
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire78a3"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire78a3"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("aTPuV", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $7ef6fcd62fb1d91d$export$ffb0004e005737fa; }, function (v) { return $7ef6fcd62fb1d91d$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $7ef6fcd62fb1d91d$export$34b9dba7ce09269b; }, function (v) { return $7ef6fcd62fb1d91d$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $7ef6fcd62fb1d91d$export$25062201e9e25d76; }, function (v) { return $7ef6fcd62fb1d91d$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7ef6fcd62fb1d91d$export$ffb0004e005737fa;
var $7ef6fcd62fb1d91d$export$34b9dba7ce09269b;
var $7ef6fcd62fb1d91d$export$25062201e9e25d76;
"use strict";
var $7ef6fcd62fb1d91d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $7ef6fcd62fb1d91d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $7ef6fcd62fb1d91d$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $7ef6fcd62fb1d91d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$7ef6fcd62fb1d91d$export$ffb0004e005737fa = $7ef6fcd62fb1d91d$var$REACT_FRAGMENT_TYPE;
$7ef6fcd62fb1d91d$export$34b9dba7ce09269b = $7ef6fcd62fb1d91d$var$jsxProd;
$7ef6fcd62fb1d91d$export$25062201e9e25d76 = $7ef6fcd62fb1d91d$var$jsxProd;

});

parcelRegister("cQmXV", function(module, exports) {
"use strict";

module.exports = (parcelRequire("ko9PG"));

});
parcelRegister("ko9PG", function(module, exports) {

$parcel$export(module.exports, "Activity", function () { return $ed7dad10c0d7dd15$export$9c16c1426311996d; }, function (v) { return $ed7dad10c0d7dd15$export$9c16c1426311996d = v; });
$parcel$export(module.exports, "Children", function () { return $ed7dad10c0d7dd15$export$dca3b0875bd9a954; }, function (v) { return $ed7dad10c0d7dd15$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $ed7dad10c0d7dd15$export$16fa2f45be04daa8; }, function (v) { return $ed7dad10c0d7dd15$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $ed7dad10c0d7dd15$export$ffb0004e005737fa; }, function (v) { return $ed7dad10c0d7dd15$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $ed7dad10c0d7dd15$export$e2c29f18771995cb; }, function (v) { return $ed7dad10c0d7dd15$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $ed7dad10c0d7dd15$export$221d75b3f55bb0bd; }, function (v) { return $ed7dad10c0d7dd15$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $ed7dad10c0d7dd15$export$5f8d39834fd61797; }, function (v) { return $ed7dad10c0d7dd15$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $ed7dad10c0d7dd15$export$74bf444e3cd11ea5; }, function (v) { return $ed7dad10c0d7dd15$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $ed7dad10c0d7dd15$export$1ced07cd6b1985ce; }, function (v) { return $ed7dad10c0d7dd15$export$1ced07cd6b1985ce = v; });
$parcel$export(module.exports, "__COMPILER_RUNTIME", function () { return $ed7dad10c0d7dd15$export$abd8e32b826d7ea7; }, function (v) { return $ed7dad10c0d7dd15$export$abd8e32b826d7ea7 = v; });
$parcel$export(module.exports, "cache", function () { return $ed7dad10c0d7dd15$export$69a3209f1a06c04d; }, function (v) { return $ed7dad10c0d7dd15$export$69a3209f1a06c04d = v; });
$parcel$export(module.exports, "cacheSignal", function () { return $ed7dad10c0d7dd15$export$8c538325882c7eec; }, function (v) { return $ed7dad10c0d7dd15$export$8c538325882c7eec = v; });
$parcel$export(module.exports, "cloneElement", function () { return $ed7dad10c0d7dd15$export$e530037191fcd5d7; }, function (v) { return $ed7dad10c0d7dd15$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $ed7dad10c0d7dd15$export$fd42f52fd3ae1109; }, function (v) { return $ed7dad10c0d7dd15$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $ed7dad10c0d7dd15$export$c8a8987d4410bf2d; }, function (v) { return $ed7dad10c0d7dd15$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createRef", function () { return $ed7dad10c0d7dd15$export$7d1e3a5e95ceca43; }, function (v) { return $ed7dad10c0d7dd15$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $ed7dad10c0d7dd15$export$257a8862b851cb5b; }, function (v) { return $ed7dad10c0d7dd15$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $ed7dad10c0d7dd15$export$a8257692ac88316c; }, function (v) { return $ed7dad10c0d7dd15$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $ed7dad10c0d7dd15$export$488013bae63b21da; }, function (v) { return $ed7dad10c0d7dd15$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $ed7dad10c0d7dd15$export$7c73462e0d25e514; }, function (v) { return $ed7dad10c0d7dd15$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $ed7dad10c0d7dd15$export$7568632d0d33d16d; }, function (v) { return $ed7dad10c0d7dd15$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_useCacheRefresh", function () { return $ed7dad10c0d7dd15$export$f93f40ac0ca7e3a8; }, function (v) { return $ed7dad10c0d7dd15$export$f93f40ac0ca7e3a8 = v; });
$parcel$export(module.exports, "use", function () { return $ed7dad10c0d7dd15$export$1f96ae73734a86cc; }, function (v) { return $ed7dad10c0d7dd15$export$1f96ae73734a86cc = v; });
$parcel$export(module.exports, "useActionState", function () { return $ed7dad10c0d7dd15$export$9a47ced3238df325; }, function (v) { return $ed7dad10c0d7dd15$export$9a47ced3238df325 = v; });
$parcel$export(module.exports, "useCallback", function () { return $ed7dad10c0d7dd15$export$35808ee640e87ca7; }, function (v) { return $ed7dad10c0d7dd15$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $ed7dad10c0d7dd15$export$fae74005e78b1a27; }, function (v) { return $ed7dad10c0d7dd15$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $ed7dad10c0d7dd15$export$dc8fbce3eb94dc1e; }, function (v) { return $ed7dad10c0d7dd15$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $ed7dad10c0d7dd15$export$6a7bc4e911dc01cf; }, function (v) { return $ed7dad10c0d7dd15$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $ed7dad10c0d7dd15$export$6d9c69b0de29b591; }, function (v) { return $ed7dad10c0d7dd15$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useEffectEvent", function () { return $ed7dad10c0d7dd15$export$7f54fc3180508a52; }, function (v) { return $ed7dad10c0d7dd15$export$7f54fc3180508a52 = v; });
$parcel$export(module.exports, "useId", function () { return $ed7dad10c0d7dd15$export$f680877a34711e37; }, function (v) { return $ed7dad10c0d7dd15$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $ed7dad10c0d7dd15$export$d5a552a76deda3c2; }, function (v) { return $ed7dad10c0d7dd15$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $ed7dad10c0d7dd15$export$aaabe4eda9ed9969; }, function (v) { return $ed7dad10c0d7dd15$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $ed7dad10c0d7dd15$export$e5c5a5f917a5871c; }, function (v) { return $ed7dad10c0d7dd15$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $ed7dad10c0d7dd15$export$1538c33de8887b59; }, function (v) { return $ed7dad10c0d7dd15$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useOptimistic", function () { return $ed7dad10c0d7dd15$export$fca7f784ae7a249a; }, function (v) { return $ed7dad10c0d7dd15$export$fca7f784ae7a249a = v; });
$parcel$export(module.exports, "useReducer", function () { return $ed7dad10c0d7dd15$export$13e3392192263954; }, function (v) { return $ed7dad10c0d7dd15$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $ed7dad10c0d7dd15$export$b8f5890fc79d6aca; }, function (v) { return $ed7dad10c0d7dd15$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $ed7dad10c0d7dd15$export$60241385465d0a34; }, function (v) { return $ed7dad10c0d7dd15$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $ed7dad10c0d7dd15$export$306c0aa65ff9ec16; }, function (v) { return $ed7dad10c0d7dd15$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $ed7dad10c0d7dd15$export$7b286972b8d8ccbf; }, function (v) { return $ed7dad10c0d7dd15$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $ed7dad10c0d7dd15$export$83d89fbfd8236492; }, function (v) { return $ed7dad10c0d7dd15$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ed7dad10c0d7dd15$export$9c16c1426311996d;
var $ed7dad10c0d7dd15$export$dca3b0875bd9a954;
var $ed7dad10c0d7dd15$export$16fa2f45be04daa8;
var $ed7dad10c0d7dd15$export$ffb0004e005737fa;
var $ed7dad10c0d7dd15$export$e2c29f18771995cb;
var $ed7dad10c0d7dd15$export$221d75b3f55bb0bd;
var $ed7dad10c0d7dd15$export$5f8d39834fd61797;
var $ed7dad10c0d7dd15$export$74bf444e3cd11ea5;
var $ed7dad10c0d7dd15$export$1ced07cd6b1985ce;
var $ed7dad10c0d7dd15$export$abd8e32b826d7ea7;
var $ed7dad10c0d7dd15$export$69a3209f1a06c04d;
var $ed7dad10c0d7dd15$export$8c538325882c7eec;
var $ed7dad10c0d7dd15$export$e530037191fcd5d7;
var $ed7dad10c0d7dd15$export$fd42f52fd3ae1109;
var $ed7dad10c0d7dd15$export$c8a8987d4410bf2d;
var $ed7dad10c0d7dd15$export$7d1e3a5e95ceca43;
var $ed7dad10c0d7dd15$export$257a8862b851cb5b;
var $ed7dad10c0d7dd15$export$a8257692ac88316c;
var $ed7dad10c0d7dd15$export$488013bae63b21da;
var $ed7dad10c0d7dd15$export$7c73462e0d25e514;
var $ed7dad10c0d7dd15$export$7568632d0d33d16d;
var $ed7dad10c0d7dd15$export$f93f40ac0ca7e3a8;
var $ed7dad10c0d7dd15$export$1f96ae73734a86cc;
var $ed7dad10c0d7dd15$export$9a47ced3238df325;
var $ed7dad10c0d7dd15$export$35808ee640e87ca7;
var $ed7dad10c0d7dd15$export$fae74005e78b1a27;
var $ed7dad10c0d7dd15$export$dc8fbce3eb94dc1e;
var $ed7dad10c0d7dd15$export$6a7bc4e911dc01cf;
var $ed7dad10c0d7dd15$export$6d9c69b0de29b591;
var $ed7dad10c0d7dd15$export$7f54fc3180508a52;
var $ed7dad10c0d7dd15$export$f680877a34711e37;
var $ed7dad10c0d7dd15$export$d5a552a76deda3c2;
var $ed7dad10c0d7dd15$export$aaabe4eda9ed9969;
var $ed7dad10c0d7dd15$export$e5c5a5f917a5871c;
var $ed7dad10c0d7dd15$export$1538c33de8887b59;
var $ed7dad10c0d7dd15$export$fca7f784ae7a249a;
var $ed7dad10c0d7dd15$export$13e3392192263954;
var $ed7dad10c0d7dd15$export$b8f5890fc79d6aca;
var $ed7dad10c0d7dd15$export$60241385465d0a34;
var $ed7dad10c0d7dd15$export$306c0aa65ff9ec16;
var $ed7dad10c0d7dd15$export$7b286972b8d8ccbf;
var $ed7dad10c0d7dd15$export$83d89fbfd8236492;

var $4dBQg = parcelRequire("4dBQg");
"use strict";
var $ed7dad10c0d7dd15$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $ed7dad10c0d7dd15$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $ed7dad10c0d7dd15$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $ed7dad10c0d7dd15$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $ed7dad10c0d7dd15$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $ed7dad10c0d7dd15$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $ed7dad10c0d7dd15$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $ed7dad10c0d7dd15$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $ed7dad10c0d7dd15$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $ed7dad10c0d7dd15$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $ed7dad10c0d7dd15$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $ed7dad10c0d7dd15$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $ed7dad10c0d7dd15$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $ed7dad10c0d7dd15$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $ed7dad10c0d7dd15$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$ed7dad10c0d7dd15$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $ed7dad10c0d7dd15$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $ed7dad10c0d7dd15$var$assign = Object.assign, $ed7dad10c0d7dd15$var$emptyObject = {};
function $ed7dad10c0d7dd15$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $ed7dad10c0d7dd15$var$emptyObject;
    this.updater = updater || $ed7dad10c0d7dd15$var$ReactNoopUpdateQueue;
}
$ed7dad10c0d7dd15$var$Component.prototype.isReactComponent = {};
$ed7dad10c0d7dd15$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$ed7dad10c0d7dd15$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $ed7dad10c0d7dd15$var$ComponentDummy() {}
$ed7dad10c0d7dd15$var$ComponentDummy.prototype = $ed7dad10c0d7dd15$var$Component.prototype;
function $ed7dad10c0d7dd15$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $ed7dad10c0d7dd15$var$emptyObject;
    this.updater = updater || $ed7dad10c0d7dd15$var$ReactNoopUpdateQueue;
}
var $ed7dad10c0d7dd15$var$pureComponentPrototype = $ed7dad10c0d7dd15$var$PureComponent.prototype = new $ed7dad10c0d7dd15$var$ComponentDummy();
$ed7dad10c0d7dd15$var$pureComponentPrototype.constructor = $ed7dad10c0d7dd15$var$PureComponent;
$ed7dad10c0d7dd15$var$assign($ed7dad10c0d7dd15$var$pureComponentPrototype, $ed7dad10c0d7dd15$var$Component.prototype);
$ed7dad10c0d7dd15$var$pureComponentPrototype.isPureReactComponent = !0;
var $ed7dad10c0d7dd15$var$isArrayImpl = Array.isArray;
function $ed7dad10c0d7dd15$var$noop() {}
var $ed7dad10c0d7dd15$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $ed7dad10c0d7dd15$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $ed7dad10c0d7dd15$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $ed7dad10c0d7dd15$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $ed7dad10c0d7dd15$var$cloneAndReplaceKey(oldElement, newKey) {
    return $ed7dad10c0d7dd15$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $ed7dad10c0d7dd15$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $ed7dad10c0d7dd15$var$REACT_ELEMENT_TYPE;
}
function $ed7dad10c0d7dd15$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $ed7dad10c0d7dd15$var$userProvidedKeyEscapeRegex = /\/+/g;
function $ed7dad10c0d7dd15$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $ed7dad10c0d7dd15$var$escape("" + element.key) : index.toString(36);
}
function $ed7dad10c0d7dd15$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($ed7dad10c0d7dd15$var$noop, $ed7dad10c0d7dd15$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $ed7dad10c0d7dd15$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $ed7dad10c0d7dd15$var$REACT_ELEMENT_TYPE:
                case $ed7dad10c0d7dd15$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $ed7dad10c0d7dd15$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $ed7dad10c0d7dd15$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $ed7dad10c0d7dd15$var$getElementKey(children, 0) : nameSoFar, $ed7dad10c0d7dd15$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($ed7dad10c0d7dd15$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $ed7dad10c0d7dd15$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($ed7dad10c0d7dd15$var$isValidElement(callback) && (callback = $ed7dad10c0d7dd15$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($ed7dad10c0d7dd15$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($ed7dad10c0d7dd15$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $ed7dad10c0d7dd15$var$getElementKey(nameSoFar, i), invokeCallback += $ed7dad10c0d7dd15$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $ed7dad10c0d7dd15$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $ed7dad10c0d7dd15$var$getElementKey(nameSoFar, i++), invokeCallback += $ed7dad10c0d7dd15$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $ed7dad10c0d7dd15$var$mapIntoArray($ed7dad10c0d7dd15$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $ed7dad10c0d7dd15$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $ed7dad10c0d7dd15$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $ed7dad10c0d7dd15$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $ed7dad10c0d7dd15$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    } else if ("object" === typeof $4dBQg && "function" === typeof $4dBQg.emit) {
        $4dBQg.emit("uncaughtException", error);
        return;
    }
    console.error(error);
}, $ed7dad10c0d7dd15$var$Children = {
    map: $ed7dad10c0d7dd15$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $ed7dad10c0d7dd15$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $ed7dad10c0d7dd15$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $ed7dad10c0d7dd15$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$ed7dad10c0d7dd15$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$ed7dad10c0d7dd15$export$9c16c1426311996d = $ed7dad10c0d7dd15$var$REACT_ACTIVITY_TYPE;
$ed7dad10c0d7dd15$export$dca3b0875bd9a954 = $ed7dad10c0d7dd15$var$Children;
$ed7dad10c0d7dd15$export$16fa2f45be04daa8 = $ed7dad10c0d7dd15$var$Component;
$ed7dad10c0d7dd15$export$ffb0004e005737fa = $ed7dad10c0d7dd15$var$REACT_FRAGMENT_TYPE;
$ed7dad10c0d7dd15$export$e2c29f18771995cb = $ed7dad10c0d7dd15$var$REACT_PROFILER_TYPE;
$ed7dad10c0d7dd15$export$221d75b3f55bb0bd = $ed7dad10c0d7dd15$var$PureComponent;
$ed7dad10c0d7dd15$export$5f8d39834fd61797 = $ed7dad10c0d7dd15$var$REACT_STRICT_MODE_TYPE;
$ed7dad10c0d7dd15$export$74bf444e3cd11ea5 = $ed7dad10c0d7dd15$var$REACT_SUSPENSE_TYPE;
$ed7dad10c0d7dd15$export$1ced07cd6b1985ce = $ed7dad10c0d7dd15$var$ReactSharedInternals;
$ed7dad10c0d7dd15$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $ed7dad10c0d7dd15$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$ed7dad10c0d7dd15$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$ed7dad10c0d7dd15$export$8c538325882c7eec = function() {
    return null;
};
$ed7dad10c0d7dd15$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $ed7dad10c0d7dd15$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$ed7dad10c0d7dd15$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $ed7dad10c0d7dd15$var$ReactElement(element.type, key, props);
};
$ed7dad10c0d7dd15$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $ed7dad10c0d7dd15$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $ed7dad10c0d7dd15$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$ed7dad10c0d7dd15$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$ed7dad10c0d7dd15$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $ed7dad10c0d7dd15$var$ReactElement(type, key, props);
};
$ed7dad10c0d7dd15$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$ed7dad10c0d7dd15$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $ed7dad10c0d7dd15$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$ed7dad10c0d7dd15$export$a8257692ac88316c = $ed7dad10c0d7dd15$var$isValidElement;
$ed7dad10c0d7dd15$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $ed7dad10c0d7dd15$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $ed7dad10c0d7dd15$var$lazyInitializer
    };
};
$ed7dad10c0d7dd15$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $ed7dad10c0d7dd15$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$ed7dad10c0d7dd15$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $ed7dad10c0d7dd15$var$ReactSharedInternals.T, currentTransition = {};
    $ed7dad10c0d7dd15$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $ed7dad10c0d7dd15$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($ed7dad10c0d7dd15$var$noop, $ed7dad10c0d7dd15$var$reportGlobalError);
    } catch (error) {
        $ed7dad10c0d7dd15$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $ed7dad10c0d7dd15$var$ReactSharedInternals.T = prevTransition;
    }
};
$ed7dad10c0d7dd15$export$f93f40ac0ca7e3a8 = function() {
    return $ed7dad10c0d7dd15$var$ReactSharedInternals.H.useCacheRefresh();
};
$ed7dad10c0d7dd15$export$1f96ae73734a86cc = function(usable) {
    return $ed7dad10c0d7dd15$var$ReactSharedInternals.H.use(usable);
};
$ed7dad10c0d7dd15$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $ed7dad10c0d7dd15$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$ed7dad10c0d7dd15$export$35808ee640e87ca7 = function(callback, deps) {
    return $ed7dad10c0d7dd15$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$ed7dad10c0d7dd15$export$fae74005e78b1a27 = function(Context) {
    return $ed7dad10c0d7dd15$var$ReactSharedInternals.H.useContext(Context);
};
$ed7dad10c0d7dd15$export$dc8fbce3eb94dc1e = function() {};
$ed7dad10c0d7dd15$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $ed7dad10c0d7dd15$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$ed7dad10c0d7dd15$export$6d9c69b0de29b591 = function(create, deps) {
    return $ed7dad10c0d7dd15$var$ReactSharedInternals.H.useEffect(create, deps);
};
$ed7dad10c0d7dd15$export$7f54fc3180508a52 = function(callback) {
    return $ed7dad10c0d7dd15$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$ed7dad10c0d7dd15$export$f680877a34711e37 = function() {
    return $ed7dad10c0d7dd15$var$ReactSharedInternals.H.useId();
};
$ed7dad10c0d7dd15$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $ed7dad10c0d7dd15$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$ed7dad10c0d7dd15$export$aaabe4eda9ed9969 = function(create, deps) {
    return $ed7dad10c0d7dd15$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$ed7dad10c0d7dd15$export$e5c5a5f917a5871c = function(create, deps) {
    return $ed7dad10c0d7dd15$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$ed7dad10c0d7dd15$export$1538c33de8887b59 = function(create, deps) {
    return $ed7dad10c0d7dd15$var$ReactSharedInternals.H.useMemo(create, deps);
};
$ed7dad10c0d7dd15$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $ed7dad10c0d7dd15$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$ed7dad10c0d7dd15$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $ed7dad10c0d7dd15$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$ed7dad10c0d7dd15$export$b8f5890fc79d6aca = function(initialValue) {
    return $ed7dad10c0d7dd15$var$ReactSharedInternals.H.useRef(initialValue);
};
$ed7dad10c0d7dd15$export$60241385465d0a34 = function(initialState) {
    return $ed7dad10c0d7dd15$var$ReactSharedInternals.H.useState(initialState);
};
$ed7dad10c0d7dd15$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $ed7dad10c0d7dd15$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$ed7dad10c0d7dd15$export$7b286972b8d8ccbf = function() {
    return $ed7dad10c0d7dd15$var$ReactSharedInternals.H.useTransition();
};
$ed7dad10c0d7dd15$export$83d89fbfd8236492 = "19.2.7";

});
parcelRegister("4dBQg", function(module, exports) {
// shim for using process in browser
var $3125baf2b7ca59a6$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $3125baf2b7ca59a6$var$cachedSetTimeout;
var $3125baf2b7ca59a6$var$cachedClearTimeout;
function $3125baf2b7ca59a6$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $3125baf2b7ca59a6$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $3125baf2b7ca59a6$var$cachedSetTimeout = setTimeout;
        else $3125baf2b7ca59a6$var$cachedSetTimeout = $3125baf2b7ca59a6$var$defaultSetTimout;
    } catch (e) {
        $3125baf2b7ca59a6$var$cachedSetTimeout = $3125baf2b7ca59a6$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $3125baf2b7ca59a6$var$cachedClearTimeout = clearTimeout;
        else $3125baf2b7ca59a6$var$cachedClearTimeout = $3125baf2b7ca59a6$var$defaultClearTimeout;
    } catch (e) {
        $3125baf2b7ca59a6$var$cachedClearTimeout = $3125baf2b7ca59a6$var$defaultClearTimeout;
    }
})();
function $3125baf2b7ca59a6$var$runTimeout(fun) {
    if ($3125baf2b7ca59a6$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($3125baf2b7ca59a6$var$cachedSetTimeout === $3125baf2b7ca59a6$var$defaultSetTimout || !$3125baf2b7ca59a6$var$cachedSetTimeout) && setTimeout) {
        $3125baf2b7ca59a6$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $3125baf2b7ca59a6$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $3125baf2b7ca59a6$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $3125baf2b7ca59a6$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $3125baf2b7ca59a6$var$runClearTimeout(marker) {
    if ($3125baf2b7ca59a6$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($3125baf2b7ca59a6$var$cachedClearTimeout === $3125baf2b7ca59a6$var$defaultClearTimeout || !$3125baf2b7ca59a6$var$cachedClearTimeout) && clearTimeout) {
        $3125baf2b7ca59a6$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $3125baf2b7ca59a6$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $3125baf2b7ca59a6$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $3125baf2b7ca59a6$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $3125baf2b7ca59a6$var$queue = [];
var $3125baf2b7ca59a6$var$draining = false;
var $3125baf2b7ca59a6$var$currentQueue;
var $3125baf2b7ca59a6$var$queueIndex = -1;
function $3125baf2b7ca59a6$var$cleanUpNextTick() {
    if (!$3125baf2b7ca59a6$var$draining || !$3125baf2b7ca59a6$var$currentQueue) return;
    $3125baf2b7ca59a6$var$draining = false;
    if ($3125baf2b7ca59a6$var$currentQueue.length) $3125baf2b7ca59a6$var$queue = $3125baf2b7ca59a6$var$currentQueue.concat($3125baf2b7ca59a6$var$queue);
    else $3125baf2b7ca59a6$var$queueIndex = -1;
    if ($3125baf2b7ca59a6$var$queue.length) $3125baf2b7ca59a6$var$drainQueue();
}
function $3125baf2b7ca59a6$var$drainQueue() {
    if ($3125baf2b7ca59a6$var$draining) return;
    var timeout = $3125baf2b7ca59a6$var$runTimeout($3125baf2b7ca59a6$var$cleanUpNextTick);
    $3125baf2b7ca59a6$var$draining = true;
    var len = $3125baf2b7ca59a6$var$queue.length;
    while(len){
        $3125baf2b7ca59a6$var$currentQueue = $3125baf2b7ca59a6$var$queue;
        $3125baf2b7ca59a6$var$queue = [];
        while(++$3125baf2b7ca59a6$var$queueIndex < len)if ($3125baf2b7ca59a6$var$currentQueue) $3125baf2b7ca59a6$var$currentQueue[$3125baf2b7ca59a6$var$queueIndex].run();
        $3125baf2b7ca59a6$var$queueIndex = -1;
        len = $3125baf2b7ca59a6$var$queue.length;
    }
    $3125baf2b7ca59a6$var$currentQueue = null;
    $3125baf2b7ca59a6$var$draining = false;
    $3125baf2b7ca59a6$var$runClearTimeout(timeout);
}
$3125baf2b7ca59a6$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $3125baf2b7ca59a6$var$queue.push(new $3125baf2b7ca59a6$var$Item(fun, args));
    if ($3125baf2b7ca59a6$var$queue.length === 1 && !$3125baf2b7ca59a6$var$draining) $3125baf2b7ca59a6$var$runTimeout($3125baf2b7ca59a6$var$drainQueue);
};
// v8 likes predictible objects
function $3125baf2b7ca59a6$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$3125baf2b7ca59a6$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$3125baf2b7ca59a6$var$process.title = "browser";
$3125baf2b7ca59a6$var$process.browser = true;
$3125baf2b7ca59a6$var$process.env = {};
$3125baf2b7ca59a6$var$process.argv = [];
$3125baf2b7ca59a6$var$process.version = ""; // empty string to avoid regexp issues
$3125baf2b7ca59a6$var$process.versions = {};
function $3125baf2b7ca59a6$var$noop() {}
$3125baf2b7ca59a6$var$process.on = $3125baf2b7ca59a6$var$noop;
$3125baf2b7ca59a6$var$process.addListener = $3125baf2b7ca59a6$var$noop;
$3125baf2b7ca59a6$var$process.once = $3125baf2b7ca59a6$var$noop;
$3125baf2b7ca59a6$var$process.off = $3125baf2b7ca59a6$var$noop;
$3125baf2b7ca59a6$var$process.removeListener = $3125baf2b7ca59a6$var$noop;
$3125baf2b7ca59a6$var$process.removeAllListeners = $3125baf2b7ca59a6$var$noop;
$3125baf2b7ca59a6$var$process.emit = $3125baf2b7ca59a6$var$noop;
$3125baf2b7ca59a6$var$process.prependListener = $3125baf2b7ca59a6$var$noop;
$3125baf2b7ca59a6$var$process.prependOnceListener = $3125baf2b7ca59a6$var$noop;
$3125baf2b7ca59a6$var$process.listeners = function(name) {
    return [];
};
$3125baf2b7ca59a6$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$3125baf2b7ca59a6$var$process.cwd = function() {
    return "/";
};
$3125baf2b7ca59a6$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$3125baf2b7ca59a6$var$process.umask = function() {
    return 0;
};

});



parcelRegister("bhIuc", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $8373ca4214e15aed$export$882461b6382ed46c; }, function (v) { return $8373ca4214e15aed$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $8373ca4214e15aed$export$757ceba2d55c277e; }, function (v) { return $8373ca4214e15aed$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "version", function () { return $8373ca4214e15aed$export$83d89fbfd8236492; }, function (v) { return $8373ca4214e15aed$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $8373ca4214e15aed$export$882461b6382ed46c;
var $8373ca4214e15aed$export$757ceba2d55c277e;
var $8373ca4214e15aed$export$83d89fbfd8236492;

var $4dBQg = parcelRequire("4dBQg");
"use strict";

var $1zXL0 = parcelRequire("1zXL0");

var $cQmXV = parcelRequire("cQmXV");

var $3h5eW = parcelRequire("3h5eW");
function $8373ca4214e15aed$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $8373ca4214e15aed$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $8373ca4214e15aed$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $8373ca4214e15aed$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $8373ca4214e15aed$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $8373ca4214e15aed$var$assertIsMounted(fiber) {
    if ($8373ca4214e15aed$var$getNearestMountedFiber(fiber) !== fiber) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(188));
}
function $8373ca4214e15aed$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $8373ca4214e15aed$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $8373ca4214e15aed$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $8373ca4214e15aed$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($8373ca4214e15aed$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $8373ca4214e15aed$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $8373ca4214e15aed$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $8373ca4214e15aed$var$assign = Object.assign, $8373ca4214e15aed$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $8373ca4214e15aed$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $8373ca4214e15aed$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $8373ca4214e15aed$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $8373ca4214e15aed$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $8373ca4214e15aed$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $8373ca4214e15aed$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $8373ca4214e15aed$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $8373ca4214e15aed$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $8373ca4214e15aed$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $8373ca4214e15aed$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $8373ca4214e15aed$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $8373ca4214e15aed$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $8373ca4214e15aed$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $8373ca4214e15aed$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $8373ca4214e15aed$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $8373ca4214e15aed$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $8373ca4214e15aed$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$8373ca4214e15aed$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $8373ca4214e15aed$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $8373ca4214e15aed$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $8373ca4214e15aed$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $8373ca4214e15aed$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $8373ca4214e15aed$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $8373ca4214e15aed$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $8373ca4214e15aed$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $8373ca4214e15aed$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $8373ca4214e15aed$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $8373ca4214e15aed$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $8373ca4214e15aed$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $8373ca4214e15aed$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $8373ca4214e15aed$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $8373ca4214e15aed$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $8373ca4214e15aed$var$getComponentNameFromType(type.type) || "Memo";
        case $8373ca4214e15aed$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $8373ca4214e15aed$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $8373ca4214e15aed$var$isArrayImpl = Array.isArray, $8373ca4214e15aed$var$ReactSharedInternals = $cQmXV.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $8373ca4214e15aed$var$ReactDOMSharedInternals = $3h5eW.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $8373ca4214e15aed$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $8373ca4214e15aed$var$valueStack = [], $8373ca4214e15aed$var$index = -1;
function $8373ca4214e15aed$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $8373ca4214e15aed$var$pop(cursor) {
    0 > $8373ca4214e15aed$var$index || (cursor.current = $8373ca4214e15aed$var$valueStack[$8373ca4214e15aed$var$index], $8373ca4214e15aed$var$valueStack[$8373ca4214e15aed$var$index] = null, $8373ca4214e15aed$var$index--);
}
function $8373ca4214e15aed$var$push(cursor, value) {
    $8373ca4214e15aed$var$index++;
    $8373ca4214e15aed$var$valueStack[$8373ca4214e15aed$var$index] = cursor.current;
    cursor.current = value;
}
var $8373ca4214e15aed$var$contextStackCursor = $8373ca4214e15aed$var$createCursor(null), $8373ca4214e15aed$var$contextFiberStackCursor = $8373ca4214e15aed$var$createCursor(null), $8373ca4214e15aed$var$rootInstanceStackCursor = $8373ca4214e15aed$var$createCursor(null), $8373ca4214e15aed$var$hostTransitionProviderCursor = $8373ca4214e15aed$var$createCursor(null);
function $8373ca4214e15aed$var$pushHostContainer(fiber, nextRootInstance) {
    $8373ca4214e15aed$var$push($8373ca4214e15aed$var$rootInstanceStackCursor, nextRootInstance);
    $8373ca4214e15aed$var$push($8373ca4214e15aed$var$contextFiberStackCursor, fiber);
    $8373ca4214e15aed$var$push($8373ca4214e15aed$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $8373ca4214e15aed$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $8373ca4214e15aed$var$getOwnHostContext(nextRootInstance), fiber = $8373ca4214e15aed$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $8373ca4214e15aed$var$pop($8373ca4214e15aed$var$contextStackCursor);
    $8373ca4214e15aed$var$push($8373ca4214e15aed$var$contextStackCursor, fiber);
}
function $8373ca4214e15aed$var$popHostContainer() {
    $8373ca4214e15aed$var$pop($8373ca4214e15aed$var$contextStackCursor);
    $8373ca4214e15aed$var$pop($8373ca4214e15aed$var$contextFiberStackCursor);
    $8373ca4214e15aed$var$pop($8373ca4214e15aed$var$rootInstanceStackCursor);
}
function $8373ca4214e15aed$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $8373ca4214e15aed$var$push($8373ca4214e15aed$var$hostTransitionProviderCursor, fiber);
    var context = $8373ca4214e15aed$var$contextStackCursor.current;
    var JSCompiler_inline_result = $8373ca4214e15aed$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($8373ca4214e15aed$var$push($8373ca4214e15aed$var$contextFiberStackCursor, fiber), $8373ca4214e15aed$var$push($8373ca4214e15aed$var$contextStackCursor, JSCompiler_inline_result));
}
function $8373ca4214e15aed$var$popHostContext(fiber) {
    $8373ca4214e15aed$var$contextFiberStackCursor.current === fiber && ($8373ca4214e15aed$var$pop($8373ca4214e15aed$var$contextStackCursor), $8373ca4214e15aed$var$pop($8373ca4214e15aed$var$contextFiberStackCursor));
    $8373ca4214e15aed$var$hostTransitionProviderCursor.current === fiber && ($8373ca4214e15aed$var$pop($8373ca4214e15aed$var$hostTransitionProviderCursor), $8373ca4214e15aed$var$HostTransitionContext._currentValue = $8373ca4214e15aed$var$sharedNotPendingObject);
}
var $8373ca4214e15aed$var$prefix, $8373ca4214e15aed$var$suffix;
function $8373ca4214e15aed$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $8373ca4214e15aed$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $8373ca4214e15aed$var$prefix = match && match[1] || "";
        $8373ca4214e15aed$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $8373ca4214e15aed$var$prefix + name + $8373ca4214e15aed$var$suffix;
}
var $8373ca4214e15aed$var$reentry = !1;
function $8373ca4214e15aed$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $8373ca4214e15aed$var$reentry) return "";
    $8373ca4214e15aed$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $8373ca4214e15aed$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $8373ca4214e15aed$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $8373ca4214e15aed$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $8373ca4214e15aed$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $8373ca4214e15aed$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $8373ca4214e15aed$var$describeBuiltInComponentFrame("Suspense Fallback") : $8373ca4214e15aed$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $8373ca4214e15aed$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $8373ca4214e15aed$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $8373ca4214e15aed$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $8373ca4214e15aed$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $8373ca4214e15aed$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $8373ca4214e15aed$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $8373ca4214e15aed$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $8373ca4214e15aed$var$hasOwnProperty = Object.prototype.hasOwnProperty, $8373ca4214e15aed$var$scheduleCallback$3 = $1zXL0.unstable_scheduleCallback, $8373ca4214e15aed$var$cancelCallback$1 = $1zXL0.unstable_cancelCallback, $8373ca4214e15aed$var$shouldYield = $1zXL0.unstable_shouldYield, $8373ca4214e15aed$var$requestPaint = $1zXL0.unstable_requestPaint, $8373ca4214e15aed$var$now = $1zXL0.unstable_now, $8373ca4214e15aed$var$getCurrentPriorityLevel = $1zXL0.unstable_getCurrentPriorityLevel, $8373ca4214e15aed$var$ImmediatePriority = $1zXL0.unstable_ImmediatePriority, $8373ca4214e15aed$var$UserBlockingPriority = $1zXL0.unstable_UserBlockingPriority, $8373ca4214e15aed$var$NormalPriority$1 = $1zXL0.unstable_NormalPriority, $8373ca4214e15aed$var$LowPriority = $1zXL0.unstable_LowPriority, $8373ca4214e15aed$var$IdlePriority = $1zXL0.unstable_IdlePriority, $8373ca4214e15aed$var$log$1 = $1zXL0.log, $8373ca4214e15aed$var$unstable_setDisableYieldValue = $1zXL0.unstable_setDisableYieldValue, $8373ca4214e15aed$var$rendererID = null, $8373ca4214e15aed$var$injectedHook = null;
function $8373ca4214e15aed$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $8373ca4214e15aed$var$log$1 && $8373ca4214e15aed$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($8373ca4214e15aed$var$injectedHook && "function" === typeof $8373ca4214e15aed$var$injectedHook.setStrictMode) try {
        $8373ca4214e15aed$var$injectedHook.setStrictMode($8373ca4214e15aed$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $8373ca4214e15aed$var$clz32 = Math.clz32 ? Math.clz32 : $8373ca4214e15aed$var$clz32Fallback, $8373ca4214e15aed$var$log = Math.log, $8373ca4214e15aed$var$LN2 = Math.LN2;
function $8373ca4214e15aed$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($8373ca4214e15aed$var$log(x) / $8373ca4214e15aed$var$LN2 | 0) | 0;
}
var $8373ca4214e15aed$var$nextTransitionUpdateLane = 256, $8373ca4214e15aed$var$nextTransitionDeferredLane = 262144, $8373ca4214e15aed$var$nextRetryLane = 4194304;
function $8373ca4214e15aed$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $8373ca4214e15aed$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $8373ca4214e15aed$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $8373ca4214e15aed$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $8373ca4214e15aed$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $8373ca4214e15aed$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $8373ca4214e15aed$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $8373ca4214e15aed$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $8373ca4214e15aed$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $8373ca4214e15aed$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $8373ca4214e15aed$var$claimNextRetryLane() {
    var lane = $8373ca4214e15aed$var$nextRetryLane;
    $8373ca4214e15aed$var$nextRetryLane <<= 1;
    0 === ($8373ca4214e15aed$var$nextRetryLane & 62914560) && ($8373ca4214e15aed$var$nextRetryLane = 4194304);
    return lane;
}
function $8373ca4214e15aed$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $8373ca4214e15aed$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $8373ca4214e15aed$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $8373ca4214e15aed$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $8373ca4214e15aed$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $8373ca4214e15aed$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $8373ca4214e15aed$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $8373ca4214e15aed$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $8373ca4214e15aed$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $8373ca4214e15aed$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $8373ca4214e15aed$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $8373ca4214e15aed$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $8373ca4214e15aed$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $8373ca4214e15aed$var$resolveUpdatePriority() {
    var updatePriority = $8373ca4214e15aed$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $8373ca4214e15aed$var$getEventPriority(updatePriority.type);
}
function $8373ca4214e15aed$var$runWithPriority(priority, fn) {
    var previousPriority = $8373ca4214e15aed$var$ReactDOMSharedInternals.p;
    try {
        return $8373ca4214e15aed$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $8373ca4214e15aed$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $8373ca4214e15aed$var$randomKey = Math.random().toString(36).slice(2), $8373ca4214e15aed$var$internalInstanceKey = "__reactFiber$" + $8373ca4214e15aed$var$randomKey, $8373ca4214e15aed$var$internalPropsKey = "__reactProps$" + $8373ca4214e15aed$var$randomKey, $8373ca4214e15aed$var$internalContainerInstanceKey = "__reactContainer$" + $8373ca4214e15aed$var$randomKey, $8373ca4214e15aed$var$internalEventHandlersKey = "__reactEvents$" + $8373ca4214e15aed$var$randomKey, $8373ca4214e15aed$var$internalEventHandlerListenersKey = "__reactListeners$" + $8373ca4214e15aed$var$randomKey, $8373ca4214e15aed$var$internalEventHandlesSetKey = "__reactHandles$" + $8373ca4214e15aed$var$randomKey, $8373ca4214e15aed$var$internalRootNodeResourcesKey = "__reactResources$" + $8373ca4214e15aed$var$randomKey, $8373ca4214e15aed$var$internalHoistableMarker = "__reactMarker$" + $8373ca4214e15aed$var$randomKey;
function $8373ca4214e15aed$var$detachDeletedInstance(node) {
    delete node[$8373ca4214e15aed$var$internalInstanceKey];
    delete node[$8373ca4214e15aed$var$internalPropsKey];
    delete node[$8373ca4214e15aed$var$internalEventHandlersKey];
    delete node[$8373ca4214e15aed$var$internalEventHandlerListenersKey];
    delete node[$8373ca4214e15aed$var$internalEventHandlesSetKey];
}
function $8373ca4214e15aed$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$8373ca4214e15aed$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$8373ca4214e15aed$var$internalContainerInstanceKey] || parentNode[$8373ca4214e15aed$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $8373ca4214e15aed$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$8373ca4214e15aed$var$internalInstanceKey]) return parentNode;
                targetNode = $8373ca4214e15aed$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $8373ca4214e15aed$var$getInstanceFromNode(node) {
    if (node = node[$8373ca4214e15aed$var$internalInstanceKey] || node[$8373ca4214e15aed$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $8373ca4214e15aed$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($8373ca4214e15aed$var$formatProdErrorMessage(33));
}
function $8373ca4214e15aed$var$getResourcesFromRoot(root) {
    var resources = root[$8373ca4214e15aed$var$internalRootNodeResourcesKey];
    resources || (resources = root[$8373ca4214e15aed$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $8373ca4214e15aed$var$markNodeAsHoistable(node) {
    node[$8373ca4214e15aed$var$internalHoistableMarker] = !0;
}
var $8373ca4214e15aed$var$allNativeEvents = new Set(), $8373ca4214e15aed$var$registrationNameDependencies = {};
function $8373ca4214e15aed$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $8373ca4214e15aed$var$registerDirectEvent(registrationName, dependencies);
    $8373ca4214e15aed$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $8373ca4214e15aed$var$registerDirectEvent(registrationName, dependencies) {
    $8373ca4214e15aed$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$8373ca4214e15aed$var$allNativeEvents.add(dependencies[registrationName]);
}
var $8373ca4214e15aed$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $8373ca4214e15aed$var$illegalAttributeNameCache = {}, $8373ca4214e15aed$var$validatedAttributeNameCache = {};
function $8373ca4214e15aed$var$isAttributeNameSafe(attributeName) {
    if ($8373ca4214e15aed$var$hasOwnProperty.call($8373ca4214e15aed$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($8373ca4214e15aed$var$hasOwnProperty.call($8373ca4214e15aed$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($8373ca4214e15aed$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $8373ca4214e15aed$var$validatedAttributeNameCache[attributeName] = !0;
    $8373ca4214e15aed$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $8373ca4214e15aed$var$setValueForAttribute(node, name, value) {
    if ($8373ca4214e15aed$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $8373ca4214e15aed$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $8373ca4214e15aed$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $8373ca4214e15aed$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $8373ca4214e15aed$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $8373ca4214e15aed$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $8373ca4214e15aed$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $8373ca4214e15aed$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $8373ca4214e15aed$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $8373ca4214e15aed$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $8373ca4214e15aed$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $8373ca4214e15aed$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $8373ca4214e15aed$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $8373ca4214e15aed$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($8373ca4214e15aed$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $8373ca4214e15aed$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $8373ca4214e15aed$var$getToStringValue(value);
        } else element.value !== "" + $8373ca4214e15aed$var$getToStringValue(value) && (element.value = "" + $8373ca4214e15aed$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $8373ca4214e15aed$var$setDefaultValue(element, type, $8373ca4214e15aed$var$getToStringValue(value)) : null != defaultValue ? $8373ca4214e15aed$var$setDefaultValue(element, type, $8373ca4214e15aed$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $8373ca4214e15aed$var$getToStringValue(name) : element.removeAttribute("name");
}
function $8373ca4214e15aed$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $8373ca4214e15aed$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $8373ca4214e15aed$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $8373ca4214e15aed$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $8373ca4214e15aed$var$track(element);
}
function $8373ca4214e15aed$var$setDefaultValue(node, type, value) {
    "number" === type && $8373ca4214e15aed$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $8373ca4214e15aed$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $8373ca4214e15aed$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $8373ca4214e15aed$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $8373ca4214e15aed$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $8373ca4214e15aed$var$getToStringValue(defaultValue) : "";
}
function $8373ca4214e15aed$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(92));
            if ($8373ca4214e15aed$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $8373ca4214e15aed$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $8373ca4214e15aed$var$track(element);
}
function $8373ca4214e15aed$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $8373ca4214e15aed$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $8373ca4214e15aed$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $8373ca4214e15aed$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $8373ca4214e15aed$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $8373ca4214e15aed$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $8373ca4214e15aed$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $8373ca4214e15aed$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $8373ca4214e15aed$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $8373ca4214e15aed$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $8373ca4214e15aed$var$sanitizeURL(url) {
    return $8373ca4214e15aed$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $8373ca4214e15aed$var$noop$1() {}
var $8373ca4214e15aed$var$currentReplayingEvent = null;
function $8373ca4214e15aed$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $8373ca4214e15aed$var$restoreTarget = null, $8373ca4214e15aed$var$restoreQueue = null;
function $8373ca4214e15aed$var$restoreStateOfTarget(target) {
    var internalInstance = $8373ca4214e15aed$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$8373ca4214e15aed$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $8373ca4214e15aed$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $8373ca4214e15aed$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$8373ca4214e15aed$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(90));
                            $8373ca4214e15aed$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $8373ca4214e15aed$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $8373ca4214e15aed$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $8373ca4214e15aed$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $8373ca4214e15aed$var$isInsideEventHandler = !1;
function $8373ca4214e15aed$var$batchedUpdates$1(fn, a, b) {
    if ($8373ca4214e15aed$var$isInsideEventHandler) return fn(a, b);
    $8373ca4214e15aed$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($8373ca4214e15aed$var$isInsideEventHandler = !1, null !== $8373ca4214e15aed$var$restoreTarget || null !== $8373ca4214e15aed$var$restoreQueue) {
            if ($8373ca4214e15aed$var$flushSyncWork$1(), $8373ca4214e15aed$var$restoreTarget && (a = $8373ca4214e15aed$var$restoreTarget, fn = $8373ca4214e15aed$var$restoreQueue, $8373ca4214e15aed$var$restoreQueue = $8373ca4214e15aed$var$restoreTarget = null, $8373ca4214e15aed$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$8373ca4214e15aed$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $8373ca4214e15aed$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$8373ca4214e15aed$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $8373ca4214e15aed$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $8373ca4214e15aed$var$passiveBrowserEventsSupported = !1;
if ($8373ca4214e15aed$var$canUseDOM) try {
    var $8373ca4214e15aed$var$options = {};
    Object.defineProperty($8373ca4214e15aed$var$options, "passive", {
        get: function() {
            $8373ca4214e15aed$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $8373ca4214e15aed$var$options, $8373ca4214e15aed$var$options);
    window.removeEventListener("test", $8373ca4214e15aed$var$options, $8373ca4214e15aed$var$options);
} catch (e) {
    $8373ca4214e15aed$var$passiveBrowserEventsSupported = !1;
}
var $8373ca4214e15aed$var$root = null, $8373ca4214e15aed$var$startText = null, $8373ca4214e15aed$var$fallbackText = null;
function $8373ca4214e15aed$var$getData() {
    if ($8373ca4214e15aed$var$fallbackText) return $8373ca4214e15aed$var$fallbackText;
    var start, startValue = $8373ca4214e15aed$var$startText, startLength = startValue.length, end, endValue = "value" in $8373ca4214e15aed$var$root ? $8373ca4214e15aed$var$root.value : $8373ca4214e15aed$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $8373ca4214e15aed$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $8373ca4214e15aed$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $8373ca4214e15aed$var$functionThatReturnsTrue() {
    return !0;
}
function $8373ca4214e15aed$var$functionThatReturnsFalse() {
    return !1;
}
function $8373ca4214e15aed$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $8373ca4214e15aed$var$functionThatReturnsTrue : $8373ca4214e15aed$var$functionThatReturnsFalse;
        this.isPropagationStopped = $8373ca4214e15aed$var$functionThatReturnsFalse;
        return this;
    }
    $8373ca4214e15aed$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $8373ca4214e15aed$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $8373ca4214e15aed$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $8373ca4214e15aed$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $8373ca4214e15aed$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $8373ca4214e15aed$var$SyntheticEvent = $8373ca4214e15aed$var$createSyntheticEvent($8373ca4214e15aed$var$EventInterface), $8373ca4214e15aed$var$UIEventInterface = $8373ca4214e15aed$var$assign({}, $8373ca4214e15aed$var$EventInterface, {
    view: 0,
    detail: 0
}), $8373ca4214e15aed$var$SyntheticUIEvent = $8373ca4214e15aed$var$createSyntheticEvent($8373ca4214e15aed$var$UIEventInterface), $8373ca4214e15aed$var$lastMovementX, $8373ca4214e15aed$var$lastMovementY, $8373ca4214e15aed$var$lastMouseEvent, $8373ca4214e15aed$var$MouseEventInterface = $8373ca4214e15aed$var$assign({}, $8373ca4214e15aed$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $8373ca4214e15aed$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $8373ca4214e15aed$var$lastMouseEvent && ($8373ca4214e15aed$var$lastMouseEvent && "mousemove" === event.type ? ($8373ca4214e15aed$var$lastMovementX = event.screenX - $8373ca4214e15aed$var$lastMouseEvent.screenX, $8373ca4214e15aed$var$lastMovementY = event.screenY - $8373ca4214e15aed$var$lastMouseEvent.screenY) : $8373ca4214e15aed$var$lastMovementY = $8373ca4214e15aed$var$lastMovementX = 0, $8373ca4214e15aed$var$lastMouseEvent = event);
        return $8373ca4214e15aed$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $8373ca4214e15aed$var$lastMovementY;
    }
}), $8373ca4214e15aed$var$SyntheticMouseEvent = $8373ca4214e15aed$var$createSyntheticEvent($8373ca4214e15aed$var$MouseEventInterface), $8373ca4214e15aed$var$DragEventInterface = $8373ca4214e15aed$var$assign({}, $8373ca4214e15aed$var$MouseEventInterface, {
    dataTransfer: 0
}), $8373ca4214e15aed$var$SyntheticDragEvent = $8373ca4214e15aed$var$createSyntheticEvent($8373ca4214e15aed$var$DragEventInterface), $8373ca4214e15aed$var$FocusEventInterface = $8373ca4214e15aed$var$assign({}, $8373ca4214e15aed$var$UIEventInterface, {
    relatedTarget: 0
}), $8373ca4214e15aed$var$SyntheticFocusEvent = $8373ca4214e15aed$var$createSyntheticEvent($8373ca4214e15aed$var$FocusEventInterface), $8373ca4214e15aed$var$AnimationEventInterface = $8373ca4214e15aed$var$assign({}, $8373ca4214e15aed$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $8373ca4214e15aed$var$SyntheticAnimationEvent = $8373ca4214e15aed$var$createSyntheticEvent($8373ca4214e15aed$var$AnimationEventInterface), $8373ca4214e15aed$var$ClipboardEventInterface = $8373ca4214e15aed$var$assign({}, $8373ca4214e15aed$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $8373ca4214e15aed$var$SyntheticClipboardEvent = $8373ca4214e15aed$var$createSyntheticEvent($8373ca4214e15aed$var$ClipboardEventInterface), $8373ca4214e15aed$var$CompositionEventInterface = $8373ca4214e15aed$var$assign({}, $8373ca4214e15aed$var$EventInterface, {
    data: 0
}), $8373ca4214e15aed$var$SyntheticCompositionEvent = $8373ca4214e15aed$var$createSyntheticEvent($8373ca4214e15aed$var$CompositionEventInterface), $8373ca4214e15aed$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $8373ca4214e15aed$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $8373ca4214e15aed$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $8373ca4214e15aed$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $8373ca4214e15aed$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $8373ca4214e15aed$var$getEventModifierState() {
    return $8373ca4214e15aed$var$modifierStateGetter;
}
var $8373ca4214e15aed$var$KeyboardEventInterface = $8373ca4214e15aed$var$assign({}, $8373ca4214e15aed$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $8373ca4214e15aed$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $8373ca4214e15aed$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $8373ca4214e15aed$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $8373ca4214e15aed$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $8373ca4214e15aed$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $8373ca4214e15aed$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $8373ca4214e15aed$var$SyntheticKeyboardEvent = $8373ca4214e15aed$var$createSyntheticEvent($8373ca4214e15aed$var$KeyboardEventInterface), $8373ca4214e15aed$var$PointerEventInterface = $8373ca4214e15aed$var$assign({}, $8373ca4214e15aed$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $8373ca4214e15aed$var$SyntheticPointerEvent = $8373ca4214e15aed$var$createSyntheticEvent($8373ca4214e15aed$var$PointerEventInterface), $8373ca4214e15aed$var$TouchEventInterface = $8373ca4214e15aed$var$assign({}, $8373ca4214e15aed$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $8373ca4214e15aed$var$getEventModifierState
}), $8373ca4214e15aed$var$SyntheticTouchEvent = $8373ca4214e15aed$var$createSyntheticEvent($8373ca4214e15aed$var$TouchEventInterface), $8373ca4214e15aed$var$TransitionEventInterface = $8373ca4214e15aed$var$assign({}, $8373ca4214e15aed$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $8373ca4214e15aed$var$SyntheticTransitionEvent = $8373ca4214e15aed$var$createSyntheticEvent($8373ca4214e15aed$var$TransitionEventInterface), $8373ca4214e15aed$var$WheelEventInterface = $8373ca4214e15aed$var$assign({}, $8373ca4214e15aed$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $8373ca4214e15aed$var$SyntheticWheelEvent = $8373ca4214e15aed$var$createSyntheticEvent($8373ca4214e15aed$var$WheelEventInterface), $8373ca4214e15aed$var$ToggleEventInterface = $8373ca4214e15aed$var$assign({}, $8373ca4214e15aed$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $8373ca4214e15aed$var$SyntheticToggleEvent = $8373ca4214e15aed$var$createSyntheticEvent($8373ca4214e15aed$var$ToggleEventInterface), $8373ca4214e15aed$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $8373ca4214e15aed$var$canUseCompositionEvent = $8373ca4214e15aed$var$canUseDOM && "CompositionEvent" in window, $8373ca4214e15aed$var$documentMode = null;
$8373ca4214e15aed$var$canUseDOM && "documentMode" in document && ($8373ca4214e15aed$var$documentMode = document.documentMode);
var $8373ca4214e15aed$var$canUseTextInputEvent = $8373ca4214e15aed$var$canUseDOM && "TextEvent" in window && !$8373ca4214e15aed$var$documentMode, $8373ca4214e15aed$var$useFallbackCompositionData = $8373ca4214e15aed$var$canUseDOM && (!$8373ca4214e15aed$var$canUseCompositionEvent || $8373ca4214e15aed$var$documentMode && 8 < $8373ca4214e15aed$var$documentMode && 11 >= $8373ca4214e15aed$var$documentMode), $8373ca4214e15aed$var$SPACEBAR_CHAR = String.fromCharCode(32), $8373ca4214e15aed$var$hasSpaceKeypress = !1;
function $8373ca4214e15aed$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $8373ca4214e15aed$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $8373ca4214e15aed$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $8373ca4214e15aed$var$isComposing = !1;
function $8373ca4214e15aed$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $8373ca4214e15aed$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $8373ca4214e15aed$var$hasSpaceKeypress = !0;
            return $8373ca4214e15aed$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $8373ca4214e15aed$var$SPACEBAR_CHAR && $8373ca4214e15aed$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $8373ca4214e15aed$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($8373ca4214e15aed$var$isComposing) return "compositionend" === domEventName || !$8373ca4214e15aed$var$canUseCompositionEvent && $8373ca4214e15aed$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $8373ca4214e15aed$var$getData(), $8373ca4214e15aed$var$fallbackText = $8373ca4214e15aed$var$startText = $8373ca4214e15aed$var$root = null, $8373ca4214e15aed$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $8373ca4214e15aed$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $8373ca4214e15aed$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $8373ca4214e15aed$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$8373ca4214e15aed$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $8373ca4214e15aed$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $8373ca4214e15aed$var$restoreTarget ? $8373ca4214e15aed$var$restoreQueue ? $8373ca4214e15aed$var$restoreQueue.push(target) : $8373ca4214e15aed$var$restoreQueue = [
        target
    ] : $8373ca4214e15aed$var$restoreTarget = target;
    inst = $8373ca4214e15aed$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $8373ca4214e15aed$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $8373ca4214e15aed$var$activeElement$1 = null, $8373ca4214e15aed$var$activeElementInst$1 = null;
function $8373ca4214e15aed$var$runEventInBatch(dispatchQueue) {
    $8373ca4214e15aed$var$processDispatchQueue(dispatchQueue, 0);
}
function $8373ca4214e15aed$var$getInstIfValueChanged(targetInst) {
    var targetNode = $8373ca4214e15aed$var$getNodeFromInstance(targetInst);
    if ($8373ca4214e15aed$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $8373ca4214e15aed$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $8373ca4214e15aed$var$isInputEventSupported = !1;
if ($8373ca4214e15aed$var$canUseDOM) {
    var $8373ca4214e15aed$var$JSCompiler_inline_result$jscomp$286;
    if ($8373ca4214e15aed$var$canUseDOM) {
        var $8373ca4214e15aed$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$8373ca4214e15aed$var$isSupported$jscomp$inline_427) {
            var $8373ca4214e15aed$var$element$jscomp$inline_428 = document.createElement("div");
            $8373ca4214e15aed$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $8373ca4214e15aed$var$isSupported$jscomp$inline_427 = "function" === typeof $8373ca4214e15aed$var$element$jscomp$inline_428.oninput;
        }
        $8373ca4214e15aed$var$JSCompiler_inline_result$jscomp$286 = $8373ca4214e15aed$var$isSupported$jscomp$inline_427;
    } else $8373ca4214e15aed$var$JSCompiler_inline_result$jscomp$286 = !1;
    $8373ca4214e15aed$var$isInputEventSupported = $8373ca4214e15aed$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $8373ca4214e15aed$var$stopWatchingForValueChange() {
    $8373ca4214e15aed$var$activeElement$1 && ($8373ca4214e15aed$var$activeElement$1.detachEvent("onpropertychange", $8373ca4214e15aed$var$handlePropertyChange), $8373ca4214e15aed$var$activeElementInst$1 = $8373ca4214e15aed$var$activeElement$1 = null);
}
function $8373ca4214e15aed$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $8373ca4214e15aed$var$getInstIfValueChanged($8373ca4214e15aed$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $8373ca4214e15aed$var$createAndAccumulateChangeEvent(dispatchQueue, $8373ca4214e15aed$var$activeElementInst$1, nativeEvent, $8373ca4214e15aed$var$getEventTarget(nativeEvent));
        $8373ca4214e15aed$var$batchedUpdates$1($8373ca4214e15aed$var$runEventInBatch, dispatchQueue);
    }
}
function $8373ca4214e15aed$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($8373ca4214e15aed$var$stopWatchingForValueChange(), $8373ca4214e15aed$var$activeElement$1 = target, $8373ca4214e15aed$var$activeElementInst$1 = targetInst, $8373ca4214e15aed$var$activeElement$1.attachEvent("onpropertychange", $8373ca4214e15aed$var$handlePropertyChange)) : "focusout" === domEventName && $8373ca4214e15aed$var$stopWatchingForValueChange();
}
function $8373ca4214e15aed$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $8373ca4214e15aed$var$getInstIfValueChanged($8373ca4214e15aed$var$activeElementInst$1);
}
function $8373ca4214e15aed$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $8373ca4214e15aed$var$getInstIfValueChanged(targetInst);
}
function $8373ca4214e15aed$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $8373ca4214e15aed$var$getInstIfValueChanged(targetInst);
}
function $8373ca4214e15aed$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $8373ca4214e15aed$var$objectIs = "function" === typeof Object.is ? Object.is : $8373ca4214e15aed$var$is;
function $8373ca4214e15aed$var$shallowEqual(objA, objB) {
    if ($8373ca4214e15aed$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$8373ca4214e15aed$var$hasOwnProperty.call(objB, currentKey) || !$8373ca4214e15aed$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $8373ca4214e15aed$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $8373ca4214e15aed$var$getNodeForCharacterOffset(root, offset) {
    var node = $8373ca4214e15aed$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $8373ca4214e15aed$var$getLeafNode(node);
    }
}
function $8373ca4214e15aed$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $8373ca4214e15aed$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $8373ca4214e15aed$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $8373ca4214e15aed$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $8373ca4214e15aed$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $8373ca4214e15aed$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $8373ca4214e15aed$var$skipSelectionChangeEvent = $8373ca4214e15aed$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $8373ca4214e15aed$var$activeElement = null, $8373ca4214e15aed$var$activeElementInst = null, $8373ca4214e15aed$var$lastSelection = null, $8373ca4214e15aed$var$mouseDown = !1;
function $8373ca4214e15aed$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $8373ca4214e15aed$var$mouseDown || null == $8373ca4214e15aed$var$activeElement || $8373ca4214e15aed$var$activeElement !== $8373ca4214e15aed$var$getActiveElement(doc) || (doc = $8373ca4214e15aed$var$activeElement, "selectionStart" in doc && $8373ca4214e15aed$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $8373ca4214e15aed$var$lastSelection && $8373ca4214e15aed$var$shallowEqual($8373ca4214e15aed$var$lastSelection, doc) || ($8373ca4214e15aed$var$lastSelection = doc, doc = $8373ca4214e15aed$var$accumulateTwoPhaseListeners($8373ca4214e15aed$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $8373ca4214e15aed$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $8373ca4214e15aed$var$activeElement)));
}
function $8373ca4214e15aed$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $8373ca4214e15aed$var$vendorPrefixes = {
    animationend: $8373ca4214e15aed$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $8373ca4214e15aed$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $8373ca4214e15aed$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $8373ca4214e15aed$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $8373ca4214e15aed$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $8373ca4214e15aed$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $8373ca4214e15aed$var$makePrefixMap("Transition", "TransitionEnd")
}, $8373ca4214e15aed$var$prefixedEventNames = {}, $8373ca4214e15aed$var$style = {};
$8373ca4214e15aed$var$canUseDOM && ($8373ca4214e15aed$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $8373ca4214e15aed$var$vendorPrefixes.animationend.animation, delete $8373ca4214e15aed$var$vendorPrefixes.animationiteration.animation, delete $8373ca4214e15aed$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $8373ca4214e15aed$var$vendorPrefixes.transitionend.transition);
function $8373ca4214e15aed$var$getVendorPrefixedEventName(eventName) {
    if ($8373ca4214e15aed$var$prefixedEventNames[eventName]) return $8373ca4214e15aed$var$prefixedEventNames[eventName];
    if (!$8373ca4214e15aed$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $8373ca4214e15aed$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $8373ca4214e15aed$var$style) return $8373ca4214e15aed$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $8373ca4214e15aed$var$ANIMATION_END = $8373ca4214e15aed$var$getVendorPrefixedEventName("animationend"), $8373ca4214e15aed$var$ANIMATION_ITERATION = $8373ca4214e15aed$var$getVendorPrefixedEventName("animationiteration"), $8373ca4214e15aed$var$ANIMATION_START = $8373ca4214e15aed$var$getVendorPrefixedEventName("animationstart"), $8373ca4214e15aed$var$TRANSITION_RUN = $8373ca4214e15aed$var$getVendorPrefixedEventName("transitionrun"), $8373ca4214e15aed$var$TRANSITION_START = $8373ca4214e15aed$var$getVendorPrefixedEventName("transitionstart"), $8373ca4214e15aed$var$TRANSITION_CANCEL = $8373ca4214e15aed$var$getVendorPrefixedEventName("transitioncancel"), $8373ca4214e15aed$var$TRANSITION_END = $8373ca4214e15aed$var$getVendorPrefixedEventName("transitionend"), $8373ca4214e15aed$var$topLevelEventsToReactNames = new Map(), $8373ca4214e15aed$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$8373ca4214e15aed$var$simpleEventPluginEvents.push("scrollEnd");
function $8373ca4214e15aed$var$registerSimpleEvent(domEventName, reactName) {
    $8373ca4214e15aed$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $8373ca4214e15aed$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $8373ca4214e15aed$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    } else if ("object" === typeof $4dBQg && "function" === typeof $4dBQg.emit) {
        $4dBQg.emit("uncaughtException", error);
        return;
    }
    console.error(error);
}, $8373ca4214e15aed$var$concurrentQueues = [], $8373ca4214e15aed$var$concurrentQueuesIndex = 0, $8373ca4214e15aed$var$concurrentlyUpdatedLanes = 0;
function $8373ca4214e15aed$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $8373ca4214e15aed$var$concurrentQueuesIndex, i = $8373ca4214e15aed$var$concurrentlyUpdatedLanes = $8373ca4214e15aed$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $8373ca4214e15aed$var$concurrentQueues[i];
        $8373ca4214e15aed$var$concurrentQueues[i++] = null;
        var queue = $8373ca4214e15aed$var$concurrentQueues[i];
        $8373ca4214e15aed$var$concurrentQueues[i++] = null;
        var update = $8373ca4214e15aed$var$concurrentQueues[i];
        $8373ca4214e15aed$var$concurrentQueues[i++] = null;
        var lane = $8373ca4214e15aed$var$concurrentQueues[i];
        $8373ca4214e15aed$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $8373ca4214e15aed$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $8373ca4214e15aed$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $8373ca4214e15aed$var$concurrentQueues[$8373ca4214e15aed$var$concurrentQueuesIndex++] = fiber;
    $8373ca4214e15aed$var$concurrentQueues[$8373ca4214e15aed$var$concurrentQueuesIndex++] = queue;
    $8373ca4214e15aed$var$concurrentQueues[$8373ca4214e15aed$var$concurrentQueuesIndex++] = update;
    $8373ca4214e15aed$var$concurrentQueues[$8373ca4214e15aed$var$concurrentQueuesIndex++] = lane;
    $8373ca4214e15aed$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $8373ca4214e15aed$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $8373ca4214e15aed$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $8373ca4214e15aed$var$getRootForUpdatedFiber(fiber);
}
function $8373ca4214e15aed$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $8373ca4214e15aed$var$enqueueUpdate$1(fiber, null, null, lane);
    return $8373ca4214e15aed$var$getRootForUpdatedFiber(fiber);
}
function $8373ca4214e15aed$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $8373ca4214e15aed$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $8373ca4214e15aed$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $8373ca4214e15aed$var$nestedUpdateCount) throw $8373ca4214e15aed$var$nestedUpdateCount = 0, $8373ca4214e15aed$var$rootWithNestedUpdates = null, Error($8373ca4214e15aed$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $8373ca4214e15aed$var$emptyContextObject = {};
function $8373ca4214e15aed$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $8373ca4214e15aed$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $8373ca4214e15aed$var$FiberNode(tag, pendingProps, key, mode);
}
function $8373ca4214e15aed$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $8373ca4214e15aed$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $8373ca4214e15aed$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $8373ca4214e15aed$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $8373ca4214e15aed$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $8373ca4214e15aed$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $8373ca4214e15aed$var$isHostHoistableType(type, pendingProps, $8373ca4214e15aed$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $8373ca4214e15aed$var$REACT_ACTIVITY_TYPE:
            return type = $8373ca4214e15aed$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $8373ca4214e15aed$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $8373ca4214e15aed$var$REACT_FRAGMENT_TYPE:
            return $8373ca4214e15aed$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $8373ca4214e15aed$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $8373ca4214e15aed$var$REACT_PROFILER_TYPE:
            return type = $8373ca4214e15aed$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $8373ca4214e15aed$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $8373ca4214e15aed$var$REACT_SUSPENSE_TYPE:
            return type = $8373ca4214e15aed$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $8373ca4214e15aed$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $8373ca4214e15aed$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $8373ca4214e15aed$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $8373ca4214e15aed$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $8373ca4214e15aed$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $8373ca4214e15aed$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $8373ca4214e15aed$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $8373ca4214e15aed$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $8373ca4214e15aed$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($8373ca4214e15aed$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $8373ca4214e15aed$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $8373ca4214e15aed$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $8373ca4214e15aed$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $8373ca4214e15aed$var$createFiberFromText(content, mode, lanes) {
    content = $8373ca4214e15aed$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $8373ca4214e15aed$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $8373ca4214e15aed$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $8373ca4214e15aed$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $8373ca4214e15aed$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $8373ca4214e15aed$var$CapturedStacks = new WeakMap();
function $8373ca4214e15aed$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $8373ca4214e15aed$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $8373ca4214e15aed$var$getStackByFiberInDevAndProd(source)
        };
        $8373ca4214e15aed$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $8373ca4214e15aed$var$getStackByFiberInDevAndProd(source)
    };
}
var $8373ca4214e15aed$var$forkStack = [], $8373ca4214e15aed$var$forkStackIndex = 0, $8373ca4214e15aed$var$treeForkProvider = null, $8373ca4214e15aed$var$treeForkCount = 0, $8373ca4214e15aed$var$idStack = [], $8373ca4214e15aed$var$idStackIndex = 0, $8373ca4214e15aed$var$treeContextProvider = null, $8373ca4214e15aed$var$treeContextId = 1, $8373ca4214e15aed$var$treeContextOverflow = "";
function $8373ca4214e15aed$var$pushTreeFork(workInProgress, totalChildren) {
    $8373ca4214e15aed$var$forkStack[$8373ca4214e15aed$var$forkStackIndex++] = $8373ca4214e15aed$var$treeForkCount;
    $8373ca4214e15aed$var$forkStack[$8373ca4214e15aed$var$forkStackIndex++] = $8373ca4214e15aed$var$treeForkProvider;
    $8373ca4214e15aed$var$treeForkProvider = workInProgress;
    $8373ca4214e15aed$var$treeForkCount = totalChildren;
}
function $8373ca4214e15aed$var$pushTreeId(workInProgress, totalChildren, index) {
    $8373ca4214e15aed$var$idStack[$8373ca4214e15aed$var$idStackIndex++] = $8373ca4214e15aed$var$treeContextId;
    $8373ca4214e15aed$var$idStack[$8373ca4214e15aed$var$idStackIndex++] = $8373ca4214e15aed$var$treeContextOverflow;
    $8373ca4214e15aed$var$idStack[$8373ca4214e15aed$var$idStackIndex++] = $8373ca4214e15aed$var$treeContextProvider;
    $8373ca4214e15aed$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $8373ca4214e15aed$var$treeContextId;
    workInProgress = $8373ca4214e15aed$var$treeContextOverflow;
    var baseLength = 32 - $8373ca4214e15aed$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $8373ca4214e15aed$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $8373ca4214e15aed$var$treeContextId = 1 << 32 - $8373ca4214e15aed$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $8373ca4214e15aed$var$treeContextOverflow = length + workInProgress;
    } else $8373ca4214e15aed$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $8373ca4214e15aed$var$treeContextOverflow = workInProgress;
}
function $8373ca4214e15aed$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($8373ca4214e15aed$var$pushTreeFork(workInProgress, 1), $8373ca4214e15aed$var$pushTreeId(workInProgress, 1, 0));
}
function $8373ca4214e15aed$var$popTreeContext(workInProgress) {
    for(; workInProgress === $8373ca4214e15aed$var$treeForkProvider;)$8373ca4214e15aed$var$treeForkProvider = $8373ca4214e15aed$var$forkStack[--$8373ca4214e15aed$var$forkStackIndex], $8373ca4214e15aed$var$forkStack[$8373ca4214e15aed$var$forkStackIndex] = null, $8373ca4214e15aed$var$treeForkCount = $8373ca4214e15aed$var$forkStack[--$8373ca4214e15aed$var$forkStackIndex], $8373ca4214e15aed$var$forkStack[$8373ca4214e15aed$var$forkStackIndex] = null;
    for(; workInProgress === $8373ca4214e15aed$var$treeContextProvider;)$8373ca4214e15aed$var$treeContextProvider = $8373ca4214e15aed$var$idStack[--$8373ca4214e15aed$var$idStackIndex], $8373ca4214e15aed$var$idStack[$8373ca4214e15aed$var$idStackIndex] = null, $8373ca4214e15aed$var$treeContextOverflow = $8373ca4214e15aed$var$idStack[--$8373ca4214e15aed$var$idStackIndex], $8373ca4214e15aed$var$idStack[$8373ca4214e15aed$var$idStackIndex] = null, $8373ca4214e15aed$var$treeContextId = $8373ca4214e15aed$var$idStack[--$8373ca4214e15aed$var$idStackIndex], $8373ca4214e15aed$var$idStack[$8373ca4214e15aed$var$idStackIndex] = null;
}
function $8373ca4214e15aed$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $8373ca4214e15aed$var$idStack[$8373ca4214e15aed$var$idStackIndex++] = $8373ca4214e15aed$var$treeContextId;
    $8373ca4214e15aed$var$idStack[$8373ca4214e15aed$var$idStackIndex++] = $8373ca4214e15aed$var$treeContextOverflow;
    $8373ca4214e15aed$var$idStack[$8373ca4214e15aed$var$idStackIndex++] = $8373ca4214e15aed$var$treeContextProvider;
    $8373ca4214e15aed$var$treeContextId = suspendedContext.id;
    $8373ca4214e15aed$var$treeContextOverflow = suspendedContext.overflow;
    $8373ca4214e15aed$var$treeContextProvider = workInProgress;
}
var $8373ca4214e15aed$var$hydrationParentFiber = null, $8373ca4214e15aed$var$nextHydratableInstance = null, $8373ca4214e15aed$var$isHydrating = !1, $8373ca4214e15aed$var$hydrationErrors = null, $8373ca4214e15aed$var$rootOrSingletonContext = !1, $8373ca4214e15aed$var$HydrationMismatchException = Error($8373ca4214e15aed$var$formatProdErrorMessage(519));
function $8373ca4214e15aed$var$throwOnHydrationMismatch(fiber) {
    var error = Error($8373ca4214e15aed$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $8373ca4214e15aed$var$queueHydrationError($8373ca4214e15aed$var$createCapturedValueAtFiber(error, fiber));
    throw $8373ca4214e15aed$var$HydrationMismatchException;
}
function $8373ca4214e15aed$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$8373ca4214e15aed$var$internalInstanceKey] = fiber;
    instance[$8373ca4214e15aed$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $8373ca4214e15aed$var$listenToNonDelegatedEvent("cancel", instance);
            $8373ca4214e15aed$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $8373ca4214e15aed$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $8373ca4214e15aed$var$mediaEventTypes.length; type++)$8373ca4214e15aed$var$listenToNonDelegatedEvent($8373ca4214e15aed$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $8373ca4214e15aed$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $8373ca4214e15aed$var$listenToNonDelegatedEvent("error", instance);
            $8373ca4214e15aed$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $8373ca4214e15aed$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $8373ca4214e15aed$var$listenToNonDelegatedEvent("invalid", instance);
            $8373ca4214e15aed$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $8373ca4214e15aed$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $8373ca4214e15aed$var$listenToNonDelegatedEvent("invalid", instance), $8373ca4214e15aed$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $8373ca4214e15aed$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($8373ca4214e15aed$var$listenToNonDelegatedEvent("beforetoggle", instance), $8373ca4214e15aed$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $8373ca4214e15aed$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $8373ca4214e15aed$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $8373ca4214e15aed$var$noop$1), instance = !0) : instance = !1;
    instance || $8373ca4214e15aed$var$throwOnHydrationMismatch(fiber, !0);
}
function $8373ca4214e15aed$var$popToNextHostParent(fiber) {
    for($8373ca4214e15aed$var$hydrationParentFiber = fiber.return; $8373ca4214e15aed$var$hydrationParentFiber;)switch($8373ca4214e15aed$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $8373ca4214e15aed$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $8373ca4214e15aed$var$rootOrSingletonContext = !0;
            return;
        default:
            $8373ca4214e15aed$var$hydrationParentFiber = $8373ca4214e15aed$var$hydrationParentFiber.return;
    }
}
function $8373ca4214e15aed$var$popHydrationState(fiber) {
    if (fiber !== $8373ca4214e15aed$var$hydrationParentFiber) return !1;
    if (!$8373ca4214e15aed$var$isHydrating) return $8373ca4214e15aed$var$popToNextHostParent(fiber), $8373ca4214e15aed$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $8373ca4214e15aed$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $8373ca4214e15aed$var$nextHydratableInstance && $8373ca4214e15aed$var$throwOnHydrationMismatch(fiber);
    $8373ca4214e15aed$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(317));
        $8373ca4214e15aed$var$nextHydratableInstance = $8373ca4214e15aed$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(317));
        $8373ca4214e15aed$var$nextHydratableInstance = $8373ca4214e15aed$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $8373ca4214e15aed$var$nextHydratableInstance, $8373ca4214e15aed$var$isSingletonScope(fiber.type) ? (fiber = $8373ca4214e15aed$var$previousHydratableOnEnteringScopedSingleton, $8373ca4214e15aed$var$previousHydratableOnEnteringScopedSingleton = null, $8373ca4214e15aed$var$nextHydratableInstance = fiber) : $8373ca4214e15aed$var$nextHydratableInstance = tag) : $8373ca4214e15aed$var$nextHydratableInstance = $8373ca4214e15aed$var$hydrationParentFiber ? $8373ca4214e15aed$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $8373ca4214e15aed$var$resetHydrationState() {
    $8373ca4214e15aed$var$nextHydratableInstance = $8373ca4214e15aed$var$hydrationParentFiber = null;
    $8373ca4214e15aed$var$isHydrating = !1;
}
function $8373ca4214e15aed$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $8373ca4214e15aed$var$hydrationErrors;
    null !== queuedErrors && (null === $8373ca4214e15aed$var$workInProgressRootRecoverableErrors ? $8373ca4214e15aed$var$workInProgressRootRecoverableErrors = queuedErrors : $8373ca4214e15aed$var$workInProgressRootRecoverableErrors.push.apply($8373ca4214e15aed$var$workInProgressRootRecoverableErrors, queuedErrors), $8373ca4214e15aed$var$hydrationErrors = null);
    return queuedErrors;
}
function $8373ca4214e15aed$var$queueHydrationError(error) {
    null === $8373ca4214e15aed$var$hydrationErrors ? $8373ca4214e15aed$var$hydrationErrors = [
        error
    ] : $8373ca4214e15aed$var$hydrationErrors.push(error);
}
var $8373ca4214e15aed$var$valueCursor = $8373ca4214e15aed$var$createCursor(null), $8373ca4214e15aed$var$currentlyRenderingFiber$1 = null, $8373ca4214e15aed$var$lastContextDependency = null;
function $8373ca4214e15aed$var$pushProvider(providerFiber, context, nextValue) {
    $8373ca4214e15aed$var$push($8373ca4214e15aed$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $8373ca4214e15aed$var$popProvider(context) {
    context._currentValue = $8373ca4214e15aed$var$valueCursor.current;
    $8373ca4214e15aed$var$pop($8373ca4214e15aed$var$valueCursor);
}
function $8373ca4214e15aed$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $8373ca4214e15aed$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $8373ca4214e15aed$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $8373ca4214e15aed$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $8373ca4214e15aed$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $8373ca4214e15aed$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $8373ca4214e15aed$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($8373ca4214e15aed$var$HostTransitionContext) : current = [
                $8373ca4214e15aed$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $8373ca4214e15aed$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $8373ca4214e15aed$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$8373ca4214e15aed$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $8373ca4214e15aed$var$prepareToReadContext(workInProgress) {
    $8373ca4214e15aed$var$currentlyRenderingFiber$1 = workInProgress;
    $8373ca4214e15aed$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $8373ca4214e15aed$var$readContext(context) {
    return $8373ca4214e15aed$var$readContextForConsumer($8373ca4214e15aed$var$currentlyRenderingFiber$1, context);
}
function $8373ca4214e15aed$var$readContextDuringReconciliation(consumer, context) {
    null === $8373ca4214e15aed$var$currentlyRenderingFiber$1 && $8373ca4214e15aed$var$prepareToReadContext(consumer);
    return $8373ca4214e15aed$var$readContextForConsumer(consumer, context);
}
function $8373ca4214e15aed$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $8373ca4214e15aed$var$lastContextDependency) {
        if (null === consumer) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(308));
        $8373ca4214e15aed$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $8373ca4214e15aed$var$lastContextDependency = $8373ca4214e15aed$var$lastContextDependency.next = context;
    return value;
}
var $8373ca4214e15aed$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $8373ca4214e15aed$var$scheduleCallback$2 = $1zXL0.unstable_scheduleCallback, $8373ca4214e15aed$var$NormalPriority = $1zXL0.unstable_NormalPriority, $8373ca4214e15aed$var$CacheContext = {
    $$typeof: $8373ca4214e15aed$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $8373ca4214e15aed$var$createCache() {
    return {
        controller: new $8373ca4214e15aed$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $8373ca4214e15aed$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $8373ca4214e15aed$var$scheduleCallback$2($8373ca4214e15aed$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $8373ca4214e15aed$var$currentEntangledListeners = null, $8373ca4214e15aed$var$currentEntangledPendingCount = 0, $8373ca4214e15aed$var$currentEntangledLane = 0, $8373ca4214e15aed$var$currentEntangledActionThenable = null;
function $8373ca4214e15aed$var$entangleAsyncAction(transition, thenable) {
    if (null === $8373ca4214e15aed$var$currentEntangledListeners) {
        var entangledListeners = $8373ca4214e15aed$var$currentEntangledListeners = [];
        $8373ca4214e15aed$var$currentEntangledPendingCount = 0;
        $8373ca4214e15aed$var$currentEntangledLane = $8373ca4214e15aed$var$requestTransitionLane();
        $8373ca4214e15aed$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $8373ca4214e15aed$var$currentEntangledPendingCount++;
    thenable.then($8373ca4214e15aed$var$pingEngtangledActionScope, $8373ca4214e15aed$var$pingEngtangledActionScope);
    return thenable;
}
function $8373ca4214e15aed$var$pingEngtangledActionScope() {
    if (0 === --$8373ca4214e15aed$var$currentEntangledPendingCount && null !== $8373ca4214e15aed$var$currentEntangledListeners) {
        null !== $8373ca4214e15aed$var$currentEntangledActionThenable && ($8373ca4214e15aed$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $8373ca4214e15aed$var$currentEntangledListeners;
        $8373ca4214e15aed$var$currentEntangledListeners = null;
        $8373ca4214e15aed$var$currentEntangledLane = 0;
        $8373ca4214e15aed$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $8373ca4214e15aed$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $8373ca4214e15aed$var$prevOnStartTransitionFinish = $8373ca4214e15aed$var$ReactSharedInternals.S;
$8373ca4214e15aed$var$ReactSharedInternals.S = function(transition, returnValue) {
    $8373ca4214e15aed$var$globalMostRecentTransitionTime = $8373ca4214e15aed$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $8373ca4214e15aed$var$entangleAsyncAction(transition, returnValue);
    null !== $8373ca4214e15aed$var$prevOnStartTransitionFinish && $8373ca4214e15aed$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $8373ca4214e15aed$var$resumedCache = $8373ca4214e15aed$var$createCursor(null);
function $8373ca4214e15aed$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $8373ca4214e15aed$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $8373ca4214e15aed$var$workInProgressRoot.pooledCache;
}
function $8373ca4214e15aed$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $8373ca4214e15aed$var$push($8373ca4214e15aed$var$resumedCache, $8373ca4214e15aed$var$resumedCache.current) : $8373ca4214e15aed$var$push($8373ca4214e15aed$var$resumedCache, prevCachePool.pool);
}
function $8373ca4214e15aed$var$getSuspendedCache() {
    var cacheFromPool = $8373ca4214e15aed$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $8373ca4214e15aed$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $8373ca4214e15aed$var$SuspenseException = Error($8373ca4214e15aed$var$formatProdErrorMessage(460)), $8373ca4214e15aed$var$SuspenseyCommitException = Error($8373ca4214e15aed$var$formatProdErrorMessage(474)), $8373ca4214e15aed$var$SuspenseActionException = Error($8373ca4214e15aed$var$formatProdErrorMessage(542)), $8373ca4214e15aed$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $8373ca4214e15aed$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $8373ca4214e15aed$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($8373ca4214e15aed$var$noop$1, $8373ca4214e15aed$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $8373ca4214e15aed$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($8373ca4214e15aed$var$noop$1, $8373ca4214e15aed$var$noop$1);
            else {
                thenableState = $8373ca4214e15aed$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $8373ca4214e15aed$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $8373ca4214e15aed$var$suspendedThenable = thenable;
            throw $8373ca4214e15aed$var$SuspenseException;
    }
}
function $8373ca4214e15aed$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $8373ca4214e15aed$var$suspendedThenable = x, $8373ca4214e15aed$var$SuspenseException;
        throw x;
    }
}
var $8373ca4214e15aed$var$suspendedThenable = null;
function $8373ca4214e15aed$var$getSuspendedThenable() {
    if (null === $8373ca4214e15aed$var$suspendedThenable) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(459));
    var thenable = $8373ca4214e15aed$var$suspendedThenable;
    $8373ca4214e15aed$var$suspendedThenable = null;
    return thenable;
}
function $8373ca4214e15aed$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $8373ca4214e15aed$var$SuspenseException || rejectedReason === $8373ca4214e15aed$var$SuspenseActionException) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(483));
}
var $8373ca4214e15aed$var$thenableState$1 = null, $8373ca4214e15aed$var$thenableIndexCounter$1 = 0;
function $8373ca4214e15aed$var$unwrapThenable(thenable) {
    var index = $8373ca4214e15aed$var$thenableIndexCounter$1;
    $8373ca4214e15aed$var$thenableIndexCounter$1 += 1;
    null === $8373ca4214e15aed$var$thenableState$1 && ($8373ca4214e15aed$var$thenableState$1 = []);
    return $8373ca4214e15aed$var$trackUsedThenable($8373ca4214e15aed$var$thenableState$1, thenable, index);
}
function $8373ca4214e15aed$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $8373ca4214e15aed$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $8373ca4214e15aed$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($8373ca4214e15aed$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $8373ca4214e15aed$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $8373ca4214e15aed$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $8373ca4214e15aed$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $8373ca4214e15aed$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $8373ca4214e15aed$var$REACT_LAZY_TYPE && $8373ca4214e15aed$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $8373ca4214e15aed$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $8373ca4214e15aed$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $8373ca4214e15aed$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $8373ca4214e15aed$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $8373ca4214e15aed$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $8373ca4214e15aed$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $8373ca4214e15aed$var$REACT_ELEMENT_TYPE:
                    return lanes = $8373ca4214e15aed$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $8373ca4214e15aed$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $8373ca4214e15aed$var$REACT_PORTAL_TYPE:
                    return newChild = $8373ca4214e15aed$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $8373ca4214e15aed$var$REACT_LAZY_TYPE:
                    return newChild = $8373ca4214e15aed$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($8373ca4214e15aed$var$isArrayImpl(newChild) || $8373ca4214e15aed$var$getIteratorFn(newChild)) return newChild = $8373ca4214e15aed$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $8373ca4214e15aed$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $8373ca4214e15aed$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $8373ca4214e15aed$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $8373ca4214e15aed$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $8373ca4214e15aed$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $8373ca4214e15aed$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $8373ca4214e15aed$var$REACT_LAZY_TYPE:
                    return newChild = $8373ca4214e15aed$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($8373ca4214e15aed$var$isArrayImpl(newChild) || $8373ca4214e15aed$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $8373ca4214e15aed$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $8373ca4214e15aed$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $8373ca4214e15aed$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $8373ca4214e15aed$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $8373ca4214e15aed$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $8373ca4214e15aed$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $8373ca4214e15aed$var$REACT_LAZY_TYPE:
                    return newChild = $8373ca4214e15aed$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($8373ca4214e15aed$var$isArrayImpl(newChild) || $8373ca4214e15aed$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $8373ca4214e15aed$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $8373ca4214e15aed$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $8373ca4214e15aed$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $8373ca4214e15aed$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $8373ca4214e15aed$var$isHydrating && $8373ca4214e15aed$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $8373ca4214e15aed$var$isHydrating && $8373ca4214e15aed$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $8373ca4214e15aed$var$isHydrating && $8373ca4214e15aed$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $8373ca4214e15aed$var$isHydrating && $8373ca4214e15aed$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $8373ca4214e15aed$var$isHydrating && $8373ca4214e15aed$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $8373ca4214e15aed$var$isHydrating && $8373ca4214e15aed$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $8373ca4214e15aed$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $8373ca4214e15aed$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $8373ca4214e15aed$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $8373ca4214e15aed$var$REACT_LAZY_TYPE && $8373ca4214e15aed$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $8373ca4214e15aed$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $8373ca4214e15aed$var$REACT_FRAGMENT_TYPE ? (lanes = $8373ca4214e15aed$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $8373ca4214e15aed$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $8373ca4214e15aed$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $8373ca4214e15aed$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $8373ca4214e15aed$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $8373ca4214e15aed$var$REACT_LAZY_TYPE:
                    return newChild = $8373ca4214e15aed$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($8373ca4214e15aed$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($8373ca4214e15aed$var$getIteratorFn(newChild)) {
                key = $8373ca4214e15aed$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $8373ca4214e15aed$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $8373ca4214e15aed$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $8373ca4214e15aed$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $8373ca4214e15aed$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $8373ca4214e15aed$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $8373ca4214e15aed$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $8373ca4214e15aed$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $8373ca4214e15aed$var$SuspenseException || x === $8373ca4214e15aed$var$SuspenseActionException) throw x;
            var fiber = $8373ca4214e15aed$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $8373ca4214e15aed$var$reconcileChildFibers = $8373ca4214e15aed$var$createChildReconciler(!0), $8373ca4214e15aed$var$mountChildFibers = $8373ca4214e15aed$var$createChildReconciler(!1), $8373ca4214e15aed$var$hasForceUpdate = !1;
function $8373ca4214e15aed$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $8373ca4214e15aed$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $8373ca4214e15aed$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $8373ca4214e15aed$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($8373ca4214e15aed$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $8373ca4214e15aed$var$getRootForUpdatedFiber(fiber);
        $8373ca4214e15aed$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $8373ca4214e15aed$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $8373ca4214e15aed$var$getRootForUpdatedFiber(fiber);
}
function $8373ca4214e15aed$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $8373ca4214e15aed$var$markRootEntangled(root, lane);
    }
}
function $8373ca4214e15aed$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $8373ca4214e15aed$var$didReadFromEntangledAsyncAction = !1;
function $8373ca4214e15aed$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($8373ca4214e15aed$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $8373ca4214e15aed$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $8373ca4214e15aed$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $8373ca4214e15aed$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $8373ca4214e15aed$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($8373ca4214e15aed$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $8373ca4214e15aed$var$currentEntangledLane && ($8373ca4214e15aed$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $8373ca4214e15aed$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $8373ca4214e15aed$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $8373ca4214e15aed$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $8373ca4214e15aed$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $8373ca4214e15aed$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$8373ca4214e15aed$var$callCallback(callbacks[updateQueue], context);
}
var $8373ca4214e15aed$var$currentTreeHiddenStackCursor = $8373ca4214e15aed$var$createCursor(null), $8373ca4214e15aed$var$prevEntangledRenderLanesCursor = $8373ca4214e15aed$var$createCursor(0);
function $8373ca4214e15aed$var$pushHiddenContext(fiber, context) {
    fiber = $8373ca4214e15aed$var$entangledRenderLanes;
    $8373ca4214e15aed$var$push($8373ca4214e15aed$var$prevEntangledRenderLanesCursor, fiber);
    $8373ca4214e15aed$var$push($8373ca4214e15aed$var$currentTreeHiddenStackCursor, context);
    $8373ca4214e15aed$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $8373ca4214e15aed$var$reuseHiddenContextOnStack() {
    $8373ca4214e15aed$var$push($8373ca4214e15aed$var$prevEntangledRenderLanesCursor, $8373ca4214e15aed$var$entangledRenderLanes);
    $8373ca4214e15aed$var$push($8373ca4214e15aed$var$currentTreeHiddenStackCursor, $8373ca4214e15aed$var$currentTreeHiddenStackCursor.current);
}
function $8373ca4214e15aed$var$popHiddenContext() {
    $8373ca4214e15aed$var$entangledRenderLanes = $8373ca4214e15aed$var$prevEntangledRenderLanesCursor.current;
    $8373ca4214e15aed$var$pop($8373ca4214e15aed$var$currentTreeHiddenStackCursor);
    $8373ca4214e15aed$var$pop($8373ca4214e15aed$var$prevEntangledRenderLanesCursor);
}
var $8373ca4214e15aed$var$suspenseHandlerStackCursor = $8373ca4214e15aed$var$createCursor(null), $8373ca4214e15aed$var$shellBoundary = null;
function $8373ca4214e15aed$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $8373ca4214e15aed$var$push($8373ca4214e15aed$var$suspenseStackCursor, $8373ca4214e15aed$var$suspenseStackCursor.current & 1);
    $8373ca4214e15aed$var$push($8373ca4214e15aed$var$suspenseHandlerStackCursor, handler);
    null === $8373ca4214e15aed$var$shellBoundary && (null === current || null !== $8373ca4214e15aed$var$currentTreeHiddenStackCursor.current ? $8373ca4214e15aed$var$shellBoundary = handler : null !== current.memoizedState && ($8373ca4214e15aed$var$shellBoundary = handler));
}
function $8373ca4214e15aed$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $8373ca4214e15aed$var$push($8373ca4214e15aed$var$suspenseStackCursor, $8373ca4214e15aed$var$suspenseStackCursor.current);
    $8373ca4214e15aed$var$push($8373ca4214e15aed$var$suspenseHandlerStackCursor, fiber);
    null === $8373ca4214e15aed$var$shellBoundary && ($8373ca4214e15aed$var$shellBoundary = fiber);
}
function $8373ca4214e15aed$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($8373ca4214e15aed$var$push($8373ca4214e15aed$var$suspenseStackCursor, $8373ca4214e15aed$var$suspenseStackCursor.current), $8373ca4214e15aed$var$push($8373ca4214e15aed$var$suspenseHandlerStackCursor, fiber), null === $8373ca4214e15aed$var$shellBoundary && ($8373ca4214e15aed$var$shellBoundary = fiber)) : $8373ca4214e15aed$var$reuseSuspenseHandlerOnStack(fiber);
}
function $8373ca4214e15aed$var$reuseSuspenseHandlerOnStack() {
    $8373ca4214e15aed$var$push($8373ca4214e15aed$var$suspenseStackCursor, $8373ca4214e15aed$var$suspenseStackCursor.current);
    $8373ca4214e15aed$var$push($8373ca4214e15aed$var$suspenseHandlerStackCursor, $8373ca4214e15aed$var$suspenseHandlerStackCursor.current);
}
function $8373ca4214e15aed$var$popSuspenseHandler(fiber) {
    $8373ca4214e15aed$var$pop($8373ca4214e15aed$var$suspenseHandlerStackCursor);
    $8373ca4214e15aed$var$shellBoundary === fiber && ($8373ca4214e15aed$var$shellBoundary = null);
    $8373ca4214e15aed$var$pop($8373ca4214e15aed$var$suspenseStackCursor);
}
var $8373ca4214e15aed$var$suspenseStackCursor = $8373ca4214e15aed$var$createCursor(0);
function $8373ca4214e15aed$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $8373ca4214e15aed$var$isSuspenseInstancePending(state) || $8373ca4214e15aed$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $8373ca4214e15aed$var$renderLanes = 0, $8373ca4214e15aed$var$currentlyRenderingFiber = null, $8373ca4214e15aed$var$currentHook = null, $8373ca4214e15aed$var$workInProgressHook = null, $8373ca4214e15aed$var$didScheduleRenderPhaseUpdate = !1, $8373ca4214e15aed$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $8373ca4214e15aed$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $8373ca4214e15aed$var$localIdCounter = 0, $8373ca4214e15aed$var$thenableIndexCounter = 0, $8373ca4214e15aed$var$thenableState = null, $8373ca4214e15aed$var$globalClientIdCounter = 0;
function $8373ca4214e15aed$var$throwInvalidHookError() {
    throw Error($8373ca4214e15aed$var$formatProdErrorMessage(321));
}
function $8373ca4214e15aed$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$8373ca4214e15aed$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $8373ca4214e15aed$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $8373ca4214e15aed$var$renderLanes = nextRenderLanes;
    $8373ca4214e15aed$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $8373ca4214e15aed$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $8373ca4214e15aed$var$HooksDispatcherOnMount : $8373ca4214e15aed$var$HooksDispatcherOnUpdate;
    $8373ca4214e15aed$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $8373ca4214e15aed$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $8373ca4214e15aed$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $8373ca4214e15aed$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $8373ca4214e15aed$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $8373ca4214e15aed$var$finishRenderingHooks(current) {
    $8373ca4214e15aed$var$ReactSharedInternals.H = $8373ca4214e15aed$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $8373ca4214e15aed$var$currentHook && null !== $8373ca4214e15aed$var$currentHook.next;
    $8373ca4214e15aed$var$renderLanes = 0;
    $8373ca4214e15aed$var$workInProgressHook = $8373ca4214e15aed$var$currentHook = $8373ca4214e15aed$var$currentlyRenderingFiber = null;
    $8373ca4214e15aed$var$didScheduleRenderPhaseUpdate = !1;
    $8373ca4214e15aed$var$thenableIndexCounter = 0;
    $8373ca4214e15aed$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(300));
    null === current || $8373ca4214e15aed$var$didReceiveUpdate || (current = current.dependencies, null !== current && $8373ca4214e15aed$var$checkIfContextChanged(current) && ($8373ca4214e15aed$var$didReceiveUpdate = !0));
}
function $8373ca4214e15aed$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $8373ca4214e15aed$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $8373ca4214e15aed$var$didScheduleRenderPhaseUpdateDuringThisPass && ($8373ca4214e15aed$var$thenableState = null);
        $8373ca4214e15aed$var$thenableIndexCounter = 0;
        $8373ca4214e15aed$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $8373ca4214e15aed$var$workInProgressHook = $8373ca4214e15aed$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $8373ca4214e15aed$var$ReactSharedInternals.H = $8373ca4214e15aed$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($8373ca4214e15aed$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $8373ca4214e15aed$var$TransitionAwareHostComponent() {
    var dispatcher = $8373ca4214e15aed$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $8373ca4214e15aed$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $8373ca4214e15aed$var$currentHook ? $8373ca4214e15aed$var$currentHook.memoizedState : null) !== dispatcher && ($8373ca4214e15aed$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $8373ca4214e15aed$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $8373ca4214e15aed$var$localIdCounter;
    $8373ca4214e15aed$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $8373ca4214e15aed$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $8373ca4214e15aed$var$resetHooksOnUnwind(workInProgress) {
    if ($8373ca4214e15aed$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $8373ca4214e15aed$var$didScheduleRenderPhaseUpdate = !1;
    }
    $8373ca4214e15aed$var$renderLanes = 0;
    $8373ca4214e15aed$var$workInProgressHook = $8373ca4214e15aed$var$currentHook = $8373ca4214e15aed$var$currentlyRenderingFiber = null;
    $8373ca4214e15aed$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $8373ca4214e15aed$var$thenableIndexCounter = $8373ca4214e15aed$var$localIdCounter = 0;
    $8373ca4214e15aed$var$thenableState = null;
}
function $8373ca4214e15aed$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $8373ca4214e15aed$var$workInProgressHook ? $8373ca4214e15aed$var$currentlyRenderingFiber.memoizedState = $8373ca4214e15aed$var$workInProgressHook = hook : $8373ca4214e15aed$var$workInProgressHook = $8373ca4214e15aed$var$workInProgressHook.next = hook;
    return $8373ca4214e15aed$var$workInProgressHook;
}
function $8373ca4214e15aed$var$updateWorkInProgressHook() {
    if (null === $8373ca4214e15aed$var$currentHook) {
        var nextCurrentHook = $8373ca4214e15aed$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $8373ca4214e15aed$var$currentHook.next;
    var nextWorkInProgressHook = null === $8373ca4214e15aed$var$workInProgressHook ? $8373ca4214e15aed$var$currentlyRenderingFiber.memoizedState : $8373ca4214e15aed$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $8373ca4214e15aed$var$workInProgressHook = nextWorkInProgressHook, $8373ca4214e15aed$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $8373ca4214e15aed$var$currentlyRenderingFiber.alternate) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(467));
            throw Error($8373ca4214e15aed$var$formatProdErrorMessage(310));
        }
        $8373ca4214e15aed$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $8373ca4214e15aed$var$currentHook.memoizedState,
            baseState: $8373ca4214e15aed$var$currentHook.baseState,
            baseQueue: $8373ca4214e15aed$var$currentHook.baseQueue,
            queue: $8373ca4214e15aed$var$currentHook.queue,
            next: null
        };
        null === $8373ca4214e15aed$var$workInProgressHook ? $8373ca4214e15aed$var$currentlyRenderingFiber.memoizedState = $8373ca4214e15aed$var$workInProgressHook = nextCurrentHook : $8373ca4214e15aed$var$workInProgressHook = $8373ca4214e15aed$var$workInProgressHook.next = nextCurrentHook;
    }
    return $8373ca4214e15aed$var$workInProgressHook;
}
function $8373ca4214e15aed$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $8373ca4214e15aed$var$useThenable(thenable) {
    var index = $8373ca4214e15aed$var$thenableIndexCounter;
    $8373ca4214e15aed$var$thenableIndexCounter += 1;
    null === $8373ca4214e15aed$var$thenableState && ($8373ca4214e15aed$var$thenableState = []);
    thenable = $8373ca4214e15aed$var$trackUsedThenable($8373ca4214e15aed$var$thenableState, thenable, index);
    index = $8373ca4214e15aed$var$currentlyRenderingFiber;
    null === (null === $8373ca4214e15aed$var$workInProgressHook ? index.memoizedState : $8373ca4214e15aed$var$workInProgressHook.next) && (index = index.alternate, $8373ca4214e15aed$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $8373ca4214e15aed$var$HooksDispatcherOnMount : $8373ca4214e15aed$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $8373ca4214e15aed$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $8373ca4214e15aed$var$useThenable(usable);
        if (usable.$$typeof === $8373ca4214e15aed$var$REACT_CONTEXT_TYPE) return $8373ca4214e15aed$var$readContext(usable);
    }
    throw Error($8373ca4214e15aed$var$formatProdErrorMessage(438, String(usable)));
}
function $8373ca4214e15aed$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $8373ca4214e15aed$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $8373ca4214e15aed$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $8373ca4214e15aed$var$createFunctionComponentUpdateQueue(), $8373ca4214e15aed$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $8373ca4214e15aed$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $8373ca4214e15aed$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $8373ca4214e15aed$var$updateReducer(reducer) {
    var hook = $8373ca4214e15aed$var$updateWorkInProgressHook();
    return $8373ca4214e15aed$var$updateReducerImpl(hook, $8373ca4214e15aed$var$currentHook, reducer);
}
function $8373ca4214e15aed$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($8373ca4214e15aed$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($8373ca4214e15aed$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $8373ca4214e15aed$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($8373ca4214e15aed$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $8373ca4214e15aed$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $8373ca4214e15aed$var$currentlyRenderingFiber.lanes |= revertLane, $8373ca4214e15aed$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $8373ca4214e15aed$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $8373ca4214e15aed$var$currentlyRenderingFiber.lanes |= updateLane, $8373ca4214e15aed$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$8373ca4214e15aed$var$objectIs(pendingQueue, hook.memoizedState) && ($8373ca4214e15aed$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $8373ca4214e15aed$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $8373ca4214e15aed$var$rerenderReducer(reducer) {
    var hook = $8373ca4214e15aed$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $8373ca4214e15aed$var$objectIs(newState, hook.memoizedState) || ($8373ca4214e15aed$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $8373ca4214e15aed$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $8373ca4214e15aed$var$currentlyRenderingFiber, hook = $8373ca4214e15aed$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $8373ca4214e15aed$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$8373ca4214e15aed$var$objectIs(($8373ca4214e15aed$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $8373ca4214e15aed$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $8373ca4214e15aed$var$updateEffect($8373ca4214e15aed$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $8373ca4214e15aed$var$workInProgressHook && $8373ca4214e15aed$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $8373ca4214e15aed$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $8373ca4214e15aed$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $8373ca4214e15aed$var$workInProgressRoot) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($8373ca4214e15aed$var$renderLanes & 127) || $8373ca4214e15aed$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $8373ca4214e15aed$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $8373ca4214e15aed$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $8373ca4214e15aed$var$createFunctionComponentUpdateQueue(), $8373ca4214e15aed$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $8373ca4214e15aed$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $8373ca4214e15aed$var$checkIfSnapshotChanged(inst) && $8373ca4214e15aed$var$forceStoreRerender(fiber);
}
function $8373ca4214e15aed$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $8373ca4214e15aed$var$checkIfSnapshotChanged(inst) && $8373ca4214e15aed$var$forceStoreRerender(fiber);
    });
}
function $8373ca4214e15aed$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$8373ca4214e15aed$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $8373ca4214e15aed$var$forceStoreRerender(fiber) {
    var root = $8373ca4214e15aed$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $8373ca4214e15aed$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $8373ca4214e15aed$var$mountStateImpl(initialState) {
    var hook = $8373ca4214e15aed$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($8373ca4214e15aed$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $8373ca4214e15aed$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $8373ca4214e15aed$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $8373ca4214e15aed$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $8373ca4214e15aed$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $8373ca4214e15aed$var$updateReducerImpl(hook, $8373ca4214e15aed$var$currentHook, "function" === typeof reducer ? reducer : $8373ca4214e15aed$var$basicStateReducer);
}
function $8373ca4214e15aed$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($8373ca4214e15aed$var$isRenderPhaseUpdate(fiber)) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $8373ca4214e15aed$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $8373ca4214e15aed$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $8373ca4214e15aed$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $8373ca4214e15aed$var$ReactSharedInternals.T, currentTransition = {};
        $8373ca4214e15aed$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $8373ca4214e15aed$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $8373ca4214e15aed$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $8373ca4214e15aed$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $8373ca4214e15aed$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $8373ca4214e15aed$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $8373ca4214e15aed$var$onActionError(actionQueue, node, error$66);
    }
}
function $8373ca4214e15aed$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $8373ca4214e15aed$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $8373ca4214e15aed$var$onActionError(actionQueue, node, error);
    }) : $8373ca4214e15aed$var$onActionSuccess(actionQueue, node, returnValue);
}
function $8373ca4214e15aed$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $8373ca4214e15aed$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $8373ca4214e15aed$var$runActionStateAction(actionQueue, nextState)));
}
function $8373ca4214e15aed$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $8373ca4214e15aed$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $8373ca4214e15aed$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $8373ca4214e15aed$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $8373ca4214e15aed$var$mountActionState(action, initialStateProp) {
    if ($8373ca4214e15aed$var$isHydrating) {
        var ssrFormState = $8373ca4214e15aed$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $8373ca4214e15aed$var$currentlyRenderingFiber;
                if ($8373ca4214e15aed$var$isHydrating) {
                    if ($8373ca4214e15aed$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $8373ca4214e15aed$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $8373ca4214e15aed$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $8373ca4214e15aed$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $8373ca4214e15aed$var$nextHydratableInstance = $8373ca4214e15aed$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $8373ca4214e15aed$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $8373ca4214e15aed$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $8373ca4214e15aed$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $8373ca4214e15aed$var$dispatchSetState.bind(null, $8373ca4214e15aed$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $8373ca4214e15aed$var$mountStateImpl(!1);
    inRootOrSingleton = $8373ca4214e15aed$var$dispatchOptimisticSetState.bind(null, $8373ca4214e15aed$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $8373ca4214e15aed$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $8373ca4214e15aed$var$dispatchActionState.bind(null, $8373ca4214e15aed$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $8373ca4214e15aed$var$updateActionState(action) {
    var stateHook = $8373ca4214e15aed$var$updateWorkInProgressHook();
    return $8373ca4214e15aed$var$updateActionStateImpl(stateHook, $8373ca4214e15aed$var$currentHook, action);
}
function $8373ca4214e15aed$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $8373ca4214e15aed$var$updateReducerImpl(stateHook, currentStateHook, $8373ca4214e15aed$var$actionStateReducer)[0];
    stateHook = $8373ca4214e15aed$var$updateReducer($8373ca4214e15aed$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $8373ca4214e15aed$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $8373ca4214e15aed$var$SuspenseException) throw $8373ca4214e15aed$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $8373ca4214e15aed$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($8373ca4214e15aed$var$currentlyRenderingFiber.flags |= 2048, $8373ca4214e15aed$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $8373ca4214e15aed$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $8373ca4214e15aed$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $8373ca4214e15aed$var$rerenderActionState(action) {
    var stateHook = $8373ca4214e15aed$var$updateWorkInProgressHook(), currentStateHook = $8373ca4214e15aed$var$currentHook;
    if (null !== currentStateHook) return $8373ca4214e15aed$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $8373ca4214e15aed$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $8373ca4214e15aed$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $8373ca4214e15aed$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $8373ca4214e15aed$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $8373ca4214e15aed$var$createFunctionComponentUpdateQueue(), $8373ca4214e15aed$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $8373ca4214e15aed$var$updateRef() {
    return $8373ca4214e15aed$var$updateWorkInProgressHook().memoizedState;
}
function $8373ca4214e15aed$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $8373ca4214e15aed$var$mountWorkInProgressHook();
    $8373ca4214e15aed$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $8373ca4214e15aed$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $8373ca4214e15aed$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $8373ca4214e15aed$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $8373ca4214e15aed$var$currentHook && null !== deps && $8373ca4214e15aed$var$areHookInputsEqual(deps, $8373ca4214e15aed$var$currentHook.memoizedState.deps) ? hook.memoizedState = $8373ca4214e15aed$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($8373ca4214e15aed$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $8373ca4214e15aed$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $8373ca4214e15aed$var$mountEffect(create, deps) {
    $8373ca4214e15aed$var$mountEffectImpl(8390656, 8, create, deps);
}
function $8373ca4214e15aed$var$updateEffect(create, deps) {
    $8373ca4214e15aed$var$updateEffectImpl(2048, 8, create, deps);
}
function $8373ca4214e15aed$var$useEffectEventImpl(payload) {
    $8373ca4214e15aed$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $8373ca4214e15aed$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $8373ca4214e15aed$var$createFunctionComponentUpdateQueue(), $8373ca4214e15aed$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $8373ca4214e15aed$var$updateEvent(callback) {
    var ref = $8373ca4214e15aed$var$updateWorkInProgressHook().memoizedState;
    $8373ca4214e15aed$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($8373ca4214e15aed$var$executionContext & 2)) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $8373ca4214e15aed$var$updateInsertionEffect(create, deps) {
    return $8373ca4214e15aed$var$updateEffectImpl(4, 2, create, deps);
}
function $8373ca4214e15aed$var$updateLayoutEffect(create, deps) {
    return $8373ca4214e15aed$var$updateEffectImpl(4, 4, create, deps);
}
function $8373ca4214e15aed$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $8373ca4214e15aed$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $8373ca4214e15aed$var$updateEffectImpl(4, 4, $8373ca4214e15aed$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $8373ca4214e15aed$var$mountDebugValue() {}
function $8373ca4214e15aed$var$updateCallback(callback, deps) {
    var hook = $8373ca4214e15aed$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $8373ca4214e15aed$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $8373ca4214e15aed$var$updateMemo(nextCreate, deps) {
    var hook = $8373ca4214e15aed$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $8373ca4214e15aed$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($8373ca4214e15aed$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $8373ca4214e15aed$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $8373ca4214e15aed$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $8373ca4214e15aed$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($8373ca4214e15aed$var$renderLanes & 1073741824) && 0 === ($8373ca4214e15aed$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $8373ca4214e15aed$var$requestDeferredLane();
    $8373ca4214e15aed$var$currentlyRenderingFiber.lanes |= hook;
    $8373ca4214e15aed$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $8373ca4214e15aed$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($8373ca4214e15aed$var$objectIs(value, prevValue)) return value;
    if (null !== $8373ca4214e15aed$var$currentTreeHiddenStackCursor.current) return hook = $8373ca4214e15aed$var$mountDeferredValueImpl(hook, value, initialValue), $8373ca4214e15aed$var$objectIs(hook, prevValue) || ($8373ca4214e15aed$var$didReceiveUpdate = !0), hook;
    if (0 === ($8373ca4214e15aed$var$renderLanes & 42) || 0 !== ($8373ca4214e15aed$var$renderLanes & 1073741824) && 0 === ($8373ca4214e15aed$var$workInProgressRootRenderLanes & 261930)) return $8373ca4214e15aed$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $8373ca4214e15aed$var$requestDeferredLane();
    $8373ca4214e15aed$var$currentlyRenderingFiber.lanes |= hook;
    $8373ca4214e15aed$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $8373ca4214e15aed$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $8373ca4214e15aed$var$ReactDOMSharedInternals.p;
    $8373ca4214e15aed$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $8373ca4214e15aed$var$ReactSharedInternals.T, currentTransition = {};
    $8373ca4214e15aed$var$ReactSharedInternals.T = currentTransition;
    $8373ca4214e15aed$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $8373ca4214e15aed$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $8373ca4214e15aed$var$chainThenableValue(returnValue, finishedState);
            $8373ca4214e15aed$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $8373ca4214e15aed$var$requestUpdateLane(fiber));
        } else $8373ca4214e15aed$var$dispatchSetStateInternal(fiber, queue, finishedState, $8373ca4214e15aed$var$requestUpdateLane(fiber));
    } catch (error) {
        $8373ca4214e15aed$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $8373ca4214e15aed$var$requestUpdateLane());
    } finally{
        $8373ca4214e15aed$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $8373ca4214e15aed$var$ReactSharedInternals.T = prevTransition;
    }
}
function $8373ca4214e15aed$var$noop() {}
function $8373ca4214e15aed$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(476));
    var queue = $8373ca4214e15aed$var$ensureFormComponentIsStateful(formFiber).queue;
    $8373ca4214e15aed$var$startTransition(formFiber, queue, pendingState, $8373ca4214e15aed$var$sharedNotPendingObject, null === action ? $8373ca4214e15aed$var$noop : function() {
        $8373ca4214e15aed$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $8373ca4214e15aed$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $8373ca4214e15aed$var$sharedNotPendingObject,
        baseState: $8373ca4214e15aed$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $8373ca4214e15aed$var$basicStateReducer,
            lastRenderedState: $8373ca4214e15aed$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $8373ca4214e15aed$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $8373ca4214e15aed$var$requestFormReset$1(formFiber) {
    var stateHook = $8373ca4214e15aed$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $8373ca4214e15aed$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $8373ca4214e15aed$var$requestUpdateLane());
}
function $8373ca4214e15aed$var$useHostTransitionStatus() {
    return $8373ca4214e15aed$var$readContext($8373ca4214e15aed$var$HostTransitionContext);
}
function $8373ca4214e15aed$var$updateId() {
    return $8373ca4214e15aed$var$updateWorkInProgressHook().memoizedState;
}
function $8373ca4214e15aed$var$updateRefresh() {
    return $8373ca4214e15aed$var$updateWorkInProgressHook().memoizedState;
}
function $8373ca4214e15aed$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $8373ca4214e15aed$var$requestUpdateLane();
                fiber = $8373ca4214e15aed$var$createUpdate(lane);
                var root$69 = $8373ca4214e15aed$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($8373ca4214e15aed$var$scheduleUpdateOnFiber(root$69, provider, lane), $8373ca4214e15aed$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $8373ca4214e15aed$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $8373ca4214e15aed$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $8373ca4214e15aed$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $8373ca4214e15aed$var$isRenderPhaseUpdate(fiber) ? $8373ca4214e15aed$var$enqueueRenderPhaseUpdate(queue, action) : (action = $8373ca4214e15aed$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($8373ca4214e15aed$var$scheduleUpdateOnFiber(action, fiber, lane), $8373ca4214e15aed$var$entangleTransitionUpdate(action, queue, lane)));
}
function $8373ca4214e15aed$var$dispatchSetState(fiber, queue, action) {
    var lane = $8373ca4214e15aed$var$requestUpdateLane();
    $8373ca4214e15aed$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $8373ca4214e15aed$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($8373ca4214e15aed$var$isRenderPhaseUpdate(fiber)) $8373ca4214e15aed$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($8373ca4214e15aed$var$objectIs(eagerState, currentState)) return $8373ca4214e15aed$var$enqueueUpdate$1(fiber, queue, update, 0), null === $8373ca4214e15aed$var$workInProgressRoot && $8373ca4214e15aed$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $8373ca4214e15aed$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $8373ca4214e15aed$var$scheduleUpdateOnFiber(action, fiber, lane), $8373ca4214e15aed$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $8373ca4214e15aed$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $8373ca4214e15aed$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($8373ca4214e15aed$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $8373ca4214e15aed$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $8373ca4214e15aed$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $8373ca4214e15aed$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $8373ca4214e15aed$var$currentlyRenderingFiber || null !== alternate && alternate === $8373ca4214e15aed$var$currentlyRenderingFiber;
}
function $8373ca4214e15aed$var$enqueueRenderPhaseUpdate(queue, update) {
    $8373ca4214e15aed$var$didScheduleRenderPhaseUpdateDuringThisPass = $8373ca4214e15aed$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $8373ca4214e15aed$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $8373ca4214e15aed$var$markRootEntangled(root, lane);
    }
}
var $8373ca4214e15aed$var$ContextOnlyDispatcher = {
    readContext: $8373ca4214e15aed$var$readContext,
    use: $8373ca4214e15aed$var$use,
    useCallback: $8373ca4214e15aed$var$throwInvalidHookError,
    useContext: $8373ca4214e15aed$var$throwInvalidHookError,
    useEffect: $8373ca4214e15aed$var$throwInvalidHookError,
    useImperativeHandle: $8373ca4214e15aed$var$throwInvalidHookError,
    useLayoutEffect: $8373ca4214e15aed$var$throwInvalidHookError,
    useInsertionEffect: $8373ca4214e15aed$var$throwInvalidHookError,
    useMemo: $8373ca4214e15aed$var$throwInvalidHookError,
    useReducer: $8373ca4214e15aed$var$throwInvalidHookError,
    useRef: $8373ca4214e15aed$var$throwInvalidHookError,
    useState: $8373ca4214e15aed$var$throwInvalidHookError,
    useDebugValue: $8373ca4214e15aed$var$throwInvalidHookError,
    useDeferredValue: $8373ca4214e15aed$var$throwInvalidHookError,
    useTransition: $8373ca4214e15aed$var$throwInvalidHookError,
    useSyncExternalStore: $8373ca4214e15aed$var$throwInvalidHookError,
    useId: $8373ca4214e15aed$var$throwInvalidHookError,
    useHostTransitionStatus: $8373ca4214e15aed$var$throwInvalidHookError,
    useFormState: $8373ca4214e15aed$var$throwInvalidHookError,
    useActionState: $8373ca4214e15aed$var$throwInvalidHookError,
    useOptimistic: $8373ca4214e15aed$var$throwInvalidHookError,
    useMemoCache: $8373ca4214e15aed$var$throwInvalidHookError,
    useCacheRefresh: $8373ca4214e15aed$var$throwInvalidHookError
};
$8373ca4214e15aed$var$ContextOnlyDispatcher.useEffectEvent = $8373ca4214e15aed$var$throwInvalidHookError;
var $8373ca4214e15aed$var$HooksDispatcherOnMount = {
    readContext: $8373ca4214e15aed$var$readContext,
    use: $8373ca4214e15aed$var$use,
    useCallback: function(callback, deps) {
        $8373ca4214e15aed$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $8373ca4214e15aed$var$readContext,
    useEffect: $8373ca4214e15aed$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $8373ca4214e15aed$var$mountEffectImpl(4194308, 4, $8373ca4214e15aed$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $8373ca4214e15aed$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $8373ca4214e15aed$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $8373ca4214e15aed$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($8373ca4214e15aed$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $8373ca4214e15aed$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $8373ca4214e15aed$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $8373ca4214e15aed$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($8373ca4214e15aed$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $8373ca4214e15aed$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $8373ca4214e15aed$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $8373ca4214e15aed$var$dispatchReducerAction.bind(null, $8373ca4214e15aed$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $8373ca4214e15aed$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $8373ca4214e15aed$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $8373ca4214e15aed$var$dispatchSetState.bind(null, $8373ca4214e15aed$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $8373ca4214e15aed$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $8373ca4214e15aed$var$mountWorkInProgressHook();
        return $8373ca4214e15aed$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $8373ca4214e15aed$var$mountStateImpl(!1);
        stateHook = $8373ca4214e15aed$var$startTransition.bind(null, $8373ca4214e15aed$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $8373ca4214e15aed$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $8373ca4214e15aed$var$currentlyRenderingFiber, hook = $8373ca4214e15aed$var$mountWorkInProgressHook();
        if ($8373ca4214e15aed$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $8373ca4214e15aed$var$workInProgressRoot) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(349));
            0 !== ($8373ca4214e15aed$var$workInProgressRootRenderLanes & 127) || $8373ca4214e15aed$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $8373ca4214e15aed$var$mountEffect($8373ca4214e15aed$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $8373ca4214e15aed$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $8373ca4214e15aed$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $8373ca4214e15aed$var$mountWorkInProgressHook(), identifierPrefix = $8373ca4214e15aed$var$workInProgressRoot.identifierPrefix;
        if ($8373ca4214e15aed$var$isHydrating) {
            var JSCompiler_inline_result = $8373ca4214e15aed$var$treeContextOverflow;
            var idWithLeadingBit = $8373ca4214e15aed$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $8373ca4214e15aed$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $8373ca4214e15aed$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $8373ca4214e15aed$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $8373ca4214e15aed$var$useHostTransitionStatus,
    useFormState: $8373ca4214e15aed$var$mountActionState,
    useActionState: $8373ca4214e15aed$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $8373ca4214e15aed$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $8373ca4214e15aed$var$dispatchOptimisticSetState.bind(null, $8373ca4214e15aed$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $8373ca4214e15aed$var$useMemoCache,
    useCacheRefresh: function() {
        return $8373ca4214e15aed$var$mountWorkInProgressHook().memoizedState = $8373ca4214e15aed$var$refreshCache.bind(null, $8373ca4214e15aed$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $8373ca4214e15aed$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($8373ca4214e15aed$var$executionContext & 2)) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $8373ca4214e15aed$var$HooksDispatcherOnUpdate = {
    readContext: $8373ca4214e15aed$var$readContext,
    use: $8373ca4214e15aed$var$use,
    useCallback: $8373ca4214e15aed$var$updateCallback,
    useContext: $8373ca4214e15aed$var$readContext,
    useEffect: $8373ca4214e15aed$var$updateEffect,
    useImperativeHandle: $8373ca4214e15aed$var$updateImperativeHandle,
    useInsertionEffect: $8373ca4214e15aed$var$updateInsertionEffect,
    useLayoutEffect: $8373ca4214e15aed$var$updateLayoutEffect,
    useMemo: $8373ca4214e15aed$var$updateMemo,
    useReducer: $8373ca4214e15aed$var$updateReducer,
    useRef: $8373ca4214e15aed$var$updateRef,
    useState: function() {
        return $8373ca4214e15aed$var$updateReducer($8373ca4214e15aed$var$basicStateReducer);
    },
    useDebugValue: $8373ca4214e15aed$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $8373ca4214e15aed$var$updateWorkInProgressHook();
        return $8373ca4214e15aed$var$updateDeferredValueImpl(hook, $8373ca4214e15aed$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $8373ca4214e15aed$var$updateReducer($8373ca4214e15aed$var$basicStateReducer)[0], start = $8373ca4214e15aed$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $8373ca4214e15aed$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $8373ca4214e15aed$var$updateSyncExternalStore,
    useId: $8373ca4214e15aed$var$updateId,
    useHostTransitionStatus: $8373ca4214e15aed$var$useHostTransitionStatus,
    useFormState: $8373ca4214e15aed$var$updateActionState,
    useActionState: $8373ca4214e15aed$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $8373ca4214e15aed$var$updateWorkInProgressHook();
        return $8373ca4214e15aed$var$updateOptimisticImpl(hook, $8373ca4214e15aed$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $8373ca4214e15aed$var$useMemoCache,
    useCacheRefresh: $8373ca4214e15aed$var$updateRefresh
};
$8373ca4214e15aed$var$HooksDispatcherOnUpdate.useEffectEvent = $8373ca4214e15aed$var$updateEvent;
var $8373ca4214e15aed$var$HooksDispatcherOnRerender = {
    readContext: $8373ca4214e15aed$var$readContext,
    use: $8373ca4214e15aed$var$use,
    useCallback: $8373ca4214e15aed$var$updateCallback,
    useContext: $8373ca4214e15aed$var$readContext,
    useEffect: $8373ca4214e15aed$var$updateEffect,
    useImperativeHandle: $8373ca4214e15aed$var$updateImperativeHandle,
    useInsertionEffect: $8373ca4214e15aed$var$updateInsertionEffect,
    useLayoutEffect: $8373ca4214e15aed$var$updateLayoutEffect,
    useMemo: $8373ca4214e15aed$var$updateMemo,
    useReducer: $8373ca4214e15aed$var$rerenderReducer,
    useRef: $8373ca4214e15aed$var$updateRef,
    useState: function() {
        return $8373ca4214e15aed$var$rerenderReducer($8373ca4214e15aed$var$basicStateReducer);
    },
    useDebugValue: $8373ca4214e15aed$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $8373ca4214e15aed$var$updateWorkInProgressHook();
        return null === $8373ca4214e15aed$var$currentHook ? $8373ca4214e15aed$var$mountDeferredValueImpl(hook, value, initialValue) : $8373ca4214e15aed$var$updateDeferredValueImpl(hook, $8373ca4214e15aed$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $8373ca4214e15aed$var$rerenderReducer($8373ca4214e15aed$var$basicStateReducer)[0], start = $8373ca4214e15aed$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $8373ca4214e15aed$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $8373ca4214e15aed$var$updateSyncExternalStore,
    useId: $8373ca4214e15aed$var$updateId,
    useHostTransitionStatus: $8373ca4214e15aed$var$useHostTransitionStatus,
    useFormState: $8373ca4214e15aed$var$rerenderActionState,
    useActionState: $8373ca4214e15aed$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $8373ca4214e15aed$var$updateWorkInProgressHook();
        if (null !== $8373ca4214e15aed$var$currentHook) return $8373ca4214e15aed$var$updateOptimisticImpl(hook, $8373ca4214e15aed$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $8373ca4214e15aed$var$useMemoCache,
    useCacheRefresh: $8373ca4214e15aed$var$updateRefresh
};
$8373ca4214e15aed$var$HooksDispatcherOnRerender.useEffectEvent = $8373ca4214e15aed$var$updateEvent;
function $8373ca4214e15aed$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $8373ca4214e15aed$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $8373ca4214e15aed$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $8373ca4214e15aed$var$requestUpdateLane(), update = $8373ca4214e15aed$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $8373ca4214e15aed$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($8373ca4214e15aed$var$scheduleUpdateOnFiber(payload, inst, lane), $8373ca4214e15aed$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $8373ca4214e15aed$var$requestUpdateLane(), update = $8373ca4214e15aed$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $8373ca4214e15aed$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($8373ca4214e15aed$var$scheduleUpdateOnFiber(payload, inst, lane), $8373ca4214e15aed$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $8373ca4214e15aed$var$requestUpdateLane(), update = $8373ca4214e15aed$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $8373ca4214e15aed$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($8373ca4214e15aed$var$scheduleUpdateOnFiber(callback, inst, lane), $8373ca4214e15aed$var$entangleTransitions(callback, inst, lane));
    }
};
function $8373ca4214e15aed$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$8373ca4214e15aed$var$shallowEqual(oldProps, newProps) || !$8373ca4214e15aed$var$shallowEqual(oldState, newState) : !0;
}
function $8373ca4214e15aed$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $8373ca4214e15aed$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $8373ca4214e15aed$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $8373ca4214e15aed$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $8373ca4214e15aed$var$defaultOnUncaughtError(error) {
    $8373ca4214e15aed$var$reportGlobalError(error);
}
function $8373ca4214e15aed$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $8373ca4214e15aed$var$defaultOnRecoverableError(error) {
    $8373ca4214e15aed$var$reportGlobalError(error);
}
function $8373ca4214e15aed$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $8373ca4214e15aed$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $8373ca4214e15aed$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $8373ca4214e15aed$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $8373ca4214e15aed$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $8373ca4214e15aed$var$createClassErrorUpdate(lane) {
    lane = $8373ca4214e15aed$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $8373ca4214e15aed$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $8373ca4214e15aed$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $8373ca4214e15aed$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $8373ca4214e15aed$var$legacyErrorBoundariesThatAlreadyFailed ? $8373ca4214e15aed$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $8373ca4214e15aed$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $8373ca4214e15aed$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $8373ca4214e15aed$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $8373ca4214e15aed$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $8373ca4214e15aed$var$shellBoundary ? $8373ca4214e15aed$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $8373ca4214e15aed$var$workInProgressRootExitStatus && ($8373ca4214e15aed$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $8373ca4214e15aed$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $8373ca4214e15aed$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $8373ca4214e15aed$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $8373ca4214e15aed$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($8373ca4214e15aed$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $8373ca4214e15aed$var$attachPingListener(root, value, rootRenderLanes);
        $8373ca4214e15aed$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($8373ca4214e15aed$var$isHydrating) return returnFiber = $8373ca4214e15aed$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $8373ca4214e15aed$var$HydrationMismatchException && (root = Error($8373ca4214e15aed$var$formatProdErrorMessage(422), {
        cause: value
    }), $8373ca4214e15aed$var$queueHydrationError($8373ca4214e15aed$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $8373ca4214e15aed$var$HydrationMismatchException && (returnFiber = Error($8373ca4214e15aed$var$formatProdErrorMessage(423), {
        cause: value
    }), $8373ca4214e15aed$var$queueHydrationError($8373ca4214e15aed$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $8373ca4214e15aed$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $8373ca4214e15aed$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $8373ca4214e15aed$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $8373ca4214e15aed$var$workInProgressRootExitStatus && ($8373ca4214e15aed$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($8373ca4214e15aed$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $8373ca4214e15aed$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $8373ca4214e15aed$var$workInProgressRootConcurrentErrors ? $8373ca4214e15aed$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $8373ca4214e15aed$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $8373ca4214e15aed$var$workInProgressRootExitStatus && ($8373ca4214e15aed$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $8373ca4214e15aed$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $8373ca4214e15aed$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $8373ca4214e15aed$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $8373ca4214e15aed$var$legacyErrorBoundariesThatAlreadyFailed || !$8373ca4214e15aed$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $8373ca4214e15aed$var$createClassErrorUpdate(rootRenderLanes), $8373ca4214e15aed$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $8373ca4214e15aed$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $8373ca4214e15aed$var$SelectiveHydrationException = Error($8373ca4214e15aed$var$formatProdErrorMessage(461)), $8373ca4214e15aed$var$didReceiveUpdate = !1;
function $8373ca4214e15aed$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $8373ca4214e15aed$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $8373ca4214e15aed$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $8373ca4214e15aed$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $8373ca4214e15aed$var$prepareToReadContext(workInProgress);
    nextProps = $8373ca4214e15aed$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $8373ca4214e15aed$var$checkDidRenderIdHook();
    if (null !== current && !$8373ca4214e15aed$var$didReceiveUpdate) return $8373ca4214e15aed$var$bailoutHooks(current, workInProgress, renderLanes), $8373ca4214e15aed$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $8373ca4214e15aed$var$isHydrating && key && $8373ca4214e15aed$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $8373ca4214e15aed$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $8373ca4214e15aed$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$8373ca4214e15aed$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $8373ca4214e15aed$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $8373ca4214e15aed$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$8373ca4214e15aed$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $8373ca4214e15aed$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $8373ca4214e15aed$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $8373ca4214e15aed$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $8373ca4214e15aed$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($8373ca4214e15aed$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($8373ca4214e15aed$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $8373ca4214e15aed$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($8373ca4214e15aed$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $8373ca4214e15aed$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $8373ca4214e15aed$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $8373ca4214e15aed$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $8373ca4214e15aed$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $8373ca4214e15aed$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $8373ca4214e15aed$var$pushHiddenContext(workInProgress, prevState) : $8373ca4214e15aed$var$reuseHiddenContextOnStack(), $8373ca4214e15aed$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $8373ca4214e15aed$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($8373ca4214e15aed$var$pushTransition(workInProgress, prevState.cachePool), $8373ca4214e15aed$var$pushHiddenContext(workInProgress, prevState), $8373ca4214e15aed$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $8373ca4214e15aed$var$pushTransition(workInProgress, null), $8373ca4214e15aed$var$reuseHiddenContextOnStack(), $8373ca4214e15aed$var$reuseSuspenseHandlerOnStack(workInProgress));
    $8373ca4214e15aed$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $8373ca4214e15aed$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $8373ca4214e15aed$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $8373ca4214e15aed$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $8373ca4214e15aed$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $8373ca4214e15aed$var$pushTransition(workInProgress, null);
    $8373ca4214e15aed$var$reuseHiddenContextOnStack();
    $8373ca4214e15aed$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $8373ca4214e15aed$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $8373ca4214e15aed$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $8373ca4214e15aed$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $8373ca4214e15aed$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $8373ca4214e15aed$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $8373ca4214e15aed$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $8373ca4214e15aed$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $8373ca4214e15aed$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($8373ca4214e15aed$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $8373ca4214e15aed$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $8373ca4214e15aed$var$bailoutOffscreenComponent(null, current);
            $8373ca4214e15aed$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $8373ca4214e15aed$var$nextHydratableInstance) ? (current = $8373ca4214e15aed$var$canHydrateHydrationBoundary(current, $8373ca4214e15aed$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $8373ca4214e15aed$var$treeContextProvider ? {
                    id: $8373ca4214e15aed$var$treeContextId,
                    overflow: $8373ca4214e15aed$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $8373ca4214e15aed$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $8373ca4214e15aed$var$hydrationParentFiber = workInProgress, $8373ca4214e15aed$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $8373ca4214e15aed$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $8373ca4214e15aed$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $8373ca4214e15aed$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $8373ca4214e15aed$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($8373ca4214e15aed$var$formatProdErrorMessage(558));
        } else if ($8373ca4214e15aed$var$didReceiveUpdate || $8373ca4214e15aed$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $8373ca4214e15aed$var$didReceiveUpdate || didSuspend) {
            nextProps = $8373ca4214e15aed$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $8373ca4214e15aed$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $8373ca4214e15aed$var$enqueueConcurrentRenderForLane(current, dehydrated), $8373ca4214e15aed$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $8373ca4214e15aed$var$SelectiveHydrationException;
            $8373ca4214e15aed$var$renderDidSuspendDelayIfPossible();
            workInProgress = $8373ca4214e15aed$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $8373ca4214e15aed$var$nextHydratableInstance = $8373ca4214e15aed$var$getNextHydratable(dehydrated.nextSibling), $8373ca4214e15aed$var$hydrationParentFiber = workInProgress, $8373ca4214e15aed$var$isHydrating = !0, $8373ca4214e15aed$var$hydrationErrors = null, $8373ca4214e15aed$var$rootOrSingletonContext = !1, null !== current && $8373ca4214e15aed$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $8373ca4214e15aed$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $8373ca4214e15aed$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $8373ca4214e15aed$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $8373ca4214e15aed$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $8373ca4214e15aed$var$prepareToReadContext(workInProgress);
    Component = $8373ca4214e15aed$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $8373ca4214e15aed$var$checkDidRenderIdHook();
    if (null !== current && !$8373ca4214e15aed$var$didReceiveUpdate) return $8373ca4214e15aed$var$bailoutHooks(current, workInProgress, renderLanes), $8373ca4214e15aed$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $8373ca4214e15aed$var$isHydrating && nextProps && $8373ca4214e15aed$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $8373ca4214e15aed$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $8373ca4214e15aed$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $8373ca4214e15aed$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $8373ca4214e15aed$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $8373ca4214e15aed$var$finishRenderingHooks(current);
    Component = $8373ca4214e15aed$var$checkDidRenderIdHook();
    if (null !== current && !$8373ca4214e15aed$var$didReceiveUpdate) return $8373ca4214e15aed$var$bailoutHooks(current, workInProgress, renderLanes), $8373ca4214e15aed$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $8373ca4214e15aed$var$isHydrating && Component && $8373ca4214e15aed$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $8373ca4214e15aed$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $8373ca4214e15aed$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $8373ca4214e15aed$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $8373ca4214e15aed$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $8373ca4214e15aed$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $8373ca4214e15aed$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $8373ca4214e15aed$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $8373ca4214e15aed$var$readContext(contextType) : $8373ca4214e15aed$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($8373ca4214e15aed$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $8373ca4214e15aed$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $8373ca4214e15aed$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $8373ca4214e15aed$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $8373ca4214e15aed$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $8373ca4214e15aed$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $8373ca4214e15aed$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $8373ca4214e15aed$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $8373ca4214e15aed$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $8373ca4214e15aed$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $8373ca4214e15aed$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $8373ca4214e15aed$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($8373ca4214e15aed$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $8373ca4214e15aed$var$hasForceUpdate || $8373ca4214e15aed$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $8373ca4214e15aed$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $8373ca4214e15aed$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $8373ca4214e15aed$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $8373ca4214e15aed$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $8373ca4214e15aed$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $8373ca4214e15aed$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $8373ca4214e15aed$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $8373ca4214e15aed$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $8373ca4214e15aed$var$hasForceUpdate || null !== current && null !== current.dependencies && $8373ca4214e15aed$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($8373ca4214e15aed$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $8373ca4214e15aed$var$hasForceUpdate || $8373ca4214e15aed$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $8373ca4214e15aed$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $8373ca4214e15aed$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $8373ca4214e15aed$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $8373ca4214e15aed$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $8373ca4214e15aed$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $8373ca4214e15aed$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $8373ca4214e15aed$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $8373ca4214e15aed$var$resetHydrationState();
    workInProgress.flags |= 256;
    $8373ca4214e15aed$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $8373ca4214e15aed$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $8373ca4214e15aed$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $8373ca4214e15aed$var$getSuspendedCache()
    };
}
function $8373ca4214e15aed$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $8373ca4214e15aed$var$workInProgressDeferredLane);
    return current;
}
function $8373ca4214e15aed$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($8373ca4214e15aed$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($8373ca4214e15aed$var$isHydrating) {
            showFallback ? $8373ca4214e15aed$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $8373ca4214e15aed$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $8373ca4214e15aed$var$nextHydratableInstance) ? (current = $8373ca4214e15aed$var$canHydrateHydrationBoundary(current, $8373ca4214e15aed$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $8373ca4214e15aed$var$treeContextProvider ? {
                    id: $8373ca4214e15aed$var$treeContextId,
                    overflow: $8373ca4214e15aed$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $8373ca4214e15aed$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $8373ca4214e15aed$var$hydrationParentFiber = workInProgress, $8373ca4214e15aed$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $8373ca4214e15aed$var$throwOnHydrationMismatch(workInProgress);
            $8373ca4214e15aed$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $8373ca4214e15aed$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $8373ca4214e15aed$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $8373ca4214e15aed$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $8373ca4214e15aed$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $8373ca4214e15aed$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $8373ca4214e15aed$var$SUSPENDED_MARKER, $8373ca4214e15aed$var$bailoutOffscreenComponent(null, nextProps);
        $8373ca4214e15aed$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $8373ca4214e15aed$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($8373ca4214e15aed$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $8373ca4214e15aed$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($8373ca4214e15aed$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($8373ca4214e15aed$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $8373ca4214e15aed$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $8373ca4214e15aed$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $8373ca4214e15aed$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $8373ca4214e15aed$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $8373ca4214e15aed$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $8373ca4214e15aed$var$SUSPENDED_MARKER, workInProgress = $8373ca4214e15aed$var$bailoutOffscreenComponent(null, nextProps));
        else if ($8373ca4214e15aed$var$pushPrimaryTreeSuspenseHandler(workInProgress), $8373ca4214e15aed$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($8373ca4214e15aed$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $8373ca4214e15aed$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $8373ca4214e15aed$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($8373ca4214e15aed$var$didReceiveUpdate || $8373ca4214e15aed$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $8373ca4214e15aed$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $8373ca4214e15aed$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $8373ca4214e15aed$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $8373ca4214e15aed$var$enqueueConcurrentRenderForLane(current, nextProps), $8373ca4214e15aed$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $8373ca4214e15aed$var$SelectiveHydrationException;
            $8373ca4214e15aed$var$isSuspenseInstancePending(nextPrimaryChildren) || $8373ca4214e15aed$var$renderDidSuspendDelayIfPossible();
            workInProgress = $8373ca4214e15aed$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $8373ca4214e15aed$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $8373ca4214e15aed$var$nextHydratableInstance = $8373ca4214e15aed$var$getNextHydratable(nextPrimaryChildren.nextSibling), $8373ca4214e15aed$var$hydrationParentFiber = workInProgress, $8373ca4214e15aed$var$isHydrating = !0, $8373ca4214e15aed$var$hydrationErrors = null, $8373ca4214e15aed$var$rootOrSingletonContext = !1, null !== current && $8373ca4214e15aed$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $8373ca4214e15aed$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $8373ca4214e15aed$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $8373ca4214e15aed$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $8373ca4214e15aed$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $8373ca4214e15aed$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $8373ca4214e15aed$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $8373ca4214e15aed$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $8373ca4214e15aed$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $8373ca4214e15aed$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $8373ca4214e15aed$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $8373ca4214e15aed$var$SUSPENDED_MARKER, $8373ca4214e15aed$var$bailoutOffscreenComponent(current.child, nextProps);
    $8373ca4214e15aed$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $8373ca4214e15aed$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $8373ca4214e15aed$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $8373ca4214e15aed$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $8373ca4214e15aed$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $8373ca4214e15aed$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $8373ca4214e15aed$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $8373ca4214e15aed$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $8373ca4214e15aed$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $8373ca4214e15aed$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $8373ca4214e15aed$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $8373ca4214e15aed$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $8373ca4214e15aed$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $8373ca4214e15aed$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $8373ca4214e15aed$var$push($8373ca4214e15aed$var$suspenseStackCursor, suspenseContext);
    $8373ca4214e15aed$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $8373ca4214e15aed$var$isHydrating ? $8373ca4214e15aed$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $8373ca4214e15aed$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $8373ca4214e15aed$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $8373ca4214e15aed$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $8373ca4214e15aed$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $8373ca4214e15aed$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $8373ca4214e15aed$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $8373ca4214e15aed$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $8373ca4214e15aed$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $8373ca4214e15aed$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($8373ca4214e15aed$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $8373ca4214e15aed$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $8373ca4214e15aed$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $8373ca4214e15aed$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $8373ca4214e15aed$var$checkIfContextChanged(current) ? !0 : !1;
}
function $8373ca4214e15aed$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $8373ca4214e15aed$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $8373ca4214e15aed$var$pushProvider(workInProgress, $8373ca4214e15aed$var$CacheContext, current.memoizedState.cache);
            $8373ca4214e15aed$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $8373ca4214e15aed$var$pushHostContext(workInProgress);
            break;
        case 4:
            $8373ca4214e15aed$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $8373ca4214e15aed$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $8373ca4214e15aed$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $8373ca4214e15aed$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $8373ca4214e15aed$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $8373ca4214e15aed$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $8373ca4214e15aed$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $8373ca4214e15aed$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($8373ca4214e15aed$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $8373ca4214e15aed$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $8373ca4214e15aed$var$push($8373ca4214e15aed$var$suspenseStackCursor, $8373ca4214e15aed$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $8373ca4214e15aed$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $8373ca4214e15aed$var$pushProvider(workInProgress, $8373ca4214e15aed$var$CacheContext, current.memoizedState.cache);
    }
    return $8373ca4214e15aed$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $8373ca4214e15aed$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $8373ca4214e15aed$var$didReceiveUpdate = !0;
        else {
            if (!$8373ca4214e15aed$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $8373ca4214e15aed$var$didReceiveUpdate = !1, $8373ca4214e15aed$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $8373ca4214e15aed$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $8373ca4214e15aed$var$didReceiveUpdate = !1, $8373ca4214e15aed$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $8373ca4214e15aed$var$pushTreeId(workInProgress, $8373ca4214e15aed$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $8373ca4214e15aed$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $8373ca4214e15aed$var$shouldConstruct(current) ? (props = $8373ca4214e15aed$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $8373ca4214e15aed$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $8373ca4214e15aed$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $8373ca4214e15aed$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $8373ca4214e15aed$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $8373ca4214e15aed$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $8373ca4214e15aed$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $8373ca4214e15aed$var$getComponentNameFromType(current) || current;
                    throw Error($8373ca4214e15aed$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $8373ca4214e15aed$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $8373ca4214e15aed$var$resolveClassComponentProps(props, workInProgress.pendingProps), $8373ca4214e15aed$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $8373ca4214e15aed$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $8373ca4214e15aed$var$cloneUpdateQueue(current, workInProgress);
                $8373ca4214e15aed$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $8373ca4214e15aed$var$pushProvider(workInProgress, $8373ca4214e15aed$var$CacheContext, props);
                props !== prevState.cache && $8373ca4214e15aed$var$propagateContextChanges(workInProgress, [
                    $8373ca4214e15aed$var$CacheContext
                ], renderLanes, !0);
                $8373ca4214e15aed$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $8373ca4214e15aed$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $8373ca4214e15aed$var$createCapturedValueAtFiber(Error($8373ca4214e15aed$var$formatProdErrorMessage(424)), workInProgress);
                        $8373ca4214e15aed$var$queueHydrationError($$typeof);
                        workInProgress = $8373ca4214e15aed$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $8373ca4214e15aed$var$nextHydratableInstance = $8373ca4214e15aed$var$getNextHydratable(current.firstChild);
                        $8373ca4214e15aed$var$hydrationParentFiber = workInProgress;
                        $8373ca4214e15aed$var$isHydrating = !0;
                        $8373ca4214e15aed$var$hydrationErrors = null;
                        $8373ca4214e15aed$var$rootOrSingletonContext = !0;
                        renderLanes = $8373ca4214e15aed$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $8373ca4214e15aed$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $8373ca4214e15aed$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $8373ca4214e15aed$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $8373ca4214e15aed$var$markRef(current, workInProgress), null === current ? (renderLanes = $8373ca4214e15aed$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $8373ca4214e15aed$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $8373ca4214e15aed$var$getOwnerDocumentFromRootContainer($8373ca4214e15aed$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$8373ca4214e15aed$var$internalInstanceKey] = workInProgress, props[$8373ca4214e15aed$var$internalPropsKey] = current, $8373ca4214e15aed$var$setInitialProperties(props, renderLanes, current), $8373ca4214e15aed$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $8373ca4214e15aed$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $8373ca4214e15aed$var$pushHostContext(workInProgress), null === current && $8373ca4214e15aed$var$isHydrating && (props = workInProgress.stateNode = $8373ca4214e15aed$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $8373ca4214e15aed$var$rootInstanceStackCursor.current), $8373ca4214e15aed$var$hydrationParentFiber = workInProgress, $8373ca4214e15aed$var$rootOrSingletonContext = !0, $$typeof = $8373ca4214e15aed$var$nextHydratableInstance, $8373ca4214e15aed$var$isSingletonScope(workInProgress.type) ? ($8373ca4214e15aed$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $8373ca4214e15aed$var$nextHydratableInstance = $8373ca4214e15aed$var$getNextHydratable(props.firstChild)) : $8373ca4214e15aed$var$nextHydratableInstance = $$typeof), $8373ca4214e15aed$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $8373ca4214e15aed$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $8373ca4214e15aed$var$isHydrating) {
                if ($$typeof = props = $8373ca4214e15aed$var$nextHydratableInstance) props = $8373ca4214e15aed$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $8373ca4214e15aed$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $8373ca4214e15aed$var$hydrationParentFiber = workInProgress, $8373ca4214e15aed$var$nextHydratableInstance = $8373ca4214e15aed$var$getNextHydratable(props.firstChild), $8373ca4214e15aed$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $8373ca4214e15aed$var$throwOnHydrationMismatch(workInProgress);
            }
            $8373ca4214e15aed$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $8373ca4214e15aed$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $8373ca4214e15aed$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $8373ca4214e15aed$var$renderWithHooks(current, workInProgress, $8373ca4214e15aed$var$TransitionAwareHostComponent, null, null, renderLanes), $8373ca4214e15aed$var$HostTransitionContext._currentValue = $$typeof);
            $8373ca4214e15aed$var$markRef(current, workInProgress);
            $8373ca4214e15aed$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $8373ca4214e15aed$var$isHydrating) {
                if (current = renderLanes = $8373ca4214e15aed$var$nextHydratableInstance) renderLanes = $8373ca4214e15aed$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $8373ca4214e15aed$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $8373ca4214e15aed$var$hydrationParentFiber = workInProgress, $8373ca4214e15aed$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $8373ca4214e15aed$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $8373ca4214e15aed$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $8373ca4214e15aed$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $8373ca4214e15aed$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $8373ca4214e15aed$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $8373ca4214e15aed$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $8373ca4214e15aed$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $8373ca4214e15aed$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $8373ca4214e15aed$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $8373ca4214e15aed$var$pushProvider(workInProgress, workInProgress.type, props.value), $8373ca4214e15aed$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $8373ca4214e15aed$var$prepareToReadContext(workInProgress), $$typeof = $8373ca4214e15aed$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $8373ca4214e15aed$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $8373ca4214e15aed$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $8373ca4214e15aed$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $8373ca4214e15aed$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $8373ca4214e15aed$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $8373ca4214e15aed$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $8373ca4214e15aed$var$prepareToReadContext(workInProgress), props = $8373ca4214e15aed$var$readContext($8373ca4214e15aed$var$CacheContext), null === current ? ($$typeof = $8373ca4214e15aed$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $8373ca4214e15aed$var$workInProgressRoot, prevState = $8373ca4214e15aed$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $8373ca4214e15aed$var$initializeUpdateQueue(workInProgress), $8373ca4214e15aed$var$pushProvider(workInProgress, $8373ca4214e15aed$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($8373ca4214e15aed$var$cloneUpdateQueue(current, workInProgress), $8373ca4214e15aed$var$processUpdateQueue(workInProgress, null, null, renderLanes), $8373ca4214e15aed$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $8373ca4214e15aed$var$pushProvider(workInProgress, $8373ca4214e15aed$var$CacheContext, props)) : (props = prevState.cache, $8373ca4214e15aed$var$pushProvider(workInProgress, $8373ca4214e15aed$var$CacheContext, props), props !== $$typeof.cache && $8373ca4214e15aed$var$propagateContextChanges(workInProgress, [
                $8373ca4214e15aed$var$CacheContext
            ], renderLanes, !0))), $8373ca4214e15aed$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($8373ca4214e15aed$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $8373ca4214e15aed$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $8373ca4214e15aed$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($8373ca4214e15aed$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $8373ca4214e15aed$var$suspendedThenable = $8373ca4214e15aed$var$noopSuspenseyCommitThenable, $8373ca4214e15aed$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $8373ca4214e15aed$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$8373ca4214e15aed$var$preloadResource(resource)) {
        if ($8373ca4214e15aed$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $8373ca4214e15aed$var$suspendedThenable = $8373ca4214e15aed$var$noopSuspenseyCommitThenable, $8373ca4214e15aed$var$SuspenseyCommitException;
    }
}
function $8373ca4214e15aed$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $8373ca4214e15aed$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $8373ca4214e15aed$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $8373ca4214e15aed$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$8373ca4214e15aed$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $8373ca4214e15aed$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $8373ca4214e15aed$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $8373ca4214e15aed$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $8373ca4214e15aed$var$bubbleProperties(workInProgress), null;
        case 1:
            return $8373ca4214e15aed$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $8373ca4214e15aed$var$popProvider($8373ca4214e15aed$var$CacheContext);
            $8373ca4214e15aed$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $8373ca4214e15aed$var$popHydrationState(workInProgress) ? $8373ca4214e15aed$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $8373ca4214e15aed$var$upgradeHydrationErrorsToRecoverable());
            $8373ca4214e15aed$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($8373ca4214e15aed$var$markUpdate(workInProgress), null !== nextResource ? ($8373ca4214e15aed$var$bubbleProperties(workInProgress), $8373ca4214e15aed$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($8373ca4214e15aed$var$bubbleProperties(workInProgress), $8373ca4214e15aed$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($8373ca4214e15aed$var$markUpdate(workInProgress), $8373ca4214e15aed$var$bubbleProperties(workInProgress), $8373ca4214e15aed$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($8373ca4214e15aed$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $8373ca4214e15aed$var$markUpdate(workInProgress), $8373ca4214e15aed$var$bubbleProperties(workInProgress), $8373ca4214e15aed$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $8373ca4214e15aed$var$popHostContext(workInProgress);
            renderLanes = $8373ca4214e15aed$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $8373ca4214e15aed$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(166));
                    $8373ca4214e15aed$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $8373ca4214e15aed$var$contextStackCursor.current;
                $8373ca4214e15aed$var$popHydrationState(workInProgress) ? $8373ca4214e15aed$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $8373ca4214e15aed$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $8373ca4214e15aed$var$markUpdate(workInProgress));
            }
            $8373ca4214e15aed$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $8373ca4214e15aed$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $8373ca4214e15aed$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(166));
                    $8373ca4214e15aed$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $8373ca4214e15aed$var$contextStackCursor.current;
                if ($8373ca4214e15aed$var$popHydrationState(workInProgress)) $8373ca4214e15aed$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $8373ca4214e15aed$var$getOwnerDocumentFromRootContainer($8373ca4214e15aed$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script></script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$8373ca4214e15aed$var$internalInstanceKey] = workInProgress;
                    nextResource[$8373ca4214e15aed$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($8373ca4214e15aed$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $8373ca4214e15aed$var$markUpdate(workInProgress);
                }
            }
            $8373ca4214e15aed$var$bubbleProperties(workInProgress);
            $8373ca4214e15aed$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $8373ca4214e15aed$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(166));
                current = $8373ca4214e15aed$var$rootInstanceStackCursor.current;
                if ($8373ca4214e15aed$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $8373ca4214e15aed$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$8373ca4214e15aed$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $8373ca4214e15aed$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $8373ca4214e15aed$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $8373ca4214e15aed$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$8373ca4214e15aed$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $8373ca4214e15aed$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $8373ca4214e15aed$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(557));
                        current[$8373ca4214e15aed$var$internalInstanceKey] = workInProgress;
                    } else $8373ca4214e15aed$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $8373ca4214e15aed$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $8373ca4214e15aed$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $8373ca4214e15aed$var$popSuspenseHandler(workInProgress), workInProgress;
                    $8373ca4214e15aed$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(558));
            }
            $8373ca4214e15aed$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $8373ca4214e15aed$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(317));
                        type[$8373ca4214e15aed$var$internalInstanceKey] = workInProgress;
                    } else $8373ca4214e15aed$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $8373ca4214e15aed$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $8373ca4214e15aed$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $8373ca4214e15aed$var$popSuspenseHandler(workInProgress), workInProgress;
                    $8373ca4214e15aed$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $8373ca4214e15aed$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $8373ca4214e15aed$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $8373ca4214e15aed$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $8373ca4214e15aed$var$popHostContainer(), null === current && $8373ca4214e15aed$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $8373ca4214e15aed$var$bubbleProperties(workInProgress), null;
        case 10:
            return $8373ca4214e15aed$var$popProvider(workInProgress.type), $8373ca4214e15aed$var$bubbleProperties(workInProgress), null;
        case 19:
            $8373ca4214e15aed$var$pop($8373ca4214e15aed$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $8373ca4214e15aed$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $8373ca4214e15aed$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $8373ca4214e15aed$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $8373ca4214e15aed$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $8373ca4214e15aed$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $8373ca4214e15aed$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$8373ca4214e15aed$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $8373ca4214e15aed$var$push($8373ca4214e15aed$var$suspenseStackCursor, $8373ca4214e15aed$var$suspenseStackCursor.current & 1 | 2);
                            $8373ca4214e15aed$var$isHydrating && $8373ca4214e15aed$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $8373ca4214e15aed$var$now() > $8373ca4214e15aed$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $8373ca4214e15aed$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $8373ca4214e15aed$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $8373ca4214e15aed$var$scheduleRetryEffect(workInProgress, current), $8373ca4214e15aed$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$8373ca4214e15aed$var$isHydrating) return $8373ca4214e15aed$var$bubbleProperties(workInProgress), null;
                    } else 2 * $8373ca4214e15aed$var$now() - newProps.renderingStartTime > $8373ca4214e15aed$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $8373ca4214e15aed$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $8373ca4214e15aed$var$now(), current.sibling = null, renderLanes = $8373ca4214e15aed$var$suspenseStackCursor.current, $8373ca4214e15aed$var$push($8373ca4214e15aed$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $8373ca4214e15aed$var$isHydrating && $8373ca4214e15aed$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $8373ca4214e15aed$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $8373ca4214e15aed$var$popSuspenseHandler(workInProgress), $8373ca4214e15aed$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($8373ca4214e15aed$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $8373ca4214e15aed$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $8373ca4214e15aed$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $8373ca4214e15aed$var$pop($8373ca4214e15aed$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $8373ca4214e15aed$var$popProvider($8373ca4214e15aed$var$CacheContext), $8373ca4214e15aed$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($8373ca4214e15aed$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $8373ca4214e15aed$var$unwindWork(current, workInProgress) {
    $8373ca4214e15aed$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $8373ca4214e15aed$var$popProvider($8373ca4214e15aed$var$CacheContext), $8373ca4214e15aed$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $8373ca4214e15aed$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $8373ca4214e15aed$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(340));
                $8373ca4214e15aed$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $8373ca4214e15aed$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(340));
                $8373ca4214e15aed$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $8373ca4214e15aed$var$pop($8373ca4214e15aed$var$suspenseStackCursor), null;
        case 4:
            return $8373ca4214e15aed$var$popHostContainer(), null;
        case 10:
            return $8373ca4214e15aed$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $8373ca4214e15aed$var$popSuspenseHandler(workInProgress), $8373ca4214e15aed$var$popHiddenContext(), null !== current && $8373ca4214e15aed$var$pop($8373ca4214e15aed$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $8373ca4214e15aed$var$popProvider($8373ca4214e15aed$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $8373ca4214e15aed$var$unwindInterruptedWork(current, interruptedWork) {
    $8373ca4214e15aed$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $8373ca4214e15aed$var$popProvider($8373ca4214e15aed$var$CacheContext);
            $8373ca4214e15aed$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $8373ca4214e15aed$var$popHostContext(interruptedWork);
            break;
        case 4:
            $8373ca4214e15aed$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $8373ca4214e15aed$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $8373ca4214e15aed$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $8373ca4214e15aed$var$pop($8373ca4214e15aed$var$suspenseStackCursor);
            break;
        case 10:
            $8373ca4214e15aed$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $8373ca4214e15aed$var$popSuspenseHandler(interruptedWork);
            $8373ca4214e15aed$var$popHiddenContext();
            null !== current && $8373ca4214e15aed$var$pop($8373ca4214e15aed$var$resumedCache);
            break;
        case 24:
            $8373ca4214e15aed$var$popProvider($8373ca4214e15aed$var$CacheContext);
    }
}
function $8373ca4214e15aed$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $8373ca4214e15aed$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $8373ca4214e15aed$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $8373ca4214e15aed$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $8373ca4214e15aed$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $8373ca4214e15aed$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $8373ca4214e15aed$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $8373ca4214e15aed$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $8373ca4214e15aed$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $8373ca4214e15aed$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $8373ca4214e15aed$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $8373ca4214e15aed$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $8373ca4214e15aed$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $8373ca4214e15aed$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $8373ca4214e15aed$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $8373ca4214e15aed$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $8373ca4214e15aed$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $8373ca4214e15aed$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $8373ca4214e15aed$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $8373ca4214e15aed$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$8373ca4214e15aed$var$internalPropsKey] = newProps;
    } catch (error) {
        $8373ca4214e15aed$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $8373ca4214e15aed$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $8373ca4214e15aed$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $8373ca4214e15aed$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $8373ca4214e15aed$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $8373ca4214e15aed$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $8373ca4214e15aed$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $8373ca4214e15aed$var$noop$1));
    else if (4 !== tag && (27 === tag && $8373ca4214e15aed$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($8373ca4214e15aed$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$8373ca4214e15aed$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $8373ca4214e15aed$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $8373ca4214e15aed$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($8373ca4214e15aed$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$8373ca4214e15aed$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $8373ca4214e15aed$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $8373ca4214e15aed$var$setInitialProperties(singleton, type, props);
        singleton[$8373ca4214e15aed$var$internalInstanceKey] = finishedWork;
        singleton[$8373ca4214e15aed$var$internalPropsKey] = props;
    } catch (error) {
        $8373ca4214e15aed$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $8373ca4214e15aed$var$offscreenSubtreeIsHidden = !1, $8373ca4214e15aed$var$offscreenSubtreeWasHidden = !1, $8373ca4214e15aed$var$needsFormReset = !1, $8373ca4214e15aed$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $8373ca4214e15aed$var$nextEffect = null;
function $8373ca4214e15aed$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $8373ca4214e15aed$var$eventsEnabled = $8373ca4214e15aed$var$_enabled;
    root = $8373ca4214e15aed$var$getActiveElementDeep(root);
    if ($8373ca4214e15aed$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $8373ca4214e15aed$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $8373ca4214e15aed$var$_enabled = !1;
    for($8373ca4214e15aed$var$nextEffect = firstChild; null !== $8373ca4214e15aed$var$nextEffect;)if (firstChild = $8373ca4214e15aed$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $8373ca4214e15aed$var$nextEffect = root;
    else for(; null !== $8373ca4214e15aed$var$nextEffect;){
        firstChild = $8373ca4214e15aed$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $8373ca4214e15aed$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $8373ca4214e15aed$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $8373ca4214e15aed$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $8373ca4214e15aed$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $8373ca4214e15aed$var$nextEffect = root;
            break;
        }
        $8373ca4214e15aed$var$nextEffect = firstChild.return;
    }
}
function $8373ca4214e15aed$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $8373ca4214e15aed$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $8373ca4214e15aed$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $8373ca4214e15aed$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $8373ca4214e15aed$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $8373ca4214e15aed$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $8373ca4214e15aed$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $8373ca4214e15aed$var$commitClassCallbacks(finishedWork);
            flags & 512 && $8373ca4214e15aed$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $8373ca4214e15aed$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $8373ca4214e15aed$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $8373ca4214e15aed$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $8373ca4214e15aed$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $8373ca4214e15aed$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $8373ca4214e15aed$var$commitHostMount(finishedWork);
            flags & 512 && $8373ca4214e15aed$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $8373ca4214e15aed$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $8373ca4214e15aed$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $8373ca4214e15aed$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $8373ca4214e15aed$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $8373ca4214e15aed$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $8373ca4214e15aed$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $8373ca4214e15aed$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $8373ca4214e15aed$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $8373ca4214e15aed$var$offscreenSubtreeWasHidden;
                prevProps = $8373ca4214e15aed$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $8373ca4214e15aed$var$offscreenSubtreeWasHidden;
                $8373ca4214e15aed$var$offscreenSubtreeIsHidden = flags;
                ($8373ca4214e15aed$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $8373ca4214e15aed$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $8373ca4214e15aed$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $8373ca4214e15aed$var$offscreenSubtreeIsHidden = prevProps;
                $8373ca4214e15aed$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $8373ca4214e15aed$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $8373ca4214e15aed$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $8373ca4214e15aed$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $8373ca4214e15aed$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $8373ca4214e15aed$var$hostParent = null, $8373ca4214e15aed$var$hostParentIsContainer = !1;
function $8373ca4214e15aed$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$8373ca4214e15aed$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $8373ca4214e15aed$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($8373ca4214e15aed$var$injectedHook && "function" === typeof $8373ca4214e15aed$var$injectedHook.onCommitFiberUnmount) try {
        $8373ca4214e15aed$var$injectedHook.onCommitFiberUnmount($8373ca4214e15aed$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $8373ca4214e15aed$var$offscreenSubtreeWasHidden || $8373ca4214e15aed$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $8373ca4214e15aed$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $8373ca4214e15aed$var$offscreenSubtreeWasHidden || $8373ca4214e15aed$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $8373ca4214e15aed$var$hostParent, prevHostParentIsContainer = $8373ca4214e15aed$var$hostParentIsContainer;
            $8373ca4214e15aed$var$isSingletonScope(deletedFiber.type) && ($8373ca4214e15aed$var$hostParent = deletedFiber.stateNode, $8373ca4214e15aed$var$hostParentIsContainer = !1);
            $8373ca4214e15aed$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $8373ca4214e15aed$var$releaseSingletonInstance(deletedFiber.stateNode);
            $8373ca4214e15aed$var$hostParent = prevHostParent;
            $8373ca4214e15aed$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $8373ca4214e15aed$var$offscreenSubtreeWasHidden || $8373ca4214e15aed$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $8373ca4214e15aed$var$hostParent;
            prevHostParentIsContainer = $8373ca4214e15aed$var$hostParentIsContainer;
            $8373ca4214e15aed$var$hostParent = null;
            $8373ca4214e15aed$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $8373ca4214e15aed$var$hostParent = prevHostParent;
            $8373ca4214e15aed$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $8373ca4214e15aed$var$hostParent) {
                if ($8373ca4214e15aed$var$hostParentIsContainer) try {
                    (9 === $8373ca4214e15aed$var$hostParent.nodeType ? $8373ca4214e15aed$var$hostParent.body : "HTML" === $8373ca4214e15aed$var$hostParent.nodeName ? $8373ca4214e15aed$var$hostParent.ownerDocument.body : $8373ca4214e15aed$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $8373ca4214e15aed$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $8373ca4214e15aed$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $8373ca4214e15aed$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $8373ca4214e15aed$var$hostParent && ($8373ca4214e15aed$var$hostParentIsContainer ? (finishedRoot = $8373ca4214e15aed$var$hostParent, $8373ca4214e15aed$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $8373ca4214e15aed$var$retryIfBlockedOn(finishedRoot)) : $8373ca4214e15aed$var$clearHydrationBoundary($8373ca4214e15aed$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $8373ca4214e15aed$var$hostParent;
            prevHostParentIsContainer = $8373ca4214e15aed$var$hostParentIsContainer;
            $8373ca4214e15aed$var$hostParent = deletedFiber.stateNode.containerInfo;
            $8373ca4214e15aed$var$hostParentIsContainer = !0;
            $8373ca4214e15aed$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $8373ca4214e15aed$var$hostParent = prevHostParent;
            $8373ca4214e15aed$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $8373ca4214e15aed$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $8373ca4214e15aed$var$offscreenSubtreeWasHidden || $8373ca4214e15aed$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $8373ca4214e15aed$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $8373ca4214e15aed$var$offscreenSubtreeWasHidden || ($8373ca4214e15aed$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $8373ca4214e15aed$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $8373ca4214e15aed$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $8373ca4214e15aed$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $8373ca4214e15aed$var$offscreenSubtreeWasHidden = (prevHostParent = $8373ca4214e15aed$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $8373ca4214e15aed$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $8373ca4214e15aed$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $8373ca4214e15aed$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $8373ca4214e15aed$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $8373ca4214e15aed$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $8373ca4214e15aed$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $8373ca4214e15aed$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $8373ca4214e15aed$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $8373ca4214e15aed$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $8373ca4214e15aed$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $8373ca4214e15aed$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $8373ca4214e15aed$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($8373ca4214e15aed$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $8373ca4214e15aed$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $8373ca4214e15aed$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $8373ca4214e15aed$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $8373ca4214e15aed$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($8373ca4214e15aed$var$isSingletonScope(parent.type)) {
                        $8373ca4214e15aed$var$hostParent = parent.stateNode;
                        $8373ca4214e15aed$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $8373ca4214e15aed$var$hostParent = parent.stateNode;
                    $8373ca4214e15aed$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $8373ca4214e15aed$var$hostParent = parent.stateNode.containerInfo;
                    $8373ca4214e15aed$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $8373ca4214e15aed$var$hostParent) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(160));
        $8373ca4214e15aed$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $8373ca4214e15aed$var$hostParent = null;
        $8373ca4214e15aed$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$8373ca4214e15aed$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $8373ca4214e15aed$var$currentHoistableRoot = null;
function $8373ca4214e15aed$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $8373ca4214e15aed$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $8373ca4214e15aed$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($8373ca4214e15aed$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $8373ca4214e15aed$var$commitHookEffectListMount(3, finishedWork), $8373ca4214e15aed$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $8373ca4214e15aed$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $8373ca4214e15aed$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($8373ca4214e15aed$var$offscreenSubtreeWasHidden || null === current || $8373ca4214e15aed$var$safelyDetachRef(current, current.return));
            flags & 64 && $8373ca4214e15aed$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $8373ca4214e15aed$var$currentHoistableRoot;
            $8373ca4214e15aed$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $8373ca4214e15aed$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($8373ca4214e15aed$var$offscreenSubtreeWasHidden || null === current || $8373ca4214e15aed$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$8373ca4214e15aed$var$internalHoistableMarker] || currentResource[$8373ca4214e15aed$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $8373ca4214e15aed$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$8373ca4214e15aed$var$internalInstanceKey] = finishedWork;
                                        $8373ca4214e15aed$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $8373ca4214e15aed$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $8373ca4214e15aed$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $8373ca4214e15aed$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $8373ca4214e15aed$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($8373ca4214e15aed$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$8373ca4214e15aed$var$internalInstanceKey] = finishedWork;
                                $8373ca4214e15aed$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $8373ca4214e15aed$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $8373ca4214e15aed$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $8373ca4214e15aed$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $8373ca4214e15aed$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $8373ca4214e15aed$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $8373ca4214e15aed$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $8373ca4214e15aed$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($8373ca4214e15aed$var$offscreenSubtreeWasHidden || null === current || $8373ca4214e15aed$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $8373ca4214e15aed$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $8373ca4214e15aed$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $8373ca4214e15aed$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($8373ca4214e15aed$var$offscreenSubtreeWasHidden || null === current || $8373ca4214e15aed$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $8373ca4214e15aed$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $8373ca4214e15aed$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $8373ca4214e15aed$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($8373ca4214e15aed$var$needsFormReset = !0);
            break;
        case 6:
            $8373ca4214e15aed$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $8373ca4214e15aed$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $8373ca4214e15aed$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $8373ca4214e15aed$var$tagCaches = null;
            hoistableRoot = $8373ca4214e15aed$var$currentHoistableRoot;
            $8373ca4214e15aed$var$currentHoistableRoot = $8373ca4214e15aed$var$getHoistableRoot(root.containerInfo);
            $8373ca4214e15aed$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $8373ca4214e15aed$var$currentHoistableRoot = hoistableRoot;
            $8373ca4214e15aed$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $8373ca4214e15aed$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $8373ca4214e15aed$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $8373ca4214e15aed$var$needsFormReset && ($8373ca4214e15aed$var$needsFormReset = !1, $8373ca4214e15aed$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $8373ca4214e15aed$var$currentHoistableRoot;
            $8373ca4214e15aed$var$currentHoistableRoot = $8373ca4214e15aed$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $8373ca4214e15aed$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $8373ca4214e15aed$var$commitReconciliationEffects(finishedWork);
            $8373ca4214e15aed$var$currentHoistableRoot = flags;
            break;
        case 12:
            $8373ca4214e15aed$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $8373ca4214e15aed$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $8373ca4214e15aed$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $8373ca4214e15aed$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $8373ca4214e15aed$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $8373ca4214e15aed$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $8373ca4214e15aed$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($8373ca4214e15aed$var$globalMostRecentFallbackTime = $8373ca4214e15aed$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $8373ca4214e15aed$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $8373ca4214e15aed$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $8373ca4214e15aed$var$offscreenSubtreeWasHidden;
            $8373ca4214e15aed$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $8373ca4214e15aed$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $8373ca4214e15aed$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $8373ca4214e15aed$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $8373ca4214e15aed$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $8373ca4214e15aed$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $8373ca4214e15aed$var$offscreenSubtreeIsHidden || $8373ca4214e15aed$var$offscreenSubtreeWasHidden || $8373ca4214e15aed$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $8373ca4214e15aed$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $8373ca4214e15aed$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $8373ca4214e15aed$var$hideOrUnhideDehydratedBoundary(instance, !0) : $8373ca4214e15aed$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $8373ca4214e15aed$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $8373ca4214e15aed$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $8373ca4214e15aed$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $8373ca4214e15aed$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $8373ca4214e15aed$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $8373ca4214e15aed$var$recursivelyTraverseMutationEffects(root, finishedWork), $8373ca4214e15aed$var$commitReconciliationEffects(finishedWork);
    }
}
function $8373ca4214e15aed$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($8373ca4214e15aed$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $8373ca4214e15aed$var$getHostSibling(finishedWork);
                    $8373ca4214e15aed$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($8373ca4214e15aed$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $8373ca4214e15aed$var$getHostSibling(finishedWork);
                    $8373ca4214e15aed$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $8373ca4214e15aed$var$getHostSibling(finishedWork);
                    $8373ca4214e15aed$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($8373ca4214e15aed$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $8373ca4214e15aed$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $8373ca4214e15aed$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $8373ca4214e15aed$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $8373ca4214e15aed$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$8373ca4214e15aed$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $8373ca4214e15aed$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $8373ca4214e15aed$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $8373ca4214e15aed$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $8373ca4214e15aed$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $8373ca4214e15aed$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $8373ca4214e15aed$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $8373ca4214e15aed$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $8373ca4214e15aed$var$safelyDetachRef(finishedWork, finishedWork.return);
                $8373ca4214e15aed$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $8373ca4214e15aed$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $8373ca4214e15aed$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $8373ca4214e15aed$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $8373ca4214e15aed$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $8373ca4214e15aed$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $8373ca4214e15aed$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $8373ca4214e15aed$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $8373ca4214e15aed$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$8373ca4214e15aed$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $8373ca4214e15aed$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $8373ca4214e15aed$var$commitClassCallbacks(finishedWork);
                $8373ca4214e15aed$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $8373ca4214e15aed$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $8373ca4214e15aed$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $8373ca4214e15aed$var$commitHostMount(finishedWork);
                $8373ca4214e15aed$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $8373ca4214e15aed$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $8373ca4214e15aed$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $8373ca4214e15aed$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $8373ca4214e15aed$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $8373ca4214e15aed$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $8373ca4214e15aed$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $8373ca4214e15aed$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $8373ca4214e15aed$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $8373ca4214e15aed$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $8373ca4214e15aed$var$releaseCache(previousCache));
}
function $8373ca4214e15aed$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $8373ca4214e15aed$var$releaseCache(current));
}
function $8373ca4214e15aed$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$8373ca4214e15aed$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $8373ca4214e15aed$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $8373ca4214e15aed$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $8373ca4214e15aed$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $8373ca4214e15aed$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $8373ca4214e15aed$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $8373ca4214e15aed$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $8373ca4214e15aed$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $8373ca4214e15aed$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $8373ca4214e15aed$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $8373ca4214e15aed$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $8373ca4214e15aed$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $8373ca4214e15aed$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $8373ca4214e15aed$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $8373ca4214e15aed$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $8373ca4214e15aed$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $8373ca4214e15aed$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $8373ca4214e15aed$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $8373ca4214e15aed$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $8373ca4214e15aed$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $8373ca4214e15aed$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $8373ca4214e15aed$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $8373ca4214e15aed$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $8373ca4214e15aed$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $8373ca4214e15aed$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $8373ca4214e15aed$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $8373ca4214e15aed$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $8373ca4214e15aed$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $8373ca4214e15aed$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $8373ca4214e15aed$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $8373ca4214e15aed$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $8373ca4214e15aed$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $8373ca4214e15aed$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $8373ca4214e15aed$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $8373ca4214e15aed$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $8373ca4214e15aed$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $8373ca4214e15aed$var$suspenseyCommitFlag = 8192;
function $8373ca4214e15aed$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $8373ca4214e15aed$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$8373ca4214e15aed$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $8373ca4214e15aed$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $8373ca4214e15aed$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $8373ca4214e15aed$var$suspenseyCommitFlag && null !== fiber.memoizedState && $8373ca4214e15aed$var$suspendResource(suspendedState, $8373ca4214e15aed$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $8373ca4214e15aed$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $8373ca4214e15aed$var$currentHoistableRoot;
            $8373ca4214e15aed$var$currentHoistableRoot = $8373ca4214e15aed$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $8373ca4214e15aed$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $8373ca4214e15aed$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $8373ca4214e15aed$var$suspenseyCommitFlag, $8373ca4214e15aed$var$suspenseyCommitFlag = 16777216, $8373ca4214e15aed$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $8373ca4214e15aed$var$suspenseyCommitFlag = previousHoistableRoot) : $8373ca4214e15aed$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $8373ca4214e15aed$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $8373ca4214e15aed$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $8373ca4214e15aed$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $8373ca4214e15aed$var$nextEffect = childToDelete;
            $8373ca4214e15aed$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $8373ca4214e15aed$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$8373ca4214e15aed$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $8373ca4214e15aed$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $8373ca4214e15aed$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $8373ca4214e15aed$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $8373ca4214e15aed$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $8373ca4214e15aed$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $8373ca4214e15aed$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $8373ca4214e15aed$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $8373ca4214e15aed$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $8373ca4214e15aed$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $8373ca4214e15aed$var$nextEffect = childToDelete;
            $8373ca4214e15aed$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $8373ca4214e15aed$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $8373ca4214e15aed$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $8373ca4214e15aed$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $8373ca4214e15aed$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $8373ca4214e15aed$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $8373ca4214e15aed$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $8373ca4214e15aed$var$nextEffect;){
        var fiber = $8373ca4214e15aed$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $8373ca4214e15aed$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $8373ca4214e15aed$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $8373ca4214e15aed$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $8373ca4214e15aed$var$nextEffect;){
            cache = $8373ca4214e15aed$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $8373ca4214e15aed$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $8373ca4214e15aed$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $8373ca4214e15aed$var$nextEffect = sibling;
                break a;
            }
            $8373ca4214e15aed$var$nextEffect = returnFiber;
        }
    }
}
var $8373ca4214e15aed$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $8373ca4214e15aed$var$readContext($8373ca4214e15aed$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $8373ca4214e15aed$var$readContext($8373ca4214e15aed$var$CacheContext).controller.signal;
    }
}, $8373ca4214e15aed$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $8373ca4214e15aed$var$executionContext = 0, $8373ca4214e15aed$var$workInProgressRoot = null, $8373ca4214e15aed$var$workInProgress = null, $8373ca4214e15aed$var$workInProgressRootRenderLanes = 0, $8373ca4214e15aed$var$workInProgressSuspendedReason = 0, $8373ca4214e15aed$var$workInProgressThrownValue = null, $8373ca4214e15aed$var$workInProgressRootDidSkipSuspendedSiblings = !1, $8373ca4214e15aed$var$workInProgressRootIsPrerendering = !1, $8373ca4214e15aed$var$workInProgressRootDidAttachPingListener = !1, $8373ca4214e15aed$var$entangledRenderLanes = 0, $8373ca4214e15aed$var$workInProgressRootExitStatus = 0, $8373ca4214e15aed$var$workInProgressRootSkippedLanes = 0, $8373ca4214e15aed$var$workInProgressRootInterleavedUpdatedLanes = 0, $8373ca4214e15aed$var$workInProgressRootPingedLanes = 0, $8373ca4214e15aed$var$workInProgressDeferredLane = 0, $8373ca4214e15aed$var$workInProgressSuspendedRetryLanes = 0, $8373ca4214e15aed$var$workInProgressRootConcurrentErrors = null, $8373ca4214e15aed$var$workInProgressRootRecoverableErrors = null, $8373ca4214e15aed$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $8373ca4214e15aed$var$globalMostRecentFallbackTime = 0, $8373ca4214e15aed$var$globalMostRecentTransitionTime = 0, $8373ca4214e15aed$var$workInProgressRootRenderTargetTime = Infinity, $8373ca4214e15aed$var$workInProgressTransitions = null, $8373ca4214e15aed$var$legacyErrorBoundariesThatAlreadyFailed = null, $8373ca4214e15aed$var$pendingEffectsStatus = 0, $8373ca4214e15aed$var$pendingEffectsRoot = null, $8373ca4214e15aed$var$pendingFinishedWork = null, $8373ca4214e15aed$var$pendingEffectsLanes = 0, $8373ca4214e15aed$var$pendingEffectsRemainingLanes = 0, $8373ca4214e15aed$var$pendingPassiveTransitions = null, $8373ca4214e15aed$var$pendingRecoverableErrors = null, $8373ca4214e15aed$var$nestedUpdateCount = 0, $8373ca4214e15aed$var$rootWithNestedUpdates = null;
function $8373ca4214e15aed$var$requestUpdateLane() {
    return 0 !== ($8373ca4214e15aed$var$executionContext & 2) && 0 !== $8373ca4214e15aed$var$workInProgressRootRenderLanes ? $8373ca4214e15aed$var$workInProgressRootRenderLanes & -$8373ca4214e15aed$var$workInProgressRootRenderLanes : null !== $8373ca4214e15aed$var$ReactSharedInternals.T ? $8373ca4214e15aed$var$requestTransitionLane() : $8373ca4214e15aed$var$resolveUpdatePriority();
}
function $8373ca4214e15aed$var$requestDeferredLane() {
    if (0 === $8373ca4214e15aed$var$workInProgressDeferredLane) {
        if (0 === ($8373ca4214e15aed$var$workInProgressRootRenderLanes & 536870912) || $8373ca4214e15aed$var$isHydrating) {
            var lane = $8373ca4214e15aed$var$nextTransitionDeferredLane;
            $8373ca4214e15aed$var$nextTransitionDeferredLane <<= 1;
            0 === ($8373ca4214e15aed$var$nextTransitionDeferredLane & 3932160) && ($8373ca4214e15aed$var$nextTransitionDeferredLane = 262144);
            $8373ca4214e15aed$var$workInProgressDeferredLane = lane;
        } else $8373ca4214e15aed$var$workInProgressDeferredLane = 536870912;
    }
    lane = $8373ca4214e15aed$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $8373ca4214e15aed$var$workInProgressDeferredLane;
}
function $8373ca4214e15aed$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $8373ca4214e15aed$var$workInProgressRoot && (2 === $8373ca4214e15aed$var$workInProgressSuspendedReason || 9 === $8373ca4214e15aed$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $8373ca4214e15aed$var$prepareFreshStack(root, 0), $8373ca4214e15aed$var$markRootSuspended(root, $8373ca4214e15aed$var$workInProgressRootRenderLanes, $8373ca4214e15aed$var$workInProgressDeferredLane, !1);
    $8373ca4214e15aed$var$markRootUpdated$1(root, lane);
    if (0 === ($8373ca4214e15aed$var$executionContext & 2) || root !== $8373ca4214e15aed$var$workInProgressRoot) root === $8373ca4214e15aed$var$workInProgressRoot && (0 === ($8373ca4214e15aed$var$executionContext & 2) && ($8373ca4214e15aed$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $8373ca4214e15aed$var$workInProgressRootExitStatus && $8373ca4214e15aed$var$markRootSuspended(root, $8373ca4214e15aed$var$workInProgressRootRenderLanes, $8373ca4214e15aed$var$workInProgressDeferredLane, !1)), $8373ca4214e15aed$var$ensureRootIsScheduled(root);
}
function $8373ca4214e15aed$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($8373ca4214e15aed$var$executionContext & 6)) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $8373ca4214e15aed$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $8373ca4214e15aed$var$renderRootConcurrent(root$jscomp$0, lanes) : $8373ca4214e15aed$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $8373ca4214e15aed$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $8373ca4214e15aed$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$8373ca4214e15aed$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $8373ca4214e15aed$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $8373ca4214e15aed$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($8373ca4214e15aed$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $8373ca4214e15aed$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($8373ca4214e15aed$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $8373ca4214e15aed$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $8373ca4214e15aed$var$workInProgressRootRecoverableErrors;
                            $8373ca4214e15aed$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $8373ca4214e15aed$var$workInProgressRootRecoverableErrors ? $8373ca4214e15aed$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $8373ca4214e15aed$var$workInProgressRootRecoverableErrors.push.apply($8373ca4214e15aed$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $8373ca4214e15aed$var$prepareFreshStack(root$jscomp$0, 0);
                $8373ca4214e15aed$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($8373ca4214e15aed$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $8373ca4214e15aed$var$markRootSuspended(shouldTimeSlice, lanes, $8373ca4214e15aed$var$workInProgressDeferredLane, !$8373ca4214e15aed$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $8373ca4214e15aed$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($8373ca4214e15aed$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $8373ca4214e15aed$var$globalMostRecentFallbackTime + 300 - $8373ca4214e15aed$var$now(), 10 < exitStatus)) {
                    $8373ca4214e15aed$var$markRootSuspended(shouldTimeSlice, lanes, $8373ca4214e15aed$var$workInProgressDeferredLane, !$8373ca4214e15aed$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $8373ca4214e15aed$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $8373ca4214e15aed$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $8373ca4214e15aed$var$scheduleTimeout($8373ca4214e15aed$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $8373ca4214e15aed$var$workInProgressRootRecoverableErrors, $8373ca4214e15aed$var$workInProgressTransitions, $8373ca4214e15aed$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $8373ca4214e15aed$var$workInProgressDeferredLane, $8373ca4214e15aed$var$workInProgressRootInterleavedUpdatedLanes, $8373ca4214e15aed$var$workInProgressSuspendedRetryLanes, $8373ca4214e15aed$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $8373ca4214e15aed$var$commitRootWhenReady(shouldTimeSlice, forceSync, $8373ca4214e15aed$var$workInProgressRootRecoverableErrors, $8373ca4214e15aed$var$workInProgressTransitions, $8373ca4214e15aed$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $8373ca4214e15aed$var$workInProgressDeferredLane, $8373ca4214e15aed$var$workInProgressRootInterleavedUpdatedLanes, $8373ca4214e15aed$var$workInProgressSuspendedRetryLanes, $8373ca4214e15aed$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $8373ca4214e15aed$var$ensureRootIsScheduled(root$jscomp$0);
}
function $8373ca4214e15aed$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $8373ca4214e15aed$var$noop$1
        };
        $8373ca4214e15aed$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $8373ca4214e15aed$var$globalMostRecentFallbackTime - $8373ca4214e15aed$var$now() : (lanes & 4194048) === lanes ? $8373ca4214e15aed$var$globalMostRecentTransitionTime - $8373ca4214e15aed$var$now() : 0;
        timeoutOffset = $8373ca4214e15aed$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $8373ca4214e15aed$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($8373ca4214e15aed$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $8373ca4214e15aed$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $8373ca4214e15aed$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $8373ca4214e15aed$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$8373ca4214e15aed$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $8373ca4214e15aed$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$8373ca4214e15aed$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$8373ca4214e15aed$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $8373ca4214e15aed$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $8373ca4214e15aed$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $8373ca4214e15aed$var$flushSyncWork$1() {
    return 0 === ($8373ca4214e15aed$var$executionContext & 6) ? ($8373ca4214e15aed$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $8373ca4214e15aed$var$resetWorkInProgressStack() {
    if (null !== $8373ca4214e15aed$var$workInProgress) {
        if (0 === $8373ca4214e15aed$var$workInProgressSuspendedReason) var interruptedWork = $8373ca4214e15aed$var$workInProgress.return;
        else interruptedWork = $8373ca4214e15aed$var$workInProgress, $8373ca4214e15aed$var$lastContextDependency = $8373ca4214e15aed$var$currentlyRenderingFiber$1 = null, $8373ca4214e15aed$var$resetHooksOnUnwind(interruptedWork), $8373ca4214e15aed$var$thenableState$1 = null, $8373ca4214e15aed$var$thenableIndexCounter$1 = 0, interruptedWork = $8373ca4214e15aed$var$workInProgress;
        for(; null !== interruptedWork;)$8373ca4214e15aed$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $8373ca4214e15aed$var$workInProgress = null;
    }
}
function $8373ca4214e15aed$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $8373ca4214e15aed$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $8373ca4214e15aed$var$pendingEffectsLanes = 0;
    $8373ca4214e15aed$var$resetWorkInProgressStack();
    $8373ca4214e15aed$var$workInProgressRoot = root;
    $8373ca4214e15aed$var$workInProgress = timeoutHandle = $8373ca4214e15aed$var$createWorkInProgress(root.current, null);
    $8373ca4214e15aed$var$workInProgressRootRenderLanes = lanes;
    $8373ca4214e15aed$var$workInProgressSuspendedReason = 0;
    $8373ca4214e15aed$var$workInProgressThrownValue = null;
    $8373ca4214e15aed$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $8373ca4214e15aed$var$workInProgressRootIsPrerendering = $8373ca4214e15aed$var$checkIfRootIsPrerendering(root, lanes);
    $8373ca4214e15aed$var$workInProgressRootDidAttachPingListener = !1;
    $8373ca4214e15aed$var$workInProgressSuspendedRetryLanes = $8373ca4214e15aed$var$workInProgressDeferredLane = $8373ca4214e15aed$var$workInProgressRootPingedLanes = $8373ca4214e15aed$var$workInProgressRootInterleavedUpdatedLanes = $8373ca4214e15aed$var$workInProgressRootSkippedLanes = $8373ca4214e15aed$var$workInProgressRootExitStatus = 0;
    $8373ca4214e15aed$var$workInProgressRootRecoverableErrors = $8373ca4214e15aed$var$workInProgressRootConcurrentErrors = null;
    $8373ca4214e15aed$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $8373ca4214e15aed$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $8373ca4214e15aed$var$entangledRenderLanes = lanes;
    $8373ca4214e15aed$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $8373ca4214e15aed$var$handleThrow(root, thrownValue) {
    $8373ca4214e15aed$var$currentlyRenderingFiber = null;
    $8373ca4214e15aed$var$ReactSharedInternals.H = $8373ca4214e15aed$var$ContextOnlyDispatcher;
    thrownValue === $8373ca4214e15aed$var$SuspenseException || thrownValue === $8373ca4214e15aed$var$SuspenseActionException ? (thrownValue = $8373ca4214e15aed$var$getSuspendedThenable(), $8373ca4214e15aed$var$workInProgressSuspendedReason = 3) : thrownValue === $8373ca4214e15aed$var$SuspenseyCommitException ? (thrownValue = $8373ca4214e15aed$var$getSuspendedThenable(), $8373ca4214e15aed$var$workInProgressSuspendedReason = 4) : $8373ca4214e15aed$var$workInProgressSuspendedReason = thrownValue === $8373ca4214e15aed$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $8373ca4214e15aed$var$workInProgressThrownValue = thrownValue;
    null === $8373ca4214e15aed$var$workInProgress && ($8373ca4214e15aed$var$workInProgressRootExitStatus = 1, $8373ca4214e15aed$var$logUncaughtError(root, $8373ca4214e15aed$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $8373ca4214e15aed$var$shouldRemainOnPreviousScreen() {
    var handler = $8373ca4214e15aed$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($8373ca4214e15aed$var$workInProgressRootRenderLanes & 4194048) === $8373ca4214e15aed$var$workInProgressRootRenderLanes ? null === $8373ca4214e15aed$var$shellBoundary ? !0 : !1 : ($8373ca4214e15aed$var$workInProgressRootRenderLanes & 62914560) === $8373ca4214e15aed$var$workInProgressRootRenderLanes || 0 !== ($8373ca4214e15aed$var$workInProgressRootRenderLanes & 536870912) ? handler === $8373ca4214e15aed$var$shellBoundary : !1;
}
function $8373ca4214e15aed$var$pushDispatcher() {
    var prevDispatcher = $8373ca4214e15aed$var$ReactSharedInternals.H;
    $8373ca4214e15aed$var$ReactSharedInternals.H = $8373ca4214e15aed$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $8373ca4214e15aed$var$ContextOnlyDispatcher : prevDispatcher;
}
function $8373ca4214e15aed$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $8373ca4214e15aed$var$ReactSharedInternals.A;
    $8373ca4214e15aed$var$ReactSharedInternals.A = $8373ca4214e15aed$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $8373ca4214e15aed$var$renderDidSuspendDelayIfPossible() {
    $8373ca4214e15aed$var$workInProgressRootExitStatus = 4;
    $8373ca4214e15aed$var$workInProgressRootDidSkipSuspendedSiblings || ($8373ca4214e15aed$var$workInProgressRootRenderLanes & 4194048) !== $8373ca4214e15aed$var$workInProgressRootRenderLanes && null !== $8373ca4214e15aed$var$suspenseHandlerStackCursor.current || ($8373ca4214e15aed$var$workInProgressRootIsPrerendering = !0);
    0 === ($8373ca4214e15aed$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($8373ca4214e15aed$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $8373ca4214e15aed$var$workInProgressRoot || $8373ca4214e15aed$var$markRootSuspended($8373ca4214e15aed$var$workInProgressRoot, $8373ca4214e15aed$var$workInProgressRootRenderLanes, $8373ca4214e15aed$var$workInProgressDeferredLane, !1);
}
function $8373ca4214e15aed$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $8373ca4214e15aed$var$executionContext;
    $8373ca4214e15aed$var$executionContext |= 2;
    var prevDispatcher = $8373ca4214e15aed$var$pushDispatcher(), prevAsyncDispatcher = $8373ca4214e15aed$var$pushAsyncDispatcher();
    if ($8373ca4214e15aed$var$workInProgressRoot !== root || $8373ca4214e15aed$var$workInProgressRootRenderLanes !== lanes) $8373ca4214e15aed$var$workInProgressTransitions = null, $8373ca4214e15aed$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $8373ca4214e15aed$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $8373ca4214e15aed$var$workInProgressSuspendedReason && null !== $8373ca4214e15aed$var$workInProgress) {
            var unitOfWork = $8373ca4214e15aed$var$workInProgress, thrownValue = $8373ca4214e15aed$var$workInProgressThrownValue;
            switch($8373ca4214e15aed$var$workInProgressSuspendedReason){
                case 8:
                    $8373ca4214e15aed$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $8373ca4214e15aed$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $8373ca4214e15aed$var$workInProgressSuspendedReason;
                    $8373ca4214e15aed$var$workInProgressSuspendedReason = 0;
                    $8373ca4214e15aed$var$workInProgressThrownValue = null;
                    $8373ca4214e15aed$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $8373ca4214e15aed$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $8373ca4214e15aed$var$workInProgressSuspendedReason, $8373ca4214e15aed$var$workInProgressSuspendedReason = 0, $8373ca4214e15aed$var$workInProgressThrownValue = null, $8373ca4214e15aed$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $8373ca4214e15aed$var$workLoopSync();
        exitStatus = $8373ca4214e15aed$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $8373ca4214e15aed$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $8373ca4214e15aed$var$lastContextDependency = $8373ca4214e15aed$var$currentlyRenderingFiber$1 = null;
    $8373ca4214e15aed$var$executionContext = prevExecutionContext;
    $8373ca4214e15aed$var$ReactSharedInternals.H = prevDispatcher;
    $8373ca4214e15aed$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $8373ca4214e15aed$var$workInProgress && ($8373ca4214e15aed$var$workInProgressRoot = null, $8373ca4214e15aed$var$workInProgressRootRenderLanes = 0, $8373ca4214e15aed$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $8373ca4214e15aed$var$workLoopSync() {
    for(; null !== $8373ca4214e15aed$var$workInProgress;)$8373ca4214e15aed$var$performUnitOfWork($8373ca4214e15aed$var$workInProgress);
}
function $8373ca4214e15aed$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $8373ca4214e15aed$var$executionContext;
    $8373ca4214e15aed$var$executionContext |= 2;
    var prevDispatcher = $8373ca4214e15aed$var$pushDispatcher(), prevAsyncDispatcher = $8373ca4214e15aed$var$pushAsyncDispatcher();
    $8373ca4214e15aed$var$workInProgressRoot !== root || $8373ca4214e15aed$var$workInProgressRootRenderLanes !== lanes ? ($8373ca4214e15aed$var$workInProgressTransitions = null, $8373ca4214e15aed$var$workInProgressRootRenderTargetTime = $8373ca4214e15aed$var$now() + 500, $8373ca4214e15aed$var$prepareFreshStack(root, lanes)) : $8373ca4214e15aed$var$workInProgressRootIsPrerendering = $8373ca4214e15aed$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $8373ca4214e15aed$var$workInProgressSuspendedReason && null !== $8373ca4214e15aed$var$workInProgress) {
            lanes = $8373ca4214e15aed$var$workInProgress;
            var thrownValue = $8373ca4214e15aed$var$workInProgressThrownValue;
            b: switch($8373ca4214e15aed$var$workInProgressSuspendedReason){
                case 1:
                    $8373ca4214e15aed$var$workInProgressSuspendedReason = 0;
                    $8373ca4214e15aed$var$workInProgressThrownValue = null;
                    $8373ca4214e15aed$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($8373ca4214e15aed$var$isThenableResolved(thrownValue)) {
                        $8373ca4214e15aed$var$workInProgressSuspendedReason = 0;
                        $8373ca4214e15aed$var$workInProgressThrownValue = null;
                        $8373ca4214e15aed$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $8373ca4214e15aed$var$workInProgressSuspendedReason && 9 !== $8373ca4214e15aed$var$workInProgressSuspendedReason || $8373ca4214e15aed$var$workInProgressRoot !== root || ($8373ca4214e15aed$var$workInProgressSuspendedReason = 7);
                        $8373ca4214e15aed$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $8373ca4214e15aed$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $8373ca4214e15aed$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $8373ca4214e15aed$var$isThenableResolved(thrownValue) ? ($8373ca4214e15aed$var$workInProgressSuspendedReason = 0, $8373ca4214e15aed$var$workInProgressThrownValue = null, $8373ca4214e15aed$var$replaySuspendedUnitOfWork(lanes)) : ($8373ca4214e15aed$var$workInProgressSuspendedReason = 0, $8373ca4214e15aed$var$workInProgressThrownValue = null, $8373ca4214e15aed$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($8373ca4214e15aed$var$workInProgress.tag){
                        case 26:
                            resource = $8373ca4214e15aed$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $8373ca4214e15aed$var$workInProgress;
                            if (resource ? $8373ca4214e15aed$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $8373ca4214e15aed$var$workInProgressSuspendedReason = 0;
                                $8373ca4214e15aed$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $8373ca4214e15aed$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($8373ca4214e15aed$var$workInProgress = returnFiber, $8373ca4214e15aed$var$completeUnitOfWork(returnFiber)) : $8373ca4214e15aed$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $8373ca4214e15aed$var$workInProgressSuspendedReason = 0;
                    $8373ca4214e15aed$var$workInProgressThrownValue = null;
                    $8373ca4214e15aed$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $8373ca4214e15aed$var$workInProgressSuspendedReason = 0;
                    $8373ca4214e15aed$var$workInProgressThrownValue = null;
                    $8373ca4214e15aed$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $8373ca4214e15aed$var$resetWorkInProgressStack();
                    $8373ca4214e15aed$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($8373ca4214e15aed$var$formatProdErrorMessage(462));
            }
        }
        $8373ca4214e15aed$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $8373ca4214e15aed$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $8373ca4214e15aed$var$lastContextDependency = $8373ca4214e15aed$var$currentlyRenderingFiber$1 = null;
    $8373ca4214e15aed$var$ReactSharedInternals.H = prevDispatcher;
    $8373ca4214e15aed$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $8373ca4214e15aed$var$executionContext = prevExecutionContext;
    if (null !== $8373ca4214e15aed$var$workInProgress) return 0;
    $8373ca4214e15aed$var$workInProgressRoot = null;
    $8373ca4214e15aed$var$workInProgressRootRenderLanes = 0;
    $8373ca4214e15aed$var$finishQueueingConcurrentUpdates();
    return $8373ca4214e15aed$var$workInProgressRootExitStatus;
}
function $8373ca4214e15aed$var$workLoopConcurrentByScheduler() {
    for(; null !== $8373ca4214e15aed$var$workInProgress && !$8373ca4214e15aed$var$shouldYield();)$8373ca4214e15aed$var$performUnitOfWork($8373ca4214e15aed$var$workInProgress);
}
function $8373ca4214e15aed$var$performUnitOfWork(unitOfWork) {
    var next = $8373ca4214e15aed$var$beginWork(unitOfWork.alternate, unitOfWork, $8373ca4214e15aed$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $8373ca4214e15aed$var$completeUnitOfWork(unitOfWork) : $8373ca4214e15aed$var$workInProgress = next;
}
function $8373ca4214e15aed$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $8373ca4214e15aed$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $8373ca4214e15aed$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $8373ca4214e15aed$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $8373ca4214e15aed$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $8373ca4214e15aed$var$resetHooksOnUnwind(next);
        default:
            $8373ca4214e15aed$var$unwindInterruptedWork(current, next), next = $8373ca4214e15aed$var$workInProgress = $8373ca4214e15aed$var$resetWorkInProgress(next, $8373ca4214e15aed$var$entangledRenderLanes), next = $8373ca4214e15aed$var$beginWork(current, next, $8373ca4214e15aed$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $8373ca4214e15aed$var$completeUnitOfWork(unitOfWork) : $8373ca4214e15aed$var$workInProgress = next;
}
function $8373ca4214e15aed$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $8373ca4214e15aed$var$lastContextDependency = $8373ca4214e15aed$var$currentlyRenderingFiber$1 = null;
    $8373ca4214e15aed$var$resetHooksOnUnwind(unitOfWork);
    $8373ca4214e15aed$var$thenableState$1 = null;
    $8373ca4214e15aed$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($8373ca4214e15aed$var$throwException(root, returnFiber, unitOfWork, thrownValue, $8373ca4214e15aed$var$workInProgressRootRenderLanes)) {
            $8373ca4214e15aed$var$workInProgressRootExitStatus = 1;
            $8373ca4214e15aed$var$logUncaughtError(root, $8373ca4214e15aed$var$createCapturedValueAtFiber(thrownValue, root.current));
            $8373ca4214e15aed$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $8373ca4214e15aed$var$workInProgress = returnFiber, error;
        $8373ca4214e15aed$var$workInProgressRootExitStatus = 1;
        $8373ca4214e15aed$var$logUncaughtError(root, $8373ca4214e15aed$var$createCapturedValueAtFiber(thrownValue, root.current));
        $8373ca4214e15aed$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($8373ca4214e15aed$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($8373ca4214e15aed$var$workInProgressRootIsPrerendering || 0 !== ($8373ca4214e15aed$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($8373ca4214e15aed$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $8373ca4214e15aed$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $8373ca4214e15aed$var$unwindUnitOfWork(unitOfWork, root);
    } else $8373ca4214e15aed$var$completeUnitOfWork(unitOfWork);
}
function $8373ca4214e15aed$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $8373ca4214e15aed$var$unwindUnitOfWork(completedWork, $8373ca4214e15aed$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $8373ca4214e15aed$var$completeWork(completedWork.alternate, completedWork, $8373ca4214e15aed$var$entangledRenderLanes);
        if (null !== next) {
            $8373ca4214e15aed$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $8373ca4214e15aed$var$workInProgress = completedWork;
            return;
        }
        $8373ca4214e15aed$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $8373ca4214e15aed$var$workInProgressRootExitStatus && ($8373ca4214e15aed$var$workInProgressRootExitStatus = 5);
}
function $8373ca4214e15aed$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $8373ca4214e15aed$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $8373ca4214e15aed$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $8373ca4214e15aed$var$workInProgress = unitOfWork;
            return;
        }
        $8373ca4214e15aed$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $8373ca4214e15aed$var$workInProgressRootExitStatus = 6;
    $8373ca4214e15aed$var$workInProgress = null;
}
function $8373ca4214e15aed$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $8373ca4214e15aed$var$flushPendingEffects();
    while (0 !== $8373ca4214e15aed$var$pendingEffectsStatus);
    if (0 !== ($8373ca4214e15aed$var$executionContext & 6)) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $8373ca4214e15aed$var$concurrentlyUpdatedLanes;
        $8373ca4214e15aed$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $8373ca4214e15aed$var$workInProgressRoot && ($8373ca4214e15aed$var$workInProgress = $8373ca4214e15aed$var$workInProgressRoot = null, $8373ca4214e15aed$var$workInProgressRootRenderLanes = 0);
        $8373ca4214e15aed$var$pendingFinishedWork = finishedWork;
        $8373ca4214e15aed$var$pendingEffectsRoot = root;
        $8373ca4214e15aed$var$pendingEffectsLanes = lanes;
        $8373ca4214e15aed$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $8373ca4214e15aed$var$pendingPassiveTransitions = transitions;
        $8373ca4214e15aed$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $8373ca4214e15aed$var$scheduleCallback$1($8373ca4214e15aed$var$NormalPriority$1, function() {
            $8373ca4214e15aed$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $8373ca4214e15aed$var$ReactSharedInternals.T;
            $8373ca4214e15aed$var$ReactSharedInternals.T = null;
            transitions = $8373ca4214e15aed$var$ReactDOMSharedInternals.p;
            $8373ca4214e15aed$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $8373ca4214e15aed$var$executionContext;
            $8373ca4214e15aed$var$executionContext |= 4;
            try {
                $8373ca4214e15aed$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $8373ca4214e15aed$var$executionContext = spawnedLane, $8373ca4214e15aed$var$ReactDOMSharedInternals.p = transitions, $8373ca4214e15aed$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $8373ca4214e15aed$var$pendingEffectsStatus = 1;
        $8373ca4214e15aed$var$flushMutationEffects();
        $8373ca4214e15aed$var$flushLayoutEffects();
        $8373ca4214e15aed$var$flushSpawnedWork();
    }
}
function $8373ca4214e15aed$var$flushMutationEffects() {
    if (1 === $8373ca4214e15aed$var$pendingEffectsStatus) {
        $8373ca4214e15aed$var$pendingEffectsStatus = 0;
        var root = $8373ca4214e15aed$var$pendingEffectsRoot, finishedWork = $8373ca4214e15aed$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $8373ca4214e15aed$var$ReactSharedInternals.T;
            $8373ca4214e15aed$var$ReactSharedInternals.T = null;
            var previousPriority = $8373ca4214e15aed$var$ReactDOMSharedInternals.p;
            $8373ca4214e15aed$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $8373ca4214e15aed$var$executionContext;
            $8373ca4214e15aed$var$executionContext |= 4;
            try {
                $8373ca4214e15aed$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $8373ca4214e15aed$var$selectionInformation, curFocusedElem = $8373ca4214e15aed$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $8373ca4214e15aed$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $8373ca4214e15aed$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $8373ca4214e15aed$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $8373ca4214e15aed$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $8373ca4214e15aed$var$_enabled = !!$8373ca4214e15aed$var$eventsEnabled;
                $8373ca4214e15aed$var$selectionInformation = $8373ca4214e15aed$var$eventsEnabled = null;
            } finally{
                $8373ca4214e15aed$var$executionContext = prevExecutionContext, $8373ca4214e15aed$var$ReactDOMSharedInternals.p = previousPriority, $8373ca4214e15aed$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $8373ca4214e15aed$var$pendingEffectsStatus = 2;
    }
}
function $8373ca4214e15aed$var$flushLayoutEffects() {
    if (2 === $8373ca4214e15aed$var$pendingEffectsStatus) {
        $8373ca4214e15aed$var$pendingEffectsStatus = 0;
        var root = $8373ca4214e15aed$var$pendingEffectsRoot, finishedWork = $8373ca4214e15aed$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $8373ca4214e15aed$var$ReactSharedInternals.T;
            $8373ca4214e15aed$var$ReactSharedInternals.T = null;
            var previousPriority = $8373ca4214e15aed$var$ReactDOMSharedInternals.p;
            $8373ca4214e15aed$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $8373ca4214e15aed$var$executionContext;
            $8373ca4214e15aed$var$executionContext |= 4;
            try {
                $8373ca4214e15aed$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $8373ca4214e15aed$var$executionContext = prevExecutionContext, $8373ca4214e15aed$var$ReactDOMSharedInternals.p = previousPriority, $8373ca4214e15aed$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $8373ca4214e15aed$var$pendingEffectsStatus = 3;
    }
}
function $8373ca4214e15aed$var$flushSpawnedWork() {
    if (4 === $8373ca4214e15aed$var$pendingEffectsStatus || 3 === $8373ca4214e15aed$var$pendingEffectsStatus) {
        $8373ca4214e15aed$var$pendingEffectsStatus = 0;
        $8373ca4214e15aed$var$requestPaint();
        var root = $8373ca4214e15aed$var$pendingEffectsRoot, finishedWork = $8373ca4214e15aed$var$pendingFinishedWork, lanes = $8373ca4214e15aed$var$pendingEffectsLanes, recoverableErrors = $8373ca4214e15aed$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $8373ca4214e15aed$var$pendingEffectsStatus = 5 : ($8373ca4214e15aed$var$pendingEffectsStatus = 0, $8373ca4214e15aed$var$pendingFinishedWork = $8373ca4214e15aed$var$pendingEffectsRoot = null, $8373ca4214e15aed$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($8373ca4214e15aed$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $8373ca4214e15aed$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($8373ca4214e15aed$var$injectedHook && "function" === typeof $8373ca4214e15aed$var$injectedHook.onCommitFiberRoot) try {
            $8373ca4214e15aed$var$injectedHook.onCommitFiberRoot($8373ca4214e15aed$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $8373ca4214e15aed$var$ReactSharedInternals.T;
            remainingLanes = $8373ca4214e15aed$var$ReactDOMSharedInternals.p;
            $8373ca4214e15aed$var$ReactDOMSharedInternals.p = 2;
            $8373ca4214e15aed$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $8373ca4214e15aed$var$ReactSharedInternals.T = finishedWork, $8373ca4214e15aed$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($8373ca4214e15aed$var$pendingEffectsLanes & 3) && $8373ca4214e15aed$var$flushPendingEffects();
        $8373ca4214e15aed$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $8373ca4214e15aed$var$rootWithNestedUpdates ? $8373ca4214e15aed$var$nestedUpdateCount++ : ($8373ca4214e15aed$var$nestedUpdateCount = 0, $8373ca4214e15aed$var$rootWithNestedUpdates = root) : $8373ca4214e15aed$var$nestedUpdateCount = 0;
        $8373ca4214e15aed$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $8373ca4214e15aed$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $8373ca4214e15aed$var$releaseCache(remainingLanes)));
}
function $8373ca4214e15aed$var$flushPendingEffects() {
    $8373ca4214e15aed$var$flushMutationEffects();
    $8373ca4214e15aed$var$flushLayoutEffects();
    $8373ca4214e15aed$var$flushSpawnedWork();
    return $8373ca4214e15aed$var$flushPassiveEffects();
}
function $8373ca4214e15aed$var$flushPassiveEffects() {
    if (5 !== $8373ca4214e15aed$var$pendingEffectsStatus) return !1;
    var root = $8373ca4214e15aed$var$pendingEffectsRoot, remainingLanes = $8373ca4214e15aed$var$pendingEffectsRemainingLanes;
    $8373ca4214e15aed$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $8373ca4214e15aed$var$lanesToEventPriority($8373ca4214e15aed$var$pendingEffectsLanes), prevTransition = $8373ca4214e15aed$var$ReactSharedInternals.T, previousPriority = $8373ca4214e15aed$var$ReactDOMSharedInternals.p;
    try {
        $8373ca4214e15aed$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $8373ca4214e15aed$var$ReactSharedInternals.T = null;
        renderPriority = $8373ca4214e15aed$var$pendingPassiveTransitions;
        $8373ca4214e15aed$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $8373ca4214e15aed$var$pendingEffectsRoot, lanes = $8373ca4214e15aed$var$pendingEffectsLanes;
        $8373ca4214e15aed$var$pendingEffectsStatus = 0;
        $8373ca4214e15aed$var$pendingFinishedWork = $8373ca4214e15aed$var$pendingEffectsRoot = null;
        $8373ca4214e15aed$var$pendingEffectsLanes = 0;
        if (0 !== ($8373ca4214e15aed$var$executionContext & 6)) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(331));
        var prevExecutionContext = $8373ca4214e15aed$var$executionContext;
        $8373ca4214e15aed$var$executionContext |= 4;
        $8373ca4214e15aed$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $8373ca4214e15aed$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $8373ca4214e15aed$var$executionContext = prevExecutionContext;
        $8373ca4214e15aed$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($8373ca4214e15aed$var$injectedHook && "function" === typeof $8373ca4214e15aed$var$injectedHook.onPostCommitFiberRoot) try {
            $8373ca4214e15aed$var$injectedHook.onPostCommitFiberRoot($8373ca4214e15aed$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $8373ca4214e15aed$var$ReactDOMSharedInternals.p = previousPriority, $8373ca4214e15aed$var$ReactSharedInternals.T = prevTransition, $8373ca4214e15aed$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $8373ca4214e15aed$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $8373ca4214e15aed$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $8373ca4214e15aed$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $8373ca4214e15aed$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($8373ca4214e15aed$var$markRootUpdated$1(rootFiber, 2), $8373ca4214e15aed$var$ensureRootIsScheduled(rootFiber));
}
function $8373ca4214e15aed$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $8373ca4214e15aed$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $8373ca4214e15aed$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $8373ca4214e15aed$var$legacyErrorBoundariesThatAlreadyFailed || !$8373ca4214e15aed$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $8373ca4214e15aed$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $8373ca4214e15aed$var$createClassErrorUpdate(2);
                instance = $8373ca4214e15aed$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($8373ca4214e15aed$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $8373ca4214e15aed$var$markRootUpdated$1(instance, 2), $8373ca4214e15aed$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $8373ca4214e15aed$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $8373ca4214e15aed$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($8373ca4214e15aed$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $8373ca4214e15aed$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $8373ca4214e15aed$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $8373ca4214e15aed$var$workInProgressRoot === root && ($8373ca4214e15aed$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $8373ca4214e15aed$var$workInProgressRootExitStatus || 3 === $8373ca4214e15aed$var$workInProgressRootExitStatus && ($8373ca4214e15aed$var$workInProgressRootRenderLanes & 62914560) === $8373ca4214e15aed$var$workInProgressRootRenderLanes && 300 > $8373ca4214e15aed$var$now() - $8373ca4214e15aed$var$globalMostRecentFallbackTime ? 0 === ($8373ca4214e15aed$var$executionContext & 2) && $8373ca4214e15aed$var$prepareFreshStack(root, 0) : $8373ca4214e15aed$var$workInProgressRootPingedLanes |= pingedLanes, $8373ca4214e15aed$var$workInProgressSuspendedRetryLanes === $8373ca4214e15aed$var$workInProgressRootRenderLanes && ($8373ca4214e15aed$var$workInProgressSuspendedRetryLanes = 0));
    $8373ca4214e15aed$var$ensureRootIsScheduled(root);
}
function $8373ca4214e15aed$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $8373ca4214e15aed$var$claimNextRetryLane());
    boundaryFiber = $8373ca4214e15aed$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($8373ca4214e15aed$var$markRootUpdated$1(boundaryFiber, retryLane), $8373ca4214e15aed$var$ensureRootIsScheduled(boundaryFiber));
}
function $8373ca4214e15aed$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $8373ca4214e15aed$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $8373ca4214e15aed$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($8373ca4214e15aed$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $8373ca4214e15aed$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $8373ca4214e15aed$var$scheduleCallback$1(priorityLevel, callback) {
    return $8373ca4214e15aed$var$scheduleCallback$3(priorityLevel, callback);
}
var $8373ca4214e15aed$var$firstScheduledRoot = null, $8373ca4214e15aed$var$lastScheduledRoot = null, $8373ca4214e15aed$var$didScheduleMicrotask = !1, $8373ca4214e15aed$var$mightHavePendingSyncWork = !1, $8373ca4214e15aed$var$isFlushingWork = !1, $8373ca4214e15aed$var$currentEventTransitionLane = 0;
function $8373ca4214e15aed$var$ensureRootIsScheduled(root) {
    root !== $8373ca4214e15aed$var$lastScheduledRoot && null === root.next && (null === $8373ca4214e15aed$var$lastScheduledRoot ? $8373ca4214e15aed$var$firstScheduledRoot = $8373ca4214e15aed$var$lastScheduledRoot = root : $8373ca4214e15aed$var$lastScheduledRoot = $8373ca4214e15aed$var$lastScheduledRoot.next = root);
    $8373ca4214e15aed$var$mightHavePendingSyncWork = !0;
    $8373ca4214e15aed$var$didScheduleMicrotask || ($8373ca4214e15aed$var$didScheduleMicrotask = !0, $8373ca4214e15aed$var$scheduleImmediateRootScheduleTask());
}
function $8373ca4214e15aed$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$8373ca4214e15aed$var$isFlushingWork && $8373ca4214e15aed$var$mightHavePendingSyncWork) {
        $8373ca4214e15aed$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $8373ca4214e15aed$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $8373ca4214e15aed$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $8373ca4214e15aed$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $8373ca4214e15aed$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $8373ca4214e15aed$var$getNextLanes(root$170, root$170 === $8373ca4214e15aed$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $8373ca4214e15aed$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $8373ca4214e15aed$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $8373ca4214e15aed$var$isFlushingWork = !1;
    }
}
function $8373ca4214e15aed$var$processRootScheduleInImmediateTask() {
    $8373ca4214e15aed$var$processRootScheduleInMicrotask();
}
function $8373ca4214e15aed$var$processRootScheduleInMicrotask() {
    $8373ca4214e15aed$var$mightHavePendingSyncWork = $8373ca4214e15aed$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $8373ca4214e15aed$var$currentEventTransitionLane && $8373ca4214e15aed$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $8373ca4214e15aed$var$currentEventTransitionLane);
    for(var currentTime = $8373ca4214e15aed$var$now(), prev = null, root = $8373ca4214e15aed$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $8373ca4214e15aed$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $8373ca4214e15aed$var$firstScheduledRoot = next : prev.next = next, null === next && ($8373ca4214e15aed$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $8373ca4214e15aed$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $8373ca4214e15aed$var$pendingEffectsStatus && 5 !== $8373ca4214e15aed$var$pendingEffectsStatus || $8373ca4214e15aed$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $8373ca4214e15aed$var$currentEventTransitionLane && ($8373ca4214e15aed$var$currentEventTransitionLane = 0);
}
function $8373ca4214e15aed$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $8373ca4214e15aed$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $8373ca4214e15aed$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $8373ca4214e15aed$var$workInProgressRoot;
    suspendedLanes = $8373ca4214e15aed$var$workInProgressRootRenderLanes;
    suspendedLanes = $8373ca4214e15aed$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $8373ca4214e15aed$var$workInProgressSuspendedReason || 9 === $8373ca4214e15aed$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $8373ca4214e15aed$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $8373ca4214e15aed$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $8373ca4214e15aed$var$cancelCallback$1(pingedLanes);
        switch($8373ca4214e15aed$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $8373ca4214e15aed$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $8373ca4214e15aed$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $8373ca4214e15aed$var$IdlePriority;
                break;
            default:
                suspendedLanes = $8373ca4214e15aed$var$NormalPriority$1;
        }
        pingedLanes = $8373ca4214e15aed$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $8373ca4214e15aed$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $8373ca4214e15aed$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $8373ca4214e15aed$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $8373ca4214e15aed$var$pendingEffectsStatus && 5 !== $8373ca4214e15aed$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($8373ca4214e15aed$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $8373ca4214e15aed$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $8373ca4214e15aed$var$getNextLanes(root, root === $8373ca4214e15aed$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $8373ca4214e15aed$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $8373ca4214e15aed$var$scheduleTaskForRootDuringMicrotask(root, $8373ca4214e15aed$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $8373ca4214e15aed$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $8373ca4214e15aed$var$performSyncWorkOnRoot(root, lanes) {
    if ($8373ca4214e15aed$var$flushPendingEffects()) return null;
    $8373ca4214e15aed$var$performWorkOnRoot(root, lanes, !0);
}
function $8373ca4214e15aed$var$scheduleImmediateRootScheduleTask() {
    $8373ca4214e15aed$var$scheduleMicrotask(function() {
        0 !== ($8373ca4214e15aed$var$executionContext & 6) ? $8373ca4214e15aed$var$scheduleCallback$3($8373ca4214e15aed$var$ImmediatePriority, $8373ca4214e15aed$var$processRootScheduleInImmediateTask) : $8373ca4214e15aed$var$processRootScheduleInMicrotask();
    });
}
function $8373ca4214e15aed$var$requestTransitionLane() {
    if (0 === $8373ca4214e15aed$var$currentEventTransitionLane) {
        var actionScopeLane = $8373ca4214e15aed$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $8373ca4214e15aed$var$nextTransitionUpdateLane, $8373ca4214e15aed$var$nextTransitionUpdateLane <<= 1, 0 === ($8373ca4214e15aed$var$nextTransitionUpdateLane & 261888) && ($8373ca4214e15aed$var$nextTransitionUpdateLane = 256));
        $8373ca4214e15aed$var$currentEventTransitionLane = actionScopeLane;
    }
    return $8373ca4214e15aed$var$currentEventTransitionLane;
}
function $8373ca4214e15aed$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $8373ca4214e15aed$var$sanitizeURL("" + actionProp);
}
function $8373ca4214e15aed$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $8373ca4214e15aed$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $8373ca4214e15aed$var$coerceFormActionProp((nativeEventTarget[$8373ca4214e15aed$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$8373ca4214e15aed$var$internalPropsKey] || null) ? $8373ca4214e15aed$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $8373ca4214e15aed$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $8373ca4214e15aed$var$currentEventTransitionLane) {
                                var formData = submitter ? $8373ca4214e15aed$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $8373ca4214e15aed$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $8373ca4214e15aed$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $8373ca4214e15aed$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $8373ca4214e15aed$var$i$jscomp$inline_1577 = 0; $8373ca4214e15aed$var$i$jscomp$inline_1577 < $8373ca4214e15aed$var$simpleEventPluginEvents.length; $8373ca4214e15aed$var$i$jscomp$inline_1577++){
    var $8373ca4214e15aed$var$eventName$jscomp$inline_1578 = $8373ca4214e15aed$var$simpleEventPluginEvents[$8373ca4214e15aed$var$i$jscomp$inline_1577], $8373ca4214e15aed$var$domEventName$jscomp$inline_1579 = $8373ca4214e15aed$var$eventName$jscomp$inline_1578.toLowerCase(), $8373ca4214e15aed$var$capitalizedEvent$jscomp$inline_1580 = $8373ca4214e15aed$var$eventName$jscomp$inline_1578[0].toUpperCase() + $8373ca4214e15aed$var$eventName$jscomp$inline_1578.slice(1);
    $8373ca4214e15aed$var$registerSimpleEvent($8373ca4214e15aed$var$domEventName$jscomp$inline_1579, "on" + $8373ca4214e15aed$var$capitalizedEvent$jscomp$inline_1580);
}
$8373ca4214e15aed$var$registerSimpleEvent($8373ca4214e15aed$var$ANIMATION_END, "onAnimationEnd");
$8373ca4214e15aed$var$registerSimpleEvent($8373ca4214e15aed$var$ANIMATION_ITERATION, "onAnimationIteration");
$8373ca4214e15aed$var$registerSimpleEvent($8373ca4214e15aed$var$ANIMATION_START, "onAnimationStart");
$8373ca4214e15aed$var$registerSimpleEvent("dblclick", "onDoubleClick");
$8373ca4214e15aed$var$registerSimpleEvent("focusin", "onFocus");
$8373ca4214e15aed$var$registerSimpleEvent("focusout", "onBlur");
$8373ca4214e15aed$var$registerSimpleEvent($8373ca4214e15aed$var$TRANSITION_RUN, "onTransitionRun");
$8373ca4214e15aed$var$registerSimpleEvent($8373ca4214e15aed$var$TRANSITION_START, "onTransitionStart");
$8373ca4214e15aed$var$registerSimpleEvent($8373ca4214e15aed$var$TRANSITION_CANCEL, "onTransitionCancel");
$8373ca4214e15aed$var$registerSimpleEvent($8373ca4214e15aed$var$TRANSITION_END, "onTransitionEnd");
$8373ca4214e15aed$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$8373ca4214e15aed$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$8373ca4214e15aed$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$8373ca4214e15aed$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$8373ca4214e15aed$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$8373ca4214e15aed$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$8373ca4214e15aed$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$8373ca4214e15aed$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$8373ca4214e15aed$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$8373ca4214e15aed$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $8373ca4214e15aed$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $8373ca4214e15aed$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($8373ca4214e15aed$var$mediaEventTypes));
function $8373ca4214e15aed$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $8373ca4214e15aed$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $8373ca4214e15aed$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $8373ca4214e15aed$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$8373ca4214e15aed$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$8373ca4214e15aed$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($8373ca4214e15aed$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $8373ca4214e15aed$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $8373ca4214e15aed$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $8373ca4214e15aed$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $8373ca4214e15aed$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$8373ca4214e15aed$var$listeningMarker]) {
        rootContainerElement[$8373ca4214e15aed$var$listeningMarker] = !0;
        $8373ca4214e15aed$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($8373ca4214e15aed$var$nonDelegatedEvents.has(domEventName) || $8373ca4214e15aed$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $8373ca4214e15aed$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$8373ca4214e15aed$var$listeningMarker] || (ownerDocument[$8373ca4214e15aed$var$listeningMarker] = !0, $8373ca4214e15aed$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $8373ca4214e15aed$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($8373ca4214e15aed$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $8373ca4214e15aed$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $8373ca4214e15aed$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $8373ca4214e15aed$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$8373ca4214e15aed$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $8373ca4214e15aed$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $8373ca4214e15aed$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $8373ca4214e15aed$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $8373ca4214e15aed$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $8373ca4214e15aed$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $8373ca4214e15aed$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $8373ca4214e15aed$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $8373ca4214e15aed$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $8373ca4214e15aed$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $8373ca4214e15aed$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $8373ca4214e15aed$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $8373ca4214e15aed$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $8373ca4214e15aed$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $8373ca4214e15aed$var$SyntheticTouchEvent;
                        break;
                    case $8373ca4214e15aed$var$ANIMATION_END:
                    case $8373ca4214e15aed$var$ANIMATION_ITERATION:
                    case $8373ca4214e15aed$var$ANIMATION_START:
                        SyntheticEventCtor = $8373ca4214e15aed$var$SyntheticAnimationEvent;
                        break;
                    case $8373ca4214e15aed$var$TRANSITION_END:
                        SyntheticEventCtor = $8373ca4214e15aed$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $8373ca4214e15aed$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $8373ca4214e15aed$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $8373ca4214e15aed$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $8373ca4214e15aed$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $8373ca4214e15aed$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $8373ca4214e15aed$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($8373ca4214e15aed$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $8373ca4214e15aed$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($8373ca4214e15aed$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$8373ca4214e15aed$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $8373ca4214e15aed$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $8373ca4214e15aed$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $8373ca4214e15aed$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $8373ca4214e15aed$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $8373ca4214e15aed$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $8373ca4214e15aed$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $8373ca4214e15aed$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $8373ca4214e15aed$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $8373ca4214e15aed$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $8373ca4214e15aed$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $8373ca4214e15aed$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $8373ca4214e15aed$var$getTargetInstForChangeEvent;
                else if ($8373ca4214e15aed$var$isTextInputElement(reactName)) {
                    if ($8373ca4214e15aed$var$isInputEventSupported) getTargetInstFunc = $8373ca4214e15aed$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $8373ca4214e15aed$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $8373ca4214e15aed$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $8373ca4214e15aed$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $8373ca4214e15aed$var$getTargetInstForChangeEvent) : getTargetInstFunc = $8373ca4214e15aed$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $8373ca4214e15aed$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $8373ca4214e15aed$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $8373ca4214e15aed$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($8373ca4214e15aed$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $8373ca4214e15aed$var$activeElement = handleEventFunc, $8373ca4214e15aed$var$activeElementInst = targetInst, $8373ca4214e15aed$var$lastSelection = null;
                    break;
                case "focusout":
                    $8373ca4214e15aed$var$lastSelection = $8373ca4214e15aed$var$activeElementInst = $8373ca4214e15aed$var$activeElement = null;
                    break;
                case "mousedown":
                    $8373ca4214e15aed$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $8373ca4214e15aed$var$mouseDown = !1;
                    $8373ca4214e15aed$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($8373ca4214e15aed$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $8373ca4214e15aed$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($8373ca4214e15aed$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $8373ca4214e15aed$var$isComposing ? $8373ca4214e15aed$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($8373ca4214e15aed$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($8373ca4214e15aed$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $8373ca4214e15aed$var$isComposing && (fallbackData = $8373ca4214e15aed$var$getData()) : ($8373ca4214e15aed$var$root = nativeEventTarget, $8373ca4214e15aed$var$startText = "value" in $8373ca4214e15aed$var$root ? $8373ca4214e15aed$var$root.value : $8373ca4214e15aed$var$root.textContent, $8373ca4214e15aed$var$isComposing = !0)), handleEventFunc = $8373ca4214e15aed$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $8373ca4214e15aed$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $8373ca4214e15aed$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $8373ca4214e15aed$var$canUseTextInputEvent ? $8373ca4214e15aed$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $8373ca4214e15aed$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $8373ca4214e15aed$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $8373ca4214e15aed$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $8373ca4214e15aed$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $8373ca4214e15aed$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $8373ca4214e15aed$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $8373ca4214e15aed$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $8373ca4214e15aed$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($8373ca4214e15aed$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $8373ca4214e15aed$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($8373ca4214e15aed$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $8373ca4214e15aed$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $8373ca4214e15aed$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $8373ca4214e15aed$var$getListener(target, registrationName), null != stateNode && listeners.unshift($8373ca4214e15aed$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $8373ca4214e15aed$var$getListener(target, registrationName), null != stateNode && listeners.push($8373ca4214e15aed$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $8373ca4214e15aed$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $8373ca4214e15aed$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $8373ca4214e15aed$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($8373ca4214e15aed$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($8373ca4214e15aed$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $8373ca4214e15aed$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $8373ca4214e15aed$var$normalizeMarkupForTextOrAttribute(clientText);
    return $8373ca4214e15aed$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $8373ca4214e15aed$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $8373ca4214e15aed$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $8373ca4214e15aed$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $8373ca4214e15aed$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $8373ca4214e15aed$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $8373ca4214e15aed$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $8373ca4214e15aed$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $8373ca4214e15aed$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $8373ca4214e15aed$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $8373ca4214e15aed$var$setProp(domElement, tag, "name", props.name, props, null), $8373ca4214e15aed$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $8373ca4214e15aed$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $8373ca4214e15aed$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($8373ca4214e15aed$var$setProp(domElement, tag, "encType", props.encType, props, null), $8373ca4214e15aed$var$setProp(domElement, tag, "method", props.method, props, null), $8373ca4214e15aed$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $8373ca4214e15aed$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $8373ca4214e15aed$var$noop$1);
            break;
        case "onScroll":
            null != value && $8373ca4214e15aed$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $8373ca4214e15aed$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $8373ca4214e15aed$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $8373ca4214e15aed$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $8373ca4214e15aed$var$listenToNonDelegatedEvent("toggle", domElement);
            $8373ca4214e15aed$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $8373ca4214e15aed$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $8373ca4214e15aed$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $8373ca4214e15aed$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $8373ca4214e15aed$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $8373ca4214e15aed$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $8373ca4214e15aed$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $8373ca4214e15aed$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $8373ca4214e15aed$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $8373ca4214e15aed$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $8373ca4214e15aed$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $8373ca4214e15aed$var$aliases.get(key) || key, $8373ca4214e15aed$var$setValueForAttribute(domElement, key, value);
    }
}
function $8373ca4214e15aed$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $8373ca4214e15aed$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $8373ca4214e15aed$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $8373ca4214e15aed$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $8373ca4214e15aed$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $8373ca4214e15aed$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $8373ca4214e15aed$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$8373ca4214e15aed$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$8373ca4214e15aed$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $8373ca4214e15aed$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $8373ca4214e15aed$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $8373ca4214e15aed$var$listenToNonDelegatedEvent("error", domElement);
            $8373ca4214e15aed$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($8373ca4214e15aed$var$formatProdErrorMessage(137, tag));
                    default:
                        $8373ca4214e15aed$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $8373ca4214e15aed$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $8373ca4214e15aed$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $8373ca4214e15aed$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $8373ca4214e15aed$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $8373ca4214e15aed$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $8373ca4214e15aed$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $8373ca4214e15aed$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $8373ca4214e15aed$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $8373ca4214e15aed$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $8373ca4214e15aed$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(91));
                    break;
                default:
                    $8373ca4214e15aed$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $8373ca4214e15aed$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $8373ca4214e15aed$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $8373ca4214e15aed$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $8373ca4214e15aed$var$listenToNonDelegatedEvent("toggle", domElement);
            $8373ca4214e15aed$var$listenToNonDelegatedEvent("cancel", domElement);
            $8373ca4214e15aed$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $8373ca4214e15aed$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $8373ca4214e15aed$var$mediaEventTypes.length; hasSrc++)$8373ca4214e15aed$var$listenToNonDelegatedEvent($8373ca4214e15aed$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $8373ca4214e15aed$var$listenToNonDelegatedEvent("error", domElement);
            $8373ca4214e15aed$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $8373ca4214e15aed$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $8373ca4214e15aed$var$listenToNonDelegatedEvent("error", domElement), $8373ca4214e15aed$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($8373ca4214e15aed$var$formatProdErrorMessage(137, tag));
                default:
                    $8373ca4214e15aed$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($8373ca4214e15aed$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $8373ca4214e15aed$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $8373ca4214e15aed$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $8373ca4214e15aed$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $8373ca4214e15aed$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $8373ca4214e15aed$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $8373ca4214e15aed$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $8373ca4214e15aed$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $8373ca4214e15aed$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $8373ca4214e15aed$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $8373ca4214e15aed$var$updateOptions(domElement, !!lastProps, tag, !0) : $8373ca4214e15aed$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $8373ca4214e15aed$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $8373ca4214e15aed$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $8373ca4214e15aed$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $8373ca4214e15aed$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $8373ca4214e15aed$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $8373ca4214e15aed$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $8373ca4214e15aed$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($8373ca4214e15aed$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $8373ca4214e15aed$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $8373ca4214e15aed$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $8373ca4214e15aed$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $8373ca4214e15aed$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $8373ca4214e15aed$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $8373ca4214e15aed$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $8373ca4214e15aed$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $8373ca4214e15aed$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $8373ca4214e15aed$var$eventsEnabled = null, $8373ca4214e15aed$var$selectionInformation = null;
function $8373ca4214e15aed$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $8373ca4214e15aed$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $8373ca4214e15aed$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $8373ca4214e15aed$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $8373ca4214e15aed$var$currentPopstateTransitionEvent = null;
function $8373ca4214e15aed$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $8373ca4214e15aed$var$currentPopstateTransitionEvent) return !1;
        $8373ca4214e15aed$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $8373ca4214e15aed$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $8373ca4214e15aed$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $8373ca4214e15aed$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $8373ca4214e15aed$var$localPromise = "function" === typeof Promise ? Promise : void 0, $8373ca4214e15aed$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $8373ca4214e15aed$var$localPromise ? function(callback) {
    return $8373ca4214e15aed$var$localPromise.resolve(null).then(callback).catch($8373ca4214e15aed$var$handleErrorInNextTick);
} : $8373ca4214e15aed$var$scheduleTimeout;
function $8373ca4214e15aed$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $8373ca4214e15aed$var$isSingletonScope(type) {
    return "head" === type;
}
function $8373ca4214e15aed$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $8373ca4214e15aed$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $8373ca4214e15aed$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $8373ca4214e15aed$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$8373ca4214e15aed$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $8373ca4214e15aed$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $8373ca4214e15aed$var$retryIfBlockedOn(hydrationInstance);
}
function $8373ca4214e15aed$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $8373ca4214e15aed$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $8373ca4214e15aed$var$clearContainerSparingly(node);
                $8373ca4214e15aed$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $8373ca4214e15aed$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$8373ca4214e15aed$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $8373ca4214e15aed$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $8373ca4214e15aed$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $8373ca4214e15aed$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $8373ca4214e15aed$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $8373ca4214e15aed$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $8373ca4214e15aed$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $8373ca4214e15aed$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $8373ca4214e15aed$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $8373ca4214e15aed$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $8373ca4214e15aed$var$previousHydratableOnEnteringScopedSingleton = null;
function $8373ca4214e15aed$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $8373ca4214e15aed$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $8373ca4214e15aed$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $8373ca4214e15aed$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $8373ca4214e15aed$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($8373ca4214e15aed$var$formatProdErrorMessage(451));
    }
}
function $8373ca4214e15aed$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $8373ca4214e15aed$var$detachDeletedInstance(instance);
}
var $8373ca4214e15aed$var$preloadPropsMap = new Map(), $8373ca4214e15aed$var$preconnectsSet = new Set();
function $8373ca4214e15aed$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $8373ca4214e15aed$var$previousDispatcher = $8373ca4214e15aed$var$ReactDOMSharedInternals.d;
$8373ca4214e15aed$var$ReactDOMSharedInternals.d = {
    f: $8373ca4214e15aed$var$flushSyncWork,
    r: $8373ca4214e15aed$var$requestFormReset,
    D: $8373ca4214e15aed$var$prefetchDNS,
    C: $8373ca4214e15aed$var$preconnect,
    L: $8373ca4214e15aed$var$preload,
    m: $8373ca4214e15aed$var$preloadModule,
    X: $8373ca4214e15aed$var$preinitScript,
    S: $8373ca4214e15aed$var$preinitStyle,
    M: $8373ca4214e15aed$var$preinitModuleScript
};
function $8373ca4214e15aed$var$flushSyncWork() {
    var previousWasRendering = $8373ca4214e15aed$var$previousDispatcher.f(), wasRendering = $8373ca4214e15aed$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $8373ca4214e15aed$var$requestFormReset(form) {
    var formInst = $8373ca4214e15aed$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $8373ca4214e15aed$var$requestFormReset$1(formInst) : $8373ca4214e15aed$var$previousDispatcher.r(form);
}
var $8373ca4214e15aed$var$globalDocument = "undefined" === typeof document ? null : document;
function $8373ca4214e15aed$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $8373ca4214e15aed$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $8373ca4214e15aed$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $8373ca4214e15aed$var$preconnectsSet.has(limitedEscapedHref) || ($8373ca4214e15aed$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $8373ca4214e15aed$var$setInitialProperties(href, "link", rel), $8373ca4214e15aed$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $8373ca4214e15aed$var$prefetchDNS(href) {
    $8373ca4214e15aed$var$previousDispatcher.D(href);
    $8373ca4214e15aed$var$preconnectAs("dns-prefetch", href, null);
}
function $8373ca4214e15aed$var$preconnect(href, crossOrigin) {
    $8373ca4214e15aed$var$previousDispatcher.C(href, crossOrigin);
    $8373ca4214e15aed$var$preconnectAs("preconnect", href, crossOrigin);
}
function $8373ca4214e15aed$var$preload(href, as, options) {
    $8373ca4214e15aed$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $8373ca4214e15aed$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $8373ca4214e15aed$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $8373ca4214e15aed$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $8373ca4214e15aed$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $8373ca4214e15aed$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $8373ca4214e15aed$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $8373ca4214e15aed$var$getStyleKey(href);
                break;
            case "script":
                key = $8373ca4214e15aed$var$getScriptKey(href);
        }
        $8373ca4214e15aed$var$preloadPropsMap.has(key) || (href = $8373ca4214e15aed$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $8373ca4214e15aed$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($8373ca4214e15aed$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($8373ca4214e15aed$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $8373ca4214e15aed$var$setInitialProperties(as, "link", href), $8373ca4214e15aed$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $8373ca4214e15aed$var$preloadModule(href, options) {
    $8373ca4214e15aed$var$previousDispatcher.m(href, options);
    var ownerDocument = $8373ca4214e15aed$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $8373ca4214e15aed$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $8373ca4214e15aed$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $8373ca4214e15aed$var$getScriptKey(href);
        }
        if (!$8373ca4214e15aed$var$preloadPropsMap.has(key) && (href = $8373ca4214e15aed$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $8373ca4214e15aed$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($8373ca4214e15aed$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $8373ca4214e15aed$var$setInitialProperties(as, "link", href);
            $8373ca4214e15aed$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $8373ca4214e15aed$var$preinitStyle(href, precedence, options) {
    $8373ca4214e15aed$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $8373ca4214e15aed$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $8373ca4214e15aed$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $8373ca4214e15aed$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($8373ca4214e15aed$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $8373ca4214e15aed$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $8373ca4214e15aed$var$preloadPropsMap.get(key)) && $8373ca4214e15aed$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $8373ca4214e15aed$var$markNodeAsHoistable(link);
                $8373ca4214e15aed$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $8373ca4214e15aed$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $8373ca4214e15aed$var$preinitScript(src, options) {
    $8373ca4214e15aed$var$previousDispatcher.X(src, options);
    var ownerDocument = $8373ca4214e15aed$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $8373ca4214e15aed$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $8373ca4214e15aed$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($8373ca4214e15aed$var$getScriptSelectorFromKey(key)), resource || (src = $8373ca4214e15aed$var$assign({
            src: src,
            async: !0
        }, options), (options = $8373ca4214e15aed$var$preloadPropsMap.get(key)) && $8373ca4214e15aed$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $8373ca4214e15aed$var$markNodeAsHoistable(resource), $8373ca4214e15aed$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $8373ca4214e15aed$var$preinitModuleScript(src, options) {
    $8373ca4214e15aed$var$previousDispatcher.M(src, options);
    var ownerDocument = $8373ca4214e15aed$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $8373ca4214e15aed$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $8373ca4214e15aed$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($8373ca4214e15aed$var$getScriptSelectorFromKey(key)), resource || (src = $8373ca4214e15aed$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $8373ca4214e15aed$var$preloadPropsMap.get(key)) && $8373ca4214e15aed$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $8373ca4214e15aed$var$markNodeAsHoistable(resource), $8373ca4214e15aed$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $8373ca4214e15aed$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $8373ca4214e15aed$var$rootInstanceStackCursor.current) ? $8373ca4214e15aed$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $8373ca4214e15aed$var$getStyleKey(pendingProps.href), pendingProps = $8373ca4214e15aed$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $8373ca4214e15aed$var$getStyleKey(pendingProps.href);
                var styles$243 = $8373ca4214e15aed$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($8373ca4214e15aed$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $8373ca4214e15aed$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $8373ca4214e15aed$var$preloadPropsMap.set(type, pendingProps), styles$243 || $8373ca4214e15aed$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $8373ca4214e15aed$var$getScriptKey(pendingProps), pendingProps = $8373ca4214e15aed$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($8373ca4214e15aed$var$formatProdErrorMessage(444, type));
    }
}
function $8373ca4214e15aed$var$getStyleKey(href) {
    return 'href="' + $8373ca4214e15aed$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $8373ca4214e15aed$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $8373ca4214e15aed$var$stylesheetPropsFromRawProps(rawProps) {
    return $8373ca4214e15aed$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $8373ca4214e15aed$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $8373ca4214e15aed$var$setInitialProperties(key, "link", preloadProps), $8373ca4214e15aed$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $8373ca4214e15aed$var$getScriptKey(src) {
    return '[src="' + $8373ca4214e15aed$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $8373ca4214e15aed$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $8373ca4214e15aed$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $8373ca4214e15aed$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $8373ca4214e15aed$var$markNodeAsHoistable(instance), instance;
            var styleProps = $8373ca4214e15aed$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $8373ca4214e15aed$var$markNodeAsHoistable(instance);
            $8373ca4214e15aed$var$setInitialProperties(instance, "style", styleProps);
            $8373ca4214e15aed$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $8373ca4214e15aed$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($8373ca4214e15aed$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $8373ca4214e15aed$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $8373ca4214e15aed$var$stylesheetPropsFromRawProps(props);
            (styleProps = $8373ca4214e15aed$var$preloadPropsMap.get(styleProps)) && $8373ca4214e15aed$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $8373ca4214e15aed$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $8373ca4214e15aed$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $8373ca4214e15aed$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $8373ca4214e15aed$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($8373ca4214e15aed$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $8373ca4214e15aed$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $8373ca4214e15aed$var$preloadPropsMap.get(instance$249)) instance = $8373ca4214e15aed$var$assign({}, props), $8373ca4214e15aed$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $8373ca4214e15aed$var$markNodeAsHoistable(styleProps);
            $8373ca4214e15aed$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($8373ca4214e15aed$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $8373ca4214e15aed$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $8373ca4214e15aed$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $8373ca4214e15aed$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $8373ca4214e15aed$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $8373ca4214e15aed$var$tagCaches = null;
function $8373ca4214e15aed$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $8373ca4214e15aed$var$tagCaches) {
        var cache = new Map();
        var caches = $8373ca4214e15aed$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $8373ca4214e15aed$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$8373ca4214e15aed$var$internalHoistableMarker] || node[$8373ca4214e15aed$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $8373ca4214e15aed$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $8373ca4214e15aed$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $8373ca4214e15aed$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $8373ca4214e15aed$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $8373ca4214e15aed$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($8373ca4214e15aed$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $8373ca4214e15aed$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $8373ca4214e15aed$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $8373ca4214e15aed$var$stylesheetPropsFromRawProps(props);
            (key = $8373ca4214e15aed$var$preloadPropsMap.get(key)) && $8373ca4214e15aed$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $8373ca4214e15aed$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $8373ca4214e15aed$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $8373ca4214e15aed$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $8373ca4214e15aed$var$estimatedBytesWithinLimit = 0;
function $8373ca4214e15aed$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $8373ca4214e15aed$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $8373ca4214e15aed$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $8373ca4214e15aed$var$estimatedBytesWithinLimit && ($8373ca4214e15aed$var$estimatedBytesWithinLimit = 62500 * $8373ca4214e15aed$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $8373ca4214e15aed$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $8373ca4214e15aed$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $8373ca4214e15aed$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $8373ca4214e15aed$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $8373ca4214e15aed$var$precedencesByRoot = null;
function $8373ca4214e15aed$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $8373ca4214e15aed$var$precedencesByRoot = new Map(), resources.forEach($8373ca4214e15aed$var$insertStylesheetIntoRoot, state), $8373ca4214e15aed$var$precedencesByRoot = null, $8373ca4214e15aed$var$onUnsuspend.call(state));
}
function $8373ca4214e15aed$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $8373ca4214e15aed$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $8373ca4214e15aed$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $8373ca4214e15aed$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $8373ca4214e15aed$var$HostTransitionContext = {
    $$typeof: $8373ca4214e15aed$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $8373ca4214e15aed$var$sharedNotPendingObject,
    _currentValue2: $8373ca4214e15aed$var$sharedNotPendingObject,
    _threadCount: 0
};
function $8373ca4214e15aed$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $8373ca4214e15aed$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $8373ca4214e15aed$var$createLaneMap(0);
    this.hiddenUpdates = $8373ca4214e15aed$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $8373ca4214e15aed$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $8373ca4214e15aed$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $8373ca4214e15aed$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $8373ca4214e15aed$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $8373ca4214e15aed$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $8373ca4214e15aed$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $8373ca4214e15aed$var$emptyContextObject;
    parentComponent = $8373ca4214e15aed$var$emptyContextObject;
    return parentComponent;
}
function $8373ca4214e15aed$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $8373ca4214e15aed$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $8373ca4214e15aed$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $8373ca4214e15aed$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($8373ca4214e15aed$var$scheduleUpdateOnFiber(element, rootFiber, lane), $8373ca4214e15aed$var$entangleTransitions(element, rootFiber, lane));
}
function $8373ca4214e15aed$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $8373ca4214e15aed$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $8373ca4214e15aed$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $8373ca4214e15aed$var$markRetryLaneImpl(fiber, retryLane);
}
function $8373ca4214e15aed$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $8373ca4214e15aed$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $8373ca4214e15aed$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $8373ca4214e15aed$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $8373ca4214e15aed$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $8373ca4214e15aed$var$requestUpdateLane();
        lane = $8373ca4214e15aed$var$getBumpedLaneForHydrationByLane(lane);
        var root = $8373ca4214e15aed$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $8373ca4214e15aed$var$scheduleUpdateOnFiber(root, fiber, lane);
        $8373ca4214e15aed$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $8373ca4214e15aed$var$_enabled = !0;
function $8373ca4214e15aed$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $8373ca4214e15aed$var$ReactSharedInternals.T;
    $8373ca4214e15aed$var$ReactSharedInternals.T = null;
    var previousPriority = $8373ca4214e15aed$var$ReactDOMSharedInternals.p;
    try {
        $8373ca4214e15aed$var$ReactDOMSharedInternals.p = 2, $8373ca4214e15aed$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $8373ca4214e15aed$var$ReactDOMSharedInternals.p = previousPriority, $8373ca4214e15aed$var$ReactSharedInternals.T = prevTransition;
    }
}
function $8373ca4214e15aed$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $8373ca4214e15aed$var$ReactSharedInternals.T;
    $8373ca4214e15aed$var$ReactSharedInternals.T = null;
    var previousPriority = $8373ca4214e15aed$var$ReactDOMSharedInternals.p;
    try {
        $8373ca4214e15aed$var$ReactDOMSharedInternals.p = 8, $8373ca4214e15aed$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $8373ca4214e15aed$var$ReactDOMSharedInternals.p = previousPriority, $8373ca4214e15aed$var$ReactSharedInternals.T = prevTransition;
    }
}
function $8373ca4214e15aed$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($8373ca4214e15aed$var$_enabled) {
        var blockedOn = $8373ca4214e15aed$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $8373ca4214e15aed$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $8373ca4214e15aed$var$return_targetInst, targetContainer), $8373ca4214e15aed$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($8373ca4214e15aed$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($8373ca4214e15aed$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $8373ca4214e15aed$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $8373ca4214e15aed$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $8373ca4214e15aed$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $8373ca4214e15aed$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $8373ca4214e15aed$var$ensureRootIsScheduled(fiber);
                                0 === ($8373ca4214e15aed$var$executionContext & 6) && ($8373ca4214e15aed$var$workInProgressRootRenderTargetTime = $8373ca4214e15aed$var$now() + 500, $8373ca4214e15aed$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $8373ca4214e15aed$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $8373ca4214e15aed$var$scheduleUpdateOnFiber(root, fiber, 2), $8373ca4214e15aed$var$flushSyncWork$1(), $8373ca4214e15aed$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $8373ca4214e15aed$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $8373ca4214e15aed$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $8373ca4214e15aed$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $8373ca4214e15aed$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $8373ca4214e15aed$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $8373ca4214e15aed$var$getEventTarget(nativeEvent);
    return $8373ca4214e15aed$var$findInstanceBlockingTarget(nativeEvent);
}
var $8373ca4214e15aed$var$return_targetInst = null;
function $8373ca4214e15aed$var$findInstanceBlockingTarget(targetNode) {
    $8373ca4214e15aed$var$return_targetInst = null;
    targetNode = $8373ca4214e15aed$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $8373ca4214e15aed$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $8373ca4214e15aed$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $8373ca4214e15aed$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $8373ca4214e15aed$var$return_targetInst = targetNode;
    return null;
}
function $8373ca4214e15aed$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($8373ca4214e15aed$var$getCurrentPriorityLevel()){
                case $8373ca4214e15aed$var$ImmediatePriority:
                    return 2;
                case $8373ca4214e15aed$var$UserBlockingPriority:
                    return 8;
                case $8373ca4214e15aed$var$NormalPriority$1:
                case $8373ca4214e15aed$var$LowPriority:
                    return 32;
                case $8373ca4214e15aed$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $8373ca4214e15aed$var$hasScheduledReplayAttempt = !1, $8373ca4214e15aed$var$queuedFocus = null, $8373ca4214e15aed$var$queuedDrag = null, $8373ca4214e15aed$var$queuedMouse = null, $8373ca4214e15aed$var$queuedPointers = new Map(), $8373ca4214e15aed$var$queuedPointerCaptures = new Map(), $8373ca4214e15aed$var$queuedExplicitHydrationTargets = [], $8373ca4214e15aed$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $8373ca4214e15aed$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $8373ca4214e15aed$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $8373ca4214e15aed$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $8373ca4214e15aed$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $8373ca4214e15aed$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $8373ca4214e15aed$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $8373ca4214e15aed$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $8373ca4214e15aed$var$getInstanceFromNode(blockedOn), null !== blockedOn && $8373ca4214e15aed$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $8373ca4214e15aed$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $8373ca4214e15aed$var$queuedFocus = $8373ca4214e15aed$var$accumulateOrCreateContinuousQueuedReplayableEvent($8373ca4214e15aed$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $8373ca4214e15aed$var$queuedDrag = $8373ca4214e15aed$var$accumulateOrCreateContinuousQueuedReplayableEvent($8373ca4214e15aed$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $8373ca4214e15aed$var$queuedMouse = $8373ca4214e15aed$var$accumulateOrCreateContinuousQueuedReplayableEvent($8373ca4214e15aed$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $8373ca4214e15aed$var$queuedPointers.set(pointerId, $8373ca4214e15aed$var$accumulateOrCreateContinuousQueuedReplayableEvent($8373ca4214e15aed$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $8373ca4214e15aed$var$queuedPointerCaptures.set(pointerId, $8373ca4214e15aed$var$accumulateOrCreateContinuousQueuedReplayableEvent($8373ca4214e15aed$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $8373ca4214e15aed$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $8373ca4214e15aed$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $8373ca4214e15aed$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $8373ca4214e15aed$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $8373ca4214e15aed$var$runWithPriority(queuedTarget.priority, function() {
                        $8373ca4214e15aed$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $8373ca4214e15aed$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $8373ca4214e15aed$var$runWithPriority(queuedTarget.priority, function() {
                        $8373ca4214e15aed$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $8373ca4214e15aed$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $8373ca4214e15aed$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $8373ca4214e15aed$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $8373ca4214e15aed$var$currentReplayingEvent = null;
        } else return targetContainers = $8373ca4214e15aed$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $8373ca4214e15aed$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $8373ca4214e15aed$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $8373ca4214e15aed$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $8373ca4214e15aed$var$replayUnblockedEvents() {
    $8373ca4214e15aed$var$hasScheduledReplayAttempt = !1;
    null !== $8373ca4214e15aed$var$queuedFocus && $8373ca4214e15aed$var$attemptReplayContinuousQueuedEvent($8373ca4214e15aed$var$queuedFocus) && ($8373ca4214e15aed$var$queuedFocus = null);
    null !== $8373ca4214e15aed$var$queuedDrag && $8373ca4214e15aed$var$attemptReplayContinuousQueuedEvent($8373ca4214e15aed$var$queuedDrag) && ($8373ca4214e15aed$var$queuedDrag = null);
    null !== $8373ca4214e15aed$var$queuedMouse && $8373ca4214e15aed$var$attemptReplayContinuousQueuedEvent($8373ca4214e15aed$var$queuedMouse) && ($8373ca4214e15aed$var$queuedMouse = null);
    $8373ca4214e15aed$var$queuedPointers.forEach($8373ca4214e15aed$var$attemptReplayContinuousQueuedEventInMap);
    $8373ca4214e15aed$var$queuedPointerCaptures.forEach($8373ca4214e15aed$var$attemptReplayContinuousQueuedEventInMap);
}
function $8373ca4214e15aed$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $8373ca4214e15aed$var$hasScheduledReplayAttempt || ($8373ca4214e15aed$var$hasScheduledReplayAttempt = !0, $1zXL0.unstable_scheduleCallback($1zXL0.unstable_NormalPriority, $8373ca4214e15aed$var$replayUnblockedEvents)));
}
var $8373ca4214e15aed$var$lastScheduledReplayQueue = null;
function $8373ca4214e15aed$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $8373ca4214e15aed$var$lastScheduledReplayQueue !== formReplayingQueue && ($8373ca4214e15aed$var$lastScheduledReplayQueue = formReplayingQueue, $1zXL0.unstable_scheduleCallback($1zXL0.unstable_NormalPriority, function() {
        $8373ca4214e15aed$var$lastScheduledReplayQueue === formReplayingQueue && ($8373ca4214e15aed$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $8373ca4214e15aed$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $8373ca4214e15aed$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $8373ca4214e15aed$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $8373ca4214e15aed$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $8373ca4214e15aed$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $8373ca4214e15aed$var$queuedFocus && $8373ca4214e15aed$var$scheduleCallbackIfUnblocked($8373ca4214e15aed$var$queuedFocus, unblocked);
    null !== $8373ca4214e15aed$var$queuedDrag && $8373ca4214e15aed$var$scheduleCallbackIfUnblocked($8373ca4214e15aed$var$queuedDrag, unblocked);
    null !== $8373ca4214e15aed$var$queuedMouse && $8373ca4214e15aed$var$scheduleCallbackIfUnblocked($8373ca4214e15aed$var$queuedMouse, unblocked);
    $8373ca4214e15aed$var$queuedPointers.forEach(unblock);
    $8373ca4214e15aed$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $8373ca4214e15aed$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $8373ca4214e15aed$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $8373ca4214e15aed$var$queuedExplicitHydrationTargets.length && (i = $8373ca4214e15aed$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$8373ca4214e15aed$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $8373ca4214e15aed$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$8373ca4214e15aed$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $8373ca4214e15aed$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$8373ca4214e15aed$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $8373ca4214e15aed$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $8373ca4214e15aed$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $8373ca4214e15aed$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $8373ca4214e15aed$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$8373ca4214e15aed$var$ReactDOMHydrationRoot.prototype.render = $8373ca4214e15aed$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(409));
    var current = root.current, lane = $8373ca4214e15aed$var$requestUpdateLane();
    $8373ca4214e15aed$var$updateContainerImpl(current, lane, children, root, null, null);
};
$8373ca4214e15aed$var$ReactDOMHydrationRoot.prototype.unmount = $8373ca4214e15aed$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $8373ca4214e15aed$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $8373ca4214e15aed$var$flushSyncWork$1();
        container[$8373ca4214e15aed$var$internalContainerInstanceKey] = null;
    }
};
function $8373ca4214e15aed$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$8373ca4214e15aed$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $8373ca4214e15aed$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $8373ca4214e15aed$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $8373ca4214e15aed$var$queuedExplicitHydrationTargets[i].priority; i++);
        $8373ca4214e15aed$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $8373ca4214e15aed$var$attemptExplicitHydrationTarget(target);
    }
};
var $8373ca4214e15aed$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $cQmXV.version;
if ("19.2.7" !== $8373ca4214e15aed$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(527, $8373ca4214e15aed$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.7"));
$8373ca4214e15aed$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($8373ca4214e15aed$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $8373ca4214e15aed$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $8373ca4214e15aed$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $8373ca4214e15aed$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.7",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $8373ca4214e15aed$var$ReactSharedInternals,
    reconcilerVersion: "19.2.7"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $8373ca4214e15aed$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$8373ca4214e15aed$var$hook$jscomp$inline_2348.isDisabled && $8373ca4214e15aed$var$hook$jscomp$inline_2348.supportsFiber) try {
        $8373ca4214e15aed$var$rendererID = $8373ca4214e15aed$var$hook$jscomp$inline_2348.inject($8373ca4214e15aed$var$internals$jscomp$inline_2347), $8373ca4214e15aed$var$injectedHook = $8373ca4214e15aed$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$8373ca4214e15aed$export$882461b6382ed46c = function(container, options) {
    if (!$8373ca4214e15aed$var$isValidContainer(container)) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $8373ca4214e15aed$var$defaultOnUncaughtError, onCaughtError = $8373ca4214e15aed$var$defaultOnCaughtError, onRecoverableError = $8373ca4214e15aed$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $8373ca4214e15aed$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $8373ca4214e15aed$var$defaultOnDefaultTransitionIndicator);
    container[$8373ca4214e15aed$var$internalContainerInstanceKey] = options.current;
    $8373ca4214e15aed$var$listenToAllSupportedEvents(container);
    return new $8373ca4214e15aed$var$ReactDOMRoot(options);
};
$8373ca4214e15aed$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$8373ca4214e15aed$var$isValidContainer(container)) throw Error($8373ca4214e15aed$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $8373ca4214e15aed$var$defaultOnUncaughtError, onCaughtError = $8373ca4214e15aed$var$defaultOnCaughtError, onRecoverableError = $8373ca4214e15aed$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $8373ca4214e15aed$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $8373ca4214e15aed$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $8373ca4214e15aed$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $8373ca4214e15aed$var$requestUpdateLane();
    isStrictMode = $8373ca4214e15aed$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $8373ca4214e15aed$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $8373ca4214e15aed$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $8373ca4214e15aed$var$markRootUpdated$1(initialChildren, options);
    $8373ca4214e15aed$var$ensureRootIsScheduled(initialChildren);
    container[$8373ca4214e15aed$var$internalContainerInstanceKey] = initialChildren.current;
    $8373ca4214e15aed$var$listenToAllSupportedEvents(container);
    return new $8373ca4214e15aed$var$ReactDOMHydrationRoot(initialChildren);
};
$8373ca4214e15aed$export$83d89fbfd8236492 = "19.2.7";

});
parcelRegister("1zXL0", function(module, exports) {
"use strict";

module.exports = (parcelRequire("1r3Y4"));

});
parcelRegister("1r3Y4", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $10bb63fb0ca7de0b$export$c4744153514ff05d; }, function (v) { return $10bb63fb0ca7de0b$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $10bb63fb0ca7de0b$export$3e506c1ccc9cc1a7; }, function (v) { return $10bb63fb0ca7de0b$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $10bb63fb0ca7de0b$export$e26fe2ed2fa76875; }, function (v) { return $10bb63fb0ca7de0b$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $10bb63fb0ca7de0b$export$502329bbf4b505b1; }, function (v) { return $10bb63fb0ca7de0b$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $10bb63fb0ca7de0b$export$6e3807111c4874c4; }, function (v) { return $10bb63fb0ca7de0b$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $10bb63fb0ca7de0b$export$c27134553091fb3a; }, function (v) { return $10bb63fb0ca7de0b$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $10bb63fb0ca7de0b$export$33ee1acdc04fd2a2; }, function (v) { return $10bb63fb0ca7de0b$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $10bb63fb0ca7de0b$export$b00a404bbd5edef2; }, function (v) { return $10bb63fb0ca7de0b$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $10bb63fb0ca7de0b$export$d66a1c1c77bd778b; }, function (v) { return $10bb63fb0ca7de0b$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $10bb63fb0ca7de0b$export$d3dfb8e4810cb555; }, function (v) { return $10bb63fb0ca7de0b$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $10bb63fb0ca7de0b$export$72fdf0e06517287b; }, function (v) { return $10bb63fb0ca7de0b$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $10bb63fb0ca7de0b$export$816d2913ae6b83b1; }, function (v) { return $10bb63fb0ca7de0b$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $10bb63fb0ca7de0b$export$61bcfe829111a1d0; }, function (v) { return $10bb63fb0ca7de0b$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $10bb63fb0ca7de0b$export$7ee8c9beb337bc3f; }, function (v) { return $10bb63fb0ca7de0b$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $10bb63fb0ca7de0b$export$b5836b71941fa3ed; }, function (v) { return $10bb63fb0ca7de0b$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $10bb63fb0ca7de0b$export$cf845f2c119da08a; }, function (v) { return $10bb63fb0ca7de0b$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $10bb63fb0ca7de0b$export$c4744153514ff05d;
var $10bb63fb0ca7de0b$export$3e506c1ccc9cc1a7;
var $10bb63fb0ca7de0b$export$e26fe2ed2fa76875;
var $10bb63fb0ca7de0b$export$502329bbf4b505b1;
var $10bb63fb0ca7de0b$export$6e3807111c4874c4;
var $10bb63fb0ca7de0b$export$c27134553091fb3a;
var $10bb63fb0ca7de0b$export$33ee1acdc04fd2a2;
var $10bb63fb0ca7de0b$export$b00a404bbd5edef2;
var $10bb63fb0ca7de0b$export$d66a1c1c77bd778b;
var $10bb63fb0ca7de0b$export$d3dfb8e4810cb555;
var $10bb63fb0ca7de0b$export$72fdf0e06517287b;
var $10bb63fb0ca7de0b$export$816d2913ae6b83b1;
var $10bb63fb0ca7de0b$export$61bcfe829111a1d0;
var $10bb63fb0ca7de0b$export$7ee8c9beb337bc3f;
var $10bb63fb0ca7de0b$export$b5836b71941fa3ed;
var $10bb63fb0ca7de0b$export$cf845f2c119da08a;
"use strict";
function $10bb63fb0ca7de0b$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $10bb63fb0ca7de0b$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $10bb63fb0ca7de0b$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $10bb63fb0ca7de0b$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $10bb63fb0ca7de0b$var$compare(left, last)) rightIndex < length && 0 > $10bb63fb0ca7de0b$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $10bb63fb0ca7de0b$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $10bb63fb0ca7de0b$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$10bb63fb0ca7de0b$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $10bb63fb0ca7de0b$var$localPerformance = performance;
    $10bb63fb0ca7de0b$export$c4744153514ff05d = function() {
        return $10bb63fb0ca7de0b$var$localPerformance.now();
    };
} else {
    var $10bb63fb0ca7de0b$var$localDate = Date, $10bb63fb0ca7de0b$var$initialTime = $10bb63fb0ca7de0b$var$localDate.now();
    $10bb63fb0ca7de0b$export$c4744153514ff05d = function() {
        return $10bb63fb0ca7de0b$var$localDate.now() - $10bb63fb0ca7de0b$var$initialTime;
    };
}
var $10bb63fb0ca7de0b$var$taskQueue = [], $10bb63fb0ca7de0b$var$timerQueue = [], $10bb63fb0ca7de0b$var$taskIdCounter = 1, $10bb63fb0ca7de0b$var$currentTask = null, $10bb63fb0ca7de0b$var$currentPriorityLevel = 3, $10bb63fb0ca7de0b$var$isPerformingWork = !1, $10bb63fb0ca7de0b$var$isHostCallbackScheduled = !1, $10bb63fb0ca7de0b$var$isHostTimeoutScheduled = !1, $10bb63fb0ca7de0b$var$needsPaint = !1, $10bb63fb0ca7de0b$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $10bb63fb0ca7de0b$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $10bb63fb0ca7de0b$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $10bb63fb0ca7de0b$var$advanceTimers(currentTime) {
    for(var timer = $10bb63fb0ca7de0b$var$peek($10bb63fb0ca7de0b$var$timerQueue); null !== timer;){
        if (null === timer.callback) $10bb63fb0ca7de0b$var$pop($10bb63fb0ca7de0b$var$timerQueue);
        else if (timer.startTime <= currentTime) $10bb63fb0ca7de0b$var$pop($10bb63fb0ca7de0b$var$timerQueue), timer.sortIndex = timer.expirationTime, $10bb63fb0ca7de0b$var$push($10bb63fb0ca7de0b$var$taskQueue, timer);
        else break;
        timer = $10bb63fb0ca7de0b$var$peek($10bb63fb0ca7de0b$var$timerQueue);
    }
}
function $10bb63fb0ca7de0b$var$handleTimeout(currentTime) {
    $10bb63fb0ca7de0b$var$isHostTimeoutScheduled = !1;
    $10bb63fb0ca7de0b$var$advanceTimers(currentTime);
    if (!$10bb63fb0ca7de0b$var$isHostCallbackScheduled) {
        if (null !== $10bb63fb0ca7de0b$var$peek($10bb63fb0ca7de0b$var$taskQueue)) $10bb63fb0ca7de0b$var$isHostCallbackScheduled = !0, $10bb63fb0ca7de0b$var$isMessageLoopRunning || ($10bb63fb0ca7de0b$var$isMessageLoopRunning = !0, $10bb63fb0ca7de0b$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $10bb63fb0ca7de0b$var$peek($10bb63fb0ca7de0b$var$timerQueue);
            null !== firstTimer && $10bb63fb0ca7de0b$var$requestHostTimeout($10bb63fb0ca7de0b$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $10bb63fb0ca7de0b$var$isMessageLoopRunning = !1, $10bb63fb0ca7de0b$var$taskTimeoutID = -1, $10bb63fb0ca7de0b$var$frameInterval = 5, $10bb63fb0ca7de0b$var$startTime = -1;
function $10bb63fb0ca7de0b$var$shouldYieldToHost() {
    return $10bb63fb0ca7de0b$var$needsPaint ? !0 : $10bb63fb0ca7de0b$export$c4744153514ff05d() - $10bb63fb0ca7de0b$var$startTime < $10bb63fb0ca7de0b$var$frameInterval ? !1 : !0;
}
function $10bb63fb0ca7de0b$var$performWorkUntilDeadline() {
    $10bb63fb0ca7de0b$var$needsPaint = !1;
    if ($10bb63fb0ca7de0b$var$isMessageLoopRunning) {
        var currentTime = $10bb63fb0ca7de0b$export$c4744153514ff05d();
        $10bb63fb0ca7de0b$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $10bb63fb0ca7de0b$var$isHostCallbackScheduled = !1;
                $10bb63fb0ca7de0b$var$isHostTimeoutScheduled && ($10bb63fb0ca7de0b$var$isHostTimeoutScheduled = !1, $10bb63fb0ca7de0b$var$localClearTimeout($10bb63fb0ca7de0b$var$taskTimeoutID), $10bb63fb0ca7de0b$var$taskTimeoutID = -1);
                $10bb63fb0ca7de0b$var$isPerformingWork = !0;
                var previousPriorityLevel = $10bb63fb0ca7de0b$var$currentPriorityLevel;
                try {
                    b: {
                        $10bb63fb0ca7de0b$var$advanceTimers(currentTime);
                        for($10bb63fb0ca7de0b$var$currentTask = $10bb63fb0ca7de0b$var$peek($10bb63fb0ca7de0b$var$taskQueue); null !== $10bb63fb0ca7de0b$var$currentTask && !($10bb63fb0ca7de0b$var$currentTask.expirationTime > currentTime && $10bb63fb0ca7de0b$var$shouldYieldToHost());){
                            var callback = $10bb63fb0ca7de0b$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $10bb63fb0ca7de0b$var$currentTask.callback = null;
                                $10bb63fb0ca7de0b$var$currentPriorityLevel = $10bb63fb0ca7de0b$var$currentTask.priorityLevel;
                                var continuationCallback = callback($10bb63fb0ca7de0b$var$currentTask.expirationTime <= currentTime);
                                currentTime = $10bb63fb0ca7de0b$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $10bb63fb0ca7de0b$var$currentTask.callback = continuationCallback;
                                    $10bb63fb0ca7de0b$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $10bb63fb0ca7de0b$var$currentTask === $10bb63fb0ca7de0b$var$peek($10bb63fb0ca7de0b$var$taskQueue) && $10bb63fb0ca7de0b$var$pop($10bb63fb0ca7de0b$var$taskQueue);
                                $10bb63fb0ca7de0b$var$advanceTimers(currentTime);
                            } else $10bb63fb0ca7de0b$var$pop($10bb63fb0ca7de0b$var$taskQueue);
                            $10bb63fb0ca7de0b$var$currentTask = $10bb63fb0ca7de0b$var$peek($10bb63fb0ca7de0b$var$taskQueue);
                        }
                        if (null !== $10bb63fb0ca7de0b$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $10bb63fb0ca7de0b$var$peek($10bb63fb0ca7de0b$var$timerQueue);
                            null !== firstTimer && $10bb63fb0ca7de0b$var$requestHostTimeout($10bb63fb0ca7de0b$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $10bb63fb0ca7de0b$var$currentTask = null, $10bb63fb0ca7de0b$var$currentPriorityLevel = previousPriorityLevel, $10bb63fb0ca7de0b$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $10bb63fb0ca7de0b$var$schedulePerformWorkUntilDeadline() : $10bb63fb0ca7de0b$var$isMessageLoopRunning = !1;
        }
    }
}
var $10bb63fb0ca7de0b$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $10bb63fb0ca7de0b$var$localSetImmediate) $10bb63fb0ca7de0b$var$schedulePerformWorkUntilDeadline = function() {
    $10bb63fb0ca7de0b$var$localSetImmediate($10bb63fb0ca7de0b$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $10bb63fb0ca7de0b$var$channel = new MessageChannel(), $10bb63fb0ca7de0b$var$port = $10bb63fb0ca7de0b$var$channel.port2;
    $10bb63fb0ca7de0b$var$channel.port1.onmessage = $10bb63fb0ca7de0b$var$performWorkUntilDeadline;
    $10bb63fb0ca7de0b$var$schedulePerformWorkUntilDeadline = function() {
        $10bb63fb0ca7de0b$var$port.postMessage(null);
    };
} else $10bb63fb0ca7de0b$var$schedulePerformWorkUntilDeadline = function() {
    $10bb63fb0ca7de0b$var$localSetTimeout($10bb63fb0ca7de0b$var$performWorkUntilDeadline, 0);
};
function $10bb63fb0ca7de0b$var$requestHostTimeout(callback, ms) {
    $10bb63fb0ca7de0b$var$taskTimeoutID = $10bb63fb0ca7de0b$var$localSetTimeout(function() {
        callback($10bb63fb0ca7de0b$export$c4744153514ff05d());
    }, ms);
}
$10bb63fb0ca7de0b$export$3e506c1ccc9cc1a7 = 5;
$10bb63fb0ca7de0b$export$e26fe2ed2fa76875 = 1;
$10bb63fb0ca7de0b$export$502329bbf4b505b1 = 4;
$10bb63fb0ca7de0b$export$6e3807111c4874c4 = 3;
$10bb63fb0ca7de0b$export$c27134553091fb3a = null;
$10bb63fb0ca7de0b$export$33ee1acdc04fd2a2 = 2;
$10bb63fb0ca7de0b$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$10bb63fb0ca7de0b$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $10bb63fb0ca7de0b$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$10bb63fb0ca7de0b$export$d3dfb8e4810cb555 = function() {
    return $10bb63fb0ca7de0b$var$currentPriorityLevel;
};
$10bb63fb0ca7de0b$export$72fdf0e06517287b = function(eventHandler) {
    switch($10bb63fb0ca7de0b$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $10bb63fb0ca7de0b$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $10bb63fb0ca7de0b$var$currentPriorityLevel;
    $10bb63fb0ca7de0b$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $10bb63fb0ca7de0b$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$10bb63fb0ca7de0b$export$816d2913ae6b83b1 = function() {
    $10bb63fb0ca7de0b$var$needsPaint = !0;
};
$10bb63fb0ca7de0b$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $10bb63fb0ca7de0b$var$currentPriorityLevel;
    $10bb63fb0ca7de0b$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $10bb63fb0ca7de0b$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$10bb63fb0ca7de0b$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $10bb63fb0ca7de0b$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $10bb63fb0ca7de0b$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $10bb63fb0ca7de0b$var$push($10bb63fb0ca7de0b$var$timerQueue, priorityLevel), null === $10bb63fb0ca7de0b$var$peek($10bb63fb0ca7de0b$var$taskQueue) && priorityLevel === $10bb63fb0ca7de0b$var$peek($10bb63fb0ca7de0b$var$timerQueue) && ($10bb63fb0ca7de0b$var$isHostTimeoutScheduled ? ($10bb63fb0ca7de0b$var$localClearTimeout($10bb63fb0ca7de0b$var$taskTimeoutID), $10bb63fb0ca7de0b$var$taskTimeoutID = -1) : $10bb63fb0ca7de0b$var$isHostTimeoutScheduled = !0, $10bb63fb0ca7de0b$var$requestHostTimeout($10bb63fb0ca7de0b$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $10bb63fb0ca7de0b$var$push($10bb63fb0ca7de0b$var$taskQueue, priorityLevel), $10bb63fb0ca7de0b$var$isHostCallbackScheduled || $10bb63fb0ca7de0b$var$isPerformingWork || ($10bb63fb0ca7de0b$var$isHostCallbackScheduled = !0, $10bb63fb0ca7de0b$var$isMessageLoopRunning || ($10bb63fb0ca7de0b$var$isMessageLoopRunning = !0, $10bb63fb0ca7de0b$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$10bb63fb0ca7de0b$export$b5836b71941fa3ed = $10bb63fb0ca7de0b$var$shouldYieldToHost;
$10bb63fb0ca7de0b$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $10bb63fb0ca7de0b$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $10bb63fb0ca7de0b$var$currentPriorityLevel;
        $10bb63fb0ca7de0b$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $10bb63fb0ca7de0b$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("3h5eW", function(module, exports) {
"use strict";
function $2627062c24ff394e$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($2627062c24ff394e$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$2627062c24ff394e$var$checkDCE();

module.exports = (parcelRequire("gmKll"));

});
parcelRegister("gmKll", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $bea2a63a093f15da$export$69ce8ef3fe5cead0; }, function (v) { return $bea2a63a093f15da$export$69ce8ef3fe5cead0 = v; });
$parcel$export(module.exports, "createPortal", function () { return $bea2a63a093f15da$export$d39a5bbd09211389; }, function (v) { return $bea2a63a093f15da$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "flushSync", function () { return $bea2a63a093f15da$export$cd75ccfd720a3cd4; }, function (v) { return $bea2a63a093f15da$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "preconnect", function () { return $bea2a63a093f15da$export$a0816fa17a9e79be; }, function (v) { return $bea2a63a093f15da$export$a0816fa17a9e79be = v; });
$parcel$export(module.exports, "prefetchDNS", function () { return $bea2a63a093f15da$export$7292efcadded39f3; }, function (v) { return $bea2a63a093f15da$export$7292efcadded39f3 = v; });
$parcel$export(module.exports, "preinit", function () { return $bea2a63a093f15da$export$da407abadb9b8f86; }, function (v) { return $bea2a63a093f15da$export$da407abadb9b8f86 = v; });
$parcel$export(module.exports, "preinitModule", function () { return $bea2a63a093f15da$export$314cfea32580671c; }, function (v) { return $bea2a63a093f15da$export$314cfea32580671c = v; });
$parcel$export(module.exports, "preload", function () { return $bea2a63a093f15da$export$513ccb98c53b8039; }, function (v) { return $bea2a63a093f15da$export$513ccb98c53b8039 = v; });
$parcel$export(module.exports, "preloadModule", function () { return $bea2a63a093f15da$export$dbca993bc2d264a; }, function (v) { return $bea2a63a093f15da$export$dbca993bc2d264a = v; });
$parcel$export(module.exports, "requestFormReset", function () { return $bea2a63a093f15da$export$4797a8006f0655d0; }, function (v) { return $bea2a63a093f15da$export$4797a8006f0655d0 = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $bea2a63a093f15da$export$c78a37762a8d58e1; }, function (v) { return $bea2a63a093f15da$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "useFormState", function () { return $bea2a63a093f15da$export$606f11b2eb45ecc6; }, function (v) { return $bea2a63a093f15da$export$606f11b2eb45ecc6 = v; });
$parcel$export(module.exports, "useFormStatus", function () { return $bea2a63a093f15da$export$f7e8a0bf92324b1e; }, function (v) { return $bea2a63a093f15da$export$f7e8a0bf92324b1e = v; });
$parcel$export(module.exports, "version", function () { return $bea2a63a093f15da$export$83d89fbfd8236492; }, function (v) { return $bea2a63a093f15da$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bea2a63a093f15da$export$69ce8ef3fe5cead0;
var $bea2a63a093f15da$export$d39a5bbd09211389;
var $bea2a63a093f15da$export$cd75ccfd720a3cd4;
var $bea2a63a093f15da$export$a0816fa17a9e79be;
var $bea2a63a093f15da$export$7292efcadded39f3;
var $bea2a63a093f15da$export$da407abadb9b8f86;
var $bea2a63a093f15da$export$314cfea32580671c;
var $bea2a63a093f15da$export$513ccb98c53b8039;
var $bea2a63a093f15da$export$dbca993bc2d264a;
var $bea2a63a093f15da$export$4797a8006f0655d0;
var $bea2a63a093f15da$export$c78a37762a8d58e1;
var $bea2a63a093f15da$export$606f11b2eb45ecc6;
var $bea2a63a093f15da$export$f7e8a0bf92324b1e;
var $bea2a63a093f15da$export$83d89fbfd8236492;
"use strict";

var $cQmXV = parcelRequire("cQmXV");
function $bea2a63a093f15da$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $bea2a63a093f15da$var$noop() {}
var $bea2a63a093f15da$var$Internals = {
    d: {
        f: $bea2a63a093f15da$var$noop,
        r: function() {
            throw Error($bea2a63a093f15da$var$formatProdErrorMessage(522));
        },
        D: $bea2a63a093f15da$var$noop,
        C: $bea2a63a093f15da$var$noop,
        L: $bea2a63a093f15da$var$noop,
        m: $bea2a63a093f15da$var$noop,
        X: $bea2a63a093f15da$var$noop,
        S: $bea2a63a093f15da$var$noop,
        M: $bea2a63a093f15da$var$noop
    },
    p: 0,
    findDOMNode: null
}, $bea2a63a093f15da$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $bea2a63a093f15da$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $bea2a63a093f15da$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $bea2a63a093f15da$var$ReactSharedInternals = $cQmXV.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $bea2a63a093f15da$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$bea2a63a093f15da$export$69ce8ef3fe5cead0 = $bea2a63a093f15da$var$Internals;
$bea2a63a093f15da$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($bea2a63a093f15da$var$formatProdErrorMessage(299));
    return $bea2a63a093f15da$var$createPortal$1(children, container, null, key);
};
$bea2a63a093f15da$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $bea2a63a093f15da$var$ReactSharedInternals.T, previousUpdatePriority = $bea2a63a093f15da$var$Internals.p;
    try {
        if ($bea2a63a093f15da$var$ReactSharedInternals.T = null, $bea2a63a093f15da$var$Internals.p = 2, fn) return fn();
    } finally{
        $bea2a63a093f15da$var$ReactSharedInternals.T = previousTransition, $bea2a63a093f15da$var$Internals.p = previousUpdatePriority, $bea2a63a093f15da$var$Internals.d.f();
    }
};
$bea2a63a093f15da$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $bea2a63a093f15da$var$Internals.d.C(href, options));
};
$bea2a63a093f15da$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $bea2a63a093f15da$var$Internals.d.D(href);
};
$bea2a63a093f15da$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $bea2a63a093f15da$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $bea2a63a093f15da$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $bea2a63a093f15da$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$bea2a63a093f15da$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $bea2a63a093f15da$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $bea2a63a093f15da$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $bea2a63a093f15da$var$Internals.d.M(href);
    }
};
$bea2a63a093f15da$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $bea2a63a093f15da$var$getCrossOriginStringAs(as, options.crossOrigin);
        $bea2a63a093f15da$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$bea2a63a093f15da$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $bea2a63a093f15da$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $bea2a63a093f15da$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $bea2a63a093f15da$var$Internals.d.m(href);
    }
};
$bea2a63a093f15da$export$4797a8006f0655d0 = function(form) {
    $bea2a63a093f15da$var$Internals.d.r(form);
};
$bea2a63a093f15da$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$bea2a63a093f15da$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $bea2a63a093f15da$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$bea2a63a093f15da$export$f7e8a0bf92324b1e = function() {
    return $bea2a63a093f15da$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$bea2a63a093f15da$export$83d89fbfd8236492 = "19.2.7";

});



parcelRegister("kaDml", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $eaf345c99ac31b1a$export$a7c73072b1a182ae; }, function (v) { return $eaf345c99ac31b1a$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $eaf345c99ac31b1a$export$9f27bc3417b4524d; }, function (v) { return $eaf345c99ac31b1a$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $eaf345c99ac31b1a$export$db77ccec0bb4ccac; }, function (v) { return $eaf345c99ac31b1a$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $eaf345c99ac31b1a$export$8392c0c9d3dcbd35; }, function (v) { return $eaf345c99ac31b1a$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $eaf345c99ac31b1a$export$ffb0004e005737fa; }, function (v) { return $eaf345c99ac31b1a$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $eaf345c99ac31b1a$export$b624eff549462981; }, function (v) { return $eaf345c99ac31b1a$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $eaf345c99ac31b1a$export$7897aa7841a5380c; }, function (v) { return $eaf345c99ac31b1a$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $eaf345c99ac31b1a$export$602eac185826482c; }, function (v) { return $eaf345c99ac31b1a$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $eaf345c99ac31b1a$export$e2c29f18771995cb; }, function (v) { return $eaf345c99ac31b1a$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $eaf345c99ac31b1a$export$5f8d39834fd61797; }, function (v) { return $eaf345c99ac31b1a$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $eaf345c99ac31b1a$export$74bf444e3cd11ea5; }, function (v) { return $eaf345c99ac31b1a$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $eaf345c99ac31b1a$export$998bcd577473dd93; }, function (v) { return $eaf345c99ac31b1a$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $eaf345c99ac31b1a$export$b706b080d889d2c9; }, function (v) { return $eaf345c99ac31b1a$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $eaf345c99ac31b1a$export$5be5a87408f70ddc; }, function (v) { return $eaf345c99ac31b1a$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $eaf345c99ac31b1a$export$45a5e7f76e0caa8d; }, function (v) { return $eaf345c99ac31b1a$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $eaf345c99ac31b1a$export$455c2e768291efa6; }, function (v) { return $eaf345c99ac31b1a$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $eaf345c99ac31b1a$export$9522e17588c12572; }, function (v) { return $eaf345c99ac31b1a$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $eaf345c99ac31b1a$export$2110ac352bb060b9; }, function (v) { return $eaf345c99ac31b1a$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $eaf345c99ac31b1a$export$56885ab8b9c456ab; }, function (v) { return $eaf345c99ac31b1a$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $eaf345c99ac31b1a$export$d927fcb6adf8f9de; }, function (v) { return $eaf345c99ac31b1a$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $eaf345c99ac31b1a$export$b82d16f27459e05a; }, function (v) { return $eaf345c99ac31b1a$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $eaf345c99ac31b1a$export$522c17b4f5e123e8; }, function (v) { return $eaf345c99ac31b1a$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $eaf345c99ac31b1a$export$1aabd8a0274ecfd6; }, function (v) { return $eaf345c99ac31b1a$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $eaf345c99ac31b1a$export$3d6c20d97e46b957; }, function (v) { return $eaf345c99ac31b1a$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $eaf345c99ac31b1a$export$9b621391a187a31a; }, function (v) { return $eaf345c99ac31b1a$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $eaf345c99ac31b1a$export$f5bbd400c2f4426f; }, function (v) { return $eaf345c99ac31b1a$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $eaf345c99ac31b1a$export$a7c73072b1a182ae;
var $eaf345c99ac31b1a$export$9f27bc3417b4524d;
var $eaf345c99ac31b1a$export$db77ccec0bb4ccac;
var $eaf345c99ac31b1a$export$8392c0c9d3dcbd35;
var $eaf345c99ac31b1a$export$ffb0004e005737fa;
var $eaf345c99ac31b1a$export$b624eff549462981;
var $eaf345c99ac31b1a$export$7897aa7841a5380c;
var $eaf345c99ac31b1a$export$602eac185826482c;
var $eaf345c99ac31b1a$export$e2c29f18771995cb;
var $eaf345c99ac31b1a$export$5f8d39834fd61797;
var $eaf345c99ac31b1a$export$74bf444e3cd11ea5;
var $eaf345c99ac31b1a$export$998bcd577473dd93;
var $eaf345c99ac31b1a$export$b706b080d889d2c9;
var $eaf345c99ac31b1a$export$5be5a87408f70ddc;
var $eaf345c99ac31b1a$export$45a5e7f76e0caa8d;
var $eaf345c99ac31b1a$export$455c2e768291efa6;
var $eaf345c99ac31b1a$export$9522e17588c12572;
var $eaf345c99ac31b1a$export$2110ac352bb060b9;
var $eaf345c99ac31b1a$export$56885ab8b9c456ab;
var $eaf345c99ac31b1a$export$d927fcb6adf8f9de;
var $eaf345c99ac31b1a$export$b82d16f27459e05a;
var $eaf345c99ac31b1a$export$522c17b4f5e123e8;
var $eaf345c99ac31b1a$export$1aabd8a0274ecfd6;
var $eaf345c99ac31b1a$export$3d6c20d97e46b957;
var $eaf345c99ac31b1a$export$9b621391a187a31a;
var $eaf345c99ac31b1a$export$f5bbd400c2f4426f;
"use strict";
var $eaf345c99ac31b1a$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $eaf345c99ac31b1a$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $eaf345c99ac31b1a$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $eaf345c99ac31b1a$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $eaf345c99ac31b1a$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $eaf345c99ac31b1a$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $eaf345c99ac31b1a$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $eaf345c99ac31b1a$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $eaf345c99ac31b1a$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $eaf345c99ac31b1a$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $eaf345c99ac31b1a$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $eaf345c99ac31b1a$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $eaf345c99ac31b1a$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $eaf345c99ac31b1a$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $eaf345c99ac31b1a$var$typeOf(object) {
    if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $eaf345c99ac31b1a$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $eaf345c99ac31b1a$var$REACT_FRAGMENT_TYPE:
                    case $eaf345c99ac31b1a$var$REACT_PROFILER_TYPE:
                    case $eaf345c99ac31b1a$var$REACT_STRICT_MODE_TYPE:
                    case $eaf345c99ac31b1a$var$REACT_SUSPENSE_TYPE:
                    case $eaf345c99ac31b1a$var$REACT_SUSPENSE_LIST_TYPE:
                    case $eaf345c99ac31b1a$var$REACT_VIEW_TRANSITION_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $eaf345c99ac31b1a$var$REACT_CONTEXT_TYPE:
                            case $eaf345c99ac31b1a$var$REACT_FORWARD_REF_TYPE:
                            case $eaf345c99ac31b1a$var$REACT_LAZY_TYPE:
                            case $eaf345c99ac31b1a$var$REACT_MEMO_TYPE:
                                return object;
                            case $eaf345c99ac31b1a$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $eaf345c99ac31b1a$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
$eaf345c99ac31b1a$export$a7c73072b1a182ae = $eaf345c99ac31b1a$var$REACT_CONSUMER_TYPE;
$eaf345c99ac31b1a$export$9f27bc3417b4524d = $eaf345c99ac31b1a$var$REACT_CONTEXT_TYPE;
$eaf345c99ac31b1a$export$db77ccec0bb4ccac = $eaf345c99ac31b1a$var$REACT_ELEMENT_TYPE;
$eaf345c99ac31b1a$export$8392c0c9d3dcbd35 = $eaf345c99ac31b1a$var$REACT_FORWARD_REF_TYPE;
$eaf345c99ac31b1a$export$ffb0004e005737fa = $eaf345c99ac31b1a$var$REACT_FRAGMENT_TYPE;
$eaf345c99ac31b1a$export$b624eff549462981 = $eaf345c99ac31b1a$var$REACT_LAZY_TYPE;
$eaf345c99ac31b1a$export$7897aa7841a5380c = $eaf345c99ac31b1a$var$REACT_MEMO_TYPE;
$eaf345c99ac31b1a$export$602eac185826482c = $eaf345c99ac31b1a$var$REACT_PORTAL_TYPE;
$eaf345c99ac31b1a$export$e2c29f18771995cb = $eaf345c99ac31b1a$var$REACT_PROFILER_TYPE;
$eaf345c99ac31b1a$export$5f8d39834fd61797 = $eaf345c99ac31b1a$var$REACT_STRICT_MODE_TYPE;
$eaf345c99ac31b1a$export$74bf444e3cd11ea5 = $eaf345c99ac31b1a$var$REACT_SUSPENSE_TYPE;
$eaf345c99ac31b1a$export$998bcd577473dd93 = $eaf345c99ac31b1a$var$REACT_SUSPENSE_LIST_TYPE;
$eaf345c99ac31b1a$export$b706b080d889d2c9 = function(object) {
    return $eaf345c99ac31b1a$var$typeOf(object) === $eaf345c99ac31b1a$var$REACT_CONSUMER_TYPE;
};
$eaf345c99ac31b1a$export$5be5a87408f70ddc = function(object) {
    return $eaf345c99ac31b1a$var$typeOf(object) === $eaf345c99ac31b1a$var$REACT_CONTEXT_TYPE;
};
$eaf345c99ac31b1a$export$45a5e7f76e0caa8d = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $eaf345c99ac31b1a$var$REACT_ELEMENT_TYPE;
};
$eaf345c99ac31b1a$export$455c2e768291efa6 = function(object) {
    return $eaf345c99ac31b1a$var$typeOf(object) === $eaf345c99ac31b1a$var$REACT_FORWARD_REF_TYPE;
};
$eaf345c99ac31b1a$export$9522e17588c12572 = function(object) {
    return $eaf345c99ac31b1a$var$typeOf(object) === $eaf345c99ac31b1a$var$REACT_FRAGMENT_TYPE;
};
$eaf345c99ac31b1a$export$2110ac352bb060b9 = function(object) {
    return $eaf345c99ac31b1a$var$typeOf(object) === $eaf345c99ac31b1a$var$REACT_LAZY_TYPE;
};
$eaf345c99ac31b1a$export$56885ab8b9c456ab = function(object) {
    return $eaf345c99ac31b1a$var$typeOf(object) === $eaf345c99ac31b1a$var$REACT_MEMO_TYPE;
};
$eaf345c99ac31b1a$export$d927fcb6adf8f9de = function(object) {
    return $eaf345c99ac31b1a$var$typeOf(object) === $eaf345c99ac31b1a$var$REACT_PORTAL_TYPE;
};
$eaf345c99ac31b1a$export$b82d16f27459e05a = function(object) {
    return $eaf345c99ac31b1a$var$typeOf(object) === $eaf345c99ac31b1a$var$REACT_PROFILER_TYPE;
};
$eaf345c99ac31b1a$export$522c17b4f5e123e8 = function(object) {
    return $eaf345c99ac31b1a$var$typeOf(object) === $eaf345c99ac31b1a$var$REACT_STRICT_MODE_TYPE;
};
$eaf345c99ac31b1a$export$1aabd8a0274ecfd6 = function(object) {
    return $eaf345c99ac31b1a$var$typeOf(object) === $eaf345c99ac31b1a$var$REACT_SUSPENSE_TYPE;
};
$eaf345c99ac31b1a$export$3d6c20d97e46b957 = function(object) {
    return $eaf345c99ac31b1a$var$typeOf(object) === $eaf345c99ac31b1a$var$REACT_SUSPENSE_LIST_TYPE;
};
$eaf345c99ac31b1a$export$9b621391a187a31a = function(type) {
    return "string" === typeof type || "function" === typeof type || type === $eaf345c99ac31b1a$var$REACT_FRAGMENT_TYPE || type === $eaf345c99ac31b1a$var$REACT_PROFILER_TYPE || type === $eaf345c99ac31b1a$var$REACT_STRICT_MODE_TYPE || type === $eaf345c99ac31b1a$var$REACT_SUSPENSE_TYPE || type === $eaf345c99ac31b1a$var$REACT_SUSPENSE_LIST_TYPE || "object" === typeof type && null !== type && (type.$$typeof === $eaf345c99ac31b1a$var$REACT_LAZY_TYPE || type.$$typeof === $eaf345c99ac31b1a$var$REACT_MEMO_TYPE || type.$$typeof === $eaf345c99ac31b1a$var$REACT_CONTEXT_TYPE || type.$$typeof === $eaf345c99ac31b1a$var$REACT_CONSUMER_TYPE || type.$$typeof === $eaf345c99ac31b1a$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $eaf345c99ac31b1a$var$REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
};
$eaf345c99ac31b1a$export$f5bbd400c2f4426f = $eaf345c99ac31b1a$var$typeOf;

});

parcelRegister("d00aZ", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $976b6973b6020089$export$bf730a2d8bf68b42; }, function (v) { return $976b6973b6020089$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $976b6973b6020089$export$bf730a2d8bf68b42;
"use strict";

var $cQmXV = parcelRequire("cQmXV");
function $976b6973b6020089$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $976b6973b6020089$var$objectIs = "function" === typeof Object.is ? Object.is : $976b6973b6020089$var$is, $976b6973b6020089$var$useSyncExternalStore = $cQmXV.useSyncExternalStore, $976b6973b6020089$var$useRef = $cQmXV.useRef, $976b6973b6020089$var$useEffect = $cQmXV.useEffect, $976b6973b6020089$var$useMemo = $cQmXV.useMemo, $976b6973b6020089$var$useDebugValue = $cQmXV.useDebugValue;
$976b6973b6020089$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $976b6973b6020089$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $976b6973b6020089$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($976b6973b6020089$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $976b6973b6020089$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $976b6973b6020089$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $976b6973b6020089$var$useDebugValue(value);
    return value;
};

});

parcelRegister("keGWe", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $iLKj0 = parcelRequire("iLKj0");
function $ebb66c15cd244f3f$var$emptyFunction() {}
function $ebb66c15cd244f3f$var$emptyFunctionWithReset() {}
$ebb66c15cd244f3f$var$emptyFunctionWithReset.resetWarningCache = $ebb66c15cd244f3f$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $iLKj0) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $ebb66c15cd244f3f$var$emptyFunctionWithReset,
        resetWarningCache: $ebb66c15cd244f3f$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("iLKj0", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $daa089165e95456f$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $daa089165e95456f$var$ReactPropTypesSecret;

});


parcelRegister("9fiKv", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $6bb40ef39bebc166$export$2b8d127b894957b9; }, function (v) { return $6bb40ef39bebc166$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $6bb40ef39bebc166$export$cea3a54a6425200c; }, function (v) { return $6bb40ef39bebc166$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $6bb40ef39bebc166$export$a7c73072b1a182ae; }, function (v) { return $6bb40ef39bebc166$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $6bb40ef39bebc166$export$9f27bc3417b4524d; }, function (v) { return $6bb40ef39bebc166$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $6bb40ef39bebc166$export$db77ccec0bb4ccac; }, function (v) { return $6bb40ef39bebc166$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $6bb40ef39bebc166$export$8392c0c9d3dcbd35; }, function (v) { return $6bb40ef39bebc166$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $6bb40ef39bebc166$export$ffb0004e005737fa; }, function (v) { return $6bb40ef39bebc166$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $6bb40ef39bebc166$export$b624eff549462981; }, function (v) { return $6bb40ef39bebc166$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $6bb40ef39bebc166$export$7897aa7841a5380c; }, function (v) { return $6bb40ef39bebc166$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $6bb40ef39bebc166$export$602eac185826482c; }, function (v) { return $6bb40ef39bebc166$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $6bb40ef39bebc166$export$e2c29f18771995cb; }, function (v) { return $6bb40ef39bebc166$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $6bb40ef39bebc166$export$5f8d39834fd61797; }, function (v) { return $6bb40ef39bebc166$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $6bb40ef39bebc166$export$74bf444e3cd11ea5; }, function (v) { return $6bb40ef39bebc166$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $6bb40ef39bebc166$export$92387174baf9b227; }, function (v) { return $6bb40ef39bebc166$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $6bb40ef39bebc166$export$ec112efeb987d9c6; }, function (v) { return $6bb40ef39bebc166$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $6bb40ef39bebc166$export$b706b080d889d2c9; }, function (v) { return $6bb40ef39bebc166$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $6bb40ef39bebc166$export$5be5a87408f70ddc; }, function (v) { return $6bb40ef39bebc166$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $6bb40ef39bebc166$export$45a5e7f76e0caa8d; }, function (v) { return $6bb40ef39bebc166$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $6bb40ef39bebc166$export$455c2e768291efa6; }, function (v) { return $6bb40ef39bebc166$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $6bb40ef39bebc166$export$9522e17588c12572; }, function (v) { return $6bb40ef39bebc166$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $6bb40ef39bebc166$export$2110ac352bb060b9; }, function (v) { return $6bb40ef39bebc166$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $6bb40ef39bebc166$export$56885ab8b9c456ab; }, function (v) { return $6bb40ef39bebc166$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $6bb40ef39bebc166$export$d927fcb6adf8f9de; }, function (v) { return $6bb40ef39bebc166$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $6bb40ef39bebc166$export$b82d16f27459e05a; }, function (v) { return $6bb40ef39bebc166$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $6bb40ef39bebc166$export$522c17b4f5e123e8; }, function (v) { return $6bb40ef39bebc166$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $6bb40ef39bebc166$export$1aabd8a0274ecfd6; }, function (v) { return $6bb40ef39bebc166$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $6bb40ef39bebc166$export$9b621391a187a31a; }, function (v) { return $6bb40ef39bebc166$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $6bb40ef39bebc166$export$f5bbd400c2f4426f; }, function (v) { return $6bb40ef39bebc166$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6bb40ef39bebc166$export$2b8d127b894957b9;
var $6bb40ef39bebc166$export$cea3a54a6425200c;
var $6bb40ef39bebc166$export$a7c73072b1a182ae;
var $6bb40ef39bebc166$export$9f27bc3417b4524d;
var $6bb40ef39bebc166$export$db77ccec0bb4ccac;
var $6bb40ef39bebc166$export$8392c0c9d3dcbd35;
var $6bb40ef39bebc166$export$ffb0004e005737fa;
var $6bb40ef39bebc166$export$b624eff549462981;
var $6bb40ef39bebc166$export$7897aa7841a5380c;
var $6bb40ef39bebc166$export$602eac185826482c;
var $6bb40ef39bebc166$export$e2c29f18771995cb;
var $6bb40ef39bebc166$export$5f8d39834fd61797;
var $6bb40ef39bebc166$export$74bf444e3cd11ea5;
var $6bb40ef39bebc166$export$92387174baf9b227;
var $6bb40ef39bebc166$export$ec112efeb987d9c6;
var $6bb40ef39bebc166$export$b706b080d889d2c9;
var $6bb40ef39bebc166$export$5be5a87408f70ddc;
var $6bb40ef39bebc166$export$45a5e7f76e0caa8d;
var $6bb40ef39bebc166$export$455c2e768291efa6;
var $6bb40ef39bebc166$export$9522e17588c12572;
var $6bb40ef39bebc166$export$2110ac352bb060b9;
var $6bb40ef39bebc166$export$56885ab8b9c456ab;
var $6bb40ef39bebc166$export$d927fcb6adf8f9de;
var $6bb40ef39bebc166$export$b82d16f27459e05a;
var $6bb40ef39bebc166$export$522c17b4f5e123e8;
var $6bb40ef39bebc166$export$1aabd8a0274ecfd6;
var $6bb40ef39bebc166$export$9b621391a187a31a;
var $6bb40ef39bebc166$export$f5bbd400c2f4426f;
"use strict";
var $6bb40ef39bebc166$var$b = "function" === typeof Symbol && Symbol.for, $6bb40ef39bebc166$var$c = $6bb40ef39bebc166$var$b ? Symbol.for("react.element") : 60103, $6bb40ef39bebc166$var$d = $6bb40ef39bebc166$var$b ? Symbol.for("react.portal") : 60106, $6bb40ef39bebc166$var$e = $6bb40ef39bebc166$var$b ? Symbol.for("react.fragment") : 60107, $6bb40ef39bebc166$var$f = $6bb40ef39bebc166$var$b ? Symbol.for("react.strict_mode") : 60108, $6bb40ef39bebc166$var$g = $6bb40ef39bebc166$var$b ? Symbol.for("react.profiler") : 60114, $6bb40ef39bebc166$var$h = $6bb40ef39bebc166$var$b ? Symbol.for("react.provider") : 60109, $6bb40ef39bebc166$var$k = $6bb40ef39bebc166$var$b ? Symbol.for("react.context") : 60110, $6bb40ef39bebc166$var$l = $6bb40ef39bebc166$var$b ? Symbol.for("react.async_mode") : 60111, $6bb40ef39bebc166$var$m = $6bb40ef39bebc166$var$b ? Symbol.for("react.concurrent_mode") : 60111, $6bb40ef39bebc166$var$n = $6bb40ef39bebc166$var$b ? Symbol.for("react.forward_ref") : 60112, $6bb40ef39bebc166$var$p = $6bb40ef39bebc166$var$b ? Symbol.for("react.suspense") : 60113, $6bb40ef39bebc166$var$q = $6bb40ef39bebc166$var$b ? Symbol.for("react.suspense_list") : 60120, $6bb40ef39bebc166$var$r = $6bb40ef39bebc166$var$b ? Symbol.for("react.memo") : 60115, $6bb40ef39bebc166$var$t = $6bb40ef39bebc166$var$b ? Symbol.for("react.lazy") : 60116, $6bb40ef39bebc166$var$v = $6bb40ef39bebc166$var$b ? Symbol.for("react.block") : 60121, $6bb40ef39bebc166$var$w = $6bb40ef39bebc166$var$b ? Symbol.for("react.fundamental") : 60117, $6bb40ef39bebc166$var$x = $6bb40ef39bebc166$var$b ? Symbol.for("react.responder") : 60118, $6bb40ef39bebc166$var$y = $6bb40ef39bebc166$var$b ? Symbol.for("react.scope") : 60119;
function $6bb40ef39bebc166$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $6bb40ef39bebc166$var$c:
                switch(a = a.type, a){
                    case $6bb40ef39bebc166$var$l:
                    case $6bb40ef39bebc166$var$m:
                    case $6bb40ef39bebc166$var$e:
                    case $6bb40ef39bebc166$var$g:
                    case $6bb40ef39bebc166$var$f:
                    case $6bb40ef39bebc166$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $6bb40ef39bebc166$var$k:
                            case $6bb40ef39bebc166$var$n:
                            case $6bb40ef39bebc166$var$t:
                            case $6bb40ef39bebc166$var$r:
                            case $6bb40ef39bebc166$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $6bb40ef39bebc166$var$d:
                return u;
        }
    }
}
function $6bb40ef39bebc166$var$A(a) {
    return $6bb40ef39bebc166$var$z(a) === $6bb40ef39bebc166$var$m;
}
$6bb40ef39bebc166$export$2b8d127b894957b9 = $6bb40ef39bebc166$var$l;
$6bb40ef39bebc166$export$cea3a54a6425200c = $6bb40ef39bebc166$var$m;
$6bb40ef39bebc166$export$a7c73072b1a182ae = $6bb40ef39bebc166$var$k;
$6bb40ef39bebc166$export$9f27bc3417b4524d = $6bb40ef39bebc166$var$h;
$6bb40ef39bebc166$export$db77ccec0bb4ccac = $6bb40ef39bebc166$var$c;
$6bb40ef39bebc166$export$8392c0c9d3dcbd35 = $6bb40ef39bebc166$var$n;
$6bb40ef39bebc166$export$ffb0004e005737fa = $6bb40ef39bebc166$var$e;
$6bb40ef39bebc166$export$b624eff549462981 = $6bb40ef39bebc166$var$t;
$6bb40ef39bebc166$export$7897aa7841a5380c = $6bb40ef39bebc166$var$r;
$6bb40ef39bebc166$export$602eac185826482c = $6bb40ef39bebc166$var$d;
$6bb40ef39bebc166$export$e2c29f18771995cb = $6bb40ef39bebc166$var$g;
$6bb40ef39bebc166$export$5f8d39834fd61797 = $6bb40ef39bebc166$var$f;
$6bb40ef39bebc166$export$74bf444e3cd11ea5 = $6bb40ef39bebc166$var$p;
$6bb40ef39bebc166$export$92387174baf9b227 = function(a) {
    return $6bb40ef39bebc166$var$A(a) || $6bb40ef39bebc166$var$z(a) === $6bb40ef39bebc166$var$l;
};
$6bb40ef39bebc166$export$ec112efeb987d9c6 = $6bb40ef39bebc166$var$A;
$6bb40ef39bebc166$export$b706b080d889d2c9 = function(a) {
    return $6bb40ef39bebc166$var$z(a) === $6bb40ef39bebc166$var$k;
};
$6bb40ef39bebc166$export$5be5a87408f70ddc = function(a) {
    return $6bb40ef39bebc166$var$z(a) === $6bb40ef39bebc166$var$h;
};
$6bb40ef39bebc166$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $6bb40ef39bebc166$var$c;
};
$6bb40ef39bebc166$export$455c2e768291efa6 = function(a) {
    return $6bb40ef39bebc166$var$z(a) === $6bb40ef39bebc166$var$n;
};
$6bb40ef39bebc166$export$9522e17588c12572 = function(a) {
    return $6bb40ef39bebc166$var$z(a) === $6bb40ef39bebc166$var$e;
};
$6bb40ef39bebc166$export$2110ac352bb060b9 = function(a) {
    return $6bb40ef39bebc166$var$z(a) === $6bb40ef39bebc166$var$t;
};
$6bb40ef39bebc166$export$56885ab8b9c456ab = function(a) {
    return $6bb40ef39bebc166$var$z(a) === $6bb40ef39bebc166$var$r;
};
$6bb40ef39bebc166$export$d927fcb6adf8f9de = function(a) {
    return $6bb40ef39bebc166$var$z(a) === $6bb40ef39bebc166$var$d;
};
$6bb40ef39bebc166$export$b82d16f27459e05a = function(a) {
    return $6bb40ef39bebc166$var$z(a) === $6bb40ef39bebc166$var$g;
};
$6bb40ef39bebc166$export$522c17b4f5e123e8 = function(a) {
    return $6bb40ef39bebc166$var$z(a) === $6bb40ef39bebc166$var$f;
};
$6bb40ef39bebc166$export$1aabd8a0274ecfd6 = function(a) {
    return $6bb40ef39bebc166$var$z(a) === $6bb40ef39bebc166$var$p;
};
$6bb40ef39bebc166$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $6bb40ef39bebc166$var$e || a === $6bb40ef39bebc166$var$m || a === $6bb40ef39bebc166$var$g || a === $6bb40ef39bebc166$var$f || a === $6bb40ef39bebc166$var$p || a === $6bb40ef39bebc166$var$q || "object" === typeof a && null !== a && (a.$$typeof === $6bb40ef39bebc166$var$t || a.$$typeof === $6bb40ef39bebc166$var$r || a.$$typeof === $6bb40ef39bebc166$var$h || a.$$typeof === $6bb40ef39bebc166$var$k || a.$$typeof === $6bb40ef39bebc166$var$n || a.$$typeof === $6bb40ef39bebc166$var$w || a.$$typeof === $6bb40ef39bebc166$var$x || a.$$typeof === $6bb40ef39bebc166$var$y || a.$$typeof === $6bb40ef39bebc166$var$v);
};
$6bb40ef39bebc166$export$f5bbd400c2f4426f = $6bb40ef39bebc166$var$z;

});

parcelRegister("bdrlo", function(module, exports) {
module.exports = JSON.parse('{"application/1d-interleaved-parityfec":{"source":"iana"},"application/3gpdash-qoe-report+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/3gpp-ims+xml":{"source":"iana","compressible":true},"application/3gpphal+json":{"source":"iana","compressible":true},"application/3gpphalforms+json":{"source":"iana","compressible":true},"application/a2l":{"source":"iana"},"application/ace+cbor":{"source":"iana"},"application/activemessage":{"source":"iana"},"application/activity+json":{"source":"iana","compressible":true},"application/alto-costmap+json":{"source":"iana","compressible":true},"application/alto-costmapfilter+json":{"source":"iana","compressible":true},"application/alto-directory+json":{"source":"iana","compressible":true},"application/alto-endpointcost+json":{"source":"iana","compressible":true},"application/alto-endpointcostparams+json":{"source":"iana","compressible":true},"application/alto-endpointprop+json":{"source":"iana","compressible":true},"application/alto-endpointpropparams+json":{"source":"iana","compressible":true},"application/alto-error+json":{"source":"iana","compressible":true},"application/alto-networkmap+json":{"source":"iana","compressible":true},"application/alto-networkmapfilter+json":{"source":"iana","compressible":true},"application/alto-updatestreamcontrol+json":{"source":"iana","compressible":true},"application/alto-updatestreamparams+json":{"source":"iana","compressible":true},"application/aml":{"source":"iana"},"application/andrew-inset":{"source":"iana","extensions":["ez"]},"application/applefile":{"source":"iana"},"application/applixware":{"source":"apache","extensions":["aw"]},"application/at+jwt":{"source":"iana"},"application/atf":{"source":"iana"},"application/atfx":{"source":"iana"},"application/atom+xml":{"source":"iana","compressible":true,"extensions":["atom"]},"application/atomcat+xml":{"source":"iana","compressible":true,"extensions":["atomcat"]},"application/atomdeleted+xml":{"source":"iana","compressible":true,"extensions":["atomdeleted"]},"application/atomicmail":{"source":"iana"},"application/atomsvc+xml":{"source":"iana","compressible":true,"extensions":["atomsvc"]},"application/atsc-dwd+xml":{"source":"iana","compressible":true,"extensions":["dwd"]},"application/atsc-dynamic-event-message":{"source":"iana"},"application/atsc-held+xml":{"source":"iana","compressible":true,"extensions":["held"]},"application/atsc-rdt+json":{"source":"iana","compressible":true},"application/atsc-rsat+xml":{"source":"iana","compressible":true,"extensions":["rsat"]},"application/atxml":{"source":"iana"},"application/auth-policy+xml":{"source":"iana","compressible":true},"application/bacnet-xdd+zip":{"source":"iana","compressible":false},"application/batch-smtp":{"source":"iana"},"application/bdoc":{"compressible":false,"extensions":["bdoc"]},"application/beep+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/calendar+json":{"source":"iana","compressible":true},"application/calendar+xml":{"source":"iana","compressible":true,"extensions":["xcs"]},"application/call-completion":{"source":"iana"},"application/cals-1840":{"source":"iana"},"application/captive+json":{"source":"iana","compressible":true},"application/cbor":{"source":"iana"},"application/cbor-seq":{"source":"iana"},"application/cccex":{"source":"iana"},"application/ccmp+xml":{"source":"iana","compressible":true},"application/ccxml+xml":{"source":"iana","compressible":true,"extensions":["ccxml"]},"application/cdfx+xml":{"source":"iana","compressible":true,"extensions":["cdfx"]},"application/cdmi-capability":{"source":"iana","extensions":["cdmia"]},"application/cdmi-container":{"source":"iana","extensions":["cdmic"]},"application/cdmi-domain":{"source":"iana","extensions":["cdmid"]},"application/cdmi-object":{"source":"iana","extensions":["cdmio"]},"application/cdmi-queue":{"source":"iana","extensions":["cdmiq"]},"application/cdni":{"source":"iana"},"application/cea":{"source":"iana"},"application/cea-2018+xml":{"source":"iana","compressible":true},"application/cellml+xml":{"source":"iana","compressible":true},"application/cfw":{"source":"iana"},"application/city+json":{"source":"iana","compressible":true},"application/clr":{"source":"iana"},"application/clue+xml":{"source":"iana","compressible":true},"application/clue_info+xml":{"source":"iana","compressible":true},"application/cms":{"source":"iana"},"application/cnrp+xml":{"source":"iana","compressible":true},"application/coap-group+json":{"source":"iana","compressible":true},"application/coap-payload":{"source":"iana"},"application/commonground":{"source":"iana"},"application/conference-info+xml":{"source":"iana","compressible":true},"application/cose":{"source":"iana"},"application/cose-key":{"source":"iana"},"application/cose-key-set":{"source":"iana"},"application/cpl+xml":{"source":"iana","compressible":true,"extensions":["cpl"]},"application/csrattrs":{"source":"iana"},"application/csta+xml":{"source":"iana","compressible":true},"application/cstadata+xml":{"source":"iana","compressible":true},"application/csvm+json":{"source":"iana","compressible":true},"application/cu-seeme":{"source":"apache","extensions":["cu"]},"application/cwt":{"source":"iana"},"application/cybercash":{"source":"iana"},"application/dart":{"compressible":true},"application/dash+xml":{"source":"iana","compressible":true,"extensions":["mpd"]},"application/dash-patch+xml":{"source":"iana","compressible":true,"extensions":["mpp"]},"application/dashdelta":{"source":"iana"},"application/davmount+xml":{"source":"iana","compressible":true,"extensions":["davmount"]},"application/dca-rft":{"source":"iana"},"application/dcd":{"source":"iana"},"application/dec-dx":{"source":"iana"},"application/dialog-info+xml":{"source":"iana","compressible":true},"application/dicom":{"source":"iana"},"application/dicom+json":{"source":"iana","compressible":true},"application/dicom+xml":{"source":"iana","compressible":true},"application/dii":{"source":"iana"},"application/dit":{"source":"iana"},"application/dns":{"source":"iana"},"application/dns+json":{"source":"iana","compressible":true},"application/dns-message":{"source":"iana"},"application/docbook+xml":{"source":"apache","compressible":true,"extensions":["dbk"]},"application/dots+cbor":{"source":"iana"},"application/dskpp+xml":{"source":"iana","compressible":true},"application/dssc+der":{"source":"iana","extensions":["dssc"]},"application/dssc+xml":{"source":"iana","compressible":true,"extensions":["xdssc"]},"application/dvcs":{"source":"iana"},"application/ecmascript":{"source":"iana","compressible":true,"extensions":["es","ecma"]},"application/edi-consent":{"source":"iana"},"application/edi-x12":{"source":"iana","compressible":false},"application/edifact":{"source":"iana","compressible":false},"application/efi":{"source":"iana"},"application/elm+json":{"source":"iana","charset":"UTF-8","compressible":true},"application/elm+xml":{"source":"iana","compressible":true},"application/emergencycalldata.cap+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/emergencycalldata.comment+xml":{"source":"iana","compressible":true},"application/emergencycalldata.control+xml":{"source":"iana","compressible":true},"application/emergencycalldata.deviceinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.ecall.msd":{"source":"iana"},"application/emergencycalldata.providerinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.serviceinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.subscriberinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.veds+xml":{"source":"iana","compressible":true},"application/emma+xml":{"source":"iana","compressible":true,"extensions":["emma"]},"application/emotionml+xml":{"source":"iana","compressible":true,"extensions":["emotionml"]},"application/encaprtp":{"source":"iana"},"application/epp+xml":{"source":"iana","compressible":true},"application/epub+zip":{"source":"iana","compressible":false,"extensions":["epub"]},"application/eshop":{"source":"iana"},"application/exi":{"source":"iana","extensions":["exi"]},"application/expect-ct-report+json":{"source":"iana","compressible":true},"application/express":{"source":"iana","extensions":["exp"]},"application/fastinfoset":{"source":"iana"},"application/fastsoap":{"source":"iana"},"application/fdt+xml":{"source":"iana","compressible":true,"extensions":["fdt"]},"application/fhir+json":{"source":"iana","charset":"UTF-8","compressible":true},"application/fhir+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/fido.trusted-apps+json":{"compressible":true},"application/fits":{"source":"iana"},"application/flexfec":{"source":"iana"},"application/font-sfnt":{"source":"iana"},"application/font-tdpfr":{"source":"iana","extensions":["pfr"]},"application/font-woff":{"source":"iana","compressible":false},"application/framework-attributes+xml":{"source":"iana","compressible":true},"application/geo+json":{"source":"iana","compressible":true,"extensions":["geojson"]},"application/geo+json-seq":{"source":"iana"},"application/geopackage+sqlite3":{"source":"iana"},"application/geoxacml+xml":{"source":"iana","compressible":true},"application/gltf-buffer":{"source":"iana"},"application/gml+xml":{"source":"iana","compressible":true,"extensions":["gml"]},"application/gpx+xml":{"source":"apache","compressible":true,"extensions":["gpx"]},"application/gxf":{"source":"apache","extensions":["gxf"]},"application/gzip":{"source":"iana","compressible":false,"extensions":["gz"]},"application/h224":{"source":"iana"},"application/held+xml":{"source":"iana","compressible":true},"application/hjson":{"extensions":["hjson"]},"application/http":{"source":"iana"},"application/hyperstudio":{"source":"iana","extensions":["stk"]},"application/ibe-key-request+xml":{"source":"iana","compressible":true},"application/ibe-pkg-reply+xml":{"source":"iana","compressible":true},"application/ibe-pp-data":{"source":"iana"},"application/iges":{"source":"iana"},"application/im-iscomposing+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/index":{"source":"iana"},"application/index.cmd":{"source":"iana"},"application/index.obj":{"source":"iana"},"application/index.response":{"source":"iana"},"application/index.vnd":{"source":"iana"},"application/inkml+xml":{"source":"iana","compressible":true,"extensions":["ink","inkml"]},"application/iotp":{"source":"iana"},"application/ipfix":{"source":"iana","extensions":["ipfix"]},"application/ipp":{"source":"iana"},"application/isup":{"source":"iana"},"application/its+xml":{"source":"iana","compressible":true,"extensions":["its"]},"application/java-archive":{"source":"apache","compressible":false,"extensions":["jar","war","ear"]},"application/java-serialized-object":{"source":"apache","compressible":false,"extensions":["ser"]},"application/java-vm":{"source":"apache","compressible":false,"extensions":["class"]},"application/javascript":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["js","mjs"]},"application/jf2feed+json":{"source":"iana","compressible":true},"application/jose":{"source":"iana"},"application/jose+json":{"source":"iana","compressible":true},"application/jrd+json":{"source":"iana","compressible":true},"application/jscalendar+json":{"source":"iana","compressible":true},"application/json":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["json","map"]},"application/json-patch+json":{"source":"iana","compressible":true},"application/json-seq":{"source":"iana"},"application/json5":{"extensions":["json5"]},"application/jsonml+json":{"source":"apache","compressible":true,"extensions":["jsonml"]},"application/jwk+json":{"source":"iana","compressible":true},"application/jwk-set+json":{"source":"iana","compressible":true},"application/jwt":{"source":"iana"},"application/kpml-request+xml":{"source":"iana","compressible":true},"application/kpml-response+xml":{"source":"iana","compressible":true},"application/ld+json":{"source":"iana","compressible":true,"extensions":["jsonld"]},"application/lgr+xml":{"source":"iana","compressible":true,"extensions":["lgr"]},"application/link-format":{"source":"iana"},"application/load-control+xml":{"source":"iana","compressible":true},"application/lost+xml":{"source":"iana","compressible":true,"extensions":["lostxml"]},"application/lostsync+xml":{"source":"iana","compressible":true},"application/lpf+zip":{"source":"iana","compressible":false},"application/lxf":{"source":"iana"},"application/mac-binhex40":{"source":"iana","extensions":["hqx"]},"application/mac-compactpro":{"source":"apache","extensions":["cpt"]},"application/macwriteii":{"source":"iana"},"application/mads+xml":{"source":"iana","compressible":true,"extensions":["mads"]},"application/manifest+json":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["webmanifest"]},"application/marc":{"source":"iana","extensions":["mrc"]},"application/marcxml+xml":{"source":"iana","compressible":true,"extensions":["mrcx"]},"application/mathematica":{"source":"iana","extensions":["ma","nb","mb"]},"application/mathml+xml":{"source":"iana","compressible":true,"extensions":["mathml"]},"application/mathml-content+xml":{"source":"iana","compressible":true},"application/mathml-presentation+xml":{"source":"iana","compressible":true},"application/mbms-associated-procedure-description+xml":{"source":"iana","compressible":true},"application/mbms-deregister+xml":{"source":"iana","compressible":true},"application/mbms-envelope+xml":{"source":"iana","compressible":true},"application/mbms-msk+xml":{"source":"iana","compressible":true},"application/mbms-msk-response+xml":{"source":"iana","compressible":true},"application/mbms-protection-description+xml":{"source":"iana","compressible":true},"application/mbms-reception-report+xml":{"source":"iana","compressible":true},"application/mbms-register+xml":{"source":"iana","compressible":true},"application/mbms-register-response+xml":{"source":"iana","compressible":true},"application/mbms-schedule+xml":{"source":"iana","compressible":true},"application/mbms-user-service-description+xml":{"source":"iana","compressible":true},"application/mbox":{"source":"iana","extensions":["mbox"]},"application/media-policy-dataset+xml":{"source":"iana","compressible":true,"extensions":["mpf"]},"application/media_control+xml":{"source":"iana","compressible":true},"application/mediaservercontrol+xml":{"source":"iana","compressible":true,"extensions":["mscml"]},"application/merge-patch+json":{"source":"iana","compressible":true},"application/metalink+xml":{"source":"apache","compressible":true,"extensions":["metalink"]},"application/metalink4+xml":{"source":"iana","compressible":true,"extensions":["meta4"]},"application/mets+xml":{"source":"iana","compressible":true,"extensions":["mets"]},"application/mf4":{"source":"iana"},"application/mikey":{"source":"iana"},"application/mipc":{"source":"iana"},"application/missing-blocks+cbor-seq":{"source":"iana"},"application/mmt-aei+xml":{"source":"iana","compressible":true,"extensions":["maei"]},"application/mmt-usd+xml":{"source":"iana","compressible":true,"extensions":["musd"]},"application/mods+xml":{"source":"iana","compressible":true,"extensions":["mods"]},"application/moss-keys":{"source":"iana"},"application/moss-signature":{"source":"iana"},"application/mosskey-data":{"source":"iana"},"application/mosskey-request":{"source":"iana"},"application/mp21":{"source":"iana","extensions":["m21","mp21"]},"application/mp4":{"source":"iana","extensions":["mp4s","m4p"]},"application/mpeg4-generic":{"source":"iana"},"application/mpeg4-iod":{"source":"iana"},"application/mpeg4-iod-xmt":{"source":"iana"},"application/mrb-consumer+xml":{"source":"iana","compressible":true},"application/mrb-publish+xml":{"source":"iana","compressible":true},"application/msc-ivr+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/msc-mixer+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/msword":{"source":"iana","compressible":false,"extensions":["doc","dot"]},"application/mud+json":{"source":"iana","compressible":true},"application/multipart-core":{"source":"iana"},"application/mxf":{"source":"iana","extensions":["mxf"]},"application/n-quads":{"source":"iana","extensions":["nq"]},"application/n-triples":{"source":"iana","extensions":["nt"]},"application/nasdata":{"source":"iana"},"application/news-checkgroups":{"source":"iana","charset":"US-ASCII"},"application/news-groupinfo":{"source":"iana","charset":"US-ASCII"},"application/news-transmission":{"source":"iana"},"application/nlsml+xml":{"source":"iana","compressible":true},"application/node":{"source":"iana","extensions":["cjs"]},"application/nss":{"source":"iana"},"application/oauth-authz-req+jwt":{"source":"iana"},"application/oblivious-dns-message":{"source":"iana"},"application/ocsp-request":{"source":"iana"},"application/ocsp-response":{"source":"iana"},"application/octet-stream":{"source":"iana","compressible":false,"extensions":["bin","dms","lrf","mar","so","dist","distz","pkg","bpk","dump","elc","deploy","exe","dll","deb","dmg","iso","img","msi","msp","msm","buffer"]},"application/oda":{"source":"iana","extensions":["oda"]},"application/odm+xml":{"source":"iana","compressible":true},"application/odx":{"source":"iana"},"application/oebps-package+xml":{"source":"iana","compressible":true,"extensions":["opf"]},"application/ogg":{"source":"iana","compressible":false,"extensions":["ogx"]},"application/omdoc+xml":{"source":"apache","compressible":true,"extensions":["omdoc"]},"application/onenote":{"source":"apache","extensions":["onetoc","onetoc2","onetmp","onepkg"]},"application/opc-nodeset+xml":{"source":"iana","compressible":true},"application/oscore":{"source":"iana"},"application/oxps":{"source":"iana","extensions":["oxps"]},"application/p21":{"source":"iana"},"application/p21+zip":{"source":"iana","compressible":false},"application/p2p-overlay+xml":{"source":"iana","compressible":true,"extensions":["relo"]},"application/parityfec":{"source":"iana"},"application/passport":{"source":"iana"},"application/patch-ops-error+xml":{"source":"iana","compressible":true,"extensions":["xer"]},"application/pdf":{"source":"iana","compressible":false,"extensions":["pdf"]},"application/pdx":{"source":"iana"},"application/pem-certificate-chain":{"source":"iana"},"application/pgp-encrypted":{"source":"iana","compressible":false,"extensions":["pgp"]},"application/pgp-keys":{"source":"iana","extensions":["asc"]},"application/pgp-signature":{"source":"iana","extensions":["asc","sig"]},"application/pics-rules":{"source":"apache","extensions":["prf"]},"application/pidf+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/pidf-diff+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/pkcs10":{"source":"iana","extensions":["p10"]},"application/pkcs12":{"source":"iana"},"application/pkcs7-mime":{"source":"iana","extensions":["p7m","p7c"]},"application/pkcs7-signature":{"source":"iana","extensions":["p7s"]},"application/pkcs8":{"source":"iana","extensions":["p8"]},"application/pkcs8-encrypted":{"source":"iana"},"application/pkix-attr-cert":{"source":"iana","extensions":["ac"]},"application/pkix-cert":{"source":"iana","extensions":["cer"]},"application/pkix-crl":{"source":"iana","extensions":["crl"]},"application/pkix-pkipath":{"source":"iana","extensions":["pkipath"]},"application/pkixcmp":{"source":"iana","extensions":["pki"]},"application/pls+xml":{"source":"iana","compressible":true,"extensions":["pls"]},"application/poc-settings+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/postscript":{"source":"iana","compressible":true,"extensions":["ai","eps","ps"]},"application/ppsp-tracker+json":{"source":"iana","compressible":true},"application/problem+json":{"source":"iana","compressible":true},"application/problem+xml":{"source":"iana","compressible":true},"application/provenance+xml":{"source":"iana","compressible":true,"extensions":["provx"]},"application/prs.alvestrand.titrax-sheet":{"source":"iana"},"application/prs.cww":{"source":"iana","extensions":["cww"]},"application/prs.cyn":{"source":"iana","charset":"7-BIT"},"application/prs.hpub+zip":{"source":"iana","compressible":false},"application/prs.nprend":{"source":"iana"},"application/prs.plucker":{"source":"iana"},"application/prs.rdf-xml-crypt":{"source":"iana"},"application/prs.xsf+xml":{"source":"iana","compressible":true},"application/pskc+xml":{"source":"iana","compressible":true,"extensions":["pskcxml"]},"application/pvd+json":{"source":"iana","compressible":true},"application/qsig":{"source":"iana"},"application/raml+yaml":{"compressible":true,"extensions":["raml"]},"application/raptorfec":{"source":"iana"},"application/rdap+json":{"source":"iana","compressible":true},"application/rdf+xml":{"source":"iana","compressible":true,"extensions":["rdf","owl"]},"application/reginfo+xml":{"source":"iana","compressible":true,"extensions":["rif"]},"application/relax-ng-compact-syntax":{"source":"iana","extensions":["rnc"]},"application/remote-printing":{"source":"iana"},"application/reputon+json":{"source":"iana","compressible":true},"application/resource-lists+xml":{"source":"iana","compressible":true,"extensions":["rl"]},"application/resource-lists-diff+xml":{"source":"iana","compressible":true,"extensions":["rld"]},"application/rfc+xml":{"source":"iana","compressible":true},"application/riscos":{"source":"iana"},"application/rlmi+xml":{"source":"iana","compressible":true},"application/rls-services+xml":{"source":"iana","compressible":true,"extensions":["rs"]},"application/route-apd+xml":{"source":"iana","compressible":true,"extensions":["rapd"]},"application/route-s-tsid+xml":{"source":"iana","compressible":true,"extensions":["sls"]},"application/route-usd+xml":{"source":"iana","compressible":true,"extensions":["rusd"]},"application/rpki-ghostbusters":{"source":"iana","extensions":["gbr"]},"application/rpki-manifest":{"source":"iana","extensions":["mft"]},"application/rpki-publication":{"source":"iana"},"application/rpki-roa":{"source":"iana","extensions":["roa"]},"application/rpki-updown":{"source":"iana"},"application/rsd+xml":{"source":"apache","compressible":true,"extensions":["rsd"]},"application/rss+xml":{"source":"apache","compressible":true,"extensions":["rss"]},"application/rtf":{"source":"iana","compressible":true,"extensions":["rtf"]},"application/rtploopback":{"source":"iana"},"application/rtx":{"source":"iana"},"application/samlassertion+xml":{"source":"iana","compressible":true},"application/samlmetadata+xml":{"source":"iana","compressible":true},"application/sarif+json":{"source":"iana","compressible":true},"application/sarif-external-properties+json":{"source":"iana","compressible":true},"application/sbe":{"source":"iana"},"application/sbml+xml":{"source":"iana","compressible":true,"extensions":["sbml"]},"application/scaip+xml":{"source":"iana","compressible":true},"application/scim+json":{"source":"iana","compressible":true},"application/scvp-cv-request":{"source":"iana","extensions":["scq"]},"application/scvp-cv-response":{"source":"iana","extensions":["scs"]},"application/scvp-vp-request":{"source":"iana","extensions":["spq"]},"application/scvp-vp-response":{"source":"iana","extensions":["spp"]},"application/sdp":{"source":"iana","extensions":["sdp"]},"application/secevent+jwt":{"source":"iana"},"application/senml+cbor":{"source":"iana"},"application/senml+json":{"source":"iana","compressible":true},"application/senml+xml":{"source":"iana","compressible":true,"extensions":["senmlx"]},"application/senml-etch+cbor":{"source":"iana"},"application/senml-etch+json":{"source":"iana","compressible":true},"application/senml-exi":{"source":"iana"},"application/sensml+cbor":{"source":"iana"},"application/sensml+json":{"source":"iana","compressible":true},"application/sensml+xml":{"source":"iana","compressible":true,"extensions":["sensmlx"]},"application/sensml-exi":{"source":"iana"},"application/sep+xml":{"source":"iana","compressible":true},"application/sep-exi":{"source":"iana"},"application/session-info":{"source":"iana"},"application/set-payment":{"source":"iana"},"application/set-payment-initiation":{"source":"iana","extensions":["setpay"]},"application/set-registration":{"source":"iana"},"application/set-registration-initiation":{"source":"iana","extensions":["setreg"]},"application/sgml":{"source":"iana"},"application/sgml-open-catalog":{"source":"iana"},"application/shf+xml":{"source":"iana","compressible":true,"extensions":["shf"]},"application/sieve":{"source":"iana","extensions":["siv","sieve"]},"application/simple-filter+xml":{"source":"iana","compressible":true},"application/simple-message-summary":{"source":"iana"},"application/simplesymbolcontainer":{"source":"iana"},"application/sipc":{"source":"iana"},"application/slate":{"source":"iana"},"application/smil":{"source":"iana"},"application/smil+xml":{"source":"iana","compressible":true,"extensions":["smi","smil"]},"application/smpte336m":{"source":"iana"},"application/soap+fastinfoset":{"source":"iana"},"application/soap+xml":{"source":"iana","compressible":true},"application/sparql-query":{"source":"iana","extensions":["rq"]},"application/sparql-results+xml":{"source":"iana","compressible":true,"extensions":["srx"]},"application/spdx+json":{"source":"iana","compressible":true},"application/spirits-event+xml":{"source":"iana","compressible":true},"application/sql":{"source":"iana"},"application/srgs":{"source":"iana","extensions":["gram"]},"application/srgs+xml":{"source":"iana","compressible":true,"extensions":["grxml"]},"application/sru+xml":{"source":"iana","compressible":true,"extensions":["sru"]},"application/ssdl+xml":{"source":"apache","compressible":true,"extensions":["ssdl"]},"application/ssml+xml":{"source":"iana","compressible":true,"extensions":["ssml"]},"application/stix+json":{"source":"iana","compressible":true},"application/swid+xml":{"source":"iana","compressible":true,"extensions":["swidtag"]},"application/tamp-apex-update":{"source":"iana"},"application/tamp-apex-update-confirm":{"source":"iana"},"application/tamp-community-update":{"source":"iana"},"application/tamp-community-update-confirm":{"source":"iana"},"application/tamp-error":{"source":"iana"},"application/tamp-sequence-adjust":{"source":"iana"},"application/tamp-sequence-adjust-confirm":{"source":"iana"},"application/tamp-status-query":{"source":"iana"},"application/tamp-status-response":{"source":"iana"},"application/tamp-update":{"source":"iana"},"application/tamp-update-confirm":{"source":"iana"},"application/tar":{"compressible":true},"application/taxii+json":{"source":"iana","compressible":true},"application/td+json":{"source":"iana","compressible":true},"application/tei+xml":{"source":"iana","compressible":true,"extensions":["tei","teicorpus"]},"application/tetra_isi":{"source":"iana"},"application/thraud+xml":{"source":"iana","compressible":true,"extensions":["tfi"]},"application/timestamp-query":{"source":"iana"},"application/timestamp-reply":{"source":"iana"},"application/timestamped-data":{"source":"iana","extensions":["tsd"]},"application/tlsrpt+gzip":{"source":"iana"},"application/tlsrpt+json":{"source":"iana","compressible":true},"application/tnauthlist":{"source":"iana"},"application/token-introspection+jwt":{"source":"iana"},"application/toml":{"compressible":true,"extensions":["toml"]},"application/trickle-ice-sdpfrag":{"source":"iana"},"application/trig":{"source":"iana","extensions":["trig"]},"application/ttml+xml":{"source":"iana","compressible":true,"extensions":["ttml"]},"application/tve-trigger":{"source":"iana"},"application/tzif":{"source":"iana"},"application/tzif-leap":{"source":"iana"},"application/ubjson":{"compressible":false,"extensions":["ubj"]},"application/ulpfec":{"source":"iana"},"application/urc-grpsheet+xml":{"source":"iana","compressible":true},"application/urc-ressheet+xml":{"source":"iana","compressible":true,"extensions":["rsheet"]},"application/urc-targetdesc+xml":{"source":"iana","compressible":true,"extensions":["td"]},"application/urc-uisocketdesc+xml":{"source":"iana","compressible":true},"application/vcard+json":{"source":"iana","compressible":true},"application/vcard+xml":{"source":"iana","compressible":true},"application/vemmi":{"source":"iana"},"application/vividence.scriptfile":{"source":"apache"},"application/vnd.1000minds.decision-model+xml":{"source":"iana","compressible":true,"extensions":["1km"]},"application/vnd.3gpp-prose+xml":{"source":"iana","compressible":true},"application/vnd.3gpp-prose-pc3ch+xml":{"source":"iana","compressible":true},"application/vnd.3gpp-v2x-local-service-information":{"source":"iana"},"application/vnd.3gpp.5gnas":{"source":"iana"},"application/vnd.3gpp.access-transfer-events+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.bsf+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.gmop+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.gtpc":{"source":"iana"},"application/vnd.3gpp.interworking-data":{"source":"iana"},"application/vnd.3gpp.lpp":{"source":"iana"},"application/vnd.3gpp.mc-signalling-ear":{"source":"iana"},"application/vnd.3gpp.mcdata-affiliation-command+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcdata-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcdata-payload":{"source":"iana"},"application/vnd.3gpp.mcdata-service-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcdata-signalling":{"source":"iana"},"application/vnd.3gpp.mcdata-ue-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcdata-user-profile+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-affiliation-command+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-floor-request+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-location-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-mbms-usage-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-service-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-signed+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-ue-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-ue-init-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-user-profile+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-affiliation-command+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-affiliation-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-location-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-mbms-usage-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-service-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-transmission-request+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-ue-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-user-profile+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mid-call+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.ngap":{"source":"iana"},"application/vnd.3gpp.pfcp":{"source":"iana"},"application/vnd.3gpp.pic-bw-large":{"source":"iana","extensions":["plb"]},"application/vnd.3gpp.pic-bw-small":{"source":"iana","extensions":["psb"]},"application/vnd.3gpp.pic-bw-var":{"source":"iana","extensions":["pvb"]},"application/vnd.3gpp.s1ap":{"source":"iana"},"application/vnd.3gpp.sms":{"source":"iana"},"application/vnd.3gpp.sms+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.srvcc-ext+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.srvcc-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.state-and-event-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.ussd+xml":{"source":"iana","compressible":true},"application/vnd.3gpp2.bcmcsinfo+xml":{"source":"iana","compressible":true},"application/vnd.3gpp2.sms":{"source":"iana"},"application/vnd.3gpp2.tcap":{"source":"iana","extensions":["tcap"]},"application/vnd.3lightssoftware.imagescal":{"source":"iana"},"application/vnd.3m.post-it-notes":{"source":"iana","extensions":["pwn"]},"application/vnd.accpac.simply.aso":{"source":"iana","extensions":["aso"]},"application/vnd.accpac.simply.imp":{"source":"iana","extensions":["imp"]},"application/vnd.acucobol":{"source":"iana","extensions":["acu"]},"application/vnd.acucorp":{"source":"iana","extensions":["atc","acutc"]},"application/vnd.adobe.air-application-installer-package+zip":{"source":"apache","compressible":false,"extensions":["air"]},"application/vnd.adobe.flash.movie":{"source":"iana"},"application/vnd.adobe.formscentral.fcdt":{"source":"iana","extensions":["fcdt"]},"application/vnd.adobe.fxp":{"source":"iana","extensions":["fxp","fxpl"]},"application/vnd.adobe.partial-upload":{"source":"iana"},"application/vnd.adobe.xdp+xml":{"source":"iana","compressible":true,"extensions":["xdp"]},"application/vnd.adobe.xfdf":{"source":"iana","extensions":["xfdf"]},"application/vnd.aether.imp":{"source":"iana"},"application/vnd.afpc.afplinedata":{"source":"iana"},"application/vnd.afpc.afplinedata-pagedef":{"source":"iana"},"application/vnd.afpc.cmoca-cmresource":{"source":"iana"},"application/vnd.afpc.foca-charset":{"source":"iana"},"application/vnd.afpc.foca-codedfont":{"source":"iana"},"application/vnd.afpc.foca-codepage":{"source":"iana"},"application/vnd.afpc.modca":{"source":"iana"},"application/vnd.afpc.modca-cmtable":{"source":"iana"},"application/vnd.afpc.modca-formdef":{"source":"iana"},"application/vnd.afpc.modca-mediummap":{"source":"iana"},"application/vnd.afpc.modca-objectcontainer":{"source":"iana"},"application/vnd.afpc.modca-overlay":{"source":"iana"},"application/vnd.afpc.modca-pagesegment":{"source":"iana"},"application/vnd.age":{"source":"iana","extensions":["age"]},"application/vnd.ah-barcode":{"source":"iana"},"application/vnd.ahead.space":{"source":"iana","extensions":["ahead"]},"application/vnd.airzip.filesecure.azf":{"source":"iana","extensions":["azf"]},"application/vnd.airzip.filesecure.azs":{"source":"iana","extensions":["azs"]},"application/vnd.amadeus+json":{"source":"iana","compressible":true},"application/vnd.amazon.ebook":{"source":"apache","extensions":["azw"]},"application/vnd.amazon.mobi8-ebook":{"source":"iana"},"application/vnd.americandynamics.acc":{"source":"iana","extensions":["acc"]},"application/vnd.amiga.ami":{"source":"iana","extensions":["ami"]},"application/vnd.amundsen.maze+xml":{"source":"iana","compressible":true},"application/vnd.android.ota":{"source":"iana"},"application/vnd.android.package-archive":{"source":"apache","compressible":false,"extensions":["apk"]},"application/vnd.anki":{"source":"iana"},"application/vnd.anser-web-certificate-issue-initiation":{"source":"iana","extensions":["cii"]},"application/vnd.anser-web-funds-transfer-initiation":{"source":"apache","extensions":["fti"]},"application/vnd.antix.game-component":{"source":"iana","extensions":["atx"]},"application/vnd.apache.arrow.file":{"source":"iana"},"application/vnd.apache.arrow.stream":{"source":"iana"},"application/vnd.apache.thrift.binary":{"source":"iana"},"application/vnd.apache.thrift.compact":{"source":"iana"},"application/vnd.apache.thrift.json":{"source":"iana"},"application/vnd.api+json":{"source":"iana","compressible":true},"application/vnd.aplextor.warrp+json":{"source":"iana","compressible":true},"application/vnd.apothekende.reservation+json":{"source":"iana","compressible":true},"application/vnd.apple.installer+xml":{"source":"iana","compressible":true,"extensions":["mpkg"]},"application/vnd.apple.keynote":{"source":"iana","extensions":["key"]},"application/vnd.apple.mpegurl":{"source":"iana","extensions":["m3u8"]},"application/vnd.apple.numbers":{"source":"iana","extensions":["numbers"]},"application/vnd.apple.pages":{"source":"iana","extensions":["pages"]},"application/vnd.apple.pkpass":{"compressible":false,"extensions":["pkpass"]},"application/vnd.arastra.swi":{"source":"iana"},"application/vnd.aristanetworks.swi":{"source":"iana","extensions":["swi"]},"application/vnd.artisan+json":{"source":"iana","compressible":true},"application/vnd.artsquare":{"source":"iana"},"application/vnd.astraea-software.iota":{"source":"iana","extensions":["iota"]},"application/vnd.audiograph":{"source":"iana","extensions":["aep"]},"application/vnd.autopackage":{"source":"iana"},"application/vnd.avalon+json":{"source":"iana","compressible":true},"application/vnd.avistar+xml":{"source":"iana","compressible":true},"application/vnd.balsamiq.bmml+xml":{"source":"iana","compressible":true,"extensions":["bmml"]},"application/vnd.balsamiq.bmpr":{"source":"iana"},"application/vnd.banana-accounting":{"source":"iana"},"application/vnd.bbf.usp.error":{"source":"iana"},"application/vnd.bbf.usp.msg":{"source":"iana"},"application/vnd.bbf.usp.msg+json":{"source":"iana","compressible":true},"application/vnd.bekitzur-stech+json":{"source":"iana","compressible":true},"application/vnd.bint.med-content":{"source":"iana"},"application/vnd.biopax.rdf+xml":{"source":"iana","compressible":true},"application/vnd.blink-idb-value-wrapper":{"source":"iana"},"application/vnd.blueice.multipass":{"source":"iana","extensions":["mpm"]},"application/vnd.bluetooth.ep.oob":{"source":"iana"},"application/vnd.bluetooth.le.oob":{"source":"iana"},"application/vnd.bmi":{"source":"iana","extensions":["bmi"]},"application/vnd.bpf":{"source":"iana"},"application/vnd.bpf3":{"source":"iana"},"application/vnd.businessobjects":{"source":"iana","extensions":["rep"]},"application/vnd.byu.uapi+json":{"source":"iana","compressible":true},"application/vnd.cab-jscript":{"source":"iana"},"application/vnd.canon-cpdl":{"source":"iana"},"application/vnd.canon-lips":{"source":"iana"},"application/vnd.capasystems-pg+json":{"source":"iana","compressible":true},"application/vnd.cendio.thinlinc.clientconf":{"source":"iana"},"application/vnd.century-systems.tcp_stream":{"source":"iana"},"application/vnd.chemdraw+xml":{"source":"iana","compressible":true,"extensions":["cdxml"]},"application/vnd.chess-pgn":{"source":"iana"},"application/vnd.chipnuts.karaoke-mmd":{"source":"iana","extensions":["mmd"]},"application/vnd.ciedi":{"source":"iana"},"application/vnd.cinderella":{"source":"iana","extensions":["cdy"]},"application/vnd.cirpack.isdn-ext":{"source":"iana"},"application/vnd.citationstyles.style+xml":{"source":"iana","compressible":true,"extensions":["csl"]},"application/vnd.claymore":{"source":"iana","extensions":["cla"]},"application/vnd.cloanto.rp9":{"source":"iana","extensions":["rp9"]},"application/vnd.clonk.c4group":{"source":"iana","extensions":["c4g","c4d","c4f","c4p","c4u"]},"application/vnd.cluetrust.cartomobile-config":{"source":"iana","extensions":["c11amc"]},"application/vnd.cluetrust.cartomobile-config-pkg":{"source":"iana","extensions":["c11amz"]},"application/vnd.coffeescript":{"source":"iana"},"application/vnd.collabio.xodocuments.document":{"source":"iana"},"application/vnd.collabio.xodocuments.document-template":{"source":"iana"},"application/vnd.collabio.xodocuments.presentation":{"source":"iana"},"application/vnd.collabio.xodocuments.presentation-template":{"source":"iana"},"application/vnd.collabio.xodocuments.spreadsheet":{"source":"iana"},"application/vnd.collabio.xodocuments.spreadsheet-template":{"source":"iana"},"application/vnd.collection+json":{"source":"iana","compressible":true},"application/vnd.collection.doc+json":{"source":"iana","compressible":true},"application/vnd.collection.next+json":{"source":"iana","compressible":true},"application/vnd.comicbook+zip":{"source":"iana","compressible":false},"application/vnd.comicbook-rar":{"source":"iana"},"application/vnd.commerce-battelle":{"source":"iana"},"application/vnd.commonspace":{"source":"iana","extensions":["csp"]},"application/vnd.contact.cmsg":{"source":"iana","extensions":["cdbcmsg"]},"application/vnd.coreos.ignition+json":{"source":"iana","compressible":true},"application/vnd.cosmocaller":{"source":"iana","extensions":["cmc"]},"application/vnd.crick.clicker":{"source":"iana","extensions":["clkx"]},"application/vnd.crick.clicker.keyboard":{"source":"iana","extensions":["clkk"]},"application/vnd.crick.clicker.palette":{"source":"iana","extensions":["clkp"]},"application/vnd.crick.clicker.template":{"source":"iana","extensions":["clkt"]},"application/vnd.crick.clicker.wordbank":{"source":"iana","extensions":["clkw"]},"application/vnd.criticaltools.wbs+xml":{"source":"iana","compressible":true,"extensions":["wbs"]},"application/vnd.cryptii.pipe+json":{"source":"iana","compressible":true},"application/vnd.crypto-shade-file":{"source":"iana"},"application/vnd.cryptomator.encrypted":{"source":"iana"},"application/vnd.cryptomator.vault":{"source":"iana"},"application/vnd.ctc-posml":{"source":"iana","extensions":["pml"]},"application/vnd.ctct.ws+xml":{"source":"iana","compressible":true},"application/vnd.cups-pdf":{"source":"iana"},"application/vnd.cups-postscript":{"source":"iana"},"application/vnd.cups-ppd":{"source":"iana","extensions":["ppd"]},"application/vnd.cups-raster":{"source":"iana"},"application/vnd.cups-raw":{"source":"iana"},"application/vnd.curl":{"source":"iana"},"application/vnd.curl.car":{"source":"apache","extensions":["car"]},"application/vnd.curl.pcurl":{"source":"apache","extensions":["pcurl"]},"application/vnd.cyan.dean.root+xml":{"source":"iana","compressible":true},"application/vnd.cybank":{"source":"iana"},"application/vnd.cyclonedx+json":{"source":"iana","compressible":true},"application/vnd.cyclonedx+xml":{"source":"iana","compressible":true},"application/vnd.d2l.coursepackage1p0+zip":{"source":"iana","compressible":false},"application/vnd.d3m-dataset":{"source":"iana"},"application/vnd.d3m-problem":{"source":"iana"},"application/vnd.dart":{"source":"iana","compressible":true,"extensions":["dart"]},"application/vnd.data-vision.rdz":{"source":"iana","extensions":["rdz"]},"application/vnd.datapackage+json":{"source":"iana","compressible":true},"application/vnd.dataresource+json":{"source":"iana","compressible":true},"application/vnd.dbf":{"source":"iana","extensions":["dbf"]},"application/vnd.debian.binary-package":{"source":"iana"},"application/vnd.dece.data":{"source":"iana","extensions":["uvf","uvvf","uvd","uvvd"]},"application/vnd.dece.ttml+xml":{"source":"iana","compressible":true,"extensions":["uvt","uvvt"]},"application/vnd.dece.unspecified":{"source":"iana","extensions":["uvx","uvvx"]},"application/vnd.dece.zip":{"source":"iana","extensions":["uvz","uvvz"]},"application/vnd.denovo.fcselayout-link":{"source":"iana","extensions":["fe_launch"]},"application/vnd.desmume.movie":{"source":"iana"},"application/vnd.dir-bi.plate-dl-nosuffix":{"source":"iana"},"application/vnd.dm.delegation+xml":{"source":"iana","compressible":true},"application/vnd.dna":{"source":"iana","extensions":["dna"]},"application/vnd.document+json":{"source":"iana","compressible":true},"application/vnd.dolby.mlp":{"source":"apache","extensions":["mlp"]},"application/vnd.dolby.mobile.1":{"source":"iana"},"application/vnd.dolby.mobile.2":{"source":"iana"},"application/vnd.doremir.scorecloud-binary-document":{"source":"iana"},"application/vnd.dpgraph":{"source":"iana","extensions":["dpg"]},"application/vnd.dreamfactory":{"source":"iana","extensions":["dfac"]},"application/vnd.drive+json":{"source":"iana","compressible":true},"application/vnd.ds-keypoint":{"source":"apache","extensions":["kpxx"]},"application/vnd.dtg.local":{"source":"iana"},"application/vnd.dtg.local.flash":{"source":"iana"},"application/vnd.dtg.local.html":{"source":"iana"},"application/vnd.dvb.ait":{"source":"iana","extensions":["ait"]},"application/vnd.dvb.dvbisl+xml":{"source":"iana","compressible":true},"application/vnd.dvb.dvbj":{"source":"iana"},"application/vnd.dvb.esgcontainer":{"source":"iana"},"application/vnd.dvb.ipdcdftnotifaccess":{"source":"iana"},"application/vnd.dvb.ipdcesgaccess":{"source":"iana"},"application/vnd.dvb.ipdcesgaccess2":{"source":"iana"},"application/vnd.dvb.ipdcesgpdd":{"source":"iana"},"application/vnd.dvb.ipdcroaming":{"source":"iana"},"application/vnd.dvb.iptv.alfec-base":{"source":"iana"},"application/vnd.dvb.iptv.alfec-enhancement":{"source":"iana"},"application/vnd.dvb.notif-aggregate-root+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-container+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-generic+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-ia-msglist+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-ia-registration-request+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-ia-registration-response+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-init+xml":{"source":"iana","compressible":true},"application/vnd.dvb.pfr":{"source":"iana"},"application/vnd.dvb.service":{"source":"iana","extensions":["svc"]},"application/vnd.dxr":{"source":"iana"},"application/vnd.dynageo":{"source":"iana","extensions":["geo"]},"application/vnd.dzr":{"source":"iana"},"application/vnd.easykaraoke.cdgdownload":{"source":"iana"},"application/vnd.ecdis-update":{"source":"iana"},"application/vnd.ecip.rlp":{"source":"iana"},"application/vnd.eclipse.ditto+json":{"source":"iana","compressible":true},"application/vnd.ecowin.chart":{"source":"iana","extensions":["mag"]},"application/vnd.ecowin.filerequest":{"source":"iana"},"application/vnd.ecowin.fileupdate":{"source":"iana"},"application/vnd.ecowin.series":{"source":"iana"},"application/vnd.ecowin.seriesrequest":{"source":"iana"},"application/vnd.ecowin.seriesupdate":{"source":"iana"},"application/vnd.efi.img":{"source":"iana"},"application/vnd.efi.iso":{"source":"iana"},"application/vnd.emclient.accessrequest+xml":{"source":"iana","compressible":true},"application/vnd.enliven":{"source":"iana","extensions":["nml"]},"application/vnd.enphase.envoy":{"source":"iana"},"application/vnd.eprints.data+xml":{"source":"iana","compressible":true},"application/vnd.epson.esf":{"source":"iana","extensions":["esf"]},"application/vnd.epson.msf":{"source":"iana","extensions":["msf"]},"application/vnd.epson.quickanime":{"source":"iana","extensions":["qam"]},"application/vnd.epson.salt":{"source":"iana","extensions":["slt"]},"application/vnd.epson.ssf":{"source":"iana","extensions":["ssf"]},"application/vnd.ericsson.quickcall":{"source":"iana"},"application/vnd.espass-espass+zip":{"source":"iana","compressible":false},"application/vnd.eszigno3+xml":{"source":"iana","compressible":true,"extensions":["es3","et3"]},"application/vnd.etsi.aoc+xml":{"source":"iana","compressible":true},"application/vnd.etsi.asic-e+zip":{"source":"iana","compressible":false},"application/vnd.etsi.asic-s+zip":{"source":"iana","compressible":false},"application/vnd.etsi.cug+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvcommand+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvdiscovery+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvprofile+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsad-bc+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsad-cod+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsad-npvr+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvservice+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsync+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvueprofile+xml":{"source":"iana","compressible":true},"application/vnd.etsi.mcid+xml":{"source":"iana","compressible":true},"application/vnd.etsi.mheg5":{"source":"iana"},"application/vnd.etsi.overload-control-policy-dataset+xml":{"source":"iana","compressible":true},"application/vnd.etsi.pstn+xml":{"source":"iana","compressible":true},"application/vnd.etsi.sci+xml":{"source":"iana","compressible":true},"application/vnd.etsi.simservs+xml":{"source":"iana","compressible":true},"application/vnd.etsi.timestamp-token":{"source":"iana"},"application/vnd.etsi.tsl+xml":{"source":"iana","compressible":true},"application/vnd.etsi.tsl.der":{"source":"iana"},"application/vnd.eu.kasparian.car+json":{"source":"iana","compressible":true},"application/vnd.eudora.data":{"source":"iana"},"application/vnd.evolv.ecig.profile":{"source":"iana"},"application/vnd.evolv.ecig.settings":{"source":"iana"},"application/vnd.evolv.ecig.theme":{"source":"iana"},"application/vnd.exstream-empower+zip":{"source":"iana","compressible":false},"application/vnd.exstream-package":{"source":"iana"},"application/vnd.ezpix-album":{"source":"iana","extensions":["ez2"]},"application/vnd.ezpix-package":{"source":"iana","extensions":["ez3"]},"application/vnd.f-secure.mobile":{"source":"iana"},"application/vnd.familysearch.gedcom+zip":{"source":"iana","compressible":false},"application/vnd.fastcopy-disk-image":{"source":"iana"},"application/vnd.fdf":{"source":"iana","extensions":["fdf"]},"application/vnd.fdsn.mseed":{"source":"iana","extensions":["mseed"]},"application/vnd.fdsn.seed":{"source":"iana","extensions":["seed","dataless"]},"application/vnd.ffsns":{"source":"iana"},"application/vnd.ficlab.flb+zip":{"source":"iana","compressible":false},"application/vnd.filmit.zfc":{"source":"iana"},"application/vnd.fints":{"source":"iana"},"application/vnd.firemonkeys.cloudcell":{"source":"iana"},"application/vnd.flographit":{"source":"iana","extensions":["gph"]},"application/vnd.fluxtime.clip":{"source":"iana","extensions":["ftc"]},"application/vnd.font-fontforge-sfd":{"source":"iana"},"application/vnd.framemaker":{"source":"iana","extensions":["fm","frame","maker","book"]},"application/vnd.frogans.fnc":{"source":"iana","extensions":["fnc"]},"application/vnd.frogans.ltf":{"source":"iana","extensions":["ltf"]},"application/vnd.fsc.weblaunch":{"source":"iana","extensions":["fsc"]},"application/vnd.fujifilm.fb.docuworks":{"source":"iana"},"application/vnd.fujifilm.fb.docuworks.binder":{"source":"iana"},"application/vnd.fujifilm.fb.docuworks.container":{"source":"iana"},"application/vnd.fujifilm.fb.jfi+xml":{"source":"iana","compressible":true},"application/vnd.fujitsu.oasys":{"source":"iana","extensions":["oas"]},"application/vnd.fujitsu.oasys2":{"source":"iana","extensions":["oa2"]},"application/vnd.fujitsu.oasys3":{"source":"iana","extensions":["oa3"]},"application/vnd.fujitsu.oasysgp":{"source":"iana","extensions":["fg5"]},"application/vnd.fujitsu.oasysprs":{"source":"iana","extensions":["bh2"]},"application/vnd.fujixerox.art-ex":{"source":"iana"},"application/vnd.fujixerox.art4":{"source":"iana"},"application/vnd.fujixerox.ddd":{"source":"iana","extensions":["ddd"]},"application/vnd.fujixerox.docuworks":{"source":"iana","extensions":["xdw"]},"application/vnd.fujixerox.docuworks.binder":{"source":"iana","extensions":["xbd"]},"application/vnd.fujixerox.docuworks.container":{"source":"iana"},"application/vnd.fujixerox.hbpl":{"source":"iana"},"application/vnd.fut-misnet":{"source":"iana"},"application/vnd.futoin+cbor":{"source":"iana"},"application/vnd.futoin+json":{"source":"iana","compressible":true},"application/vnd.fuzzysheet":{"source":"iana","extensions":["fzs"]},"application/vnd.genomatix.tuxedo":{"source":"iana","extensions":["txd"]},"application/vnd.gentics.grd+json":{"source":"iana","compressible":true},"application/vnd.geo+json":{"source":"iana","compressible":true},"application/vnd.geocube+xml":{"source":"iana","compressible":true},"application/vnd.geogebra.file":{"source":"iana","extensions":["ggb"]},"application/vnd.geogebra.slides":{"source":"iana"},"application/vnd.geogebra.tool":{"source":"iana","extensions":["ggt"]},"application/vnd.geometry-explorer":{"source":"iana","extensions":["gex","gre"]},"application/vnd.geonext":{"source":"iana","extensions":["gxt"]},"application/vnd.geoplan":{"source":"iana","extensions":["g2w"]},"application/vnd.geospace":{"source":"iana","extensions":["g3w"]},"application/vnd.gerber":{"source":"iana"},"application/vnd.globalplatform.card-content-mgt":{"source":"iana"},"application/vnd.globalplatform.card-content-mgt-response":{"source":"iana"},"application/vnd.gmx":{"source":"iana","extensions":["gmx"]},"application/vnd.google-apps.document":{"compressible":false,"extensions":["gdoc"]},"application/vnd.google-apps.presentation":{"compressible":false,"extensions":["gslides"]},"application/vnd.google-apps.spreadsheet":{"compressible":false,"extensions":["gsheet"]},"application/vnd.google-earth.kml+xml":{"source":"iana","compressible":true,"extensions":["kml"]},"application/vnd.google-earth.kmz":{"source":"iana","compressible":false,"extensions":["kmz"]},"application/vnd.gov.sk.e-form+xml":{"source":"iana","compressible":true},"application/vnd.gov.sk.e-form+zip":{"source":"iana","compressible":false},"application/vnd.gov.sk.xmldatacontainer+xml":{"source":"iana","compressible":true},"application/vnd.grafeq":{"source":"iana","extensions":["gqf","gqs"]},"application/vnd.gridmp":{"source":"iana"},"application/vnd.groove-account":{"source":"iana","extensions":["gac"]},"application/vnd.groove-help":{"source":"iana","extensions":["ghf"]},"application/vnd.groove-identity-message":{"source":"iana","extensions":["gim"]},"application/vnd.groove-injector":{"source":"iana","extensions":["grv"]},"application/vnd.groove-tool-message":{"source":"iana","extensions":["gtm"]},"application/vnd.groove-tool-template":{"source":"iana","extensions":["tpl"]},"application/vnd.groove-vcard":{"source":"iana","extensions":["vcg"]},"application/vnd.hal+json":{"source":"iana","compressible":true},"application/vnd.hal+xml":{"source":"iana","compressible":true,"extensions":["hal"]},"application/vnd.handheld-entertainment+xml":{"source":"iana","compressible":true,"extensions":["zmm"]},"application/vnd.hbci":{"source":"iana","extensions":["hbci"]},"application/vnd.hc+json":{"source":"iana","compressible":true},"application/vnd.hcl-bireports":{"source":"iana"},"application/vnd.hdt":{"source":"iana"},"application/vnd.heroku+json":{"source":"iana","compressible":true},"application/vnd.hhe.lesson-player":{"source":"iana","extensions":["les"]},"application/vnd.hl7cda+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.hl7v2+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.hp-hpgl":{"source":"iana","extensions":["hpgl"]},"application/vnd.hp-hpid":{"source":"iana","extensions":["hpid"]},"application/vnd.hp-hps":{"source":"iana","extensions":["hps"]},"application/vnd.hp-jlyt":{"source":"iana","extensions":["jlt"]},"application/vnd.hp-pcl":{"source":"iana","extensions":["pcl"]},"application/vnd.hp-pclxl":{"source":"iana","extensions":["pclxl"]},"application/vnd.httphone":{"source":"iana"},"application/vnd.hydrostatix.sof-data":{"source":"iana","extensions":["sfd-hdstx"]},"application/vnd.hyper+json":{"source":"iana","compressible":true},"application/vnd.hyper-item+json":{"source":"iana","compressible":true},"application/vnd.hyperdrive+json":{"source":"iana","compressible":true},"application/vnd.hzn-3d-crossword":{"source":"iana"},"application/vnd.ibm.afplinedata":{"source":"iana"},"application/vnd.ibm.electronic-media":{"source":"iana"},"application/vnd.ibm.minipay":{"source":"iana","extensions":["mpy"]},"application/vnd.ibm.modcap":{"source":"iana","extensions":["afp","listafp","list3820"]},"application/vnd.ibm.rights-management":{"source":"iana","extensions":["irm"]},"application/vnd.ibm.secure-container":{"source":"iana","extensions":["sc"]},"application/vnd.iccprofile":{"source":"iana","extensions":["icc","icm"]},"application/vnd.ieee.1905":{"source":"iana"},"application/vnd.igloader":{"source":"iana","extensions":["igl"]},"application/vnd.imagemeter.folder+zip":{"source":"iana","compressible":false},"application/vnd.imagemeter.image+zip":{"source":"iana","compressible":false},"application/vnd.immervision-ivp":{"source":"iana","extensions":["ivp"]},"application/vnd.immervision-ivu":{"source":"iana","extensions":["ivu"]},"application/vnd.ims.imsccv1p1":{"source":"iana"},"application/vnd.ims.imsccv1p2":{"source":"iana"},"application/vnd.ims.imsccv1p3":{"source":"iana"},"application/vnd.ims.lis.v2.result+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolconsumerprofile+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolproxy+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolproxy.id+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolsettings+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolsettings.simple+json":{"source":"iana","compressible":true},"application/vnd.informedcontrol.rms+xml":{"source":"iana","compressible":true},"application/vnd.informix-visionary":{"source":"iana"},"application/vnd.infotech.project":{"source":"iana"},"application/vnd.infotech.project+xml":{"source":"iana","compressible":true},"application/vnd.innopath.wamp.notification":{"source":"iana"},"application/vnd.insors.igm":{"source":"iana","extensions":["igm"]},"application/vnd.intercon.formnet":{"source":"iana","extensions":["xpw","xpx"]},"application/vnd.intergeo":{"source":"iana","extensions":["i2g"]},"application/vnd.intertrust.digibox":{"source":"iana"},"application/vnd.intertrust.nncp":{"source":"iana"},"application/vnd.intu.qbo":{"source":"iana","extensions":["qbo"]},"application/vnd.intu.qfx":{"source":"iana","extensions":["qfx"]},"application/vnd.iptc.g2.catalogitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.conceptitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.knowledgeitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.newsitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.newsmessage+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.packageitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.planningitem+xml":{"source":"iana","compressible":true},"application/vnd.ipunplugged.rcprofile":{"source":"iana","extensions":["rcprofile"]},"application/vnd.irepository.package+xml":{"source":"iana","compressible":true,"extensions":["irp"]},"application/vnd.is-xpr":{"source":"iana","extensions":["xpr"]},"application/vnd.isac.fcs":{"source":"iana","extensions":["fcs"]},"application/vnd.iso11783-10+zip":{"source":"iana","compressible":false},"application/vnd.jam":{"source":"iana","extensions":["jam"]},"application/vnd.japannet-directory-service":{"source":"iana"},"application/vnd.japannet-jpnstore-wakeup":{"source":"iana"},"application/vnd.japannet-payment-wakeup":{"source":"iana"},"application/vnd.japannet-registration":{"source":"iana"},"application/vnd.japannet-registration-wakeup":{"source":"iana"},"application/vnd.japannet-setstore-wakeup":{"source":"iana"},"application/vnd.japannet-verification":{"source":"iana"},"application/vnd.japannet-verification-wakeup":{"source":"iana"},"application/vnd.jcp.javame.midlet-rms":{"source":"iana","extensions":["rms"]},"application/vnd.jisp":{"source":"iana","extensions":["jisp"]},"application/vnd.joost.joda-archive":{"source":"iana","extensions":["joda"]},"application/vnd.jsk.isdn-ngn":{"source":"iana"},"application/vnd.kahootz":{"source":"iana","extensions":["ktz","ktr"]},"application/vnd.kde.karbon":{"source":"iana","extensions":["karbon"]},"application/vnd.kde.kchart":{"source":"iana","extensions":["chrt"]},"application/vnd.kde.kformula":{"source":"iana","extensions":["kfo"]},"application/vnd.kde.kivio":{"source":"iana","extensions":["flw"]},"application/vnd.kde.kontour":{"source":"iana","extensions":["kon"]},"application/vnd.kde.kpresenter":{"source":"iana","extensions":["kpr","kpt"]},"application/vnd.kde.kspread":{"source":"iana","extensions":["ksp"]},"application/vnd.kde.kword":{"source":"iana","extensions":["kwd","kwt"]},"application/vnd.kenameaapp":{"source":"iana","extensions":["htke"]},"application/vnd.kidspiration":{"source":"iana","extensions":["kia"]},"application/vnd.kinar":{"source":"iana","extensions":["kne","knp"]},"application/vnd.koan":{"source":"iana","extensions":["skp","skd","skt","skm"]},"application/vnd.kodak-descriptor":{"source":"iana","extensions":["sse"]},"application/vnd.las":{"source":"iana"},"application/vnd.las.las+json":{"source":"iana","compressible":true},"application/vnd.las.las+xml":{"source":"iana","compressible":true,"extensions":["lasxml"]},"application/vnd.laszip":{"source":"iana"},"application/vnd.leap+json":{"source":"iana","compressible":true},"application/vnd.liberty-request+xml":{"source":"iana","compressible":true},"application/vnd.llamagraphics.life-balance.desktop":{"source":"iana","extensions":["lbd"]},"application/vnd.llamagraphics.life-balance.exchange+xml":{"source":"iana","compressible":true,"extensions":["lbe"]},"application/vnd.logipipe.circuit+zip":{"source":"iana","compressible":false},"application/vnd.loom":{"source":"iana"},"application/vnd.lotus-1-2-3":{"source":"iana","extensions":["123"]},"application/vnd.lotus-approach":{"source":"iana","extensions":["apr"]},"application/vnd.lotus-freelance":{"source":"iana","extensions":["pre"]},"application/vnd.lotus-notes":{"source":"iana","extensions":["nsf"]},"application/vnd.lotus-organizer":{"source":"iana","extensions":["org"]},"application/vnd.lotus-screencam":{"source":"iana","extensions":["scm"]},"application/vnd.lotus-wordpro":{"source":"iana","extensions":["lwp"]},"application/vnd.macports.portpkg":{"source":"iana","extensions":["portpkg"]},"application/vnd.mapbox-vector-tile":{"source":"iana","extensions":["mvt"]},"application/vnd.marlin.drm.actiontoken+xml":{"source":"iana","compressible":true},"application/vnd.marlin.drm.conftoken+xml":{"source":"iana","compressible":true},"application/vnd.marlin.drm.license+xml":{"source":"iana","compressible":true},"application/vnd.marlin.drm.mdcf":{"source":"iana"},"application/vnd.mason+json":{"source":"iana","compressible":true},"application/vnd.maxar.archive.3tz+zip":{"source":"iana","compressible":false},"application/vnd.maxmind.maxmind-db":{"source":"iana"},"application/vnd.mcd":{"source":"iana","extensions":["mcd"]},"application/vnd.medcalcdata":{"source":"iana","extensions":["mc1"]},"application/vnd.mediastation.cdkey":{"source":"iana","extensions":["cdkey"]},"application/vnd.meridian-slingshot":{"source":"iana"},"application/vnd.mfer":{"source":"iana","extensions":["mwf"]},"application/vnd.mfmp":{"source":"iana","extensions":["mfm"]},"application/vnd.micro+json":{"source":"iana","compressible":true},"application/vnd.micrografx.flo":{"source":"iana","extensions":["flo"]},"application/vnd.micrografx.igx":{"source":"iana","extensions":["igx"]},"application/vnd.microsoft.portable-executable":{"source":"iana"},"application/vnd.microsoft.windows.thumbnail-cache":{"source":"iana"},"application/vnd.miele+json":{"source":"iana","compressible":true},"application/vnd.mif":{"source":"iana","extensions":["mif"]},"application/vnd.minisoft-hp3000-save":{"source":"iana"},"application/vnd.mitsubishi.misty-guard.trustweb":{"source":"iana"},"application/vnd.mobius.daf":{"source":"iana","extensions":["daf"]},"application/vnd.mobius.dis":{"source":"iana","extensions":["dis"]},"application/vnd.mobius.mbk":{"source":"iana","extensions":["mbk"]},"application/vnd.mobius.mqy":{"source":"iana","extensions":["mqy"]},"application/vnd.mobius.msl":{"source":"iana","extensions":["msl"]},"application/vnd.mobius.plc":{"source":"iana","extensions":["plc"]},"application/vnd.mobius.txf":{"source":"iana","extensions":["txf"]},"application/vnd.mophun.application":{"source":"iana","extensions":["mpn"]},"application/vnd.mophun.certificate":{"source":"iana","extensions":["mpc"]},"application/vnd.motorola.flexsuite":{"source":"iana"},"application/vnd.motorola.flexsuite.adsi":{"source":"iana"},"application/vnd.motorola.flexsuite.fis":{"source":"iana"},"application/vnd.motorola.flexsuite.gotap":{"source":"iana"},"application/vnd.motorola.flexsuite.kmr":{"source":"iana"},"application/vnd.motorola.flexsuite.ttc":{"source":"iana"},"application/vnd.motorola.flexsuite.wem":{"source":"iana"},"application/vnd.motorola.iprm":{"source":"iana"},"application/vnd.mozilla.xul+xml":{"source":"iana","compressible":true,"extensions":["xul"]},"application/vnd.ms-3mfdocument":{"source":"iana"},"application/vnd.ms-artgalry":{"source":"iana","extensions":["cil"]},"application/vnd.ms-asf":{"source":"iana"},"application/vnd.ms-cab-compressed":{"source":"iana","extensions":["cab"]},"application/vnd.ms-color.iccprofile":{"source":"apache"},"application/vnd.ms-excel":{"source":"iana","compressible":false,"extensions":["xls","xlm","xla","xlc","xlt","xlw"]},"application/vnd.ms-excel.addin.macroenabled.12":{"source":"iana","extensions":["xlam"]},"application/vnd.ms-excel.sheet.binary.macroenabled.12":{"source":"iana","extensions":["xlsb"]},"application/vnd.ms-excel.sheet.macroenabled.12":{"source":"iana","extensions":["xlsm"]},"application/vnd.ms-excel.template.macroenabled.12":{"source":"iana","extensions":["xltm"]},"application/vnd.ms-fontobject":{"source":"iana","compressible":true,"extensions":["eot"]},"application/vnd.ms-htmlhelp":{"source":"iana","extensions":["chm"]},"application/vnd.ms-ims":{"source":"iana","extensions":["ims"]},"application/vnd.ms-lrm":{"source":"iana","extensions":["lrm"]},"application/vnd.ms-office.activex+xml":{"source":"iana","compressible":true},"application/vnd.ms-officetheme":{"source":"iana","extensions":["thmx"]},"application/vnd.ms-opentype":{"source":"apache","compressible":true},"application/vnd.ms-outlook":{"compressible":false,"extensions":["msg"]},"application/vnd.ms-package.obfuscated-opentype":{"source":"apache"},"application/vnd.ms-pki.seccat":{"source":"apache","extensions":["cat"]},"application/vnd.ms-pki.stl":{"source":"apache","extensions":["stl"]},"application/vnd.ms-playready.initiator+xml":{"source":"iana","compressible":true},"application/vnd.ms-powerpoint":{"source":"iana","compressible":false,"extensions":["ppt","pps","pot"]},"application/vnd.ms-powerpoint.addin.macroenabled.12":{"source":"iana","extensions":["ppam"]},"application/vnd.ms-powerpoint.presentation.macroenabled.12":{"source":"iana","extensions":["pptm"]},"application/vnd.ms-powerpoint.slide.macroenabled.12":{"source":"iana","extensions":["sldm"]},"application/vnd.ms-powerpoint.slideshow.macroenabled.12":{"source":"iana","extensions":["ppsm"]},"application/vnd.ms-powerpoint.template.macroenabled.12":{"source":"iana","extensions":["potm"]},"application/vnd.ms-printdevicecapabilities+xml":{"source":"iana","compressible":true},"application/vnd.ms-printing.printticket+xml":{"source":"apache","compressible":true},"application/vnd.ms-printschematicket+xml":{"source":"iana","compressible":true},"application/vnd.ms-project":{"source":"iana","extensions":["mpp","mpt"]},"application/vnd.ms-tnef":{"source":"iana"},"application/vnd.ms-windows.devicepairing":{"source":"iana"},"application/vnd.ms-windows.nwprinting.oob":{"source":"iana"},"application/vnd.ms-windows.printerpairing":{"source":"iana"},"application/vnd.ms-windows.wsd.oob":{"source":"iana"},"application/vnd.ms-wmdrm.lic-chlg-req":{"source":"iana"},"application/vnd.ms-wmdrm.lic-resp":{"source":"iana"},"application/vnd.ms-wmdrm.meter-chlg-req":{"source":"iana"},"application/vnd.ms-wmdrm.meter-resp":{"source":"iana"},"application/vnd.ms-word.document.macroenabled.12":{"source":"iana","extensions":["docm"]},"application/vnd.ms-word.template.macroenabled.12":{"source":"iana","extensions":["dotm"]},"application/vnd.ms-works":{"source":"iana","extensions":["wps","wks","wcm","wdb"]},"application/vnd.ms-wpl":{"source":"iana","extensions":["wpl"]},"application/vnd.ms-xpsdocument":{"source":"iana","compressible":false,"extensions":["xps"]},"application/vnd.msa-disk-image":{"source":"iana"},"application/vnd.mseq":{"source":"iana","extensions":["mseq"]},"application/vnd.msign":{"source":"iana"},"application/vnd.multiad.creator":{"source":"iana"},"application/vnd.multiad.creator.cif":{"source":"iana"},"application/vnd.music-niff":{"source":"iana"},"application/vnd.musician":{"source":"iana","extensions":["mus"]},"application/vnd.muvee.style":{"source":"iana","extensions":["msty"]},"application/vnd.mynfc":{"source":"iana","extensions":["taglet"]},"application/vnd.nacamar.ybrid+json":{"source":"iana","compressible":true},"application/vnd.ncd.control":{"source":"iana"},"application/vnd.ncd.reference":{"source":"iana"},"application/vnd.nearst.inv+json":{"source":"iana","compressible":true},"application/vnd.nebumind.line":{"source":"iana"},"application/vnd.nervana":{"source":"iana"},"application/vnd.netfpx":{"source":"iana"},"application/vnd.neurolanguage.nlu":{"source":"iana","extensions":["nlu"]},"application/vnd.nimn":{"source":"iana"},"application/vnd.nintendo.nitro.rom":{"source":"iana"},"application/vnd.nintendo.snes.rom":{"source":"iana"},"application/vnd.nitf":{"source":"iana","extensions":["ntf","nitf"]},"application/vnd.noblenet-directory":{"source":"iana","extensions":["nnd"]},"application/vnd.noblenet-sealer":{"source":"iana","extensions":["nns"]},"application/vnd.noblenet-web":{"source":"iana","extensions":["nnw"]},"application/vnd.nokia.catalogs":{"source":"iana"},"application/vnd.nokia.conml+wbxml":{"source":"iana"},"application/vnd.nokia.conml+xml":{"source":"iana","compressible":true},"application/vnd.nokia.iptv.config+xml":{"source":"iana","compressible":true},"application/vnd.nokia.isds-radio-presets":{"source":"iana"},"application/vnd.nokia.landmark+wbxml":{"source":"iana"},"application/vnd.nokia.landmark+xml":{"source":"iana","compressible":true},"application/vnd.nokia.landmarkcollection+xml":{"source":"iana","compressible":true},"application/vnd.nokia.n-gage.ac+xml":{"source":"iana","compressible":true,"extensions":["ac"]},"application/vnd.nokia.n-gage.data":{"source":"iana","extensions":["ngdat"]},"application/vnd.nokia.n-gage.symbian.install":{"source":"iana","extensions":["n-gage"]},"application/vnd.nokia.ncd":{"source":"iana"},"application/vnd.nokia.pcd+wbxml":{"source":"iana"},"application/vnd.nokia.pcd+xml":{"source":"iana","compressible":true},"application/vnd.nokia.radio-preset":{"source":"iana","extensions":["rpst"]},"application/vnd.nokia.radio-presets":{"source":"iana","extensions":["rpss"]},"application/vnd.novadigm.edm":{"source":"iana","extensions":["edm"]},"application/vnd.novadigm.edx":{"source":"iana","extensions":["edx"]},"application/vnd.novadigm.ext":{"source":"iana","extensions":["ext"]},"application/vnd.ntt-local.content-share":{"source":"iana"},"application/vnd.ntt-local.file-transfer":{"source":"iana"},"application/vnd.ntt-local.ogw_remote-access":{"source":"iana"},"application/vnd.ntt-local.sip-ta_remote":{"source":"iana"},"application/vnd.ntt-local.sip-ta_tcp_stream":{"source":"iana"},"application/vnd.oasis.opendocument.chart":{"source":"iana","extensions":["odc"]},"application/vnd.oasis.opendocument.chart-template":{"source":"iana","extensions":["otc"]},"application/vnd.oasis.opendocument.database":{"source":"iana","extensions":["odb"]},"application/vnd.oasis.opendocument.formula":{"source":"iana","extensions":["odf"]},"application/vnd.oasis.opendocument.formula-template":{"source":"iana","extensions":["odft"]},"application/vnd.oasis.opendocument.graphics":{"source":"iana","compressible":false,"extensions":["odg"]},"application/vnd.oasis.opendocument.graphics-template":{"source":"iana","extensions":["otg"]},"application/vnd.oasis.opendocument.image":{"source":"iana","extensions":["odi"]},"application/vnd.oasis.opendocument.image-template":{"source":"iana","extensions":["oti"]},"application/vnd.oasis.opendocument.presentation":{"source":"iana","compressible":false,"extensions":["odp"]},"application/vnd.oasis.opendocument.presentation-template":{"source":"iana","extensions":["otp"]},"application/vnd.oasis.opendocument.spreadsheet":{"source":"iana","compressible":false,"extensions":["ods"]},"application/vnd.oasis.opendocument.spreadsheet-template":{"source":"iana","extensions":["ots"]},"application/vnd.oasis.opendocument.text":{"source":"iana","compressible":false,"extensions":["odt"]},"application/vnd.oasis.opendocument.text-master":{"source":"iana","extensions":["odm"]},"application/vnd.oasis.opendocument.text-template":{"source":"iana","extensions":["ott"]},"application/vnd.oasis.opendocument.text-web":{"source":"iana","extensions":["oth"]},"application/vnd.obn":{"source":"iana"},"application/vnd.ocf+cbor":{"source":"iana"},"application/vnd.oci.image.manifest.v1+json":{"source":"iana","compressible":true},"application/vnd.oftn.l10n+json":{"source":"iana","compressible":true},"application/vnd.oipf.contentaccessdownload+xml":{"source":"iana","compressible":true},"application/vnd.oipf.contentaccessstreaming+xml":{"source":"iana","compressible":true},"application/vnd.oipf.cspg-hexbinary":{"source":"iana"},"application/vnd.oipf.dae.svg+xml":{"source":"iana","compressible":true},"application/vnd.oipf.dae.xhtml+xml":{"source":"iana","compressible":true},"application/vnd.oipf.mippvcontrolmessage+xml":{"source":"iana","compressible":true},"application/vnd.oipf.pae.gem":{"source":"iana"},"application/vnd.oipf.spdiscovery+xml":{"source":"iana","compressible":true},"application/vnd.oipf.spdlist+xml":{"source":"iana","compressible":true},"application/vnd.oipf.ueprofile+xml":{"source":"iana","compressible":true},"application/vnd.oipf.userprofile+xml":{"source":"iana","compressible":true},"application/vnd.olpc-sugar":{"source":"iana","extensions":["xo"]},"application/vnd.oma-scws-config":{"source":"iana"},"application/vnd.oma-scws-http-request":{"source":"iana"},"application/vnd.oma-scws-http-response":{"source":"iana"},"application/vnd.oma.bcast.associated-procedure-parameter+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.drm-trigger+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.imd+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.ltkm":{"source":"iana"},"application/vnd.oma.bcast.notification+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.provisioningtrigger":{"source":"iana"},"application/vnd.oma.bcast.sgboot":{"source":"iana"},"application/vnd.oma.bcast.sgdd+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.sgdu":{"source":"iana"},"application/vnd.oma.bcast.simple-symbol-container":{"source":"iana"},"application/vnd.oma.bcast.smartcard-trigger+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.sprov+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.stkm":{"source":"iana"},"application/vnd.oma.cab-address-book+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-feature-handler+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-pcc+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-subs-invite+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-user-prefs+xml":{"source":"iana","compressible":true},"application/vnd.oma.dcd":{"source":"iana"},"application/vnd.oma.dcdc":{"source":"iana"},"application/vnd.oma.dd2+xml":{"source":"iana","compressible":true,"extensions":["dd2"]},"application/vnd.oma.drm.risd+xml":{"source":"iana","compressible":true},"application/vnd.oma.group-usage-list+xml":{"source":"iana","compressible":true},"application/vnd.oma.lwm2m+cbor":{"source":"iana"},"application/vnd.oma.lwm2m+json":{"source":"iana","compressible":true},"application/vnd.oma.lwm2m+tlv":{"source":"iana"},"application/vnd.oma.pal+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.detailed-progress-report+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.final-report+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.groups+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.invocation-descriptor+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.optimized-progress-report+xml":{"source":"iana","compressible":true},"application/vnd.oma.push":{"source":"iana"},"application/vnd.oma.scidm.messages+xml":{"source":"iana","compressible":true},"application/vnd.oma.xcap-directory+xml":{"source":"iana","compressible":true},"application/vnd.omads-email+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.omads-file+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.omads-folder+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.omaloc-supl-init":{"source":"iana"},"application/vnd.onepager":{"source":"iana"},"application/vnd.onepagertamp":{"source":"iana"},"application/vnd.onepagertamx":{"source":"iana"},"application/vnd.onepagertat":{"source":"iana"},"application/vnd.onepagertatp":{"source":"iana"},"application/vnd.onepagertatx":{"source":"iana"},"application/vnd.openblox.game+xml":{"source":"iana","compressible":true,"extensions":["obgx"]},"application/vnd.openblox.game-binary":{"source":"iana"},"application/vnd.openeye.oeb":{"source":"iana"},"application/vnd.openofficeorg.extension":{"source":"apache","extensions":["oxt"]},"application/vnd.openstreetmap.data+xml":{"source":"iana","compressible":true,"extensions":["osm"]},"application/vnd.opentimestamps.ots":{"source":"iana"},"application/vnd.openxmlformats-officedocument.custom-properties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.customxmlproperties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawing+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.chart+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramcolors+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramdata+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramlayout+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramstyle+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.extended-properties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.commentauthors+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.comments+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.handoutmaster+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.notesmaster+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.notesslide+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.presentation":{"source":"iana","compressible":false,"extensions":["pptx"]},"application/vnd.openxmlformats-officedocument.presentationml.presentation.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.presprops+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slide":{"source":"iana","extensions":["sldx"]},"application/vnd.openxmlformats-officedocument.presentationml.slide+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slidelayout+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slidemaster+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slideshow":{"source":"iana","extensions":["ppsx"]},"application/vnd.openxmlformats-officedocument.presentationml.slideshow.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slideupdateinfo+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.tablestyles+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.tags+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.template":{"source":"iana","extensions":["potx"]},"application/vnd.openxmlformats-officedocument.presentationml.template.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.viewprops+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.calcchain+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.externallink+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcachedefinition+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcacherecords+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.pivottable+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.querytable+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionheaders+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionlog+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.sharedstrings+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":{"source":"iana","compressible":false,"extensions":["xlsx"]},"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.sheetmetadata+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.tablesinglecells+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.template":{"source":"iana","extensions":["xltx"]},"application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.usernames+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.volatiledependencies+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.theme+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.themeoverride+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.vmldrawing":{"source":"iana"},"application/vnd.openxmlformats-officedocument.wordprocessingml.comments+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.document":{"source":"iana","compressible":false,"extensions":["docx"]},"application/vnd.openxmlformats-officedocument.wordprocessingml.document.glossary+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.document.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.endnotes+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.fonttable+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.footer+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.footnotes+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.numbering+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.settings+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.styles+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.template":{"source":"iana","extensions":["dotx"]},"application/vnd.openxmlformats-officedocument.wordprocessingml.template.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.websettings+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-package.core-properties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-package.digital-signature-xmlsignature+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-package.relationships+xml":{"source":"iana","compressible":true},"application/vnd.oracle.resource+json":{"source":"iana","compressible":true},"application/vnd.orange.indata":{"source":"iana"},"application/vnd.osa.netdeploy":{"source":"iana"},"application/vnd.osgeo.mapguide.package":{"source":"iana","extensions":["mgp"]},"application/vnd.osgi.bundle":{"source":"iana"},"application/vnd.osgi.dp":{"source":"iana","extensions":["dp"]},"application/vnd.osgi.subsystem":{"source":"iana","extensions":["esa"]},"application/vnd.otps.ct-kip+xml":{"source":"iana","compressible":true},"application/vnd.oxli.countgraph":{"source":"iana"},"application/vnd.pagerduty+json":{"source":"iana","compressible":true},"application/vnd.palm":{"source":"iana","extensions":["pdb","pqa","oprc"]},"application/vnd.panoply":{"source":"iana"},"application/vnd.paos.xml":{"source":"iana"},"application/vnd.patentdive":{"source":"iana"},"application/vnd.patientecommsdoc":{"source":"iana"},"application/vnd.pawaafile":{"source":"iana","extensions":["paw"]},"application/vnd.pcos":{"source":"iana"},"application/vnd.pg.format":{"source":"iana","extensions":["str"]},"application/vnd.pg.osasli":{"source":"iana","extensions":["ei6"]},"application/vnd.piaccess.application-licence":{"source":"iana"},"application/vnd.picsel":{"source":"iana","extensions":["efif"]},"application/vnd.pmi.widget":{"source":"iana","extensions":["wg"]},"application/vnd.poc.group-advertisement+xml":{"source":"iana","compressible":true},"application/vnd.pocketlearn":{"source":"iana","extensions":["plf"]},"application/vnd.powerbuilder6":{"source":"iana","extensions":["pbd"]},"application/vnd.powerbuilder6-s":{"source":"iana"},"application/vnd.powerbuilder7":{"source":"iana"},"application/vnd.powerbuilder7-s":{"source":"iana"},"application/vnd.powerbuilder75":{"source":"iana"},"application/vnd.powerbuilder75-s":{"source":"iana"},"application/vnd.preminet":{"source":"iana"},"application/vnd.previewsystems.box":{"source":"iana","extensions":["box"]},"application/vnd.proteus.magazine":{"source":"iana","extensions":["mgz"]},"application/vnd.psfs":{"source":"iana"},"application/vnd.publishare-delta-tree":{"source":"iana","extensions":["qps"]},"application/vnd.pvi.ptid1":{"source":"iana","extensions":["ptid"]},"application/vnd.pwg-multiplexed":{"source":"iana"},"application/vnd.pwg-xhtml-print+xml":{"source":"iana","compressible":true},"application/vnd.qualcomm.brew-app-res":{"source":"iana"},"application/vnd.quarantainenet":{"source":"iana"},"application/vnd.quark.quarkxpress":{"source":"iana","extensions":["qxd","qxt","qwd","qwt","qxl","qxb"]},"application/vnd.quobject-quoxdocument":{"source":"iana"},"application/vnd.radisys.moml+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-conf+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-conn+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-dialog+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-stream+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-conf+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-base+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-fax-detect+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-fax-sendrecv+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-group+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-speech+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-transform+xml":{"source":"iana","compressible":true},"application/vnd.rainstor.data":{"source":"iana"},"application/vnd.rapid":{"source":"iana"},"application/vnd.rar":{"source":"iana","extensions":["rar"]},"application/vnd.realvnc.bed":{"source":"iana","extensions":["bed"]},"application/vnd.recordare.musicxml":{"source":"iana","extensions":["mxl"]},"application/vnd.recordare.musicxml+xml":{"source":"iana","compressible":true,"extensions":["musicxml"]},"application/vnd.renlearn.rlprint":{"source":"iana"},"application/vnd.resilient.logic":{"source":"iana"},"application/vnd.restful+json":{"source":"iana","compressible":true},"application/vnd.rig.cryptonote":{"source":"iana","extensions":["cryptonote"]},"application/vnd.rim.cod":{"source":"apache","extensions":["cod"]},"application/vnd.rn-realmedia":{"source":"apache","extensions":["rm"]},"application/vnd.rn-realmedia-vbr":{"source":"apache","extensions":["rmvb"]},"application/vnd.route66.link66+xml":{"source":"iana","compressible":true,"extensions":["link66"]},"application/vnd.rs-274x":{"source":"iana"},"application/vnd.ruckus.download":{"source":"iana"},"application/vnd.s3sms":{"source":"iana"},"application/vnd.sailingtracker.track":{"source":"iana","extensions":["st"]},"application/vnd.sar":{"source":"iana"},"application/vnd.sbm.cid":{"source":"iana"},"application/vnd.sbm.mid2":{"source":"iana"},"application/vnd.scribus":{"source":"iana"},"application/vnd.sealed.3df":{"source":"iana"},"application/vnd.sealed.csf":{"source":"iana"},"application/vnd.sealed.doc":{"source":"iana"},"application/vnd.sealed.eml":{"source":"iana"},"application/vnd.sealed.mht":{"source":"iana"},"application/vnd.sealed.net":{"source":"iana"},"application/vnd.sealed.ppt":{"source":"iana"},"application/vnd.sealed.tiff":{"source":"iana"},"application/vnd.sealed.xls":{"source":"iana"},"application/vnd.sealedmedia.softseal.html":{"source":"iana"},"application/vnd.sealedmedia.softseal.pdf":{"source":"iana"},"application/vnd.seemail":{"source":"iana","extensions":["see"]},"application/vnd.seis+json":{"source":"iana","compressible":true},"application/vnd.sema":{"source":"iana","extensions":["sema"]},"application/vnd.semd":{"source":"iana","extensions":["semd"]},"application/vnd.semf":{"source":"iana","extensions":["semf"]},"application/vnd.shade-save-file":{"source":"iana"},"application/vnd.shana.informed.formdata":{"source":"iana","extensions":["ifm"]},"application/vnd.shana.informed.formtemplate":{"source":"iana","extensions":["itp"]},"application/vnd.shana.informed.interchange":{"source":"iana","extensions":["iif"]},"application/vnd.shana.informed.package":{"source":"iana","extensions":["ipk"]},"application/vnd.shootproof+json":{"source":"iana","compressible":true},"application/vnd.shopkick+json":{"source":"iana","compressible":true},"application/vnd.shp":{"source":"iana"},"application/vnd.shx":{"source":"iana"},"application/vnd.sigrok.session":{"source":"iana"},"application/vnd.simtech-mindmapper":{"source":"iana","extensions":["twd","twds"]},"application/vnd.siren+json":{"source":"iana","compressible":true},"application/vnd.smaf":{"source":"iana","extensions":["mmf"]},"application/vnd.smart.notebook":{"source":"iana"},"application/vnd.smart.teacher":{"source":"iana","extensions":["teacher"]},"application/vnd.snesdev-page-table":{"source":"iana"},"application/vnd.software602.filler.form+xml":{"source":"iana","compressible":true,"extensions":["fo"]},"application/vnd.software602.filler.form-xml-zip":{"source":"iana"},"application/vnd.solent.sdkm+xml":{"source":"iana","compressible":true,"extensions":["sdkm","sdkd"]},"application/vnd.spotfire.dxp":{"source":"iana","extensions":["dxp"]},"application/vnd.spotfire.sfs":{"source":"iana","extensions":["sfs"]},"application/vnd.sqlite3":{"source":"iana"},"application/vnd.sss-cod":{"source":"iana"},"application/vnd.sss-dtf":{"source":"iana"},"application/vnd.sss-ntf":{"source":"iana"},"application/vnd.stardivision.calc":{"source":"apache","extensions":["sdc"]},"application/vnd.stardivision.draw":{"source":"apache","extensions":["sda"]},"application/vnd.stardivision.impress":{"source":"apache","extensions":["sdd"]},"application/vnd.stardivision.math":{"source":"apache","extensions":["smf"]},"application/vnd.stardivision.writer":{"source":"apache","extensions":["sdw","vor"]},"application/vnd.stardivision.writer-global":{"source":"apache","extensions":["sgl"]},"application/vnd.stepmania.package":{"source":"iana","extensions":["smzip"]},"application/vnd.stepmania.stepchart":{"source":"iana","extensions":["sm"]},"application/vnd.street-stream":{"source":"iana"},"application/vnd.sun.wadl+xml":{"source":"iana","compressible":true,"extensions":["wadl"]},"application/vnd.sun.xml.calc":{"source":"apache","extensions":["sxc"]},"application/vnd.sun.xml.calc.template":{"source":"apache","extensions":["stc"]},"application/vnd.sun.xml.draw":{"source":"apache","extensions":["sxd"]},"application/vnd.sun.xml.draw.template":{"source":"apache","extensions":["std"]},"application/vnd.sun.xml.impress":{"source":"apache","extensions":["sxi"]},"application/vnd.sun.xml.impress.template":{"source":"apache","extensions":["sti"]},"application/vnd.sun.xml.math":{"source":"apache","extensions":["sxm"]},"application/vnd.sun.xml.writer":{"source":"apache","extensions":["sxw"]},"application/vnd.sun.xml.writer.global":{"source":"apache","extensions":["sxg"]},"application/vnd.sun.xml.writer.template":{"source":"apache","extensions":["stw"]},"application/vnd.sus-calendar":{"source":"iana","extensions":["sus","susp"]},"application/vnd.svd":{"source":"iana","extensions":["svd"]},"application/vnd.swiftview-ics":{"source":"iana"},"application/vnd.sycle+xml":{"source":"iana","compressible":true},"application/vnd.syft+json":{"source":"iana","compressible":true},"application/vnd.symbian.install":{"source":"apache","extensions":["sis","sisx"]},"application/vnd.syncml+xml":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["xsm"]},"application/vnd.syncml.dm+wbxml":{"source":"iana","charset":"UTF-8","extensions":["bdm"]},"application/vnd.syncml.dm+xml":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["xdm"]},"application/vnd.syncml.dm.notification":{"source":"iana"},"application/vnd.syncml.dmddf+wbxml":{"source":"iana"},"application/vnd.syncml.dmddf+xml":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["ddf"]},"application/vnd.syncml.dmtnds+wbxml":{"source":"iana"},"application/vnd.syncml.dmtnds+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.syncml.ds.notification":{"source":"iana"},"application/vnd.tableschema+json":{"source":"iana","compressible":true},"application/vnd.tao.intent-module-archive":{"source":"iana","extensions":["tao"]},"application/vnd.tcpdump.pcap":{"source":"iana","extensions":["pcap","cap","dmp"]},"application/vnd.think-cell.ppttc+json":{"source":"iana","compressible":true},"application/vnd.tmd.mediaflex.api+xml":{"source":"iana","compressible":true},"application/vnd.tml":{"source":"iana"},"application/vnd.tmobile-livetv":{"source":"iana","extensions":["tmo"]},"application/vnd.tri.onesource":{"source":"iana"},"application/vnd.trid.tpt":{"source":"iana","extensions":["tpt"]},"application/vnd.triscape.mxs":{"source":"iana","extensions":["mxs"]},"application/vnd.trueapp":{"source":"iana","extensions":["tra"]},"application/vnd.truedoc":{"source":"iana"},"application/vnd.ubisoft.webplayer":{"source":"iana"},"application/vnd.ufdl":{"source":"iana","extensions":["ufd","ufdl"]},"application/vnd.uiq.theme":{"source":"iana","extensions":["utz"]},"application/vnd.umajin":{"source":"iana","extensions":["umj"]},"application/vnd.unity":{"source":"iana","extensions":["unityweb"]},"application/vnd.uoml+xml":{"source":"iana","compressible":true,"extensions":["uoml"]},"application/vnd.uplanet.alert":{"source":"iana"},"application/vnd.uplanet.alert-wbxml":{"source":"iana"},"application/vnd.uplanet.bearer-choice":{"source":"iana"},"application/vnd.uplanet.bearer-choice-wbxml":{"source":"iana"},"application/vnd.uplanet.cacheop":{"source":"iana"},"application/vnd.uplanet.cacheop-wbxml":{"source":"iana"},"application/vnd.uplanet.channel":{"source":"iana"},"application/vnd.uplanet.channel-wbxml":{"source":"iana"},"application/vnd.uplanet.list":{"source":"iana"},"application/vnd.uplanet.list-wbxml":{"source":"iana"},"application/vnd.uplanet.listcmd":{"source":"iana"},"application/vnd.uplanet.listcmd-wbxml":{"source":"iana"},"application/vnd.uplanet.signal":{"source":"iana"},"application/vnd.uri-map":{"source":"iana"},"application/vnd.valve.source.material":{"source":"iana"},"application/vnd.vcx":{"source":"iana","extensions":["vcx"]},"application/vnd.vd-study":{"source":"iana"},"application/vnd.vectorworks":{"source":"iana"},"application/vnd.vel+json":{"source":"iana","compressible":true},"application/vnd.verimatrix.vcas":{"source":"iana"},"application/vnd.veritone.aion+json":{"source":"iana","compressible":true},"application/vnd.veryant.thin":{"source":"iana"},"application/vnd.ves.encrypted":{"source":"iana"},"application/vnd.vidsoft.vidconference":{"source":"iana"},"application/vnd.visio":{"source":"iana","extensions":["vsd","vst","vss","vsw"]},"application/vnd.visionary":{"source":"iana","extensions":["vis"]},"application/vnd.vividence.scriptfile":{"source":"iana"},"application/vnd.vsf":{"source":"iana","extensions":["vsf"]},"application/vnd.wap.sic":{"source":"iana"},"application/vnd.wap.slc":{"source":"iana"},"application/vnd.wap.wbxml":{"source":"iana","charset":"UTF-8","extensions":["wbxml"]},"application/vnd.wap.wmlc":{"source":"iana","extensions":["wmlc"]},"application/vnd.wap.wmlscriptc":{"source":"iana","extensions":["wmlsc"]},"application/vnd.webturbo":{"source":"iana","extensions":["wtb"]},"application/vnd.wfa.dpp":{"source":"iana"},"application/vnd.wfa.p2p":{"source":"iana"},"application/vnd.wfa.wsc":{"source":"iana"},"application/vnd.windows.devicepairing":{"source":"iana"},"application/vnd.wmc":{"source":"iana"},"application/vnd.wmf.bootstrap":{"source":"iana"},"application/vnd.wolfram.mathematica":{"source":"iana"},"application/vnd.wolfram.mathematica.package":{"source":"iana"},"application/vnd.wolfram.player":{"source":"iana","extensions":["nbp"]},"application/vnd.wordperfect":{"source":"iana","extensions":["wpd"]},"application/vnd.wqd":{"source":"iana","extensions":["wqd"]},"application/vnd.wrq-hp3000-labelled":{"source":"iana"},"application/vnd.wt.stf":{"source":"iana","extensions":["stf"]},"application/vnd.wv.csp+wbxml":{"source":"iana"},"application/vnd.wv.csp+xml":{"source":"iana","compressible":true},"application/vnd.wv.ssp+xml":{"source":"iana","compressible":true},"application/vnd.xacml+json":{"source":"iana","compressible":true},"application/vnd.xara":{"source":"iana","extensions":["xar"]},"application/vnd.xfdl":{"source":"iana","extensions":["xfdl"]},"application/vnd.xfdl.webform":{"source":"iana"},"application/vnd.xmi+xml":{"source":"iana","compressible":true},"application/vnd.xmpie.cpkg":{"source":"iana"},"application/vnd.xmpie.dpkg":{"source":"iana"},"application/vnd.xmpie.plan":{"source":"iana"},"application/vnd.xmpie.ppkg":{"source":"iana"},"application/vnd.xmpie.xlim":{"source":"iana"},"application/vnd.yamaha.hv-dic":{"source":"iana","extensions":["hvd"]},"application/vnd.yamaha.hv-script":{"source":"iana","extensions":["hvs"]},"application/vnd.yamaha.hv-voice":{"source":"iana","extensions":["hvp"]},"application/vnd.yamaha.openscoreformat":{"source":"iana","extensions":["osf"]},"application/vnd.yamaha.openscoreformat.osfpvg+xml":{"source":"iana","compressible":true,"extensions":["osfpvg"]},"application/vnd.yamaha.remote-setup":{"source":"iana"},"application/vnd.yamaha.smaf-audio":{"source":"iana","extensions":["saf"]},"application/vnd.yamaha.smaf-phrase":{"source":"iana","extensions":["spf"]},"application/vnd.yamaha.through-ngn":{"source":"iana"},"application/vnd.yamaha.tunnel-udpencap":{"source":"iana"},"application/vnd.yaoweme":{"source":"iana"},"application/vnd.yellowriver-custom-menu":{"source":"iana","extensions":["cmp"]},"application/vnd.youtube.yt":{"source":"iana"},"application/vnd.zul":{"source":"iana","extensions":["zir","zirz"]},"application/vnd.zzazz.deck+xml":{"source":"iana","compressible":true,"extensions":["zaz"]},"application/voicexml+xml":{"source":"iana","compressible":true,"extensions":["vxml"]},"application/voucher-cms+json":{"source":"iana","compressible":true},"application/vq-rtcpxr":{"source":"iana"},"application/wasm":{"source":"iana","compressible":true,"extensions":["wasm"]},"application/watcherinfo+xml":{"source":"iana","compressible":true,"extensions":["wif"]},"application/webpush-options+json":{"source":"iana","compressible":true},"application/whoispp-query":{"source":"iana"},"application/whoispp-response":{"source":"iana"},"application/widget":{"source":"iana","extensions":["wgt"]},"application/winhlp":{"source":"apache","extensions":["hlp"]},"application/wita":{"source":"iana"},"application/wordperfect5.1":{"source":"iana"},"application/wsdl+xml":{"source":"iana","compressible":true,"extensions":["wsdl"]},"application/wspolicy+xml":{"source":"iana","compressible":true,"extensions":["wspolicy"]},"application/x-7z-compressed":{"source":"apache","compressible":false,"extensions":["7z"]},"application/x-abiword":{"source":"apache","extensions":["abw"]},"application/x-ace-compressed":{"source":"apache","extensions":["ace"]},"application/x-amf":{"source":"apache"},"application/x-apple-diskimage":{"source":"apache","extensions":["dmg"]},"application/x-arj":{"compressible":false,"extensions":["arj"]},"application/x-authorware-bin":{"source":"apache","extensions":["aab","x32","u32","vox"]},"application/x-authorware-map":{"source":"apache","extensions":["aam"]},"application/x-authorware-seg":{"source":"apache","extensions":["aas"]},"application/x-bcpio":{"source":"apache","extensions":["bcpio"]},"application/x-bdoc":{"compressible":false,"extensions":["bdoc"]},"application/x-bittorrent":{"source":"apache","extensions":["torrent"]},"application/x-blorb":{"source":"apache","extensions":["blb","blorb"]},"application/x-bzip":{"source":"apache","compressible":false,"extensions":["bz"]},"application/x-bzip2":{"source":"apache","compressible":false,"extensions":["bz2","boz"]},"application/x-cbr":{"source":"apache","extensions":["cbr","cba","cbt","cbz","cb7"]},"application/x-cdlink":{"source":"apache","extensions":["vcd"]},"application/x-cfs-compressed":{"source":"apache","extensions":["cfs"]},"application/x-chat":{"source":"apache","extensions":["chat"]},"application/x-chess-pgn":{"source":"apache","extensions":["pgn"]},"application/x-chrome-extension":{"extensions":["crx"]},"application/x-cocoa":{"source":"nginx","extensions":["cco"]},"application/x-compress":{"source":"apache"},"application/x-conference":{"source":"apache","extensions":["nsc"]},"application/x-cpio":{"source":"apache","extensions":["cpio"]},"application/x-csh":{"source":"apache","extensions":["csh"]},"application/x-deb":{"compressible":false},"application/x-debian-package":{"source":"apache","extensions":["deb","udeb"]},"application/x-dgc-compressed":{"source":"apache","extensions":["dgc"]},"application/x-director":{"source":"apache","extensions":["dir","dcr","dxr","cst","cct","cxt","w3d","fgd","swa"]},"application/x-doom":{"source":"apache","extensions":["wad"]},"application/x-dtbncx+xml":{"source":"apache","compressible":true,"extensions":["ncx"]},"application/x-dtbook+xml":{"source":"apache","compressible":true,"extensions":["dtb"]},"application/x-dtbresource+xml":{"source":"apache","compressible":true,"extensions":["res"]},"application/x-dvi":{"source":"apache","compressible":false,"extensions":["dvi"]},"application/x-envoy":{"source":"apache","extensions":["evy"]},"application/x-eva":{"source":"apache","extensions":["eva"]},"application/x-font-bdf":{"source":"apache","extensions":["bdf"]},"application/x-font-dos":{"source":"apache"},"application/x-font-framemaker":{"source":"apache"},"application/x-font-ghostscript":{"source":"apache","extensions":["gsf"]},"application/x-font-libgrx":{"source":"apache"},"application/x-font-linux-psf":{"source":"apache","extensions":["psf"]},"application/x-font-pcf":{"source":"apache","extensions":["pcf"]},"application/x-font-snf":{"source":"apache","extensions":["snf"]},"application/x-font-speedo":{"source":"apache"},"application/x-font-sunos-news":{"source":"apache"},"application/x-font-type1":{"source":"apache","extensions":["pfa","pfb","pfm","afm"]},"application/x-font-vfont":{"source":"apache"},"application/x-freearc":{"source":"apache","extensions":["arc"]},"application/x-futuresplash":{"source":"apache","extensions":["spl"]},"application/x-gca-compressed":{"source":"apache","extensions":["gca"]},"application/x-glulx":{"source":"apache","extensions":["ulx"]},"application/x-gnumeric":{"source":"apache","extensions":["gnumeric"]},"application/x-gramps-xml":{"source":"apache","extensions":["gramps"]},"application/x-gtar":{"source":"apache","extensions":["gtar"]},"application/x-gzip":{"source":"apache"},"application/x-hdf":{"source":"apache","extensions":["hdf"]},"application/x-httpd-php":{"compressible":true,"extensions":["php"]},"application/x-install-instructions":{"source":"apache","extensions":["install"]},"application/x-iso9660-image":{"source":"apache","extensions":["iso"]},"application/x-iwork-keynote-sffkey":{"extensions":["key"]},"application/x-iwork-numbers-sffnumbers":{"extensions":["numbers"]},"application/x-iwork-pages-sffpages":{"extensions":["pages"]},"application/x-java-archive-diff":{"source":"nginx","extensions":["jardiff"]},"application/x-java-jnlp-file":{"source":"apache","compressible":false,"extensions":["jnlp"]},"application/x-javascript":{"compressible":true},"application/x-keepass2":{"extensions":["kdbx"]},"application/x-latex":{"source":"apache","compressible":false,"extensions":["latex"]},"application/x-lua-bytecode":{"extensions":["luac"]},"application/x-lzh-compressed":{"source":"apache","extensions":["lzh","lha"]},"application/x-makeself":{"source":"nginx","extensions":["run"]},"application/x-mie":{"source":"apache","extensions":["mie"]},"application/x-mobipocket-ebook":{"source":"apache","extensions":["prc","mobi"]},"application/x-mpegurl":{"compressible":false},"application/x-ms-application":{"source":"apache","extensions":["application"]},"application/x-ms-shortcut":{"source":"apache","extensions":["lnk"]},"application/x-ms-wmd":{"source":"apache","extensions":["wmd"]},"application/x-ms-wmz":{"source":"apache","extensions":["wmz"]},"application/x-ms-xbap":{"source":"apache","extensions":["xbap"]},"application/x-msaccess":{"source":"apache","extensions":["mdb"]},"application/x-msbinder":{"source":"apache","extensions":["obd"]},"application/x-mscardfile":{"source":"apache","extensions":["crd"]},"application/x-msclip":{"source":"apache","extensions":["clp"]},"application/x-msdos-program":{"extensions":["exe"]},"application/x-msdownload":{"source":"apache","extensions":["exe","dll","com","bat","msi"]},"application/x-msmediaview":{"source":"apache","extensions":["mvb","m13","m14"]},"application/x-msmetafile":{"source":"apache","extensions":["wmf","wmz","emf","emz"]},"application/x-msmoney":{"source":"apache","extensions":["mny"]},"application/x-mspublisher":{"source":"apache","extensions":["pub"]},"application/x-msschedule":{"source":"apache","extensions":["scd"]},"application/x-msterminal":{"source":"apache","extensions":["trm"]},"application/x-mswrite":{"source":"apache","extensions":["wri"]},"application/x-netcdf":{"source":"apache","extensions":["nc","cdf"]},"application/x-ns-proxy-autoconfig":{"compressible":true,"extensions":["pac"]},"application/x-nzb":{"source":"apache","extensions":["nzb"]},"application/x-perl":{"source":"nginx","extensions":["pl","pm"]},"application/x-pilot":{"source":"nginx","extensions":["prc","pdb"]},"application/x-pkcs12":{"source":"apache","compressible":false,"extensions":["p12","pfx"]},"application/x-pkcs7-certificates":{"source":"apache","extensions":["p7b","spc"]},"application/x-pkcs7-certreqresp":{"source":"apache","extensions":["p7r"]},"application/x-pki-message":{"source":"iana"},"application/x-rar-compressed":{"source":"apache","compressible":false,"extensions":["rar"]},"application/x-redhat-package-manager":{"source":"nginx","extensions":["rpm"]},"application/x-research-info-systems":{"source":"apache","extensions":["ris"]},"application/x-sea":{"source":"nginx","extensions":["sea"]},"application/x-sh":{"source":"apache","compressible":true,"extensions":["sh"]},"application/x-shar":{"source":"apache","extensions":["shar"]},"application/x-shockwave-flash":{"source":"apache","compressible":false,"extensions":["swf"]},"application/x-silverlight-app":{"source":"apache","extensions":["xap"]},"application/x-sql":{"source":"apache","extensions":["sql"]},"application/x-stuffit":{"source":"apache","compressible":false,"extensions":["sit"]},"application/x-stuffitx":{"source":"apache","extensions":["sitx"]},"application/x-subrip":{"source":"apache","extensions":["srt"]},"application/x-sv4cpio":{"source":"apache","extensions":["sv4cpio"]},"application/x-sv4crc":{"source":"apache","extensions":["sv4crc"]},"application/x-t3vm-image":{"source":"apache","extensions":["t3"]},"application/x-tads":{"source":"apache","extensions":["gam"]},"application/x-tar":{"source":"apache","compressible":true,"extensions":["tar"]},"application/x-tcl":{"source":"apache","extensions":["tcl","tk"]},"application/x-tex":{"source":"apache","extensions":["tex"]},"application/x-tex-tfm":{"source":"apache","extensions":["tfm"]},"application/x-texinfo":{"source":"apache","extensions":["texinfo","texi"]},"application/x-tgif":{"source":"apache","extensions":["obj"]},"application/x-ustar":{"source":"apache","extensions":["ustar"]},"application/x-virtualbox-hdd":{"compressible":true,"extensions":["hdd"]},"application/x-virtualbox-ova":{"compressible":true,"extensions":["ova"]},"application/x-virtualbox-ovf":{"compressible":true,"extensions":["ovf"]},"application/x-virtualbox-vbox":{"compressible":true,"extensions":["vbox"]},"application/x-virtualbox-vbox-extpack":{"compressible":false,"extensions":["vbox-extpack"]},"application/x-virtualbox-vdi":{"compressible":true,"extensions":["vdi"]},"application/x-virtualbox-vhd":{"compressible":true,"extensions":["vhd"]},"application/x-virtualbox-vmdk":{"compressible":true,"extensions":["vmdk"]},"application/x-wais-source":{"source":"apache","extensions":["src"]},"application/x-web-app-manifest+json":{"compressible":true,"extensions":["webapp"]},"application/x-www-form-urlencoded":{"source":"iana","compressible":true},"application/x-x509-ca-cert":{"source":"iana","extensions":["der","crt","pem"]},"application/x-x509-ca-ra-cert":{"source":"iana"},"application/x-x509-next-ca-cert":{"source":"iana"},"application/x-xfig":{"source":"apache","extensions":["fig"]},"application/x-xliff+xml":{"source":"apache","compressible":true,"extensions":["xlf"]},"application/x-xpinstall":{"source":"apache","compressible":false,"extensions":["xpi"]},"application/x-xz":{"source":"apache","extensions":["xz"]},"application/x-zmachine":{"source":"apache","extensions":["z1","z2","z3","z4","z5","z6","z7","z8"]},"application/x400-bp":{"source":"iana"},"application/xacml+xml":{"source":"iana","compressible":true},"application/xaml+xml":{"source":"apache","compressible":true,"extensions":["xaml"]},"application/xcap-att+xml":{"source":"iana","compressible":true,"extensions":["xav"]},"application/xcap-caps+xml":{"source":"iana","compressible":true,"extensions":["xca"]},"application/xcap-diff+xml":{"source":"iana","compressible":true,"extensions":["xdf"]},"application/xcap-el+xml":{"source":"iana","compressible":true,"extensions":["xel"]},"application/xcap-error+xml":{"source":"iana","compressible":true},"application/xcap-ns+xml":{"source":"iana","compressible":true,"extensions":["xns"]},"application/xcon-conference-info+xml":{"source":"iana","compressible":true},"application/xcon-conference-info-diff+xml":{"source":"iana","compressible":true},"application/xenc+xml":{"source":"iana","compressible":true,"extensions":["xenc"]},"application/xhtml+xml":{"source":"iana","compressible":true,"extensions":["xhtml","xht"]},"application/xhtml-voice+xml":{"source":"apache","compressible":true},"application/xliff+xml":{"source":"iana","compressible":true,"extensions":["xlf"]},"application/xml":{"source":"iana","compressible":true,"extensions":["xml","xsl","xsd","rng"]},"application/xml-dtd":{"source":"iana","compressible":true,"extensions":["dtd"]},"application/xml-external-parsed-entity":{"source":"iana"},"application/xml-patch+xml":{"source":"iana","compressible":true},"application/xmpp+xml":{"source":"iana","compressible":true},"application/xop+xml":{"source":"iana","compressible":true,"extensions":["xop"]},"application/xproc+xml":{"source":"apache","compressible":true,"extensions":["xpl"]},"application/xslt+xml":{"source":"iana","compressible":true,"extensions":["xsl","xslt"]},"application/xspf+xml":{"source":"apache","compressible":true,"extensions":["xspf"]},"application/xv+xml":{"source":"iana","compressible":true,"extensions":["mxml","xhvml","xvml","xvm"]},"application/yang":{"source":"iana","extensions":["yang"]},"application/yang-data+json":{"source":"iana","compressible":true},"application/yang-data+xml":{"source":"iana","compressible":true},"application/yang-patch+json":{"source":"iana","compressible":true},"application/yang-patch+xml":{"source":"iana","compressible":true},"application/yin+xml":{"source":"iana","compressible":true,"extensions":["yin"]},"application/zip":{"source":"iana","compressible":false,"extensions":["zip"]},"application/zlib":{"source":"iana"},"application/zstd":{"source":"iana"},"audio/1d-interleaved-parityfec":{"source":"iana"},"audio/32kadpcm":{"source":"iana"},"audio/3gpp":{"source":"iana","compressible":false,"extensions":["3gpp"]},"audio/3gpp2":{"source":"iana"},"audio/aac":{"source":"iana"},"audio/ac3":{"source":"iana"},"audio/adpcm":{"source":"apache","extensions":["adp"]},"audio/amr":{"source":"iana","extensions":["amr"]},"audio/amr-wb":{"source":"iana"},"audio/amr-wb+":{"source":"iana"},"audio/aptx":{"source":"iana"},"audio/asc":{"source":"iana"},"audio/atrac-advanced-lossless":{"source":"iana"},"audio/atrac-x":{"source":"iana"},"audio/atrac3":{"source":"iana"},"audio/basic":{"source":"iana","compressible":false,"extensions":["au","snd"]},"audio/bv16":{"source":"iana"},"audio/bv32":{"source":"iana"},"audio/clearmode":{"source":"iana"},"audio/cn":{"source":"iana"},"audio/dat12":{"source":"iana"},"audio/dls":{"source":"iana"},"audio/dsr-es201108":{"source":"iana"},"audio/dsr-es202050":{"source":"iana"},"audio/dsr-es202211":{"source":"iana"},"audio/dsr-es202212":{"source":"iana"},"audio/dv":{"source":"iana"},"audio/dvi4":{"source":"iana"},"audio/eac3":{"source":"iana"},"audio/encaprtp":{"source":"iana"},"audio/evrc":{"source":"iana"},"audio/evrc-qcp":{"source":"iana"},"audio/evrc0":{"source":"iana"},"audio/evrc1":{"source":"iana"},"audio/evrcb":{"source":"iana"},"audio/evrcb0":{"source":"iana"},"audio/evrcb1":{"source":"iana"},"audio/evrcnw":{"source":"iana"},"audio/evrcnw0":{"source":"iana"},"audio/evrcnw1":{"source":"iana"},"audio/evrcwb":{"source":"iana"},"audio/evrcwb0":{"source":"iana"},"audio/evrcwb1":{"source":"iana"},"audio/evs":{"source":"iana"},"audio/flexfec":{"source":"iana"},"audio/fwdred":{"source":"iana"},"audio/g711-0":{"source":"iana"},"audio/g719":{"source":"iana"},"audio/g722":{"source":"iana"},"audio/g7221":{"source":"iana"},"audio/g723":{"source":"iana"},"audio/g726-16":{"source":"iana"},"audio/g726-24":{"source":"iana"},"audio/g726-32":{"source":"iana"},"audio/g726-40":{"source":"iana"},"audio/g728":{"source":"iana"},"audio/g729":{"source":"iana"},"audio/g7291":{"source":"iana"},"audio/g729d":{"source":"iana"},"audio/g729e":{"source":"iana"},"audio/gsm":{"source":"iana"},"audio/gsm-efr":{"source":"iana"},"audio/gsm-hr-08":{"source":"iana"},"audio/ilbc":{"source":"iana"},"audio/ip-mr_v2.5":{"source":"iana"},"audio/isac":{"source":"apache"},"audio/l16":{"source":"iana"},"audio/l20":{"source":"iana"},"audio/l24":{"source":"iana","compressible":false},"audio/l8":{"source":"iana"},"audio/lpc":{"source":"iana"},"audio/melp":{"source":"iana"},"audio/melp1200":{"source":"iana"},"audio/melp2400":{"source":"iana"},"audio/melp600":{"source":"iana"},"audio/mhas":{"source":"iana"},"audio/midi":{"source":"apache","extensions":["mid","midi","kar","rmi"]},"audio/mobile-xmf":{"source":"iana","extensions":["mxmf"]},"audio/mp3":{"compressible":false,"extensions":["mp3"]},"audio/mp4":{"source":"iana","compressible":false,"extensions":["m4a","mp4a"]},"audio/mp4a-latm":{"source":"iana"},"audio/mpa":{"source":"iana"},"audio/mpa-robust":{"source":"iana"},"audio/mpeg":{"source":"iana","compressible":false,"extensions":["mpga","mp2","mp2a","mp3","m2a","m3a"]},"audio/mpeg4-generic":{"source":"iana"},"audio/musepack":{"source":"apache"},"audio/ogg":{"source":"iana","compressible":false,"extensions":["oga","ogg","spx","opus"]},"audio/opus":{"source":"iana"},"audio/parityfec":{"source":"iana"},"audio/pcma":{"source":"iana"},"audio/pcma-wb":{"source":"iana"},"audio/pcmu":{"source":"iana"},"audio/pcmu-wb":{"source":"iana"},"audio/prs.sid":{"source":"iana"},"audio/qcelp":{"source":"iana"},"audio/raptorfec":{"source":"iana"},"audio/red":{"source":"iana"},"audio/rtp-enc-aescm128":{"source":"iana"},"audio/rtp-midi":{"source":"iana"},"audio/rtploopback":{"source":"iana"},"audio/rtx":{"source":"iana"},"audio/s3m":{"source":"apache","extensions":["s3m"]},"audio/scip":{"source":"iana"},"audio/silk":{"source":"apache","extensions":["sil"]},"audio/smv":{"source":"iana"},"audio/smv-qcp":{"source":"iana"},"audio/smv0":{"source":"iana"},"audio/sofa":{"source":"iana"},"audio/sp-midi":{"source":"iana"},"audio/speex":{"source":"iana"},"audio/t140c":{"source":"iana"},"audio/t38":{"source":"iana"},"audio/telephone-event":{"source":"iana"},"audio/tetra_acelp":{"source":"iana"},"audio/tetra_acelp_bb":{"source":"iana"},"audio/tone":{"source":"iana"},"audio/tsvcis":{"source":"iana"},"audio/uemclip":{"source":"iana"},"audio/ulpfec":{"source":"iana"},"audio/usac":{"source":"iana"},"audio/vdvi":{"source":"iana"},"audio/vmr-wb":{"source":"iana"},"audio/vnd.3gpp.iufp":{"source":"iana"},"audio/vnd.4sb":{"source":"iana"},"audio/vnd.audiokoz":{"source":"iana"},"audio/vnd.celp":{"source":"iana"},"audio/vnd.cisco.nse":{"source":"iana"},"audio/vnd.cmles.radio-events":{"source":"iana"},"audio/vnd.cns.anp1":{"source":"iana"},"audio/vnd.cns.inf1":{"source":"iana"},"audio/vnd.dece.audio":{"source":"iana","extensions":["uva","uvva"]},"audio/vnd.digital-winds":{"source":"iana","extensions":["eol"]},"audio/vnd.dlna.adts":{"source":"iana"},"audio/vnd.dolby.heaac.1":{"source":"iana"},"audio/vnd.dolby.heaac.2":{"source":"iana"},"audio/vnd.dolby.mlp":{"source":"iana"},"audio/vnd.dolby.mps":{"source":"iana"},"audio/vnd.dolby.pl2":{"source":"iana"},"audio/vnd.dolby.pl2x":{"source":"iana"},"audio/vnd.dolby.pl2z":{"source":"iana"},"audio/vnd.dolby.pulse.1":{"source":"iana"},"audio/vnd.dra":{"source":"iana","extensions":["dra"]},"audio/vnd.dts":{"source":"iana","extensions":["dts"]},"audio/vnd.dts.hd":{"source":"iana","extensions":["dtshd"]},"audio/vnd.dts.uhd":{"source":"iana"},"audio/vnd.dvb.file":{"source":"iana"},"audio/vnd.everad.plj":{"source":"iana"},"audio/vnd.hns.audio":{"source":"iana"},"audio/vnd.lucent.voice":{"source":"iana","extensions":["lvp"]},"audio/vnd.ms-playready.media.pya":{"source":"iana","extensions":["pya"]},"audio/vnd.nokia.mobile-xmf":{"source":"iana"},"audio/vnd.nortel.vbk":{"source":"iana"},"audio/vnd.nuera.ecelp4800":{"source":"iana","extensions":["ecelp4800"]},"audio/vnd.nuera.ecelp7470":{"source":"iana","extensions":["ecelp7470"]},"audio/vnd.nuera.ecelp9600":{"source":"iana","extensions":["ecelp9600"]},"audio/vnd.octel.sbc":{"source":"iana"},"audio/vnd.presonus.multitrack":{"source":"iana"},"audio/vnd.qcelp":{"source":"iana"},"audio/vnd.rhetorex.32kadpcm":{"source":"iana"},"audio/vnd.rip":{"source":"iana","extensions":["rip"]},"audio/vnd.rn-realaudio":{"compressible":false},"audio/vnd.sealedmedia.softseal.mpeg":{"source":"iana"},"audio/vnd.vmx.cvsd":{"source":"iana"},"audio/vnd.wave":{"compressible":false},"audio/vorbis":{"source":"iana","compressible":false},"audio/vorbis-config":{"source":"iana"},"audio/wav":{"compressible":false,"extensions":["wav"]},"audio/wave":{"compressible":false,"extensions":["wav"]},"audio/webm":{"source":"apache","compressible":false,"extensions":["weba"]},"audio/x-aac":{"source":"apache","compressible":false,"extensions":["aac"]},"audio/x-aiff":{"source":"apache","extensions":["aif","aiff","aifc"]},"audio/x-caf":{"source":"apache","compressible":false,"extensions":["caf"]},"audio/x-flac":{"source":"apache","extensions":["flac"]},"audio/x-m4a":{"source":"nginx","extensions":["m4a"]},"audio/x-matroska":{"source":"apache","extensions":["mka"]},"audio/x-mpegurl":{"source":"apache","extensions":["m3u"]},"audio/x-ms-wax":{"source":"apache","extensions":["wax"]},"audio/x-ms-wma":{"source":"apache","extensions":["wma"]},"audio/x-pn-realaudio":{"source":"apache","extensions":["ram","ra"]},"audio/x-pn-realaudio-plugin":{"source":"apache","extensions":["rmp"]},"audio/x-realaudio":{"source":"nginx","extensions":["ra"]},"audio/x-tta":{"source":"apache"},"audio/x-wav":{"source":"apache","extensions":["wav"]},"audio/xm":{"source":"apache","extensions":["xm"]},"chemical/x-cdx":{"source":"apache","extensions":["cdx"]},"chemical/x-cif":{"source":"apache","extensions":["cif"]},"chemical/x-cmdf":{"source":"apache","extensions":["cmdf"]},"chemical/x-cml":{"source":"apache","extensions":["cml"]},"chemical/x-csml":{"source":"apache","extensions":["csml"]},"chemical/x-pdb":{"source":"apache"},"chemical/x-xyz":{"source":"apache","extensions":["xyz"]},"font/collection":{"source":"iana","extensions":["ttc"]},"font/otf":{"source":"iana","compressible":true,"extensions":["otf"]},"font/sfnt":{"source":"iana"},"font/ttf":{"source":"iana","compressible":true,"extensions":["ttf"]},"font/woff":{"source":"iana","extensions":["woff"]},"font/woff2":{"source":"iana","extensions":["woff2"]},"image/aces":{"source":"iana","extensions":["exr"]},"image/apng":{"compressible":false,"extensions":["apng"]},"image/avci":{"source":"iana","extensions":["avci"]},"image/avcs":{"source":"iana","extensions":["avcs"]},"image/avif":{"source":"iana","compressible":false,"extensions":["avif"]},"image/bmp":{"source":"iana","compressible":true,"extensions":["bmp"]},"image/cgm":{"source":"iana","extensions":["cgm"]},"image/dicom-rle":{"source":"iana","extensions":["drle"]},"image/emf":{"source":"iana","extensions":["emf"]},"image/fits":{"source":"iana","extensions":["fits"]},"image/g3fax":{"source":"iana","extensions":["g3"]},"image/gif":{"source":"iana","compressible":false,"extensions":["gif"]},"image/heic":{"source":"iana","extensions":["heic"]},"image/heic-sequence":{"source":"iana","extensions":["heics"]},"image/heif":{"source":"iana","extensions":["heif"]},"image/heif-sequence":{"source":"iana","extensions":["heifs"]},"image/hej2k":{"source":"iana","extensions":["hej2"]},"image/hsj2":{"source":"iana","extensions":["hsj2"]},"image/ief":{"source":"iana","extensions":["ief"]},"image/jls":{"source":"iana","extensions":["jls"]},"image/jp2":{"source":"iana","compressible":false,"extensions":["jp2","jpg2"]},"image/jpeg":{"source":"iana","compressible":false,"extensions":["jpeg","jpg","jpe"]},"image/jph":{"source":"iana","extensions":["jph"]},"image/jphc":{"source":"iana","extensions":["jhc"]},"image/jpm":{"source":"iana","compressible":false,"extensions":["jpm"]},"image/jpx":{"source":"iana","compressible":false,"extensions":["jpx","jpf"]},"image/jxr":{"source":"iana","extensions":["jxr"]},"image/jxra":{"source":"iana","extensions":["jxra"]},"image/jxrs":{"source":"iana","extensions":["jxrs"]},"image/jxs":{"source":"iana","extensions":["jxs"]},"image/jxsc":{"source":"iana","extensions":["jxsc"]},"image/jxsi":{"source":"iana","extensions":["jxsi"]},"image/jxss":{"source":"iana","extensions":["jxss"]},"image/ktx":{"source":"iana","extensions":["ktx"]},"image/ktx2":{"source":"iana","extensions":["ktx2"]},"image/naplps":{"source":"iana"},"image/pjpeg":{"compressible":false},"image/png":{"source":"iana","compressible":false,"extensions":["png"]},"image/prs.btif":{"source":"iana","extensions":["btif"]},"image/prs.pti":{"source":"iana","extensions":["pti"]},"image/pwg-raster":{"source":"iana"},"image/sgi":{"source":"apache","extensions":["sgi"]},"image/svg+xml":{"source":"iana","compressible":true,"extensions":["svg","svgz"]},"image/t38":{"source":"iana","extensions":["t38"]},"image/tiff":{"source":"iana","compressible":false,"extensions":["tif","tiff"]},"image/tiff-fx":{"source":"iana","extensions":["tfx"]},"image/vnd.adobe.photoshop":{"source":"iana","compressible":true,"extensions":["psd"]},"image/vnd.airzip.accelerator.azv":{"source":"iana","extensions":["azv"]},"image/vnd.cns.inf2":{"source":"iana"},"image/vnd.dece.graphic":{"source":"iana","extensions":["uvi","uvvi","uvg","uvvg"]},"image/vnd.djvu":{"source":"iana","extensions":["djvu","djv"]},"image/vnd.dvb.subtitle":{"source":"iana","extensions":["sub"]},"image/vnd.dwg":{"source":"iana","extensions":["dwg"]},"image/vnd.dxf":{"source":"iana","extensions":["dxf"]},"image/vnd.fastbidsheet":{"source":"iana","extensions":["fbs"]},"image/vnd.fpx":{"source":"iana","extensions":["fpx"]},"image/vnd.fst":{"source":"iana","extensions":["fst"]},"image/vnd.fujixerox.edmics-mmr":{"source":"iana","extensions":["mmr"]},"image/vnd.fujixerox.edmics-rlc":{"source":"iana","extensions":["rlc"]},"image/vnd.globalgraphics.pgb":{"source":"iana"},"image/vnd.microsoft.icon":{"source":"iana","compressible":true,"extensions":["ico"]},"image/vnd.mix":{"source":"iana"},"image/vnd.mozilla.apng":{"source":"iana"},"image/vnd.ms-dds":{"compressible":true,"extensions":["dds"]},"image/vnd.ms-modi":{"source":"iana","extensions":["mdi"]},"image/vnd.ms-photo":{"source":"apache","extensions":["wdp"]},"image/vnd.net-fpx":{"source":"iana","extensions":["npx"]},"image/vnd.pco.b16":{"source":"iana","extensions":["b16"]},"image/vnd.radiance":{"source":"iana"},"image/vnd.sealed.png":{"source":"iana"},"image/vnd.sealedmedia.softseal.gif":{"source":"iana"},"image/vnd.sealedmedia.softseal.jpg":{"source":"iana"},"image/vnd.svf":{"source":"iana"},"image/vnd.tencent.tap":{"source":"iana","extensions":["tap"]},"image/vnd.valve.source.texture":{"source":"iana","extensions":["vtf"]},"image/vnd.wap.wbmp":{"source":"iana","extensions":["wbmp"]},"image/vnd.xiff":{"source":"iana","extensions":["xif"]},"image/vnd.zbrush.pcx":{"source":"iana","extensions":["pcx"]},"image/webp":{"source":"apache","extensions":["webp"]},"image/wmf":{"source":"iana","extensions":["wmf"]},"image/x-3ds":{"source":"apache","extensions":["3ds"]},"image/x-cmu-raster":{"source":"apache","extensions":["ras"]},"image/x-cmx":{"source":"apache","extensions":["cmx"]},"image/x-freehand":{"source":"apache","extensions":["fh","fhc","fh4","fh5","fh7"]},"image/x-icon":{"source":"apache","compressible":true,"extensions":["ico"]},"image/x-jng":{"source":"nginx","extensions":["jng"]},"image/x-mrsid-image":{"source":"apache","extensions":["sid"]},"image/x-ms-bmp":{"source":"nginx","compressible":true,"extensions":["bmp"]},"image/x-pcx":{"source":"apache","extensions":["pcx"]},"image/x-pict":{"source":"apache","extensions":["pic","pct"]},"image/x-portable-anymap":{"source":"apache","extensions":["pnm"]},"image/x-portable-bitmap":{"source":"apache","extensions":["pbm"]},"image/x-portable-graymap":{"source":"apache","extensions":["pgm"]},"image/x-portable-pixmap":{"source":"apache","extensions":["ppm"]},"image/x-rgb":{"source":"apache","extensions":["rgb"]},"image/x-tga":{"source":"apache","extensions":["tga"]},"image/x-xbitmap":{"source":"apache","extensions":["xbm"]},"image/x-xcf":{"compressible":false},"image/x-xpixmap":{"source":"apache","extensions":["xpm"]},"image/x-xwindowdump":{"source":"apache","extensions":["xwd"]},"message/cpim":{"source":"iana"},"message/delivery-status":{"source":"iana"},"message/disposition-notification":{"source":"iana","extensions":["disposition-notification"]},"message/external-body":{"source":"iana"},"message/feedback-report":{"source":"iana"},"message/global":{"source":"iana","extensions":["u8msg"]},"message/global-delivery-status":{"source":"iana","extensions":["u8dsn"]},"message/global-disposition-notification":{"source":"iana","extensions":["u8mdn"]},"message/global-headers":{"source":"iana","extensions":["u8hdr"]},"message/http":{"source":"iana","compressible":false},"message/imdn+xml":{"source":"iana","compressible":true},"message/news":{"source":"iana"},"message/partial":{"source":"iana","compressible":false},"message/rfc822":{"source":"iana","compressible":true,"extensions":["eml","mime"]},"message/s-http":{"source":"iana"},"message/sip":{"source":"iana"},"message/sipfrag":{"source":"iana"},"message/tracking-status":{"source":"iana"},"message/vnd.si.simp":{"source":"iana"},"message/vnd.wfa.wsc":{"source":"iana","extensions":["wsc"]},"model/3mf":{"source":"iana","extensions":["3mf"]},"model/e57":{"source":"iana"},"model/gltf+json":{"source":"iana","compressible":true,"extensions":["gltf"]},"model/gltf-binary":{"source":"iana","compressible":true,"extensions":["glb"]},"model/iges":{"source":"iana","compressible":false,"extensions":["igs","iges"]},"model/mesh":{"source":"iana","compressible":false,"extensions":["msh","mesh","silo"]},"model/mtl":{"source":"iana","extensions":["mtl"]},"model/obj":{"source":"iana","extensions":["obj"]},"model/step":{"source":"iana"},"model/step+xml":{"source":"iana","compressible":true,"extensions":["stpx"]},"model/step+zip":{"source":"iana","compressible":false,"extensions":["stpz"]},"model/step-xml+zip":{"source":"iana","compressible":false,"extensions":["stpxz"]},"model/stl":{"source":"iana","extensions":["stl"]},"model/vnd.collada+xml":{"source":"iana","compressible":true,"extensions":["dae"]},"model/vnd.dwf":{"source":"iana","extensions":["dwf"]},"model/vnd.flatland.3dml":{"source":"iana"},"model/vnd.gdl":{"source":"iana","extensions":["gdl"]},"model/vnd.gs-gdl":{"source":"apache"},"model/vnd.gs.gdl":{"source":"iana"},"model/vnd.gtw":{"source":"iana","extensions":["gtw"]},"model/vnd.moml+xml":{"source":"iana","compressible":true},"model/vnd.mts":{"source":"iana","extensions":["mts"]},"model/vnd.opengex":{"source":"iana","extensions":["ogex"]},"model/vnd.parasolid.transmit.binary":{"source":"iana","extensions":["x_b"]},"model/vnd.parasolid.transmit.text":{"source":"iana","extensions":["x_t"]},"model/vnd.pytha.pyox":{"source":"iana"},"model/vnd.rosette.annotated-data-model":{"source":"iana"},"model/vnd.sap.vds":{"source":"iana","extensions":["vds"]},"model/vnd.usdz+zip":{"source":"iana","compressible":false,"extensions":["usdz"]},"model/vnd.valve.source.compiled-map":{"source":"iana","extensions":["bsp"]},"model/vnd.vtu":{"source":"iana","extensions":["vtu"]},"model/vrml":{"source":"iana","compressible":false,"extensions":["wrl","vrml"]},"model/x3d+binary":{"source":"apache","compressible":false,"extensions":["x3db","x3dbz"]},"model/x3d+fastinfoset":{"source":"iana","extensions":["x3db"]},"model/x3d+vrml":{"source":"apache","compressible":false,"extensions":["x3dv","x3dvz"]},"model/x3d+xml":{"source":"iana","compressible":true,"extensions":["x3d","x3dz"]},"model/x3d-vrml":{"source":"iana","extensions":["x3dv"]},"multipart/alternative":{"source":"iana","compressible":false},"multipart/appledouble":{"source":"iana"},"multipart/byteranges":{"source":"iana"},"multipart/digest":{"source":"iana"},"multipart/encrypted":{"source":"iana","compressible":false},"multipart/form-data":{"source":"iana","compressible":false},"multipart/header-set":{"source":"iana"},"multipart/mixed":{"source":"iana"},"multipart/multilingual":{"source":"iana"},"multipart/parallel":{"source":"iana"},"multipart/related":{"source":"iana","compressible":false},"multipart/report":{"source":"iana"},"multipart/signed":{"source":"iana","compressible":false},"multipart/vnd.bint.med-plus":{"source":"iana"},"multipart/voice-message":{"source":"iana"},"multipart/x-mixed-replace":{"source":"iana"},"text/1d-interleaved-parityfec":{"source":"iana"},"text/cache-manifest":{"source":"iana","compressible":true,"extensions":["appcache","manifest"]},"text/calendar":{"source":"iana","extensions":["ics","ifb"]},"text/calender":{"compressible":true},"text/cmd":{"compressible":true},"text/coffeescript":{"extensions":["coffee","litcoffee"]},"text/cql":{"source":"iana"},"text/cql-expression":{"source":"iana"},"text/cql-identifier":{"source":"iana"},"text/css":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["css"]},"text/csv":{"source":"iana","compressible":true,"extensions":["csv"]},"text/csv-schema":{"source":"iana"},"text/directory":{"source":"iana"},"text/dns":{"source":"iana"},"text/ecmascript":{"source":"iana"},"text/encaprtp":{"source":"iana"},"text/enriched":{"source":"iana"},"text/fhirpath":{"source":"iana"},"text/flexfec":{"source":"iana"},"text/fwdred":{"source":"iana"},"text/gff3":{"source":"iana"},"text/grammar-ref-list":{"source":"iana"},"text/html":{"source":"iana","compressible":true,"extensions":["html","htm","shtml"]},"text/jade":{"extensions":["jade"]},"text/javascript":{"source":"iana","compressible":true},"text/jcr-cnd":{"source":"iana"},"text/jsx":{"compressible":true,"extensions":["jsx"]},"text/less":{"compressible":true,"extensions":["less"]},"text/markdown":{"source":"iana","compressible":true,"extensions":["markdown","md"]},"text/mathml":{"source":"nginx","extensions":["mml"]},"text/mdx":{"compressible":true,"extensions":["mdx"]},"text/mizar":{"source":"iana"},"text/n3":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["n3"]},"text/parameters":{"source":"iana","charset":"UTF-8"},"text/parityfec":{"source":"iana"},"text/plain":{"source":"iana","compressible":true,"extensions":["txt","text","conf","def","list","log","in","ini"]},"text/provenance-notation":{"source":"iana","charset":"UTF-8"},"text/prs.fallenstein.rst":{"source":"iana"},"text/prs.lines.tag":{"source":"iana","extensions":["dsc"]},"text/prs.prop.logic":{"source":"iana"},"text/raptorfec":{"source":"iana"},"text/red":{"source":"iana"},"text/rfc822-headers":{"source":"iana"},"text/richtext":{"source":"iana","compressible":true,"extensions":["rtx"]},"text/rtf":{"source":"iana","compressible":true,"extensions":["rtf"]},"text/rtp-enc-aescm128":{"source":"iana"},"text/rtploopback":{"source":"iana"},"text/rtx":{"source":"iana"},"text/sgml":{"source":"iana","extensions":["sgml","sgm"]},"text/shaclc":{"source":"iana"},"text/shex":{"source":"iana","extensions":["shex"]},"text/slim":{"extensions":["slim","slm"]},"text/spdx":{"source":"iana","extensions":["spdx"]},"text/strings":{"source":"iana"},"text/stylus":{"extensions":["stylus","styl"]},"text/t140":{"source":"iana"},"text/tab-separated-values":{"source":"iana","compressible":true,"extensions":["tsv"]},"text/troff":{"source":"iana","extensions":["t","tr","roff","man","me","ms"]},"text/turtle":{"source":"iana","charset":"UTF-8","extensions":["ttl"]},"text/ulpfec":{"source":"iana"},"text/uri-list":{"source":"iana","compressible":true,"extensions":["uri","uris","urls"]},"text/vcard":{"source":"iana","compressible":true,"extensions":["vcard"]},"text/vnd.a":{"source":"iana"},"text/vnd.abc":{"source":"iana"},"text/vnd.ascii-art":{"source":"iana"},"text/vnd.curl":{"source":"iana","extensions":["curl"]},"text/vnd.curl.dcurl":{"source":"apache","extensions":["dcurl"]},"text/vnd.curl.mcurl":{"source":"apache","extensions":["mcurl"]},"text/vnd.curl.scurl":{"source":"apache","extensions":["scurl"]},"text/vnd.debian.copyright":{"source":"iana","charset":"UTF-8"},"text/vnd.dmclientscript":{"source":"iana"},"text/vnd.dvb.subtitle":{"source":"iana","extensions":["sub"]},"text/vnd.esmertec.theme-descriptor":{"source":"iana","charset":"UTF-8"},"text/vnd.familysearch.gedcom":{"source":"iana","extensions":["ged"]},"text/vnd.ficlab.flt":{"source":"iana"},"text/vnd.fly":{"source":"iana","extensions":["fly"]},"text/vnd.fmi.flexstor":{"source":"iana","extensions":["flx"]},"text/vnd.gml":{"source":"iana"},"text/vnd.graphviz":{"source":"iana","extensions":["gv"]},"text/vnd.hans":{"source":"iana"},"text/vnd.hgl":{"source":"iana"},"text/vnd.in3d.3dml":{"source":"iana","extensions":["3dml"]},"text/vnd.in3d.spot":{"source":"iana","extensions":["spot"]},"text/vnd.iptc.newsml":{"source":"iana"},"text/vnd.iptc.nitf":{"source":"iana"},"text/vnd.latex-z":{"source":"iana"},"text/vnd.motorola.reflex":{"source":"iana"},"text/vnd.ms-mediapackage":{"source":"iana"},"text/vnd.net2phone.commcenter.command":{"source":"iana"},"text/vnd.radisys.msml-basic-layout":{"source":"iana"},"text/vnd.senx.warpscript":{"source":"iana"},"text/vnd.si.uricatalogue":{"source":"iana"},"text/vnd.sosi":{"source":"iana"},"text/vnd.sun.j2me.app-descriptor":{"source":"iana","charset":"UTF-8","extensions":["jad"]},"text/vnd.trolltech.linguist":{"source":"iana","charset":"UTF-8"},"text/vnd.wap.si":{"source":"iana"},"text/vnd.wap.sl":{"source":"iana"},"text/vnd.wap.wml":{"source":"iana","extensions":["wml"]},"text/vnd.wap.wmlscript":{"source":"iana","extensions":["wmls"]},"text/vtt":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["vtt"]},"text/x-asm":{"source":"apache","extensions":["s","asm"]},"text/x-c":{"source":"apache","extensions":["c","cc","cxx","cpp","h","hh","dic"]},"text/x-component":{"source":"nginx","extensions":["htc"]},"text/x-fortran":{"source":"apache","extensions":["f","for","f77","f90"]},"text/x-gwt-rpc":{"compressible":true},"text/x-handlebars-template":{"extensions":["hbs"]},"text/x-java-source":{"source":"apache","extensions":["java"]},"text/x-jquery-tmpl":{"compressible":true},"text/x-lua":{"extensions":["lua"]},"text/x-markdown":{"compressible":true,"extensions":["mkd"]},"text/x-nfo":{"source":"apache","extensions":["nfo"]},"text/x-opml":{"source":"apache","extensions":["opml"]},"text/x-org":{"compressible":true,"extensions":["org"]},"text/x-pascal":{"source":"apache","extensions":["p","pas"]},"text/x-processing":{"compressible":true,"extensions":["pde"]},"text/x-sass":{"extensions":["sass"]},"text/x-scss":{"extensions":["scss"]},"text/x-setext":{"source":"apache","extensions":["etx"]},"text/x-sfv":{"source":"apache","extensions":["sfv"]},"text/x-suse-ymp":{"compressible":true,"extensions":["ymp"]},"text/x-uuencode":{"source":"apache","extensions":["uu"]},"text/x-vcalendar":{"source":"apache","extensions":["vcs"]},"text/x-vcard":{"source":"apache","extensions":["vcf"]},"text/xml":{"source":"iana","compressible":true,"extensions":["xml"]},"text/xml-external-parsed-entity":{"source":"iana"},"text/yaml":{"compressible":true,"extensions":["yaml","yml"]},"video/1d-interleaved-parityfec":{"source":"iana"},"video/3gpp":{"source":"iana","extensions":["3gp","3gpp"]},"video/3gpp-tt":{"source":"iana"},"video/3gpp2":{"source":"iana","extensions":["3g2"]},"video/av1":{"source":"iana"},"video/bmpeg":{"source":"iana"},"video/bt656":{"source":"iana"},"video/celb":{"source":"iana"},"video/dv":{"source":"iana"},"video/encaprtp":{"source":"iana"},"video/ffv1":{"source":"iana"},"video/flexfec":{"source":"iana"},"video/h261":{"source":"iana","extensions":["h261"]},"video/h263":{"source":"iana","extensions":["h263"]},"video/h263-1998":{"source":"iana"},"video/h263-2000":{"source":"iana"},"video/h264":{"source":"iana","extensions":["h264"]},"video/h264-rcdo":{"source":"iana"},"video/h264-svc":{"source":"iana"},"video/h265":{"source":"iana"},"video/iso.segment":{"source":"iana","extensions":["m4s"]},"video/jpeg":{"source":"iana","extensions":["jpgv"]},"video/jpeg2000":{"source":"iana"},"video/jpm":{"source":"apache","extensions":["jpm","jpgm"]},"video/jxsv":{"source":"iana"},"video/mj2":{"source":"iana","extensions":["mj2","mjp2"]},"video/mp1s":{"source":"iana"},"video/mp2p":{"source":"iana"},"video/mp2t":{"source":"iana","extensions":["ts"]},"video/mp4":{"source":"iana","compressible":false,"extensions":["mp4","mp4v","mpg4"]},"video/mp4v-es":{"source":"iana"},"video/mpeg":{"source":"iana","compressible":false,"extensions":["mpeg","mpg","mpe","m1v","m2v"]},"video/mpeg4-generic":{"source":"iana"},"video/mpv":{"source":"iana"},"video/nv":{"source":"iana"},"video/ogg":{"source":"iana","compressible":false,"extensions":["ogv"]},"video/parityfec":{"source":"iana"},"video/pointer":{"source":"iana"},"video/quicktime":{"source":"iana","compressible":false,"extensions":["qt","mov"]},"video/raptorfec":{"source":"iana"},"video/raw":{"source":"iana"},"video/rtp-enc-aescm128":{"source":"iana"},"video/rtploopback":{"source":"iana"},"video/rtx":{"source":"iana"},"video/scip":{"source":"iana"},"video/smpte291":{"source":"iana"},"video/smpte292m":{"source":"iana"},"video/ulpfec":{"source":"iana"},"video/vc1":{"source":"iana"},"video/vc2":{"source":"iana"},"video/vnd.cctv":{"source":"iana"},"video/vnd.dece.hd":{"source":"iana","extensions":["uvh","uvvh"]},"video/vnd.dece.mobile":{"source":"iana","extensions":["uvm","uvvm"]},"video/vnd.dece.mp4":{"source":"iana"},"video/vnd.dece.pd":{"source":"iana","extensions":["uvp","uvvp"]},"video/vnd.dece.sd":{"source":"iana","extensions":["uvs","uvvs"]},"video/vnd.dece.video":{"source":"iana","extensions":["uvv","uvvv"]},"video/vnd.directv.mpeg":{"source":"iana"},"video/vnd.directv.mpeg-tts":{"source":"iana"},"video/vnd.dlna.mpeg-tts":{"source":"iana"},"video/vnd.dvb.file":{"source":"iana","extensions":["dvb"]},"video/vnd.fvt":{"source":"iana","extensions":["fvt"]},"video/vnd.hns.video":{"source":"iana"},"video/vnd.iptvforum.1dparityfec-1010":{"source":"iana"},"video/vnd.iptvforum.1dparityfec-2005":{"source":"iana"},"video/vnd.iptvforum.2dparityfec-1010":{"source":"iana"},"video/vnd.iptvforum.2dparityfec-2005":{"source":"iana"},"video/vnd.iptvforum.ttsavc":{"source":"iana"},"video/vnd.iptvforum.ttsmpeg2":{"source":"iana"},"video/vnd.motorola.video":{"source":"iana"},"video/vnd.motorola.videop":{"source":"iana"},"video/vnd.mpegurl":{"source":"iana","extensions":["mxu","m4u"]},"video/vnd.ms-playready.media.pyv":{"source":"iana","extensions":["pyv"]},"video/vnd.nokia.interleaved-multimedia":{"source":"iana"},"video/vnd.nokia.mp4vr":{"source":"iana"},"video/vnd.nokia.videovoip":{"source":"iana"},"video/vnd.objectvideo":{"source":"iana"},"video/vnd.radgamettools.bink":{"source":"iana"},"video/vnd.radgamettools.smacker":{"source":"iana"},"video/vnd.sealed.mpeg1":{"source":"iana"},"video/vnd.sealed.mpeg4":{"source":"iana"},"video/vnd.sealed.swf":{"source":"iana"},"video/vnd.sealedmedia.softseal.mov":{"source":"iana"},"video/vnd.uvvu.mp4":{"source":"iana","extensions":["uvu","uvvu"]},"video/vnd.vivo":{"source":"iana","extensions":["viv"]},"video/vnd.youtube.yt":{"source":"iana"},"video/vp8":{"source":"iana"},"video/vp9":{"source":"iana"},"video/webm":{"source":"apache","compressible":false,"extensions":["webm"]},"video/x-f4v":{"source":"apache","extensions":["f4v"]},"video/x-fli":{"source":"apache","extensions":["fli"]},"video/x-flv":{"source":"apache","compressible":false,"extensions":["flv"]},"video/x-m4v":{"source":"apache","extensions":["m4v"]},"video/x-matroska":{"source":"apache","compressible":false,"extensions":["mkv","mk3d","mks"]},"video/x-mng":{"source":"apache","extensions":["mng"]},"video/x-ms-asf":{"source":"apache","extensions":["asf","asx"]},"video/x-ms-vob":{"source":"apache","extensions":["vob"]},"video/x-ms-wm":{"source":"apache","extensions":["wm"]},"video/x-ms-wmv":{"source":"apache","compressible":false,"extensions":["wmv"]},"video/x-ms-wmx":{"source":"apache","extensions":["wmx"]},"video/x-ms-wvx":{"source":"apache","extensions":["wvx"]},"video/x-msvideo":{"source":"apache","extensions":["avi"]},"video/x-sgi-movie":{"source":"apache","extensions":["movie"]},"video/x-smv":{"source":"apache","extensions":["smv"]},"x-conference/x-cooltalk":{"source":"apache","extensions":["ice"]},"x-shader/x-fragment":{"compressible":true},"x-shader/x-vertex":{"compressible":true}}');

});

parcelRegister("3PYIs", function(module, exports) {
/**
 * @license React
 * react-reconciler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $4dBQg = parcelRequire("4dBQg");
"use strict";


module.exports = function($$$config) {
    function createFiber(tag, pendingProps, key, mode) {
        return new FiberNode(tag, pendingProps, key, mode);
    }
    function noop() {}
    function formatProdErrorMessage(code) {
        var url = "https://react.dev/errors/" + code;
        if (1 < arguments.length) {
            url += "?args[]=" + encodeURIComponent(arguments[1]);
            for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
        }
        return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
    }
    function getNearestMountedFiber(fiber) {
        var node = fiber, nearestMounted = fiber;
        if (fiber.alternate) for(; node.return;)node = node.return;
        else {
            fiber = node;
            do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
            while (fiber);
        }
        return 3 === node.tag ? nearestMounted : null;
    }
    function assertIsMounted(fiber) {
        if (getNearestMountedFiber(fiber) !== fiber) throw Error(formatProdErrorMessage(188));
    }
    function findCurrentFiberUsingSlowPath(fiber) {
        var alternate = fiber.alternate;
        if (!alternate) {
            alternate = getNearestMountedFiber(fiber);
            if (null === alternate) throw Error(formatProdErrorMessage(188));
            return alternate !== fiber ? null : fiber;
        }
        for(var a = fiber, b = alternate;;){
            var parentA = a.return;
            if (null === parentA) break;
            var parentB = parentA.alternate;
            if (null === parentB) {
                b = parentA.return;
                if (null !== b) {
                    a = b;
                    continue;
                }
                break;
            }
            if (parentA.child === parentB.child) {
                for(parentB = parentA.child; parentB;){
                    if (parentB === a) return assertIsMounted(parentA), fiber;
                    if (parentB === b) return assertIsMounted(parentA), alternate;
                    parentB = parentB.sibling;
                }
                throw Error(formatProdErrorMessage(188));
            }
            if (a.return !== b.return) a = parentA, b = parentB;
            else {
                for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentA;
                        b = parentB;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentA;
                        a = parentB;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) {
                    for(child$0 = parentB.child; child$0;){
                        if (child$0 === a) {
                            didFindChild = !0;
                            a = parentB;
                            b = parentA;
                            break;
                        }
                        if (child$0 === b) {
                            didFindChild = !0;
                            b = parentB;
                            a = parentA;
                            break;
                        }
                        child$0 = child$0.sibling;
                    }
                    if (!didFindChild) throw Error(formatProdErrorMessage(189));
                }
            }
            if (a.alternate !== b) throw Error(formatProdErrorMessage(190));
        }
        if (3 !== a.tag) throw Error(formatProdErrorMessage(188));
        return a.stateNode.current === a ? fiber : alternate;
    }
    function findCurrentHostFiberImpl(node) {
        var tag = node.tag;
        if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
        for(node = node.child; null !== node;){
            tag = findCurrentHostFiberImpl(node);
            if (null !== tag) return tag;
            node = node.sibling;
        }
        return null;
    }
    function findCurrentHostFiberWithNoPortalsImpl(node) {
        var tag = node.tag;
        if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
        for(node = node.child; null !== node;){
            if (4 !== node.tag && (tag = findCurrentHostFiberWithNoPortalsImpl(node), null !== tag)) return tag;
            node = node.sibling;
        }
        return null;
    }
    function getIteratorFn(maybeIterable) {
        if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
        maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
        return "function" === typeof maybeIterable ? maybeIterable : null;
    }
    function getComponentNameFromType(type) {
        if (null == type) return null;
        if ("function" === typeof type) return type.$$typeof === REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
        if ("string" === typeof type) return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return "Fragment";
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return "StrictMode";
            case REACT_SUSPENSE_TYPE:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
            case REACT_ACTIVITY_TYPE:
                return "Activity";
        }
        if ("object" === typeof type) switch(type.$$typeof){
            case REACT_PORTAL_TYPE:
                return "Portal";
            case REACT_CONTEXT_TYPE:
                return type.displayName || "Context";
            case REACT_CONSUMER_TYPE:
                return (type._context.displayName || "Context") + ".Consumer";
            case REACT_FORWARD_REF_TYPE:
                var innerType = type.render;
                type = type.displayName;
                type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
                return type;
            case REACT_MEMO_TYPE:
                return innerType = type.displayName || null, null !== innerType ? innerType : getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE:
                innerType = type._payload;
                type = type._init;
                try {
                    return getComponentNameFromType(type(innerType));
                } catch (x) {}
        }
        return null;
    }
    function createCursor(defaultValue) {
        return {
            current: defaultValue
        };
    }
    function pop(cursor) {
        0 > index$jscomp$0 || (cursor.current = valueStack[index$jscomp$0], valueStack[index$jscomp$0] = null, index$jscomp$0--);
    }
    function push(cursor, value) {
        index$jscomp$0++;
        valueStack[index$jscomp$0] = cursor.current;
        cursor.current = value;
    }
    function clz32Fallback(x) {
        x >>>= 0;
        return 0 === x ? 32 : 31 - (log$1(x) / LN2 | 0) | 0;
    }
    function getHighestPriorityLanes(lanes) {
        var pendingSyncLanes = lanes & 42;
        if (0 !== pendingSyncLanes) return pendingSyncLanes;
        switch(lanes & -lanes){
            case 1:
                return 1;
            case 2:
                return 2;
            case 4:
                return 4;
            case 8:
                return 8;
            case 16:
                return 16;
            case 32:
                return 32;
            case 64:
                return 64;
            case 128:
                return 128;
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
                return lanes & 261888;
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
                return lanes & 3932160;
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
                return lanes & 62914560;
            case 67108864:
                return 67108864;
            case 134217728:
                return 134217728;
            case 268435456:
                return 268435456;
            case 536870912:
                return 536870912;
            case 1073741824:
                return 0;
            default:
                return lanes;
        }
    }
    function getNextLanes(root, wipLanes, rootHasPendingCommit) {
        var pendingLanes = root.pendingLanes;
        if (0 === pendingLanes) return 0;
        var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
        root = root.warmLanes;
        var nonIdlePendingLanes = pendingLanes & 134217727;
        0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = getHighestPriorityLanes(rootHasPendingCommit))));
        return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
    }
    function checkIfRootIsPrerendering(root, renderLanes) {
        return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
    }
    function computeExpirationTime(lane, currentTime) {
        switch(lane){
            case 1:
            case 2:
            case 4:
            case 8:
            case 64:
                return currentTime + 250;
            case 16:
            case 32:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
                return currentTime + 5e3;
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
                return -1;
            case 67108864:
            case 134217728:
            case 268435456:
            case 536870912:
            case 1073741824:
                return -1;
            default:
                return -1;
        }
    }
    function claimNextRetryLane() {
        var lane = nextRetryLane;
        nextRetryLane <<= 1;
        0 === (nextRetryLane & 62914560) && (nextRetryLane = 4194304);
        return lane;
    }
    function createLaneMap(initial) {
        for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
        return laneMap;
    }
    function markRootUpdated$1(root, updateLane) {
        root.pendingLanes |= updateLane;
        268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
    }
    function markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
        var previouslyPendingLanes = root.pendingLanes;
        root.pendingLanes = remainingLanes;
        root.suspendedLanes = 0;
        root.pingedLanes = 0;
        root.warmLanes = 0;
        root.expiredLanes &= remainingLanes;
        root.entangledLanes &= remainingLanes;
        root.errorRecoveryDisabledLanes &= remainingLanes;
        root.shellSuspendCounter = 0;
        var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
        for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
            var index$5 = 31 - clz32(remainingLanes), lane = 1 << index$5;
            entanglements[index$5] = 0;
            expirationTimes[index$5] = -1;
            var hiddenUpdatesForLane = hiddenUpdates[index$5];
            if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$5] = null, index$5 = 0; index$5 < hiddenUpdatesForLane.length; index$5++){
                var update = hiddenUpdatesForLane[index$5];
                null !== update && (update.lane &= -536870913);
            }
            remainingLanes &= ~lane;
        }
        0 !== spawnedLane && markSpawnedDeferredLane(root, spawnedLane, 0);
        0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
    }
    function markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
        root.pendingLanes |= spawnedLane;
        root.suspendedLanes &= ~spawnedLane;
        var spawnedLaneIndex = 31 - clz32(spawnedLane);
        root.entangledLanes |= spawnedLane;
        root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
    }
    function markRootEntangled(root, entangledLanes) {
        var rootEntangledLanes = root.entangledLanes |= entangledLanes;
        for(root = root.entanglements; rootEntangledLanes;){
            var index$6 = 31 - clz32(rootEntangledLanes), lane = 1 << index$6;
            lane & entangledLanes | root[index$6] & entangledLanes && (root[index$6] |= entangledLanes);
            rootEntangledLanes &= ~lane;
        }
    }
    function getBumpedLaneForHydration(root, renderLanes) {
        var renderLane = renderLanes & -renderLanes;
        renderLane = 0 !== (renderLane & 42) ? 1 : getBumpedLaneForHydrationByLane(renderLane);
        return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
    }
    function getBumpedLaneForHydrationByLane(lane) {
        switch(lane){
            case 2:
                lane = 1;
                break;
            case 8:
                lane = 4;
                break;
            case 32:
                lane = 16;
                break;
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
                lane = 128;
                break;
            case 268435456:
                lane = 134217728;
                break;
            default:
                lane = 0;
        }
        return lane;
    }
    function lanesToEventPriority(lanes) {
        lanes &= -lanes;
        return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
    }
    function setIsStrictModeForDevtools(newIsStrictMode) {
        "function" === typeof log && unstable_setDisableYieldValue(newIsStrictMode);
        if (injectedHook && "function" === typeof injectedHook.setStrictMode) try {
            injectedHook.setStrictMode(rendererID, newIsStrictMode);
        } catch (err) {}
    }
    function is(x, y) {
        return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
    }
    function describeBuiltInComponentFrame(name) {
        if (void 0 === prefix) try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || "";
            suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
        }
        return "\n" + prefix + name + suffix;
    }
    function describeNativeComponentFrame(fn, construct) {
        if (!fn || reentry) return "";
        reentry = !0;
        var previousPrepareStackTrace = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        try {
            var RunInRootFrame = {
                DetermineComponentFrameRoot: function() {
                    try {
                        if (construct) {
                            var Fake = function() {
                                throw Error();
                            };
                            Object.defineProperty(Fake.prototype, "props", {
                                set: function() {
                                    throw Error();
                                }
                            });
                            if ("object" === typeof Reflect && Reflect.construct) {
                                try {
                                    Reflect.construct(Fake, []);
                                } catch (x) {
                                    var control = x;
                                }
                                Reflect.construct(fn, [], Fake);
                            } else {
                                try {
                                    Fake.call();
                                } catch (x$8) {
                                    control = x$8;
                                }
                                fn.call(Fake.prototype);
                            }
                        } else {
                            try {
                                throw Error();
                            } catch (x$9) {
                                control = x$9;
                            }
                            (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                        }
                    } catch (sample) {
                        if (sample && control && "string" === typeof sample.stack) return [
                            sample.stack,
                            control.stack
                        ];
                    }
                    return [
                        null,
                        null
                    ];
                }
            };
            RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
            var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
            namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
                value: "DetermineComponentFrameRoot"
            });
            var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
            if (sampleStack && controlStack) {
                var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
                for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
                for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
                if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
                for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                    if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                        do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                            var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                            fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                            return frame;
                        }
                        while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                    }
                    break;
                }
            }
        } finally{
            reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
        }
        return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
    }
    function describeFiber(fiber, childFiber) {
        switch(fiber.tag){
            case 26:
            case 27:
            case 5:
                return describeBuiltInComponentFrame(fiber.type);
            case 16:
                return describeBuiltInComponentFrame("Lazy");
            case 13:
                return fiber.child !== childFiber && null !== childFiber ? describeBuiltInComponentFrame("Suspense Fallback") : describeBuiltInComponentFrame("Suspense");
            case 19:
                return describeBuiltInComponentFrame("SuspenseList");
            case 0:
            case 15:
                return describeNativeComponentFrame(fiber.type, !1);
            case 11:
                return describeNativeComponentFrame(fiber.type.render, !1);
            case 1:
                return describeNativeComponentFrame(fiber.type, !0);
            case 31:
                return describeBuiltInComponentFrame("Activity");
            default:
                return "";
        }
    }
    function getStackByFiberInDevAndProd(workInProgress) {
        try {
            var info = "", previous = null;
            do info += describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
            while (workInProgress);
            return info;
        } catch (x) {
            return "\nError generating stack: " + x.message + "\n" + x.stack;
        }
    }
    function createCapturedValueAtFiber(value, source) {
        if ("object" === typeof value && null !== value) {
            var existing = CapturedStacks.get(value);
            if (void 0 !== existing) return existing;
            source = {
                value: value,
                source: source,
                stack: getStackByFiberInDevAndProd(source)
            };
            CapturedStacks.set(value, source);
            return source;
        }
        return {
            value: value,
            source: source,
            stack: getStackByFiberInDevAndProd(source)
        };
    }
    function pushTreeFork(workInProgress, totalChildren) {
        forkStack[forkStackIndex++] = treeForkCount;
        forkStack[forkStackIndex++] = treeForkProvider;
        treeForkProvider = workInProgress;
        treeForkCount = totalChildren;
    }
    function pushTreeId(workInProgress, totalChildren, index) {
        idStack[idStackIndex++] = treeContextId;
        idStack[idStackIndex++] = treeContextOverflow;
        idStack[idStackIndex++] = treeContextProvider;
        treeContextProvider = workInProgress;
        var baseIdWithLeadingBit = treeContextId;
        workInProgress = treeContextOverflow;
        var baseLength = 32 - clz32(baseIdWithLeadingBit) - 1;
        baseIdWithLeadingBit &= ~(1 << baseLength);
        index += 1;
        var length = 32 - clz32(totalChildren) + baseLength;
        if (30 < length) {
            var numberOfOverflowBits = baseLength - baseLength % 5;
            length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
            baseIdWithLeadingBit >>= numberOfOverflowBits;
            baseLength -= numberOfOverflowBits;
            treeContextId = 1 << 32 - clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
            treeContextOverflow = length + workInProgress;
        } else treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, treeContextOverflow = workInProgress;
    }
    function pushMaterializedTreeId(workInProgress) {
        null !== workInProgress.return && (pushTreeFork(workInProgress, 1), pushTreeId(workInProgress, 1, 0));
    }
    function popTreeContext(workInProgress) {
        for(; workInProgress === treeForkProvider;)treeForkProvider = forkStack[--forkStackIndex], forkStack[forkStackIndex] = null, treeForkCount = forkStack[--forkStackIndex], forkStack[forkStackIndex] = null;
        for(; workInProgress === treeContextProvider;)treeContextProvider = idStack[--idStackIndex], idStack[idStackIndex] = null, treeContextOverflow = idStack[--idStackIndex], idStack[idStackIndex] = null, treeContextId = idStack[--idStackIndex], idStack[idStackIndex] = null;
    }
    function restoreSuspendedTreeContext(workInProgress, suspendedContext) {
        idStack[idStackIndex++] = treeContextId;
        idStack[idStackIndex++] = treeContextOverflow;
        idStack[idStackIndex++] = treeContextProvider;
        treeContextId = suspendedContext.id;
        treeContextOverflow = suspendedContext.overflow;
        treeContextProvider = workInProgress;
    }
    function pushHostContainer(fiber, nextRootInstance) {
        push(rootInstanceStackCursor, nextRootInstance);
        push(contextFiberStackCursor, fiber);
        push(contextStackCursor, null);
        fiber = getRootHostContext(nextRootInstance);
        pop(contextStackCursor);
        push(contextStackCursor, fiber);
    }
    function popHostContainer() {
        pop(contextStackCursor);
        pop(contextFiberStackCursor);
        pop(rootInstanceStackCursor);
    }
    function pushHostContext(fiber) {
        null !== fiber.memoizedState && push(hostTransitionProviderCursor, fiber);
        var context = contextStackCursor.current, nextContext = getChildHostContext(context, fiber.type);
        context !== nextContext && (push(contextFiberStackCursor, fiber), push(contextStackCursor, nextContext));
    }
    function popHostContext(fiber) {
        contextFiberStackCursor.current === fiber && (pop(contextStackCursor), pop(contextFiberStackCursor));
        hostTransitionProviderCursor.current === fiber && (pop(hostTransitionProviderCursor), isPrimaryRenderer ? HostTransitionContext._currentValue = NotPendingTransition : HostTransitionContext._currentValue2 = NotPendingTransition);
    }
    function throwOnHydrationMismatch(fiber) {
        var error = Error(formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
        queueHydrationError(createCapturedValueAtFiber(error, fiber));
        throw HydrationMismatchException;
    }
    function prepareToHydrateHostInstance(fiber, hostContext) {
        if (!supportsHydration) throw Error(formatProdErrorMessage(175));
        hydrateInstance(fiber.stateNode, fiber.type, fiber.memoizedProps, hostContext, fiber) || throwOnHydrationMismatch(fiber, !0);
    }
    function popToNextHostParent(fiber) {
        for(hydrationParentFiber = fiber.return; hydrationParentFiber;)switch(hydrationParentFiber.tag){
            case 5:
            case 31:
            case 13:
                rootOrSingletonContext = !1;
                return;
            case 27:
            case 3:
                rootOrSingletonContext = !0;
                return;
            default:
                hydrationParentFiber = hydrationParentFiber.return;
        }
    }
    function popHydrationState(fiber) {
        if (!supportsHydration || fiber !== hydrationParentFiber) return !1;
        if (!isHydrating) return popToNextHostParent(fiber), isHydrating = !0, !1;
        var tag = fiber.tag;
        supportsSingletons ? 3 !== tag && 27 !== tag && (5 !== tag || shouldDeleteUnhydratedTailInstances(fiber.type) && !shouldSetTextContent(fiber.type, fiber.memoizedProps)) && nextHydratableInstance && throwOnHydrationMismatch(fiber) : 3 !== tag && (5 !== tag || shouldDeleteUnhydratedTailInstances(fiber.type) && !shouldSetTextContent(fiber.type, fiber.memoizedProps)) && nextHydratableInstance && throwOnHydrationMismatch(fiber);
        popToNextHostParent(fiber);
        if (13 === tag) {
            if (!supportsHydration) throw Error(formatProdErrorMessage(316));
            fiber = fiber.memoizedState;
            fiber = null !== fiber ? fiber.dehydrated : null;
            if (!fiber) throw Error(formatProdErrorMessage(317));
            nextHydratableInstance = getNextHydratableInstanceAfterSuspenseInstance(fiber);
        } else if (31 === tag) {
            fiber = fiber.memoizedState;
            fiber = null !== fiber ? fiber.dehydrated : null;
            if (!fiber) throw Error(formatProdErrorMessage(317));
            nextHydratableInstance = getNextHydratableInstanceAfterActivityInstance(fiber);
        } else nextHydratableInstance = supportsSingletons && 27 === tag ? getNextHydratableSiblingAfterSingleton(fiber.type, nextHydratableInstance) : hydrationParentFiber ? getNextHydratableSibling(fiber.stateNode) : null;
        return !0;
    }
    function resetHydrationState() {
        supportsHydration && (nextHydratableInstance = hydrationParentFiber = null, isHydrating = !1);
    }
    function upgradeHydrationErrorsToRecoverable() {
        var queuedErrors = hydrationErrors;
        null !== queuedErrors && (null === workInProgressRootRecoverableErrors ? workInProgressRootRecoverableErrors = queuedErrors : workInProgressRootRecoverableErrors.push.apply(workInProgressRootRecoverableErrors, queuedErrors), hydrationErrors = null);
        return queuedErrors;
    }
    function queueHydrationError(error) {
        null === hydrationErrors ? hydrationErrors = [
            error
        ] : hydrationErrors.push(error);
    }
    function pushProvider(providerFiber, context, nextValue) {
        isPrimaryRenderer ? (push(valueCursor, context._currentValue), context._currentValue = nextValue) : (push(valueCursor, context._currentValue2), context._currentValue2 = nextValue);
    }
    function popProvider(context) {
        var currentValue = valueCursor.current;
        isPrimaryRenderer ? context._currentValue = currentValue : context._currentValue2 = currentValue;
        pop(valueCursor);
    }
    function scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
        for(; null !== parent;){
            var alternate = parent.alternate;
            (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
            if (parent === propagationRoot) break;
            parent = parent.return;
        }
    }
    function propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
        var fiber = workInProgress.child;
        null !== fiber && (fiber.return = workInProgress);
        for(; null !== fiber;){
            var list = fiber.dependencies;
            if (null !== list) {
                var nextFiber = fiber.child;
                list = list.firstContext;
                a: for(; null !== list;){
                    var dependency = list;
                    list = fiber;
                    for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                        list.lanes |= renderLanes;
                        dependency = list.alternate;
                        null !== dependency && (dependency.lanes |= renderLanes);
                        scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                        forcePropagateEntireTree || (nextFiber = null);
                        break a;
                    }
                    list = dependency.next;
                }
            } else if (18 === fiber.tag) {
                nextFiber = fiber.return;
                if (null === nextFiber) throw Error(formatProdErrorMessage(341));
                nextFiber.lanes |= renderLanes;
                list = nextFiber.alternate;
                null !== list && (list.lanes |= renderLanes);
                scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
                nextFiber = null;
            } else nextFiber = fiber.child;
            if (null !== nextFiber) nextFiber.return = fiber;
            else for(nextFiber = fiber; null !== nextFiber;){
                if (nextFiber === workInProgress) {
                    nextFiber = null;
                    break;
                }
                fiber = nextFiber.sibling;
                if (null !== fiber) {
                    fiber.return = nextFiber.return;
                    nextFiber = fiber;
                    break;
                }
                nextFiber = nextFiber.return;
            }
            fiber = nextFiber;
        }
    }
    function propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
        current = null;
        for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
            if (!isInsidePropagationBailout) {
                if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
                else if (0 !== (parent.flags & 262144)) break;
            }
            if (10 === parent.tag) {
                var currentParent = parent.alternate;
                if (null === currentParent) throw Error(formatProdErrorMessage(387));
                currentParent = currentParent.memoizedProps;
                if (null !== currentParent) {
                    var context = parent.type;
                    objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                        context
                    ]);
                }
            } else if (parent === hostTransitionProviderCursor.current) {
                currentParent = parent.alternate;
                if (null === currentParent) throw Error(formatProdErrorMessage(387));
                currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push(HostTransitionContext) : current = [
                    HostTransitionContext
                ]);
            }
            parent = parent.return;
        }
        null !== current && propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
        workInProgress.flags |= 262144;
    }
    function checkIfContextChanged(currentDependencies) {
        for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
            var context = currentDependencies.context;
            if (!objectIs(isPrimaryRenderer ? context._currentValue : context._currentValue2, currentDependencies.memoizedValue)) return !0;
            currentDependencies = currentDependencies.next;
        }
        return !1;
    }
    function prepareToReadContext(workInProgress) {
        currentlyRenderingFiber$1 = workInProgress;
        lastContextDependency = null;
        workInProgress = workInProgress.dependencies;
        null !== workInProgress && (workInProgress.firstContext = null);
    }
    function readContext(context) {
        return readContextForConsumer(currentlyRenderingFiber$1, context);
    }
    function readContextDuringReconciliation(consumer, context) {
        null === currentlyRenderingFiber$1 && prepareToReadContext(consumer);
        return readContextForConsumer(consumer, context);
    }
    function readContextForConsumer(consumer, context) {
        var value = isPrimaryRenderer ? context._currentValue : context._currentValue2;
        context = {
            context: context,
            memoizedValue: value,
            next: null
        };
        if (null === lastContextDependency) {
            if (null === consumer) throw Error(formatProdErrorMessage(308));
            lastContextDependency = context;
            consumer.dependencies = {
                lanes: 0,
                firstContext: context
            };
            consumer.flags |= 524288;
        } else lastContextDependency = lastContextDependency.next = context;
        return value;
    }
    function createCache() {
        return {
            controller: new AbortControllerLocal(),
            data: new Map(),
            refCount: 0
        };
    }
    function releaseCache(cache) {
        cache.refCount--;
        0 === cache.refCount && scheduleCallback$2(NormalPriority, function() {
            cache.controller.abort();
        });
    }
    function noop$1() {}
    function ensureRootIsScheduled(root) {
        root !== lastScheduledRoot && null === root.next && (null === lastScheduledRoot ? firstScheduledRoot = lastScheduledRoot = root : lastScheduledRoot = lastScheduledRoot.next = root);
        mightHavePendingSyncWork = !0;
        didScheduleMicrotask || (didScheduleMicrotask = !0, scheduleImmediateRootScheduleTask());
    }
    function flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
        if (!isFlushingWork && mightHavePendingSyncWork) {
            isFlushingWork = !0;
            do {
                var didPerformSomeWork = !1;
                for(var root = firstScheduledRoot; null !== root;){
                    if (!onlyLegacy) {
                        if (0 !== syncTransitionLanes) {
                            var pendingLanes = root.pendingLanes;
                            if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                            else {
                                var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
                                JSCompiler_inline_result = (1 << 31 - clz32(42 | syncTransitionLanes) + 1) - 1;
                                JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                                JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                            }
                            0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, performSyncWorkOnRoot(root, JSCompiler_inline_result));
                        } else JSCompiler_inline_result = workInProgressRootRenderLanes, JSCompiler_inline_result = getNextLanes(root, root === workInProgressRoot ? JSCompiler_inline_result : 0, null !== root.cancelPendingCommit || root.timeoutHandle !== noTimeout), 0 === (JSCompiler_inline_result & 3) || checkIfRootIsPrerendering(root, JSCompiler_inline_result) || (didPerformSomeWork = !0, performSyncWorkOnRoot(root, JSCompiler_inline_result));
                    }
                    root = root.next;
                }
            }while (didPerformSomeWork);
            isFlushingWork = !1;
        }
    }
    function processRootScheduleInImmediateTask() {
        processRootScheduleInMicrotask();
    }
    function processRootScheduleInMicrotask() {
        mightHavePendingSyncWork = didScheduleMicrotask = !1;
        var syncTransitionLanes = 0;
        0 !== currentEventTransitionLane && shouldAttemptEagerTransition() && (syncTransitionLanes = currentEventTransitionLane);
        for(var currentTime = now(), prev = null, root = firstScheduledRoot; null !== root;){
            var next = root.next, nextLanes = scheduleTaskForRootDuringMicrotask(root, currentTime);
            if (0 === nextLanes) root.next = null, null === prev ? firstScheduledRoot = next : prev.next = next, null === next && (lastScheduledRoot = prev);
            else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) mightHavePendingSyncWork = !0;
            root = next;
        }
        0 !== pendingEffectsStatus && 5 !== pendingEffectsStatus || flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
        0 !== currentEventTransitionLane && (currentEventTransitionLane = 0);
    }
    function scheduleTaskForRootDuringMicrotask(root, currentTime) {
        for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
            var index$3 = 31 - clz32(lanes), lane = 1 << index$3, expirationTime = expirationTimes[index$3];
            if (-1 === expirationTime) {
                if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$3] = computeExpirationTime(lane, currentTime);
            } else expirationTime <= currentTime && (root.expiredLanes |= lane);
            lanes &= ~lane;
        }
        currentTime = workInProgressRoot;
        suspendedLanes = workInProgressRootRenderLanes;
        suspendedLanes = getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || root.timeoutHandle !== noTimeout);
        pingedLanes = root.callbackNode;
        if (0 === suspendedLanes || root === currentTime && (2 === workInProgressSuspendedReason || 9 === workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
        if (0 === (suspendedLanes & 3) || checkIfRootIsPrerendering(root, suspendedLanes)) {
            currentTime = suspendedLanes & -suspendedLanes;
            if (currentTime === root.callbackPriority) return currentTime;
            null !== pingedLanes && cancelCallback$1(pingedLanes);
            switch(lanesToEventPriority(suspendedLanes)){
                case 2:
                case 8:
                    suspendedLanes = UserBlockingPriority;
                    break;
                case 32:
                    suspendedLanes = NormalPriority$1;
                    break;
                case 268435456:
                    suspendedLanes = IdlePriority;
                    break;
                default:
                    suspendedLanes = NormalPriority$1;
            }
            pingedLanes = performWorkOnRootViaSchedulerTask.bind(null, root);
            suspendedLanes = scheduleCallback$3(suspendedLanes, pingedLanes);
            root.callbackPriority = currentTime;
            root.callbackNode = suspendedLanes;
            return currentTime;
        }
        null !== pingedLanes && null !== pingedLanes && cancelCallback$1(pingedLanes);
        root.callbackPriority = 2;
        root.callbackNode = null;
        return 2;
    }
    function performWorkOnRootViaSchedulerTask(root, didTimeout) {
        if (0 !== pendingEffectsStatus && 5 !== pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
        var originalCallbackNode = root.callbackNode;
        if (flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
        var workInProgressRootRenderLanes$jscomp$0 = workInProgressRootRenderLanes;
        workInProgressRootRenderLanes$jscomp$0 = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || root.timeoutHandle !== noTimeout);
        if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
        performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
        scheduleTaskForRootDuringMicrotask(root, now());
        return null != root.callbackNode && root.callbackNode === originalCallbackNode ? performWorkOnRootViaSchedulerTask.bind(null, root) : null;
    }
    function performSyncWorkOnRoot(root, lanes) {
        if (flushPendingEffects()) return null;
        performWorkOnRoot(root, lanes, !0);
    }
    function scheduleImmediateRootScheduleTask() {
        supportsMicrotasks ? scheduleMicrotask(function() {
            0 !== (executionContext & 6) ? scheduleCallback$3(ImmediatePriority, processRootScheduleInImmediateTask) : processRootScheduleInMicrotask();
        }) : scheduleCallback$3(ImmediatePriority, processRootScheduleInImmediateTask);
    }
    function requestTransitionLane() {
        if (0 === currentEventTransitionLane) {
            var actionScopeLane = currentEntangledLane;
            0 === actionScopeLane && (actionScopeLane = nextTransitionUpdateLane, nextTransitionUpdateLane <<= 1, 0 === (nextTransitionUpdateLane & 261888) && (nextTransitionUpdateLane = 256));
            currentEventTransitionLane = actionScopeLane;
        }
        return currentEventTransitionLane;
    }
    function entangleAsyncAction(transition, thenable) {
        if (null === currentEntangledListeners) {
            var entangledListeners = currentEntangledListeners = [];
            currentEntangledPendingCount = 0;
            currentEntangledLane = requestTransitionLane();
            currentEntangledActionThenable = {
                status: "pending",
                value: void 0,
                then: function(resolve) {
                    entangledListeners.push(resolve);
                }
            };
        }
        currentEntangledPendingCount++;
        thenable.then(pingEngtangledActionScope, pingEngtangledActionScope);
        return thenable;
    }
    function pingEngtangledActionScope() {
        if (0 === --currentEntangledPendingCount && null !== currentEntangledListeners) {
            null !== currentEntangledActionThenable && (currentEntangledActionThenable.status = "fulfilled");
            var listeners = currentEntangledListeners;
            currentEntangledListeners = null;
            currentEntangledLane = 0;
            currentEntangledActionThenable = null;
            for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
        }
    }
    function chainThenableValue(thenable, result) {
        var listeners = [], thenableWithOverride = {
            status: "pending",
            value: null,
            reason: null,
            then: function(resolve) {
                listeners.push(resolve);
            }
        };
        thenable.then(function() {
            thenableWithOverride.status = "fulfilled";
            thenableWithOverride.value = result;
            for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
        }, function(error) {
            thenableWithOverride.status = "rejected";
            thenableWithOverride.reason = error;
            for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
        });
        return thenableWithOverride;
    }
    function peekCacheFromPool() {
        var cacheResumedFromPreviousRender = resumedCache.current;
        return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : workInProgressRoot.pooledCache;
    }
    function pushTransition(offscreenWorkInProgress, prevCachePool) {
        null === prevCachePool ? push(resumedCache, resumedCache.current) : push(resumedCache, prevCachePool.pool);
    }
    function getSuspendedCache() {
        var cacheFromPool = peekCacheFromPool();
        return null === cacheFromPool ? null : {
            parent: isPrimaryRenderer ? CacheContext._currentValue : CacheContext._currentValue2,
            pool: cacheFromPool
        };
    }
    function shallowEqual(objA, objB) {
        if (objectIs(objA, objB)) return !0;
        if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
        var keysA = Object.keys(objA), keysB = Object.keys(objB);
        if (keysA.length !== keysB.length) return !1;
        for(keysB = 0; keysB < keysA.length; keysB++){
            var currentKey = keysA[keysB];
            if (!hasOwnProperty.call(objB, currentKey) || !objectIs(objA[currentKey], objB[currentKey])) return !1;
        }
        return !0;
    }
    function isThenableResolved(thenable) {
        thenable = thenable.status;
        return "fulfilled" === thenable || "rejected" === thenable;
    }
    function trackUsedThenable(thenableState, thenable, index) {
        index = thenableState[index];
        void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then(noop$1, noop$1), thenable = index);
        switch(thenable.status){
            case "fulfilled":
                return thenable.value;
            case "rejected":
                throw thenableState = thenable.reason, checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            default:
                if ("string" === typeof thenable.status) thenable.then(noop$1, noop$1);
                else {
                    thenableState = workInProgressRoot;
                    if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error(formatProdErrorMessage(482));
                    thenableState = thenable;
                    thenableState.status = "pending";
                    thenableState.then(function(fulfilledValue) {
                        if ("pending" === thenable.status) {
                            var fulfilledThenable = thenable;
                            fulfilledThenable.status = "fulfilled";
                            fulfilledThenable.value = fulfilledValue;
                        }
                    }, function(error) {
                        if ("pending" === thenable.status) {
                            var rejectedThenable = thenable;
                            rejectedThenable.status = "rejected";
                            rejectedThenable.reason = error;
                        }
                    });
                }
                switch(thenable.status){
                    case "fulfilled":
                        return thenable.value;
                    case "rejected":
                        throw thenableState = thenable.reason, checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
                }
                suspendedThenable = thenable;
                throw SuspenseException;
        }
    }
    function resolveLazy(lazyType) {
        try {
            var init = lazyType._init;
            return init(lazyType._payload);
        } catch (x) {
            if (null !== x && "object" === typeof x && "function" === typeof x.then) throw suspendedThenable = x, SuspenseException;
            throw x;
        }
    }
    function getSuspendedThenable() {
        if (null === suspendedThenable) throw Error(formatProdErrorMessage(459));
        var thenable = suspendedThenable;
        suspendedThenable = null;
        return thenable;
    }
    function checkIfUseWrappedInAsyncCatch(rejectedReason) {
        if (rejectedReason === SuspenseException || rejectedReason === SuspenseActionException) throw Error(formatProdErrorMessage(483));
    }
    function unwrapThenable(thenable) {
        var index = thenableIndexCounter$1;
        thenableIndexCounter$1 += 1;
        null === thenableState$1 && (thenableState$1 = []);
        return trackUsedThenable(thenableState$1, thenable, index);
    }
    function coerceRef(workInProgress, element) {
        element = element.props.ref;
        workInProgress.ref = void 0 !== element ? element : null;
    }
    function throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
        if (newChild.$$typeof === REACT_LEGACY_ELEMENT_TYPE) throw Error(formatProdErrorMessage(525));
        returnFiber = Object.prototype.toString.call(newChild);
        throw Error(formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
    }
    function createChildReconciler(shouldTrackSideEffects) {
        function deleteChild(returnFiber, childToDelete) {
            if (shouldTrackSideEffects) {
                var deletions = returnFiber.deletions;
                null === deletions ? (returnFiber.deletions = [
                    childToDelete
                ], returnFiber.flags |= 16) : deletions.push(childToDelete);
            }
        }
        function deleteRemainingChildren(returnFiber, currentFirstChild) {
            if (!shouldTrackSideEffects) return null;
            for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
            return null;
        }
        function mapRemainingChildren(currentFirstChild) {
            for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
            return existingChildren;
        }
        function useFiber(fiber, pendingProps) {
            fiber = createWorkInProgress(fiber, pendingProps);
            fiber.index = 0;
            fiber.sibling = null;
            return fiber;
        }
        function placeChild(newFiber, lastPlacedIndex, newIndex) {
            newFiber.index = newIndex;
            if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
            newIndex = newFiber.alternate;
            if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
            newFiber.flags |= 67108866;
            return lastPlacedIndex;
        }
        function placeSingleChild(newFiber) {
            shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
            return newFiber;
        }
        function updateTextNode(returnFiber, current, textContent, lanes) {
            if (null === current || 6 !== current.tag) return current = createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
            current = useFiber(current, textContent);
            current.return = returnFiber;
            return current;
        }
        function updateElement(returnFiber, current, element, lanes) {
            var elementType = element.type;
            if (elementType === REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
            if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), coerceRef(current, element), current.return = returnFiber, current;
            current = createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
            coerceRef(current, element);
            current.return = returnFiber;
            return current;
        }
        function updatePortal(returnFiber, current, portal, lanes) {
            if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
            current = useFiber(current, portal.children || []);
            current.return = returnFiber;
            return current;
        }
        function updateFragment(returnFiber, current, fragment, lanes, key) {
            if (null === current || 7 !== current.tag) return current = createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
            current = useFiber(current, fragment);
            current.return = returnFiber;
            return current;
        }
        function createChild(returnFiber, newChild, lanes) {
            if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
            if ("object" === typeof newChild && null !== newChild) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        return lanes = createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                    case REACT_PORTAL_TYPE:
                        return newChild = createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                    case REACT_LAZY_TYPE:
                        return newChild = resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
                }
                if (isArrayImpl(newChild) || getIteratorFn(newChild)) return newChild = createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
                if ("function" === typeof newChild.then) return createChild(returnFiber, unwrapThenable(newChild), lanes);
                if (newChild.$$typeof === REACT_CONTEXT_TYPE) return createChild(returnFiber, readContextDuringReconciliation(returnFiber, newChild), lanes);
                throwOnInvalidObjectTypeImpl(returnFiber, newChild);
            }
            return null;
        }
        function updateSlot(returnFiber, oldFiber, newChild, lanes) {
            var key = null !== oldFiber ? oldFiber.key : null;
            if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
            if ("object" === typeof newChild && null !== newChild) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                    case REACT_PORTAL_TYPE:
                        return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                    case REACT_LAZY_TYPE:
                        return newChild = resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
                }
                if (isArrayImpl(newChild) || getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
                if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, unwrapThenable(newChild), lanes);
                if (newChild.$$typeof === REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, readContextDuringReconciliation(returnFiber, newChild), lanes);
                throwOnInvalidObjectTypeImpl(returnFiber, newChild);
            }
            return null;
        }
        function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
            if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
            if ("object" === typeof newChild && null !== newChild) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                    case REACT_PORTAL_TYPE:
                        return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                    case REACT_LAZY_TYPE:
                        return newChild = resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
                }
                if (isArrayImpl(newChild) || getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
                if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, unwrapThenable(newChild), lanes);
                if (newChild.$$typeof === REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, readContextDuringReconciliation(returnFiber, newChild), lanes);
                throwOnInvalidObjectTypeImpl(returnFiber, newChild);
            }
            return null;
        }
        function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
            for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
                oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
                if (null === newFiber) {
                    null === oldFiber && (oldFiber = nextOldFiber);
                    break;
                }
                shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
                currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
                null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), isHydrating && pushTreeFork(returnFiber, newIdx), resultingFirstChild;
            if (null === oldFiber) {
                for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
                isHydrating && pushTreeFork(returnFiber, newIdx);
                return resultingFirstChild;
            }
            for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
            shouldTrackSideEffects && oldFiber.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            isHydrating && pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
            if (null == newChildren) throw Error(formatProdErrorMessage(151));
            for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
                oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
                if (null === newFiber) {
                    null === oldFiber && (oldFiber = nextOldFiber);
                    break;
                }
                shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
                currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
                null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), isHydrating && pushTreeFork(returnFiber, newIdx), resultingFirstChild;
            if (null === oldFiber) {
                for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
                isHydrating && pushTreeFork(returnFiber, newIdx);
                return resultingFirstChild;
            }
            for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            shouldTrackSideEffects && oldFiber.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            isHydrating && pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
            "object" === typeof newChild && null !== newChild && newChild.type === REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
            if ("object" === typeof newChild && null !== newChild) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        a: {
                            for(var key = newChild.key; null !== currentFirstChild;){
                                if (currentFirstChild.key === key) {
                                    key = newChild.type;
                                    if (key === REACT_FRAGMENT_TYPE) {
                                        if (7 === currentFirstChild.tag) {
                                            deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                            lanes = useFiber(currentFirstChild, newChild.props.children);
                                            lanes.return = returnFiber;
                                            returnFiber = lanes;
                                            break a;
                                        }
                                    } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === REACT_LAZY_TYPE && resolveLazy(key) === currentFirstChild.type) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props);
                                        coerceRef(lanes, newChild);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                } else deleteChild(returnFiber, currentFirstChild);
                                currentFirstChild = currentFirstChild.sibling;
                            }
                            newChild.type === REACT_FRAGMENT_TYPE ? (lanes = createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                        }
                        return placeSingleChild(returnFiber);
                    case REACT_PORTAL_TYPE:
                        a: {
                            for(key = newChild.key; null !== currentFirstChild;){
                                if (currentFirstChild.key === key) {
                                    if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.children || []);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    } else {
                                        deleteRemainingChildren(returnFiber, currentFirstChild);
                                        break;
                                    }
                                } else deleteChild(returnFiber, currentFirstChild);
                                currentFirstChild = currentFirstChild.sibling;
                            }
                            lanes = createFiberFromPortal(newChild, returnFiber.mode, lanes);
                            lanes.return = returnFiber;
                            returnFiber = lanes;
                        }
                        return placeSingleChild(returnFiber);
                    case REACT_LAZY_TYPE:
                        return newChild = resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
                }
                if (isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
                if (getIteratorFn(newChild)) {
                    key = getIteratorFn(newChild);
                    if ("function" !== typeof key) throw Error(formatProdErrorMessage(150));
                    newChild = key.call(newChild);
                    return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
                }
                if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, unwrapThenable(newChild), lanes);
                if (newChild.$$typeof === REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, readContextDuringReconciliation(returnFiber, newChild), lanes);
                throwOnInvalidObjectTypeImpl(returnFiber, newChild);
            }
            return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
        }
        return function(returnFiber, currentFirstChild, newChild, lanes) {
            try {
                thenableIndexCounter$1 = 0;
                var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
                thenableState$1 = null;
                return firstChildFiber;
            } catch (x) {
                if (x === SuspenseException || x === SuspenseActionException) throw x;
                var fiber = createFiber(29, x, null, returnFiber.mode);
                fiber.lanes = lanes;
                fiber.return = returnFiber;
                return fiber;
            } finally{}
        };
    }
    function finishQueueingConcurrentUpdates() {
        for(var endIndex = concurrentQueuesIndex, i = concurrentlyUpdatedLanes = concurrentQueuesIndex = 0; i < endIndex;){
            var fiber = concurrentQueues[i];
            concurrentQueues[i++] = null;
            var queue = concurrentQueues[i];
            concurrentQueues[i++] = null;
            var update = concurrentQueues[i];
            concurrentQueues[i++] = null;
            var lane = concurrentQueues[i];
            concurrentQueues[i++] = null;
            if (null !== queue && null !== update) {
                var pending = queue.pending;
                null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
                queue.pending = update;
            }
            0 !== lane && markUpdateLaneFromFiberToRoot(fiber, update, lane);
        }
    }
    function enqueueUpdate$1(fiber, queue, update, lane) {
        concurrentQueues[concurrentQueuesIndex++] = fiber;
        concurrentQueues[concurrentQueuesIndex++] = queue;
        concurrentQueues[concurrentQueuesIndex++] = update;
        concurrentQueues[concurrentQueuesIndex++] = lane;
        concurrentlyUpdatedLanes |= lane;
        fiber.lanes |= lane;
        fiber = fiber.alternate;
        null !== fiber && (fiber.lanes |= lane);
    }
    function enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
        enqueueUpdate$1(fiber, queue, update, lane);
        return getRootForUpdatedFiber(fiber);
    }
    function enqueueConcurrentRenderForLane(fiber, lane) {
        enqueueUpdate$1(fiber, null, null, lane);
        return getRootForUpdatedFiber(fiber);
    }
    function markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
        sourceFiber.lanes |= lane;
        var alternate = sourceFiber.alternate;
        null !== alternate && (alternate.lanes |= lane);
        for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
        return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
            update
        ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
    }
    function getRootForUpdatedFiber(sourceFiber) {
        if (50 < nestedUpdateCount) throw nestedUpdateCount = 0, rootWithNestedUpdates = null, Error(formatProdErrorMessage(185));
        for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
        return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
    }
    function initializeUpdateQueue(fiber) {
        fiber.updateQueue = {
            baseState: fiber.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: {
                pending: null,
                lanes: 0,
                hiddenCallbacks: null
            },
            callbacks: null
        };
    }
    function cloneUpdateQueue(current, workInProgress) {
        current = current.updateQueue;
        workInProgress.updateQueue === current && (workInProgress.updateQueue = {
            baseState: current.baseState,
            firstBaseUpdate: current.firstBaseUpdate,
            lastBaseUpdate: current.lastBaseUpdate,
            shared: current.shared,
            callbacks: null
        });
    }
    function createUpdate(lane) {
        return {
            lane: lane,
            tag: 0,
            payload: null,
            callback: null,
            next: null
        };
    }
    function enqueueUpdate(fiber, update, lane) {
        var updateQueue = fiber.updateQueue;
        if (null === updateQueue) return null;
        updateQueue = updateQueue.shared;
        if (0 !== (executionContext & 2)) {
            var pending = updateQueue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            updateQueue.pending = update;
            update = getRootForUpdatedFiber(fiber);
            markUpdateLaneFromFiberToRoot(fiber, null, lane);
            return update;
        }
        enqueueUpdate$1(fiber, updateQueue, update, lane);
        return getRootForUpdatedFiber(fiber);
    }
    function entangleTransitions(root, fiber, lane) {
        fiber = fiber.updateQueue;
        if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
            var queueLanes = fiber.lanes;
            queueLanes &= root.pendingLanes;
            lane |= queueLanes;
            fiber.lanes = lane;
            markRootEntangled(root, lane);
        }
    }
    function enqueueCapturedUpdate(workInProgress, capturedUpdate) {
        var queue = workInProgress.updateQueue, current = workInProgress.alternate;
        if (null !== current && (current = current.updateQueue, queue === current)) {
            var newFirst = null, newLast = null;
            queue = queue.firstBaseUpdate;
            if (null !== queue) {
                do {
                    var clone = {
                        lane: queue.lane,
                        tag: queue.tag,
                        payload: queue.payload,
                        callback: null,
                        next: null
                    };
                    null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                    queue = queue.next;
                }while (null !== queue);
                null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
            } else newFirst = newLast = capturedUpdate;
            queue = {
                baseState: current.baseState,
                firstBaseUpdate: newFirst,
                lastBaseUpdate: newLast,
                shared: current.shared,
                callbacks: current.callbacks
            };
            workInProgress.updateQueue = queue;
            return;
        }
        workInProgress = queue.lastBaseUpdate;
        null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
        queue.lastBaseUpdate = capturedUpdate;
    }
    function suspendIfUpdateReadFromEntangledAsyncAction() {
        if (didReadFromEntangledAsyncAction) {
            var entangledActionThenable = currentEntangledActionThenable;
            if (null !== entangledActionThenable) throw entangledActionThenable;
        }
    }
    function processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
        didReadFromEntangledAsyncAction = !1;
        var queue = workInProgress$jscomp$0.updateQueue;
        hasForceUpdate = !1;
        var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
        if (null !== pendingQueue) {
            queue.shared.pending = null;
            var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
            lastPendingUpdate.next = null;
            null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
            lastBaseUpdate = lastPendingUpdate;
            var current = workInProgress$jscomp$0.alternate;
            null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
        }
        if (null !== firstBaseUpdate) {
            var newState = queue.baseState;
            lastBaseUpdate = 0;
            current = firstPendingUpdate = lastPendingUpdate = null;
            pendingQueue = firstBaseUpdate;
            do {
                var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
                if (isHiddenUpdate ? (workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                    0 !== updateLane && updateLane === currentEntangledLane && (didReadFromEntangledAsyncAction = !0);
                    null !== current && (current = current.next = {
                        lane: 0,
                        tag: pendingQueue.tag,
                        payload: pendingQueue.payload,
                        callback: null,
                        next: null
                    });
                    a: {
                        var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                        updateLane = props;
                        var instance = instance$jscomp$0;
                        switch(update.tag){
                            case 1:
                                workInProgress = update.payload;
                                if ("function" === typeof workInProgress) {
                                    newState = workInProgress.call(instance, newState, updateLane);
                                    break a;
                                }
                                newState = workInProgress;
                                break a;
                            case 3:
                                workInProgress.flags = workInProgress.flags & -65537 | 128;
                            case 0:
                                workInProgress = update.payload;
                                updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                                if (null === updateLane || void 0 === updateLane) break a;
                                newState = assign({}, newState, updateLane);
                                break a;
                            case 2:
                                hasForceUpdate = !0;
                        }
                    }
                    updateLane = pendingQueue.callback;
                    null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                        updateLane
                    ] : isHiddenUpdate.push(updateLane));
                } else isHiddenUpdate = {
                    lane: updateLane,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: pendingQueue.callback,
                    next: null
                }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
                pendingQueue = pendingQueue.next;
                if (null === pendingQueue) {
                    if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                    else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
                }
            }while (1);
            null === current && (lastPendingUpdate = newState);
            queue.baseState = lastPendingUpdate;
            queue.firstBaseUpdate = firstPendingUpdate;
            queue.lastBaseUpdate = current;
            null === firstBaseUpdate && (queue.shared.lanes = 0);
            workInProgressRootSkippedLanes |= lastBaseUpdate;
            workInProgress$jscomp$0.lanes = lastBaseUpdate;
            workInProgress$jscomp$0.memoizedState = newState;
        }
    }
    function callCallback(callback, context) {
        if ("function" !== typeof callback) throw Error(formatProdErrorMessage(191, callback));
        callback.call(context);
    }
    function commitCallbacks(updateQueue, context) {
        var callbacks = updateQueue.callbacks;
        if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)callCallback(callbacks[updateQueue], context);
    }
    function pushHiddenContext(fiber, context) {
        fiber = entangledRenderLanes;
        push(prevEntangledRenderLanesCursor, fiber);
        push(currentTreeHiddenStackCursor, context);
        entangledRenderLanes = fiber | context.baseLanes;
    }
    function reuseHiddenContextOnStack() {
        push(prevEntangledRenderLanesCursor, entangledRenderLanes);
        push(currentTreeHiddenStackCursor, currentTreeHiddenStackCursor.current);
    }
    function popHiddenContext() {
        entangledRenderLanes = prevEntangledRenderLanesCursor.current;
        pop(currentTreeHiddenStackCursor);
        pop(prevEntangledRenderLanesCursor);
    }
    function pushPrimaryTreeSuspenseHandler(handler) {
        var current = handler.alternate;
        push(suspenseStackCursor, suspenseStackCursor.current & 1);
        push(suspenseHandlerStackCursor, handler);
        null === shellBoundary && (null === current || null !== currentTreeHiddenStackCursor.current ? shellBoundary = handler : null !== current.memoizedState && (shellBoundary = handler));
    }
    function pushDehydratedActivitySuspenseHandler(fiber) {
        push(suspenseStackCursor, suspenseStackCursor.current);
        push(suspenseHandlerStackCursor, fiber);
        null === shellBoundary && (shellBoundary = fiber);
    }
    function pushOffscreenSuspenseHandler(fiber) {
        22 === fiber.tag ? (push(suspenseStackCursor, suspenseStackCursor.current), push(suspenseHandlerStackCursor, fiber), null === shellBoundary && (shellBoundary = fiber)) : reuseSuspenseHandlerOnStack(fiber);
    }
    function reuseSuspenseHandlerOnStack() {
        push(suspenseStackCursor, suspenseStackCursor.current);
        push(suspenseHandlerStackCursor, suspenseHandlerStackCursor.current);
    }
    function popSuspenseHandler(fiber) {
        pop(suspenseHandlerStackCursor);
        shellBoundary === fiber && (shellBoundary = null);
        pop(suspenseStackCursor);
    }
    function findFirstSuspended(row) {
        for(var node = row; null !== node;){
            if (13 === node.tag) {
                var state = node.memoizedState;
                if (null !== state && (state = state.dehydrated, null === state || isSuspenseInstancePending(state) || isSuspenseInstanceFallback(state))) return node;
            } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
                if (0 !== (node.flags & 128)) return node;
            } else if (null !== node.child) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === row) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === row) return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
        return null;
    }
    function throwInvalidHookError() {
        throw Error(formatProdErrorMessage(321));
    }
    function areHookInputsEqual(nextDeps, prevDeps) {
        if (null === prevDeps) return !1;
        for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!objectIs(nextDeps[i], prevDeps[i])) return !1;
        return !0;
    }
    function renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
        renderLanes = nextRenderLanes;
        currentlyRenderingFiber = workInProgress;
        workInProgress.memoizedState = null;
        workInProgress.updateQueue = null;
        workInProgress.lanes = 0;
        ReactSharedInternals.H = null === current || null === current.memoizedState ? HooksDispatcherOnMount : HooksDispatcherOnUpdate;
        shouldDoubleInvokeUserFnsInHooksDEV = !1;
        nextRenderLanes = Component(props, secondArg);
        shouldDoubleInvokeUserFnsInHooksDEV = !1;
        didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = renderWithHooksAgain(workInProgress, Component, props, secondArg));
        finishRenderingHooks(current);
        return nextRenderLanes;
    }
    function finishRenderingHooks(current) {
        ReactSharedInternals.H = ContextOnlyDispatcher;
        var didRenderTooFewHooks = null !== currentHook && null !== currentHook.next;
        renderLanes = 0;
        workInProgressHook = currentHook = currentlyRenderingFiber = null;
        didScheduleRenderPhaseUpdate = !1;
        thenableIndexCounter = 0;
        thenableState = null;
        if (didRenderTooFewHooks) throw Error(formatProdErrorMessage(300));
        null === current || didReceiveUpdate || (current = current.dependencies, null !== current && checkIfContextChanged(current) && (didReceiveUpdate = !0));
    }
    function renderWithHooksAgain(workInProgress, Component, props, secondArg) {
        currentlyRenderingFiber = workInProgress;
        var numberOfReRenders = 0;
        do {
            didScheduleRenderPhaseUpdateDuringThisPass && (thenableState = null);
            thenableIndexCounter = 0;
            didScheduleRenderPhaseUpdateDuringThisPass = !1;
            if (25 <= numberOfReRenders) throw Error(formatProdErrorMessage(301));
            numberOfReRenders += 1;
            workInProgressHook = currentHook = null;
            if (null != workInProgress.updateQueue) {
                var children = workInProgress.updateQueue;
                children.lastEffect = null;
                children.events = null;
                children.stores = null;
                null != children.memoCache && (children.memoCache.index = 0);
            }
            ReactSharedInternals.H = HooksDispatcherOnRerender;
            children = Component(props, secondArg);
        }while (didScheduleRenderPhaseUpdateDuringThisPass);
        return children;
    }
    function TransitionAwareHostComponent() {
        var dispatcher = ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
        maybeThenable = "function" === typeof maybeThenable.then ? useThenable(maybeThenable) : maybeThenable;
        dispatcher = dispatcher.useState()[0];
        (null !== currentHook ? currentHook.memoizedState : null) !== dispatcher && (currentlyRenderingFiber.flags |= 1024);
        return maybeThenable;
    }
    function checkDidRenderIdHook() {
        var didRenderIdHook = 0 !== localIdCounter;
        localIdCounter = 0;
        return didRenderIdHook;
    }
    function bailoutHooks(current, workInProgress, lanes) {
        workInProgress.updateQueue = current.updateQueue;
        workInProgress.flags &= -2053;
        current.lanes &= ~lanes;
    }
    function resetHooksOnUnwind(workInProgress) {
        if (didScheduleRenderPhaseUpdate) {
            for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
                var queue = workInProgress.queue;
                null !== queue && (queue.pending = null);
                workInProgress = workInProgress.next;
            }
            didScheduleRenderPhaseUpdate = !1;
        }
        renderLanes = 0;
        workInProgressHook = currentHook = currentlyRenderingFiber = null;
        didScheduleRenderPhaseUpdateDuringThisPass = !1;
        thenableIndexCounter = localIdCounter = 0;
        thenableState = null;
    }
    function mountWorkInProgressHook() {
        var hook = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null
        };
        null === workInProgressHook ? currentlyRenderingFiber.memoizedState = workInProgressHook = hook : workInProgressHook = workInProgressHook.next = hook;
        return workInProgressHook;
    }
    function updateWorkInProgressHook() {
        if (null === currentHook) {
            var nextCurrentHook = currentlyRenderingFiber.alternate;
            nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
        } else nextCurrentHook = currentHook.next;
        var nextWorkInProgressHook = null === workInProgressHook ? currentlyRenderingFiber.memoizedState : workInProgressHook.next;
        if (null !== nextWorkInProgressHook) workInProgressHook = nextWorkInProgressHook, currentHook = nextCurrentHook;
        else {
            if (null === nextCurrentHook) {
                if (null === currentlyRenderingFiber.alternate) throw Error(formatProdErrorMessage(467));
                throw Error(formatProdErrorMessage(310));
            }
            currentHook = nextCurrentHook;
            nextCurrentHook = {
                memoizedState: currentHook.memoizedState,
                baseState: currentHook.baseState,
                baseQueue: currentHook.baseQueue,
                queue: currentHook.queue,
                next: null
            };
            null === workInProgressHook ? currentlyRenderingFiber.memoizedState = workInProgressHook = nextCurrentHook : workInProgressHook = workInProgressHook.next = nextCurrentHook;
        }
        return workInProgressHook;
    }
    function createFunctionComponentUpdateQueue() {
        return {
            lastEffect: null,
            events: null,
            stores: null,
            memoCache: null
        };
    }
    function useThenable(thenable) {
        var index = thenableIndexCounter;
        thenableIndexCounter += 1;
        null === thenableState && (thenableState = []);
        thenable = trackUsedThenable(thenableState, thenable, index);
        index = currentlyRenderingFiber;
        null === (null === workInProgressHook ? index.memoizedState : workInProgressHook.next) && (index = index.alternate, ReactSharedInternals.H = null === index || null === index.memoizedState ? HooksDispatcherOnMount : HooksDispatcherOnUpdate);
        return thenable;
    }
    function use(usable) {
        if (null !== usable && "object" === typeof usable) {
            if ("function" === typeof usable.then) return useThenable(usable);
            if (usable.$$typeof === REACT_CONTEXT_TYPE) return readContext(usable);
        }
        throw Error(formatProdErrorMessage(438, String(usable)));
    }
    function useMemoCache(size) {
        var memoCache = null, updateQueue = currentlyRenderingFiber.updateQueue;
        null !== updateQueue && (memoCache = updateQueue.memoCache);
        if (null == memoCache) {
            var current = currentlyRenderingFiber.alternate;
            null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
                data: current.data.map(function(array) {
                    return array.slice();
                }),
                index: 0
            })));
        }
        null == memoCache && (memoCache = {
            data: [],
            index: 0
        });
        null === updateQueue && (updateQueue = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = updateQueue);
        updateQueue.memoCache = memoCache;
        updateQueue = memoCache.data[memoCache.index];
        if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = REACT_MEMO_CACHE_SENTINEL;
        memoCache.index++;
        return updateQueue;
    }
    function basicStateReducer(state, action) {
        return "function" === typeof action ? action(state) : action;
    }
    function updateReducer(reducer) {
        var hook = updateWorkInProgressHook();
        return updateReducerImpl(hook, currentHook, reducer);
    }
    function updateReducerImpl(hook, current, reducer) {
        var queue = hook.queue;
        if (null === queue) throw Error(formatProdErrorMessage(311));
        queue.lastRenderedReducer = reducer;
        var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
        if (null !== pendingQueue) {
            if (null !== baseQueue) {
                var baseFirst = baseQueue.next;
                baseQueue.next = pendingQueue.next;
                pendingQueue.next = baseFirst;
            }
            current.baseQueue = baseQueue = pendingQueue;
            queue.pending = null;
        }
        pendingQueue = hook.baseState;
        if (null === baseQueue) hook.memoizedState = pendingQueue;
        else {
            current = baseQueue.next;
            var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$51 = !1;
            do {
                var updateLane = update.lane & -536870913;
                if (updateLane !== update.lane ? (workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                    var revertLane = update.revertLane;
                    if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                        lane: 0,
                        revertLane: 0,
                        gesture: null,
                        action: update.action,
                        hasEagerState: update.hasEagerState,
                        eagerState: update.eagerState,
                        next: null
                    }), updateLane === currentEntangledLane && (didReadFromEntangledAsyncAction$51 = !0);
                    else if ((renderLanes & revertLane) === revertLane) {
                        update = update.next;
                        revertLane === currentEntangledLane && (didReadFromEntangledAsyncAction$51 = !0);
                        continue;
                    } else updateLane = {
                        lane: 0,
                        revertLane: update.revertLane,
                        gesture: null,
                        action: update.action,
                        hasEagerState: update.hasEagerState,
                        eagerState: update.eagerState,
                        next: null
                    }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, currentlyRenderingFiber.lanes |= revertLane, workInProgressRootSkippedLanes |= revertLane;
                    updateLane = update.action;
                    shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                    pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
                } else revertLane = {
                    lane: updateLane,
                    revertLane: update.revertLane,
                    gesture: update.gesture,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, currentlyRenderingFiber.lanes |= updateLane, workInProgressRootSkippedLanes |= updateLane;
                update = update.next;
            }while (null !== update && update !== current);
            null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
            if (!objectIs(pendingQueue, hook.memoizedState) && (didReceiveUpdate = !0, didReadFromEntangledAsyncAction$51 && (reducer = currentEntangledActionThenable, null !== reducer))) throw reducer;
            hook.memoizedState = pendingQueue;
            hook.baseState = baseFirst;
            hook.baseQueue = newBaseQueueLast;
            queue.lastRenderedState = pendingQueue;
        }
        null === baseQueue && (queue.lanes = 0);
        return [
            hook.memoizedState,
            queue.dispatch
        ];
    }
    function rerenderReducer(reducer) {
        var hook = updateWorkInProgressHook(), queue = hook.queue;
        if (null === queue) throw Error(formatProdErrorMessage(311));
        queue.lastRenderedReducer = reducer;
        var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
        if (null !== lastRenderPhaseUpdate) {
            queue.pending = null;
            var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
            do newState = reducer(newState, update.action), update = update.next;
            while (update !== lastRenderPhaseUpdate);
            objectIs(newState, hook.memoizedState) || (didReceiveUpdate = !0);
            hook.memoizedState = newState;
            null === hook.baseQueue && (hook.baseState = newState);
            queue.lastRenderedState = newState;
        }
        return [
            newState,
            dispatch
        ];
    }
    function updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber, hook = updateWorkInProgressHook(), isHydrating$jscomp$0 = isHydrating;
        if (isHydrating$jscomp$0) {
            if (void 0 === getServerSnapshot) throw Error(formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else getServerSnapshot = getSnapshot();
        var snapshotChanged = !objectIs((currentHook || hook).memoizedState, getServerSnapshot);
        snapshotChanged && (hook.memoizedState = getServerSnapshot, didReceiveUpdate = !0);
        hook = hook.queue;
        updateEffect(subscribeToStore.bind(null, fiber, hook, subscribe), [
            subscribe
        ]);
        if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== workInProgressHook && workInProgressHook.memoizedState.tag & 1) {
            fiber.flags |= 2048;
            pushSimpleEffect(9, {
                destroy: void 0
            }, updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
            if (null === workInProgressRoot) throw Error(formatProdErrorMessage(349));
            isHydrating$jscomp$0 || 0 !== (renderLanes & 127) || pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        return getServerSnapshot;
    }
    function pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
        fiber.flags |= 16384;
        fiber = {
            getSnapshot: getSnapshot,
            value: renderedSnapshot
        };
        getSnapshot = currentlyRenderingFiber.updateQueue;
        null === getSnapshot ? (getSnapshot = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
            fiber
        ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
            fiber
        ] : renderedSnapshot.push(fiber));
    }
    function updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
        inst.value = nextSnapshot;
        inst.getSnapshot = getSnapshot;
        checkIfSnapshotChanged(inst) && forceStoreRerender(fiber);
    }
    function subscribeToStore(fiber, inst, subscribe) {
        return subscribe(function() {
            checkIfSnapshotChanged(inst) && forceStoreRerender(fiber);
        });
    }
    function checkIfSnapshotChanged(inst) {
        var latestGetSnapshot = inst.getSnapshot;
        inst = inst.value;
        try {
            var nextValue = latestGetSnapshot();
            return !objectIs(inst, nextValue);
        } catch (error) {
            return !0;
        }
    }
    function forceStoreRerender(fiber) {
        var root = enqueueConcurrentRenderForLane(fiber, 2);
        null !== root && scheduleUpdateOnFiber(root, fiber, 2);
    }
    function mountStateImpl(initialState) {
        var hook = mountWorkInProgressHook();
        if ("function" === typeof initialState) {
            var initialStateInitializer = initialState;
            initialState = initialStateInitializer();
            if (shouldDoubleInvokeUserFnsInHooksDEV) {
                setIsStrictModeForDevtools(!0);
                try {
                    initialStateInitializer();
                } finally{
                    setIsStrictModeForDevtools(!1);
                }
            }
        }
        hook.memoizedState = hook.baseState = initialState;
        hook.queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: basicStateReducer,
            lastRenderedState: initialState
        };
        return hook;
    }
    function updateOptimisticImpl(hook, current, passthrough, reducer) {
        hook.baseState = passthrough;
        return updateReducerImpl(hook, currentHook, "function" === typeof reducer ? reducer : basicStateReducer);
    }
    function dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
        if (isRenderPhaseUpdate(fiber)) throw Error(formatProdErrorMessage(485));
        fiber = actionQueue.action;
        if (null !== fiber) {
            var actionNode = {
                payload: payload,
                action: fiber,
                next: null,
                isTransition: !0,
                status: "pending",
                value: null,
                reason: null,
                listeners: [],
                then: function(listener) {
                    actionNode.listeners.push(listener);
                }
            };
            null !== ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
            setState(actionNode);
            setPendingState = actionQueue.pending;
            null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
        }
    }
    function runActionStateAction(actionQueue, node) {
        var action = node.action, payload = node.payload, prevState = actionQueue.state;
        if (node.isTransition) {
            var prevTransition = ReactSharedInternals.T, currentTransition = {};
            ReactSharedInternals.T = currentTransition;
            try {
                var returnValue = action(prevState, payload), onStartTransitionFinish = ReactSharedInternals.S;
                null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
                handleActionReturnValue(actionQueue, node, returnValue);
            } catch (error) {
                onActionError(actionQueue, node, error);
            } finally{
                null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), ReactSharedInternals.T = prevTransition;
            }
        } else try {
            prevTransition = action(prevState, payload), handleActionReturnValue(actionQueue, node, prevTransition);
        } catch (error$55) {
            onActionError(actionQueue, node, error$55);
        }
    }
    function handleActionReturnValue(actionQueue, node, returnValue) {
        null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
            onActionSuccess(actionQueue, node, nextState);
        }, function(error) {
            return onActionError(actionQueue, node, error);
        }) : onActionSuccess(actionQueue, node, returnValue);
    }
    function onActionSuccess(actionQueue, actionNode, nextState) {
        actionNode.status = "fulfilled";
        actionNode.value = nextState;
        notifyActionListeners(actionNode);
        actionQueue.state = nextState;
        actionNode = actionQueue.pending;
        null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, runActionStateAction(actionQueue, nextState)));
    }
    function onActionError(actionQueue, actionNode, error) {
        var last = actionQueue.pending;
        actionQueue.pending = null;
        if (null !== last) {
            last = last.next;
            do actionNode.status = "rejected", actionNode.reason = error, notifyActionListeners(actionNode), actionNode = actionNode.next;
            while (actionNode !== last);
        }
        actionQueue.action = null;
    }
    function notifyActionListeners(actionNode) {
        actionNode = actionNode.listeners;
        for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
    }
    function actionStateReducer(oldState, newState) {
        return newState;
    }
    function mountActionState(action, initialStateProp) {
        if (isHydrating) {
            var ssrFormState = workInProgressRoot.formState;
            if (null !== ssrFormState) {
                a: {
                    var JSCompiler_inline_result = currentlyRenderingFiber;
                    if (isHydrating) {
                        if (nextHydratableInstance) {
                            var markerInstance = canHydrateFormStateMarker(nextHydratableInstance, rootOrSingletonContext);
                            if (markerInstance) {
                                nextHydratableInstance = getNextHydratableSibling(markerInstance);
                                JSCompiler_inline_result = isFormStateMarkerMatching(markerInstance);
                                break a;
                            }
                        }
                        throwOnHydrationMismatch(JSCompiler_inline_result);
                    }
                    JSCompiler_inline_result = !1;
                }
                JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
            }
        }
        ssrFormState = mountWorkInProgressHook();
        ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
        JSCompiler_inline_result = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: actionStateReducer,
            lastRenderedState: initialStateProp
        };
        ssrFormState.queue = JSCompiler_inline_result;
        ssrFormState = dispatchSetState.bind(null, currentlyRenderingFiber, JSCompiler_inline_result);
        JSCompiler_inline_result.dispatch = ssrFormState;
        JSCompiler_inline_result = mountStateImpl(!1);
        var setPendingState = dispatchOptimisticSetState.bind(null, currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
        JSCompiler_inline_result = mountWorkInProgressHook();
        markerInstance = {
            state: initialStateProp,
            dispatch: null,
            action: action,
            pending: null
        };
        JSCompiler_inline_result.queue = markerInstance;
        ssrFormState = dispatchActionState.bind(null, currentlyRenderingFiber, markerInstance, setPendingState, ssrFormState);
        markerInstance.dispatch = ssrFormState;
        JSCompiler_inline_result.memoizedState = action;
        return [
            initialStateProp,
            ssrFormState,
            !1
        ];
    }
    function updateActionState(action) {
        var stateHook = updateWorkInProgressHook();
        return updateActionStateImpl(stateHook, currentHook, action);
    }
    function updateActionStateImpl(stateHook, currentStateHook, action) {
        currentStateHook = updateReducerImpl(stateHook, currentStateHook, actionStateReducer)[0];
        stateHook = updateReducer(basicStateReducer)[0];
        if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
            var state = useThenable(currentStateHook);
        } catch (x) {
            if (x === SuspenseException) throw SuspenseActionException;
            throw x;
        }
        else state = currentStateHook;
        currentStateHook = updateWorkInProgressHook();
        var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
        action !== currentStateHook.memoizedState && (currentlyRenderingFiber.flags |= 2048, pushSimpleEffect(9, {
            destroy: void 0
        }, actionStateActionEffect.bind(null, actionQueue, action), null));
        return [
            state,
            dispatch,
            stateHook
        ];
    }
    function actionStateActionEffect(actionQueue, action) {
        actionQueue.action = action;
    }
    function rerenderActionState(action) {
        var stateHook = updateWorkInProgressHook(), currentStateHook = currentHook;
        if (null !== currentStateHook) return updateActionStateImpl(stateHook, currentStateHook, action);
        updateWorkInProgressHook();
        stateHook = stateHook.memoizedState;
        currentStateHook = updateWorkInProgressHook();
        var dispatch = currentStateHook.queue.dispatch;
        currentStateHook.memoizedState = action;
        return [
            stateHook,
            dispatch,
            !1
        ];
    }
    function pushSimpleEffect(tag, inst, create, deps) {
        tag = {
            tag: tag,
            create: create,
            deps: deps,
            inst: inst,
            next: null
        };
        inst = currentlyRenderingFiber.updateQueue;
        null === inst && (inst = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = inst);
        create = inst.lastEffect;
        null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
        return tag;
    }
    function updateRef() {
        return updateWorkInProgressHook().memoizedState;
    }
    function mountEffectImpl(fiberFlags, hookFlags, create, deps) {
        var hook = mountWorkInProgressHook();
        currentlyRenderingFiber.flags |= fiberFlags;
        hook.memoizedState = pushSimpleEffect(1 | hookFlags, {
            destroy: void 0
        }, create, void 0 === deps ? null : deps);
    }
    function updateEffectImpl(fiberFlags, hookFlags, create, deps) {
        var hook = updateWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var inst = hook.memoizedState.inst;
        null !== currentHook && null !== deps && areHookInputsEqual(deps, currentHook.memoizedState.deps) ? hook.memoizedState = pushSimpleEffect(hookFlags, inst, create, deps) : (currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = pushSimpleEffect(1 | hookFlags, inst, create, deps));
    }
    function mountEffect(create, deps) {
        mountEffectImpl(8390656, 8, create, deps);
    }
    function updateEffect(create, deps) {
        updateEffectImpl(2048, 8, create, deps);
    }
    function useEffectEventImpl(payload) {
        currentlyRenderingFiber.flags |= 4;
        var componentUpdateQueue = currentlyRenderingFiber.updateQueue;
        if (null === componentUpdateQueue) componentUpdateQueue = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
            payload
        ];
        else {
            var events = componentUpdateQueue.events;
            null === events ? componentUpdateQueue.events = [
                payload
            ] : events.push(payload);
        }
    }
    function updateEvent(callback) {
        var ref = updateWorkInProgressHook().memoizedState;
        useEffectEventImpl({
            ref: ref,
            nextImpl: callback
        });
        return function() {
            if (0 !== (executionContext & 2)) throw Error(formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
    function updateInsertionEffect(create, deps) {
        return updateEffectImpl(4, 2, create, deps);
    }
    function updateLayoutEffect(create, deps) {
        return updateEffectImpl(4, 4, create, deps);
    }
    function imperativeHandleEffect(create, ref) {
        if ("function" === typeof ref) {
            create = create();
            var refCleanup = ref(create);
            return function() {
                "function" === typeof refCleanup ? refCleanup() : ref(null);
            };
        }
        if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
            ref.current = null;
        };
    }
    function updateImperativeHandle(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        updateEffectImpl(4, 4, imperativeHandleEffect.bind(null, create, ref), deps);
    }
    function mountDebugValue() {}
    function updateCallback(callback, deps) {
        var hook = updateWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var prevState = hook.memoizedState;
        if (null !== deps && areHookInputsEqual(deps, prevState[1])) return prevState[0];
        hook.memoizedState = [
            callback,
            deps
        ];
        return callback;
    }
    function updateMemo(nextCreate, deps) {
        var hook = updateWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var prevState = hook.memoizedState;
        if (null !== deps && areHookInputsEqual(deps, prevState[1])) return prevState[0];
        prevState = nextCreate();
        if (shouldDoubleInvokeUserFnsInHooksDEV) {
            setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            prevState,
            deps
        ];
        return prevState;
    }
    function mountDeferredValueImpl(hook, value, initialValue) {
        if (void 0 === initialValue || 0 !== (renderLanes & 1073741824) && 0 === (workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
        hook.memoizedState = initialValue;
        hook = requestDeferredLane();
        currentlyRenderingFiber.lanes |= hook;
        workInProgressRootSkippedLanes |= hook;
        return initialValue;
    }
    function updateDeferredValueImpl(hook, prevValue, value, initialValue) {
        if (objectIs(value, prevValue)) return value;
        if (null !== currentTreeHiddenStackCursor.current) return hook = mountDeferredValueImpl(hook, value, initialValue), objectIs(hook, prevValue) || (didReceiveUpdate = !0), hook;
        if (0 === (renderLanes & 42) || 0 !== (renderLanes & 1073741824) && 0 === (workInProgressRootRenderLanes & 261930)) return didReceiveUpdate = !0, hook.memoizedState = value;
        hook = requestDeferredLane();
        currentlyRenderingFiber.lanes |= hook;
        workInProgressRootSkippedLanes |= hook;
        return prevValue;
    }
    function startTransition(fiber, queue, pendingState, finishedState, callback) {
        var previousPriority = getCurrentUpdatePriority();
        setCurrentUpdatePriority(0 !== previousPriority && 8 > previousPriority ? previousPriority : 8);
        var prevTransition = ReactSharedInternals.T, currentTransition = {};
        ReactSharedInternals.T = currentTransition;
        dispatchOptimisticSetState(fiber, !1, queue, pendingState);
        try {
            var returnValue = callback(), onStartTransitionFinish = ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
                var thenableForFinishedState = chainThenableValue(returnValue, finishedState);
                dispatchSetStateInternal(fiber, queue, thenableForFinishedState, requestUpdateLane(fiber));
            } else dispatchSetStateInternal(fiber, queue, finishedState, requestUpdateLane(fiber));
        } catch (error) {
            dispatchSetStateInternal(fiber, queue, {
                then: function() {},
                status: "rejected",
                reason: error
            }, requestUpdateLane());
        } finally{
            setCurrentUpdatePriority(previousPriority), null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), ReactSharedInternals.T = prevTransition;
        }
    }
    function ensureFormComponentIsStateful(formFiber) {
        var existingStateHook = formFiber.memoizedState;
        if (null !== existingStateHook) return existingStateHook;
        existingStateHook = {
            memoizedState: NotPendingTransition,
            baseState: NotPendingTransition,
            baseQueue: null,
            queue: {
                pending: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: basicStateReducer,
                lastRenderedState: NotPendingTransition
            },
            next: null
        };
        var initialResetState = {};
        existingStateHook.next = {
            memoizedState: initialResetState,
            baseState: initialResetState,
            baseQueue: null,
            queue: {
                pending: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: basicStateReducer,
                lastRenderedState: initialResetState
            },
            next: null
        };
        formFiber.memoizedState = existingStateHook;
        formFiber = formFiber.alternate;
        null !== formFiber && (formFiber.memoizedState = existingStateHook);
        return existingStateHook;
    }
    function useHostTransitionStatus() {
        return readContext(HostTransitionContext);
    }
    function updateId() {
        return updateWorkInProgressHook().memoizedState;
    }
    function updateRefresh() {
        return updateWorkInProgressHook().memoizedState;
    }
    function refreshCache(fiber) {
        for(var provider = fiber.return; null !== provider;){
            switch(provider.tag){
                case 24:
                case 3:
                    var lane = requestUpdateLane();
                    fiber = createUpdate(lane);
                    var root = enqueueUpdate(provider, fiber, lane);
                    null !== root && (scheduleUpdateOnFiber(root, provider, lane), entangleTransitions(root, provider, lane));
                    provider = {
                        cache: createCache()
                    };
                    fiber.payload = provider;
                    return;
            }
            provider = provider.return;
        }
    }
    function dispatchReducerAction(fiber, queue, action) {
        var lane = requestUpdateLane();
        action = {
            lane: lane,
            revertLane: 0,
            gesture: null,
            action: action,
            hasEagerState: !1,
            eagerState: null,
            next: null
        };
        isRenderPhaseUpdate(fiber) ? enqueueRenderPhaseUpdate(queue, action) : (action = enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && (scheduleUpdateOnFiber(action, fiber, lane), entangleTransitionUpdate(action, queue, lane)));
    }
    function dispatchSetState(fiber, queue, action) {
        var lane = requestUpdateLane();
        dispatchSetStateInternal(fiber, queue, action, lane);
    }
    function dispatchSetStateInternal(fiber, queue, action, lane) {
        var update = {
            lane: lane,
            revertLane: 0,
            gesture: null,
            action: action,
            hasEagerState: !1,
            eagerState: null,
            next: null
        };
        if (isRenderPhaseUpdate(fiber)) enqueueRenderPhaseUpdate(queue, update);
        else {
            var alternate = fiber.alternate;
            if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
                var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
                update.hasEagerState = !0;
                update.eagerState = eagerState;
                if (objectIs(eagerState, currentState)) return enqueueUpdate$1(fiber, queue, update, 0), null === workInProgressRoot && finishQueueingConcurrentUpdates(), !1;
            } catch (error) {} finally{}
            action = enqueueConcurrentHookUpdate(fiber, queue, update, lane);
            if (null !== action) return scheduleUpdateOnFiber(action, fiber, lane), entangleTransitionUpdate(action, queue, lane), !0;
        }
        return !1;
    }
    function dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
        action = {
            lane: 2,
            revertLane: requestTransitionLane(),
            gesture: null,
            action: action,
            hasEagerState: !1,
            eagerState: null,
            next: null
        };
        if (isRenderPhaseUpdate(fiber)) {
            if (throwIfDuringRender) throw Error(formatProdErrorMessage(479));
        } else throwIfDuringRender = enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
    }
    function isRenderPhaseUpdate(fiber) {
        var alternate = fiber.alternate;
        return fiber === currentlyRenderingFiber || null !== alternate && alternate === currentlyRenderingFiber;
    }
    function enqueueRenderPhaseUpdate(queue, update) {
        didScheduleRenderPhaseUpdateDuringThisPass = didScheduleRenderPhaseUpdate = !0;
        var pending = queue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        queue.pending = update;
    }
    function entangleTransitionUpdate(root, queue, lane) {
        if (0 !== (lane & 4194048)) {
            var queueLanes = queue.lanes;
            queueLanes &= root.pendingLanes;
            lane |= queueLanes;
            queue.lanes = lane;
            markRootEntangled(root, lane);
        }
    }
    function applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
        ctor = workInProgress.memoizedState;
        getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
        getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : assign({}, ctor, getDerivedStateFromProps);
        workInProgress.memoizedState = getDerivedStateFromProps;
        0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
    }
    function checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
        workInProgress = workInProgress.stateNode;
        return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState) : !0;
    }
    function callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
        workInProgress = instance.state;
        "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
        "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
        instance.state !== workInProgress && classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
    }
    function resolveClassComponentProps(Component, baseProps) {
        var newProps = baseProps;
        if ("ref" in baseProps) {
            newProps = {};
            for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
        }
        if (Component = Component.defaultProps) {
            newProps === baseProps && (newProps = assign({}, newProps));
            for(var propName$57 in Component)void 0 === newProps[propName$57] && (newProps[propName$57] = Component[propName$57]);
        }
        return newProps;
    }
    function logUncaughtError(root, errorInfo) {
        try {
            var onUncaughtError = root.onUncaughtError;
            onUncaughtError(errorInfo.value, {
                componentStack: errorInfo.stack
            });
        } catch (e) {
            setTimeout(function() {
                throw e;
            });
        }
    }
    function logCaughtError(root, boundary, errorInfo) {
        try {
            var onCaughtError = root.onCaughtError;
            onCaughtError(errorInfo.value, {
                componentStack: errorInfo.stack,
                errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
            });
        } catch (e) {
            setTimeout(function() {
                throw e;
            });
        }
    }
    function createRootErrorUpdate(root, errorInfo, lane) {
        lane = createUpdate(lane);
        lane.tag = 3;
        lane.payload = {
            element: null
        };
        lane.callback = function() {
            logUncaughtError(root, errorInfo);
        };
        return lane;
    }
    function createClassErrorUpdate(lane) {
        lane = createUpdate(lane);
        lane.tag = 3;
        return lane;
    }
    function initializeClassErrorUpdate(update, root, fiber, errorInfo) {
        var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
        if ("function" === typeof getDerivedStateFromError) {
            var error = errorInfo.value;
            update.payload = function() {
                return getDerivedStateFromError(error);
            };
            update.callback = function() {
                logCaughtError(root, fiber, errorInfo);
            };
        }
        var inst = fiber.stateNode;
        null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
            logCaughtError(root, fiber, errorInfo);
            "function" !== typeof getDerivedStateFromError && (null === legacyErrorBoundariesThatAlreadyFailed ? legacyErrorBoundariesThatAlreadyFailed = new Set([
                this
            ]) : legacyErrorBoundariesThatAlreadyFailed.add(this));
            var stack = errorInfo.stack;
            this.componentDidCatch(errorInfo.value, {
                componentStack: null !== stack ? stack : ""
            });
        });
    }
    function throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
        sourceFiber.flags |= 32768;
        if (null !== value && "object" === typeof value && "function" === typeof value.then) {
            returnFiber = sourceFiber.alternate;
            null !== returnFiber && propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
            sourceFiber = suspenseHandlerStackCursor.current;
            if (null !== sourceFiber) {
                switch(sourceFiber.tag){
                    case 31:
                    case 13:
                        return null === shellBoundary ? renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === workInProgressRootExitStatus && (workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                            value
                        ]) : returnFiber.add(value), attachPingListener(root, value, rootRenderLanes)), !1;
                    case 22:
                        return sourceFiber.flags |= 65536, value === noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                            transitions: null,
                            markerInstances: null,
                            retryQueue: new Set([
                                value
                            ])
                        }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                            value
                        ]) : sourceFiber.add(value)), attachPingListener(root, value, rootRenderLanes)), !1;
                }
                throw Error(formatProdErrorMessage(435, sourceFiber.tag));
            }
            attachPingListener(root, value, rootRenderLanes);
            renderDidSuspendDelayIfPossible();
            return !1;
        }
        if (isHydrating) return returnFiber = suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== HydrationMismatchException && (root = Error(formatProdErrorMessage(422), {
            cause: value
        }), queueHydrationError(createCapturedValueAtFiber(root, sourceFiber)))) : (value !== HydrationMismatchException && (returnFiber = Error(formatProdErrorMessage(423), {
            cause: value
        }), queueHydrationError(createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = createRootErrorUpdate(root.stateNode, value, rootRenderLanes), enqueueCapturedUpdate(root, rootRenderLanes), 4 !== workInProgressRootExitStatus && (workInProgressRootExitStatus = 2)), !1;
        var wrapperError = Error(formatProdErrorMessage(520), {
            cause: value
        });
        wrapperError = createCapturedValueAtFiber(wrapperError, sourceFiber);
        null === workInProgressRootConcurrentErrors ? workInProgressRootConcurrentErrors = [
            wrapperError
        ] : workInProgressRootConcurrentErrors.push(wrapperError);
        4 !== workInProgressRootExitStatus && (workInProgressRootExitStatus = 2);
        if (null === returnFiber) return !0;
        value = createCapturedValueAtFiber(value, sourceFiber);
        sourceFiber = returnFiber;
        do {
            switch(sourceFiber.tag){
                case 3:
                    return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = createRootErrorUpdate(sourceFiber.stateNode, value, root), enqueueCapturedUpdate(sourceFiber, root), !1;
                case 1:
                    if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === legacyErrorBoundariesThatAlreadyFailed || !legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = createClassErrorUpdate(rootRenderLanes), initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
            }
            sourceFiber = sourceFiber.return;
        }while (null !== sourceFiber);
        return !1;
    }
    function reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
        workInProgress.child = null === current ? mountChildFibers(workInProgress, null, nextChildren, renderLanes) : reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
    }
    function updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
        Component = Component.render;
        var ref = workInProgress.ref;
        if ("ref" in nextProps) {
            var propsWithoutRef = {};
            for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
        } else propsWithoutRef = nextProps;
        prepareToReadContext(workInProgress);
        nextProps = renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
        key = checkDidRenderIdHook();
        if (null !== current && !didReceiveUpdate) return bailoutHooks(current, workInProgress, renderLanes), bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        isHydrating && key && pushMaterializedTreeId(workInProgress);
        workInProgress.flags |= 1;
        reconcileChildren(current, workInProgress, nextProps, renderLanes);
        return workInProgress.child;
    }
    function updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (null === current) {
            var type = Component.type;
            if ("function" === typeof type && !shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
            current = createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
            current.ref = workInProgress.ref;
            current.return = workInProgress;
            return workInProgress.child = current;
        }
        type = current.child;
        if (!checkScheduledUpdateOrContext(current, renderLanes)) {
            var prevProps = type.memoizedProps;
            Component = Component.compare;
            Component = null !== Component ? Component : shallowEqual;
            if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        workInProgress.flags |= 1;
        current = createWorkInProgress(type, nextProps);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    function updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (null !== current) {
            var prevProps = current.memoizedProps;
            if (shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
                if (didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && (didReceiveUpdate = !0);
                else return workInProgress.lanes = current.lanes, bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
            }
        }
        return updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
    }
    function updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
        var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
        null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
            _visibility: 1,
            _pendingMarkers: null,
            _retryCache: null,
            _transitions: null
        });
        if ("hidden" === nextProps.mode) {
            if (0 !== (workInProgress.flags & 128)) {
                prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
                if (null !== current) {
                    nextProps = workInProgress.child = current.child;
                    for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                    nextProps = nextChildren & ~prevState;
                } else nextProps = 0, workInProgress.child = null;
                return deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
            }
            if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
                baseLanes: 0,
                cachePool: null
            }, null !== current && pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? pushHiddenContext(workInProgress, prevState) : reuseHiddenContextOnStack(), pushOffscreenSuspenseHandler(workInProgress);
            else return nextProps = workInProgress.lanes = 536870912, deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
        } else null !== prevState ? (pushTransition(workInProgress, prevState.cachePool), pushHiddenContext(workInProgress, prevState), reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && pushTransition(workInProgress, null), reuseHiddenContextOnStack(), reuseSuspenseHandlerOnStack(workInProgress));
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function bailoutOffscreenComponent(current, workInProgress) {
        null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
            _visibility: 1,
            _pendingMarkers: null,
            _retryCache: null,
            _transitions: null
        });
        return workInProgress.sibling;
    }
    function deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
        var JSCompiler_inline_result = peekCacheFromPool();
        JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
            parent: isPrimaryRenderer ? CacheContext._currentValue : CacheContext._currentValue2,
            pool: JSCompiler_inline_result
        };
        workInProgress.memoizedState = {
            baseLanes: nextBaseLanes,
            cachePool: JSCompiler_inline_result
        };
        null !== current && pushTransition(workInProgress, null);
        reuseHiddenContextOnStack();
        pushOffscreenSuspenseHandler(workInProgress);
        null !== current && propagateParentContextChanges(current, workInProgress, renderLanes, !0);
        workInProgress.childLanes = remainingChildLanes;
        return null;
    }
    function mountActivityChildren(workInProgress, nextProps) {
        nextProps = mountWorkInProgressOffscreenFiber({
            mode: nextProps.mode,
            children: nextProps.children
        }, workInProgress.mode);
        nextProps.ref = workInProgress.ref;
        workInProgress.child = nextProps;
        nextProps.return = workInProgress;
        return nextProps;
    }
    function retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
        reconcileChildFibers(workInProgress, current.child, null, renderLanes);
        current = mountActivityChildren(workInProgress, workInProgress.pendingProps);
        current.flags |= 2;
        popSuspenseHandler(workInProgress);
        workInProgress.memoizedState = null;
        return current;
    }
    function updateActivityComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
        workInProgress.flags &= -129;
        if (null === current) {
            if (isHydrating) {
                if ("hidden" === nextProps.mode) return current = mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, bailoutOffscreenComponent(null, current);
                pushDehydratedActivitySuspenseHandler(workInProgress);
                (current = nextHydratableInstance) ? (current = canHydrateActivityInstance(current, rootOrSingletonContext), null !== current && (workInProgress.memoizedState = {
                    dehydrated: current,
                    treeContext: null !== treeContextProvider ? {
                        id: treeContextId,
                        overflow: treeContextOverflow
                    } : null,
                    retryLane: 536870912,
                    hydrationErrors: null
                }, renderLanes = createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, hydrationParentFiber = workInProgress, nextHydratableInstance = null)) : current = null;
                if (null === current) throw throwOnHydrationMismatch(workInProgress);
                workInProgress.lanes = 536870912;
                return null;
            }
            return mountActivityChildren(workInProgress, nextProps);
        }
        var prevState = current.memoizedState;
        if (null !== prevState) {
            var dehydrated = prevState.dehydrated;
            pushDehydratedActivitySuspenseHandler(workInProgress);
            if (didSuspend) {
                if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
                else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
                else throw Error(formatProdErrorMessage(558));
            } else if (didReceiveUpdate || propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), didReceiveUpdate || didSuspend) {
                nextProps = workInProgressRoot;
                if (null !== nextProps && (dehydrated = getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, enqueueConcurrentRenderForLane(current, dehydrated), scheduleUpdateOnFiber(nextProps, current, dehydrated), SelectiveHydrationException;
                renderDidSuspendDelayIfPossible();
                workInProgress = retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            } else current = prevState.treeContext, supportsHydration && (nextHydratableInstance = getFirstHydratableChildWithinActivityInstance(dehydrated), hydrationParentFiber = workInProgress, isHydrating = !0, hydrationErrors = null, rootOrSingletonContext = !1, null !== current && restoreSuspendedTreeContext(workInProgress, current)), workInProgress = mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
            return workInProgress;
        }
        current = createWorkInProgress(current.child, {
            mode: nextProps.mode,
            children: nextProps.children
        });
        current.ref = workInProgress.ref;
        workInProgress.child = current;
        current.return = workInProgress;
        return current;
    }
    function markRef(current, workInProgress) {
        var ref = workInProgress.ref;
        if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
        else {
            if ("function" !== typeof ref && "object" !== typeof ref) throw Error(formatProdErrorMessage(284));
            if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
        }
    }
    function updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
        prepareToReadContext(workInProgress);
        Component = renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
        nextProps = checkDidRenderIdHook();
        if (null !== current && !didReceiveUpdate) return bailoutHooks(current, workInProgress, renderLanes), bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        isHydrating && nextProps && pushMaterializedTreeId(workInProgress);
        workInProgress.flags |= 1;
        reconcileChildren(current, workInProgress, Component, renderLanes);
        return workInProgress.child;
    }
    function replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
        prepareToReadContext(workInProgress);
        workInProgress.updateQueue = null;
        nextProps = renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
        finishRenderingHooks(current);
        Component = checkDidRenderIdHook();
        if (null !== current && !didReceiveUpdate) return bailoutHooks(current, workInProgress, renderLanes), bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        isHydrating && Component && pushMaterializedTreeId(workInProgress);
        workInProgress.flags |= 1;
        reconcileChildren(current, workInProgress, nextProps, renderLanes);
        return workInProgress.child;
    }
    function updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
        prepareToReadContext(workInProgress);
        if (null === workInProgress.stateNode) {
            var context = emptyContextObject, contextType = Component.contextType;
            "object" === typeof contextType && null !== contextType && (context = readContext(contextType));
            context = new Component(nextProps, context);
            workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
            context.updater = classComponentUpdater;
            workInProgress.stateNode = context;
            context._reactInternals = workInProgress;
            context = workInProgress.stateNode;
            context.props = nextProps;
            context.state = workInProgress.memoizedState;
            context.refs = {};
            initializeUpdateQueue(workInProgress);
            contextType = Component.contextType;
            context.context = "object" === typeof contextType && null !== contextType ? readContext(contextType) : emptyContextObject;
            context.state = workInProgress.memoizedState;
            contextType = Component.getDerivedStateFromProps;
            "function" === typeof contextType && (applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
            "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && classComponentUpdater.enqueueReplaceState(context, context.state, null), processUpdateQueue(workInProgress, nextProps, context, renderLanes), suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
            "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
            nextProps = !0;
        } else if (null === current) {
            context = workInProgress.stateNode;
            var unresolvedOldProps = workInProgress.memoizedProps, oldProps = resolveClassComponentProps(Component, unresolvedOldProps);
            context.props = oldProps;
            var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
            contextType = emptyContextObject;
            "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = readContext(contextType$jscomp$0));
            var getDerivedStateFromProps = Component.getDerivedStateFromProps;
            contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
            unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
            contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
            hasForceUpdate = !1;
            var oldState = workInProgress.memoizedState;
            context.state = oldState;
            processUpdateQueue(workInProgress, nextProps, context, renderLanes);
            suspendIfUpdateReadFromEntangledAsyncAction();
            oldContext = workInProgress.memoizedState;
            unresolvedOldProps || oldState !== oldContext || hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && (applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = hasForceUpdate || checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
        } else {
            context = workInProgress.stateNode;
            cloneUpdateQueue(current, workInProgress);
            contextType = workInProgress.memoizedProps;
            contextType$jscomp$0 = resolveClassComponentProps(Component, contextType);
            context.props = contextType$jscomp$0;
            getDerivedStateFromProps = workInProgress.pendingProps;
            oldState = context.context;
            oldContext = Component.contextType;
            oldProps = emptyContextObject;
            "object" === typeof oldContext && null !== oldContext && (oldProps = readContext(oldContext));
            unresolvedOldProps = Component.getDerivedStateFromProps;
            (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
            hasForceUpdate = !1;
            oldState = workInProgress.memoizedState;
            context.state = oldState;
            processUpdateQueue(workInProgress, nextProps, context, renderLanes);
            suspendIfUpdateReadFromEntangledAsyncAction();
            var newState = workInProgress.memoizedState;
            contextType !== getDerivedStateFromProps || oldState !== newState || hasForceUpdate || null !== current && null !== current.dependencies && checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && (applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = hasForceUpdate || checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
        }
        context = nextProps;
        markRef(current, workInProgress);
        nextProps = 0 !== (workInProgress.flags & 128);
        context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = reconcileChildFibers(workInProgress, null, Component, renderLanes)) : reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        return current;
    }
    function mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
        resetHydrationState();
        workInProgress.flags |= 256;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function mountSuspenseOffscreenState(renderLanes) {
        return {
            baseLanes: renderLanes,
            cachePool: getSuspendedCache()
        };
    }
    function getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
        current = null !== current ? current.childLanes & ~renderLanes : 0;
        primaryTreeDidDefer && (current |= workInProgressDeferredLane);
        return current;
    }
    function updateSuspenseComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
        (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== (suspenseStackCursor.current & 2));
        JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
        JSCompiler_temp = 0 !== (workInProgress.flags & 32);
        workInProgress.flags &= -33;
        if (null === current) {
            if (isHydrating) {
                showFallback ? pushPrimaryTreeSuspenseHandler(workInProgress) : reuseSuspenseHandlerOnStack(workInProgress);
                (current = nextHydratableInstance) ? (current = canHydrateSuspenseInstance(current, rootOrSingletonContext), null !== current && (workInProgress.memoizedState = {
                    dehydrated: current,
                    treeContext: null !== treeContextProvider ? {
                        id: treeContextId,
                        overflow: treeContextOverflow
                    } : null,
                    retryLane: 536870912,
                    hydrationErrors: null
                }, renderLanes = createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, hydrationParentFiber = workInProgress, nextHydratableInstance = null)) : current = null;
                if (null === current) throw throwOnHydrationMismatch(workInProgress);
                isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
                return null;
            }
            var nextPrimaryChildren = nextProps.children;
            nextProps = nextProps.fallback;
            if (showFallback) return reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = mountWorkInProgressOffscreenFiber({
                mode: "hidden",
                children: nextPrimaryChildren
            }, showFallback), nextProps = createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = SUSPENDED_MARKER, bailoutOffscreenComponent(null, nextProps);
            pushPrimaryTreeSuspenseHandler(workInProgress);
            return mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
        }
        var prevState = current.memoizedState;
        if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
            if (didSuspend) workInProgress.flags & 256 ? (pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? (reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : (reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = mountWorkInProgressOffscreenFiber({
                mode: "visible",
                children: nextProps.children
            }, showFallback), nextPrimaryChildren = createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = SUSPENDED_MARKER, workInProgress = bailoutOffscreenComponent(null, nextProps));
            else if (pushPrimaryTreeSuspenseHandler(workInProgress), isSuspenseInstanceFallback(nextPrimaryChildren)) JSCompiler_temp = getSuspenseInstanceFallbackErrorDetails(nextPrimaryChildren).digest, nextProps = Error(formatProdErrorMessage(419)), nextProps.stack = "", nextProps.digest = JSCompiler_temp, queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            }), workInProgress = retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (didReceiveUpdate || propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), didReceiveUpdate || JSCompiler_temp) {
                JSCompiler_temp = workInProgressRoot;
                if (null !== JSCompiler_temp && (nextProps = getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, enqueueConcurrentRenderForLane(current, nextProps), scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), SelectiveHydrationException;
                isSuspenseInstancePending(nextPrimaryChildren) || renderDidSuspendDelayIfPossible();
                workInProgress = retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
            } else isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, supportsHydration && (nextHydratableInstance = getFirstHydratableChildWithinSuspenseInstance(nextPrimaryChildren), hydrationParentFiber = workInProgress, isHydrating = !0, hydrationErrors = null, rootOrSingletonContext = !1, null !== current && restoreSuspendedTreeContext(workInProgress, current)), workInProgress = mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
            return workInProgress;
        }
        if (showFallback) return reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, didSuspend = prevState.sibling, nextProps = createWorkInProgress(prevState, {
            mode: "hidden",
            children: nextProps.children
        }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== didSuspend ? nextPrimaryChildren = createWorkInProgress(didSuspend, nextPrimaryChildren) : (nextPrimaryChildren = createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = isPrimaryRenderer ? CacheContext._currentValue : CacheContext._currentValue2, showFallback = showFallback.parent !== prevState ? {
            parent: prevState,
            pool: prevState
        } : showFallback) : showFallback = getSuspendedCache(), nextPrimaryChildren = {
            baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
            cachePool: showFallback
        }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = SUSPENDED_MARKER, bailoutOffscreenComponent(current.child, nextProps);
        pushPrimaryTreeSuspenseHandler(workInProgress);
        renderLanes = current.child;
        current = renderLanes.sibling;
        renderLanes = createWorkInProgress(renderLanes, {
            mode: "visible",
            children: nextProps.children
        });
        renderLanes.return = workInProgress;
        renderLanes.sibling = null;
        null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
            current
        ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
        workInProgress.child = renderLanes;
        workInProgress.memoizedState = null;
        return renderLanes;
    }
    function mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
        primaryChildren = mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: primaryChildren
        }, workInProgress.mode);
        primaryChildren.return = workInProgress;
        return workInProgress.child = primaryChildren;
    }
    function mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
        offscreenProps = createFiber(22, offscreenProps, null, mode);
        offscreenProps.lanes = 0;
        return offscreenProps;
    }
    function retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
        reconcileChildFibers(workInProgress, current.child, null, renderLanes);
        current = mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
        current.flags |= 2;
        workInProgress.memoizedState = null;
        return current;
    }
    function scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
        fiber.lanes |= renderLanes;
        var alternate = fiber.alternate;
        null !== alternate && (alternate.lanes |= renderLanes);
        scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
    }
    function initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
        var renderState = workInProgress.memoizedState;
        null === renderState ? workInProgress.memoizedState = {
            isBackwards: isBackwards,
            rendering: null,
            renderingStartTime: 0,
            last: lastContentRow,
            tail: tail,
            tailMode: tailMode,
            treeForkCount: treeForkCount
        } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
    }
    function updateSuspenseListComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
        nextProps = nextProps.children;
        var suspenseContext = suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
        shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
        push(suspenseStackCursor, suspenseContext);
        reconcileChildren(current, workInProgress, nextProps, renderLanes);
        nextProps = isHydrating ? treeForkCount : 0;
        if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
            if (13 === current.tag) null !== current.memoizedState && scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (19 === current.tag) scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (null !== current.child) {
                current.child.return = current;
                current = current.child;
                continue;
            }
            if (current === workInProgress) break a;
            for(; null === current.sibling;){
                if (null === current.return || current.return === workInProgress) break a;
                current = current.return;
            }
            current.sibling.return = current.return;
            current = current.sibling;
        }
        switch(revealOrder){
            case "forwards":
                renderLanes = workInProgress.child;
                for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
                renderLanes = revealOrder;
                null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
                initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
                break;
            case "backwards":
            case "unstable_legacy-backwards":
                renderLanes = null;
                revealOrder = workInProgress.child;
                for(workInProgress.child = null; null !== revealOrder;){
                    current = revealOrder.alternate;
                    if (null !== current && null === findFirstSuspended(current)) {
                        workInProgress.child = revealOrder;
                        break;
                    }
                    current = revealOrder.sibling;
                    revealOrder.sibling = renderLanes;
                    renderLanes = revealOrder;
                    revealOrder = current;
                }
                initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
                break;
            case "together":
                initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
                break;
            default:
                workInProgress.memoizedState = null;
        }
        return workInProgress.child;
    }
    function bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
        null !== current && (workInProgress.dependencies = current.dependencies);
        workInProgressRootSkippedLanes |= workInProgress.lanes;
        if (0 === (renderLanes & workInProgress.childLanes)) {
            if (null !== current) {
                if (propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
            } else return null;
        }
        if (null !== current && workInProgress.child !== current.child) throw Error(formatProdErrorMessage(153));
        if (null !== workInProgress.child) {
            current = workInProgress.child;
            renderLanes = createWorkInProgress(current, current.pendingProps);
            workInProgress.child = renderLanes;
            for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
            renderLanes.sibling = null;
        }
        return workInProgress.child;
    }
    function checkScheduledUpdateOrContext(current, renderLanes) {
        if (0 !== (current.lanes & renderLanes)) return !0;
        current = current.dependencies;
        return null !== current && checkIfContextChanged(current) ? !0 : !1;
    }
    function attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
        switch(workInProgress.tag){
            case 3:
                pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                pushProvider(workInProgress, CacheContext, current.memoizedState.cache);
                resetHydrationState();
                break;
            case 27:
            case 5:
                pushHostContext(workInProgress);
                break;
            case 4:
                pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                break;
            case 10:
                pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
                break;
            case 31:
                if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, pushDehydratedActivitySuspenseHandler(workInProgress), null;
                break;
            case 13:
                var state$82 = workInProgress.memoizedState;
                if (null !== state$82) {
                    if (null !== state$82.dehydrated) return pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                    if (0 !== (renderLanes & workInProgress.child.childLanes)) return updateSuspenseComponent(current, workInProgress, renderLanes);
                    pushPrimaryTreeSuspenseHandler(workInProgress);
                    current = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                    return null !== current ? current.sibling : null;
                }
                pushPrimaryTreeSuspenseHandler(workInProgress);
                break;
            case 19:
                var didSuspendBefore = 0 !== (current.flags & 128);
                state$82 = 0 !== (renderLanes & workInProgress.childLanes);
                state$82 || (propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$82 = 0 !== (renderLanes & workInProgress.childLanes));
                if (didSuspendBefore) {
                    if (state$82) return updateSuspenseListComponent(current, workInProgress, renderLanes);
                    workInProgress.flags |= 128;
                }
                didSuspendBefore = workInProgress.memoizedState;
                null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
                push(suspenseStackCursor, suspenseStackCursor.current);
                if (state$82) break;
                else return null;
            case 22:
                return workInProgress.lanes = 0, updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
            case 24:
                pushProvider(workInProgress, CacheContext, current.memoizedState.cache);
        }
        return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    function beginWork(current, workInProgress, renderLanes) {
        if (null !== current) {
            if (current.memoizedProps !== workInProgress.pendingProps) didReceiveUpdate = !0;
            else {
                if (!checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return didReceiveUpdate = !1, attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
                didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
            }
        } else didReceiveUpdate = !1, isHydrating && 0 !== (workInProgress.flags & 1048576) && pushTreeId(workInProgress, treeForkCount, workInProgress.index);
        workInProgress.lanes = 0;
        switch(workInProgress.tag){
            case 16:
                a: {
                    var props = workInProgress.pendingProps;
                    current = resolveLazy(workInProgress.elementType);
                    workInProgress.type = current;
                    if ("function" === typeof current) shouldConstruct(current) ? (props = resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                    else {
                        if (void 0 !== current && null !== current) {
                            var $$typeof = current.$$typeof;
                            if ($$typeof === REACT_FORWARD_REF_TYPE) {
                                workInProgress.tag = 11;
                                workInProgress = updateForwardRef(null, workInProgress, current, props, renderLanes);
                                break a;
                            } else if ($$typeof === REACT_MEMO_TYPE) {
                                workInProgress.tag = 14;
                                workInProgress = updateMemoComponent(null, workInProgress, current, props, renderLanes);
                                break a;
                            }
                        }
                        workInProgress = getComponentNameFromType(current) || current;
                        throw Error(formatProdErrorMessage(306, workInProgress, ""));
                    }
                }
                return workInProgress;
            case 0:
                return updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
            case 1:
                return props = workInProgress.type, $$typeof = resolveClassComponentProps(props, workInProgress.pendingProps), updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
            case 3:
                a: {
                    pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                    if (null === current) throw Error(formatProdErrorMessage(387));
                    var nextProps = workInProgress.pendingProps;
                    $$typeof = workInProgress.memoizedState;
                    props = $$typeof.element;
                    cloneUpdateQueue(current, workInProgress);
                    processUpdateQueue(workInProgress, nextProps, null, renderLanes);
                    var nextState = workInProgress.memoizedState;
                    nextProps = nextState.cache;
                    pushProvider(workInProgress, CacheContext, nextProps);
                    nextProps !== $$typeof.cache && propagateContextChanges(workInProgress, [
                        CacheContext
                    ], renderLanes, !0);
                    suspendIfUpdateReadFromEntangledAsyncAction();
                    nextProps = nextState.element;
                    if (supportsHydration && $$typeof.isDehydrated) {
                        if ($$typeof = {
                            element: nextProps,
                            isDehydrated: !1,
                            cache: nextState.cache
                        }, workInProgress.updateQueue.baseState = $$typeof, workInProgress.memoizedState = $$typeof, workInProgress.flags & 256) {
                            workInProgress = mountHostRootWithoutHydrating(current, workInProgress, nextProps, renderLanes);
                            break a;
                        } else if (nextProps !== props) {
                            props = createCapturedValueAtFiber(Error(formatProdErrorMessage(424)), workInProgress);
                            queueHydrationError(props);
                            workInProgress = mountHostRootWithoutHydrating(current, workInProgress, nextProps, renderLanes);
                            break a;
                        } else for(supportsHydration && (nextHydratableInstance = getFirstHydratableChildWithinContainer(workInProgress.stateNode.containerInfo), hydrationParentFiber = workInProgress, isHydrating = !0, hydrationErrors = null, rootOrSingletonContext = !0), renderLanes = mountChildFibers(workInProgress, null, nextProps, renderLanes), workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    } else {
                        resetHydrationState();
                        if (nextProps === props) {
                            workInProgress = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                            break a;
                        }
                        reconcileChildren(current, workInProgress, nextProps, renderLanes);
                    }
                    workInProgress = workInProgress.child;
                }
                return workInProgress;
            case 26:
                if (supportsResources) return markRef(current, workInProgress), null === current ? (renderLanes = getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : isHydrating || (workInProgress.stateNode = createHoistableInstance(workInProgress.type, workInProgress.pendingProps, rootInstanceStackCursor.current, workInProgress)) : workInProgress.memoizedState = getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
            case 27:
                if (supportsSingletons) return pushHostContext(workInProgress), null === current && supportsSingletons && isHydrating && (props = workInProgress.stateNode = resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, rootInstanceStackCursor.current, contextStackCursor.current, !1), hydrationParentFiber = workInProgress, rootOrSingletonContext = !0, nextHydratableInstance = getFirstHydratableChildWithinSingleton(workInProgress.type, props, nextHydratableInstance)), reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
            case 5:
                if (null === current && isHydrating) {
                    validateHydratableInstance(workInProgress.type, workInProgress.pendingProps, contextStackCursor.current);
                    if ($$typeof = props = nextHydratableInstance) props = canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, hydrationParentFiber = workInProgress, nextHydratableInstance = getFirstHydratableChild(props), rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                    $$typeof || throwOnHydrationMismatch(workInProgress);
                }
                pushHostContext(workInProgress);
                $$typeof = workInProgress.type;
                nextProps = workInProgress.pendingProps;
                nextState = null !== current ? current.memoizedProps : null;
                props = nextProps.children;
                shouldSetTextContent($$typeof, nextProps) ? props = null : null !== nextState && shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
                null !== workInProgress.memoizedState && ($$typeof = renderWithHooks(current, workInProgress, TransitionAwareHostComponent, null, null, renderLanes), isPrimaryRenderer ? HostTransitionContext._currentValue = $$typeof : HostTransitionContext._currentValue2 = $$typeof);
                markRef(current, workInProgress);
                reconcileChildren(current, workInProgress, props, renderLanes);
                return workInProgress.child;
            case 6:
                if (null === current && isHydrating) {
                    validateHydratableTextInstance(workInProgress.pendingProps, contextStackCursor.current);
                    if (current = renderLanes = nextHydratableInstance) renderLanes = canHydrateTextInstance(renderLanes, workInProgress.pendingProps, rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, hydrationParentFiber = workInProgress, nextHydratableInstance = null, current = !0) : current = !1;
                    current || throwOnHydrationMismatch(workInProgress);
                }
                return null;
            case 13:
                return updateSuspenseComponent(current, workInProgress, renderLanes);
            case 4:
                return pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = reconcileChildFibers(workInProgress, null, props, renderLanes) : reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
            case 11:
                return updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
            case 7:
                return reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
            case 8:
                return reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
            case 12:
                return reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
            case 10:
                return props = workInProgress.pendingProps, pushProvider(workInProgress, workInProgress.type, props.value), reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
            case 9:
                return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, prepareToReadContext(workInProgress), $$typeof = readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
            case 14:
                return updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
            case 15:
                return updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
            case 19:
                return updateSuspenseListComponent(current, workInProgress, renderLanes);
            case 31:
                return updateActivityComponent(current, workInProgress, renderLanes);
            case 22:
                return updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
            case 24:
                return prepareToReadContext(workInProgress), props = readContext(CacheContext), null === current ? ($$typeof = peekCacheFromPool(), null === $$typeof && ($$typeof = workInProgressRoot, nextProps = createCache(), $$typeof.pooledCache = nextProps, nextProps.refCount++, null !== nextProps && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = nextProps), workInProgress.memoizedState = {
                    parent: props,
                    cache: $$typeof
                }, initializeUpdateQueue(workInProgress), pushProvider(workInProgress, CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && (cloneUpdateQueue(current, workInProgress), processUpdateQueue(workInProgress, null, null, renderLanes), suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, nextProps = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                    parent: props,
                    cache: props
                }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), pushProvider(workInProgress, CacheContext, props)) : (props = nextProps.cache, pushProvider(workInProgress, CacheContext, props), props !== $$typeof.cache && propagateContextChanges(workInProgress, [
                    CacheContext
                ], renderLanes, !0))), reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
            case 29:
                throw workInProgress.pendingProps;
        }
        throw Error(formatProdErrorMessage(156, workInProgress.tag));
    }
    function markUpdate(workInProgress) {
        workInProgress.flags |= 4;
    }
    function markCloned(workInProgress) {
        supportsPersistence && (workInProgress.flags |= 8);
    }
    function doesRequireClone(current, completedWork) {
        if (null !== current && current.child === completedWork.child) return !1;
        if (0 !== (completedWork.flags & 16)) return !0;
        for(current = completedWork.child; null !== current;){
            if (0 !== (current.flags & 8218) || 0 !== (current.subtreeFlags & 8218)) return !0;
            current = current.sibling;
        }
        return !1;
    }
    function appendAllChildren(parent, workInProgress, needsVisibilityToggle, isHidden) {
        if (supportsMutation) for(needsVisibilityToggle = workInProgress.child; null !== needsVisibilityToggle;){
            if (5 === needsVisibilityToggle.tag || 6 === needsVisibilityToggle.tag) appendInitialChild(parent, needsVisibilityToggle.stateNode);
            else if (!(4 === needsVisibilityToggle.tag || supportsSingletons && 27 === needsVisibilityToggle.tag) && null !== needsVisibilityToggle.child) {
                needsVisibilityToggle.child.return = needsVisibilityToggle;
                needsVisibilityToggle = needsVisibilityToggle.child;
                continue;
            }
            if (needsVisibilityToggle === workInProgress) break;
            for(; null === needsVisibilityToggle.sibling;){
                if (null === needsVisibilityToggle.return || needsVisibilityToggle.return === workInProgress) return;
                needsVisibilityToggle = needsVisibilityToggle.return;
            }
            needsVisibilityToggle.sibling.return = needsVisibilityToggle.return;
            needsVisibilityToggle = needsVisibilityToggle.sibling;
        }
        else if (supportsPersistence) for(var node$85 = workInProgress.child; null !== node$85;){
            if (5 === node$85.tag) {
                var instance = node$85.stateNode;
                needsVisibilityToggle && isHidden && (instance = cloneHiddenInstance(instance, node$85.type, node$85.memoizedProps));
                appendInitialChild(parent, instance);
            } else if (6 === node$85.tag) instance = node$85.stateNode, needsVisibilityToggle && isHidden && (instance = cloneHiddenTextInstance(instance, node$85.memoizedProps)), appendInitialChild(parent, instance);
            else if (4 !== node$85.tag) {
                if (22 === node$85.tag && null !== node$85.memoizedState) instance = node$85.child, null !== instance && (instance.return = node$85), appendAllChildren(parent, node$85, !0, !0);
                else if (null !== node$85.child) {
                    node$85.child.return = node$85;
                    node$85 = node$85.child;
                    continue;
                }
            }
            if (node$85 === workInProgress) break;
            for(; null === node$85.sibling;){
                if (null === node$85.return || node$85.return === workInProgress) return;
                node$85 = node$85.return;
            }
            node$85.sibling.return = node$85.return;
            node$85 = node$85.sibling;
        }
    }
    function appendAllChildrenToContainer(containerChildSet, workInProgress, needsVisibilityToggle, isHidden) {
        var hasOffscreenComponentChild = !1;
        if (supportsPersistence) for(var node = workInProgress.child; null !== node;){
            if (5 === node.tag) {
                var instance = node.stateNode;
                needsVisibilityToggle && isHidden && (instance = cloneHiddenInstance(instance, node.type, node.memoizedProps));
                appendChildToContainerChildSet(containerChildSet, instance);
            } else if (6 === node.tag) instance = node.stateNode, needsVisibilityToggle && isHidden && (instance = cloneHiddenTextInstance(instance, node.memoizedProps)), appendChildToContainerChildSet(containerChildSet, instance);
            else if (4 !== node.tag) {
                if (22 === node.tag && null !== node.memoizedState) hasOffscreenComponentChild = node.child, null !== hasOffscreenComponentChild && (hasOffscreenComponentChild.return = node), appendAllChildrenToContainer(containerChildSet, node, !0, !0), hasOffscreenComponentChild = !0;
                else if (null !== node.child) {
                    node.child.return = node;
                    node = node.child;
                    continue;
                }
            }
            if (node === workInProgress) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === workInProgress) return hasOffscreenComponentChild;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
        return hasOffscreenComponentChild;
    }
    function updateHostContainer(current, workInProgress) {
        if (supportsPersistence && doesRequireClone(current, workInProgress)) {
            current = workInProgress.stateNode;
            var container = current.containerInfo, newChildSet = createContainerChildSet();
            appendAllChildrenToContainer(newChildSet, workInProgress, !1, !1);
            current.pendingChildren = newChildSet;
            markUpdate(workInProgress);
            finalizeContainerChildren(container, newChildSet);
        }
    }
    function updateHostComponent(current, workInProgress, type, newProps) {
        if (supportsMutation) current.memoizedProps !== newProps && markUpdate(workInProgress);
        else if (supportsPersistence) {
            var currentInstance = current.stateNode, oldProps$88 = current.memoizedProps;
            if ((current = doesRequireClone(current, workInProgress)) || oldProps$88 !== newProps) {
                var currentHostContext = contextStackCursor.current;
                oldProps$88 = cloneInstance(currentInstance, type, oldProps$88, newProps, !current, null);
                oldProps$88 === currentInstance ? workInProgress.stateNode = currentInstance : (markCloned(workInProgress), finalizeInitialChildren(oldProps$88, type, newProps, currentHostContext) && markUpdate(workInProgress), workInProgress.stateNode = oldProps$88, current && appendAllChildren(oldProps$88, workInProgress, !1, !1));
            } else workInProgress.stateNode = currentInstance;
        }
    }
    function preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
        if (0 !== (workInProgress.mode & 32) && (null === oldProps ? maySuspendCommit(type, newProps) : maySuspendCommitOnUpdate(type, oldProps, newProps))) {
            if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes || maySuspendCommitInSyncRender(type, newProps)) {
                if (preloadInstance(workInProgress.stateNode, type, newProps)) workInProgress.flags |= 8192;
                else if (shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
                else throw suspendedThenable = noopSuspenseyCommitThenable, SuspenseyCommitException;
            }
        } else workInProgress.flags &= -16777217;
    }
    function preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
        if (mayResourceSuspendCommit(resource)) {
            if (workInProgress.flags |= 16777216, !preloadResource(resource)) {
                if (shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
                else throw suspendedThenable = noopSuspenseyCommitThenable, SuspenseyCommitException;
            }
        } else workInProgress.flags &= -16777217;
    }
    function scheduleRetryEffect(workInProgress, retryQueue) {
        null !== retryQueue && (workInProgress.flags |= 4);
        workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, workInProgressSuspendedRetryLanes |= retryQueue);
    }
    function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
        if (!isHydrating) switch(renderState.tailMode){
            case "hidden":
                hasRenderedATailFallback = renderState.tail;
                for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
                null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
                break;
            case "collapsed":
                lastTailNode = renderState.tail;
                for(var lastTailNode$90 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$90 = lastTailNode), lastTailNode = lastTailNode.sibling;
                null === lastTailNode$90 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$90.sibling = null;
        }
    }
    function bubbleProperties(completedWork) {
        var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
        if (didBailout) for(var child$91 = completedWork.child; null !== child$91;)newChildLanes |= child$91.lanes | child$91.childLanes, subtreeFlags |= child$91.subtreeFlags & 65011712, subtreeFlags |= child$91.flags & 65011712, child$91.return = completedWork, child$91 = child$91.sibling;
        else for(child$91 = completedWork.child; null !== child$91;)newChildLanes |= child$91.lanes | child$91.childLanes, subtreeFlags |= child$91.subtreeFlags, subtreeFlags |= child$91.flags, child$91.return = completedWork, child$91 = child$91.sibling;
        completedWork.subtreeFlags |= subtreeFlags;
        completedWork.childLanes = newChildLanes;
        return didBailout;
    }
    function completeWork(current, workInProgress, renderLanes) {
        var newProps = workInProgress.pendingProps;
        popTreeContext(workInProgress);
        switch(workInProgress.tag){
            case 16:
            case 15:
            case 0:
            case 11:
            case 7:
            case 8:
            case 12:
            case 9:
            case 14:
                return bubbleProperties(workInProgress), null;
            case 1:
                return bubbleProperties(workInProgress), null;
            case 3:
                renderLanes = workInProgress.stateNode;
                newProps = null;
                null !== current && (newProps = current.memoizedState.cache);
                workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
                popProvider(CacheContext);
                popHostContainer();
                renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
                if (null === current || null === current.child) popHydrationState(workInProgress) ? markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, upgradeHydrationErrorsToRecoverable());
                updateHostContainer(current, workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case 26:
                if (supportsResources) {
                    var type = workInProgress.type, nextResource = workInProgress.memoizedState;
                    null === current ? (markUpdate(workInProgress), null !== nextResource ? (bubbleProperties(workInProgress), preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : (bubbleProperties(workInProgress), preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? (markUpdate(workInProgress), bubbleProperties(workInProgress), preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : (bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (nextResource = current.memoizedProps, supportsMutation ? nextResource !== newProps && markUpdate(workInProgress) : updateHostComponent(current, workInProgress, type, newProps), bubbleProperties(workInProgress), preloadInstanceAndSuspendIfNeeded(workInProgress, type, nextResource, newProps, renderLanes));
                    return null;
                }
            case 27:
                if (supportsSingletons) {
                    popHostContext(workInProgress);
                    renderLanes = rootInstanceStackCursor.current;
                    type = workInProgress.type;
                    if (null !== current && null != workInProgress.stateNode) supportsMutation ? current.memoizedProps !== newProps && markUpdate(workInProgress) : updateHostComponent(current, workInProgress, type, newProps);
                    else {
                        if (!newProps) {
                            if (null === workInProgress.stateNode) throw Error(formatProdErrorMessage(166));
                            bubbleProperties(workInProgress);
                            return null;
                        }
                        current = contextStackCursor.current;
                        popHydrationState(workInProgress) ? prepareToHydrateHostInstance(workInProgress, current) : (current = resolveSingletonInstance(type, newProps, renderLanes, current, !0), workInProgress.stateNode = current, markUpdate(workInProgress));
                    }
                    bubbleProperties(workInProgress);
                    return null;
                }
            case 5:
                popHostContext(workInProgress);
                type = workInProgress.type;
                if (null !== current && null != workInProgress.stateNode) updateHostComponent(current, workInProgress, type, newProps);
                else {
                    if (!newProps) {
                        if (null === workInProgress.stateNode) throw Error(formatProdErrorMessage(166));
                        bubbleProperties(workInProgress);
                        return null;
                    }
                    nextResource = contextStackCursor.current;
                    if (popHydrationState(workInProgress)) prepareToHydrateHostInstance(workInProgress, nextResource), finalizeHydratedChildren(workInProgress.stateNode, type, newProps, nextResource) && (workInProgress.flags |= 64);
                    else {
                        var instance$101 = createInstance(type, newProps, rootInstanceStackCursor.current, nextResource, workInProgress);
                        markCloned(workInProgress);
                        appendAllChildren(instance$101, workInProgress, !1, !1);
                        workInProgress.stateNode = instance$101;
                        finalizeInitialChildren(instance$101, type, newProps, nextResource) && markUpdate(workInProgress);
                    }
                }
                bubbleProperties(workInProgress);
                preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
                return null;
            case 6:
                if (current && null != workInProgress.stateNode) renderLanes = current.memoizedProps, supportsMutation ? renderLanes !== newProps && markUpdate(workInProgress) : supportsPersistence && (renderLanes !== newProps ? (current = rootInstanceStackCursor.current, renderLanes = contextStackCursor.current, markCloned(workInProgress), workInProgress.stateNode = createTextInstance(newProps, current, renderLanes, workInProgress)) : workInProgress.stateNode = current.stateNode);
                else {
                    if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error(formatProdErrorMessage(166));
                    current = rootInstanceStackCursor.current;
                    renderLanes = contextStackCursor.current;
                    if (popHydrationState(workInProgress)) {
                        if (!supportsHydration) throw Error(formatProdErrorMessage(176));
                        current = workInProgress.stateNode;
                        renderLanes = workInProgress.memoizedProps;
                        newProps = null;
                        type = hydrationParentFiber;
                        if (null !== type) switch(type.tag){
                            case 27:
                            case 5:
                                newProps = type.memoizedProps;
                        }
                        hydrateTextInstance(current, renderLanes, workInProgress, newProps) || throwOnHydrationMismatch(workInProgress, !0);
                    } else markCloned(workInProgress), workInProgress.stateNode = createTextInstance(newProps, current, renderLanes, workInProgress);
                }
                bubbleProperties(workInProgress);
                return null;
            case 31:
                renderLanes = workInProgress.memoizedState;
                if (null === current || null !== current.memoizedState) {
                    newProps = popHydrationState(workInProgress);
                    if (null !== renderLanes) {
                        if (null === current) {
                            if (!newProps) throw Error(formatProdErrorMessage(318));
                            if (!supportsHydration) throw Error(formatProdErrorMessage(556));
                            current = workInProgress.memoizedState;
                            current = null !== current ? current.dehydrated : null;
                            if (!current) throw Error(formatProdErrorMessage(557));
                            hydrateActivityInstance(current, workInProgress);
                        } else resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                        bubbleProperties(workInProgress);
                        current = !1;
                    } else renderLanes = upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                    if (!current) {
                        if (workInProgress.flags & 256) return popSuspenseHandler(workInProgress), workInProgress;
                        popSuspenseHandler(workInProgress);
                        return null;
                    }
                    if (0 !== (workInProgress.flags & 128)) throw Error(formatProdErrorMessage(558));
                }
                bubbleProperties(workInProgress);
                return null;
            case 13:
                newProps = workInProgress.memoizedState;
                if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                    type = popHydrationState(workInProgress);
                    if (null !== newProps && null !== newProps.dehydrated) {
                        if (null === current) {
                            if (!type) throw Error(formatProdErrorMessage(318));
                            if (!supportsHydration) throw Error(formatProdErrorMessage(344));
                            type = workInProgress.memoizedState;
                            type = null !== type ? type.dehydrated : null;
                            if (!type) throw Error(formatProdErrorMessage(317));
                            hydrateSuspenseInstance(type, workInProgress);
                        } else resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                        bubbleProperties(workInProgress);
                        type = !1;
                    } else type = upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                    if (!type) {
                        if (workInProgress.flags & 256) return popSuspenseHandler(workInProgress), workInProgress;
                        popSuspenseHandler(workInProgress);
                        return null;
                    }
                }
                popSuspenseHandler(workInProgress);
                if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
                renderLanes = null !== newProps;
                current = null !== current && null !== current.memoizedState;
                renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
                renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
                scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
                bubbleProperties(workInProgress);
                return null;
            case 4:
                return popHostContainer(), updateHostContainer(current, workInProgress), null === current && preparePortalMount(workInProgress.stateNode.containerInfo), bubbleProperties(workInProgress), null;
            case 10:
                return popProvider(workInProgress.type), bubbleProperties(workInProgress), null;
            case 19:
                pop(suspenseStackCursor);
                newProps = workInProgress.memoizedState;
                if (null === newProps) return bubbleProperties(workInProgress), null;
                type = 0 !== (workInProgress.flags & 128);
                nextResource = newProps.rendering;
                if (null === nextResource) {
                    if (type) cutOffTailIfNeeded(newProps, !1);
                    else {
                        if (0 !== workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                            nextResource = findFirstSuspended(current);
                            if (null !== nextResource) {
                                workInProgress.flags |= 128;
                                cutOffTailIfNeeded(newProps, !1);
                                current = nextResource.updateQueue;
                                workInProgress.updateQueue = current;
                                scheduleRetryEffect(workInProgress, current);
                                workInProgress.subtreeFlags = 0;
                                current = renderLanes;
                                for(renderLanes = workInProgress.child; null !== renderLanes;)resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                                push(suspenseStackCursor, suspenseStackCursor.current & 1 | 2);
                                isHydrating && pushTreeFork(workInProgress, newProps.treeForkCount);
                                return workInProgress.child;
                            }
                            current = current.sibling;
                        }
                        null !== newProps.tail && now() > workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                    }
                } else {
                    if (!type) {
                        if (current = findFirstSuspended(nextResource), null !== current) {
                            if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, scheduleRetryEffect(workInProgress, current), cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !isHydrating) return bubbleProperties(workInProgress), null;
                        } else 2 * now() - newProps.renderingStartTime > workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                    }
                    newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
                }
                if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = now(), current.sibling = null, renderLanes = suspenseStackCursor.current, push(suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), isHydrating && pushTreeFork(workInProgress, newProps.treeForkCount), current;
                bubbleProperties(workInProgress);
                return null;
            case 22:
            case 23:
                return popSuspenseHandler(workInProgress), popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && (bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && pop(resumedCache), null;
            case 24:
                return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), popProvider(CacheContext), bubbleProperties(workInProgress), null;
            case 25:
                return null;
            case 30:
                return null;
        }
        throw Error(formatProdErrorMessage(156, workInProgress.tag));
    }
    function unwindWork(current, workInProgress) {
        popTreeContext(workInProgress);
        switch(workInProgress.tag){
            case 1:
                return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
            case 3:
                return popProvider(CacheContext), popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
            case 26:
            case 27:
            case 5:
                return popHostContext(workInProgress), null;
            case 31:
                if (null !== workInProgress.memoizedState) {
                    popSuspenseHandler(workInProgress);
                    if (null === workInProgress.alternate) throw Error(formatProdErrorMessage(340));
                    resetHydrationState();
                }
                current = workInProgress.flags;
                return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
            case 13:
                popSuspenseHandler(workInProgress);
                current = workInProgress.memoizedState;
                if (null !== current && null !== current.dehydrated) {
                    if (null === workInProgress.alternate) throw Error(formatProdErrorMessage(340));
                    resetHydrationState();
                }
                current = workInProgress.flags;
                return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
            case 19:
                return pop(suspenseStackCursor), null;
            case 4:
                return popHostContainer(), null;
            case 10:
                return popProvider(workInProgress.type), null;
            case 22:
            case 23:
                return popSuspenseHandler(workInProgress), popHiddenContext(), null !== current && pop(resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
            case 24:
                return popProvider(CacheContext), null;
            case 25:
                return null;
            default:
                return null;
        }
    }
    function unwindInterruptedWork(current, interruptedWork) {
        popTreeContext(interruptedWork);
        switch(interruptedWork.tag){
            case 3:
                popProvider(CacheContext);
                popHostContainer();
                break;
            case 26:
            case 27:
            case 5:
                popHostContext(interruptedWork);
                break;
            case 4:
                popHostContainer();
                break;
            case 31:
                null !== interruptedWork.memoizedState && popSuspenseHandler(interruptedWork);
                break;
            case 13:
                popSuspenseHandler(interruptedWork);
                break;
            case 19:
                pop(suspenseStackCursor);
                break;
            case 10:
                popProvider(interruptedWork.type);
                break;
            case 22:
            case 23:
                popSuspenseHandler(interruptedWork);
                popHiddenContext();
                null !== current && pop(resumedCache);
                break;
            case 24:
                popProvider(CacheContext);
        }
    }
    function commitHookEffectListMount(flags, finishedWork) {
        try {
            var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
            if (null !== lastEffect) {
                var firstEffect = lastEffect.next;
                updateQueue = firstEffect;
                do {
                    if ((updateQueue.tag & flags) === flags) {
                        lastEffect = void 0;
                        var create = updateQueue.create, inst = updateQueue.inst;
                        lastEffect = create();
                        inst.destroy = lastEffect;
                    }
                    updateQueue = updateQueue.next;
                }while (updateQueue !== firstEffect);
            }
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
    function commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
        try {
            var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
            if (null !== lastEffect) {
                var firstEffect = lastEffect.next;
                updateQueue = firstEffect;
                do {
                    if ((updateQueue.tag & flags) === flags) {
                        var inst = updateQueue.inst, destroy = inst.destroy;
                        if (void 0 !== destroy) {
                            inst.destroy = void 0;
                            lastEffect = finishedWork;
                            var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                            try {
                                destroy_();
                            } catch (error) {
                                captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                            }
                        }
                    }
                    updateQueue = updateQueue.next;
                }while (updateQueue !== firstEffect);
            }
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
    function commitClassCallbacks(finishedWork) {
        var updateQueue = finishedWork.updateQueue;
        if (null !== updateQueue) {
            var instance = finishedWork.stateNode;
            try {
                commitCallbacks(updateQueue, instance);
            } catch (error) {
                captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
        }
    }
    function safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
        instance.props = resolveClassComponentProps(current.type, current.memoizedProps);
        instance.state = current.memoizedState;
        try {
            instance.componentWillUnmount();
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    }
    function safelyAttachRef(current, nearestMountedAncestor) {
        try {
            var ref = current.ref;
            if (null !== ref) {
                switch(current.tag){
                    case 26:
                    case 27:
                    case 5:
                        var instanceToUse = getPublicInstance(current.stateNode);
                        break;
                    case 30:
                        instanceToUse = current.stateNode;
                        break;
                    default:
                        instanceToUse = current.stateNode;
                }
                "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
            }
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    }
    function safelyDetachRef(current, nearestMountedAncestor) {
        var ref = current.ref, refCleanup = current.refCleanup;
        if (null !== ref) {
            if ("function" === typeof refCleanup) try {
                refCleanup();
            } catch (error) {
                captureCommitPhaseError(current, nearestMountedAncestor, error);
            } finally{
                current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
            }
            else if ("function" === typeof ref) try {
                ref(null);
            } catch (error$124) {
                captureCommitPhaseError(current, nearestMountedAncestor, error$124);
            }
            else ref.current = null;
        }
    }
    function commitHostMount(finishedWork) {
        var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
        try {
            commitMount(instance, type, props, finishedWork);
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
    function commitHostUpdate(finishedWork, newProps, oldProps) {
        try {
            commitUpdate(finishedWork.stateNode, finishedWork.type, oldProps, newProps, finishedWork);
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
    function isHostParent(fiber) {
        return 5 === fiber.tag || 3 === fiber.tag || (supportsResources ? 26 === fiber.tag : !1) || (supportsSingletons ? 27 === fiber.tag && isSingletonScope(fiber.type) : !1) || 4 === fiber.tag;
    }
    function getHostSibling(fiber) {
        a: for(;;){
            for(; null === fiber.sibling;){
                if (null === fiber.return || isHostParent(fiber.return)) return null;
                fiber = fiber.return;
            }
            fiber.sibling.return = fiber.return;
            for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
                if (supportsSingletons && 27 === fiber.tag && isSingletonScope(fiber.type)) continue a;
                if (fiber.flags & 2) continue a;
                if (null === fiber.child || 4 === fiber.tag) continue a;
                else fiber.child.return = fiber, fiber = fiber.child;
            }
            if (!(fiber.flags & 2)) return fiber.stateNode;
        }
    }
    function insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
        var tag = node.tag;
        if (5 === tag || 6 === tag) node = node.stateNode, before ? insertInContainerBefore(parent, node, before) : appendChildToContainer(parent, node);
        else if (4 !== tag && (supportsSingletons && 27 === tag && isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for(insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
    }
    function insertOrAppendPlacementNode(node, before, parent) {
        var tag = node.tag;
        if (5 === tag || 6 === tag) node = node.stateNode, before ? insertBefore(parent, node, before) : appendChild(parent, node);
        else if (4 !== tag && (supportsSingletons && 27 === tag && isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for(insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
    }
    function commitHostPortalContainerChildren(portal, finishedWork, pendingChildren) {
        portal = portal.containerInfo;
        try {
            replaceContainerChildren(portal, pendingChildren);
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
    function commitHostSingletonAcquisition(finishedWork) {
        var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
        try {
            acquireSingletonInstance(finishedWork.type, props, singleton, finishedWork);
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
    function commitBeforeMutationEffects(root, firstChild) {
        prepareForCommit(root.containerInfo);
        for(nextEffect = firstChild; null !== nextEffect;)if (root = nextEffect, firstChild = root.child, 0 !== (root.subtreeFlags & 1028) && null !== firstChild) firstChild.return = root, nextEffect = firstChild;
        else for(; null !== nextEffect;){
            root = nextEffect;
            var current = root.alternate;
            firstChild = root.flags;
            switch(root.tag){
                case 0:
                    if (0 !== (firstChild & 4) && (firstChild = root.updateQueue, firstChild = null !== firstChild ? firstChild.events : null, null !== firstChild)) for(var ii = 0; ii < firstChild.length; ii++){
                        var _eventPayloads$ii = firstChild[ii];
                        _eventPayloads$ii.ref.impl = _eventPayloads$ii.nextImpl;
                    }
                    break;
                case 11:
                case 15:
                    break;
                case 1:
                    if (0 !== (firstChild & 1024) && null !== current) {
                        firstChild = void 0;
                        ii = root;
                        _eventPayloads$ii = current.memoizedProps;
                        current = current.memoizedState;
                        var instance = ii.stateNode;
                        try {
                            var resolvedPrevProps = resolveClassComponentProps(ii.type, _eventPayloads$ii);
                            firstChild = instance.getSnapshotBeforeUpdate(resolvedPrevProps, current);
                            instance.__reactInternalSnapshotBeforeUpdate = firstChild;
                        } catch (error) {
                            captureCommitPhaseError(ii, ii.return, error);
                        }
                    }
                    break;
                case 3:
                    0 !== (firstChild & 1024) && supportsMutation && clearContainer(root.stateNode.containerInfo);
                    break;
                case 5:
                case 26:
                case 27:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    if (0 !== (firstChild & 1024)) throw Error(formatProdErrorMessage(163));
            }
            firstChild = root.sibling;
            if (null !== firstChild) {
                firstChild.return = root.return;
                nextEffect = firstChild;
                break;
            }
            nextEffect = root.return;
        }
    }
    function commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
        var flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                flags & 4 && commitHookEffectListMount(5, finishedWork);
                break;
            case 1:
                recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                if (flags & 4) {
                    if (finishedRoot = finishedWork.stateNode, null === current) try {
                        finishedRoot.componentDidMount();
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                    else {
                        var prevProps = resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                        current = current.memoizedState;
                        try {
                            finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                        } catch (error$123) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error$123);
                        }
                    }
                }
                flags & 64 && commitClassCallbacks(finishedWork);
                flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 3:
                recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                if (flags & 64 && (flags = finishedWork.updateQueue, null !== flags)) {
                    finishedRoot = null;
                    if (null !== finishedWork.child) switch(finishedWork.child.tag){
                        case 27:
                        case 5:
                            finishedRoot = getPublicInstance(finishedWork.child.stateNode);
                            break;
                        case 1:
                            finishedRoot = finishedWork.child.stateNode;
                    }
                    try {
                        commitCallbacks(flags, finishedRoot);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                break;
            case 27:
                supportsSingletons && null === current && flags & 4 && commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                if (null === current) {
                    if (flags & 4) commitHostMount(finishedWork);
                    else if (flags & 64) {
                        finishedRoot = finishedWork.type;
                        current = finishedWork.memoizedProps;
                        prevProps = finishedWork.stateNode;
                        try {
                            commitHydratedInstance(prevProps, finishedRoot, current, finishedWork);
                        } catch (error) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error);
                        }
                    }
                }
                flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                break;
            case 31:
                recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                flags & 4 && commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                flags & 4 && commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                flags & 64 && (flags = finishedWork.memoizedState, null !== flags && (flags = flags.dehydrated, null !== flags && (finishedWork = retryDehydratedSuspenseBoundary.bind(null, finishedWork), registerSuspenseInstanceRetry(flags, finishedWork))));
                break;
            case 22:
                flags = null !== finishedWork.memoizedState || offscreenSubtreeIsHidden;
                if (!flags) {
                    current = null !== current && null !== current.memoizedState || offscreenSubtreeWasHidden;
                    prevProps = offscreenSubtreeIsHidden;
                    var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
                    offscreenSubtreeIsHidden = flags;
                    (offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                    offscreenSubtreeIsHidden = prevProps;
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
                }
                break;
            case 30:
                break;
            default:
                recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
        }
    }
    function detachFiberAfterEffects(fiber) {
        var alternate = fiber.alternate;
        null !== alternate && (fiber.alternate = null, detachFiberAfterEffects(alternate));
        fiber.child = null;
        fiber.deletions = null;
        fiber.sibling = null;
        5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && detachDeletedInstance(alternate));
        fiber.stateNode = null;
        fiber.return = null;
        fiber.dependencies = null;
        fiber.memoizedProps = null;
        fiber.memoizedState = null;
        fiber.pendingProps = null;
        fiber.stateNode = null;
        fiber.updateQueue = null;
    }
    function recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
        for(parent = parent.child; null !== parent;)commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
    }
    function commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
        if (injectedHook && "function" === typeof injectedHook.onCommitFiberUnmount) try {
            injectedHook.onCommitFiberUnmount(rendererID, deletedFiber);
        } catch (err) {}
        switch(deletedFiber.tag){
            case 26:
                if (supportsResources) {
                    offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
                    recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                    deletedFiber.memoizedState ? releaseResource(deletedFiber.memoizedState) : deletedFiber.stateNode && unmountHoistable(deletedFiber.stateNode);
                    break;
                }
            case 27:
                if (supportsSingletons) {
                    offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
                    var prevHostParent = hostParent, prevHostParentIsContainer = hostParentIsContainer;
                    isSingletonScope(deletedFiber.type) && (hostParent = deletedFiber.stateNode, hostParentIsContainer = !1);
                    recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                    releaseSingletonInstance(deletedFiber.stateNode);
                    hostParent = prevHostParent;
                    hostParentIsContainer = prevHostParentIsContainer;
                    break;
                }
            case 5:
                offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
            case 6:
                if (supportsMutation) {
                    if (prevHostParent = hostParent, prevHostParentIsContainer = hostParentIsContainer, hostParent = null, recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber), hostParent = prevHostParent, hostParentIsContainer = prevHostParentIsContainer, null !== hostParent) {
                        if (hostParentIsContainer) try {
                            removeChildFromContainer(hostParent, deletedFiber.stateNode);
                        } catch (error) {
                            captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                        }
                        else try {
                            removeChild(hostParent, deletedFiber.stateNode);
                        } catch (error) {
                            captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                        }
                    }
                } else recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                break;
            case 18:
                supportsMutation && null !== hostParent && (hostParentIsContainer ? clearSuspenseBoundaryFromContainer(hostParent, deletedFiber.stateNode) : clearSuspenseBoundary(hostParent, deletedFiber.stateNode));
                break;
            case 4:
                supportsMutation ? (prevHostParent = hostParent, prevHostParentIsContainer = hostParentIsContainer, hostParent = deletedFiber.stateNode.containerInfo, hostParentIsContainer = !0, recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber), hostParent = prevHostParent, hostParentIsContainer = prevHostParentIsContainer) : (supportsPersistence && commitHostPortalContainerChildren(deletedFiber.stateNode, deletedFiber, createContainerChildSet()), recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber));
                break;
            case 0:
            case 11:
            case 14:
            case 15:
                commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
                offscreenSubtreeWasHidden || commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                break;
            case 1:
                offscreenSubtreeWasHidden || (safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                break;
            case 21:
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                break;
            case 22:
                offscreenSubtreeWasHidden = (prevHostParent = offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                offscreenSubtreeWasHidden = prevHostParent;
                break;
            default:
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
        }
    }
    function commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
        if (supportsHydration && null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
            finishedRoot = finishedRoot.dehydrated;
            try {
                commitHydratedActivityInstance(finishedRoot);
            } catch (error) {
                captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
        }
    }
    function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
        if (supportsHydration && null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
            commitHydratedSuspenseInstance(finishedRoot);
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
    function getRetryCache(finishedWork) {
        switch(finishedWork.tag){
            case 31:
            case 13:
            case 19:
                var retryCache = finishedWork.stateNode;
                null === retryCache && (retryCache = finishedWork.stateNode = new PossiblyWeakSet());
                return retryCache;
            case 22:
                return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new PossiblyWeakSet()), retryCache;
            default:
                throw Error(formatProdErrorMessage(435, finishedWork.tag));
        }
    }
    function attachSuspenseRetryListeners(finishedWork, wakeables) {
        var retryCache = getRetryCache(finishedWork);
        wakeables.forEach(function(wakeable) {
            if (!retryCache.has(wakeable)) {
                retryCache.add(wakeable);
                var retry = resolveRetryWakeable.bind(null, finishedWork, wakeable);
                wakeable.then(retry, retry);
            }
        });
    }
    function recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
        var deletions = parentFiber.deletions;
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber;
            if (supportsMutation) {
                var parent = returnFiber;
                a: for(; null !== parent;){
                    switch(parent.tag){
                        case 27:
                            if (supportsSingletons) {
                                if (isSingletonScope(parent.type)) {
                                    hostParent = parent.stateNode;
                                    hostParentIsContainer = !1;
                                    break a;
                                }
                                break;
                            }
                        case 5:
                            hostParent = parent.stateNode;
                            hostParentIsContainer = !1;
                            break a;
                        case 3:
                        case 4:
                            hostParent = parent.stateNode.containerInfo;
                            hostParentIsContainer = !0;
                            break a;
                    }
                    parent = parent.return;
                }
                if (null === hostParent) throw Error(formatProdErrorMessage(160));
                commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
                hostParent = null;
                hostParentIsContainer = !1;
            } else commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
            root = childToDelete.alternate;
            null !== root && (root.return = null);
            childToDelete.return = null;
        }
        if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
    }
    function commitMutationEffectsOnFiber(finishedWork, root) {
        var current = finishedWork.alternate, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                flags & 4 && (commitHookEffectListUnmount(3, finishedWork, finishedWork.return), commitHookEffectListMount(3, finishedWork), commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
                break;
            case 1:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
                flags & 64 && offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
                break;
            case 26:
                if (supportsResources) {
                    var hoistableRoot = currentHoistableRoot;
                    recursivelyTraverseMutationEffects(root, finishedWork);
                    commitReconciliationEffects(finishedWork);
                    flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
                    if (flags & 4) {
                        flags = null !== current ? current.memoizedState : null;
                        var newResource = finishedWork.memoizedState;
                        null === current ? null === newResource ? null === finishedWork.stateNode ? finishedWork.stateNode = hydrateHoistable(hoistableRoot, finishedWork.type, finishedWork.memoizedProps, finishedWork) : mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : finishedWork.stateNode = acquireResource(hoistableRoot, newResource, finishedWork.memoizedProps) : flags !== newResource ? (null === flags ? null !== current.stateNode && unmountHoistable(current.stateNode) : releaseResource(flags), null === newResource ? mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : acquireResource(hoistableRoot, newResource, finishedWork.memoizedProps)) : null === newResource && null !== finishedWork.stateNode && commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
                    }
                    break;
                }
            case 27:
                if (supportsSingletons) {
                    recursivelyTraverseMutationEffects(root, finishedWork);
                    commitReconciliationEffects(finishedWork);
                    flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
                    null !== current && flags & 4 && commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
                    break;
                }
            case 5:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
                if (supportsMutation) {
                    if (finishedWork.flags & 32) {
                        hoistableRoot = finishedWork.stateNode;
                        try {
                            resetTextContent(hoistableRoot);
                        } catch (error) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error);
                        }
                    }
                    flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
                    flags & 1024 && (needsFormReset = !0);
                } else supportsPersistence && null !== finishedWork.alternate && (finishedWork.alternate.stateNode = finishedWork.stateNode);
                break;
            case 6:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & 4 && supportsMutation) {
                    if (null === finishedWork.stateNode) throw Error(formatProdErrorMessage(162));
                    flags = finishedWork.memoizedProps;
                    current = null !== current ? current.memoizedProps : flags;
                    hoistableRoot = finishedWork.stateNode;
                    try {
                        commitTextUpdate(hoistableRoot, current, flags);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                break;
            case 3:
                supportsResources ? (prepareToCommitHoistables(), hoistableRoot = currentHoistableRoot, currentHoistableRoot = getHoistableRoot(root.containerInfo), recursivelyTraverseMutationEffects(root, finishedWork), currentHoistableRoot = hoistableRoot) : recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & 4) {
                    if (supportsMutation && supportsHydration && null !== current && current.memoizedState.isDehydrated) try {
                        commitHydratedContainer(root.containerInfo);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                    if (supportsPersistence) {
                        flags = root.containerInfo;
                        current = root.pendingChildren;
                        try {
                            replaceContainerChildren(flags, current);
                        } catch (error) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error);
                        }
                    }
                }
                needsFormReset && (needsFormReset = !1, recursivelyResetForms(finishedWork));
                break;
            case 4:
                supportsResources ? (current = currentHoistableRoot, currentHoistableRoot = getHoistableRoot(finishedWork.stateNode.containerInfo), recursivelyTraverseMutationEffects(root, finishedWork), commitReconciliationEffects(finishedWork), currentHoistableRoot = current) : (recursivelyTraverseMutationEffects(root, finishedWork), commitReconciliationEffects(finishedWork));
                flags & 4 && supportsPersistence && commitHostPortalContainerChildren(finishedWork.stateNode, finishedWork, finishedWork.stateNode.pendingChildren);
                break;
            case 12:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                break;
            case 31:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, flags)));
                break;
            case 13:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && (globalMostRecentFallbackTime = now());
                flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, flags)));
                break;
            case 22:
                hoistableRoot = null !== finishedWork.memoizedState;
                var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
                offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
                offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
                recursivelyTraverseMutationEffects(root, finishedWork);
                offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
                offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
                commitReconciliationEffects(finishedWork);
                if (flags & 8192 && (root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || offscreenSubtreeIsHidden || offscreenSubtreeWasHidden || recursivelyTraverseDisappearLayoutEffects(finishedWork)), supportsMutation)) {
                    a: if (current = null, supportsMutation) for(root = finishedWork;;){
                        if (5 === root.tag || supportsResources && 26 === root.tag) {
                            if (null === current) {
                                wasHidden = current = root;
                                try {
                                    newResource = wasHidden.stateNode, hoistableRoot ? hideInstance(newResource) : unhideInstance(wasHidden.stateNode, wasHidden.memoizedProps);
                                } catch (error) {
                                    captureCommitPhaseError(wasHidden, wasHidden.return, error);
                                }
                            }
                        } else if (6 === root.tag) {
                            if (null === current) {
                                wasHidden = root;
                                try {
                                    var instance = wasHidden.stateNode;
                                    hoistableRoot ? hideTextInstance(instance) : unhideTextInstance(instance, wasHidden.memoizedProps);
                                } catch (error) {
                                    captureCommitPhaseError(wasHidden, wasHidden.return, error);
                                }
                            }
                        } else if (18 === root.tag) {
                            if (null === current) {
                                wasHidden = root;
                                try {
                                    var instance$jscomp$0 = wasHidden.stateNode;
                                    hoistableRoot ? hideDehydratedBoundary(instance$jscomp$0) : unhideDehydratedBoundary(wasHidden.stateNode);
                                } catch (error) {
                                    captureCommitPhaseError(wasHidden, wasHidden.return, error);
                                }
                            }
                        } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                            root.child.return = root;
                            root = root.child;
                            continue;
                        }
                        if (root === finishedWork) break a;
                        for(; null === root.sibling;){
                            if (null === root.return || root.return === finishedWork) break a;
                            current === root && (current = null);
                            root = root.return;
                        }
                        current === root && (current = null);
                        root.sibling.return = root.return;
                        root = root.sibling;
                    }
                }
                flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, attachSuspenseRetryListeners(finishedWork, current))));
                break;
            case 19:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, flags)));
                break;
            case 30:
                break;
            case 21:
                break;
            default:
                recursivelyTraverseMutationEffects(root, finishedWork), commitReconciliationEffects(finishedWork);
        }
    }
    function commitReconciliationEffects(finishedWork) {
        var flags = finishedWork.flags;
        if (flags & 2) {
            try {
                for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                    if (isHostParent(parentFiber)) {
                        hostParentFiber = parentFiber;
                        break;
                    }
                    parentFiber = parentFiber.return;
                }
                if (supportsMutation) {
                    if (null == hostParentFiber) throw Error(formatProdErrorMessage(160));
                    switch(hostParentFiber.tag){
                        case 27:
                            if (supportsSingletons) {
                                var parent = hostParentFiber.stateNode, before = getHostSibling(finishedWork);
                                insertOrAppendPlacementNode(finishedWork, before, parent);
                                break;
                            }
                        case 5:
                            var parent$125 = hostParentFiber.stateNode;
                            hostParentFiber.flags & 32 && (resetTextContent(parent$125), hostParentFiber.flags &= -33);
                            var before$126 = getHostSibling(finishedWork);
                            insertOrAppendPlacementNode(finishedWork, before$126, parent$125);
                            break;
                        case 3:
                        case 4:
                            var parent$127 = hostParentFiber.stateNode.containerInfo, before$128 = getHostSibling(finishedWork);
                            insertOrAppendPlacementNodeIntoContainer(finishedWork, before$128, parent$127);
                            break;
                        default:
                            throw Error(formatProdErrorMessage(161));
                    }
                }
            } catch (error) {
                captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            finishedWork.flags &= -3;
        }
        flags & 4096 && (finishedWork.flags &= -4097);
    }
    function recursivelyResetForms(parentFiber) {
        if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
            var fiber = parentFiber;
            recursivelyResetForms(fiber);
            5 === fiber.tag && fiber.flags & 1024 && resetFormInstance(fiber.stateNode);
            parentFiber = parentFiber.sibling;
        }
    }
    function recursivelyTraverseLayoutEffects(root, parentFiber) {
        if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
    }
    function recursivelyTraverseDisappearLayoutEffects(parentFiber) {
        for(parentFiber = parentFiber.child; null !== parentFiber;){
            var finishedWork = parentFiber;
            switch(finishedWork.tag){
                case 0:
                case 11:
                case 14:
                case 15:
                    commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                    recursivelyTraverseDisappearLayoutEffects(finishedWork);
                    break;
                case 1:
                    safelyDetachRef(finishedWork, finishedWork.return);
                    var instance = finishedWork.stateNode;
                    "function" === typeof instance.componentWillUnmount && safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                    recursivelyTraverseDisappearLayoutEffects(finishedWork);
                    break;
                case 27:
                    supportsSingletons && releaseSingletonInstance(finishedWork.stateNode);
                case 26:
                case 5:
                    safelyDetachRef(finishedWork, finishedWork.return);
                    recursivelyTraverseDisappearLayoutEffects(finishedWork);
                    break;
                case 22:
                    null === finishedWork.memoizedState && recursivelyTraverseDisappearLayoutEffects(finishedWork);
                    break;
                case 30:
                    recursivelyTraverseDisappearLayoutEffects(finishedWork);
                    break;
                default:
                    recursivelyTraverseDisappearLayoutEffects(finishedWork);
            }
            parentFiber = parentFiber.sibling;
        }
    }
    function recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
        includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
        for(parentFiber = parentFiber.child; null !== parentFiber;){
            var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
            switch(finishedWork.tag){
                case 0:
                case 11:
                case 15:
                    recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                    commitHookEffectListMount(4, finishedWork);
                    break;
                case 1:
                    recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                    current = finishedWork;
                    finishedRoot = current.stateNode;
                    if ("function" === typeof finishedRoot.componentDidMount) try {
                        finishedRoot.componentDidMount();
                    } catch (error) {
                        captureCommitPhaseError(current, current.return, error);
                    }
                    current = finishedWork;
                    finishedRoot = current.updateQueue;
                    if (null !== finishedRoot) {
                        var instance = current.stateNode;
                        try {
                            var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                            if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)callCallback(hiddenCallbacks[finishedRoot], instance);
                        } catch (error) {
                            captureCommitPhaseError(current, current.return, error);
                        }
                    }
                    includeWorkInProgressEffects && flags & 64 && commitClassCallbacks(finishedWork);
                    safelyAttachRef(finishedWork, finishedWork.return);
                    break;
                case 27:
                    supportsSingletons && commitHostSingletonAcquisition(finishedWork);
                case 26:
                case 5:
                    recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                    includeWorkInProgressEffects && null === current && flags & 4 && commitHostMount(finishedWork);
                    safelyAttachRef(finishedWork, finishedWork.return);
                    break;
                case 12:
                    recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                    break;
                case 31:
                    recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                    includeWorkInProgressEffects && flags & 4 && commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                    break;
                case 13:
                    recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                    includeWorkInProgressEffects && flags & 4 && commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                    break;
                case 22:
                    null === finishedWork.memoizedState && recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                    safelyAttachRef(finishedWork, finishedWork.return);
                    break;
                case 30:
                    break;
                default:
                    recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
            }
            parentFiber = parentFiber.sibling;
        }
    }
    function commitOffscreenPassiveMountEffects(current, finishedWork) {
        var previousCache = null;
        null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
        current = null;
        null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
        current !== previousCache && (null != current && current.refCount++, null != previousCache && releaseCache(previousCache));
    }
    function commitCachePassiveMountEffect(current, finishedWork) {
        current = null;
        null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
        finishedWork = finishedWork.memoizedState.cache;
        finishedWork !== current && (finishedWork.refCount++, null != current && releaseCache(current));
    }
    function recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
        if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
    }
    function commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
        var flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                flags & 2048 && commitHookEffectListMount(9, finishedWork);
                break;
            case 1:
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                break;
            case 3:
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && releaseCache(finishedRoot)));
                break;
            case 12:
                if (flags & 2048) {
                    recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                    finishedRoot = finishedWork.stateNode;
                    try {
                        var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                        "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                } else recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                break;
            case 31:
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                break;
            case 13:
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                break;
            case 23:
                break;
            case 22:
                _finishedWork$memoize2 = finishedWork.stateNode;
                id = finishedWork.alternate;
                null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
                flags & 2048 && commitOffscreenPassiveMountEffects(id, finishedWork);
                break;
            case 24:
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
        }
    }
    function recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
        includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
        for(parentFiber = parentFiber.child; null !== parentFiber;){
            var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
            switch(finishedWork.tag){
                case 0:
                case 11:
                case 15:
                    recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                    commitHookEffectListMount(8, finishedWork);
                    break;
                case 23:
                    break;
                case 22:
                    var instance = finishedWork.stateNode;
                    null !== finishedWork.memoizedState ? instance._visibility & 2 ? recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                    includeWorkInProgressEffects && flags & 2048 && commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                    break;
                case 24:
                    recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                    includeWorkInProgressEffects && flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                    break;
                default:
                    recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
            }
            parentFiber = parentFiber.sibling;
        }
    }
    function recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
        if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
            var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
            switch(finishedWork.tag){
                case 22:
                    recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                    flags & 2048 && commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                    break;
                case 24:
                    recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                    flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                    break;
                default:
                    recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
            }
            parentFiber = parentFiber.sibling;
        }
    }
    function recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
        if (parentFiber.subtreeFlags & suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
    }
    function accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
        switch(fiber.tag){
            case 26:
                recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
                if (fiber.flags & suspenseyCommitFlag) {
                    if (null !== fiber.memoizedState) suspendResource(suspendedState, currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
                    else {
                        var instance = fiber.stateNode, type = fiber.type;
                        fiber = fiber.memoizedProps;
                        ((committedLanes & 335544128) === committedLanes || maySuspendCommitInSyncRender(type, fiber)) && suspendInstance(suspendedState, instance, type, fiber);
                    }
                }
                break;
            case 5:
                recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
                fiber.flags & suspenseyCommitFlag && (instance = fiber.stateNode, type = fiber.type, fiber = fiber.memoizedProps, ((committedLanes & 335544128) === committedLanes || maySuspendCommitInSyncRender(type, fiber)) && suspendInstance(suspendedState, instance, type, fiber));
                break;
            case 3:
            case 4:
                supportsResources ? (instance = currentHoistableRoot, currentHoistableRoot = getHoistableRoot(fiber.stateNode.containerInfo), recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), currentHoistableRoot = instance) : recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
                break;
            case 22:
                null === fiber.memoizedState && (instance = fiber.alternate, null !== instance && null !== instance.memoizedState ? (instance = suspenseyCommitFlag, suspenseyCommitFlag = 16777216, recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), suspenseyCommitFlag = instance) : recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
                break;
            default:
                recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
        }
    }
    function detachAlternateSiblings(parentFiber) {
        var previousFiber = parentFiber.alternate;
        if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
            previousFiber.child = null;
            do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
            while (null !== parentFiber);
        }
    }
    function recursivelyTraversePassiveUnmountEffects(parentFiber) {
        var deletions = parentFiber.deletions;
        if (0 !== (parentFiber.flags & 16)) {
            if (null !== deletions) for(var i = 0; i < deletions.length; i++){
                var childToDelete = deletions[i];
                nextEffect = childToDelete;
                commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
            }
            detachAlternateSiblings(parentFiber);
        }
        if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
    }
    function commitPassiveUnmountOnFiber(finishedWork) {
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                recursivelyTraversePassiveUnmountEffects(finishedWork);
                finishedWork.flags & 2048 && commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
                break;
            case 3:
                recursivelyTraversePassiveUnmountEffects(finishedWork);
                break;
            case 12:
                recursivelyTraversePassiveUnmountEffects(finishedWork);
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : recursivelyTraversePassiveUnmountEffects(finishedWork);
                break;
            default:
                recursivelyTraversePassiveUnmountEffects(finishedWork);
        }
    }
    function recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
        var deletions = parentFiber.deletions;
        if (0 !== (parentFiber.flags & 16)) {
            if (null !== deletions) for(var i = 0; i < deletions.length; i++){
                var childToDelete = deletions[i];
                nextEffect = childToDelete;
                commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
            }
            detachAlternateSiblings(parentFiber);
        }
        for(parentFiber = parentFiber.child; null !== parentFiber;){
            deletions = parentFiber;
            switch(deletions.tag){
                case 0:
                case 11:
                case 15:
                    commitHookEffectListUnmount(8, deletions, deletions.return);
                    recursivelyTraverseDisconnectPassiveEffects(deletions);
                    break;
                case 22:
                    i = deletions.stateNode;
                    i._visibility & 2 && (i._visibility &= -3, recursivelyTraverseDisconnectPassiveEffects(deletions));
                    break;
                default:
                    recursivelyTraverseDisconnectPassiveEffects(deletions);
            }
            parentFiber = parentFiber.sibling;
        }
    }
    function commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
        for(; null !== nextEffect;){
            var fiber = nextEffect;
            switch(fiber.tag){
                case 0:
                case 11:
                case 15:
                    commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                    break;
                case 23:
                case 22:
                    if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                        var cache = fiber.memoizedState.cachePool.pool;
                        null != cache && cache.refCount++;
                    }
                    break;
                case 24:
                    releaseCache(fiber.memoizedState.cache);
            }
            cache = fiber.child;
            if (null !== cache) cache.return = fiber, nextEffect = cache;
            else a: for(fiber = deletedSubtreeRoot; null !== nextEffect;){
                cache = nextEffect;
                var sibling = cache.sibling, returnFiber = cache.return;
                detachFiberAfterEffects(cache);
                if (cache === fiber) {
                    nextEffect = null;
                    break a;
                }
                if (null !== sibling) {
                    sibling.return = returnFiber;
                    nextEffect = sibling;
                    break a;
                }
                nextEffect = returnFiber;
            }
        }
    }
    function findFiberRootForHostRoot(hostRoot) {
        var maybeFiber = getInstanceFromNode(hostRoot);
        if (null != maybeFiber) {
            if ("string" !== typeof maybeFiber.memoizedProps["data-testname"]) throw Error(formatProdErrorMessage(364));
            return maybeFiber;
        }
        hostRoot = findFiberRoot(hostRoot);
        if (null === hostRoot) throw Error(formatProdErrorMessage(362));
        return hostRoot.stateNode.current;
    }
    function matchSelector(fiber$jscomp$0, selector) {
        var tag = fiber$jscomp$0.tag;
        switch(selector.$$typeof){
            case COMPONENT_TYPE:
                if (fiber$jscomp$0.type === selector.value) return !0;
                break;
            case HAS_PSEUDO_CLASS_TYPE:
                a: {
                    selector = selector.value;
                    fiber$jscomp$0 = [
                        fiber$jscomp$0,
                        0
                    ];
                    for(tag = 0; tag < fiber$jscomp$0.length;){
                        var fiber = fiber$jscomp$0[tag++], tag$jscomp$0 = fiber.tag, selectorIndex = fiber$jscomp$0[tag++], selector$jscomp$0 = selector[selectorIndex];
                        if (5 !== tag$jscomp$0 && 26 !== tag$jscomp$0 && 27 !== tag$jscomp$0 || !isHiddenSubtree(fiber)) {
                            for(; null != selector$jscomp$0 && matchSelector(fiber, selector$jscomp$0);)selectorIndex++, selector$jscomp$0 = selector[selectorIndex];
                            if (selectorIndex === selector.length) {
                                selector = !0;
                                break a;
                            } else for(fiber = fiber.child; null !== fiber;)fiber$jscomp$0.push(fiber, selectorIndex), fiber = fiber.sibling;
                        }
                    }
                    selector = !1;
                }
                return selector;
            case ROLE_TYPE:
                if ((5 === tag || 26 === tag || 27 === tag) && matchAccessibilityRole(fiber$jscomp$0.stateNode, selector.value)) return !0;
                break;
            case TEXT_TYPE:
                if (5 === tag || 6 === tag || 26 === tag || 27 === tag) {
                    if (fiber$jscomp$0 = getTextContent(fiber$jscomp$0), null !== fiber$jscomp$0 && 0 <= fiber$jscomp$0.indexOf(selector.value)) return !0;
                }
                break;
            case TEST_NAME_TYPE:
                if (5 === tag || 26 === tag || 27 === tag) {
                    if (fiber$jscomp$0 = fiber$jscomp$0.memoizedProps["data-testname"], "string" === typeof fiber$jscomp$0 && fiber$jscomp$0.toLowerCase() === selector.value.toLowerCase()) return !0;
                }
                break;
            default:
                throw Error(formatProdErrorMessage(365));
        }
        return !1;
    }
    function selectorToString(selector) {
        switch(selector.$$typeof){
            case COMPONENT_TYPE:
                return "<" + (getComponentNameFromType(selector.value) || "Unknown") + ">";
            case HAS_PSEUDO_CLASS_TYPE:
                return ":has(" + (selectorToString(selector) || "") + ")";
            case ROLE_TYPE:
                return '[role="' + selector.value + '"]';
            case TEXT_TYPE:
                return '"' + selector.value + '"';
            case TEST_NAME_TYPE:
                return '[data-testname="' + selector.value + '"]';
            default:
                throw Error(formatProdErrorMessage(365));
        }
    }
    function findPaths(root, selectors) {
        var matchingFibers = [];
        root = [
            root,
            0
        ];
        for(var index = 0; index < root.length;){
            var fiber = root[index++], tag = fiber.tag, selectorIndex = root[index++], selector = selectors[selectorIndex];
            if (5 !== tag && 26 !== tag && 27 !== tag || !isHiddenSubtree(fiber)) {
                for(; null != selector && matchSelector(fiber, selector);)selectorIndex++, selector = selectors[selectorIndex];
                if (selectorIndex === selectors.length) matchingFibers.push(fiber);
                else for(fiber = fiber.child; null !== fiber;)root.push(fiber, selectorIndex), fiber = fiber.sibling;
            }
        }
        return matchingFibers;
    }
    function findAllNodes(hostRoot, selectors) {
        if (!supportsTestSelectors) throw Error(formatProdErrorMessage(363));
        hostRoot = findFiberRootForHostRoot(hostRoot);
        hostRoot = findPaths(hostRoot, selectors);
        selectors = [];
        hostRoot = Array.from(hostRoot);
        for(var index = 0; index < hostRoot.length;){
            var node = hostRoot[index++], tag = node.tag;
            if (5 === tag || 26 === tag || 27 === tag) isHiddenSubtree(node) || selectors.push(node.stateNode);
            else for(node = node.child; null !== node;)hostRoot.push(node), node = node.sibling;
        }
        return selectors;
    }
    function requestUpdateLane() {
        return 0 !== (executionContext & 2) && 0 !== workInProgressRootRenderLanes ? workInProgressRootRenderLanes & -workInProgressRootRenderLanes : null !== ReactSharedInternals.T ? requestTransitionLane() : resolveUpdatePriority();
    }
    function requestDeferredLane() {
        if (0 === workInProgressDeferredLane) {
            if (0 === (workInProgressRootRenderLanes & 536870912) || isHydrating) {
                var lane = nextTransitionDeferredLane;
                nextTransitionDeferredLane <<= 1;
                0 === (nextTransitionDeferredLane & 3932160) && (nextTransitionDeferredLane = 262144);
                workInProgressDeferredLane = lane;
            } else workInProgressDeferredLane = 536870912;
        }
        lane = suspenseHandlerStackCursor.current;
        null !== lane && (lane.flags |= 32);
        return workInProgressDeferredLane;
    }
    function scheduleUpdateOnFiber(root, fiber, lane) {
        if (root === workInProgressRoot && (2 === workInProgressSuspendedReason || 9 === workInProgressSuspendedReason) || null !== root.cancelPendingCommit) prepareFreshStack(root, 0), markRootSuspended(root, workInProgressRootRenderLanes, workInProgressDeferredLane, !1);
        markRootUpdated$1(root, lane);
        if (0 === (executionContext & 2) || root !== workInProgressRoot) root === workInProgressRoot && (0 === (executionContext & 2) && (workInProgressRootInterleavedUpdatedLanes |= lane), 4 === workInProgressRootExitStatus && markRootSuspended(root, workInProgressRootRenderLanes, workInProgressDeferredLane, !1)), ensureRootIsScheduled(root);
    }
    function performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
        if (0 !== (executionContext & 6)) throw Error(formatProdErrorMessage(327));
        var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? renderRootConcurrent(root$jscomp$0, lanes) : renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
        do {
            if (0 === exitStatus) {
                workInProgressRootIsPrerendering && !shouldTimeSlice && markRootSuspended(root$jscomp$0, lanes, 0, !1);
                break;
            } else {
                forceSync = root$jscomp$0.current.alternate;
                if (renderWasConcurrent && !isRenderConsistentWithExternalStores(forceSync)) {
                    exitStatus = renderRootSync(root$jscomp$0, lanes, !1);
                    renderWasConcurrent = !1;
                    continue;
                }
                if (2 === exitStatus) {
                    renderWasConcurrent = lanes;
                    if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                    else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                    if (0 !== JSCompiler_inline_result) {
                        lanes = JSCompiler_inline_result;
                        a: {
                            var root = root$jscomp$0;
                            exitStatus = workInProgressRootConcurrentErrors;
                            var wasRootDehydrated = supportsHydration && root.current.memoizedState.isDehydrated;
                            wasRootDehydrated && (prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                            JSCompiler_inline_result = renderRootSync(root, JSCompiler_inline_result, !1);
                            if (2 !== JSCompiler_inline_result) {
                                if (workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                    root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                    workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                    exitStatus = 4;
                                    break a;
                                }
                                renderWasConcurrent = workInProgressRootRecoverableErrors;
                                workInProgressRootRecoverableErrors = exitStatus;
                                null !== renderWasConcurrent && (null === workInProgressRootRecoverableErrors ? workInProgressRootRecoverableErrors = renderWasConcurrent : workInProgressRootRecoverableErrors.push.apply(workInProgressRootRecoverableErrors, renderWasConcurrent));
                            }
                            exitStatus = JSCompiler_inline_result;
                        }
                        renderWasConcurrent = !1;
                        if (2 !== exitStatus) continue;
                    }
                }
                if (1 === exitStatus) {
                    prepareFreshStack(root$jscomp$0, 0);
                    markRootSuspended(root$jscomp$0, lanes, 0, !0);
                    break;
                }
                a: {
                    shouldTimeSlice = root$jscomp$0;
                    renderWasConcurrent = exitStatus;
                    switch(renderWasConcurrent){
                        case 0:
                        case 1:
                            throw Error(formatProdErrorMessage(345));
                        case 4:
                            if ((lanes & 4194048) !== lanes) break;
                        case 6:
                            markRootSuspended(shouldTimeSlice, lanes, workInProgressDeferredLane, !workInProgressRootDidSkipSuspendedSiblings);
                            break a;
                        case 2:
                            workInProgressRootRecoverableErrors = null;
                            break;
                        case 3:
                        case 5:
                            break;
                        default:
                            throw Error(formatProdErrorMessage(329));
                    }
                    if ((lanes & 62914560) === lanes && (exitStatus = globalMostRecentFallbackTime + 300 - now(), 10 < exitStatus)) {
                        markRootSuspended(shouldTimeSlice, lanes, workInProgressDeferredLane, !workInProgressRootDidSkipSuspendedSiblings);
                        if (0 !== getNextLanes(shouldTimeSlice, 0, !0)) break a;
                        pendingEffectsLanes = lanes;
                        shouldTimeSlice.timeoutHandle = scheduleTimeout(commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, workInProgressRootRecoverableErrors, workInProgressTransitions, workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, workInProgressDeferredLane, workInProgressRootInterleavedUpdatedLanes, workInProgressSuspendedRetryLanes, workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                        break a;
                    }
                    commitRootWhenReady(shouldTimeSlice, forceSync, workInProgressRootRecoverableErrors, workInProgressTransitions, workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, workInProgressDeferredLane, workInProgressRootInterleavedUpdatedLanes, workInProgressSuspendedRetryLanes, workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
                }
            }
            break;
        }while (1);
        ensureRootIsScheduled(root$jscomp$0);
    }
    function commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
        root.timeoutHandle = noTimeout;
        suspendedCommitReason = finishedWork.subtreeFlags;
        if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
            suspendedCommitReason = startSuspendingCommit();
            accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
            var timeoutOffset = (lanes & 62914560) === lanes ? globalMostRecentFallbackTime - now() : (lanes & 4194048) === lanes ? globalMostRecentTransitionTime - now() : 0;
            timeoutOffset = waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
            if (null !== timeoutOffset) {
                pendingEffectsLanes = lanes;
                root.cancelPendingCommit = timeoutOffset(commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
                markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
                return;
            }
        }
        commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
    }
    function isRenderConsistentWithExternalStores(finishedWork) {
        for(var node = finishedWork;;){
            var tag = node.tag;
            if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
                var check = tag[i], getSnapshot = check.getSnapshot;
                check = check.value;
                try {
                    if (!objectIs(getSnapshot(), check)) return !1;
                } catch (error) {
                    return !1;
                }
            }
            tag = node.child;
            if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
            else {
                if (node === finishedWork) break;
                for(; null === node.sibling;){
                    if (null === node.return || node.return === finishedWork) return !0;
                    node = node.return;
                }
                node.sibling.return = node.return;
                node = node.sibling;
            }
        }
        return !0;
    }
    function markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
        suspendedLanes &= ~workInProgressRootPingedLanes;
        suspendedLanes &= ~workInProgressRootInterleavedUpdatedLanes;
        root.suspendedLanes |= suspendedLanes;
        root.pingedLanes &= ~suspendedLanes;
        didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
        didAttemptEntireTree = root.expirationTimes;
        for(var lanes = suspendedLanes; 0 < lanes;){
            var index$4 = 31 - clz32(lanes), lane = 1 << index$4;
            didAttemptEntireTree[index$4] = -1;
            lanes &= ~lane;
        }
        0 !== spawnedLane && markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
    }
    function flushSyncWork() {
        return 0 === (executionContext & 6) ? (flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
    }
    function resetWorkInProgressStack() {
        if (null !== workInProgress) {
            if (0 === workInProgressSuspendedReason) var interruptedWork = workInProgress.return;
            else interruptedWork = workInProgress, lastContextDependency = currentlyRenderingFiber$1 = null, resetHooksOnUnwind(interruptedWork), thenableState$1 = null, thenableIndexCounter$1 = 0, interruptedWork = workInProgress;
            for(; null !== interruptedWork;)unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
            workInProgress = null;
        }
    }
    function prepareFreshStack(root, lanes) {
        var timeoutHandle = root.timeoutHandle;
        timeoutHandle !== noTimeout && (root.timeoutHandle = noTimeout, cancelTimeout(timeoutHandle));
        timeoutHandle = root.cancelPendingCommit;
        null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
        pendingEffectsLanes = 0;
        resetWorkInProgressStack();
        workInProgressRoot = root;
        workInProgress = timeoutHandle = createWorkInProgress(root.current, null);
        workInProgressRootRenderLanes = lanes;
        workInProgressSuspendedReason = 0;
        workInProgressThrownValue = null;
        workInProgressRootDidSkipSuspendedSiblings = !1;
        workInProgressRootIsPrerendering = checkIfRootIsPrerendering(root, lanes);
        workInProgressRootDidAttachPingListener = !1;
        workInProgressSuspendedRetryLanes = workInProgressDeferredLane = workInProgressRootPingedLanes = workInProgressRootInterleavedUpdatedLanes = workInProgressRootSkippedLanes = workInProgressRootExitStatus = 0;
        workInProgressRootRecoverableErrors = workInProgressRootConcurrentErrors = null;
        workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
        0 !== (lanes & 8) && (lanes |= lanes & 32);
        var allEntangledLanes = root.entangledLanes;
        if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
            var index$2 = 31 - clz32(allEntangledLanes), lane = 1 << index$2;
            lanes |= root[index$2];
            allEntangledLanes &= ~lane;
        }
        entangledRenderLanes = lanes;
        finishQueueingConcurrentUpdates();
        return timeoutHandle;
    }
    function handleThrow(root, thrownValue) {
        currentlyRenderingFiber = null;
        ReactSharedInternals.H = ContextOnlyDispatcher;
        thrownValue === SuspenseException || thrownValue === SuspenseActionException ? (thrownValue = getSuspendedThenable(), workInProgressSuspendedReason = 3) : thrownValue === SuspenseyCommitException ? (thrownValue = getSuspendedThenable(), workInProgressSuspendedReason = 4) : workInProgressSuspendedReason = thrownValue === SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
        workInProgressThrownValue = thrownValue;
        null === workInProgress && (workInProgressRootExitStatus = 1, logUncaughtError(root, createCapturedValueAtFiber(thrownValue, root.current)));
    }
    function shouldRemainOnPreviousScreen() {
        var handler = suspenseHandlerStackCursor.current;
        return null === handler ? !0 : (workInProgressRootRenderLanes & 4194048) === workInProgressRootRenderLanes ? null === shellBoundary ? !0 : !1 : (workInProgressRootRenderLanes & 62914560) === workInProgressRootRenderLanes || 0 !== (workInProgressRootRenderLanes & 536870912) ? handler === shellBoundary : !1;
    }
    function pushDispatcher() {
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = ContextOnlyDispatcher;
        return null === prevDispatcher ? ContextOnlyDispatcher : prevDispatcher;
    }
    function pushAsyncDispatcher() {
        var prevAsyncDispatcher = ReactSharedInternals.A;
        ReactSharedInternals.A = DefaultAsyncDispatcher;
        return prevAsyncDispatcher;
    }
    function renderDidSuspendDelayIfPossible() {
        workInProgressRootExitStatus = 4;
        workInProgressRootDidSkipSuspendedSiblings || (workInProgressRootRenderLanes & 4194048) !== workInProgressRootRenderLanes && null !== suspenseHandlerStackCursor.current || (workInProgressRootIsPrerendering = !0);
        0 === (workInProgressRootSkippedLanes & 134217727) && 0 === (workInProgressRootInterleavedUpdatedLanes & 134217727) || null === workInProgressRoot || markRootSuspended(workInProgressRoot, workInProgressRootRenderLanes, workInProgressDeferredLane, !1);
    }
    function renderRootSync(root, lanes, shouldYieldForPrerendering) {
        var prevExecutionContext = executionContext;
        executionContext |= 2;
        var prevDispatcher = pushDispatcher(), prevAsyncDispatcher = pushAsyncDispatcher();
        if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) workInProgressTransitions = null, prepareFreshStack(root, lanes);
        lanes = !1;
        var exitStatus = workInProgressRootExitStatus;
        a: do try {
            if (0 !== workInProgressSuspendedReason && null !== workInProgress) {
                var unitOfWork = workInProgress, thrownValue = workInProgressThrownValue;
                switch(workInProgressSuspendedReason){
                    case 8:
                        resetWorkInProgressStack();
                        exitStatus = 6;
                        break a;
                    case 3:
                    case 2:
                    case 9:
                    case 6:
                        null === suspenseHandlerStackCursor.current && (lanes = !0);
                        var reason = workInProgressSuspendedReason;
                        workInProgressSuspendedReason = 0;
                        workInProgressThrownValue = null;
                        throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                        if (shouldYieldForPrerendering && workInProgressRootIsPrerendering) {
                            exitStatus = 0;
                            break a;
                        }
                        break;
                    default:
                        reason = workInProgressSuspendedReason, workInProgressSuspendedReason = 0, workInProgressThrownValue = null, throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                }
            }
            workLoopSync();
            exitStatus = workInProgressRootExitStatus;
            break;
        } catch (thrownValue$152) {
            handleThrow(root, thrownValue$152);
        }
        while (1);
        lanes && root.shellSuspendCounter++;
        lastContextDependency = currentlyRenderingFiber$1 = null;
        executionContext = prevExecutionContext;
        ReactSharedInternals.H = prevDispatcher;
        ReactSharedInternals.A = prevAsyncDispatcher;
        null === workInProgress && (workInProgressRoot = null, workInProgressRootRenderLanes = 0, finishQueueingConcurrentUpdates());
        return exitStatus;
    }
    function workLoopSync() {
        for(; null !== workInProgress;)performUnitOfWork(workInProgress);
    }
    function renderRootConcurrent(root, lanes) {
        var prevExecutionContext = executionContext;
        executionContext |= 2;
        var prevDispatcher = pushDispatcher(), prevAsyncDispatcher = pushAsyncDispatcher();
        workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes ? (workInProgressTransitions = null, workInProgressRootRenderTargetTime = now() + 500, prepareFreshStack(root, lanes)) : workInProgressRootIsPrerendering = checkIfRootIsPrerendering(root, lanes);
        a: do try {
            if (0 !== workInProgressSuspendedReason && null !== workInProgress) {
                lanes = workInProgress;
                var thrownValue = workInProgressThrownValue;
                b: switch(workInProgressSuspendedReason){
                    case 1:
                        workInProgressSuspendedReason = 0;
                        workInProgressThrownValue = null;
                        throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                        break;
                    case 2:
                    case 9:
                        if (isThenableResolved(thrownValue)) {
                            workInProgressSuspendedReason = 0;
                            workInProgressThrownValue = null;
                            replaySuspendedUnitOfWork(lanes);
                            break;
                        }
                        lanes = function() {
                            2 !== workInProgressSuspendedReason && 9 !== workInProgressSuspendedReason || workInProgressRoot !== root || (workInProgressSuspendedReason = 7);
                            ensureRootIsScheduled(root);
                        };
                        thrownValue.then(lanes, lanes);
                        break a;
                    case 3:
                        workInProgressSuspendedReason = 7;
                        break a;
                    case 4:
                        workInProgressSuspendedReason = 5;
                        break a;
                    case 7:
                        isThenableResolved(thrownValue) ? (workInProgressSuspendedReason = 0, workInProgressThrownValue = null, replaySuspendedUnitOfWork(lanes)) : (workInProgressSuspendedReason = 0, workInProgressThrownValue = null, throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                        break;
                    case 5:
                        var resource = null;
                        switch(workInProgress.tag){
                            case 26:
                                resource = workInProgress.memoizedState;
                            case 5:
                            case 27:
                                var hostFiber = workInProgress, type = hostFiber.type, props = hostFiber.pendingProps;
                                if (resource ? preloadResource(resource) : preloadInstance(hostFiber.stateNode, type, props)) {
                                    workInProgressSuspendedReason = 0;
                                    workInProgressThrownValue = null;
                                    var sibling = hostFiber.sibling;
                                    if (null !== sibling) workInProgress = sibling;
                                    else {
                                        var returnFiber = hostFiber.return;
                                        null !== returnFiber ? (workInProgress = returnFiber, completeUnitOfWork(returnFiber)) : workInProgress = null;
                                    }
                                    break b;
                                }
                        }
                        workInProgressSuspendedReason = 0;
                        workInProgressThrownValue = null;
                        throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                        break;
                    case 6:
                        workInProgressSuspendedReason = 0;
                        workInProgressThrownValue = null;
                        throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                        break;
                    case 8:
                        resetWorkInProgressStack();
                        workInProgressRootExitStatus = 6;
                        break a;
                    default:
                        throw Error(formatProdErrorMessage(462));
                }
            }
            workLoopConcurrentByScheduler();
            break;
        } catch (thrownValue$154) {
            handleThrow(root, thrownValue$154);
        }
        while (1);
        lastContextDependency = currentlyRenderingFiber$1 = null;
        ReactSharedInternals.H = prevDispatcher;
        ReactSharedInternals.A = prevAsyncDispatcher;
        executionContext = prevExecutionContext;
        if (null !== workInProgress) return 0;
        workInProgressRoot = null;
        workInProgressRootRenderLanes = 0;
        finishQueueingConcurrentUpdates();
        return workInProgressRootExitStatus;
    }
    function workLoopConcurrentByScheduler() {
        for(; null !== workInProgress && !shouldYield();)performUnitOfWork(workInProgress);
    }
    function performUnitOfWork(unitOfWork) {
        var next = beginWork(unitOfWork.alternate, unitOfWork, entangledRenderLanes);
        unitOfWork.memoizedProps = unitOfWork.pendingProps;
        null === next ? completeUnitOfWork(unitOfWork) : workInProgress = next;
    }
    function replaySuspendedUnitOfWork(unitOfWork) {
        var next = unitOfWork;
        var current = next.alternate;
        switch(next.tag){
            case 15:
            case 0:
                next = replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, workInProgressRootRenderLanes);
                break;
            case 11:
                next = replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, workInProgressRootRenderLanes);
                break;
            case 5:
                resetHooksOnUnwind(next);
            default:
                unwindInterruptedWork(current, next), next = workInProgress = resetWorkInProgress(next, entangledRenderLanes), next = beginWork(current, next, entangledRenderLanes);
        }
        unitOfWork.memoizedProps = unitOfWork.pendingProps;
        null === next ? completeUnitOfWork(unitOfWork) : workInProgress = next;
    }
    function throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
        lastContextDependency = currentlyRenderingFiber$1 = null;
        resetHooksOnUnwind(unitOfWork);
        thenableState$1 = null;
        thenableIndexCounter$1 = 0;
        var returnFiber = unitOfWork.return;
        try {
            if (throwException(root, returnFiber, unitOfWork, thrownValue, workInProgressRootRenderLanes)) {
                workInProgressRootExitStatus = 1;
                logUncaughtError(root, createCapturedValueAtFiber(thrownValue, root.current));
                workInProgress = null;
                return;
            }
        } catch (error) {
            if (null !== returnFiber) throw workInProgress = returnFiber, error;
            workInProgressRootExitStatus = 1;
            logUncaughtError(root, createCapturedValueAtFiber(thrownValue, root.current));
            workInProgress = null;
            return;
        }
        if (unitOfWork.flags & 32768) {
            if (isHydrating || 1 === suspendedReason) root = !0;
            else if (workInProgressRootIsPrerendering || 0 !== (workInProgressRootRenderLanes & 536870912)) root = !1;
            else if (workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
            unwindUnitOfWork(unitOfWork, root);
        } else completeUnitOfWork(unitOfWork);
    }
    function completeUnitOfWork(unitOfWork) {
        var completedWork = unitOfWork;
        do {
            if (0 !== (completedWork.flags & 32768)) {
                unwindUnitOfWork(completedWork, workInProgressRootDidSkipSuspendedSiblings);
                return;
            }
            unitOfWork = completedWork.return;
            var next = completeWork(completedWork.alternate, completedWork, entangledRenderLanes);
            if (null !== next) {
                workInProgress = next;
                return;
            }
            completedWork = completedWork.sibling;
            if (null !== completedWork) {
                workInProgress = completedWork;
                return;
            }
            workInProgress = completedWork = unitOfWork;
        }while (null !== completedWork);
        0 === workInProgressRootExitStatus && (workInProgressRootExitStatus = 5);
    }
    function unwindUnitOfWork(unitOfWork, skipSiblings) {
        do {
            var next = unwindWork(unitOfWork.alternate, unitOfWork);
            if (null !== next) {
                next.flags &= 32767;
                workInProgress = next;
                return;
            }
            next = unitOfWork.return;
            null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
            if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
                workInProgress = unitOfWork;
                return;
            }
            workInProgress = unitOfWork = next;
        }while (null !== unitOfWork);
        workInProgressRootExitStatus = 6;
        workInProgress = null;
    }
    function commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
        root.cancelPendingCommit = null;
        do flushPendingEffects();
        while (0 !== pendingEffectsStatus);
        if (0 !== (executionContext & 6)) throw Error(formatProdErrorMessage(327));
        if (null !== finishedWork) {
            if (finishedWork === root.current) throw Error(formatProdErrorMessage(177));
            didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
            didIncludeRenderPhaseUpdate |= concurrentlyUpdatedLanes;
            markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
            root === workInProgressRoot && (workInProgress = workInProgressRoot = null, workInProgressRootRenderLanes = 0);
            pendingFinishedWork = finishedWork;
            pendingEffectsRoot = root;
            pendingEffectsLanes = lanes;
            pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
            pendingPassiveTransitions = transitions;
            pendingRecoverableErrors = recoverableErrors;
            0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, scheduleCallback(NormalPriority$1, function() {
                flushPassiveEffects();
                return null;
            })) : (root.callbackNode = null, root.callbackPriority = 0);
            recoverableErrors = 0 !== (finishedWork.flags & 13878);
            if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
                recoverableErrors = ReactSharedInternals.T;
                ReactSharedInternals.T = null;
                transitions = getCurrentUpdatePriority();
                setCurrentUpdatePriority(2);
                spawnedLane = executionContext;
                executionContext |= 4;
                try {
                    commitBeforeMutationEffects(root, finishedWork, lanes);
                } finally{
                    executionContext = spawnedLane, setCurrentUpdatePriority(transitions), ReactSharedInternals.T = recoverableErrors;
                }
            }
            pendingEffectsStatus = 1;
            flushMutationEffects();
            flushLayoutEffects();
            flushSpawnedWork();
        }
    }
    function flushMutationEffects() {
        if (1 === pendingEffectsStatus) {
            pendingEffectsStatus = 0;
            var root = pendingEffectsRoot, finishedWork = pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
            if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
                rootMutationHasEffect = ReactSharedInternals.T;
                ReactSharedInternals.T = null;
                var previousPriority = getCurrentUpdatePriority();
                setCurrentUpdatePriority(2);
                var prevExecutionContext = executionContext;
                executionContext |= 4;
                try {
                    commitMutationEffectsOnFiber(finishedWork, root), resetAfterCommit(root.containerInfo);
                } finally{
                    executionContext = prevExecutionContext, setCurrentUpdatePriority(previousPriority), ReactSharedInternals.T = rootMutationHasEffect;
                }
            }
            root.current = finishedWork;
            pendingEffectsStatus = 2;
        }
    }
    function flushLayoutEffects() {
        if (2 === pendingEffectsStatus) {
            pendingEffectsStatus = 0;
            var root = pendingEffectsRoot, finishedWork = pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
            if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
                rootHasLayoutEffect = ReactSharedInternals.T;
                ReactSharedInternals.T = null;
                var previousPriority = getCurrentUpdatePriority();
                setCurrentUpdatePriority(2);
                var prevExecutionContext = executionContext;
                executionContext |= 4;
                try {
                    commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
                } finally{
                    executionContext = prevExecutionContext, setCurrentUpdatePriority(previousPriority), ReactSharedInternals.T = rootHasLayoutEffect;
                }
            }
            pendingEffectsStatus = 3;
        }
    }
    function flushSpawnedWork() {
        if (4 === pendingEffectsStatus || 3 === pendingEffectsStatus) {
            pendingEffectsStatus = 0;
            requestPaint();
            var root = pendingEffectsRoot, finishedWork = pendingFinishedWork, lanes = pendingEffectsLanes, recoverableErrors = pendingRecoverableErrors;
            0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? pendingEffectsStatus = 5 : (pendingEffectsStatus = 0, pendingFinishedWork = pendingEffectsRoot = null, releaseRootPooledCache(root, root.pendingLanes));
            var remainingLanes = root.pendingLanes;
            0 === remainingLanes && (legacyErrorBoundariesThatAlreadyFailed = null);
            lanesToEventPriority(lanes);
            finishedWork = finishedWork.stateNode;
            if (injectedHook && "function" === typeof injectedHook.onCommitFiberRoot) try {
                injectedHook.onCommitFiberRoot(rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
            } catch (err) {}
            if (null !== recoverableErrors) {
                finishedWork = ReactSharedInternals.T;
                remainingLanes = getCurrentUpdatePriority();
                setCurrentUpdatePriority(2);
                ReactSharedInternals.T = null;
                try {
                    for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                        var recoverableError = recoverableErrors[i];
                        onRecoverableError(recoverableError.value, {
                            componentStack: recoverableError.stack
                        });
                    }
                } finally{
                    ReactSharedInternals.T = finishedWork, setCurrentUpdatePriority(remainingLanes);
                }
            }
            0 !== (pendingEffectsLanes & 3) && flushPendingEffects();
            ensureRootIsScheduled(root);
            remainingLanes = root.pendingLanes;
            0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === rootWithNestedUpdates ? nestedUpdateCount++ : (nestedUpdateCount = 0, rootWithNestedUpdates = root) : nestedUpdateCount = 0;
            supportsHydration && flushHydrationEvents();
            flushSyncWorkAcrossRoots_impl(0, !1);
        }
    }
    function releaseRootPooledCache(root, remainingLanes) {
        0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, releaseCache(remainingLanes)));
    }
    function flushPendingEffects() {
        flushMutationEffects();
        flushLayoutEffects();
        flushSpawnedWork();
        return flushPassiveEffects();
    }
    function flushPassiveEffects() {
        if (5 !== pendingEffectsStatus) return !1;
        var root = pendingEffectsRoot, remainingLanes = pendingEffectsRemainingLanes;
        pendingEffectsRemainingLanes = 0;
        var renderPriority = lanesToEventPriority(pendingEffectsLanes), priority = 32 > renderPriority ? 32 : renderPriority;
        renderPriority = ReactSharedInternals.T;
        var previousPriority = getCurrentUpdatePriority();
        try {
            setCurrentUpdatePriority(priority);
            ReactSharedInternals.T = null;
            priority = pendingPassiveTransitions;
            pendingPassiveTransitions = null;
            var root$jscomp$0 = pendingEffectsRoot, lanes = pendingEffectsLanes;
            pendingEffectsStatus = 0;
            pendingFinishedWork = pendingEffectsRoot = null;
            pendingEffectsLanes = 0;
            if (0 !== (executionContext & 6)) throw Error(formatProdErrorMessage(331));
            var prevExecutionContext = executionContext;
            executionContext |= 4;
            commitPassiveUnmountOnFiber(root$jscomp$0.current);
            commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, priority);
            executionContext = prevExecutionContext;
            flushSyncWorkAcrossRoots_impl(0, !1);
            if (injectedHook && "function" === typeof injectedHook.onPostCommitFiberRoot) try {
                injectedHook.onPostCommitFiberRoot(rendererID, root$jscomp$0);
            } catch (err) {}
            return !0;
        } finally{
            setCurrentUpdatePriority(previousPriority), ReactSharedInternals.T = renderPriority, releaseRootPooledCache(root, remainingLanes);
        }
    }
    function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
        sourceFiber = createCapturedValueAtFiber(error, sourceFiber);
        sourceFiber = createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
        rootFiber = enqueueUpdate(rootFiber, sourceFiber, 2);
        null !== rootFiber && (markRootUpdated$1(rootFiber, 2), ensureRootIsScheduled(rootFiber));
    }
    function captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
        if (3 === sourceFiber.tag) captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
        else for(; null !== nearestMountedAncestor;){
            if (3 === nearestMountedAncestor.tag) {
                captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
                break;
            } else if (1 === nearestMountedAncestor.tag) {
                var instance = nearestMountedAncestor.stateNode;
                if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === legacyErrorBoundariesThatAlreadyFailed || !legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                    sourceFiber = createCapturedValueAtFiber(error, sourceFiber);
                    error = createClassErrorUpdate(2);
                    instance = enqueueUpdate(nearestMountedAncestor, error, 2);
                    null !== instance && (initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), markRootUpdated$1(instance, 2), ensureRootIsScheduled(instance));
                    break;
                }
            }
            nearestMountedAncestor = nearestMountedAncestor.return;
        }
    }
    function attachPingListener(root, wakeable, lanes) {
        var pingCache = root.pingCache;
        if (null === pingCache) {
            pingCache = root.pingCache = new PossiblyWeakMap();
            var threadIDs = new Set();
            pingCache.set(wakeable, threadIDs);
        } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
        threadIDs.has(lanes) || (workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
    }
    function pingSuspendedRoot(root, wakeable, pingedLanes) {
        var pingCache = root.pingCache;
        null !== pingCache && pingCache.delete(wakeable);
        root.pingedLanes |= root.suspendedLanes & pingedLanes;
        root.warmLanes &= ~pingedLanes;
        workInProgressRoot === root && (workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === workInProgressRootExitStatus || 3 === workInProgressRootExitStatus && (workInProgressRootRenderLanes & 62914560) === workInProgressRootRenderLanes && 300 > now() - globalMostRecentFallbackTime ? 0 === (executionContext & 2) && prepareFreshStack(root, 0) : workInProgressRootPingedLanes |= pingedLanes, workInProgressSuspendedRetryLanes === workInProgressRootRenderLanes && (workInProgressSuspendedRetryLanes = 0));
        ensureRootIsScheduled(root);
    }
    function retryTimedOutBoundary(boundaryFiber, retryLane) {
        0 === retryLane && (retryLane = claimNextRetryLane());
        boundaryFiber = enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
        null !== boundaryFiber && (markRootUpdated$1(boundaryFiber, retryLane), ensureRootIsScheduled(boundaryFiber));
    }
    function retryDehydratedSuspenseBoundary(boundaryFiber) {
        var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
        null !== suspenseState && (retryLane = suspenseState.retryLane);
        retryTimedOutBoundary(boundaryFiber, retryLane);
    }
    function resolveRetryWakeable(boundaryFiber, wakeable) {
        var retryLane = 0;
        switch(boundaryFiber.tag){
            case 31:
            case 13:
                var retryCache = boundaryFiber.stateNode;
                var suspenseState = boundaryFiber.memoizedState;
                null !== suspenseState && (retryLane = suspenseState.retryLane);
                break;
            case 19:
                retryCache = boundaryFiber.stateNode;
                break;
            case 22:
                retryCache = boundaryFiber.stateNode._retryCache;
                break;
            default:
                throw Error(formatProdErrorMessage(314));
        }
        null !== retryCache && retryCache.delete(wakeable);
        retryTimedOutBoundary(boundaryFiber, retryLane);
    }
    function scheduleCallback(priorityLevel, callback) {
        return scheduleCallback$3(priorityLevel, callback);
    }
    function FiberNode(tag, pendingProps, key, mode) {
        this.tag = tag;
        this.key = key;
        this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
        this.index = 0;
        this.refCleanup = this.ref = null;
        this.pendingProps = pendingProps;
        this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
        this.mode = mode;
        this.subtreeFlags = this.flags = 0;
        this.deletions = null;
        this.childLanes = this.lanes = 0;
        this.alternate = null;
    }
    function shouldConstruct(Component) {
        Component = Component.prototype;
        return !(!Component || !Component.isReactComponent);
    }
    function createWorkInProgress(current, pendingProps) {
        var workInProgress = current.alternate;
        null === workInProgress ? (workInProgress = createFiber(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
        workInProgress.flags = current.flags & 65011712;
        workInProgress.childLanes = current.childLanes;
        workInProgress.lanes = current.lanes;
        workInProgress.child = current.child;
        workInProgress.memoizedProps = current.memoizedProps;
        workInProgress.memoizedState = current.memoizedState;
        workInProgress.updateQueue = current.updateQueue;
        pendingProps = current.dependencies;
        workInProgress.dependencies = null === pendingProps ? null : {
            lanes: pendingProps.lanes,
            firstContext: pendingProps.firstContext
        };
        workInProgress.sibling = current.sibling;
        workInProgress.index = current.index;
        workInProgress.ref = current.ref;
        workInProgress.refCleanup = current.refCleanup;
        return workInProgress;
    }
    function resetWorkInProgress(workInProgress, renderLanes) {
        workInProgress.flags &= 65011714;
        var current = workInProgress.alternate;
        null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
            lanes: renderLanes.lanes,
            firstContext: renderLanes.firstContext
        });
        return workInProgress;
    }
    function createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
        var fiberTag = 0;
        owner = type;
        if ("function" === typeof type) shouldConstruct(type) && (fiberTag = 1);
        else if ("string" === typeof type) fiberTag = supportsResources && supportsSingletons ? isHostHoistableType(type, pendingProps, contextStackCursor.current) ? 26 : isHostSingletonType(type) ? 27 : 5 : supportsResources ? isHostHoistableType(type, pendingProps, contextStackCursor.current) ? 26 : 5 : supportsSingletons ? isHostSingletonType(type) ? 27 : 5 : 5;
        else a: switch(type){
            case REACT_ACTIVITY_TYPE:
                return type = createFiber(31, pendingProps, key, mode), type.elementType = REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
            case REACT_FRAGMENT_TYPE:
                return createFiberFromFragment(pendingProps.children, mode, lanes, key);
            case REACT_STRICT_MODE_TYPE:
                fiberTag = 8;
                mode |= 24;
                break;
            case REACT_PROFILER_TYPE:
                return type = createFiber(12, pendingProps, key, mode | 2), type.elementType = REACT_PROFILER_TYPE, type.lanes = lanes, type;
            case REACT_SUSPENSE_TYPE:
                return type = createFiber(13, pendingProps, key, mode), type.elementType = REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
            case REACT_SUSPENSE_LIST_TYPE:
                return type = createFiber(19, pendingProps, key, mode), type.elementType = REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
            default:
                if ("object" === typeof type && null !== type) switch(type.$$typeof){
                    case REACT_CONTEXT_TYPE:
                        fiberTag = 10;
                        break a;
                    case REACT_CONSUMER_TYPE:
                        fiberTag = 9;
                        break a;
                    case REACT_FORWARD_REF_TYPE:
                        fiberTag = 11;
                        break a;
                    case REACT_MEMO_TYPE:
                        fiberTag = 14;
                        break a;
                    case REACT_LAZY_TYPE:
                        fiberTag = 16;
                        owner = null;
                        break a;
                }
                fiberTag = 29;
                pendingProps = Error(formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
                owner = null;
        }
        key = createFiber(fiberTag, pendingProps, key, mode);
        key.elementType = type;
        key.type = owner;
        key.lanes = lanes;
        return key;
    }
    function createFiberFromFragment(elements, mode, lanes, key) {
        elements = createFiber(7, elements, key, mode);
        elements.lanes = lanes;
        return elements;
    }
    function createFiberFromText(content, mode, lanes) {
        content = createFiber(6, content, null, mode);
        content.lanes = lanes;
        return content;
    }
    function createFiberFromDehydratedFragment(dehydratedNode) {
        var fiber = createFiber(18, null, null, 0);
        fiber.stateNode = dehydratedNode;
        return fiber;
    }
    function createFiberFromPortal(portal, mode, lanes) {
        mode = createFiber(4, null !== portal.children ? portal.children : [], portal.key, mode);
        mode.lanes = lanes;
        mode.stateNode = {
            containerInfo: portal.containerInfo,
            pendingChildren: null,
            implementation: portal.implementation
        };
        return mode;
    }
    function FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
        this.tag = 1;
        this.containerInfo = containerInfo;
        this.pingCache = this.current = this.pendingChildren = null;
        this.timeoutHandle = noTimeout;
        this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
        this.callbackPriority = 0;
        this.expirationTimes = createLaneMap(-1);
        this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
        this.entanglements = createLaneMap(0);
        this.hiddenUpdates = createLaneMap(null);
        this.identifierPrefix = identifierPrefix;
        this.onUncaughtError = onUncaughtError;
        this.onCaughtError = onCaughtError;
        this.onRecoverableError = onRecoverableError;
        this.pooledCache = null;
        this.pooledCacheLanes = 0;
        this.formState = formState;
        this.incompleteTransitions = new Map();
    }
    function createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
        containerInfo = new FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
        tag = 1;
        !0 === isStrictMode && (tag |= 24);
        isStrictMode = createFiber(3, null, null, tag);
        containerInfo.current = isStrictMode;
        isStrictMode.stateNode = containerInfo;
        tag = createCache();
        tag.refCount++;
        containerInfo.pooledCache = tag;
        tag.refCount++;
        isStrictMode.memoizedState = {
            element: initialChildren,
            isDehydrated: hydrate,
            cache: tag
        };
        initializeUpdateQueue(isStrictMode);
        return containerInfo;
    }
    function getContextForSubtree(parentComponent) {
        if (!parentComponent) return emptyContextObject;
        parentComponent = emptyContextObject;
        return parentComponent;
    }
    function findHostInstance(component) {
        var fiber = component._reactInternals;
        if (void 0 === fiber) {
            if ("function" === typeof component.render) throw Error(formatProdErrorMessage(188));
            component = Object.keys(component).join(",");
            throw Error(formatProdErrorMessage(268, component));
        }
        component = findCurrentFiberUsingSlowPath(fiber);
        component = null !== component ? findCurrentHostFiberImpl(component) : null;
        return null === component ? null : getPublicInstance(component.stateNode);
    }
    function updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
        parentComponent = getContextForSubtree(parentComponent);
        null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
        container = createUpdate(lane);
        container.payload = {
            element: element
        };
        callback = void 0 === callback ? null : callback;
        null !== callback && (container.callback = callback);
        element = enqueueUpdate(rootFiber, container, lane);
        null !== element && (scheduleUpdateOnFiber(element, rootFiber, lane), entangleTransitions(element, rootFiber, lane));
    }
    function markRetryLaneImpl(fiber, retryLane) {
        fiber = fiber.memoizedState;
        if (null !== fiber && null !== fiber.dehydrated) {
            var a = fiber.retryLane;
            fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
        }
    }
    function markRetryLaneIfNotHydrated(fiber, retryLane) {
        markRetryLaneImpl(fiber, retryLane);
        (fiber = fiber.alternate) && markRetryLaneImpl(fiber, retryLane);
    }
    var exports = {};
    "use strict";
    var React = (parcelRequire("cQmXV")), Scheduler = (parcelRequire("1zXL0")), assign = Object.assign, REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy");
    Symbol.for("react.scope");
    var REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
    Symbol.for("react.legacy_hidden");
    Symbol.for("react.tracing_marker");
    var REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
    Symbol.for("react.view_transition");
    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator, REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference"), isArrayImpl = Array.isArray, ReactSharedInternals = React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, rendererVersion = $$$config.rendererVersion, rendererPackageName = $$$config.rendererPackageName, extraDevToolsConfig = $$$config.extraDevToolsConfig, getPublicInstance = $$$config.getPublicInstance, getRootHostContext = $$$config.getRootHostContext, getChildHostContext = $$$config.getChildHostContext, prepareForCommit = $$$config.prepareForCommit, resetAfterCommit = $$$config.resetAfterCommit, createInstance = $$$config.createInstance;
    $$$config.cloneMutableInstance;
    var appendInitialChild = $$$config.appendInitialChild, finalizeInitialChildren = $$$config.finalizeInitialChildren, shouldSetTextContent = $$$config.shouldSetTextContent, createTextInstance = $$$config.createTextInstance;
    $$$config.cloneMutableTextInstance;
    var scheduleTimeout = $$$config.scheduleTimeout, cancelTimeout = $$$config.cancelTimeout, noTimeout = $$$config.noTimeout, isPrimaryRenderer = $$$config.isPrimaryRenderer;
    $$$config.warnsIfNotActing;
    var supportsMutation = $$$config.supportsMutation, supportsPersistence = $$$config.supportsPersistence, supportsHydration = $$$config.supportsHydration, getInstanceFromNode = $$$config.getInstanceFromNode;
    $$$config.beforeActiveInstanceBlur;
    var preparePortalMount = $$$config.preparePortalMount;
    $$$config.prepareScopeUpdate;
    $$$config.getInstanceFromScope;
    var setCurrentUpdatePriority = $$$config.setCurrentUpdatePriority, getCurrentUpdatePriority = $$$config.getCurrentUpdatePriority, resolveUpdatePriority = $$$config.resolveUpdatePriority;
    $$$config.trackSchedulerEvent;
    $$$config.resolveEventType;
    $$$config.resolveEventTimeStamp;
    var shouldAttemptEagerTransition = $$$config.shouldAttemptEagerTransition, detachDeletedInstance = $$$config.detachDeletedInstance;
    $$$config.requestPostPaintCallback;
    var maySuspendCommit = $$$config.maySuspendCommit, maySuspendCommitOnUpdate = $$$config.maySuspendCommitOnUpdate, maySuspendCommitInSyncRender = $$$config.maySuspendCommitInSyncRender, preloadInstance = $$$config.preloadInstance, startSuspendingCommit = $$$config.startSuspendingCommit, suspendInstance = $$$config.suspendInstance;
    $$$config.suspendOnActiveViewTransition;
    var waitForCommitToBeReady = $$$config.waitForCommitToBeReady;
    $$$config.getSuspendedCommitReason;
    var NotPendingTransition = $$$config.NotPendingTransition, HostTransitionContext = $$$config.HostTransitionContext, resetFormInstance = $$$config.resetFormInstance;
    $$$config.bindToConsole;
    var supportsMicrotasks = $$$config.supportsMicrotasks, scheduleMicrotask = $$$config.scheduleMicrotask, supportsTestSelectors = $$$config.supportsTestSelectors, findFiberRoot = $$$config.findFiberRoot, getBoundingRect = $$$config.getBoundingRect, getTextContent = $$$config.getTextContent, isHiddenSubtree = $$$config.isHiddenSubtree, matchAccessibilityRole = $$$config.matchAccessibilityRole, setFocusIfFocusable = $$$config.setFocusIfFocusable, setupIntersectionObserver = $$$config.setupIntersectionObserver, appendChild = $$$config.appendChild, appendChildToContainer = $$$config.appendChildToContainer, commitTextUpdate = $$$config.commitTextUpdate, commitMount = $$$config.commitMount, commitUpdate = $$$config.commitUpdate, insertBefore = $$$config.insertBefore, insertInContainerBefore = $$$config.insertInContainerBefore, removeChild = $$$config.removeChild, removeChildFromContainer = $$$config.removeChildFromContainer, resetTextContent = $$$config.resetTextContent, hideInstance = $$$config.hideInstance, hideTextInstance = $$$config.hideTextInstance, unhideInstance = $$$config.unhideInstance, unhideTextInstance = $$$config.unhideTextInstance;
    $$$config.cancelViewTransitionName;
    $$$config.cancelRootViewTransitionName;
    $$$config.restoreRootViewTransitionName;
    $$$config.cloneRootViewTransitionContainer;
    $$$config.removeRootViewTransitionClone;
    $$$config.measureClonedInstance;
    $$$config.hasInstanceChanged;
    $$$config.hasInstanceAffectedParent;
    $$$config.startViewTransition;
    $$$config.startGestureTransition;
    $$$config.stopViewTransition;
    $$$config.getCurrentGestureOffset;
    $$$config.createViewTransitionInstance;
    var clearContainer = $$$config.clearContainer;
    $$$config.createFragmentInstance;
    $$$config.updateFragmentInstanceFiber;
    $$$config.commitNewChildToFragmentInstance;
    $$$config.deleteChildFromFragmentInstance;
    var cloneInstance = $$$config.cloneInstance, createContainerChildSet = $$$config.createContainerChildSet, appendChildToContainerChildSet = $$$config.appendChildToContainerChildSet, finalizeContainerChildren = $$$config.finalizeContainerChildren, replaceContainerChildren = $$$config.replaceContainerChildren, cloneHiddenInstance = $$$config.cloneHiddenInstance, cloneHiddenTextInstance = $$$config.cloneHiddenTextInstance, isSuspenseInstancePending = $$$config.isSuspenseInstancePending, isSuspenseInstanceFallback = $$$config.isSuspenseInstanceFallback, getSuspenseInstanceFallbackErrorDetails = $$$config.getSuspenseInstanceFallbackErrorDetails, registerSuspenseInstanceRetry = $$$config.registerSuspenseInstanceRetry, canHydrateFormStateMarker = $$$config.canHydrateFormStateMarker, isFormStateMarkerMatching = $$$config.isFormStateMarkerMatching, getNextHydratableSibling = $$$config.getNextHydratableSibling, getNextHydratableSiblingAfterSingleton = $$$config.getNextHydratableSiblingAfterSingleton, getFirstHydratableChild = $$$config.getFirstHydratableChild, getFirstHydratableChildWithinContainer = $$$config.getFirstHydratableChildWithinContainer, getFirstHydratableChildWithinActivityInstance = $$$config.getFirstHydratableChildWithinActivityInstance, getFirstHydratableChildWithinSuspenseInstance = $$$config.getFirstHydratableChildWithinSuspenseInstance, getFirstHydratableChildWithinSingleton = $$$config.getFirstHydratableChildWithinSingleton, canHydrateInstance = $$$config.canHydrateInstance, canHydrateTextInstance = $$$config.canHydrateTextInstance, canHydrateActivityInstance = $$$config.canHydrateActivityInstance, canHydrateSuspenseInstance = $$$config.canHydrateSuspenseInstance, hydrateInstance = $$$config.hydrateInstance, hydrateTextInstance = $$$config.hydrateTextInstance, hydrateActivityInstance = $$$config.hydrateActivityInstance, hydrateSuspenseInstance = $$$config.hydrateSuspenseInstance, getNextHydratableInstanceAfterActivityInstance = $$$config.getNextHydratableInstanceAfterActivityInstance, getNextHydratableInstanceAfterSuspenseInstance = $$$config.getNextHydratableInstanceAfterSuspenseInstance, commitHydratedInstance = $$$config.commitHydratedInstance, commitHydratedContainer = $$$config.commitHydratedContainer, commitHydratedActivityInstance = $$$config.commitHydratedActivityInstance, commitHydratedSuspenseInstance = $$$config.commitHydratedSuspenseInstance, finalizeHydratedChildren = $$$config.finalizeHydratedChildren, flushHydrationEvents = $$$config.flushHydrationEvents;
    $$$config.clearActivityBoundary;
    var clearSuspenseBoundary = $$$config.clearSuspenseBoundary;
    $$$config.clearActivityBoundaryFromContainer;
    var clearSuspenseBoundaryFromContainer = $$$config.clearSuspenseBoundaryFromContainer, hideDehydratedBoundary = $$$config.hideDehydratedBoundary, unhideDehydratedBoundary = $$$config.unhideDehydratedBoundary, shouldDeleteUnhydratedTailInstances = $$$config.shouldDeleteUnhydratedTailInstances;
    $$$config.diffHydratedPropsForDevWarnings;
    $$$config.diffHydratedTextForDevWarnings;
    $$$config.describeHydratableInstanceForDevWarnings;
    var validateHydratableInstance = $$$config.validateHydratableInstance, validateHydratableTextInstance = $$$config.validateHydratableTextInstance, supportsResources = $$$config.supportsResources, isHostHoistableType = $$$config.isHostHoistableType, getHoistableRoot = $$$config.getHoistableRoot, getResource = $$$config.getResource, acquireResource = $$$config.acquireResource, releaseResource = $$$config.releaseResource, hydrateHoistable = $$$config.hydrateHoistable, mountHoistable = $$$config.mountHoistable, unmountHoistable = $$$config.unmountHoistable, createHoistableInstance = $$$config.createHoistableInstance, prepareToCommitHoistables = $$$config.prepareToCommitHoistables, mayResourceSuspendCommit = $$$config.mayResourceSuspendCommit, preloadResource = $$$config.preloadResource, suspendResource = $$$config.suspendResource, supportsSingletons = $$$config.supportsSingletons, resolveSingletonInstance = $$$config.resolveSingletonInstance, acquireSingletonInstance = $$$config.acquireSingletonInstance, releaseSingletonInstance = $$$config.releaseSingletonInstance, isHostSingletonType = $$$config.isHostSingletonType, isSingletonScope = $$$config.isSingletonScope, valueStack = [], index$jscomp$0 = -1, emptyContextObject = {}, clz32 = Math.clz32 ? Math.clz32 : clz32Fallback, log$1 = Math.log, LN2 = Math.LN2, nextTransitionUpdateLane = 256, nextTransitionDeferredLane = 262144, nextRetryLane = 4194304, scheduleCallback$3 = Scheduler.unstable_scheduleCallback, cancelCallback$1 = Scheduler.unstable_cancelCallback, shouldYield = Scheduler.unstable_shouldYield, requestPaint = Scheduler.unstable_requestPaint, now = Scheduler.unstable_now, ImmediatePriority = Scheduler.unstable_ImmediatePriority, UserBlockingPriority = Scheduler.unstable_UserBlockingPriority, NormalPriority$1 = Scheduler.unstable_NormalPriority, IdlePriority = Scheduler.unstable_IdlePriority, log = Scheduler.log, unstable_setDisableYieldValue = Scheduler.unstable_setDisableYieldValue, rendererID = null, injectedHook = null, objectIs = "function" === typeof Object.is ? Object.is : is, reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
        if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
            var event = new window.ErrorEvent("error", {
                bubbles: !0,
                cancelable: !0,
                message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
                error: error
            });
            if (!window.dispatchEvent(event)) return;
        } else if ("object" === typeof $4dBQg && "function" === typeof $4dBQg.emit) {
            $4dBQg.emit("uncaughtException", error);
            return;
        }
        console.error(error);
    }, hasOwnProperty = Object.prototype.hasOwnProperty, prefix, suffix, reentry = !1, CapturedStacks = new WeakMap(), forkStack = [], forkStackIndex = 0, treeForkProvider = null, treeForkCount = 0, idStack = [], idStackIndex = 0, treeContextProvider = null, treeContextId = 1, treeContextOverflow = "", contextStackCursor = createCursor(null), contextFiberStackCursor = createCursor(null), rootInstanceStackCursor = createCursor(null), hostTransitionProviderCursor = createCursor(null), hydrationParentFiber = null, nextHydratableInstance = null, isHydrating = !1, hydrationErrors = null, rootOrSingletonContext = !1, HydrationMismatchException = Error(formatProdErrorMessage(519)), valueCursor = createCursor(null), currentlyRenderingFiber$1 = null, lastContextDependency = null, AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
        var listeners = [], signal = this.signal = {
            aborted: !1,
            addEventListener: function(type, listener) {
                listeners.push(listener);
            }
        };
        this.abort = function() {
            signal.aborted = !0;
            listeners.forEach(function(listener) {
                return listener();
            });
        };
    }, scheduleCallback$2 = Scheduler.unstable_scheduleCallback, NormalPriority = Scheduler.unstable_NormalPriority, CacheContext = {
        $$typeof: REACT_CONTEXT_TYPE,
        Consumer: null,
        Provider: null,
        _currentValue: null,
        _currentValue2: null,
        _threadCount: 0
    }, firstScheduledRoot = null, lastScheduledRoot = null, didScheduleMicrotask = !1, mightHavePendingSyncWork = !1, isFlushingWork = !1, currentEventTransitionLane = 0, currentEntangledListeners = null, currentEntangledPendingCount = 0, currentEntangledLane = 0, currentEntangledActionThenable = null, prevOnStartTransitionFinish = ReactSharedInternals.S;
    ReactSharedInternals.S = function(transition, returnValue) {
        globalMostRecentTransitionTime = now();
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && entangleAsyncAction(transition, returnValue);
        null !== prevOnStartTransitionFinish && prevOnStartTransitionFinish(transition, returnValue);
    };
    var resumedCache = createCursor(null), SuspenseException = Error(formatProdErrorMessage(460)), SuspenseyCommitException = Error(formatProdErrorMessage(474)), SuspenseActionException = Error(formatProdErrorMessage(542)), noopSuspenseyCommitThenable = {
        then: function() {}
    }, suspendedThenable = null, thenableState$1 = null, thenableIndexCounter$1 = 0, reconcileChildFibers = createChildReconciler(!0), mountChildFibers = createChildReconciler(!1), concurrentQueues = [], concurrentQueuesIndex = 0, concurrentlyUpdatedLanes = 0, hasForceUpdate = !1, didReadFromEntangledAsyncAction = !1, currentTreeHiddenStackCursor = createCursor(null), prevEntangledRenderLanesCursor = createCursor(0), suspenseHandlerStackCursor = createCursor(null), shellBoundary = null, suspenseStackCursor = createCursor(0), renderLanes = 0, currentlyRenderingFiber = null, currentHook = null, workInProgressHook = null, didScheduleRenderPhaseUpdate = !1, didScheduleRenderPhaseUpdateDuringThisPass = !1, shouldDoubleInvokeUserFnsInHooksDEV = !1, localIdCounter = 0, thenableIndexCounter = 0, thenableState = null, globalClientIdCounter = 0, ContextOnlyDispatcher = {
        readContext: readContext,
        use: use,
        useCallback: throwInvalidHookError,
        useContext: throwInvalidHookError,
        useEffect: throwInvalidHookError,
        useImperativeHandle: throwInvalidHookError,
        useLayoutEffect: throwInvalidHookError,
        useInsertionEffect: throwInvalidHookError,
        useMemo: throwInvalidHookError,
        useReducer: throwInvalidHookError,
        useRef: throwInvalidHookError,
        useState: throwInvalidHookError,
        useDebugValue: throwInvalidHookError,
        useDeferredValue: throwInvalidHookError,
        useTransition: throwInvalidHookError,
        useSyncExternalStore: throwInvalidHookError,
        useId: throwInvalidHookError,
        useHostTransitionStatus: throwInvalidHookError,
        useFormState: throwInvalidHookError,
        useActionState: throwInvalidHookError,
        useOptimistic: throwInvalidHookError,
        useMemoCache: throwInvalidHookError,
        useCacheRefresh: throwInvalidHookError
    };
    ContextOnlyDispatcher.useEffectEvent = throwInvalidHookError;
    var HooksDispatcherOnMount = {
        readContext: readContext,
        use: use,
        useCallback: function(callback, deps) {
            mountWorkInProgressHook().memoizedState = [
                callback,
                void 0 === deps ? null : deps
            ];
            return callback;
        },
        useContext: readContext,
        useEffect: mountEffect,
        useImperativeHandle: function(ref, create, deps) {
            deps = null !== deps && void 0 !== deps ? deps.concat([
                ref
            ]) : null;
            mountEffectImpl(4194308, 4, imperativeHandleEffect.bind(null, create, ref), deps);
        },
        useLayoutEffect: function(create, deps) {
            return mountEffectImpl(4194308, 4, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            mountEffectImpl(4, 2, create, deps);
        },
        useMemo: function(nextCreate, deps) {
            var hook = mountWorkInProgressHook();
            deps = void 0 === deps ? null : deps;
            var nextValue = nextCreate();
            if (shouldDoubleInvokeUserFnsInHooksDEV) {
                setIsStrictModeForDevtools(!0);
                try {
                    nextCreate();
                } finally{
                    setIsStrictModeForDevtools(!1);
                }
            }
            hook.memoizedState = [
                nextValue,
                deps
            ];
            return nextValue;
        },
        useReducer: function(reducer, initialArg, init) {
            var hook = mountWorkInProgressHook();
            if (void 0 !== init) {
                var initialState = init(initialArg);
                if (shouldDoubleInvokeUserFnsInHooksDEV) {
                    setIsStrictModeForDevtools(!0);
                    try {
                        init(initialArg);
                    } finally{
                        setIsStrictModeForDevtools(!1);
                    }
                }
            } else initialState = initialArg;
            hook.memoizedState = hook.baseState = initialState;
            reducer = {
                pending: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: reducer,
                lastRenderedState: initialState
            };
            hook.queue = reducer;
            reducer = reducer.dispatch = dispatchReducerAction.bind(null, currentlyRenderingFiber, reducer);
            return [
                hook.memoizedState,
                reducer
            ];
        },
        useRef: function(initialValue) {
            var hook = mountWorkInProgressHook();
            initialValue = {
                current: initialValue
            };
            return hook.memoizedState = initialValue;
        },
        useState: function(initialState) {
            initialState = mountStateImpl(initialState);
            var queue = initialState.queue, dispatch = dispatchSetState.bind(null, currentlyRenderingFiber, queue);
            queue.dispatch = dispatch;
            return [
                initialState.memoizedState,
                dispatch
            ];
        },
        useDebugValue: mountDebugValue,
        useDeferredValue: function(value, initialValue) {
            var hook = mountWorkInProgressHook();
            return mountDeferredValueImpl(hook, value, initialValue);
        },
        useTransition: function() {
            var stateHook = mountStateImpl(!1);
            stateHook = startTransition.bind(null, currentlyRenderingFiber, stateHook.queue, !0, !1);
            mountWorkInProgressHook().memoizedState = stateHook;
            return [
                !1,
                stateHook
            ];
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            var fiber = currentlyRenderingFiber, hook = mountWorkInProgressHook();
            if (isHydrating) {
                if (void 0 === getServerSnapshot) throw Error(formatProdErrorMessage(407));
                getServerSnapshot = getServerSnapshot();
            } else {
                getServerSnapshot = getSnapshot();
                if (null === workInProgressRoot) throw Error(formatProdErrorMessage(349));
                0 !== (workInProgressRootRenderLanes & 127) || pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
            }
            hook.memoizedState = getServerSnapshot;
            var inst = {
                value: getServerSnapshot,
                getSnapshot: getSnapshot
            };
            hook.queue = inst;
            mountEffect(subscribeToStore.bind(null, fiber, inst, subscribe), [
                subscribe
            ]);
            fiber.flags |= 2048;
            pushSimpleEffect(9, {
                destroy: void 0
            }, updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
            return getServerSnapshot;
        },
        useId: function() {
            var hook = mountWorkInProgressHook(), identifierPrefix = workInProgressRoot.identifierPrefix;
            if (isHydrating) {
                var JSCompiler_inline_result = treeContextOverflow;
                var idWithLeadingBit = treeContextId;
                JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
                identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
                JSCompiler_inline_result = localIdCounter++;
                0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
                identifierPrefix += "_";
            } else JSCompiler_inline_result = globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
            return hook.memoizedState = identifierPrefix;
        },
        useHostTransitionStatus: useHostTransitionStatus,
        useFormState: mountActionState,
        useActionState: mountActionState,
        useOptimistic: function(passthrough) {
            var hook = mountWorkInProgressHook();
            hook.memoizedState = hook.baseState = passthrough;
            var queue = {
                pending: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: null,
                lastRenderedState: null
            };
            hook.queue = queue;
            hook = dispatchOptimisticSetState.bind(null, currentlyRenderingFiber, !0, queue);
            queue.dispatch = hook;
            return [
                passthrough,
                hook
            ];
        },
        useMemoCache: useMemoCache,
        useCacheRefresh: function() {
            return mountWorkInProgressHook().memoizedState = refreshCache.bind(null, currentlyRenderingFiber);
        },
        useEffectEvent: function(callback) {
            var hook = mountWorkInProgressHook(), ref = {
                impl: callback
            };
            hook.memoizedState = ref;
            return function() {
                if (0 !== (executionContext & 2)) throw Error(formatProdErrorMessage(440));
                return ref.impl.apply(void 0, arguments);
            };
        }
    }, HooksDispatcherOnUpdate = {
        readContext: readContext,
        use: use,
        useCallback: updateCallback,
        useContext: readContext,
        useEffect: updateEffect,
        useImperativeHandle: updateImperativeHandle,
        useInsertionEffect: updateInsertionEffect,
        useLayoutEffect: updateLayoutEffect,
        useMemo: updateMemo,
        useReducer: updateReducer,
        useRef: updateRef,
        useState: function() {
            return updateReducer(basicStateReducer);
        },
        useDebugValue: mountDebugValue,
        useDeferredValue: function(value, initialValue) {
            var hook = updateWorkInProgressHook();
            return updateDeferredValueImpl(hook, currentHook.memoizedState, value, initialValue);
        },
        useTransition: function() {
            var booleanOrThenable = updateReducer(basicStateReducer)[0], start = updateWorkInProgressHook().memoizedState;
            return [
                "boolean" === typeof booleanOrThenable ? booleanOrThenable : useThenable(booleanOrThenable),
                start
            ];
        },
        useSyncExternalStore: updateSyncExternalStore,
        useId: updateId,
        useHostTransitionStatus: useHostTransitionStatus,
        useFormState: updateActionState,
        useActionState: updateActionState,
        useOptimistic: function(passthrough, reducer) {
            var hook = updateWorkInProgressHook();
            return updateOptimisticImpl(hook, currentHook, passthrough, reducer);
        },
        useMemoCache: useMemoCache,
        useCacheRefresh: updateRefresh
    };
    HooksDispatcherOnUpdate.useEffectEvent = updateEvent;
    var HooksDispatcherOnRerender = {
        readContext: readContext,
        use: use,
        useCallback: updateCallback,
        useContext: readContext,
        useEffect: updateEffect,
        useImperativeHandle: updateImperativeHandle,
        useInsertionEffect: updateInsertionEffect,
        useLayoutEffect: updateLayoutEffect,
        useMemo: updateMemo,
        useReducer: rerenderReducer,
        useRef: updateRef,
        useState: function() {
            return rerenderReducer(basicStateReducer);
        },
        useDebugValue: mountDebugValue,
        useDeferredValue: function(value, initialValue) {
            var hook = updateWorkInProgressHook();
            return null === currentHook ? mountDeferredValueImpl(hook, value, initialValue) : updateDeferredValueImpl(hook, currentHook.memoizedState, value, initialValue);
        },
        useTransition: function() {
            var booleanOrThenable = rerenderReducer(basicStateReducer)[0], start = updateWorkInProgressHook().memoizedState;
            return [
                "boolean" === typeof booleanOrThenable ? booleanOrThenable : useThenable(booleanOrThenable),
                start
            ];
        },
        useSyncExternalStore: updateSyncExternalStore,
        useId: updateId,
        useHostTransitionStatus: useHostTransitionStatus,
        useFormState: rerenderActionState,
        useActionState: rerenderActionState,
        useOptimistic: function(passthrough, reducer) {
            var hook = updateWorkInProgressHook();
            if (null !== currentHook) return updateOptimisticImpl(hook, currentHook, passthrough, reducer);
            hook.baseState = passthrough;
            return [
                passthrough,
                hook.queue.dispatch
            ];
        },
        useMemoCache: useMemoCache,
        useCacheRefresh: updateRefresh
    };
    HooksDispatcherOnRerender.useEffectEvent = updateEvent;
    var classComponentUpdater = {
        enqueueSetState: function(inst, payload, callback) {
            inst = inst._reactInternals;
            var lane = requestUpdateLane(), update = createUpdate(lane);
            update.payload = payload;
            void 0 !== callback && null !== callback && (update.callback = callback);
            payload = enqueueUpdate(inst, update, lane);
            null !== payload && (scheduleUpdateOnFiber(payload, inst, lane), entangleTransitions(payload, inst, lane));
        },
        enqueueReplaceState: function(inst, payload, callback) {
            inst = inst._reactInternals;
            var lane = requestUpdateLane(), update = createUpdate(lane);
            update.tag = 1;
            update.payload = payload;
            void 0 !== callback && null !== callback && (update.callback = callback);
            payload = enqueueUpdate(inst, update, lane);
            null !== payload && (scheduleUpdateOnFiber(payload, inst, lane), entangleTransitions(payload, inst, lane));
        },
        enqueueForceUpdate: function(inst, callback) {
            inst = inst._reactInternals;
            var lane = requestUpdateLane(), update = createUpdate(lane);
            update.tag = 2;
            void 0 !== callback && null !== callback && (update.callback = callback);
            callback = enqueueUpdate(inst, update, lane);
            null !== callback && (scheduleUpdateOnFiber(callback, inst, lane), entangleTransitions(callback, inst, lane));
        }
    }, SelectiveHydrationException = Error(formatProdErrorMessage(461)), didReceiveUpdate = !1, SUSPENDED_MARKER = {
        dehydrated: null,
        treeContext: null,
        retryLane: 0,
        hydrationErrors: null
    }, offscreenSubtreeIsHidden = !1, offscreenSubtreeWasHidden = !1, needsFormReset = !1, PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, nextEffect = null, hostParent = null, hostParentIsContainer = !1, currentHoistableRoot = null, suspenseyCommitFlag = 8192, DefaultAsyncDispatcher = {
        getCacheForType: function(resourceType) {
            var cache = readContext(CacheContext), cacheForType = cache.data.get(resourceType);
            void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
            return cacheForType;
        },
        cacheSignal: function() {
            return readContext(CacheContext).controller.signal;
        }
    }, COMPONENT_TYPE = 0, HAS_PSEUDO_CLASS_TYPE = 1, ROLE_TYPE = 2, TEST_NAME_TYPE = 3, TEXT_TYPE = 4;
    if ("function" === typeof Symbol && Symbol.for) {
        var symbolFor = Symbol.for;
        COMPONENT_TYPE = symbolFor("selector.component");
        HAS_PSEUDO_CLASS_TYPE = symbolFor("selector.has_pseudo_class");
        ROLE_TYPE = symbolFor("selector.role");
        TEST_NAME_TYPE = symbolFor("selector.test_id");
        TEXT_TYPE = symbolFor("selector.text");
    }
    var PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, executionContext = 0, workInProgressRoot = null, workInProgress = null, workInProgressRootRenderLanes = 0, workInProgressSuspendedReason = 0, workInProgressThrownValue = null, workInProgressRootDidSkipSuspendedSiblings = !1, workInProgressRootIsPrerendering = !1, workInProgressRootDidAttachPingListener = !1, entangledRenderLanes = 0, workInProgressRootExitStatus = 0, workInProgressRootSkippedLanes = 0, workInProgressRootInterleavedUpdatedLanes = 0, workInProgressRootPingedLanes = 0, workInProgressDeferredLane = 0, workInProgressSuspendedRetryLanes = 0, workInProgressRootConcurrentErrors = null, workInProgressRootRecoverableErrors = null, workInProgressRootDidIncludeRecursiveRenderUpdate = !1, globalMostRecentFallbackTime = 0, globalMostRecentTransitionTime = 0, workInProgressRootRenderTargetTime = Infinity, workInProgressTransitions = null, legacyErrorBoundariesThatAlreadyFailed = null, pendingEffectsStatus = 0, pendingEffectsRoot = null, pendingFinishedWork = null, pendingEffectsLanes = 0, pendingEffectsRemainingLanes = 0, pendingPassiveTransitions = null, pendingRecoverableErrors = null, nestedUpdateCount = 0, rootWithNestedUpdates = null;
    exports.attemptContinuousHydration = function(fiber) {
        if (13 === fiber.tag || 31 === fiber.tag) {
            var root = enqueueConcurrentRenderForLane(fiber, 67108864);
            null !== root && scheduleUpdateOnFiber(root, fiber, 67108864);
            markRetryLaneIfNotHydrated(fiber, 67108864);
        }
    };
    exports.attemptHydrationAtCurrentPriority = function(fiber) {
        if (13 === fiber.tag || 31 === fiber.tag) {
            var lane = requestUpdateLane();
            lane = getBumpedLaneForHydrationByLane(lane);
            var root = enqueueConcurrentRenderForLane(fiber, lane);
            null !== root && scheduleUpdateOnFiber(root, fiber, lane);
            markRetryLaneIfNotHydrated(fiber, lane);
        }
    };
    exports.attemptSynchronousHydration = function(fiber) {
        switch(fiber.tag){
            case 3:
                fiber = fiber.stateNode;
                if (fiber.current.memoizedState.isDehydrated) {
                    var lanes = getHighestPriorityLanes(fiber.pendingLanes);
                    if (0 !== lanes) {
                        fiber.pendingLanes |= 2;
                        for(fiber.entangledLanes |= 2; lanes;){
                            var lane = 1 << 31 - clz32(lanes);
                            fiber.entanglements[1] |= lane;
                            lanes &= ~lane;
                        }
                        ensureRootIsScheduled(fiber);
                        0 === (executionContext & 6) && (workInProgressRootRenderTargetTime = now() + 500, flushSyncWorkAcrossRoots_impl(0, !1));
                    }
                }
                break;
            case 31:
            case 13:
                lanes = enqueueConcurrentRenderForLane(fiber, 2), null !== lanes && scheduleUpdateOnFiber(lanes, fiber, 2), flushSyncWork(), markRetryLaneIfNotHydrated(fiber, 2);
        }
    };
    exports.batchedUpdates = function(fn, a) {
        return fn(a);
    };
    exports.createComponentSelector = function(component) {
        return {
            $$typeof: COMPONENT_TYPE,
            value: component
        };
    };
    exports.createContainer = function(containerInfo, tag, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
        return createFiberRoot(containerInfo, tag, !1, null, hydrationCallbacks, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator);
    };
    exports.createHasPseudoClassSelector = function(selectors) {
        return {
            $$typeof: HAS_PSEUDO_CLASS_TYPE,
            value: selectors
        };
    };
    exports.createHydrationContainer = function(initialChildren, callback, containerInfo, tag, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, transitionCallbacks, formState) {
        initialChildren = createFiberRoot(containerInfo, tag, !0, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator);
        initialChildren.context = getContextForSubtree(null);
        containerInfo = initialChildren.current;
        tag = requestUpdateLane();
        tag = getBumpedLaneForHydrationByLane(tag);
        hydrationCallbacks = createUpdate(tag);
        hydrationCallbacks.callback = void 0 !== callback && null !== callback ? callback : null;
        enqueueUpdate(containerInfo, hydrationCallbacks, tag);
        callback = tag;
        initialChildren.current.lanes = callback;
        markRootUpdated$1(initialChildren, callback);
        ensureRootIsScheduled(initialChildren);
        return initialChildren;
    };
    exports.createPortal = function(children, containerInfo, implementation) {
        var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
        return {
            $$typeof: REACT_PORTAL_TYPE,
            key: null == key ? null : "" + key,
            children: children,
            containerInfo: containerInfo,
            implementation: implementation
        };
    };
    exports.createRoleSelector = function(role) {
        return {
            $$typeof: ROLE_TYPE,
            value: role
        };
    };
    exports.createTestNameSelector = function(id) {
        return {
            $$typeof: TEST_NAME_TYPE,
            value: id
        };
    };
    exports.createTextSelector = function(text) {
        return {
            $$typeof: TEXT_TYPE,
            value: text
        };
    };
    exports.defaultOnCaughtError = function(error) {
        console.error(error);
    };
    exports.defaultOnRecoverableError = function(error) {
        reportGlobalError(error);
    };
    exports.defaultOnUncaughtError = function(error) {
        reportGlobalError(error);
    };
    exports.deferredUpdates = function(fn) {
        var prevTransition = ReactSharedInternals.T, previousPriority = getCurrentUpdatePriority();
        try {
            return setCurrentUpdatePriority(32), ReactSharedInternals.T = null, fn();
        } finally{
            setCurrentUpdatePriority(previousPriority), ReactSharedInternals.T = prevTransition;
        }
    };
    exports.discreteUpdates = function(fn, a, b, c, d) {
        var prevTransition = ReactSharedInternals.T, previousPriority = getCurrentUpdatePriority();
        try {
            return setCurrentUpdatePriority(2), ReactSharedInternals.T = null, fn(a, b, c, d);
        } finally{
            setCurrentUpdatePriority(previousPriority), ReactSharedInternals.T = prevTransition, 0 === executionContext && (workInProgressRootRenderTargetTime = now() + 500);
        }
    };
    exports.findAllNodes = findAllNodes;
    exports.findBoundingRects = function(hostRoot, selectors) {
        if (!supportsTestSelectors) throw Error(formatProdErrorMessage(363));
        selectors = findAllNodes(hostRoot, selectors);
        hostRoot = [];
        for(var i = 0; i < selectors.length; i++)hostRoot.push(getBoundingRect(selectors[i]));
        for(selectors = hostRoot.length - 1; 0 < selectors; selectors--){
            i = hostRoot[selectors];
            for(var targetLeft = i.x, targetRight = targetLeft + i.width, targetTop = i.y, targetBottom = targetTop + i.height, j = selectors - 1; 0 <= j; j--)if (selectors !== j) {
                var otherRect = hostRoot[j], otherLeft = otherRect.x, otherRight = otherLeft + otherRect.width, otherTop = otherRect.y, otherBottom = otherTop + otherRect.height;
                if (targetLeft >= otherLeft && targetTop >= otherTop && targetRight <= otherRight && targetBottom <= otherBottom) {
                    hostRoot.splice(selectors, 1);
                    break;
                } else if (!(targetLeft !== otherLeft || i.width !== otherRect.width || otherBottom < targetTop || otherTop > targetBottom)) {
                    otherTop > targetTop && (otherRect.height += otherTop - targetTop, otherRect.y = targetTop);
                    otherBottom < targetBottom && (otherRect.height = targetBottom - otherTop);
                    hostRoot.splice(selectors, 1);
                    break;
                } else if (!(targetTop !== otherTop || i.height !== otherRect.height || otherRight < targetLeft || otherLeft > targetRight)) {
                    otherLeft > targetLeft && (otherRect.width += otherLeft - targetLeft, otherRect.x = targetLeft);
                    otherRight < targetRight && (otherRect.width = targetRight - otherLeft);
                    hostRoot.splice(selectors, 1);
                    break;
                }
            }
        }
        return hostRoot;
    };
    exports.findHostInstance = findHostInstance;
    exports.findHostInstanceWithNoPortals = function(fiber) {
        fiber = findCurrentFiberUsingSlowPath(fiber);
        fiber = null !== fiber ? findCurrentHostFiberWithNoPortalsImpl(fiber) : null;
        return null === fiber ? null : getPublicInstance(fiber.stateNode);
    };
    exports.findHostInstanceWithWarning = function(component) {
        return findHostInstance(component);
    };
    exports.flushPassiveEffects = flushPendingEffects;
    exports.flushSyncFromReconciler = function(fn) {
        var prevExecutionContext = executionContext;
        executionContext |= 1;
        var prevTransition = ReactSharedInternals.T, previousPriority = getCurrentUpdatePriority();
        try {
            if (setCurrentUpdatePriority(2), ReactSharedInternals.T = null, fn) return fn();
        } finally{
            setCurrentUpdatePriority(previousPriority), ReactSharedInternals.T = prevTransition, executionContext = prevExecutionContext, 0 === (executionContext & 6) && flushSyncWorkAcrossRoots_impl(0, !1);
        }
    };
    exports.flushSyncWork = flushSyncWork;
    exports.focusWithin = function(hostRoot, selectors) {
        if (!supportsTestSelectors) throw Error(formatProdErrorMessage(363));
        hostRoot = findFiberRootForHostRoot(hostRoot);
        selectors = findPaths(hostRoot, selectors);
        selectors = Array.from(selectors);
        for(hostRoot = 0; hostRoot < selectors.length;){
            var fiber = selectors[hostRoot++], tag = fiber.tag;
            if (!isHiddenSubtree(fiber)) {
                if ((5 === tag || 26 === tag || 27 === tag) && setFocusIfFocusable(fiber.stateNode)) return !0;
                for(fiber = fiber.child; null !== fiber;)selectors.push(fiber), fiber = fiber.sibling;
            }
        }
        return !1;
    };
    exports.getFindAllNodesFailureDescription = function(hostRoot, selectors) {
        if (!supportsTestSelectors) throw Error(formatProdErrorMessage(363));
        var maxSelectorIndex = 0, matchedNames = [];
        hostRoot = [
            findFiberRootForHostRoot(hostRoot),
            0
        ];
        for(var index = 0; index < hostRoot.length;){
            var fiber = hostRoot[index++], tag = fiber.tag, selectorIndex = hostRoot[index++], selector = selectors[selectorIndex];
            if (5 !== tag && 26 !== tag && 27 !== tag || !isHiddenSubtree(fiber)) {
                if (matchSelector(fiber, selector) && (matchedNames.push(selectorToString(selector)), selectorIndex++, selectorIndex > maxSelectorIndex && (maxSelectorIndex = selectorIndex)), selectorIndex < selectors.length) for(fiber = fiber.child; null !== fiber;)hostRoot.push(fiber, selectorIndex), fiber = fiber.sibling;
            }
        }
        if (maxSelectorIndex < selectors.length) {
            for(hostRoot = []; maxSelectorIndex < selectors.length; maxSelectorIndex++)hostRoot.push(selectorToString(selectors[maxSelectorIndex]));
            return "findAllNodes was able to match part of the selector:\n  " + (matchedNames.join(" > ") + "\n\nNo matching component was found for:\n  ") + hostRoot.join(" > ");
        }
        return null;
    };
    exports.getPublicRootInstance = function(container) {
        container = container.current;
        if (!container.child) return null;
        switch(container.child.tag){
            case 27:
            case 5:
                return getPublicInstance(container.child.stateNode);
            default:
                return container.child.stateNode;
        }
    };
    exports.injectIntoDevTools = function() {
        var internals = {
            bundleType: 0,
            version: rendererVersion,
            rendererPackageName: rendererPackageName,
            currentDispatcherRef: ReactSharedInternals,
            reconcilerVersion: "19.2.0"
        };
        null !== extraDevToolsConfig && (internals.rendererConfig = extraDevToolsConfig);
        if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) internals = !1;
        else {
            var hook = __REACT_DEVTOOLS_GLOBAL_HOOK__;
            if (hook.isDisabled || !hook.supportsFiber) internals = !0;
            else {
                try {
                    rendererID = hook.inject(internals), injectedHook = hook;
                } catch (err) {}
                internals = hook.checkDCE ? !0 : !1;
            }
        }
        return internals;
    };
    exports.isAlreadyRendering = function() {
        return 0 !== (executionContext & 6);
    };
    exports.observeVisibleRects = function(hostRoot, selectors, callback, options) {
        if (!supportsTestSelectors) throw Error(formatProdErrorMessage(363));
        hostRoot = findAllNodes(hostRoot, selectors);
        var disconnect = setupIntersectionObserver(hostRoot, callback, options).disconnect;
        return {
            disconnect: function() {
                disconnect();
            }
        };
    };
    exports.shouldError = function() {
        return null;
    };
    exports.shouldSuspend = function() {
        return !1;
    };
    exports.startHostTransition = function(formFiber, pendingState, action, formData) {
        if (5 !== formFiber.tag) throw Error(formatProdErrorMessage(476));
        var queue = ensureFormComponentIsStateful(formFiber).queue;
        startTransition(formFiber, queue, pendingState, NotPendingTransition, null === action ? noop : function() {
            var stateHook = ensureFormComponentIsStateful(formFiber);
            null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
            dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, requestUpdateLane());
            return action(formData);
        });
    };
    exports.updateContainer = function(element, container, parentComponent, callback) {
        var current = container.current, lane = requestUpdateLane();
        updateContainerImpl(current, lane, element, container, parentComponent, callback);
        return lane;
    };
    exports.updateContainerSync = function(element, container, parentComponent, callback) {
        updateContainerImpl(container.current, 2, element, container, parentComponent, callback);
        return 2;
    };
    return exports;
};
module.exports.default = module.exports;
Object.defineProperty(module.exports, "__esModule", {
    value: !0
});

});

parcelRegister("lL7Ui", function(module, exports) {

$parcel$export(module.exports, "ConcurrentRoot", function () { return $fd741eef7edae142$export$816aac48d41c2f81; }, function (v) { return $fd741eef7edae142$export$816aac48d41c2f81 = v; });
$parcel$export(module.exports, "ContinuousEventPriority", function () { return $fd741eef7edae142$export$3bb88615cd12cb3b; }, function (v) { return $fd741eef7edae142$export$3bb88615cd12cb3b = v; });
$parcel$export(module.exports, "DefaultEventPriority", function () { return $fd741eef7edae142$export$d46163d5c045f347; }, function (v) { return $fd741eef7edae142$export$d46163d5c045f347 = v; });
$parcel$export(module.exports, "DiscreteEventPriority", function () { return $fd741eef7edae142$export$8ee75c97f0333f15; }, function (v) { return $fd741eef7edae142$export$8ee75c97f0333f15 = v; });
$parcel$export(module.exports, "IdleEventPriority", function () { return $fd741eef7edae142$export$d1c113b83e1f881a; }, function (v) { return $fd741eef7edae142$export$d1c113b83e1f881a = v; });
$parcel$export(module.exports, "LegacyRoot", function () { return $fd741eef7edae142$export$ff78c4883554845d; }, function (v) { return $fd741eef7edae142$export$ff78c4883554845d = v; });
$parcel$export(module.exports, "NoEventPriority", function () { return $fd741eef7edae142$export$affca60ecfa921c7; }, function (v) { return $fd741eef7edae142$export$affca60ecfa921c7 = v; });
/**
 * @license React
 * react-reconciler-constants.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $fd741eef7edae142$export$816aac48d41c2f81;
var $fd741eef7edae142$export$3bb88615cd12cb3b;
var $fd741eef7edae142$export$d46163d5c045f347;
var $fd741eef7edae142$export$8ee75c97f0333f15;
var $fd741eef7edae142$export$d1c113b83e1f881a;
var $fd741eef7edae142$export$ff78c4883554845d;
var $fd741eef7edae142$export$affca60ecfa921c7;
"use strict";
$fd741eef7edae142$export$816aac48d41c2f81 = 1;
$fd741eef7edae142$export$3bb88615cd12cb3b = 8;
$fd741eef7edae142$export$d46163d5c045f347 = 32;
$fd741eef7edae142$export$8ee75c97f0333f15 = 2;
$fd741eef7edae142$export$d1c113b83e1f881a = 268435456;
$fd741eef7edae142$export$ff78c4883554845d = 0;
$fd741eef7edae142$export$affca60ecfa921c7 = 0;

});

parcelRegister("dAj32", function(module, exports) {

var $6LAMD = parcelRequire("6LAMD");
module.exports = $6LAMD("02Igr").then(()=>parcelRequire("1rWdC"));

});
parcelRegister("6LAMD", function(module, exports) {
"use strict";

function $4ed3aa4aed78948a$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("6n3dX")).resolve(id));
}
module.exports = $4ed3aa4aed78948a$var$load;

});


// Design tokens first: the custom properties, the minimal reset and the base type rule become
// available app-wide. Single source of truth, shared verbatim with the design mockups
// (docs/design/spec/01-foundations.md).
//
// The legacy cascade that used to sit here — Bootstrap's CSS, `assets/css/{app,style,modern-theme}.css`
// and three self-hosted font families (Roboto, HelveticaNeue, Font Awesome) — is gone with the
// screens that needed it. Between them they were ~16,600 lines of which under 10% was still
// reachable, and they were a live source of bugs: bare `label` / `h5` / `thead` rules leaked into
// every antd control (see the fences that used to live in theme/antd.scss).
var $575603080129eb00$exports = {};
"use strict";

$575603080129eb00$exports = (parcelRequire("aTPuV"));








parcelRequire("cQmXV");
var $3e75b56ae88591f4$exports = {};
"use strict";
function $3e75b56ae88591f4$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($3e75b56ae88591f4$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$3e75b56ae88591f4$var$checkDCE();

$3e75b56ae88591f4$exports = (parcelRequire("bhIuc"));



var $cQmXV = parcelRequire("cQmXV");
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $6ed32536c828ace4$var$murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}
var $6ed32536c828ace4$export$2e2bcd8739ae039 = $6ed32536c828ace4$var$murmur2;


function $78361969822ad097$export$2e2bcd8739ae039() {
    return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}


function $2971d4d077005d97$export$2e2bcd8739ae039(root, n) {
    if (!root) return false;
    // Use native if support
    if (root.contains) return root.contains(n);
    // `document.contains` not support with IE11
    let node = n;
    while(node){
        if (node === root) return true;
        node = node.parentNode;
    }
    return false;
}


const $449b73243fa975a1$var$APPEND_ORDER = "data-rc-order";
const $449b73243fa975a1$var$APPEND_PRIORITY = "data-rc-priority";
const $449b73243fa975a1$var$MARK_KEY = `rc-util-key`;
const $449b73243fa975a1$var$containerCache = new Map();
function $449b73243fa975a1$var$getMark({ mark: mark } = {}) {
    if (mark) return mark.startsWith("data-") ? mark : `data-${mark}`;
    return $449b73243fa975a1$var$MARK_KEY;
}
function $449b73243fa975a1$var$getContainer(option) {
    if (option.attachTo) return option.attachTo;
    const head = document.querySelector("head");
    return head || document.body;
}
function $449b73243fa975a1$var$getOrder(prepend) {
    if (prepend === "queue") return "prependQueue";
    return prepend ? "prepend" : "append";
}
/**
 * Find style which inject by rc-util
 */ function $449b73243fa975a1$var$findStyles(container) {
    return Array.from(($449b73243fa975a1$var$containerCache.get(container) || container).children).filter((node)=>node.tagName === "STYLE");
}
function $449b73243fa975a1$export$1ab5838465dbd10a(css, option = {}) {
    if (!(0, $78361969822ad097$export$2e2bcd8739ae039)()) return null;
    const { csp: csp, prepend: prepend, priority: priority = 0 } = option;
    const mergedOrder = $449b73243fa975a1$var$getOrder(prepend);
    const isPrependQueue = mergedOrder === "prependQueue";
    const styleNode = document.createElement("style");
    styleNode.setAttribute($449b73243fa975a1$var$APPEND_ORDER, mergedOrder);
    if (isPrependQueue && priority) styleNode.setAttribute($449b73243fa975a1$var$APPEND_PRIORITY, `${priority}`);
    if (csp?.nonce) styleNode.nonce = csp?.nonce;
    styleNode.innerHTML = css;
    const container = $449b73243fa975a1$var$getContainer(option);
    const { firstChild: firstChild } = container;
    if (prepend) {
        // If is queue `prepend`, it will prepend first style and then append rest style
        if (isPrependQueue) {
            const existStyle = (option.styles || $449b73243fa975a1$var$findStyles(container)).filter((node)=>{
                // Ignore style which not injected by rc-util with prepend
                if (![
                    "prepend",
                    "prependQueue"
                ].includes(node.getAttribute($449b73243fa975a1$var$APPEND_ORDER))) return false;
                // Ignore style which priority less then new style
                const nodePriority = Number(node.getAttribute($449b73243fa975a1$var$APPEND_PRIORITY) || 0);
                return priority >= nodePriority;
            });
            if (existStyle.length) {
                container.insertBefore(styleNode, existStyle[existStyle.length - 1].nextSibling);
                return styleNode;
            }
        }
        // Use `insertBefore` as `prepend`
        container.insertBefore(styleNode, firstChild);
    } else container.appendChild(styleNode);
    return styleNode;
}
function $449b73243fa975a1$var$findExistNode(key, option = {}) {
    let { styles: styles } = option;
    styles ||= $449b73243fa975a1$var$findStyles($449b73243fa975a1$var$getContainer(option));
    return styles.find((node)=>node.getAttribute($449b73243fa975a1$var$getMark(option)) === key);
}
function $449b73243fa975a1$export$2232e336aecaa80a(key, option = {}) {
    const existNode = $449b73243fa975a1$var$findExistNode(key, option);
    if (existNode) {
        const container = $449b73243fa975a1$var$getContainer(option);
        container.removeChild(existNode);
    }
}
/**
 * qiankun will inject `appendChild` to insert into other
 */ function $449b73243fa975a1$var$syncRealContainer(container, option) {
    const cachedRealContainer = $449b73243fa975a1$var$containerCache.get(container);
    // Find real container when not cached or cached container removed
    if (!cachedRealContainer || !(0, $2971d4d077005d97$export$2e2bcd8739ae039)(document, cachedRealContainer)) {
        const placeholderStyle = $449b73243fa975a1$export$1ab5838465dbd10a("", option);
        const { parentNode: parentNode } = placeholderStyle;
        $449b73243fa975a1$var$containerCache.set(container, parentNode);
        container.removeChild(placeholderStyle);
    }
}
function $449b73243fa975a1$export$f80df667f2f5a272() {
    $449b73243fa975a1$var$containerCache.clear();
}
function $449b73243fa975a1$export$4d99a2890bb989f0(css, key, originOption = {}) {
    const container = $449b73243fa975a1$var$getContainer(originOption);
    const styles = $449b73243fa975a1$var$findStyles(container);
    const option = {
        ...originOption,
        styles: styles
    };
    // Sync real parent
    $449b73243fa975a1$var$syncRealContainer(container, option);
    const existNode = $449b73243fa975a1$var$findExistNode(key, option);
    if (existNode) {
        if (option.csp?.nonce && existNode.nonce !== option.csp?.nonce) existNode.nonce = option.csp?.nonce;
        if (existNode.innerHTML !== css) existNode.innerHTML = css;
        return existNode;
    }
    const newNode = $449b73243fa975a1$export$1ab5838465dbd10a(css, option);
    newNode.setAttribute($449b73243fa975a1$var$getMark(option), key);
    return newNode;
}



var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");
function $d627c2941353b4cb$export$2e2bcd8739ae039(getValue, condition, shouldUpdate) {
    const cacheRef = $cQmXV.useRef({});
    if (!("value" in cacheRef.current) || shouldUpdate(cacheRef.current.condition, condition)) {
        cacheRef.current.value = getValue();
        cacheRef.current.condition = condition;
    }
    return cacheRef.current.value;
}


/* eslint-disable no-console */ let $26d7cf6379fe7659$var$warned = {};
const $26d7cf6379fe7659$var$preWarningFns = [];
const $26d7cf6379fe7659$export$61616f168f0e5a05 = (fn)=>{
    $26d7cf6379fe7659$var$preWarningFns.push(fn);
};
function $26d7cf6379fe7659$export$491112666e282270(valid, message) {}
function $26d7cf6379fe7659$export$a92e4c44d367d0af(valid, message) {}
function $26d7cf6379fe7659$export$60eef1277fe463e4() {
    $26d7cf6379fe7659$var$warned = {};
}
function $26d7cf6379fe7659$export$848feb93d8f32b9b(method, valid, message) {
    if (!valid && !$26d7cf6379fe7659$var$warned[message]) {
        method(false, message);
        $26d7cf6379fe7659$var$warned[message] = true;
    }
}
function $26d7cf6379fe7659$export$82934adf09101657(valid, message) {
    $26d7cf6379fe7659$export$848feb93d8f32b9b($26d7cf6379fe7659$export$491112666e282270, valid, message);
}
function $26d7cf6379fe7659$export$89ff31684837bbbf(valid, message) {
    $26d7cf6379fe7659$export$848feb93d8f32b9b($26d7cf6379fe7659$export$a92e4c44d367d0af, valid, message);
}
$26d7cf6379fe7659$export$82934adf09101657.preMessage = $26d7cf6379fe7659$export$61616f168f0e5a05;
$26d7cf6379fe7659$export$82934adf09101657.resetWarned = $26d7cf6379fe7659$export$60eef1277fe463e4;
$26d7cf6379fe7659$export$82934adf09101657.noteOnce = $26d7cf6379fe7659$export$89ff31684837bbbf;
var $26d7cf6379fe7659$export$2e2bcd8739ae039 = $26d7cf6379fe7659$export$82934adf09101657;


/**
 * Deeply compares two object literals.
 * @param obj1 object 1
 * @param obj2 object 2
 * @param shallow shallow compare
 * @returns
 */ function $3f19ee2a2ff4618a$var$isEqual(obj1, obj2, shallow = false) {
    // https://github.com/mapbox/mapbox-gl-js/pull/5979/files#diff-fde7145050c47cc3a306856efd5f9c3016e86e859de9afbd02c879be5067e58f
    const refSet = new Set();
    function deepEqual(a, b, level = 1) {
        const circular = refSet.has(a);
        (0, $26d7cf6379fe7659$export$2e2bcd8739ae039)(!circular, "Warning: There may be circular references");
        if (circular) return false;
        if (a === b) return true;
        if (shallow && level > 1) return false;
        refSet.add(a);
        const newLevel = level + 1;
        if (Array.isArray(a)) {
            if (!Array.isArray(b) || a.length !== b.length) return false;
            for(let i = 0; i < a.length; i++){
                if (!deepEqual(a[i], b[i], newLevel)) return false;
            }
            return true;
        }
        if (a && b && typeof a === "object" && typeof b === "object") {
            const keys = Object.keys(a);
            if (keys.length !== Object.keys(b).length) return false;
            return keys.every((key)=>deepEqual(a[key], b[key], newLevel));
        }
        // other
        return false;
    }
    return deepEqual(obj1, obj2);
}
var $3f19ee2a2ff4618a$export$2e2bcd8739ae039 = $3f19ee2a2ff4618a$var$isEqual;



var $cQmXV = parcelRequire("cQmXV");
// [times, realValue]
const $5b367ab252324f7b$var$SPLIT = "%";
function $5b367ab252324f7b$export$1d14e1d8187b9aad(keys) {
    return keys.join($5b367ab252324f7b$var$SPLIT);
}
/** Record update id for extract static style order. */ let $5b367ab252324f7b$var$updateId = 0;
class $5b367ab252324f7b$var$Entity {
    instanceId;
    constructor(instanceId){
        this.instanceId = instanceId;
    }
    /** @private Internal cache map. Do not access this directly */ cache = new Map();
    /** @private Record update times for each key */ updateTimes = new Map();
    extracted = new Set();
    get(keys) {
        return this.opGet($5b367ab252324f7b$export$1d14e1d8187b9aad(keys));
    }
    /** A fast get cache with `get` concat. */ opGet(keyPathStr) {
        return this.cache.get(keyPathStr) || null;
    }
    update(keys, valueFn) {
        return this.opUpdate($5b367ab252324f7b$export$1d14e1d8187b9aad(keys), valueFn);
    }
    /** A fast get cache with `get` concat. */ opUpdate(keyPathStr, valueFn) {
        const prevValue = this.cache.get(keyPathStr);
        const nextValue = valueFn(prevValue);
        if (nextValue === null) {
            this.cache.delete(keyPathStr);
            this.updateTimes.delete(keyPathStr);
        } else {
            this.cache.set(keyPathStr, nextValue);
            this.updateTimes.set(keyPathStr, $5b367ab252324f7b$var$updateId);
            $5b367ab252324f7b$var$updateId += 1;
        }
    }
}
var $5b367ab252324f7b$export$2e2bcd8739ae039 = $5b367ab252324f7b$var$Entity;


const $ff03b68c6009e469$export$3a1a912fd9fd3325 = {};
const $ff03b68c6009e469$var$transform = $ff03b68c6009e469$export$3a1a912fd9fd3325;
var $ff03b68c6009e469$export$2e2bcd8739ae039 = $ff03b68c6009e469$var$transform;


const $21cab3db22272d25$export$5d99297dcd5476ac = "data-token-hash";
const $21cab3db22272d25$export$89ce1123b3c0bd9e = "data-css-hash";
const $21cab3db22272d25$export$36f8a6c9fa24262a = "data-cache-path";
const $21cab3db22272d25$export$4c16a0c02134a7dc = "__cssinjs_instance__";
function $21cab3db22272d25$export$cf6fa0bbcc94b912() {
    const cssinjsInstanceId = Math.random().toString(12).slice(2);
    // Tricky SSR: Move all inline style to the head.
    // PS: We do not recommend tricky mode.
    if (typeof document !== "undefined" && document.head && document.body) {
        const styles = document.body.querySelectorAll(`style[${$21cab3db22272d25$export$89ce1123b3c0bd9e}]`) || [];
        const { firstChild: firstChild } = document.head;
        Array.from(styles).forEach((style)=>{
            style[$21cab3db22272d25$export$4c16a0c02134a7dc] ||= cssinjsInstanceId;
            // Not force move if no head
            if (style[$21cab3db22272d25$export$4c16a0c02134a7dc] === cssinjsInstanceId) document.head.insertBefore(style, firstChild);
        });
        // Deduplicate of moved styles
        const styleHash = {};
        Array.from(document.querySelectorAll(`style[${$21cab3db22272d25$export$89ce1123b3c0bd9e}]`)).forEach((style)=>{
            const hash = style.getAttribute($21cab3db22272d25$export$89ce1123b3c0bd9e);
            if (styleHash[hash]) {
                if (style[$21cab3db22272d25$export$4c16a0c02134a7dc] === cssinjsInstanceId) style.parentNode?.removeChild(style);
            } else styleHash[hash] = true;
        });
    }
    return new (0, $5b367ab252324f7b$export$2e2bcd8739ae039)(cssinjsInstanceId);
}
const $21cab3db22272d25$var$StyleContext = /*#__PURE__*/ $cQmXV.createContext({
    hashPriority: "low",
    cache: $21cab3db22272d25$export$cf6fa0bbcc94b912(),
    defaultCache: true,
    autoPrefix: false
});
const $21cab3db22272d25$export$6aedb87c7b665270 = (props)=>{
    const { children: children, ...restProps } = props;
    const parentContext = $cQmXV.useContext($21cab3db22272d25$var$StyleContext);
    const context = (0, $d627c2941353b4cb$export$2e2bcd8739ae039)(()=>{
        const mergedContext = {
            ...parentContext
        };
        Object.keys(restProps).forEach((key)=>{
            const value = restProps[key];
            if (restProps[key] !== undefined) mergedContext[key] = value;
        });
        const { cache: cache, transformers: transformers = [] } = restProps;
        mergedContext.cache = mergedContext.cache || $21cab3db22272d25$export$cf6fa0bbcc94b912();
        mergedContext.defaultCache = !cache && parentContext.defaultCache;
        // autoPrefix
        if (transformers.includes((0, $ff03b68c6009e469$export$3a1a912fd9fd3325))) mergedContext.autoPrefix = true;
        return mergedContext;
    }, [
        parentContext,
        restProps
    ], (prev, next)=>!(0, $3f19ee2a2ff4618a$export$2e2bcd8739ae039)(prev[0], next[0], true) || !(0, $3f19ee2a2ff4618a$export$2e2bcd8739ae039)(prev[1], next[1], true));
    return /*#__PURE__*/ $cQmXV.createElement($21cab3db22272d25$var$StyleContext.Provider, {
        value: context
    }, children);
};
var $21cab3db22272d25$export$2e2bcd8739ae039 = $21cab3db22272d25$var$StyleContext;






class $96e374f873ed75c8$var$AbstractCalculator {
}
var $96e374f873ed75c8$export$2e2bcd8739ae039 = $96e374f873ed75c8$var$AbstractCalculator;


const $ffd5fafce3adfb79$var$CALC_UNIT = "CALC_UNIT";
const $ffd5fafce3adfb79$var$regexp = new RegExp($ffd5fafce3adfb79$var$CALC_UNIT, "g");
function $ffd5fafce3adfb79$var$unit(value) {
    if (typeof value === "number") return `${value}${$ffd5fafce3adfb79$var$CALC_UNIT}`;
    return value;
}
class $ffd5fafce3adfb79$export$2e2bcd8739ae039 extends (0, $96e374f873ed75c8$export$2e2bcd8739ae039) {
    result = "";
    unitlessCssVar;
    lowPriority;
    constructor(num, unitlessCssVar){
        super();
        const numType = typeof num;
        this.unitlessCssVar = unitlessCssVar;
        if (num instanceof $ffd5fafce3adfb79$export$2e2bcd8739ae039) this.result = `(${num.result})`;
        else if (numType === "number") this.result = $ffd5fafce3adfb79$var$unit(num);
        else if (numType === "string") this.result = num;
    }
    add(num) {
        if (num instanceof $ffd5fafce3adfb79$export$2e2bcd8739ae039) this.result = `${this.result} + ${num.getResult()}`;
        else if (typeof num === "number" || typeof num === "string") this.result = `${this.result} + ${$ffd5fafce3adfb79$var$unit(num)}`;
        this.lowPriority = true;
        return this;
    }
    sub(num) {
        if (num instanceof $ffd5fafce3adfb79$export$2e2bcd8739ae039) this.result = `${this.result} - ${num.getResult()}`;
        else if (typeof num === "number" || typeof num === "string") this.result = `${this.result} - ${$ffd5fafce3adfb79$var$unit(num)}`;
        this.lowPriority = true;
        return this;
    }
    mul(num) {
        if (this.lowPriority) this.result = `(${this.result})`;
        if (num instanceof $ffd5fafce3adfb79$export$2e2bcd8739ae039) this.result = `${this.result} * ${num.getResult(true)}`;
        else if (typeof num === "number" || typeof num === "string") this.result = `${this.result} * ${num}`;
        this.lowPriority = false;
        return this;
    }
    div(num) {
        if (this.lowPriority) this.result = `(${this.result})`;
        if (num instanceof $ffd5fafce3adfb79$export$2e2bcd8739ae039) this.result = `${this.result} / ${num.getResult(true)}`;
        else if (typeof num === "number" || typeof num === "string") this.result = `${this.result} / ${num}`;
        this.lowPriority = false;
        return this;
    }
    getResult(force) {
        return this.lowPriority || force ? `(${this.result})` : this.result;
    }
    equal(options) {
        const { unit: cssUnit } = options || {};
        let mergedUnit = true;
        if (typeof cssUnit === "boolean") mergedUnit = cssUnit;
        else if (Array.from(this.unitlessCssVar).some((cssVar)=>this.result.includes(cssVar))) mergedUnit = false;
        this.result = this.result.replace($ffd5fafce3adfb79$var$regexp, mergedUnit ? "px" : "");
        if (typeof this.lowPriority !== "undefined") return `calc(${this.result})`;
        return this.result;
    }
}



class $d8c8f718c1edc075$export$2e2bcd8739ae039 extends (0, $96e374f873ed75c8$export$2e2bcd8739ae039) {
    result = 0;
    constructor(num){
        super();
        if (num instanceof $d8c8f718c1edc075$export$2e2bcd8739ae039) this.result = num.result;
        else if (typeof num === "number") this.result = num;
    }
    add(num) {
        if (num instanceof $d8c8f718c1edc075$export$2e2bcd8739ae039) this.result += num.result;
        else if (typeof num === "number") this.result += num;
        return this;
    }
    sub(num) {
        if (num instanceof $d8c8f718c1edc075$export$2e2bcd8739ae039) this.result -= num.result;
        else if (typeof num === "number") this.result -= num;
        return this;
    }
    mul(num) {
        if (num instanceof $d8c8f718c1edc075$export$2e2bcd8739ae039) this.result *= num.result;
        else if (typeof num === "number") this.result *= num;
        return this;
    }
    div(num) {
        if (num instanceof $d8c8f718c1edc075$export$2e2bcd8739ae039) this.result /= num.result;
        else if (typeof num === "number") this.result /= num;
        return this;
    }
    equal() {
        return this.result;
    }
}


const $b0a660a4e8c1cdfe$var$genCalc = (type, unitlessCssVar)=>{
    const Calculator = type === "css" ? (0, $ffd5fafce3adfb79$export$2e2bcd8739ae039) : (0, $d8c8f718c1edc075$export$2e2bcd8739ae039);
    return (num)=>new Calculator(num, unitlessCssVar);
};
var $b0a660a4e8c1cdfe$export$2e2bcd8739ae039 = $b0a660a4e8c1cdfe$var$genCalc;


// ================================== Cache ==================================
function $afb98ad8ab1d90bb$export$dd65e95e99ed0739(left, right) {
    if (left.length !== right.length) return false;
    for(let i = 0; i < left.length; i++){
        if (left[i] !== right[i]) return false;
    }
    return true;
}
class $afb98ad8ab1d90bb$export$2e2bcd8739ae039 {
    static MAX_CACHE_SIZE = 20;
    static MAX_CACHE_OFFSET = 5;
    cache;
    keys;
    cacheCallTimes;
    constructor(){
        this.cache = new Map();
        this.keys = [];
        this.cacheCallTimes = 0;
    }
    size() {
        return this.keys.length;
    }
    internalGet(derivativeOption, updateCallTimes = false) {
        let cache = {
            map: this.cache
        };
        derivativeOption.forEach((derivative)=>{
            if (!cache) cache = undefined;
            else cache = cache?.map?.get(derivative);
        });
        if (cache?.value && updateCallTimes) cache.value[1] = this.cacheCallTimes++;
        return cache?.value;
    }
    get(derivativeOption) {
        return this.internalGet(derivativeOption, true)?.[0];
    }
    has(derivativeOption) {
        return !!this.internalGet(derivativeOption);
    }
    set(derivativeOption, value) {
        // New cache
        if (!this.has(derivativeOption)) {
            if (this.size() + 1 > $afb98ad8ab1d90bb$export$2e2bcd8739ae039.MAX_CACHE_SIZE + $afb98ad8ab1d90bb$export$2e2bcd8739ae039.MAX_CACHE_OFFSET) {
                const [targetKey] = this.keys.reduce((result, key)=>{
                    const [, callTimes] = result;
                    if (this.internalGet(key)[1] < callTimes) return [
                        key,
                        this.internalGet(key)[1]
                    ];
                    return result;
                }, [
                    this.keys[0],
                    this.cacheCallTimes
                ]);
                this.delete(targetKey);
            }
            this.keys.push(derivativeOption);
        }
        let cache = this.cache;
        derivativeOption.forEach((derivative, index)=>{
            if (index === derivativeOption.length - 1) cache.set(derivative, {
                value: [
                    value,
                    this.cacheCallTimes++
                ]
            });
            else {
                const cacheValue = cache.get(derivative);
                if (!cacheValue) cache.set(derivative, {
                    map: new Map()
                });
                else if (!cacheValue.map) cacheValue.map = new Map();
                cache = cache.get(derivative).map;
            }
        });
    }
    deleteByPath(currentCache, derivatives) {
        const cache = currentCache.get(derivatives[0]);
        if (derivatives.length === 1) {
            if (!cache.map) currentCache.delete(derivatives[0]);
            else currentCache.set(derivatives[0], {
                map: cache.map
            });
            return cache.value?.[0];
        }
        const result = this.deleteByPath(cache.map, derivatives.slice(1));
        if ((!cache.map || cache.map.size === 0) && !cache.value) currentCache.delete(derivatives[0]);
        return result;
    }
    delete(derivativeOption) {
        // If cache exists
        if (this.has(derivativeOption)) {
            this.keys = this.keys.filter((item)=>!$afb98ad8ab1d90bb$export$dd65e95e99ed0739(item, derivativeOption));
            return this.deleteByPath(this.cache, derivativeOption);
        }
        return undefined;
    }
}



let $87dfc1637ab95ccc$var$uuid = 0;
class $87dfc1637ab95ccc$export$2e2bcd8739ae039 {
    derivatives;
    id;
    constructor(derivatives){
        this.derivatives = Array.isArray(derivatives) ? derivatives : [
            derivatives
        ];
        this.id = $87dfc1637ab95ccc$var$uuid;
        if (derivatives.length === 0) (0, $26d7cf6379fe7659$export$491112666e282270)(derivatives.length > 0, "[Ant Design CSS-in-JS] Theme should have at least one derivative function.");
        $87dfc1637ab95ccc$var$uuid += 1;
    }
    getDerivativeToken(token) {
        return this.derivatives.reduce((result, derivative)=>derivative(token, result), undefined);
    }
}


const $01a2faba6df82710$var$cacheThemes = new (0, $afb98ad8ab1d90bb$export$2e2bcd8739ae039)();
function $01a2faba6df82710$export$2e2bcd8739ae039(derivatives) {
    const derivativeArr = Array.isArray(derivatives) ? derivatives : [
        derivatives
    ];
    // Create new theme if not exist
    if (!$01a2faba6df82710$var$cacheThemes.has(derivativeArr)) $01a2faba6df82710$var$cacheThemes.set(derivativeArr, new (0, $87dfc1637ab95ccc$export$2e2bcd8739ae039)(derivativeArr));
    // Get theme from cache and return
    return $01a2faba6df82710$var$cacheThemes.get(derivativeArr);
}






// Create a cache for memo concat
const $05f34ed03d41967d$var$resultCache = new WeakMap();
const $05f34ed03d41967d$var$RESULT_VALUE = {};
function $05f34ed03d41967d$export$6aabcc1951563d93(callback, deps) {
    let current = $05f34ed03d41967d$var$resultCache;
    for(let i = 0; i < deps.length; i += 1){
        const dep = deps[i];
        if (!current.has(dep)) current.set(dep, new WeakMap());
        current = current.get(dep);
    }
    if (!current.has($05f34ed03d41967d$var$RESULT_VALUE)) current.set($05f34ed03d41967d$var$RESULT_VALUE, callback());
    return current.get($05f34ed03d41967d$var$RESULT_VALUE);
}
// Create a cache here to avoid always loop generate
const $05f34ed03d41967d$var$flattenTokenCache = new WeakMap();
function $05f34ed03d41967d$export$597374558a261efc(token) {
    let str = $05f34ed03d41967d$var$flattenTokenCache.get(token) || "";
    if (!str) {
        Object.keys(token).forEach((key)=>{
            const value = token[key];
            str += key;
            if (value instanceof (0, $87dfc1637ab95ccc$export$2e2bcd8739ae039)) str += value.id;
            else if (value && typeof value === "object") str += $05f34ed03d41967d$export$597374558a261efc(value);
            else str += value;
        });
        // https://github.com/ant-design/ant-design/issues/48386
        // Should hash the string to avoid style tag name too long
        str = (0, $6ed32536c828ace4$export$2e2bcd8739ae039)(str);
        // Put in cache
        $05f34ed03d41967d$var$flattenTokenCache.set(token, str);
    }
    return str;
}
function $05f34ed03d41967d$export$6c82d0ebe8f2ea2c(token, salt) {
    return (0, $6ed32536c828ace4$export$2e2bcd8739ae039)(`${salt}_${$05f34ed03d41967d$export$597374558a261efc(token)}`);
}
const $05f34ed03d41967d$var$randomSelectorKey = `random-${Date.now()}-${Math.random()}`.replace(/\./g, "");
// Magic `content` for detect selector support
const $05f34ed03d41967d$var$checkContent = "_bAmBoO_";
function $05f34ed03d41967d$var$supportSelector(styleStr, handleElement, supportCheck) {
    if ((0, $78361969822ad097$export$2e2bcd8739ae039)()) {
        (0, $449b73243fa975a1$export$4d99a2890bb989f0)(styleStr, $05f34ed03d41967d$var$randomSelectorKey);
        const ele = document.createElement("div");
        ele.style.position = "fixed";
        ele.style.left = "0";
        ele.style.top = "0";
        handleElement?.(ele);
        document.body.appendChild(ele);
        const support = supportCheck ? supportCheck(ele) : getComputedStyle(ele).content?.includes($05f34ed03d41967d$var$checkContent);
        ele.parentNode?.removeChild(ele);
        (0, $449b73243fa975a1$export$2232e336aecaa80a)($05f34ed03d41967d$var$randomSelectorKey);
        return support;
    }
    return false;
}
let $05f34ed03d41967d$var$canLayer = undefined;
function $05f34ed03d41967d$export$ac8d3fd9840e20dd() {
    if ($05f34ed03d41967d$var$canLayer === undefined) $05f34ed03d41967d$var$canLayer = $05f34ed03d41967d$var$supportSelector(`@layer ${$05f34ed03d41967d$var$randomSelectorKey} { .${$05f34ed03d41967d$var$randomSelectorKey} { content: "${$05f34ed03d41967d$var$checkContent}"!important; } }`, (ele)=>{
        ele.className = $05f34ed03d41967d$var$randomSelectorKey;
    });
    return $05f34ed03d41967d$var$canLayer;
}
let $05f34ed03d41967d$var$canWhere = undefined;
function $05f34ed03d41967d$export$f51d3b8ac4ac9ed1() {
    if ($05f34ed03d41967d$var$canWhere === undefined) $05f34ed03d41967d$var$canWhere = $05f34ed03d41967d$var$supportSelector(`:where(.${$05f34ed03d41967d$var$randomSelectorKey}) { content: "${$05f34ed03d41967d$var$checkContent}"!important; }`, (ele)=>{
        ele.className = $05f34ed03d41967d$var$randomSelectorKey;
    });
    return $05f34ed03d41967d$var$canWhere;
}
let $05f34ed03d41967d$var$canLogic = undefined;
function $05f34ed03d41967d$export$64a912f57d5de48e() {
    if ($05f34ed03d41967d$var$canLogic === undefined) $05f34ed03d41967d$var$canLogic = $05f34ed03d41967d$var$supportSelector(`.${$05f34ed03d41967d$var$randomSelectorKey} { inset-block: 93px !important; }`, (ele)=>{
        ele.className = $05f34ed03d41967d$var$randomSelectorKey;
    }, (ele)=>getComputedStyle(ele).bottom === "93px");
    return $05f34ed03d41967d$var$canLogic;
}
const $05f34ed03d41967d$export$9542afab8c2a5f48 = (0, $78361969822ad097$export$2e2bcd8739ae039)();
function $05f34ed03d41967d$export$523c0b569236b342(num) {
    if (typeof num === "number") return `${num}px`;
    return num;
}
function $05f34ed03d41967d$export$71c98ec84f0481d3(style, tokenKey, styleId, customizeAttrs = {}, plain = false) {
    if (plain) return style;
    const attrs = {
        ...customizeAttrs,
        [(0, $21cab3db22272d25$export$5d99297dcd5476ac)]: tokenKey,
        [(0, $21cab3db22272d25$export$89ce1123b3c0bd9e)]: styleId
    };
    const attrStr = Object.keys(attrs).map((attr)=>{
        const val = attrs[attr];
        return val ? `${attr}="${val}"` : null;
    }).filter((v)=>v).join(" ");
    return `<style ${attrStr}>${style}</style>`;
}
function $05f34ed03d41967d$export$9c59b80dda569a6e(options) {
    const { hashCls: hashCls, hashPriority: hashPriority = "low" } = options || {};
    if (!hashCls) return "";
    const hashSelector = `.${hashCls}`;
    return hashPriority === "low" ? `:where(${hashSelector})` : hashSelector;
}
const $05f34ed03d41967d$export$826fff653a329e83 = (val)=>{
    return val !== undefined && val !== null;
};
function $05f34ed03d41967d$export$f508583337ce246(config, nonce) {
    const nonceStr = typeof nonce === "function" ? nonce() : nonce;
    if (nonceStr) return {
        ...config,
        csp: {
            ...config.csp,
            nonce: nonceStr
        }
    };
    return config;
}



const $bf825bc7ff5f466f$export$309b3b095f0c7662 = (token, prefix = "")=>{
    return `--${prefix ? `${prefix}-` : ""}${token}`.replace(/([a-z0-9])([A-Z])/g, "$1-$2").replace(/([A-Z]+)([A-Z][a-z0-9]+)/g, "$1-$2").replace(/([a-z])([A-Z0-9])/g, "$1-$2").toLowerCase();
};
const $bf825bc7ff5f466f$export$a27ef1ee9bbc757e = (cssVars, hashId, options)=>{
    const { hashCls: hashCls, hashPriority: hashPriority = "low", scope: scope } = options || {};
    if (!Object.keys(cssVars).length) return "";
    const baseSelector = `${(0, $05f34ed03d41967d$export$9c59b80dda569a6e)({
        hashCls: hashCls,
        hashPriority: hashPriority
    })}.${hashId}`;
    const scopes = [
        scope
    ].flat().filter(Boolean);
    const selector = scopes.length ? scopes.map((s)=>`${baseSelector}.${s}`).join(", ") : baseSelector;
    return `${selector}{${Object.entries(cssVars).map(([key, value])=>`${key}:${value};`).join("")}}`;
};
const $bf825bc7ff5f466f$export$67858afe85bce49f = (token, themeKey, config)=>{
    const { hashCls: hashCls, hashPriority: hashPriority = "low", prefix: prefix, unitless: unitless, ignore: ignore, preserve: preserve } = config || {};
    const cssVars = {};
    const result = {};
    Object.entries(token).forEach(([key, value])=>{
        if (preserve?.[key]) result[key] = value;
        else if ((typeof value === "string" || typeof value === "number") && !ignore?.[key]) {
            const cssVar = $bf825bc7ff5f466f$export$309b3b095f0c7662(key, prefix);
            cssVars[cssVar] = typeof value === "number" && !unitless?.[key] ? `${value}px` : String(value);
            result[key] = `var(${cssVar})`;
        }
    });
    return [
        result,
        $bf825bc7ff5f466f$export$a27ef1ee9bbc757e(cssVars, themeKey, {
            scope: config?.scope,
            hashCls: hashCls,
            hashPriority: hashPriority
        })
    ];
};



var $cQmXV = parcelRequire("cQmXV");


function $a6f86040189b976e$var$useProdHMR() {
    return false;
}
let $a6f86040189b976e$var$webpackHMR = false;
function $a6f86040189b976e$var$useDevHMR() {
    return $a6f86040189b976e$var$webpackHMR;
}
var $a6f86040189b976e$export$2e2bcd8739ae039 = $a6f86040189b976e$var$useProdHMR;
var $a6f86040189b976e$var$args;


const $ebd32f83d3ce5163$var$effectMap = new Map();
function $ebd32f83d3ce5163$export$2e2bcd8739ae039(prefix, keyPath, cacheFn, onCacheRemove, // Add additional effect trigger by `useInsertionEffect`
onCacheEffect) {
    const { cache: globalCache } = $cQmXV.useContext((0, $21cab3db22272d25$export$2e2bcd8739ae039));
    const fullPath = [
        prefix,
        ...keyPath
    ];
    const fullPathStr = (0, $5b367ab252324f7b$export$1d14e1d8187b9aad)(fullPath);
    const HMRUpdate = (0, $a6f86040189b976e$export$2e2bcd8739ae039)();
    const buildCache = (updater)=>{
        globalCache.opUpdate(fullPathStr, (prevCache)=>{
            const [times = 0, cache] = prevCache || [
                undefined,
                undefined
            ];
            // HMR should always ignore cache since developer may change it
            let tmpCache = cache;
            const mergedCache = tmpCache || cacheFn();
            const data = [
                times,
                mergedCache
            ];
            // Call updater if need additional logic
            return updater ? updater(data) : data;
        });
    };
    // Create cache
    $cQmXV.useMemo(()=>{
        buildCache();
    }, /* eslint-disable react-hooks/exhaustive-deps */ [
        fullPathStr
    ]);
    let cacheEntity = globalCache.opGet(fullPathStr);
    const cacheContent = cacheEntity[1];
    // Remove if no need anymore
    (0, $cQmXV.useInsertionEffect)(()=>{
        buildCache(([times, cache])=>[
                times + 1,
                cache
            ]);
        if (!$ebd32f83d3ce5163$var$effectMap.has(fullPathStr)) {
            onCacheEffect?.(cacheContent);
            $ebd32f83d3ce5163$var$effectMap.set(fullPathStr, true);
            // 微任务清理缓存，可以认为是单次 batch render 中只触发一次 effect
            Promise.resolve().then(()=>{
                $ebd32f83d3ce5163$var$effectMap.delete(fullPathStr);
            });
        }
        return ()=>{
            globalCache.opUpdate(fullPathStr, (prevCache)=>{
                const [times = 0, cache] = prevCache || [];
                const nextCount = times - 1;
                if (nextCount === 0) {
                    onCacheRemove?.(cache, false);
                    $ebd32f83d3ce5163$var$effectMap.delete(fullPathStr);
                    return null;
                }
                return [
                    times - 1,
                    cache
                ];
            });
        };
    }, [
        fullPathStr
    ]);
    return cacheContent;
}


const $5a9aa371498f42c7$var$EMPTY_OVERRIDE = {};
// Generate different prefix to make user selector break in production env.
// This helps developer not to do style override directly on the hash id.
const $5a9aa371498f42c7$var$hashPrefix = "css";
const $5a9aa371498f42c7$var$tokenKeys = new Map();
function $5a9aa371498f42c7$var$recordCleanToken(tokenKey) {
    $5a9aa371498f42c7$var$tokenKeys.set(tokenKey, ($5a9aa371498f42c7$var$tokenKeys.get(tokenKey) || 0) + 1);
}
function $5a9aa371498f42c7$var$removeStyleTags(key, instanceId) {
    if (typeof document !== "undefined") {
        const styles = document.querySelectorAll(`style[${(0, $21cab3db22272d25$export$5d99297dcd5476ac)}="${key}"]`);
        styles.forEach((style)=>{
            if (style[0, $21cab3db22272d25$export$4c16a0c02134a7dc] === instanceId) style.parentNode?.removeChild(style);
        });
    }
}
const $5a9aa371498f42c7$var$TOKEN_THRESHOLD = -1;
// Remove will check current keys first
function $5a9aa371498f42c7$var$cleanTokenStyle(tokenKey, instanceId) {
    $5a9aa371498f42c7$var$tokenKeys.set(tokenKey, ($5a9aa371498f42c7$var$tokenKeys.get(tokenKey) || 0) - 1);
    const cleanableKeyList = new Set();
    $5a9aa371498f42c7$var$tokenKeys.forEach((value, key)=>{
        if (value <= 0) cleanableKeyList.add(key);
    });
    // Should keep tokens under threshold for not to insert style too often
    if ($5a9aa371498f42c7$var$tokenKeys.size - cleanableKeyList.size > $5a9aa371498f42c7$var$TOKEN_THRESHOLD) cleanableKeyList.forEach((key)=>{
        $5a9aa371498f42c7$var$removeStyleTags(key, instanceId);
        $5a9aa371498f42c7$var$tokenKeys.delete(key);
    });
}
const $5a9aa371498f42c7$export$18602cb46ae80b62 = (originToken, overrideToken, theme, format)=>{
    const derivativeToken = theme.getDerivativeToken(originToken);
    // Merge with override
    let mergedDerivativeToken = {
        ...derivativeToken,
        ...overrideToken
    };
    // Format if needed
    if (format) mergedDerivativeToken = format(mergedDerivativeToken);
    return mergedDerivativeToken;
};
const $5a9aa371498f42c7$export$270fba097347f4fa = "token";
function $5a9aa371498f42c7$export$2e2bcd8739ae039(theme, tokens, option) {
    const { cache: { instanceId: instanceId }, container: container, hashPriority: hashPriority } = (0, $cQmXV.useContext)((0, $21cab3db22272d25$export$2e2bcd8739ae039));
    const { salt: salt = "", override: override = $5a9aa371498f42c7$var$EMPTY_OVERRIDE, formatToken: formatToken, getComputedToken: compute, cssVar: cssVar, nonce: nonce } = option;
    // Basic - We do basic cache here
    const mergedToken = (0, $05f34ed03d41967d$export$6aabcc1951563d93)(()=>Object.assign({}, ...tokens), tokens);
    const tokenStr = (0, $05f34ed03d41967d$export$597374558a261efc)(mergedToken);
    const overrideTokenStr = (0, $05f34ed03d41967d$export$597374558a261efc)(override);
    const cssVarStr = (0, $05f34ed03d41967d$export$597374558a261efc)(cssVar);
    const cachedToken = (0, $ebd32f83d3ce5163$export$2e2bcd8739ae039)($5a9aa371498f42c7$export$270fba097347f4fa, [
        salt,
        theme.id,
        tokenStr,
        overrideTokenStr,
        cssVarStr
    ], ()=>{
        const mergedDerivativeToken = compute ? compute(mergedToken, override, theme) : $5a9aa371498f42c7$export$18602cb46ae80b62(mergedToken, override, theme, formatToken);
        const actualToken = {
            ...mergedDerivativeToken
        };
        // Optimize for `useStyleRegister` performance
        const mergedSalt = `${salt}_${cssVar.prefix}`;
        const hashId = (0, $6ed32536c828ace4$export$2e2bcd8739ae039)(mergedSalt);
        const hashCls = `${$5a9aa371498f42c7$var$hashPrefix}-${hashId}`;
        actualToken._tokenKey = (0, $05f34ed03d41967d$export$6c82d0ebe8f2ea2c)(actualToken, mergedSalt);
        // Replace token value with css variables
        const [tokenWithCssVar, cssVarsStr] = (0, $bf825bc7ff5f466f$export$67858afe85bce49f)(mergedDerivativeToken, cssVar.key, {
            prefix: cssVar.prefix,
            ignore: cssVar.ignore,
            unitless: cssVar.unitless,
            preserve: cssVar.preserve,
            hashPriority: hashPriority,
            hashCls: cssVar.hashed ? hashCls : undefined
        });
        tokenWithCssVar._hashId = hashId;
        $5a9aa371498f42c7$var$recordCleanToken(cssVar.key);
        return [
            tokenWithCssVar,
            hashCls,
            actualToken,
            cssVarsStr,
            cssVar.key
        ];
    }, ([, , , , themeKey])=>{
        // Remove token will remove all related style
        $5a9aa371498f42c7$var$cleanTokenStyle(themeKey, instanceId);
    }, ([, , , cssVarsStr, themeKey])=>{
        if (!cssVarsStr) return;
        let mergedCSSConfig = {
            mark: (0, $21cab3db22272d25$export$89ce1123b3c0bd9e),
            prepend: "queue",
            attachTo: container,
            priority: -999
        };
        mergedCSSConfig = (0, $05f34ed03d41967d$export$f508583337ce246)(mergedCSSConfig, nonce);
        const style = (0, $449b73243fa975a1$export$4d99a2890bb989f0)(cssVarsStr, (0, $6ed32536c828ace4$export$2e2bcd8739ae039)(`css-var-${themeKey}`), mergedCSSConfig);
        style[0, $21cab3db22272d25$export$4c16a0c02134a7dc] = instanceId;
        // Used for `useCacheToken` to remove on batch when token removed
        style.setAttribute((0, $21cab3db22272d25$export$5d99297dcd5476ac), themeKey);
    });
    return cachedToken;
}
const $5a9aa371498f42c7$export$f9380c9a627682d3 = (cache, effectStyles, options)=>{
    const [, , realToken, styleStr, cssVarKey] = cache;
    const { plain: plain } = options || {};
    if (!styleStr) return null;
    const styleId = realToken._tokenKey;
    const order = -999;
    // ====================== Style ======================
    // Used for @rc-component/util
    const sharedAttrs = {
        "data-rc-order": "prependQueue",
        "data-rc-priority": `${order}`
    };
    const styleText = (0, $05f34ed03d41967d$export$71c98ec84f0481d3)(styleStr, cssVarKey, styleId, sharedAttrs, plain);
    return [
        order,
        styleId,
        styleText
    ];
};




var $cQmXV = parcelRequire("cQmXV");







var $cQmXV = parcelRequire("cQmXV");
var $ff9ab6c93114df17$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $ff9ab6c93114df17$export$2e2bcd8739ae039 = $ff9ab6c93114df17$var$unitlessKeys;


var $f90fe41aaaad6526$export$71ad59f2e432cfe8 = "-ms-";
var $f90fe41aaaad6526$export$2c0f367103c8d01c = "-moz-";
var $f90fe41aaaad6526$export$39dfd62a25e0fe93 = "-webkit-";
var $f90fe41aaaad6526$export$a29989082612d0d9 = "comm";
var $f90fe41aaaad6526$export$aa3a2e812ca8570d = "rule";
var $f90fe41aaaad6526$export$527d108ccf083c2b = "decl";
var $f90fe41aaaad6526$export$d3d35020fa5b54f0 = "@page";
var $f90fe41aaaad6526$export$500415a86c544f73 = "@media";
var $f90fe41aaaad6526$export$a763edbf796b780a = "@import";
var $f90fe41aaaad6526$export$2790aeb8b4e5c826 = "@charset";
var $f90fe41aaaad6526$export$1cc683e23b84b133 = "@viewport";
var $f90fe41aaaad6526$export$9447a5efea57e862 = "@supports";
var $f90fe41aaaad6526$export$ef011b4e114b1fba = "@document";
var $f90fe41aaaad6526$export$6aad947bda0f3f46 = "@namespace";
var $f90fe41aaaad6526$export$b44a8529a35fcb60 = "@keyframes";
var $f90fe41aaaad6526$export$2c16de31893252e6 = "@font-face";
var $f90fe41aaaad6526$export$3d846dd52e150c6f = "@counter-style";
var $f90fe41aaaad6526$export$22314bfbb57653fe = "@font-feature-values";
var $f90fe41aaaad6526$export$d773506282b3cfe6 = "@layer";
var $f90fe41aaaad6526$export$1c5a554c78c0cd12 = "@scope";
var $f90fe41aaaad6526$export$2335f513bbd82c6d = Math.abs;
var $f90fe41aaaad6526$export$6788812c4e6611e6 = String.fromCharCode;
var $f90fe41aaaad6526$export$e6e34fd1f2686227 = Object.assign;
function $f90fe41aaaad6526$export$d6af199866bfb566(e, r) {
    return $f90fe41aaaad6526$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $f90fe41aaaad6526$export$a9db5e087081082d(e, 0)) << 2 ^ $f90fe41aaaad6526$export$a9db5e087081082d(e, 1)) << 2 ^ $f90fe41aaaad6526$export$a9db5e087081082d(e, 2)) << 2 ^ $f90fe41aaaad6526$export$a9db5e087081082d(e, 3) : 0;
}
function $f90fe41aaaad6526$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $f90fe41aaaad6526$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $f90fe41aaaad6526$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $f90fe41aaaad6526$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $f90fe41aaaad6526$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $f90fe41aaaad6526$export$36776f635604f274(e) {
    return e.length;
}
function $f90fe41aaaad6526$export$f9084667e487ed46(e) {
    return e.length;
}
function $f90fe41aaaad6526$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $f90fe41aaaad6526$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
function $f90fe41aaaad6526$export$3dea766d36a8935f(e, r) {
    return e.filter(function(e) {
        return !$f90fe41aaaad6526$export$4659b591c19bdf3d(e, r);
    });
}
var $f90fe41aaaad6526$export$53f1d5ea8de3d7c = 1;
var $f90fe41aaaad6526$export$4e0c71f277ca26b3 = 1;
var $f90fe41aaaad6526$export$f24224f1c91d8156 = 0;
var $f90fe41aaaad6526$export$5880b8b5730aff45 = 0;
var $f90fe41aaaad6526$export$c0306caf338ac095 = 0;
var $f90fe41aaaad6526$export$30a86d91af8ff6e6 = "";
function $f90fe41aaaad6526$export$35059013cd4a06db(e, r, a, c, n, s, t, u) {
    return {
        value: e,
        root: r,
        parent: a,
        type: c,
        props: n,
        children: s,
        line: $f90fe41aaaad6526$export$53f1d5ea8de3d7c,
        column: $f90fe41aaaad6526$export$4e0c71f277ca26b3,
        length: t,
        return: "",
        siblings: u
    };
}
function $f90fe41aaaad6526$export$784d13d8ee351f07(e, r) {
    return $f90fe41aaaad6526$export$e6e34fd1f2686227($f90fe41aaaad6526$export$35059013cd4a06db("", null, null, "", null, null, 0, e.siblings), e, {
        length: -e.length
    }, r);
}
function $f90fe41aaaad6526$export$590e8b2c435046d9(e) {
    while(e.root)e = $f90fe41aaaad6526$export$784d13d8ee351f07(e.root, {
        children: [
            e
        ]
    });
    $f90fe41aaaad6526$export$10d8903dec122b9d(e, e.siblings);
}
function $f90fe41aaaad6526$export$eba6f6f03b0a92e7() {
    return $f90fe41aaaad6526$export$c0306caf338ac095;
}
function $f90fe41aaaad6526$export$232faf9add678146() {
    $f90fe41aaaad6526$export$c0306caf338ac095 = $f90fe41aaaad6526$export$5880b8b5730aff45 > 0 ? $f90fe41aaaad6526$export$a9db5e087081082d($f90fe41aaaad6526$export$30a86d91af8ff6e6, --$f90fe41aaaad6526$export$5880b8b5730aff45) : 0;
    if ($f90fe41aaaad6526$export$4e0c71f277ca26b3--, $f90fe41aaaad6526$export$c0306caf338ac095 === 10) $f90fe41aaaad6526$export$4e0c71f277ca26b3 = 1, $f90fe41aaaad6526$export$53f1d5ea8de3d7c--;
    return $f90fe41aaaad6526$export$c0306caf338ac095;
}
function $f90fe41aaaad6526$export$48cfd1e771a65c4f() {
    $f90fe41aaaad6526$export$c0306caf338ac095 = $f90fe41aaaad6526$export$5880b8b5730aff45 < $f90fe41aaaad6526$export$f24224f1c91d8156 ? $f90fe41aaaad6526$export$a9db5e087081082d($f90fe41aaaad6526$export$30a86d91af8ff6e6, $f90fe41aaaad6526$export$5880b8b5730aff45++) : 0;
    if ($f90fe41aaaad6526$export$4e0c71f277ca26b3++, $f90fe41aaaad6526$export$c0306caf338ac095 === 10) $f90fe41aaaad6526$export$4e0c71f277ca26b3 = 1, $f90fe41aaaad6526$export$53f1d5ea8de3d7c++;
    return $f90fe41aaaad6526$export$c0306caf338ac095;
}
function $f90fe41aaaad6526$export$4d3fb11e950abb9e() {
    return $f90fe41aaaad6526$export$a9db5e087081082d($f90fe41aaaad6526$export$30a86d91af8ff6e6, $f90fe41aaaad6526$export$5880b8b5730aff45);
}
function $f90fe41aaaad6526$export$e88cb2efb12ae807() {
    return $f90fe41aaaad6526$export$5880b8b5730aff45;
}
function $f90fe41aaaad6526$export$58adb3bec8346d0f(e, r) {
    return $f90fe41aaaad6526$export$2f35ab04d2335697($f90fe41aaaad6526$export$30a86d91af8ff6e6, e, r);
}
function $f90fe41aaaad6526$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $f90fe41aaaad6526$export$2de70f21292aac9e(e) {
    return $f90fe41aaaad6526$export$53f1d5ea8de3d7c = $f90fe41aaaad6526$export$4e0c71f277ca26b3 = 1, $f90fe41aaaad6526$export$f24224f1c91d8156 = $f90fe41aaaad6526$export$36776f635604f274($f90fe41aaaad6526$export$30a86d91af8ff6e6 = e), $f90fe41aaaad6526$export$5880b8b5730aff45 = 0, [];
}
function $f90fe41aaaad6526$export$45918ac1574455b1(e) {
    return $f90fe41aaaad6526$export$30a86d91af8ff6e6 = "", e;
}
function $f90fe41aaaad6526$export$410ac95b9ec204b8(e) {
    return $f90fe41aaaad6526$export$87c2784dc9fc4ab($f90fe41aaaad6526$export$58adb3bec8346d0f($f90fe41aaaad6526$export$5880b8b5730aff45 - 1, $f90fe41aaaad6526$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $f90fe41aaaad6526$export$660b2ee2d4fb4eff(e) {
    return $f90fe41aaaad6526$export$45918ac1574455b1($f90fe41aaaad6526$export$5f8c09e3ae6f64e1($f90fe41aaaad6526$export$2de70f21292aac9e(e)));
}
function $f90fe41aaaad6526$export$7af1228ff777d175(e) {
    while($f90fe41aaaad6526$export$c0306caf338ac095 = $f90fe41aaaad6526$export$4d3fb11e950abb9e())if ($f90fe41aaaad6526$export$c0306caf338ac095 < 33) $f90fe41aaaad6526$export$48cfd1e771a65c4f();
    else break;
    return $f90fe41aaaad6526$export$9e1725a4cfeada27(e) > 2 || $f90fe41aaaad6526$export$9e1725a4cfeada27($f90fe41aaaad6526$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $f90fe41aaaad6526$export$5f8c09e3ae6f64e1(e) {
    while($f90fe41aaaad6526$export$48cfd1e771a65c4f())switch($f90fe41aaaad6526$export$9e1725a4cfeada27($f90fe41aaaad6526$export$c0306caf338ac095)){
        case 0:
            $f90fe41aaaad6526$export$10d8903dec122b9d($f90fe41aaaad6526$export$c2ab62c7bf24634($f90fe41aaaad6526$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $f90fe41aaaad6526$export$10d8903dec122b9d($f90fe41aaaad6526$export$410ac95b9ec204b8($f90fe41aaaad6526$export$c0306caf338ac095), e);
            break;
        default:
            $f90fe41aaaad6526$export$10d8903dec122b9d($f90fe41aaaad6526$export$6788812c4e6611e6($f90fe41aaaad6526$export$c0306caf338ac095), e);
    }
    return e;
}
function $f90fe41aaaad6526$export$955ba06d119e085e(e, r) {
    while(--r && $f90fe41aaaad6526$export$48cfd1e771a65c4f())if ($f90fe41aaaad6526$export$c0306caf338ac095 < 48 || $f90fe41aaaad6526$export$c0306caf338ac095 > 102 || $f90fe41aaaad6526$export$c0306caf338ac095 > 57 && $f90fe41aaaad6526$export$c0306caf338ac095 < 65 || $f90fe41aaaad6526$export$c0306caf338ac095 > 70 && $f90fe41aaaad6526$export$c0306caf338ac095 < 97) break;
    return $f90fe41aaaad6526$export$58adb3bec8346d0f(e, $f90fe41aaaad6526$export$e88cb2efb12ae807() + (r < 6 && $f90fe41aaaad6526$export$4d3fb11e950abb9e() == 32 && $f90fe41aaaad6526$export$48cfd1e771a65c4f() == 32));
}
function $f90fe41aaaad6526$export$c889f2fcc19dbf12(e) {
    while($f90fe41aaaad6526$export$48cfd1e771a65c4f())switch($f90fe41aaaad6526$export$c0306caf338ac095){
        case e:
            return $f90fe41aaaad6526$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $f90fe41aaaad6526$export$c889f2fcc19dbf12($f90fe41aaaad6526$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $f90fe41aaaad6526$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $f90fe41aaaad6526$export$48cfd1e771a65c4f();
            break;
    }
    return $f90fe41aaaad6526$export$5880b8b5730aff45;
}
function $f90fe41aaaad6526$export$4254d4e2b3745c4c(e, r) {
    while($f90fe41aaaad6526$export$48cfd1e771a65c4f())if (e + $f90fe41aaaad6526$export$c0306caf338ac095 === 57) break;
    else if (e + $f90fe41aaaad6526$export$c0306caf338ac095 === 84 && $f90fe41aaaad6526$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $f90fe41aaaad6526$export$58adb3bec8346d0f(r, $f90fe41aaaad6526$export$5880b8b5730aff45 - 1) + "*" + $f90fe41aaaad6526$export$6788812c4e6611e6(e === 47 ? e : $f90fe41aaaad6526$export$48cfd1e771a65c4f());
}
function $f90fe41aaaad6526$export$c2ab62c7bf24634(e) {
    while(!$f90fe41aaaad6526$export$9e1725a4cfeada27($f90fe41aaaad6526$export$4d3fb11e950abb9e()))$f90fe41aaaad6526$export$48cfd1e771a65c4f();
    return $f90fe41aaaad6526$export$58adb3bec8346d0f(e, $f90fe41aaaad6526$export$5880b8b5730aff45);
}
function $f90fe41aaaad6526$export$ef7acd7185315e22(e) {
    return $f90fe41aaaad6526$export$45918ac1574455b1($f90fe41aaaad6526$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $f90fe41aaaad6526$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $f90fe41aaaad6526$export$98e6a39c04603d36(e, r, a, c, n, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var p = 0;
    var v = 0;
    var b = 0;
    var h = 1;
    var w = 1;
    var d = 1;
    var k = 0;
    var g = 0;
    var $ = "";
    var x = n;
    var y = s;
    var j = c;
    var z = $;
    while(w)switch(b = g, g = $f90fe41aaaad6526$export$48cfd1e771a65c4f()){
        case 40:
            if (b != 108 && $f90fe41aaaad6526$export$a9db5e087081082d(z, l - 1) == 58) k++, z += "(";
            else z += $f90fe41aaaad6526$export$410ac95b9ec204b8(g);
            break;
        case 41:
            k--, z += ")";
            break;
        case 34:
        case 39:
        case 91:
            z += $f90fe41aaaad6526$export$410ac95b9ec204b8(g);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            if (k > 0) {
                z += $f90fe41aaaad6526$export$6788812c4e6611e6(g);
                break;
            }
            z += $f90fe41aaaad6526$export$7af1228ff777d175(b);
            break;
        case 92:
            z += $f90fe41aaaad6526$export$955ba06d119e085e($f90fe41aaaad6526$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($f90fe41aaaad6526$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $f90fe41aaaad6526$export$10d8903dec122b9d($f90fe41aaaad6526$export$4a34f930e789283c($f90fe41aaaad6526$export$4254d4e2b3745c4c($f90fe41aaaad6526$export$48cfd1e771a65c4f(), $f90fe41aaaad6526$export$e88cb2efb12ae807()), r, a, i), i);
                    if (($f90fe41aaaad6526$export$9e1725a4cfeada27(b || 1) == 5 || $f90fe41aaaad6526$export$9e1725a4cfeada27($f90fe41aaaad6526$export$4d3fb11e950abb9e() || 1) == 5) && $f90fe41aaaad6526$export$36776f635604f274(z) && $f90fe41aaaad6526$export$2f35ab04d2335697(z, -1, void 0) !== " ") z += " ";
                    break;
                default:
                    z += "/";
            }
            break;
        case 123 * h:
            u[f++] = $f90fe41aaaad6526$export$36776f635604f274(z) * d;
        case 125 * h:
        case 59:
        case 0:
            if (k > 0 && g) {
                z += $f90fe41aaaad6526$export$6788812c4e6611e6(g);
                break;
            }
            switch(g){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) z = $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(z, /\f/g, "");
                    if (v > 0 && ($f90fe41aaaad6526$export$36776f635604f274(z) - l || h === 0)) $f90fe41aaaad6526$export$10d8903dec122b9d(v > 32 ? $f90fe41aaaad6526$export$f8483753829ec8f3(z + ";", c, a, l - 1, i) : $f90fe41aaaad6526$export$f8483753829ec8f3($f90fe41aaaad6526$export$77ad94ebf1c2b9ed(z, " ", "") + ";", c, a, l - 2, i), i);
                    break;
                case 59:
                    z += ";";
                default:
                    $f90fe41aaaad6526$export$10d8903dec122b9d(j = $f90fe41aaaad6526$export$3307ffa7023ede1e(z, r, a, f, o, n, u, $, x = [], y = [], l, s), s);
                    if (g === 123) {
                        if (o === 0) $f90fe41aaaad6526$export$98e6a39c04603d36(z, r, j, j, x, s, l, u, y);
                        else {
                            switch(p){
                                case 99:
                                    if ($f90fe41aaaad6526$export$a9db5e087081082d(z, 3) === 110) break;
                                case 108:
                                    if ($f90fe41aaaad6526$export$a9db5e087081082d(z, 2) === 97) break;
                                default:
                                    o = 0;
                                case 100:
                                case 109:
                                case 115:
                            }
                            if (o) $f90fe41aaaad6526$export$98e6a39c04603d36(e, j, j, c && $f90fe41aaaad6526$export$10d8903dec122b9d($f90fe41aaaad6526$export$3307ffa7023ede1e(e, j, j, 0, 0, n, u, $, n, x = [], l, y), y), n, y, l, u, c ? x : y);
                            else $f90fe41aaaad6526$export$98e6a39c04603d36(z, j, j, j, [
                                ""
                            ], y, 0, u, y);
                        }
                    }
            }
            f = o = v = 0, h = d = 1, $ = z = "", l = t;
            break;
        case 58:
            l = 1 + $f90fe41aaaad6526$export$36776f635604f274(z), v = b;
        default:
            if (h < 1) {
                if (g == 123) --h;
                else if (g == 125 && h++ == 0 && $f90fe41aaaad6526$export$232faf9add678146() == 125) continue;
            }
            switch(z += $f90fe41aaaad6526$export$6788812c4e6611e6(g), g * h){
                case 38:
                    d = o > 0 ? 1 : (z += "\f", -1);
                    break;
                case 44:
                    if (k > 0) break;
                    u[f++] = ($f90fe41aaaad6526$export$36776f635604f274(z) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($f90fe41aaaad6526$export$4d3fb11e950abb9e() === 45) z += $f90fe41aaaad6526$export$410ac95b9ec204b8($f90fe41aaaad6526$export$48cfd1e771a65c4f());
                    p = $f90fe41aaaad6526$export$4d3fb11e950abb9e(), o = l = $f90fe41aaaad6526$export$36776f635604f274($ = z += $f90fe41aaaad6526$export$c2ab62c7bf24634($f90fe41aaaad6526$export$e88cb2efb12ae807())), g++;
                    break;
                case 45:
                    if (b === 45 && $f90fe41aaaad6526$export$36776f635604f274(z) == 2) h = 0;
            }
    }
    return s;
}
function $f90fe41aaaad6526$export$3307ffa7023ede1e(e, r, a, c, s, t, u, i, f, o, l, p) {
    var v = s - 1;
    var b = s === 0 ? t : [
        ""
    ];
    var h = $f90fe41aaaad6526$export$f9084667e487ed46(b);
    for(var w = 0, d = 0, k = 0; w < c; ++w)for(var g = 0, m = $f90fe41aaaad6526$export$2f35ab04d2335697(e, v + 1, v = $f90fe41aaaad6526$export$2335f513bbd82c6d(d = u[w])), x = e; g < h; ++g)if (x = $f90fe41aaaad6526$export$87c2784dc9fc4ab(d > 0 ? b[g] + " " + m : $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(m, /&\f/g, b[g]))) f[k++] = x;
    return $f90fe41aaaad6526$export$35059013cd4a06db(e, r, a, s === 0 ? $f90fe41aaaad6526$export$aa3a2e812ca8570d : i, f, o, l, p);
}
function $f90fe41aaaad6526$export$4a34f930e789283c(e, r, a, n) {
    return $f90fe41aaaad6526$export$35059013cd4a06db(e, r, a, $f90fe41aaaad6526$export$a29989082612d0d9, $f90fe41aaaad6526$export$6788812c4e6611e6($f90fe41aaaad6526$export$eba6f6f03b0a92e7()), $f90fe41aaaad6526$export$2f35ab04d2335697(e, 2, -2), 0, n);
}
function $f90fe41aaaad6526$export$f8483753829ec8f3(e, r, a, c, n) {
    return $f90fe41aaaad6526$export$35059013cd4a06db(e, r, a, $f90fe41aaaad6526$export$527d108ccf083c2b, $f90fe41aaaad6526$export$2f35ab04d2335697(e, 0, c), $f90fe41aaaad6526$export$2f35ab04d2335697(e, c + 1, -1), c, n);
}
function $f90fe41aaaad6526$export$82e9f45cca5ba907(c, n, s) {
    switch($f90fe41aaaad6526$export$d6af199866bfb566(c, n)){
        case 5103:
            return $f90fe41aaaad6526$export$39dfd62a25e0fe93 + "print-" + c + c;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
            return $f90fe41aaaad6526$export$39dfd62a25e0fe93 + c + c;
        case 4855:
            return $f90fe41aaaad6526$export$39dfd62a25e0fe93 + c.replace("add", "source-over").replace("substract", "source-out").replace("intersect", "source-in").replace("exclude", "xor") + c;
        case 4789:
            return $f90fe41aaaad6526$export$2c0f367103c8d01c + c + c;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $f90fe41aaaad6526$export$39dfd62a25e0fe93 + c + $f90fe41aaaad6526$export$2c0f367103c8d01c + c + $f90fe41aaaad6526$export$71ad59f2e432cfe8 + c + c;
        case 5936:
            switch($f90fe41aaaad6526$export$a9db5e087081082d(c, n + 11)){
                case 114:
                    return $f90fe41aaaad6526$export$39dfd62a25e0fe93 + c + $f90fe41aaaad6526$export$71ad59f2e432cfe8 + $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(c, /[svh]\w+-[tblr]{2}/, "tb") + c;
                case 108:
                    return $f90fe41aaaad6526$export$39dfd62a25e0fe93 + c + $f90fe41aaaad6526$export$71ad59f2e432cfe8 + $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(c, /[svh]\w+-[tblr]{2}/, "tb-rl") + c;
                case 45:
                    return $f90fe41aaaad6526$export$39dfd62a25e0fe93 + c + $f90fe41aaaad6526$export$71ad59f2e432cfe8 + $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(c, /[svh]\w+-[tblr]{2}/, "lr") + c;
            }
        case 6828:
        case 4268:
        case 2903:
            return $f90fe41aaaad6526$export$39dfd62a25e0fe93 + c + $f90fe41aaaad6526$export$71ad59f2e432cfe8 + c + c;
        case 6165:
            return $f90fe41aaaad6526$export$39dfd62a25e0fe93 + c + $f90fe41aaaad6526$export$71ad59f2e432cfe8 + "flex-" + c + c;
        case 5187:
            return $f90fe41aaaad6526$export$39dfd62a25e0fe93 + c + $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(c, /(\w+).+(:[^]+)/, $f90fe41aaaad6526$export$39dfd62a25e0fe93 + "box-$1$2" + $f90fe41aaaad6526$export$71ad59f2e432cfe8 + "flex-$1$2") + c;
        case 5443:
            return $f90fe41aaaad6526$export$39dfd62a25e0fe93 + c + $f90fe41aaaad6526$export$71ad59f2e432cfe8 + "flex-item-" + $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(c, /flex-|-self/g, "") + (!$f90fe41aaaad6526$export$4659b591c19bdf3d(c, /flex-|baseline/) ? $f90fe41aaaad6526$export$71ad59f2e432cfe8 + "grid-row-" + $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(c, /flex-|-self/g, "") : "") + c;
        case 4675:
            return $f90fe41aaaad6526$export$39dfd62a25e0fe93 + c + $f90fe41aaaad6526$export$71ad59f2e432cfe8 + "flex-line-pack" + $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(c, /align-content|flex-|-self/g, "") + c;
        case 5548:
            return $f90fe41aaaad6526$export$39dfd62a25e0fe93 + c + $f90fe41aaaad6526$export$71ad59f2e432cfe8 + $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(c, "shrink", "negative") + c;
        case 5292:
            return $f90fe41aaaad6526$export$39dfd62a25e0fe93 + c + $f90fe41aaaad6526$export$71ad59f2e432cfe8 + $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(c, "basis", "preferred-size") + c;
        case 6060:
            return $f90fe41aaaad6526$export$39dfd62a25e0fe93 + "box-" + $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(c, "-grow", "") + $f90fe41aaaad6526$export$39dfd62a25e0fe93 + c + $f90fe41aaaad6526$export$71ad59f2e432cfe8 + $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(c, "grow", "positive") + c;
        case 4554:
            return $f90fe41aaaad6526$export$39dfd62a25e0fe93 + $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(c, /([^-])(transform)/g, "$1" + $f90fe41aaaad6526$export$39dfd62a25e0fe93 + "$2") + c;
        case 6187:
            return $f90fe41aaaad6526$export$77ad94ebf1c2b9ed($f90fe41aaaad6526$export$77ad94ebf1c2b9ed($f90fe41aaaad6526$export$77ad94ebf1c2b9ed(c, /(zoom-|grab)/, $f90fe41aaaad6526$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $f90fe41aaaad6526$export$39dfd62a25e0fe93 + "$1"), c, "") + c;
        case 5495:
        case 3959:
            return $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(c, /(image-set\([^]*)/, $f90fe41aaaad6526$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $f90fe41aaaad6526$export$77ad94ebf1c2b9ed($f90fe41aaaad6526$export$77ad94ebf1c2b9ed(c, /(.+:)(flex-)?(.*)/, $f90fe41aaaad6526$export$39dfd62a25e0fe93 + "box-pack:$3" + $f90fe41aaaad6526$export$71ad59f2e432cfe8 + "flex-pack:$3"), /space-between/, "justify") + $f90fe41aaaad6526$export$39dfd62a25e0fe93 + c + c;
        case 4200:
            if (!$f90fe41aaaad6526$export$4659b591c19bdf3d(c, /flex-|baseline/)) return $f90fe41aaaad6526$export$71ad59f2e432cfe8 + "grid-column-align" + $f90fe41aaaad6526$export$2f35ab04d2335697(c, n) + c;
            break;
        case 2592:
        case 3360:
            return $f90fe41aaaad6526$export$71ad59f2e432cfe8 + $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(c, "template-", "") + c;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return n = r, $f90fe41aaaad6526$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$f90fe41aaaad6526$export$f8e21b1e77979a08(c + (s = s[n].value), "span") ? c : $f90fe41aaaad6526$export$71ad59f2e432cfe8 + $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(c, "-start", "") + c + $f90fe41aaaad6526$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$f90fe41aaaad6526$export$f8e21b1e77979a08(s, "span") ? $f90fe41aaaad6526$export$4659b591c19bdf3d(s, /\d+/) : +$f90fe41aaaad6526$export$4659b591c19bdf3d(s, /\d+/) - +$f90fe41aaaad6526$export$4659b591c19bdf3d(c, /\d+/)) + ";";
            return $f90fe41aaaad6526$export$71ad59f2e432cfe8 + $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(c, "-start", "") + c;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $f90fe41aaaad6526$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? c : $f90fe41aaaad6526$export$71ad59f2e432cfe8 + $f90fe41aaaad6526$export$77ad94ebf1c2b9ed($f90fe41aaaad6526$export$77ad94ebf1c2b9ed(c, "-end", "-span"), "span ", "") + c;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(c, /(.+)-inline(.+)/, $f90fe41aaaad6526$export$39dfd62a25e0fe93 + "$1$2") + c;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($f90fe41aaaad6526$export$36776f635604f274(c) - 1 - n > 6) switch($f90fe41aaaad6526$export$a9db5e087081082d(c, n + 1)){
                case 109:
                    if ($f90fe41aaaad6526$export$a9db5e087081082d(c, n + 4) !== 45) break;
                case 102:
                    return $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(c, /(.+:)(.+)-([^]+)/, "$1" + $f90fe41aaaad6526$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $f90fe41aaaad6526$export$2c0f367103c8d01c + ($f90fe41aaaad6526$export$a9db5e087081082d(c, n + 3) == 108 ? "$3" : "$2-$3")) + c;
                case 115:
                    return ~$f90fe41aaaad6526$export$f8e21b1e77979a08(c, "stretch") ? $f90fe41aaaad6526$export$82e9f45cca5ba907($f90fe41aaaad6526$export$77ad94ebf1c2b9ed(c, "stretch", "fill-available"), n, s) + c : c;
            }
            break;
        case 5152:
        case 5920:
            return $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(c, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, n, s, t, u, i) {
                return $f90fe41aaaad6526$export$71ad59f2e432cfe8 + a + ":" + n + i + (s ? $f90fe41aaaad6526$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +n) + i : "") + c;
            });
        case 4949:
            if ($f90fe41aaaad6526$export$a9db5e087081082d(c, n + 6) === 121) return $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(c, ":", ":" + $f90fe41aaaad6526$export$39dfd62a25e0fe93) + c;
            break;
        case 6444:
            switch($f90fe41aaaad6526$export$a9db5e087081082d(c, $f90fe41aaaad6526$export$a9db5e087081082d(c, 14) === 45 ? 18 : 11)){
                case 120:
                    return $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(c, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $f90fe41aaaad6526$export$39dfd62a25e0fe93 + ($f90fe41aaaad6526$export$a9db5e087081082d(c, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $f90fe41aaaad6526$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $f90fe41aaaad6526$export$71ad59f2e432cfe8 + "$2box$3") + c;
                case 100:
                    return $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(c, ":", ":" + $f90fe41aaaad6526$export$71ad59f2e432cfe8) + c;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(c, "scroll-", "scroll-snap-") + c;
    }
    return c;
}
function $f90fe41aaaad6526$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    for(var c = 0; c < e.length; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $f90fe41aaaad6526$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $f90fe41aaaad6526$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $f90fe41aaaad6526$export$a763edbf796b780a:
        case $f90fe41aaaad6526$export$6aad947bda0f3f46:
        case $f90fe41aaaad6526$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $f90fe41aaaad6526$export$a29989082612d0d9:
            return "";
        case $f90fe41aaaad6526$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $f90fe41aaaad6526$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $f90fe41aaaad6526$export$aa3a2e812ca8570d:
            if (!$f90fe41aaaad6526$export$36776f635604f274(e.value = e.props.join(","))) return "";
    }
    return $f90fe41aaaad6526$export$36776f635604f274(a = $f90fe41aaaad6526$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $f90fe41aaaad6526$export$5a7767152ae0305f(e) {
    var r = $f90fe41aaaad6526$export$f9084667e487ed46(e);
    return function(a, c, n, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, c, n, s) || "";
        return t;
    };
}
function $f90fe41aaaad6526$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $f90fe41aaaad6526$export$e08c7d021b829b7a(c, t, u, i) {
    if (c.length > -1) {
        if (!c.return) switch(c.type){
            case $f90fe41aaaad6526$export$527d108ccf083c2b:
                c.return = $f90fe41aaaad6526$export$82e9f45cca5ba907(c.value, c.length, u);
                return;
            case $f90fe41aaaad6526$export$b44a8529a35fcb60:
                return $f90fe41aaaad6526$export$dfdc1655ccc5b9cb([
                    $f90fe41aaaad6526$export$784d13d8ee351f07(c, {
                        value: $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(c.value, "@", "@" + $f90fe41aaaad6526$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $f90fe41aaaad6526$export$aa3a2e812ca8570d:
                if (c.length) return $f90fe41aaaad6526$export$1be1fc439b849fdf(u = c.props, function(n) {
                    switch($f90fe41aaaad6526$export$4659b591c19bdf3d(n, i = /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            $f90fe41aaaad6526$export$590e8b2c435046d9($f90fe41aaaad6526$export$784d13d8ee351f07(c, {
                                props: [
                                    $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(n, /:(read-\w+)/, ":" + $f90fe41aaaad6526$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $f90fe41aaaad6526$export$590e8b2c435046d9($f90fe41aaaad6526$export$784d13d8ee351f07(c, {
                                props: [
                                    n
                                ]
                            }));
                            $f90fe41aaaad6526$export$e6e34fd1f2686227(c, {
                                props: $f90fe41aaaad6526$export$3dea766d36a8935f(u, i)
                            });
                            break;
                        case "::placeholder":
                            $f90fe41aaaad6526$export$590e8b2c435046d9($f90fe41aaaad6526$export$784d13d8ee351f07(c, {
                                props: [
                                    $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(n, /:(plac\w+)/, ":" + $f90fe41aaaad6526$export$39dfd62a25e0fe93 + "input-$1")
                                ]
                            }));
                            $f90fe41aaaad6526$export$590e8b2c435046d9($f90fe41aaaad6526$export$784d13d8ee351f07(c, {
                                props: [
                                    $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(n, /:(plac\w+)/, ":" + $f90fe41aaaad6526$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $f90fe41aaaad6526$export$590e8b2c435046d9($f90fe41aaaad6526$export$784d13d8ee351f07(c, {
                                props: [
                                    $f90fe41aaaad6526$export$77ad94ebf1c2b9ed(n, /:(plac\w+)/, $f90fe41aaaad6526$export$71ad59f2e432cfe8 + "input-$1")
                                ]
                            }));
                            $f90fe41aaaad6526$export$590e8b2c435046d9($f90fe41aaaad6526$export$784d13d8ee351f07(c, {
                                props: [
                                    n
                                ]
                            }));
                            $f90fe41aaaad6526$export$e6e34fd1f2686227(c, {
                                props: $f90fe41aaaad6526$export$3dea766d36a8935f(u, i)
                            });
                            break;
                    }
                    return "";
                });
        }
    }
}
function $f90fe41aaaad6526$export$76a88f7de6507443(e) {
    switch(e.type){
        case $f90fe41aaaad6526$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $f90fe41aaaad6526$export$1be1fc439b849fdf($f90fe41aaaad6526$export$660b2ee2d4fb4eff(r), function(r, a, c) {
                    switch($f90fe41aaaad6526$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $f90fe41aaaad6526$export$2f35ab04d2335697(r, 1, $f90fe41aaaad6526$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (c[++a] === "global") c[a] = "", c[++a] = "\f" + $f90fe41aaaad6526$export$2f35ab04d2335697(c[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $f90fe41aaaad6526$export$f9084667e487ed46(c) > 1 ? "" : r;
                                case a = $f90fe41aaaad6526$export$f9084667e487ed46(c) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}



function $cc5529066cfd5337$export$e7b7955c4f1f8c03(message, info) {
    const { path: path, parentSelectors: parentSelectors } = info;
    (0, $26d7cf6379fe7659$export$2e2bcd8739ae039)(false, `[Ant Design CSS-in-JS] ${path ? `Error in ${path}: ` : ""}${message}${parentSelectors.length ? ` Selector: ${parentSelectors.join(" | ")}` : ""}`);
}


const $244faa57726e7665$var$linter = (key, value, info)=>{
    if (key === "content") {
        // From emotion: https://github.com/emotion-js/emotion/blob/main/packages/serialize/src/index.js#L63
        const contentValuePattern = /(attr|counters?|url|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/;
        const contentValues = [
            "normal",
            "none",
            "initial",
            "inherit",
            "unset"
        ];
        if (typeof value !== "string" || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && !value.startsWith("var(") && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) (0, $cc5529066cfd5337$export$e7b7955c4f1f8c03)(`You seem to be using a value for 'content' without quotes, try replacing it with \`content: '"${value}"'\`.`, info);
    }
};
var $244faa57726e7665$export$2e2bcd8739ae039 = $244faa57726e7665$var$linter;



const $0a6026ab593a34c6$var$linter = (key, value, info)=>{
    if (key === "animation") {
        if (info.hashId && value !== "none") (0, $cc5529066cfd5337$export$e7b7955c4f1f8c03)(`You seem to be using hashed animation '${value}', in which case 'animationName' with Keyframe as value is recommended.`, info);
    }
};
var $0a6026ab593a34c6$export$2e2bcd8739ae039 = $0a6026ab593a34c6$var$linter;



function $e553f886d5c70d58$var$isConcatSelector(selector) {
    const notContent = selector.match(/:not\(([^)]*)\)/)?.[1] || "";
    // split selector. e.g.
    // `h1#a.b` => ['h1', #a', '.b']
    const splitCells = notContent.split(/(\[[^[]*])|(?=[.#])/).filter((str)=>str);
    return splitCells.length > 1;
}
function $e553f886d5c70d58$var$parsePath(info) {
    return info.parentSelectors.reduce((prev, cur)=>{
        if (!prev) return cur;
        return cur.includes("&") ? cur.replace(/&/g, prev) : `${prev} ${cur}`;
    }, "");
}
const $e553f886d5c70d58$var$linter = (key, value, info)=>{
    const parentSelectorPath = $e553f886d5c70d58$var$parsePath(info);
    const notList = parentSelectorPath.match(/:not\([^)]*\)/g) || [];
    if (notList.length > 0 && notList.some($e553f886d5c70d58$var$isConcatSelector)) (0, $cc5529066cfd5337$export$e7b7955c4f1f8c03)(`Concat ':not' selector not support in legacy browsers.`, info);
};
var $e553f886d5c70d58$export$2e2bcd8739ae039 = $e553f886d5c70d58$var$linter;



const $e6f1afb836af7a38$var$linter = (key, value, info)=>{
    switch(key){
        case "marginLeft":
        case "marginRight":
        case "paddingLeft":
        case "paddingRight":
        case "left":
        case "right":
        case "borderLeft":
        case "borderLeftWidth":
        case "borderLeftStyle":
        case "borderLeftColor":
        case "borderRight":
        case "borderRightWidth":
        case "borderRightStyle":
        case "borderRightColor":
        case "borderTopLeftRadius":
        case "borderTopRightRadius":
        case "borderBottomLeftRadius":
        case "borderBottomRightRadius":
            (0, $cc5529066cfd5337$export$e7b7955c4f1f8c03)(`You seem to be using non-logical property '${key}' which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties.`, info);
            return;
        case "margin":
        case "padding":
        case "borderWidth":
        case "borderStyle":
            // case 'borderColor':
            if (typeof value === "string") {
                const valueArr = value.split(" ").map((item)=>item.trim());
                if (valueArr.length === 4 && valueArr[1] !== valueArr[3]) (0, $cc5529066cfd5337$export$e7b7955c4f1f8c03)(`You seem to be using '${key}' property with different left ${key} and right ${key}, which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties.`, info);
            }
            return;
        case "clear":
        case "textAlign":
            if (value === "left" || value === "right") (0, $cc5529066cfd5337$export$e7b7955c4f1f8c03)(`You seem to be using non-logical value '${value}' of ${key}, which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties.`, info);
            return;
        case "borderRadius":
            if (typeof value === "string") {
                const radiusGroups = value.split("/").map((item)=>item.trim());
                const invalid = radiusGroups.reduce((result, group)=>{
                    if (result) return result;
                    const radiusArr = group.split(" ").map((item)=>item.trim());
                    // borderRadius: '2px 4px'
                    if (radiusArr.length >= 2 && radiusArr[0] !== radiusArr[1]) return true;
                    // borderRadius: '4px 4px 2px'
                    if (radiusArr.length === 3 && radiusArr[1] !== radiusArr[2]) return true;
                    // borderRadius: '4px 4px 2px 4px'
                    if (radiusArr.length === 4 && radiusArr[2] !== radiusArr[3]) return true;
                    return result;
                }, false);
                if (invalid) (0, $cc5529066cfd5337$export$e7b7955c4f1f8c03)(`You seem to be using non-logical value '${value}' of ${key}, which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties.`, info);
            }
            return;
        default:
    }
};
var $e6f1afb836af7a38$export$2e2bcd8739ae039 = $e6f1afb836af7a38$var$linter;



const $20dc66b8d3ec6387$var$linter = (key, value, info)=>{
    if (typeof value === "string" && /NaN/g.test(value) || Number.isNaN(value)) (0, $cc5529066cfd5337$export$e7b7955c4f1f8c03)(`Unexpected 'NaN' in property '${key}: ${value}'.`, info);
};
var $20dc66b8d3ec6387$export$2e2bcd8739ae039 = $20dc66b8d3ec6387$var$linter;



const $c13e492e0627f8e2$var$linter = (key, value, info)=>{
    if (info.parentSelectors.some((selector)=>{
        const selectors = selector.split(",");
        return selectors.some((item)=>item.split("&").length > 2);
    })) (0, $cc5529066cfd5337$export$e7b7955c4f1f8c03)("Should not use more than one `&` in a selector.", info);
};
var $c13e492e0627f8e2$export$2e2bcd8739ae039 = $c13e492e0627f8e2$var$linter;








const $fcd0c3ab18a0a431$export$1c054aa01963e47e = "data-ant-cssinjs-cache-path";
const $fcd0c3ab18a0a431$export$e0a2f8ff7fc63361 = "_FILE_STYLE__";
function $fcd0c3ab18a0a431$export$dfdc1655ccc5b9cb(cachePathMap) {
    return Object.keys(cachePathMap).map((path)=>{
        const hash = cachePathMap[path];
        return `${path}:${hash}`;
    }).join(";");
}
let $fcd0c3ab18a0a431$var$cachePathMap;
let $fcd0c3ab18a0a431$var$fromCSSFile = true;
function $fcd0c3ab18a0a431$export$aad8462122ac592b(mockCache, fromFile = true) {
    $fcd0c3ab18a0a431$var$cachePathMap = mockCache;
    $fcd0c3ab18a0a431$var$fromCSSFile = fromFile;
}
function $fcd0c3ab18a0a431$export$18298bb220d85216() {
    if (!$fcd0c3ab18a0a431$var$cachePathMap) {
        $fcd0c3ab18a0a431$var$cachePathMap = {};
        if ((0, $78361969822ad097$export$2e2bcd8739ae039)()) {
            const div = document.createElement("div");
            div.className = $fcd0c3ab18a0a431$export$1c054aa01963e47e;
            div.style.position = "fixed";
            div.style.visibility = "hidden";
            div.style.top = "-9999px";
            document.body.appendChild(div);
            let content = getComputedStyle(div).content || "";
            content = content.replace(/^"/, "").replace(/"$/, "");
            // Fill data
            content.split(";").forEach((item)=>{
                const [path, hash] = item.split(":");
                $fcd0c3ab18a0a431$var$cachePathMap[path] = hash;
            });
            // Remove inline record style
            const inlineMapStyle = document.querySelector(`style[${$fcd0c3ab18a0a431$export$1c054aa01963e47e}]`);
            if (inlineMapStyle) {
                $fcd0c3ab18a0a431$var$fromCSSFile = false;
                inlineMapStyle.parentNode?.removeChild(inlineMapStyle);
            }
            document.body.removeChild(div);
        }
    }
}
function $fcd0c3ab18a0a431$export$5aa0d776d676ab98(path) {
    $fcd0c3ab18a0a431$export$18298bb220d85216();
    return !!$fcd0c3ab18a0a431$var$cachePathMap[path];
}
function $fcd0c3ab18a0a431$export$d3851dfd3659b2ce(path) {
    const hash = $fcd0c3ab18a0a431$var$cachePathMap[path];
    let styleStr = null;
    if (hash && (0, $78361969822ad097$export$2e2bcd8739ae039)()) {
        if ($fcd0c3ab18a0a431$var$fromCSSFile) styleStr = $fcd0c3ab18a0a431$export$e0a2f8ff7fc63361;
        else {
            const style = document.querySelector(`style[${(0, $21cab3db22272d25$export$89ce1123b3c0bd9e)}="${$fcd0c3ab18a0a431$var$cachePathMap[path]}"]`);
            if (style) styleStr = style.innerHTML;
            else // Clean up since not exist anymore
            delete $fcd0c3ab18a0a431$var$cachePathMap[path];
        }
    }
    return [
        styleStr,
        hash
    ];
}



const $0fc07301276d48a5$var$SKIP_CHECK = "_skip_check_";
const $0fc07301276d48a5$var$MULTI_VALUE = "_multi_value_";
function $0fc07301276d48a5$export$8756898546458274(styleStr, autoPrefix) {
    const serialized = autoPrefix ? (0, $f90fe41aaaad6526$export$dfdc1655ccc5b9cb)((0, $f90fe41aaaad6526$export$ef7acd7185315e22)(styleStr), (0, $f90fe41aaaad6526$export$5a7767152ae0305f)([
        (0, $f90fe41aaaad6526$export$e08c7d021b829b7a),
        (0, $f90fe41aaaad6526$export$fac44ee5b035f737)
    ])) : (0, $f90fe41aaaad6526$export$dfdc1655ccc5b9cb)((0, $f90fe41aaaad6526$export$ef7acd7185315e22)(styleStr), (0, $f90fe41aaaad6526$export$fac44ee5b035f737));
    return serialized.replace(/\{%%%\:[^;];}/g, ";");
}
function $0fc07301276d48a5$var$isCompoundCSSProperty(value) {
    return typeof value === "object" && value && ($0fc07301276d48a5$var$SKIP_CHECK in value || $0fc07301276d48a5$var$MULTI_VALUE in value);
}
// 注入 hash 值
function $0fc07301276d48a5$var$injectSelectorHash(key, hashId, hashPriority = "high") {
    if (!hashId) return key;
    const hashSelector = (0, $05f34ed03d41967d$export$9c59b80dda569a6e)({
        hashCls: hashId,
        hashPriority: hashPriority
    });
    // 注入 hashId
    const keys = key.split(",").map((k)=>{
        const fullPath = k.trim().split(/\s+/);
        // 如果 Selector 第一个是 HTML Element，那我们就插到它的后面。反之，就插到最前面。
        let firstPath = fullPath[0] || "";
        const htmlElement = firstPath.match(/^\w+/)?.[0] || "";
        firstPath = `${htmlElement}${hashSelector}${firstPath.slice(htmlElement.length)}`;
        return [
            firstPath,
            ...fullPath.slice(1)
        ].join(" ");
    });
    return keys.join(",");
}
const $0fc07301276d48a5$export$e13dc740254f53d7 = (interpolation, config = {}, { root: root, injectHash: injectHash, parentSelectors: parentSelectors } = {
    root: true,
    parentSelectors: []
})=>{
    const { hashId: hashId, layer: layer, path: path, hashPriority: hashPriority, transformers: transformers = [], linters: linters = [] } = config;
    let styleStr = "";
    let effectStyle = {};
    function parseKeyframes(keyframes) {
        const animationName = keyframes.getName(hashId);
        if (!effectStyle[animationName]) {
            const [parsedStr] = $0fc07301276d48a5$export$e13dc740254f53d7(keyframes.style, config, {
                root: false,
                parentSelectors: parentSelectors
            });
            effectStyle[animationName] = `@keyframes ${keyframes.getName(hashId)}${parsedStr}`;
        }
    }
    function flattenList(list, fullList = []) {
        list.forEach((item)=>{
            if (Array.isArray(item)) flattenList(item, fullList);
            else if (item) fullList.push(item);
        });
        return fullList;
    }
    const flattenStyleList = flattenList(Array.isArray(interpolation) ? interpolation : [
        interpolation
    ]);
    flattenStyleList.forEach((originStyle)=>{
        // Only root level can use raw string
        const style = typeof originStyle === "string" && !root ? {} : originStyle;
        if (typeof style === "string") styleStr += `${style}\n`;
        else if (style._keyframe) // Keyframe
        parseKeyframes(style);
        else {
            const mergedStyle = transformers.reduce((prev, trans)=>trans?.visit?.(prev) || prev, style);
            // Normal CSSObject
            Object.keys(mergedStyle).forEach((key)=>{
                const value = mergedStyle[key];
                if (typeof value === "object" && value && (key !== "animationName" || !value._keyframe) && !$0fc07301276d48a5$var$isCompoundCSSProperty(value)) {
                    let subInjectHash = false;
                    // 当成嵌套对象来处理
                    let mergedKey = key.trim();
                    // Whether treat child as root. In most case it is false.
                    let nextRoot = false;
                    // 拆分多个选择器
                    if ((root || injectHash) && hashId) {
                        if (mergedKey.startsWith("@")) // 略过媒体查询，交给子节点继续插入 hashId
                        subInjectHash = true;
                        else if (mergedKey === "&") // 抹掉 root selector 上的单个 &
                        mergedKey = $0fc07301276d48a5$var$injectSelectorHash("", hashId, hashPriority);
                        else // 注入 hashId
                        mergedKey = $0fc07301276d48a5$var$injectSelectorHash(key, hashId, hashPriority);
                    } else if (root && !hashId && (mergedKey === "&" || mergedKey === "")) {
                        // In case of `{ '&': { a: { color: 'red' } } }` or `{ '': { a: { color: 'red' } } }` without hashId,
                        // we will get `&{a:{color:red;}}` or `{a:{color:red;}}` string for stylis to compile.
                        // But it does not conform to stylis syntax,
                        // and finally we will get `{color:red;}` as css, which is wrong.
                        // So we need to remove key in root, and treat child `{ a: { color: 'red' } }` as root.
                        mergedKey = "";
                        nextRoot = true;
                    }
                    const [parsedStr, childEffectStyle] = $0fc07301276d48a5$export$e13dc740254f53d7(value, config, {
                        root: nextRoot,
                        injectHash: subInjectHash,
                        parentSelectors: [
                            ...parentSelectors,
                            mergedKey
                        ]
                    });
                    effectStyle = {
                        ...effectStyle,
                        ...childEffectStyle
                    };
                    styleStr += `${mergedKey}${parsedStr}`;
                } else {
                    function appendStyle(cssKey, cssValue) {
                        var linter;
                        // 如果是样式则直接插入
                        const styleName = cssKey.replace(/[A-Z]/g, (match)=>`-${match.toLowerCase()}`);
                        // Auto suffix with px
                        let formatValue = cssValue;
                        if (!(0, $ff9ab6c93114df17$export$2e2bcd8739ae039)[cssKey] && typeof formatValue === "number" && formatValue !== 0) formatValue = `${formatValue}px`;
                        // handle animationName & Keyframe value
                        if (cssKey === "animationName" && cssValue?._keyframe) {
                            parseKeyframes(cssValue);
                            formatValue = cssValue.getName(hashId);
                        }
                        styleStr += `${styleName}:${formatValue};`;
                    }
                    const actualValue = value?.value ?? value;
                    if (typeof value === "object" && value?.[$0fc07301276d48a5$var$MULTI_VALUE] && Array.isArray(actualValue)) actualValue.forEach((item)=>{
                        appendStyle(key, item);
                    });
                    else if ((0, $05f34ed03d41967d$export$826fff653a329e83)(actualValue)) appendStyle(key, actualValue);
                }
            });
        }
    });
    if (!root) styleStr = `{${styleStr}}`;
    else if (layer) {
        // fixme: https://github.com/thysultan/stylis/pull/339
        if (styleStr) styleStr = `@layer ${layer.name} {${styleStr}}`;
        if (layer.dependencies) effectStyle[`@layer ${layer.name}`] = layer.dependencies.map((deps)=>`@layer ${deps}, ${layer.name};`).join("\n");
    }
    return [
        styleStr,
        effectStyle
    ];
};
function $0fc07301276d48a5$export$412618713057f6ca(path, styleStr) {
    return (0, $6ed32536c828ace4$export$2e2bcd8739ae039)(`${path.join("%")}${styleStr}`);
}
const $0fc07301276d48a5$export$1e6d9f0d06c7ec14 = "style";
function $0fc07301276d48a5$export$2e2bcd8739ae039(info, styleFn) {
    const { path: path, hashId: hashId, layer: layer, nonce: nonce, clientOnly: clientOnly, order: order = 0 } = info;
    const { mock: mock, hashPriority: hashPriority, container: container, transformers: transformers, linters: linters, cache: cache, layer: enableLayer, autoPrefix: autoPrefix } = $cQmXV.useContext((0, $21cab3db22272d25$export$2e2bcd8739ae039));
    const fullPath = [
        hashId || ""
    ];
    if (enableLayer) fullPath.push("layer");
    fullPath.push(...path);
    // Check if need insert style
    let isMergedClientSide = (0, $05f34ed03d41967d$export$9542afab8c2a5f48);
    (0, $ebd32f83d3ce5163$export$2e2bcd8739ae039)($0fc07301276d48a5$export$1e6d9f0d06c7ec14, fullPath, // Create cache if needed
    ()=>{
        const cachePath = fullPath.join("|");
        // Get style from SSR inline style directly
        if ((0, $fcd0c3ab18a0a431$export$5aa0d776d676ab98)(cachePath)) {
            const [inlineCacheStyleStr, styleHash] = (0, $fcd0c3ab18a0a431$export$d3851dfd3659b2ce)(cachePath);
            if (inlineCacheStyleStr) return [
                inlineCacheStyleStr,
                styleHash,
                {},
                clientOnly,
                order
            ];
        }
        // Generate style
        const styleObj = styleFn();
        const [parsedStyle, effectStyle] = $0fc07301276d48a5$export$e13dc740254f53d7(styleObj, {
            hashId: hashId,
            hashPriority: hashPriority,
            layer: enableLayer ? layer : undefined,
            path: path.join("-"),
            transformers: transformers,
            linters: linters
        });
        const styleStr = $0fc07301276d48a5$export$8756898546458274(parsedStyle, autoPrefix || false);
        const styleId = $0fc07301276d48a5$export$412618713057f6ca(fullPath, styleStr);
        return [
            styleStr,
            styleId,
            effectStyle,
            clientOnly,
            order
        ];
    }, // Remove cache if no need
    (cacheValue, fromHMR)=>{
        const [, styleId] = cacheValue;
        if (fromHMR && (0, $05f34ed03d41967d$export$9542afab8c2a5f48)) (0, $449b73243fa975a1$export$2232e336aecaa80a)(styleId, {
            mark: (0, $21cab3db22272d25$export$89ce1123b3c0bd9e),
            attachTo: container
        });
    }, // Effect: Inject style here
    (cacheValue)=>{
        const [styleStr, styleId, effectStyle, , priority] = cacheValue;
        if (isMergedClientSide && styleStr !== (0, $fcd0c3ab18a0a431$export$e0a2f8ff7fc63361)) {
            let mergedCSSConfig = {
                mark: (0, $21cab3db22272d25$export$89ce1123b3c0bd9e),
                prepend: enableLayer ? false : "queue",
                attachTo: container,
                priority: priority
            };
            mergedCSSConfig = (0, $05f34ed03d41967d$export$f508583337ce246)(mergedCSSConfig, nonce);
            // ================= Split Effect Style =================
            // We will split effectStyle here since @layer should be at the top level
            const effectLayerKeys = [];
            const effectRestKeys = [];
            Object.keys(effectStyle).forEach((key)=>{
                if (key.startsWith("@layer")) effectLayerKeys.push(key);
                else effectRestKeys.push(key);
            });
            // ================= Inject Layer Style =================
            // Inject layer style
            effectLayerKeys.forEach((effectKey)=>{
                (0, $449b73243fa975a1$export$4d99a2890bb989f0)($0fc07301276d48a5$export$8756898546458274(effectStyle[effectKey], autoPrefix || false), `_layer-${effectKey}`, {
                    ...mergedCSSConfig,
                    prepend: true
                });
            });
            // ==================== Inject Style ====================
            // Inject style
            const style = (0, $449b73243fa975a1$export$4d99a2890bb989f0)(styleStr, styleId, mergedCSSConfig);
            style[0, $21cab3db22272d25$export$4c16a0c02134a7dc] = cache.instanceId;
            // ================ Inject Effect Style =================
            // Inject client side effect style
            effectRestKeys.forEach((effectKey)=>{
                (0, $449b73243fa975a1$export$4d99a2890bb989f0)($0fc07301276d48a5$export$8756898546458274(effectStyle[effectKey], autoPrefix || false), `_effect-${effectKey}`, mergedCSSConfig);
            });
        }
    });
}
const $0fc07301276d48a5$export$f9380c9a627682d3 = (cache, effectStyles, options)=>{
    const [styleStr, styleId, effectStyle, clientOnly, order] = cache;
    const { plain: plain, autoPrefix: autoPrefix } = options || {};
    // Skip client only style
    if (clientOnly) return null;
    let keyStyleText = styleStr;
    // ====================== Share ======================
    // Used for @rc-component/util
    const sharedAttrs = {
        "data-rc-order": "prependQueue",
        "data-rc-priority": `${order}`
    };
    // ====================== Style ======================
    keyStyleText = (0, $05f34ed03d41967d$export$71c98ec84f0481d3)(styleStr, undefined, styleId, sharedAttrs, plain);
    // =============== Create effect style ===============
    if (effectStyle) Object.keys(effectStyle).forEach((effectKey)=>{
        // Effect style can be reused
        if (!effectStyles[effectKey]) {
            effectStyles[effectKey] = true;
            const effectStyleStr = $0fc07301276d48a5$export$8756898546458274(effectStyle[effectKey], autoPrefix || false);
            const effectStyleHTML = (0, $05f34ed03d41967d$export$71c98ec84f0481d3)(effectStyleStr, undefined, `_effect-${effectKey}`, sharedAttrs, plain);
            if (effectKey.startsWith("@layer")) keyStyleText = effectStyleHTML + keyStyleText;
            else keyStyleText += effectStyleHTML;
        }
    });
    return [
        order,
        styleId,
        keyStyleText
    ];
};


const $496ed4f36d7e1f98$export$d96c342855c5e1fc = "cssVar";
const $496ed4f36d7e1f98$var$useCSSVarRegister = (config, fn)=>{
    const { key: key, prefix: prefix, unitless: unitless, ignore: ignore, token: token, hashId: hashId, scope: scope, nonce: nonce } = config;
    const { cache: { instanceId: instanceId }, container: container, hashPriority: hashPriority } = (0, $cQmXV.useContext)((0, $21cab3db22272d25$export$2e2bcd8739ae039));
    const { _tokenKey: tokenKey } = token;
    const scopeKey = Array.isArray(scope) ? scope.join("@@") : scope;
    const stylePath = [
        ...config.path,
        key,
        scopeKey,
        tokenKey
    ];
    const cache = (0, $ebd32f83d3ce5163$export$2e2bcd8739ae039)($496ed4f36d7e1f98$export$d96c342855c5e1fc, stylePath, ()=>{
        const originToken = fn();
        const [mergedToken, cssVarsStr] = (0, $bf825bc7ff5f466f$export$67858afe85bce49f)(originToken, key, {
            prefix: prefix,
            unitless: unitless,
            ignore: ignore,
            scope: scope,
            hashPriority: hashPriority,
            hashCls: hashId
        });
        const styleId = (0, $0fc07301276d48a5$export$412618713057f6ca)(stylePath, cssVarsStr);
        return [
            mergedToken,
            cssVarsStr,
            styleId,
            key
        ];
    }, ([, , styleId])=>{
        if (0, $05f34ed03d41967d$export$9542afab8c2a5f48) (0, $449b73243fa975a1$export$2232e336aecaa80a)(styleId, {
            mark: (0, $21cab3db22272d25$export$89ce1123b3c0bd9e),
            attachTo: container
        });
    }, ([, cssVarsStr, styleId])=>{
        if (!cssVarsStr) return;
        let mergedCSSConfig = {
            mark: (0, $21cab3db22272d25$export$89ce1123b3c0bd9e),
            prepend: "queue",
            attachTo: container,
            priority: -999
        };
        mergedCSSConfig = (0, $05f34ed03d41967d$export$f508583337ce246)(mergedCSSConfig, nonce);
        const style = (0, $449b73243fa975a1$export$4d99a2890bb989f0)(cssVarsStr, styleId, mergedCSSConfig);
        style[0, $21cab3db22272d25$export$4c16a0c02134a7dc] = instanceId;
        // Used for `useCacheToken` to remove on batch when token removed
        style.setAttribute((0, $21cab3db22272d25$export$5d99297dcd5476ac), key);
    });
    return cache;
};
const $496ed4f36d7e1f98$export$f9380c9a627682d3 = (cache, effectStyles, options)=>{
    const [, styleStr, styleId, cssVarKey] = cache;
    const { plain: plain } = options || {};
    if (!styleStr) return null;
    const order = -999;
    // ====================== Style ======================
    // Used for @rc-component/util
    const sharedAttrs = {
        "data-rc-order": "prependQueue",
        "data-rc-priority": `${order}`
    };
    const styleText = (0, $05f34ed03d41967d$export$71c98ec84f0481d3)(styleStr, cssVarKey, styleId, sharedAttrs, plain);
    return [
        order,
        styleId,
        styleText
    ];
};
var $496ed4f36d7e1f98$export$2e2bcd8739ae039 = $496ed4f36d7e1f98$var$useCSSVarRegister;





const $59aa42e78d2fc67e$var$ExtractStyleFns = {
    [(0, $0fc07301276d48a5$export$1e6d9f0d06c7ec14)]: (0, $0fc07301276d48a5$export$f9380c9a627682d3),
    [(0, $5a9aa371498f42c7$export$270fba097347f4fa)]: (0, $5a9aa371498f42c7$export$f9380c9a627682d3),
    [(0, $496ed4f36d7e1f98$export$d96c342855c5e1fc)]: (0, $496ed4f36d7e1f98$export$f9380c9a627682d3)
};
function $59aa42e78d2fc67e$var$isNotNull(value) {
    return value !== null;
}
function $59aa42e78d2fc67e$export$2e2bcd8739ae039(cache, options) {
    const { plain: plain = false, types: types = [
        "style",
        "token",
        "cssVar"
    ], once: once = false } = typeof options === "boolean" ? {
        plain: options
    } : options || {};
    const matchPrefixRegexp = new RegExp(`^(${(typeof types === "string" ? [
        types
    ] : types).join("|")})%`);
    // prefix with `style` is used for `useStyleRegister` to cache style context
    const styleKeys = Array.from(cache.cache.keys()).filter((key)=>matchPrefixRegexp.test(key));
    // Common effect styles like animation
    const effectStyles = {};
    // Mapping of cachePath to style hash
    const cachePathMap = {};
    let styleText = "";
    styleKeys.map((key)=>{
        if (once && cache.extracted.has(key)) return null; // Skip if already extracted
        const cachePath = key.replace(matchPrefixRegexp, "").replace(/%/g, "|");
        const [prefix] = key.split("%");
        const extractFn = $59aa42e78d2fc67e$var$ExtractStyleFns[prefix];
        const extractedStyle = extractFn(cache.cache.get(key)[1], effectStyles, {
            plain: plain
        });
        if (!extractedStyle) return null;
        const updateTime = cache.updateTimes.get(key) || 0;
        const [order, styleId, styleStr] = extractedStyle;
        if (key.startsWith("style")) cachePathMap[cachePath] = styleId;
        // record that this style has been extracted
        cache.extracted.add(key);
        return [
            order,
            styleStr,
            updateTime
        ];
    }).filter($59aa42e78d2fc67e$var$isNotNull).sort(([o1, , u1], [o2, , u2])=>{
        if (o1 !== o2) return o1 - o2;
        return u1 - u2;
    }).forEach(([, style])=>{
        styleText += style;
    });
    // ==================== Fill Cache Path ====================
    styleText += (0, $05f34ed03d41967d$export$71c98ec84f0481d3)(`.${(0, $fcd0c3ab18a0a431$export$1c054aa01963e47e)}{content:"${(0, $fcd0c3ab18a0a431$export$dfdc1655ccc5b9cb)(cachePathMap)}";}`, undefined, undefined, {
        [(0, $fcd0c3ab18a0a431$export$1c054aa01963e47e)]: (0, $fcd0c3ab18a0a431$export$1c054aa01963e47e)
    }, plain);
    return styleText;
}





class $e928d3664c9ed565$var$Keyframe {
    name;
    style;
    constructor(name, style){
        this.name = name;
        this.style = style;
    }
    getName(hashId = "") {
        return hashId ? `${hashId}-${this.name}` : this.name;
    }
    _keyframe = true;
}
var $e928d3664c9ed565$export$2e2bcd8739ae039 = $e928d3664c9ed565$var$Keyframe;






function $ffee4cf456d8537f$var$splitValues(value) {
    if (typeof value === "number") return [
        [
            value
        ],
        false
    ];
    const rawStyle = String(value).trim();
    const importantCells = rawStyle.match(/(.*)(!important)/);
    const splitStyle = (importantCells ? importantCells[1] : rawStyle).trim().split(/\s+/);
    // Combine styles split in brackets, like `calc(1px + 2px)`
    let temp = [];
    let brackets = 0;
    return [
        splitStyle.reduce((list, item)=>{
            if (item.includes("(") || item.includes(")")) {
                const left = item.split("(").length - 1;
                const right = item.split(")").length - 1;
                brackets += left - right;
            }
            if (brackets >= 0) temp.push(item);
            if (brackets === 0) {
                list.push(temp.join(" "));
                temp = [];
            }
            return list;
        }, []),
        !!importantCells
    ];
}
function $ffee4cf456d8537f$var$noSplit(list) {
    list.notSplit = true;
    return list;
}
const $ffee4cf456d8537f$var$keyMap = {
    // Inset
    inset: [
        "top",
        "right",
        "bottom",
        "left"
    ],
    insetBlock: [
        "top",
        "bottom"
    ],
    insetBlockStart: [
        "top"
    ],
    insetBlockEnd: [
        "bottom"
    ],
    insetInline: [
        "left",
        "right"
    ],
    insetInlineStart: [
        "left"
    ],
    insetInlineEnd: [
        "right"
    ],
    // Margin
    marginBlock: [
        "marginTop",
        "marginBottom"
    ],
    marginBlockStart: [
        "marginTop"
    ],
    marginBlockEnd: [
        "marginBottom"
    ],
    marginInline: [
        "marginLeft",
        "marginRight"
    ],
    marginInlineStart: [
        "marginLeft"
    ],
    marginInlineEnd: [
        "marginRight"
    ],
    // Padding
    paddingBlock: [
        "paddingTop",
        "paddingBottom"
    ],
    paddingBlockStart: [
        "paddingTop"
    ],
    paddingBlockEnd: [
        "paddingBottom"
    ],
    paddingInline: [
        "paddingLeft",
        "paddingRight"
    ],
    paddingInlineStart: [
        "paddingLeft"
    ],
    paddingInlineEnd: [
        "paddingRight"
    ],
    // Border
    borderBlock: $ffee4cf456d8537f$var$noSplit([
        "borderTop",
        "borderBottom"
    ]),
    borderBlockStart: $ffee4cf456d8537f$var$noSplit([
        "borderTop"
    ]),
    borderBlockEnd: $ffee4cf456d8537f$var$noSplit([
        "borderBottom"
    ]),
    borderInline: $ffee4cf456d8537f$var$noSplit([
        "borderLeft",
        "borderRight"
    ]),
    borderInlineStart: $ffee4cf456d8537f$var$noSplit([
        "borderLeft"
    ]),
    borderInlineEnd: $ffee4cf456d8537f$var$noSplit([
        "borderRight"
    ]),
    // Border width
    borderBlockWidth: [
        "borderTopWidth",
        "borderBottomWidth"
    ],
    borderBlockStartWidth: [
        "borderTopWidth"
    ],
    borderBlockEndWidth: [
        "borderBottomWidth"
    ],
    borderInlineWidth: [
        "borderLeftWidth",
        "borderRightWidth"
    ],
    borderInlineStartWidth: [
        "borderLeftWidth"
    ],
    borderInlineEndWidth: [
        "borderRightWidth"
    ],
    // Border style
    borderBlockStyle: [
        "borderTopStyle",
        "borderBottomStyle"
    ],
    borderBlockStartStyle: [
        "borderTopStyle"
    ],
    borderBlockEndStyle: [
        "borderBottomStyle"
    ],
    borderInlineStyle: [
        "borderLeftStyle",
        "borderRightStyle"
    ],
    borderInlineStartStyle: [
        "borderLeftStyle"
    ],
    borderInlineEndStyle: [
        "borderRightStyle"
    ],
    // Border color
    borderBlockColor: [
        "borderTopColor",
        "borderBottomColor"
    ],
    borderBlockStartColor: [
        "borderTopColor"
    ],
    borderBlockEndColor: [
        "borderBottomColor"
    ],
    borderInlineColor: [
        "borderLeftColor",
        "borderRightColor"
    ],
    borderInlineStartColor: [
        "borderLeftColor"
    ],
    borderInlineEndColor: [
        "borderRightColor"
    ],
    // Border radius
    borderStartStartRadius: [
        "borderTopLeftRadius"
    ],
    borderStartEndRadius: [
        "borderTopRightRadius"
    ],
    borderEndStartRadius: [
        "borderBottomLeftRadius"
    ],
    borderEndEndRadius: [
        "borderBottomRightRadius"
    ]
};
function $ffee4cf456d8537f$var$wrapImportantAndSkipCheck(value, important) {
    let parsedValue = value;
    if (important) parsedValue = `${parsedValue} !important`;
    return {
        _skip_check_: true,
        value: parsedValue
    };
}
/**
 * Convert css logical properties to legacy properties.
 * Such as: `margin-block-start` to `margin-top`.
 * Transform list:
 * - inset
 * - margin
 * - padding
 * - border
 */ const $ffee4cf456d8537f$var$transform = {
    visit: (cssObj)=>{
        const clone = {};
        Object.keys(cssObj).forEach((key)=>{
            const value = cssObj[key];
            const matchValue = $ffee4cf456d8537f$var$keyMap[key];
            if (matchValue && (typeof value === "number" || typeof value === "string")) {
                const [values, important] = $ffee4cf456d8537f$var$splitValues(value);
                if (matchValue.length && matchValue.notSplit) // not split means always give same value like border
                matchValue.forEach((matchKey)=>{
                    clone[matchKey] = $ffee4cf456d8537f$var$wrapImportantAndSkipCheck(value, important);
                });
                else if (matchValue.length === 1) // Handle like `marginBlockStart` => `marginTop`
                clone[matchValue[0]] = $ffee4cf456d8537f$var$wrapImportantAndSkipCheck(values[0], important);
                else if (matchValue.length === 2) // Handle like `marginBlock` => `marginTop` & `marginBottom`
                matchValue.forEach((matchKey, index)=>{
                    clone[matchKey] = $ffee4cf456d8537f$var$wrapImportantAndSkipCheck(values[index] ?? values[0], important);
                });
                else if (matchValue.length === 4) // Handle like `inset` => `top` & `right` & `bottom` & `left`
                matchValue.forEach((matchKey, index)=>{
                    clone[matchKey] = $ffee4cf456d8537f$var$wrapImportantAndSkipCheck(values[index] ?? values[index - 2] ?? values[0], important);
                });
                else clone[key] = value;
            } else clone[key] = value;
        });
        return clone;
    }
};
var $ffee4cf456d8537f$export$2e2bcd8739ae039 = $ffee4cf456d8537f$var$transform;


/**
 * respect https://github.com/cuth/postcss-pxtorem
 */ // @ts-ignore

const $d24557675b66506c$var$pxRegex = /url\([^)]+\)|var\([^)]+\)|(\d*\.?\d+)px/g;
function $d24557675b66506c$var$toFixed(number, precision) {
    const multiplier = Math.pow(10, precision + 1), wholeNumber = Math.floor(number * multiplier);
    return Math.round(wholeNumber / 10) * 10 / multiplier;
}
const $d24557675b66506c$var$transform = (options = {})=>{
    const { rootValue: rootValue = 16, precision: precision = 5, mediaQuery: mediaQuery = false } = options;
    const pxReplace = (m, $1)=>{
        if (!$1) return m;
        const pixels = parseFloat($1);
        // covenant: pixels <= 1, not transform to rem @zombieJ
        if (pixels <= 1) return m;
        const fixedVal = $d24557675b66506c$var$toFixed(pixels / rootValue, precision);
        return `${fixedVal}rem`;
    };
    const visit = (cssObj)=>{
        const clone = {
            ...cssObj
        };
        Object.entries(cssObj).forEach(([key, value])=>{
            if (typeof value === "string" && value.includes("px")) {
                const newValue = value.replace($d24557675b66506c$var$pxRegex, pxReplace);
                clone[key] = newValue;
            }
            // no unit
            if (!(0, $ff9ab6c93114df17$export$2e2bcd8739ae039)[key] && typeof value === "number" && value !== 0) clone[key] = `${value}px`.replace($d24557675b66506c$var$pxRegex, pxReplace);
            // Media queries
            const mergedKey = key.trim();
            if (mergedKey.startsWith("@") && mergedKey.includes("px") && mediaQuery) {
                const newKey = key.replace($d24557675b66506c$var$pxRegex, pxReplace);
                clone[newKey] = clone[key];
                delete clone[key];
            }
        });
        return clone;
    };
    return {
        visit: visit
    };
};
var $d24557675b66506c$export$2e2bcd8739ae039 = $d24557675b66506c$var$transform;




const $71fac7cd04ff2c94$export$73abaea5066f503b = {
    supportModernCSS: ()=>(0, $05f34ed03d41967d$export$f51d3b8ac4ac9ed1)() && (0, $05f34ed03d41967d$export$64a912f57d5de48e)()
};



var $cQmXV = parcelRequire("cQmXV");
const $92d549a1da97eca7$var$IconContext = /*#__PURE__*/ (0, $cQmXV.createContext)({});
var $92d549a1da97eca7$export$2e2bcd8739ae039 = $92d549a1da97eca7$var$IconContext;



var $cQmXV = parcelRequire("cQmXV");
const $eeae8f903af414c5$var$useEvent = (callback)=>{
    const fnRef = $cQmXV.useRef(callback);
    fnRef.current = callback;
    const memoFn = $cQmXV.useCallback((...args)=>fnRef.current?.(...args), []);
    return memoFn;
};
var $eeae8f903af414c5$export$2e2bcd8739ae039 = $eeae8f903af414c5$var$useEvent;




var $cQmXV = parcelRequire("cQmXV");

/**
 * Wrap `React.useLayoutEffect` which will not throw warning message in test env
 */ const $7673d874dab69d07$var$useInternalLayoutEffect = (0, $78361969822ad097$export$2e2bcd8739ae039)() ? $cQmXV.useLayoutEffect : $cQmXV.useEffect;
const $7673d874dab69d07$var$useLayoutEffect = (callback, deps)=>{
    const firstMountRef = $cQmXV.useRef(true);
    $7673d874dab69d07$var$useInternalLayoutEffect(()=>{
        return callback(firstMountRef.current);
    }, deps);
    // We tell react that first mount has passed
    $7673d874dab69d07$var$useInternalLayoutEffect(()=>{
        firstMountRef.current = false;
        return ()=>{
            firstMountRef.current = true;
        };
    }, []);
};
const $7673d874dab69d07$export$9283e56bae2f7b0f = (callback, deps)=>{
    $7673d874dab69d07$var$useLayoutEffect((firstMount)=>{
        if (!firstMount) return callback();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
};
var $7673d874dab69d07$export$2e2bcd8739ae039 = $7673d874dab69d07$var$useLayoutEffect;



var $cQmXV = parcelRequire("cQmXV");
/**
 * Same as React.useState but `setState` accept `ignoreDestroy` param to not to setState after destroyed.
 * We do not make this auto is to avoid real memory leak.
 * Developer should confirm it's safe to ignore themselves.
 */ const $8caa85071cca5555$var$useSafeState = (defaultValue)=>{
    const destroyRef = $cQmXV.useRef(false);
    const [value, setValue] = $cQmXV.useState(defaultValue);
    $cQmXV.useEffect(()=>{
        destroyRef.current = false;
        return ()=>{
            destroyRef.current = true;
        };
    }, []);
    function safeSetState(updater, ignoreDestroy) {
        if (ignoreDestroy && destroyRef.current) return;
        setValue(updater);
    }
    return [
        value,
        safeSetState
    ];
};
var $8caa85071cca5555$export$2e2bcd8739ae039 = $8caa85071cca5555$var$useSafeState;


/** We only think `undefined` is empty */ function $54ca439e0bf0b8d7$var$hasValue(value) {
    return value !== undefined;
}
function $54ca439e0bf0b8d7$export$2e2bcd8739ae039(defaultStateValue, option) {
    const { defaultValue: defaultValue, value: value, onChange: onChange, postState: postState } = option || {};
    // ======================= Init =======================
    const [innerValue, setInnerValue] = (0, $8caa85071cca5555$export$2e2bcd8739ae039)(()=>{
        if ($54ca439e0bf0b8d7$var$hasValue(value)) return value;
        else if ($54ca439e0bf0b8d7$var$hasValue(defaultValue)) return typeof defaultValue === "function" ? defaultValue() : defaultValue;
        else return typeof defaultStateValue === "function" ? defaultStateValue() : defaultStateValue;
    });
    const mergedValue = value !== undefined ? value : innerValue;
    const postMergedValue = postState ? postState(mergedValue) : mergedValue;
    // ====================== Change ======================
    const onChangeFn = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)(onChange);
    const [prevValue, setPrevValue] = (0, $8caa85071cca5555$export$2e2bcd8739ae039)([
        mergedValue
    ]);
    (0, $7673d874dab69d07$export$9283e56bae2f7b0f)(()=>{
        const prev = prevValue[0];
        if (innerValue !== prev) onChangeFn(innerValue, prev);
    }, [
        prevValue
    ]);
    // Sync value back to `undefined` when it from control to un-control
    (0, $7673d874dab69d07$export$9283e56bae2f7b0f)(()=>{
        if (!$54ca439e0bf0b8d7$var$hasValue(value)) setInnerValue(value);
    }, [
        value
    ]);
    // ====================== Update ======================
    const triggerChange = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((updater, ignoreDestroy)=>{
        setInnerValue(updater, ignoreDestroy);
        setPrevValue([
            mergedValue
        ], ignoreDestroy);
    });
    return [
        postMergedValue,
        triggerChange
    ];
}



var $cQmXV = parcelRequire("cQmXV");

function $a51866d781137e08$export$2e2bcd8739ae039(defaultStateValue, value) {
    const [innerValue, setInnerValue] = (0, $cQmXV.useState)(defaultStateValue);
    const mergedValue = value !== undefined ? value : innerValue;
    (0, $7673d874dab69d07$export$2e2bcd8739ae039)((mount)=>{
        if (!mount) setInnerValue(value);
    }, [
        value
    ]);
    return [
        // Value
        mergedValue,
        // Update function
        setInnerValue
    ];
}



var $cQmXV = parcelRequire("cQmXV");
let $905c53b807de704e$var$raf = (callback)=>+setTimeout(callback, 16);
let $905c53b807de704e$var$caf = (num)=>clearTimeout(num);
if (typeof window !== "undefined" && "requestAnimationFrame" in window) {
    $905c53b807de704e$var$raf = (callback)=>window.requestAnimationFrame(callback);
    $905c53b807de704e$var$caf = (handle)=>window.cancelAnimationFrame(handle);
}
let $905c53b807de704e$var$rafUUID = 0;
const $905c53b807de704e$var$rafIds = new Map();
function $905c53b807de704e$var$cleanup(id) {
    $905c53b807de704e$var$rafIds.delete(id);
}
const $905c53b807de704e$var$wrapperRaf = (callback, times = 1)=>{
    $905c53b807de704e$var$rafUUID += 1;
    const id = $905c53b807de704e$var$rafUUID;
    function callRef(leftTimes) {
        if (leftTimes === 0) {
            // Clean up
            $905c53b807de704e$var$cleanup(id);
            // Trigger
            callback();
        } else {
            // Next raf
            const realId = $905c53b807de704e$var$raf(()=>{
                callRef(leftTimes - 1);
            });
            // Bind real raf id
            $905c53b807de704e$var$rafIds.set(id, realId);
        }
    }
    callRef(times);
    return id;
};
$905c53b807de704e$var$wrapperRaf.cancel = (id)=>{
    const realId = $905c53b807de704e$var$rafIds.get(id);
    $905c53b807de704e$var$cleanup(id);
    return $905c53b807de704e$var$caf(realId);
};
var $905c53b807de704e$export$2e2bcd8739ae039 = $905c53b807de704e$var$wrapperRaf;



function $f0cf805f93abd5af$export$2e2bcd8739ae039(defaultValue) {
    const [value, setValue] = $cQmXV.useState(defaultValue);
    const delayRef = $cQmXV.useRef(null);
    const cancelPending = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)(()=>{
        if (delayRef.current) {
            const [isRaf, delay] = delayRef.current;
            if (isRaf) (0, $905c53b807de704e$export$2e2bcd8739ae039).cancel(delay);
            else clearTimeout(delay);
            delayRef.current = null;
        }
    });
    const setDelayValue = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((nextValue, immediatelyOrDelay)=>{
        const delayConfig = immediatelyOrDelay || {
            frame: 1
        };
        cancelPending();
        if (delayConfig === true) setValue(nextValue);
        else if ("ms" in delayConfig) delayRef.current = [
            false,
            setTimeout(()=>setValue(nextValue), delayConfig.ms)
        ];
        else delayRef.current = [
            true,
            (0, $905c53b807de704e$export$2e2bcd8739ae039)(()=>setValue(nextValue), delayConfig.frame)
        ];
    });
    return [
        value,
        setDelayValue
    ];
}



var $cQmXV = parcelRequire("cQmXV");
function $a2da91bb60e2cbfb$var$getUseId() {
    // We need fully clone React function here to avoid webpack warning React 17 do not export `useId`
    const fullClone = {
        ...$cQmXV
    };
    return fullClone.useId;
}
let $a2da91bb60e2cbfb$var$uuid = 0;
function $a2da91bb60e2cbfb$export$2f0435a662835942() {}
function $a2da91bb60e2cbfb$export$218c8c3169c024d2(prefix, key) {
    // React.Key can be string | number, convert to string first
    const keyStr = String(key);
    // Valid id characters: letters, digits, hyphen, underscore, colon, period
    // Replace all invalid characters (including spaces) with hyphens to preserve length
    const sanitizedKey = keyStr.replace(/[^a-zA-Z0-9_.:-]/g, "-");
    return `${prefix}-${sanitizedKey}`;
}
const $a2da91bb60e2cbfb$var$useOriginId = $a2da91bb60e2cbfb$var$getUseId();
var $a2da91bb60e2cbfb$export$2e2bcd8739ae039 = $a2da91bb60e2cbfb$var$useOriginId ? // Use React `useId`
function useId(id) {
    const reactId = $a2da91bb60e2cbfb$var$useOriginId();
    // Developer passed id is single source of truth
    if (id) return id;
    return reactId;
} : // Use compatible of `useId`
function useCompatId(id) {
    // Inner id for accessibility usage. Only work in client side
    const [innerId, setInnerId] = $cQmXV.useState("ssr-id");
    $cQmXV.useEffect(()=>{
        const nextId = $a2da91bb60e2cbfb$var$uuid;
        $a2da91bb60e2cbfb$var$uuid += 1;
        setInnerId(`rc_unique_${nextId}`);
    }, []);
    // Developer passed id is single source of truth
    if (id) return id;
    // Return react native id or inner id
    return innerId;
};






var $cQmXV = parcelRequire("cQmXV");

/**
 * Same as React.useState but will always get latest state.
 * This is useful when React merge multiple state updates into one.
 * e.g. onTransitionEnd trigger multiple event at once will be merged state update in React.
 */ function $ca0e9e88b17f6373$var$useSyncState(defaultValue) {
    const [, forceUpdate] = $cQmXV.useReducer((x)=>x + 1, 0);
    const currentValueRef = $cQmXV.useRef(defaultValue);
    const getValue = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)(()=>{
        return currentValueRef.current;
    });
    const setValue = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((updater)=>{
        currentValueRef.current = typeof updater === "function" ? updater(currentValueRef.current) : updater;
        forceUpdate();
    });
    return [
        getValue,
        setValue
    ];
}
var $ca0e9e88b17f6373$export$2e2bcd8739ae039 = $ca0e9e88b17f6373$var$useSyncState;



var $cQmXV = parcelRequire("cQmXV");
var $aa1fd19150b5249e$exports = {};
"use strict";

$aa1fd19150b5249e$exports = (parcelRequire("kaDml"));



const $0b5ff2deb7eed9f1$var$REACT_ELEMENT_TYPE_18 = Symbol.for("react.element");
const $0b5ff2deb7eed9f1$var$REACT_ELEMENT_TYPE_19 = Symbol.for("react.transitional.element");
const $0b5ff2deb7eed9f1$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $0b5ff2deb7eed9f1$export$2e2bcd8739ae039(object) {
    return(// Base object type
    object && typeof object === "object" && // React Element type
    (object.$$typeof === $0b5ff2deb7eed9f1$var$REACT_ELEMENT_TYPE_18 || object.$$typeof === $0b5ff2deb7eed9f1$var$REACT_ELEMENT_TYPE_19) && // React Fragment type
    object.type === $0b5ff2deb7eed9f1$var$REACT_FRAGMENT_TYPE);
}


const $10341b937b26f69d$var$ReactMajorVersion = Number((0, $cQmXV.version).split(".")[0]);
const $10341b937b26f69d$export$f17fd18fa51dcb5b = (ref, node)=>{
    if (typeof ref === "function") ref(node);
    else if (typeof ref === "object" && ref && "current" in ref) ref.current = node;
};
const $10341b937b26f69d$export$ab452c34e8e05029 = (...refs)=>{
    const refList = refs.filter(Boolean);
    if (refList.length <= 1) return refList[0];
    return (node)=>{
        refs.forEach((ref)=>{
            $10341b937b26f69d$export$f17fd18fa51dcb5b(ref, node);
        });
    };
};
const $10341b937b26f69d$export$1d1c999670a1285d = (...refs)=>{
    return (0, $d627c2941353b4cb$export$2e2bcd8739ae039)(()=>$10341b937b26f69d$export$ab452c34e8e05029(...refs), // eslint-disable-next-line react-hooks/exhaustive-deps
    refs, (prev, next)=>prev.length !== next.length || prev.every((ref, i)=>ref !== next[i]));
};
const $10341b937b26f69d$export$c1cec34af06bcf7 = (nodeOrComponent)=>{
    if (!nodeOrComponent) return false;
    // React 19 no need `forwardRef` anymore. So just pass if is a React element.
    if ($10341b937b26f69d$var$isReactElement(nodeOrComponent) && $10341b937b26f69d$var$ReactMajorVersion >= 19) return true;
    const type = (0, $aa1fd19150b5249e$exports.isMemo)(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;
    // Function component node
    if (typeof type === "function" && !type.prototype?.render && type.$$typeof !== (0, $aa1fd19150b5249e$exports.ForwardRef)) return false;
    // Class component
    if (typeof nodeOrComponent === "function" && !nodeOrComponent.prototype?.render && nodeOrComponent.$$typeof !== (0, $aa1fd19150b5249e$exports.ForwardRef)) return false;
    return true;
};
function $10341b937b26f69d$var$isReactElement(node) {
    return /*#__PURE__*/ (0, $cQmXV.isValidElement)(node) && !(0, $0b5ff2deb7eed9f1$export$2e2bcd8739ae039)(node);
}
const $10341b937b26f69d$export$b51ae67c7882a242 = (node)=>{
    return $10341b937b26f69d$var$isReactElement(node) && $10341b937b26f69d$export$c1cec34af06bcf7(node);
};
const $10341b937b26f69d$export$7465e5c0bf44f19a = (node)=>{
    if (node && $10341b937b26f69d$var$isReactElement(node)) {
        const ele = node;
        // Source from:
        // https://github.com/mui/material-ui/blob/master/packages/mui-utils/src/getReactNodeRef/getReactNodeRef.ts
        return ele.props.propertyIsEnumerable("ref") ? ele.props.ref : ele.ref;
    }
    return null;
};





function $d3fb35d553a86e29$export$41e30d8dd0ba7a50(node) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Element
    // Since XULElement is also subclass of Element, we only need HTMLElement and SVGElement
    return node instanceof HTMLElement || node instanceof SVGElement;
}
function $d3fb35d553a86e29$export$9aa546fdc20ae5b3(node) {
    if (node && typeof node === "object" && $d3fb35d553a86e29$export$41e30d8dd0ba7a50(node.nativeElement)) return node.nativeElement;
    if ($d3fb35d553a86e29$export$41e30d8dd0ba7a50(node)) return node;
    return null;
}
function $d3fb35d553a86e29$export$2e2bcd8739ae039(node) {
    const domNode = $d3fb35d553a86e29$export$9aa546fdc20ae5b3(node);
    if (domNode) return domNode;
    if (node && typeof node === "object" && "current" in node) {
        const refDomNode = $d3fb35d553a86e29$export$9aa546fdc20ae5b3(node.current);
        if (refDomNode) return refDomNode;
    }
    return null;
}



var $cQmXV = parcelRequire("cQmXV");
var $c70640475a7bd353$export$2e2bcd8739ae039 = (element)=>{
    if (!element) return false;
    if (element instanceof Element) {
        if (element.offsetParent) return true;
        if (element.getBBox) {
            const { width: width, height: height } = element.getBBox();
            if (width || height) return true;
        }
        if (element.getBoundingClientRect) {
            const { width: width, height: height } = element.getBoundingClientRect();
            if (width || height) return true;
        }
    }
    return false;
};



function $7aa1eaa901116c60$var$focusable(node, includePositive = false) {
    if ((0, $c70640475a7bd353$export$2e2bcd8739ae039)(node)) {
        const nodeName = node.nodeName.toLowerCase();
        const isFocusableElement = // Focusable element
        [
            "input",
            "select",
            "textarea",
            "button"
        ].includes(nodeName) || // Editable element
        node.isContentEditable || // Anchor with href element
        nodeName === "a" && !!node.getAttribute("href");
        // Get tabIndex
        const tabIndexAttr = node.getAttribute("tabindex");
        const tabIndexNum = Number(tabIndexAttr);
        // Parse as number if validate
        let tabIndex = null;
        if (tabIndexAttr && !Number.isNaN(tabIndexNum)) tabIndex = tabIndexNum;
        else if (isFocusableElement && tabIndex === null) tabIndex = 0;
        // Block focusable if disabled
        if (isFocusableElement && node.disabled) tabIndex = null;
        return tabIndex !== null && (tabIndex >= 0 || includePositive && tabIndex < 0);
    }
    return false;
}
function $7aa1eaa901116c60$export$bbc7b5f11aba534b(node, includePositive = false) {
    const res = [
        ...node.querySelectorAll("*")
    ].filter((child)=>{
        return $7aa1eaa901116c60$var$focusable(child, includePositive);
    });
    if ($7aa1eaa901116c60$var$focusable(node, includePositive)) res.unshift(node);
    return res;
}
function $7aa1eaa901116c60$export$2b92016deb0b7aad(element, option) {
    if (!element) return;
    element.focus(option);
    // Selection content
    const { cursor: cursor } = option || {};
    if (cursor && (element instanceof HTMLInputElement || element instanceof HTMLTextAreaElement)) {
        const len = element.value.length;
        switch(cursor){
            case "start":
                element.setSelectionRange(0, 0);
                break;
            case "end":
                element.setSelectionRange(len, len);
                break;
            default:
                element.setSelectionRange(0, len);
        }
    }
}
// ======================================================
// ==                    Lock Focus                    ==
// ======================================================
let $7aa1eaa901116c60$var$lastFocusElement = null;
let $7aa1eaa901116c60$var$focusElements = [];
// Map stable ID to lock element
const $7aa1eaa901116c60$var$idToElementMap = new Map();
// Map stable ID to ignored element
const $7aa1eaa901116c60$var$ignoredElementMap = new Map();
function $7aa1eaa901116c60$var$getLastElement() {
    return $7aa1eaa901116c60$var$focusElements[$7aa1eaa901116c60$var$focusElements.length - 1];
}
function $7aa1eaa901116c60$var$isIgnoredElement(element) {
    const lastElement = $7aa1eaa901116c60$var$getLastElement();
    if (element && lastElement) {
        // Find the ID that maps to the last element
        let lockId;
        for (const [id, ele] of $7aa1eaa901116c60$var$idToElementMap.entries())if (ele === lastElement) {
            lockId = id;
            break;
        }
        const ignoredEle = $7aa1eaa901116c60$var$ignoredElementMap.get(lockId);
        return !!ignoredEle && (ignoredEle === element || ignoredEle.contains(element));
    }
    return false;
}
function $7aa1eaa901116c60$var$hasFocus(element) {
    const { activeElement: activeElement } = document;
    return element === activeElement || element.contains(activeElement);
}
function $7aa1eaa901116c60$var$syncFocus() {
    const lastElement = $7aa1eaa901116c60$var$getLastElement();
    const { activeElement: activeElement } = document;
    // If current focus is on an ignored element, don't force it back
    if ($7aa1eaa901116c60$var$isIgnoredElement(activeElement)) return;
    if (lastElement && !$7aa1eaa901116c60$var$hasFocus(lastElement)) {
        const focusableList = $7aa1eaa901116c60$export$bbc7b5f11aba534b(lastElement);
        const matchElement = focusableList.includes($7aa1eaa901116c60$var$lastFocusElement) ? $7aa1eaa901116c60$var$lastFocusElement : focusableList[0];
        matchElement?.focus({
            preventScroll: true
        });
    } else $7aa1eaa901116c60$var$lastFocusElement = activeElement;
}
function $7aa1eaa901116c60$var$onWindowKeyDown(e) {
    if (e.key === "Tab") {
        const { activeElement: activeElement } = document;
        const lastElement = $7aa1eaa901116c60$var$getLastElement();
        const focusableList = $7aa1eaa901116c60$export$bbc7b5f11aba534b(lastElement);
        const last = focusableList[focusableList.length - 1];
        if (e.shiftKey && activeElement === focusableList[0]) // Tab backward on first focusable element
        $7aa1eaa901116c60$var$lastFocusElement = last;
        else if (!e.shiftKey && activeElement === last) // Tab forward on last focusable element
        $7aa1eaa901116c60$var$lastFocusElement = focusableList[0];
    }
}
function $7aa1eaa901116c60$export$a71918e269a02274(element, id) {
    if (element) {
        // Store the mapping between ID and element
        $7aa1eaa901116c60$var$idToElementMap.set(id, element);
        // Refresh focus elements
        $7aa1eaa901116c60$var$focusElements = $7aa1eaa901116c60$var$focusElements.filter((ele)=>ele !== element);
        $7aa1eaa901116c60$var$focusElements.push(element);
        // Just add event since it will de-duplicate
        window.addEventListener("focusin", $7aa1eaa901116c60$var$syncFocus);
        window.addEventListener("keydown", $7aa1eaa901116c60$var$onWindowKeyDown, true);
        $7aa1eaa901116c60$var$syncFocus();
    }
    // Always return unregister function
    return ()=>{
        $7aa1eaa901116c60$var$lastFocusElement = null;
        $7aa1eaa901116c60$var$focusElements = $7aa1eaa901116c60$var$focusElements.filter((ele)=>ele !== element);
        $7aa1eaa901116c60$var$idToElementMap.delete(id);
        $7aa1eaa901116c60$var$ignoredElementMap.delete(id);
        if ($7aa1eaa901116c60$var$focusElements.length === 0) {
            window.removeEventListener("focusin", $7aa1eaa901116c60$var$syncFocus);
            window.removeEventListener("keydown", $7aa1eaa901116c60$var$onWindowKeyDown, true);
        }
    };
}
/**
 * Retry an effect until it reports ready.
 * When `ready` is `false`, it will schedule one more effect cycle and call `func` again
 * with the next `retryTimes`.
 */ function $7aa1eaa901116c60$var$useRetryEffect(func, deps) {
    /* eslint-disable react-hooks/exhaustive-deps */ const retryTimesRef = (0, $cQmXV.useRef)(0);
    const [retryMark, setRetryMark] = (0, $cQmXV.useState)(0);
    (0, $cQmXV.useEffect)(()=>{
        retryTimesRef.current = 0;
    }, deps);
    (0, $cQmXV.useEffect)(()=>{
        const [clearFn, ready] = func(retryTimesRef.current);
        if (!ready) {
            retryTimesRef.current += 1;
            setRetryMark((count)=>count + 1);
        }
        return clearFn;
    }, [
        ...deps,
        retryMark
    ]);
/* eslint-enable react-hooks/exhaustive-deps */ }
function $7aa1eaa901116c60$export$9e3bf6f439c42dc9(lock, getElement) {
    const id = (0, $a2da91bb60e2cbfb$export$2e2bcd8739ae039)();
    const getElementRef = (0, $cQmXV.useRef)(getElement);
    getElementRef.current = getElement;
    const lockEffect = (retryTimes)=>{
        if (!lock) return [
            undefined,
            true
        ];
        const element = getElementRef.current();
        if (element) return [
            $7aa1eaa901116c60$export$a71918e269a02274(element, id),
            true
        ];
        return [
            undefined,
            retryTimes >= 1
        ];
    };
    $7aa1eaa901116c60$var$useRetryEffect(lockEffect, [
        id,
        lock
    ]);
    const ignoreElement = (ele)=>{
        if (ele) // Set the ignored element using stable ID
        $7aa1eaa901116c60$var$ignoredElementMap.set(id, ele);
    };
    return [
        ignoreElement
    ];
}



function $7b66ec1d5ddc0bd4$var$getRoot(ele) {
    return ele?.getRootNode?.();
}
function $7b66ec1d5ddc0bd4$export$cca82218ea4431a(ele) {
    return $7b66ec1d5ddc0bd4$var$getRoot(ele) instanceof ShadowRoot;
}
function $7b66ec1d5ddc0bd4$export$70e8259662bb498b(ele) {
    return $7b66ec1d5ddc0bd4$export$cca82218ea4431a(ele) ? $7b66ec1d5ddc0bd4$var$getRoot(ele) : null;
}



const $c2057eea61f67d6e$var$isStyleNameSupport = (styleName)=>{
    if ((0, $78361969822ad097$export$2e2bcd8739ae039)() && window.document.documentElement) {
        const styleNameList = Array.isArray(styleName) ? styleName : [
            styleName
        ];
        const { documentElement: documentElement } = window.document;
        return styleNameList.some((name)=>name in documentElement.style);
    }
    return false;
};
const $c2057eea61f67d6e$var$isStyleValueSupport = (styleName, value)=>{
    if (!$c2057eea61f67d6e$var$isStyleNameSupport(styleName)) return false;
    const ele = document.createElement("div");
    const origin = ele.style[styleName];
    ele.style[styleName] = value;
    return ele.style[styleName] !== origin;
};
function $c2057eea61f67d6e$export$d616d7831008e86c(styleName, styleValue) {
    if (!Array.isArray(styleName) && styleValue !== undefined) return $c2057eea61f67d6e$var$isStyleValueSupport(styleName, styleValue);
    return $c2057eea61f67d6e$var$isStyleNameSupport(styleName);
}


/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */ const $7c2257a1fd9763eb$var$KeyCode = {
    /**
   * MAC_ENTER
   */ MAC_ENTER: 3,
    /**
   * BACKSPACE
   */ BACKSPACE: 8,
    /**
   * TAB
   */ TAB: 9,
    /**
   * NUMLOCK on FF/Safari Mac
   */ NUM_CENTER: 12,
    // NUMLOCK on FF/Safari Mac
    /**
   * ENTER
   */ ENTER: 13,
    /**
   * SHIFT
   */ SHIFT: 16,
    /**
   * CTRL
   */ CTRL: 17,
    /**
   * ALT
   */ ALT: 18,
    /**
   * PAUSE
   */ PAUSE: 19,
    /**
   * CAPS_LOCK
   */ CAPS_LOCK: 20,
    /**
   * ESC
   */ ESC: 27,
    /**
   * SPACE
   */ SPACE: 32,
    /**
   * PAGE_UP
   */ PAGE_UP: 33,
    // also NUM_NORTH_EAST
    /**
   * PAGE_DOWN
   */ PAGE_DOWN: 34,
    // also NUM_SOUTH_EAST
    /**
   * END
   */ END: 35,
    // also NUM_SOUTH_WEST
    /**
   * HOME
   */ HOME: 36,
    // also NUM_NORTH_WEST
    /**
   * LEFT
   */ LEFT: 37,
    // also NUM_WEST
    /**
   * UP
   */ UP: 38,
    // also NUM_NORTH
    /**
   * RIGHT
   */ RIGHT: 39,
    // also NUM_EAST
    /**
   * DOWN
   */ DOWN: 40,
    // also NUM_SOUTH
    /**
   * PRINT_SCREEN
   */ PRINT_SCREEN: 44,
    /**
   * INSERT
   */ INSERT: 45,
    // also NUM_INSERT
    /**
   * DELETE
   */ DELETE: 46,
    // also NUM_DELETE
    /**
   * ZERO
   */ ZERO: 48,
    /**
   * ONE
   */ ONE: 49,
    /**
   * TWO
   */ TWO: 50,
    /**
   * THREE
   */ THREE: 51,
    /**
   * FOUR
   */ FOUR: 52,
    /**
   * FIVE
   */ FIVE: 53,
    /**
   * SIX
   */ SIX: 54,
    /**
   * SEVEN
   */ SEVEN: 55,
    /**
   * EIGHT
   */ EIGHT: 56,
    /**
   * NINE
   */ NINE: 57,
    /**
   * QUESTION_MARK
   */ QUESTION_MARK: 63,
    // needs localization
    /**
   * A
   */ A: 65,
    /**
   * B
   */ B: 66,
    /**
   * C
   */ C: 67,
    /**
   * D
   */ D: 68,
    /**
   * E
   */ E: 69,
    /**
   * F
   */ F: 70,
    /**
   * G
   */ G: 71,
    /**
   * H
   */ H: 72,
    /**
   * I
   */ I: 73,
    /**
   * J
   */ J: 74,
    /**
   * K
   */ K: 75,
    /**
   * L
   */ L: 76,
    /**
   * M
   */ M: 77,
    /**
   * N
   */ N: 78,
    /**
   * O
   */ O: 79,
    /**
   * P
   */ P: 80,
    /**
   * Q
   */ Q: 81,
    /**
   * R
   */ R: 82,
    /**
   * S
   */ S: 83,
    /**
   * T
   */ T: 84,
    /**
   * U
   */ U: 85,
    /**
   * V
   */ V: 86,
    /**
   * W
   */ W: 87,
    /**
   * X
   */ X: 88,
    /**
   * Y
   */ Y: 89,
    /**
   * Z
   */ Z: 90,
    /**
   * META
   */ META: 91,
    // WIN_KEY_LEFT
    /**
   * WIN_KEY_RIGHT
   */ WIN_KEY_RIGHT: 92,
    /**
   * CONTEXT_MENU
   */ CONTEXT_MENU: 93,
    /**
   * NUM_ZERO
   */ NUM_ZERO: 96,
    /**
   * NUM_ONE
   */ NUM_ONE: 97,
    /**
   * NUM_TWO
   */ NUM_TWO: 98,
    /**
   * NUM_THREE
   */ NUM_THREE: 99,
    /**
   * NUM_FOUR
   */ NUM_FOUR: 100,
    /**
   * NUM_FIVE
   */ NUM_FIVE: 101,
    /**
   * NUM_SIX
   */ NUM_SIX: 102,
    /**
   * NUM_SEVEN
   */ NUM_SEVEN: 103,
    /**
   * NUM_EIGHT
   */ NUM_EIGHT: 104,
    /**
   * NUM_NINE
   */ NUM_NINE: 105,
    /**
   * NUM_MULTIPLY
   */ NUM_MULTIPLY: 106,
    /**
   * NUM_PLUS
   */ NUM_PLUS: 107,
    /**
   * NUM_MINUS
   */ NUM_MINUS: 109,
    /**
   * NUM_PERIOD
   */ NUM_PERIOD: 110,
    /**
   * NUM_DIVISION
   */ NUM_DIVISION: 111,
    /**
   * F1
   */ F1: 112,
    /**
   * F2
   */ F2: 113,
    /**
   * F3
   */ F3: 114,
    /**
   * F4
   */ F4: 115,
    /**
   * F5
   */ F5: 116,
    /**
   * F6
   */ F6: 117,
    /**
   * F7
   */ F7: 118,
    /**
   * F8
   */ F8: 119,
    /**
   * F9
   */ F9: 120,
    /**
   * F10
   */ F10: 121,
    /**
   * F11
   */ F11: 122,
    /**
   * F12
   */ F12: 123,
    /**
   * NUMLOCK
   */ NUMLOCK: 144,
    /**
   * SEMICOLON
   */ SEMICOLON: 186,
    // needs localization
    /**
   * DASH
   */ DASH: 189,
    // needs localization
    /**
   * EQUALS
   */ EQUALS: 187,
    // needs localization
    /**
   * COMMA
   */ COMMA: 188,
    // needs localization
    /**
   * PERIOD
   */ PERIOD: 190,
    // needs localization
    /**
   * SLASH
   */ SLASH: 191,
    // needs localization
    /**
   * APOSTROPHE
   */ APOSTROPHE: 192,
    // needs localization
    /**
   * SINGLE_QUOTE
   */ SINGLE_QUOTE: 222,
    // needs localization
    /**
   * OPEN_SQUARE_BRACKET
   */ OPEN_SQUARE_BRACKET: 219,
    // needs localization
    /**
   * BACKSLASH
   */ BACKSLASH: 220,
    // needs localization
    /**
   * CLOSE_SQUARE_BRACKET
   */ CLOSE_SQUARE_BRACKET: 221,
    // needs localization
    /**
   * WIN_KEY
   */ WIN_KEY: 224,
    /**
   * MAC_FF_META
   */ MAC_FF_META: 224,
    // Firefox (Gecko) fires this for the meta key instead of 91
    /**
   * WIN_IME
   */ WIN_IME: 229,
    // ======================== Function ========================
    /**
   * whether text and modified key is entered at the same time.
   */ isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
        const { keyCode: keyCode } = e;
        if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
        keyCode >= $7c2257a1fd9763eb$var$KeyCode.F1 && keyCode <= $7c2257a1fd9763eb$var$KeyCode.F12) return false;
        // The following keys are quite harmless, even in combination with
        // CTRL, ALT or SHIFT.
        switch(keyCode){
            case $7c2257a1fd9763eb$var$KeyCode.ALT:
            case $7c2257a1fd9763eb$var$KeyCode.CAPS_LOCK:
            case $7c2257a1fd9763eb$var$KeyCode.CONTEXT_MENU:
            case $7c2257a1fd9763eb$var$KeyCode.CTRL:
            case $7c2257a1fd9763eb$var$KeyCode.DOWN:
            case $7c2257a1fd9763eb$var$KeyCode.END:
            case $7c2257a1fd9763eb$var$KeyCode.ESC:
            case $7c2257a1fd9763eb$var$KeyCode.HOME:
            case $7c2257a1fd9763eb$var$KeyCode.INSERT:
            case $7c2257a1fd9763eb$var$KeyCode.LEFT:
            case $7c2257a1fd9763eb$var$KeyCode.MAC_FF_META:
            case $7c2257a1fd9763eb$var$KeyCode.META:
            case $7c2257a1fd9763eb$var$KeyCode.NUMLOCK:
            case $7c2257a1fd9763eb$var$KeyCode.NUM_CENTER:
            case $7c2257a1fd9763eb$var$KeyCode.PAGE_DOWN:
            case $7c2257a1fd9763eb$var$KeyCode.PAGE_UP:
            case $7c2257a1fd9763eb$var$KeyCode.PAUSE:
            case $7c2257a1fd9763eb$var$KeyCode.PRINT_SCREEN:
            case $7c2257a1fd9763eb$var$KeyCode.RIGHT:
            case $7c2257a1fd9763eb$var$KeyCode.SHIFT:
            case $7c2257a1fd9763eb$var$KeyCode.UP:
            case $7c2257a1fd9763eb$var$KeyCode.WIN_KEY:
            case $7c2257a1fd9763eb$var$KeyCode.WIN_KEY_RIGHT:
                return false;
            default:
                return true;
        }
    },
    /**
   * whether character is entered.
   */ isCharacterKey: function isCharacterKey(keyCode) {
        if (keyCode >= $7c2257a1fd9763eb$var$KeyCode.ZERO && keyCode <= $7c2257a1fd9763eb$var$KeyCode.NINE) return true;
        if (keyCode >= $7c2257a1fd9763eb$var$KeyCode.NUM_ZERO && keyCode <= $7c2257a1fd9763eb$var$KeyCode.NUM_MULTIPLY) return true;
        if (keyCode >= $7c2257a1fd9763eb$var$KeyCode.A && keyCode <= $7c2257a1fd9763eb$var$KeyCode.Z) return true;
        // Safari sends zero key code for non-latin characters.
        if (window.navigator.userAgent.indexOf("WebKit") !== -1 && keyCode === 0) return true;
        switch(keyCode){
            case $7c2257a1fd9763eb$var$KeyCode.SPACE:
            case $7c2257a1fd9763eb$var$KeyCode.QUESTION_MARK:
            case $7c2257a1fd9763eb$var$KeyCode.NUM_PLUS:
            case $7c2257a1fd9763eb$var$KeyCode.NUM_MINUS:
            case $7c2257a1fd9763eb$var$KeyCode.NUM_PERIOD:
            case $7c2257a1fd9763eb$var$KeyCode.NUM_DIVISION:
            case $7c2257a1fd9763eb$var$KeyCode.SEMICOLON:
            case $7c2257a1fd9763eb$var$KeyCode.DASH:
            case $7c2257a1fd9763eb$var$KeyCode.EQUALS:
            case $7c2257a1fd9763eb$var$KeyCode.COMMA:
            case $7c2257a1fd9763eb$var$KeyCode.PERIOD:
            case $7c2257a1fd9763eb$var$KeyCode.SLASH:
            case $7c2257a1fd9763eb$var$KeyCode.APOSTROPHE:
            case $7c2257a1fd9763eb$var$KeyCode.SINGLE_QUOTE:
            case $7c2257a1fd9763eb$var$KeyCode.OPEN_SQUARE_BRACKET:
            case $7c2257a1fd9763eb$var$KeyCode.BACKSLASH:
            case $7c2257a1fd9763eb$var$KeyCode.CLOSE_SQUARE_BRACKET:
                return true;
            default:
                return false;
        }
    },
    isEditableTarget: function isEditableTarget(e) {
        const target = e.target;
        if (!(target instanceof HTMLElement)) return false;
        const tagName = target.tagName;
        if (tagName === "INPUT" || tagName === "TEXTAREA" || tagName === "SELECT" || target.isContentEditable) return true;
        return false;
    }
};
var $7c2257a1fd9763eb$export$2e2bcd8739ae039 = $7c2257a1fd9763eb$var$KeyCode;


/* eslint-disable no-param-reassign */ 
let $14f2e271a4ead6fa$var$cached;
function $14f2e271a4ead6fa$var$measureScrollbarSize(ele) {
    const randomId = `rc-scrollbar-measure-${Math.random().toString(36).substring(7)}`;
    const measureEle = document.createElement("div");
    measureEle.id = randomId;
    // Create Style
    const measureStyle = measureEle.style;
    measureStyle.position = "absolute";
    measureStyle.left = "0";
    measureStyle.top = "0";
    measureStyle.width = "100px";
    measureStyle.height = "100px";
    measureStyle.overflow = "scroll";
    // Clone Style if needed
    let fallbackWidth;
    let fallbackHeight;
    if (ele) {
        const targetStyle = getComputedStyle(ele);
        measureStyle.scrollbarColor = targetStyle.scrollbarColor;
        measureStyle.scrollbarWidth = targetStyle.scrollbarWidth;
        // Set Webkit style
        const webkitScrollbarStyle = getComputedStyle(ele, "::-webkit-scrollbar");
        const width = parseInt(webkitScrollbarStyle.width, 10);
        const height = parseInt(webkitScrollbarStyle.height, 10);
        // Try wrap to handle CSP case
        try {
            const widthStyle = width ? `width: ${webkitScrollbarStyle.width};` : "";
            const heightStyle = height ? `height: ${webkitScrollbarStyle.height};` : "";
            (0, $449b73243fa975a1$export$4d99a2890bb989f0)(`
#${randomId}::-webkit-scrollbar {
${widthStyle}
${heightStyle}
}`, randomId);
        } catch (e) {
            // Can't wrap, just log error
            console.error(e);
            // Get from style directly
            fallbackWidth = width;
            fallbackHeight = height;
        }
    }
    document.body.appendChild(measureEle);
    // Measure. Get fallback style if provided
    const scrollWidth = ele && fallbackWidth && !Number.isNaN(fallbackWidth) ? fallbackWidth : measureEle.offsetWidth - measureEle.clientWidth;
    const scrollHeight = ele && fallbackHeight && !Number.isNaN(fallbackHeight) ? fallbackHeight : measureEle.offsetHeight - measureEle.clientHeight;
    // Clean up
    document.body.removeChild(measureEle);
    (0, $449b73243fa975a1$export$2232e336aecaa80a)(randomId);
    return {
        width: scrollWidth,
        height: scrollHeight
    };
}
function $14f2e271a4ead6fa$export$2e2bcd8739ae039(fresh) {
    if (typeof document === "undefined") return 0;
    if (fresh || $14f2e271a4ead6fa$var$cached === undefined) $14f2e271a4ead6fa$var$cached = $14f2e271a4ead6fa$var$measureScrollbarSize();
    return $14f2e271a4ead6fa$var$cached.width;
}
function $14f2e271a4ead6fa$export$4f3ef2310365b56a(target) {
    if (typeof document === "undefined" || !target || !(target instanceof Element)) return {
        width: 0,
        height: 0
    };
    return $14f2e271a4ead6fa$var$measureScrollbarSize(target);
}



var $280bf9306bf90118$exports = {};
"use strict";
$280bf9306bf90118$exports = $280bf9306bf90118$var$isMobile;
$280bf9306bf90118$exports.isMobile = $280bf9306bf90118$var$isMobile;
$280bf9306bf90118$exports.default = $280bf9306bf90118$var$isMobile;
const $280bf9306bf90118$var$mobileRE = /(android|bb\d+|meego).+mobile|armv7l|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|redmi|series[46]0|samsungbrowser.*mobile|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i;
const $280bf9306bf90118$var$notMobileRE = /CrOS/;
const $280bf9306bf90118$var$tabletRE = /android|ipad|playbook|silk/i;
function $280bf9306bf90118$var$isMobile(opts) {
    if (!opts) opts = {};
    let ua = opts.ua;
    if (!ua && typeof navigator !== "undefined") ua = navigator.userAgent;
    if (ua && ua.headers && typeof ua.headers["user-agent"] === "string") ua = ua.headers["user-agent"];
    if (typeof ua !== "string") return false;
    let result = $280bf9306bf90118$var$mobileRE.test(ua) && !$280bf9306bf90118$var$notMobileRE.test(ua) || !!opts.tablet && $280bf9306bf90118$var$tabletRE.test(ua);
    if (!result && opts.tablet && opts.featureDetect && navigator && navigator.maxTouchPoints > 1 && ua.indexOf("Macintosh") !== -1 && ua.indexOf("Safari") !== -1) result = true;
    return result;
}


let $2bf5fcb531762fb8$var$cached;
const $2bf5fcb531762fb8$var$getIsMobile = ()=>{
    if (typeof $2bf5fcb531762fb8$var$cached === "undefined") $2bf5fcb531762fb8$var$cached = (0, (/*@__PURE__*/$parcel$interopDefault($280bf9306bf90118$exports)))();
    return $2bf5fcb531762fb8$var$cached;
};
var $2bf5fcb531762fb8$export$2e2bcd8739ae039 = $2bf5fcb531762fb8$var$getIsMobile;


function $e8c5093aebad6025$export$2e2bcd8739ae039(obj, fields) {
    const clone = Object.assign({}, obj);
    if (Array.isArray(fields)) fields.forEach((key)=>{
        delete clone[key];
    });
    return clone;
}


const $4b5c733d1d7bb306$var$attributes = `accept acceptCharset accessKey action allowFullScreen allowTransparency
    alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge
    charSet checked classID className colSpan cols content contentEditable contextMenu
    controls coords crossOrigin data dateTime default defer dir disabled download draggable
    encType form formAction formEncType formMethod formNoValidate formTarget frameBorder
    headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity
    is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media
    mediaGroup method min minLength multiple muted name noValidate nonce open
    optimum pattern placeholder poster preload radioGroup readOnly rel required
    reversed role rowSpan rows sandbox scope scoped scrolling seamless selected
    shape size sizes span spellCheck src srcDoc srcLang srcSet start step style
    summary tabIndex target title type useMap value width wmode wrap`;
const $4b5c733d1d7bb306$var$eventsName = `onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown
    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick
    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown
    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel
    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough
    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata
    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad
    onPointerDown onPointerMove onPointerUp onPointerCancel onPointerEnter onPointerLeave onPointerOver onPointerOut onGotPointerCapture onLostPointerCapture
    onAnimationStart onAnimationEnd onAnimationIteration
    onTransitionEnd onTransitionRun onTransitionStart onTransitionCancel
    onBeforeInput onReset onInvalid
    onAuxClick onToggle onBeforeToggle onCancel onClose onResize onScrollEnd`;
const $4b5c733d1d7bb306$var$propList = `${$4b5c733d1d7bb306$var$attributes} ${$4b5c733d1d7bb306$var$eventsName}`.split(/[\s\n]+/);
/* eslint-enable max-len */ const $4b5c733d1d7bb306$var$ariaPrefix = "aria-";
const $4b5c733d1d7bb306$var$dataPrefix = "data-";
function $4b5c733d1d7bb306$var$match(key, prefix) {
    return key.indexOf(prefix) === 0;
}
function $4b5c733d1d7bb306$export$2e2bcd8739ae039(props, ariaOnly = false) {
    let mergedConfig;
    if (ariaOnly === false) mergedConfig = {
        aria: true,
        data: true,
        attr: true
    };
    else if (ariaOnly === true) mergedConfig = {
        aria: true
    };
    else mergedConfig = {
        ...ariaOnly
    };
    const attrs = {};
    Object.keys(props).forEach((key)=>{
        if (// Aria
        mergedConfig.aria && (key === "role" || $4b5c733d1d7bb306$var$match(key, $4b5c733d1d7bb306$var$ariaPrefix)) || // Data
        mergedConfig.data && $4b5c733d1d7bb306$var$match(key, $4b5c733d1d7bb306$var$dataPrefix) || // Attr
        mergedConfig.attr && $4b5c733d1d7bb306$var$propList.includes(key)) attrs[key] = props[key];
    });
    return attrs;
}


/**
 * Proxy object if environment supported
 */ function $7849fe9d137ec9a3$export$2e2bcd8739ae039(obj, extendProps) {
    if (typeof Proxy !== "undefined" && obj) return new Proxy(obj, {
        get (target, prop) {
            if (extendProps[prop]) return extendProps[prop];
            // Proxy origin property
            const originProp = target[prop];
            return typeof originProp === "function" ? originProp.bind(target) : originProp;
        }
    });
    return obj;
}





var $cQmXV = parcelRequire("cQmXV");
function $cd966a313e0a92ff$export$2e2bcd8739ae039(children, option = {}) {
    let ret = [];
    (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Children.forEach(children, (child)=>{
        if ((child === undefined || child === null) && !option.keepEmpty) return;
        if (Array.isArray(child)) ret = ret.concat($cd966a313e0a92ff$export$2e2bcd8739ae039(child));
        else if ((0, $0b5ff2deb7eed9f1$export$2e2bcd8739ae039)(child) && child.props) ret = ret.concat($cd966a313e0a92ff$export$2e2bcd8739ae039(child.props.children, option));
        else ret.push(child);
    });
    return ret;
}


/**
 * Merges multiple props objects into one. Unlike `Object.assign()` or `{ ...a, ...b }`, it skips
 * properties whose value is explicitly set to `undefined`.
 */ function $5bb86b4f753905a4$var$mergeProps(...items) {
    const ret = {};
    for (const item of items)if (item) {
        for (const key of Object.keys(item))if (item[key] !== undefined) ret[key] = item[key];
    }
    return ret;
}
var $5bb86b4f753905a4$export$2e2bcd8739ae039 = $5bb86b4f753905a4$var$mergeProps;


function $bb62aae17cbc8bd7$export$2e2bcd8739ae039(entity, path) {
    let current = entity;
    for(let i = 0; i < path.length; i += 1){
        if (current === null || current === undefined) return undefined;
        current = current[path[i]];
    }
    return current;
}



function $a3099986deccaee4$var$internalSet(entity, paths, value, removeIfUndefined) {
    if (!paths.length) return value;
    const [path, ...restPath] = paths;
    let clone;
    if (!entity && typeof path === "number") clone = [];
    else if (Array.isArray(entity)) clone = [
        ...entity
    ];
    else clone = {
        ...entity
    };
    // Delete prop if `removeIfUndefined` and value is undefined
    if (removeIfUndefined && value === undefined && restPath.length === 1) delete clone[path][restPath[0]];
    else clone[path] = $a3099986deccaee4$var$internalSet(clone[path], restPath, value, removeIfUndefined);
    return clone;
}
function $a3099986deccaee4$export$2e2bcd8739ae039(entity, paths, value, removeIfUndefined = false) {
    // Do nothing if `removeIfUndefined` and parent object not exist
    if (paths.length && removeIfUndefined && value === undefined && !(0, $bb62aae17cbc8bd7$export$2e2bcd8739ae039)(entity, paths.slice(0, -1))) return entity;
    return $a3099986deccaee4$var$internalSet(entity, paths, value, removeIfUndefined);
}
function $a3099986deccaee4$var$isObject(obj) {
    return typeof obj === "object" && obj !== null && Object.getPrototypeOf(obj) === Object.prototype;
}
function $a3099986deccaee4$var$createEmpty(source) {
    return Array.isArray(source) ? [] : {};
}
const $a3099986deccaee4$var$keys = typeof Reflect === "undefined" ? Object.keys : Reflect.ownKeys;
function $a3099986deccaee4$export$2ee76fde9ffe109d(sources, config = {}) {
    const { prepareArray: prepareArray } = config;
    const finalPrepareArray = prepareArray || (()=>[]);
    let clone = $a3099986deccaee4$var$createEmpty(sources[0]);
    sources.forEach((src)=>{
        function internalMerge(path, parentLoopSet) {
            const loopSet = new Set(parentLoopSet);
            const value = (0, $bb62aae17cbc8bd7$export$2e2bcd8739ae039)(src, path);
            const isArr = Array.isArray(value);
            if (isArr || $a3099986deccaee4$var$isObject(value)) // Only add not loop obj
            {
                if (!loopSet.has(value)) {
                    loopSet.add(value);
                    const originValue = (0, $bb62aae17cbc8bd7$export$2e2bcd8739ae039)(clone, path);
                    if (isArr) // Array will always be override
                    clone = $a3099986deccaee4$export$2e2bcd8739ae039(clone, path, finalPrepareArray(originValue, value));
                    else if (!originValue || typeof originValue !== "object") // Init container if not exist
                    clone = $a3099986deccaee4$export$2e2bcd8739ae039(clone, path, $a3099986deccaee4$var$createEmpty(value));
                    $a3099986deccaee4$var$keys(value).forEach((key)=>{
                        if (Object.getOwnPropertyDescriptor(value, key).enumerable) internalMerge([
                            ...path,
                            key
                        ], loopSet);
                    });
                }
            } else clone = $a3099986deccaee4$export$2e2bcd8739ae039(clone, path, value);
        }
        internalMerge([]);
    });
    return clone;
}
function $a3099986deccaee4$export$4950aa0f605343fb(...sources) {
    return $a3099986deccaee4$export$2ee76fde9ffe109d(sources);
}




const $462099a4eea3a68d$var$MARK = "__rc_react_root__";
function $462099a4eea3a68d$export$b3890eb0ae9dca99(node, container) {
    const root = container[$462099a4eea3a68d$var$MARK] || (0, $3e75b56ae88591f4$exports.createRoot)(container);
    root.render(node);
    container[$462099a4eea3a68d$var$MARK] = root;
}
async function $462099a4eea3a68d$export$121e2d597d222bad(container) {
    // Delay to unmount to avoid React 18 sync warning
    return Promise.resolve().then(()=>{
        container[$462099a4eea3a68d$var$MARK]?.unmount();
        delete container[$462099a4eea3a68d$var$MARK];
    });
}


/* eslint-disable no-param-reassign */ const $bc8d3195204138c7$var$NO_EXIST = {
    __NOT_EXIST: true
};
function $bc8d3195204138c7$export$aa23418fe3feda3a(elementClass, properties) {
    const propNames = Object.keys(properties);
    const originDescriptors = {};
    propNames.forEach((propName)=>{
        const originDescriptor = Object.getOwnPropertyDescriptor(elementClass.prototype, propName);
        originDescriptors[propName] = originDescriptor || $bc8d3195204138c7$var$NO_EXIST;
        const spyProp = properties[propName];
        if (typeof spyProp === "function") // If is a function
        elementClass.prototype[propName] = function spyFunc(...args) {
            return spyProp.call(this, originDescriptor, ...args);
        };
        else // Otherwise tread as a property
        Object.defineProperty(elementClass.prototype, propName, {
            ...spyProp,
            set (value) {
                if (spyProp.set) return spyProp.set.call(this, originDescriptor, value);
                return originDescriptor.set(value);
            },
            get () {
                if (spyProp.get) return spyProp.get.call(this, originDescriptor);
                return originDescriptor.get();
            },
            configurable: true
        });
    });
    return {
        mockRestore () {
            propNames.forEach((propName)=>{
                const originDescriptor = originDescriptors[propName];
                if (originDescriptor === $bc8d3195204138c7$var$NO_EXIST) delete elementClass.prototype[propName];
                else if (typeof originDescriptor === "function") elementClass.prototype[propName] = originDescriptor;
                else Object.defineProperty(elementClass.prototype, propName, originDescriptor);
            });
        }
    };
}
function $bc8d3195204138c7$export$731ccc610ab0be2e(Element, propName, property) {
    return $bc8d3195204138c7$export$aa23418fe3feda3a(Element, {
        [propName]: property
    });
} /* eslint-enable */ 



var $cQmXV = parcelRequire("cQmXV");

var $3h5eW = parcelRequire("3h5eW");

const $fa976b7899c7ffe4$var$Portal = /*#__PURE__*/ (0, $cQmXV.forwardRef)((props, ref)=>{
    const { didUpdate: didUpdate, getContainer: getContainer, children: children } = props;
    const parentRef = (0, $cQmXV.useRef)(null);
    const containerRef = (0, $cQmXV.useRef)(null);
    // Ref return nothing, only for wrapper check exist
    (0, $cQmXV.useImperativeHandle)(ref, ()=>({}));
    // Create container in client side with sync to avoid useEffect not get ref
    const initRef = (0, $cQmXV.useRef)(false);
    if (!initRef.current && (0, $78361969822ad097$export$2e2bcd8739ae039)()) {
        containerRef.current = getContainer();
        parentRef.current = containerRef.current.parentNode;
        initRef.current = true;
    }
    // [Legacy] Used by `rc-trigger`
    (0, $cQmXV.useEffect)(()=>{
        didUpdate?.(props);
    });
    (0, $cQmXV.useEffect)(()=>{
        // Restore container to original place
        // React 18 StrictMode will unmount first and mount back for effect test:
        // https://reactjs.org/blog/2022/03/29/react-v18.html#new-strict-mode-behaviors
        if (containerRef.current.parentNode === null && parentRef.current !== null) parentRef.current.appendChild(containerRef.current);
        return ()=>{
            // [Legacy] This should not be handle by Portal but parent PortalWrapper instead.
            // Since some component use `Portal` directly, we have to keep the logic here.
            containerRef.current?.parentNode?.removeChild(containerRef.current);
        };
    }, []);
    return containerRef.current ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3h5eW))).createPortal(children, containerRef.current) : null;
});
var $fa976b7899c7ffe4$export$2e2bcd8739ae039 = $fa976b7899c7ffe4$var$Portal;




const $8e2d153a3c855782$export$826fff653a329e83 = (val)=>{
    return val !== undefined && val !== null;
};
const $8e2d153a3c855782$export$72280d5f896dac9a = (val)=>{
    return $8e2d153a3c855782$export$826fff653a329e83(val) && val !== false && val !== "";
};
const $8e2d153a3c855782$export$7e4aa119212bc614 = (val)=>{
    return typeof val === "number" && !Number.isNaN(val);
};
const $8e2d153a3c855782$export$844ec244b1367d54 = (val)=>{
    return typeof val === "string";
};
const $8e2d153a3c855782$export$53b83ca8eaab0383 = (val)=>{
    return val !== null && typeof val === "object";
};
const $8e2d153a3c855782$export$f6e2535fb5126e54 = (val)=>{
    return typeof val === "function";
};
const $8e2d153a3c855782$export$f5b060c2914b97c8 = (val)=>{
    return $8e2d153a3c855782$export$826fff653a329e83(val) && $8e2d153a3c855782$export$f6e2535fb5126e54(val.then);
};
const $8e2d153a3c855782$export$c3825b437cbdea5c = (val)=>{
    return typeof val !== "object" && !$8e2d153a3c855782$export$f6e2535fb5126e54(val) || val === null;
};
const $8e2d153a3c855782$export$9e6f93c2a213a96b = (event)=>{
    return $8e2d153a3c855782$export$53b83ca8eaab0383(event) && "propertyName" in event && $8e2d153a3c855782$export$844ec244b1367d54(event.propertyName);
};
const $8e2d153a3c855782$export$5a096129d439f843 = (val)=>{
    if (!$8e2d153a3c855782$export$826fff653a329e83(val)) return false;
    return val === val.window;
};
const $8e2d153a3c855782$export$62858bae88b53fd0 = (val)=>{
    if (!$8e2d153a3c855782$export$826fff653a329e83(val)) return false;
    return val instanceof Document || val.constructor.name === "HTMLDocument" || val.nodeType === window.Node.DOCUMENT_NODE;
};
const $8e2d153a3c855782$export$1b3bfaa9684536aa = (val)=>{
    if (!$8e2d153a3c855782$export$826fff653a329e83(val)) return false;
    return typeof HTMLElement !== "undefined" && val instanceof HTMLElement;
};



var $cQmXV = parcelRequire("cQmXV");

function $b5822acdae823465$export$8793edee2d425525() {}
const { resetWarned: $b5822acdae823465$var$rcResetWarned } = (0, $26d7cf6379fe7659$export$2e2bcd8739ae039);
let $b5822acdae823465$var$deprecatedWarnList = null;
function $b5822acdae823465$export$60eef1277fe463e4() {
    $b5822acdae823465$var$deprecatedWarnList = null;
    $b5822acdae823465$var$rcResetWarned();
}
let $b5822acdae823465$var$_warning = $b5822acdae823465$export$8793edee2d425525;
var $b5822acdae823465$var$valid, $b5822acdae823465$var$component, $b5822acdae823465$var$message;
const $b5822acdae823465$var$warning = $b5822acdae823465$var$_warning;
const $b5822acdae823465$export$11b88c75b33aa1fd = /*#__PURE__*/ $cQmXV.createContext({});
const $b5822acdae823465$export$e02e8dff7b78de83 = ()=>{
    const noopWarning = ()=>{};
    noopWarning.deprecated = $b5822acdae823465$export$8793edee2d425525;
    return noopWarning;
};
const $b5822acdae823465$export$cf977aa92c751e61 = $b5822acdae823465$export$e02e8dff7b78de83;
var $b5822acdae823465$export$2e2bcd8739ae039 = $b5822acdae823465$var$warning;



var $cQmXV = parcelRequire("cQmXV");
"use client";
var // ZombieJ: We export single file here since
// ConfigProvider use this which will make loop deps
// to import whole `rc-component/form`
$d111de4f04aff124$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $cQmXV.createContext)(undefined);



var $cQmXV = parcelRequire("cQmXV");

const $879775c0fcd9ca37$var$locale = {
    // Options
    items_per_page: "/ page",
    jump_to: "Go to",
    jump_to_confirm: "confirm",
    page: "Page",
    // Pagination
    prev_page: "Previous Page",
    next_page: "Next Page",
    prev_5: "Previous 5 Pages",
    next_5: "Next 5 Pages",
    prev_3: "Previous 3 Pages",
    next_3: "Next 3 Pages",
    page_size: "Page Size"
};
var $879775c0fcd9ca37$export$2e2bcd8739ae039 = $879775c0fcd9ca37$var$locale;


const $468f660b5a11d829$export$bdd78c3fd9633c1e = {
    yearFormat: "YYYY",
    dayFormat: "D",
    cellMeridiemFormat: "A",
    monthBeforeYear: true
};


const $a52ae8542c88c208$var$locale = {
    ...(0, $468f660b5a11d829$export$bdd78c3fd9633c1e),
    locale: "en_US",
    today: "Today",
    now: "Now",
    backToToday: "Back to today",
    ok: "OK",
    clear: "Clear",
    week: "Week",
    month: "Month",
    year: "Year",
    timeSelect: "select time",
    dateSelect: "select date",
    weekSelect: "Choose a week",
    monthSelect: "Choose a month",
    yearSelect: "Choose a year",
    decadeSelect: "Choose a decade",
    previousMonth: "Previous month",
    nextMonth: "Next month",
    previousYear: "Last year",
    nextYear: "Next year",
    previousDecade: "Last decade",
    nextDecade: "Next decade",
    previousCentury: "Last century",
    nextCentury: "Next century"
};
var $a52ae8542c88c208$export$2e2bcd8739ae039 = $a52ae8542c88c208$var$locale;


const $c55a6778f21ec342$var$locale = {
    placeholder: "Select time",
    rangePlaceholder: [
        "Start time",
        "End time"
    ]
};
var $c55a6778f21ec342$export$2e2bcd8739ae039 = $c55a6778f21ec342$var$locale;


// Merge into a locale object
const $641f44f02f49e3ed$var$locale = {
    lang: {
        placeholder: "Select date",
        yearPlaceholder: "Select year",
        quarterPlaceholder: "Select quarter",
        monthPlaceholder: "Select month",
        weekPlaceholder: "Select week",
        rangePlaceholder: [
            "Start date",
            "End date"
        ],
        rangeYearPlaceholder: [
            "Start year",
            "End year"
        ],
        rangeQuarterPlaceholder: [
            "Start quarter",
            "End quarter"
        ],
        rangeMonthPlaceholder: [
            "Start month",
            "End month"
        ],
        rangeWeekPlaceholder: [
            "Start week",
            "End week"
        ],
        ...(0, $a52ae8542c88c208$export$2e2bcd8739ae039)
    },
    timePickerLocale: {
        ...(0, $c55a6778f21ec342$export$2e2bcd8739ae039)
    }
};
var // All settings at:
// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json
$641f44f02f49e3ed$export$2e2bcd8739ae039 = $641f44f02f49e3ed$var$locale;


var $ee6aa9cc160357b8$export$2e2bcd8739ae039 = (0, $641f44f02f49e3ed$export$2e2bcd8739ae039);




const $4ab0c7032ff9de6a$var$typeTemplate = "${label} is not a valid ${type}";
const $4ab0c7032ff9de6a$var$localeValues = {
    locale: "en",
    Pagination: $879775c0fcd9ca37$export$2e2bcd8739ae039,
    DatePicker: $641f44f02f49e3ed$export$2e2bcd8739ae039,
    TimePicker: $c55a6778f21ec342$export$2e2bcd8739ae039,
    Calendar: $ee6aa9cc160357b8$export$2e2bcd8739ae039,
    global: {
        placeholder: "Please select",
        close: "Close",
        sortable: "sortable",
        show: "Show",
        hide: "Hide"
    },
    Table: {
        filterTitle: "Filter menu",
        filterConfirm: "OK",
        filterReset: "Reset",
        filterEmptyText: "No filters",
        filterCheckAll: "Select all items",
        filterSearchPlaceholder: "Search in filters",
        emptyText: "No data",
        selectAll: "Select current page",
        selectInvert: "Invert current page",
        selectNone: "Clear all data",
        selectionAll: "Select all data",
        sortTitle: "Sort",
        expand: "Expand row",
        collapse: "Collapse row",
        triggerDesc: "Click to sort descending",
        triggerAsc: "Click to sort ascending",
        cancelSort: "Click to cancel sorting"
    },
    Tour: {
        Next: "Next",
        Previous: "Previous",
        Finish: "Finish"
    },
    Modal: {
        okText: "OK",
        cancelText: "Cancel",
        justOkText: "OK"
    },
    Popconfirm: {
        okText: "OK",
        cancelText: "Cancel"
    },
    Transfer: {
        titles: [
            "",
            ""
        ],
        searchPlaceholder: "Search here",
        itemUnit: "item",
        itemsUnit: "items",
        remove: "Remove",
        selectCurrent: "Select current page",
        removeCurrent: "Remove current page",
        selectAll: "Select all data",
        deselectAll: "Deselect all data",
        removeAll: "Remove all data",
        selectInvert: "Invert current page"
    },
    Upload: {
        uploading: "Uploading...",
        removeFile: "Remove file",
        uploadError: "Upload error",
        previewFile: "Preview file",
        downloadFile: "Download file"
    },
    Empty: {
        description: "No data"
    },
    Icon: {
        icon: "icon"
    },
    Text: {
        edit: "Edit",
        copy: "Copy",
        copied: "Copied",
        expand: "Expand",
        collapse: "Collapse"
    },
    Form: {
        optional: "(optional)",
        defaultValidateMessages: {
            default: "Field validation error for ${label}",
            required: "Please enter ${label}",
            enum: "${label} must be one of [${enum}]",
            whitespace: "${label} cannot be a blank character",
            date: {
                format: "${label} date format is invalid",
                parse: "${label} cannot be converted to a date",
                invalid: "${label} is an invalid date"
            },
            types: {
                string: $4ab0c7032ff9de6a$var$typeTemplate,
                method: $4ab0c7032ff9de6a$var$typeTemplate,
                array: $4ab0c7032ff9de6a$var$typeTemplate,
                object: $4ab0c7032ff9de6a$var$typeTemplate,
                number: $4ab0c7032ff9de6a$var$typeTemplate,
                date: $4ab0c7032ff9de6a$var$typeTemplate,
                boolean: $4ab0c7032ff9de6a$var$typeTemplate,
                integer: $4ab0c7032ff9de6a$var$typeTemplate,
                float: $4ab0c7032ff9de6a$var$typeTemplate,
                regexp: $4ab0c7032ff9de6a$var$typeTemplate,
                email: $4ab0c7032ff9de6a$var$typeTemplate,
                url: $4ab0c7032ff9de6a$var$typeTemplate,
                hex: $4ab0c7032ff9de6a$var$typeTemplate
            },
            string: {
                len: "${label} must be ${len} characters",
                min: "${label} must be at least ${min} characters",
                max: "${label} must be up to ${max} characters",
                range: "${label} must be between ${min}-${max} characters"
            },
            number: {
                len: "${label} must be equal to ${len}",
                min: "${label} must be minimum ${min}",
                max: "${label} must be maximum ${max}",
                range: "${label} must be between ${min}-${max}"
            },
            array: {
                len: "Must be ${len} ${label}",
                min: "At least ${min} ${label}",
                max: "At most ${max} ${label}",
                range: "The amount of ${label} must be between ${min}-${max}"
            },
            pattern: {
                mismatch: "${label} does not match the pattern ${pattern}"
            }
        }
    },
    QRCode: {
        expired: "QR code expired",
        refresh: "Refresh",
        scanned: "Scanned"
    },
    ColorPicker: {
        presetEmpty: "Empty",
        transparent: "Transparent",
        singleColor: "Single",
        gradientColor: "Gradient"
    }
};
var $4ab0c7032ff9de6a$export$2e2bcd8739ae039 = $4ab0c7032ff9de6a$var$localeValues;


let $66f33989f9adff20$var$runtimeLocale = {
    ...(0, $4ab0c7032ff9de6a$export$2e2bcd8739ae039).Modal
};
let $66f33989f9adff20$var$localeList = [];
const $66f33989f9adff20$var$generateLocale = ()=>$66f33989f9adff20$var$localeList.reduce((merged, locale)=>({
            ...merged,
            ...locale
        }), (0, $4ab0c7032ff9de6a$export$2e2bcd8739ae039).Modal);
function $66f33989f9adff20$export$9485ecb9d81a550c(newLocale) {
    if (newLocale) {
        const cloneLocale = {
            ...newLocale
        };
        $66f33989f9adff20$var$localeList.push(cloneLocale);
        $66f33989f9adff20$var$runtimeLocale = $66f33989f9adff20$var$generateLocale();
        return ()=>{
            $66f33989f9adff20$var$localeList = $66f33989f9adff20$var$localeList.filter((locale)=>locale !== cloneLocale);
            $66f33989f9adff20$var$runtimeLocale = $66f33989f9adff20$var$generateLocale();
        };
    }
    $66f33989f9adff20$var$runtimeLocale = {
        ...(0, $4ab0c7032ff9de6a$export$2e2bcd8739ae039).Modal
    };
}
function $66f33989f9adff20$export$1b6004afda18cd51() {
    return $66f33989f9adff20$var$runtimeLocale;
}



var $cQmXV = parcelRequire("cQmXV");
const $58fff045e75b7fbc$var$LocaleContext = /*#__PURE__*/ (0, $cQmXV.createContext)(undefined);
var $58fff045e75b7fbc$export$2e2bcd8739ae039 = $58fff045e75b7fbc$var$LocaleContext;



var $cQmXV = parcelRequire("cQmXV");



const $c953dac9d015386e$var$useLocale = (componentName, defaultLocale)=>{
    const fullLocale = $cQmXV.useContext((0, $58fff045e75b7fbc$export$2e2bcd8739ae039));
    const getLocale = $cQmXV.useMemo(()=>{
        const locale = defaultLocale || (0, $4ab0c7032ff9de6a$export$2e2bcd8739ae039)[componentName];
        const localeFromContext = fullLocale?.[componentName] ?? {};
        return {
            ...(0, $8e2d153a3c855782$export$f6e2535fb5126e54)(locale) ? locale() : locale,
            ...localeFromContext || {}
        };
    }, [
        componentName,
        defaultLocale,
        fullLocale
    ]);
    const getLocaleCode = $cQmXV.useMemo(()=>{
        const localeCode = fullLocale?.locale;
        // Had use LocaleProvide but didn't set locale
        if (fullLocale?.exist && !localeCode) return (0, $4ab0c7032ff9de6a$export$2e2bcd8739ae039).locale;
        return localeCode;
    }, [
        fullLocale
    ]);
    return [
        getLocale,
        getLocaleCode
    ];
};
var $c953dac9d015386e$export$2e2bcd8739ae039 = $c953dac9d015386e$var$useLocale;


"use client";
const $a9b226314edf7f3d$export$b2f162cd5c15ea3e = "internalMark";
const $a9b226314edf7f3d$var$LocaleProvider = (props)=>{
    const { locale: locale = {}, children: children, _ANT_MARK__: _ANT_MARK__ } = props;
    $cQmXV.useEffect(()=>{
        const clearLocale = (0, $66f33989f9adff20$export$9485ecb9d81a550c)(locale?.Modal);
        return clearLocale;
    }, [
        locale
    ]);
    const getMemoizedContextValue = $cQmXV.useMemo(()=>({
            ...locale,
            exist: true
        }), [
        locale
    ]);
    return /*#__PURE__*/ $cQmXV.createElement((0, $58fff045e75b7fbc$export$2e2bcd8739ae039).Provider, {
        value: getMemoizedContextValue
    }, children);
};
var $a9b226314edf7f3d$export$2e2bcd8739ae039 = $a9b226314edf7f3d$var$LocaleProvider;





// 36 Hex to reduce the size of the file
var $81356b8aa87b1c45$export$2e2bcd8739ae039 = {
    aliceblue: "9ehhb",
    antiquewhite: "9sgk7",
    aqua: "1ekf",
    aquamarine: "4zsno",
    azure: "9eiv3",
    beige: "9lhp8",
    bisque: "9zg04",
    black: "0",
    blanchedalmond: "9zhe5",
    blue: "73",
    blueviolet: "5e31e",
    brown: "6g016",
    burlywood: "8ouiv",
    cadetblue: "3qba8",
    chartreuse: "4zshs",
    chocolate: "87k0u",
    coral: "9yvyo",
    cornflowerblue: "3xael",
    cornsilk: "9zjz0",
    crimson: "8l4xo",
    cyan: "1ekf",
    darkblue: "3v",
    darkcyan: "rkb",
    darkgoldenrod: "776yz",
    darkgray: "6mbhl",
    darkgreen: "jr4",
    darkgrey: "6mbhl",
    darkkhaki: "7ehkb",
    darkmagenta: "5f91n",
    darkolivegreen: "3bzfz",
    darkorange: "9yygw",
    darkorchid: "5z6x8",
    darkred: "5f8xs",
    darksalmon: "9441m",
    darkseagreen: "5lwgf",
    darkslateblue: "2th1n",
    darkslategray: "1ugcv",
    darkslategrey: "1ugcv",
    darkturquoise: "14up",
    darkviolet: "5rw7n",
    deeppink: "9yavn",
    deepskyblue: "11xb",
    dimgray: "442g9",
    dimgrey: "442g9",
    dodgerblue: "16xof",
    firebrick: "6y7tu",
    floralwhite: "9zkds",
    forestgreen: "1cisi",
    fuchsia: "9y70f",
    gainsboro: "8m8kc",
    ghostwhite: "9pq0v",
    goldenrod: "8j4f4",
    gold: "9zda8",
    gray: "50i2o",
    green: "pa8",
    greenyellow: "6senj",
    grey: "50i2o",
    honeydew: "9eiuo",
    hotpink: "9yrp0",
    indianred: "80gnw",
    indigo: "2xcoy",
    ivory: "9zldc",
    khaki: "9edu4",
    lavenderblush: "9ziet",
    lavender: "90c8q",
    lawngreen: "4vk74",
    lemonchiffon: "9zkct",
    lightblue: "6s73a",
    lightcoral: "9dtog",
    lightcyan: "8s1rz",
    lightgoldenrodyellow: "9sjiq",
    lightgray: "89jo3",
    lightgreen: "5nkwg",
    lightgrey: "89jo3",
    lightpink: "9z6wx",
    lightsalmon: "9z2ii",
    lightseagreen: "19xgq",
    lightskyblue: "5arju",
    lightslategray: "4nwk9",
    lightslategrey: "4nwk9",
    lightsteelblue: "6wau6",
    lightyellow: "9zlcw",
    lime: "1edc",
    limegreen: "1zcxe",
    linen: "9shk6",
    magenta: "9y70f",
    maroon: "4zsow",
    mediumaquamarine: "40eju",
    mediumblue: "5p",
    mediumorchid: "79qkz",
    mediumpurple: "5r3rv",
    mediumseagreen: "2d9ip",
    mediumslateblue: "4tcku",
    mediumspringgreen: "1di2",
    mediumturquoise: "2uabw",
    mediumvioletred: "7rn9h",
    midnightblue: "z980",
    mintcream: "9ljp6",
    mistyrose: "9zg0x",
    moccasin: "9zfzp",
    navajowhite: "9zest",
    navy: "3k",
    oldlace: "9wq92",
    olive: "50hz4",
    olivedrab: "472ub",
    orange: "9z3eo",
    orangered: "9ykg0",
    orchid: "8iu3a",
    palegoldenrod: "9bl4a",
    palegreen: "5yw0o",
    paleturquoise: "6v4ku",
    palevioletred: "8k8lv",
    papayawhip: "9zi6t",
    peachpuff: "9ze0p",
    peru: "80oqn",
    pink: "9z8wb",
    plum: "8nba5",
    powderblue: "6wgdi",
    purple: "4zssg",
    rebeccapurple: "3zk49",
    red: "9y6tc",
    rosybrown: "7cv4f",
    royalblue: "2jvtt",
    saddlebrown: "5fmkz",
    salmon: "9rvci",
    sandybrown: "9jn1c",
    seagreen: "1tdnb",
    seashell: "9zje6",
    sienna: "6973h",
    silver: "7ir40",
    skyblue: "5arjf",
    slateblue: "45e4t",
    slategray: "4e100",
    slategrey: "4e100",
    snow: "9zke2",
    springgreen: "1egv",
    steelblue: "2r1kk",
    tan: "87yx8",
    teal: "pds",
    thistle: "8ggk8",
    tomato: "9yqfb",
    turquoise: "2j4r4",
    violet: "9b10u",
    wheat: "9ld4j",
    white: "9zldr",
    whitesmoke: "9lhpx",
    yellow: "9zl6o",
    yellowgreen: "61fzm"
};


const $3bb84f07fb2a2f32$var$round = Math.round;
/**
 * Support format, alpha unit will check the % mark:
 * - rgba(102, 204, 255, .5)      -> [102, 204, 255, 0.5]
 * - rgb(102 204 255 / .5)        -> [102, 204, 255, 0.5]
 * - rgb(100%, 50%, 0% / 50%)     -> [255, 128, 0, 0.5]
 * - hsl(270, 60, 40, .5)         -> [270, 60, 40, 0.5]
 * - hsl(270deg 60% 40% / 50%)   -> [270, 60, 40, 0.5]
 *
 * When `base` is provided, the percentage value will be divided by `base`.
 */ function $3bb84f07fb2a2f32$var$splitColorStr(str, parseNum) {
    const match = str// Remove str before `(`
    .replace(/^[^(]*\((.*)/, "$1")// Remove str after `)`
    .replace(/\).*/, "").match(/\d*\.?\d+%?/g) || [];
    const numList = match.map((item)=>parseFloat(item));
    for(let i = 0; i < 3; i += 1)numList[i] = parseNum(numList[i] || 0, match[i] || "", i);
    // For alpha. 50% should be 0.5
    if (match[3]) numList[3] = match[3].includes("%") ? numList[3] / 100 : numList[3];
    else // By default, alpha is 1
    numList[3] = 1;
    return numList;
}
const $3bb84f07fb2a2f32$var$parseHSVorHSL = (num, _, index)=>index === 0 ? num : num / 100;
/** round and limit number to integer between 0-255 */ function $3bb84f07fb2a2f32$var$limitRange(value, max) {
    const mergedMax = max || 255;
    if (value > mergedMax) return mergedMax;
    if (value < 0) return 0;
    return value;
}
class $3bb84f07fb2a2f32$export$2c4f38d6c0ecc25a {
    /**
   * All FastColor objects are valid. So isValid is always true. This property is kept to be compatible with TinyColor.
   */ isValid = true;
    /**
   * Red, R in RGB
   */ r = 0;
    /**
   * Green, G in RGB
   */ g = 0;
    /**
   * Blue, B in RGB
   */ b = 0;
    /**
   * Alpha/Opacity, A in RGBA/HSLA
   */ a = 1;
    // HSV privates
    _h;
    _hsl_s;
    _hsv_s;
    _l;
    _v;
    // intermediate variables to calculate HSL/HSV
    _max;
    _min;
    _brightness;
    constructor(input){
        /**
     * Always check 3 char in the object to determine the format.
     * We not use function in check to save bundle size.
     * e.g. 'rgb' -> { r: 0, g: 0, b: 0 }.
     */ function matchFormat(str) {
            return str[0] in input && str[1] in input && str[2] in input;
        }
        if (!input) ;
        else if (typeof input === "string") {
            const trimStr = input.trim();
            function matchPrefix(prefix) {
                return trimStr.startsWith(prefix);
            }
            if (/^#?[A-F\d]{3,8}$/i.test(trimStr)) this.fromHexString(trimStr);
            else if (matchPrefix("rgb")) this.fromRgbString(trimStr);
            else if (matchPrefix("hsl")) this.fromHslString(trimStr);
            else if (matchPrefix("hsv") || matchPrefix("hsb")) this.fromHsvString(trimStr);
            else {
                // From preset color
                const presetColor = (0, $81356b8aa87b1c45$export$2e2bcd8739ae039)[trimStr.toLowerCase()];
                if (presetColor) this.fromHexString(// Convert 36 hex to 16 hex
                parseInt(presetColor, 36).toString(16).padStart(6, "0"));
            }
        } else if (input instanceof $3bb84f07fb2a2f32$export$2c4f38d6c0ecc25a) {
            this.r = input.r;
            this.g = input.g;
            this.b = input.b;
            this.a = input.a;
            this._h = input._h;
            this._hsl_s = input._hsl_s;
            this._hsv_s = input._hsv_s;
            this._l = input._l;
            this._v = input._v;
        } else if (matchFormat("rgb")) {
            this.r = $3bb84f07fb2a2f32$var$limitRange(input.r);
            this.g = $3bb84f07fb2a2f32$var$limitRange(input.g);
            this.b = $3bb84f07fb2a2f32$var$limitRange(input.b);
            this.a = typeof input.a === "number" ? $3bb84f07fb2a2f32$var$limitRange(input.a, 1) : 1;
        } else if (matchFormat("hsl")) this.fromHsl(input);
        else if (matchFormat("hsv")) this.fromHsv(input);
        else throw new Error("@ant-design/fast-color: unsupported input " + JSON.stringify(input));
    }
    // ======================= Setter =======================
    setR(value) {
        return this._sc("r", value);
    }
    setG(value) {
        return this._sc("g", value);
    }
    setB(value) {
        return this._sc("b", value);
    }
    setA(value) {
        return this._sc("a", value, 1);
    }
    setHue(value) {
        const hsv = this.toHsv();
        hsv.h = value;
        return this._c(hsv);
    }
    // ======================= Getter =======================
    /**
   * Returns the perceived luminance of a color, from 0-1.
   * @see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
   */ getLuminance() {
        function adjustGamma(raw) {
            const val = raw / 255;
            return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
        }
        const R = adjustGamma(this.r);
        const G = adjustGamma(this.g);
        const B = adjustGamma(this.b);
        return 0.2126 * R + 0.7152 * G + 0.0722 * B;
    }
    getHue() {
        if (typeof this._h === "undefined") {
            const delta = this.getMax() - this.getMin();
            if (delta === 0) this._h = 0;
            else this._h = $3bb84f07fb2a2f32$var$round(60 * (this.r === this.getMax() ? (this.g - this.b) / delta + (this.g < this.b ? 6 : 0) : this.g === this.getMax() ? (this.b - this.r) / delta + 2 : (this.r - this.g) / delta + 4));
        }
        return this._h;
    }
    /**
   * @deprecated should use getHSVSaturation or getHSLSaturation instead
   */ getSaturation() {
        return this.getHSVSaturation();
    }
    getHSVSaturation() {
        if (typeof this._hsv_s === "undefined") {
            const delta = this.getMax() - this.getMin();
            if (delta === 0) this._hsv_s = 0;
            else this._hsv_s = delta / this.getMax();
        }
        return this._hsv_s;
    }
    getHSLSaturation() {
        if (typeof this._hsl_s === "undefined") {
            const delta = this.getMax() - this.getMin();
            if (delta === 0) this._hsl_s = 0;
            else {
                const l = this.getLightness();
                this._hsl_s = delta / 255 / (1 - Math.abs(2 * l - 1));
            }
        }
        return this._hsl_s;
    }
    getLightness() {
        if (typeof this._l === "undefined") this._l = (this.getMax() + this.getMin()) / 510;
        return this._l;
    }
    getValue() {
        if (typeof this._v === "undefined") this._v = this.getMax() / 255;
        return this._v;
    }
    /**
   * Returns the perceived brightness of the color, from 0-255.
   * Note: this is not the b of HSB
   * @see http://www.w3.org/TR/AERT#color-contrast
   */ getBrightness() {
        if (typeof this._brightness === "undefined") this._brightness = (this.r * 299 + this.g * 587 + this.b * 114) / 1000;
        return this._brightness;
    }
    // ======================== Func ========================
    darken(amount = 10) {
        const h = this.getHue();
        const s = this.getSaturation();
        let l = this.getLightness() - amount / 100;
        if (l < 0) l = 0;
        return this._c({
            h: h,
            s: s,
            l: l,
            a: this.a
        });
    }
    lighten(amount = 10) {
        const h = this.getHue();
        const s = this.getSaturation();
        let l = this.getLightness() + amount / 100;
        if (l > 1) l = 1;
        return this._c({
            h: h,
            s: s,
            l: l,
            a: this.a
        });
    }
    /**
   * Mix the current color a given amount with another color, from 0 to 100.
   * 0 means no mixing (return current color).
   */ mix(input, amount = 50) {
        const color = this._c(input);
        const p = amount / 100;
        const calc = (key)=>(color[key] - this[key]) * p + this[key];
        const rgba = {
            r: $3bb84f07fb2a2f32$var$round(calc("r")),
            g: $3bb84f07fb2a2f32$var$round(calc("g")),
            b: $3bb84f07fb2a2f32$var$round(calc("b")),
            a: $3bb84f07fb2a2f32$var$round(calc("a") * 100) / 100
        };
        return this._c(rgba);
    }
    /**
   * Mix the color with pure white, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return white.
   */ tint(amount = 10) {
        return this.mix({
            r: 255,
            g: 255,
            b: 255,
            a: 1
        }, amount);
    }
    /**
   * Mix the color with pure black, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return black.
   */ shade(amount = 10) {
        return this.mix({
            r: 0,
            g: 0,
            b: 0,
            a: 1
        }, amount);
    }
    onBackground(background) {
        const bg = this._c(background);
        const alpha = this.a + bg.a * (1 - this.a);
        const calc = (key)=>{
            return $3bb84f07fb2a2f32$var$round((this[key] * this.a + bg[key] * bg.a * (1 - this.a)) / alpha);
        };
        return this._c({
            r: calc("r"),
            g: calc("g"),
            b: calc("b"),
            a: alpha
        });
    }
    // ======================= Status =======================
    isDark() {
        return this.getBrightness() < 128;
    }
    isLight() {
        return this.getBrightness() >= 128;
    }
    // ======================== MISC ========================
    equals(other) {
        return this.r === other.r && this.g === other.g && this.b === other.b && this.a === other.a;
    }
    clone() {
        return this._c(this);
    }
    // ======================= Format =======================
    toHexString() {
        let hex = "#";
        const rHex = (this.r || 0).toString(16);
        hex += rHex.length === 2 ? rHex : "0" + rHex;
        const gHex = (this.g || 0).toString(16);
        hex += gHex.length === 2 ? gHex : "0" + gHex;
        const bHex = (this.b || 0).toString(16);
        hex += bHex.length === 2 ? bHex : "0" + bHex;
        if (typeof this.a === "number" && this.a >= 0 && this.a < 1) {
            const aHex = $3bb84f07fb2a2f32$var$round(this.a * 255).toString(16);
            hex += aHex.length === 2 ? aHex : "0" + aHex;
        }
        return hex;
    }
    /** CSS support color pattern */ toHsl() {
        return {
            h: this.getHue(),
            s: this.getHSLSaturation(),
            l: this.getLightness(),
            a: this.a
        };
    }
    /** CSS support color pattern */ toHslString() {
        const h = this.getHue();
        const s = $3bb84f07fb2a2f32$var$round(this.getHSLSaturation() * 100);
        const l = $3bb84f07fb2a2f32$var$round(this.getLightness() * 100);
        return this.a !== 1 ? `hsla(${h},${s}%,${l}%,${this.a})` : `hsl(${h},${s}%,${l}%)`;
    }
    /** Same as toHsb */ toHsv() {
        return {
            h: this.getHue(),
            s: this.getHSVSaturation(),
            v: this.getValue(),
            a: this.a
        };
    }
    toRgb() {
        return {
            r: this.r,
            g: this.g,
            b: this.b,
            a: this.a
        };
    }
    toRgbString() {
        return this.a !== 1 ? `rgba(${this.r},${this.g},${this.b},${this.a})` : `rgb(${this.r},${this.g},${this.b})`;
    }
    toString() {
        return this.toRgbString();
    }
    // ====================== Privates ======================
    /** Return a new FastColor object with one channel changed */ _sc(rgb, value, max) {
        const clone = this.clone();
        clone[rgb] = $3bb84f07fb2a2f32$var$limitRange(value, max);
        return clone;
    }
    _c(input) {
        return new this.constructor(input);
    }
    getMax() {
        if (typeof this._max === "undefined") this._max = Math.max(this.r, this.g, this.b);
        return this._max;
    }
    getMin() {
        if (typeof this._min === "undefined") this._min = Math.min(this.r, this.g, this.b);
        return this._min;
    }
    fromHexString(trimStr) {
        const withoutPrefix = trimStr.replace("#", "");
        function connectNum(index1, index2) {
            return parseInt(withoutPrefix[index1] + withoutPrefix[index2 || index1], 16);
        }
        if (withoutPrefix.length < 6) {
            // #rgb or #rgba
            this.r = connectNum(0);
            this.g = connectNum(1);
            this.b = connectNum(2);
            this.a = withoutPrefix[3] ? connectNum(3) / 255 : 1;
        } else {
            // #rrggbb or #rrggbbaa
            this.r = connectNum(0, 1);
            this.g = connectNum(2, 3);
            this.b = connectNum(4, 5);
            this.a = withoutPrefix[6] ? connectNum(6, 7) / 255 : 1;
        }
    }
    fromHsl({ h: _h, s: s, l: l, a: a }) {
        const h = (_h % 360 + 360) % 360;
        this._h = h;
        this._hsl_s = s;
        this._l = l;
        this.a = typeof a === "number" ? a : 1;
        if (s <= 0) {
            const rgb = $3bb84f07fb2a2f32$var$round(l * 255);
            this.r = rgb;
            this.g = rgb;
            this.b = rgb;
            return;
        }
        let r = 0, g = 0, b = 0;
        const huePrime = h / 60;
        const chroma = (1 - Math.abs(2 * l - 1)) * s;
        const secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
        if (huePrime >= 0 && huePrime < 1) {
            r = chroma;
            g = secondComponent;
        } else if (huePrime >= 1 && huePrime < 2) {
            r = secondComponent;
            g = chroma;
        } else if (huePrime >= 2 && huePrime < 3) {
            g = chroma;
            b = secondComponent;
        } else if (huePrime >= 3 && huePrime < 4) {
            g = secondComponent;
            b = chroma;
        } else if (huePrime >= 4 && huePrime < 5) {
            r = secondComponent;
            b = chroma;
        } else if (huePrime >= 5 && huePrime < 6) {
            r = chroma;
            b = secondComponent;
        }
        const lightnessModification = l - chroma / 2;
        this.r = $3bb84f07fb2a2f32$var$round((r + lightnessModification) * 255);
        this.g = $3bb84f07fb2a2f32$var$round((g + lightnessModification) * 255);
        this.b = $3bb84f07fb2a2f32$var$round((b + lightnessModification) * 255);
    }
    fromHsv({ h: _h, s: s, v: v, a: a }) {
        const h = (_h % 360 + 360) % 360;
        this._h = h;
        this._hsv_s = s;
        this._v = v;
        this.a = typeof a === "number" ? a : 1;
        const vv = $3bb84f07fb2a2f32$var$round(v * 255);
        this.r = vv;
        this.g = vv;
        this.b = vv;
        if (s <= 0) return;
        const hh = h / 60;
        const i = Math.floor(hh);
        const ff = hh - i;
        const p = $3bb84f07fb2a2f32$var$round(v * (1.0 - s) * 255);
        const q = $3bb84f07fb2a2f32$var$round(v * (1.0 - s * ff) * 255);
        const t = $3bb84f07fb2a2f32$var$round(v * (1.0 - s * (1.0 - ff)) * 255);
        switch(i){
            case 0:
                this.g = t;
                this.b = p;
                break;
            case 1:
                this.r = q;
                this.b = p;
                break;
            case 2:
                this.r = p;
                this.b = t;
                break;
            case 3:
                this.r = p;
                this.g = q;
                break;
            case 4:
                this.r = t;
                this.g = p;
                break;
            case 5:
            default:
                this.g = p;
                this.b = q;
                break;
        }
    }
    fromHsvString(trimStr) {
        const cells = $3bb84f07fb2a2f32$var$splitColorStr(trimStr, $3bb84f07fb2a2f32$var$parseHSVorHSL);
        this.fromHsv({
            h: cells[0],
            s: cells[1],
            v: cells[2],
            a: cells[3]
        });
    }
    fromHslString(trimStr) {
        const cells = $3bb84f07fb2a2f32$var$splitColorStr(trimStr, $3bb84f07fb2a2f32$var$parseHSVorHSL);
        this.fromHsl({
            h: cells[0],
            s: cells[1],
            l: cells[2],
            a: cells[3]
        });
    }
    fromRgbString(trimStr) {
        const cells = $3bb84f07fb2a2f32$var$splitColorStr(trimStr, (num, txt)=>// Convert percentage to number. e.g. 50% -> 128
            txt.includes("%") ? $3bb84f07fb2a2f32$var$round(num / 100 * 255) : num);
        this.r = cells[0];
        this.g = cells[1];
        this.b = cells[2];
        this.a = cells[3];
    }
}






const $8da55d644cf9b154$var$hueStep = 2; // 色相阶梯
const $8da55d644cf9b154$var$saturationStep = 0.16; // 饱和度阶梯，浅色部分
const $8da55d644cf9b154$var$saturationStep2 = 0.05; // 饱和度阶梯，深色部分
const $8da55d644cf9b154$var$brightnessStep1 = 0.05; // 亮度阶梯，浅色部分
const $8da55d644cf9b154$var$brightnessStep2 = 0.15; // 亮度阶梯，深色部分
const $8da55d644cf9b154$var$lightColorCount = 5; // 浅色数量，主色上
const $8da55d644cf9b154$var$darkColorCount = 4; // 深色数量，主色下
// 暗色主题颜色映射关系表
const $8da55d644cf9b154$var$darkColorMap = [
    {
        index: 7,
        amount: 15
    },
    {
        index: 6,
        amount: 25
    },
    {
        index: 5,
        amount: 30
    },
    {
        index: 5,
        amount: 45
    },
    {
        index: 5,
        amount: 65
    },
    {
        index: 5,
        amount: 85
    },
    {
        index: 4,
        amount: 90
    },
    {
        index: 3,
        amount: 95
    },
    {
        index: 2,
        amount: 97
    },
    {
        index: 1,
        amount: 98
    }
];
function $8da55d644cf9b154$var$getHue(hsv, i, light) {
    let hue;
    // 根据色相不同，色相转向不同
    if (Math.round(hsv.h) >= 60 && Math.round(hsv.h) <= 240) hue = light ? Math.round(hsv.h) - $8da55d644cf9b154$var$hueStep * i : Math.round(hsv.h) + $8da55d644cf9b154$var$hueStep * i;
    else hue = light ? Math.round(hsv.h) + $8da55d644cf9b154$var$hueStep * i : Math.round(hsv.h) - $8da55d644cf9b154$var$hueStep * i;
    if (hue < 0) hue += 360;
    else if (hue >= 360) hue -= 360;
    return hue;
}
function $8da55d644cf9b154$var$getSaturation(hsv, i, light) {
    // grey color don't change saturation
    if (hsv.h === 0 && hsv.s === 0) return hsv.s;
    let saturation;
    if (light) saturation = hsv.s - $8da55d644cf9b154$var$saturationStep * i;
    else if (i === $8da55d644cf9b154$var$darkColorCount) saturation = hsv.s + $8da55d644cf9b154$var$saturationStep;
    else saturation = hsv.s + $8da55d644cf9b154$var$saturationStep2 * i;
    // 边界值修正
    if (saturation > 1) saturation = 1;
    // 第一格的 s 限制在 0.06-0.1 之间
    if (light && i === $8da55d644cf9b154$var$lightColorCount && saturation > 0.1) saturation = 0.1;
    if (saturation < 0.06) saturation = 0.06;
    return Math.round(saturation * 100) / 100;
}
function $8da55d644cf9b154$var$getValue(hsv, i, light) {
    let value;
    if (light) value = hsv.v + $8da55d644cf9b154$var$brightnessStep1 * i;
    else value = hsv.v - $8da55d644cf9b154$var$brightnessStep2 * i;
    // Clamp value between 0 and 1
    value = Math.max(0, Math.min(1, value));
    return Math.round(value * 100) / 100;
}
function $8da55d644cf9b154$export$2e2bcd8739ae039(color, opts = {}) {
    const patterns = [];
    const pColor = new (0, $3bb84f07fb2a2f32$export$2c4f38d6c0ecc25a)(color);
    const hsv = pColor.toHsv();
    for(let i = $8da55d644cf9b154$var$lightColorCount; i > 0; i -= 1){
        const c = new (0, $3bb84f07fb2a2f32$export$2c4f38d6c0ecc25a)({
            h: $8da55d644cf9b154$var$getHue(hsv, i, true),
            s: $8da55d644cf9b154$var$getSaturation(hsv, i, true),
            v: $8da55d644cf9b154$var$getValue(hsv, i, true)
        });
        patterns.push(c);
    }
    patterns.push(pColor);
    for(let i = 1; i <= $8da55d644cf9b154$var$darkColorCount; i += 1){
        const c = new (0, $3bb84f07fb2a2f32$export$2c4f38d6c0ecc25a)({
            h: $8da55d644cf9b154$var$getHue(hsv, i),
            s: $8da55d644cf9b154$var$getSaturation(hsv, i),
            v: $8da55d644cf9b154$var$getValue(hsv, i)
        });
        patterns.push(c);
    }
    // dark theme patterns
    if (opts.theme === "dark") return $8da55d644cf9b154$var$darkColorMap.map(({ index: index, amount: amount })=>new (0, $3bb84f07fb2a2f32$export$2c4f38d6c0ecc25a)(opts.backgroundColor || "#141414").mix(patterns[index], amount).toHexString());
    return patterns.map((c)=>c.toHexString());
}


// Generated by script. Do NOT modify!
const $bac0cac4764de8cf$export$3968a3afc810b5f5 = {
    "red": "#F5222D",
    "volcano": "#FA541C",
    "orange": "#FA8C16",
    "gold": "#FAAD14",
    "yellow": "#FADB14",
    "lime": "#A0D911",
    "green": "#52C41A",
    "cyan": "#13C2C2",
    "blue": "#1677FF",
    "geekblue": "#2F54EB",
    "purple": "#722ED1",
    "magenta": "#EB2F96",
    "grey": "#666666"
};
const $bac0cac4764de8cf$export$a90204d1394caf30 = [
    "#fff1f0",
    "#ffccc7",
    "#ffa39e",
    "#ff7875",
    "#ff4d4f",
    "#f5222d",
    "#cf1322",
    "#a8071a",
    "#820014",
    "#5c0011"
];
$bac0cac4764de8cf$export$a90204d1394caf30.primary = $bac0cac4764de8cf$export$a90204d1394caf30[5];
const $bac0cac4764de8cf$export$e63a1643b2f79b16 = [
    "#fff2e8",
    "#ffd8bf",
    "#ffbb96",
    "#ff9c6e",
    "#ff7a45",
    "#fa541c",
    "#d4380d",
    "#ad2102",
    "#871400",
    "#610b00"
];
$bac0cac4764de8cf$export$e63a1643b2f79b16.primary = $bac0cac4764de8cf$export$e63a1643b2f79b16[5];
const $bac0cac4764de8cf$export$ad766f34ace1cafd = [
    "#fff7e6",
    "#ffe7ba",
    "#ffd591",
    "#ffc069",
    "#ffa940",
    "#fa8c16",
    "#d46b08",
    "#ad4e00",
    "#873800",
    "#612500"
];
$bac0cac4764de8cf$export$ad766f34ace1cafd.primary = $bac0cac4764de8cf$export$ad766f34ace1cafd[5];
const $bac0cac4764de8cf$export$c24201f7fe3571d8 = [
    "#fffbe6",
    "#fff1b8",
    "#ffe58f",
    "#ffd666",
    "#ffc53d",
    "#faad14",
    "#d48806",
    "#ad6800",
    "#874d00",
    "#613400"
];
$bac0cac4764de8cf$export$c24201f7fe3571d8.primary = $bac0cac4764de8cf$export$c24201f7fe3571d8[5];
const $bac0cac4764de8cf$export$594c5a8758200c32 = [
    "#feffe6",
    "#ffffb8",
    "#fffb8f",
    "#fff566",
    "#ffec3d",
    "#fadb14",
    "#d4b106",
    "#ad8b00",
    "#876800",
    "#614700"
];
$bac0cac4764de8cf$export$594c5a8758200c32.primary = $bac0cac4764de8cf$export$594c5a8758200c32[5];
const $bac0cac4764de8cf$export$221d31baf2636aad = [
    "#fcffe6",
    "#f4ffb8",
    "#eaff8f",
    "#d3f261",
    "#bae637",
    "#a0d911",
    "#7cb305",
    "#5b8c00",
    "#3f6600",
    "#254000"
];
$bac0cac4764de8cf$export$221d31baf2636aad.primary = $bac0cac4764de8cf$export$221d31baf2636aad[5];
const $bac0cac4764de8cf$export$955a2ebd2fb142ae = [
    "#f6ffed",
    "#d9f7be",
    "#b7eb8f",
    "#95de64",
    "#73d13d",
    "#52c41a",
    "#389e0d",
    "#237804",
    "#135200",
    "#092b00"
];
$bac0cac4764de8cf$export$955a2ebd2fb142ae.primary = $bac0cac4764de8cf$export$955a2ebd2fb142ae[5];
const $bac0cac4764de8cf$export$7474046f446842ee = [
    "#e6fffb",
    "#b5f5ec",
    "#87e8de",
    "#5cdbd3",
    "#36cfc9",
    "#13c2c2",
    "#08979c",
    "#006d75",
    "#00474f",
    "#002329"
];
$bac0cac4764de8cf$export$7474046f446842ee.primary = $bac0cac4764de8cf$export$7474046f446842ee[5];
const $bac0cac4764de8cf$export$2aa0182783e7e9de = [
    "#e6f4ff",
    "#bae0ff",
    "#91caff",
    "#69b1ff",
    "#4096ff",
    "#1677ff",
    "#0958d9",
    "#003eb3",
    "#002c8c",
    "#001d66"
];
$bac0cac4764de8cf$export$2aa0182783e7e9de.primary = $bac0cac4764de8cf$export$2aa0182783e7e9de[5];
const $bac0cac4764de8cf$export$4138d3aeddcbf415 = [
    "#f0f5ff",
    "#d6e4ff",
    "#adc6ff",
    "#85a5ff",
    "#597ef7",
    "#2f54eb",
    "#1d39c4",
    "#10239e",
    "#061178",
    "#030852"
];
$bac0cac4764de8cf$export$4138d3aeddcbf415.primary = $bac0cac4764de8cf$export$4138d3aeddcbf415[5];
const $bac0cac4764de8cf$export$e13cce2a2d16a9d4 = [
    "#f9f0ff",
    "#efdbff",
    "#d3adf7",
    "#b37feb",
    "#9254de",
    "#722ed1",
    "#531dab",
    "#391085",
    "#22075e",
    "#120338"
];
$bac0cac4764de8cf$export$e13cce2a2d16a9d4.primary = $bac0cac4764de8cf$export$e13cce2a2d16a9d4[5];
const $bac0cac4764de8cf$export$2a9ca2e383622e18 = [
    "#fff0f6",
    "#ffd6e7",
    "#ffadd2",
    "#ff85c0",
    "#f759ab",
    "#eb2f96",
    "#c41d7f",
    "#9e1068",
    "#780650",
    "#520339"
];
$bac0cac4764de8cf$export$2a9ca2e383622e18.primary = $bac0cac4764de8cf$export$2a9ca2e383622e18[5];
const $bac0cac4764de8cf$export$e4c89085febbc618 = [
    "#a6a6a6",
    "#999999",
    "#8c8c8c",
    "#808080",
    "#737373",
    "#666666",
    "#404040",
    "#1a1a1a",
    "#000000",
    "#000000"
];
$bac0cac4764de8cf$export$e4c89085febbc618.primary = $bac0cac4764de8cf$export$e4c89085febbc618[5];
const $bac0cac4764de8cf$export$3e2c219d3ab79d01 = $bac0cac4764de8cf$export$e4c89085febbc618;
const $bac0cac4764de8cf$export$36ad6df0f83f284d = {
    red: $bac0cac4764de8cf$export$a90204d1394caf30,
    volcano: $bac0cac4764de8cf$export$e63a1643b2f79b16,
    orange: $bac0cac4764de8cf$export$ad766f34ace1cafd,
    gold: $bac0cac4764de8cf$export$c24201f7fe3571d8,
    yellow: $bac0cac4764de8cf$export$594c5a8758200c32,
    lime: $bac0cac4764de8cf$export$221d31baf2636aad,
    green: $bac0cac4764de8cf$export$955a2ebd2fb142ae,
    cyan: $bac0cac4764de8cf$export$7474046f446842ee,
    blue: $bac0cac4764de8cf$export$2aa0182783e7e9de,
    geekblue: $bac0cac4764de8cf$export$4138d3aeddcbf415,
    purple: $bac0cac4764de8cf$export$e13cce2a2d16a9d4,
    magenta: $bac0cac4764de8cf$export$2a9ca2e383622e18,
    grey: $bac0cac4764de8cf$export$e4c89085febbc618
};
const $bac0cac4764de8cf$export$e984d34fc144caa1 = [
    "#2a1215",
    "#431418",
    "#58181c",
    "#791a1f",
    "#a61d24",
    "#d32029",
    "#e84749",
    "#f37370",
    "#f89f9a",
    "#fac8c3"
];
$bac0cac4764de8cf$export$e984d34fc144caa1.primary = $bac0cac4764de8cf$export$e984d34fc144caa1[5];
const $bac0cac4764de8cf$export$360e10f78e17a865 = [
    "#2b1611",
    "#441d12",
    "#592716",
    "#7c3118",
    "#aa3e19",
    "#d84a1b",
    "#e87040",
    "#f3956a",
    "#f8b692",
    "#fad4bc"
];
$bac0cac4764de8cf$export$360e10f78e17a865.primary = $bac0cac4764de8cf$export$360e10f78e17a865[5];
const $bac0cac4764de8cf$export$d5a12c698b31fa45 = [
    "#2b1d11",
    "#442a11",
    "#593815",
    "#7c4a15",
    "#aa6215",
    "#d87a16",
    "#e89a3c",
    "#f3b765",
    "#f8cf8d",
    "#fae3b7"
];
$bac0cac4764de8cf$export$d5a12c698b31fa45.primary = $bac0cac4764de8cf$export$d5a12c698b31fa45[5];
const $bac0cac4764de8cf$export$2330427fb6a6af6f = [
    "#2b2111",
    "#443111",
    "#594214",
    "#7c5914",
    "#aa7714",
    "#d89614",
    "#e8b339",
    "#f3cc62",
    "#f8df8b",
    "#faedb5"
];
$bac0cac4764de8cf$export$2330427fb6a6af6f.primary = $bac0cac4764de8cf$export$2330427fb6a6af6f[5];
const $bac0cac4764de8cf$export$67d203119f0ecec = [
    "#2b2611",
    "#443b11",
    "#595014",
    "#7c6e14",
    "#aa9514",
    "#d8bd14",
    "#e8d639",
    "#f3ea62",
    "#f8f48b",
    "#fafab5"
];
$bac0cac4764de8cf$export$67d203119f0ecec.primary = $bac0cac4764de8cf$export$67d203119f0ecec[5];
const $bac0cac4764de8cf$export$51ed2a10d86576ed = [
    "#1f2611",
    "#2e3c10",
    "#3e4f13",
    "#536d13",
    "#6f9412",
    "#8bbb11",
    "#a9d134",
    "#c9e75d",
    "#e4f88b",
    "#f0fab5"
];
$bac0cac4764de8cf$export$51ed2a10d86576ed.primary = $bac0cac4764de8cf$export$51ed2a10d86576ed[5];
const $bac0cac4764de8cf$export$76a3d804058f9b5f = [
    "#162312",
    "#1d3712",
    "#274916",
    "#306317",
    "#3c8618",
    "#49aa19",
    "#6abe39",
    "#8fd460",
    "#b2e58b",
    "#d5f2bb"
];
$bac0cac4764de8cf$export$76a3d804058f9b5f.primary = $bac0cac4764de8cf$export$76a3d804058f9b5f[5];
const $bac0cac4764de8cf$export$dee6c7c6683c0d88 = [
    "#112123",
    "#113536",
    "#144848",
    "#146262",
    "#138585",
    "#13a8a8",
    "#33bcb7",
    "#58d1c9",
    "#84e2d8",
    "#b2f1e8"
];
$bac0cac4764de8cf$export$dee6c7c6683c0d88.primary = $bac0cac4764de8cf$export$dee6c7c6683c0d88[5];
const $bac0cac4764de8cf$export$10e0fd027e632624 = [
    "#111a2c",
    "#112545",
    "#15325b",
    "#15417e",
    "#1554ad",
    "#1668dc",
    "#3c89e8",
    "#65a9f3",
    "#8dc5f8",
    "#b7dcfa"
];
$bac0cac4764de8cf$export$10e0fd027e632624.primary = $bac0cac4764de8cf$export$10e0fd027e632624[5];
const $bac0cac4764de8cf$export$abdd57ab473bba66 = [
    "#131629",
    "#161d40",
    "#1c2755",
    "#203175",
    "#263ea0",
    "#2b4acb",
    "#5273e0",
    "#7f9ef3",
    "#a8c1f8",
    "#d2e0fa"
];
$bac0cac4764de8cf$export$abdd57ab473bba66.primary = $bac0cac4764de8cf$export$abdd57ab473bba66[5];
const $bac0cac4764de8cf$export$7a65e68792738764 = [
    "#1a1325",
    "#24163a",
    "#301c4d",
    "#3e2069",
    "#51258f",
    "#642ab5",
    "#854eca",
    "#ab7ae0",
    "#cda8f0",
    "#ebd7fa"
];
$bac0cac4764de8cf$export$7a65e68792738764.primary = $bac0cac4764de8cf$export$7a65e68792738764[5];
const $bac0cac4764de8cf$export$d260a9321db4ab86 = [
    "#291321",
    "#40162f",
    "#551c3b",
    "#75204f",
    "#a02669",
    "#cb2b83",
    "#e0529c",
    "#f37fb7",
    "#f8a8cc",
    "#fad2e3"
];
$bac0cac4764de8cf$export$d260a9321db4ab86.primary = $bac0cac4764de8cf$export$d260a9321db4ab86[5];
const $bac0cac4764de8cf$export$515283ba400ffa6c = [
    "#151515",
    "#1f1f1f",
    "#2d2d2d",
    "#393939",
    "#494949",
    "#5a5a5a",
    "#6a6a6a",
    "#7b7b7b",
    "#888888",
    "#969696"
];
$bac0cac4764de8cf$export$515283ba400ffa6c.primary = $bac0cac4764de8cf$export$515283ba400ffa6c[5];
const $bac0cac4764de8cf$export$24617255e4daf647 = {
    red: $bac0cac4764de8cf$export$e984d34fc144caa1,
    volcano: $bac0cac4764de8cf$export$360e10f78e17a865,
    orange: $bac0cac4764de8cf$export$d5a12c698b31fa45,
    gold: $bac0cac4764de8cf$export$2330427fb6a6af6f,
    yellow: $bac0cac4764de8cf$export$67d203119f0ecec,
    lime: $bac0cac4764de8cf$export$51ed2a10d86576ed,
    green: $bac0cac4764de8cf$export$76a3d804058f9b5f,
    cyan: $bac0cac4764de8cf$export$dee6c7c6683c0d88,
    blue: $bac0cac4764de8cf$export$10e0fd027e632624,
    geekblue: $bac0cac4764de8cf$export$abdd57ab473bba66,
    purple: $bac0cac4764de8cf$export$7a65e68792738764,
    magenta: $bac0cac4764de8cf$export$d260a9321db4ab86,
    grey: $bac0cac4764de8cf$export$515283ba400ffa6c
};




const $84fac8c8876d9d5c$export$37e27b43af4d16eb = {
    blue: "#1677FF",
    purple: "#722ED1",
    cyan: "#13C2C2",
    green: "#52C41A",
    magenta: "#EB2F96",
    /**
   * @deprecated Use magenta instead
   */ pink: "#EB2F96",
    red: "#F5222D",
    orange: "#FA8C16",
    yellow: "#FADB14",
    volcano: "#FA541C",
    geekblue: "#2F54EB",
    gold: "#FAAD14",
    lime: "#A0D911"
};
const $84fac8c8876d9d5c$var$seedToken = {
    // preset color palettes
    ...$84fac8c8876d9d5c$export$37e27b43af4d16eb,
    // Color
    colorPrimary: "#1677ff",
    colorSuccess: "#52c41a",
    colorWarning: "#faad14",
    colorError: "#ff4d4f",
    colorInfo: "#1677ff",
    colorLink: "",
    colorTextBase: "",
    colorBgBase: "",
    // Font
    fontFamily: `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
'Noto Color Emoji'`,
    fontFamilyCode: `'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace`,
    fontSize: 14,
    // Line
    lineWidth: 1,
    lineType: "solid",
    // Motion
    motionUnit: 0.1,
    motionBase: 0,
    motionEaseOutCirc: "cubic-bezier(0.08, 0.82, 0.17, 1)",
    motionEaseInOutCirc: "cubic-bezier(0.78, 0.14, 0.15, 0.86)",
    motionEaseOut: "cubic-bezier(0.215, 0.61, 0.355, 1)",
    motionEaseInOut: "cubic-bezier(0.645, 0.045, 0.355, 1)",
    motionEaseOutBack: "cubic-bezier(0.12, 0.4, 0.29, 1.46)",
    motionEaseInBack: "cubic-bezier(0.71, -0.46, 0.88, 0.6)",
    motionEaseInQuint: "cubic-bezier(0.755, 0.05, 0.855, 0.06)",
    motionEaseOutQuint: "cubic-bezier(0.23, 1, 0.32, 1)",
    // Radius
    borderRadius: 6,
    // Size
    sizeUnit: 4,
    sizeStep: 4,
    sizePopupArrow: 16,
    // Control Base
    controlHeight: 32,
    // zIndex
    zIndexBase: 0,
    zIndexPopupBase: 1000,
    // Image
    opacityImage: 1,
    // Wireframe
    wireframe: false,
    // Focus Outline
    focusOutline: true,
    // Motion
    motion: true
};
var $84fac8c8876d9d5c$export$2e2bcd8739ae039 = $84fac8c8876d9d5c$var$seedToken;



const $ade5e73b59dc3f96$export$6d4fe3a00a1811ad = [
    "blue",
    "purple",
    "cyan",
    "green",
    "magenta",
    "pink",
    "red",
    "orange",
    "yellow",
    "volcano",
    "geekblue",
    "lime",
    "gold"
];


function $9d836749d581943a$export$2e2bcd8739ae039(seed, { generateColorPalettes: generateColorPalettes, generateNeutralColorPalettes: generateNeutralColorPalettes }) {
    const { colorSuccess: colorSuccessBase, colorWarning: colorWarningBase, colorError: colorErrorBase, colorInfo: colorInfoBase, colorPrimary: colorPrimaryBase, colorBgBase: colorBgBase, colorTextBase: colorTextBase } = seed;
    const primaryColors = generateColorPalettes(colorPrimaryBase);
    const successColors = generateColorPalettes(colorSuccessBase);
    const warningColors = generateColorPalettes(colorWarningBase);
    const errorColors = generateColorPalettes(colorErrorBase);
    const infoColors = generateColorPalettes(colorInfoBase);
    const neutralColors = generateNeutralColorPalettes(colorBgBase, colorTextBase);
    // Color Link
    const colorLink = seed.colorLink || seed.colorInfo;
    const linkColors = generateColorPalettes(colorLink);
    const colorErrorBgFilledHover = new (0, $3bb84f07fb2a2f32$export$2c4f38d6c0ecc25a)(errorColors[1]).mix(new (0, $3bb84f07fb2a2f32$export$2c4f38d6c0ecc25a)(errorColors[3]), 50).toHexString();
    const presetColorTokens = {};
    (0, $ade5e73b59dc3f96$export$6d4fe3a00a1811ad).forEach((colorKey)=>{
        const colorBase = seed[colorKey];
        if (colorBase) {
            const colorPalette = generateColorPalettes(colorBase);
            presetColorTokens[`${colorKey}Hover`] = colorPalette[5];
            presetColorTokens[`${colorKey}Active`] = colorPalette[7];
        }
    });
    return {
        ...neutralColors,
        colorPrimaryBg: primaryColors[1],
        colorPrimaryBgHover: primaryColors[2],
        colorPrimaryBorder: primaryColors[3],
        colorPrimaryBorderHover: primaryColors[4],
        colorPrimaryHover: primaryColors[5],
        colorPrimary: primaryColors[6],
        colorPrimaryActive: primaryColors[7],
        colorPrimaryTextHover: primaryColors[8],
        colorPrimaryText: primaryColors[9],
        colorPrimaryTextActive: primaryColors[10],
        colorSuccessBg: successColors[1],
        colorSuccessBgHover: successColors[2],
        colorSuccessBorder: successColors[3],
        colorSuccessBorderHover: successColors[4],
        colorSuccessHover: successColors[4],
        colorSuccess: successColors[6],
        colorSuccessActive: successColors[7],
        colorSuccessTextHover: successColors[8],
        colorSuccessText: successColors[9],
        colorSuccessTextActive: successColors[10],
        colorErrorBg: errorColors[1],
        colorErrorBgHover: errorColors[2],
        colorErrorBgFilledHover: colorErrorBgFilledHover,
        colorErrorBgActive: errorColors[3],
        colorErrorBorder: errorColors[3],
        colorErrorBorderHover: errorColors[4],
        colorErrorHover: errorColors[5],
        colorError: errorColors[6],
        colorErrorActive: errorColors[7],
        colorErrorTextHover: errorColors[8],
        colorErrorText: errorColors[9],
        colorErrorTextActive: errorColors[10],
        colorWarningBg: warningColors[1],
        colorWarningBgHover: warningColors[2],
        colorWarningBorder: warningColors[3],
        colorWarningBorderHover: warningColors[4],
        colorWarningHover: warningColors[4],
        colorWarning: warningColors[6],
        colorWarningActive: warningColors[7],
        colorWarningTextHover: warningColors[8],
        colorWarningText: warningColors[9],
        colorWarningTextActive: warningColors[10],
        colorInfoBg: infoColors[1],
        colorInfoBgHover: infoColors[2],
        colorInfoBorder: infoColors[3],
        colorInfoBorderHover: infoColors[4],
        colorInfoHover: infoColors[4],
        colorInfo: infoColors[6],
        colorInfoActive: infoColors[7],
        colorInfoTextHover: infoColors[8],
        colorInfoText: infoColors[9],
        colorInfoTextActive: infoColors[10],
        colorLinkHover: linkColors[4],
        colorLink: linkColors[6],
        colorLinkActive: linkColors[7],
        ...presetColorTokens,
        colorBgMask: new (0, $3bb84f07fb2a2f32$export$2c4f38d6c0ecc25a)("#000").setA(0.45).toRgbString(),
        colorWhite: "#fff"
    };
}


const $519a1725e1582f0b$var$genRadius = (radiusBase)=>{
    let radiusLG = radiusBase;
    let radiusSM = radiusBase;
    let radiusXS = radiusBase;
    let radiusOuter = radiusBase;
    // radiusLG
    if (radiusBase < 6 && radiusBase >= 5) radiusLG = radiusBase + 1;
    else if (radiusBase < 16 && radiusBase >= 6) radiusLG = radiusBase + 2;
    else if (radiusBase >= 16) radiusLG = 16;
    // radiusSM
    if (radiusBase < 7 && radiusBase >= 5) radiusSM = 4;
    else if (radiusBase < 8 && radiusBase >= 7) radiusSM = 5;
    else if (radiusBase < 14 && radiusBase >= 8) radiusSM = 6;
    else if (radiusBase < 16 && radiusBase >= 14) radiusSM = 7;
    else if (radiusBase >= 16) radiusSM = 8;
    // radiusXS
    if (radiusBase < 6 && radiusBase >= 2) radiusXS = 1;
    else if (radiusBase >= 6) radiusXS = 2;
    // radiusOuter
    if (radiusBase > 4 && radiusBase < 8) radiusOuter = 4;
    else if (radiusBase >= 8) radiusOuter = 6;
    return {
        borderRadius: radiusBase,
        borderRadiusXS: radiusXS,
        borderRadiusSM: radiusSM,
        borderRadiusLG: radiusLG,
        borderRadiusOuter: radiusOuter
    };
};
var $519a1725e1582f0b$export$2e2bcd8739ae039 = $519a1725e1582f0b$var$genRadius;


function $0c9fba075dec08aa$export$2e2bcd8739ae039(token) {
    const { motionUnit: motionUnit, motionBase: motionBase, borderRadius: borderRadius, lineWidth: lineWidth } = token;
    return {
        // motion
        motionDurationFast: `${(motionBase + motionUnit).toFixed(1)}s`,
        motionDurationMid: `${(motionBase + motionUnit * 2).toFixed(1)}s`,
        motionDurationSlow: `${(motionBase + motionUnit * 3).toFixed(1)}s`,
        // line
        lineWidthBold: lineWidth + 1,
        // radius
        ...(0, $519a1725e1582f0b$export$2e2bcd8739ae039)(borderRadius)
    };
}


const $a5fcd3dbe0aeee12$var$genControlHeight = (token)=>{
    const { controlHeight: controlHeight } = token;
    return {
        controlHeightSM: controlHeight * 0.75,
        controlHeightXS: controlHeight * 0.5,
        controlHeightLG: controlHeight * 1.25
    };
};
var $a5fcd3dbe0aeee12$export$2e2bcd8739ae039 = $a5fcd3dbe0aeee12$var$genControlHeight;


function $7e34bbc761b71f61$export$56204a27a2958a55(fontSize) {
    return (fontSize + 8) / fontSize;
}
function $7e34bbc761b71f61$export$2e2bcd8739ae039(base) {
    const fontSizes = Array.from({
        length: 10
    }).map((_, index)=>{
        const i = index - 1;
        const baseSize = base * Math.E ** (i / 5);
        const intSize = index > 1 ? Math.floor(baseSize) : Math.ceil(baseSize);
        // Convert to even
        return Math.floor(intSize / 2) * 2;
    });
    fontSizes[1] = base;
    return fontSizes.map((size)=>({
            size: size,
            lineHeight: $7e34bbc761b71f61$export$56204a27a2958a55(size)
        }));
}


const $d4f7189528fc8577$var$genFontMapToken = (fontSize)=>{
    const fontSizePairs = (0, $7e34bbc761b71f61$export$2e2bcd8739ae039)(fontSize);
    const fontSizes = fontSizePairs.map((pair)=>pair.size);
    const lineHeights = fontSizePairs.map((pair)=>pair.lineHeight);
    const fontSizeMD = fontSizes[1];
    const fontSizeSM = fontSizes[0];
    const fontSizeLG = fontSizes[2];
    const lineHeight = lineHeights[1];
    const lineHeightSM = lineHeights[0];
    const lineHeightLG = lineHeights[2];
    return {
        fontSizeSM: fontSizeSM,
        fontSize: fontSizeMD,
        fontSizeLG: fontSizeLG,
        fontSizeXL: fontSizes[3],
        fontSizeHeading1: fontSizes[6],
        fontSizeHeading2: fontSizes[5],
        fontSizeHeading3: fontSizes[4],
        fontSizeHeading4: fontSizes[3],
        fontSizeHeading5: fontSizes[2],
        lineHeight: lineHeight,
        lineHeightLG: lineHeightLG,
        lineHeightSM: lineHeightSM,
        fontHeight: Math.round(lineHeight * fontSizeMD),
        fontHeightLG: Math.round(lineHeightLG * fontSizeLG),
        fontHeightSM: Math.round(lineHeightSM * fontSizeSM),
        lineHeightHeading1: lineHeights[6],
        lineHeightHeading2: lineHeights[5],
        lineHeightHeading3: lineHeights[4],
        lineHeightHeading4: lineHeights[3],
        lineHeightHeading5: lineHeights[2]
    };
};
var $d4f7189528fc8577$export$2e2bcd8739ae039 = $d4f7189528fc8577$var$genFontMapToken;


function $9202f1dc47c7e8f8$export$2e2bcd8739ae039(token) {
    const { sizeUnit: sizeUnit, sizeStep: sizeStep } = token;
    return {
        sizeXXL: sizeUnit * (sizeStep + 8),
        // 48
        sizeXL: sizeUnit * (sizeStep + 4),
        // 32
        sizeLG: sizeUnit * (sizeStep + 2),
        // 24
        sizeMD: sizeUnit * (sizeStep + 1),
        // 20
        sizeMS: sizeUnit * sizeStep,
        // 16
        size: sizeUnit * sizeStep,
        // 16
        sizeSM: sizeUnit * (sizeStep - 1),
        // 12
        sizeXS: sizeUnit * (sizeStep - 2),
        // 8
        sizeXXS: sizeUnit * (sizeStep - 3 // 4
        )
    };
}




const $bf85ad03d6574cb0$export$31f6399ba7ce6bea = (baseColor, alpha)=>new (0, $3bb84f07fb2a2f32$export$2c4f38d6c0ecc25a)(baseColor).setA(alpha).toRgbString();
const $bf85ad03d6574cb0$export$7003a8a990e79359 = (baseColor, brightness)=>{
    const instance = new (0, $3bb84f07fb2a2f32$export$2c4f38d6c0ecc25a)(baseColor);
    return instance.darken(brightness).toHexString();
};


const $b3d7d07f9d838b04$export$da275153033f4ec1 = (baseColor)=>{
    const colors = (0, $8da55d644cf9b154$export$2e2bcd8739ae039)(baseColor);
    return {
        1: colors[0],
        2: colors[1],
        3: colors[2],
        4: colors[3],
        5: colors[4],
        6: colors[5],
        7: colors[6],
        8: colors[4],
        9: colors[5],
        10: colors[6]
    };
};
const $b3d7d07f9d838b04$export$3e0cb0c1d9c1b691 = (bgBaseColor, textBaseColor, shadowColor)=>{
    const colorBgBase = bgBaseColor || "#fff";
    const colorTextBase = textBaseColor || "#000";
    const colorShadow = shadowColor || "#000";
    return {
        colorBgBase: colorBgBase,
        colorTextBase: colorTextBase,
        colorShadow: colorShadow,
        colorText: (0, $bf85ad03d6574cb0$export$31f6399ba7ce6bea)(colorTextBase, 0.88),
        colorTextSecondary: (0, $bf85ad03d6574cb0$export$31f6399ba7ce6bea)(colorTextBase, 0.65),
        colorTextTertiary: (0, $bf85ad03d6574cb0$export$31f6399ba7ce6bea)(colorTextBase, 0.45),
        colorTextQuaternary: (0, $bf85ad03d6574cb0$export$31f6399ba7ce6bea)(colorTextBase, 0.25),
        colorFill: (0, $bf85ad03d6574cb0$export$31f6399ba7ce6bea)(colorTextBase, 0.15),
        colorFillSecondary: (0, $bf85ad03d6574cb0$export$31f6399ba7ce6bea)(colorTextBase, 0.06),
        colorFillTertiary: (0, $bf85ad03d6574cb0$export$31f6399ba7ce6bea)(colorTextBase, 0.04),
        colorFillQuaternary: (0, $bf85ad03d6574cb0$export$31f6399ba7ce6bea)(colorTextBase, 0.02),
        colorBgSolid: (0, $bf85ad03d6574cb0$export$31f6399ba7ce6bea)(colorTextBase, 1),
        colorBgSolidHover: (0, $bf85ad03d6574cb0$export$31f6399ba7ce6bea)(colorTextBase, 0.75),
        colorBgSolidActive: (0, $bf85ad03d6574cb0$export$31f6399ba7ce6bea)(colorTextBase, 0.95),
        colorBgLayout: (0, $bf85ad03d6574cb0$export$7003a8a990e79359)(colorBgBase, 4),
        colorBgContainer: (0, $bf85ad03d6574cb0$export$7003a8a990e79359)(colorBgBase, 0),
        colorBgElevated: (0, $bf85ad03d6574cb0$export$7003a8a990e79359)(colorBgBase, 0),
        colorBgSpotlight: (0, $bf85ad03d6574cb0$export$31f6399ba7ce6bea)(colorTextBase, 0.85),
        colorBgBlur: "transparent",
        colorBorder: (0, $bf85ad03d6574cb0$export$7003a8a990e79359)(colorBgBase, 15),
        colorBorderDisabled: (0, $bf85ad03d6574cb0$export$7003a8a990e79359)(colorBgBase, 15),
        colorBorderSecondary: (0, $bf85ad03d6574cb0$export$7003a8a990e79359)(colorBgBase, 6)
    };
};


function $386388e6a6a8398e$export$2e2bcd8739ae039(token) {
    // pink is deprecated name of magenta, keep this for backwards compatibility
    (0, $bac0cac4764de8cf$export$3968a3afc810b5f5).pink = (0, $bac0cac4764de8cf$export$3968a3afc810b5f5).magenta;
    (0, $bac0cac4764de8cf$export$36ad6df0f83f284d).pink = (0, $bac0cac4764de8cf$export$36ad6df0f83f284d).magenta;
    const colorPalettes = Object.keys((0, $84fac8c8876d9d5c$export$37e27b43af4d16eb)).map((colorKey)=>{
        const colors = token[colorKey] === (0, $bac0cac4764de8cf$export$3968a3afc810b5f5)[colorKey] ? (0, $bac0cac4764de8cf$export$36ad6df0f83f284d)[colorKey] : (0, $8da55d644cf9b154$export$2e2bcd8739ae039)(token[colorKey]);
        return Array.from({
            length: 10
        }, ()=>1).reduce((prev, _, i)=>{
            prev[`${colorKey}-${i + 1}`] = colors[i];
            prev[`${colorKey}${i + 1}`] = colors[i];
            return prev;
        }, {});
    }).reduce((prev, cur)=>{
        prev = {
            ...prev,
            ...cur
        };
        return prev;
    }, {});
    return {
        ...token,
        ...colorPalettes,
        // Colors
        ...(0, $9d836749d581943a$export$2e2bcd8739ae039)(token, {
            generateColorPalettes: $b3d7d07f9d838b04$export$da275153033f4ec1,
            generateNeutralColorPalettes: $b3d7d07f9d838b04$export$3e0cb0c1d9c1b691
        }),
        // Font
        ...(0, $d4f7189528fc8577$export$2e2bcd8739ae039)(token.fontSize),
        // Size
        ...(0, $9202f1dc47c7e8f8$export$2e2bcd8739ae039)(token),
        // Height
        ...(0, $a5fcd3dbe0aeee12$export$2e2bcd8739ae039)(token),
        // Others
        ...(0, $0c9fba075dec08aa$export$2e2bcd8739ae039)(token)
    };
}


const $3fc6617fc53b3959$var$defaultTheme = (0, $01a2faba6df82710$export$2e2bcd8739ae039)((0, $386388e6a6a8398e$export$2e2bcd8739ae039));
var $3fc6617fc53b3959$export$2e2bcd8739ae039 = $3fc6617fc53b3959$var$defaultTheme;


var $cQmXV = parcelRequire("cQmXV");


const $284e1db1c3fa1faa$export$f84bd70098573c5c = {
    token: (0, $84fac8c8876d9d5c$export$2e2bcd8739ae039),
    override: {
        override: (0, $84fac8c8876d9d5c$export$2e2bcd8739ae039)
    },
    hashed: true
};
const $284e1db1c3fa1faa$export$69b0ebb9efcddb30 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createContext($284e1db1c3fa1faa$export$f84bd70098573c5c);




var $cQmXV = parcelRequire("cQmXV");


var $cQmXV = parcelRequire("cQmXV");

var $3h5eW = parcelRequire("3h5eW");

var $cQmXV = parcelRequire("cQmXV");
const $b31af9f7ba42f972$var$OrderContext = /*#__PURE__*/ $cQmXV.createContext(null);
var $b31af9f7ba42f972$export$2e2bcd8739ae039 = $b31af9f7ba42f972$var$OrderContext;


let $95f36d880ba2f557$export$18c8ad048e32c7d5 = false;
function $95f36d880ba2f557$export$121d9fd0ca615463(nextInline) {
    if (typeof nextInline === "boolean") $95f36d880ba2f557$export$18c8ad048e32c7d5 = nextInline;
    return $95f36d880ba2f557$export$18c8ad048e32c7d5;
}



var $cQmXV = parcelRequire("cQmXV");


const $1c53acb43be68ae7$var$EMPTY_LIST = [];
function $1c53acb43be68ae7$export$2e2bcd8739ae039(render, debug) {
    const [ele] = $cQmXV.useState(()=>{
        if (!(0, $78361969822ad097$export$2e2bcd8739ae039)()) return null;
        const defaultEle = document.createElement("div");
        return defaultEle;
    });
    // ========================== Order ==========================
    const appendedRef = $cQmXV.useRef(false);
    const queueCreate = $cQmXV.useContext((0, $b31af9f7ba42f972$export$2e2bcd8739ae039));
    const [queue, setQueue] = $cQmXV.useState($1c53acb43be68ae7$var$EMPTY_LIST);
    const mergedQueueCreate = queueCreate || (appendedRef.current ? undefined : (appendFn)=>{
        setQueue((origin)=>{
            const newQueue = [
                appendFn,
                ...origin
            ];
            return newQueue;
        });
    });
    // =========================== DOM ===========================
    function append() {
        if (!ele.parentElement) document.body.appendChild(ele);
        appendedRef.current = true;
    }
    function cleanup() {
        ele.parentElement?.removeChild(ele);
        appendedRef.current = false;
    }
    (0, $7673d874dab69d07$export$2e2bcd8739ae039)(()=>{
        if (render) {
            if (queueCreate) queueCreate(append);
            else append();
        } else cleanup();
        return cleanup;
    }, [
        render
    ]);
    (0, $7673d874dab69d07$export$2e2bcd8739ae039)(()=>{
        if (queue.length) {
            queue.forEach((appendFn)=>appendFn());
            setQueue($1c53acb43be68ae7$var$EMPTY_LIST);
        }
    }, [
        queue
    ]);
    return [
        ele,
        mergedQueueCreate
    ];
}



var $cQmXV = parcelRequire("cQmXV");

/**
 * Test usage export. Do not use in your production
 */ function $94e3ddc005a668eb$export$31b5c8f1131a3a52() {
    return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
}


const $c0dcda94d4783fa0$var$UNIQUE_ID = `rc-util-locker-${Date.now()}`;
let $c0dcda94d4783fa0$var$uuid = 0;
function $c0dcda94d4783fa0$export$2e2bcd8739ae039(lock) {
    const mergedLock = !!lock;
    const [id] = $cQmXV.useState(()=>{
        $c0dcda94d4783fa0$var$uuid += 1;
        return `${$c0dcda94d4783fa0$var$UNIQUE_ID}_${$c0dcda94d4783fa0$var$uuid}`;
    });
    (0, $7673d874dab69d07$export$2e2bcd8739ae039)(()=>{
        if (mergedLock) {
            const scrollbarSize = (0, $14f2e271a4ead6fa$export$4f3ef2310365b56a)(document.body).width;
            const isOverflow = (0, $94e3ddc005a668eb$export$31b5c8f1131a3a52)();
            (0, $449b73243fa975a1$export$4d99a2890bb989f0)(`
html body {
  overflow-y: hidden;
  ${isOverflow ? `width: calc(100% - ${scrollbarSize}px);` : ""}
}`, id);
        } else (0, $449b73243fa975a1$export$2232e336aecaa80a)(id);
        return ()=>{
            (0, $449b73243fa975a1$export$2232e336aecaa80a)(id);
        };
    }, [
        mergedLock,
        id
    ]);
}




var $cQmXV = parcelRequire("cQmXV");
let $3bf4cffc00f8a4bf$var$stack = [];
const $3bf4cffc00f8a4bf$var$IME_LOCK_DURATION = 200;
let $3bf4cffc00f8a4bf$var$lastCompositionEndTime = 0;
const $3bf4cffc00f8a4bf$export$9b72c8a279453f3a = null;
// Global event handlers
const $3bf4cffc00f8a4bf$var$onGlobalKeyDown = (event)=>{
    if (event.key === "Escape" && !event.isComposing) {
        const now = Date.now();
        if (now - $3bf4cffc00f8a4bf$var$lastCompositionEndTime < $3bf4cffc00f8a4bf$var$IME_LOCK_DURATION) return;
        const len = $3bf4cffc00f8a4bf$var$stack.length;
        for(let i = len - 1; i >= 0; i -= 1)$3bf4cffc00f8a4bf$var$stack[i].onEsc({
            top: i === len - 1,
            event: event
        });
    }
};
const $3bf4cffc00f8a4bf$var$onGlobalCompositionEnd = ()=>{
    $3bf4cffc00f8a4bf$var$lastCompositionEndTime = Date.now();
};
function $3bf4cffc00f8a4bf$var$attachGlobalEventListeners() {
    window.addEventListener("keydown", $3bf4cffc00f8a4bf$var$onGlobalKeyDown);
    window.addEventListener("compositionend", $3bf4cffc00f8a4bf$var$onGlobalCompositionEnd);
}
function $3bf4cffc00f8a4bf$var$detachGlobalEventListeners() {
    if ($3bf4cffc00f8a4bf$var$stack.length === 0) {
        window.removeEventListener("keydown", $3bf4cffc00f8a4bf$var$onGlobalKeyDown);
        window.removeEventListener("compositionend", $3bf4cffc00f8a4bf$var$onGlobalCompositionEnd);
    }
}
function $3bf4cffc00f8a4bf$export$2e2bcd8739ae039(open, onEsc) {
    const id = (0, $a2da91bb60e2cbfb$export$2e2bcd8739ae039)();
    const onEventEsc = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)(onEsc);
    const ensure = ()=>{
        if (!$3bf4cffc00f8a4bf$var$stack.find((item)=>item.id === id)) $3bf4cffc00f8a4bf$var$stack.push({
            id: id,
            onEsc: onEventEsc
        });
    };
    const clear = ()=>{
        $3bf4cffc00f8a4bf$var$stack = $3bf4cffc00f8a4bf$var$stack.filter((item)=>item.id !== id);
    };
    (0, $cQmXV.useMemo)(()=>{
        if (open) ensure();
        else if (!open) clear();
    }, [
        open
    ]);
    (0, $cQmXV.useEffect)(()=>{
        if (open) {
            ensure();
            // Attach global event listeners
            $3bf4cffc00f8a4bf$var$attachGlobalEventListeners();
            return ()=>{
                clear();
                // Remove global event listeners if instances is empty
                $3bf4cffc00f8a4bf$var$detachGlobalEventListeners();
            };
        }
    }, [
        open
    ]);
}


const $ef3db7d5cb42643a$var$getPortalContainer = (getContainer)=>{
    if (getContainer === false) return false;
    if (!(0, $78361969822ad097$export$2e2bcd8739ae039)() || !getContainer) return null;
    if (typeof getContainer === "string") return document.querySelector(getContainer);
    if (typeof getContainer === "function") return getContainer();
    return getContainer;
};
const $ef3db7d5cb42643a$var$Portal = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { open: open, autoLock: autoLock, getContainer: getContainer, debug: debug, autoDestroy: autoDestroy = true, children: children, onEsc: onEsc } = props;
    const [shouldRender, setShouldRender] = $cQmXV.useState(open);
    const mergedRender = shouldRender || open;
    // ====================== Should Render ======================
    $cQmXV.useEffect(()=>{
        if (autoDestroy || open) setShouldRender(open);
    }, [
        open,
        autoDestroy
    ]);
    // ======================== Container ========================
    const [innerContainer, setInnerContainer] = $cQmXV.useState(()=>$ef3db7d5cb42643a$var$getPortalContainer(getContainer));
    $cQmXV.useEffect(()=>{
        const customizeContainer = $ef3db7d5cb42643a$var$getPortalContainer(getContainer);
        // Tell component that we check this in effect which is safe to be `null`
        setInnerContainer(()=>// React do the state update even the value is the same,
            // Use function call to force React to compare update
            customizeContainer ?? null);
    });
    const [defaultContainer, queueCreate] = (0, $1c53acb43be68ae7$export$2e2bcd8739ae039)(mergedRender && !innerContainer, debug);
    const mergedContainer = innerContainer ?? defaultContainer;
    // ========================= Locker ==========================
    (0, $c0dcda94d4783fa0$export$2e2bcd8739ae039)(autoLock && open && (0, $78361969822ad097$export$2e2bcd8739ae039)() && (mergedContainer === defaultContainer || mergedContainer === document.body));
    // ========================= Esc Keydown ==========================
    (0, $3bf4cffc00f8a4bf$export$2e2bcd8739ae039)(open, onEsc);
    // =========================== Ref ===========================
    let childRef = null;
    if (children && (0, $10341b937b26f69d$export$c1cec34af06bcf7)(children) && ref) childRef = (0, $10341b937b26f69d$export$7465e5c0bf44f19a)(children);
    const mergedRef = (0, $10341b937b26f69d$export$1d1c999670a1285d)(childRef, ref);
    // ========================= Render ==========================
    // Do not render when nothing need render
    // When innerContainer is `undefined`, it may not ready since user use ref in the same render
    if (!mergedRender || !(0, $78361969822ad097$export$2e2bcd8739ae039)() || innerContainer === undefined) return null;
    // Render inline
    const renderInline = mergedContainer === false || (0, $95f36d880ba2f557$export$121d9fd0ca615463)();
    let reffedChildren = children;
    if (ref) reffedChildren = /*#__PURE__*/ $cQmXV.cloneElement(children, {
        ref: mergedRef
    });
    return /*#__PURE__*/ $cQmXV.createElement((0, $b31af9f7ba42f972$export$2e2bcd8739ae039).Provider, {
        value: queueCreate
    }, renderInline ? reffedChildren : /*#__PURE__*/ (0, $3h5eW.createPortal)(reffedChildren, mergedContainer));
});
var $ef3db7d5cb42643a$export$2e2bcd8739ae039 = $ef3db7d5cb42643a$var$Portal;



var $aa72a6fdf7676c76$export$2e2bcd8739ae039 = (0, $ef3db7d5cb42643a$export$2e2bcd8739ae039);


function $772fd6e40f1fbf40$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $772fd6e40f1fbf40$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $772fd6e40f1fbf40$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $772fd6e40f1fbf40$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $772fd6e40f1fbf40$export$2e2bcd8739ae039 = $772fd6e40f1fbf40$export$4f5d2d50c9deca37;



var $cQmXV = parcelRequire("cQmXV");





var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");
const $fd0c2247228c63e1$export$db36075d98ba73d3 = /*#__PURE__*/ $cQmXV.createContext(null);
function $fd0c2247228c63e1$export$fb8073518f34e6ec({ children: children, onBatchResize: onBatchResize }) {
    const resizeIdRef = $cQmXV.useRef(0);
    const resizeInfosRef = $cQmXV.useRef([]);
    const onCollectionResize = $cQmXV.useContext($fd0c2247228c63e1$export$db36075d98ba73d3);
    const onResize = $cQmXV.useCallback((size, element, data)=>{
        resizeIdRef.current += 1;
        const currentId = resizeIdRef.current;
        resizeInfosRef.current.push({
            size: size,
            element: element,
            data: data
        });
        Promise.resolve().then(()=>{
            if (currentId === resizeIdRef.current) {
                onBatchResize?.(resizeInfosRef.current);
                resizeInfosRef.current = [];
            }
        });
        // Continue bubbling if parent exist
        onCollectionResize?.(size, element, data);
    }, [
        onBatchResize,
        onCollectionResize
    ]);
    return /*#__PURE__*/ $cQmXV.createElement($fd0c2247228c63e1$export$db36075d98ba73d3.Provider, {
        value: onResize
    }, children);
}



var $cQmXV = parcelRequire("cQmXV");
// =============================== Const ===============================
const $0d7a2867824a1279$var$elementListeners = new Map();
function $0d7a2867824a1279$var$onResize(entities) {
    entities.forEach((entity)=>{
        const { target: target } = entity;
        $0d7a2867824a1279$var$elementListeners.get(target)?.forEach((listener)=>listener(target));
    });
}
// Delay create ResizeObserver since it's not supported in server side
let $0d7a2867824a1279$var$observer;
function $0d7a2867824a1279$var$ensureResizeObserver() {
    if (!$0d7a2867824a1279$var$observer) $0d7a2867824a1279$var$observer = new ResizeObserver($0d7a2867824a1279$var$onResize);
    return $0d7a2867824a1279$var$observer;
}
const $0d7a2867824a1279$export$3fbe5a08fd9e4702 = null; // eslint-disable-line
const $0d7a2867824a1279$export$524f0fd3b47831a = null; // eslint-disable-line
function $0d7a2867824a1279$export$d1203567a167490e(element, callback) {
    if (!$0d7a2867824a1279$var$elementListeners.has(element)) {
        $0d7a2867824a1279$var$elementListeners.set(element, new Set());
        $0d7a2867824a1279$var$ensureResizeObserver().observe(element);
    }
    $0d7a2867824a1279$var$elementListeners.get(element).add(callback);
}
function $0d7a2867824a1279$export$23a2283368c55ea2(element, callback) {
    if ($0d7a2867824a1279$var$elementListeners.has(element)) {
        $0d7a2867824a1279$var$elementListeners.get(element).delete(callback);
        if (!$0d7a2867824a1279$var$elementListeners.get(element).size) {
            $0d7a2867824a1279$var$ensureResizeObserver().unobserve(element);
            $0d7a2867824a1279$var$elementListeners.delete(element);
        }
    }
}



function $341bf970f445a7e3$export$2e2bcd8739ae039(enabled, getTarget, onDelayResize, onSyncResize) {
    // ============================= Size =============================
    const sizeRef = $cQmXV.useRef({
        width: -1,
        height: -1,
        offsetWidth: -1,
        offsetHeight: -1
    });
    // =========================== Observe ============================
    // Handler
    const onInternalResize = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((target)=>{
        const { width: width, height: height } = target.getBoundingClientRect();
        const { offsetWidth: offsetWidth, offsetHeight: offsetHeight } = target;
        /**
     * Resize observer trigger when content size changed.
     * In most case we just care about element size,
     * let's use `boundary` instead of `contentRect` here to avoid shaking.
     */ const fixedWidth = Math.floor(width);
        const fixedHeight = Math.floor(height);
        if (sizeRef.current.width !== fixedWidth || sizeRef.current.height !== fixedHeight || sizeRef.current.offsetWidth !== offsetWidth || sizeRef.current.offsetHeight !== offsetHeight) {
            const size = {
                width: fixedWidth,
                height: fixedHeight,
                offsetWidth: offsetWidth,
                offsetHeight: offsetHeight
            };
            sizeRef.current = size;
            // IE is strange, right?
            const mergedOffsetWidth = offsetWidth === Math.round(width) ? width : offsetWidth;
            const mergedOffsetHeight = offsetHeight === Math.round(height) ? height : offsetHeight;
            const sizeInfo = {
                ...size,
                offsetWidth: mergedOffsetWidth,
                offsetHeight: mergedOffsetHeight
            };
            // Call the callback immediately, let the caller decide whether to defer
            // onResize(sizeInfo, target);
            onSyncResize?.(sizeInfo, target);
            // defer the callback but not defer to next frame
            Promise.resolve().then(()=>{
                onDelayResize?.(sizeInfo, target);
            });
        }
    });
    // Dynamic observe
    const isFuncTarget = typeof getTarget === "function";
    const funcTargetIdRef = $cQmXV.useRef(0);
    $cQmXV.useEffect(()=>{
        const target = isFuncTarget ? getTarget() : getTarget;
        if (target && enabled) (0, $0d7a2867824a1279$export$d1203567a167490e)(target, onInternalResize);
        else if (enabled && isFuncTarget) funcTargetIdRef.current += 1;
        return ()=>{
            if (target) (0, $0d7a2867824a1279$export$23a2283368c55ea2)(target, onInternalResize);
        };
    }, [
        enabled,
        // If function target resolves after a parent render, the bumped ref value
        // lets the next render re-run this effect without watching the function identity.
        isFuncTarget ? funcTargetIdRef.current : getTarget
    ]);
}


function $54bf8fb37007c85d$var$SingleObserver(props, ref) {
    const { children: children, disabled: disabled, onResize: onResize, data: data } = props;
    const elementRef = $cQmXV.useRef(null);
    const onCollectionResize = $cQmXV.useContext((0, $fd0c2247228c63e1$export$db36075d98ba73d3));
    // =========================== Children ===========================
    const isRenderProps = typeof children === "function";
    const mergedChildren = isRenderProps ? children(elementRef) : children;
    // ============================= Ref ==============================
    const canRef = !isRenderProps && /*#__PURE__*/ $cQmXV.isValidElement(mergedChildren) && (0, $10341b937b26f69d$export$c1cec34af06bcf7)(mergedChildren);
    const originRef = canRef ? (0, $10341b937b26f69d$export$7465e5c0bf44f19a)(mergedChildren) : null;
    const mergedRef = (0, $10341b937b26f69d$export$1d1c999670a1285d)(originRef, elementRef);
    const getDomElement = ()=>{
        return (0, $d3fb35d553a86e29$export$9aa546fdc20ae5b3)(elementRef.current);
    };
    $cQmXV.useImperativeHandle(ref, ()=>getDomElement());
    // =========================== Observe ============================
    (0, $341bf970f445a7e3$export$2e2bcd8739ae039)(!disabled, getDomElement, onResize, (sizeInfo, target)=>{
        onCollectionResize?.(sizeInfo, target, data);
    });
    // ============================ Render ============================
    return canRef ? /*#__PURE__*/ $cQmXV.cloneElement(mergedChildren, {
        ref: mergedRef
    }) : mergedChildren;
}
const $54bf8fb37007c85d$var$RefSingleObserver = /*#__PURE__*/ $cQmXV.forwardRef($54bf8fb37007c85d$var$SingleObserver);
var $54bf8fb37007c85d$export$2e2bcd8739ae039 = $54bf8fb37007c85d$var$RefSingleObserver;





function $1d6306c05e604045$var$_extends() {
    $1d6306c05e604045$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1d6306c05e604045$var$_extends.apply(this, arguments);
}
const $1d6306c05e604045$var$INTERNAL_PREFIX_KEY = "rc-observer-key";
function $1d6306c05e604045$var$ResizeObserver(props, ref) {
    const { children: children } = props;
    const childNodes = typeof children === "function" ? [
        children
    ] : (0, $cd966a313e0a92ff$export$2e2bcd8739ae039)(children);
    return childNodes.map((child, index)=>{
        const key = child?.key || `${$1d6306c05e604045$var$INTERNAL_PREFIX_KEY}-${index}`;
        return /*#__PURE__*/ $cQmXV.createElement((0, $54bf8fb37007c85d$export$2e2bcd8739ae039), $1d6306c05e604045$var$_extends({}, props, {
            key: key,
            ref: index === 0 ? ref : undefined
        }), child);
    });
}
const $1d6306c05e604045$var$RefResizeObserver = /*#__PURE__*/ $cQmXV.forwardRef($1d6306c05e604045$var$ResizeObserver);
$1d6306c05e604045$var$RefResizeObserver.Collection = (0, $fd0c2247228c63e1$export$fb8073518f34e6ec);
var $1d6306c05e604045$export$2e2bcd8739ae039 = $1d6306c05e604045$var$RefResizeObserver;




var $cQmXV = parcelRequire("cQmXV");

/* eslint-disable react/default-props-match-prop-types, react/no-multi-comp, react/prop-types */ 


var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");
const $3aebaa435fd7d75e$export$841858b892ce1f4c = /*#__PURE__*/ $cQmXV.createContext({});
const $3aebaa435fd7d75e$var$MotionProvider = (props)=>{
    const { children: children, ...rest } = props;
    const memoizedValue = $cQmXV.useMemo(()=>{
        return {
            motion: rest.motion
        };
    }, [
        rest.motion
    ]);
    return /*#__PURE__*/ $cQmXV.createElement($3aebaa435fd7d75e$export$841858b892ce1f4c.Provider, {
        value: memoizedValue
    }, children);
};
var $3aebaa435fd7d75e$export$2e2bcd8739ae039 = $3aebaa435fd7d75e$var$MotionProvider;




var $cQmXV = parcelRequire("cQmXV");
const $6340722eb5bf9108$export$de71442bbf2143da = "none";
const $6340722eb5bf9108$export$4fc3521687bcacd2 = "appear";
const $6340722eb5bf9108$export$5d6af549241fe2e8 = "enter";
const $6340722eb5bf9108$export$59b1c493d29f68e4 = "leave";
const $6340722eb5bf9108$export$40b34dd77d5522bf = "none";
const $6340722eb5bf9108$export$1b792916a5fac4fc = "prepare";
const $6340722eb5bf9108$export$9563153dd25a3ce8 = "start";
const $6340722eb5bf9108$export$e205886172277ec6 = "active";
const $6340722eb5bf9108$export$3a846c3d2fac10b8 = "end";
const $6340722eb5bf9108$export$98351fa4e6b4f204 = "prepared";



var $cQmXV = parcelRequire("cQmXV");

// ================= Transition =================
// Event wrapper. Copy from react source code
function $c2b97af08f49fb2b$var$makePrefixMap(styleProp, eventName) {
    const prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes[`Webkit${styleProp}`] = `webkit${eventName}`;
    prefixes[`Moz${styleProp}`] = `moz${eventName}`;
    prefixes[`ms${styleProp}`] = `MS${eventName}`;
    prefixes[`O${styleProp}`] = `o${eventName.toLowerCase()}`;
    return prefixes;
}
function $c2b97af08f49fb2b$export$6e8b350b1a8958a0(domSupport, win) {
    const prefixes = {
        animationend: $c2b97af08f49fb2b$var$makePrefixMap("Animation", "AnimationEnd"),
        transitionend: $c2b97af08f49fb2b$var$makePrefixMap("Transition", "TransitionEnd")
    };
    if (domSupport) {
        if (!("AnimationEvent" in win)) delete prefixes.animationend.animation;
        if (!("TransitionEvent" in win)) delete prefixes.transitionend.transition;
    }
    return prefixes;
}
const $c2b97af08f49fb2b$var$vendorPrefixes = $c2b97af08f49fb2b$export$6e8b350b1a8958a0((0, $78361969822ad097$export$2e2bcd8739ae039)(), typeof window !== "undefined" ? window : {});
let $c2b97af08f49fb2b$var$style = {};
if ((0, $78361969822ad097$export$2e2bcd8739ae039)()) ({ style: $c2b97af08f49fb2b$var$style } = document.createElement("div"));
const $c2b97af08f49fb2b$var$prefixedEventNames = {};
function $c2b97af08f49fb2b$export$a032e4f39350c1d8(eventName) {
    if ($c2b97af08f49fb2b$var$prefixedEventNames[eventName]) return $c2b97af08f49fb2b$var$prefixedEventNames[eventName];
    const prefixMap = $c2b97af08f49fb2b$var$vendorPrefixes[eventName];
    if (prefixMap) {
        const stylePropList = Object.keys(prefixMap);
        const len = stylePropList.length;
        for(let i = 0; i < len; i += 1){
            const styleProp = stylePropList[i];
            if (Object.prototype.hasOwnProperty.call(prefixMap, styleProp) && styleProp in $c2b97af08f49fb2b$var$style) {
                $c2b97af08f49fb2b$var$prefixedEventNames[eventName] = prefixMap[styleProp];
                return $c2b97af08f49fb2b$var$prefixedEventNames[eventName];
            }
        }
    }
    return "";
}
const $c2b97af08f49fb2b$var$internalAnimationEndName = $c2b97af08f49fb2b$export$a032e4f39350c1d8("animationend");
const $c2b97af08f49fb2b$var$internalTransitionEndName = $c2b97af08f49fb2b$export$a032e4f39350c1d8("transitionend");
const $c2b97af08f49fb2b$export$d28133ed3ad06c8b = !!($c2b97af08f49fb2b$var$internalAnimationEndName && $c2b97af08f49fb2b$var$internalTransitionEndName);
const $c2b97af08f49fb2b$export$760cc9769c51b738 = $c2b97af08f49fb2b$var$internalAnimationEndName || "animationend";
const $c2b97af08f49fb2b$export$44baea64b8602e3c = $c2b97af08f49fb2b$var$internalTransitionEndName || "transitionend";
function $c2b97af08f49fb2b$export$27c72201b1d09951(transitionName, transitionType) {
    if (!transitionName) return null;
    if (typeof transitionName === "object") {
        const type = transitionType.replace(/-\w/g, (match)=>match[1].toUpperCase());
        return transitionName[type];
    }
    return `${transitionName}-${transitionType}`;
}


var $df2b2bf6c1e96ddd$export$2e2bcd8739ae039 = (onInternalMotionEnd)=>{
    const cacheElementRef = (0, $cQmXV.useRef)();
    // Remove events
    function removeMotionEvents(element) {
        if (element) {
            element.removeEventListener((0, $c2b97af08f49fb2b$export$44baea64b8602e3c), onInternalMotionEnd);
            element.removeEventListener((0, $c2b97af08f49fb2b$export$760cc9769c51b738), onInternalMotionEnd);
        }
    }
    // Patch events
    function patchMotionEvents(element) {
        if (cacheElementRef.current && cacheElementRef.current !== element) removeMotionEvents(cacheElementRef.current);
        if (element && element !== cacheElementRef.current) {
            element.addEventListener((0, $c2b97af08f49fb2b$export$44baea64b8602e3c), onInternalMotionEnd);
            element.addEventListener((0, $c2b97af08f49fb2b$export$760cc9769c51b738), onInternalMotionEnd);
            // Save as cache in case dom removed trigger by `motionDeadline`
            cacheElementRef.current = element;
        }
    }
    // Clean up when removed
    $cQmXV.useEffect(()=>()=>{
            removeMotionEvents(cacheElementRef.current);
            cacheElementRef.current = null;
        }, []);
    return [
        patchMotionEvents,
        removeMotionEvents
    ];
};




var $cQmXV = parcelRequire("cQmXV");
// It's safe to use `useLayoutEffect` but the warning is annoying
const $1213d7d789b4e9a1$var$useIsomorphicLayoutEffect = (0, $78361969822ad097$export$2e2bcd8739ae039)() ? (0, $cQmXV.useLayoutEffect) : (0, $cQmXV.useEffect);
var $1213d7d789b4e9a1$export$2e2bcd8739ae039 = $1213d7d789b4e9a1$var$useIsomorphicLayoutEffect;




var $cQmXV = parcelRequire("cQmXV");




var $cQmXV = parcelRequire("cQmXV");
var $a00f5117f8324110$export$2e2bcd8739ae039 = ()=>{
    const nextFrameRef = $cQmXV.useRef(null);
    function cancelNextFrame() {
        (0, $905c53b807de704e$export$2e2bcd8739ae039).cancel(nextFrameRef.current);
    }
    function nextFrame(callback, delay = 2) {
        cancelNextFrame();
        const nextFrameId = (0, $905c53b807de704e$export$2e2bcd8739ae039)(()=>{
            if (delay <= 1) callback({
                isCanceled: ()=>nextFrameId !== nextFrameRef.current
            });
            else nextFrame(callback, delay - 1);
        });
        nextFrameRef.current = nextFrameId;
    }
    $cQmXV.useEffect(()=>()=>{
            cancelNextFrame();
        }, []);
    return [
        nextFrame,
        cancelNextFrame
    ];
};


const $e4f2ff4546529177$var$FULL_STEP_QUEUE = [
    (0, $6340722eb5bf9108$export$1b792916a5fac4fc),
    (0, $6340722eb5bf9108$export$9563153dd25a3ce8),
    (0, $6340722eb5bf9108$export$e205886172277ec6),
    (0, $6340722eb5bf9108$export$3a846c3d2fac10b8)
];
const $e4f2ff4546529177$var$SIMPLE_STEP_QUEUE = [
    (0, $6340722eb5bf9108$export$1b792916a5fac4fc),
    (0, $6340722eb5bf9108$export$98351fa4e6b4f204)
];
const $e4f2ff4546529177$export$c2029bf6cfdbc28a = false;
const $e4f2ff4546529177$export$dbee1e282e8c4830 = true;
function $e4f2ff4546529177$export$39e04e72f972b885(step) {
    return step === (0, $6340722eb5bf9108$export$e205886172277ec6) || step === (0, $6340722eb5bf9108$export$3a846c3d2fac10b8);
}
var $e4f2ff4546529177$export$2e2bcd8739ae039 = (status, prepareOnly, callback)=>{
    const [step, setStep] = (0, $8caa85071cca5555$export$2e2bcd8739ae039)((0, $6340722eb5bf9108$export$40b34dd77d5522bf));
    const [nextFrame, cancelNextFrame] = (0, $a00f5117f8324110$export$2e2bcd8739ae039)();
    function startQueue() {
        setStep((0, $6340722eb5bf9108$export$1b792916a5fac4fc), true);
    }
    const STEP_QUEUE = prepareOnly ? $e4f2ff4546529177$var$SIMPLE_STEP_QUEUE : $e4f2ff4546529177$var$FULL_STEP_QUEUE;
    (0, $1213d7d789b4e9a1$export$2e2bcd8739ae039)(()=>{
        if (step !== (0, $6340722eb5bf9108$export$40b34dd77d5522bf) && step !== (0, $6340722eb5bf9108$export$3a846c3d2fac10b8)) {
            const index = STEP_QUEUE.indexOf(step);
            const nextStep = STEP_QUEUE[index + 1];
            const result = callback(step);
            if (result === $e4f2ff4546529177$export$c2029bf6cfdbc28a) // Skip when no needed
            setStep(nextStep, true);
            else if (nextStep) // Do as frame for step update
            nextFrame((info)=>{
                function doNext() {
                    // Skip since current queue is ood
                    if (info.isCanceled()) return;
                    setStep(nextStep, true);
                }
                if (result === true) doNext();
                else // Only promise should be async
                Promise.resolve(result).then(doNext);
            });
        }
    }, [
        status,
        step
    ]);
    $cQmXV.useEffect(()=>()=>{
            cancelNextFrame();
        }, []);
    return [
        startQueue,
        step
    ];
};


function $c4770ac572533f8b$export$2e2bcd8739ae039(supportMotion, visible, getElement, { motionEnter: motionEnter = true, motionAppear: motionAppear = true, motionLeave: motionLeave = true, motionDeadline: motionDeadline, motionLeaveImmediately: motionLeaveImmediately, onAppearPrepare: onAppearPrepare, onEnterPrepare: onEnterPrepare, onLeavePrepare: onLeavePrepare, onAppearStart: onAppearStart, onEnterStart: onEnterStart, onLeaveStart: onLeaveStart, onAppearActive: onAppearActive, onEnterActive: onEnterActive, onLeaveActive: onLeaveActive, onAppearEnd: onAppearEnd, onEnterEnd: onEnterEnd, onLeaveEnd: onLeaveEnd, onVisibleChanged: onVisibleChanged }) {
    // Used for outer render usage to avoid `visible: false & status: none` to render nothing
    const [asyncVisible, setAsyncVisible] = $cQmXV.useState();
    const [getStatus, setStatus] = (0, $ca0e9e88b17f6373$export$2e2bcd8739ae039)((0, $6340722eb5bf9108$export$de71442bbf2143da));
    const [style, setStyle] = $cQmXV.useState([
        null,
        null
    ]);
    const currentStatus = getStatus();
    const mountedRef = (0, $cQmXV.useRef)(false);
    const deadlineRef = (0, $cQmXV.useRef)(null);
    // =========================== Dom Node ===========================
    function getDomElement() {
        return getElement();
    }
    // ========================== Motion End ==========================
    const activeRef = (0, $cQmXV.useRef)(false);
    /**
   * Clean up status & style
   */ function updateMotionEndStatus() {
        setStatus((0, $6340722eb5bf9108$export$de71442bbf2143da));
        setStyle([
            null,
            null
        ]);
    }
    const onInternalMotionEnd = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((event)=>{
        const status = getStatus();
        // Do nothing since not in any transition status.
        // This may happen when `motionDeadline` trigger.
        if (status === (0, $6340722eb5bf9108$export$de71442bbf2143da)) return;
        const element = getDomElement();
        if (event && !event.deadline && event.target !== element) // event exists
        // not initiated by deadline
        // transitionEnd not fired by inner elements
        return;
        const currentActive = activeRef.current;
        let canEnd;
        if (status === (0, $6340722eb5bf9108$export$4fc3521687bcacd2) && currentActive) canEnd = onAppearEnd?.(element, event);
        else if (status === (0, $6340722eb5bf9108$export$5d6af549241fe2e8) && currentActive) canEnd = onEnterEnd?.(element, event);
        else if (status === (0, $6340722eb5bf9108$export$59b1c493d29f68e4) && currentActive) canEnd = onLeaveEnd?.(element, event);
        // Only update status when `canEnd` and not destroyed
        if (currentActive && canEnd !== false) updateMotionEndStatus();
    });
    const [patchMotionEvents] = (0, $df2b2bf6c1e96ddd$export$2e2bcd8739ae039)(onInternalMotionEnd);
    // ============================= Step =============================
    const getEventHandlers = (targetStatus)=>{
        switch(targetStatus){
            case 0, $6340722eb5bf9108$export$4fc3521687bcacd2:
                return {
                    [(0, $6340722eb5bf9108$export$1b792916a5fac4fc)]: onAppearPrepare,
                    [(0, $6340722eb5bf9108$export$9563153dd25a3ce8)]: onAppearStart,
                    [(0, $6340722eb5bf9108$export$e205886172277ec6)]: onAppearActive
                };
            case 0, $6340722eb5bf9108$export$5d6af549241fe2e8:
                return {
                    [(0, $6340722eb5bf9108$export$1b792916a5fac4fc)]: onEnterPrepare,
                    [(0, $6340722eb5bf9108$export$9563153dd25a3ce8)]: onEnterStart,
                    [(0, $6340722eb5bf9108$export$e205886172277ec6)]: onEnterActive
                };
            case 0, $6340722eb5bf9108$export$59b1c493d29f68e4:
                return {
                    [(0, $6340722eb5bf9108$export$1b792916a5fac4fc)]: onLeavePrepare,
                    [(0, $6340722eb5bf9108$export$9563153dd25a3ce8)]: onLeaveStart,
                    [(0, $6340722eb5bf9108$export$e205886172277ec6)]: onLeaveActive
                };
            default:
                return {};
        }
    };
    const eventHandlers = $cQmXV.useMemo(()=>getEventHandlers(currentStatus), [
        currentStatus
    ]);
    const [startStep, step] = (0, $e4f2ff4546529177$export$2e2bcd8739ae039)(currentStatus, !supportMotion, (newStep)=>{
        // Only prepare step can be skip
        if (newStep === (0, $6340722eb5bf9108$export$1b792916a5fac4fc)) {
            const onPrepare = eventHandlers[0, $6340722eb5bf9108$export$1b792916a5fac4fc];
            if (!onPrepare) return 0, $e4f2ff4546529177$export$c2029bf6cfdbc28a;
            return onPrepare(getDomElement());
        }
        // Rest step is sync update
        if (newStep in eventHandlers) setStyle([
            eventHandlers[newStep]?.(getDomElement(), null) || null,
            newStep
        ]);
        if (newStep === (0, $6340722eb5bf9108$export$e205886172277ec6) && currentStatus !== (0, $6340722eb5bf9108$export$de71442bbf2143da)) {
            // Patch events when motion needed
            patchMotionEvents(getDomElement());
            if (motionDeadline > 0) {
                clearTimeout(deadlineRef.current);
                deadlineRef.current = setTimeout(()=>{
                    onInternalMotionEnd({
                        deadline: true
                    });
                }, motionDeadline);
            }
        }
        if (newStep === (0, $6340722eb5bf9108$export$98351fa4e6b4f204)) updateMotionEndStatus();
        return 0, $e4f2ff4546529177$export$dbee1e282e8c4830;
    });
    const active = (0, $e4f2ff4546529177$export$39e04e72f972b885)(step);
    activeRef.current = active;
    // ============================ Status ============================
    const visibleRef = (0, $cQmXV.useRef)(null);
    // Update with new status
    (0, $1213d7d789b4e9a1$export$2e2bcd8739ae039)(()=>{
        // When use Suspense, the `visible` will repeat trigger,
        // But not real change of the `visible`, we need to skip it.
        // https://github.com/ant-design/ant-design/issues/44379
        if (mountedRef.current && visibleRef.current === visible) return;
        setAsyncVisible(visible);
        const isMounted = mountedRef.current;
        mountedRef.current = true;
        // if (!supportMotion) {
        //   return;
        // }
        let nextStatus;
        // Appear
        if (!isMounted && visible && motionAppear) nextStatus = (0, $6340722eb5bf9108$export$4fc3521687bcacd2);
        // Enter
        if (isMounted && visible && motionEnter) nextStatus = (0, $6340722eb5bf9108$export$5d6af549241fe2e8);
        // Leave
        if (isMounted && !visible && motionLeave || !isMounted && motionLeaveImmediately && !visible && motionLeave) nextStatus = (0, $6340722eb5bf9108$export$59b1c493d29f68e4);
        const nextEventHandlers = getEventHandlers(nextStatus);
        // Update to next status
        if (nextStatus && (supportMotion || nextEventHandlers[0, $6340722eb5bf9108$export$1b792916a5fac4fc])) {
            setStatus(nextStatus);
            startStep();
        } else // Set back in case no motion but prev status has prepare step
        setStatus((0, $6340722eb5bf9108$export$de71442bbf2143da));
        visibleRef.current = visible;
    }, [
        visible
    ]);
    // ============================ Effect ============================
    // Reset when motion changed
    (0, $cQmXV.useEffect)(()=>{
        if (// Cancel appear
        currentStatus === (0, $6340722eb5bf9108$export$4fc3521687bcacd2) && !motionAppear || // Cancel enter
        currentStatus === (0, $6340722eb5bf9108$export$5d6af549241fe2e8) && !motionEnter || // Cancel leave
        currentStatus === (0, $6340722eb5bf9108$export$59b1c493d29f68e4) && !motionLeave) setStatus((0, $6340722eb5bf9108$export$de71442bbf2143da));
    }, [
        motionAppear,
        motionEnter,
        motionLeave
    ]);
    (0, $cQmXV.useEffect)(()=>()=>{
            mountedRef.current = false;
            clearTimeout(deadlineRef.current);
        }, []);
    // Trigger `onVisibleChanged`
    const firstMountChangeRef = $cQmXV.useRef(false);
    (0, $cQmXV.useEffect)(()=>{
        // [visible & motion not end] => [!visible & motion end] still need trigger onVisibleChanged
        if (asyncVisible) firstMountChangeRef.current = true;
        if (asyncVisible !== undefined && currentStatus === (0, $6340722eb5bf9108$export$de71442bbf2143da)) {
            // Skip first render is invisible since it's nothing changed
            if (firstMountChangeRef.current || asyncVisible) onVisibleChanged?.(asyncVisible);
            firstMountChangeRef.current = true;
        }
    }, [
        asyncVisible,
        currentStatus
    ]);
    // ============================ Styles ============================
    let mergedStyle = style[0];
    if (eventHandlers[0, $6340722eb5bf9108$export$1b792916a5fac4fc] && step === (0, $6340722eb5bf9108$export$9563153dd25a3ce8)) mergedStyle = {
        transition: "none",
        ...mergedStyle
    };
    const styleStep = style[1];
    return [
        getStatus,
        step,
        mergedStyle,
        asyncVisible ?? visible,
        // Appear Check
        !mountedRef.current && currentStatus === (0, $6340722eb5bf9108$export$de71442bbf2143da) && supportMotion && motionAppear ? "NONE" : // Enter or Leave check
        step === (0, $6340722eb5bf9108$export$9563153dd25a3ce8) || step === (0, $6340722eb5bf9108$export$e205886172277ec6) ? styleStep === step : true
    ];
}





function $8c51644f9597c41e$export$35eb5aa7e3b3c295(children) {
    return children?.length < 2;
}
function $8c51644f9597c41e$export$e265d52a86a9f199(config) {
    let transitionSupport = config;
    if (typeof config === "object") ({ transitionSupport: transitionSupport } = config);
    function isSupportTransition(props, contextMotion) {
        return !!(props.motionName && transitionSupport && contextMotion !== false);
    }
    const CSSMotion = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
        const { visible: // Default config
        visible = true, removeOnLeave: removeOnLeave = true, forceRender: forceRender, children: children, motionName: motionName, leavedClassName: leavedClassName, eventProps: eventProps } = props;
        const { motion: contextMotion } = $cQmXV.useContext((0, $3aebaa435fd7d75e$export$841858b892ce1f4c));
        const supportMotion = isSupportTransition(props, contextMotion);
        // Ref to the react node, it may be a HTMLElement
        const nodeRef = (0, $cQmXV.useRef)();
        function getDomElement() {
            return (0, $d3fb35d553a86e29$export$9aa546fdc20ae5b3)(nodeRef.current);
        }
        const [getStatus, statusStep, statusStyle, mergedVisible, styleReady] = (0, $c4770ac572533f8b$export$2e2bcd8739ae039)(supportMotion, visible, getDomElement, props);
        const status = getStatus();
        // Record whether content has rendered
        // Will return null for un-rendered even when `removeOnLeave={false}`
        const renderedRef = $cQmXV.useRef(mergedVisible);
        if (mergedVisible) renderedRef.current = true;
        // ====================== Refs ======================
        const refObj = $cQmXV.useMemo(()=>{
            const obj = {};
            Object.defineProperties(obj, {
                nativeElement: {
                    enumerable: true,
                    get: getDomElement
                },
                inMotion: {
                    enumerable: true,
                    get: ()=>()=>getStatus() !== (0, $6340722eb5bf9108$export$de71442bbf2143da)
                },
                enableMotion: {
                    enumerable: true,
                    get: ()=>()=>supportMotion
                }
            });
            return obj;
        }, []);
        // We lock `deps` here since function return object
        // will repeat trigger ref from `refConfig` -> `null` -> `refConfig`
        $cQmXV.useImperativeHandle(ref, ()=>refObj, []);
        // ===================== Render =====================
        // return motionChildren as React.ReactElement;
        const idRef = $cQmXV.useRef(0);
        if (styleReady) idRef.current += 1;
        // We should render children when motionStyle is sync with stepStatus
        const returnNode = $cQmXV.useMemo(()=>{
            if (styleReady === "NONE") return null;
            let motionChildren;
            const mergedProps = {
                ...eventProps,
                visible: visible
            };
            if (!children) // No children
            motionChildren = null;
            else if (status === (0, $6340722eb5bf9108$export$de71442bbf2143da)) {
                // Stable children
                if (mergedVisible) motionChildren = children({
                    ...mergedProps
                }, nodeRef);
                else if (!removeOnLeave && renderedRef.current && leavedClassName) motionChildren = children({
                    ...mergedProps,
                    className: leavedClassName
                }, nodeRef);
                else if (forceRender || !removeOnLeave && !leavedClassName) motionChildren = children({
                    ...mergedProps,
                    style: {
                        display: "none"
                    }
                }, nodeRef);
                else motionChildren = null;
            } else {
                // In motion
                let statusSuffix;
                if (statusStep === (0, $6340722eb5bf9108$export$1b792916a5fac4fc)) statusSuffix = "prepare";
                else if ((0, $e4f2ff4546529177$export$39e04e72f972b885)(statusStep)) statusSuffix = "active";
                else if (statusStep === (0, $6340722eb5bf9108$export$9563153dd25a3ce8)) statusSuffix = "start";
                const motionCls = (0, $c2b97af08f49fb2b$export$27c72201b1d09951)(motionName, `${status}-${statusSuffix}`);
                motionChildren = children({
                    ...mergedProps,
                    className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)((0, $c2b97af08f49fb2b$export$27c72201b1d09951)(motionName, status), {
                        [motionCls]: motionCls && statusSuffix,
                        [motionName]: typeof motionName === "string"
                    }),
                    style: statusStyle
                }, nodeRef);
            }
            return motionChildren;
        }, [
            idRef.current
        ]);
        if ($8c51644f9597c41e$export$35eb5aa7e3b3c295(children) && (0, $10341b937b26f69d$export$b51ae67c7882a242)(returnNode)) {
            const originNodeRef = (0, $10341b937b26f69d$export$7465e5c0bf44f19a)(returnNode);
            if (originNodeRef !== nodeRef) return /*#__PURE__*/ $cQmXV.cloneElement(returnNode, {
                ref: (0, $10341b937b26f69d$export$ab452c34e8e05029)(originNodeRef, nodeRef)
            });
        }
        return returnNode;
    });
    CSSMotion.displayName = "CSSMotion";
    return CSSMotion;
}
var $8c51644f9597c41e$export$2e2bcd8739ae039 = $8c51644f9597c41e$export$e265d52a86a9f199((0, $c2b97af08f49fb2b$export$d28133ed3ad06c8b));



var $cQmXV = parcelRequire("cQmXV");

const $368c9ee6aef19c98$export$3904baa009bc026e = "add";
const $368c9ee6aef19c98$export$851162f0adad2cbc = "keep";
const $368c9ee6aef19c98$export$c8b3fb08b68cfc85 = "remove";
const $368c9ee6aef19c98$export$2ac1bd1808d2e43a = "removed";
function $368c9ee6aef19c98$export$c47fd798e598c85c(key) {
    let keyObj;
    if (key && typeof key === "object" && "key" in key) keyObj = key;
    else keyObj = {
        key: key
    };
    return {
        ...keyObj,
        key: String(keyObj.key)
    };
}
function $368c9ee6aef19c98$export$84bd7bd42ccc0f72(keys = []) {
    return keys.map($368c9ee6aef19c98$export$c47fd798e598c85c);
}
function $368c9ee6aef19c98$export$14527669107aa301(prevKeys = [], currentKeys = []) {
    let list = [];
    let currentIndex = 0;
    const currentLen = currentKeys.length;
    const prevKeyObjects = $368c9ee6aef19c98$export$84bd7bd42ccc0f72(prevKeys);
    const currentKeyObjects = $368c9ee6aef19c98$export$84bd7bd42ccc0f72(currentKeys);
    // Check prev keys to insert or keep
    prevKeyObjects.forEach((keyObj)=>{
        let hit = false;
        for(let i = currentIndex; i < currentLen; i += 1){
            const currentKeyObj = currentKeyObjects[i];
            if (currentKeyObj.key === keyObj.key) {
                // New added keys should add before current key
                if (currentIndex < i) {
                    list = list.concat(currentKeyObjects.slice(currentIndex, i).map((obj)=>({
                            ...obj,
                            status: $368c9ee6aef19c98$export$3904baa009bc026e
                        })));
                    currentIndex = i;
                }
                list.push({
                    ...currentKeyObj,
                    status: $368c9ee6aef19c98$export$851162f0adad2cbc
                });
                currentIndex += 1;
                hit = true;
                break;
            }
        }
        // If not hit, it means key is removed
        if (!hit) list.push({
            ...keyObj,
            status: $368c9ee6aef19c98$export$c8b3fb08b68cfc85
        });
    });
    // Add rest to the list
    if (currentIndex < currentLen) list = list.concat(currentKeyObjects.slice(currentIndex).map((obj)=>({
            ...obj,
            status: $368c9ee6aef19c98$export$3904baa009bc026e
        })));
    /**
   * Merge same key when it remove and add again:
   *    [1 - add, 2 - keep, 1 - remove] -> [1 - keep, 2 - keep]
   */ const keys = {};
    list.forEach(({ key: key })=>{
        keys[key] = (keys[key] || 0) + 1;
    });
    const duplicatedKeys = Object.keys(keys).filter((key)=>keys[key] > 1);
    duplicatedKeys.forEach((matchKey)=>{
        // Remove `STATUS_REMOVE` node.
        list = list.filter(({ key: key, status: status })=>key !== matchKey || status !== $368c9ee6aef19c98$export$c8b3fb08b68cfc85);
        // Update `STATUS_ADD` to `STATUS_KEEP`
        list.forEach((node)=>{
            if (node.key === matchKey) // eslint-disable-next-line no-param-reassign
            node.status = $368c9ee6aef19c98$export$851162f0adad2cbc;
        });
    });
    return list;
}



function $26c73d1f8271409e$var$_extends() {
    $26c73d1f8271409e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $26c73d1f8271409e$var$_extends.apply(this, arguments);
}
const $26c73d1f8271409e$var$MOTION_PROP_NAMES = [
    "eventProps",
    "visible",
    "children",
    "motionName",
    "motionAppear",
    "motionEnter",
    "motionLeave",
    "motionLeaveImmediately",
    "motionDeadline",
    "removeOnLeave",
    "leavedClassName",
    "onAppearPrepare",
    "onAppearStart",
    "onAppearActive",
    "onAppearEnd",
    "onEnterStart",
    "onEnterActive",
    "onEnterEnd",
    "onLeaveStart",
    "onLeaveActive",
    "onLeaveEnd"
];
function $26c73d1f8271409e$export$fcfc62c1d33d5e2e(transitionSupport, CSSMotion = (0, $8c51644f9597c41e$export$2e2bcd8739ae039)) {
    class CSSMotionList extends $cQmXV.Component {
        static defaultProps = {
            component: "div"
        };
        state = {
            keyEntities: []
        };
        static getDerivedStateFromProps({ keys: keys }, { keyEntities: keyEntities }) {
            const parsedKeyObjects = (0, $368c9ee6aef19c98$export$84bd7bd42ccc0f72)(keys);
            const mixedKeyEntities = (0, $368c9ee6aef19c98$export$14527669107aa301)(keyEntities, parsedKeyObjects);
            return {
                keyEntities: mixedKeyEntities.filter((entity)=>{
                    const prevEntity = keyEntities.find(({ key: key })=>entity.key === key);
                    // Remove if already mark as removed
                    if (prevEntity && prevEntity.status === (0, $368c9ee6aef19c98$export$2ac1bd1808d2e43a) && entity.status === (0, $368c9ee6aef19c98$export$c8b3fb08b68cfc85)) return false;
                    return true;
                })
            };
        }
        // ZombieJ: Return the count of rest keys. It's safe to refactor if need more info.
        removeKey = (removeKey)=>{
            this.setState((prevState)=>{
                const nextKeyEntities = prevState.keyEntities.map((entity)=>{
                    if (entity.key !== removeKey) return entity;
                    return {
                        ...entity,
                        status: (0, $368c9ee6aef19c98$export$2ac1bd1808d2e43a)
                    };
                });
                return {
                    keyEntities: nextKeyEntities
                };
            }, ()=>{
                const { keyEntities: keyEntities } = this.state;
                const restKeysCount = keyEntities.filter(({ status: status })=>status !== (0, $368c9ee6aef19c98$export$2ac1bd1808d2e43a)).length;
                if (restKeysCount === 0 && this.props.onAllRemoved) this.props.onAllRemoved();
            });
        };
        render() {
            const { keyEntities: keyEntities } = this.state;
            const { component: component, children: children, onVisibleChanged: onVisibleChanged, onAllRemoved: onAllRemoved, ...restProps } = this.props;
            const Component = component || $cQmXV.Fragment;
            const motionProps = {};
            $26c73d1f8271409e$var$MOTION_PROP_NAMES.forEach((prop)=>{
                motionProps[prop] = restProps[prop];
                delete restProps[prop];
            });
            delete restProps.keys;
            return /*#__PURE__*/ $cQmXV.createElement(Component, restProps, keyEntities.map(({ status: status, ...eventProps }, index)=>{
                const visible = status === (0, $368c9ee6aef19c98$export$3904baa009bc026e) || status === (0, $368c9ee6aef19c98$export$851162f0adad2cbc);
                return /*#__PURE__*/ $cQmXV.createElement(CSSMotion, $26c73d1f8271409e$var$_extends({}, motionProps, {
                    key: eventProps.key,
                    visible: visible,
                    eventProps: eventProps,
                    onVisibleChanged: (changedVisible)=>{
                        onVisibleChanged?.(changedVisible, {
                            key: eventProps.key
                        });
                        if (!changedVisible) this.removeKey(eventProps.key);
                    }
                }), (0, $8c51644f9597c41e$export$35eb5aa7e3b3c295)(children) ? (props)=>children({
                        ...props,
                        index: index
                    }) : (props, ref)=>children({
                        ...props,
                        index: index
                    }, ref));
            }));
        }
    }
    return CSSMotionList;
}
var $26c73d1f8271409e$export$2e2bcd8739ae039 = $26c73d1f8271409e$export$fcfc62c1d33d5e2e((0, $c2b97af08f49fb2b$export$d28133ed3ad06c8b));



var $04c53b89814950f8$export$2e2bcd8739ae039 = (0, $8c51644f9597c41e$export$2e2bcd8739ae039);





var $cQmXV = parcelRequire("cQmXV");


var $cQmXV = parcelRequire("cQmXV");
function $1f464d1fcddecaa8$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, align: align, arrow: arrow, arrowPos: arrowPos } = props;
    const { className: className, content: content, style: style } = arrow || {};
    const { x: x = 0, y: y = 0 } = arrowPos;
    const arrowRef = $cQmXV.useRef(null);
    // Skip if no align
    if (!align || !align.points) return null;
    const alignStyle = {
        position: "absolute"
    };
    // Skip if no need to align
    if (align.autoArrow !== false) {
        const popupPoints = align.points[0];
        const targetPoints = align.points[1];
        const popupTB = popupPoints[0];
        const popupLR = popupPoints[1];
        const targetTB = targetPoints[0];
        const targetLR = targetPoints[1];
        // Top & Bottom
        if (popupTB === targetTB || ![
            "t",
            "b"
        ].includes(popupTB)) alignStyle.top = y;
        else if (popupTB === "t") alignStyle.top = 0;
        else alignStyle.bottom = 0;
        // Left & Right
        if (popupLR === targetLR || ![
            "l",
            "r"
        ].includes(popupLR)) alignStyle.left = x;
        else if (popupLR === "l") alignStyle.left = 0;
        else alignStyle.right = 0;
    }
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        ref: arrowRef,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-arrow`, className),
        style: {
            ...alignStyle,
            ...style
        }
    }, content);
}





var $cQmXV = parcelRequire("cQmXV");
function $553b9158d3ae03f6$var$_extends() {
    $553b9158d3ae03f6$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $553b9158d3ae03f6$var$_extends.apply(this, arguments);
}
function $553b9158d3ae03f6$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, open: open, zIndex: zIndex, mask: mask, motion: motion, mobile: mobile } = props;
    if (!mask) return null;
    return /*#__PURE__*/ $cQmXV.createElement((0, $04c53b89814950f8$export$2e2bcd8739ae039), $553b9158d3ae03f6$var$_extends({}, motion, {
        motionAppear: true,
        visible: open,
        removeOnLeave: true
    }), ({ className: className })=>/*#__PURE__*/ $cQmXV.createElement("div", {
            style: {
                zIndex: zIndex
            },
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-mask`, mobile && `${prefixCls}-mobile-mask`, className)
        }));
}



var $cQmXV = parcelRequire("cQmXV");
const $8a2c48002d4f5769$var$PopupContent = /*#__PURE__*/ $cQmXV.memo(({ children: children })=>children, (_, next)=>next.cache);
var $8a2c48002d4f5769$export$2e2bcd8739ae039 = $8a2c48002d4f5769$var$PopupContent;


function $cff79926997707b4$export$2e2bcd8739ae039(isMobile, ready, open, align, offsetR, offsetB, offsetX, offsetY) {
    // >>>>> Offset
    const AUTO = "auto";
    const offsetStyle = isMobile ? {} : {
        left: "-1000vw",
        top: "-1000vh",
        right: AUTO,
        bottom: AUTO
    };
    // Set align style
    if (!isMobile && (ready || !open)) {
        const { points: points } = align;
        const dynamicInset = align.dynamicInset || align._experimental?.dynamicInset;
        const alignRight = dynamicInset && points[0][1] === "r";
        const alignBottom = dynamicInset && points[0][0] === "b";
        if (alignRight) {
            offsetStyle.right = offsetR;
            offsetStyle.left = AUTO;
        } else {
            offsetStyle.left = offsetX;
            offsetStyle.right = AUTO;
        }
        if (alignBottom) {
            offsetStyle.bottom = offsetB;
            offsetStyle.top = AUTO;
        } else {
            offsetStyle.top = offsetY;
            offsetStyle.bottom = AUTO;
        }
    }
    return offsetStyle;
}


function $221bf3c16aa8f63b$var$_extends() {
    $221bf3c16aa8f63b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $221bf3c16aa8f63b$var$_extends.apply(this, arguments);
}
const $221bf3c16aa8f63b$var$Popup = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { onEsc: onEsc, popup: popup, className: className, prefixCls: prefixCls, style: style, target: target, onVisibleChanged: onVisibleChanged, open: // Open
    open, keepDom: keepDom, fresh: fresh, onClick: // Click
    onClick, mask: // Mask
    mask, arrow: // Arrow
    arrow, arrowPos: arrowPos, align: align, motion: // Motion
    motion, maskMotion: maskMotion, mobile: // Mobile
    mobile, forceRender: // Portal
    forceRender, getPopupContainer: getPopupContainer, autoDestroy: autoDestroy, portal: Portal, children: children, zIndex: zIndex, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onPointerEnter: onPointerEnter, onPointerDownCapture: onPointerDownCapture, ready: ready, offsetX: offsetX, offsetY: offsetY, offsetR: offsetR, offsetB: offsetB, onAlign: onAlign, onPrepare: onPrepare, onResize: // Resize
    onResize, stretch: stretch, targetWidth: targetWidth, targetHeight: targetHeight } = props;
    const popupContent = typeof popup === "function" ? popup() : popup;
    // We can not remove holder only when motion finished.
    const isNodeVisible = open || keepDom;
    // ========================= Mobile =========================
    const isMobile = !!mobile;
    // ========================== Mask ==========================
    const [mergedMask, mergedMaskMotion, mergedPopupMotion] = $cQmXV.useMemo(()=>{
        if (mobile) return [
            mobile.mask,
            mobile.maskMotion,
            mobile.motion
        ];
        return [
            mask,
            maskMotion,
            motion
        ];
    }, [
        mobile,
        mask,
        maskMotion,
        motion
    ]);
    // ======================= Container ========================
    const getPopupContainerNeedParams = getPopupContainer?.length > 0;
    const [show, setShow] = $cQmXV.useState(!getPopupContainer || !getPopupContainerNeedParams);
    // Delay to show since `getPopupContainer` need target element
    (0, $7673d874dab69d07$export$2e2bcd8739ae039)(()=>{
        if (!show && getPopupContainerNeedParams && target) setShow(true);
    }, [
        show,
        getPopupContainerNeedParams,
        target
    ]);
    // ========================= Resize =========================
    const onInternalResize = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((size, ele)=>{
        onResize?.(size, ele);
        onAlign();
    });
    // ========================= Styles =========================
    const offsetStyle = (0, $cff79926997707b4$export$2e2bcd8739ae039)(isMobile, ready, open, align, offsetR, offsetB, offsetX, offsetY);
    // ========================= Render =========================
    if (!show) return null;
    // >>>>> Misc
    const miscStyle = {};
    if (stretch) {
        if (stretch.includes("height") && targetHeight) miscStyle.height = targetHeight;
        else if (stretch.includes("minHeight") && targetHeight) miscStyle.minHeight = targetHeight;
        if (stretch.includes("width") && targetWidth) miscStyle.width = targetWidth;
        else if (stretch.includes("minWidth") && targetWidth) miscStyle.minWidth = targetWidth;
    }
    if (!open) miscStyle.pointerEvents = "none";
    return /*#__PURE__*/ $cQmXV.createElement(Portal, {
        open: forceRender || isNodeVisible,
        getContainer: getPopupContainer && (()=>getPopupContainer(target)),
        autoDestroy: autoDestroy,
        onEsc: onEsc
    }, /*#__PURE__*/ $cQmXV.createElement((0, $553b9158d3ae03f6$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        open: open,
        zIndex: zIndex,
        mask: mergedMask,
        motion: mergedMaskMotion,
        mobile: isMobile
    }), /*#__PURE__*/ $cQmXV.createElement((0, $1d6306c05e604045$export$2e2bcd8739ae039), {
        onResize: onInternalResize,
        disabled: !open
    }, (resizeObserverRef)=>{
        return /*#__PURE__*/ $cQmXV.createElement((0, $04c53b89814950f8$export$2e2bcd8739ae039), $221bf3c16aa8f63b$var$_extends({
            motionAppear: true,
            motionEnter: true,
            motionLeave: true,
            removeOnLeave: false,
            forceRender: forceRender,
            leavedClassName: `${prefixCls}-hidden`
        }, mergedPopupMotion, {
            onAppearPrepare: onPrepare,
            onEnterPrepare: onPrepare,
            visible: open,
            onVisibleChanged: (nextVisible)=>{
                motion?.onVisibleChanged?.(nextVisible);
                onVisibleChanged(nextVisible);
            }
        }), ({ className: motionClassName, style: motionStyle }, motionRef)=>{
            const cls = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, motionClassName, className, {
                [`${prefixCls}-mobile`]: isMobile
            });
            return /*#__PURE__*/ $cQmXV.createElement("div", {
                ref: (0, $10341b937b26f69d$export$ab452c34e8e05029)(resizeObserverRef, ref, motionRef),
                className: cls,
                style: {
                    "--arrow-x": `${arrowPos.x || 0}px`,
                    "--arrow-y": `${arrowPos.y || 0}px`,
                    ...offsetStyle,
                    ...miscStyle,
                    ...motionStyle,
                    boxSizing: "border-box",
                    zIndex: zIndex,
                    ...style
                },
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onPointerEnter: onPointerEnter,
                onClick: onClick,
                onPointerDownCapture: onPointerDownCapture
            }, arrow && /*#__PURE__*/ $cQmXV.createElement((0, $1f464d1fcddecaa8$export$2e2bcd8739ae039), {
                prefixCls: prefixCls,
                arrow: arrow,
                arrowPos: arrowPos,
                align: align
            }), /*#__PURE__*/ $cQmXV.createElement((0, $8a2c48002d4f5769$export$2e2bcd8739ae039), {
                cache: !open && !fresh
            }, popupContent));
        });
    }), children);
});
var $221bf3c16aa8f63b$export$2e2bcd8739ae039 = $221bf3c16aa8f63b$var$Popup;



var $cQmXV = parcelRequire("cQmXV");
// ===================== Nest =====================
const $cfeb227ea2e5b3be$var$TriggerContext = /*#__PURE__*/ $cQmXV.createContext(null);
var $cfeb227ea2e5b3be$export$2e2bcd8739ae039 = $cfeb227ea2e5b3be$var$TriggerContext;
const $cfeb227ea2e5b3be$export$14cc6d12cdc906c = /*#__PURE__*/ $cQmXV.createContext(null);



var $cQmXV = parcelRequire("cQmXV");
function $95272f42763935fc$var$toArray(val) {
    return val ? Array.isArray(val) ? val : [
        val
    ] : [];
}
function $95272f42763935fc$export$2e2bcd8739ae039(action, showAction, hideAction) {
    return $cQmXV.useMemo(()=>{
        const mergedShowAction = $95272f42763935fc$var$toArray(showAction ?? action);
        const mergedHideAction = $95272f42763935fc$var$toArray(hideAction ?? action);
        const showActionSet = new Set(mergedShowAction);
        const hideActionSet = new Set(mergedHideAction);
        if (showActionSet.has("hover") && !showActionSet.has("click")) showActionSet.add("touch");
        if (hideActionSet.has("hover") && !hideActionSet.has("click")) hideActionSet.add("touch");
        return [
            showActionSet,
            hideActionSet
        ];
    }, [
        action,
        showAction,
        hideAction
    ]);
}




var $cQmXV = parcelRequire("cQmXV");
function $2cce73f2a40e27d4$var$isPointsEq(a1 = [], a2 = [], isAlignPoint) {
    const getVal = (a, index)=>a[index] || "";
    if (isAlignPoint) return getVal(a1, 0) === getVal(a2, 0);
    return getVal(a1, 0) === getVal(a2, 0) && getVal(a1, 1) === getVal(a2, 1);
}
function $2cce73f2a40e27d4$export$faa0aa8ed2fe6432(builtinPlacements, prefixCls, align, isAlignPoint) {
    const { points: points } = align;
    const placements = Object.keys(builtinPlacements);
    for(let i = 0; i < placements.length; i += 1){
        const placement = placements[i];
        if ($2cce73f2a40e27d4$var$isPointsEq(builtinPlacements[placement]?.points, points, isAlignPoint)) return `${prefixCls}-placement-${placement}`;
    }
    return "";
}
function $2cce73f2a40e27d4$export$9c0584a7cc24d9e(ele) {
    return ele.ownerDocument.defaultView;
}
function $2cce73f2a40e27d4$export$ba21ed9400ca485b(ele) {
    const scrollerList = [];
    let current = ele?.parentElement;
    const scrollStyle = [
        "hidden",
        "scroll",
        "clip",
        "auto"
    ];
    while(current){
        const { overflowX: overflowX, overflowY: overflowY, overflow: overflow } = $2cce73f2a40e27d4$export$9c0584a7cc24d9e(current).getComputedStyle(current);
        if ([
            overflowX,
            overflowY,
            overflow
        ].some((o)=>scrollStyle.includes(o))) scrollerList.push(current);
        current = current.parentElement;
    }
    return scrollerList;
}
function $2cce73f2a40e27d4$export$34dfc8f73bbb64ae(num, defaultValue = 1) {
    return Number.isNaN(num) ? defaultValue : num;
}
function $2cce73f2a40e27d4$var$getPxValue(val) {
    return $2cce73f2a40e27d4$export$34dfc8f73bbb64ae(parseFloat(val), 0);
}
function $2cce73f2a40e27d4$export$94be9d7985092f2d(initArea, scrollerList) {
    const visibleArea = {
        ...initArea
    };
    (scrollerList || []).forEach((ele)=>{
        if (ele instanceof HTMLBodyElement || ele instanceof HTMLHtmlElement) return;
        // Skip if static position which will not affect visible area
        const { overflow: overflow, overflowClipMargin: overflowClipMargin, borderTopWidth: borderTopWidth, borderBottomWidth: borderBottomWidth, borderLeftWidth: borderLeftWidth, borderRightWidth: borderRightWidth } = $2cce73f2a40e27d4$export$9c0584a7cc24d9e(ele).getComputedStyle(ele);
        const eleRect = ele.getBoundingClientRect();
        const { offsetHeight: eleOutHeight, clientHeight: eleInnerHeight, offsetWidth: eleOutWidth, clientWidth: eleInnerWidth } = ele;
        const borderTopNum = $2cce73f2a40e27d4$var$getPxValue(borderTopWidth);
        const borderBottomNum = $2cce73f2a40e27d4$var$getPxValue(borderBottomWidth);
        const borderLeftNum = $2cce73f2a40e27d4$var$getPxValue(borderLeftWidth);
        const borderRightNum = $2cce73f2a40e27d4$var$getPxValue(borderRightWidth);
        const scaleX = $2cce73f2a40e27d4$export$34dfc8f73bbb64ae(Math.round(eleRect.width / eleOutWidth * 1000) / 1000);
        const scaleY = $2cce73f2a40e27d4$export$34dfc8f73bbb64ae(Math.round(eleRect.height / eleOutHeight * 1000) / 1000);
        // Original visible area
        const eleScrollWidth = (eleOutWidth - eleInnerWidth - borderLeftNum - borderRightNum) * scaleX;
        const eleScrollHeight = (eleOutHeight - eleInnerHeight - borderTopNum - borderBottomNum) * scaleY;
        // Cut border size
        const scaledBorderTopWidth = borderTopNum * scaleY;
        const scaledBorderBottomWidth = borderBottomNum * scaleY;
        const scaledBorderLeftWidth = borderLeftNum * scaleX;
        const scaledBorderRightWidth = borderRightNum * scaleX;
        // Clip margin
        let clipMarginWidth = 0;
        let clipMarginHeight = 0;
        if (overflow === "clip") {
            const clipNum = $2cce73f2a40e27d4$var$getPxValue(overflowClipMargin);
            clipMarginWidth = clipNum * scaleX;
            clipMarginHeight = clipNum * scaleY;
        }
        // Region
        const eleLeft = eleRect.x + scaledBorderLeftWidth - clipMarginWidth;
        const eleTop = eleRect.y + scaledBorderTopWidth - clipMarginHeight;
        const eleRight = eleLeft + eleRect.width + 2 * clipMarginWidth - scaledBorderLeftWidth - scaledBorderRightWidth - eleScrollWidth;
        const eleBottom = eleTop + eleRect.height + 2 * clipMarginHeight - scaledBorderTopWidth - scaledBorderBottomWidth - eleScrollHeight;
        visibleArea.left = Math.max(visibleArea.left, eleLeft);
        visibleArea.top = Math.max(visibleArea.top, eleTop);
        visibleArea.right = Math.min(visibleArea.right, eleRight);
        visibleArea.bottom = Math.min(visibleArea.bottom, eleBottom);
    });
    return visibleArea;
}


function $622d35b035865dbb$var$getUnitOffset(size, offset = 0) {
    const offsetStr = `${offset}`;
    const cells = offsetStr.match(/^(.*)\%$/);
    if (cells) return size * (parseFloat(cells[1]) / 100);
    return parseFloat(offsetStr);
}
function $622d35b035865dbb$var$getNumberOffset(rect, offset) {
    const [offsetX, offsetY] = offset || [];
    return [
        $622d35b035865dbb$var$getUnitOffset(rect.width, offsetX),
        $622d35b035865dbb$var$getUnitOffset(rect.height, offsetY)
    ];
}
function $622d35b035865dbb$var$splitPoints(points = "") {
    return [
        points[0],
        points[1]
    ];
}
function $622d35b035865dbb$var$getAlignPoint(rect, points) {
    const topBottom = points[0];
    const leftRight = points[1];
    let x;
    let y;
    // Top & Bottom
    if (topBottom === "t") y = rect.y;
    else if (topBottom === "b") y = rect.y + rect.height;
    else y = rect.y + rect.height / 2;
    // Left & Right
    if (leftRight === "l") x = rect.x;
    else if (leftRight === "r") x = rect.x + rect.width;
    else x = rect.x + rect.width / 2;
    return {
        x: x,
        y: y
    };
}
function $622d35b035865dbb$var$reversePoints(points, index) {
    const reverseMap = {
        t: "b",
        b: "t",
        l: "r",
        r: "l"
    };
    const clone = [
        ...points
    ];
    clone[index] = reverseMap[points[index]] || "c";
    return clone;
}
function $622d35b035865dbb$var$flatPoints(points) {
    return points.join("");
}
function $622d35b035865dbb$export$2e2bcd8739ae039(open, popupEle, target, placement, builtinPlacements, popupAlign, onPopupAlign, mobile) {
    const [offsetInfo, setOffsetInfo] = $cQmXV.useState({
        ready: false,
        offsetX: 0,
        offsetY: 0,
        offsetR: 0,
        offsetB: 0,
        arrowX: 0,
        arrowY: 0,
        scaleX: 1,
        scaleY: 1,
        align: builtinPlacements[placement] || {}
    });
    const alignCountRef = $cQmXV.useRef(0);
    const scrollerList = $cQmXV.useMemo(()=>{
        if (!popupEle || mobile) return [];
        return (0, $2cce73f2a40e27d4$export$ba21ed9400ca485b)(popupEle);
    }, [
        popupEle
    ]);
    // ========================= Flip ==========================
    // We will memo flip info.
    // If size change to make flip, it will memo the flip info and use it in next align.
    const prevFlipRef = $cQmXV.useRef({});
    const resetFlipCache = ()=>{
        prevFlipRef.current = {};
    };
    if (!open) resetFlipCache();
    // ========================= Align =========================
    const onAlign = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)(()=>{
        if (popupEle && target && open && !mobile) {
            const popupElement = popupEle;
            const doc = popupElement.ownerDocument;
            const win = (0, $2cce73f2a40e27d4$export$9c0584a7cc24d9e)(popupElement);
            const { position: popupPosition } = win.getComputedStyle(popupElement);
            const originLeft = popupElement.style.left;
            const originTop = popupElement.style.top;
            const originRight = popupElement.style.right;
            const originBottom = popupElement.style.bottom;
            const originOverflow = popupElement.style.overflow;
            const originOverflowX = popupElement.style.overflowX;
            const originOverflowY = popupElement.style.overflowY;
            // Placement
            const placementInfo = {
                ...builtinPlacements[placement],
                ...popupAlign
            };
            // placeholder element
            const placeholderElement = doc.createElement("div");
            popupElement.parentElement?.appendChild(placeholderElement);
            placeholderElement.style.left = `${popupElement.offsetLeft}px`;
            placeholderElement.style.top = `${popupElement.offsetTop}px`;
            placeholderElement.style.position = popupPosition;
            placeholderElement.style.height = `${popupElement.offsetHeight}px`;
            placeholderElement.style.width = `${popupElement.offsetWidth}px`;
            // Reset first
            popupElement.style.left = "0";
            popupElement.style.top = "0";
            popupElement.style.right = "auto";
            popupElement.style.bottom = "auto";
            popupElement.style.overflow = "hidden";
            // Calculate align style, we should consider `transform` case
            let targetRect;
            if (Array.isArray(target)) targetRect = {
                x: target[0],
                y: target[1],
                width: 0,
                height: 0
            };
            else {
                const rect = target.getBoundingClientRect();
                rect.x = rect.x ?? rect.left;
                rect.y = rect.y ?? rect.top;
                targetRect = {
                    x: rect.x,
                    y: rect.y,
                    width: rect.width,
                    height: rect.height
                };
            }
            const popupRect = popupElement.getBoundingClientRect();
            const { height: height, width: width } = win.getComputedStyle(popupElement);
            popupRect.x = popupRect.x ?? popupRect.left;
            popupRect.y = popupRect.y ?? popupRect.top;
            const { clientWidth: clientWidth, clientHeight: clientHeight, scrollWidth: scrollWidth, scrollHeight: scrollHeight, scrollTop: scrollTop, scrollLeft: scrollLeft } = doc.documentElement;
            const popupHeight = popupRect.height;
            const popupWidth = popupRect.width;
            const targetHeight = targetRect.height;
            const targetWidth = targetRect.width;
            // Get bounding of visible area
            const visibleRegion = {
                left: 0,
                top: 0,
                right: clientWidth,
                bottom: clientHeight
            };
            const scrollRegion = {
                left: -scrollLeft,
                top: -scrollTop,
                right: scrollWidth - scrollLeft,
                bottom: scrollHeight - scrollTop
            };
            let { htmlRegion: htmlRegion } = placementInfo;
            const VISIBLE = "visible";
            const VISIBLE_FIRST = "visibleFirst";
            if (htmlRegion !== "scroll" && htmlRegion !== VISIBLE_FIRST) htmlRegion = VISIBLE;
            const isVisibleFirst = htmlRegion === VISIBLE_FIRST;
            const scrollRegionArea = (0, $2cce73f2a40e27d4$export$94be9d7985092f2d)(scrollRegion, scrollerList);
            const visibleRegionArea = (0, $2cce73f2a40e27d4$export$94be9d7985092f2d)(visibleRegion, scrollerList);
            const visibleArea = htmlRegion === VISIBLE ? visibleRegionArea : scrollRegionArea;
            // When set to `visibleFirst`,
            // the check `adjust` logic will use `visibleRegion` for check first.
            const adjustCheckVisibleArea = isVisibleFirst ? visibleRegionArea : visibleArea;
            // Record right & bottom align data
            popupElement.style.left = "auto";
            popupElement.style.top = "auto";
            popupElement.style.right = "0";
            popupElement.style.bottom = "0";
            const popupMirrorRect = popupElement.getBoundingClientRect();
            // Reset back
            popupElement.style.left = originLeft;
            popupElement.style.top = originTop;
            popupElement.style.right = originRight;
            popupElement.style.bottom = originBottom;
            popupElement.style.overflow = originOverflow;
            popupElement.style.overflowX = originOverflowX;
            popupElement.style.overflowY = originOverflowY;
            popupElement.parentElement?.removeChild(placeholderElement);
            // Calculate scale
            const scaleX = (0, $2cce73f2a40e27d4$export$34dfc8f73bbb64ae)(Math.round(popupWidth / parseFloat(width) * 1000) / 1000);
            const scaleY = (0, $2cce73f2a40e27d4$export$34dfc8f73bbb64ae)(Math.round(popupHeight / parseFloat(height) * 1000) / 1000);
            // No need to align since it's not visible in view
            if (scaleX === 0 || scaleY === 0 || (0, $d3fb35d553a86e29$export$41e30d8dd0ba7a50)(target) && !(0, $c70640475a7bd353$export$2e2bcd8739ae039)(target)) return;
            // Offset
            const { offset: offset, targetOffset: targetOffset } = placementInfo;
            let [popupOffsetX, popupOffsetY] = $622d35b035865dbb$var$getNumberOffset(popupRect, offset);
            const [targetOffsetX, targetOffsetY] = $622d35b035865dbb$var$getNumberOffset(targetRect, targetOffset);
            targetRect.x -= targetOffsetX;
            targetRect.y -= targetOffsetY;
            // Points
            const [popupPoint, targetPoint] = placementInfo.points || [];
            const targetPoints = $622d35b035865dbb$var$splitPoints(targetPoint);
            const popupPoints = $622d35b035865dbb$var$splitPoints(popupPoint);
            const targetAlignPoint = $622d35b035865dbb$var$getAlignPoint(targetRect, targetPoints);
            const popupAlignPoint = $622d35b035865dbb$var$getAlignPoint(popupRect, popupPoints);
            // Real align info may not same as origin one
            const nextAlignInfo = {
                ...placementInfo
            };
            let nextPoints = [
                popupPoints,
                targetPoints
            ];
            // Next Offset
            let nextOffsetX = targetAlignPoint.x - popupAlignPoint.x + popupOffsetX;
            let nextOffsetY = targetAlignPoint.y - popupAlignPoint.y + popupOffsetY;
            // ============== Intersection ===============
            // Get area by position. Used for check if flip area is better
            function getIntersectionVisibleArea(offsetX, offsetY, area = visibleArea) {
                const l = popupRect.x + offsetX;
                const t = popupRect.y + offsetY;
                const r = l + popupWidth;
                const b = t + popupHeight;
                const visibleL = Math.max(l, area.left);
                const visibleT = Math.max(t, area.top);
                const visibleR = Math.min(r, area.right);
                const visibleB = Math.min(b, area.bottom);
                return Math.max(0, (visibleR - visibleL) * (visibleB - visibleT));
            }
            const originIntersectionVisibleArea = getIntersectionVisibleArea(nextOffsetX, nextOffsetY);
            // As `visibleFirst`, we prepare this for check
            const originIntersectionRecommendArea = getIntersectionVisibleArea(nextOffsetX, nextOffsetY, visibleRegionArea);
            // ========================== Overflow ===========================
            const targetAlignPointTL = $622d35b035865dbb$var$getAlignPoint(targetRect, [
                "t",
                "l"
            ]);
            const popupAlignPointTL = $622d35b035865dbb$var$getAlignPoint(popupRect, [
                "t",
                "l"
            ]);
            const targetAlignPointBR = $622d35b035865dbb$var$getAlignPoint(targetRect, [
                "b",
                "r"
            ]);
            const popupAlignPointBR = $622d35b035865dbb$var$getAlignPoint(popupRect, [
                "b",
                "r"
            ]);
            const overflow = placementInfo.overflow || {};
            const { adjustX: adjustX, adjustY: adjustY, shiftX: shiftX, shiftY: shiftY } = overflow;
            const supportAdjust = (val)=>{
                if (typeof val === "boolean") return val;
                return val >= 0;
            };
            // Prepare position
            let nextPopupY;
            let nextPopupBottom;
            let nextPopupX;
            let nextPopupRight;
            function syncNextPopupPosition() {
                nextPopupY = popupRect.y + nextOffsetY;
                nextPopupBottom = nextPopupY + popupHeight;
                nextPopupX = popupRect.x + nextOffsetX;
                nextPopupRight = nextPopupX + popupWidth;
            }
            syncNextPopupPosition();
            // >>>>>>>>>> Top & Bottom
            const needAdjustY = supportAdjust(adjustY);
            const sameTB = popupPoints[0] === targetPoints[0];
            // Bottom to Top
            if (needAdjustY && popupPoints[0] === "t" && (nextPopupBottom > adjustCheckVisibleArea.bottom || prevFlipRef.current.bt)) {
                let tmpNextOffsetY = nextOffsetY;
                if (sameTB) tmpNextOffsetY -= popupHeight - targetHeight;
                else tmpNextOffsetY = targetAlignPointTL.y - popupAlignPointBR.y - popupOffsetY;
                const newVisibleArea = getIntersectionVisibleArea(nextOffsetX, tmpNextOffsetY);
                const newVisibleRecommendArea = getIntersectionVisibleArea(nextOffsetX, tmpNextOffsetY, visibleRegionArea);
                if (// Of course use larger one
                newVisibleArea > originIntersectionVisibleArea || newVisibleArea === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
                newVisibleRecommendArea >= originIntersectionRecommendArea)) {
                    prevFlipRef.current.bt = true;
                    nextOffsetY = tmpNextOffsetY;
                    popupOffsetY = -popupOffsetY;
                    nextPoints = [
                        $622d35b035865dbb$var$reversePoints(nextPoints[0], 0),
                        $622d35b035865dbb$var$reversePoints(nextPoints[1], 0)
                    ];
                } else prevFlipRef.current.bt = false;
            }
            // Top to Bottom
            if (needAdjustY && popupPoints[0] === "b" && (nextPopupY < adjustCheckVisibleArea.top || prevFlipRef.current.tb)) {
                let tmpNextOffsetY = nextOffsetY;
                if (sameTB) tmpNextOffsetY += popupHeight - targetHeight;
                else tmpNextOffsetY = targetAlignPointBR.y - popupAlignPointTL.y - popupOffsetY;
                const newVisibleArea = getIntersectionVisibleArea(nextOffsetX, tmpNextOffsetY);
                const newVisibleRecommendArea = getIntersectionVisibleArea(nextOffsetX, tmpNextOffsetY, visibleRegionArea);
                if (// Of course use larger one
                newVisibleArea > originIntersectionVisibleArea || newVisibleArea === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
                newVisibleRecommendArea >= originIntersectionRecommendArea)) {
                    prevFlipRef.current.tb = true;
                    nextOffsetY = tmpNextOffsetY;
                    popupOffsetY = -popupOffsetY;
                    nextPoints = [
                        $622d35b035865dbb$var$reversePoints(nextPoints[0], 0),
                        $622d35b035865dbb$var$reversePoints(nextPoints[1], 0)
                    ];
                } else prevFlipRef.current.tb = false;
            }
            // >>>>>>>>>> Left & Right
            const needAdjustX = supportAdjust(adjustX);
            // >>>>> Flip
            const sameLR = popupPoints[1] === targetPoints[1];
            // Right to Left
            if (needAdjustX && popupPoints[1] === "l" && (nextPopupRight > adjustCheckVisibleArea.right || prevFlipRef.current.rl)) {
                let tmpNextOffsetX = nextOffsetX;
                if (sameLR) tmpNextOffsetX -= popupWidth - targetWidth;
                else tmpNextOffsetX = targetAlignPointTL.x - popupAlignPointBR.x - popupOffsetX;
                const newVisibleArea = getIntersectionVisibleArea(tmpNextOffsetX, nextOffsetY);
                const newVisibleRecommendArea = getIntersectionVisibleArea(tmpNextOffsetX, nextOffsetY, visibleRegionArea);
                if (// Of course use larger one
                newVisibleArea > originIntersectionVisibleArea || newVisibleArea === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
                newVisibleRecommendArea >= originIntersectionRecommendArea)) {
                    prevFlipRef.current.rl = true;
                    nextOffsetX = tmpNextOffsetX;
                    popupOffsetX = -popupOffsetX;
                    nextPoints = [
                        $622d35b035865dbb$var$reversePoints(nextPoints[0], 1),
                        $622d35b035865dbb$var$reversePoints(nextPoints[1], 1)
                    ];
                } else prevFlipRef.current.rl = false;
            }
            // Left to Right
            if (needAdjustX && popupPoints[1] === "r" && (nextPopupX < adjustCheckVisibleArea.left || prevFlipRef.current.lr)) {
                let tmpNextOffsetX = nextOffsetX;
                if (sameLR) tmpNextOffsetX += popupWidth - targetWidth;
                else tmpNextOffsetX = targetAlignPointBR.x - popupAlignPointTL.x - popupOffsetX;
                const newVisibleArea = getIntersectionVisibleArea(tmpNextOffsetX, nextOffsetY);
                const newVisibleRecommendArea = getIntersectionVisibleArea(tmpNextOffsetX, nextOffsetY, visibleRegionArea);
                if (// Of course use larger one
                newVisibleArea > originIntersectionVisibleArea || newVisibleArea === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
                newVisibleRecommendArea >= originIntersectionRecommendArea)) {
                    prevFlipRef.current.lr = true;
                    nextOffsetX = tmpNextOffsetX;
                    popupOffsetX = -popupOffsetX;
                    nextPoints = [
                        $622d35b035865dbb$var$reversePoints(nextPoints[0], 1),
                        $622d35b035865dbb$var$reversePoints(nextPoints[1], 1)
                    ];
                } else prevFlipRef.current.lr = false;
            }
            nextAlignInfo.points = [
                $622d35b035865dbb$var$flatPoints(nextPoints[0]),
                $622d35b035865dbb$var$flatPoints(nextPoints[1])
            ];
            // ============================ Shift ============================
            syncNextPopupPosition();
            const numShiftX = shiftX === true ? 0 : shiftX;
            if (typeof numShiftX === "number") {
                // Left
                if (nextPopupX < visibleRegionArea.left) {
                    nextOffsetX -= nextPopupX - visibleRegionArea.left - popupOffsetX;
                    if (targetRect.x + targetWidth < visibleRegionArea.left + numShiftX) nextOffsetX += targetRect.x - visibleRegionArea.left + targetWidth - numShiftX;
                }
                // Right
                if (nextPopupRight > visibleRegionArea.right) {
                    nextOffsetX -= nextPopupRight - visibleRegionArea.right - popupOffsetX;
                    if (targetRect.x > visibleRegionArea.right - numShiftX) nextOffsetX += targetRect.x - visibleRegionArea.right + numShiftX;
                }
            }
            const numShiftY = shiftY === true ? 0 : shiftY;
            if (typeof numShiftY === "number") {
                // Top
                if (nextPopupY < visibleRegionArea.top) {
                    nextOffsetY -= nextPopupY - visibleRegionArea.top - popupOffsetY;
                    // When target if far away from visible area
                    // Stop shift
                    if (targetRect.y + targetHeight < visibleRegionArea.top + numShiftY) nextOffsetY += targetRect.y - visibleRegionArea.top + targetHeight - numShiftY;
                }
                // Bottom
                if (nextPopupBottom > visibleRegionArea.bottom) {
                    nextOffsetY -= nextPopupBottom - visibleRegionArea.bottom - popupOffsetY;
                    if (targetRect.y > visibleRegionArea.bottom - numShiftY) nextOffsetY += targetRect.y - visibleRegionArea.bottom + numShiftY;
                }
            }
            // ============================ Arrow ============================
            // Arrow center align
            const popupLeft = popupRect.x + nextOffsetX;
            const popupRight = popupLeft + popupWidth;
            const popupTop = popupRect.y + nextOffsetY;
            const popupBottom = popupTop + popupHeight;
            const targetLeft = targetRect.x;
            const targetRight = targetLeft + targetWidth;
            const targetTop = targetRect.y;
            const targetBottom = targetTop + targetHeight;
            /** Max left of the popup and target element */ const maxLeft = Math.max(popupLeft, targetLeft);
            /** Min right of the popup and target element */ const minRight = Math.min(popupRight, targetRight);
            /** The center X of popup & target cross area */ const xCenter = (maxLeft + minRight) / 2;
            /** Arrow X of popup offset */ const nextArrowX = xCenter - popupLeft;
            const maxTop = Math.max(popupTop, targetTop);
            const minBottom = Math.min(popupBottom, targetBottom);
            const yCenter = (maxTop + minBottom) / 2;
            const nextArrowY = yCenter - popupTop;
            onPopupAlign?.(popupEle, nextAlignInfo);
            // Additional calculate right & bottom position
            let offsetX4Right = popupMirrorRect.right - popupRect.x - (nextOffsetX + popupRect.width);
            let offsetY4Bottom = popupMirrorRect.bottom - popupRect.y - (nextOffsetY + popupRect.height);
            if (scaleX === 1) {
                nextOffsetX = Math.floor(nextOffsetX);
                offsetX4Right = Math.floor(offsetX4Right);
            }
            if (scaleY === 1) {
                nextOffsetY = Math.floor(nextOffsetY);
                offsetY4Bottom = Math.floor(offsetY4Bottom);
            }
            const nextOffsetInfo = {
                ready: true,
                offsetX: nextOffsetX / scaleX,
                offsetY: nextOffsetY / scaleY,
                offsetR: offsetX4Right / scaleX,
                offsetB: offsetY4Bottom / scaleY,
                arrowX: nextArrowX / scaleX,
                arrowY: nextArrowY / scaleY,
                scaleX: scaleX,
                scaleY: scaleY,
                align: nextAlignInfo
            };
            setOffsetInfo(nextOffsetInfo);
        }
    });
    const triggerAlign = ()=>{
        alignCountRef.current += 1;
        const id = alignCountRef.current;
        // Merge all align requirement into one frame
        Promise.resolve().then(()=>{
            if (alignCountRef.current === id) onAlign();
        });
    };
    // Reset ready status when placement & open changed
    const resetReady = ()=>{
        setOffsetInfo((ori)=>({
                ...ori,
                ready: false
            }));
    };
    (0, $7673d874dab69d07$export$2e2bcd8739ae039)(resetReady, [
        placement
    ]);
    (0, $7673d874dab69d07$export$2e2bcd8739ae039)(()=>{
        if (!open) resetReady();
    }, [
        open
    ]);
    return [
        offsetInfo.ready,
        offsetInfo.offsetX,
        offsetInfo.offsetY,
        offsetInfo.offsetR,
        offsetInfo.offsetB,
        offsetInfo.arrowX,
        offsetInfo.arrowY,
        offsetInfo.scaleX,
        offsetInfo.scaleY,
        offsetInfo.align,
        triggerAlign
    ];
}



var $cQmXV = parcelRequire("cQmXV");
function $b8a63d9f6aead508$export$2e2bcd8739ae039() {
    const delayRef = $cQmXV.useRef(null);
    const clearDelay = ()=>{
        if (delayRef.current) {
            clearTimeout(delayRef.current);
            delayRef.current = null;
        }
    };
    const delayInvoke = (callback, delay)=>{
        clearDelay();
        if (delay === 0) callback();
        else delayRef.current = setTimeout(()=>{
            callback();
        }, delay * 1000);
    };
    // Clean up on unmount
    $cQmXV.useEffect(()=>{
        return ()=>{
            clearDelay();
        };
    }, []);
    return delayInvoke;
}




function $05c8bee7852a4271$export$2e2bcd8739ae039(open, target, popup, onAlign, onScroll) {
    (0, $7673d874dab69d07$export$2e2bcd8739ae039)(()=>{
        if (open && target && popup) {
            const targetElement = target;
            const popupElement = popup;
            const targetScrollList = (0, $2cce73f2a40e27d4$export$ba21ed9400ca485b)(targetElement);
            const popupScrollList = (0, $2cce73f2a40e27d4$export$ba21ed9400ca485b)(popupElement);
            const win = (0, $2cce73f2a40e27d4$export$9c0584a7cc24d9e)(popupElement);
            const mergedList = new Set([
                win,
                ...targetScrollList,
                ...popupScrollList
            ]);
            function notifyScroll() {
                onAlign();
                onScroll();
            }
            mergedList.forEach((scroller)=>{
                scroller.addEventListener("scroll", notifyScroll, {
                    passive: true
                });
            });
            win.addEventListener("resize", notifyScroll, {
                passive: true
            });
            // First time always do align
            onAlign();
            return ()=>{
                mergedList.forEach((scroller)=>{
                    scroller.removeEventListener("scroll", notifyScroll);
                    win.removeEventListener("resize", notifyScroll);
                });
            };
        }
    }, [
        open,
        target,
        popup
    ]);
}




var $cQmXV = parcelRequire("cQmXV");

function $faca169b1695cd10$export$2e2bcd8739ae039(open, clickToHide, targetEle, popupEle, mask, maskClosable, inPopupOrChild, triggerOpen) {
    const openRef = $cQmXV.useRef(open);
    openRef.current = open;
    const popupPointerDownRef = $cQmXV.useRef(false);
    // Click to hide is special action since click popup element should not hide
    $cQmXV.useEffect(()=>{
        if (clickToHide && popupEle && (!mask || maskClosable)) {
            const onPointerDown = ()=>{
                popupPointerDownRef.current = false;
            };
            const onTriggerClose = (e)=>{
                if (openRef.current && !inPopupOrChild(e.composedPath?.()?.[0] || e.target) && !popupPointerDownRef.current) triggerOpen(false);
            };
            const win = (0, $2cce73f2a40e27d4$export$9c0584a7cc24d9e)(popupEle);
            win.addEventListener("pointerdown", onPointerDown, true);
            win.addEventListener("mousedown", onTriggerClose, true);
            win.addEventListener("contextmenu", onTriggerClose, true);
            // shadow root
            const targetShadowRoot = (0, $7b66ec1d5ddc0bd4$export$70e8259662bb498b)(targetEle);
            if (targetShadowRoot) {
                targetShadowRoot.addEventListener("mousedown", onTriggerClose, true);
                targetShadowRoot.addEventListener("contextmenu", onTriggerClose, true);
            }
            return ()=>{
                win.removeEventListener("pointerdown", onPointerDown, true);
                win.removeEventListener("mousedown", onTriggerClose, true);
                win.removeEventListener("contextmenu", onTriggerClose, true);
                if (targetShadowRoot) {
                    targetShadowRoot.removeEventListener("mousedown", onTriggerClose, true);
                    targetShadowRoot.removeEventListener("contextmenu", onTriggerClose, true);
                }
            };
        }
    }, [
        clickToHide,
        targetEle,
        popupEle,
        mask,
        maskClosable
    ]);
    function onPopupPointerDown() {
        popupPointerDownRef.current = true;
    }
    return onPopupPointerDown;
}




var $cQmXV = parcelRequire("cQmXV");







var $cQmXV = parcelRequire("cQmXV");

function $a0ea01fe9c8c34d3$export$2e2bcd8739ae039() {
    const [options, setOptions] = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useState(null);
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useState(false);
    const [isAnimating, setIsAnimating] = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useState(false);
    const pendingOptionsRef = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useRef(null);
    const trigger = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((nextOptions)=>{
        if (nextOptions === false) {
            // Clear pending options when hiding
            pendingOptionsRef.current = null;
            setOpen(false);
        } else if (isAnimating && open) // If animating (appear or enter), cache new options
        pendingOptionsRef.current = nextOptions;
        else {
            setOpen(true);
            // Set new options
            setOptions(nextOptions);
            pendingOptionsRef.current = null;
            // Only mark as animating when transitioning from closed to open
            if (!open) setIsAnimating(true);
        }
    });
    const onVisibleChanged = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((visible)=>{
        if (visible) {
            // Animation enter completed, check if there are pending options
            setIsAnimating(false);
            if (pendingOptionsRef.current) {
                // Apply pending options
                setOptions(pendingOptionsRef.current);
                pendingOptionsRef.current = null;
            }
        } else {
            // Animation leave completed
            setIsAnimating(false);
            pendingOptionsRef.current = null;
        }
    });
    return [
        trigger,
        open,
        options,
        onVisibleChanged
    ];
}



var $cQmXV = parcelRequire("cQmXV");



function $763024e6a8d166ec$var$_extends() {
    $763024e6a8d166ec$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $763024e6a8d166ec$var$_extends.apply(this, arguments);
}
const $763024e6a8d166ec$var$UniqueContainer = (props)=>{
    const { prefixCls: prefixCls, isMobile: isMobile, ready: ready, open: open, align: align, offsetR: offsetR, offsetB: offsetB, offsetX: offsetX, offsetY: offsetY, arrowPos: arrowPos, popupSize: popupSize, motion: motion, uniqueContainerClassName: uniqueContainerClassName, uniqueContainerStyle: uniqueContainerStyle } = props;
    const containerCls = `${prefixCls}-unique-container`;
    const [motionVisible, setMotionVisible] = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useState(false);
    // ========================= Styles =========================
    const offsetStyle = (0, $cff79926997707b4$export$2e2bcd8739ae039)(isMobile, ready, open, align, offsetR, offsetB, offsetX, offsetY);
    // Cache for offsetStyle when ready is true
    const cachedOffsetStyleRef = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useRef(offsetStyle);
    // Update cached offset style when ready is true
    if (ready) cachedOffsetStyleRef.current = offsetStyle;
    // Apply popup size if available
    const sizeStyle = {};
    if (popupSize) {
        sizeStyle.width = popupSize.width;
        sizeStyle.height = popupSize.height;
    }
    // ========================= Render =========================
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $04c53b89814950f8$export$2e2bcd8739ae039), $763024e6a8d166ec$var$_extends({
        motionAppear: true,
        motionEnter: true,
        motionLeave: true,
        removeOnLeave: false,
        leavedClassName: `${containerCls}-hidden`
    }, motion, {
        visible: open,
        onVisibleChanged: (nextVisible)=>{
            setMotionVisible(nextVisible);
        }
    }), ({ className: motionClassName, style: motionStyle })=>{
        const cls = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(containerCls, motionClassName, uniqueContainerClassName, {
            [`${containerCls}-visible`]: motionVisible
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
            className: cls,
            style: {
                "--arrow-x": `${arrowPos?.x || 0}px`,
                "--arrow-y": `${arrowPos?.y || 0}px`,
                ...cachedOffsetStyleRef.current,
                ...sizeStyle,
                ...motionStyle,
                ...uniqueContainerStyle
            }
        });
    });
};
var $763024e6a8d166ec$export$2e2bcd8739ae039 = $763024e6a8d166ec$var$UniqueContainer;




const $8c1540a7f6caa2b5$var$UniqueProvider = ({ children: children, postTriggerProps: postTriggerProps })=>{
    const [trigger, open, options, onTargetVisibleChanged] = (0, $a0ea01fe9c8c34d3$export$2e2bcd8739ae039)();
    // ========================== Options ===========================
    const mergedOptions = $cQmXV.useMemo(()=>{
        if (!options || !postTriggerProps) return options;
        return postTriggerProps(options);
    }, [
        options,
        postTriggerProps
    ]);
    // =========================== Popup ============================
    const [popupEle, setPopupEle] = $cQmXV.useState(null);
    const [popupSize, setPopupSize] = $cQmXV.useState(null);
    // Used for forwardRef popup. Not use internal
    const externalPopupRef = $cQmXV.useRef(null);
    const setPopupRef = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((node)=>{
        externalPopupRef.current = node;
        if ((0, $d3fb35d553a86e29$export$41e30d8dd0ba7a50)(node) && popupEle !== node) setPopupEle(node);
    });
    // ========================== Register ==========================
    // Store the isOpen function from the latest show call
    const isOpenRef = $cQmXV.useRef(null);
    const delayInvoke = (0, $b8a63d9f6aead508$export$2e2bcd8739ae039)();
    const show = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((showOptions, isOpen)=>{
        // Store the isOpen function for later use in hide
        isOpenRef.current = isOpen;
        delayInvoke(()=>{
            trigger(showOptions);
        }, showOptions.delay);
    });
    const hide = (delay)=>{
        delayInvoke(()=>{
            // Check if we should still hide by calling the isOpen function
            // If isOpen returns true, it means another trigger wants to keep it open
            if (isOpenRef.current?.()) return; // Don't hide if something else wants it open
            trigger(false);
        // Don't clear target, currentNode, options immediately, wait until animation completes
        }, delay);
    };
    // Callback after animation completes
    const onVisibleChanged = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((visible)=>{
        // Call useTargetState callback to handle animation state
        onTargetVisibleChanged(visible);
    });
    // =========================== Align ============================
    const [ready, offsetX, offsetY, offsetR, offsetB, arrowX, arrowY, , , // scaleY - not used in UniqueProvider
    alignInfo, onAlign] = (0, $622d35b035865dbb$export$2e2bcd8739ae039)(open, popupEle, mergedOptions?.target, mergedOptions?.popupPlacement, mergedOptions?.builtinPlacements || {}, mergedOptions?.popupAlign, undefined, // onPopupAlign
    false // isMobile
    );
    const alignedClassName = $cQmXV.useMemo(()=>{
        if (!mergedOptions) return "";
        const baseClassName = (0, $2cce73f2a40e27d4$export$faa0aa8ed2fe6432)(mergedOptions.builtinPlacements || {}, mergedOptions.prefixCls || "", alignInfo, false // alignPoint is false for UniqueProvider
        );
        return (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(baseClassName, mergedOptions.getPopupClassNameFromAlign?.(alignInfo));
    }, [
        alignInfo,
        mergedOptions?.getPopupClassNameFromAlign,
        mergedOptions?.builtinPlacements,
        mergedOptions?.prefixCls
    ]);
    const contextValue = $cQmXV.useMemo(()=>({
            show: show,
            hide: hide
        }), []);
    // =========================== Align ============================
    $cQmXV.useEffect(()=>{
        onAlign();
    }, [
        mergedOptions?.target
    ]);
    // =========================== Motion ===========================
    const onPrepare = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)(()=>{
        onAlign();
        return Promise.resolve();
    });
    // ======================== Trigger Context =====================
    const subPopupElements = $cQmXV.useRef({});
    const parentContext = $cQmXV.useContext((0, $cfeb227ea2e5b3be$export$2e2bcd8739ae039));
    const triggerContextValue = $cQmXV.useMemo(()=>({
            registerSubPopup: (id, subPopupEle)=>{
                subPopupElements.current[id] = subPopupEle;
                parentContext?.registerSubPopup(id, subPopupEle);
            }
        }), [
        parentContext
    ]);
    // =========================== Render ===========================
    const prefixCls = mergedOptions?.prefixCls;
    return /*#__PURE__*/ $cQmXV.createElement((0, $cfeb227ea2e5b3be$export$14cc6d12cdc906c).Provider, {
        value: contextValue
    }, children, mergedOptions && /*#__PURE__*/ $cQmXV.createElement((0, $cfeb227ea2e5b3be$export$2e2bcd8739ae039).Provider, {
        value: triggerContextValue
    }, /*#__PURE__*/ $cQmXV.createElement((0, $221bf3c16aa8f63b$export$2e2bcd8739ae039), {
        ref: setPopupRef,
        portal: (0, $aa72a6fdf7676c76$export$2e2bcd8739ae039),
        onEsc: mergedOptions.onEsc,
        prefixCls: prefixCls,
        popup: mergedOptions.popup,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(mergedOptions.popupClassName, alignedClassName, `${prefixCls}-unique-controlled`),
        style: mergedOptions.popupStyle,
        target: mergedOptions.target,
        open: open,
        keepDom: true,
        fresh: true,
        autoDestroy: false,
        onVisibleChanged: onVisibleChanged,
        ready: ready,
        offsetX: offsetX,
        offsetY: offsetY,
        offsetR: offsetR,
        offsetB: offsetB,
        onAlign: onAlign,
        onPrepare: onPrepare,
        onResize: (size)=>setPopupSize({
                width: size.offsetWidth,
                height: size.offsetHeight
            }),
        arrowPos: {
            x: arrowX,
            y: arrowY
        },
        align: alignInfo,
        zIndex: mergedOptions.zIndex,
        mask: mergedOptions.mask,
        arrow: mergedOptions.arrow,
        motion: mergedOptions.popupMotion,
        maskMotion: mergedOptions.maskMotion,
        getPopupContainer: mergedOptions.getPopupContainer
    }, /*#__PURE__*/ $cQmXV.createElement((0, $763024e6a8d166ec$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        isMobile: false,
        ready: ready,
        open: open,
        align: alignInfo,
        offsetR: offsetR,
        offsetB: offsetB,
        offsetX: offsetX,
        offsetY: offsetY,
        arrowPos: {
            x: arrowX,
            y: arrowY
        },
        popupSize: popupSize,
        motion: mergedOptions.popupMotion,
        uniqueContainerClassName: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(mergedOptions.uniqueContainerClassName, alignedClassName),
        uniqueContainerStyle: mergedOptions.uniqueContainerStyle
    }))));
};
var $8c1540a7f6caa2b5$export$2e2bcd8739ae039 = $8c1540a7f6caa2b5$var$UniqueProvider;



var $3h5eW = parcelRequire("3h5eW");
function $c77226a956f109d7$export$55e99723d7f71b47(PortalComponent = (0, $aa72a6fdf7676c76$export$2e2bcd8739ae039)) {
    const Trigger = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
        const { prefixCls: prefixCls = "rc-trigger-popup", children: children, action: // Action
        action = "hover", showAction: showAction, hideAction: hideAction, disabled: disabled = false, popupVisible: // Open
        popupVisible, defaultPopupVisible: defaultPopupVisible, onOpenChange: onOpenChange, afterOpenChange: afterOpenChange, onPopupVisibleChange: onPopupVisibleChange, afterPopupVisibleChange: afterPopupVisibleChange, mouseEnterDelay: // Delay
        mouseEnterDelay, mouseLeaveDelay: mouseLeaveDelay = 0.1, focusDelay: focusDelay, blurDelay: blurDelay, mask: // Mask
        mask, maskClosable: maskClosable = true, getPopupContainer: // Portal
        getPopupContainer, forceRender: forceRender, autoDestroy: autoDestroy, popup: // Popup
        popup, popupClassName: popupClassName, uniqueContainerClassName: uniqueContainerClassName, uniqueContainerStyle: uniqueContainerStyle, popupStyle: popupStyle, popupPlacement: popupPlacement, builtinPlacements: builtinPlacements = {}, popupAlign: popupAlign, zIndex: zIndex, stretch: stretch, getPopupClassNameFromAlign: getPopupClassNameFromAlign, fresh: fresh, unique: unique, alignPoint: alignPoint, onPopupClick: onPopupClick, onPopupAlign: onPopupAlign, arrow: // Arrow
        arrow, popupMotion: // Motion
        popupMotion, maskMotion: maskMotion, mobile: // Private
        mobile, ...restProps } = props;
        const mergedAutoDestroy = autoDestroy || false;
        const openUncontrolled = popupVisible === undefined;
        // =========================== Mobile ===========================
        const isMobile = !!mobile;
        // ========================== Context ===========================
        const subPopupElements = $cQmXV.useRef({});
        const parentContext = $cQmXV.useContext((0, $cfeb227ea2e5b3be$export$2e2bcd8739ae039));
        const context = $cQmXV.useMemo(()=>{
            return {
                registerSubPopup: (id, subPopupEle)=>{
                    subPopupElements.current[id] = subPopupEle;
                    parentContext?.registerSubPopup(id, subPopupEle);
                }
            };
        }, [
            parentContext
        ]);
        // ======================== UniqueContext =========================
        const uniqueContext = $cQmXV.useContext((0, $cfeb227ea2e5b3be$export$14cc6d12cdc906c));
        // =========================== Popup ============================
        const id = (0, $a2da91bb60e2cbfb$export$2e2bcd8739ae039)();
        const [popupEle, setPopupEle] = $cQmXV.useState(null);
        // Used for forwardRef popup. Not use internal
        const externalPopupRef = $cQmXV.useRef(null);
        const setPopupRef = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((node)=>{
            externalPopupRef.current = node;
            if ((0, $d3fb35d553a86e29$export$41e30d8dd0ba7a50)(node) && popupEle !== node) setPopupEle(node);
            parentContext?.registerSubPopup(id, node);
        });
        // =========================== Target ===========================
        // Use state to control here since `useRef` update not trigger render
        const [targetEle, setTargetEle] = $cQmXV.useState(null);
        // Used for forwardRef target. Not use internal
        const externalForwardRef = $cQmXV.useRef(null);
        const setTargetRef = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((node)=>{
            const domNode = (0, $d3fb35d553a86e29$export$9aa546fdc20ae5b3)(node);
            if ((0, $d3fb35d553a86e29$export$41e30d8dd0ba7a50)(domNode) && targetEle !== domNode) {
                setTargetEle(domNode);
                externalForwardRef.current = domNode;
            }
        });
        const cloneProps = {};
        const inPopupOrChild = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((ele)=>{
            const childDOM = targetEle;
            return childDOM?.contains(ele) || (0, $7b66ec1d5ddc0bd4$export$70e8259662bb498b)(childDOM)?.host === ele || ele === childDOM || popupEle?.contains(ele) || (0, $7b66ec1d5ddc0bd4$export$70e8259662bb498b)(popupEle)?.host === ele || ele === popupEle || Object.values(subPopupElements.current).some((subPopupEle)=>subPopupEle?.contains(ele) || ele === subPopupEle);
        });
        // =========================== Arrow ============================
        const innerArrow = arrow ? {
            // true and Object likely
            ...arrow !== true ? arrow : {}
        } : null;
        // ============================ Open ============================
        const [internalOpen, setInternalOpen] = (0, $a51866d781137e08$export$2e2bcd8739ae039)(defaultPopupVisible || false, popupVisible);
        const rawOpen = internalOpen || false;
        const mergedOpen = rawOpen && !disabled;
        // ========================== Children ==========================
        const child = $cQmXV.useMemo(()=>{
            const nextChild = typeof children === "function" ? children({
                open: mergedOpen
            }) : children;
            return $cQmXV.Children.only(nextChild);
        }, [
            children,
            mergedOpen
        ]);
        const originChildProps = child?.props || {};
        // Support ref
        const isOpen = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)(()=>mergedOpen);
        // Extract common options for UniqueProvider
        const getUniqueOptions = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((delay = 0)=>({
                popup: popup,
                target: targetEle,
                delay: delay,
                prefixCls: prefixCls,
                popupClassName: popupClassName,
                uniqueContainerClassName: uniqueContainerClassName,
                uniqueContainerStyle: uniqueContainerStyle,
                popupStyle: popupStyle,
                popupPlacement: popupPlacement,
                builtinPlacements: builtinPlacements,
                popupAlign: popupAlign,
                zIndex: zIndex,
                mask: mask,
                maskClosable: maskClosable,
                popupMotion: popupMotion,
                maskMotion: maskMotion,
                arrow: innerArrow,
                getPopupContainer: getPopupContainer,
                getPopupClassNameFromAlign: getPopupClassNameFromAlign,
                id: id,
                onEsc: onEsc
            }));
        // Handle controlled state changes for UniqueProvider
        // Only sync to UniqueProvider when it's controlled mode
        // If there is a parentContext, don't call uniqueContext methods
        (0, $7673d874dab69d07$export$2e2bcd8739ae039)(()=>{
            if (uniqueContext && unique && targetEle && !openUncontrolled && !parentContext) {
                if (mergedOpen) uniqueContext.show(getUniqueOptions(mouseEnterDelay), isOpen);
                else uniqueContext.hide(mouseLeaveDelay);
            }
        }, [
            mergedOpen,
            targetEle
        ]);
        const openRef = $cQmXV.useRef(mergedOpen);
        openRef.current = mergedOpen;
        const internalTriggerOpen = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((nextOpen)=>{
            (0, $3h5eW.flushSync)(()=>{
                if (rawOpen !== nextOpen) {
                    setInternalOpen(nextOpen);
                    onOpenChange?.(nextOpen);
                    onPopupVisibleChange?.(nextOpen);
                }
            });
        });
        // Trigger for delay
        const delayInvoke = (0, $b8a63d9f6aead508$export$2e2bcd8739ae039)();
        const triggerOpen = (nextOpen, delay = 0)=>{
            // If it's controlled mode, always use internal trigger logic
            // UniqueProvider will be synced through useLayoutEffect
            if (popupVisible !== undefined) {
                delayInvoke(()=>{
                    internalTriggerOpen(nextOpen);
                }, delay);
                return;
            }
            // If UniqueContext exists and not controlled, pass delay to Provider instead of handling it internally
            // If there is a parentContext, don't call uniqueContext methods
            if (uniqueContext && unique && openUncontrolled && !parentContext) {
                if (nextOpen) uniqueContext.show(getUniqueOptions(delay), isOpen);
                else uniqueContext.hide(delay);
                return;
            }
            delayInvoke(()=>{
                internalTriggerOpen(nextOpen);
            }, delay);
        };
        function onEsc({ top: top }) {
            if (top) triggerOpen(false);
        }
        // ========================== Motion ============================
        const [inMotion, setInMotion] = $cQmXV.useState(false);
        (0, $7673d874dab69d07$export$2e2bcd8739ae039)((firstMount)=>{
            if (!firstMount || mergedOpen) setInMotion(true);
        }, [
            mergedOpen
        ]);
        const [motionPrepareResolve, setMotionPrepareResolve] = $cQmXV.useState(null);
        // =========================== Align ============================
        const [mousePos, setMousePos] = $cQmXV.useState(null);
        const setMousePosByEvent = (event)=>{
            setMousePos([
                event.clientX,
                event.clientY
            ]);
        };
        const [ready, offsetX, offsetY, offsetR, offsetB, arrowX, arrowY, scaleX, scaleY, alignInfo, onAlign] = (0, $622d35b035865dbb$export$2e2bcd8739ae039)(mergedOpen, popupEle, alignPoint && mousePos !== null ? mousePos : targetEle, popupPlacement, builtinPlacements, popupAlign, onPopupAlign, isMobile);
        const [showActions, hideActions] = (0, $95272f42763935fc$export$2e2bcd8739ae039)(action, showAction, hideAction);
        const clickToShow = showActions.has("click");
        const clickToHide = hideActions.has("click") || hideActions.has("contextMenu");
        const triggerAlign = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)(()=>{
            if (!inMotion) onAlign();
        });
        const onScroll = ()=>{
            if (openRef.current && alignPoint && clickToHide) triggerOpen(false);
        };
        (0, $05c8bee7852a4271$export$2e2bcd8739ae039)(mergedOpen, targetEle, popupEle, triggerAlign, onScroll);
        (0, $7673d874dab69d07$export$2e2bcd8739ae039)(()=>{
            triggerAlign();
        }, [
            mousePos,
            popupPlacement
        ]);
        // When no builtinPlacements and popupAlign changed
        (0, $7673d874dab69d07$export$2e2bcd8739ae039)(()=>{
            if (mergedOpen && !builtinPlacements?.[popupPlacement]) triggerAlign();
        }, [
            JSON.stringify(popupAlign)
        ]);
        const alignedClassName = $cQmXV.useMemo(()=>{
            const baseClassName = (0, $2cce73f2a40e27d4$export$faa0aa8ed2fe6432)(builtinPlacements, prefixCls, alignInfo, alignPoint);
            return (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(baseClassName, getPopupClassNameFromAlign?.(alignInfo));
        }, [
            alignInfo,
            getPopupClassNameFromAlign,
            builtinPlacements,
            prefixCls,
            alignPoint
        ]);
        // ============================ Refs ============================
        $cQmXV.useImperativeHandle(ref, ()=>({
                nativeElement: externalForwardRef.current,
                popupElement: externalPopupRef.current,
                forceAlign: triggerAlign
            }));
        // ========================== Stretch ===========================
        const [targetWidth, setTargetWidth] = $cQmXV.useState(0);
        const [targetHeight, setTargetHeight] = $cQmXV.useState(0);
        const syncTargetSize = ()=>{
            if (stretch && targetEle) {
                const rect = targetEle.getBoundingClientRect();
                setTargetWidth(rect.width);
                setTargetHeight(rect.height);
            }
        };
        const onTargetResize = ()=>{
            syncTargetSize();
            triggerAlign();
        };
        // ========================== Motion ============================
        const onVisibleChanged = (visible)=>{
            setInMotion(false);
            onAlign();
            afterOpenChange?.(visible);
            afterPopupVisibleChange?.(visible);
        };
        // We will trigger align when motion is in prepare
        const onPrepare = ()=>new Promise((resolve)=>{
                syncTargetSize();
                setMotionPrepareResolve(()=>resolve);
            });
        (0, $7673d874dab69d07$export$2e2bcd8739ae039)(()=>{
            if (motionPrepareResolve) {
                onAlign();
                motionPrepareResolve();
                setMotionPrepareResolve(null);
            }
        }, [
            motionPrepareResolve
        ]);
        // =========================== Action ===========================
        /**
     * Util wrapper for trigger action
     * @param eventName  Listen event name
     * @param nextOpen  Next open state after trigger
     * @param delay Delay to trigger open change
     * @param callback Callback if current event need additional action
     * @param ignoreCheck  Ignore current event if check return true
     */ function wrapperAction(eventName, nextOpen, delay, callback, ignoreCheck) {
            cloneProps[eventName] = (event, ...args)=>{
                if (!ignoreCheck || !ignoreCheck()) {
                    callback?.(event);
                    triggerOpen(nextOpen, delay);
                }
                // Pass to origin
                originChildProps[eventName]?.(event, ...args);
            };
        }
        // ======================= Action: Touch ========================
        const touchToShow = showActions.has("touch");
        const touchToHide = hideActions.has("touch");
        /** Used for prevent `hover` event conflict with mobile env */ const touchedRef = $cQmXV.useRef(false);
        if (touchToShow || touchToHide) cloneProps.onTouchStart = (...args)=>{
            touchedRef.current = true;
            if (openRef.current && touchToHide) triggerOpen(false);
            else if (!openRef.current && touchToShow) triggerOpen(true);
            // Pass to origin
            originChildProps.onTouchStart?.(...args);
        };
        // ======================= Action: Click ========================
        if (clickToShow || clickToHide) cloneProps.onClick = (event, ...args)=>{
            if (openRef.current && clickToHide) triggerOpen(false);
            else if (!openRef.current && clickToShow) {
                setMousePosByEvent(event);
                triggerOpen(true);
            }
            // Pass to origin
            originChildProps.onClick?.(event, ...args);
            touchedRef.current = false;
        };
        // Click to hide is special action since click popup element should not hide
        const onPopupPointerDown = (0, $faca169b1695cd10$export$2e2bcd8739ae039)(mergedOpen, clickToHide || touchToHide, targetEle, popupEle, mask, maskClosable, inPopupOrChild, triggerOpen);
        // ======================= Action: Hover ========================
        const hoverToShow = showActions.has("hover");
        const hoverToHide = hideActions.has("hover");
        let onPopupMouseEnter;
        let onPopupMouseLeave;
        const ignoreMouseTrigger = ()=>{
            return touchedRef.current;
        };
        if (hoverToShow) {
            const onMouseEnterCallback = (event)=>{
                setMousePosByEvent(event);
            };
            // Compatible with old browser which not support pointer event
            wrapperAction("onMouseEnter", true, mouseEnterDelay, onMouseEnterCallback, ignoreMouseTrigger);
            wrapperAction("onPointerEnter", true, mouseEnterDelay, onMouseEnterCallback, ignoreMouseTrigger);
            onPopupMouseEnter = (event)=>{
                // Only trigger re-open when popup is visible
                if ((mergedOpen || inMotion) && popupEle?.contains(event.target)) triggerOpen(true, mouseEnterDelay);
            };
            // Align Point
            if (alignPoint) cloneProps.onMouseMove = (event)=>{
                originChildProps.onMouseMove?.(event);
            };
        }
        if (hoverToHide) {
            wrapperAction("onMouseLeave", false, mouseLeaveDelay, undefined, ignoreMouseTrigger);
            wrapperAction("onPointerLeave", false, mouseLeaveDelay, undefined, ignoreMouseTrigger);
            onPopupMouseLeave = ()=>{
                triggerOpen(false, mouseLeaveDelay);
            };
        }
        // ======================= Action: Focus ========================
        if (showActions.has("focus")) wrapperAction("onFocus", true, focusDelay);
        if (hideActions.has("focus")) wrapperAction("onBlur", false, blurDelay);
        // ==================== Action: ContextMenu =====================
        if (showActions.has("contextMenu")) cloneProps.onContextMenu = (event, ...args)=>{
            if (openRef.current && hideActions.has("contextMenu")) triggerOpen(false);
            else {
                setMousePosByEvent(event);
                triggerOpen(true);
            }
            event.preventDefault();
            // Pass to origin
            originChildProps.onContextMenu?.(event, ...args);
        };
        // ============================ Perf ============================
        const rendedRef = $cQmXV.useRef(false);
        rendedRef.current ||= forceRender || mergedOpen || inMotion;
        // =========================== Render ===========================
        const mergedChildrenProps = {
            ...originChildProps,
            ...cloneProps
        };
        // Pass props into cloneProps for nest usage
        const passedProps = {};
        const passedEventList = [
            "onContextMenu",
            "onClick",
            "onMouseDown",
            "onTouchStart",
            "onMouseEnter",
            "onMouseLeave",
            "onFocus",
            "onBlur"
        ];
        passedEventList.forEach((eventName)=>{
            if (restProps[eventName]) passedProps[eventName] = (...args)=>{
                mergedChildrenProps[eventName]?.(...args);
                restProps[eventName](...args);
            };
        });
        const arrowPos = {
            x: arrowX,
            y: arrowY
        };
        // =================== Resize Observer ===================
        // Use hook to observe target element resize
        // Pass targetEle directly instead of a function so the hook will re-observe when target changes
        (0, $341bf970f445a7e3$export$2e2bcd8739ae039)(mergedOpen, targetEle, onTargetResize);
        // Compose refs
        const mergedRef = (0, $10341b937b26f69d$export$1d1c999670a1285d)(setTargetRef, (0, $10341b937b26f69d$export$7465e5c0bf44f19a)(child));
        // Child Node
        const triggerNode = /*#__PURE__*/ $cQmXV.cloneElement(child, {
            ...mergedChildrenProps,
            ...passedProps,
            ref: mergedRef
        });
        // Render
        return /*#__PURE__*/ $cQmXV.createElement($cQmXV.Fragment, null, triggerNode, rendedRef.current && (!uniqueContext || !unique) && /*#__PURE__*/ $cQmXV.createElement((0, $cfeb227ea2e5b3be$export$2e2bcd8739ae039).Provider, {
            value: context
        }, /*#__PURE__*/ $cQmXV.createElement((0, $221bf3c16aa8f63b$export$2e2bcd8739ae039), {
            portal: PortalComponent,
            ref: setPopupRef,
            prefixCls: prefixCls,
            popup: popup,
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(popupClassName, !isMobile && alignedClassName),
            style: popupStyle,
            target: targetEle,
            onMouseEnter: onPopupMouseEnter,
            onMouseLeave: onPopupMouseLeave,
            onPointerEnter: onPopupMouseEnter,
            zIndex: zIndex,
            open: mergedOpen,
            keepDom: inMotion,
            fresh: fresh,
            onClick: onPopupClick,
            onPointerDownCapture: onPopupPointerDown,
            mask: mask,
            motion: popupMotion,
            maskMotion: maskMotion,
            onVisibleChanged: onVisibleChanged,
            onPrepare: onPrepare,
            forceRender: forceRender,
            autoDestroy: mergedAutoDestroy,
            getPopupContainer: getPopupContainer,
            onEsc: onEsc,
            align: alignInfo,
            arrow: innerArrow,
            arrowPos: arrowPos,
            ready: ready,
            offsetX: offsetX,
            offsetY: offsetY,
            offsetR: offsetR,
            offsetB: offsetB,
            onAlign: triggerAlign,
            stretch: stretch,
            targetWidth: targetWidth / scaleX,
            targetHeight: targetHeight / scaleY,
            mobile: mobile
        })));
    });
    return Trigger;
}
var $c77226a956f109d7$export$2e2bcd8739ae039 = $c77226a956f109d7$export$55e99723d7f71b47((0, $aa72a6fdf7676c76$export$2e2bcd8739ae039));




var $cQmXV = parcelRequire("cQmXV");



var $cQmXV = parcelRequire("cQmXV");

function $a91ef204d03d8eec$export$9522e17588c12572(child) {
    return child && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).isValidElement(child) && child.type === (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Fragment;
}
const $a91ef204d03d8eec$export$2dfe578f95754f6a = (element, replacement, props)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).isValidElement(element)) return replacement;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).cloneElement(element, (0, $8e2d153a3c855782$export$f6e2535fb5126e54)(props) ? props(element.props || {}) : props);
};
function $a91ef204d03d8eec$export$e530037191fcd5d7(element, props) {
    return $a91ef204d03d8eec$export$2dfe578f95754f6a(element, element, props);
}



var $cQmXV = parcelRequire("cQmXV");
const $82ffd17441b57982$export$e4ec87ea71f29b41 = "ant";
const $82ffd17441b57982$export$eaca8ee5ed21b4e9 = "anticon";
const $82ffd17441b57982$export$fa216ce2679a073b = [
    "outlined",
    "borderless",
    "filled",
    "underlined"
];
const $82ffd17441b57982$var$defaultGetPrefixCls = (suffixCls, customizePrefixCls)=>{
    if (customizePrefixCls) return customizePrefixCls;
    return suffixCls ? `${$82ffd17441b57982$export$e4ec87ea71f29b41}-${suffixCls}` : $82ffd17441b57982$export$e4ec87ea71f29b41;
};
const $82ffd17441b57982$export$a92f85ab3e9ad68b = /*#__PURE__*/ $cQmXV.createContext({
    // We provide a default function for Context without provider
    getPrefixCls: $82ffd17441b57982$var$defaultGetPrefixCls,
    iconPrefixCls: $82ffd17441b57982$export$eaca8ee5ed21b4e9
});
const { Consumer: $82ffd17441b57982$export$cd5442f2b8da7663 } = $82ffd17441b57982$export$a92f85ab3e9ad68b;
const $82ffd17441b57982$var$EMPTY_OBJECT = {};
function $82ffd17441b57982$export$46f4bd6436a25a31(propName) {
    const context = $cQmXV.useContext($82ffd17441b57982$export$a92f85ab3e9ad68b);
    const { getPrefixCls: getPrefixCls, direction: direction, getPopupContainer: getPopupContainer, renderEmpty: renderEmpty } = context;
    const propValue = context[propName];
    return {
        classNames: $82ffd17441b57982$var$EMPTY_OBJECT,
        styles: $82ffd17441b57982$var$EMPTY_OBJECT,
        ...propValue,
        getPrefixCls: getPrefixCls,
        direction: direction,
        getPopupContainer: getPopupContainer,
        renderEmpty: renderEmpty
    };
}


"use client";
const $9cafb838145f1c41$var$MotionContent = ({ children: children })=>{
    const { getPrefixCls: getPrefixCls } = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useContext((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    const rootPrefixCls = getPrefixCls();
    // This will never reach since we will not render this when no children
    /* istanbul ignore next */ if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).isValidElement(children)) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $04c53b89814950f8$export$2e2bcd8739ae039), {
        visible: true,
        motionName: `${rootPrefixCls}-fade`,
        motionAppear: true,
        motionEnter: true,
        motionLeave: false,
        removeOnLeave: false
    }, ({ style: motionStyle, className: motionClassName })=>{
        return (0, $a91ef204d03d8eec$export$e530037191fcd5d7)(children, (oriProps)=>({
                className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(oriProps.className, motionClassName),
                style: {
                    ...oriProps.style,
                    ...motionStyle
                }
            }));
    });
};
var $9cafb838145f1c41$export$2e2bcd8739ae039 = $9cafb838145f1c41$var$MotionContent;


"use client";
const $4271d9f55cb3799b$var$cachedPlacements = [
    null,
    null
];
function $4271d9f55cb3799b$var$uniqueBuiltinPlacements(ori) {
    if ($4271d9f55cb3799b$var$cachedPlacements[0] !== ori) {
        const target = {};
        Object.keys(ori).forEach((placement)=>{
            target[placement] = {
                ...ori[placement],
                dynamicInset: false
            };
        });
        $4271d9f55cb3799b$var$cachedPlacements[0] = ori;
        $4271d9f55cb3799b$var$cachedPlacements[1] = target;
    }
    return $4271d9f55cb3799b$var$cachedPlacements[1];
}
const $4271d9f55cb3799b$var$UniqueProvider = ({ children: children })=>{
    const renderPopup = (options)=>{
        const { id: id, builtinPlacements: builtinPlacements, popup: popup } = options;
        const popupEle = (0, $8e2d153a3c855782$export$f6e2535fb5126e54)(popup) ? popup() : popup;
        const parsedPlacements = $4271d9f55cb3799b$var$uniqueBuiltinPlacements(builtinPlacements);
        return {
            ...options,
            getPopupContainer: null,
            arrow: false,
            popup: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $9cafb838145f1c41$export$2e2bcd8739ae039), {
                key: id
            }, popupEle),
            builtinPlacements: parsedPlacements
        };
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $8c1540a7f6caa2b5$export$2e2bcd8739ae039), {
        postTriggerProps: renderPopup
    }, children);
};
var $4271d9f55cb3799b$export$2e2bcd8739ae039 = $4271d9f55cb3799b$var$UniqueProvider;




var $cQmXV = parcelRequire("cQmXV");
"use client";
const $4f0e1ea30330557c$var$DisabledContext = /*#__PURE__*/ $cQmXV.createContext(false);
const $4f0e1ea30330557c$export$6adb5f3b918b11bb = ({ children: children, disabled: disabled })=>{
    const originDisabled = $cQmXV.useContext($4f0e1ea30330557c$var$DisabledContext);
    return /*#__PURE__*/ $cQmXV.createElement($4f0e1ea30330557c$var$DisabledContext.Provider, {
        value: disabled ?? originDisabled
    }, children);
};
var $4f0e1ea30330557c$export$2e2bcd8739ae039 = $4f0e1ea30330557c$var$DisabledContext;



var $cQmXV = parcelRequire("cQmXV");


var $cQmXV = parcelRequire("cQmXV");
"use client";
const $767e8ef819e95b6d$var$SizeContext = /*#__PURE__*/ $cQmXV.createContext(undefined);
const $767e8ef819e95b6d$export$dbc92d89fabc8ebe = ({ children: children, size: size })=>{
    const originSize = $cQmXV.useContext($767e8ef819e95b6d$var$SizeContext);
    return /*#__PURE__*/ $cQmXV.createElement($767e8ef819e95b6d$var$SizeContext.Provider, {
        value: size || originSize
    }, children);
};
var $767e8ef819e95b6d$export$2e2bcd8739ae039 = $767e8ef819e95b6d$var$SizeContext;


function $e728fd34be248c9d$var$useConfig() {
    const componentDisabled = (0, $cQmXV.useContext)((0, $4f0e1ea30330557c$export$2e2bcd8739ae039));
    const componentSize = (0, $cQmXV.useContext)((0, $767e8ef819e95b6d$export$2e2bcd8739ae039));
    return {
        componentDisabled: componentDisabled,
        componentSize: componentSize
    };
}
var $e728fd34be248c9d$export$2e2bcd8739ae039 = $e728fd34be248c9d$var$useConfig;



var $cQmXV = parcelRequire("cQmXV");




function $d9452c6466030853$export$2e2bcd8739ae039(theme, parentTheme, config) {
    const warning = (0, $b5822acdae823465$export$cf977aa92c751e61)("ConfigProvider");
    const themeConfig = theme || {};
    const parentThemeConfig = themeConfig.inherit === false || !parentTheme ? {
        ...(0, $284e1db1c3fa1faa$export$f84bd70098573c5c),
        hashed: parentTheme?.hashed ?? (0, $284e1db1c3fa1faa$export$f84bd70098573c5c).hashed,
        cssVar: parentTheme?.cssVar
    } : parentTheme;
    // Generate a unique key for cssVar
    const themeKey = (0, $cQmXV.useId)();
    return (0, $d627c2941353b4cb$export$2e2bcd8739ae039)(()=>{
        if (!theme) return parentTheme;
        // Override
        const mergedComponents = {
            ...parentThemeConfig.components
        };
        Object.keys(theme.components || {}).forEach((componentName)=>{
            mergedComponents[componentName] = {
                ...mergedComponents[componentName],
                ...theme.components[componentName]
            };
        });
        const cssVarKey = `css-var-${themeKey.replace(/:/g, "")}`;
        const mergedCssVar = {
            prefix: config?.prefixCls,
            // Same as prefixCls by default
            ...parentThemeConfig.cssVar,
            ...themeConfig.cssVar,
            key: themeConfig.cssVar?.key || cssVarKey
        };
        // Base token
        return {
            ...parentThemeConfig,
            ...themeConfig,
            token: {
                ...parentThemeConfig.token,
                ...themeConfig.token
            },
            components: mergedComponents,
            cssVar: mergedCssVar
        };
    }, [
        themeConfig,
        parentThemeConfig,
        config?.prefixCls,
        themeKey
    ], (prev, next)=>prev.some((prevTheme, index)=>{
            const nextTheme = next[index];
            return !(0, $3f19ee2a2ff4618a$export$2e2bcd8739ae039)(prevTheme, nextTheme, true);
        }));
}



var $cQmXV = parcelRequire("cQmXV");


var $cQmXV = parcelRequire("cQmXV");


var $c2c45a270a7fff44$export$2e2bcd8739ae039 = "6.6.0";


"use client";
var $3611500093ef25eb$export$2e2bcd8739ae039 = (0, $c2c45a270a7fff44$export$2e2bcd8739ae039);







function $5d4592d59e730fdd$var$isStableColor(color) {
    return color >= 0 && color <= 255;
}
function $5d4592d59e730fdd$var$getAlphaColor(frontColor, backgroundColor) {
    const { r: fR, g: fG, b: fB, a: originAlpha } = new (0, $3bb84f07fb2a2f32$export$2c4f38d6c0ecc25a)(frontColor).toRgb();
    if (originAlpha < 1) return frontColor;
    const { r: bR, g: bG, b: bB } = new (0, $3bb84f07fb2a2f32$export$2c4f38d6c0ecc25a)(backgroundColor).toRgb();
    for(let fA = 0.01; fA <= 1; fA += 0.01){
        const r = Math.round((fR - bR * (1 - fA)) / fA);
        const g = Math.round((fG - bG * (1 - fA)) / fA);
        const b = Math.round((fB - bB * (1 - fA)) / fA);
        if ($5d4592d59e730fdd$var$isStableColor(r) && $5d4592d59e730fdd$var$isStableColor(g) && $5d4592d59e730fdd$var$isStableColor(b)) return new (0, $3bb84f07fb2a2f32$export$2c4f38d6c0ecc25a)({
            r: r,
            g: g,
            b: b,
            a: Math.round(fA * 100) / 100
        }).toRgbString();
    }
    // fallback
    /* istanbul ignore next */ return new (0, $3bb84f07fb2a2f32$export$2c4f38d6c0ecc25a)({
        r: fR,
        g: fG,
        b: fB,
        a: 1
    }).toRgbString();
}
var $5d4592d59e730fdd$export$2e2bcd8739ae039 = $5d4592d59e730fdd$var$getAlphaColor;


function $bc580b75618d9ea5$export$2e2bcd8739ae039(derivativeToken) {
    const { override: override, ...restToken } = derivativeToken;
    const overrideTokens = {
        ...override
    };
    Object.keys((0, $84fac8c8876d9d5c$export$2e2bcd8739ae039)).forEach((token)=>{
        delete overrideTokens[token];
    });
    const mergedToken = {
        ...restToken,
        ...overrideTokens
    };
    const shadowBaseColor = new (0, $3bb84f07fb2a2f32$export$2c4f38d6c0ecc25a)(mergedToken.colorShadow);
    const shadowBaseAlpha = shadowBaseColor.a;
    const getShadowColor = (alpha)=>shadowBaseColor.clone().setA(shadowBaseAlpha * alpha).toRgbString();
    const screenXS = 480;
    const screenSM = 576;
    const screenMD = 768;
    const screenLG = 992;
    const screenXL = 1200;
    const screenXXL = 1600;
    const screenXXXL = 1920;
    // Motion
    if (mergedToken.motion === false) {
        const fastDuration = "0s";
        mergedToken.motionDurationFast = fastDuration;
        mergedToken.motionDurationMid = fastDuration;
        mergedToken.motionDurationSlow = fastDuration;
    }
    // Generate alias token
    const aliasToken = {
        ...mergedToken,
        // ============== Background ============== //
        colorFillContent: mergedToken.colorFillSecondary,
        colorFillContentHover: mergedToken.colorFill,
        colorFillAlter: mergedToken.colorFillQuaternary,
        colorBgContainerDisabled: mergedToken.colorFillTertiary,
        // ============== Split ============== //
        colorBorderBg: mergedToken.colorBgContainer,
        colorSplit: (0, $5d4592d59e730fdd$export$2e2bcd8739ae039)(mergedToken.colorBorderSecondary, mergedToken.colorBgContainer),
        // ============== Text ============== //
        colorTextPlaceholder: mergedToken.colorTextQuaternary,
        colorTextDisabled: mergedToken.colorTextQuaternary,
        colorTextHeading: mergedToken.colorText,
        colorTextLabel: mergedToken.colorTextSecondary,
        colorTextDescription: mergedToken.colorTextTertiary,
        colorTextLightSolid: mergedToken.colorWhite,
        colorHighlight: mergedToken.colorError,
        colorBgTextHover: mergedToken.colorFillSecondary,
        colorBgTextActive: mergedToken.colorFill,
        colorIcon: mergedToken.colorTextTertiary,
        colorIconHover: mergedToken.colorText,
        colorErrorOutline: (0, $5d4592d59e730fdd$export$2e2bcd8739ae039)(mergedToken.colorErrorBg, mergedToken.colorBgContainer),
        colorWarningOutline: (0, $5d4592d59e730fdd$export$2e2bcd8739ae039)(mergedToken.colorWarningBg, mergedToken.colorBgContainer),
        colorErrorAffix: mergedToken.colorError,
        colorWarningAffix: mergedToken.colorWarning,
        // Font
        fontSizeIcon: mergedToken.fontSizeSM,
        // Line
        lineWidthFocus: mergedToken.focusOutline === false ? 0 : mergedToken.lineWidth * 3,
        // Control
        lineWidth: mergedToken.lineWidth,
        controlOutlineWidth: mergedToken.lineWidth * 2,
        // Checkbox size and expand icon size
        controlInteractiveSize: mergedToken.controlHeight / 2,
        controlItemBgHover: mergedToken.colorFillTertiary,
        controlItemBgActive: mergedToken.colorPrimaryBg,
        controlItemBgActiveHover: mergedToken.colorPrimaryBgHover,
        controlItemBgActiveDisabled: mergedToken.colorFill,
        controlTmpOutline: mergedToken.colorFillQuaternary,
        controlOutline: (0, $5d4592d59e730fdd$export$2e2bcd8739ae039)(mergedToken.colorPrimaryBg, mergedToken.colorBgContainer),
        lineType: mergedToken.lineType,
        borderRadius: mergedToken.borderRadius,
        borderRadiusXS: mergedToken.borderRadiusXS,
        borderRadiusSM: mergedToken.borderRadiusSM,
        borderRadiusLG: mergedToken.borderRadiusLG,
        fontWeightStrong: 600,
        opacityLoading: 0.65,
        linkDecoration: "none",
        linkHoverDecoration: "none",
        linkFocusDecoration: "none",
        controlPaddingHorizontal: 12,
        controlPaddingHorizontalSM: 8,
        paddingXXS: mergedToken.sizeXXS,
        paddingXS: mergedToken.sizeXS,
        paddingSM: mergedToken.sizeSM,
        padding: mergedToken.size,
        paddingMD: mergedToken.sizeMD,
        paddingLG: mergedToken.sizeLG,
        paddingXL: mergedToken.sizeXL,
        paddingContentHorizontalLG: mergedToken.sizeLG,
        paddingContentVerticalLG: mergedToken.sizeMS,
        paddingContentHorizontal: mergedToken.sizeMS,
        paddingContentVertical: mergedToken.sizeSM,
        paddingContentHorizontalSM: mergedToken.size,
        paddingContentVerticalSM: mergedToken.sizeXS,
        marginXXS: mergedToken.sizeXXS,
        marginXS: mergedToken.sizeXS,
        marginSM: mergedToken.sizeSM,
        margin: mergedToken.size,
        marginMD: mergedToken.sizeMD,
        marginLG: mergedToken.sizeLG,
        marginXL: mergedToken.sizeXL,
        marginXXL: mergedToken.sizeXXL,
        boxShadow: `
      0 6px 16px 0 ${getShadowColor(0.08)},
      0 3px 6px -4px ${getShadowColor(0.12)},
      0 9px 28px 8px ${getShadowColor(0.05)}
    `,
        boxShadowSecondary: `
      0 6px 16px 0 ${getShadowColor(0.08)},
      0 3px 6px -4px ${getShadowColor(0.12)},
      0 9px 28px 8px ${getShadowColor(0.05)}
    `,
        boxShadowTertiary: `
      0 1px 2px 0 ${getShadowColor(0.05)},
      0 1px 6px -1px ${getShadowColor(0.03)},
      0 2px 4px 0 ${getShadowColor(0.03)}
    `,
        screenXS: screenXS,
        screenXSMin: screenXS,
        screenXSMax: screenSM - 1,
        screenSM: screenSM,
        screenSMMin: screenSM,
        screenSMMax: screenMD - 1,
        screenMD: screenMD,
        screenMDMin: screenMD,
        screenMDMax: screenLG - 1,
        screenLG: screenLG,
        screenLGMin: screenLG,
        screenLGMax: screenXL - 1,
        screenXL: screenXL,
        screenXLMin: screenXL,
        screenXLMax: screenXXL - 1,
        screenXXL: screenXXL,
        screenXXLMin: screenXXL,
        screenXXLMax: screenXXXL - 1,
        screenXXXL: screenXXXL,
        screenXXXLMin: screenXXXL,
        boxShadowPopoverArrow: `2px 2px 5px ${getShadowColor(0.05)}`,
        dropShadowPopover: `drop-shadow(0 6px 16px ${getShadowColor(0.08)}) drop-shadow(0 3px 6px ${getShadowColor(0.12)}) drop-shadow(0 9px 28px ${getShadowColor(0.05)})`,
        boxShadowCard: `
      0 1px 2px -2px ${getShadowColor(0.16)},
      0 3px 6px 0 ${getShadowColor(0.12)},
      0 5px 12px 4px ${getShadowColor(0.09)}
    `,
        boxShadowDrawerRight: `
      -6px 0 16px 0 ${getShadowColor(0.08)},
      -3px 0 6px -4px ${getShadowColor(0.12)},
      -9px 0 28px 8px ${getShadowColor(0.05)}
    `,
        boxShadowDrawerLeft: `
      6px 0 16px 0 ${getShadowColor(0.08)},
      3px 0 6px -4px ${getShadowColor(0.12)},
      9px 0 28px 8px ${getShadowColor(0.05)}
    `,
        boxShadowDrawerUp: `
      0 6px 16px 0 ${getShadowColor(0.08)},
      0 3px 6px -4px ${getShadowColor(0.12)},
      0 9px 28px 8px ${getShadowColor(0.05)}
    `,
        boxShadowDrawerDown: `
      0 -6px 16px 0 ${getShadowColor(0.08)},
      0 -3px 6px -4px ${getShadowColor(0.12)},
      0 -9px 28px 8px ${getShadowColor(0.05)}
    `,
        boxShadowTabsOverflowLeft: `inset 10px 0 8px -8px ${getShadowColor(0.08)}`,
        boxShadowTabsOverflowRight: `inset -10px 0 8px -8px ${getShadowColor(0.08)}`,
        boxShadowTabsOverflowTop: `inset 0 10px 8px -8px ${getShadowColor(0.08)}`,
        boxShadowTabsOverflowBottom: `inset 0 -10px 8px -8px ${getShadowColor(0.08)}`,
        // Override AliasToken
        ...overrideTokens
    };
    return aliasToken;
}


const $b22e03a54a548614$export$c6b9faa6b723d31a = {
    lineHeight: true,
    lineHeightSM: true,
    lineHeightLG: true,
    lineHeightHeading1: true,
    lineHeightHeading2: true,
    lineHeightHeading3: true,
    lineHeightHeading4: true,
    lineHeightHeading5: true,
    opacityLoading: true,
    fontWeightStrong: true,
    zIndexPopupBase: true,
    zIndexBase: true,
    opacityImage: true
};
const $b22e03a54a548614$export$738b109e247a462c = {
    motionBase: true,
    motionUnit: true
};
const $b22e03a54a548614$var$preserve = {
    screenXS: true,
    screenXSMin: true,
    screenXSMax: true,
    screenSM: true,
    screenSMMin: true,
    screenSMMax: true,
    screenMD: true,
    screenMDMin: true,
    screenMDMax: true,
    screenLG: true,
    screenLGMin: true,
    screenLGMax: true,
    screenXL: true,
    screenXLMin: true,
    screenXLMax: true,
    screenXXL: true,
    screenXXLMin: true,
    screenXXLMax: true,
    screenXXXL: true,
    screenXXXLMin: true
};
const $b22e03a54a548614$export$18602cb46ae80b62 = (originToken, overrideToken, theme)=>{
    const derivativeToken = theme.getDerivativeToken(originToken);
    const { override: override, ...components } = overrideToken;
    // Merge with override
    let mergedDerivativeToken = {
        ...derivativeToken,
        override: override
    };
    // Format if needed
    mergedDerivativeToken = (0, $bc580b75618d9ea5$export$2e2bcd8739ae039)(mergedDerivativeToken);
    if (components) Object.entries(components).forEach(([key, value])=>{
        const { theme: componentTheme, ...componentTokens } = value;
        let mergedComponentToken = componentTokens;
        if (componentTheme) mergedComponentToken = $b22e03a54a548614$export$18602cb46ae80b62({
            ...mergedDerivativeToken,
            ...componentTokens
        }, {
            override: componentTokens
        }, componentTheme);
        mergedDerivativeToken[key] = mergedComponentToken;
    });
    return mergedDerivativeToken;
};
function $b22e03a54a548614$export$2e2bcd8739ae039() {
    const { token: rootDesignToken, hashed: hashed, theme: theme, override: override, cssVar: ctxCssVar, zeroRuntime: zeroRuntime } = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useContext((0, $284e1db1c3fa1faa$export$69b0ebb9efcddb30));
    const { csp: csp, getPrefixCls: getPrefixCls } = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useContext((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    const cssVar = {
        prefix: ctxCssVar?.prefix ?? getPrefixCls(),
        key: ctxCssVar?.key ?? "css-var-root"
    };
    const salt = `${(0, $3611500093ef25eb$export$2e2bcd8739ae039)}-${hashed || ""}`;
    const mergedTheme = theme || (0, $3fc6617fc53b3959$export$2e2bcd8739ae039);
    const [token, hashId, realToken] = (0, $5a9aa371498f42c7$export$2e2bcd8739ae039)(mergedTheme, [
        (0, $84fac8c8876d9d5c$export$2e2bcd8739ae039),
        rootDesignToken
    ], {
        salt: salt,
        override: override,
        getComputedToken: $b22e03a54a548614$export$18602cb46ae80b62,
        cssVar: {
            ...cssVar,
            unitless: $b22e03a54a548614$export$c6b9faa6b723d31a,
            ignore: $b22e03a54a548614$export$738b109e247a462c,
            preserve: $b22e03a54a548614$var$preserve
        },
        nonce: csp?.nonce
    });
    return [
        mergedTheme,
        realToken,
        hashed ? hashId : "",
        token,
        cssVar,
        !!zeroRuntime
    ];
}


"use client";
const $8d7cfdf38ccd938e$var$MotionCacheContext = /*#__PURE__*/ $cQmXV.createContext(true);
function $8d7cfdf38ccd938e$export$2e2bcd8739ae039(props) {
    const parentMotion = $cQmXV.useContext($8d7cfdf38ccd938e$var$MotionCacheContext);
    const { children: children } = props;
    const [, token] = (0, $b22e03a54a548614$export$2e2bcd8739ae039)();
    const { motion: motion } = token;
    const needWrapMotionProviderRef = $cQmXV.useRef(false);
    needWrapMotionProviderRef.current || (needWrapMotionProviderRef.current = parentMotion !== motion);
    if (needWrapMotionProviderRef.current) return /*#__PURE__*/ $cQmXV.createElement($8d7cfdf38ccd938e$var$MotionCacheContext.Provider, {
        value: motion
    }, /*#__PURE__*/ $cQmXV.createElement((0, $3aebaa435fd7d75e$export$2e2bcd8739ae039), {
        motion: motion
    }, children));
    return children;
}



var $cQmXV = parcelRequire("cQmXV");

"use client";
/**
 * Warning for ConfigProviderProps.
 * This will be empty function in production.
 */ const $8699e5b0bb32789d$var$PropWarning = /*#__PURE__*/ $cQmXV.memo((props)=>{
    const { dropdownMatchSelectWidth: dropdownMatchSelectWidth } = props;
    const warning = (0, $b5822acdae823465$export$cf977aa92c751e61)("ConfigProvider");
    warning.deprecated(dropdownMatchSelectWidth === undefined, "dropdownMatchSelectWidth", "popupMatchSelectWidth");
    return null;
});
var $8699e5b0bb32789d$export$2e2bcd8739ae039 = ()=>null;





"use client";
const $519d20bf207ce864$export$b2b65df0d0824629 = {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
};
const $519d20bf207ce864$export$23997c3e44cc1c59 = (token, needInheritFontFamily = false)=>({
        boxSizing: "border-box",
        margin: 0,
        padding: 0,
        color: token.colorText,
        fontSize: token.fontSize,
        // font-variant: @font-variant-base;
        lineHeight: token.lineHeight,
        listStyle: "none",
        // font-feature-settings: @font-feature-settings-base;
        fontFamily: needInheritFontFamily ? "inherit" : token.fontFamily
    });
const $519d20bf207ce864$export$171ccda7bc085e59 = ()=>({
        display: "inline-flex",
        alignItems: "center",
        color: "inherit",
        fontStyle: "normal",
        lineHeight: 0,
        textAlign: "center",
        textTransform: "none",
        // for SVG icon, see https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4
        verticalAlign: "-0.125em",
        textRendering: "optimizeLegibility",
        "-webkit-font-smoothing": "antialiased",
        "-moz-osx-font-smoothing": "grayscale",
        "> *": {
            lineHeight: 1
        },
        svg: {
            display: "inline-block",
            verticalAlign: "inherit"
        }
    });
const $519d20bf207ce864$var$loadingCircle = new (0, $e928d3664c9ed565$export$2e2bcd8739ae039)("loadingCircle", {
    "100%": {
        transform: "rotate(360deg)"
    }
});
const $519d20bf207ce864$export$8c467e8859fdef13 = ()=>({
        // https://github.com/ant-design/ant-design/issues/21301#issuecomment-583955229
        "&::before": {
            display: "table",
            content: '""'
        },
        "&::after": {
            // https://github.com/ant-design/ant-design/issues/21864
            display: "table",
            clear: "both",
            content: '""'
        }
    });
const $519d20bf207ce864$export$6539948f0a737e39 = (token, offset)=>({
        outline: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidthFocus)} solid ${token.colorPrimaryBorder}`,
        outlineOffset: offset ?? 1,
        transition: [
            `outline-offset`,
            `outline`
        ].map((prop)=>`${prop} 0s`).join(", ")
    });
const $519d20bf207ce864$export$a44db842bcb28231 = (token, offset)=>({
        "&:focus-visible": $519d20bf207ce864$export$6539948f0a737e39(token, offset)
    });
const $519d20bf207ce864$export$905d771977096614 = (token)=>({
        a: {
            color: token.colorLink,
            textDecoration: token.linkDecoration,
            backgroundColor: "transparent",
            // remove the gray background on active links in IE 10.
            outline: "none",
            cursor: "pointer",
            transition: `color ${token.motionDurationSlow}`,
            "-webkit-text-decoration-skip": "objects",
            // remove gaps in links underline in iOS 8+ and Safari 8+.
            "&:hover": {
                color: token.colorLinkHover
            },
            "&:active": {
                color: token.colorLinkActive
            },
            "&:active, &:hover": {
                textDecoration: token.linkHoverDecoration,
                outline: 0
            },
            // https://github.com/ant-design/ant-design/issues/22503
            "&:focus": {
                textDecoration: token.linkFocusDecoration,
                outline: 0
            },
            ...$519d20bf207ce864$export$a44db842bcb28231(token),
            "&[disabled]": {
                color: token.colorTextDisabled,
                cursor: "not-allowed"
            }
        }
    });
const $519d20bf207ce864$export$689382c111559cd9 = (token, componentPrefixCls, rootCls, resetFont)=>{
    const prefixSelector = `[class^="${componentPrefixCls}"], [class*=" ${componentPrefixCls}"]`;
    const rootPrefixSelector = rootCls ? `.${rootCls}` : prefixSelector;
    const resetStyle = {
        boxSizing: "border-box",
        "&::before, &::after": {
            boxSizing: "border-box"
        }
    };
    let resetFontStyle = {};
    if (resetFont !== false) resetFontStyle = {
        fontFamily: token.fontFamily,
        fontSize: token.fontSize
    };
    return {
        [rootPrefixSelector]: {
            ...resetFontStyle,
            ...resetStyle,
            [prefixSelector]: resetStyle
        }
    };
};
const $519d20bf207ce864$export$f1a0b31dfb234e7e = (iconPrefixCls)=>({
        [`.${iconPrefixCls}`]: {
            ...$519d20bf207ce864$export$171ccda7bc085e59(),
            "&::before": {
                display: "none"
            },
            "&[tabindex]": {
                cursor: "pointer"
            }
        },
        [`.${iconPrefixCls} .${iconPrefixCls}-icon`]: {
            display: "block"
        },
        [`.${iconPrefixCls}-spin`]: {
            animationName: $519d20bf207ce864$var$loadingCircle,
            animationDuration: "1s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear"
        }
    });
const $519d20bf207ce864$export$9a16e7694a707ab4 = (token)=>({
        // FIXME: This use link but is a operation unit. Seems should be a colorPrimary.
        // And Typography use this to generate link style which should not do this.
        color: token.colorLink,
        textDecoration: token.linkDecoration,
        outline: "none",
        cursor: "pointer",
        transition: `all ${token.motionDurationSlow}`,
        border: 0,
        padding: 0,
        background: "none",
        userSelect: "none",
        ...$519d20bf207ce864$export$a44db842bcb28231(token),
        "&:hover": {
            color: token.colorLinkHover,
            textDecoration: token.linkHoverDecoration
        },
        "&:focus": {
            color: token.colorLinkHover,
            textDecoration: token.linkFocusDecoration
        },
        "&:active": {
            color: token.colorLinkActive,
            textDecoration: token.linkHoverDecoration
        }
    });



const $707695595ac1b4f8$var$useResetIconStyle = (iconPrefixCls, csp)=>{
    const [theme, token] = (0, $b22e03a54a548614$export$2e2bcd8739ae039)();
    // Generate style for icons
    return (0, $0fc07301276d48a5$export$2e2bcd8739ae039)({
        theme: theme,
        token: token,
        hashId: "",
        path: [
            "ant-design-icons",
            iconPrefixCls
        ],
        nonce: ()=>csp?.nonce,
        layer: {
            name: "antd"
        }
    }, ()=>(0, $519d20bf207ce864$export$f1a0b31dfb234e7e)(iconPrefixCls));
};
var $707695595ac1b4f8$export$2e2bcd8739ae039 = $707695595ac1b4f8$var$useResetIconStyle;


"use client";
/**
 * This component registers icon styles inside the DesignTokenContext.Provider
 * so that CSS variables use the correct cssVar key from the theme config.
 */ const $5764e43cf38ca965$var$IconStyle = ({ iconPrefixCls: iconPrefixCls, csp: csp })=>{
    (0, $707695595ac1b4f8$export$2e2bcd8739ae039)(iconPrefixCls, csp);
    return null;
};
/**
 * Since too many feedback using static method like `Modal.confirm` not getting theme, we record the
 * theme register info here to help developer get warning info.
 */ let $5764e43cf38ca965$var$existThemeConfig = false;
const $5764e43cf38ca965$export$7c4f6da0f9434a77 = /* istanbul ignore next */ null;
const $5764e43cf38ca965$export$e7f14a745e5c386a = [
    "getTargetContainer",
    "getPopupContainer",
    "rootPrefixCls",
    "getPrefixCls",
    "renderEmpty",
    "csp",
    "autoInsertSpaceInButton",
    "locale"
];
// These props is used by `useContext` directly in sub component
const $5764e43cf38ca965$var$PASSED_PROPS = [
    "getTargetContainer",
    "getPopupContainer",
    "renderEmpty",
    "input",
    "pagination",
    "form",
    "select",
    "button"
];
let $5764e43cf38ca965$var$globalPrefixCls;
let $5764e43cf38ca965$var$globalIconPrefixCls;
let $5764e43cf38ca965$var$globalTheme;
let $5764e43cf38ca965$var$globalHolderRender;
function $5764e43cf38ca965$var$getGlobalPrefixCls() {
    return $5764e43cf38ca965$var$globalPrefixCls || (0, $82ffd17441b57982$export$e4ec87ea71f29b41);
}
function $5764e43cf38ca965$var$getGlobalIconPrefixCls() {
    return $5764e43cf38ca965$var$globalIconPrefixCls || (0, $82ffd17441b57982$export$eaca8ee5ed21b4e9);
}
const $5764e43cf38ca965$var$setGlobalConfig = (props)=>{
    const { prefixCls: prefixCls, iconPrefixCls: iconPrefixCls, theme: theme, holderRender: holderRender } = props;
    if (prefixCls !== undefined) $5764e43cf38ca965$var$globalPrefixCls = prefixCls;
    if (iconPrefixCls !== undefined) $5764e43cf38ca965$var$globalIconPrefixCls = iconPrefixCls;
    if ("holderRender" in props) $5764e43cf38ca965$var$globalHolderRender = holderRender;
    if (theme) $5764e43cf38ca965$var$globalTheme = theme;
};
const $5764e43cf38ca965$export$f9cd1e43211d8a4a = ()=>({
        getPrefixCls: (suffixCls, customizePrefixCls)=>{
            if (customizePrefixCls) return customizePrefixCls;
            return suffixCls ? `${$5764e43cf38ca965$var$getGlobalPrefixCls()}-${suffixCls}` : $5764e43cf38ca965$var$getGlobalPrefixCls();
        },
        getIconPrefixCls: $5764e43cf38ca965$var$getGlobalIconPrefixCls,
        getRootPrefixCls: ()=>{
            // If Global prefixCls provided, use this
            if ($5764e43cf38ca965$var$globalPrefixCls) return $5764e43cf38ca965$var$globalPrefixCls;
            // Fallback to default prefixCls
            return $5764e43cf38ca965$var$getGlobalPrefixCls();
        },
        getTheme: ()=>$5764e43cf38ca965$var$globalTheme,
        holderRender: $5764e43cf38ca965$var$globalHolderRender
    });
const $5764e43cf38ca965$var$ProviderChildren = (props)=>{
    const { children: children, csp: customCsp, autoInsertSpaceInButton: autoInsertSpaceInButton, alert: alert, affix: affix, anchor: anchor, app: app, form: form, locale: rawLocale, componentSize: componentSize, direction: direction, space: space, splitter: splitter, virtual: virtual, dropdownMatchSelectWidth: dropdownMatchSelectWidth, popupMatchSelectWidth: popupMatchSelectWidth, popupOverflow: popupOverflow, legacyLocale: legacyLocale, parentContext: parentContext, iconPrefixCls: customIconPrefixCls, theme: theme, componentDisabled: componentDisabled, segmented: segmented, statistic: statistic, spin: spin, calendar: calendar, carousel: carousel, cascader: cascader, collapse: collapse, typography: typography, checkbox: checkbox, descriptions: descriptions, divider: divider, drawer: drawer, skeleton: skeleton, steps: steps, image: image, layout: layout, list: list, listy: listy, mentions: mentions, modal: modal, progress: progress, result: result, slider: slider, breadcrumb: breadcrumb, masonry: masonry, menu: menu, pagination: pagination, input: input, inputPassword: inputPassword, inputSearch: inputSearch, textArea: textArea, otp: otp, empty: empty, badge: badge, borderBeam: borderBeam, radio: radio, rate: rate, ribbon: ribbon, switch: SWITCH, transfer: transfer, avatar: avatar, message: message, tag: tag, table: table, card: card, cardMeta: cardMeta, tabs: tabs, timeline: timeline, timePicker: timePicker, upload: upload, notification: notification, tree: tree, colorPicker: colorPicker, datePicker: datePicker, rangePicker: rangePicker, flex: flex, wave: wave, dropdown: dropdown, warning: warningConfig, tour: tour, tooltip: tooltip, popover: popover, popconfirm: popconfirm, qrcode: qrcode, floatButton: floatButton, floatButtonGroup: floatButtonGroup, variant: variant, inputNumber: inputNumber, treeSelect: treeSelect, watermark: watermark } = props;
    // https://github.com/ant-design/ant-design/issues/57295
    const locale = $cQmXV.useMemo(()=>{
        if ((0, $8e2d153a3c855782$export$53b83ca8eaab0383)(rawLocale) && Object.prototype.hasOwnProperty.call(rawLocale, "default") && rawLocale.default?.locale) return rawLocale.default;
        return rawLocale;
    }, [
        rawLocale
    ]);
    // =================================== Context ===================================
    const getPrefixCls = $cQmXV.useCallback((suffixCls, customizePrefixCls)=>{
        const { prefixCls: prefixCls } = props;
        if (customizePrefixCls) return customizePrefixCls;
        const mergedPrefixCls = prefixCls || parentContext.getPrefixCls("");
        return suffixCls ? `${mergedPrefixCls}-${suffixCls}` : mergedPrefixCls;
    }, [
        parentContext.getPrefixCls,
        props.prefixCls
    ]);
    const iconPrefixCls = customIconPrefixCls || parentContext.iconPrefixCls || (0, $82ffd17441b57982$export$eaca8ee5ed21b4e9);
    const csp = customCsp || parentContext.csp;
    const mergedTheme = (0, $d9452c6466030853$export$2e2bcd8739ae039)(theme, parentContext.theme, {
        prefixCls: getPrefixCls("")
    });
    const baseConfig = {
        csp: csp,
        autoInsertSpaceInButton: autoInsertSpaceInButton,
        alert: alert,
        affix: affix,
        anchor: anchor,
        app: app,
        locale: locale || legacyLocale,
        direction: direction,
        space: space,
        splitter: splitter,
        virtual: virtual,
        popupMatchSelectWidth: popupMatchSelectWidth ?? dropdownMatchSelectWidth,
        popupOverflow: popupOverflow,
        getPrefixCls: getPrefixCls,
        iconPrefixCls: iconPrefixCls,
        theme: mergedTheme,
        segmented: segmented,
        statistic: statistic,
        spin: spin,
        calendar: calendar,
        carousel: carousel,
        cascader: cascader,
        collapse: collapse,
        typography: typography,
        checkbox: checkbox,
        descriptions: descriptions,
        divider: divider,
        drawer: drawer,
        skeleton: skeleton,
        steps: steps,
        image: image,
        input: input,
        inputPassword: inputPassword,
        inputSearch: inputSearch,
        textArea: textArea,
        otp: otp,
        layout: layout,
        list: list,
        listy: listy,
        mentions: mentions,
        modal: modal,
        progress: progress,
        result: result,
        slider: slider,
        breadcrumb: breadcrumb,
        masonry: masonry,
        menu: menu,
        pagination: pagination,
        empty: empty,
        badge: badge,
        borderBeam: borderBeam,
        radio: radio,
        rate: rate,
        ribbon: ribbon,
        switch: SWITCH,
        transfer: transfer,
        avatar: avatar,
        message: message,
        tag: tag,
        table: table,
        card: card,
        cardMeta: cardMeta,
        tabs: tabs,
        timeline: timeline,
        timePicker: timePicker,
        upload: upload,
        notification: notification,
        tree: tree,
        colorPicker: colorPicker,
        datePicker: datePicker,
        rangePicker: rangePicker,
        flex: flex,
        wave: wave,
        dropdown: dropdown,
        warning: warningConfig,
        tour: tour,
        tooltip: tooltip,
        popover: popover,
        popconfirm: popconfirm,
        qrcode: qrcode,
        floatButton: floatButton,
        floatButtonGroup: floatButtonGroup,
        variant: variant,
        inputNumber: inputNumber,
        treeSelect: treeSelect,
        watermark: watermark
    };
    const config = {
        ...parentContext
    };
    Object.keys(baseConfig).forEach((key)=>{
        if (baseConfig[key] !== undefined) config[key] = baseConfig[key];
    });
    // Pass the props used by `useContext` directly with child component.
    // These props should merged into `config`.
    $5764e43cf38ca965$var$PASSED_PROPS.forEach((propName)=>{
        const propValue = props[propName];
        if (propValue) config[propName] = propValue;
    });
    if (typeof autoInsertSpaceInButton !== "undefined") // merge deprecated api
    config.button = {
        autoInsertSpace: autoInsertSpaceInButton,
        ...config.button
    };
    // https://github.com/ant-design/ant-design/issues/27617
    const memoedConfig = (0, $d627c2941353b4cb$export$2e2bcd8739ae039)(()=>config, config, (prevConfig, currentConfig)=>{
        const prevKeys = Object.keys(prevConfig);
        const currentKeys = Object.keys(currentConfig);
        return prevKeys.length !== currentKeys.length || prevKeys.some((key)=>prevConfig[key] !== currentConfig[key]);
    });
    const { layer: layer } = $cQmXV.useContext((0, $21cab3db22272d25$export$2e2bcd8739ae039));
    const memoIconContextValue = $cQmXV.useMemo(()=>({
            prefixCls: iconPrefixCls,
            csp: csp,
            layer: layer ? "antd" : undefined,
            zeroRuntime: !!layer || mergedTheme?.zeroRuntime
        }), [
        iconPrefixCls,
        csp,
        layer,
        mergedTheme?.zeroRuntime
    ]);
    let childNode = /*#__PURE__*/ $cQmXV.createElement($cQmXV.Fragment, null, /*#__PURE__*/ $cQmXV.createElement($5764e43cf38ca965$var$IconStyle, {
        iconPrefixCls: iconPrefixCls,
        csp: csp
    }), /*#__PURE__*/ $cQmXV.createElement((0, $8699e5b0bb32789d$export$2e2bcd8739ae039), {
        dropdownMatchSelectWidth: dropdownMatchSelectWidth
    }), children);
    const validateMessages = $cQmXV.useMemo(()=>(0, $a3099986deccaee4$export$4950aa0f605343fb)((0, $4ab0c7032ff9de6a$export$2e2bcd8739ae039).Form?.defaultValidateMessages || {}, memoedConfig.locale?.Form?.defaultValidateMessages || {}, memoedConfig.form?.validateMessages || {}, form?.validateMessages || {}), [
        memoedConfig,
        form?.validateMessages
    ]);
    if (Object.keys(validateMessages).length > 0) childNode = /*#__PURE__*/ $cQmXV.createElement((0, $d111de4f04aff124$export$2e2bcd8739ae039).Provider, {
        value: validateMessages
    }, childNode);
    if (locale) childNode = /*#__PURE__*/ $cQmXV.createElement((0, $a9b226314edf7f3d$export$2e2bcd8739ae039), {
        locale: locale,
        _ANT_MARK__: (0, $a9b226314edf7f3d$export$b2f162cd5c15ea3e)
    }, childNode);
    if (iconPrefixCls || csp) childNode = /*#__PURE__*/ $cQmXV.createElement((0, $92d549a1da97eca7$export$2e2bcd8739ae039).Provider, {
        value: memoIconContextValue
    }, childNode);
    if (componentSize) childNode = /*#__PURE__*/ $cQmXV.createElement((0, $767e8ef819e95b6d$export$dbc92d89fabc8ebe), {
        size: componentSize
    }, childNode);
    // =================================== Motion ===================================
    childNode = /*#__PURE__*/ $cQmXV.createElement((0, $8d7cfdf38ccd938e$export$2e2bcd8739ae039), null, childNode);
    // ================================ Tooltip Unique ===============================
    if (tooltip?.unique) childNode = /*#__PURE__*/ $cQmXV.createElement((0, $4271d9f55cb3799b$export$2e2bcd8739ae039), null, childNode);
    // ================================ Dynamic theme ================================
    const memoTheme = $cQmXV.useMemo(()=>{
        const { algorithm: algorithm, token: token, components: components, cssVar: cssVar, ...rest } = mergedTheme || {};
        const themeObj = algorithm && (!Array.isArray(algorithm) || algorithm.length > 0) ? (0, $01a2faba6df82710$export$2e2bcd8739ae039)(algorithm) : (0, $3fc6617fc53b3959$export$2e2bcd8739ae039);
        const parsedComponents = {};
        Object.entries(components || {}).forEach(([componentName, componentToken])=>{
            const parsedToken = {
                ...componentToken
            };
            if ("algorithm" in parsedToken) {
                if (parsedToken.algorithm === true) parsedToken.theme = themeObj;
                else if (Array.isArray(parsedToken.algorithm) || (0, $8e2d153a3c855782$export$f6e2535fb5126e54)(parsedToken.algorithm)) parsedToken.theme = (0, $01a2faba6df82710$export$2e2bcd8739ae039)(parsedToken.algorithm);
                delete parsedToken.algorithm;
            }
            parsedComponents[componentName] = parsedToken;
        });
        const mergedToken = {
            ...(0, $84fac8c8876d9d5c$export$2e2bcd8739ae039),
            ...token
        };
        return {
            ...rest,
            theme: themeObj,
            token: mergedToken,
            components: parsedComponents,
            override: {
                override: mergedToken,
                ...parsedComponents
            },
            cssVar: cssVar
        };
    }, [
        mergedTheme
    ]);
    if (theme) childNode = /*#__PURE__*/ $cQmXV.createElement((0, $284e1db1c3fa1faa$export$69b0ebb9efcddb30).Provider, {
        value: memoTheme
    }, childNode);
    // ================================== Warning ===================================
    if (memoedConfig.warning) childNode = /*#__PURE__*/ $cQmXV.createElement((0, $b5822acdae823465$export$11b88c75b33aa1fd).Provider, {
        value: memoedConfig.warning
    }, childNode);
    // =================================== Render ===================================
    if (componentDisabled !== undefined) childNode = /*#__PURE__*/ $cQmXV.createElement((0, $4f0e1ea30330557c$export$6adb5f3b918b11bb), {
        disabled: componentDisabled
    }, childNode);
    return /*#__PURE__*/ $cQmXV.createElement((0, $82ffd17441b57982$export$a92f85ab3e9ad68b).Provider, {
        value: memoedConfig
    }, childNode);
};
const $5764e43cf38ca965$var$ConfigProvider = (props)=>{
    const context = $cQmXV.useContext((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    const antLocale = $cQmXV.useContext((0, $58fff045e75b7fbc$export$2e2bcd8739ae039));
    return /*#__PURE__*/ $cQmXV.createElement($5764e43cf38ca965$var$ProviderChildren, {
        parentContext: context,
        legacyLocale: antLocale,
        ...props
    });
};
$5764e43cf38ca965$var$ConfigProvider.ConfigContext = (0, $82ffd17441b57982$export$a92f85ab3e9ad68b);
$5764e43cf38ca965$var$ConfigProvider.SizeContext = (0, $767e8ef819e95b6d$export$2e2bcd8739ae039);
$5764e43cf38ca965$var$ConfigProvider.config = $5764e43cf38ca965$var$setGlobalConfig;
$5764e43cf38ca965$var$ConfigProvider.useConfig = (0, $e728fd34be248c9d$export$2e2bcd8739ae039);
Object.defineProperty($5764e43cf38ca965$var$ConfigProvider, "SizeContext", {
    get: ()=>{
        return 0, $767e8ef819e95b6d$export$2e2bcd8739ae039;
    }
});
var $5764e43cf38ca965$export$2e2bcd8739ae039 = $5764e43cf38ca965$var$ConfigProvider;



var $cQmXV = parcelRequire("cQmXV");
var $e184e13c9f06c781$exports = {};
"use strict";

$e184e13c9f06c781$exports = (parcelRequire("d00aZ"));


var $b83e93e5ef3de8b0$var$__defProp = Object.defineProperty;
var $b83e93e5ef3de8b0$var$__defProps = Object.defineProperties;
var $b83e93e5ef3de8b0$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $b83e93e5ef3de8b0$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $b83e93e5ef3de8b0$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $b83e93e5ef3de8b0$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $b83e93e5ef3de8b0$var$__defNormalProp = (obj, key, value)=>key in obj ? $b83e93e5ef3de8b0$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $b83e93e5ef3de8b0$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($b83e93e5ef3de8b0$var$__hasOwnProp.call(b, prop)) $b83e93e5ef3de8b0$var$__defNormalProp(a, prop, b[prop]);
    if ($b83e93e5ef3de8b0$var$__getOwnPropSymbols) {
        for (var prop of $b83e93e5ef3de8b0$var$__getOwnPropSymbols(b))if ($b83e93e5ef3de8b0$var$__propIsEnum.call(b, prop)) $b83e93e5ef3de8b0$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $b83e93e5ef3de8b0$var$__spreadProps = (a, b)=>$b83e93e5ef3de8b0$var$__defProps(a, $b83e93e5ef3de8b0$var$__getOwnPropDescs(b));
var $b83e93e5ef3de8b0$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($b83e93e5ef3de8b0$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $b83e93e5ef3de8b0$var$__getOwnPropSymbols) {
        for (var prop of $b83e93e5ef3de8b0$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $b83e93e5ef3de8b0$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
// src/utils/react-is.ts
var $b83e93e5ef3de8b0$var$IS_REACT_19 = /* @__PURE__ */ $cQmXV.version.startsWith("19");
var $b83e93e5ef3de8b0$var$REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for($b83e93e5ef3de8b0$var$IS_REACT_19 ? "react.transitional.element" : "react.element");
var $b83e93e5ef3de8b0$var$REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal");
var $b83e93e5ef3de8b0$var$REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment");
var $b83e93e5ef3de8b0$var$REACT_STRICT_MODE_TYPE = /* @__PURE__ */ Symbol.for("react.strict_mode");
var $b83e93e5ef3de8b0$var$REACT_PROFILER_TYPE = /* @__PURE__ */ Symbol.for("react.profiler");
var $b83e93e5ef3de8b0$var$REACT_CONSUMER_TYPE = /* @__PURE__ */ Symbol.for("react.consumer");
var $b83e93e5ef3de8b0$var$REACT_CONTEXT_TYPE = /* @__PURE__ */ Symbol.for("react.context");
var $b83e93e5ef3de8b0$var$REACT_FORWARD_REF_TYPE = /* @__PURE__ */ Symbol.for("react.forward_ref");
var $b83e93e5ef3de8b0$var$REACT_SUSPENSE_TYPE = /* @__PURE__ */ Symbol.for("react.suspense");
var $b83e93e5ef3de8b0$var$REACT_SUSPENSE_LIST_TYPE = /* @__PURE__ */ Symbol.for("react.suspense_list");
var $b83e93e5ef3de8b0$var$REACT_MEMO_TYPE = /* @__PURE__ */ Symbol.for("react.memo");
var $b83e93e5ef3de8b0$var$REACT_LAZY_TYPE = /* @__PURE__ */ Symbol.for("react.lazy");
var $b83e93e5ef3de8b0$var$REACT_OFFSCREEN_TYPE = /* @__PURE__ */ Symbol.for("react.offscreen");
var $b83e93e5ef3de8b0$var$REACT_CLIENT_REFERENCE = /* @__PURE__ */ Symbol.for("react.client.reference");
var $b83e93e5ef3de8b0$var$ForwardRef = $b83e93e5ef3de8b0$var$REACT_FORWARD_REF_TYPE;
var $b83e93e5ef3de8b0$var$Memo = $b83e93e5ef3de8b0$var$REACT_MEMO_TYPE;
function $b83e93e5ef3de8b0$var$isValidElementType(type) {
    return typeof type === "string" || typeof type === "function" || type === $b83e93e5ef3de8b0$var$REACT_FRAGMENT_TYPE || type === $b83e93e5ef3de8b0$var$REACT_PROFILER_TYPE || type === $b83e93e5ef3de8b0$var$REACT_STRICT_MODE_TYPE || type === $b83e93e5ef3de8b0$var$REACT_SUSPENSE_TYPE || type === $b83e93e5ef3de8b0$var$REACT_SUSPENSE_LIST_TYPE || type === $b83e93e5ef3de8b0$var$REACT_OFFSCREEN_TYPE || typeof type === "object" && type !== null && (type.$$typeof === $b83e93e5ef3de8b0$var$REACT_LAZY_TYPE || type.$$typeof === $b83e93e5ef3de8b0$var$REACT_MEMO_TYPE || type.$$typeof === $b83e93e5ef3de8b0$var$REACT_CONTEXT_TYPE || type.$$typeof === $b83e93e5ef3de8b0$var$REACT_CONSUMER_TYPE || type.$$typeof === $b83e93e5ef3de8b0$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $b83e93e5ef3de8b0$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) ? true : false;
}
function $b83e93e5ef3de8b0$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const { $$typeof: $$typeof } = object;
        switch($$typeof){
            case $b83e93e5ef3de8b0$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $b83e93e5ef3de8b0$var$REACT_FRAGMENT_TYPE:
                    case $b83e93e5ef3de8b0$var$REACT_PROFILER_TYPE:
                    case $b83e93e5ef3de8b0$var$REACT_STRICT_MODE_TYPE:
                    case $b83e93e5ef3de8b0$var$REACT_SUSPENSE_TYPE:
                    case $b83e93e5ef3de8b0$var$REACT_SUSPENSE_LIST_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $b83e93e5ef3de8b0$var$REACT_CONTEXT_TYPE:
                            case $b83e93e5ef3de8b0$var$REACT_FORWARD_REF_TYPE:
                            case $b83e93e5ef3de8b0$var$REACT_LAZY_TYPE:
                            case $b83e93e5ef3de8b0$var$REACT_MEMO_TYPE:
                                return object;
                            case $b83e93e5ef3de8b0$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $b83e93e5ef3de8b0$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
function $b83e93e5ef3de8b0$var$isContextConsumer(object) {
    return $b83e93e5ef3de8b0$var$IS_REACT_19 ? $b83e93e5ef3de8b0$var$typeOf(object) === $b83e93e5ef3de8b0$var$REACT_CONSUMER_TYPE : $b83e93e5ef3de8b0$var$typeOf(object) === $b83e93e5ef3de8b0$var$REACT_CONTEXT_TYPE;
}
function $b83e93e5ef3de8b0$var$isMemo(object) {
    return $b83e93e5ef3de8b0$var$typeOf(object) === $b83e93e5ef3de8b0$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $b83e93e5ef3de8b0$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $b83e93e5ef3de8b0$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $b83e93e5ef3de8b0$var$warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $b83e93e5ef3de8b0$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $b83e93e5ef3de8b0$var$verify(mapStateToProps, "mapStateToProps");
    $b83e93e5ef3de8b0$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $b83e93e5ef3de8b0$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $b83e93e5ef3de8b0$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $b83e93e5ef3de8b0$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _b, options = $b83e93e5ef3de8b0$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $b83e93e5ef3de8b0$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $b83e93e5ef3de8b0$var$bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $b83e93e5ef3de8b0$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $b83e93e5ef3de8b0$var$verifyPlainObject(value, displayName, methodName) {
    if (!$b83e93e5ef3de8b0$var$isPlainObject(value)) $b83e93e5ef3de8b0$var$warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
// src/connect/wrapMapToProps.ts
function $b83e93e5ef3de8b0$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $b83e93e5ef3de8b0$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $b83e93e5ef3de8b0$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $b83e93e5ef3de8b0$var$getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $b83e93e5ef3de8b0$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $b83e93e5ef3de8b0$var$createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
// src/connect/mapDispatchToProps.ts
function $b83e93e5ef3de8b0$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $b83e93e5ef3de8b0$var$wrapMapToPropsConstant((dispatch)=>// @ts-ignore
        $b83e93e5ef3de8b0$var$bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? $b83e93e5ef3de8b0$var$wrapMapToPropsConstant((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $b83e93e5ef3de8b0$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $b83e93e5ef3de8b0$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $b83e93e5ef3de8b0$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $b83e93e5ef3de8b0$var$wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? // @ts-ignore
    $b83e93e5ef3de8b0$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $b83e93e5ef3de8b0$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $b83e93e5ef3de8b0$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $b83e93e5ef3de8b0$var$__spreadValues($b83e93e5ef3de8b0$var$__spreadValues($b83e93e5ef3de8b0$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $b83e93e5ef3de8b0$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $b83e93e5ef3de8b0$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>$b83e93e5ef3de8b0$var$defaultMergeProps : typeof mergeProps === "function" ? $b83e93e5ef3de8b0$var$wrapMergePropsFunc(mergeProps) : $b83e93e5ef3de8b0$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $b83e93e5ef3de8b0$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $b83e93e5ef3de8b0$var$createListenerCollection() {
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            $b83e93e5ef3de8b0$var$defaultNoopBatch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            const listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            const listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $b83e93e5ef3de8b0$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $b83e93e5ef3de8b0$var$createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = $b83e93e5ef3de8b0$var$nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $b83e93e5ef3de8b0$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $b83e93e5ef3de8b0$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $b83e93e5ef3de8b0$var$canUseDOM = ()=>!!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $b83e93e5ef3de8b0$var$isDOM = /* @__PURE__ */ $b83e93e5ef3de8b0$var$canUseDOM();
var $b83e93e5ef3de8b0$var$isRunningInReactNative = ()=>typeof navigator !== "undefined" && navigator.product === "ReactNative";
var $b83e93e5ef3de8b0$var$isReactNative = /* @__PURE__ */ $b83e93e5ef3de8b0$var$isRunningInReactNative();
var $b83e93e5ef3de8b0$var$getUseIsomorphicLayoutEffect = ()=>$b83e93e5ef3de8b0$var$isDOM || $b83e93e5ef3de8b0$var$isReactNative ? $cQmXV.useLayoutEffect : $cQmXV.useEffect;
var $b83e93e5ef3de8b0$var$useIsomorphicLayoutEffect = /* @__PURE__ */ $b83e93e5ef3de8b0$var$getUseIsomorphicLayoutEffect();
// src/utils/shallowEqual.ts
function $b83e93e5ef3de8b0$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $b83e93e5ef3de8b0$export$d36bdfa510afb180(objA, objB) {
    if ($b83e93e5ef3de8b0$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$b83e93e5ef3de8b0$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $b83e93e5ef3de8b0$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $b83e93e5ef3de8b0$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $b83e93e5ef3de8b0$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $b83e93e5ef3de8b0$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $b83e93e5ef3de8b0$var$TYPE_STATICS = {
    [$b83e93e5ef3de8b0$var$ForwardRef]: $b83e93e5ef3de8b0$var$FORWARD_REF_STATICS,
    [$b83e93e5ef3de8b0$var$Memo]: $b83e93e5ef3de8b0$var$MEMO_STATICS
};
function $b83e93e5ef3de8b0$var$getStatics(component) {
    if ($b83e93e5ef3de8b0$var$isMemo(component)) return $b83e93e5ef3de8b0$var$MEMO_STATICS;
    return $b83e93e5ef3de8b0$var$TYPE_STATICS[component["$$typeof"]] || $b83e93e5ef3de8b0$var$REACT_STATICS;
}
var $b83e93e5ef3de8b0$var$defineProperty = Object.defineProperty;
var $b83e93e5ef3de8b0$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $b83e93e5ef3de8b0$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $b83e93e5ef3de8b0$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $b83e93e5ef3de8b0$var$getPrototypeOf = Object.getPrototypeOf;
var $b83e93e5ef3de8b0$var$objectPrototype = Object.prototype;
function $b83e93e5ef3de8b0$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($b83e93e5ef3de8b0$var$objectPrototype) {
            const inheritedComponent = $b83e93e5ef3de8b0$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $b83e93e5ef3de8b0$var$objectPrototype) $b83e93e5ef3de8b0$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = $b83e93e5ef3de8b0$var$getOwnPropertyNames(sourceComponent);
        if ($b83e93e5ef3de8b0$var$getOwnPropertySymbols) keys = keys.concat($b83e93e5ef3de8b0$var$getOwnPropertySymbols(sourceComponent));
        const targetStatics = $b83e93e5ef3de8b0$var$getStatics(targetComponent);
        const sourceStatics = $b83e93e5ef3de8b0$var$getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!$b83e93e5ef3de8b0$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = $b83e93e5ef3de8b0$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $b83e93e5ef3de8b0$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/Context.ts
var $b83e93e5ef3de8b0$var$ContextKey = /* @__PURE__ */ Symbol.for(`react-redux-context`);
var $b83e93e5ef3de8b0$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $b83e93e5ef3de8b0$var$getContext() {
    var _a;
    if (!$cQmXV.createContext) return {};
    const contextMap = (_a = $b83e93e5ef3de8b0$var$gT[$b83e93e5ef3de8b0$var$ContextKey]) != null ? _a : $b83e93e5ef3de8b0$var$gT[$b83e93e5ef3de8b0$var$ContextKey] = /* @__PURE__ */ new Map();
    let realContext = contextMap.get($cQmXV.createContext);
    if (!realContext) {
        realContext = $cQmXV.createContext(null);
        contextMap.set($cQmXV.createContext, realContext);
    }
    return realContext;
}
var $b83e93e5ef3de8b0$export$cc80c08dc91f1c00 = /* @__PURE__ */ $b83e93e5ef3de8b0$var$getContext();
// src/components/connect.tsx
var $b83e93e5ef3de8b0$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $b83e93e5ef3de8b0$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $b83e93e5ef3de8b0$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $b83e93e5ef3de8b0$var$useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function $b83e93e5ef3de8b0$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $b83e93e5ef3de8b0$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $b83e93e5ef3de8b0$var$strictEqual(a, b) {
    return a === b;
}
var $b83e93e5ef3de8b0$var$hasWarnedAboutDeprecatedPureOption = false;
function $b83e93e5ef3de8b0$var$_connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $b83e93e5ef3de8b0$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = $b83e93e5ef3de8b0$export$d36bdfa510afb180, areStatePropsEqual: areStatePropsEqual = $b83e93e5ef3de8b0$export$d36bdfa510afb180, areMergedPropsEqual: areMergedPropsEqual = $b83e93e5ef3de8b0$export$d36bdfa510afb180, forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = $b83e93e5ef3de8b0$export$cc80c08dc91f1c00 } = {}) {
    const Context = context;
    const initMapStateToProps = $b83e93e5ef3de8b0$var$mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = $b83e93e5ef3de8b0$var$mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = $b83e93e5ef3de8b0$var$mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $cQmXV.useMemo(()=>{
                const _a = props, { reactReduxForwardedRef: reactReduxForwardedRef2 } = _a, wrapperProps2 = $b83e93e5ef3de8b0$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]);
            const ContextToUse = $cQmXV.useMemo(()=>{
                let ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = $cQmXV.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $cQmXV.useMemo(()=>{
                return $b83e93e5ef3de8b0$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $cQmXV.useMemo(()=>{
                if (!shouldHandleStateChanges) return $b83e93e5ef3de8b0$var$NO_SUBSCRIPTION_ARRAY;
                const subscription2 = $b83e93e5ef3de8b0$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                const notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = $cQmXV.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return $b83e93e5ef3de8b0$var$__spreadProps($b83e93e5ef3de8b0$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = $cQmXV.useRef(void 0);
            const lastWrapperProps = $cQmXV.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $cQmXV.useRef(void 0);
            const renderIsScheduled = $cQmXV.useRef(false);
            const isMounted = $cQmXV.useRef(false);
            const latestSubscriptionCallbackError = $cQmXV.useRef(void 0);
            $b83e93e5ef3de8b0$var$useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $cQmXV.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = $cQmXV.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $b83e93e5ef3de8b0$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $b83e93e5ef3de8b0$var$useIsomorphicLayoutEffectWithArgs($b83e93e5ef3de8b0$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $cQmXV.useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `
The error may be correlated with this previous error:
${latestSubscriptionCallbackError.current.stack}

`;
                throw err;
            }
            $b83e93e5ef3de8b0$var$useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = $cQmXV.useMemo(()=>{
                return(// @ts-ignore
                /* @__PURE__ */ $cQmXV.createElement(WrappedComponent, $b83e93e5ef3de8b0$var$__spreadProps($b83e93e5ef3de8b0$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            const renderedChild = $cQmXV.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ $cQmXV.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $cQmXV.memo(ConnectFunction);
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $cQmXV.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $cQmXV.createElement(Connect, $b83e93e5ef3de8b0$var$__spreadProps($b83e93e5ef3de8b0$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $b83e93e5ef3de8b0$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $b83e93e5ef3de8b0$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $b83e93e5ef3de8b0$export$64605811ab45167f = $b83e93e5ef3de8b0$var$_connect;
var $b83e93e5ef3de8b0$export$8807b5ba46f9d0b7 = $b83e93e5ef3de8b0$var$_connect;
// src/components/Provider.tsx
function $b83e93e5ef3de8b0$var$Provider(providerProps) {
    const { children: children, context: context, serverState: serverState, store: store } = providerProps;
    const contextValue = $cQmXV.useMemo(()=>{
        const subscription = $b83e93e5ef3de8b0$var$createSubscription(store);
        const baseContextValue = {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : void 0
        };
        return baseContextValue;
    }, [
        store,
        serverState
    ]);
    const previousState = $cQmXV.useMemo(()=>store.getState(), [
        store
    ]);
    $b83e93e5ef3de8b0$var$useIsomorphicLayoutEffect(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || $b83e93e5ef3de8b0$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $cQmXV.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $b83e93e5ef3de8b0$export$2881499e37b75b9a = $b83e93e5ef3de8b0$var$Provider;
// src/hooks/useReduxContext.ts
function $b83e93e5ef3de8b0$var$createReduxContextHook(context = $b83e93e5ef3de8b0$export$cc80c08dc91f1c00) {
    return function useReduxContext2() {
        const contextValue = $cQmXV.useContext(context);
        return contextValue;
    };
}
var $b83e93e5ef3de8b0$var$useReduxContext = /* @__PURE__ */ $b83e93e5ef3de8b0$var$createReduxContextHook();
// src/hooks/useStore.ts
function $b83e93e5ef3de8b0$export$671dba69185d0304(context = $b83e93e5ef3de8b0$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $b83e93e5ef3de8b0$export$cc80c08dc91f1c00 ? $b83e93e5ef3de8b0$var$useReduxContext : // @ts-ignore
    $b83e93e5ef3de8b0$var$createReduxContextHook(context);
    const useStore2 = ()=>{
        const { store: store } = useReduxContext2();
        return store;
    };
    Object.assign(useStore2, {
        withTypes: ()=>useStore2
    });
    return useStore2;
}
var $b83e93e5ef3de8b0$export$6ccbb43953eebf8 = /* @__PURE__ */ $b83e93e5ef3de8b0$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $b83e93e5ef3de8b0$export$bc9b55530897c558(context = $b83e93e5ef3de8b0$export$cc80c08dc91f1c00) {
    const useStore2 = context === $b83e93e5ef3de8b0$export$cc80c08dc91f1c00 ? $b83e93e5ef3de8b0$export$6ccbb43953eebf8 : $b83e93e5ef3de8b0$export$671dba69185d0304(context);
    const useDispatch2 = ()=>{
        const store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: ()=>useDispatch2
    });
    return useDispatch2;
}
var $b83e93e5ef3de8b0$export$8ad76b76a4c905f8 = /* @__PURE__ */ $b83e93e5ef3de8b0$export$bc9b55530897c558();
var $b83e93e5ef3de8b0$var$refEquality = (a, b)=>a === b;
function $b83e93e5ef3de8b0$export$2b53f90d2bd1cbfb(context = $b83e93e5ef3de8b0$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $b83e93e5ef3de8b0$export$cc80c08dc91f1c00 ? $b83e93e5ef3de8b0$var$useReduxContext : $b83e93e5ef3de8b0$var$createReduxContextHook(context);
    const useSelector2 = (selector, equalityFnOrOptions = {})=>{
        const { equalityFn: equalityFn = $b83e93e5ef3de8b0$var$refEquality } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const reduxContext = useReduxContext2();
        const { store: store, subscription: subscription, getServerState: getServerState } = reduxContext;
        const firstRun = $cQmXV.useRef(true);
        const wrappedSelector = $cQmXV.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector
        ]);
        const selectedState = (0, $e184e13c9f06c781$exports.useSyncExternalStoreWithSelector)(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $cQmXV.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: ()=>useSelector2
    });
    return useSelector2;
}
var $b83e93e5ef3de8b0$export$2105062e25df4afe = /* @__PURE__ */ $b83e93e5ef3de8b0$export$2b53f90d2bd1cbfb();
// src/exports.ts
var $b83e93e5ef3de8b0$export$712ea50be43a7858 = $b83e93e5ef3de8b0$var$defaultNoopBatch;


function $adeb9d53cddaa624$export$2e2bcd8739ae039(o, p) {
    $adeb9d53cddaa624$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $adeb9d53cddaa624$export$2e2bcd8739ae039(o, p);
}


function $6b0af4b8874706ba$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $adeb9d53cddaa624$export$2e2bcd8739ae039)(subClass, superClass);
}



var $cQmXV = parcelRequire("cQmXV");
var $15de6a39776cbd22$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $15de6a39776cbd22$var$ReactIs, $15de6a39776cbd22$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$15de6a39776cbd22$exports = (parcelRequire("keGWe"))();


function $b89b2235dc73b9b5$export$2e2bcd8739ae039() {
    $b89b2235dc73b9b5$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b89b2235dc73b9b5$export$2e2bcd8739ae039.apply(this, arguments);
}


function $5344b827b291c7d3$var$isAbsolute(pathname) {
    return pathname.charAt(0) === "/";
}
// About 1.5x faster than the two-arg version of Array#splice()
function $5344b827b291c7d3$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $5344b827b291c7d3$var$resolvePathname(to, from) {
    if (from === undefined) from = "";
    var toParts = to && to.split("/") || [];
    var fromParts = from && from.split("/") || [];
    var isToAbs = to && $5344b827b291c7d3$var$isAbsolute(to);
    var isFromAbs = from && $5344b827b291c7d3$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $5344b827b291c7d3$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return "/";
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === "." || last === ".." || last === "";
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === ".") $5344b827b291c7d3$var$spliceOne(fromParts, i);
        else if (part === "..") {
            $5344b827b291c7d3$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $5344b827b291c7d3$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift("..");
    if (mustEndAbs && fromParts[0] !== "" && (!fromParts[0] || !$5344b827b291c7d3$var$isAbsolute(fromParts[0]))) fromParts.unshift("");
    var result = fromParts.join("/");
    if (hasTrailingSlash && result.substr(-1) !== "/") result += "/";
    return result;
}
var $5344b827b291c7d3$export$2e2bcd8739ae039 = $5344b827b291c7d3$var$resolvePathname;


function $9349e69ea1339174$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $9349e69ea1339174$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $9349e69ea1339174$var$valueEqual(item, b[index]);
    });
    if (typeof a === "object" || typeof b === "object") {
        var aValue = $9349e69ea1339174$var$valueOf(a);
        var bValue = $9349e69ea1339174$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $9349e69ea1339174$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $9349e69ea1339174$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $9349e69ea1339174$export$2e2bcd8739ae039 = $9349e69ea1339174$var$valueEqual;



var $5419295210f48b37$var$isProduction = true;
var $5419295210f48b37$var$prefix = "Invariant failed";
function $5419295210f48b37$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($5419295210f48b37$var$isProduction) throw new Error($5419295210f48b37$var$prefix);
    var provided = typeof message === "function" ? message() : message;
    var value = provided ? "".concat($5419295210f48b37$var$prefix, ": ").concat(provided) : $5419295210f48b37$var$prefix;
    throw new Error(value);
}


function $45e6502123b39884$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $45e6502123b39884$var$stripLeadingSlash(path) {
    return path.charAt(0) === "/" ? path.substr(1) : path;
}
function $45e6502123b39884$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && "/?#".indexOf(path.charAt(prefix.length)) !== -1;
}
function $45e6502123b39884$var$stripBasename(path, prefix) {
    return $45e6502123b39884$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $45e6502123b39884$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === "/" ? path.slice(0, -1) : path;
}
function $45e6502123b39884$export$8ccf933b0513f8d0(path) {
    var pathname = path || "/";
    var search = "";
    var hash = "";
    var hashIndex = pathname.indexOf("#");
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf("?");
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === "?" ? "" : search,
        hash: hash === "#" ? "" : hash
    };
}
function $45e6502123b39884$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || "/";
    if (search && search !== "?") path += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") path += hash.charAt(0) === "#" ? hash : "#" + hash;
    return path;
}
function $45e6502123b39884$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === "string") {
        // Two-arg form: push(path, state)
        location = $45e6502123b39884$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $b89b2235dc73b9b5$export$2e2bcd8739ae039)({}, path);
        if (location.pathname === undefined) location.pathname = "";
        if (location.search) {
            if (location.search.charAt(0) !== "?") location.search = "?" + location.search;
        } else location.search = "";
        if (location.hash) {
            if (location.hash.charAt(0) !== "#") location.hash = "#" + location.hash;
        } else location.hash = "";
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + "This is likely caused by an invalid percent-encoding.");
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== "/") location.pathname = (0, $5344b827b291c7d3$export$2e2bcd8739ae039)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = "/";
    return location;
}
function $45e6502123b39884$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $9349e69ea1339174$export$2e2bcd8739ae039)(a.state, b.state);
}
function $45e6502123b39884$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === "function" ? prompt(location, action) : prompt;
            if (typeof result === "string") {
                if (typeof getUserConfirmation === "function") getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $45e6502123b39884$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $45e6502123b39884$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $45e6502123b39884$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf("Android 2.") !== -1 || ua.indexOf("Android 4.0") !== -1) && ua.indexOf("Mobile Safari") !== -1 && ua.indexOf("Chrome") === -1 && ua.indexOf("Windows Phone") === -1) return false;
    return window.history && "pushState" in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $45e6502123b39884$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf("Trident") === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $45e6502123b39884$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf("Firefox") === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $45e6502123b39884$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf("CriOS") === -1;
}
var $45e6502123b39884$var$PopStateEvent = "popstate";
var $45e6502123b39884$var$HashChangeEvent = "hashchange";
function $45e6502123b39884$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $45e6502123b39884$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$45e6502123b39884$var$canUseDOM && (0, $5419295210f48b37$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canUseHistory = $45e6502123b39884$var$supportsHistory();
    var needsHashChangeListener = !$45e6502123b39884$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $45e6502123b39884$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $45e6502123b39884$var$stripTrailingSlash($45e6502123b39884$var$addLeadingSlash(props.basename)) : "";
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $45e6502123b39884$var$stripBasename(path, basename);
        return $45e6502123b39884$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $45e6502123b39884$var$createTransitionManager();
    function setState(nextState) {
        (0, $b89b2235dc73b9b5$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($45e6502123b39884$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($45e6502123b39884$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($45e6502123b39884$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $45e6502123b39884$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = "PUSH";
        var location = $45e6502123b39884$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $45e6502123b39884$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($45e6502123b39884$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($45e6502123b39884$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($45e6502123b39884$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($45e6502123b39884$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $45e6502123b39884$var$HashChangeEvent$1 = "hashchange";
var $45e6502123b39884$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === "!" ? path : "!/" + $45e6502123b39884$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === "!" ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $45e6502123b39884$var$stripLeadingSlash,
        decodePath: $45e6502123b39884$var$addLeadingSlash
    },
    slash: {
        encodePath: $45e6502123b39884$var$addLeadingSlash,
        decodePath: $45e6502123b39884$var$addLeadingSlash
    }
};
function $45e6502123b39884$var$stripHash(url) {
    var hashIndex = url.indexOf("#");
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $45e6502123b39884$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf("#");
    return hashIndex === -1 ? "" : href.substring(hashIndex + 1);
}
function $45e6502123b39884$var$pushHashPath(path) {
    window.location.hash = path;
}
function $45e6502123b39884$var$replaceHashPath(path) {
    window.location.replace($45e6502123b39884$var$stripHash(window.location.href) + "#" + path);
}
function $45e6502123b39884$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$45e6502123b39884$var$canUseDOM && (0, $5419295210f48b37$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $45e6502123b39884$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $45e6502123b39884$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? "slash" : _props$hashType;
    var basename = props.basename ? $45e6502123b39884$var$stripTrailingSlash($45e6502123b39884$var$addLeadingSlash(props.basename)) : "";
    var _HashPathCoders$hashT = $45e6502123b39884$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($45e6502123b39884$var$getHashPath());
        if (basename) path = $45e6502123b39884$var$stripBasename(path, basename);
        return $45e6502123b39884$export$90c043f1c57770b8(path);
    }
    var transitionManager = $45e6502123b39884$var$createTransitionManager();
    function setState(nextState) {
        (0, $b89b2235dc73b9b5$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $45e6502123b39884$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $45e6502123b39884$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $45e6502123b39884$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($45e6502123b39884$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($45e6502123b39884$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $45e6502123b39884$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $45e6502123b39884$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $45e6502123b39884$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector("base");
        var href = "";
        if (baseTag && baseTag.getAttribute("href")) href = $45e6502123b39884$var$stripHash(window.location.href);
        return href + "#" + encodePath(basename + $45e6502123b39884$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = "PUSH";
        var location = $45e6502123b39884$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $45e6502123b39884$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $45e6502123b39884$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $45e6502123b39884$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($45e6502123b39884$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $45e6502123b39884$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $45e6502123b39884$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $45e6502123b39884$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $45e6502123b39884$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($45e6502123b39884$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($45e6502123b39884$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($45e6502123b39884$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $45e6502123b39884$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $45e6502123b39884$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        "/"
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $45e6502123b39884$var$createTransitionManager();
    function setState(nextState) {
        (0, $b89b2235dc73b9b5$export$2e2bcd8739ae039)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $45e6502123b39884$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === "string" ? $45e6502123b39884$export$90c043f1c57770b8(entry, undefined, createKey()) : $45e6502123b39884$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $45e6502123b39884$export$fe53371bee54353d;
    function push(path, state) {
        var action = "PUSH";
        var location = $45e6502123b39884$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $45e6502123b39884$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $45e6502123b39884$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = "POP";
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: "POP",
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}




function $e036e5b583d268c4$export$2e2bcd8739ae039() {
    $e036e5b583d268c4$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e036e5b583d268c4$export$2e2bcd8739ae039.apply(this, arguments);
}


var $b7d24e21982fde27$exports = {};
var $863f3576fb1768dd$exports = {};
$863f3576fb1768dd$exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == "[object Array]";
};


/**
 * Expose `pathToRegexp`.
 */ $b7d24e21982fde27$exports = $b7d24e21982fde27$var$pathToRegexp;
$b7d24e21982fde27$exports.parse = $b7d24e21982fde27$var$parse;
$b7d24e21982fde27$exports.compile = $b7d24e21982fde27$var$compile;
$b7d24e21982fde27$exports.tokensToFunction = $b7d24e21982fde27$var$tokensToFunction;
$b7d24e21982fde27$exports.tokensToRegExp = $b7d24e21982fde27$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $b7d24e21982fde27$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    "(\\\\.)",
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    "([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))"
].join("|"), "g");
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $b7d24e21982fde27$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = "";
    var defaultDelimiter = options && options.delimiter || "/";
    var res;
    while((res = $b7d24e21982fde27$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = "";
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === "+" || modifier === "*";
        var optional = modifier === "?" || modifier === "*";
        var delimiter = res[2] || defaultDelimiter;
        var pattern = capture || group;
        tokens.push({
            name: name || key++,
            prefix: prefix || "",
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $b7d24e21982fde27$var$escapeGroup(pattern) : asterisk ? ".*" : "[^" + $b7d24e21982fde27$var$escapeString(delimiter) + "]+?"
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $b7d24e21982fde27$var$compile(str, options) {
    return $b7d24e21982fde27$var$tokensToFunction($b7d24e21982fde27$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $b7d24e21982fde27$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $b7d24e21982fde27$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $b7d24e21982fde27$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === "object") matches[i] = new RegExp("^(?:" + tokens[i].pattern + ")$", $b7d24e21982fde27$var$flags(options));
    return function(obj, opts) {
        var path = "";
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $b7d24e21982fde27$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($863f3576fb1768dd$exports(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + "`");
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + "`");
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $b7d24e21982fde27$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $b7d24e21982fde27$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, "\\$1");
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $b7d24e21982fde27$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, "\\$1");
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $b7d24e21982fde27$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $b7d24e21982fde27$var$flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $b7d24e21982fde27$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $b7d24e21982fde27$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $b7d24e21982fde27$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($b7d24e21982fde27$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp("(?:" + parts.join("|") + ")", $b7d24e21982fde27$var$flags(options));
    return $b7d24e21982fde27$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $b7d24e21982fde27$var$stringToRegexp(path, keys, options) {
    return $b7d24e21982fde27$var$tokensToRegExp($b7d24e21982fde27$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $b7d24e21982fde27$var$tokensToRegExp(tokens, keys, options) {
    if (!$863f3576fb1768dd$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = "";
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === "string") route += $b7d24e21982fde27$var$escapeString(token);
        else {
            var prefix = $b7d24e21982fde27$var$escapeString(token.prefix);
            var capture = "(?:" + token.pattern + ")";
            keys.push(token);
            if (token.repeat) capture += "(?:" + prefix + capture + ")*";
            if (token.optional) {
                if (!token.partial) capture = "(?:" + prefix + "(" + capture + "))?";
                else capture = prefix + "(" + capture + ")?";
            } else capture = prefix + "(" + capture + ")";
            route += capture;
        }
    }
    var delimiter = $b7d24e21982fde27$var$escapeString(options.delimiter || "/");
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + "(?:" + delimiter + "(?=$))?";
    if (end) route += "$";
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? "" : "(?=" + delimiter + "|$)";
    return $b7d24e21982fde27$var$attachKeys(new RegExp("^" + route, $b7d24e21982fde27$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $b7d24e21982fde27$var$pathToRegexp(path, keys, options) {
    if (!$863f3576fb1768dd$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $b7d24e21982fde27$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($863f3576fb1768dd$exports(path)) return $b7d24e21982fde27$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $b7d24e21982fde27$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}


var $21f6602429e2c0ce$exports = {};
"use strict";

$21f6602429e2c0ce$exports = (parcelRequire("9fiKv"));


function $f80f46f2f14e982b$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var $dbf5b6306a11b711$exports = {};
"use strict";

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $dbf5b6306a11b711$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $dbf5b6306a11b711$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $dbf5b6306a11b711$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $dbf5b6306a11b711$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $dbf5b6306a11b711$var$TYPE_STATICS = {};
$dbf5b6306a11b711$var$TYPE_STATICS[$21f6602429e2c0ce$exports.ForwardRef] = $dbf5b6306a11b711$var$FORWARD_REF_STATICS;
$dbf5b6306a11b711$var$TYPE_STATICS[$21f6602429e2c0ce$exports.Memo] = $dbf5b6306a11b711$var$MEMO_STATICS;
function $dbf5b6306a11b711$var$getStatics(component) {
    // React v16.11 and below
    if ($21f6602429e2c0ce$exports.isMemo(component)) return $dbf5b6306a11b711$var$MEMO_STATICS;
     // React v16.12 and above
    return $dbf5b6306a11b711$var$TYPE_STATICS[component["$$typeof"]] || $dbf5b6306a11b711$var$REACT_STATICS;
}
var $dbf5b6306a11b711$var$defineProperty = Object.defineProperty;
var $dbf5b6306a11b711$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $dbf5b6306a11b711$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $dbf5b6306a11b711$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $dbf5b6306a11b711$var$getPrototypeOf = Object.getPrototypeOf;
var $dbf5b6306a11b711$var$objectPrototype = Object.prototype;
function $dbf5b6306a11b711$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($dbf5b6306a11b711$var$objectPrototype) {
            var inheritedComponent = $dbf5b6306a11b711$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $dbf5b6306a11b711$var$objectPrototype) $dbf5b6306a11b711$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $dbf5b6306a11b711$var$getOwnPropertyNames(sourceComponent);
        if ($dbf5b6306a11b711$var$getOwnPropertySymbols) keys = keys.concat($dbf5b6306a11b711$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $dbf5b6306a11b711$var$getStatics(targetComponent);
        var sourceStatics = $dbf5b6306a11b711$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$dbf5b6306a11b711$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $dbf5b6306a11b711$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $dbf5b6306a11b711$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$dbf5b6306a11b711$exports = $dbf5b6306a11b711$var$hoistNonReactStatics;


var $6f5d68f762d5488a$var$MAX_SIGNED_31_BIT_INT = 1073741823;
var $6f5d68f762d5488a$var$commonjsGlobal = typeof globalThis !== "undefined" // 'global proper'
 ? globalThis : typeof window !== "undefined" ? window // Browser
 : typeof $parcel$global !== "undefined" ? $parcel$global // node.js
 : {};
function $6f5d68f762d5488a$var$getUniqueId() {
    var key = "__global_unique_id__";
    return $6f5d68f762d5488a$var$commonjsGlobal[key] = ($6f5d68f762d5488a$var$commonjsGlobal[key] || 0) + 1;
} // Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function $6f5d68f762d5488a$var$objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else // eslint-disable-next-line no-self-compare
    return x !== x && y !== y;
}
function $6f5d68f762d5488a$var$createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function $6f5d68f762d5488a$var$onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function $6f5d68f762d5488a$var$createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + $6f5d68f762d5488a$var$getUniqueId() + "__";
    var Provider = /*#__PURE__*/ function(_React$Component) {
        (0, $6b0af4b8874706ba$export$2e2bcd8739ae039)(Provider, _React$Component);
        function Provider() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.emitter = $6f5d68f762d5488a$var$createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if ($6f5d68f762d5488a$var$objectIs(oldValue, newValue)) changedBits = 0; // No change
                else {
                    changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : $6f5d68f762d5488a$var$MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Component);
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($15de6a39776cbd22$exports))).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_React$Component2) {
        (0, $6b0af4b8874706ba$export$2e2bcd8739ae039)(Consumer, _React$Component2);
        function Consumer() {
            var _this2;
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            _this2 = _React$Component2.call.apply(_React$Component2, [
                this
            ].concat(args)) || this;
            _this2.observedBits = void 0;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $6f5d68f762d5488a$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $6f5d68f762d5488a$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return $6f5d68f762d5488a$var$onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Component);
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($15de6a39776cbd22$exports))).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
// MIT License
var $6f5d68f762d5488a$var$createContext = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createContext || $6f5d68f762d5488a$var$createReactContext;
// TODO: Replace with React.createContext once we can assume React 16+
var $6f5d68f762d5488a$var$createNamedContext = function createNamedContext(name) {
    var context = $6f5d68f762d5488a$var$createContext();
    context.displayName = name;
    return context;
};
var $6f5d68f762d5488a$export$c213558b66925821 = /*#__PURE__*/ $6f5d68f762d5488a$var$createNamedContext("Router-History");
var $6f5d68f762d5488a$export$63baa8ccbe60bb07 = /*#__PURE__*/ $6f5d68f762d5488a$var$createNamedContext("Router");
/**
 * The public API for putting history on context.
 */ var $6f5d68f762d5488a$export$55185c17a0fcbe46 = /*#__PURE__*/ function(_React$Component) {
    (0, $6b0af4b8874706ba$export$2e2bcd8739ae039)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        this._isMounted = true;
        if (this.unlisten) // Any pre-mount location changes have been captured at
        // this point, so unregister the listener.
        this.unlisten();
        if (!this.props.staticContext) this.unlisten = this.props.history.listen(function(location) {
            if (_this2._isMounted) _this2.setState({
                location: location
            });
        });
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
            this._isMounted = false;
            this._pendingLocation = null;
        }
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($6f5d68f762d5488a$export$63baa8ccbe60bb07.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($6f5d68f762d5488a$export$c213558b66925821.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var $6f5d68f762d5488a$export$ae46f04cfaffe093 = /*#__PURE__*/ function(_React$Component) {
    (0, $6b0af4b8874706ba$export$2e2bcd8739ae039)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $45e6502123b39884$export$2b76ad033c6e6d08)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($6f5d68f762d5488a$export$55185c17a0fcbe46, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Component);
var $6f5d68f762d5488a$var$Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, $6b0af4b8874706ba$export$2e2bcd8739ae039)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function $6f5d68f762d5488a$export$83716a4aa1642908(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($6f5d68f762d5488a$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $5419295210f48b37$export$2e2bcd8739ae039)(false);
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($6f5d68f762d5488a$var$Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var $6f5d68f762d5488a$var$messageType;
var $6f5d68f762d5488a$var$cache = {};
var $6f5d68f762d5488a$var$cacheLimit = 10000;
var $6f5d68f762d5488a$var$cacheCount = 0;
function $6f5d68f762d5488a$var$compilePath(path) {
    if ($6f5d68f762d5488a$var$cache[path]) return $6f5d68f762d5488a$var$cache[path];
    var generator = (0, (/*@__PURE__*/$parcel$interopDefault($b7d24e21982fde27$exports))).compile(path);
    if ($6f5d68f762d5488a$var$cacheCount < $6f5d68f762d5488a$var$cacheLimit) {
        $6f5d68f762d5488a$var$cache[path] = generator;
        $6f5d68f762d5488a$var$cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function $6f5d68f762d5488a$export$82476f982757e71e(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : $6f5d68f762d5488a$var$compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function $6f5d68f762d5488a$export$2d8d895a0a0f636e(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($6f5d68f762d5488a$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $5419295210f48b37$export$2e2bcd8739ae039)(false);
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, $45e6502123b39884$export$90c043f1c57770b8)(computedMatch ? typeof to === "string" ? $6f5d68f762d5488a$export$82476f982757e71e(to, computedMatch.params) : (0, $e036e5b583d268c4$export$2e2bcd8739ae039)({}, to, {
            pathname: $6f5d68f762d5488a$export$82476f982757e71e(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($6f5d68f762d5488a$var$Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, $45e6502123b39884$export$90c043f1c57770b8)(prevProps.to);
                if (!(0, $45e6502123b39884$export$c3e8bb440bd55b18)(prevLocation, (0, $e036e5b583d268c4$export$2e2bcd8739ae039)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
var $6f5d68f762d5488a$var$cache$1 = {};
var $6f5d68f762d5488a$var$cacheLimit$1 = 10000;
var $6f5d68f762d5488a$var$cacheCount$1 = 0;
function $6f5d68f762d5488a$var$compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = $6f5d68f762d5488a$var$cache$1[cacheKey] || ($6f5d68f762d5488a$var$cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, (/*@__PURE__*/$parcel$interopDefault($b7d24e21982fde27$exports)))(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if ($6f5d68f762d5488a$var$cacheCount$1 < $6f5d68f762d5488a$var$cacheLimit$1) {
        pathCache[path] = result;
        $6f5d68f762d5488a$var$cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function $6f5d68f762d5488a$export$81336c211d5ff295(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = $6f5d68f762d5488a$var$compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function $6f5d68f762d5488a$var$isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Children.count(children) === 0;
}
function $6f5d68f762d5488a$var$evalChildrenDev(children, props, path) {
    var value = children(props);
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var $6f5d68f762d5488a$export$e7b0ac011bb776c6 = /*#__PURE__*/ function(_React$Component) {
    (0, $6b0af4b8874706ba$export$2e2bcd8739ae039)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($6f5d68f762d5488a$export$63baa8ccbe60bb07.Consumer, null, function(context$1) {
            !context$1 && (0, $5419295210f48b37$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? $6f5d68f762d5488a$export$81336c211d5ff295(location.pathname, _this.props) : context$1.match;
            var props = (0, $e036e5b583d268c4$export$2e2bcd8739ae039)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && $6f5d68f762d5488a$var$isEmptyChildren(children)) children = null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($6f5d68f762d5488a$export$63baa8ccbe60bb07.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? children(props) : children : component ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? children(props) : null);
        });
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Component);
function $6f5d68f762d5488a$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $6f5d68f762d5488a$var$addBasename(basename, location) {
    if (!basename) return location;
    return (0, $e036e5b583d268c4$export$2e2bcd8739ae039)({}, location, {
        pathname: $6f5d68f762d5488a$var$addLeadingSlash(basename) + location.pathname
    });
}
function $6f5d68f762d5488a$var$stripBasename(basename, location) {
    if (!basename) return location;
    var base = $6f5d68f762d5488a$var$addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, $e036e5b583d268c4$export$2e2bcd8739ae039)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function $6f5d68f762d5488a$var$createURL(location) {
    return typeof location === "string" ? location : (0, $45e6502123b39884$export$fe53371bee54353d)(location);
}
function $6f5d68f762d5488a$var$staticHandler(methodName) {
    return function() {
        (0, $5419295210f48b37$export$2e2bcd8739ae039)(false);
    };
}
function $6f5d68f762d5488a$var$noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var $6f5d68f762d5488a$export$cac06da4d76d935b = /*#__PURE__*/ function(_React$Component) {
    (0, $6b0af4b8874706ba$export$2e2bcd8739ae039)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return $6f5d68f762d5488a$var$noop;
        };
        _this.handleBlock = function() {
            return $6f5d68f762d5488a$var$noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = $6f5d68f762d5488a$var$addBasename(basename, (0, $45e6502123b39884$export$90c043f1c57770b8)(location));
        context.url = $6f5d68f762d5488a$var$createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, $f80f46f2f14e982b$export$2e2bcd8739ae039)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return $6f5d68f762d5488a$var$addLeadingSlash(basename + $6f5d68f762d5488a$var$createURL(path));
            },
            action: "POP",
            location: $6f5d68f762d5488a$var$stripBasename(basename, (0, $45e6502123b39884$export$90c043f1c57770b8)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: $6f5d68f762d5488a$var$staticHandler("go"),
            goBack: $6f5d68f762d5488a$var$staticHandler("goBack"),
            goForward: $6f5d68f762d5488a$var$staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($6f5d68f762d5488a$export$55185c17a0fcbe46, (0, $e036e5b583d268c4$export$2e2bcd8739ae039)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var $6f5d68f762d5488a$export$b5d5cf8927ab7262 = /*#__PURE__*/ function(_React$Component) {
    (0, $6b0af4b8874706ba$export$2e2bcd8739ae039)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($6f5d68f762d5488a$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $5419295210f48b37$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Children.forEach(_this.props.children, function(child) {
                if (match == null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? $6f5d68f762d5488a$export$81336c211d5ff295(location.pathname, (0, $e036e5b583d268c4$export$2e2bcd8739ae039)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Component);
/**
 * A public higher-order component to access the imperative API
 */ function $6f5d68f762d5488a$export$369b6b2b30582e8e(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, $f80f46f2f14e982b$export$2e2bcd8739ae039)(props, [
            "wrappedComponentRef"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($6f5d68f762d5488a$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $5419295210f48b37$export$2e2bcd8739ae039)(false);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement(Component, (0, $e036e5b583d268c4$export$2e2bcd8739ae039)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    return (0, (/*@__PURE__*/$parcel$interopDefault($dbf5b6306a11b711$exports)))(C, Component);
}
var $6f5d68f762d5488a$var$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useContext;
function $6f5d68f762d5488a$export$3420e1dc2c4a518c() {
    return $6f5d68f762d5488a$var$useContext($6f5d68f762d5488a$export$c213558b66925821);
}
function $6f5d68f762d5488a$export$45d76561a5302f2b() {
    return $6f5d68f762d5488a$var$useContext($6f5d68f762d5488a$export$63baa8ccbe60bb07).location;
}
function $6f5d68f762d5488a$export$99eaa27ddbbb95ef() {
    var match = $6f5d68f762d5488a$var$useContext($6f5d68f762d5488a$export$63baa8ccbe60bb07).match;
    return match ? match.params : {};
}
function $6f5d68f762d5488a$export$632be4bb944c1bc7(path) {
    var location = $6f5d68f762d5488a$export$45d76561a5302f2b();
    var match = $6f5d68f762d5488a$var$useContext($6f5d68f762d5488a$export$63baa8ccbe60bb07).match;
    return path ? $6f5d68f762d5488a$export$81336c211d5ff295(location.pathname, path) : match;
}
var $6f5d68f762d5488a$var$global$1, $6f5d68f762d5488a$var$key, $6f5d68f762d5488a$var$buildNames, $6f5d68f762d5488a$var$initialBuildName, $6f5d68f762d5488a$var$secondaryBuildName;


function $cb2783116e3bd5d0$export$2e2bcd8739ae039(o, p) {
    $cb2783116e3bd5d0$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $cb2783116e3bd5d0$export$2e2bcd8739ae039(o, p);
}


function $b3c57d5f93ff83f9$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $cb2783116e3bd5d0$export$2e2bcd8739ae039)(subClass, superClass);
}



var $cQmXV = parcelRequire("cQmXV");



function $2477d41dc1d121a0$export$2e2bcd8739ae039() {
    $2477d41dc1d121a0$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2477d41dc1d121a0$export$2e2bcd8739ae039.apply(this, arguments);
}


function $dc489fce59f1bd59$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $50f22649d61cdefc$export$9ba4e89fdfa1fc54 = /*#__PURE__*/ function(_React$Component) {
    (0, $b3c57d5f93ff83f9$export$2e2bcd8739ae039)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $45e6502123b39884$export$719fc203c4e16dee)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $6f5d68f762d5488a$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $50f22649d61cdefc$export$7221d69dcfc8e36b = /*#__PURE__*/ function(_React$Component) {
    (0, $b3c57d5f93ff83f9$export$2e2bcd8739ae039)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $45e6502123b39884$export$b71fdd3798280242)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $6f5d68f762d5488a$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Component);
var $50f22649d61cdefc$var$resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var $50f22649d61cdefc$var$normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, $45e6502123b39884$export$90c043f1c57770b8)(to, null, null, currentLocation) : to;
};
var $50f22649d61cdefc$var$forwardRefShim = function forwardRefShim(C) {
    return C;
};
var $50f22649d61cdefc$var$forwardRef = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).forwardRef;
if (typeof $50f22649d61cdefc$var$forwardRef === "undefined") $50f22649d61cdefc$var$forwardRef = $50f22649d61cdefc$var$forwardRefShim;
function $50f22649d61cdefc$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $50f22649d61cdefc$var$LinkAnchor = $50f22649d61cdefc$var$forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, $dc489fce59f1bd59$export$2e2bcd8739ae039)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, $2477d41dc1d121a0$export$2e2bcd8739ae039)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !$50f22649d61cdefc$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if ($50f22649d61cdefc$var$forwardRefShim !== $50f22649d61cdefc$var$forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var $50f22649d61cdefc$export$a6c7ac8248d6e38a = $50f22649d61cdefc$var$forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? $50f22649d61cdefc$var$LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, $dc489fce59f1bd59$export$2e2bcd8739ae039)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $6f5d68f762d5488a$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $5419295210f48b37$export$2e2bcd8739ae039)(false);
        var history = context.history;
        var location = $50f22649d61cdefc$var$normalizeToLocation($50f22649d61cdefc$var$resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, $2477d41dc1d121a0$export$2e2bcd8739ae039)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = $50f22649d61cdefc$var$resolveToLocation(to, context.location);
                var isDuplicateNavigation = (0, $45e6502123b39884$export$fe53371bee54353d)(context.location) === (0, $45e6502123b39884$export$fe53371bee54353d)($50f22649d61cdefc$var$normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if ($50f22649d61cdefc$var$forwardRefShim !== $50f22649d61cdefc$var$forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement(component, props);
    });
});
var $50f22649d61cdefc$var$toType, $50f22649d61cdefc$var$refType;
var $50f22649d61cdefc$var$forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var $50f22649d61cdefc$var$forwardRef$1 = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).forwardRef;
if (typeof $50f22649d61cdefc$var$forwardRef$1 === "undefined") $50f22649d61cdefc$var$forwardRef$1 = $50f22649d61cdefc$var$forwardRefShim$1;
function $50f22649d61cdefc$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $50f22649d61cdefc$export$b0d92dbee9b5b60d = $50f22649d61cdefc$var$forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, $dc489fce59f1bd59$export$2e2bcd8739ae039)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $6f5d68f762d5488a$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $5419295210f48b37$export$2e2bcd8739ae039)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = $50f22649d61cdefc$var$normalizeToLocation($50f22649d61cdefc$var$resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, $6f5d68f762d5488a$export$81336c211d5ff295)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = $50f22649d61cdefc$var$joinClassnames(className, activeClassName);
            style = (0, $2477d41dc1d121a0$export$2e2bcd8739ae039)({}, style, activeStyle);
        }
        var props = (0, $2477d41dc1d121a0$export$2e2bcd8739ae039)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if ($50f22649d61cdefc$var$forwardRefShim$1 !== $50f22649d61cdefc$var$forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($50f22649d61cdefc$export$a6c7ac8248d6e38a, props);
    });
});
var $50f22649d61cdefc$var$ariaCurrentType;



var $cQmXV = parcelRequire("cQmXV");

"use client";
var $896e8f74d1491439$var$L = (t)=>typeof t == "number" && !isNaN(t), $896e8f74d1491439$var$N = (t)=>typeof t == "string", $896e8f74d1491439$var$P = (t)=>typeof t == "function", $896e8f74d1491439$var$ut = (t)=>$896e8f74d1491439$var$N(t) || $896e8f74d1491439$var$L(t), $896e8f74d1491439$var$z = (t)=>$896e8f74d1491439$var$N(t) || $896e8f74d1491439$var$P(t) ? t : null, $896e8f74d1491439$var$yt = (t, o)=>t === !1 || $896e8f74d1491439$var$L(t) && t > 0 ? t : o, $896e8f74d1491439$var$F = (t)=>(0, $cQmXV.isValidElement)(t) || $896e8f74d1491439$var$N(t) || $896e8f74d1491439$var$P(t) || $896e8f74d1491439$var$L(t);
function $896e8f74d1491439$export$184cca501f1aed7f(t, o, e = 300) {
    let { scrollHeight: r, style: a } = t;
    requestAnimationFrame(()=>{
        a.minHeight = "initial", a.height = r + "px", a.transition = `all ${e}ms`, requestAnimationFrame(()=>{
            a.height = "0", a.padding = "0", a.margin = "0", setTimeout(o, e);
        });
    });
}
function $896e8f74d1491439$export$3ff7dc44d332d222({ enter: t, exit: o, appendPosition: e = !1, collapse: r = !0, collapseDuration: a = 300 }) {
    return function({ children: s, position: f, preventExitTransition: c, done: T, nodeRef: g, isIn: v, playToast: x }) {
        let C = e ? `${t}--${f}` : t, S = e ? `${o}--${f}` : o, E = (0, $cQmXV.useRef)(0);
        return (0, $cQmXV.useLayoutEffect)(()=>{
            let d = g.current, p = C.split(" "), b = (n)=>{
                n.target === g.current && (x(), d.removeEventListener("animationend", b), d.removeEventListener("animationcancel", b), E.current === 0 && n.type !== "animationcancel" && d.classList.remove(...p));
            };
            d.classList.add(...p), d.addEventListener("animationend", b), d.addEventListener("animationcancel", b);
        }, []), (0, $cQmXV.useEffect)(()=>{
            let d = g.current, p = ()=>{
                d.removeEventListener("animationend", p), r ? $896e8f74d1491439$export$184cca501f1aed7f(d, T, a) : T();
            };
            v || (c ? p() : (E.current = 1, d.className += ` ${S}`, d.addEventListener("animationend", p)));
        }, [
            v
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Fragment, null, s);
    };
}
function $896e8f74d1491439$var$tt(t, o) {
    return {
        content: $896e8f74d1491439$var$ot(t.content, t.props),
        containerId: t.props.containerId,
        id: t.props.toastId,
        theme: t.props.theme,
        type: t.props.type,
        data: t.props.data || {},
        isLoading: t.props.isLoading,
        icon: t.props.icon,
        reason: t.removalReason,
        status: o
    };
}
function $896e8f74d1491439$var$ot(t, o, e = !1) {
    return (0, $cQmXV.isValidElement)(t) && !$896e8f74d1491439$var$N(t.type) ? (0, $cQmXV.cloneElement)(t, {
        closeToast: o.closeToast,
        toastProps: o,
        data: o.data,
        isPaused: e
    }) : $896e8f74d1491439$var$P(t) ? t({
        closeToast: o.closeToast,
        toastProps: o,
        data: o.data,
        isPaused: e
    }) : t;
}
function $896e8f74d1491439$var$gt({ closeToast: t, theme: o, ariaLabel: e = "close" }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("button", {
        className: `Toastify__close-button Toastify__close-button--${o}`,
        type: "button",
        onClick: (r)=>{
            r.stopPropagation(), t(!0);
        },
        "aria-label": e
    }, (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("svg", {
        "aria-hidden": "true",
        viewBox: "0 0 14 16"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("path", {
        fillRule: "evenodd",
        d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
    })));
}
function $896e8f74d1491439$var$bt({ delay: t, isRunning: o, closeToast: e, type: r = "default", hide: a, className: l, controlledProgress: s, progress: f, rtl: c, isIn: T, theme: g }) {
    let v = a || s && f === 0, x = {
        animationDuration: `${t}ms`,
        animationPlayState: o ? "running" : "paused"
    };
    s && (x.transform = `scaleX(${f})`);
    let C = (0, $772fd6e40f1fbf40$export$2e2bcd8739ae039)("Toastify__progress-bar", s ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${g}`, `Toastify__progress-bar--${r}`, {
        ["Toastify__progress-bar--rtl"]: c
    }), S = $896e8f74d1491439$var$P(l) ? l({
        rtl: c,
        type: r,
        defaultClassName: C
    }) : (0, $772fd6e40f1fbf40$export$2e2bcd8739ae039)(C, l), E = {
        [s && f >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: s && f < 1 ? null : ()=>{
            T && e();
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
        className: "Toastify__progress-bar--wrp",
        "data-hidden": v
    }, (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
        className: `Toastify__progress-bar--bg Toastify__progress-bar-theme--${g} Toastify__progress-bar--${r}`
    }), (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
        role: "progressbar",
        "aria-hidden": v ? "true" : "false",
        "aria-label": "notification timer",
        "aria-valuenow": s ? Math.round(f * 100) : void 0,
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        className: S,
        style: x,
        ...E
    }));
}
var $896e8f74d1491439$var$Qt = 1, $896e8f74d1491439$var$st = ()=>`${$896e8f74d1491439$var$Qt++}`;
function $896e8f74d1491439$var$vt(t, o, e) {
    let r = 1, a = 0, l = [], s = [], f = o, c = new Map, T = new Set, g = (i)=>(T.add(i), ()=>T.delete(i)), v = ()=>{
        s = Array.from(c.values()), T.forEach((i)=>i());
    }, x = ({ containerId: i, toastId: n, updateId: u })=>{
        let h = i ? i !== t : t !== 1, m = c.has(n) && u == null;
        return h || m;
    }, C = (i, n)=>{
        c.forEach((u)=>{
            var h;
            (n == null || n === u.props.toastId) && ((h = u.toggle) == null || h.call(u, i));
        });
    }, S = (i)=>{
        var n, u;
        i.isActive && ((u = (n = i.props) == null ? void 0 : n.onClose) == null || u.call(n, i.removalReason), i.isActive = !1, e($896e8f74d1491439$var$tt(i, "removed")));
    }, E = (i)=>{
        if (i == null) c.forEach(S);
        else {
            let n = c.get(i);
            n && S(n);
        }
        v();
    }, d = ()=>{
        a -= l.length, l = [];
    }, p = (i)=>{
        var m, _;
        let { toastId: n, updateId: u } = i.props, h = u == null;
        i.staleId && c.delete(i.staleId), i.isActive = !0, c.set(n, i), v(), e($896e8f74d1491439$var$tt(i, h ? "added" : "updated")), h && ((_ = (m = i.props).onOpen) == null || _.call(m));
    };
    return {
        id: t,
        props: f,
        observe: g,
        toggle: C,
        removeToast: E,
        toasts: c,
        clearQueue: d,
        buildToast: (i, n)=>{
            if (x(n)) return;
            let { toastId: u, updateId: h, data: m, staleId: _, delay: k } = n, D = h == null;
            D && a++;
            let A = {
                ...f,
                style: f.toastStyle,
                key: r++,
                ...Object.fromEntries(Object.entries(n).filter(([M, $])=>$ != null)),
                toastId: u,
                updateId: h,
                data: m,
                isIn: !1,
                className: $896e8f74d1491439$var$z(n.className || f.toastClassName),
                progressClassName: $896e8f74d1491439$var$z(n.progressClassName || f.progressClassName),
                autoClose: n.isLoading ? !1 : $896e8f74d1491439$var$yt(n.autoClose, f.autoClose),
                closeToast (M) {
                    let $ = c.get(u);
                    $ && ($.removalReason = M, E(u));
                },
                deleteToast () {
                    if (c.get(u) != null) {
                        if (c.delete(u), a--, a < 0 && (a = 0), l.length > 0) {
                            p(l.shift());
                            return;
                        }
                        v();
                    }
                }
            };
            A.closeButton = f.closeButton, n.closeButton === !1 || $896e8f74d1491439$var$F(n.closeButton) ? A.closeButton = n.closeButton : n.closeButton === !0 && (A.closeButton = $896e8f74d1491439$var$F(f.closeButton) ? f.closeButton : !0);
            let B = {
                content: i,
                props: A,
                staleId: _
            };
            f.limit && f.limit > 0 && a > f.limit && D ? l.push(B) : $896e8f74d1491439$var$L(k) ? setTimeout(()=>{
                p(B);
            }, k) : p(B);
        },
        setProps (i) {
            f = i;
        },
        setToggle: (i, n)=>{
            let u = c.get(i);
            u && (u.toggle = n);
        },
        isToastActive: (i)=>{
            var n;
            return (n = c.get(i)) == null ? void 0 : n.isActive;
        },
        getSnapshot: ()=>s
    };
}
var $896e8f74d1491439$var$I = new Map, $896e8f74d1491439$var$U = [], $896e8f74d1491439$var$rt = new Set, $896e8f74d1491439$var$Wt = (t)=>$896e8f74d1491439$var$rt.forEach((o)=>o(t)), $896e8f74d1491439$var$ht = ()=>$896e8f74d1491439$var$I.size > 0;
function $896e8f74d1491439$var$Gt() {
    $896e8f74d1491439$var$U.forEach((t)=>$896e8f74d1491439$var$nt(t.content, t.options)), $896e8f74d1491439$var$U = [];
}
var $896e8f74d1491439$var$Ct = (t, { containerId: o })=>{
    var e;
    return (e = $896e8f74d1491439$var$I.get(o || 1)) == null ? void 0 : e.toasts.get(t);
};
function $896e8f74d1491439$var$X(t, o) {
    var r;
    if (o) return !!((r = $896e8f74d1491439$var$I.get(o)) != null && r.isToastActive(t));
    let e = !1;
    return $896e8f74d1491439$var$I.forEach((a)=>{
        a.isToastActive(t) && (e = !0);
    }), e;
}
function $896e8f74d1491439$var$xt(t) {
    if (!$896e8f74d1491439$var$ht()) {
        $896e8f74d1491439$var$U = $896e8f74d1491439$var$U.filter((o)=>t != null && o.options.toastId !== t);
        return;
    }
    if (t == null || $896e8f74d1491439$var$ut(t)) $896e8f74d1491439$var$I.forEach((o)=>{
        o.removeToast(t);
    });
    else if (t && ("containerId" in t || "id" in t)) {
        let o = $896e8f74d1491439$var$I.get(t.containerId);
        o ? o.removeToast(t.id) : $896e8f74d1491439$var$I.forEach((e)=>{
            e.removeToast(t.id);
        });
    }
}
var $896e8f74d1491439$var$Et = (t = {})=>{
    $896e8f74d1491439$var$I.forEach((o)=>{
        o.props.limit && (!t.containerId || o.id === t.containerId) && o.clearQueue();
    });
};
function $896e8f74d1491439$var$nt(t, o) {
    $896e8f74d1491439$var$F(t) && ($896e8f74d1491439$var$ht() || $896e8f74d1491439$var$U.push({
        content: t,
        options: o
    }), $896e8f74d1491439$var$I.forEach((e)=>{
        e.buildToast(t, o);
    }));
}
function $896e8f74d1491439$var$Pt(t) {
    var o;
    (o = $896e8f74d1491439$var$I.get(t.containerId || 1)) == null || o.setToggle(t.id, t.fn);
}
function $896e8f74d1491439$var$it(t, o) {
    $896e8f74d1491439$var$I.forEach((e)=>{
        (o == null || !(o != null && o.containerId) || (o == null ? void 0 : o.containerId) === e.id) && e.toggle(t, o == null ? void 0 : o.id);
    });
}
function $896e8f74d1491439$var$It(t) {
    let o = t.containerId || 1;
    return {
        subscribe (e) {
            let r = $896e8f74d1491439$var$vt(o, t, $896e8f74d1491439$var$Wt);
            $896e8f74d1491439$var$I.set(o, r);
            let a = r.observe(e);
            return $896e8f74d1491439$var$Gt(), ()=>{
                a(), $896e8f74d1491439$var$I.delete(o);
            };
        },
        setProps (e) {
            var r;
            (r = $896e8f74d1491439$var$I.get(o)) == null || r.setProps(e);
        },
        getSnapshot () {
            var e;
            return (e = $896e8f74d1491439$var$I.get(o)) == null ? void 0 : e.getSnapshot();
        }
    };
}
function $896e8f74d1491439$var$St(t) {
    return $896e8f74d1491439$var$rt.add(t), ()=>{
        $896e8f74d1491439$var$rt.delete(t);
    };
}
function $896e8f74d1491439$var$qt(t) {
    return t && ($896e8f74d1491439$var$N(t.toastId) || $896e8f74d1491439$var$L(t.toastId)) ? t.toastId : $896e8f74d1491439$var$st();
}
function $896e8f74d1491439$var$H(t, o) {
    return $896e8f74d1491439$var$nt(t, o), o.toastId;
}
function $896e8f74d1491439$var$Q(t, o) {
    return {
        ...o,
        type: o && o.type || t,
        toastId: $896e8f74d1491439$var$qt(o)
    };
}
function $896e8f74d1491439$var$W(t) {
    return (o, e)=>$896e8f74d1491439$var$H(o, $896e8f74d1491439$var$Q(t, e));
}
function $896e8f74d1491439$export$b410431fab84fa58(t, o) {
    return $896e8f74d1491439$var$H(t, $896e8f74d1491439$var$Q("default", o));
}
$896e8f74d1491439$export$b410431fab84fa58.loading = (t, o)=>$896e8f74d1491439$var$H(t, $896e8f74d1491439$var$Q("default", {
        isLoading: !0,
        autoClose: !1,
        closeOnClick: !1,
        closeButton: !1,
        draggable: !1,
        ...o
    }));
function $896e8f74d1491439$var$Kt(t, { pending: o, error: e, success: r }, a) {
    let l;
    o && (l = $896e8f74d1491439$var$N(o) ? $896e8f74d1491439$export$b410431fab84fa58.loading(o, a) : $896e8f74d1491439$export$b410431fab84fa58.loading(o.render, {
        ...a,
        ...o
    }));
    let s = {
        isLoading: null,
        autoClose: null,
        closeOnClick: null,
        closeButton: null,
        draggable: null
    }, f = (T, g, v)=>{
        if (g == null) {
            $896e8f74d1491439$export$b410431fab84fa58.dismiss(l);
            return;
        }
        let x = {
            type: T,
            ...s,
            ...a,
            data: v
        }, C = $896e8f74d1491439$var$N(g) ? {
            render: g
        } : g;
        return l ? $896e8f74d1491439$export$b410431fab84fa58.update(l, {
            ...x,
            ...C
        }) : $896e8f74d1491439$export$b410431fab84fa58(C.render, {
            ...x,
            ...C
        }), v;
    }, c = $896e8f74d1491439$var$P(t) ? t() : t;
    return c.then((T)=>f("success", r, T)).catch((T)=>f("error", e, T)), c;
}
$896e8f74d1491439$export$b410431fab84fa58.promise = $896e8f74d1491439$var$Kt;
$896e8f74d1491439$export$b410431fab84fa58.success = $896e8f74d1491439$var$W("success");
$896e8f74d1491439$export$b410431fab84fa58.info = $896e8f74d1491439$var$W("info");
$896e8f74d1491439$export$b410431fab84fa58.error = $896e8f74d1491439$var$W("error");
$896e8f74d1491439$export$b410431fab84fa58.warning = $896e8f74d1491439$var$W("warning");
$896e8f74d1491439$export$b410431fab84fa58.warn = $896e8f74d1491439$export$b410431fab84fa58.warning;
$896e8f74d1491439$export$b410431fab84fa58.dark = (t, o)=>$896e8f74d1491439$var$H(t, $896e8f74d1491439$var$Q("default", {
        theme: "dark",
        ...o
    }));
function $896e8f74d1491439$var$Yt(t) {
    $896e8f74d1491439$var$xt(t);
}
$896e8f74d1491439$export$b410431fab84fa58.dismiss = $896e8f74d1491439$var$Yt;
$896e8f74d1491439$export$b410431fab84fa58.clearWaitingQueue = $896e8f74d1491439$var$Et;
$896e8f74d1491439$export$b410431fab84fa58.isActive = $896e8f74d1491439$var$X;
$896e8f74d1491439$export$b410431fab84fa58.update = (t, o = {})=>{
    let e = $896e8f74d1491439$var$Ct(t, o);
    if (e) {
        let { props: r, content: a } = e, l = {
            delay: 100,
            ...r,
            ...o,
            toastId: o.toastId || t,
            updateId: $896e8f74d1491439$var$st()
        };
        l.toastId !== t && (l.staleId = t);
        let s = l.render || a;
        delete l.render, $896e8f74d1491439$var$H(s, l);
    }
};
$896e8f74d1491439$export$b410431fab84fa58.done = (t)=>{
    $896e8f74d1491439$export$b410431fab84fa58.update(t, {
        progress: 1
    });
};
$896e8f74d1491439$export$b410431fab84fa58.onChange = $896e8f74d1491439$var$St;
$896e8f74d1491439$export$b410431fab84fa58.play = (t)=>$896e8f74d1491439$var$it(!0, t);
$896e8f74d1491439$export$b410431fab84fa58.pause = (t)=>$896e8f74d1491439$var$it(!1, t);
function $896e8f74d1491439$var$kt(t) {
    var s;
    let { subscribe: o, getSnapshot: e, setProps: r } = (0, $cQmXV.useRef)($896e8f74d1491439$var$It(t)).current;
    r(t);
    let a = (s = (0, $cQmXV.useSyncExternalStore)(o, e, e)) == null ? void 0 : s.slice();
    function l(f) {
        if (!a) return [];
        let c = new Map;
        return t.newestOnTop && a.reverse(), a.forEach((T)=>{
            let { position: g } = T.props;
            c.has(g) || c.set(g, []), c.get(g).push(T);
        }), Array.from(c, (T)=>f(T[0], T[1]));
    }
    return {
        getToastToRender: l,
        isToastActive: $896e8f74d1491439$var$X,
        count: a == null ? void 0 : a.length
    };
}
function $896e8f74d1491439$var$Nt(t) {
    let [o, e] = (0, $cQmXV.useState)(!1), [r, a] = (0, $cQmXV.useState)(!1), l = (0, $cQmXV.useRef)(null), s = (0, $cQmXV.useRef)({
        start: 0,
        delta: 0,
        removalDistance: 0,
        canCloseOnClick: !0,
        canDrag: !1,
        didMove: !1
    }).current, { autoClose: f, pauseOnHover: c, closeToast: T, onClick: g, closeOnClick: v } = t;
    $896e8f74d1491439$var$Pt({
        id: t.toastId,
        containerId: t.containerId,
        fn: e
    }), (0, $cQmXV.useEffect)(()=>{
        if (t.pauseOnFocusLoss) return x(), ()=>{
            C();
        };
    }, [
        t.pauseOnFocusLoss
    ]);
    function x() {
        document.hasFocus() || p(), window.addEventListener("focus", d), window.addEventListener("blur", p);
    }
    function C() {
        window.removeEventListener("focus", d), window.removeEventListener("blur", p);
    }
    function S(m) {
        if (t.draggable === !0 || t.draggable === m.pointerType) {
            b();
            let _ = l.current;
            s.canCloseOnClick = !0, s.canDrag = !0, _.style.transition = "none", t.draggableDirection === "x" ? (s.start = m.clientX, s.removalDistance = _.offsetWidth * (t.draggablePercent / 100)) : (s.start = m.clientY, s.removalDistance = _.offsetHeight * (t.draggablePercent === 80 ? t.draggablePercent * 1.5 : t.draggablePercent) / 100);
        }
    }
    function E(m) {
        let { top: _, bottom: k, left: D, right: A } = l.current.getBoundingClientRect();
        m.pointerType === "mouse" && t.pauseOnHover && m.clientX >= D && m.clientX <= A && m.clientY >= _ && m.clientY <= k ? p() : d();
    }
    function d() {
        e(!0);
    }
    function p() {
        e(!1);
    }
    function b() {
        s.didMove = !1, document.addEventListener("pointermove", n), document.addEventListener("pointerup", u);
    }
    function i() {
        document.removeEventListener("pointermove", n), document.removeEventListener("pointerup", u);
    }
    function n(m) {
        let _ = l.current;
        if (s.canDrag && _) {
            s.didMove = !0, o && p(), t.draggableDirection === "x" ? s.delta = m.clientX - s.start : s.delta = m.clientY - s.start, s.start !== m.clientX && (s.canCloseOnClick = !1);
            let k = t.draggableDirection === "x" ? `${s.delta}px, var(--y)` : `0, calc(${s.delta}px + var(--y))`;
            _.style.transform = `translate3d(${k},0)`, _.style.opacity = `${1 - Math.abs(s.delta / s.removalDistance)}`;
        }
    }
    function u() {
        i();
        let m = l.current;
        if (s.canDrag && s.didMove && m) {
            if (s.canDrag = !1, Math.abs(s.delta) > s.removalDistance) {
                a(!0), t.closeToast(!0), t.collapseAll();
                return;
            }
            m.style.transition = "transform 0.2s, opacity 0.2s", m.style.removeProperty("transform"), m.style.removeProperty("opacity");
        }
    }
    let h = {
        onPointerDown: S,
        onPointerUp: E
    };
    return f && c && (h.onMouseEnter = p, t.stacked || (h.onMouseLeave = d)), v && (h.onClick = (m)=>{
        g && g(m), s.canCloseOnClick && T(!0);
    }), {
        playToast: d,
        pauseToast: p,
        isRunning: o,
        preventExitTransition: r,
        toastRef: l,
        eventHandlers: h
    };
}
var $896e8f74d1491439$var$G = typeof window != "undefined" ? (0, $cQmXV.useLayoutEffect) : (0, $cQmXV.useEffect);
var $896e8f74d1491439$var$K = ({ theme: t, type: o, isLoading: e, ...r })=>(0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("svg", {
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        fill: t === "colored" ? "currentColor" : `var(--toastify-icon-color-${o})`,
        ...r
    });
function $896e8f74d1491439$var$ro(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($896e8f74d1491439$var$K, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("path", {
        d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z"
    }));
}
function $896e8f74d1491439$var$no(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($896e8f74d1491439$var$K, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("path", {
        d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z"
    }));
}
function $896e8f74d1491439$var$io(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($896e8f74d1491439$var$K, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("path", {
        d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"
    }));
}
function $896e8f74d1491439$var$lo(t) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($896e8f74d1491439$var$K, {
        ...t
    }, (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("path", {
        d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"
    }));
}
function $896e8f74d1491439$var$fo() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
        className: "Toastify__spinner"
    });
}
var $896e8f74d1491439$export$4f13f83fd8bb1dac = {
    info: $896e8f74d1491439$var$no,
    warning: $896e8f74d1491439$var$ro,
    success: $896e8f74d1491439$var$io,
    error: $896e8f74d1491439$var$lo,
    spinner: $896e8f74d1491439$var$fo
}, $896e8f74d1491439$var$co = (t)=>t in $896e8f74d1491439$export$4f13f83fd8bb1dac;
function $896e8f74d1491439$var$wt({ theme: t, type: o, isLoading: e, icon: r }) {
    let a = null, l = {
        theme: t,
        type: o
    };
    return r === !1 || ($896e8f74d1491439$var$P(r) ? a = r({
        ...l,
        isLoading: e
    }) : (0, $cQmXV.isValidElement)(r) ? a = (0, $cQmXV.cloneElement)(r, l) : e ? a = $896e8f74d1491439$export$4f13f83fd8bb1dac.spinner() : $896e8f74d1491439$var$co(o) && (a = $896e8f74d1491439$export$4f13f83fd8bb1dac[o](l))), a;
}
var $896e8f74d1491439$var$Dt = (t)=>{
    let { isRunning: o, preventExitTransition: e, toastRef: r, eventHandlers: a, playToast: l } = $896e8f74d1491439$var$Nt(t), { closeButton: s, children: f, autoClose: c, onClick: T, type: g, hideProgressBar: v, closeToast: x, transition: C, position: S, className: E, style: d, progressClassName: p, updateId: b, role: i, progress: n, rtl: u, toastId: h, deleteToast: m, isIn: _, isLoading: k, closeOnClick: D, theme: A, ariaLabel: B } = t, M = (0, $772fd6e40f1fbf40$export$2e2bcd8739ae039)("Toastify__toast", `Toastify__toast-theme--${A}`, `Toastify__toast--${g}`, {
        ["Toastify__toast--rtl"]: u
    }, {
        ["Toastify__toast--close-on-click"]: D
    }), $ = $896e8f74d1491439$var$P(E) ? E({
        rtl: u,
        position: S,
        type: g,
        defaultClassName: M
    }) : (0, $772fd6e40f1fbf40$export$2e2bcd8739ae039)(M, E), mt = $896e8f74d1491439$var$wt(t), pt = !!n || !c, Z = {
        closeToast: x,
        type: g,
        theme: A
    }, V = null;
    return s === !1 || ($896e8f74d1491439$var$P(s) ? V = s(Z) : (0, $cQmXV.isValidElement)(s) ? V = (0, $cQmXV.cloneElement)(s, Z) : V = $896e8f74d1491439$var$gt(Z)), (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement(C, {
        isIn: _,
        done: m,
        position: S,
        preventExitTransition: e,
        nodeRef: r,
        playToast: l
    }, (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
        id: h,
        tabIndex: 0,
        onClick: T,
        "data-in": _,
        className: $,
        ...a,
        style: d,
        ref: r,
        ..._ && {
            role: i,
            "aria-label": B
        }
    }, mt != null && (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$2e2bcd8739ae039)("Toastify__toast-icon", {
            ["Toastify--animate-icon Toastify__zoom-enter"]: !k
        })
    }, mt), $896e8f74d1491439$var$ot(f, t, !o), V, !t.customProgressBar && (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($896e8f74d1491439$var$bt, {
        ...b && !pt ? {
            key: `p-${b}`
        } : {},
        rtl: u,
        theme: A,
        delay: c,
        isRunning: o,
        isIn: _,
        closeToast: x,
        hide: v,
        type: g,
        className: p,
        controlledProgress: pt,
        progress: n || 0
    })));
};
var $896e8f74d1491439$var$j = (t, o = !1)=>({
        enter: `Toastify--animate Toastify__${t}-enter`,
        exit: `Toastify--animate Toastify__${t}-exit`,
        appendPosition: o
    }), $896e8f74d1491439$export$d20e79fdc3899e95 = $896e8f74d1491439$export$3ff7dc44d332d222($896e8f74d1491439$var$j("bounce", !0)), $896e8f74d1491439$export$d8dc01b5c85a37b9 = $896e8f74d1491439$export$3ff7dc44d332d222($896e8f74d1491439$var$j("slide", !0)), $896e8f74d1491439$export$65cfd44a2050f99 = $896e8f74d1491439$export$3ff7dc44d332d222($896e8f74d1491439$var$j("zoom")), $896e8f74d1491439$export$4d2fae537bd90431 = $896e8f74d1491439$export$3ff7dc44d332d222($896e8f74d1491439$var$j("flip"));
var $896e8f74d1491439$var$vo = {
    position: "top-right",
    transition: $896e8f74d1491439$export$d20e79fdc3899e95,
    autoClose: 5e3,
    closeButton: !0,
    pauseOnHover: !0,
    pauseOnFocusLoss: !0,
    draggable: "touch",
    draggablePercent: 80,
    draggableDirection: "x",
    role: "alert",
    theme: "light",
    "aria-label": "Notifications Alt+T",
    hotKeys: (t)=>t.altKey && t.code === "KeyT"
};
function $896e8f74d1491439$var$dt(t) {
    let o = {
        ...$896e8f74d1491439$var$vo,
        ...t
    }, e = t.stacked, [r, a] = (0, $cQmXV.useState)(!0), l = (0, $cQmXV.useRef)(null), { getToastToRender: s, isToastActive: f, count: c } = $896e8f74d1491439$var$kt(o), { className: T, style: g, rtl: v, containerId: x, hotKeys: C } = o;
    function S(d) {
        let p = (0, $772fd6e40f1fbf40$export$2e2bcd8739ae039)("Toastify__toast-container", `Toastify__toast-container--${d}`, {
            ["Toastify__toast-container--rtl"]: v
        });
        return $896e8f74d1491439$var$P(T) ? T({
            position: d,
            rtl: v,
            defaultClassName: p
        }) : (0, $772fd6e40f1fbf40$export$2e2bcd8739ae039)(p, $896e8f74d1491439$var$z(T));
    }
    function E() {
        e && (a(!0), $896e8f74d1491439$export$b410431fab84fa58.play());
    }
    return $896e8f74d1491439$var$G(()=>{
        var d;
        if (e) {
            let p = l.current.querySelectorAll('[data-in="true"]'), b = 12, i = (d = o.position) == null ? void 0 : d.includes("top"), n = 0, u = 0;
            Array.from(p).reverse().forEach((h, m)=>{
                let _ = h;
                _.classList.add("Toastify__toast--stacked"), m > 0 && (_.dataset.collapsed = `${r}`), _.dataset.pos || (_.dataset.pos = i ? "top" : "bot");
                let k = n * (r ? .2 : 1) + (r ? 0 : b * m), D = Math.max(.5, 1 - (r ? u : 0));
                _.style.setProperty("--y", `${i ? k : k * -1}px`), _.style.setProperty("--g", `${b}`), _.style.setProperty("--s", `${D}`), n += _.offsetHeight, u += .025;
            });
        }
    }, [
        r,
        c,
        e
    ]), (0, $cQmXV.useEffect)(()=>{
        function d(p) {
            var i;
            let b = l.current;
            C(p) && ((i = b == null ? void 0 : b.querySelector('[tabIndex="0"]')) == null || i.focus(), a(!1), $896e8f74d1491439$export$b410431fab84fa58.pause()), p.key === "Escape" && (document.activeElement === b || b != null && b.contains(document.activeElement)) && (a(!0), $896e8f74d1491439$export$b410431fab84fa58.play());
        }
        return document.addEventListener("keydown", d), ()=>{
            document.removeEventListener("keydown", d);
        };
    }, [
        C
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("section", {
        ref: l,
        className: "Toastify",
        id: x,
        onMouseEnter: ()=>{
            e && (a(!1), $896e8f74d1491439$export$b410431fab84fa58.pause());
        },
        onMouseLeave: E,
        "aria-live": "polite",
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        "aria-label": o["aria-label"]
    }, s((d, p)=>{
        let b = p.length ? {
            ...g
        } : {
            ...g,
            pointerEvents: "none"
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
            tabIndex: -1,
            className: S(d),
            "data-stacked": e,
            style: b,
            key: `c-${d}`
        }, p.map(({ content: i, props: n })=>(0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($896e8f74d1491439$var$Dt, {
                ...n,
                stacked: e,
                collapseAll: E,
                isIn: f(n.toastId, n.containerId),
                key: `t-${n.key}`
            }, i)));
    }));
}
var $896e8f74d1491439$var$Mt = `:root {
  --toastify-color-light: #fff;
  --toastify-color-dark: #121212;
  --toastify-color-info: #3498db;
  --toastify-color-success: #07bc0c;
  --toastify-color-warning: #f1c40f;
  --toastify-color-error: hsl(6, 78%, 57%);
  --toastify-color-transparent: rgba(255, 255, 255, 0.7);

  --toastify-icon-color-info: var(--toastify-color-info);
  --toastify-icon-color-success: var(--toastify-color-success);
  --toastify-icon-color-warning: var(--toastify-color-warning);
  --toastify-icon-color-error: var(--toastify-color-error);

  --toastify-container-width: fit-content;
  --toastify-toast-width: 320px;
  --toastify-toast-offset: 16px;
  --toastify-toast-top: max(var(--toastify-toast-offset), env(safe-area-inset-top));
  --toastify-toast-right: max(var(--toastify-toast-offset), env(safe-area-inset-right));
  --toastify-toast-left: max(var(--toastify-toast-offset), env(safe-area-inset-left));
  --toastify-toast-bottom: max(var(--toastify-toast-offset), env(safe-area-inset-bottom));
  --toastify-toast-background: #fff;
  --toastify-toast-padding: 14px;
  --toastify-toast-min-height: 64px;
  --toastify-toast-max-height: 800px;
  --toastify-toast-bd-radius: 6px;
  --toastify-toast-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  --toastify-font-family: sans-serif;
  --toastify-z-index: 9999;
  --toastify-text-color-light: #757575;
  --toastify-text-color-dark: #fff;

  /* Used only for colored theme */
  --toastify-text-color-info: #fff;
  --toastify-text-color-success: #fff;
  --toastify-text-color-warning: #fff;
  --toastify-text-color-error: #fff;

  --toastify-spinner-color: #616161;
  --toastify-spinner-color-empty-area: #e0e0e0;
  --toastify-color-progress-light: linear-gradient(to right, #4cd964, #5ac8fa, #007aff, #34aadc, #5856d6, #ff2d55);
  --toastify-color-progress-dark: #bb86fc;
  --toastify-color-progress-info: var(--toastify-color-info);
  --toastify-color-progress-success: var(--toastify-color-success);
  --toastify-color-progress-warning: var(--toastify-color-warning);
  --toastify-color-progress-error: var(--toastify-color-error);
  /* used to control the opacity of the progress trail */
  --toastify-color-progress-bgo: 0.2;
}

.Toastify__toast-container {
  z-index: var(--toastify-z-index);
  -webkit-transform: translate3d(0, 0, var(--toastify-z-index));
  position: fixed;
  width: var(--toastify-container-width);
  box-sizing: border-box;
  color: #fff;
  display: flex;
  flex-direction: column;
}

.Toastify__toast-container--top-left {
  top: var(--toastify-toast-top);
  left: var(--toastify-toast-left);
}
.Toastify__toast-container--top-center {
  top: var(--toastify-toast-top);
  left: 50%;
  transform: translateX(-50%);
  align-items: center;
}
.Toastify__toast-container--top-right {
  top: var(--toastify-toast-top);
  right: var(--toastify-toast-right);
  align-items: end;
}
.Toastify__toast-container--bottom-left {
  bottom: var(--toastify-toast-bottom);
  left: var(--toastify-toast-left);
}
.Toastify__toast-container--bottom-center {
  bottom: var(--toastify-toast-bottom);
  left: 50%;
  transform: translateX(-50%);
  align-items: center;
}
.Toastify__toast-container--bottom-right {
  bottom: var(--toastify-toast-bottom);
  right: var(--toastify-toast-right);
  align-items: end;
}

.Toastify__toast {
  --y: 0px;
  position: relative;
  touch-action: none;
  width: var(--toastify-toast-width);
  min-height: var(--toastify-toast-min-height);
  box-sizing: border-box;
  margin-bottom: 1rem;
  padding: var(--toastify-toast-padding);
  border-radius: var(--toastify-toast-bd-radius);
  box-shadow: var(--toastify-toast-shadow);
  max-height: var(--toastify-toast-max-height);
  font-family: var(--toastify-font-family);
  /* webkit only issue #791 */
  z-index: 0;
  /* inner swag */
  display: flex;
  flex: 1 auto;
  align-items: center;
  word-break: break-word;
}

@media only screen and (max-width: 480px) {
  .Toastify__toast-container {
    width: 100vw;
    left: env(safe-area-inset-left);
    margin: 0;
  }
  .Toastify__toast-container--top-left,
  .Toastify__toast-container--top-center,
  .Toastify__toast-container--top-right {
    top: env(safe-area-inset-top);
    transform: translateX(0);
  }
  .Toastify__toast-container--bottom-left,
  .Toastify__toast-container--bottom-center,
  .Toastify__toast-container--bottom-right {
    bottom: env(safe-area-inset-bottom);
    transform: translateX(0);
  }
  .Toastify__toast-container--rtl {
    right: env(safe-area-inset-right);
    left: initial;
  }
  .Toastify__toast {
    --toastify-toast-width: 100%;
    margin-bottom: 0;
    border-radius: 0;
  }
}

.Toastify__toast-container[data-stacked='true'] {
  width: var(--toastify-toast-width);
}

@media only screen and (max-width: 480px) {
  .Toastify__toast-container[data-stacked='true'] {
    width: 100vw;
  }
}

.Toastify__toast--stacked {
  position: absolute;
  width: 100%;
  transform: translate3d(0, var(--y), 0) scale(var(--s));
  transition: transform 0.3s;
}

.Toastify__toast--stacked[data-collapsed] .Toastify__toast-body,
.Toastify__toast--stacked[data-collapsed] .Toastify__close-button {
  transition: opacity 0.1s;
}

.Toastify__toast--stacked[data-collapsed='false'] {
  overflow: visible;
}

.Toastify__toast--stacked[data-collapsed='true']:not(:last-child) > * {
  opacity: 0;
}

.Toastify__toast--stacked:after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  height: calc(var(--g) * 1px);
  bottom: 100%;
}

.Toastify__toast--stacked[data-pos='top'] {
  top: 0;
}

.Toastify__toast--stacked[data-pos='bot'] {
  bottom: 0;
}

.Toastify__toast--stacked[data-pos='bot'].Toastify__toast--stacked:before {
  transform-origin: top;
}

.Toastify__toast--stacked[data-pos='top'].Toastify__toast--stacked:before {
  transform-origin: bottom;
}

.Toastify__toast--stacked:before {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100%;
  transform: scaleY(3);
  z-index: -1;
}

.Toastify__toast--rtl {
  direction: rtl;
}

.Toastify__toast--close-on-click {
  cursor: pointer;
}

.Toastify__toast-icon {
  margin-inline-end: 10px;
  width: 22px;
  flex-shrink: 0;
  display: flex;
}

.Toastify--animate {
  animation-fill-mode: both;
  animation-duration: 0.5s;
}

.Toastify--animate-icon {
  animation-fill-mode: both;
  animation-duration: 0.3s;
}

.Toastify__toast-theme--dark {
  background: var(--toastify-color-dark);
  color: var(--toastify-text-color-dark);
}

.Toastify__toast-theme--light {
  background: var(--toastify-color-light);
  color: var(--toastify-text-color-light);
}

.Toastify__toast-theme--colored.Toastify__toast--default {
  background: var(--toastify-color-light);
  color: var(--toastify-text-color-light);
}

.Toastify__toast-theme--colored.Toastify__toast--info {
  color: var(--toastify-text-color-info);
  background: var(--toastify-color-info);
}

.Toastify__toast-theme--colored.Toastify__toast--success {
  color: var(--toastify-text-color-success);
  background: var(--toastify-color-success);
}

.Toastify__toast-theme--colored.Toastify__toast--warning {
  color: var(--toastify-text-color-warning);
  background: var(--toastify-color-warning);
}

.Toastify__toast-theme--colored.Toastify__toast--error {
  color: var(--toastify-text-color-error);
  background: var(--toastify-color-error);
}

.Toastify__progress-bar-theme--light {
  background: var(--toastify-color-progress-light);
}

.Toastify__progress-bar-theme--dark {
  background: var(--toastify-color-progress-dark);
}

.Toastify__progress-bar--info {
  background: var(--toastify-color-progress-info);
}

.Toastify__progress-bar--success {
  background: var(--toastify-color-progress-success);
}

.Toastify__progress-bar--warning {
  background: var(--toastify-color-progress-warning);
}

.Toastify__progress-bar--error {
  background: var(--toastify-color-progress-error);
}

.Toastify__progress-bar-theme--colored.Toastify__progress-bar--info,
.Toastify__progress-bar-theme--colored.Toastify__progress-bar--success,
.Toastify__progress-bar-theme--colored.Toastify__progress-bar--warning,
.Toastify__progress-bar-theme--colored.Toastify__progress-bar--error {
  background: var(--toastify-color-transparent);
}

.Toastify__close-button {
  color: #fff;
  position: absolute;
  top: 6px;
  right: 6px;
  background: transparent;
  outline: none;
  border: none;
  padding: 0;
  cursor: pointer;
  opacity: 0.7;
  transition: 0.3s ease;
  z-index: 1;
}

.Toastify__toast--rtl .Toastify__close-button {
  left: 6px;
  right: unset;
}

.Toastify__close-button--light {
  color: #000;
  opacity: 0.3;
}

.Toastify__close-button > svg {
  fill: currentColor;
  height: 16px;
  width: 14px;
}

.Toastify__close-button:hover,
.Toastify__close-button:focus {
  opacity: 1;
}

@keyframes Toastify__trackProgress {
  0% {
    transform: scaleX(1);
  }
  100% {
    transform: scaleX(0);
  }
}

.Toastify__progress-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  opacity: 0.7;
  transform-origin: left;
}

.Toastify__progress-bar--animated {
  animation: Toastify__trackProgress linear 1 forwards;
}

.Toastify__progress-bar--controlled {
  transition: transform 0.2s;
}

.Toastify__progress-bar--rtl {
  right: 0;
  left: initial;
  transform-origin: right;
  border-bottom-left-radius: initial;
}

.Toastify__progress-bar--wrp {
  position: absolute;
  overflow: hidden;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 5px;
  border-bottom-left-radius: var(--toastify-toast-bd-radius);
  border-bottom-right-radius: var(--toastify-toast-bd-radius);
}

.Toastify__progress-bar--wrp[data-hidden='true'] {
  opacity: 0;
}

.Toastify__progress-bar--bg {
  opacity: var(--toastify-color-progress-bgo);
  width: 100%;
  height: 100%;
}

.Toastify__spinner {
  width: 20px;
  height: 20px;
  box-sizing: border-box;
  border: 2px solid;
  border-radius: 100%;
  border-color: var(--toastify-spinner-color-empty-area);
  border-right-color: var(--toastify-spinner-color);
  animation: Toastify__spin 0.65s linear infinite;
}

@keyframes Toastify__bounceInRight {
  from,
  60%,
  75%,
  90%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  from {
    opacity: 0;
    transform: translate3d(3000px, 0, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(-25px, 0, 0);
  }
  75% {
    transform: translate3d(10px, 0, 0);
  }
  90% {
    transform: translate3d(-5px, 0, 0);
  }
  to {
    transform: none;
  }
}

@keyframes Toastify__bounceOutRight {
  20% {
    opacity: 1;
    transform: translate3d(-20px, var(--y), 0);
  }
  to {
    opacity: 0;
    transform: translate3d(2000px, var(--y), 0);
  }
}

@keyframes Toastify__bounceInLeft {
  from,
  60%,
  75%,
  90%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    transform: translate3d(-3000px, 0, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(25px, 0, 0);
  }
  75% {
    transform: translate3d(-10px, 0, 0);
  }
  90% {
    transform: translate3d(5px, 0, 0);
  }
  to {
    transform: none;
  }
}

@keyframes Toastify__bounceOutLeft {
  20% {
    opacity: 1;
    transform: translate3d(20px, var(--y), 0);
  }
  to {
    opacity: 0;
    transform: translate3d(-2000px, var(--y), 0);
  }
}

@keyframes Toastify__bounceInUp {
  from,
  60%,
  75%,
  90%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  from {
    opacity: 0;
    transform: translate3d(0, 3000px, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(0, -20px, 0);
  }
  75% {
    transform: translate3d(0, 10px, 0);
  }
  90% {
    transform: translate3d(0, -5px, 0);
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}

@keyframes Toastify__bounceOutUp {
  20% {
    transform: translate3d(0, calc(var(--y) - 10px), 0);
  }
  40%,
  45% {
    opacity: 1;
    transform: translate3d(0, calc(var(--y) + 20px), 0);
  }
  to {
    opacity: 0;
    transform: translate3d(0, -2000px, 0);
  }
}

@keyframes Toastify__bounceInDown {
  from,
  60%,
  75%,
  90%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    transform: translate3d(0, -3000px, 0);
  }
  60% {
    opacity: 1;
    transform: translate3d(0, 25px, 0);
  }
  75% {
    transform: translate3d(0, -10px, 0);
  }
  90% {
    transform: translate3d(0, 5px, 0);
  }
  to {
    transform: none;
  }
}

@keyframes Toastify__bounceOutDown {
  20% {
    transform: translate3d(0, calc(var(--y) - 10px), 0);
  }
  40%,
  45% {
    opacity: 1;
    transform: translate3d(0, calc(var(--y) + 20px), 0);
  }
  to {
    opacity: 0;
    transform: translate3d(0, 2000px, 0);
  }
}

.Toastify__bounce-enter--top-left,
.Toastify__bounce-enter--bottom-left {
  animation-name: Toastify__bounceInLeft;
}

.Toastify__bounce-enter--top-right,
.Toastify__bounce-enter--bottom-right {
  animation-name: Toastify__bounceInRight;
}

.Toastify__bounce-enter--top-center {
  animation-name: Toastify__bounceInDown;
}

.Toastify__bounce-enter--bottom-center {
  animation-name: Toastify__bounceInUp;
}

.Toastify__bounce-exit--top-left,
.Toastify__bounce-exit--bottom-left {
  animation-name: Toastify__bounceOutLeft;
}

.Toastify__bounce-exit--top-right,
.Toastify__bounce-exit--bottom-right {
  animation-name: Toastify__bounceOutRight;
}

.Toastify__bounce-exit--top-center {
  animation-name: Toastify__bounceOutUp;
}

.Toastify__bounce-exit--bottom-center {
  animation-name: Toastify__bounceOutDown;
}

@keyframes Toastify__zoomIn {
  from {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
  50% {
    opacity: 1;
  }
}

@keyframes Toastify__zoomOut {
  from {
    opacity: 1;
  }
  50% {
    opacity: 0;
    transform: translate3d(0, var(--y), 0) scale3d(0.3, 0.3, 0.3);
  }
  to {
    opacity: 0;
  }
}

.Toastify__zoom-enter {
  animation-name: Toastify__zoomIn;
}

.Toastify__zoom-exit {
  animation-name: Toastify__zoomOut;
}

@keyframes Toastify__flipIn {
  from {
    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
    animation-timing-function: ease-in;
    opacity: 0;
  }
  40% {
    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
    animation-timing-function: ease-in;
  }
  60% {
    transform: perspective(400px) rotate3d(1, 0, 0, 10deg);
    opacity: 1;
  }
  80% {
    transform: perspective(400px) rotate3d(1, 0, 0, -5deg);
  }
  to {
    transform: perspective(400px);
  }
}

@keyframes Toastify__flipOut {
  from {
    transform: translate3d(0, var(--y), 0) perspective(400px);
  }
  30% {
    transform: translate3d(0, var(--y), 0) perspective(400px) rotate3d(1, 0, 0, -20deg);
    opacity: 1;
  }
  to {
    transform: translate3d(0, var(--y), 0) perspective(400px) rotate3d(1, 0, 0, 90deg);
    opacity: 0;
  }
}

.Toastify__flip-enter {
  animation-name: Toastify__flipIn;
}

.Toastify__flip-exit {
  animation-name: Toastify__flipOut;
}

@keyframes Toastify__slideInRight {
  from {
    transform: translate3d(110%, 0, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, var(--y), 0);
  }
}

@keyframes Toastify__slideInLeft {
  from {
    transform: translate3d(-110%, 0, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, var(--y), 0);
  }
}

@keyframes Toastify__slideInUp {
  from {
    transform: translate3d(0, 110%, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, var(--y), 0);
  }
}

@keyframes Toastify__slideInDown {
  from {
    transform: translate3d(0, -110%, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, var(--y), 0);
  }
}

@keyframes Toastify__slideOutRight {
  from {
    transform: translate3d(0, var(--y), 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(110%, var(--y), 0);
  }
}

@keyframes Toastify__slideOutLeft {
  from {
    transform: translate3d(0, var(--y), 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(-110%, var(--y), 0);
  }
}

@keyframes Toastify__slideOutDown {
  from {
    transform: translate3d(0, var(--y), 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(0, 500px, 0);
  }
}

@keyframes Toastify__slideOutUp {
  from {
    transform: translate3d(0, var(--y), 0);
  }
  to {
    visibility: hidden;
    transform: translate3d(0, -500px, 0);
  }
}

.Toastify__slide-enter--top-left,
.Toastify__slide-enter--bottom-left {
  animation-name: Toastify__slideInLeft;
}

.Toastify__slide-enter--top-right,
.Toastify__slide-enter--bottom-right {
  animation-name: Toastify__slideInRight;
}

.Toastify__slide-enter--top-center {
  animation-name: Toastify__slideInDown;
}

.Toastify__slide-enter--bottom-center {
  animation-name: Toastify__slideInUp;
}

.Toastify__slide-exit--top-left,
.Toastify__slide-exit--bottom-left {
  animation-name: Toastify__slideOutLeft;
  animation-timing-function: ease-in;
  animation-duration: 0.3s;
}

.Toastify__slide-exit--top-right,
.Toastify__slide-exit--bottom-right {
  animation-name: Toastify__slideOutRight;
  animation-timing-function: ease-in;
  animation-duration: 0.3s;
}

.Toastify__slide-exit--top-center {
  animation-name: Toastify__slideOutUp;
  animation-timing-function: ease-in;
  animation-duration: 0.3s;
}

.Toastify__slide-exit--bottom-center {
  animation-name: Toastify__slideOutDown;
  animation-timing-function: ease-in;
  animation-duration: 0.3s;
}

@keyframes Toastify__spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
`;
var $896e8f74d1491439$var$$t = new Map, $896e8f74d1491439$var$Rt = (t, o)=>{
    $896e8f74d1491439$var$G(()=>{
        if (!t || typeof document == "undefined") return;
        let e = document, r = $896e8f74d1491439$var$$t.get(e);
        if (r) {
            o && r.setAttribute("nonce", o);
            return;
        }
        let a = e.createElement("style");
        a.textContent = t, o && a.setAttribute("nonce", o), e.head.appendChild(a), $896e8f74d1491439$var$$t.set(e, a);
    }, [
        o
    ]);
};
function $896e8f74d1491439$export$f2815235e76a62b9(t) {
    return $896e8f74d1491439$var$Rt($896e8f74d1491439$var$Mt, t.nonce), (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($896e8f74d1491439$var$dt, {
        ...t
    });
}



// Drop-in replacement for the abandoned `react-s-alert` package, removed during the
// React 19 upgrade (it peer-locked to React 15/16). The app calls
// Alert.success/error/warning/info(message, options?) in ~23 places and mounts a single
// <Alert/> container in src/index.js; here we back the same API with react-toastify and
// re-export a ToastContainer to mount instead.
// Map the few react-s-alert positions used in the codebase to react-toastify equivalents.
const $8e06ecfa6b5e89ed$var$POSITION_MAP = {
    "top": "top-center",
    "top-left": "top-left",
    "top-right": "top-right",
    "bottom": "bottom-center",
    "bottom-left": "bottom-left",
    "bottom-right": "bottom-right"
};
const $8e06ecfa6b5e89ed$var$normalize = (opts)=>{
    if (!opts) return undefined;
    const out = {};
    if (typeof opts.timeout === "number") out.autoClose = opts.timeout;
    if (opts.position && $8e06ecfa6b5e89ed$var$POSITION_MAP[opts.position]) out.position = $8e06ecfa6b5e89ed$var$POSITION_MAP[opts.position];
    return out;
};
const $8e06ecfa6b5e89ed$var$Alert = {
    success: (msg, opts)=>(0, $896e8f74d1491439$export$b410431fab84fa58).success(msg, $8e06ecfa6b5e89ed$var$normalize(opts)),
    error: (msg, opts)=>(0, $896e8f74d1491439$export$b410431fab84fa58).error(msg, $8e06ecfa6b5e89ed$var$normalize(opts)),
    warning: (msg, opts)=>(0, $896e8f74d1491439$export$b410431fab84fa58).warn(msg, $8e06ecfa6b5e89ed$var$normalize(opts)),
    info: (msg, opts)=>(0, $896e8f74d1491439$export$b410431fab84fa58).info(msg, $8e06ecfa6b5e89ed$var$normalize(opts)),
    // react-s-alert exposed close(id) / closeAll(); toast.dismiss() closes all when id is absent.
    close: (id)=>id != null ? (0, $896e8f74d1491439$export$b410431fab84fa58).dismiss(id) : (0, $896e8f74d1491439$export$b410431fab84fa58).dismiss(),
    closeAll: ()=>(0, $896e8f74d1491439$export$b410431fab84fa58).dismiss()
};
var $8e06ecfa6b5e89ed$export$2e2bcd8739ae039 = $8e06ecfa6b5e89ed$var$Alert;




var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");


function $956338a9e9c125d6$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $1301bbb20b42149f$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $956338a9e9c125d6$export$2e2bcd8739ae039)(r);
}


function $76a0531dbf122754$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



function $07bfc70c3f0251dd$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $956338a9e9c125d6$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $956338a9e9c125d6$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $e51b862fe4e76988$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $68381b18b974dc9f$export$2e2bcd8739ae039(r) {
    return (0, $1301bbb20b42149f$export$2e2bcd8739ae039)(r) || (0, $76a0531dbf122754$export$2e2bcd8739ae039)(r) || (0, $07bfc70c3f0251dd$export$2e2bcd8739ae039)(r) || (0, $e51b862fe4e76988$export$2e2bcd8739ae039)();
}



var $cQmXV = parcelRequire("cQmXV");


/**
 * Fill object structure by schema, initialize empty objects for keys with `_default` property.
 */ const $929d64d16c910c44$export$b0b33f05d3a1a8f1 = (obj, schema)=>{
    const newObj = {
        ...obj
    };
    Object.keys(schema).forEach((key)=>{
        if (schema[key]._default) newObj[key] || (newObj[key] = {});
        else newObj[key] = $929d64d16c910c44$export$b0b33f05d3a1a8f1(newObj[key], schema[key]);
    });
    return newObj;
};


const $30c5f9f911d4f61b$export$8bf64cd1c29a1310 = (schema = {}, ...classNames)=>{
    return classNames.filter((item)=>Boolean(item)).reduce((acc, cur)=>{
        // Loop keys of the current classNames
        Object.keys(cur).forEach((key)=>{
            const keySchema = schema[key];
            const curVal = cur[key];
            if (keySchema) {
                if ((0, $8e2d153a3c855782$export$53b83ca8eaab0383)(curVal)) // Loop fill
                acc[key] = $30c5f9f911d4f61b$export$8bf64cd1c29a1310(keySchema, acc[key], curVal);
                else {
                    // Convert string to object structure
                    const { _default: defaultField } = keySchema;
                    if (defaultField) {
                        acc[key] = acc[key] || {};
                        acc[key][defaultField] = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(acc[key][defaultField], curVal);
                    }
                }
            } else // Flatten fill
            acc[key] = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(acc[key], curVal);
        });
        return acc;
    }, {});
};
const $30c5f9f911d4f61b$var$useSemanticClassNames = (schema, ...classNames)=>{
    return $cQmXV.useMemo(()=>$30c5f9f911d4f61b$export$8bf64cd1c29a1310.apply(void 0, [
            schema
        ].concat(classNames)), [
        schema
    ].concat(classNames));
};
const $30c5f9f911d4f61b$export$e618dc39ac9ad607 = (...styles)=>{
    return styles.filter((item)=>Boolean(item)).reduce((acc, cur = {})=>{
        Object.keys(cur).forEach((key)=>{
            acc[key] = {
                ...acc[key],
                ...cur[key]
            };
        });
        return acc;
    }, {});
};
const $30c5f9f911d4f61b$var$useSemanticStyles = (...styles)=>{
    return $cQmXV.useMemo(()=>$30c5f9f911d4f61b$export$e618dc39ac9ad607.apply(void 0, styles), [].concat(styles));
};
const $30c5f9f911d4f61b$export$e6b3587a05cff7e4 = (style, key = "root")=>{
    return $cQmXV.useMemo(()=>style ? {
            [key]: style
        } : undefined, [
        style,
        key
    ]);
};
const $30c5f9f911d4f61b$export$ccd424010a24474f = (value, info)=>{
    return (0, $8e2d153a3c855782$export$f6e2535fb5126e54)(value) ? value(info) : value;
};
const $30c5f9f911d4f61b$export$648566b068f28737 = (classNamesList, stylesList, info, schema)=>{
    const resolvedClassNamesList = classNamesList.map((classNames)=>classNames ? $30c5f9f911d4f61b$export$ccd424010a24474f(classNames, info) : undefined);
    const resolvedStylesList = stylesList.map((styles)=>styles ? $30c5f9f911d4f61b$export$ccd424010a24474f(styles, info) : undefined);
    const mergedClassNames = $30c5f9f911d4f61b$var$useSemanticClassNames.apply(void 0, [
        schema
    ].concat((0, $68381b18b974dc9f$export$2e2bcd8739ae039)(resolvedClassNamesList)));
    const mergedStyles = $30c5f9f911d4f61b$var$useSemanticStyles.apply(void 0, (0, $68381b18b974dc9f$export$2e2bcd8739ae039)(resolvedStylesList));
    return $cQmXV.useMemo(()=>{
        if (!schema) return [
            mergedClassNames,
            mergedStyles
        ];
        return [
            (0, $929d64d16c910c44$export$b0b33f05d3a1a8f1)(mergedClassNames, schema),
            (0, $929d64d16c910c44$export$b0b33f05d3a1a8f1)(mergedStyles, schema)
        ];
    }, [
        mergedClassNames,
        mergedStyles,
        schema
    ]);
};





var $cQmXV = parcelRequire("cQmXV");





var $cQmXV = parcelRequire("cQmXV");
function $ccb28fa1a7ecc481$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $ccb28fa1a7ecc481$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ccb28fa1a7ecc481$export$2e2bcd8739ae039(o);
}


function $02dc85def57bbdda$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $b56093cb51bf02b1$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}



function $5ddfc925ae0af29a$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $6b65fc3b4acde7f2$export$2e2bcd8739ae039(r, e) {
    return (0, $02dc85def57bbdda$export$2e2bcd8739ae039)(r) || (0, $b56093cb51bf02b1$export$2e2bcd8739ae039)(r, e) || (0, $07bfc70c3f0251dd$export$2e2bcd8739ae039)(r, e) || (0, $5ddfc925ae0af29a$export$2e2bcd8739ae039)();
}





function $942d99e408f6e993$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $ccb28fa1a7ecc481$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $ccb28fa1a7ecc481$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $8f99ccc7d9abb291$export$2e2bcd8739ae039(t) {
    var i = (0, $942d99e408f6e993$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $ccb28fa1a7ecc481$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $8a87dbb78c4121a9$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $8f99ccc7d9abb291$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}



function $f163cd56d32104d1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f163cd56d32104d1$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f163cd56d32104d1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f163cd56d32104d1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}



var $cQmXV = parcelRequire("cQmXV");


function $07be749aeca07699$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}



function $c180160353ceabc3$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $8f99ccc7d9abb291$export$2e2bcd8739ae039)(o.key), o);
    }
}
function $c180160353ceabc3$export$2e2bcd8739ae039(e, r, t) {
    return r && $c180160353ceabc3$var$_defineProperties(e.prototype, r), t && $c180160353ceabc3$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}


function $220785158be974ce$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $e9bcd870dc67024b$export$2e2bcd8739ae039(t, e) {
    return $e9bcd870dc67024b$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $e9bcd870dc67024b$export$2e2bcd8739ae039(t, e);
}


function $97a7799c9b277eb6$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $e9bcd870dc67024b$export$2e2bcd8739ae039)(t, e);
}


function $5b4fe65c74408c52$export$2e2bcd8739ae039(t) {
    return $5b4fe65c74408c52$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $5b4fe65c74408c52$export$2e2bcd8739ae039(t);
}


function $5d696402a43f7962$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($5d696402a43f7962$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}




function $33c3c70a2b283b30$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $ccb28fa1a7ecc481$export$2e2bcd8739ae039)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $220785158be974ce$export$2e2bcd8739ae039)(t);
}


function $0d52efb306ead7d6$export$2e2bcd8739ae039(t) {
    var r = (0, $5d696402a43f7962$export$2e2bcd8739ae039)();
    return function() {
        var e, o = (0, $5b4fe65c74408c52$export$2e2bcd8739ae039)(t);
        if (r) {
            var s = (0, $5b4fe65c74408c52$export$2e2bcd8739ae039)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $33c3c70a2b283b30$export$2e2bcd8739ae039)(this, e);
    };
}





var $eed423db6d0242a0$var$AbstractCalculator = /*#__PURE__*/ (0, $c180160353ceabc3$export$2e2bcd8739ae039)(function AbstractCalculator() {
    (0, $07be749aeca07699$export$2e2bcd8739ae039)(this, AbstractCalculator);
});
var $eed423db6d0242a0$export$2e2bcd8739ae039 = $eed423db6d0242a0$var$AbstractCalculator;


var $2bc4345c67b33972$var$CALC_UNIT = "CALC_UNIT";
var $2bc4345c67b33972$var$regexp = new RegExp($2bc4345c67b33972$var$CALC_UNIT, "g");
function $2bc4345c67b33972$var$unit(value) {
    if (typeof value === "number") return "".concat(value).concat($2bc4345c67b33972$var$CALC_UNIT);
    return value;
}
var $2bc4345c67b33972$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AbstractCalculator) {
    (0, $97a7799c9b277eb6$export$2e2bcd8739ae039)(CSSCalculator, _AbstractCalculator);
    var _super = (0, $0d52efb306ead7d6$export$2e2bcd8739ae039)(CSSCalculator);
    function CSSCalculator(num, unitlessCssVar) {
        var _this;
        (0, $07be749aeca07699$export$2e2bcd8739ae039)(this, CSSCalculator);
        _this = _super.call(this);
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)((0, $220785158be974ce$export$2e2bcd8739ae039)(_this), "result", "");
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)((0, $220785158be974ce$export$2e2bcd8739ae039)(_this), "unitlessCssVar", void 0);
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)((0, $220785158be974ce$export$2e2bcd8739ae039)(_this), "lowPriority", void 0);
        var numType = (0, $ccb28fa1a7ecc481$export$2e2bcd8739ae039)(num);
        _this.unitlessCssVar = unitlessCssVar;
        if (num instanceof CSSCalculator) _this.result = "(".concat(num.result, ")");
        else if (numType === "number") _this.result = $2bc4345c67b33972$var$unit(num);
        else if (numType === "string") _this.result = num;
        return _this;
    }
    (0, $c180160353ceabc3$export$2e2bcd8739ae039)(CSSCalculator, [
        {
            key: "add",
            value: function add(num) {
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " + ").concat(num.getResult());
                else if (typeof num === "number" || typeof num === "string") this.result = "".concat(this.result, " + ").concat($2bc4345c67b33972$var$unit(num));
                this.lowPriority = true;
                return this;
            }
        },
        {
            key: "sub",
            value: function sub(num) {
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " - ").concat(num.getResult());
                else if (typeof num === "number" || typeof num === "string") this.result = "".concat(this.result, " - ").concat($2bc4345c67b33972$var$unit(num));
                this.lowPriority = true;
                return this;
            }
        },
        {
            key: "mul",
            value: function mul(num) {
                if (this.lowPriority) this.result = "(".concat(this.result, ")");
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " * ").concat(num.getResult(true));
                else if (typeof num === "number" || typeof num === "string") this.result = "".concat(this.result, " * ").concat(num);
                this.lowPriority = false;
                return this;
            }
        },
        {
            key: "div",
            value: function div(num) {
                if (this.lowPriority) this.result = "(".concat(this.result, ")");
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " / ").concat(num.getResult(true));
                else if (typeof num === "number" || typeof num === "string") this.result = "".concat(this.result, " / ").concat(num);
                this.lowPriority = false;
                return this;
            }
        },
        {
            key: "getResult",
            value: function getResult(force) {
                return this.lowPriority || force ? "(".concat(this.result, ")") : this.result;
            }
        },
        {
            key: "equal",
            value: function equal(options) {
                var _this2 = this;
                var _ref = options || {}, cssUnit = _ref.unit;
                var mergedUnit = true;
                if (typeof cssUnit === "boolean") mergedUnit = cssUnit;
                else if (Array.from(this.unitlessCssVar).some(function(cssVar) {
                    return _this2.result.includes(cssVar);
                })) mergedUnit = false;
                this.result = this.result.replace($2bc4345c67b33972$var$regexp, mergedUnit ? "px" : "");
                if (typeof this.lowPriority !== "undefined") return "calc(".concat(this.result, ")");
                return this.result;
            }
        }
    ]);
    return CSSCalculator;
}((0, $eed423db6d0242a0$export$2e2bcd8739ae039));









var $785e1aea486c3ad6$var$NumCalculator = /*#__PURE__*/ function(_AbstractCalculator) {
    (0, $97a7799c9b277eb6$export$2e2bcd8739ae039)(NumCalculator, _AbstractCalculator);
    var _super = (0, $0d52efb306ead7d6$export$2e2bcd8739ae039)(NumCalculator);
    function NumCalculator(num) {
        var _this;
        (0, $07be749aeca07699$export$2e2bcd8739ae039)(this, NumCalculator);
        _this = _super.call(this);
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)((0, $220785158be974ce$export$2e2bcd8739ae039)(_this), "result", 0);
        if (num instanceof NumCalculator) _this.result = num.result;
        else if (typeof num === "number") _this.result = num;
        return _this;
    }
    (0, $c180160353ceabc3$export$2e2bcd8739ae039)(NumCalculator, [
        {
            key: "add",
            value: function add(num) {
                if (num instanceof NumCalculator) this.result += num.result;
                else if (typeof num === "number") this.result += num;
                return this;
            }
        },
        {
            key: "sub",
            value: function sub(num) {
                if (num instanceof NumCalculator) this.result -= num.result;
                else if (typeof num === "number") this.result -= num;
                return this;
            }
        },
        {
            key: "mul",
            value: function mul(num) {
                if (num instanceof NumCalculator) this.result *= num.result;
                else if (typeof num === "number") this.result *= num;
                return this;
            }
        },
        {
            key: "div",
            value: function div(num) {
                if (num instanceof NumCalculator) this.result /= num.result;
                else if (typeof num === "number") this.result /= num;
                return this;
            }
        },
        {
            key: "equal",
            value: function equal() {
                return this.result;
            }
        }
    ]);
    return NumCalculator;
}((0, $eed423db6d0242a0$export$2e2bcd8739ae039));
var $785e1aea486c3ad6$export$2e2bcd8739ae039 = $785e1aea486c3ad6$var$NumCalculator;


var $c105d3f1e2d0f20f$var$genCalc = function genCalc(type, unitlessCssVar) {
    var Calculator = type === "css" ? (0, $2bc4345c67b33972$export$2e2bcd8739ae039) : (0, $785e1aea486c3ad6$export$2e2bcd8739ae039);
    return function(num) {
        return new Calculator(num, unitlessCssVar);
    };
};
var $c105d3f1e2d0f20f$export$2e2bcd8739ae039 = $c105d3f1e2d0f20f$var$genCalc;


var $7500218a94b59e9b$var$getCompVarPrefix = function getCompVarPrefix(component, prefix) {
    return "".concat([
        prefix,
        component.replace(/([A-Z]+)([A-Z][a-z]+)/g, "$1-$2").replace(/([a-z])([A-Z])/g, "$1-$2")
    ].filter(Boolean).join("-"));
};
var $7500218a94b59e9b$export$2e2bcd8739ae039 = $7500218a94b59e9b$var$getCompVarPrefix;





function $d2850981b25874f5$var$getComponentToken(component, token, defaultToken, options) {
    var customToken = (0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, token[component]);
    if (options !== null && options !== void 0 && options.deprecatedTokens) {
        var deprecatedTokens = options.deprecatedTokens;
        deprecatedTokens.forEach(function(_ref) {
            var _ref2 = (0, $6b65fc3b4acde7f2$export$2e2bcd8739ae039)(_ref, 2), oldTokenKey = _ref2[0], newTokenKey = _ref2[1];
            // Should wrap with `if` clause, or there will be `undefined` in object.
            if (customToken !== null && customToken !== void 0 && customToken[oldTokenKey] || customToken !== null && customToken !== void 0 && customToken[newTokenKey]) {
                var _customToken$newToken;
                (_customToken$newToken = customToken[newTokenKey]) !== null && _customToken$newToken !== void 0 ? _customToken$newToken : customToken[newTokenKey] = customToken === null || customToken === void 0 ? void 0 : customToken[oldTokenKey];
            }
        });
    }
    var mergedToken = (0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, defaultToken), customToken);
    // Remove same value as global token to minimize size
    Object.keys(mergedToken).forEach(function(key) {
        if (mergedToken[key] === token[key]) delete mergedToken[key];
    });
    return mergedToken;
}
var $d2850981b25874f5$export$2e2bcd8739ae039 = $d2850981b25874f5$var$getComponentToken;




var $fef50f256b80dfa5$var$enableStatistic = typeof CSSINJS_STATISTIC !== "undefined";
var $fef50f256b80dfa5$var$recording = true;
function $fef50f256b80dfa5$export$4950aa0f605343fb() {
    for(var _len = arguments.length, objs = new Array(_len), _key = 0; _key < _len; _key++)objs[_key] = arguments[_key];
    /* istanbul ignore next */ if (!$fef50f256b80dfa5$var$enableStatistic) return Object.assign.apply(Object, [
        {}
    ].concat(objs));
    $fef50f256b80dfa5$var$recording = false;
    var ret = {};
    objs.forEach(function(obj) {
        if ((0, $ccb28fa1a7ecc481$export$2e2bcd8739ae039)(obj) !== "object") return;
        var keys = Object.keys(obj);
        keys.forEach(function(key) {
            Object.defineProperty(ret, key, {
                configurable: true,
                enumerable: true,
                get: function get() {
                    return obj[key];
                }
            });
        });
    });
    $fef50f256b80dfa5$var$recording = true;
    return ret;
}
var $fef50f256b80dfa5$export$754a5e2d36c5fa7a = {};
var $fef50f256b80dfa5$export$36157caab8bf9cbd = {};
/* istanbul ignore next */ function $fef50f256b80dfa5$var$noop() {}
/** Statistic token usage case. Should use `merge` function if you do not want spread record. */ var $fef50f256b80dfa5$var$statisticToken = function statisticToken(token) {
    var tokenKeys;
    var proxy = token;
    var flush = $fef50f256b80dfa5$var$noop;
    if ($fef50f256b80dfa5$var$enableStatistic && typeof Proxy !== "undefined") {
        tokenKeys = new Set();
        proxy = new Proxy(token, {
            get: function get(obj, prop) {
                if ($fef50f256b80dfa5$var$recording) {
                    var _tokenKeys;
                    (_tokenKeys = tokenKeys) === null || _tokenKeys === void 0 || _tokenKeys.add(prop);
                }
                return obj[prop];
            }
        });
        flush = function flush(componentName, componentToken) {
            var _statistic$componentN;
            $fef50f256b80dfa5$export$754a5e2d36c5fa7a[componentName] = {
                global: Array.from(tokenKeys),
                component: (0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, (_statistic$componentN = $fef50f256b80dfa5$export$754a5e2d36c5fa7a[componentName]) === null || _statistic$componentN === void 0 ? void 0 : _statistic$componentN.component), componentToken)
            };
        };
    }
    return {
        token: proxy,
        keys: tokenKeys,
        flush: flush
    };
};
var $fef50f256b80dfa5$export$2e2bcd8739ae039 = $fef50f256b80dfa5$var$statisticToken;


function $e5b39cd103b44493$var$getDefaultComponentToken(component, token, getDefaultToken) {
    if (typeof getDefaultToken === "function") {
        var _token$component;
        return getDefaultToken((0, $fef50f256b80dfa5$export$4950aa0f605343fb)(token, (_token$component = token[component]) !== null && _token$component !== void 0 ? _token$component : {}));
    }
    return getDefaultToken !== null && getDefaultToken !== void 0 ? getDefaultToken : {};
}
var $e5b39cd103b44493$export$2e2bcd8739ae039 = $e5b39cd103b44493$var$getDefaultComponentToken;



function $6d863d6f4a4ffa83$var$genMaxMin(type) {
    if (type === "js") return {
        max: Math.max,
        min: Math.min
    };
    return {
        max: function max() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return "max(".concat(args.map(function(value) {
                return (0, $05f34ed03d41967d$export$523c0b569236b342)(value);
            }).join(","), ")");
        },
        min: function min() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return "min(".concat(args.map(function(value) {
                return (0, $05f34ed03d41967d$export$523c0b569236b342)(value);
            }).join(","), ")");
        }
    };
}
var $6d863d6f4a4ffa83$export$2e2bcd8739ae039 = $6d863d6f4a4ffa83$var$genMaxMin;








var $cQmXV = parcelRequire("cQmXV");
var $091cc978e657e53e$var$BEAT_LIMIT = 600000;
/**
 * A helper class to map keys to values.
 * It supports both primitive keys and object keys.
 */ var $091cc978e657e53e$var$ArrayKeyMap = /*#__PURE__*/ function() {
    function ArrayKeyMap() {
        (0, $07be749aeca07699$export$2e2bcd8739ae039)(this, ArrayKeyMap);
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(this, "map", new Map());
        // Use WeakMap to avoid memory leak
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(this, "objectIDMap", new WeakMap());
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(this, "nextID", 0);
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(this, "lastAccessBeat", new Map());
        // We will clean up the cache when reach the limit
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(this, "accessBeat", 0);
    }
    (0, $c180160353ceabc3$export$2e2bcd8739ae039)(ArrayKeyMap, [
        {
            key: "set",
            value: function set(keys, value) {
                // New set will trigger clear
                this.clear();
                // Set logic
                var compositeKey = this.getCompositeKey(keys);
                this.map.set(compositeKey, value);
                this.lastAccessBeat.set(compositeKey, Date.now());
            }
        },
        {
            key: "get",
            value: function get(keys) {
                var compositeKey = this.getCompositeKey(keys);
                var cache = this.map.get(compositeKey);
                this.lastAccessBeat.set(compositeKey, Date.now());
                this.accessBeat += 1;
                return cache;
            }
        },
        {
            key: "getCompositeKey",
            value: function getCompositeKey(keys) {
                var _this = this;
                var ids = keys.map(function(key) {
                    if (key && (0, $ccb28fa1a7ecc481$export$2e2bcd8739ae039)(key) === "object") return "obj_".concat(_this.getObjectID(key));
                    return "".concat((0, $ccb28fa1a7ecc481$export$2e2bcd8739ae039)(key), "_").concat(key);
                });
                return ids.join("|");
            }
        },
        {
            key: "getObjectID",
            value: function getObjectID(obj) {
                if (this.objectIDMap.has(obj)) return this.objectIDMap.get(obj);
                var id = this.nextID;
                this.objectIDMap.set(obj, id);
                this.nextID += 1;
                return id;
            }
        },
        {
            key: "clear",
            value: function clear() {
                var _this2 = this;
                if (this.accessBeat > 10000) {
                    var now = Date.now();
                    this.lastAccessBeat.forEach(function(beat, key) {
                        if (now - beat > $091cc978e657e53e$var$BEAT_LIMIT) {
                            _this2.map.delete(key);
                            _this2.lastAccessBeat.delete(key);
                        }
                    });
                    this.accessBeat = 0;
                }
            }
        }
    ]);
    return ArrayKeyMap;
}();
var $091cc978e657e53e$var$uniqueMap = new $091cc978e657e53e$var$ArrayKeyMap();
/**
 * Like `useMemo`, but this hook result will be shared across all instances.
 */ function $091cc978e657e53e$var$useUniqueMemo(memoFn, deps) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useMemo(function() {
        var cachedValue = $091cc978e657e53e$var$uniqueMap.get(deps);
        if (cachedValue) return cachedValue;
        var newValue = memoFn();
        $091cc978e657e53e$var$uniqueMap.set(deps, newValue);
        return newValue;
    }, deps);
}
var $091cc978e657e53e$export$2e2bcd8739ae039 = $091cc978e657e53e$var$useUniqueMemo;


/**
 * Provide a default hook since not everyone needs to config this.
 */ var $736780eeafbdd577$var$useDefaultCSP = function useDefaultCSP() {
    return {};
};
var $736780eeafbdd577$export$2e2bcd8739ae039 = $736780eeafbdd577$var$useDefaultCSP;


function $562241d7e94fdd18$var$genStyleUtils(config) {
    // Dependency inversion for preparing basic config.
    var _config$useCSP = config.useCSP, useCSP = _config$useCSP === void 0 ? (0, $736780eeafbdd577$export$2e2bcd8739ae039) : _config$useCSP, useToken = config.useToken, usePrefix = config.usePrefix, getResetStyles = config.getResetStyles, getCommonStyle = config.getCommonStyle, getCompUnitless = config.getCompUnitless;
    function genStyleHooks(component, styleFn, getDefaultToken, options) {
        var componentName = Array.isArray(component) ? component[0] : component;
        function prefixToken(key) {
            return "".concat(String(componentName)).concat(key.slice(0, 1).toUpperCase()).concat(key.slice(1));
        }
        // Fill unitless
        var originUnitless = (options === null || options === void 0 ? void 0 : options.unitless) || {};
        var originCompUnitless = typeof getCompUnitless === "function" ? getCompUnitless(component) : {};
        var compUnitless = (0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, originCompUnitless), {}, (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)({}, prefixToken("zIndexPopup"), true));
        Object.keys(originUnitless).forEach(function(key) {
            compUnitless[prefixToken(key)] = originUnitless[key];
        });
        // Options
        var mergedOptions = (0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, options), {}, {
            unitless: compUnitless,
            prefixToken: prefixToken
        });
        // Hooks
        var useStyle = genComponentStyleHook(component, styleFn, getDefaultToken, mergedOptions);
        var useCSSVar = genCSSVarRegister(componentName, getDefaultToken, mergedOptions);
        return function(prefixCls) {
            var rootCls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : prefixCls;
            var hashId = useStyle(prefixCls, rootCls);
            // Resolve function type to get dynamic extra prefix
            var extraPrefixCls = options === null || options === void 0 ? void 0 : options.extraCssVarPrefixCls;
            var resolvedExtraPrefixCls = typeof extraPrefixCls === "function" ? extraPrefixCls({
                prefixCls: prefixCls,
                rootCls: rootCls
            }) : extraPrefixCls;
            var cssVarCls = useCSSVar(resolvedExtraPrefixCls !== null && resolvedExtraPrefixCls !== void 0 && resolvedExtraPrefixCls.length ? [
                rootCls
            ].concat((0, $68381b18b974dc9f$export$2e2bcd8739ae039)(resolvedExtraPrefixCls)) : rootCls);
            return [
                hashId,
                cssVarCls
            ];
        };
    }
    function genCSSVarRegister(component, getDefaultToken, options) {
        var compUnitless = options.unitless, prefixToken = options.prefixToken, ignore = options.ignore;
        return function(rootCls) {
            var _useToken = useToken(), cssVar = _useToken.cssVar, realToken = _useToken.realToken;
            var csp = useCSP();
            (0, $496ed4f36d7e1f98$export$2e2bcd8739ae039)({
                path: [
                    component
                ],
                prefix: cssVar.prefix,
                key: cssVar.key,
                unitless: compUnitless,
                ignore: ignore,
                token: realToken,
                scope: rootCls,
                nonce: function nonce() {
                    return csp.nonce;
                }
            }, function() {
                var defaultToken = (0, $e5b39cd103b44493$export$2e2bcd8739ae039)(component, realToken, getDefaultToken);
                var componentToken = (0, $d2850981b25874f5$export$2e2bcd8739ae039)(component, realToken, defaultToken, {
                    deprecatedTokens: options === null || options === void 0 ? void 0 : options.deprecatedTokens
                });
                if (defaultToken) Object.keys(defaultToken).forEach(function(key) {
                    componentToken[prefixToken(key)] = componentToken[key];
                    delete componentToken[key];
                });
                return componentToken;
            });
            return cssVar === null || cssVar === void 0 ? void 0 : cssVar.key;
        };
    }
    function genComponentStyleHook(componentName, styleFn, getDefaultToken) {
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var cells = Array.isArray(componentName) ? componentName : [
            componentName,
            componentName
        ];
        var _cells = (0, $6b65fc3b4acde7f2$export$2e2bcd8739ae039)(cells, 1), component = _cells[0];
        var concatComponent = cells.join("-");
        var mergedLayer = config.layer || {
            name: "antd"
        };
        // Return new style hook
        return function(prefixCls) {
            var rootCls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : prefixCls;
            var _useToken2 = useToken(), theme = _useToken2.theme, realToken = _useToken2.realToken, hashId = _useToken2.hashId, token = _useToken2.token, cssVar = _useToken2.cssVar, zeroRuntime = _useToken2.zeroRuntime;
            // Update of `disabledRuntimeStyle` would cause React hook error, so memoized it and never update.
            var memoizedZeroRuntime = (0, $cQmXV.useMemo)(function() {
                return zeroRuntime;
            }, []);
            if (memoizedZeroRuntime) return hashId;
            var _usePrefix = usePrefix(), rootPrefixCls = _usePrefix.rootPrefixCls, iconPrefixCls = _usePrefix.iconPrefixCls;
            var csp = useCSP();
            var type = "css";
            // Use unique memo to share the result across all instances
            var calc = (0, $091cc978e657e53e$export$2e2bcd8739ae039)(function() {
                var unitlessCssVar = new Set();
                Object.keys(options.unitless || {}).forEach(function(key) {
                    // Some component proxy the AliasToken (e.g. Image) and some not (e.g. Modal)
                    // We should both pass in `unitlessCssVar` to make sure the CSSVar can be unitless.
                    unitlessCssVar.add((0, $bf825bc7ff5f466f$export$309b3b095f0c7662)(key, cssVar.prefix));
                    unitlessCssVar.add((0, $bf825bc7ff5f466f$export$309b3b095f0c7662)(key, (0, $7500218a94b59e9b$export$2e2bcd8739ae039)(component, cssVar.prefix)));
                });
                return (0, $c105d3f1e2d0f20f$export$2e2bcd8739ae039)(type, unitlessCssVar);
            }, [
                type,
                component,
                cssVar === null || cssVar === void 0 ? void 0 : cssVar.prefix
            ]);
            var _genMaxMin = (0, $6d863d6f4a4ffa83$export$2e2bcd8739ae039)(type), max = _genMaxMin.max, min = _genMaxMin.min;
            // Shared config
            var sharedConfig = {
                theme: theme,
                token: token,
                hashId: hashId,
                nonce: function nonce() {
                    return csp.nonce;
                },
                clientOnly: options.clientOnly,
                layer: mergedLayer,
                // antd is always at top of styles
                order: options.order || -999
            };
            // This if statement is safe, as it will only be used if the generator has the function. It's not dynamic.
            if (typeof getResetStyles === "function") // Generate style for all need reset tags.
            (0, $0fc07301276d48a5$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, sharedConfig), {}, {
                clientOnly: false,
                path: [
                    "Shared",
                    rootPrefixCls
                ]
            }), function() {
                return getResetStyles(token, {
                    prefix: {
                        rootPrefixCls: rootPrefixCls,
                        iconPrefixCls: iconPrefixCls
                    },
                    csp: csp
                });
            });
            (0, $0fc07301276d48a5$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, sharedConfig), {}, {
                path: [
                    concatComponent,
                    prefixCls,
                    iconPrefixCls
                ]
            }), function() {
                if (options.injectStyle === false) return [];
                var _statisticToken = (0, $fef50f256b80dfa5$export$2e2bcd8739ae039)(token), proxyToken = _statisticToken.token, flush = _statisticToken.flush;
                var defaultComponentToken = (0, $e5b39cd103b44493$export$2e2bcd8739ae039)(component, realToken, getDefaultToken);
                var componentCls = ".".concat(prefixCls);
                var componentToken = (0, $d2850981b25874f5$export$2e2bcd8739ae039)(component, realToken, defaultComponentToken, {
                    deprecatedTokens: options.deprecatedTokens
                });
                if (defaultComponentToken && (0, $ccb28fa1a7ecc481$export$2e2bcd8739ae039)(defaultComponentToken) === "object") Object.keys(defaultComponentToken).forEach(function(key) {
                    defaultComponentToken[key] = "var(".concat((0, $bf825bc7ff5f466f$export$309b3b095f0c7662)(key, (0, $7500218a94b59e9b$export$2e2bcd8739ae039)(component, cssVar.prefix)), ")");
                });
                var mergedToken = (0, $fef50f256b80dfa5$export$4950aa0f605343fb)(proxyToken, {
                    componentCls: componentCls,
                    prefixCls: prefixCls,
                    iconCls: ".".concat(iconPrefixCls),
                    antCls: ".".concat(rootPrefixCls),
                    calc: calc,
                    max: max,
                    min: min
                }, defaultComponentToken);
                var styleInterpolation = styleFn(mergedToken, {
                    hashId: hashId,
                    prefixCls: prefixCls,
                    rootPrefixCls: rootPrefixCls,
                    iconPrefixCls: iconPrefixCls
                });
                flush(component, componentToken);
                var commonStyle = typeof getCommonStyle === "function" ? getCommonStyle(mergedToken, prefixCls, rootCls, options.resetFont) : null;
                return [
                    options.resetStyle === false ? null : commonStyle,
                    styleInterpolation
                ];
            });
            return hashId;
        };
    }
    function genSubStyleComponent(componentName, styleFn, getDefaultToken) {
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var useStyle = genComponentStyleHook(componentName, styleFn, getDefaultToken, (0, $f163cd56d32104d1$export$2e2bcd8739ae039)({
            resetStyle: false,
            // Sub Style should default after root one
            order: -998
        }, options));
        var StyledComponent = function StyledComponent(_ref) {
            var prefixCls = _ref.prefixCls, _ref$rootCls = _ref.rootCls, rootCls = _ref$rootCls === void 0 ? prefixCls : _ref$rootCls;
            useStyle(prefixCls, rootCls);
            return null;
        };
        return StyledComponent;
    }
    return {
        genStyleHooks: genStyleHooks,
        genSubStyleComponent: genSubStyleComponent,
        genComponentStyleHook: genComponentStyleHook
    };
}
var $562241d7e94fdd18$export$2e2bcd8739ae039 = $562241d7e94fdd18$var$genStyleUtils;









const { genStyleHooks: $6870d4d7c14ae0bb$export$51ec95de45185b42, genComponentStyleHook: $6870d4d7c14ae0bb$export$b8cc4ee2ee8cfbc8, genSubStyleComponent: $6870d4d7c14ae0bb$export$1537386bc155ea56 } = (0, $562241d7e94fdd18$export$2e2bcd8739ae039)({
    usePrefix: ()=>{
        const { getPrefixCls: getPrefixCls, iconPrefixCls: iconPrefixCls } = (0, $cQmXV.useContext)((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
        const rootPrefixCls = getPrefixCls();
        return {
            rootPrefixCls: rootPrefixCls,
            iconPrefixCls: iconPrefixCls
        };
    },
    useToken: ()=>{
        const [theme, realToken, hashId, token, cssVar, zeroRuntime] = (0, $b22e03a54a548614$export$2e2bcd8739ae039)();
        return {
            theme: theme,
            realToken: realToken,
            hashId: hashId,
            token: token,
            cssVar: cssVar,
            zeroRuntime: zeroRuntime
        };
    },
    useCSP: ()=>{
        const { csp: csp } = (0, $cQmXV.useContext)((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
        return csp ?? {};
    },
    getResetStyles: (token, config)=>{
        const linkStyle = (0, $519d20bf207ce864$export$905d771977096614)(token);
        return [
            linkStyle,
            {
                "&": linkStyle
            },
            (0, $519d20bf207ce864$export$f1a0b31dfb234e7e)(config?.prefix.iconPrefixCls ?? (0, $82ffd17441b57982$export$eaca8ee5ed21b4e9))
        ];
    },
    getCommonStyle: (0, $519d20bf207ce864$export$689382c111559cd9),
    getCompUnitless: ()=>(0, $b22e03a54a548614$export$c6b9faa6b723d31a)
});
const $6870d4d7c14ae0bb$export$d82b8f66c5649e14 = (antCls, component)=>{
    const cssPrefix = `--${antCls.replace(/\./g, "")}-${component}-`;
    const varName = (name)=>{
        return `${cssPrefix}${name}`;
    };
    const varRef = (name, fallback)=>{
        return fallback ? `var(${cssPrefix}${name}, ${fallback})` : `var(${cssPrefix}${name})`;
    };
    return [
        varName,
        varRef
    ];
};



const $f18bba386f5a0efe$var$genWaveStyle = (token)=>{
    const { componentCls: componentCls, colorPrimary: colorPrimary, motionDurationSlow: motionDurationSlow, motionEaseInOut: motionEaseInOut, motionEaseOutCirc: motionEaseOutCirc, antCls: antCls } = token;
    const [, varRef] = (0, $6870d4d7c14ae0bb$export$d82b8f66c5649e14)(antCls, "wave");
    return {
        [componentCls]: {
            position: "absolute",
            background: "transparent",
            pointerEvents: "none",
            boxSizing: "border-box",
            color: varRef("color", colorPrimary),
            boxShadow: `0 0 0 0 currentcolor`,
            opacity: 0.2,
            // =================== Motion ===================
            "&.wave-motion-appear": {
                transition: [
                    `box-shadow 0.4s`,
                    `opacity 2s`
                ].map((prop)=>`${prop} ${motionEaseOutCirc}`).join(","),
                "&-active": {
                    boxShadow: `0 0 0 6px currentcolor`,
                    opacity: 0
                },
                "&.wave-quick": {
                    transition: [
                        `box-shadow`,
                        `opacity`
                    ].map((prop)=>`${prop} ${motionDurationSlow} ${motionEaseInOut}`).join(",")
                }
            }
        }
    };
};
var $f18bba386f5a0efe$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$b8cc4ee2ee8cfbc8)("Wave", $f18bba386f5a0efe$var$genWaveStyle);



var $cQmXV = parcelRequire("cQmXV");




const $1f1e565d7b1db8d0$export$23466a5792b7a5d3 = `${(0, $82ffd17441b57982$export$e4ec87ea71f29b41)}-wave-target`;



var $cQmXV = parcelRequire("cQmXV");








const $8fc2cafc052c6399$export$9d61ea039e87eb91 = (color)=>{
    if (!color) return false;
    return (0, $8e2d153a3c855782$export$844ec244b1367d54)(color) && color !== "#fff" && color !== "#ffffff" && color !== "rgb(255, 255, 255)" && color !== "rgba(255, 255, 255, 1)" && !/rgba\((?:\d*, ){3}0\)/i.test(color) && // any transparent rgba color
    !/^#(?:[0-9a-f]{3}0|[0-9a-f]{6}00)$/i.test(color) && // any transparent hex color
    color !== "transparent" && color !== "canvastext";
};
function $8fc2cafc052c6399$export$651d8e9c80304fc8(node, colorSource = null) {
    const style = getComputedStyle(node);
    const { borderTopColor: borderTopColor, borderColor: borderColor, backgroundColor: backgroundColor } = style;
    if (colorSource && $8fc2cafc052c6399$export$9d61ea039e87eb91(style[colorSource])) return style[colorSource];
    return [
        borderTopColor,
        borderColor,
        backgroundColor
    ].find($8fc2cafc052c6399$export$9d61ea039e87eb91) ?? null;
}


"use client";
function $95058963b6b41982$var$validateNum(value) {
    return Number.isNaN(value) ? 0 : value;
}
const $95058963b6b41982$var$WaveEffect = (props)=>{
    const { className: className, target: target, component: component, colorSource: colorSource } = props;
    const divRef = $cQmXV.useRef(null);
    const { getPrefixCls: getPrefixCls } = $cQmXV.useContext((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    const rootPrefixCls = getPrefixCls();
    const [varName] = (0, $6870d4d7c14ae0bb$export$d82b8f66c5649e14)(rootPrefixCls, "wave");
    // ===================== Effect =====================
    const [waveColor, setWaveColor] = $cQmXV.useState(null);
    const [borderRadius, setBorderRadius] = $cQmXV.useState([]);
    const [left, setLeft] = $cQmXV.useState(0);
    const [top, setTop] = $cQmXV.useState(0);
    const [width, setWidth] = $cQmXV.useState(0);
    const [height, setHeight] = $cQmXV.useState(0);
    const [enabled, setEnabled] = $cQmXV.useState(false);
    const waveStyle = {
        left: left,
        top: top,
        width: width,
        height: height,
        borderRadius: borderRadius.map((radius)=>`${radius}px`).join(" ")
    };
    if (waveColor) waveStyle[varName("color")] = waveColor;
    function syncPos() {
        const nodeStyle = getComputedStyle(target);
        // Get wave color from target
        setWaveColor((0, $8fc2cafc052c6399$export$651d8e9c80304fc8)(target, colorSource));
        const isStatic = nodeStyle.position === "static";
        // Rect
        const { borderLeftWidth: borderLeftWidth, borderTopWidth: borderTopWidth } = nodeStyle;
        setLeft(isStatic ? target.offsetLeft : $95058963b6b41982$var$validateNum(-Number.parseFloat(borderLeftWidth)));
        setTop(isStatic ? target.offsetTop : $95058963b6b41982$var$validateNum(-Number.parseFloat(borderTopWidth)));
        setWidth(target.offsetWidth);
        setHeight(target.offsetHeight);
        // Get border radius
        const { borderTopLeftRadius: borderTopLeftRadius, borderTopRightRadius: borderTopRightRadius, borderBottomLeftRadius: borderBottomLeftRadius, borderBottomRightRadius: borderBottomRightRadius } = nodeStyle;
        setBorderRadius([
            borderTopLeftRadius,
            borderTopRightRadius,
            borderBottomRightRadius,
            borderBottomLeftRadius
        ].map((radius)=>$95058963b6b41982$var$validateNum(Number.parseFloat(radius))));
    }
    $cQmXV.useEffect(()=>{
        if (target) {
            // We need delay to check position here
            // since UI may change after click
            const id = (0, $905c53b807de704e$export$2e2bcd8739ae039)(()=>{
                syncPos();
                setEnabled(true);
            });
            // Add resize observer to follow size
            let resizeObserver;
            if (typeof ResizeObserver !== "undefined") {
                resizeObserver = new ResizeObserver(syncPos);
                resizeObserver.observe(target);
            }
            return ()=>{
                (0, $905c53b807de704e$export$2e2bcd8739ae039).cancel(id);
                resizeObserver?.disconnect();
            };
        }
    }, [
        target
    ]);
    if (!enabled) return null;
    const isSmallComponent = (component === "Checkbox" || component === "Radio") && target?.classList.contains((0, $1f1e565d7b1db8d0$export$23466a5792b7a5d3));
    return /*#__PURE__*/ $cQmXV.createElement((0, $04c53b89814950f8$export$2e2bcd8739ae039), {
        visible: true,
        motionAppear: true,
        motionName: "wave-motion",
        motionDeadline: 5000,
        onAppearEnd: (_, event)=>{
            if (event.deadline || (0, $8e2d153a3c855782$export$9e6f93c2a213a96b)(event) && event.propertyName === "opacity") {
                const holder = divRef.current?.parentElement;
                (0, $462099a4eea3a68d$export$121e2d597d222bad)(holder).then(()=>{
                    holder?.remove();
                });
            }
            return false;
        }
    }, ({ className: motionClassName }, ref)=>/*#__PURE__*/ $cQmXV.createElement("div", {
            ref: (0, $10341b937b26f69d$export$ab452c34e8e05029)(divRef, ref),
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(className, motionClassName, {
                "wave-quick": isSmallComponent
            }),
            style: waveStyle
        }));
};
const $95058963b6b41982$var$showWaveEffect = (target, info)=>{
    const { component: component } = info;
    // Skip for unchecked checkbox
    if (component === "Checkbox" && !target.querySelector("input")?.checked) return;
    // Create holder
    const holder = document.createElement("div");
    holder.style.position = "absolute";
    holder.style.left = "0px";
    holder.style.top = "0px";
    target?.insertBefore(holder, target?.firstChild);
    (0, $462099a4eea3a68d$export$b3890eb0ae9dca99)(/*#__PURE__*/ $cQmXV.createElement($95058963b6b41982$var$WaveEffect, {
        ...info,
        target: target
    }), holder);
};
var $95058963b6b41982$export$2e2bcd8739ae039 = $95058963b6b41982$var$showWaveEffect;


const $ee62cdfecebc3008$var$useWave = (nodeRef, className, component, colorSource)=>{
    const { wave: wave } = $cQmXV.useContext((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    const [, token, hashId] = (0, $b22e03a54a548614$export$2e2bcd8739ae039)();
    const showWave = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((event)=>{
        const node = nodeRef.current;
        if (wave?.disabled || !node) return;
        const targetNode = node.querySelector(`.${(0, $1f1e565d7b1db8d0$export$23466a5792b7a5d3)}`) || node;
        const { showEffect: showEffect } = wave || {};
        // Customize wave effect
        (showEffect || (0, $95058963b6b41982$export$2e2bcd8739ae039))(targetNode, {
            className: className,
            token: token,
            component: component,
            event: event,
            hashId: hashId,
            colorSource: colorSource
        });
    });
    const rafIdRef = $cQmXV.useRef(null);
    // Clean up RAF on unmount to prevent memory leaks and stale callbacks
    $cQmXV.useEffect(()=>()=>{
            (0, $905c53b807de704e$export$2e2bcd8739ae039).cancel(rafIdRef.current);
        }, []);
    // Merge trigger event into one for each frame
    const showDebounceWave = (event)=>{
        (0, $905c53b807de704e$export$2e2bcd8739ae039).cancel(rafIdRef.current);
        rafIdRef.current = (0, $905c53b807de704e$export$2e2bcd8739ae039)(()=>{
            showWave(event);
        });
    };
    return showDebounceWave;
};
var $ee62cdfecebc3008$export$2e2bcd8739ae039 = $ee62cdfecebc3008$var$useWave;


const $02f5adbd0068e010$var$TRIGGER_TYPE_TO_EVENT_MAP = {
    click: "click",
    mousedown: "mousedown",
    mouseup: "mouseup",
    pointerdown: "pointerdown",
    pointerup: "pointerup"
};
const $02f5adbd0068e010$var$Wave = (props)=>{
    const { children: children, disabled: disabled, component: component, colorSource: colorSource } = props;
    const { getPrefixCls: getPrefixCls, wave: wave } = (0, $cQmXV.useContext)((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    const containerRef = (0, $cQmXV.useRef)(null);
    // ============================== Style ===============================
    const prefixCls = getPrefixCls("wave");
    const hashId = (0, $f18bba386f5a0efe$export$2e2bcd8739ae039)(prefixCls);
    // =============================== Wave ===============================
    const showWave = (0, $ee62cdfecebc3008$export$2e2bcd8739ae039)(containerRef, (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, hashId), component, colorSource);
    // ============================== Effect ==============================
    (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useEffect(()=>{
        const node = containerRef.current;
        if (!node || node.nodeType !== window.Node.ELEMENT_NODE || disabled) return;
        const onClick = (e)=>{
            // Fix radio button click twice
            if (!(0, $c70640475a7bd353$export$2e2bcd8739ae039)(e.target) || !node.getAttribute || node.getAttribute("disabled") || node.disabled || node.className.includes("disabled") && !node.className.includes("disabled:") || node.getAttribute("aria-disabled") === "true" || node.className.includes("-leave")) return;
            showWave(e);
        };
        const triggerType = wave?.triggerType;
        const eventName = triggerType && triggerType in $02f5adbd0068e010$var$TRIGGER_TYPE_TO_EVENT_MAP ? $02f5adbd0068e010$var$TRIGGER_TYPE_TO_EVENT_MAP[triggerType] : "click";
        node.addEventListener(eventName, onClick, true);
        return ()=>{
            node.removeEventListener(eventName, onClick, true);
        };
    }, [
        disabled,
        wave?.triggerType
    ]);
    // ============================== Render ==============================
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).isValidElement(children)) return children ?? null;
    const ref = (0, $10341b937b26f69d$export$c1cec34af06bcf7)(children) ? (0, $10341b937b26f69d$export$ab452c34e8e05029)((0, $10341b937b26f69d$export$7465e5c0bf44f19a)(children), containerRef) : containerRef;
    return (0, $a91ef204d03d8eec$export$e530037191fcd5d7)(children, {
        ref: ref
    });
};
var $02f5adbd0068e010$export$2e2bcd8739ae039 = $02f5adbd0068e010$var$Wave;





var $cQmXV = parcelRequire("cQmXV");


const $78cdfb6138721329$var$useSize = (customSize)=>{
    const size = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useContext((0, $767e8ef819e95b6d$export$2e2bcd8739ae039));
    const mergedSize = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useMemo(()=>{
        if (!customSize) return size;
        if ((0, $8e2d153a3c855782$export$844ec244b1367d54)(customSize)) return customSize ?? size;
        if ((0, $8e2d153a3c855782$export$f6e2535fb5126e54)(customSize)) return customSize(size);
        return size;
    }, [
        customSize,
        size
    ]);
    return mergedSize;
};
var $78cdfb6138721329$export$2e2bcd8739ae039 = $78cdfb6138721329$var$useSize;



var $cQmXV = parcelRequire("cQmXV");



var $cQmXV = parcelRequire("cQmXV");
const $78e4f9cb51a5af1c$var$isValidOrientation = (orientation)=>{
    return orientation === "horizontal" || orientation === "vertical";
};
const $78e4f9cb51a5af1c$export$550084c67147f6c4 = (orientation, vertical, legacyDirection)=>{
    return (0, $cQmXV.useMemo)(()=>{
        const validOrientation = $78e4f9cb51a5af1c$var$isValidOrientation(orientation);
        let mergedOrientation;
        if (validOrientation) mergedOrientation = orientation;
        else if (typeof vertical === "boolean") mergedOrientation = vertical ? "vertical" : "horizontal";
        else {
            const validLegacyDirection = $78e4f9cb51a5af1c$var$isValidOrientation(legacyDirection);
            mergedOrientation = validLegacyDirection ? legacyDirection : "horizontal";
        }
        return [
            mergedOrientation,
            mergedOrientation === "vertical"
        ];
    }, [
        legacyDirection,
        orientation,
        vertical
    ]);
};






const $39ae206bcd8e6990$var$genSpaceCompactStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: {
            display: "inline-flex",
            "&-block": {
                display: "flex",
                width: "100%"
            },
            "&-vertical": {
                flexDirection: "column"
            },
            "&-rtl": {
                direction: "rtl"
            }
        }
    };
};
var // ============================== Export ==============================
$39ae206bcd8e6990$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$51ec95de45185b42)([
    "Space",
    "Compact"
], $39ae206bcd8e6990$var$genSpaceCompactStyle, ()=>({}), {
    // Space component don't apply extra font style
    // https://github.com/ant-design/ant-design/issues/40315
    resetStyle: false
});


"use client";
const $68fddf51400eda11$export$8d1c486ac0db0a7d = /*#__PURE__*/ $cQmXV.createContext(null);
const $68fddf51400eda11$export$cd8cf9d7bab8dd4 = (prefixCls, direction)=>{
    const compactItemContext = $cQmXV.useContext($68fddf51400eda11$export$8d1c486ac0db0a7d);
    const compactItemClassnames = $cQmXV.useMemo(()=>{
        if (!compactItemContext) return "";
        const { compactDirection: compactDirection, isFirstItem: isFirstItem, isLastItem: isLastItem } = compactItemContext;
        const separator = compactDirection === "vertical" ? "-vertical-" : "-";
        return (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-compact${separator}item`, {
            [`${prefixCls}-compact${separator}first-item`]: isFirstItem,
            [`${prefixCls}-compact${separator}last-item`]: isLastItem,
            [`${prefixCls}-compact${separator}item-rtl`]: direction === "rtl"
        });
    }, [
        prefixCls,
        direction,
        compactItemContext
    ]);
    return {
        compactSize: compactItemContext?.compactSize,
        compactDirection: compactItemContext?.compactDirection,
        compactItemClassnames: compactItemClassnames
    };
};
const $68fddf51400eda11$export$5f56e610a4afb685 = (props)=>{
    const { children: children } = props;
    return /*#__PURE__*/ $cQmXV.createElement($68fddf51400eda11$export$8d1c486ac0db0a7d.Provider, {
        value: null
    }, children);
};
const $68fddf51400eda11$var$CompactItem = (props)=>{
    const { children: children, ...others } = props;
    return /*#__PURE__*/ $cQmXV.createElement($68fddf51400eda11$export$8d1c486ac0db0a7d.Provider, {
        value: $cQmXV.useMemo(()=>others, [
            others
        ])
    }, children);
};
const $68fddf51400eda11$var$Compact = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { getPrefixCls: getPrefixCls, direction: directionConfig } = $cQmXV.useContext((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    const { size: size, direction: direction, orientation: orientation, block: block, prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, children: children, vertical: vertical, ...restProps } = props;
    const [mergedOrientation, mergedVertical] = (0, $78e4f9cb51a5af1c$export$550084c67147f6c4)(orientation, vertical, direction);
    const mergedSize = (0, $78cdfb6138721329$export$2e2bcd8739ae039)((ctx)=>size ?? ctx);
    const prefixCls = getPrefixCls("space-compact", customizePrefixCls);
    const [hashId] = (0, $39ae206bcd8e6990$export$2e2bcd8739ae039)(prefixCls);
    const clx = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, hashId, {
        [`${prefixCls}-rtl`]: directionConfig === "rtl",
        [`${prefixCls}-block`]: block,
        [`${prefixCls}-vertical`]: mergedVertical
    }, className, rootClassName);
    const compactItemContext = $cQmXV.useContext($68fddf51400eda11$export$8d1c486ac0db0a7d);
    const nativeElementRef = $cQmXV.useRef(null);
    $cQmXV.useImperativeHandle(ref, ()=>({
            nativeElement: nativeElementRef.current
        }));
    const childNodes = (0, $cd966a313e0a92ff$export$2e2bcd8739ae039)(children);
    const nodes = $cQmXV.useMemo(()=>childNodes.map((child, i)=>{
            const key = child?.key || `${prefixCls}-item-${i}`;
            return /*#__PURE__*/ $cQmXV.createElement($68fddf51400eda11$var$CompactItem, {
                key: key,
                compactSize: mergedSize,
                compactDirection: mergedOrientation,
                isFirstItem: i === 0 && (!compactItemContext || compactItemContext?.isFirstItem),
                isLastItem: i === childNodes.length - 1 && (!compactItemContext || compactItemContext?.isLastItem)
            }, child);
        }), [
        childNodes,
        compactItemContext,
        mergedOrientation,
        mergedSize,
        prefixCls
    ]);
    // =========================== Render ===========================
    if (childNodes.length === 0) return null;
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        ref: nativeElementRef,
        className: clx,
        ...restProps
    }, nodes);
});
var $68fddf51400eda11$export$2e2bcd8739ae039 = $68fddf51400eda11$var$Compact;



var $cQmXV = parcelRequire("cQmXV");




"use client";
const $f9eeaefe4fcb3479$export$ed0cc8bd1f617d6d = /*#__PURE__*/ $cQmXV.createContext(undefined);
const $f9eeaefe4fcb3479$var$ButtonGroup = (props)=>{
    const { getPrefixCls: getPrefixCls, direction: direction } = $cQmXV.useContext((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    const { prefixCls: customizePrefixCls, size: size, className: className, ...others } = props;
    const prefixCls = getPrefixCls("btn-group", customizePrefixCls);
    const [, , hashId] = (0, $b22e03a54a548614$export$2e2bcd8739ae039)();
    const sizeCls = $cQmXV.useMemo(()=>{
        switch(size){
            case "large":
                return "lg";
            case "small":
                return "sm";
            default:
                return "";
        }
    }, [
        size
    ]);
    const classes = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, {
        [`${prefixCls}-${sizeCls}`]: sizeCls,
        [`${prefixCls}-rtl`]: direction === "rtl"
    }, className, hashId);
    return /*#__PURE__*/ $cQmXV.createElement($f9eeaefe4fcb3479$export$ed0cc8bd1f617d6d.Provider, {
        value: size
    }, /*#__PURE__*/ $cQmXV.createElement("div", {
        ...others,
        className: classes
    }));
};
var $f9eeaefe4fcb3479$export$2e2bcd8739ae039 = $f9eeaefe4fcb3479$var$ButtonGroup;




var $cQmXV = parcelRequire("cQmXV");




"use client";
const $62e55ded4111e367$var$rxTwoCNChar = /^[\u4E00-\u9FA5]{2}$/;
const $62e55ded4111e367$export$c5dca2bf412dea0d = $62e55ded4111e367$var$rxTwoCNChar.test.bind($62e55ded4111e367$var$rxTwoCNChar);
function $62e55ded4111e367$export$19bc9a290855952(type) {
    if (type === "danger") return {
        danger: true
    };
    return {
        type: type
    };
}
function $62e55ded4111e367$export$b120bc11c0d9c214(type) {
    return type === "text" || type === "link";
}
function $62e55ded4111e367$var$splitCNCharsBySpace(child, needInserted, style, className) {
    if (!(0, $8e2d153a3c855782$export$72280d5f896dac9a)(child)) return;
    const SPACE = needInserted ? " " : "";
    if (!(0, $8e2d153a3c855782$export$844ec244b1367d54)(child) && !(0, $8e2d153a3c855782$export$7e4aa119212bc614)(child) && (0, $8e2d153a3c855782$export$844ec244b1367d54)(child.type) && $62e55ded4111e367$export$c5dca2bf412dea0d(child.props.children)) return (0, $a91ef204d03d8eec$export$e530037191fcd5d7)(child, (oriProps)=>{
        const mergedCls = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(oriProps.className, className) || undefined;
        const mergedStyle = {
            ...style,
            ...oriProps.style
        };
        return {
            ...oriProps,
            children: oriProps.children.split("").join(SPACE),
            className: mergedCls,
            style: mergedStyle
        };
    });
    if ((0, $8e2d153a3c855782$export$844ec244b1367d54)(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("span", {
        className: className,
        style: style
    }, $62e55ded4111e367$export$c5dca2bf412dea0d(child) ? child.split("").join(SPACE) : child);
    if ((0, $a91ef204d03d8eec$export$9522e17588c12572)(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("span", {
        className: className,
        style: style
    }, child);
    return (0, $a91ef204d03d8eec$export$e530037191fcd5d7)(child, (oriProps)=>({
            ...oriProps,
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(oriProps.className, className) || undefined,
            style: {
                ...oriProps.style,
                ...style
            }
        }));
}
function $62e55ded4111e367$export$b6ee00a7e7908bc(children, needInserted, style, className) {
    let isPrevChildPure = false;
    const childList = [];
    (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Children.forEach(children, (child)=>{
        const isCurrentChildPure = (0, $8e2d153a3c855782$export$844ec244b1367d54)(child) || (0, $8e2d153a3c855782$export$7e4aa119212bc614)(child);
        if (isPrevChildPure && isCurrentChildPure) {
            const lastIndex = childList.length - 1;
            const lastChild = childList[lastIndex];
            childList[lastIndex] = `${lastChild}${child}`;
        } else childList.push(child);
        isPrevChildPure = isCurrentChildPure;
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Children.map(childList, (child)=>$62e55ded4111e367$var$splitCNCharsBySpace(child, needInserted, style, className));
}
const $62e55ded4111e367$var$_ButtonTypes = [
    "default",
    "primary",
    "dashed",
    "link",
    "text"
];
const $62e55ded4111e367$var$_ButtonShapes = [
    "default",
    "circle",
    "round",
    "square"
];
const $62e55ded4111e367$var$_ButtonHTMLTypes = [
    "submit",
    "button",
    "reset"
];
const $62e55ded4111e367$export$9870b52452f51da5 = [
    "outlined",
    "dashed",
    "solid",
    "filled",
    "text",
    "link"
];
const $62e55ded4111e367$export$760f16d96e091fc5 = [
    "default",
    "primary",
    "danger"
].concat((0, $68381b18b974dc9f$export$2e2bcd8739ae039)((0, $ade5e73b59dc3f96$export$6d4fe3a00a1811ad)));



var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");
var $e042fd66efa44a9b$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($e042fd66efa44a9b$exports, "__esModule", {
    value: true
});
var $e042fd66efa44a9b$var$LoadingOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"
                }
            }
        ]
    },
    "name": "loading",
    "theme": "outlined"
};
$e042fd66efa44a9b$exports.default = $e042fd66efa44a9b$var$LoadingOutlined;



var $cQmXV = parcelRequire("cQmXV");



var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");

const $31d1f76aeb92e12f$var$APPEND_ORDER = "data-rc-order";
const $31d1f76aeb92e12f$var$APPEND_PRIORITY = "data-rc-priority";
const $31d1f76aeb92e12f$var$MARK_KEY = "rc-util-key";
const $31d1f76aeb92e12f$var$containerCache = new Map();
function $31d1f76aeb92e12f$var$canUseDom() {
    return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}
function $31d1f76aeb92e12f$var$contains(root, node) {
    if (!root || !node) return false;
    if (root.contains) return root.contains(node);
    let current = node;
    while(current){
        if (current === root) return true;
        current = current.parentNode;
    }
    return false;
}
function $31d1f76aeb92e12f$var$getMark({ mark: mark } = {}) {
    if (mark) return mark.startsWith("data-") ? mark : `data-${mark}`;
    return $31d1f76aeb92e12f$var$MARK_KEY;
}
function $31d1f76aeb92e12f$var$getContainer(option) {
    if (option.attachTo) return option.attachTo;
    const head = document.querySelector("head");
    return head || document.body;
}
function $31d1f76aeb92e12f$var$getOrder(prepend) {
    if (prepend === "queue") return "prependQueue";
    return prepend ? "prepend" : "append";
}
function $31d1f76aeb92e12f$var$findStyles(container) {
    return Array.from(($31d1f76aeb92e12f$var$containerCache.get(container) || container).children).filter((node)=>node.tagName === "STYLE");
}
function $31d1f76aeb92e12f$var$injectCSS(css, option = {}) {
    if (!$31d1f76aeb92e12f$var$canUseDom()) return null;
    const { csp: csp, prepend: prepend, priority: priority = 0 } = option;
    const mergedOrder = $31d1f76aeb92e12f$var$getOrder(prepend);
    const isPrependQueue = mergedOrder === "prependQueue";
    const styleNode = document.createElement("style");
    styleNode.setAttribute($31d1f76aeb92e12f$var$APPEND_ORDER, mergedOrder);
    if (isPrependQueue && priority) styleNode.setAttribute($31d1f76aeb92e12f$var$APPEND_PRIORITY, `${priority}`);
    if (csp?.nonce) styleNode.nonce = csp.nonce;
    styleNode.innerHTML = css;
    const container = $31d1f76aeb92e12f$var$getContainer(option);
    const { firstChild: firstChild } = container;
    if (prepend) {
        if (isPrependQueue) {
            const existStyle = (option.styles || $31d1f76aeb92e12f$var$findStyles(container)).filter((node)=>{
                if (![
                    "prepend",
                    "prependQueue"
                ].includes(node.getAttribute($31d1f76aeb92e12f$var$APPEND_ORDER))) return false;
                const nodePriority = Number(node.getAttribute($31d1f76aeb92e12f$var$APPEND_PRIORITY) || 0);
                return priority >= nodePriority;
            });
            if (existStyle.length) {
                container.insertBefore(styleNode, existStyle[existStyle.length - 1].nextSibling);
                return styleNode;
            }
        }
        container.insertBefore(styleNode, firstChild);
    } else container.appendChild(styleNode);
    return styleNode;
}
function $31d1f76aeb92e12f$var$findExistNode(key, option = {}) {
    let { styles: styles } = option;
    styles ||= $31d1f76aeb92e12f$var$findStyles($31d1f76aeb92e12f$var$getContainer(option));
    return styles.find((node)=>node.getAttribute($31d1f76aeb92e12f$var$getMark(option)) === key);
}
function $31d1f76aeb92e12f$var$syncRealContainer(container, option) {
    const cachedRealContainer = $31d1f76aeb92e12f$var$containerCache.get(container);
    if (!cachedRealContainer || !$31d1f76aeb92e12f$var$contains(document, cachedRealContainer)) {
        const placeholderStyle = $31d1f76aeb92e12f$var$injectCSS("", option);
        if (!placeholderStyle) return;
        const { parentNode: parentNode } = placeholderStyle;
        $31d1f76aeb92e12f$var$containerCache.set(container, parentNode);
        container.removeChild(placeholderStyle);
    }
}
function $31d1f76aeb92e12f$export$4d99a2890bb989f0(css, key, originOption = {}) {
    if (!$31d1f76aeb92e12f$var$canUseDom()) return null;
    const container = $31d1f76aeb92e12f$var$getContainer(originOption);
    const styles = $31d1f76aeb92e12f$var$findStyles(container);
    const option = {
        ...originOption,
        styles: styles
    };
    $31d1f76aeb92e12f$var$syncRealContainer(container, option);
    const existNode = $31d1f76aeb92e12f$var$findExistNode(key, option);
    if (existNode) {
        if (option.csp?.nonce && existNode.nonce !== option.csp.nonce) existNode.nonce = option.csp.nonce;
        if (existNode.innerHTML !== css) existNode.innerHTML = css;
        return existNode;
    }
    const newNode = $31d1f76aeb92e12f$var$injectCSS(css, option);
    newNode?.setAttribute($31d1f76aeb92e12f$var$getMark(option), key);
    return newNode;
}
function $31d1f76aeb92e12f$var$getRoot(ele) {
    return ele?.getRootNode?.();
}
function $31d1f76aeb92e12f$export$70e8259662bb498b(ele) {
    const root = $31d1f76aeb92e12f$var$getRoot(ele);
    return typeof ShadowRoot !== "undefined" && root instanceof ShadowRoot ? root : null;
}
const $31d1f76aeb92e12f$var$warned = {};
function $31d1f76aeb92e12f$export$82934adf09101657(valid, message) {
    if (valid || $31d1f76aeb92e12f$var$warned[message]) return;
    $31d1f76aeb92e12f$var$warned[message] = true;
}


function $99e3ef479bf6c114$var$camelCase(input) {
    return input.replace(/-(.)/g, (match, g)=>g.toUpperCase());
}
function $99e3ef479bf6c114$export$491112666e282270(valid, message) {
    (0, $31d1f76aeb92e12f$export$82934adf09101657)(valid, `[@ant-design/icons] ${message}`);
}
function $99e3ef479bf6c114$export$ab652842c37578f4(target) {
    return typeof target === "object" && typeof target.name === "string" && typeof target.theme === "string" && (typeof target.icon === "object" || typeof target.icon === "function");
}
function $99e3ef479bf6c114$export$9f5073e7201cc21c(attrs = {}) {
    return Object.keys(attrs).reduce((acc, key)=>{
        const val = attrs[key];
        switch(key){
            case "class":
                acc.className = val;
                delete acc.class;
                break;
            default:
                delete acc[key];
                acc[$99e3ef479bf6c114$var$camelCase(key)] = val;
        }
        return acc;
    }, {});
}
function $99e3ef479bf6c114$export$80d376111cc09ad7(node, key, rootProps) {
    if (!rootProps) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement(node.tag, {
        key: key,
        ...$99e3ef479bf6c114$export$9f5073e7201cc21c(node.attrs)
    }, (node.children || []).map((child, index)=>$99e3ef479bf6c114$export$80d376111cc09ad7(child, `${key}-${node.tag}-${index}`)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement(node.tag, {
        key: key,
        ...$99e3ef479bf6c114$export$9f5073e7201cc21c(node.attrs),
        ...rootProps
    }, (node.children || []).map((child, index)=>$99e3ef479bf6c114$export$80d376111cc09ad7(child, `${key}-${node.tag}-${index}`)));
}
const $99e3ef479bf6c114$export$960a899a9cccb2d5 = {
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    focusable: "false"
};
const $99e3ef479bf6c114$export$2c99b98b77550cb4 = `
.anticon {
  display: inline-flex;
  align-items: center;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.anticon > * {
  line-height: 1;
}

.anticon svg {
  display: inline-block;
  vertical-align: inherit;
}

.anticon::before {
  display: none;
}

.anticon .anticon-icon {
  display: block;
}

.anticon[tabindex] {
  cursor: pointer;
}

.anticon-spin {
  -webkit-animation: loadingCircle 1s infinite linear;
  animation: loadingCircle 1s infinite linear;
}

@-webkit-keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
`;
const $99e3ef479bf6c114$export$938b1f86b61613d0 = (eleRef)=>{
    const { csp: csp, prefixCls: prefixCls, layer: layer, zeroRuntime: zeroRuntime } = (0, $cQmXV.useContext)((0, $92d549a1da97eca7$export$2e2bcd8739ae039));
    let mergedStyleStr = $99e3ef479bf6c114$export$2c99b98b77550cb4;
    if (prefixCls) mergedStyleStr = mergedStyleStr.replace(/anticon/g, prefixCls);
    if (layer) mergedStyleStr = `@layer ${layer} {\n${mergedStyleStr}\n}`;
    (0, $cQmXV.useEffect)(()=>{
        if (zeroRuntime) return;
        const ele = eleRef.current;
        const shadowRoot = (0, $31d1f76aeb92e12f$export$70e8259662bb498b)(ele);
        (0, $31d1f76aeb92e12f$export$4d99a2890bb989f0)(mergedStyleStr, "@ant-design-icons", {
            prepend: !layer,
            csp: csp,
            attachTo: shadowRoot
        });
    }, []);
};


const $900ee2ec664ac064$var$IconBase = (props)=>{
    const { icon: icon, className: className, onClick: onClick, style: style, primaryColor: _primaryColor, secondaryColor: _secondaryColor, ...restProps } = props;
    const svgRef = $cQmXV.useRef(null);
    (0, $99e3ef479bf6c114$export$938b1f86b61613d0)(svgRef);
    (0, $99e3ef479bf6c114$export$491112666e282270)((0, $99e3ef479bf6c114$export$ab652842c37578f4)(icon), `icon should be icon definiton, but got ${icon}`);
    if (!(0, $99e3ef479bf6c114$export$ab652842c37578f4)(icon)) return null;
    const target = icon;
    return (0, $99e3ef479bf6c114$export$80d376111cc09ad7)(target.icon, `svg-${target.name}`, {
        className: className,
        onClick: onClick,
        style: style,
        "data-icon": target.name,
        width: "1em",
        height: "1em",
        fill: "currentColor",
        "aria-hidden": "true",
        ...restProps,
        ref: svgRef
    });
};
$900ee2ec664ac064$var$IconBase.displayName = "IconReact";
var $900ee2ec664ac064$export$2e2bcd8739ae039 = $900ee2ec664ac064$var$IconBase;


"use client";
function $162ce9b1660c259f$var$_extends() {
    $162ce9b1660c259f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $162ce9b1660c259f$var$_extends.apply(this, arguments);
}
const $162ce9b1660c259f$var$Icon = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { className: // affect outter <i>...</i>
    className, icon: // affect inner <svg>...</svg>
    icon, spin: spin, rotate: rotate, tabIndex: tabIndex, onClick: onClick, twoToneColor: _twoToneColor, // other
    ...restProps } = props;
    const { prefixCls: prefixCls = "anticon", rootClassName: rootClassName } = $cQmXV.useContext((0, $92d549a1da97eca7$export$2e2bcd8739ae039));
    const classString = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(rootClassName, prefixCls, {
        [`${prefixCls}-${icon.name}`]: !!icon.name,
        [`${prefixCls}-spin`]: !!spin || icon.name === "loading"
    }, className);
    let iconTabIndex = tabIndex;
    if (iconTabIndex === undefined && onClick) iconTabIndex = -1;
    const svgStyle = rotate ? {
        msTransform: `rotate(${rotate}deg)`,
        transform: `rotate(${rotate}deg)`
    } : undefined;
    return /*#__PURE__*/ $cQmXV.createElement("span", $162ce9b1660c259f$var$_extends({
        role: "img",
        "aria-label": icon.name
    }, restProps, {
        ref: ref,
        tabIndex: iconTabIndex,
        onClick: onClick,
        className: classString
    }), /*#__PURE__*/ $cQmXV.createElement((0, $900ee2ec664ac064$export$2e2bcd8739ae039), {
        icon: icon,
        style: svgStyle
    }));
});
var $162ce9b1660c259f$export$2e2bcd8739ae039 = $162ce9b1660c259f$var$Icon;


function $bf7996ca956facd7$var$_extends() {
    $bf7996ca956facd7$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bf7996ca956facd7$var$_extends.apply(this, arguments);
}
const $bf7996ca956facd7$var$LoadingOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $bf7996ca956facd7$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e042fd66efa44a9b$exports)))
    }));
/**![loading](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTk4OCA1NDhjLTE5LjkgMC0zNi0xNi4xLTM2LTM2IDAtNTkuNC0xMS42LTExNy0zNC42LTE3MS4zYTQ0MC40NSA0NDAuNDUgMCAwMC05NC4zLTEzOS45IDQzNy43MSA0MzcuNzEgMCAwMC0xMzkuOS05NC4zQzYyOSA4My42IDU3MS40IDcyIDUxMiA3MmMtMTkuOSAwLTM2LTE2LjEtMzYtMzZzMTYuMS0zNiAzNi0zNmM2OS4xIDAgMTM2LjIgMTMuNSAxOTkuMyA0MC4zQzc3Mi4zIDY2IDgyNyAxMDMgODc0IDE1MGM0NyA0NyA4My45IDEwMS44IDEwOS43IDE2Mi43IDI2LjcgNjMuMSA0MC4yIDEzMC4yIDQwLjIgMTk5LjMuMSAxOS45LTE2IDM2LTM1LjkgMzZ6IiAvPjwvc3ZnPg==) */ const $bf7996ca956facd7$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($bf7996ca956facd7$var$LoadingOutlined);
var $bf7996ca956facd7$export$2e2bcd8739ae039 = $bf7996ca956facd7$var$RefIcon;





var $cQmXV = parcelRequire("cQmXV");

"use client";
const $912e7d9c7a8e3cf2$var$IconWrapper = /*#__PURE__*/ (0, $cQmXV.forwardRef)((props, ref)=>{
    const { className: className, style: style, children: children, prefixCls: prefixCls } = props;
    const iconWrapperCls = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-icon`, className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("span", {
        ref: ref,
        className: iconWrapperCls,
        style: style
    }, children);
});
var $912e7d9c7a8e3cf2$export$2e2bcd8739ae039 = $912e7d9c7a8e3cf2$var$IconWrapper;


"use client";
const $44c2f8faf8741e4b$var$InnerLoadingIcon = /*#__PURE__*/ (0, $cQmXV.forwardRef)((props, ref)=>{
    const { prefixCls: prefixCls, className: className, style: style, iconClassName: iconClassName } = props;
    const mergedIconCls = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-loading-icon`, className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $912e7d9c7a8e3cf2$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        className: mergedIconCls,
        style: style,
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $bf7996ca956facd7$export$2e2bcd8739ae039), {
        className: iconClassName
    }));
});
const $44c2f8faf8741e4b$var$getCollapsedWidth = ()=>({
        width: 0,
        opacity: 0,
        transform: "scale(0)"
    });
const $44c2f8faf8741e4b$var$getRealWidth = (node)=>({
        width: node.scrollWidth,
        opacity: 1,
        transform: "scale(1)"
    });
const $44c2f8faf8741e4b$var$DefaultLoadingIcon = (props)=>{
    const { prefixCls: prefixCls, loading: loading, existIcon: existIcon, className: className, style: style, mount: mount } = props;
    const visible = !!loading;
    if (existIcon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($44c2f8faf8741e4b$var$InnerLoadingIcon, {
        prefixCls: prefixCls,
        className: className,
        style: style
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $04c53b89814950f8$export$2e2bcd8739ae039), {
        visible: visible,
        // Used for minus flex gap style only
        motionName: `${prefixCls}-loading-icon-motion`,
        motionAppear: !mount,
        motionEnter: !mount,
        motionLeave: !mount,
        removeOnLeave: true,
        onAppearStart: $44c2f8faf8741e4b$var$getCollapsedWidth,
        onAppearActive: $44c2f8faf8741e4b$var$getRealWidth,
        onEnterStart: $44c2f8faf8741e4b$var$getCollapsedWidth,
        onEnterActive: $44c2f8faf8741e4b$var$getRealWidth,
        onLeaveStart: $44c2f8faf8741e4b$var$getRealWidth,
        onLeaveActive: $44c2f8faf8741e4b$var$getCollapsedWidth
    }, ({ className: motionCls, style: motionStyle }, ref)=>{
        const mergedStyle = {
            ...style,
            ...motionStyle
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($44c2f8faf8741e4b$var$InnerLoadingIcon, {
            prefixCls: prefixCls,
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(className, motionCls),
            style: mergedStyle,
            ref: ref
        });
    });
};
var $44c2f8faf8741e4b$export$2e2bcd8739ae039 = $44c2f8faf8741e4b$var$DefaultLoadingIcon;





const $e111c624d18c33f1$export$c5b4e7cabb00fc99 = ()=>{
    return {
        "@media (prefers-reduced-motion: reduce)": {
            "&, &::before, &::after": {
                transition: "none",
                animation: "none"
            }
        }
    };
};
const $e111c624d18c33f1$export$a2e3d2d19d960234 = ()=>{
    return {
        "@media (prefers-reduced-motion: reduce)": {
            transition: "none",
            animation: "none"
        }
    };
};



const $0d0e8fa830a917ca$var$genButtonBorderStyle = (buttonTypeCls, borderColor)=>({
        // Border
        [`> span, > ${buttonTypeCls}`]: {
            "&:not(:last-child)": {
                [`&, & > ${buttonTypeCls}`]: {
                    "&:not(:disabled)": {
                        borderInlineEndColor: borderColor
                    }
                }
            },
            "&:not(:first-child)": {
                [`&, & > ${buttonTypeCls}`]: {
                    "&:not(:disabled)": {
                        borderInlineStartColor: borderColor
                    }
                }
            }
        }
    });
const $0d0e8fa830a917ca$var$genGroupStyle = (token)=>{
    const { componentCls: componentCls, fontSize: fontSize, lineWidth: lineWidth, groupBorderColor: groupBorderColor, colorErrorHover: colorErrorHover } = token;
    return {
        [`${componentCls}-group`]: [
            {
                position: "relative",
                display: "inline-flex",
                // Border
                [`> span, > ${componentCls}`]: {
                    "&:not(:last-child)": {
                        [`&, & > ${componentCls}`]: {
                            borderStartEndRadius: 0,
                            borderEndEndRadius: 0
                        }
                    },
                    "&:not(:first-child)": {
                        marginInlineStart: token.calc(lineWidth).mul(-1).equal(),
                        [`&, & > ${componentCls}`]: {
                            borderStartStartRadius: 0,
                            borderEndStartRadius: 0
                        }
                    }
                },
                [componentCls]: {
                    position: "relative",
                    zIndex: 1,
                    "&:hover, &:focus, &:active": {
                        zIndex: 2
                    },
                    "&[disabled]": {
                        zIndex: 0
                    }
                },
                [`${componentCls}-icon-only`]: {
                    fontSize: fontSize
                }
            },
            // Border Color
            $0d0e8fa830a917ca$var$genButtonBorderStyle(`${componentCls}-primary`, groupBorderColor),
            $0d0e8fa830a917ca$var$genButtonBorderStyle(`${componentCls}-danger`, colorErrorHover)
        ]
    };
};
var $0d0e8fa830a917ca$export$2e2bcd8739ae039 = $0d0e8fa830a917ca$var$genGroupStyle;






var $cQmXV = parcelRequire("cQmXV");

const $9f6f44da566aebb9$export$8d6531175688484b = (value)=>Math.round(Number(value || 0));
const $9f6f44da566aebb9$var$convertHsb2Hsv = (color)=>{
    if (color instanceof (0, $3bb84f07fb2a2f32$export$2c4f38d6c0ecc25a)) return color;
    if (color && typeof color === "object" && "h" in color && "b" in color) {
        const { b: b, ...resets } = color;
        return {
            ...resets,
            v: b
        };
    }
    if (typeof color === "string" && /hsb/.test(color)) return color.replace(/hsb/, "hsv");
    return color;
};
class $9f6f44da566aebb9$export$892596cec99bc70e extends (0, $3bb84f07fb2a2f32$export$2c4f38d6c0ecc25a) {
    constructor(color){
        super($9f6f44da566aebb9$var$convertHsb2Hsv(color));
    }
    toHsbString() {
        const hsb = this.toHsb();
        const saturation = $9f6f44da566aebb9$export$8d6531175688484b(hsb.s * 100);
        const lightness = $9f6f44da566aebb9$export$8d6531175688484b(hsb.b * 100);
        const hue = $9f6f44da566aebb9$export$8d6531175688484b(hsb.h);
        const alpha = hsb.a;
        const hsbString = `hsb(${hue}, ${saturation}%, ${lightness}%)`;
        const hsbaString = `hsba(${hue}, ${saturation}%, ${lightness}%, ${alpha.toFixed(alpha === 0 ? 0 : 2)})`;
        return alpha === 1 ? hsbString : hsbaString;
    }
    toHsb() {
        const { v: v, ...resets } = this.toHsv();
        return {
            ...resets,
            b: v,
            a: this.a
        };
    }
}


const $01fb1ce707e13248$export$90004e2badfbdf1f = "rc-color-picker";
const $01fb1ce707e13248$export$c844f5d21427d1ab = (color)=>{
    if (color instanceof (0, $9f6f44da566aebb9$export$892596cec99bc70e)) return color;
    return new (0, $9f6f44da566aebb9$export$892596cec99bc70e)(color);
};
const $01fb1ce707e13248$export$f705f0fde43a55a = $01fb1ce707e13248$export$c844f5d21427d1ab("#1677ff");
const $01fb1ce707e13248$export$3a7095e9fd85a71d = (props)=>{
    const { offset: offset, targetRef: targetRef, containerRef: containerRef, color: color, type: type } = props;
    const { width: width, height: height } = containerRef.current.getBoundingClientRect();
    const { width: targetWidth, height: targetHeight } = targetRef.current.getBoundingClientRect();
    const centerOffsetX = targetWidth / 2;
    const centerOffsetY = targetHeight / 2;
    const saturation = (offset.x + centerOffsetX) / width;
    const bright = 1 - (offset.y + centerOffsetY) / height;
    const hsb = color.toHsb();
    const alphaOffset = saturation;
    const hueOffset = (offset.x + centerOffsetX) / width * 360;
    if (type) switch(type){
        case "hue":
            return $01fb1ce707e13248$export$c844f5d21427d1ab({
                ...hsb,
                h: hueOffset <= 0 ? 0 : hueOffset
            });
        case "alpha":
            return $01fb1ce707e13248$export$c844f5d21427d1ab({
                ...hsb,
                a: alphaOffset <= 0 ? 0 : alphaOffset
            });
    }
    return $01fb1ce707e13248$export$c844f5d21427d1ab({
        h: hsb.h,
        s: saturation <= 0 ? 0 : saturation,
        b: bright >= 1 ? 1 : bright,
        a: hsb.a
    });
};
const $01fb1ce707e13248$export$20165527867cbf14 = (color, type)=>{
    const hsb = color.toHsb();
    switch(type){
        case "hue":
            return {
                x: hsb.h / 360 * 100,
                y: 50
            };
        case "alpha":
            return {
                x: color.a * 100,
                y: 50
            };
        // Picker panel
        default:
            return {
                x: hsb.s * 100,
                y: (1 - hsb.b) * 100
            };
    }
};






var $cQmXV = parcelRequire("cQmXV");
const $c7ef50270498224a$var$ColorBlock = ({ color: color, prefixCls: prefixCls, className: className, style: style, innerClassName: innerClassName, innerStyle: innerStyle, onClick: onClick })=>{
    const colorBlockCls = `${prefixCls}-color-block`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(colorBlockCls, className),
        style: style,
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${colorBlockCls}-inner`, innerClassName),
        style: {
            background: color,
            ...innerStyle
        }
    }));
};
var $c7ef50270498224a$export$2e2bcd8739ae039 = $c7ef50270498224a$var$ColorBlock;



var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");
function $eee7a278f6c3c94e$var$getPosition(e) {
    const obj = "touches" in e ? e.touches[0] : e;
    const scrollXOffset = document.documentElement.scrollLeft || document.body.scrollLeft || window.pageXOffset;
    const scrollYOffset = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
    return {
        pageX: obj.pageX - scrollXOffset,
        pageY: obj.pageY - scrollYOffset
    };
}
function $eee7a278f6c3c94e$var$useColorDrag(props) {
    const { targetRef: targetRef, containerRef: containerRef, direction: direction, onDragChange: onDragChange, onDragChangeComplete: onDragChangeComplete, calculate: calculate, color: color, disabledDrag: disabledDrag } = props;
    const [offsetValue, setOffsetValue] = (0, $cQmXV.useState)({
        x: 0,
        y: 0
    });
    const mouseMoveRef = (0, $cQmXV.useRef)(null);
    const mouseUpRef = (0, $cQmXV.useRef)(null);
    // Always get position from `color`
    (0, $cQmXV.useEffect)(()=>{
        setOffsetValue(calculate());
    }, [
        color
    ]);
    (0, $cQmXV.useEffect)(()=>()=>{
            document.removeEventListener("mousemove", mouseMoveRef.current);
            document.removeEventListener("mouseup", mouseUpRef.current);
            document.removeEventListener("touchmove", mouseMoveRef.current);
            document.removeEventListener("touchend", mouseUpRef.current);
            mouseMoveRef.current = null;
            mouseUpRef.current = null;
        }, []);
    const updateOffset = (e)=>{
        const { pageX: pageX, pageY: pageY } = $eee7a278f6c3c94e$var$getPosition(e);
        const { x: rectX, y: rectY, width: width, height: height } = containerRef.current.getBoundingClientRect();
        const { width: targetWidth, height: targetHeight } = targetRef.current.getBoundingClientRect();
        const centerOffsetX = targetWidth / 2;
        const centerOffsetY = targetHeight / 2;
        const offsetX = Math.max(0, Math.min(pageX - rectX, width)) - centerOffsetX;
        const offsetY = Math.max(0, Math.min(pageY - rectY, height)) - centerOffsetY;
        const calcOffset = {
            x: offsetX,
            y: direction === "x" ? offsetValue.y : offsetY
        };
        // Exclusion of boundary cases
        if (targetWidth === 0 && targetHeight === 0 || targetWidth !== targetHeight) return false;
        onDragChange?.(calcOffset);
    };
    const onDragMove = (e)=>{
        e.preventDefault();
        updateOffset(e);
    };
    const onDragStop = (e)=>{
        e.preventDefault();
        document.removeEventListener("mousemove", mouseMoveRef.current);
        document.removeEventListener("mouseup", mouseUpRef.current);
        document.removeEventListener("touchmove", mouseMoveRef.current);
        document.removeEventListener("touchend", mouseUpRef.current);
        mouseMoveRef.current = null;
        mouseUpRef.current = null;
        onDragChangeComplete?.();
    };
    const onDragStart = (e)=>{
        // https://github.com/ant-design/ant-design/issues/43529
        document.removeEventListener("mousemove", mouseMoveRef.current);
        document.removeEventListener("mouseup", mouseUpRef.current);
        if (disabledDrag) return;
        updateOffset(e);
        document.addEventListener("mousemove", onDragMove);
        document.addEventListener("mouseup", onDragStop);
        document.addEventListener("touchmove", onDragMove);
        document.addEventListener("touchend", onDragStop);
        mouseMoveRef.current = onDragMove;
        mouseUpRef.current = onDragStop;
    };
    return [
        offsetValue,
        onDragStart
    ];
}
var $eee7a278f6c3c94e$export$2e2bcd8739ae039 = $eee7a278f6c3c94e$var$useColorDrag;






var $cQmXV = parcelRequire("cQmXV");
const $d2466ea5c8ae6786$var$Handler = ({ size: size = "default", color: color, prefixCls: prefixCls })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-handler`, {
            [`${prefixCls}-handler-sm`]: size === "small"
        }),
        style: {
            backgroundColor: color
        }
    });
};
var $d2466ea5c8ae6786$export$2e2bcd8739ae039 = $d2466ea5c8ae6786$var$Handler;



var $cQmXV = parcelRequire("cQmXV");
const $ee752dadd69416d0$var$Palette = ({ children: children, style: style, prefixCls: prefixCls })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
        className: `${prefixCls}-palette`,
        style: {
            position: "relative",
            ...style
        }
    }, children);
};
var $ee752dadd69416d0$export$2e2bcd8739ae039 = $ee752dadd69416d0$var$Palette;



var $cQmXV = parcelRequire("cQmXV");
const $e3c1f964b1eecadf$var$Transform = /*#__PURE__*/ (0, $cQmXV.forwardRef)((props, ref)=>{
    const { children: children, x: x, y: y } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
        ref: ref,
        style: {
            position: "absolute",
            left: `${x}%`,
            top: `${y}%`,
            zIndex: 1,
            transform: "translate(-50%, -50%)"
        }
    }, children);
});
var $e3c1f964b1eecadf$export$2e2bcd8739ae039 = $e3c1f964b1eecadf$var$Transform;


const $f49cc265b47764c4$var$Picker = ({ color: color, onChange: onChange, prefixCls: prefixCls, onChangeComplete: onChangeComplete, disabled: disabled })=>{
    const pickerRef = (0, $cQmXV.useRef)();
    const transformRef = (0, $cQmXV.useRef)();
    const colorRef = (0, $cQmXV.useRef)(color);
    const onDragChange = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((offsetValue)=>{
        const calcColor = (0, $01fb1ce707e13248$export$3a7095e9fd85a71d)({
            offset: offsetValue,
            targetRef: transformRef,
            containerRef: pickerRef,
            color: color
        });
        colorRef.current = calcColor;
        onChange(calcColor);
    });
    const [offset, dragStartHandle] = (0, $eee7a278f6c3c94e$export$2e2bcd8739ae039)({
        color: color,
        containerRef: pickerRef,
        targetRef: transformRef,
        calculate: ()=>(0, $01fb1ce707e13248$export$20165527867cbf14)(color),
        onDragChange: onDragChange,
        onDragChangeComplete: ()=>onChangeComplete?.(colorRef.current),
        disabledDrag: disabled
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
        ref: pickerRef,
        className: `${prefixCls}-select`,
        onMouseDown: dragStartHandle,
        onTouchStart: dragStartHandle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $ee752dadd69416d0$export$2e2bcd8739ae039), {
        prefixCls: prefixCls
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $e3c1f964b1eecadf$export$2e2bcd8739ae039), {
        x: offset.x,
        y: offset.y,
        ref: transformRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $d2466ea5c8ae6786$export$2e2bcd8739ae039), {
        color: color.toRgbString(),
        prefixCls: prefixCls
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
        className: `${prefixCls}-saturation`,
        style: {
            backgroundColor: `hsl(${color.toHsb().h},100%, 50%)`,
            backgroundImage: "linear-gradient(0deg, #000, transparent),linear-gradient(90deg, #fff, hsla(0, 0%, 100%, 0))"
        }
    })));
};
var $f49cc265b47764c4$export$2e2bcd8739ae039 = $f49cc265b47764c4$var$Picker;




var $cQmXV = parcelRequire("cQmXV");

const $153d6e39c2cb074e$var$useColorState = (defaultValue, value)=>{
    const [mergedValue, setValue] = (0, $a51866d781137e08$export$2e2bcd8739ae039)(defaultValue, value);
    const color = (0, $cQmXV.useMemo)(()=>(0, $01fb1ce707e13248$export$c844f5d21427d1ab)(mergedValue), [
        mergedValue
    ]);
    return [
        color,
        setValue
    ];
};
var $153d6e39c2cb074e$export$2e2bcd8739ae039 = $153d6e39c2cb074e$var$useColorState;



var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");







var $cQmXV = parcelRequire("cQmXV");


const $c236628582ad0cb8$var$Gradient = ({ colors: colors, children: children, direction: direction = "to right", type: type, prefixCls: prefixCls })=>{
    const gradientColors = (0, $cQmXV.useMemo)(()=>colors.map((color, idx)=>{
            let result = (0, $01fb1ce707e13248$export$c844f5d21427d1ab)(color);
            if (type === "alpha" && idx === colors.length - 1) result = new (0, $9f6f44da566aebb9$export$892596cec99bc70e)(result.setA(1));
            return result.toRgbString();
        }).join(","), [
        colors,
        type
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
        className: `${prefixCls}-gradient`,
        style: {
            position: "absolute",
            inset: 0,
            background: `linear-gradient(${direction}, ${gradientColors})`
        }
    }, children);
};
var $c236628582ad0cb8$export$2e2bcd8739ae039 = $c236628582ad0cb8$var$Gradient;




const $a5c989ee2c8a22f7$var$Slider = (props)=>{
    const { prefixCls: prefixCls, colors: colors, disabled: disabled, onChange: onChange, onChangeComplete: onChangeComplete, color: color, type: type } = props;
    const sliderRef = (0, $cQmXV.useRef)(null);
    const transformRef = (0, $cQmXV.useRef)(null);
    const colorRef = (0, $cQmXV.useRef)(color);
    const getValue = (c)=>{
        return type === "hue" ? c.getHue() : c.a * 100;
    };
    const onDragChange = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((offsetValue)=>{
        const calcColor = (0, $01fb1ce707e13248$export$3a7095e9fd85a71d)({
            offset: offsetValue,
            targetRef: transformRef,
            containerRef: sliderRef,
            color: color,
            type: type
        });
        colorRef.current = calcColor;
        onChange(getValue(calcColor));
    });
    const [offset, dragStartHandle] = (0, $eee7a278f6c3c94e$export$2e2bcd8739ae039)({
        color: color,
        targetRef: transformRef,
        containerRef: sliderRef,
        calculate: ()=>(0, $01fb1ce707e13248$export$20165527867cbf14)(color, type),
        onDragChange: onDragChange,
        onDragChangeComplete () {
            onChangeComplete(getValue(colorRef.current));
        },
        direction: "x",
        disabledDrag: disabled
    });
    const handleColor = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useMemo(()=>{
        if (type === "hue") {
            const hsb = color.toHsb();
            hsb.s = 1;
            hsb.b = 1;
            hsb.a = 1;
            const lightColor = new (0, $9f6f44da566aebb9$export$892596cec99bc70e)(hsb);
            return lightColor;
        }
        return color;
    }, [
        color,
        type
    ]);
    // ========================= Gradient =========================
    const gradientList = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useMemo(()=>colors.map((info)=>`${info.color} ${info.percent}%`), [
        colors
    ]);
    // ========================== Render ==========================
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
        ref: sliderRef,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-slider`, `${prefixCls}-slider-${type}`),
        onMouseDown: dragStartHandle,
        onTouchStart: dragStartHandle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $ee752dadd69416d0$export$2e2bcd8739ae039), {
        prefixCls: prefixCls
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $e3c1f964b1eecadf$export$2e2bcd8739ae039), {
        x: offset.x,
        y: offset.y,
        ref: transformRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $d2466ea5c8ae6786$export$2e2bcd8739ae039), {
        size: "small",
        color: handleColor.toHexString(),
        prefixCls: prefixCls
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $c236628582ad0cb8$export$2e2bcd8739ae039), {
        colors: gradientList,
        type: type,
        prefixCls: prefixCls
    })));
};
var $a5c989ee2c8a22f7$export$2e2bcd8739ae039 = $a5c989ee2c8a22f7$var$Slider;


function $439a07936a6a1562$export$2e2bcd8739ae039(components) {
    return $cQmXV.useMemo(()=>{
        const { slider: slider } = components || {};
        return [
            slider || (0, $a5c989ee2c8a22f7$export$2e2bcd8739ae039)
        ];
    }, [
        components
    ]);
}


function $0ed6631b93555dd6$var$_extends() {
    $0ed6631b93555dd6$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0ed6631b93555dd6$var$_extends.apply(this, arguments);
}
const $0ed6631b93555dd6$var$HUE_COLORS = [
    {
        color: "rgb(255, 0, 0)",
        percent: 0
    },
    {
        color: "rgb(255, 255, 0)",
        percent: 17
    },
    {
        color: "rgb(0, 255, 0)",
        percent: 33
    },
    {
        color: "rgb(0, 255, 255)",
        percent: 50
    },
    {
        color: "rgb(0, 0, 255)",
        percent: 67
    },
    {
        color: "rgb(255, 0, 255)",
        percent: 83
    },
    {
        color: "rgb(255, 0, 0)",
        percent: 100
    }
];
const $0ed6631b93555dd6$var$ColorPicker = /*#__PURE__*/ (0, $cQmXV.forwardRef)((props, ref)=>{
    const { value: value, defaultValue: defaultValue, prefixCls: prefixCls = (0, $01fb1ce707e13248$export$90004e2badfbdf1f), onChange: onChange, onChangeComplete: onChangeComplete, className: className, style: style, panelRender: panelRender, disabledAlpha: disabledAlpha = false, disabled: disabled = false, components: components } = props;
    // ========================== Components ==========================
    const [Slider] = (0, $439a07936a6a1562$export$2e2bcd8739ae039)(components);
    // ============================ Color =============================
    const [colorValue, setColorValue] = (0, $153d6e39c2cb074e$export$2e2bcd8739ae039)(defaultValue || (0, $01fb1ce707e13248$export$f705f0fde43a55a), value);
    const alphaColor = (0, $cQmXV.useMemo)(()=>colorValue.setA(1).toRgbString(), [
        colorValue
    ]);
    // ============================ Events ============================
    const handleChange = (data, type)=>{
        if (!value) setColorValue(data);
        onChange?.(data, type);
    };
    // Convert
    const getHueColor = (hue)=>new (0, $9f6f44da566aebb9$export$892596cec99bc70e)(colorValue.setHue(hue));
    const getAlphaColor = (alpha)=>new (0, $9f6f44da566aebb9$export$892596cec99bc70e)(colorValue.setA(alpha / 100));
    // Slider change
    const onHueChange = (hue)=>{
        handleChange(getHueColor(hue), {
            type: "hue",
            value: hue
        });
    };
    const onAlphaChange = (alpha)=>{
        handleChange(getAlphaColor(alpha), {
            type: "alpha",
            value: alpha
        });
    };
    // Complete
    const onHueChangeComplete = (hue)=>{
        if (onChangeComplete) onChangeComplete(getHueColor(hue));
    };
    const onAlphaChangeComplete = (alpha)=>{
        if (onChangeComplete) onChangeComplete(getAlphaColor(alpha));
    };
    // ============================ Render ============================
    const mergeCls = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-panel`, className, {
        [`${prefixCls}-panel-disabled`]: disabled
    });
    const sharedSliderProps = {
        prefixCls: prefixCls,
        disabled: disabled,
        color: colorValue
    };
    const defaultPanel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $f49cc265b47764c4$export$2e2bcd8739ae039), $0ed6631b93555dd6$var$_extends({
        onChange: handleChange
    }, sharedSliderProps, {
        onChangeComplete: onChangeComplete
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
        className: `${prefixCls}-slider-container`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-slider-group`, {
            [`${prefixCls}-slider-group-disabled-alpha`]: disabledAlpha
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement(Slider, $0ed6631b93555dd6$var$_extends({}, sharedSliderProps, {
        type: "hue",
        colors: $0ed6631b93555dd6$var$HUE_COLORS,
        min: 0,
        max: 359,
        value: colorValue.getHue(),
        onChange: onHueChange,
        onChangeComplete: onHueChangeComplete
    })), !disabledAlpha && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement(Slider, $0ed6631b93555dd6$var$_extends({}, sharedSliderProps, {
        type: "alpha",
        colors: [
            {
                percent: 0,
                color: "rgba(255, 0, 4, 0)"
            },
            {
                percent: 100,
                color: alphaColor
            }
        ],
        min: 0,
        max: 100,
        value: colorValue.a * 100,
        onChange: onAlphaChange,
        onChangeComplete: onAlphaChangeComplete
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $c7ef50270498224a$export$2e2bcd8739ae039), {
        color: colorValue.toRgbString(),
        prefixCls: prefixCls
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
        className: mergeCls,
        style: style,
        ref: ref
    }, typeof panelRender === "function" ? panelRender(defaultPanel) : defaultPanel);
});
var $0ed6631b93555dd6$export$2e2bcd8739ae039 = $0ed6631b93555dd6$var$ColorPicker;






var $ca882193e71b48e5$export$2e2bcd8739ae039 = (0, $0ed6631b93555dd6$export$2e2bcd8739ae039);


const $e572682ae9022769$export$d0aa8b5e56c9af06 = (value, alpha)=>value?.replace(/[^0-9a-f]/gi, "").slice(0, alpha ? 8 : 6) || "";
const $e572682ae9022769$export$6c90ef703dcfba25 = (value, alpha)=>value ? $e572682ae9022769$export$d0aa8b5e56c9af06(value, alpha) : "";
let $e572682ae9022769$export$e8cc8a2e87e145b4 = /*#__PURE__*/ function() {
    function AggregationColor(color) {
        (0, $07be749aeca07699$export$2e2bcd8739ae039)(this, AggregationColor);
        this.cleared = false;
        // Clone from another AggregationColor
        if (color instanceof AggregationColor) {
            this.metaColor = color.metaColor.clone();
            this.colors = color.colors?.map((info)=>({
                    color: new AggregationColor(info.color),
                    percent: info.percent
                }));
            this.cleared = color.cleared;
            return;
        }
        const isArray = Array.isArray(color);
        if (isArray && color.length) {
            this.colors = color.map(({ color: c, percent: percent })=>({
                    color: new AggregationColor(c),
                    percent: percent
                }));
            this.metaColor = new (0, $9f6f44da566aebb9$export$892596cec99bc70e)(this.colors[0].color.metaColor);
        } else this.metaColor = new (0, $9f6f44da566aebb9$export$892596cec99bc70e)(isArray ? "" : color);
        if (!color || isArray && !this.colors) {
            this.metaColor = this.metaColor.setA(0);
            this.cleared = true;
        }
    }
    return (0, $c180160353ceabc3$export$2e2bcd8739ae039)(AggregationColor, [
        {
            key: "toHsb",
            value: function toHsb() {
                return this.metaColor.toHsb();
            }
        },
        {
            key: "toHsbString",
            value: function toHsbString() {
                return this.metaColor.toHsbString();
            }
        },
        {
            key: "toHex",
            value: function toHex() {
                return $e572682ae9022769$export$6c90ef703dcfba25(this.toHexString(), this.metaColor.a < 1);
            }
        },
        {
            key: "toHexString",
            value: function toHexString() {
                return this.metaColor.toHexString();
            }
        },
        {
            key: "toRgb",
            value: function toRgb() {
                return this.metaColor.toRgb();
            }
        },
        {
            key: "toRgbString",
            value: function toRgbString() {
                return this.metaColor.toRgbString();
            }
        },
        {
            key: "isGradient",
            value: function isGradient() {
                return !!this.colors && !this.cleared;
            }
        },
        {
            key: "getColors",
            value: function getColors() {
                return this.colors || [
                    {
                        color: this,
                        percent: 0
                    }
                ];
            }
        },
        {
            key: "toCssString",
            value: function toCssString() {
                const { colors: colors } = this;
                // CSS line-gradient
                if (colors) {
                    const colorsStr = colors.map((c)=>`${c.color.toRgbString()} ${c.percent}%`).join(", ");
                    return `linear-gradient(90deg, ${colorsStr})`;
                }
                return this.metaColor.toRgbString();
            }
        },
        {
            key: "equals",
            value: function equals(color) {
                if (!color || this.isGradient() !== color.isGradient()) return false;
                if (!this.isGradient()) return this.toHexString() === color.toHexString();
                return this.colors.length === color.colors.length && this.colors.every((c, i)=>{
                    const target = color.colors[i];
                    return c.percent === target.percent && c.color.equals(target.color);
                });
            }
        }
    ]);
}();



var $cQmXV = parcelRequire("cQmXV");



var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");
var $644dd371dd78b225$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($644dd371dd78b225$exports, "__esModule", {
    value: true
});
var $644dd371dd78b225$var$RightOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z"
                }
            }
        ]
    },
    "name": "right",
    "theme": "outlined"
};
$644dd371dd78b225$exports.default = $644dd371dd78b225$var$RightOutlined;



function $89db7229a7e10f8f$var$_extends() {
    $89db7229a7e10f8f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $89db7229a7e10f8f$var$_extends.apply(this, arguments);
}
const $89db7229a7e10f8f$var$RightOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $89db7229a7e10f8f$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($644dd371dd78b225$exports)))
    }));
/**![right](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTc2NS43IDQ4Ni44TDMxNC45IDEzNC43QTcuOTcgNy45NyAwIDAwMzAyIDE0MXY3Ny4zYzAgNC45IDIuMyA5LjYgNi4xIDEyLjZsMzYwIDI4MS4xLTM2MCAyODEuMWMtMy45IDMtNi4xIDcuNy02LjEgMTIuNlY4ODNjMCA2LjcgNy43IDEwLjQgMTIuOSA2LjNsNDUwLjgtMzUyLjFhMzEuOTYgMzEuOTYgMCAwMDAtNTAuNHoiIC8+PC9zdmc+) */ const $89db7229a7e10f8f$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($89db7229a7e10f8f$var$RightOutlined);
var $89db7229a7e10f8f$export$2e2bcd8739ae039 = $89db7229a7e10f8f$var$RefIcon;


function $e69a41570260c349$export$2e2bcd8739ae039() {
    return $e69a41570260c349$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $e69a41570260c349$export$2e2bcd8739ae039.apply(null, arguments);
}






var $cQmXV = parcelRequire("cQmXV");



var $cQmXV = parcelRequire("cQmXV");





var $cQmXV = parcelRequire("cQmXV");


var $cQmXV = parcelRequire("cQmXV");
const $39dcb2196f043bef$var$PanelContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).forwardRef((props, ref)=>{
    const { prefixCls: prefixCls, forceRender: forceRender, className: className, style: style, children: children, isActive: isActive, role: role, classNames: customizeClassNames, styles: styles } = props;
    const [rendered, setRendered] = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useState(isActive || forceRender);
    (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useEffect(()=>{
        if (forceRender || isActive) setRendered(true);
    }, [
        forceRender,
        isActive
    ]);
    if (!rendered) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
        ref: ref,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-panel`, {
            [`${prefixCls}-panel-active`]: isActive,
            [`${prefixCls}-panel-inactive`]: !isActive
        }, className),
        style: style,
        role: role
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-body`, customizeClassNames?.body),
        style: styles?.body
    }, children));
});
var $39dcb2196f043bef$export$2e2bcd8739ae039 = $39dcb2196f043bef$var$PanelContent;


const $01a2e420eb669bd1$var$CollapsePanel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).forwardRef((props, ref)=>{
    const { showArrow: showArrow = true, headerClass: headerClass, isActive: isActive, onItemClick: onItemClick, forceRender: forceRender, className: className, classNames: customizeClassNames = {}, styles: styles = {}, prefixCls: prefixCls, collapsible: collapsible, accordion: accordion, panelKey: panelKey, extra: extra, header: header, expandIcon: expandIcon, openMotion: openMotion, destroyOnHidden: destroyOnHidden, children: children, ...resetProps } = props;
    const disabled = collapsible === "disabled";
    const ifExtraExist = extra !== null && extra !== undefined && typeof extra !== "boolean";
    const collapsibleProps = {
        onClick: ()=>{
            onItemClick?.(panelKey);
        },
        onKeyDown: (e)=>{
            if (e.key === "Enter" || e.keyCode === (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).ENTER || e.which === (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).ENTER) onItemClick?.(panelKey);
        },
        role: accordion ? "tab" : "button",
        ["aria-expanded"]: isActive,
        ["aria-disabled"]: disabled,
        tabIndex: disabled ? -1 : 0
    };
    // ======================== Icon ========================
    const iconNodeInner = typeof expandIcon === "function" ? expandIcon(props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("i", {
        className: "arrow"
    });
    const iconNode = iconNodeInner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", (0, $e69a41570260c349$export$2e2bcd8739ae039)({
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-expand-icon`, customizeClassNames?.icon),
        style: styles?.icon
    }, [
        "header",
        "icon"
    ].includes(collapsible) ? collapsibleProps : {}), iconNodeInner);
    const collapsePanelClassNames = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-item`, {
        [`${prefixCls}-item-active`]: isActive,
        [`${prefixCls}-item-disabled`]: disabled
    }, className);
    const headerClassName = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(headerClass, `${prefixCls}-header`, {
        [`${prefixCls}-collapsible-${collapsible}`]: !!collapsible
    }, customizeClassNames?.header);
    // ======================== HeaderProps ========================
    const headerProps = {
        className: headerClassName,
        style: styles?.header,
        ...[
            "header",
            "icon"
        ].includes(collapsible) ? {} : collapsibleProps
    };
    // ======================== Render ========================
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", (0, $e69a41570260c349$export$2e2bcd8739ae039)({}, resetProps, {
        ref: ref,
        className: collapsePanelClassNames
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", headerProps, showArrow && iconNode, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("span", (0, $e69a41570260c349$export$2e2bcd8739ae039)({
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-title`, customizeClassNames?.title),
        style: styles?.title
    }, collapsible === "header" ? collapsibleProps : {}), header), ifExtraExist && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
        className: `${prefixCls}-extra`
    }, extra)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $04c53b89814950f8$export$2e2bcd8739ae039), (0, $e69a41570260c349$export$2e2bcd8739ae039)({
        visible: isActive,
        leavedClassName: `${prefixCls}-panel-hidden`
    }, openMotion, {
        forceRender: forceRender,
        removeOnLeave: destroyOnHidden
    }), ({ className: motionClassName, style: motionStyle }, motionRef)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $39dcb2196f043bef$export$2e2bcd8739ae039), {
            ref: motionRef,
            prefixCls: prefixCls,
            className: motionClassName,
            classNames: customizeClassNames,
            style: motionStyle,
            styles: styles,
            isActive: isActive,
            forceRender: forceRender,
            role: accordion ? "tabpanel" : undefined
        }, children);
    }));
});
var $01a2e420eb669bd1$export$2e2bcd8739ae039 = $01a2e420eb669bd1$var$CollapsePanel;



function $a2fda9b6aed41c8e$var$mergeSemantic(src, tgt, mergeFn) {
    if (!src || !tgt) return src || tgt;
    const keys = Array.from(new Set([
        ...Object.keys(src),
        ...Object.keys(tgt)
    ]));
    const result = {};
    keys.forEach((key)=>{
        result[key] = mergeFn(src[key], tgt[key]);
    });
    return result;
}
function $a2fda9b6aed41c8e$var$mergeSemanticClassNames(src, tgt) {
    return $a2fda9b6aed41c8e$var$mergeSemantic(src, tgt, (a, b)=>(0, $772fd6e40f1fbf40$export$2e2bcd8739ae039)(a, b));
}
function $a2fda9b6aed41c8e$var$mergeSemanticStyles(src, tgt) {
    return $a2fda9b6aed41c8e$var$mergeSemantic(src, tgt, (a, b)=>({
            ...a,
            ...b
        }));
}
const $a2fda9b6aed41c8e$var$convertItemsToNodes = (items, props)=>{
    const { prefixCls: prefixCls, accordion: accordion, collapsible: collapsible, destroyOnHidden: destroyOnHidden, onItemClick: onItemClick, activeKey: activeKey, openMotion: openMotion, expandIcon: expandIcon, classNames: collapseClassNames, styles: collapseStyles } = props;
    return items.map((item, index)=>{
        const { children: children, label: label, key: rawKey, collapsible: rawCollapsible, onItemClick: rawOnItemClick, destroyOnHidden: rawDestroyOnHidden, classNames: classNames, styles: styles, ...restProps } = item;
        // You may be puzzled why you want to convert them all into strings, me too.
        // Maybe: https://github.com/react-component/collapse/blob/aac303a8b6ff30e35060b4f8fecde6f4556fcbe2/src/Collapse.tsx#L15
        const key = String(rawKey ?? index);
        const mergeCollapsible = rawCollapsible ?? collapsible;
        const mergedDestroyOnHidden = rawDestroyOnHidden ?? destroyOnHidden;
        const handleItemClick = (value)=>{
            if (mergeCollapsible === "disabled") return;
            onItemClick(value);
            rawOnItemClick?.(value);
        };
        let isActive = false;
        if (accordion) isActive = activeKey[0] === key;
        else isActive = activeKey.indexOf(key) > -1;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $01a2e420eb669bd1$export$2e2bcd8739ae039), (0, $e69a41570260c349$export$2e2bcd8739ae039)({}, restProps, {
            classNames: $a2fda9b6aed41c8e$var$mergeSemanticClassNames(collapseClassNames, classNames),
            styles: $a2fda9b6aed41c8e$var$mergeSemanticStyles(collapseStyles, styles),
            prefixCls: prefixCls,
            key: key,
            panelKey: key,
            isActive: isActive,
            accordion: accordion,
            openMotion: openMotion,
            expandIcon: expandIcon,
            header: label,
            collapsible: mergeCollapsible,
            onItemClick: handleItemClick,
            destroyOnHidden: mergedDestroyOnHidden
        }), children);
    });
};
/**
 * @deprecated The next major version will be removed
 */ const $a2fda9b6aed41c8e$var$getNewChild = (child, index, props)=>{
    if (!child) return null;
    const { prefixCls: prefixCls, accordion: accordion, collapsible: collapsible, destroyOnHidden: destroyOnHidden, onItemClick: onItemClick, activeKey: activeKey, openMotion: openMotion, expandIcon: expandIcon, classNames: collapseClassNames, styles: styles } = props;
    const key = child.key || String(index);
    const { header: header, headerClass: headerClass, destroyOnHidden: childDestroyOnHidden, collapsible: childCollapsible, onItemClick: childOnItemClick } = child.props;
    let isActive = false;
    if (accordion) isActive = activeKey[0] === key;
    else isActive = activeKey.indexOf(key) > -1;
    const mergeCollapsible = childCollapsible ?? collapsible;
    const handleItemClick = (value)=>{
        if (mergeCollapsible === "disabled") return;
        onItemClick(value);
        childOnItemClick?.(value);
    };
    const childProps = {
        key: key,
        panelKey: key,
        header: header,
        headerClass: headerClass,
        classNames: collapseClassNames,
        styles: styles,
        isActive: isActive,
        prefixCls: prefixCls,
        destroyOnHidden: childDestroyOnHidden ?? destroyOnHidden,
        openMotion: openMotion,
        accordion: accordion,
        children: child.props.children,
        onItemClick: handleItemClick,
        expandIcon: expandIcon,
        collapsible: mergeCollapsible
    };
    // https://github.com/ant-design/ant-design/issues/20479
    if (typeof child.type === "string") return child;
    Object.keys(childProps).forEach((propName)=>{
        if (typeof childProps[propName] === "undefined") delete childProps[propName];
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).cloneElement(child, childProps);
};
function $a2fda9b6aed41c8e$var$useItems(items, rawChildren, props) {
    if (Array.isArray(items)) return $a2fda9b6aed41c8e$var$convertItemsToNodes(items, props);
    return (0, $cd966a313e0a92ff$export$2e2bcd8739ae039)(rawChildren).map((child, index)=>$a2fda9b6aed41c8e$var$getNewChild(child, index, props));
}
var $a2fda9b6aed41c8e$export$2e2bcd8739ae039 = $a2fda9b6aed41c8e$var$useItems;




function $f3a294c6d0efd9df$var$getActiveKeysArray(activeKey) {
    let currentActiveKey = activeKey;
    if (!Array.isArray(currentActiveKey)) {
        const activeKeyType = typeof currentActiveKey;
        currentActiveKey = activeKeyType === "number" || activeKeyType === "string" ? [
            currentActiveKey
        ] : [];
    }
    return currentActiveKey.map((key)=>String(key));
}
const $f3a294c6d0efd9df$var$Collapse = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).forwardRef((props, ref)=>{
    const { prefixCls: prefixCls = "rc-collapse", destroyOnHidden: destroyOnHidden = false, style: style, accordion: accordion, className: className, children: children, collapsible: collapsible, openMotion: openMotion, expandIcon: expandIcon, activeKey: rawActiveKey, defaultActiveKey: defaultActiveKey, onChange: onChange, items: items, classNames: customizeClassNames, styles: styles } = props;
    const collapseClassName = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, className);
    const [internalActiveKey, setActiveKey] = (0, $a51866d781137e08$export$2e2bcd8739ae039)(defaultActiveKey, rawActiveKey);
    const activeKey = $f3a294c6d0efd9df$var$getActiveKeysArray(internalActiveKey);
    const triggerActiveKey = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((next)=>{
        const nextKeys = $f3a294c6d0efd9df$var$getActiveKeysArray(next);
        setActiveKey(nextKeys);
        onChange?.(nextKeys);
    });
    const onItemClick = (key)=>{
        if (accordion) triggerActiveKey(activeKey[0] === key ? [] : [
            key
        ]);
        else triggerActiveKey(activeKey.includes(key) ? activeKey.filter((item)=>item !== key) : [
            ...activeKey,
            key
        ]);
    };
    // ======================== Children ========================
    (0, $26d7cf6379fe7659$export$2e2bcd8739ae039)(!children, "[rc-collapse] `children` will be removed in next major version. Please use `items` instead.");
    const mergedChildren = (0, $a2fda9b6aed41c8e$export$2e2bcd8739ae039)(items, children, {
        prefixCls: prefixCls,
        accordion: accordion,
        openMotion: openMotion,
        expandIcon: expandIcon,
        collapsible: collapsible,
        destroyOnHidden: destroyOnHidden,
        onItemClick: onItemClick,
        activeKey: activeKey,
        classNames: customizeClassNames,
        styles: styles
    });
    // ======================== Render ========================
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", (0, $e69a41570260c349$export$2e2bcd8739ae039)({
        ref: ref,
        className: collapseClassName,
        style: style,
        role: accordion ? "tablist" : undefined
    }, (0, $4b5c733d1d7bb306$export$2e2bcd8739ae039)(props, {
        aria: true,
        data: true
    })), mergedChildren);
});
var $f3a294c6d0efd9df$export$2e2bcd8739ae039 = Object.assign($f3a294c6d0efd9df$var$Collapse, {
    /**
   * @deprecated use `items` instead, will be removed in `v4.0.0`
   */ Panel: (0, $01a2e420eb669bd1$export$2e2bcd8739ae039)
});


var $ed13545ef29ab953$export$2e2bcd8739ae039 = (0, $f3a294c6d0efd9df$export$2e2bcd8739ae039);
const { Panel: $ed13545ef29ab953$export$2ddb90ad54e5f587 } = (0, $f3a294c6d0efd9df$export$2e2bcd8739ae039);








// ================== Collapse Motion ==================
const $047a5f051ebda8ba$var$getCollapsedHeight = ()=>({
        height: 0,
        opacity: 0
    });
const $047a5f051ebda8ba$var$getRealHeight = (node)=>({
        height: node?.scrollHeight ?? 0,
        opacity: node ? 1 : 0
    });
const $047a5f051ebda8ba$var$getCurrentHeight = (node)=>({
        height: node?.offsetHeight ?? 0
    });
const $047a5f051ebda8ba$var$skipOpacityTransition = (_, event)=>{
    return event?.deadline === true || (0, $8e2d153a3c855782$export$9e6f93c2a213a96b)(event) && event.propertyName === "height";
};
const $047a5f051ebda8ba$var$initCollapseMotion = (rootCls = (0, $82ffd17441b57982$export$e4ec87ea71f29b41))=>({
        motionName: `${rootCls}-motion-collapse`,
        onAppearStart: $047a5f051ebda8ba$var$getCollapsedHeight,
        onEnterStart: $047a5f051ebda8ba$var$getCollapsedHeight,
        onAppearActive: $047a5f051ebda8ba$var$getRealHeight,
        onEnterActive: $047a5f051ebda8ba$var$getRealHeight,
        onLeaveStart: $047a5f051ebda8ba$var$getCurrentHeight,
        onLeaveActive: $047a5f051ebda8ba$var$getCollapsedHeight,
        onAppearEnd: $047a5f051ebda8ba$var$skipOpacityTransition,
        onEnterEnd: $047a5f051ebda8ba$var$skipOpacityTransition,
        onLeaveEnd: $047a5f051ebda8ba$var$skipOpacityTransition,
        motionDeadline: 500
    });
const $047a5f051ebda8ba$var$_SelectPlacements = [
    "bottomLeft",
    "bottomRight",
    "topLeft",
    "topRight"
];
const $047a5f051ebda8ba$export$27c72201b1d09951 = (rootPrefixCls, motion, transitionName)=>{
    if (transitionName !== undefined) return transitionName;
    return `${rootPrefixCls}-${motion}`;
};
var $047a5f051ebda8ba$export$2e2bcd8739ae039 = $047a5f051ebda8ba$var$initCollapseMotion;







var $cQmXV = parcelRequire("cQmXV");




"use client";
const $83564532b2eca71b$var$CollapsePanel = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { getPrefixCls: getPrefixCls } = $cQmXV.useContext((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    const { prefixCls: customizePrefixCls, className: className, showArrow: showArrow = true } = props;
    const prefixCls = getPrefixCls("collapse", customizePrefixCls);
    const collapsePanelClassName = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)({
        [`${prefixCls}-no-arrow`]: !showArrow
    }, className);
    return /*#__PURE__*/ $cQmXV.createElement((0, $ed13545ef29ab953$export$2e2bcd8739ae039).Panel, {
        ref: ref,
        ...props,
        prefixCls: prefixCls,
        className: collapsePanelClassName
    });
});
var $83564532b2eca71b$export$2e2bcd8739ae039 = $83564532b2eca71b$var$CollapsePanel;




const $3576e621578e370a$var$genCollapseMotion = (token)=>{
    const { componentCls: componentCls, antCls: antCls, motionDurationMid: motionDurationMid, motionEaseInOut: motionEaseInOut } = token;
    return {
        [componentCls]: {
            // For common/openAnimation
            [`${antCls}-motion-collapse-legacy`]: {
                overflow: "hidden",
                "&-active": {
                    transition: `${[
                        "height",
                        "opacity"
                    ].map((prop)=>`${prop} ${motionDurationMid} ${motionEaseInOut}`).join(", ")} !important`
                }
            },
            [`${antCls}-motion-collapse`]: {
                overflow: "hidden",
                transition: `${[
                    "height",
                    "opacity"
                ].map((prop)=>`${prop} ${motionDurationMid} ${motionEaseInOut}`).join(", ")} !important`
            }
        }
    };
};
var $3576e621578e370a$export$2e2bcd8739ae039 = $3576e621578e370a$var$genCollapseMotion;



const $094a92698eab8fac$export$5ca74f7be820a85 = (token)=>{
    const { componentCls: componentCls, contentBg: contentBg, padding: padding, headerBg: headerBg, headerPadding: headerPadding, headerPaddingSM: headerPaddingSM, headerPaddingLG: headerPaddingLG, collapsePanelBorderRadius: collapsePanelBorderRadius, lineWidth: lineWidth, lineType: lineType, colorBorder: colorBorder, colorText: colorText, colorTextHeading: colorTextHeading, colorTextDisabled: colorTextDisabled, fontSizeLG: fontSizeLG, lineHeight: lineHeight, lineHeightLG: lineHeightLG, marginSM: marginSM, paddingSM: paddingSM, paddingLG: paddingLG, paddingXS: paddingXS, motionDurationSlow: motionDurationSlow, fontSizeIcon: fontSizeIcon, contentPadding: contentPadding, contentPaddingSM: contentPaddingSM, contentPaddingLG: contentPaddingLG, fontHeight: fontHeight, fontHeightLG: fontHeightLG } = token;
    const borderBase = `${(0, $05f34ed03d41967d$export$523c0b569236b342)(lineWidth)} ${lineType} ${colorBorder}`;
    return {
        [componentCls]: {
            ...(0, $519d20bf207ce864$export$23997c3e44cc1c59)(token),
            backgroundColor: headerBg,
            border: borderBase,
            borderRadius: collapsePanelBorderRadius,
            "&-rtl": {
                direction: "rtl"
            },
            [`& > ${componentCls}-item`]: {
                borderBottom: borderBase,
                "&:first-child": {
                    [`
            &,
            & > ${componentCls}-header`]: {
                        borderRadius: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(collapsePanelBorderRadius)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(collapsePanelBorderRadius)} 0 0`
                    }
                },
                "&:last-child": {
                    [`
            &,
            & > ${componentCls}-header`]: {
                        borderRadius: `0 0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(collapsePanelBorderRadius)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(collapsePanelBorderRadius)}`
                    }
                },
                [`> ${componentCls}-header`]: {
                    position: "relative",
                    // Compatible with old version of antd, should remove in next version
                    display: "flex",
                    flexWrap: "nowrap",
                    alignItems: "flex-start",
                    padding: headerPadding,
                    color: colorTextHeading,
                    lineHeight: lineHeight,
                    cursor: "pointer",
                    transition: `all ${motionDurationSlow}, visibility 0s`,
                    ...(0, $519d20bf207ce864$export$a44db842bcb28231)(token),
                    [`> ${componentCls}-title`]: {
                        flex: "auto"
                    },
                    // >>>>> Arrow
                    [`${componentCls}-expand-icon`]: {
                        height: fontHeight,
                        display: "flex",
                        alignItems: "center",
                        marginInlineEnd: marginSM
                    },
                    [`${componentCls}-arrow`]: {
                        ...(0, $519d20bf207ce864$export$171ccda7bc085e59)(),
                        fontSize: fontSizeIcon,
                        // when `transform: rotate()` is applied to icon's root element
                        transition: `transform ${motionDurationSlow}`,
                        // when `transform: rotate()` is applied to icon's child element
                        svg: {
                            transition: `transform ${motionDurationSlow}`
                        }
                    },
                    // >>>>> Text
                    [`${componentCls}-title`]: {
                        marginInlineEnd: "auto",
                        // Icons from third-party libraries render as a bare `<svg>`, which the `.anticon`
                        // reset never reaches. An `<svg>` has no baseline of its own, so it is aligned by its
                        // bottom margin edge (CSS 2.1 §10.8.1) and rides above the title text.
                        // `display: inline-block` keeps it an atomic inline box so `vertical-align` still applies
                        // even under a CSS reset that forces `svg { display: block }` (e.g. Tailwind Preflight),
                        // which would otherwise drop the icon onto its own line. `vertical-align: middle` centres
                        // its margin box on the x-height line; `margin-block-end` then lifts it by half its own
                        // value onto the cap-height centre (capHeight − xHeight ≈ 0.2em across typical fonts),
                        // keeping it centred at any icon size.
                        // Only matches a bare `<svg>`: an `.anticon` keeps its `<svg>` one level deeper.
                        "> svg": {
                            display: "inline-block",
                            verticalAlign: "middle",
                            marginBlockEnd: "0.2em"
                        }
                    }
                },
                [`${componentCls}-collapsible-header`]: {
                    cursor: "default",
                    [`${componentCls}-title`]: {
                        flex: "none",
                        cursor: "pointer"
                    },
                    [`${componentCls}-expand-icon`]: {
                        cursor: "pointer"
                    }
                },
                [`${componentCls}-collapsible-icon`]: {
                    cursor: "unset",
                    [`${componentCls}-expand-icon`]: {
                        cursor: "pointer"
                    }
                }
            },
            [`${componentCls}-panel`]: {
                color: colorText,
                backgroundColor: contentBg,
                borderTop: borderBase,
                [`& > ${componentCls}-body`]: {
                    padding: contentPadding
                },
                "&-hidden": {
                    display: "none"
                }
            },
            "&-small": {
                [`> ${componentCls}-item`]: {
                    [`> ${componentCls}-header`]: {
                        padding: headerPaddingSM,
                        [`> ${componentCls}-expand-icon`]: {
                            // Arrow offset
                            marginInlineStart: token.calc(paddingSM).sub(paddingXS).equal()
                        }
                    },
                    [`> ${componentCls}-panel > ${componentCls}-body`]: {
                        padding: contentPaddingSM
                    }
                }
            },
            "&-large": {
                [`> ${componentCls}-item`]: {
                    fontSize: fontSizeLG,
                    lineHeight: lineHeightLG,
                    [`> ${componentCls}-header`]: {
                        padding: headerPaddingLG,
                        [`> ${componentCls}-expand-icon`]: {
                            height: fontHeightLG,
                            // Arrow offset
                            marginInlineStart: token.calc(paddingLG).sub(padding).equal()
                        }
                    },
                    [`> ${componentCls}-panel > ${componentCls}-body`]: {
                        padding: contentPaddingLG
                    }
                }
            },
            [`${componentCls}-item:last-child`]: {
                borderBottom: 0,
                [`> ${componentCls}-panel`]: {
                    borderRadius: `0 0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(collapsePanelBorderRadius)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(collapsePanelBorderRadius)}`
                }
            },
            [`& ${componentCls}-item-disabled > ${componentCls}-header`]: {
                "&, & > .arrow": {
                    color: colorTextDisabled,
                    cursor: "not-allowed"
                }
            },
            // ========================== Icon Placement ==========================
            [`&${componentCls}-icon-placement-end`]: {
                [`& > ${componentCls}-item`]: {
                    [`> ${componentCls}-header`]: {
                        [`${componentCls}-expand-icon`]: {
                            order: 1,
                            marginInlineEnd: 0,
                            marginInlineStart: marginSM
                        }
                    }
                }
            }
        }
    };
};
const $094a92698eab8fac$var$genArrowStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const fixedSelector = `> ${componentCls}-item > ${componentCls}-header ${componentCls}-arrow`;
    return {
        [`${componentCls}-rtl`]: {
            [fixedSelector]: {
                transform: `rotate(180deg)`
            }
        }
    };
};
const $094a92698eab8fac$var$genBorderlessStyle = (token)=>{
    const { componentCls: componentCls, headerBg: headerBg, borderlessContentPadding: borderlessContentPadding, borderlessContentBg: borderlessContentBg, colorBorder: colorBorder } = token;
    return {
        [`${componentCls}-borderless`]: {
            backgroundColor: headerBg,
            border: 0,
            [`> ${componentCls}-item`]: {
                borderBottom: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${colorBorder}`
            },
            [`
        > ${componentCls}-item:last-child,
        > ${componentCls}-item:last-child ${componentCls}-header
      `]: {
                borderRadius: 0
            },
            [`> ${componentCls}-item:last-child`]: {
                borderBottom: 0
            },
            [`> ${componentCls}-item > ${componentCls}-panel`]: {
                backgroundColor: borderlessContentBg,
                borderTop: 0
            },
            [`> ${componentCls}-item > ${componentCls}-panel > ${componentCls}-body`]: {
                padding: borderlessContentPadding
            }
        }
    };
};
const $094a92698eab8fac$var$genGhostStyle = (token)=>{
    const { componentCls: componentCls, paddingSM: paddingSM } = token;
    return {
        [`${componentCls}-ghost`]: {
            backgroundColor: "transparent",
            border: 0,
            [`> ${componentCls}-item`]: {
                borderBottom: 0,
                [`> ${componentCls}-panel`]: {
                    backgroundColor: "transparent",
                    border: 0,
                    [`> ${componentCls}-body`]: {
                        paddingBlock: paddingSM
                    }
                }
            }
        }
    };
};
const $094a92698eab8fac$export$9ca1be8807fe0675 = (token)=>{
    const componentToken = {
        headerPadding: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.paddingSM)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.padding)}`,
        headerPaddingSM: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.paddingXS)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.paddingSM)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.paddingXS)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.paddingXS)}`,
        headerPaddingLG: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.padding)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.paddingLG)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.padding)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.padding)}`,
        headerBg: token.colorFillAlter,
        contentPadding: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.padding)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(16)}`,
        // Fixed Value
        contentPaddingSM: token.paddingSM,
        contentPaddingLG: token.paddingLG,
        contentBg: token.colorBgContainer,
        borderlessContentPadding: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.paddingXXS)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(16)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.padding)}`,
        borderlessContentBg: "transparent"
    };
    return componentToken;
};
var $094a92698eab8fac$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$51ec95de45185b42)("Collapse", (token)=>{
    const collapseToken = (0, $fef50f256b80dfa5$export$4950aa0f605343fb)(token, {
        collapsePanelBorderRadius: token.borderRadiusLG
    });
    return [
        $094a92698eab8fac$export$5ca74f7be820a85(collapseToken),
        $094a92698eab8fac$var$genBorderlessStyle(collapseToken),
        $094a92698eab8fac$var$genGhostStyle(collapseToken),
        $094a92698eab8fac$var$genArrowStyle(collapseToken),
        (0, $3576e621578e370a$export$2e2bcd8739ae039)(collapseToken)
    ];
}, $094a92698eab8fac$export$9ca1be8807fe0675);


"use client";
const $6d2d6c84d16712cb$var$Collapse = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { getPrefixCls: getPrefixCls, direction: direction, expandIcon: contextExpandIcon, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("collapse");
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, style: style, bordered: bordered = true, ghost: ghost, size: customizeSize, expandIconPlacement: expandIconPlacement, expandIconPosition: expandIconPosition, children: children, destroyInactivePanel: destroyInactivePanel, destroyOnHidden: destroyOnHidden, expandIcon: expandIcon, classNames: classNames, styles: styles } = props;
    const mergedSize = (0, $78cdfb6138721329$export$2e2bcd8739ae039)((ctx)=>customizeSize ?? ctx ?? "middle");
    const prefixCls = getPrefixCls("collapse", customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    const [hashId, cssVarCls] = (0, $094a92698eab8fac$export$2e2bcd8739ae039)(prefixCls);
    const mergedPlacement = expandIconPlacement ?? expandIconPosition ?? "start";
    // =========== Merged Props for Semantic ===========
    const mergedProps = {
        ...props,
        size: mergedSize,
        bordered: bordered,
        expandIconPlacement: mergedPlacement
    };
    const contextStyleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $30c5f9f911d4f61b$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: mergedProps
    });
    const mergedExpandIcon = expandIcon ?? contextExpandIcon;
    var deprecatedName, newName;
    const renderExpandIcon = $cQmXV.useCallback((panelProps = {})=>{
        const icon = (0, $8e2d153a3c855782$export$f6e2535fb5126e54)(mergedExpandIcon) ? mergedExpandIcon(panelProps) : /*#__PURE__*/ $cQmXV.createElement((0, $89db7229a7e10f8f$export$2e2bcd8739ae039), {
            rotate: panelProps.isActive ? direction === "rtl" ? -90 : 90 : undefined,
            "aria-label": panelProps.isActive ? "expanded" : "collapsed"
        });
        return (0, $a91ef204d03d8eec$export$e530037191fcd5d7)(icon, (oriProps)=>({
                className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(oriProps.className, `${prefixCls}-arrow`)
            }));
    }, [
        mergedExpandIcon,
        prefixCls,
        direction
    ]);
    const collapseClassName = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-icon-placement-${mergedPlacement}`, {
        [`${prefixCls}-borderless`]: !bordered,
        [`${prefixCls}-rtl`]: direction === "rtl",
        [`${prefixCls}-ghost`]: !!ghost,
        [`${prefixCls}-large`]: mergedSize === "large",
        [`${prefixCls}-small`]: mergedSize === "small"
    }, contextClassName, className, rootClassName, hashId, cssVarCls, mergedClassNames.root);
    const openMotion = $cQmXV.useMemo(()=>({
            ...(0, $047a5f051ebda8ba$export$2e2bcd8739ae039)(rootPrefixCls),
            motionAppear: false,
            leavedClassName: `${prefixCls}-panel-hidden`
        }), [
        rootPrefixCls,
        prefixCls
    ]);
    const items = $cQmXV.useMemo(()=>{
        if (children) return (0, $cd966a313e0a92ff$export$2e2bcd8739ae039)(children).map((child)=>child);
        return null;
    }, [
        children
    ]);
    return /*#__PURE__*/ $cQmXV.createElement((0, $ed13545ef29ab953$export$2e2bcd8739ae039), {
        ref: ref,
        openMotion: openMotion,
        ...(0, $e8c5093aebad6025$export$2e2bcd8739ae039)(props, [
            "rootClassName"
        ]),
        expandIcon: renderExpandIcon,
        prefixCls: prefixCls,
        className: collapseClassName,
        style: mergedStyles.root,
        classNames: mergedClassNames,
        styles: mergedStyles,
        destroyOnHidden: destroyOnHidden ?? destroyInactivePanel
    }, items);
});
var $6d2d6c84d16712cb$export$2e2bcd8739ae039 = Object.assign($6d2d6c84d16712cb$var$Collapse, {
    Panel: (0, $83564532b2eca71b$export$2e2bcd8739ae039)
});


"use client";
var $23bd4bba91b7ee72$export$2e2bcd8739ae039 = (0, $6d2d6c84d16712cb$export$2e2bcd8739ae039);







const $6004e9e16651595b$export$c844f5d21427d1ab = (color)=>{
    if (color instanceof (0, $e572682ae9022769$export$e8cc8a2e87e145b4)) return color;
    return new (0, $e572682ae9022769$export$e8cc8a2e87e145b4)(color);
};
const $6004e9e16651595b$export$8d6531175688484b = (value)=>Math.round(Number(value || 0));
const $6004e9e16651595b$export$3c8ae3c73ab0e52a = (color)=>$6004e9e16651595b$export$8d6531175688484b(color.toHsb().a * 100);
const $6004e9e16651595b$export$f04e5f54cfbb466c = (color, alpha)=>{
    const rgba = color.toRgb();
    // Color from hsb input may get `rgb` is (0/0/0) when `hsb.b` is 0
    // So if rgb is empty, we should get from hsb
    if (!rgba.r && !rgba.g && !rgba.b) {
        const hsba = color.toHsb();
        hsba.a = alpha || 1;
        return $6004e9e16651595b$export$c844f5d21427d1ab(hsba);
    }
    rgba.a = alpha || 1;
    return $6004e9e16651595b$export$c844f5d21427d1ab(rgba);
};
const $6004e9e16651595b$export$9dd6bfe648e14e97 = (colors, percent)=>{
    const filledColors = [
        {
            percent: 0,
            color: colors[0].color
        }
    ].concat((0, $68381b18b974dc9f$export$2e2bcd8739ae039)(colors), [
        {
            percent: 100,
            color: colors[colors.length - 1].color
        }
    ]);
    for(let i = 0; i < filledColors.length - 1; i += 1){
        const startPtg = filledColors[i].percent;
        const endPtg = filledColors[i + 1].percent;
        const startColor = filledColors[i].color;
        const endColor = filledColors[i + 1].color;
        if (startPtg <= percent && percent <= endPtg) {
            const dist = endPtg - startPtg;
            if (dist === 0) return startColor;
            const ratio = (percent - startPtg) / dist * 100;
            const startRcColor = new (0, $9f6f44da566aebb9$export$892596cec99bc70e)(startColor);
            const endRcColor = new (0, $9f6f44da566aebb9$export$892596cec99bc70e)(endColor);
            return startRcColor.mix(endRcColor, ratio).toRgbString();
        }
    }
    // This will never reach
    /* istanbul ignore next */ return "";
};


"use client";
const $41a5307a3420cf5b$var$genPresetColor = (list)=>list.map((value)=>{
        value.colors = value.colors.map((0, $6004e9e16651595b$export$c844f5d21427d1ab));
        return value;
    });
const $41a5307a3420cf5b$export$6341b37cb79161da = (value, bgColorToken)=>{
    const { r: r, g: g, b: b, a: a } = value.toRgb();
    const hsv = new (0, $9f6f44da566aebb9$export$892596cec99bc70e)(value.toRgbString()).onBackground(bgColorToken).toHsv();
    if (a <= 0.5) // Adapted to dark mode
    return hsv.v > 0.5;
    return r * 0.299 + g * 0.587 + b * 0.114 > 192;
};
const $41a5307a3420cf5b$var$genCollapsePanelKey = (preset, index)=>{
    const mergedKey = preset.key ?? index;
    return `panel-${mergedKey}`;
};
const $41a5307a3420cf5b$var$ColorPresets = ({ prefixCls: prefixCls, presets: presets, value: color, onChange: onChange })=>{
    const [locale] = (0, $c953dac9d015386e$export$2e2bcd8739ae039)("ColorPicker");
    const [, token] = (0, $b22e03a54a548614$export$2e2bcd8739ae039)();
    const presetsValue = (0, $cQmXV.useMemo)(()=>$41a5307a3420cf5b$var$genPresetColor(presets), [
        presets
    ]);
    const colorPresetsPrefixCls = `${prefixCls}-presets`;
    const activeKeys = (0, $cQmXV.useMemo)(()=>presetsValue.reduce((acc, preset, index)=>{
            const { defaultOpen: defaultOpen = true } = preset;
            if (defaultOpen) acc.push($41a5307a3420cf5b$var$genCollapsePanelKey(preset, index));
            return acc;
        }, []), [
        presetsValue
    ]);
    const handleClick = (colorValue)=>{
        onChange?.(colorValue);
    };
    const items = presetsValue.map((preset, index)=>({
            key: $41a5307a3420cf5b$var$genCollapsePanelKey(preset, index),
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
                className: `${colorPresetsPrefixCls}-label`
            }, preset?.label),
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
                className: `${colorPresetsPrefixCls}-items`
            }, Array.isArray(preset?.colors) && preset.colors?.length > 0 ? preset.colors.map((presetColor, index)=>{
                const colorInst = (0, $6004e9e16651595b$export$c844f5d21427d1ab)(presetColor);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $c7ef50270498224a$export$2e2bcd8739ae039), {
                    // eslint-disable-next-line react/no-array-index-key
                    key: `preset-${index}-${presetColor.toHexString()}`,
                    color: colorInst.toCssString(),
                    prefixCls: prefixCls,
                    className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${colorPresetsPrefixCls}-color`, {
                        [`${colorPresetsPrefixCls}-color-checked`]: presetColor.toCssString() === color?.toCssString(),
                        [`${colorPresetsPrefixCls}-color-bright`]: $41a5307a3420cf5b$export$6341b37cb79161da(presetColor, token.colorBgElevated)
                    }),
                    onClick: ()=>handleClick(presetColor)
                });
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("span", {
                className: `${colorPresetsPrefixCls}-empty`
            }, locale.presetEmpty))
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
        className: colorPresetsPrefixCls
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $23bd4bba91b7ee72$export$2e2bcd8739ae039), {
        defaultActiveKey: activeKeys,
        ghost: true,
        items: items
    }));
};
var $41a5307a3420cf5b$export$2e2bcd8739ae039 = $41a5307a3420cf5b$var$ColorPresets;





const $52ee65e4bdc9943c$export$362fb92a8f81bbf9 = (token)=>{
    const { paddingInline: paddingInline, onlyIconSize: onlyIconSize, borderColorDisabled: borderColorDisabled } = token;
    const buttonToken = (0, $fef50f256b80dfa5$export$4950aa0f605343fb)(token, {
        buttonPaddingHorizontal: paddingInline,
        buttonPaddingVertical: 0,
        buttonIconOnlyFontSize: onlyIconSize,
        colorBorderDisabled: borderColorDisabled
    });
    return buttonToken;
};
const $52ee65e4bdc9943c$export$9ca1be8807fe0675 = (token)=>{
    const contentFontSize = token.contentFontSize ?? token.fontSize;
    const contentFontSizeSM = token.contentFontSizeSM ?? token.fontSize;
    const contentFontSizeLG = token.contentFontSizeLG ?? token.fontSizeLG;
    const contentLineHeight = token.contentLineHeight ?? (0, $7e34bbc761b71f61$export$56204a27a2958a55)(contentFontSize);
    const contentLineHeightSM = token.contentLineHeightSM ?? (0, $7e34bbc761b71f61$export$56204a27a2958a55)(contentFontSizeSM);
    const contentLineHeightLG = token.contentLineHeightLG ?? (0, $7e34bbc761b71f61$export$56204a27a2958a55)(contentFontSizeLG);
    const solidTextColor = (0, $41a5307a3420cf5b$export$6341b37cb79161da)(new (0, $e572682ae9022769$export$e8cc8a2e87e145b4)(token.colorBgSolid), "#fff") ? "#000" : "#fff";
    const shadowColorTokens = (0, $ade5e73b59dc3f96$export$6d4fe3a00a1811ad).reduce((prev, colorKey)=>({
            ...prev,
            [`${colorKey}ShadowColor`]: `0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.controlOutlineWidth)} 0 ${(0, $5d4592d59e730fdd$export$2e2bcd8739ae039)(token[`${colorKey}1`], token.colorBgContainer)}`
        }), {});
    const defaultBgDisabled = token.colorBgContainerDisabled;
    const dashedBgDisabled = token.colorBgContainerDisabled;
    return {
        ...shadowColorTokens,
        fontWeight: 400,
        iconGap: token.marginXS,
        defaultShadow: `0 ${token.controlOutlineWidth}px 0 ${token.controlTmpOutline}`,
        primaryShadow: `0 ${token.controlOutlineWidth}px 0 ${token.controlOutline}`,
        dangerShadow: `0 ${token.controlOutlineWidth}px 0 ${token.colorErrorOutline}`,
        primaryColor: token.colorTextLightSolid,
        dangerColor: token.colorTextLightSolid,
        borderColorDisabled: token.colorBorderDisabled,
        defaultGhostColor: token.colorBgContainer,
        ghostBg: "transparent",
        defaultGhostBorderColor: token.colorBgContainer,
        paddingInline: token.paddingContentHorizontal - token.lineWidth,
        paddingInlineLG: token.paddingContentHorizontal - token.lineWidth,
        paddingInlineSM: 8 - token.lineWidth,
        onlyIconSize: "inherit",
        onlyIconSizeSM: "inherit",
        onlyIconSizeLG: "inherit",
        groupBorderColor: token.colorPrimaryHover,
        linkHoverBg: "transparent",
        textTextColor: token.colorText,
        textTextHoverColor: token.colorText,
        textTextActiveColor: token.colorText,
        textHoverBg: token.colorFillTertiary,
        defaultColor: token.colorText,
        defaultBg: token.colorBgContainer,
        defaultBorderColor: token.colorBorder,
        defaultBorderColorDisabled: token.colorBorder,
        defaultHoverBg: token.colorBgContainer,
        defaultHoverColor: token.colorPrimaryHover,
        defaultHoverBorderColor: token.colorPrimaryHover,
        defaultActiveBg: token.colorBgContainer,
        defaultActiveColor: token.colorPrimaryActive,
        defaultActiveBorderColor: token.colorPrimaryActive,
        solidTextColor: solidTextColor,
        contentFontSize: contentFontSize,
        contentFontSizeSM: contentFontSizeSM,
        contentFontSizeLG: contentFontSizeLG,
        contentLineHeight: contentLineHeight,
        contentLineHeightSM: contentLineHeightSM,
        contentLineHeightLG: contentLineHeightLG,
        paddingBlock: Math.max((token.controlHeight - contentFontSize * contentLineHeight) / 2 - token.lineWidth, 0),
        paddingBlockSM: Math.max((token.controlHeightSM - contentFontSizeSM * contentLineHeightSM) / 2 - token.lineWidth, 0),
        paddingBlockLG: Math.max((token.controlHeightLG - contentFontSizeLG * contentLineHeightLG) / 2 - token.lineWidth, 0),
        defaultBgDisabled: defaultBgDisabled,
        dashedBgDisabled: dashedBgDisabled
    };
};




const $840a4b46669db28e$var$genVariantStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls, lineWidth: lineWidth, lineType: lineType } = token;
    const [varName, varRef] = (0, $6870d4d7c14ae0bb$export$d82b8f66c5649e14)(antCls, "btn");
    return {
        [componentCls]: [
            // ==============================================================
            // ==                         Variable                         ==
            // ==============================================================
            {
                // Border
                [varName("border-width")]: lineWidth,
                [varName("border-color")]: "#000",
                [varName("border-color-hover")]: varRef("border-color"),
                [varName("border-color-active")]: varRef("border-color"),
                [varName("border-color-disabled")]: varRef("border-color"),
                [varName("border-style")]: lineType,
                // Text
                [varName("text-color")]: "#000",
                [varName("text-color-hover")]: varRef("text-color"),
                [varName("text-color-active")]: varRef("text-color"),
                [varName("text-color-disabled")]: varRef("text-color"),
                // Background
                [varName("bg-color")]: "#ddd",
                [varName("bg-color-hover")]: varRef("bg-color"),
                [varName("bg-color-active")]: varRef("bg-color"),
                [varName("bg-color-disabled")]: token.colorBgContainerDisabled,
                [varName("bg-color-container")]: token.colorBgContainer,
                // Shadow
                [varName("shadow")]: "none"
            },
            // ==============================================================
            // ==                         Template                         ==
            // ==============================================================
            {
                // Basic
                border: [
                    varRef("border-width"),
                    varRef("border-style"),
                    varRef("border-color")
                ].join(" "),
                color: varRef("text-color"),
                backgroundColor: varRef("bg-color"),
                // Status
                [`&:not(:disabled):not(${componentCls}-disabled)`]: {
                    // Hover
                    "&:hover": {
                        border: [
                            varRef("border-width"),
                            varRef("border-style"),
                            varRef("border-color-hover")
                        ].join(" "),
                        color: varRef("text-color-hover"),
                        backgroundColor: varRef("bg-color-hover")
                    },
                    // Active
                    "&:active": {
                        border: [
                            varRef("border-width"),
                            varRef("border-style"),
                            varRef("border-color-active")
                        ].join(" "),
                        color: varRef("text-color-active"),
                        backgroundColor: varRef("bg-color-active")
                    }
                }
            },
            // ==============================================================
            // ==                         Variants                         ==
            // ==============================================================
            {
                // >>>>> Solid
                [`&${componentCls}-variant-solid`]: {
                    // Solid Variables
                    [varName("solid-bg-color")]: varRef("color-base"),
                    [varName("solid-bg-color-hover")]: varRef("color-hover"),
                    [varName("solid-bg-color-active")]: varRef("color-active"),
                    // Variables
                    [varName("border-color")]: "transparent",
                    [varName("text-color")]: token.colorTextLightSolid,
                    [varName("bg-color")]: varRef("solid-bg-color"),
                    [varName("bg-color-hover")]: varRef("solid-bg-color-hover"),
                    [varName("bg-color-active")]: varRef("solid-bg-color-active"),
                    // Box Shadow
                    boxShadow: varRef("shadow")
                },
                // >>>>> Outlined & Dashed
                [`&${componentCls}-variant-outlined, &${componentCls}-variant-dashed`]: {
                    [varName("border-color")]: varRef("color-base"),
                    [varName("border-color-hover")]: varRef("color-hover"),
                    [varName("border-color-active")]: varRef("color-active"),
                    [varName("bg-color")]: varRef("bg-color-container"),
                    [varName("text-color")]: varRef("color-base"),
                    [varName("text-color-hover")]: varRef("color-hover"),
                    [varName("text-color-active")]: varRef("color-active"),
                    // Box Shadow
                    boxShadow: varRef("shadow")
                },
                // >>>>> Dashed
                [`&${componentCls}-variant-dashed`]: {
                    [varName("border-style")]: "dashed",
                    [varName("bg-color-disabled")]: token.dashedBgDisabled
                },
                // >>>>> Filled
                [`&${componentCls}-variant-filled`]: {
                    [varName("border-color")]: "transparent",
                    [varName("text-color")]: varRef("color-base"),
                    [varName("bg-color")]: varRef("color-light"),
                    [varName("bg-color-hover")]: varRef("color-light-hover"),
                    [varName("bg-color-active")]: varRef("color-light-active")
                },
                // >>>>> Text & Link
                [`&${componentCls}-variant-text, &${componentCls}-variant-link`]: {
                    [varName("border-color")]: "transparent",
                    [varName("text-color")]: varRef("color-base"),
                    [varName("text-color-hover")]: varRef("color-hover"),
                    [varName("text-color-active")]: varRef("color-active"),
                    [varName("bg-color")]: "transparent",
                    [varName("bg-color-hover")]: "transparent",
                    [varName("bg-color-active")]: "transparent",
                    [`&:disabled, &${token.componentCls}-disabled`]: {
                        background: "transparent",
                        borderColor: "transparent"
                    }
                },
                // >>>>> Text
                [`&${componentCls}-variant-text`]: {
                    [varName("bg-color-hover")]: varRef("color-light"),
                    [varName("bg-color-active")]: varRef("color-light-active")
                }
            },
            // ==============================================================
            // ==                          Colors                          ==
            // ==============================================================
            {
                // ======================== By Default ========================
                // >>>>> Link
                [`&${componentCls}-variant-link`]: {
                    [varName("color-base")]: token.colorLink,
                    [varName("color-hover")]: token.colorLinkHover,
                    [varName("color-active")]: token.colorLinkActive,
                    [varName("bg-color-hover")]: token.linkHoverBg
                },
                // ======================== Compatible ========================
                // >>>>> Primary
                [`&${componentCls}-color-primary`]: {
                    [varName("color-base")]: token.colorPrimary,
                    [varName("color-hover")]: token.colorPrimaryHover,
                    [varName("color-active")]: token.colorPrimaryActive,
                    [varName("color-light")]: token.colorPrimaryBg,
                    [varName("color-light-hover")]: token.colorPrimaryBgHover,
                    [varName("color-light-active")]: token.colorPrimaryBorder,
                    [varName("shadow")]: token.primaryShadow,
                    [`&${componentCls}-variant-solid`]: {
                        [varName("text-color")]: token.primaryColor,
                        [varName("text-color-hover")]: varRef("text-color"),
                        [varName("text-color-active")]: varRef("text-color")
                    }
                },
                // >>>>> Danger
                [`&${componentCls}-color-dangerous`]: {
                    [varName("color-base")]: token.colorError,
                    [varName("color-hover")]: token.colorErrorHover,
                    [varName("color-active")]: token.colorErrorActive,
                    [varName("color-light")]: token.colorErrorBg,
                    [varName("color-light-hover")]: token.colorErrorBgFilledHover,
                    [varName("color-light-active")]: token.colorErrorBgActive,
                    [varName("shadow")]: token.dangerShadow,
                    [`&${componentCls}-variant-solid`]: {
                        [varName("text-color")]: token.dangerColor,
                        [varName("text-color-hover")]: varRef("text-color"),
                        [varName("text-color-active")]: varRef("text-color")
                    }
                },
                // >>>>> Default
                [`&${componentCls}-color-default`]: {
                    [varName("solid-bg-color")]: token.colorBgSolid,
                    [varName("solid-bg-color-hover")]: token.colorBgSolidHover,
                    [varName("solid-bg-color-active")]: token.colorBgSolidActive,
                    [varName("color-base")]: token.defaultBorderColor,
                    [varName("color-hover")]: token.defaultHoverBorderColor,
                    [varName("color-active")]: token.defaultActiveBorderColor,
                    [varName("color-light")]: token.colorFillTertiary,
                    [varName("color-light-hover")]: token.colorFillSecondary,
                    [varName("color-light-active")]: token.colorFill,
                    [varName("text-color")]: token.defaultColor,
                    [varName("text-color-hover")]: token.defaultHoverColor,
                    [varName("text-color-active")]: token.defaultActiveColor,
                    [varName("shadow")]: token.defaultShadow,
                    [`&${componentCls}-variant-outlined`]: {
                        [varName("bg-color-disabled")]: token.defaultBgDisabled
                    },
                    [`&${componentCls}-variant-solid`]: {
                        [varName("text-color")]: token.solidTextColor,
                        [varName("text-color-hover")]: varRef("text-color"),
                        [varName("text-color-active")]: varRef("text-color")
                    },
                    [`&${componentCls}-variant-filled, &${componentCls}-variant-text`]: {
                        [varName("text-color-hover")]: varRef("text-color"),
                        [varName("text-color-active")]: varRef("text-color")
                    },
                    [`&${componentCls}-variant-outlined, &${componentCls}-variant-dashed`]: {
                        [varName("text-color")]: token.defaultColor,
                        [varName("text-color-hover")]: token.defaultHoverColor,
                        [varName("text-color-active")]: token.defaultActiveColor,
                        [varName("bg-color-container")]: token.defaultBg,
                        [varName("bg-color-hover")]: token.defaultHoverBg,
                        [varName("bg-color-active")]: token.defaultActiveBg
                    },
                    [`&${componentCls}-variant-text`]: {
                        [varName("text-color")]: token.textTextColor,
                        [varName("text-color-hover")]: token.textTextHoverColor,
                        [varName("text-color-active")]: token.textTextActiveColor,
                        [varName("bg-color-hover")]: token.textHoverBg
                    },
                    [`&${componentCls}-background-ghost`]: {
                        [`&${componentCls}-variant-outlined, &${componentCls}-variant-dashed`]: {
                            [varName("text-color")]: token.defaultGhostColor,
                            [varName("border-color")]: token.defaultGhostBorderColor
                        }
                    }
                }
            },
            // >>>>> Preset Colors
            (0, $ade5e73b59dc3f96$export$6d4fe3a00a1811ad).map((colorKey)=>{
                const darkColor = token[`${colorKey}6`];
                const lightColor = token[`${colorKey}1`];
                const hoverColor = token[`${colorKey}Hover`];
                const lightHoverColor = token[`${colorKey}2`];
                const lightActiveColor = token[`${colorKey}3`];
                const activeColor = token[`${colorKey}Active`];
                const shadowColor = token[`${colorKey}ShadowColor`];
                return {
                    [`&${componentCls}-color-${colorKey}`]: {
                        [varName("color-base")]: darkColor,
                        [varName("color-hover")]: hoverColor,
                        [varName("color-active")]: activeColor,
                        [varName("color-light")]: lightColor,
                        [varName("color-light-hover")]: lightHoverColor,
                        [varName("color-light-active")]: lightActiveColor,
                        [varName("shadow")]: shadowColor
                    }
                };
            }),
            // ==============================================================
            // ==                         Disabled                         ==
            // ==============================================================
            {
                // Disabled
                [`&:disabled, &${token.componentCls}-disabled`]: {
                    cursor: "not-allowed",
                    borderColor: token.colorBorderDisabled,
                    background: varRef("bg-color-disabled"),
                    color: token.colorTextDisabled,
                    boxShadow: "none"
                }
            },
            // ==============================================================
            // ==                          Ghost                           ==
            // ==============================================================
            {
                // Ghost
                [`&${componentCls}-background-ghost`]: {
                    [varName("bg-color")]: token.ghostBg,
                    [varName("bg-color-hover")]: token.ghostBg,
                    [varName("bg-color-active")]: token.ghostBg,
                    [varName("shadow")]: "none",
                    [`&${componentCls}-variant-outlined, &${componentCls}-variant-dashed`]: {
                        [varName("bg-color-hover")]: token.ghostBg,
                        [varName("bg-color-active")]: token.ghostBg
                    }
                }
            }
        ]
    };
};
var $840a4b46669db28e$export$2e2bcd8739ae039 = $840a4b46669db28e$var$genVariantStyle;


// ============================== Shared ==============================
const $0907426fc204f594$var$genSharedButtonStyle = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, fontWeight: fontWeight, opacityLoading: opacityLoading, motionDurationSlow: motionDurationSlow, motionEaseInOut: motionEaseInOut, iconGap: iconGap, calc: calc } = token;
    return {
        [componentCls]: {
            outline: "none",
            position: "relative",
            display: "inline-flex",
            gap: iconGap,
            alignItems: "center",
            justifyContent: "center",
            fontWeight: fontWeight,
            whiteSpace: "nowrap",
            textAlign: "center",
            backgroundImage: "none",
            cursor: "pointer",
            transition: `all ${token.motionDurationMid} ${token.motionEaseInOut}`,
            userSelect: "none",
            touchAction: "manipulation",
            ...(0, $e111c624d18c33f1$export$c5b4e7cabb00fc99)(),
            "&:disabled > *": {
                pointerEvents: "none"
            },
            // https://github.com/ant-design/ant-design/issues/51380
            [`${componentCls}-icon > svg`]: (0, $519d20bf207ce864$export$171ccda7bc085e59)(),
            // https://github.com/ant-design/ant-design/issues/57727
            [`${componentCls}-icon`]: {
                display: "inline-flex",
                alignItems: "center",
                [iconCls]: {
                    verticalAlign: "middle",
                    // Baseline will align the first element.
                    // So the Button with SVG will make the baseline to be the bottom of the SVG.
                    // Let's use `:before` to add a space to make the baseline to be the center of the Button.
                    // https://github.com/ant-design/ant-design/issues/58428
                    "&:before": {
                        content: '"\\a0"',
                        display: "inline-block",
                        width: 0
                    }
                }
            },
            "> a": {
                color: "currentColor"
            },
            "&:not(:disabled)": (0, $519d20bf207ce864$export$a44db842bcb28231)(token),
            [`&${componentCls}-two-chinese-chars::first-letter`]: {
                letterSpacing: "0.34em"
            },
            [`&${componentCls}-two-chinese-chars > *:not(${iconCls})`]: {
                marginInlineEnd: "-0.34em",
                letterSpacing: "0.34em"
            },
            [`&${componentCls}-icon-only`]: {
                paddingInline: 0,
                // make `btn-icon-only` not too narrow
                [`&${componentCls}-compact-item`]: {
                    flex: "none"
                }
            },
            // Loading
            [`&${componentCls}-loading`]: {
                opacity: opacityLoading,
                cursor: "default"
            },
            [`${componentCls}-loading-icon`]: {
                transition: [
                    "width",
                    "opacity",
                    "margin"
                ].map((prop)=>`${prop} ${motionDurationSlow} ${motionEaseInOut}`).join(",")
            },
            // iconPlacement
            [`&:not(${componentCls}-icon-end)`]: {
                [`${componentCls}-loading-icon-motion`]: {
                    "&-appear-start, &-enter-start, &-appear-prepare, &-enter-prepare": {
                        marginInlineEnd: calc(iconGap).mul(-1).equal(),
                        opacity: 0
                    },
                    "&-appear-active, &-enter-active": {
                        marginInlineEnd: 0
                    },
                    "&-leave-start": {
                        marginInlineEnd: 0
                    },
                    "&-leave-active": {
                        marginInlineEnd: calc(iconGap).mul(-1).equal()
                    }
                }
            },
            "&-icon-end": {
                flexDirection: "row-reverse",
                [`${componentCls}-loading-icon-motion`]: {
                    "&-appear-start, &-enter-start, &-appear-prepare, &-enter-prepare": {
                        marginInlineStart: calc(iconGap).mul(-1).equal(),
                        opacity: 0
                    },
                    "&-appear-active, &-enter-active": {
                        marginInlineStart: 0
                    },
                    "&-leave-start": {
                        marginInlineStart: 0
                    },
                    "&-leave-active": {
                        marginInlineStart: calc(iconGap).mul(-1).equal()
                    }
                }
            }
        }
    };
};
// ============================== Shape ===============================
const $0907426fc204f594$var$genCircleButtonStyle = (token)=>({
        minWidth: token.controlHeight,
        paddingInline: 0,
        borderRadius: "50%"
    });
// =============================== Size ===============================
const $0907426fc204f594$var$genButtonStyle = (token, prefixCls = "")=>{
    const { componentCls: componentCls, controlHeight: controlHeight, fontSize: fontSize, borderRadius: borderRadius, buttonPaddingHorizontal: buttonPaddingHorizontal, iconCls: iconCls, buttonPaddingVertical: buttonPaddingVertical, buttonIconOnlyFontSize: buttonIconOnlyFontSize } = token;
    return [
        {
            [prefixCls]: {
                fontSize: fontSize,
                height: controlHeight,
                padding: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(buttonPaddingVertical)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(buttonPaddingHorizontal)}`,
                borderRadius: borderRadius,
                [`&${componentCls}-icon-only`]: {
                    width: controlHeight,
                    [iconCls]: {
                        fontSize: buttonIconOnlyFontSize
                    }
                }
            }
        },
        // Shape - patch prefixCls again to override solid border radius style
        {
            [`${componentCls}${componentCls}-circle${prefixCls}`]: $0907426fc204f594$var$genCircleButtonStyle(token)
        },
        {
            [`${componentCls}${componentCls}-round${prefixCls}`]: {
                borderRadius: token.controlHeight,
                [`&:not(${componentCls}-icon-only)`]: {
                    paddingInline: token.buttonPaddingHorizontal
                }
            }
        }
    ];
};
const $0907426fc204f594$var$genSizeBaseButtonStyle = (token)=>{
    const baseToken = (0, $fef50f256b80dfa5$export$4950aa0f605343fb)(token, {
        fontSize: token.contentFontSize
    });
    return $0907426fc204f594$var$genButtonStyle(baseToken, token.componentCls);
};
const $0907426fc204f594$var$genSizeSmallButtonStyle = (token)=>{
    const smallToken = (0, $fef50f256b80dfa5$export$4950aa0f605343fb)(token, {
        controlHeight: token.controlHeightSM,
        fontSize: token.contentFontSizeSM,
        padding: token.paddingXS,
        buttonPaddingHorizontal: token.paddingInlineSM,
        buttonPaddingVertical: 0,
        borderRadius: token.borderRadiusSM,
        buttonIconOnlyFontSize: token.onlyIconSizeSM
    });
    return $0907426fc204f594$var$genButtonStyle(smallToken, `${token.componentCls}-sm`);
};
const $0907426fc204f594$var$genSizeLargeButtonStyle = (token)=>{
    const largeToken = (0, $fef50f256b80dfa5$export$4950aa0f605343fb)(token, {
        controlHeight: token.controlHeightLG,
        fontSize: token.contentFontSizeLG,
        buttonPaddingHorizontal: token.paddingInlineLG,
        buttonPaddingVertical: 0,
        borderRadius: token.borderRadiusLG,
        buttonIconOnlyFontSize: token.onlyIconSizeLG
    });
    return $0907426fc204f594$var$genButtonStyle(largeToken, `${token.componentCls}-lg`);
};
const $0907426fc204f594$var$genBlockButtonStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: {
            [`&${componentCls}-block`]: {
                width: "100%"
            }
        }
    };
};
var // ============================== Export ==============================
$0907426fc204f594$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$51ec95de45185b42)("Button", (token)=>{
    const buttonToken = (0, $52ee65e4bdc9943c$export$362fb92a8f81bbf9)(token);
    return [
        // Shared
        $0907426fc204f594$var$genSharedButtonStyle(buttonToken),
        // Size
        $0907426fc204f594$var$genSizeBaseButtonStyle(buttonToken),
        $0907426fc204f594$var$genSizeSmallButtonStyle(buttonToken),
        $0907426fc204f594$var$genSizeLargeButtonStyle(buttonToken),
        // Block
        $0907426fc204f594$var$genBlockButtonStyle(buttonToken),
        // Variant
        (0, $840a4b46669db28e$export$2e2bcd8739ae039)(buttonToken),
        // Button Group
        (0, $0d0e8fa830a917ca$export$2e2bcd8739ae039)(buttonToken)
    ];
}, (0, $52ee65e4bdc9943c$export$9ca1be8807fe0675), {
    unitless: {
        fontWeight: true,
        contentLineHeight: true,
        contentLineHeightSM: true,
        contentLineHeightLG: true
    }
});


// handle border collapse
function $6e46145470fc0a51$var$compactItemBorder(token, parentCls, options, prefixCls) {
    const { focusElCls: focusElCls, focus: focus, borderElCls: borderElCls } = options;
    const childCombinator = borderElCls ? "> *" : "";
    const suffix = childCombinator ? ` ${childCombinator}` : "";
    const genEffects = (effects)=>effects.filter(Boolean).map((n)=>`&:${n}${suffix}`).join(",");
    const hoverEffects = genEffects([
        "hover",
        focusElCls ? `hover${focusElCls}` : null
    ]);
    const focusEffects = genEffects([
        focus ? "focus" : null,
        "active"
    ]);
    return {
        [`&-item:not(${parentCls}-last-item)`]: {
            marginInlineEnd: token.calc(token.lineWidth).mul(-1).equal()
        },
        [`&-item:not(${prefixCls}-status-success)`]: {
            zIndex: 2
        },
        "&-item": {
            [focusEffects]: {
                zIndex: 3
            },
            [hoverEffects]: {
                zIndex: 4
            },
            ...focusElCls ? {
                [`&${focusElCls}`]: {
                    zIndex: 3
                }
            } : {},
            [`&[disabled] ${childCombinator}`]: {
                zIndex: 0
            }
        }
    };
}
// handle border-radius
function $6e46145470fc0a51$var$compactItemBorderRadius(prefixCls, parentCls, options) {
    const { borderElCls: borderElCls } = options;
    const childCombinator = borderElCls ? `> ${borderElCls}` : "";
    return {
        [`&-item:not(${parentCls}-first-item):not(${parentCls}-last-item) ${childCombinator}`]: {
            borderRadius: 0
        },
        [`&-item:not(${parentCls}-last-item)${parentCls}-first-item`]: {
            [`& ${childCombinator}, &${prefixCls}-sm ${childCombinator}, &${prefixCls}-lg ${childCombinator}`]: {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0
            }
        },
        [`&-item:not(${parentCls}-first-item)${parentCls}-last-item`]: {
            [`& ${childCombinator}, &${prefixCls}-sm ${childCombinator}, &${prefixCls}-lg ${childCombinator}`]: {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
            }
        }
    };
}
function $6e46145470fc0a51$export$b1208b23589b4b73(token, options = {
    focus: true
}) {
    const { componentCls: componentCls } = token;
    const { componentCls: customizePrefixCls } = options;
    const mergedComponentCls = customizePrefixCls || componentCls;
    const compactCls = `${mergedComponentCls}-compact`;
    return {
        [compactCls]: {
            ...$6e46145470fc0a51$var$compactItemBorder(token, compactCls, options, mergedComponentCls),
            ...$6e46145470fc0a51$var$compactItemBorderRadius(mergedComponentCls, compactCls, options)
        }
    };
}


function $7e052fa18dafeab6$var$compactItemVerticalBorder(token, parentCls, prefixCls) {
    return {
        // border collapse
        [`&-item:not(${parentCls}-last-item)`]: {
            marginBottom: token.calc(token.lineWidth).mul(-1).equal()
        },
        [`&-item:not(${prefixCls}-status-success)`]: {
            zIndex: 2
        },
        "&-item": {
            "&:focus,&:active": {
                zIndex: 3
            },
            "&:hover": {
                zIndex: 4
            },
            "&[disabled]": {
                zIndex: 0
            }
        }
    };
}
function $7e052fa18dafeab6$var$compactItemBorderVerticalRadius(prefixCls, parentCls) {
    return {
        [`&-item:not(${parentCls}-first-item):not(${parentCls}-last-item)`]: {
            borderRadius: 0
        },
        [`&-item${parentCls}-first-item:not(${parentCls}-last-item)`]: {
            [`&, &${prefixCls}-sm, &${prefixCls}-lg`]: {
                borderEndEndRadius: 0,
                borderEndStartRadius: 0
            }
        },
        [`&-item${parentCls}-last-item:not(${parentCls}-first-item)`]: {
            [`&, &${prefixCls}-sm, &${prefixCls}-lg`]: {
                borderStartStartRadius: 0,
                borderStartEndRadius: 0
            }
        }
    };
}
function $7e052fa18dafeab6$export$4dc87cb8ebf78ac6(token) {
    const compactCls = `${token.componentCls}-compact-vertical`;
    return {
        [compactCls]: {
            ...$7e052fa18dafeab6$var$compactItemVerticalBorder(token, compactCls, token.componentCls),
            ...$7e052fa18dafeab6$var$compactItemBorderVerticalRadius(token.componentCls, compactCls)
        }
    };
}





const $b4e423ef9f4273a8$var$genButtonCompactStyle = (token)=>{
    const { antCls: antCls, componentCls: componentCls, lineWidth: lineWidth, calc: calc, colorBgContainer: colorBgContainer } = token;
    const solidSelector = `${componentCls}-variant-solid:not([disabled])`;
    const insetOffset = calc(lineWidth).mul(-1).equal();
    const [varName, varRef] = (0, $6870d4d7c14ae0bb$export$d82b8f66c5649e14)(antCls, "btn");
    const getCompactBorderStyle = (vertical)=>{
        const itemCls = `${componentCls}-compact${vertical ? "-vertical" : ""}-item`;
        return {
            // TODO: Border color transition should be not cover when has color.
            [itemCls]: {
                [varName("compact-connect-border-color")]: varRef("bg-color-hover"),
                [`&${solidSelector}`]: {
                    transition: `none`,
                    [`& + ${solidSelector}:before`]: [
                        {
                            position: "absolute",
                            backgroundColor: varRef("compact-connect-border-color"),
                            content: '""'
                        },
                        vertical ? {
                            top: insetOffset,
                            insetInline: insetOffset,
                            height: lineWidth
                        } : {
                            insetBlock: insetOffset,
                            insetInlineStart: insetOffset,
                            width: lineWidth
                        }
                    ],
                    "&:hover:before": {
                        display: "none"
                    }
                }
            }
        };
    };
    // Special styles for solid Button
    return [
        getCompactBorderStyle(),
        getCompactBorderStyle(true),
        {
            [`${solidSelector}${componentCls}-color-default`]: {
                [varName("compact-connect-border-color")]: `color-mix(in srgb, ${varRef("bg-color-hover")} 75%, ${colorBgContainer})`
            }
        }
    ];
};
var // ============================== Export ==============================
$b4e423ef9f4273a8$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$1537386bc155ea56)([
    "Button",
    "compact"
], (token)=>{
    const buttonToken = (0, $52ee65e4bdc9943c$export$362fb92a8f81bbf9)(token);
    return [
        // Space Compact
        (0, $6e46145470fc0a51$export$b1208b23589b4b73)(buttonToken),
        (0, $7e052fa18dafeab6$export$4dc87cb8ebf78ac6)(buttonToken),
        $b4e423ef9f4273a8$var$genButtonCompactStyle(buttonToken)
    ];
}, (0, $52ee65e4bdc9943c$export$9ca1be8807fe0675));


"use client";
function $1fc505710073cde5$var$getLoadingConfig(loading) {
    if ((0, $8e2d153a3c855782$export$53b83ca8eaab0383)(loading)) {
        let delay = loading?.delay;
        delay = (0, $8e2d153a3c855782$export$7e4aa119212bc614)(delay) ? delay : 0;
        return {
            loading: delay <= 0,
            delay: delay
        };
    }
    return {
        loading: !!loading,
        delay: 0
    };
}
const $1fc505710073cde5$var$ButtonTypeMap = {
    default: [
        "default",
        "outlined"
    ],
    primary: [
        "primary",
        "solid"
    ],
    dashed: [
        "default",
        "dashed"
    ],
    // `link` is not a real color but we should compatible with it
    link: [
        "link",
        "link"
    ],
    text: [
        "default",
        "text"
    ]
};
const $1fc505710073cde5$var$InternalCompoundedButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).forwardRef((props, ref)=>{
    const { _skipSemantic: _skipSemantic, loading: loading = false, prefixCls: customizePrefixCls, color: color, variant: variant, type: type, danger: danger = false, shape: customizeShape, size: customizeSize, disabled: customDisabled, className: className, rootClassName: rootClassName, children: children, icon: icon, iconPosition: iconPosition, iconPlacement: iconPlacement, ghost: ghost = false, block: block = false, htmlType: // React does not recognize the `htmlType` prop on a DOM element. Here we pick it out of `rest`.
    htmlType = "button", classNames: classNames, styles: styles, style: style, autoInsertSpace: autoInsertSpace, autoFocus: autoFocus, ...rest } = props;
    const childNodes = (0, $cd966a313e0a92ff$export$2e2bcd8739ae039)(children);
    // https://github.com/ant-design/ant-design/issues/47605
    // Compatible with original `type` behavior
    const mergedType = type || "default";
    const { getPrefixCls: getPrefixCls, direction: direction, autoInsertSpace: contextAutoInsertSpace, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles, loadingIcon: contextLoadingIcon, shape: contextShape, color: contextColor, variant: contextVariant } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("button");
    const mergedShape = customizeShape || contextShape || "default";
    const [parsedColor, parsedVariant] = (0, $cQmXV.useMemo)(()=>{
        // >>>>> Local
        // Color & Variant
        if (color && variant) return [
            color,
            variant
        ];
        // Sugar syntax
        if (type || danger) {
            const colorVariantPair = $1fc505710073cde5$var$ButtonTypeMap[mergedType] || [];
            if (danger) return [
                "danger",
                colorVariantPair[1]
            ];
            return colorVariantPair;
        }
        if (variant === "solid") return [
            "primary",
            variant
        ];
        // >>> Context fallback
        if (contextColor && contextVariant) return [
            contextColor,
            contextVariant
        ];
        if (contextVariant === "solid") return [
            "primary",
            contextVariant
        ];
        return [
            "default",
            "outlined"
        ];
    }, [
        color,
        variant,
        type,
        danger,
        contextColor,
        contextVariant,
        mergedType
    ]);
    const [mergedColor, mergedVariant] = (0, $cQmXV.useMemo)(()=>{
        if (ghost && parsedVariant === "solid") return [
            parsedColor,
            "outlined"
        ];
        return [
            parsedColor,
            parsedVariant
        ];
    }, [
        parsedColor,
        parsedVariant,
        ghost
    ]);
    const isDanger = mergedColor === "danger";
    const mergedColorText = isDanger ? "dangerous" : mergedColor;
    const mergedInsertSpace = autoInsertSpace ?? contextAutoInsertSpace ?? true;
    const prefixCls = getPrefixCls("btn", customizePrefixCls);
    const [hashId, cssVarCls] = (0, $0907426fc204f594$export$2e2bcd8739ae039)(prefixCls);
    const disabled = (0, $cQmXV.useContext)((0, $4f0e1ea30330557c$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled ?? disabled;
    const groupSize = (0, $cQmXV.useContext)((0, $f9eeaefe4fcb3479$export$ed0cc8bd1f617d6d));
    const loadingOrDelay = (0, $cQmXV.useMemo)(()=>$1fc505710073cde5$var$getLoadingConfig(loading), [
        loading
    ]);
    const [innerLoading, setInnerLoading] = (0, $f0cf805f93abd5af$export$2e2bcd8739ae039)(loadingOrDelay.loading);
    const [hasTwoCNChar, setHasTwoCNChar] = (0, $cQmXV.useState)(false);
    const buttonRef = (0, $cQmXV.useRef)(null);
    const mergedRef = (0, $10341b937b26f69d$export$1d1c999670a1285d)(ref, buttonRef);
    const needInserted = childNodes.length === 1 && !icon && !(0, $62e55ded4111e367$export$b120bc11c0d9c214)(mergedVariant);
    // ========================= Mount ==========================
    // Record for mount status.
    // This will help to no to show the animation of loading on the first mount.
    const isMountRef = (0, $cQmXV.useRef)(true);
    (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useEffect(()=>{
        isMountRef.current = false;
        return ()=>{
            isMountRef.current = true;
        };
    }, []);
    // ========================= Effect =========================
    // Loading. Should use `useLayoutEffect` to avoid low perf multiple click issue.
    // https://github.com/ant-design/ant-design/issues/51325
    (0, $7673d874dab69d07$export$2e2bcd8739ae039)(()=>{
        if (loadingOrDelay.delay > 0) setInnerLoading(true, {
            ms: loadingOrDelay.delay
        });
        else setInnerLoading(loadingOrDelay.loading, true);
    }, [
        loadingOrDelay.delay,
        loadingOrDelay.loading
    ]);
    // Two chinese characters check
    (0, $cQmXV.useEffect)(()=>{
        // FIXME: for HOC usage like <FormatMessage />
        if (!buttonRef.current || !mergedInsertSpace) return;
        const buttonText = buttonRef.current.textContent || "";
        if (needInserted && (0, $62e55ded4111e367$export$c5dca2bf412dea0d)(buttonText)) {
            if (!hasTwoCNChar) setHasTwoCNChar(true);
        } else if (hasTwoCNChar) setHasTwoCNChar(false);
    }); // 这里不需要依赖数组
    // Auto focus
    (0, $cQmXV.useEffect)(()=>{
        if (autoFocus) buttonRef.current?.focus();
    }, []); // 这里不需要依赖 autoFocus 变量，只需要在第一次 mount 时生效
    // ========================= Events =========================
    const handleClick = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useCallback((e)=>{
        // FIXME: https://github.com/ant-design/ant-design/issues/30207
        if (innerLoading || mergedDisabled) {
            e.preventDefault();
            return;
        }
        props.onClick?.("href" in props ? e : e);
    }, [
        props.onClick,
        innerLoading,
        mergedDisabled
    ]);
    // ========================== Size ==========================
    const { compactSize: compactSize, compactItemClassnames: compactItemClassnames } = (0, $68fddf51400eda11$export$cd8cf9d7bab8dd4)(prefixCls, direction);
    const sizeFullName = (0, $78cdfb6138721329$export$2e2bcd8739ae039)((ctxSize)=>customizeSize ?? compactSize ?? groupSize ?? ctxSize);
    const iconType = innerLoading ? "loading" : icon;
    const mergedIconPlacement = iconPlacement ?? iconPosition ?? "start";
    const linkButtonRestProps = (0, $e8c5093aebad6025$export$2e2bcd8739ae039)(rest, [
        "navigate"
    ]);
    // =========== Merged Props for Semantic ===========
    const mergedProps = {
        ...props,
        type: mergedType,
        color: mergedColor,
        variant: mergedVariant,
        danger: isDanger,
        shape: mergedShape,
        size: sizeFullName,
        disabled: mergedDisabled,
        loading: innerLoading,
        iconPlacement: mergedIconPlacement
    };
    // ========================= Style ==========================
    const contextStyleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $30c5f9f911d4f61b$export$648566b068f28737)([
        _skipSemantic ? undefined : contextClassNames,
        classNames
    ], [
        _skipSemantic ? undefined : contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: mergedProps
    });
    // ========================= Render =========================
    const classes = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, hashId, cssVarCls, {
        [`${prefixCls}-${mergedShape}`]: mergedShape !== "default" && mergedShape !== "square" && mergedShape,
        // Compatible with versions earlier than 5.21.0
        [`${prefixCls}-${mergedType}`]: mergedType,
        [`${prefixCls}-dangerous`]: danger,
        [`${prefixCls}-color-${mergedColorText}`]: mergedColorText,
        [`${prefixCls}-variant-${mergedVariant}`]: mergedVariant,
        [`${prefixCls}-lg`]: sizeFullName === "large",
        [`${prefixCls}-sm`]: sizeFullName === "small",
        [`${prefixCls}-icon-only`]: !children && children !== 0 && !!iconType,
        [`${prefixCls}-background-ghost`]: ghost && !(0, $62e55ded4111e367$export$b120bc11c0d9c214)(mergedVariant),
        [`${prefixCls}-loading`]: innerLoading,
        [`${prefixCls}-two-chinese-chars`]: hasTwoCNChar && mergedInsertSpace && !innerLoading,
        [`${prefixCls}-block`]: block,
        [`${prefixCls}-rtl`]: direction === "rtl",
        [`${prefixCls}-icon-end`]: mergedIconPlacement === "end"
    }, compactItemClassnames, className, rootClassName, contextClassName, mergedClassNames.root);
    const iconSharedProps = {
        className: mergedClassNames.icon,
        style: mergedStyles.icon
    };
    /**
   * Extract icon node
   * If there is a custom icon and not in loading state: show custom icon
   */ const iconWrapperElement = (child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $912e7d9c7a8e3cf2$export$2e2bcd8739ae039), {
            prefixCls: prefixCls,
            ...iconSharedProps
        }, child);
    const defaultLoadingIconElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $44c2f8faf8741e4b$export$2e2bcd8739ae039), {
        existIcon: !!icon,
        prefixCls: prefixCls,
        loading: innerLoading,
        mount: isMountRef.current,
        ...iconSharedProps
    });
    const mergedLoadingIcon = (0, $8e2d153a3c855782$export$53b83ca8eaab0383)(loading) ? loading.icon || contextLoadingIcon : contextLoadingIcon;
    /**
   * Using if-else statements can improve code readability without affecting future expansion.
   */ let iconNode;
    if (icon && !innerLoading) iconNode = iconWrapperElement(icon);
    else if (loading && mergedLoadingIcon) iconNode = iconWrapperElement(mergedLoadingIcon);
    else iconNode = defaultLoadingIconElement;
    const contentNode = (0, $8e2d153a3c855782$export$72280d5f896dac9a)(children) ? (0, $62e55ded4111e367$export$b6ee00a7e7908bc)(children, needInserted && mergedInsertSpace, mergedStyles.content, mergedClassNames.content) : null;
    if (linkButtonRestProps.href !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("a", {
        ...linkButtonRestProps,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(classes, {
            [`${prefixCls}-disabled`]: mergedDisabled
        }),
        href: mergedDisabled ? undefined : linkButtonRestProps.href,
        style: mergedStyles.root,
        onClick: handleClick,
        ref: mergedRef,
        tabIndex: mergedDisabled ? -1 : 0,
        "aria-disabled": mergedDisabled
    }, iconNode, contentNode);
    let buttonNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("button", {
        ...rest,
        type: htmlType,
        className: classes,
        style: mergedStyles.root,
        onClick: handleClick,
        disabled: mergedDisabled,
        ref: mergedRef
    }, iconNode, contentNode, compactItemClassnames && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $b4e423ef9f4273a8$export$2e2bcd8739ae039), {
        prefixCls: prefixCls
    }));
    if (!(0, $62e55ded4111e367$export$b120bc11c0d9c214)(mergedVariant)) buttonNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $02f5adbd0068e010$export$2e2bcd8739ae039), {
        component: "Button",
        disabled: innerLoading
    }, buttonNode);
    return buttonNode;
});
const $1fc505710073cde5$var$Button = $1fc505710073cde5$var$InternalCompoundedButton;
$1fc505710073cde5$var$Button.Group = (0, $f9eeaefe4fcb3479$export$2e2bcd8739ae039);
$1fc505710073cde5$var$Button.__ANT_BUTTON = true;
var $1fc505710073cde5$export$2e2bcd8739ae039 = $1fc505710073cde5$var$Button;



"use client";
var $2d1c32fbb5b444a6$export$2e2bcd8739ae039 = (0, $1fc505710073cde5$export$2e2bcd8739ae039);


class $c4ecd91a3fcb0ac8$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    componentDidCatch(error, info) {
        // No remote error reporting is configured; log for local debugging.
        console.error("ErrorBoundary caught an error:", error, info);
    }
    handleReload = ()=>{
        window.location.reload();
    };
    render() {
        if (!this.state.hasError) return this.props.children;
        return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
            style: {
                padding: "48px 24px",
                textAlign: "center",
                maxWidth: 480,
                margin: "40px auto"
            },
            children: [
                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                    style: {
                        fontSize: 48,
                        lineHeight: 1,
                        marginBottom: 16
                    },
                    children: "\u26A0\uFE0F"
                }),
                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("h3", {
                    style: {
                        marginBottom: 8
                    },
                    children: "Something went wrong"
                }),
                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("p", {
                    style: {
                        color: "#666",
                        marginBottom: 24
                    },
                    children: "This page ran into an unexpected error. Reload to try again, or use the menu to open another page."
                }),
                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                    type: "primary",
                    onClick: this.handleReload,
                    children: "Reload"
                })
            ]
        });
    }
}


const $67f64b78c4102acd$var$STATE = "state";
const $67f64b78c4102acd$export$ea32cbdd559da174 = ()=>{
    try {
        const serializedState = localStorage.getItem($67f64b78c4102acd$var$STATE);
        if (serializedState === null) return undefined;
        return JSON.parse(serializedState);
    } catch (error) {
        return undefined;
    }
};
const $67f64b78c4102acd$export$fb931cd598921492 = (state)=>{
    try {
        const serializedState = JSON.stringify(state);
        localStorage.setItem($67f64b78c4102acd$var$STATE, serializedState);
    } catch (error) {
        console.error("State wasn't saved");
    }
};


function $279f0bce2b66583f$export$2e2bcd8739ae039(obj) {
    "@babel/helpers - typeof";
    return $279f0bce2b66583f$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $279f0bce2b66583f$export$2e2bcd8739ae039(obj);
}



function $1eb315a3e85df336$export$2e2bcd8739ae039(input, hint) {
    if ((0, $279f0bce2b66583f$export$2e2bcd8739ae039)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $279f0bce2b66583f$export$2e2bcd8739ae039)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}


function $b2a8793059ad009b$export$2e2bcd8739ae039(arg) {
    var key = (0, $1eb315a3e85df336$export$2e2bcd8739ae039)(arg, "string");
    return (0, $279f0bce2b66583f$export$2e2bcd8739ae039)(key) === "symbol" ? key : String(key);
}


function $4add5f495020d673$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $b2a8793059ad009b$export$2e2bcd8739ae039)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $770d56936c203dc9$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $770d56936c203dc9$export$2e2bcd8739ae039(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $770d56936c203dc9$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $4add5f495020d673$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $770d56936c203dc9$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $3ea067e0471763f5$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + "use the non-minified dev environment for full errors. ";
}
// Inlined version of the `symbol-observable` polyfill
var $3ea067e0471763f5$var$$$observable = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $3ea067e0471763f5$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $3ea067e0471763f5$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $3ea067e0471763f5$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $3ea067e0471763f5$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $3ea067e0471763f5$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $3ea067e0471763f5$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $3ea067e0471763f5$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($3ea067e0471763f5$var$isDate(val)) return "date";
    if ($3ea067e0471763f5$var$isError(val)) return "error";
    var constructorName = $3ea067e0471763f5$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $3ea067e0471763f5$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $3ea067e0471763f5$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $3ea067e0471763f5$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $3ea067e0471763f5$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $3ea067e0471763f5$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($3ea067e0471763f5$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($3ea067e0471763f5$var$formatProdErrorMessage(1));
        return enhancer($3ea067e0471763f5$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") throw new Error($3ea067e0471763f5$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($3ea067e0471763f5$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($3ea067e0471763f5$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($3ea067e0471763f5$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($3ea067e0471763f5$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$3ea067e0471763f5$var$isPlainObject(action)) throw new Error($3ea067e0471763f5$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($3ea067e0471763f5$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($3ea067e0471763f5$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($3ea067e0471763f5$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $3ea067e0471763f5$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($3ea067e0471763f5$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$3ea067e0471763f5$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $3ea067e0471763f5$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$3ea067e0471763f5$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $3ea067e0471763f5$export$8928921ea2d3b126 = $3ea067e0471763f5$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $3ea067e0471763f5$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $3ea067e0471763f5$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $3ea067e0471763f5$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$3ea067e0471763f5$var$isPlainObject(inputState)) return "The " + argumentName + ' has unexpected type of "' + $3ea067e0471763f5$var$kindOf(inputState) + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $3ea067e0471763f5$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function $3ea067e0471763f5$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $3ea067e0471763f5$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($3ea067e0471763f5$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $3ea067e0471763f5$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($3ea067e0471763f5$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $3ea067e0471763f5$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $3ea067e0471763f5$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error($3ea067e0471763f5$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $3ea067e0471763f5$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $3ea067e0471763f5$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $3ea067e0471763f5$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($3ea067e0471763f5$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $3ea067e0471763f5$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $3ea067e0471763f5$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $3ea067e0471763f5$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($3ea067e0471763f5$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $3ea067e0471763f5$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $770d56936c203dc9$export$2e2bcd8739ae039)((0, $770d56936c203dc9$export$2e2bcd8739ae039)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}


var $84dc5bf6a82842e2$export$1e511d4a378977f5;
var $84dc5bf6a82842e2$export$d32324a03b6bde1b;
var $84dc5bf6a82842e2$export$321b1ffcca858b2b;
"use strict";

var $84dc5bf6a82842e2$require$compose = $3ea067e0471763f5$export$f672e0b6f7222cd7;
$84dc5bf6a82842e2$export$1e511d4a378977f5 = true;
$84dc5bf6a82842e2$export$d32324a03b6bde1b = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return undefined;
    if (typeof arguments[0] === "object") return $84dc5bf6a82842e2$require$compose;
    return $84dc5bf6a82842e2$require$compose.apply(null, arguments);
};
$84dc5bf6a82842e2$export$321b1ffcca858b2b = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop) {
        return noop;
    };
};


/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */ function $4db2afaa32fd3fcb$var$createThunkMiddleware(extraArgument) {
    // Standard Redux middleware definition pattern:
    // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
    var middleware = function middleware(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                // The thunk middleware looks for any functions that were passed to `store.dispatch`.
                // If this "action" is really a function, call it and return the result.
                if (typeof action === "function") // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
                return action(dispatch, getState, extraArgument);
                 // Otherwise, pass the action down the middleware chain as usual
                return next(action);
            };
        };
    };
    return middleware;
}
var $4db2afaa32fd3fcb$var$thunk = $4db2afaa32fd3fcb$var$createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks
$4db2afaa32fd3fcb$var$thunk.withExtraArgument = $4db2afaa32fd3fcb$var$createThunkMiddleware;
var $4db2afaa32fd3fcb$export$2e2bcd8739ae039 = $4db2afaa32fd3fcb$var$thunk;


const $7e11c65b70d794b3$export$1fa6c04dd35d59ff = {
    LOGIN: "LOGIN",
    REGISTER: "REGISTER",
    LOGOUT: "LOGOUT",
    UPDATE_ME: "UPDATE_ME"
};
const $7e11c65b70d794b3$export$d4c72bab9d6cc13a = {
    me: undefined
};


const $e9ab468ed108e06a$var$inText = (translate, localization)=>(module)=>(key)=>translate[module][key] && translate[module][key][localization] || key;
const $e9ab468ed108e06a$export$1650419e431d3ba3 = (state = (0, $7e11c65b70d794b3$export$d4c72bab9d6cc13a), action)=>{
    const itf = state && state.translate ? $e9ab468ed108e06a$var$inText(state.translate, state.localization) : ()=>()=>"";
    state = Object.assign({}, state, {
        inText: itf
    });
    switch(action.type){
        case (0, $7e11c65b70d794b3$export$1fa6c04dd35d59ff).LOGIN:
            window.location.replace("/");
            return Object.assign({}, state, {
                me: action.body
            });
        case (0, $7e11c65b70d794b3$export$1fa6c04dd35d59ff).REGISTER:
            window.location.replace("/");
            return Object.assign({}, state, {
                me: action.body
            });
        case (0, $7e11c65b70d794b3$export$1fa6c04dd35d59ff).LOGOUT:
            window.location.replace("/login");
            window.location.reload(true);
            localStorage.getItem("visitCurrentPage") && localStorage.removeItem("visitCurrentPage");
            localStorage.getItem("visitCurrentFilter") && localStorage.removeItem("visitCurrentFilter");
            return Object.assign({}, state, {
                me: null
            });
        case (0, $7e11c65b70d794b3$export$1fa6c04dd35d59ff).UPDATE_ME:
            return Object.assign({}, state, {
                me: action.body
            });
        default:
            return state;
    }
};



function $81aca8a46f6ecb51$export$6fec604aa7293d0c() {
    const persistedState = (0, $67f64b78c4102acd$export$ea32cbdd559da174)();
    const store = (0, $3ea067e0471763f5$export$f51a9068ac82ea43)((0, $e9ab468ed108e06a$export$1650419e431d3ba3), persistedState, (0, $84dc5bf6a82842e2$export$d32324a03b6bde1b)((0, $3ea067e0471763f5$export$9ff26e0402cc7b7)((0, $4db2afaa32fd3fcb$export$2e2bcd8739ae039))));
    if (null) null.accept("../reducers", ()=>{
        store.replaceReducer((0, $e9ab468ed108e06a$export$1650419e431d3ba3));
    });
    return store;
}



parcelRequire("cQmXV");



var $cQmXV = parcelRequire("cQmXV");



var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");
// export this package's api



var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");
const $fdaf04adbcfc0541$var$DrawerContext = /*#__PURE__*/ $cQmXV.createContext(null);
const $fdaf04adbcfc0541$export$ee4e38b469b6f5d1 = /*#__PURE__*/ $cQmXV.createContext({});
var $fdaf04adbcfc0541$export$2e2bcd8739ae039 = $fdaf04adbcfc0541$var$DrawerContext;






var $cQmXV = parcelRequire("cQmXV");



var $cQmXV = parcelRequire("cQmXV");



function $5ea4e864fa354b6c$var$_extends() {
    $5ea4e864fa354b6c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5ea4e864fa354b6c$var$_extends.apply(this, arguments);
}
const $5ea4e864fa354b6c$var$DrawerPanel = (props)=>{
    const { prefixCls: prefixCls, className: className, containerRef: containerRef, ...restProps } = props;
    const { panel: panelRef } = $cQmXV.useContext((0, $fdaf04adbcfc0541$export$ee4e38b469b6f5d1));
    const mergedRef = (0, $10341b937b26f69d$export$1d1c999670a1285d)(panelRef, containerRef);
    // =============================== Render ===============================
    return /*#__PURE__*/ $cQmXV.createElement("div", $5ea4e864fa354b6c$var$_extends({
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-section`, className),
        role: "dialog",
        ref: mergedRef
    }, (0, $4b5c733d1d7bb306$export$2e2bcd8739ae039)(props, {
        aria: true
    }), {
        "aria-modal": "true"
    }, restProps));
};
var $5ea4e864fa354b6c$export$2e2bcd8739ae039 = $5ea4e864fa354b6c$var$DrawerPanel;



var $cQmXV = parcelRequire("cQmXV");


function $f2b8cf22f243fe25$export$2e2bcd8739ae039(options) {
    const { prefixCls: prefixCls, direction: direction, className: className, style: style, maxSize: maxSize, containerRef: containerRef, currentSize: currentSize, onResize: onResize, onResizeEnd: onResizeEnd, onResizeStart: onResizeStart } = options;
    const [isDragging, setIsDragging] = $cQmXV.useState(false);
    const [startPos, setStartPos] = $cQmXV.useState(0);
    const [startSize, setStartSize] = $cQmXV.useState(0);
    const isHorizontal = direction === "left" || direction === "right";
    const handleMouseDown = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((e)=>{
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(true);
        if (isHorizontal) setStartPos(e.clientX);
        else setStartPos(e.clientY);
        // Use provided currentSize, or fallback to container size
        let startSize;
        if (typeof currentSize === "number") startSize = currentSize;
        else if (containerRef?.current) {
            const rect = containerRef.current.getBoundingClientRect();
            startSize = isHorizontal ? rect.width : rect.height;
        }
        setStartSize(startSize);
        onResizeStart?.(startSize);
    });
    const handleMouseMove = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((e)=>{
        if (!isDragging) return;
        const currentPos = isHorizontal ? e.clientX : e.clientY;
        let delta = currentPos - startPos;
        // Adjust delta direction based on placement
        if (direction === "right" || direction === "bottom") delta = -delta;
        let newSize = startSize + delta;
        // Apply min/max size limits
        if (newSize < 0) newSize = 0;
        // Only apply maxSize if it's a valid positive number
        if (maxSize && newSize > maxSize) newSize = maxSize;
        onResize?.(newSize);
    });
    const handleMouseUp = $cQmXV.useCallback(()=>{
        if (isDragging) {
            setIsDragging(false);
            // Get the final size after resize
            if (containerRef?.current) {
                const rect = containerRef.current.getBoundingClientRect();
                const finalSize = isHorizontal ? rect.width : rect.height;
                onResizeEnd?.(finalSize);
            }
        }
    }, [
        isDragging,
        containerRef,
        onResizeEnd,
        isHorizontal
    ]);
    $cQmXV.useEffect(()=>{
        if (isDragging) {
            document.addEventListener("mousemove", handleMouseMove);
            document.addEventListener("mouseup", handleMouseUp);
            return ()=>{
                document.removeEventListener("mousemove", handleMouseMove);
                document.removeEventListener("mouseup", handleMouseUp);
            };
        }
    }, [
        isDragging,
        handleMouseMove,
        handleMouseUp
    ]);
    const dragElementClassName = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-dragger`, `${prefixCls}-dragger-${direction}`, {
        [`${prefixCls}-dragger-dragging`]: isDragging,
        [`${prefixCls}-dragger-horizontal`]: isHorizontal,
        [`${prefixCls}-dragger-vertical`]: !isHorizontal
    }, className);
    return {
        dragElementProps: {
            className: dragElementClassName,
            style: style,
            onMouseDown: handleMouseDown
        },
        isDragging: isDragging
    };
}




function $3fd0bd52909c79d0$export$efeadb1af96d0a6d(value) {
    if (typeof value === "string") {
        const num = Number(value.replace(/px$/i, ""));
        const floatNum = parseFloat(value);
        if (floatNum === num) (0, $26d7cf6379fe7659$export$2e2bcd8739ae039)(false, "Invalid value type of `width` or `height` which should be number type instead.");
        if (!Number.isNaN(num)) return num;
    }
    return value;
}
function $3fd0bd52909c79d0$export$e77176dc71180add(props) {
    (0, $26d7cf6379fe7659$export$2e2bcd8739ae039)(!("wrapperClassName" in props), `'wrapperClassName' is removed. Please use 'rootClassName' instead.`);
    (0, $26d7cf6379fe7659$export$2e2bcd8739ae039)((0, $78361969822ad097$export$2e2bcd8739ae039)() || !props.open, `Drawer with 'open' in SSR is not work since no place to createPortal. Please move to 'useEffect' instead.`);
}




var $cQmXV = parcelRequire("cQmXV");

function $4f235c6d6fcfc5fc$export$2e2bcd8739ae039(getContainer, open, autoFocus, focusTrap, mask) {
    const mergedFocusTrap = focusTrap ?? mask !== false;
    // Focus lock
    const [ignoreElement] = (0, $7aa1eaa901116c60$export$9e3bf6f439c42dc9)(open && mergedFocusTrap, getContainer);
    // Auto Focus
    (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useEffect(()=>{
        if (open && autoFocus === true) getContainer()?.focus({
            preventScroll: true
        });
    }, [
        open
    ]);
    return ignoreElement;
}


function $ecbbf85226829608$var$_extends() {
    $ecbbf85226829608$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ecbbf85226829608$var$_extends.apply(this, arguments);
}
const $ecbbf85226829608$var$DrawerPopup = (props, ref)=>{
    const { prefixCls: prefixCls, open: open, placement: placement, inline: inline, push: push, forceRender: forceRender, autoFocus: // Focus
    autoFocus, focusTrap: focusTrap, // classNames
    classNames: drawerClassNames, rootClassName: // Root
    rootClassName, rootStyle: rootStyle, zIndex: zIndex, className: // Drawer
    className, id: id, style: style, motion: motion, width: width, height: height, size: size, maxSize: maxSize, children: children, mask: // Mask
    mask, maskClosable: maskClosable, maskMotion: maskMotion, maskClassName: maskClassName, maskStyle: maskStyle, afterOpenChange: // Events
    afterOpenChange, onClose: onClose, onMouseEnter: onMouseEnter, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave, onClick: onClick, onKeyDown: onKeyDown, onKeyUp: onKeyUp, styles: styles, drawerRender: drawerRender, resizable: resizable, defaultSize: defaultSize } = props;
    // ================================ Refs ================================
    const panelRef = $cQmXV.useRef(null);
    $cQmXV.useImperativeHandle(ref, ()=>panelRef.current);
    // ========================= Focusable ==========================
    const ignoreElement = (0, $4f235c6d6fcfc5fc$export$2e2bcd8739ae039)(()=>panelRef.current, open, autoFocus, focusTrap, mask);
    // ============================ Push ============================
    const [pushed, setPushed] = $cQmXV.useState(false);
    const parentContext = $cQmXV.useContext((0, $fdaf04adbcfc0541$export$2e2bcd8739ae039));
    // Merge push distance
    let pushConfig;
    if (typeof push === "boolean") pushConfig = push ? {} : {
        distance: 0
    };
    else pushConfig = push || {};
    const pushDistance = pushConfig?.distance ?? parentContext?.pushDistance ?? 180;
    const mergedContext = $cQmXV.useMemo(()=>({
            pushDistance: pushDistance,
            push: ()=>{
                setPushed(true);
            },
            pull: ()=>{
                setPushed(false);
            }
        }), [
        pushDistance
    ]);
    // ========================= ScrollLock =========================
    // Tell parent to push
    $cQmXV.useEffect(()=>{
        if (open) parentContext?.push?.();
        else parentContext?.pull?.();
    }, [
        open
    ]);
    // Clean up
    $cQmXV.useEffect(()=>()=>{
            parentContext?.pull?.();
        }, []);
    // ============================ Mask ============================
    const maskNode = /*#__PURE__*/ $cQmXV.createElement((0, $04c53b89814950f8$export$2e2bcd8739ae039), $ecbbf85226829608$var$_extends({
        key: "mask"
    }, maskMotion, {
        visible: mask && open
    }), ({ className: motionMaskClassName, style: motionMaskStyle }, maskRef)=>/*#__PURE__*/ $cQmXV.createElement("div", {
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-mask`, motionMaskClassName, drawerClassNames?.mask, maskClassName),
            style: {
                ...motionMaskStyle,
                ...maskStyle,
                ...styles?.mask
            },
            onClick: maskClosable && open ? onClose : undefined,
            ref: maskRef
        }));
    // =========================== Panel ============================
    const motionProps = typeof motion === "function" ? motion(placement) : motion;
    // ============================ Size ============================
    const [currentSize, setCurrentSize] = $cQmXV.useState();
    const isHorizontal = placement === "left" || placement === "right";
    // Aggregate size logic with backward compatibility using useMemo
    const mergedSize = $cQmXV.useMemo(()=>{
        const legacySize = isHorizontal ? width : height;
        const nextMergedSize = size ?? legacySize ?? currentSize ?? defaultSize ?? (isHorizontal ? 378 : undefined);
        return (0, $3fd0bd52909c79d0$export$efeadb1af96d0a6d)(nextMergedSize);
    }, [
        size,
        width,
        height,
        defaultSize,
        isHorizontal,
        currentSize
    ]);
    // >>> Style
    const wrapperStyle = $cQmXV.useMemo(()=>{
        const nextWrapperStyle = {};
        if (pushed && pushDistance) switch(placement){
            case "top":
                nextWrapperStyle.transform = `translateY(${pushDistance}px)`;
                break;
            case "bottom":
                nextWrapperStyle.transform = `translateY(${-pushDistance}px)`;
                break;
            case "left":
                nextWrapperStyle.transform = `translateX(${pushDistance}px)`;
                break;
            default:
                nextWrapperStyle.transform = `translateX(${-pushDistance}px)`;
                break;
        }
        if (isHorizontal) nextWrapperStyle.width = (0, $3fd0bd52909c79d0$export$efeadb1af96d0a6d)(mergedSize);
        else nextWrapperStyle.height = (0, $3fd0bd52909c79d0$export$efeadb1af96d0a6d)(mergedSize);
        return nextWrapperStyle;
    }, [
        pushed,
        pushDistance,
        placement,
        isHorizontal,
        mergedSize
    ]);
    // =========================== Resize ===========================
    const wrapperRef = $cQmXV.useRef(null);
    const isResizable = !!resizable;
    const resizeConfig = typeof resizable === "object" && resizable || {};
    const onInternalResize = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((size)=>{
        setCurrentSize(size);
        resizeConfig.onResize?.(size);
    });
    const { dragElementProps: dragElementProps, isDragging: isDragging } = (0, $f2b8cf22f243fe25$export$2e2bcd8739ae039)({
        prefixCls: `${prefixCls}-resizable`,
        direction: placement,
        className: drawerClassNames?.dragger,
        style: styles?.dragger,
        maxSize: maxSize,
        containerRef: wrapperRef,
        currentSize: mergedSize,
        onResize: onInternalResize,
        onResizeStart: resizeConfig.onResizeStart,
        onResizeEnd: resizeConfig.onResizeEnd
    });
    // =========================== Events ===========================
    const eventHandlers = {
        onMouseEnter: onMouseEnter,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave,
        onClick: onClick,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onFocus: (e)=>{
            ignoreElement(e.target);
        }
    };
    // =========================== Render ==========================
    // >>>>> Panel
    const panelNode = /*#__PURE__*/ $cQmXV.createElement((0, $04c53b89814950f8$export$2e2bcd8739ae039), $ecbbf85226829608$var$_extends({
        key: "panel"
    }, motionProps, {
        visible: open,
        forceRender: forceRender,
        onVisibleChanged: afterOpenChange,
        removeOnLeave: false,
        leavedClassName: `${prefixCls}-content-wrapper-hidden`
    }), ({ className: motionClassName, style: motionStyle }, motionRef)=>{
        const content = /*#__PURE__*/ $cQmXV.createElement((0, $5ea4e864fa354b6c$export$2e2bcd8739ae039), $ecbbf85226829608$var$_extends({
            id: id,
            containerRef: motionRef,
            prefixCls: prefixCls,
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(className, drawerClassNames?.section),
            style: {
                ...style,
                ...styles?.section
            }
        }, (0, $4b5c733d1d7bb306$export$2e2bcd8739ae039)(props, {
            aria: true
        }), eventHandlers), children);
        return /*#__PURE__*/ $cQmXV.createElement("div", $ecbbf85226829608$var$_extends({
            ref: wrapperRef,
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-content-wrapper`, isDragging && `${prefixCls}-content-wrapper-dragging`, drawerClassNames?.wrapper, !isDragging && motionClassName),
            style: {
                ...motionStyle,
                ...wrapperStyle,
                ...styles?.wrapper
            }
        }, (0, $4b5c733d1d7bb306$export$2e2bcd8739ae039)(props, {
            data: true
        })), isResizable && /*#__PURE__*/ $cQmXV.createElement("div", dragElementProps), drawerRender ? drawerRender(content) : content);
    });
    // >>>>> Container
    const containerStyle = {
        ...rootStyle
    };
    if (zIndex) containerStyle.zIndex = zIndex;
    return /*#__PURE__*/ $cQmXV.createElement((0, $fdaf04adbcfc0541$export$2e2bcd8739ae039).Provider, {
        value: mergedContext
    }, /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-${placement}`, rootClassName, {
            [`${prefixCls}-open`]: open,
            [`${prefixCls}-inline`]: inline
        }),
        style: containerStyle,
        tabIndex: -1,
        ref: panelRef
    }, maskNode, panelNode));
};
const $ecbbf85226829608$var$RefDrawerPopup = /*#__PURE__*/ $cQmXV.forwardRef($ecbbf85226829608$var$DrawerPopup);
var $ecbbf85226829608$export$2e2bcd8739ae039 = $ecbbf85226829608$var$RefDrawerPopup;



const $c09f6ab7471b0f6d$var$Drawer = (props)=>{
    const { open: open = false, prefixCls: prefixCls = "rc-drawer", placement: placement = "right", autoFocus: autoFocus = true, keyboard: keyboard = true, width: width, height: height, size: size, maxSize: maxSize, mask: mask = true, maskClosable: maskClosable = true, getContainer: getContainer, forceRender: forceRender, afterOpenChange: afterOpenChange, destroyOnHidden: destroyOnHidden, onMouseEnter: onMouseEnter, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave, onClick: onClick, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onClose: onClose, resizable: resizable, defaultSize: defaultSize, focusTriggerAfterClose: focusTriggerAfterClose, panelRef: // Refs
    panelRef } = props;
    const [animatedVisible, setAnimatedVisible] = $cQmXV.useState(false);
    // ============================= Open =============================
    const [mounted, setMounted] = $cQmXV.useState(false);
    (0, $7673d874dab69d07$export$2e2bcd8739ae039)(()=>{
        setMounted(true);
    }, []);
    const mergedOpen = mounted ? open : false;
    // ============================ Focus =============================
    const popupRef = $cQmXV.useRef(null);
    const lastActiveRef = $cQmXV.useRef(null);
    (0, $7673d874dab69d07$export$2e2bcd8739ae039)(()=>{
        if (mergedOpen) lastActiveRef.current = document.activeElement;
    }, [
        mergedOpen
    ]);
    // ============================= Open =============================
    const internalAfterOpenChange = (nextVisible)=>{
        setAnimatedVisible(nextVisible);
        afterOpenChange?.(nextVisible);
        if (!nextVisible && focusTriggerAfterClose !== false && lastActiveRef.current && !popupRef.current?.contains(lastActiveRef.current)) lastActiveRef.current?.focus({
            preventScroll: true
        });
    };
    // =========================== Context ============================
    const refContext = $cQmXV.useMemo(()=>({
            panel: panelRef
        }), [
        panelRef
    ]);
    // ============================ Render ============================
    if (!forceRender && !animatedVisible && !mergedOpen && destroyOnHidden) return null;
    const eventHandlers = {
        onMouseEnter: onMouseEnter,
        onMouseOver: onMouseOver,
        onMouseLeave: onMouseLeave,
        onClick: onClick,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp
    };
    const drawerPopupProps = {
        ...props,
        open: mergedOpen,
        prefixCls: prefixCls,
        placement: placement,
        autoFocus: autoFocus,
        keyboard: keyboard,
        width: width,
        height: height,
        size: size,
        maxSize: maxSize,
        defaultSize: defaultSize,
        mask: mask,
        maskClosable: maskClosable,
        inline: getContainer === false,
        afterOpenChange: internalAfterOpenChange,
        ref: popupRef,
        resizable: resizable,
        ...eventHandlers
    };
    const onEsc = ({ top: top, event: event })=>{
        if (top && keyboard) {
            event.stopPropagation();
            onClose?.(event);
        }
    };
    return /*#__PURE__*/ $cQmXV.createElement((0, $fdaf04adbcfc0541$export$ee4e38b469b6f5d1).Provider, {
        value: refContext
    }, /*#__PURE__*/ $cQmXV.createElement((0, $aa72a6fdf7676c76$export$2e2bcd8739ae039), {
        open: mergedOpen || forceRender || animatedVisible,
        autoDestroy: false,
        getContainer: getContainer,
        autoLock: mask && (mergedOpen || animatedVisible),
        onEsc: onEsc
    }, /*#__PURE__*/ $cQmXV.createElement((0, $ecbbf85226829608$export$2e2bcd8739ae039), drawerPopupProps)));
};
var $c09f6ab7471b0f6d$export$2e2bcd8739ae039 = $c09f6ab7471b0f6d$var$Drawer;


var $d7a68e565aac79e7$export$2e2bcd8739ae039 = (0, $c09f6ab7471b0f6d$export$2e2bcd8739ae039);





var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");


var $cQmXV = parcelRequire("cQmXV");


var $cQmXV = parcelRequire("cQmXV");
const $7b2f48a2d7a9ccda$export$24829b7c0e49e9f7 = "RC_FORM_INTERNAL_HOOKS";
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7b2f48a2d7a9ccda$var$warningFunc = ()=>{
    (0, $26d7cf6379fe7659$export$2e2bcd8739ae039)(false, "Can not find FormContext. Please make sure you wrap Field under Form.");
};
const $7b2f48a2d7a9ccda$var$Context = /*#__PURE__*/ $cQmXV.createContext({
    getFieldValue: $7b2f48a2d7a9ccda$var$warningFunc,
    getFieldsValue: $7b2f48a2d7a9ccda$var$warningFunc,
    getFieldError: $7b2f48a2d7a9ccda$var$warningFunc,
    getFieldWarning: $7b2f48a2d7a9ccda$var$warningFunc,
    getFieldsError: $7b2f48a2d7a9ccda$var$warningFunc,
    isFieldsTouched: $7b2f48a2d7a9ccda$var$warningFunc,
    isFieldTouched: $7b2f48a2d7a9ccda$var$warningFunc,
    isFieldValidating: $7b2f48a2d7a9ccda$var$warningFunc,
    isFieldsValidating: $7b2f48a2d7a9ccda$var$warningFunc,
    resetFields: $7b2f48a2d7a9ccda$var$warningFunc,
    setFields: $7b2f48a2d7a9ccda$var$warningFunc,
    setFieldValue: $7b2f48a2d7a9ccda$var$warningFunc,
    setFieldsValue: $7b2f48a2d7a9ccda$var$warningFunc,
    validateFields: $7b2f48a2d7a9ccda$var$warningFunc,
    submit: $7b2f48a2d7a9ccda$var$warningFunc,
    getInternalHooks: ()=>{
        $7b2f48a2d7a9ccda$var$warningFunc();
        return {
            dispatch: $7b2f48a2d7a9ccda$var$warningFunc,
            initEntityValue: $7b2f48a2d7a9ccda$var$warningFunc,
            registerField: $7b2f48a2d7a9ccda$var$warningFunc,
            useSubscribe: $7b2f48a2d7a9ccda$var$warningFunc,
            setInitialValues: $7b2f48a2d7a9ccda$var$warningFunc,
            destroyForm: $7b2f48a2d7a9ccda$var$warningFunc,
            setCallbacks: $7b2f48a2d7a9ccda$var$warningFunc,
            registerWatch: $7b2f48a2d7a9ccda$var$warningFunc,
            getFields: $7b2f48a2d7a9ccda$var$warningFunc,
            setValidateMessages: $7b2f48a2d7a9ccda$var$warningFunc,
            setPreserve: $7b2f48a2d7a9ccda$var$warningFunc,
            getInitialValue: $7b2f48a2d7a9ccda$var$warningFunc
        };
    }
});
var $7b2f48a2d7a9ccda$export$2e2bcd8739ae039 = $7b2f48a2d7a9ccda$var$Context;



var $cQmXV = parcelRequire("cQmXV");
const $e8f8acdce8879be3$var$ListContext = /*#__PURE__*/ $cQmXV.createContext(null);
var $e8f8acdce8879be3$export$2e2bcd8739ae039 = $e8f8acdce8879be3$var$ListContext;


function $95fac96d9e2bedd3$export$45b10814cc054894(value) {
    if (value === undefined || value === null) return [];
    return Array.isArray(value) ? value : [
        value
    ];
}
function $95fac96d9e2bedd3$export$717b316e73068e8d(form) {
    return form && !!form._init;
}


function $7d8078becc471b7a$export$f77fd0c3b25d8534() {
    return {
        default: "Validation error on field %s",
        required: "%s is required",
        enum: "%s must be one of %s",
        whitespace: "%s cannot be empty",
        date: {
            format: "%s date %s is invalid for format %s",
            parse: "%s date could not be parsed, %s is invalid ",
            invalid: "%s date %s is invalid"
        },
        types: {
            string: "%s is not a %s",
            method: "%s is not a %s (function)",
            array: "%s is not an %s",
            object: "%s is not an %s",
            number: "%s is not a %s",
            date: "%s is not a %s",
            boolean: "%s is not a %s",
            integer: "%s is not an %s",
            float: "%s is not a %s",
            regexp: "%s is not a valid %s",
            email: "%s is not a valid %s",
            tel: "%s is not a valid %s",
            url: "%s is not a valid %s",
            hex: "%s is not a valid %s"
        },
        string: {
            len: "%s must be exactly %s characters",
            min: "%s must be at least %s characters",
            max: "%s cannot be longer than %s characters",
            range: "%s must be between %s and %s characters"
        },
        number: {
            len: "%s must equal %s",
            min: "%s cannot be less than %s",
            max: "%s cannot be greater than %s",
            range: "%s must be between %s and %s"
        },
        array: {
            len: "%s must be exactly %s in length",
            min: "%s cannot be less than %s in length",
            max: "%s cannot be greater than %s in length",
            range: "%s must be between %s and %s in length"
        },
        pattern: {
            mismatch: "%s value %s does not match pattern %s"
        },
        clone () {
            const cloned = JSON.parse(JSON.stringify(this));
            cloned.clone = this.clone;
            return cloned;
        }
    };
}
const $7d8078becc471b7a$export$defe85febe8b728c = $7d8078becc471b7a$export$f77fd0c3b25d8534();


/* eslint no-console:0 */ 
var $4dBQg = parcelRequire("4dBQg");
const $58b5f17b6e7baa87$var$formatRegExp = /%[sdj%]/g;
let $58b5f17b6e7baa87$export$491112666e282270 = ()=>{};
// don't print warning message when in production env or node runtime
typeof $4dBQg !== "undefined" && $4dBQg.env;
var $58b5f17b6e7baa87$var$type, $58b5f17b6e7baa87$var$errors, $58b5f17b6e7baa87$var$e;
function $58b5f17b6e7baa87$export$e85887f5ceeacced(errors) {
    if (!errors || !errors.length) return null;
    const fields = {};
    errors.forEach((error)=>{
        const field = error.field;
        fields[field] = fields[field] || [];
        fields[field].push(error);
    });
    return fields;
}
function $58b5f17b6e7baa87$export$d9468344d3651243(template, ...args) {
    let i = 0;
    const len = args.length;
    if (typeof template === "function") // eslint-disable-next-line prefer-spread
    return template.apply(null, args);
    if (typeof template === "string") {
        const str = template.replace($58b5f17b6e7baa87$var$formatRegExp, (x)=>{
            if (x === "%%") return "%";
            if (i >= len) return x;
            switch(x){
                case "%s":
                    return String(args[i++]);
                case "%d":
                    return Number(args[i++]);
                case "%j":
                    try {
                        return JSON.stringify(args[i++]);
                    } catch (_) {
                        return "[Circular]";
                    }
                    break;
                default:
                    return x;
            }
        });
        return str;
    }
    return template;
}
function $58b5f17b6e7baa87$var$isNativeStringType(type) {
    return type === "string" || type === "url" || type === "hex" || type === "email" || type === "date" || type === "pattern" || type === "tel";
}
function $58b5f17b6e7baa87$export$141eca273a04dc3e(value, type) {
    if (value === undefined || value === null) return true;
    if (type === "array" && Array.isArray(value) && !value.length) return true;
    if ($58b5f17b6e7baa87$var$isNativeStringType(type) && typeof value === "string" && !value) return true;
    return false;
}
function $58b5f17b6e7baa87$export$83b788b1a3698c03(obj) {
    return Object.keys(obj).length === 0;
}
function $58b5f17b6e7baa87$var$asyncParallelArray(arr, func, callback) {
    const results = [];
    let total = 0;
    const arrLength = arr.length;
    function count(errors) {
        results.push(...errors || []);
        total++;
        if (total === arrLength) callback(results);
    }
    arr.forEach((a)=>{
        func(a, count);
    });
}
function $58b5f17b6e7baa87$var$asyncSerialArray(arr, func, callback) {
    let index = 0;
    const arrLength = arr.length;
    function next(errors) {
        if (errors && errors.length) {
            callback(errors);
            return;
        }
        const original = index;
        index = index + 1;
        if (original < arrLength) func(arr[original], next);
        else callback([]);
    }
    next([]);
}
function $58b5f17b6e7baa87$var$flattenObjArr(objArr) {
    const ret = [];
    Object.keys(objArr).forEach((k)=>{
        ret.push(...objArr[k] || []);
    });
    return ret;
}
class $58b5f17b6e7baa87$export$188f48b73534b6f0 extends Error {
    errors;
    fields;
    constructor(errors, fields){
        super("Async Validation Error");
        this.errors = errors;
        this.fields = fields;
    }
}
function $58b5f17b6e7baa87$export$707ee4c4c95d39e3(objArr, option, func, callback, source) {
    if (option.first) {
        const pending = new Promise((resolve, reject)=>{
            const next = (errors)=>{
                callback(errors);
                return errors.length ? reject(new $58b5f17b6e7baa87$export$188f48b73534b6f0(errors, $58b5f17b6e7baa87$export$e85887f5ceeacced(errors))) : resolve(source);
            };
            const flattenArr = $58b5f17b6e7baa87$var$flattenObjArr(objArr);
            $58b5f17b6e7baa87$var$asyncSerialArray(flattenArr, func, next);
        });
        pending.catch((e)=>e);
        return pending;
    }
    const firstFields = option.firstFields === true ? Object.keys(objArr) : option.firstFields || [];
    const objArrKeys = Object.keys(objArr);
    const objArrLength = objArrKeys.length;
    let total = 0;
    const results = [];
    const pending = new Promise((resolve, reject)=>{
        const next = (errors)=>{
            // eslint-disable-next-line prefer-spread
            results.push.apply(results, errors);
            total++;
            if (total === objArrLength) {
                callback(results);
                return results.length ? reject(new $58b5f17b6e7baa87$export$188f48b73534b6f0(results, $58b5f17b6e7baa87$export$e85887f5ceeacced(results))) : resolve(source);
            }
        };
        if (!objArrKeys.length) {
            callback(results);
            resolve(source);
        }
        objArrKeys.forEach((key)=>{
            const arr = objArr[key];
            if (firstFields.indexOf(key) !== -1) $58b5f17b6e7baa87$var$asyncSerialArray(arr, func, next);
            else $58b5f17b6e7baa87$var$asyncParallelArray(arr, func, next);
        });
    });
    pending.catch((e)=>e);
    return pending;
}
function $58b5f17b6e7baa87$var$isErrorObj(obj) {
    return !!(obj && obj.message !== undefined);
}
function $58b5f17b6e7baa87$var$getValue(value, path) {
    let v = value;
    for(let i = 0; i < path.length; i++){
        if (v == undefined) return v;
        v = v[path[i]];
    }
    return v;
}
function $58b5f17b6e7baa87$export$34d5fe50d2616cee(rule, source) {
    return (oe)=>{
        let fieldValue;
        if (rule.fullFields) fieldValue = $58b5f17b6e7baa87$var$getValue(source, rule.fullFields);
        else fieldValue = source[oe.field || rule.fullField];
        if ($58b5f17b6e7baa87$var$isErrorObj(oe)) {
            oe.field = oe.field || rule.fullField;
            oe.fieldValue = fieldValue;
            return oe;
        }
        return {
            message: typeof oe === "function" ? oe() : oe,
            fieldValue: fieldValue,
            field: oe.field || rule.fullField
        };
    };
}
function $58b5f17b6e7baa87$export$6969335ea1e4e77c(target, source) {
    if (source) {
        for(const s in source)if (source.hasOwnProperty(s)) {
            const value = source[s];
            if (typeof value === "object" && typeof target[s] === "object") target[s] = {
                ...target[s],
                ...value
            };
            else target[s] = value;
        }
    }
    return target;
}



const $531571e3ac8133e5$var$ENUM = "enum";
const $531571e3ac8133e5$var$enumerable = (rule, value, source, errors, options)=>{
    rule[$531571e3ac8133e5$var$ENUM] = Array.isArray(rule[$531571e3ac8133e5$var$ENUM]) ? rule[$531571e3ac8133e5$var$ENUM] : [];
    if (rule[$531571e3ac8133e5$var$ENUM].indexOf(value) === -1) errors.push((0, $58b5f17b6e7baa87$export$d9468344d3651243)(options.messages[$531571e3ac8133e5$var$ENUM], rule.fullField, rule[$531571e3ac8133e5$var$ENUM].join(", ")));
};
var $531571e3ac8133e5$export$2e2bcd8739ae039 = $531571e3ac8133e5$var$enumerable;



const $5d2e5be45c03f660$var$pattern = (rule, value, source, errors, options)=>{
    if (rule.pattern) {
        if (rule.pattern instanceof RegExp) {
            // if a RegExp instance is passed, reset `lastIndex` in case its `global`
            // flag is accidentally set to `true`, which in a validation scenario
            // is not necessary and the result might be misleading
            rule.pattern.lastIndex = 0;
            if (!rule.pattern.test(value)) errors.push((0, $58b5f17b6e7baa87$export$d9468344d3651243)(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
        } else if (typeof rule.pattern === "string") {
            const _pattern = new RegExp(rule.pattern);
            if (!_pattern.test(value)) errors.push((0, $58b5f17b6e7baa87$export$d9468344d3651243)(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
        }
    }
};
var $5d2e5be45c03f660$export$2e2bcd8739ae039 = $5d2e5be45c03f660$var$pattern;



const $5e7ff2e298f47327$var$range = (rule, value, source, errors, options)=>{
    const len = typeof rule.len === "number";
    const min = typeof rule.min === "number";
    const max = typeof rule.max === "number";
    // 正则匹配码点范围从U+010000一直到U+10FFFF的文字（补充平面Supplementary Plane）
    const spRegexp = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
    let val = value;
    let key = null;
    const num = typeof value === "number";
    const str = typeof value === "string";
    const arr = Array.isArray(value);
    if (num) key = "number";
    else if (str) key = "string";
    else if (arr) key = "array";
    // if the value is not of a supported type for range validation
    // the validation rule rule should use the
    // type property to also test for a particular type
    if (!key) return false;
    if (arr) val = value.length;
    if (str) // 处理码点大于U+010000的文字length属性不准确的bug，如"𠮷𠮷𠮷".length !== 3
    val = value.replace(spRegexp, "_").length;
    if (len) {
        if (val !== rule.len) errors.push((0, $58b5f17b6e7baa87$export$d9468344d3651243)(options.messages[key].len, rule.fullField, rule.len));
    } else if (min && !max && val < rule.min) errors.push((0, $58b5f17b6e7baa87$export$d9468344d3651243)(options.messages[key].min, rule.fullField, rule.min));
    else if (max && !min && val > rule.max) errors.push((0, $58b5f17b6e7baa87$export$d9468344d3651243)(options.messages[key].max, rule.fullField, rule.max));
    else if (min && max && (val < rule.min || val > rule.max)) errors.push((0, $58b5f17b6e7baa87$export$d9468344d3651243)(options.messages[key].range, rule.fullField, rule.min, rule.max));
};
var $5e7ff2e298f47327$export$2e2bcd8739ae039 = $5e7ff2e298f47327$var$range;



const $d3472082015b5b97$var$required = (rule, value, source, errors, options, type)=>{
    if (rule.required && (!source.hasOwnProperty(rule.field) || (0, $58b5f17b6e7baa87$export$141eca273a04dc3e)(value, type || rule.type))) errors.push((0, $58b5f17b6e7baa87$export$d9468344d3651243)(options.messages.required, rule.fullField));
};
var $d3472082015b5b97$export$2e2bcd8739ae039 = $d3472082015b5b97$var$required;




// https://github.com/kevva/url-regex/blob/master/index.js
let $f77fbbafffc009a6$var$urlReg;
var $f77fbbafffc009a6$export$2e2bcd8739ae039 = ()=>{
    if ($f77fbbafffc009a6$var$urlReg) return $f77fbbafffc009a6$var$urlReg;
    const word = "[a-fA-F\\d:]";
    const b = (options)=>options && options.includeBoundaries ? `(?:(?<=\\s|^)(?=${word})|(?<=${word})(?=\\s|$))` : "";
    const v4 = "(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}";
    const v6seg = "[a-fA-F\\d]{1,4}";
    const v6List = [
        `(?:${v6seg}:){7}(?:${v6seg}|:)`,
        // 1:2:3:4:5:6:7::  1:2:3:4:5:6:7:8
        `(?:${v6seg}:){6}(?:${v4}|:${v6seg}|:)`,
        // 1:2:3:4:5:6::    1:2:3:4:5:6::8   1:2:3:4:5:6::8  1:2:3:4:5:6::
        `(?:${v6seg}:){5}(?::${v4}|(?::${v6seg}){1,2}|:)`,
        // 1:2:3:4:5::      1:2:3:4:5::7:8   1:2:3:4:5::8    1:2:3:4:5::
        `(?:${v6seg}:){4}(?:(?::${v6seg}){0,1}:${v4}|(?::${v6seg}){1,3}|:)`,
        // 1:2:3:4::        1:2:3:4::6:7:8   1:2:3:4::8      1:2:3:4::
        `(?:${v6seg}:){3}(?:(?::${v6seg}){0,2}:${v4}|(?::${v6seg}){1,4}|:)`,
        // 1:2:3::          1:2:3::5:6:7:8   1:2:3::8        1:2:3::
        `(?:${v6seg}:){2}(?:(?::${v6seg}){0,3}:${v4}|(?::${v6seg}){1,5}|:)`,
        // 1:2::            1:2::4:5:6:7:8   1:2::8          1:2::
        `(?:${v6seg}:){1}(?:(?::${v6seg}){0,4}:${v4}|(?::${v6seg}){1,6}|:)`,
        // 1::              1::3:4:5:6:7:8   1::8            1::
        `(?::(?:(?::${v6seg}){0,5}:${v4}|(?::${v6seg}){1,7}|:))` // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::
    ];
    const v6Eth0 = `(?:%[0-9a-zA-Z]{1,})?`; // %eth0            %1
    const v6 = `(?:${v6List.join("|")})${v6Eth0}`;
    // Pre-compile only the exact regexes because adding a global flag make regexes stateful
    const v46Exact = new RegExp(`(?:^${v4}$)|(?:^${v6}$)`);
    const v4exact = new RegExp(`^${v4}$`);
    const v6exact = new RegExp(`^${v6}$`);
    const ip = (options)=>options && options.exact ? v46Exact : new RegExp(`(?:${b(options)}${v4}${b(options)})|(?:${b(options)}${v6}${b(options)})`, "g");
    ip.v4 = (options)=>options && options.exact ? v4exact : new RegExp(`${b(options)}${v4}${b(options)}`, "g");
    ip.v6 = (options)=>options && options.exact ? v6exact : new RegExp(`${b(options)}${v6}${b(options)}`, "g");
    const protocol = `(?:(?:[a-z]+:)?//)`;
    const auth = "(?:\\S+(?::\\S*)?@)?";
    const ipv4 = ip.v4().source;
    const ipv6 = ip.v6().source;
    const host = "(?:(?:[a-z\\u00a1-\\uffff0-9][-_]*)*[a-z\\u00a1-\\uffff0-9]+)";
    const domain = "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*";
    const tld = `(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))`;
    const port = "(?::\\d{2,5})?";
    const path = '(?:[/?#][^\\s"]*)?';
    const regex = `(?:${protocol}|www\\.)${auth}(?:localhost|${ipv4}|${ipv6}|${host}${domain}${tld})${port}${path}`;
    $f77fbbafffc009a6$var$urlReg = new RegExp(`(?:^${regex}$)`, "i");
    return $f77fbbafffc009a6$var$urlReg;
};


/* eslint max-len:0 */ const $cbdd26f81906a8c9$var$pattern = {
    // http://emailregex.com/
    email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/,
    // url: new RegExp(
    //   '^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$',
    //   'i',
    // ),
    /**
   * Phone number regex, support country code, brackets, spaces, and dashes (or non-breaking hyphen \u2011).
   * @see https://regexr.com/3c53v
   * @see https://ihateregex.io/expr/phone/
   * @see https://developers.google.com/style/phone-numbers using non-breaking hyphen \u2011
   */ tel: /^(\+[0-9]{1,3}[-\s\u2011]?)?(\([0-9]{1,4}\)[-\s\u2011]?)?([0-9]+[-\s\u2011]?)*[0-9]+$/,
    hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
};
const $cbdd26f81906a8c9$var$types = {
    integer (value) {
        return $cbdd26f81906a8c9$var$types.number(value) && parseInt(value, 10) === value;
    },
    float (value) {
        return $cbdd26f81906a8c9$var$types.number(value) && !$cbdd26f81906a8c9$var$types.integer(value);
    },
    array (value) {
        return Array.isArray(value);
    },
    regexp (value) {
        if (value instanceof RegExp) return true;
        try {
            return new RegExp(value), true;
        } catch (e) {
            return false;
        }
    },
    date (value) {
        return typeof value.getTime === "function" && typeof value.getMonth === "function" && typeof value.getYear === "function" && !isNaN(value.getTime());
    },
    number (value) {
        if (isNaN(value)) return false;
        return typeof value === "number";
    },
    object (value) {
        return typeof value === "object" && !$cbdd26f81906a8c9$var$types.array(value);
    },
    method (value) {
        return typeof value === "function";
    },
    email (value) {
        return typeof value === "string" && value.length <= 320 && !!value.match($cbdd26f81906a8c9$var$pattern.email);
    },
    tel (value) {
        return typeof value === "string" && value.length <= 32 && !!value.match($cbdd26f81906a8c9$var$pattern.tel);
    },
    url (value) {
        return typeof value === "string" && value.length <= 2048 && !!value.match((0, $f77fbbafffc009a6$export$2e2bcd8739ae039)());
    },
    hex (value) {
        return typeof value === "string" && !!value.match($cbdd26f81906a8c9$var$pattern.hex);
    }
};
const $cbdd26f81906a8c9$var$type = (rule, value, source, errors, options)=>{
    if (rule.required && value === undefined) {
        (0, $d3472082015b5b97$export$2e2bcd8739ae039)(rule, value, source, errors, options);
        return;
    }
    const custom = [
        "integer",
        "float",
        "array",
        "regexp",
        "object",
        "method",
        "email",
        "tel",
        "number",
        "date",
        "url",
        "hex"
    ];
    const ruleType = rule.type;
    if (custom.indexOf(ruleType) > -1) {
        if (!$cbdd26f81906a8c9$var$types[ruleType](value)) errors.push((0, $58b5f17b6e7baa87$export$d9468344d3651243)(options.messages.types[ruleType], rule.fullField, rule.type));
    } else if (ruleType && typeof value !== rule.type) errors.push((0, $58b5f17b6e7baa87$export$d9468344d3651243)(options.messages.types[ruleType], rule.fullField, rule.type));
};
var $cbdd26f81906a8c9$export$2e2bcd8739ae039 = $cbdd26f81906a8c9$var$type;



/**
 *  Rule for validating whitespace.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */ const $7368beb831153cf3$var$whitespace = (rule, value, source, errors, options)=>{
    if (/^\s+$/.test(value) || value === "") errors.push((0, $58b5f17b6e7baa87$export$d9468344d3651243)(options.messages.whitespace, rule.fullField));
};
var $7368beb831153cf3$export$2e2bcd8739ae039 = $7368beb831153cf3$var$whitespace;


var $cf773459927874f1$export$2e2bcd8739ae039 = {
    required: $d3472082015b5b97$export$2e2bcd8739ae039,
    whitespace: $7368beb831153cf3$export$2e2bcd8739ae039,
    type: $cbdd26f81906a8c9$export$2e2bcd8739ae039,
    range: $5e7ff2e298f47327$export$2e2bcd8739ae039,
    enum: (0, $531571e3ac8133e5$export$2e2bcd8739ae039),
    pattern: $5d2e5be45c03f660$export$2e2bcd8739ae039
};



const $cb07eff86f406b8f$var$any = (rule, value, callback, source, options)=>{
    const errors = [];
    const validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $58b5f17b6e7baa87$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $cf773459927874f1$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
    }
    callback(errors);
};
var $cb07eff86f406b8f$export$2e2bcd8739ae039 = $cb07eff86f406b8f$var$any;



const $e4853d43a2fb2aca$var$array = (rule, value, callback, source, options)=>{
    const errors = [];
    const validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((value === undefined || value === null) && !rule.required) return callback();
        (0, $cf773459927874f1$export$2e2bcd8739ae039).required(rule, value, source, errors, options, "array");
        if (value !== undefined && value !== null) {
            (0, $cf773459927874f1$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
            (0, $cf773459927874f1$export$2e2bcd8739ae039).range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $e4853d43a2fb2aca$export$2e2bcd8739ae039 = $e4853d43a2fb2aca$var$array;




const $7e460303ec8e6376$var$boolean = (rule, value, callback, source, options)=>{
    const errors = [];
    const validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $58b5f17b6e7baa87$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $cf773459927874f1$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (value !== undefined) (0, $cf773459927874f1$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $7e460303ec8e6376$export$2e2bcd8739ae039 = $7e460303ec8e6376$var$boolean;




const $df31fc0826d42bb8$var$date = (rule, value, callback, source, options)=>{
    // console.log('integer rule called %j', rule);
    const errors = [];
    const validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    // console.log('validate on %s value', value);
    if (validate) {
        if ((0, $58b5f17b6e7baa87$export$141eca273a04dc3e)(value, "date") && !rule.required) return callback();
        (0, $cf773459927874f1$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (!(0, $58b5f17b6e7baa87$export$141eca273a04dc3e)(value, "date")) {
            let dateObject;
            if (value instanceof Date) dateObject = value;
            else dateObject = new Date(value);
            (0, $cf773459927874f1$export$2e2bcd8739ae039).type(rule, dateObject, source, errors, options);
            if (dateObject) (0, $cf773459927874f1$export$2e2bcd8739ae039).range(rule, dateObject.getTime(), source, errors, options);
        }
    }
    callback(errors);
};
var $df31fc0826d42bb8$export$2e2bcd8739ae039 = $df31fc0826d42bb8$var$date;




const $ab44e28087290562$var$ENUM = "enum";
const $ab44e28087290562$var$enumerable = (rule, value, callback, source, options)=>{
    const errors = [];
    const validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $58b5f17b6e7baa87$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $cf773459927874f1$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (value !== undefined) (0, $cf773459927874f1$export$2e2bcd8739ae039)[$ab44e28087290562$var$ENUM](rule, value, source, errors, options);
    }
    callback(errors);
};
var $ab44e28087290562$export$2e2bcd8739ae039 = $ab44e28087290562$var$enumerable;




const $0194de7196ced6a6$var$floatFn = (rule, value, callback, source, options)=>{
    const errors = [];
    const validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $58b5f17b6e7baa87$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $cf773459927874f1$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (value !== undefined) {
            (0, $cf773459927874f1$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
            (0, $cf773459927874f1$export$2e2bcd8739ae039).range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $0194de7196ced6a6$export$2e2bcd8739ae039 = $0194de7196ced6a6$var$floatFn;




const $4d736fd8914edb20$var$integer = (rule, value, callback, source, options)=>{
    const errors = [];
    const validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $58b5f17b6e7baa87$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $cf773459927874f1$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (value !== undefined) {
            (0, $cf773459927874f1$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
            (0, $cf773459927874f1$export$2e2bcd8739ae039).range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $4d736fd8914edb20$export$2e2bcd8739ae039 = $4d736fd8914edb20$var$integer;




const $4b7450ed29dbc164$var$method = (rule, value, callback, source, options)=>{
    const errors = [];
    const validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $58b5f17b6e7baa87$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $cf773459927874f1$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (value !== undefined) (0, $cf773459927874f1$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $4b7450ed29dbc164$export$2e2bcd8739ae039 = $4b7450ed29dbc164$var$method;




const $d5d574eb0cabaeeb$var$number = (rule, value, callback, source, options)=>{
    const errors = [];
    const validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if (value === "") // eslint-disable-next-line no-param-reassign
        value = undefined;
        if ((0, $58b5f17b6e7baa87$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $cf773459927874f1$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (value !== undefined) {
            (0, $cf773459927874f1$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
            (0, $cf773459927874f1$export$2e2bcd8739ae039).range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $d5d574eb0cabaeeb$export$2e2bcd8739ae039 = $d5d574eb0cabaeeb$var$number;




const $9b72a3490482c277$var$object = (rule, value, callback, source, options)=>{
    const errors = [];
    const validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $58b5f17b6e7baa87$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $cf773459927874f1$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (value !== undefined) (0, $cf773459927874f1$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $9b72a3490482c277$export$2e2bcd8739ae039 = $9b72a3490482c277$var$object;




const $f4d1ab45461b7aff$var$pattern = (rule, value, callback, source, options)=>{
    const errors = [];
    const validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $58b5f17b6e7baa87$export$141eca273a04dc3e)(value, "string") && !rule.required) return callback();
        (0, $cf773459927874f1$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (!(0, $58b5f17b6e7baa87$export$141eca273a04dc3e)(value, "string")) (0, $cf773459927874f1$export$2e2bcd8739ae039).pattern(rule, value, source, errors, options);
    }
    callback(errors);
};
var $f4d1ab45461b7aff$export$2e2bcd8739ae039 = $f4d1ab45461b7aff$var$pattern;




const $18549b0dc0c4a150$var$regexp = (rule, value, callback, source, options)=>{
    const errors = [];
    const validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $58b5f17b6e7baa87$export$141eca273a04dc3e)(value) && !rule.required) return callback();
        (0, $cf773459927874f1$export$2e2bcd8739ae039).required(rule, value, source, errors, options);
        if (!(0, $58b5f17b6e7baa87$export$141eca273a04dc3e)(value)) (0, $cf773459927874f1$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $18549b0dc0c4a150$export$2e2bcd8739ae039 = $18549b0dc0c4a150$var$regexp;



const $8679dabb4eb25919$var$required = (rule, value, callback, source, options)=>{
    const errors = [];
    const type = Array.isArray(value) ? "array" : typeof value;
    (0, $cf773459927874f1$export$2e2bcd8739ae039).required(rule, value, source, errors, options, type);
    callback(errors);
};
var $8679dabb4eb25919$export$2e2bcd8739ae039 = $8679dabb4eb25919$var$required;




const $838465634ad3a2f9$var$string = (rule, value, callback, source, options)=>{
    const errors = [];
    const validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $58b5f17b6e7baa87$export$141eca273a04dc3e)(value, "string") && !rule.required) return callback();
        (0, $cf773459927874f1$export$2e2bcd8739ae039).required(rule, value, source, errors, options, "string");
        if (!(0, $58b5f17b6e7baa87$export$141eca273a04dc3e)(value, "string")) {
            (0, $cf773459927874f1$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
            (0, $cf773459927874f1$export$2e2bcd8739ae039).range(rule, value, source, errors, options);
            (0, $cf773459927874f1$export$2e2bcd8739ae039).pattern(rule, value, source, errors, options);
            if (rule.whitespace === true) (0, $cf773459927874f1$export$2e2bcd8739ae039).whitespace(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
var $838465634ad3a2f9$export$2e2bcd8739ae039 = $838465634ad3a2f9$var$string;




const $cff65fc83cf98551$var$type = (rule, value, callback, source, options)=>{
    const ruleType = rule.type;
    const errors = [];
    const validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, $58b5f17b6e7baa87$export$141eca273a04dc3e)(value, ruleType) && !rule.required) return callback();
        (0, $cf773459927874f1$export$2e2bcd8739ae039).required(rule, value, source, errors, options, ruleType);
        if (!(0, $58b5f17b6e7baa87$export$141eca273a04dc3e)(value, ruleType)) (0, $cf773459927874f1$export$2e2bcd8739ae039).type(rule, value, source, errors, options);
    }
    callback(errors);
};
var $cff65fc83cf98551$export$2e2bcd8739ae039 = $cff65fc83cf98551$var$type;


var $edfc1f0866de197e$export$2e2bcd8739ae039 = {
    string: $838465634ad3a2f9$export$2e2bcd8739ae039,
    method: $4b7450ed29dbc164$export$2e2bcd8739ae039,
    number: $d5d574eb0cabaeeb$export$2e2bcd8739ae039,
    boolean: $7e460303ec8e6376$export$2e2bcd8739ae039,
    regexp: $18549b0dc0c4a150$export$2e2bcd8739ae039,
    integer: $4d736fd8914edb20$export$2e2bcd8739ae039,
    float: $0194de7196ced6a6$export$2e2bcd8739ae039,
    array: $e4853d43a2fb2aca$export$2e2bcd8739ae039,
    object: $9b72a3490482c277$export$2e2bcd8739ae039,
    enum: (0, $ab44e28087290562$export$2e2bcd8739ae039),
    pattern: $f4d1ab45461b7aff$export$2e2bcd8739ae039,
    date: $df31fc0826d42bb8$export$2e2bcd8739ae039,
    url: (0, $cff65fc83cf98551$export$2e2bcd8739ae039),
    hex: (0, $cff65fc83cf98551$export$2e2bcd8739ae039),
    email: (0, $cff65fc83cf98551$export$2e2bcd8739ae039),
    tel: (0, $cff65fc83cf98551$export$2e2bcd8739ae039),
    required: $8679dabb4eb25919$export$2e2bcd8739ae039,
    any: $cb07eff86f406b8f$export$2e2bcd8739ae039
};




/**
 *  Encapsulates a validation schema.
 *
 *  @param descriptor An object declaring validation rules
 *  for this schema.
 */ class $f78c867b4c5b2b23$var$Schema {
    // ========================= Static =========================
    static register = function register(type, validator) {
        if (typeof validator !== "function") throw new Error("Cannot register a validator by type, validator is not a function");
        (0, $edfc1f0866de197e$export$2e2bcd8739ae039)[type] = validator;
    };
    static warning = (0, $58b5f17b6e7baa87$export$491112666e282270);
    static messages = (0, $7d8078becc471b7a$export$defe85febe8b728c);
    static validators = (0, $edfc1f0866de197e$export$2e2bcd8739ae039);
    // ======================== Instance ========================
    rules = null;
    _messages = (0, $7d8078becc471b7a$export$defe85febe8b728c);
    constructor(descriptor){
        this.define(descriptor);
    }
    define(rules) {
        if (!rules) throw new Error("Cannot configure a schema with no rules");
        if (typeof rules !== "object" || Array.isArray(rules)) throw new Error("Rules must be an object");
        this.rules = {};
        Object.keys(rules).forEach((name)=>{
            const item = rules[name];
            this.rules[name] = Array.isArray(item) ? item : [
                item
            ];
        });
    }
    messages(messages) {
        if (messages) this._messages = (0, $58b5f17b6e7baa87$export$6969335ea1e4e77c)((0, $7d8078becc471b7a$export$f77fd0c3b25d8534)(), messages);
        return this._messages;
    }
    // eslint-disable-next-line @typescript-eslint/unified-signatures
    validate(source_, o = {}, oc = ()=>{}) {
        let source = source_;
        let options = o;
        let callback = oc;
        if (typeof options === "function") {
            callback = options;
            options = {};
        }
        if (!this.rules || Object.keys(this.rules).length === 0) {
            if (callback) callback(null, source);
            return Promise.resolve(source);
        }
        function complete(results) {
            let errors = [];
            let fields = {};
            function add(e) {
                if (Array.isArray(e)) errors = errors.concat(...e);
                else errors.push(e);
            }
            for(let i = 0; i < results.length; i++)add(results[i]);
            if (!errors.length) callback(null, source);
            else {
                fields = (0, $58b5f17b6e7baa87$export$e85887f5ceeacced)(errors);
                callback(errors, fields);
            }
        }
        if (options.messages) {
            let messages = this.messages();
            if (messages === (0, $7d8078becc471b7a$export$defe85febe8b728c)) messages = (0, $7d8078becc471b7a$export$f77fd0c3b25d8534)();
            (0, $58b5f17b6e7baa87$export$6969335ea1e4e77c)(messages, options.messages);
            options.messages = messages;
        } else options.messages = this.messages();
        const series = {};
        const keys = options.keys || Object.keys(this.rules);
        keys.forEach((z)=>{
            const arr = this.rules[z];
            let value = source[z];
            arr.forEach((r)=>{
                let rule = r;
                if (typeof rule.transform === "function") {
                    if (source === source_) source = {
                        ...source
                    };
                    value = source[z] = rule.transform(value);
                    if (value !== undefined && value !== null) rule.type = rule.type || (Array.isArray(value) ? "array" : typeof value);
                }
                if (typeof rule === "function") rule = {
                    validator: rule
                };
                else rule = {
                    ...rule
                };
                // Fill validator. Skip if nothing need to validate
                rule.validator = this.getValidationMethod(rule);
                if (!rule.validator) return;
                rule.field = z;
                rule.fullField = rule.fullField || z;
                rule.type = this.getType(rule);
                series[z] = series[z] || [];
                series[z].push({
                    rule: rule,
                    value: value,
                    source: source,
                    field: z
                });
            });
        });
        const errorFields = {};
        return (0, $58b5f17b6e7baa87$export$707ee4c4c95d39e3)(series, options, (data, doIt)=>{
            const rule = data.rule;
            let deep = (rule.type === "object" || rule.type === "array") && (typeof rule.fields === "object" || typeof rule.defaultField === "object");
            deep = deep && (rule.required || !rule.required && data.value);
            rule.field = data.field;
            function addFullField(key, schema) {
                return {
                    ...schema,
                    fullField: `${rule.fullField}.${key}`,
                    fullFields: rule.fullFields ? [
                        ...rule.fullFields,
                        key
                    ] : [
                        key
                    ]
                };
            }
            function cb(e = []) {
                let errorList = Array.isArray(e) ? e : [
                    e
                ];
                if (!options.suppressWarning && errorList.length) $f78c867b4c5b2b23$var$Schema.warning("async-validator:", errorList);
                if (errorList.length && rule.message !== undefined && rule.message !== null) errorList = [].concat(rule.message);
                // Fill error info
                let filledErrors = errorList.map((0, $58b5f17b6e7baa87$export$34d5fe50d2616cee)(rule, source));
                if (options.first && filledErrors.length) {
                    errorFields[rule.field] = 1;
                    return doIt(filledErrors);
                }
                if (!deep) doIt(filledErrors);
                else {
                    // if rule is required but the target object
                    // does not exist fail at the rule level and don't
                    // go deeper
                    if (rule.required && !data.value) {
                        if (rule.message !== undefined) filledErrors = [].concat(rule.message).map((0, $58b5f17b6e7baa87$export$34d5fe50d2616cee)(rule, source));
                        else if (options.error) filledErrors = [
                            options.error(rule, (0, $58b5f17b6e7baa87$export$d9468344d3651243)(options.messages.required, rule.field))
                        ];
                        return doIt(filledErrors);
                    }
                    let fieldsSchema = {};
                    if (rule.defaultField) Object.keys(data.value).map((key)=>{
                        fieldsSchema[key] = rule.defaultField;
                    });
                    fieldsSchema = {
                        ...fieldsSchema,
                        ...data.rule.fields
                    };
                    const paredFieldsSchema = {};
                    Object.keys(fieldsSchema).forEach((field)=>{
                        const fieldSchema = fieldsSchema[field];
                        const fieldSchemaList = Array.isArray(fieldSchema) ? fieldSchema : [
                            fieldSchema
                        ];
                        paredFieldsSchema[field] = fieldSchemaList.map(addFullField.bind(null, field));
                    });
                    const schema = new $f78c867b4c5b2b23$var$Schema(paredFieldsSchema);
                    schema.messages(options.messages);
                    if (data.rule.options) {
                        data.rule.options.messages = options.messages;
                        data.rule.options.error = options.error;
                    }
                    schema.validate(data.value, data.rule.options || options, (errs)=>{
                        const finalErrors = [];
                        if (filledErrors && filledErrors.length) finalErrors.push(...filledErrors);
                        if (errs && errs.length) finalErrors.push(...errs);
                        doIt(finalErrors.length ? finalErrors : null);
                    });
                }
            }
            let res;
            if (rule.asyncValidator) res = rule.asyncValidator(rule, data.value, cb, data.source, options);
            else if (rule.validator) {
                try {
                    res = rule.validator(rule, data.value, cb, data.source, options);
                } catch (error) {
                    console.error?.(error);
                    // rethrow to report error
                    if (!options.suppressValidatorError) setTimeout(()=>{
                        throw error;
                    }, 0);
                    cb(error.message);
                }
                if (res === true) cb();
                else if (res === false) cb(typeof rule.message === "function" ? rule.message(rule.fullField || rule.field) : rule.message || `${rule.fullField || rule.field} fails`);
                else if (res instanceof Array) cb(res);
                else if (res instanceof Error) cb(res.message);
            }
            if (res && res.then) res.then(()=>cb(), (e)=>cb(e));
        }, (results)=>{
            complete(results);
        }, source);
    }
    getType(rule) {
        if (rule.type === undefined && rule.pattern instanceof RegExp) rule.type = "pattern";
        if (typeof rule.validator !== "function" && rule.type && !(0, $edfc1f0866de197e$export$2e2bcd8739ae039).hasOwnProperty(rule.type)) throw new Error((0, $58b5f17b6e7baa87$export$d9468344d3651243)("Unknown rule type %s", rule.type));
        return rule.type || "string";
    }
    getValidationMethod(rule) {
        if (typeof rule.validator === "function") return rule.validator;
        const keys = Object.keys(rule);
        const messageIndex = keys.indexOf("message");
        if (messageIndex !== -1) keys.splice(messageIndex, 1);
        if (keys.length === 1 && keys[0] === "required") return (0, $edfc1f0866de197e$export$2e2bcd8739ae039).required;
        return (0, $edfc1f0866de197e$export$2e2bcd8739ae039)[this.getType(rule)] || undefined;
    }
}
var $f78c867b4c5b2b23$export$2e2bcd8739ae039 = $f78c867b4c5b2b23$var$Schema;



var $cQmXV = parcelRequire("cQmXV");

const $676816715e783bda$var$typeTemplate = "'${name}' is not a valid ${type}";
const $676816715e783bda$export$c86b939816b8fbf8 = {
    default: "Validation error on field '${name}'",
    required: "'${name}' is required",
    enum: "'${name}' must be one of [${enum}]",
    whitespace: "'${name}' cannot be empty",
    date: {
        format: "'${name}' is invalid for format date",
        parse: "'${name}' could not be parsed as date",
        invalid: "'${name}' is invalid date"
    },
    types: {
        string: $676816715e783bda$var$typeTemplate,
        method: $676816715e783bda$var$typeTemplate,
        array: $676816715e783bda$var$typeTemplate,
        object: $676816715e783bda$var$typeTemplate,
        number: $676816715e783bda$var$typeTemplate,
        date: $676816715e783bda$var$typeTemplate,
        boolean: $676816715e783bda$var$typeTemplate,
        integer: $676816715e783bda$var$typeTemplate,
        float: $676816715e783bda$var$typeTemplate,
        regexp: $676816715e783bda$var$typeTemplate,
        email: $676816715e783bda$var$typeTemplate,
        tel: $676816715e783bda$var$typeTemplate,
        url: $676816715e783bda$var$typeTemplate,
        hex: $676816715e783bda$var$typeTemplate
    },
    string: {
        len: "'${name}' must be exactly ${len} characters",
        min: "'${name}' must be at least ${min} characters",
        max: "'${name}' cannot be longer than ${max} characters",
        range: "'${name}' must be between ${min} and ${max} characters"
    },
    number: {
        len: "'${name}' must equal ${len}",
        min: "'${name}' cannot be less than ${min}",
        max: "'${name}' cannot be greater than ${max}",
        range: "'${name}' must be between ${min} and ${max}"
    },
    array: {
        len: "'${name}' must be exactly ${len} in length",
        min: "'${name}' cannot be less than ${min} in length",
        max: "'${name}' cannot be greater than ${max} in length",
        range: "'${name}' must be between ${min} and ${max} in length"
    },
    pattern: {
        mismatch: "'${name}' does not match pattern ${pattern}"
    }
};


// Remove incorrect original ts define
const $0cf59ff0f52c7bb2$var$AsyncValidator = (0, $f78c867b4c5b2b23$export$2e2bcd8739ae039);
/**
 * Replace with template.
 *   `I'm ${name}` + { name: 'bamboo' } = I'm bamboo
 */ function $0cf59ff0f52c7bb2$var$replaceMessage(template, kv) {
    return template.replace(/\\?\$\{\w+\}/g, (str)=>{
        if (str.startsWith("\\")) return str.slice(1);
        const key = str.slice(2, -1);
        return kv[key];
    });
}
const $0cf59ff0f52c7bb2$var$CODE_LOGIC_ERROR = "CODE_LOGIC_ERROR";
async function $0cf59ff0f52c7bb2$var$validateRule(name, value, rule, options, messageVariables) {
    const cloneRule = {
        ...rule
    };
    // Bug of `async-validator`
    // https://github.com/react-component/field-form/issues/316
    // https://github.com/react-component/field-form/issues/313
    delete cloneRule.ruleIndex;
    // https://github.com/ant-design/ant-design/issues/40497#issuecomment-1422282378
    $0cf59ff0f52c7bb2$var$AsyncValidator.warning = ()=>void 0;
    if (cloneRule.validator) {
        const originValidator = cloneRule.validator;
        cloneRule.validator = (...args)=>{
            try {
                return originValidator(...args);
            } catch (error) {
                console.error(error);
                return Promise.reject($0cf59ff0f52c7bb2$var$CODE_LOGIC_ERROR);
            }
        };
    }
    // We should special handle array validate
    let subRuleField = null;
    if (cloneRule && cloneRule.type === "array" && cloneRule.defaultField) {
        subRuleField = cloneRule.defaultField;
        delete cloneRule.defaultField;
    }
    const validator = new $0cf59ff0f52c7bb2$var$AsyncValidator({
        [name]: [
            cloneRule
        ]
    });
    const messages = (0, $a3099986deccaee4$export$4950aa0f605343fb)((0, $676816715e783bda$export$c86b939816b8fbf8), options.validateMessages);
    validator.messages(messages);
    let result = [];
    try {
        await Promise.resolve(validator.validate({
            [name]: value
        }, {
            ...options
        }));
    } catch (errObj) {
        if (errObj.errors) result = errObj.errors.map(({ message: message }, index)=>{
            const mergedMessage = message === $0cf59ff0f52c7bb2$var$CODE_LOGIC_ERROR ? messages.default : message;
            return /*#__PURE__*/ $cQmXV.isValidElement(mergedMessage) ? /*#__PURE__*/ // Wrap ReactNode with `key`
            $cQmXV.cloneElement(mergedMessage, {
                key: `error_${index}`
            }) : mergedMessage;
        });
    }
    if (!result.length && subRuleField && Array.isArray(value) && value.length > 0) {
        const subResults = await Promise.all(value.map((subValue, i)=>$0cf59ff0f52c7bb2$var$validateRule(`${name}.${i}`, subValue, subRuleField, options, messageVariables)));
        return subResults.reduce((prev, errors)=>[
                ...prev,
                ...errors
            ], []);
    }
    // Replace message with variables
    const kv = {
        ...rule,
        name: name,
        enum: (rule.enum || []).join(", "),
        ...messageVariables
    };
    const fillVariableResult = result.map((error)=>{
        if (typeof error === "string") return $0cf59ff0f52c7bb2$var$replaceMessage(error, kv);
        return error;
    });
    return fillVariableResult;
}
function $0cf59ff0f52c7bb2$export$e1fc4b442d0297dd(namePath, value, rules, options, validateFirst, messageVariables) {
    const name = namePath.join(".");
    // Fill rule with context
    const filledRules = rules.map((currentRule, ruleIndex)=>{
        const originValidatorFunc = currentRule.validator;
        const cloneRule = {
            ...currentRule,
            ruleIndex: ruleIndex
        };
        // Replace validator if needed
        if (originValidatorFunc) cloneRule.validator = (rule, val, callback)=>{
            let hasPromise = false;
            // Wrap callback only accept when promise not provided
            const wrappedCallback = (...args)=>{
                // Wait a tick to make sure return type is a promise
                Promise.resolve().then(()=>{
                    (0, $26d7cf6379fe7659$export$2e2bcd8739ae039)(!hasPromise, "Your validator function has already return a promise. `callback` will be ignored.");
                    if (!hasPromise) callback(...args);
                });
            };
            // Get promise
            const promise = originValidatorFunc(rule, val, wrappedCallback);
            hasPromise = promise && typeof promise.then === "function" && typeof promise.catch === "function";
            /**
         * 1. Use promise as the first priority.
         * 2. If promise not exist, use callback with warning instead
         */ (0, $26d7cf6379fe7659$export$2e2bcd8739ae039)(hasPromise, "`callback` is deprecated. Please return a promise instead.");
            if (hasPromise) promise.then(()=>{
                callback();
            }).catch((err)=>{
                callback(err || " ");
            });
        };
        return cloneRule;
    }).sort(({ warningOnly: w1, ruleIndex: i1 }, { warningOnly: w2, ruleIndex: i2 })=>{
        if (!!w1 === !!w2) // Let keep origin order
        return i1 - i2;
        if (w1) return 1;
        return -1;
    });
    // Do validate rules
    let summaryPromise;
    if (validateFirst === true) // >>>>> Validate by serialization
    summaryPromise = new Promise(async (resolve, reject)=>{
        /* eslint-disable no-await-in-loop */ for(let i = 0; i < filledRules.length; i += 1){
            const rule = filledRules[i];
            const errors = await $0cf59ff0f52c7bb2$var$validateRule(name, value, rule, options, messageVariables);
            if (errors.length) {
                reject([
                    {
                        errors: errors,
                        rule: rule
                    }
                ]);
                return;
            }
        }
        /* eslint-enable */ resolve([]);
    });
    else {
        // >>>>> Validate by parallel
        const rulePromises = filledRules.map((rule)=>$0cf59ff0f52c7bb2$var$validateRule(name, value, rule, options, messageVariables).then((errors)=>({
                    errors: errors,
                    rule: rule
                })));
        summaryPromise = (validateFirst ? $0cf59ff0f52c7bb2$var$finishOnFirstFailed(rulePromises) : $0cf59ff0f52c7bb2$var$finishOnAllFailed(rulePromises)).then((errors)=>{
            // Always change to rejection for Field to catch
            return Promise.reject(errors);
        });
    }
    // Internal catch error to avoid console error log.
    summaryPromise.catch((e)=>e);
    return summaryPromise;
}
async function $0cf59ff0f52c7bb2$var$finishOnAllFailed(rulePromises) {
    return Promise.all(rulePromises).then((errorsList)=>{
        const errors = [].concat(...errorsList);
        return errors;
    });
}
async function $0cf59ff0f52c7bb2$var$finishOnFirstFailed(rulePromises) {
    let count = 0;
    return new Promise((resolve)=>{
        rulePromises.forEach((promise)=>{
            promise.then((ruleError)=>{
                if (ruleError.errors.length) resolve([
                    ruleError
                ]);
                count += 1;
                if (count === rulePromises.length) resolve([]);
            });
        });
    });
}




function $8e145835e5ed0368$export$f877b3cb4cb4ccf9(path) {
    return (0, $95fac96d9e2bedd3$export$45b10814cc054894)(path);
}
function $8e145835e5ed0368$export$f5be6dfb30403c59(store, namePathList) {
    let newStore = {};
    namePathList.forEach((namePath)=>{
        const value = (0, $bb62aae17cbc8bd7$export$2e2bcd8739ae039)(store, namePath);
        newStore = (0, $a3099986deccaee4$export$2e2bcd8739ae039)(newStore, namePath, value);
    });
    return newStore;
}
function $8e145835e5ed0368$export$646d5504364ae55b(namePathList, namePath, partialMatch = false) {
    return namePathList && namePathList.some((path)=>$8e145835e5ed0368$export$325a4bd0e71bdc3a(namePath, path, partialMatch));
}
function $8e145835e5ed0368$export$325a4bd0e71bdc3a(namePath, subNamePath, partialMatch = false) {
    if (!namePath || !subNamePath) return false;
    if (!partialMatch && namePath.length !== subNamePath.length) return false;
    return subNamePath.every((nameUnit, i)=>namePath[i] === nameUnit);
}
function $8e145835e5ed0368$export$dfcec05bb7372a54(source, target) {
    if (source === target) return true;
    if (!source && target || source && !target) return false;
    if (!source || !target || typeof source !== "object" || typeof target !== "object") return false;
    const sourceKeys = Object.keys(source);
    const targetKeys = Object.keys(target);
    const keys = new Set([
        ...sourceKeys,
        ...targetKeys
    ]);
    return [
        ...keys
    ].every((key)=>{
        const sourceValue = source[key];
        const targetValue = target[key];
        if (typeof sourceValue === "function" && typeof targetValue === "function") return true;
        return sourceValue === targetValue;
    });
}
function $8e145835e5ed0368$export$6eeac3c5b406fb30(valuePropName, ...args) {
    const event = args[0];
    if (event && event.target && typeof event.target === "object" && valuePropName in event.target) return event.target[valuePropName];
    return event;
}
function $8e145835e5ed0368$export$d947e5f4f4c48d48(array, moveIndex, toIndex) {
    const { length: length } = array;
    if (moveIndex < 0 || moveIndex >= length || toIndex < 0 || toIndex >= length) return array;
    const item = array[moveIndex];
    const diff = moveIndex - toIndex;
    if (diff > 0) // move left
    return [
        ...array.slice(0, toIndex),
        item,
        ...array.slice(toIndex, moveIndex),
        ...array.slice(moveIndex + 1, length)
    ];
    if (diff < 0) // move right
    return [
        ...array.slice(0, moveIndex),
        ...array.slice(moveIndex + 1, toIndex + 1),
        item,
        ...array.slice(toIndex + 1, length)
    ];
    return array;
}



const $918bfb875b2e6ecb$export$f1309b2412c6fa89 = (fn)=>{
    const channel = new MessageChannel();
    channel.port1.onmessage = fn;
    channel.port2.postMessage(null);
};
class $918bfb875b2e6ecb$export$2e2bcd8739ae039 {
    namePathList = [];
    taskId = 0;
    watcherList = new Set();
    form;
    constructor(form){
        this.form = form;
    }
    register(callback) {
        this.watcherList.add(callback);
        return ()=>{
            this.watcherList.delete(callback);
        };
    }
    notify(namePath) {
        // Insert with deduplication
        namePath.forEach((path)=>{
            if (this.namePathList.every((exist)=>!(0, $8e145835e5ed0368$export$325a4bd0e71bdc3a)(exist, path))) this.namePathList.push(path);
        });
        this.doBatch();
    }
    doBatch() {
        this.taskId += 1;
        const currentId = this.taskId;
        $918bfb875b2e6ecb$export$f1309b2412c6fa89(()=>{
            if (currentId === this.taskId && this.watcherList.size) {
                const formInst = this.form.getForm();
                const values = formInst.getFieldsValue();
                const allValues = formInst.getFieldsValue(true);
                this.watcherList.forEach((callback)=>{
                    callback(values, allValues, this.namePathList);
                });
                this.namePathList = [];
            }
        });
    }
}



async function $0e92a4dd0019be86$export$2e2bcd8739ae039() {
    return new Promise((resolve)=>{
        (0, $918bfb875b2e6ecb$export$f1309b2412c6fa89)(()=>{
            (0, $905c53b807de704e$export$2e2bcd8739ae039)(()=>{
                resolve();
            });
        });
    });
}


function $d1298bc083b1892f$var$_extends() {
    $d1298bc083b1892f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d1298bc083b1892f$var$_extends.apply(this, arguments);
}
const $d1298bc083b1892f$var$EMPTY_ERRORS = [];
const $d1298bc083b1892f$var$EMPTY_WARNINGS = [];
function $d1298bc083b1892f$var$requireUpdate(shouldUpdate, prev, next, prevValue, nextValue, info) {
    if (typeof shouldUpdate === "function") return shouldUpdate(prev, next, "source" in info ? {
        source: info.source
    } : {});
    return prevValue !== nextValue;
}
// eslint-disable-next-line @typescript-eslint/consistent-indexed-object-style
// We use Class instead of Hooks here since it will cost much code by using Hooks.
class $d1298bc083b1892f$var$Field extends $cQmXV.PureComponent {
    static contextType = (0, $7b2f48a2d7a9ccda$export$2e2bcd8739ae039);
    state = {
        resetCount: 0
    };
    cancelRegisterFunc = null;
    mounted = false;
    /**
   * Follow state should not management in State since it will async update by React.
   * This makes first render of form can not get correct state value.
   */ touched = false;
    /**
   * Mark when touched & validated. Currently only used for `dependencies`.
   * Note that we do not think field with `initialValue` is dirty
   * but this will be by `isFieldDirty` func.
   */ dirty = false;
    validatePromise;
    prevValidating;
    errors = $d1298bc083b1892f$var$EMPTY_ERRORS;
    warnings = $d1298bc083b1892f$var$EMPTY_WARNINGS;
    // ============================== Subscriptions ==============================
    constructor(props){
        super(props);
        // Register on init
        if (props.fieldContext) {
            const { getInternalHooks: getInternalHooks } = props.fieldContext;
            const { initEntityValue: initEntityValue } = getInternalHooks((0, $7b2f48a2d7a9ccda$export$24829b7c0e49e9f7));
            initEntityValue(this);
        }
    }
    componentDidMount() {
        const { shouldUpdate: shouldUpdate, fieldContext: fieldContext } = this.props;
        this.mounted = true;
        // Register on init
        if (fieldContext) {
            const { getInternalHooks: getInternalHooks } = fieldContext;
            const { registerField: registerField } = getInternalHooks((0, $7b2f48a2d7a9ccda$export$24829b7c0e49e9f7));
            this.cancelRegisterFunc = registerField(this);
        }
        // One more render for component in case fields not ready
        if (shouldUpdate === true) this.reRender();
    }
    componentWillUnmount() {
        this.cancelRegister();
        this.triggerMetaEvent(true);
        this.mounted = false;
    }
    cancelRegister = ()=>{
        const { preserve: preserve, isListField: isListField, name: name } = this.props;
        if (this.cancelRegisterFunc) this.cancelRegisterFunc(isListField, preserve, (0, $8e145835e5ed0368$export$f877b3cb4cb4ccf9)(name));
        this.cancelRegisterFunc = null;
    };
    // ================================== Utils ==================================
    getNamePath = ()=>{
        const { name: name, fieldContext: fieldContext } = this.props;
        const { prefixName: prefixName = [] } = fieldContext;
        return name !== undefined ? [
            ...prefixName,
            ...name
        ] : [];
    };
    getRules = ()=>{
        const { rules: rules = [], fieldContext: fieldContext } = this.props;
        return rules.map((rule)=>{
            if (typeof rule === "function") return rule(fieldContext);
            return rule;
        });
    };
    reRender() {
        if (!this.mounted) return;
        this.forceUpdate();
    }
    refresh = ()=>{
        if (!this.mounted) return;
        /**
     * Clean up current node.
     */ this.setState(({ resetCount: resetCount })=>({
                resetCount: resetCount + 1
            }));
    };
    // Event should only trigger when meta changed
    metaCache = null;
    triggerMetaEvent = (destroy)=>{
        const { onMetaChange: onMetaChange } = this.props;
        if (onMetaChange) {
            const meta = {
                ...this.getMeta(),
                destroy: destroy
            };
            if (!(0, $3f19ee2a2ff4618a$export$2e2bcd8739ae039)(this.metaCache, meta)) onMetaChange(meta);
            this.metaCache = meta;
        } else this.metaCache = null;
    };
    // ========================= Field Entity Interfaces =========================
    // Trigger by store update. Check if need update the component
    onStoreChange = (prevStore, namePathList, info)=>{
        const { shouldUpdate: shouldUpdate, dependencies: dependencies = [], onReset: onReset } = this.props;
        const { store: store } = info;
        const namePath = this.getNamePath();
        const prevValue = this.getValue(prevStore);
        const curValue = this.getValue(store);
        const namePathMatch = namePathList && (0, $8e145835e5ed0368$export$646d5504364ae55b)(namePathList, namePath);
        // `setFieldsValue` is a quick access to update related status
        if (info.type === "valueUpdate" && info.source === "external" && !(0, $3f19ee2a2ff4618a$export$2e2bcd8739ae039)(prevValue, curValue)) {
            this.touched = true;
            this.dirty = true;
            this.validatePromise = null;
            this.errors = $d1298bc083b1892f$var$EMPTY_ERRORS;
            this.warnings = $d1298bc083b1892f$var$EMPTY_WARNINGS;
            this.triggerMetaEvent();
        }
        switch(info.type){
            case "reset":
                if (!namePathList || namePathMatch) {
                    // Clean up state
                    this.touched = false;
                    this.dirty = false;
                    this.validatePromise = undefined;
                    this.errors = $d1298bc083b1892f$var$EMPTY_ERRORS;
                    this.warnings = $d1298bc083b1892f$var$EMPTY_WARNINGS;
                    this.triggerMetaEvent();
                    onReset?.();
                    this.refresh();
                    return;
                }
                break;
            /**
       * In case field with `preserve = false` nest deps like:
       * - A = 1 => show B
       * - B = 1 => show C
       * - Reset A, need clean B, C
       */ case "remove":
                if (shouldUpdate && $d1298bc083b1892f$var$requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
                    this.reRender();
                    return;
                }
                break;
            case "setField":
                {
                    const { data: data } = info;
                    if (namePathMatch) {
                        if ("touched" in data) this.touched = data.touched;
                        if ("validating" in data && !("originRCField" in data)) this.validatePromise = data.validating ? Promise.resolve([]) : null;
                        if ("errors" in data) this.errors = data.errors || $d1298bc083b1892f$var$EMPTY_ERRORS;
                        if ("warnings" in data) this.warnings = data.warnings || $d1298bc083b1892f$var$EMPTY_WARNINGS;
                        this.dirty = true;
                        this.triggerMetaEvent();
                        this.reRender();
                        return;
                    } else if ("value" in data && (0, $8e145835e5ed0368$export$646d5504364ae55b)(namePathList, namePath, true)) {
                        // Contains path with value should also check
                        this.reRender();
                        return;
                    }
                    // Handle update by `setField` with `shouldUpdate`
                    if (shouldUpdate && !namePath.length && $d1298bc083b1892f$var$requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
                        this.reRender();
                        return;
                    }
                    break;
                }
            case "dependenciesUpdate":
                {
                    /**
           * Trigger when marked `dependencies` updated. Related fields will all update
           */ const dependencyList = dependencies.map((0, $8e145835e5ed0368$export$f877b3cb4cb4ccf9));
                    // No need for `namePathMath` check and `shouldUpdate` check, since `valueUpdate` will be
                    // emitted earlier and they will work there
                    // If set it may cause unnecessary twice rerendering
                    if (dependencyList.some((dependency)=>(0, $8e145835e5ed0368$export$646d5504364ae55b)(info.relatedFields, dependency))) {
                        this.reRender();
                        return;
                    }
                    break;
                }
            default:
                // 1. If `namePath` exists in `namePathList`, means it's related value and should update
                //      For example <List name="list"><Field name={['list', 0]}></List>
                //      If `namePathList` is [['list']] (List value update), Field should be updated
                //      If `namePathList` is [['list', 0]] (Field value update), List shouldn't be updated
                // 2.
                //   2.1 If `dependencies` is set, `name` is not set and `shouldUpdate` is not set,
                //       don't use `shouldUpdate`. `dependencies` is view as a shortcut if `shouldUpdate`
                //       is not provided
                //   2.2 If `shouldUpdate` provided, use customize logic to update the field
                //       else to check if value changed
                if (namePathMatch || (!dependencies.length || namePath.length || shouldUpdate) && $d1298bc083b1892f$var$requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
                    this.reRender();
                    return;
                }
                break;
        }
        if (shouldUpdate === true) this.reRender();
    };
    validateRules = (options)=>{
        // We should fixed namePath & value to avoid developer change then by form function
        const namePath = this.getNamePath();
        const currentValue = this.getValue();
        const { triggerName: triggerName, validateOnly: validateOnly = false, delayFrame: showDelayFrame } = options || {};
        // Force change to async to avoid rule OOD under renderProps field
        const rootPromise = Promise.resolve().then(async ()=>{
            if (!this.mounted) return [];
            const { validateFirst: validateFirst = false, messageVariables: messageVariables, validateDebounce: validateDebounce } = this.props;
            // Should wait for the frame render,
            // since developer may `useWatch` value in the rules.
            if (showDelayFrame) await (0, $0e92a4dd0019be86$export$2e2bcd8739ae039)();
            // Start validate
            let filteredRules = this.getRules();
            if (triggerName) filteredRules = filteredRules.filter((rule)=>rule).filter((rule)=>{
                const { validateTrigger: validateTrigger } = rule;
                if (!validateTrigger) return true;
                const triggerList = (0, $95fac96d9e2bedd3$export$45b10814cc054894)(validateTrigger);
                return triggerList.includes(triggerName);
            });
            // Wait for debounce. Skip if no `triggerName` since its from `validateFields / submit`
            if (validateDebounce && triggerName) {
                await new Promise((resolve)=>{
                    setTimeout(resolve, validateDebounce);
                });
                // Skip since out of date
                if (this.validatePromise !== rootPromise) return [];
            }
            const promise = (0, $0cf59ff0f52c7bb2$export$e1fc4b442d0297dd)(namePath, currentValue, filteredRules, options, validateFirst, messageVariables);
            promise.catch((e)=>e).then((ruleErrors = $d1298bc083b1892f$var$EMPTY_ERRORS)=>{
                if (this.validatePromise === rootPromise) {
                    this.validatePromise = null;
                    // Get errors & warnings
                    const nextErrors = [];
                    const nextWarnings = [];
                    ruleErrors.forEach?.(({ rule: { warningOnly: warningOnly }, errors: errors = $d1298bc083b1892f$var$EMPTY_ERRORS })=>{
                        if (warningOnly) nextWarnings.push(...errors);
                        else nextErrors.push(...errors);
                    });
                    this.errors = nextErrors;
                    this.warnings = nextWarnings;
                    this.triggerMetaEvent();
                    this.reRender();
                }
            });
            return promise;
        });
        if (validateOnly) return rootPromise;
        this.validatePromise = rootPromise;
        this.dirty = true;
        this.errors = $d1298bc083b1892f$var$EMPTY_ERRORS;
        this.warnings = $d1298bc083b1892f$var$EMPTY_WARNINGS;
        this.triggerMetaEvent();
        // Force trigger re-render since we need sync renderProps with new meta
        this.reRender();
        return rootPromise;
    };
    isFieldValidating = ()=>!!this.validatePromise;
    isFieldTouched = ()=>this.touched;
    isFieldDirty = ()=>{
        // Touched or validate or has initialValue
        if (this.dirty || this.props.initialValue !== undefined) return true;
        // Form set initialValue
        const { fieldContext: fieldContext } = this.props;
        const { getInitialValue: getInitialValue } = fieldContext.getInternalHooks((0, $7b2f48a2d7a9ccda$export$24829b7c0e49e9f7));
        if (getInitialValue(this.getNamePath()) !== undefined) return true;
        return false;
    };
    getErrors = ()=>this.errors;
    getWarnings = ()=>this.warnings;
    isListField = ()=>this.props.isListField;
    isList = ()=>this.props.isList;
    isPreserve = ()=>this.props.preserve;
    // ============================= Child Component =============================
    getMeta = ()=>{
        // Make error & validating in cache to save perf
        this.prevValidating = this.isFieldValidating();
        const meta = {
            touched: this.isFieldTouched(),
            validating: this.prevValidating,
            errors: this.errors,
            warnings: this.warnings,
            name: this.getNamePath(),
            validated: this.validatePromise === null
        };
        return meta;
    };
    // Only return validate child node. If invalidate, will do nothing about field.
    getOnlyChild = (children)=>{
        // Support render props
        if (typeof children === "function") {
            const meta = this.getMeta();
            return {
                ...this.getOnlyChild(children(this.getControlled(), meta, this.props.fieldContext)),
                isFunction: true
            };
        }
        // Filed element only
        const childList = (0, $cd966a313e0a92ff$export$2e2bcd8739ae039)(children);
        if (childList.length !== 1 || !/*#__PURE__*/ $cQmXV.isValidElement(childList[0])) return {
            child: childList,
            isFunction: false
        };
        return {
            child: childList[0],
            isFunction: false
        };
    };
    // ============================== Field Control ==============================
    getValue = (store)=>{
        const { getFieldsValue: getFieldsValue } = this.props.fieldContext;
        const namePath = this.getNamePath();
        return (0, $bb62aae17cbc8bd7$export$2e2bcd8739ae039)(store || getFieldsValue(true), namePath);
    };
    getControlled = (childProps = {})=>{
        const { name: name, trigger: trigger = "onChange", validateTrigger: validateTrigger, getValueFromEvent: getValueFromEvent, normalize: normalize, valuePropName: valuePropName = "value", getValueProps: getValueProps, fieldContext: fieldContext } = this.props;
        const mergedValidateTrigger = validateTrigger !== undefined ? validateTrigger : fieldContext.validateTrigger;
        const namePath = this.getNamePath();
        const { getInternalHooks: getInternalHooks, getFieldsValue: getFieldsValue } = fieldContext;
        const { dispatch: dispatch } = getInternalHooks((0, $7b2f48a2d7a9ccda$export$24829b7c0e49e9f7));
        const value = this.getValue();
        const mergedGetValueProps = getValueProps || ((val)=>({
                [valuePropName]: val
            }));
        const originTriggerFunc = childProps[trigger];
        const valueProps = name !== undefined ? mergedGetValueProps(value) : {};
        var key;
        const control = {
            ...childProps,
            ...valueProps
        };
        // Add trigger
        control[trigger] = (...args)=>{
            // Mark as touched
            this.touched = true;
            this.dirty = true;
            this.triggerMetaEvent();
            const curValue = this.getValue();
            let newValue;
            if (getValueFromEvent) newValue = getValueFromEvent(...args);
            else newValue = (0, $8e145835e5ed0368$export$6eeac3c5b406fb30)(valuePropName, ...args);
            if (normalize) newValue = normalize(newValue, curValue, getFieldsValue(true));
            if (newValue !== curValue) dispatch({
                type: "updateValue",
                namePath: namePath,
                value: newValue
            });
            if (originTriggerFunc) originTriggerFunc(...args);
        };
        // Add validateTrigger
        const validateTriggerList = (0, $95fac96d9e2bedd3$export$45b10814cc054894)(mergedValidateTrigger || []);
        validateTriggerList.forEach((triggerName)=>{
            // Wrap additional function of component, so that we can get latest value from store
            const originTrigger = control[triggerName];
            control[triggerName] = (...args)=>{
                if (originTrigger) originTrigger(...args);
                // Always use latest rules
                const { rules: rules } = this.props;
                if (rules && rules.length) // We dispatch validate to root,
                // since it will update related data with other field with same name
                dispatch({
                    type: "validateField",
                    namePath: namePath,
                    triggerName: triggerName
                });
            };
        });
        return control;
    };
    render() {
        const { resetCount: resetCount } = this.state;
        const { children: children } = this.props;
        const { child: child, isFunction: isFunction } = this.getOnlyChild(children);
        // Not need to `cloneElement` since user can handle this in render function self
        let returnChildNode;
        if (isFunction) returnChildNode = child;
        else if (/*#__PURE__*/ $cQmXV.isValidElement(child)) returnChildNode = /*#__PURE__*/ $cQmXV.cloneElement(child, this.getControlled(child.props));
        else {
            (0, $26d7cf6379fe7659$export$2e2bcd8739ae039)(!child, "`children` of Field is not validate ReactElement.");
            returnChildNode = child;
        }
        return /*#__PURE__*/ $cQmXV.createElement($cQmXV.Fragment, {
            key: resetCount
        }, returnChildNode);
    }
}
function $d1298bc083b1892f$var$WrapperField({ name: name, ...restProps }) {
    const fieldContext = $cQmXV.useContext((0, $7b2f48a2d7a9ccda$export$2e2bcd8739ae039));
    const listContext = $cQmXV.useContext((0, $e8f8acdce8879be3$export$2e2bcd8739ae039));
    const namePath = name !== undefined ? (0, $8e145835e5ed0368$export$f877b3cb4cb4ccf9)(name) : undefined;
    const isMergedListField = restProps.isListField ?? !!listContext;
    let key = "keep";
    if (!isMergedListField) key = `_${(namePath || []).join("_")}`;
    return /*#__PURE__*/ $cQmXV.createElement($d1298bc083b1892f$var$Field, $d1298bc083b1892f$var$_extends({
        key: key,
        name: namePath,
        isListField: isMergedListField
    }, restProps, {
        fieldContext: fieldContext
    }));
}
var $d1298bc083b1892f$export$2e2bcd8739ae039 = $d1298bc083b1892f$var$WrapperField;



var $cQmXV = parcelRequire("cQmXV");





function $257bd90c8a7c2d10$var$List({ name: name, initialValue: initialValue, children: children, rules: rules, validateTrigger: validateTrigger, isListField: isListField }) {
    const context = $cQmXV.useContext((0, $7b2f48a2d7a9ccda$export$2e2bcd8739ae039));
    const wrapperListContext = $cQmXV.useContext((0, $e8f8acdce8879be3$export$2e2bcd8739ae039));
    const keyRef = $cQmXV.useRef({
        keys: [],
        id: 0
    });
    const keyManager = keyRef.current;
    const prefixName = $cQmXV.useMemo(()=>{
        const parentPrefixName = (0, $8e145835e5ed0368$export$f877b3cb4cb4ccf9)(context.prefixName) || [];
        return [
            ...parentPrefixName,
            ...(0, $8e145835e5ed0368$export$f877b3cb4cb4ccf9)(name)
        ];
    }, [
        context.prefixName,
        name
    ]);
    const fieldContext = $cQmXV.useMemo(()=>({
            ...context,
            prefixName: prefixName
        }), [
        context,
        prefixName
    ]);
    // List context
    const listContext = $cQmXV.useMemo(()=>({
            getKey: (namePath)=>{
                const len = prefixName.length;
                const pathName = namePath[len];
                return [
                    keyManager.keys[pathName],
                    namePath.slice(len + 1)
                ];
            }
        }), [
        keyManager,
        prefixName
    ]);
    // User should not pass `children` as other type.
    if (typeof children !== "function") {
        (0, $26d7cf6379fe7659$export$2e2bcd8739ae039)(false, "Form.List only accepts function as children.");
        return null;
    }
    const shouldUpdate = (prevValue, nextValue, { source: source })=>{
        if (source === "internal") return false;
        return prevValue !== nextValue;
    };
    return /*#__PURE__*/ $cQmXV.createElement((0, $e8f8acdce8879be3$export$2e2bcd8739ae039).Provider, {
        value: listContext
    }, /*#__PURE__*/ $cQmXV.createElement((0, $7b2f48a2d7a9ccda$export$2e2bcd8739ae039).Provider, {
        value: fieldContext
    }, /*#__PURE__*/ $cQmXV.createElement((0, $d1298bc083b1892f$export$2e2bcd8739ae039), {
        name: [],
        shouldUpdate: shouldUpdate,
        rules: rules,
        validateTrigger: validateTrigger,
        initialValue: initialValue,
        isList: true,
        isListField: isListField ?? !!wrapperListContext
    }, ({ value: value = [], onChange: onChange }, meta)=>{
        const { getFieldValue: getFieldValue } = context;
        const getNewValue = ()=>{
            const values = getFieldValue(prefixName || []);
            return values || [];
        };
        /**
     * Always get latest value in case user update fields by `form` api.
     */ const operations = {
            add: (defaultValue, index)=>{
                // Mapping keys
                const newValue = getNewValue();
                if (index >= 0 && index <= newValue.length) {
                    keyManager.keys = [
                        ...keyManager.keys.slice(0, index),
                        keyManager.id,
                        ...keyManager.keys.slice(index)
                    ];
                    onChange([
                        ...newValue.slice(0, index),
                        defaultValue,
                        ...newValue.slice(index)
                    ]);
                } else {
                    keyManager.keys = [
                        ...keyManager.keys,
                        keyManager.id
                    ];
                    onChange([
                        ...newValue,
                        defaultValue
                    ]);
                }
                keyManager.id += 1;
            },
            remove: (index)=>{
                const newValue = getNewValue();
                const indexSet = new Set(Array.isArray(index) ? index : [
                    index
                ]);
                if (indexSet.size <= 0) return;
                keyManager.keys = keyManager.keys.filter((_, keysIndex)=>!indexSet.has(keysIndex));
                // Trigger store change
                onChange(newValue.filter((_, valueIndex)=>!indexSet.has(valueIndex)));
            },
            move (from, to) {
                if (from === to) return;
                const newValue = getNewValue();
                // Do not handle out of range
                if (from < 0 || from >= newValue.length || to < 0 || to >= newValue.length) return;
                keyManager.keys = (0, $8e145835e5ed0368$export$d947e5f4f4c48d48)(keyManager.keys, from, to);
                // Trigger store change
                onChange((0, $8e145835e5ed0368$export$d947e5f4f4c48d48)(newValue, from, to));
            }
        };
        let listValue = value || [];
        if (!Array.isArray(listValue)) listValue = [];
        return children(listValue.map((__, index)=>{
            let key = keyManager.keys[index];
            if (key === undefined) {
                keyManager.keys[index] = keyManager.id;
                key = keyManager.keys[index];
                keyManager.id += 1;
            }
            return {
                name: index,
                key: key,
                isListField: true
            };
        }), operations, meta);
    })));
}
var $257bd90c8a7c2d10$export$2e2bcd8739ae039 = $257bd90c8a7c2d10$var$List;




var $cQmXV = parcelRequire("cQmXV");

function $1fd952ed8d406b0b$export$6152adfdcc6be2b5(promiseList) {
    let hasError = false;
    let count = promiseList.length;
    const results = [];
    if (!promiseList.length) return Promise.resolve([]);
    return new Promise((resolve, reject)=>{
        promiseList.forEach((promise, index)=>{
            promise.catch((e)=>{
                hasError = true;
                return e;
            }).then((result)=>{
                count -= 1;
                results[index] = result;
                if (count > 0) return;
                if (hasError) reject(results);
                resolve(results);
            });
        });
    });
}



const $09b74f6b906406a8$var$SPLIT = "__@field_split__";
/**
 * Convert name path into string to fast the fetch speed of Map.
 */ function $09b74f6b906406a8$var$normalize(namePath) {
    return namePath.map((cell)=>`${typeof cell}:${cell}`)// Magic split
    .join($09b74f6b906406a8$var$SPLIT);
}
/**
 * NameMap like a `Map` but accepts `string[]` as key.
 */ class $09b74f6b906406a8$var$NameMap {
    kvs = new Map();
    set(key, value) {
        this.kvs.set($09b74f6b906406a8$var$normalize(key), value);
    }
    get(key) {
        return this.kvs.get($09b74f6b906406a8$var$normalize(key));
    }
    getAsPrefix(key) {
        const normalizedKey = $09b74f6b906406a8$var$normalize(key);
        const normalizedPrefix = normalizedKey + $09b74f6b906406a8$var$SPLIT;
        const results = [];
        const current = this.kvs.get(normalizedKey);
        if (current !== undefined) results.push(current);
        this.kvs.forEach((value, itemNormalizedKey)=>{
            if (itemNormalizedKey.startsWith(normalizedPrefix)) results.push(value);
        });
        return results;
    }
    update(key, updater) {
        const origin = this.get(key);
        const next = updater(origin);
        if (!next) this.delete(key);
        else this.set(key, next);
    }
    delete(key) {
        this.kvs.delete($09b74f6b906406a8$var$normalize(key));
    }
    // Since we only use this in test, let simply realize this
    map(callback) {
        return [
            ...this.kvs.entries()
        ].map(([key, value])=>{
            const cells = key.split($09b74f6b906406a8$var$SPLIT);
            return callback({
                key: cells.map((cell)=>{
                    const [, type, unit] = cell.match(/^([^:]*):(.*)$/);
                    return type === "number" ? Number(unit) : unit;
                }),
                value: value
            });
        });
    }
    toJSON() {
        const json = {};
        this.map(({ key: key, value: value })=>{
            json[key.join(".")] = value;
            return null;
        });
        return json;
    }
}
var $09b74f6b906406a8$export$2e2bcd8739ae039 = $09b74f6b906406a8$var$NameMap;




class $616d24d3edb0e567$export$75ff1ab1187e691 {
    formHooked = false;
    forceRootUpdate;
    subscribable = true;
    store = {};
    fieldEntities = [];
    initialValues = {};
    callbacks = {};
    validateMessages = null;
    preserve = null;
    lastValidatePromise = null;
    watcherCenter = new (0, $918bfb875b2e6ecb$export$2e2bcd8739ae039)(this);
    constructor(forceRootUpdate){
        this.forceRootUpdate = forceRootUpdate;
    }
    getForm = ()=>({
            getFieldValue: this.getFieldValue,
            getFieldsValue: this.getFieldsValue,
            getFieldError: this.getFieldError,
            getFieldWarning: this.getFieldWarning,
            getFieldsError: this.getFieldsError,
            isFieldsTouched: this.isFieldsTouched,
            isFieldTouched: this.isFieldTouched,
            isFieldValidating: this.isFieldValidating,
            isFieldsValidating: this.isFieldsValidating,
            resetFields: this.resetFields,
            setFields: this.setFields,
            setFieldValue: this.setFieldValue,
            setFieldsValue: this.setFieldsValue,
            validateFields: this.validateFields,
            submit: this.submit,
            _init: true,
            getInternalHooks: this.getInternalHooks
        });
    // ======================== Internal Hooks ========================
    getInternalHooks = (key)=>{
        if (key === (0, $7b2f48a2d7a9ccda$export$24829b7c0e49e9f7)) {
            this.formHooked = true;
            return {
                dispatch: this.dispatch,
                initEntityValue: this.initEntityValue,
                registerField: this.registerField,
                useSubscribe: this.useSubscribe,
                setInitialValues: this.setInitialValues,
                destroyForm: this.destroyForm,
                setCallbacks: this.setCallbacks,
                setValidateMessages: this.setValidateMessages,
                getFields: this.getFields,
                setPreserve: this.setPreserve,
                getInitialValue: this.getInitialValue,
                registerWatch: this.registerWatch
            };
        }
        (0, $26d7cf6379fe7659$export$2e2bcd8739ae039)(false, "`getInternalHooks` is internal usage. Should not call directly.");
        return null;
    };
    useSubscribe = (subscribable)=>{
        this.subscribable = subscribable;
    };
    /**
   * Record prev Form unmount fieldEntities which config preserve false.
   * This need to be refill with initialValues instead of store value.
   */ prevWithoutPreserves = null;
    /**
   * First time `setInitialValues` should update store with initial value
   */ setInitialValues = (initialValues, init)=>{
        this.initialValues = initialValues || {};
        if (init) {
            let nextStore = (0, $a3099986deccaee4$export$4950aa0f605343fb)(initialValues, this.store);
            // We will take consider prev form unmount fields.
            // When the field is not `preserve`, we need fill this with initialValues instead of store.
            // eslint-disable-next-line array-callback-return
            this.prevWithoutPreserves?.map(({ key: namePath })=>{
                nextStore = (0, $a3099986deccaee4$export$2e2bcd8739ae039)(nextStore, namePath, (0, $bb62aae17cbc8bd7$export$2e2bcd8739ae039)(initialValues, namePath));
            });
            this.prevWithoutPreserves = null;
            this.updateStore(nextStore);
        }
    };
    destroyForm = (clearOnDestroy)=>{
        if (clearOnDestroy) // destroy form reset store
        this.updateStore({});
        else {
            // Fill preserve fields
            const prevWithoutPreserves = new (0, $09b74f6b906406a8$export$2e2bcd8739ae039)();
            this.getFieldEntities(true).forEach((entity)=>{
                if (!this.isMergedPreserve(entity.isPreserve())) prevWithoutPreserves.set(entity.getNamePath(), true);
            });
            this.prevWithoutPreserves = prevWithoutPreserves;
        }
    };
    getInitialValue = (namePath)=>{
        const initValue = (0, $bb62aae17cbc8bd7$export$2e2bcd8739ae039)(this.initialValues, namePath);
        // Not cloneDeep when without `namePath`
        return namePath.length ? (0, $a3099986deccaee4$export$4950aa0f605343fb)(initValue) : initValue;
    };
    setCallbacks = (callbacks)=>{
        this.callbacks = callbacks;
    };
    setValidateMessages = (validateMessages)=>{
        this.validateMessages = validateMessages;
    };
    setPreserve = (preserve)=>{
        this.preserve = preserve;
    };
    // ============================= Watch ============================
    registerWatch = (callback)=>{
        return this.watcherCenter.register(callback);
    };
    notifyWatch = (namePath = [])=>{
        this.watcherCenter.notify(namePath);
    };
    // ========================== Dev Warning =========================
    timeoutId = null;
    warningUnhooked = ()=>{};
    // ============================ Store =============================
    updateStore = (nextStore)=>{
        this.store = nextStore;
    };
    // ============================ Fields ============================
    /**
   * Get registered field entities.
   * @param pure Only return field which has a `name`. Default: false
   */ getFieldEntities = (pure = false)=>{
        if (!pure) return this.fieldEntities;
        return this.fieldEntities.filter((field)=>field.getNamePath().length);
    };
    /**
   * Get a map of registered field entities with their name path as the key.
   * @param pure Only include fields which have a `name`. Default: false
   * @returns A NameMap containing field entities indexed by their name paths
   */ getFieldsMap = (pure = false)=>{
        const cache = new (0, $09b74f6b906406a8$export$2e2bcd8739ae039)();
        this.getFieldEntities(pure).forEach((field)=>{
            const namePath = field.getNamePath();
            cache.set(namePath, field);
        });
        return cache;
    };
    /**
   * Get field entities based on a list of name paths.
   * @param nameList - Array of name paths to search for. If not provided, returns all field entities with names.
   * @param includesSubNamePath - Whether to include fields that have the given name path as a prefix.
   */ getFieldEntitiesForNamePathList = (nameList, includesSubNamePath = false)=>{
        if (!nameList) return this.getFieldEntities(true);
        const cache = this.getFieldsMap(true);
        if (!includesSubNamePath) return nameList.map((name)=>{
            const namePath = (0, $8e145835e5ed0368$export$f877b3cb4cb4ccf9)(name);
            return cache.get(namePath) || {
                INVALIDATE_NAME_PATH: (0, $8e145835e5ed0368$export$f877b3cb4cb4ccf9)(name)
            };
        });
        return nameList.flatMap((name)=>{
            const namePath = (0, $8e145835e5ed0368$export$f877b3cb4cb4ccf9)(name);
            const fields = cache.getAsPrefix(namePath);
            if (fields.length) return fields;
            return [
                {
                    INVALIDATE_NAME_PATH: namePath
                }
            ];
        });
    };
    getFieldsValue = (nameList, filterFunc)=>{
        this.warningUnhooked();
        // Fill args
        let mergedNameList;
        let mergedFilterFunc;
        if (nameList === true || Array.isArray(nameList)) {
            mergedNameList = nameList;
            mergedFilterFunc = filterFunc;
        } else if (nameList && typeof nameList === "object") mergedFilterFunc = nameList.filter;
        if (mergedNameList === true && !mergedFilterFunc) return this.store;
        const fieldEntities = this.getFieldEntitiesForNamePathList(Array.isArray(mergedNameList) ? mergedNameList : null, true);
        const filteredNameList = [];
        const listNamePaths = [];
        fieldEntities.forEach((entity)=>{
            const namePath = entity.INVALIDATE_NAME_PATH || entity.getNamePath();
            // Ignore when it's a list item and not specific the namePath,
            // since parent field is already take in count
            if (entity.isList?.()) {
                listNamePaths.push(namePath);
                return;
            }
            if (!mergedFilterFunc) filteredNameList.push(namePath);
            else {
                const meta = "getMeta" in entity ? entity.getMeta() : null;
                if (mergedFilterFunc(meta)) filteredNameList.push(namePath);
            }
        });
        let mergedValues = (0, $8e145835e5ed0368$export$f5be6dfb30403c59)(this.store, filteredNameList.map((0, $8e145835e5ed0368$export$f877b3cb4cb4ccf9)));
        // We need fill the list as [] if Form.List is empty
        listNamePaths.forEach((namePath)=>{
            if (!(0, $bb62aae17cbc8bd7$export$2e2bcd8739ae039)(mergedValues, namePath)) mergedValues = (0, $a3099986deccaee4$export$2e2bcd8739ae039)(mergedValues, namePath, []);
        });
        return mergedValues;
    };
    getFieldValue = (name)=>{
        this.warningUnhooked();
        const namePath = (0, $8e145835e5ed0368$export$f877b3cb4cb4ccf9)(name);
        return (0, $bb62aae17cbc8bd7$export$2e2bcd8739ae039)(this.store, namePath);
    };
    getFieldsError = (nameList)=>{
        this.warningUnhooked();
        const fieldEntities = this.getFieldEntitiesForNamePathList(nameList);
        return fieldEntities.map((entity, index)=>{
            if (entity && !entity.INVALIDATE_NAME_PATH) return {
                name: entity.getNamePath(),
                errors: entity.getErrors(),
                warnings: entity.getWarnings()
            };
            return {
                name: (0, $8e145835e5ed0368$export$f877b3cb4cb4ccf9)(nameList[index]),
                errors: [],
                warnings: []
            };
        });
    };
    getFieldError = (name)=>{
        this.warningUnhooked();
        const namePath = (0, $8e145835e5ed0368$export$f877b3cb4cb4ccf9)(name);
        const fieldError = this.getFieldsError([
            namePath
        ])[0];
        return fieldError.errors;
    };
    getFieldWarning = (name)=>{
        this.warningUnhooked();
        const namePath = (0, $8e145835e5ed0368$export$f877b3cb4cb4ccf9)(name);
        const fieldError = this.getFieldsError([
            namePath
        ])[0];
        return fieldError.warnings;
    };
    isFieldsTouched = (...args)=>{
        this.warningUnhooked();
        const [arg0, arg1] = args;
        let namePathList;
        let isAllFieldsTouched = false;
        if (args.length === 0) namePathList = null;
        else if (args.length === 1) {
            if (Array.isArray(arg0)) {
                namePathList = arg0.map((0, $8e145835e5ed0368$export$f877b3cb4cb4ccf9));
                isAllFieldsTouched = false;
            } else {
                namePathList = null;
                isAllFieldsTouched = arg0;
            }
        } else {
            namePathList = arg0.map((0, $8e145835e5ed0368$export$f877b3cb4cb4ccf9));
            isAllFieldsTouched = arg1;
        }
        const fieldEntities = this.getFieldEntities(true);
        const isFieldTouched = (field)=>field.isFieldTouched();
        // ===== Will get fully compare when not config namePathList =====
        if (!namePathList) return isAllFieldsTouched ? fieldEntities.every((entity)=>isFieldTouched(entity) || entity.isList()) : fieldEntities.some(isFieldTouched);
        // Generate a nest tree for validate
        const map = new (0, $09b74f6b906406a8$export$2e2bcd8739ae039)();
        namePathList.forEach((shortNamePath)=>{
            map.set(shortNamePath, []);
        });
        fieldEntities.forEach((field)=>{
            const fieldNamePath = field.getNamePath();
            // Find matched entity and put into list
            namePathList.forEach((shortNamePath)=>{
                if (shortNamePath.every((nameUnit, i)=>fieldNamePath[i] === nameUnit)) map.update(shortNamePath, (list)=>[
                        ...list,
                        field
                    ]);
            });
        });
        // Check if NameMap value is touched
        const isNamePathListTouched = (entities)=>entities.some(isFieldTouched);
        const namePathListEntities = map.map(({ value: value })=>value);
        return isAllFieldsTouched ? namePathListEntities.every(isNamePathListTouched) : namePathListEntities.some(isNamePathListTouched);
    };
    isFieldTouched = (name)=>{
        this.warningUnhooked();
        return this.isFieldsTouched([
            name
        ]);
    };
    isFieldsValidating = (nameList)=>{
        this.warningUnhooked();
        const fieldEntities = this.getFieldEntities();
        if (!nameList) return fieldEntities.some((testField)=>testField.isFieldValidating());
        const namePathList = nameList.map((0, $8e145835e5ed0368$export$f877b3cb4cb4ccf9));
        return fieldEntities.some((testField)=>{
            const fieldNamePath = testField.getNamePath();
            return (0, $8e145835e5ed0368$export$646d5504364ae55b)(namePathList, fieldNamePath) && testField.isFieldValidating();
        });
    };
    isFieldValidating = (name)=>{
        this.warningUnhooked();
        return this.isFieldsValidating([
            name
        ]);
    };
    /**
   * Reset Field with field `initialValue` prop.
   * Can pass `entities` or `namePathList` or just nothing.
   */ resetWithFieldInitialValue = (info = {})=>{
        // Create cache
        const cache = new (0, $09b74f6b906406a8$export$2e2bcd8739ae039)();
        const fieldEntities = this.getFieldEntities(true);
        fieldEntities.forEach((field)=>{
            const { initialValue: initialValue } = field.props;
            const namePath = field.getNamePath();
            // Record only if has `initialValue`
            if (initialValue !== undefined) {
                const records = cache.get(namePath) || new Set();
                records.add({
                    entity: field,
                    value: initialValue
                });
                cache.set(namePath, records);
            }
        });
        // Reset
        const resetWithFields = (entities)=>{
            entities.forEach((field)=>{
                const { initialValue: initialValue } = field.props;
                if (initialValue !== undefined) {
                    const namePath = field.getNamePath();
                    const formInitialValue = this.getInitialValue(namePath);
                    if (formInitialValue !== undefined) // Warning if conflict with form initialValues and do not modify value
                    (0, $26d7cf6379fe7659$export$2e2bcd8739ae039)(false, `Form already set 'initialValues' with path '${namePath.join(".")}'. Field can not overwrite it.`);
                    else {
                        const records = cache.get(namePath);
                        if (records && records.size > 1) // Warning if multiple field set `initialValue`and do not modify value
                        (0, $26d7cf6379fe7659$export$2e2bcd8739ae039)(false, `Multiple Field with path '${namePath.join(".")}' set 'initialValue'. Can not decide which one to pick.`);
                        else if (records) {
                            const originValue = this.getFieldValue(namePath);
                            const isListField = field.isListField();
                            // Set `initialValue`
                            if (!isListField && (!info.skipExist || originValue === undefined)) this.updateStore((0, $a3099986deccaee4$export$2e2bcd8739ae039)(this.store, namePath, [
                                ...records
                            ][0].value));
                        }
                    }
                }
            });
        };
        let requiredFieldEntities;
        if (info.entities) requiredFieldEntities = info.entities;
        else if (info.namePathList) {
            requiredFieldEntities = [];
            info.namePathList.forEach((namePath)=>{
                const records = cache.get(namePath);
                if (records) requiredFieldEntities.push(...[
                    ...records
                ].map((r)=>r.entity));
            });
        } else requiredFieldEntities = fieldEntities;
        resetWithFields(requiredFieldEntities);
    };
    resetFields = (nameList)=>{
        this.warningUnhooked();
        const prevStore = this.store;
        if (!nameList) {
            this.updateStore((0, $a3099986deccaee4$export$4950aa0f605343fb)(this.initialValues));
            this.resetWithFieldInitialValue();
            this.notifyObservers(prevStore, null, {
                type: "reset"
            });
            this.notifyWatch();
            return;
        }
        // Reset by `nameList`
        const namePathList = nameList.map((0, $8e145835e5ed0368$export$f877b3cb4cb4ccf9));
        namePathList.forEach((namePath)=>{
            const initialValue = this.getInitialValue(namePath);
            this.updateStore((0, $a3099986deccaee4$export$2e2bcd8739ae039)(this.store, namePath, initialValue));
        });
        this.resetWithFieldInitialValue({
            namePathList: namePathList
        });
        this.notifyObservers(prevStore, namePathList, {
            type: "reset"
        });
        this.notifyWatch(namePathList);
    };
    setFields = (fields)=>{
        this.warningUnhooked();
        const prevStore = this.store;
        const namePathList = [];
        fields.forEach((fieldData)=>{
            const { name: name, ...data } = fieldData;
            const namePath = (0, $8e145835e5ed0368$export$f877b3cb4cb4ccf9)(name);
            namePathList.push(namePath);
            // Value
            if ("value" in data) this.updateStore((0, $a3099986deccaee4$export$2e2bcd8739ae039)(this.store, namePath, data.value));
            this.notifyObservers(prevStore, [
                namePath
            ], {
                type: "setField",
                data: fieldData
            });
        });
        this.notifyWatch(namePathList);
    };
    getFields = ()=>{
        const entities = this.getFieldEntities(true);
        const fields = entities.map((field)=>{
            const namePath = field.getNamePath();
            const meta = field.getMeta();
            const fieldData = {
                ...meta,
                name: namePath,
                value: this.getFieldValue(namePath)
            };
            Object.defineProperty(fieldData, "originRCField", {
                value: true
            });
            return fieldData;
        });
        return fields;
    };
    // =========================== Observer ===========================
    /**
   * This only trigger when a field is on constructor to avoid we get initialValue too late
   */ initEntityValue = (entity)=>{
        const { initialValue: initialValue } = entity.props;
        if (initialValue !== undefined) {
            const namePath = entity.getNamePath();
            const prevValue = (0, $bb62aae17cbc8bd7$export$2e2bcd8739ae039)(this.store, namePath);
            if (prevValue === undefined) this.updateStore((0, $a3099986deccaee4$export$2e2bcd8739ae039)(this.store, namePath, initialValue));
        }
    };
    isMergedPreserve = (fieldPreserve)=>{
        const mergedPreserve = fieldPreserve !== undefined ? fieldPreserve : this.preserve;
        return mergedPreserve ?? true;
    };
    registerField = (entity)=>{
        this.fieldEntities.push(entity);
        const namePath = entity.getNamePath();
        this.notifyWatch([
            namePath
        ]);
        // Set initial values
        if (entity.props.initialValue !== undefined) {
            const prevStore = this.store;
            this.resetWithFieldInitialValue({
                entities: [
                    entity
                ],
                skipExist: true
            });
            this.notifyObservers(prevStore, [
                entity.getNamePath()
            ], {
                type: "valueUpdate",
                source: "internal"
            });
        }
        // un-register field callback
        return (isListField, preserve, subNamePath = [])=>{
            this.fieldEntities = this.fieldEntities.filter((item)=>item !== entity);
            // Clean up store value if not preserve
            if (!this.isMergedPreserve(preserve) && (!isListField || subNamePath.length > 1)) {
                const defaultValue = isListField ? undefined : this.getInitialValue(namePath);
                if (namePath.length && this.getFieldValue(namePath) !== defaultValue && this.fieldEntities.every((field)=>// Only reset when no namePath exist
                    !(0, $8e145835e5ed0368$export$325a4bd0e71bdc3a)(field.getNamePath(), namePath))) {
                    const prevStore = this.store;
                    this.updateStore((0, $a3099986deccaee4$export$2e2bcd8739ae039)(prevStore, namePath, defaultValue, true));
                    // Notify that field is unmount
                    this.notifyObservers(prevStore, [
                        namePath
                    ], {
                        type: "remove"
                    });
                    // Dependencies update
                    this.triggerDependenciesUpdate(prevStore, namePath);
                }
            }
            this.notifyWatch([
                namePath
            ]);
        };
    };
    dispatch = (action)=>{
        switch(action.type){
            case "updateValue":
                {
                    const { namePath: namePath, value: value } = action;
                    this.updateValue(namePath, value);
                    break;
                }
            case "validateField":
                {
                    const { namePath: namePath, triggerName: triggerName } = action;
                    this.validateFields([
                        namePath
                    ], {
                        triggerName: triggerName
                    });
                    break;
                }
            default:
        }
    };
    notifyObservers = (prevStore, namePathList, info)=>{
        if (this.subscribable) {
            const mergedInfo = {
                ...info,
                store: this.getFieldsValue(true)
            };
            this.getFieldEntities().forEach(({ onStoreChange: onStoreChange })=>{
                onStoreChange(prevStore, namePathList, mergedInfo);
            });
        } else this.forceRootUpdate();
    };
    /**
   * Notify dependencies children with parent update
   * We need delay to trigger validate in case Field is under render props
   */ triggerDependenciesUpdate = (prevStore, namePath)=>{
        const childrenFields = this.getDependencyChildrenFields(namePath);
        if (childrenFields.length) this.validateFields(childrenFields, {
            // Delay to avoid `useWatch` dynamic adjust rules that deps not get latest one
            delayFrame: true
        });
        this.notifyObservers(prevStore, childrenFields, {
            type: "dependenciesUpdate",
            relatedFields: [
                namePath,
                ...childrenFields
            ]
        });
        return childrenFields;
    };
    updateValue = (name, value)=>{
        const namePath = (0, $8e145835e5ed0368$export$f877b3cb4cb4ccf9)(name);
        const prevStore = this.store;
        this.updateStore((0, $a3099986deccaee4$export$2e2bcd8739ae039)(this.store, namePath, value));
        this.notifyObservers(prevStore, [
            namePath
        ], {
            type: "valueUpdate",
            source: "internal"
        });
        this.notifyWatch([
            namePath
        ]);
        // Dependencies update
        const childrenFields = this.triggerDependenciesUpdate(prevStore, namePath);
        // trigger callback function
        const { onValuesChange: onValuesChange } = this.callbacks;
        if (onValuesChange) {
            const changedValues = (0, $8e145835e5ed0368$export$f5be6dfb30403c59)(this.store, [
                namePath
            ]);
            const allValues = this.getFieldsValue();
            const mergedAllValues = (0, $a3099986deccaee4$export$2e2bcd8739ae039)(allValues, namePath, (0, $bb62aae17cbc8bd7$export$2e2bcd8739ae039)(changedValues, namePath));
            onValuesChange(changedValues, mergedAllValues);
        }
        this.triggerOnFieldsChange([
            namePath,
            ...childrenFields
        ]);
    };
    // Let all child Field get update.
    setFieldsValue = (store)=>{
        this.warningUnhooked();
        const prevStore = this.store;
        if (store) {
            const nextStore = (0, $a3099986deccaee4$export$4950aa0f605343fb)(this.store, store);
            this.updateStore(nextStore);
        }
        this.notifyObservers(prevStore, null, {
            type: "valueUpdate",
            source: "external"
        });
        this.notifyWatch();
    };
    setFieldValue = (name, value)=>{
        this.setFields([
            {
                name: name,
                value: value,
                errors: [],
                warnings: [],
                touched: true
            }
        ]);
    };
    getDependencyChildrenFields = (rootNamePath)=>{
        const children = new Set();
        const childrenFields = [];
        const dependencies2fields = new (0, $09b74f6b906406a8$export$2e2bcd8739ae039)();
        /**
     * Generate maps
     * Can use cache to save perf if user report performance issue with this
     */ this.getFieldEntities().forEach((field)=>{
            const { dependencies: dependencies } = field.props;
            (dependencies || []).forEach((dependency)=>{
                const dependencyNamePath = (0, $8e145835e5ed0368$export$f877b3cb4cb4ccf9)(dependency);
                dependencies2fields.update(dependencyNamePath, (fields = new Set())=>{
                    fields.add(field);
                    return fields;
                });
            });
        });
        const fillChildren = (namePath)=>{
            const fields = dependencies2fields.get(namePath) || new Set();
            fields.forEach((field)=>{
                if (!children.has(field)) {
                    children.add(field);
                    const fieldNamePath = field.getNamePath();
                    if (field.isFieldDirty() && fieldNamePath.length) {
                        childrenFields.push(fieldNamePath);
                        fillChildren(fieldNamePath);
                    }
                }
            });
        };
        fillChildren(rootNamePath);
        return childrenFields;
    };
    triggerOnFieldsChange = (namePathList, filedErrors)=>{
        const { onFieldsChange: onFieldsChange } = this.callbacks;
        if (onFieldsChange) {
            const fields = this.getFields();
            /**
       * Fill errors since `fields` may be replaced by controlled fields
       */ if (filedErrors) {
                const cache = new (0, $09b74f6b906406a8$export$2e2bcd8739ae039)();
                filedErrors.forEach(({ name: name, errors: errors })=>{
                    cache.set(name, errors);
                });
                fields.forEach((field)=>{
                    // eslint-disable-next-line no-param-reassign
                    field.errors = cache.get(field.name) || field.errors;
                });
            }
            const changedFields = fields.filter(({ name: fieldName })=>(0, $8e145835e5ed0368$export$646d5504364ae55b)(namePathList, fieldName));
            if (changedFields.length) onFieldsChange(changedFields, fields);
        }
    };
    // =========================== Validate ===========================
    validateFields = (arg1, arg2)=>{
        this.warningUnhooked();
        let nameList;
        let options;
        if (Array.isArray(arg1) || typeof arg1 === "string" || typeof arg2 === "string") {
            nameList = arg1;
            options = arg2;
        } else options = arg1;
        const provideNameList = !!nameList;
        const namePathList = provideNameList ? nameList.map((0, $8e145835e5ed0368$export$f877b3cb4cb4ccf9)) : [];
        // Same namePathList, but does not include Form.List name
        const finalValueNamePathList = [
            ...namePathList
        ];
        // Collect result in promise list
        const promiseList = [];
        // We temp save the path which need trigger for `onFieldsChange`
        const TMP_SPLIT = String(Date.now());
        const validateNamePathList = new Set();
        const { recursive: recursive, dirty: dirty } = options || {};
        this.getFieldEntities(true).forEach((field)=>{
            const fieldNamePath = field.getNamePath();
            // Add field if not provide `nameList`
            if (!provideNameList) {
                if (// If is field, pass directly
                !field.isList() || // If is list, do not add if already exist sub field in the namePathList
                !namePathList.some((name)=>(0, $8e145835e5ed0368$export$325a4bd0e71bdc3a)(name, fieldNamePath, true))) finalValueNamePathList.push(fieldNamePath);
                namePathList.push(fieldNamePath);
            }
            // Skip if without rule
            if (!field.props.rules || !field.props.rules.length) return;
            // Skip if only validate dirty field
            if (dirty && !field.isFieldDirty()) return;
            validateNamePathList.add(fieldNamePath.join(TMP_SPLIT));
            // Add field validate rule in to promise list
            if (!provideNameList || (0, $8e145835e5ed0368$export$646d5504364ae55b)(namePathList, fieldNamePath, recursive)) {
                const promise = field.validateRules({
                    validateMessages: {
                        ...(0, $676816715e783bda$export$c86b939816b8fbf8),
                        ...this.validateMessages
                    },
                    ...options
                });
                // Wrap promise with field
                promiseList.push(promise.then(()=>({
                        name: fieldNamePath,
                        errors: [],
                        warnings: []
                    })).catch((ruleErrors)=>{
                    const mergedErrors = [];
                    const mergedWarnings = [];
                    ruleErrors.forEach?.(({ rule: { warningOnly: warningOnly }, errors: errors })=>{
                        if (warningOnly) mergedWarnings.push(...errors);
                        else mergedErrors.push(...errors);
                    });
                    if (mergedErrors.length) return Promise.reject({
                        name: fieldNamePath,
                        errors: mergedErrors,
                        warnings: mergedWarnings
                    });
                    return {
                        name: fieldNamePath,
                        errors: mergedErrors,
                        warnings: mergedWarnings
                    };
                }));
            }
        });
        const summaryPromise = (0, $1fd952ed8d406b0b$export$6152adfdcc6be2b5)(promiseList);
        this.lastValidatePromise = summaryPromise;
        // Notify fields with rule that validate has finished and need update
        summaryPromise.catch((results)=>results).then((results)=>{
            const resultNamePathList = results.map(({ name: name })=>name);
            this.notifyObservers(this.store, resultNamePathList, {
                type: "validateFinish"
            });
            this.triggerOnFieldsChange(resultNamePathList, results);
        });
        const returnPromise = summaryPromise.then(()=>{
            if (this.lastValidatePromise === summaryPromise) return Promise.resolve(this.getFieldsValue(finalValueNamePathList));
            return Promise.reject([]);
        }).catch((results)=>{
            const errorList = results.filter((result)=>result && result.errors.length);
            const errorMessage = errorList[0]?.errors?.[0];
            return Promise.reject({
                message: errorMessage,
                values: this.getFieldsValue(namePathList),
                errorFields: errorList,
                outOfDate: this.lastValidatePromise !== summaryPromise
            });
        });
        // Do not throw in console
        returnPromise.catch((e)=>e);
        // `validating` changed. Trigger `onFieldsChange`
        const triggerNamePathList = namePathList.filter((namePath)=>validateNamePathList.has(namePath.join(TMP_SPLIT)));
        this.triggerOnFieldsChange(triggerNamePathList);
        return returnPromise;
    };
    // ============================ Submit ============================
    submit = ()=>{
        this.warningUnhooked();
        this.validateFields().then((values)=>{
            const { onFinish: onFinish } = this.callbacks;
            if (onFinish) try {
                onFinish(values);
            } catch (err) {
                // Should print error if user `onFinish` callback failed
                console.error(err);
            }
        }).catch((e)=>{
            const { onFinishFailed: onFinishFailed } = this.callbacks;
            if (onFinishFailed) onFinishFailed(e);
        });
    };
}
function $616d24d3edb0e567$var$useForm(form) {
    const formRef = $cQmXV.useRef(null);
    const [, forceUpdate] = $cQmXV.useState({});
    // Create singleton FormStore
    if (!formRef.current) {
        if (form) formRef.current = form;
        else {
            // Create a new FormStore if not provided
            const forceReRender = ()=>{
                forceUpdate({});
            };
            const formStore = new $616d24d3edb0e567$export$75ff1ab1187e691(forceReRender);
            formRef.current = formStore.getForm();
        }
    }
    return [
        formRef.current
    ];
}
var $616d24d3edb0e567$export$2e2bcd8739ae039 = $616d24d3edb0e567$var$useForm;



var $cQmXV = parcelRequire("cQmXV");



var $cQmXV = parcelRequire("cQmXV");
const $11fe1b3ccf1eb181$var$FormContext = /*#__PURE__*/ $cQmXV.createContext({
    triggerFormChange: ()=>{},
    triggerFormFinish: ()=>{},
    registerForm: ()=>{},
    unregisterForm: ()=>{}
});
const $11fe1b3ccf1eb181$export$8ce1ff4f94d08846 = ({ validateMessages: validateMessages, onFormChange: onFormChange, onFormFinish: onFormFinish, children: children })=>{
    const formContext = $cQmXV.useContext($11fe1b3ccf1eb181$var$FormContext);
    const formsRef = $cQmXV.useRef({});
    return /*#__PURE__*/ $cQmXV.createElement($11fe1b3ccf1eb181$var$FormContext.Provider, {
        value: {
            ...formContext,
            validateMessages: {
                ...formContext.validateMessages,
                ...validateMessages
            },
            // =========================================================
            // =                  Global Form Control                  =
            // =========================================================
            triggerFormChange: (name, changedFields)=>{
                if (onFormChange) onFormChange(name, {
                    changedFields: changedFields,
                    forms: formsRef.current
                });
                formContext.triggerFormChange(name, changedFields);
            },
            triggerFormFinish: (name, values)=>{
                if (onFormFinish) onFormFinish(name, {
                    values: values,
                    forms: formsRef.current
                });
                formContext.triggerFormFinish(name, values);
            },
            registerForm: (name, form)=>{
                if (name) formsRef.current = {
                    ...formsRef.current,
                    [name]: form
                };
                formContext.registerForm(name, form);
            },
            unregisterForm: (name)=>{
                const newForms = {
                    ...formsRef.current
                };
                delete newForms[name];
                formsRef.current = newForms;
                formContext.unregisterForm(name);
            }
        }
    }, children);
};
var $11fe1b3ccf1eb181$export$2e2bcd8739ae039 = $11fe1b3ccf1eb181$var$FormContext;




function $0501e1a1a351a153$var$_extends() {
    $0501e1a1a351a153$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0501e1a1a351a153$var$_extends.apply(this, arguments);
}
const $0501e1a1a351a153$var$Form = (props, ref)=>{
    const { name: name, initialValues: initialValues, fields: fields, form: form, preserve: preserve, children: children, component: Component = "form", validateMessages: validateMessages, validateTrigger: validateTrigger = "onChange", onValuesChange: onValuesChange, onFieldsChange: onFieldsChange, onFinish: onFinish, onFinishFailed: onFinishFailed, clearOnDestroy: clearOnDestroy, ...restProps } = props;
    const nativeElementRef = $cQmXV.useRef(null);
    const formContext = $cQmXV.useContext((0, $11fe1b3ccf1eb181$export$2e2bcd8739ae039));
    // We customize handle event since Context will makes all the consumer re-render:
    // https://reactjs.org/docs/context.html#contextprovider
    const [formInstance] = (0, $616d24d3edb0e567$export$2e2bcd8739ae039)(form);
    const { useSubscribe: useSubscribe, setInitialValues: setInitialValues, setCallbacks: setCallbacks, setValidateMessages: setValidateMessages, setPreserve: setPreserve, destroyForm: destroyForm } = formInstance.getInternalHooks((0, $7b2f48a2d7a9ccda$export$24829b7c0e49e9f7));
    // Pass ref with form instance
    $cQmXV.useImperativeHandle(ref, ()=>({
            ...formInstance,
            nativeElement: nativeElementRef.current
        }));
    // Register form into Context
    $cQmXV.useEffect(()=>{
        formContext.registerForm(name, formInstance);
        return ()=>{
            formContext.unregisterForm(name);
        };
    }, [
        formContext,
        formInstance,
        name
    ]);
    // Pass props to store
    setValidateMessages({
        ...formContext.validateMessages,
        ...validateMessages
    });
    setCallbacks({
        onValuesChange: onValuesChange,
        onFieldsChange: (changedFields, ...rest)=>{
            formContext.triggerFormChange(name, changedFields);
            if (onFieldsChange) onFieldsChange(changedFields, ...rest);
        },
        onFinish: (values)=>{
            formContext.triggerFormFinish(name, values);
            if (onFinish) onFinish(values);
        },
        onFinishFailed: onFinishFailed
    });
    setPreserve(preserve);
    // Set initial value, init store value when first mount
    const mountRef = $cQmXV.useRef(null);
    setInitialValues(initialValues, !mountRef.current);
    if (!mountRef.current) mountRef.current = true;
    // ========================== Unmount ===========================
    $cQmXV.useEffect(()=>()=>destroyForm(clearOnDestroy), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // Prepare children by `children` type
    let childrenNode;
    const childrenRenderProps = typeof children === "function";
    if (childrenRenderProps) {
        const values = formInstance.getFieldsValue(true);
        childrenNode = children(values, formInstance);
    } else childrenNode = children;
    // Not use subscribe when using render props
    useSubscribe(!childrenRenderProps);
    // Listen if fields provided. We use ref to save prev data here to avoid additional render
    const prevFieldsRef = $cQmXV.useRef(null);
    $cQmXV.useEffect(()=>{
        if (!(0, $8e145835e5ed0368$export$dfcec05bb7372a54)(prevFieldsRef.current || [], fields || [])) formInstance.setFields(fields || []);
        prevFieldsRef.current = fields;
    }, [
        fields,
        formInstance
    ]);
    // =========================== Render ===========================
    const formContextValue = $cQmXV.useMemo(()=>({
            ...formInstance,
            validateTrigger: validateTrigger
        }), [
        formInstance,
        validateTrigger
    ]);
    const wrapperNode = /*#__PURE__*/ $cQmXV.createElement((0, $e8f8acdce8879be3$export$2e2bcd8739ae039).Provider, {
        value: null
    }, /*#__PURE__*/ $cQmXV.createElement((0, $7b2f48a2d7a9ccda$export$2e2bcd8739ae039).Provider, {
        value: formContextValue
    }, childrenNode));
    if (Component === false) return wrapperNode;
    return /*#__PURE__*/ $cQmXV.createElement(Component, $0501e1a1a351a153$var$_extends({}, restProps, {
        ref: nativeElementRef,
        onSubmit: (event)=>{
            event.preventDefault();
            event.stopPropagation();
            formInstance.submit();
        },
        onReset: (event)=>{
            event.preventDefault();
            formInstance.resetFields();
            restProps.onReset?.(event);
        }
    }), wrapperNode);
};
var $0501e1a1a351a153$export$2e2bcd8739ae039 = $0501e1a1a351a153$var$Form;







var $cQmXV = parcelRequire("cQmXV");



function $1e547a634d237262$export$fac44ee5b035f737(value) {
    try {
        return JSON.stringify(value);
    } catch  {
        return Math.random();
    }
}
// ------- selector type -------
// ------- selector type end -------
function $1e547a634d237262$var$useWatch(...args) {
    const [dependencies, _form = {}] = args;
    const options = (0, $95fac96d9e2bedd3$export$717b316e73068e8d)(_form) ? {
        form: _form
    } : _form;
    const form = options.form;
    const [value, setValue] = (0, $cQmXV.useState)(()=>typeof dependencies === "function" ? dependencies({}) : undefined);
    const valueStr = (0, $cQmXV.useMemo)(()=>$1e547a634d237262$export$fac44ee5b035f737(value), [
        value
    ]);
    const valueStrRef = (0, $cQmXV.useRef)(valueStr);
    valueStrRef.current = valueStr;
    const fieldContext = (0, $cQmXV.useContext)((0, $7b2f48a2d7a9ccda$export$2e2bcd8739ae039));
    const formInstance = form || fieldContext;
    const isValidForm = formInstance && formInstance._init;
    // ============================== Form ==============================
    const { getFieldsValue: getFieldsValue, getInternalHooks: getInternalHooks } = formInstance;
    const { registerWatch: registerWatch } = getInternalHooks((0, $7b2f48a2d7a9ccda$export$24829b7c0e49e9f7));
    // ============================= Update =============================
    const triggerUpdate = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((values, allValues)=>{
        const watchValue = options.preserve ? allValues ?? getFieldsValue(true) : values ?? getFieldsValue();
        const nextValue = typeof dependencies === "function" ? dependencies(watchValue) : (0, $bb62aae17cbc8bd7$export$2e2bcd8739ae039)(watchValue, (0, $8e145835e5ed0368$export$f877b3cb4cb4ccf9)(dependencies));
        if ($1e547a634d237262$export$fac44ee5b035f737(value) !== $1e547a634d237262$export$fac44ee5b035f737(nextValue)) setValue(nextValue);
    });
    // ============================= Effect =============================
    const flattenDeps = typeof dependencies === "function" ? dependencies : JSON.stringify(dependencies);
    // Deps changed
    (0, $cQmXV.useEffect)(()=>{
        // Skip if not exist form instance
        if (!isValidForm) return;
        triggerUpdate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isValidForm,
        flattenDeps
    ]);
    // Value changed
    (0, $cQmXV.useEffect)(()=>{
        // Skip if not exist form instance
        if (!isValidForm) return;
        const cancelRegister = registerWatch((values, allValues)=>{
            triggerUpdate(values, allValues);
        });
        return cancelRegister;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isValidForm
    ]);
    return value;
}
var $1e547a634d237262$export$2e2bcd8739ae039 = $1e547a634d237262$var$useWatch;


const $13cc7c1e34a7da5c$var$InternalForm = /*#__PURE__*/ $cQmXV.forwardRef((0, $0501e1a1a351a153$export$2e2bcd8739ae039));
const $13cc7c1e34a7da5c$var$RefForm = $13cc7c1e34a7da5c$var$InternalForm;
$13cc7c1e34a7da5c$var$RefForm.FormProvider = (0, $11fe1b3ccf1eb181$export$8ce1ff4f94d08846);
$13cc7c1e34a7da5c$var$RefForm.Field = (0, $d1298bc083b1892f$export$2e2bcd8739ae039);
$13cc7c1e34a7da5c$var$RefForm.List = (0, $257bd90c8a7c2d10$export$2e2bcd8739ae039);
$13cc7c1e34a7da5c$var$RefForm.useForm = (0, $616d24d3edb0e567$export$2e2bcd8739ae039);
$13cc7c1e34a7da5c$var$RefForm.useWatch = (0, $1e547a634d237262$export$2e2bcd8739ae039);
var $13cc7c1e34a7da5c$export$2e2bcd8739ae039 = $13cc7c1e34a7da5c$var$RefForm;



"use client";
const $7a3804f153d8a19d$export$c24727297075ec6a = /*#__PURE__*/ $cQmXV.createContext({
    labelAlign: "right",
    layout: "horizontal",
    itemRef: ()=>{}
});
const $7a3804f153d8a19d$export$d718247e9f9b0b9e = /*#__PURE__*/ $cQmXV.createContext(null);
const $7a3804f153d8a19d$export$8ce1ff4f94d08846 = (props)=>{
    const providerProps = (0, $e8c5093aebad6025$export$2e2bcd8739ae039)(props, [
        "prefixCls"
    ]);
    return /*#__PURE__*/ $cQmXV.createElement((0, $11fe1b3ccf1eb181$export$8ce1ff4f94d08846), {
        ...providerProps
    });
};
const $7a3804f153d8a19d$export$fb6582d3042cc879 = /*#__PURE__*/ $cQmXV.createContext({
    prefixCls: ""
});
const $7a3804f153d8a19d$export$bbb5553c6c7a14ed = /*#__PURE__*/ $cQmXV.createContext({});
const $7a3804f153d8a19d$export$80e4c53cb85dcab1 = ({ children: children, status: status, override: override })=>{
    const formItemInputContext = $cQmXV.useContext($7a3804f153d8a19d$export$bbb5553c6c7a14ed);
    const newFormItemInputContext = $cQmXV.useMemo(()=>{
        const newContext = {
            ...formItemInputContext
        };
        if (override) delete newContext.isFormItemInput;
        if (status) {
            delete newContext.status;
            delete newContext.hasFeedback;
            delete newContext.feedbackIcon;
        }
        return newContext;
    }, [
        status,
        override,
        formItemInputContext
    ]);
    return /*#__PURE__*/ $cQmXV.createElement($7a3804f153d8a19d$export$bbb5553c6c7a14ed.Provider, {
        value: newFormItemInputContext
    }, children);
};
const $7a3804f153d8a19d$export$6f0555dad42725fb = /*#__PURE__*/ $cQmXV.createContext(undefined);




"use client";
const $1585084388e75c84$var$ContextIsolator = (props)=>{
    const { space: space, form: form, children: children } = props;
    if (!(0, $8e2d153a3c855782$export$72280d5f896dac9a)(children)) return null;
    let result = children;
    if (form) result = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $7a3804f153d8a19d$export$80e4c53cb85dcab1), {
        override: true,
        status: true
    }, result);
    if (space) result = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $68fddf51400eda11$export$5f56e610a4afb685), null, result);
    return result;
};
var $1585084388e75c84$export$2e2bcd8739ae039 = $1585084388e75c84$var$ContextIsolator;



var $cQmXV = parcelRequire("cQmXV");



var $cQmXV = parcelRequire("cQmXV");
const $2a7b32ec1626bb34$var$ZIndexContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createContext(undefined);
var $2a7b32ec1626bb34$export$2e2bcd8739ae039 = $2a7b32ec1626bb34$var$ZIndexContext;


// Z-Index control range
// Container: 1000 + offset 100 (max base + 10 * offset = 2000)
// Popover: offset 50
// Notification: Container Max zIndex + componentOffset
const $b2b300e6909d7707$var$CONTAINER_OFFSET = 100;
const $b2b300e6909d7707$var$CONTAINER_OFFSET_MAX_COUNT = 10;
const $b2b300e6909d7707$export$33ada7d8845f7e5 = $b2b300e6909d7707$var$CONTAINER_OFFSET * $b2b300e6909d7707$var$CONTAINER_OFFSET_MAX_COUNT;
/**
 * Static function will default be the `CONTAINER_MAX_OFFSET`.
 * But it still may have children component like Select, Dropdown.
 * So the warning zIndex should exceed the `CONTAINER_MAX_OFFSET`.
 */ const $b2b300e6909d7707$var$CONTAINER_MAX_OFFSET_WITH_CHILDREN = $b2b300e6909d7707$export$33ada7d8845f7e5 + $b2b300e6909d7707$var$CONTAINER_OFFSET;
const $b2b300e6909d7707$export$1658852af8bb2a55 = {
    Modal: $b2b300e6909d7707$var$CONTAINER_OFFSET,
    Drawer: $b2b300e6909d7707$var$CONTAINER_OFFSET,
    Popover: $b2b300e6909d7707$var$CONTAINER_OFFSET,
    Popconfirm: $b2b300e6909d7707$var$CONTAINER_OFFSET,
    Tooltip: $b2b300e6909d7707$var$CONTAINER_OFFSET,
    Tour: $b2b300e6909d7707$var$CONTAINER_OFFSET,
    FloatButton: $b2b300e6909d7707$var$CONTAINER_OFFSET
};
const $b2b300e6909d7707$export$3f7a364c708f940b = {
    SelectLike: 50,
    Dropdown: 50,
    DatePicker: 50,
    Menu: 50,
    ImagePreview: 1
};
const $b2b300e6909d7707$var$isContainerType = (type)=>{
    return type in $b2b300e6909d7707$export$1658852af8bb2a55;
};
const $b2b300e6909d7707$export$3e7906d4075187a4 = (componentType, customZIndex)=>{
    const [, token] = (0, $b22e03a54a548614$export$2e2bcd8739ae039)();
    const parentZIndex = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useContext((0, $2a7b32ec1626bb34$export$2e2bcd8739ae039));
    const isContainer = $b2b300e6909d7707$var$isContainerType(componentType);
    let result;
    if (customZIndex !== undefined) result = [
        customZIndex,
        customZIndex
    ];
    else {
        let zIndex = parentZIndex ?? 0;
        if (isContainer) zIndex += // Use preset token zIndex by default but not stack when has parent container
        (parentZIndex ? 0 : token.zIndexPopupBase) + // Container offset
        $b2b300e6909d7707$export$1658852af8bb2a55[componentType];
        else zIndex += $b2b300e6909d7707$export$3f7a364c708f940b[componentType];
        result = [
            parentZIndex === undefined ? customZIndex : zIndex,
            zIndex
        ];
    }
    return result;
};


var $cQmXV = parcelRequire("cQmXV");

const $43591a623a20c2b6$export$c0a98b854d121670 = (mask, maskClosable)=>{
    let maskConfig = {};
    if ((0, $8e2d153a3c855782$export$53b83ca8eaab0383)(mask)) maskConfig = mask;
    if (typeof mask === "boolean") maskConfig = {
        enabled: mask
    };
    if (maskConfig.closable === undefined && maskClosable !== undefined) maskConfig.closable = maskClosable;
    return maskConfig;
};
const $43591a623a20c2b6$export$a4ac1bdd74570410 = (mask, contextMask, prefixCls, maskClosable)=>{
    return (0, $cQmXV.useMemo)(()=>{
        const maskConfig = $43591a623a20c2b6$export$c0a98b854d121670(mask, maskClosable);
        const contextMaskConfig = $43591a623a20c2b6$export$c0a98b854d121670(contextMask);
        const mergedConfig = {
            blur: false,
            ...contextMaskConfig,
            ...maskConfig,
            closable: maskConfig.closable ?? maskClosable ?? contextMaskConfig.closable ?? true
        };
        const className = mergedConfig.blur ? `${prefixCls}-mask-blur` : undefined;
        return [
            mergedConfig.enabled !== false,
            {
                mask: className
            },
            !!mergedConfig.closable
        ];
    }, [
        mask,
        contextMask,
        prefixCls,
        maskClosable
    ]);
};










var $cQmXV = parcelRequire("cQmXV");

function $f1d001121ad33e46$var$voidFunc() {}
const $f1d001121ad33e46$var$WatermarkContext = /*#__PURE__*/ $cQmXV.createContext({
    add: $f1d001121ad33e46$var$voidFunc,
    remove: $f1d001121ad33e46$var$voidFunc
});
function $f1d001121ad33e46$export$94ab53417567be34(panelSelector) {
    const watermark = $cQmXV.useContext($f1d001121ad33e46$var$WatermarkContext);
    const panelEleRef = $cQmXV.useRef(null);
    const panelRef = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((ele)=>{
        if (ele) {
            const innerContentEle = panelSelector ? ele.querySelector(panelSelector) : ele;
            if (innerContentEle) {
                watermark.add(innerContentEle);
                panelEleRef.current = innerContentEle;
            }
        } else watermark.remove(panelEleRef.current);
    });
    return panelRef;
}
var $f1d001121ad33e46$export$2e2bcd8739ae039 = $f1d001121ad33e46$var$WatermarkContext;



var $cQmXV = parcelRequire("cQmXV");


var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");
var $f16b7d90735af084$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($f16b7d90735af084$exports, "__esModule", {
    value: true
});
var $f16b7d90735af084$var$CloseOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "fill-rule": "evenodd",
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z"
                }
            }
        ]
    },
    "name": "close",
    "theme": "outlined"
};
$f16b7d90735af084$exports.default = $f16b7d90735af084$var$CloseOutlined;



function $837faca566926e3c$var$_extends() {
    $837faca566926e3c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $837faca566926e3c$var$_extends.apply(this, arguments);
}
const $837faca566926e3c$var$CloseOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $837faca566926e3c$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($f16b7d90735af084$exports)))
    }));
/**![close](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdmlld0JveD0iNjQgNjQgODk2IDg5NiIgZm9jdXNhYmxlPSJmYWxzZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNzk5Ljg2IDE2Ni4zMWMuMDIgMCAuMDQuMDIuMDguMDZsNTcuNjkgNTcuN2MuMDQuMDMuMDUuMDUuMDYuMDhhLjEyLjEyIDAgMDEwIC4wNmMwIC4wMy0uMDIuMDUtLjA2LjA5TDU2OS45MyA1MTJsMjg3LjcgMjg3LjdjLjA0LjA0LjA1LjA2LjA2LjA5YS4xMi4xMiAwIDAxMCAuMDdjMCAuMDItLjAyLjA0LS4wNi4wOGwtNTcuNyA1Ny42OWMtLjAzLjA0LS4wNS4wNS0uMDcuMDZhLjEyLjEyIDAgMDEtLjA3IDBjLS4wMyAwLS4wNS0uMDItLjA5LS4wNkw1MTIgNTY5LjkzbC0yODcuNyAyODcuN2MtLjA0LjA0LS4wNi4wNS0uMDkuMDZhLjEyLjEyIDAgMDEtLjA3IDBjLS4wMiAwLS4wNC0uMDItLjA4LS4wNmwtNTcuNjktNTcuN2MtLjA0LS4wMy0uMDUtLjA1LS4wNi0uMDdhLjEyLjEyIDAgMDEwLS4wN2MwLS4wMy4wMi0uMDUuMDYtLjA5TDQ1NC4wNyA1MTJsLTI4Ny43LTI4Ny43Yy0uMDQtLjA0LS4wNS0uMDYtLjA2LS4wOWEuMTIuMTIgMCAwMTAtLjA3YzAtLjAyLjAyLS4wNC4wNi0uMDhsNTcuNy01Ny42OWMuMDMtLjA0LjA1LS4wNS4wNy0uMDZhLjEyLjEyIDAgMDEuMDcgMGMuMDMgMCAuMDUuMDIuMDkuMDZMNTEyIDQ1NC4wN2wyODcuNy0yODcuN2MuMDQtLjA0LjA2LS4wNS4wOS0uMDZhLjEyLjEyIDAgMDEuMDcgMHoiIC8+PC9zdmc+) */ const $837faca566926e3c$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($837faca566926e3c$var$CloseOutlined);
var $837faca566926e3c$export$2e2bcd8739ae039 = $837faca566926e3c$var$RefIcon;






"use client";
const $d68006bfa4b86b8f$export$51ad9c30389f050b = (context)=>{
    if (!context) return undefined;
    const { closable: closable, closeIcon: closeIcon } = context;
    return {
        closable: closable,
        closeIcon: closeIcon
    };
};
const $d68006bfa4b86b8f$var$EmptyFallbackCloseCollection = {};
const $d68006bfa4b86b8f$var$computeClosableConfig = (closable, closeIcon)=>{
    if (!closable && (closable === false || closeIcon === false || closeIcon === null)) return false;
    if (!(0, $8e2d153a3c855782$export$826fff653a329e83)(closable) && !(0, $8e2d153a3c855782$export$826fff653a329e83)(closeIcon)) return null;
    let closableConfig = {
        closeIcon: typeof closeIcon !== "boolean" && (0, $8e2d153a3c855782$export$826fff653a329e83)(closeIcon) ? closeIcon : undefined
    };
    if ((0, $8e2d153a3c855782$export$53b83ca8eaab0383)(closable)) closableConfig = {
        ...closableConfig,
        ...closable
    };
    return closableConfig;
};
const $d68006bfa4b86b8f$var$mergeClosableConfigs = (propConfig, contextConfig, fallbackConfig)=>{
    if (propConfig === false) return false;
    if (propConfig) return (0, $5bb86b4f753905a4$export$2e2bcd8739ae039)(fallbackConfig, contextConfig, propConfig);
    if (contextConfig === false) return false;
    if (contextConfig) return (0, $5bb86b4f753905a4$export$2e2bcd8739ae039)(fallbackConfig, contextConfig);
    return fallbackConfig.closable ? fallbackConfig : false;
};
const $d68006bfa4b86b8f$var$computeCloseIcon = (mergedConfig, fallbackCloseCollection, closeLabel)=>{
    const { closeIconRender: closeIconRender } = fallbackCloseCollection;
    const { closeIcon: closeIcon, ...restConfig } = mergedConfig;
    let finalCloseIcon = closeIcon;
    const ariaOrDataProps = (0, $4b5c733d1d7bb306$export$2e2bcd8739ae039)(restConfig, true);
    if ((0, $8e2d153a3c855782$export$826fff653a329e83)(finalCloseIcon)) {
        if (closeIconRender) finalCloseIcon = closeIconRender(finalCloseIcon);
        finalCloseIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).isValidElement(finalCloseIcon) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).cloneElement(finalCloseIcon, {
            "aria-label": closeLabel,
            ...finalCloseIcon.props,
            ...ariaOrDataProps
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("span", {
            "aria-label": closeLabel,
            ...ariaOrDataProps
        }, finalCloseIcon);
    }
    return [
        finalCloseIcon,
        ariaOrDataProps
    ];
};
const $d68006bfa4b86b8f$export$41ed0597a5c42f8 = (propCloseCollection, contextCloseCollection, fallbackCloseCollection = $d68006bfa4b86b8f$var$EmptyFallbackCloseCollection, closeLabel = "Close")=>{
    const propConfig = $d68006bfa4b86b8f$var$computeClosableConfig(propCloseCollection?.closable, propCloseCollection?.closeIcon);
    const contextConfig = $d68006bfa4b86b8f$var$computeClosableConfig(contextCloseCollection?.closable, contextCloseCollection?.closeIcon);
    const mergedFallback = {
        closeIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $837faca566926e3c$export$2e2bcd8739ae039), null),
        ...fallbackCloseCollection
    };
    const mergedConfig = $d68006bfa4b86b8f$var$mergeClosableConfigs(propConfig, contextConfig, mergedFallback);
    const closeBtnIsDisabled = typeof mergedConfig !== "boolean" ? !!mergedConfig?.disabled : false;
    if (mergedConfig === false) return [
        false,
        null,
        closeBtnIsDisabled,
        {}
    ];
    const [closeIcon, ariaProps] = $d68006bfa4b86b8f$var$computeCloseIcon(mergedConfig, mergedFallback, closeLabel);
    return [
        true,
        closeIcon,
        closeBtnIsDisabled,
        ariaProps
    ];
};
const $d68006bfa4b86b8f$export$aa101db403ccf5f3 = (propCloseCollection, contextCloseCollection, fallbackCloseCollection = $d68006bfa4b86b8f$var$EmptyFallbackCloseCollection)=>{
    const [contextLocale] = (0, $c953dac9d015386e$export$2e2bcd8739ae039)("global", (0, $4ab0c7032ff9de6a$export$2e2bcd8739ae039).global);
    return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useMemo(()=>{
        return $d68006bfa4b86b8f$export$41ed0597a5c42f8(propCloseCollection, contextCloseCollection, {
            closeIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $837faca566926e3c$export$2e2bcd8739ae039), null),
            ...fallbackCloseCollection
        }, contextLocale.close);
    }, [
        propCloseCollection,
        contextCloseCollection,
        fallbackCloseCollection,
        contextLocale.close
    ]);
};







var $cQmXV = parcelRequire("cQmXV");





var $cQmXV = parcelRequire("cQmXV");




var $cQmXV = parcelRequire("cQmXV");



"use client";
const $9033110632082edc$var$Element = (props)=>{
    const { prefixCls: prefixCls, className: className, style: style, size: size, shape: shape } = props;
    const sizeCls = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)({
        [`${prefixCls}-lg`]: size === "large",
        [`${prefixCls}-sm`]: size === "small"
    });
    const shapeCls = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)({
        [`${prefixCls}-circle`]: shape === "circle",
        [`${prefixCls}-square`]: shape === "square",
        [`${prefixCls}-round`]: shape === "round"
    });
    const sizeStyle = $cQmXV.useMemo(()=>(0, $8e2d153a3c855782$export$7e4aa119212bc614)(size) ? {
            width: size,
            height: size,
            lineHeight: `${size}px`
        } : {}, [
        size
    ]);
    return /*#__PURE__*/ $cQmXV.createElement("span", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, sizeCls, shapeCls, className),
        style: {
            ...sizeStyle,
            ...style
        }
    });
};
var $9033110632082edc$export$2e2bcd8739ae039 = $9033110632082edc$var$Element;




const $ad17a4c11cf11e46$var$skeletonClsLoading = new (0, $e928d3664c9ed565$export$2e2bcd8739ae039)(`ant-skeleton-loading`, {
    "0%": {
        backgroundPosition: "100% 50%"
    },
    "100%": {
        backgroundPosition: "0 50%"
    }
});
const $ad17a4c11cf11e46$var$genSkeletonElementCommonSize = (size)=>({
        height: size,
        lineHeight: (0, $05f34ed03d41967d$export$523c0b569236b342)(size)
    });
const $ad17a4c11cf11e46$var$genSkeletonElementSize = (size)=>({
        width: size,
        ...$ad17a4c11cf11e46$var$genSkeletonElementCommonSize(size)
    });
const $ad17a4c11cf11e46$var$genSkeletonColor = (token)=>({
        background: token.skeletonLoadingBackground,
        backgroundSize: "400% 100%",
        animationName: $ad17a4c11cf11e46$var$skeletonClsLoading,
        animationDuration: token.skeletonLoadingMotionDuration,
        animationTimingFunction: "ease",
        animationIterationCount: "infinite"
    });
const $ad17a4c11cf11e46$var$genSkeletonElementInputSize = (size, calc)=>({
        width: calc(size).mul(5).equal(),
        minWidth: calc(size).mul(5).equal(),
        ...$ad17a4c11cf11e46$var$genSkeletonElementCommonSize(size)
    });
const $ad17a4c11cf11e46$var$genSkeletonElementAvatar = (token)=>{
    const { skeletonAvatarCls: skeletonAvatarCls, gradientFromColor: gradientFromColor, controlHeight: controlHeight, controlHeightLG: controlHeightLG, controlHeightSM: controlHeightSM } = token;
    return {
        [skeletonAvatarCls]: {
            display: "inline-block",
            verticalAlign: "top",
            background: gradientFromColor,
            ...$ad17a4c11cf11e46$var$genSkeletonElementSize(controlHeight)
        },
        [`${skeletonAvatarCls}${skeletonAvatarCls}-circle`]: {
            borderRadius: "50%"
        },
        [`${skeletonAvatarCls}${skeletonAvatarCls}-lg`]: {
            ...$ad17a4c11cf11e46$var$genSkeletonElementSize(controlHeightLG)
        },
        [`${skeletonAvatarCls}${skeletonAvatarCls}-sm`]: {
            ...$ad17a4c11cf11e46$var$genSkeletonElementSize(controlHeightSM)
        }
    };
};
const $ad17a4c11cf11e46$var$genSkeletonElementInput = (token)=>{
    const { controlHeight: controlHeight, borderRadiusSM: borderRadiusSM, skeletonInputCls: skeletonInputCls, controlHeightLG: controlHeightLG, controlHeightSM: controlHeightSM, gradientFromColor: gradientFromColor, calc: calc } = token;
    return {
        [skeletonInputCls]: {
            display: "inline-block",
            verticalAlign: "top",
            background: gradientFromColor,
            borderRadius: borderRadiusSM,
            ...$ad17a4c11cf11e46$var$genSkeletonElementInputSize(controlHeight, calc)
        },
        [`${skeletonInputCls}-lg`]: {
            ...$ad17a4c11cf11e46$var$genSkeletonElementInputSize(controlHeightLG, calc)
        },
        [`${skeletonInputCls}-sm`]: {
            ...$ad17a4c11cf11e46$var$genSkeletonElementInputSize(controlHeightSM, calc)
        }
    };
};
const $ad17a4c11cf11e46$var$genSkeletonElementShape = (token)=>{
    const { gradientFromColor: gradientFromColor, borderRadiusSM: borderRadiusSM, imageSizeBase: imageSizeBase, calc: calc } = token;
    return {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        verticalAlign: "middle",
        background: gradientFromColor,
        borderRadius: borderRadiusSM,
        ...$ad17a4c11cf11e46$var$genSkeletonElementSize(calc(imageSizeBase).mul(2).equal())
    };
};
const $ad17a4c11cf11e46$var$genSkeletonElementNode = (token)=>{
    return {
        [token.skeletonNodeCls]: {
            ...$ad17a4c11cf11e46$var$genSkeletonElementShape(token)
        }
    };
};
const $ad17a4c11cf11e46$var$genSkeletonElementImage = (token)=>{
    const { skeletonImageCls: skeletonImageCls, imageSizeBase: imageSizeBase, calc: calc } = token;
    return {
        [skeletonImageCls]: {
            ...$ad17a4c11cf11e46$var$genSkeletonElementShape(token),
            [`${skeletonImageCls}-path`]: {
                fill: "#bfbfbf"
            },
            [`${skeletonImageCls}-svg`]: {
                ...$ad17a4c11cf11e46$var$genSkeletonElementSize(imageSizeBase),
                maxWidth: calc(imageSizeBase).mul(4).equal(),
                maxHeight: calc(imageSizeBase).mul(4).equal()
            },
            [`${skeletonImageCls}-svg${skeletonImageCls}-svg-circle`]: {
                borderRadius: "50%"
            }
        },
        [`${skeletonImageCls}${skeletonImageCls}-circle`]: {
            borderRadius: "50%"
        }
    };
};
const $ad17a4c11cf11e46$var$genSkeletonElementButtonShape = (token, size, buttonCls)=>{
    const { skeletonButtonCls: skeletonButtonCls } = token;
    return {
        [`${buttonCls}${skeletonButtonCls}-circle`]: {
            width: size,
            minWidth: size,
            borderRadius: "50%"
        },
        [`${buttonCls}${skeletonButtonCls}-round`]: {
            borderRadius: size
        }
    };
};
const $ad17a4c11cf11e46$var$genSkeletonElementButtonSize = (size, calc)=>({
        width: calc(size).mul(2).equal(),
        minWidth: calc(size).mul(2).equal(),
        ...$ad17a4c11cf11e46$var$genSkeletonElementCommonSize(size)
    });
const $ad17a4c11cf11e46$var$genSkeletonElementButton = (token)=>{
    const { borderRadiusSM: borderRadiusSM, skeletonButtonCls: skeletonButtonCls, controlHeight: controlHeight, controlHeightLG: controlHeightLG, controlHeightSM: controlHeightSM, gradientFromColor: gradientFromColor, calc: calc } = token;
    return {
        [skeletonButtonCls]: {
            display: "inline-block",
            verticalAlign: "top",
            background: gradientFromColor,
            borderRadius: borderRadiusSM,
            width: calc(controlHeight).mul(2).equal(),
            minWidth: calc(controlHeight).mul(2).equal(),
            ...$ad17a4c11cf11e46$var$genSkeletonElementButtonSize(controlHeight, calc)
        },
        ...$ad17a4c11cf11e46$var$genSkeletonElementButtonShape(token, controlHeight, skeletonButtonCls),
        [`${skeletonButtonCls}-lg`]: {
            ...$ad17a4c11cf11e46$var$genSkeletonElementButtonSize(controlHeightLG, calc)
        },
        ...$ad17a4c11cf11e46$var$genSkeletonElementButtonShape(token, controlHeightLG, `${skeletonButtonCls}-lg`),
        [`${skeletonButtonCls}-sm`]: {
            ...$ad17a4c11cf11e46$var$genSkeletonElementButtonSize(controlHeightSM, calc)
        },
        ...$ad17a4c11cf11e46$var$genSkeletonElementButtonShape(token, controlHeightSM, `${skeletonButtonCls}-sm`)
    };
};
// =============================== Base ===============================
const $ad17a4c11cf11e46$var$genBaseStyle = (token)=>{
    const { componentCls: componentCls, skeletonAvatarCls: skeletonAvatarCls, skeletonTitleCls: skeletonTitleCls, skeletonParagraphCls: skeletonParagraphCls, skeletonButtonCls: skeletonButtonCls, skeletonInputCls: skeletonInputCls, skeletonNodeCls: skeletonNodeCls, skeletonImageCls: skeletonImageCls, controlHeight: controlHeight, controlHeightLG: controlHeightLG, controlHeightSM: controlHeightSM, gradientFromColor: gradientFromColor, padding: padding, marginSM: marginSM, borderRadius: borderRadius, titleHeight: titleHeight, blockRadius: blockRadius, paragraphLiHeight: paragraphLiHeight, controlHeightXS: controlHeightXS, paragraphMarginTop: paragraphMarginTop } = token;
    return {
        [componentCls]: {
            display: "table",
            width: "100%",
            [`${componentCls}-header`]: {
                display: "table-cell",
                paddingInlineEnd: padding,
                verticalAlign: "top",
                // Avatar
                [skeletonAvatarCls]: {
                    display: "inline-block",
                    verticalAlign: "top",
                    background: gradientFromColor,
                    ...$ad17a4c11cf11e46$var$genSkeletonElementSize(controlHeight)
                },
                [`${skeletonAvatarCls}-circle`]: {
                    borderRadius: "50%"
                },
                [`${skeletonAvatarCls}-lg`]: {
                    ...$ad17a4c11cf11e46$var$genSkeletonElementSize(controlHeightLG)
                },
                [`${skeletonAvatarCls}-sm`]: {
                    ...$ad17a4c11cf11e46$var$genSkeletonElementSize(controlHeightSM)
                }
            },
            [`${componentCls}-section`]: {
                display: "table-cell",
                width: "100%",
                verticalAlign: "top",
                // Title
                [skeletonTitleCls]: {
                    width: "100%",
                    height: titleHeight,
                    background: gradientFromColor,
                    borderRadius: blockRadius,
                    [`+ ${skeletonParagraphCls}`]: {
                        marginBlockStart: controlHeightSM
                    }
                },
                // paragraph
                [skeletonParagraphCls]: {
                    padding: 0,
                    "> li": {
                        width: "100%",
                        height: paragraphLiHeight,
                        listStyle: "none",
                        background: gradientFromColor,
                        borderRadius: blockRadius,
                        "+ li": {
                            marginBlockStart: controlHeightXS
                        }
                    }
                },
                [`${skeletonParagraphCls}> li:last-child:not(:first-child):not(:nth-child(2))`]: {
                    width: "61%"
                }
            },
            [`&-round ${componentCls}-section`]: {
                [`${skeletonTitleCls}, ${skeletonParagraphCls} > li`]: {
                    borderRadius: borderRadius
                }
            }
        },
        [`${componentCls}-with-avatar ${componentCls}-section`]: {
            // Title
            [skeletonTitleCls]: {
                marginBlockStart: marginSM,
                [`+ ${skeletonParagraphCls}`]: {
                    marginBlockStart: paragraphMarginTop
                }
            }
        },
        // Skeleton with element
        [`${componentCls}${componentCls}-element`]: {
            display: "inline-block",
            width: "auto",
            ...$ad17a4c11cf11e46$var$genSkeletonElementButton(token),
            ...$ad17a4c11cf11e46$var$genSkeletonElementAvatar(token),
            ...$ad17a4c11cf11e46$var$genSkeletonElementInput(token),
            ...$ad17a4c11cf11e46$var$genSkeletonElementNode(token),
            ...$ad17a4c11cf11e46$var$genSkeletonElementImage(token)
        },
        // Skeleton Block Button, Input
        [`${componentCls}${componentCls}-block`]: {
            width: "100%",
            [skeletonButtonCls]: {
                width: "100%"
            },
            [skeletonInputCls]: {
                width: "100%"
            }
        },
        // With active animation
        [`${componentCls}${componentCls}-active`]: {
            [`
        ${skeletonTitleCls},
        ${skeletonParagraphCls} > li,
        ${skeletonAvatarCls},
        ${skeletonButtonCls},
        ${skeletonInputCls},
        ${skeletonNodeCls},
        ${skeletonImageCls}
      `]: {
                ...$ad17a4c11cf11e46$var$genSkeletonColor(token)
            }
        }
    };
};
const $ad17a4c11cf11e46$export$9ca1be8807fe0675 = (token)=>{
    const { colorFillContent: colorFillContent, colorFill: colorFill } = token;
    const gradientFromColor = colorFillContent;
    const gradientToColor = colorFill;
    return {
        color: gradientFromColor,
        colorGradientEnd: gradientToColor,
        gradientFromColor: gradientFromColor,
        gradientToColor: gradientToColor,
        titleHeight: token.controlHeight / 2,
        blockRadius: token.borderRadiusSM,
        paragraphMarginTop: token.marginLG + token.marginXXS,
        paragraphLiHeight: token.controlHeight / 2
    };
};
var $ad17a4c11cf11e46$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$51ec95de45185b42)("Skeleton", (token)=>{
    const { componentCls: componentCls, calc: calc } = token;
    const skeletonToken = (0, $fef50f256b80dfa5$export$4950aa0f605343fb)(token, {
        skeletonAvatarCls: `${componentCls}-avatar`,
        skeletonTitleCls: `${componentCls}-title`,
        skeletonParagraphCls: `${componentCls}-paragraph`,
        skeletonButtonCls: `${componentCls}-button`,
        skeletonInputCls: `${componentCls}-input`,
        skeletonNodeCls: `${componentCls}-node`,
        skeletonImageCls: `${componentCls}-image`,
        imageSizeBase: calc(token.controlHeight).mul(1.5).equal(),
        borderRadius: 100,
        // Large number to make capsule shape
        skeletonLoadingBackground: `linear-gradient(90deg, ${token.gradientFromColor} 25%, ${token.gradientToColor} 37%, ${token.gradientFromColor} 63%)`,
        skeletonLoadingMotionDuration: "1.4s"
    });
    return $ad17a4c11cf11e46$var$genBaseStyle(skeletonToken);
}, $ad17a4c11cf11e46$export$9ca1be8807fe0675, {
    deprecatedTokens: [
        [
            "color",
            "gradientFromColor"
        ],
        [
            "colorGradientEnd",
            "gradientToColor"
        ]
    ]
});


"use client";
const $8f3c366e1f3d8f9c$var$SkeletonAvatar = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, classNames: classNames, rootClassName: rootClassName, active: active, style: style, styles: styles, shape: shape = "circle", size: customSize, ...rest } = props;
    const { getPrefixCls: getPrefixCls } = $cQmXV.useContext((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls("skeleton", customizePrefixCls);
    const [hashId, cssVarCls] = (0, $ad17a4c11cf11e46$export$2e2bcd8739ae039)(prefixCls);
    const mergedSize = (0, $78cdfb6138721329$export$2e2bcd8739ae039)((ctx)=>customSize ?? ctx);
    const cls = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-element`, {
        [`${prefixCls}-active`]: active
    }, classNames?.root, className, rootClassName, hashId, cssVarCls);
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        className: cls,
        style: styles?.root
    }, /*#__PURE__*/ $cQmXV.createElement((0, $9033110632082edc$export$2e2bcd8739ae039), {
        prefixCls: `${prefixCls}-avatar`,
        className: classNames?.content,
        style: {
            ...styles?.content,
            ...style
        },
        shape: shape,
        size: mergedSize,
        ...rest
    }));
};
var $8f3c366e1f3d8f9c$export$2e2bcd8739ae039 = $8f3c366e1f3d8f9c$var$SkeletonAvatar;



var $cQmXV = parcelRequire("cQmXV");





"use client";
const $cb96bf7d4c78035b$var$SkeletonButton = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, classNames: classNames, active: active, style: style, styles: styles, block: block = false, size: customSize, ...rest } = props;
    const { getPrefixCls: getPrefixCls } = $cQmXV.useContext((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls("skeleton", customizePrefixCls);
    const [hashId, cssVarCls] = (0, $ad17a4c11cf11e46$export$2e2bcd8739ae039)(prefixCls);
    const mergedSize = (0, $78cdfb6138721329$export$2e2bcd8739ae039)((ctx)=>customSize ?? ctx);
    const cls = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-element`, {
        [`${prefixCls}-active`]: active,
        [`${prefixCls}-block`]: block
    }, classNames?.root, className, rootClassName, hashId, cssVarCls);
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        className: cls,
        style: styles?.root
    }, /*#__PURE__*/ $cQmXV.createElement((0, $9033110632082edc$export$2e2bcd8739ae039), {
        prefixCls: `${prefixCls}-button`,
        className: classNames?.content,
        style: {
            ...styles?.content,
            ...style
        },
        size: mergedSize,
        ...rest
    }));
};
var $cb96bf7d4c78035b$export$2e2bcd8739ae039 = $cb96bf7d4c78035b$var$SkeletonButton;




var $cQmXV = parcelRequire("cQmXV");


var $cQmXV = parcelRequire("cQmXV");



"use client";
const $631283b464bf2d61$var$SkeletonNode = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, classNames: classNames, rootClassName: rootClassName, internalClassName: internalClassName, style: style, styles: styles, active: active, children: children } = props;
    const { getPrefixCls: getPrefixCls } = $cQmXV.useContext((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls("skeleton", customizePrefixCls);
    const [hashId, cssVarCls] = (0, $ad17a4c11cf11e46$export$2e2bcd8739ae039)(prefixCls);
    const cls = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-element`, {
        [`${prefixCls}-active`]: active
    }, hashId, classNames?.root, className, rootClassName, cssVarCls);
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        className: cls,
        style: styles?.root
    }, /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(classNames?.content, internalClassName || `${prefixCls}-node`),
        style: {
            ...styles?.content,
            ...style
        }
    }, children));
};
var $631283b464bf2d61$export$2e2bcd8739ae039 = $631283b464bf2d61$var$SkeletonNode;


"use client";
const $8d14d2685477e55d$var$SkeletonImage = (props)=>{
    const { getPrefixCls: getPrefixCls } = $cQmXV.useContext((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls("skeleton", props.prefixCls);
    return /*#__PURE__*/ $cQmXV.createElement((0, $631283b464bf2d61$export$2e2bcd8739ae039), {
        ...props,
        internalClassName: `${prefixCls}-image`
    }, /*#__PURE__*/ $cQmXV.createElement("svg", {
        viewBox: "0 0 1098 1024",
        xmlns: "http://www.w3.org/2000/svg",
        className: `${prefixCls}-image-svg`
    }, /*#__PURE__*/ $cQmXV.createElement("title", null, "Image placeholder"), /*#__PURE__*/ $cQmXV.createElement("path", {
        d: "M365.7 329.1q0 45.8-32 77.7t-77.7 32-77.7-32-32-77.7 32-77.6 77.7-32 77.7 32 32 77.6M951 548.6v256H146.3V694.9L329 512l91.5 91.4L713 311zm54.8-402.3H91.4q-7.4 0-12.8 5.4T73 164.6v694.8q0 7.5 5.5 12.9t12.8 5.4h914.3q7.5 0 12.9-5.4t5.4-12.9V164.6q0-7.5-5.4-12.9t-12.9-5.4m91.4 18.3v694.8q0 37.8-26.8 64.6t-64.6 26.9H91.4q-37.7 0-64.6-26.9T0 859.4V164.6q0-37.8 26.8-64.6T91.4 73h914.3q37.8 0 64.6 26.9t26.8 64.6",
        className: `${prefixCls}-image-path`
    })));
};
var $8d14d2685477e55d$export$2e2bcd8739ae039 = $8d14d2685477e55d$var$SkeletonImage;



var $cQmXV = parcelRequire("cQmXV");





"use client";
const $11368c8c8530e0b0$var$SkeletonInput = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, classNames: classNames, rootClassName: rootClassName, active: active, block: block, style: style, styles: styles, size: customSize, ...rest } = props;
    const { getPrefixCls: getPrefixCls } = $cQmXV.useContext((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls("skeleton", customizePrefixCls);
    const [hashId, cssVarCls] = (0, $ad17a4c11cf11e46$export$2e2bcd8739ae039)(prefixCls);
    const mergedSize = (0, $78cdfb6138721329$export$2e2bcd8739ae039)((ctx)=>customSize ?? ctx);
    const cls = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-element`, {
        [`${prefixCls}-active`]: active,
        [`${prefixCls}-block`]: block
    }, classNames?.root, className, rootClassName, hashId, cssVarCls);
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        className: cls,
        style: styles?.root
    }, /*#__PURE__*/ $cQmXV.createElement((0, $9033110632082edc$export$2e2bcd8739ae039), {
        prefixCls: `${prefixCls}-input`,
        className: classNames?.content,
        style: {
            ...styles?.content,
            ...style
        },
        size: mergedSize,
        ...rest
    }));
};
var $11368c8c8530e0b0$export$2e2bcd8739ae039 = $11368c8c8530e0b0$var$SkeletonInput;




var $cQmXV = parcelRequire("cQmXV");

"use client";
const $71cf91c1ae779817$var$getWidth = (index, props)=>{
    const { width: width, rows: rows = 2 } = props;
    if (Array.isArray(width)) return width[index];
    // last paragraph
    if (rows - 1 === index) return width;
    return undefined;
};
const $71cf91c1ae779817$var$Paragraph = (props)=>{
    const { prefixCls: prefixCls, className: className, style: style, rows: rows = 0 } = props;
    const rowList = Array.from({
        length: rows
    }).map((_, index)=>/*#__PURE__*/ $cQmXV.createElement("li", {
            key: index,
            style: {
                width: $71cf91c1ae779817$var$getWidth(index, props)
            }
        }));
    return /*#__PURE__*/ $cQmXV.createElement("ul", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, className),
        style: style
    }, rowList);
};
var $71cf91c1ae779817$export$2e2bcd8739ae039 = $71cf91c1ae779817$var$Paragraph;




var $cQmXV = parcelRequire("cQmXV");

"use client";
const $2738968123c09e39$var$Title = ({ prefixCls: prefixCls, className: className, width: width, style: style })=>/*#__PURE__*/ $cQmXV.createElement("h3", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, className),
        style: {
            width: width,
            ...style
        }
    });
var $2738968123c09e39$export$2e2bcd8739ae039 = $2738968123c09e39$var$Title;


"use client";
function $2fc34552c5fedee3$var$getComponentProps(prop) {
    if ((0, $8e2d153a3c855782$export$53b83ca8eaab0383)(prop)) return prop;
    return {};
}
function $2fc34552c5fedee3$var$getAvatarBasicProps(hasTitle, hasParagraph) {
    if (hasTitle && !hasParagraph) // Square avatar
    return {
        size: "large",
        shape: "square"
    };
    return {
        size: "large",
        shape: "circle"
    };
}
function $2fc34552c5fedee3$var$getTitleBasicProps(hasAvatar, hasParagraph) {
    if (!hasAvatar && hasParagraph) return {
        width: "38%"
    };
    if (hasAvatar && hasParagraph) return {
        width: "50%"
    };
    return {};
}
function $2fc34552c5fedee3$var$getParagraphBasicProps(hasAvatar, hasTitle) {
    const basicProps = {};
    // Width
    if (!hasAvatar || !hasTitle) basicProps.width = "61%";
    // Rows
    if (!hasAvatar && hasTitle) basicProps.rows = 3;
    else basicProps.rows = 2;
    return basicProps;
}
// Tips: ctx.classNames.root < ctx.className < cpns.classNames.root < cpns.className < rootClassName
const $2fc34552c5fedee3$var$Skeleton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, loading: loading, className: className, rootClassName: rootClassName, classNames: classNames, style: style, styles: styles, children: children, avatar: avatar = false, title: title = true, paragraph: paragraph = true, active: active, round: round } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("skeleton");
    const prefixCls = getPrefixCls("skeleton", customizePrefixCls);
    const [hashId, cssVarCls] = (0, $ad17a4c11cf11e46$export$2e2bcd8739ae039)(prefixCls);
    const mergedProps = {
        ...props,
        avatar: avatar,
        title: title,
        paragraph: paragraph
    };
    const contextStyleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $30c5f9f911d4f61b$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: mergedProps
    });
    const nativeElementRef = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useImperativeHandle(ref, ()=>({
            nativeElement: nativeElementRef.current
        }));
    if (loading || !("loading" in props)) {
        const hasAvatar = !!avatar;
        const hasTitle = !!title;
        const hasParagraph = !!paragraph;
        // Avatar
        let avatarNode;
        if (hasAvatar) {
            const avatarProps = {
                className: mergedClassNames.avatar,
                prefixCls: `${prefixCls}-avatar`,
                ...$2fc34552c5fedee3$var$getAvatarBasicProps(hasTitle, hasParagraph),
                ...$2fc34552c5fedee3$var$getComponentProps(avatar),
                style: mergedStyles.avatar
            };
            // We direct use SkeletonElement as avatar in skeleton internal.
            avatarNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
                className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(mergedClassNames.header, `${prefixCls}-header`),
                style: mergedStyles.header
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $9033110632082edc$export$2e2bcd8739ae039), {
                ...avatarProps
            }));
        }
        let contentNode;
        if (hasTitle || hasParagraph) {
            // Title
            let $title;
            if (hasTitle) {
                const titleProps = {
                    className: mergedClassNames.title,
                    prefixCls: `${prefixCls}-title`,
                    ...$2fc34552c5fedee3$var$getTitleBasicProps(hasAvatar, hasParagraph),
                    ...$2fc34552c5fedee3$var$getComponentProps(title),
                    style: mergedStyles.title
                };
                $title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $2738968123c09e39$export$2e2bcd8739ae039), {
                    ...titleProps
                });
            }
            // Paragraph
            let paragraphNode;
            if (hasParagraph) {
                const paragraphProps = {
                    className: mergedClassNames.paragraph,
                    prefixCls: `${prefixCls}-paragraph`,
                    ...$2fc34552c5fedee3$var$getParagraphBasicProps(hasAvatar, hasTitle),
                    ...$2fc34552c5fedee3$var$getComponentProps(paragraph),
                    style: mergedStyles.paragraph
                };
                paragraphNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $71cf91c1ae779817$export$2e2bcd8739ae039), {
                    ...paragraphProps
                });
            }
            contentNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
                className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(mergedClassNames.section, `${prefixCls}-section`),
                style: mergedStyles.section
            }, $title, paragraphNode);
        }
        const cls = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, {
            [`${prefixCls}-with-avatar`]: hasAvatar,
            [`${prefixCls}-active`]: active,
            [`${prefixCls}-rtl`]: direction === "rtl",
            [`${prefixCls}-round`]: round
        }, mergedClassNames.root, contextClassName, className, rootClassName, hashId, cssVarCls);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
            ref: nativeElementRef,
            className: cls,
            style: mergedStyles.root
        }, avatarNode, contentNode);
    }
    return children ?? null;
});
$2fc34552c5fedee3$var$Skeleton.Button = (0, $cb96bf7d4c78035b$export$2e2bcd8739ae039);
$2fc34552c5fedee3$var$Skeleton.Avatar = (0, $8f3c366e1f3d8f9c$export$2e2bcd8739ae039);
$2fc34552c5fedee3$var$Skeleton.Input = (0, $11368c8c8530e0b0$export$2e2bcd8739ae039);
$2fc34552c5fedee3$var$Skeleton.Image = (0, $8d14d2685477e55d$export$2e2bcd8739ae039);
$2fc34552c5fedee3$var$Skeleton.Node = (0, $631283b464bf2d61$export$2e2bcd8739ae039);
var $2fc34552c5fedee3$export$2e2bcd8739ae039 = $2fc34552c5fedee3$var$Skeleton;


"use client";
var $e855c7114b2916ed$export$2e2bcd8739ae039 = (0, $2fc34552c5fedee3$export$2e2bcd8739ae039);


"use client";
const $a0b4bfdf7560f45f$var$DrawerPanel = (props)=>{
    const { prefixCls: prefixCls, ariaId: ariaId, title: title, footer: footer, extra: extra, closable: closable, loading: loading, onClose: onClose, headerStyle: headerStyle, bodyStyle: bodyStyle, footerStyle: footerStyle, children: children, classNames: drawerClassNames, styles: drawerStyles } = props;
    const drawerContext = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("drawer");
    const { classNames: contextClassNames, styles: contextStyles, closable: contextClosable } = drawerContext;
    const [mergedClassNames, mergedStyles] = (0, $30c5f9f911d4f61b$export$648566b068f28737)([
        contextClassNames,
        drawerClassNames
    ], [
        contextStyles,
        drawerStyles
    ], {
        props: {
            ...props,
            closable: closable ?? contextClosable
        }
    });
    const closablePlacement = $cQmXV.useMemo(()=>{
        const merged = closable ?? contextClosable;
        if (merged === false) return undefined;
        if ((0, $8e2d153a3c855782$export$53b83ca8eaab0383)(merged) && merged?.placement === "end") return "end";
        return "start";
    }, [
        closable,
        contextClosable
    ]);
    const customCloseIconRender = $cQmXV.useCallback((icon)=>/*#__PURE__*/ $cQmXV.createElement("button", {
            type: "button",
            onClick: onClose,
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-close`, {
                [`${prefixCls}-close-${closablePlacement}`]: closablePlacement === "end"
            }, mergedClassNames.close),
            style: mergedStyles.close
        }, icon), [
        onClose,
        prefixCls,
        closablePlacement,
        mergedClassNames.close,
        mergedStyles.close
    ]);
    const [mergedClosable, mergedCloseIcon, closeBtnIsDisabled] = (0, $d68006bfa4b86b8f$export$aa101db403ccf5f3)((0, $d68006bfa4b86b8f$export$51ad9c30389f050b)(props), (0, $d68006bfa4b86b8f$export$51ad9c30389f050b)(drawerContext), {
        closable: true,
        closeIconRender: customCloseIconRender
    });
    const mergedCloseButton = (0, $a91ef204d03d8eec$export$e530037191fcd5d7)(mergedCloseIcon, {
        disabled: closeBtnIsDisabled
    });
    const renderHeader = ()=>{
        if (!title && !mergedClosable) return null;
        return /*#__PURE__*/ $cQmXV.createElement("div", {
            style: {
                ...mergedStyles.header,
                ...headerStyle
            },
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-header`, mergedClassNames.header, {
                [`${prefixCls}-header-close-only`]: mergedClosable && !title && !extra
            })
        }, /*#__PURE__*/ $cQmXV.createElement("div", {
            className: `${prefixCls}-header-title`
        }, closablePlacement === "start" && mergedCloseButton, title && /*#__PURE__*/ $cQmXV.createElement("div", {
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-title`, mergedClassNames.title),
            style: mergedStyles.title,
            id: ariaId
        }, title)), extra && /*#__PURE__*/ $cQmXV.createElement("div", {
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-extra`, mergedClassNames.extra),
            style: mergedStyles.extra
        }, extra), closablePlacement === "end" && mergedCloseButton);
    };
    const renderFooter = ()=>{
        if (!footer) return null;
        return /*#__PURE__*/ $cQmXV.createElement("div", {
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-footer`, mergedClassNames.footer),
            style: {
                ...mergedStyles.footer,
                ...footerStyle
            }
        }, footer);
    };
    return /*#__PURE__*/ $cQmXV.createElement($cQmXV.Fragment, null, renderHeader(), /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-body`, mergedClassNames.body),
        style: {
            ...mergedStyles.body,
            ...bodyStyle
        }
    }, loading ? /*#__PURE__*/ $cQmXV.createElement((0, $e855c7114b2916ed$export$2e2bcd8739ae039), {
        active: true,
        title: false,
        paragraph: {
            rows: 5
        },
        className: `${prefixCls}-body-skeleton`
    }) : children), renderFooter());
};
var $a0b4bfdf7560f45f$export$2e2bcd8739ae039 = $a0b4bfdf7560f45f$var$DrawerPanel;





const $26d8522788768639$var$getMoveTranslate = (direction)=>{
    const value = "100%";
    return ({
        left: `translateX(-${value})`,
        right: `translateX(${value})`,
        top: `translateY(-${value})`,
        bottom: `translateY(${value})`
    })[direction];
};
const $26d8522788768639$var$getEnterLeaveStyle = (startStyle, endStyle)=>({
        "&-enter, &-appear": {
            ...startStyle,
            "&-active": endStyle
        },
        "&-leave": {
            ...endStyle,
            "&-active": startStyle
        }
    });
const $26d8522788768639$var$getFadeStyle = (from, duration)=>({
        "&-enter, &-appear, &-leave": {
            "&-start": {
                transition: "none"
            },
            "&-active": {
                transition: `all ${duration}`
            }
        },
        ...$26d8522788768639$var$getEnterLeaveStyle({
            opacity: from
        }, {
            opacity: 1
        })
    });
const $26d8522788768639$var$getPanelMotionStyles = (direction, duration)=>[
        $26d8522788768639$var$getFadeStyle(0.7, duration),
        $26d8522788768639$var$getEnterLeaveStyle({
            transform: $26d8522788768639$var$getMoveTranslate(direction)
        }, {
            transform: "none"
        })
    ];
const $26d8522788768639$var$genMotionStyle = (token)=>{
    const { componentCls: componentCls, motionDurationSlow: motionDurationSlow } = token;
    return {
        [componentCls]: {
            // ======================== Mask ========================
            [`${componentCls}-mask-motion`]: $26d8522788768639$var$getFadeStyle(0, motionDurationSlow),
            // ======================= Panel ========================
            [`${componentCls}-panel-motion`]: [
                "left",
                "right",
                "top",
                "bottom"
            ].reduce((obj, direction)=>{
                return {
                    ...obj,
                    [`&-${direction}`]: $26d8522788768639$var$getPanelMotionStyles(direction, motionDurationSlow)
                };
            }, {})
        }
    };
};
var $26d8522788768639$export$2e2bcd8739ae039 = $26d8522788768639$var$genMotionStyle;


// =============================== Base ===============================
const $eb695dd7dc67dbda$var$genDrawerStyle = (token)=>{
    const { borderRadiusSM: borderRadiusSM, componentCls: componentCls, zIndexPopup: zIndexPopup, colorBgMask: colorBgMask, colorBgElevated: colorBgElevated, motionDurationSlow: motionDurationSlow, motionDurationMid: motionDurationMid, paddingXS: paddingXS, padding: padding, paddingLG: paddingLG, fontSizeLG: fontSizeLG, lineHeightLG: lineHeightLG, lineWidth: lineWidth, lineType: lineType, colorSplit: colorSplit, marginXS: marginXS, colorIcon: colorIcon, colorIconHover: colorIconHover, colorBgTextHover: colorBgTextHover, colorBgTextActive: colorBgTextActive, colorText: colorText, fontWeightStrong: fontWeightStrong, footerPaddingBlock: footerPaddingBlock, footerPaddingInline: footerPaddingInline, draggerSize: draggerSize, calc: calc } = token;
    const wrapperCls = `${componentCls}-content-wrapper`;
    const draggerCls = `${componentCls}-resizable-dragger`;
    return {
        [componentCls]: {
            position: "fixed",
            inset: 0,
            zIndex: zIndexPopup,
            pointerEvents: "none",
            color: colorText,
            "&-pure": {
                position: "relative",
                background: colorBgElevated,
                display: "flex",
                flexDirection: "column",
                pointerEvents: "auto",
                [`&${componentCls}-left`]: {
                    boxShadow: token.boxShadowDrawerLeft
                },
                [`&${componentCls}-right`]: {
                    boxShadow: token.boxShadowDrawerRight
                },
                [`&${componentCls}-top`]: {
                    boxShadow: token.boxShadowDrawerUp
                },
                [`&${componentCls}-bottom`]: {
                    boxShadow: token.boxShadowDrawerDown
                }
            },
            "&-inline": {
                position: "absolute"
            },
            // ====================== Mask ======================
            [`${componentCls}-mask`]: {
                position: "absolute",
                inset: 0,
                zIndex: zIndexPopup,
                background: colorBgMask,
                pointerEvents: "auto",
                [`&${componentCls}-mask-blur`]: {
                    backdropFilter: "blur(4px)"
                }
            },
            // ==================== Content =====================
            [wrapperCls]: {
                position: "absolute",
                zIndex: zIndexPopup,
                maxWidth: "100vw",
                transition: `all ${motionDurationSlow}`,
                "&-hidden": {
                    display: "none"
                }
            },
            // Placement
            [`&-left > ${wrapperCls}`]: {
                top: 0,
                bottom: 0,
                left: {
                    _skip_check_: true,
                    value: 0
                },
                boxShadow: token.boxShadowDrawerLeft
            },
            [`&-right > ${wrapperCls}`]: {
                top: 0,
                right: {
                    _skip_check_: true,
                    value: 0
                },
                bottom: 0,
                boxShadow: token.boxShadowDrawerRight
            },
            [`&-top > ${wrapperCls}`]: {
                top: 0,
                insetInline: 0,
                boxShadow: token.boxShadowDrawerUp
            },
            [`&-bottom > ${wrapperCls}`]: {
                bottom: 0,
                insetInline: 0,
                boxShadow: token.boxShadowDrawerDown
            },
            [`${componentCls}-section`]: {
                display: "flex",
                flexDirection: "column",
                width: "100%",
                height: "100%",
                overflow: "auto",
                background: colorBgElevated,
                pointerEvents: "auto"
            },
            // Header
            [`${componentCls}-header`]: {
                display: "flex",
                flex: 0,
                alignItems: "center",
                padding: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(padding)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(paddingLG)}`,
                fontSize: fontSizeLG,
                lineHeight: lineHeightLG,
                borderBottom: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(lineWidth)} ${lineType} ${colorSplit}`,
                "&-title": {
                    display: "flex",
                    flex: 1,
                    alignItems: "center",
                    minWidth: 0,
                    minHeight: 0
                }
            },
            [`${componentCls}-extra`]: {
                flex: "none"
            },
            [`${componentCls}-close`]: {
                display: "inline-flex",
                width: calc(fontSizeLG).add(paddingXS).equal(),
                height: calc(fontSizeLG).add(paddingXS).equal(),
                borderRadius: borderRadiusSM,
                justifyContent: "center",
                alignItems: "center",
                color: colorIcon,
                fontWeight: fontWeightStrong,
                fontSize: fontSizeLG,
                fontStyle: "normal",
                lineHeight: 1,
                textAlign: "center",
                textTransform: "none",
                textDecoration: "none",
                background: "transparent",
                border: 0,
                cursor: "pointer",
                transition: `all ${motionDurationMid}`,
                textRendering: "auto",
                [`&${componentCls}-close-end`]: {
                    marginInlineStart: marginXS
                },
                [`&:not(${componentCls}-close-end)`]: {
                    marginInlineEnd: marginXS
                },
                "&:disabled": {
                    pointerEvents: "none"
                },
                "&:hover": {
                    color: colorIconHover,
                    backgroundColor: colorBgTextHover,
                    textDecoration: "none"
                },
                "&:active": {
                    backgroundColor: colorBgTextActive
                },
                ...(0, $519d20bf207ce864$export$a44db842bcb28231)(token)
            },
            [`${componentCls}-title`]: {
                flex: 1,
                margin: 0,
                fontWeight: token.fontWeightStrong,
                fontSize: fontSizeLG,
                lineHeight: lineHeightLG
            },
            // Body
            [`${componentCls}-body`]: {
                flex: 1,
                minWidth: 0,
                minHeight: 0,
                padding: paddingLG,
                overflow: "auto",
                [`${componentCls}-body-skeleton`]: {
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    justifyContent: "center"
                }
            },
            // Footer
            [`${componentCls}-footer`]: {
                flexShrink: 0,
                padding: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(footerPaddingBlock)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(footerPaddingInline)}`,
                borderTop: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(lineWidth)} ${lineType} ${colorSplit}`
            },
            // ==================== Resizable ===================
            [draggerCls]: {
                position: "absolute",
                zIndex: 1,
                backgroundColor: "transparent",
                userSelect: "none",
                pointerEvents: "auto",
                "&:hover": {
                    backgroundColor: token.colorPrimary,
                    opacity: 0.2
                },
                "&-dragging": {
                    backgroundColor: token.colorPrimary,
                    opacity: 0.3
                }
            },
            [`${draggerCls}-left`]: {
                top: 0,
                bottom: 0,
                right: {
                    _skip_check_: true,
                    value: 0
                },
                width: draggerSize,
                cursor: "col-resize"
            },
            [`${draggerCls}-right`]: {
                top: 0,
                bottom: 0,
                left: {
                    _skip_check_: true,
                    value: 0
                },
                width: draggerSize,
                cursor: "col-resize"
            },
            [`${draggerCls}-top`]: {
                insetInline: 0,
                bottom: 0,
                height: draggerSize,
                cursor: "row-resize"
            },
            [`${draggerCls}-bottom`]: {
                insetInline: 0,
                top: 0,
                height: draggerSize,
                cursor: "row-resize"
            },
            // Wrapper dragging state - disable transitions for smooth dragging
            [`${wrapperCls}-dragging`]: {
                userSelect: "none",
                transition: "none",
                willChange: "width, height",
                [`${componentCls}-content`]: {
                    pointerEvents: "none"
                },
                [`${componentCls}-section`]: {
                    pointerEvents: "none"
                }
            },
            // ====================== RTL =======================
            "&-rtl": {
                direction: "rtl"
            }
        }
    };
};
const $eb695dd7dc67dbda$export$9ca1be8807fe0675 = (token)=>({
        zIndexPopup: token.zIndexPopupBase,
        footerPaddingBlock: token.paddingXS,
        footerPaddingInline: token.padding,
        draggerSize: 4
    });
var // ============================== Export ==============================
$eb695dd7dc67dbda$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$51ec95de45185b42)("Drawer", (token)=>{
    const drawerToken = (0, $fef50f256b80dfa5$export$4950aa0f605343fb)(token, {});
    return [
        $eb695dd7dc67dbda$var$genDrawerStyle(drawerToken),
        (0, $26d8522788768639$export$2e2bcd8739ae039)(drawerToken)
    ];
}, $eb695dd7dc67dbda$export$9ca1be8807fe0675);



var $cQmXV = parcelRequire("cQmXV");
function $16771e6a3398e203$export$2e2bcd8739ae039(focusable, defaultTrap, legacyFocusTriggerAfterClose) {
    return (0, $cQmXV.useMemo)(()=>{
        const ret = {
            trap: defaultTrap ?? true,
            focusTriggerAfterClose: legacyFocusTriggerAfterClose ?? true
        };
        return {
            ...ret,
            ...focusable
        };
    }, [
        focusable,
        defaultTrap,
        legacyFocusTriggerAfterClose
    ]);
}


"use client";
const $4302180bdfaa4dc4$var$_SizeTypes = [
    "default",
    "large"
];
const $4302180bdfaa4dc4$var$DEFAULT_PUSH_STATE = {
    distance: 180
};
const $4302180bdfaa4dc4$var$DEFAULT_SIZE = 378;
const $4302180bdfaa4dc4$var$MOTION_CONFIG = {
    motionAppear: true,
    motionEnter: true,
    motionLeave: true,
    motionDeadline: 500
};
const $4302180bdfaa4dc4$var$Drawer = (props)=>{
    const { rootClassName: rootClassName, size: size, defaultSize: defaultSize = $4302180bdfaa4dc4$var$DEFAULT_SIZE, height: height, width: width, mask: drawerMask, push: push = $4302180bdfaa4dc4$var$DEFAULT_PUSH_STATE, open: open, afterOpenChange: afterOpenChange, onClose: onClose, prefixCls: customizePrefixCls, getContainer: customizeGetContainer, panelRef: panelRef = null, style: style, className: className, resizable: resizable, "aria-labelledby": ariaLabelledby, focusable: // Focus
    focusable, maskClosable: // Deprecated
    maskClosable, maskStyle: maskStyle, drawerStyle: drawerStyle, contentWrapperStyle: contentWrapperStyle, destroyOnClose: destroyOnClose, destroyOnHidden: destroyOnHidden, ...rest } = props;
    const { placement: placement } = rest;
    const id = (0, $a2da91bb60e2cbfb$export$2e2bcd8739ae039)();
    const ariaId = rest.title ? id : undefined;
    const { getPopupContainer: getPopupContainer, getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles, mask: contextMask, focusable: contextFocusable } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("drawer");
    const prefixCls = getPrefixCls("drawer", customizePrefixCls);
    const [hashId, cssVarCls] = (0, $eb695dd7dc67dbda$export$2e2bcd8739ae039)(prefixCls);
    const getContainer = // 有可能为 false，所以不能直接判断
    customizeGetContainer === undefined && getPopupContainer ? ()=>getPopupContainer(document.body) : customizeGetContainer;
    // ============================ Size ============================
    const drawerSize = $cQmXV.useMemo(()=>{
        if ((0, $8e2d153a3c855782$export$7e4aa119212bc614)(size)) return size;
        if (size === "large") return 736;
        if (size === "default") return $4302180bdfaa4dc4$var$DEFAULT_SIZE;
        if (typeof size === "string") {
            if (/^\d+(\.\d+)?$/.test(size)) return Number(size);
            return size;
        }
        if (!placement || placement === "left" || placement === "right") return width;
        return height;
    }, [
        size,
        placement,
        width,
        height
    ]);
    // =========================== Motion ===========================
    const maskMotion = {
        motionName: (0, $047a5f051ebda8ba$export$27c72201b1d09951)(prefixCls, "mask-motion"),
        ...$4302180bdfaa4dc4$var$MOTION_CONFIG
    };
    const panelMotion = (motionPlacement)=>({
            motionName: (0, $047a5f051ebda8ba$export$27c72201b1d09951)(prefixCls, `panel-motion-${motionPlacement}`),
            ...$4302180bdfaa4dc4$var$MOTION_CONFIG
        });
    // ============================ Refs ============================
    // Select `ant-drawer-content` by `panelRef`
    const innerPanelRef = (0, $f1d001121ad33e46$export$94ab53417567be34)();
    const mergedPanelRef = (0, $10341b937b26f69d$export$ab452c34e8e05029)(panelRef, innerPanelRef);
    // =========================== zIndex ===========================
    const [zIndex, contextZIndex] = (0, $b2b300e6909d7707$export$3e7906d4075187a4)("Drawer", rest.zIndex);
    // ============================ Mask ============================
    const [mergedMask, maskBlurClassName, mergedMaskClosable] = (0, $43591a623a20c2b6$export$a4ac1bdd74570410)(drawerMask, contextMask, prefixCls, maskClosable);
    // ========================== Focusable =========================
    const mergedFocusable = (0, $16771e6a3398e203$export$2e2bcd8739ae039)({
        ...contextFocusable,
        ...focusable
    }, getContainer !== false && mergedMask);
    // =========================== Render ===========================
    const { classNames: classNames, styles: styles, rootStyle: rootStyle } = rest;
    const mergedProps = {
        ...props,
        zIndex: zIndex,
        panelRef: panelRef,
        mask: mergedMask,
        maskClosable: mergedMaskClosable,
        defaultSize: defaultSize,
        push: push,
        focusable: mergedFocusable
    };
    const contextSectionStyle = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(contextStyle, "section");
    const drawerSectionStyle = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(drawerStyle, "section");
    const sectionStyle = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(style, "section");
    const [mergedClassNames, mergedStyles] = (0, $30c5f9f911d4f61b$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextSectionStyle,
        styles,
        drawerSectionStyle,
        sectionStyle
    ], {
        props: mergedProps
    });
    const drawerClassName = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)({
        "no-mask": !mergedMask,
        [`${prefixCls}-rtl`]: direction === "rtl"
    }, rootClassName, hashId, cssVarCls, mergedClassNames.root);
    var deprecatedName, newName;
    return /*#__PURE__*/ $cQmXV.createElement((0, $1585084388e75c84$export$2e2bcd8739ae039), {
        form: true,
        space: true
    }, /*#__PURE__*/ $cQmXV.createElement((0, $2a7b32ec1626bb34$export$2e2bcd8739ae039).Provider, {
        value: contextZIndex
    }, /*#__PURE__*/ $cQmXV.createElement((0, $d7a68e565aac79e7$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        onClose: onClose,
        maskMotion: maskMotion,
        motion: panelMotion,
        ...rest,
        classNames: {
            mask: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(mergedClassNames.mask, maskBlurClassName.mask),
            section: mergedClassNames.section,
            wrapper: mergedClassNames.wrapper,
            dragger: mergedClassNames.dragger
        },
        styles: {
            mask: {
                ...mergedStyles.mask,
                ...maskStyle
            },
            section: mergedStyles.section,
            wrapper: {
                ...mergedStyles.wrapper,
                ...contentWrapperStyle
            },
            dragger: mergedStyles.dragger
        },
        open: open,
        mask: mergedMask,
        maskClosable: mergedMaskClosable,
        push: push,
        size: drawerSize,
        defaultSize: defaultSize,
        rootStyle: {
            ...mergedStyles.root,
            ...rootStyle
        },
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(contextClassName, className),
        rootClassName: drawerClassName,
        getContainer: getContainer,
        afterOpenChange: afterOpenChange,
        panelRef: mergedPanelRef,
        zIndex: zIndex,
        ...resizable ? {
            resizable: resizable
        } : {},
        "aria-labelledby": ariaLabelledby ?? ariaId,
        destroyOnHidden: destroyOnHidden ?? destroyOnClose,
        // Focusable
        focusTriggerAfterClose: mergedFocusable.focusTriggerAfterClose,
        focusTrap: mergedFocusable.trap
    }, /*#__PURE__*/ $cQmXV.createElement((0, $a0b4bfdf7560f45f$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        size: size,
        ...rest,
        ariaId: ariaId,
        onClose: onClose
    }))));
};
/** @private Internal Component. Do not use in your production. */ const $4302180bdfaa4dc4$var$PurePanel = (props)=>{
    const { prefixCls: customizePrefixCls, style: style, className: className, placement: placement = "right", ...restProps } = props;
    const { getPrefixCls: getPrefixCls } = $cQmXV.useContext((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls("drawer", customizePrefixCls);
    const [hashId, cssVarCls] = (0, $eb695dd7dc67dbda$export$2e2bcd8739ae039)(prefixCls);
    const cls = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-pure`, `${prefixCls}-${placement}`, hashId, cssVarCls, className);
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        className: cls,
        style: style
    }, /*#__PURE__*/ $cQmXV.createElement((0, $a0b4bfdf7560f45f$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        ...restProps
    }));
};
$4302180bdfaa4dc4$var$Drawer._InternalPanelDoNotUseOrYouWillBeFired = $4302180bdfaa4dc4$var$PurePanel;
var $4302180bdfaa4dc4$export$2e2bcd8739ae039 = $4302180bdfaa4dc4$var$Drawer;


"use client";
var $265dbad0185b5dfc$export$2e2bcd8739ae039 = (0, $4302180bdfaa4dc4$export$2e2bcd8739ae039);



var $39824af573644a06$exports = {};
$39824af573644a06$exports = new URL("logo-white.f0350e20.svg", import.meta.url).toString();




const $bddbe90ebe740c11$var$typeTemplate = "${label}-\u0568 \u057E\u0561\u057E\u0565\u0580 ${type} \u0579\u0567";
const $bddbe90ebe740c11$var$datePickerLocale = {
    lang: {
        locale: "hy-am",
        placeholder: "\u0538\u0576\u057F\u0580\u0565\u0584 \u0561\u0574\u057D\u0561\u0569\u056B\u057E\u0568",
        rangePlaceholder: [
            "\u0544\u0565\u056F\u0576\u0561\u0580\u056F\u056B \u0561\u0574\u057D\u0561\u0569\u056B\u057E",
            "\u0531\u057E\u0561\u0580\u057F\u056B \u0561\u0574\u057D\u0561\u0569\u056B\u057E\u0568"
        ],
        today: "\u0531\u0575\u057D\u0585\u0580",
        now: "\u0540\u056B\u0574\u0561",
        backToToday: "\u054E\u0565\u0580\u0561\u0564\u0561\u057C\u0576\u0561\u056C \u0561\u0575\u057D\u0585\u0580",
        ok: "\u0555\u056F",
        clear: "\u0544\u0561\u0584\u0580\u0565\u056C",
        week: "\u0547\u0561\u0562\u0561\u0569",
        month: "\u0531\u0574\u056B\u057D",
        year: "\u054F\u0561\u0580\u056B",
        timeSelect: "\u0568\u0576\u057F\u0580\u0565\u0584 \u056A\u0561\u0574\u0568",
        dateSelect: "\u0568\u0576\u057F\u0580\u0565\u0584 \u0561\u0574\u057D\u0561\u0569\u056B\u057E\u0568",
        weekSelect: "\u0538\u0576\u057F\u0580\u0565\u0584 \u0577\u0561\u0562\u0561\u0569\u0568",
        monthSelect: "\u0538\u0576\u057F\u0580\u0565\u0584 \u0561\u0574\u056B\u057D\u0568",
        yearSelect: "\u0538\u0576\u057F\u0580\u0565\u0584 \u057F\u0561\u0580\u056B\u0576",
        decadeSelect: "\u0538\u0576\u057F\u0580\u0565\u0584 \u057F\u0561\u057D\u0576\u0561\u0574\u0575\u0561\u056F\u0568",
        yearFormat: "YYYY",
        dayFormat: "DD",
        monthBeforeYear: true,
        previousMonth: "\u0531\u0576\u0581\u0561\u056E \u0561\u0574\u056B\u057D (PageUp)",
        nextMonth: "\u0544\u0575\u0578\u0582\u057D \u0561\u0574\u056B\u057D (PageDown)",
        previousYear: "\u0531\u0576\u0581\u0561\u056E \u057F\u0561\u0580\u056B (Control + left)",
        nextYear: "\u0544\u0575\u0578\u0582\u057D \u057F\u0561\u0580\u056B (Control + right)",
        previousDecade: "\u0531\u0576\u0581\u0561\u056E \u057F\u0561\u057D\u0576\u0561\u0574\u0575\u0561\u056F",
        nextDecade: "\u0544\u0575\u0578\u0582\u057D \u057F\u0561\u057D\u0576\u0561\u0574\u0575\u0561\u056F",
        previousCentury: "\u0531\u0576\u0581\u0561\u056E \u0564\u0561\u0580",
        nextCentury: "\u0544\u0575\u0578\u0582\u057D \u0564\u0561\u0580"
    },
    timePickerLocale: {
        placeholder: "\u0538\u0576\u057F\u0580\u0565\u0584 \u056A\u0561\u0574\u0568"
    }
};
const $bddbe90ebe740c11$var$localeValues = {
    locale: "hy-am",
    Pagination: {
        // Options.jsx
        items_per_page: "/ \u0567\u057B",
        jump_to: "\u0533\u0576\u0561\u056C",
        jump_to_confirm: "\u0570\u0561\u057D\u057F\u0561\u057F\u0565\u056C",
        page: "",
        // Pagination.jsx
        prev_page: "\u0546\u0561\u056D\u0578\u0580\u0564 \u0537\u057B",
        next_page: "\u0540\u0561\u057B\u0578\u0580\u0564 \u0537\u057B",
        prev_5: "\u0546\u0561\u056D\u0578\u0580\u0564 5 \u0537\u057B\u0565\u0580\u0568",
        next_5: "\u0540\u0561\u057B\u0578\u0580\u0564 5 \u0537\u057B\u0565\u0580\u0568",
        prev_3: "\u0546\u0561\u056D\u0578\u0580\u0564 3 \u0537\u057B\u0565\u0580\u0568",
        next_3: "\u0540\u0561\u057B\u0578\u0580\u0564 3 \u0537\u057B\u0565\u0580\u0568"
    },
    DatePicker: $bddbe90ebe740c11$var$datePickerLocale,
    TimePicker: {
        placeholder: "\u0538\u0576\u057F\u0580\u0565\u0584 \u056A\u0561\u0574\u0568"
    },
    Calendar: $bddbe90ebe740c11$var$datePickerLocale,
    global: {
        placeholder: "\u0538\u0576\u057F\u0580\u0565\u0584",
        close: "\u0534\u0561\u0564\u0561\u0580\u0565\u0581\u0576\u0565\u056C",
        show: "\u0551\u0578\u0582\u0575\u0581 \u057F\u0561\u056C",
        hide: "\u0539\u0561\u0584\u0581\u0576\u0565\u056C",
        sortable: "\u057F\u0565\u057D\u0561\u056F\u0561\u057E\u0578\u0580\u0565\u056C\u056B"
    },
    Table: {
        filterTitle: "\u0586\u056B\u056C\u057F\u0580\u056B \u0568\u0576\u057F\u0580\u0561\u0581\u0561\u0576\u056F",
        filterConfirm: "\u0586\u056B\u056C\u057F\u0580\u0565\u056C",
        filterReset: "\u0536\u0580\u0578\u0575\u0561\u0581\u0576\u0565\u056C",
        selectAll: "\u0538\u0576\u057F\u0580\u0565\u0584 \u0568\u0576\u0569\u0561\u0581\u056B\u056F \u0567\u057B\u0568",
        selectInvert: "\u0553\u0578\u056D\u0561\u0580\u056F\u0565\u056C \u0568\u0576\u0569\u0561\u0581\u056B\u056F \u0567\u057B\u0568",
        sortTitle: "\u054F\u0565\u057D\u0561\u056F\u0561\u057E\u0578\u0580\u0565\u056C",
        expand: "\u0538\u0576\u0564\u056C\u0561\u0575\u0576\u0565\u0584 \u057F\u0578\u0572\u0568",
        collapse: "\u053F\u0580\u0573\u0561\u057F\u0565\u056C \u057F\u0578\u0572\u0568",
        filterEmptyText: "\u0536\u057F\u056B\u0579\u0576\u0565\u0580 \u0579\u056F\u0561\u0576",
        filterCheckAll: "\u0538\u0576\u057F\u0580\u0565\u0584 \u0562\u0578\u056C\u0578\u0580 \u057F\u0561\u0580\u0580\u0565\u0580\u0568",
        filterSearchPlaceholder: "\u0548\u0580\u0578\u0576\u0565\u056C \u0586\u056B\u056C\u057F\u0580\u0565\u0580\u0578\u0582\u0574",
        emptyText: "\u054F\u057E\u0575\u0561\u056C\u0576\u0565\u0580 \u0579\u056F\u0561\u0576",
        selectNone: "\u0544\u0561\u0584\u0580\u0565\u056C \u0562\u0578\u056C\u0578\u0580 \u057F\u057E\u0575\u0561\u056C\u0576\u0565\u0580\u0568",
        selectionAll: "\u0538\u0576\u057F\u0580\u0565\u0584 \u0562\u0578\u056C\u0578\u0580 \u057F\u057E\u0575\u0561\u056C\u0576\u0565\u0580\u0568",
        triggerDesc: "\u054D\u0565\u0572\u0574\u0565\u0584\u055D \u0576\u057E\u0561\u0566\u0574\u0561\u0576 \u056F\u0561\u0580\u0563\u0578\u057E",
        triggerAsc: "\u054D\u0565\u0572\u0574\u0565\u0584\u055D \u0561\u0573\u0578\u0572 \u057F\u0565\u057D\u0561\u056F\u0561\u057E\u0578\u0580\u0565\u056C\u0578\u0582 \u0570\u0561\u0574\u0561\u0580",
        cancelSort: "\u054D\u0565\u0572\u0574\u0565\u0584\u055D \u057F\u0565\u057D\u0561\u056F\u0561\u057E\u0578\u0580\u0578\u0582\u0574\u0568 \u0579\u0565\u0572\u0561\u0580\u056F\u0565\u056C\u0578\u0582 \u0570\u0561\u0574\u0561\u0580"
    },
    Tour: {
        Next: "\u0540\u0561\u057B\u0578\u0580\u0564",
        Previous: "\u0546\u0561\u056D\u0578\u0580\u0564",
        Finish: "\u0531\u057E\u0561\u0580\u057F\u0565\u056C"
    },
    Modal: {
        okText: "\u0555\u056F",
        cancelText: "\u0549\u0565\u0572\u0561\u0580\u056F\u0565\u056C",
        justOkText: "\u0555\u056F"
    },
    Popconfirm: {
        okText: "\u0540\u0561\u057D\u057F\u0561\u057F\u0565\u056C",
        cancelText: "\u0544\u0565\u0580\u056A\u0565\u056C"
    },
    Transfer: {
        titles: [
            "",
            ""
        ],
        searchPlaceholder: "\u0548\u0580\u0578\u0576\u0565\u0584 \u0561\u0575\u057D\u057F\u0565\u0572",
        itemUnit: "\u057A\u0561\u0580\u0561\u0563\u0561\u0576",
        itemsUnit: "\u057A\u0561\u0580\u0561\u0563\u0561\u0576\u0565\u0580\u0568",
        remove: "\u0540\u0565\u057C\u0561\u0581\u0576\u0565\u056C",
        selectCurrent: "\u0538\u0576\u057F\u0580\u0565\u0584 \u0568\u0576\u0569\u0561\u0581\u056B\u056F \u0567\u057B\u0568",
        removeCurrent: "\u0540\u0565\u057C\u0561\u0581\u0576\u0565\u056C \u0568\u0576\u0569\u0561\u0581\u056B\u056F \u0567\u057B\u0568",
        selectAll: "\u0538\u0576\u057F\u0580\u0565\u0584 \u0562\u0578\u056C\u0578\u0580 \u057F\u057E\u0575\u0561\u056C\u0576\u0565\u0580\u0568",
        deselectAll: "\u0531\u057A\u0561\u0568\u0576\u057F\u0580\u0565\u056C \u0562\u0578\u056C\u0578\u0580 \u057F\u057E\u0575\u0561\u056C\u0576\u0565\u0580\u0568",
        removeAll: "\u0540\u0565\u057C\u0561\u0581\u0580\u0565\u0584 \u0562\u0578\u056C\u0578\u0580 \u057F\u057E\u0575\u0561\u056C\u0576\u0565\u0580\u0568",
        selectInvert: "\u0547\u0580\u057B\u0565\u056C \u0568\u0576\u0569\u0561\u0581\u056B\u056F \u0567\u057B\u0568"
    },
    Upload: {
        uploading: "\u0546\u0565\u0580\u0562\u0565\u057C\u0576\u0578\u0582\u0574...",
        removeFile: "\u0540\u0565\u057C\u0561\u0581\u0576\u0565\u056C \u0586\u0561\u0575\u056C\u0568",
        uploadError: "\u0546\u0565\u0580\u0562\u0565\u057C\u0576\u0574\u0561\u0576 \u057D\u056D\u0561\u056C",
        previewFile: "\u0534\u056B\u057F\u0565\u056C \u0586\u0561\u0575\u056C\u0568",
        downloadFile: "\u0546\u0565\u0580\u0562\u0565\u057C\u0576\u0565\u056C \u0586\u0561\u0575\u056C\u0568"
    },
    Empty: {
        description: "\u054F\u057E\u0575\u0561\u056C\u0576\u0565\u0580 \u0579\u056F\u0561\u0576"
    },
    Icon: {
        icon: "\u057A\u0561\u057F\u056F\u0565\u0580"
    },
    Text: {
        edit: "\u053D\u0574\u0562\u0561\u0563\u0580\u0565\u056C",
        copy: "\u054A\u0561\u057F\u0573\u0565\u0576\u0565\u056C",
        copied: "\u054A\u0561\u057F\u0573\u0565\u0576\u057E\u0565\u056C \u0567",
        expand: "\u054F\u0565\u057D\u0576\u0565\u056C \u0561\u057E\u0565\u056C\u056B\u0576",
        collapse: "\u0553\u056C\u0578\u0582\u0566\u0578\u0582\u0574"
    },
    Form: {
        optional: "(\u0578\u0579 \u057A\u0561\u0580\u057F\u0561\u0564\u056B\u0580)",
        defaultValidateMessages: {
            default: "\u0534\u0561\u0577\u057F\u056B \u057E\u0561\u057E\u0565\u0580\u0561\u056F\u0561\u0576\u0578\u0582\u0569\u0575\u0561\u0576 \u057D\u056D\u0561\u056C\u055D ${label}",
            required: "\u053D\u0576\u0564\u0580\u0578\u0582\u0574 \u0565\u0576\u0584 \u0574\u0578\u0582\u057F\u0584\u0561\u0563\u0580\u0565\u056C ${label}",
            enum: "${label}-\u0568 \u057A\u0565\u057F\u0584 \u0567 \u056C\u056B\u0576\u056B [${enum}]-\u056B\u0581 \u0574\u0565\u056F\u0568",
            whitespace: "${label}-\u0568 \u0579\u056B \u056F\u0561\u0580\u0578\u0572 \u056C\u056B\u0576\u0565\u056C \u0564\u0561\u057F\u0561\u0580\u056F \u0576\u056B\u0577",
            date: {
                format: "${label} \u0561\u0574\u057D\u0561\u0569\u057E\u056B \u0571\u0587\u0561\u0579\u0561\u0583\u0568 \u0561\u0576\u057E\u0561\u057E\u0565\u0580 \u0567",
                parse: "${label}-\u0568 \u0570\u0576\u0561\u0580\u0561\u057E\u0578\u0580 \u0579\u0567 \u0583\u0578\u056D\u0561\u0580\u056F\u0565\u056C \u0561\u0574\u057D\u0561\u0569\u057E\u056B",
                invalid: "${label}-\u0568 \u0561\u0576\u057E\u0561\u057E\u0565\u0580 \u0561\u0574\u057D\u0561\u0569\u056B\u057E \u0567"
            },
            types: {
                string: $bddbe90ebe740c11$var$typeTemplate,
                method: $bddbe90ebe740c11$var$typeTemplate,
                array: $bddbe90ebe740c11$var$typeTemplate,
                object: $bddbe90ebe740c11$var$typeTemplate,
                number: $bddbe90ebe740c11$var$typeTemplate,
                date: $bddbe90ebe740c11$var$typeTemplate,
                boolean: $bddbe90ebe740c11$var$typeTemplate,
                integer: $bddbe90ebe740c11$var$typeTemplate,
                float: $bddbe90ebe740c11$var$typeTemplate,
                regexp: $bddbe90ebe740c11$var$typeTemplate,
                email: $bddbe90ebe740c11$var$typeTemplate,
                url: $bddbe90ebe740c11$var$typeTemplate,
                hex: $bddbe90ebe740c11$var$typeTemplate
            },
            string: {
                len: "${label}-\u0568 \u057A\u0565\u057F\u0584 \u0567 \u056C\u056B\u0576\u056B ${len} \u0576\u056B\u0577",
                min: "${label}-\u0568 \u057A\u0565\u057F\u0584 \u0567 \u056C\u056B\u0576\u056B \u0561\u057C\u0576\u057E\u0561\u0566\u0576 ${min} \u0576\u056B\u0577",
                max: "${label}-\u0568 \u056F\u0561\u0580\u0578\u0572 \u0567 \u056C\u056B\u0576\u0565\u056C \u0561\u057C\u0561\u057E\u0565\u056C\u0561\u0563\u0578\u0582\u0575\u0576\u0568 ${max} \u0576\u056B\u0577",
                range: "${label}-\u0568 \u057A\u0565\u057F\u0584 \u0567 \u056C\u056B\u0576\u056B ${min}-${max} \u0576\u056B\u0577\u0565\u0580\u056B \u0574\u056B\u057B\u0587"
            },
            number: {
                len: "${label}-\u0568 \u057A\u0565\u057F\u0584 \u0567 \u0570\u0561\u057E\u0561\u057D\u0561\u0580 \u056C\u056B\u0576\u056B ${len}-\u056B\u0576",
                min: "${label}-\u0568 \u057A\u0565\u057F\u0584 \u0567 \u056C\u056B\u0576\u056B \u0561\u057C\u0576\u057E\u0561\u0566\u0576 ${min}",
                max: "${label}-\u0568 \u056F\u0561\u0580\u0578\u0572 \u0567 \u056C\u056B\u0576\u0565\u056C \u0561\u057C\u0561\u057E\u0565\u056C\u0561\u0563\u0578\u0582\u0575\u0576\u0568 ${max}",
                range: "${label}-\u0568 \u057A\u0565\u057F\u0584 \u0567 \u056C\u056B\u0576\u056B ${min}-${max} \u0574\u056B\u057B\u0561\u056F\u0561\u0575\u0584\u0578\u0582\u0574"
            },
            array: {
                len: "\u054A\u0565\u057F\u0584 \u0567 \u056C\u056B\u0576\u056B ${len} ${label}",
                min: "\u0531\u057C\u0576\u057E\u0561\u0566\u0576 ${min} ${label}",
                max: "\u0531\u057C\u0561\u057E\u0565\u056C\u0561\u0563\u0578\u0582\u0575\u0576\u0568 ${max} ${label}",
                range: "${label}-\u056B \u0584\u0561\u0576\u0561\u056F\u0568 \u057A\u0565\u057F\u0584 \u0567 \u056C\u056B\u0576\u056B ${min}-${max} \u0574\u056B\u057B\u0561\u056F\u0561\u0575\u0584\u0578\u0582\u0574"
            },
            pattern: {
                mismatch: "${label}-\u0568 \u0579\u056B \u0570\u0561\u0574\u0561\u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0578\u0582\u0574 ${pattern} \u0571\u0587\u0561\u0576\u0574\u0578\u0582\u0577\u056B\u0576"
            }
        }
    },
    QRCode: {
        expired: "QR \u056F\u0578\u0564\u0568 \u056A\u0561\u0574\u056F\u0565\u057F\u0561\u0576\u0581 \u0567",
        refresh: "\u0539\u0561\u0580\u0574\u0561\u0581\u0576\u0565\u056C",
        scanned: "\u054D\u056F\u0561\u0576\u0561\u057E\u0578\u0580\u057E\u0565\u056C \u0567"
    },
    ColorPicker: {
        presetEmpty: "\u0534\u0561\u057F\u0561\u0580\u056F",
        transparent: "\u0539\u0561\u0583\u0561\u0576\u0581\u056B\u056F",
        singleColor: "\u0544\u0565\u056F \u0563\u0578\u0582\u0575\u0576",
        gradientColor: "\u0533\u0580\u0561\u0564\u056B\u0565\u0576\u057F \u0563\u0578\u0582\u0575\u0576"
    }
};
var $bddbe90ebe740c11$export$2e2bcd8739ae039 = $bddbe90ebe740c11$var$localeValues;


const $cf3eb979f2c4275a$var$locale = {
    // Options
    items_per_page: "/ \u10D2\u10D5\u10D4\u10E0\u10D3\u10D8.",
    jump_to: "\u10D2\u10D0\u10D3\u10D0\u10E1\u10D5\u10DA\u10D0",
    jump_to_confirm: "\u10D3\u10D0\u10D3\u10D0\u10E1\u10E2\u10E3\u10E0\u10D4\u10D1\u10D0",
    page: "",
    // Pagination
    prev_page: "\u10EC\u10D8\u10DC\u10D0 \u10D2\u10D5\u10D4\u10E0\u10D3\u10D8",
    next_page: "\u10E8\u10D4\u10DB\u10D3\u10D4\u10D2\u10D8 \u10D2\u10D5\u10D4\u10E0\u10D3\u10D8",
    prev_5: "\u10EC\u10D8\u10DC\u10D0 5 \u10D2\u10D5\u10D4\u10E0\u10D3\u10D8",
    next_5: "\u10E8\u10D4\u10DB\u10D3\u10D4\u10D2\u10D8 5 \u10D2\u10D5\u10D4\u10E0\u10D3\u10D8",
    prev_3: "\u10EC\u10D8\u10DC\u10D0 3 \u10D2\u10D5\u10D4\u10E0\u10D3\u10D8",
    next_3: "\u10E8\u10D4\u10DB\u10D3\u10D4\u10D2\u10D8 3 \u10D2\u10D5\u10D4\u10E0\u10D3\u10D8",
    page_size: "Page Size"
};
var $cf3eb979f2c4275a$export$2e2bcd8739ae039 = $cf3eb979f2c4275a$var$locale;



const $e76575a65596b044$var$locale = {
    ...(0, $468f660b5a11d829$export$bdd78c3fd9633c1e),
    locale: "ka_GE",
    today: "\u10D3\u10E6\u10D4\u10E1",
    now: "\u10D0\u10EE\u10DA\u10D0",
    backToToday: "\u10DB\u10D8\u10DB\u10D3\u10D8\u10DC\u10D0\u10E0\u10D4 \u10D7\u10D0\u10E0\u10D8\u10E6\u10D8",
    ok: "OK",
    clear: "\u10D2\u10D0\u10E1\u10E3\u10E4\u10D7\u10D0\u10D5\u10D4\u10D1\u10D0",
    week: "\u10D9\u10D5\u10D8\u10E0\u10D0",
    month: "\u10D7\u10D5\u10D4",
    year: "\u10EC\u10D4\u10DA\u10D8",
    timeSelect: "\u10D3\u10E0\u10DD\u10D8\u10E1 \u10D0\u10E0\u10E9\u10D4\u10D5\u10D0",
    dateSelect: "\u10D7\u10D0\u10E0\u10D8\u10E6\u10D8\u10E1 \u10D0\u10E0\u10E9\u10D4\u10D5\u10D0",
    weekSelect: "\u10D9\u10D5\u10D8\u10E0\u10D8\u10E1 \u10D0\u10E0\u10E9\u10D4\u10D5\u10D0",
    monthSelect: "\u10D7\u10D5\u10D8\u10E1 \u10D0\u10E0\u10E9\u10D4\u10D5\u10D0",
    yearSelect: "\u10EC\u10DA\u10D8\u10E1 \u10D0\u10E0\u10E9\u10D4\u10D5\u10D0",
    decadeSelect: "\u10D0\u10D7\u10EC\u10DA\u10D4\u10E3\u10DA\u10D8\u10E1 \u10D0\u10E0\u10E9\u10D4\u10D5\u10D0",
    previousMonth: "\u10EC\u10D8\u10DC\u10D0 \u10D7\u10D5\u10D4",
    nextMonth: "\u10DB\u10DD\u10DB\u10D3\u10D4\u10D5\u10DC\u10DD \u10D7\u10D5\u10D4",
    previousYear: "\u10EC\u10D8\u10DC\u10D0 \u10EC\u10D4\u10DA\u10D8",
    nextYear: "\u10DB\u10DD\u10DB\u10D3\u10D4\u10D5\u10DC\u10DD \u10EC\u10D4\u10DA\u10D8",
    previousDecade: "\u10EC\u10D8\u10DC\u10D0 \u10D0\u10D7\u10EC\u10DA\u10D4\u10E3\u10DA\u10D8",
    nextDecade: "\u10DB\u10DD\u10DB\u10D3\u10D4\u10D5\u10DC\u10DD \u10D0\u10D7\u10EC\u10DA\u10D4\u10E3\u10DA\u10D8",
    previousCentury: "\u10D2\u10D0\u10E1\u10E3\u10DA\u10D8 \u10E1\u10D0\u10E3\u10D9\u10E3\u10DC\u10D4",
    nextCentury: "\u10DB\u10DD\u10DB\u10D3\u10D4\u10D5\u10DC\u10DD \u10E1\u10D0\u10E3\u10D9\u10E3\u10DC\u10D4"
};
var $e76575a65596b044$export$2e2bcd8739ae039 = $e76575a65596b044$var$locale;


const $9b4be7e0379d81f5$var$locale = {
    placeholder: "\u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10D3\u10E0\u10DD",
    rangePlaceholder: [
        "\u10E1\u10D0\u10EC\u10E7\u10D8\u10E1\u10D8 \u10D7\u10D0\u10E0\u10D8\u10E6\u10D8",
        "\u10E1\u10D0\u10D1\u10DD\u10DA\u10DD\u10DD \u10D7\u10D0\u10E0\u10D8\u10E6\u10D8"
    ]
};
var $9b4be7e0379d81f5$export$2e2bcd8739ae039 = $9b4be7e0379d81f5$var$locale;


const $779b762a5a172f8c$var$locale = {
    lang: {
        placeholder: "\u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10D7\u10D0\u10E0\u10D8\u10E6\u10D8",
        yearPlaceholder: "\u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10EC\u10D4\u10DA\u10D8",
        quarterPlaceholder: "\u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10DB\u10D4\u10DD\u10D7\u10EE\u10D4\u10D3\u10D8",
        monthPlaceholder: "\u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10D7\u10D5\u10D4",
        weekPlaceholder: "\u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10D9\u10D5\u10D8\u10E0\u10D0",
        rangePlaceholder: [
            "\u10E1\u10D0\u10EC\u10E7\u10D8\u10E1\u10D8 \u10D7\u10D0\u10E0\u10D8\u10E6\u10D8",
            "\u10E1\u10D0\u10D1\u10DD\u10DA\u10DD\u10DD \u10D7\u10D0\u10E0\u10D8\u10E6\u10D8"
        ],
        rangeYearPlaceholder: [
            "\u10E1\u10D0\u10EC\u10E7\u10D8\u10E1\u10D8 \u10EC\u10D4\u10DA\u10D8",
            "\u10E1\u10D0\u10D1\u10DD\u10DA\u10DD\u10DD \u10EC\u10D4\u10DA\u10D8"
        ],
        rangeMonthPlaceholder: [
            "\u10E1\u10D0\u10EC\u10E7\u10D8\u10E1\u10D8 \u10D7\u10D5\u10D4",
            "\u10E1\u10D0\u10D1\u10DD\u10DA\u10DD\u10DD \u10D7\u10D5\u10D4"
        ],
        rangeWeekPlaceholder: [
            "\u10E1\u10D0\u10EC\u10E7\u10D8\u10E1\u10D8 \u10D9\u10D5\u10D8\u10E0\u10D0",
            "\u10E1\u10D0\u10D1\u10DD\u10DA\u10DD\u10DD \u10D9\u10D5\u10D8\u10E0\u10D0"
        ],
        ...(0, $e76575a65596b044$export$2e2bcd8739ae039)
    },
    timePickerLocale: {
        ...(0, $9b4be7e0379d81f5$export$2e2bcd8739ae039)
    }
};
var $779b762a5a172f8c$export$2e2bcd8739ae039 = $779b762a5a172f8c$var$locale;


var $a842407a6437d309$export$2e2bcd8739ae039 = (0, $779b762a5a172f8c$export$2e2bcd8739ae039);




const $9eaeb6750148cf1f$var$typeTemplate = "${label} \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1 \u10E1\u10EC\u10DD\u10E0\u10D8 ${type}";
const $9eaeb6750148cf1f$var$localeValues = {
    locale: "ka",
    Pagination: $cf3eb979f2c4275a$export$2e2bcd8739ae039,
    DatePicker: $779b762a5a172f8c$export$2e2bcd8739ae039,
    TimePicker: $9b4be7e0379d81f5$export$2e2bcd8739ae039,
    Calendar: $a842407a6437d309$export$2e2bcd8739ae039,
    global: {
        placeholder: "\u10D2\u10D7\u10EE\u10DD\u10D5\u10D7 \u10D0\u10D8\u10E0\u10E9\u10D8\u10DD\u10D7",
        close: "\u10D3\u10D0\u10EE\u10E3\u10E0\u10D5\u10D0",
        show: "\u10D0\u10E9\u10D5\u10D4\u10DC\u10D4",
        hide: "\u10D3\u10D0\u10DB\u10D0\u10DA\u10D4",
        sortable: "\u10D3\u10D0\u10E1\u10D0\u10DA\u10D0\u10D2\u10D4\u10D1\u10D4\u10DA\u10D8"
    },
    Table: {
        filterTitle: "\u10E4\u10D8\u10DA\u10E2\u10E0\u10D8\u10E1 \u10DB\u10D4\u10DC\u10D8\u10E3",
        filterConfirm: "\u10D9\u10D0\u10E0\u10D2\u10D8",
        filterReset: "\u10D2\u10D0\u10E1\u10E3\u10E4\u10D7\u10D0\u10D5\u10D4\u10D1\u10D0",
        filterEmptyText: "\u10E4\u10D8\u10DA\u10E2\u10E0\u10D4\u10D1\u10D8 \u10D0\u10E0\u10D0\u10D0",
        emptyText: "\u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D0 \u10D0\u10E0\u10D0\u10D0",
        selectAll: "\u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10DB\u10D8\u10DB\u10D3\u10D8\u10DC\u10D0\u10E0\u10D4 \u10D2\u10D5\u10D4\u10E0\u10D3\u10D8",
        selectInvert: "\u10E8\u10D4\u10D0\u10D1\u10E0\u10E3\u10DC\u10D4\u10D7 \u10DB\u10D8\u10DB\u10D3\u10D8\u10DC\u10D0\u10E0\u10D4 \u10D2\u10D5\u10D4\u10E0\u10D3\u10D8",
        selectNone: "\u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10E1\u10E3\u10E4\u10D7\u10D0\u10D5\u10D4\u10D1\u10D0",
        selectionAll: "\u10E7\u10D5\u10D4\u10DA\u10D0\u10E1 \u10DB\u10DD\u10DC\u10D8\u10E8\u10D5\u10DC\u10D0",
        sortTitle: "\u10D3\u10D0\u10DA\u10D0\u10D2\u10D4\u10D1\u10D0",
        expand: "\u10E1\u10E2\u10E0\u10D8\u10E5\u10DD\u10DC\u10D8\u10E1 \u10D2\u10D0\u10E8\u10DA\u10D0",
        collapse: "\u10E1\u10E2\u10E0\u10D8\u10E5\u10DD\u10DC\u10D8\u10E1 \u10E8\u10D4\u10D9\u10E3\u10DB\u10E8\u10D5\u10D0",
        triggerDesc: "\u10D3\u10D0\u10E6\u10DB\u10D0\u10D5\u10D0\u10DA\u10D8 \u10D3\u10D0\u10DA\u10D0\u10D2\u10D4\u10D1\u10D0",
        triggerAsc: "\u10D0\u10E6\u10DB\u10D0\u10D5\u10D0\u10DA\u10D8 \u10D3\u10D0\u10DA\u10D0\u10D2\u10D4\u10D1\u10D0",
        cancelSort: "\u10D3\u10D0\u10DA\u10D0\u10D2\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10E3\u10E5\u10DB\u10D4\u10D1\u10D0",
        filterCheckAll: "\u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10E7\u10D5\u10D4\u10DA\u10D0 \u10D4\u10DA\u10D4\u10DB\u10D4\u10DC\u10E2\u10D8",
        filterSearchPlaceholder: "\u10DB\u10DD\u10EB\u10D4\u10D1\u10DC\u10D4\u10D7 \u10E4\u10D8\u10DA\u10E2\u10E0\u10D4\u10D1\u10E8\u10D8"
    },
    Tour: {
        Next: "\u10DB\u10DD\u10DB\u10D3\u10D4\u10D5\u10DC\u10DD",
        Previous: "\u10EC\u10D8\u10DC\u10D0",
        Finish: "\u10D3\u10D0\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10D0"
    },
    Modal: {
        okText: "\u10D9\u10D0\u10E0\u10D2\u10D8",
        cancelText: "\u10D2\u10D0\u10E3\u10E5\u10DB\u10D4\u10D1\u10D0",
        justOkText: "\u10DD\u10D9"
    },
    Popconfirm: {
        okText: "\u10D9\u10D0\u10E0\u10D2\u10D8",
        cancelText: "\u10D2\u10D0\u10E3\u10E5\u10DB\u10D4\u10D1\u10D0"
    },
    Transfer: {
        titles: [
            "",
            ""
        ],
        searchPlaceholder: "\u10DB\u10DD\u10EB\u10D4\u10D1\u10DC\u10D4 \u10D0\u10E5",
        itemUnit: "\u10D4\u10E0\u10D7\u10D4\u10E3\u10DA\u10D8",
        itemsUnit: "\u10D4\u10E0\u10D7\u10D4\u10E3\u10DA\u10D4\u10D1\u10D8",
        remove: "\u10D0\u10DB\u10DD\u10E8\u10DA\u10D0",
        selectCurrent: "\u10DB\u10D8\u10DB\u10D3\u10D8\u10DC\u10D0\u10E0\u10D4 \u10D2\u10D5\u10D4\u10E0\u10D3\u10D8\u10E1 \u10D0\u10E0\u10E9\u10D4\u10D5\u10D0",
        removeCurrent: "\u10DB\u10D8\u10DB\u10D3\u10D8\u10DC\u10D0\u10E0\u10D4 \u10D2\u10D5\u10D4\u10E0\u10D3\u10D8\u10E1 \u10D0\u10DB\u10DD\u10E8\u10DA\u10D0",
        selectAll: "\u10E7\u10D5\u10D4\u10DA\u10D0\u10E1 \u10DB\u10DD\u10DC\u10D8\u10E8\u10D5\u10DC\u10D0",
        removeAll: "\u10E7\u10D5\u10D4\u10DA\u10D0\u10E1 \u10EC\u10D0\u10E8\u10DA\u10D0",
        selectInvert: "\u10DB\u10D8\u10DB\u10D3\u10D8\u10DC\u10D0\u10E0\u10D4 \u10D2\u10D5\u10D4\u10E0\u10D3\u10D8\u10E1 \u10E8\u10D4\u10D1\u10E0\u10E3\u10DC\u10D4\u10D1\u10D0",
        deselectAll: "\u10D2\u10D0\u10D0\u10E3\u10E5\u10DB\u10D4\u10D7 \u10E7\u10D5\u10D4\u10DA\u10D0 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D8"
    },
    Upload: {
        uploading: "\u10D8\u10E2\u10D5\u10D8\u10E0\u10D7\u10D4\u10D1\u10D0...",
        removeFile: "\u10E4\u10D0\u10D8\u10DA\u10D8\u10E1 \u10D0\u10DB\u10DD\u10E8\u10DA\u10D0",
        uploadError: "\u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D8\u10E1 \u10E8\u10D4\u10EA\u10D3\u10DD\u10DB\u10D0",
        previewFile: "\u10E4\u10D0\u10D8\u10DA\u10D8\u10E1 \u10D2\u10D0\u10D3\u10D0\u10EE\u10D4\u10D3\u10D5\u10D0",
        downloadFile: "\u10E4\u10D0\u10D8\u10DA\u10D8\u10E1 \u10E9\u10D0\u10DB\u10DD\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D0"
    },
    Empty: {
        description: "\u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D0 \u10D0\u10E0\u10D0\u10D0"
    },
    Icon: {
        icon: "\u10EE\u10D0\u10E2\u10E3\u10DA\u10D0"
    },
    Text: {
        edit: "\u10E0\u10D4\u10D3\u10D0\u10E5\u10E2\u10D8\u10E0\u10D4\u10D1\u10D0",
        copy: "\u10D0\u10E1\u10DA\u10D8",
        copied: "\u10D0\u10E1\u10DA\u10D8 \u10D0\u10E6\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0",
        expand: "\u10D2\u10D0\u10E8\u10DA\u10D0",
        collapse: "\u10D9\u10DD\u10DA\u10D0\u10E4\u10E1\u10D8"
    },
    Form: {
        optional: "(\u10D0\u10E0\u10D0\u10E1\u10D0\u10D5\u10D0\u10DA\u10D3\u10D4\u10D1\u10E3\u10DA\u10DD)",
        defaultValidateMessages: {
            default: "\u10D5\u10D4\u10DA\u10D8\u10E1 \u10E8\u10D4\u10DB\u10DD\u10EC\u10DB\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10EA\u10D3\u10DD\u10DB\u10D0 ${label}-\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1",
            required: "\u10D2\u10D7\u10EE\u10DD\u10D5\u10D7 \u10E8\u10D4\u10D8\u10E7\u10D5\u10D0\u10DC\u10D4\u10D7 ${label}",
            enum: "${label} \u10E3\u10DC\u10D3\u10D0 \u10D8\u10E7\u10DD\u10E1 \u10D4\u10E0\u10D7-\u10D4\u10E0\u10D7\u10D8 [${enum}]-\u10D3\u10D0\u10DC",
            whitespace: "${label} \u10D0\u10E0 \u10E8\u10D4\u10D8\u10EB\u10DA\u10D4\u10D1\u10D0 \u10D8\u10E7\u10DD\u10E1 \u10EA\u10D0\u10E0\u10D8\u10D4\u10DA\u10D8 \u10E1\u10D8\u10DB\u10D1\u10DD\u10DA\u10DD",
            date: {
                format: "${label} \u10D7\u10D0\u10E0\u10D8\u10E6\u10D8\u10E1 \u10E4\u10DD\u10E0\u10DB\u10D0\u10E2\u10D8 \u10D0\u10E0\u10D0\u10E1\u10EC\u10DD\u10E0\u10D8\u10D0",
                parse: "${label} \u10D7\u10D0\u10E0\u10D8\u10E6\u10E8\u10D8 \u10D9\u10DD\u10DC\u10D5\u10D4\u10E0\u10E2\u10D8\u10E0\u10D4\u10D1\u10D0 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1 \u10E8\u10D4\u10E1\u10D0\u10EB\u10DA\u10D4\u10D1\u10D4\u10DA\u10D8",
                invalid: "${label} \u10D0\u10E0\u10D0\u10E1\u10EC\u10DD\u10E0\u10D8 \u10D7\u10D0\u10E0\u10D8\u10E6\u10D8\u10D0"
            },
            types: {
                string: $9eaeb6750148cf1f$var$typeTemplate,
                method: $9eaeb6750148cf1f$var$typeTemplate,
                array: $9eaeb6750148cf1f$var$typeTemplate,
                object: $9eaeb6750148cf1f$var$typeTemplate,
                number: $9eaeb6750148cf1f$var$typeTemplate,
                date: $9eaeb6750148cf1f$var$typeTemplate,
                boolean: $9eaeb6750148cf1f$var$typeTemplate,
                integer: $9eaeb6750148cf1f$var$typeTemplate,
                float: $9eaeb6750148cf1f$var$typeTemplate,
                regexp: $9eaeb6750148cf1f$var$typeTemplate,
                email: $9eaeb6750148cf1f$var$typeTemplate,
                url: $9eaeb6750148cf1f$var$typeTemplate,
                hex: $9eaeb6750148cf1f$var$typeTemplate
            },
            string: {
                len: "${label} \u10E3\u10DC\u10D3\u10D0 \u10D8\u10E7\u10DD\u10E1 ${len} \u10E1\u10D8\u10DB\u10D1\u10DD\u10DA\u10DD",
                min: "${label} \u10E3\u10DC\u10D3\u10D0 \u10D8\u10E7\u10DD\u10E1 \u10E1\u10E3\u10DA \u10DB\u10EA\u10D8\u10E0\u10D4 ${min} \u10E1\u10D8\u10DB\u10D1\u10DD\u10DA\u10DD",
                max: "${label} \u10E3\u10DC\u10D3\u10D0 \u10D8\u10E7\u10DD\u10E1 \u10DB\u10D0\u10E5\u10E1\u10D8\u10DB\u10E3\u10DB ${max} \u10E1\u10D8\u10DB\u10D1\u10DD\u10DA\u10DD",
                range: "${label} \u10E3\u10DC\u10D3\u10D0 \u10D8\u10E7\u10DD\u10E1 ${min}-${max} \u10E1\u10D8\u10DB\u10D1\u10DD\u10DA\u10DD\u10E1 \u10E8\u10DD\u10E0\u10D8\u10E1"
            },
            number: {
                len: "${label} \u10E3\u10DC\u10D3\u10D0 \u10D8\u10E7\u10DD\u10E1 ${len} \u10E2\u10DD\u10DA\u10D8",
                min: "${label} \u10E3\u10DC\u10D3\u10D0 \u10D8\u10E7\u10DD\u10E1 \u10DB\u10D8\u10DC\u10E3\u10DB\u10D8\u10DB ${min}",
                max: "${label} \u10E3\u10DC\u10D3\u10D0 \u10D8\u10E7\u10DD\u10E1 \u10DB\u10D0\u10E5\u10E1\u10D8\u10DB\u10E3\u10DB ${max}",
                range: "${label} \u10E3\u10DC\u10D3\u10D0 \u10D8\u10E7\u10DD\u10E1 ${min}-${max} \u10E8\u10DD\u10E0\u10D8\u10E1"
            },
            array: {
                len: "\u10E3\u10DC\u10D3\u10D0 \u10D8\u10E7\u10DD\u10E1 ${len} ${label}",
                min: "\u10E1\u10E3\u10DA \u10DB\u10EA\u10D8\u10E0\u10D4 ${min} ${label}",
                max: "\u10D0\u10E0\u10D0\u10E3\u10DB\u10D4\u10E2\u10D4\u10E1 ${max} ${label}",
                range: "${label}-\u10D8\u10E1 \u10E0\u10D0\u10DD\u10D3\u10D4\u10DC\u10DD\u10D1\u10D0 \u10E3\u10DC\u10D3\u10D0 \u10D8\u10E7\u10DD\u10E1 ${min}-${max} \u10E8\u10DD\u10E0\u10D8\u10E1"
            },
            pattern: {
                mismatch: "${label} \u10D0\u10E0 \u10D4\u10E0\u10D2\u10D4\u10D1\u10D0 \u10E8\u10D0\u10D1\u10DA\u10DD\u10DC\u10E1 ${pattern}"
            }
        }
    },
    QRCode: {
        expired: "QR \u10D9\u10DD\u10D3\u10E1 \u10D5\u10D0\u10D3\u10D0 \u10D2\u10D0\u10E3\u10D5\u10D8\u10D3\u10D0",
        refresh: "\u10D2\u10D0\u10DC\u10D0\u10D0\u10EE\u10DA\u10D4\u10D7",
        scanned: "\u10D3\u10D0\u10E1\u10D9\u10D0\u10DC\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0"
    },
    ColorPicker: {
        presetEmpty: "\u10EA\u10D0\u10E0\u10D8\u10D4\u10DA\u10D8",
        transparent: "\u10D2\u10D0\u10DB\u10ED\u10D5\u10D8\u10E0\u10D5\u10D0\u10DA\u10D4",
        singleColor: "\u10D4\u10E0\u10D7\u10D8 \u10E4\u10D4\u10E0\u10D8",
        gradientColor: "\u10D2\u10E0\u10D0\u10D3\u10D8\u10D4\u10DC\u10E2\u10E3\u10E0\u10D8 \u10E4\u10D4\u10E0\u10D8"
    }
};
var $9eaeb6750148cf1f$export$2e2bcd8739ae039 = $9eaeb6750148cf1f$var$localeValues;


const $c068c7ecd02a8d45$var$locale = {
    // Options
    items_per_page: "/ \u0441\u0442\u043E\u0440\u0456\u043D\u0446\u0456",
    jump_to: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438",
    jump_to_confirm: "\u043F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438",
    page: "",
    // Pagination
    prev_page: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u044F \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0430",
    next_page: "\u041D\u0430\u0441\u0442\u0443\u043F\u043D\u0430 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0430",
    prev_5: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u0456 5 \u0441\u0442\u043E\u0440\u0456\u043D\u043E\u043A",
    next_5: "\u041D\u0430\u0441\u0442\u0443\u043F\u043D\u0456 5 \u0441\u0442\u043E\u0440\u0456\u043D\u043E\u043A",
    prev_3: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u0456 3 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438",
    next_3: "\u041D\u0430\u0441\u0442\u0443\u043F\u043D\u0456 3 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438",
    page_size: "Page Size"
};
var $c068c7ecd02a8d45$export$2e2bcd8739ae039 = $c068c7ecd02a8d45$var$locale;



const $b51703a7ec2f7ac6$var$locale = {
    ...(0, $468f660b5a11d829$export$bdd78c3fd9633c1e),
    locale: "uk_UA",
    today: "\u0421\u044C\u043E\u0433\u043E\u0434\u043D\u0456",
    now: "\u0417\u0430\u0440\u0430\u0437",
    backToToday: "\u041F\u043E\u0442\u043E\u0447\u043D\u0430 \u0434\u0430\u0442\u0430",
    ok: "OK",
    clear: "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u0438",
    week: "\u0422\u0438\u0436\u0434\u0435\u043D\u044C",
    month: "\u041C\u0456\u0441\u044F\u0446\u044C",
    year: "\u0420\u0456\u043A",
    timeSelect: "\u041E\u0431\u0440\u0430\u0442\u0438 \u0447\u0430\u0441",
    dateSelect: "\u041E\u0431\u0440\u0430\u0442\u0438 \u0434\u0430\u0442\u0443",
    monthSelect: "\u041E\u0431\u0440\u0430\u0442\u0438 \u043C\u0456\u0441\u044F\u0446\u044C",
    yearSelect: "\u041E\u0431\u0440\u0430\u0442\u0438 \u0440\u0456\u043A",
    decadeSelect: "\u041E\u0431\u0440\u0430\u0442\u0438 \u0434\u0435\u0441\u044F\u0442\u0438\u0440\u0456\u0447\u0447\u044F",
    previousMonth: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u0456\u0439 \u043C\u0456\u0441\u044F\u0446\u044C",
    nextMonth: "\u041D\u0430\u0441\u0442\u0443\u043F\u043D\u0438\u0439 \u043C\u0456\u0441\u044F\u0446\u044C",
    previousYear: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u0456\u0439 \u0440\u0456\u043A",
    nextYear: "\u041D\u0430\u0441\u0442\u0443\u043F\u043D\u0438\u0439 \u0440\u0456\u043A",
    previousDecade: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u0454 \u0434\u0435\u0441\u044F\u0442\u0438\u0440\u0456\u0447\u0447\u044F",
    nextDecade: "\u041D\u0430\u0441\u0442\u0443\u043F\u043D\u0435 \u0434\u0435\u0441\u044F\u0442\u0438\u0440\u0456\u0447\u0447\u044F",
    previousCentury: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u0454 \u0441\u0442\u043E\u043B\u0456\u0442\u0442\u044F",
    nextCentury: "\u041D\u0430\u0441\u0442\u0443\u043F\u043D\u0435 \u0441\u0442\u043E\u043B\u0456\u0442\u0442\u044F"
};
var $b51703a7ec2f7ac6$export$2e2bcd8739ae039 = $b51703a7ec2f7ac6$var$locale;


const $d80c25514b36ac74$var$locale = {
    placeholder: "\u041E\u0431\u0435\u0440\u0456\u0442\u044C \u0447\u0430\u0441",
    rangePlaceholder: [
        "\u041F\u043E\u0447\u0430\u0442\u043A\u043E\u0432\u0438\u0439 \u0447\u0430\u0441",
        "\u041A\u0456\u043D\u0446\u0435\u0432\u0438\u0439 \u0447\u0430\u0441"
    ]
};
var $d80c25514b36ac74$export$2e2bcd8739ae039 = $d80c25514b36ac74$var$locale;


// Merge into a locale object
const $6e62ffedc9c9f317$var$locale = {
    lang: {
        placeholder: "\u041E\u0431\u0435\u0440\u0456\u0442\u044C \u0434\u0430\u0442\u0443",
        yearPlaceholder: "\u041E\u0431\u0435\u0440\u0456\u0442\u044C \u0440\u0456\u043A",
        quarterPlaceholder: "\u041E\u0431\u0435\u0440\u0456\u0442\u044C \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        monthPlaceholder: "\u041E\u0431\u0435\u0440\u0456\u0442\u044C \u043C\u0456\u0441\u044F\u0446\u044C",
        weekPlaceholder: "\u041E\u0431\u0435\u0440\u0456\u0442\u044C \u0442\u0438\u0436\u0434\u0435\u043D\u044C",
        rangePlaceholder: [
            "\u041F\u043E\u0447\u0430\u0442\u043A\u043E\u0432\u0430 \u0434\u0430\u0442\u0430",
            "\u041A\u0456\u043D\u0446\u0435\u0432\u0430 \u0434\u0430\u0442\u0430"
        ],
        rangeYearPlaceholder: [
            "\u041F\u043E\u0447\u0430\u0442\u043A\u043E\u0432\u0438\u0439 \u0440\u0456\u043A",
            "\u041A\u0456\u043D\u0446\u0435\u0432\u0438\u0439 \u0440\u0456\u043A"
        ],
        rangeMonthPlaceholder: [
            "\u041F\u043E\u0447\u0430\u0442\u043A\u043E\u0432\u0438\u0439 \u043C\u0456\u0441\u044F\u0446\u044C",
            "\u041A\u0456\u043D\u0446\u0435\u0432\u0438\u0439 \u043C\u0456\u0441\u044F\u0446\u044C"
        ],
        rangeWeekPlaceholder: [
            "\u041F\u043E\u0447\u0430\u0442\u043A\u043E\u0432\u0438\u0439 \u0442\u0438\u0436\u0434\u0435\u043D\u044C",
            "\u041A\u0456\u043D\u0446\u0435\u0432\u0438\u0439 \u0442\u0438\u0436\u0434\u0435\u043D\u044C"
        ],
        shortWeekDays: [
            "\u041D\u0434",
            "\u041F\u043D",
            "\u0412\u0442",
            "\u0421\u0440",
            "\u0427\u0442",
            "\u041F\u0442",
            "\u0421\u0431"
        ],
        shortMonths: [
            "\u0421\u0456\u0447",
            "\u041B\u044E\u0442",
            "\u0411\u0435\u0440",
            "\u041A\u0432\u0456",
            "\u0422\u0440\u0430",
            "\u0427\u0435\u0440",
            "\u041B\u0438\u043F",
            "\u0421\u0435\u0440",
            "\u0412\u0435\u0440",
            "\u0416\u043E\u0432",
            "\u041B\u0438\u0441",
            "\u0413\u0440\u0443"
        ],
        ...(0, $b51703a7ec2f7ac6$export$2e2bcd8739ae039)
    },
    timePickerLocale: {
        ...(0, $d80c25514b36ac74$export$2e2bcd8739ae039)
    }
};
var // All settings at:
// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json
$6e62ffedc9c9f317$export$2e2bcd8739ae039 = $6e62ffedc9c9f317$var$locale;


var $ebb39b42d971a9e8$export$2e2bcd8739ae039 = (0, $6e62ffedc9c9f317$export$2e2bcd8739ae039);




const $ea9ab936e9625e9a$var$typeTemplate = "${label} \u043D\u0435 \u0454 \u0442\u0438\u043F\u043E\u043C ${type}";
const $ea9ab936e9625e9a$var$localeValues = {
    locale: "uk",
    Pagination: $c068c7ecd02a8d45$export$2e2bcd8739ae039,
    DatePicker: $6e62ffedc9c9f317$export$2e2bcd8739ae039,
    TimePicker: $d80c25514b36ac74$export$2e2bcd8739ae039,
    Calendar: $ebb39b42d971a9e8$export$2e2bcd8739ae039,
    global: {
        placeholder: "\u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u043E\u0431\u0435\u0440\u0456\u0442\u044C",
        close: "\u0417\u0430\u043A\u0440\u0438\u0442\u0438",
        show: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438",
        hide: "\u041F\u0440\u0438\u0445\u043E\u0432\u0430\u0442\u0438",
        sortable: "\u0441\u043E\u0440\u0442\u0443\u0432\u0430\u043B\u044C\u043D\u0438\u0439"
    },
    Table: {
        filterTitle: "\u0424\u0456\u043B\u044C\u0442\u0440\u0443\u0432\u0430\u0442\u0438",
        filterConfirm: "OK",
        filterReset: "\u0421\u043A\u0438\u043D\u0443\u0442\u0438",
        filterEmptyText: "\u0424\u0456\u043B\u044C\u0442\u0440\u0438 \u0432\u0456\u0434\u0441\u0443\u0442\u043D\u0456",
        filterCheckAll: "\u041E\u0431\u0440\u0430\u0442\u0438 \u0432\u0441\u0456",
        filterSearchPlaceholder: "\u041F\u043E\u0448\u0443\u043A \u0443 \u0444\u0456\u043B\u044C\u0442\u0440\u0430\u0445",
        emptyText: "\u0414\u0430\u043D\u0438\u0445 \u043D\u0435\u043C\u0430\u0454",
        selectAll: "\u041E\u0431\u0440\u0430\u0442\u0438 \u0432\u0441\u0456 \u043D\u0430 \u0441\u0442\u043E\u0440\u0456\u043D\u0446\u0456",
        selectInvert: "\u0406\u043D\u0432\u0435\u0440\u0442\u0443\u0432\u0430\u0442\u0438 \u0432\u0438\u0431\u0456\u0440",
        selectNone: "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u0438 \u0432\u0438\u0431\u0456\u0440",
        selectionAll: "\u041E\u0431\u0440\u0430\u0442\u0438 \u0432\u0441\u0456",
        sortTitle: "\u0421\u043E\u0440\u0442\u0443\u0432\u0430\u0442\u0438",
        expand: "\u0420\u043E\u0437\u0433\u043E\u0440\u043D\u0443\u0442\u0438 \u0440\u044F\u0434\u043E\u043A",
        collapse: "\u0417\u0433\u043E\u0440\u043D\u0443\u0442\u0438 \u0440\u044F\u0434\u043E\u043A",
        triggerDesc: "\u0421\u043E\u0440\u0442\u0443\u0432\u0430\u0442\u0438 \u0437\u0430 \u0441\u043F\u0430\u0434\u0430\u043D\u043D\u044F\u043C",
        triggerAsc: "\u0421\u043E\u0440\u0442\u0443\u0432\u0430\u0442\u0438 \u0437\u0430 \u0437\u0440\u043E\u0441\u0442\u0430\u043D\u043D\u044F\u043C",
        cancelSort: "\u0412\u0456\u0434\u043C\u0456\u043D\u0438\u0442\u0438 \u0441\u043E\u0440\u0442\u0443\u0432\u0430\u043D\u043D\u044F"
    },
    Tour: {
        Next: "\u0414\u0430\u043B\u0456",
        Previous: "\u041D\u0430\u0437\u0430\u0434",
        Finish: "\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u0438"
    },
    Modal: {
        okText: "\u0413\u0430\u0440\u0430\u0437\u0434",
        cancelText: "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438",
        justOkText: "\u0413\u0430\u0440\u0430\u0437\u0434"
    },
    Popconfirm: {
        okText: "\u0413\u0430\u0440\u0430\u0437\u0434",
        cancelText: "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438"
    },
    Transfer: {
        titles: [
            "",
            ""
        ],
        searchPlaceholder: "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u0442\u0435\u043A\u0441\u0442 \u0434\u043B\u044F \u043F\u043E\u0448\u0443\u043A\u0443",
        itemUnit: "\u0435\u043B\u0435\u043C.",
        itemsUnit: "\u0435\u043B\u0435\u043C.",
        remove: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438",
        selectCurrent: "\u0412\u0438\u0431\u0440\u0430\u0442\u0438 \u043F\u043E\u0442\u043E\u0447\u043D\u0443 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443",
        removeCurrent: "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438 \u0432\u0438\u0431\u0456\u0440 \u043D\u0430 \u0441\u0442\u043E\u0440\u0456\u043D\u0446\u0456",
        selectAll: "\u0412\u0438\u0431\u0440\u0430\u0442\u0438 \u0432\u0441\u0456 \u0434\u0430\u043D\u0456",
        deselectAll: "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u0438 \u0432\u0438\u0431\u0456\u0440",
        removeAll: "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438 \u0432\u0438\u0431\u0456\u0440",
        selectInvert: "\u0406\u043D\u0432\u0435\u0440\u0442\u0443\u0432\u0430\u0442\u0438 \u043F\u043E\u0442\u043E\u0447\u043D\u0443 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443"
    },
    Upload: {
        uploading: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F ...",
        removeFile: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0444\u0430\u0439\u043B",
        uploadError: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F",
        previewFile: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u0456\u0439 \u043F\u0435\u0440\u0435\u0433\u043B\u044F\u0434 \u0444\u0430\u0439\u043B\u0443",
        downloadFile: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0444\u0430\u0439\u043B"
    },
    Empty: {
        description: "\u0414\u0430\u043D\u0438\u0445 \u043D\u0435\u043C\u0430\u0454"
    },
    Icon: {
        icon: "\u0456\u043A\u043E\u043D\u043A\u0430"
    },
    Text: {
        edit: "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438",
        copy: "\u0421\u043A\u043E\u043F\u0456\u044E\u0432\u0430\u0442\u0438",
        copied: "\u0421\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u043E",
        expand: "\u0420\u043E\u0437\u0448\u0438\u0440\u0438\u0442\u0438",
        collapse: "\u0417\u0433\u043E\u0440\u043D\u0443\u0442\u0438"
    },
    Form: {
        optional: "(\u043E\u043F\u0446\u0456\u043E\u043D\u0430\u043B\u044C\u043D\u043E)",
        defaultValidateMessages: {
            default: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0432\u0430\u043B\u0456\u0434\u0430\u0446\u0456\u0457 \u0434\u043B\u044F \u043F\u043E\u043B\u044F ${label}",
            required: "\u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u0437\u0430\u043F\u043E\u0432\u043D\u0456\u0442\u044C ${label}",
            enum: "\u041B\u0438\u0448\u0435 \u043E\u0434\u043D\u0435 \u0437\u0456 \u0437\u043D\u0430\u0447\u0435\u043D\u044C [${enum}] \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0435 \u0434\u043B\u044F ${label}",
            whitespace: "\u0417\u043D\u0430\u0447\u0435\u043D\u043D\u044F \u0443 \u043F\u043E\u043B\u0456 ${label} \u043D\u0435 \u043C\u043E\u0436\u0435 \u0431\u0443\u0442\u0438 \u043F\u0440\u043E\u0431\u0456\u043B\u043E\u043C",
            date: {
                format: "\u041D\u0435 \u0432\u0430\u043B\u0456\u0434\u043D\u0438\u0439 \u0444\u043E\u0440\u043C\u0430\u0442 \u0434\u0430\u0442\u0438 \u0443 ${label}",
                parse: "\u0417\u043D\u0430\u0447\u0435\u043D\u043D\u044F ${label} \u043D\u0435 \u043C\u043E\u0436\u0435 \u0431\u0443\u0442\u0438 \u043F\u0440\u0438\u0432\u0435\u0434\u0435\u043D\u0435 \u0434\u043E \u0434\u0430\u0442\u0438",
                invalid: "\u041D\u0435 \u0432\u0430\u043B\u0456\u0434\u043D\u0430 \u0434\u0430\u0442\u0430 \u0443 ${label}"
            },
            types: {
                string: $ea9ab936e9625e9a$var$typeTemplate,
                method: $ea9ab936e9625e9a$var$typeTemplate,
                array: $ea9ab936e9625e9a$var$typeTemplate,
                object: $ea9ab936e9625e9a$var$typeTemplate,
                number: $ea9ab936e9625e9a$var$typeTemplate,
                date: $ea9ab936e9625e9a$var$typeTemplate,
                boolean: $ea9ab936e9625e9a$var$typeTemplate,
                integer: $ea9ab936e9625e9a$var$typeTemplate,
                float: $ea9ab936e9625e9a$var$typeTemplate,
                regexp: $ea9ab936e9625e9a$var$typeTemplate,
                email: $ea9ab936e9625e9a$var$typeTemplate,
                url: $ea9ab936e9625e9a$var$typeTemplate,
                hex: $ea9ab936e9625e9a$var$typeTemplate
            },
            string: {
                len: "${label} \u043C\u0430\u0454 \u043C\u0456\u0441\u0442\u0438\u0442\u0438 ${len} \u0441\u0438\u043C\u0432\u043E\u043B\u0456\u0432",
                min: "${label} \u043C\u0430\u0454 \u043C\u0456\u0441\u0442\u0438\u0442\u0438 \u043D\u0435 \u043C\u0435\u043D\u0448, \u043D\u0456\u0436 ${min} \u0441\u0438\u043C\u0432\u043E\u043B\u0456\u0432",
                max: "${label} \u043C\u0430\u0454 \u043C\u0456\u0441\u0442\u0438\u0442\u0438 \u043D\u0435 \u0431\u0456\u043B\u044C\u0448, \u043D\u0456\u0436 ${max} \u0441\u0438\u043C\u0432\u043E\u043B\u0456\u0432",
                range: "${label} \u043C\u0430\u0454 \u043C\u0456\u0441\u0442\u0438\u0442\u0438 ${min}-${max} \u0441\u0438\u043C\u0432\u043E\u043B\u0456\u0432"
            },
            number: {
                len: "${label} \u043C\u0430\u0454 \u0434\u043E\u0440\u0456\u0432\u043D\u044E\u0432\u0430\u0442\u0438 ${len}",
                min: "${label} \u043C\u0430\u0454 \u0431\u0443\u0442\u0438 \u043D\u0435 \u043C\u0435\u043D\u0448, \u043D\u0456\u0436 ${min}",
                max: "${label} \u043C\u0430\u0454 \u0431\u0443\u0442\u0438 \u043D\u0435 \u0431\u0456\u043B\u044C\u0448, \u043D\u0456\u0436 ${max}",
                range: "${label} \u043C\u0430\u0454 \u0431\u0443\u0442\u0438 \u0432 \u043C\u0435\u0436\u0430\u0445 ${min}-${max}"
            },
            array: {
                len: "${label} \u043C\u0430\u0454 \u043C\u0456\u0441\u0442\u0438\u0442\u0438 ${len} \u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0438",
                min: "${label} \u043C\u0430\u0454 \u043C\u0456\u0441\u0442\u0438\u0442\u0438 \u043D\u0435 \u043C\u0435\u043D\u0448, \u043D\u0456\u0436 ${min} \u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0438",
                max: "${label} \u043C\u0430\u0454 \u043C\u0456\u0441\u0442\u0438\u0442\u0438 \u043D\u0435 \u0431\u0456\u043B\u044C\u0448, \u043D\u0456\u0436 ${max} \u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0438",
                range: "\u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C \u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0456\u0432 \u0432 ${label} \u043C\u0430\u0454 \u0431\u0443\u0442\u0438 \u0432 \u043C\u0435\u0436\u0430\u0445 ${min}-${max}"
            },
            pattern: {
                mismatch: "${label} \u043D\u0435 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0430\u0454 \u0448\u0430\u0431\u043B\u043E\u043D\u0443 ${pattern}"
            }
        }
    },
    QRCode: {
        expired: "QR-\u043A\u043E\u0434 \u0437\u0430\u043A\u0456\u043D\u0447\u0438\u0432\u0441\u044F",
        refresh: "\u041E\u043D\u043E\u0432\u0438\u0442\u0438",
        scanned: "\u0412\u0456\u0434\u0441\u043A\u0430\u043D\u043E\u0432\u0430\u043D\u0456"
    },
    ColorPicker: {
        presetEmpty: "\u041F\u043E\u0440\u043E\u0436\u043D\u0456\u0439",
        transparent: "\u041F\u0440\u043E\u0437\u043E\u0440\u0438\u0439",
        singleColor: "\u041E\u0434\u043D\u043E\u043A\u043E\u043B\u0456\u0440\u043D\u0438\u0439",
        gradientColor: "\u0413\u0440\u0430\u0434\u0456\u0454\u043D\u0442\u043D\u0438\u0439 \u043A\u043E\u043B\u0456\u0440"
    }
};
var $ea9ab936e9625e9a$export$2e2bcd8739ae039 = $ea9ab936e9625e9a$var$localeValues;


/**
 * antd ships its own strings — the password reveal label, Table/Pagination/DatePicker copy.
 * Without handing `ConfigProvider` the matching locale they stay English no matter what
 * `lang.js` says. All four locales exist upstream.
 */ const $d40125f317306d19$var$ANTD_LOCALES = {
    en: (0, $4ab0c7032ff9de6a$export$2e2bcd8739ae039),
    uk: (0, $ea9ab936e9625e9a$export$2e2bcd8739ae039),
    hy: (0, $bddbe90ebe740c11$export$2e2bcd8739ae039),
    ka: (0, $9eaeb6750148cf1f$export$2e2bcd8739ae039)
};
const $d40125f317306d19$export$699e2fca28693f3d = (code)=>$d40125f317306d19$var$ANTD_LOCALES[code] || (0, $4ab0c7032ff9de6a$export$2e2bcd8739ae039);
const $d40125f317306d19$export$ea009db4dcb4845b = {
    token: {
        colorPrimary: "#0077A8",
        colorLink: "#0077A8",
        colorError: "#BA1A1A",
        colorSuccess: "#1E8E3E",
        colorWarning: "#B26A00",
        colorTextBase: "#171C20",
        colorBorder: "#BFC8D0",
        /* Dividers, table row rules, menu separators. antd's default is rgba(5,5,5,.06), a warm grey
       that sits visibly off the blue-grey borders the rest of the design uses. */ colorSplit: "#DAE2E9",
        colorBgLayout: "#F4F8FC",
        /* Every hoverable row in the design lands on --surface-subtle — menu items, select options,
       table rows, quiet buttons. antd's defaults are translucent neutral washes
       (rgba(23,28,32,.04) / .06), which read grey-warm against our blue-grey surfaces and made
       a dropdown row hover differently from the control that opened it. */ controlItemBgHover: "#F4F8FC",
        /* Hovering a row that is ALREADY selected is its own antd state, derived from colorPrimary —
       a saturated #8CCEDB that turned the picked option in a dropdown into a solid blue bar. The
       design marks selection with colour, weight and a tick; the hover stays just the hover. */ controlItemBgActiveHover: "#F4F8FC",
        colorBgTextHover: "#F4F8FC",
        colorBgTextActive: "#EAF0F5",
        borderRadius: 8,
        // antd derives borderRadiusLG as borderRadius + 2, which puts large controls on 10px.
        // The design has one control radius, so pin it back to --radius-md.
        borderRadiusLG: 8,
        /* --radius-sm, the spec's radius for "tags, chips, small inputs". antd derives 4px, which
       reads square next to the 8px fields the chips sit inside. */ borderRadiusSM: 6,
        /* Denser than antd's own 32 default was the redesign's first pass at 40, but 40 read
       magnified across the app; 36 is the density this dashboard runs at. Still ≥ WCAG 2.5.8's
       24px target-size minimum. Mirror in docs/design/tokens.css + spec/01-foundations.md. */ controlHeight: 36,
        controlHeightLG: 44,
        controlHeightSM: 32,
        fontFamily: "'Noto Sans','Noto Sans Armenian','Noto Sans Georgian',system-ui,-apple-system,'Segoe UI',Roboto,sans-serif",
        fontSize: 14
    },
    components: {
        /* Input carries NO paddingInline override. It used to be 16 (--space-4), but the mockups put
       every control on the same 11px inset — `.ctl { padding: 0 11px }`, `.combo__ctl` and
       `.rp__ctl` likewise — and Select/DatePicker have no matching token, so a text field sat 5px
       further in than the select beside it in the same filter row. antd's default is 11. */ /* A default antd button hovers by painting its border AND label primary-5 (#1D8CB5). The
       design's is a grey wash with the border and label unchanged (`.btn:hover` in the mockups),
       and blue-on-hover also reads as "this is the primary action", which a default button is
       not. Fixed here rather than per-component: the app-bar language trigger is where it was
       first noticed, but every default Button in the app had it. */ /* The sidebar is an antd DARK Menu, whose hover background is its own token and defaults to
       transparent — so `.shell-nav.ant-menu .ant-menu-item:hover` (four classes) lost to
       `.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item:not(.ant-menu-item-selected):hover`
       (six) and nav rows answered the pointer with a text-colour change only. The design's is
       `rgba(255,255,255,.07)`. */ Menu: {
            darkItemHoverBg: "rgba(255,255,255,0.07)"
        },
        /* The range panel is 656px wide in the mockups and 875px in stock antd — a 48×44 cell grid
       against the design's 34×30. See `src/component/PeriodPicker.js`. */ /* The trailing caret and the clear button. antd's `fontSizeIcon` is 12 and drives the glyph's
       width, height AND its centring margin — so it cannot be fixed with CSS `font-size` alone.
       The mockups draw both at 18, the same size as the leading glyph on the same row
       (`.combo__caret .ms`, `.rp__clear .ms`, `.combo__clear .ms`); at 12 they read as a second,
       smaller control kit. Scoped per component rather than set globally, which would also grow
       every Modal close, Tag close and table filter icon in the app. */ DatePicker: {
            fontSizeIcon: 18,
            cellHeight: 30,
            cellWidth: 32,
            textHeight: 34,
            presetsWidth: 158,
            presetsMaxWidth: 158,
            cellActiveWithRangeBg: "#E6F7FE",
            cellHoverBg: "#F4F8FC"
        },
        /* The entity dropdown — `src/component/EntitySelect.js`, the mockups' `.combo`. A selected row
       there is marked by colour, weight and a tick, NOT by a filled bar, so the hover wash stays
       the only background in the list and "hovered" never reads as "chosen". */ Select: {
            fontSizeIcon: 18,
            multipleItemBg: "#EAF0F5",
            multipleItemBorderColor: "transparent",
            optionSelectedBg: "transparent",
            optionSelectedColor: "#0077A8",
            optionSelectedFontWeight: 600,
            optionActiveBg: "#F4F8FC",
            optionHeight: 34,
            optionPadding: "8px 12px"
        },
        Button: {
            defaultHoverBg: "#F4F8FC",
            defaultHoverColor: "#171C20",
            defaultHoverBorderColor: "#BFC8D0",
            defaultActiveBg: "#EAF0F5",
            defaultActiveColor: "#171C20",
            defaultActiveBorderColor: "#BFC8D0",
            /* The mockups' `.btn` is a 500-weight label; antd's is 400, which read visibly lighter than
         the design next to the same 14px body text. `.btn--primary` is 600 — one token cannot
         express both, so the primary's weight is the one CSS rule in `antd.scss`. */ fontWeight: 500,
            /* `.btn` carries no shadow and `.btn--primary` carries --shadow-brand. antd's defaults are
         a 1px `0 2px 0` ledge under every button, which reads as a Bootstrap-era press effect. */ defaultShadow: "none",
            dangerShadow: "none",
            primaryShadow: "0 4px 12px rgba(0, 119, 168, 0.28)",
            // `.btn` is `0 14px`, `.btn--sm` is `0 11px`; antd ships 15 and 7.
            paddingInline: 14,
            paddingInlineSM: 11
        }
    }
};
var $d40125f317306d19$export$2e2bcd8739ae039 = $d40125f317306d19$export$ea009db4dcb4845b;




var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");
var $0b0fee1684a66c6f$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($0b0fee1684a66c6f$exports, "__esModule", {
    value: true
});
var $0b0fee1684a66c6f$var$LeftOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z"
                }
            }
        ]
    },
    "name": "left",
    "theme": "outlined"
};
$0b0fee1684a66c6f$exports.default = $0b0fee1684a66c6f$var$LeftOutlined;



function $0f3c6d60b091c877$var$_extends() {
    $0f3c6d60b091c877$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0f3c6d60b091c877$var$_extends.apply(this, arguments);
}
const $0f3c6d60b091c877$var$LeftOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $0f3c6d60b091c877$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($0b0fee1684a66c6f$exports)))
    }));
/**![left](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTcyNCAyMTguM1YxNDFjMC02LjctNy43LTEwLjQtMTIuOS02LjNMMjYwLjMgNDg2LjhhMzEuODYgMzEuODYgMCAwMDAgNTAuM2w0NTAuOCAzNTIuMWM1LjMgNC4xIDEyLjkuNCAxMi45LTYuM3YtNzcuM2MwLTQuOS0yLjMtOS42LTYuMS0xMi42bC0zNjAtMjgxIDM2MC0yODEuMWMzLjgtMyA2LjEtNy43IDYuMS0xMi42eiIgLz48L3N2Zz4=) */ const $0f3c6d60b091c877$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($0f3c6d60b091c877$var$LeftOutlined);
var $0f3c6d60b091c877$export$2e2bcd8739ae039 = $0f3c6d60b091c877$var$RefIcon;







var $cQmXV = parcelRequire("cQmXV");


var $cQmXV = parcelRequire("cQmXV");
const { ESC: $2489fdc0dd85e845$var$ESC, TAB: $2489fdc0dd85e845$var$TAB } = (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039);
function $2489fdc0dd85e845$export$2e2bcd8739ae039({ visible: visible, triggerRef: triggerRef, onVisibleChange: onVisibleChange, autoFocus: autoFocus, overlayRef: overlayRef }) {
    const focusMenuRef = $cQmXV.useRef(false);
    const handleCloseMenuAndReturnFocus = ()=>{
        if (visible) {
            triggerRef.current?.focus?.();
            onVisibleChange?.(false);
        }
    };
    const focusMenu = ()=>{
        if (overlayRef.current?.focus) {
            overlayRef.current.focus();
            focusMenuRef.current = true;
            return true;
        }
        return false;
    };
    const handleKeyDown = (event)=>{
        switch(event.keyCode){
            case $2489fdc0dd85e845$var$ESC:
                handleCloseMenuAndReturnFocus();
                break;
            case $2489fdc0dd85e845$var$TAB:
                {
                    let focusResult = false;
                    if (!focusMenuRef.current) focusResult = focusMenu();
                    if (focusResult) event.preventDefault();
                    else handleCloseMenuAndReturnFocus();
                    break;
                }
        }
    };
    $cQmXV.useEffect(()=>{
        if (visible) {
            window.addEventListener("keydown", handleKeyDown);
            if (autoFocus) // FIXME: hack with raf
            (0, $905c53b807de704e$export$2e2bcd8739ae039)(focusMenu, 3);
            return ()=>{
                window.removeEventListener("keydown", handleKeyDown);
                focusMenuRef.current = false;
            };
        }
        return ()=>{
            focusMenuRef.current = false;
        };
    }, [
        visible
    ]); // eslint-disable-line react-hooks/exhaustive-deps
}




var $cQmXV = parcelRequire("cQmXV");
const $600df161ac2e0114$var$Overlay = /*#__PURE__*/ (0, $cQmXV.forwardRef)((props, ref)=>{
    const { overlay: overlay, arrow: arrow, prefixCls: prefixCls } = props;
    const overlayNode = (0, $cQmXV.useMemo)(()=>{
        let overlayElement;
        if (typeof overlay === "function") overlayElement = overlay();
        else overlayElement = overlay;
        return overlayElement;
    }, [
        overlay
    ]);
    const composedRef = (0, $10341b937b26f69d$export$ab452c34e8e05029)(ref, (0, $10341b937b26f69d$export$7465e5c0bf44f19a)(overlayNode));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Fragment, null, arrow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
        className: `${prefixCls}-arrow`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).cloneElement(overlayNode, {
        ref: (0, $10341b937b26f69d$export$c1cec34af06bcf7)(overlayNode) ? composedRef : undefined
    }));
});
var $600df161ac2e0114$export$2e2bcd8739ae039 = $600df161ac2e0114$var$Overlay;


const $707e4581a31b1e9a$var$autoAdjustOverflow = {
    adjustX: 1,
    adjustY: 1
};
const $707e4581a31b1e9a$var$targetOffset = [
    0,
    0
];
const $707e4581a31b1e9a$var$placements = {
    topLeft: {
        points: [
            "bl",
            "tl"
        ],
        overflow: $707e4581a31b1e9a$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $707e4581a31b1e9a$var$targetOffset
    },
    top: {
        points: [
            "bc",
            "tc"
        ],
        overflow: $707e4581a31b1e9a$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $707e4581a31b1e9a$var$targetOffset
    },
    topRight: {
        points: [
            "br",
            "tr"
        ],
        overflow: $707e4581a31b1e9a$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $707e4581a31b1e9a$var$targetOffset
    },
    bottomLeft: {
        points: [
            "tl",
            "bl"
        ],
        overflow: $707e4581a31b1e9a$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $707e4581a31b1e9a$var$targetOffset
    },
    bottom: {
        points: [
            "tc",
            "bc"
        ],
        overflow: $707e4581a31b1e9a$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $707e4581a31b1e9a$var$targetOffset
    },
    bottomRight: {
        points: [
            "tr",
            "br"
        ],
        overflow: $707e4581a31b1e9a$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $707e4581a31b1e9a$var$targetOffset
    }
};
var $707e4581a31b1e9a$export$2e2bcd8739ae039 = $707e4581a31b1e9a$var$placements;


function $ac0e466ba6112721$var$_extends() {
    $ac0e466ba6112721$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ac0e466ba6112721$var$_extends.apply(this, arguments);
}
const $ac0e466ba6112721$var$Dropdown = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).forwardRef((props, ref)=>{
    const { arrow: arrow = false, prefixCls: prefixCls = "rc-dropdown", transitionName: transitionName, animation: animation, align: align, placement: placement = "bottomLeft", placements: placements = (0, $707e4581a31b1e9a$export$2e2bcd8739ae039), getPopupContainer: getPopupContainer, showAction: showAction, hideAction: hideAction, overlayClassName: overlayClassName, overlayStyle: overlayStyle, visible: visible, trigger: trigger = [
        "hover"
    ], autoFocus: autoFocus, overlay: overlay, children: children, onVisibleChange: onVisibleChange, disabled: disabled, ...otherProps } = props;
    const [triggerVisible, setTriggerVisible] = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useState();
    const mergedVisible = "visible" in props ? visible : triggerVisible;
    const mergedMotionName = animation ? `${prefixCls}-${animation}` : transitionName;
    const triggerRef = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useRef(null);
    const overlayRef = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useRef(null);
    const childRef = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useImperativeHandle(ref, ()=>triggerRef.current);
    const handleVisibleChange = (newVisible)=>{
        setTriggerVisible(newVisible);
        onVisibleChange?.(newVisible);
    };
    (0, $2489fdc0dd85e845$export$2e2bcd8739ae039)({
        visible: mergedVisible,
        triggerRef: childRef,
        onVisibleChange: handleVisibleChange,
        autoFocus: autoFocus,
        overlayRef: overlayRef
    });
    const onClick = (e)=>{
        const { onOverlayClick: onOverlayClick } = props;
        setTriggerVisible(false);
        if (onOverlayClick) onOverlayClick(e);
    };
    const getMenuElement = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $600df161ac2e0114$export$2e2bcd8739ae039), {
            ref: overlayRef,
            overlay: overlay,
            prefixCls: prefixCls,
            arrow: arrow
        });
    const getMenuElementOrLambda = ()=>{
        if (typeof overlay === "function") return getMenuElement;
        return getMenuElement();
    };
    const getMinOverlayWidthMatchTrigger = ()=>{
        const { minOverlayWidthMatchTrigger: minOverlayWidthMatchTrigger, alignPoint: alignPoint } = props;
        if ("minOverlayWidthMatchTrigger" in props) return minOverlayWidthMatchTrigger;
        return !alignPoint;
    };
    const getOpenClassName = ()=>{
        const { openClassName: openClassName } = props;
        if (openClassName !== undefined) return openClassName;
        return `${prefixCls}-open`;
    };
    const elementChild = children;
    const childClassName = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(elementChild.props?.className, mergedVisible && getOpenClassName());
    const triggerChildProps = {
        className: childClassName,
        ref: (0, $10341b937b26f69d$export$ab452c34e8e05029)(childRef, (0, $10341b937b26f69d$export$7465e5c0bf44f19a)(elementChild))
    };
    const childrenNode = (0, $10341b937b26f69d$export$c1cec34af06bcf7)(elementChild) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).cloneElement(elementChild, triggerChildProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("span", {
        className: childClassName,
        ref: childRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).cloneElement(elementChild, {
        className: childClassName
    }));
    let triggerHideAction = hideAction;
    if (!triggerHideAction && trigger.indexOf("contextMenu") !== -1) triggerHideAction = [
        "click"
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $c77226a956f109d7$export$2e2bcd8739ae039), $ac0e466ba6112721$var$_extends({
        builtinPlacements: placements
    }, otherProps, {
        prefixCls: prefixCls,
        ref: triggerRef,
        popupClassName: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(overlayClassName, {
            [`${prefixCls}-show-arrow`]: arrow
        }),
        popupStyle: overlayStyle,
        action: trigger,
        showAction: showAction,
        hideAction: triggerHideAction,
        popupPlacement: placement,
        popupAlign: align,
        popupMotion: {
            motionName: mergedMotionName
        },
        popupVisible: mergedVisible,
        stretch: getMinOverlayWidthMatchTrigger() ? "minWidth" : "",
        popup: getMenuElementOrLambda(),
        onOpenChange: handleVisibleChange,
        onPopupClick: onClick,
        getPopupContainer: getPopupContainer
    }), childrenNode);
});
var $ac0e466ba6112721$export$2e2bcd8739ae039 = $ac0e466ba6112721$var$Dropdown;


var $2674fedb26eedb51$export$2e2bcd8739ae039 = (0, $ac0e466ba6112721$export$2e2bcd8739ae039);










function $e1e9e0ec17db0365$export$87e38ee403661ccc(token) {
    const { sizePopupArrow: sizePopupArrow, borderRadiusXS: borderRadiusXS, borderRadiusOuter: borderRadiusOuter } = token;
    const unitWidth = sizePopupArrow / 2;
    const ax = 0;
    const ay = unitWidth;
    const bx = borderRadiusOuter * 1 / Math.sqrt(2);
    const by = unitWidth - borderRadiusOuter * (1 - 1 / Math.sqrt(2));
    const cx = unitWidth - borderRadiusXS * (1 / Math.sqrt(2));
    const cy = borderRadiusOuter * (Math.sqrt(2) - 1) + borderRadiusXS * (1 / Math.sqrt(2));
    const dx = 2 * unitWidth - cx;
    const dy = cy;
    const ex = 2 * unitWidth - bx;
    const ey = by;
    const fx = 2 * unitWidth - ax;
    const fy = ay;
    const shadowWidth = unitWidth * Math.sqrt(2) + borderRadiusOuter * (Math.sqrt(2) - 2);
    const polygonOffset = borderRadiusOuter * (Math.sqrt(2) - 1);
    const arrowPolygon = `polygon(${polygonOffset}px 100%, 50% ${polygonOffset}px, ${2 * unitWidth - polygonOffset}px 100%, ${polygonOffset}px 100%)`;
    const arrowPath = `path('M ${ax} ${ay} A ${borderRadiusOuter} ${borderRadiusOuter} 0 0 0 ${bx} ${by} L ${cx} ${cy} A ${borderRadiusXS} ${borderRadiusXS} 0 0 1 ${dx} ${dy} L ${ex} ${ey} A ${borderRadiusOuter} ${borderRadiusOuter} 0 0 0 ${fx} ${fy} Z')`;
    return {
        arrowShadowWidth: shadowWidth,
        arrowPath: arrowPath,
        arrowPolygon: arrowPolygon
    };
}
const $e1e9e0ec17db0365$export$601fa0375eb80eec = (token, bgColor, boxShadow)=>{
    const { sizePopupArrow: sizePopupArrow, arrowPolygon: arrowPolygon, arrowPath: arrowPath, arrowShadowWidth: arrowShadowWidth, borderRadiusXS: borderRadiusXS, calc: calc } = token;
    const afterStyle = {
        content: '""',
        position: "absolute",
        width: arrowShadowWidth,
        height: arrowShadowWidth,
        bottom: 0,
        insetInline: 0,
        margin: "auto",
        borderRadius: {
            _skip_check_: true,
            value: `0 0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(borderRadiusXS)} 0`
        },
        transform: "translateY(50%) rotate(-135deg)",
        zIndex: 0,
        background: "transparent"
    };
    if (boxShadow) afterStyle.boxShadow = boxShadow;
    return {
        pointerEvents: "none",
        width: sizePopupArrow,
        height: sizePopupArrow,
        overflow: "hidden",
        "&::before": {
            position: "absolute",
            bottom: 0,
            insetInlineStart: 0,
            width: sizePopupArrow,
            height: calc(sizePopupArrow).div(2).equal(),
            background: bgColor,
            clipPath: {
                _multi_value_: true,
                value: [
                    arrowPolygon,
                    arrowPath
                ]
            },
            content: '""'
        },
        "&::after": afterStyle
    };
};


const $dc42b38f8ad9a4d1$export$de6e4ffc9ec3c089 = 8;
function $dc42b38f8ad9a4d1$export$bddc192327bb9823(options) {
    const { contentRadius: contentRadius, limitVerticalRadius: limitVerticalRadius } = options;
    const arrowOffset = contentRadius > 12 ? contentRadius + 2 : 12;
    const arrowOffsetVertical = limitVerticalRadius ? $dc42b38f8ad9a4d1$export$de6e4ffc9ec3c089 : arrowOffset;
    return {
        arrowOffsetHorizontal: arrowOffset,
        arrowOffsetVertical: arrowOffsetVertical
    };
}
const $dc42b38f8ad9a4d1$var$getArrowStyle = (token, colorBg, options)=>{
    const { componentCls: componentCls, boxShadowPopoverArrow: boxShadowPopoverArrow, arrowOffsetVertical: arrowOffsetVertical, arrowOffsetHorizontal: arrowOffsetHorizontal, antCls: antCls } = token;
    const [varName] = (0, $6870d4d7c14ae0bb$export$d82b8f66c5649e14)(antCls, "tooltip");
    const { arrowDistance: arrowDistance = 0, arrowShadow: arrowShadow = true } = options || {};
    return {
        [componentCls]: {
            // ============================ Basic ============================
            [`${componentCls}-arrow`]: [
                {
                    position: "absolute",
                    zIndex: 1,
                    // lift it up so the menu wouldn't cask shadow on it
                    display: "block",
                    ...(0, $e1e9e0ec17db0365$export$601fa0375eb80eec)(token, colorBg, arrowShadow ? boxShadowPopoverArrow : false),
                    "&:before": {
                        background: colorBg
                    }
                }
            ],
            // ========================== Placement ==========================
            // Here handle the arrow position and rotate stuff
            // >>>>> Top
            [[
                `&-placement-top > ${componentCls}-arrow`,
                `&-placement-topLeft > ${componentCls}-arrow`,
                `&-placement-topRight > ${componentCls}-arrow`
            ].join(",")]: {
                bottom: arrowDistance,
                transform: "translateY(100%) rotate(180deg)"
            },
            [`&-placement-top > ${componentCls}-arrow`]: {
                left: {
                    _skip_check_: true,
                    value: "50%"
                },
                transform: "translateX(-50%) translateY(100%) rotate(180deg)"
            },
            "&-placement-topLeft": {
                [varName("arrow-offset-x")]: arrowOffsetHorizontal,
                [`> ${componentCls}-arrow`]: {
                    left: {
                        _skip_check_: true,
                        value: arrowOffsetHorizontal
                    }
                }
            },
            "&-placement-topRight": {
                [varName("arrow-offset-x")]: `calc(100% - ${(0, $05f34ed03d41967d$export$523c0b569236b342)(arrowOffsetHorizontal)})`,
                [`> ${componentCls}-arrow`]: {
                    right: {
                        _skip_check_: true,
                        value: arrowOffsetHorizontal
                    }
                }
            },
            // >>>>> Bottom
            [[
                `&-placement-bottom > ${componentCls}-arrow`,
                `&-placement-bottomLeft > ${componentCls}-arrow`,
                `&-placement-bottomRight > ${componentCls}-arrow`
            ].join(",")]: {
                top: arrowDistance,
                transform: `translateY(-100%)`
            },
            [`&-placement-bottom > ${componentCls}-arrow`]: {
                left: {
                    _skip_check_: true,
                    value: "50%"
                },
                transform: `translateX(-50%) translateY(-100%)`
            },
            "&-placement-bottomLeft": {
                [varName("arrow-offset-x")]: arrowOffsetHorizontal,
                [`> ${componentCls}-arrow`]: {
                    left: {
                        _skip_check_: true,
                        value: arrowOffsetHorizontal
                    }
                }
            },
            "&-placement-bottomRight": {
                [varName("arrow-offset-x")]: `calc(100% - ${(0, $05f34ed03d41967d$export$523c0b569236b342)(arrowOffsetHorizontal)})`,
                [`> ${componentCls}-arrow`]: {
                    right: {
                        _skip_check_: true,
                        value: arrowOffsetHorizontal
                    }
                }
            },
            // >>>>> Left
            [[
                `&-placement-left > ${componentCls}-arrow`,
                `&-placement-leftTop > ${componentCls}-arrow`,
                `&-placement-leftBottom > ${componentCls}-arrow`
            ].join(",")]: {
                right: {
                    _skip_check_: true,
                    value: arrowDistance
                },
                transform: "translateX(100%) rotate(90deg)"
            },
            [`&-placement-left > ${componentCls}-arrow`]: {
                top: {
                    _skip_check_: true,
                    value: "50%"
                },
                transform: "translateY(-50%) translateX(100%) rotate(90deg)"
            },
            [`&-placement-leftTop > ${componentCls}-arrow`]: {
                top: arrowOffsetVertical
            },
            [`&-placement-leftBottom > ${componentCls}-arrow`]: {
                bottom: arrowOffsetVertical
            },
            // >>>>> Right
            [[
                `&-placement-right > ${componentCls}-arrow`,
                `&-placement-rightTop > ${componentCls}-arrow`,
                `&-placement-rightBottom > ${componentCls}-arrow`
            ].join(",")]: {
                left: {
                    _skip_check_: true,
                    value: arrowDistance
                },
                transform: "translateX(-100%) rotate(-90deg)"
            },
            [`&-placement-right > ${componentCls}-arrow`]: {
                top: {
                    _skip_check_: true,
                    value: "50%"
                },
                transform: "translateY(-50%) translateX(-100%) rotate(-90deg)"
            },
            [`&-placement-rightTop > ${componentCls}-arrow`]: {
                top: arrowOffsetVertical
            },
            [`&-placement-rightBottom > ${componentCls}-arrow`]: {
                bottom: arrowOffsetVertical
            }
        }
    };
};
var $dc42b38f8ad9a4d1$export$2e2bcd8739ae039 = $dc42b38f8ad9a4d1$var$getArrowStyle;



function $79d8965a045fdc17$export$fde75e5b410c093f(placement, arrowOffset, arrowWidth, autoAdjustOverflow) {
    if (autoAdjustOverflow === false) return {
        adjustX: false,
        adjustY: false
    };
    const overflow = (0, $8e2d153a3c855782$export$53b83ca8eaab0383)(autoAdjustOverflow) ? autoAdjustOverflow : {};
    const baseOverflow = {};
    switch(placement){
        case "top":
        case "bottom":
            baseOverflow.shiftX = arrowOffset.arrowOffsetHorizontal * 2 + arrowWidth;
            baseOverflow.shiftY = true;
            baseOverflow.adjustY = true;
            break;
        case "left":
        case "right":
            baseOverflow.shiftY = arrowOffset.arrowOffsetVertical * 2 + arrowWidth;
            baseOverflow.shiftX = true;
            baseOverflow.adjustX = true;
            break;
    }
    const mergedOverflow = {
        ...baseOverflow,
        ...overflow
    };
    // Support auto shift
    if (!mergedOverflow.shiftX) mergedOverflow.adjustX = true;
    if (!mergedOverflow.shiftY) mergedOverflow.adjustY = true;
    return mergedOverflow;
}
const $79d8965a045fdc17$var$PlacementAlignMap = {
    left: {
        points: [
            "cr",
            "cl"
        ]
    },
    right: {
        points: [
            "cl",
            "cr"
        ]
    },
    top: {
        points: [
            "bc",
            "tc"
        ]
    },
    bottom: {
        points: [
            "tc",
            "bc"
        ]
    },
    topLeft: {
        points: [
            "bl",
            "tl"
        ]
    },
    leftTop: {
        points: [
            "tr",
            "tl"
        ]
    },
    topRight: {
        points: [
            "br",
            "tr"
        ]
    },
    rightTop: {
        points: [
            "tl",
            "tr"
        ]
    },
    bottomRight: {
        points: [
            "tr",
            "br"
        ]
    },
    rightBottom: {
        points: [
            "bl",
            "br"
        ]
    },
    bottomLeft: {
        points: [
            "tl",
            "bl"
        ]
    },
    leftBottom: {
        points: [
            "br",
            "bl"
        ]
    }
};
const $79d8965a045fdc17$var$ArrowCenterPlacementAlignMap = {
    topLeft: {
        points: [
            "bl",
            "tc"
        ]
    },
    leftTop: {
        points: [
            "tr",
            "cl"
        ]
    },
    topRight: {
        points: [
            "br",
            "tc"
        ]
    },
    rightTop: {
        points: [
            "tl",
            "cr"
        ]
    },
    bottomRight: {
        points: [
            "tr",
            "bc"
        ]
    },
    rightBottom: {
        points: [
            "bl",
            "cr"
        ]
    },
    bottomLeft: {
        points: [
            "tl",
            "bc"
        ]
    },
    leftBottom: {
        points: [
            "br",
            "cl"
        ]
    }
};
const $79d8965a045fdc17$var$DisableAutoArrowList = new Set([
    "topLeft",
    "topRight",
    "bottomLeft",
    "bottomRight",
    "leftTop",
    "leftBottom",
    "rightTop",
    "rightBottom"
]);
function $79d8965a045fdc17$export$2e2bcd8739ae039(config) {
    const { arrowWidth: arrowWidth, autoAdjustOverflow: autoAdjustOverflow, arrowPointAtCenter: arrowPointAtCenter, offset: offset, borderRadius: borderRadius, visibleFirst: visibleFirst } = config;
    const halfArrowWidth = arrowWidth / 2;
    const placementMap = {};
    // Dynamic offset
    const arrowOffset = (0, $dc42b38f8ad9a4d1$export$bddc192327bb9823)({
        contentRadius: borderRadius,
        limitVerticalRadius: true
    });
    Object.keys($79d8965a045fdc17$var$PlacementAlignMap).forEach((key)=>{
        const template = arrowPointAtCenter && $79d8965a045fdc17$var$ArrowCenterPlacementAlignMap[key] || $79d8965a045fdc17$var$PlacementAlignMap[key];
        const placementInfo = {
            ...template,
            offset: [
                0,
                0
            ],
            dynamicInset: true
        };
        placementMap[key] = placementInfo;
        // Disable autoArrow since design is fixed position
        if ($79d8965a045fdc17$var$DisableAutoArrowList.has(key)) placementInfo.autoArrow = false;
        // Static offset
        switch(key){
            case "top":
            case "topLeft":
            case "topRight":
                placementInfo.offset[1] = -halfArrowWidth - offset;
                break;
            case "bottom":
            case "bottomLeft":
            case "bottomRight":
                placementInfo.offset[1] = halfArrowWidth + offset;
                break;
            case "left":
            case "leftTop":
            case "leftBottom":
                placementInfo.offset[0] = -halfArrowWidth - offset;
                break;
            case "right":
            case "rightTop":
            case "rightBottom":
                placementInfo.offset[0] = halfArrowWidth + offset;
                break;
        }
        if (arrowPointAtCenter) switch(key){
            case "topLeft":
            case "bottomLeft":
                placementInfo.offset[0] = -arrowOffset.arrowOffsetHorizontal - halfArrowWidth;
                break;
            case "topRight":
            case "bottomRight":
                placementInfo.offset[0] = arrowOffset.arrowOffsetHorizontal + halfArrowWidth;
                break;
            case "leftTop":
            case "rightTop":
                placementInfo.offset[1] = -arrowOffset.arrowOffsetHorizontal * 2 + halfArrowWidth;
                break;
            case "leftBottom":
            case "rightBottom":
                placementInfo.offset[1] = arrowOffset.arrowOffsetHorizontal * 2 - halfArrowWidth;
                break;
        }
        // Overflow
        placementInfo.overflow = $79d8965a045fdc17$export$fde75e5b410c093f(key, arrowOffset, arrowWidth, autoAdjustOverflow);
        // VisibleFirst
        if (visibleFirst) placementInfo.htmlRegion = "visibleFirst";
    });
    return placementMap;
}



var $cQmXV = parcelRequire("cQmXV");


"use client";
function $f2e41308375833b9$export$29e2a8c3cdb34b03(Component) {
    return (props)=>/*#__PURE__*/ $cQmXV.createElement((0, $5764e43cf38ca965$export$2e2bcd8739ae039), {
            theme: {
                token: {
                    motion: false,
                    zIndexPopupBase: 0
                }
            }
        }, /*#__PURE__*/ $cQmXV.createElement(Component, {
            ...props
        }));
}
/* istanbul ignore next */ const $f2e41308375833b9$var$genPurePanel = (Component, alignPropName, postProps, defaultPrefixCls, getDropdownCls)=>{
    const PurePanel = (props)=>{
        const { prefixCls: customizePrefixCls, style: style } = props;
        const holderRef = $cQmXV.useRef(null);
        const [popupHeight, setPopupHeight] = $cQmXV.useState(0);
        const [popupWidth, setPopupWidth] = $cQmXV.useState(0);
        const [open, setOpen] = (0, $a51866d781137e08$export$2e2bcd8739ae039)(false, props.open);
        const { getPrefixCls: getPrefixCls } = $cQmXV.useContext((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
        const prefixCls = getPrefixCls(defaultPrefixCls || "select", customizePrefixCls);
        $cQmXV.useEffect(()=>{
            // We do not care about ssr
            setOpen(true);
            if (typeof ResizeObserver !== "undefined") {
                const resizeObserver = new ResizeObserver((entries)=>{
                    const element = entries[0].target;
                    setPopupHeight(element.offsetHeight + 8);
                    setPopupWidth(element.offsetWidth);
                });
                const interval = setInterval(()=>{
                    const dropdownCls = getDropdownCls ? `.${getDropdownCls(prefixCls)}` : `.${prefixCls}-dropdown`;
                    const popup = holderRef.current?.querySelector(dropdownCls);
                    if (popup) {
                        clearInterval(interval);
                        resizeObserver.observe(popup);
                    }
                }, 10);
                return ()=>{
                    clearInterval(interval);
                    resizeObserver.disconnect();
                };
            }
        }, [
            prefixCls
        ]);
        let mergedProps = {
            ...props,
            style: {
                ...style,
                margin: 0
            },
            open: open,
            getPopupContainer: ()=>holderRef.current
        };
        if (postProps) mergedProps = postProps(mergedProps);
        if (alignPropName) mergedProps = {
            ...mergedProps,
            [alignPropName]: {
                overflow: {
                    adjustX: false,
                    adjustY: false
                }
            }
        };
        const mergedStyle = {
            paddingBottom: popupHeight,
            position: "relative",
            minWidth: popupWidth
        };
        return /*#__PURE__*/ $cQmXV.createElement("div", {
            ref: holderRef,
            style: mergedStyle
        }, /*#__PURE__*/ $cQmXV.createElement(Component, {
            ...mergedProps
        }));
    };
    return $f2e41308375833b9$export$29e2a8c3cdb34b03(PurePanel);
};
var $f2e41308375833b9$export$2e2bcd8739ae039 = $f2e41308375833b9$var$genPurePanel;






/**
 * This hook is only for cssVar to add root className for components.
 * If root ClassName is needed, this hook could be refactored with `-root`
 * @param prefixCls
 */ const $2237081acd3cfc09$var$useCSSVarCls = (prefixCls)=>`${prefixCls}-css-var`;
var $2237081acd3cfc09$export$2e2bcd8739ae039 = $2237081acd3cfc09$var$useCSSVarCls;



var $cQmXV = parcelRequire("cQmXV");



var $cQmXV = parcelRequire("cQmXV");





var $cQmXV = parcelRequire("cQmXV");


// Use shared variable to save bundle size
const $00a5b524d26e4c7b$var$UNDEFINED = undefined;
function $00a5b524d26e4c7b$var$InternalItem(props, ref) {
    const { prefixCls: prefixCls, invalidate: invalidate, item: item, renderItem: renderItem, responsive: responsive, responsiveDisabled: responsiveDisabled, registerSize: registerSize, itemKey: itemKey, className: className, style: style, children: children, display: display, order: order, component: Component = "div", ...restProps } = props;
    const mergedHidden = responsive && !display;
    // ================================ Effect ================================
    function internalRegisterSize(width) {
        registerSize(itemKey, width);
    }
    $cQmXV.useEffect(()=>()=>{
            internalRegisterSize(null);
        }, []);
    // ================================ Render ================================
    const childNode = renderItem && item !== $00a5b524d26e4c7b$var$UNDEFINED ? renderItem(item, {
        index: order
    }) : children;
    let overflowStyle;
    if (!invalidate) overflowStyle = {
        opacity: mergedHidden ? 0 : 1,
        height: mergedHidden ? 0 : $00a5b524d26e4c7b$var$UNDEFINED,
        overflowY: mergedHidden ? "hidden" : $00a5b524d26e4c7b$var$UNDEFINED,
        order: responsive ? order : $00a5b524d26e4c7b$var$UNDEFINED,
        pointerEvents: mergedHidden ? "none" : $00a5b524d26e4c7b$var$UNDEFINED,
        position: mergedHidden ? "absolute" : $00a5b524d26e4c7b$var$UNDEFINED
    };
    const overflowProps = {};
    if (mergedHidden) overflowProps["aria-hidden"] = true;
    let itemNode = /*#__PURE__*/ $cQmXV.createElement(Component, (0, $e69a41570260c349$export$2e2bcd8739ae039)({
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(!invalidate && prefixCls, className),
        style: {
            ...overflowStyle,
            ...style
        }
    }, overflowProps, restProps, {
        ref: ref
    }), childNode);
    if (responsive) itemNode = /*#__PURE__*/ $cQmXV.createElement((0, $1d6306c05e604045$export$2e2bcd8739ae039), {
        onResize: ({ offsetWidth: offsetWidth })=>{
            internalRegisterSize(offsetWidth);
        },
        disabled: responsiveDisabled
    }, itemNode);
    return itemNode;
}
const $00a5b524d26e4c7b$var$Item = /*#__PURE__*/ $cQmXV.forwardRef($00a5b524d26e4c7b$var$InternalItem);
var $00a5b524d26e4c7b$export$2e2bcd8739ae039 = $00a5b524d26e4c7b$var$Item;




var $cQmXV = parcelRequire("cQmXV");

var $3h5eW = parcelRequire("3h5eW");

function $b5ed87d27c689e57$export$2e2bcd8739ae039(callback) {
    if (typeof MessageChannel === "undefined") (0, $905c53b807de704e$export$2e2bcd8739ae039)(callback);
    else {
        const channel = new MessageChannel();
        channel.port1.onmessage = ()=>callback();
        channel.port2.postMessage(undefined);
    }
}


function $6fe0b3e460ee0a7a$export$eedf51fe9d751c7a() {
    // Updater Trigger
    const updateFuncRef = $cQmXV.useRef(null);
    // Notify update
    const notifyEffectUpdate = (callback)=>{
        if (!updateFuncRef.current) {
            updateFuncRef.current = [];
            (0, $b5ed87d27c689e57$export$2e2bcd8739ae039)(()=>{
                (0, $3h5eW.unstable_batchedUpdates)(()=>{
                    updateFuncRef.current.forEach((fn)=>{
                        fn();
                    });
                    updateFuncRef.current = null;
                });
            });
        }
        updateFuncRef.current.push(callback);
    };
    return notifyEffectUpdate;
}
function $6fe0b3e460ee0a7a$export$2e2bcd8739ae039(notifyEffectUpdate, defaultValue) {
    // Value
    const [stateValue, setStateValue] = $cQmXV.useState(defaultValue);
    // Set State
    const setEffectVal = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((nextValue)=>{
        notifyEffectUpdate(()=>{
            setStateValue(nextValue);
        });
    });
    return [
        stateValue,
        setEffectVal
    ];
}




var $cQmXV = parcelRequire("cQmXV");



var $cQmXV = parcelRequire("cQmXV");
const $81b1f68cf25eb9c2$export$79f16dd643143c25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createContext(null);


const $3fbaa238837a4380$var$InternalRawItem = (props, ref)=>{
    const context = $cQmXV.useContext((0, $81b1f68cf25eb9c2$export$79f16dd643143c25));
    // Render directly when context not provided
    if (!context) {
        const { component: Component = "div", ...restProps } = props;
        return /*#__PURE__*/ $cQmXV.createElement(Component, (0, $e69a41570260c349$export$2e2bcd8739ae039)({}, restProps, {
            ref: ref
        }));
    }
    const { className: contextClassName, ...restContext } = context;
    const { className: className, ...restProps } = props;
    // Do not pass context to sub item to avoid multiple measure
    return /*#__PURE__*/ $cQmXV.createElement((0, $81b1f68cf25eb9c2$export$79f16dd643143c25).Provider, {
        value: null
    }, /*#__PURE__*/ $cQmXV.createElement((0, $00a5b524d26e4c7b$export$2e2bcd8739ae039), (0, $e69a41570260c349$export$2e2bcd8739ae039)({
        ref: ref,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(contextClassName, className)
    }, restContext, restProps)));
};
const $3fbaa238837a4380$var$RawItem = /*#__PURE__*/ $cQmXV.forwardRef($3fbaa238837a4380$var$InternalRawItem);
var $3fbaa238837a4380$export$2e2bcd8739ae039 = $3fbaa238837a4380$var$RawItem;



const $f8551ea2b523d517$var$RESPONSIVE = "responsive";
const $f8551ea2b523d517$var$INVALIDATE = "invalidate";
function $f8551ea2b523d517$var$defaultRenderRest(omittedItems) {
    return `+ ${omittedItems.length} ...`;
}
function $f8551ea2b523d517$var$Overflow(props, ref) {
    const { prefixCls: prefixCls = "rc-overflow", data: data = [], renderItem: renderItem, renderRawItem: renderRawItem, itemKey: itemKey, itemWidth: itemWidth = 10, ssr: ssr, style: style, className: className, maxCount: maxCount, renderRest: renderRest, renderRawRest: renderRawRest, prefix: prefix, suffix: suffix, component: Component = "div", itemComponent: itemComponent, onVisibleChange: onVisibleChange, ...restProps } = props;
    const fullySSR = ssr === "full";
    const notifyEffectUpdate = (0, $6fe0b3e460ee0a7a$export$eedf51fe9d751c7a)();
    const [containerWidth, setContainerWidth] = (0, $6fe0b3e460ee0a7a$export$2e2bcd8739ae039)(notifyEffectUpdate, null);
    const mergedContainerWidth = containerWidth || 0;
    const [itemWidths, setItemWidths] = (0, $6fe0b3e460ee0a7a$export$2e2bcd8739ae039)(notifyEffectUpdate, new Map());
    const [prevRestWidth, setPrevRestWidth] = (0, $6fe0b3e460ee0a7a$export$2e2bcd8739ae039)(notifyEffectUpdate, 0);
    const [restWidth, setRestWidth] = (0, $6fe0b3e460ee0a7a$export$2e2bcd8739ae039)(notifyEffectUpdate, 0);
    const [prefixWidth, setPrefixWidth] = (0, $6fe0b3e460ee0a7a$export$2e2bcd8739ae039)(notifyEffectUpdate, 0);
    const [suffixWidth, setSuffixWidth] = (0, $6fe0b3e460ee0a7a$export$2e2bcd8739ae039)(notifyEffectUpdate, 0);
    const [suffixFixedStart, setSuffixFixedStart] = (0, $cQmXV.useState)(null);
    const [displayCount, setDisplayCount] = (0, $cQmXV.useState)(null);
    const mergedDisplayCount = $cQmXV.useMemo(()=>{
        if (displayCount === null && fullySSR) return Number.MAX_SAFE_INTEGER;
        return displayCount || 0;
    }, [
        displayCount,
        containerWidth
    ]);
    const [restReady, setRestReady] = (0, $cQmXV.useState)(false);
    const itemPrefixCls = `${prefixCls}-item`;
    // Always use the max width to avoid blink
    const mergedRestWidth = Math.max(prevRestWidth, restWidth);
    // ================================= Data =================================
    const isResponsive = maxCount === $f8551ea2b523d517$var$RESPONSIVE;
    const shouldResponsive = data.length && isResponsive;
    const invalidate = maxCount === $f8551ea2b523d517$var$INVALIDATE;
    /**
   * When is `responsive`, we will always render rest node to get the real width of it for calculation
   */ const showRest = shouldResponsive || typeof maxCount === "number" && data.length > maxCount;
    const mergedData = (0, $cQmXV.useMemo)(()=>{
        let items = data;
        if (shouldResponsive) {
            if (containerWidth === null && fullySSR) items = data;
            else items = data.slice(0, Math.min(data.length, mergedContainerWidth / itemWidth));
        } else if (typeof maxCount === "number") items = data.slice(0, maxCount);
        return items;
    }, [
        data,
        itemWidth,
        containerWidth,
        maxCount,
        shouldResponsive
    ]);
    const omittedItems = (0, $cQmXV.useMemo)(()=>{
        if (shouldResponsive) return data.slice(mergedDisplayCount + 1);
        return data.slice(mergedData.length);
    }, [
        data,
        mergedData,
        shouldResponsive,
        mergedDisplayCount
    ]);
    // ================================= Item =================================
    const getKey = (0, $cQmXV.useCallback)((item, index)=>{
        if (typeof itemKey === "function") return itemKey(item);
        return (itemKey && item?.[itemKey]) ?? index;
    }, [
        itemKey
    ]);
    const mergedRenderItem = (0, $cQmXV.useCallback)(renderItem || ((item)=>item), [
        renderItem
    ]);
    function updateDisplayCount(count, suffixFixedStartVal, notReady) {
        // React 18 will sync render even when the value is same in some case.
        // We take `mergedData` as deps which may cause dead loop if it's dynamic generate.
        // ref: https://github.com/ant-design/ant-design/issues/36559
        if (displayCount === count && (suffixFixedStartVal === undefined || suffixFixedStartVal === suffixFixedStart)) return;
        setDisplayCount(count);
        if (!notReady) {
            setRestReady(count < data.length - 1);
            onVisibleChange?.(count);
        }
        if (suffixFixedStartVal !== undefined) setSuffixFixedStart(suffixFixedStartVal);
    }
    // ================================= Size =================================
    function onOverflowResize(_, element) {
        setContainerWidth(element.clientWidth);
    }
    function registerSize(key, width) {
        setItemWidths((origin)=>{
            const clone = new Map(origin);
            if (width === null) clone.delete(key);
            else clone.set(key, width);
            return clone;
        });
    }
    function registerOverflowSize(_, width) {
        setRestWidth(width);
        setPrevRestWidth(restWidth);
    }
    function registerPrefixSize(_, width) {
        setPrefixWidth(width);
    }
    function registerSuffixSize(_, width) {
        setSuffixWidth(width);
    }
    // ================================ Effect ================================
    function getItemWidth(index) {
        return itemWidths.get(getKey(mergedData[index], index));
    }
    (0, $7673d874dab69d07$export$2e2bcd8739ae039)(()=>{
        if (mergedContainerWidth && typeof mergedRestWidth === "number" && mergedData) {
            let totalWidth = prefixWidth + suffixWidth;
            const len = mergedData.length;
            const lastIndex = len - 1;
            // When data count change to 0, reset this since not loop will reach
            if (!len) {
                updateDisplayCount(0, null);
                return;
            }
            for(let i = 0; i < len; i += 1){
                let currentItemWidth = getItemWidth(i);
                // Fully will always render
                if (fullySSR) currentItemWidth = currentItemWidth || 0;
                // Break since data not ready
                if (currentItemWidth === undefined) {
                    updateDisplayCount(i - 1, undefined, true);
                    break;
                }
                // Find best match
                totalWidth += currentItemWidth;
                if (// Only one means `totalWidth` is the final width
                lastIndex === 0 && totalWidth <= mergedContainerWidth || // Last two width will be the final width
                i === lastIndex - 1 && totalWidth + getItemWidth(lastIndex) <= mergedContainerWidth) {
                    // Additional check if match the end
                    updateDisplayCount(lastIndex, null);
                    break;
                } else if (totalWidth + mergedRestWidth > mergedContainerWidth) {
                    // Can not hold all the content to show rest
                    updateDisplayCount(i - 1, totalWidth - currentItemWidth - suffixWidth + restWidth);
                    break;
                }
            }
            if (suffix && getItemWidth(0) + suffixWidth > mergedContainerWidth) setSuffixFixedStart(null);
        }
    }, [
        mergedContainerWidth,
        itemWidths,
        restWidth,
        prefixWidth,
        suffixWidth,
        getKey,
        mergedData
    ]);
    // ================================ Render ================================
    const displayRest = restReady && !!omittedItems.length;
    let suffixStyle = {};
    if (suffixFixedStart !== null && shouldResponsive) suffixStyle = {
        position: "absolute",
        top: 0,
        insetInlineStart: suffixFixedStart
    };
    const itemSharedProps = {
        prefixCls: itemPrefixCls,
        responsive: shouldResponsive,
        component: itemComponent,
        invalidate: invalidate
    };
    // >>>>> Choice render fun by `renderRawItem`
    const internalRenderItemNode = renderRawItem ? (item, index)=>{
        const key = getKey(item, index);
        return /*#__PURE__*/ $cQmXV.createElement((0, $81b1f68cf25eb9c2$export$79f16dd643143c25).Provider, {
            key: key,
            value: {
                ...itemSharedProps,
                order: index,
                item: item,
                itemKey: key,
                registerSize: registerSize,
                display: index <= mergedDisplayCount
            }
        }, renderRawItem(item, index));
    } : (item, index)=>{
        const key = getKey(item, index);
        return /*#__PURE__*/ $cQmXV.createElement((0, $00a5b524d26e4c7b$export$2e2bcd8739ae039), (0, $e69a41570260c349$export$2e2bcd8739ae039)({}, itemSharedProps, {
            order: index,
            key: key,
            item: item,
            renderItem: mergedRenderItem,
            itemKey: key,
            registerSize: registerSize,
            display: index <= mergedDisplayCount
        }));
    };
    // >>>>> Rest node
    const restContextProps = {
        order: displayRest ? mergedDisplayCount : Number.MAX_SAFE_INTEGER,
        className: `${itemPrefixCls}-rest`,
        registerSize: registerOverflowSize,
        display: displayRest
    };
    const mergedRenderRest = renderRest || $f8551ea2b523d517$var$defaultRenderRest;
    const restNode = renderRawRest ? /*#__PURE__*/ $cQmXV.createElement((0, $81b1f68cf25eb9c2$export$79f16dd643143c25).Provider, {
        value: {
            ...itemSharedProps,
            ...restContextProps
        }
    }, renderRawRest(omittedItems)) : /*#__PURE__*/ $cQmXV.createElement((0, $00a5b524d26e4c7b$export$2e2bcd8739ae039), (0, $e69a41570260c349$export$2e2bcd8739ae039)({}, itemSharedProps, restContextProps), typeof mergedRenderRest === "function" ? mergedRenderRest(omittedItems) : mergedRenderRest);
    const overflowNode = /*#__PURE__*/ $cQmXV.createElement(Component, (0, $e69a41570260c349$export$2e2bcd8739ae039)({
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(!invalidate && prefixCls, className),
        style: style,
        ref: ref
    }, restProps), prefix && /*#__PURE__*/ $cQmXV.createElement((0, $00a5b524d26e4c7b$export$2e2bcd8739ae039), (0, $e69a41570260c349$export$2e2bcd8739ae039)({}, itemSharedProps, {
        responsive: isResponsive,
        responsiveDisabled: !shouldResponsive,
        order: -1,
        className: `${itemPrefixCls}-prefix`,
        registerSize: registerPrefixSize,
        display: true
    }), prefix), mergedData.map(internalRenderItemNode), showRest ? restNode : null, suffix && /*#__PURE__*/ $cQmXV.createElement((0, $00a5b524d26e4c7b$export$2e2bcd8739ae039), (0, $e69a41570260c349$export$2e2bcd8739ae039)({}, itemSharedProps, {
        responsive: isResponsive,
        responsiveDisabled: !shouldResponsive,
        order: mergedDisplayCount,
        className: `${itemPrefixCls}-suffix`,
        registerSize: registerSuffixSize,
        display: true,
        style: suffixStyle
    }), suffix));
    return isResponsive ? /*#__PURE__*/ $cQmXV.createElement((0, $1d6306c05e604045$export$2e2bcd8739ae039), {
        onResize: onOverflowResize,
        disabled: !shouldResponsive
    }, overflowNode) : overflowNode;
}
const $f8551ea2b523d517$var$ForwardOverflow = /*#__PURE__*/ $cQmXV.forwardRef($f8551ea2b523d517$var$Overflow);
$f8551ea2b523d517$var$ForwardOverflow.Item = (0, $3fbaa238837a4380$export$2e2bcd8739ae039);
$f8551ea2b523d517$var$ForwardOverflow.RESPONSIVE = $f8551ea2b523d517$var$RESPONSIVE;
$f8551ea2b523d517$var$ForwardOverflow.INVALIDATE = $f8551ea2b523d517$var$INVALIDATE;
var // Convert to generic type
$f8551ea2b523d517$export$2e2bcd8739ae039 = $f8551ea2b523d517$var$ForwardOverflow;


var $788a6a69bf396d02$export$2e2bcd8739ae039 = (0, $f8551ea2b523d517$export$2e2bcd8739ae039);




var $cQmXV = parcelRequire("cQmXV");

var $3h5eW = parcelRequire("3h5eW");

var $cQmXV = parcelRequire("cQmXV");
const $6d545ce41484d312$export$26537912ea160acd = /*#__PURE__*/ $cQmXV.createContext(null);
function $6d545ce41484d312$export$80c871fe8d6b896(uuid, eventKey) {
    return `${uuid}-${eventKey}`;
}
function $6d545ce41484d312$export$a276eb4e9be640f8(eventKey) {
    const id = $cQmXV.useContext($6d545ce41484d312$export$26537912ea160acd);
    return $6d545ce41484d312$export$80c871fe8d6b896(id, eventKey);
}



var $cQmXV = parcelRequire("cQmXV");

const $1045c7350ff5831e$export$c7e742effb1c51e2 = /*#__PURE__*/ $cQmXV.createContext(null);
function $1045c7350ff5831e$var$mergeProps(origin, target) {
    const clone = {
        ...origin
    };
    Object.keys(target).forEach((key)=>{
        const value = target[key];
        if (value !== undefined) clone[key] = value;
    });
    return clone;
}
function $1045c7350ff5831e$export$2e2bcd8739ae039({ children: children, locked: locked, ...restProps }) {
    const context = $cQmXV.useContext($1045c7350ff5831e$export$c7e742effb1c51e2);
    const inheritableContext = (0, $d627c2941353b4cb$export$2e2bcd8739ae039)(()=>$1045c7350ff5831e$var$mergeProps(context, restProps), [
        context,
        restProps
    ], (prev, next)=>!locked && (prev[0] !== next[0] || !(0, $3f19ee2a2ff4618a$export$2e2bcd8739ae039)(prev[1], next[1], true)));
    return /*#__PURE__*/ $cQmXV.createElement($1045c7350ff5831e$export$c7e742effb1c51e2.Provider, {
        value: inheritableContext
    }, children);
}



var $cQmXV = parcelRequire("cQmXV");
const $bf3002d33db0f6a4$var$EmptyList = [];
const $bf3002d33db0f6a4$export$d9ffb5bfd108b003 = /*#__PURE__*/ $cQmXV.createContext(null);
function $bf3002d33db0f6a4$export$e295b0c537d32d7d() {
    return $cQmXV.useContext($bf3002d33db0f6a4$export$d9ffb5bfd108b003);
}
const $bf3002d33db0f6a4$export$54d9e16aa4c8a7fa = /*#__PURE__*/ $cQmXV.createContext($bf3002d33db0f6a4$var$EmptyList);
function $bf3002d33db0f6a4$export$d3d2d0a05677870a(eventKey) {
    const parentKeyPath = $cQmXV.useContext($bf3002d33db0f6a4$export$54d9e16aa4c8a7fa);
    return $cQmXV.useMemo(()=>eventKey !== undefined ? [
            ...parentKeyPath,
            eventKey
        ] : parentKeyPath, [
        parentKeyPath,
        eventKey
    ]);
}
const $bf3002d33db0f6a4$export$f0b9e0db98edfa53 = /*#__PURE__*/ $cQmXV.createContext(null);



var $cQmXV = parcelRequire("cQmXV");
const $9b24ab808f2f22a1$var$PrivateContext = /*#__PURE__*/ $cQmXV.createContext({});
var $9b24ab808f2f22a1$export$2e2bcd8739ae039 = $9b24ab808f2f22a1$var$PrivateContext;




var $cQmXV = parcelRequire("cQmXV");

// destruct to reduce minify size
const { LEFT: $e0147216e3c8903c$var$LEFT, RIGHT: $e0147216e3c8903c$var$RIGHT, UP: $e0147216e3c8903c$var$UP, DOWN: $e0147216e3c8903c$var$DOWN, ENTER: $e0147216e3c8903c$var$ENTER, ESC: $e0147216e3c8903c$var$ESC, HOME: $e0147216e3c8903c$var$HOME, END: $e0147216e3c8903c$var$END } = (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039);
const $e0147216e3c8903c$var$ArrowKeys = [
    $e0147216e3c8903c$var$UP,
    $e0147216e3c8903c$var$DOWN,
    $e0147216e3c8903c$var$LEFT,
    $e0147216e3c8903c$var$RIGHT
];
function $e0147216e3c8903c$var$getOffset(mode, isRootLevel, isRtl, which) {
    const prev = "prev";
    const next = "next";
    const children = "children";
    const parent = "parent";
    // Inline enter is special that we use unique operation
    if (mode === "inline" && which === $e0147216e3c8903c$var$ENTER) return {
        inlineTrigger: true
    };
    const inline = {
        [$e0147216e3c8903c$var$UP]: prev,
        [$e0147216e3c8903c$var$DOWN]: next
    };
    const horizontal = {
        [$e0147216e3c8903c$var$LEFT]: isRtl ? next : prev,
        [$e0147216e3c8903c$var$RIGHT]: isRtl ? prev : next,
        [$e0147216e3c8903c$var$DOWN]: children,
        [$e0147216e3c8903c$var$ENTER]: children
    };
    const vertical = {
        [$e0147216e3c8903c$var$UP]: prev,
        [$e0147216e3c8903c$var$DOWN]: next,
        [$e0147216e3c8903c$var$ENTER]: children,
        [$e0147216e3c8903c$var$ESC]: parent,
        [$e0147216e3c8903c$var$LEFT]: isRtl ? children : parent,
        [$e0147216e3c8903c$var$RIGHT]: isRtl ? parent : children
    };
    const offsets = {
        inline: inline,
        horizontal: horizontal,
        vertical: vertical,
        inlineSub: inline,
        horizontalSub: vertical,
        verticalSub: vertical
    };
    const type = offsets[`${mode}${isRootLevel ? "" : "Sub"}`]?.[which];
    switch(type){
        case prev:
            return {
                offset: -1,
                sibling: true
            };
        case next:
            return {
                offset: 1,
                sibling: true
            };
        case parent:
            return {
                offset: -1,
                sibling: false
            };
        case children:
            return {
                offset: 1,
                sibling: false
            };
        default:
            return null;
    }
}
function $e0147216e3c8903c$var$findContainerUL(element) {
    let current = element;
    while(current){
        if (current.getAttribute("data-menu-list")) return current;
        current = current.parentElement;
    }
    // Normally should not reach this line
    /* istanbul ignore next */ return null;
}
/**
 * Find focused element within element set provided
 */ function $e0147216e3c8903c$var$getFocusElement(activeElement, elements) {
    let current = activeElement || document.activeElement;
    while(current){
        if (elements.has(current)) return current;
        current = current.parentElement;
    }
    return null;
}
function $e0147216e3c8903c$export$433aaa1f216cf32d(container, elements) {
    const list = (0, $7aa1eaa901116c60$export$bbc7b5f11aba534b)(container, true);
    return list.filter((ele)=>elements.has(ele));
}
function $e0147216e3c8903c$var$getNextFocusElement(parentQueryContainer, elements, focusMenuElement, offset = 1) {
    // Key on the menu item will not get validate parent container
    if (!parentQueryContainer) return null;
    // List current level menu item elements
    const sameLevelFocusableMenuElementList = $e0147216e3c8903c$export$433aaa1f216cf32d(parentQueryContainer, elements);
    // Find next focus index
    const count = sameLevelFocusableMenuElementList.length;
    let focusIndex = sameLevelFocusableMenuElementList.findIndex((ele)=>focusMenuElement === ele);
    if (offset < 0) {
        if (focusIndex === -1) focusIndex = count - 1;
        else focusIndex -= 1;
    } else if (offset > 0) focusIndex += 1;
    focusIndex = (focusIndex + count) % count;
    // Focus menu item
    return sameLevelFocusableMenuElementList[focusIndex];
}
const $e0147216e3c8903c$export$20827b68c762d23 = (keys, id)=>{
    const elements = new Set();
    const key2element = new Map();
    const element2key = new Map();
    keys.forEach((key)=>{
        const element = document.querySelector(`[data-menu-id='${(0, $6d545ce41484d312$export$80c871fe8d6b896)(id, key)}']`);
        if (element) {
            elements.add(element);
            element2key.set(element, key);
            key2element.set(key, element);
        }
    });
    return {
        elements: elements,
        key2element: key2element,
        element2key: element2key
    };
};
function $e0147216e3c8903c$export$aa6de64279d64603(mode, activeKey, isRtl, id, containerRef, getKeys, getKeyPath, triggerActiveKey, triggerAccessibilityOpen, originOnKeyDown) {
    const rafRef = $cQmXV.useRef();
    const activeRef = $cQmXV.useRef();
    activeRef.current = activeKey;
    const cleanRaf = ()=>{
        (0, $905c53b807de704e$export$2e2bcd8739ae039).cancel(rafRef.current);
    };
    $cQmXV.useEffect(()=>()=>{
            cleanRaf();
        }, []);
    return (e)=>{
        const { which: which } = e;
        if ([
            ...$e0147216e3c8903c$var$ArrowKeys,
            $e0147216e3c8903c$var$ENTER,
            $e0147216e3c8903c$var$ESC,
            $e0147216e3c8903c$var$HOME,
            $e0147216e3c8903c$var$END
        ].includes(which)) {
            const keys = getKeys();
            let refreshedElements = $e0147216e3c8903c$export$20827b68c762d23(keys, id);
            const { elements: elements, key2element: key2element, element2key: element2key } = refreshedElements;
            // First we should find current focused MenuItem/SubMenu element
            const activeElement = key2element.get(activeKey);
            const focusMenuElement = $e0147216e3c8903c$var$getFocusElement(activeElement, elements);
            const focusMenuKey = element2key.get(focusMenuElement);
            const offsetObj = $e0147216e3c8903c$var$getOffset(mode, getKeyPath(focusMenuKey, true).length === 1, isRtl, which);
            // Some mode do not have fully arrow operation like inline
            if (!offsetObj && which !== $e0147216e3c8903c$var$HOME && which !== $e0147216e3c8903c$var$END) return;
            // Arrow prevent default to avoid page scroll
            if ($e0147216e3c8903c$var$ArrowKeys.includes(which) || [
                $e0147216e3c8903c$var$HOME,
                $e0147216e3c8903c$var$END
            ].includes(which)) e.preventDefault();
            const tryFocus = (menuElement)=>{
                if (menuElement) {
                    let focusTargetElement = menuElement;
                    // Focus to link instead of menu item if possible
                    const link = menuElement.querySelector("a");
                    if (link?.getAttribute("href")) focusTargetElement = link;
                    const targetKey = element2key.get(menuElement);
                    triggerActiveKey(targetKey);
                    /**
           * Do not `useEffect` here since `tryFocus` may trigger async
           * which makes React sync update the `activeKey`
           * that force render before `useRef` set the next activeKey
           */ cleanRaf();
                    rafRef.current = (0, $905c53b807de704e$export$2e2bcd8739ae039)(()=>{
                        if (activeRef.current === targetKey) focusTargetElement.focus();
                    });
                }
            };
            if ([
                $e0147216e3c8903c$var$HOME,
                $e0147216e3c8903c$var$END
            ].includes(which) || offsetObj.sibling || !focusMenuElement) {
                // ========================== Sibling ==========================
                // Find walkable focus menu element container
                let parentQueryContainer;
                if (!focusMenuElement || mode === "inline") parentQueryContainer = containerRef.current;
                else parentQueryContainer = $e0147216e3c8903c$var$findContainerUL(focusMenuElement);
                // Get next focus element
                let targetElement;
                const focusableElements = $e0147216e3c8903c$export$433aaa1f216cf32d(parentQueryContainer, elements);
                if (which === $e0147216e3c8903c$var$HOME) targetElement = focusableElements[0];
                else if (which === $e0147216e3c8903c$var$END) targetElement = focusableElements[focusableElements.length - 1];
                else targetElement = $e0147216e3c8903c$var$getNextFocusElement(parentQueryContainer, elements, focusMenuElement, offsetObj.offset);
                // Focus menu item
                tryFocus(targetElement);
            // ======================= InlineTrigger =======================
            } else if (offsetObj.inlineTrigger) // Inline trigger no need switch to sub menu item
            triggerAccessibilityOpen(focusMenuKey);
            else if (offsetObj.offset > 0) {
                triggerAccessibilityOpen(focusMenuKey, true);
                cleanRaf();
                rafRef.current = (0, $905c53b807de704e$export$2e2bcd8739ae039)(()=>{
                    // Async should resync elements
                    refreshedElements = $e0147216e3c8903c$export$20827b68c762d23(keys, id);
                    const controlId = focusMenuElement.getAttribute("aria-controls");
                    const subQueryContainer = document.getElementById(controlId);
                    // Get sub focusable menu item
                    const targetElement = $e0147216e3c8903c$var$getNextFocusElement(subQueryContainer, refreshedElements.elements);
                    // Focus menu item
                    tryFocus(targetElement);
                }, 5);
            } else if (offsetObj.offset < 0) {
                const keyPath = getKeyPath(focusMenuKey, true);
                const parentKey = keyPath[keyPath.length - 2];
                const parentMenuElement = key2element.get(parentKey);
                // Focus menu item
                triggerAccessibilityOpen(parentKey, false);
                tryFocus(parentMenuElement);
            }
        }
        // Pass origin key down event
        originOnKeyDown?.(e);
    };
}



var $cQmXV = parcelRequire("cQmXV");

function $3f375fabecec3874$export$7693db51ef834b40(callback) {
    /* istanbul ignore next */ Promise.resolve().then(callback);
}


const $9e1d79d9752eccf7$var$PATH_SPLIT = "__RC_UTIL_PATH_SPLIT__";
const $9e1d79d9752eccf7$var$getPathStr = (keyPath)=>keyPath.join($9e1d79d9752eccf7$var$PATH_SPLIT);
const $9e1d79d9752eccf7$var$getPathKeys = (keyPathStr)=>keyPathStr.split($9e1d79d9752eccf7$var$PATH_SPLIT);
const $9e1d79d9752eccf7$export$20a0132c46ce5b04 = "rc-menu-more";
function $9e1d79d9752eccf7$export$2e2bcd8739ae039() {
    const [, internalForceUpdate] = $cQmXV.useState({});
    const key2pathRef = (0, $cQmXV.useRef)(new Map());
    const path2keyRef = (0, $cQmXV.useRef)(new Map());
    const [overflowKeys, setOverflowKeys] = $cQmXV.useState([]);
    const updateRef = (0, $cQmXV.useRef)(0);
    const destroyRef = (0, $cQmXV.useRef)(false);
    const forceUpdate = ()=>{
        if (!destroyRef.current) internalForceUpdate({});
    };
    const registerPath = (0, $cQmXV.useCallback)((key, keyPath)=>{
        // Fill map
        const connectedPath = $9e1d79d9752eccf7$var$getPathStr(keyPath);
        path2keyRef.current.set(connectedPath, key);
        key2pathRef.current.set(key, connectedPath);
        updateRef.current += 1;
        const id = updateRef.current;
        (0, $3f375fabecec3874$export$7693db51ef834b40)(()=>{
            if (id === updateRef.current) forceUpdate();
        });
    }, []);
    const unregisterPath = (0, $cQmXV.useCallback)((key, keyPath)=>{
        const connectedPath = $9e1d79d9752eccf7$var$getPathStr(keyPath);
        path2keyRef.current.delete(connectedPath);
        key2pathRef.current.delete(key);
    }, []);
    const refreshOverflowKeys = (0, $cQmXV.useCallback)((keys)=>{
        setOverflowKeys(keys);
    }, []);
    const getKeyPath = (0, $cQmXV.useCallback)((eventKey, includeOverflow)=>{
        const fullPath = key2pathRef.current.get(eventKey) || "";
        const keys = $9e1d79d9752eccf7$var$getPathKeys(fullPath);
        if (includeOverflow && overflowKeys.includes(keys[0])) keys.unshift($9e1d79d9752eccf7$export$20a0132c46ce5b04);
        return keys;
    }, [
        overflowKeys
    ]);
    const isSubPathKey = (0, $cQmXV.useCallback)((pathKeys, eventKey)=>pathKeys.filter((item)=>item !== undefined).some((pathKey)=>{
            const pathKeyList = getKeyPath(pathKey, true);
            return pathKeyList.includes(eventKey);
        }), [
        getKeyPath
    ]);
    const getKeys = ()=>{
        const keys = [
            ...key2pathRef.current.keys()
        ];
        if (overflowKeys.length) keys.push($9e1d79d9752eccf7$export$20a0132c46ce5b04);
        return keys;
    };
    /**
   * Find current key related child path keys
   */ const getSubPathKeys = (0, $cQmXV.useCallback)((key)=>{
        const connectedPath = `${key2pathRef.current.get(key)}${$9e1d79d9752eccf7$var$PATH_SPLIT}`;
        const pathKeys = new Set();
        [
            ...path2keyRef.current.keys()
        ].forEach((pathKey)=>{
            if (pathKey.startsWith(connectedPath)) pathKeys.add(path2keyRef.current.get(pathKey));
        });
        return pathKeys;
    }, []);
    $cQmXV.useEffect(()=>()=>{
            destroyRef.current = true;
        }, []);
    return {
        registerPath: // Register
        registerPath,
        unregisterPath: unregisterPath,
        refreshOverflowKeys: refreshOverflowKeys,
        isSubPathKey: // Util
        isSubPathKey,
        getKeyPath: getKeyPath,
        getKeys: getKeys,
        getSubPathKeys: getSubPathKeys
    };
}



var $cQmXV = parcelRequire("cQmXV");
function $59dc9f05f734c70e$export$2e2bcd8739ae039(func) {
    const funRef = $cQmXV.useRef(func);
    funRef.current = func;
    const callback = $cQmXV.useCallback((...args)=>funRef.current?.(...args), []);
    return func ? callback : undefined;
}






var $cQmXV = parcelRequire("cQmXV");





var $cQmXV = parcelRequire("cQmXV");

function $415ed218550fb561$export$2e2bcd8739ae039(eventKey, disabled, onMouseEnter, onMouseLeave) {
    const { activeKey: // Active
    activeKey, onActive: onActive, onInactive: onInactive } = $cQmXV.useContext((0, $1045c7350ff5831e$export$c7e742effb1c51e2));
    const ret = {
        active: activeKey === eventKey
    };
    // Skip when disabled
    if (!disabled) {
        ret.onMouseEnter = (domEvent)=>{
            onMouseEnter?.({
                key: eventKey,
                domEvent: domEvent
            });
            onActive(eventKey);
        };
        ret.onMouseLeave = (domEvent)=>{
            onMouseLeave?.({
                key: eventKey,
                domEvent: domEvent
            });
            onInactive(eventKey);
        };
    }
    return ret;
}



var $cQmXV = parcelRequire("cQmXV");

function $3ac43456faca28e6$export$2e2bcd8739ae039(level) {
    const { mode: mode, rtl: rtl, inlineIndent: inlineIndent } = $cQmXV.useContext((0, $1045c7350ff5831e$export$c7e742effb1c51e2));
    if (mode !== "inline") return null;
    const len = level;
    return rtl ? {
        paddingRight: len * inlineIndent
    } : {
        paddingLeft: len * inlineIndent
    };
}



var $cQmXV = parcelRequire("cQmXV");
function $24399cdbe47e677d$export$2e2bcd8739ae039({ icon: icon, props: props, children: children }) {
    let iconNode;
    if (icon === null || icon === false) return null;
    if (typeof icon === "function") iconNode = /*#__PURE__*/ $cQmXV.createElement(icon, {
        ...props
    });
    else if (typeof icon !== "boolean") // Compatible for origin definition
    iconNode = icon;
    return iconNode || children || null;
}



function $b612928d660b51d6$export$e189bcd94b66c1db({ item: item, ...restInfo }) {
    Object.defineProperty(restInfo, "item", {
        get: ()=>{
            (0, $26d7cf6379fe7659$export$2e2bcd8739ae039)(false, "`info.item` is deprecated since we will move to function component that not provides React Node instance in future.");
            return item;
        }
    });
    return restInfo;
}


function $dc497472bf4ea988$var$_extends() {
    $dc497472bf4ea988$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $dc497472bf4ea988$var$_extends.apply(this, arguments);
}
// Since Menu event provide the `info.item` which point to the MenuItem node instance.
// We have to use class component here.
// This should be removed from doc & api in future.
class $dc497472bf4ea988$var$LegacyMenuItem extends $cQmXV.Component {
    render() {
        const { title: title, attribute: attribute, elementRef: elementRef, ...restProps } = this.props;
        // Here the props are eventually passed to the DOM element.
        // React does not recognize non-standard attributes.
        // Therefore, remove the props that is not used here.
        // ref: https://github.com/ant-design/ant-design/issues/41395
        const passedProps = (0, $e8c5093aebad6025$export$2e2bcd8739ae039)(restProps, [
            "eventKey",
            "popupClassName",
            "popupOffset",
            "onTitleClick"
        ]);
        (0, $26d7cf6379fe7659$export$2e2bcd8739ae039)(!attribute, "`attribute` of Menu.Item is deprecated. Please pass attribute directly.");
        return /*#__PURE__*/ $cQmXV.createElement((0, $788a6a69bf396d02$export$2e2bcd8739ae039).Item, $dc497472bf4ea988$var$_extends({}, attribute, {
            title: typeof title === "string" ? title : undefined
        }, passedProps, {
            ref: elementRef
        }));
    }
}
/**
 * Real Menu Item component
 */ const $dc497472bf4ea988$var$InternalMenuItem = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { style: style, className: className, eventKey: eventKey, warnKey: warnKey, disabled: disabled, itemIcon: itemIcon, children: children, itemData: propsItemData, role: // Aria
    role, onMouseEnter: // Active
    onMouseEnter, onMouseLeave: onMouseLeave, onClick: onClick, onKeyDown: onKeyDown, onFocus: onFocus, ...restProps } = props;
    const domDataId = (0, $6d545ce41484d312$export$a276eb4e9be640f8)(eventKey);
    const { prefixCls: prefixCls, onItemClick: onItemClick, disabled: contextDisabled, overflowDisabled: overflowDisabled, // Icon
    itemIcon: contextItemIcon, selectedKeys: // Select
    selectedKeys, onActive: // Active
    onActive } = $cQmXV.useContext((0, $1045c7350ff5831e$export$c7e742effb1c51e2));
    const { _internalRenderMenuItem: _internalRenderMenuItem } = $cQmXV.useContext((0, $9b24ab808f2f22a1$export$2e2bcd8739ae039));
    const itemCls = `${prefixCls}-item`;
    const legacyMenuItemRef = $cQmXV.useRef();
    const elementRef = $cQmXV.useRef();
    const mergedDisabled = contextDisabled || disabled;
    const mergedEleRef = (0, $10341b937b26f69d$export$1d1c999670a1285d)(ref, elementRef);
    const connectedKeys = (0, $bf3002d33db0f6a4$export$d3d2d0a05677870a)(eventKey);
    // ============================= Info =============================
    const getEventInfo = (e)=>{
        // If propsInfo exists (items mode), use it; otherwise build from props (children mode)
        const itemData = propsItemData || {
            key: eventKey || "",
            label: children,
            itemIcon: itemIcon,
            extra: props.extra,
            title: props.title
        };
        return {
            key: eventKey,
            // Note: For legacy code is reversed which not like other antd component
            keyPath: [
                ...connectedKeys
            ].reverse(),
            item: legacyMenuItemRef.current,
            domEvent: e,
            itemData: propsItemData || itemData
        };
    };
    // ============================= Icon =============================
    const mergedItemIcon = itemIcon || contextItemIcon;
    // ============================ Active ============================
    const { active: active, ...activeProps } = (0, $415ed218550fb561$export$2e2bcd8739ae039)(eventKey, mergedDisabled, onMouseEnter, onMouseLeave);
    // ============================ Select ============================
    const selected = selectedKeys.includes(eventKey);
    // ======================== DirectionStyle ========================
    const directionStyle = (0, $3ac43456faca28e6$export$2e2bcd8739ae039)(connectedKeys.length);
    // ============================ Events ============================
    const onInternalClick = (e)=>{
        if (mergedDisabled) return;
        const info = getEventInfo(e);
        onClick?.((0, $b612928d660b51d6$export$e189bcd94b66c1db)(info));
        onItemClick(info);
    };
    const onInternalKeyDown = (e)=>{
        onKeyDown?.(e);
        if (e.which === (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).ENTER) {
            const info = getEventInfo(e);
            // Legacy. Key will also trigger click event
            onClick?.((0, $b612928d660b51d6$export$e189bcd94b66c1db)(info));
            onItemClick(info);
        }
    };
    /**
   * Used for accessibility. Helper will focus element without key board.
   * We should manually trigger an active
   */ const onInternalFocus = (e)=>{
        onActive(eventKey);
        onFocus?.(e);
    };
    // ============================ Render ============================
    const optionRoleProps = {};
    if (props.role === "option") optionRoleProps["aria-selected"] = selected;
    let renderNode = /*#__PURE__*/ $cQmXV.createElement($dc497472bf4ea988$var$LegacyMenuItem, $dc497472bf4ea988$var$_extends({
        ref: legacyMenuItemRef,
        elementRef: mergedEleRef,
        role: role === null ? "none" : role || "menuitem",
        tabIndex: disabled ? null : -1,
        "data-menu-id": overflowDisabled && domDataId ? null : domDataId
    }, (0, $e8c5093aebad6025$export$2e2bcd8739ae039)(restProps, [
        "extra"
    ]), activeProps, optionRoleProps, {
        component: "li",
        "aria-disabled": disabled,
        style: {
            ...directionStyle,
            ...style
        },
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(itemCls, {
            [`${itemCls}-active`]: active,
            [`${itemCls}-selected`]: selected,
            [`${itemCls}-disabled`]: mergedDisabled
        }, className),
        onClick: onInternalClick,
        onKeyDown: onInternalKeyDown,
        onFocus: onInternalFocus
    }), children, /*#__PURE__*/ $cQmXV.createElement((0, $24399cdbe47e677d$export$2e2bcd8739ae039), {
        props: {
            ...props,
            isSelected: selected
        },
        icon: mergedItemIcon
    }));
    if (_internalRenderMenuItem) renderNode = _internalRenderMenuItem(renderNode, props, {
        selected: selected
    });
    return renderNode;
});
function $dc497472bf4ea988$var$MenuItem(props, ref) {
    const { eventKey: eventKey } = props;
    // ==================== Record KeyPath ====================
    const measure = (0, $bf3002d33db0f6a4$export$e295b0c537d32d7d)();
    const connectedKeyPath = (0, $bf3002d33db0f6a4$export$d3d2d0a05677870a)(eventKey);
    // eslint-disable-next-line consistent-return
    $cQmXV.useEffect(()=>{
        if (measure) {
            measure.registerPath(eventKey, connectedKeyPath);
            return ()=>{
                measure.unregisterPath(eventKey, connectedKeyPath);
            };
        }
    }, [
        connectedKeyPath
    ]);
    if (measure) return null;
    // ======================== Render ========================
    return /*#__PURE__*/ $cQmXV.createElement($dc497472bf4ea988$var$InternalMenuItem, $dc497472bf4ea988$var$_extends({}, props, {
        ref: ref
    }));
}
var $dc497472bf4ea988$export$2e2bcd8739ae039 = /*#__PURE__*/ $cQmXV.forwardRef($dc497472bf4ea988$var$MenuItem);



var $cQmXV = parcelRequire("cQmXV");




var $cQmXV = parcelRequire("cQmXV");


function $e452e49dc62fd115$var$_extends() {
    $e452e49dc62fd115$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e452e49dc62fd115$var$_extends.apply(this, arguments);
}
const $e452e49dc62fd115$var$InternalSubMenuList = ({ className: className, children: children, ...restProps }, ref)=>{
    const { prefixCls: prefixCls, mode: mode, rtl: rtl } = $cQmXV.useContext((0, $1045c7350ff5831e$export$c7e742effb1c51e2));
    return /*#__PURE__*/ $cQmXV.createElement("ul", $e452e49dc62fd115$var$_extends({
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, rtl && `${prefixCls}-rtl`, `${prefixCls}-sub`, `${prefixCls}-${mode === "inline" ? "inline" : "vertical"}`, className),
        role: "menu"
    }, restProps, {
        "data-menu-list": true,
        ref: ref
    }), children);
};
const $e452e49dc62fd115$var$SubMenuList = /*#__PURE__*/ $cQmXV.forwardRef($e452e49dc62fd115$var$InternalSubMenuList);
var $e452e49dc62fd115$export$2e2bcd8739ae039 = $e452e49dc62fd115$var$SubMenuList;




var $cQmXV = parcelRequire("cQmXV");
function $a3071810dba204a1$export$cd230e97e668be9(children, keyPath) {
    return (0, $cd966a313e0a92ff$export$2e2bcd8739ae039)(children).map((child, index)=>{
        if (/*#__PURE__*/ $cQmXV.isValidElement(child)) {
            const { key: key } = child;
            let eventKey = child.props?.eventKey ?? key;
            const emptyKey = eventKey === null || eventKey === undefined;
            if (emptyKey) eventKey = `tmp_key-${[
                ...keyPath,
                index
            ].join("-")}`;
            const cloneProps = {
                key: eventKey,
                eventKey: eventKey
            };
            return /*#__PURE__*/ $cQmXV.cloneElement(child, cloneProps);
        }
        return child;
    });
}





var $cQmXV = parcelRequire("cQmXV");




const $13f0ad43e67d96e3$var$autoAdjustOverflow = {
    adjustX: 1,
    adjustY: 1
};
const $13f0ad43e67d96e3$export$803cd8101b6c182b = {
    topLeft: {
        points: [
            "bl",
            "tl"
        ],
        overflow: $13f0ad43e67d96e3$var$autoAdjustOverflow
    },
    topRight: {
        points: [
            "br",
            "tr"
        ],
        overflow: $13f0ad43e67d96e3$var$autoAdjustOverflow
    },
    bottomLeft: {
        points: [
            "tl",
            "bl"
        ],
        overflow: $13f0ad43e67d96e3$var$autoAdjustOverflow
    },
    bottomRight: {
        points: [
            "tr",
            "br"
        ],
        overflow: $13f0ad43e67d96e3$var$autoAdjustOverflow
    },
    leftTop: {
        points: [
            "tr",
            "tl"
        ],
        overflow: $13f0ad43e67d96e3$var$autoAdjustOverflow
    },
    leftBottom: {
        points: [
            "br",
            "bl"
        ],
        overflow: $13f0ad43e67d96e3$var$autoAdjustOverflow
    },
    rightTop: {
        points: [
            "tl",
            "tr"
        ],
        overflow: $13f0ad43e67d96e3$var$autoAdjustOverflow
    },
    rightBottom: {
        points: [
            "bl",
            "br"
        ],
        overflow: $13f0ad43e67d96e3$var$autoAdjustOverflow
    }
};
const $13f0ad43e67d96e3$export$e2b3f69b0a16e1f = {
    topLeft: {
        points: [
            "bl",
            "tl"
        ],
        overflow: $13f0ad43e67d96e3$var$autoAdjustOverflow
    },
    topRight: {
        points: [
            "br",
            "tr"
        ],
        overflow: $13f0ad43e67d96e3$var$autoAdjustOverflow
    },
    bottomLeft: {
        points: [
            "tl",
            "bl"
        ],
        overflow: $13f0ad43e67d96e3$var$autoAdjustOverflow
    },
    bottomRight: {
        points: [
            "tr",
            "br"
        ],
        overflow: $13f0ad43e67d96e3$var$autoAdjustOverflow
    },
    rightTop: {
        points: [
            "tr",
            "tl"
        ],
        overflow: $13f0ad43e67d96e3$var$autoAdjustOverflow
    },
    rightBottom: {
        points: [
            "br",
            "bl"
        ],
        overflow: $13f0ad43e67d96e3$var$autoAdjustOverflow
    },
    leftTop: {
        points: [
            "tl",
            "tr"
        ],
        overflow: $13f0ad43e67d96e3$var$autoAdjustOverflow
    },
    leftBottom: {
        points: [
            "bl",
            "br"
        ],
        overflow: $13f0ad43e67d96e3$var$autoAdjustOverflow
    }
};
var $13f0ad43e67d96e3$export$2e2bcd8739ae039 = $13f0ad43e67d96e3$export$803cd8101b6c182b;


function $f6ad46640fbff9b4$export$7b8936ddc277a29a(mode, motion, defaultMotions) {
    if (motion) return motion;
    if (defaultMotions) return defaultMotions[mode] || defaultMotions.other;
    return undefined;
}


const $c6f29864fc708ad8$var$popupPlacementMap = {
    horizontal: "bottomLeft",
    vertical: "rightTop",
    "vertical-left": "rightTop",
    "vertical-right": "leftTop"
};
function $c6f29864fc708ad8$export$2e2bcd8739ae039({ prefixCls: prefixCls, visible: visible, children: children, popup: popup, popupStyle: popupStyle, popupClassName: popupClassName, popupOffset: popupOffset, disabled: disabled, mode: mode, onVisibleChange: onVisibleChange }) {
    const { getPopupContainer: getPopupContainer, rtl: rtl, subMenuOpenDelay: subMenuOpenDelay, subMenuCloseDelay: subMenuCloseDelay, builtinPlacements: builtinPlacements, triggerSubMenuAction: triggerSubMenuAction, forceSubMenuRender: forceSubMenuRender, rootClassName: rootClassName, motion: // Motion
    motion, defaultMotions: defaultMotions } = $cQmXV.useContext((0, $1045c7350ff5831e$export$c7e742effb1c51e2));
    const [innerVisible, setInnerVisible] = $cQmXV.useState(false);
    const placement = rtl ? {
        ...(0, $13f0ad43e67d96e3$export$e2b3f69b0a16e1f),
        ...builtinPlacements
    } : {
        ...(0, $13f0ad43e67d96e3$export$803cd8101b6c182b),
        ...builtinPlacements
    };
    const popupPlacement = $c6f29864fc708ad8$var$popupPlacementMap[mode];
    const targetMotion = (0, $f6ad46640fbff9b4$export$7b8936ddc277a29a)(mode, motion, defaultMotions);
    const targetMotionRef = $cQmXV.useRef(targetMotion);
    if (mode !== "inline") /**
     * PopupTrigger is only used for vertical and horizontal types.
     * When collapsed is unfolded, the inline animation will destroy the vertical animation.
     */ targetMotionRef.current = targetMotion;
    const mergedMotion = {
        ...targetMotionRef.current,
        leavedClassName: `${prefixCls}-hidden`,
        removeOnLeave: false,
        motionAppear: true
    };
    // Delay to change visible
    const visibleRef = $cQmXV.useRef();
    $cQmXV.useEffect(()=>{
        visibleRef.current = (0, $905c53b807de704e$export$2e2bcd8739ae039)(()=>{
            setInnerVisible(visible);
        });
        return ()=>{
            (0, $905c53b807de704e$export$2e2bcd8739ae039).cancel(visibleRef.current);
        };
    }, [
        visible
    ]);
    return /*#__PURE__*/ $cQmXV.createElement((0, $c77226a956f109d7$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        popupClassName: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-popup`, {
            [`${prefixCls}-rtl`]: rtl
        }, popupClassName, rootClassName),
        stretch: mode === "horizontal" ? "minWidth" : null,
        getPopupContainer: getPopupContainer,
        builtinPlacements: placement,
        popupPlacement: popupPlacement,
        popupVisible: innerVisible,
        popup: popup,
        popupStyle: popupStyle,
        popupAlign: popupOffset && {
            offset: popupOffset
        },
        action: disabled ? [] : [
            triggerSubMenuAction
        ],
        mouseEnterDelay: subMenuOpenDelay,
        mouseLeaveDelay: subMenuCloseDelay,
        onPopupVisibleChange: onVisibleChange,
        forceRender: forceSubMenuRender,
        popupMotion: mergedMotion,
        fresh: true
    }, children);
}







var $cQmXV = parcelRequire("cQmXV");




function $645ae1b84de0e71e$var$_extends() {
    $645ae1b84de0e71e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $645ae1b84de0e71e$var$_extends.apply(this, arguments);
}
function $645ae1b84de0e71e$export$2e2bcd8739ae039({ id: id, open: open, keyPath: keyPath, children: children }) {
    const fixedMode = "inline";
    const { prefixCls: prefixCls, forceSubMenuRender: forceSubMenuRender, motion: motion, defaultMotions: defaultMotions, mode: mode } = $cQmXV.useContext((0, $1045c7350ff5831e$export$c7e742effb1c51e2));
    // Always use latest mode check
    const sameModeRef = $cQmXV.useRef(false);
    sameModeRef.current = mode === fixedMode;
    // We record `destroy` mark here since when mode change from `inline` to others.
    // The inline list should remove when motion end.
    const [destroy, setDestroy] = $cQmXV.useState(!sameModeRef.current);
    const mergedOpen = sameModeRef.current ? open : false;
    // ================================= Effect =================================
    // Reset destroy state when mode change back
    $cQmXV.useEffect(()=>{
        if (sameModeRef.current) setDestroy(false);
    }, [
        mode
    ]);
    // ================================= Render =================================
    const mergedMotion = {
        ...(0, $f6ad46640fbff9b4$export$7b8936ddc277a29a)(fixedMode, motion, defaultMotions)
    };
    // No need appear since nest inlineCollapse changed
    if (keyPath.length > 1) mergedMotion.motionAppear = false;
    // Hide inline list when mode changed and motion end
    const originOnVisibleChanged = mergedMotion.onVisibleChanged;
    mergedMotion.onVisibleChanged = (newVisible)=>{
        if (!sameModeRef.current && !newVisible) setDestroy(true);
        return originOnVisibleChanged?.(newVisible);
    };
    if (destroy) return null;
    return /*#__PURE__*/ $cQmXV.createElement((0, $1045c7350ff5831e$export$2e2bcd8739ae039), {
        mode: fixedMode,
        locked: !sameModeRef.current
    }, /*#__PURE__*/ $cQmXV.createElement((0, $04c53b89814950f8$export$2e2bcd8739ae039), $645ae1b84de0e71e$var$_extends({
        visible: mergedOpen
    }, mergedMotion, {
        forceRender: forceSubMenuRender,
        removeOnLeave: false,
        leavedClassName: `${prefixCls}-hidden`
    }), ({ className: motionClassName, style: motionStyle })=>{
        return /*#__PURE__*/ $cQmXV.createElement((0, $e452e49dc62fd115$export$2e2bcd8739ae039), {
            id: id,
            className: motionClassName,
            style: motionStyle
        }, children);
    }));
}





function $15b59d86bf5e5a20$var$_extends() {
    $15b59d86bf5e5a20$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $15b59d86bf5e5a20$var$_extends.apply(this, arguments);
}
const $15b59d86bf5e5a20$var$InternalSubMenu = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { style: style, className: className, styles: styles, classNames: menuClassNames, title: title, eventKey: eventKey, warnKey: warnKey, disabled: disabled, internalPopupClose: internalPopupClose, children: children, itemIcon: // Icons
    itemIcon, expandIcon: expandIcon, popupClassName: // Popup
    popupClassName, popupOffset: popupOffset, popupStyle: popupStyle, onClick: // Events
    onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTitleClick: onTitleClick, onTitleMouseEnter: onTitleMouseEnter, onTitleMouseLeave: onTitleMouseLeave, popupRender: propsPopupRender, ...restProps } = props;
    const domDataId = (0, $6d545ce41484d312$export$a276eb4e9be640f8)(eventKey);
    const { prefixCls: prefixCls, mode: mode, openKeys: openKeys, // Disabled
    disabled: contextDisabled, overflowDisabled: overflowDisabled, activeKey: // ActiveKey
    activeKey, selectedKeys: // SelectKey
    selectedKeys, // Icon
    itemIcon: contextItemIcon, expandIcon: contextExpandIcon, onItemClick: // Events
    onItemClick, onOpenChange: onOpenChange, onActive: onActive, popupRender: contextPopupRender } = $cQmXV.useContext((0, $1045c7350ff5831e$export$c7e742effb1c51e2));
    const { _internalRenderSubMenuItem: _internalRenderSubMenuItem } = $cQmXV.useContext((0, $9b24ab808f2f22a1$export$2e2bcd8739ae039));
    const { isSubPathKey: isSubPathKey } = $cQmXV.useContext((0, $bf3002d33db0f6a4$export$f0b9e0db98edfa53));
    const connectedPath = (0, $bf3002d33db0f6a4$export$d3d2d0a05677870a)();
    const subMenuPrefixCls = `${prefixCls}-submenu`;
    const mergedDisabled = contextDisabled || disabled;
    const elementRef = $cQmXV.useRef();
    const popupRef = $cQmXV.useRef();
    // ================================ Icon ================================
    const mergedItemIcon = itemIcon ?? contextItemIcon;
    const mergedExpandIcon = expandIcon ?? contextExpandIcon;
    // ================================ Open ================================
    const originOpen = openKeys.includes(eventKey);
    const open = !overflowDisabled && originOpen;
    // =============================== Select ===============================
    const childrenSelected = isSubPathKey(selectedKeys, eventKey);
    // =============================== Active ===============================
    const { active: active, ...activeProps } = (0, $415ed218550fb561$export$2e2bcd8739ae039)(eventKey, mergedDisabled, onTitleMouseEnter, onTitleMouseLeave);
    // Fallback of active check to avoid hover on menu title or disabled item
    const [childrenActive, setChildrenActive] = $cQmXV.useState(false);
    const triggerChildrenActive = (newActive)=>{
        if (!mergedDisabled) setChildrenActive(newActive);
    };
    const onInternalMouseEnter = (domEvent)=>{
        triggerChildrenActive(true);
        onMouseEnter?.({
            key: eventKey,
            domEvent: domEvent
        });
    };
    const onInternalMouseLeave = (domEvent)=>{
        triggerChildrenActive(false);
        onMouseLeave?.({
            key: eventKey,
            domEvent: domEvent
        });
    };
    const mergedActive = $cQmXV.useMemo(()=>{
        if (active) return active;
        if (mode !== "inline") return childrenActive || isSubPathKey([
            activeKey
        ], eventKey);
        return false;
    }, [
        mode,
        active,
        activeKey,
        childrenActive,
        eventKey,
        isSubPathKey
    ]);
    // ========================== DirectionStyle ==========================
    const directionStyle = (0, $3ac43456faca28e6$export$2e2bcd8739ae039)(connectedPath.length);
    // =============================== Events ===============================
    // >>>> Title click
    const onInternalTitleClick = (e)=>{
        // Skip if disabled
        if (mergedDisabled) return;
        onTitleClick?.({
            key: eventKey,
            domEvent: e
        });
        // Trigger open by click when mode is `inline`
        if (mode === "inline") onOpenChange(eventKey, !originOpen);
    };
    // >>>> Context for children click
    const onMergedItemClick = (0, $59dc9f05f734c70e$export$2e2bcd8739ae039)((info)=>{
        onClick?.((0, $b612928d660b51d6$export$e189bcd94b66c1db)(info));
        onItemClick(info);
    });
    // >>>>> Visible change
    const onPopupVisibleChange = (newVisible)=>{
        if (mode !== "inline") onOpenChange(eventKey, newVisible);
    };
    /**
   * Used for accessibility. Helper will focus element without key board.
   * We should manually trigger an active
   */ const onInternalFocus = ()=>{
        onActive(eventKey);
    };
    // =============================== Render ===============================
    const popupId = domDataId && `${domDataId}-popup`;
    const expandIconNode = $cQmXV.useMemo(()=>/*#__PURE__*/ $cQmXV.createElement((0, $24399cdbe47e677d$export$2e2bcd8739ae039), {
            icon: mode !== "horizontal" ? mergedExpandIcon : undefined,
            props: {
                ...props,
                isOpen: open,
                // [Legacy] Not sure why need this mark
                isSubMenu: true
            }
        }, /*#__PURE__*/ $cQmXV.createElement("i", {
            className: `${subMenuPrefixCls}-arrow`
        })), [
        mode,
        mergedExpandIcon,
        props,
        open,
        subMenuPrefixCls
    ]);
    // >>>>> Title
    let titleNode = /*#__PURE__*/ $cQmXV.createElement("div", $15b59d86bf5e5a20$var$_extends({
        role: "menuitem",
        style: directionStyle,
        className: `${subMenuPrefixCls}-title`,
        tabIndex: mergedDisabled ? null : -1,
        ref: elementRef,
        title: typeof title === "string" ? title : null,
        "data-menu-id": overflowDisabled && domDataId ? null : domDataId,
        "aria-expanded": open,
        "aria-haspopup": true,
        "aria-controls": popupId,
        "aria-disabled": mergedDisabled,
        onClick: onInternalTitleClick,
        onFocus: onInternalFocus
    }, activeProps), title, expandIconNode);
    // Cache mode if it change to `inline` which do not have popup motion
    const triggerModeRef = $cQmXV.useRef(mode);
    if (mode !== "inline" && connectedPath.length > 1) triggerModeRef.current = "vertical";
    else triggerModeRef.current = mode;
    const popupContentTriggerMode = triggerModeRef.current;
    const renderPopupContent = $cQmXV.useMemo(()=>{
        const originNode = /*#__PURE__*/ $cQmXV.createElement((0, $1045c7350ff5831e$export$2e2bcd8739ae039), {
            classNames: menuClassNames,
            styles: styles,
            mode: popupContentTriggerMode === "horizontal" ? "vertical" : popupContentTriggerMode
        }, /*#__PURE__*/ $cQmXV.createElement((0, $e452e49dc62fd115$export$2e2bcd8739ae039), {
            id: popupId,
            ref: popupRef
        }, children));
        const mergedPopupRender = propsPopupRender || contextPopupRender;
        if (mergedPopupRender) {
            const node = mergedPopupRender(originNode, {
                item: props,
                keys: connectedPath
            });
            return node;
        }
        return originNode;
    }, [
        propsPopupRender,
        contextPopupRender,
        connectedPath,
        popupId,
        children,
        props,
        popupContentTriggerMode
    ]);
    if (!overflowDisabled) {
        const triggerMode = triggerModeRef.current;
        // Still wrap with Trigger here since we need avoid react re-mount dom node
        // Which makes motion failed
        titleNode = /*#__PURE__*/ $cQmXV.createElement((0, $c6f29864fc708ad8$export$2e2bcd8739ae039), {
            mode: triggerMode,
            prefixCls: subMenuPrefixCls,
            visible: !internalPopupClose && open && mode !== "inline",
            popupClassName: popupClassName,
            popupOffset: popupOffset,
            popupStyle: popupStyle,
            popup: renderPopupContent,
            disabled: mergedDisabled,
            onVisibleChange: onPopupVisibleChange
        }, titleNode);
    }
    // >>>>> List node
    let listNode = /*#__PURE__*/ $cQmXV.createElement((0, $788a6a69bf396d02$export$2e2bcd8739ae039).Item, $15b59d86bf5e5a20$var$_extends({
        ref: ref,
        role: "none"
    }, restProps, {
        component: "li",
        style: style,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(subMenuPrefixCls, `${subMenuPrefixCls}-${mode}`, className, {
            [`${subMenuPrefixCls}-open`]: open,
            [`${subMenuPrefixCls}-active`]: mergedActive,
            [`${subMenuPrefixCls}-selected`]: childrenSelected,
            [`${subMenuPrefixCls}-disabled`]: mergedDisabled
        }),
        onMouseEnter: onInternalMouseEnter,
        onMouseLeave: onInternalMouseLeave
    }), titleNode, !overflowDisabled && /*#__PURE__*/ $cQmXV.createElement((0, $645ae1b84de0e71e$export$2e2bcd8739ae039), {
        id: popupId,
        open: open,
        keyPath: connectedPath
    }, children));
    if (_internalRenderSubMenuItem) listNode = _internalRenderSubMenuItem(listNode, props, {
        selected: childrenSelected,
        active: mergedActive,
        open: open,
        disabled: mergedDisabled
    });
    // >>>>> Render
    return /*#__PURE__*/ $cQmXV.createElement((0, $1045c7350ff5831e$export$2e2bcd8739ae039), {
        classNames: menuClassNames,
        styles: styles,
        onItemClick: onMergedItemClick,
        mode: mode === "horizontal" ? "vertical" : mode,
        itemIcon: mergedItemIcon,
        expandIcon: mergedExpandIcon
    }, listNode);
});
const $15b59d86bf5e5a20$var$SubMenu = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { eventKey: eventKey, children: children } = props;
    const connectedKeyPath = (0, $bf3002d33db0f6a4$export$d3d2d0a05677870a)(eventKey);
    const childList = (0, $a3071810dba204a1$export$cd230e97e668be9)(children, connectedKeyPath);
    // ==================== Record KeyPath ====================
    const measure = (0, $bf3002d33db0f6a4$export$e295b0c537d32d7d)();
    // eslint-disable-next-line consistent-return
    $cQmXV.useEffect(()=>{
        if (measure) {
            measure.registerPath(eventKey, connectedKeyPath);
            return ()=>{
                measure.unregisterPath(eventKey, connectedKeyPath);
            };
        }
    }, [
        connectedKeyPath
    ]);
    let renderNode;
    // ======================== Render ========================
    if (measure) renderNode = childList;
    else renderNode = /*#__PURE__*/ $cQmXV.createElement($15b59d86bf5e5a20$var$InternalSubMenu, $15b59d86bf5e5a20$var$_extends({
        ref: ref
    }, props), childList);
    return /*#__PURE__*/ $cQmXV.createElement((0, $bf3002d33db0f6a4$export$54d9e16aa4c8a7fa).Provider, {
        value: connectedKeyPath
    }, renderNode);
});
var $15b59d86bf5e5a20$export$2e2bcd8739ae039 = $15b59d86bf5e5a20$var$SubMenu;



var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");



function $e7f817772278445a$export$2e2bcd8739ae039({ className: className, style: style }) {
    const { prefixCls: prefixCls } = $cQmXV.useContext((0, $1045c7350ff5831e$export$c7e742effb1c51e2));
    const measure = (0, $bf3002d33db0f6a4$export$e295b0c537d32d7d)();
    if (measure) return null;
    return /*#__PURE__*/ $cQmXV.createElement("li", {
        role: "separator",
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-item-divider`, className),
        style: style
    });
}






var $cQmXV = parcelRequire("cQmXV");



function $6a91e202943b1752$var$_extends() {
    $6a91e202943b1752$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6a91e202943b1752$var$_extends.apply(this, arguments);
}
const $6a91e202943b1752$var$InternalMenuItemGroup = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { className: className, title: title, eventKey: eventKey, children: children, ...restProps } = props;
    const { prefixCls: prefixCls, classNames: menuClassNames, styles: styles } = $cQmXV.useContext((0, $1045c7350ff5831e$export$c7e742effb1c51e2));
    const groupPrefixCls = `${prefixCls}-item-group`;
    return /*#__PURE__*/ $cQmXV.createElement("li", $6a91e202943b1752$var$_extends({
        ref: ref,
        role: "presentation"
    }, restProps, {
        onClick: (e)=>e.stopPropagation(),
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(groupPrefixCls, className)
    }), /*#__PURE__*/ $cQmXV.createElement("div", {
        role: "presentation",
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${groupPrefixCls}-title`, menuClassNames?.listTitle),
        style: styles?.listTitle,
        title: typeof title === "string" ? title : undefined
    }, title), /*#__PURE__*/ $cQmXV.createElement("ul", {
        role: "group",
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${groupPrefixCls}-list`, menuClassNames?.list),
        style: styles?.list
    }, children));
});
const $6a91e202943b1752$var$MenuItemGroup = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { eventKey: eventKey, children: children } = props;
    const connectedKeyPath = (0, $bf3002d33db0f6a4$export$d3d2d0a05677870a)(eventKey);
    const childList = (0, $a3071810dba204a1$export$cd230e97e668be9)(children, connectedKeyPath);
    const measure = (0, $bf3002d33db0f6a4$export$e295b0c537d32d7d)();
    if (measure) return childList;
    return /*#__PURE__*/ $cQmXV.createElement($6a91e202943b1752$var$InternalMenuItemGroup, $6a91e202943b1752$var$_extends({
        ref: ref
    }, (0, $e8c5093aebad6025$export$2e2bcd8739ae039)(props, [
        "warnKey"
    ])), childList);
});
var $6a91e202943b1752$export$2e2bcd8739ae039 = $6a91e202943b1752$var$MenuItemGroup;




function $d2f9c2d02f06af44$var$_extends() {
    $d2f9c2d02f06af44$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d2f9c2d02f06af44$var$_extends.apply(this, arguments);
}
function $d2f9c2d02f06af44$var$convertItemsToNodes(list, components, prefixCls) {
    const { item: MergedMenuItem, group: MergedMenuItemGroup, submenu: MergedSubMenu, divider: MergedDivider } = components;
    return (list || []).map((opt, index)=>{
        if (opt && typeof opt === "object") {
            const { label: label, children: children, key: key, type: type, extra: extra, ...restProps } = opt;
            const mergedKey = key ?? `tmp-${index}`;
            // MenuItemGroup & SubMenuItem
            if (children || type === "group") {
                if (type === "group") // Group
                return /*#__PURE__*/ $cQmXV.createElement(MergedMenuItemGroup, $d2f9c2d02f06af44$var$_extends({
                    key: mergedKey
                }, restProps, {
                    title: label
                }), $d2f9c2d02f06af44$var$convertItemsToNodes(children, components, prefixCls));
                // Sub Menu
                return /*#__PURE__*/ $cQmXV.createElement(MergedSubMenu, $d2f9c2d02f06af44$var$_extends({
                    key: mergedKey
                }, restProps, {
                    title: label
                }), $d2f9c2d02f06af44$var$convertItemsToNodes(children, components, prefixCls));
            }
            // MenuItem & Divider
            if (type === "divider") return /*#__PURE__*/ $cQmXV.createElement(MergedDivider, $d2f9c2d02f06af44$var$_extends({
                key: mergedKey
            }, restProps));
            const hasExtra = !!extra || extra === 0;
            return /*#__PURE__*/ $cQmXV.createElement(MergedMenuItem, $d2f9c2d02f06af44$var$_extends({
                key: mergedKey
            }, restProps, {
                extra: extra,
                itemData: {
                    ...opt,
                    key: mergedKey
                }
            }), hasExtra ? /*#__PURE__*/ $cQmXV.createElement($cQmXV.Fragment, null, /*#__PURE__*/ $cQmXV.createElement("span", {
                className: `${prefixCls}-item-label`
            }, label), /*#__PURE__*/ $cQmXV.createElement("span", {
                className: `${prefixCls}-item-extra`
            }, extra)) : label);
        }
        return null;
    }).filter((opt)=>opt);
}
function $d2f9c2d02f06af44$export$50458dc1a9a0f894(children, items, keyPath, components, prefixCls) {
    let childNodes = children;
    const mergedComponents = {
        divider: (0, $e7f817772278445a$export$2e2bcd8739ae039),
        item: (0, $dc497472bf4ea988$export$2e2bcd8739ae039),
        group: (0, $6a91e202943b1752$export$2e2bcd8739ae039),
        submenu: (0, $15b59d86bf5e5a20$export$2e2bcd8739ae039),
        ...components
    };
    if (items) childNodes = $d2f9c2d02f06af44$var$convertItemsToNodes(items, mergedComponents, prefixCls);
    return (0, $a3071810dba204a1$export$cd230e97e668be9)(childNodes, keyPath);
}



function $0b014c4900dc7f25$var$_extends() {
    $0b014c4900dc7f25$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0b014c4900dc7f25$var$_extends.apply(this, arguments);
}
/**
 * Menu modify after refactor:
 * ## Add
 * - disabled
 *
 * ## Remove
 * - openTransitionName
 * - openAnimation
 * - onDestroy
 * - siderCollapsed: Seems antd do not use this prop (Need test in antd)
 * - collapsedWidth: Seems this logic should be handle by antd Layout.Sider
 */ // optimize for render
const $0b014c4900dc7f25$var$EMPTY_LIST = [];
const $0b014c4900dc7f25$var$Menu = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { prefixCls: prefixCls = "rc-menu", rootClassName: rootClassName, style: style, className: className, styles: styles, classNames: menuClassNames, tabIndex: tabIndex = 0, items: items, children: children, direction: direction, id: id, mode: // Mode
    mode = "vertical", inlineCollapsed: inlineCollapsed, disabled: // Disabled
    disabled, disabledOverflow: disabledOverflow, subMenuOpenDelay: // Open
    subMenuOpenDelay = 0.1, subMenuCloseDelay: subMenuCloseDelay = 0.1, forceSubMenuRender: forceSubMenuRender, defaultOpenKeys: defaultOpenKeys, openKeys: openKeys, activeKey: // Active
    activeKey, defaultActiveFirst: defaultActiveFirst, selectable: // Selection
    selectable = true, multiple: multiple = false, defaultSelectedKeys: defaultSelectedKeys, selectedKeys: selectedKeys, onSelect: onSelect, onDeselect: onDeselect, inlineIndent: // Level
    inlineIndent = 24, motion: // Motion
    motion, defaultMotions: defaultMotions, triggerSubMenuAction: // Popup
    triggerSubMenuAction = "hover", builtinPlacements: builtinPlacements, itemIcon: // Icon
    itemIcon, expandIcon: expandIcon, overflowedIndicator: overflowedIndicator = "...", overflowedIndicatorPopupClassName: overflowedIndicatorPopupClassName, getPopupContainer: // Function
    getPopupContainer, onClick: // Events
    onClick, onOpenChange: onOpenChange, onKeyDown: onKeyDown, openAnimation: // Deprecated
    openAnimation, openTransitionName: openTransitionName, _internalRenderMenuItem: // Internal
    _internalRenderMenuItem, _internalRenderSubMenuItem: _internalRenderSubMenuItem, _internalComponents: _internalComponents, popupRender: popupRender, ...restProps } = props;
    const [childList, measureChildList] = $cQmXV.useMemo(()=>[
            (0, $d2f9c2d02f06af44$export$50458dc1a9a0f894)(children, items, $0b014c4900dc7f25$var$EMPTY_LIST, _internalComponents, prefixCls),
            (0, $d2f9c2d02f06af44$export$50458dc1a9a0f894)(children, items, $0b014c4900dc7f25$var$EMPTY_LIST, {}, prefixCls)
        ], [
        children,
        items,
        _internalComponents
    ]);
    const [mounted, setMounted] = $cQmXV.useState(false);
    const containerRef = $cQmXV.useRef();
    const uuid = (0, $a2da91bb60e2cbfb$export$2e2bcd8739ae039)(id ? `rc-menu-uuid-${id}` : "rc-menu-uuid");
    const isRtl = direction === "rtl";
    // ========================= Open =========================
    const [innerOpenKeys, setMergedOpenKeys] = (0, $a51866d781137e08$export$2e2bcd8739ae039)(defaultOpenKeys, openKeys);
    const mergedOpenKeys = innerOpenKeys || $0b014c4900dc7f25$var$EMPTY_LIST;
    // React 18 will merge mouse event which means we open key will not sync
    // ref: https://github.com/ant-design/ant-design/issues/38818
    const triggerOpenKeys = (keys, forceFlush = false)=>{
        function doUpdate() {
            setMergedOpenKeys(keys);
            onOpenChange?.(keys);
        }
        if (forceFlush) (0, $3h5eW.flushSync)(doUpdate);
        else doUpdate();
    };
    // >>>>> Cache & Reset open keys when inlineCollapsed changed
    const [inlineCacheOpenKeys, setInlineCacheOpenKeys] = $cQmXV.useState(mergedOpenKeys);
    const mountRef = $cQmXV.useRef(false);
    // ========================= Mode =========================
    const [mergedMode, mergedInlineCollapsed] = $cQmXV.useMemo(()=>{
        if ((mode === "inline" || mode === "vertical") && inlineCollapsed) return [
            "vertical",
            inlineCollapsed
        ];
        return [
            mode,
            false
        ];
    }, [
        mode,
        inlineCollapsed
    ]);
    const isInlineMode = mergedMode === "inline";
    const [internalMode, setInternalMode] = $cQmXV.useState(mergedMode);
    const [internalInlineCollapsed, setInternalInlineCollapsed] = $cQmXV.useState(mergedInlineCollapsed);
    $cQmXV.useEffect(()=>{
        setInternalMode(mergedMode);
        setInternalInlineCollapsed(mergedInlineCollapsed);
        if (!mountRef.current) return;
        // Synchronously update MergedOpenKeys
        if (isInlineMode) setMergedOpenKeys(inlineCacheOpenKeys);
        else // Trigger open event in case its in control
        triggerOpenKeys($0b014c4900dc7f25$var$EMPTY_LIST);
    }, [
        mergedMode,
        mergedInlineCollapsed
    ]);
    // ====================== Responsive ======================
    const [lastVisibleIndex, setLastVisibleIndex] = $cQmXV.useState(0);
    const allVisible = lastVisibleIndex >= childList.length - 1 || internalMode !== "horizontal" || disabledOverflow;
    // Cache
    $cQmXV.useEffect(()=>{
        if (isInlineMode) setInlineCacheOpenKeys(mergedOpenKeys);
    }, [
        mergedOpenKeys
    ]);
    $cQmXV.useEffect(()=>{
        mountRef.current = true;
        return ()=>{
            mountRef.current = false;
        };
    }, []);
    // ========================= Path =========================
    const { registerPath: registerPath, unregisterPath: unregisterPath, refreshOverflowKeys: refreshOverflowKeys, isSubPathKey: isSubPathKey, getKeyPath: getKeyPath, getKeys: getKeys, getSubPathKeys: getSubPathKeys } = (0, $9e1d79d9752eccf7$export$2e2bcd8739ae039)();
    const registerPathContext = $cQmXV.useMemo(()=>({
            registerPath: registerPath,
            unregisterPath: unregisterPath
        }), [
        registerPath,
        unregisterPath
    ]);
    const pathUserContext = $cQmXV.useMemo(()=>({
            isSubPathKey: isSubPathKey
        }), [
        isSubPathKey
    ]);
    $cQmXV.useEffect(()=>{
        refreshOverflowKeys(allVisible ? $0b014c4900dc7f25$var$EMPTY_LIST : childList.slice(lastVisibleIndex + 1).map((child)=>child.key));
    }, [
        lastVisibleIndex,
        allVisible
    ]);
    // ======================== Active ========================
    const [mergedActiveKey, setMergedActiveKey] = (0, $a51866d781137e08$export$2e2bcd8739ae039)(activeKey || defaultActiveFirst && childList[0]?.key, activeKey);
    const onActive = (0, $59dc9f05f734c70e$export$2e2bcd8739ae039)((key)=>{
        setMergedActiveKey(key);
    });
    const onInactive = (0, $59dc9f05f734c70e$export$2e2bcd8739ae039)(()=>{
        setMergedActiveKey(undefined);
    });
    (0, $cQmXV.useImperativeHandle)(ref, ()=>{
        return {
            list: containerRef.current,
            focus: (options)=>{
                const keys = getKeys();
                const { elements: elements, key2element: key2element, element2key: element2key } = (0, $e0147216e3c8903c$export$20827b68c762d23)(keys, uuid);
                const focusableElements = (0, $e0147216e3c8903c$export$433aaa1f216cf32d)(containerRef.current, elements);
                let shouldFocusKey;
                if (mergedActiveKey && keys.includes(mergedActiveKey)) shouldFocusKey = mergedActiveKey;
                else shouldFocusKey = focusableElements[0] ? element2key.get(focusableElements[0]) : childList.find((node)=>!node.props.disabled)?.key;
                const elementToFocus = key2element.get(shouldFocusKey);
                if (shouldFocusKey && elementToFocus) elementToFocus?.focus?.(options);
            },
            findItem: ({ key: itemKey })=>{
                const keys = getKeys();
                const { key2element: key2element } = (0, $e0147216e3c8903c$export$20827b68c762d23)(keys, uuid);
                return key2element.get(itemKey) || null;
            }
        };
    });
    // ======================== Select ========================
    // >>>>> Select keys
    const [internalSelectKeys, setMergedSelectKeys] = (0, $a51866d781137e08$export$2e2bcd8739ae039)(defaultSelectedKeys || [], selectedKeys);
    const mergedSelectKeys = $cQmXV.useMemo(()=>{
        if (Array.isArray(internalSelectKeys)) return internalSelectKeys;
        if (internalSelectKeys === null || internalSelectKeys === undefined) return $0b014c4900dc7f25$var$EMPTY_LIST;
        return [
            internalSelectKeys
        ];
    }, [
        internalSelectKeys
    ]);
    // >>>>> Trigger select
    const triggerSelection = (info)=>{
        if (selectable) {
            // Insert or Remove
            const { key: targetKey } = info;
            const exist = mergedSelectKeys.includes(targetKey);
            let newSelectKeys;
            if (multiple) {
                if (exist) newSelectKeys = mergedSelectKeys.filter((key)=>key !== targetKey);
                else newSelectKeys = [
                    ...mergedSelectKeys,
                    targetKey
                ];
            } else newSelectKeys = [
                targetKey
            ];
            setMergedSelectKeys(newSelectKeys);
            // Trigger event
            const selectInfo = {
                ...info,
                selectedKeys: newSelectKeys
            };
            if (exist) onDeselect?.(selectInfo);
            else onSelect?.(selectInfo);
        }
        // Whatever selectable, always close it
        if (!multiple && mergedOpenKeys.length && internalMode !== "inline") triggerOpenKeys($0b014c4900dc7f25$var$EMPTY_LIST);
    };
    // ========================= Open =========================
    /**
   * Click for item. SubMenu do not have selection status
   */ const onInternalClick = (0, $59dc9f05f734c70e$export$2e2bcd8739ae039)((info)=>{
        onClick?.((0, $b612928d660b51d6$export$e189bcd94b66c1db)(info));
        triggerSelection(info);
    });
    const onInternalOpenChange = (0, $59dc9f05f734c70e$export$2e2bcd8739ae039)((key, open)=>{
        let newOpenKeys = mergedOpenKeys.filter((k)=>k !== key);
        if (open) newOpenKeys.push(key);
        else if (internalMode !== "inline") {
            // We need find all related popup to close
            const subPathKeys = getSubPathKeys(key);
            newOpenKeys = newOpenKeys.filter((k)=>!subPathKeys.has(k));
        }
        if (!(0, $3f19ee2a2ff4618a$export$2e2bcd8739ae039)(mergedOpenKeys, newOpenKeys, true)) triggerOpenKeys(newOpenKeys, true);
    });
    // ==================== Accessibility =====================
    const triggerAccessibilityOpen = (key, open)=>{
        const nextOpen = open ?? !mergedOpenKeys.includes(key);
        onInternalOpenChange(key, nextOpen);
    };
    const onInternalKeyDown = (0, $e0147216e3c8903c$export$aa6de64279d64603)(internalMode, mergedActiveKey, isRtl, uuid, containerRef, getKeys, getKeyPath, setMergedActiveKey, triggerAccessibilityOpen, onKeyDown);
    // ======================== Effect ========================
    $cQmXV.useEffect(()=>{
        setMounted(true);
    }, []);
    // ======================= Context ========================
    const privateContext = $cQmXV.useMemo(()=>({
            _internalRenderMenuItem: _internalRenderMenuItem,
            _internalRenderSubMenuItem: _internalRenderSubMenuItem
        }), [
        _internalRenderMenuItem,
        _internalRenderSubMenuItem
    ]);
    // ======================== Render ========================
    // >>>>> Children
    const wrappedChildList = internalMode !== "horizontal" || disabledOverflow ? childList : // Need wrap for overflow dropdown that do not response for open
    childList.map((child, index)=>/*#__PURE__*/ // Always wrap provider to avoid sub node re-mount
        $cQmXV.createElement((0, $1045c7350ff5831e$export$2e2bcd8739ae039), {
            key: child.key,
            overflowDisabled: index > lastVisibleIndex,
            classNames: menuClassNames,
            styles: styles
        }, child));
    // >>>>> Container
    const container = /*#__PURE__*/ $cQmXV.createElement((0, $788a6a69bf396d02$export$2e2bcd8739ae039), $0b014c4900dc7f25$var$_extends({
        id: id,
        ref: containerRef,
        prefixCls: `${prefixCls}-overflow`,
        component: "ul",
        itemComponent: (0, $dc497472bf4ea988$export$2e2bcd8739ae039),
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-root`, `${prefixCls}-${internalMode}`, className, {
            [`${prefixCls}-inline-collapsed`]: internalInlineCollapsed,
            [`${prefixCls}-rtl`]: isRtl
        }, rootClassName),
        dir: direction,
        style: style,
        role: "menu",
        tabIndex: tabIndex,
        data: wrappedChildList,
        renderRawItem: (node)=>node,
        renderRawRest: (omitItems)=>{
            // We use origin list since wrapped list use context to prevent open
            const len = omitItems.length;
            const originOmitItems = len ? childList.slice(-len) : null;
            return /*#__PURE__*/ $cQmXV.createElement((0, $15b59d86bf5e5a20$export$2e2bcd8739ae039), {
                eventKey: (0, $9e1d79d9752eccf7$export$20a0132c46ce5b04),
                title: overflowedIndicator,
                disabled: allVisible,
                internalPopupClose: len === 0,
                popupClassName: overflowedIndicatorPopupClassName
            }, originOmitItems);
        },
        maxCount: internalMode !== "horizontal" || disabledOverflow ? (0, $788a6a69bf396d02$export$2e2bcd8739ae039).INVALIDATE : (0, $788a6a69bf396d02$export$2e2bcd8739ae039).RESPONSIVE,
        ssr: "full",
        "data-menu-list": true,
        onVisibleChange: (newLastIndex)=>{
            setLastVisibleIndex(newLastIndex);
        },
        onKeyDown: onInternalKeyDown
    }, restProps));
    // >>>>> Render
    return /*#__PURE__*/ $cQmXV.createElement((0, $9b24ab808f2f22a1$export$2e2bcd8739ae039).Provider, {
        value: privateContext
    }, /*#__PURE__*/ $cQmXV.createElement((0, $6d545ce41484d312$export$26537912ea160acd).Provider, {
        value: uuid
    }, /*#__PURE__*/ $cQmXV.createElement((0, $1045c7350ff5831e$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        rootClassName: rootClassName,
        classNames: menuClassNames,
        styles: styles,
        mode: internalMode,
        openKeys: mergedOpenKeys,
        rtl: isRtl,
        disabled: disabled,
        motion: mounted ? motion : null,
        defaultMotions: mounted ? defaultMotions : null,
        activeKey: mergedActiveKey,
        onActive: onActive,
        onInactive: onInactive,
        selectedKeys: mergedSelectKeys,
        inlineIndent: inlineIndent,
        subMenuOpenDelay: subMenuOpenDelay,
        subMenuCloseDelay: subMenuCloseDelay,
        forceSubMenuRender: forceSubMenuRender,
        builtinPlacements: builtinPlacements,
        triggerSubMenuAction: triggerSubMenuAction,
        getPopupContainer: getPopupContainer,
        itemIcon: itemIcon,
        expandIcon: expandIcon,
        onItemClick: onInternalClick,
        onOpenChange: onInternalOpenChange,
        popupRender: popupRender
    }, /*#__PURE__*/ $cQmXV.createElement((0, $bf3002d33db0f6a4$export$f0b9e0db98edfa53).Provider, {
        value: pathUserContext
    }, container), /*#__PURE__*/ $cQmXV.createElement("div", {
        style: {
            display: "none"
        },
        "aria-hidden": true
    }, /*#__PURE__*/ $cQmXV.createElement((0, $bf3002d33db0f6a4$export$d9ffb5bfd108b003).Provider, {
        value: registerPathContext
    }, measureChildList)))));
});
var $0b014c4900dc7f25$export$2e2bcd8739ae039 = $0b014c4900dc7f25$var$Menu;







const $f2204382bfad12ac$var$ExportMenu = (0, $0b014c4900dc7f25$export$2e2bcd8739ae039);
$f2204382bfad12ac$var$ExportMenu.Item = (0, $dc497472bf4ea988$export$2e2bcd8739ae039);
$f2204382bfad12ac$var$ExportMenu.SubMenu = (0, $15b59d86bf5e5a20$export$2e2bcd8739ae039);
$f2204382bfad12ac$var$ExportMenu.ItemGroup = (0, $6a91e202943b1752$export$2e2bcd8739ae039);
$f2204382bfad12ac$var$ExportMenu.Divider = (0, $e7f817772278445a$export$2e2bcd8739ae039);
var $f2204382bfad12ac$export$2e2bcd8739ae039 = $f2204382bfad12ac$var$ExportMenu;



var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");
var $3ccb35aaecb71abd$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($3ccb35aaecb71abd$exports, "__esModule", {
    value: true
});
var $3ccb35aaecb71abd$var$BarsOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0z"
                }
            }
        ]
    },
    "name": "bars",
    "theme": "outlined"
};
$3ccb35aaecb71abd$exports.default = $3ccb35aaecb71abd$var$BarsOutlined;



function $f5d22ea5da469466$var$_extends() {
    $f5d22ea5da469466$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f5d22ea5da469466$var$_extends.apply(this, arguments);
}
const $f5d22ea5da469466$var$BarsOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $f5d22ea5da469466$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3ccb35aaecb71abd$exports)))
    }));
/**![bars](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkxMiAxOTJIMzI4Yy00LjQgMC04IDMuNi04IDh2NTZjMCA0LjQgMy42IDggOCA4aDU4NGM0LjQgMCA4LTMuNiA4LTh2LTU2YzAtNC40LTMuNi04LTgtOHptMCAyODRIMzI4Yy00LjQgMC04IDMuNi04IDh2NTZjMCA0LjQgMy42IDggOCA4aDU4NGM0LjQgMCA4LTMuNiA4LTh2LTU2YzAtNC40LTMuNi04LTgtOHptMCAyODRIMzI4Yy00LjQgMC04IDMuNi04IDh2NTZjMCA0LjQgMy42IDggOCA4aDU4NGM0LjQgMCA4LTMuNiA4LTh2LTU2YzAtNC40LTMuNi04LTgtOHpNMTA0IDIyOGE1NiA1NiAwIDEwMTEyIDAgNTYgNTYgMCAxMC0xMTIgMHptMCAyODRhNTYgNTYgMCAxMDExMiAwIDU2IDU2IDAgMTAtMTEyIDB6bTAgMjg0YTU2IDU2IDAgMTAxMTIgMCA1NiA1NiAwIDEwLTExMiAweiIgLz48L3N2Zz4=) */ const $f5d22ea5da469466$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($f5d22ea5da469466$var$BarsOutlined);
var $f5d22ea5da469466$export$2e2bcd8739ae039 = $f5d22ea5da469466$var$RefIcon;










var $cQmXV = parcelRequire("cQmXV");
const $fd5abfa53e539244$export$964282a2c3979546 = /*#__PURE__*/ $cQmXV.createContext({
    siderHook: {
        addSider: ()=>null,
        removeSider: ()=>null
    }
});





const $d544f3549ac64d89$var$genLayoutStyle = (token)=>{
    const { antCls: antCls, componentCls: // .ant
    componentCls, colorText: // .ant-layout
    colorText, footerBg: footerBg, headerHeight: headerHeight, headerPadding: headerPadding, headerColor: headerColor, footerPadding: footerPadding, fontSize: fontSize, bodyBg: bodyBg, headerBg: headerBg } = token;
    return {
        [componentCls]: {
            display: "flex",
            flex: "auto",
            flexDirection: "column",
            /* fix firefox can't set height smaller than content on flex item */ minHeight: 0,
            background: bodyBg,
            "&, *": {
                boxSizing: "border-box"
            },
            [`&${componentCls}-has-sider`]: {
                flexDirection: "row",
                [`> ${componentCls}, > ${componentCls}-content`]: {
                    // https://segmentfault.com/a/1190000019498300
                    width: 0
                }
            },
            [`${componentCls}-header, &${componentCls}-footer`]: {
                flex: "0 0 auto"
            },
            // RTL
            "&-rtl": {
                direction: "rtl"
            }
        },
        // ==================== Header ====================
        [`${componentCls}-header`]: {
            height: headerHeight,
            padding: headerPadding,
            color: headerColor,
            lineHeight: (0, $05f34ed03d41967d$export$523c0b569236b342)(headerHeight),
            background: headerBg,
            // Other components/menu/style/index.less line:686
            // Integration with header element so menu items have the same height
            [`${antCls}-menu`]: {
                lineHeight: "inherit"
            }
        },
        // ==================== Footer ====================
        [`${componentCls}-footer`]: {
            padding: footerPadding,
            color: colorText,
            fontSize: fontSize,
            background: footerBg
        },
        // =================== Content ====================
        [`${componentCls}-content`]: {
            flex: "auto",
            color: colorText,
            // fix firefox can't set height smaller than content on flex item
            minHeight: 0
        }
    };
};
const $d544f3549ac64d89$export$9ca1be8807fe0675 = (token)=>{
    const { colorBgLayout: colorBgLayout, controlHeight: controlHeight, controlHeightLG: controlHeightLG, colorText: colorText, controlHeightSM: controlHeightSM, marginXXS: marginXXS, colorTextLightSolid: colorTextLightSolid, colorBgContainer: colorBgContainer } = token;
    const paddingInline = controlHeightLG * 1.25;
    return {
        // Deprecated
        colorBgHeader: "#001529",
        colorBgBody: colorBgLayout,
        colorBgTrigger: "#002140",
        bodyBg: colorBgLayout,
        headerBg: "#001529",
        headerHeight: controlHeight * 2,
        headerPadding: `0 ${paddingInline}px`,
        headerColor: colorText,
        footerPadding: `${controlHeightSM}px ${paddingInline}px`,
        footerBg: colorBgLayout,
        siderBg: "#001529",
        triggerHeight: controlHeightLG + marginXXS * 2,
        triggerBg: "#002140",
        triggerColor: colorTextLightSolid,
        zeroTriggerWidth: controlHeightLG,
        zeroTriggerHeight: controlHeightLG,
        lightSiderBg: colorBgContainer,
        lightTriggerBg: colorBgContainer,
        lightTriggerColor: colorText
    };
};
const $d544f3549ac64d89$export$da0be9ab56e785fc = [
    [
        "colorBgBody",
        "bodyBg"
    ],
    [
        "colorBgHeader",
        "headerBg"
    ],
    [
        "colorBgTrigger",
        "triggerBg"
    ]
];
var $d544f3549ac64d89$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$51ec95de45185b42)("Layout", $d544f3549ac64d89$var$genLayoutStyle, $d544f3549ac64d89$export$9ca1be8807fe0675, {
    deprecatedTokens: $d544f3549ac64d89$export$da0be9ab56e785fc
});



const $b2603108fcc01410$var$genSiderStyle = (token)=>{
    const { componentCls: componentCls, siderBg: siderBg, motionDurationMid: motionDurationMid, motionDurationSlow: motionDurationSlow, antCls: antCls, triggerHeight: triggerHeight, triggerColor: triggerColor, triggerBg: triggerBg, headerHeight: headerHeight, zeroTriggerWidth: zeroTriggerWidth, zeroTriggerHeight: zeroTriggerHeight, borderRadiusLG: borderRadiusLG, lightSiderBg: lightSiderBg, lightTriggerColor: lightTriggerColor, lightTriggerBg: lightTriggerBg, bodyBg: bodyBg } = token;
    return {
        [componentCls]: {
            position: "relative",
            // fix firefox can't set width smaller than content on flex item
            minWidth: 0,
            background: siderBg,
            transition: `all ${motionDurationMid}, background 0s`,
            "&-has-trigger": {
                paddingBottom: triggerHeight
            },
            "&-right": {
                order: 1
            },
            [`${componentCls}-children`]: {
                height: "100%",
                // Hack for fixing margin collapse bug
                // https://github.com/ant-design/ant-design/issues/7967
                // solution from https://stackoverflow.com/a/33132624/3040605
                marginTop: -0.1,
                paddingTop: 0.1,
                [`${antCls}-menu${antCls}-menu-inline-collapsed`]: {
                    width: "auto"
                }
            },
            [`&-zero-width ${componentCls}-children`]: {
                overflow: "hidden"
            },
            [`${componentCls}-trigger`]: {
                position: "fixed",
                bottom: 0,
                zIndex: 1,
                height: triggerHeight,
                color: triggerColor,
                lineHeight: (0, $05f34ed03d41967d$export$523c0b569236b342)(triggerHeight),
                textAlign: "center",
                background: triggerBg,
                cursor: "pointer",
                transition: `all ${motionDurationMid}`
            },
            [`${componentCls}-zero-width-trigger`]: {
                position: "absolute",
                top: headerHeight,
                insetInlineEnd: token.calc(zeroTriggerWidth).mul(-1).equal(),
                zIndex: 1,
                width: zeroTriggerWidth,
                height: zeroTriggerHeight,
                color: triggerColor,
                fontSize: token.fontSizeXL,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: siderBg,
                borderRadius: `0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(borderRadiusLG)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(borderRadiusLG)} 0`,
                cursor: "pointer",
                transition: `background-color ${motionDurationSlow} ease`,
                "&::after": {
                    position: "absolute",
                    inset: 0,
                    background: "transparent",
                    transition: `all ${motionDurationSlow}`,
                    content: '""'
                },
                "&:hover::after": {
                    background: `rgba(255, 255, 255, 0.2)`
                },
                "&-right": {
                    insetInlineStart: token.calc(zeroTriggerWidth).mul(-1).equal(),
                    borderRadius: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(borderRadiusLG)} 0 0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(borderRadiusLG)}`
                }
            },
            // Light
            "&-light": {
                background: lightSiderBg,
                [`${componentCls}-trigger`]: {
                    color: lightTriggerColor,
                    background: lightTriggerBg
                },
                [`${componentCls}-zero-width-trigger`]: {
                    color: lightTriggerColor,
                    background: lightTriggerBg,
                    border: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${bodyBg}`,
                    // Safe to modify to any other color
                    borderInlineStart: 0
                }
            }
        }
    };
};
var $b2603108fcc01410$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$51ec95de45185b42)([
    "Layout",
    "Sider"
], $b2603108fcc01410$var$genSiderStyle, (0, $d544f3549ac64d89$export$9ca1be8807fe0675), {
    deprecatedTokens: (0, $d544f3549ac64d89$export$da0be9ab56e785fc)
});


"use client";
const $89ef2fa4f6587b8b$var$dimensionMaxMap = {
    xs: "479.98px",
    sm: "575.98px",
    md: "767.98px",
    lg: "991.98px",
    xl: "1199.98px",
    xxl: "1599.98px",
    xxxl: `1839.98px`
};
const $89ef2fa4f6587b8b$var$isNumeric = (val)=>!Number.isNaN(Number.parseFloat(val)) && Number.isFinite(Number(val));
const $89ef2fa4f6587b8b$export$63554aebd2a6d54c = /*#__PURE__*/ $cQmXV.createContext({});
const $89ef2fa4f6587b8b$var$generateId = (()=>{
    let i = 0;
    return (prefix = "")=>{
        i += 1;
        return `${prefix}${i}`;
    };
})();
const $89ef2fa4f6587b8b$var$Sider = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, className: className, trigger: trigger, children: children, defaultCollapsed: defaultCollapsed = false, theme: theme = "dark", style: style = {}, collapsible: collapsible = false, reverseArrow: reverseArrow = false, width: width = 200, collapsedWidth: collapsedWidth = 80, zeroWidthTriggerStyle: zeroWidthTriggerStyle, breakpoint: breakpoint, onCollapse: onCollapse, onBreakpoint: onBreakpoint, classNames: classNames, styles: styles, ...otherProps } = props;
    const { siderHook: siderHook } = (0, $cQmXV.useContext)((0, $fd5abfa53e539244$export$964282a2c3979546));
    const [collapsed, setCollapsed] = (0, $cQmXV.useState)("collapsed" in props ? props.collapsed : defaultCollapsed);
    const [below, setBelow] = (0, $cQmXV.useState)(false);
    (0, $cQmXV.useEffect)(()=>{
        if ("collapsed" in props) setCollapsed(props.collapsed);
    }, [
        props.collapsed
    ]);
    const handleSetCollapsed = (value, type)=>{
        if (!("collapsed" in props)) setCollapsed(value);
        onCollapse?.(value, type);
    };
    const semanticProps = {
        ...props,
        collapsed: collapsed,
        defaultCollapsed: defaultCollapsed,
        theme: theme,
        style: style,
        collapsible: collapsible,
        reverseArrow: reverseArrow,
        width: width,
        collapsedWidth: collapsedWidth,
        zeroWidthTriggerStyle: zeroWidthTriggerStyle,
        breakpoint: breakpoint,
        onCollapse: onCollapse,
        onBreakpoint: onBreakpoint
    };
    const [mergedClassNames, mergedStyles] = (0, $30c5f9f911d4f61b$export$648566b068f28737)([
        classNames
    ], [
        styles
    ], {
        props: semanticProps
    });
    // =========================== Prefix ===========================
    const { getPrefixCls: getPrefixCls, direction: direction } = (0, $cQmXV.useContext)((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls("layout-sider", customizePrefixCls);
    const [hashId, cssVarCls] = (0, $b2603108fcc01410$export$2e2bcd8739ae039)(prefixCls);
    // ========================= Responsive =========================
    const responsiveHandlerRef = (0, $cQmXV.useRef)(null);
    responsiveHandlerRef.current = (mql)=>{
        setBelow(mql.matches);
        onBreakpoint?.(mql.matches);
        if (collapsed !== mql.matches) handleSetCollapsed(mql.matches, "responsive");
    };
    (0, $cQmXV.useEffect)(()=>{
        function responsiveHandler(mql) {
            return responsiveHandlerRef.current?.(mql);
        }
        let mql;
        if (typeof window?.matchMedia !== "undefined" && breakpoint && breakpoint in $89ef2fa4f6587b8b$var$dimensionMaxMap) {
            mql = window.matchMedia(`screen and (max-width: ${$89ef2fa4f6587b8b$var$dimensionMaxMap[breakpoint]})`);
            if ((0, $8e2d153a3c855782$export$f6e2535fb5126e54)(mql?.addEventListener)) mql.addEventListener("change", responsiveHandler);
            responsiveHandler(mql);
        }
        return ()=>{
            if ((0, $8e2d153a3c855782$export$f6e2535fb5126e54)(mql?.removeEventListener)) mql.removeEventListener("change", responsiveHandler);
        };
    }, [
        breakpoint
    ]); // in order to accept dynamic 'breakpoint' property, we need to add 'breakpoint' into dependency array.
    (0, $cQmXV.useEffect)(()=>{
        const uniqueId = $89ef2fa4f6587b8b$var$generateId("ant-sider-");
        siderHook.addSider(uniqueId);
        return ()=>siderHook.removeSider(uniqueId);
    }, []);
    const toggle = ()=>{
        handleSetCollapsed(!collapsed, "clickTrigger");
    };
    const divProps = (0, $e8c5093aebad6025$export$2e2bcd8739ae039)(otherProps, [
        "collapsed"
    ]);
    const rawWidth = collapsed ? collapsedWidth : width;
    // use "px" as fallback unit for width
    const siderWidth = $89ef2fa4f6587b8b$var$isNumeric(rawWidth) ? `${rawWidth}px` : String(rawWidth);
    // special trigger when collapsedWidth == 0
    const zeroWidthTrigger = Number.parseFloat(String(collapsedWidth || 0)) === 0 ? /*#__PURE__*/ $cQmXV.createElement("span", {
        onClick: toggle,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-zero-width-trigger`, `${prefixCls}-zero-width-trigger-${reverseArrow ? "right" : "left"}`),
        style: zeroWidthTriggerStyle
    }, trigger || /*#__PURE__*/ $cQmXV.createElement((0, $f5d22ea5da469466$export$2e2bcd8739ae039), null)) : null;
    const reverseIcon = direction === "rtl" === !reverseArrow;
    const iconObj = {
        expanded: reverseIcon ? /*#__PURE__*/ $cQmXV.createElement((0, $89db7229a7e10f8f$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $cQmXV.createElement((0, $0f3c6d60b091c877$export$2e2bcd8739ae039), null),
        collapsed: reverseIcon ? /*#__PURE__*/ $cQmXV.createElement((0, $0f3c6d60b091c877$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $cQmXV.createElement((0, $89db7229a7e10f8f$export$2e2bcd8739ae039), null)
    };
    const status = collapsed ? "collapsed" : "expanded";
    const defaultTrigger = iconObj[status];
    const triggerDom = trigger !== null ? zeroWidthTrigger || /*#__PURE__*/ $cQmXV.createElement("div", {
        className: `${prefixCls}-trigger`,
        onClick: toggle,
        style: {
            width: siderWidth
        }
    }, trigger || defaultTrigger) : null;
    const divStyle = {
        ...style,
        flex: `0 0 ${siderWidth}`,
        maxWidth: siderWidth,
        // Fix width transition bug in IE11
        minWidth: siderWidth,
        // https://github.com/ant-design/ant-design/issues/6349
        width: siderWidth
    };
    const siderCls = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-${theme}`, {
        [`${prefixCls}-collapsed`]: !!collapsed,
        [`${prefixCls}-has-trigger`]: collapsible && trigger !== null && !zeroWidthTrigger,
        [`${prefixCls}-below`]: !!below,
        [`${prefixCls}-zero-width`]: Number.parseFloat(siderWidth) === 0
    }, className, mergedClassNames.root, hashId, cssVarCls);
    const contextValue = $cQmXV.useMemo(()=>({
            siderCollapsed: collapsed
        }), [
        collapsed
    ]);
    return /*#__PURE__*/ $cQmXV.createElement($89ef2fa4f6587b8b$export$63554aebd2a6d54c.Provider, {
        value: contextValue
    }, /*#__PURE__*/ $cQmXV.createElement("aside", {
        className: siderCls,
        ...divProps,
        style: {
            ...mergedStyles.root,
            ...divStyle
        },
        ref: ref
    }, /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-children`, mergedClassNames.body),
        style: mergedStyles.body
    }, children), collapsible || below && zeroWidthTrigger ? triggerDom : null));
});
var $89ef2fa4f6587b8b$export$2e2bcd8739ae039 = $89ef2fa4f6587b8b$var$Sider;



var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");
var $f449e4949bc4ce32$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($f449e4949bc4ce32$exports, "__esModule", {
    value: true
});
var $f449e4949bc4ce32$var$EllipsisOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z"
                }
            }
        ]
    },
    "name": "ellipsis",
    "theme": "outlined"
};
$f449e4949bc4ce32$exports.default = $f449e4949bc4ce32$var$EllipsisOutlined;



function $f172eb883972dae9$var$_extends() {
    $f172eb883972dae9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f172eb883972dae9$var$_extends.apply(this, arguments);
}
const $f172eb883972dae9$var$EllipsisOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $f172eb883972dae9$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($f449e4949bc4ce32$exports)))
    }));
/**![ellipsis](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTE3NiA1MTFhNTYgNTYgMCAxMDExMiAwIDU2IDU2IDAgMTAtMTEyIDB6bTI4MCAwYTU2IDU2IDAgMTAxMTIgMCA1NiA1NiAwIDEwLTExMiAwem0yODAgMGE1NiA1NiAwIDEwMTEyIDAgNTYgNTYgMCAxMC0xMTIgMHoiIC8+PC9zdmc+) */ const $f172eb883972dae9$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($f172eb883972dae9$var$EllipsisOutlined);
var $f172eb883972dae9$export$2e2bcd8739ae039 = $f172eb883972dae9$var$RefIcon;














var $cQmXV = parcelRequire("cQmXV");
"use client";
const $d4856615573199b1$var$MenuContext = /*#__PURE__*/ (0, $cQmXV.createContext)({
    prefixCls: "",
    firstLevel: true,
    inlineCollapsed: false,
    styles: null,
    classNames: null
});
var $d4856615573199b1$export$2e2bcd8739ae039 = $d4856615573199b1$var$MenuContext;



var $cQmXV = parcelRequire("cQmXV");



"use client";
const $5daebba96b0340f8$var$MenuDivider = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, dashed: dashed, ...restProps } = props;
    const { getPrefixCls: getPrefixCls } = $cQmXV.useContext((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls("menu", customizePrefixCls);
    const classString = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)({
        [`${prefixCls}-item-divider-dashed`]: !!dashed
    }, className);
    return /*#__PURE__*/ $cQmXV.createElement((0, $e7f817772278445a$export$2e2bcd8739ae039), {
        className: classString,
        ...restProps
    });
};
var $5daebba96b0340f8$export$2e2bcd8739ae039 = $5daebba96b0340f8$var$MenuDivider;



var $cQmXV = parcelRequire("cQmXV");







var $cQmXV = parcelRequire("cQmXV");


var $cQmXV = parcelRequire("cQmXV");
const $0c7c49576d1200b8$var$Popup = (props)=>{
    const { children: children, prefixCls: prefixCls, id: id, classNames: classNames, styles: styles, className: className, style: style } = props;
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        id: id,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-container`, classNames?.container, className),
        style: {
            ...styles?.container,
            ...style
        },
        role: "tooltip"
    }, typeof children === "function" ? children() : children);
};
var $0c7c49576d1200b8$export$2e2bcd8739ae039 = $0c7c49576d1200b8$var$Popup;






var $cQmXV = parcelRequire("cQmXV");
const $cdd392485d5759f0$var$autoAdjustOverflowTopBottom = {
    shiftX: 64,
    adjustY: 1
};
const $cdd392485d5759f0$var$autoAdjustOverflowLeftRight = {
    adjustX: 1,
    shiftY: true
};
const $cdd392485d5759f0$var$targetOffset = [
    0,
    0
];
const $cdd392485d5759f0$export$803cd8101b6c182b = {
    left: {
        points: [
            "cr",
            "cl"
        ],
        overflow: $cdd392485d5759f0$var$autoAdjustOverflowLeftRight,
        offset: [
            -4,
            0
        ],
        targetOffset: $cdd392485d5759f0$var$targetOffset
    },
    right: {
        points: [
            "cl",
            "cr"
        ],
        overflow: $cdd392485d5759f0$var$autoAdjustOverflowLeftRight,
        offset: [
            4,
            0
        ],
        targetOffset: $cdd392485d5759f0$var$targetOffset
    },
    top: {
        points: [
            "bc",
            "tc"
        ],
        overflow: $cdd392485d5759f0$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            -4
        ],
        targetOffset: $cdd392485d5759f0$var$targetOffset
    },
    bottom: {
        points: [
            "tc",
            "bc"
        ],
        overflow: $cdd392485d5759f0$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            4
        ],
        targetOffset: $cdd392485d5759f0$var$targetOffset
    },
    topLeft: {
        points: [
            "bl",
            "tl"
        ],
        overflow: $cdd392485d5759f0$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            -4
        ],
        targetOffset: $cdd392485d5759f0$var$targetOffset
    },
    leftTop: {
        points: [
            "tr",
            "tl"
        ],
        overflow: $cdd392485d5759f0$var$autoAdjustOverflowLeftRight,
        offset: [
            -4,
            0
        ],
        targetOffset: $cdd392485d5759f0$var$targetOffset
    },
    topRight: {
        points: [
            "br",
            "tr"
        ],
        overflow: $cdd392485d5759f0$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            -4
        ],
        targetOffset: $cdd392485d5759f0$var$targetOffset
    },
    rightTop: {
        points: [
            "tl",
            "tr"
        ],
        overflow: $cdd392485d5759f0$var$autoAdjustOverflowLeftRight,
        offset: [
            4,
            0
        ],
        targetOffset: $cdd392485d5759f0$var$targetOffset
    },
    bottomRight: {
        points: [
            "tr",
            "br"
        ],
        overflow: $cdd392485d5759f0$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            4
        ],
        targetOffset: $cdd392485d5759f0$var$targetOffset
    },
    rightBottom: {
        points: [
            "bl",
            "br"
        ],
        overflow: $cdd392485d5759f0$var$autoAdjustOverflowLeftRight,
        offset: [
            4,
            0
        ],
        targetOffset: $cdd392485d5759f0$var$targetOffset
    },
    bottomLeft: {
        points: [
            "tl",
            "bl"
        ],
        overflow: $cdd392485d5759f0$var$autoAdjustOverflowTopBottom,
        offset: [
            0,
            4
        ],
        targetOffset: $cdd392485d5759f0$var$targetOffset
    },
    leftBottom: {
        points: [
            "br",
            "bl"
        ],
        overflow: $cdd392485d5759f0$var$autoAdjustOverflowLeftRight,
        offset: [
            -4,
            0
        ],
        targetOffset: $cdd392485d5759f0$var$targetOffset
    }
};
var $cdd392485d5759f0$export$2e2bcd8739ae039 = $cdd392485d5759f0$export$803cd8101b6c182b;



function $3f996effe8bf7a87$var$_extends() {
    $3f996effe8bf7a87$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3f996effe8bf7a87$var$_extends.apply(this, arguments);
}
const $3f996effe8bf7a87$var$Tooltip = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { trigger: trigger = [
        "hover"
    ], mouseEnterDelay: mouseEnterDelay = 0, mouseLeaveDelay: mouseLeaveDelay = 0.1, prefixCls: prefixCls = "rc-tooltip", children: children, onVisibleChange: onVisibleChange, afterVisibleChange: afterVisibleChange, motion: motion, placement: placement = "right", align: align = {}, destroyOnHidden: destroyOnHidden = false, defaultVisible: defaultVisible, getTooltipContainer: getTooltipContainer, arrowContent: arrowContent, overlay: overlay, id: id, showArrow: showArrow = true, classNames: classNames, styles: styles, ...restProps } = props;
    const mergedId = (0, $a2da91bb60e2cbfb$export$2e2bcd8739ae039)(id);
    const triggerRef = (0, $cQmXV.useRef)(null);
    (0, $cQmXV.useImperativeHandle)(ref, ()=>triggerRef.current);
    const extraProps = {
        ...restProps
    };
    if ("visible" in props) extraProps.popupVisible = props.visible;
    // ========================= Arrow ==========================
    // Process arrow configuration
    const mergedArrow = $cQmXV.useMemo(()=>{
        if (!showArrow) return false;
        // Convert true to object for unified processing
        const arrowConfig = showArrow === true ? {} : showArrow;
        // Apply semantic styles with unified logic
        return {
            ...arrowConfig,
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(arrowConfig.className, classNames?.arrow),
            style: {
                ...arrowConfig.style,
                ...styles?.arrow
            },
            content: arrowConfig.content ?? arrowContent
        };
    }, [
        showArrow,
        classNames?.arrow,
        styles?.arrow,
        arrowContent
    ]);
    // ======================== Children ========================
    const getChildren = ({ open: open })=>{
        const child = $cQmXV.Children.only(children);
        const ariaProps = {
            "aria-describedby": overlay && open ? mergedId : undefined
        };
        return /*#__PURE__*/ $cQmXV.cloneElement(child, ariaProps);
    };
    // ========================= Render =========================
    return /*#__PURE__*/ $cQmXV.createElement((0, $c77226a956f109d7$export$2e2bcd8739ae039), $3f996effe8bf7a87$var$_extends({
        popupClassName: classNames?.root,
        prefixCls: prefixCls,
        popup: /*#__PURE__*/ $cQmXV.createElement((0, $0c7c49576d1200b8$export$2e2bcd8739ae039), {
            key: "content",
            prefixCls: prefixCls,
            id: mergedId,
            classNames: classNames,
            styles: styles
        }, overlay),
        action: trigger,
        builtinPlacements: (0, $cdd392485d5759f0$export$803cd8101b6c182b),
        popupPlacement: placement,
        ref: triggerRef,
        popupAlign: align,
        getPopupContainer: getTooltipContainer,
        onOpenChange: onVisibleChange,
        afterOpenChange: afterVisibleChange,
        popupMotion: motion,
        defaultPopupVisible: defaultVisible,
        autoDestroy: destroyOnHidden,
        mouseLeaveDelay: mouseLeaveDelay,
        popupStyle: styles?.root,
        mouseEnterDelay: mouseEnterDelay,
        arrow: mergedArrow,
        uniqueContainerClassName: classNames?.uniqueContainer,
        uniqueContainerStyle: styles?.uniqueContainer
    }, extraProps), getChildren);
});
var $3f996effe8bf7a87$export$2e2bcd8739ae039 = $3f996effe8bf7a87$var$Tooltip;


var $c317db53a65dcd48$export$2e2bcd8739ae039 = (0, $3f996effe8bf7a87$export$2e2bcd8739ae039);
















var $cQmXV = parcelRequire("cQmXV");
const $618736959620ab5c$var$TableMeasureRowContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createContext(false);
var $618736959620ab5c$export$2e2bcd8739ae039 = $618736959620ab5c$var$TableMeasureRowContext;




var $cQmXV = parcelRequire("cQmXV");
const $91d7bcfa626b18b0$var$useMergedArrow = (providedArrow, providedContextArrow)=>{
    const toConfig = (arrow)=>typeof arrow === "boolean" ? {
            show: arrow
        } : arrow || {};
    return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useMemo(()=>{
        const arrowConfig = toConfig(providedArrow);
        const contextArrowConfig = toConfig(providedContextArrow);
        return {
            ...contextArrowConfig,
            ...arrowConfig,
            show: arrowConfig.show ?? contextArrowConfig.show ?? true
        };
    }, [
        providedArrow,
        providedContextArrow
    ]);
};
var $91d7bcfa626b18b0$export$2e2bcd8739ae039 = $91d7bcfa626b18b0$var$useMergedArrow;



var $cQmXV = parcelRequire("cQmXV");








const $bae41aa9cbf75fc8$var$initMotionCommon = (duration)=>({
        animationDuration: duration,
        animationFillMode: "both"
    });
const $bae41aa9cbf75fc8$export$83e1da9e09ec9112 = (motionCls, inKeyframes, outKeyframes, duration, sameLevel = false)=>{
    const sameLevelPrefix = sameLevel ? "&" : "";
    return {
        [`
      ${sameLevelPrefix}${motionCls}-enter,
      ${sameLevelPrefix}${motionCls}-appear
    `]: {
            ...$bae41aa9cbf75fc8$var$initMotionCommon(duration),
            animationPlayState: "paused"
        },
        [`${sameLevelPrefix}${motionCls}-leave`]: {
            ...$bae41aa9cbf75fc8$var$initMotionCommon(duration),
            animationPlayState: "paused"
        },
        [`
      ${sameLevelPrefix}${motionCls}-enter${motionCls}-enter-active,
      ${sameLevelPrefix}${motionCls}-appear${motionCls}-appear-active
    `]: {
            animationName: inKeyframes,
            animationPlayState: "running"
        },
        [`${sameLevelPrefix}${motionCls}-leave${motionCls}-leave-active`]: {
            animationName: outKeyframes,
            animationPlayState: "running",
            pointerEvents: "none"
        }
    };
};


const $3fd8fb5c97e7786c$export$82e6205b15e6c637 = new (0, $e928d3664c9ed565$export$2e2bcd8739ae039)("antFadeIn", {
    "0%": {
        opacity: 0
    },
    "100%": {
        opacity: 1
    }
});
const $3fd8fb5c97e7786c$export$c091916f1530334c = new (0, $e928d3664c9ed565$export$2e2bcd8739ae039)("antFadeOut", {
    "0%": {
        opacity: 1
    },
    "100%": {
        opacity: 0
    }
});
const $3fd8fb5c97e7786c$export$2909268c8354a12 = (token, sameLevel = false)=>{
    const { antCls: antCls } = token;
    const motionCls = `${antCls}-fade`;
    const sameLevelPrefix = sameLevel ? "&" : "";
    return [
        (0, $bae41aa9cbf75fc8$export$83e1da9e09ec9112)(motionCls, $3fd8fb5c97e7786c$export$82e6205b15e6c637, $3fd8fb5c97e7786c$export$c091916f1530334c, token.motionDurationMid, sameLevel),
        {
            [`
        ${sameLevelPrefix}${motionCls}-enter,
        ${sameLevelPrefix}${motionCls}-appear
      `]: {
                opacity: 0,
                animationTimingFunction: "linear"
            },
            [`${sameLevelPrefix}${motionCls}-leave`]: {
                animationTimingFunction: "linear"
            }
        }
    ];
};



const $35f7d6eebd10a5fe$export$3b71758b3ed5255f = new (0, $e928d3664c9ed565$export$2e2bcd8739ae039)("antZoomIn", {
    "0%": {
        transform: "scale(0.2)",
        opacity: 0
    },
    "100%": {
        transform: "scale(1)",
        opacity: 1
    }
});
const $35f7d6eebd10a5fe$export$9fdb0a49c6b4b521 = new (0, $e928d3664c9ed565$export$2e2bcd8739ae039)("antZoomOut", {
    "0%": {
        transform: "scale(1)"
    },
    "100%": {
        transform: "scale(0.2)",
        opacity: 0
    }
});
const $35f7d6eebd10a5fe$export$be061d573c42e33a = new (0, $e928d3664c9ed565$export$2e2bcd8739ae039)("antZoomBigIn", {
    "0%": {
        transform: "scale(0.8)",
        opacity: 0
    },
    "100%": {
        transform: "scale(1)",
        opacity: 1
    }
});
const $35f7d6eebd10a5fe$export$582d93d613303da3 = new (0, $e928d3664c9ed565$export$2e2bcd8739ae039)("antZoomBigOut", {
    "0%": {
        transform: "scale(1)"
    },
    "100%": {
        transform: "scale(0.8)",
        opacity: 0
    }
});
const $35f7d6eebd10a5fe$export$45eddd18c599b827 = new (0, $e928d3664c9ed565$export$2e2bcd8739ae039)("antZoomUpIn", {
    "0%": {
        transform: "scale(0.8)",
        transformOrigin: "50% 0%",
        opacity: 0
    },
    "100%": {
        transform: "scale(1)",
        transformOrigin: "50% 0%"
    }
});
const $35f7d6eebd10a5fe$export$a85c97750adaa37a = new (0, $e928d3664c9ed565$export$2e2bcd8739ae039)("antZoomUpOut", {
    "0%": {
        transform: "scale(1)",
        transformOrigin: "50% 0%"
    },
    "100%": {
        transform: "scale(0.8)",
        transformOrigin: "50% 0%",
        opacity: 0
    }
});
const $35f7d6eebd10a5fe$export$bd2378f7814f5f1a = new (0, $e928d3664c9ed565$export$2e2bcd8739ae039)("antZoomLeftIn", {
    "0%": {
        transform: "scale(0.8)",
        transformOrigin: "0% 50%",
        opacity: 0
    },
    "100%": {
        transform: "scale(1)",
        transformOrigin: "0% 50%"
    }
});
const $35f7d6eebd10a5fe$export$e58f88c751c4f04e = new (0, $e928d3664c9ed565$export$2e2bcd8739ae039)("antZoomLeftOut", {
    "0%": {
        transform: "scale(1)",
        transformOrigin: "0% 50%"
    },
    "100%": {
        transform: "scale(0.8)",
        transformOrigin: "0% 50%",
        opacity: 0
    }
});
const $35f7d6eebd10a5fe$export$fee1456954aef331 = new (0, $e928d3664c9ed565$export$2e2bcd8739ae039)("antZoomRightIn", {
    "0%": {
        transform: "scale(0.8)",
        transformOrigin: "100% 50%",
        opacity: 0
    },
    "100%": {
        transform: "scale(1)",
        transformOrigin: "100% 50%"
    }
});
const $35f7d6eebd10a5fe$export$811ba6d3e2adb730 = new (0, $e928d3664c9ed565$export$2e2bcd8739ae039)("antZoomRightOut", {
    "0%": {
        transform: "scale(1)",
        transformOrigin: "100% 50%"
    },
    "100%": {
        transform: "scale(0.8)",
        transformOrigin: "100% 50%",
        opacity: 0
    }
});
const $35f7d6eebd10a5fe$export$633a68aa72dec21c = new (0, $e928d3664c9ed565$export$2e2bcd8739ae039)("antZoomDownIn", {
    "0%": {
        transform: "scale(0.8)",
        transformOrigin: "50% 100%",
        opacity: 0
    },
    "100%": {
        transform: "scale(1)",
        transformOrigin: "50% 100%"
    }
});
const $35f7d6eebd10a5fe$export$1cf46a906e8dede4 = new (0, $e928d3664c9ed565$export$2e2bcd8739ae039)("antZoomDownOut", {
    "0%": {
        transform: "scale(1)",
        transformOrigin: "50% 100%"
    },
    "100%": {
        transform: "scale(0.8)",
        transformOrigin: "50% 100%",
        opacity: 0
    }
});
const $35f7d6eebd10a5fe$var$zoomMotion = {
    zoom: {
        inKeyframes: $35f7d6eebd10a5fe$export$3b71758b3ed5255f,
        outKeyframes: $35f7d6eebd10a5fe$export$9fdb0a49c6b4b521
    },
    "zoom-big": {
        inKeyframes: $35f7d6eebd10a5fe$export$be061d573c42e33a,
        outKeyframes: $35f7d6eebd10a5fe$export$582d93d613303da3
    },
    "zoom-big-fast": {
        inKeyframes: $35f7d6eebd10a5fe$export$be061d573c42e33a,
        outKeyframes: $35f7d6eebd10a5fe$export$582d93d613303da3
    },
    "zoom-left": {
        inKeyframes: $35f7d6eebd10a5fe$export$bd2378f7814f5f1a,
        outKeyframes: $35f7d6eebd10a5fe$export$e58f88c751c4f04e
    },
    "zoom-right": {
        inKeyframes: $35f7d6eebd10a5fe$export$fee1456954aef331,
        outKeyframes: $35f7d6eebd10a5fe$export$811ba6d3e2adb730
    },
    "zoom-up": {
        inKeyframes: $35f7d6eebd10a5fe$export$45eddd18c599b827,
        outKeyframes: $35f7d6eebd10a5fe$export$a85c97750adaa37a
    },
    "zoom-down": {
        inKeyframes: $35f7d6eebd10a5fe$export$633a68aa72dec21c,
        outKeyframes: $35f7d6eebd10a5fe$export$1cf46a906e8dede4
    }
};
const $35f7d6eebd10a5fe$export$f5d123412490d9dc = (token, motionName)=>{
    const { antCls: antCls } = token;
    const motionCls = `${antCls}-${motionName}`;
    const { inKeyframes: inKeyframes, outKeyframes: outKeyframes } = $35f7d6eebd10a5fe$var$zoomMotion[motionName];
    return [
        (0, $bae41aa9cbf75fc8$export$83e1da9e09ec9112)(motionCls, inKeyframes, outKeyframes, motionName === "zoom-big-fast" ? token.motionDurationFast : token.motionDurationMid),
        {
            [`
        ${motionCls}-enter,
        ${motionCls}-appear
      `]: {
                transform: "scale(0)",
                opacity: 0,
                animationTimingFunction: token.motionEaseOutCirc,
                "&-prepare": {
                    transform: "none"
                }
            },
            [`${motionCls}-leave`]: {
                animationTimingFunction: token.motionEaseInOutCirc
            }
        }
    ];
};





function $7c652e13f0bdefc8$export$2e2bcd8739ae039(token, genCss) {
    return (0, $ade5e73b59dc3f96$export$6d4fe3a00a1811ad).reduce((prev, colorKey)=>{
        const lightColor = token[`${colorKey}1`];
        const lightBorderColor = token[`${colorKey}3`];
        const darkColor = token[`${colorKey}6`];
        const textColor = token[`${colorKey}7`];
        return {
            ...prev,
            ...genCss(colorKey, {
                lightColor: lightColor,
                lightBorderColor: lightBorderColor,
                darkColor: darkColor,
                textColor: textColor
            })
        };
    }, {});
}



const $be605e20519e8e05$var$FALL_BACK_ORIGIN = "50%";
const $be605e20519e8e05$var$genTooltipStyle = (token)=>{
    const { calc: calc, componentCls: componentCls, tooltipMaxWidth: // ant-tooltip
    tooltipMaxWidth, tooltipColor: tooltipColor, tooltipBg: tooltipBg, tooltipBorderRadius: tooltipBorderRadius, zIndexPopup: zIndexPopup, controlHeight: controlHeight, dropShadowPopover: dropShadowPopover, paddingSM: paddingSM, paddingXS: paddingXS, arrowOffsetHorizontal: arrowOffsetHorizontal, sizePopupArrow: sizePopupArrow, antCls: antCls } = token;
    const [varName, varRef] = (0, $6870d4d7c14ae0bb$export$d82b8f66c5649e14)(antCls, "tooltip");
    // arrowOffsetHorizontal + arrowWidth + borderRadius
    const edgeAlignMinWidth = calc(tooltipBorderRadius).add(sizePopupArrow).add(arrowOffsetHorizontal).equal();
    // borderRadius * 2 + arrowWidth
    const centerAlignMinWidth = calc(tooltipBorderRadius).mul(2).add(sizePopupArrow).equal();
    const sharedBodyStyle = {
        minWidth: centerAlignMinWidth,
        minHeight: controlHeight,
        padding: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.calc(paddingSM).div(2).equal())} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(paddingXS)}`,
        color: varRef("overlay-color", tooltipColor),
        textAlign: "start",
        textDecoration: "none",
        wordWrap: "break-word",
        backgroundColor: tooltipBg,
        borderRadius: tooltipBorderRadius,
        boxSizing: "border-box"
    };
    const sharedTransformOrigin = {
        // When use `autoArrow`, origin will follow the arrow position
        [varName("valid-offset-x")]: varRef("arrow-offset-x", "var(--arrow-x)"),
        transformOrigin: [
            varRef("valid-offset-x", $be605e20519e8e05$var$FALL_BACK_ORIGIN),
            `var(--arrow-y, ${$be605e20519e8e05$var$FALL_BACK_ORIGIN})`
        ].join(" ")
    };
    return [
        {
            [componentCls]: {
                ...(0, $519d20bf207ce864$export$23997c3e44cc1c59)(token),
                position: "absolute",
                zIndex: zIndexPopup,
                display: "block",
                width: "max-content",
                maxWidth: tooltipMaxWidth,
                visibility: "visible",
                filter: dropShadowPopover,
                ...sharedTransformOrigin,
                "&-hidden": {
                    display: "none"
                },
                [varName("arrow-background-color")]: tooltipBg,
                // Wrapper for the tooltip content
                [`${componentCls}-container`]: [
                    sharedBodyStyle,
                    (0, $3fd8fb5c97e7786c$export$2909268c8354a12)(token, true)
                ],
                [`&:has(~ ${componentCls}-unique-container)`]: {
                    [`${componentCls}-container`]: {
                        border: "none",
                        background: "transparent"
                    }
                },
                // Align placement should have another min width
                [[
                    `&-placement-topLeft`,
                    `&-placement-topRight`,
                    `&-placement-bottomLeft`,
                    `&-placement-bottomRight`
                ].join(",")]: {
                    minWidth: edgeAlignMinWidth
                },
                // Limit left and right placement radius
                [[
                    `&-placement-left`,
                    `&-placement-leftTop`,
                    `&-placement-leftBottom`,
                    `&-placement-right`,
                    `&-placement-rightTop`,
                    `&-placement-rightBottom`
                ].join(",")]: {
                    [`${componentCls}-inner`]: {
                        borderRadius: token.min(tooltipBorderRadius, (0, $dc42b38f8ad9a4d1$export$de6e4ffc9ec3c089))
                    }
                },
                [`${componentCls}-content`]: {
                    position: "relative"
                },
                // generator for preset color
                ...(0, $7c652e13f0bdefc8$export$2e2bcd8739ae039)(token, (colorKey, { darkColor: darkColor })=>({
                        [`&${componentCls}-${colorKey}`]: {
                            [`${componentCls}-container`]: {
                                backgroundColor: darkColor
                            },
                            [`${componentCls}-arrow`]: {
                                [varName("arrow-background-color")]: darkColor
                            }
                        }
                    })),
                // RTL
                "&-rtl": {
                    direction: "rtl"
                }
            }
        },
        // Arrow Style
        (0, $dc42b38f8ad9a4d1$export$2e2bcd8739ae039)(token, varRef("arrow-background-color"), {
            arrowShadow: false
        }),
        // Pure Render
        {
            [`${componentCls}-pure`]: {
                position: "relative",
                maxWidth: "none",
                margin: token.sizePopupArrow
            }
        },
        // Unique Body
        {
            [`${componentCls}-unique-container`]: {
                ...sharedBodyStyle,
                ...sharedTransformOrigin,
                position: "absolute",
                zIndex: calc(zIndexPopup).sub(1).equal(),
                filter: dropShadowPopover,
                "&-hidden": {
                    display: "none"
                },
                "&-visible": {
                    transition: `all ${token.motionDurationSlow}`
                }
            }
        }
    ];
};
const $be605e20519e8e05$export$9ca1be8807fe0675 = (token)=>({
        zIndexPopup: token.zIndexPopupBase + 70,
        maxWidth: 250,
        ...(0, $dc42b38f8ad9a4d1$export$bddc192327bb9823)({
            contentRadius: token.borderRadius,
            limitVerticalRadius: true
        }),
        ...(0, $e1e9e0ec17db0365$export$87e38ee403661ccc)((0, $fef50f256b80dfa5$export$4950aa0f605343fb)(token, {
            borderRadiusOuter: Math.min(token.borderRadiusOuter, 4)
        }))
    });
var $be605e20519e8e05$export$2e2bcd8739ae039 = (prefixCls, rootCls, injectStyle = true)=>{
    const useStyle = (0, $6870d4d7c14ae0bb$export$51ec95de45185b42)("Tooltip", (token)=>{
        const { borderRadius: borderRadius, colorTextLightSolid: colorTextLightSolid, colorBgSpotlight: colorBgSpotlight, maxWidth: maxWidth } = token;
        const TooltipToken = (0, $fef50f256b80dfa5$export$4950aa0f605343fb)(token, {
            // default variables
            tooltipMaxWidth: maxWidth,
            tooltipColor: colorTextLightSolid,
            tooltipBorderRadius: borderRadius,
            tooltipBg: colorBgSpotlight
        });
        return [
            $be605e20519e8e05$var$genTooltipStyle(TooltipToken),
            (0, $35f7d6eebd10a5fe$export$f5d123412490d9dc)(token, "zoom-big-fast")
        ];
    }, $be605e20519e8e05$export$9ca1be8807fe0675, {
        resetStyle: false,
        injectStyle: // Popover use Tooltip as internal component. We do not need to handle this.
        injectStyle
    });
    return useStyle(prefixCls, rootCls);
};





const $4cbe68e4e955ed41$var$inverseColors = (0, $ade5e73b59dc3f96$export$6d4fe3a00a1811ad).map((color)=>`${color}-inverse`);
const $4cbe68e4e955ed41$export$2c43cb57a48fae33 = [
    "success",
    "processing",
    "error",
    "default",
    "warning"
];
function $4cbe68e4e955ed41$export$ee62ebd6a58c4884(color, includeInverse = true) {
    if (includeInverse) return [].concat((0, $68381b18b974dc9f$export$2e2bcd8739ae039)($4cbe68e4e955ed41$var$inverseColors), (0, $68381b18b974dc9f$export$2e2bcd8739ae039)((0, $ade5e73b59dc3f96$export$6d4fe3a00a1811ad))).includes(color);
    return (0, $ade5e73b59dc3f96$export$6d4fe3a00a1811ad).includes(color);
}
function $4cbe68e4e955ed41$export$88a0ba1f7d1ea40e(color) {
    return $4cbe68e4e955ed41$export$2c43cb57a48fae33.includes(color);
}




const $215602f223e1b235$export$6e865ea70d7724f = (rootPrefixCls, prefixCls, color)=>{
    const isInternalColor = (0, $4cbe68e4e955ed41$export$ee62ebd6a58c4884)(color);
    const [varName] = (0, $6870d4d7c14ae0bb$export$d82b8f66c5649e14)(rootPrefixCls, "tooltip");
    const className = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)({
        [`${prefixCls}-${color}`]: color && isInternalColor
    });
    const overlayStyle = {};
    const arrowStyle = {};
    const rgb = (0, $6004e9e16651595b$export$c844f5d21427d1ab)(color).toRgb();
    const luminance = (0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b) / 255;
    const textColor = luminance < 0.5 ? "#FFF" : "#000";
    if (color && !isInternalColor) {
        overlayStyle.background = color;
        overlayStyle[varName("overlay-color")] = textColor;
        arrowStyle[varName("arrow-background-color")] = color;
    }
    return {
        className: className,
        overlayStyle: overlayStyle,
        arrowStyle: arrowStyle
    };
};


"use client";
/** @private Internal Component. Do not use in your production. */ const $88ea75725e616b6a$var$PurePanel = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, placement: placement = "top", title: title, color: color, overlayInnerStyle: overlayInnerStyle, classNames: classNames, styles: styles } = props;
    const { getPrefixCls: getPrefixCls } = $cQmXV.useContext((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls("tooltip", customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    const rootCls = (0, $2237081acd3cfc09$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $be605e20519e8e05$export$2e2bcd8739ae039)(prefixCls, rootCls);
    // Color
    const colorInfo = (0, $215602f223e1b235$export$6e865ea70d7724f)(rootPrefixCls, prefixCls, color);
    const arrowContentStyle = colorInfo.arrowStyle;
    const innerStyles = $cQmXV.useMemo(()=>{
        const mergedStyle = {
            ...overlayInnerStyle,
            ...colorInfo.overlayStyle
        };
        return {
            container: mergedStyle
        };
    }, [
        overlayInnerStyle,
        colorInfo.overlayStyle
    ]);
    const mergedProps = {
        ...props,
        placement: placement
    };
    const [mergedClassNames, mergedStyles] = (0, $30c5f9f911d4f61b$export$648566b068f28737)([
        classNames
    ], [
        innerStyles,
        styles
    ], {
        props: mergedProps
    });
    const rootClassName = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(rootCls, hashId, cssVarCls, prefixCls, `${prefixCls}-pure`, `${prefixCls}-placement-${placement}`, className, colorInfo.className);
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        className: rootClassName,
        style: arrowContentStyle
    }, /*#__PURE__*/ $cQmXV.createElement("div", {
        className: `${prefixCls}-arrow`
    }), /*#__PURE__*/ $cQmXV.createElement((0, $0c7c49576d1200b8$export$2e2bcd8739ae039), {
        ...props,
        className: hashId,
        prefixCls: prefixCls,
        classNames: mergedClassNames,
        styles: mergedStyles
    }, title));
};
var $88ea75725e616b6a$export$2e2bcd8739ae039 = $88ea75725e616b6a$var$PurePanel;





"use client";
const $1e5256cf9d329b2c$var$InternalTooltip = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, openClassName: openClassName, getTooltipContainer: getTooltipContainer, color: color, children: children, afterOpenChange: afterOpenChange, arrow: tooltipArrow, destroyTooltipOnHide: destroyTooltipOnHide, destroyOnHidden: destroyOnHidden, title: title, overlay: overlay, trigger: trigger, builtinPlacements: builtinPlacements, autoAdjustOverflow: autoAdjustOverflow = true, motion: motion, getPopupContainer: getPopupContainer, placement: placement = "top", mouseEnterDelay: mouseEnterDelay, mouseLeaveDelay: mouseLeaveDelay, rootClassName: rootClassName, styles: styles, classNames: classNames, onOpenChange: onOpenChange, overlayInnerStyle: // Legacy
    overlayInnerStyle, overlayStyle: overlayStyle, overlayClassName: overlayClassName, ...restProps } = props;
    const [, token] = (0, $b22e03a54a548614$export$2e2bcd8739ae039)();
    const injectFromPopover = props["data-popover-inject"];
    const { getPopupContainer: getContextPopupContainer, getPrefixCls: getPrefixCls, direction: direction, ...semanticConfig } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("tooltip");
    // When injected from Popover/Popconfirm, skip tooltip-specific semantic config
    // to prevent ConfigProvider tooltip config from leaking into those components
    const { className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles, arrow: contextArrow, trigger: contextTrigger, mouseEnterDelay: contextMouseEnterDelay, mouseLeaveDelay: contextMouseLeaveDelay } = injectFromPopover ? {} : semanticConfig;
    const mergedMouseEnterDelay = mouseEnterDelay ?? contextMouseEnterDelay ?? 0.1;
    const mergedMouseLeaveDelay = mouseLeaveDelay ?? contextMouseLeaveDelay ?? 0.1;
    const mergedArrow = (0, $91d7bcfa626b18b0$export$2e2bcd8739ae039)(tooltipArrow, contextArrow);
    const mergedShowArrow = mergedArrow.show;
    const mergedTrigger = trigger || contextTrigger || "hover";
    const mergedGetPopupContainer = getPopupContainer || getContextPopupContainer;
    const mergedDestroyOnHidden = destroyOnHidden ?? !!destroyTooltipOnHide;
    const inTableMeasureRow = $cQmXV.useContext((0, $618736959620ab5c$export$2e2bcd8739ae039));
    // ============================== Ref ===============================
    const warning = (0, $b5822acdae823465$export$cf977aa92c751e61)("Tooltip");
    const tooltipRef = $cQmXV.useRef(null);
    const forceAlign = ()=>{
        tooltipRef.current?.forceAlign();
    };
    $cQmXV.useImperativeHandle(ref, ()=>({
            forceAlign: forceAlign,
            nativeElement: tooltipRef.current?.nativeElement,
            popupElement: tooltipRef.current?.popupElement
        }));
    var deprecatedName, newName;
    // ============================== Open ==============================
    const [open, setOpen] = (0, $a51866d781137e08$export$2e2bcd8739ae039)(props.defaultOpen ?? false, props.open);
    const noTitle = !title && !overlay && title !== 0; // overlay for old version compatibility
    const onInternalOpenChange = (vis)=>{
        setOpen(noTitle ? false : vis);
        if (!noTitle && onOpenChange) onOpenChange(vis);
    };
    const tooltipPlacements = $cQmXV.useMemo(()=>{
        return builtinPlacements || (0, $79d8965a045fdc17$export$2e2bcd8739ae039)({
            arrowPointAtCenter: mergedArrow?.pointAtCenter ?? false,
            autoAdjustOverflow: autoAdjustOverflow,
            arrowWidth: mergedShowArrow ? token.sizePopupArrow : 0,
            borderRadius: token.borderRadius,
            offset: token.marginXXS,
            visibleFirst: true
        });
    }, [
        mergedArrow,
        builtinPlacements,
        token,
        mergedShowArrow,
        autoAdjustOverflow
    ]);
    const memoOverlay = $cQmXV.useMemo(()=>{
        if (title === 0) return title;
        return overlay || title || "";
    }, [
        overlay,
        title
    ]);
    const memoOverlayWrapper = /*#__PURE__*/ $cQmXV.createElement((0, $1585084388e75c84$export$2e2bcd8739ae039), {
        space: true,
        form: true
    }, (0, $8e2d153a3c855782$export$f6e2535fb5126e54)(memoOverlay) ? memoOverlay() : memoOverlay);
    // =========== Merged Props for Semantic ===========
    const mergedProps = {
        ...props,
        trigger: mergedTrigger,
        builtinPlacements: tooltipPlacements,
        getPopupContainer: mergedGetPopupContainer,
        destroyOnHidden: mergedDestroyOnHidden,
        mouseEnterDelay: mergedMouseEnterDelay,
        mouseLeaveDelay: mergedMouseLeaveDelay
    };
    const contextStyleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(contextStyle);
    const overlayStyleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(overlayStyle);
    const [mergedClassNames, mergedStyles] = (0, $30c5f9f911d4f61b$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        overlayStyleRoot
    ], {
        props: mergedProps
    });
    const prefixCls = getPrefixCls("tooltip", customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    let tempOpen = open;
    // Hide tooltip when there is no title or in table measure row
    if (!("open" in props) && noTitle || inTableMeasureRow) tempOpen = false;
    // ============================= Render =============================
    const child = /*#__PURE__*/ $cQmXV.isValidElement(children) && !(0, $a91ef204d03d8eec$export$9522e17588c12572)(children) ? children : /*#__PURE__*/ $cQmXV.createElement("span", null, children);
    const childProps = child.props;
    const childCls = !childProps.className || typeof childProps.className === "string" ? (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(childProps.className, openClassName || `${prefixCls}-open`) : childProps.className;
    // Style
    const rootCls = (0, $2237081acd3cfc09$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $be605e20519e8e05$export$2e2bcd8739ae039)(prefixCls, rootCls, !injectFromPopover);
    // Color
    const colorInfo = (0, $215602f223e1b235$export$6e865ea70d7724f)(rootPrefixCls, prefixCls, color);
    const arrowContentStyle = colorInfo.arrowStyle;
    const themeCls = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(rootCls, hashId, cssVarCls);
    const rootClassNames = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(overlayClassName, {
        [`${prefixCls}-rtl`]: direction === "rtl"
    }, colorInfo.className, rootClassName, themeCls, contextClassName, mergedClassNames.root);
    // ============================ zIndex ============================
    const [zIndex, contextZIndex] = (0, $b2b300e6909d7707$export$3e7906d4075187a4)("Tooltip", restProps.zIndex);
    const containerStyle = {
        ...mergedStyles.container,
        ...overlayInnerStyle,
        ...colorInfo.overlayStyle
    };
    const content = /*#__PURE__*/ $cQmXV.createElement((0, $c317db53a65dcd48$export$2e2bcd8739ae039), {
        unique: true,
        ...restProps,
        zIndex: zIndex,
        showArrow: mergedShowArrow,
        placement: placement,
        mouseEnterDelay: mergedMouseEnterDelay,
        mouseLeaveDelay: mergedMouseLeaveDelay,
        prefixCls: prefixCls,
        classNames: {
            root: rootClassNames,
            container: mergedClassNames.container,
            arrow: mergedClassNames.arrow,
            uniqueContainer: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(themeCls, mergedClassNames.container)
        },
        styles: {
            root: {
                ...arrowContentStyle,
                ...mergedStyles.root
            },
            container: containerStyle,
            uniqueContainer: containerStyle,
            arrow: mergedStyles.arrow
        },
        ref: tooltipRef,
        overlay: memoOverlayWrapper,
        visible: tempOpen,
        onVisibleChange: onInternalOpenChange,
        afterVisibleChange: afterOpenChange,
        arrowContent: /*#__PURE__*/ $cQmXV.createElement("span", {
            className: `${prefixCls}-arrow-content`
        }),
        motion: {
            motionName: (0, $047a5f051ebda8ba$export$27c72201b1d09951)(rootPrefixCls, "zoom-big-fast", typeof motion?.motionName === "string" ? motion?.motionName : undefined),
            motionDeadline: 1000
        },
        trigger: mergedTrigger,
        builtinPlacements: tooltipPlacements,
        getTooltipContainer: mergedGetPopupContainer,
        destroyOnHidden: mergedDestroyOnHidden
    }, tempOpen && !restProps.disabled ? (0, $a91ef204d03d8eec$export$e530037191fcd5d7)(child, {
        className: childCls
    }) : child);
    return /*#__PURE__*/ $cQmXV.createElement((0, $2a7b32ec1626bb34$export$2e2bcd8739ae039).Provider, {
        value: contextZIndex
    }, content);
});
const $1e5256cf9d329b2c$var$Tooltip = $1e5256cf9d329b2c$var$InternalTooltip;
$1e5256cf9d329b2c$var$Tooltip._InternalPanelDoNotUseOrYouWillBeFired = (0, $88ea75725e616b6a$export$2e2bcd8739ae039);
$1e5256cf9d329b2c$var$Tooltip.UniqueProvider = (0, $4271d9f55cb3799b$export$2e2bcd8739ae039);
var $1e5256cf9d329b2c$export$2e2bcd8739ae039 = $1e5256cf9d329b2c$var$Tooltip;



"use client";
const $eada6d81760a5fb4$var$MenuItem = (props)=>{
    const { className: className, children: children, icon: icon, title: title, danger: danger, extra: extra } = props;
    const { prefixCls: prefixCls, firstLevel: firstLevel, direction: direction, disableMenuItemTitleTooltip: disableMenuItemTitleTooltip, tooltip: tooltip, inlineCollapsed: isInlineCollapsed, styles: styles, classNames: classNames } = $cQmXV.useContext((0, $d4856615573199b1$export$2e2bcd8739ae039));
    const renderItemChildren = (inlineCollapsed)=>{
        const label = children?.[0];
        const wrapNode = /*#__PURE__*/ $cQmXV.createElement("span", {
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-title-content`, firstLevel ? classNames?.itemContent : classNames?.subMenu?.itemContent, {
                [`${prefixCls}-title-content-with-extra`]: !!extra || extra === 0
            }),
            style: firstLevel ? styles?.itemContent : styles?.subMenu?.itemContent
        }, children);
        // inline-collapsed.md demo 依赖 span 来隐藏文字,有 icon 属性，则内部包裹一个 span
        // ref: https://github.com/ant-design/ant-design/pull/23456
        if (!icon || /*#__PURE__*/ $cQmXV.isValidElement(children) && children.type === "span") {
            if (children && inlineCollapsed && firstLevel && typeof label === "string") return /*#__PURE__*/ $cQmXV.createElement("div", {
                className: `${prefixCls}-inline-collapsed-noicon`
            }, label.charAt(0));
        }
        return wrapNode;
    };
    const { siderCollapsed: siderCollapsed } = $cQmXV.useContext((0, $89ef2fa4f6587b8b$export$63554aebd2a6d54c));
    let tooltipTitle = title;
    if (typeof title === "undefined") tooltipTitle = firstLevel ? children : "";
    else if (title === false) tooltipTitle = "";
    const tooltipConfig = tooltip === false ? undefined : tooltip;
    const mergedTooltipTitle = tooltipConfig && tooltipConfig.title !== undefined ? tooltipConfig.title : tooltipTitle;
    const tooltipProps = {
        ...tooltipConfig ?? null,
        title: mergedTooltipTitle
    };
    if (!siderCollapsed && !isInlineCollapsed) {
        tooltipProps.title = null;
        // Reset `open` to fix control mode tooltip display not correct
        // ref: https://github.com/ant-design/ant-design/issues/16742
        tooltipProps.open = false;
    }
    const childrenLength = (0, $cd966a313e0a92ff$export$2e2bcd8739ae039)(children).length;
    let returnNode = /*#__PURE__*/ $cQmXV.createElement((0, $dc497472bf4ea988$export$2e2bcd8739ae039), {
        ...(0, $e8c5093aebad6025$export$2e2bcd8739ae039)(props, [
            "title",
            "icon",
            "danger"
        ]),
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(firstLevel ? classNames?.item : classNames?.subMenu?.item, {
            [`${prefixCls}-item-danger`]: danger,
            [`${prefixCls}-item-only-child`]: (icon ? childrenLength + 1 : childrenLength) === 1
        }, className),
        style: {
            ...firstLevel ? styles?.item : styles?.subMenu?.item,
            ...props.style
        },
        title: typeof title === "string" ? title : undefined,
        itemData: props?.itemData ?? {
            ...props,
            key: props.eventKey
        }
    }, (0, $a91ef204d03d8eec$export$e530037191fcd5d7)(icon, (oriProps)=>({
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-item-icon`, firstLevel ? classNames?.itemIcon : classNames?.subMenu?.itemIcon, oriProps.className),
            style: {
                ...firstLevel ? styles?.itemIcon : styles?.subMenu?.itemIcon,
                ...oriProps.style
            }
        })), renderItemChildren(isInlineCollapsed));
    if (!disableMenuItemTitleTooltip && tooltip !== false) {
        const mergedTooltipPlacement = tooltipConfig && tooltipConfig.placement ? tooltipConfig.placement : direction === "rtl" ? "left" : "right";
        const baseTooltipClassName = `${prefixCls}-inline-collapsed-tooltip`;
        const mergeTooltipRootClassName = (classNames)=>({
                ...classNames,
                root: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(baseTooltipClassName, classNames?.root)
            });
        const mergedTooltipClassNames = (0, $8e2d153a3c855782$export$f6e2535fb5126e54)(tooltipConfig?.classNames) ? (info)=>{
            const resolvedClassNames = tooltipConfig.classNames(info);
            return mergeTooltipRootClassName(resolvedClassNames);
        } : mergeTooltipRootClassName(tooltipConfig?.classNames);
        returnNode = /*#__PURE__*/ $cQmXV.createElement((0, $1e5256cf9d329b2c$export$2e2bcd8739ae039), {
            ...tooltipProps,
            placement: mergedTooltipPlacement,
            classNames: mergedTooltipClassNames
        }, returnNode);
    }
    return returnNode;
};
var $eada6d81760a5fb4$export$2e2bcd8739ae039 = $eada6d81760a5fb4$var$MenuItem;



var $cQmXV = parcelRequire("cQmXV");


"use client";
const $7e4ae2ec58dd3044$var$OverrideContext = /*#__PURE__*/ $cQmXV.createContext(null);
const $7e4ae2ec58dd3044$export$9bd434816b0530d0 = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { children: children, ...restProps } = props;
    const override = $cQmXV.useContext($7e4ae2ec58dd3044$var$OverrideContext);
    const context = $cQmXV.useMemo(()=>({
            ...override,
            ...restProps
        }), [
        override,
        restProps.prefixCls,
        // restProps.expandIcon, Not mark as deps since this is a ReactNode
        restProps.mode,
        restProps.selectable,
        restProps.rootClassName
    ]);
    const canRef = (0, $10341b937b26f69d$export$b51ae67c7882a242)(children);
    const mergedRef = (0, $10341b937b26f69d$export$1d1c999670a1285d)(ref, canRef ? (0, $10341b937b26f69d$export$7465e5c0bf44f19a)(children) : null);
    return /*#__PURE__*/ $cQmXV.createElement($7e4ae2ec58dd3044$var$OverrideContext.Provider, {
        value: context
    }, /*#__PURE__*/ $cQmXV.createElement((0, $1585084388e75c84$export$2e2bcd8739ae039), {
        space: true
    }, canRef ? /*#__PURE__*/ $cQmXV.cloneElement(children, {
        ref: mergedRef
    }) : children));
});
var /** @internal Only used for Dropdown component. Do not use this in your production. */ $7e4ae2ec58dd3044$export$2e2bcd8739ae039 = $7e4ae2ec58dd3044$var$OverrideContext;







const $ff153a7980a78f00$export$e801b802b037de6a = new (0, $e928d3664c9ed565$export$2e2bcd8739ae039)("antSlideUpIn", {
    "0%": {
        transform: "scaleY(0.8)",
        transformOrigin: "0% 0%",
        opacity: 0
    },
    "100%": {
        transform: "scaleY(1)",
        transformOrigin: "0% 0%",
        opacity: 1
    }
});
const $ff153a7980a78f00$export$f40f41df328ebc38 = new (0, $e928d3664c9ed565$export$2e2bcd8739ae039)("antSlideUpOut", {
    "0%": {
        transform: "scaleY(1)",
        transformOrigin: "0% 0%",
        opacity: 1
    },
    "100%": {
        transform: "scaleY(0.8)",
        transformOrigin: "0% 0%",
        opacity: 0
    }
});
const $ff153a7980a78f00$export$dd9f089fa5e819fe = new (0, $e928d3664c9ed565$export$2e2bcd8739ae039)("antSlideDownIn", {
    "0%": {
        transform: "scaleY(0.8)",
        transformOrigin: "100% 100%",
        opacity: 0
    },
    "100%": {
        transform: "scaleY(1)",
        transformOrigin: "100% 100%",
        opacity: 1
    }
});
const $ff153a7980a78f00$export$f7243fdb9c27c3b7 = new (0, $e928d3664c9ed565$export$2e2bcd8739ae039)("antSlideDownOut", {
    "0%": {
        transform: "scaleY(1)",
        transformOrigin: "100% 100%",
        opacity: 1
    },
    "100%": {
        transform: "scaleY(0.8)",
        transformOrigin: "100% 100%",
        opacity: 0
    }
});
const $ff153a7980a78f00$export$2ad3a07c3513a54 = new (0, $e928d3664c9ed565$export$2e2bcd8739ae039)("antSlideLeftIn", {
    "0%": {
        transform: "scaleX(0.8)",
        transformOrigin: "0% 0%",
        opacity: 0
    },
    "100%": {
        transform: "scaleX(1)",
        transformOrigin: "0% 0%",
        opacity: 1
    }
});
const $ff153a7980a78f00$export$486fbda27512d5a9 = new (0, $e928d3664c9ed565$export$2e2bcd8739ae039)("antSlideLeftOut", {
    "0%": {
        transform: "scaleX(1)",
        transformOrigin: "0% 0%",
        opacity: 1
    },
    "100%": {
        transform: "scaleX(0.8)",
        transformOrigin: "0% 0%",
        opacity: 0
    }
});
const $ff153a7980a78f00$export$dd03ad46dbbcd7e0 = new (0, $e928d3664c9ed565$export$2e2bcd8739ae039)("antSlideRightIn", {
    "0%": {
        transform: "scaleX(0.8)",
        transformOrigin: "100% 0%",
        opacity: 0
    },
    "100%": {
        transform: "scaleX(1)",
        transformOrigin: "100% 0%",
        opacity: 1
    }
});
const $ff153a7980a78f00$export$db8e3c9b93664f34 = new (0, $e928d3664c9ed565$export$2e2bcd8739ae039)("antSlideRightOut", {
    "0%": {
        transform: "scaleX(1)",
        transformOrigin: "100% 0%",
        opacity: 1
    },
    "100%": {
        transform: "scaleX(0.8)",
        transformOrigin: "100% 0%",
        opacity: 0
    }
});
const $ff153a7980a78f00$var$slideMotion = {
    "slide-up": {
        inKeyframes: $ff153a7980a78f00$export$e801b802b037de6a,
        outKeyframes: $ff153a7980a78f00$export$f40f41df328ebc38
    },
    "slide-down": {
        inKeyframes: $ff153a7980a78f00$export$dd9f089fa5e819fe,
        outKeyframes: $ff153a7980a78f00$export$f7243fdb9c27c3b7
    },
    "slide-left": {
        inKeyframes: $ff153a7980a78f00$export$2ad3a07c3513a54,
        outKeyframes: $ff153a7980a78f00$export$486fbda27512d5a9
    },
    "slide-right": {
        inKeyframes: $ff153a7980a78f00$export$dd03ad46dbbcd7e0,
        outKeyframes: $ff153a7980a78f00$export$db8e3c9b93664f34
    }
};
const $ff153a7980a78f00$export$9018e60daecf7a6c = (token, motionName)=>{
    const { antCls: antCls } = token;
    const motionCls = `${antCls}-${motionName}`;
    const { inKeyframes: inKeyframes, outKeyframes: outKeyframes } = $ff153a7980a78f00$var$slideMotion[motionName];
    return [
        (0, $bae41aa9cbf75fc8$export$83e1da9e09ec9112)(motionCls, inKeyframes, outKeyframes, token.motionDurationMid),
        {
            [`
      ${motionCls}-enter,
      ${motionCls}-appear
    `]: {
                transform: "scale(0)",
                transformOrigin: "0% 0%",
                opacity: 0,
                animationTimingFunction: token.motionEaseOutQuint,
                "&-prepare": {
                    transform: "scale(1)"
                }
            },
            [`${motionCls}-leave`]: {
                animationTimingFunction: token.motionEaseInQuint
            }
        }
    ];
};




const $08ad494e60f91a82$var$getHorizontalStyle = (token)=>{
    const { componentCls: componentCls, motionDurationSlow: motionDurationSlow, horizontalLineHeight: horizontalLineHeight, colorSplit: colorSplit, lineWidth: lineWidth, lineType: lineType, itemPaddingInline: itemPaddingInline } = token;
    return {
        [`${componentCls}-horizontal`]: {
            lineHeight: horizontalLineHeight,
            border: 0,
            borderBottom: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(lineWidth)} ${lineType} ${colorSplit}`,
            boxShadow: "none",
            "&::after": {
                display: "block",
                clear: "both",
                height: 0,
                content: '"\\20"'
            },
            // ======================= Item =======================
            [`${componentCls}-item, ${componentCls}-submenu`]: {
                position: "relative",
                display: "inline-block",
                verticalAlign: "bottom",
                paddingInline: itemPaddingInline
            },
            [`> ${componentCls}-item:hover,
        > ${componentCls}-item-active,
        > ${componentCls}-submenu ${componentCls}-submenu-title:hover`]: {
                backgroundColor: "transparent"
            },
            [`${componentCls}-item, ${componentCls}-submenu-title`]: {
                transition: [
                    `border-color`,
                    `background-color`
                ].map((prop)=>`${prop} ${motionDurationSlow}`).join(",")
            },
            // ===================== Sub Menu =====================
            [`${componentCls}-submenu-arrow`]: {
                display: "none"
            }
        }
    };
};
var $08ad494e60f91a82$export$2e2bcd8739ae039 = $08ad494e60f91a82$var$getHorizontalStyle;



const $624f6d7c90cf11c6$var$getRTLStyle = ({ componentCls: componentCls, menuArrowOffset: menuArrowOffset, calc: calc })=>({
        [`${componentCls}-rtl`]: {
            direction: "rtl"
        },
        [`${componentCls}-submenu-rtl`]: {
            transformOrigin: "100% 0"
        },
        // Vertical Arrow
        [`${componentCls}-rtl${componentCls}-vertical,
    ${componentCls}-submenu-rtl ${componentCls}-vertical`]: {
            [`${componentCls}-submenu-arrow`]: {
                "&::before": {
                    transform: `rotate(-45deg) translateY(${(0, $05f34ed03d41967d$export$523c0b569236b342)(calc(menuArrowOffset).mul(-1).equal())})`
                },
                "&::after": {
                    transform: `rotate(45deg) translateY(${(0, $05f34ed03d41967d$export$523c0b569236b342)(menuArrowOffset)})`
                }
            }
        }
    });
var $624f6d7c90cf11c6$export$2e2bcd8739ae039 = $624f6d7c90cf11c6$var$getRTLStyle;




const $43b4abc831ab5e3d$var$accessibilityFocus = (token)=>(0, $519d20bf207ce864$export$6539948f0a737e39)(token);
const $43b4abc831ab5e3d$var$getThemeStyle = (token, themeSuffix)=>{
    const { componentCls: componentCls, itemColor: itemColor, itemSelectedColor: itemSelectedColor, subMenuItemSelectedColor: subMenuItemSelectedColor, groupTitleColor: groupTitleColor, itemBg: itemBg, subMenuItemBg: subMenuItemBg, itemSelectedBg: itemSelectedBg, activeBarHeight: activeBarHeight, activeBarWidth: activeBarWidth, activeBarBorderWidth: activeBarBorderWidth, motionDurationSlow: motionDurationSlow, motionEaseInOut: motionEaseInOut, motionEaseOut: motionEaseOut, itemPaddingInline: itemPaddingInline, motionDurationMid: motionDurationMid, itemHoverColor: itemHoverColor, lineType: lineType, colorSplit: colorSplit, itemDisabledColor: // Disabled
    itemDisabledColor, dangerItemColor: // Danger
    dangerItemColor, dangerItemHoverColor: dangerItemHoverColor, dangerItemSelectedColor: dangerItemSelectedColor, dangerItemActiveBg: dangerItemActiveBg, dangerItemSelectedBg: dangerItemSelectedBg, popupBg: // Bg
    popupBg, itemHoverBg: itemHoverBg, itemActiveBg: itemActiveBg, menuSubMenuBg: menuSubMenuBg, horizontalItemSelectedColor: // Horizontal
    horizontalItemSelectedColor, horizontalItemSelectedBg: horizontalItemSelectedBg, horizontalItemBorderRadius: horizontalItemBorderRadius, horizontalItemHoverBg: horizontalItemHoverBg } = token;
    return {
        [`${componentCls}-${themeSuffix}, ${componentCls}-${themeSuffix} > ${componentCls}`]: {
            color: itemColor,
            background: itemBg,
            [`&${componentCls}-root:focus-visible`]: {
                ...$43b4abc831ab5e3d$var$accessibilityFocus(token)
            },
            // ======================== Item ========================
            [`${componentCls}-item`]: {
                "&-group-title, &-extra": {
                    color: groupTitleColor
                }
            },
            [`${componentCls}-submenu-selected > ${componentCls}-submenu-title`]: {
                color: subMenuItemSelectedColor
            },
            [`${componentCls}-item, ${componentCls}-submenu-title`]: {
                color: itemColor,
                [`&:not(${componentCls}-item-disabled):focus-visible`]: {
                    ...$43b4abc831ab5e3d$var$accessibilityFocus(token)
                }
            },
            // Disabled
            [`${componentCls}-item-disabled, ${componentCls}-submenu-disabled`]: {
                color: `${itemDisabledColor} !important`
            },
            // Hover
            [`${componentCls}-item:not(${componentCls}-item-selected):not(${componentCls}-submenu-selected)`]: {
                [`&:hover, > ${componentCls}-submenu-title:hover`]: {
                    color: itemHoverColor
                }
            },
            // SubMenu active (when hover on parent menu item)
            [`${componentCls}-submenu:not(${componentCls}-submenu-selected)`]: {
                [`> ${componentCls}-submenu-title:hover`]: {
                    color: itemHoverColor
                }
            },
            [`&:not(${componentCls}-horizontal)`]: {
                [`${componentCls}-item:not(${componentCls}-item-selected)`]: {
                    "&:hover": {
                        backgroundColor: itemHoverBg
                    },
                    "&:active": {
                        backgroundColor: itemActiveBg
                    }
                },
                [`${componentCls}-submenu-title`]: {
                    "&:hover": {
                        backgroundColor: itemHoverBg
                    },
                    "&:active": {
                        backgroundColor: itemActiveBg
                    }
                }
            },
            // Danger - only Item has
            [`${componentCls}-item-danger`]: {
                color: dangerItemColor,
                [`&${componentCls}-item:hover`]: {
                    [`&:not(${componentCls}-item-selected):not(${componentCls}-submenu-selected)`]: {
                        color: dangerItemHoverColor
                    }
                },
                [`&${componentCls}-item:active`]: {
                    background: dangerItemActiveBg
                }
            },
            [`${componentCls}-item a`]: {
                "&, &:hover": {
                    color: "inherit"
                }
            },
            [`${componentCls}-item-selected`]: {
                color: itemSelectedColor,
                // Danger
                [`&${componentCls}-item-danger`]: {
                    color: dangerItemSelectedColor
                },
                "a, a:hover": {
                    color: "inherit"
                }
            },
            [`& ${componentCls}-item-selected`]: {
                backgroundColor: itemSelectedBg,
                // Danger
                [`&${componentCls}-item-danger`]: {
                    backgroundColor: dangerItemSelectedBg
                }
            },
            [`&${componentCls}-submenu > ${componentCls}`]: {
                backgroundColor: menuSubMenuBg
            },
            // ===== 设置浮层的颜色 =======
            // ！dark 模式会被popupBg 会被rest 为 darkPopupBg
            [`&${componentCls}-popup > ${componentCls}`]: {
                backgroundColor: popupBg
            },
            [`&${componentCls}-submenu-popup > ${componentCls}`]: {
                backgroundColor: popupBg
            },
            // ===== 设置浮层的颜色 end =======
            // ====================== Horizontal ======================
            [`&${componentCls}-horizontal`]: {
                ...themeSuffix === "dark" ? {
                    borderBottom: 0
                } : {},
                [`> ${componentCls}-item, > ${componentCls}-submenu`]: {
                    top: activeBarBorderWidth,
                    marginTop: token.calc(activeBarBorderWidth).mul(-1).equal(),
                    marginBottom: 0,
                    borderRadius: horizontalItemBorderRadius,
                    "&::after": {
                        position: "absolute",
                        insetInline: itemPaddingInline,
                        bottom: 0,
                        borderBottom: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(activeBarHeight)} solid transparent`,
                        transition: `border-color ${motionDurationSlow} ${motionEaseInOut}`,
                        content: '""'
                    },
                    "&:hover, &-active, &-open": {
                        background: horizontalItemHoverBg,
                        "&::after": {
                            borderBottomWidth: activeBarHeight,
                            borderBottomColor: horizontalItemSelectedColor
                        }
                    },
                    "&-selected": {
                        color: horizontalItemSelectedColor,
                        backgroundColor: horizontalItemSelectedBg,
                        "&:hover": {
                            backgroundColor: horizontalItemSelectedBg
                        },
                        "&::after": {
                            borderBottomWidth: activeBarHeight,
                            borderBottomColor: horizontalItemSelectedColor
                        }
                    }
                }
            },
            // ================== Inline & Vertical ===================
            //
            [`&${componentCls}-root`]: {
                [`&${componentCls}-inline, &${componentCls}-vertical`]: {
                    borderInlineEnd: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(activeBarBorderWidth)} ${lineType} ${colorSplit}`
                }
            },
            // ======================== Inline ========================
            [`&${componentCls}-inline`]: {
                // Sub
                [`${componentCls}-sub${componentCls}-inline`]: {
                    background: subMenuItemBg
                },
                [`${componentCls}-item`]: {
                    position: "relative",
                    "&::after": {
                        position: "absolute",
                        insetBlock: 0,
                        insetInlineEnd: 0,
                        borderInlineEnd: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(activeBarWidth)} solid ${itemSelectedColor}`,
                        transform: "scaleY(0.0001)",
                        opacity: 0,
                        transition: [
                            `transform`,
                            `opacity`
                        ].map((prop)=>`${prop} ${motionDurationMid} ${motionEaseOut}`).join(","),
                        content: '""'
                    },
                    // Danger
                    [`&${componentCls}-item-danger`]: {
                        "&::after": {
                            borderInlineEndColor: dangerItemSelectedColor
                        }
                    }
                },
                [`${componentCls}-selected, ${componentCls}-item-selected`]: {
                    "&::after": {
                        transform: "scaleY(1)",
                        opacity: 1,
                        transition: [
                            `transform`,
                            `opacity`
                        ].map((prop)=>`${prop} ${motionDurationMid} ${motionEaseInOut}`).join(",")
                    }
                }
            }
        }
    };
};
var $43b4abc831ab5e3d$export$2e2bcd8739ae039 = $43b4abc831ab5e3d$var$getThemeStyle;




const $fb2b01bbf147c2ad$var$getVerticalInlineStyle = (token)=>{
    const { componentCls: componentCls, itemHeight: itemHeight, itemMarginInline: itemMarginInline, padding: padding, menuArrowSize: menuArrowSize, marginXS: marginXS, itemMarginBlock: itemMarginBlock, itemWidth: itemWidth, itemPaddingInline: itemPaddingInline } = token;
    const paddingWithArrow = token.calc(menuArrowSize).add(padding).add(marginXS).equal();
    return {
        [`${componentCls}-item`]: {
            position: "relative",
            overflow: "hidden"
        },
        [`${componentCls}-item, ${componentCls}-submenu-title`]: {
            height: itemHeight,
            lineHeight: (0, $05f34ed03d41967d$export$523c0b569236b342)(itemHeight),
            paddingInline: itemPaddingInline,
            overflow: "hidden",
            textOverflow: "ellipsis",
            marginInline: itemMarginInline,
            marginBlock: itemMarginBlock,
            width: itemWidth
        },
        [`> ${componentCls}-item,
            > ${componentCls}-submenu > ${componentCls}-submenu-title`]: {
            height: itemHeight,
            lineHeight: (0, $05f34ed03d41967d$export$523c0b569236b342)(itemHeight)
        },
        [`${componentCls}-item-group-list ${componentCls}-submenu-title,
            ${componentCls}-submenu-title`]: {
            paddingInlineEnd: paddingWithArrow
        }
    };
};
const $fb2b01bbf147c2ad$var$getVerticalStyle = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, itemHeight: itemHeight, colorTextLightSolid: colorTextLightSolid, dropdownWidth: dropdownWidth, controlHeightLG: controlHeightLG, motionEaseOut: motionEaseOut, padding: padding, paddingXL: paddingXL, itemMarginInline: itemMarginInline, fontSizeLG: fontSizeLG, motionDurationFast: motionDurationFast, motionDurationSlow: motionDurationSlow, paddingXS: paddingXS, boxShadowSecondary: boxShadowSecondary, collapsedWidth: collapsedWidth, collapsedIconSize: collapsedIconSize } = token;
    const inlineItemStyle = {
        height: itemHeight,
        lineHeight: (0, $05f34ed03d41967d$export$523c0b569236b342)(itemHeight),
        listStylePosition: "inside",
        listStyleType: "disc"
    };
    return [
        {
            [componentCls]: {
                "&-inline, &-vertical": {
                    [`&${componentCls}-root`]: {
                        boxShadow: "none"
                    },
                    ...$fb2b01bbf147c2ad$var$getVerticalInlineStyle(token)
                }
            },
            [`${componentCls}-submenu-popup`]: {
                [`${componentCls}-vertical`]: {
                    ...$fb2b01bbf147c2ad$var$getVerticalInlineStyle(token),
                    boxShadow: boxShadowSecondary
                }
            }
        },
        // Vertical only
        {
            [`${componentCls}-submenu-popup ${componentCls}-vertical${componentCls}-sub`]: {
                minWidth: dropdownWidth,
                maxHeight: `calc(100vh - ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.calc(controlHeightLG).mul(2.5).equal())})`,
                padding: "0",
                overflow: "hidden",
                borderInlineEnd: 0,
                // https://github.com/ant-design/ant-design/issues/22244
                // https://github.com/ant-design/ant-design/issues/26812
                "&:not([class*='-active'])": {
                    overflowX: "hidden",
                    overflowY: "auto"
                }
            }
        },
        // Inline Only
        {
            [`${componentCls}-inline`]: {
                width: "100%",
                // Motion enhance for first level
                [`&${componentCls}-root`]: {
                    [`${componentCls}-item, ${componentCls}-submenu-title`]: {
                        display: "flex",
                        alignItems: "center",
                        transition: [
                            `border-color ${motionDurationSlow}`,
                            `background-color ${motionDurationSlow}`,
                            `padding ${motionDurationFast} ${motionEaseOut}`
                        ].join(","),
                        [`> ${componentCls}-title-content`]: {
                            flex: "auto",
                            minWidth: 0,
                            overflow: "hidden",
                            textOverflow: "ellipsis"
                        },
                        "> *": {
                            flex: "none"
                        }
                    }
                },
                // >>>>> Sub
                [`${componentCls}-sub${componentCls}-inline`]: {
                    padding: 0,
                    border: 0,
                    borderRadius: 0,
                    boxShadow: "none",
                    [`& > ${componentCls}-submenu > ${componentCls}-submenu-title`]: inlineItemStyle,
                    [`& ${componentCls}-item-group-title`]: {
                        paddingInlineStart: paddingXL
                    }
                },
                // >>>>> Item
                [`${componentCls}-item`]: inlineItemStyle
            }
        },
        // Inline Collapse Only
        {
            [`${componentCls}-inline-collapsed`]: {
                width: collapsedWidth,
                [`&${componentCls}-root`]: {
                    [`${componentCls}-item, ${componentCls}-submenu ${componentCls}-submenu-title`]: {
                        [`> ${componentCls}-inline-collapsed-noicon`]: {
                            fontSize: fontSizeLG,
                            textAlign: "center",
                            width: "100%"
                        }
                    }
                },
                [`> ${componentCls}-item,
          > ${componentCls}-item-group > ${componentCls}-item-group-list > ${componentCls}-item,
          > ${componentCls}-item-group > ${componentCls}-item-group-list > ${componentCls}-submenu > ${componentCls}-submenu-title,
          > ${componentCls}-submenu > ${componentCls}-submenu-title`]: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    insetInlineStart: 0,
                    paddingInline: `calc(50% - ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.calc(collapsedIconSize).div(2).equal())} - ${(0, $05f34ed03d41967d$export$523c0b569236b342)(itemMarginInline)})`,
                    textOverflow: "clip",
                    [`
            ${componentCls}-submenu-arrow,
            ${componentCls}-submenu-expand-icon
          `]: {
                        opacity: 0
                    },
                    [`> ${componentCls}-title-content`]: {
                        width: 0,
                        opacity: 0,
                        overflow: "hidden"
                    },
                    [`${componentCls}-item-icon, ${iconCls}`]: {
                        margin: 0,
                        fontSize: collapsedIconSize,
                        lineHeight: (0, $05f34ed03d41967d$export$523c0b569236b342)(itemHeight),
                        "+ span": {
                            display: "inline-block",
                            width: 0,
                            opacity: 0,
                            overflow: "hidden",
                            marginInlineStart: 0
                        }
                    }
                },
                [`${componentCls}-item-icon, ${iconCls}`]: {
                    display: "inline-block"
                },
                "&-tooltip": {
                    pointerEvents: "none",
                    [`${componentCls}-item-icon, ${iconCls}`]: {
                        display: "none"
                    },
                    [`${componentCls}-item-extra`]: {
                        paddingInlineStart: padding
                    },
                    "a, a:hover": {
                        color: colorTextLightSolid
                    }
                },
                [`${componentCls}-item-group-title`]: {
                    ...(0, $519d20bf207ce864$export$b2b65df0d0824629),
                    paddingInline: paddingXS
                }
            }
        }
    ];
};
var $fb2b01bbf147c2ad$export$2e2bcd8739ae039 = $fb2b01bbf147c2ad$var$getVerticalStyle;


const $d0a99ff8c40e103c$var$genMenuItemStyle = (token)=>{
    const { componentCls: componentCls, motionDurationSlow: motionDurationSlow, motionDurationMid: motionDurationMid, motionEaseInOut: motionEaseInOut, motionEaseOut: motionEaseOut, iconCls: iconCls, iconSize: iconSize, iconMarginInlineEnd: iconMarginInlineEnd } = token;
    return {
        // >>>>> Item
        [`${componentCls}-item, ${componentCls}-submenu-title`]: {
            position: "relative",
            display: "block",
            margin: 0,
            whiteSpace: "nowrap",
            cursor: "pointer",
            transition: [
                `border-color ${motionDurationSlow}`,
                `background-color ${motionDurationSlow}`,
                `padding calc(${motionDurationSlow} + 0.1s) ${motionEaseInOut}`
            ].join(","),
            [`${componentCls}-item-icon, ${iconCls}`]: {
                minWidth: iconSize,
                fontSize: iconSize,
                transition: [
                    `font-size ${motionDurationMid} ${motionEaseOut}`,
                    `margin ${motionDurationSlow} ${motionEaseInOut}`,
                    `color ${motionDurationSlow}`
                ].join(","),
                "+ span": {
                    marginInlineStart: iconMarginInlineEnd,
                    opacity: 1,
                    transition: [
                        `opacity ${motionDurationSlow} ${motionEaseInOut}`,
                        `margin ${motionDurationSlow}`,
                        `color ${motionDurationSlow}`
                    ].join(",")
                }
            },
            [`${componentCls}-item-icon`]: {
                ...(0, $519d20bf207ce864$export$171ccda7bc085e59)()
            },
            [`&${componentCls}-item-only-child`]: {
                [`> ${iconCls}, > ${componentCls}-item-icon`]: {
                    marginInlineEnd: 0
                }
            }
        },
        // Disabled state sets text to gray and nukes hover/tab effects
        [`${componentCls}-item-disabled, ${componentCls}-submenu-disabled`]: {
            background: "none !important",
            cursor: "not-allowed",
            "&::after": {
                borderColor: "transparent !important"
            },
            a: {
                color: "inherit !important",
                cursor: "not-allowed",
                pointerEvents: "none"
            },
            [`> ${componentCls}-submenu-title`]: {
                color: "inherit !important",
                cursor: "not-allowed"
            }
        }
    };
};
const $d0a99ff8c40e103c$var$genSubMenuArrowStyle = (token)=>{
    const { componentCls: componentCls, motionDurationSlow: motionDurationSlow, motionEaseInOut: motionEaseInOut, borderRadius: borderRadius, menuArrowSize: menuArrowSize, menuArrowOffset: menuArrowOffset } = token;
    return {
        [`${componentCls}-submenu`]: {
            "&-expand-icon, &-arrow": {
                position: "absolute",
                top: "50%",
                insetInlineEnd: token.margin,
                width: menuArrowSize,
                color: "currentcolor",
                transform: "translateY(-50%)",
                transition: [
                    "transform",
                    "opacity"
                ].map((prop)=>`${prop} ${motionDurationSlow}`).join(",")
            },
            "&-arrow": {
                // →
                "&::before, &::after": {
                    position: "absolute",
                    width: token.calc(menuArrowSize).mul(0.6).equal(),
                    height: token.calc(menuArrowSize).mul(0.15).equal(),
                    backgroundColor: "currentcolor",
                    borderRadius: borderRadius,
                    transition: [
                        `background-color`,
                        `transform`,
                        `top`,
                        `color`
                    ].map((prop)=>`${prop} ${motionDurationSlow} ${motionEaseInOut}`).join(","),
                    content: '""'
                },
                "&::before": {
                    transform: `rotate(45deg) translateY(${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.calc(menuArrowOffset).mul(-1).equal())})`
                },
                "&::after": {
                    transform: `rotate(-45deg) translateY(${(0, $05f34ed03d41967d$export$523c0b569236b342)(menuArrowOffset)})`
                }
            }
        }
    };
};
// =============================== Base ===============================
const $d0a99ff8c40e103c$var$getBaseStyle = (token)=>{
    const { antCls: antCls, componentCls: componentCls, fontSize: fontSize, motionDurationSlow: motionDurationSlow, motionDurationMid: motionDurationMid, motionEaseInOut: motionEaseInOut, paddingXS: paddingXS, padding: padding, colorSplit: colorSplit, lineWidth: lineWidth, zIndexPopup: zIndexPopup, borderRadiusLG: borderRadiusLG, subMenuItemBorderRadius: subMenuItemBorderRadius, menuArrowSize: menuArrowSize, menuArrowOffset: menuArrowOffset, lineType: lineType, groupTitleLineHeight: groupTitleLineHeight, groupTitleFontSize: groupTitleFontSize, iconSize: iconSize, iconMarginInlineEnd: iconMarginInlineEnd } = token;
    const titleContentTypographyEllipsisSelector = [
        `> ${antCls}-typography-ellipsis-single-line`,
        `> ${componentCls}-item-label > ${antCls}-typography-ellipsis-single-line`
    ].join(",");
    return [
        // Misc
        {
            "": {
                [componentCls]: {
                    ...(0, $519d20bf207ce864$export$8c467e8859fdef13)(),
                    // Hidden
                    "&-hidden": {
                        display: "none"
                    }
                }
            },
            [`${componentCls}-submenu-hidden`]: {
                display: "none"
            }
        },
        {
            [componentCls]: {
                ...(0, $519d20bf207ce864$export$23997c3e44cc1c59)(token),
                ...(0, $519d20bf207ce864$export$8c467e8859fdef13)(),
                marginBottom: 0,
                paddingInlineStart: 0,
                fontSize: // Override default ul/ol
                fontSize,
                lineHeight: 0,
                // Fix display inline-block gap
                listStyle: "none",
                outline: "none",
                // Magic cubic here but smooth transition
                transition: `width ${motionDurationSlow} cubic-bezier(0.2, 0, 0, 1) 0s`,
                "ul, ol": {
                    margin: 0,
                    padding: 0,
                    listStyle: "none"
                },
                // Overflow ellipsis
                "&-overflow": {
                    display: "flex",
                    [`${componentCls}-item`]: {
                        flex: "none"
                    }
                },
                [`${componentCls}-item, ${componentCls}-submenu, ${componentCls}-submenu-title`]: {
                    borderRadius: token.itemBorderRadius
                },
                [`${componentCls}-item-group-title`]: {
                    padding: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(paddingXS)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(padding)}`,
                    fontSize: groupTitleFontSize,
                    lineHeight: groupTitleLineHeight,
                    transition: `all ${motionDurationSlow}`
                },
                [`&-horizontal ${componentCls}-submenu`]: {
                    transition: [
                        `border-color`,
                        `background-color`
                    ].map((prop)=>`${prop} ${motionDurationSlow} ${motionEaseInOut}`).join(",")
                },
                [`${componentCls}-submenu, ${componentCls}-submenu-inline`]: {
                    transition: [
                        `border-color ${motionDurationSlow}`,
                        `background-color ${motionDurationSlow}`,
                        `padding ${motionDurationMid}`
                    ].map((prop)=>`${prop} ${motionEaseInOut}`).join(",")
                },
                [`${componentCls}-submenu ${componentCls}-sub`]: {
                    cursor: "initial",
                    transition: [
                        `background-color`,
                        `padding`
                    ].map((prop)=>`${prop} ${motionDurationSlow} ${motionEaseInOut}`).join(",")
                },
                [`${componentCls}-title-content`]: {
                    transition: `color ${motionDurationSlow}`,
                    "&-with-extra": {
                        display: "inline-flex",
                        alignItems: "center",
                        width: "100%",
                        minWidth: 0
                    },
                    [`${componentCls}-item-label`]: {
                        flex: "auto",
                        minWidth: 0,
                        ...(0, $519d20bf207ce864$export$b2b65df0d0824629)
                    },
                    // https://github.com/ant-design/ant-design/issues/41143
                    [titleContentTypographyEllipsisSelector]: {
                        display: "inline",
                        verticalAlign: "unset"
                    },
                    [`${componentCls}-item-extra`]: {
                        flex: "none",
                        marginInlineStart: "auto",
                        paddingInlineStart: token.padding
                    }
                },
                [`${componentCls}-item-icon + ${componentCls}-title-content-with-extra`]: {
                    width: `calc(100% - ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.calc(iconSize).add(iconMarginInlineEnd ?? 0).equal())})`
                },
                [`${componentCls}-item a`]: {
                    "&::before": {
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "transparent",
                        content: '""'
                    }
                },
                // Removed a Badge related style seems it's safe
                // https://github.com/ant-design/ant-design/issues/19809
                // >>>>> Divider
                [`${componentCls}-item-divider`]: {
                    overflow: "hidden",
                    lineHeight: 0,
                    borderColor: colorSplit,
                    borderStyle: lineType,
                    borderWidth: 0,
                    borderTopWidth: lineWidth,
                    marginBlock: lineWidth,
                    padding: 0,
                    "&-dashed": {
                        borderStyle: "dashed"
                    }
                },
                // Item
                ...$d0a99ff8c40e103c$var$genMenuItemStyle(token),
                [`${componentCls}-item-group`]: {
                    [`${componentCls}-item-group-list`]: {
                        margin: 0,
                        padding: 0,
                        [`${componentCls}-item, ${componentCls}-submenu-title`]: {
                            paddingInline: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.calc(fontSize).mul(2).equal())} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(padding)}`
                        }
                    }
                },
                // ======================= Sub Menu =======================
                "&-submenu": {
                    "&-popup": {
                        position: "absolute",
                        zIndex: zIndexPopup,
                        borderRadius: borderRadiusLG,
                        boxShadow: "none",
                        transformOrigin: "0 0",
                        [`&${componentCls}-submenu`]: {
                            background: "transparent"
                        },
                        // https://github.com/ant-design/ant-design/issues/13955
                        "&::before": {
                            position: "absolute",
                            inset: 0,
                            zIndex: -1,
                            width: "100%",
                            height: "100%",
                            opacity: 0,
                            content: '""'
                        },
                        [`> ${componentCls}`]: {
                            borderRadius: borderRadiusLG,
                            ...$d0a99ff8c40e103c$var$genMenuItemStyle(token),
                            ...$d0a99ff8c40e103c$var$genSubMenuArrowStyle(token),
                            [`${componentCls}-item, ${componentCls}-submenu > ${componentCls}-submenu-title`]: {
                                borderRadius: subMenuItemBorderRadius
                            },
                            [`${componentCls}-submenu-title::after`]: {
                                transition: `transform ${motionDurationSlow} ${motionEaseInOut}`
                            }
                        }
                    },
                    "&-placement-leftTop, &-placement-bottomRight": {
                        transformOrigin: "100% 0"
                    },
                    "&-placement-leftBottom, &-placement-topRight": {
                        transformOrigin: "100% 100%"
                    },
                    "&-placement-rightBottom, &-placement-topLeft": {
                        transformOrigin: "0 100%"
                    },
                    "&-placement-bottomLeft, &-placement-rightTop": {
                        transformOrigin: "0 0"
                    },
                    "&-placement-leftTop, &-placement-leftBottom": {
                        paddingInlineEnd: token.paddingXS
                    },
                    "&-placement-rightTop, &-placement-rightBottom": {
                        paddingInlineStart: token.paddingXS
                    },
                    "&-placement-topRight, &-placement-topLeft": {
                        paddingBottom: token.paddingXS
                    },
                    "&-placement-bottomRight, &-placement-bottomLeft": {
                        paddingTop: token.paddingXS
                    }
                },
                ...$d0a99ff8c40e103c$var$genSubMenuArrowStyle(token),
                [`&-inline-collapsed ${componentCls}-submenu-arrow,
        &-inline ${componentCls}-submenu-arrow`]: {
                    // ↓
                    "&::before": {
                        transform: `rotate(-45deg) translateX(${(0, $05f34ed03d41967d$export$523c0b569236b342)(menuArrowOffset)})`
                    },
                    "&::after": {
                        transform: `rotate(45deg) translateX(${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.calc(menuArrowOffset).mul(-1).equal())})`
                    }
                },
                [`${componentCls}-submenu-open${componentCls}-submenu-inline > ${componentCls}-submenu-title > ${componentCls}-submenu-arrow`]: {
                    // ↑
                    transform: `translateY(${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.calc(menuArrowSize).mul(0.2).mul(-1).equal())})`,
                    "&::after": {
                        transform: `rotate(-45deg) translateX(${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.calc(menuArrowOffset).mul(-1).equal())})`
                    },
                    "&::before": {
                        transform: `rotate(45deg) translateX(${(0, $05f34ed03d41967d$export$523c0b569236b342)(menuArrowOffset)})`
                    }
                }
            }
        },
        // Integration with header element so menu items have the same height
        {
            [`${antCls}-layout-header`]: {
                [componentCls]: {
                    lineHeight: "inherit"
                }
            }
        }
    ];
};
const $d0a99ff8c40e103c$export$9ca1be8807fe0675 = (token)=>{
    const { colorPrimary: colorPrimary, colorError: colorError, colorTextDisabled: colorTextDisabled, colorErrorBg: colorErrorBg, colorText: colorText, colorTextDescription: colorTextDescription, colorBgContainer: colorBgContainer, colorFillAlter: colorFillAlter, colorFillContent: colorFillContent, lineWidth: lineWidth, lineWidthBold: lineWidthBold, controlItemBgActive: controlItemBgActive, colorBgTextHover: colorBgTextHover, controlHeightLG: controlHeightLG, lineHeight: lineHeight, colorBgElevated: colorBgElevated, marginXXS: marginXXS, padding: padding, fontSize: fontSize, controlHeightSM: controlHeightSM, fontSizeLG: fontSizeLG, colorTextLightSolid: colorTextLightSolid, colorErrorHover: colorErrorHover } = token;
    const activeBarWidth = token.activeBarWidth ?? 0;
    const activeBarBorderWidth = token.activeBarBorderWidth ?? lineWidth;
    const itemMarginInline = token.itemMarginInline ?? token.marginXXS;
    const colorTextDark = new (0, $3bb84f07fb2a2f32$export$2c4f38d6c0ecc25a)(colorTextLightSolid).setA(0.65).toRgbString();
    return {
        dropdownWidth: 160,
        zIndexPopup: token.zIndexPopupBase + 50,
        radiusItem: token.borderRadiusLG,
        itemBorderRadius: token.borderRadiusLG,
        radiusSubMenuItem: token.borderRadiusSM,
        subMenuItemBorderRadius: token.borderRadiusSM,
        colorItemText: colorText,
        itemColor: colorText,
        colorItemTextHover: colorText,
        itemHoverColor: colorText,
        colorItemTextHoverHorizontal: colorPrimary,
        horizontalItemHoverColor: colorPrimary,
        colorGroupTitle: colorTextDescription,
        groupTitleColor: colorTextDescription,
        colorItemTextSelected: colorPrimary,
        itemSelectedColor: colorPrimary,
        subMenuItemSelectedColor: colorPrimary,
        colorItemTextSelectedHorizontal: colorPrimary,
        horizontalItemSelectedColor: colorPrimary,
        colorItemBg: colorBgContainer,
        itemBg: colorBgContainer,
        colorItemBgHover: colorBgTextHover,
        itemHoverBg: colorBgTextHover,
        colorItemBgActive: colorFillContent,
        itemActiveBg: controlItemBgActive,
        colorSubItemBg: colorFillAlter,
        subMenuItemBg: colorFillAlter,
        colorItemBgSelected: controlItemBgActive,
        itemSelectedBg: controlItemBgActive,
        colorItemBgSelectedHorizontal: "transparent",
        horizontalItemSelectedBg: "transparent",
        colorActiveBarWidth: 0,
        activeBarWidth: activeBarWidth,
        colorActiveBarHeight: lineWidthBold,
        activeBarHeight: lineWidthBold,
        colorActiveBarBorderSize: lineWidth,
        activeBarBorderWidth: activeBarBorderWidth,
        // Disabled
        colorItemTextDisabled: colorTextDisabled,
        itemDisabledColor: colorTextDisabled,
        // Danger
        colorDangerItemText: colorError,
        dangerItemColor: colorError,
        colorDangerItemTextHover: colorError,
        dangerItemHoverColor: colorError,
        colorDangerItemTextSelected: colorError,
        dangerItemSelectedColor: colorError,
        colorDangerItemBgActive: colorErrorBg,
        dangerItemActiveBg: colorErrorBg,
        colorDangerItemBgSelected: colorErrorBg,
        dangerItemSelectedBg: colorErrorBg,
        itemMarginInline: itemMarginInline,
        horizontalItemBorderRadius: 0,
        horizontalItemHoverBg: "transparent",
        itemHeight: controlHeightLG,
        groupTitleLineHeight: lineHeight,
        collapsedWidth: controlHeightLG * 2,
        popupBg: colorBgElevated,
        itemMarginBlock: marginXXS,
        itemPaddingInline: padding,
        horizontalLineHeight: `${controlHeightLG * 1.15}px`,
        iconSize: fontSize,
        iconMarginInlineEnd: controlHeightSM - fontSize,
        collapsedIconSize: fontSizeLG,
        groupTitleFontSize: fontSize,
        // Disabled
        darkItemDisabledColor: new (0, $3bb84f07fb2a2f32$export$2c4f38d6c0ecc25a)(colorTextLightSolid).setA(0.25).toRgbString(),
        // Dark
        darkItemColor: colorTextDark,
        darkDangerItemColor: colorError,
        darkItemBg: "#001529",
        darkPopupBg: "#001529",
        darkSubMenuItemBg: "#000c17",
        darkItemSelectedColor: colorTextLightSolid,
        darkItemSelectedBg: colorPrimary,
        darkDangerItemSelectedBg: colorError,
        darkItemHoverBg: "transparent",
        darkGroupTitleColor: colorTextDark,
        darkItemHoverColor: colorTextLightSolid,
        darkDangerItemHoverColor: colorErrorHover,
        darkDangerItemSelectedColor: colorTextLightSolid,
        darkDangerItemActiveBg: colorError,
        // internal
        itemWidth: activeBarWidth ? `calc(100% + ${activeBarBorderWidth}px)` : `calc(100% - ${itemMarginInline * 2}px)`
    };
};
var // ============================== Export ==============================
$d0a99ff8c40e103c$export$2e2bcd8739ae039 = (prefixCls, rootCls = prefixCls, injectStyle = true)=>{
    const useStyle = (0, $6870d4d7c14ae0bb$export$51ec95de45185b42)("Menu", (token)=>{
        const { colorBgElevated: colorBgElevated, controlHeightLG: controlHeightLG, fontSize: fontSize, darkItemColor: darkItemColor, darkDangerItemColor: darkDangerItemColor, darkItemBg: darkItemBg, darkSubMenuItemBg: darkSubMenuItemBg, darkItemSelectedColor: darkItemSelectedColor, darkItemSelectedBg: darkItemSelectedBg, darkDangerItemSelectedBg: darkDangerItemSelectedBg, darkItemHoverBg: darkItemHoverBg, darkGroupTitleColor: darkGroupTitleColor, darkItemHoverColor: darkItemHoverColor, darkItemDisabledColor: darkItemDisabledColor, darkDangerItemHoverColor: darkDangerItemHoverColor, darkDangerItemSelectedColor: darkDangerItemSelectedColor, darkDangerItemActiveBg: darkDangerItemActiveBg, popupBg: popupBg, darkPopupBg: darkPopupBg } = token;
        const menuArrowSize = token.calc(fontSize).div(7).mul(5).equal();
        // Menu Token
        const menuToken = (0, $fef50f256b80dfa5$export$4950aa0f605343fb)(token, {
            menuArrowSize: menuArrowSize,
            menuHorizontalHeight: token.calc(controlHeightLG).mul(1.15).equal(),
            menuArrowOffset: token.calc(menuArrowSize).mul(0.25).equal(),
            menuSubMenuBg: colorBgElevated,
            calc: token.calc,
            popupBg: popupBg
        });
        const menuDarkToken = (0, $fef50f256b80dfa5$export$4950aa0f605343fb)(menuToken, {
            itemColor: darkItemColor,
            itemHoverColor: darkItemHoverColor,
            groupTitleColor: darkGroupTitleColor,
            itemSelectedColor: darkItemSelectedColor,
            subMenuItemSelectedColor: darkItemSelectedColor,
            itemBg: darkItemBg,
            popupBg: darkPopupBg,
            subMenuItemBg: darkSubMenuItemBg,
            itemActiveBg: "transparent",
            itemSelectedBg: darkItemSelectedBg,
            activeBarHeight: 0,
            activeBarBorderWidth: 0,
            itemHoverBg: darkItemHoverBg,
            // Disabled
            itemDisabledColor: darkItemDisabledColor,
            // Danger
            dangerItemColor: darkDangerItemColor,
            dangerItemHoverColor: darkDangerItemHoverColor,
            dangerItemSelectedColor: darkDangerItemSelectedColor,
            dangerItemActiveBg: darkDangerItemActiveBg,
            dangerItemSelectedBg: darkDangerItemSelectedBg,
            menuSubMenuBg: darkSubMenuItemBg,
            // Horizontal
            horizontalItemSelectedColor: darkItemSelectedColor,
            horizontalItemSelectedBg: darkItemSelectedBg
        });
        return [
            // Basic
            $d0a99ff8c40e103c$var$getBaseStyle(menuToken),
            // Horizontal
            (0, $08ad494e60f91a82$export$2e2bcd8739ae039)(menuToken),
            // Hard code for some light style
            // Vertical
            (0, $fb2b01bbf147c2ad$export$2e2bcd8739ae039)(menuToken),
            // Hard code for some light style
            // Theme
            (0, $43b4abc831ab5e3d$export$2e2bcd8739ae039)(menuToken, "light"),
            (0, $43b4abc831ab5e3d$export$2e2bcd8739ae039)(menuDarkToken, "dark"),
            // RTL
            (0, $624f6d7c90cf11c6$export$2e2bcd8739ae039)(menuToken),
            // Motion
            (0, $3576e621578e370a$export$2e2bcd8739ae039)(menuToken),
            (0, $ff153a7980a78f00$export$9018e60daecf7a6c)(menuToken, "slide-up"),
            (0, $ff153a7980a78f00$export$9018e60daecf7a6c)(menuToken, "slide-down"),
            (0, $35f7d6eebd10a5fe$export$f5d123412490d9dc)(menuToken, "zoom-big")
        ];
    }, $d0a99ff8c40e103c$export$9ca1be8807fe0675, {
        deprecatedTokens: [
            [
                "colorGroupTitle",
                "groupTitleColor"
            ],
            [
                "radiusItem",
                "itemBorderRadius"
            ],
            [
                "radiusSubMenuItem",
                "subMenuItemBorderRadius"
            ],
            [
                "colorItemText",
                "itemColor"
            ],
            [
                "colorItemTextHover",
                "itemHoverColor"
            ],
            [
                "colorItemTextHoverHorizontal",
                "horizontalItemHoverColor"
            ],
            [
                "colorItemTextSelected",
                "itemSelectedColor"
            ],
            [
                "colorItemTextSelectedHorizontal",
                "horizontalItemSelectedColor"
            ],
            [
                "colorItemTextDisabled",
                "itemDisabledColor"
            ],
            [
                "colorDangerItemText",
                "dangerItemColor"
            ],
            [
                "colorDangerItemTextHover",
                "dangerItemHoverColor"
            ],
            [
                "colorDangerItemTextSelected",
                "dangerItemSelectedColor"
            ],
            [
                "colorDangerItemBgActive",
                "dangerItemActiveBg"
            ],
            [
                "colorDangerItemBgSelected",
                "dangerItemSelectedBg"
            ],
            [
                "colorItemBg",
                "itemBg"
            ],
            [
                "colorItemBgHover",
                "itemHoverBg"
            ],
            [
                "colorSubItemBg",
                "subMenuItemBg"
            ],
            [
                "colorItemBgActive",
                "itemActiveBg"
            ],
            [
                "colorItemBgSelectedHorizontal",
                "horizontalItemSelectedBg"
            ],
            [
                "colorActiveBarWidth",
                "activeBarWidth"
            ],
            [
                "colorActiveBarHeight",
                "activeBarHeight"
            ],
            [
                "colorActiveBarBorderSize",
                "activeBarBorderWidth"
            ],
            [
                "colorItemBgSelected",
                "itemSelectedBg"
            ]
        ],
        injectStyle: // Dropdown will handle menu style self. We do not need to handle this.
        injectStyle,
        unitless: {
            groupTitleLineHeight: true
        }
    });
    return useStyle(prefixCls, rootCls);
};



var $cQmXV = parcelRequire("cQmXV");






"use client";
const $efee3d42041f5be7$var$SubMenu = (props)=>{
    const { popupClassName: popupClassName, icon: icon, title: title, theme: customTheme } = props;
    const context = $cQmXV.useContext((0, $d4856615573199b1$export$2e2bcd8739ae039));
    const { prefixCls: prefixCls, inlineCollapsed: inlineCollapsed, theme: contextTheme, classNames: classNames, styles: styles } = context;
    const parentPath = (0, $bf3002d33db0f6a4$export$d3d2d0a05677870a)();
    let titleNode;
    if (!icon) titleNode = inlineCollapsed && !parentPath.length && title && typeof title === "string" ? /*#__PURE__*/ $cQmXV.createElement("div", {
        className: `${prefixCls}-inline-collapsed-noicon`
    }, title.charAt(0)) : /*#__PURE__*/ $cQmXV.createElement("span", {
        className: `${prefixCls}-title-content`
    }, title);
    else {
        // inline-collapsed.md demo 依赖 span 来隐藏文字,有 icon 属性，则内部包裹一个 span
        // ref: https://github.com/ant-design/ant-design/pull/23456
        const titleIsSpan = /*#__PURE__*/ $cQmXV.isValidElement(title) && title.type === "span";
        titleNode = /*#__PURE__*/ $cQmXV.createElement($cQmXV.Fragment, null, (0, $a91ef204d03d8eec$export$e530037191fcd5d7)(icon, (oriProps)=>({
                className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(oriProps.className, `${prefixCls}-item-icon`, classNames?.itemIcon),
                style: {
                    ...oriProps.style,
                    ...styles?.itemIcon
                }
            })), titleIsSpan ? title : /*#__PURE__*/ $cQmXV.createElement("span", {
            className: `${prefixCls}-title-content`
        }, title));
    }
    const contextValue = $cQmXV.useMemo(()=>({
            ...context,
            firstLevel: false
        }), [
        context
    ]);
    // ============================ zIndex ============================
    const [zIndex] = (0, $b2b300e6909d7707$export$3e7906d4075187a4)("Menu");
    return /*#__PURE__*/ $cQmXV.createElement((0, $d4856615573199b1$export$2e2bcd8739ae039).Provider, {
        value: contextValue
    }, /*#__PURE__*/ $cQmXV.createElement((0, $15b59d86bf5e5a20$export$2e2bcd8739ae039), {
        ...(0, $e8c5093aebad6025$export$2e2bcd8739ae039)(props, [
            "icon"
        ]),
        title: titleNode,
        classNames: {
            list: classNames?.subMenu?.list,
            listTitle: classNames?.subMenu?.itemTitle
        },
        styles: {
            list: styles?.subMenu?.list,
            listTitle: styles?.subMenu?.itemTitle
        },
        popupClassName: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, popupClassName, classNames?.popup?.root, `${prefixCls}-${customTheme || contextTheme}`),
        popupStyle: {
            zIndex: zIndex,
            // fix: https://github.com/ant-design/ant-design/issues/47826#issuecomment-2360737237
            ...props.popupStyle,
            ...styles?.popup?.root
        }
    }));
};
var $efee3d42041f5be7$export$2e2bcd8739ae039 = $efee3d42041f5be7$var$SubMenu;


"use client";
function $fac1715adac1f3e2$var$isEmptyIcon(icon) {
    return icon === null || icon === false;
}
const $fac1715adac1f3e2$var$MENU_COMPONENTS = {
    item: (0, $eada6d81760a5fb4$export$2e2bcd8739ae039),
    submenu: (0, $efee3d42041f5be7$export$2e2bcd8739ae039),
    divider: (0, $5daebba96b0340f8$export$2e2bcd8739ae039)
};
const $fac1715adac1f3e2$var$InternalMenu = /*#__PURE__*/ (0, $cQmXV.forwardRef)((props, ref)=>{
    const override = $cQmXV.useContext((0, $7e4ae2ec58dd3044$export$2e2bcd8739ae039));
    const overrideObj = override || {};
    const { prefixCls: customizePrefixCls, className: className, style: style, theme: theme = "light", expandIcon: expandIcon, _internalDisableMenuItemTitleTooltip: _internalDisableMenuItemTitleTooltip, tooltip: tooltip, inlineCollapsed: inlineCollapsed, siderCollapsed: siderCollapsed, rootClassName: rootClassName, mode: mode, selectable: selectable, onClick: onClick, overflowedIndicatorPopupClassName: overflowedIndicatorPopupClassName, classNames: classNames, styles: styles, ...restProps } = props;
    const { menu: menu } = $cQmXV.useContext((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    const { getPrefixCls: getPrefixCls, getPopupContainer: getPopupContainer, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("menu");
    const rootPrefixCls = getPrefixCls();
    const passedProps = (0, $e8c5093aebad6025$export$2e2bcd8739ae039)(restProps, [
        "collapsedWidth"
    ]);
    overrideObj.validator?.({
        mode: mode
    });
    // ========================== Click ==========================
    // Tell dropdown that item clicked
    const onItemClick = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((...args)=>{
        onClick?.(...args);
        overrideObj.onClick?.();
    });
    // ========================== Mode ===========================
    const mergedMode = overrideObj.mode || mode;
    // ======================= Selectable ========================
    const mergedSelectable = selectable ?? overrideObj.selectable;
    // ======================== Collapsed ========================
    // Inline Collapsed
    const mergedInlineCollapsed = inlineCollapsed ?? siderCollapsed;
    // ================ Merged Props for Semantic ================
    const mergedProps = {
        ...props,
        mode: mergedMode,
        inlineCollapsed: mergedInlineCollapsed,
        selectable: mergedSelectable,
        theme: theme
    };
    const contextStyleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $30c5f9f911d4f61b$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: mergedProps
    }, {
        popup: {
            _default: "root"
        },
        subMenu: {
            _default: "item"
        }
    });
    const defaultMotions = {
        horizontal: {
            motionName: `${rootPrefixCls}-slide-up`
        },
        inline: (0, $047a5f051ebda8ba$export$2e2bcd8739ae039)(rootPrefixCls),
        other: {
            motionName: `${rootPrefixCls}-zoom-big`
        }
    };
    const prefixCls = getPrefixCls("menu", customizePrefixCls || overrideObj.prefixCls);
    const rootCls = (0, $2237081acd3cfc09$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $d0a99ff8c40e103c$export$2e2bcd8739ae039)(prefixCls, rootCls, !override);
    const menuClassName = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-${theme}`, contextClassName, className);
    // ====================== ExpandIcon ========================
    const mergedExpandIcon = $cQmXV.useMemo(()=>{
        if ((0, $8e2d153a3c855782$export$f6e2535fb5126e54)(expandIcon) || $fac1715adac1f3e2$var$isEmptyIcon(expandIcon)) return expandIcon || null;
        if ((0, $8e2d153a3c855782$export$f6e2535fb5126e54)(overrideObj.expandIcon) || $fac1715adac1f3e2$var$isEmptyIcon(overrideObj.expandIcon)) return overrideObj.expandIcon || null;
        if ((0, $8e2d153a3c855782$export$f6e2535fb5126e54)(menu?.expandIcon) || $fac1715adac1f3e2$var$isEmptyIcon(menu?.expandIcon)) return menu?.expandIcon || null;
        const mergedIcon = expandIcon ?? overrideObj?.expandIcon ?? menu?.expandIcon;
        return (0, $a91ef204d03d8eec$export$e530037191fcd5d7)(mergedIcon, {
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-submenu-expand-icon`, /*#__PURE__*/ $cQmXV.isValidElement(mergedIcon) ? mergedIcon.props?.className : undefined)
        });
    }, [
        expandIcon,
        overrideObj?.expandIcon,
        menu?.expandIcon,
        prefixCls
    ]);
    // ======================== Context ==========================
    const contextValue = $cQmXV.useMemo(()=>({
            prefixCls: prefixCls,
            inlineCollapsed: mergedInlineCollapsed || false,
            direction: direction,
            firstLevel: true,
            theme: theme,
            mode: mergedMode,
            disableMenuItemTitleTooltip: _internalDisableMenuItemTitleTooltip,
            tooltip: tooltip,
            classNames: mergedClassNames,
            styles: mergedStyles
        }), [
        prefixCls,
        mergedInlineCollapsed,
        direction,
        _internalDisableMenuItemTitleTooltip,
        theme,
        mergedMode,
        mergedClassNames,
        mergedStyles,
        tooltip
    ]);
    // ========================= Render ==========================
    return /*#__PURE__*/ $cQmXV.createElement((0, $7e4ae2ec58dd3044$export$2e2bcd8739ae039).Provider, {
        value: null
    }, /*#__PURE__*/ $cQmXV.createElement((0, $d4856615573199b1$export$2e2bcd8739ae039).Provider, {
        value: contextValue
    }, /*#__PURE__*/ $cQmXV.createElement((0, $f2204382bfad12ac$export$2e2bcd8739ae039), {
        getPopupContainer: getPopupContainer,
        overflowedIndicator: /*#__PURE__*/ $cQmXV.createElement((0, $f172eb883972dae9$export$2e2bcd8739ae039), null),
        overflowedIndicatorPopupClassName: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-${theme}`, overflowedIndicatorPopupClassName),
        classNames: {
            list: mergedClassNames.list,
            listTitle: mergedClassNames.itemTitle
        },
        styles: {
            list: mergedStyles.list,
            listTitle: mergedStyles.itemTitle
        },
        mode: mergedMode,
        selectable: mergedSelectable,
        onClick: onItemClick,
        ...passedProps,
        inlineCollapsed: mergedInlineCollapsed,
        style: mergedStyles.root,
        className: menuClassName,
        prefixCls: prefixCls,
        direction: direction,
        defaultMotions: defaultMotions,
        expandIcon: mergedExpandIcon,
        ref: ref,
        rootClassName: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(rootClassName, hashId, overrideObj.rootClassName, cssVarCls, rootCls, mergedClassNames.root),
        _internalComponents: $fac1715adac1f3e2$var$MENU_COMPONENTS
    })));
});
var $fac1715adac1f3e2$export$2e2bcd8739ae039 = $fac1715adac1f3e2$var$InternalMenu;





"use client";
const $9669e71ca8202aee$var$Menu = /*#__PURE__*/ (0, $cQmXV.forwardRef)((props, ref)=>{
    const menuRef = (0, $cQmXV.useRef)(null);
    const context = $cQmXV.useContext((0, $89ef2fa4f6587b8b$export$63554aebd2a6d54c));
    (0, $cQmXV.useImperativeHandle)(ref, ()=>({
            menu: menuRef.current,
            focus: (options)=>{
                menuRef.current?.focus(options);
            }
        }));
    return /*#__PURE__*/ $cQmXV.createElement((0, $fac1715adac1f3e2$export$2e2bcd8739ae039), {
        ref: menuRef,
        ...props,
        ...context
    });
});
$9669e71ca8202aee$var$Menu.Item = (0, $eada6d81760a5fb4$export$2e2bcd8739ae039);
$9669e71ca8202aee$var$Menu.SubMenu = (0, $efee3d42041f5be7$export$2e2bcd8739ae039);
$9669e71ca8202aee$var$Menu.Divider = (0, $5daebba96b0340f8$export$2e2bcd8739ae039);
$9669e71ca8202aee$var$Menu.ItemGroup = (0, $6a91e202943b1752$export$2e2bcd8739ae039);
var $9669e71ca8202aee$export$2e2bcd8739ae039 = $9669e71ca8202aee$var$Menu;








const $23de50b91f818ff9$export$c81b62e088da1305 = new (0, $e928d3664c9ed565$export$2e2bcd8739ae039)("antMoveDownIn", {
    "0%": {
        transform: "translate3d(0, 100%, 0)",
        transformOrigin: "0 0",
        opacity: 0
    },
    "100%": {
        transform: "translate3d(0, 0, 0)",
        transformOrigin: "0 0",
        opacity: 1
    }
});
const $23de50b91f818ff9$export$6c1eca72ac4f6672 = new (0, $e928d3664c9ed565$export$2e2bcd8739ae039)("antMoveDownOut", {
    "0%": {
        transform: "translate3d(0, 0, 0)",
        transformOrigin: "0 0",
        opacity: 1
    },
    "100%": {
        transform: "translate3d(0, 100%, 0)",
        transformOrigin: "0 0",
        opacity: 0
    }
});
const $23de50b91f818ff9$export$8dd54688d033571 = new (0, $e928d3664c9ed565$export$2e2bcd8739ae039)("antMoveLeftIn", {
    "0%": {
        transform: "translate3d(-100%, 0, 0)",
        transformOrigin: "0 0",
        opacity: 0
    },
    "100%": {
        transform: "translate3d(0, 0, 0)",
        transformOrigin: "0 0",
        opacity: 1
    }
});
const $23de50b91f818ff9$export$be161c4e647bea9b = new (0, $e928d3664c9ed565$export$2e2bcd8739ae039)("antMoveLeftOut", {
    "0%": {
        transform: "translate3d(0, 0, 0)",
        transformOrigin: "0 0",
        opacity: 1
    },
    "100%": {
        transform: "translate3d(-100%, 0, 0)",
        transformOrigin: "0 0",
        opacity: 0
    }
});
const $23de50b91f818ff9$export$a984c43131c7d145 = new (0, $e928d3664c9ed565$export$2e2bcd8739ae039)("antMoveRightIn", {
    "0%": {
        transform: "translate3d(100%, 0, 0)",
        transformOrigin: "0 0",
        opacity: 0
    },
    "100%": {
        transform: "translate3d(0, 0, 0)",
        transformOrigin: "0 0",
        opacity: 1
    }
});
const $23de50b91f818ff9$export$e141ac6798b476df = new (0, $e928d3664c9ed565$export$2e2bcd8739ae039)("antMoveRightOut", {
    "0%": {
        transform: "translate3d(0, 0, 0)",
        transformOrigin: "0 0",
        opacity: 1
    },
    "100%": {
        transform: "translate3d(100%, 0, 0)",
        transformOrigin: "0 0",
        opacity: 0
    }
});
const $23de50b91f818ff9$export$ab676201eaaca05 = new (0, $e928d3664c9ed565$export$2e2bcd8739ae039)("antMoveUpIn", {
    "0%": {
        transform: "translate3d(0, -100%, 0)",
        transformOrigin: "0 0",
        opacity: 0
    },
    "100%": {
        transform: "translate3d(0, 0, 0)",
        transformOrigin: "0 0",
        opacity: 1
    }
});
const $23de50b91f818ff9$export$ec1b91b8ec2f6331 = new (0, $e928d3664c9ed565$export$2e2bcd8739ae039)("antMoveUpOut", {
    "0%": {
        transform: "translate3d(0, 0, 0)",
        transformOrigin: "0 0",
        opacity: 1
    },
    "100%": {
        transform: "translate3d(0, -100%, 0)",
        transformOrigin: "0 0",
        opacity: 0
    }
});
const $23de50b91f818ff9$var$moveMotion = {
    "move-up": {
        inKeyframes: $23de50b91f818ff9$export$ab676201eaaca05,
        outKeyframes: $23de50b91f818ff9$export$ec1b91b8ec2f6331
    },
    "move-down": {
        inKeyframes: $23de50b91f818ff9$export$c81b62e088da1305,
        outKeyframes: $23de50b91f818ff9$export$6c1eca72ac4f6672
    },
    "move-left": {
        inKeyframes: $23de50b91f818ff9$export$8dd54688d033571,
        outKeyframes: $23de50b91f818ff9$export$be161c4e647bea9b
    },
    "move-right": {
        inKeyframes: $23de50b91f818ff9$export$a984c43131c7d145,
        outKeyframes: $23de50b91f818ff9$export$e141ac6798b476df
    }
};
const $23de50b91f818ff9$export$913b1b7e3288c319 = (token, motionName)=>{
    const { antCls: antCls } = token;
    const motionCls = `${antCls}-${motionName}`;
    const { inKeyframes: inKeyframes, outKeyframes: outKeyframes } = $23de50b91f818ff9$var$moveMotion[motionName];
    return [
        (0, $bae41aa9cbf75fc8$export$83e1da9e09ec9112)(motionCls, inKeyframes, outKeyframes, token.motionDurationMid),
        {
            [`
        ${motionCls}-enter,
        ${motionCls}-appear
      `]: {
                opacity: 0,
                animationTimingFunction: token.motionEaseOutCirc
            },
            [`${motionCls}-leave`]: {
                animationTimingFunction: token.motionEaseInOutCirc
            }
        }
    ];
};





const $5a8c54e52772976a$var$genStatusStyle = (token)=>{
    const { componentCls: componentCls, menuCls: menuCls, colorError: colorError, colorTextLightSolid: colorTextLightSolid } = token;
    const itemCls = `${menuCls}-item`;
    return {
        [`${componentCls}, ${componentCls}-menu-submenu`]: {
            [`${menuCls} ${itemCls}`]: {
                [`&${itemCls}-danger:not(${itemCls}-disabled)`]: {
                    color: colorError,
                    "&:hover": {
                        color: colorTextLightSolid,
                        backgroundColor: colorError
                    }
                }
            }
        }
    };
};
var $5a8c54e52772976a$export$2e2bcd8739ae039 = $5a8c54e52772976a$var$genStatusStyle;


// =============================== Base ===============================
const $53f7984deecb2c3e$var$genBaseStyle = (token)=>{
    const { componentCls: componentCls, menuCls: menuCls, zIndexPopup: zIndexPopup, dropdownArrowDistance: dropdownArrowDistance, sizePopupArrow: sizePopupArrow, antCls: antCls, iconCls: iconCls, motionDurationMid: motionDurationMid, paddingBlock: paddingBlock, fontSize: fontSize, dropdownEdgeChildPadding: dropdownEdgeChildPadding, colorTextDisabled: colorTextDisabled, fontSizeIcon: fontSizeIcon, controlPaddingHorizontal: controlPaddingHorizontal, colorBgElevated: colorBgElevated, controlHeightLG: controlHeightLG } = token;
    return [
        {
            [componentCls]: {
                position: "absolute",
                top: -9999,
                left: {
                    _skip_check_: true,
                    value: -9999
                },
                zIndex: zIndexPopup,
                display: "block",
                // A placeholder out of dropdown visible range to avoid close when user moving
                "&::before": {
                    position: "absolute",
                    insetBlock: token.calc(sizePopupArrow).div(2).sub(dropdownArrowDistance).equal(),
                    // insetInlineStart: -7, // FIXME: Seems not work for hidden element
                    zIndex: -9999,
                    opacity: 0.0001,
                    content: '""'
                },
                // Makes vertical dropdowns have a scrollbar once they become taller than the viewport.
                // Leave some viewport spacing so the menu stays on-screen when the trigger is centered.
                // https://github.com/ant-design/ant-design/issues/56044
                "&-menu-vertical": {
                    maxHeight: `calc(100vh - ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.calc(controlHeightLG).mul(2.5).equal())})`,
                    overflowY: "auto"
                },
                [`&-trigger${antCls}-btn`]: {
                    [`& > ${iconCls}-down, & > ${antCls}-btn-icon > ${iconCls}-down`]: {
                        fontSize: fontSizeIcon
                    }
                },
                [`${componentCls}-wrap`]: {
                    position: "relative",
                    [`${antCls}-btn > ${iconCls}-down`]: {
                        fontSize: fontSizeIcon
                    },
                    [`${iconCls}-down::before`]: {
                        transition: `transform ${motionDurationMid}`
                    }
                },
                [`${componentCls}-wrap-open`]: {
                    [`${iconCls}-down::before`]: {
                        transform: `rotate(180deg)`
                    }
                },
                "&-hidden, &-menu-hidden, &-menu-submenu-hidden": {
                    display: "none"
                },
                // =============================================================
                // ==                         Motion                          ==
                // =============================================================
                // When position is not enough for dropdown, the placement will revert.
                // We will handle this with revert motion name.
                [`&${antCls}-slide-down-enter${antCls}-slide-down-enter-active${componentCls}-placement-bottomLeft,
          &${antCls}-slide-down-appear${antCls}-slide-down-appear-active${componentCls}-placement-bottomLeft,
          &${antCls}-slide-down-enter${antCls}-slide-down-enter-active${componentCls}-placement-bottom,
          &${antCls}-slide-down-appear${antCls}-slide-down-appear-active${componentCls}-placement-bottom,
          &${antCls}-slide-down-enter${antCls}-slide-down-enter-active${componentCls}-placement-bottomRight,
          &${antCls}-slide-down-appear${antCls}-slide-down-appear-active${componentCls}-placement-bottomRight`]: {
                    animationName: (0, $ff153a7980a78f00$export$e801b802b037de6a)
                },
                [`&${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-placement-topLeft,
          &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-placement-topLeft,
          &${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-placement-top,
          &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-placement-top,
          &${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-placement-topRight,
          &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-placement-topRight`]: {
                    animationName: (0, $ff153a7980a78f00$export$dd9f089fa5e819fe)
                },
                [`&${antCls}-slide-down-leave${antCls}-slide-down-leave-active${componentCls}-placement-bottomLeft,
          &${antCls}-slide-down-leave${antCls}-slide-down-leave-active${componentCls}-placement-bottom,
          &${antCls}-slide-down-leave${antCls}-slide-down-leave-active${componentCls}-placement-bottomRight`]: {
                    animationName: (0, $ff153a7980a78f00$export$f40f41df328ebc38)
                },
                [`&${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-placement-topLeft,
          &${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-placement-top,
          &${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-placement-topRight`]: {
                    animationName: (0, $ff153a7980a78f00$export$f7243fdb9c27c3b7)
                },
                [`&${antCls}-slide-right-enter${antCls}-slide-right-enter-active${componentCls}-placement-right,
          &${antCls}-slide-right-appear${antCls}-slide-right-appear-active${componentCls}-placement-right,
          &${antCls}-slide-right-enter${antCls}-slide-right-enter-active${componentCls}-placement-rightTop,
          &${antCls}-slide-right-appear${antCls}-slide-right-appear-active${componentCls}-placement-rightTop,
          &${antCls}-slide-right-enter${antCls}-slide-right-enter-active${componentCls}-placement-rightBottom,
          &${antCls}-slide-right-appear${antCls}-slide-right-appear-active${componentCls}-placement-rightBottom`]: {
                    animationName: (0, $ff153a7980a78f00$export$2ad3a07c3513a54)
                },
                [`&${antCls}-slide-left-enter${antCls}-slide-left-enter-active${componentCls}-placement-left,
          &${antCls}-slide-left-appear${antCls}-slide-left-appear-active${componentCls}-placement-left,
          &${antCls}-slide-left-enter${antCls}-slide-left-enter-active${componentCls}-placement-leftTop,
          &${antCls}-slide-left-appear${antCls}-slide-left-appear-active${componentCls}-placement-leftTop,
          &${antCls}-slide-left-enter${antCls}-slide-left-enter-active${componentCls}-placement-leftBottom,
          &${antCls}-slide-left-appear${antCls}-slide-left-appear-active${componentCls}-placement-leftBottom`]: {
                    animationName: (0, $ff153a7980a78f00$export$dd03ad46dbbcd7e0)
                },
                [`&${antCls}-slide-right-leave${antCls}-slide-right-leave-active${componentCls}-placement-right,
          &${antCls}-slide-right-leave${antCls}-slide-right-leave-active${componentCls}-placement-rightTop,
          &${antCls}-slide-right-leave${antCls}-slide-right-leave-active${componentCls}-placement-rightBottom`]: {
                    animationName: (0, $ff153a7980a78f00$export$486fbda27512d5a9)
                },
                [`&${antCls}-slide-left-leave${antCls}-slide-left-leave-active${componentCls}-placement-left,
          &${antCls}-slide-left-leave${antCls}-slide-left-leave-active${componentCls}-placement-leftTop,
          &${antCls}-slide-left-leave${antCls}-slide-left-leave-active${componentCls}-placement-leftBottom`]: {
                    animationName: (0, $ff153a7980a78f00$export$db8e3c9b93664f34)
                }
            }
        },
        // =============================================================
        // ==                        Arrow style                      ==
        // =============================================================
        (0, $dc42b38f8ad9a4d1$export$2e2bcd8739ae039)(token, colorBgElevated),
        {
            // =============================================================
            // ==                          Menu                           ==
            // =============================================================
            [`${componentCls} ${menuCls}`]: {
                position: "relative",
                margin: 0
            },
            [`${menuCls}-submenu-popup`]: {
                position: "absolute",
                zIndex: zIndexPopup,
                background: "transparent",
                boxShadow: "none",
                transformOrigin: "0 0",
                "ul, li": {
                    listStyle: "none",
                    margin: 0
                }
            },
            [`${componentCls}, ${componentCls}-menu-submenu`]: {
                ...(0, $519d20bf207ce864$export$23997c3e44cc1c59)(token),
                [menuCls]: {
                    padding: dropdownEdgeChildPadding,
                    listStyleType: "none",
                    backgroundColor: colorBgElevated,
                    backgroundClip: "padding-box",
                    borderRadius: token.borderRadiusLG,
                    outline: "none",
                    boxShadow: token.boxShadowSecondary,
                    ...(0, $519d20bf207ce864$export$a44db842bcb28231)(token),
                    "&:empty": {
                        padding: 0,
                        boxShadow: "none"
                    },
                    [`${menuCls}-item-group-title`]: {
                        padding: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(paddingBlock)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(controlPaddingHorizontal)}`,
                        color: token.colorTextDescription,
                        transition: `all ${motionDurationMid}`
                    },
                    // ======================= Item Content =======================
                    [`${menuCls}-item`]: {
                        position: "relative",
                        display: "flex",
                        alignItems: "center"
                    },
                    [`${menuCls}-item-icon`]: {
                        minWidth: fontSize,
                        marginInlineEnd: token.marginXS,
                        fontSize: token.fontSizeSM
                    },
                    [`${menuCls}-title-content`]: {
                        flex: "auto",
                        "&-with-extra": {
                            display: "inline-flex",
                            alignItems: "center",
                            width: "100%"
                        },
                        [`> a, > ${menuCls}-item-label > a`]: {
                            color: "inherit",
                            transition: `all ${motionDurationMid}`,
                            "&:hover": {
                                color: "inherit"
                            },
                            "&::after": {
                                position: "absolute",
                                inset: 0,
                                content: '""'
                            }
                        },
                        [`${menuCls}-item-extra`]: {
                            paddingInlineStart: token.padding,
                            marginInlineStart: "auto",
                            fontSize: token.fontSizeSM,
                            color: token.colorTextDescription
                        }
                    },
                    // =========================== Item ===========================
                    [`${menuCls}-item, ${menuCls}-submenu-title`]: {
                        display: "flex",
                        margin: 0,
                        padding: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(paddingBlock)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(controlPaddingHorizontal)}`,
                        color: token.colorText,
                        fontWeight: "normal",
                        fontSize: fontSize,
                        lineHeight: token.lineHeight,
                        cursor: "pointer",
                        transition: `all ${motionDurationMid}`,
                        borderRadius: token.borderRadiusSM,
                        "&:hover, &-active": {
                            backgroundColor: token.controlItemBgHover
                        },
                        ...(0, $519d20bf207ce864$export$a44db842bcb28231)(token),
                        "&-selected": {
                            color: token.colorPrimary,
                            backgroundColor: token.controlItemBgActive,
                            "&:hover, &-active": {
                                backgroundColor: token.controlItemBgActiveHover
                            }
                        },
                        "&-disabled": {
                            color: colorTextDisabled,
                            cursor: "not-allowed",
                            "&:hover": {
                                color: colorTextDisabled,
                                backgroundColor: colorBgElevated,
                                cursor: "not-allowed"
                            },
                            a: {
                                pointerEvents: "none"
                            }
                        },
                        "&-divider": {
                            height: 1,
                            // By design
                            margin: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.marginXXS)} 0`,
                            overflow: "hidden",
                            lineHeight: 0,
                            backgroundColor: token.colorSplit
                        },
                        [`${componentCls}-menu-submenu-expand-icon`]: {
                            position: "absolute",
                            insetInlineEnd: token.paddingXS,
                            [`${componentCls}-menu-submenu-arrow-icon`]: {
                                marginInlineEnd: "0 !important",
                                color: token.colorIcon,
                                fontSize: fontSizeIcon,
                                fontStyle: "normal"
                            }
                        }
                    },
                    [`${menuCls}-item-group-list`]: {
                        margin: `0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.marginXS)}`,
                        padding: 0,
                        listStyle: "none"
                    },
                    [`${menuCls}-submenu-title`]: {
                        paddingInlineEnd: token.calc(controlPaddingHorizontal).add(token.fontSizeSM).equal()
                    },
                    [`${menuCls}-submenu-vertical`]: {
                        position: "relative"
                    },
                    [`${menuCls}-submenu${menuCls}-submenu-disabled ${componentCls}-menu-submenu-title`]: {
                        [`&, ${componentCls}-menu-submenu-arrow-icon`]: {
                            color: colorTextDisabled,
                            backgroundColor: colorBgElevated,
                            cursor: "not-allowed"
                        }
                    },
                    // https://github.com/ant-design/ant-design/issues/19264
                    [`${menuCls}-submenu-selected ${componentCls}-menu-submenu-title`]: {
                        color: token.colorPrimary
                    }
                }
            }
        },
        // Follow code may reuse in other components
        [
            (0, $ff153a7980a78f00$export$9018e60daecf7a6c)(token, "slide-up"),
            (0, $ff153a7980a78f00$export$9018e60daecf7a6c)(token, "slide-down"),
            (0, $ff153a7980a78f00$export$9018e60daecf7a6c)(token, "slide-left"),
            (0, $ff153a7980a78f00$export$9018e60daecf7a6c)(token, "slide-right"),
            (0, $23de50b91f818ff9$export$913b1b7e3288c319)(token, "move-up"),
            (0, $23de50b91f818ff9$export$913b1b7e3288c319)(token, "move-down"),
            (0, $35f7d6eebd10a5fe$export$f5d123412490d9dc)(token, "zoom-big")
        ]
    ];
};
const $53f7984deecb2c3e$export$9ca1be8807fe0675 = (token)=>({
        zIndexPopup: token.zIndexPopupBase + 50,
        paddingBlock: (token.controlHeight - token.fontSize * token.lineHeight) / 2,
        ...(0, $dc42b38f8ad9a4d1$export$bddc192327bb9823)({
            contentRadius: token.borderRadiusLG,
            limitVerticalRadius: true
        }),
        ...(0, $e1e9e0ec17db0365$export$87e38ee403661ccc)(token)
    });
var $53f7984deecb2c3e$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$51ec95de45185b42)("Dropdown", (token)=>{
    const { marginXXS: marginXXS, sizePopupArrow: sizePopupArrow, paddingXXS: paddingXXS, componentCls: componentCls } = token;
    const dropdownToken = (0, $fef50f256b80dfa5$export$4950aa0f605343fb)(token, {
        menuCls: `${componentCls}-menu`,
        dropdownArrowDistance: token.calc(sizePopupArrow).div(2).add(marginXXS).equal(),
        dropdownEdgeChildPadding: paddingXXS
    });
    return [
        $53f7984deecb2c3e$var$genBaseStyle(dropdownToken),
        (0, $5a8c54e52772976a$export$2e2bcd8739ae039)(dropdownToken)
    ];
}, $53f7984deecb2c3e$export$9ca1be8807fe0675, {
    resetStyle: false
});


"use client";
const $8f2ae9c9297cd2c6$var$_Placements = [
    "topLeft",
    "topCenter",
    "topRight",
    "bottomLeft",
    "bottomCenter",
    "bottomRight",
    "top",
    "bottom",
    "left",
    "leftTop",
    "leftBottom",
    "right",
    "rightTop",
    "rightBottom"
];
const $8f2ae9c9297cd2c6$var$Dropdown = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { menu: menu, arrow: arrow, prefixCls: customizePrefixCls, children: children, trigger: trigger, disabled: disabled, dropdownRender: dropdownRender, popupRender: popupRender, getPopupContainer: getPopupContainer, overlayClassName: overlayClassName, rootClassName: rootClassName, overlayStyle: overlayStyle, open: open, onOpenChange: onOpenChange, mouseEnterDelay: mouseEnterDelay = 0.15, mouseLeaveDelay: mouseLeaveDelay = 0.1, autoAdjustOverflow: autoAdjustOverflow = true, placement: placement = "", transitionName: transitionName, classNames: classNames, styles: styles, destroyPopupOnHide: destroyPopupOnHide, destroyOnHidden: destroyOnHidden } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, getPopupContainer: getContextPopupContainer, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("dropdown");
    const mergedProps = {
        ...props,
        mouseEnterDelay: mouseEnterDelay,
        mouseLeaveDelay: mouseLeaveDelay,
        autoAdjustOverflow: autoAdjustOverflow
    };
    const contextStyleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(contextStyle);
    const overlayStyleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(overlayStyle);
    const [mergedClassNames, mergedStyles] = (0, $30c5f9f911d4f61b$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        overlayStyleRoot
    ], {
        props: mergedProps
    });
    const mergedRootStyles = {
        ...mergedStyles.root
    };
    const mergedPopupRender = popupRender || dropdownRender;
    // =================== Warning =====================
    const warning = (0, $b5822acdae823465$export$cf977aa92c751e61)("Dropdown");
    var deprecatedName, newName;
    const memoTransitionName = $cQmXV.useMemo(()=>{
        const rootPrefixCls = getPrefixCls();
        if (transitionName !== undefined) return transitionName;
        if (placement.startsWith("top")) return `${rootPrefixCls}-slide-down`;
        if (placement.startsWith("left")) return `${rootPrefixCls}-slide-right`;
        if (placement.startsWith("right")) return `${rootPrefixCls}-slide-left`;
        return `${rootPrefixCls}-slide-up`;
    }, [
        getPrefixCls,
        placement,
        transitionName
    ]);
    const memoPlacement = $cQmXV.useMemo(()=>{
        if (!placement) return direction === "rtl" ? "bottomRight" : "bottomLeft";
        if (placement.includes("Center")) return placement.slice(0, placement.indexOf("Center"));
        return placement;
    }, [
        placement,
        direction
    ]);
    const prefixCls = getPrefixCls("dropdown", customizePrefixCls);
    const rootCls = (0, $2237081acd3cfc09$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $53f7984deecb2c3e$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const [, token] = (0, $b22e03a54a548614$export$2e2bcd8739ae039)();
    const child = $cQmXV.Children.only((0, $8e2d153a3c855782$export$c3825b437cbdea5c)(children) ? /*#__PURE__*/ $cQmXV.createElement("span", null, children) : children);
    const composedRef = (0, $10341b937b26f69d$export$1d1c999670a1285d)(ref, (0, $10341b937b26f69d$export$7465e5c0bf44f19a)(child));
    const popupTrigger = (0, $a91ef204d03d8eec$export$e530037191fcd5d7)(child, {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-trigger`, {
            [`${prefixCls}-rtl`]: direction === "rtl"
        }, child.props.className),
        disabled: child.props.disabled ?? disabled,
        ref: composedRef
    });
    const triggerActions = disabled ? [] : trigger;
    const alignPoint = !!triggerActions?.includes("contextMenu");
    // =========================== Open ============================
    const [mergedOpen, setOpen] = (0, $a51866d781137e08$export$2e2bcd8739ae039)(false, open);
    const onInnerOpenChange = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((nextOpen)=>{
        onOpenChange?.(nextOpen, {
            source: "trigger"
        });
        setOpen(nextOpen);
    });
    // =========================== Overlay ============================
    const overlayClassNameCustomized = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(overlayClassName, rootClassName, hashId, cssVarCls, rootCls, contextClassName, mergedClassNames.root, {
        [`${prefixCls}-rtl`]: direction === "rtl"
    });
    const builtinPlacements = (0, $79d8965a045fdc17$export$2e2bcd8739ae039)({
        arrowPointAtCenter: (0, $8e2d153a3c855782$export$53b83ca8eaab0383)(arrow) && arrow.pointAtCenter,
        autoAdjustOverflow: autoAdjustOverflow,
        offset: token.marginXXS,
        arrowWidth: arrow ? token.sizePopupArrow : 0,
        borderRadius: token.borderRadius
    });
    const onMenuClick = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)(()=>{
        if (menu?.selectable && menu?.multiple) return;
        onOpenChange?.(false, {
            source: "menu"
        });
        setOpen(false);
    });
    const renderOverlay = ()=>{
        // @rc-component/dropdown already can process the function of overlay, but we have check logic here.
        // So we need render the element to check and pass back to @rc-component/dropdown.
        const menuClassNames = (0, $e8c5093aebad6025$export$2e2bcd8739ae039)(mergedClassNames, [
            "root"
        ]);
        const menuStyles = (0, $e8c5093aebad6025$export$2e2bcd8739ae039)(mergedStyles, [
            "root"
        ]);
        let overlayNode;
        if (menu?.items) overlayNode = /*#__PURE__*/ $cQmXV.createElement((0, $9669e71ca8202aee$export$2e2bcd8739ae039), {
            ...menu,
            classNames: {
                ...menuClassNames,
                subMenu: {
                    ...menuClassNames
                }
            },
            styles: {
                ...menuStyles,
                subMenu: {
                    ...menuStyles
                }
            }
        });
        if (mergedPopupRender) overlayNode = mergedPopupRender(overlayNode);
        overlayNode = $cQmXV.Children.only(typeof overlayNode === "string" ? /*#__PURE__*/ $cQmXV.createElement("span", null, overlayNode) : overlayNode);
        return /*#__PURE__*/ $cQmXV.createElement((0, $7e4ae2ec58dd3044$export$9bd434816b0530d0), {
            prefixCls: `${prefixCls}-menu`,
            rootClassName: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(cssVarCls, rootCls),
            expandIcon: /*#__PURE__*/ $cQmXV.createElement("span", {
                className: `${prefixCls}-menu-submenu-arrow`
            }, direction === "rtl" ? /*#__PURE__*/ $cQmXV.createElement((0, $0f3c6d60b091c877$export$2e2bcd8739ae039), {
                className: `${prefixCls}-menu-submenu-arrow-icon`
            }) : /*#__PURE__*/ $cQmXV.createElement((0, $89db7229a7e10f8f$export$2e2bcd8739ae039), {
                className: `${prefixCls}-menu-submenu-arrow-icon`
            })),
            mode: "vertical",
            selectable: false,
            onClick: onMenuClick,
            validator: ({ mode: mode })=>{}
        }, overlayNode);
    };
    // =========================== zIndex ============================
    const [zIndex, contextZIndex] = (0, $b2b300e6909d7707$export$3e7906d4075187a4)("Dropdown", mergedRootStyles.zIndex);
    // ============================ Render ============================
    let renderNode = /*#__PURE__*/ $cQmXV.createElement((0, $2674fedb26eedb51$export$2e2bcd8739ae039), {
        alignPoint: alignPoint,
        ...(0, $e8c5093aebad6025$export$2e2bcd8739ae039)(props, [
            "rootClassName",
            "onOpenChange"
        ]),
        mouseEnterDelay: mouseEnterDelay,
        mouseLeaveDelay: mouseLeaveDelay,
        visible: mergedOpen,
        builtinPlacements: builtinPlacements,
        arrow: !!arrow,
        overlayClassName: overlayClassNameCustomized,
        prefixCls: prefixCls,
        getPopupContainer: getPopupContainer || getContextPopupContainer,
        transitionName: memoTransitionName,
        trigger: triggerActions,
        overlay: renderOverlay,
        placement: memoPlacement,
        onVisibleChange: onInnerOpenChange,
        overlayStyle: {
            ...mergedRootStyles,
            zIndex: zIndex
        },
        autoDestroy: destroyOnHidden ?? destroyPopupOnHide
    }, popupTrigger);
    if (zIndex) renderNode = /*#__PURE__*/ $cQmXV.createElement((0, $2a7b32ec1626bb34$export$2e2bcd8739ae039).Provider, {
        value: contextZIndex
    }, renderNode);
    return renderNode;
});
// We don't care debug panel
const $8f2ae9c9297cd2c6$var$PurePanel = (0, $f2e41308375833b9$export$2e2bcd8739ae039)($8f2ae9c9297cd2c6$var$Dropdown, "align", undefined, "dropdown", (prefixCls)=>prefixCls);
/* istanbul ignore next */ const $8f2ae9c9297cd2c6$var$WrapPurePanel = (props)=>/*#__PURE__*/ $cQmXV.createElement($8f2ae9c9297cd2c6$var$PurePanel, {
        ...props
    }, /*#__PURE__*/ $cQmXV.createElement("span", null));
$8f2ae9c9297cd2c6$var$Dropdown._InternalPanelDoNotUseOrYouWillBeFired = $8f2ae9c9297cd2c6$var$WrapPurePanel;
var $8f2ae9c9297cd2c6$export$2e2bcd8739ae039 = $8f2ae9c9297cd2c6$var$Dropdown;



var $cQmXV = parcelRequire("cQmXV");






var $cQmXV = parcelRequire("cQmXV");



function $a3ff185e46cc584b$export$f5153c3888a6824e(size) {
    return [
        "small",
        "middle",
        "medium",
        "large"
    ].includes(size);
}
function $a3ff185e46cc584b$export$1b502d0a9135d42b(size) {
    if (!size) // The case of size = 0 is deliberately excluded here, because the default value of the gap attribute in CSS is 0, so if the user passes 0 in, we can directly ignore it.
    return false;
    return (0, $8e2d153a3c855782$export$7e4aa119212bc614)(size);
}








var $cQmXV = parcelRequire("cQmXV");


const $4a3ea1f9228016b7$var$_InputStatuses = [
    "warning",
    "error",
    "",
    "success",
    "validating"
];
const $4a3ea1f9228016b7$export$b08e7b47149942a2 = (prefixCls, status, hasFeedback)=>{
    return (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)({
        [`${prefixCls}-status-success`]: status === "success",
        [`${prefixCls}-status-warning`]: status === "warning",
        [`${prefixCls}-status-error`]: status === "error",
        [`${prefixCls}-status-validating`]: status === "validating",
        [`${prefixCls}-has-feedback`]: hasFeedback
    });
};
const $4a3ea1f9228016b7$export$314e193082d7ba49 = (contextStatus, customStatus)=>customStatus || contextStatus;








const $d49f0108d42b34a8$var$genSpaceAddonStyle = (token)=>{
    const { componentCls: componentCls, borderRadius: borderRadius, paddingSM: paddingSM, colorBorder: colorBorder, paddingXS: paddingXS, fontSizeLG: fontSizeLG, fontSizeSM: fontSizeSM, borderRadiusLG: borderRadiusLG, borderRadiusSM: borderRadiusSM, colorBgContainerDisabled: colorBgContainerDisabled, lineWidth: lineWidth, lineType: lineType, antCls: antCls } = token;
    const [varName, varRef] = (0, $6870d4d7c14ae0bb$export$d82b8f66c5649e14)(antCls, "space-addon");
    return {
        [componentCls]: [
            // ==========================================================
            // ==                         Base                         ==
            // ==========================================================
            {
                ...(0, $519d20bf207ce864$export$23997c3e44cc1c59)(token),
                display: "inline-flex",
                alignItems: "center",
                gap: 0,
                whiteSpace: "nowrap",
                paddingInline: paddingSM,
                margin: 0,
                borderWidth: lineWidth,
                borderStyle: lineType,
                borderRadius: borderRadius,
                "&:hover": {
                    zIndex: 0
                },
                [`&${componentCls}-disabled`]: {
                    color: token.colorTextDisabled
                },
                "&-large": {
                    fontSize: fontSizeLG,
                    borderRadius: borderRadiusLG
                },
                "&-small": {
                    paddingInline: paddingXS,
                    borderRadius: borderRadiusSM,
                    fontSize: fontSizeSM
                },
                "&-compact-last-item": {
                    borderEndStartRadius: 0,
                    borderStartStartRadius: 0
                },
                "&-compact-first-item": {
                    borderEndEndRadius: 0,
                    borderStartEndRadius: 0
                },
                "&-compact-item:not(:first-child):not(:last-child)": {
                    borderRadius: 0
                },
                "&-compact-item:not(:last-child)": {
                    borderInlineEndWidth: 0
                },
                "&-compact-item:not(:first-child)": {
                    borderInlineStartWidth: 0
                }
            },
            // ==========================================================
            // ==                       Variants                       ==
            // ==========================================================
            {
                [varName("addon-border-color")]: colorBorder,
                [varName("addon-background")]: colorBgContainerDisabled,
                // Filled
                [varName("addon-border-color-outlined")]: colorBorder,
                [varName("addon-background-filled")]: colorBgContainerDisabled,
                borderColor: varRef("addon-border-color"),
                background: varRef("addon-background"),
                // ======================= Outlined =======================
                "&-variant-outlined": {
                    [varName("addon-border-color")]: varRef("addon-border-color-outlined")
                },
                // ======================== Filled ========================
                "&-variant-filled": {
                    [varName("addon-border-color")]: "transparent",
                    [varName("addon-background")]: varRef("addon-background-filled"),
                    // Disabled
                    [`&${componentCls}-disabled`]: {
                        [varName("addon-border-color")]: colorBorder,
                        [varName("addon-background")]: colorBgContainerDisabled
                    }
                },
                // ====================== Borderless ======================
                "&-variant-borderless": {
                    border: "none",
                    background: "transparent"
                },
                // ====================== Underlined ======================
                "&-variant-underlined": {
                    border: "none",
                    background: "transparent"
                }
            },
            // ==========================================================
            // ==                        Status                        ==
            // ==========================================================
            {
                "&-status-error": {
                    [varName("addon-border-color-outlined")]: token.colorError,
                    [varName("addon-background-filled")]: token.colorErrorBg,
                    color: token.colorError
                },
                "&-status-warning": {
                    [varName("addon-border-color-outlined")]: token.colorWarning,
                    [varName("addon-background-filled")]: token.colorWarningBg,
                    color: token.colorWarning
                }
            }
        ]
    };
};
var // ============================== Export ==============================
$d49f0108d42b34a8$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$51ec95de45185b42)("Addon", (token)=>[
        $d49f0108d42b34a8$var$genSpaceAddonStyle(token),
        (0, $6e46145470fc0a51$export$b1208b23589b4b73)(token, {
            focus: false
        })
    ]);


"use client";
const $783061a72adde0bd$var$SpaceAddon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).forwardRef((props, ref)=>{
    const { className: className, children: children, style: style, prefixCls: customizePrefixCls, variant: variant = "outlined", disabled: disabled, status: status, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, direction: directionConfig } = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useContext((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls("space-addon", customizePrefixCls);
    const [hashId, cssVarCls] = (0, $d49f0108d42b34a8$export$2e2bcd8739ae039)(prefixCls);
    const { compactItemClassnames: compactItemClassnames, compactSize: compactSize } = (0, $68fddf51400eda11$export$cd8cf9d7bab8dd4)(prefixCls, directionConfig);
    const statusCls = (0, $4a3ea1f9228016b7$export$b08e7b47149942a2)(prefixCls, status);
    const classes = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, hashId, compactItemClassnames, cssVarCls, `${prefixCls}-variant-${variant}`, statusCls, {
        [`${prefixCls}-${compactSize}`]: compactSize,
        [`${prefixCls}-disabled`]: disabled
    }, className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
        ref: ref,
        className: classes,
        style: style,
        ...restProps
    }, children);
});
var $783061a72adde0bd$export$2e2bcd8739ae039 = $783061a72adde0bd$var$SpaceAddon;




var $cQmXV = parcelRequire("cQmXV");
const $44f4d56e4d2d01a9$export$853f607fd5cc208b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createContext({
    latestIndex: 0
});
const $44f4d56e4d2d01a9$export$2bbf36e6e96e17f9 = $44f4d56e4d2d01a9$export$853f607fd5cc208b.Provider;



var $cQmXV = parcelRequire("cQmXV");



"use client";
const $c32a1030ceca4d2f$var$Item = (props)=>{
    const { className: className, prefix: prefix, index: index, children: children, separator: separator, style: style, classNames: classNames, styles: styles } = props;
    const { latestIndex: latestIndex } = $cQmXV.useContext((0, $44f4d56e4d2d01a9$export$853f607fd5cc208b));
    if (!(0, $8e2d153a3c855782$export$72280d5f896dac9a)(children)) return null;
    return /*#__PURE__*/ $cQmXV.createElement($cQmXV.Fragment, null, /*#__PURE__*/ $cQmXV.createElement("div", {
        className: className,
        style: style
    }, children), index < latestIndex && separator && /*#__PURE__*/ $cQmXV.createElement("span", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefix}-item-separator`, classNames?.separator),
        style: styles?.separator
    }, separator));
};
var $c32a1030ceca4d2f$export$2e2bcd8739ae039 = $c32a1030ceca4d2f$var$Item;



const $777fc576af9158f9$var$genSpaceStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    return {
        [componentCls]: {
            display: "inline-flex",
            "&-rtl": {
                direction: "rtl"
            },
            "&-vertical": {
                flexDirection: "column"
            },
            "&-align": {
                flexDirection: "column",
                "&-center": {
                    alignItems: "center"
                },
                "&-start": {
                    alignItems: "flex-start"
                },
                "&-end": {
                    alignItems: "flex-end"
                },
                "&-baseline": {
                    alignItems: "baseline"
                }
            },
            [`${componentCls}-item:empty`]: {
                display: "none"
            },
            // https://github.com/ant-design/ant-design/issues/47875
            [`${componentCls}-item > ${antCls}-badge-not-a-wrapper:only-child`]: {
                display: "block"
            }
        }
    };
};
const $777fc576af9158f9$var$genSpaceGapStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: {
            "&-gap-row-small": {
                rowGap: token.spaceGapSmallSize
            },
            "&-gap-row-medium, &-gap-row-middle": {
                rowGap: token.spaceGapMiddleSize
            },
            "&-gap-row-large": {
                rowGap: token.spaceGapLargeSize
            },
            "&-gap-col-small": {
                columnGap: token.spaceGapSmallSize
            },
            "&-gap-col-medium, &-gap-col-middle": {
                columnGap: token.spaceGapMiddleSize
            },
            "&-gap-col-large": {
                columnGap: token.spaceGapLargeSize
            }
        }
    };
};
const $777fc576af9158f9$export$9ca1be8807fe0675 = ()=>({});
var $777fc576af9158f9$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$51ec95de45185b42)("Space", (token)=>{
    const spaceToken = (0, $fef50f256b80dfa5$export$4950aa0f605343fb)(token, {
        spaceGapSmallSize: token.paddingXS,
        spaceGapMiddleSize: token.padding,
        spaceGapLargeSize: token.paddingLG
    });
    return [
        $777fc576af9158f9$var$genSpaceStyle(spaceToken),
        $777fc576af9158f9$var$genSpaceGapStyle(spaceToken)
    ];
}, ()=>({}), {
    // Space component don't apply extra font style
    // https://github.com/ant-design/ant-design/issues/40315
    resetStyle: false
});


"use client";
const $eb1133c43d00490b$var$InternalSpace = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { getPrefixCls: getPrefixCls, direction: directionConfig, size: contextSize, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("space");
    const { size: size = contextSize ?? "small", align: align, className: className, rootClassName: rootClassName, children: children, direction: direction, orientation: orientation, prefixCls: customizePrefixCls, split: split, separator: separator, style: style, vertical: vertical, wrap: wrap = false, classNames: classNames, styles: styles, ...restProps } = props;
    const [horizontalSize, verticalSize] = Array.isArray(size) ? size : [
        size,
        size
    ];
    const isPresetVerticalSize = (0, $a3ff185e46cc584b$export$f5153c3888a6824e)(verticalSize);
    const isPresetHorizontalSize = (0, $a3ff185e46cc584b$export$f5153c3888a6824e)(horizontalSize);
    const isValidVerticalSize = (0, $a3ff185e46cc584b$export$1b502d0a9135d42b)(verticalSize);
    const isValidHorizontalSize = (0, $a3ff185e46cc584b$export$1b502d0a9135d42b)(horizontalSize);
    const childNodes = (0, $cd966a313e0a92ff$export$2e2bcd8739ae039)(children, {
        keepEmpty: true
    });
    const [mergedOrientation, mergedVertical] = (0, $78e4f9cb51a5af1c$export$550084c67147f6c4)(orientation, vertical, direction);
    const mergedAlign = align === undefined && !mergedVertical ? "center" : align;
    const mergedSeparator = separator ?? split;
    const prefixCls = getPrefixCls("space", customizePrefixCls);
    const [hashId, cssVarCls] = (0, $777fc576af9158f9$export$2e2bcd8739ae039)(prefixCls);
    // =========== Merged Props for Semantic ==========
    const mergedProps = {
        ...props,
        size: size,
        orientation: mergedOrientation,
        align: mergedAlign
    };
    const contextStyleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $30c5f9f911d4f61b$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: mergedProps
    });
    const rootClassNames = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, contextClassName, hashId, `${prefixCls}-${mergedOrientation}`, {
        [`${prefixCls}-rtl`]: directionConfig === "rtl",
        [`${prefixCls}-align-${mergedAlign}`]: mergedAlign,
        [`${prefixCls}-gap-row-${verticalSize}`]: isPresetVerticalSize,
        [`${prefixCls}-gap-col-${horizontalSize}`]: isPresetHorizontalSize
    }, className, rootClassName, cssVarCls, mergedClassNames.root);
    const itemClassName = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-item`, mergedClassNames.item);
    // Calculate latest one
    const renderedItems = childNodes.map((child, i)=>{
        const key = child?.key || `${itemClassName}-${i}`;
        return /*#__PURE__*/ $cQmXV.createElement((0, $c32a1030ceca4d2f$export$2e2bcd8739ae039), {
            prefix: prefixCls,
            classNames: mergedClassNames,
            styles: mergedStyles,
            className: itemClassName,
            key: key,
            index: i,
            separator: mergedSeparator,
            style: mergedStyles.item
        }, child);
    });
    var deprecatedName, newName;
    const memoizedSpaceContext = $cQmXV.useMemo(()=>{
        const calcLatestIndex = childNodes.reduce((latest, child, i)=>(0, $8e2d153a3c855782$export$72280d5f896dac9a)(child) ? i : latest, 0);
        return {
            latestIndex: calcLatestIndex
        };
    }, [
        childNodes
    ]);
    // =========================== Render ===========================
    if (childNodes.length === 0) return null;
    const gapStyle = {};
    if (wrap) gapStyle.flexWrap = "wrap";
    if (!isPresetHorizontalSize && isValidHorizontalSize) gapStyle.columnGap = horizontalSize;
    if (!isPresetVerticalSize && isValidVerticalSize) gapStyle.rowGap = verticalSize;
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        ref: ref,
        className: rootClassNames,
        style: {
            ...gapStyle,
            ...mergedStyles.root
        },
        ...restProps
    }, /*#__PURE__*/ $cQmXV.createElement((0, $44f4d56e4d2d01a9$export$2bbf36e6e96e17f9), {
        value: memoizedSpaceContext
    }, renderedItems));
});
const $eb1133c43d00490b$var$Space = $eb1133c43d00490b$var$InternalSpace;
$eb1133c43d00490b$var$Space.Compact = (0, $68fddf51400eda11$export$2e2bcd8739ae039);
$eb1133c43d00490b$var$Space.Addon = (0, $783061a72adde0bd$export$2e2bcd8739ae039);
var $eb1133c43d00490b$export$2e2bcd8739ae039 = $eb1133c43d00490b$var$Space;




"use client";
/** @deprecated Please use Space.Compact + Dropdown + Button instead */ const $c77be3f38e16e728$var$DropdownButton = (props)=>{
    const { getPopupContainer: getContextPopupContainer, getPrefixCls: getPrefixCls, direction: direction } = $cQmXV.useContext((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    const { prefixCls: customizePrefixCls, type: type = "default", danger: danger, disabled: disabled, loading: loading, onClick: onClick, htmlType: htmlType, children: children, className: className, menu: menu, arrow: arrow, autoFocus: autoFocus, trigger: trigger, align: align, open: open, onOpenChange: onOpenChange, placement: placement, getPopupContainer: getPopupContainer, href: href, icon: icon = /*#__PURE__*/ $cQmXV.createElement((0, $f172eb883972dae9$export$2e2bcd8739ae039), null), title: title, buttonsRender: buttonsRender = (buttons)=>buttons, mouseEnterDelay: mouseEnterDelay, mouseLeaveDelay: mouseLeaveDelay, overlayClassName: overlayClassName, overlayStyle: overlayStyle, destroyOnHidden: destroyOnHidden, destroyPopupOnHide: destroyPopupOnHide, dropdownRender: dropdownRender, popupRender: popupRender, ...restProps } = props;
    const prefixCls = getPrefixCls("dropdown", customizePrefixCls);
    const buttonPrefixCls = `${prefixCls}-button`;
    const mergedPopupRender = popupRender || dropdownRender;
    const dropdownProps = {
        menu: menu,
        arrow: arrow,
        autoFocus: autoFocus,
        align: align,
        disabled: disabled,
        trigger: disabled ? [] : trigger,
        onOpenChange: onOpenChange,
        getPopupContainer: getPopupContainer || getContextPopupContainer,
        mouseEnterDelay: mouseEnterDelay,
        mouseLeaveDelay: mouseLeaveDelay,
        classNames: {
            root: overlayClassName
        },
        styles: {
            root: overlayStyle
        },
        destroyOnHidden: destroyOnHidden,
        popupRender: mergedPopupRender
    };
    const { compactSize: compactSize, compactItemClassnames: compactItemClassnames } = (0, $68fddf51400eda11$export$cd8cf9d7bab8dd4)(prefixCls, direction);
    const classes = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(buttonPrefixCls, compactItemClassnames, className);
    if ("destroyPopupOnHide" in props) dropdownProps.destroyPopupOnHide = destroyPopupOnHide;
    if ("open" in props) dropdownProps.open = open;
    if ("placement" in props) dropdownProps.placement = placement;
    else dropdownProps.placement = direction === "rtl" ? "bottomLeft" : "bottomRight";
    const leftButton = /*#__PURE__*/ $cQmXV.createElement((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
        type: type,
        danger: danger,
        disabled: disabled,
        loading: loading,
        onClick: onClick,
        htmlType: htmlType,
        href: href,
        title: title
    }, children);
    const rightButton = /*#__PURE__*/ $cQmXV.createElement((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
        type: type,
        danger: danger,
        icon: icon
    });
    const [leftButtonToRender, rightButtonToRender] = buttonsRender([
        leftButton,
        rightButton
    ]);
    return /*#__PURE__*/ $cQmXV.createElement((0, $eb1133c43d00490b$export$2e2bcd8739ae039).Compact, {
        className: classes,
        size: compactSize,
        block: true,
        ...restProps
    }, leftButtonToRender, /*#__PURE__*/ $cQmXV.createElement((0, $8f2ae9c9297cd2c6$export$2e2bcd8739ae039), {
        ...dropdownProps
    }, rightButtonToRender));
};
$c77be3f38e16e728$var$DropdownButton.__ANT_BUTTON = true;
var $c77be3f38e16e728$export$2e2bcd8739ae039 = $c77be3f38e16e728$var$DropdownButton;


"use client";
const $30ddd2d6a9f4b7d6$var$Dropdown = (0, $8f2ae9c9297cd2c6$export$2e2bcd8739ae039);
/** @deprecated Please use Space.Compact + Dropdown + Button instead */ $30ddd2d6a9f4b7d6$var$Dropdown.Button = (0, $c77be3f38e16e728$export$2e2bcd8739ae039);
var $30ddd2d6a9f4b7d6$export$2e2bcd8739ae039 = $30ddd2d6a9f4b7d6$var$Dropdown;



var $cQmXV = parcelRequire("cQmXV");
var $2acd5d348c18ba0f$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($2acd5d348c18ba0f$exports, "__esModule", {
    value: true
});
var $2acd5d348c18ba0f$var$CheckOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z"
                }
            }
        ]
    },
    "name": "check",
    "theme": "outlined"
};
$2acd5d348c18ba0f$exports.default = $2acd5d348c18ba0f$var$CheckOutlined;



function $77ccca814b0c39fe$var$_extends() {
    $77ccca814b0c39fe$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $77ccca814b0c39fe$var$_extends.apply(this, arguments);
}
const $77ccca814b0c39fe$var$CheckOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $77ccca814b0c39fe$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2acd5d348c18ba0f$exports)))
    }));
/**![check](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkxMiAxOTBoLTY5LjljLTkuOCAwLTE5LjEgNC41LTI1LjEgMTIuMkw0MDQuNyA3MjQuNSAyMDcgNDc0YTMyIDMyIDAgMDAtMjUuMS0xMi4ySDExMmMtNi43IDAtMTAuNCA3LjctNi4zIDEyLjlsMjczLjkgMzQ3YzEyLjggMTYuMiAzNy40IDE2LjIgNTAuMyAwbDQ4OC40LTYxOC45YzQuMS01LjEuNC0xMi44LTYuMy0xMi44eiIgLz48L3N2Zz4=) */ const $77ccca814b0c39fe$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($77ccca814b0c39fe$var$CheckOutlined);
var $77ccca814b0c39fe$export$2e2bcd8739ae039 = $77ccca814b0c39fe$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $0aef4d019fc8b117$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($0aef4d019fc8b117$exports, "__esModule", {
    value: true
});
var $0aef4d019fc8b117$var$DownOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z"
                }
            }
        ]
    },
    "name": "down",
    "theme": "outlined"
};
$0aef4d019fc8b117$exports.default = $0aef4d019fc8b117$var$DownOutlined;



function $e7119b602540b2c5$var$_extends() {
    $e7119b602540b2c5$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e7119b602540b2c5$var$_extends.apply(this, arguments);
}
const $e7119b602540b2c5$var$DownOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $e7119b602540b2c5$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($0aef4d019fc8b117$exports)))
    }));
/**![down](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg4NCAyNTZoLTc1Yy01LjEgMC05LjkgMi41LTEyLjkgNi42TDUxMiA2NTQuMiAyMjcuOSAyNjIuNmMtMy00LjEtNy44LTYuNi0xMi45LTYuNmgtNzVjLTYuNSAwLTEwLjMgNy40LTYuNSAxMi43bDM1Mi42IDQ4Ni4xYzEyLjggMTcuNiAzOSAxNy42IDUxLjcgMGwzNTIuNi00ODYuMWMzLjktNS4zLjEtMTIuNy02LjQtMTIuN3oiIC8+PC9zdmc+) */ const $e7119b602540b2c5$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($e7119b602540b2c5$var$DownOutlined);
var $e7119b602540b2c5$export$2e2bcd8739ae039 = $e7119b602540b2c5$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $13d2429d2ed44767$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($13d2429d2ed44767$exports, "__esModule", {
    value: true
});
var $13d2429d2ed44767$var$UserOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M858.5 763.6a374 374 0 00-80.6-119.5 375.63 375.63 0 00-119.5-80.6c-.4-.2-.8-.3-1.2-.5C719.5 518 760 444.7 760 362c0-137-111-248-248-248S264 225 264 362c0 82.7 40.5 156 102.8 201.1-.4.2-.8.3-1.2.5-44.8 18.9-85 46-119.5 80.6a375.63 375.63 0 00-80.6 119.5A371.7 371.7 0 00136 901.8a8 8 0 008 8.2h60c4.4 0 7.9-3.5 8-7.8 2-77.2 33-149.5 87.8-204.3 56.7-56.7 132-87.9 212.2-87.9s155.5 31.2 212.2 87.9C779 752.7 810 825 812 902.2c.1 4.4 3.6 7.8 8 7.8h60a8 8 0 008-8.2c-1-47.8-10.9-94.3-29.5-138.2zM512 534c-45.9 0-89.1-17.9-121.6-50.4S340 407.9 340 362c0-45.9 17.9-89.1 50.4-121.6S466.1 190 512 190s89.1 17.9 121.6 50.4S684 316.1 684 362c0 45.9-17.9 89.1-50.4 121.6S557.9 534 512 534z"
                }
            }
        ]
    },
    "name": "user",
    "theme": "outlined"
};
$13d2429d2ed44767$exports.default = $13d2429d2ed44767$var$UserOutlined;



function $7804300d9b621775$var$_extends() {
    $7804300d9b621775$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7804300d9b621775$var$_extends.apply(this, arguments);
}
const $7804300d9b621775$var$UserOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $7804300d9b621775$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($13d2429d2ed44767$exports)))
    }));
/**![user](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg1OC41IDc2My42YTM3NCAzNzQgMCAwMC04MC42LTExOS41IDM3NS42MyAzNzUuNjMgMCAwMC0xMTkuNS04MC42Yy0uNC0uMi0uOC0uMy0xLjItLjVDNzE5LjUgNTE4IDc2MCA0NDQuNyA3NjAgMzYyYzAtMTM3LTExMS0yNDgtMjQ4LTI0OFMyNjQgMjI1IDI2NCAzNjJjMCA4Mi43IDQwLjUgMTU2IDEwMi44IDIwMS4xLS40LjItLjguMy0xLjIuNS00NC44IDE4LjktODUgNDYtMTE5LjUgODAuNmEzNzUuNjMgMzc1LjYzIDAgMDAtODAuNiAxMTkuNUEzNzEuNyAzNzEuNyAwIDAwMTM2IDkwMS44YTggOCAwIDAwOCA4LjJoNjBjNC40IDAgNy45LTMuNSA4LTcuOCAyLTc3LjIgMzMtMTQ5LjUgODcuOC0yMDQuMyA1Ni43LTU2LjcgMTMyLTg3LjkgMjEyLjItODcuOXMxNTUuNSAzMS4yIDIxMi4yIDg3LjlDNzc5IDc1Mi43IDgxMCA4MjUgODEyIDkwMi4yYy4xIDQuNCAzLjYgNy44IDggNy44aDYwYTggOCAwIDAwOC04LjJjLTEtNDcuOC0xMC45LTk0LjMtMjkuNS0xMzguMnpNNTEyIDUzNGMtNDUuOSAwLTg5LjEtMTcuOS0xMjEuNi01MC40UzM0MCA0MDcuOSAzNDAgMzYyYzAtNDUuOSAxNy45LTg5LjEgNTAuNC0xMjEuNlM0NjYuMSAxOTAgNTEyIDE5MHM4OS4xIDE3LjkgMTIxLjYgNTAuNFM2ODQgMzE2LjEgNjg0IDM2MmMwIDQ1LjktMTcuOSA4OS4xLTUwLjQgMTIxLjZTNTU3LjkgNTM0IDUxMiA1MzR6IiAvPjwvc3ZnPg==) */ const $7804300d9b621775$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($7804300d9b621775$var$UserOutlined);
var $7804300d9b621775$export$2e2bcd8739ae039 = $7804300d9b621775$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $11c84f222eb13b55$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($11c84f222eb13b55$exports, "__esModule", {
    value: true
});
var $11c84f222eb13b55$var$QuestionCircleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0130.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1080 0 40 40 0 10-80 0z"
                }
            }
        ]
    },
    "name": "question-circle",
    "theme": "outlined"
};
$11c84f222eb13b55$exports.default = $11c84f222eb13b55$var$QuestionCircleOutlined;



function $9e51bdaef216a39c$var$_extends() {
    $9e51bdaef216a39c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9e51bdaef216a39c$var$_extends.apply(this, arguments);
}
const $9e51bdaef216a39c$var$QuestionCircleOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $9e51bdaef216a39c$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($11c84f222eb13b55$exports)))
    }));
/**![question-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0wIDgyMGMtMjA1LjQgMC0zNzItMTY2LjYtMzcyLTM3MnMxNjYuNi0zNzIgMzcyLTM3MiAzNzIgMTY2LjYgMzcyIDM3Mi0xNjYuNiAzNzItMzcyIDM3MnoiIC8+PHBhdGggZD0iTTYyMy42IDMxNi43QzU5My42IDI5MC40IDU1NCAyNzYgNTEyIDI3NnMtODEuNiAxNC41LTExMS42IDQwLjdDMzY5LjIgMzQ0IDM1MiAzODAuNyAzNTIgNDIwdjcuNmMwIDQuNCAzLjYgOCA4IDhoNDhjNC40IDAgOC0zLjYgOC04VjQyMGMwLTQ0LjEgNDMuMS04MCA5Ni04MHM5NiAzNS45IDk2IDgwYzAgMzEuMS0yMiA1OS42LTU2LjEgNzIuNy0yMS4yIDguMS0zOS4yIDIyLjMtNTIuMSA0MC45LTEzLjEgMTktMTkuOSA0MS44LTE5LjkgNjQuOVY2MjBjMCA0LjQgMy42IDggOCA4aDQ4YzQuNCAwIDgtMy42IDgtOHYtMjIuN2E0OC4zIDQ4LjMgMCAwMTMwLjktNDQuOGM1OS0yMi43IDk3LjEtNzQuNyA5Ny4xLTEzMi41LjEtMzkuMy0xNy4xLTc2LTQ4LjMtMTAzLjN6TTQ3MiA3MzJhNDAgNDAgMCAxMDgwIDAgNDAgNDAgMCAxMC04MCAweiIgLz48L3N2Zz4=) */ const $9e51bdaef216a39c$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($9e51bdaef216a39c$var$QuestionCircleOutlined);
var $9e51bdaef216a39c$export$2e2bcd8739ae039 = $9e51bdaef216a39c$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $0c0393e84ab6168f$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($0c0393e84ab6168f$exports, "__esModule", {
    value: true
});
var $0c0393e84ab6168f$var$LogoutOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M868 732h-70.3c-4.8 0-9.3 2.1-12.3 5.8-7 8.5-14.5 16.7-22.4 24.5a353.84 353.84 0 01-112.7 75.9A352.8 352.8 0 01512.4 866c-47.9 0-94.3-9.4-137.9-27.8a353.84 353.84 0 01-112.7-75.9 353.28 353.28 0 01-76-112.5C167.3 606.2 158 559.9 158 512s9.4-94.2 27.8-137.8c17.8-42.1 43.4-80 76-112.5s70.5-58.1 112.7-75.9c43.6-18.4 90-27.8 137.9-27.8 47.9 0 94.3 9.3 137.9 27.8 42.2 17.8 80.1 43.4 112.7 75.9 7.9 7.9 15.3 16.1 22.4 24.5 3 3.7 7.6 5.8 12.3 5.8H868c6.3 0 10.2-7 6.7-12.3C798 160.5 663.8 81.6 511.3 82 271.7 82.6 79.6 277.1 82 516.4 84.4 751.9 276.2 942 512.4 942c152.1 0 285.7-78.8 362.3-197.7 3.4-5.3-.4-12.3-6.7-12.3zm88.9-226.3L815 393.7c-5.3-4.2-13-.4-13 6.3v76H488c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h314v76c0 6.7 7.8 10.5 13 6.3l141.9-112a8 8 0 000-12.6z"
                }
            }
        ]
    },
    "name": "logout",
    "theme": "outlined"
};
$0c0393e84ab6168f$exports.default = $0c0393e84ab6168f$var$LogoutOutlined;



function $27dfd059157cea02$var$_extends() {
    $27dfd059157cea02$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $27dfd059157cea02$var$_extends.apply(this, arguments);
}
const $27dfd059157cea02$var$LogoutOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $27dfd059157cea02$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($0c0393e84ab6168f$exports)))
    }));
/**![logout](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg2OCA3MzJoLTcwLjNjLTQuOCAwLTkuMyAyLjEtMTIuMyA1LjgtNyA4LjUtMTQuNSAxNi43LTIyLjQgMjQuNWEzNTMuODQgMzUzLjg0IDAgMDEtMTEyLjcgNzUuOUEzNTIuOCAzNTIuOCAwIDAxNTEyLjQgODY2Yy00Ny45IDAtOTQuMy05LjQtMTM3LjktMjcuOGEzNTMuODQgMzUzLjg0IDAgMDEtMTEyLjctNzUuOSAzNTMuMjggMzUzLjI4IDAgMDEtNzYtMTEyLjVDMTY3LjMgNjA2LjIgMTU4IDU1OS45IDE1OCA1MTJzOS40LTk0LjIgMjcuOC0xMzcuOGMxNy44LTQyLjEgNDMuNC04MCA3Ni0xMTIuNXM3MC41LTU4LjEgMTEyLjctNzUuOWM0My42LTE4LjQgOTAtMjcuOCAxMzcuOS0yNy44IDQ3LjkgMCA5NC4zIDkuMyAxMzcuOSAyNy44IDQyLjIgMTcuOCA4MC4xIDQzLjQgMTEyLjcgNzUuOSA3LjkgNy45IDE1LjMgMTYuMSAyMi40IDI0LjUgMyAzLjcgNy42IDUuOCAxMi4zIDUuOEg4NjhjNi4zIDAgMTAuMi03IDYuNy0xMi4zQzc5OCAxNjAuNSA2NjMuOCA4MS42IDUxMS4zIDgyIDI3MS43IDgyLjYgNzkuNiAyNzcuMSA4MiA1MTYuNCA4NC40IDc1MS45IDI3Ni4yIDk0MiA1MTIuNCA5NDJjMTUyLjEgMCAyODUuNy03OC44IDM2Mi4zLTE5Ny43IDMuNC01LjMtLjQtMTIuMy02LjctMTIuM3ptODguOS0yMjYuM0w4MTUgMzkzLjdjLTUuMy00LjItMTMtLjQtMTMgNi4zdjc2SDQ4OGMtNC40IDAtOCAzLjYtOCA4djU2YzAgNC40IDMuNiA4IDggOGgzMTR2NzZjMCA2LjcgNy44IDEwLjUgMTMgNi4zbDE0MS45LTExMmE4IDggMCAwMDAtMTIuNnoiIC8+PC9zdmc+) */ const $27dfd059157cea02$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($27dfd059157cea02$var$LogoutOutlined);
var $27dfd059157cea02$export$2e2bcd8739ae039 = $27dfd059157cea02$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $0d61b4996eac13a4$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($0d61b4996eac13a4$exports, "__esModule", {
    value: true
});
var $0d61b4996eac13a4$var$MenuOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M904 160H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0 624H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0-312H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "menu",
    "theme": "outlined"
};
$0d61b4996eac13a4$exports.default = $0d61b4996eac13a4$var$MenuOutlined;



function $214f3d80484a9230$var$_extends() {
    $214f3d80484a9230$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $214f3d80484a9230$var$_extends.apply(this, arguments);
}
const $214f3d80484a9230$var$MenuOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $214f3d80484a9230$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($0d61b4996eac13a4$exports)))
    }));
/**![menu](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkwNCAxNjBIMTIwYy00LjQgMC04IDMuNi04IDh2NjRjMCA0LjQgMy42IDggOCA4aDc4NGM0LjQgMCA4LTMuNiA4LTh2LTY0YzAtNC40LTMuNi04LTgtOHptMCA2MjRIMTIwYy00LjQgMC04IDMuNi04IDh2NjRjMCA0LjQgMy42IDggOCA4aDc4NGM0LjQgMCA4LTMuNiA4LTh2LTY0YzAtNC40LTMuNi04LTgtOHptMC0zMTJIMTIwYy00LjQgMC04IDMuNi04IDh2NjRjMCA0LjQgMy42IDggOCA4aDc4NGM0LjQgMCA4LTMuNiA4LTh2LTY0YzAtNC40LTMuNi04LTgtOHoiIC8+PC9zdmc+) */ const $214f3d80484a9230$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($214f3d80484a9230$var$MenuOutlined);
var $214f3d80484a9230$export$2e2bcd8739ae039 = $214f3d80484a9230$var$RefIcon;





/**
 * Language list, storage and detection.
 *
 * Deliberately free of antd imports so the resolution logic can be exercised by
 * `scripts/check-languages.mjs` under plain node. The antd locale binding lives in
 * `src/theme/antd.js`.
 */ /**
 * The four locales the product ships, in menu order.
 *
 * `label` is the endonym (what a speaker of that language calls it) and `native` is its English
 * name, shown as a secondary hint. English needs no hint, hence null.
 */ const $2753457ad00c82b6$export$b4b5a31092c79bca = [
    {
        code: "en",
        label: "English",
        native: null
    },
    {
        code: "uk",
        label: "\u0423\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0430",
        native: "Ukrainian"
    },
    {
        code: "hy",
        label: "\u0540\u0561\u0575\u0565\u0580\u0565\u0576",
        native: "Armenian"
    },
    {
        code: "ka",
        label: "\u10E5\u10D0\u10E0\u10D7\u10E3\u10DA\u10D8",
        native: "Georgian"
    }
];
const $2753457ad00c82b6$export$90898903f0729f34 = "en";
const $2753457ad00c82b6$export$5054ee9bb15d330e = (code)=>$2753457ad00c82b6$export$b4b5a31092c79bca.some((l)=>l.code === code);
const $2753457ad00c82b6$export$e73e935b1d3686be = "picsell.lang";
/**
 * IANA time zone → language, for the three countries that get their own locale.
 *
 * Each of these countries has a single zone, which is what makes the mapping viable. The legacy
 * aliases are not optional: plenty of systems still report `Europe/Kiev` rather than the current
 * `Europe/Kyiv` (the machine this was written on does).
 *
 * `Europe/Simferopol` is listed by IANA under Ukraine, so it maps to Ukrainian.
 */ const $2753457ad00c82b6$var$TZ_TO_LANG = {
    // Ukraine
    "Europe/Kyiv": "uk",
    "Europe/Kiev": "uk",
    "Europe/Uzhgorod": "uk",
    "Europe/Uzhhorod": "uk",
    "Europe/Zaporozhye": "uk",
    "Europe/Simferopol": "uk",
    // Armenia
    "Asia/Yerevan": "hy",
    // Georgia
    "Asia/Tbilisi": "ka"
};
function $2753457ad00c82b6$export$ae9ea24a1b29b07c(timeZone) {
    try {
        const tz = timeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;
        return $2753457ad00c82b6$var$TZ_TO_LANG[tz] || $2753457ad00c82b6$export$90898903f0729f34;
    } catch  {
        /* Intl is missing or the zone is unresolvable — English is the documented fallback. */ return $2753457ad00c82b6$export$90898903f0729f34;
    }
}
function $2753457ad00c82b6$export$beebcb678c85f58c(storage = $2753457ad00c82b6$var$safeStorage()) {
    try {
        const saved = storage?.getItem($2753457ad00c82b6$export$e73e935b1d3686be);
        return $2753457ad00c82b6$export$5054ee9bb15d330e(saved) ? saved : null;
    } catch  {
        return null;
    }
}
function $2753457ad00c82b6$export$3d819036c4c4fbb5(code, storage = $2753457ad00c82b6$var$safeStorage()) {
    try {
        storage?.setItem($2753457ad00c82b6$export$e73e935b1d3686be, code);
    } catch  {
    /* Private mode or a full quota — the choice just won't survive a reload. */ }
}
function $2753457ad00c82b6$export$fd43f4122341a86b(opts = {}) {
    return $2753457ad00c82b6$export$beebcb678c85f58c(opts.storage) || $2753457ad00c82b6$export$ae9ea24a1b29b07c(opts.timeZone);
}
function $2753457ad00c82b6$var$safeStorage() {
    try {
        return typeof localStorage === "undefined" ? null : localStorage;
    } catch  {
        /* Some privacy modes throw on mere access. */ return null;
    }
}




var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");

/* eslint-disable no-undefined,no-param-reassign,no-shadow */ /**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param {number} delay -                  A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher)
 *                                            are most useful.
 * @param {Function} callback -               A function to be executed after delay milliseconds. The `this` context and all arguments are passed through,
 *                                            as-is, to `callback` when the throttled-function is executed.
 * @param {object} [options] -              An object to configure options.
 * @param {boolean} [options.noTrailing] -   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds
 *                                            while the throttled-function is being called. If noTrailing is false or unspecified, callback will be executed
 *                                            one final time after the last throttled-function call. (After the throttled-function has not been called for
 *                                            `delay` milliseconds, the internal counter is reset).
 * @param {boolean} [options.noLeading] -   Optional, defaults to false. If noLeading is false, the first throttled-function call will execute callback
 *                                            immediately. If noLeading is true, the first the callback execution will be skipped. It should be noted that
 *                                            callback will never executed if both noLeading = true and noTrailing = true.
 * @param {boolean} [options.debounceMode] - If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is
 *                                            false (at end), schedule `callback` to execute after `delay` ms.
 *
 * @returns {Function} A new, throttled, function.
 */ function $ac11bb2a597bd9e1$export$de363e709c412c8a(delay, callback, options) {
    var _ref = options || {}, _ref$noTrailing = _ref.noTrailing, noTrailing = _ref$noTrailing === void 0 ? false : _ref$noTrailing, _ref$noLeading = _ref.noLeading, noLeading = _ref$noLeading === void 0 ? false : _ref$noLeading, _ref$debounceMode = _ref.debounceMode, debounceMode = _ref$debounceMode === void 0 ? undefined : _ref$debounceMode;
    /*
   * After wrapper has stopped being called, this timeout ensures that
   * `callback` is executed at the proper times in `throttle` and `end`
   * debounce modes.
   */ var timeoutID;
    var cancelled = false;
    // Keep track of the last time `callback` was executed.
    var lastExec = 0;
    // Function to clear existing timeout
    function clearExistingTimeout() {
        if (timeoutID) clearTimeout(timeoutID);
    }
    // Function to cancel next exec
    function cancel(options) {
        var _ref2 = options || {}, _ref2$upcomingOnly = _ref2.upcomingOnly, upcomingOnly = _ref2$upcomingOnly === void 0 ? false : _ref2$upcomingOnly;
        clearExistingTimeout();
        cancelled = !upcomingOnly;
    }
    /*
   * The `wrapper` function encapsulates all of the throttling / debouncing
   * functionality and when executed will limit the rate at which `callback`
   * is executed.
   */ function wrapper() {
        for(var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++)arguments_[_key] = arguments[_key];
        var self = this;
        var elapsed = Date.now() - lastExec;
        if (cancelled) return;
        // Execute `callback` and update the `lastExec` timestamp.
        function exec() {
            lastExec = Date.now();
            callback.apply(self, arguments_);
        }
        /*
     * If `debounceMode` is true (at begin) this is used to clear the flag
     * to allow future `callback` executions.
     */ function clear() {
            timeoutID = undefined;
        }
        if (!noLeading && debounceMode && !timeoutID) /*
       * Since `wrapper` is being called for the first time and
       * `debounceMode` is true (at begin), execute `callback`
       * and noLeading != true.
       */ exec();
        clearExistingTimeout();
        if (debounceMode === undefined && elapsed > delay) {
            if (noLeading) {
                /*
         * In throttle mode with noLeading, if `delay` time has
         * been exceeded, update `lastExec` and schedule `callback`
         * to execute after `delay` ms.
         */ lastExec = Date.now();
                if (!noTrailing) timeoutID = setTimeout(debounceMode ? clear : exec, delay);
            } else /*
         * In throttle mode without noLeading, if `delay` time has been exceeded, execute
         * `callback`.
         */ exec();
        } else if (noTrailing !== true) /*
       * In trailing throttle mode, since `delay` time has not been
       * exceeded, schedule `callback` to execute `delay` ms after most
       * recent execution.
       *
       * If `debounceMode` is true (at begin), schedule `clear` to execute
       * after `delay` ms.
       *
       * If `debounceMode` is false (at end), schedule `callback` to
       * execute after `delay` ms.
       */ timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
    }
    wrapper.cancel = cancel;
    // Return the wrapper function.
    return wrapper;
}
/* eslint-disable no-undefined */ /**
 * Debounce execution of a function. Debouncing, unlike throttling,
 * guarantees that a function is only executed a single time, either at the
 * very beginning of a series of calls, or at the very end.
 *
 * @param {number} delay -               A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param {Function} callback -          A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                        to `callback` when the debounced-function is executed.
 * @param {object} [options] -           An object to configure options.
 * @param {boolean} [options.atBegin] -  Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
 *                                        after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
 *                                        (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
 *
 * @returns {Function} A new, debounced function.
 */ function $ac11bb2a597bd9e1$export$61fc7d43ac8f84b0(delay, callback, options) {
    var _ref = options || {}, _ref$atBegin = _ref.atBegin, atBegin = _ref$atBegin === void 0 ? false : _ref$atBegin;
    return $ac11bb2a597bd9e1$export$de363e709c412c8a(delay, callback, {
        debounceMode: atBegin !== false
    });
}







var $cQmXV = parcelRequire("cQmXV");



var $cQmXV = parcelRequire("cQmXV");


var $cQmXV = parcelRequire("cQmXV");


"use client";
const $d48c6a6d4f1a2bc9$var$viewSize = 100;
const $d48c6a6d4f1a2bc9$var$borderWidth = $d48c6a6d4f1a2bc9$var$viewSize / 5;
const $d48c6a6d4f1a2bc9$var$radius = $d48c6a6d4f1a2bc9$var$viewSize / 2 - $d48c6a6d4f1a2bc9$var$borderWidth / 2;
const $d48c6a6d4f1a2bc9$var$circumference = $d48c6a6d4f1a2bc9$var$radius * 2 * Math.PI;
const $d48c6a6d4f1a2bc9$var$position = 50;
const $d48c6a6d4f1a2bc9$var$CustomCircle = (props)=>{
    const { dotClassName: dotClassName, style: style, hasCircleCls: hasCircleCls } = props;
    return /*#__PURE__*/ $cQmXV.createElement("circle", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${dotClassName}-circle`, {
            [`${dotClassName}-circle-bg`]: hasCircleCls
        }),
        r: $d48c6a6d4f1a2bc9$var$radius,
        cx: $d48c6a6d4f1a2bc9$var$position,
        cy: $d48c6a6d4f1a2bc9$var$position,
        strokeWidth: $d48c6a6d4f1a2bc9$var$borderWidth,
        style: style
    });
};
const $d48c6a6d4f1a2bc9$var$Progress = ({ percent: percent, prefixCls: prefixCls })=>{
    const dotClassName = `${prefixCls}-dot`;
    const holderClassName = `${dotClassName}-holder`;
    const hideClassName = `${holderClassName}-hidden`;
    const [render, setRender] = $cQmXV.useState(false);
    // ==================== Visible =====================
    (0, $7673d874dab69d07$export$2e2bcd8739ae039)(()=>{
        if (percent !== 0) setRender(true);
    }, [
        percent
    ]);
    // ==================== Progress ====================
    const safePtg = Math.max(Math.min(percent, 100), 0);
    // ===================== Render =====================
    if (!render) return null;
    const circleStyle = {
        strokeDashoffset: `${$d48c6a6d4f1a2bc9$var$circumference / 4}`,
        strokeDasharray: `${$d48c6a6d4f1a2bc9$var$circumference * safePtg / 100} ${$d48c6a6d4f1a2bc9$var$circumference * (100 - safePtg) / 100}`
    };
    return /*#__PURE__*/ $cQmXV.createElement("span", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(holderClassName, `${dotClassName}-progress`, {
            [hideClassName]: safePtg <= 0
        })
    }, /*#__PURE__*/ $cQmXV.createElement("svg", {
        viewBox: `0 0 ${$d48c6a6d4f1a2bc9$var$viewSize} ${$d48c6a6d4f1a2bc9$var$viewSize}`,
        role: "progressbar",
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-valuenow": safePtg
    }, /*#__PURE__*/ $cQmXV.createElement($d48c6a6d4f1a2bc9$var$CustomCircle, {
        dotClassName: dotClassName,
        hasCircleCls: true
    }), /*#__PURE__*/ $cQmXV.createElement($d48c6a6d4f1a2bc9$var$CustomCircle, {
        dotClassName: dotClassName,
        style: circleStyle
    })));
};
var $d48c6a6d4f1a2bc9$export$2e2bcd8739ae039 = $d48c6a6d4f1a2bc9$var$Progress;


"use client";
function $9f842442547cad21$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, percent: percent = 0, className: className, style: style } = props;
    const dotClassName = `${prefixCls}-dot`;
    const holderClassName = `${dotClassName}-holder`;
    const hideClassName = `${holderClassName}-hidden`;
    // ===================== Render =====================
    return /*#__PURE__*/ $cQmXV.createElement($cQmXV.Fragment, null, /*#__PURE__*/ $cQmXV.createElement("span", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(holderClassName, className, percent > 0 && hideClassName),
        style: style
    }, /*#__PURE__*/ $cQmXV.createElement("span", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(dotClassName, `${prefixCls}-dot-spin`)
    }, [
        1,
        2,
        3,
        4
    ].map((i)=>/*#__PURE__*/ $cQmXV.createElement("i", {
            className: `${prefixCls}-dot-item`,
            key: i
        })))), /*#__PURE__*/ $cQmXV.createElement((0, $d48c6a6d4f1a2bc9$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        percent: percent
    }));
}


"use client";
function $507e4ba8c4049c4d$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, indicator: indicator, percent: percent, className: className, style: style } = props;
    const dotClassName = `${prefixCls}-dot`;
    if (indicator && /*#__PURE__*/ $cQmXV.isValidElement(indicator)) return (0, $a91ef204d03d8eec$export$e530037191fcd5d7)(indicator, (currentProps)=>({
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(currentProps.className, dotClassName, className),
            style: {
                ...currentProps.style,
                ...style
            },
            percent: percent
        }));
    return /*#__PURE__*/ $cQmXV.createElement((0, $9f842442547cad21$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        percent: percent,
        className: className,
        style: style
    });
}






const $a1815e6a7d7baf52$var$antSpinMove = new (0, $e928d3664c9ed565$export$2e2bcd8739ae039)("antSpinMove", {
    to: {
        opacity: 1
    }
});
const $a1815e6a7d7baf52$var$antRotate = new (0, $e928d3664c9ed565$export$2e2bcd8739ae039)("antRotate", {
    to: {
        transform: "rotate(405deg)"
    }
});
// =============================== Spin ===============================
const $a1815e6a7d7baf52$var$genSpinStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const sectionCls = `${componentCls}-section`;
    return {
        [componentCls]: {
            ...(0, $519d20bf207ce864$export$23997c3e44cc1c59)(token),
            position: "relative",
            "&-rtl": {
                direction: "rtl"
            },
            // ========================== Section ===========================
            [`&${sectionCls}, > ${sectionCls}`]: {
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                gap: token.paddingSM,
                color: token.colorPrimary
            },
            [`&${sectionCls}`]: {
                display: "inline-flex"
            },
            [`> ${sectionCls}`]: {
                position: "absolute",
                top: "50%",
                left: {
                    _skip_check_: true,
                    value: "50%"
                },
                transform: "translate(-50%, -50%)",
                zIndex: 1
            },
            [`${componentCls}-description`]: {
                fontSize: token.fontSize,
                lineHeight: 1
            },
            // ========================= Container ==========================
            [`${componentCls}-container`]: {
                position: "relative",
                transition: `opacity ${token.motionDurationSlow}`,
                "&::after": {
                    position: "absolute",
                    top: 0,
                    insetInlineEnd: 0,
                    bottom: 0,
                    insetInlineStart: 0,
                    zIndex: 10,
                    width: "100%",
                    height: "100%",
                    background: token.colorBgContainer,
                    opacity: 0,
                    transition: `all ${token.motionDurationSlow}`,
                    content: '""',
                    pointerEvents: "none"
                }
            },
            // ========================== Spinning ==========================
            "&-spinning": {
                [`${componentCls}-description`]: {
                    textShadow: `0 0px 5px ${token.colorBgContainer}`
                },
                [`${componentCls}-container`]: {
                    clear: "both",
                    opacity: 0.5,
                    userSelect: "none",
                    pointerEvents: "none",
                    "&::after": {
                        opacity: 0.4,
                        pointerEvents: "auto"
                    }
                }
            },
            // ========================= Fullscreen =========================
            "&-fullscreen": {
                position: "fixed",
                inset: 0,
                backgroundColor: token.colorBgMask,
                zIndex: token.zIndexPopupBase,
                opacity: 0,
                pointerEvents: "none",
                transition: `all ${token.motionDurationMid}`,
                [`&${componentCls}-spinning`]: {
                    opacity: 1,
                    pointerEvents: "auto"
                },
                [`> ${sectionCls}`]: {
                    color: token.colorWhite,
                    [`${componentCls}-description`]: {
                        color: token.colorTextLightSolid
                    }
                }
            }
        }
    };
};
// ============================ Indicator =============================
const $a1815e6a7d7baf52$var$genIndicatorStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls, motionDurationSlow: motionDurationSlow } = token;
    const [varName, varRef] = (0, $6870d4d7c14ae0bb$export$d82b8f66c5649e14)(antCls, "spin");
    return {
        [componentCls]: {
            [varName("dot-holder-size")]: token.dotSize,
            [varName("dot-item-size")]: `calc((${varRef("dot-holder-size")} - ${token.marginXXS} / 2) / 2)`,
            [`${componentCls}-dot`]: {
                // >>> holder
                "&-holder": {
                    width: "1em",
                    height: "1em",
                    fontSize: varRef("dot-holder-size"),
                    display: "inline-block",
                    transition: [
                        "transform",
                        "opacity"
                    ].map((prop)=>`${prop} ${motionDurationSlow} ease`).join(", "),
                    transformOrigin: "50% 50%",
                    lineHeight: 1,
                    "&-hidden": {
                        transform: "scale(0.3)",
                        opacity: 0
                    }
                },
                // >>> holder > dot
                position: "relative",
                display: "inline-block",
                fontSize: varRef("dot-holder-size"),
                width: "1em",
                height: "1em",
                "&-spin": {
                    transform: "rotate(45deg)",
                    animationName: $a1815e6a7d7baf52$var$antRotate,
                    animationDuration: "1.2s",
                    animationIterationCount: "infinite",
                    animationTimingFunction: "linear"
                },
                // >>> holder > dot > item
                "&-item": {
                    position: "absolute",
                    display: "block",
                    width: varRef("dot-item-size"),
                    height: varRef("dot-item-size"),
                    background: "currentColor",
                    borderRadius: "100%",
                    transform: "scale(0.75)",
                    transformOrigin: "50% 50%",
                    opacity: 0.3,
                    animationName: $a1815e6a7d7baf52$var$antSpinMove,
                    animationDuration: "1s",
                    animationIterationCount: "infinite",
                    animationTimingFunction: "linear",
                    animationDirection: "alternate",
                    "&:nth-child(1)": {
                        top: 0,
                        insetInlineStart: 0,
                        animationDelay: "0s"
                    },
                    "&:nth-child(2)": {
                        top: 0,
                        insetInlineEnd: 0,
                        animationDelay: "0.4s"
                    },
                    "&:nth-child(3)": {
                        insetInlineEnd: 0,
                        bottom: 0,
                        animationDelay: "0.8s"
                    },
                    "&:nth-child(4)": {
                        bottom: 0,
                        insetInlineStart: 0,
                        animationDelay: "1.2s"
                    }
                },
                // ========================= Progress =========================
                "&-progress": {
                    position: "absolute",
                    left: "50%",
                    top: 0,
                    transform: "translateX(-50%)"
                },
                "&-circle": {
                    strokeLinecap: "round",
                    transition: [
                        "stroke-dashoffset",
                        "stroke-dasharray",
                        "stroke",
                        "stroke-width",
                        "opacity"
                    ].map((item)=>`${item} ${motionDurationSlow} ease`).join(","),
                    fillOpacity: 0,
                    stroke: "currentcolor"
                },
                "&-circle-bg": {
                    stroke: token.colorFillSecondary
                }
            }
        }
    };
};
// =============================== Size ===============================
const $a1815e6a7d7baf52$var$genSizeStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const [varName] = (0, $6870d4d7c14ae0bb$export$d82b8f66c5649e14)(token.antCls, "spin");
    return {
        [componentCls]: {
            "&-sm": {
                [varName("dot-holder-size")]: token.dotSizeSM
            },
            "&-lg": {
                [varName("dot-holder-size")]: token.dotSizeLG
            }
        }
    };
};
const $a1815e6a7d7baf52$export$9ca1be8807fe0675 = (token)=>{
    const { controlHeightLG: controlHeightLG, controlHeight: controlHeight } = token;
    return {
        contentHeight: 400,
        dotSize: controlHeightLG / 2,
        dotSizeSM: controlHeightLG * 0.35,
        dotSizeLG: controlHeight
    };
};
var // ============================== Export ==============================
$a1815e6a7d7baf52$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$51ec95de45185b42)("Spin", (token)=>{
    const spinToken = (0, $fef50f256b80dfa5$export$4950aa0f605343fb)(token, {
        spinDotDefault: token.colorTextDescription
    });
    return [
        $a1815e6a7d7baf52$var$genSpinStyle(spinToken),
        $a1815e6a7d7baf52$var$genIndicatorStyle(spinToken),
        $a1815e6a7d7baf52$var$genSizeStyle(spinToken)
    ];
}, $a1815e6a7d7baf52$export$9ca1be8807fe0675);



var $cQmXV = parcelRequire("cQmXV");
const $f1987191db9e99e9$var$AUTO_INTERVAL = 200;
const $f1987191db9e99e9$var$STEP_BUCKETS = [
    [
        30,
        0.05
    ],
    [
        70,
        0.03
    ],
    [
        96,
        0.01
    ]
];
function $f1987191db9e99e9$export$2e2bcd8739ae039(spinning, percent) {
    const [mockPercent, setMockPercent] = $cQmXV.useState(0);
    const mockIntervalRef = $cQmXV.useRef(null);
    const isAuto = percent === "auto";
    $cQmXV.useEffect(()=>{
        if (isAuto && spinning) {
            setMockPercent(0);
            mockIntervalRef.current = setInterval(()=>{
                setMockPercent((prev)=>{
                    const restPTG = 100 - prev;
                    for(let i = 0; i < $f1987191db9e99e9$var$STEP_BUCKETS.length; i += 1){
                        const [limit, stepPtg] = $f1987191db9e99e9$var$STEP_BUCKETS[i];
                        if (prev <= limit) return prev + restPTG * stepPtg;
                    }
                    return prev;
                });
            }, $f1987191db9e99e9$var$AUTO_INTERVAL);
        }
        return ()=>{
            if (mockIntervalRef.current) {
                clearInterval(mockIntervalRef.current);
                mockIntervalRef.current = null;
            }
        };
    }, [
        isAuto,
        spinning
    ]);
    return isAuto ? mockPercent : percent;
}


"use client";
// Render indicator
let $62b8cbcd99b9ffa2$var$defaultIndicator;
function $62b8cbcd99b9ffa2$var$shouldDelay(spinning, delay) {
    return !!spinning && !!delay && !Number.isNaN(Number(delay));
}
const $62b8cbcd99b9ffa2$var$Spin = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, spinning: customSpinning = true, delay: delay = 0, className: className, rootClassName: rootClassName, size: size, tip: tip, description: description, wrapperClassName: wrapperClassName, style: style, children: children, fullscreen: fullscreen = false, indicator: indicator, percent: percent, classNames: classNames, styles: styles, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, indicator: contextIndicator, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("spin");
    const prefixCls = getPrefixCls("spin", customizePrefixCls);
    const [hashId, cssVarCls] = (0, $a1815e6a7d7baf52$export$2e2bcd8739ae039)(prefixCls);
    const [spinning, setSpinning] = $cQmXV.useState(()=>customSpinning && !$62b8cbcd99b9ffa2$var$shouldDelay(customSpinning, delay));
    const mergedPercent = (0, $f1987191db9e99e9$export$2e2bcd8739ae039)(spinning, percent);
    $cQmXV.useEffect(()=>{
        if (customSpinning) {
            const showSpinning = (0, $ac11bb2a597bd9e1$export$61fc7d43ac8f84b0)(delay, ()=>{
                setSpinning(true);
            });
            showSpinning();
            return ()=>{
                showSpinning?.cancel?.();
            };
        }
        setSpinning(false);
    }, [
        delay,
        customSpinning
    ]);
    // ======================= Size ======================
    const mergedSize = (0, $78cdfb6138721329$export$2e2bcd8739ae039)((ctx)=>size ?? ctx);
    // ======================= Description ======================
    const mergedDescription = description ?? tip;
    // =============== Merged Props for Semantic ================
    const mergedProps = {
        ...props,
        size: mergedSize,
        spinning: spinning,
        tip: mergedDescription,
        description: mergedDescription,
        fullscreen: fullscreen,
        children: children,
        percent: mergedPercent
    };
    // ========================= Style ==========================
    const contextStyleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(contextStyle);
    const [mergedClassNames, mergedStyles] = (0, $30c5f9f911d4f61b$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles
    ], {
        props: mergedProps
    });
    // ======================= Indicator ========================
    const mergedIndicator = indicator ?? contextIndicator ?? $62b8cbcd99b9ffa2$var$defaultIndicator;
    // ========================= Render =========================
    const hasChildren = typeof children !== "undefined";
    const isNested = hasChildren || fullscreen;
    const indicatorNode = /*#__PURE__*/ $cQmXV.createElement($cQmXV.Fragment, null, /*#__PURE__*/ $cQmXV.createElement((0, $507e4ba8c4049c4d$export$2e2bcd8739ae039), {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(mergedClassNames.indicator),
        style: mergedStyles.indicator,
        prefixCls: prefixCls,
        indicator: mergedIndicator,
        percent: mergedPercent
    }), mergedDescription && /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-description`, mergedClassNames.tip, mergedClassNames.description),
        style: {
            ...mergedStyles.tip,
            ...mergedStyles.description
        }
    }, mergedDescription));
    const nativeElementRef = $cQmXV.useRef(null);
    $cQmXV.useImperativeHandle(ref, ()=>({
            nativeElement: nativeElementRef.current
        }));
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        ref: nativeElementRef,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, {
            [`${prefixCls}-sm`]: mergedSize === "small",
            [`${prefixCls}-lg`]: mergedSize === "large",
            [`${prefixCls}-spinning`]: spinning,
            [`${prefixCls}-rtl`]: direction === "rtl",
            [`${prefixCls}-fullscreen`]: fullscreen
        }, rootClassName, mergedClassNames.root, fullscreen && mergedClassNames.mask, isNested ? wrapperClassName : [
            `${prefixCls}-section`,
            mergedClassNames.section
        ], contextClassName, className, hashId, cssVarCls),
        style: {
            ...mergedStyles.root,
            ...!isNested ? mergedStyles.section : {},
            ...fullscreen ? mergedStyles.mask : {},
            ...style
        },
        "aria-live": "polite",
        "aria-busy": spinning,
        ...restProps
    }, spinning && (isNested ? /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-section`, mergedClassNames.section),
        style: mergedStyles.section
    }, indicatorNode) : indicatorNode), hasChildren && /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-container`, mergedClassNames.container),
        style: mergedStyles.container
    }, children));
});
$62b8cbcd99b9ffa2$var$Spin.setDefaultIndicator = (indicator)=>{
    $62b8cbcd99b9ffa2$var$defaultIndicator = indicator;
};
var $62b8cbcd99b9ffa2$export$2e2bcd8739ae039 = $62b8cbcd99b9ffa2$var$Spin;


var $cQmXV = parcelRequire("cQmXV");









var $cQmXV = parcelRequire("cQmXV");




var $cQmXV = parcelRequire("cQmXV");

"use client";
const $1391cfd5d2eb2bfc$var$UnitNumber = (props)=>{
    const { prefixCls: prefixCls, value: value, current: current, offset: offset = 0 } = props;
    let style;
    if (offset) style = {
        position: "absolute",
        top: `${offset}00%`,
        left: 0
    };
    return /*#__PURE__*/ $cQmXV.createElement("span", {
        style: style,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-only-unit`, {
            current: current
        })
    }, value);
};
function $1391cfd5d2eb2bfc$var$getOffset(start, end, unit) {
    let index = start;
    let offset = 0;
    while((index + 10) % 10 !== end){
        index += unit;
        offset += unit;
    }
    return offset;
}
const $1391cfd5d2eb2bfc$var$SingleNumber = (props)=>{
    const { prefixCls: prefixCls, count: originCount, value: originValue } = props;
    const value = Number(originValue);
    const count = Math.abs(originCount);
    const [prevValue, setPrevValue] = $cQmXV.useState(value);
    const [prevCount, setPrevCount] = $cQmXV.useState(count);
    // ============================= Events =============================
    const onTransitionEnd = ()=>{
        setPrevValue(value);
        setPrevCount(count);
    };
    // Fallback if transition events are not supported
    $cQmXV.useEffect(()=>{
        const timer = setTimeout(onTransitionEnd, 1000);
        return ()=>clearTimeout(timer);
    }, [
        value
    ]);
    // ============================= Render =============================
    // Render unit list
    let unitNodes;
    let offsetStyle;
    if (prevValue === value || Number.isNaN(value) || Number.isNaN(prevValue)) {
        // Nothing to change
        unitNodes = [
            /*#__PURE__*/ $cQmXV.createElement($1391cfd5d2eb2bfc$var$UnitNumber, {
                ...props,
                key: value,
                current: true
            })
        ];
        offsetStyle = {
            transition: "none"
        };
    } else {
        unitNodes = [];
        // Fill basic number units
        const end = value + 10;
        const unitNumberList = [];
        for(let index = value; index <= end; index += 1)unitNumberList.push(index);
        const unit = prevCount < count ? 1 : -1;
        // Fill with number unit nodes
        const prevIndex = unitNumberList.findIndex((n)=>n % 10 === prevValue);
        // Cut list
        const cutUnitNumberList = unit < 0 ? unitNumberList.slice(0, prevIndex + 1) : unitNumberList.slice(prevIndex);
        unitNodes = cutUnitNumberList.map((n, index)=>{
            const singleUnit = n % 10;
            return /*#__PURE__*/ $cQmXV.createElement($1391cfd5d2eb2bfc$var$UnitNumber, {
                ...props,
                key: n,
                value: singleUnit,
                offset: unit < 0 ? index - prevIndex : index,
                current: index === prevIndex
            });
        });
        // Calculate container offset value
        offsetStyle = {
            transform: `translateY(${-$1391cfd5d2eb2bfc$var$getOffset(prevValue, value, unit)}00%)`
        };
    }
    return /*#__PURE__*/ $cQmXV.createElement("span", {
        className: `${prefixCls}-only`,
        style: offsetStyle,
        onTransitionEnd: onTransitionEnd
    }, unitNodes);
};
var $1391cfd5d2eb2bfc$export$2e2bcd8739ae039 = $1391cfd5d2eb2bfc$var$SingleNumber;


"use client";
const $9fcfc7037eb0bc17$var$ScrollNumber = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, count: count, className: className, motionClassName: motionClassName, style: style, title: title, show: show, component: Component = "sup", children: children, ...restProps } = props;
    const { getPrefixCls: getPrefixCls } = $cQmXV.useContext((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls("scroll-number", customizePrefixCls);
    // ============================ Render ============================
    const newProps = {
        ...restProps,
        "data-show": show,
        style: style,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, className, motionClassName),
        title: title
    };
    // Only integer need motion
    let numberNodes = count;
    if (count && Number(count) % 1 === 0) {
        const numberList = String(count).split("");
        numberNodes = /*#__PURE__*/ $cQmXV.createElement("bdi", null, numberList.map((num, i)=>/*#__PURE__*/ $cQmXV.createElement((0, $1391cfd5d2eb2bfc$export$2e2bcd8739ae039), {
                prefixCls: prefixCls,
                count: Number(count),
                value: num,
                // eslint-disable-next-line react/no-array-index-key
                key: numberList.length - i
            })));
    }
    // allow specify the border
    // mock border-color by box-shadow for compatible with old usage:
    // <Badge count={4} style={{ backgroundColor: '#fff', color: '#999', borderColor: '#d9d9d9' }} />
    if (style?.borderColor) newProps.style = {
        ...style,
        boxShadow: `0 0 0 1px ${style.borderColor} inset`
    };
    if (children) return (0, $a91ef204d03d8eec$export$e530037191fcd5d7)(children, (oriProps)=>({
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-custom-component`, oriProps?.className, motionClassName)
        }));
    return /*#__PURE__*/ $cQmXV.createElement(Component, {
        ...newProps,
        ref: ref
    }, numberNodes);
});
var $9fcfc7037eb0bc17$export$2e2bcd8739ae039 = $9fcfc7037eb0bc17$var$ScrollNumber;





const $6c870bde7fa5136e$var$antStatusProcessing = new (0, $e928d3664c9ed565$export$2e2bcd8739ae039)("antStatusProcessing", {
    "0%": {
        transform: "scale(0.8)",
        opacity: 0.5
    },
    "100%": {
        transform: "scale(2.4)",
        opacity: 0
    }
});
const $6c870bde7fa5136e$var$antZoomBadgeIn = new (0, $e928d3664c9ed565$export$2e2bcd8739ae039)("antZoomBadgeIn", {
    "0%": {
        transform: "scale(0) translate(50%, -50%)",
        opacity: 0
    },
    "100%": {
        transform: "scale(1) translate(50%, -50%)"
    }
});
const $6c870bde7fa5136e$var$antZoomBadgeOut = new (0, $e928d3664c9ed565$export$2e2bcd8739ae039)("antZoomBadgeOut", {
    "0%": {
        transform: "scale(1) translate(50%, -50%)"
    },
    "100%": {
        transform: "scale(0) translate(50%, -50%)",
        opacity: 0
    }
});
const $6c870bde7fa5136e$var$antNoWrapperZoomBadgeIn = new (0, $e928d3664c9ed565$export$2e2bcd8739ae039)("antNoWrapperZoomBadgeIn", {
    "0%": {
        transform: "scale(0)",
        opacity: 0
    },
    "100%": {
        transform: "scale(1)"
    }
});
const $6c870bde7fa5136e$var$antNoWrapperZoomBadgeOut = new (0, $e928d3664c9ed565$export$2e2bcd8739ae039)("antNoWrapperZoomBadgeOut", {
    "0%": {
        transform: "scale(1)"
    },
    "100%": {
        transform: "scale(0)",
        opacity: 0
    }
});
const $6c870bde7fa5136e$var$antBadgeLoadingCircle = new (0, $e928d3664c9ed565$export$2e2bcd8739ae039)("antBadgeLoadingCircle", {
    "0%": {
        transformOrigin: "50%"
    },
    "100%": {
        transform: "translate(50%, -50%) rotate(360deg)",
        transformOrigin: "50%"
    }
});
const $6c870bde7fa5136e$var$genSharedBadgeStyle = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, antCls: antCls, badgeShadowSize: badgeShadowSize, textFontSize: textFontSize, textFontSizeSM: textFontSizeSM, statusSize: statusSize, dotSize: dotSize, textFontWeight: textFontWeight, indicatorHeight: indicatorHeight, indicatorHeightSM: indicatorHeightSM, marginXS: marginXS, calc: calc } = token;
    const numberPrefixCls = `${antCls}-scroll-number`;
    const colorPreset = (0, $7c652e13f0bdefc8$export$2e2bcd8739ae039)(token, (colorKey, { darkColor: darkColor })=>({
            [`&${componentCls} ${componentCls}-color-${colorKey}`]: {
                background: darkColor,
                [`&:not(${componentCls}-count)`]: {
                    color: darkColor
                },
                "a:hover &": {
                    background: darkColor
                }
            }
        }));
    return {
        [componentCls]: {
            ...(0, $519d20bf207ce864$export$23997c3e44cc1c59)(token),
            position: "relative",
            display: "inline-block",
            width: "fit-content",
            lineHeight: 1,
            [`${componentCls}-count`]: {
                display: "inline-flex",
                justifyContent: "center",
                zIndex: token.indicatorZIndex,
                minWidth: indicatorHeight,
                height: indicatorHeight,
                color: token.badgeTextColor,
                fontWeight: textFontWeight,
                fontSize: textFontSize,
                lineHeight: (0, $05f34ed03d41967d$export$523c0b569236b342)(indicatorHeight),
                whiteSpace: "nowrap",
                textAlign: "center",
                background: token.badgeColor,
                borderRadius: calc(indicatorHeight).div(2).equal(),
                boxShadow: `0 0 0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(badgeShadowSize)} ${token.badgeShadowColor}`,
                transition: `background-color ${token.motionDurationMid}`,
                a: {
                    color: token.badgeTextColor
                },
                "a:hover": {
                    color: token.badgeTextColor
                },
                "a:hover &": {
                    background: token.badgeColorHover
                }
            },
            [`${componentCls}-count-sm`]: {
                minWidth: indicatorHeightSM,
                height: indicatorHeightSM,
                fontSize: textFontSizeSM,
                lineHeight: (0, $05f34ed03d41967d$export$523c0b569236b342)(indicatorHeightSM),
                borderRadius: calc(indicatorHeightSM).div(2).equal()
            },
            [`${componentCls}-multiple-words`]: {
                paddingInline: token.paddingInline,
                bdi: {
                    unicodeBidi: "plaintext"
                }
            },
            [`${componentCls}-dot`]: {
                zIndex: token.indicatorZIndex,
                width: dotSize,
                minWidth: dotSize,
                height: dotSize,
                background: token.badgeColor,
                borderRadius: "100%",
                boxShadow: `0 0 0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(badgeShadowSize)} ${token.badgeShadowColor}`
            },
            [`${componentCls}-count, ${componentCls}-dot, ${numberPrefixCls}-custom-component`]: {
                position: "absolute",
                top: 0,
                insetInlineEnd: 0,
                transform: "translate(50%, -50%)",
                transformOrigin: "100% 0%",
                [`&${iconCls}-spin`]: {
                    animationName: $6c870bde7fa5136e$var$antBadgeLoadingCircle,
                    animationDuration: "1s",
                    animationIterationCount: "infinite",
                    animationTimingFunction: "linear"
                }
            },
            [`&${componentCls}-status`]: {
                lineHeight: "inherit",
                verticalAlign: "baseline",
                [`${componentCls}-status-dot`]: {
                    position: "relative",
                    top: -1,
                    // Magic number, but seems better experience
                    display: "inline-block",
                    width: statusSize,
                    height: statusSize,
                    verticalAlign: "middle",
                    borderRadius: "50%"
                },
                [`${componentCls}-status-success`]: {
                    backgroundColor: token.colorSuccess
                },
                [`${componentCls}-status-processing`]: {
                    overflow: "visible",
                    color: token.colorInfoTextHover,
                    backgroundColor: token.colorInfo,
                    borderColor: "currentcolor",
                    "&::after": {
                        position: "absolute",
                        top: 0,
                        insetInlineStart: 0,
                        width: "100%",
                        height: "100%",
                        borderWidth: badgeShadowSize,
                        borderStyle: "solid",
                        borderColor: "inherit",
                        borderRadius: "50%",
                        animationName: $6c870bde7fa5136e$var$antStatusProcessing,
                        animationDuration: token.badgeProcessingDuration,
                        animationIterationCount: "infinite",
                        animationTimingFunction: "ease-in-out",
                        content: '""'
                    }
                },
                [`${componentCls}-status-default`]: {
                    backgroundColor: token.colorTextPlaceholder
                },
                [`${componentCls}-status-error`]: {
                    backgroundColor: token.colorError
                },
                [`${componentCls}-status-warning`]: {
                    backgroundColor: token.colorWarning
                },
                [`${componentCls}-status-text`]: {
                    marginInlineStart: marginXS,
                    color: token.colorText,
                    fontSize: token.fontSize
                }
            },
            ...colorPreset,
            [`${componentCls}-zoom-appear, ${componentCls}-zoom-enter`]: {
                animationName: $6c870bde7fa5136e$var$antZoomBadgeIn,
                animationDuration: token.motionDurationSlow,
                animationTimingFunction: token.motionEaseOutBack,
                animationFillMode: "both"
            },
            [`${componentCls}-zoom-leave`]: {
                animationName: $6c870bde7fa5136e$var$antZoomBadgeOut,
                animationDuration: token.motionDurationSlow,
                animationTimingFunction: token.motionEaseOutBack,
                animationFillMode: "both"
            },
            [`&${componentCls}-not-a-wrapper`]: {
                [`${componentCls}-zoom-appear, ${componentCls}-zoom-enter`]: {
                    animationName: $6c870bde7fa5136e$var$antNoWrapperZoomBadgeIn,
                    animationDuration: token.motionDurationSlow,
                    animationTimingFunction: token.motionEaseOutBack
                },
                [`${componentCls}-zoom-leave`]: {
                    animationName: $6c870bde7fa5136e$var$antNoWrapperZoomBadgeOut,
                    animationDuration: token.motionDurationSlow,
                    animationTimingFunction: token.motionEaseOutBack
                },
                [`&:not(${componentCls}-status)`]: {
                    verticalAlign: "middle"
                },
                [`${numberPrefixCls}-custom-component, ${componentCls}-count`]: {
                    transform: "none"
                },
                [`${numberPrefixCls}-custom-component, ${numberPrefixCls}`]: {
                    position: "relative",
                    top: "auto",
                    display: "block",
                    transformOrigin: "50% 50%"
                }
            },
            [numberPrefixCls]: {
                overflow: "hidden",
                transition: `all ${token.motionDurationMid} ${token.motionEaseOutBack}`,
                [`${numberPrefixCls}-only`]: {
                    position: "relative",
                    display: "inline-block",
                    height: indicatorHeight,
                    transition: `all ${token.motionDurationSlow} ${token.motionEaseOutBack}`,
                    WebkitTransformStyle: "preserve-3d",
                    WebkitBackfaceVisibility: "hidden",
                    [`> p${numberPrefixCls}-only-unit`]: {
                        height: indicatorHeight,
                        margin: 0,
                        WebkitTransformStyle: "preserve-3d",
                        WebkitBackfaceVisibility: "hidden"
                    }
                },
                [`${numberPrefixCls}-symbol`]: {
                    verticalAlign: "top"
                }
            },
            // ====================== RTL =======================
            "&-rtl": {
                direction: "rtl",
                [`${componentCls}-count, ${componentCls}-dot, ${numberPrefixCls}-custom-component`]: {
                    transform: "translate(-50%, -50%)"
                }
            }
        }
    };
};
const $6c870bde7fa5136e$export$362fb92a8f81bbf9 = (token)=>{
    const { fontHeight: fontHeight, lineWidth: lineWidth, marginXS: marginXS, colorBorderBg: colorBorderBg } = token;
    const badgeFontHeight = fontHeight;
    const badgeShadowSize = lineWidth;
    const badgeTextColor = token.colorTextLightSolid;
    const badgeColor = token.colorError;
    const badgeColorHover = token.colorErrorHover;
    const badgeToken = (0, $fef50f256b80dfa5$export$4950aa0f605343fb)(token, {
        badgeFontHeight: badgeFontHeight,
        badgeShadowSize: badgeShadowSize,
        badgeTextColor: badgeTextColor,
        badgeColor: badgeColor,
        badgeColorHover: badgeColorHover,
        badgeShadowColor: colorBorderBg,
        badgeProcessingDuration: "1.2s",
        badgeRibbonOffset: marginXS,
        // Follow token just by Design. Not related with token
        badgeRibbonCornerTransform: "scaleY(0.75)",
        badgeRibbonCornerFilter: `brightness(75%)`
    });
    return badgeToken;
};
const $6c870bde7fa5136e$export$9ca1be8807fe0675 = (token)=>{
    const { fontSize: fontSize, lineHeight: lineHeight, fontSizeSM: fontSizeSM, lineWidth: lineWidth, paddingXS: paddingXS } = token;
    return {
        indicatorZIndex: "auto",
        indicatorHeight: Math.round(fontSize * lineHeight) - 2 * lineWidth,
        indicatorHeightSM: fontSize,
        dotSize: fontSizeSM / 2,
        textFontSize: fontSizeSM,
        textFontSizeSM: fontSizeSM,
        textFontWeight: "normal",
        statusSize: fontSizeSM / 2,
        paddingInline: paddingXS
    };
};
var $6c870bde7fa5136e$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$51ec95de45185b42)("Badge", (token)=>{
    const badgeToken = $6c870bde7fa5136e$export$362fb92a8f81bbf9(token);
    return $6c870bde7fa5136e$var$genSharedBadgeStyle(badgeToken);
}, $6c870bde7fa5136e$export$9ca1be8807fe0675);


"use client";
const $2dd718bfd7ed6afa$var$Badge = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, scrollNumberPrefixCls: customizeScrollNumberPrefixCls, children: children, status: status, text: text, color: color, count: count = null, overflowCount: overflowCount = 99, dot: dot = false, size: size = "medium", title: title, offset: offset, style: style, className: className, rootClassName: rootClassName, classNames: classNames, styles: styles, showZero: showZero = false, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("badge");
    const prefixCls = getPrefixCls("badge", customizePrefixCls);
    const [hashId, cssVarCls] = (0, $6c870bde7fa5136e$export$2e2bcd8739ae039)(prefixCls);
    // =========== Merged Props for Semantic ===========
    const mergedProps = {
        ...props,
        overflowCount: overflowCount,
        size: size,
        dot: dot,
        showZero: showZero
    };
    // ================================ Misc ================================
    const numberedDisplayCount = count > overflowCount ? `${overflowCount}+` : count;
    const isZero = numberedDisplayCount === "0" || numberedDisplayCount === 0 || text === "0" || text === 0;
    const ignoreCount = count === null || isZero && !showZero;
    const hasStatus = ((0, $8e2d153a3c855782$export$826fff653a329e83)(status) || (0, $8e2d153a3c855782$export$826fff653a329e83)(color)) && ignoreCount;
    const hasStatusValue = (0, $8e2d153a3c855782$export$826fff653a329e83)(status) || !isZero;
    const isStatusBadge = Boolean(!children && hasStatus && (text || hasStatusValue || !ignoreCount));
    // =============================== Styles ===============================
    const offsetStyle = (0, $cQmXV.useMemo)(()=>{
        if (!offset) return undefined;
        const horizontalOffset = Number.parseInt(offset[0], 10);
        return {
            marginTop: offset[1],
            insetInlineEnd: -horizontalOffset
        };
    }, [
        offset
    ]);
    const mergedStyle = (0, $cQmXV.useMemo)(()=>({
            ...offsetStyle,
            ...contextStyle,
            ...style
        }), [
        offsetStyle,
        style,
        contextStyle
    ]);
    const legacyStyleKey = isStatusBadge ? "root" : "indicator";
    const contextLegacyStyle = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(contextStyle, legacyStyleKey);
    const componentLegacyStyle = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(style, legacyStyleKey);
    const [mergedClassNames, mergedStyles] = (0, $30c5f9f911d4f61b$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextLegacyStyle,
        styles,
        componentLegacyStyle
    ], {
        props: mergedProps
    });
    const showAsDot = dot && !isZero;
    const mergedCount = showAsDot ? "" : numberedDisplayCount;
    const isHidden = (0, $cQmXV.useMemo)(()=>{
        const isEmpty = !(0, $8e2d153a3c855782$export$72280d5f896dac9a)(mergedCount) && !(0, $8e2d153a3c855782$export$72280d5f896dac9a)(text);
        return (isEmpty || isZero && !showZero) && !showAsDot;
    }, [
        mergedCount,
        isZero,
        showZero,
        showAsDot,
        text
    ]);
    // Count should be cache in case hidden change it
    const countRef = (0, $cQmXV.useRef)(count);
    if (!isHidden) countRef.current = count;
    const livingCount = countRef.current;
    // We need cache count since remove motion should not change count display
    const displayCountRef = (0, $cQmXV.useRef)(mergedCount);
    if (!isHidden) displayCountRef.current = mergedCount;
    const displayCount = displayCountRef.current;
    // We will cache the dot status to avoid shaking on leaved motion
    const isDotRef = (0, $cQmXV.useRef)(showAsDot);
    if (!isHidden) isDotRef.current = showAsDot;
    // =============================== Render ===============================
    // >>> Title
    const fallbackTitleNode = (0, $8e2d153a3c855782$export$844ec244b1367d54)(livingCount) || (0, $8e2d153a3c855782$export$7e4aa119212bc614)(livingCount) ? livingCount : undefined;
    const titleNode = title === null || title === false ? undefined : title ?? fallbackTitleNode;
    // >>> Status Text
    const showStatusTextNode = !isHidden && (text === 0 ? showZero : !!text && text !== true);
    const statusTextNode = !showStatusTextNode ? null : /*#__PURE__*/ $cQmXV.createElement("span", {
        className: `${prefixCls}-status-text`
    }, text);
    // >>> Display Component
    const displayNode = (0, $8e2d153a3c855782$export$53b83ca8eaab0383)(livingCount) ? (0, $a91ef204d03d8eec$export$e530037191fcd5d7)(livingCount, (oriProps)=>({
            style: {
                ...mergedStyle,
                ...oriProps.style
            }
        })) : undefined;
    // InternalColor
    const isInternalColor = (0, $4cbe68e4e955ed41$export$ee62ebd6a58c4884)(color, false);
    // Shared styles
    const statusCls = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(mergedClassNames.indicator, {
        [`${prefixCls}-status-dot`]: hasStatus,
        [`${prefixCls}-status-${status}`]: !!status,
        [`${prefixCls}-color-${color}`]: isInternalColor
    });
    const statusStyle = {};
    if (color && !isInternalColor) {
        statusStyle.color = color;
        statusStyle.background = color;
    }
    const badgeClassName = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, {
        [`${prefixCls}-status`]: hasStatus,
        [`${prefixCls}-not-a-wrapper`]: !children,
        [`${prefixCls}-rtl`]: direction === "rtl"
    }, className, rootClassName, contextClassName, mergedClassNames.root, hashId, cssVarCls);
    // <Badge status="success" />
    if (isStatusBadge) {
        const statusTextColor = mergedStyles.root?.color;
        return /*#__PURE__*/ $cQmXV.createElement("span", {
            ref: ref,
            ...restProps,
            className: badgeClassName,
            style: {
                ...offsetStyle,
                ...mergedStyles.root
            }
        }, /*#__PURE__*/ $cQmXV.createElement("span", {
            className: statusCls,
            style: {
                ...mergedStyles.indicator,
                ...statusStyle
            }
        }), showStatusTextNode && /*#__PURE__*/ $cQmXV.createElement("span", {
            style: {
                color: statusTextColor
            },
            className: `${prefixCls}-status-text`
        }, text));
    }
    return /*#__PURE__*/ $cQmXV.createElement("span", {
        ref: ref,
        ...restProps,
        className: badgeClassName,
        style: mergedStyles.root
    }, children, /*#__PURE__*/ $cQmXV.createElement((0, $04c53b89814950f8$export$2e2bcd8739ae039), {
        visible: !isHidden,
        motionName: `${prefixCls}-zoom`,
        motionAppear: false,
        motionDeadline: 1000
    }, ({ className: motionClassName })=>{
        const scrollNumberPrefixCls = getPrefixCls("scroll-number", customizeScrollNumberPrefixCls);
        const isDot = isDotRef.current;
        const scrollNumberCls = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(mergedClassNames.indicator, {
            [`${prefixCls}-dot`]: isDot,
            [`${prefixCls}-count`]: !isDot,
            [`${prefixCls}-count-sm`]: size === "small",
            [`${prefixCls}-multiple-words`]: !isDot && displayCount && displayCount.toString().length > 1,
            [`${prefixCls}-status-${status}`]: !!status,
            [`${prefixCls}-color-${color}`]: isInternalColor
        });
        let scrollNumberStyle = {
            ...offsetStyle,
            ...mergedStyles.indicator
        };
        if (color && !isInternalColor) {
            scrollNumberStyle = scrollNumberStyle || {};
            scrollNumberStyle.background = color;
        }
        return /*#__PURE__*/ $cQmXV.createElement((0, $9fcfc7037eb0bc17$export$2e2bcd8739ae039), {
            prefixCls: scrollNumberPrefixCls,
            show: !isHidden,
            motionClassName: motionClassName,
            className: scrollNumberCls,
            count: displayCount,
            title: titleNode,
            style: scrollNumberStyle,
            key: "scrollNumber"
        }, displayNode);
    }), statusTextNode);
});
var $2dd718bfd7ed6afa$export$2e2bcd8739ae039 = $2dd718bfd7ed6afa$var$Badge;



var $cQmXV = parcelRequire("cQmXV");








// ============================== Ribbon ==============================
const $ab1329c7d2df8064$var$genRibbonStyle = (token)=>{
    const { antCls: antCls, badgeFontHeight: badgeFontHeight, marginXS: marginXS, badgeRibbonOffset: badgeRibbonOffset, calc: calc } = token;
    const ribbonPrefixCls = `${antCls}-ribbon`;
    const ribbonWrapperPrefixCls = `${antCls}-ribbon-wrapper`;
    const statusRibbonPreset = (0, $7c652e13f0bdefc8$export$2e2bcd8739ae039)(token, (colorKey, { darkColor: darkColor })=>({
            [`&${ribbonPrefixCls}-color-${colorKey}`]: {
                background: darkColor,
                color: darkColor
            }
        }));
    return {
        [ribbonWrapperPrefixCls]: {
            position: "relative"
        },
        [ribbonPrefixCls]: {
            ...(0, $519d20bf207ce864$export$23997c3e44cc1c59)(token),
            position: "absolute",
            top: marginXS,
            padding: `0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.paddingXS)}`,
            color: token.colorPrimary,
            lineHeight: (0, $05f34ed03d41967d$export$523c0b569236b342)(badgeFontHeight),
            whiteSpace: "nowrap",
            backgroundColor: token.colorPrimary,
            borderRadius: token.borderRadiusSM,
            [`${ribbonPrefixCls}-content`]: {
                color: token.badgeTextColor
            },
            [`${ribbonPrefixCls}-corner`]: {
                position: "absolute",
                top: "100%",
                width: badgeRibbonOffset,
                height: badgeRibbonOffset,
                color: "currentcolor",
                border: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(calc(badgeRibbonOffset).div(2).equal())} solid`,
                transform: token.badgeRibbonCornerTransform,
                transformOrigin: "top",
                filter: token.badgeRibbonCornerFilter
            },
            ...statusRibbonPreset,
            [`&${ribbonPrefixCls}-placement-end`]: {
                insetInlineEnd: calc(badgeRibbonOffset).mul(-1).equal(),
                borderEndEndRadius: 0,
                [`${ribbonPrefixCls}-corner`]: {
                    insetInlineEnd: 0,
                    borderInlineEndColor: "transparent",
                    borderBlockEndColor: "transparent"
                }
            },
            [`&${ribbonPrefixCls}-placement-start`]: {
                insetInlineStart: calc(badgeRibbonOffset).mul(-1).equal(),
                borderEndStartRadius: 0,
                [`${ribbonPrefixCls}-corner`]: {
                    insetInlineStart: 0,
                    borderBlockEndColor: "transparent",
                    borderInlineStartColor: "transparent"
                }
            },
            // ====================== RTL =======================
            "&-rtl": {
                direction: "rtl"
            }
        }
    };
};
var // ============================== Export ==============================
$ab1329c7d2df8064$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$51ec95de45185b42)([
    "Badge",
    "Ribbon"
], (token)=>{
    const badgeToken = (0, $6c870bde7fa5136e$export$362fb92a8f81bbf9)(token);
    return $ab1329c7d2df8064$var$genRibbonStyle(badgeToken);
}, (0, $6c870bde7fa5136e$export$9ca1be8807fe0675));


"use client";
const $b0ddef09db0c8206$var$Ribbon = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { className: className, prefixCls: customizePrefixCls, style: style, color: color, children: children, text: text, placement: placement = "end", rootClassName: rootClassName, styles: styles, classNames: ribbonClassNames } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("ribbon");
    const prefixCls = getPrefixCls("ribbon", customizePrefixCls);
    const wrapperCls = `${prefixCls}-wrapper`;
    const [hashId, cssVarCls] = (0, $ab1329c7d2df8064$export$2e2bcd8739ae039)(prefixCls, wrapperCls);
    // =========== Merged Props for Semantic ===========
    const mergedProps = {
        ...props,
        placement: placement
    };
    const contextIndicatorStyle = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(contextStyle, "indicator");
    const indicatorStyle = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(style, "indicator");
    const [mergedClassNames, mergedStyles] = (0, $30c5f9f911d4f61b$export$648566b068f28737)([
        contextClassNames,
        ribbonClassNames
    ], [
        contextStyles,
        contextIndicatorStyle,
        styles,
        indicatorStyle
    ], {
        props: mergedProps
    });
    const colorInPreset = (0, $4cbe68e4e955ed41$export$ee62ebd6a58c4884)(color, false);
    const ribbonCls = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-placement-${placement}`, {
        [`${prefixCls}-rtl`]: direction === "rtl",
        [`${prefixCls}-color-${color}`]: colorInPreset
    }, className, contextClassName, mergedClassNames.indicator);
    const colorStyle = {};
    const cornerColorStyle = {};
    if (color && !colorInPreset) {
        colorStyle.background = color;
        cornerColorStyle.color = color;
    }
    const nativeElementRef = $cQmXV.useRef(null);
    $cQmXV.useImperativeHandle(ref, ()=>({
            nativeElement: nativeElementRef.current
        }));
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        ref: nativeElementRef,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(wrapperCls, rootClassName, hashId, cssVarCls, mergedClassNames.root),
        style: mergedStyles.root
    }, children, /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(ribbonCls, hashId),
        style: {
            ...colorStyle,
            ...mergedStyles.indicator
        }
    }, /*#__PURE__*/ $cQmXV.createElement("span", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-content`, mergedClassNames.content),
        style: mergedStyles.content
    }, text), /*#__PURE__*/ $cQmXV.createElement("div", {
        className: `${prefixCls}-corner`,
        style: cornerColorStyle
    })));
});
var $b0ddef09db0c8206$export$2e2bcd8739ae039 = $b0ddef09db0c8206$var$Ribbon;


"use client";
const $b5470af5a9674a86$var$Badge = (0, $2dd718bfd7ed6afa$export$2e2bcd8739ae039);
$b5470af5a9674a86$var$Badge.Ribbon = (0, $b0ddef09db0c8206$export$2e2bcd8739ae039);
var $b5470af5a9674a86$export$2e2bcd8739ae039 = $b5470af5a9674a86$var$Badge;



var $cQmXV = parcelRequire("cQmXV");
var $4f4d89350c9de693$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($4f4d89350c9de693$exports, "__esModule", {
    value: true
});
var $4f4d89350c9de693$var$EnvironmentOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M854.6 289.1a362.49 362.49 0 00-79.9-115.7 370.83 370.83 0 00-118.2-77.8C610.7 76.6 562.1 67 512 67c-50.1 0-98.7 9.6-144.5 28.5-44.3 18.3-84 44.5-118.2 77.8A363.6 363.6 0 00169.4 289c-19.5 45-29.4 92.8-29.4 142 0 70.6 16.9 140.9 50.1 208.7 26.7 54.5 64 107.6 111 158.1 80.3 86.2 164.5 138.9 188.4 153a43.9 43.9 0 0022.4 6.1c7.8 0 15.5-2 22.4-6.1 23.9-14.1 108.1-66.8 188.4-153 47-50.4 84.3-103.6 111-158.1C867.1 572 884 501.8 884 431.1c0-49.2-9.9-97-29.4-142zM512 880.2c-65.9-41.9-300-207.8-300-449.1 0-77.9 31.1-151.1 87.6-206.3C356.3 169.5 431.7 139 512 139s155.7 30.5 212.4 85.9C780.9 280 812 353.2 812 431.1c0 241.3-234.1 407.2-300 449.1zm0-617.2c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm79.2 255.2A111.6 111.6 0 01512 551c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 01400 439c0-29.9 11.7-58 32.8-79.2C454 338.6 482.1 327 512 327c29.9 0 58 11.6 79.2 32.8C612.4 381 624 409.1 624 439c0 29.9-11.6 58-32.8 79.2z"
                }
            }
        ]
    },
    "name": "environment",
    "theme": "outlined"
};
$4f4d89350c9de693$exports.default = $4f4d89350c9de693$var$EnvironmentOutlined;



function $d6c8837c82724a15$var$_extends() {
    $d6c8837c82724a15$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d6c8837c82724a15$var$_extends.apply(this, arguments);
}
const $d6c8837c82724a15$var$EnvironmentOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $d6c8837c82724a15$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4f4d89350c9de693$exports)))
    }));
/**![environment](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg1NC42IDI4OS4xYTM2Mi40OSAzNjIuNDkgMCAwMC03OS45LTExNS43IDM3MC44MyAzNzAuODMgMCAwMC0xMTguMi03Ny44QzYxMC43IDc2LjYgNTYyLjEgNjcgNTEyIDY3Yy01MC4xIDAtOTguNyA5LjYtMTQ0LjUgMjguNS00NC4zIDE4LjMtODQgNDQuNS0xMTguMiA3Ny44QTM2My42IDM2My42IDAgMDAxNjkuNCAyODljLTE5LjUgNDUtMjkuNCA5Mi44LTI5LjQgMTQyIDAgNzAuNiAxNi45IDE0MC45IDUwLjEgMjA4LjcgMjYuNyA1NC41IDY0IDEwNy42IDExMSAxNTguMSA4MC4zIDg2LjIgMTY0LjUgMTM4LjkgMTg4LjQgMTUzYTQzLjkgNDMuOSAwIDAwMjIuNCA2LjFjNy44IDAgMTUuNS0yIDIyLjQtNi4xIDIzLjktMTQuMSAxMDguMS02Ni44IDE4OC40LTE1MyA0Ny01MC40IDg0LjMtMTAzLjYgMTExLTE1OC4xQzg2Ny4xIDU3MiA4ODQgNTAxLjggODg0IDQzMS4xYzAtNDkuMi05LjktOTctMjkuNC0xNDJ6TTUxMiA4ODAuMmMtNjUuOS00MS45LTMwMC0yMDcuOC0zMDAtNDQ5LjEgMC03Ny45IDMxLjEtMTUxLjEgODcuNi0yMDYuM0MzNTYuMyAxNjkuNSA0MzEuNyAxMzkgNTEyIDEzOXMxNTUuNyAzMC41IDIxMi40IDg1LjlDNzgwLjkgMjgwIDgxMiAzNTMuMiA4MTIgNDMxLjFjMCAyNDEuMy0yMzQuMSA0MDcuMi0zMDAgNDQ5LjF6bTAtNjE3LjJjLTk3LjIgMC0xNzYgNzguOC0xNzYgMTc2czc4LjggMTc2IDE3NiAxNzYgMTc2LTc4LjggMTc2LTE3Ni03OC44LTE3Ni0xNzYtMTc2em03OS4yIDI1NS4yQTExMS42IDExMS42IDAgMDE1MTIgNTUxYy0yOS45IDAtNTgtMTEuNy03OS4yLTMyLjhBMTExLjYgMTExLjYgMCAwMTQwMCA0MzljMC0yOS45IDExLjctNTggMzIuOC03OS4yQzQ1NCAzMzguNiA0ODIuMSAzMjcgNTEyIDMyN2MyOS45IDAgNTggMTEuNiA3OS4yIDMyLjhDNjEyLjQgMzgxIDYyNCA0MDkuMSA2MjQgNDM5YzAgMjkuOS0xMS42IDU4LTMyLjggNzkuMnoiIC8+PC9zdmc+) */ const $d6c8837c82724a15$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($d6c8837c82724a15$var$EnvironmentOutlined);
var $d6c8837c82724a15$export$2e2bcd8739ae039 = $d6c8837c82724a15$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $c90489e723bfe36c$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($c90489e723bfe36c$exports, "__esModule", {
    value: true
});
var $c90489e723bfe36c$var$IdcardOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136V232h752v560zM610.3 476h123.4c1.3 0 2.3-3.6 2.3-8v-48c0-4.4-1-8-2.3-8H610.3c-1.3 0-2.3 3.6-2.3 8v48c0 4.4 1 8 2.3 8zm4.8 144h185.7c3.9 0 7.1-3.6 7.1-8v-48c0-4.4-3.2-8-7.1-8H615.1c-3.9 0-7.1 3.6-7.1 8v48c0 4.4 3.2 8 7.1 8zM224 673h43.9c4.2 0 7.6-3.3 7.9-7.5 3.8-50.5 46-90.5 97.2-90.5s93.4 40 97.2 90.5c.3 4.2 3.7 7.5 7.9 7.5H522a8 8 0 008-8.4c-2.8-53.3-32-99.7-74.6-126.1a111.8 111.8 0 0029.1-75.5c0-61.9-49.9-112-111.4-112s-111.4 50.1-111.4 112c0 29.1 11 55.5 29.1 75.5a158.09 158.09 0 00-74.6 126.1c-.4 4.6 3.2 8.4 7.8 8.4zm149-262c28.5 0 51.7 23.3 51.7 52s-23.2 52-51.7 52-51.7-23.3-51.7-52 23.2-52 51.7-52z"
                }
            }
        ]
    },
    "name": "idcard",
    "theme": "outlined"
};
$c90489e723bfe36c$exports.default = $c90489e723bfe36c$var$IdcardOutlined;



function $e85f2e3cc711f245$var$_extends() {
    $e85f2e3cc711f245$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e85f2e3cc711f245$var$_extends.apply(this, arguments);
}
const $e85f2e3cc711f245$var$IdcardOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $e85f2e3cc711f245$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($c90489e723bfe36c$exports)))
    }));
/**![idcard](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkyOCAxNjBIOTZjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjY0MGMwIDE3LjcgMTQuMyAzMiAzMiAzMmg4MzJjMTcuNyAwIDMyLTE0LjMgMzItMzJWMTkyYzAtMTcuNy0xNC4zLTMyLTMyLTMyem0tNDAgNjMySDEzNlYyMzJoNzUydjU2MHpNNjEwLjMgNDc2aDEyMy40YzEuMyAwIDIuMy0zLjYgMi4zLTh2LTQ4YzAtNC40LTEtOC0yLjMtOEg2MTAuM2MtMS4zIDAtMi4zIDMuNi0yLjMgOHY0OGMwIDQuNCAxIDggMi4zIDh6bTQuOCAxNDRoMTg1LjdjMy45IDAgNy4xLTMuNiA3LjEtOHYtNDhjMC00LjQtMy4yLTgtNy4xLThINjE1LjFjLTMuOSAwLTcuMSAzLjYtNy4xIDh2NDhjMCA0LjQgMy4yIDggNy4xIDh6TTIyNCA2NzNoNDMuOWM0LjIgMCA3LjYtMy4zIDcuOS03LjUgMy44LTUwLjUgNDYtOTAuNSA5Ny4yLTkwLjVzOTMuNCA0MCA5Ny4yIDkwLjVjLjMgNC4yIDMuNyA3LjUgNy45IDcuNUg1MjJhOCA4IDAgMDA4LTguNGMtMi44LTUzLjMtMzItOTkuNy03NC42LTEyNi4xYTExMS44IDExMS44IDAgMDAyOS4xLTc1LjVjMC02MS45LTQ5LjktMTEyLTExMS40LTExMnMtMTExLjQgNTAuMS0xMTEuNCAxMTJjMCAyOS4xIDExIDU1LjUgMjkuMSA3NS41YTE1OC4wOSAxNTguMDkgMCAwMC03NC42IDEyNi4xYy0uNCA0LjYgMy4yIDguNCA3LjggOC40em0xNDktMjYyYzI4LjUgMCA1MS43IDIzLjMgNTEuNyA1MnMtMjMuMiA1Mi01MS43IDUyLTUxLjctMjMuMy01MS43LTUyIDIzLjItNTIgNTEuNy01MnoiIC8+PC9zdmc+) */ const $e85f2e3cc711f245$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($e85f2e3cc711f245$var$IdcardOutlined);
var $e85f2e3cc711f245$export$2e2bcd8739ae039 = $e85f2e3cc711f245$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $f3908ccd0f0e9d09$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($f3908ccd0f0e9d09$exports, "__esModule", {
    value: true
});
var $f3908ccd0f0e9d09$var$OrderedListOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M920 760H336c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-568H336c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H336c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM216 712H100c-2.2 0-4 1.8-4 4v34c0 2.2 1.8 4 4 4h72.4v20.5h-35.7c-2.2 0-4 1.8-4 4v34c0 2.2 1.8 4 4 4h35.7V838H100c-2.2 0-4 1.8-4 4v34c0 2.2 1.8 4 4 4h116c2.2 0 4-1.8 4-4V716c0-2.2-1.8-4-4-4zM100 188h38v120c0 2.2 1.8 4 4 4h40c2.2 0 4-1.8 4-4V152c0-4.4-3.6-8-8-8h-78c-2.2 0-4 1.8-4 4v36c0 2.2 1.8 4 4 4zm116 240H100c-2.2 0-4 1.8-4 4v36c0 2.2 1.8 4 4 4h68.4l-70.3 77.7a8.3 8.3 0 00-2.1 5.4V592c0 2.2 1.8 4 4 4h116c2.2 0 4-1.8 4-4v-36c0-2.2-1.8-4-4-4h-68.4l70.3-77.7a8.3 8.3 0 002.1-5.4V432c0-2.2-1.8-4-4-4z"
                }
            }
        ]
    },
    "name": "ordered-list",
    "theme": "outlined"
};
$f3908ccd0f0e9d09$exports.default = $f3908ccd0f0e9d09$var$OrderedListOutlined;



function $170c031fa50279f7$var$_extends() {
    $170c031fa50279f7$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $170c031fa50279f7$var$_extends.apply(this, arguments);
}
const $170c031fa50279f7$var$OrderedListOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $170c031fa50279f7$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($f3908ccd0f0e9d09$exports)))
    }));
/**![ordered-list](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkyMCA3NjBIMzM2Yy00LjQgMC04IDMuNi04IDh2NTZjMCA0LjQgMy42IDggOCA4aDU4NGM0LjQgMCA4LTMuNiA4LTh2LTU2YzAtNC40LTMuNi04LTgtOHptMC01NjhIMzM2Yy00LjQgMC04IDMuNi04IDh2NTZjMCA0LjQgMy42IDggOCA4aDU4NGM0LjQgMCA4LTMuNiA4LTh2LTU2YzAtNC40LTMuNi04LTgtOHptMCAyODRIMzM2Yy00LjQgMC04IDMuNi04IDh2NTZjMCA0LjQgMy42IDggOCA4aDU4NGM0LjQgMCA4LTMuNiA4LTh2LTU2YzAtNC40LTMuNi04LTgtOHpNMjE2IDcxMkgxMDBjLTIuMiAwLTQgMS44LTQgNHYzNGMwIDIuMiAxLjggNCA0IDRoNzIuNHYyMC41aC0zNS43Yy0yLjIgMC00IDEuOC00IDR2MzRjMCAyLjIgMS44IDQgNCA0aDM1LjdWODM4SDEwMGMtMi4yIDAtNCAxLjgtNCA0djM0YzAgMi4yIDEuOCA0IDQgNGgxMTZjMi4yIDAgNC0xLjggNC00VjcxNmMwLTIuMi0xLjgtNC00LTR6TTEwMCAxODhoMzh2MTIwYzAgMi4yIDEuOCA0IDQgNGg0MGMyLjIgMCA0LTEuOCA0LTRWMTUyYzAtNC40LTMuNi04LTgtOGgtNzhjLTIuMiAwLTQgMS44LTQgNHYzNmMwIDIuMiAxLjggNCA0IDR6bTExNiAyNDBIMTAwYy0yLjIgMC00IDEuOC00IDR2MzZjMCAyLjIgMS44IDQgNCA0aDY4LjRsLTcwLjMgNzcuN2E4LjMgOC4zIDAgMDAtMi4xIDUuNFY1OTJjMCAyLjIgMS44IDQgNCA0aDExNmMyLjIgMCA0LTEuOCA0LTR2LTM2YzAtMi4yLTEuOC00LTQtNGgtNjguNGw3MC4zLTc3LjdhOC4zIDguMyAwIDAwMi4xLTUuNFY0MzJjMC0yLjItMS44LTQtNC00eiIgLz48L3N2Zz4=) */ const $170c031fa50279f7$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($170c031fa50279f7$var$OrderedListOutlined);
var $170c031fa50279f7$export$2e2bcd8739ae039 = $170c031fa50279f7$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $524949e05d3b80b8$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($524949e05d3b80b8$exports, "__esModule", {
    value: true
});
var $524949e05d3b80b8$var$BellOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M816 768h-24V428c0-141.1-104.3-257.7-240-277.1V112c0-22.1-17.9-40-40-40s-40 17.9-40 40v38.9c-135.7 19.4-240 136-240 277.1v340h-24c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h216c0 61.8 50.2 112 112 112s112-50.2 112-112h216c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM512 888c-26.5 0-48-21.5-48-48h96c0 26.5-21.5 48-48 48zM304 768V428c0-55.6 21.6-107.8 60.9-147.1S456.4 220 512 220c55.6 0 107.8 21.6 147.1 60.9S720 372.4 720 428v340H304z"
                }
            }
        ]
    },
    "name": "bell",
    "theme": "outlined"
};
$524949e05d3b80b8$exports.default = $524949e05d3b80b8$var$BellOutlined;



function $1005916731c83b87$var$_extends() {
    $1005916731c83b87$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1005916731c83b87$var$_extends.apply(this, arguments);
}
const $1005916731c83b87$var$BellOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $1005916731c83b87$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($524949e05d3b80b8$exports)))
    }));
/**![bell](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTgxNiA3NjhoLTI0VjQyOGMwLTE0MS4xLTEwNC4zLTI1Ny43LTI0MC0yNzcuMVYxMTJjMC0yMi4xLTE3LjktNDAtNDAtNDBzLTQwIDE3LjktNDAgNDB2MzguOWMtMTM1LjcgMTkuNC0yNDAgMTM2LTI0MCAyNzcuMXYzNDBoLTI0Yy0xNy43IDAtMzIgMTQuMy0zMiAzMnYzMmMwIDQuNCAzLjYgOCA4IDhoMjE2YzAgNjEuOCA1MC4yIDExMiAxMTIgMTEyczExMi01MC4yIDExMi0xMTJoMjE2YzQuNCAwIDgtMy42IDgtOHYtMzJjMC0xNy43LTE0LjMtMzItMzItMzJ6TTUxMiA4ODhjLTI2LjUgMC00OC0yMS41LTQ4LTQ4aDk2YzAgMjYuNS0yMS41IDQ4LTQ4IDQ4ek0zMDQgNzY4VjQyOGMwLTU1LjYgMjEuNi0xMDcuOCA2MC45LTE0Ny4xUzQ1Ni40IDIyMCA1MTIgMjIwYzU1LjYgMCAxMDcuOCAyMS42IDE0Ny4xIDYwLjlTNzIwIDM3Mi40IDcyMCA0Mjh2MzQwSDMwNHoiIC8+PC9zdmc+) */ const $1005916731c83b87$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($1005916731c83b87$var$BellOutlined);
var $1005916731c83b87$export$2e2bcd8739ae039 = $1005916731c83b87$var$RefIcon;




const $fc3f36407bc5ec6c$export$72266474e9355649 = {
    overview: {
        uk: "\u041E\u0433\u043B\u044F\u0434",
        en: "Overview",
        hy: "\u0531\u056F\u0576\u0561\u0580\u056F",
        ka: "\u10DB\u10D8\u10DB\u10DD\u10EE\u10D8\u10DA\u10D5\u10D0"
    },
    photo_report: {
        uk: "\u0424\u043E\u0442\u043E \u0437\u0432\u0456\u0442",
        en: "Photo report",
        hy: "\u053C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580\u056B \u0570\u0561\u0577\u057E\u0565\u057F\u057E\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10E4\u10DD\u10E2\u10DD \u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10D8"
    },
    all_reports: {
        uk: "BI \u0437\u0432\u0456\u0442\u0438",
        en: "BI reports",
        hy: "BI \u0570\u0561\u0577\u057E\u0565\u057F\u057E\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580",
        ka: "BI \u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10D4\u10D1\u10D8"
    },
    merchandiser: {
        uk: "\u041C\u0435\u0440\u0447\u0435\u043D\u0434\u0430\u0439\u0437\u0435\u0440",
        en: "Merchandiser",
        hy: "\u0544\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580",
        ka: "\u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D8"
    },
    supervisors: {
        uk: "\u0421\u0443\u043F\u0435\u0440\u0432\u0430\u0439\u0437\u0435\u0440\u0438",
        en: "Supervisors",
        hy: "\u054D\u0578\u0582\u057A\u0565\u0580\u057E\u0561\u0575\u0566\u0565\u0580\u0576\u0565\u0580",
        ka: "\u10E1\u10E3\u10DE\u10D4\u10E0\u10D5\u10D0\u10D8\u10D6\u10D4\u10E0\u10D4\u10D1\u10D8"
    },
    tasks: {
        uk: "\u0417\u0430\u0432\u0434\u0430\u043D\u043D\u044F",
        en: "Tasks",
        hy: "\u0531\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0576\u0565\u0580",
        ka: "\u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8"
    },
    my_uploads: {
        uk: "\u041C\u043E\u0457 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F",
        en: "My Uploads",
        hy: "\u053B\u0574 \u057E\u0565\u0580\u0562\u0565\u057C\u0576\u0578\u0582\u0574\u0576\u0565\u0580\u0568",
        ka: "\u10E9\u10D4\u10DB\u10D8 \u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D4\u10D1\u10D8"
    },
    answers: {
        uk: "\u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0456",
        en: "Answers",
        hy: "\u054A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0576\u0565\u0580",
        ka: "\u10DE\u10D0\u10E1\u10E3\u10EE\u10D4\u10D1\u10D8"
    },
    task_uploading: {
        uk: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0437\u0430\u0432\u0434\u0430\u043D\u044C",
        en: "Task uploading",
        hy: "\u0531\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0576\u0565\u0580\u056B \u057E\u0565\u0580\u0562\u0565\u057C\u0576\u0578\u0582\u0574",
        ka: "\u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8\u10E1 \u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D0"
    },
    points: {
        uk: "\u0422\u043E\u0447\u043A\u0438",
        en: "Points",
        hy: "\u053F\u0565\u057F\u0565\u0580",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8"
    },
    visit: {
        uk: "\u0412\u0456\u0437\u0438\u0442\u0438",
        en: "Visits",
        hy: "\u0531\u0575\u0581\u0565\u0580",
        ka: "\u10D5\u10D8\u10D6\u10D8\u10E2\u10D4\u10D1\u10D8"
    },
    tracking: {
        uk: "\u041E\u043D\u043B\u0430\u0439\u043D-\u043C\u043E\u043D\u0456\u0442\u043E\u0440\u0438\u043D\u0433",
        en: "Online tracking",
        hy: "\u0531\u057C\u0581\u0561\u0576\u0581 \u0574\u0578\u0576\u056B\u057F\u0578\u0580\u056B\u0576\u0563",
        ka: "\u10DD\u10DC\u10DA\u10D0\u10D8\u10DC \u10DB\u10DD\u10DC\u10D8\u10E2\u10DD\u10E0\u10D8\u10DC\u10D2\u10D8"
    },
    documents: {
        uk: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438",
        en: "Documents",
        hy: "\u0553\u0561\u057D\u057F\u0561\u0569\u0572\u0569\u0565\u0580",
        ka: "\u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8"
    },
    logout: {
        uk: "\u0412\u0438\u0445\u0456\u0434",
        en: "Logout",
        hy: "\u0534\u0578\u0582\u0580\u057D \u0563\u0561\u056C",
        ka: "\u10D2\u10D0\u10DB\u10DD\u10E1\u10D5\u10DA\u10D0"
    },
    pt_points: {
        uk: "\u0422\u043E\u0447\u043A\u0438",
        en: "Points",
        hy: "\u053F\u0565\u057F\u0565\u0580",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8"
    },
    pt_networks: {
        uk: "\u041C\u0435\u0440\u0435\u0436\u0456",
        en: "Networks",
        hy: "\u0551\u0561\u0576\u0581\u0565\u0580",
        ka: "\u10E5\u10E1\u10D4\u10DA\u10D4\u10D1\u10D8"
    },
    pt_categories: {
        uk: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u0457",
        en: "Categories",
        hy: "\u053F\u0561\u057F\u0565\u0563\u0578\u0580\u056B\u0561\u0576\u0565\u0580",
        ka: "\u10D9\u10D0\u10E2\u10D4\u10D2\u10DD\u10E0\u10D8\u10D4\u10D1\u10D8"
    },
    pt_countries: {
        uk: "\u041A\u0440\u0430\u0457\u043D\u0438",
        en: "Countries",
        hy: "\u0535\u0580\u056F\u0580\u0576\u0565\u0580",
        ka: "\u10E5\u10D5\u10D4\u10E7\u10DC\u10D4\u10D1\u10D8"
    },
    pt_counties: {
        uk: "\u0420\u0435\u0433\u0456\u043E\u043D\u0438",
        en: "Counties",
        hy: "\u0544\u0561\u0580\u0566\u0565\u0580",
        ka: "\u10E0\u10D4\u10D2\u10D8\u10DD\u10DC\u10D4\u10D1\u10D8"
    },
    pt_localities: {
        uk: "\u041D\u0430\u0441\u0435\u043B\u0435\u043D\u0456 \u043F\u0443\u043D\u043A\u0442\u0438",
        en: "Localities",
        hy: "\u0532\u0576\u0561\u056F\u0561\u057E\u0561\u0575\u0580\u0565\u0580",
        ka: "\u10D3\u10D0\u10E1\u10D0\u10EE\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8"
    },
    pt_point_groups: {
        uk: "\u0413\u0440\u0443\u043F\u0438 \u0442\u043E\u0447\u043E\u043A",
        en: "Point groups",
        hy: "\u053F\u0565\u057F\u0565\u0580\u056B \u056D\u0574\u0562\u0565\u0580",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1 \u10EF\u10D2\u10E3\u10E4\u10D4\u10D1\u10D8"
    },
    pt_surveys: {
        uk: "\u041E\u043F\u0438\u0442\u0443\u0432\u0430\u043D\u043D\u044F",
        en: "Surveys",
        hy: "\u0540\u0561\u0580\u0581\u0578\u0582\u0574\u0576\u0565\u0580",
        ka: "\u10D2\u10D0\u10DB\u10DD\u10D9\u10D8\u10D7\u10EE\u10D5\u10D4\u10D1\u10D8"
    }
};
const $fc3f36407bc5ec6c$export$7926257c0571e339 = {
    my_profile: {
        uk: "\u041C\u0456\u0439 \u043F\u0440\u043E\u0444\u0430\u0439\u043B",
        en: "My profile",
        hy: "\u053B\u0574 \u057A\u0580\u0578\u0586\u056B\u056C\u0568",
        ka: "\u10E9\u10D4\u10DB\u10D8 \u10DE\u10E0\u10DD\u10E4\u10D8\u10DA\u10D8"
    },
    my_help: {
        uk: "\u0414\u043E\u043F\u043E\u043C\u043E\u0433\u0430",
        en: "Help",
        hy: "\u0555\u0563\u0576\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10D3\u10D0\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D0"
    },
    name: {
        uk: "\u0406\u043C\u044F",
        en: "Name",
        hy: "\u0531\u0576\u0578\u0582\u0576",
        ka: "\u10E1\u10D0\u10EE\u10D4\u10DA\u10D8"
    },
    surname: {
        uk: "\u041F\u0440\u0456\u0437\u0432\u0438\u0449\u0435",
        en: "Surname",
        hy: "\u0531\u0566\u0563\u0561\u0576\u0578\u0582\u0576",
        ka: "\u10D2\u10D5\u10D0\u10E0\u10D8"
    },
    position: {
        uk: "\u041F\u043E\u0441\u0430\u0434\u0430",
        en: "Position",
        hy: "\u054A\u0561\u0577\u057F\u0578\u0576",
        ka: "\u10DE\u10DD\u10D6\u10D8\u10EA\u10D8\u10D0"
    },
    my_region: {
        uk: "\u041C\u0456\u0439 \u0440\u0435\u0433\u0456\u043E\u043D",
        en: "My region",
        hy: "\u053B\u0574 \u0574\u0561\u0580\u0566\u0568",
        ka: "\u10E9\u10D4\u10DB\u10D8 \u10E0\u10D4\u10D2\u10D8\u10DD\u10DC\u10D8"
    },
    telegram: {
        uk: "\u0422\u0435\u043B\u0435\u0433\u0440\u0430\u043C ID",
        en: "Telegram ID",
        hy: "\u054F\u0565\u056C\u0565\u0563\u0580\u0561\u0574 ID",
        ka: "\u10E2\u10D4\u10DA\u10D4\u10D2\u10E0\u10D0\u10DB ID"
    },
    language: {
        uk: "\u041C\u043E\u0432\u0430",
        en: "Language",
        hy: "\u053C\u0565\u0566\u0578\u0582",
        ka: "\u10D4\u10DC\u10D0"
    },
    save: {
        uk: "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438",
        en: "Save",
        hy: "\u054A\u0561\u0570\u057A\u0561\u0576\u0565\u056C",
        ka: "\u10E8\u10D4\u10DC\u10D0\u10EE\u10D5\u10D0"
    },
    save_success: {
        uk: "\u0414\u0430\u043D\u0456 \u0443\u0441\u043F\u0456\u0448\u043D\u043E \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u0456",
        en: "Data saved successfully",
        hy: "\u054F\u057E\u0575\u0561\u056C\u0576\u0565\u0580\u0568 \u0570\u0561\u057B\u0578\u0572\u0578\u0582\u0569\u0575\u0561\u0574\u0562 \u057A\u0561\u0570\u057A\u0561\u0576\u057E\u0565\u0581\u056B\u0576",
        ka: "\u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8 \u10EC\u10D0\u10E0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D8\u10D7 \u10E8\u10D4\u10DC\u10D0\u10EE\u10E3\u10DA\u10D8\u10D0"
    },
    save_success_reload: {
        uk: "\u0414\u0430\u043D\u0456 \u0443\u0441\u043F\u0456\u0448\u043D\u043E \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u0456. \u0421\u0442\u043E\u0440\u0456\u043D\u043A\u0430 \u0431\u0443\u0434\u0435 \u043F\u0435\u0440\u0435\u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u0430...",
        en: "Data saved successfully. The page will be reloaded...",
        hy: "\u054F\u057E\u0575\u0561\u056C\u0576\u0565\u0580\u0568 \u0570\u0561\u057B\u0578\u0572\u0578\u0582\u0569\u0575\u0561\u0574\u0562 \u057A\u0561\u0570\u057A\u0561\u0576\u057E\u0565\u0581\u056B\u0576\u0589 \u0537\u057B\u0568 \u056F\u057E\u0565\u0580\u0562\u0565\u057C\u0576\u057E\u056B...",
        ka: "\u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8 \u10EC\u10D0\u10E0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D8\u10D7 \u10E8\u10D4\u10DC\u10D0\u10EE\u10E3\u10DA\u10D8\u10D0. \u10D2\u10D5\u10D4\u10E0\u10D3\u10D8 \u10D2\u10D0\u10D3\u10D0\u10D8\u10E2\u10D5\u10D8\u10E0\u10D7\u10D4\u10D1\u10D0..."
    },
    exit: {
        uk: "\u0412\u0438\u0445\u0456\u0434",
        en: "Logout",
        hy: "\u0534\u0578\u0582\u0580\u057D \u0563\u0561\u056C",
        ka: "\u10D2\u10D0\u10DB\u10DD\u10E1\u10D5\u10DA\u10D0"
    }
};
const $fc3f36407bc5ec6c$export$33bf88bbb69ebeac = {
    custom_filter: {
        uk: "\u041A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0446\u044C\u043A\u0438\u0439 \u0444\u0456\u043B\u044C\u0442\u0440",
        en: "Customer filter",
        hy: "\u0540\u0561\u057F\u0578\u0582\u056F \u0586\u056B\u056C\u057F\u0580",
        ka: "\u10DB\u10DD\u10E0\u10D2\u10D4\u10D1\u10E3\u10DA\u10D8 \u10E4\u10D8\u10DA\u10E2\u10E0\u10D8"
    },
    merchandiser: {
        uk: "\u041C\u0435\u0440\u0447\u0435\u043D\u0434\u0430\u0439\u0437\u0435\u0440",
        en: "Merchandiser",
        hy: "\u0544\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580",
        ka: "\u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D8"
    },
    merchandisers: {
        uk: "\u041C\u0435\u0440\u0447\u0435\u043D\u0434\u0430\u0439\u0437\u0435\u0440\u0438",
        en: "Merchandisers",
        hy: "\u0544\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580\u0576\u0565\u0580",
        ka: "\u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D4\u10D1\u10D8"
    },
    supervisor: {
        uk: "\u0421\u0443\u043F\u0435\u0440\u0432\u0430\u0439\u0437\u0435\u0440",
        en: "Supervisor",
        hy: "\u054D\u0578\u0582\u057A\u0565\u0580\u057E\u0561\u0575\u0566\u0565\u0580",
        ka: "\u10E1\u10E3\u10DE\u10D4\u10E0\u10D5\u10D0\u10D8\u10D6\u10D4\u10E0\u10D8"
    },
    clients: {
        uk: "\u041A\u043B\u0456\u0454\u043D\u0442\u0438",
        en: "Clients",
        hy: "\u0540\u0561\u0573\u0561\u056D\u0578\u0580\u0564\u0576\u0565\u0580",
        ka: "\u10D9\u10DA\u10D8\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8"
    },
    comment: {
        uk: "\u041A\u043E\u043C\u0435\u043D\u0442\u0430\u0440",
        en: "Comment",
        hy: "\u0544\u0565\u056F\u0576\u0561\u0562\u0561\u0576\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10D9\u10DD\u10DB\u10D4\u10DC\u10E2\u10D0\u10E0\u10D8"
    },
    point: {
        uk: "\u0422\u043E\u0447\u043A\u0430",
        en: "Point",
        hy: "\u053F\u0565\u057F",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8"
    },
    points: {
        uk: "\u0422\u043E\u0447\u043A\u0438",
        en: "Points",
        hy: "\u053F\u0565\u057F\u0565\u0580",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8"
    },
    group_point_select_placeholder: {
        uk: "\u0413\u0440\u0443\u043F\u0430 \u0442\u043E\u0447\u043E\u043A",
        en: "Group of points",
        hy: "\u053F\u0565\u057F\u0565\u0580\u056B \u056D\u0578\u0582\u0574\u0562",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1 \u10EF\u10D2\u10E3\u10E4\u10D8"
    },
    network: {
        uk: "\u041C\u0435\u0440\u0435\u0436\u0430",
        en: "Network",
        hy: "\u0551\u0561\u0576\u0581",
        ka: "\u10E5\u10E1\u10D4\u10DA\u10D8"
    },
    networks: {
        uk: "\u041C\u0435\u0440\u0435\u0436\u0456",
        en: "Networks",
        hy: "\u0551\u0561\u0576\u0581\u0565\u0580",
        ka: "\u10E5\u10E1\u10D4\u10DA\u10D4\u10D1\u10D8"
    },
    created_by: {
        uk: "\u041A\u0438\u043C \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043E",
        en: "Created by",
        hy: "\u054D\u057F\u0565\u0572\u056E\u0565\u056C \u0567",
        ka: "\u10E8\u10D4\u10DB\u10E5\u10DB\u10DC\u10D4\u10DA\u10D8"
    },
    region: {
        uk: "\u0420\u0435\u0433\u0456\u043E\u043D",
        en: "Region",
        hy: "\u0544\u0561\u0580\u0566",
        ka: "\u10E0\u10D4\u10D2\u10D8\u10DD\u10DC\u10D8"
    },
    city: {
        uk: "\u041C\u0456\u0441\u0442\u043E",
        en: "City",
        hy: "\u0554\u0561\u0572\u0561\u0584",
        ka: "\u10E5\u10D0\u10DA\u10D0\u10E5\u10D8"
    },
    country: {
        uk: "\u041E\u0431\u0435\u0440\u0456\u0442\u044C \u043A\u0440\u0430\u0457\u043D\u0443",
        en: "Select country",
        hy: "\u0538\u0576\u057F\u0580\u0565\u0584 \u0565\u0580\u056F\u056B\u0580\u0568",
        ka: "\u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10E5\u10D5\u10D4\u10E7\u10D0\u10DC\u10D0"
    },
    countries: {
        uk: "\u041E\u0431\u0435\u0440\u0456\u0442\u044C \u043A\u0440\u0430\u0457\u043D\u0443",
        en: "Select country",
        hy: "\u0538\u0576\u057F\u0580\u0565\u0584 \u0565\u0580\u056F\u056B\u0580\u0568",
        ka: "\u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10E5\u10D5\u10D4\u10E7\u10D0\u10DC\u10D0"
    },
    brand: {
        uk: "\u0411\u0440\u0435\u043D\u0434",
        en: "Brand",
        hy: "\u0532\u0580\u0565\u0576\u0564",
        ka: "\u10D1\u10E0\u10D4\u10DC\u10D3\u10D8"
    },
    brands: {
        uk: "\u0411\u0440\u0435\u043D\u0434\u0438",
        en: "Brands",
        hy: "\u0532\u0580\u0565\u0576\u0564\u0576\u0565\u0580",
        ka: "\u10D1\u10E0\u10D4\u10DC\u10D3\u10D4\u10D1\u10D8"
    },
    product: {
        uk: "\u041F\u0440\u043E\u0434\u0443\u043A\u0442",
        en: "Product",
        hy: "\u0531\u057A\u0580\u0561\u0576\u0584",
        ka: "\u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10E2\u10D8"
    },
    products: {
        uk: "\u041F\u0440\u043E\u0434\u0443\u043A\u0442\u0438",
        en: "Products",
        hy: "\u0531\u057A\u0580\u0561\u0576\u0584\u0576\u0565\u0580",
        ka: "\u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10E2\u10D4\u10D1\u10D8"
    },
    category: {
        uk: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u044F",
        en: "Category",
        hy: "\u053F\u0561\u057F\u0565\u0563\u0578\u0580\u056B\u0561",
        ka: "\u10D9\u10D0\u10E2\u10D4\u10D2\u10DD\u10E0\u10D8\u10D0"
    },
    categories: {
        uk: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u0457",
        en: "Categories",
        hy: "\u053F\u0561\u057F\u0565\u0563\u0578\u0580\u056B\u0561\u0576\u0565\u0580",
        ka: "\u10D9\u10D0\u10E2\u10D4\u10D2\u10DD\u10E0\u10D8\u10D4\u10D1\u10D8"
    },
    subcategories: {
        uk: "\u041F\u0456\u0434\u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u044F",
        en: "Sub category",
        hy: "\u0535\u0576\u0569\u0561\u056F\u0561\u057F\u0565\u0563\u0578\u0580\u056B\u0561",
        ka: "\u10E5\u10D5\u10D4\u10D9\u10D0\u10E2\u10D4\u10D2\u10DD\u10E0\u10D8\u10D0"
    },
    tag: {
        uk: "\u0422\u0435\u0433",
        en: "Tag",
        hy: "\u0539\u0565\u0563",
        ka: "\u10E2\u10D4\u10D2\u10D8"
    },
    tags: {
        uk: "\u0422\u0435\u0433\u0438",
        en: "Tags",
        hy: "\u0539\u0565\u0563\u0565\u0580",
        ka: "\u10E2\u10D4\u10D2\u10D4\u10D1\u10D8"
    },
    component: {
        uk: "\u041A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442",
        en: "Component",
        hy: "\u0532\u0561\u0572\u0561\u0564\u0580\u056B\u0579",
        ka: "\u10D9\u10DD\u10DB\u10DE\u10DD\u10DC\u10D4\u10DC\u10E2\u10D8"
    },
    template: {
        uk: "\u0428\u0430\u0431\u043B\u043E\u043D",
        en: "Template",
        hy: "\u0541\u0587\u0561\u0576\u0574\u0578\u0582\u0577",
        ka: "\u10E8\u10D0\u10D1\u10DA\u10DD\u10DC\u10D8"
    },
    task_status: {
        uk: "\u0421\u0442\u0430\u0442\u0443\u0441: \u0432\u0441\u0456",
        en: "Status: all",
        hy: "\u053F\u0561\u0580\u0563\u0561\u057E\u056B\u0573\u0561\u056F\u055D \u0562\u0578\u056C\u0578\u0580\u0568",
        ka: "\u10E1\u10E2\u10D0\u10E2\u10E3\u10E1\u10D8: \u10E7\u10D5\u10D4\u10DA\u10D0"
    },
    task_negative: {
        uk: "\u041D\u0435\u0433\u0430\u0442\u0438\u0432\u043D\u0430 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u044C",
        en: "Negative answer",
        hy: "\u0532\u0561\u0581\u0561\u057D\u0561\u056F\u0561\u0576 \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576",
        ka: "\u10E3\u10D0\u10E0\u10E7\u10DD\u10E4\u10D8\u10D7\u10D8 \u10DE\u10D0\u10E1\u10E3\u10EE\u10D8"
    },
    task_deadline: {
        uk: "\u0414\u0435\u0434\u043B\u0430\u0439\u043D",
        en: "Deadline",
        hy: "\u0534\u0565\u0564\u056C\u0561\u0575\u0576",
        ka: "\u10D3\u10D4\u10D3\u10DA\u10D0\u10D8\u10DC\u10D8"
    },
    additional_filters: {
        uk: "\u0414\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0456 \u0444\u0456\u043B\u044C\u0442\u0440\u0438",
        en: "Additional filters",
        hy: "\u053C\u0580\u0561\u0581\u0578\u0582\u0581\u056B\u0579 \u0586\u056B\u056C\u057F\u0580\u0565\u0580",
        ka: "\u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D8\u10D7\u10D8 \u10E4\u10D8\u10DA\u10E2\u10E0\u10D4\u10D1\u10D8"
    },
    apply: {
        uk: "\u0417\u0430\u0441\u0442\u043E\u0441\u0443\u0432\u0430\u0442\u0438",
        en: "Apply",
        hy: "\u053F\u056B\u0580\u0561\u057C\u0565\u056C",
        ka: "\u10D2\u10D0\u10DB\u10DD\u10E7\u10D4\u10DC\u10D4\u10D1\u10D0"
    },
    filter_reset: {
        uk: "\u0421\u043A\u0438\u043D\u0443\u0442\u0438 \u0444\u0456\u043B\u044C\u0442\u0440\u0438",
        en: "Reset the filters",
        hy: "\u0536\u0580\u0578\u0575\u0561\u0581\u0576\u0565\u056C \u0586\u056B\u056C\u057F\u0580\u0565\u0580\u0568",
        ka: "\u10E4\u10D8\u10DA\u10E2\u10E0\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10D3\u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D0"
    },
    filter_save: {
        uk: "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u0444\u0456\u043B\u044C\u0442\u0440",
        en: "Save the filter",
        hy: "\u054A\u0561\u0570\u057A\u0561\u0576\u0565\u056C \u0586\u056B\u056C\u057F\u0580\u0568",
        ka: "\u10E4\u10D8\u10DA\u10E2\u10E0\u10D8\u10E1 \u10E8\u10D4\u10DC\u10D0\u10EE\u10D5\u10D0"
    },
    filter_remove: {
        uk: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0444\u0456\u043B\u044C\u0442\u0440",
        en: "Remove the filter",
        hy: "\u0540\u0565\u057C\u0561\u0581\u0576\u0565\u056C \u0586\u056B\u056C\u057F\u0580\u0568",
        ka: "\u10E4\u10D8\u10DA\u10E2\u10E0\u10D8\u10E1 \u10EC\u10D0\u10E8\u10DA\u10D0"
    },
    filter_name_placeholder: {
        uk: "\u041D\u0430\u0437\u0432\u0430 \u0444\u0456\u043B\u044C\u0442\u0440\u0443",
        en: "Filter name",
        hy: "\u0556\u056B\u056C\u057F\u0580\u056B \u0561\u0576\u057E\u0561\u0576\u0578\u0582\u0574",
        ka: "\u10E4\u10D8\u10DA\u10E2\u10E0\u10D8\u10E1 \u10E1\u10D0\u10EE\u10D4\u10DA\u10D8"
    },
    date_range: {
        uk: "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u043F\u0435\u0440\u0456\u043E\u0434",
        en: "Select a certain period",
        hy: "\u0538\u0576\u057F\u0580\u0565\u0584 \u056A\u0561\u0574\u0561\u0576\u0561\u056F\u0561\u0570\u0561\u057F\u057E\u0561\u056E",
        ka: "\u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10DE\u10D4\u10E0\u10D8\u10DD\u10D3\u10D8"
    },
    date_today: {
        uk: "\u0421\u044C\u043E\u0433\u043E\u0434\u043D\u0456",
        en: "Today",
        hy: "\u0531\u0575\u057D\u0585\u0580",
        ka: "\u10D3\u10E6\u10D4\u10E1"
    },
    date_yesterday: {
        uk: "\u0412\u0447\u043E\u0440\u0430",
        en: "Yesterday",
        hy: "\u0535\u0580\u0565\u056F",
        ka: "\u10D2\u10E3\u10E8\u10D8\u10DC"
    },
    date_current_week: {
        uk: "\u041F\u043E\u0442\u043E\u0447\u043D\u0438\u0439 \u0442\u0438\u0436\u0434\u0435\u043D\u044C",
        en: "Current week",
        hy: "\u0538\u0576\u0569\u0561\u0581\u056B\u056F \u0577\u0561\u0562\u0561\u0569",
        ka: "\u10DB\u10D8\u10DB\u10D3\u10D8\u10DC\u10D0\u10E0\u10D4 \u10D9\u10D5\u10D8\u10E0\u10D0"
    },
    date_last_week: {
        uk: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u0456\u0439 \u0442\u0438\u0436\u0434\u0435\u043D\u044C",
        en: "Last week",
        hy: "\u0531\u0576\u0581\u0561\u056E \u0577\u0561\u0562\u0561\u0569",
        ka: "\u10D2\u10D0\u10E1\u10E3\u10DA\u10D8 \u10D9\u10D5\u10D8\u10E0\u10D0"
    },
    date_current_month: {
        uk: "\u041F\u043E\u0442\u043E\u0447\u043D\u0438\u0439 \u043C\u0456\u0441\u044F\u0446\u044C",
        en: "Current month",
        hy: "\u0538\u0576\u0569\u0561\u0581\u056B\u056F \u0561\u0574\u056B\u057D",
        ka: "\u10DB\u10D8\u10DB\u10D3\u10D8\u10DC\u10D0\u10E0\u10D4 \u10D7\u10D5\u10D4"
    },
    date_last_month: {
        uk: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u0456\u0439 \u043C\u0456\u0441\u044F\u0446\u044C",
        en: "Last month",
        hy: "\u0531\u0576\u0581\u0561\u056E \u0561\u0574\u056B\u057D",
        ka: "\u10D2\u10D0\u10E1\u10E3\u10DA\u10D8 \u10D7\u10D5\u10D4"
    },
    date_last_half_year: {
        uk: "\u041E\u0441\u0442\u0430\u043D\u043D\u0456 \u043F\u0456\u0432 \u0440\u043E\u043A\u0443",
        en: "Last half a year",
        hy: "\u054E\u0565\u0580\u057B\u056B\u0576 \u056F\u0565\u057D \u057F\u0561\u0580\u056B",
        ka: "\u10D1\u10DD\u10DA\u10DD \u10DC\u10D0\u10EE\u10D4\u10D5\u10D0\u10E0\u10D8 \u10EC\u10D4\u10DA\u10D8"
    },
    /* The rest of this block belongs to `src/component/PeriodPicker.js` — the shared range picker.
     Rolling windows, which the calendar-aligned ones above do not cover. */ date_last_7_days: {
        uk: "\u041E\u0441\u0442\u0430\u043D\u043D\u0456 7 \u0434\u043D\u0456\u0432",
        en: "Last 7 days",
        hy: "\u054E\u0565\u0580\u057B\u056B\u0576 7 \u0585\u0580\u0568",
        ka: "\u10D1\u10DD\u10DA\u10DD 7 \u10D3\u10E6\u10D4"
    },
    date_last_14_days: {
        uk: "\u041E\u0441\u0442\u0430\u043D\u043D\u0456 14 \u0434\u043D\u0456\u0432",
        en: "Last 14 days",
        hy: "\u054E\u0565\u0580\u057B\u056B\u0576 14 \u0585\u0580\u0568",
        ka: "\u10D1\u10DD\u10DA\u10DD 14 \u10D3\u10E6\u10D4"
    },
    date_last_30_days: {
        uk: "\u041E\u0441\u0442\u0430\u043D\u043D\u0456 30 \u0434\u043D\u0456\u0432",
        en: "Last 30 days",
        hy: "\u054E\u0565\u0580\u057B\u056B\u0576 30 \u0585\u0580\u0568",
        ka: "\u10D1\u10DD\u10DA\u10DD 30 \u10D3\u10E6\u10D4"
    },
    date_from: {
        uk: "\u0412\u0456\u0434",
        en: "From",
        hy: "\u054D\u056F\u057D\u0561\u056E",
        ka: "\u10D3\u10D0\u10DC"
    },
    date_to: {
        uk: "\u0414\u043E",
        en: "To",
        hy: "\u0544\u056B\u0576\u0579\u0587",
        ka: "\u10DB\u10D3\u10D4"
    },
    date_pick_start: {
        uk: "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u043F\u043E\u0447\u0430\u0442\u043A\u043E\u0432\u0443 \u0434\u0430\u0442\u0443",
        en: "Select start date",
        hy: "\u0538\u0576\u057F\u0580\u0565\u0584 \u057D\u056F\u0566\u0562\u056B \u0561\u0574\u057D\u0561\u0569\u056B\u057E\u0568",
        ka: "\u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10D3\u10D0\u10EC\u10E7\u10D4\u10D1\u10D8\u10E1 \u10D7\u10D0\u10E0\u10D8\u10E6\u10D8"
    },
    date_pick_end: {
        uk: "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u043A\u0456\u043D\u0446\u0435\u0432\u0443 \u0434\u0430\u0442\u0443",
        en: "Select end date",
        hy: "\u0538\u0576\u057F\u0580\u0565\u0584 \u0561\u057E\u0561\u0580\u057F\u056B \u0561\u0574\u057D\u0561\u0569\u056B\u057E\u0568",
        ka: "\u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10D3\u10D0\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10D8\u10E1 \u10D7\u10D0\u10E0\u10D8\u10E6\u10D8"
    },
    /* Days, not months — `PeriodPicker`'s cap is in days now. Abbreviated so the number never has
     to agree with the noun (spec/04), matching `notif_merch_idle`. */ date_max_range: {
        uk: "\u043C\u0430\u043A\u0441\u0438\u043C\u0443\u043C {n} \u0434",
        en: "max {n} d",
        hy: "\u0561\u057C\u0561\u057E\u0565\u056C\u0561\u0563\u0578\u0582\u0575\u0576\u0568 {n} \u0585\u0580",
        ka: "\u10DB\u10D0\u10E5\u10E1\u10D8\u10DB\u10E3\u10DB {n} \u10D3\u10E6\u10D4"
    },
    /* The option list's own three states — `src/component/EntitySelect.js`. */ option_loading: {
        uk: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F\u2026",
        en: "Loading\u2026",
        hy: "\u0532\u0565\u057C\u0576\u057E\u0578\u0582\u0574 \u0567\u2026",
        ka: "\u10D8\u10E2\u10D5\u10D8\u10E0\u10D7\u10D4\u10D1\u10D0\u2026"
    },
    option_no_matches: {
        uk: "\u041D\u0435\u043C\u0430\u0454 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u043D\u0438\u043A\u0456\u0432",
        en: "No matches",
        hy: "\u0540\u0561\u0574\u0561\u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580 \u0579\u056F\u0561\u0576",
        ka: "\u10E8\u10D4\u10E1\u10D0\u10E2\u10E7\u10D5\u10D8\u10E1\u10D8 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1"
    },
    option_scroll_more: {
        uk: "\u041F\u0440\u043E\u043A\u0440\u0443\u0442\u0456\u0442\u044C, \u0449\u043E\u0431 \u043F\u043E\u0431\u0430\u0447\u0438\u0442\u0438 \u0431\u0456\u043B\u044C\u0448\u0435",
        en: "Scroll for more",
        hy: "\u0548\u056C\u0578\u0580\u0565\u0584 \u0561\u057E\u0565\u056C\u056B\u0576 \u057F\u0565\u057D\u0576\u0565\u056C\u0578\u0582 \u0570\u0561\u0574\u0561\u0580",
        ka: "\u10D2\u10D0\u10D3\u10D0\u10D0\u10EE\u10D5\u10D8\u10D4\u10D7 \u10DB\u10D4\u10E2\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1"
    },
    photo_review_type_group: {
        uk: "\u0413\u0440\u0443\u043F\u043E\u0432\u0438\u0439 \u0432\u0438\u0433\u043B\u044F\u0434",
        en: "Grouped",
        hy: "\u053D\u0574\u0562\u0561\u0575\u056B\u0576 \u057F\u0565\u057D\u0584",
        ka: "\u10EF\u10D2\u10E3\u10E4\u10E3\u10E0\u10D8 \u10EE\u10D4\u10D3\u10D8"
    },
    photo_review_type_single: {
        uk: "\u0406\u043D\u0434\u0438\u0432\u0456\u0434\u0443\u0430\u043B\u044C\u043D\u0438\u0439 \u0432\u0438\u0433\u043B\u044F\u0434",
        en: "Single",
        hy: "\u0531\u0576\u0570\u0561\u057F\u0561\u056F\u0561\u0576 \u057F\u0565\u057D\u0584",
        ka: "\u10D8\u10DC\u10D3\u10D8\u10D5\u10D8\u10D3\u10E3\u10D0\u10DA\u10E3\u10E0\u10D8 \u10EE\u10D4\u10D3\u10D8"
    },
    date_\u0441urrent_month: {
        uk: "\u041F\u043E\u0442\u043E\u0447\u043D\u0438\u0439 \u043C\u0456\u0441\u044F\u0446\u044C",
        en: "Current month",
        hy: "\u0538\u0576\u0569\u0561\u0581\u056B\u056F \u0561\u0574\u056B\u057D",
        ka: "\u10DB\u10D8\u10DB\u10D3\u10D8\u10DC\u10D0\u10E0\u10D4 \u10D7\u10D5\u10D4"
    }
};
const $fc3f36407bc5ec6c$export$f544127b46daf517 = {
    export: {
        uk: "\u0415\u043A\u0441\u043F\u043E\u0440\u0442\u0443\u0432\u0430\u0442\u0438",
        en: "Export",
        hy: "\u0531\u0580\u057F\u0561\u0570\u0561\u0576\u0565\u056C",
        ka: "\u10D4\u10E5\u10E1\u10DE\u10DD\u10E0\u10E2\u10D8"
    },
    download: {
        uk: "\u0421\u043A\u0430\u0447\u0430\u0442\u0438",
        en: "Download",
        hy: "\u0546\u0565\u0580\u0562\u0565\u057C\u0576\u0565\u056C",
        ka: "\u10E9\u10D0\u10DB\u10DD\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D0"
    },
    downloadAll: {
        uk: "\u0421\u043A\u0430\u0447\u0430\u0442\u0438 \u0432\u0441\u0456",
        en: "Download all",
        hy: "\u0546\u0565\u0580\u0562\u0565\u057C\u0576\u0565\u056C \u0562\u0578\u056C\u0578\u0580\u0568",
        ka: "\u10E9\u10D0\u10DB\u10DD\u10E2\u10D5\u10D8\u10E0\u10D7\u10D4 \u10E7\u10D5\u10D4\u10DA\u10D0"
    },
    downloading: {
        uk: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F",
        en: "Downloading",
        hy: "\u0546\u0565\u0580\u0562\u0565\u057C\u0576\u057E\u0578\u0582\u0574 \u0567",
        ka: "\u10E9\u10D0\u10DB\u10DD\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D0 \u10DB\u10D8\u10DB\u10D3\u10D8\u10DC\u10D0\u10E0\u10D4\u10DD\u10D1\u10E1"
    },
    confirmation_msg: {
        uk: "\u0412\u0438 \u0432\u043F\u0435\u0432\u043D\u0435\u043D\u043D\u0456 \u0449\u043E \u0445\u043E\u0447\u0435\u0442\u0435 \u0432\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0444\u0456\u043B\u044C\u0442\u0440?",
        en: "Are you sure that you want to delete the filter?",
        hy: "\u0540\u0561\u0574\u0578\u0566\u057E\u0561\u056E \u0565\u0584, \u0578\u0580 \u0581\u0561\u0576\u056F\u0561\u0576\u0578\u0582\u0574 \u0565\u0584 \u057B\u0576\u057B\u0565\u056C \u0586\u056B\u056C\u057F\u0580\u0568?",
        ka: "\u10D3\u10D0\u10E0\u10EC\u10DB\u10E3\u10DC\u10D4\u10D1\u10E3\u10DA\u10D8 \u10EE\u10D0\u10E0\u10D7, \u10E0\u10DD\u10DB \u10D2\u10E1\u10E3\u10E0\u10D7 \u10EC\u10D0\u10E8\u10D0\u10DA\u10DD\u10D7 \u10E4\u10D8\u10DA\u10E2\u10E0\u10D8?"
    },
    remove_confirmation_msg: {
        uk: "\u041F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u0432\u0438\u0431\u0440\u0430\u0442\u0438 \u0444\u0456\u043B\u044C\u0442\u0440 \u0434\u043B\u044F \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043D\u044F",
        en: "Need to select a filter to delete",
        hy: "\u054B\u0576\u057B\u0565\u056C\u0578\u0582 \u0570\u0561\u0574\u0561\u0580 \u0561\u0576\u0570\u0580\u0561\u056A\u0565\u0577\u057F \u0567 \u0568\u0576\u057F\u0580\u0565\u056C \u0586\u056B\u056C\u057F\u0580",
        ka: "\u10EC\u10D0\u10E1\u10D0\u10E8\u10DA\u10D4\u10DA\u10D0\u10D3 \u10E1\u10D0\u10ED\u10D8\u10E0\u10DD\u10D0 \u10E4\u10D8\u10DA\u10E2\u10E0\u10D8\u10E1 \u10E8\u10D4\u10E0\u10E9\u10D4\u10D5\u10D0"
    },
    remove_success_msg: {
        uk: "\u0424\u0456\u043B\u044C\u0442\u0440 \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u0438\u0439",
        en: "The filter is deleted",
        hy: "\u0556\u056B\u056C\u057F\u0580\u0568 \u057B\u0576\u057B\u057E\u0561\u056E \u0567",
        ka: "\u10E4\u10D8\u10DA\u10E2\u10E0\u10D8 \u10EC\u10D0\u10E8\u10DA\u10D8\u10DA\u10D8\u10D0"
    },
    valid_error_msg: {
        uk: "\u0406\u043C'\u044F \u0444\u0456\u043B\u044C\u0442\u0440\u0430 \u043D\u0435 \u043C\u043E\u0436\u0435 \u0431\u0443\u0442\u0438 \u043F\u0443\u0441\u0442\u0438\u043C!",
        en: "The filter's name cannot be empty!",
        hy: "\u0556\u056B\u056C\u057F\u0580\u056B \u0561\u0576\u0578\u0582\u0576\u0568 \u0579\u056B \u056F\u0561\u0580\u0578\u0572 \u0564\u0561\u057F\u0561\u0580\u056F \u056C\u056B\u0576\u0565\u056C!",
        ka: "\u10E4\u10D8\u10DA\u10E2\u10E0\u10D8\u10E1 \u10E1\u10D0\u10EE\u10D4\u10DA\u10D8 \u10D0\u10E0 \u10E8\u10D4\u10D8\u10EB\u10DA\u10D4\u10D1\u10D0 \u10D8\u10E7\u10DD\u10E1 \u10EA\u10D0\u10E0\u10D8\u10D4\u10DA\u10D8!"
    },
    newtask_success_msg: {
        uk: "\u0417\u0430\u0432\u0434\u0430\u043D\u043D\u044F \u0437\u0431\u0435\u0440e\u0436\u0435\u043D\u0435",
        en: "The task is saved",
        hy: "\u0531\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0568 \u057A\u0561\u0570\u057A\u0561\u0576\u057E\u0561\u056E \u0567",
        ka: "\u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D0 \u10E8\u10D4\u10DC\u10D0\u10EE\u10E3\u10DA\u10D8\u10D0"
    },
    task_object_item_id_msg: {
        uk: "object_id \u0430\u0431\u043E object_type \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u0456",
        en: "object_id or object_type not found",
        hy: "object_id \u056F\u0561\u0574 object_type \u0579\u056B \u0563\u057F\u0576\u057E\u0565\u056C",
        ka: "object_id \u10D0\u10DC object_type \u10D5\u10D4\u10E0 \u10DB\u10DD\u10D8\u10EB\u10D4\u10D1\u10DC\u10D0"
    },
    task_reject_msg: {
        uk: "\u0412\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043D\u043E",
        en: "Rejection",
        hy: "\u0544\u0565\u0580\u056A\u0578\u0582\u0574",
        ka: "\u10E3\u10D0\u10E0\u10E7\u10DD\u10E4\u10D0"
    },
    task_accept_msg: {
        uk: "\u0417\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u043E",
        en: "Approval",
        hy: "\u0540\u0561\u057D\u057F\u0561\u057F\u0578\u0582\u0574",
        ka: "\u10D3\u10D0\u10DB\u10E2\u10D9\u10D8\u10EA\u10D4\u10D1\u10D0"
    },
    back: {
        uk: "\u041D\u0430\u0437\u0430\u0434",
        en: "Back",
        hy: "\u0540\u0565\u057F",
        ka: "\u10E3\u10D9\u10D0\u10DC"
    },
    yes: {
        uk: "\u0422\u0430\u043A",
        en: "Yes",
        hy: "\u0531\u0575\u0578",
        ka: "\u10D3\u10D8\u10D0\u10EE"
    },
    cancel: {
        uk: "\u0412\u0456\u0434\u043C\u0456\u043D\u0438\u0442\u0438",
        en: "Cancel",
        hy: "\u0549\u0565\u0572\u0561\u0580\u056F\u0565\u056C",
        ka: "\u10D2\u10D0\u10E3\u10E5\u10DB\u10D4\u10D1\u10D0"
    }
};
const $fc3f36407bc5ec6c$export$7c2d9af61f6af587 = {
    heading: {
        uk: "\u041C\u0430\u0440\u0448\u0440\u0443\u0442\u0438",
        en: "Routes",
        hy: "\u0535\u0580\u0569\u0578\u0582\u0572\u056B\u0576\u0565\u0580",
        ka: "\u10DB\u10D0\u10E0\u10E8\u10E0\u10E3\u10E2\u10D4\u10D1\u10D8"
    },
    /* Both ways of adding a stop are named: dragging does not work on a touch screen and cannot be
     started from the keyboard, so "drag a point" alone described a path half the users do not
     have. */ legend: {
        uk: "\u041F\u0435\u0440\u0435\u0442\u044F\u0433\u043D\u0456\u0442\u044C \u0442\u043E\u0447\u043A\u0443 \u043D\u0430 \u0434\u0435\u043D\u044C \u0430\u0431\u043E \u043E\u0431\u0435\u0440\u0456\u0442\u044C \u0442\u043E\u0447\u043A\u0443 \u0439 \u043D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C \xab\u0414\u043E\u0434\u0430\u0442\u0438 \u0441\u044E\u0434\u0438\xbb. \u0412\u0438\u043D\u044F\u0442\u043A\u0438 \u0443\u0441\u043F\u0430\u0434\u043A\u043E\u0432\u0443\u044E\u0442\u044C \u0442\u0438\u0436\u043D\u0435\u0432\u0438\u0439 \u043F\u043B\u0430\u043D.",
        en: "Drag a point onto a day, or select a point and choose \u201CAdd here\u201D. Overrides inherit the weekly plan.",
        hy: "\u0554\u0561\u0577\u0565\u0584 \u056F\u0565\u057F\u0568 \u0585\u0580\u057E\u0561 \u057E\u0580\u0561 \u056F\u0561\u0574 \u0568\u0576\u057F\u0580\u0565\u0584 \u056F\u0565\u057F\u0568 \u0587 \u057D\u0565\u0572\u0574\u0565\u0584 \xab\u0531\u057E\u0565\u056C\u0561\u0581\u0576\u0565\u056C \u0561\u0575\u057D\u057F\u0565\u0572\xbb\u0589 \u0532\u0561\u0581\u0561\u057C\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580\u0568 \u056A\u0561\u057C\u0561\u0576\u0563\u0578\u0582\u0574 \u0565\u0576 \u0577\u0561\u0562\u0561\u0569\u0561\u056F\u0561\u0576 \u057A\u056C\u0561\u0576\u0568\u0589",
        ka: "\u10D2\u10D0\u10D3\u10D0\u10D0\u10D7\u10E0\u10D8\u10D4\u10D7 \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8 \u10D3\u10E6\u10D4\u10D6\u10D4 \u10D0\u10DC \u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8 \u10D3\u10D0 \u10D3\u10D0\u10D0\u10ED\u10D8\u10E0\u10D4\u10D7 \u201E\u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D0 \u10D0\u10E5\u201C. \u10D2\u10D0\u10DB\u10DD\u10DC\u10D0\u10D9\u10DA\u10D8\u10E1\u10D4\u10D1\u10D8 \u10DB\u10D4\u10DB\u10D9\u10D5\u10D8\u10D3\u10E0\u10D4\u10DD\u10D1\u10D8\u10D7 \u10D8\u10E6\u10D4\u10D1\u10D4\u10DC \u10D9\u10D5\u10D8\u10E0\u10D8\u10E1 \u10D2\u10D4\u10D2\u10DB\u10D0\u10E1."
    },
    search_placeholder: {
        uk: "\u041F\u043E\u0448\u0443\u043A \u0442\u043E\u0447\u043E\u043A\u2026",
        en: "Search points\u2026",
        hy: "\u0553\u0576\u057F\u0580\u0565\u056C \u056F\u0565\u057F\u0565\u0580\u2026",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1 \u10EB\u10D4\u10D1\u10DC\u10D0\u2026"
    },
    no_points_found: {
        uk: "\u0422\u043E\u0447\u043E\u043A \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
        en: "No points found",
        hy: "\u053F\u0565\u057F\u0565\u0580 \u0579\u0565\u0576 \u0563\u057F\u0576\u057E\u0565\u056C",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8 \u10D5\u10D4\u10E0 \u10DB\u10DD\u10D8\u10EB\u10D4\u10D1\u10DC\u10D0"
    },
    scope_title: {
        uk: "\u0414\u043E\u0434\u0430\u0442\u0438 \u0442\u043E\u0447\u043A\u0443 \u0434\u043E\u2026",
        en: "Add point to\u2026",
        hy: "\u0531\u057E\u0565\u056C\u0561\u0581\u0576\u0565\u056C \u056F\u0565\u057F\u0568\u2026",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8\u10E1 \u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D0\u2026"
    },
    scope_every: {
        uk: "\u041A\u043E\u0436\u0435\u043D {day}",
        en: "Every {day}",
        hy: "\u0531\u0574\u0565\u0576 {day}",
        ka: "\u10E7\u10DD\u10D5\u10D4\u10DA {day}"
    },
    scope_nth: {
        uk: "\u041B\u0438\u0448\u0435 {ord} {day} \u0449\u043E\u043C\u0456\u0441\u044F\u0446\u044F",
        en: "Only the {ord} {day} of each month",
        hy: "\u0531\u0574\u057D\u057E\u0561 {ord} {day}-\u0568",
        ka: "\u10D7\u10D5\u10D8\u10E1 {ord} {day}"
    },
    /* Encoded as the 1st+3rd or 2nd+4th Nth-weekday pair — see routeModel.biweeklyNths.
     uk goes through ukGrammar.ukBiweekly for case/gender agreement. */ scope_biweekly: {
        uk: "\u0420\u0430\u0437 \u043D\u0430 \u0434\u0432\u0430 \u0442\u0438\u0436\u043D\u0456 ({ordA} \u0456 {ordB} {day})",
        en: "Every two weeks ({ordA} and {ordB} {day})",
        hy: "\u0535\u0580\u056F\u0578\u0582 \u0577\u0561\u0562\u0561\u0569\u0568 \u0574\u0565\u056F ({ordA} \u0587 {ordB} {day})",
        ka: "\u10DD\u10E0 \u10D9\u10D5\u10D8\u10E0\u10D0\u10E8\u10D8 \u10D4\u10E0\u10D7\u10EE\u10D4\u10DA ({ordA} \u10D3\u10D0 {ordB} {day})"
    },
    scope_date: {
        uk: "\u041B\u0438\u0448\u0435 {date}",
        en: "Only on {date}",
        hy: "\u0544\u056B\u0561\u0575\u0576 {date}",
        ka: "\u10DB\u10EE\u10DD\u10DA\u10DD\u10D3 {date}"
    },
    cancel: {
        uk: "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438",
        en: "Cancel",
        hy: "\u0549\u0565\u0572\u0561\u0580\u056F\u0565\u056C",
        ka: "\u10D2\u10D0\u10E3\u10E5\u10DB\u10D4\u10D1\u10D0"
    },
    badge_weekly: {
        uk: "\u0429\u043E\u0442\u0438\u0436\u043D\u044F",
        en: "Weekly",
        hy: "\u0547\u0561\u0562\u0561\u0569\u0561\u056F\u0561\u0576",
        ka: "\u10E7\u10DD\u10D5\u10D4\u10DA\u10D9\u10D5\u10D8\u10E0\u10D0"
    },
    badge_date: {
        uk: "\u0420\u0430\u0437\u043E\u0432\u043E",
        en: "One-off",
        hy: "\u0544\u0565\u056F\u0561\u0576\u0563\u0561\u0574\u0575\u0561",
        ka: "\u10D4\u10E0\u10D7\u10EF\u10D4\u10E0\u10D0\u10D3\u10D8"
    },
    /* Fallback for an absence day whose record carries no reason text (PICSELL-1581 #14). */ absent_day: {
        uk: "\u0412\u0456\u0434\u0441\u0443\u0442\u043D\u0456\u0441\u0442\u044C",
        en: "Absence",
        hy: "\u0532\u0561\u0581\u0561\u056F\u0561\u0575\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10D0\u10E0\u10E7\u10DD\u10E4\u10DC\u10D0"
    },
    ord_first: {
        uk: "1-\u0439",
        en: "1st",
        hy: "1-\u056B\u0576",
        ka: "1-\u10DA\u10D8"
    },
    ord_second: {
        uk: "2-\u0439",
        en: "2nd",
        hy: "2-\u0580\u0564",
        ka: "2-\u10D4"
    },
    ord_third: {
        uk: "3-\u0439",
        en: "3rd",
        hy: "3-\u0580\u0564",
        ka: "3-\u10D4"
    },
    ord_fourth: {
        uk: "4-\u0439",
        en: "4th",
        hy: "4-\u0580\u0564",
        ka: "4-\u10D4"
    },
    ord_fifth: {
        uk: "5-\u0439",
        en: "5th",
        hy: "5-\u0580\u0564",
        ka: "5-\u10D4"
    },
    /* Click-to-place: dragging is mouse-only (native HTML5 drag fires no events on a touch screen)
     and gave a keyboard user no way to add a stop at all, so selecting a point and then choosing a
     day is the same action by a second route. */ select_point: {
        uk: "\u041E\u0431\u0440\u0430\u0442\u0438 \u0442\u043E\u0447\u043A\u0443",
        en: "Select point",
        hy: "\u0538\u0576\u057F\u0580\u0565\u056C \u056F\u0565\u057F\u0568",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8\u10E1 \u10D0\u10E0\u10E9\u10D4\u10D5\u10D0"
    },
    point_selected: {
        uk: "\u041E\u0431\u0440\u0430\u043D\u043E. \u0422\u0435\u043F\u0435\u0440 \u0432\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0434\u0435\u043D\u044C.",
        en: "Selected. Now choose a day.",
        hy: "\u0538\u0576\u057F\u0580\u057E\u0561\u056E \u0567\u0589 \u0531\u0575\u056A\u0574 \u0568\u0576\u057F\u0580\u0565\u0584 \u0585\u0580\u0568\u0589",
        ka: "\u10D0\u10E0\u10E9\u10D4\u10E3\u10DA\u10D8\u10D0. \u10D0\u10EE\u10DA\u10D0 \u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10D3\u10E6\u10D4."
    },
    add_here: {
        uk: "\u0414\u043E\u0434\u0430\u0442\u0438 \u0441\u044E\u0434\u0438",
        en: "Add here",
        hy: "\u0531\u057E\u0565\u056C\u0561\u0581\u0576\u0565\u056C \u0561\u0575\u057D\u057F\u0565\u0572",
        ka: "\u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D0 \u10D0\u10E5"
    },
    clear_selection: {
        uk: "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438 \u0432\u0438\u0431\u0456\u0440",
        en: "Clear selection",
        hy: "\u0549\u0565\u0572\u0561\u0580\u056F\u0565\u056C \u0568\u0576\u057F\u0580\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0568",
        ka: "\u10D0\u10E0\u10E9\u10D4\u10D5\u10D8\u10E1 \u10D2\u10D0\u10E1\u10E3\u10E4\u10D7\u10D0\u10D5\u10D4\u10D1\u10D0"
    },
    /* aria-labels. These were hardcoded English strings, which a screen reader reads out to a
     Ukrainian supervisor verbatim. */ move_up: {
        uk: "\u041F\u0435\u0440\u0435\u043C\u0456\u0441\u0442\u0438\u0442\u0438 \u0432\u0438\u0449\u0435",
        en: "Move up",
        hy: "\u054F\u0565\u0572\u0561\u0583\u0578\u056D\u0565\u056C \u057E\u0565\u0580",
        ka: "\u10D0\u10EC\u10D4\u10D5\u10D0"
    },
    move_down: {
        uk: "\u041F\u0435\u0440\u0435\u043C\u0456\u0441\u0442\u0438\u0442\u0438 \u043D\u0438\u0436\u0447\u0435",
        en: "Move down",
        hy: "\u054F\u0565\u0572\u0561\u0583\u0578\u056D\u0565\u056C \u057E\u0561\u0580",
        ka: "\u10E9\u10D0\u10DB\u10DD\u10EC\u10D4\u10D5\u10D0"
    },
    remove_stop: {
        uk: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0442\u043E\u0447\u043A\u0443",
        en: "Remove point",
        hy: "\u0540\u0565\u057C\u0561\u0581\u0576\u0565\u056C \u056F\u0565\u057F\u0568",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8\u10E1 \u10EC\u10D0\u10E8\u10DA\u10D0"
    },
    prev_month: {
        uk: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u0456\u0439 \u043C\u0456\u0441\u044F\u0446\u044C",
        en: "Previous month",
        hy: "\u0546\u0561\u056D\u0578\u0580\u0564 \u0561\u0574\u056B\u057D",
        ka: "\u10EC\u10D8\u10DC\u10D0 \u10D7\u10D5\u10D4"
    },
    next_month: {
        uk: "\u041D\u0430\u0441\u0442\u0443\u043F\u043D\u0438\u0439 \u043C\u0456\u0441\u044F\u0446\u044C",
        en: "Next month",
        hy: "\u0540\u0561\u057B\u0578\u0580\u0564 \u0561\u0574\u056B\u057D",
        ka: "\u10E8\u10D4\u10DB\u10D3\u10D4\u10D2\u10D8 \u10D7\u10D5\u10D4"
    },
    /* The week view (PICSELL-1615 #8). The stepper's labels change with it: "Previous month" on a
     button that steps a week would be an a11y lie. */ prev_week: {
        uk: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u0456\u0439 \u0442\u0438\u0436\u0434\u0435\u043D\u044C",
        en: "Previous week",
        hy: "\u0546\u0561\u056D\u0578\u0580\u0564 \u0577\u0561\u0562\u0561\u0569",
        ka: "\u10EC\u10D8\u10DC\u10D0 \u10D9\u10D5\u10D8\u10E0\u10D0"
    },
    next_week: {
        uk: "\u041D\u0430\u0441\u0442\u0443\u043F\u043D\u0438\u0439 \u0442\u0438\u0436\u0434\u0435\u043D\u044C",
        en: "Next week",
        hy: "\u0540\u0561\u057B\u0578\u0580\u0564 \u0577\u0561\u0562\u0561\u0569",
        ka: "\u10E8\u10D4\u10DB\u10D3\u10D4\u10D2\u10D8 \u10D9\u10D5\u10D8\u10E0\u10D0"
    },
    view_month: {
        uk: "\u041C\u0456\u0441\u044F\u0446\u044C",
        en: "Month",
        hy: "\u0531\u0574\u056B\u057D",
        ka: "\u10D7\u10D5\u10D4"
    },
    view_week: {
        uk: "\u0422\u0438\u0436\u0434\u0435\u043D\u044C",
        en: "Week",
        hy: "\u0547\u0561\u0562\u0561\u0569",
        ka: "\u10D9\u10D5\u10D8\u10E0\u10D0"
    },
    stops_label: {
        uk: "\u0422\u043E\u0447\u043E\u043A",
        en: "Stops",
        hy: "\u053F\u0565\u057F\u0565\u0580",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8"
    },
    unsaved_changes: {
        uk: "\u0404 \u043D\u0435\u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u0456 \u0437\u043C\u0456\u043D\u0438",
        en: "Unsaved changes",
        hy: "\u0549\u057A\u0561\u0570\u057E\u0561\u056E \u0583\u0578\u0583\u0578\u056D\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580",
        ka: "\u10E8\u10D4\u10E3\u10DC\u10D0\u10EE\u10D0\u10D5\u10D8 \u10EA\u10D5\u10DA\u10D8\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8"
    },
    save_failed: {
        uk: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u0438",
        en: "Could not save routes",
        hy: "\u0549\u0570\u0561\u057B\u0578\u0572\u057E\u0565\u0581 \u057A\u0561\u0570\u0565\u056C \u0565\u0580\u0569\u0578\u0582\u0572\u056B\u0576\u0565\u0580\u0568",
        ka: "\u10DB\u10D0\u10E0\u10E8\u10E0\u10E3\u10E2\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10DC\u10D0\u10EE\u10D5\u10D0 \u10D5\u10D4\u10E0 \u10DB\u10DD\u10EE\u10D4\u10E0\u10EE\u10D3\u10D0"
    }
};
const $fc3f36407bc5ec6c$export$912d163297011df8 = {
    photo: {
        uk: "\u0424\u043E\u0442\u043E",
        en: "Photo",
        hy: "\u053C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580",
        ka: "\u10E4\u10DD\u10E2\u10DD"
    },
    price: {
        uk: "\u0426\u0456\u043D\u0430",
        en: "Price",
        hy: "\u0533\u056B\u0576",
        ka: "\u10E4\u10D0\u10E1\u10D8"
    },
    sale_price: {
        uk: "\u0410\u043A\u0446\u0456\u0439\u043D\u0430 \u0446\u0456\u043D\u0430",
        en: "Sale price",
        hy: "\u0536\u0565\u0572\u0579\u057E\u0561\u056E \u0563\u056B\u0576",
        ka: "\u10E4\u10D0\u10E1\u10D3\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8\u10E1 \u10E4\u10D0\u10E1\u10D8"
    },
    comment: {
        uk: "\u041A\u043E\u043C\u0435\u043D\u0442\u0430\u0440",
        en: "Comment",
        hy: "\u0544\u0565\u056F\u0576\u0561\u0562\u0561\u0576\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10D9\u10DD\u10DB\u10D4\u10DC\u10E2\u10D0\u10E0\u10D8"
    },
    created: {
        uk: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043E",
        en: "Created",
        hy: "\u054D\u057F\u0565\u0572\u056E\u057E\u0561\u056E",
        ka: "\u10E8\u10D4\u10E5\u10DB\u10DC\u10D8\u10DA\u10D8\u10D0"
    },
    ready_for_neural_network: {
        uk: "\u0413\u043E\u0442\u043E\u0432\u043E \u0434\u043B\u044F \u043D\u0435\u0439\u0440\u043E\u043C\u0435\u0440\u0435\u0436\u0456",
        en: "Ready for neural network",
        hy: "\u054A\u0561\u057F\u0580\u0561\u057D\u057F \u0576\u0565\u0575\u0580\u0578\u0581\u0561\u0576\u0581\u056B",
        ka: "\u10DB\u10D6\u10D0\u10D3\u10D0\u10D0 \u10DC\u10D4\u10D8\u10E0\u10DD\u10DC\u10E3\u10DA\u10D8 \u10E5\u10E1\u10D4\u10DA\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1"
    },
    in_neural_network: {
        uk: "\u0423 \u043D\u0435\u0439\u0440\u043E\u043C\u0435\u0440\u0435\u0436\u0456",
        en: "In neural network",
        hy: "\u0546\u0565\u0575\u0580\u0578\u0581\u0561\u0576\u0581\u0578\u0582\u0574",
        ka: "\u10DC\u10D4\u10D8\u10E0\u10DD\u10DC\u10E3\u10DA \u10E5\u10E1\u10D4\u10DA\u10E8\u10D8"
    },
    got_an_error_in_neural_network: {
        uk: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0432 \u043D\u0435\u0439\u0440\u043E\u043C\u0435\u0440\u0435\u0436\u0456",
        en: "Error in neural network",
        hy: "\u054D\u056D\u0561\u056C \u0576\u0565\u0575\u0580\u0578\u0581\u0561\u0576\u0581\u0578\u0582\u0574",
        ka: "\u10E8\u10D4\u10EA\u10D3\u10DD\u10DB\u10D0 \u10DC\u10D4\u10D8\u10E0\u10DD\u10DC\u10E3\u10DA \u10E5\u10E1\u10D4\u10DA\u10E8\u10D8"
    },
    open: {
        uk: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u043E",
        en: "Open",
        hy: "\u0532\u0561\u0581",
        ka: "\u10E6\u10D8\u10D0\u10D0"
    },
    in_progress: {
        uk: "\u0412 \u0440\u043E\u0431\u043E\u0442\u0456",
        en: "In progress",
        hy: "\u0538\u0576\u0569\u0561\u0581\u0584\u056B \u0574\u0565\u057B",
        ka: "\u10DB\u10D8\u10DB\u10D3\u10D8\u10DC\u10D0\u10E0\u10D4\u10DD\u10D1\u10E1"
    },
    review: {
        uk: "\u041D\u0430 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0446\u0456",
        en: "Review",
        hy: "\u054E\u0565\u0580\u0561\u0576\u0561\u0575\u0578\u0582\u0574",
        ka: "\u10D2\u10D0\u10DC\u10EE\u10D8\u10DA\u10D5\u10D0"
    },
    done: {
        uk: "\u0412\u0438\u043A\u043E\u043D\u0430\u043D\u043E",
        en: "Done",
        hy: "\u053F\u0561\u057F\u0561\u0580\u057E\u0561\u056E",
        ka: "\u10D3\u10D0\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10E3\u10DA\u10D8"
    },
    closed: {
        uk: "\u0417\u0430\u043A\u0440\u0438\u0442\u043E",
        en: "Closed",
        hy: "\u0553\u0561\u056F\u057E\u0561\u056E",
        ka: "\u10D3\u10D0\u10EE\u10E3\u10E0\u10E3\u10DA\u10D8"
    }
};
const $fc3f36407bc5ec6c$export$38fc5682710cdf86 = {
    data_successfully_saved: {
        uk: "\u0414\u0430\u043D\u0456 \u0443\u0441\u043F\u0456\u0448\u043D\u043E \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u0456",
        en: "Data successfully saved",
        hy: "\u054F\u057E\u0575\u0561\u056C\u0576\u0565\u0580\u0568 \u0570\u0561\u057B\u0578\u0572\u0578\u0582\u0569\u0575\u0561\u0574\u0562 \u057A\u0561\u0570\u057A\u0561\u0576\u057E\u0565\u0581\u056B\u0576",
        ka: "\u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8 \u10EC\u10D0\u10E0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D8\u10D7 \u10E8\u10D4\u10DC\u10D0\u10EE\u10E3\u10DA\u10D8\u10D0"
    },
    view_btn: {
        uk: "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u0434",
        en: "View",
        hy: "\u0534\u056B\u057F\u0565\u056C",
        ka: "\u10DC\u10D0\u10EE\u10D5\u10D0"
    },
    edit_btn: {
        uk: "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438",
        en: "Edit",
        hy: "\u053D\u0574\u0562\u0561\u0563\u0580\u0565\u056C",
        ka: "\u10E0\u10D4\u10D3\u10D0\u10E5\u10E2\u10D8\u10E0\u10D4\u10D1\u10D0"
    },
    routes: {
        uk: "Ma\u0440\u0448\u0440\u0443\u0442\u0438",
        en: "Routes",
        hy: "\u0544\u0561\u0580\u0584\u0578\u0582\u057F\u0576\u0565\u0580",
        ka: "\u10DB\u10D0\u10E0\u10E8\u10E0\u10E3\u10E2\u10D4\u10D1\u10D8"
    },
    route: {
        uk: "\u041C\u0430\u0440\u0448\u0440\u0443\u0442",
        en: "Route",
        hy: "\u0535\u0580\u0569\u0578\u0582\u0572\u056B",
        ka: "\u10DB\u10D0\u10E0\u10E8\u10E0\u10E3\u10E2\u10D8"
    },
    assignment: {
        uk: "\u0417\u0430\u0432\u0434\u0430\u043D\u043D\u044F",
        en: "Assignment",
        hy: "\u0531\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584",
        ka: "\u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D0"
    },
    visits: {
        uk: "\u0412i\u0437\u0438\u0442\u0438",
        en: "Visits",
        hy: "\u0531\u0545\u0551\u0535\u0550",
        ka: "\u10D5\u10D8\u10D6\u10D8\u10E2\u10D4\u10D1\u10D8"
    },
    presence: {
        uk: "\u0412\u0456\u0434\u0441\u0443\u0442\u043D\u0456\u0441\u0442\u044C",
        en: "Absence",
        hy: "\u0546\u0535\u0550\u053F\u0531\u0545\u0548\u0552\u0539\u0545\u0548\u0552\u0546",
        ka: "\u10D3\u10D0\u10E1\u10EC\u10E0\u10D4\u10D1\u10D0"
    },
    network_title: {
        uk: "\u041C\u0435\u0440\u0435\u0436\u0430",
        en: "Network",
        hy: "\u0551\u0561\u0576\u0581",
        ka: "\u10E5\u10E1\u10D4\u10DA\u10D8"
    },
    title_title: {
        uk: "\u0422\u0438\u0442\u0443\u043B",
        en: "Title",
        hy: "\u054F\u056B\u057F\u0572\u0578\u057D",
        ka: "\u10E1\u10D0\u10D7\u10D0\u10E3\u10E0\u10D8"
    },
    start_title: {
        /* Was "Срт" — a truncated Ukrainian value whose Cyrillic С-р-т reads as the pseudo-Latin "CPT",
       which is exactly how it was reported (PICSELL-1574 #4). en/hy/ka were already correct. */ uk: "\u041F\u043E\u0447\u0430\u0442\u043E\u043A",
        en: "Start",
        hy: "\u054D\u056F\u056B\u0566\u0562",
        ka: "\u10D3\u10D0\u10EC\u10E7\u10D4\u10D1\u10D0"
    },
    end_title: {
        uk: "\u041A\u0456\u043D\u0435\u0446\u044C",
        en: "End",
        hy: "\u0531\u057E\u0561\u0580\u057F",
        ka: "\u10D3\u10D0\u10E1\u10D0\u10E1\u10E0\u10E3\u10DA\u10D8"
    },
    number_of_tags_title: {
        uk: "\u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C \u0442\u0435\u0433\u0456\u0432",
        en: "Number of tags",
        hy: "\u0539\u0565\u0563\u0565\u0580\u056B \u0584\u0561\u0576\u0561\u056F",
        ka: "\u10E2\u10D4\u10D2\u10D4\u10D1\u10D8\u10E1 \u10E0\u10D0\u10DD\u10D3\u10D4\u10DC\u10DD\u10D1\u10D0"
    },
    completion_title: {
        uk: "\u0417\u0430\u043A\u0456\u043D\u0447\u0435\u043D\u043D\u044F",
        en: "Completion",
        hy: "\u0531\u057E\u0561\u0580\u057F\u0578\u0582\u0574",
        ka: "\u10D3\u10D0\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10D0"
    },
    point_title: {
        uk: "\u0422\u043E\u0447\u043A\u0430",
        en: "Point",
        hy: "\u053F\u0565\u057F",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8"
    },
    points_title: {
        uk: "\u0422\u043E\u0447\u043A\u0438",
        en: "Points",
        hy: "\u053F\u0565\u057F\u0565\u0580",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8"
    },
    day_title: {
        uk: "\u0414\u0435\u043D\u044C",
        en: "Day",
        hy: "\u0555\u0580",
        ka: "\u10D3\u10E6\u10D4"
    },
    save_btn: {
        uk: "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438",
        en: "Save",
        hy: "\u054A\u0561\u0570\u057A\u0561\u0576\u0565\u056C",
        ka: "\u10E8\u10D4\u10DC\u10D0\u10EE\u10D5\u10D0"
    },
    movement: {
        uk: "\u041F\u0435\u0440\u0435\u0441\u0443\u0432\u0430\u043D\u043D\u044F",
        en: "Movement",
        hy: "\u054F\u0565\u0572\u0561\u0577\u0561\u0580\u056A",
        ka: "\u10DB\u10DD\u10EB\u10E0\u10D0\u10DD\u10D1\u10D0"
    },
    connected: {
        uk: "\u041F\u0440\u0438\u0454\u0434\u043D\u0430\u0432\u0441\u044F",
        en: "Connected",
        hy: "\u0544\u056B\u0561\u0581\u057E\u0561\u056E",
        ka: "\u10D3\u10D0\u10D9\u10D0\u10D5\u10E8\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8"
    },
    deactivated: {
        uk: "\u0414\u0435\u0430\u043A\u0442\u0438\u0432\u043E\u0432\u0430\u043D\u0438\u0439",
        en: "Deactivated",
        hy: "\u0531\u057A\u0561\u0561\u056F\u057F\u056B\u057E\u0561\u0581\u057E\u0561\u056E",
        ka: "\u10D3\u10D4\u10D0\u10E5\u10E2\u10D8\u10D5\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8"
    },
    till_newbie: {
        uk: "\u0414\u043E \u043D\u043E\u0432\u0430\u0447\u043A\u0456\u0432",
        en: "Till Newbie",
        hy: "\u0544\u056B\u0576\u0579\u0587 \u0576\u0578\u0580\u0565\u056F",
        ka: "\u10D3\u10D0\u10DB\u10EC\u10E7\u10D4\u10D1\u10D0\u10DB\u10D3\u10D4"
    },
    user_status: {
        uk: "\u0421\u0442\u0430\u0442\u0443\u0441",
        en: "Status",
        hy: "\u053F\u0561\u0580\u0563\u0561\u057E\u056B\u0573\u0561\u056F",
        ka: "\u10E1\u10E2\u10D0\u10E2\u10E3\u10E1\u10D8"
    },
    phone_number: {
        uk: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D",
        en: "Phone",
        hy: "\u0540\u0565\u057C\u0561\u056D\u0578\u057D",
        ka: "\u10E2\u10D4\u10DA\u10D4\u10E4\u10DD\u10DC\u10D8"
    }
};
const $fc3f36407bc5ec6c$export$37c2c40e726df6 = {
    user_name: {
        uk: "\u0406\u043C'\u044F \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430",
        en: "User name",
        hy: "\u0555\u0563\u057F\u0561\u057F\u056B\u0580\u0578\u057B \u0561\u0576\u0578\u0582\u0576\u0568",
        ka: "\u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10E1\u10D0\u10EE\u10D4\u10DA\u10D8"
    },
    phone_number: {
        uk: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D",
        en: "Phone",
        hy: "\u0540\u0565\u057C\u0561\u056D\u0578\u057D",
        ka: "\u10E2\u10D4\u10DA\u10D4\u10E4\u10DD\u10DC\u10D8"
    },
    movement: {
        uk: "\u041F\u0435\u0440\u0435\u0441\u0443\u0432\u0430\u043D\u043D\u044F",
        en: "Movement",
        hy: "\u054F\u0565\u0572\u0561\u0577\u0561\u0580\u056A",
        ka: "\u10DB\u10DD\u10EB\u10E0\u10D0\u10DD\u10D1\u10D0"
    },
    user_state: {
        uk: "\u0421\u0442\u0430\u043D",
        en: "User State",
        hy: "\u0555\u0563\u057F\u0561\u057F\u056B\u0580\u0578\u057B \u056F\u0561\u0580\u0563\u0561\u057E\u056B\u0573\u0561\u056F",
        ka: "\u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10DB\u10D3\u10D2\u10DD\u10DB\u10D0\u10E0\u10D4\u10DD\u10D1\u10D0"
    },
    date_join: {
        uk: "\u0414\u0430\u0442\u0430 \u043F\u0440\u0438\u0454\u0434\u043D\u0430\u043D\u043D\u044F",
        en: "Date of joining",
        hy: "\u0544\u056B\u0561\u0576\u0561\u056C\u0578\u0582 \u0561\u0574\u057D\u0561\u0569\u056B\u057E",
        ka: "\u10D2\u10D0\u10EC\u10D4\u10D5\u10E0\u10D8\u10D0\u10DC\u10D4\u10D1\u10D8\u10E1 \u10D7\u10D0\u10E0\u10D8\u10E6\u10D8"
    }
};
const $fc3f36407bc5ec6c$export$437eb927da0bf418 = {
    query: {
        uk: "\u0417\u0430\u043F\u0438\u0442",
        en: "Request",
        hy: "\u0540\u0561\u0575\u057F",
        ka: "\u10DB\u10DD\u10D7\u10EE\u10DD\u10D5\u10DC\u10D0"
    },
    date_from: {
        uk: "\u0414\u0430\u0442\u0430 \u0437",
        en: "Date from",
        hy: "\u0531\u0574\u057D\u0561\u0569\u056B\u057E\u0568 \u057D\u056F\u057D\u0561\u056E",
        ka: "\u10D7\u10D0\u10E0\u10D8\u10E6\u10D8 \u10D3\u10D0\u10DC"
    },
    date_to: {
        uk: "\u0414\u0430\u0442\u0430 \u0434\u043E",
        en: "Date to",
        hy: "\u0531\u0574\u057D\u0561\u0569\u056B\u057E\u0568 \u0574\u056B\u0576\u0579\u0587",
        ka: "\u10D7\u10D0\u10E0\u10D8\u10E6\u10D8 \u10DB\u10D3\u10D4"
    },
    reason: {
        uk: "\u041F\u0440\u0438\u0447\u0438\u043D\u0430",
        en: "Reason",
        hy: "\u054A\u0561\u057F\u0573\u0561\u057C",
        ka: "\u10DB\u10D8\u10D6\u10D4\u10D6\u10D8"
    },
    add_btn: {
        uk: "\u0414\u043E\u0434\u0430\u0442\u0438",
        en: "Add",
        hy: "\u0531\u057E\u0565\u056C\u0561\u0581\u0576\u0565\u056C",
        ka: "\u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D0"
    },
    absence_history: {
        uk: "\u0406\u0441\u0442\u043E\u0440\u0456\u044F \u0432\u0456\u0434\u0441\u0443\u0442\u043D\u043E\u0441\u0442\u0435\u0439",
        en: "Absence history",
        hy: "\u0532\u0561\u0581\u0561\u056F\u0561\u0575\u0578\u0582\u0569\u0575\u0561\u0576 \u057A\u0561\u057F\u0574\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10D0\u10E0\u10E7\u10DD\u10E4\u10DC\u10D8\u10E1 \u10D8\u10E1\u10E2\u10DD\u10E0\u10D8\u10D0"
    },
    absence_reason: {
        uk: "\u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u0432\u0432\u0435\u0434\u0456\u0442\u044C \u043F\u0440\u0438\u0447\u0438\u043D\u0443 \u0432\u0456\u0434\u0441\u0443\u0442\u043D\u043E\u0441\u0442\u0456",
        en: "Please enter the reason of absence",
        hy: "\u053D\u0576\u0564\u0580\u0578\u0582\u0574 \u0565\u0576\u0584 \u0576\u0577\u0565\u056C \u0562\u0561\u0581\u0561\u056F\u0561\u0575\u0578\u0582\u0569\u0575\u0561\u0576 \u057A\u0561\u057F\u0573\u0561\u057C\u0568",
        ka: "\u10D2\u10D7\u10EE\u10DD\u10D5\u10D7 \u10DB\u10D8\u10E3\u10D7\u10D8\u10D7\u10DD\u10D7 \u10D0\u10E0\u10E7\u10DD\u10E4\u10DC\u10D8\u10E1 \u10DB\u10D8\u10D6\u10D4\u10D6\u10D8"
    },
    absence_short_reason_title: {
        uk: "\u0412\u0430\u0440\u0456\u0430\u043D\u0442\u0438 \u0448\u0432\u0438\u0434\u043A\u0438\u0445 \u043F\u0440\u0438\u0447\u0438\u043D \u0432\u0456\u0434\u0441\u0443\u0442\u043D\u043E\u0441\u0442\u0456",
        en: "Quick absence reasons",
        hy: "\u0532\u0561\u0581\u0561\u056F\u0561\u0575\u0578\u0582\u0569\u0575\u0561\u0576 \u0561\u0580\u0561\u0563 \u057A\u0561\u057F\u0573\u0561\u057C\u0576\u0565\u0580",
        ka: "\u10D0\u10E0\u10E7\u10DD\u10E4\u10DC\u10D8\u10E1 \u10E1\u10D0\u10E1\u10EC\u10E0\u10D0\u10E4\u10DD \u10DB\u10D8\u10D6\u10D4\u10D6\u10D4\u10D1\u10D8"
    },
    absence_short_reason: {
        uk: "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0448\u0432\u0438\u0434\u043A\u0438\u0439 \u0432\u0430\u0440\u0456\u0430\u043D\u0442 \u043F\u0440\u0438\u0447\u0438\u043D\u0438 \u0432\u0456\u0434\u0441\u0443\u0442\u043D\u043E\u0441\u0442\u0456",
        en: "You can choose a quick reason for absence",
        hy: "\u0534\u0578\u0582\u0584 \u056F\u0561\u0580\u0578\u0572 \u0565\u0584 \u0568\u0576\u057F\u0580\u0565\u056C \u0562\u0561\u0581\u0561\u056F\u0561\u0575\u0578\u0582\u0569\u0575\u0561\u0576 \u0561\u0580\u0561\u0563 \u057A\u0561\u057F\u0573\u0561\u057C",
        ka: "\u10E8\u10D4\u10D2\u10D8\u10EB\u10DA\u10D8\u10D0\u10D7 \u10D0\u10D8\u10E0\u10E9\u10D8\u10DD\u10D7 \u10D0\u10E0\u10E7\u10DD\u10E4\u10DC\u10D8\u10E1 \u10E1\u10D0\u10E1\u10EC\u10E0\u10D0\u10E4\u10DD \u10DB\u10D8\u10D6\u10D4\u10D6\u10D8"
    }
};
const $fc3f36407bc5ec6c$export$3241045aa1844a20 = {
    monday: {
        uk: "\u041F\u043E\u043D\u0435\u0434\u0456\u043B\u043E\u043A",
        en: "Monday",
        hy: "\u0535\u0580\u056F\u0578\u0582\u0577\u0561\u0562\u0569\u056B",
        ka: "\u10DD\u10E0\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8"
    },
    tuesday: {
        uk: "\u0412\u0456\u0432\u0442\u043E\u0440\u043E\u043A",
        en: "Tuesday",
        hy: "\u0535\u0580\u0565\u0584\u0577\u0561\u0562\u0569\u056B",
        ka: "\u10E1\u10D0\u10DB\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8"
    },
    wednesday: {
        uk: "\u0421\u0435\u0440\u0435\u0434\u0430",
        en: "Wednesday",
        hy: "\u0549\u0578\u0580\u0565\u0584\u0577\u0561\u0562\u0569\u056B",
        ka: "\u10DD\u10D7\u10EE\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8"
    },
    thursday: {
        uk: "\u0427\u0435\u0442\u0432\u0435\u0440",
        en: "Thursday",
        hy: "\u0540\u056B\u0576\u0563\u0577\u0561\u0562\u0569\u056B",
        ka: "\u10EE\u10E3\u10D7\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8"
    },
    friday: {
        uk: "\u041F\u044F\u0442\u043D\u0438\u0446\u044F",
        en: "Friday",
        hy: "\u0548\u0582\u0580\u0562\u0561\u0569",
        ka: "\u10DE\u10D0\u10E0\u10D0\u10E1\u10D9\u10D4\u10D5\u10D8"
    },
    saturday: {
        uk: "\u0421\u0443\u0431\u043E\u0442\u0430",
        en: "Saturday",
        hy: "\u0547\u0561\u0562\u0561\u0569",
        ka: "\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8"
    },
    sunday: {
        uk: "\u041D\u0435\u0434\u0456\u043B\u044F",
        en: "Sunday",
        hy: "\u053F\u056B\u0580\u0561\u056F\u056B",
        ka: "\u10D9\u10D5\u10D8\u10E0\u10D0"
    }
};
const $fc3f36407bc5ec6c$export$5f49f978abb09725 = {
    import_tab: {
        uk: "\u0406\u043C\u043F\u043E\u0440\u0442",
        en: "Import",
        hy: "\u0546\u0565\u0580\u0574\u0578\u0582\u056E\u0578\u0582\u0574",
        ka: "\u10D8\u10DB\u10DE\u10DD\u10E0\u10E2\u10D8"
    },
    import_advanced_tab: {
        uk: "\u0420\u043E\u0437\u0448\u0438\u0440\u0435\u043D\u0438\u0439 \u0456\u043C\u043F\u043E\u0440\u0442",
        en: "Advanced Import",
        hy: "\u0538\u0576\u0564\u056C\u0561\u0575\u0576\u057E\u0561\u056E \u0576\u0565\u0580\u0574\u0578\u0582\u056E\u0578\u0582\u0574",
        ka: "\u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D8\u10D7\u10D8 \u10D8\u10DB\u10DE\u10DD\u10E0\u10E2\u10D8"
    },
    import_matrix_tab: {
        uk: "\u0406\u043C\u043F\u043E\u0440\u0442: \u0430\u0441\u043E\u0440\u0442\u0438\u043C\u0435\u043D\u0442\u0430 \u043C\u0430\u0442\u0440\u0438\u0446\u044F",
        en: "Import: Assortment Matrix",
        hy: "\u0546\u0565\u0580\u0574\u0578\u0582\u056E\u0578\u0582\u0574. \u054F\u0565\u057D\u0561\u056F\u0561\u0576\u0578\u0582 \u0574\u0561\u057F\u0580\u056B\u0581\u0561",
        ka: "\u10D8\u10DB\u10DE\u10DD\u10E0\u10E2\u10D8: \u10D0\u10E1\u10DD\u10E0\u10E2\u10D8\u10DB\u10D4\u10DC\u10E2\u10D8\u10E1 \u10DB\u10D0\u10E2\u10E0\u10D8\u10EA\u10D0"
    },
    import_downloads_tab: {
        uk: "\u041C\u043E\u0457 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F",
        en: "My Uploads",
        hy: "\u053B\u0574 \u057E\u0565\u0580\u0562\u0565\u057C\u0576\u0578\u0582\u0574\u0576\u0565\u0580\u0568",
        ka: "\u10E9\u10D4\u10DB\u10D8 \u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D4\u10D1\u10D8"
    },
    type_loading: {
        uk: "\u0422\u0438\u043F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F",
        en: "Loading Type",
        hy: "\u0532\u0565\u057C\u0576\u0574\u0561\u0576 \u057F\u0565\u057D\u0561\u056F",
        ka: "\u10E9\u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D8\u10E1 \u10E2\u10D8\u10DE\u10D8"
    },
    click_or_drag_file: {
        uk: "\u041A\u043B\u0456\u043A\u043D\u0456\u0442\u044C \u0430\u0431\u043E \u043F\u0435\u0440\u0435\u0442\u044F\u0433\u043D\u0456\u0442\u044C \u0444\u0430\u0439\u043B",
        en: "Click or Drag a File",
        hy: "\u054D\u0565\u0572\u0574\u0565\u0584 \u056F\u0561\u0574 \u0584\u0561\u0577\u0565\u0584 \u0586\u0561\u0575\u056C\u0568",
        ka: "\u10D3\u10D0\u10D0\u10ED\u10D8\u10E0\u10D4\u10D7 \u10D0\u10DC \u10D2\u10D0\u10D3\u10DB\u10DD\u10D0\u10D7\u10E0\u10D8\u10D4\u10D7 \u10E4\u10D0\u10D8\u10DA\u10D8"
    },
    download_btn: {
        uk: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438",
        en: "Download",
        hy: "\u0546\u0565\u0580\u0562\u0565\u057C\u0576\u0565\u056C",
        ka: "\u10E9\u10D0\u10DB\u10DD\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D0"
    },
    add_record_btn: {
        uk: "\u0414\u043E\u0434\u0430\u0442\u0438 \u0437\u0430\u043F\u0438\u0441",
        en: "Add Record",
        hy: "\u0531\u057E\u0565\u056C\u0561\u0581\u0576\u0565\u056C \u0563\u0580\u0561\u057C\u0578\u0582\u0574",
        ka: "\u10E9\u10D0\u10DC\u10D0\u10EC\u10D4\u10E0\u10D8\u10E1 \u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D0"
    },
    save_btn: {
        uk: "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438",
        en: "Save",
        hy: "\u054A\u0561\u0570\u057A\u0561\u0576\u0565\u056C",
        ka: "\u10E8\u10D4\u10DC\u10D0\u10EE\u10D5\u10D0"
    },
    back_btn: {
        uk: "\u041D\u0430\u0437\u0430\u0434",
        en: "Back",
        hy: "\u0540\u0565\u057F",
        ka: "\u10E3\u10D9\u10D0\u10DC"
    },
    status: {
        uk: "\u0421\u0442\u0430\u0442\u0443\u0441",
        en: "Status",
        hy: "\u053F\u0561\u0580\u0563\u0561\u057E\u056B\u0573\u0561\u056F",
        ka: "\u10E1\u10E2\u10D0\u10E2\u10E3\u10E1\u10D8"
    },
    name_title: {
        uk: "\u041D\u0430\u0437\u0432\u0430",
        en: "Name",
        hy: "\u0531\u0576\u0578\u0582\u0576",
        ka: "\u10E1\u10D0\u10EE\u10D4\u10DA\u10D8"
    },
    line_title: {
        uk: "\u0420\u044F\u0434\u043E\u043A",
        en: "Line",
        hy: "\u054F\u0578\u0572",
        ka: "\u10EE\u10D0\u10D6\u10D8"
    },
    start_date_title: {
        uk: "\u0414\u0430\u0442\u0430 \u043F\u043E\u0447\u0430\u0442\u043A\u0443",
        en: "Start Date",
        hy: "\u054D\u056F\u0566\u0562\u056B \u0561\u0574\u057D\u0561\u0569\u056B\u057E",
        ka: "\u10D3\u10D0\u10EC\u10E7\u10D4\u10D1\u10D8\u10E1 \u10D7\u10D0\u10E0\u10D8\u10E6\u10D8"
    },
    end_date_title: {
        uk: "\u0414\u0430\u0442\u0430 \u043A\u0456\u043D\u0446\u044F",
        en: "End Date",
        hy: "\u0531\u057E\u0561\u0580\u057F\u056B \u0561\u0574\u057D\u0561\u0569\u056B\u057E",
        ka: "\u10D3\u10D0\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10D8\u10E1 \u10D7\u10D0\u10E0\u10D8\u10E6\u10D8"
    },
    photo_title: {
        uk: "\u0424\u043E\u0442\u043E",
        en: "Photo",
        hy: "\u053C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580",
        ka: "\u10E4\u10DD\u10E2\u10DD"
    },
    description_title: {
        uk: "\u041E\u043F\u0438\u0441",
        en: "Description",
        hy: "\u0546\u056F\u0561\u0580\u0561\u0563\u0580\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10D0\u10E6\u10EC\u10D4\u10E0\u10D0"
    },
    added_points_text_label_suf: {
        uk: "\u0414\u043E\u0434\u0430\u043D\u043E",
        en: "Added",
        hy: "\u0531\u057E\u0565\u056C\u0561\u0581\u057E\u0565\u056C \u0567",
        ka: "\u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0"
    },
    added_points_text_label_pref: {
        uk: "\u0442\u043E\u0447\u043A\u0430(\u0442\u043E\u0447\u043E\u043A)",
        en: "point(points)",
        hy: "\u056F\u0565\u057F(\u0565\u0580)",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8(\u10D4\u10D1\u10D8)"
    },
    type_tasks_title: {
        uk: "\u0422\u0438\u043F \u0437\u0430\u0434\u0430\u0447",
        en: "Type of tasks",
        hy: "\u0531\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0576\u0565\u0580\u056B \u057F\u0565\u057D\u0561\u056F",
        ka: "\u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8\u10E1 \u10E2\u10D8\u10DE\u10D8"
    },
    download_date_title: {
        uk: "\u0414\u0430\u0442\u0430 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F",
        en: "Download date",
        hy: "\u0546\u0565\u0580\u0562\u0565\u057C\u0576\u0574\u0561\u0576 \u0561\u0574\u057D\u0561\u0569\u056B\u057E",
        ka: "\u10E9\u10D0\u10DB\u10DD\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D8\u10E1 \u10D7\u10D0\u10E0\u10D8\u10E6\u10D8"
    },
    loading_errors_title: {
        uk: "\u041F\u043E\u043C\u0438\u043B\u043A\u0438 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F",
        en: "Loading errors",
        hy: "\u0532\u0565\u057C\u0576\u0574\u0561\u0576 \u057D\u056D\u0561\u056C\u0576\u0565\u0580",
        ka: "\u10E9\u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D8\u10E1 \u10E8\u10D4\u10EA\u10D3\u10DD\u10DB\u10D4\u10D1\u10D8"
    },
    need_title_task_msg: {
        uk: "\u041F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u0432\u0432\u0435\u0441\u0442\u0438 \u0442\u0438\u0442\u0443\u043B \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F",
        en: "You need to enter the title of the task",
        hy: "\u0531\u0576\u0570\u0580\u0561\u056A\u0565\u0577\u057F \u0567 \u0574\u0578\u0582\u057F\u0584\u0561\u0563\u0580\u0565\u056C \u0561\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u056B \u057E\u0565\u0580\u0576\u0561\u0563\u056B\u0580\u0568",
        ka: "\u10E1\u10D0\u10ED\u10D8\u10E0\u10DD\u10D0 \u10E8\u10D4\u10D8\u10E7\u10D5\u10D0\u10DC\u10DD\u10D7 \u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D8\u10E1 \u10E1\u10D0\u10D7\u10D0\u10E3\u10E0\u10D8"
    },
    download_was_delete_msg: {
        uk: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0443\u0441\u043F\u0456\u0448\u043D\u043E \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043E",
        en: "Download has been successfully deleted",
        hy: "\u0546\u0565\u0580\u0562\u0565\u057C\u0576\u0578\u0582\u0574\u0568 \u0570\u0561\u057B\u0578\u0572\u0578\u0582\u0569\u0575\u0561\u0574\u0562 \u057B\u0576\u057B\u057E\u0565\u056C \u0567",
        ka: "\u10E9\u10D0\u10DB\u10DD\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D0 \u10EC\u10D0\u10E0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D8\u10D7 \u10EC\u10D0\u10D8\u10E8\u10D0\u10DA\u10D0"
    },
    need_choose_task_msg: {
        uk: "\u041F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u0432\u0438\u0431\u0440\u0430\u0442\u0438 \u0448\u0430\u0431\u043B\u043E\u043D",
        en: "You need to choose a template",
        hy: "\u0531\u0576\u0570\u0580\u0561\u056A\u0565\u0577\u057F \u0567 \u0568\u0576\u057F\u0580\u0565\u056C \u0571\u0587\u0561\u0576\u0574\u0578\u0582\u0577",
        ka: "\u10E1\u10D0\u10ED\u10D8\u10E0\u10DD\u10D0 \u10E8\u10D0\u10D1\u10DA\u10DD\u10DC\u10D8\u10E1 \u10D0\u10E0\u10E9\u10D4\u10D5\u10D0"
    },
    need_choose_point_msg: {
        uk: "\u041F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u0432\u0438\u0431\u0440\u0430\u0442\u0438 \u0442\u043E\u0447\u043A\u0443",
        en: "Point is required field",
        hy: "\u053F\u0565\u057F\u0568 \u057A\u0561\u0580\u057F\u0561\u0564\u056B\u0580 \u0564\u0561\u0577\u057F \u0567",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8 \u10E1\u10D0\u10D5\u10D0\u10DA\u10D3\u10D4\u10D1\u10E3\u10DA\u10DD \u10D5\u10D4\u10DA\u10D8\u10D0"
    },
    /* Added with the `"network"` branch in `validateReviewTask` — before it, a network task always
     failed the `"single"` check with "Point is required". hy/ka need native review. */ need_choose_network_msg: {
        uk: "\u041F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u0432\u0438\u0431\u0440\u0430\u0442\u0438 \u043C\u0435\u0440\u0435\u0436\u0443",
        en: "Network is required field",
        hy: "\u0551\u0561\u0576\u0581\u0568 \u057A\u0561\u0580\u057F\u0561\u0564\u056B\u0580 \u0564\u0561\u0577\u057F \u0567",
        ka: "\u10E5\u10E1\u10D4\u10DA\u10D8 \u10E1\u10D0\u10D5\u10D0\u10DA\u10D3\u10D4\u10D1\u10E3\u10DA\u10DD \u10D5\u10D4\u10DA\u10D8\u10D0"
    },
    need_choose_point_group_msg: {
        uk: "\u041F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u0432\u0438\u0431\u0440\u0430\u0442\u0438 \u0433\u0440\u0443\u043F\u0443 \u0442\u043E\u0447\u043E\u043A",
        en: "Group of points is required field",
        hy: "\u053F\u0565\u057F\u0565\u0580\u056B \u056D\u0578\u0582\u0574\u0562\u0568 \u057A\u0561\u0580\u057F\u0561\u0564\u056B\u0580 \u0564\u0561\u0577\u057F \u0567",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1 \u10EF\u10D2\u10E3\u10E4\u10D8 \u10E1\u10D0\u10D5\u10D0\u10DA\u10D3\u10D4\u10D1\u10E3\u10DA\u10DD \u10D5\u10D4\u10DA\u10D8\u10D0"
    },
    create_success_group_task_msg: {
        uk: "\u0412\u0430\u0448\u0456 \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F \u0441\u0442\u0432\u043E\u0440\u044E\u044E\u0442\u044C\u0441\u044F \u0442\u0430 \u0431\u0443\u0434\u0443\u0442\u044C \u0433\u043E\u0442\u043E\u0432\u0456 \u0437\u0430 \u043A\u0456\u043B\u044C\u043A\u0430 \u0445\u0432\u0438\u043B\u0438\u043D.",
        en: "Creating your tasks. They will be ready in a couple of minutes.",
        hy: "\u0541\u0565\u0580 \u0561\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0576\u0565\u0580\u0568 \u057D\u057F\u0565\u0572\u056E\u057E\u0578\u0582\u0574 \u0565\u0576\u0589 \u0534\u0580\u0561\u0576\u0584 \u057A\u0561\u057F\u0580\u0561\u057D\u057F \u056F\u056C\u056B\u0576\u0565\u0576 \u0574\u056B \u0584\u0561\u0576\u056B \u0580\u0578\u057A\u0565\u0578\u0582\u0574\u0589",
        ka: "\u10D7\u10E5\u10D5\u10D4\u10DC\u10D8 \u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8 \u10D8\u10E5\u10DB\u10DC\u10D4\u10D1\u10D0. \u10D8\u10E1\u10D8\u10DC\u10D8 \u10DB\u10D6\u10D0\u10D3 \u10D8\u10E5\u10DC\u10D4\u10D1\u10D0 \u10E0\u10D0\u10DB\u10D3\u10D4\u10DC\u10D8\u10DB\u10D4 \u10EC\u10E3\u10D7\u10E8\u10D8."
    },
    need_choose_point_group_name_msg: {
        uk: "\u041F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u0432\u0432\u0435\u0441\u0442\u0438 \u0442\u0438\u0442\u0443\u043B \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F",
        en: "Group of points title is required field",
        hy: "\u053F\u0565\u057F\u0565\u0580\u056B \u056D\u0574\u0562\u056B \u057E\u0565\u0580\u0576\u0561\u0563\u056B\u0580\u0568 \u057A\u0561\u0580\u057F\u0561\u0564\u056B\u0580 \u0564\u0561\u0577\u057F \u0567",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1 \u10EF\u10D2\u10E3\u10E4\u10D8\u10E1 \u10E1\u10D0\u10D7\u10D0\u10E3\u10E0\u10D8 \u10E1\u10D0\u10D5\u10D0\u10DA\u10D3\u10D4\u10D1\u10E3\u10DA\u10DD \u10D5\u10D4\u10DA\u10D8\u10D0"
    },
    empty_field_msg: {
        uk: "\u0426\u0435 \u043F\u043E\u043B\u0435 \u043D\u0435 \u043C\u043E\u0436\u0435 \u0431\u0443\u0442\u0438 \u043F\u0443\u0441\u0442\u0438\u043C",
        en: "This field cannot be empty",
        hy: "\u0531\u0575\u057D \u0564\u0561\u0577\u057F\u0568 \u0579\u056B \u056F\u0561\u0580\u0578\u0572 \u0564\u0561\u057F\u0561\u0580\u056F \u056C\u056B\u0576\u0565\u056C",
        ka: "\u10D4\u10E1 \u10D5\u10D4\u10DA\u10D8 \u10D0\u10E0 \u10E8\u10D4\u10D8\u10EB\u10DA\u10D4\u10D1\u10D0 \u10D8\u10E7\u10DD\u10E1 \u10EA\u10D0\u10E0\u10D8\u10D4\u10DA\u10D8"
    },
    download_name: {
        uk: "\u041D\u0430\u0437\u0432\u0430 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F",
        en: "Download name",
        hy: "\u0546\u0565\u0580\u0562\u0565\u057C\u0576\u0574\u0561\u0576 \u0561\u0576\u057E\u0561\u0576\u0578\u0582\u0574",
        ka: "\u10E9\u10D0\u10DB\u10DD\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D8\u10E1 \u10E1\u10D0\u10EE\u10D4\u10DA\u10D8"
    },
    select_download_type: {
        uk: "\u041E\u0431\u0435\u0440\u0456\u0442\u044C \u0442\u0438\u043F\u0430 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F",
        en: "Choose the download type",
        hy: "\u0538\u0576\u057F\u0580\u0565\u0584 \u0576\u0565\u0580\u0562\u0565\u057C\u0576\u0574\u0561\u0576 \u057F\u0565\u057D\u0561\u056F\u0568",
        ka: "\u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10E9\u10D0\u10DB\u10DD\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D8\u10E1 \u10E2\u10D8\u10DE\u10D8"
    },
    click_drag_img: {
        uk: "\u041A\u043B\u0456\u043A\u043D\u0456\u0442\u044C \u0430\u0431\u043E \u043F\u0435\u0440\u0435\u0442\u044F\u0433\u043D\u0456\u0442\u044C \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F \u0441\u044E\u0434\u0438",
        en: "Click or drag the image here",
        hy: "\u054D\u0565\u0572\u0574\u0565\u0584 \u056F\u0561\u0574 \u0584\u0561\u0577\u0565\u0584 \u0576\u056F\u0561\u0580\u0568 \u0561\u0575\u057D\u057F\u0565\u0572",
        ka: "\u10D3\u10D0\u10D0\u10ED\u10D8\u10E0\u10D4\u10D7 \u10D0\u10DC \u10D2\u10D0\u10D3\u10DB\u10DD\u10D0\u10D7\u10E0\u10D8\u10D4\u10D7 \u10E1\u10E3\u10E0\u10D0\u10D7\u10D8 \u10D0\u10E5"
    },
    only_one_photo_allowed_for_type_point: {
        uk: "\u0414\u043B\u044F \u0442\u0438\u043F\u0443 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F '\u0422\u043E\u0447\u043A\u0430' \u0434\u043E\u0437\u0432\u043E\u043B\u0435\u043D\u0435 \u043B\u0438\u0448\u0435 \u043E\u0434\u043D\u0435 \u0444\u043E\u0442\u043E",
        en: "For upload type 'Point', only one photo is allowed",
        hy: "\xab\u053F\u0565\u057F\xbb \u057F\u0565\u057D\u0561\u056F\u056B \u057E\u0565\u0580\u0562\u0565\u057C\u0576\u0574\u0561\u0576 \u0570\u0561\u0574\u0561\u0580 \u0569\u0578\u0582\u0575\u056C\u0561\u057F\u0580\u057E\u0578\u0582\u0574 \u0567 \u0574\u056B\u0561\u0575\u0576 \u0574\u0565\u056F \u056C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580",
        ka: "'\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8' \u10E2\u10D8\u10DE\u10D8\u10E1 \u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1 \u10D3\u10D0\u10E8\u10D5\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0 \u10DB\u10EE\u10DD\u10DA\u10DD\u10D3 \u10D4\u10E0\u10D7\u10D8 \u10E4\u10DD\u10E2\u10DD"
    },
    complete_at_least_one_task_msg: {
        uk: "\u0417\u0430\u043F\u043E\u0432\u043D\u0456\u0442\u044C \u0445\u043E\u0447\u0430 \u0431 \u043E\u0434\u043D\u0435 \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F \u0430\u0431\u043E \u0432\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0444\u0430\u0439\u043B \u0434\u043B\u044F \u0456\u043C\u043F\u043E\u0440\u0442\u0443",
        en: "Complete at least one task or select a file to import",
        hy: "\u053C\u0580\u0561\u0581\u0580\u0565\u0584 \u0561\u057C\u0576\u057E\u0561\u0566\u0576 \u0574\u0565\u056F \u0561\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584 \u056F\u0561\u0574 \u0568\u0576\u057F\u0580\u0565\u0584 \u0586\u0561\u0575\u056C \u0576\u0565\u0580\u0574\u0578\u0582\u056E\u0574\u0561\u0576 \u0570\u0561\u0574\u0561\u0580",
        ka: "\u10E8\u10D4\u10D0\u10D5\u10E1\u10D4\u10D7 \u10E1\u10E3\u10DA \u10DB\u10EA\u10D8\u10E0\u10D4 \u10D4\u10E0\u10D7\u10D8 \u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D0 \u10D0\u10DC \u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10E4\u10D0\u10D8\u10DA\u10D8 \u10D8\u10DB\u10DE\u10DD\u10E0\u10E2\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1"
    },
    network_label: {
        uk: "\u041C\u0435\u0440\u0435\u0436\u0430",
        en: "Network",
        hy: "\u0551\u0561\u0576\u0581",
        ka: "\u10E5\u10E1\u10D4\u10DA\u10D8"
    },
    point_label: {
        uk: "\u0422\u043E\u0447\u043A\u0430",
        en: "Point",
        hy: "\u053F\u0565\u057F",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8"
    },
    remove_btn: {
        uk: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438",
        en: "Remove",
        hy: "\u0540\u0565\u057C\u0561\u0581\u0576\u0565\u056C",
        ka: "\u10EC\u10D0\u10E8\u10DA\u10D0"
    },
    addresses_label: {
        uk: "\u0410\u0434\u0440\u0435\u0441\u0430",
        en: "Addresses",
        hy: "\u0540\u0561\u057D\u0581\u0565\u0576\u0565\u0580",
        ka: "\u10DB\u10D8\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10D4\u10D1\u10D8"
    },
    code_label: {
        uk: "\u041A\u043E\u0434",
        en: "Code",
        hy: "\u053F\u0578\u0564",
        ka: "\u10D9\u10DD\u10D3\u10D8"
    },
    location_label: {
        uk: "\u0420\u043E\u0437\u0442\u0430\u0448\u0443\u0432\u0430\u043D\u043D\u044F",
        en: "Location",
        hy: "\u0533\u057F\u0576\u057E\u0565\u056C\u0578\u0582 \u057E\u0561\u0575\u0580",
        ka: "\u10DB\u10D3\u10D4\u10D1\u10D0\u10E0\u10D4\u10DD\u10D1\u10D0"
    },
    coordinates_label: {
        uk: "\u041A\u043E\u043E\u0440\u0434\u0438\u043D\u0430\u0442\u0438",
        en: "Coordinates",
        hy: "\u053F\u0578\u0578\u0580\u0564\u056B\u0576\u0561\u057F\u0576\u0565\u0580",
        ka: "\u10D9\u10DD\u10DD\u10E0\u10D3\u10D8\u10DC\u10D0\u10E2\u10D4\u10D1\u10D8"
    },
    view_the_point: {
        uk: "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u0434 \u0442\u043E\u0447\u043A\u0438",
        en: "View the point",
        hy: "\u0534\u056B\u057F\u0565\u056C \u056F\u0565\u057F\u0568",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8\u10E1 \u10DC\u10D0\u10EE\u10D5\u10D0"
    },
    grouping_btn_name: {
        uk: "\u0413\u0440\u0443\u043F\u0443\u0432\u0430\u043D\u043D\u044F",
        en: "Grouping",
        hy: "\u053D\u0574\u0562\u0561\u057E\u0578\u0580\u0578\u0582\u0574",
        ka: "\u10D3\u10D0\u10EF\u10D2\u10E3\u10E4\u10D4\u10D1\u10D0"
    },
    new_group_btn_name: {
        uk: "\u041D\u043E\u0432\u0430 \u0433\u0440\u0443\u043F\u0430",
        en: "New Group",
        hy: "\u0546\u0578\u0580 \u056D\u0578\u0582\u0574\u0562",
        ka: "\u10D0\u10EE\u10D0\u10DA\u10D8 \u10EF\u10D2\u10E3\u10E4\u10D8"
    },
    grouping_popup_title: {
        uk: "\u0413\u0440\u0443\u043F\u0443\u0432\u0430\u043D\u043D\u044F \u0442\u043E\u0440\u0433\u043E\u0432\u0438\u0445 \u0442\u043E\u0447\u043E\u043A",
        en: "Grouping of trade points",
        hy: "\u0531\u057C\u0587\u057F\u0580\u056B \u056F\u0565\u057F\u0565\u0580\u056B \u056D\u0574\u0562\u0561\u057E\u0578\u0580\u0578\u0582\u0574",
        ka: "\u10E1\u10D0\u10D5\u10D0\u10ED\u10E0\u10DD \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1 \u10D3\u10D0\u10EF\u10D2\u10E3\u10E4\u10D4\u10D1\u10D0"
    },
    new_group_popup_title: {
        uk: "\u0406\u0441\u043D\u0443\u044E\u0447\u0456 \u0433\u0440\u0443\u043F\u0438",
        en: "Existing groups",
        hy: "\u0531\u057C\u056F\u0561 \u056D\u0574\u0562\u0565\u0580",
        ka: "\u10D0\u10E0\u10E1\u10D4\u10D1\u10E3\u10DA\u10D8 \u10EF\u10D2\u10E3\u10E4\u10D4\u10D1\u10D8"
    },
    new_group_popup_new_title: {
        uk: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u043D\u043E\u0432\u043E\u0457 \u0433\u0440\u0443\u043F\u0438",
        en: "Creating a new group",
        hy: "\u0546\u0578\u0580 \u056D\u0574\u0562\u056B \u057D\u057F\u0565\u0572\u056E\u0578\u0582\u0574",
        ka: "\u10D0\u10EE\u10D0\u10DA\u10D8 \u10EF\u10D2\u10E3\u10E4\u10D8\u10E1 \u10E8\u10D4\u10E5\u10DB\u10DC\u10D0"
    },
    new_group_popup_edit_title: {
        uk: "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u043D\u043D\u044F \u0433\u0440\u0443\u043F\u0438",
        en: "Editing group",
        hy: "\u053D\u0574\u0562\u056B \u056D\u0574\u0562\u0561\u0563\u0580\u0578\u0582\u0574",
        ka: "\u10EF\u10D2\u10E3\u10E4\u10D8\u10E1 \u10E0\u10D4\u10D3\u10D0\u10E5\u10E2\u10D8\u10E0\u10D4\u10D1\u10D0"
    },
    new_group_popup_field_name: {
        uk: "\u041D\u0430\u0437\u0432\u0430 \u0433\u0440\u0443\u043F\u0438",
        en: "Group Name",
        hy: "\u053D\u0574\u0562\u056B \u0561\u0576\u057E\u0561\u0576\u0578\u0582\u0574",
        ka: "\u10EF\u10D2\u10E3\u10E4\u10D8\u10E1 \u10E1\u10D0\u10EE\u10D4\u10DA\u10D8"
    },
    new_group_popup_field_group_textarea_name: {
        uk: "\u0422\u043E\u0440\u0433\u043E\u0432\u0456 \u0442\u043E\u0447\u043A\u0438",
        en: "Trade points",
        hy: "\u0531\u057C\u0587\u057F\u0580\u056B \u056F\u0565\u057F\u0565\u0580",
        ka: "\u10E1\u10D0\u10D5\u10D0\u10ED\u10E0\u10DD \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8"
    },
    group_popup_filter_name_label: {
        uk: "\u0424\u0456\u043B\u044C\u0442\u0440 \u0442\u043E\u0447\u043E\u043A",
        en: "Points filter",
        hy: "\u053F\u0565\u057F\u0565\u0580\u056B \u0586\u056B\u056C\u057F\u0580",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1 \u10E4\u10D8\u10DA\u10E2\u10E0\u10D8"
    },
    new_group_popup_field_group_available_users: {
        uk: "\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u043E \u0434\u043B\u044F",
        en: "Available for",
        hy: "\u0540\u0561\u057D\u0561\u0576\u0565\u056C\u056B \u0567",
        ka: "\u10EE\u10D4\u10DA\u10DB\u10D8\u10E1\u10D0\u10EC\u10D5\u10D3\u10DD\u10DB\u10D8\u10D0"
    },
    new_group_popup_field_name_placeholder: {
        uk: "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u043D\u0430\u0437\u0432\u0443 \u0433\u0440\u0443\u043F\u0438. \u041C\u0456\u043D\u0456\u043C\u0443\u043C 5 \u0441\u0438\u043C\u0432\u043E\u043B\u0456\u0432",
        en: "Enter the name of the group. Minimum 5 characters",
        hy: "\u0544\u0578\u0582\u057F\u0584\u0561\u0563\u0580\u0565\u0584 \u056D\u0574\u0562\u056B \u0561\u0576\u057E\u0561\u0576\u0578\u0582\u0574\u0568\u0589 \u0531\u057C\u0576\u057E\u0561\u0566\u0576 5 \u0576\u0577\u0561\u0576",
        ka: "\u10E8\u10D4\u10D8\u10E7\u10D5\u10D0\u10DC\u10D4\u10D7 \u10EF\u10D2\u10E3\u10E4\u10D8\u10E1 \u10E1\u10D0\u10EE\u10D4\u10DA\u10D8. \u10DB\u10D8\u10DC\u10D8\u10DB\u10E3\u10DB 5 \u10E1\u10D8\u10DB\u10D1\u10DD\u10DA\u10DD"
    },
    group_popup_filter_name_placeholder: {
        uk: "\u0424\u0456\u043B\u044C\u0442\u0440\u0443\u0432\u0430\u043D\u043D\u044F \u0442\u043E\u0440\u0433\u043E\u0432\u0438\u0445 \u0442\u043E\u0447\u043E\u043A (\u043C\u0456\u043D 3 \u0441\u0438\u043C\u0432\u043E\u043B\u0438)",
        en: "Filtering trade points (min 3 characters)",
        hy: "\u0531\u057C\u0587\u057F\u0580\u056B \u056F\u0565\u057F\u0565\u0580\u056B \u0566\u057F\u0578\u0582\u0574 (\u0576\u057E\u0561\u0566\u0561\u0563\u0578\u0582\u0575\u0576\u0568 3 \u0576\u0577\u0561\u0576)",
        ka: "\u10E1\u10D0\u10D5\u10D0\u10ED\u10E0\u10DD \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1 \u10E4\u10D8\u10DA\u10E2\u10E0\u10D0\u10EA\u10D8\u10D0 (\u10DB\u10D8\u10DC. 3 \u10E1\u10D8\u10DB\u10D1\u10DD\u10DA\u10DD)"
    },
    new_group_popup_field_group_add_all_btn_text: {
        uk: "\u0414\u043E\u0434\u0430\u0442\u0438 \u0432\u0441\u0456 \u0442\u043E\u0447\u043A\u0438",
        en: "Add all points",
        hy: "\u0531\u057E\u0565\u056C\u0561\u0581\u0576\u0565\u056C \u0562\u0578\u056C\u0578\u0580 \u056F\u0565\u057F\u0565\u0580\u0568",
        ka: "\u10E7\u10D5\u10D4\u10DA\u10D0 \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8\u10E1 \u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D0"
    },
    new_group_popup_field_group_placeholder: {
        uk: "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0442\u043E\u0440\u0433\u043E\u0432\u0456 \u0442\u043E\u0447\u043A\u0438 \u0437\u0456 \u0441\u043F\u0438\u0441\u043A\u0443",
        en: "Choose trade points from the list",
        hy: "\u0538\u0576\u057F\u0580\u0565\u0584 \u0561\u057C\u0587\u057F\u0580\u056B \u056F\u0565\u057F\u0565\u0580\u0568 \u0581\u0561\u0576\u056F\u056B\u0581",
        ka: "\u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10E1\u10D0\u10D5\u10D0\u10ED\u10E0\u10DD \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8 \u10E1\u10D8\u10D8\u10D3\u10D0\u10DC"
    },
    group_popup_filter_name_empty_placeholder: {
        uk: "\u0422\u043E\u0440\u0433\u043E\u0432\u0438\u0445 \u0442\u043E\u0447\u043E\u043A \u0449\u043E \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0430\u044E\u0442\u044C \u0432\u0430\u0448\u043E\u043C\u0443 \u0444\u0456\u043B\u044C\u0442\u0440\u0443 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
        en: "No trade points matching your filter were found.",
        hy: "\u0541\u0565\u0580 \u0586\u056B\u056C\u057F\u0580\u056B\u0576 \u0570\u0561\u0574\u0561\u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0578\u0572 \u0561\u057C\u0587\u057F\u0580\u056B \u056F\u0565\u057F\u0565\u0580 \u0579\u0565\u0576 \u0563\u057F\u0576\u057E\u0565\u056C\u0589",
        ka: "\u10D7\u10E5\u10D5\u10D4\u10DC\u10D8 \u10E4\u10D8\u10DA\u10E2\u10E0\u10D8\u10E1 \u10E8\u10D4\u10E1\u10D0\u10E2\u10E7\u10D5\u10D8\u10E1\u10D8 \u10E1\u10D0\u10D5\u10D0\u10ED\u10E0\u10DD \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8 \u10D0\u10E0 \u10DB\u10DD\u10D8\u10EB\u10D4\u10D1\u10DC\u10D0."
    },
    new_group_popup_field_users_placeholder: {
        uk: "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u043A\u043E\u043C\u0443 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430 \u0433\u0440\u0443\u043F\u0430 \u0437\u0456 \u0441\u043F\u0438\u0441\u043A\u0443",
        en: "Choose who has access to the group from the list",
        hy: "\u0538\u0576\u057F\u0580\u0565\u0584 \u0581\u0561\u0576\u056F\u056B\u0581, \u0578\u0582\u0574 \u0570\u0561\u0574\u0561\u0580 \u0570\u0561\u057D\u0561\u0576\u0565\u056C\u056B \u0567 \u056D\u0578\u0582\u0574\u0562\u0568",
        ka: "\u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10E1\u10D8\u10D8\u10D3\u10D0\u10DC, \u10D5\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1\u10D0\u10EA \u10EE\u10D4\u10DA\u10DB\u10D8\u10E1\u10D0\u10EC\u10D5\u10D3\u10DD\u10DB\u10D8\u10D0 \u10EF\u10D2\u10E3\u10E4\u10D8"
    },
    new_group_popup_error_text: {
        uk: "\u041F\u043E\u043B\u0435 \u043D\u0435 \u043C\u043E\u0436\u0435 \u0431\u0443\u0442\u0438 \u043F\u0443\u0441\u0442\u0438\u043C",
        en: "The field cannot be empty",
        hy: "\u0534\u0561\u0577\u057F\u0568 \u0579\u056B \u056F\u0561\u0580\u0578\u0572 \u0564\u0561\u057F\u0561\u0580\u056F \u056C\u056B\u0576\u0565\u056C",
        ka: "\u10D5\u10D4\u10DA\u10D8 \u10D0\u10E0 \u10E8\u10D4\u10D8\u10EB\u10DA\u10D4\u10D1\u10D0 \u10D8\u10E7\u10DD\u10E1 \u10EA\u10D0\u10E0\u10D8\u10D4\u10DA\u10D8"
    },
    new_group_popup_error_text_minimum: {
        uk: "\u041C\u0456\u043D\u0456\u043C\u0443\u043C 5 \u0441\u0438\u043C\u0432\u043E\u043B\u0456\u0432",
        en: "Minimum 5 characters",
        hy: "\u0531\u057C\u0576\u057E\u0561\u0566\u0576 5 \u0576\u0577\u0561\u0576",
        ka: "\u10DB\u10D8\u10DC\u10D8\u10DB\u10E3\u10DB 5 \u10E1\u10D8\u10DB\u10D1\u10DD\u10DA\u10DD"
    },
    new_group_popup_success_save_text: {
        uk: "\u0423\u0441\u043F\u0456\u0448\u043D\u043E \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043E",
        en: "Successfully saved",
        hy: "\u0540\u0561\u057B\u0578\u0572\u0578\u0582\u0569\u0575\u0561\u0574\u0562 \u057A\u0561\u0570\u057A\u0561\u0576\u057E\u0565\u056C \u0567",
        ka: "\u10EC\u10D0\u10E0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D8\u10D7 \u10E8\u10D4\u10D8\u10DC\u10D0\u10EE\u10D0"
    },
    new_group_popup_success_deleted_text: {
        uk: "\u0423\u0441\u043F\u0456\u0448\u043D\u043E \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043E",
        en: "Successfully deleted",
        hy: "\u0540\u0561\u057B\u0578\u0572\u0578\u0582\u0569\u0575\u0561\u0574\u0562 \u057B\u0576\u057B\u057E\u0565\u056C \u0567",
        ka: "\u10EC\u10D0\u10E0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D8\u10D7 \u10EC\u10D0\u10D8\u10E8\u10D0\u10DA\u10D0"
    },
    new_group_popup_failed_deleted_text: {
        uk: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043D\u044F, \u0434\u0438\u0432\u0456\u0442\u044C\u0441\u044F \u0434\u0435\u0442\u0430\u043B\u0456 \u0432 \u043A\u043E\u043D\u0441\u043E\u043B\u0456",
        en: "Failed to delete, check the console",
        hy: "\u054B\u0576\u057B\u0578\u0582\u0574\u0568 \u0571\u0561\u056D\u0578\u0572\u057E\u0565\u0581, \u057D\u057F\u0578\u0582\u0563\u0565\u0584 console-\u0568",
        ka: "\u10EC\u10D0\u10E8\u10DA\u10D0 \u10D5\u10D4\u10E0 \u10DB\u10DD\u10EE\u10D4\u10E0\u10EE\u10D3\u10D0, \u10D2\u10D0\u10D3\u10D0\u10D0\u10DB\u10DD\u10EC\u10DB\u10D4\u10D7 \u10D9\u10DD\u10DC\u10E1\u10DD\u10DA\u10D8"
    },
    new_group_popup_user_validate_error_text: {
        uk: "\u0423 \u0432\u0430\u0441 \u043D\u0435\u043C\u0430\u0454 \u0434\u043E\u0437\u0432\u043E\u043B\u0443 \u0434\u043B\u044F \u0432\u0438\u043A\u043E\u043D\u0430\u043D\u043D\u044F \u0446\u0456\u0454\u0457 \u0434\u0456\u0457",
        en: "You do not have permission to perform this action.",
        hy: "\u0534\u0578\u0582\u0584 \u0579\u0578\u0582\u0576\u0565\u0584 \u0561\u0575\u057D \u0563\u0578\u0580\u056E\u0578\u0572\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0568 \u056F\u0561\u057F\u0561\u0580\u0565\u056C\u0578\u0582 \u0569\u0578\u0582\u0575\u056C\u057F\u057E\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0589",
        ka: "\u10D7\u10E5\u10D5\u10D4\u10DC \u10D0\u10E0 \u10D2\u10D0\u10E5\u10D5\u10D7 \u10D0\u10DB \u10DB\u10DD\u10E5\u10DB\u10D4\u10D3\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10D8\u10E1 \u10E3\u10E4\u10DA\u10D4\u10D1\u10D0."
    },
    new_group_popup_error_save_text: {
        uk: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u043D\u043E\u0432\u043E\u0457 \u0433\u0440\u0443\u043F\u043F\u0438",
        en: "Error creating a new group",
        hy: "\u054D\u056D\u0561\u056C \u0576\u0578\u0580 \u056D\u0578\u0582\u0574\u0562 \u057D\u057F\u0565\u0572\u056E\u0565\u056C\u056B\u057D",
        ka: "\u10E8\u10D4\u10EA\u10D3\u10DD\u10DB\u10D0 \u10D0\u10EE\u10D0\u10DA\u10D8 \u10EF\u10D2\u10E3\u10E4\u10D8\u10E1 \u10E8\u10D4\u10E5\u10DB\u10DC\u10D8\u10E1\u10D0\u10E1"
    },
    new_group_popup_error_update_text: {
        uk: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u0433\u0440\u0443\u043F\u043F\u0438",
        en: "Error updating group",
        hy: "\u054D\u056D\u0561\u056C \u056D\u0578\u0582\u0574\u0562\u0568 \u0569\u0561\u0580\u0574\u0561\u0581\u0576\u0565\u056C\u056B\u057D",
        ka: "\u10E8\u10D4\u10EA\u10D3\u10DD\u10DB\u10D0 \u10EF\u10D2\u10E3\u10E4\u10D8\u10E1 \u10D2\u10D0\u10DC\u10D0\u10EE\u10DA\u10D4\u10D1\u10D8\u10E1\u10D0\u10E1"
    },
    new_group_popup_delete_approve_text: {
        uk: "\u0412\u0438 \u0432\u043F\u0435\u0432\u043D\u0435\u043D\u0456, \u0449\u043E \u0445\u043E\u0447\u0435\u0442\u0435 \u0432\u0438\u0434\u0430\u043B\u0438\u0442\u0438?",
        en: "Are you sure you want to delete?",
        hy: "\u0540\u0561\u0574\u0578\u0566\u057E\u0561\u056E \u0565\u0584, \u0578\u0580 \u0578\u0582\u0566\u0578\u0582\u0574 \u0565\u0584 \u057B\u0576\u057B\u0565\u056C?",
        ka: "\u10D3\u10D0\u10E0\u10EC\u10DB\u10E3\u10DC\u10D4\u10D1\u10E3\u10DA\u10D8 \u10EE\u10D0\u10E0\u10D7, \u10E0\u10DD\u10DB \u10D2\u10E1\u10E3\u10E0\u10D7 \u10EC\u10D0\u10E8\u10DA\u10D0?"
    },
    new_group_popup_btn_save_name: {
        uk: "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438",
        en: "Save",
        hy: "\u054A\u0561\u0570\u057A\u0561\u0576\u0565\u056C",
        ka: "\u10E8\u10D4\u10DC\u10D0\u10EE\u10D5\u10D0"
    },
    no_group_found_msg: {
        uk: "\u0416\u043E\u0434\u043D\u0430 \u0433\u0440\u0443\u043F\u0430 \u043D\u0435 \u0437\u043D\u0430\u0438\u0306\u0434\u0435\u043D\u0430",
        en: "No group found",
        hy: "\u053D\u0578\u0582\u0574\u0562 \u0579\u056B \u0563\u057F\u0576\u057E\u0565\u056C",
        ka: "\u10EF\u10D2\u10E3\u10E4\u10D8 \u10D0\u10E0 \u10DB\u10DD\u10D8\u10EB\u10D4\u10D1\u10DC\u10D0"
    },
    selected_point_row_has_error: {
        uk: "\u041F\u0440\u0438 \u0432\u0438\u0431\u043E\u0440\u0456 \u0442\u043E\u0447\u043A\u0438 \u0432\u0438\u043D\u0438\u043A\u043B\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430",
        en: "An error occurred while selecting the point",
        hy: "\u053F\u0565\u057F\u0568 \u0568\u0576\u057F\u0580\u0565\u056C\u056B\u057D \u057D\u056D\u0561\u056C \u057F\u0565\u0572\u056B \u0578\u0582\u0576\u0565\u0581\u0561\u057E",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8\u10E1 \u10D0\u10E0\u10E9\u10D4\u10D5\u10D8\u10E1\u10D0\u10E1 \u10DB\u10DD\u10EE\u10D3\u10D0 \u10E8\u10D4\u10EA\u10D3\u10DD\u10DB\u10D0"
    },
    file_successfully_uploaded: {
        uk: "\u0424\u0430\u0439\u043B \u0443\u0441\u043F\u0456\u0448\u043D\u043E \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u0438\u0439",
        en: "File Successfully Uploaded",
        hy: "\u0556\u0561\u0575\u056C\u0568 \u0570\u0561\u057B\u0578\u0572\u0578\u0582\u0569\u0575\u0561\u0574\u0562 \u057E\u0565\u0580\u0562\u0565\u057C\u0576\u057E\u0565\u0581",
        ka: "\u10E4\u10D0\u10D8\u10DA\u10D8 \u10EC\u10D0\u10E0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D8\u10D7 \u10D0\u10D8\u10E2\u10D5\u10D8\u10E0\u10D7\u10D0"
    },
    file_error_uploaded: {
        uk: "\u0412\u0438\u043D\u0438\u043A\u043B\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430 \u043F\u0440\u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u0446\u0456 \u0444\u0430\u0439\u043B\u0430",
        en: "An error occurred while loading the file.",
        hy: "\u0556\u0561\u0575\u056C\u0568 \u0562\u0565\u057C\u0576\u0565\u056C\u056B\u057D \u057D\u056D\u0561\u056C \u057F\u0565\u0572\u056B \u0578\u0582\u0576\u0565\u0581\u0561\u057E\u0589",
        ka: "\u10E4\u10D0\u10D8\u10DA\u10D8\u10E1 \u10E9\u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D8\u10E1\u10D0\u10E1 \u10DB\u10DD\u10EE\u10D3\u10D0 \u10E8\u10D4\u10EA\u10D3\u10DD\u10DB\u10D0."
    },
    import_group_dragdrop_label: {
        uk: "\u041A\u043B\u0456\u043A\u043D\u0456\u0442\u044C \u0430\u0431\u043E \u043F\u0435\u0440\u0435\u0442\u044F\u0433\u043D\u0456\u0442\u044C \u0444\u0430\u0439\u043B \u0441\u044E\u0434\u0438 \u0430\u0431\u043E \u0432\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0442\u043E\u0440\u0433\u043E\u0432\u0456 \u0442\u043E\u0447\u043A\u0438 \u0437\u0456 \u0441\u043F\u0438\u0441\u043A\u0443",
        en: "Click or drag the file here or select the trade points from the list",
        hy: "\u054D\u0565\u0572\u0574\u0565\u0584 \u056F\u0561\u0574 \u0584\u0561\u0577\u0565\u0584 \u0586\u0561\u0575\u056C\u0568 \u0561\u0575\u057D\u057F\u0565\u0572, \u056F\u0561\u0574 \u0568\u0576\u057F\u0580\u0565\u0584 \u0561\u057C\u0587\u057F\u0580\u056B \u056F\u0565\u057F\u0565\u0580\u0568 \u0581\u0561\u0576\u056F\u056B\u0581",
        ka: "\u10D3\u10D0\u10D0\u10ED\u10D8\u10E0\u10D4\u10D7 \u10D0\u10DC \u10D2\u10D0\u10D3\u10DB\u10DD\u10D0\u10D7\u10E0\u10D8\u10D4\u10D7 \u10E4\u10D0\u10D8\u10DA\u10D8 \u10D0\u10E5, \u10D0\u10DC \u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10E1\u10D0\u10D5\u10D0\u10ED\u10E0\u10DD \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8 \u10E1\u10D8\u10D8\u10D3\u10D0\u10DC"
    },
    import_group_dragdrop_approve_file_text: {
        uk: "\u0422\u0456\u043B\u044C\u043A\u0438 .csv,.xlsx \u0444\u0430\u0439\u043B",
        en: "Only .csv,.xlsx file",
        hy: "\u0544\u056B\u0561\u0575\u0576 .csv, .xlsx \u0586\u0561\u0575\u056C",
        ka: "\u10DB\u10EE\u10DD\u10DA\u10DD\u10D3 .csv, .xlsx \u10E4\u10D0\u10D8\u10DA\u10D8"
    },
    confirm_clear_all_points_before_change: {
        uk: "\u0412\u0438 \u0434\u043E\u0434\u0430\u043B\u0438 \u0432\u0441\u0456 \u043F\u043E\u0456\u043D\u0442\u0438. \u041E\u0447\u0438\u0441\u0442\u0438\u0442\u0438 \u0441\u043F\u0438\u0441\u043E\u043A \u0442\u0430 \u043F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438? (\u041E\u041A \u2014 \u043E\u0447\u0438\u0441\u0442\u0438\u0442\u0438, \u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438 \u2014 \u0437\u0430\u043B\u0438\u0448\u0438\u0442\u0438)",
        en: "You added all points. Clear the list and proceed? (OK \u2014 clear, Cancel \u2014 keep)",
        hy: "\u0534\u0578\u0582\u0584 \u0561\u057E\u0565\u056C\u0561\u0581\u0580\u0565\u056C \u0565\u0584 \u0562\u0578\u056C\u0578\u0580 \u056F\u0565\u057F\u0565\u0580\u0568\u0589 \u0544\u0561\u0584\u0580\u0565\u056C \u0581\u0561\u0576\u056F\u0568 \u0587 \u0577\u0561\u0580\u0578\u0582\u0576\u0561\u056F\u0565\u056C\u0589 (OK \u2014 \u0574\u0561\u0584\u0580\u0565\u056C, \u0549\u0565\u0572\u0561\u0580\u056F\u0565\u056C \u2014 \u057A\u0561\u0570\u0565\u056C)",
        ka: "\u10D7\u10E5\u10D5\u10D4\u10DC \u10D3\u10D0\u10D0\u10DB\u10D0\u10E2\u10D4\u10D7 \u10E7\u10D5\u10D4\u10DA\u10D0 \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8. \u10D2\u10D0\u10D5\u10D0\u10E1\u10E3\u10E4\u10D7\u10D0\u10DD\u10D7 \u10E1\u10D8\u10D0 \u10D3\u10D0 \u10D2\u10D0\u10D5\u10D0\u10D2\u10E0\u10EB\u10D4\u10DA\u10DD\u10D7? (OK \u2014 \u10D2\u10D0\u10E1\u10E3\u10E4\u10D7\u10D0\u10D5\u10D4\u10D1\u10D0, \u10D2\u10D0\u10E3\u10E5\u10DB\u10D4\u10D1\u10D0 \u2014 \u10E8\u10D4\u10DC\u10D0\u10E0\u10E9\u10E3\u10DC\u10D4\u10D1\u10D0)"
    },
    confirm_reset_or_keep_points: {
        uk: "\u0412 \u0441\u043F\u0438\u0441\u043A\u0443 \u0454 \u0432\u0438\u0431\u0440\u0430\u043D\u0456 \u043F\u043E\u0456\u043D\u0442\u0438. \u0414\u043E\u0434\u0430\u0442\u0438 \u043D\u043E\u0432\u0456 \u0434\u043E \u0456\u0441\u043D\u0443\u044E\u0447\u0438\u0445? (\u041E\u041A \u2014 \u0434\u043E\u0434\u0430\u0442\u0438 \u0434\u043E \u0456\u0441\u043D\u0443\u044E\u0447\u0438\u0445, \u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438 \u2014 \u0441\u043A\u0438\u043D\u0443\u0442\u0438)",
        en: "Points exist in the list. Add new ones to existing? (OK \u2014 add to existing, Cancel \u2014 reset)",
        hy: "\u0551\u0561\u0576\u056F\u0578\u0582\u0574 \u056F\u0561\u0576 \u0568\u0576\u057F\u0580\u057E\u0561\u056E \u056F\u0565\u057F\u0565\u0580\u0589 \u0531\u057E\u0565\u056C\u0561\u0581\u0576\u0565\u056C \u0576\u0578\u0580\u0565\u0580\u0568 \u0563\u0578\u0575\u0578\u0582\u0569\u0575\u0578\u0582\u0576 \u0578\u0582\u0576\u0565\u0581\u0578\u0572\u0576\u0565\u0580\u056B\u0576\u0589 (OK \u2014 \u0561\u057E\u0565\u056C\u0561\u0581\u0576\u0565\u056C \u0561\u057C\u056F\u0561\u0576\u0565\u0580\u056B\u0576, \u0549\u0565\u0572\u0561\u0580\u056F\u0565\u056C \u2014 \u0566\u0580\u0578\u0575\u0561\u0581\u0576\u0565\u056C)",
        ka: "\u10E1\u10D8\u10D0\u10E8\u10D8 \u10D0\u10E0\u10E1\u10D4\u10D1\u10DD\u10D1\u10E1 \u10D0\u10E0\u10E9\u10D4\u10E3\u10DA\u10D8 \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8. \u10D3\u10D0\u10D5\u10D0\u10DB\u10D0\u10E2\u10DD\u10D7 \u10D0\u10EE\u10DA\u10D4\u10D1\u10D8 \u10D0\u10E0\u10E1\u10D4\u10D1\u10E3\u10DA\u10D4\u10D1\u10D7\u10D0\u10DC? (OK \u2014 \u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D0 \u10D0\u10E0\u10E1\u10D4\u10D1\u10E3\u10DA\u10D7\u10D0\u10DC, \u10D2\u10D0\u10E3\u10E5\u10DB\u10D4\u10D1\u10D0 \u2014 \u10D2\u10D0\u10D3\u10D0\u10E7\u10D4\u10DC\u10D4\u10D1\u10D0)"
    },
    add_to_group_btn: {
        uk: "\u0414\u043E\u0434\u0430\u0442\u0438 \u0434\u043E \u0433\u0440\u0443\u043F\u0438",
        en: "Add to group",
        hy: "\u0531\u057E\u0565\u056C\u0561\u0581\u0576\u0565\u056C \u056D\u0574\u0562\u056B\u0576",
        ka: "\u10EF\u10D2\u10E3\u10E4\u10E8\u10D8 \u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D0"
    },
    cancel_btn: {
        uk: "\u0412\u0456\u0434\u043C\u0456\u043D\u0438\u0442\u0438",
        en: "Cancel",
        hy: "\u0549\u0565\u0572\u0561\u0580\u056F\u0565\u056C",
        ka: "\u10D2\u10D0\u10E3\u10E5\u10DB\u10D4\u10D1\u10D0"
    },
    group_already_in: {
        uk: "\u0423\u0436\u0435 \u0432 \u0433\u0440\u0443\u043F\u0456:",
        en: "Already in the group:",
        hy: "\u0531\u0580\u0564\u0565\u0576 \u056D\u0574\u0562\u0578\u0582\u0574\u055D",
        ka: "\u10E3\u10D9\u10D5\u10D4 \u10EF\u10D2\u10E3\u10E4\u10E8\u10D8\u10D0:"
    },
    group_field_label: {
        uk: "\u0413\u0440\u0443\u043F\u0430",
        en: "Group",
        hy: "\u053D\u0578\u0582\u0574\u0562",
        ka: "\u10EF\u10D2\u10E3\u10E4\u10D8"
    },
    group_has_points: {
        uk: "\u0422\u043E\u0447\u043E\u043A \u0443 \u0433\u0440\u0443\u043F\u0456:",
        en: "Points in the group:",
        hy: "\u053F\u0565\u057F\u0565\u0580 \u056D\u0574\u0562\u0578\u0582\u0574\u055D",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8 \u10EF\u10D2\u10E3\u10E4\u10E8\u10D8:"
    },
    group_import_btn: {
        uk: "\u0406\u043C\u043F\u043E\u0440\u0442 \u0437 \u0444\u0430\u0439\u043B\u0443",
        en: "Import from file",
        hy: "\u0546\u0565\u0580\u0574\u0578\u0582\u056E\u0565\u056C \u0586\u0561\u0575\u056C\u056B\u0581",
        ka: "\u10D8\u10DB\u10DE\u10DD\u10E0\u10E2\u10D8 \u10E4\u10D0\u10D8\u10DA\u10D8\u10D3\u10D0\u10DC"
    },
    group_manage_link: {
        uk: "\u041A\u0435\u0440\u0443\u0432\u0430\u043D\u043D\u044F \u0433\u0440\u0443\u043F\u0430\u043C\u0438",
        en: "Manage groups",
        hy: "\u053D\u0574\u0562\u0565\u0580\u056B \u056F\u0561\u057C\u0561\u057E\u0561\u0580\u0578\u0582\u0574",
        ka: "\u10EF\u10D2\u10E3\u10E4\u10D4\u10D1\u10D8\u10E1 \u10DB\u10D0\u10E0\u10D7\u10D5\u10D0"
    },
    group_more_hidden: {
        uk: "\u0429\u0435 {n}",
        en: "{n} more",
        hy: "\u0535\u057E\u057D {n}",
        ka: "\u10D9\u10D8\u10D3\u10D4\u10D5 {n}"
    },
    group_no_points: {
        uk: "\u041D\u0435\u043C\u0430\u0454 \u0442\u043E\u0447\u043E\u043A \u0434\u043B\u044F \u0434\u043E\u0434\u0430\u0432\u0430\u043D\u043D\u044F",
        en: "No points to add",
        hy: "\u0531\u057E\u0565\u056C\u0561\u0581\u0576\u0565\u056C\u0578\u0582 \u056F\u0565\u057F\u0565\u0580 \u0579\u056F\u0561\u0576",
        ka: "\u10D3\u10D0\u10E1\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D4\u10DA\u10D8 \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1"
    },
    group_points_added: {
        uk: "\u0422\u043E\u0447\u043A\u0438 \u0434\u043E\u0434\u0430\u043D\u043E \u0434\u043E \u0433\u0440\u0443\u043F\u0438",
        en: "Points added to the group",
        hy: "\u053F\u0565\u057F\u0565\u0580\u0576 \u0561\u057E\u0565\u056C\u0561\u0581\u057E\u0565\u056C \u0565\u0576 \u056D\u0574\u0562\u056B\u0576",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8 \u10D3\u10D0\u10D4\u10DB\u10D0\u10E2\u10D0 \u10EF\u10D2\u10E3\u10E4\u10E1"
    },
    group_points_to_add: {
        uk: "\u0422\u043E\u0447\u043A\u0438 \u0434\u043B\u044F \u0434\u043E\u0434\u0430\u0432\u0430\u043D\u043D\u044F",
        en: "Points to add",
        hy: "\u0531\u057E\u0565\u056C\u0561\u0581\u057E\u0578\u0572 \u056F\u0565\u057F\u0565\u0580",
        ka: "\u10D3\u10D0\u10E1\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D4\u10DA\u10D8 \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8"
    },
    group_target_existing: {
        uk: "\u0406\u0441\u043D\u0443\u044E\u0447\u0430 \u0433\u0440\u0443\u043F\u0430",
        en: "Existing group",
        hy: "\u0531\u057C\u056F\u0561 \u056D\u0578\u0582\u0574\u0562",
        ka: "\u10D0\u10E0\u10E1\u10D4\u10D1\u10E3\u10DA\u10D8 \u10EF\u10D2\u10E3\u10E4\u10D8"
    },
    group_target_new: {
        uk: "\u041D\u043E\u0432\u0430 \u0433\u0440\u0443\u043F\u0430",
        en: "New group",
        hy: "\u0546\u0578\u0580 \u056D\u0578\u0582\u0574\u0562",
        ka: "\u10D0\u10EE\u10D0\u10DA\u10D8 \u10EF\u10D2\u10E3\u10E4\u10D8"
    }
};
const $fc3f36407bc5ec6c$export$2cbd0be658ac061c = {
    file_deleted: {
        uk: "\u0424\u0430\u0439\u043B \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u0438\u0439",
        en: "File Deleted",
        hy: "\u0556\u0561\u0575\u056C\u0568 \u057B\u0576\u057B\u057E\u0561\u056E \u0567",
        ka: "\u10E4\u10D0\u10D8\u10DA\u10D8 \u10EC\u10D0\u10E8\u10DA\u10D8\u10DA\u10D8\u10D0"
    },
    file_name_cannot_be_empty: {
        uk: "\u0406\u043C'\u044F \u0444\u0430\u0439\u043B\u0443 \u043D\u0435 \u043C\u043E\u0436\u0435 \u0431\u0443\u0442\u0438 \u043F\u0443\u0441\u0442\u0438\u043C",
        en: "File Name Cannot Be Empty",
        hy: "\u0556\u0561\u0575\u056C\u056B \u0561\u0576\u0578\u0582\u0576\u0568 \u0579\u056B \u056F\u0561\u0580\u0578\u0572 \u0564\u0561\u057F\u0561\u0580\u056F \u056C\u056B\u0576\u0565\u056C",
        ka: "\u10E4\u10D0\u10D8\u10DA\u10D8\u10E1 \u10E1\u10D0\u10EE\u10D4\u10DA\u10D8 \u10D0\u10E0 \u10E8\u10D4\u10D8\u10EB\u10DA\u10D4\u10D1\u10D0 \u10D8\u10E7\u10DD\u10E1 \u10EA\u10D0\u10E0\u10D8\u10D4\u10DA\u10D8"
    },
    need_to_add_file: {
        uk: "\u041F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u0434\u043E\u0434\u0430\u0442\u0438 \u0444\u0430\u0439\u043B",
        en: "Need to Add File",
        hy: "\u0531\u0576\u0570\u0580\u0561\u056A\u0565\u0577\u057F \u0567 \u0561\u057E\u0565\u056C\u0561\u0581\u0576\u0565\u056C \u0586\u0561\u0575\u056C",
        ka: "\u10E1\u10D0\u10ED\u10D8\u10E0\u10DD\u10D0 \u10E4\u10D0\u10D8\u10DA\u10D8\u10E1 \u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D0"
    },
    file_successfully_uploaded: {
        uk: "\u0424\u0430\u0439\u043B \u0443\u0441\u043F\u0456\u0448\u043D\u043E \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u0438\u0439",
        en: "File Successfully Uploaded",
        hy: "\u0556\u0561\u0575\u056C\u0568 \u0570\u0561\u057B\u0578\u0572\u0578\u0582\u0569\u0575\u0561\u0574\u0562 \u057E\u0565\u0580\u0562\u0565\u057C\u0576\u057E\u0565\u0581",
        ka: "\u10E4\u10D0\u10D8\u10DA\u10D8 \u10EC\u10D0\u10E0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D8\u10D7 \u10D0\u10D8\u10E2\u10D5\u10D8\u10E0\u10D7\u10D0"
    },
    add_file: {
        uk: "\u0414\u043E\u0434\u0430\u0442\u0438 \u0444\u0430\u0439\u043B",
        en: "Add File",
        hy: "\u0531\u057E\u0565\u056C\u0561\u0581\u0576\u0565\u056C \u0586\u0561\u0575\u056C",
        ka: "\u10E4\u10D0\u10D8\u10DA\u10D8\u10E1 \u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D0"
    },
    file_name: {
        uk: "\u041D\u0430\u0437\u0432\u0430 \u0444\u0430\u0439\u043B\u0443",
        en: "File Name",
        hy: "\u0556\u0561\u0575\u056C\u056B \u0561\u0576\u0578\u0582\u0576",
        ka: "\u10E4\u10D0\u10D8\u10DA\u10D8\u10E1 \u10E1\u10D0\u10EE\u10D4\u10DA\u10D8"
    },
    click_or_drag_files_here: {
        uk: "\u041A\u043B\u0456\u043A\u043D\u0456\u0442\u044C \u0430\u0431\u043E \u043F\u0435\u0440\u0435\u0442\u044F\u0433\u043D\u0456\u0442\u044C \u0444\u0430\u0439\u043B\u0438 \u0441\u044E\u0434\u0438",
        en: "Click or Drag Files Here",
        hy: "\u054D\u0565\u0572\u0574\u0565\u0584 \u056F\u0561\u0574 \u0584\u0561\u0577\u0565\u0584 \u0586\u0561\u0575\u056C\u0565\u0580\u0568 \u0561\u0575\u057D\u057F\u0565\u0572",
        ka: "\u10D3\u10D0\u10D0\u10ED\u10D8\u10E0\u10D4\u10D7 \u10D0\u10DC \u10D2\u10D0\u10D3\u10DB\u10DD\u10D0\u10D7\u10E0\u10D8\u10D4\u10D7 \u10E4\u10D0\u10D8\u10DA\u10D4\u10D1\u10D8 \u10D0\u10E5"
    },
    download_file_btn: {
        uk: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0444\u0430\u0439\u043B",
        en: "Download File",
        hy: "\u0546\u0565\u0580\u0562\u0565\u057C\u0576\u0565\u056C \u0586\u0561\u0575\u056C\u0568",
        ka: "\u10E4\u10D0\u10D8\u10DA\u10D8\u10E1 \u10E9\u10D0\u10DB\u10DD\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D0"
    },
    creation_time: {
        uk: "\u0427\u0430\u0441 \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F",
        en: "Creation Time",
        hy: "\u054D\u057F\u0565\u0572\u056E\u0574\u0561\u0576 \u056A\u0561\u0574\u0561\u0576\u0561\u056F",
        ka: "\u10E8\u10D4\u10E5\u10DB\u10DC\u10D8\u10E1 \u10D3\u10E0\u10DD"
    },
    search: {
        uk: "\u041F\u043E\u0448\u0443\u043A",
        en: "Search",
        hy: "\u0548\u0580\u0578\u0576\u0578\u0582\u0574",
        ka: "\u10EB\u10D4\u10D1\u10DC\u10D0"
    },
    confirm_delete: {
        uk: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \xab{name}\xbb?",
        en: "Delete \u201C{name}\u201D?",
        hy: "\u054B\u0576\u057B\u0565\u055E\u056C \xab{name}\xbb-\u0568:",
        ka: "\u10EC\u10D0\u10D5\u10E8\u10D0\u10DA\u10DD \u201E{name}\u201C?"
    },
    empty_desc: {
        uk: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0442\u0435 \u043F\u0435\u0440\u0448\u0438\u0439 \u0444\u0430\u0439\u043B, \u0449\u043E\u0431 \u043F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F \u043D\u0438\u043C \u0456\u0437 \u043A\u043E\u043C\u0430\u043D\u0434\u043E\u044E",
        en: "Upload the first file to share it with your team",
        hy: "\u054E\u0565\u0580\u0562\u0565\u057C\u0576\u0565\u0584 \u0561\u057C\u0561\u057B\u056B\u0576 \u0586\u0561\u0575\u056C\u0568\u055D \u0569\u056B\u0574\u056B \u0570\u0565\u057F \u056F\u056B\u057D\u057E\u0565\u056C\u0578\u0582 \u0570\u0561\u0574\u0561\u0580",
        ka: "\u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10D4\u10D7 \u10DE\u10D8\u10E0\u10D5\u10D4\u10DA\u10D8 \u10E4\u10D0\u10D8\u10DA\u10D8, \u10E0\u10DD\u10DB \u10D2\u10D0\u10E3\u10D6\u10D8\u10D0\u10E0\u10DD\u10D7 \u10D2\u10E3\u10DC\u10D3\u10E1"
    },
    empty_search_desc: {
        uk: "\u0417\u043C\u0456\u043D\u0456\u0442\u044C \u0437\u0430\u043F\u0438\u0442 \u0430\u0431\u043E \u043E\u0447\u0438\u0441\u0442\u0456\u0442\u044C \u043F\u043E\u0448\u0443\u043A",
        en: "Change the query or clear the search",
        hy: "\u0553\u0578\u056D\u0565\u0584 \u0570\u0561\u0580\u0581\u0578\u0582\u0574\u0568 \u056F\u0561\u0574 \u0574\u0561\u0584\u0580\u0565\u0584 \u0578\u0580\u0578\u0576\u0578\u0582\u0574\u0568",
        ka: "\u10E8\u10D4\u10EA\u10D5\u10D0\u10DA\u10D4\u10D7 \u10DB\u10DD\u10D7\u10EE\u10DD\u10D5\u10DC\u10D0 \u10D0\u10DC \u10D2\u10D0\u10D0\u10E1\u10E3\u10E4\u10D7\u10D0\u10D5\u10D4\u10D7 \u10EB\u10D4\u10D1\u10DC\u10D0"
    },
    empty_search_title: {
        uk: "\u041D\u0456\u0447\u043E\u0433\u043E \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
        en: "Nothing found",
        hy: "\u0548\u0579\u056B\u0576\u0579 \u0579\u056B \u0563\u057F\u0576\u057E\u0565\u056C",
        ka: "\u10D5\u10D4\u10E0\u10D0\u10E4\u10D4\u10E0\u10D8 \u10DB\u10DD\u10D8\u10EB\u10D4\u10D1\u10DC\u10D0"
    },
    empty_title: {
        uk: "\u0424\u0430\u0439\u043B\u0456\u0432 \u0449\u0435 \u043D\u0435\u043C\u0430\u0454",
        en: "No files yet",
        hy: "\u0556\u0561\u0575\u056C\u0565\u0580 \u0564\u0565\u057C \u0579\u056F\u0561\u0576",
        ka: "\u10E4\u10D0\u10D8\u10DA\u10D4\u10D1\u10D8 \u10EF\u10D4\u10E0 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1"
    },
    f_type: {
        uk: "\u0422\u0438\u043F",
        en: "Type",
        hy: "\u054F\u056B\u057A",
        ka: "\u10E2\u10D8\u10DE\u10D8"
    },
    page_sub: {
        uk: "\u0424\u0430\u0439\u043B\u0438, \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0456 \u0432\u0430\u0448\u0456\u0439 \u043A\u043E\u043C\u0430\u043D\u0434\u0456",
        en: "Files available to your team",
        hy: "\u0541\u0565\u0580 \u0569\u056B\u0574\u056B\u0576 \u0570\u0561\u057D\u0561\u0576\u0565\u056C\u056B \u0586\u0561\u0575\u056C\u0565\u0580\u0568",
        ka: "\u10D7\u10E5\u10D5\u10D4\u10DC\u10D8 \u10D2\u10E3\u10DC\u10D3\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1 \u10EE\u10D4\u10DA\u10DB\u10D8\u10E1\u10D0\u10EC\u10D5\u10D3\u10DD\u10DB\u10D8 \u10E4\u10D0\u10D8\u10DA\u10D4\u10D1\u10D8"
    },
    search_ph: {
        uk: "\u041D\u0430\u0437\u0432\u0430 \u0444\u0430\u0439\u043B\u0443",
        en: "File name",
        hy: "\u0556\u0561\u0575\u056C\u056B \u0561\u0576\u0578\u0582\u0576",
        ka: "\u10E4\u10D0\u10D8\u10DA\u10D8\u10E1 \u10E1\u10D0\u10EE\u10D4\u10DA\u10D8"
    }
};
const $fc3f36407bc5ec6c$export$ce86776e5caf6dd0 = {
    merchendiser: {
        uk: "\u041C\u0435\u0440\u0447\u0435\u043D\u0434\u0430\u0439\u0437\u0435\u0440",
        en: "Merchendiser",
        hy: "\u0544\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580",
        ka: "\u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D8"
    },
    responsible_supervisor: {
        uk: "\u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0430\u043B\u044C\u043D\u0438\u0439 \u0441\u0443\u043F\u0435\u0440\u0432\u0430\u0439\u0437\u0435\u0440",
        en: "Responsible supervisor",
        hy: "\u054A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0561\u057F\u0578\u0582 \u057E\u0565\u0580\u0561\u056F\u0561\u0581\u0578\u0582",
        ka: "\u10DE\u10D0\u10E1\u10E3\u10EE\u10D8\u10E1\u10DB\u10D2\u10D4\u10D1\u10D4\u10DA\u10D8 \u10E1\u10E3\u10DE\u10D4\u10E0\u10D5\u10D0\u10D8\u10D6\u10D4\u10E0\u10D8"
    },
    start_visit: {
        uk: "\u0421\u0442\u0430\u0440\u0442 \u0432\u0456\u0437\u0438\u0442\u0443",
        en: "The start of the visit",
        hy: "\u0531\u0575\u0581\u056B \u057D\u056F\u056B\u0566\u0562\u0568",
        ka: "\u10D5\u10D8\u10D6\u10D8\u10E2\u10D8\u10E1 \u10D3\u10D0\u10EC\u10E7\u10D4\u10D1\u10D0"
    },
    end_visit: {
        uk: "\u041A\u0456\u043D\u0435\u0446\u044C \u0432\u0456\u0437\u0438\u0442\u0443",
        en: "The end of the visit",
        hy: "\u0531\u0575\u0581\u056B \u0561\u057E\u0561\u0580\u057F\u0568",
        ka: "\u10D5\u10D8\u10D6\u10D8\u10E2\u10D8\u10E1 \u10D3\u10D0\u10E1\u10D0\u10E1\u10E0\u10E3\u10DA\u10D8"
    },
    comment: {
        uk: "\u041A\u043E\u043C\u0435\u043D\u0442\u0430\u0440",
        en: "Comment",
        hy: "\u0544\u0565\u056F\u0576\u0561\u0562\u0561\u0576\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10D9\u10DD\u10DB\u10D4\u10DC\u10E2\u10D0\u10E0\u10D8"
    },
    price: {
        uk: "\u0426\u0456\u043D\u0430",
        en: "Price",
        hy: "\u0533\u056B\u0576",
        ka: "\u10E4\u10D0\u10E1\u10D8"
    },
    sales_price: {
        uk: "\u0426\u0456\u043D\u0430 \u043F\u0440\u043E\u0434\u0430\u0436\u0443",
        en: "Sales price",
        hy: "\u054E\u0561\u0573\u0561\u057C\u0584\u056B \u0563\u056B\u0576",
        ka: "\u10D2\u10D0\u10E7\u10D8\u10D3\u10D5\u10D8\u10E1 \u10E4\u10D0\u10E1\u10D8"
    },
    price_monitoring: {
        uk: "\u041C\u043E\u043D\u0456\u0442\u043E\u0440\u0438\u043D\u0433 \u0446\u0456\u043D",
        en: "Price monitoring",
        hy: "\u0533\u0576\u0565\u0580\u056B \u0574\u0578\u0576\u056B\u057F\u0578\u0580\u056B\u0576\u0563",
        ka: "\u10E4\u10D0\u10E1\u10D4\u10D1\u10D8\u10E1 \u10DB\u10DD\u10DC\u10D8\u10E2\u10DD\u10E0\u10D8\u10DC\u10D2\u10D8"
    },
    approve_reject_label_block: {
        uk: "\u0421\u0442\u0430\u0442\u0443\u0441 \u0437\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u044F/\u0432\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043D\u044F",
        en: "Approval/Rejection Status",
        hy: "\u0540\u0561\u057D\u057F\u0561\u057F\u0574\u0561\u0576/\u0574\u0565\u0580\u056A\u0574\u0561\u0576 \u056F\u0561\u0580\u0563\u0561\u057E\u056B\u0573\u0561\u056F",
        ka: "\u10D3\u10D0\u10DB\u10E2\u10D9\u10D8\u10EA\u10D4\u10D1\u10D8\u10E1/\u10E3\u10D9\u10E3\u10E5\u10EA\u10D4\u10D5\u10D8\u10E1 \u10E1\u10E2\u10D0\u10E2\u10E3\u10E1\u10D8"
    },
    approv_btn: {
        uk: "\u0417\u0430\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438",
        en: "Approve",
        hy: "\u0540\u0561\u057D\u057F\u0561\u057F\u0565\u056C",
        ka: "\u10D3\u10D0\u10DB\u10E2\u10D9\u10D8\u10EA\u10D4\u10D1\u10D0"
    },
    reject_btn: {
        uk: "\u0412\u0456\u0434\u0445\u0438\u043B\u0438\u0442\u0438",
        en: "Reject",
        hy: "\u0544\u0565\u0580\u056A\u0565\u056C",
        ka: "\u10E3\u10D9\u10E3\u10E5\u10EA\u10D4\u10D5\u10D0"
    },
    approved_by: {
        uk: "\u0417\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043E",
        en: "Approved by",
        hy: "\u0540\u0561\u057D\u057F\u0561\u057F\u057E\u0561\u056E \u0567\u055D",
        ka: "\u10D3\u10D0\u10DB\u10E2\u10D9\u10D8\u10EA\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0"
    },
    rejected_by: {
        uk: "\u0412\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043E",
        en: "Rejected by",
        hy: "\u0544\u0565\u0580\u056A\u057E\u0561\u056E \u0567\u055D",
        ka: "\u10E3\u10D9\u10E3\u10E5\u10EA\u10D4\u10E3\u10DA\u10D8\u10D0"
    },
    app_reject_date: {
        uk: "\u0414\u0430\u0442\u0430",
        en: "Date",
        hy: "\u0531\u0574\u057D\u0561\u0569\u056B\u057E",
        ka: "\u10D7\u10D0\u10E0\u10D8\u10E6\u10D8"
    },
    answer: {
        uk: "\u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u044C",
        en: "Answer",
        hy: "\u054A\u0561\u057F\u0561\u057D\u056D\u0561\u0576",
        ka: "\u10DE\u10D0\u10E1\u10E3\u10EE\u10D8"
    },
    linkedTasks: {
        uk: "\u041F\u043E\u0432\u044F\u0437\u0430\u043D\u0456 \u0437\u0430\u0434\u0430\u0447\u0456",
        en: "Linked tasks",
        hy: "\u053F\u0561\u057A\u0561\u056F\u0581\u057E\u0561\u056E \u0561\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0576\u0565\u0580",
        ka: "\u10D3\u10D0\u10D9\u10D0\u10D5\u10E8\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8 \u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8"
    },
    linkedVisit: {
        uk: "\u0412\u0456\u0437\u0438\u0442",
        en: "Visit",
        hy: "\u0531\u0575\u0581",
        ka: "\u10D5\u10D8\u10D6\u10D8\u10E2\u10D8"
    },
    description: {
        uk: "\u041E\u043F\u0438\u0441",
        en: "Description",
        hy: "\u0546\u056F\u0561\u0580\u0561\u0563\u0580\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10D0\u10E6\u10EC\u10D4\u10E0\u10D0"
    },
    yes: {
        uk: "\u0422\u0430\u043A",
        en: "Yes",
        hy: "\u0531\u0575\u0578",
        ka: "\u10D3\u10D8\u10D0\u10EE"
    },
    no: {
        uk: "\u041D\u0456",
        en: "No",
        hy: "\u0548\u0579",
        ka: "\u10D0\u10E0\u10D0"
    },
    created_by: {
        uk: "\u041A\u0438\u043C \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043E",
        en: "Created by",
        hy: "\u054D\u057F\u0565\u0572\u056E\u057E\u0561\u056E \u0567\u055D",
        ka: "\u10E8\u10D4\u10E5\u10DB\u10DC\u10D8\u10DA\u10D8\u10D0"
    },
    priority: {
        uk: "\u041F\u0440\u0456\u043E\u0440\u0456\u0442\u0435\u0442",
        en: "Priority",
        hy: "\u0531\u057C\u0561\u057B\u0576\u0561\u0570\u0565\u0580\u0569\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10DE\u10E0\u10D8\u10DD\u10E0\u10D8\u10E2\u10D4\u10E2\u10D8"
    },
    status: {
        uk: "\u0421\u0442\u0430\u0442\u0443\u0441",
        en: "Status",
        hy: "\u053F\u0561\u0580\u0563\u0561\u057E\u056B\u0573\u0561\u056F",
        ka: "\u10E1\u10E2\u10D0\u10E2\u10E3\u10E1\u10D8"
    },
    approved: {
        uk: "\u0417\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043E",
        en: "Approved",
        hy: "\u0540\u0561\u057D\u057F\u0561\u057F\u057E\u0561\u056E",
        ka: "\u10D3\u10D0\u10DB\u10E2\u10D9\u10D8\u10EA\u10D4\u10D1\u10E3\u10DA\u10D8"
    },
    rejected: {
        uk: "\u0412\u0456\u0434\u0445\u0456\u043B\u0435\u043D\u043E",
        en: "Rejected",
        hy: "\u0544\u0565\u0580\u056A\u057E\u0561\u056E",
        ka: "\u10E3\u10D9\u10E3\u10E5\u10EA\u10D4\u10E3\u10DA\u10D8"
    }
};
const $fc3f36407bc5ec6c$export$b8441a9a81ffc5d6 = {
    load_failed: {
        uk: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0444\u043E\u0442\u043E\u0437\u0432\u0456\u0442\u0438",
        en: "Could not load the photo reports",
        hy: "\u0549\u0570\u0561\u057B\u0578\u0572\u057E\u0565\u0581 \u0562\u0565\u057C\u0576\u0565\u056C \u056C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580\u0576\u0565\u0580\u056B \u0570\u0561\u0577\u057E\u0565\u057F\u057E\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580\u0568",
        ka: "\u10E4\u10DD\u10E2\u10DD\u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10D4\u10D1\u10D8\u10E1 \u10E9\u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D0 \u10D5\u10D4\u10E0 \u10DB\u10DD\u10EE\u10D4\u10E0\u10EE\u10D3\u10D0"
    },
    status_all: {
        uk: "\u0423\u0441\u0456",
        en: "All",
        hy: "\u0532\u0578\u056C\u0578\u0580\u0568",
        ka: "\u10E7\u10D5\u10D4\u10DA\u10D0"
    },
    status_pending: {
        uk: "\u041D\u0430 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0446\u0456",
        en: "On verification",
        hy: "\u054D\u057F\u0578\u0582\u0563\u0574\u0561\u0576 \u0583\u0578\u0582\u056C\u0578\u0582\u0574",
        ka: "\u10E8\u10D4\u10DB\u10DD\u10EC\u10DB\u10D4\u10D1\u10D0\u10D6\u10D4"
    },
    status_approved: {
        uk: "\u0417\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043E",
        en: "Approved",
        hy: "\u0540\u0561\u057D\u057F\u0561\u057F\u057E\u0561\u056E",
        ka: "\u10D3\u10D0\u10DB\u10E2\u10D9\u10D8\u10EA\u10D4\u10D1\u10E3\u10DA\u10D8"
    },
    status_rejected: {
        uk: "\u041D\u0435 \u0437\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043E",
        en: "Not approved",
        hy: "\u0549\u0570\u0561\u057D\u057F\u0561\u057F\u057E\u0561\u056E",
        ka: "\u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1 \u10D3\u10D0\u10DB\u10E2\u10D9\u10D8\u10EA\u10D4\u10D1\u10E3\u10DA\u10D8"
    },
    records_count: {
        uk: "\u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C \u0437\u0430\u043F\u0438\u0441\u0456\u0432",
        en: "Records count",
        hy: "\u0533\u0580\u0561\u057C\u0578\u0582\u0574\u0576\u0565\u0580\u056B \u0584\u0561\u0576\u0561\u056F\u0568",
        ka: "\u10E9\u10D0\u10DC\u10D0\u10EC\u10D4\u10E0\u10D4\u10D1\u10D8\u10E1 \u10E0\u10D0\u10DD\u10D3\u10D4\u10DC\u10DD\u10D1\u10D0"
    },
    select_all: {
        uk: "\u0412\u0438\u0431\u0440\u0430\u0442\u0438 \u0432\u0441\u0456",
        en: "Select all",
        hy: "\u0538\u0576\u057F\u0580\u0565\u056C \u0562\u0578\u056C\u0578\u0580\u0568",
        ka: "\u10E7\u10D5\u10D4\u10DA\u10D0\u10E1 \u10DB\u10DD\u10DC\u10D8\u10E8\u10D5\u10DC\u10D0"
    },
    clear_selection: {
        uk: "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u0438",
        en: "Clear",
        hy: "\u0544\u0561\u0584\u0580\u0565\u056C",
        ka: "\u10D2\u10D0\u10E1\u10E3\u10E4\u10D7\u10D0\u10D5\u10D4\u10D1\u10D0"
    },
    w_selected: {
        uk: "\u0412\u0438\u0431\u0440\u0430\u043D\u043E: {n}",
        en: "{n} selected",
        hy: "\u0538\u0576\u057F\u0580\u057E\u0561\u056E \u0567\u055D {n}",
        ka: "\u10DB\u10DD\u10DC\u10D8\u10E8\u10DC\u10E3\u10DA\u10D8\u10D0: {n}"
    },
    w_position: {
        uk: "{i} \u0437 {n}",
        en: "{i} of {n}",
        hy: "{i} / {n}",
        ka: "{i} / {n}"
    },
    photos_label: {
        uk: "\u0424\u043E\u0442\u043E",
        en: "Photos",
        hy: "\u053C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580\u0576\u0565\u0580",
        ka: "\u10E4\u10DD\u10E2\u10DD\u10D4\u10D1\u10D8"
    },
    empty_title: {
        uk: "\u041D\u0435\u043C\u0430\u0454 \u0444\u043E\u0442\u043E \u0437\u0430 \u0446\u0438\u043C\u0438 \u0444\u0456\u043B\u044C\u0442\u0440\u0430\u043C\u0438",
        en: "No photos match these filters",
        hy: "\u0531\u0575\u057D \u0566\u057F\u056B\u0579\u0576\u0565\u0580\u0578\u057E \u056C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580\u0576\u0565\u0580 \u0579\u056F\u0561\u0576",
        ka: "\u10D0\u10DB \u10E4\u10D8\u10DA\u10E2\u10E0\u10D4\u10D1\u10D8\u10D7 \u10E4\u10DD\u10E2\u10DD\u10D4\u10D1\u10D8 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1"
    },
    empty_desc: {
        uk: "\u0421\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0440\u043E\u0437\u0448\u0438\u0440\u0438\u0442\u0438 \u043F\u0435\u0440\u0456\u043E\u0434 \u0430\u0431\u043E \u0437\u043D\u044F\u0442\u0438 \u0447\u0430\u0441\u0442\u0438\u043D\u0443 \u0444\u0456\u043B\u044C\u0442\u0440\u0456\u0432.",
        en: "Try widening the date range or clearing some filters.",
        hy: "\u0553\u0578\u0580\u0571\u0565\u0584 \u0568\u0576\u0564\u056C\u0561\u0575\u0576\u0565\u056C \u056A\u0561\u0574\u0561\u0576\u0561\u056F\u0561\u0570\u0561\u057F\u057E\u0561\u056E\u0568 \u056F\u0561\u0574 \u0570\u0565\u057C\u0561\u0581\u0576\u0565\u056C \u0578\u0580\u0578\u0577 \u0566\u057F\u056B\u0579\u0576\u0565\u0580\u0589",
        ka: "\u10E1\u10EA\u10D0\u10D3\u10D4\u10D7 \u10DE\u10D4\u10E0\u10D8\u10DD\u10D3\u10D8\u10E1 \u10D2\u10D0\u10E4\u10D0\u10E0\u10D7\u10DD\u10D4\u10D1\u10D0 \u10D0\u10DC \u10DC\u10D0\u10EC\u10D8\u10DA\u10D8 \u10E4\u10D8\u10DA\u10E2\u10E0\u10D4\u10D1\u10D8\u10E1 \u10DB\u10DD\u10EE\u10E1\u10DC\u10D0."
    },
    load_more: {
        uk: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0449\u0435",
        en: "Load more",
        hy: "\u0532\u0565\u057C\u0576\u0565\u056C \u0587\u057D",
        ka: "\u10DB\u10D4\u10E2\u10D8\u10E1 \u10E9\u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D0"
    },
    review_title: {
        uk: "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u0434 \u0444\u043E\u0442\u043E",
        en: "Photo review",
        hy: "\u053C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580\u056B \u057D\u057F\u0578\u0582\u0563\u0578\u0582\u0574",
        ka: "\u10E4\u10DD\u10E2\u10DD\u10E1 \u10D2\u10D0\u10DC\u10EE\u10D8\u10DA\u10D5\u10D0"
    },
    no_photo: {
        uk: "\u041D\u0435\u043C\u0430\u0454 \u0444\u043E\u0442\u043E",
        en: "No photo",
        hy: "\u053C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580 \u0579\u056F\u0561",
        ka: "\u10E4\u10DD\u10E2\u10DD \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1"
    },
    period: {
        uk: "\u041F\u0435\u0440\u0456\u043E\u0434",
        en: "Period",
        hy: "\u053A\u0561\u0574\u0561\u0576\u0561\u056F\u0561\u0570\u0561\u057F\u057E\u0561\u056E",
        ka: "\u10DE\u10D4\u10E0\u10D8\u10DD\u10D3\u10D8"
    },
    kbd_hint: {
        uk: "\u2190 \u2192 \u043F\u0435\u0440\u0435\u0445\u0456\u0434 \xb7 A \u0437\u0430\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438 \xb7 R \u0432\u0456\u0434\u0445\u0438\u043B\u0438\u0442\u0438 \xb7 Esc \u0437\u0430\u043A\u0440\u0438\u0442\u0438",
        en: "\u2190 \u2192 to move \xb7 A approve \xb7 R reject \xb7 Esc to close",
        hy: "\u2190 \u2192 \u057F\u0565\u0572\u0561\u0583\u0578\u056D\u0578\u0582\u0574 \xb7 A \u0570\u0561\u057D\u057F\u0561\u057F\u0565\u056C \xb7 R \u0574\u0565\u0580\u056A\u0565\u056C \xb7 Esc \u0583\u0561\u056F\u0565\u056C",
        ka: "\u2190 \u2192 \u10D2\u10D0\u10D3\u10D0\u10D0\u10D3\u10D2\u10D8\u10DA\u10D4\u10D1\u10D0 \xb7 A \u10D3\u10D0\u10DB\u10E2\u10D9\u10D8\u10EA\u10D4\u10D1\u10D0 \xb7 R \u10E3\u10D9\u10E3\u10E5\u10EA\u10D4\u10D5\u10D0 \xb7 Esc \u10D3\u10D0\u10EE\u10E3\u10E0\u10D5\u10D0"
    },
    filter_saved_msg: {
        uk: "\u0424\u0456\u043B\u044C\u0442\u0440 \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043E",
        en: "The filter is saved",
        hy: "\u0536\u057F\u056B\u0579\u0568 \u057A\u0561\u0570\u057A\u0561\u0576\u057E\u0561\u056E \u0567",
        ka: "\u10E4\u10D8\u10DA\u10E2\u10E0\u10D8 \u10E8\u10D4\u10DC\u10D0\u10EE\u10E3\u10DA\u10D8\u10D0"
    },
    print_hint: {
        uk: "\u0414\u0440\u0443\u043A \u043F\u043E\u0442\u043E\u0447\u043D\u043E\u0457 \u0432\u0438\u0431\u0456\u0440\u043A\u0438",
        en: "Print the current selection",
        hy: "\u054F\u057A\u0565\u056C \u0568\u0576\u0569\u0561\u0581\u056B\u056F \u0568\u0576\u057F\u0580\u0561\u0576\u0584\u0568",
        ka: "\u10DB\u10D8\u10DB\u10D3\u10D8\u10DC\u10D0\u10E0\u10D4 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8\u10E1 \u10D1\u10D4\u10ED\u10D3\u10D5\u10D0"
    },
    a_prev: {
        uk: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u0456\u0439 \u0437\u0432\u0456\u0442",
        en: "Previous report",
        hy: "\u0546\u0561\u056D\u0578\u0580\u0564 \u0570\u0561\u0577\u057E\u0565\u057F\u057E\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0568",
        ka: "\u10EC\u10D8\u10DC\u10D0 \u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10D8"
    },
    a_next: {
        uk: "\u041D\u0430\u0441\u0442\u0443\u043F\u043D\u0438\u0439 \u0437\u0432\u0456\u0442",
        en: "Next report",
        hy: "\u0540\u0561\u057B\u0578\u0580\u0564 \u0570\u0561\u0577\u057E\u0565\u057F\u057E\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0568",
        ka: "\u10E8\u10D4\u10DB\u10D3\u10D4\u10D2\u10D8 \u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10D8"
    },
    a_close: {
        uk: "\u0417\u0430\u043A\u0440\u0438\u0442\u0438",
        en: "Close",
        hy: "\u0553\u0561\u056F\u0565\u056C",
        ka: "\u10D3\u10D0\u10EE\u10E3\u10E0\u10D5\u10D0"
    },
    a_select: {
        uk: "\u0412\u0438\u0431\u0440\u0430\u0442\u0438",
        en: "Select",
        hy: "\u0538\u0576\u057F\u0580\u0565\u056C",
        ka: "\u10DB\u10DD\u10DC\u10D8\u10E8\u10D5\u10DC\u10D0"
    },
    a_prev_photo: {
        uk: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u0454 \u0444\u043E\u0442\u043E",
        en: "Previous photo",
        hy: "\u0546\u0561\u056D\u0578\u0580\u0564 \u056C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580\u0568",
        ka: "\u10EC\u10D8\u10DC\u10D0 \u10E4\u10DD\u10E2\u10DD"
    },
    a_next_photo: {
        uk: "\u041D\u0430\u0441\u0442\u0443\u043F\u043D\u0435 \u0444\u043E\u0442\u043E",
        en: "Next photo",
        hy: "\u0540\u0561\u057B\u0578\u0580\u0564 \u056C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580\u0568",
        ka: "\u10E8\u10D4\u10DB\u10D3\u10D4\u10D2\u10D8 \u10E4\u10DD\u10E2\u10DD"
    },
    a_photo_n: {
        uk: "\u0424\u043E\u0442\u043E {n}",
        en: "Photo {n}",
        hy: "\u053C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580 {n}",
        ka: "\u10E4\u10DD\u10E2\u10DD {n}"
    },
    a_remove_filter: {
        uk: "\u0417\u043D\u044F\u0442\u0438 \u0444\u0456\u043B\u044C\u0442\u0440",
        en: "Remove filter",
        hy: "\u0540\u0565\u057C\u0561\u0581\u0576\u0565\u056C \u0566\u057F\u056B\u0579\u0568",
        ka: "\u10E4\u10D8\u10DA\u10E2\u10E0\u10D8\u10E1 \u10DB\u10DD\u10EE\u10E1\u10DC\u10D0"
    },
    annot_clear: {
        uk: "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u0438",
        en: "Clear",
        hy: "\u0544\u0561\u0584\u0580\u0565\u056C",
        ka: "\u10D2\u10D0\u10E1\u10E3\u10E4\u10D7\u10D0\u10D5\u10D4\u10D1\u10D0"
    },
    annot_colour: {
        uk: "\u041A\u043E\u043B\u0456\u0440",
        en: "Colour",
        hy: "\u0533\u0578\u0582\u0575\u0576",
        ka: "\u10E4\u10D4\u10E0\u10D8"
    },
    annot_fit: {
        uk: "\u0412\u043C\u0456\u0441\u0442\u0438\u0442\u0438",
        en: "Fit",
        hy: "\u054F\u0565\u0572\u0561\u057E\u0578\u0580\u0565\u056C",
        ka: "\u10DB\u10DD\u10E0\u10D2\u10D4\u10D1\u10D0"
    },
    annot_hint: {
        uk: "\u041F\u0440\u043E\u043A\u0440\u0443\u0447\u0443\u0432\u0430\u043D\u043D\u044F \u2014 \u043C\u0430\u0441\u0448\u0442\u0430\u0431, \u043F\u043E\u0434\u0432\u0456\u0439\u043D\u0435 \u043A\u043B\u0430\u0446\u0430\u043D\u043D\u044F \u043F\u043E \xab\u0412\u043C\u0456\u0441\u0442\u0438\u0442\u0438\xbb \u2014 \u0441\u043A\u0438\u043D\u0443\u0442\u0438",
        en: "Scroll to zoom, Fit to reset the view",
        hy: "\u0548\u056C\u0578\u0580\u0578\u0582\u0574\u0568\u055D \u0574\u0561\u057D\u0577\u057F\u0561\u0562, \xab\u054F\u0565\u0572\u0561\u057E\u0578\u0580\u0565\u056C\xbb\u055D \u057E\u0565\u0580\u0561\u056F\u0561\u0576\u0563\u0576\u0565\u056C \u057F\u0565\u057D\u0584\u0568",
        ka: "\u10E1\u10E5\u10E0\u10DD\u10DA\u10D8 \u2014 \u10DB\u10D0\u10E1\u10E8\u10E2\u10D0\u10D1\u10D8, \xab\u10DB\u10DD\u10E0\u10D2\u10D4\u10D1\u10D0\xbb \u2014 \u10EE\u10D4\u10D3\u10D8\u10E1 \u10D3\u10D0\u10D1\u10E0\u10E3\u10DC\u10D4\u10D1\u10D0"
    },
    annot_text_hint: {
        uk: "\u0422\u0435\u043A\u0441\u0442, Enter \u2014 \u0434\u043E\u0434\u0430\u0442\u0438",
        en: "Text, Enter to add",
        hy: "\u054F\u0565\u0584\u057D\u057F, Enter\u055D \u0561\u057E\u0565\u056C\u0561\u0581\u0576\u0565\u056C",
        ka: "\u10E2\u10D4\u10E5\u10E1\u10E2\u10D8, Enter \u2014 \u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D0"
    },
    annot_unavailable: {
        uk: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0444\u043E\u0442\u043E \u0434\u043B\u044F \u0440\u043E\u0437\u043C\u0456\u0442\u043A\u0438. \u0414\u043E\u0440\u0443\u0447\u0435\u043D\u043D\u044F \u043C\u043E\u0436\u043D\u0430 \u0441\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u0431\u0435\u0437 \u043D\u0435\u0457.",
        en: "The photo could not be loaded for markup. The task can still be created without it.",
        hy: "\u0549\u0570\u0561\u057B\u0578\u0572\u057E\u0565\u0581 \u0562\u0565\u057C\u0576\u0565\u056C \u056C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580\u0568 \u0576\u0577\u0578\u0582\u0574\u0576\u0565\u0580\u056B \u0570\u0561\u0574\u0561\u0580\u0589 \u0540\u0561\u0576\u0571\u0576\u0561\u0580\u0561\u0580\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0568 \u056F\u0561\u0580\u0565\u056C\u056B \u0567 \u057D\u057F\u0565\u0572\u056E\u0565\u056C \u0561\u057C\u0561\u0576\u0581 \u0564\u0580\u0561\u0589",
        ka: "\u10E4\u10DD\u10E2\u10DD\u10E1 \u10E9\u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D0 \u10D5\u10D4\u10E0 \u10DB\u10DD\u10EE\u10D4\u10E0\u10EE\u10D3\u10D0 \u10DB\u10DD\u10DC\u10D8\u10E8\u10D5\u10DC\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1. \u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10E5\u10DB\u10DC\u10D0 \u10DB\u10D0\u10D8\u10DC\u10EA \u10E8\u10D4\u10E1\u10D0\u10EB\u10DA\u10D4\u10D1\u10D4\u10DA\u10D8\u10D0."
    },
    annot_undo: {
        uk: "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438",
        en: "Undo",
        hy: "\u0540\u0565\u057F\u0561\u0580\u056F\u0565\u056C",
        ka: "\u10D3\u10D0\u10D1\u10E0\u10E3\u10DC\u10D4\u10D1\u10D0"
    },
    annot_weight: {
        uk: "\u0422\u043E\u0432\u0449\u0438\u043D\u0430",
        en: "Stroke weight",
        hy: "\u0540\u0561\u057D\u057F\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10E1\u10D8\u10E1\u10E5\u10D4"
    },
    search: {
        uk: "\u041F\u043E\u0448\u0443\u043A",
        en: "Search",
        hy: "\u0548\u0580\u0578\u0576\u0578\u0582\u0574",
        ka: "\u10EB\u10D4\u10D1\u10DC\u10D0"
    },
    a_zoom_in: {
        uk: "\u0417\u0431\u0456\u043B\u044C\u0448\u0438\u0442\u0438",
        en: "Zoom in",
        hy: "\u0544\u0565\u056E\u0561\u0581\u0576\u0565\u056C",
        ka: "\u10D2\u10D0\u10D3\u10D8\u10D3\u10D4\u10D1\u10D0"
    },
    a_zoom_out: {
        uk: "\u0417\u043C\u0435\u043D\u0448\u0438\u0442\u0438",
        en: "Zoom out",
        hy: "\u0553\u0578\u0584\u0580\u0561\u0581\u0576\u0565\u056C",
        ka: "\u10D3\u10D0\u10DE\u10D0\u10E2\u10D0\u10E0\u10D0\u10D5\u10D4\u10D1\u10D0"
    },
    a_zoom_reset: {
        uk: "\u0412\u0438\u0445\u0456\u0434\u043D\u0438\u0439 \u0440\u043E\u0437\u043C\u0456\u0440",
        en: "Reset zoom",
        hy: "\u054E\u0565\u0580\u0561\u056F\u0561\u0576\u0563\u0576\u0565\u056C \u0579\u0561\u0583\u0568",
        ka: "\u10D6\u10DD\u10DB\u10D8\u10E1 \u10D3\u10D0\u10D1\u10E0\u10E3\u10DC\u10D4\u10D1\u10D0"
    },
    a_open_image: {
        uk: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u0444\u043E\u0442\u043E \u0432 \u043D\u043E\u0432\u0456\u0439 \u0432\u043A\u043B\u0430\u0434\u0446\u0456",
        en: "Open photo in a new tab",
        hy: "\u0532\u0561\u0581\u0565\u056C \u056C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580\u0568 \u0576\u0578\u0580 \u0576\u0565\u0580\u0564\u056B\u0580\u0578\u0582\u0574",
        ka: "\u10E4\u10DD\u10E2\u10DD\u10E1 \u10D2\u10D0\u10EE\u10E1\u10DC\u10D0 \u10D0\u10EE\u10D0\u10DA \u10E9\u10D0\u10DC\u10D0\u10E0\u10D7\u10E8\u10D8"
    },
    a_copy_image_link: {
        uk: "\u041A\u043E\u043F\u0456\u044E\u0432\u0430\u0442\u0438 \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u043D\u0430 \u0444\u043E\u0442\u043E",
        en: "Copy photo link",
        hy: "\u054A\u0561\u057F\u0573\u0565\u0576\u0565\u056C \u056C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580\u056B \u0570\u0572\u0578\u0582\u0574\u0568",
        ka: "\u10E4\u10DD\u10E2\u10DD\u10E1 \u10D1\u10DB\u10E3\u10DA\u10D8\u10E1 \u10D9\u10DD\u10DE\u10D8\u10E0\u10D4\u10D1\u10D0"
    },
    link_copied: {
        uk: "\u041F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u0441\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u043E",
        en: "Link copied",
        hy: "\u0540\u0572\u0578\u0582\u0574\u0568 \u057A\u0561\u057F\u0573\u0565\u0576\u057E\u0565\u0581",
        ka: "\u10D1\u10DB\u10E3\u10DA\u10D8 \u10D3\u10D0\u10D9\u10DD\u10DE\u10D8\u10E0\u10D3\u10D0"
    },
    link_copy_failed: {
        uk: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0441\u043A\u043E\u043F\u0456\u044E\u0432\u0430\u0442\u0438 \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F",
        en: "Could not copy the link",
        hy: "\u0549\u0570\u0561\u057B\u0578\u0572\u057E\u0565\u0581 \u057A\u0561\u057F\u0573\u0565\u0576\u0565\u056C \u0570\u0572\u0578\u0582\u0574\u0568",
        ka: "\u10D1\u10DB\u10E3\u10DA\u10D8\u10E1 \u10D9\u10DD\u10DE\u10D8\u10E0\u10D4\u10D1\u10D0 \u10D5\u10D4\u10E0 \u10DB\u10DD\u10EE\u10D4\u10E0\u10EE\u10D3\u10D0"
    },
    annot_arrow: {
        uk: "\u0421\u0442\u0440\u0456\u043B\u043A\u0430",
        en: "Arrow",
        hy: "\u054D\u056C\u0561\u0584",
        ka: "\u10D8\u10E1\u10D0\u10E0\u10D8"
    },
    annot_pan: {
        uk: "\u041F\u0435\u0440\u0435\u0441\u0443\u043D\u0443\u0442\u0438",
        en: "Pan",
        hy: "\u054F\u0565\u0572\u0561\u0583\u0578\u056D\u0565\u056C",
        ka: "\u10D2\u10D0\u10D3\u10D0\u10D0\u10D3\u10D2\u10D8\u10DA\u10D4\u10D1\u10D0"
    },
    annot_pen: {
        uk: "\u041E\u043B\u0456\u0432\u0435\u0446\u044C",
        en: "Pen",
        hy: "\u0544\u0561\u057F\u056B\u057F",
        ka: "\u10D9\u10D0\u10DA\u10D0\u10DB\u10D8"
    },
    annot_rect: {
        uk: "\u041F\u0440\u044F\u043C\u043E\u043A\u0443\u0442\u043D\u0438\u043A",
        en: "Box",
        hy: "\u0548\u0582\u0572\u0572\u0561\u0576\u056F\u0575\u0578\u0582\u0576",
        ka: "\u10DB\u10D0\u10E0\u10D7\u10D9\u10E3\u10D7\u10EE\u10D4\u10D3\u10D8"
    },
    annot_text: {
        uk: "\u0422\u0435\u043A\u0441\u0442",
        en: "Text",
        hy: "\u054F\u0565\u0584\u057D\u057F",
        ka: "\u10E2\u10D4\u10E5\u10E1\u10E2\u10D8"
    },
    annot_weight_l: {
        uk: "L",
        en: "L",
        hy: "L",
        ka: "L"
    },
    annot_weight_m: {
        uk: "M",
        en: "M",
        hy: "M",
        ka: "M"
    },
    annot_weight_s: {
        uk: "S",
        en: "S",
        hy: "S",
        ka: "S"
    },
    f_all: {
        uk: "\u0423\u0441\u0456",
        en: "All",
        hy: "\u0532\u0578\u056C\u0578\u0580\u0568",
        ka: "\u10E7\u10D5\u10D4\u10DA\u10D0"
    },
    f_date: {
        uk: "\u0414\u0430\u0442\u0430",
        en: "Date",
        hy: "\u0531\u0574\u057D\u0561\u0569\u056B\u057E",
        ka: "\u10D7\u10D0\u10E0\u10D8\u10E6\u10D8"
    },
    priority_1: {
        uk: "\u041D\u0438\u0437\u044C\u043A\u0438\u0439",
        en: "Low",
        hy: "\u0551\u0561\u056E\u0580",
        ka: "\u10D3\u10D0\u10D1\u10D0\u10DA\u10D8"
    },
    priority_2: {
        uk: "\u0417\u0432\u0438\u0447\u0430\u0439\u043D\u0438\u0439",
        en: "Normal",
        hy: "\u054D\u0578\u057E\u0578\u0580\u0561\u056F\u0561\u0576",
        ka: "\u10E9\u10D5\u10D4\u10E3\u10DA\u10D4\u10D1\u10E0\u10D8\u10D5\u10D8"
    },
    priority_3: {
        uk: "\u0412\u0438\u0441\u043E\u043A\u0438\u0439",
        en: "High",
        hy: "\u0532\u0561\u0580\u0571\u0580",
        ka: "\u10DB\u10D0\u10E6\u10D0\u10DA\u10D8"
    },
    reject_done: {
        uk: "\u0424\u043E\u0442\u043E \u0432\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043E",
        en: "Photo rejected",
        hy: "\u053C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580\u0568 \u0574\u0565\u0580\u056A\u057E\u0561\u056E \u0567",
        ka: "\u10E4\u10DD\u10E2\u10DD \u10E3\u10D0\u10E0\u10E7\u10DD\u10E4\u10D8\u10DA\u10D8\u10D0"
    },
    reject_task_due: {
        uk: "\u0412\u0438\u043A\u043E\u043D\u0430\u0442\u0438 \u0434\u043E",
        en: "Due by",
        hy: "\u053F\u0561\u057F\u0561\u0580\u0565\u056C \u0574\u056B\u0576\u0579\u0587",
        ka: "\u10E8\u10D4\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10D8\u10E1 \u10D5\u10D0\u10D3\u10D0"
    },
    reject_task_for: {
        uk: "\u0414\u043B\u044F \u0442\u043E\u0447\u043A\u0438",
        en: "For point",
        hy: "\u053F\u0565\u057F\u056B \u0570\u0561\u0574\u0561\u0580",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1"
    },
    reject_task_name: {
        uk: "\u041D\u0430\u0437\u0432\u0430 \u0434\u043E\u0440\u0443\u0447\u0435\u043D\u043D\u044F",
        en: "Task name",
        hy: "\u0540\u0561\u0576\u0571\u0576\u0561\u0580\u0561\u0580\u0578\u0582\u0569\u0575\u0561\u0576 \u0561\u0576\u057E\u0561\u0576\u0578\u0582\u0574\u0568",
        ka: "\u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D8\u10E1 \u10E1\u10D0\u10EE\u10D4\u10DA\u10D8"
    },
    reject_task_priority: {
        uk: "\u041F\u0440\u0456\u043E\u0440\u0438\u0442\u0435\u0442",
        en: "Priority",
        hy: "\u0531\u057C\u0561\u057B\u0576\u0561\u0570\u0565\u0580\u0569\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10DE\u10E0\u10D8\u10DD\u10E0\u10D8\u10E2\u10D4\u10E2\u10D8"
    },
    // The form the merchandiser will be asked to fill in — what the corrective task actually is.
    reject_task_template: {
        uk: "\u0428\u0430\u0431\u043B\u043E\u043D",
        en: "Template",
        hy: "\u053F\u0561\u0572\u0561\u057A\u0561\u0580",
        ka: "\u10E8\u10D0\u10D1\u10DA\u10DD\u10DC\u10D8"
    },
    reject_task_saved_verdict_failed: {
        uk: "\u0414\u043E\u0440\u0443\u0447\u0435\u043D\u043D\u044F \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043E, \u0430\u043B\u0435 \u0432\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043D\u044F \u043D\u0435 \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043E. \u0421\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0432\u0456\u0434\u0445\u0438\u043B\u0438\u0442\u0438 \u0449\u0435 \u0440\u0430\u0437.",
        en: "The task was created, but the rejection was not saved. Try rejecting again.",
        hy: "\u0540\u0561\u0576\u0571\u0576\u0561\u0580\u0561\u0580\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0568 \u057D\u057F\u0565\u0572\u056E\u057E\u0565\u0581, \u0562\u0561\u0575\u0581 \u0574\u0565\u0580\u056A\u0578\u0582\u0574\u0568 \u0579\u057A\u0561\u0570\u057A\u0561\u0576\u057E\u0565\u0581\u0589 \u0553\u0578\u0580\u0571\u0565\u0584 \u056F\u0580\u056F\u056B\u0576 \u0574\u0565\u0580\u056A\u0565\u056C\u0589",
        ka: "\u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D0 \u10E8\u10D4\u10D8\u10E5\u10DB\u10DC\u10D0, \u10DB\u10D0\u10D2\u10E0\u10D0\u10DB \u10E3\u10D0\u10E0\u10E7\u10DD\u10E4\u10D0 \u10D5\u10D4\u10E0 \u10E8\u10D4\u10D8\u10DC\u10D0\u10EE\u10D0. \u10E1\u10EA\u10D0\u10D3\u10D4\u10D7 \u10E3\u10D0\u10E0\u10E7\u10DD\u10E4\u10D0 \u10EE\u10D4\u10DA\u10D0\u10EE\u10DA\u10D0."
    },
    reject_task_submit: {
        uk: "\u0412\u0456\u0434\u0445\u0438\u043B\u0438\u0442\u0438 \u0442\u0430 \u0441\u0442\u0432\u043E\u0440\u0438\u0442\u0438",
        en: "Reject and create",
        hy: "\u0544\u0565\u0580\u056A\u0565\u056C \u0587 \u057D\u057F\u0565\u0572\u056E\u0565\u056C",
        ka: "\u10E3\u10D0\u10E0\u10E7\u10DD\u10E4\u10D0 \u10D3\u10D0 \u10E8\u10D4\u10E5\u10DB\u10DC\u10D0"
    },
    reject_task_photo_pending: {
        uk: "\u0424\u043E\u0442\u043E \u0449\u0435 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0443\u0454\u0442\u044C\u0441\u044F \u2014 \u0437\u0430\u0447\u0435\u043A\u0430\u0439\u0442\u0435 \u0430\u0431\u043E \u0432\u0456\u0434\u0445\u0438\u043B\u0456\u0442\u044C \u0431\u0435\u0437 \u0437\u0430\u0434\u0430\u0447\u0456",
        en: "The photo is still loading \u2014 wait a moment, or reject without a task",
        hy: "\u053C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580\u0568 \u0564\u0565\u057C \u0562\u0565\u057C\u0576\u057E\u0578\u0582\u0574 \u0567 \u2014 \u057D\u057A\u0561\u057D\u0565\u0584 \u056F\u0561\u0574 \u0574\u0565\u0580\u056A\u0565\u0584 \u0561\u057C\u0561\u0576\u0581 \u0561\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u056B",
        ka: "\u10E4\u10DD\u10E2\u10DD \u10EF\u10D4\u10E0 \u10D8\u10E2\u10D5\u10D8\u10E0\u10D7\u10D4\u10D1\u10D0 \u2014 \u10D3\u10D0\u10D4\u10DA\u10DD\u10D3\u10D4\u10D7 \u10D0\u10DC \u10E3\u10D0\u10E0\u10E7\u10D0\u10D5\u10D8\u10D7 \u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10E0\u10D4\u10E8\u10D4"
    },
    reject_task_title: {
        uk: "\u0412\u0456\u0434\u0445\u0438\u043B\u0438\u0442\u0438 \u0442\u0430 \u0441\u0442\u0432\u043E\u0440\u0438\u0442\u0438 \u0434\u043E\u0440\u0443\u0447\u0435\u043D\u043D\u044F",
        en: "Reject and create a task",
        hy: "\u0544\u0565\u0580\u056A\u0565\u056C \u0587 \u057D\u057F\u0565\u0572\u056E\u0565\u056C \u0570\u0561\u0576\u0571\u0576\u0561\u0580\u0561\u0580\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10E3\u10D0\u10E0\u10E7\u10DD\u10E4\u10D0 \u10D3\u10D0 \u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10E5\u10DB\u10DC\u10D0"
    },
    reject_without_task: {
        uk: "\u041B\u0438\u0448\u0435 \u0432\u0456\u0434\u0445\u0438\u043B\u0438\u0442\u0438",
        en: "Reject only",
        hy: "\u0544\u056B\u0561\u0575\u0576 \u0574\u0565\u0580\u056A\u0565\u056C",
        ka: "\u10DB\u10EE\u10DD\u10DA\u10DD\u10D3 \u10E3\u10D0\u10E0\u10E7\u10DD\u10E4\u10D0"
    }
};
const $fc3f36407bc5ec6c$export$78a94b7660ec0e3b = {
    headline: {
        uk: "\u041C\u0435\u0440\u0447\u0430\u043D\u0434\u0430\u0439\u0437\u0438\u043D\u0433\n\u043F\u0456\u0434 \u043A\u043E\u043D\u0442\u0440\u043E\u043B\u0435\u043C",
        en: "Merchandising\nunder control",
        hy: "\u0544\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u056B\u0576\u0563\u0568\n\u057E\u0565\u0580\u0561\u0570\u057D\u056F\u0578\u0572\u0578\u0582\u0569\u0575\u0561\u0576 \u057F\u0561\u056F",
        ka: "\u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D8\u10DC\u10D2\u10D8\n\u10D9\u10DD\u10DC\u10E2\u10E0\u10DD\u10DA\u10D8\u10E1 \u10E5\u10D5\u10D4\u10E8"
    },
    subhead: {
        uk: "\u041C\u0430\u0440\u0448\u0440\u0443\u0442\u0438, \u0432\u0456\u0437\u0438\u0442\u0438 \u0442\u0430 \u0444\u043E\u0442\u043E\u0437\u0432\u0456\u0442\u0438 \u2014 \u0443\u0441\u0435 \u0432 \u043E\u0434\u043D\u043E\u043C\u0443 \u043C\u0456\u0441\u0446\u0456. \u0428\u0432\u0438\u0434\u043A\u0430 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u043A\u0430, \u0447\u0456\u0442\u043A\u0456 \u0440\u0456\u0448\u0435\u043D\u043D\u044F.",
        en: "Routes, visits and photo reports \u2014 all in one place. Faster checks, clearer decisions.",
        hy: "\u0535\u0580\u0569\u0578\u0582\u0572\u056B\u0576\u0565\u0580, \u0561\u0575\u0581\u0565\u0580 \u0587 \u056C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580\u0561\u0575\u056B\u0576 \u0570\u0561\u0577\u057E\u0565\u057F\u057E\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580\u055D \u0574\u0565\u056F \u057E\u0561\u0575\u0580\u0578\u0582\u0574\u0589 \u0531\u0580\u0561\u0563 \u057D\u057F\u0578\u0582\u0563\u0578\u0582\u0574, \u0570\u057D\u057F\u0561\u056F \u0578\u0580\u0578\u0577\u0578\u0582\u0574\u0576\u0565\u0580\u0589",
        ka: "\u10DB\u10D0\u10E0\u10E8\u10E0\u10E3\u10E2\u10D4\u10D1\u10D8, \u10D5\u10D8\u10D6\u10D8\u10E2\u10D4\u10D1\u10D8 \u10D3\u10D0 \u10E4\u10DD\u10E2\u10DD\u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10D4\u10D1\u10D8 \u2014 \u10D4\u10E0\u10D7 \u10D0\u10D3\u10D2\u10D8\u10DA\u10D0\u10E1. \u10E1\u10EC\u10E0\u10D0\u10E4\u10D8 \u10E8\u10D4\u10DB\u10DD\u10EC\u10DB\u10D4\u10D1\u10D0, \u10DC\u10D0\u10D7\u10D4\u10DA\u10D8 \u10D2\u10D0\u10D3\u10D0\u10EC\u10E7\u10D5\u10D4\u10E2\u10D8\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8."
    },
    feat1: {
        uk: "\u0424\u043E\u0442\u043E\u043F\u0435\u0440\u0435\u0432\u0456\u0440\u043A\u0430 \u2014 \u043F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u044F \u0430\u0431\u043E \u0432\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043D\u044F \u0437\u0430 \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
        en: "Photo review \u2014 approve or reject in seconds",
        hy: "\u053C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580\u0576\u0565\u0580\u056B \u057D\u057F\u0578\u0582\u0563\u0578\u0582\u0574\u055D \u0570\u0561\u057D\u057F\u0561\u057F\u0565\u0584 \u056F\u0561\u0574 \u0574\u0565\u0580\u056A\u0565\u0584 \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576\u0576\u0565\u0580\u056B \u0568\u0576\u0569\u0561\u0581\u0584\u0578\u0582\u0574",
        ka: "\u10E4\u10DD\u10E2\u10DD\u10E1 \u10E8\u10D4\u10DB\u10DD\u10EC\u10DB\u10D4\u10D1\u10D0 \u2014 \u10D3\u10D0\u10D0\u10DB\u10E2\u10D9\u10D8\u10EA\u10D4\u10D7 \u10D0\u10DC \u10E3\u10D0\u10E0\u10E7\u10D0\u10D5\u10D8\u10D7 \u10EC\u10D0\u10DB\u10D4\u10D1\u10E8\u10D8"
    },
    feat2: {
        uk: "\u041F\u043B\u0430\u043D\u0443\u0432\u0430\u043D\u043D\u044F \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u0456\u0432 \u0456 \u0432\u0456\u0434\u0441\u0442\u0435\u0436\u0435\u043D\u043D\u044F \u0432\u0456\u0437\u0438\u0442\u0456\u0432",
        en: "Route planning and live visit tracking",
        hy: "\u0535\u0580\u0569\u0578\u0582\u0572\u056B\u0576\u0565\u0580\u056B \u057A\u056C\u0561\u0576\u0561\u057E\u0578\u0580\u0578\u0582\u0574 \u0587 \u0561\u0575\u0581\u0565\u0580\u056B \u0570\u0565\u057F\u0587\u0578\u0582\u0574",
        ka: "\u10DB\u10D0\u10E0\u10E8\u10E0\u10E3\u10E2\u10D4\u10D1\u10D8\u10E1 \u10D3\u10D0\u10D2\u10D4\u10D2\u10DB\u10D5\u10D0 \u10D3\u10D0 \u10D5\u10D8\u10D6\u10D8\u10E2\u10D4\u10D1\u10D8\u10E1 \u10D7\u10D5\u10D0\u10DA\u10E7\u10E3\u10E0\u10D8\u10E1 \u10D3\u10D4\u10D5\u10DC\u10D4\u10D1\u10D0"
    },
    feat3: {
        uk: "\u0422\u043E\u0447\u043A\u0438, \u043C\u0435\u0440\u0435\u0436\u0456 \u0442\u0430 \u043E\u043F\u0438\u0442\u0443\u0432\u0430\u043D\u043D\u044F \u0432 \u043E\u0434\u043D\u043E\u043C\u0443 \u043C\u0456\u0441\u0446\u0456",
        en: "Points, networks and surveys in one place",
        hy: "\u053F\u0565\u057F\u0565\u0580, \u0581\u0561\u0576\u0581\u0565\u0580 \u0587 \u0570\u0561\u0580\u0581\u0578\u0582\u0574\u0576\u0565\u0580 \u0574\u0565\u056F \u057E\u0561\u0575\u0580\u0578\u0582\u0574",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8, \u10E5\u10E1\u10D4\u10DA\u10D4\u10D1\u10D8 \u10D3\u10D0 \u10D2\u10D0\u10DB\u10DD\u10D9\u10D8\u10D7\u10EE\u10D5\u10D4\u10D1\u10D8 \u10D4\u10E0\u10D7 \u10D0\u10D3\u10D2\u10D8\u10DA\u10D0\u10E1"
    },
    signin_title: {
        uk: "\u0412\u0445\u0456\u0434",
        en: "Sign in",
        hy: "\u0544\u0578\u0582\u057F\u0584",
        ka: "\u10E8\u10D4\u10E1\u10D5\u10DA\u10D0"
    },
    signin_sub: {
        uk: "\u0423\u0432\u0456\u0439\u0434\u0456\u0442\u044C, \u0449\u043E\u0431 \u043F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438 \u0440\u043E\u0431\u043E\u0442\u0443 \u0432 Picsell Dashboard",
        en: "Sign in to continue to Picsell Dashboard",
        hy: "\u0544\u0578\u0582\u057F\u0584 \u0563\u0578\u0580\u056E\u0565\u0584\u055D Picsell Dashboard-\u0578\u0582\u0574 \u0561\u0577\u056D\u0561\u057F\u0561\u0576\u0584\u0568 \u0577\u0561\u0580\u0578\u0582\u0576\u0561\u056F\u0565\u056C\u0578\u0582 \u0570\u0561\u0574\u0561\u0580",
        ka: "\u10E8\u10D4\u10D3\u10D8\u10D7, \u10E0\u10DD\u10DB \u10D2\u10D0\u10D0\u10D2\u10E0\u10EB\u10D4\u10DA\u10DD\u10D7 \u10DB\u10E3\u10E8\u10D0\u10DD\u10D1\u10D0 Picsell Dashboard-\u10E8\u10D8"
    },
    phone_label: {
        uk: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D",
        en: "Phone",
        hy: "\u0540\u0565\u057C\u0561\u056D\u0578\u057D",
        ka: "\u10E2\u10D4\u10DA\u10D4\u10E4\u10DD\u10DC\u10D8"
    },
    phone_ph: {
        uk: "+380 50 123 45 67",
        en: "+380 50 123 45 67",
        hy: "+380 50 123 45 67",
        ka: "+380 50 123 45 67"
    },
    password_label: {
        uk: "\u041F\u0430\u0440\u043E\u043B\u044C",
        en: "Password",
        hy: "\u0533\u0561\u0572\u057F\u0576\u0561\u0562\u0561\u057C",
        ka: "\u10DE\u10D0\u10E0\u10DD\u10DA\u10D8"
    },
    password_ph: {
        uk: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022",
        en: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022",
        hy: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022",
        ka: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022"
    },
    forgot_link: {
        uk: "\u0417\u0430\u0431\u0443\u043B\u0438 \u043F\u0430\u0440\u043E\u043B\u044C?",
        en: "Forgot password?",
        hy: "\u0544\u0578\u057C\u0561\u0581\u0565\u055E\u056C \u0565\u0584 \u0563\u0561\u0572\u057F\u0576\u0561\u0562\u0561\u057C\u0568",
        ka: "\u10D3\u10D0\u10D2\u10D0\u10D5\u10D8\u10EC\u10E7\u10D3\u10D0\u10D7 \u10DE\u10D0\u10E0\u10DD\u10DA\u10D8?"
    },
    signin_btn: {
        uk: "\u0423\u0432\u0456\u0439\u0442\u0438",
        en: "Sign in",
        hy: "\u0544\u0578\u0582\u057F\u0584",
        ka: "\u10E8\u10D4\u10E1\u10D5\u10DA\u10D0"
    },
    role_note: {
        uk: "\u0414\u043E\u0441\u0442\u0443\u043F \u043B\u0438\u0448\u0435 \u0434\u043B\u044F \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0456\u0432 \u0437 \u0440\u043E\u043B\u043B\u044E \xab\u0421\u0443\u043F\u0435\u0440\u0432\u0430\u0439\u0437\u0435\u0440\xbb",
        en: "Access is limited to users with the Supervisor role",
        hy: "\u0540\u0561\u057D\u0561\u0576\u0565\u056C\u056B \u0567 \u0574\u056B\u0561\u0575\u0576 \xab\u054E\u0565\u0580\u0561\u056F\u0561\u0581\u0578\u0582\xbb \u0564\u0565\u0580\u0578\u057E \u0585\u0563\u057F\u0561\u057F\u0565\u0580\u0565\u0580\u056B\u0576",
        ka: "\u10EC\u10D5\u10D3\u10DD\u10DB\u10D0 \u10DB\u10EE\u10DD\u10DA\u10DD\u10D3 \u201E\u10E1\u10E3\u10DE\u10D4\u10E0\u10D5\u10D0\u10D8\u10D6\u10D4\u10E0\u10D8\u10E1\u201C \u10E0\u10DD\u10DA\u10D8\u10E1 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D4\u10D1\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1"
    },
    show_password: {
        uk: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u043F\u0430\u0440\u043E\u043B\u044C",
        en: "Show password",
        hy: "\u0551\u0578\u0582\u0581\u0561\u0564\u0580\u0565\u056C \u0563\u0561\u0572\u057F\u0576\u0561\u0562\u0561\u057C\u0568",
        ka: "\u10DE\u10D0\u10E0\u10DD\u10DA\u10D8\u10E1 \u10E9\u10D5\u10D4\u10DC\u10D4\u10D1\u10D0"
    },
    hide_password: {
        uk: "\u0421\u0445\u043E\u0432\u0430\u0442\u0438 \u043F\u0430\u0440\u043E\u043B\u044C",
        en: "Hide password",
        hy: "\u0539\u0561\u0584\u0581\u0576\u0565\u056C \u0563\u0561\u0572\u057F\u0576\u0561\u0562\u0561\u057C\u0568",
        ka: "\u10DE\u10D0\u10E0\u10DD\u10DA\u10D8\u10E1 \u10D3\u10D0\u10DB\u10D0\u10DA\u10D5\u10D0"
    },
    forgot_title: {
        uk: "\u0417\u0430\u0431\u0443\u043B\u0438 \u043F\u0430\u0440\u043E\u043B\u044C?",
        en: "Forgot password?",
        hy: "\u0544\u0578\u057C\u0561\u0581\u0565\u055E\u056C \u0565\u0584 \u0563\u0561\u0572\u057F\u0576\u0561\u0562\u0561\u057C\u0568",
        ka: "\u10D3\u10D0\u10D2\u10D0\u10D5\u10D8\u10EC\u10E7\u10D3\u10D0\u10D7 \u10DE\u10D0\u10E0\u10DD\u10DA\u10D8?"
    },
    forgot_sub: {
        uk: "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443, \u0437 \u044F\u043A\u0438\u043C \u0432\u0438 \u0432\u0445\u043E\u0434\u0438\u0442\u0435 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443, \u0456 \u043C\u0438 \u043D\u0430\u0434\u0456\u0448\u043B\u0435\u043C\u043E \u0456\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0456\u0457 \u0434\u043B\u044F \u0432\u0456\u0434\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u043F\u0430\u0440\u043E\u043B\u044F \u0432 SMS.",
        en: "Enter the phone number you sign in with and we'll send password reset instructions by SMS.",
        hy: "\u0544\u0578\u0582\u057F\u0584\u0561\u0563\u0580\u0565\u0584 \u0570\u0565\u057C\u0561\u056D\u0578\u057D\u0561\u0570\u0561\u0574\u0561\u0580\u0568, \u0578\u0580\u0578\u057E \u0574\u0578\u0582\u057F\u0584 \u0565\u0584 \u0563\u0578\u0580\u056E\u0578\u0582\u0574, \u0587 \u0574\u0565\u0576\u0584 SMS-\u0578\u057E \u056F\u0578\u0582\u0572\u0561\u0580\u056F\u0565\u0576\u0584 \u0563\u0561\u0572\u057F\u0576\u0561\u0562\u0561\u057C\u0568 \u057E\u0565\u0580\u0561\u056F\u0561\u0576\u0563\u0576\u0565\u056C\u0578\u0582 \u0570\u0580\u0561\u0570\u0561\u0576\u0563\u0576\u0565\u0580\u0568\u0589",
        ka: "\u10E8\u10D4\u10D8\u10E7\u10D5\u10D0\u10DC\u10D4\u10D7 \u10E2\u10D4\u10DA\u10D4\u10E4\u10DD\u10DC\u10D8\u10E1 \u10DC\u10DD\u10DB\u10D4\u10E0\u10D8, \u10E0\u10DD\u10DB\u10DA\u10D8\u10D7\u10D0\u10EA \u10E8\u10D4\u10D3\u10D8\u10EE\u10D0\u10E0\u10D7, \u10D3\u10D0 \u10E9\u10D5\u10D4\u10DC SMS-\u10D8\u10D7 \u10D2\u10D0\u10DB\u10DD\u10D2\u10D8\u10D2\u10D6\u10D0\u10D5\u10DC\u10D8\u10D7 \u10DE\u10D0\u10E0\u10DD\u10DA\u10D8\u10E1 \u10D0\u10E6\u10D3\u10D2\u10D4\u10DC\u10D8\u10E1 \u10D8\u10DC\u10E1\u10E2\u10E0\u10E3\u10E5\u10EA\u10D8\u10D0\u10E1."
    },
    send_btn: {
        uk: "\u0412\u0456\u0434\u043F\u0440\u0430\u0432\u0438\u0442\u0438",
        en: "Send",
        hy: "\u0548\u0582\u0572\u0561\u0580\u056F\u0565\u056C",
        ka: "\u10D2\u10D0\u10D2\u10D6\u10D0\u10D5\u10DC\u10D0"
    },
    back_link: {
        uk: "\u041F\u043E\u0432\u0435\u0440\u043D\u0443\u0442\u0438\u0441\u044F \u0434\u043E \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438 \u0432\u0445\u043E\u0434\u0443",
        en: "Back to sign in",
        hy: "\u054E\u0565\u0580\u0561\u0564\u0561\u057C\u0576\u0561\u056C \u0574\u0578\u0582\u057F\u0584\u056B \u0567\u057B",
        ka: "\u10D3\u10D0\u10D1\u10E0\u10E3\u10DC\u10D4\u10D1\u10D0 \u10E8\u10D4\u10E1\u10D5\u10DA\u10D8\u10E1 \u10D2\u10D5\u10D4\u10E0\u10D3\u10D6\u10D4"
    },
    sent_title: {
        uk: "\u041F\u0435\u0440\u0435\u0432\u0456\u0440\u0442\u0435 \u0442\u0435\u043B\u0435\u0444\u043E\u043D",
        en: "Check your phone",
        hy: "\u054D\u057F\u0578\u0582\u0563\u0565\u0584 \u0571\u0565\u0580 \u0570\u0565\u057C\u0561\u056D\u0578\u057D\u0568",
        ka: "\u10E8\u10D4\u10D0\u10DB\u10DD\u10EC\u10DB\u10D4\u10D7 \u10D7\u10E5\u10D5\u10D4\u10DC\u10D8 \u10E2\u10D4\u10DA\u10D4\u10E4\u10DD\u10DC\u10D8"
    },
    sent_sub: {
        uk: "\u042F\u043A\u0449\u043E \u0430\u043A\u0430\u0443\u043D\u0442 \u0434\u043B\u044F {phone} \u0456\u0441\u043D\u0443\u0454, \u0456\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0456\u0457 \u0437 \u0432\u0456\u0434\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u043D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u043E \u0432 SMS.",
        en: "If an account exists for {phone}, reset instructions are on their way by SMS.",
        hy: "\u0535\u0569\u0565 {phone} \u0570\u0561\u0574\u0561\u0580\u0578\u057E \u0570\u0561\u0577\u056B\u057E \u0563\u0578\u0575\u0578\u0582\u0569\u0575\u0578\u0582\u0576 \u0578\u0582\u0576\u056B, \u057E\u0565\u0580\u0561\u056F\u0561\u0576\u0563\u0576\u0574\u0561\u0576 \u0570\u0580\u0561\u0570\u0561\u0576\u0563\u0576\u0565\u0580\u0576 \u0578\u0582\u0572\u0561\u0580\u056F\u057E\u0565\u056C \u0565\u0576 SMS-\u0578\u057E\u0589",
        ka: "\u10D7\u10E3 {phone}-\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1 \u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10D8 \u10D0\u10E0\u10E1\u10D4\u10D1\u10DD\u10D1\u10E1, \u10D0\u10E6\u10D3\u10D2\u10D4\u10DC\u10D8\u10E1 \u10D8\u10DC\u10E1\u10E2\u10E0\u10E3\u10E5\u10EA\u10D8\u10D0 \u10D2\u10D0\u10DB\u10DD\u10D2\u10D6\u10D0\u10D5\u10DC\u10D8\u10DA\u10D8\u10D0 SMS-\u10D8\u10D7."
    },
    err_required: {
        uk: "\u0426\u0435 \u043F\u043E\u043B\u0435 \u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0435",
        en: "This field is required",
        hy: "\u0531\u0575\u057D \u0564\u0561\u0577\u057F\u0568 \u057A\u0561\u0580\u057F\u0561\u0564\u056B\u0580 \u0567",
        ka: "\u10D4\u10E1 \u10D5\u10D4\u10DA\u10D8 \u10E1\u10D0\u10D5\u10D0\u10DA\u10D3\u10D4\u10D1\u10E3\u10DA\u10DD\u10D0"
    },
    err_phone: {
        uk: "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u043A\u043E\u0440\u0435\u043A\u0442\u043D\u0438\u0439 \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443",
        en: "Enter a valid phone number",
        hy: "\u0544\u0578\u0582\u057F\u0584\u0561\u0563\u0580\u0565\u0584 \u057E\u0561\u057E\u0565\u0580 \u0570\u0565\u057C\u0561\u056D\u0578\u057D\u0561\u0570\u0561\u0574\u0561\u0580",
        ka: "\u10E8\u10D4\u10D8\u10E7\u10D5\u10D0\u10DC\u10D4\u10D7 \u10E1\u10EC\u10DD\u10E0\u10D8 \u10E2\u10D4\u10DA\u10D4\u10E4\u10DD\u10DC\u10D8\u10E1 \u10DC\u10DD\u10DB\u10D4\u10E0\u10D8"
    },
    err_reset_unavailable: {
        uk: "\u0412\u0456\u0434\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u043F\u0430\u0440\u043E\u043B\u044F \u0449\u0435 \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0435. \u0417\u0432\u0435\u0440\u043D\u0456\u0442\u044C\u0441\u044F \u0434\u043E \u0441\u0432\u043E\u0433\u043E \u043A\u0435\u0440\u0456\u0432\u043D\u0438\u043A\u0430.",
        en: "Password reset is not available yet. Please contact your manager.",
        hy: "\u0533\u0561\u0572\u057F\u0576\u0561\u0562\u0561\u057C\u056B \u057E\u0565\u0580\u0561\u056F\u0561\u0576\u0563\u0576\u0578\u0582\u0574\u0568 \u0564\u0565\u057C \u0570\u0561\u057D\u0561\u0576\u0565\u056C\u056B \u0579\u0567\u0589 \u0534\u056B\u0574\u0565\u0584 \u0541\u0565\u0580 \u0572\u0565\u056F\u0561\u057E\u0561\u0580\u056B\u0576\u0589",
        ka: "\u10DE\u10D0\u10E0\u10DD\u10DA\u10D8\u10E1 \u10D0\u10E6\u10D3\u10D2\u10D4\u10DC\u10D0 \u10EF\u10D4\u10E0 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1 \u10EE\u10D4\u10DA\u10DB\u10D8\u10E1\u10D0\u10EC\u10D5\u10D3\u10DD\u10DB\u10D8. \u10DB\u10D8\u10DB\u10D0\u10E0\u10D7\u10D4\u10D7 \u10D7\u10E5\u10D5\u10D4\u10DC\u10E1 \u10EE\u10D4\u10DA\u10DB\u10EB\u10E6\u10D5\u10D0\u10DC\u10D4\u10DA\u10E1."
    },
    language: {
        uk: "\u041C\u043E\u0432\u0430",
        en: "Language",
        hy: "\u053C\u0565\u0566\u0578\u0582",
        ka: "\u10D4\u10DC\u10D0"
    },
    /* Reuses the brand-panel wording: same fact, no second translation to drift. */ err_role: {
        uk: "\u0414\u043E\u0441\u0442\u0443\u043F \u043B\u0438\u0448\u0435 \u0434\u043B\u044F \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0456\u0432 \u0437 \u0440\u043E\u043B\u043B\u044E \xab\u0421\u0443\u043F\u0435\u0440\u0432\u0430\u0439\u0437\u0435\u0440\xbb",
        en: "Access is limited to users with the Supervisor role",
        hy: "\u0540\u0561\u057D\u0561\u0576\u0565\u056C\u056B \u0567 \u0574\u056B\u0561\u0575\u0576 \xab\u054E\u0565\u0580\u0561\u056F\u0561\u0581\u0578\u0582\xbb \u0564\u0565\u0580\u0578\u057E \u0585\u0563\u057F\u0561\u057F\u0565\u0580\u0565\u0580\u056B\u0576",
        ka: "\u10EC\u10D5\u10D3\u10DD\u10DB\u10D0 \u10DB\u10EE\u10DD\u10DA\u10DD\u10D3 \u201E\u10E1\u10E3\u10DE\u10D4\u10E0\u10D5\u10D0\u10D8\u10D6\u10D4\u10E0\u10D8\u10E1\u201C \u10E0\u10DD\u10DA\u10D8\u10E1 \u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D4\u10D1\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1"
    },
    login: {
        uk: "\u0423\u0432\u0456\u0439\u0442\u0438",
        en: "Log in",
        hy: "\u0544\u0578\u0582\u057F\u0584",
        ka: "\u10E8\u10D4\u10E1\u10D5\u10DA\u10D0"
    }
};
const $fc3f36407bc5ec6c$export$e24f02e1b5477764 = {
    profile_sub: {
        uk: "\u041A\u0435\u0440\u0443\u0439\u0442\u0435 \u043E\u0441\u043E\u0431\u0438\u0441\u0442\u0438\u043C\u0438 \u0434\u0430\u043D\u0438\u043C\u0438, \u043A\u0430\u043D\u0430\u043B\u0430\u043C\u0438 \u0437\u0432\u02BC\u044F\u0437\u043A\u0443 \u0442\u0430 \u043D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F\u043C\u0438 \u0434\u0430\u0448\u0431\u043E\u0440\u0434\u0443.",
        en: "Manage your personal details, contact channels and dashboard preferences.",
        hy: "\u053F\u0561\u057C\u0561\u057E\u0561\u0580\u0565\u0584 \u0571\u0565\u0580 \u0561\u0576\u0571\u0576\u0561\u056F\u0561\u0576 \u057F\u057E\u0575\u0561\u056C\u0576\u0565\u0580\u0568, \u056F\u0561\u057A\u056B \u0578\u0582\u0572\u056B\u0576\u0565\u0580\u0568 \u0587 \u0564\u0561\u0577\u0562\u0578\u0580\u0564\u056B \u056F\u0561\u0580\u0563\u0561\u057E\u0578\u0580\u0578\u0582\u0574\u0576\u0565\u0580\u0568\u0589",
        ka: "\u10DB\u10D0\u10E0\u10D7\u10D4\u10D7 \u10DE\u10D8\u10E0\u10D0\u10D3\u10D8 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8, \u10D9\u10DD\u10DC\u10E2\u10D0\u10E5\u10E2\u10D8\u10E1 \u10D0\u10E0\u10EE\u10D4\u10D1\u10D8 \u10D3\u10D0 \u10D3\u10D4\u10E8\u10D1\u10DD\u10E0\u10D3\u10D8\u10E1 \u10DE\u10D0\u10E0\u10D0\u10DB\u10D4\u10E2\u10E0\u10D4\u10D1\u10D8."
    },
    sec_identity: {
        uk: "\u041E\u0441\u043E\u0431\u0438\u0441\u0442\u0456 \u0434\u0430\u043D\u0456",
        en: "Identity",
        hy: "\u0531\u0576\u0571\u0576\u0561\u056F\u0561\u0576 \u057F\u057E\u0575\u0561\u056C\u0576\u0565\u0580",
        ka: "\u10DE\u10D8\u10E0\u10D0\u10D3\u10D8 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8"
    },
    sec_identity_desc: {
        uk: "\u042F\u043A \u0432\u0430\u0448\u0435 \u0456\u043C\u02BC\u044F \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0436\u0430\u0454\u0442\u044C\u0441\u044F \u0432 \u0434\u0430\u0448\u0431\u043E\u0440\u0434\u0456 \u0442\u0430 \u0434\u043B\u044F \u043C\u0435\u0440\u0447\u0435\u043D\u0434\u0430\u0439\u0437\u0435\u0440\u0456\u0432.",
        en: "How your name appears across the dashboard and to your merchandisers.",
        hy: "\u053B\u0576\u0579\u057A\u0565\u057D \u0567 \u0571\u0565\u0580 \u0561\u0576\u0578\u0582\u0576\u0568 \u0565\u0580\u0587\u0578\u0582\u0574 \u0564\u0561\u0577\u0562\u0578\u0580\u0564\u0578\u0582\u0574 \u0587 \u0574\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580\u0576\u0565\u0580\u056B \u0570\u0561\u0574\u0561\u0580\u0589",
        ka: "\u10E0\u10DD\u10D2\u10DD\u10E0 \u10E9\u10D0\u10DC\u10E1 \u10D7\u10E5\u10D5\u10D4\u10DC\u10D8 \u10E1\u10D0\u10EE\u10D4\u10DA\u10D8 \u10D3\u10D4\u10E8\u10D1\u10DD\u10E0\u10D3\u10E8\u10D8 \u10D3\u10D0 \u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D4\u10D1\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1."
    },
    sec_contact: {
        uk: "\u041A\u043E\u043D\u0442\u0430\u043A\u0442\u0438",
        en: "Contact",
        hy: "\u053F\u0561\u057A",
        ka: "\u10D9\u10DD\u10DC\u10E2\u10D0\u10E5\u10E2\u10D8"
    },
    sec_contact_desc: {
        uk: "\u041A\u0443\u0434\u0438 \u0441\u0438\u0441\u0442\u0435\u043C\u0430 \u043D\u0430\u0434\u0441\u0438\u043B\u0430\u0454 \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F \u043F\u0440\u043E \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u043A\u0438 \u0442\u0430 \u0441\u043F\u043E\u0432\u0456\u0449\u0435\u043D\u043D\u044F.",
        en: "Where the system reaches you about reviews and alerts.",
        hy: "\u0548\u0582\u0580 \u0570\u0561\u0574\u0561\u056F\u0561\u0580\u0563\u0568 \u0578\u0582\u0572\u0561\u0580\u056F\u0578\u0582\u0574 \u0567 \u057D\u057F\u0578\u0582\u0563\u0578\u0582\u0574\u0576\u0565\u0580\u056B \u0587 \u056E\u0561\u0576\u0578\u0582\u0581\u0578\u0582\u0574\u0576\u0565\u0580\u056B \u0574\u0561\u057D\u056B\u0576 \u057F\u0565\u0572\u0565\u056F\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580\u0589",
        ka: "\u10E1\u10D0\u10D3 \u10D2\u10D8\u10D2\u10D6\u10D0\u10D5\u10DC\u10D8\u10E1 \u10E1\u10D8\u10E1\u10E2\u10D4\u10DB\u10D0 \u10E8\u10D4\u10DB\u10DD\u10EC\u10DB\u10D4\u10D1\u10D4\u10D1\u10D8\u10E1\u10D0 \u10D3\u10D0 \u10E8\u10D4\u10E2\u10E7\u10DD\u10D1\u10D8\u10DC\u10D4\u10D1\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10E1\u10D0\u10EE\u10D4\u10D1 \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D0\u10E1."
    },
    sec_work: {
        uk: "\u0420\u043E\u0431\u043E\u0447\u0430 \u0437\u043E\u043D\u0430",
        en: "Work area",
        hy: "\u0531\u0577\u056D\u0561\u057F\u0561\u0576\u0584\u0561\u0575\u056B\u0576 \u0563\u0578\u057F\u056B",
        ka: "\u10E1\u10D0\u10DB\u10E3\u10E8\u10D0\u10DD \u10D6\u10DD\u10DC\u10D0"
    },
    sec_work_desc: {
        uk: "\u0422\u0435\u0440\u0438\u0442\u043E\u0440\u0456\u044F \u0442\u0430 \u043E\u0440\u0433\u0430\u043D\u0456\u0437\u0430\u0446\u0456\u044F, \u0434\u043E \u044F\u043A\u0438\u0445 \u043D\u0430\u043B\u0435\u0436\u0438\u0442\u044C \u0432\u0430\u0448 \u0430\u043A\u0430\u0443\u043D\u0442.",
        en: "The territory and organisation your account belongs to.",
        hy: "\u054F\u0561\u0580\u0561\u056E\u0584\u0568 \u0587 \u056F\u0561\u0566\u0574\u0561\u056F\u0565\u0580\u057A\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0568, \u0578\u0580\u056B\u0576 \u057A\u0561\u057F\u056F\u0561\u0576\u0578\u0582\u0574 \u0567 \u0571\u0565\u0580 \u0570\u0561\u0577\u056B\u057E\u0568\u0589",
        ka: "\u10E2\u10D4\u10E0\u10D8\u10E2\u10DD\u10E0\u10D8\u10D0 \u10D3\u10D0 \u10DD\u10E0\u10D2\u10D0\u10DC\u10D8\u10D6\u10D0\u10EA\u10D8\u10D0, \u10E0\u10DD\u10DB\u10D4\u10DA\u10E1\u10D0\u10EA \u10D4\u10D9\u10E3\u10D7\u10D5\u10DC\u10D8\u10E1 \u10D7\u10E5\u10D5\u10D4\u10DC\u10D8 \u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10D8."
    },
    sec_prefs: {
        uk: "\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F",
        en: "Preferences",
        hy: "\u053F\u0561\u0580\u0563\u0561\u057E\u0578\u0580\u0578\u0582\u0574\u0576\u0565\u0580",
        ka: "\u10DE\u10D0\u10E0\u10D0\u10DB\u10D4\u10E2\u10E0\u10D4\u10D1\u10D8"
    },
    sec_prefs_desc: {
        uk: "\u041C\u043E\u0432\u0430 \u0456\u043D\u0442\u0435\u0440\u0444\u0435\u0439\u0441\u0443 \u0434\u0430\u0448\u0431\u043E\u0440\u0434\u0443.",
        en: "Language used across the dashboard interface.",
        hy: "\u0534\u0561\u0577\u0562\u0578\u0580\u0564\u056B \u056B\u0576\u057F\u0565\u0580\u0586\u0565\u0575\u057D\u056B \u056C\u0565\u0566\u0578\u0582\u0576\u0589",
        ka: "\u10D3\u10D4\u10E8\u10D1\u10DD\u10E0\u10D3\u10D8\u10E1 \u10D8\u10DC\u10E2\u10D4\u10E0\u10E4\u10D4\u10D8\u10E1\u10D8\u10E1 \u10D4\u10DC\u10D0."
    },
    upload_photo: {
        uk: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0444\u043E\u0442\u043E",
        en: "Upload photo",
        hy: "\u054E\u0565\u0580\u0562\u0565\u057C\u0576\u0565\u056C \u056C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580",
        ka: "\u10E4\u10DD\u10E2\u10DD\u10E1 \u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D0"
    },
    remove_photo: {
        uk: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438",
        en: "Remove",
        hy: "\u0540\u0565\u057C\u0561\u0581\u0576\u0565\u056C",
        ka: "\u10EC\u10D0\u10E8\u10DA\u10D0"
    },
    photo_hint: {
        uk: "JPG \u0430\u0431\u043E PNG, \u043D\u0435 \u043C\u0435\u043D\u0448\u0435 200\xd7200 px. \u041F\u043E\u043A\u0430\u0437\u0443\u0454\u0442\u044C\u0441\u044F \u0432 \u0445\u0435\u0434\u0435\u0440\u0456 \u0442\u0430 \u0443 \u0437\u0432\u0456\u0442\u0430\u0445 \u043F\u0440\u043E \u0432\u0456\u0437\u0438\u0442\u0438.",
        en: "JPG or PNG, at least 200\xd7200 px. Shown in the header and on visit reports.",
        hy: "JPG \u056F\u0561\u0574 PNG, \u0561\u057C\u0576\u057E\u0561\u0566\u0576 200\xd7200 px\u0589 \u0551\u0578\u0582\u0581\u0561\u0564\u0580\u057E\u0578\u0582\u0574 \u0567 \u057E\u0565\u0580\u0576\u0561\u0563\u0580\u0578\u0582\u0574 \u0587 \u0561\u0575\u0581\u0565\u0580\u056B \u0570\u0561\u0577\u057E\u0565\u057F\u057E\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580\u0578\u0582\u0574\u0589",
        ka: "JPG \u10D0\u10DC PNG, \u10DB\u10D8\u10DC\u10D8\u10DB\u10E3\u10DB 200\xd7200 px. \u10E9\u10D0\u10DC\u10E1 \u10F0\u10D4\u10D3\u10D4\u10E0\u10E8\u10D8 \u10D3\u10D0 \u10D5\u10D8\u10D6\u10D8\u10E2\u10D4\u10D1\u10D8\u10E1 \u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10D4\u10D1\u10E8\u10D8."
    },
    position_hint: {
        uk: "\u0414\u043E\u0432\u0456\u043B\u044C\u043D\u0438\u0439 \u0442\u0435\u043A\u0441\u0442, \u043D\u0430\u043F\u0440. \xab\u0420\u0435\u0433\u0456\u043E\u043D\u0430\u043B\u044C\u043D\u0438\u0439 \u0441\u0443\u043F\u0435\u0440\u0432\u0430\u0439\u0437\u0435\u0440-\u043C\u0435\u043D\u0435\u0434\u0436\u0435\u0440\xbb.",
        en: "Free text, e.g. \u201CRegional supervisor manager\u201D.",
        hy: "\u0531\u0566\u0561\u057F \u057F\u0565\u0584\u057D\u057F, \u0585\u0580. \xab\u054F\u0561\u0580\u0561\u056E\u0561\u0577\u0580\u057B\u0561\u0576\u0561\u0575\u056B\u0576 \u057D\u0578\u0582\u057A\u0565\u0580\u057E\u0561\u0575\u0566\u0565\u0580-\u0574\u0565\u0576\u0565\u057B\u0565\u0580\xbb\u0589",
        ka: "\u10D7\u10D0\u10D5\u10D8\u10E1\u10E3\u10E4\u10D0\u10DA\u10D8 \u10E2\u10D4\u10E5\u10E1\u10E2\u10D8, \u10DB\u10D0\u10D2. \u201E\u10E0\u10D4\u10D2\u10D8\u10DD\u10DC\u10E3\u10DA\u10D8 \u10E1\u10E3\u10DE\u10D4\u10E0\u10D5\u10D0\u10D8\u10D6\u10D4\u10E0-\u10DB\u10D4\u10DC\u10D4\u10EF\u10D4\u10E0\u10D8\u201C."
    },
    phone: {
        uk: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D",
        en: "Phone",
        hy: "\u0540\u0565\u057C\u0561\u056D\u0578\u057D",
        ka: "\u10E2\u10D4\u10DA\u10D4\u10E4\u10DD\u10DC\u10D8"
    },
    phone_hint: {
        uk: "\u0426\u0435 \u0432\u0430\u0448 \u0456\u0434\u0435\u043D\u0442\u0438\u0444\u0456\u043A\u0430\u0442\u043E\u0440 \u0434\u043B\u044F \u0432\u0445\u043E\u0434\u0443 \u2014 \u0439\u043E\u0433\u043E \u043D\u0435 \u043C\u043E\u0436\u043D\u0430 \u0437\u043C\u0456\u043D\u0438\u0442\u0438 \u0442\u0443\u0442, \u0437\u0432\u0435\u0440\u043D\u0456\u0442\u044C\u0441\u044F \u0434\u043E \u0430\u0434\u043C\u0456\u043D\u0456\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u0430.",
        en: "This is your sign-in identifier and cannot be changed here \u2014 contact an administrator.",
        hy: "\u054D\u0561 \u0571\u0565\u0580 \u0574\u0578\u0582\u057F\u0584\u056B \u0576\u0578\u0582\u0575\u0576\u0561\u0581\u0578\u0582\u0581\u056B\u0579\u0576 \u0567 \u0587 \u0561\u0575\u057D\u057F\u0565\u0572 \u0579\u056B \u0583\u0578\u0583\u0578\u056D\u057E\u0578\u0582\u0574 \u2014 \u0564\u056B\u0574\u0565\u0584 \u0561\u0564\u0574\u056B\u0576\u056B\u057D\u057F\u0580\u0561\u057F\u0578\u0580\u056B\u0576\u0589",
        ka: "\u10D4\u10E1 \u10D0\u10E0\u10D8\u10E1 \u10D7\u10E5\u10D5\u10D4\u10DC\u10D8 \u10E8\u10D4\u10E1\u10D5\u10DA\u10D8\u10E1 \u10D8\u10D3\u10D4\u10DC\u10E2\u10D8\u10E4\u10D8\u10D9\u10D0\u10E2\u10DD\u10E0\u10D8 \u10D3\u10D0 \u10D0\u10E5 \u10D5\u10D4\u10E0 \u10D8\u10EA\u10D5\u10DA\u10D4\u10D1\u10D0 \u2014 \u10DB\u10D8\u10DB\u10D0\u10E0\u10D7\u10D4\u10D7 \u10D0\u10D3\u10DB\u10D8\u10DC\u10D8\u10E1\u10E2\u10E0\u10D0\u10E2\u10DD\u10E0\u10E1."
    },
    telegram_hint: {
        uk: "\u041D\u0435\u043E\u0431\u043E\u0432\u02BC\u044F\u0437\u043A\u043E\u0432\u043E. \u0414\u043B\u044F \u043C\u0438\u0442\u0442\u0454\u0432\u0438\u0445 \u0441\u043F\u043E\u0432\u0456\u0449\u0435\u043D\u044C \u0432\u0456\u0434 \u0431\u043E\u0442\u0430 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u043A\u0438.",
        en: "Optional. Used for instant alerts from the review bot.",
        hy: "\u0548\u0579 \u057A\u0561\u0580\u057F\u0561\u0564\u056B\u0580\u0589 \u054D\u057F\u0578\u0582\u0563\u0574\u0561\u0576 \u0562\u0578\u057F\u056B\u0581 \u0561\u056F\u0576\u0569\u0561\u0580\u0569\u0561\u0575\u056B\u0576 \u056E\u0561\u0576\u0578\u0582\u0581\u0578\u0582\u0574\u0576\u0565\u0580\u056B \u0570\u0561\u0574\u0561\u0580\u0589",
        ka: "\u10D0\u10E0\u10D0\u10E1\u10D0\u10D5\u10D0\u10DA\u10D3\u10D4\u10D1\u10E3\u10DA\u10DD. \u10E8\u10D4\u10DB\u10DD\u10EC\u10DB\u10D4\u10D1\u10D8\u10E1 \u10D1\u10DD\u10E2\u10D8\u10E1\u10D2\u10D0\u10DC \u10DB\u10E7\u10D8\u10E1\u10D8\u10D4\u10E0\u10D8 \u10E8\u10D4\u10E2\u10E7\u10DD\u10D1\u10D8\u10DC\u10D4\u10D1\u10D4\u10D1\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1."
    },
    region_hint: {
        uk: "\u041E\u0431\u043C\u0435\u0436\u0443\u0454, \u044F\u043A\u0456 \u0442\u043E\u0447\u043A\u0438 \u0442\u0430 \u0432\u0456\u0437\u0438\u0442\u0438 \u0432\u0438 \u0431\u0430\u0447\u0438\u0442\u0435.",
        en: "Limits which points and visits you can see.",
        hy: "\u054D\u0561\u0570\u0574\u0561\u0576\u0561\u0583\u0561\u056F\u0578\u0582\u0574 \u0567, \u0569\u0565 \u0578\u0580 \u056F\u0565\u057F\u0565\u0580\u0576 \u0578\u0582 \u0561\u0575\u0581\u0565\u0580\u0568 \u056F\u057F\u0565\u057D\u0576\u0565\u0584\u0589",
        ka: "\u10D6\u10E6\u10E3\u10D3\u10D0\u10D5\u10E1, \u10E0\u10DD\u10DB\u10D4\u10DA \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10E1\u10D0 \u10D3\u10D0 \u10D5\u10D8\u10D6\u10D8\u10E2\u10D4\u10D1\u10E1 \u10EE\u10D4\u10D3\u10D0\u10D5\u10D7."
    },
    role: {
        uk: "\u0420\u043E\u043B\u044C",
        en: "Role",
        hy: "\u0534\u0565\u0580",
        ka: "\u10E0\u10DD\u10DA\u10D8"
    },
    role_supervisor_manager: {
        uk: "\u0421\u0443\u043F\u0435\u0440\u0432\u0430\u0439\u0437\u0435\u0440-\u043C\u0435\u043D\u0435\u0434\u0436\u0435\u0440",
        en: "Supervisor manager",
        hy: "\u054D\u0578\u0582\u057A\u0565\u0580\u057E\u0561\u0575\u0566\u0565\u0580-\u0574\u0565\u0576\u0565\u057B\u0565\u0580",
        ka: "\u10E1\u10E3\u10DE\u10D4\u10E0\u10D5\u10D0\u10D8\u10D6\u10D4\u10E0-\u10DB\u10D4\u10DC\u10D4\u10EF\u10D4\u10E0\u10D8"
    },
    company: {
        uk: "\u041A\u043E\u043C\u043F\u0430\u043D\u0456\u044F",
        en: "Company",
        hy: "\u0538\u0576\u056F\u0565\u0580\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10D9\u10DD\u10DB\u10DE\u10D0\u10DC\u10D8\u10D0"
    },
    readonly_hint: {
        uk: "\u0420\u043E\u043B\u044C \u0456 \u043A\u043E\u043C\u043F\u0430\u043D\u0456\u044E \u0432\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u044E\u0454 \u0430\u0434\u043C\u0456\u043D\u0456\u0441\u0442\u0440\u0430\u0442\u043E\u0440.",
        en: "Role and company are set by an administrator.",
        hy: "\u0534\u0565\u0580\u0568 \u0587 \u0568\u0576\u056F\u0565\u0580\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0568 \u057D\u0561\u0570\u0574\u0561\u0576\u0578\u0582\u0574 \u0567 \u0561\u0564\u0574\u056B\u0576\u056B\u057D\u057F\u0580\u0561\u057F\u0578\u0580\u0568\u0589",
        ka: "\u10E0\u10DD\u10DA\u10E1 \u10D3\u10D0 \u10D9\u10DD\u10DB\u10DE\u10D0\u10DC\u10D8\u10D0\u10E1 \u10D0\u10D3\u10DB\u10D8\u10DC\u10D8\u10E1\u10E2\u10E0\u10D0\u10E2\u10DD\u10E0\u10D8 \u10D2\u10D0\u10DC\u10E1\u10D0\u10D6\u10E6\u10D5\u10E0\u10D0\u10D5\u10E1."
    },
    language_reload_warn: {
        uk: "\u041F\u0456\u0441\u043B\u044F \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043D\u044F \u0437\u043C\u0456\u043D\u0430 \u043C\u043E\u0432\u0438 \u043F\u0435\u0440\u0435\u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u044C \u0434\u0430\u0448\u0431\u043E\u0440\u0434.",
        en: "Changing the language reloads the dashboard after saving.",
        hy: "\u054A\u0561\u0570\u057A\u0561\u0576\u0565\u056C\u0578\u0582\u0581 \u0570\u0565\u057F\u0578 \u056C\u0565\u0566\u057E\u056B \u0583\u0578\u0583\u0578\u056D\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0568 \u057E\u0565\u0580\u0561\u0562\u0565\u057C\u0576\u0578\u0582\u0574 \u0567 \u0564\u0561\u0577\u0562\u0578\u0580\u0564\u0568\u0589",
        ka: "\u10E8\u10D4\u10DC\u10D0\u10EE\u10D5\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D3\u10D4\u10D2 \u10D4\u10DC\u10D8\u10E1 \u10E8\u10D4\u10EA\u10D5\u10DA\u10D0 \u10D2\u10D0\u10D3\u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10D0\u10D5\u10E1 \u10D3\u10D4\u10E8\u10D1\u10DD\u10E0\u10D3\u10E1."
    },
    account: {
        uk: "\u0410\u043A\u0430\u0443\u043D\u0442",
        en: "Account",
        hy: "\u0540\u0561\u0577\u056B\u057E",
        ka: "\u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10D8"
    },
    rail_note: {
        uk: "\u0417\u043C\u0456\u043D\u0438 \u0441\u0442\u043E\u0441\u0443\u044E\u0442\u044C\u0441\u044F \u043B\u0438\u0448\u0435 \u0432\u0430\u0448\u043E\u0433\u043E \u0430\u043A\u0430\u0443\u043D\u0442\u0430. \u0414\u0430\u043D\u0456 \u043C\u0435\u0440\u0447\u0435\u043D\u0434\u0430\u0439\u0437\u0435\u0440\u0456\u0432 \u0440\u0435\u0434\u0430\u0433\u0443\u044E\u0442\u044C\u0441\u044F \u043D\u0430 \u0441\u0442\u043E\u0440\u0456\u043D\u0446\u0456 \xab\u041C\u0435\u0440\u0447\u0435\u043D\u0434\u0430\u0439\u0437\u0435\u0440\xbb.",
        en: "Changes apply to your account only. Merchandiser records are edited from the Merchandiser page.",
        hy: "\u0553\u0578\u0583\u0578\u056D\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580\u0568 \u057E\u0565\u0580\u0561\u0562\u0565\u0580\u0578\u0582\u0574 \u0565\u0576 \u0574\u056B\u0561\u0575\u0576 \u0571\u0565\u0580 \u0570\u0561\u0577\u057E\u056B\u0576\u0589 \u0544\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580\u0576\u0565\u0580\u056B \u057F\u057E\u0575\u0561\u056C\u0576\u0565\u0580\u0568 \u056D\u0574\u0562\u0561\u0563\u0580\u057E\u0578\u0582\u0574 \u0565\u0576 \xab\u0544\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580\xbb \u0567\u057B\u0578\u0582\u0574\u0589",
        ka: "\u10EA\u10D5\u10DA\u10D8\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8 \u10DB\u10EE\u10DD\u10DA\u10DD\u10D3 \u10D7\u10E5\u10D5\u10D4\u10DC\u10E1 \u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10E1 \u10D4\u10EE\u10D4\u10D1\u10D0. \u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D4\u10D1\u10D8\u10E1 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8 \u10D8\u10EE\u10D4\u10D3\u10D4\u10D1\u10D0 \u201E\u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D8\u10E1\u201C \u10D2\u10D5\u10D4\u10E0\u10D3\u10D6\u10D4."
    },
    unsaved_changes: {
        uk: "\u0404 \u043D\u0435\u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u0456 \u0437\u043C\u0456\u043D\u0438",
        en: "You have unsaved changes",
        hy: "\u053F\u0561\u0576 \u0579\u057A\u0561\u0570\u057A\u0561\u0576\u057E\u0561\u056E \u0583\u0578\u0583\u0578\u056D\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580",
        ka: "\u10D2\u10D0\u10E5\u10D5\u10D7 \u10E8\u10D4\u10E3\u10DC\u10D0\u10EE\u10D0\u10D5\u10D8 \u10EA\u10D5\u10DA\u10D8\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8"
    },
    discard: {
        uk: "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438",
        en: "Discard",
        hy: "\u0549\u0565\u0572\u0561\u0580\u056F\u0565\u056C",
        ka: "\u10D2\u10D0\u10E3\u10E5\u10DB\u10D4\u10D1\u10D0"
    },
    err_required: {
        uk: "\u0426\u0435 \u043F\u043E\u043B\u0435 \u043E\u0431\u043E\u0432\u02BC\u044F\u0437\u043A\u043E\u0432\u0435",
        en: "This field is required",
        hy: "\u0531\u0575\u057D \u0564\u0561\u0577\u057F\u0568 \u057A\u0561\u0580\u057F\u0561\u0564\u056B\u0580 \u0567",
        ka: "\u10D4\u10E1 \u10D5\u10D4\u10DA\u10D8 \u10E1\u10D0\u10D5\u10D0\u10DA\u10D3\u10D4\u10D1\u10E3\u10DA\u10DD\u10D0"
    },
    err_telegram: {
        uk: "\u0412\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0439\u0442\u0435 \u0444\u043E\u0440\u043C\u0430\u0442 @username",
        en: "Use the @username format",
        hy: "\u0555\u0563\u057F\u0561\u0563\u0578\u0580\u056E\u0565\u0584 @username \u0571\u0587\u0561\u0579\u0561\u0583\u0568",
        ka: "\u10D2\u10D0\u10DB\u10DD\u10D8\u10E7\u10D4\u10DC\u10D4\u10D7 @username \u10E4\u10DD\u10E0\u10DB\u10D0\u10E2\u10D8"
    },
    help_confirm: {
        uk: "\u041C\u0438 \u043D\u0430\u0434\u0456\u0448\u043B\u0435\u043C\u043E \u0441\u043B\u0443\u0436\u0431\u0456 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u043A\u0438 \u0432\u0430\u0448\u0435 \u0456\u043C\u02BC\u044F, \u0442\u0435\u043B\u0435\u0444\u043E\u043D \u0456 \u043A\u043E\u043C\u043F\u0430\u043D\u0456\u044E, \u0449\u043E\u0431 \u0432\u043E\u043D\u0438 \u0437\u0432\u02BC\u044F\u0437\u0430\u043B\u0438\u0441\u044F \u0437 \u0432\u0430\u043C\u0438.",
        en: "We will send support your name, phone number and company so they can get back to you.",
        hy: "\u0531\u057B\u0561\u056F\u0581\u0574\u0561\u0576 \u056E\u0561\u057C\u0561\u0575\u0578\u0582\u0569\u0575\u0561\u0576\u0568 \u056F\u0578\u0582\u0572\u0561\u0580\u056F\u0565\u0576\u0584 \u0571\u0565\u0580 \u0561\u0576\u0578\u0582\u0576\u0568, \u0570\u0565\u057C\u0561\u056D\u0578\u057D\u0561\u0570\u0561\u0574\u0561\u0580\u0568 \u0587 \u0568\u0576\u056F\u0565\u0580\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0568, \u0578\u0580\u057A\u0565\u057D\u0566\u056B \u056F\u0561\u057A\u057E\u0565\u0576 \u0571\u0565\u0566 \u0570\u0565\u057F\u0589",
        ka: "\u10DB\u10EE\u10D0\u10E0\u10D3\u10D0\u10ED\u10D4\u10E0\u10D0\u10E1 \u10D2\u10D0\u10D5\u10E3\u10D2\u10D6\u10D0\u10D5\u10DC\u10D8\u10D7 \u10D7\u10E5\u10D5\u10D4\u10DC\u10E1 \u10E1\u10D0\u10EE\u10D4\u10DA\u10E1, \u10E2\u10D4\u10DA\u10D4\u10E4\u10DD\u10DC\u10D8\u10E1 \u10DC\u10DD\u10DB\u10D4\u10E0\u10E1 \u10D3\u10D0 \u10D9\u10DD\u10DB\u10DE\u10D0\u10DC\u10D8\u10D0\u10E1, \u10E0\u10DD\u10DB \u10D3\u10D0\u10D2\u10D8\u10D9\u10D0\u10D5\u10E8\u10D8\u10E0\u10D3\u10DC\u10D4\u10DC."
    },
    help_send: {
        uk: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438",
        en: "Send",
        hy: "\u0548\u0582\u0572\u0561\u0580\u056F\u0565\u056C",
        ka: "\u10D2\u10D0\u10D2\u10D6\u10D0\u10D5\u10DC\u10D0"
    },
    help_sent: {
        uk: "\u0417\u0430\u043F\u0438\u0442 \u043D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u043E. \u041F\u0456\u0434\u0442\u0440\u0438\u043C\u043A\u0430 \u0437\u0432\u02BC\u044F\u0436\u0435\u0442\u044C\u0441\u044F \u0437 \u0432\u0430\u043C\u0438.",
        en: "Request sent. Support will get back to you.",
        hy: "\u0540\u0561\u0580\u0581\u0578\u0582\u0574\u0576 \u0578\u0582\u0572\u0561\u0580\u056F\u057E\u0565\u056C \u0567\u0589 \u0531\u057B\u0561\u056F\u0581\u0578\u0582\u0574\u0568 \u056F\u056F\u0561\u057A\u057E\u056B \u0571\u0565\u0566 \u0570\u0565\u057F\u0589",
        ka: "\u10DB\u10DD\u10D7\u10EE\u10DD\u10D5\u10DC\u10D0 \u10D2\u10D0\u10D8\u10D2\u10D6\u10D0\u10D5\u10DC\u10D0. \u10DB\u10EE\u10D0\u10E0\u10D3\u10D0\u10ED\u10D4\u10E0\u10D0 \u10D3\u10D0\u10D2\u10D8\u10D9\u10D0\u10D5\u10E8\u10D8\u10E0\u10D3\u10D4\u10D1\u10D0\u10D7."
    },
    help_failed: {
        uk: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u043D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438 \u0437\u0430\u043F\u0438\u0442. \u0421\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u0456\u0437\u043D\u0456\u0448\u0435.",
        en: "Could not send the request. Please try again later.",
        hy: "\u0540\u0561\u0580\u0581\u0578\u0582\u0574\u0576 \u0578\u0582\u0572\u0561\u0580\u056F\u0565\u056C \u0579\u0570\u0561\u057B\u0578\u0572\u057E\u0565\u0581\u0589 \u0553\u0578\u0580\u0571\u0565\u0584 \u0561\u057E\u0565\u056C\u056B \u0578\u0582\u0577\u0589",
        ka: "\u10DB\u10DD\u10D7\u10EE\u10DD\u10D5\u10DC\u10D8\u10E1 \u10D2\u10D0\u10D2\u10D6\u10D0\u10D5\u10DC\u10D0 \u10D5\u10D4\u10E0 \u10DB\u10DD\u10EE\u10D4\u10E0\u10EE\u10D3\u10D0. \u10E1\u10EA\u10D0\u10D3\u10D4\u10D7 \u10DB\u10DD\u10D2\u10D5\u10D8\u10D0\u10DC\u10D4\u10D1\u10D8\u10D7."
    },
    /* Derived from role_supervisor_manager by dropping the "-manager" component. The Georgian
     nominative ending is an inflection rather than a truncation — review this one. */ role_supervisor: {
        uk: "\u0421\u0443\u043F\u0435\u0440\u0432\u0430\u0439\u0437\u0435\u0440",
        en: "Supervisor",
        hy: "\u054D\u0578\u0582\u057A\u0565\u0580\u057E\u0561\u0575\u0566\u0565\u0580",
        ka: "\u10E1\u10E3\u10DE\u10D4\u10E0\u10D5\u10D0\u10D8\u10D6\u10D4\u10E0\u10D8"
    }
};
const $fc3f36407bc5ec6c$export$74880610319600c9 = {
    /* One category is still time-windowed server-side (`RECENT_DAYS` in
     picsell/search/api/web/v1/views.py) — `visit`, the largest table, where the window is a second
     bound on top of the trigram index. The rest are searched in full. So this renders in the header
     of the GROUPS that carry a window, not in the panel footer: one global note would claim to
     apply to all five. It is stated at all because a search that silently cannot find an older
     record reads as broken. Number kept off the noun — {n} is always days (spec/04). */ window_days: {
        uk: "\u0437\u0430 \u043E\u0441\u0442\u0430\u043D\u043D\u0456 {n} \u0434",
        en: "last {n} d",
        hy: "\u057E\u0565\u0580\u057B\u056B\u0576 {n} \u0585\u0580",
        ka: "\u10D1\u10DD\u10DA\u10DD {n} \u10D3\u10E6\u10D4"
    },
    kb_navigate: {
        uk: "\u043D\u0430\u0432\u0456\u0433\u0430\u0446\u0456\u044F",
        en: "to navigate",
        hy: "\u0576\u0561\u057E\u0561\u0580\u056F\u0565\u056C",
        ka: "\u10DC\u10D0\u10D5\u10D8\u10D2\u10D0\u10EA\u10D8\u10D0"
    },
    kb_open: {
        uk: "\u0432\u0456\u0434\u043A\u0440\u0438\u0442\u0438",
        en: "to open",
        hy: "\u0562\u0561\u0581\u0565\u056C",
        ka: "\u10D2\u10D0\u10EE\u10E1\u10DC\u10D0"
    },
    kb_close: {
        uk: "\u0437\u0430\u043A\u0440\u0438\u0442\u0438",
        en: "to close",
        hy: "\u0583\u0561\u056F\u0565\u056C",
        ka: "\u10D3\u10D0\u10EE\u10E3\u10E0\u10D5\u10D0"
    },
    recent_searches: {
        uk: "\u041E\u0441\u0442\u0430\u043D\u043D\u0456 \u0437\u0430\u043F\u0438\u0442\u0438",
        en: "Recent searches",
        hy: "\u054E\u0565\u0580\u057B\u056B\u0576 \u0578\u0580\u0578\u0576\u0578\u0582\u0574\u0576\u0565\u0580\u0568",
        ka: "\u10D1\u10DD\u10DA\u10DD \u10EB\u10D4\u10D1\u10DC\u10D4\u10D1\u10D8"
    },
    see_all: {
        uk: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u0432\u0441\u0456",
        en: "See all",
        hy: "\u0534\u056B\u057F\u0565\u056C \u0562\u0578\u056C\u0578\u0580\u0568",
        ka: "\u10E7\u10D5\u10D4\u10DA\u10D0\u10E1 \u10DC\u10D0\u10EE\u10D5\u10D0"
    },
    search_placeholder: {
        uk: "\u041F\u043E\u0448\u0443\u043A \u043C\u0435\u0440\u0447\u0435\u043D\u0434\u0430\u0439\u0437\u0435\u0440\u0456\u0432, \u0432\u0456\u0437\u0438\u0442\u0456\u0432, \u0442\u043E\u0447\u043E\u043A, \u043E\u043F\u0438\u0442\u0443\u0432\u0430\u043D\u044C\u2026",
        en: "Search merchandisers, visits, points, surveys\u2026",
        hy: "\u0548\u0580\u0578\u0576\u0565\u056C \u0574\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580\u0576\u0565\u0580, \u0561\u0575\u0581\u0565\u0580, \u056F\u0565\u057F\u0565\u0580, \u0570\u0561\u0580\u0581\u0578\u0582\u0574\u0576\u0565\u0580\u2026",
        ka: "\u10DB\u10DD\u10EB\u10D4\u10D1\u10DC\u10D4\u10D7 \u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D4\u10D1\u10D8, \u10D5\u10D8\u10D6\u10D8\u10E2\u10D4\u10D1\u10D8, \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8, \u10D2\u10D0\u10DB\u10DD\u10D9\u10D8\u10D7\u10EE\u10D5\u10D4\u10D1\u10D8\u2026"
    },
    /* {n} is MIN_QUERY in AppSearch.js, not a literal, because the floor is set by what the
     trigram index can serve and has already drifted from this string once. ⚠ uk agrees with the
     number: 2–4 takes "символи", 5+ would need "символів". */ search_hint: {
        uk: "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u0449\u043E\u043D\u0430\u0439\u043C\u0435\u043D\u0448\u0435 {n} \u0441\u0438\u043C\u0432\u043E\u043B\u0438",
        en: "Type at least {n} characters",
        hy: "\u0544\u0578\u0582\u057F\u0584\u0561\u0563\u0580\u0565\u0584 \u0561\u057C\u0576\u057E\u0561\u0566\u0576 {n} \u0576\u0577\u0561\u0576",
        ka: "\u10E8\u10D4\u10D8\u10E7\u10D5\u10D0\u10DC\u10D4\u10D7 \u10DB\u10D8\u10DC\u10D8\u10DB\u10E3\u10DB {n} \u10E1\u10D8\u10DB\u10D1\u10DD\u10DA\u10DD"
    },
    search_no_results: {
        uk: "\u041D\u0456\u0447\u043E\u0433\u043E \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E \u0437\u0430 \u0437\u0430\u043F\u0438\u0442\u043E\u043C",
        en: "Nothing found for",
        hy: "\u0548\u0579\u056B\u0576\u0579 \u0579\u056B \u0563\u057F\u0576\u057E\u0565\u056C\u055D",
        ka: "\u10D5\u10D4\u10E0\u10D0\u10E4\u10D4\u10E0\u10D8 \u10DB\u10DD\u10D8\u10EB\u10D4\u10D1\u10DC\u10D0:"
    },
    search_all: {
        uk: "\u0423\u0441\u0456",
        en: "All",
        hy: "\u0532\u0578\u056C\u0578\u0580\u0568",
        ka: "\u10E7\u10D5\u10D4\u10DA\u10D0"
    },
    search_label: {
        uk: "\u041F\u043E\u0448\u0443\u043A",
        en: "Search",
        hy: "\u0548\u0580\u0578\u0576\u0578\u0582\u0574",
        ka: "\u10EB\u10D4\u10D1\u10DC\u10D0"
    },
    search_clear: {
        uk: "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u0438",
        en: "Clear",
        hy: "\u0544\u0561\u0584\u0580\u0565\u056C",
        ka: "\u10D2\u10D0\u10E1\u10E3\u10E4\u10D7\u10D0\u10D5\u10D4\u10D1\u10D0"
    }
};
const $fc3f36407bc5ec6c$export$a37c17837c5ca0c5 = {
    notifications: {
        uk: "\u041F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F",
        en: "Notifications",
        hy: "\u053E\u0561\u0576\u0578\u0582\u0581\u0578\u0582\u0574\u0576\u0565\u0580",
        ka: "\u10E8\u10D4\u10E2\u10E7\u10DD\u10D1\u10D8\u10DC\u10D4\u10D1\u10D4\u10D1\u10D8"
    },
    mark_all_read: {
        uk: "\u041F\u043E\u0437\u043D\u0430\u0447\u0438\u0442\u0438 \u0432\u0441\u0456 \u044F\u043A \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u0456",
        en: "Mark all as read",
        hy: "\u0546\u0577\u0565\u056C \u0562\u0578\u056C\u0578\u0580\u0568 \u0578\u0580\u057A\u0565\u057D \u056F\u0561\u0580\u0564\u0561\u0581\u057E\u0561\u056E",
        ka: "\u10E7\u10D5\u10D4\u10DA\u10D0\u10E1 \u10EC\u10D0\u10D9\u10D8\u10D7\u10EE\u10E3\u10DA\u10D0\u10D3 \u10DB\u10DD\u10DC\u10D8\u10E8\u10D5\u10DC\u10D0"
    },
    view_all_notifications: {
        uk: "\u0423\u0441\u0456 \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u043D\u044F",
        en: "View all notifications",
        hy: "\u0532\u0578\u056C\u0578\u0580 \u056E\u0561\u0576\u0578\u0582\u0581\u0578\u0582\u0574\u0576\u0565\u0580\u0568",
        ka: "\u10E7\u10D5\u10D4\u10DA\u10D0 \u10E8\u10D4\u10E2\u10E7\u10DD\u10D1\u10D8\u10DC\u10D4\u10D1\u10D0"
    },
    notif_empty: {
        uk: "\u041D\u043E\u0432\u0438\u0445 \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u043B\u0435\u043D\u044C \u043D\u0435\u043C\u0430\u0454",
        en: "Nothing needs your attention",
        hy: "\u0548\u0579\u056B\u0576\u0579 \u0579\u056B \u057A\u0561\u0570\u0561\u0576\u057B\u0578\u0582\u0574 \u0571\u0565\u0580 \u0578\u0582\u0577\u0561\u0564\u0580\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0568",
        ka: "\u10E7\u10E3\u10E0\u10D0\u10D3\u10E6\u10D4\u10D1\u10D0\u10E1 \u10D0\u10E0\u10D0\u10E4\u10D4\u10E0\u10D8 \u10E1\u10D0\u10ED\u10D8\u10E0\u10DD\u10D4\u10D1\u10E1"
    },
    notif_visits_pending: {
        uk: "\u0412\u0456\u0437\u0438\u0442\u0438 \u043D\u0430 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0446\u0456",
        en: "Visits awaiting verification",
        hy: "\u0531\u0575\u0581\u0565\u0580, \u0578\u0580\u0578\u0576\u0584 \u057D\u057A\u0561\u057D\u0578\u0582\u0574 \u0565\u0576 \u057D\u057F\u0578\u0582\u0563\u0574\u0561\u0576",
        ka: "\u10D5\u10D8\u10D6\u10D8\u10E2\u10D4\u10D1\u10D8, \u10E0\u10DD\u10DB\u10DA\u10D4\u10D1\u10D8\u10EA \u10E8\u10D4\u10DB\u10DD\u10EC\u10DB\u10D4\u10D1\u10D0\u10E1 \u10D4\u10DA\u10DD\u10D3\u10D4\u10D1\u10D0"
    },
    notif_merch_idle: {
        uk: "\u041C\u0435\u0440\u0447\u0435\u043D\u0434\u0430\u0439\u0437\u0435\u0440\u0438 \u0431\u0435\u0437 \u0432\u0456\u0437\u0438\u0442\u0456\u0432 \u043F\u043E\u043D\u0430\u0434 {n} \u0434",
        en: "Merchandisers with no visits in {n} d",
        hy: "\u0544\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580\u0576\u0565\u0580 \u0561\u057C\u0561\u0576\u0581 \u0561\u0575\u0581\u0565\u0580\u056B {n} \u0585\u0580\u056B\u0581 \u0561\u057E\u0565\u056C\u056B",
        ka: "\u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D4\u10D1\u10D8 \u10D5\u10D8\u10D6\u10D8\u10E2\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10E0\u10D4\u10E8\u10D4 {n} \u10D3\u10E6\u10D4\u10D6\u10D4 \u10DB\u10D4\u10E2\u10D8"
    },
    notif_surveys_ending: {
        uk: "\u041E\u043F\u0438\u0442\u0443\u0432\u0430\u043D\u043D\u044F \u0437\u0430\u0432\u0435\u0440\u0448\u0443\u044E\u0442\u044C\u0441\u044F \u043F\u0440\u043E\u0442\u044F\u0433\u043E\u043C {n} \u0434",
        en: "Surveys closing within {n} d",
        hy: "\u0540\u0561\u0580\u0581\u0578\u0582\u0574\u0576\u0565\u0580, \u0578\u0580\u0578\u0576\u0584 \u0561\u057E\u0561\u0580\u057F\u057E\u0578\u0582\u0574 \u0565\u0576 {n} \u0585\u0580\u057E\u0561 \u0568\u0576\u0569\u0561\u0581\u0584\u0578\u0582\u0574",
        ka: "\u10D2\u10D0\u10DB\u10DD\u10D9\u10D8\u10D7\u10EE\u10D5\u10D4\u10D1\u10D8, \u10E0\u10DD\u10DB\u10DA\u10D4\u10D1\u10D8\u10EA {n} \u10D3\u10E6\u10D4\u10E8\u10D8 \u10E1\u10E0\u10E3\u10DA\u10D3\u10D4\u10D1\u10D0"
    }
};
const $fc3f36407bc5ec6c$export$62d0a6d9a23c818 = {
    login_success_msg: {
        uk: "\u0412\u0438 \u0443\u0441\u043F\u0456\u0448\u043D\u043E \u0443\u0432\u0456\u0439\u0448\u043B\u0438 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443",
        en: "You have successfully logged in to the system",
        hy: "\u0534\u0578\u0582\u0584 \u0570\u0561\u057B\u0578\u0572\u0578\u0582\u0569\u0575\u0561\u0574\u0562 \u0574\u0578\u0582\u057F\u0584 \u0563\u0578\u0580\u056E\u0565\u0581\u056B\u0584 \u0570\u0561\u0574\u0561\u056F\u0561\u0580\u0563",
        ka: "\u10D7\u10E5\u10D5\u10D4\u10DC \u10EC\u10D0\u10E0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D8\u10D7 \u10E8\u10D4\u10EE\u10D5\u10D4\u10D3\u10D8\u10D7 \u10E1\u10D8\u10E1\u10E2\u10D4\u10DB\u10D0\u10E8\u10D8"
    },
    login_error_msg: {
        uk: "\u041A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447 \u043D\u0435 \u0456\u0441\u043D\u0443\u0454 \u0430\u0431\u043E \u043D\u0435\u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u0456 \u0434\u0430\u043D\u0456 \u0434\u043B\u044F \u0432\u0445\u043E\u0434\u0443.",
        en: "User does not exist or incorrect login data.",
        hy: "\u0555\u0563\u057F\u0561\u057F\u0565\u0580\u0568 \u0563\u0578\u0575\u0578\u0582\u0569\u0575\u0578\u0582\u0576 \u0579\u0578\u0582\u0576\u056B \u056F\u0561\u0574 \u0574\u0578\u0582\u057F\u0584\u056B \u057F\u057E\u0575\u0561\u056C\u0576\u0565\u0580\u0568 \u057D\u056D\u0561\u056C \u0565\u0576\u0589",
        ka: "\u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D4\u10DA\u10D8 \u10D0\u10E0 \u10D0\u10E0\u10E1\u10D4\u10D1\u10DD\u10D1\u10E1 \u10D0\u10DC \u10E8\u10D4\u10E1\u10D5\u10DA\u10D8\u10E1 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8 \u10D0\u10E0\u10D0\u10E1\u10EC\u10DD\u10E0\u10D8\u10D0."
    }
};
const $fc3f36407bc5ec6c$export$34f353d91e697be5 = {
    page_title: {
        uk: "\u0412\u0456\u0437\u0438\u0442\u0438",
        en: "Visits",
        hy: "\u0531\u0575\u0581\u0565\u0580",
        ka: "\u10D5\u10D8\u10D6\u10D8\u10E2\u10D4\u10D1\u10D8"
    },
    columns: {
        uk: "\u0421\u0442\u043E\u0432\u043F\u0446\u0456",
        en: "Columns",
        hy: "\u054D\u0575\u0578\u0582\u0576\u0561\u056F\u0576\u0565\u0580",
        ka: "\u10E1\u10D5\u10D4\u10E2\u10D4\u10D1\u10D8"
    },
    table_timespent: {
        uk: "\u0427\u0430\u0441",
        en: "Time",
        hy: "\u053A\u0561\u0574\u0561\u0576\u0561\u056F",
        ka: "\u10D3\u10E0\u10DD"
    },
    author_way: {
        uk: "\u0410\u0432\u0442\u043E\u0440/\u041F\u043E \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u0443",
        en: "Author/On the route",
        hy: "\u0540\u0565\u0572\u056B\u0576\u0561\u056F/\u0535\u0580\u0569\u0578\u0582\u0572\u0578\u057E",
        ka: "\u10D0\u10D5\u10E2\u10DD\u10E0\u10D8/\u10DB\u10D0\u10E0\u10E8\u10E0\u10E3\u10E2\u10D6\u10D4"
    },
    merchandiser: {
        uk: "\u041C\u0435\u0440\u0447\u0435\u043D\u0434\u0430\u0439\u0437\u0435\u0440",
        en: "Merchandiser",
        hy: "\u0544\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580",
        ka: "\u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D8"
    },
    supervisor: {
        uk: "\u0421\u0443\u043F\u0435\u0440\u0432\u0430\u0439\u0437\u0435\u0440",
        en: "Supervisor",
        hy: "\u054E\u0565\u0580\u0561\u056F\u0561\u0581\u0578\u0582",
        ka: "\u10E1\u10E3\u10DE\u10D4\u10E0\u10D5\u10D0\u10D8\u10D6\u10D4\u10E0\u10D8"
    },
    approved_by: {
        uk: "\u0417\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043E",
        en: "Approved by",
        hy: "\u0540\u0561\u057D\u057F\u0561\u057F\u057E\u0561\u056E \u0567\u055D",
        ka: "\u10D3\u10D0\u10DB\u10E2\u10D9\u10D8\u10EA\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0"
    },
    point: {
        uk: "\u0422\u043E\u0447\u043A\u0430",
        en: "Point",
        hy: "\u053F\u0565\u057F",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8"
    },
    point_started_title: {
        uk: "\u0420\u043E\u0437\u043F\u043E\u0447\u0430\u0442\u043E",
        en: "Started",
        hy: "\u054D\u056F\u057D\u057E\u0561\u056E \u0567",
        ka: "\u10D3\u10D0\u10EC\u10E7\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0"
    },
    point_agoby_title: {
        uk: "\u0442\u043E\u043C\u0443",
        en: "ago by",
        hy: "\u0561\u057C\u0561\u057B\u055D",
        ka: "\u10EC\u10D8\u10DC"
    },
    seconds: {
        uk: "\u0441\u0435\u043A\u0443\u043D\u0434",
        en: "seconds",
        hy: "\u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576",
        ka: "\u10EC\u10D0\u10DB\u10D8"
    },
    minutes: {
        uk: "\u0445\u0432\u0438\u043B\u0438\u043D",
        en: "minutes",
        hy: "\u0580\u0578\u057A\u0565",
        ka: "\u10EC\u10E3\u10D7\u10D8"
    },
    hours: {
        uk: "\u0433\u043E\u0434\u0438\u043D",
        en: "hours",
        hy: "\u056A\u0561\u0574",
        ka: "\u10E1\u10D0\u10D0\u10D7\u10D8"
    },
    days: {
        uk: "\u0434\u043D\u0456\u0432",
        en: "days",
        hy: "\u0585\u0580",
        ka: "\u10D3\u10E6\u10D4"
    },
    months: {
        uk: "\u043C\u0456\u0441\u044F\u0446\u0456\u0432",
        en: "months",
        hy: "\u0561\u0574\u056B\u057D",
        ka: "\u10D7\u10D5\u10D4"
    },
    years: {
        uk: "\u0440\u043E\u043A\u0456\u0432",
        en: "years",
        hy: "\u057F\u0561\u0580\u056B",
        ka: "\u10EC\u10D4\u10DA\u10D8"
    },
    status_label: {
        uk: "\u0421\u0442\u0430\u0442\u0443\u0441",
        en: "Status",
        hy: "\u053F\u0561\u0580\u0563\u0561\u057E\u056B\u0573\u0561\u056F",
        ka: "\u10E1\u10E2\u10D0\u10E2\u10E3\u10E1\u10D8"
    },
    progress_label: {
        uk: "\u041F\u0440\u043E\u0433\u0440\u0435\u0441, %",
        en: "Progress, %",
        hy: "\u0531\u057C\u0561\u057B\u0568\u0576\u0569\u0561\u0581, %",
        ka: "\u10DE\u10E0\u10DD\u10D2\u10E0\u10D4\u10E1\u10D8, %"
    },
    approved_label_popup: {
        uk: "\u0417\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043E",
        en: "Approved",
        hy: "\u0540\u0561\u057D\u057F\u0561\u057F\u057E\u0561\u056E",
        ka: "\u10D3\u10D0\u10DB\u10E2\u10D9\u10D8\u10EA\u10D4\u10D1\u10E3\u10DA\u10D8"
    },
    pending_label_popup: {
        uk: "\u041D\u0430 \u0437\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u0456",
        en: "Pending",
        hy: "\u054D\u057A\u0561\u057D\u0574\u0561\u0576 \u0574\u0565\u057B",
        ka: "\u10DB\u10DD\u10DA\u10DD\u10D3\u10D8\u10DC\u10E8\u10D8"
    },
    rejected_label_popup: {
        uk: "\u041D\u0435 \u0432\u0438\u043A\u043E\u043D\u0430\u043D\u0456",
        en: "Not executed",
        hy: "\u0549\u056F\u0561\u057F\u0561\u0580\u057E\u0561\u056E",
        ka: "\u10E8\u10D4\u10E3\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10D4\u10DA\u10D8"
    },
    /* The price-monitoring section's status segment; the other three are the *_single_visit_name
     keys below. */ f_all: {
        uk: "\u0423\u0441\u0456",
        en: "All",
        hy: "\u0532\u0578\u056C\u0578\u0580\u0568",
        ka: "\u10E7\u10D5\u10D4\u10DA\u10D0"
    },
    approved_single_visit_name: {
        uk: "\u0417\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043E",
        en: "Approved",
        hy: "\u0540\u0561\u057D\u057F\u0561\u057F\u057E\u0561\u056E",
        ka: "\u10D3\u10D0\u10DB\u10E2\u10D9\u10D8\u10EA\u10D4\u10D1\u10E3\u10DA\u10D8"
    },
    no_approved_single_visit_name: {
        uk: "\u041D\u0435 \u0437\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043E",
        en: "Not approved",
        hy: "\u0549\u0570\u0561\u057D\u057F\u0561\u057F\u057E\u0561\u056E",
        ka: "\u10D3\u10D0\u10E3\u10DB\u10E2\u10D9\u10D8\u10EA\u10D4\u10D1\u10D4\u10DA\u10D8"
    },
    on_verification_single_visit_name: {
        uk: "\u041D\u0430 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0446\u0456",
        en: "On verification",
        hy: "\u054D\u057F\u0578\u0582\u0563\u0574\u0561\u0576 \u0583\u0578\u0582\u056C\u0578\u0582\u0574",
        ka: "\u10D2\u10D0\u10D3\u10D0\u10DB\u10DD\u10EC\u10DB\u10D4\u10D1\u10D0\u10E8\u10D8"
    },
    /* `StatusTag`'s neutral fourth state — a task nobody has answered (PICSELL-1615 #6). */ awaiting_answer_name: {
        uk: "\u0411\u0435\u0437 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0456",
        en: "Awaiting answer",
        hy: "\u054D\u057A\u0561\u057D\u0578\u0582\u0574 \u0567 \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u056B",
        ka: "\u10DE\u10D0\u10E1\u10E3\u10EE\u10D8\u10E1 \u10DB\u10DD\u10DA\u10DD\u10D3\u10D8\u10DC\u10E8\u10D8"
    },
    back_to_btn_label: {
        uk: "\u041F\u043E\u0432\u0435\u0440\u043D\u0443\u0442\u0438\u0441\u044F \u0434\u043E \u0432\u0456\u0437\u0438\u0442\u0456\u0432",
        en: "Back to visits",
        hy: "\u054E\u0565\u0580\u0561\u0564\u0561\u057C\u0576\u0561\u056C \u0561\u0575\u0581\u0565\u0580\u056B\u0576",
        ka: "\u10D3\u10D0\u10D1\u10E0\u10E3\u10DC\u10D4\u10D1\u10D0 \u10D5\u10D8\u10D6\u10D8\u10E2\u10D4\u10D1\u10D6\u10D4"
    },
    orders_tab_name: {
        uk: "\u0417\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F",
        en: "Orders",
        hy: "\u054A\u0561\u057F\u057E\u0565\u0580\u0576\u0565\u0580",
        ka: "\u10E8\u10D4\u10D9\u10D5\u10D4\u10D7\u10D4\u10D1\u10D8"
    },
    returns_tab_name: {
        uk: "\u041F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F",
        en: "Returns",
        hy: "\u054E\u0565\u0580\u0561\u0564\u0561\u0580\u0571\u0576\u0565\u0580",
        ka: "\u10D3\u10D0\u10D1\u10E0\u10E3\u10DC\u10D4\u10D1\u10D4\u10D1\u10D8"
    },
    payments_tab_name: {
        uk: "\u041F\u043B\u0430\u0442\u0435\u0436\u0456",
        en: "Payments",
        hy: "\u054E\u0573\u0561\u0580\u0578\u0582\u0574\u0576\u0565\u0580",
        ka: "\u10D2\u10D0\u10D3\u10D0\u10EE\u10D3\u10D4\u10D1\u10D8"
    },
    zvit_tab_name: {
        uk: "\u0417\u0432\u0456\u0442\u0438",
        en: "Reports",
        hy: "\u0540\u0561\u0577\u057E\u0565\u057F\u057E\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580",
        ka: "\u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10D4\u10D1\u10D8"
    },
    task_tab_name: {
        uk: "\u0417\u0430\u0434\u0430\u0447\u0456",
        en: "Tasks",
        hy: "\u0531\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0576\u0565\u0580",
        ka: "\u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8"
    },
    /* The record modal's way out to the task's own page (PICSELL-1581 #4). */ open_task: {
        uk: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F",
        en: "Open task",
        hy: "\u0532\u0561\u0581\u0565\u056C \u0561\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0568",
        ka: "\u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10EE\u10E1\u0576\u0561"
    },
    /* A section fetch that FAILED, as opposed to one that returned nothing — the two used to be
     indistinguishable ("nothing here" under a pending counter, PICSELL-1581 #21). */ sec_load_failed: {
        uk: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0440\u043E\u0437\u0434\u0456\u043B",
        en: "Failed to load this section",
        hy: "\u0549\u0570\u0561\u057B\u0578\u0572\u057E\u0565\u0581 \u0562\u0565\u057C\u0576\u0565\u056C \u0562\u0561\u056A\u056B\u0576\u0568",
        ka: "\u10E1\u10D4\u10E5\u10EA\u10D8\u10D8\u10E1 \u10E9\u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D0 \u10D5\u10D4\u10E0 \u10DB\u10DD\u10EE\u10D4\u10E0\u10EE\u10D3\u10D0"
    },
    retry: {
        uk: "\u0421\u043F\u0440\u043E\u0431\u0443\u0432\u0430\u0442\u0438 \u0437\u043D\u043E\u0432\u0443",
        en: "Retry",
        hy: "\u053F\u0580\u056F\u0576\u0565\u056C",
        ka: "\u10EE\u10D4\u10DA\u10D0\u10EE\u10DA\u10D0"
    },
    monitoring_tab_name: {
        uk: "\u041C\u043E\u043D\u0456\u0442\u043E\u0440\u0438\u043D\u0433",
        en: "Monitoring",
        hy: "\u0544\u0578\u0576\u056B\u057F\u0578\u0580\u056B\u0576\u0563",
        ka: "\u10DB\u10DD\u10DC\u10D8\u10E2\u10DD\u10E0\u10D8\u10DC\u10D2\u10D8"
    },
    log_tab_name: {
        uk: "\u0416\u0443\u0440\u043D\u0430\u043B \u043F\u043E\u0434\u0456\u0439",
        en: "Event log",
        hy: "\u053B\u0580\u0561\u0564\u0561\u0580\u0571\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580\u056B \u0574\u0561\u057F\u0575\u0561\u0576",
        ka: "\u10D8\u10D5\u10D4\u10DC\u10D7\u10D4\u10D1\u10D8\u10E1 \u10DF\u10E3\u10E0\u10DC\u10D0\u10DA\u10D8"
    },
    surveys_tab_name: {
        uk: "\u041E\u043F\u0438\u0442\u0443\u0432\u0430\u043D\u043D\u044F",
        en: "Surveys",
        hy: "\u0540\u0561\u0580\u0581\u0578\u0582\u0574\u0576\u0565\u0580",
        ka: "\u10D2\u10D0\u10DB\u10DD\u10D9\u10D8\u10D7\u10EE\u10D5\u10D4\u10D1\u10D8"
    },
    surveys_summary_surveys_label: {
        uk: "\u041E\u043F\u0438\u0442\u0443\u0432\u0430\u043D\u043D\u044F",
        en: "Surveys",
        hy: "\u0540\u0561\u0580\u0581\u0578\u0582\u0574\u0576\u0565\u0580",
        ka: "\u10D2\u10D0\u10DB\u10DD\u10D9\u10D8\u10D7\u10EE\u10D5\u10D4\u10D1\u10D8"
    },
    surveys_summary_answers_label: {
        uk: "\u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0456",
        en: "Answers",
        hy: "\u054A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0576\u0565\u0580",
        ka: "\u10DE\u10D0\u10E1\u10E3\u10EE\u10D4\u10D1\u10D8"
    },
    surveys_summary_photos_label: {
        uk: "\u0424\u043E\u0442\u043E",
        en: "Photos",
        hy: "\u053C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580\u0576\u0565\u0580",
        ka: "\u10E4\u10DD\u10E2\u10DD\u10D4\u10D1\u10D8"
    },
    surveys_tab_products: {
        uk: "\u0422\u043E\u0432\u0430\u0440\u0438",
        en: "Products",
        hy: "\u0531\u057A\u0580\u0561\u0576\u0584\u0576\u0565\u0580",
        ka: "\u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10E2\u10D4\u10D1\u10D8"
    },
    surveys_tab_brands: {
        uk: "\u0411\u0440\u0435\u043D\u0434\u0438",
        en: "Brands",
        hy: "\u0532\u0580\u0565\u0576\u0564\u0576\u0565\u0580",
        ka: "\u10D1\u10E0\u10D4\u10DC\u10D3\u10D4\u10D1\u10D8"
    },
    surveys_tab_categories: {
        uk: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u0457",
        en: "Categories",
        hy: "\u053F\u0561\u057F\u0565\u0563\u0578\u0580\u056B\u0561\u0576\u0565\u0580",
        ka: "\u10D9\u10D0\u10E2\u10D4\u10D2\u10DD\u10E0\u10D8\u10D4\u10D1\u10D8"
    },
    surveys_tab_other: {
        uk: "\u0406\u043D\u0448\u0435",
        en: "Other",
        hy: "\u0531\u0575\u056C",
        ka: "\u10E1\u10EE\u10D5\u10D0"
    },
    surveys_answer_type_bool: {
        uk: "\u0422\u0430\u043A/\u041D\u0456",
        en: "Bool",
        hy: "\u0531\u0575\u0578/\u0548\u0579",
        ka: "\u10D3\u10D8\u10D0\u10EE/\u10D0\u10E0\u10D0"
    },
    surveys_answer_type_numeric: {
        uk: "\u0427\u0438\u0441\u043B\u043E",
        en: "Numeric",
        hy: "\u0539\u057E\u0561\u0575\u056B\u0576",
        ka: "\u10E0\u10D8\u10EA\u10EE\u10D5\u10D8\u10D7\u10D8"
    },
    surveys_answer_type_dropdown: {
        uk: "\u0421\u043F\u0438\u0441\u043E\u043A",
        en: "Dropdown",
        hy: "\u0551\u0561\u0576\u056F",
        ka: "\u10E1\u10D8\u10D0"
    },
    surveys_answer_type_text: {
        uk: "\u0422\u0435\u043A\u0441\u0442",
        en: "Text",
        hy: "\u054F\u0565\u0584\u057D\u057F",
        ka: "\u10E2\u10D4\u10E5\u10E1\u10E2\u10D8"
    },
    surveys_answer_type_date: {
        uk: "\u0414\u0430\u0442\u0430",
        en: "Date",
        hy: "\u0531\u0574\u057D\u0561\u0569\u056B\u057E",
        ka: "\u10D7\u10D0\u10E0\u10D8\u10E6\u10D8"
    },
    surveys_answer_type_photo: {
        uk: "\u0424\u043E\u0442\u043E",
        en: "Photo",
        hy: "\u053C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580",
        ka: "\u10E4\u10DD\u10E2\u10DD"
    },
    surveys_answer_bool_yes: {
        uk: "\u0422\u0430\u043A",
        en: "Yes",
        hy: "\u0531\u0575\u0578",
        ka: "\u10D3\u10D8\u10D0\u10EE"
    },
    surveys_answer_bool_no: {
        uk: "\u041D\u0456",
        en: "No",
        hy: "\u0548\u0579",
        ka: "\u10D0\u10E0\u10D0"
    },
    surveys_photo_label: {
        uk: "\u0444\u043E\u0442\u043E",
        en: "photos",
        hy: "\u056C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580",
        ka: "\u10E4\u10DD\u10E2\u10DD"
    },
    surveys_empty_products: {
        uk: "\u041D\u0435\u043C\u0430\u0454 \u043F\u0438\u0442\u0430\u043D\u044C \u043F\u043E \u0442\u043E\u0432\u0430\u0440\u0430\u0445",
        en: "No product questions",
        hy: "\u0531\u057A\u0580\u0561\u0576\u0584\u0576\u0565\u0580\u056B \u057E\u0565\u0580\u0561\u0562\u0565\u0580\u0575\u0561\u056C \u0570\u0561\u0580\u0581\u0565\u0580 \u0579\u056F\u0561\u0576",
        ka: "\u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10E2\u10D8\u10E1 \u10D9\u10D8\u10D7\u10EE\u10D5\u10D4\u10D1\u10D8 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1"
    },
    surveys_empty_brands: {
        uk: "\u041D\u0435\u043C\u0430\u0454 \u043F\u0438\u0442\u0430\u043D\u044C \u043F\u043E \u0431\u0440\u0435\u043D\u0434\u0430\u0445",
        en: "No brand questions",
        hy: "\u0532\u0580\u0565\u0576\u0564\u0576\u0565\u0580\u056B \u057E\u0565\u0580\u0561\u0562\u0565\u0580\u0575\u0561\u056C \u0570\u0561\u0580\u0581\u0565\u0580 \u0579\u056F\u0561\u0576",
        ka: "\u10D1\u10E0\u10D4\u10DC\u10D3\u10D8\u10E1 \u10D9\u10D8\u10D7\u10EE\u10D5\u10D4\u10D1\u10D8 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1"
    },
    surveys_empty_categories: {
        uk: "\u041D\u0435\u043C\u0430\u0454 \u043F\u0438\u0442\u0430\u043D\u044C \u043F\u043E \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u044F\u0445",
        en: "No category questions",
        hy: "\u053F\u0561\u057F\u0565\u0563\u0578\u0580\u056B\u0561\u0576\u0565\u0580\u056B \u057E\u0565\u0580\u0561\u0562\u0565\u0580\u0575\u0561\u056C \u0570\u0561\u0580\u0581\u0565\u0580 \u0579\u056F\u0561\u0576",
        ka: "\u10D9\u10D0\u10E2\u10D4\u10D2\u10DD\u10E0\u10D8\u10D8\u10E1 \u10D9\u10D8\u10D7\u10EE\u10D5\u10D4\u10D1\u10D8 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1"
    },
    surveys_empty_other: {
        uk: "\u041D\u0435\u043C\u0430\u0454 \u0456\u043D\u0448\u0438\u0445 \u043F\u0438\u0442\u0430\u043D\u044C",
        en: "No other questions",
        hy: "\u0531\u0575\u056C \u0570\u0561\u0580\u0581\u0565\u0580 \u0579\u056F\u0561\u0576",
        ka: "\u10E1\u10EE\u10D5\u10D0 \u10D9\u10D8\u10D7\u10EE\u10D5\u10D4\u10D1\u10D8 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1"
    },
    surveys_modal_close: {
        uk: "\u0417\u0430\u043A\u0440\u0438\u0442\u0438",
        en: "Close",
        hy: "\u0553\u0561\u056F\u0565\u056C",
        ka: "\u10D3\u10D0\u10EE\u10E3\u10E0\u10D5\u10D0"
    },
    surveys_search_placeholder: {
        uk: "\u041F\u043E\u0448\u0443\u043A \u043E\u043F\u0438\u0442\u0443\u0432\u0430\u043D\u043D\u044F\u2026",
        en: "Search survey\u2026",
        hy: "\u0553\u0576\u057F\u0580\u0565\u056C \u0570\u0561\u0580\u0581\u0578\u0582\u0574\u2026",
        ka: "\u10D2\u10D0\u10DB\u10DD\u10D9\u10D8\u10D7\u10EE\u10D5\u10D8\u10E1 \u10EB\u10D4\u10D1\u10DC\u10D0\u2026"
    },
    surveys_reset_btn: {
        uk: "\u0421\u043A\u0438\u043D\u0443\u0442\u0438",
        en: "Reset",
        hy: "\u0536\u0580\u0578\u0575\u0561\u0581\u0576\u0565\u056C",
        ka: "\u10D2\u10D0\u10D3\u10D0\u10E7\u10D4\u10DC\u10D4\u10D1\u10D0"
    },
    surveys_entity_search_placeholder: {
        uk: "\u041F\u043E\u0448\u0443\u043A\u2026",
        en: "Search\u2026",
        hy: "\u0553\u0576\u057F\u0580\u0565\u056C\u2026",
        ka: "\u10EB\u10D4\u10D1\u10DC\u10D0\u2026"
    },
    surveys_no_results: {
        uk: "\u041D\u0456\u0447\u043E\u0433\u043E \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E \u0437\u0430 \u0437\u0430\u043F\u0438\u0442\u043E\u043C",
        en: "No results found",
        hy: "\u0531\u0580\u0564\u0575\u0578\u0582\u0576\u0584\u0576\u0565\u0580 \u0579\u0565\u0576 \u0563\u057F\u0576\u057E\u0565\u056C",
        ka: "\u10E8\u10D4\u10D3\u10D4\u10D2\u10D4\u10D1\u10D8 \u10D0\u10E0 \u10DB\u10DD\u10D8\u10EB\u10D4\u10D1\u10DC\u10D0"
    },
    surveys_show_more: {
        uk: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u0449\u0435",
        en: "Show more",
        hy: "\u0551\u0578\u0582\u0575\u0581 \u057F\u0561\u056C \u0561\u057E\u0565\u056C\u056B\u0576",
        ka: "\u10DB\u10D4\u10E2\u10D8\u10E1 \u10E9\u10D5\u10D4\u10DC\u10D4\u10D1\u10D0"
    },
    task_has_empty_error: {
        uk: "\u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u0432\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0445\u043E\u0447\u0430 \u0431 \u043E\u0434\u0438\u043D \u0456\u0442\u0435\u043C",
        en: "Please select at least one item",
        hy: "\u053D\u0576\u0564\u0580\u0578\u0582\u0574 \u0565\u0576\u0584 \u0568\u0576\u057F\u0580\u0565\u056C \u0561\u057C\u0576\u057E\u0561\u0566\u0576 \u0574\u0565\u056F \u0574\u056B\u0561\u057E\u0578\u0580",
        ka: "\u10D2\u10D7\u10EE\u10DD\u10D5\u10D7, \u10D0\u10D8\u10E0\u10E9\u10D8\u10DD\u10D7 \u10DB\u10D8\u10DC\u10D8\u10DB\u10E3\u10DB \u10D4\u10E0\u10D7\u10D8 \u10D4\u10E0\u10D7\u10D4\u10E3\u10DA\u10D8"
    },
    task_has_answer_error: {
        uk: "\u0417\u0430\u0434\u0430\u0447\u0430 \u043D\u0435\u043C\u0430\u0454 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0456",
        en: "The task has no answer",
        hy: "\u0531\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0568 \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576 \u0579\u0578\u0582\u0576\u056B",
        ka: "\u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D0\u10E1 \u10DE\u10D0\u10E1\u10E3\u10EE\u10D8 \u10D0\u10E0 \u10D0\u10E5\u10D5\u10E1"
    },
    approv_task_product_btn: {
        uk: "\u0417\u0430\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438 \u043F\u0440\u043E\u0434\u0443\u043A\u0442",
        en: "Approve the product",
        hy: "\u0540\u0561\u057D\u057F\u0561\u057F\u0565\u056C \u0561\u057A\u0580\u0561\u0576\u0584\u0568",
        ka: "\u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10E2\u10D8\u10E1 \u10D3\u10D0\u10DB\u10E2\u10D9\u10D8\u10EA\u10D4\u10D1\u10D0"
    },
    reject_task_product_btn: {
        uk: "\u0412\u0456\u0434\u0445\u0438\u043B\u0438\u0442\u0438 \u043F\u0440\u043E\u0434\u0443\u043A\u0442",
        en: "Reject the product",
        hy: "\u0544\u0565\u0580\u056A\u0565\u056C \u0561\u057A\u0580\u0561\u0576\u0584\u0568",
        ka: "\u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10E2\u10D8\u10E1 \u10E3\u10D9\u10E3\u10E5\u10EA\u10D4\u10D5\u10D0"
    },
    approv_task_btn: {
        uk: "\u0417\u0430\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438 \u0437\u0430\u0434\u0430\u0447\u0443",
        en: "Approve the task",
        hy: "\u0540\u0561\u057D\u057F\u0561\u057F\u0565\u056C \u0561\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0568",
        ka: "\u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D8\u10E1 \u10D3\u10D0\u10DB\u10E2\u10D9\u10D8\u10EA\u10D4\u10D1\u10D0"
    },
    reject_task_btn: {
        uk: "\u0412\u0456\u0434\u0445\u0438\u043B\u0438\u0442\u0438 \u0437\u0430\u0434\u0430\u0447\u0443",
        en: "Reject the task",
        hy: "\u0544\u0565\u0580\u056A\u0565\u056C \u0561\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0568",
        ka: "\u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D8\u10E1 \u10E3\u10D9\u10E3\u10E5\u10EA\u10D4\u10D5\u10D0"
    },
    approv_btn: {
        uk: "\u0417\u0430\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438",
        en: "Approve",
        hy: "\u0540\u0561\u057D\u057F\u0561\u057F\u0565\u056C",
        ka: "\u10D3\u10D0\u10DB\u10E2\u10D9\u10D8\u10EA\u10D4\u10D1\u10D0"
    },
    reject_btn: {
        uk: "\u0412\u0456\u0434\u0445\u0438\u043B\u0438\u0442\u0438",
        en: "Reject",
        hy: "\u0544\u0565\u0580\u056A\u0565\u056C",
        ka: "\u10E3\u10D9\u10E3\u10E5\u10EA\u10D4\u10D5\u10D0"
    },
    task_tab_type_label: {
        uk: "\u0422\u0438\u043F",
        en: "Type",
        hy: "\u054F\u0565\u057D\u0561\u056F",
        ka: "\u10E2\u10D8\u10DE\u10D8"
    },
    task_tab_task_name_label: {
        uk: "\u041D\u0430\u0437\u0432\u0430 \u0437\u0430\u0434\u0430\u0447\u0456",
        en: "Name of the task",
        hy: "\u0531\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u056B \u0561\u0576\u057E\u0561\u0576\u0578\u0582\u0574",
        ka: "\u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D8\u10E1 \u10E1\u10D0\u10EE\u10D4\u10DA\u10D8"
    },
    task_tab_info_label: {
        uk: "\u041E\u043F\u0438\u0441",
        en: "Description",
        hy: "\u0546\u056F\u0561\u0580\u0561\u0563\u0580\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10D0\u10E6\u10EC\u10D4\u10E0\u10D0"
    },
    task_tab_deadline_label: {
        uk: "\u0414\u0435\u0434\u043B\u0430\u0439\u043D",
        en: "Deadline",
        hy: "\u054E\u0565\u0580\u057B\u0576\u0561\u056A\u0561\u0574\u056F\u0565\u057F",
        ka: "\u10D3\u10D4\u10D3\u10DA\u10D0\u10D8\u10DC\u10D8"
    },
    task_tab_createdby_label: {
        uk: "\u041A\u0438\u043C \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043E",
        en: "Created by",
        hy: "\u054D\u057F\u0565\u0572\u056E\u057E\u0561\u056E \u0567\u055D",
        ka: "\u10E8\u10D4\u10E5\u10DB\u10DC\u10D8\u10DA\u10D8\u10D0"
    },
    task_tab_count_photo_label: {
        uk: "\u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C \u0444\u043E\u0442\u043E",
        en: "Number of photos",
        hy: "\u053C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580\u0576\u0565\u0580\u056B \u0584\u0561\u0576\u0561\u056F",
        ka: "\u10E4\u10DD\u10E2\u10DD\u10D4\u10D1\u10D8\u10E1 \u10E0\u10D0\u10DD\u10D3\u10D4\u10DC\u10DD\u10D1\u10D0"
    },
    task_tab_status_label: {
        uk: "\u0421\u0442\u0430\u0442\u0443\u0441",
        en: "Status",
        hy: "\u053F\u0561\u0580\u0563\u0561\u057E\u056B\u0573\u0561\u056F",
        ka: "\u10E1\u10E2\u10D0\u10E2\u10E3\u10E1\u10D8"
    },
    task_tab_answer_status_yes_label: {
        uk: "\u0422\u0430\u043A",
        en: "Yes",
        hy: "\u0531\u0575\u0578",
        ka: "\u10D3\u10D8\u10D0\u10EE"
    },
    task_tab_answer_status_no_label: {
        uk: "\u041D\u0456",
        en: "No",
        hy: "\u0548\u0579",
        ka: "\u10D0\u10E0\u10D0"
    },
    task_tab_answer_status_label: {
        uk: "\u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u044C",
        en: "Answer",
        hy: "\u054A\u0561\u057F\u0561\u057D\u056D\u0561\u0576",
        ka: "\u10DE\u10D0\u10E1\u10E3\u10EE\u10D8"
    },
    task_tab_answer_comment_label: {
        uk: "\u041A\u043E\u043C\u0435\u043D\u0442\u0430\u0440",
        en: "Comment ",
        hy: "\u0544\u0565\u056F\u0576\u0561\u0562\u0561\u0576\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10D9\u10DD\u10DB\u10D4\u10DC\u10E2\u10D0\u10E0\u10D8"
    },
    task_tab_answer_tags_label: {
        uk: "\u0422\u0435\u0433\u0438",
        en: "Tags ",
        hy: "\u0539\u0565\u0563\u0565\u0580",
        ka: "\u10D7\u10D4\u10D2\u10D4\u10D1\u10D8"
    },
    approve_visit_msg: {
        uk: "\u0412\u0456\u0437\u0438\u0442 \u0437\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043E",
        en: "Visit approved",
        hy: "\u0531\u0575\u0581\u0568 \u0570\u0561\u057D\u057F\u0561\u057F\u057E\u0561\u056E \u0567",
        ka: "\u10D5\u10D8\u10D6\u10D8\u10E2\u10D8 \u10D3\u10D0\u10DB\u10E2\u10D9\u10D8\u10EA\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0"
    },
    already_approve_visit_msg: {
        uk: "\u0412\u0456\u0437\u0438\u0442 \u0432\u0436\u0435 \u0431\u0443\u043B\u043E \u0437\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043E",
        en: "Visit already approved",
        hy: "\u0531\u0575\u0581\u0576 \u0561\u0580\u0564\u0565\u0576 \u0570\u0561\u057D\u057F\u0561\u057F\u057E\u0561\u056E \u0567",
        ka: "\u10D5\u10D8\u10D6\u10D8\u10E2\u10D8 \u10E3\u10D9\u10D5\u10D4 \u10D3\u10D0\u10DB\u10E2\u10D9\u10D8\u10EA\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0"
    },
    reject_visit_msg: {
        uk: "\u0412\u0456\u0437\u0438\u0442 \u0432\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043E",
        en: "Visit rejected",
        hy: "\u0531\u0575\u0581\u0568 \u0574\u0565\u0580\u056A\u057E\u0561\u056E \u0567",
        ka: "\u10D5\u10D8\u10D6\u10D8\u10E2\u10D8 \u10E3\u10D9\u10E3\u10E5\u10EA\u10D4\u10E3\u10DA\u10D8\u10D0"
    },
    already_reject_visit_msg: {
        uk: "\u0412\u0456\u0437\u0438\u0442 \u0432\u0436\u0435 \u0431\u0443\u043B\u043E \u0432\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043E",
        en: "Visit already rejected",
        hy: "\u0531\u0575\u0581\u0576 \u0561\u0580\u0564\u0565\u0576 \u0574\u0565\u0580\u056A\u057E\u0561\u056E \u0567",
        ka: "\u10D5\u10D8\u10D6\u10D8\u10E2\u10D8 \u10E3\u10D9\u10D5\u10D4 \u10E3\u10D9\u10E3\u10E5\u10EA\u10D4\u10E3\u10DA\u10D8\u10D0"
    },
    monitoring_tab_pname_label: {
        uk: "\u041D\u0430\u0437\u0432\u0430",
        en: "Name",
        hy: "\u0531\u0576\u057E\u0561\u0576\u0578\u0582\u0574",
        ka: "\u10E1\u10D0\u10EE\u10D4\u10DA\u10D8"
    },
    monitoring_tab_pcode_label: {
        uk: "\u041A\u043E\u0434 \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0443",
        en: "Product code",
        hy: "\u0531\u057A\u0580\u0561\u0576\u0584\u056B \u056F\u0578\u0564",
        ka: "\u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10E2\u10D8\u10E1 \u10D9\u10DD\u10D3\u10D8"
    },
    monitoring_tab_price_label: {
        uk: "\u0426\u0456\u043D\u0430",
        en: "Price",
        hy: "\u0533\u056B\u0576",
        ka: "\u10E4\u10D0\u10E1\u10D8"
    },
    monitoring_tab_sale_price_label: {
        uk: "\u0426\u0456\u043D\u0430 \u043F\u0440\u043E\u0434\u0430\u0436\u0443",
        en: "Sale Price",
        hy: "\u054E\u0561\u0573\u0561\u057C\u0584\u056B \u0563\u056B\u0576",
        ka: "\u10D2\u10D0\u10E7\u10D8\u10D3\u10D5\u10D8\u10E1 \u10E4\u10D0\u10E1\u10D8"
    },
    monitoring_tab_photo_label: {
        uk: "\u0424\u043E\u0442\u043E",
        en: "Photo URL",
        hy: "\u053C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580\u056B \u0570\u0572\u0578\u0582\u0574",
        ka: "\u10E4\u10DD\u10E2\u10DD\u10E1 URL"
    },
    monitoring_tab_comment_label: {
        uk: "\u041A\u043E\u043C\u0435\u043D\u0442\u0430\u0440",
        en: "Comment",
        hy: "\u0544\u0565\u056F\u0576\u0561\u0562\u0561\u0576\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10D9\u10DD\u10DB\u10D4\u10DC\u10E2\u10D0\u10E0\u10D8"
    },
    monitoring_tab_event_monitoring_label: {
        uk: "\u041C\u043E\u043D\u0456\u0442\u043E\u0440\u0438\u043D\u0433",
        en: "Monitoring",
        hy: "\u0544\u0578\u0576\u056B\u057F\u0578\u0580\u056B\u0576\u0563",
        ka: "\u10DB\u10DD\u10DC\u10D8\u10E2\u10DD\u10E0\u10D8\u10DC\u10D2\u10D8"
    },
    monitoring_tab_event_photos_in_answers_label: {
        uk: "\u0424\u043E\u0442\u043E \u0443 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u044F\u0445",
        en: "Photos in answers",
        hy: "\u053C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580\u0576\u0565\u0580 \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0576\u0565\u0580\u0578\u0582\u0574",
        ka: "\u10E4\u10DD\u10E2\u10DD\u10D4\u10D1\u10D8 \u10DE\u10D0\u10E1\u10E3\u10EE\u10D4\u10D1\u10E8\u10D8"
    },
    monitoring_tab_event_photos_in_reports_label: {
        uk: "\u0424\u043E\u0442\u043E \u0443 \u0437\u0432\u0456\u0442\u0430\u0445",
        en: "Photos in reports",
        hy: "\u053C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580\u0576\u0565\u0580 \u0570\u0561\u0577\u057E\u0565\u057F\u057E\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580\u0578\u0582\u0574",
        ka: "\u10E4\u10DD\u10E2\u10DD\u10D4\u10D1\u10D8 \u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10D4\u10D1\u10E8\u10D8"
    },
    monitoring_tab_event_reports_done_label: {
        uk: "\u0417\u0432\u0456\u0442\u0456\u0432 \u0432\u0438\u043A\u043E\u043D\u0430\u043D\u043E",
        en: "Reports done",
        hy: "\u053F\u0561\u057F\u0561\u0580\u057E\u0561\u056E \u0570\u0561\u0577\u057E\u0565\u057F\u057E\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580",
        ka: "\u10E8\u10D4\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10E3\u10DA\u10D8 \u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10D4\u10D1\u10D8"
    },
    monitoring_tab_event_tasks_done_label: {
        uk: "\u0417\u0430\u0432\u0434\u0430\u043D\u044C \u0432\u0438\u043A\u043E\u043D\u0430\u043D\u043E",
        en: "Tasks done",
        hy: "\u053F\u0561\u057F\u0561\u0580\u057E\u0561\u056E \u0561\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0576\u0565\u0580",
        ka: "\u10E8\u10D4\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10E3\u10DA\u10D8 \u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8"
    },
    monitoring_tab_event_tasks_not_done_label: {
        uk: "\u0417\u0430\u0432\u0434\u0430\u043D\u044C \u043D\u0435 \u0432\u0438\u043A\u043E\u043D\u0430\u043D\u043E",
        en: "Tasks not done",
        hy: "\u0549\u056F\u0561\u057F\u0561\u0580\u057E\u0561\u056E \u0561\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0576\u0565\u0580",
        ka: "\u10E8\u10D4\u10E3\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10D4\u10DA\u10D8 \u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8"
    },
    monitoring_tab_event_answers_not_supervised_label: {
        uk: "\u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0435\u0439 \u043D\u0435 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u043E",
        en: "Answers not supervised",
        hy: "\u0549\u057E\u0565\u0580\u057D\u057F\u0578\u0582\u0563\u057E\u0561\u056E \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0576\u0565\u0580",
        ka: "\u10E8\u10D4\u10E3\u10DB\u10DD\u10EC\u10DB\u10D4\u10D1\u10D4\u10DA\u10D8 \u10DE\u10D0\u10E1\u10E3\u10EE\u10D4\u10D1\u10D8"
    },
    monitoring_tab_event_answers_supervised_label: {
        uk: "\u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0435\u0439 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u043E",
        en: "Answers supervised",
        hy: "\u054E\u0565\u0580\u057D\u057F\u0578\u0582\u0563\u057E\u0561\u056E \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0576\u0565\u0580",
        ka: "\u10E8\u10D4\u10DB\u10DD\u10EC\u10DB\u10D4\u10D1\u10E3\u10DA\u10D8 \u10DE\u10D0\u10E1\u10E3\u10EE\u10D4\u10D1\u10D8"
    },
    monitoring_tab_selected_label: {
        uk: "\u041E\u0431\u0440\u0430\u043D\u043E",
        en: "Selected",
        hy: "\u0538\u0576\u057F\u0580\u057E\u0561\u056E",
        ka: "\u10E8\u10D4\u10E0\u10E9\u10D4\u10E3\u10DA\u10D8"
    },
    orders_product_name: {
        uk: "\u041D\u0430\u0437\u0432\u0430 \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F",
        en: "Order Name",
        hy: "\u054A\u0561\u057F\u057E\u0565\u0580\u056B \u0561\u0576\u057E\u0561\u0576\u0578\u0582\u0574",
        ka: "\u10E8\u10D4\u10D9\u10D5\u10D4\u10D7\u10D8\u10E1 \u10E1\u10D0\u10EE\u10D4\u10DA\u10D8"
    },
    orders_product_status_changed: {
        uk: "\u0421\u0442\u0430\u0442\u0443\u0441 \u0437\u043C\u0456\u043D\u0435\u043D\u043E",
        en: "Status changed ",
        hy: "\u053F\u0561\u0580\u0563\u0561\u057E\u056B\u0573\u0561\u056F\u0568 \u0583\u0578\u056D\u057E\u0565\u056C \u0567",
        ka: "\u10E1\u10E2\u10D0\u10E2\u10E3\u10E1\u10D8 \u10E8\u10D4\u10D8\u10EA\u10D5\u10D0\u10DA\u10D0"
    },
    orders_product_status_date: {
        uk: "\u0414\u0430\u0442\u0430",
        en: "Date",
        hy: "\u0531\u0574\u057D\u0561\u0569\u056B\u057E",
        ka: "\u10D7\u10D0\u10E0\u10D8\u10E6\u10D8"
    },
    orders_product_status: {
        uk: "\u0421\u0442\u0430\u0442\u0443\u0441",
        en: "Status ",
        hy: "\u053F\u0561\u0580\u0563\u0561\u057E\u056B\u0573\u0561\u056F",
        ka: "\u10E1\u10E2\u10D0\u10E2\u10E3\u10E1\u10D8"
    },
    orders_product_total: {
        uk: "\u0412\u0441\u044C\u043E\u0433\u043E",
        en: "Total ",
        hy: "\u0538\u0576\u0564\u0561\u0574\u0565\u0576\u0568",
        ka: "\u10EF\u10D0\u10DB\u10D8"
    },
    orders_currency_total: {
        uk: "\u0433\u0440\u043D.",
        en: "grn.",
        hy: "\u0563\u0580\u0576.",
        ka: "\u10D2\u10E0\u10DC."
    },
    orders_popup_order_id_title: {
        uk: "ID \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F",
        en: "Order ID",
        hy: "\u054A\u0561\u057F\u057E\u0565\u0580\u056B ID",
        ka: "\u10E8\u10D4\u10D9\u10D5\u10D4\u10D7\u10D8\u10E1 ID"
    },
    orders_popup_details_title: {
        uk: "\u0414\u0435\u0442\u0430\u043B\u0456 \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F",
        en: "Order details",
        hy: "\u054A\u0561\u057F\u057E\u0565\u0580\u056B \u0574\u0561\u0576\u0580\u0561\u0574\u0561\u057D\u0576\u0565\u0580",
        ka: "\u10E8\u10D4\u10D9\u10D5\u10D4\u10D7\u10D8\u10E1 \u10D3\u10D4\u10E2\u10D0\u10DA\u10D4\u10D1\u10D8"
    },
    orders_popup_sales_rep_label: {
        uk: "\u0422\u043E\u0440\u0433\u043E\u0432\u0438\u0439 \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043D\u0438\u043A",
        en: "Sales Rep",
        hy: "\u054E\u0561\u0573\u0561\u057C\u0584\u056B \u0576\u0565\u0580\u056F\u0561\u0575\u0561\u0581\u0578\u0582\u0581\u056B\u0579",
        ka: "\u10D2\u10D0\u10E7\u10D8\u10D3\u10D5\u10D4\u10D1\u10D8\u10E1 \u10EC\u10D0\u10E0\u10DB\u10DD\u10DB\u10D0\u10D3\u10D2\u10D4\u10DC\u10D4\u10DA\u10D8"
    },
    orders_popup_order_status_label: {
        uk: "\u0421\u0442\u0430\u0442\u0443\u0441 \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F",
        en: "Order Status",
        hy: "\u054A\u0561\u057F\u057E\u0565\u0580\u056B \u056F\u0561\u0580\u0563\u0561\u057E\u056B\u0573\u0561\u056F",
        ka: "\u10E8\u10D4\u10D9\u10D5\u10D4\u10D7\u10D8\u10E1 \u10E1\u10E2\u10D0\u10E2\u10E3\u10E1\u10D8"
    },
    /* Added for PICSELL-1574 #12–#15: the counterparty's address and the number of product lines,
     both shown on the orders and returns tables and in their detail panels. */ orders_address_label: {
        uk: "\u0410\u0434\u0440\u0435\u0441\u0430",
        en: "Address",
        hy: "\u0540\u0561\u057D\u0581\u0565",
        ka: "\u10DB\u10D8\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10D8"
    },
    orders_items_count_label: {
        uk: "\u041F\u043E\u0437\u0438\u0446\u0456\u0439",
        en: "Items",
        hy: "\u0534\u056B\u0580\u0584\u0565\u0580",
        ka: "\u10DE\u10DD\u10D6\u10D8\u10EA\u10D8\u10D4\u10D1\u10D8"
    },
    /* The gross sum of the product lines, shown BESIDE the document's own total because the two
     disagree in the payload — see the note at the order modal's item table. */ orders_lines_total: {
        uk: "\u0421\u0443\u043C\u0430 \u043F\u043E\u0437\u0438\u0446\u0456\u0439",
        en: "Line total",
        hy: "\u054F\u0578\u0572\u0565\u0580\u056B \u0563\u0578\u0582\u0574\u0561\u0580\u0568",
        ka: "\u10EE\u10D0\u10D6\u10D4\u10D1\u10D8\u10E1 \u10EF\u10D0\u10DB\u10D8"
    },
    orders_popup_counterparty_label: {
        uk: "\u041A\u043E\u043D\u0442\u0440\u0430\u0433\u0435\u043D\u0442",
        en: "Counterparty",
        hy: "\u053F\u0578\u0576\u057F\u0580\u0561\u0563\u0565\u0576\u057F",
        ka: "\u10D9\u10DD\u10DC\u10E2\u10E0\u10D0\u10D2\u10D4\u10DC\u10E2\u10D8"
    },
    orders_popup_order_type_label: {
        uk: "\u0422\u0438\u043F \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F",
        en: "Order Type",
        hy: "\u054A\u0561\u057F\u057E\u0565\u0580\u056B \u057F\u0565\u057D\u0561\u056F",
        ka: "\u10E8\u10D4\u10D9\u10D5\u10D4\u10D7\u10D8\u10E1 \u10E2\u10D8\u10DE\u10D8"
    },
    orders_popup_order_table_label: {
        uk: "\u0422\u0430\u0431\u043B\u0438\u0446\u044F \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0456\u0432",
        en: "Products Table",
        hy: "\u0531\u057A\u0580\u0561\u0576\u0584\u0576\u0565\u0580\u056B \u0561\u0572\u0575\u0578\u0582\u057D\u0561\u056F",
        ka: "\u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10E2\u10D4\u10D1\u10D8\u10E1 \u10EA\u10EE\u10E0\u10D8\u10DA\u10D8"
    },
    orders_popup_order_table_name: {
        uk: "\u041D\u0430\u0437\u0432\u0430",
        en: "Name",
        hy: "\u0531\u0576\u057E\u0561\u0576\u0578\u0582\u0574",
        ka: "\u10E1\u10D0\u10EE\u10D4\u10DA\u10D8"
    },
    orders_popup_order_table_quantity: {
        uk: "\u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C",
        en: "Quantity",
        hy: "\u0554\u0561\u0576\u0561\u056F",
        ka: "\u10E0\u10D0\u10DD\u10D3\u10D4\u10DC\u10DD\u10D1\u10D0"
    },
    orders_popup_order_table_amount: {
        uk: "\u0421\u0443\u043C\u0430",
        en: "Amount",
        hy: "\u0533\u0578\u0582\u0574\u0561\u0580",
        ka: "\u10D7\u10D0\u10DC\u10EE\u10D0"
    },
    orders_popup_created_time_label: {
        uk: "\u0414\u0430\u0442\u0430 \u0442\u0430 \u0447\u0430\u0441 \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F",
        en: "Created Date & Time",
        hy: "\u054D\u057F\u0565\u0572\u056E\u0574\u0561\u0576 \u0561\u0574\u057D\u0561\u0569\u056B\u057E \u0587 \u056A\u0561\u0574",
        ka: "\u10E8\u10D4\u10E5\u10DB\u10DC\u10D8\u10E1 \u10D7\u10D0\u10E0\u10D8\u10E6\u10D8 \u10D3\u10D0 \u10D3\u10E0\u10DD"
    },
    orders_popup_delivery_time_label: {
        uk: "\u0414\u0430\u0442\u0430 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0438",
        en: "Delivery Date",
        hy: "\u0531\u057C\u0561\u0584\u0574\u0561\u0576 \u0561\u0574\u057D\u0561\u0569\u056B\u057E",
        ka: "\u10DB\u10D8\u10EC\u10DD\u10D3\u10D4\u10D1\u10D8\u10E1 \u10D7\u10D0\u10E0\u10D8\u10E6\u10D8"
    },
    orders_popup_tracked_geolocation_label: {
        uk: "\u0412\u0456\u0434\u0441\u0442\u0435\u0436\u0435\u043D\u0430 \u0433\u0435\u043E\u043B\u043E\u043A\u0430\u0446\u0456\u044F",
        en: "Tracked Geolocation",
        hy: "\u0540\u0565\u057F\u0561\u0563\u056E\u057E\u0561\u056E \u0561\u0577\u056D\u0561\u0580\u0570\u0561\u0563\u0580\u0561\u056F\u0561\u0576 \u0564\u056B\u0580\u0584",
        ka: "\u10D7\u10E0\u10D4\u10E5\u10D8\u10DC\u10D2\u10D8\u10E1 \u10D2\u10D4\u10DD\u10DA\u10DD\u10D9\u10D0\u10EA\u10D8\u10D0"
    },
    orders_popup_custom_fields_label: {
        uk: "\u041A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0446\u044C\u043A\u0456 \u043F\u043E\u043B\u044F",
        en: "Custom Fields",
        hy: "\u0540\u0561\u057F\u0578\u0582\u056F \u0564\u0561\u0577\u057F\u0565\u0580",
        ka: "\u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D8\u10D7\u10D8 \u10D5\u10D4\u10DA\u10D4\u10D1\u10D8"
    },
    orders_popup_comment_label: {
        uk: "\u041A\u043E\u043C\u0435\u043D\u0442\u0430\u0440",
        en: "Comment",
        hy: "\u0544\u0565\u056F\u0576\u0561\u0562\u0561\u0576\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10D9\u10DD\u10DB\u10D4\u10DC\u10E2\u10D0\u10E0\u10D8"
    },
    orders_popup_visit_label: {
        uk: "\u0412\u0456\u0437\u0438\u0442",
        en: "Visit",
        hy: "\u0531\u0575\u0581",
        ka: "\u10D5\u10D8\u10D6\u10D8\u10E2\u10D8"
    },
    orders_physical_return_label: {
        uk: "\u0414\u0430\u0442\u0430 \u0444\u0456\u0437\u0438\u0447\u043D\u043E\u0433\u043E \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F",
        en: "Physical Return Date",
        hy: "\u0556\u056B\u0566\u056B\u056F\u0561\u056F\u0561\u0576 \u057E\u0565\u0580\u0561\u0564\u0561\u0580\u0571\u056B \u0561\u0574\u057D\u0561\u0569\u056B\u057E",
        ka: "\u10E4\u10D8\u10D6\u10D8\u10D9\u10E3\u10E0\u10D8 \u10D3\u10D0\u10D1\u10E0\u10E3\u10DC\u10D4\u10D1\u10D8\u10E1 \u10D7\u10D0\u10E0\u10D8\u10E6\u10D8"
    },
    orders_status_return_label: {
        uk: "\u0421\u0442\u0430\u0442\u0443\u0441 \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F",
        en: "Return Status",
        hy: "\u054E\u0565\u0580\u0561\u0564\u0561\u0580\u0571\u056B \u056F\u0561\u0580\u0563\u0561\u057E\u056B\u0573\u0561\u056F",
        ka: "\u10D3\u10D0\u10D1\u10E0\u10E3\u10DC\u10D4\u10D1\u10D8\u10E1 \u10E1\u10E2\u10D0\u10E2\u10E3\u10E1\u10D8"
    },
    orders_return_id_label: {
        uk: "ID \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F",
        en: "Return ID",
        hy: "\u054E\u0565\u0580\u0561\u0564\u0561\u0580\u0571\u056B ID",
        ka: "\u10D3\u10D0\u10D1\u10E0\u10E3\u10DC\u10D4\u10D1\u10D8\u10E1 ID"
    },
    orders_return_crated_label: {
        uk: "\u0414\u0430\u0442\u0430 \u0442\u0430 \u0447\u0430\u0441 \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F",
        en: "Created Date & Time",
        hy: "\u054D\u057F\u0565\u0572\u056E\u0574\u0561\u0576 \u0561\u0574\u057D\u0561\u0569\u056B\u057E \u0587 \u056A\u0561\u0574",
        ka: "\u10E8\u10D4\u10E5\u10DB\u10DC\u10D8\u10E1 \u10D7\u10D0\u10E0\u10D8\u10E6\u10D8 \u10D3\u10D0 \u10D3\u10E0\u10DD"
    },
    orders_payment_id_label: {
        uk: "ID \u043E\u043F\u043B\u0430\u0442\u0438",
        en: "Payment ID",
        hy: "\u054E\u0573\u0561\u0580\u0574\u0561\u0576 ID",
        ka: "\u10D2\u10D0\u10D3\u10D0\u10EE\u10D3\u10D8\u10E1 ID"
    },
    orders_payment_amount_label: {
        uk: "\u0421\u0443\u043C\u0430",
        en: "Amount",
        hy: "\u0533\u0578\u0582\u0574\u0561\u0580",
        ka: "\u10D7\u10D0\u10DC\u10EE\u10D0"
    },
    orders_payment_debt_label: {
        uk: "\u0411\u043E\u0440\u0433",
        en: "Debt",
        hy: "\u054A\u0561\u0580\u057F\u0584",
        ka: "\u10D3\u10D0\u10D5\u10D0\u10DA\u10D8\u10D0\u10DC\u10D4\u10D1\u10D0"
    },
    orders_delivery_label: {
        uk: "\u0414\u043E\u0441\u0442\u0430\u0432\u043A\u0430",
        en: "Delivery",
        hy: "\u0531\u057C\u0561\u0584\u0578\u0582\u0574",
        ka: "\u10DB\u10D8\u10EC\u10DD\u10D3\u10D4\u10D1\u10D0"
    },
    orders_item_price_label: {
        uk: "\u0426\u0456\u043D\u0430",
        en: "Price",
        hy: "\u0533\u056B\u0576",
        ka: "\u10E4\u10D0\u10E1\u10D8"
    },
    orders_item_sum_label: {
        uk: "\u0421\u0443\u043C\u0430",
        en: "Sum",
        hy: "\u0533\u0578\u0582\u0574\u0561\u0580",
        ka: "\u10EF\u10D0\u10DB\u10D8"
    },
    /* The stored `Order.Statuses` / `Return.Statuses` keys. DRF emits the KEY, not the label, so
     the cell used to read `sent_for_delivering` — lowercase, snake_case, English everywhere. */ order_status_new: {
        uk: "\u041D\u043E\u0432\u0438\u0439",
        en: "New",
        hy: "\u0546\u0578\u0580",
        ka: "\u10D0\u10EE\u10D0\u10DA\u10D8"
    },
    order_status_processing: {
        uk: "\u0412 \u043E\u0431\u0440\u043E\u0431\u0446\u0456",
        en: "Processing",
        hy: "\u0544\u0577\u0561\u056F\u057E\u0578\u0582\u0574 \u0567",
        ka: "\u10DB\u10E3\u10E8\u10D0\u10D5\u10D3\u10D4\u10D1\u10D0"
    },
    order_status_sent_for_delivering: {
        uk: "\u0412\u0456\u0434\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E \u043D\u0430 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0443",
        en: "Sent for delivering",
        hy: "\u0548\u0582\u0572\u0561\u0580\u056F\u057E\u0561\u056E \u0567 \u0561\u057C\u0561\u0584\u0574\u0561\u0576",
        ka: "\u10D2\u10D0\u10D2\u10D6\u10D0\u10D5\u10DC\u10D8\u10DA\u10D8\u10D0 \u10DB\u10D8\u10EC\u10DD\u10D3\u10D4\u10D1\u10D0\u10D6\u10D4"
    },
    order_status_sent_to_logistics: {
        uk: "\u041F\u0435\u0440\u0435\u0434\u0430\u043D\u043E \u0432 \u043B\u043E\u0433\u0456\u0441\u0442\u0438\u043A\u0443",
        en: "Sent to logistics",
        hy: "\u0553\u0578\u056D\u0561\u0576\u0581\u057E\u0561\u056E \u0567 \u056C\u0578\u0563\u056B\u057D\u057F\u056B\u056F\u0561\u0575\u056B\u0576",
        ka: "\u10D2\u10D0\u10D3\u10D0\u10EA\u10D4\u10DB\u10E3\u10DA\u10D8\u10D0 \u10DA\u10DD\u10D2\u10D8\u10E1\u10E2\u10D8\u10D9\u10D0\u10E8\u10D8"
    },
    order_status_closed: {
        uk: "\u0417\u0430\u043A\u0440\u0438\u0442\u043E",
        en: "Closed",
        hy: "\u0553\u0561\u056F\u057E\u0561\u056E",
        ka: "\u10D3\u10D0\u10EE\u10E3\u10E0\u10E3\u10DA\u10D8"
    },
    order_status_canceled: {
        uk: "\u0421\u043A\u0430\u0441\u043E\u0432\u0430\u043D\u043E",
        en: "Cancelled",
        hy: "\u0549\u0565\u0572\u0561\u0580\u056F\u057E\u0561\u056E",
        ka: "\u10D2\u10D0\u10E3\u10E5\u10DB\u10D4\u10D1\u10E3\u10DA\u10D8"
    },
    rows_per_page: {
        uk: "\u0420\u044F\u0434\u043A\u0456\u0432 \u043D\u0430 \u0441\u0442\u043E\u0440\u0456\u043D\u0446\u0456",
        en: "Rows per page",
        hy: "\u054F\u0578\u0572\u0565\u0580 \u0574\u0565\u056F \u0567\u057B\u0578\u0582\u0574",
        ka: "\u10E1\u10E2\u10E0\u10D8\u10E5\u10DD\u10DC\u10D4\u10D1\u10D8 \u10D2\u10D5\u10D4\u10E0\u10D3\u10D6\u10D4"
    },
    range_of: {
        uk: "{from}\u2013{to} \u0437 {n}",
        en: "{from}\u2013{to} of {n}",
        hy: "{from}\u2013{to} {n}-\u056B\u0581",
        ka: "{from}\u2013{to} {n}-\u10D3\u10D0\u10DC"
    },
    /* The photo report section pages next/prev: its endpoint reports no total (see `SectionSteps`).
     The number stays out of a phrase, so nothing has to agree with it (spec/04). */ page_n: {
        uk: "\u0421\u0442\u043E\u0440\u0456\u043D\u043A\u0430 {n}",
        en: "Page {n}",
        hy: "\u0537\u057B {n}",
        ka: "\u10D2\u10D5\u10D4\u10E0\u10D3\u10D8 {n}"
    },
    page_prev: {
        uk: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u044F",
        en: "Previous",
        hy: "\u0546\u0561\u056D\u0578\u0580\u0564\u0568",
        ka: "\u10EC\u10D8\u10DC\u10D0"
    },
    page_next: {
        uk: "\u041D\u0430\u0441\u0442\u0443\u043F\u043D\u0430",
        en: "Next",
        hy: "\u0540\u0561\u057B\u0578\u0580\u0564\u0568",
        ka: "\u10E8\u10D4\u10DB\u10D3\u10D4\u10D2\u10D8"
    },
    w_selected: {
        uk: "{n} \u043E\u0431\u0440\u0430\u043D\u043E",
        en: "{n} selected",
        hy: "{n} \u0568\u0576\u057F\u0580\u057E\u0561\u056E",
        ka: "{n} \u10D0\u10E0\u10E9\u10D4\u10E3\u10DA\u10D8\u10D0"
    },
    clear_selection: {
        uk: "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u0438",
        en: "Clear",
        hy: "\u0544\u0561\u0584\u0580\u0565\u056C",
        ka: "\u10D2\u10D0\u10E1\u10E3\u10E4\u10D7\u10D0\u10D5\u10D4\u10D1\u10D0"
    },
    all_reviewed_hint: {
        uk: "\u0423 \u0446\u044C\u043E\u043C\u0443 \u0432\u0456\u0437\u0438\u0442\u0456 \u043D\u0435\u043C\u0430\u0454 \u043D\u0456\u0447\u043E\u0433\u043E, \u0449\u043E \u0447\u0435\u043A\u0430\u0454 \u043D\u0430 \u0440\u0456\u0448\u0435\u043D\u043D\u044F.",
        en: "Nothing in this visit is waiting for a decision.",
        hy: "\u0531\u0575\u057D \u0561\u0575\u0581\u0578\u0582\u0574 \u0578\u0580\u0578\u0577\u0574\u0561\u0576 \u057D\u057A\u0561\u057D\u0578\u0572 \u0578\u0579\u056B\u0576\u0579 \u0579\u056F\u0561\u0589",
        ka: "\u10D0\u10DB \u10D5\u10D8\u10D6\u10D8\u10E2\u10E8\u10D8 \u10D2\u10D0\u10D3\u10D0\u10EC\u10E7\u10D5\u10D4\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1 \u10DB\u10DD\u10DB\u10DA\u10DD\u10D3\u10D8\u10DC\u10D4 \u10D0\u10E0\u10D0\u10E4\u10D4\u10E0\u10D8\u10D0."
    },
    approved_at: {
        uk: "\u0414\u0430\u0442\u0430 \u0440\u0456\u0448\u0435\u043D\u043D\u044F",
        en: "Decided at",
        hy: "\u0548\u0580\u0578\u0577\u0574\u0561\u0576 \u0561\u0574\u057D\u0561\u0569\u056B\u057E\u0568",
        ka: "\u10D2\u10D0\u10D3\u10D0\u10EC\u10E7\u10D5\u10D4\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1 \u10D7\u10D0\u10E0\u10D8\u10E6\u10D8"
    },
    comment: {
        uk: "\u041A\u043E\u043C\u0435\u043D\u0442\u0430\u0440",
        en: "Comment",
        hy: "\u0544\u0565\u056F\u0576\u0561\u0562\u0561\u0576\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10D9\u10DD\u10DB\u10D4\u10DC\u10E2\u10D0\u10E0\u10D8"
    },
    copy_link: {
        uk: "\u0421\u043A\u043E\u043F\u0456\u044E\u0432\u0430\u0442\u0438 \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F",
        en: "Copy link",
        hy: "\u054A\u0561\u057F\u0573\u0565\u0576\u0565\u056C \u0570\u0572\u0578\u0582\u0574\u0568",
        ka: "\u10D1\u10DB\u10E3\u10DA\u10D8\u10E1 \u10D9\u10DD\u10DE\u10D8\u10E0\u10D4\u10D1\u10D0"
    },
    decide_failed_msg: {
        uk: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u0432\u0456\u0437\u0438\u0442\u0456\u0432: {n}",
        en: "{n} visits could not be saved",
        hy: "\u0549\u0570\u0561\u057B\u0578\u0572\u057E\u0565\u0581 \u057A\u0561\u0570\u057A\u0561\u0576\u0565\u056C \u0561\u0575\u0581\u0565\u0580\u055D {n}",
        ka: "\u10D5\u10D4\u10E0 \u10E8\u10D4\u10D8\u10DC\u10D0\u10EE\u10D0 \u10D5\u10D8\u10D6\u10D8\u10E2\u10D4\u10D1\u10D8: {n}"
    },
    delta: {
        uk: "\u0420\u0456\u0437\u043D\u0438\u0446\u044F",
        en: "Difference",
        hy: "\u054F\u0561\u0580\u0562\u0565\u0580\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10E1\u10EE\u10D5\u10D0\u10DD\u10D1\u10D0"
    },
    empty_desc: {
        uk: "\u0421\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0440\u043E\u0437\u0448\u0438\u0440\u0438\u0442\u0438 \u043F\u0435\u0440\u0456\u043E\u0434 \u0430\u0431\u043E \u0437\u043D\u044F\u0442\u0438 \u0447\u0430\u0441\u0442\u0438\u043D\u0443 \u0444\u0456\u043B\u044C\u0442\u0440\u0456\u0432.",
        en: "Try widening the period or clearing some filters.",
        hy: "\u0553\u0578\u0580\u0571\u0565\u0584 \u0568\u0576\u0564\u056C\u0561\u0575\u0576\u0565\u056C \u056A\u0561\u0574\u0561\u0576\u0561\u056F\u0561\u0570\u0561\u057F\u057E\u0561\u056E\u0568 \u056F\u0561\u0574 \u0570\u0565\u057C\u0561\u0581\u0576\u0565\u056C \u0578\u0580\u0578\u0577 \u0566\u057F\u056B\u0579\u0576\u0565\u0580\u0589",
        ka: "\u10E1\u10EA\u10D0\u10D3\u10D4\u10D7 \u10DE\u10D4\u10E0\u10D8\u10DD\u10D3\u10D8\u10E1 \u10D2\u10D0\u10E4\u10D0\u10E0\u10D7\u10DD\u10D4\u10D1\u10D0 \u10D0\u10DC \u10DC\u10D0\u10EC\u10D8\u10DA\u10D8 \u10E4\u10D8\u10DA\u10E2\u10E0\u10D4\u10D1\u10D8\u10E1 \u10DB\u10DD\u10EE\u10E1\u10DC\u10D0."
    },
    empty_title: {
        uk: "\u041D\u0435\u043C\u0430\u0454 \u0432\u0456\u0437\u0438\u0442\u0456\u0432 \u0437\u0430 \u0446\u0438\u043C\u0438 \u0444\u0456\u043B\u044C\u0442\u0440\u0430\u043C\u0438",
        en: "No visits match these filters",
        hy: "\u0531\u0575\u057D \u0566\u057F\u056B\u0579\u0576\u0565\u0580\u0578\u057E \u0561\u0575\u0581\u0565\u0580 \u0579\u056F\u0561\u0576",
        ka: "\u10D0\u10DB \u10E4\u10D8\u10DA\u10E2\u10E0\u10D4\u10D1\u10D8\u10D7 \u10D5\u10D8\u10D6\u10D8\u10E2\u10D4\u10D1\u10D8 \u10D5\u10D4\u10E0 \u10DB\u10DD\u10D8\u10EB\u10D4\u10D1\u10DC\u10D0"
    },
    gps_points: {
        uk: "\u0422\u043E\u0447\u043E\u043A \u0442\u0440\u0435\u043A\u0443",
        en: "Track points",
        hy: "\u0535\u0580\u0569\u0578\u0582\u0572\u0578\u0582 \u056F\u0565\u057F\u0565\u0580",
        ka: "\u10E2\u10E0\u10D4\u10D9\u10D8\u10E1 \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8"
    },
    h_short: {
        uk: "\u0433",
        en: "h",
        hy: "\u056A",
        ka: "\u10E1\u10D7"
    },
    link_copied: {
        uk: "\u041F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u0441\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u043E",
        en: "Link copied",
        hy: "\u0540\u0572\u0578\u0582\u0574\u0568 \u057A\u0561\u057F\u0573\u0565\u0576\u057E\u0561\u056E \u0567",
        ka: "\u10D1\u10DB\u10E3\u10DA\u10D8 \u10D3\u10D0\u10D9\u10DD\u10DE\u10D8\u10E0\u10D3\u10D0"
    },
    m_short: {
        uk: "\u0445\u0432",
        en: "m",
        hy: "\u0580",
        ka: "\u10EC\u10D7"
    },
    n_pending: {
        uk: "\u041D\u0430 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0446\u0456: {n}",
        en: "On verification: {n}",
        hy: "\u054D\u057F\u0578\u0582\u0563\u0574\u0561\u0576 \u0583\u0578\u0582\u056C\u0578\u0582\u0574\u055D {n}",
        ka: "\u10D2\u10D0\u10D3\u10D0\u10DB\u10DD\u10EC\u10DB\u10D4\u10D1\u10D0\u10E8\u10D8: {n}"
    },
    next_visit: {
        uk: "\u041D\u0430\u0441\u0442\u0443\u043F\u043D\u0438\u0439 \u0432\u0456\u0437\u0438\u0442",
        en: "Next visit",
        hy: "\u0540\u0561\u057B\u0578\u0580\u0564 \u0561\u0575\u0581\u0568",
        ka: "\u10E8\u10D4\u10DB\u10D3\u10D4\u10D2\u10D8 \u10D5\u10D8\u10D6\u10D8\u10E2\u10D8"
    },
    no_answer: {
        uk: "\u041D\u0435\u043C\u0430\u0454 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0456",
        en: "No answer",
        hy: "\u054A\u0561\u057F\u0561\u057D\u056D\u0561\u0576 \u0579\u056F\u0561",
        ka: "\u10DE\u10D0\u10E1\u10E3\u10EE\u10D8 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1"
    },
    no_coordinates: {
        uk: "\u0422\u043E\u0447\u043A\u0430 \u043D\u0435 \u043C\u0430\u0454 \u043A\u043E\u043E\u0440\u0434\u0438\u043D\u0430\u0442",
        en: "The point has no coordinates",
        hy: "\u053F\u0565\u057F\u0568 \u0579\u0578\u0582\u0576\u056B \u056F\u0578\u0578\u0580\u0564\u056B\u0576\u0561\u057F\u0576\u0565\u0580",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10E1 \u10D0\u10E0 \u10D0\u10E5\u10D5\u10E1 \u10D9\u10DD\u10DD\u10E0\u10D3\u10D8\u10DC\u10D0\u10E2\u10D4\u10D1\u10D8"
    },
    nothing_here: {
        uk: "\u0422\u0443\u0442 \u043F\u043E\u0440\u043E\u0436\u043D\u044C\u043E",
        en: "Nothing here",
        hy: "\u0531\u0575\u057D\u057F\u0565\u0572 \u0564\u0561\u057F\u0561\u0580\u056F \u0567",
        ka: "\u10D0\u10E5 \u10EA\u10D0\u10E0\u10D8\u10D4\u10DA\u10D8\u10D0"
    },
    open_visit: {
        uk: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u0432\u0456\u0437\u0438\u0442",
        en: "Open visit",
        hy: "\u0532\u0561\u0581\u0565\u056C \u0561\u0575\u0581\u0568",
        ka: "\u10D5\u10D8\u10D6\u10D8\u10E2\u10D8\u10E1 \u10D2\u10D0\u10EE\u10E1\u10DC\u10D0"
    },
    page_sub: {
        uk: "\u0417\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u044F \u0432\u0456\u0437\u0438\u0442\u0456\u0432 \u0456 \u0432\u0438\u043A\u043E\u043D\u0430\u043D\u043D\u044F \u0437\u0432\u0456\u0442\u0456\u0432",
        en: "Visit approvals and report completion",
        hy: "\u0531\u0575\u0581\u0565\u0580\u056B \u0570\u0561\u057D\u057F\u0561\u057F\u0578\u0582\u0574 \u0587 \u0570\u0561\u0577\u057E\u0565\u057F\u057E\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580\u056B \u056F\u0561\u057F\u0561\u0580\u0578\u0582\u0574",
        ka: "\u10D5\u10D8\u10D6\u10D8\u10E2\u10D4\u10D1\u10D8\u10E1 \u10D3\u10D0\u10DB\u10E2\u10D9\u10D8\u10EA\u10D4\u10D1\u10D0 \u10D3\u10D0 \u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10D0"
    },
    position_of: {
        uk: "{i} \u0437 {n}",
        en: "{i} of {n}",
        hy: "{n}-\u056B\u0581 {i}",
        ka: "{n}-\u10D3\u10D0\u10DC {i}"
    },
    prev_visit: {
        uk: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u0456\u0439 \u0432\u0456\u0437\u0438\u0442",
        en: "Previous visit",
        hy: "\u0546\u0561\u056D\u0578\u0580\u0564 \u0561\u0575\u0581\u0568",
        ka: "\u10EC\u10D8\u10DC\u10D0 \u10D5\u10D8\u10D6\u10D8\u10E2\u10D8"
    },
    reject_reason: {
        uk: "\u041F\u0440\u0438\u0447\u0438\u043D\u0430 \u0432\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043D\u044F",
        en: "Rejection reason",
        hy: "\u0544\u0565\u0580\u056A\u0574\u0561\u0576 \u057A\u0561\u057F\u0573\u0561\u057C\u0568",
        ka: "\u10E3\u10D0\u10E0\u10E7\u10DD\u10E4\u10D8\u10E1 \u10DB\u10D8\u10D6\u10D4\u10D6\u10D8"
    },
    reject_reason_ph: {
        uk: "\u0429\u043E \u043F\u043E\u0442\u0440\u0456\u0431\u043D\u043E \u0432\u0438\u043F\u0440\u0430\u0432\u0438\u0442\u0438?",
        en: "What needs to be fixed?",
        hy: "\u053B\u055E\u0576\u0579\u0568 \u057A\u0565\u057F\u0584 \u0567 \u0577\u057F\u056F\u0565\u056C\u0589",
        ka: "\u10E0\u10D0 \u10E3\u10DC\u10D3\u10D0 \u10D2\u10D0\u10DB\u10DD\u10E1\u10EC\u10DD\u10E0\u10D3\u10D4\u10E1?"
    },
    row_actions: {
        uk: "\u0414\u0456\u0457",
        en: "Row actions",
        hy: "\u0533\u0578\u0580\u056E\u0578\u0572\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580",
        ka: "\u10DB\u10DD\u10E5\u10DB\u10D4\u10D3\u10D4\u10D1\u10D4\u10D1\u10D8"
    },
    sections: {
        uk: "\u0420\u043E\u0437\u0434\u0456\u043B\u0438",
        en: "Sections",
        hy: "\u0532\u0561\u056A\u056B\u0576\u0576\u0565\u0580",
        ka: "\u10E1\u10D4\u10E5\u10EA\u10D8\u10D4\u10D1\u10D8"
    },
    show_on_map: {
        uk: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u043D\u0430 \u043A\u0430\u0440\u0442\u0456",
        en: "Show on map",
        hy: "\u0551\u0578\u0582\u0575\u0581 \u057F\u0561\u056C \u0584\u0561\u0580\u057F\u0565\u0566\u056B\u0576",
        ka: "\u10E0\u10E3\u10D9\u10D0\u10D6\u10D4 \u10E9\u10D5\u10D4\u10DC\u10D4\u10D1\u10D0"
    },
    view_details: {
        uk: "\u0414\u0435\u0442\u0430\u043B\u0456",
        en: "View details",
        hy: "\u0544\u0561\u0576\u0580\u0561\u0574\u0561\u057D\u0576\u0565\u0580",
        ka: "\u10D3\u10D4\u10E2\u10D0\u10DA\u10D4\u10D1\u10D8"
    },
    visit_end: {
        uk: "\u041A\u0456\u043D\u0435\u0446\u044C \u0432\u0456\u0437\u0438\u0442\u0443",
        en: "Visit end",
        hy: "\u0531\u0575\u0581\u056B \u0561\u057E\u0561\u0580\u057F\u0568",
        ka: "\u10D5\u10D8\u10D6\u10D8\u10E2\u10D8\u10E1 \u10D3\u10D0\u10E1\u10D0\u10E1\u10E0\u10E3\u10DA\u10D8"
    },
    all_reviewed: {
        uk: "\u0412\u0441\u0435 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u043E",
        en: "All reviewed",
        hy: "\u0531\u0574\u0565\u0576 \u056B\u0576\u0579 \u057D\u057F\u0578\u0582\u0563\u057E\u0561\u056E \u0567",
        ka: "\u10E7\u10D5\u10D4\u10DA\u10D0\u10E4\u10D4\u10E0\u10D8 \u10E8\u10D4\u10DB\u10DD\u10EC\u10DB\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0"
    },
    approve_visits_msg: {
        uk: "\u0417\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043E \u0432\u0456\u0437\u0438\u0442\u0456\u0432: {n}",
        en: "{n} visits approved",
        hy: "\u0540\u0561\u057D\u057F\u0561\u057F\u057E\u0561\u056E \u0561\u0575\u0581\u0565\u0580\u055D {n}",
        ka: "\u10D3\u10D0\u10DB\u10E2\u10D9\u10D8\u10EA\u10D4\u10D1\u10E3\u10DA\u10D8 \u10D5\u10D8\u10D6\u10D8\u10E2\u10D4\u10D1\u10D8: {n}"
    },
    gps_track: {
        uk: "GPS-\u0442\u0440\u0435\u043A",
        en: "GPS track",
        hy: "GPS \u0565\u0580\u0569\u0578\u0582\u0572\u056B",
        ka: "GPS \u10E2\u10E0\u10D4\u10D9\u10D8"
    },
    needs_attention: {
        uk: "\u041F\u043E\u0442\u0440\u0435\u0431\u0443\u0454 \u0443\u0432\u0430\u0433\u0438",
        en: "Needs your attention",
        hy: "\u054A\u0561\u0570\u0561\u0576\u057B\u0578\u0582\u0574 \u0567 \u0571\u0565\u0580 \u0578\u0582\u0577\u0561\u0564\u0580\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0568",
        ka: "\u10E1\u10D0\u10ED\u10D8\u10E0\u10DD\u10D4\u10D1\u10E1 \u10D7\u10E5\u10D5\u10D4\u10DC\u10E1 \u10E7\u10E3\u10E0\u10D0\u10D3\u10E6\u10D4\u10D1\u10D0\u10E1"
    },
    off_route: {
        uk: "\u041F\u043E\u0437\u0430 \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u043E\u043C",
        en: "Off route",
        hy: "\u0535\u0580\u0569\u0578\u0582\u0572\u0578\u0582\u0581 \u0564\u0578\u0582\u0580\u057D",
        ka: "\u10DB\u10D0\u10E0\u10E8\u10E0\u10E3\u10E2\u10D8\u10E1 \u10D2\u10D0\u10E0\u10D4\u10D7"
    },
    on_route: {
        uk: "\u0417\u0430 \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u043E\u043C",
        en: "On the route",
        hy: "\u0535\u0580\u0569\u0578\u0582\u0572\u0578\u057E",
        ka: "\u10DB\u10D0\u10E0\u10E8\u10E0\u10E3\u10E2\u10D6\u10D4"
    },
    record_approved: {
        uk: "\u0417\u0430\u043F\u0438\u0441 \u0437\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043E",
        en: "Record approved",
        hy: "\u0533\u0580\u0561\u057C\u0578\u0582\u0574\u0568 \u0570\u0561\u057D\u057F\u0561\u057F\u057E\u0561\u056E \u0567",
        ka: "\u10E9\u10D0\u10DC\u10D0\u10EC\u10D4\u10E0\u10D8 \u10D3\u10D0\u10DB\u10E2\u10D9\u10D8\u10EA\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0"
    },
    record_rejected: {
        uk: "\u0417\u0430\u043F\u0438\u0441 \u0432\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043E",
        en: "Record rejected",
        hy: "\u0533\u0580\u0561\u057C\u0578\u0582\u0574\u0568 \u0574\u0565\u0580\u056A\u057E\u0561\u056E \u0567",
        ka: "\u10E9\u10D0\u10DC\u10D0\u10EC\u10D4\u10E0\u10D8 \u10E3\u10D0\u10E0\u10E7\u10DD\u10E4\u10D8\u10DA\u10D8\u10D0"
    },
    /* Mock-GPS pings on the track (PICSELL-1581 #5) — shown only when the mobile app flags one. */ gps_mock_warning: {
        uk: "\u0412\u0438\u044F\u0432\u043B\u0435\u043D\u043E \u043E\u0437\u043D\u0430\u043A\u0438 \u043F\u0456\u0434\u0440\u043E\u0431\u043B\u0435\u043D\u043E\u0433\u043E GPS: \u043F\u043E\u0437\u043D\u0430\u0447\u043E\u043A \u2014 {n}. \u041F\u0435\u0440\u0435\u0432\u0456\u0440\u0442\u0435 \u0432\u0456\u0437\u0438\u0442.",
        en: "Possible fake GPS detected: {n} flagged points. Review this visit.",
        hy: "\u0540\u0576\u0561\u0580\u0561\u057E\u0578\u0580 \u056F\u0565\u0572\u056E GPS\u055D {n} \u0576\u0577\u057E\u0561\u056E \u056F\u0565\u057F\u0589 \u054D\u057F\u0578\u0582\u0563\u0565\u0584 \u0561\u0575\u0581\u0568\u0589",
        ka: "\u10E8\u10D4\u10E1\u10D0\u10EB\u10DA\u10DD \u10E7\u10D0\u10DA\u10D1\u10D8 GPS: {n} \u10DB\u10DD\u10DC\u10D8\u10E8\u10DC\u10E3\u10DA\u10D8 \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8. \u10D2\u10D0\u10D3\u10D0\u10D0\u10DB\u10DD\u10EC\u10DB\u10D4\u10D7 \u10D5\u10D8\u10D6\u10D8\u10E2\u10D8."
    },
    gps_from_point: {
        uk: "\u0427\u0430\u0441 \u0456 \u0432\u0456\u0434\u0441\u0442\u0430\u043D\u044C \u0434\u043E \u0442\u043E\u0447\u043A\u0438 \u0432\u0456\u0437\u0438\u0442\u0443",
        en: "Time and distance from the visit point",
        hy: "\u053A\u0561\u0574\u0568 \u0587 \u0570\u0565\u057C\u0561\u057E\u0578\u0580\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0568 \u0561\u0575\u0581\u056B \u056F\u0565\u057F\u056B\u0581",
        ka: "\u10D3\u10E0\u10DD \u10D3\u10D0 \u10D3\u10D0\u10E8\u10DD\u10E0\u10D4\u10D1\u10D0 \u10D5\u10D8\u10D6\u10D8\u10E2\u10D8\u10E1 \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8\u10D3\u10D0\u10DC"
    },
    gps_mock_tag: {
        uk: "\u041F\u0456\u0434\u0440\u043E\u0431\u043B\u0435\u043D\u0438\u0439 GPS",
        en: "Fake GPS",
        hy: "\u053F\u0565\u0572\u056E GPS",
        ka: "\u10E7\u10D0\u10DA\u10D1\u10D8 GPS"
    },
    gps_m: {
        uk: "\u043C",
        en: "m",
        hy: "\u0574",
        ka: "\u10DB"
    },
    gps_km: {
        uk: "\u043A\u043C",
        en: "km",
        hy: "\u056F\u0574",
        ka: "\u10D9\u10DB"
    },
    /* The bulk bar's result — a number, never a noun that must agree with it (spec/04). */ records_approved: {
        uk: "\u0417\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043E: {n}",
        en: "Approved: {n}",
        hy: "\u0540\u0561\u057D\u057F\u0561\u057F\u057E\u0561\u056E \u0567\u055D {n}",
        ka: "\u10D3\u10D0\u10DB\u10E2\u10D9\u10D8\u10EA\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0: {n}"
    },
    records_rejected: {
        uk: "\u0412\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043E: {n}",
        en: "Rejected: {n}",
        hy: "\u0544\u0565\u0580\u056A\u057E\u0561\u056E \u0567\u055D {n}",
        ka: "\u10E3\u10D0\u10E0\u10E7\u10DD\u10E4\u10D8\u10DA\u10D8\u10D0: {n}"
    },
    reject_visits_msg: {
        uk: "\u0412\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043E \u0432\u0456\u0437\u0438\u0442\u0456\u0432: {n}",
        en: "{n} visits rejected",
        hy: "\u0544\u0565\u0580\u056A\u057E\u0561\u056E \u0561\u0575\u0581\u0565\u0580\u055D {n}",
        ka: "\u10E3\u10D0\u10E0\u10E7\u10DD\u10E4\u10D8\u10DA\u10D8 \u10D5\u10D8\u10D6\u10D8\u10E2\u10D4\u10D1\u10D8: {n}"
    }
};
const $fc3f36407bc5ec6c$export$ac552071080927b0 = {
    // section + generic
    section_points: {
        uk: "\u0422\u043E\u0447\u043A\u0438",
        en: "Points",
        hy: "\u053F\u0565\u057F\u0565\u0580",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8"
    },
    new_btn: {
        uk: "\u0414\u043E\u0434\u0430\u0442\u0438",
        en: "New",
        hy: "\u0546\u0578\u0580",
        ka: "\u10D0\u10EE\u10D0\u10DA\u10D8"
    },
    save_btn: {
        uk: "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438",
        en: "Save",
        hy: "\u054A\u0561\u0570\u057A\u0561\u0576\u0565\u056C",
        ka: "\u10E8\u10D4\u10DC\u10D0\u10EE\u10D5\u10D0"
    },
    /* ⚠ `create_btn` was ASKED FOR and never existed. `ResourcePage` renders
     `{isNew ? t("create_btn") : t("save_btn")}` as the children of a `<Button icon={<SaveOutlined/>}>`,
     `translate()` returns null for an unknown key, and antd applies `ant-btn-icon-only` when a
     button has an icon and no children — so the save control on every /<resource>/new page was a
     bare disk glyph with no label (PICSELL-1574 #26, #30). `summary` and `discard_confirm` were
     missing the same way: an empty rail heading and a titleless confirm modal. */ create_btn: {
        uk: "\u0421\u0442\u0432\u043E\u0440\u0438\u0442\u0438",
        en: "Create",
        hy: "\u054D\u057F\u0565\u0572\u056E\u0565\u056C",
        ka: "\u10E8\u10D4\u10E5\u10DB\u10DC\u10D0"
    },
    summary: {
        uk: "\u0417\u0432\u0435\u0434\u0435\u043D\u043D\u044F",
        en: "Summary",
        hy: "\u0531\u0574\u0583\u0578\u0583\u0578\u0582\u0574",
        ka: "\u10E8\u10D4\u10EF\u10D0\u10DB\u10D4\u10D1\u10D0"
    },
    discard_confirm: {
        uk: "\u0412\u0456\u0434\u0445\u0438\u043B\u0438\u0442\u0438 \u043D\u0435\u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u0456 \u0437\u043C\u0456\u043D\u0438?",
        en: "Discard unsaved changes?",
        hy: "\u0549\u0565\u0572\u0561\u0580\u056F\u0565\u055E\u056C \u0579\u057A\u0561\u0570\u057A\u0561\u0576\u057E\u0561\u056E \u0583\u0578\u0583\u0578\u056D\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580\u0568\u0589",
        ka: "\u10D2\u10D0\u10D5\u10D0\u10E3\u10E5\u10DB\u10DD\u10D7 \u10E8\u10D4\u10DC\u10D0\u10EE\u10E3\u10DA\u10D8 \u10EA\u10D5\u10DA\u10D8\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8?"
    },
    delete_btn: {
        uk: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438",
        en: "Delete",
        hy: "\u054B\u0576\u057B\u0565\u056C",
        ka: "\u10EC\u10D0\u10E8\u10DA\u10D0"
    },
    back_btn: {
        uk: "\u041D\u0430\u0437\u0430\u0434",
        en: "Back",
        hy: "\u0540\u0565\u057F",
        ka: "\u10E3\u10D9\u10D0\u10DC"
    },
    edit_btn: {
        uk: "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438",
        en: "Edit",
        hy: "\u053D\u0574\u0562\u0561\u0563\u0580\u0565\u056C",
        ka: "\u10E0\u10D4\u10D3\u10D0\u10E5\u10E2\u10D8\u10E0\u10D4\u10D1\u10D0"
    },
    view_btn: {
        uk: "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u0434",
        en: "View",
        hy: "\u0534\u056B\u057F\u0565\u056C",
        ka: "\u10DC\u10D0\u10EE\u10D5\u10D0"
    },
    search_ph: {
        uk: "\u041F\u043E\u0448\u0443\u043A",
        en: "Search",
        hy: "\u0548\u0580\u0578\u0576\u0578\u0582\u0574",
        ka: "\u10EB\u10D4\u10D1\u10DC\u10D0"
    },
    confirm_delete: {
        uk: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0446\u0435\u0439 \u0437\u0430\u043F\u0438\u0441?",
        en: "Delete this record?",
        hy: "\u054B\u0576\u057B\u0565\u056C \u0561\u0575\u057D \u0563\u0580\u0561\u057C\u0578\u0582\u0574\u0568?",
        ka: "\u10EC\u10D0\u10D5\u10E8\u10D0\u10DA\u10DD \u10D4\u10E1 \u10E9\u10D0\u10DC\u10D0\u10EC\u10D4\u10E0\u10D8?"
    },
    saved: {
        uk: "\u0417\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043E",
        en: "Saved",
        hy: "\u054A\u0561\u0570\u057A\u0561\u0576\u057E\u0561\u056E \u0567",
        ka: "\u10E8\u10D4\u10DC\u10D0\u10EE\u10E3\u10DA\u10D8\u10D0"
    },
    save_error: {
        uk: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043D\u044F",
        en: "Error while saving",
        hy: "\u054A\u0561\u0570\u057A\u0561\u0576\u0574\u0561\u0576 \u057D\u056D\u0561\u056C",
        ka: "\u10E8\u10D4\u10DC\u10D0\u10EE\u10D5\u10D8\u10E1 \u10E8\u10D4\u10EA\u10D3\u10DD\u10DB\u10D0"
    },
    deleted: {
        uk: "\u0412\u0438\u0434\u0430\u043B\u0435\u043D\u043E",
        en: "Deleted",
        hy: "\u054B\u0576\u057B\u057E\u0561\u056E \u0567",
        ka: "\u10EC\u10D0\u10E8\u10DA\u10D8\u10DA\u10D8\u10D0"
    },
    empty: {
        uk: "\u041D\u0435\u043C\u0430\u0454 \u0434\u0430\u043D\u0438\u0445",
        en: "No data",
        hy: "\u054F\u057E\u0575\u0561\u056C\u0576\u0565\u0580 \u0579\u056F\u0561\u0576",
        ka: "\u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1"
    },
    // shared field labels
    f_name: {
        uk: "\u041D\u0430\u0437\u0432\u0430",
        en: "Name",
        hy: "\u0531\u0576\u057E\u0561\u0576\u0578\u0582\u0574",
        ka: "\u10E1\u10D0\u10EE\u10D4\u10DA\u10D8"
    },
    f_code: {
        uk: "\u041A\u043E\u0434",
        en: "Code",
        hy: "\u053F\u0578\u0564",
        ka: "\u10D9\u10DD\u10D3\u10D8"
    },
    f_image: {
        uk: "\u0417\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F",
        en: "Image",
        hy: "\u0546\u056F\u0561\u0580",
        ka: "\u10E1\u10E3\u10E0\u10D0\u10D7\u10D8"
    },
    f_logo: {
        uk: "\u041B\u043E\u0433\u043E\u0442\u0438\u043F",
        en: "Logo",
        hy: "\u053C\u0578\u0563\u0578",
        ka: "\u10DA\u10DD\u10D2\u10DD"
    },
    f_address: {
        uk: "\u0410\u0434\u0440\u0435\u0441\u0430",
        en: "Address",
        hy: "\u0540\u0561\u057D\u0581\u0565",
        ka: "\u10DB\u10D8\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10D8"
    },
    f_network: {
        uk: "\u041C\u0435\u0440\u0435\u0436\u0430",
        en: "Network",
        hy: "\u0551\u0561\u0576\u0581",
        ka: "\u10E5\u10E1\u10D4\u10DA\u10D8"
    },
    f_category: {
        uk: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u044F",
        en: "Category",
        hy: "\u053F\u0561\u057F\u0565\u0563\u0578\u0580\u056B\u0561",
        ka: "\u10D9\u10D0\u10E2\u10D4\u10D2\u10DD\u10E0\u10D8\u10D0"
    },
    f_country: {
        uk: "\u041A\u0440\u0430\u0457\u043D\u0430",
        en: "Country",
        hy: "\u0535\u0580\u056F\u056B\u0580",
        ka: "\u10E5\u10D5\u10D4\u10E7\u10D0\u10DC\u10D0"
    },
    f_county: {
        uk: "\u0420\u0435\u0433\u0456\u043E\u043D",
        en: "County",
        hy: "\u0544\u0561\u0580\u0566",
        ka: "\u10E0\u10D4\u10D2\u10D8\u10DD\u10DC\u10D8"
    },
    f_locality: {
        uk: "\u041D\u0430\u0441\u0435\u043B\u0435\u043D\u0438\u0439 \u043F\u0443\u043D\u043A\u0442",
        en: "Locality",
        hy: "\u0532\u0576\u0561\u056F\u0561\u057E\u0561\u0575\u0580",
        ka: "\u10D3\u10D0\u10E1\u10D0\u10EE\u10DA\u10D4\u10D1\u10E3\u10DA\u10D8 \u10DE\u10E3\u10DC\u10E5\u10E2\u10D8"
    },
    f_location: {
        uk: "\u041A\u043E\u043E\u0440\u0434\u0438\u043D\u0430\u0442\u0438",
        en: "Coordinates",
        hy: "\u053F\u0578\u0578\u0580\u0564\u056B\u0576\u0561\u057F\u0576\u0565\u0580",
        ka: "\u10D9\u10DD\u10DD\u10E0\u10D3\u10D8\u10DC\u10D0\u10E2\u10D4\u10D1\u10D8"
    },
    f_lat: {
        uk: "\u0428\u0438\u0440\u043E\u0442\u0430",
        en: "Latitude",
        hy: "\u053C\u0561\u0575\u0576\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10D2\u10D0\u10DC\u10D4\u10D3\u10D8"
    },
    f_lng: {
        uk: "\u0414\u043E\u0432\u0433\u043E\u0442\u0430",
        en: "Longitude",
        hy: "\u0535\u0580\u056F\u0561\u0575\u0576\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10D2\u10E0\u10EB\u10D4\u10D3\u10D8"
    },
    f_minutes: {
        uk: "\u0420\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u043E\u0432\u0430\u043D\u0456 \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
        en: "Recommended minutes",
        hy: "\u0531\u057C\u0561\u057B\u0561\u0580\u056F\u057E\u0578\u0572 \u0580\u0578\u057A\u0565\u0576\u0565\u0580",
        ka: "\u10E0\u10D4\u10D9\u10DD\u10DB\u10D4\u10DC\u10D3\u10D4\u10D1\u10E3\u10DA\u10D8 \u10EC\u10E3\u10D7\u10D4\u10D1\u10D8"
    },
    f_merchandiser: {
        uk: "\u041C\u0435\u0440\u0447\u0435\u043D\u0434\u0430\u0439\u0437\u0435\u0440",
        en: "Merchandiser",
        hy: "\u0544\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580",
        ka: "\u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D8"
    },
    f_supervisors: {
        uk: "\u0421\u0443\u043F\u0435\u0440\u0432\u0430\u0439\u0437\u0435\u0440\u0438",
        en: "Supervisors",
        hy: "\u054D\u0578\u0582\u057A\u0565\u0580\u057E\u0561\u0575\u0566\u0565\u0580\u0576\u0565\u0580",
        ka: "\u10E1\u10E3\u10DE\u10D4\u10E0\u10D5\u10D0\u10D8\u10D6\u10D4\u10E0\u10D4\u10D1\u10D8"
    },
    f_is_active: {
        uk: "\u0410\u043A\u0442\u0438\u0432\u043D\u0430",
        en: "Active",
        hy: "\u0531\u056F\u057F\u056B\u057E",
        ka: "\u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D8"
    },
    f_available_tasks: {
        uk: "\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u0430 \u0434\u043B\u044F \u0437\u0430\u0432\u0434\u0430\u043D\u044C",
        en: "Available for tasks",
        hy: "\u0540\u0561\u057D\u0561\u0576\u0565\u056C\u056B \u0567 \u0561\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0576\u0565\u0580\u056B \u0570\u0561\u0574\u0561\u0580",
        ka: "\u10EE\u10D4\u10DA\u10DB\u10D8\u10E1\u10D0\u10EC\u10D5\u10D3\u10DD\u10DB\u10D8\u10D0 \u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1"
    },
    f_additional_info: {
        uk: "\u0414\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0430 \u0456\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0456\u044F",
        en: "Additional info",
        hy: "\u053C\u0580\u0561\u0581\u0578\u0582\u0581\u056B\u0579 \u057F\u0565\u0572\u0565\u056F\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580",
        ka: "\u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D8\u10D7\u10D8 \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D0"
    },
    filter_created_by_me: {
        uk: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u0456 \u043C\u043D\u043E\u044E",
        en: "Created by me",
        hy: "\u053B\u0574 \u057D\u057F\u0565\u0572\u056E\u0561\u056E",
        ka: "\u10E9\u10D4\u10DB \u10DB\u10D8\u10D4\u10E0 \u10E8\u10D4\u10E5\u10DB\u10DC\u10D8\u10DA\u10D8"
    },
    kv_key: {
        uk: "\u041C\u0456\u0442\u043A\u0430",
        en: "Label",
        hy: "\u054A\u056B\u057F\u0561\u056F",
        ka: "\u10D8\u10D0\u10E0\u10DA\u10D8\u10E7\u10D8"
    },
    kv_value: {
        uk: "\u0417\u043D\u0430\u0447\u0435\u043D\u043D\u044F",
        en: "Value",
        hy: "\u0531\u0580\u056A\u0565\u0584",
        ka: "\u10DB\u10DC\u10D8\u10E8\u10D5\u10DC\u10D4\u10DA\u10DD\u10D1\u10D0"
    },
    kv_add: {
        uk: "\u0414\u043E\u0434\u0430\u0442\u0438 \u043F\u043E\u043B\u0435",
        en: "Add field",
        hy: "\u0531\u057E\u0565\u056C\u0561\u0581\u0576\u0565\u056C \u0564\u0561\u0577\u057F",
        ka: "\u10D5\u10D4\u10DA\u10D8\u10E1 \u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D0"
    },
    f_price_monitoring: {
        uk: "\u041C\u043E\u043D\u0456\u0442\u043E\u0440\u0438\u043D\u0433 \u0446\u0456\u043D",
        en: "Price monitoring",
        hy: "\u0533\u0576\u0565\u0580\u056B \u0574\u0578\u0576\u056B\u057F\u0578\u0580\u056B\u0576\u0563",
        ka: "\u10E4\u10D0\u10E1\u10D4\u10D1\u10D8\u10E1 \u10DB\u10DD\u10DC\u10D8\u10E2\u10DD\u10E0\u10D8\u10DC\u10D2\u10D8"
    },
    f_pm_components: {
        uk: "\u041A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u0438 \u043C\u043E\u043D\u0456\u0442\u043E\u0440\u0438\u043D\u0433\u0443",
        en: "Price monitoring components",
        hy: "\u0533\u0576\u0565\u0580\u056B \u0574\u0578\u0576\u056B\u057F\u0578\u0580\u056B\u0576\u0563\u056B \u0562\u0561\u0572\u0561\u0564\u0580\u056B\u0579\u0576\u0565\u0580",
        ka: "\u10E4\u10D0\u10E1\u10D4\u10D1\u10D8\u10E1 \u10DB\u10DD\u10DC\u10D8\u10E2\u10DD\u10E0\u10D8\u10DC\u10D2\u10D8\u10E1 \u10D9\u10DD\u10DB\u10DE\u10DD\u10DC\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8"
    },
    f_pm_required: {
        uk: "\u041E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0456 \u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u0438",
        en: "Required components",
        hy: "\u054A\u0561\u0580\u057F\u0561\u0564\u056B\u0580 \u0562\u0561\u0572\u0561\u0564\u0580\u056B\u0579\u0576\u0565\u0580",
        ka: "\u10E1\u10D0\u10D5\u10D0\u10DA\u10D3\u10D4\u10D1\u10E3\u10DA\u10D8 \u10D9\u10DD\u10DB\u10DE\u10DD\u10DC\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8"
    },
    f_send_outforz: {
        uk: "\u041D\u0430\u0434\u0441\u0438\u043B\u0430\u0442\u0438 \u0432 Outforz",
        en: "Send to Outforz",
        hy: "\u0548\u0582\u0572\u0561\u0580\u056F\u0565\u056C Outforz",
        ka: "\u10D2\u10D0\u10D2\u10D6\u10D0\u10D5\u10DC\u10D0 Outforz-\u10E8\u10D8"
    },
    f_auto_approve: {
        uk: "\u0410\u0432\u0442\u043E\u0437\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043D\u044F \u0437\u0432\u0456\u0442\u0456\u0432",
        en: "Auto-approve reports",
        hy: "\u0540\u0561\u0577\u057E\u0565\u057F\u057E\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580\u056B \u0561\u057E\u057F\u0578\u0570\u0561\u057D\u057F\u0561\u057F\u0578\u0582\u0574",
        ka: "\u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10D4\u10D1\u10D8\u10E1 \u10D0\u10D5\u10E2\u10DD\u10DB\u10D0\u10E2\u10E3\u10E0\u10D8 \u10D3\u10D0\u10DB\u10E2\u10D9\u10D8\u10EA\u10D4\u10D1\u10D0"
    },
    f_status_outforz: {
        uk: "\u0421\u0442\u0430\u0442\u0443\u0441 \u0434\u043B\u044F Outforz",
        en: "Status to send to Outforz",
        hy: "\u053F\u0561\u0580\u0563\u0561\u057E\u056B\u0573\u0561\u056F Outforz-\u056B\u0576 \u0578\u0582\u0572\u0561\u0580\u056F\u0565\u056C\u0578\u0582 \u0570\u0561\u0574\u0561\u0580",
        ka: "\u10E1\u10E2\u10D0\u10E2\u10E3\u10E1\u10D8 Outforz-\u10E8\u10D8 \u10D2\u10D0\u10E1\u10D0\u10D2\u10D6\u10D0\u10D5\u10DC\u10D0\u10D3"
    },
    f_default_tags: {
        uk: "\u0422\u0435\u0433\u0438 \u0437\u0430 \u0437\u0430\u043C\u043E\u0432\u0447\u0443\u0432\u0430\u043D\u043D\u044F\u043C",
        en: "Default tags",
        hy: "\u053F\u0561\u0576\u056D\u0561\u0564\u0580\u057E\u0561\u056E \u0569\u0565\u0563\u0565\u0580",
        ka: "\u10DC\u10D0\u10D2\u10E3\u10DA\u10D8\u10E1\u10EE\u10DB\u10D4\u10D5\u10D8 \u10E2\u10D4\u10D2\u10D4\u10D1\u10D8"
    },
    f_created_by: {
        uk: "\u0421\u0442\u0432\u043E\u0440\u0438\u0432",
        en: "Created by",
        hy: "\u054D\u057F\u0565\u0572\u056E\u0578\u0572",
        ka: "\u10E8\u10D4\u10DB\u10E5\u10DB\u10DC\u10D4\u10DA\u10D8"
    },
    f_available_supervisors: {
        uk: "\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u043E \u0441\u0443\u043F\u0435\u0440\u0432\u0430\u0439\u0437\u0435\u0440\u0430\u043C",
        en: "Available for supervisors",
        hy: "\u0540\u0561\u057D\u0561\u0576\u0565\u056C\u056B \u057D\u0578\u0582\u057A\u0565\u0580\u057E\u0561\u0575\u0566\u0565\u0580\u0576\u0565\u0580\u056B\u0576",
        ka: "\u10EE\u10D4\u10DA\u10DB\u10D8\u10E1\u10D0\u10EC\u10D5\u10D3\u10DD\u10DB\u10D8\u10D0 \u10E1\u10E3\u10DE\u10D4\u10E0\u10D5\u10D0\u10D8\u10D6\u10D4\u10E0\u10D4\u10D1\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1"
    },
    f_points: {
        uk: "\u0422\u043E\u0447\u043A\u0438",
        en: "Points",
        hy: "\u053F\u0565\u057F\u0565\u0580",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8"
    },
    // per-entity title keys
    networks_title: {
        uk: "\u041C\u0435\u0440\u0435\u0436\u0456",
        en: "Networks",
        hy: "\u0551\u0561\u0576\u0581\u0565\u0580",
        ka: "\u10E5\u10E1\u10D4\u10DA\u10D4\u10D1\u10D8"
    },
    countries_title: {
        uk: "\u041A\u0440\u0430\u0457\u043D\u0438",
        en: "Countries",
        hy: "\u0535\u0580\u056F\u0580\u0576\u0565\u0580",
        ka: "\u10E5\u10D5\u10D4\u10E7\u10DC\u10D4\u10D1\u10D8"
    },
    counties_title: {
        uk: "\u0420\u0435\u0433\u0456\u043E\u043D\u0438",
        en: "Counties",
        hy: "\u0544\u0561\u0580\u0566\u0565\u0580",
        ka: "\u10E0\u10D4\u10D2\u10D8\u10DD\u10DC\u10D4\u10D1\u10D8"
    },
    localities_title: {
        uk: "\u041D\u0430\u0441\u0435\u043B\u0435\u043D\u0456 \u043F\u0443\u043D\u043A\u0442\u0438",
        en: "Localities",
        hy: "\u0532\u0576\u0561\u056F\u0561\u057E\u0561\u0575\u0580\u0565\u0580",
        ka: "\u10D3\u10D0\u10E1\u10D0\u10EE\u10DA\u10D4\u10D1\u10E3\u10DA\u10D8 \u10DE\u10E3\u10DC\u10E5\u10E2\u10D4\u10D1\u10D8"
    },
    categories_title: {
        uk: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u0457 \u0442\u043E\u0447\u043E\u043A",
        en: "Point categories",
        hy: "\u053F\u0565\u057F\u0565\u0580\u056B \u056F\u0561\u057F\u0565\u0563\u0578\u0580\u056B\u0561\u0576\u0565\u0580",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1 \u10D9\u10D0\u10E2\u10D4\u10D2\u10DD\u10E0\u10D8\u10D4\u10D1\u10D8"
    },
    points_title: {
        uk: "\u0422\u043E\u0447\u043A\u0438",
        en: "Points",
        hy: "\u053F\u0565\u057F\u0565\u0580",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8"
    },
    point_groups_title: {
        uk: "\u0413\u0440\u0443\u043F\u0438 \u0442\u043E\u0447\u043E\u043A",
        en: "Point groups",
        hy: "\u053F\u0565\u057F\u0565\u0580\u056B \u056D\u0574\u0562\u0565\u0580",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1 \u10EF\u10D2\u10E3\u10E4\u10D4\u10D1\u10D8"
    },
    // status pill
    active: {
        uk: "\u0410\u043A\u0442\u0438\u0432\u043D\u0430",
        en: "Active",
        hy: "\u0531\u056F\u057F\u056B\u057E",
        ka: "\u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D8"
    },
    inactive: {
        uk: "\u041D\u0435\u0430\u043A\u0442\u0438\u0432\u043D\u0430",
        en: "Inactive",
        hy: "\u0548\u0579 \u0561\u056F\u057F\u056B\u057E",
        ka: "\u10D0\u10E0\u10D0\u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D8"
    },
    f_status: {
        uk: "\u0421\u0442\u0430\u0442\u0443\u0441",
        en: "Status",
        hy: "\u053F\u0561\u0580\u0563\u0561\u057E\u056B\u0573\u0561\u056F",
        ka: "\u10E1\u10E2\u10D0\u10E2\u10E3\u10E1\u10D8"
    },
    activate_btn: {
        uk: "\u0410\u043A\u0442\u0438\u0432\u0443\u0432\u0430\u0442\u0438",
        en: "Activate",
        hy: "\u0531\u056F\u057F\u056B\u057E\u0561\u0581\u0576\u0565\u056C",
        ka: "\u10D2\u10D0\u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D4\u10D1\u10D0"
    },
    deactivate_btn: {
        uk: "\u0414\u0435\u0430\u043A\u0442\u0438\u0432\u0443\u0432\u0430\u0442\u0438",
        en: "Deactivate",
        hy: "\u0534\u0565\u0561\u056F\u057F\u056B\u057E\u0561\u0581\u0576\u0565\u056C",
        ka: "\u10D3\u10D4\u10D0\u10E5\u10E2\u10D8\u10D5\u10D0\u10EA\u10D8\u10D0"
    },
    confirm_deactivate: {
        uk: "\u0414\u0435\u0430\u043A\u0442\u0438\u0432\u0443\u0432\u0430\u0442\u0438 \u0446\u0435\u0439 \u0437\u0430\u043F\u0438\u0441?",
        en: "Deactivate this record?",
        hy: "\u0534\u0565\u0561\u056F\u057F\u056B\u057E\u0561\u0581\u0576\u0565\u056C \u0561\u0575\u057D \u0563\u0580\u0561\u057C\u0578\u0582\u0574\u0568?",
        ka: "\u10D3\u10D4\u10D0\u10E5\u10E2\u10D8\u10D5\u10D8\u10E0\u10D4\u10D1\u10D0 \u10D0\u10DB \u10E9\u10D0\u10DC\u10D0\u10EC\u10D4\u10E0\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1?"
    },
    // form sections
    sec_basic: {
        uk: "\u041E\u0441\u043D\u043E\u0432\u043D\u0435",
        en: "Basic info",
        hy: "\u0540\u056B\u0574\u0576\u0561\u056F\u0561\u0576 \u057F\u057E\u0575\u0561\u056C\u0576\u0565\u0580",
        ka: "\u10EB\u10D8\u10E0\u10D8\u10D7\u10D0\u10D3\u10D8 \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D0"
    },
    sec_location: {
        uk: "\u0420\u043E\u0437\u0442\u0430\u0448\u0443\u0432\u0430\u043D\u043D\u044F",
        en: "Location",
        hy: "\u054F\u0565\u0572\u0561\u0564\u0580\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10DB\u10D3\u10D4\u10D1\u10D0\u10E0\u10D4\u10DD\u10D1\u10D0"
    },
    sec_assignment: {
        uk: "\u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0430\u043B\u044C\u043D\u0456",
        en: "Assignment",
        hy: "\u0540\u0561\u0576\u0571\u0576\u0561\u0580\u0561\u0580\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10D3\u10D0\u10DC\u10D8\u10E8\u10D5\u10DC\u10D0"
    },
    sec_options: {
        uk: "\u041F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0438",
        en: "Options",
        hy: "\u0538\u0576\u057F\u0580\u0561\u0576\u0584\u0576\u0565\u0580",
        ka: "\u10DE\u10D0\u10E0\u10D0\u10DB\u10D4\u10E2\u10E0\u10D4\u10D1\u10D8"
    },
    // location picker
    search_address: {
        uk: "\u041F\u043E\u0448\u0443\u043A \u0430\u0434\u0440\u0435\u0441\u0438",
        en: "Search address",
        hy: "\u0540\u0561\u057D\u0581\u0565\u056B \u0578\u0580\u0578\u0576\u0578\u0582\u0574",
        ka: "\u10DB\u10D8\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10D8\u10E1 \u10EB\u10D4\u10D1\u10DC\u10D0"
    },
    search_btn: {
        uk: "\u0417\u043D\u0430\u0439\u0442\u0438",
        en: "Search",
        hy: "\u0553\u0576\u057F\u0580\u0565\u056C",
        ka: "\u10EB\u10D4\u10D1\u10DC\u10D0"
    },
    searching: {
        uk: "\u041F\u043E\u0448\u0443\u043A\u2026",
        en: "Searching\u2026",
        hy: "\u0548\u0580\u0578\u0576\u0578\u0582\u0574\u2026",
        ka: "\u10D8\u10EB\u10D4\u10D1\u10DC\u10D4\u10D1\u10D0\u2026"
    },
    not_found: {
        uk: "\u041D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
        en: "Not found",
        hy: "\u0549\u056B \u0563\u057F\u0576\u057E\u0565\u056C",
        ka: "\u10D0\u10E0 \u10DB\u10DD\u10D8\u10EB\u10D4\u10D1\u10DC\u10D0"
    },
    remove_image: {
        uk: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438",
        en: "Remove",
        hy: "\u0540\u0565\u057C\u0561\u0581\u0576\u0565\u056C",
        ka: "\u10EC\u10D0\u10E8\u10DA\u10D0"
    },
    crop_confirm: {
        uk: "\u041E\u0431\u0440\u0456\u0437\u0430\u0442\u0438",
        en: "Crop",
        hy: "\u053F\u057F\u0580\u0565\u056C",
        ka: "\u10DB\u10DD\u10ED\u10E0\u10D0"
    },
    crop_cancel: {
        uk: "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438",
        en: "Cancel",
        hy: "\u0549\u0565\u0572\u0561\u0580\u056F\u0565\u056C",
        ka: "\u10D2\u10D0\u10E3\u10E5\u10DB\u10D4\u10D1\u10D0"
    },
    // personnel management
    merchandisers_title: {
        uk: "\u041C\u0435\u0440\u0447\u0435\u043D\u0434\u0430\u0439\u0437\u0435\u0440\u0438",
        en: "Merchandisers",
        hy: "\u0544\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580\u0576\u0565\u0580",
        ka: "\u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D4\u10D1\u10D8"
    },
    supervisors_title: {
        uk: "\u0421\u0443\u043F\u0435\u0440\u0432\u0430\u0439\u0437\u0435\u0440\u0438",
        en: "Supervisors",
        hy: "\u054D\u0578\u0582\u057A\u0565\u0580\u057E\u0561\u0575\u0566\u0565\u0580\u0576\u0565\u0580",
        ka: "\u10E1\u10E3\u10DE\u10D4\u10E0\u10D5\u10D0\u10D8\u10D6\u10D4\u10E0\u10D4\u10D1\u10D8"
    },
    f_phone: {
        uk: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D",
        en: "Phone",
        hy: "\u0540\u0565\u057C\u0561\u056D\u0578\u057D",
        ka: "\u10E2\u10D4\u10DA\u10D4\u10E4\u10DD\u10DC\u10D8"
    },
    f_movement: {
        uk: "\u041F\u0435\u0440\u0435\u0441\u0443\u0432\u0430\u043D\u043D\u044F",
        en: "Movement",
        hy: "\u054F\u0565\u0572\u0561\u0577\u0561\u0580\u056A",
        ka: "\u10D2\u10D0\u10D3\u10D0\u10D0\u10D3\u10D2\u10D8\u10DA\u10D4\u10D1\u10D0"
    },
    f_first_name: {
        uk: "\u0406\u043C'\u044F",
        en: "First name",
        hy: "\u0531\u0576\u0578\u0582\u0576",
        ka: "\u10E1\u10D0\u10EE\u10D4\u10DA\u10D8"
    },
    f_last_name: {
        uk: "\u041F\u0440\u0456\u0437\u0432\u0438\u0449\u0435",
        en: "Last name",
        hy: "\u0531\u0566\u0563\u0561\u0576\u0578\u0582\u0576",
        ka: "\u10D2\u10D5\u10D0\u10E0\u10D8"
    },
    // surveys
    surveys_title: {
        uk: "\u041E\u043F\u0438\u0442\u0443\u0432\u0430\u043D\u043D\u044F",
        en: "Surveys",
        hy: "\u0540\u0561\u0580\u0581\u0578\u0582\u0574\u0576\u0565\u0580",
        ka: "\u10D2\u10D0\u10DB\u10DD\u10D9\u10D8\u10D7\u10EE\u10D5\u10D4\u10D1\u10D8"
    },
    sec_schedule: {
        uk: "\u0420\u043E\u0437\u043A\u043B\u0430\u0434",
        en: "Schedule",
        hy: "\u053A\u0561\u0574\u0561\u0576\u0561\u056F\u0561\u0581\u0578\u0582\u0575\u0581",
        ka: "\u10D2\u10D0\u10DC\u10E0\u10D8\u10D2\u10D8"
    },
    sec_audience: {
        uk: "\u0410\u0443\u0434\u0438\u0442\u043E\u0440\u0456\u044F",
        en: "Audience",
        hy: "\u053C\u057D\u0561\u0580\u0561\u0576",
        ka: "\u10D0\u10E3\u10D3\u10D8\u10E2\u10DD\u10E0\u10D8\u10D0"
    },
    sec_questions: {
        uk: "\u041F\u0438\u0442\u0430\u043D\u043D\u044F",
        en: "Questions",
        hy: "\u0540\u0561\u0580\u0581\u0565\u0580",
        ka: "\u10D9\u10D8\u10D7\u10EE\u10D5\u10D4\u10D1\u10D8"
    },
    sec_targeting: {
        uk: "\u0422\u0430\u0440\u0433\u0435\u0442\u0438\u043D\u0433",
        en: "Targeting",
        hy: "\u0539\u056B\u0580\u0561\u056D\u0561\u057E\u0578\u0580\u0578\u0582\u0574",
        ka: "\u10D7\u10D0\u10E0\u10D2\u10D4\u10D7\u10D8\u10E0\u10D4\u10D1\u10D0"
    },
    no_dropdown_options: {
        uk: "\u0412\u0430\u0440\u0456\u0430\u043D\u0442\u0438 \u0449\u0435 \u043D\u0435 \u0434\u043E\u0434\u0430\u043D\u0456",
        en: "No options yet",
        hy: "\u054F\u0561\u0580\u0562\u0565\u0580\u0561\u056F\u0576\u0565\u0580 \u0564\u0565\u057C \u0579\u056F\u0561\u0576",
        ka: "\u10D5\u10D0\u10E0\u10D8\u10D0\u10DC\u10E2\u10D4\u10D1\u10D8 \u10EF\u10D4\u10E0 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1"
    },
    f_title: {
        uk: "\u041D\u0430\u0437\u0432\u0430",
        en: "Title",
        hy: "\u054E\u0565\u0580\u0576\u0561\u0563\u056B\u0580",
        ka: "\u10E1\u10D0\u10D7\u10D0\u10E3\u10E0\u10D8"
    },
    f_description: {
        uk: "\u041E\u043F\u0438\u0441",
        en: "Description",
        hy: "\u0546\u056F\u0561\u0580\u0561\u0563\u0580\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10D0\u10E6\u10EC\u10D4\u10E0\u10D0"
    },
    f_active_from: {
        uk: "\u0410\u043A\u0442\u0438\u0432\u043D\u0438\u0439 \u0437",
        en: "Active from",
        hy: "\u0531\u056F\u057F\u056B\u057E \u0567 \u057D\u056F\u057D\u0561\u056E",
        ka: "\u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D8\u10D0 \u10D3\u10D0\u10DC"
    },
    f_active_to: {
        uk: "\u0410\u043A\u0442\u0438\u0432\u043D\u0438\u0439 \u0434\u043E",
        en: "Active to",
        hy: "\u0531\u056F\u057F\u056B\u057E \u0567 \u0574\u056B\u0576\u0579\u0587",
        ka: "\u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D8\u10D0 \u10DB\u10D3\u10D4"
    },
    f_form_organization_mode: {
        uk: "\u0420\u0435\u0436\u0438\u043C \u043E\u0440\u0433\u0430\u043D\u0456\u0437\u0430\u0446\u0456\u0457 \u0444\u043E\u0440\u043C\u0438",
        en: "Form organization mode",
        hy: "\u0541\u0587\u056B \u056F\u0561\u0566\u0574\u0561\u056F\u0565\u0580\u057A\u0574\u0561\u0576 \u057C\u0565\u056A\u056B\u0574",
        ka: "\u10E4\u10DD\u10E0\u10DB\u10D8\u10E1 \u10DD\u10E0\u10D2\u10D0\u10DC\u10D8\u10D6\u10D4\u10D1\u10D8\u10E1 \u10E0\u10D4\u10DF\u10D8\u10DB\u10D8"
    },
    f_audience: {
        uk: "\u0410\u0443\u0434\u0438\u0442\u043E\u0440\u0456\u044F",
        en: "Audience",
        hy: "\u053C\u057D\u0561\u0580\u0561\u0576",
        ka: "\u10D0\u10E3\u10D3\u10D8\u10E2\u10DD\u10E0\u10D8\u10D0"
    },
    f_questions: {
        uk: "\u041F\u0438\u0442\u0430\u043D\u043D\u044F",
        en: "Questions",
        hy: "\u0540\u0561\u0580\u0581\u0565\u0580",
        ka: "\u10D9\u10D8\u10D7\u10EE\u10D5\u10D4\u10D1\u10D8"
    },
    audience_target_type: {
        uk: "\u0422\u0438\u043F \u0430\u0443\u0434\u0438\u0442\u043E\u0440\u0456\u0457",
        en: "Target type",
        hy: "\u0539\u056B\u0580\u0561\u056D\u056B \u057F\u0565\u057D\u0561\u056F",
        ka: "\u10E1\u10D0\u10DB\u10D8\u10D6\u10DC\u10D8\u10E1 \u10E2\u10D8\u10DE\u10D8"
    },
    target_points: {
        uk: "\u0422\u043E\u0447\u043A\u0438",
        en: "Points",
        hy: "\u053F\u0565\u057F\u0565\u0580",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8"
    },
    target_point_groups: {
        uk: "\u0413\u0440\u0443\u043F\u0438 \u0442\u043E\u0447\u043E\u043A",
        en: "Point groups",
        hy: "\u053F\u0565\u057F\u0565\u0580\u056B \u056D\u0574\u0562\u0565\u0580",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1 \u10EF\u10D2\u10E3\u10E4\u10D4\u10D1\u10D8"
    },
    target_networks: {
        uk: "\u041C\u0435\u0440\u0435\u0436\u0456",
        en: "Networks",
        hy: "\u0551\u0561\u0576\u0581\u0565\u0580",
        ka: "\u10E5\u10E1\u10D4\u10DA\u10D4\u10D1\u10D8"
    },
    mode_products: {
        uk: "\u0422\u043E\u0432\u0430\u0440\u0438",
        en: "Products",
        hy: "\u0531\u057A\u0580\u0561\u0576\u0584\u0576\u0565\u0580",
        ka: "\u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10E2\u10D4\u10D1\u10D8"
    },
    mode_brands: {
        uk: "\u0411\u0440\u0435\u043D\u0434\u0438",
        en: "Brands",
        hy: "\u0532\u0580\u0565\u0576\u0564\u0576\u0565\u0580",
        ka: "\u10D1\u10E0\u10D4\u10DC\u10D3\u10D4\u10D1\u10D8"
    },
    mode_categories: {
        uk: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u0457",
        en: "Categories",
        hy: "\u053F\u0561\u057F\u0565\u0563\u0578\u0580\u056B\u0561\u0576\u0565\u0580",
        ka: "\u10D9\u10D0\u10E2\u10D4\u10D2\u10DD\u10E0\u10D8\u10D4\u10D1\u10D8"
    },
    mode_subcategories: {
        uk: "\u041F\u0456\u0434\u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u0457",
        en: "Subcategories",
        hy: "\u0535\u0576\u0569\u0561\u056F\u0561\u057F\u0565\u0563\u0578\u0580\u056B\u0561\u0576\u0565\u0580",
        ka: "\u10E5\u10D5\u10D4\u10D9\u10D0\u10E2\u10D4\u10D2\u10DD\u10E0\u10D8\u10D4\u10D1\u10D8"
    },
    question_add_btn: {
        uk: "\u0414\u043E\u0434\u0430\u0442\u0438 \u043F\u0438\u0442\u0430\u043D\u043D\u044F",
        en: "Add question",
        hy: "\u0531\u057E\u0565\u056C\u0561\u0581\u0576\u0565\u056C \u0570\u0561\u0580\u0581",
        ka: "\u10D9\u10D8\u10D7\u10EE\u10D5\u10D8\u10E1 \u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D0"
    },
    question_remove_btn: {
        uk: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u043F\u0438\u0442\u0430\u043D\u043D\u044F",
        en: "Remove question",
        hy: "\u0540\u0565\u057C\u0561\u0581\u0576\u0565\u056C \u0570\u0561\u0580\u0581\u0568",
        ka: "\u10D9\u10D8\u10D7\u10EE\u10D5\u10D8\u10E1 \u10EC\u10D0\u10E8\u10DA\u10D0"
    },
    f_question_text: {
        uk: "\u0422\u0435\u043A\u0441\u0442 \u043F\u0438\u0442\u0430\u043D\u043D\u044F",
        en: "Question text",
        hy: "\u0540\u0561\u0580\u0581\u056B \u057F\u0565\u0584\u057D\u057F",
        ka: "\u10D9\u10D8\u10D7\u10EE\u10D5\u10D8\u10E1 \u10E2\u10D4\u10E5\u10E1\u10E2\u10D8"
    },
    f_answer_type: {
        uk: "\u0422\u0438\u043F \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0456",
        en: "Answer type",
        hy: "\u054A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u056B \u057F\u0565\u057D\u0561\u056F",
        ka: "\u10DE\u10D0\u10E1\u10E3\u10EE\u10D8\u10E1 \u10E2\u10D8\u10DE\u10D8"
    },
    answer_numeric: {
        uk: "\u0427\u0438\u0441\u043B\u043E\u0432\u0435",
        en: "Numeric",
        hy: "\u0539\u057E\u0561\u0575\u056B\u0576",
        ka: "\u10E0\u10D8\u10EA\u10EE\u10D5\u10D8\u10D7\u10D8"
    },
    answer_text: {
        uk: "\u0422\u0435\u043A\u0441\u0442\u043E\u0432\u0435",
        en: "Text",
        hy: "\u054F\u0565\u0584\u057D\u057F\u0561\u0575\u056B\u0576",
        ka: "\u10E2\u10D4\u10E5\u10E1\u10E2\u10E3\u10E0\u10D8"
    },
    answer_photo: {
        uk: "\u0424\u043E\u0442\u043E",
        en: "Photo",
        hy: "\u053C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580",
        ka: "\u10E4\u10DD\u10E2\u10DD"
    },
    answer_dropdown: {
        uk: "\u0421\u043F\u0438\u0441\u043E\u043A",
        en: "Dropdown",
        hy: "\u0551\u0561\u0576\u056F",
        ka: "\u10E9\u10D0\u10DB\u10DD\u10E1\u10D0\u10E8\u10DA\u10D4\u10DA\u10D8"
    },
    answer_date: {
        uk: "\u0414\u0430\u0442\u0430",
        en: "Date",
        hy: "\u0531\u0574\u057D\u0561\u0569\u056B\u057E",
        ka: "\u10D7\u10D0\u10E0\u10D8\u10E6\u10D8"
    },
    answer_boolean: {
        uk: "\u0422\u0430\u043A/\u041D\u0456",
        en: "Boolean",
        hy: "\u0531\u0575\u0578/\u0548\u0579",
        ka: "\u10D3\u10D8\u10D0\u10EE/\u10D0\u10E0\u10D0"
    },
    f_required: {
        uk: "\u041E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0435",
        en: "Required",
        hy: "\u054A\u0561\u0580\u057F\u0561\u0564\u056B\u0580",
        ka: "\u10E1\u10D0\u10D5\u10D0\u10DA\u10D3\u10D4\u10D1\u10E3\u10DA\u10DD"
    },
    f_priority: {
        uk: "\u041F\u0440\u0456\u043E\u0440\u0438\u0442\u0435\u0442",
        en: "Priority",
        hy: "\u0531\u057C\u0561\u057B\u0576\u0561\u0570\u0565\u0580\u0569\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10DE\u10E0\u10D8\u10DD\u10E0\u10D8\u10E2\u10D4\u10E2\u10D8"
    },
    f_order: {
        uk: "\u041F\u043E\u0440\u044F\u0434\u043E\u043A",
        en: "Order",
        hy: "\u0540\u0565\u0580\u0569\u0561\u056F\u0561\u0576\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10E0\u10D8\u10D2\u10D8\u10D7\u10DD\u10D1\u10D0"
    },
    priority_low: {
        uk: "\u041D\u0438\u0437\u044C\u043A\u0438\u0439",
        en: "Low",
        hy: "\u0551\u0561\u056E\u0580",
        ka: "\u10D3\u10D0\u10D1\u10D0\u10DA\u10D8"
    },
    priority_medium: {
        uk: "\u0421\u0435\u0440\u0435\u0434\u043D\u0456\u0439",
        en: "Medium",
        hy: "\u0544\u056B\u057B\u056B\u0576",
        ka: "\u10E1\u10D0\u10E8\u10E3\u10D0\u10DA\u10DD"
    },
    priority_high: {
        uk: "\u0412\u0438\u0441\u043E\u043A\u0438\u0439",
        en: "High",
        hy: "\u0532\u0561\u0580\u0571\u0580",
        ka: "\u10DB\u10D0\u10E6\u10D0\u10DA\u10D8"
    },
    f_question_mode: {
        uk: "\u0420\u0435\u0436\u0438\u043C \u043F\u0438\u0442\u0430\u043D\u043D\u044F",
        en: "Question mode",
        hy: "\u0540\u0561\u0580\u0581\u056B \u057C\u0565\u056A\u056B\u0574",
        ka: "\u10D9\u10D8\u10D7\u10EE\u10D5\u10D8\u10E1 \u10E0\u10D4\u10DF\u10D8\u10DB\u10D8"
    },
    f_products_source: {
        uk: "\u0414\u0436\u0435\u0440\u0435\u043B\u043E \u0442\u043E\u0432\u0430\u0440\u0456\u0432",
        en: "Products source",
        hy: "\u0531\u057A\u0580\u0561\u0576\u0584\u0576\u0565\u0580\u056B \u0561\u0572\u0562\u0575\u0578\u0582\u0580",
        ka: "\u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10E2\u10D4\u10D1\u10D8\u10E1 \u10EC\u10E7\u10D0\u10E0\u10DD"
    },
    source_all: {
        uk: "\u0423\u0441\u0456",
        en: "All",
        hy: "\u0532\u0578\u056C\u0578\u0580\u0568",
        ka: "\u10E7\u10D5\u10D4\u10DA\u10D0"
    },
    source_assortment_matrix: {
        uk: "\u0410\u0441\u043E\u0440\u0442\u0438\u043C\u0435\u043D\u0442\u043D\u0430 \u043C\u0430\u0442\u0440\u0438\u0446\u044F",
        en: "Assortment matrix",
        hy: "\u054F\u0565\u057D\u0561\u056F\u0561\u0576\u0578\u0582 \u0574\u0561\u057F\u0580\u056B\u0581\u0561",
        ka: "\u10D0\u10E1\u10DD\u10E0\u10E2\u10D8\u10DB\u10D4\u10DC\u10E2\u10D8\u10E1 \u10DB\u10D0\u10E2\u10E0\u10D8\u10EA\u10D0"
    },
    f_all_products: {
        uk: "\u0423\u0441\u0456 \u0442\u043E\u0432\u0430\u0440\u0438",
        en: "All products",
        hy: "\u0532\u0578\u056C\u0578\u0580 \u0561\u057A\u0580\u0561\u0576\u0584\u0576\u0565\u0580\u0568",
        ka: "\u10E7\u10D5\u10D4\u10DA\u10D0 \u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10E2\u10D8"
    },
    f_all_brands: {
        uk: "\u0423\u0441\u0456 \u0431\u0440\u0435\u043D\u0434\u0438",
        en: "All brands",
        hy: "\u0532\u0578\u056C\u0578\u0580 \u0562\u0580\u0565\u0576\u0564\u0576\u0565\u0580\u0568",
        ka: "\u10E7\u10D5\u10D4\u10DA\u10D0 \u10D1\u10E0\u10D4\u10DC\u10D3\u10D8"
    },
    f_all_categories: {
        uk: "\u0423\u0441\u0456 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u0457",
        en: "All categories",
        hy: "\u0532\u0578\u056C\u0578\u0580 \u056F\u0561\u057F\u0565\u0563\u0578\u0580\u056B\u0561\u0576\u0565\u0580\u0568",
        ka: "\u10E7\u10D5\u10D4\u10DA\u10D0 \u10D9\u10D0\u10E2\u10D4\u10D2\u10DD\u10E0\u10D8\u10D0"
    },
    f_all_subcategories: {
        uk: "\u0423\u0441\u0456 \u043F\u0456\u0434\u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u0457",
        en: "All subcategories",
        hy: "\u0532\u0578\u056C\u0578\u0580 \u0565\u0576\u0569\u0561\u056F\u0561\u057F\u0565\u0563\u0578\u0580\u056B\u0561\u0576\u0565\u0580\u0568",
        ka: "\u10E7\u10D5\u10D4\u10DA\u10D0 \u10E5\u10D5\u10D4\u10D9\u10D0\u10E2\u10D4\u10D2\u10DD\u10E0\u10D8\u10D0"
    },
    f_products: {
        uk: "\u0422\u043E\u0432\u0430\u0440\u0438",
        en: "Products",
        hy: "\u0531\u057A\u0580\u0561\u0576\u0584\u0576\u0565\u0580",
        ka: "\u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10E2\u10D4\u10D1\u10D8"
    },
    f_brands: {
        uk: "\u0411\u0440\u0435\u043D\u0434\u0438",
        en: "Brands",
        hy: "\u0532\u0580\u0565\u0576\u0564\u0576\u0565\u0580",
        ka: "\u10D1\u10E0\u10D4\u10DC\u10D3\u10D4\u10D1\u10D8"
    },
    f_categories: {
        uk: "\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u0457",
        en: "Categories",
        hy: "\u053F\u0561\u057F\u0565\u0563\u0578\u0580\u056B\u0561\u0576\u0565\u0580",
        ka: "\u10D9\u10D0\u10E2\u10D4\u10D2\u10DD\u10E0\u10D8\u10D4\u10D1\u10D8"
    },
    f_subcategories: {
        uk: "\u041F\u0456\u0434\u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u0457",
        en: "Subcategories",
        hy: "\u0535\u0576\u0569\u0561\u056F\u0561\u057F\u0565\u0563\u0578\u0580\u056B\u0561\u0576\u0565\u0580",
        ka: "\u10E5\u10D5\u10D4\u10D9\u10D0\u10E2\u10D4\u10D2\u10DD\u10E0\u10D8\u10D4\u10D1\u10D8"
    },
    f_dropdown_options: {
        uk: "\u0412\u0430\u0440\u0456\u0430\u043D\u0442\u0438 \u0441\u043F\u0438\u0441\u043A\u0443",
        en: "Dropdown options",
        hy: "\u0551\u0561\u0576\u056F\u056B \u057F\u0561\u0580\u0562\u0565\u0580\u0561\u056F\u0576\u0565\u0580",
        ka: "\u10E9\u10D0\u10DB\u10DD\u10E1\u10D0\u10E8\u10DA\u10D4\u10DA\u10D8 \u10D5\u10D0\u10E0\u10D8\u10D0\u10DC\u10E2\u10D4\u10D1\u10D8"
    },
    option_add_btn: {
        uk: "\u0414\u043E\u0434\u0430\u0442\u0438 \u0432\u0430\u0440\u0456\u0430\u043D\u0442",
        en: "Add option",
        hy: "\u0531\u057E\u0565\u056C\u0561\u0581\u0576\u0565\u056C \u057F\u0561\u0580\u0562\u0565\u0580\u0561\u056F",
        ka: "\u10D5\u10D0\u10E0\u10D8\u10D0\u10DC\u10E2\u10D8\u10E1 \u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D0"
    },
    option_label_ph: {
        uk: "\u041D\u0430\u0437\u0432\u0430",
        en: "Label",
        hy: "\u054A\u056B\u057F\u0561\u056F",
        ka: "\u10DA\u10D4\u10D8\u10D1\u10DA\u10D8"
    },
    option_value_ph: {
        uk: "\u0417\u043D\u0430\u0447\u0435\u043D\u043D\u044F",
        en: "Value",
        hy: "\u0531\u0580\u056A\u0565\u0584",
        ka: "\u10DB\u10DC\u10D8\u10E8\u10D5\u10DC\u10D4\u10DA\u10DD\u10D1\u10D0"
    },
    no_questions: {
        uk: "\u041F\u0438\u0442\u0430\u043D\u043D\u044F \u0449\u0435 \u043D\u0435 \u0434\u043E\u0434\u0430\u043D\u0456",
        en: "No questions yet",
        hy: "\u0540\u0561\u0580\u0581\u0565\u0580 \u0564\u0565\u057C \u0579\u056F\u0561\u0576",
        ka: "\u10D9\u10D8\u10D7\u10EE\u10D5\u10D4\u10D1\u10D8 \u10EF\u10D4\u10E0 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1"
    },
    address_min_chars: {
        uk: "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u0449\u043E\u043D\u0430\u0439\u043C\u0435\u043D\u0448\u0435 3 \u0441\u0438\u043C\u0432\u043E\u043B\u0438",
        en: "Type at least 3 characters",
        hy: "\u0544\u0578\u0582\u057F\u0584\u0561\u0563\u0580\u0565\u0584 \u0561\u057C\u0576\u057E\u0561\u0566\u0576 3 \u0576\u056B\u0577",
        ka: "\u10D0\u10D9\u10E0\u10D8\u10E4\u10D4\u10D7 \u10DB\u10D8\u10DC\u10D8\u10DB\u10E3\u10DB 3 \u10E1\u10D8\u10DB\u10D1\u10DD\u10DA\u10DD"
    },
    all_answers: {
        uk: "\u0423\u0441\u0456 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0456",
        en: "All answers",
        hy: "\u0532\u0578\u056C\u0578\u0580 \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0576\u0565\u0580\u0568",
        ka: "\u10E7\u10D5\u10D4\u10DA\u10D0 \u10DE\u10D0\u10E1\u10E3\u10EE\u10D8"
    },
    archive_btn: {
        uk: "\u0410\u0440\u0445\u0456\u0432\u0443\u0432\u0430\u0442\u0438",
        en: "Archive",
        hy: "\u0531\u0580\u056D\u056B\u057E\u0561\u0581\u0576\u0565\u056C",
        ka: "\u10D3\u10D0\u10D0\u10E0\u10E5\u10D8\u10D5\u10D4\u10D1\u10D0"
    },
    archived: {
        uk: "\u0412 \u0430\u0440\u0445\u0456\u0432\u0456",
        en: "Archived",
        hy: "\u0531\u0580\u056D\u056B\u057E\u0561\u0581\u057E\u0561\u056E",
        ka: "\u10D3\u10D0\u10D0\u10E0\u10E5\u10D8\u10D5\u10D4\u10D1\u10E3\u10DA\u10D8"
    },
    bulk_failed_n: {
        uk: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u043E\u0431\u0440\u043E\u0431\u0438\u0442\u0438. \u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C: {n}",
        en: "Could not be processed. Count: {n}",
        hy: "\u0549\u0570\u0561\u057B\u0578\u0572\u057E\u0565\u0581 \u0574\u0577\u0561\u056F\u0565\u056C\u0589 \u0554\u0561\u0576\u0561\u056F\u0568\u055D {n}",
        ka: "\u10D5\u10D4\u10E0 \u10D3\u10D0\u10DB\u10E3\u10E8\u10D0\u10D5\u10D3\u10D0. \u10E0\u10D0\u10DD\u10D3\u10D4\u10DC\u10DD\u10D1\u10D0: {n}"
    },
    coords_readonly: {
        uk: "\u041A\u043E\u043E\u0440\u0434\u0438\u043D\u0430\u0442\u0438 \u0437\u0430\u0434\u0430\u044E\u0442\u044C\u0441\u044F \u043F\u043E\u0448\u0443\u043A\u043E\u043C \u0430\u0434\u0440\u0435\u0441\u0438 \u0430\u0431\u043E \u043A\u043B\u0456\u043A\u043E\u043C \u043D\u0430 \u043A\u0430\u0440\u0442\u0456",
        en: "Coordinates are set by the address search or a map click",
        hy: "\u053F\u0578\u0578\u0580\u0564\u056B\u0576\u0561\u057F\u0576\u0565\u0580\u0568 \u057D\u0561\u0570\u0574\u0561\u0576\u057E\u0578\u0582\u0574 \u0565\u0576 \u0570\u0561\u057D\u0581\u0565\u056B \u0578\u0580\u0578\u0576\u0574\u0561\u0574\u0562 \u056F\u0561\u0574 \u0584\u0561\u0580\u057F\u0565\u0566\u056B \u057E\u0580\u0561 \u057D\u0565\u0572\u0574\u0578\u0582\u0574\u0578\u057E",
        ka: "\u10D9\u10DD\u10DD\u10E0\u10D3\u10D8\u10DC\u10D0\u10E2\u10D4\u10D1\u10D8 \u10D3\u10D2\u10D8\u10DC\u10D3\u10D4\u10D1\u10D0 \u10DB\u10D8\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10D8\u10E1 \u10EB\u10D4\u10D1\u10DC\u10D8\u10D7 \u10D0\u10DC \u10E0\u10E3\u10D9\u10D0\u10D6\u10D4 \u10D3\u10D0\u10ED\u10D4\u10E0\u10D8\u10D7"
    },
    crop_area: {
        uk: "\u041E\u0431\u043B\u0430\u0441\u0442\u044C \u043E\u0431\u0440\u0456\u0437\u0430\u043D\u043D\u044F",
        en: "Crop area",
        hy: "\u053F\u057F\u0580\u0574\u0561\u0576 \u057F\u0561\u0580\u0561\u056E\u0584",
        ka: "\u10DB\u10DD\u10ED\u10E0\u10D8\u10E1 \u10D0\u10E0\u10D4"
    },
    crop_hint: {
        uk: "\u041F\u0435\u0440\u0435\u0442\u044F\u0433\u043D\u0456\u0442\u044C, \u0449\u043E\u0431 \u043F\u0435\u0440\u0435\u043C\u0456\u0441\u0442\u0438\u0442\u0438, \u043A\u0443\u0442\u0438 \u2014 \u0449\u043E\u0431 \u0437\u043C\u0456\u043D\u0438\u0442\u0438 \u0440\u043E\u0437\u043C\u0456\u0440. \u0421\u0442\u0440\u0456\u043B\u043A\u0438 \u0437\u0441\u0443\u0432\u0430\u044E\u0442\u044C, + \u0456 \u2212 \u0437\u043C\u0456\u043D\u044E\u044E\u0442\u044C \u043C\u0430\u0441\u0448\u0442\u0430\u0431",
        en: "Drag to move, corners to resize. Arrow keys nudge, + and \u2212 zoom",
        hy: "\u0554\u0561\u0577\u0565\u0584 \u057F\u0565\u0572\u0561\u0583\u0578\u056D\u0565\u056C\u0578\u0582 \u0570\u0561\u0574\u0561\u0580, \u0561\u0576\u056F\u0575\u0578\u0582\u0576\u0576\u0565\u0580\u0568\u055D \u0579\u0561\u0583\u0568 \u0583\u0578\u056D\u0565\u056C\u0578\u0582\u0589 \u054D\u056C\u0561\u0584\u0576\u0565\u0580\u0568 \u057F\u0565\u0572\u0561\u0577\u0561\u0580\u056A\u0578\u0582\u0574 \u0565\u0576, + \u0587 \u2212 \u0583\u0578\u056D\u0578\u0582\u0574 \u0565\u0576 \u056D\u0578\u0577\u0578\u0580\u0561\u0581\u0578\u0582\u0574\u0568",
        ka: "\u10D2\u10D0\u10D3\u10D0\u10D0\u10D7\u10E0\u10D8\u10D4\u10D7 \u10D2\u10D0\u10D3\u10D0\u10E1\u10D0\u10D0\u10D3\u10D2\u10D8\u10DA\u10D4\u10D1\u10DA\u10D0\u10D3, \u10D9\u10E3\u10D7\u10EE\u10D4\u10D4\u10D1\u10D8 \u2014 \u10D6\u10DD\u10DB\u10D8\u10E1 \u10E8\u10D4\u10E1\u10D0\u10EA\u10D5\u10DA\u10D4\u10DA\u10D0\u10D3. \u10D8\u10E1\u10E0\u10D4\u10D1\u10D8 \u10D2\u10D0\u10D3\u10D0\u10D0\u10D0\u10D3\u10D2\u10D8\u10DA\u10D4\u10D1\u10E1, + \u10D3\u10D0 \u2212 \u10EA\u10D5\u10DA\u10D8\u10E1 \u10DB\u10D0\u10E1\u10E8\u10E2\u10D0\u10D1\u10E1"
    },
    crop_preview: {
        uk: "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u0434",
        en: "Preview",
        hy: "\u0546\u0561\u056D\u0561\u0564\u056B\u057F\u0578\u0582\u0574",
        ka: "\u10EC\u10D8\u10DC\u10D0\u10E1\u10EC\u10D0\u10E0\u10D8 \u10EE\u10D4\u10D3\u10D8"
    },
    crop_size: {
        uk: "\u041C\u0430\u0441\u0448\u0442\u0430\u0431",
        en: "Zoom",
        hy: "\u053D\u0578\u0577\u0578\u0580\u0561\u0581\u0578\u0582\u0574",
        ka: "\u10DB\u10D0\u10E1\u10E8\u10E2\u10D0\u10D1\u10D8"
    },
    crop_title: {
        uk: "\u041E\u0431\u0440\u0456\u0437\u0430\u0442\u0438 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F",
        en: "Crop image",
        hy: "\u053F\u057F\u0580\u0565\u056C \u057A\u0561\u057F\u056F\u0565\u0580\u0568",
        ka: "\u10E1\u10E3\u10E0\u10D0\u10D7\u10D8\u10E1 \u10DB\u10DD\u10ED\u10E0\u10D0"
    },
    data_quality: {
        uk: "\u042F\u043A\u0456\u0441\u0442\u044C \u0434\u0430\u043D\u0438\u0445",
        en: "Data quality",
        hy: "\u054F\u057E\u0575\u0561\u056C\u0576\u0565\u0580\u056B \u0578\u0580\u0561\u056F",
        ka: "\u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D7\u10D0 \u10EE\u10D0\u10E0\u10D8\u10E1\u10EE\u10D8"
    },
    empty_filtered: {
        uk: "\u041D\u0435\u043C\u0430\u0454 \u0437\u0430\u043F\u0438\u0441\u0456\u0432 \u0437\u0430 \u0446\u0438\u043C\u0438 \u0444\u0456\u043B\u044C\u0442\u0440\u0430\u043C\u0438",
        en: "No records match these filters",
        hy: "\u0531\u0575\u057D \u0566\u057F\u056B\u0579\u0576\u0565\u0580\u056B\u0576 \u0570\u0561\u0574\u0561\u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0578\u0572 \u0563\u0580\u0561\u057C\u0578\u0582\u0574\u0576\u0565\u0580 \u0579\u056F\u0561\u0576",
        ka: "\u10D0\u10DB \u10E4\u10D8\u10DA\u10E2\u10E0\u10D4\u10D1\u10E1 \u10D0\u10E0 \u10E8\u10D4\u10D4\u10E1\u10D0\u10D1\u10D0\u10DB\u10D4\u10D1\u10D0 \u10E9\u10D0\u10DC\u10D0\u10EC\u10D4\u10E0\u10D4\u10D1\u10D8"
    },
    /* The second line of each empty state: `empty` / `empty_filtered` say WHAT, these say what to do
     about it. Nothing here yet and nothing matching are different states (spec/03). */ empty_desc: {
        uk: "\u0421\u0442\u0432\u043E\u0440\u0456\u0442\u044C \u043F\u0435\u0440\u0448\u0438\u0439 \u0437\u0430\u043F\u0438\u0441, \u0449\u043E\u0431 \u043F\u043E\u0447\u0430\u0442\u0438.",
        en: "Create the first record to get started.",
        hy: "\u054D\u057F\u0565\u0572\u056E\u0565\u0584 \u0561\u057C\u0561\u057B\u056B\u0576 \u0563\u0580\u0561\u057C\u0578\u0582\u0574\u0568\u055D \u057D\u056F\u057D\u0565\u056C\u0578\u0582 \u0570\u0561\u0574\u0561\u0580\u0589",
        ka: "\u10D3\u10D0\u10E1\u10D0\u10EC\u10E7\u10D4\u10D1\u10D0\u10D3 \u10E8\u10D4\u10E5\u10DB\u10D4\u10DC\u10D8\u10D7 \u10DE\u10D8\u10E0\u10D5\u10D4\u10DA\u10D8 \u10E9\u10D0\u10DC\u10D0\u10EC\u10D4\u10E0\u10D8."
    },
    empty_filtered_desc: {
        uk: "\u0421\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0440\u043E\u0437\u0448\u0438\u0440\u0438\u0442\u0438 \u043F\u043E\u0448\u0443\u043A \u0430\u0431\u043E \u0441\u043A\u0438\u043D\u0443\u0442\u0438 \u0444\u0456\u043B\u044C\u0442\u0440\u0438.",
        en: "Try widening the search or clearing the filters.",
        hy: "\u0553\u0578\u0580\u0571\u0565\u0584 \u0568\u0576\u0564\u056C\u0561\u0575\u0576\u0565\u056C \u0578\u0580\u0578\u0576\u0578\u0582\u0574\u0568 \u056F\u0561\u0574 \u0574\u0561\u0584\u0580\u0565\u056C \u0566\u057F\u056B\u0579\u0576\u0565\u0580\u0568\u0589",
        ka: "\u10E1\u10EA\u10D0\u10D3\u10D4\u10D7 \u10EB\u10D8\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10E4\u10D0\u10E0\u10D7\u10DD\u10D4\u10D1\u10D0 \u10D0\u10DC \u10E4\u10D8\u10DA\u10E2\u10E0\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10E1\u10E3\u10E4\u10D7\u10D0\u10D5\u10D4\u10D1\u10D0."
    },
    filters_reset: {
        uk: "\u0424\u0456\u043B\u044C\u0442\u0440\u0438 \u0441\u043A\u0438\u043D\u0443\u0442\u043E",
        en: "Filters reset",
        hy: "\u0536\u057F\u056B\u0579\u0576\u0565\u0580\u0568 \u0566\u0580\u0578\u0575\u0561\u0581\u057E\u0561\u056E \u0565\u0576",
        ka: "\u10E4\u10D8\u10DA\u10E2\u10E0\u10D4\u10D1\u10D8 \u10D2\u10D0\u10E1\u10E3\u10E4\u10D7\u10D0\u10D5\u10D3\u10D0"
    },
    min_col: {
        uk: "\u0425\u0432\u0438\u043B\u0438\u043D\u0438",
        en: "Minutes",
        hy: "\u0550\u0578\u057A\u0565\u0576\u0565\u0580",
        ka: "\u10EC\u10E3\u10D7\u10D4\u10D1\u10D8"
    },
    min_short: {
        uk: "\u0445\u0432",
        en: "min",
        hy: "\u0580",
        ka: "\u10EC\u10D7"
    },
    never_visited: {
        uk: "\u0429\u0435 \u043D\u0435 \u0432\u0456\u0434\u0432\u0456\u0434\u0430\u043D\u043E",
        en: "Never visited",
        hy: "\u0534\u0565\u057C \u0579\u0561\u0575\u0581\u0565\u056C\u057E\u0561\u056E",
        ka: "\u10EF\u10D4\u10E0 \u10D0\u10E0 \u10DB\u10DD\u10DC\u10D0\u10EE\u10E3\u10DA\u10D4\u10D1\u10E3\u10DA\u10D0"
    },
    new_point: {
        uk: "\u041D\u043E\u0432\u0430 \u0442\u043E\u0447\u043A\u0430",
        en: "New point",
        hy: "\u0546\u0578\u0580 \u056F\u0565\u057F",
        ka: "\u10D0\u10EE\u10D0\u10DA\u10D8 \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8"
    },
    no_coords: {
        uk: "\u0411\u0435\u0437 \u043A\u043E\u043E\u0440\u0434\u0438\u043D\u0430\u0442",
        en: "No coordinates",
        hy: "\u0531\u057C\u0561\u0576\u0581 \u056F\u0578\u0578\u0580\u0564\u056B\u0576\u0561\u057F\u0576\u0565\u0580\u056B",
        ka: "\u10D9\u10DD\u10DD\u10E0\u10D3\u10D8\u10DC\u10D0\u10E2\u10D4\u10D1\u10D8 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1"
    },
    no_coords_hint: {
        uk: "\u0423 \u0446\u0456\u0454\u0457 \u0442\u043E\u0447\u043A\u0438 \u043D\u0435\u043C\u0430\u0454 \u043A\u043E\u043E\u0440\u0434\u0438\u043D\u0430\u0442, \u0442\u043E\u043C\u0443 \u0432\u0456\u0437\u0438\u0442\u0438 \u0434\u043E \u043D\u0435\u0457 \u043D\u0435 \u043C\u043E\u0436\u043D\u0430 \u043F\u0456\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438 \u043D\u0430 \u043C\u0456\u0441\u0446\u0456.",
        en: "This point has no coordinates, so visits to it cannot be verified on site.",
        hy: "\u0531\u0575\u057D \u056F\u0565\u057F\u0568 \u056F\u0578\u0578\u0580\u0564\u056B\u0576\u0561\u057F\u0576\u0565\u0580 \u0579\u0578\u0582\u0576\u056B, \u0578\u0582\u057D\u057F\u056B \u0561\u0575\u0581\u0565\u0580\u0568 \u0570\u0576\u0561\u057E\u0561\u0575\u0580\u0578\u0582\u0574 \u0570\u0576\u0561\u0580\u0561\u057E\u0578\u0580 \u0579\u0567 \u0570\u0561\u057D\u057F\u0561\u057F\u0565\u056C\u0589",
        ka: "\u10D0\u10DB \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10E1 \u10D9\u10DD\u10DD\u10E0\u10D3\u10D8\u10DC\u10D0\u10E2\u10D4\u10D1\u10D8 \u10D0\u10E0 \u10D0\u10E5\u10D5\u10E1, \u10D0\u10DB\u10D8\u10E2\u10DD\u10DB \u10D5\u10D8\u10D6\u10D8\u10E2\u10D4\u10D1\u10D8\u10E1 \u10D0\u10D3\u10D2\u10D8\u10DA\u10D6\u10D4 \u10D3\u10D0\u10D3\u10D0\u10E1\u10E2\u10E3\u10E0\u10D4\u10D1\u10D0 \u10E8\u10D4\u10E3\u10EB\u10DA\u10D4\u10D1\u10D4\u10DA\u10D8\u10D0."
    },
    no_tasks: {
        uk: "\u0417\u0430\u0432\u0434\u0430\u043D\u043D\u044F \u0432\u0438\u043C\u043A\u043D\u0435\u043D\u043E",
        en: "Tasks off",
        hy: "\u0531\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0576\u0565\u0580\u0576 \u0561\u0576\u057B\u0561\u057F\u057E\u0561\u056E \u0565\u0576",
        ka: "\u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8 \u10D2\u10D0\u10DB\u10DD\u10E0\u10D7\u10E3\u10DA\u10D8\u10D0"
    },
    open_editor: {
        uk: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u0440\u0435\u0434\u0430\u043A\u0442\u043E\u0440",
        en: "Open editor",
        hy: "\u0532\u0561\u0581\u0565\u056C \u056D\u0574\u0562\u0561\u0563\u0580\u056B\u0579\u0568",
        ka: "\u10E0\u10D4\u10D3\u10D0\u10E5\u10E2\u10DD\u10E0\u10D8\u10E1 \u10D2\u10D0\u10EE\u10E1\u10DC\u10D0"
    },
    option_remove: {
        uk: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0432\u0430\u0440\u0456\u0430\u043D\u0442",
        en: "Remove option",
        hy: "\u0540\u0565\u057C\u0561\u0581\u0576\u0565\u056C \u057F\u0561\u0580\u0562\u0565\u0580\u0561\u056F\u0568",
        ka: "\u10D5\u10D0\u10E0\u10D8\u10D0\u10DC\u10E2\u10D8\u10E1 \u10EC\u10D0\u10E8\u10DA\u10D0"
    },
    pick_image: {
        uk: "\u0412\u0438\u0431\u0440\u0430\u0442\u0438 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F",
        en: "Choose image",
        hy: "\u0538\u0576\u057F\u0580\u0565\u056C \u057A\u0561\u057F\u056F\u0565\u0580",
        ka: "\u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10E1\u10E3\u10E0\u10D0\u10D7\u10D8"
    },
    points_sub: {
        uk: "\u0422\u043E\u0440\u0433\u043E\u0432\u0456 \u0442\u043E\u0447\u043A\u0438, \u043F\u0440\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F \u0442\u0430 \u044F\u043A\u0456\u0441\u0442\u044C \u0434\u0430\u043D\u0438\u0445",
        en: "Retail locations, assignment and data quality",
        hy: "\u0531\u057C\u0587\u057F\u0580\u056B \u056F\u0565\u057F\u0565\u0580, \u0576\u0577\u0561\u0576\u0561\u056F\u0578\u0582\u0574 \u0587 \u057F\u057E\u0575\u0561\u056C\u0576\u0565\u0580\u056B \u0578\u0580\u0561\u056F",
        ka: "\u10E1\u10D0\u10D5\u10D0\u10ED\u10E0\u10DD \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8, \u10D3\u10D0\u10DC\u10D8\u10E8\u10D5\u10DC\u10D0 \u10D3\u10D0 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D7\u10D0 \u10EE\u10D0\u10E0\u10D8\u10E1\u10EE\u10D8"
    },
    /* One line per reference list saying what its records are FOR — the one thing a title like
     "Localities" cannot. Rendered in the page head by `ResourceList`. */ networks_sub: {
        uk: "\u0422\u043E\u0440\u0433\u043E\u0432\u0456 \u043C\u0435\u0440\u0435\u0436\u0456, \u0434\u043E \u044F\u043A\u0438\u0445 \u043D\u0430\u043B\u0435\u0436\u0430\u0442\u044C \u0442\u043E\u0447\u043A\u0438",
        en: "Retail chains the points belong to",
        hy: "\u0531\u057C\u0587\u057F\u0580\u0561\u0575\u056B\u0576 \u0581\u0561\u0576\u0581\u0565\u0580, \u0578\u0580\u0578\u0576\u0581 \u057A\u0561\u057F\u056F\u0561\u0576\u0578\u0582\u0574 \u0565\u0576 \u056F\u0565\u057F\u0565\u0580\u0568",
        ka: "\u10E1\u10D0\u10D5\u10D0\u10ED\u10E0\u10DD \u10E5\u10E1\u10D4\u10DA\u10D4\u10D1\u10D8, \u10E0\u10DD\u10DB\u10DA\u10D4\u10D1\u10E1\u10D0\u10EA \u10D4\u10D9\u10E3\u10D7\u10D5\u10DC\u10D8\u10E1 \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8"
    },
    countries_sub: {
        uk: "\u041A\u0440\u0430\u0457\u043D\u0438, \u0449\u043E \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u044E\u0442\u044C\u0441\u044F \u0432 \u0430\u0434\u0440\u0435\u0441\u0430\u0445 \u0456 \u0440\u0435\u0433\u0456\u043E\u043D\u0430\u0445",
        en: "Countries used in addresses and regions",
        hy: "\u0535\u0580\u056F\u0580\u0576\u0565\u0580, \u0578\u0580\u0578\u0576\u0584 \u0585\u0563\u057F\u0561\u0563\u0578\u0580\u056E\u057E\u0578\u0582\u0574 \u0565\u0576 \u0570\u0561\u057D\u0581\u0565\u0576\u0565\u0580\u0578\u0582\u0574 \u0587 \u057F\u0561\u0580\u0561\u056E\u0561\u0577\u0580\u057B\u0561\u0576\u0576\u0565\u0580\u0578\u0582\u0574",
        ka: "\u10E5\u10D5\u10D4\u10E7\u10DC\u10D4\u10D1\u10D8, \u10E0\u10DD\u10DB\u10DA\u10D4\u10D1\u10D8\u10EA \u10D2\u10D0\u10DB\u10DD\u10D8\u10E7\u10D4\u10DC\u10D4\u10D1\u10D0 \u10DB\u10D8\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10D4\u10D1\u10E1\u10D0 \u10D3\u10D0 \u10E0\u10D4\u10D2\u10D8\u10DD\u10DC\u10D4\u10D1\u10E8\u10D8"
    },
    counties_sub: {
        uk: "\u0420\u0435\u0433\u0456\u043E\u043D\u0438, \u0437\u0430 \u044F\u043A\u0438\u043C\u0438 \u0440\u043E\u0437\u043F\u043E\u0434\u0456\u043B\u044F\u044E\u0442\u044C\u0441\u044F \u0442\u043E\u0447\u043A\u0438, \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u0438 \u0442\u0430 \u043F\u043E\u043A\u0440\u0438\u0442\u0442\u044F",
        en: "Regions that scope points, routes and coverage",
        hy: "\u054F\u0561\u0580\u0561\u056E\u0561\u0577\u0580\u057B\u0561\u0576\u0576\u0565\u0580, \u0578\u0580\u0578\u0576\u0581\u0578\u057E \u0562\u0561\u0577\u056D\u057E\u0578\u0582\u0574 \u0565\u0576 \u056F\u0565\u057F\u0565\u0580\u0568, \u0565\u0580\u0569\u0578\u0582\u0572\u056B\u0576\u0565\u0580\u0576 \u0578\u0582 \u056E\u0561\u056E\u056F\u0578\u0582\u0575\u0569\u0568",
        ka: "\u10E0\u10D4\u10D2\u10D8\u10DD\u10DC\u10D4\u10D1\u10D8, \u10E0\u10DD\u10DB\u10DA\u10D8\u10D7\u10D0\u10EA \u10DC\u10D0\u10EC\u10D8\u10DA\u10D3\u10D4\u10D1\u10D0 \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8, \u10DB\u10D0\u10E0\u10E8\u10E0\u10E3\u10E2\u10D4\u10D1\u10D8 \u10D3\u10D0 \u10D3\u10D0\u10E4\u10D0\u10E0\u10D5\u10D0"
    },
    localities_sub: {
        uk: "\u041C\u0456\u0441\u0442\u0430 \u0442\u0430 \u0441\u0435\u043B\u0430, \u0434\u043E \u044F\u043A\u0438\u0445 \u043F\u0440\u0438\u0432'\u044F\u0437\u0430\u043D\u0456 \u0442\u043E\u0447\u043A\u0438",
        en: "Cities and towns the points are addressed to",
        hy: "\u0554\u0561\u0572\u0561\u0584\u0576\u0565\u0580 \u0587 \u0562\u0576\u0561\u056F\u0561\u057E\u0561\u0575\u0580\u0565\u0580, \u0578\u0580\u0578\u0576\u0581 \u056F\u0561\u057A\u057E\u0561\u056E \u0565\u0576 \u056F\u0565\u057F\u0565\u0580\u0568",
        ka: "\u10E5\u10D0\u10DA\u10D0\u10E5\u10D4\u10D1\u10D8 \u10D3\u10D0 \u10D3\u10D0\u10E1\u10D0\u10EE\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8, \u10E0\u10DD\u10DB\u10DA\u10D4\u10D1\u10E1\u10D0\u10EA \u10E3\u10D9\u10D0\u10D5\u10E8\u10D8\u10E0\u10D3\u10D4\u10D1\u10D0 \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8"
    },
    categories_sub: {
        uk: "\u0422\u0438\u043F\u0438 \u0442\u043E\u0447\u043E\u043A, \u043C\u043E\u043D\u0456\u0442\u043E\u0440\u0438\u043D\u0433 \u0446\u0456\u043D \u0456 \u043D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F \u0456\u043D\u0442\u0435\u0433\u0440\u0430\u0446\u0456\u0457",
        en: "Point types, price monitoring and integration settings",
        hy: "\u053F\u0565\u057F\u0565\u0580\u056B \u057F\u0565\u057D\u0561\u056F\u0576\u0565\u0580, \u0563\u0576\u0565\u0580\u056B \u0574\u0578\u0576\u056B\u057F\u0578\u0580\u056B\u0576\u0563 \u0587 \u056B\u0576\u057F\u0565\u0563\u0580\u0574\u0561\u0576 \u056F\u0561\u0580\u0563\u0561\u057E\u0578\u0580\u0578\u0582\u0574\u0576\u0565\u0580",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1 \u10E2\u10D8\u10DE\u10D4\u10D1\u10D8, \u10E4\u10D0\u10E1\u10D4\u10D1\u10D8\u10E1 \u10DB\u10DD\u10DC\u10D8\u10E2\u10DD\u10E0\u10D8\u10DC\u10D2\u10D8 \u10D3\u10D0 \u10D8\u10DC\u10E2\u10D4\u10D2\u10E0\u10D0\u10EA\u10D8\u10D8\u10E1 \u10DE\u10D0\u10E0\u10D0\u10DB\u10D4\u10E2\u10E0\u10D4\u10D1\u10D8"
    },
    point_groups_sub: {
        uk: "\u0406\u043C\u0435\u043D\u043E\u0432\u0430\u043D\u0456 \u043D\u0430\u0431\u043E\u0440\u0438 \u0442\u043E\u0447\u043E\u043A \u0434\u043B\u044F \u0437\u0430\u0432\u0434\u0430\u043D\u044C \u0456 \u043E\u043F\u0438\u0442\u0443\u0432\u0430\u043D\u044C",
        en: "Named sets of points for tasks and surveys",
        hy: "\u053F\u0565\u057F\u0565\u0580\u056B \u0561\u0576\u057E\u0561\u0576\u057E\u0561\u056E \u056D\u0574\u0562\u0565\u0580\u055D \u0561\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0576\u0565\u0580\u056B \u0587 \u0570\u0561\u0580\u0581\u0578\u0582\u0574\u0576\u0565\u0580\u056B \u0570\u0561\u0574\u0561\u0580",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1 \u10D3\u10D0\u10E1\u10D0\u10EE\u10D4\u10DA\u10D4\u10D1\u10E3\u10DA\u10D8 \u10EF\u10D2\u10E3\u10E4\u10D4\u10D1\u10D8 \u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8\u10E1\u10D0 \u10D3\u10D0 \u10D2\u10D0\u10DB\u10DD\u10D9\u10D8\u10D7\u10EE\u10D5\u10D4\u10D1\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1"
    },
    surveys_sub: {
        uk: "\u041E\u043F\u0438\u0442\u0443\u0432\u0430\u043D\u043D\u044F, \u043D\u0430 \u044F\u043A\u0456 \u043C\u0435\u0440\u0447\u0430\u043D\u0434\u0430\u0439\u0437\u0435\u0440\u0438 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0430\u044E\u0442\u044C \u043F\u0456\u0434 \u0447\u0430\u0441 \u0432\u0456\u0437\u0438\u0442\u0443",
        en: "Questionnaires merchandisers answer during a visit",
        hy: "\u0540\u0561\u0580\u0581\u0578\u0582\u0574\u0576\u0565\u0580, \u0578\u0580\u0578\u0576\u0581 \u0574\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580\u0576\u0565\u0580\u0568 \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0578\u0582\u0574 \u0565\u0576 \u0561\u0575\u0581\u056B \u056A\u0561\u0574\u0561\u0576\u0561\u056F",
        ka: "\u10D2\u10D0\u10DB\u10DD\u10D9\u10D8\u10D7\u10EE\u10D5\u10D4\u10D1\u10D8, \u10E0\u10DD\u10DB\u10DA\u10D4\u10D1\u10E1\u10D0\u10EA \u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D4\u10D1\u10D8 \u10DE\u10D0\u10E1\u10E3\u10EE\u10DD\u10D1\u10D4\u10DC \u10D5\u10D8\u10D6\u10D8\u10E2\u10D8\u10E1\u10D0\u10E1"
    },
    question_move_down: {
        uk: "\u041F\u0435\u0440\u0435\u043C\u0456\u0441\u0442\u0438\u0442\u0438 \u0432\u043D\u0438\u0437",
        en: "Move down",
        hy: "\u054F\u0565\u0572\u0561\u0583\u0578\u056D\u0565\u056C \u057E\u0561\u0580",
        ka: "\u10D3\u10D0\u10EC\u10D4\u10D5\u10D0"
    },
    question_move_up: {
        uk: "\u041F\u0435\u0440\u0435\u043C\u0456\u0441\u0442\u0438\u0442\u0438 \u0432\u0433\u043E\u0440\u0443",
        en: "Move up",
        hy: "\u054F\u0565\u0572\u0561\u0583\u0578\u056D\u0565\u056C \u057E\u0565\u0580",
        ka: "\u10D0\u10EC\u10D4\u10D5\u10D0"
    },
    restore_btn: {
        uk: "\u0412\u0456\u0434\u043D\u043E\u0432\u0438\u0442\u0438",
        en: "Restore",
        hy: "\u054E\u0565\u0580\u0561\u056F\u0561\u0576\u0563\u0576\u0565\u056C",
        ka: "\u10D0\u10E6\u10D3\u10D2\u10D4\u10DC\u10D0"
    },
    search_point_ph: {
        uk: "\u041D\u0430\u0437\u0432\u0430, \u043A\u043E\u0434 \u0430\u0431\u043E \u0430\u0434\u0440\u0435\u0441\u0430",
        en: "Name, code or address",
        hy: "\u0531\u0576\u0578\u0582\u0576, \u056F\u0578\u0564 \u056F\u0561\u0574 \u0570\u0561\u057D\u0581\u0565",
        ka: "\u10E1\u10D0\u10EE\u10D4\u10DA\u10D8, \u10D9\u10DD\u10D3\u10D8 \u10D0\u10DC \u10DB\u10D8\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10D8"
    },
    select_page_hint: {
        uk: "\u0412\u0438\u0431\u0456\u0440 \u0434\u0456\u0454 \u043D\u0430 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u0443 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443",
        en: "Selection covers the loaded page",
        hy: "\u0538\u0576\u057F\u0580\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0568 \u057E\u0565\u0580\u0561\u0562\u0565\u0580\u0578\u0582\u0574 \u0567 \u0562\u0565\u057C\u0576\u057E\u0561\u056E \u0567\u057B\u056B\u0576",
        ka: "\u10D0\u10E0\u10E9\u10D4\u10D5\u10D0\u10DC\u10D8 \u10DB\u10DD\u10E5\u10DB\u10D4\u10D3\u10D4\u10D1\u10E1 \u10E9\u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10E3\u10DA \u10D2\u10D5\u10D4\u10E0\u10D3\u10D6\u10D4"
    },
    unassigned: {
        uk: "\u041D\u0435 \u043F\u0440\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u043E",
        en: "Unassigned",
        hy: "\u0549\u0576\u0577\u0561\u0576\u0561\u056F\u057E\u0561\u056E",
        ka: "\u10D3\u10D0\u10E3\u10DC\u10D8\u10E8\u10DC\u10D0\u10D5\u10D8"
    },
    archived_n: {
        uk: "\u0410\u0440\u0445\u0456\u0432\u043E\u0432\u0430\u043D\u043E. \u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C: {n}",
        en: "Archived. Count: {n}",
        hy: "\u0531\u0580\u056D\u056B\u057E\u0561\u0581\u057E\u0565\u0581\u0589 \u0554\u0561\u0576\u0561\u056F\u0568\u055D {n}",
        ka: "\u10D3\u10D0\u10D0\u10E0\u10E5\u10D8\u10D5\u10D3\u10D0. \u10E0\u10D0\u10DD\u10D3\u10D4\u10DC\u10DD\u10D1\u10D0: {n}"
    },
    confirm_archive: {
        uk: "\u0410\u0440\u0445\u0456\u0432\u0443\u0432\u0430\u0442\u0438 \u0446\u0435\u0439 \u0437\u0430\u043F\u0438\u0441?",
        en: "Archive this record?",
        hy: "\u0531\u0580\u056D\u056B\u057E\u0561\u0581\u0576\u0565\u055E\u056C \u0561\u0575\u057D \u0563\u0580\u0561\u057C\u0578\u0582\u0574\u0568",
        ka: "\u10D3\u10D0\u10D5\u10D0\u10D0\u10E0\u10E5\u10D8\u10D5\u10DD\u10D7 \u10D4\u10E1 \u10E9\u10D0\u10DC\u10D0\u10EC\u10D4\u10E0\u10D8?"
    },
    confirm_archive_n: {
        uk: "\u0410\u0440\u0445\u0456\u0432\u0443\u0432\u0430\u0442\u0438 \u0432\u0438\u0431\u0440\u0430\u043D\u0456 \u0437\u0430\u043F\u0438\u0441\u0438? \u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C: {n}",
        en: "Archive the selected records? Count: {n}",
        hy: "\u0531\u0580\u056D\u056B\u057E\u0561\u0581\u0576\u0565\u055E\u056C \u0568\u0576\u057F\u0580\u057E\u0561\u056E \u0563\u0580\u0561\u057C\u0578\u0582\u0574\u0576\u0565\u0580\u0568\u0589 \u0554\u0561\u0576\u0561\u056F\u0568\u055D {n}",
        ka: "\u10D3\u10D0\u10D5\u10D0\u10D0\u10E0\u10E5\u10D8\u10D5\u10DD\u10D7 \u10D0\u10E0\u10E9\u10D4\u10E3\u10DA\u10D8 \u10E9\u10D0\u10DC\u10D0\u10EC\u10D4\u10E0\u10D4\u10D1\u10D8? \u10E0\u10D0\u10DD\u10D3\u10D4\u10DC\u10DD\u10D1\u10D0: {n}"
    },
    confirm_deactivate_n: {
        uk: "\u0414\u0435\u0430\u043A\u0442\u0438\u0432\u0443\u0432\u0430\u0442\u0438 \u0432\u0438\u0431\u0440\u0430\u043D\u0456 \u0437\u0430\u043F\u0438\u0441\u0438? \u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C: {n}",
        en: "Deactivate the selected records? Count: {n}",
        hy: "\u0534\u0565\u0561\u056F\u057F\u056B\u057E\u0561\u0581\u0576\u0565\u055E\u056C \u0568\u0576\u057F\u0580\u057E\u0561\u056E \u0563\u0580\u0561\u057C\u0578\u0582\u0574\u0576\u0565\u0580\u0568\u0589 \u0554\u0561\u0576\u0561\u056F\u0568\u055D {n}",
        ka: "\u10D3\u10D0\u10D5\u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D3\u10D4\u10E1 \u10D0\u10E0\u10E9\u10D4\u10E3\u10DA\u10D8 \u10E9\u10D0\u10DC\u10D0\u10EC\u10D4\u10E0\u10D4\u10D1\u10D8? \u10E0\u10D0\u10DD\u10D3\u10D4\u10DC\u10DD\u10D1\u10D0: {n}"
    },
    created_at: {
        uk: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043E",
        en: "Created",
        hy: "\u054D\u057F\u0565\u0572\u056E\u057E\u0561\u056E",
        ka: "\u10E8\u10D4\u10E5\u10DB\u10DC\u10D8\u10DA\u10D8\u10D0"
    },
    deactivated_n: {
        uk: "\u0414\u0435\u0430\u043A\u0442\u0438\u0432\u043E\u0432\u0430\u043D\u043E. \u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C: {n}",
        en: "Deactivated. Count: {n}",
        hy: "\u0534\u0565\u0561\u056F\u057F\u056B\u057E\u0561\u0581\u057E\u0565\u0581\u0589 \u0554\u0561\u0576\u0561\u056F\u0568\u055D {n}",
        ka: "\u10D3\u10D4\u10D0\u10E5\u10E2\u10D8\u10D5\u10D8\u10E0\u10D3\u10D0. \u10E0\u10D0\u10DD\u10D3\u10D4\u10DC\u10DD\u10D1\u10D0: {n}"
    },
    activated_n: {
        uk: "\u0410\u043A\u0442\u0438\u0432\u043E\u0432\u0430\u043D\u043E. \u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C: {n}",
        en: "Activated. Count: {n}",
        hy: "\u0531\u056F\u057F\u056B\u057E\u0561\u0581\u057E\u0565\u0581\u0589 \u0554\u0561\u0576\u0561\u056F\u0568\u055D {n}",
        ka: "\u10D0\u10E5\u10E2\u10D8\u10D5\u10D8\u10E0\u10D3\u10D0. \u10E0\u10D0\u10DD\u10D3\u10D4\u10DC\u10DD\u10D1\u10D0: {n}"
    },
    draft: {
        uk: "\u0427\u0435\u0440\u043D\u0435\u0442\u043A\u0430",
        en: "Draft",
        hy: "\u054D\u0587\u0561\u0563\u056B\u0580",
        ka: "\u10DB\u10DD\u10DC\u10D0\u10EE\u10D0\u10D6\u10D8"
    },
    unsaved: {
        uk: "\u041D\u0435\u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u0456 \u0437\u043C\u0456\u043D\u0438",
        en: "Unsaved changes",
        hy: "\u0549\u057A\u0561\u0570\u057A\u0561\u0576\u057E\u0561\u056E \u0583\u0578\u0583\u0578\u056D\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580",
        ka: "\u10E8\u10D4\u10E3\u10DC\u10D0\u10EE\u10D0\u10D5\u10D8 \u10EA\u10D5\u10DA\u10D8\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8"
    },
    /* The list's status segment. `active` / `inactive` / `archived` above are the same words. */ seg_all: {
        uk: "\u0423\u0441\u0456",
        en: "All",
        hy: "\u0532\u0578\u056C\u0578\u0580\u0568",
        ka: "\u10E7\u10D5\u10D4\u10DA\u10D0"
    },
    last_visit: {
        uk: "\u041E\u0441\u0442\u0430\u043D\u043D\u0456\u0439 \u0432\u0456\u0437\u0438\u0442",
        en: "Last visit",
        hy: "\u054E\u0565\u0580\u057B\u056B\u0576 \u0561\u0575\u0581\u0568",
        ka: "\u10D1\u10DD\u10DA\u10DD \u10D5\u10D8\u10D6\u10D8\u10E2\u10D8"
    },
    fix_first: {
        uk: "\u0412\u0438\u043F\u0440\u0430\u0432\u0442\u0435 \u043F\u043E\u0437\u043D\u0430\u0447\u0435\u043D\u0456 \u043F\u043E\u043B\u044F \u043F\u0435\u0440\u0435\u0434 \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043D\u044F\u043C",
        en: "Fix the highlighted fields before saving",
        hy: "\u0548\u0582\u0572\u0572\u0565\u0584 \u0576\u0577\u057E\u0561\u056E \u0564\u0561\u0577\u057F\u0565\u0580\u0568 \u0576\u0561\u056D\u0584\u0561\u0576 \u057A\u0561\u0570\u057A\u0561\u0576\u0565\u056C\u0568",
        ka: "\u10E8\u10D4\u10DC\u10D0\u10EE\u10D5\u10D0\u10DB\u10D3\u10D4 \u10D2\u10D0\u10D0\u10E1\u10EC\u10DD\u10E0\u10D4\u10D7 \u10DB\u10DD\u10DC\u10D8\u10E8\u10DC\u10E3\u10DA\u10D8 \u10D5\u10D4\u10DA\u10D4\u10D1\u10D8"
    },
    // {f} = the field's own label. The em-dash form is deliberate: uk/hy/ka would otherwise have to
    // agree with the label's gender, which a descriptor label cannot carry.
    q_required: {
        uk: "{f} \u2014 \u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0435 \u043F\u043E\u043B\u0435",
        en: "{f} is required",
        hy: "{f} \u2014 \u057A\u0561\u0580\u057F\u0561\u0564\u056B\u0580 \u0564\u0561\u0577\u057F \u0567",
        ka: "{f} \u2014 \u10E1\u10D0\u10D5\u10D0\u10DA\u10D3\u10D4\u10D1\u10E3\u10DA\u10DD \u10D5\u10D4\u10DA\u10D8\u10D0"
    },
    w_no_merch: {
        uk: "\u041D\u0435\u043C\u0430\u0454 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u043C\u0435\u0440\u0447\u0430\u043D\u0434\u0430\u0439\u0437\u0435\u0440\u0430",
        en: "No responsible merchandiser",
        hy: "\u054A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0561\u057F\u0578\u0582 \u0574\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580 \u0579\u056F\u0561",
        ka: "\u10DE\u10D0\u10E1\u10E3\u10EE\u10D8\u10E1\u10DB\u10D2\u10D4\u10D1\u10D4\u10DA\u10D8 \u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D8 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1"
    },
    import_btn: {
        uk: "\u0406\u043C\u043F\u043E\u0440\u0442",
        en: "Import",
        hy: "\u0546\u0565\u0580\u0574\u0578\u0582\u056E\u0565\u056C",
        ka: "\u10D8\u10DB\u10DE\u10DD\u10E0\u10E2\u10D8"
    },
    label: {
        uk: "\u041E\u0441\u043D\u043E\u0432\u043D\u0435",
        en: "Main",
        hy: "\u0540\u056B\u0574\u0576\u0561\u056F\u0561\u0576",
        ka: "\u10DB\u10D7\u10D0\u10D5\u10D0\u10E0\u10D8"
    },
    q_complete: {
        uk: "\u0423\u0441\u0435 \u0437\u0430\u043F\u043E\u0432\u043D\u0435\u043D\u043E",
        en: "Nothing missing",
        hy: "\u0531\u0574\u0565\u0576 \u056B\u0576\u0579 \u056C\u0580\u0561\u0581\u057E\u0561\u056E \u0567",
        ka: "\u10E7\u10D5\u10D4\u10DA\u10D0\u10E4\u10D4\u10E0\u10D8 \u10E8\u10D4\u10D5\u10E1\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0"
    },
    restored_n: {
        uk: "\u0412\u0456\u0434\u043D\u043E\u0432\u043B\u0435\u043D\u043E. \u041A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C: {n}",
        en: "Restored. Count: {n}",
        hy: "\u054E\u0565\u0580\u0561\u056F\u0561\u0576\u0563\u0576\u057E\u0565\u0581\u0589 \u0554\u0561\u0576\u0561\u056F\u0568\u055D {n}",
        ka: "\u10D0\u10E6\u10D3\u10D2\u10D0. \u10E0\u10D0\u10DD\u10D3\u10D4\u10DC\u10DD\u10D1\u10D0: {n}"
    },
    sec_assignment_desc: {
        uk: "\u0425\u0442\u043E \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0430\u0454 \u0437\u0430 \u0446\u044E \u0442\u043E\u0447\u043A\u0443",
        en: "Who is responsible for this point",
        hy: "\u0548\u057E \u0567 \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0561\u057F\u0578\u0582 \u0561\u0575\u057D \u056F\u0565\u057F\u056B \u0570\u0561\u0574\u0561\u0580",
        ka: "\u10D5\u10D8\u10DC \u10D0\u10E0\u10D8\u10E1 \u10DE\u10D0\u10E1\u10E3\u10EE\u10D8\u10E1\u10DB\u10D2\u10D4\u10D1\u10D4\u10DA\u10D8 \u10D0\u10DB \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D6\u10D4"
    },
    sec_basic_desc: {
        uk: "\u041D\u0430\u0437\u0432\u0430, \u043A\u043E\u0434 \u0456 \u043C\u0435\u0440\u0435\u0436\u0430 \u0442\u043E\u0447\u043A\u0438",
        en: "The point's name, code and network",
        hy: "\u053F\u0565\u057F\u056B \u0561\u0576\u057E\u0561\u0576\u0578\u0582\u0574\u0568, \u056F\u0578\u0564\u0568 \u0587 \u0581\u0561\u0576\u0581\u0568",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8\u10E1 \u10E1\u10D0\u10EE\u10D4\u10DA\u10D8, \u10D9\u10DD\u10D3\u10D8 \u10D3\u10D0 \u10E5\u10E1\u10D4\u10DA\u10D8"
    },
    sec_integration: {
        uk: "\u0406\u043D\u0442\u0435\u0433\u0440\u0430\u0446\u0456\u044F \u0437 Outforz",
        en: "Outforz integration",
        hy: "Outforz \u056B\u0576\u057F\u0565\u0563\u0580\u0578\u0582\u0574",
        ka: "Outforz \u10D8\u10DC\u10E2\u10D4\u10D2\u10E0\u10D0\u10EA\u10D8\u10D0"
    },
    sec_location_desc: {
        uk: "\u0410\u0434\u0440\u0435\u0441\u0430, \u043D\u0430\u0441\u0435\u043B\u0435\u043D\u0438\u0439 \u043F\u0443\u043D\u043A\u0442 \u0456 \u043A\u043E\u043E\u0440\u0434\u0438\u043D\u0430\u0442\u0438 \u043D\u0430 \u043A\u0430\u0440\u0442\u0456",
        en: "Address, locality and coordinates on the map",
        hy: "\u0540\u0561\u057D\u0581\u0565\u0576, \u0562\u0576\u0561\u056F\u0561\u057E\u0561\u0575\u0580\u0568 \u0587 \u056F\u0578\u0578\u0580\u0564\u056B\u0576\u0561\u057F\u0576\u0565\u0580\u0568 \u0584\u0561\u0580\u057F\u0565\u0566\u056B \u057E\u0580\u0561",
        ka: "\u10DB\u10D8\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10D8, \u10D3\u10D0\u10E1\u10D0\u10EE\u10DA\u10D4\u10D1\u10D0 \u10D3\u10D0 \u10D9\u10DD\u10DD\u10E0\u10D3\u10D8\u10DC\u10D0\u10E2\u10D4\u10D1\u10D8 \u10E0\u10E3\u10D9\u10D0\u10D6\u10D4"
    },
    sec_options_desc: {
        uk: "\u0420\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u043E\u0432\u0430\u043D\u0438\u0439 \u0447\u0430\u0441 \u0432\u0456\u0437\u0438\u0442\u0443 \u0442\u0430 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0456\u0441\u0442\u044C",
        en: "Recommended visit time and availability",
        hy: "\u0531\u0575\u0581\u056B \u0561\u057C\u0561\u057B\u0561\u0580\u056F\u057E\u0578\u0572 \u057F\u0587\u0578\u0572\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0568 \u0587 \u0570\u0561\u057D\u0561\u0576\u0565\u056C\u056B\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0568",
        ka: "\u10D5\u10D8\u10D6\u10D8\u10E2\u10D8\u10E1 \u10E1\u10D0\u10E1\u10E3\u10E0\u10D5\u10D4\u10DA\u10D8 \u10D3\u10E0\u10DD \u10D3\u10D0 \u10EE\u10D4\u10DA\u10DB\u10D8\u10E1\u10D0\u10EC\u10D5\u10D3\u10DD\u10DB\u10DD\u10D1\u10D0"
    },
    sec_price_monitoring: {
        uk: "\u041C\u043E\u043D\u0456\u0442\u043E\u0440\u0438\u043D\u0433 \u0446\u0456\u043D",
        en: "Price monitoring",
        hy: "\u0533\u0576\u0565\u0580\u056B \u0574\u0578\u0576\u056B\u057F\u0578\u0580\u056B\u0576\u0563",
        ka: "\u10E4\u10D0\u10E1\u10D4\u10D1\u10D8\u10E1 \u10DB\u10DD\u10DC\u10D8\u10E2\u10DD\u10E0\u10D8\u10DC\u10D2\u10D8"
    }
};
const $fc3f36407bc5ec6c$export$9cbb0f231a0ab7ea = {
    title: {
        uk: "\u041E\u0433\u043B\u044F\u0434",
        en: "Overview",
        hy: "\u0531\u056F\u0576\u0561\u0580\u056F",
        ka: "\u10DB\u10D8\u10DB\u10DD\u10EE\u10D8\u10DA\u10D5\u10D0"
    },
    active_merchandisers: {
        uk: "\u0410\u043A\u0442\u0438\u0432\u043D\u0456 \u043C\u0435\u0440\u0447\u0435\u043D\u0434\u0430\u0439\u0437\u0435\u0440\u0438",
        en: "Active merchandisers",
        hy: "\u0531\u056F\u057F\u056B\u057E \u0574\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580\u0576\u0565\u0580",
        ka: "\u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D8 \u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D4\u10D1\u10D8"
    },
    active_supervisors: {
        uk: "\u0410\u043A\u0442\u0438\u0432\u043D\u0456 \u0441\u0443\u043F\u0435\u0440\u0432\u0430\u0439\u0437\u0435\u0440\u0438",
        en: "Active supervisors",
        hy: "\u0531\u056F\u057F\u056B\u057E \u057D\u0578\u0582\u057A\u0565\u0580\u057E\u0561\u0575\u0566\u0565\u0580\u0576\u0565\u0580",
        ka: "\u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D8 \u10E1\u10E3\u10DE\u10D4\u10E0\u10D5\u10D0\u10D8\u10D6\u10D4\u10E0\u10D4\u10D1\u10D8"
    },
    visits: {
        uk: "\u0412\u0456\u0437\u0438\u0442\u0438",
        en: "Visits",
        hy: "\u0531\u0575\u0581\u0565\u0580",
        ka: "\u10D5\u10D8\u10D6\u10D8\u10E2\u10D4\u10D1\u10D8"
    },
    reports: {
        uk: "\u0417\u0432\u0456\u0442\u0438",
        en: "Reports",
        hy: "\u0540\u0561\u0577\u057E\u0565\u057F\u057E\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580",
        ka: "\u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10D4\u10D1\u10D8"
    },
    answers: {
        uk: "\u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0456",
        en: "Answers",
        hy: "\u054A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0576\u0565\u0580",
        ka: "\u10DE\u10D0\u10E1\u10E3\u10EE\u10D4\u10D1\u10D8"
    },
    trend_title: {
        uk: "\u0414\u0438\u043D\u0430\u043C\u0456\u043A\u0430 \u0437\u0430 \u043C\u0456\u0441\u044F\u0446\u044C",
        en: "Monthly activity",
        hy: "\u0531\u0574\u057D\u0561\u056F\u0561\u0576 \u0561\u056F\u057F\u056B\u057E\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10D7\u10D5\u10D8\u10E3\u10E0\u10D8 \u10D0\u10E5\u10E2\u10D8\u10D5\u10DD\u10D1\u10D0"
    },
    top_merchandisers: {
        uk: "\u0422\u043E\u043F \u043C\u0435\u0440\u0447\u0435\u043D\u0434\u0430\u0439\u0437\u0435\u0440\u0438",
        en: "Top merchandisers",
        hy: "\u053C\u0561\u057E\u0561\u0563\u0578\u0582\u0575\u0576 \u0574\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580\u0576\u0565\u0580",
        ka: "\u10E2\u10DD\u10DE \u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D4\u10D1\u10D8"
    },
    by_merchandiser: {
        uk: "\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430 \u0437\u0430 \u043C\u0435\u0440\u0447\u0435\u043D\u0434\u0430\u0439\u0437\u0435\u0440\u0430\u043C\u0438",
        en: "Statistics by merchandiser",
        hy: "\u054E\u056B\u0573\u0561\u056F\u0561\u0563\u0580\u0578\u0582\u0569\u0575\u0578\u0582\u0576 \u0568\u057D\u057F \u0574\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580\u056B",
        ka: "\u10E1\u10E2\u10D0\u10E2\u10D8\u10E1\u10E2\u10D8\u10D9\u10D0 \u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D4\u10D1\u10D8\u10E1 \u10DB\u10D8\u10EE\u10D4\u10D3\u10D5\u10D8\u10D7"
    },
    search_ph: {
        uk: "\u041F\u043E\u0448\u0443\u043A \u043C\u0435\u0440\u0447\u0435\u043D\u0434\u0430\u0439\u0437\u0435\u0440\u0430\u2026",
        en: "Search merchandiser\u2026",
        hy: "\u0553\u0576\u057F\u0580\u0565\u056C \u0574\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580\u2026",
        ka: "\u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D8\u10E1 \u10EB\u10D4\u10D1\u10DC\u10D0\u2026"
    },
    col_merchandiser: {
        uk: "\u041C\u0435\u0440\u0447\u0435\u043D\u0434\u0430\u0439\u0437\u0435\u0440",
        en: "Merchandiser",
        hy: "\u0544\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580",
        ka: "\u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D8"
    },
    col_visits: {
        uk: "\u0412\u0456\u0437\u0438\u0442\u0438",
        en: "Visits",
        hy: "\u0531\u0575\u0581\u0565\u0580",
        ka: "\u10D5\u10D8\u10D6\u10D8\u10E2\u10D4\u10D1\u10D8"
    },
    col_reports: {
        uk: "\u0417\u0432\u0456\u0442\u0438",
        en: "Reports",
        hy: "\u0540\u0561\u0577\u057E\u0565\u057F\u057E\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580",
        ka: "\u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10D4\u10D1\u10D8"
    },
    col_answers: {
        uk: "\u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0456",
        en: "Answers",
        hy: "\u054A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0576\u0565\u0580",
        ka: "\u10DE\u10D0\u10E1\u10E3\u10EE\u10D4\u10D1\u10D8"
    },
    loading: {
        uk: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F\u2026",
        en: "Loading\u2026",
        hy: "\u0532\u0565\u057C\u0576\u057E\u0578\u0582\u0574 \u0567\u2026",
        ka: "\u10D8\u10E2\u10D5\u10D8\u10E0\u10D7\u10D4\u10D1\u10D0\u2026"
    },
    empty: {
        uk: "\u041D\u0435\u043C\u0430\u0454 \u0434\u0430\u043D\u0438\u0445",
        en: "No data",
        hy: "\u054F\u057E\u0575\u0561\u056C\u0576\u0565\u0580 \u0579\u056F\u0561\u0576",
        ka: "\u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1"
    },
    error: {
        uk: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0441\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0443.",
        en: "Failed to load statistics.",
        hy: "\u0549\u0570\u0561\u057B\u0578\u0572\u057E\u0565\u0581 \u0562\u0565\u057C\u0576\u0565\u056C \u057E\u056B\u0573\u0561\u056F\u0561\u0563\u0580\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0568:",
        ka: "\u10E1\u10E2\u10D0\u10E2\u10D8\u10E1\u10E2\u10D8\u10D9\u10D8\u10E1 \u10E9\u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D0 \u10D5\u10D4\u10E0 \u10DB\u10DD\u10EE\u10D4\u10E0\u10EE\u10D3\u10D0."
    },
    retry: {
        uk: "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0438",
        en: "Retry",
        hy: "\u053F\u0580\u056F\u0576\u0565\u056C",
        ka: "\u10EE\u10D4\u10DA\u10D0\u10EE\u10DA\u10D0"
    },
    // Page subtitle: the period being shown and what it is compared against.
    // {m} = the selected month, {p} = the one before it.
    period_sub: {
        uk: "{m} \xb7 \u043F\u0440\u043E\u0442\u0438 {p}",
        en: "{m} \xb7 vs {p}",
        hy: "{m} \xb7 \u0568\u0576\u0564\u0564\u0565\u0574 {p}",
        ka: "{m} \xb7 \u10E8\u10D4\u10D3\u10D0\u10E0\u10D4\u10D1\u10D8\u10D7 {p}"
    },
    // Accessible names for the icon-only month stepper — an arrow glyph has none.
    prev_month: {
        uk: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u0456\u0439 \u043C\u0456\u0441\u044F\u0446\u044C",
        en: "Previous month",
        hy: "\u0546\u0561\u056D\u0578\u0580\u0564 \u0561\u0574\u056B\u057D",
        ka: "\u10EC\u10D8\u10DC\u10D0 \u10D7\u10D5\u10D4"
    },
    next_month: {
        uk: "\u041D\u0430\u0441\u0442\u0443\u043F\u043D\u0438\u0439 \u043C\u0456\u0441\u044F\u0446\u044C",
        en: "Next month",
        hy: "\u0540\u0561\u057B\u0578\u0580\u0564 \u0561\u0574\u056B\u057D",
        ka: "\u10E8\u10D4\u10DB\u10D3\u10D4\u10D2\u10D8 \u10D7\u10D5\u10D4"
    },
    // ---- Trend chart -------------------------------------------------------
    // The fourth series counts SURVEY answers, which are a different system from
    // the task `answers` KPI above — they need distinct labels or the legend lies.
    survey_answers: {
        uk: "\u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0456 \u043E\u043F\u0438\u0442\u0443\u0432\u0430\u043D\u044C",
        en: "Survey answers",
        hy: "\u0540\u0561\u0580\u0581\u0578\u0582\u0574\u0576\u0565\u0580\u056B \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0576\u0565\u0580",
        ka: "\u10D2\u10D0\u10DB\u10DD\u10D9\u10D8\u10D7\u10EE\u10D5\u10D8\u10E1 \u10DE\u10D0\u10E1\u10E3\u10EE\u10D4\u10D1\u10D8"
    },
    // ---- Survey band -------------------------------------------------------
    surveys: {
        uk: "\u041E\u043F\u0438\u0442\u0443\u0432\u0430\u043D\u043D\u044F",
        en: "Surveys",
        hy: "\u0540\u0561\u0580\u0581\u0578\u0582\u0574\u0576\u0565\u0580",
        ka: "\u10D2\u10D0\u10DB\u10DD\u10D9\u10D8\u10D7\u10EE\u10D5\u10D4\u10D1\u10D8"
    },
    active_surveys: {
        uk: "\u0410\u043A\u0442\u0438\u0432\u043D\u0456 \u043E\u043F\u0438\u0442\u0443\u0432\u0430\u043D\u043D\u044F",
        en: "Active surveys",
        hy: "\u0531\u056F\u057F\u056B\u057E \u0570\u0561\u0580\u0581\u0578\u0582\u0574\u0576\u0565\u0580",
        ka: "\u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D8 \u10D2\u10D0\u10DB\u10DD\u10D9\u10D8\u10D7\u10EE\u10D5\u10D4\u10D1\u10D8"
    },
    // {t} = total surveys, {e} = how many end within seven days.
    active_surveys_hint: {
        uk: "\u0443\u0441\u044C\u043E\u0433\u043E {t} \xb7 \u0437\u0430\u0432\u0435\u0440\u0448\u0443\u044E\u0442\u044C\u0441\u044F \u0446\u044C\u043E\u0433\u043E \u0442\u0438\u0436\u043D\u044F: {e}",
        en: "{t} total \xb7 {e} ending this week",
        hy: "\u0568\u0576\u0564\u0561\u0574\u0565\u0576\u0568 {t} \xb7 \u0561\u0575\u057D \u0577\u0561\u0562\u0561\u0569 \u0561\u057E\u0561\u0580\u057F\u057E\u0578\u0582\u0574 \u0567 {e}",
        ka: "\u10E1\u10E3\u10DA {t} \xb7 \u10D0\u10DB \u10D9\u10D5\u10D8\u10E0\u10D0\u10E1 \u10E1\u10E0\u10E3\u10DA\u10D3\u10D4\u10D1\u10D0 {e}"
    },
    // {a} = answered required question instances, {b} = assigned.
    answers_collected: {
        uk: "\u0417\u0456\u0431\u0440\u0430\u043D\u043E \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0435\u0439",
        en: "Answers collected",
        hy: "\u0540\u0561\u057E\u0561\u0584\u057E\u0561\u056E \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0576\u0565\u0580",
        ka: "\u10E8\u10D4\u10D2\u10E0\u10DD\u10D5\u10D4\u10D1\u10E3\u10DA\u10D8 \u10DE\u10D0\u10E1\u10E3\u10EE\u10D4\u10D1\u10D8"
    },
    // {p} carries its own sign, {m} is the previous month's name.
    vs_previous_month: {
        uk: "{p}% \u043F\u0440\u043E\u0442\u0438 {m}",
        en: "{p}% vs {m}",
        hy: "{p}% \u0568\u0576\u0564\u0564\u0565\u0574 {m}",
        ka: "{p}% \u10E8\u10D4\u10D3\u10D0\u10E0\u10D4\u10D1\u10D8\u10D7 {m}"
    },
    // ---- Visit status ------------------------------------------------------
    visit_status: {
        uk: "\u0421\u0442\u0430\u0442\u0443\u0441 \u0432\u0456\u0437\u0438\u0442\u0456\u0432",
        en: "Visit status",
        hy: "\u0531\u0575\u0581\u0565\u0580\u056B \u056F\u0561\u0580\u0563\u0561\u057E\u056B\u0573\u0561\u056F",
        ka: "\u10D5\u10D8\u10D6\u10D8\u10E2\u10D8\u10E1 \u10E1\u10E2\u10D0\u10E2\u10E3\u10E1\u10D8"
    },
    approved: {
        uk: "\u0417\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043E",
        en: "Approved",
        hy: "\u0540\u0561\u057D\u057F\u0561\u057F\u057E\u0561\u056E",
        ka: "\u10D3\u10D0\u10DB\u10E2\u10D9\u10D8\u10EA\u10D4\u10D1\u10E3\u10DA\u10D8"
    },
    on_verification: {
        uk: "\u041D\u0430 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0446\u0456",
        en: "On verification",
        hy: "\u054D\u057F\u0578\u0582\u0563\u0574\u0561\u0576 \u0583\u0578\u0582\u056C\u0578\u0582\u0574",
        ka: "\u10D2\u10D0\u10D3\u10D0\u10DB\u10DD\u10EC\u10DB\u10D4\u10D1\u10D0\u10E8\u10D8"
    },
    not_approved: {
        uk: "\u041D\u0435 \u0437\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043E",
        en: "Not approved",
        hy: "\u0549\u0570\u0561\u057D\u057F\u0561\u057F\u057E\u0561\u056E",
        ka: "\u10D3\u10D0\u10E3\u10DB\u10E2\u10D9\u10D8\u10EA\u10D4\u10D1\u10D4\u10DA\u10D8"
    },
    total: {
        uk: "\u0443\u0441\u044C\u043E\u0433\u043E",
        en: "total",
        hy: "\u0568\u0576\u0564\u0561\u0574\u0565\u0576\u0568",
        ka: "\u10E1\u10E3\u10DA"
    },
    // ---- Photo review pipeline ---------------------------------------------
    photo_pipeline: {
        uk: "\u041F\u0435\u0440\u0435\u0432\u0456\u0440\u043A\u0430 \u0444\u043E\u0442\u043E",
        en: "Photo review pipeline",
        hy: "\u053C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580\u0576\u0565\u0580\u056B \u057D\u057F\u0578\u0582\u0563\u0578\u0582\u0574",
        ka: "\u10E4\u10DD\u10E2\u10DD\u10E1 \u10E8\u10D4\u10DB\u10DD\u10EC\u10DB\u10D4\u10D1\u10D0"
    },
    submitted: {
        uk: "\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u043E",
        en: "Submitted",
        hy: "\u0548\u0582\u0572\u0561\u0580\u056F\u057E\u0561\u056E",
        ka: "\u10D2\u10D0\u10D2\u10D6\u10D0\u10D5\u10DC\u10D8\u10DA\u10D8"
    },
    reviewed: {
        uk: "\u041F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u043E",
        en: "Reviewed",
        hy: "\u054D\u057F\u0578\u0582\u0563\u057E\u0561\u056E",
        ka: "\u10E8\u10D4\u10DB\u10DD\u10EC\u10DB\u10D4\u10D1\u10E3\u10DA\u10D8"
    },
    // {n} = rejected count, {p} = share of everything reviewed.
    rejected_hint: {
        uk: "\u0432\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043E: {n} ({p}% \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0435\u043D\u0438\u0445)",
        en: "{n} rejected ({p}% of reviewed)",
        hy: "\u0574\u0565\u0580\u056A\u057E\u0561\u056E\u055D {n} ({p}% \u057D\u057F\u0578\u0582\u0563\u057E\u0561\u056E\u0576\u0565\u0580\u056B)",
        ka: "\u10E3\u10D0\u10E0\u10E7\u10DD\u10E4\u10D8\u10DA\u10D8: {n} (\u10E8\u10D4\u10DB\u10DD\u10EC\u10DB\u10D4\u10D1\u10E3\u10DA\u10D8\u10E1 {p}%)"
    },
    // ---- Answers by type ---------------------------------------------------
    answers_by_type: {
        uk: "\u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0456 \u0437\u0430 \u0442\u0438\u043F\u043E\u043C",
        en: "Answers by type",
        hy: "\u054A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0576\u0565\u0580\u0568 \u0568\u057D\u057F \u057F\u056B\u057A\u056B",
        ka: "\u10DE\u10D0\u10E1\u10E3\u10EE\u10D4\u10D1\u10D8 \u10E2\u10D8\u10DE\u10D8\u10E1 \u10DB\u10D8\u10EE\u10D4\u10D3\u10D5\u10D8\u10D7"
    },
    t_photo: {
        uk: "\u0424\u043E\u0442\u043E",
        en: "Photo",
        hy: "\u053C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580",
        ka: "\u10E4\u10DD\u10E2\u10DD"
    },
    t_dropdown: {
        uk: "\u0421\u043F\u0438\u0441\u043E\u043A",
        en: "Dropdown",
        hy: "\u0551\u0561\u0576\u056F",
        ka: "\u10E1\u10D8\u10D0"
    },
    t_numeric: {
        uk: "\u0427\u0438\u0441\u043B\u043E",
        en: "Numeric",
        hy: "\u0539\u056B\u057E",
        ka: "\u10E0\u10D8\u10EA\u10EE\u10D5\u10D8"
    },
    t_text: {
        uk: "\u0422\u0435\u043A\u0441\u0442",
        en: "Text",
        hy: "\u054F\u0565\u0584\u057D\u057F",
        ka: "\u10E2\u10D4\u10E5\u10E1\u10E2\u10D8"
    },
    t_boolean: {
        uk: "\u0422\u0430\u043A/\u041D\u0456",
        en: "Boolean",
        hy: "\u0531\u0575\u0578/\u0548\u0579",
        ka: "\u10D3\u10D8\u10D0\u10EE/\u10D0\u10E0\u10D0"
    },
    t_date: {
        uk: "\u0414\u0430\u0442\u0430",
        en: "Date",
        hy: "\u0531\u0574\u057D\u0561\u0569\u056B\u057E",
        ka: "\u10D7\u10D0\u10E0\u10D8\u10E6\u10D8"
    },
    // ---- Regions -----------------------------------------------------------
    visits_by_region: {
        uk: "\u0412\u0456\u0437\u0438\u0442\u0438 \u0437\u0430 \u0440\u0435\u0433\u0456\u043E\u043D\u0430\u043C\u0438",
        en: "Visits by region",
        hy: "\u0531\u0575\u0581\u0565\u0580 \u0568\u057D\u057F \u0574\u0561\u0580\u0566\u0565\u0580\u056B",
        ka: "\u10D5\u10D8\u10D6\u10D8\u10E2\u10D4\u10D1\u10D8 \u10E0\u10D4\u10D2\u10D8\u10DD\u10DC\u10D4\u10D1\u10D8\u10E1 \u10DB\u10D8\u10EE\u10D4\u10D3\u10D5\u10D8\u10D7"
    },
    top_regions: {
        uk: "\u0442\u043E\u043F 5 \u0456 \u0440\u0435\u0448\u0442\u0430",
        en: "top 5 and the rest",
        hy: "\u0569\u0578\u0583 5 \u0587 \u0574\u0576\u0561\u0581\u0561\u056E\u0568",
        ka: "\u10E2\u10DD\u10DE 5 \u10D3\u10D0 \u10D3\u10D0\u10DC\u10D0\u10E0\u10E9\u10D4\u10DC\u10D8"
    },
    other_regions: {
        uk: "\u0406\u043D\u0448\u0456 \u0440\u0435\u0433\u0456\u043E\u043D\u0438",
        en: "Other regions",
        hy: "\u0531\u0575\u056C \u0574\u0561\u0580\u0566\u0565\u0580",
        ka: "\u10E1\u10EE\u10D5\u10D0 \u10E0\u10D4\u10D2\u10D8\u10DD\u10DC\u10D4\u10D1\u10D8"
    },
    // ---- Per-survey completion ---------------------------------------------
    survey_activity: {
        uk: "\u0410\u043A\u0442\u0438\u0432\u043D\u0456\u0441\u0442\u044C \u043E\u043F\u0438\u0442\u0443\u0432\u0430\u043D\u044C",
        en: "Survey activity",
        hy: "\u0540\u0561\u0580\u0581\u0578\u0582\u0574\u0576\u0565\u0580\u056B \u0561\u056F\u057F\u056B\u057E\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10D2\u10D0\u10DB\u10DD\u10D9\u10D8\u10D7\u10EE\u10D5\u10D4\u10D1\u10D8\u10E1 \u10D0\u10E5\u10E2\u10D8\u10D5\u10DD\u10D1\u10D0"
    },
    active_this_month: {
        uk: "\u0430\u043A\u0442\u0438\u0432\u043D\u0456 \u0446\u044C\u043E\u0433\u043E \u043C\u0456\u0441\u044F\u0446\u044F",
        en: "active this month",
        hy: "\u0561\u056F\u057F\u056B\u057E \u0561\u0575\u057D \u0561\u0574\u056B\u057D",
        ka: "\u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D8 \u10D0\u10DB \u10D7\u10D5\u10D4\u10E8\u10D8"
    },
    // {a} = answers recorded, {q} = questions in the survey. Label:value form
    // rather than "{a} answers", which would need the noun to agree with {a}.
    // ---- Heatmap -----------------------------------------------------------
    visit_intensity: {
        uk: "\u0406\u043D\u0442\u0435\u043D\u0441\u0438\u0432\u043D\u0456\u0441\u0442\u044C \u0432\u0456\u0437\u0438\u0442\u0456\u0432",
        en: "Visit intensity",
        hy: "\u0531\u0575\u0581\u0565\u0580\u056B \u056B\u0576\u057F\u0565\u0576\u057D\u056B\u057E\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10D5\u10D8\u10D6\u10D8\u10E2\u10D4\u10D1\u10D8\u10E1 \u10D8\u10DC\u10E2\u10D4\u10DC\u10E1\u10D8\u10D5\u10DD\u10D1\u10D0"
    },
    per_day: {
        uk: "\u0432\u0456\u0437\u0438\u0442\u0456\u0432 \u043D\u0430 \u0434\u0435\u043D\u044C",
        en: "visits per day",
        hy: "\u0561\u0575\u0581 \u0585\u0580\u0561\u056F\u0561\u0576",
        ka: "\u10D5\u10D8\u10D6\u10D8\u10E2\u10D8 \u10D3\u10E6\u10D4\u10E8\u10D8"
    },
    fewer: {
        uk: "\u041C\u0435\u043D\u0448\u0435",
        en: "Fewer",
        hy: "\u0554\u056B\u0579",
        ka: "\u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8"
    },
    more: {
        uk: "\u0411\u0456\u043B\u044C\u0448\u0435",
        en: "More",
        hy: "\u0547\u0561\u057F",
        ka: "\u10DB\u10D4\u10E2\u10D8"
    },
    // ---- Table -------------------------------------------------------------
    by_visits: {
        uk: "\u0437\u0430 \u0432\u0456\u0437\u0438\u0442\u0430\u043C\u0438",
        en: "by visits",
        hy: "\u0568\u057D\u057F \u0561\u0575\u0581\u0565\u0580\u056B",
        ka: "\u10D5\u10D8\u10D6\u10D8\u10E2\u10D4\u10D1\u10D8\u10D7"
    }
};
const $fc3f36407bc5ec6c$export$b94fa0d6ced71581 = {
    subtitle: {
        uk: "\u0411\u0456\u0437\u043D\u0435\u0441-\u0437\u0432\u0456\u0442\u0438",
        en: "Business reports",
        hy: "\u0532\u056B\u0566\u0576\u0565\u057D \u0570\u0561\u0577\u057E\u0565\u057F\u057E\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580",
        ka: "\u10D1\u10D8\u10D6\u10DC\u10D4\u10E1 \u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10D4\u10D1\u10D8"
    },
    available: {
        uk: "\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u043E",
        en: "Available",
        hy: "\u0540\u0561\u057D\u0561\u0576\u0565\u056C\u056B",
        ka: "\u10EE\u10D4\u10DA\u10DB\u10D8\u10E1\u10D0\u10EC\u10D5\u10D3\u10DD\u10DB\u10D8"
    },
    error: {
        uk: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0437\u0432\u0456\u0442\u0438",
        en: "Failed to load reports",
        hy: "\u0549\u0570\u0561\u057B\u0578\u0572\u057E\u0565\u0581 \u0562\u0565\u057C\u0576\u0565\u056C \u0570\u0561\u0577\u057E\u0565\u057F\u057E\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580\u0568",
        ka: "\u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10D4\u10D1\u10D8\u10E1 \u10E9\u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D0 \u10D5\u10D4\u10E0 \u10DB\u10DD\u10EE\u10D4\u10E0\u10EE\u10D3\u10D0"
    },
    retry: {
        uk: "\u0421\u043F\u0440\u043E\u0431\u0443\u0432\u0430\u0442\u0438 \u0437\u043D\u043E\u0432\u0443",
        en: "Retry",
        hy: "\u053F\u0580\u056F\u0576\u0565\u056C",
        ka: "\u10EE\u10D4\u10DA\u10D0\u10EE\u10DA\u10D0"
    },
    empty: {
        uk: "\u041D\u0435\u043C\u0430\u0454 \u0437\u0432\u0456\u0442\u0456\u0432",
        en: "No reports available",
        hy: "\u0540\u0561\u0577\u057E\u0565\u057F\u057E\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580 \u0579\u056F\u0561\u0576",
        ka: "\u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10D4\u10D1\u10D8 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1"
    },
    open_new_tab: {
        uk: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438",
        en: "Open",
        hy: "\u0532\u0561\u0581",
        ka: "\u10E6\u10D8\u10D0\u10D0"
    }
};
const $fc3f36407bc5ec6c$export$20c290c14cdb1327 = {
    page_sub: {
        uk: "\u041A\u043E\u043C\u0430\u043D\u0434\u0430 \u0432 \u043F\u043E\u043B\u0456, \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0456\u0441\u0442\u044C \u0456 \u043D\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F",
        en: "Field team, availability and workload",
        hy: "\u0534\u0561\u0577\u057F\u0561\u0575\u056B\u0576 \u0569\u056B\u0574, \u0570\u0561\u057D\u0561\u0576\u0565\u056C\u056B\u0578\u0582\u0569\u0575\u0578\u0582\u0576 \u0587 \u056E\u0561\u0576\u0580\u0561\u0562\u0565\u057C\u0576\u057E\u0561\u056E\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10E1\u10D0\u10D5\u10D4\u10DA\u10D4 \u10D2\u10E3\u10DC\u10D3\u10D8, \u10EE\u10D4\u10DA\u10DB\u10D8\u10E1\u10D0\u10EC\u10D5\u10D3\u10DD\u10DB\u10DD\u10D1\u10D0 \u10D3\u10D0 \u10D3\u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D0"
    },
    search_ph: {
        uk: "\u0406\u043C'\u044F \u0430\u0431\u043E \u0442\u0435\u043B\u0435\u0444\u043E\u043D",
        en: "Name or phone",
        hy: "\u0531\u0576\u0578\u0582\u0576 \u056F\u0561\u0574 \u0570\u0565\u057C\u0561\u056D\u0578\u057D",
        ka: "\u10E1\u10D0\u10EE\u10D4\u10DA\u10D8 \u10D0\u10DC \u10E2\u10D4\u10DA\u10D4\u10E4\u10DD\u10DC\u10D8"
    },
    seg_all: {
        uk: "\u0423\u0441\u0456",
        en: "All",
        hy: "\u0532\u0578\u056C\u0578\u0580\u0568",
        ka: "\u10E7\u10D5\u10D4\u10DA\u10D0"
    },
    seg_active: {
        uk: "\u0410\u043A\u0442\u0438\u0432\u043D\u0456",
        en: "Active",
        hy: "\u0531\u056F\u057F\u056B\u057E",
        ka: "\u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D8"
    },
    seg_inactive: {
        uk: "\u041D\u0435\u0430\u043A\u0442\u0438\u0432\u043D\u0456",
        en: "Inactive",
        hy: "\u0548\u0579 \u0561\u056F\u057F\u056B\u057E",
        ka: "\u10D0\u10E0\u10D0\u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D8"
    },
    flag_absent: {
        uk: "\u0412\u0456\u0434\u0441\u0443\u0442\u043D\u0456 \u0441\u044C\u043E\u0433\u043E\u0434\u043D\u0456",
        en: "Away today",
        hy: "\u0531\u0575\u057D\u0585\u0580 \u0562\u0561\u0581\u0561\u056F\u0561\u0575\u0578\u0582\u0574 \u0565\u0576",
        ka: "\u10D3\u10E6\u10D4\u10E1 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1"
    },
    flag_newbie: {
        uk: "\u041D\u043E\u0432\u0430\u0447\u043A\u0438",
        en: "Newbie",
        hy: "\u0546\u0578\u0580\u0565\u056F\u0576\u0565\u0580",
        ka: "\u10D0\u10EE\u10D0\u10DA\u10D1\u10D4\u10D3\u10D4\u10D1\u10D8"
    },
    flag_no_points: {
        uk: "\u0411\u0435\u0437 \u0442\u043E\u0447\u043E\u043A",
        en: "No points",
        hy: "\u0531\u057C\u0561\u0576\u0581 \u056F\u0565\u057F\u0565\u0580\u056B",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10E0\u10D4\u10E8\u10D4"
    },
    availability: {
        uk: "\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u0456\u0441\u0442\u044C",
        en: "Availability",
        hy: "\u0540\u0561\u057D\u0561\u0576\u0565\u056C\u056B\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10EE\u10D4\u10DA\u10DB\u10D8\u10E1\u10D0\u10EC\u10D5\u10D3\u10DD\u10DB\u10DD\u10D1\u10D0"
    },
    available: {
        uk: "\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u0438\u0439",
        en: "Available",
        hy: "\u0540\u0561\u057D\u0561\u0576\u0565\u056C\u056B",
        ka: "\u10EE\u10D4\u10DA\u10DB\u10D8\u10E1\u10D0\u10EC\u10D5\u10D3\u10DD\u10DB\u10D8"
    },
    away: {
        uk: "\u0412\u0456\u0434\u0441\u0443\u0442\u043D\u0456\u0439",
        en: "Away",
        hy: "\u0532\u0561\u0581\u0561\u056F\u0561\u0575\u0578\u0582\u0574 \u0567",
        ka: "\u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1"
    },
    away_until: {
        uk: "\u0412\u0456\u0434\u0441\u0443\u0442\u043D\u0456\u0439 \u0434\u043E",
        en: "Away until",
        hy: "\u0532\u0561\u0581\u0561\u056F\u0561\u0575\u0578\u0582\u0574 \u0567 \u0574\u056B\u0576\u0579\u0587",
        ka: "\u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1 \u10DB\u10D3\u10D4"
    },
    newbie: {
        uk: "\u041D\u043E\u0432\u0430\u0447\u043E\u043A",
        en: "Newbie",
        hy: "\u0546\u0578\u0580\u0565\u056F",
        ka: "\u10D0\u10EE\u10D0\u10DA\u10D1\u10D4\u10D3\u10D0"
    },
    tenure: {
        uk: "\u0421\u0442\u0430\u0436",
        en: "Tenure",
        hy: "\u0531\u0577\u056D\u0561\u057F\u0561\u056A\u0561\u0574\u056F\u0565\u057F",
        ka: "\u10E1\u10E2\u10D0\u10DF\u10D8"
    },
    joined: {
        uk: "\u041F\u0440\u0438\u0439\u043D\u044F\u0442\u043E",
        en: "Joined",
        hy: "\u0538\u0576\u0564\u0578\u0582\u0576\u057E\u0565\u056C \u0567",
        ka: "\u10DB\u10D8\u10E6\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0"
    },
    never_visited: {
        uk: "\u0429\u0435 \u0431\u0435\u0437 \u0432\u0456\u0437\u0438\u0442\u0456\u0432",
        en: "No visits yet",
        hy: "\u0534\u0565\u057C \u0561\u0575\u0581\u0565\u0580 \u0579\u056F\u0561\u0576",
        ka: "\u10D5\u10D8\u10D6\u10D8\u10E2\u10D4\u10D1\u10D8 \u10EF\u10D4\u10E0 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1"
    },
    last_visit: {
        uk: "\u041E\u0441\u0442\u0430\u043D\u043D\u0456\u0439 \u0432\u0456\u0437\u0438\u0442",
        en: "Last visit",
        hy: "\u054E\u0565\u0580\u057B\u056B\u0576 \u0561\u0575\u0581\u0568",
        ka: "\u10D1\u10DD\u10DA\u10DD \u10D5\u10D8\u10D6\u10D8\u10E2\u10D8"
    },
    days_short: {
        uk: "\u0434\u043D.",
        en: "d",
        hy: "\u0585\u0580",
        ka: "\u10D3\u10E6"
    },
    yr_short: {
        uk: "\u0440.",
        en: "yr",
        hy: "\u057F",
        ka: "\u10EC"
    },
    status_active: {
        uk: "\u0410\u043A\u0442\u0438\u0432\u043D\u0438\u0439",
        en: "Active",
        hy: "\u0531\u056F\u057F\u056B\u057E",
        ka: "\u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D8"
    },
    status_inactive: {
        uk: "\u041D\u0435\u0430\u043A\u0442\u0438\u0432\u043D\u0438\u0439",
        en: "Inactive",
        hy: "\u0548\u0579 \u0561\u056F\u057F\u056B\u057E",
        ka: "\u10D0\u10E0\u10D0\u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D8"
    },
    mv_on_foot: {
        uk: "\u041F\u0456\u0448\u043A\u0438",
        en: "On foot",
        hy: "\u0548\u057F\u0584\u0578\u057E",
        ka: "\u10E4\u10D4\u10EE\u10D8\u10D7"
    },
    mv_motorcycle: {
        uk: "\u041C\u043E\u0442\u043E\u0446\u0438\u043A\u043B",
        en: "Motorcycle",
        hy: "\u0544\u0578\u057F\u0578\u0581\u056B\u056F\u056C",
        ka: "\u10DB\u10DD\u10E2\u10DD\u10EA\u10D8\u10D9\u10DA\u10D8"
    },
    mv_bike: {
        uk: "\u0412\u0435\u043B\u043E\u0441\u0438\u043F\u0435\u0434 \u0430\u0431\u043E \u0441\u043A\u0443\u0442\u0435\u0440",
        en: "Bike or scooter",
        hy: "\u0540\u0565\u056E\u0561\u0576\u056B\u057E \u056F\u0561\u0574 \u057D\u056F\u0578\u0582\u057F\u0565\u0580",
        ka: "\u10D5\u10D4\u10DA\u10DD\u10E1\u10D8\u10DE\u10D4\u10D3\u10D8 \u10D0\u10DC \u10E1\u10D9\u10E3\u10E2\u10D4\u10E0\u10D8"
    },
    mv_automobile: {
        uk: "\u0410\u0432\u0442\u043E\u043C\u043E\u0431\u0456\u043B\u044C",
        en: "Automobile",
        hy: "\u0531\u057E\u057F\u0578\u0574\u0565\u0584\u0565\u0576\u0561",
        ka: "\u10D0\u10D5\u10E2\u10DD\u10DB\u10DD\u10D1\u10D8\u10DA\u10D8"
    },
    mv_public: {
        uk: "\u0413\u0440\u043E\u043C\u0430\u0434\u0441\u044C\u043A\u0438\u0439 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442",
        en: "Public transport",
        hy: "\u0540\u0561\u057D\u0561\u0580\u0561\u056F\u0561\u056F\u0561\u0576 \u057F\u0580\u0561\u0576\u057D\u057A\u0578\u0580\u057F",
        ka: "\u10E1\u10D0\u10D6\u10DD\u10D2\u10D0\u10D3\u10DD\u10D4\u10D1\u10E0\u10D8\u10D5\u10D8 \u10E2\u10E0\u10D0\u10DC\u10E1\u10DE\u10DD\u10E0\u10E2\u10D8"
    },
    new_merch: {
        uk: "\u041D\u043E\u0432\u0438\u0439 \u043C\u0435\u0440\u0447\u0430\u043D\u0434\u0430\u0439\u0437\u0435\u0440",
        en: "New merchandiser",
        hy: "\u0546\u0578\u0580 \u0574\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580",
        ka: "\u10D0\u10EE\u10D0\u10DA\u10D8 \u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D8"
    },
    open: {
        uk: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u043F\u043E\u0432\u043D\u0443 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443",
        en: "Open full page",
        hy: "\u0532\u0561\u0581\u0565\u056C \u0561\u0574\u0562\u0578\u0572\u057B \u0567\u057B\u0568",
        ka: "\u10E1\u10E0\u10E3\u10DA\u10D8 \u10D2\u10D5\u10D4\u10E0\u10D3\u10D8\u10E1 \u10D2\u10D0\u10EE\u10E1\u10DC\u10D0"
    },
    add_absence: {
        uk: "\u0414\u043E\u0434\u0430\u0442\u0438 \u0432\u0456\u0434\u0441\u0443\u0442\u043D\u0456\u0441\u0442\u044C",
        en: "Add absence",
        hy: "\u0531\u057E\u0565\u056C\u0561\u0581\u0576\u0565\u056C \u0562\u0561\u0581\u0561\u056F\u0561\u0575\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10D0\u10E0\u10E7\u10DD\u10E4\u10DC\u10D8\u10E1 \u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D0"
    },
    activate: {
        uk: "\u0410\u043A\u0442\u0438\u0432\u0443\u0432\u0430\u0442\u0438",
        en: "Activate",
        hy: "\u0531\u056F\u057F\u056B\u057E\u0561\u0581\u0576\u0565\u056C",
        ka: "\u10D2\u10D0\u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D4\u10D1\u10D0"
    },
    deactivate: {
        uk: "\u0414\u0435\u0430\u043A\u0442\u0438\u0432\u0443\u0432\u0430\u0442\u0438",
        en: "Deactivate",
        hy: "\u0534\u0565\u0561\u056F\u057F\u056B\u057E\u0561\u0581\u0576\u0565\u056C",
        ka: "\u10D3\u10D4\u10D0\u10E5\u10E2\u10D8\u10D5\u10D0\u10EA\u10D8\u10D0"
    },
    confirm_deactivate: {
        uk: "\u0414\u0435\u0430\u043A\u0442\u0438\u0432\u0443\u0432\u0430\u0442\u0438 \u043C\u0435\u0440\u0447\u0430\u043D\u0434\u0430\u0439\u0437\u0435\u0440\u0456\u0432? \u0412\u0438\u0431\u0440\u0430\u043D\u043E: {n}",
        en: "Deactivate the selected merchandisers? Selected: {n}",
        hy: "\u0534\u0565\u0561\u056F\u057F\u056B\u057E\u0561\u0581\u0576\u0565\u056C \u0561\u0575\u057D \u0563\u0580\u0561\u057C\u0578\u0582\u0574\u0568 {n}",
        ka: "\u10D3\u10D4\u10D0\u10E5\u10E2\u10D8\u10D5\u10D8\u10E0\u10D4\u10D1\u10D0 \u10D0\u10DB \u10E9\u10D0\u10DC\u10D0\u10EC\u10D4\u10E0\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1 {n}"
    },
    confirm_activate: {
        uk: "\u0410\u043A\u0442\u0438\u0432\u0443\u0432\u0430\u0442\u0438 \u043C\u0435\u0440\u0447\u0430\u043D\u0434\u0430\u0439\u0437\u0435\u0440\u0456\u0432? \u0412\u0438\u0431\u0440\u0430\u043D\u043E: {n}",
        en: "Activate the selected merchandisers? Selected: {n}",
        hy: "\u0531\u056F\u057F\u056B\u057E\u0561\u0581\u0576\u0565\u056C. {n}",
        ka: "\u10D2\u10D0\u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D4\u10D1\u10D0. {n}"
    },
    deactivated_msg: {
        uk: "\u0414\u0435\u0430\u043A\u0442\u0438\u0432\u043E\u0432\u0430\u043D\u043E: {n}",
        en: "Deactivated: {n}",
        hy: "\u0531\u057A\u0561\u0561\u056F\u057F\u056B\u057E\u0561\u0581\u057E\u0561\u056E \u0567: {n}",
        ka: "\u10D3\u10D4\u10D0\u10E5\u10E2\u10D8\u10D5\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0: {n}"
    },
    activated_msg: {
        uk: "\u0410\u043A\u0442\u0438\u0432\u043E\u0432\u0430\u043D\u043E: {n}",
        en: "Activated: {n}",
        hy: "\u0531\u056F\u057F\u056B\u057E\u0561\u0581\u057E\u0561\u056E \u0567: {n}",
        ka: "\u10D0\u10E5\u10E2\u10D8\u10D5\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0: {n}"
    },
    change_failed_msg: {
        uk: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u043C\u0456\u043D\u0438\u0442\u0438: {n}",
        en: "Could not be changed: {n}",
        hy: "\u0549\u0570\u0561\u057B\u0578\u0572\u057E\u0565\u0581 \u0583\u0578\u056D\u0565\u056C\u055D {n}",
        ka: "\u10D5\u10D4\u10E0 \u10E8\u10D4\u10D8\u10EA\u10D5\u10D0\u10DA\u10D0: {n}"
    },
    empty_title: {
        uk: "\u041C\u0435\u0440\u0447\u0430\u043D\u0434\u0430\u0439\u0437\u0435\u0440\u0456\u0432 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
        en: "No merchandisers found",
        hy: "\u0544\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580\u0576\u0565\u0580 \u0579\u0565\u0576 \u0563\u057F\u0576\u057E\u0565\u056C",
        ka: "\u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D4\u10D1\u10D8 \u10D5\u10D4\u10E0 \u10DB\u10DD\u10D8\u10EB\u10D4\u10D1\u10DC\u10D0"
    },
    empty_desc: {
        uk: "\u0417\u043C\u0456\u043D\u0456\u0442\u044C \u0444\u0456\u043B\u044C\u0442\u0440\u0438 \u0430\u0431\u043E \u043F\u043E\u0448\u0443\u043A\u043E\u0432\u0438\u0439 \u0437\u0430\u043F\u0438\u0442.",
        en: "Change the filters or the search term.",
        hy: "\u0553\u0578\u056D\u0565\u0584 \u0566\u057F\u056B\u0579\u0576\u0565\u0580\u0568 \u056F\u0561\u0574 \u0578\u0580\u0578\u0576\u0574\u0561\u0576 \u057F\u0565\u0584\u057D\u057F\u0568\u0589",
        ka: "\u10E8\u10D4\u10EA\u10D5\u10D0\u10DA\u10D4\u10D7 \u10E4\u10D8\u10DA\u10E2\u10E0\u10D4\u10D1\u10D8 \u10D0\u10DC \u10EB\u10D4\u10D1\u10DC\u10D8\u10E1 \u10E2\u10D4\u10E5\u10E1\u10E2\u10D8."
    },
    absent: {
        uk: "\u0412\u0456\u0434\u0441\u0443\u0442\u043D\u0456\u0439",
        en: "Absent",
        hy: "\u0532\u0561\u0581\u0561\u056F\u0561",
        ka: "\u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1"
    },
    county: {
        uk: "\u0420\u0435\u0433\u0456\u043E\u043D",
        en: "Region",
        hy: "\u0544\u0561\u0580\u0566",
        ka: "\u10E0\u10D4\u10D2\u10D8\u10DD\u10DC\u10D8"
    },
    merch_sub: {
        uk: "\u041A\u043E\u043C\u0430\u043D\u0434\u0430 \u0432 \u043F\u043E\u043B\u0456, \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0456\u0441\u0442\u044C \u0456 \u043D\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F",
        en: "Field team, availability and workload",
        hy: "\u0534\u0561\u0577\u057F\u0561\u0575\u056B\u0576 \u0569\u056B\u0574, \u0570\u0561\u057D\u0561\u0576\u0565\u056C\u056B\u0578\u0582\u0569\u0575\u0578\u0582\u0576 \u0587 \u056E\u0561\u0576\u0580\u0561\u0562\u0565\u057C\u0576\u057E\u0561\u056E\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10E1\u10D0\u10D5\u10D4\u10DA\u10D4 \u10D2\u10E3\u10DC\u10D3\u10D8, \u10EE\u10D4\u10DA\u10DB\u10D8\u10E1\u10D0\u10EC\u10D5\u10D3\u10DD\u10DB\u10DD\u10D1\u10D0 \u10D3\u10D0 \u10D3\u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D0"
    },
    page: {
        uk: "\u041C\u0435\u0440\u0447\u0435\u043D\u0434\u0430\u0439\u0437\u0435\u0440\u0438",
        en: "Merchandisers",
        hy: "\u0544\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580\u0576\u0565\u0580",
        ka: "\u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D4\u10D1\u10D8"
    },
    search_merch_ph: {
        uk: "\u0406\u043C'\u044F \u0430\u0431\u043E \u0442\u0435\u043B\u0435\u0444\u043E\u043D",
        en: "Name or phone",
        hy: "\u0531\u0576\u0578\u0582\u0576 \u056F\u0561\u0574 \u0570\u0565\u057C\u0561\u056D\u0578\u057D",
        ka: "\u10E1\u10D0\u10EE\u10D4\u10DA\u10D8 \u10D0\u10DC \u10E2\u10D4\u10DA\u10D4\u10E4\u10DD\u10DC\u10D8"
    }
};
const $fc3f36407bc5ec6c$export$ec1daa9e9f53b5f3 = {
    save_btn: {
        uk: "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438",
        en: "Save",
        hy: "\u054A\u0561\u0570\u057A\u0561\u0576\u0565\u056C",
        ka: "\u10E8\u10D4\u10DC\u10D0\u10EE\u10D5\u10D0"
    },
    cancel_btn: {
        uk: "\u0412\u0456\u0434\u043C\u0456\u043D\u0438\u0442\u0438",
        en: "Cancel",
        hy: "\u0549\u0565\u0572\u0561\u0580\u056F\u0565\u056C",
        ka: "\u10D2\u10D0\u10E3\u10E5\u10DB\u10D4\u10D1\u10D0"
    },
    edit_btn: {
        uk: "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438",
        en: "Edit",
        hy: "\u053D\u0574\u0562\u0561\u0563\u0580\u0565\u056C",
        ka: "\u10E0\u10D4\u10D3\u10D0\u10E5\u10E2\u10D8\u10E0\u10D4\u10D1\u10D0"
    },
    view_btn: {
        uk: "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u0434",
        en: "View",
        hy: "\u0534\u056B\u057F\u0565\u056C",
        ka: "\u10DC\u10D0\u10EE\u10D5\u10D0"
    },
    activate_btn: {
        uk: "\u0410\u043A\u0442\u0438\u0432\u0443\u0432\u0430\u0442\u0438",
        en: "Activate",
        hy: "\u0531\u056F\u057F\u056B\u057E\u0561\u0581\u0576\u0565\u056C",
        ka: "\u10D2\u10D0\u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D4\u10D1\u10D0"
    },
    deactivate_btn: {
        uk: "\u0414\u0435\u0430\u043A\u0442\u0438\u0432\u0443\u0432\u0430\u0442\u0438",
        en: "Deactivate",
        hy: "\u0534\u0565\u0561\u056F\u057F\u056B\u057E\u0561\u0581\u0576\u0565\u056C",
        ka: "\u10D3\u10D4\u10D0\u10E5\u10E2\u10D8\u10D5\u10D0\u10EA\u10D8\u10D0"
    },
    confirm_deactivate: {
        uk: "\u0414\u0435\u0430\u043A\u0442\u0438\u0432\u0443\u0432\u0430\u0442\u0438 \u0446\u0435\u0439 \u0437\u0430\u043F\u0438\u0441?",
        en: "Deactivate this record?",
        hy: "\u0534\u0565\u0561\u056F\u057F\u056B\u057E\u0561\u0581\u0576\u0565\u056C \u0561\u0575\u057D \u0563\u0580\u0561\u057C\u0578\u0582\u0574\u0568?",
        ka: "\u10D3\u10D4\u10D0\u10E5\u10E2\u10D8\u10D5\u10D8\u10E0\u10D4\u10D1\u10D0 \u10D0\u10DB \u10E9\u10D0\u10DC\u10D0\u10EC\u10D4\u10E0\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1?"
    },
    activated_msg: {
        uk: "\u0410\u043A\u0442\u0438\u0432\u043E\u0432\u0430\u043D\u043E",
        en: "Activated",
        hy: "\u0531\u056F\u057F\u056B\u057E\u0561\u0581\u057E\u0561\u056E \u0567",
        ka: "\u10D0\u10E5\u10E2\u10D8\u10D5\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0"
    },
    deactivated_msg: {
        uk: "\u0414\u0435\u0430\u043A\u0442\u0438\u0432\u043E\u0432\u0430\u043D\u043E",
        en: "Deactivated",
        hy: "\u0531\u057A\u0561\u0561\u056F\u057F\u056B\u057E\u0561\u0581\u057E\u0561\u056E \u0567",
        ka: "\u10D3\u10D4\u10D0\u10E5\u10E2\u10D8\u10D5\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0"
    },
    st_inactive: {
        uk: "\u041D\u0435\u0430\u043A\u0442\u0438\u0432\u043D\u0430",
        en: "Inactive",
        hy: "\u0548\u0579 \u0561\u056F\u057F\u056B\u057E",
        ka: "\u10D0\u10E0\u10D0\u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D8"
    },
    unsaved: {
        uk: "\u041D\u0435\u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u0456 \u0437\u043C\u0456\u043D\u0438",
        en: "Unsaved changes",
        hy: "\u0549\u057A\u0561\u0570\u057A\u0561\u0576\u057E\u0561\u056E \u0583\u0578\u0583\u0578\u056D\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580",
        ka: "\u10E8\u10D4\u10DC\u10D0\u10EE\u10E3\u10DA\u10D8 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1"
    },
    all_saved: {
        uk: "\u0423\u0441\u0456 \u0437\u043C\u0456\u043D\u0438 \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043E",
        en: "All changes saved",
        hy: "\u0532\u0578\u056C\u0578\u0580 \u0583\u0578\u0583\u0578\u056D\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580\u0568 \u057A\u0561\u0570\u057A\u0561\u0576\u057E\u0561\u056E \u0565\u0576",
        ka: "\u10E7\u10D5\u10D4\u10DA\u10D0 \u10EA\u10D5\u10DA\u10D8\u10DA\u10D4\u10D1\u10D0 \u10E8\u10D4\u10DC\u10D0\u10EE\u10E3\u10DA\u10D8\u10D0"
    },
    sec_basic: {
        uk: "\u041E\u0441\u043D\u043E\u0432\u043D\u0435",
        en: "Basic info",
        hy: "\u0540\u056B\u0574\u0576\u0561\u056F\u0561\u0576 \u057F\u057E\u0575\u0561\u056C\u0576\u0565\u0580",
        ka: "\u10EB\u10D8\u10E0\u10D8\u10D7\u10D0\u10D3\u10D8 \u10D8\u10DC\u10E4\u10DD\u10E0\u10DB\u10D0\u10EA\u10D8\u10D0"
    },
    f_name: {
        uk: "\u041D\u0430\u0437\u0432\u0430",
        en: "Name",
        hy: "\u0531\u0576\u057E\u0561\u0576\u0578\u0582\u0574",
        ka: "\u10E1\u10D0\u10EE\u10D4\u10DA\u10D8"
    },
    first_name: {
        uk: "\u0406\u043C'\u044F",
        en: "First name",
        hy: "\u0531\u0576\u0578\u0582\u0576",
        ka: "\u10E1\u10D0\u10EE\u10D4\u10DA\u10D8"
    },
    last_name: {
        uk: "\u041F\u0440\u0456\u0437\u0432\u0438\u0449\u0435",
        en: "Last name",
        hy: "\u0531\u0566\u0563\u0561\u0576\u0578\u0582\u0576",
        ka: "\u10D2\u10D5\u10D0\u10E0\u10D8"
    },
    f_phone: {
        uk: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D",
        en: "Phone",
        hy: "\u0540\u0565\u057C\u0561\u056D\u0578\u057D",
        ka: "\u10E2\u10D4\u10DA\u10D4\u10E4\u10DD\u10DC\u10D8"
    },
    f_movement: {
        uk: "\u041F\u0435\u0440\u0435\u0441\u0443\u0432\u0430\u043D\u043D\u044F",
        en: "Movement",
        hy: "\u054F\u0565\u0572\u0561\u0577\u0561\u0580\u056A",
        ka: "\u10D2\u10D0\u10D3\u10D0\u10D0\u10D3\u10D2\u10D8\u10DA\u10D4\u10D1\u10D0"
    },
    supervisor: {
        uk: "\u0421\u0443\u043F\u0435\u0440\u0432\u0430\u0439\u0437\u0435\u0440",
        en: "Supervisor",
        hy: "\u054E\u0565\u0580\u0561\u056F\u0561\u0581\u0578\u0582",
        ka: "\u10E1\u10E3\u10DE\u10D4\u10E0\u10D5\u10D0\u10D8\u10D6\u10D4\u10E0\u10D8"
    },
    f_county: {
        uk: "\u0420\u0435\u0433\u0456\u043E\u043D",
        en: "County",
        hy: "\u0544\u0561\u0580\u0566",
        ka: "\u10E0\u10D4\u10D2\u10D8\u10DD\u10DC\u10D8"
    },
    password: {
        uk: "\u041F\u0430\u0440\u043E\u043B\u044C",
        en: "Password",
        hy: "\u0533\u0561\u0572\u057F\u0576\u0561\u0562\u0561\u057C",
        ka: "\u10DE\u10D0\u10E0\u10DD\u10DA\u10D8"
    },
    password_ph: {
        uk: "\u0417\u0430\u043B\u0438\u0448\u0442\u0435 \u043F\u043E\u0440\u043E\u0436\u043D\u0456\u043C, \u0449\u043E\u0431 \u043D\u0435 \u0437\u043C\u0456\u043D\u044E\u0432\u0430\u0442\u0438",
        en: "Leave blank to keep the current one",
        hy: "\u0539\u0578\u0572\u0565\u0584 \u0564\u0561\u057F\u0561\u0580\u056F\u055D \u0568\u0576\u0569\u0561\u0581\u056B\u056F\u0568 \u057A\u0561\u0570\u0565\u056C\u0578\u0582 \u0570\u0561\u0574\u0561\u0580",
        ka: "\u10D3\u10D0\u10E2\u10DD\u10D5\u10D4\u10D7 \u10EA\u10D0\u10E0\u10D8\u10D4\u10DA\u10D8 \u10DB\u10D8\u10DB\u10D3\u10D8\u10DC\u10D0\u10E0\u10D8\u10E1 \u10E8\u10D4\u10E1\u10D0\u10DC\u10D0\u10E0\u10E9\u10E3\u10DC\u10D4\u10D1\u10DA\u10D0\u10D3"
    },
    password_hint: {
        uk: "\u041D\u0430\u0434\u0441\u0438\u043B\u0430\u0454\u0442\u044C\u0441\u044F \u043B\u0438\u0448\u0435 \u044F\u043A\u0449\u043E \u0437\u0430\u043F\u043E\u0432\u043D\u0435\u043D\u043E.",
        en: "Only sent when filled in.",
        hy: "\u0548\u0582\u0572\u0561\u0580\u056F\u057E\u0578\u0582\u0574 \u0567 \u0574\u056B\u0561\u0575\u0576 \u056C\u0580\u0561\u0581\u0576\u0565\u056C\u0578\u0582 \u0564\u0565\u057A\u0584\u0578\u0582\u0574\u0589",
        ka: "\u10D8\u10D2\u10D6\u10D0\u10D5\u10DC\u10D4\u10D1\u10D0 \u10DB\u10EE\u10DD\u10DA\u10DD\u10D3 \u10E8\u10D4\u10D5\u10E1\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D7\u10EE\u10D5\u10D4\u10D5\u10D0\u10E8\u10D8."
    },
    sec_employment: {
        uk: "\u041F\u0440\u0430\u0446\u0435\u0432\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F",
        en: "Employment",
        hy: "\u0531\u0577\u056D\u0561\u057F\u0561\u0576\u0584",
        ka: "\u10D3\u10D0\u10E1\u10D0\u10E5\u10DB\u10D4\u10D1\u10D0"
    },
    visits_total: {
        uk: "\u0412\u0456\u0437\u0438\u0442\u0438 \xb7 \u0432\u0441\u044C\u043E\u0433\u043E",
        en: "Visits \xb7 total",
        hy: "\u0531\u0575\u0581\u0565\u0580 \xb7 \u0568\u0576\u0564\u0570\u0561\u0576\u0578\u0582\u0580",
        ka: "\u10D5\u10D8\u10D6\u10D8\u10E2\u10D4\u10D1\u10D8 \xb7 \u10E1\u10E3\u10DA"
    },
    weekly_stops: {
        uk: "\u0422\u043E\u0447\u043E\u043A \u043D\u0430 \u0442\u0438\u0436\u0434\u0435\u043D\u044C",
        en: "Weekly stops",
        hy: "\u0547\u0561\u0562\u0561\u0569\u0561\u056F\u0561\u0576 \u056F\u0565\u057F\u0565\u0580",
        ka: "\u10D9\u10D5\u10D8\u10E0\u10D8\u10E1 \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8"
    },
    date_till_newbie: {
        uk: "\u0414\u0430\u0442\u0430 \u0434\u043E \u043D\u043E\u0432\u0430\u0447\u043A\u0430",
        en: "Date till newbie",
        hy: "\u0531\u0574\u057D\u0561\u0569\u056B\u057E \u0574\u056B\u0576\u0579\u0587 \u0576\u0578\u0580\u0565\u056F\u056B \u056F\u0561\u0580\u0563\u0561\u057E\u056B\u0573\u0561\u056F\u056B \u0561\u057E\u0561\u0580\u057F\u0568",
        ka: "\u10D7\u10D0\u10E0\u10D8\u10E6\u10D8 \u10D3\u10D0\u10DB\u10EC\u10E7\u10D4\u10D1\u10D8\u10E1 \u10E1\u10E2\u10D0\u10E2\u10E3\u10E1\u10D8\u10E1 \u10D3\u10D0\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10D0\u10DB\u10D3\u10D4"
    },
    f_is_active: {
        uk: "\u0410\u043A\u0442\u0438\u0432\u043D\u0430",
        en: "Active",
        hy: "\u0531\u056F\u057F\u056B\u057E",
        ka: "\u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D8"
    },
    date_deactivated: {
        uk: "\u0414\u0435\u0430\u043A\u0442\u0438\u0432\u043E\u0432\u0430\u043D\u043E",
        en: "Deactivated on",
        hy: "\u0531\u057A\u0561\u0561\u056F\u057F\u056B\u057E\u0561\u0581\u057E\u0565\u056C \u0567",
        ka: "\u10D3\u10D4\u10D0\u10E5\u10E2\u10D8\u10D5\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0"
    },
    newbie_hint: {
        uk: "\u0414\u043E \u0446\u0456\u0454\u0457 \u0434\u0430\u0442\u0438 \u043C\u0435\u0440\u0447\u0430\u043D\u0434\u0430\u0439\u0437\u0435\u0440 \u0432\u0432\u0430\u0436\u0430\u0454\u0442\u044C\u0441\u044F \u043D\u043E\u0432\u0430\u0447\u043A\u043E\u043C.",
        en: "Until this date the merchandiser counts as a newbie.",
        hy: "\u0544\u056B\u0576\u0579\u0587 \u0561\u0575\u057D \u0561\u0574\u057D\u0561\u0569\u056B\u057E\u0568 \u0574\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580\u0568 \u0570\u0561\u0574\u0561\u0580\u057E\u0578\u0582\u0574 \u0567 \u0576\u0578\u0580\u0565\u056F\u0589",
        ka: "\u10D0\u10DB \u10D7\u10D0\u10E0\u10D8\u10E6\u10D0\u10DB\u10D3\u10D4 \u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D8 \u10D8\u10D7\u10D5\u10DA\u10D4\u10D1\u10D0 \u10D0\u10EE\u10D0\u10DA\u10D1\u10D4\u10D3\u10D0\u10D3."
    },
    yes_lc: {
        uk: "\u0422\u0430\u043A",
        en: "Yes",
        hy: "\u0531\u0575\u0578",
        ka: "\u10D3\u10D8\u10D0\u10EE"
    },
    no_lc: {
        uk: "\u041D\u0456",
        en: "No",
        hy: "\u0548\u0579",
        ka: "\u10D0\u10E0\u10D0"
    },
    next_absence: {
        uk: "\u041D\u0430\u0441\u0442\u0443\u043F\u043D\u0430 \u0432\u0456\u0434\u0441\u0443\u0442\u043D\u0456\u0441\u0442\u044C",
        en: "Next absence",
        hy: "\u0540\u0561\u057B\u0578\u0580\u0564 \u0562\u0561\u0581\u0561\u056F\u0561\u0575\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0568",
        ka: "\u10E8\u10D4\u10DB\u10D3\u10D4\u10D2\u10D8 \u10D0\u10E0\u10E7\u10DD\u10E4\u10DC\u10D0"
    },
    summary: {
        uk: "\u0417\u0432\u0435\u0434\u0435\u043D\u043D\u044F",
        en: "Summary",
        hy: "\u0531\u0574\u0583\u0578\u0583\u0578\u0582\u0574",
        ka: "\u10E8\u10D4\u10EF\u10D0\u10DB\u10D4\u10D1\u10D0"
    },
    status: {
        uk: "\u0421\u0442\u0430\u0442\u0443\u0441",
        en: "Status",
        hy: "\u053F\u0561\u0580\u0563\u0561\u057E\u056B\u0573\u0561\u056F",
        ka: "\u10E1\u10E2\u10D0\u10E2\u10E3\u10E1\u10D8"
    },
    routes: {
        uk: "\u041C\u0430\u0440\u0448\u0440\u0443\u0442\u0438",
        en: "Routes",
        hy: "\u0535\u0580\u0569\u0578\u0582\u0572\u056B\u0576\u0565\u0580",
        ka: "\u10DB\u10D0\u10E0\u10E8\u10E0\u10E3\u10E2\u10D4\u10D1\u10D8"
    },
    assignment: {
        uk: "\u0417\u0430\u0432\u0434\u0430\u043D\u043D\u044F",
        en: "Assignment",
        hy: "\u0531\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584",
        ka: "\u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D0"
    },
    visits: {
        uk: "\u0412i\u0437\u0438\u0442\u0438",
        en: "Visits",
        hy: "\u0531\u0545\u0551\u0535\u0550",
        ka: "\u10D5\u10D8\u10D6\u10D8\u10E2\u10D4\u10D1\u10D8"
    },
    presence: {
        uk: "\u0412\u0456\u0434\u0441\u0443\u0442\u043D\u0456\u0441\u0442\u044C",
        en: "Absence",
        hy: "\u0546\u0535\u0550\u053F\u0531\u0545\u0548\u0552\u0539\u0545\u0548\u0552\u0546",
        ka: "\u10D3\u10D0\u10E1\u10EC\u10E0\u10D4\u10D1\u10D0"
    },
    routes_model_hint: {
        uk: "\u0422\u043E\u0447\u043A\u0438 \u2014 \u0446\u0435 \u0442\u0440\u0438 \u0434\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0456 \u0448\u0430\u0440\u0438: \u0442\u0438\u0436\u043D\u0435\u0432\u0430 \u043E\u0441\u043D\u043E\u0432\u0430, \u0434\u043E\u0434\u0430\u0442\u043A\u0438 \u043D\u0430 N-\u0439 \u0434\u0435\u043D\u044C \u0442\u0438\u0436\u043D\u044F \u043C\u0456\u0441\u044F\u0446\u044F \u0442\u0430 \u043E\u0434\u043D\u043E\u0440\u0430\u0437\u043E\u0432\u0456 \u0434\u043E\u0434\u0430\u0432\u0430\u043D\u043D\u044F \u043D\u0430 \u043A\u043E\u043D\u043A\u0440\u0435\u0442\u043D\u0443 \u0434\u0430\u0442\u0443.",
        en: "Stops are three additive layers: a weekly base, extras on the Nth weekday of a month, and one-off additions on a single date.",
        hy: "\u053F\u0565\u057F\u0565\u0580\u0568 \u0565\u0580\u0565\u0584 \u0563\u0578\u0582\u0574\u0561\u0580\u057E\u0578\u0572 \u0577\u0565\u0580\u057F \u0565\u0576\u055D \u0577\u0561\u0562\u0561\u0569\u0561\u056F\u0561\u0576 \u0570\u056B\u0574\u0584, \u0561\u0574\u057D\u057E\u0561 N-\u0580\u0564 \u0577\u0561\u0562\u0561\u0569\u0585\u0580\u0575\u0561 \u0570\u0561\u057E\u0565\u056C\u0578\u0582\u0574\u0576\u0565\u0580 \u0587 \u0574\u056B\u0561\u0576\u0563\u0561\u0574\u0575\u0561 \u0561\u057E\u0565\u056C\u0561\u0581\u0578\u0582\u0574\u0576\u0565\u0580 \u0578\u0580\u0578\u0577\u0561\u056F\u056B \u0585\u0580\u057E\u0561 \u0570\u0561\u0574\u0561\u0580\u0589",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8 \u10E1\u10D0\u10DB\u10D8 \u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D8\u10D7\u10D8 \u10E8\u10E0\u10D4\u10D0: \u10D9\u10D5\u10D8\u10E0\u10D8\u10E1 \u10D1\u10D0\u10D6\u10D0, \u10D7\u10D5\u10D8\u10E1 N-\u10D4 \u10D3\u10E6\u10D8\u10E1 \u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D4\u10D1\u10D8 \u10D3\u10D0 \u10D4\u10E0\u10D7\u10EF\u10D4\u10E0\u10D0\u10D3\u10D8 \u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D4\u10D1\u10D8 \u10D9\u10DD\u10DC\u10D9\u10E0\u10D4\u10E2\u10E3\u10DA \u10D7\u10D0\u10E0\u10D8\u10E6\u10D6\u10D4."
    },
    wd_mon: {
        uk: "\u041F\u043D",
        en: "Mon",
        hy: "\u0535\u0580\u056F",
        ka: "\u10DD\u10E0\u10E8"
    },
    wd_tue: {
        uk: "\u0412\u0442",
        en: "Tue",
        hy: "\u0535\u0580\u0584",
        ka: "\u10E1\u10D0\u10DB"
    },
    wd_wed: {
        uk: "\u0421\u0440",
        en: "Wed",
        hy: "\u0549\u0580\u0584",
        ka: "\u10DD\u10D7\u10EE"
    },
    wd_thu: {
        uk: "\u0427\u0442",
        en: "Thu",
        hy: "\u0540\u0576\u0563",
        ka: "\u10EE\u10E3\u10D7"
    },
    wd_fri: {
        uk: "\u041F\u0442",
        en: "Fri",
        hy: "\u0548\u0582\u0580\u0562",
        ka: "\u10DE\u10D0\u10E0"
    },
    wd_sat: {
        uk: "\u0421\u0431",
        en: "Sat",
        hy: "\u0547\u0562\u0569",
        ka: "\u10E8\u10D0\u10D1"
    },
    wd_sun: {
        uk: "\u041D\u0434",
        en: "Sun",
        hy: "\u053F\u056B\u0580",
        ka: "\u10D9\u10D5"
    },
    day_off: {
        uk: "\u0412\u0438\u0445\u0456\u0434\u043D\u0438\u0439",
        en: "Day off",
        hy: "\u0540\u0561\u0576\u0563\u057D\u057F\u0575\u0561\u0576 \u0585\u0580",
        ka: "\u10D3\u10D0\u10E1\u10D5\u10D4\u10DC\u10D4\u10D1\u10D8\u10E1 \u10D3\u10E6\u10D4"
    },
    nth_add: {
        uk: "\u0422\u0438\u0436\u0434\u0435\u043D\u044C {n}",
        en: "Week {n}",
        hy: "\u0547\u0561\u0562\u0561\u0569 {n}",
        ka: "\u10D9\u10D5\u10D8\u10E0\u10D0 {n}"
    },
    one_offs: {
        uk: "\u041E\u0434\u043D\u043E\u0440\u0430\u0437\u043E\u0432\u0456 \u0434\u043E\u0434\u0430\u0432\u0430\u043D\u043D\u044F",
        en: "One-off additions",
        hy: "\u0544\u056B\u0561\u0576\u0563\u0561\u0574\u0575\u0561 \u0561\u057E\u0565\u056C\u0561\u0581\u0578\u0582\u0574\u0576\u0565\u0580",
        ka: "\u10D4\u10E0\u10D7\u10EF\u10D4\u10E0\u10D0\u10D3\u10D8 \u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D4\u10D1\u10D8"
    },
    no_one_offs: {
        uk: "\u041E\u0434\u043D\u043E\u0440\u0430\u0437\u043E\u0432\u0438\u0445 \u0434\u043E\u0434\u0430\u0432\u0430\u043D\u044C \u043D\u0435\u043C\u0430\u0454",
        en: "No one-off additions",
        hy: "\u0544\u056B\u0561\u0576\u0563\u0561\u0574\u0575\u0561 \u0561\u057E\u0565\u056C\u0561\u0581\u0578\u0582\u0574\u0576\u0565\u0580 \u0579\u056F\u0561\u0576",
        ka: "\u10D4\u10E0\u10D7\u10EF\u10D4\u10E0\u10D0\u10D3\u10D8 \u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D4\u10D1\u10D8 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1"
    },
    open_route_editor: {
        uk: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u0440\u0435\u0434\u0430\u043A\u0442\u043E\u0440 \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u0456\u0432",
        en: "Open route editor",
        hy: "\u0532\u0561\u0581\u0565\u056C \u0565\u0580\u0569\u0578\u0582\u0572\u0578\u0582 \u056D\u0574\u0562\u0561\u0563\u0580\u056B\u0579\u0568",
        ka: "\u10DB\u10D0\u10E0\u10E8\u10E0\u10E3\u10E2\u10D8\u10E1 \u10E0\u10D4\u10D3\u10D0\u10E5\u10E2\u10DD\u10E0\u10D8\u10E1 \u10D2\u10D0\u10EE\u10E1\u10DC\u10D0"
    },
    route_editor_toast: {
        uk: "\u0422\u0443\u0442 \u0432\u0456\u0434\u043A\u0440\u0438\u0432\u0430\u0454\u0442\u044C\u0441\u044F \u043A\u0430\u043B\u0435\u043D\u0434\u0430\u0440 \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u0456\u0432",
        en: "The route calendar opens here",
        hy: "\u0531\u0575\u057D\u057F\u0565\u0572 \u0562\u0561\u0581\u057E\u0578\u0582\u0574 \u0567 \u0565\u0580\u0569\u0578\u0582\u0572\u056B\u0576\u0565\u0580\u056B \u0585\u0580\u0561\u0581\u0578\u0582\u0575\u0581\u0568",
        ka: "\u10D0\u10E5 \u10D8\u10EE\u10E1\u10DC\u10D4\u10D1\u10D0 \u10DB\u10D0\u10E0\u10E8\u10E0\u10E3\u10E2\u10D4\u10D1\u10D8\u10E1 \u10D9\u10D0\u10DA\u10D4\u10DC\u10D3\u10D0\u10E0\u10D8"
    },
    duration: {
        uk: "\u0422\u0440\u0438\u0432\u0430\u043B\u0456\u0441\u0442\u044C",
        en: "Duration",
        hy: "\u054F\u0587\u0578\u0572\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10EE\u10D0\u10DC\u10D2\u10E0\u10EB\u10DA\u10D8\u10D5\u10DD\u10D1\u10D0"
    },
    min_short: {
        uk: "\u0445\u0432",
        en: "min",
        hy: "\u0580",
        ka: "\u10EC\u10D7"
    },
    period: {
        uk: "\u041F\u0435\u0440\u0456\u043E\u0434",
        en: "Period",
        hy: "\u053A\u0561\u0574\u0561\u0576\u0561\u056F\u0561\u0570\u0561\u057F\u057E\u0561\u056E",
        ka: "\u10DE\u10D4\u10E0\u10D8\u10DD\u10D3\u10D8"
    },
    reason: {
        uk: "\u041F\u0440\u0438\u0447\u0438\u043D\u0430",
        en: "Reason",
        hy: "\u054A\u0561\u057F\u0573\u0561\u057C",
        ka: "\u10DB\u10D8\u10D6\u10D4\u10D6\u10D8"
    },
    remove: {
        uk: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438",
        en: "Remove",
        hy: "\u0540\u0565\u057C\u0561\u0581\u0576\u0565\u056C",
        ka: "\u10EC\u10D0\u10E8\u10DA\u10D0"
    },
    no_absences: {
        uk: "\u0412\u0456\u0434\u0441\u0443\u0442\u043D\u043E\u0441\u0442\u0435\u0439 \u043D\u0435 \u0437\u0430\u0444\u0456\u043A\u0441\u043E\u0432\u0430\u043D\u043E",
        en: "No absences recorded",
        hy: "\u0532\u0561\u0581\u0561\u056F\u0561\u0575\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580 \u0563\u0580\u0561\u0576\u0581\u057E\u0561\u056E \u0579\u0565\u0576",
        ka: "\u10D0\u10E0\u10E7\u10DD\u10E4\u10DC\u10D0 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1 \u10D3\u10D0\u10E4\u10D8\u10E5\u10E1\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8"
    },
    abs_past: {
        uk: "\u041C\u0438\u043D\u0443\u043B\u0430",
        en: "Past",
        hy: "\u0531\u0576\u0581\u0575\u0561\u056C",
        ka: "\u10EC\u10D0\u10E0\u10E1\u10E3\u10DA\u10D8"
    },
    abs_now: {
        uk: "\u041F\u043E\u0442\u043E\u0447\u043D\u0430",
        en: "Current",
        hy: "\u0538\u0576\u0569\u0561\u0581\u056B\u056F",
        ka: "\u10DB\u10D8\u10DB\u10D3\u10D8\u10DC\u10D0\u10E0\u10D4"
    },
    abs_next: {
        uk: "\u041C\u0430\u0439\u0431\u0443\u0442\u043D\u044F",
        en: "Upcoming",
        hy: "\u0531\u057C\u0561\u057B\u056B\u056F\u0561",
        ka: "\u10DB\u10DD\u10DB\u10D0\u10D5\u10D0\u10DA\u10D8"
    },
    date_from: {
        uk: "\u0414\u0430\u0442\u0430 \u0437",
        en: "Date from",
        hy: "\u0531\u0574\u057D\u0561\u0569\u056B\u057E\u0568 \u057D\u056F\u057D\u0561\u056E",
        ka: "\u10D7\u10D0\u10E0\u10D8\u10E6\u10D8 \u10D3\u10D0\u10DC"
    },
    date_to: {
        uk: "\u0414\u0430\u0442\u0430 \u0434\u043E",
        en: "Date to",
        hy: "\u0531\u0574\u057D\u0561\u0569\u056B\u057E \u0574\u056B\u0576\u0579\u0587",
        ka: "\u10D7\u10D0\u10E0\u10D8\u10E6\u10D8 \u10DB\u10D3\u10D4"
    },
    absence_reason: {
        uk: "\u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u0432\u0432\u0435\u0434\u0456\u0442\u044C \u043F\u0440\u0438\u0447\u0438\u043D\u0443 \u0432\u0456\u0434\u0441\u0443\u0442\u043D\u043E\u0441\u0442\u0456",
        en: "Please enter the reason of absence",
        hy: "\u053D\u0576\u0564\u0580\u0578\u0582\u0574 \u0565\u0576\u0584 \u0576\u0577\u0565\u056C \u0562\u0561\u0581\u0561\u056F\u0561\u0575\u0578\u0582\u0569\u0575\u0561\u0576 \u057A\u0561\u057F\u0573\u0561\u057C\u0568",
        ka: "\u10D2\u10D7\u10EE\u10DD\u10D5\u10D7 \u10DB\u10D8\u10E3\u10D7\u10D8\u10D7\u10DD\u10D7 \u10D0\u10E0\u10E7\u10DD\u10E4\u10DC\u10D8\u10E1 \u10DB\u10D8\u10D6\u10D4\u10D6\u10D8"
    },
    absence_saved: {
        uk: "\u0412\u0456\u0434\u0441\u0443\u0442\u043D\u0456\u0441\u0442\u044C \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043E",
        en: "Absence saved",
        hy: "\u0532\u0561\u0581\u0561\u056F\u0561\u0575\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0568 \u057A\u0561\u0570\u057A\u0561\u0576\u057E\u0561\u056E \u0567",
        ka: "\u10D0\u10E0\u10E7\u10DD\u10E4\u10DC\u10D0 \u10E8\u10D4\u10DC\u10D0\u10EE\u10E3\u10DA\u10D8\u10D0"
    },
    absence_removed: {
        uk: "\u0412\u0456\u0434\u0441\u0443\u0442\u043D\u0456\u0441\u0442\u044C \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043E",
        en: "Absence removed",
        hy: "\u0532\u0561\u0581\u0561\u056F\u0561\u0575\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0568 \u0570\u0565\u057C\u0561\u0581\u057E\u0561\u056E \u0567",
        ka: "\u10D0\u10E0\u10E7\u10DD\u10E4\u10DC\u10D0 \u10EC\u10D0\u10E8\u10DA\u10D8\u10DA\u10D8\u10D0"
    },
    confirm_remove_absence: {
        uk: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0446\u044E \u0432\u0456\u0434\u0441\u0443\u0442\u043D\u0456\u0441\u0442\u044C?",
        en: "Remove this absence?",
        hy: "\u0540\u0565\u057C\u0561\u0581\u0576\u0565\u055E\u056C \u0561\u0575\u057D \u0562\u0561\u0581\u0561\u056F\u0561\u0575\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0568",
        ka: "\u10EC\u10D0\u10D8\u10E8\u10D0\u10DA\u10DD\u10E1 \u10D4\u10E1 \u10D0\u10E0\u10E7\u10DD\u10E4\u10DC\u10D0?"
    },
    absence_incomplete: {
        uk: "\u0412\u043A\u0430\u0436\u0456\u0442\u044C \u0434\u0430\u0442\u0438 \u0442\u0430 \u043F\u0440\u0438\u0447\u0438\u043D\u0443",
        en: "Fill in dates and a reason",
        hy: "\u053C\u0580\u0561\u0581\u0580\u0565\u0584 \u0561\u0574\u057D\u0561\u0569\u057E\u0565\u0580\u0568 \u0587 \u057A\u0561\u057F\u0573\u0561\u057C\u0568",
        ka: "\u10E8\u10D4\u10D0\u10D5\u10E1\u10D4\u10D7 \u10D7\u10D0\u10E0\u10D8\u10E6\u10D4\u10D1\u10D8 \u10D3\u10D0 \u10DB\u10D8\u10D6\u10D4\u10D6\u10D8"
    },
    v_to_after_from: {
        uk: "\u0414\u0430\u0442\u0430 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u044F \u043C\u0430\u0454 \u0431\u0443\u0442\u0438 \u043F\u0456\u0441\u043B\u044F \u043F\u043E\u0447\u0430\u0442\u043A\u0443",
        en: "End date must be after the start date",
        hy: "\u0531\u057E\u0561\u0580\u057F\u0568 \u057A\u0565\u057F\u0584 \u0567 \u0574\u0565\u056F\u0576\u0561\u0580\u056F\u056B\u0581 \u0570\u0565\u057F\u0578 \u056C\u056B\u0576\u056B",
        ka: "\u10D3\u10D0\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10D0 \u10E3\u10DC\u10D3\u10D0 \u10D8\u10E7\u10DD\u10E1 \u10D3\u10D0\u10EC\u10E7\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D3\u10D4\u10D2"
    },
    v_fix_first: {
        uk: "\u0412\u0438\u043F\u0440\u0430\u0432\u0442\u0435 \u043F\u043E\u0437\u043D\u0430\u0447\u0435\u043D\u0456 \u043F\u043E\u043C\u0438\u043B\u043A\u0438 \u043F\u0435\u0440\u0435\u0434 \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043D\u044F\u043C",
        en: "Fix the highlighted issues before saving",
        hy: "\u0548\u0582\u0572\u0572\u0565\u0584 \u0576\u0577\u057E\u0561\u056E \u057D\u056D\u0561\u056C\u0576\u0565\u0580\u0568 \u0576\u0561\u056D\u0584\u0561\u0576 \u057A\u0561\u0570\u057A\u0561\u0576\u0565\u056C\u0568",
        ka: "\u10E8\u10D4\u10DC\u10D0\u10EE\u10D5\u10D0\u10DB\u10D3\u10D4 \u10D2\u10D0\u10DB\u10DD\u10D0\u10E1\u10EC\u10DD\u10E0\u10D4\u10D7 \u10DB\u10DD\u10DC\u10D8\u10E8\u10DC\u10E3\u10DA\u10D8 \u10E8\u10D4\u10EA\u10D3\u10DD\u10DB\u10D4\u10D1\u10D8"
    },
    v_readiness: {
        uk: "\u0413\u043E\u0442\u043E\u0432\u043D\u0456\u0441\u0442\u044C",
        en: "Readiness",
        hy: "\u054A\u0561\u057F\u0580\u0561\u057D\u057F\u057E\u0561\u056E\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10DB\u10D6\u10D0\u10D3\u10E7\u10DD\u10E4\u10DC\u10D0"
    },
    v_first_required: {
        uk: "\u0406\u043C'\u044F \u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0435",
        en: "First name is required",
        hy: "\u0531\u0576\u0578\u0582\u0576\u0568 \u057A\u0561\u0580\u057F\u0561\u0564\u056B\u0580 \u0567",
        ka: "\u10E1\u10D0\u10EE\u10D4\u10DA\u10D8 \u10E1\u10D0\u10D5\u10D0\u10DA\u10D3\u10D4\u10D1\u10E3\u10DA\u10DD\u10D0"
    },
    v_last_required: {
        uk: "\u041F\u0440\u0456\u0437\u0432\u0438\u0449\u0435 \u043E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0435",
        en: "Last name is required",
        hy: "\u0531\u0566\u0563\u0561\u0576\u0578\u0582\u0576\u0568 \u057A\u0561\u0580\u057F\u0561\u0564\u056B\u0580 \u0567",
        ka: "\u10D2\u10D5\u10D0\u10E0\u10D8 \u10E1\u10D0\u10D5\u10D0\u10DA\u10D3\u10D4\u10D1\u10E3\u10DA\u10DD\u10D0"
    },
    v_phone_invalid: {
        uk: "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u043A\u043E\u0440\u0435\u043A\u0442\u043D\u0438\u0439 \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443",
        en: "Enter a valid phone number",
        hy: "\u0544\u0578\u0582\u057F\u0584\u0561\u0563\u0580\u0565\u0584 \u057E\u0561\u057E\u0565\u0580 \u0570\u0565\u057C\u0561\u056D\u0578\u057D\u0561\u0570\u0561\u0574\u0561\u0580",
        ka: "\u10E8\u10D4\u10D8\u10E7\u10D5\u10D0\u10DC\u10D4\u10D7 \u10E1\u10EC\u10DD\u10E0\u10D8 \u10E2\u10D4\u10DA\u10D4\u10E4\u10DD\u10DC\u10D8\u10E1 \u10DC\u10DD\u10DB\u10D4\u10E0\u10D8"
    },
    discard_confirm: {
        uk: "\u0412\u0456\u0434\u0445\u0438\u043B\u0438\u0442\u0438 \u043D\u0435\u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u0456 \u0437\u043C\u0456\u043D\u0438?",
        en: "Discard unsaved changes?",
        hy: "\u0549\u0565\u0572\u0561\u0580\u056F\u0565\u055E\u056C \u0579\u057A\u0561\u0570\u057A\u0561\u0576\u057E\u0561\u056E \u0583\u0578\u0583\u0578\u056D\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580\u0568\u0589",
        ka: "\u10D2\u10D0\u10D5\u10D0\u10E3\u10E5\u10DB\u10DD\u10D7 \u10E8\u10D4\u10DC\u10D0\u10EE\u10E3\u10DA\u10D8 \u10EA\u10D5\u10DA\u10D8\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8?"
    },
    data_saved: {
        uk: "\u0414\u0430\u043D\u0456 \u0443\u0441\u043F\u0456\u0448\u043D\u043E \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u0456",
        en: "Data successfully saved",
        hy: "\u054F\u057E\u0575\u0561\u056C\u0576\u0565\u0580\u0568 \u0570\u0561\u057B\u0578\u0572\u0578\u0582\u0569\u0575\u0561\u0574\u0562 \u057A\u0561\u0570\u057A\u0561\u0576\u057E\u0565\u0581\u056B\u0576",
        ka: "\u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8 \u10EC\u10D0\u10E0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D8\u10D7 \u10E8\u10D4\u10DC\u10D0\u10EE\u10E3\u10DA\u10D8\u10D0"
    },
    empty_tab: {
        uk: "\u041D\u0435\u043C\u0430\u0454 \u0434\u0430\u043D\u0438\u0445",
        en: "No data",
        hy: "\u054F\u057E\u0575\u0561\u056C\u0576\u0565\u0580 \u0579\u056F\u0561\u0576",
        ka: "\u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1"
    },
    joined: {
        uk: "\u041F\u0440\u0438\u0439\u043D\u044F\u0442\u043E",
        en: "Joined",
        hy: "\u0538\u0576\u0564\u0578\u0582\u0576\u057E\u0565\u056C \u0567",
        ka: "\u10DB\u10D8\u10E6\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0"
    },
    load_error: {
        uk: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0434\u0430\u043D\u0456",
        en: "Failed to load data",
        hy: "\u0549\u0570\u0561\u057B\u0578\u0572\u057E\u0565\u0581 \u0562\u0565\u057C\u0576\u0565\u056C \u057F\u057E\u0575\u0561\u056C\u0576\u0565\u0580\u0568",
        ka: "\u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8\u10E1 \u10E9\u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D0 \u10D5\u10D4\u10E0 \u10DB\u10DD\u10EE\u10D4\u10E0\u10EE\u10D3\u10D0"
    },
    // Fallback only: a 400 shows what the server said (see `reportFailure`).
    save_error: {
        uk: "\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043D\u044F",
        en: "Error while saving",
        hy: "\u054A\u0561\u0570\u057A\u0561\u0576\u0574\u0561\u0576 \u057D\u056D\u0561\u056C",
        ka: "\u10E8\u10D4\u10DC\u10D0\u10EE\u10D5\u10D8\u10E1 \u10E8\u10D4\u10EA\u10D3\u10DD\u10DB\u10D0"
    },
    new_merch: {
        uk: "\u041D\u043E\u0432\u0438\u0439 \u043C\u0435\u0440\u0447\u0430\u043D\u0434\u0430\u0439\u0437\u0435\u0440",
        en: "New merchandiser",
        hy: "\u0546\u0578\u0580 \u0574\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580",
        ka: "\u10D0\u10EE\u10D0\u10DA\u10D8 \u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D8"
    },
    not_found_desc: {
        uk: "\u041C\u0435\u0440\u0447\u0430\u043D\u0434\u0430\u0439\u0437\u0435\u0440\u0430 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E \u0430\u0431\u043E \u0432\u0456\u043D \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u0438\u0439.",
        en: "Merchandiser not found or deleted.",
        hy: "\u0544\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580\u0568 \u0579\u056B \u0563\u057F\u0576\u057E\u0565\u056C \u056F\u0561\u0574 \u057B\u0576\u057B\u057E\u0561\u056E \u0567\u0589",
        ka: "\u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D8 \u10D5\u10D4\u10E0 \u10DB\u10DD\u10D8\u10EB\u10D4\u10D1\u10DC\u10D0 \u10D0\u10DC \u10EC\u10D0\u10E8\u10DA\u10D8\u10DA\u10D8\u10D0."
    },
    not_found_title: {
        uk: "\u041D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
        en: "Not found",
        hy: "\u0549\u056B \u0563\u057F\u0576\u057E\u0565\u056C",
        ka: "\u10D0\u10E0 \u10DB\u10DD\u10D8\u10EB\u10D4\u10D1\u10DC\u10D0"
    },
    retry: {
        uk: "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0438",
        en: "Retry",
        hy: "\u053F\u0580\u056F\u0576\u0565\u056C",
        ka: "\u10EE\u10D4\u10DA\u10D0\u10EE\u10DA\u10D0"
    }
};
const $fc3f36407bc5ec6c$export$fbb7ce4dc3b38367 = {
    page_sub: {
        uk: "\u0425\u0442\u043E \u0449\u043E \u043F\u043E\u043A\u0440\u0438\u0432\u0430\u0454",
        en: "Who covers what",
        hy: "\u0548\u057E \u056B\u0576\u0579 \u0567 \u056E\u0561\u056E\u056F\u0578\u0582\u0574",
        ka: "\u10D5\u10D8\u10DC \u10E0\u10D0\u10E1 \u10E4\u10D0\u10E0\u10D0\u10D5\u10E1"
    },
    search_ph: {
        uk: "\u041F\u043E\u0448\u0443\u043A \u0437\u0430 \u0456\u043C\u0435\u043D\u0435\u043C",
        en: "Search by name",
        hy: "\u0548\u0580\u0578\u0576\u0565\u056C \u0568\u057D\u057F \u0561\u0576\u057E\u0561\u0576",
        ka: "\u10EB\u10D4\u10D1\u10DC\u10D0 \u10E1\u10D0\u10EE\u10D4\u10DA\u10D8\u10D7"
    },
    seg_all: {
        uk: "\u0423\u0441\u0456",
        en: "All",
        hy: "\u0532\u0578\u056C\u0578\u0580\u0568",
        ka: "\u10E7\u10D5\u10D4\u10DA\u10D0"
    },
    seg_active: {
        uk: "\u0410\u043A\u0442\u0438\u0432\u043D\u0456",
        en: "Active",
        hy: "\u0531\u056F\u057F\u056B\u057E",
        ka: "\u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D8"
    },
    seg_inactive: {
        uk: "\u041D\u0435\u0430\u043A\u0442\u0438\u0432\u043D\u0456",
        en: "Inactive",
        hy: "\u0548\u0579 \u0561\u056F\u057F\u056B\u057E",
        ka: "\u10D0\u10E0\u10D0\u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D8"
    },
    no_points: {
        uk: "\u0411\u0435\u0437 \u0442\u043E\u0447\u043E\u043A",
        en: "No points",
        hy: "\u0531\u057C\u0561\u0576\u0581 \u056F\u0565\u057F\u0565\u0580\u056B",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10E0\u10D4\u10E8\u10D4"
    },
    no_points_hint: {
        uk: "\u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0430\u0454 \u0437\u0430 \u043D\u0443\u043B\u044C \u0442\u043E\u0447\u043E\u043A",
        en: "Responsible for zero points",
        hy: "\u054A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0561\u057F\u0578\u0582 \u0579\u0567 \u0578\u0579 \u0574\u056B \u056F\u0565\u057F\u056B \u0570\u0561\u0574\u0561\u0580",
        ka: "\u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1 \u10DE\u10D0\u10E1\u10E3\u10EE\u10D8\u10E1\u10DB\u10D2\u10D4\u10D1\u10D4\u10DA\u10D8 \u10D0\u10E0\u10EA\u10D4\u10E0\u10D7 \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D6\u10D4"
    },
    no_region: {
        uk: "\u0411\u0435\u0437 \u0440\u0435\u0433\u0456\u043E\u043D\u0443",
        en: "No region",
        hy: "\u0531\u057C\u0561\u0576\u0581 \u0574\u0561\u0580\u0566\u056B",
        ka: "\u10E0\u10D4\u10D2\u10D8\u10DD\u10DC\u10D8\u10E1 \u10D2\u10D0\u10E0\u10D4\u10E8\u10D4"
    },
    empty_title: {
        uk: "\u0421\u0443\u043F\u0435\u0440\u0432\u0430\u0439\u0437\u0435\u0440\u0456\u0432 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
        en: "No supervisors",
        hy: "\u054D\u0578\u0582\u057A\u0565\u0580\u057E\u0561\u0575\u0566\u0565\u0580\u0576\u0565\u0580 \u0579\u056F\u0561\u0576",
        ka: "\u10E1\u10E3\u10DE\u10D4\u10E0\u10D5\u10D0\u10D8\u10D6\u10D4\u10E0\u10D4\u10D1\u10D8 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1"
    },
    empty_desc: {
        uk: "\u0416\u043E\u0434\u0435\u043D \u0441\u0443\u043F\u0435\u0440\u0432\u0430\u0439\u0437\u0435\u0440 \u043D\u0435 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0430\u0454 \u043F\u043E\u0442\u043E\u0447\u043D\u0438\u043C \u0444\u0456\u043B\u044C\u0442\u0440\u0430\u043C.",
        en: "No supervisors match the current filters.",
        hy: "\u0548\u0579 \u0574\u056B \u057D\u0578\u0582\u057A\u0565\u0580\u057E\u0561\u0575\u0566\u0565\u0580 \u0579\u056B \u0570\u0561\u0574\u0561\u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0578\u0582\u0574 \u0568\u0576\u0569\u0561\u0581\u056B\u056F \u0566\u057F\u056B\u0579\u0576\u0565\u0580\u056B\u0576\u0589",
        ka: "\u10D0\u10E0\u10EA\u10D4\u10E0\u10D7\u10D8 \u10E1\u10E3\u10DE\u10D4\u10E0\u10D5\u10D0\u10D8\u10D6\u10D4\u10E0\u10D8 \u10D0\u10E0 \u10D4\u10DB\u10D7\u10EE\u10D5\u10D4\u10D5\u10D0 \u10DB\u10D8\u10DB\u10D3\u10D8\u10DC\u10D0\u10E0\u10D4 \u10E4\u10D8\u10DA\u10E2\u10E0\u10D4\u10D1\u10E1."
    },
    open: {
        uk: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438",
        en: "Open",
        hy: "\u0532\u0561\u0581",
        ka: "\u10E6\u10D8\u10D0\u10D0"
    },
    activate: {
        uk: "\u0410\u043A\u0442\u0438\u0432\u0443\u0432\u0430\u0442\u0438",
        en: "Activate",
        hy: "\u0531\u056F\u057F\u056B\u057E\u0561\u0581\u0576\u0565\u056C",
        ka: "\u10D2\u10D0\u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D4\u10D1\u10D0"
    },
    deactivate: {
        uk: "\u0414\u0435\u0430\u043A\u0442\u0438\u0432\u0443\u0432\u0430\u0442\u0438",
        en: "Deactivate",
        hy: "\u0534\u0565\u0561\u056F\u057F\u056B\u057E\u0561\u0581\u0576\u0565\u056C",
        ka: "\u10D3\u10D4\u10D0\u10E5\u10E2\u10D8\u10D5\u10D0\u10EA\u10D8\u10D0"
    },
    confirm_deactivate: {
        uk: "\u0414\u0435\u0430\u043A\u0442\u0438\u0432\u0443\u0432\u0430\u0442\u0438? ({n})",
        en: "Deactivate? ({n})",
        hy: "\u0534\u0565\u0561\u056F\u057F\u056B\u057E\u0561\u0581\u0576\u0565\u055E\u056C\u0589 ({n})",
        ka: "\u10D3\u10D4\u10D0\u10E5\u10E2\u10D8\u10D5\u10D0\u10EA\u10D8\u10D0? ({n})"
    },
    activated_msg: {
        uk: "\u0410\u043A\u0442\u0438\u0432\u043E\u0432\u0430\u043D\u043E: {n}",
        en: "Activated: {n}",
        hy: "\u0531\u056F\u057F\u056B\u057E\u0561\u0581\u057E\u0561\u056E \u0567: {n}",
        ka: "\u10D0\u10E5\u10E2\u10D8\u10D5\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0: {n}"
    },
    deactivated_msg: {
        uk: "\u0414\u0435\u0430\u043A\u0442\u0438\u0432\u043E\u0432\u0430\u043D\u043E: {n}",
        en: "Deactivated: {n}",
        hy: "\u0531\u057A\u0561\u0561\u056F\u057F\u056B\u057E\u0561\u0581\u057E\u0561\u056E \u0567: {n}",
        ka: "\u10D3\u10D4\u10D0\u10E5\u10E2\u10D8\u10D5\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0: {n}"
    },
    change_failed_msg: {
        uk: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u043E\u043D\u043E\u0432\u0438\u0442\u0438: {n}",
        en: "Failed to update: {n}",
        hy: "\u0549\u0570\u0561\u057B\u0578\u0572\u057E\u0565\u0581 \u0569\u0561\u0580\u0574\u0561\u0581\u0576\u0565\u056C\u055D {n}",
        ka: "\u10D2\u10D0\u10DC\u10D0\u10EE\u10DA\u10D4\u10D1\u10D0 \u10D5\u10D4\u10E0 \u10DB\u10DD\u10EE\u10D4\u10E0\u10EE\u10D3\u10D0: {n}"
    }
};
const $fc3f36407bc5ec6c$export$d5a72fe01869f310 = {
    account: {
        uk: "\u0410\u043A\u0430\u0443\u043D\u0442",
        en: "Account",
        hy: "\u0540\u0561\u0577\u056B\u057E",
        ka: "\u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10D8"
    },
    coverage: {
        uk: "\u041F\u043E\u043A\u0440\u0438\u0442\u0442\u044F",
        en: "Coverage",
        hy: "\u053E\u0561\u056E\u056F\u0578\u0582\u0575\u0569",
        ka: "\u10D3\u10D0\u10E4\u10D0\u10E0\u10D5\u10D0"
    },
    f_telegram: {
        uk: "Telegram",
        en: "Telegram",
        hy: "Telegram",
        ka: "Telegram"
    },
    add_points: {
        uk: "\u0414\u043E\u0434\u0430\u0442\u0438 \u0442\u043E\u0447\u043A\u0438",
        en: "Add points",
        hy: "\u0531\u057E\u0565\u056C\u0561\u0581\u0576\u0565\u056C \u056F\u0565\u057F\u0565\u0580",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1 \u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D0"
    },
    add_merchandisers: {
        uk: "\u0414\u043E\u0434\u0430\u0442\u0438 \u043C\u0435\u0440\u0447\u0435\u043D\u0434\u0430\u0439\u0437\u0435\u0440\u0456\u0432",
        en: "Add merchandisers",
        hy: "\u0531\u057E\u0565\u056C\u0561\u0581\u0576\u0565\u056C \u0574\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580\u0576\u0565\u0580",
        ka: "\u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D4\u10D1\u10D8\u10E1 \u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D0"
    },
    add: {
        uk: "\u0414\u043E\u0434\u0430\u0442\u0438",
        en: "Add",
        hy: "\u0531\u057E\u0565\u056C\u0561\u0581\u0576\u0565\u056C",
        ka: "\u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D0"
    },
    remove: {
        uk: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438",
        en: "Remove",
        hy: "\u054B\u0576\u057B\u0565\u056C",
        ka: "\u10EC\u10D0\u10E8\u10DA\u10D0"
    },
    empty_tab: {
        uk: "\u041D\u0435\u043C\u0430\u0454 \u0437\u0430\u043F\u0438\u0441\u0456\u0432",
        en: "No records",
        hy: "\u0533\u0580\u0561\u057C\u0578\u0582\u0574\u0576\u0565\u0580 \u0579\u056F\u0561\u0576",
        ka: "\u10E9\u10D0\u10DC\u10D0\u10EC\u10D4\u10E0\u10D4\u10D1\u10D8 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1"
    },
    picker_ph: {
        uk: "\u041F\u043E\u0448\u0443\u043A \u0434\u043B\u044F \u0434\u043E\u0434\u0430\u0432\u0430\u043D\u043D\u044F\u2026",
        en: "Search to add\u2026",
        hy: "\u0548\u0580\u0578\u0576\u0565\u0584 \u0561\u057E\u0565\u056C\u0561\u0581\u0576\u0565\u056C\u0578\u0582 \u0570\u0561\u0574\u0561\u0580\u2026",
        ka: "\u10DB\u10DD\u10EB\u10D4\u10D1\u10DC\u10D4\u10D7 \u10D3\u10D0\u10E1\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10DA\u10D0\u10D3\u2026"
    },
    load_error: {
        uk: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0434\u0430\u043D\u0456",
        en: "Failed to load data",
        hy: "\u0549\u0570\u0561\u057B\u0578\u0572\u057E\u0565\u0581 \u0562\u0565\u057C\u0576\u0565\u056C \u057F\u057E\u0575\u0561\u056C\u0576\u0565\u0580\u0568",
        ka: "\u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8\u10E1 \u10E9\u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D0 \u10D5\u10D4\u10E0 \u10DB\u10DD\u10EE\u10D4\u10E0\u10EE\u10D3\u10D0"
    },
    retry: {
        uk: "\u0421\u043F\u0440\u043E\u0431\u0443\u0432\u0430\u0442\u0438 \u0437\u043D\u043E\u0432\u0443",
        en: "Retry",
        hy: "\u053F\u0580\u056F\u0576\u0565\u056C",
        ka: "\u10EE\u10D4\u10DA\u10D0\u10EE\u10DA\u10D0"
    },
    not_found_title: {
        uk: "\u041D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
        en: "Not found",
        hy: "\u0549\u056B \u0563\u057F\u0576\u057E\u0565\u056C",
        ka: "\u10D0\u10E0 \u10DB\u10DD\u10D8\u10EB\u10D4\u10D1\u10DC\u10D0"
    },
    not_found_desc: {
        uk: "\u0421\u0443\u043F\u0435\u0440\u0432\u0430\u0439\u0437\u0435\u0440 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u0438\u0439 \u0430\u0431\u043E \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u0438\u0439.",
        en: "Supervisor not found or deleted.",
        hy: "\u054D\u0578\u0582\u057A\u0565\u0580\u057E\u0561\u0575\u0566\u0565\u0580\u0568 \u0579\u056B \u0563\u057F\u0576\u057E\u0565\u056C \u056F\u0561\u0574 \u057B\u0576\u057B\u057E\u0561\u056E \u0567\u0589",
        ka: "\u10E1\u10E3\u10DE\u10D4\u10E0\u10D5\u10D0\u10D8\u10D6\u10D4\u10E0\u10D8 \u10D5\u10D4\u10E0 \u10DB\u10DD\u10D8\u10EB\u10D4\u10D1\u10DC\u10D0 \u10D0\u10DC \u10EC\u10D0\u10E8\u10DA\u10D8\u10DA\u10D8\u10D0."
    },
    assign_error: {
        uk: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u043F\u0440\u0438\u0437\u043D\u0430\u0447\u0438\u0442\u0438",
        en: "Failed to assign",
        hy: "\u0549\u0570\u0561\u057B\u0578\u0572\u057E\u0565\u0581 \u0576\u0577\u0561\u0576\u0561\u056F\u0565\u056C",
        ka: "\u10DB\u10D8\u10DC\u10D8\u10ED\u10D4\u10D1\u10D0 \u10D5\u10D4\u10E0 \u10DB\u10DD\u10EE\u10D4\u10E0\u10EE\u10D3\u10D0"
    },
    ignored_msg: {
        uk: "\u041F\u0440\u043E\u0456\u0433\u043D\u043E\u0440\u043E\u0432\u0430\u043D\u043E: {n}",
        en: "Ignored: {n}",
        hy: "\u0531\u0576\u057F\u0565\u057D\u057E\u0565\u056C \u0567\u055D {n}",
        ka: "\u10D2\u10D0\u10DB\u10DD\u10E2\u10DD\u10D5\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0: {n}"
    },
    no_coordinates: {
        uk: "\u0411\u0435\u0437 \u043A\u043E\u043E\u0440\u0434\u0438\u043D\u0430\u0442",
        en: "No coordinates",
        hy: "\u0531\u057C\u0561\u0576\u0581 \u056F\u0578\u0578\u0580\u0564\u056B\u0576\u0561\u057F\u0576\u0565\u0580\u056B",
        ka: "\u10D9\u10DD\u10DD\u10E0\u10D3\u10D8\u10DC\u10D0\u10E2\u10D4\u10D1\u10D8 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1"
    },
    no_points_hint: {
        uk: "\u0411\u0435\u0437 \u0442\u043E\u0447\u043E\u043A",
        en: "No points",
        hy: "\u0531\u057C\u0561\u0576\u0581 \u056F\u0565\u057F\u0565\u0580\u056B",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10E0\u10D4\u10E8\u10D4"
    },
    no_region: {
        uk: "\u0411\u0435\u0437 \u0440\u0435\u0433\u0456\u043E\u043D\u0443",
        en: "No region",
        hy: "\u0531\u057C\u0561\u0576\u0581 \u0574\u0561\u0580\u0566\u056B",
        ka: "\u10E0\u10D4\u10D2\u10D8\u10DD\u10DC\u10D8\u10E1 \u10D2\u10D0\u10E0\u10D4\u10E8\u10D4"
    },
    removed_msg: {
        uk: "\u0412\u0438\u0434\u0430\u043B\u0435\u043D\u043E: {n}",
        en: "Removed: {n}",
        hy: "\u0540\u0565\u057C\u0561\u0581\u057E\u0565\u056C \u0567\u055D {n}",
        ka: "\u10D0\u10DB\u10DD\u10E6\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0: {n}"
    },
    added_msg: {
        uk: "\u0414\u043E\u0434\u0430\u043D\u043E: {n}",
        en: "Added: {n}",
        hy: "\u0531\u057E\u0565\u056C\u0561\u0581\u057E\u0565\u056C \u0567\u055D {n}",
        ka: "\u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0: {n}"
    },
    confirm_remove_point: {
        uk: "\u0412\u0456\u0434\u043A\u0440\u0456\u043F\u0438\u0442\u0438 \xab{name}\xbb?",
        en: 'Unassign "{name}"?',
        hy: "\u0540\u0565\u057C\u0561\u0581\u0576\u0565\u055E\u056C \xab{name}\xbb-\u0568\u0589",
        ka: "\u10DB\u10DD\u10D5\u10D0\u10E8\u10DD\u10E0\u10DD\u10D7 \u201E{name}\u201C?"
    },
    confirm_remove_merchandiser: {
        uk: "\u0412\u0456\u0434\u043A\u0440\u0456\u043F\u0438\u0442\u0438 \xab{name}\xbb?",
        en: 'Unassign "{name}"?',
        hy: "\u0540\u0565\u057C\u0561\u0581\u0576\u0565\u055E\u056C \xab{name}\xbb-\u0568\u0589",
        ka: "\u10DB\u10DD\u10D5\u10D0\u10E8\u10DD\u10E0\u10DD\u10D7 \u201E{name}\u201C?"
    },
    telegram_linked: {
        uk: "\u041F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043E",
        en: "Linked",
        hy: "\u053F\u0561\u057A\u0561\u056F\u0581\u057E\u0561\u056E \u0567",
        ka: "\u10D3\u10D0\u10D9\u10D0\u10D5\u10E8\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0"
    },
    telegram_none: {
        uk: "\u041D\u0435 \u043F\u0456\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043E",
        en: "Not linked",
        hy: "\u053F\u0561\u057A\u0561\u056F\u0581\u057E\u0561\u056E \u0579\u0567",
        ka: "\u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1 \u10D3\u10D0\u10D9\u10D0\u10D5\u10E8\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8"
    }
};
const $fc3f36407bc5ec6c$export$601c8c0f45aeb0a0 = {
    page_sub: {
        uk: "\u0429\u043E \u043D\u0435 \u0437\u0440\u043E\u0431\u043B\u0435\u043D\u043E \u0456 \u0449\u043E \u043E\u0441\u044C-\u043E\u0441\u044C \u043F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0438\u0442\u044C\u0441\u044F",
        en: "What is not done, and what is about to be late",
        hy: "\u053B\u0576\u0579\u0568 \u056F\u0561\u057F\u0561\u0580\u057E\u0561\u056E \u0579\u0567 \u0587 \u056B\u0576\u0579\u0568 \u0577\u0578\u0582\u057F\u0578\u057E \u056F\u0578\u0582\u0577\u0561\u0576\u0561",
        ka: "\u10E0\u10D0 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1 \u10E8\u10D4\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10E3\u10DA\u10D8 \u10D3\u10D0 \u10E0\u10D0 \u10D3\u10D0\u10D2\u10D5\u10D8\u10D0\u10DC\u10D3\u10D4\u10D1\u10D0"
    },
    /* Status. Active/inactive is a plain column; the four-way verdict below is the API's `status`
     (newest answer's `is_supervised` — PICSELL-1615 #6/#9), also the segment's options. */ col_status: {
        uk: "\u0421\u0442\u0430\u0442\u0443\u0441",
        en: "Status",
        hy: "\u053F\u0561\u0580\u0563\u0561\u057E\u056B\u0573\u0561\u056F",
        ka: "\u10E1\u10E2\u10D0\u10E2\u10E3\u10E1\u10D8"
    },
    st_active: {
        uk: "\u0410\u043A\u0442\u0438\u0432\u043D\u0430",
        en: "Active",
        hy: "\u0531\u056F\u057F\u056B\u057E",
        ka: "\u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D8"
    },
    st_inactive: {
        uk: "\u0414\u0435\u0430\u043A\u0442\u0438\u0432\u043E\u0432\u0430\u043D\u043E",
        en: "Deactivated",
        hy: "\u0531\u057A\u0561\u0561\u056F\u057F\u056B\u057E\u0561\u0581\u057E\u0561\u056E",
        ka: "\u10D3\u10D4\u10D0\u10E5\u10E2\u10D8\u10D5\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8"
    },
    st_all: {
        uk: "\u0423\u0441\u0456",
        en: "All",
        hy: "\u0532\u0578\u056C\u0578\u0580\u0568",
        ka: "\u10E7\u10D5\u10D4\u10DA\u10D0"
    },
    st_awaiting: {
        uk: "\u0411\u0435\u0437 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0456",
        en: "Awaiting answer",
        hy: "\u054D\u057A\u0561\u057D\u0578\u0582\u0574 \u0567 \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u056B",
        ka: "\u10DE\u10D0\u10E1\u10E3\u10EE\u10D8\u10E1 \u10DB\u10DD\u10DA\u10DD\u10D3\u10D8\u10DC\u10E8\u10D8"
    },
    st_on_review: {
        uk: "\u041D\u0430 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0446\u0456",
        en: "On review",
        hy: "\u054D\u057F\u0578\u0582\u0563\u0574\u0561\u0576 \u0583\u0578\u0582\u056C\u0578\u0582\u0574",
        ka: "\u10D2\u10D0\u10D3\u10D0\u10DB\u10DD\u10EC\u10DB\u10D4\u10D1\u10D0\u10E8\u10D8"
    },
    st_approved: {
        uk: "\u0421\u0445\u0432\u0430\u043B\u0435\u043D\u043E",
        en: "Approved",
        hy: "\u0540\u0561\u057D\u057F\u0561\u057F\u057E\u0561\u056E",
        ka: "\u10D3\u10D0\u10DB\u10E2\u10D9\u10D8\u10EA\u10D4\u10D1\u10E3\u10DA\u10D8"
    },
    st_rejected: {
        uk: "\u0412\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043E",
        en: "Rejected",
        hy: "\u0544\u0565\u0580\u056A\u057E\u0561\u056E",
        ka: "\u10E3\u10D0\u10E0\u10E7\u10DD\u10E4\u10D8\u10DA\u10D8"
    },
    /* Derived chips. Each says what the state MEANS operationally, per spec/04. */ chip_overdue: {
        uk: "\u041F\u0440\u043E\u0441\u0442\u0440\u043E\u0447\u0435\u043D\u0456",
        en: "Overdue",
        hy: "\u053A\u0561\u0574\u056F\u0565\u057F\u0561\u0576\u0581",
        ka: "\u10D5\u10D0\u10D3\u10D0\u10D2\u10D0\u10D3\u10D0\u10EA\u10D8\u10DA\u10D4\u10D1\u10E3\u10DA\u10D8"
    },
    chip_overdue_hint: {
        uk: "\u0414\u0435\u0434\u043B\u0430\u0439\u043D \u043C\u0438\u043D\u0443\u0432, \u0430 \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F \u0449\u0435 \u043D\u0435 \u0432\u0438\u043A\u043E\u043D\u0430\u043D\u0435",
        en: "Past its deadline and still not done",
        hy: "\u053A\u0561\u0574\u056F\u0565\u057F\u0576 \u0561\u0576\u0581\u0565\u056C \u0567, \u0562\u0561\u0575\u0581 \u0564\u0565\u057C \u056F\u0561\u057F\u0561\u0580\u057E\u0561\u056E \u0579\u0567",
        ka: "\u10D5\u10D0\u10D3\u10D0 \u10D2\u10D0\u10E1\u10E3\u10DA\u10D8\u10D0 \u10D3\u10D0 \u10EF\u10D4\u10E0 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1 \u10E8\u10D4\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10E3\u10DA\u10D8"
    },
    chip_negative: {
        uk: "\u041D\u0435\u0433\u0430\u0442\u0438\u0432\u043D\u0456 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0456",
        en: "Negative answers",
        hy: "\u0532\u0561\u0581\u0561\u057D\u0561\u056F\u0561\u0576 \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0576\u0565\u0580",
        ka: "\u10E3\u10D0\u10E0\u10E7\u10DD\u10E4\u10D8\u10D7\u10D8 \u10DE\u10D0\u10E1\u10E3\u10EE\u10D4\u10D1\u10D8"
    },
    chip_negative_hint: {
        uk: "\u041C\u0435\u0440\u0447\u0435\u043D\u0434\u0430\u0439\u0437\u0435\u0440 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0432 \xab\u043D\u0456\xbb",
        en: "The merchandiser answered no",
        hy: "\u0544\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580\u0568 \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0565\u056C \u0567 \xab\u0578\u0579\xbb",
        ka: "\u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10DB\u10D0 \u10E3\u10DE\u10D0\u10E1\u10E3\u10EE\u10D0 \u201E\u10D0\u10E0\u10D0\u201C"
    },
    chip_inactive: {
        uk: "\u0414\u0435\u0430\u043A\u0442\u0438\u0432\u043E\u0432\u0430\u043D\u0456",
        en: "Deactivated",
        hy: "\u0531\u057A\u0561\u0561\u056F\u057F\u056B\u057E\u0561\u0581\u057E\u0561\u056E",
        ka: "\u10D3\u10D4\u10D0\u10E5\u10E2\u10D8\u10D5\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8"
    },
    chip_inactive_hint: {
        uk: "\u0417\u0430\u043A\u0440\u0438\u0442\u0435 \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F, \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0456 \u0432\u0436\u0435 \u043D\u0430\u0434\u0430\u043D\u0456",
        en: "Closed, with answers already given",
        hy: "\u0553\u0561\u056F\u057E\u0561\u056E \u0567, \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0576\u0565\u0580\u0576 \u0561\u0580\u0564\u0565\u0576 \u057F\u0580\u057E\u0561\u056E \u0565\u0576",
        ka: "\u10D3\u10D0\u10EE\u10E3\u10E0\u10E3\u10DA\u10D8\u10D0, \u10DE\u10D0\u10E1\u10E3\u10EE\u10D4\u10D1\u10D8 \u10E3\u10D9\u10D5\u10D4 \u10D2\u10D0\u10EA\u10D4\u10DB\u10E3\u10DA\u10D8\u10D0"
    },
    /* Columns */ col_task: {
        uk: "\u0417\u0430\u0432\u0434\u0430\u043D\u043D\u044F",
        en: "Task",
        hy: "\u0531\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584",
        ka: "\u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D0"
    },
    col_type: {
        uk: "\u0422\u0438\u043F",
        en: "Type",
        hy: "\u054F\u056B\u057A",
        ka: "\u10E2\u10D8\u10DE\u10D8"
    },
    col_point: {
        uk: "\u0422\u043E\u0447\u043A\u0430",
        en: "Point",
        hy: "\u053F\u0565\u057F",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8"
    },
    col_deadline: {
        uk: "\u0414\u0435\u0434\u043B\u0430\u0439\u043D",
        en: "Deadline",
        hy: "\u054E\u0565\u0580\u057B\u0576\u0561\u056A\u0561\u0574\u056F\u0565\u057F",
        ka: "\u10D1\u10DD\u10DA\u10DD \u10D5\u10D0\u10D3\u10D0"
    },
    col_author: {
        uk: "\u0410\u0432\u0442\u043E\u0440",
        en: "Created by",
        hy: "\u0540\u0565\u0572\u056B\u0576\u0561\u056F",
        ka: "\u10D0\u10D5\u10E2\u10DD\u10E0\u10D8"
    },
    /* The list's own copy of this label. `translate()` returns null (not the key) for a miss, so
     borrowing TASK_DETAIL's `k_merchandiser` from here rendered the filter with NO label at all and
     the column with a BLANK header — visible only in the browser, never in the source. */ k_merchandiser: {
        uk: "\u041C\u0435\u0440\u0447\u0435\u043D\u0434\u0430\u0439\u0437\u0435\u0440",
        en: "Merchandiser",
        hy: "\u0544\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580",
        ka: "\u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D8"
    },
    cancel_btn: {
        uk: "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438",
        en: "Cancel",
        hy: "\u0549\u0565\u0572\u0561\u0580\u056F\u0565\u056C",
        ka: "\u10D2\u10D0\u10E3\u10E5\u10DB\u10D4\u10D1\u10D0"
    },
    /* The bulk bar says what the selection covers: there is no bulk endpoint, so "select all" is
     the LOADED page and claiming otherwise would be a lie about scope. */ select_page_hint: {
        uk: "\u0412\u0438\u0431\u0456\u0440 \u0434\u0456\u0454 \u043D\u0430 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u0443 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443",
        en: "Selection covers the loaded page",
        hy: "\u0538\u0576\u057F\u0580\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0568 \u057E\u0565\u0580\u0561\u0562\u0565\u0580\u0578\u0582\u0574 \u0567 \u0562\u0565\u057C\u0576\u057E\u0561\u056E \u0567\u057B\u056B\u0576",
        ka: "\u10D0\u10E0\u10E9\u10D4\u10D5\u10D0\u10DC\u10D8 \u10DB\u10DD\u10E5\u10DB\u10D4\u10D3\u10D4\u10D1\u10E1 \u10E9\u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10E3\u10DA \u10D2\u10D5\u10D4\u10E0\u10D3\u10D6\u10D4"
    },
    search_ph: {
        uk: "\u041F\u043E\u0448\u0443\u043A \u0437\u0430 \u043D\u0430\u0437\u0432\u043E\u044E \u0430\u0431\u043E \u043E\u043F\u0438\u0441\u043E\u043C",
        en: "Search by name or description",
        hy: "\u0548\u0580\u0578\u0576\u0565\u056C \u0568\u057D\u057F \u0561\u0576\u057E\u0561\u0576 \u056F\u0561\u0574 \u0576\u056F\u0561\u0580\u0561\u0563\u0580\u0578\u0582\u0569\u0575\u0561\u0576",
        ka: "\u10EB\u10D4\u10D1\u10DC\u10D0 \u10E1\u10D0\u10EE\u10D4\u10DA\u10D8\u10D7 \u10D0\u10DC \u10D0\u10E6\u10EC\u10D4\u10E0\u10D8\u10D7"
    },
    columns: {
        uk: "\u0421\u0442\u043E\u0432\u043F\u0446\u0456",
        en: "Columns",
        hy: "\u054D\u0575\u0578\u0582\u0576\u0561\u056F\u0576\u0565\u0580",
        ka: "\u10E1\u10D5\u10D4\u10E2\u10D4\u10D1\u10D8"
    },
    rows_per_page: {
        uk: "\u0420\u044F\u0434\u043A\u0456\u0432 \u043D\u0430 \u0441\u0442\u043E\u0440\u0456\u043D\u0446\u0456",
        en: "Rows per page",
        hy: "\u054F\u0578\u0572\u0565\u0580 \u0567\u057B\u0578\u0582\u0574",
        ka: "\u10DB\u10EC\u10D9\u10E0\u10D8\u10D5\u10D8 \u10D2\u10D5\u10D4\u10E0\u10D3\u10D6\u10D4"
    },
    /* Next/prev, not `{from}–{to} of {n}`: `GET tasks/` reports no total, so `range_of` went
     with the numbered footer. The strings match VISIT_PAGE's, which the report section uses. */ page_n: {
        uk: "\u0421\u0442\u043E\u0440\u0456\u043D\u043A\u0430 {n}",
        en: "Page {n}",
        hy: "\u0537\u057B {n}",
        ka: "\u10D2\u10D5\u10D4\u10E0\u10D3\u10D8 {n}"
    },
    page_prev: {
        uk: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u044F",
        en: "Previous",
        hy: "\u0546\u0561\u056D\u0578\u0580\u0564\u0568",
        ka: "\u10EC\u10D8\u10DC\u10D0"
    },
    page_next: {
        uk: "\u041D\u0430\u0441\u0442\u0443\u043F\u043D\u0430",
        en: "Next",
        hy: "\u0540\u0561\u057B\u0578\u0580\u0564\u0568",
        ka: "\u10E8\u10D4\u10DB\u10D3\u10D4\u10D2\u10D8"
    },
    row_actions: {
        uk: "\u0414\u0456\u0457 \u0437 \u0440\u044F\u0434\u043A\u043E\u043C",
        en: "Row actions",
        hy: "\u054F\u0578\u0572\u056B \u0563\u0578\u0580\u056E\u0578\u0572\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580",
        ka: "\u10DB\u10EC\u10D9\u10E0\u10D8\u10D5\u10D8\u10E1 \u10DB\u10DD\u10E5\u10DB\u10D4\u10D3\u10D4\u10D1\u10D4\u10D1\u10D8"
    },
    open: {
        uk: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438",
        en: "Open",
        hy: "\u0532\u0561\u0581\u0565\u056C",
        ka: "\u10D2\u10D0\u10EE\u10E1\u10DC\u10D0"
    },
    /* Create. Three targets, because the API takes three: one point, a whole network, or a group.
     The last two fan out server-side into one task per point. */ new_task: {
        uk: "\u041D\u043E\u0432\u0435 \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F",
        en: "New task",
        hy: "\u0546\u0578\u0580 \u0561\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584",
        ka: "\u10D0\u10EE\u10D0\u10DA\u10D8 \u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D0"
    },
    new_for_point: {
        uk: "\u041D\u0430 \u0442\u043E\u0447\u043A\u0443",
        en: "For a point",
        hy: "\u053F\u0565\u057F\u056B \u0570\u0561\u0574\u0561\u0580",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1"
    },
    new_for_network: {
        uk: "\u041D\u0430 \u043C\u0435\u0440\u0435\u0436\u0443",
        en: "For a network",
        hy: "\u0551\u0561\u0576\u0581\u056B \u0570\u0561\u0574\u0561\u0580",
        ka: "\u10E5\u10E1\u10D4\u10DA\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1"
    },
    new_for_group: {
        uk: "\u041D\u0430 \u0433\u0440\u0443\u043F\u0443 \u0442\u043E\u0447\u043E\u043A",
        en: "For a group of points",
        hy: "\u053F\u0565\u057F\u0565\u0580\u056B \u056D\u0574\u0562\u056B \u0570\u0561\u0574\u0561\u0580",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1 \u10EF\u10D2\u10E3\u10E4\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1"
    },
    /* Deactivate. PATCH is_active=false — never DELETE, which hard-deletes a task with no answers. */ deactivate: {
        uk: "\u0414\u0435\u0430\u043A\u0442\u0438\u0432\u0443\u0432\u0430\u0442\u0438",
        en: "Deactivate",
        hy: "\u0531\u057A\u0561\u0561\u056F\u057F\u056B\u057E\u0561\u0581\u0576\u0565\u056C",
        ka: "\u10D3\u10D4\u10D0\u10E5\u10E2\u10D8\u10D5\u10D0\u10EA\u10D8\u10D0"
    },
    confirm_deactivate: {
        uk: "\u0414\u0435\u0430\u043A\u0442\u0438\u0432\u0443\u0432\u0430\u0442\u0438 \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F? ({n})",
        en: "Deactivate tasks? ({n})",
        hy: "\u0531\u057A\u0561\u0561\u056F\u057F\u056B\u057E\u0561\u0581\u0576\u0565\u055E\u056C \u0561\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0576\u0565\u0580\u0568\u0589 ({n})",
        ka: "\u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8\u10E1 \u10D3\u10D4\u10D0\u10E5\u10E2\u10D8\u10D5\u10D0\u10EA\u10D8\u10D0? ({n})"
    },
    confirm_deactivate_desc: {
        uk: "\u041C\u0435\u0440\u0447\u0435\u043D\u0434\u0430\u0439\u0437\u0435\u0440\u0438 \u0431\u0456\u043B\u044C\u0448\u0435 \u043D\u0435 \u043F\u043E\u0431\u0430\u0447\u0430\u0442\u044C \u0457\u0445 \u0443 \u0437\u0430\u0441\u0442\u043E\u0441\u0443\u043D\u043A\u0443.",
        en: "Merchandisers will no longer see them in the app.",
        hy: "\u0544\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580\u0576\u0565\u0580\u0568 \u0561\u0575\u056C\u0587\u057D \u0579\u0565\u0576 \u057F\u0565\u057D\u0576\u056B \u0564\u0580\u0561\u0576\u0584 \u0570\u0561\u057E\u0565\u056C\u057E\u0561\u056E\u0578\u0582\u0574\u0589",
        ka: "\u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D4\u10D1\u10D8 \u10DB\u10D0\u10D7 \u10D0\u10DE\u10DA\u10D8\u10D9\u10D0\u10EA\u10D8\u10D0\u10E8\u10D8 \u10D5\u10D4\u10E6\u10D0\u10E0 \u10D3\u10D0\u10D8\u10DC\u10D0\u10EE\u10D0\u10D5\u10D4\u10DC."
    },
    deactivated_msg: {
        uk: "\u0414\u0435\u0430\u043A\u0442\u0438\u0432\u043E\u0432\u0430\u043D\u043E: {n}",
        en: "Deactivated: {n}",
        hy: "\u0531\u057A\u0561\u0561\u056F\u057F\u056B\u057E\u0561\u0581\u057E\u0561\u056E \u0567\u055D {n}",
        ka: "\u10D3\u10D4\u10D0\u10E5\u10E2\u10D8\u10D5\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0: {n}"
    },
    change_failed_msg: {
        uk: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u043E\u043D\u043E\u0432\u0438\u0442\u0438: {n}",
        en: "Failed to update: {n}",
        hy: "\u0549\u0570\u0561\u057B\u0578\u0572\u057E\u0565\u0581 \u0569\u0561\u0580\u0574\u0561\u0581\u0576\u0565\u056C\u055D {n}",
        ka: "\u10D2\u10D0\u10DC\u10D0\u10EE\u10DA\u10D4\u10D1\u10D0 \u10D5\u10D4\u10E0 \u10DB\u10DD\u10EE\u10D4\u10E0\u10EE\u10D3\u10D0: {n}"
    },
    /* Empty states differ by cause (spec/04): clear the filters vs create the first task. */ empty_title: {
        uk: "\u0417\u0430\u0432\u0434\u0430\u043D\u044C \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
        en: "No tasks found",
        hy: "\u0531\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0576\u0565\u0580 \u0579\u0565\u0576 \u0563\u057F\u0576\u057E\u0565\u056C",
        ka: "\u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8 \u10D0\u10E0 \u10DB\u10DD\u10D8\u10EB\u10D4\u10D1\u10DC\u10D0"
    },
    empty_desc: {
        uk: "\u0416\u043E\u0434\u043D\u0435 \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F \u043D\u0435 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0430\u0454 \u043F\u043E\u0442\u043E\u0447\u043D\u0438\u043C \u0444\u0456\u043B\u044C\u0442\u0440\u0430\u043C.",
        en: "No tasks match the current filters.",
        hy: "\u0548\u0579 \u0574\u056B \u0561\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584 \u0579\u056B \u0570\u0561\u0574\u0561\u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0578\u0582\u0574 \u0568\u0576\u0569\u0561\u0581\u056B\u056F \u0566\u057F\u056B\u0579\u0576\u0565\u0580\u056B\u0576\u0589",
        ka: "\u10D0\u10E0\u10EA\u10D4\u10E0\u10D7\u10D8 \u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D0 \u10D0\u10E0 \u10D4\u10DB\u10D7\u10EE\u10D5\u10D4\u10D5\u10D0 \u10DB\u10D8\u10DB\u10D3\u10D8\u10DC\u10D0\u10E0\u10D4 \u10E4\u10D8\u10DA\u10E2\u10E0\u10D4\u10D1\u10E1."
    },
    empty_none_title: {
        uk: "\u0429\u0435 \u043D\u0435\u043C\u0430\u0454 \u0437\u0430\u0432\u0434\u0430\u043D\u044C",
        en: "No tasks yet",
        hy: "\u0534\u0565\u057C \u0561\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0576\u0565\u0580 \u0579\u056F\u0561\u0576",
        ka: "\u10EF\u10D4\u10E0 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1 \u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8"
    },
    empty_none_desc: {
        uk: "\u0421\u0442\u0432\u043E\u0440\u0456\u0442\u044C \u043F\u0435\u0440\u0448\u0435 \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F \u043D\u0430 \u0442\u043E\u0447\u043A\u0443 \u0430\u0431\u043E \u043C\u0435\u0440\u0435\u0436\u0443.",
        en: "Create the first task for a point or a network.",
        hy: "\u054D\u057F\u0565\u0572\u056E\u0565\u0584 \u0561\u057C\u0561\u057B\u056B\u0576 \u0561\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0568 \u056F\u0565\u057F\u056B \u056F\u0561\u0574 \u0581\u0561\u0576\u0581\u056B \u0570\u0561\u0574\u0561\u0580\u0589",
        ka: "\u10E8\u10D4\u10E5\u10DB\u10D4\u10DC\u10D8\u10D7 \u10DE\u10D8\u10E0\u10D5\u10D4\u10DA\u10D8 \u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D0 \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1 \u10D0\u10DC \u10E5\u10E1\u10D4\u10DA\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1."
    }
};
const $fc3f36407bc5ec6c$export$9b31c804fa72c7c = {
    crumb: {
        uk: "\u0417\u0430\u0432\u0434\u0430\u043D\u043D\u044F",
        en: "Tasks",
        hy: "\u0531\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0576\u0565\u0580",
        ka: "\u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8"
    },
    new_title: {
        uk: "\u041D\u043E\u0432\u0435 \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F",
        en: "New task",
        hy: "\u0546\u0578\u0580 \u0561\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584",
        ka: "\u10D0\u10EE\u10D0\u10DA\u10D8 \u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D0"
    },
    /* Sections */ sec_what: {
        uk: "\u0429\u043E \u0437\u0440\u043E\u0431\u0438\u0442\u0438",
        en: "What to do",
        hy: "\u053B\u0576\u0579 \u057A\u0565\u057F\u0584 \u0567 \u0561\u0576\u0565\u056C",
        ka: "\u10E0\u10D0 \u10E3\u10DC\u10D3\u10D0 \u10D2\u10D0\u10D9\u10D4\u10D7\u10D3\u10D4\u10E1"
    },
    sec_what_desc: {
        uk: "\u0426\u0435 \u0442\u0435, \u0449\u043E \u043C\u0435\u0440\u0447\u0435\u043D\u0434\u0430\u0439\u0437\u0435\u0440 \u043F\u043E\u0431\u0430\u0447\u0438\u0442\u044C \u0443 \u0437\u0430\u0441\u0442\u043E\u0441\u0443\u043D\u043A\u0443.",
        en: "This is what the merchandiser sees in the app.",
        hy: "\u054D\u0561 \u0561\u0575\u0576 \u0567, \u056B\u0576\u0579 \u0574\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580\u0568 \u057F\u0565\u057D\u0576\u0578\u0582\u0574 \u0567 \u0570\u0561\u057E\u0565\u056C\u057E\u0561\u056E\u0578\u0582\u0574\u0589",
        ka: "\u10D4\u10E1 \u10D0\u10E0\u10D8\u10E1 \u10D8\u10E1, \u10E0\u10D0\u10E1\u10D0\u10EA \u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D8 \u10EE\u10D4\u10D3\u10D0\u10D5\u10E1 \u10D0\u10DE\u10DA\u10D8\u10D9\u10D0\u10EA\u10D8\u10D0\u10E8\u10D8."
    },
    sec_where: {
        uk: "\u0414\u0435",
        en: "Where",
        hy: "\u0548\u0580\u057F\u0565\u0572",
        ka: "\u10E1\u10D0\u10D3"
    },
    sec_where_desc: {
        uk: "\u0426\u0456\u043B\u044C \u043D\u0435 \u0437\u043C\u0456\u043D\u044E\u0454\u0442\u044C\u0441\u044F \u043F\u0456\u0441\u043B\u044F \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F.",
        en: "The target cannot be changed after creation.",
        hy: "\u0539\u056B\u0580\u0561\u056D\u0568 \u057D\u057F\u0565\u0572\u056E\u0565\u056C\u0578\u0582\u0581 \u0570\u0565\u057F\u0578 \u0579\u056B \u0583\u0578\u056D\u057E\u0578\u0582\u0574\u0589",
        ka: "\u10DB\u10D8\u10D6\u10D0\u10DC\u10D8 \u10E8\u10D4\u10E5\u10DB\u10DC\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D3\u10D4\u10D2 \u10D0\u10E0 \u10D8\u10EA\u10D5\u10DA\u10D4\u10D1\u10D0."
    },
    sec_when: {
        uk: "\u041A\u043E\u043B\u0438",
        en: "When",
        hy: "\u0535\u0580\u0562",
        ka: "\u10E0\u10DD\u10D3\u10D8\u10E1"
    },
    sec_form: {
        uk: "\u0424\u043E\u0440\u043C\u0430 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0456",
        en: "Answer form",
        hy: "\u054A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u056B \u0571\u0587",
        ka: "\u10DE\u10D0\u10E1\u10E3\u10EE\u10D8\u10E1 \u10E4\u10DD\u10E0\u10DB\u10D0"
    },
    sec_form_desc: {
        uk: "\u0428\u0430\u0431\u043B\u043E\u043D \u0432\u0438\u0437\u043D\u0430\u0447\u0430\u0454, \u0449\u043E \u0441\u0430\u043C\u0435 \u0437\u0430\u043F\u0438\u0442\u0430\u044E\u0442\u044C \u0443 \u043C\u0435\u0440\u0447\u0435\u043D\u0434\u0430\u0439\u0437\u0435\u0440\u0430.",
        en: "The template decides what the merchandiser is asked for.",
        hy: "\u053F\u0561\u0572\u0561\u057A\u0561\u0580\u0568 \u0578\u0580\u0578\u0577\u0578\u0582\u0574 \u0567, \u0569\u0565 \u056B\u0576\u0579 \u056F\u0570\u0561\u0580\u0581\u0576\u0565\u0576 \u0574\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580\u056B\u0576\u0589",
        ka: "\u10E8\u10D0\u10D1\u10DA\u10DD\u10DC\u10D8 \u10D2\u10D0\u10DC\u10E1\u10D0\u10D6\u10E6\u10D5\u10E0\u10D0\u10D5\u10E1, \u10E0\u10D0\u10E1 \u10D4\u10D9\u10D8\u10D7\u10EE\u10D4\u10D1\u10D8\u10D0\u10DC \u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10E1."
    },
    sec_answers: {
        uk: "\u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0456",
        en: "Answers",
        hy: "\u054A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0576\u0565\u0580",
        ka: "\u10DE\u10D0\u10E1\u10E3\u10EE\u10D4\u10D1\u10D8"
    },
    /* Fields */ f_title: {
        uk: "\u041D\u0430\u0437\u0432\u0430",
        en: "Name",
        hy: "\u0531\u0576\u057E\u0561\u0576\u0578\u0582\u0574",
        ka: "\u10E1\u10D0\u10EE\u10D4\u10DA\u10D8"
    },
    f_description: {
        uk: "\u041E\u043F\u0438\u0441",
        en: "Description",
        hy: "\u0546\u056F\u0561\u0580\u0561\u0563\u0580\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10D0\u10E6\u10EC\u10D4\u10E0\u10D0"
    },
    f_image: {
        uk: "\u0417\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F-\u0437\u0440\u0430\u0437\u043E\u043A",
        en: "Reference image",
        hy: "\u0546\u0574\u0578\u0582\u0577\u0561\u0575\u056B\u0576 \u057A\u0561\u057F\u056F\u0565\u0580",
        ka: "\u10E1\u10D0\u10DD\u10E0\u10D8\u10D4\u10DC\u10E2\u10D0\u10EA\u10D8\u10DD \u10E1\u10E3\u10E0\u10D0\u10D7\u10D8"
    },
    f_image_hint: {
        uk: "\u041F\u043E\u043A\u0430\u0437\u0443\u0454\u0442\u044C\u0441\u044F \u043C\u0435\u0440\u0447\u0435\u043D\u0434\u0430\u0439\u0437\u0435\u0440\u0443 \u044F\u043A \u0437\u0440\u0430\u0437\u043E\u043A \u0432\u0438\u043A\u043B\u0430\u0434\u043A\u0438.",
        en: "Shown to the merchandiser as the shelf they should match.",
        hy: "\u0551\u0578\u0582\u0581\u0561\u0564\u0580\u057E\u0578\u0582\u0574 \u0567 \u0574\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580\u056B\u0576 \u0578\u0580\u057A\u0565\u057D \u0585\u0580\u056B\u0576\u0561\u056F\u0589",
        ka: "\u10D4\u10E9\u10D5\u10D4\u10DC\u10D4\u10D1\u10D0 \u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10E1 \u10E0\u10DD\u10D2\u10DD\u10E0\u10EA \u10DC\u10D8\u10DB\u10E3\u10E8\u10D8."
    },
    img_add: {
        uk: "\u0414\u043E\u0434\u0430\u0442\u0438 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F",
        en: "Add an image",
        hy: "\u0531\u057E\u0565\u056C\u0561\u0581\u0576\u0565\u056C \u057A\u0561\u057F\u056F\u0565\u0580",
        ka: "\u10E1\u10E3\u10E0\u10D0\u10D7\u10D8\u10E1 \u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D0"
    },
    img_change: {
        uk: "\u0417\u0430\u043C\u0456\u043D\u0438\u0442\u0438 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F",
        en: "Replace the image",
        hy: "\u0553\u0578\u056D\u0561\u0580\u056B\u0576\u0565\u056C \u057A\u0561\u057F\u056F\u0565\u0580\u0568",
        ka: "\u10E1\u10E3\u10E0\u10D0\u10D7\u10D8\u10E1 \u10E8\u10D4\u10EA\u10D5\u10DA\u10D0"
    },
    img_remove: {
        uk: "\u041F\u0440\u0438\u0431\u0440\u0430\u0442\u0438 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F",
        en: "Remove the image",
        hy: "\u0540\u0565\u057C\u0561\u0581\u0576\u0565\u056C \u057A\u0561\u057F\u056F\u0565\u0580\u0568",
        ka: "\u10E1\u10E3\u10E0\u10D0\u10D7\u10D8\u10E1 \u10DB\u10DD\u10E8\u10DD\u10E0\u10D4\u10D1\u10D0"
    },
    img_too_big: {
        uk: "\u0424\u0430\u0439\u043B \u0437\u0430\u0432\u0435\u043B\u0438\u043A\u0438\u0439 \u2014 \u0434\u043E {n} \u041C\u0411",
        en: "File is too large \u2014 up to {n} MB",
        hy: "\u0556\u0561\u0575\u056C\u0568 \u0577\u0561\u057F \u0574\u0565\u056E \u0567 \u2014 \u0574\u056B\u0576\u0579\u0587 {n} \u0544\u0532",
        ka: "\u10E4\u10D0\u10D8\u10DA\u10D8 \u10EB\u10D0\u10DA\u10D8\u10D0\u10DC \u10D3\u10D8\u10D3\u10D8\u10D0 \u2014 {n} MB-\u10DB\u10D3\u10D4"
    },
    img_failed: {
        uk: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F",
        en: "Failed to upload the image",
        hy: "\u0549\u0570\u0561\u057B\u0578\u0572\u057E\u0565\u0581 \u057E\u0565\u0580\u0562\u0565\u057C\u0576\u0565\u056C \u057A\u0561\u057F\u056F\u0565\u0580\u0568",
        ka: "\u10E1\u10E3\u10E0\u10D0\u10D7\u10D8\u10E1 \u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D0 \u10D5\u10D4\u10E0 \u10DB\u10DD\u10EE\u10D4\u10E0\u10EE\u10D3\u10D0"
    },
    f_point: {
        uk: "\u0422\u043E\u0447\u043A\u0430",
        en: "Point",
        hy: "\u053F\u0565\u057F",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8"
    },
    f_network: {
        uk: "\u041C\u0435\u0440\u0435\u0436\u0430",
        en: "Network",
        hy: "\u0551\u0561\u0576\u0581",
        ka: "\u10E5\u10E1\u10D4\u10DA\u10D8"
    },
    f_group: {
        uk: "\u0413\u0440\u0443\u043F\u0430 \u0442\u043E\u0447\u043E\u043A",
        en: "Group of points",
        hy: "\u053F\u0565\u057F\u0565\u0580\u056B \u056D\u0578\u0582\u0574\u0562",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1 \u10EF\u10D2\u10E3\u10E4\u10D8"
    },
    f_group_name: {
        uk: "\u041D\u0430\u0437\u0432\u0430 \u043F\u0430\u043A\u0435\u0442\u0430 \u0437\u0430\u0432\u0434\u0430\u043D\u044C",
        en: "Batch name",
        hy: "\u0553\u0561\u0569\u0565\u0569\u056B \u0561\u0576\u057E\u0561\u0576\u0578\u0582\u0574",
        ka: "\u10DE\u10D0\u10D9\u10D4\u10E2\u10D8\u10E1 \u10E1\u10D0\u10EE\u10D4\u10DA\u10D8"
    },
    f_start: {
        uk: "\u041F\u043E\u0447\u0430\u0442\u043E\u043A",
        en: "Start",
        hy: "\u054D\u056F\u056B\u0566\u0562",
        ka: "\u10D3\u10D0\u10EC\u10E7\u10D4\u10D1\u10D0"
    },
    f_end: {
        uk: "\u0414\u0435\u0434\u043B\u0430\u0439\u043D",
        en: "Deadline",
        hy: "\u054E\u0565\u0580\u057B\u0576\u0561\u056A\u0561\u0574\u056F\u0565\u057F",
        ka: "\u10D1\u10DD\u10DA\u10DD \u10D5\u10D0\u10D3\u10D0"
    },
    f_template: {
        uk: "\u0428\u0430\u0431\u043B\u043E\u043D",
        en: "Template",
        hy: "\u053F\u0561\u0572\u0561\u057A\u0561\u0580",
        ka: "\u10E8\u10D0\u10D1\u10DA\u10DD\u10DC\u10D8"
    },
    /* Priority and components come from the TEMPLATE and are read-only here — Task has no such
     columns, so the old form's editable priority was discarded by the API on every save. */ f_priority: {
        uk: "\u041F\u0440\u0456\u043E\u0440\u0438\u0442\u0435\u0442",
        en: "Priority",
        hy: "\u0531\u057C\u0561\u057B\u0576\u0561\u0570\u0565\u0580\u0569\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10DE\u10E0\u10D8\u10DD\u10E0\u10D8\u10E2\u10D4\u10E2\u10D8"
    },
    f_components: {
        uk: "\u041C\u0435\u0440\u0447\u0435\u043D\u0434\u0430\u0439\u0437\u0435\u0440 \u043D\u0430\u0434\u0441\u0438\u043B\u0430\u0454",
        en: "The merchandiser submits",
        hy: "\u0544\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580\u0576 \u0578\u0582\u0572\u0561\u0580\u056F\u0578\u0582\u0574 \u0567",
        ka: "\u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D8 \u10D0\u10D2\u10D6\u10D0\u10D5\u10DC\u10D8\u10E1"
    },
    from_template: {
        uk: "\u0406\u0437 \u0448\u0430\u0431\u043B\u043E\u043D\u0443",
        en: "From the template",
        hy: "\u053F\u0561\u0572\u0561\u057A\u0561\u0580\u056B\u0581",
        ka: "\u10E8\u10D0\u10D1\u10DA\u10DD\u10DC\u10D8\u10D3\u10D0\u10DC"
    },
    cmp_photo: {
        uk: "\u0424\u043E\u0442\u043E",
        en: "Photo",
        hy: "\u053C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580",
        ka: "\u10E4\u10DD\u10E2\u10DD"
    },
    cmp_text: {
        uk: "\u0422\u0435\u043A\u0441\u0442",
        en: "Text",
        hy: "\u054F\u0565\u0584\u057D\u057F",
        ka: "\u10E2\u10D4\u10E5\u10E1\u10E2\u10D8"
    },
    cmp_boolean: {
        uk: "\u0422\u0430\u043A / \u043D\u0456",
        en: "Yes / no",
        hy: "\u0531\u0575\u0578 / \u0578\u0579",
        ka: "\u10D3\u10D8\u10D0\u10EE / \u10D0\u10E0\u10D0"
    },
    cmp_numeric: {
        uk: "\u0427\u0438\u0441\u043B\u043E",
        en: "Number",
        hy: "\u0539\u056B\u057E",
        ka: "\u10E0\u10D8\u10EA\u10EE\u10D5\u10D8"
    },
    cmp_tags: {
        uk: "\u0422\u0435\u0433\u0438",
        en: "Tags",
        hy: "\u054A\u056B\u057F\u0561\u056F\u0576\u0565\u0580",
        ka: "\u10E2\u10D4\u10D2\u10D4\u10D1\u10D8"
    },
    prio_0: {
        uk: "\u041E\u0431\u043E\u0432'\u044F\u0437\u043A\u043E\u0432\u0438\u0439",
        en: "Required",
        hy: "\u054A\u0561\u0580\u057F\u0561\u0564\u056B\u0580",
        ka: "\u10E1\u10D0\u10D5\u10D0\u10DA\u10D3\u10D4\u10D1\u10E3\u10DA\u10DD"
    },
    prio_1: {
        uk: "\u0412\u0438\u0441\u043E\u043A\u0438\u0439",
        en: "High",
        hy: "\u0532\u0561\u0580\u0571\u0580",
        ka: "\u10DB\u10D0\u10E6\u10D0\u10DA\u10D8"
    },
    prio_2: {
        uk: "\u0421\u0435\u0440\u0435\u0434\u043D\u0456\u0439",
        en: "Medium",
        hy: "\u0544\u056B\u057B\u056B\u0576",
        ka: "\u10E1\u10D0\u10E8\u10E3\u10D0\u10DA\u10DD"
    },
    prio_3: {
        uk: "\u041D\u0438\u0437\u044C\u043A\u0438\u0439",
        en: "Low",
        hy: "\u0551\u0561\u056E\u0580",
        ka: "\u10D3\u10D0\u10D1\u10D0\u10DA\u10D8"
    },
    /* Rail */ rail_summary: {
        uk: "\u0417\u0432\u0435\u0434\u0435\u043D\u043D\u044F",
        en: "Summary",
        hy: "\u0531\u0574\u0583\u0578\u0583\u0578\u0582\u0574",
        ka: "\u10E8\u10D4\u10DB\u10DD\u10D9\u10DA\u10D4\u10D1\u10D0"
    },
    rail_quality: {
        uk: "\u0429\u043E \u0437\u0430\u043F\u043E\u0432\u043D\u0438\u0442\u0438",
        en: "Still needed",
        hy: "\u0534\u0565\u057C \u057A\u0565\u057F\u0584 \u0567",
        ka: "\u10EF\u10D4\u10E0 \u10E1\u10D0\u10ED\u10D8\u10E0\u10DD\u10D0"
    },
    k_created: {
        uk: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043E",
        en: "Created",
        hy: "\u054D\u057F\u0565\u0572\u056E\u057E\u0561\u056E",
        ka: "\u10E8\u10D4\u10E5\u10DB\u10DC\u10D8\u10DA\u10D8\u10D0"
    },
    k_created_by: {
        uk: "\u0410\u0432\u0442\u043E\u0440",
        en: "Created by",
        hy: "\u0540\u0565\u0572\u056B\u0576\u0561\u056F",
        ka: "\u10D0\u10D5\u10E2\u10DD\u10E0\u10D8"
    },
    k_supervisor: {
        uk: "\u0421\u0443\u043F\u0435\u0440\u0432\u0430\u0439\u0437\u0435\u0440",
        en: "Supervisor",
        hy: "\u054D\u0578\u0582\u057A\u0565\u0580\u057E\u0561\u0575\u0566\u0565\u0580",
        ka: "\u10E1\u10E3\u10DE\u10D4\u10E0\u10D5\u10D0\u10D8\u10D6\u10D4\u10E0\u10D8"
    },
    k_merchandiser: {
        uk: "\u041C\u0435\u0440\u0447\u0435\u043D\u0434\u0430\u0439\u0437\u0435\u0440",
        en: "Merchandiser",
        hy: "\u0544\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580",
        ka: "\u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D8"
    },
    k_locality: {
        uk: "\u041D\u0430\u0441\u0435\u043B\u0435\u043D\u0438\u0439 \u043F\u0443\u043D\u043A\u0442",
        en: "Locality",
        hy: "\u0532\u0576\u0561\u056F\u0561\u057E\u0561\u0575\u0580",
        ka: "\u10D3\u10D0\u10E1\u10D0\u10EE\u10DA\u10D4\u10D1\u10D0"
    },
    k_last_answer: {
        uk: "\u041E\u0441\u0442\u0430\u043D\u043D\u044F \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u044C",
        en: "Last answer",
        hy: "\u054E\u0565\u0580\u057B\u056B\u0576 \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0568",
        ka: "\u10D1\u10DD\u10DA\u10DD \u10DE\u10D0\u10E1\u10E3\u10EE\u10D8"
    },
    k_photos: {
        uk: "\u0424\u043E\u0442\u043E",
        en: "Photos",
        hy: "\u053C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580\u0576\u0565\u0580",
        ka: "\u10E4\u10DD\u10E2\u10DD\u10D4\u10D1\u10D8"
    },
    no_merchandiser: {
        uk: "\u041D\u0456\u043A\u043E\u0433\u043E \u043D\u0435 \u043F\u0440\u0438\u0437\u043D\u0430\u0447\u0435\u043D\u043E",
        en: "Nobody assigned",
        hy: "\u0548\u0579 \u0578\u0584 \u0576\u0577\u0561\u0576\u0561\u056F\u057E\u0561\u056E \u0579\u0567",
        ka: "\u10D0\u10E0\u10D0\u10D5\u10D8\u10DC \u10D0\u10E0\u10D8\u10E1 \u10D3\u10D0\u10DC\u10D8\u10E8\u10DC\u10E3\u10DA\u10D8"
    },
    /* Answers section */ ans_empty: {
        uk: "\u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0435\u0439 \u0449\u0435 \u043D\u0435\u043C\u0430\u0454",
        en: "No answers yet",
        hy: "\u0534\u0565\u057C \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0576\u0565\u0580 \u0579\u056F\u0561\u0576",
        ka: "\u10EF\u10D4\u10E0 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1 \u10DE\u10D0\u10E1\u10E3\u10EE\u10D4\u10D1\u10D8"
    },
    ans_show: {
        uk: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438",
        en: "Show",
        hy: "\u0551\u0578\u0582\u0581\u0561\u0564\u0580\u0565\u056C",
        ka: "\u10E9\u10D5\u10D4\u10DC\u10D4\u10D1\u10D0"
    },
    ans_hide: {
        uk: "\u0417\u0433\u043E\u0440\u043D\u0443\u0442\u0438",
        en: "Hide",
        hy: "\u0539\u0561\u0584\u0581\u0576\u0565\u056C",
        ka: "\u10D3\u10D0\u10DB\u10D0\u10DA\u10D5\u10D0"
    },
    /* Column headers for the answers table. */ col_status: {
        uk: "\u0421\u0442\u0430\u0442\u0443\u0441",
        en: "Status",
        hy: "\u053F\u0561\u0580\u0563\u0561\u057E\u056B\u0573\u0561\u056F",
        ka: "\u10E1\u10E2\u10D0\u10E2\u10E3\u10E1\u10D8"
    },
    ans_text: {
        uk: "\u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u044C",
        en: "Answer",
        hy: "\u054A\u0561\u057F\u0561\u057D\u056D\u0561\u0576",
        ka: "\u10DE\u10D0\u10E1\u10E3\u10EE\u10D8"
    },
    ans_comment: {
        uk: "\u041A\u043E\u043C\u0435\u043D\u0442\u0430\u0440",
        en: "Comment",
        hy: "\u0544\u0565\u056F\u0576\u0561\u0562\u0561\u0576\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10D9\u10DD\u10DB\u10D4\u10DC\u10E2\u10D0\u10E0\u10D8"
    },
    ans_date: {
        uk: "\u0414\u0430\u0442\u0430",
        en: "Date",
        hy: "\u0531\u0574\u057D\u0561\u0569\u056B\u057E",
        ka: "\u10D7\u10D0\u10E0\u10D8\u10E6\u10D8"
    },
    row_actions: {
        uk: "\u0414\u0456\u0457 \u0437 \u0440\u044F\u0434\u043A\u043E\u043C",
        en: "Row actions",
        hy: "\u054F\u0578\u0572\u056B \u0563\u0578\u0580\u056E\u0578\u0572\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580",
        ka: "\u10DB\u10EC\u10D9\u10E0\u10D8\u10D5\u10D8\u10E1 \u10DB\u10DD\u10E5\u10DB\u10D4\u10D3\u10D4\u10D1\u10D4\u10D1\u10D8"
    },
    ans_by: {
        uk: "\u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0432",
        en: "Answered by",
        hy: "\u054A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0565\u056C \u0567",
        ka: "\u10DE\u10D0\u10E1\u10E3\u10EE\u10D8 \u10D2\u10D0\u10E1\u10EA\u10D0"
    },
    ans_yes: {
        uk: "\u0422\u0430\u043A",
        en: "Yes",
        hy: "\u0531\u0575\u0578",
        ka: "\u10D3\u10D8\u10D0\u10EE"
    },
    ans_no: {
        uk: "\u041D\u0456",
        en: "No",
        hy: "\u0548\u0579",
        ka: "\u10D0\u10E0\u10D0"
    },
    approve: {
        uk: "\u0417\u0430\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0438",
        en: "Approve",
        hy: "\u0540\u0561\u057D\u057F\u0561\u057F\u0565\u056C",
        ka: "\u10D3\u10D0\u10DB\u10E2\u10D9\u10D8\u10EA\u10D4\u10D1\u10D0"
    },
    reject: {
        uk: "\u0412\u0456\u0434\u0445\u0438\u043B\u0438\u0442\u0438",
        en: "Reject",
        hy: "\u0544\u0565\u0580\u056A\u0565\u056C",
        ka: "\u10E3\u10D0\u10E0\u10E7\u10DD\u10E4\u10D0"
    },
    approved_msg: {
        uk: "\u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u044C \u0437\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u043E",
        en: "Answer approved",
        hy: "\u054A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0568 \u0570\u0561\u057D\u057F\u0561\u057F\u057E\u0561\u056E \u0567",
        ka: "\u10DE\u10D0\u10E1\u10E3\u10EE\u10D8 \u10D3\u10D0\u10DB\u10E2\u10D9\u10D8\u10EA\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0"
    },
    rejected_msg: {
        uk: "\u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u044C \u0432\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043E",
        en: "Answer rejected",
        hy: "\u054A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0568 \u0574\u0565\u0580\u056A\u057E\u0561\u056E \u0567",
        ka: "\u10DE\u10D0\u10E1\u10E3\u10EE\u10D8 \u10E3\u10D0\u10E0\u10E7\u10DD\u10E4\u10D8\u10DA\u10D8\u10D0"
    },
    load_error: {
        uk: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0456",
        en: "Failed to load answers",
        hy: "\u0549\u0570\u0561\u057B\u0578\u0572\u057E\u0565\u0581 \u0562\u0565\u057C\u0576\u0565\u056C \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0576\u0565\u0580\u0568",
        ka: "\u10DE\u10D0\u10E1\u10E3\u10EE\u10D4\u10D1\u10D8\u10E1 \u10E9\u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D0 \u10D5\u10D4\u10E0 \u10DB\u10DD\u10EE\u10D4\u10E0\u10EE\u10D3\u10D0"
    },
    retry: {
        uk: "\u0421\u043F\u0440\u043E\u0431\u0443\u0432\u0430\u0442\u0438 \u0437\u043D\u043E\u0432\u0443",
        en: "Retry",
        hy: "\u053F\u0580\u056F\u0576\u0565\u056C",
        ka: "\u10EE\u10D4\u10DA\u10D0\u10EE\u10DA\u10D0"
    },
    /* Lifecycle */ edit: {
        uk: "\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438",
        en: "Edit",
        hy: "\u053D\u0574\u0562\u0561\u0563\u0580\u0565\u056C",
        ka: "\u10E0\u10D4\u10D3\u10D0\u10E5\u10E2\u10D8\u10E0\u10D4\u10D1\u10D0"
    },
    save: {
        uk: "\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438",
        en: "Save",
        hy: "\u054A\u0561\u0570\u057A\u0561\u0576\u0565\u056C",
        ka: "\u10E8\u10D4\u10DC\u10D0\u10EE\u10D5\u10D0"
    },
    cancel: {
        uk: "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438",
        en: "Cancel",
        hy: "\u0549\u0565\u0572\u0561\u0580\u056F\u0565\u056C",
        ka: "\u10D2\u10D0\u10E3\u10E5\u10DB\u10D4\u10D1\u10D0"
    },
    draft: {
        uk: "\u0427\u0435\u0440\u043D\u0435\u0442\u043A\u0430 \u2014 \u0449\u0435 \u043D\u0435 \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043E",
        en: "Draft \u2014 not saved yet",
        hy: "\u054D\u0587\u0561\u0563\u056B\u0580 \u2014 \u0564\u0565\u057C \u057A\u0561\u0570\u057A\u0561\u0576\u057E\u0561\u056E \u0579\u0567",
        ka: "\u10DB\u10DD\u10DC\u10D0\u10EE\u10D0\u10D6\u10D8 \u2014 \u10EF\u10D4\u10E0 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1 \u10E8\u10D4\u10DC\u10D0\u10EE\u10E3\u10DA\u10D8"
    },
    unsaved: {
        uk: "\u041D\u0435\u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u0456 \u0437\u043C\u0456\u043D\u0438",
        en: "Unsaved changes",
        hy: "\u0549\u057A\u0561\u0570\u057A\u0561\u0576\u057E\u0561\u056E \u0583\u0578\u0583\u0578\u056D\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580",
        ka: "\u10E8\u10D4\u10E3\u10DC\u10D0\u10EE\u10D0\u10D5\u10D8 \u10EA\u10D5\u10DA\u10D8\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8"
    },
    confirm_cancel: {
        uk: "\u0412\u0456\u0434\u0445\u0438\u043B\u0438\u0442\u0438 \u0437\u043C\u0456\u043D\u0438?",
        en: "Discard changes?",
        hy: "\u0549\u0565\u0572\u0561\u0580\u056F\u0565\u055E\u056C \u0583\u0578\u0583\u0578\u056D\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580\u0568\u0589",
        ka: "\u10EA\u10D5\u10DA\u10D8\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10E3\u10E5\u10DB\u10D4\u10D1\u10D0?"
    },
    saved_msg: {
        uk: "\u0417\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043E",
        en: "Saved",
        hy: "\u054A\u0561\u0570\u057A\u0561\u0576\u057E\u0561\u056E \u0567",
        ka: "\u10E8\u10D4\u10DC\u10D0\u10EE\u10E3\u10DA\u10D8\u10D0"
    },
    save_failed: {
        uk: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0431\u0435\u0440\u0435\u0433\u0442\u0438",
        en: "Failed to save",
        hy: "\u0549\u0570\u0561\u057B\u0578\u0572\u057E\u0565\u0581 \u057A\u0561\u0570\u057A\u0561\u0576\u0565\u056C",
        ka: "\u10E8\u10D4\u10DC\u10D0\u10EE\u10D5\u10D0 \u10D5\u10D4\u10E0 \u10DB\u10DD\u10EE\u10D4\u10E0\u10EE\u10D3\u10D0"
    },
    required_field: {
        uk: "\u0417\u0430\u043F\u043E\u0432\u043D\u0456\u0442\u044C \u0446\u0435 \u043F\u043E\u043B\u0435",
        en: "Fill this in",
        hy: "\u053C\u0580\u0561\u0581\u0580\u0565\u0584 \u057D\u0561",
        ka: "\u10E8\u10D4\u10D0\u10D5\u10E1\u10D4\u10D7 \u10D4\u10E1"
    },
    not_found_title: {
        uk: "\u041D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
        en: "Not found",
        hy: "\u0549\u056B \u0563\u057F\u0576\u057E\u0565\u056C",
        ka: "\u10D0\u10E0 \u10DB\u10DD\u10D8\u10EB\u10D4\u10D1\u10DC\u10D0"
    },
    not_found_desc: {
        uk: "\u0417\u0430\u0432\u0434\u0430\u043D\u043D\u044F \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u0435 \u0430\u0431\u043E \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u0435.",
        en: "Task not found or deleted.",
        hy: "\u0531\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0568 \u0579\u056B \u0563\u057F\u0576\u057E\u0565\u056C \u056F\u0561\u0574 \u057B\u0576\u057B\u057E\u0561\u056E \u0567\u0589",
        ka: "\u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D0 \u10D5\u10D4\u10E0 \u10DB\u10DD\u10D8\u10EB\u10D4\u10D1\u10DC\u10D0 \u10D0\u10DC \u10EC\u10D0\u10E8\u10DA\u10D8\u10DA\u10D8\u10D0."
    },
    back_to_list: {
        uk: "\u0414\u043E \u0441\u043F\u0438\u0441\u043A\u0443 \u0437\u0430\u0432\u0434\u0430\u043D\u044C",
        en: "Back to tasks",
        hy: "\u054E\u0565\u0580\u0561\u0564\u0561\u057C\u0576\u0561\u056C \u0561\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0576\u0565\u0580\u056B\u0576",
        ka: "\u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D4\u10D1\u10E8\u10D8 \u10D3\u10D0\u10D1\u10E0\u10E3\u10DC\u10D4\u10D1\u10D0"
    },
    /* Bulk create returns no single record, so it lands back on the list with a count. */ bulk_created_msg: {
        uk: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u0437\u0430\u043F\u0443\u0449\u0435\u043D\u043E \u2014 \u0437\u0430\u0432\u0434\u0430\u043D\u044C: {n}",
        en: "Creation started \u2014 tasks: {n}",
        hy: "\u054D\u057F\u0565\u0572\u056E\u0578\u0582\u0574\u0568 \u057D\u056F\u057D\u057E\u0565\u056C \u0567 \u2014 \u0561\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0576\u0565\u0580\u055D {n}",
        ka: "\u10E8\u10D4\u10E5\u10DB\u10DC\u10D0 \u10D3\u10D0\u10D8\u10EC\u10E7\u10DD \u2014 \u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8: {n}"
    },
    bulk_queued_msg: {
        uk: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u043F\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043E \u0432 \u0447\u0435\u0440\u0433\u0443. \u0417\u0430\u0432\u0434\u0430\u043D\u043D\u044F \u0437'\u044F\u0432\u043B\u044F\u0442\u044C\u0441\u044F \u0443 \u0441\u043F\u0438\u0441\u043A\u0443.",
        en: "Creation queued. The tasks will appear in the list.",
        hy: "\u054D\u057F\u0565\u0572\u056E\u0578\u0582\u0574\u0568 \u0570\u0565\u0580\u0569\u0578\u0582\u0574 \u0567\u0589 \u0531\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0576\u0565\u0580\u0568 \u056F\u0570\u0561\u0575\u057F\u0576\u057E\u0565\u0576 \u0581\u0561\u0576\u056F\u0578\u0582\u0574\u0589",
        ka: "\u10E8\u10D4\u10E5\u10DB\u10DC\u10D0 \u10E0\u10D8\u10D2\u10E8\u10D8\u10D0. \u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8 \u10D2\u10D0\u10DB\u10DD\u10E9\u10DC\u10D3\u10D4\u10D1\u10D0 \u10E1\u10D8\u10D0\u10E8\u10D8."
    }
};
const $fc3f36407bc5ec6c$export$d944b88894773aab = {
    page_sub: {
        uk: "\u0429\u043E \u043C\u0435\u0440\u0447\u0435\u043D\u0434\u0430\u0439\u0437\u0435\u0440\u0438 \u043D\u0430\u0434\u0456\u0441\u043B\u0430\u043B\u0438 \u0456 \u0449\u043E \u0447\u0435\u043A\u0430\u0454 \u043D\u0430 \u0432\u0430\u0448\u0443 \u043E\u0446\u0456\u043D\u043A\u0443",
        en: "What merchandisers sent, and what is waiting for your verdict",
        hy: "\u053B\u0576\u0579 \u0565\u0576 \u0578\u0582\u0572\u0561\u0580\u056F\u0565\u056C \u0574\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580\u0576\u0565\u0580\u0568 \u0587 \u056B\u0576\u0579\u0576 \u0567 \u057D\u057A\u0561\u057D\u0578\u0582\u0574 \u0571\u0565\u0580 \u0563\u0576\u0561\u0570\u0561\u057F\u0561\u056F\u0561\u0576\u056B\u0576",
        ka: "\u10E0\u10D0 \u10D2\u10D0\u10DB\u10DD\u10D0\u10D2\u10D6\u10D0\u10D5\u10DC\u10D4\u10E1 \u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D4\u10D1\u10DB\u10D0 \u10D3\u10D0 \u10E0\u10D0 \u10D4\u10DA\u10DD\u10D3\u10D4\u10D1\u10D0 \u10D7\u10E5\u10D5\u10D4\u10DC\u10E1 \u10E8\u10D4\u10E4\u10D0\u10E1\u10D4\u10D1\u10D0\u10E1"
    },
    /* Derived chips. Each says what the state MEANS operationally, per spec/04. */ chip_photo: {
        uk: "\u0417 \u0444\u043E\u0442\u043E",
        en: "With a photo",
        hy: "\u053C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580\u0578\u057E",
        ka: "\u10E4\u10DD\u10E2\u10DD\u10D7\u10D8"
    },
    chip_photo_hint: {
        uk: "\u0404 \u0449\u043E \u043F\u043E\u0434\u0438\u0432\u0438\u0442\u0438\u0441\u044F \u2014 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u044C \u043C\u0456\u0441\u0442\u0438\u0442\u044C \u0437\u043D\u0456\u043C\u043E\u043A",
        en: "There is something to look at \u2014 the answer carries a photo",
        hy: "\u053F\u0561 \u0564\u056B\u057F\u0565\u056C\u0578\u0582 \u0562\u0561\u0576 \u2014 \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0568 \u057A\u0561\u0580\u0578\u0582\u0576\u0561\u056F\u0578\u0582\u0574 \u0567 \u056C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580",
        ka: "\u10D0\u10E0\u10D8\u10E1 \u10E1\u10D0\u10DC\u10D0\u10EE\u10D0\u10D5\u10D8 \u2014 \u10DE\u10D0\u10E1\u10E3\u10EE\u10E1 \u10E4\u10DD\u10E2\u10DD \u10D0\u10EE\u10DA\u10D0\u10D5\u10E1"
    },
    chip_negative: {
        uk: "\u041D\u0435\u0433\u0430\u0442\u0438\u0432\u043D\u0456",
        en: "Negative",
        hy: "\u0532\u0561\u0581\u0561\u057D\u0561\u056F\u0561\u0576",
        ka: "\u10E3\u10D0\u10E0\u10E7\u10DD\u10E4\u10D8\u10D7\u10D8"
    },
    chip_negative_hint: {
        uk: "\u041C\u0435\u0440\u0447\u0435\u043D\u0434\u0430\u0439\u0437\u0435\u0440 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0432 \xab\u043D\u0456\xbb",
        en: "The merchandiser answered no",
        hy: "\u0544\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580\u0568 \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0565\u056C \u0567 \xab\u0578\u0579\xbb",
        ka: "\u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10DB\u10D0 \u10E3\u10DE\u10D0\u10E1\u10E3\u10EE\u10D0 \u201E\u10D0\u10E0\u10D0\u201C"
    },
    /* Columns */ col_point: {
        uk: "\u0422\u043E\u0447\u043A\u0430 \u0456 \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F",
        en: "Point and task",
        hy: "\u053F\u0565\u057F \u0587 \u0561\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8 \u10D3\u10D0 \u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D0"
    },
    col_answer: {
        uk: "\u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u044C",
        en: "Answer",
        hy: "\u054A\u0561\u057F\u0561\u057D\u056D\u0561\u0576",
        ka: "\u10DE\u10D0\u10E1\u10E3\u10EE\u10D8"
    },
    col_by: {
        uk: "\u041C\u0435\u0440\u0447\u0435\u043D\u0434\u0430\u0439\u0437\u0435\u0440",
        en: "Merchandiser",
        hy: "\u0544\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580",
        ka: "\u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D8"
    },
    col_when: {
        uk: "\u041E\u0442\u0440\u0438\u043C\u0430\u043D\u043E",
        en: "Received",
        hy: "\u054D\u057F\u0561\u0581\u057E\u0565\u056C \u0567",
        ka: "\u10DB\u10D8\u10E6\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0"
    },
    ans_yes: {
        uk: "\u0422\u0430\u043A",
        en: "Yes",
        hy: "\u0531\u0575\u0578",
        ka: "\u10D3\u10D8\u10D0\u10EE"
    },
    ans_no: {
        uk: "\u041D\u0456",
        en: "No",
        hy: "\u0548\u0579",
        ka: "\u10D0\u10E0\u10D0"
    },
    ans_photo_only: {
        uk: "\u041B\u0438\u0448\u0435 \u0444\u043E\u0442\u043E",
        en: "Photo only",
        hy: "\u0544\u056B\u0561\u0575\u0576 \u056C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580",
        ka: "\u10DB\u10EE\u10DD\u10DA\u10DD\u10D3 \u10E4\u10DD\u10E2\u10DD"
    },
    photos_count: {
        uk: "\u0424\u043E\u0442\u043E: {n}",
        en: "Photos: {n}",
        hy: "\u053C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580\u0576\u0565\u0580\u055D {n}",
        ka: "\u10E4\u10DD\u10E2\u10DD\u10D4\u10D1\u10D8: {n}"
    },
    search_ph: {
        uk: "\u041F\u043E\u0448\u0443\u043A \u0437\u0430 \u043D\u0430\u0437\u0432\u043E\u044E \u0442\u043E\u0447\u043A\u0438",
        en: "Search by point name",
        hy: "\u0548\u0580\u0578\u0576\u0565\u056C \u0568\u057D\u057F \u056F\u0565\u057F\u056B \u0561\u0576\u057E\u0561\u0576",
        ka: "\u10EB\u10D4\u10D1\u10DC\u10D0 \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8\u10E1 \u10E1\u10D0\u10EE\u10D4\u10DA\u10D8\u10D7"
    },
    rows_per_page: {
        uk: "\u0420\u044F\u0434\u043A\u0456\u0432 \u043D\u0430 \u0441\u0442\u043E\u0440\u0456\u043D\u0446\u0456",
        en: "Rows per page",
        hy: "\u054F\u0578\u0572\u0565\u0580 \u0567\u057B\u0578\u0582\u0574",
        ka: "\u10DB\u10EC\u10D9\u10E0\u10D8\u10D5\u10D8 \u10D2\u10D5\u10D4\u10E0\u10D3\u10D6\u10D4"
    },
    range_of: {
        uk: "{from}\u2013{to} \u0437 {n}",
        en: "{from}\u2013{to} of {n}",
        hy: "{from}\u2013{to} / {n}",
        ka: "{from}\u2013{to} / {n}"
    },
    row_actions: {
        uk: "\u0414\u0456\u0457 \u0437 \u0440\u044F\u0434\u043A\u043E\u043C",
        en: "Row actions",
        hy: "\u054F\u0578\u0572\u056B \u0563\u0578\u0580\u056E\u0578\u0572\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580",
        ka: "\u10DB\u10EC\u10D9\u10E0\u10D8\u10D5\u10D8\u10E1 \u10DB\u10DD\u10E5\u10DB\u10D4\u10D3\u10D4\u10D1\u10D4\u10D1\u10D8"
    },
    open: {
        uk: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438",
        en: "Open",
        hy: "\u0532\u0561\u0581\u0565\u056C",
        ka: "\u10D2\u10D0\u10EE\u10E1\u10DC\u10D0"
    },
    /* Bulk. There is no bulk endpoint, so the selection is the LOADED page — saying otherwise
     would be a lie about scope. Reject is per-record: it needs a reason and a corrective task. */ select_page_hint: {
        uk: "\u0412\u0438\u0431\u0456\u0440 \u0434\u0456\u0454 \u043D\u0430 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u0443 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443",
        en: "Selection covers the loaded page",
        hy: "\u0538\u0576\u057F\u0580\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0568 \u057E\u0565\u0580\u0561\u0562\u0565\u0580\u0578\u0582\u0574 \u0567 \u0562\u0565\u057C\u0576\u057E\u0561\u056E \u0567\u057B\u056B\u0576",
        ka: "\u10D0\u10E0\u10E9\u10D4\u10D5\u10D0\u10DC\u10D8 \u10DB\u10DD\u10E5\u10DB\u10D4\u10D3\u10D4\u10D1\u10E1 \u10E9\u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10E3\u10DA \u10D2\u10D5\u10D4\u10E0\u10D3\u10D6\u10D4"
    },
    approved_msg: {
        uk: "\u041F\u0440\u0438\u0439\u043D\u044F\u0442\u043E: {n}",
        en: "Approved: {n}",
        hy: "\u0538\u0576\u0564\u0578\u0582\u0576\u057E\u0561\u056E \u0567\u055D {n}",
        ka: "\u10DB\u10D8\u10E6\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0: {n}"
    },
    failed_msg: {
        uk: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u043E\u043D\u043E\u0432\u0438\u0442\u0438: {n}",
        en: "Failed to update: {n}",
        hy: "\u0549\u0570\u0561\u057B\u0578\u0572\u057E\u0565\u0581 \u0569\u0561\u0580\u0574\u0561\u0581\u0576\u0565\u056C\u055D {n}",
        ka: "\u10D2\u10D0\u10DC\u10D0\u10EE\u10DA\u10D4\u10D1\u10D0 \u10D5\u10D4\u10E0 \u10DB\u10DD\u10EE\u10D4\u10E0\u10EE\u10D3\u10D0: {n}"
    },
    empty_title: {
        uk: "\u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0435\u0439 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
        en: "No answers found",
        hy: "\u054A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0576\u0565\u0580 \u0579\u0565\u0576 \u0563\u057F\u0576\u057E\u0565\u056C",
        ka: "\u10DE\u10D0\u10E1\u10E3\u10EE\u10D4\u10D1\u10D8 \u10D0\u10E0 \u10DB\u10DD\u10D8\u10EB\u10D4\u10D1\u10DC\u10D0"
    },
    empty_desc: {
        uk: "\u0416\u043E\u0434\u043D\u0430 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u044C \u043D\u0435 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0430\u0454 \u043F\u043E\u0442\u043E\u0447\u043D\u0438\u043C \u0444\u0456\u043B\u044C\u0442\u0440\u0430\u043C.",
        en: "No answers match the current filters.",
        hy: "\u0548\u0579 \u0574\u056B \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576 \u0579\u056B \u0570\u0561\u0574\u0561\u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0578\u0582\u0574 \u0568\u0576\u0569\u0561\u0581\u056B\u056F \u0566\u057F\u056B\u0579\u0576\u0565\u0580\u056B\u0576\u0589",
        ka: "\u10D0\u10E0\u10EA\u10D4\u10E0\u10D7\u10D8 \u10DE\u10D0\u10E1\u10E3\u10EE\u10D8 \u10D0\u10E0 \u10D4\u10DB\u10D7\u10EE\u10D5\u10D4\u10D5\u10D0 \u10DB\u10D8\u10DB\u10D3\u10D8\u10DC\u10D0\u10E0\u10D4 \u10E4\u10D8\u10DA\u10E2\u10E0\u10D4\u10D1\u10E1."
    }
};
const $fc3f36407bc5ec6c$export$4a057643b4c36045 = {
    crumb: {
        uk: "\u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0456",
        en: "Answers",
        hy: "\u054A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0576\u0565\u0580",
        ka: "\u10DE\u10D0\u10E1\u10E3\u10EE\u10D4\u10D1\u10D8"
    },
    back_to_list: {
        uk: "\u0414\u043E \u0441\u043F\u0438\u0441\u043A\u0443 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0435\u0439",
        en: "Back to answers",
        hy: "\u054E\u0565\u0580\u0561\u0564\u0561\u057C\u0576\u0561\u056C \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0576\u0565\u0580\u056B\u0576",
        ka: "\u10DE\u10D0\u10E1\u10E3\u10EE\u10D4\u10D1\u10E8\u10D8 \u10D3\u10D0\u10D1\u10E0\u10E3\u10DC\u10D4\u10D1\u10D0"
    },
    /* The queue position. One string per locale so the number never has to agree with a noun. */ queue_of: {
        uk: "{i} \u0437 {n}",
        en: "{i} of {n}",
        hy: "{i} / {n}",
        ka: "{i} / {n}"
    },
    queue_prev: {
        uk: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u044F",
        en: "Previous",
        hy: "\u0546\u0561\u056D\u0578\u0580\u0564\u0568",
        ka: "\u10EC\u10D8\u10DC\u10D0"
    },
    queue_next: {
        uk: "\u041D\u0430\u0441\u0442\u0443\u043F\u043D\u0430",
        en: "Next",
        hy: "\u0540\u0561\u057B\u0578\u0580\u0564\u0568",
        ka: "\u10E8\u10D4\u10DB\u10D3\u10D4\u10D2\u10D8"
    },
    queue_end: {
        uk: "\u0426\u0435 \u043E\u0441\u0442\u0430\u043D\u043D\u044F \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u044C \u0443 \u0447\u0435\u0440\u0437\u0456",
        en: "That is the last answer in the queue",
        hy: "\u054D\u0561 \u0570\u0565\u0580\u0569\u056B \u057E\u0565\u0580\u057B\u056B\u0576 \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0576 \u0567",
        ka: "\u10D4\u10E1 \u10E0\u10D8\u10D2\u10E8\u10D8 \u10D1\u10DD\u10DA\u10DD \u10DE\u10D0\u10E1\u10E3\u10EE\u10D8\u10D0"
    },
    photo_of: {
        uk: "{i} \u0437 {n}",
        en: "{i} of {n}",
        hy: "{i} / {n}",
        ka: "{i} / {n}"
    },
    photo_prev: {
        uk: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u0454 \u0444\u043E\u0442\u043E",
        en: "Previous photo",
        hy: "\u0546\u0561\u056D\u0578\u0580\u0564 \u056C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580\u0568",
        ka: "\u10EC\u10D8\u10DC\u10D0 \u10E4\u10DD\u10E2\u10DD"
    },
    photo_next: {
        uk: "\u041D\u0430\u0441\u0442\u0443\u043F\u043D\u0435 \u0444\u043E\u0442\u043E",
        en: "Next photo",
        hy: "\u0540\u0561\u057B\u0578\u0580\u0564 \u056C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580\u0568",
        ka: "\u10E8\u10D4\u10DB\u10D3\u10D4\u10D2\u10D8 \u10E4\u10DD\u10E2\u10DD"
    },
    sec_photos: {
        uk: "\u0424\u043E\u0442\u043E",
        en: "Photos",
        hy: "\u053C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580\u0576\u0565\u0580",
        ka: "\u10E4\u10DD\u10E2\u10DD\u10D4\u10D1\u10D8"
    },
    sec_task: {
        uk: "\u0417\u0430\u0432\u0434\u0430\u043D\u043D\u044F",
        en: "Task",
        hy: "\u0531\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584",
        ka: "\u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D0"
    },
    /* The answer is a response to a task; deciding it often needs what was actually asked for. */ open_task: {
        uk: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F",
        en: "Open task",
        hy: "\u0532\u0561\u0581\u0565\u056C \u0561\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0568",
        ka: "\u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10EE\u10E1\u10DC\u10D0"
    },
    sec_response: {
        uk: "\u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u044C",
        en: "Answer",
        hy: "\u054A\u0561\u057F\u0561\u057D\u056D\u0561\u0576",
        ka: "\u10DE\u10D0\u10E1\u10E3\u10EE\u10D8"
    },
    k_title: {
        uk: "\u041D\u0430\u0437\u0432\u0430",
        en: "Title",
        hy: "\u0531\u0576\u057E\u0561\u0576\u0578\u0582\u0574",
        ka: "\u10E1\u10D0\u10EE\u10D4\u10DA\u10D8"
    },
    k_point: {
        uk: "\u0422\u043E\u0447\u043A\u0430",
        en: "Point",
        hy: "\u053F\u0565\u057F",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8"
    },
    k_priority: {
        uk: "\u041F\u0440\u0456\u043E\u0440\u0438\u0442\u0435\u0442",
        en: "Priority",
        hy: "\u0531\u057C\u0561\u057B\u0576\u0561\u0570\u0565\u0580\u0569\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10DE\u10E0\u10D8\u10DD\u10E0\u10D8\u10E2\u10D4\u10E2\u10D8"
    },
    k_deadline: {
        uk: "\u0414\u0435\u0434\u043B\u0430\u0439\u043D",
        en: "Deadline",
        hy: "\u054E\u0565\u0580\u057B\u0576\u0561\u056A\u0561\u0574\u056F\u0565\u057F",
        ka: "\u10D1\u10DD\u10DA\u10DD \u10D5\u10D0\u10D3\u10D0"
    },
    k_description: {
        uk: "\u041E\u043F\u0438\u0441",
        en: "Description",
        hy: "\u0546\u056F\u0561\u0580\u0561\u0563\u0580\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10D0\u10E6\u10EC\u10D4\u10E0\u10D0"
    },
    k_tags: {
        uk: "\u0422\u0435\u0433\u0438",
        en: "Tags",
        hy: "\u054A\u056B\u057F\u0561\u056F\u0576\u0565\u0580",
        ka: "\u10E2\u10D4\u10D2\u10D4\u10D1\u10D8"
    },
    k_by: {
        uk: "\u041C\u0435\u0440\u0447\u0435\u043D\u0434\u0430\u0439\u0437\u0435\u0440",
        en: "Merchandiser",
        hy: "\u0544\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580",
        ka: "\u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D8"
    },
    k_supervisor: {
        uk: "\u0421\u0443\u043F\u0435\u0440\u0432\u0430\u0439\u0437\u0435\u0440",
        en: "Supervisor",
        hy: "\u054D\u0578\u0582\u057A\u0565\u0580\u057E\u0561\u0575\u0566\u0565\u0580",
        ka: "\u10E1\u10E3\u10DE\u10D4\u10E0\u10D5\u10D0\u10D8\u10D6\u10D4\u10E0\u10D8"
    },
    k_when: {
        uk: "\u041E\u0442\u0440\u0438\u043C\u0430\u043D\u043E",
        en: "Received",
        hy: "\u054D\u057F\u0561\u0581\u057E\u0565\u056C \u0567",
        ka: "\u10DB\u10D8\u10E6\u10D4\u10D1\u10E3\u10DA\u10D8\u10D0"
    },
    k_text: {
        uk: "\u0422\u0435\u043A\u0441\u0442 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0456",
        en: "Answer text",
        hy: "\u054A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u056B \u057F\u0565\u0584\u057D\u057F",
        ka: "\u10DE\u10D0\u10E1\u10E3\u10EE\u10D8\u10E1 \u10E2\u10D4\u10E5\u10E1\u10E2\u10D8"
    },
    k_boolean: {
        uk: "\u0422\u0430\u043A / \u041D\u0456",
        en: "Yes / No",
        hy: "\u0531\u0575\u0578 / \u0548\u0579",
        ka: "\u10D3\u10D8\u10D0\u10EE / \u10D0\u10E0\u10D0"
    },
    k_visit: {
        uk: "\u0412\u0456\u0437\u0438\u0442",
        en: "Visit",
        hy: "\u0531\u0575\u0581",
        ka: "\u10D5\u10D8\u10D6\u10D8\u10E2\u10D8"
    },
    k_verdict_comment: {
        uk: "\u041F\u0440\u0438\u0447\u0438\u043D\u0430 \u0432\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043D\u044F",
        en: "Rejection reason",
        hy: "\u0544\u0565\u0580\u056A\u0574\u0561\u0576 \u057A\u0561\u057F\u0573\u0561\u057C",
        ka: "\u10E3\u10D0\u10E0\u10E7\u10DD\u10E4\u10D8\u10E1 \u10DB\u10D8\u10D6\u10D4\u10D6\u10D8"
    },
    yes: {
        uk: "\u0422\u0430\u043A",
        en: "Yes",
        hy: "\u0531\u0575\u0578",
        ka: "\u10D3\u10D8\u10D0\u10EE"
    },
    no: {
        uk: "\u041D\u0456",
        en: "No",
        hy: "\u0548\u0579",
        ka: "\u10D0\u10E0\u10D0"
    },
    no_photos: {
        uk: "\u0411\u0435\u0437 \u0444\u043E\u0442\u043E",
        en: "No photos",
        hy: "\u0531\u057C\u0561\u0576\u0581 \u056C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580\u056B",
        ka: "\u10E4\u10DD\u10E2\u10DD\u10E1 \u10D2\u10D0\u10E0\u10D4\u10E8\u10D4"
    },
    /* Keyboard help, shown once under the queue stepper. */ keys_hint: {
        uk: "[ \u0456 ] \u2014 \u043F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u044F \u0442\u0430 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0430",
        en: "[ and ] \u2014 previous and next",
        hy: "[ \u0587 ] \u2014 \u0576\u0561\u056D\u0578\u0580\u0564\u0568 \u0587 \u0570\u0561\u057B\u0578\u0580\u0564\u0568",
        ka: "[ \u10D3\u10D0 ] \u2014 \u10EC\u10D8\u10DC\u10D0 \u10D3\u10D0 \u10E8\u10D4\u10DB\u10D3\u10D4\u10D2\u10D8"
    },
    not_found_title: {
        uk: "\u041D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
        en: "Not found",
        hy: "\u0549\u056B \u0563\u057F\u0576\u057E\u0565\u056C",
        ka: "\u10D0\u10E0 \u10DB\u10DD\u10D8\u10EB\u10D4\u10D1\u10DC\u10D0"
    },
    not_found_desc: {
        uk: "\u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u044C \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u0430 \u0430\u0431\u043E \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u0430.",
        en: "Answer not found or deleted.",
        hy: "\u054A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0568 \u0579\u056B \u0563\u057F\u0576\u057E\u0565\u056C \u056F\u0561\u0574 \u057B\u0576\u057B\u057E\u0561\u056E \u0567\u0589",
        ka: "\u10DE\u10D0\u10E1\u10E3\u10EE\u10D8 \u10D5\u10D4\u10E0 \u10DB\u10DD\u10D8\u10EB\u10D4\u10D1\u10DC\u10D0 \u10D0\u10DC \u10EC\u10D0\u10E8\u10DA\u10D8\u10DA\u10D8\u10D0."
    },
    load_error: {
        uk: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438",
        en: "Could not load",
        hy: "\u0549\u0570\u0561\u057B\u0578\u0572\u057E\u0565\u0581 \u0562\u0565\u057C\u0576\u0565\u056C",
        ka: "\u10E9\u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D0 \u10D5\u10D4\u10E0 \u10DB\u10DD\u10EE\u10D4\u10E0\u10EE\u10D3\u10D0"
    },
    retry: {
        uk: "\u0421\u043F\u0440\u043E\u0431\u0443\u0432\u0430\u0442\u0438 \u0449\u0435",
        en: "Try again",
        hy: "\u053F\u0580\u056F\u056B\u0576 \u0583\u0578\u0580\u0571\u0565\u056C",
        ka: "\u10EE\u10D4\u10DA\u10D0\u10EE\u10DA\u10D0 \u10EA\u10D3\u10D0"
    }
};
const $fc3f36407bc5ec6c$export$a763edbf796b780a = {
    /* ---------------------------------------------------------------- page */ page_title: {
        uk: "\u0406\u043C\u043F\u043E\u0440\u0442",
        en: "Import",
        hy: "\u0546\u0565\u0580\u0574\u0578\u0582\u056E\u0578\u0582\u0574",
        ka: "\u10D8\u10DB\u10DE\u10DD\u10E0\u10E2\u10D8"
    },
    page_sub: {
        uk: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u043D\u044F \u0437\u0430\u0432\u0434\u0430\u043D\u044C \u0456 \u0430\u0441\u043E\u0440\u0442\u0438\u043C\u0435\u043D\u0442\u043D\u0438\u0445 \u043C\u0430\u0442\u0440\u0438\u0446\u044C \u043F\u0430\u043A\u0435\u0442\u043E\u043C \u0456\u0437 \u0444\u0430\u0439\u043B\u0443.",
        en: "Create tasks and assortment matrices in bulk from a file.",
        hy: "\u054D\u057F\u0565\u0572\u056E\u0565\u0584 \u0561\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0576\u0565\u0580 \u0587 \u057F\u0565\u057D\u0561\u056F\u0561\u0576\u0578\u0582 \u0574\u0561\u057F\u0580\u056B\u0581\u0576\u0565\u0580 \u056D\u0574\u0562\u0561\u0584\u0561\u0576\u0561\u056F\u0578\u057E\u055D \u0586\u0561\u0575\u056C\u056B\u0581\u0589",
        ka: "\u10E8\u10D4\u10E5\u10DB\u10D4\u10DC\u10D8\u10D7 \u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8 \u10D3\u10D0 \u10D0\u10E1\u10DD\u10E0\u10E2\u10D8\u10DB\u10D4\u10DC\u10E2\u10D8\u10E1 \u10DB\u10D0\u10E2\u10E0\u10D8\u10EA\u10D4\u10D1\u10D8 \u10D4\u10E0\u10D7\u10D8\u10D0\u10DC\u10D0\u10D3 \u10E4\u10D0\u10D8\u10DA\u10D8\u10D3\u10D0\u10DC."
    },
    to_uploads: {
        uk: "\u041C\u043E\u0457 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F",
        en: "My uploads",
        hy: "\u053B\u0574 \u0576\u0565\u0580\u0562\u0565\u057C\u0576\u0578\u0582\u0574\u0576\u0565\u0580\u0568",
        ka: "\u10E9\u10D4\u10DB\u10D8 \u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D4\u10D1\u10D8"
    },
    /* ---------------------------------------------------------------- kinds */ kind_label: {
        uk: "\u0429\u043E \u0456\u043C\u043F\u043E\u0440\u0442\u0443\u0454\u043C\u043E",
        en: "What are you importing",
        hy: "\u053B\u055E\u0576\u0579 \u0565\u0584 \u0576\u0565\u0580\u0574\u0578\u0582\u056E\u0578\u0582\u0574",
        ka: "\u10E0\u10D0\u10E1 \u10D0\u10D8\u10DB\u10DE\u10DD\u10E0\u10E2\u10D4\u10D1\u10D7"
    },
    kind_tasks: {
        uk: "\u0417\u0430\u0432\u0434\u0430\u043D\u043D\u044F",
        en: "Tasks",
        hy: "\u0531\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0576\u0565\u0580",
        ka: "\u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8"
    },
    kind_tasks_desc: {
        uk: "\u0423\u0441\u0456 \u0437\u0430\u0432\u0434\u0430\u043D\u043D\u044F \u0437 \u0444\u0430\u0439\u043B\u0443 \u043E\u0442\u0440\u0438\u043C\u0430\u044E\u0442\u044C \u043E\u0434\u043D\u0443 \u0442\u043E\u0447\u043A\u0443 \u0430\u0431\u043E \u043E\u0434\u043D\u0443 \u043C\u0435\u0440\u0435\u0436\u0443, \u0432\u0438\u0431\u0440\u0430\u043D\u0443 \u043D\u0438\u0436\u0447\u0435.",
        en: "Every task in the file goes to the one point or network you pick below.",
        hy: "\u0556\u0561\u0575\u056C\u056B \u0562\u0578\u056C\u0578\u0580 \u0561\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0576\u0565\u0580\u0568 \u056F\u057D\u057F\u0561\u0576\u0561\u0576 \u0576\u0565\u0580\u0584\u0587\u0578\u0582\u0574 \u0568\u0576\u057F\u0580\u057E\u0561\u056E \u0574\u0565\u056F \u056F\u0565\u057F\u0568 \u056F\u0561\u0574 \u0574\u0565\u056F \u0581\u0561\u0576\u0581\u0568\u0589",
        ka: "\u10E4\u10D0\u10D8\u10DA\u10D8\u10E1 \u10E7\u10D5\u10D4\u10DA\u10D0 \u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D0 \u10DB\u10D8\u10D4\u10DC\u10D8\u10ED\u10D4\u10D1\u10D0 \u10E5\u10D5\u10D4\u10DB\u10DD\u10D7 \u10D0\u10E0\u10E9\u10D4\u10E3\u10DA \u10D4\u10E0\u10D7 \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10E1 \u10D0\u10DC \u10D4\u10E0\u10D7 \u10E5\u10E1\u10D4\u10DA\u10E1."
    },
    kind_tasks_by_row: {
        uk: "\u0417\u0430\u0432\u0434\u0430\u043D\u043D\u044F \u0437 \u0442\u043E\u0447\u043A\u043E\u044E \u0432 \u0440\u044F\u0434\u043A\u0443",
        en: "Tasks with a point per row",
        hy: "\u0531\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0576\u0565\u0580\u055D \u056F\u0565\u057F\u0568 \u057F\u0578\u0572\u0578\u0582\u0574",
        ka: "\u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8 \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8\u10D7 \u10D7\u10D8\u10D7\u10DD \u10DB\u10EC\u10D9\u10E0\u10D8\u10D5\u10E8\u10D8"
    },
    kind_tasks_by_row_desc: {
        uk: "\u041A\u043E\u0436\u0435\u043D \u0440\u044F\u0434\u043E\u043A \u0444\u0430\u0439\u043B\u0443 \u043D\u0435\u0441\u0435 \u0432\u043B\u0430\u0441\u043D\u0438\u0439 \u043A\u043E\u0434 \u0442\u043E\u0447\u043A\u0438 \u0430\u0431\u043E \u043C\u0435\u0440\u0435\u0436\u0456.",
        en: "Each row of the file carries its own point or network code.",
        hy: "\u0556\u0561\u0575\u056C\u056B \u0575\u0578\u0582\u0580\u0561\u0584\u0561\u0576\u0579\u0575\u0578\u0582\u0580 \u057F\u0578\u0572 \u056F\u0580\u0578\u0582\u0574 \u0567 \u056B\u0580 \u056F\u0565\u057F\u056B \u056F\u0561\u0574 \u0581\u0561\u0576\u0581\u056B \u056F\u0578\u0564\u0568\u0589",
        ka: "\u10E4\u10D0\u10D8\u10DA\u10D8\u10E1 \u10D7\u10D8\u10D7\u10DD\u10D4\u10E3\u10DA\u10D8 \u10DB\u10EC\u10D9\u10E0\u10D8\u10D5\u10D8 \u10E8\u10D4\u10D8\u10EA\u10D0\u10D5\u10E1 \u10E1\u10D0\u10D9\u10E3\u10D7\u10D0\u10E0 \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8\u10E1 \u10D0\u10DC \u10E5\u10E1\u10D4\u10DA\u10D8\u10E1 \u10D9\u10DD\u10D3\u10E1."
    },
    kind_matrix: {
        uk: "\u0410\u0441\u043E\u0440\u0442\u0438\u043C\u0435\u043D\u0442\u043D\u0430 \u043C\u0430\u0442\u0440\u0438\u0446\u044F",
        en: "Assortment matrix",
        hy: "\u054F\u0565\u057D\u0561\u056F\u0561\u0576\u0578\u0582 \u0574\u0561\u057F\u0580\u056B\u0581",
        ka: "\u10D0\u10E1\u10DD\u10E0\u10E2\u10D8\u10DB\u10D4\u10DC\u10E2\u10D8\u10E1 \u10DB\u10D0\u10E2\u10E0\u10D8\u10EA\u10D0"
    },
    kind_matrix_desc: {
        uk: "\u0421\u0456\u0442\u043A\u0430: \u043A\u043E\u0434\u0438 \u0442\u043E\u0447\u043E\u043A \u0443 \u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043A\u0443, \u043A\u043E\u0434\u0438 \u0442\u043E\u0432\u0430\u0440\u0456\u0432 \u0443 \u043F\u0435\u0440\u0448\u043E\u043C\u0443 \u0441\u0442\u043E\u0432\u043F\u0446\u0456, \u043F\u043E\u0437\u043D\u0430\u0447\u043A\u0430 \u043D\u0430 \u043F\u0435\u0440\u0435\u0442\u0438\u043D\u0456.",
        en: "A grid: point codes across the top, product codes down the first column, a mark where they meet.",
        hy: "\u0551\u0561\u0576\u0581\u055D \u056F\u0565\u057F\u0565\u0580\u056B \u056F\u0578\u0564\u0565\u0580\u0568 \u057E\u0565\u0580\u0587\u0578\u0582\u0574, \u0561\u057A\u0580\u0561\u0576\u0584\u0576\u0565\u0580\u056B \u056F\u0578\u0564\u0565\u0580\u0568 \u0561\u057C\u0561\u057B\u056B\u0576 \u057D\u0575\u0578\u0582\u0576\u0561\u056F\u0578\u0582\u0574, \u0576\u0577\u0561\u0576\u055D \u0570\u0561\u057F\u0574\u0561\u0576 \u056F\u0565\u057F\u0578\u0582\u0574\u0589",
        ka: "\u10D1\u10D0\u10D3\u10D4: \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1 \u10D9\u10DD\u10D3\u10D4\u10D1\u10D8 \u10D6\u10D4\u10DB\u10DD\u10D7, \u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10E2\u10D4\u10D1\u10D8\u10E1 \u10D9\u10DD\u10D3\u10D4\u10D1\u10D8 \u10DE\u10D8\u10E0\u10D5\u10D4\u10DA \u10E1\u10D5\u10D4\u10E2\u10E8\u10D8, \u10DC\u10D8\u10E8\u10D0\u10DC\u10D8 \u10D2\u10D0\u10D3\u10D0\u10D9\u10D5\u10D4\u10D7\u10D0\u10D6\u10D4."
    },
    /* ------------------------------------------------------------- sections */ sec_batch: {
        uk: "\u041F\u0430\u043A\u0435\u0442",
        en: "Batch",
        hy: "\u053D\u0574\u0562\u0561\u0584\u0561\u0576\u0561\u056F",
        ka: "\u10DE\u10D0\u10D9\u10D4\u10E2\u10D8"
    },
    sec_batch_desc: {
        uk: "\u041D\u0430\u0437\u0432\u0430, \u043F\u0456\u0434 \u044F\u043A\u043E\u044E \u0446\u0435\u0439 \u0456\u043C\u043F\u043E\u0440\u0442 \u0437\u2019\u044F\u0432\u0438\u0442\u044C\u0441\u044F \u0443 \xab\u041C\u043E\u0457\u0445 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F\u0445\xbb.",
        en: "The name this import will appear under in My uploads.",
        hy: "\u0531\u0576\u0578\u0582\u0576\u0568, \u0578\u0580\u0578\u057E \u0561\u0575\u057D \u0576\u0565\u0580\u0574\u0578\u0582\u056E\u0578\u0582\u0574\u0568 \u056F\u0570\u0561\u0575\u057F\u0576\u057E\u056B \xab\u053B\u0574 \u0576\u0565\u0580\u0562\u0565\u057C\u0576\u0578\u0582\u0574\u0576\u0565\u0580\u0578\u0582\u0574\xbb\u0589",
        ka: "\u10E1\u10D0\u10EE\u10D4\u10DA\u10D8, \u10E0\u10DD\u10DB\u10DA\u10D8\u10D7\u10D0\u10EA \u10D4\u10E1 \u10D8\u10DB\u10DE\u10DD\u10E0\u10E2\u10D8 \u10D2\u10D0\u10DB\u10DD\u10E9\u10DC\u10D3\u10D4\u10D1\u10D0 \u201E\u10E9\u10D4\u10DB\u10E1 \u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D4\u10D1\u10E8\u10D8\u201C."
    },
    sec_scope: {
        uk: "\u041A\u0443\u0434\u0438",
        en: "Where to",
        hy: "\u0548\u0582\u0580",
        ka: "\u10E1\u10D0\u10D3"
    },
    sec_scope_desc: {
        uk: "\u041E\u0434\u043D\u0430 \u0442\u043E\u0447\u043A\u0430 \u0430\u0431\u043E \u043E\u0434\u043D\u0430 \u043C\u0435\u0440\u0435\u0436\u0430 \u043D\u0430 \u0432\u0435\u0441\u044C \u043F\u0430\u043A\u0435\u0442.",
        en: "One point or one network, for the whole batch.",
        hy: "\u0544\u0565\u056F \u056F\u0565\u057F \u056F\u0561\u0574 \u0574\u0565\u056F \u0581\u0561\u0576\u0581\u055D \u0561\u0574\u0562\u0578\u0572\u057B \u056D\u0574\u0562\u0561\u0584\u0561\u0576\u0561\u056F\u056B \u0570\u0561\u0574\u0561\u0580\u0589",
        ka: "\u10D4\u10E0\u10D7\u10D8 \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8 \u10D0\u10DC \u10D4\u10E0\u10D7\u10D8 \u10E5\u10E1\u10D4\u10DA\u10D8 \u10DB\u10D7\u10D4\u10DA\u10D8 \u10DE\u10D0\u10D9\u10D4\u10E2\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1."
    },
    sec_file: {
        uk: "\u0424\u0430\u0439\u043B",
        en: "File",
        hy: "\u0556\u0561\u0575\u056C",
        ka: "\u10E4\u10D0\u10D8\u10DA\u10D8"
    },
    sec_rows: {
        uk: "\u0420\u044F\u0434\u043A\u0438",
        en: "Rows",
        hy: "\u054F\u0578\u0572\u0565\u0580",
        ka: "\u10DB\u10EC\u10D9\u10E0\u10D8\u10D5\u10D4\u10D1\u10D8"
    },
    sec_rows_desc: {
        uk: "\u041F\u0435\u0440\u0435\u0432\u0456\u0440\u0442\u0435 \u043F\u0435\u0440\u0435\u0434 \u0456\u043C\u043F\u043E\u0440\u0442\u043E\u043C. \u041D\u0430\u0434\u0441\u0438\u043B\u0430\u044E\u0442\u044C\u0441\u044F \u043B\u0438\u0448\u0435 \u0440\u044F\u0434\u043A\u0438 \u0431\u0435\u0437 \u043F\u0440\u043E\u0431\u043B\u0435\u043C.",
        en: "Check before importing. Only rows without problems are sent.",
        hy: "\u054D\u057F\u0578\u0582\u0563\u0565\u0584 \u0576\u0561\u056D\u0584\u0561\u0576 \u0576\u0565\u0580\u0574\u0578\u0582\u056E\u0578\u0582\u0574\u0568\u0589 \u0548\u0582\u0572\u0561\u0580\u056F\u057E\u0578\u0582\u0574 \u0565\u0576 \u0574\u056B\u0561\u0575\u0576 \u0561\u057C\u0561\u0576\u0581 \u056D\u0576\u0564\u056B\u0580\u0576\u0565\u0580\u056B \u057F\u0578\u0572\u0565\u0580\u0568\u0589",
        ka: "\u10E8\u10D4\u10D0\u10DB\u10DD\u10EC\u10DB\u10D4\u10D7 \u10D8\u10DB\u10DE\u10DD\u10E0\u10E2\u10D0\u10DB\u10D3\u10D4. \u10D8\u10D2\u10D6\u10D0\u10D5\u10DC\u10D4\u10D1\u10D0 \u10DB\u10EE\u10DD\u10DA\u10DD\u10D3 \u10DE\u10E0\u10DD\u10D1\u10DA\u10D4\u10DB\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10E0\u10D4\u10E8\u10D4 \u10DB\u10EC\u10D9\u10E0\u10D8\u10D5\u10D4\u10D1\u10D8."
    },
    /* --------------------------------------------------------------- fields */ f_name: {
        uk: "\u041D\u0430\u0437\u0432\u0430 \u043F\u0430\u043A\u0435\u0442\u0430",
        en: "Batch name",
        hy: "\u053D\u0574\u0562\u0561\u0584\u0561\u0576\u0561\u056F\u056B \u0561\u0576\u0578\u0582\u0576",
        ka: "\u10DE\u10D0\u10D9\u10D4\u10E2\u10D8\u10E1 \u10E1\u10D0\u10EE\u10D4\u10DA\u10D8"
    },
    f_name_ph: {
        uk: "\u041D\u0430\u043F\u0440\u0438\u043A\u043B\u0430\u0434, \u0412\u0435\u0440\u0435\u0441\u0435\u043D\u044C \u2014 \u043C\u0435\u0440\u0435\u0436\u0430 \u0410\u0422\u0411",
        en: "For example, September \u2014 ATB network",
        hy: "\u0555\u0580\u056B\u0576\u0561\u056F\u055D \u054D\u0565\u057A\u057F\u0565\u0574\u0562\u0565\u0580 \u2014 ATB \u0581\u0561\u0576\u0581",
        ka: "\u10DB\u10D0\u10D2\u10D0\u10DA\u10D8\u10D7\u10D0\u10D3, \u10E1\u10D4\u10E5\u10E2\u10D4\u10DB\u10D1\u10D4\u10E0\u10D8 \u2014 ATB \u10E5\u10E1\u10D4\u10DA\u10D8"
    },
    f_scope_type: {
        uk: "\u0422\u0438\u043F",
        en: "Type",
        hy: "\u054F\u0565\u057D\u0561\u056F",
        ka: "\u10E2\u10D8\u10DE\u10D8"
    },
    scope_network: {
        uk: "\u041C\u0435\u0440\u0435\u0436\u0430",
        en: "Network",
        hy: "\u0551\u0561\u0576\u0581",
        ka: "\u10E5\u10E1\u10D4\u10DA\u10D8"
    },
    scope_point: {
        uk: "\u0422\u043E\u0447\u043A\u0430",
        en: "Point",
        hy: "\u053F\u0565\u057F",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8"
    },
    /* --------------------------------------------------------------- upload */ drop_hint: {
        uk: "\u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C \u0430\u0431\u043E \u043F\u0435\u0440\u0435\u0442\u044F\u0433\u043D\u0456\u0442\u044C \u0444\u0430\u0439\u043B \u0441\u044E\u0434\u0438",
        en: "Click or drag a file here",
        hy: "\u054D\u0565\u0572\u0574\u0565\u0584 \u056F\u0561\u0574 \u0584\u0561\u0577\u0565\u0584 \u0586\u0561\u0575\u056C\u0568 \u0561\u0575\u057D\u057F\u0565\u0572",
        ka: "\u10D3\u10D0\u10D0\u10ED\u10D8\u10E0\u10D4\u10D7 \u10D0\u10DC \u10D2\u10D0\u10D3\u10DB\u10DD\u10D8\u10E2\u10D0\u10DC\u10D4\u10D7 \u10E4\u10D0\u10D8\u10DA\u10D8 \u10D0\u10E5"
    },
    drop_sub: {
        uk: "\u041E\u0434\u0438\u043D \u0444\u0430\u0439\u043B .csv \u0430\u0431\u043E .xlsx",
        en: "One .csv or .xlsx file",
        hy: "\u0544\u0565\u056F .csv \u056F\u0561\u0574 .xlsx \u0586\u0561\u0575\u056C",
        ka: "\u10D4\u10E0\u10D7\u10D8 .csv \u10D0\u10DC .xlsx \u10E4\u10D0\u10D8\u10DA\u10D8"
    },
    file_remove: {
        uk: "\u041F\u0440\u0438\u0431\u0440\u0430\u0442\u0438 \u0444\u0430\u0439\u043B",
        en: "Remove file",
        hy: "\u0540\u0565\u057C\u0561\u0581\u0576\u0565\u056C \u0586\u0561\u0575\u056C\u0568",
        ka: "\u10E4\u10D0\u10D8\u10DA\u10D8\u10E1 \u10DB\u10DD\u10E8\u10DD\u10E0\u10D4\u10D1\u10D0"
    },
    download_template: {
        uk: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0448\u0430\u0431\u043B\u043E\u043D",
        en: "Download template",
        hy: "\u0546\u0565\u0580\u0562\u0565\u057C\u0576\u0565\u056C \u0571\u0587\u0561\u0576\u0574\u0578\u0582\u0577\u0568",
        ka: "\u10E8\u10D0\u10D1\u10DA\u10DD\u10DC\u10D8\u10E1 \u10E9\u10D0\u10DB\u10DD\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D0"
    },
    expected_columns: {
        uk: "\u041E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u0456 \u0441\u0442\u043E\u0432\u043F\u0446\u0456",
        en: "Expected columns",
        hy: "\u054D\u057A\u0561\u057D\u057E\u0578\u0572 \u057D\u0575\u0578\u0582\u0576\u0561\u056F\u0576\u0565\u0580",
        ka: "\u10DB\u10DD\u10E1\u10D0\u10DA\u10DD\u10D3\u10DC\u10D4\u10DA\u10D8 \u10E1\u10D5\u10D4\u10E2\u10D4\u10D1\u10D8"
    },
    date_format_hint: {
        uk: "\u0414\u0430\u0442\u0438 \u0443 \u0444\u043E\u0440\u043C\u0430\u0442\u0456 {f}",
        en: "Dates in {f} format",
        hy: "\u0531\u0574\u057D\u0561\u0569\u057E\u0565\u0580\u0568 {f} \u0571\u0587\u0561\u0579\u0561\u0583\u0578\u057E",
        ka: "\u10D7\u10D0\u10E0\u10D8\u10E6\u10D4\u10D1\u10D8 {f} \u10E4\u10DD\u10E0\u10DB\u10D0\u10E2\u10E8\u10D8"
    },
    reading: {
        uk: "\u0427\u0438\u0442\u0430\u0454\u043C\u043E \u0444\u0430\u0439\u043B\u2026",
        en: "Reading the file\u2026",
        hy: "\u053F\u0561\u0580\u0564\u0578\u0582\u0574 \u0565\u0576\u0584 \u0586\u0561\u0575\u056C\u0568\u2026",
        ka: "\u10E4\u10D0\u10D8\u10DA\u10D8\u10E1 \u10EC\u10D0\u10D9\u10D8\u10D7\u10EE\u10D5\u10D0\u2026"
    },
    read_error: {
        uk: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u0442\u0438 \u0446\u0435\u0439 \u0444\u0430\u0439\u043B. \u041F\u0435\u0440\u0435\u0432\u0456\u0440\u0442\u0435, \u0449\u043E \u0446\u0435 .csv \u0430\u0431\u043E .xlsx.",
        en: "Could not read this file. Check that it is a .csv or .xlsx.",
        hy: "\u0549\u0570\u0561\u057B\u0578\u0572\u057E\u0565\u0581 \u056F\u0561\u0580\u0564\u0561\u056C \u0561\u0575\u057D \u0586\u0561\u0575\u056C\u0568\u0589 \u054D\u057F\u0578\u0582\u0563\u0565\u0584, \u0578\u0580 \u0561\u0575\u0576 .csv \u056F\u0561\u0574 .xlsx \u0567\u0589",
        ka: "\u10E4\u10D0\u10D8\u10DA\u10D8\u10E1 \u10EC\u10D0\u10D9\u10D8\u10D7\u10EE\u10D5\u10D0 \u10D5\u10D4\u10E0 \u10DB\u10DD\u10EE\u10D4\u10E0\u10EE\u10D3\u10D0. \u10E8\u10D4\u10D0\u10DB\u10DD\u10EC\u10DB\u10D4\u10D7, \u10E0\u10DD\u10DB \u10D8\u10E1 .csv \u10D0\u10DC .xlsx \u10D0\u10E0\u10D8\u10E1."
    },
    empty_file: {
        uk: "\u0423 \u0446\u044C\u043E\u043C\u0443 \u0444\u0430\u0439\u043B\u0456 \u043D\u0435\u043C\u0430\u0454 \u0440\u044F\u0434\u043A\u0456\u0432",
        en: "That file has no rows",
        hy: "\u0531\u0575\u057D \u0586\u0561\u0575\u056C\u0578\u0582\u0574 \u057F\u0578\u0572\u0565\u0580 \u0579\u056F\u0561\u0576",
        ka: "\u10D0\u10DB \u10E4\u10D0\u10D8\u10DA\u10E8\u10D8 \u10DB\u10EC\u10D9\u10E0\u10D8\u10D5\u10D4\u10D1\u10D8 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1"
    },
    /* -------------------------------------------------------------- columns */ col_row: {
        uk: "\u0420\u044F\u0434\u043E\u043A",
        en: "Row",
        hy: "\u054F\u0578\u0572",
        ka: "\u10DB\u10EC\u10D9\u10E0\u10D8\u10D5\u10D8"
    },
    col_title: {
        uk: "\u041D\u0430\u0437\u0432\u0430",
        en: "Title",
        hy: "\u0531\u0576\u057E\u0561\u0576\u0578\u0582\u0574",
        ka: "\u10D3\u10D0\u10E1\u10D0\u10EE\u10D4\u10DA\u10D4\u10D1\u10D0"
    },
    col_description: {
        uk: "\u041E\u043F\u0438\u0441",
        en: "Description",
        hy: "\u0546\u056F\u0561\u0580\u0561\u0563\u0580\u0578\u0582\u0569\u0575\u0578\u0582\u0576",
        ka: "\u10D0\u10E6\u10EC\u10D4\u10E0\u10D0"
    },
    col_start: {
        uk: "\u041F\u043E\u0447\u0430\u0442\u043E\u043A",
        en: "Start",
        hy: "\u054D\u056F\u056B\u0566\u0562",
        ka: "\u10D3\u10D0\u10EC\u10E7\u10D4\u10D1\u10D0"
    },
    col_end: {
        uk: "\u041A\u0456\u043D\u0435\u0446\u044C",
        en: "End",
        hy: "\u0531\u057E\u0561\u0580\u057F",
        ka: "\u10D3\u10D0\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10D0"
    },
    col_point: {
        uk: "\u0422\u043E\u0447\u043A\u0430",
        en: "Point",
        hy: "\u053F\u0565\u057F",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8"
    },
    col_network: {
        uk: "\u041C\u0435\u0440\u0435\u0436\u0430",
        en: "Network",
        hy: "\u0551\u0561\u0576\u0581",
        ka: "\u10E5\u10E1\u10D4\u10DA\u10D8"
    },
    col_products: {
        uk: "\u0422\u043E\u0432\u0430\u0440\u0438",
        en: "Products",
        hy: "\u0531\u057A\u0580\u0561\u0576\u0584\u0576\u0565\u0580",
        ka: "\u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10E2\u10D4\u10D1\u10D8"
    },
    col_reason: {
        uk: "\u041F\u0440\u0438\u0447\u0438\u043D\u0430",
        en: "Reason",
        hy: "\u054A\u0561\u057F\u0573\u0561\u057C",
        ka: "\u10DB\u10D8\u10D6\u10D4\u10D6\u10D8"
    },
    sample_title: {
        uk: "\u041F\u0435\u0440\u0435\u0432\u0456\u0440\u0438\u0442\u0438 \u0432\u0438\u043A\u043B\u0430\u0434\u043A\u0443",
        en: "Check the shelf",
        hy: "\u054D\u057F\u0578\u0582\u0563\u0565\u056C \u0564\u0561\u0580\u0561\u056F\u0568",
        ka: "\u10E8\u10D4\u10D0\u10DB\u10DD\u10EC\u10DB\u10D4\u10D7 \u10D7\u10D0\u10E0\u10DD"
    },
    /* ----------------------------------------------------------- row errors */ e_required: {
        uk: "\u041E\u0431\u043E\u0432\u2019\u044F\u0437\u043A\u043E\u0432\u0435",
        en: "Required",
        hy: "\u054A\u0561\u0580\u057F\u0561\u0564\u056B\u0580",
        ka: "\u10E1\u10D0\u10D5\u10D0\u10DA\u10D3\u10D4\u10D1\u10E3\u10DA\u10DD"
    },
    e_date: {
        uk: "\u041D\u0435 \u0434\u0430\u0442\u0430 \u2014 \u043F\u043E\u0442\u0440\u0456\u0431\u0435\u043D \u0444\u043E\u0440\u043C\u0430\u0442 {f}",
        en: "Not a date \u2014 use {f}",
        hy: "\u0531\u0574\u057D\u0561\u0569\u056B\u057E \u0579\u0567 \u2014 \u0585\u0563\u057F\u0561\u0563\u0578\u0580\u056E\u0565\u0584 {f}",
        ka: "\u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1 \u10D7\u10D0\u10E0\u10D8\u10E6\u10D8 \u2014 \u10D2\u10D0\u10DB\u10DD\u10D8\u10E7\u10D4\u10DC\u10D4\u10D7 {f}"
    },
    e_end_before_start: {
        uk: "\u041A\u0456\u043D\u0435\u0446\u044C \u0440\u0430\u043D\u0456\u0448\u0435 \u0437\u0430 \u043F\u043E\u0447\u0430\u0442\u043E\u043A",
        en: "Ends before it starts",
        hy: "\u0531\u057E\u0561\u0580\u057F\u0568 \u057D\u056F\u0566\u0562\u056B\u0581 \u0577\u0578\u0582\u057F \u0567",
        ka: "\u10E1\u10E0\u10E3\u10DA\u10D3\u10D4\u10D1\u10D0 \u10D3\u10D0\u10EC\u10E7\u10D4\u10D1\u10D0\u10DB\u10D3\u10D4"
    },
    e_point_or_network: {
        uk: "\u041F\u043E\u0442\u0440\u0456\u0431\u0435\u043D \u043A\u043E\u0434 \u0442\u043E\u0447\u043A\u0438 \u0430\u0431\u043E \u043C\u0435\u0440\u0435\u0436\u0456",
        en: "Needs a point or a network code",
        hy: "\u0531\u0576\u0570\u0580\u0561\u056A\u0565\u0577\u057F \u0567 \u056F\u0565\u057F\u056B \u056F\u0561\u0574 \u0581\u0561\u0576\u0581\u056B \u056F\u0578\u0564",
        ka: "\u10E1\u10D0\u10ED\u10D8\u10E0\u10DD\u10D0 \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8\u10E1 \u10D0\u10DC \u10E5\u10E1\u10D4\u10DA\u10D8\u10E1 \u10D9\u10DD\u10D3\u10D8"
    },
    e_no_assignments: {
        uk: "\u0416\u043E\u0434\u043D\u043E\u0433\u043E \u0442\u043E\u0432\u0430\u0440\u0443 \u043D\u0435 \u043F\u043E\u0437\u043D\u0430\u0447\u0435\u043D\u043E",
        en: "No products ticked",
        hy: "\u0548\u0579 \u0574\u056B \u0561\u057A\u0580\u0561\u0576\u0584 \u0576\u0577\u057E\u0561\u056E \u0579\u0567",
        ka: "\u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10E2\u10D4\u10D1\u10D8 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1 \u10DB\u10DD\u10DC\u10D8\u10E8\u10DC\u10E3\u10DA\u10D8"
    },
    /* ----------------------------------------------------------------- rows */ add_row: {
        uk: "\u0414\u043E\u0434\u0430\u0442\u0438 \u0440\u044F\u0434\u043E\u043A",
        en: "Add row",
        hy: "\u0531\u057E\u0565\u056C\u0561\u0581\u0576\u0565\u056C \u057F\u0578\u0572",
        ka: "\u10DB\u10EC\u10D9\u10E0\u10D8\u10D5\u10D8\u10E1 \u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D0"
    },
    remove_row: {
        uk: "\u041F\u0440\u0438\u0431\u0440\u0430\u0442\u0438 \u0440\u044F\u0434\u043E\u043A",
        en: "Remove row",
        hy: "\u0540\u0565\u057C\u0561\u0581\u0576\u0565\u056C \u057F\u0578\u0572\u0568",
        ka: "\u10DB\u10EC\u10D9\u10E0\u10D8\u10D5\u10D8\u10E1 \u10DB\u10DD\u10E8\u10DD\u10E0\u10D4\u10D1\u10D0"
    },
    rows_empty_title: {
        uk: "\u0429\u0435 \u043D\u0435\u043C\u0430\u0454 \u0440\u044F\u0434\u043A\u0456\u0432",
        en: "No rows yet",
        hy: "\u0534\u0565\u057C \u057F\u0578\u0572\u0565\u0580 \u0579\u056F\u0561\u0576",
        ka: "\u10EF\u10D4\u10E0 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1 \u10DB\u10EC\u10D9\u10E0\u10D8\u10D5\u10D4\u10D1\u10D8"
    },
    rows_empty_desc: {
        uk: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0442\u0435 \u0444\u0430\u0439\u043B \u0430\u0431\u043E \u0434\u043E\u0434\u0430\u0439\u0442\u0435 \u0440\u044F\u0434\u043E\u043A \u0432\u0440\u0443\u0447\u043D\u0443.",
        en: "Upload a file, or add a row by hand.",
        hy: "\u054E\u0565\u0580\u0562\u0565\u057C\u0576\u0565\u0584 \u0586\u0561\u0575\u056C \u056F\u0561\u0574 \u0561\u057E\u0565\u056C\u0561\u0581\u0580\u0565\u0584 \u057F\u0578\u0572 \u0571\u0565\u057C\u0584\u0578\u057E\u0589",
        ka: "\u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10D4\u10D7 \u10E4\u10D0\u10D8\u10DA\u10D8 \u10D0\u10DC \u10D3\u10D0\u10D0\u10DB\u10D0\u10E2\u10D4\u10D7 \u10DB\u10EC\u10D9\u10E0\u10D8\u10D5\u10D8 \u10EE\u10D4\u10DA\u10D8\u10D7."
    },
    rows_empty_file_desc: {
        uk: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0442\u0435 \u0444\u0430\u0439\u043B, \u0449\u043E\u0431 \u043F\u043E\u0431\u0430\u0447\u0438\u0442\u0438 \u0440\u044F\u0434\u043A\u0438.",
        en: "Upload a file to see its rows.",
        hy: "\u054E\u0565\u0580\u0562\u0565\u057C\u0576\u0565\u0584 \u0586\u0561\u0575\u056C\u055D \u057F\u0578\u0572\u0565\u0580\u0568 \u057F\u0565\u057D\u0576\u0565\u056C\u0578\u0582 \u0570\u0561\u0574\u0561\u0580\u0589",
        ka: "\u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10D4\u10D7 \u10E4\u10D0\u10D8\u10DA\u10D8 \u10DB\u10EC\u10D9\u10E0\u10D8\u10D5\u10D4\u10D1\u10D8\u10E1 \u10E1\u10D0\u10DC\u10D0\u10EE\u10D0\u10D5\u10D0\u10D3."
    },
    /* ----------------------------------------------------------------- rail */ n_parsed: {
        uk: "\u041F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u043E",
        en: "Parsed",
        hy: "\u053F\u0561\u0580\u0564\u0561\u0581\u057E\u0561\u056E",
        ka: "\u10EC\u10D0\u10D9\u10D8\u10D7\u10EE\u10E3\u10DA\u10D8"
    },
    n_ok: {
        uk: "\u0413\u043E\u0442\u043E\u0432\u0456",
        en: "Ready",
        hy: "\u054A\u0561\u057F\u0580\u0561\u057D\u057F",
        ka: "\u10DB\u10D6\u10D0\u10D3\u10D0\u10D0"
    },
    n_problems: {
        uk: "\u0417 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0430\u043C\u0438",
        en: "Problems",
        hy: "\u053D\u0576\u0564\u056B\u0580\u0576\u0565\u0580\u0578\u057E",
        ka: "\u10DE\u10E0\u10DD\u10D1\u10DA\u10D4\u10DB\u10D4\u10D1\u10D8\u10D7"
    },
    rail_summary: {
        uk: "\u041F\u0456\u0434\u0441\u0443\u043C\u043E\u043A",
        en: "Summary",
        hy: "\u0531\u0574\u0583\u0578\u0583\u0578\u0582\u0574",
        ka: "\u10E8\u10D4\u10EF\u10D0\u10DB\u10D4\u10D1\u10D0"
    },
    rail_target: {
        uk: "\u041A\u0443\u0434\u0438 \u043F\u0456\u0434\u0435",
        en: "Target",
        hy: "\u0548\u0582\u0580 \u056F\u0563\u0576\u0561",
        ka: "\u10E1\u10D0\u10D3 \u10EC\u10D0\u10D5\u10D0"
    },
    server_checks_hint: {
        uk: "\u0422\u0443\u0442 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u044F\u0454\u0442\u044C\u0441\u044F \u043B\u0438\u0448\u0435 \u0444\u043E\u0440\u043C\u0430 \u0440\u044F\u0434\u043A\u0456\u0432. \u041A\u043E\u0434\u0438 \u0442\u043E\u0447\u043E\u043A, \u043C\u0435\u0440\u0435\u0436 \u0456 \u0442\u043E\u0432\u0430\u0440\u0456\u0432 \u0437\u0432\u0456\u0440\u044F\u044E\u0442\u044C\u0441\u044F \u043D\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0456 \u043F\u0456\u0441\u043B\u044F \u0456\u043C\u043F\u043E\u0440\u0442\u0443.",
        en: "Only the shape of each row is checked here. Point, network and product codes are verified on the server after the import.",
        hy: "\u0531\u0575\u057D\u057F\u0565\u0572 \u057D\u057F\u0578\u0582\u0563\u057E\u0578\u0582\u0574 \u0567 \u0574\u056B\u0561\u0575\u0576 \u057F\u0578\u0572\u0565\u0580\u056B \u0571\u0587\u0568\u0589 \u053F\u0565\u057F\u0565\u0580\u056B, \u0581\u0561\u0576\u0581\u0565\u0580\u056B \u0587 \u0561\u057A\u0580\u0561\u0576\u0584\u0576\u0565\u0580\u056B \u056F\u0578\u0564\u0565\u0580\u0568 \u057D\u057F\u0578\u0582\u0563\u057E\u0578\u0582\u0574 \u0565\u0576 \u057D\u0565\u0580\u057E\u0565\u0580\u0578\u0582\u0574 \u0576\u0565\u0580\u0574\u0578\u0582\u056E\u0578\u0582\u0574\u056B\u0581 \u0570\u0565\u057F\u0578\u0589",
        ka: "\u10D0\u10E5 \u10DB\u10DD\u10EC\u10DB\u10D3\u10D4\u10D1\u10D0 \u10DB\u10EE\u10DD\u10DA\u10DD\u10D3 \u10DB\u10EC\u10D9\u10E0\u10D8\u10D5\u10D4\u10D1\u10D8\u10E1 \u10E4\u10DD\u10E0\u10DB\u10D0. \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1, \u10E5\u10E1\u10D4\u10DA\u10D4\u10D1\u10D8\u10E1\u10D0 \u10D3\u10D0 \u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10E2\u10D4\u10D1\u10D8\u10E1 \u10D9\u10DD\u10D3\u10D4\u10D1\u10D8 \u10DB\u10DD\u10EC\u10DB\u10D3\u10D4\u10D1\u10D0 \u10E1\u10D4\u10E0\u10D5\u10D4\u10E0\u10D6\u10D4 \u10D8\u10DB\u10DE\u10DD\u10E0\u10E2\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D3\u10D4\u10D2."
    },
    /* -------------------------------------------------------------- submit */ submit: {
        uk: "\u0406\u043C\u043F\u043E\u0440\u0442\u0443\u0432\u0430\u0442\u0438",
        en: "Import",
        hy: "\u0546\u0565\u0580\u0574\u0578\u0582\u056E\u0565\u056C",
        ka: "\u10D8\u10DB\u10DE\u10DD\u10E0\u10E2\u10D8"
    },
    cancel: {
        uk: "\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438",
        en: "Cancel",
        hy: "\u0549\u0565\u0572\u0561\u0580\u056F\u0565\u056C",
        ka: "\u10D2\u10D0\u10E3\u10E5\u10DB\u10D4\u10D1\u10D0"
    },
    discard_rows: {
        uk: "\u0412\u0456\u0434\u043A\u0438\u043D\u0443\u0442\u0438 \u0440\u044F\u0434\u043A\u0438",
        en: "Discard rows",
        hy: "\u0540\u0580\u0561\u056A\u0561\u0580\u057E\u0565\u056C \u057F\u0578\u0572\u0565\u0580\u056B\u0581",
        ka: "\u10DB\u10EC\u10D9\u10E0\u10D8\u10D5\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10E3\u10E5\u10DB\u10D4\u10D1\u10D0"
    },
    change_kind_confirm: {
        uk: "\u041F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u0456 \u0440\u044F\u0434\u043A\u0438 \u043D\u0435 \u043F\u0456\u0434\u0445\u043E\u0434\u044F\u0442\u044C \u0434\u043E \u0456\u043D\u0448\u043E\u0433\u043E \u0442\u0438\u043F\u0443 \u0456\u043C\u043F\u043E\u0440\u0442\u0443, \u0442\u043E\u0436 \u0457\u0445 \u0431\u0443\u0434\u0435 \u0432\u0456\u0434\u043A\u0438\u043D\u0443\u0442\u043E. \u041F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438?",
        en: "The rows you have read in do not fit another import kind, so they will be discarded. Continue?",
        hy: "\u053F\u0561\u0580\u0564\u0561\u0581\u057E\u0561\u056E \u057F\u0578\u0572\u0565\u0580\u0568 \u0561\u0575\u056C \u057F\u0565\u057D\u0561\u056F\u056B \u0576\u0565\u0580\u0574\u0578\u0582\u056E\u0574\u0561\u0576 \u0579\u0565\u0576 \u0570\u0561\u0574\u0561\u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0578\u0582\u0574, \u0578\u0582\u057D\u057F\u056B \u056F\u0570\u0565\u057C\u0561\u0581\u057E\u0565\u0576\u0589 \u0547\u0561\u0580\u0578\u0582\u0576\u0561\u056F\u0565\u055E\u056C\u0589",
        ka: "\u10EC\u10D0\u10D9\u10D8\u10D7\u10EE\u10E3\u10DA\u10D8 \u10DB\u10EC\u10D9\u10E0\u10D8\u10D5\u10D4\u10D1\u10D8 \u10D0\u10E0 \u10E8\u10D4\u10D4\u10E1\u10D0\u10D1\u10D0\u10DB\u10D4\u10D1\u10D0 \u10E1\u10EE\u10D5\u10D0 \u10E2\u10D8\u10DE\u10D8\u10E1 \u10D8\u10DB\u10DE\u10DD\u10E0\u10E2\u10E1, \u10D0\u10DB\u10D8\u10E2\u10DD\u10DB \u10D2\u10D0\u10E3\u10E5\u10DB\u10D3\u10D4\u10D1\u10D0. \u10D2\u10D0\u10D5\u10D0\u10D2\u10E0\u10EB\u10D4\u10DA\u10DD\u10D7?"
    },
    only_problems: {
        uk: "\u041B\u0438\u0448\u0435 \u0437 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u0430\u043C\u0438",
        en: "Problems only",
        hy: "\u0544\u056B\u0561\u0575\u0576 \u056D\u0576\u0564\u056B\u0580\u0576\u0565\u0580\u0578\u057E",
        ka: "\u10DB\u10EE\u10DD\u10DA\u10DD\u10D3 \u10DE\u10E0\u10DD\u10D1\u10DA\u10D4\u10DB\u10D4\u10D1\u10D8\u10D7"
    },
    v_name_required: {
        uk: "\u0412\u043A\u0430\u0436\u0456\u0442\u044C \u043D\u0430\u0437\u0432\u0443 \u043F\u0430\u043A\u0435\u0442\u0430",
        en: "Give the batch a name",
        hy: "\u0546\u0577\u0565\u0584 \u056D\u0574\u0562\u0561\u0584\u0561\u0576\u0561\u056F\u056B \u0561\u0576\u0578\u0582\u0576\u0568",
        ka: "\u10DB\u10D8\u10E3\u10D7\u10D8\u10D7\u10D4\u10D7 \u10DE\u10D0\u10D9\u10D4\u10E2\u10D8\u10E1 \u10E1\u10D0\u10EE\u10D4\u10DA\u10D8"
    },
    v_template_required: {
        uk: "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0448\u0430\u0431\u043B\u043E\u043D",
        en: "Pick a template",
        hy: "\u0538\u0576\u057F\u0580\u0565\u0584 \u0571\u0587\u0561\u0576\u0574\u0578\u0582\u0577",
        ka: "\u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10E8\u10D0\u10D1\u10DA\u10DD\u10DC\u10D8"
    },
    v_scope_required: {
        uk: "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0442\u043E\u0447\u043A\u0443 \u0430\u0431\u043E \u043C\u0435\u0440\u0435\u0436\u0443",
        en: "Pick a point or a network",
        hy: "\u0538\u0576\u057F\u0580\u0565\u0584 \u056F\u0565\u057F \u056F\u0561\u0574 \u0581\u0561\u0576\u0581",
        ka: "\u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7 \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8 \u10D0\u10DC \u10E5\u10E1\u10D4\u10DA\u10D8"
    },
    v_no_valid_rows: {
        uk: "\u041D\u0435\u043C\u0430\u0454 \u0436\u043E\u0434\u043D\u043E\u0433\u043E \u0440\u044F\u0434\u043A\u0430 \u0431\u0435\u0437 \u043F\u0440\u043E\u0431\u043B\u0435\u043C",
        en: "No row is free of problems",
        hy: "\u0549\u056F\u0561 \u0561\u057C\u0561\u0576\u0581 \u056D\u0576\u0564\u056B\u0580\u0576\u0565\u0580\u056B \u0578\u0579 \u0574\u056B \u057F\u0578\u0572",
        ka: "\u10D0\u10E0\u10EA\u10D4\u10E0\u10D7\u10D8 \u10DB\u10EC\u10D9\u10E0\u10D8\u10D5\u10D8 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1 \u10DE\u10E0\u10DD\u10D1\u10DA\u10D4\u10DB\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10E0\u10D4\u10E8\u10D4"
    },
    queued_msg: {
        uk: "\u0406\u043C\u043F\u043E\u0440\u0442 \u043F\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043E \u0432 \u0447\u0435\u0440\u0433\u0443. \u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442 \u2014 \u0443 \xab\u041C\u043E\u0457\u0445 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F\u0445\xbb.",
        en: "Import queued. The result appears in My uploads.",
        hy: "\u0546\u0565\u0580\u0574\u0578\u0582\u056E\u0578\u0582\u0574\u0568 \u0570\u0565\u0580\u0569\u0578\u0582\u0574 \u0567\u0589 \u0531\u0580\u0564\u0575\u0578\u0582\u0576\u0584\u0568\u055D \xab\u053B\u0574 \u0576\u0565\u0580\u0562\u0565\u057C\u0576\u0578\u0582\u0574\u0576\u0565\u0580\u0578\u0582\u0574\xbb\u0589",
        ka: "\u10D8\u10DB\u10DE\u10DD\u10E0\u10E2\u10D8 \u10E0\u10D8\u10D2\u10E8\u10D8\u10D0. \u10E8\u10D4\u10D3\u10D4\u10D2\u10D8 \u10D2\u10D0\u10DB\u10DD\u10E9\u10DC\u10D3\u10D4\u10D1\u10D0 \u201E\u10E9\u10D4\u10DB\u10E1 \u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D4\u10D1\u10E8\u10D8\u201C."
    },
    submit_failed: {
        uk: "\u0406\u043C\u043F\u043E\u0440\u0442 \u043D\u0435 \u0432\u0434\u0430\u0432\u0441\u044F",
        en: "The import was refused",
        hy: "\u0546\u0565\u0580\u0574\u0578\u0582\u056E\u0578\u0582\u0574\u0568 \u0574\u0565\u0580\u056A\u057E\u0565\u0581",
        ka: "\u10D8\u10DB\u10DE\u10DD\u10E0\u10E2\u10D8 \u10E3\u10D0\u10E0\u10E7\u10DD\u10E4\u10D8\u10DA\u10D8\u10D0"
    },
    leave_confirm: {
        uk: "\u041F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u0456 \u0440\u044F\u0434\u043A\u0438 \u0431\u0443\u0434\u0435 \u0432\u0442\u0440\u0430\u0447\u0435\u043D\u043E. \u0417\u0430\u043B\u0438\u0448\u0438\u0442\u0438 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443?",
        en: "The rows you have read in will be lost. Leave the page?",
        hy: "\u053F\u0561\u0580\u0564\u0561\u0581\u057E\u0561\u056E \u057F\u0578\u0572\u0565\u0580\u0568 \u056F\u056F\u0578\u0580\u0579\u0565\u0576\u0589 \u053C\u0584\u0565\u055E\u056C \u0567\u057B\u0568\u0589",
        ka: "\u10EC\u10D0\u10D9\u10D8\u10D7\u10EE\u10E3\u10DA\u10D8 \u10DB\u10EC\u10D9\u10E0\u10D8\u10D5\u10D4\u10D1\u10D8 \u10D3\u10D0\u10D8\u10D9\u10D0\u10E0\u10D2\u10D4\u10D1\u10D0. \u10D3\u10D0\u10E2\u10DD\u10D5\u10D4\u10D1\u10D7 \u10D2\u10D5\u10D4\u10E0\u10D3\u10E1?"
    },
    /* ------------------------------------------------------- My uploads */ uploads_title: {
        uk: "\u041C\u043E\u0457 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F",
        en: "My uploads",
        hy: "\u053B\u0574 \u0576\u0565\u0580\u0562\u0565\u057C\u0576\u0578\u0582\u0574\u0576\u0565\u0580\u0568",
        ka: "\u10E9\u10D4\u10DB\u10D8 \u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D4\u10D1\u10D8"
    },
    uploads_sub: {
        uk: "\u041A\u043E\u0436\u0435\u043D \u0456\u043C\u043F\u043E\u0440\u0442 \u0442\u0430 \u0439\u043E\u0433\u043E \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442. \u041E\u0431\u0440\u043E\u0431\u043A\u0430 \u0442\u0440\u0438\u0432\u0430\u0454 \u043D\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0456 \u043F\u0456\u0441\u043B\u044F \u043D\u0430\u0434\u0441\u0438\u043B\u0430\u043D\u043D\u044F.",
        en: "Every import and how it went. Processing continues on the server after you submit.",
        hy: "\u0545\u0578\u0582\u0580\u0561\u0584\u0561\u0576\u0579\u0575\u0578\u0582\u0580 \u0576\u0565\u0580\u0574\u0578\u0582\u056E\u0578\u0582\u0574 \u0587 \u0564\u0580\u0561 \u0561\u0580\u0564\u0575\u0578\u0582\u0576\u0584\u0568\u0589 \u0544\u0577\u0561\u056F\u0578\u0582\u0574\u0568 \u0577\u0561\u0580\u0578\u0582\u0576\u0561\u056F\u057E\u0578\u0582\u0574 \u0567 \u057D\u0565\u0580\u057E\u0565\u0580\u0578\u0582\u0574 \u0578\u0582\u0572\u0561\u0580\u056F\u0565\u056C\u0578\u0582\u0581 \u0570\u0565\u057F\u0578\u0589",
        ka: "\u10D7\u10D8\u10D7\u10DD\u10D4\u10E3\u10DA\u10D8 \u10D8\u10DB\u10DE\u10DD\u10E0\u10E2\u10D8 \u10D3\u10D0 \u10DB\u10D8\u10E1\u10D8 \u10E8\u10D4\u10D3\u10D4\u10D2\u10D8. \u10D3\u10D0\u10DB\u10E3\u10E8\u10D0\u10D5\u10D4\u10D1\u10D0 \u10D2\u10E0\u10EB\u10D4\u10DA\u10D3\u10D4\u10D1\u10D0 \u10E1\u10D4\u10E0\u10D5\u10D4\u10E0\u10D6\u10D4 \u10D2\u10D0\u10D2\u10D6\u10D0\u10D5\u10DC\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D3\u10D4\u10D2."
    },
    u_col_name: {
        uk: "\u041D\u0430\u0437\u0432\u0430",
        en: "Name",
        hy: "\u0531\u0576\u057E\u0561\u0576\u0578\u0582\u0574",
        ka: "\u10D3\u10D0\u10E1\u10D0\u10EE\u10D4\u10DA\u10D4\u10D1\u10D0"
    },
    u_col_type: {
        uk: "\u0422\u0438\u043F",
        en: "Type",
        hy: "\u054F\u0565\u057D\u0561\u056F",
        ka: "\u10E2\u10D8\u10DE\u10D8"
    },
    u_col_created: {
        uk: "\u041A\u043E\u043B\u0438",
        en: "When",
        hy: "\u0535\u0580\u0562",
        ka: "\u10E0\u10DD\u10D3\u10D8\u10E1"
    },
    u_col_errors: {
        uk: "\u041F\u043E\u043C\u0438\u043B\u043A\u0438",
        en: "Errors",
        hy: "\u054D\u056D\u0561\u056C\u0576\u0565\u0580",
        ka: "\u10E8\u10D4\u10EA\u10D3\u10DD\u10DB\u10D4\u10D1\u10D8"
    },
    type_tasks: {
        uk: "\u0417\u0430\u0432\u0434\u0430\u043D\u043D\u044F",
        en: "Tasks",
        hy: "\u0531\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0576\u0565\u0580",
        ka: "\u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8"
    },
    type_matrix: {
        uk: "\u0410\u0441\u043E\u0440\u0442\u0438\u043C\u0435\u043D\u0442\u043D\u0430 \u043C\u0430\u0442\u0440\u0438\u0446\u044F",
        en: "Assortment matrix",
        hy: "\u054F\u0565\u057D\u0561\u056F\u0561\u0576\u0578\u0582 \u0574\u0561\u057F\u0580\u056B\u0581",
        ka: "\u10D0\u10E1\u10DD\u10E0\u10E2\u10D8\u10DB\u10D4\u10DC\u10E2\u10D8\u10E1 \u10DB\u10D0\u10E2\u10E0\u10D8\u10EA\u10D0"
    },
    st_received: {
        uk: "\u041F\u0440\u0438\u0439\u043D\u044F\u0442\u043E",
        en: "Received",
        hy: "\u054D\u057F\u0561\u0581\u057E\u0561\u056E",
        ka: "\u10DB\u10D8\u10E6\u10D4\u10D1\u10E3\u10DA\u10D8"
    },
    st_pending: {
        uk: "\u0412 \u043E\u0431\u0440\u043E\u0431\u0446\u0456",
        en: "Processing",
        hy: "\u0544\u0577\u0561\u056F\u057E\u0578\u0582\u0574 \u0567",
        ka: "\u10DB\u10E3\u10E8\u10D0\u10D5\u10D3\u10D4\u10D1\u10D0"
    },
    st_failed: {
        uk: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F",
        en: "Failed",
        hy: "\u0541\u0561\u056D\u0578\u0572\u057E\u0565\u0581",
        ka: "\u10E9\u10D0\u10D8\u10E8\u10D0\u10DA\u10D0"
    },
    st_done: {
        uk: "\u0413\u043E\u0442\u043E\u0432\u043E",
        en: "Done",
        hy: "\u054A\u0561\u057F\u0580\u0561\u057D\u057F",
        ka: "\u10D3\u10D0\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10E3\u10DA\u10D8"
    },
    st_deleted: {
        uk: "\u0414\u0430\u043D\u0456 \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043E",
        en: "Data removed",
        hy: "\u054F\u057E\u0575\u0561\u056C\u0576\u0565\u0580\u0568 \u0570\u0565\u057C\u0561\u0581\u057E\u0561\u056E \u0565\u0576",
        ka: "\u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8 \u10EC\u10D0\u10E8\u10DA\u10D8\u10DA\u10D8\u10D0"
    },
    f_status: {
        uk: "\u0421\u0442\u0430\u0442\u0443\u0441",
        en: "Status",
        hy: "\u053F\u0561\u0580\u0563\u0561\u057E\u056B\u0573\u0561\u056F",
        ka: "\u10E1\u10E2\u10D0\u10E2\u10E3\u10E1\u10D8"
    },
    f_type: {
        uk: "\u0422\u0438\u043F",
        en: "Type",
        hy: "\u054F\u0565\u057D\u0561\u056F",
        ka: "\u10E2\u10D8\u10DE\u10D8"
    },
    f_search_ph: {
        uk: "\u041F\u043E\u0448\u0443\u043A \u0437\u0430 \u043D\u0430\u0437\u0432\u043E\u044E",
        en: "Search by name",
        hy: "\u0548\u0580\u0578\u0576\u0565\u056C \u0568\u057D\u057F \u0561\u0576\u057E\u0561\u0576",
        ka: "\u10EB\u10D4\u10D1\u10DC\u10D0 \u10E1\u10D0\u10EE\u10D4\u10DA\u10D8\u10D7"
    },
    view_logs: {
        uk: "\u041F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438 \u043F\u043E\u043C\u0438\u043B\u043A\u0438",
        en: "View errors",
        hy: "\u0534\u056B\u057F\u0565\u056C \u057D\u056D\u0561\u056C\u0576\u0565\u0580\u0568",
        ka: "\u10E8\u10D4\u10EA\u10D3\u10DD\u10DB\u10D4\u10D1\u10D8\u10E1 \u10DC\u10D0\u10EE\u10D5\u10D0"
    },
    download_logs: {
        uk: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 CSV",
        en: "Download CSV",
        hy: "\u0546\u0565\u0580\u0562\u0565\u057C\u0576\u0565\u056C CSV",
        ka: "CSV-\u10D8\u10E1 \u10E9\u10D0\u10DB\u10DD\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D0"
    },
    logs_title: {
        uk: "\u041F\u043E\u043C\u0438\u043B\u043A\u0438 \u0456\u043C\u043F\u043E\u0440\u0442\u0443",
        en: "Import errors",
        hy: "\u0546\u0565\u0580\u0574\u0578\u0582\u056E\u0574\u0561\u0576 \u057D\u056D\u0561\u056C\u0576\u0565\u0580",
        ka: "\u10D8\u10DB\u10DE\u10DD\u10E0\u10E2\u10D8\u10E1 \u10E8\u10D4\u10EA\u10D3\u10DD\u10DB\u10D4\u10D1\u10D8"
    },
    logs_opaque: {
        uk: "\u0421\u0435\u0440\u0432\u0435\u0440 \u043F\u043E\u0432\u0456\u0434\u043E\u043C\u0438\u0432 \u043F\u0440\u043E \u043F\u043E\u043C\u0438\u043B\u043A\u0443, \u0430\u043B\u0435 \u043D\u0435 \u0437\u0431\u0435\u0440\u0456\u0433, \u044F\u043A\u0456 \u0441\u0430\u043C\u0435 \u0440\u044F\u0434\u043A\u0438 \u043D\u0435 \u043F\u0440\u043E\u0439\u0448\u043B\u0438.",
        en: "The server reported a failure but did not record which rows did not go through.",
        hy: "\u054D\u0565\u0580\u057E\u0565\u0580\u0568 \u0570\u0561\u0572\u0578\u0580\u0564\u0565\u056C \u0567 \u057D\u056D\u0561\u056C\u056B \u0574\u0561\u057D\u056B\u0576, \u0562\u0561\u0575\u0581 \u0579\u056B \u057A\u0561\u0570\u057A\u0561\u0576\u0565\u056C, \u0569\u0565 \u0578\u0580 \u057F\u0578\u0572\u0565\u0580\u0576 \u0565\u0576 \u0571\u0561\u056D\u0578\u0572\u057E\u0565\u056C\u0589",
        ka: "\u10E1\u10D4\u10E0\u10D5\u10D4\u10E0\u10DB\u10D0 \u10E8\u10D4\u10EA\u10D3\u10DD\u10DB\u10D0 \u10D3\u10D0\u10D0\u10E4\u10D8\u10E5\u10E1\u10D8\u10E0\u10D0, \u10DB\u10D0\u10D2\u10E0\u10D0\u10DB \u10D0\u10E0 \u10E8\u10D4\u10D8\u10DC\u10D0\u10EE\u10D0, \u10E0\u10DD\u10DB\u10D4\u10DA\u10D8 \u10DB\u10EC\u10D9\u10E0\u10D8\u10D5\u10D4\u10D1\u10D8 \u10E9\u10D0\u10D8\u10E8\u10D0\u10DA\u10D0."
    },
    delete_data: {
        uk: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u0456 \u0434\u0430\u043D\u0456",
        en: "Remove the created data",
        hy: "\u054B\u0576\u057B\u0565\u056C \u057D\u057F\u0565\u0572\u056E\u057E\u0561\u056E \u057F\u057E\u0575\u0561\u056C\u0576\u0565\u0580\u0568",
        ka: "\u10E8\u10D4\u10E5\u10DB\u10DC\u10D8\u10DA\u10D8 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8\u10E1 \u10EC\u10D0\u10E8\u10DA\u10D0"
    },
    delete_confirm_tasks: {
        uk: "\u0417\u0430\u0432\u0434\u0430\u043D\u043D\u044F, \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u0456 \u0456\u043C\u043F\u043E\u0440\u0442\u043E\u043C \xab{name}\xbb, \u0431\u0443\u0434\u0435 \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043E \u043D\u0430\u0437\u0430\u0432\u0436\u0434\u0438. \u0421\u0430\u043C \u0437\u0430\u043F\u0438\u0441 \u043F\u0440\u043E \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0437\u0430\u043B\u0438\u0448\u0438\u0442\u044C\u0441\u044F.",
        en: "The tasks created by the import \u201C{name}\u201D will be deleted for good. The upload record itself stays.",
        hy: "\xab{name}\xbb \u0576\u0565\u0580\u0574\u0578\u0582\u056E\u0574\u0561\u0574\u0562 \u057D\u057F\u0565\u0572\u056E\u057E\u0561\u056E \u0561\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0576\u0565\u0580\u0568 \u0568\u0576\u0564\u0574\u056B\u0577\u057F \u056F\u057B\u0576\u057B\u057E\u0565\u0576\u0589 \u0546\u0565\u0580\u0562\u0565\u057C\u0576\u0574\u0561\u0576 \u0563\u0580\u0561\u057C\u0578\u0582\u0574\u0576 \u056B\u0576\u0584\u0576\u056B\u0576 \u056F\u0574\u0576\u0561\u0589",
        ka: "\u10D8\u10DB\u10DE\u10DD\u10E0\u10E2\u10D8\u10D7 \u201E{name}\u201C \u10E8\u10D4\u10E5\u10DB\u10DC\u10D8\u10DA\u10D8 \u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8 \u10E1\u10D0\u10DB\u10E3\u10D3\u10D0\u10DB\u10DD\u10D3 \u10EC\u10D0\u10D8\u10E8\u10DA\u10D4\u10D1\u10D0. \u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D8\u10E1 \u10E9\u10D0\u10DC\u10D0\u10EC\u10D4\u10E0\u10D8 \u10D3\u10D0\u10E0\u10E9\u10D4\u10D1\u10D0."
    },
    delete_confirm_matrix: {
        uk: "\u0410\u0441\u043E\u0440\u0442\u0438\u043C\u0435\u043D\u0442\u043D\u0456 \u043C\u0430\u0442\u0440\u0438\u0446\u0456, \u0441\u0442\u0432\u043E\u0440\u0435\u043D\u0456 \u0456\u043C\u043F\u043E\u0440\u0442\u043E\u043C \xab{name}\xbb, \u0431\u0443\u0434\u0435 \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043E \u043D\u0430\u0437\u0430\u0432\u0436\u0434\u0438. \u0421\u0430\u043C \u0437\u0430\u043F\u0438\u0441 \u043F\u0440\u043E \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0437\u0430\u043B\u0438\u0448\u0438\u0442\u044C\u0441\u044F.",
        en: "The assortment matrices created by the import \u201C{name}\u201D will be deleted for good. The upload record itself stays.",
        hy: "\xab{name}\xbb \u0576\u0565\u0580\u0574\u0578\u0582\u056E\u0574\u0561\u0574\u0562 \u057D\u057F\u0565\u0572\u056E\u057E\u0561\u056E \u057F\u0565\u057D\u0561\u056F\u0561\u0576\u0578\u0582 \u0574\u0561\u057F\u0580\u056B\u0581\u0576\u0565\u0580\u0568 \u0568\u0576\u0564\u0574\u056B\u0577\u057F \u056F\u057B\u0576\u057B\u057E\u0565\u0576\u0589 \u0546\u0565\u0580\u0562\u0565\u057C\u0576\u0574\u0561\u0576 \u0563\u0580\u0561\u057C\u0578\u0582\u0574\u0576 \u056B\u0576\u0584\u0576\u056B\u0576 \u056F\u0574\u0576\u0561\u0589",
        ka: "\u10D8\u10DB\u10DE\u10DD\u10E0\u10E2\u10D8\u10D7 \u201E{name}\u201C \u10E8\u10D4\u10E5\u10DB\u10DC\u10D8\u10DA\u10D8 \u10D0\u10E1\u10DD\u10E0\u10E2\u10D8\u10DB\u10D4\u10DC\u10E2\u10D8\u10E1 \u10DB\u10D0\u10E2\u10E0\u10D8\u10EA\u10D4\u10D1\u10D8 \u10E1\u10D0\u10DB\u10E3\u10D3\u10D0\u10DB\u10DD\u10D3 \u10EC\u10D0\u10D8\u10E8\u10DA\u10D4\u10D1\u10D0. \u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D8\u10E1 \u10E9\u10D0\u10DC\u10D0\u10EC\u10D4\u10E0\u10D8 \u10D3\u10D0\u10E0\u10E9\u10D4\u10D1\u10D0."
    },
    deleted_msg: {
        uk: "\u0421\u0442\u0432\u043E\u0440\u0435\u043D\u0456 \u0434\u0430\u043D\u0456 \u0432\u0438\u0434\u0430\u043B\u0435\u043D\u043E",
        en: "The created data was removed",
        hy: "\u054D\u057F\u0565\u0572\u056E\u057E\u0561\u056E \u057F\u057E\u0575\u0561\u056C\u0576\u0565\u0580\u0568 \u0570\u0565\u057C\u0561\u0581\u057E\u0565\u0581\u056B\u0576",
        ka: "\u10E8\u10D4\u10E5\u10DB\u10DC\u10D8\u10DA\u10D8 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8 \u10EC\u10D0\u10D8\u10E8\u10D0\u10DA\u10D0"
    },
    row_actions: {
        uk: "\u0414\u0456\u0457 \u0437 \u0440\u044F\u0434\u043A\u043E\u043C",
        en: "Row actions",
        hy: "\u054F\u0578\u0572\u056B \u0563\u0578\u0580\u056E\u0578\u0572\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580",
        ka: "\u10DB\u10EC\u10D9\u10E0\u10D8\u10D5\u10D8\u10E1 \u10DB\u10DD\u10E5\u10DB\u10D4\u10D3\u10D4\u10D1\u10D4\u10D1\u10D8"
    },
    rows_per_page: {
        uk: "\u0420\u044F\u0434\u043A\u0456\u0432 \u043D\u0430 \u0441\u0442\u043E\u0440\u0456\u043D\u0446\u0456",
        en: "Rows per page",
        hy: "\u054F\u0578\u0572\u0565\u0580 \u0567\u057B\u0578\u0582\u0574",
        ka: "\u10DB\u10EC\u10D9\u10E0\u10D8\u10D5\u10D8 \u10D2\u10D5\u10D4\u10E0\u10D3\u10D6\u10D4"
    },
    range_of: {
        uk: "{from}\u2013{to} \u0437 {n}",
        en: "{from}\u2013{to} of {n}",
        hy: "{from}\u2013{to} / {n}",
        ka: "{from}\u2013{to} / {n}"
    },
    empty_title: {
        uk: "\u0429\u0435 \u043D\u0456\u0447\u043E\u0433\u043E \u043D\u0435 \u0456\u043C\u043F\u043E\u0440\u0442\u043E\u0432\u0430\u043D\u043E",
        en: "Nothing imported yet",
        hy: "\u0534\u0565\u057C \u0578\u0579\u056B\u0576\u0579 \u0576\u0565\u0580\u0574\u0578\u0582\u056E\u057E\u0561\u056E \u0579\u0567",
        ka: "\u10EF\u10D4\u10E0 \u10D0\u10E0\u10D0\u10E4\u10D4\u10E0\u10D8\u10D0 \u10D8\u10DB\u10DE\u10DD\u10E0\u10E2\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8"
    },
    empty_desc: {
        uk: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0437\u2019\u044F\u0432\u043B\u044F\u044E\u0442\u044C\u0441\u044F \u0442\u0443\u0442 \u043E\u0434\u0440\u0430\u0437\u0443 \u043F\u0456\u0441\u043B\u044F \u043D\u0430\u0434\u0441\u0438\u043B\u0430\u043D\u043D\u044F.",
        en: "Uploads appear here as soon as you submit one.",
        hy: "\u0546\u0565\u0580\u0562\u0565\u057C\u0576\u0578\u0582\u0574\u0576\u0565\u0580\u0568 \u0570\u0561\u0575\u057F\u0576\u057E\u0578\u0582\u0574 \u0565\u0576 \u0561\u0575\u057D\u057F\u0565\u0572 \u0578\u0582\u0572\u0561\u0580\u056F\u0565\u056C\u0578\u0582\u0581 \u0561\u0576\u0574\u056B\u057B\u0561\u057A\u0565\u057D \u0570\u0565\u057F\u0578\u0589",
        ka: "\u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D4\u10D1\u10D8 \u10D0\u10E5 \u10D2\u10D0\u10DB\u10DD\u10E9\u10DC\u10D3\u10D4\u10D1\u10D0 \u10D2\u10D0\u10D2\u10D6\u10D0\u10D5\u10DC\u10D8\u10E1\u10D7\u10D0\u10DC\u10D0\u10D5\u10D4."
    },
    empty_filtered_title: {
        uk: "\u041D\u0456\u0447\u043E\u0433\u043E \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E",
        en: "Nothing matches these filters",
        hy: "\u0531\u0575\u057D \u0566\u057F\u056B\u0579\u0576\u0565\u0580\u056B\u0576 \u0578\u0579\u056B\u0576\u0579 \u0579\u056B \u0570\u0561\u0574\u0561\u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0578\u0582\u0574",
        ka: "\u10D0\u10DB \u10E4\u10D8\u10DA\u10E2\u10E0\u10D4\u10D1\u10E1 \u10D0\u10E0\u10D0\u10E4\u10D4\u10E0\u10D8 \u10D4\u10DB\u10D7\u10EE\u10D5\u10D4\u10D5\u10D0"
    },
    empty_filtered_desc: {
        uk: "\u0421\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0437\u043D\u044F\u0442\u0438 \u0447\u0430\u0441\u0442\u0438\u043D\u0443 \u0444\u0456\u043B\u044C\u0442\u0440\u0456\u0432 \u0430\u0431\u043E \u0440\u043E\u0437\u0448\u0438\u0440\u0438\u0442\u0438 \u043F\u0435\u0440\u0456\u043E\u0434.",
        en: "Try clearing some filters or widening the period.",
        hy: "\u0553\u0578\u0580\u0571\u0565\u0584 \u0570\u0565\u057C\u0561\u0581\u0576\u0565\u056C \u0578\u0580\u0578\u0577 \u0566\u057F\u056B\u0579\u0576\u0565\u0580 \u056F\u0561\u0574 \u0568\u0576\u0564\u056C\u0561\u0575\u0576\u0565\u056C \u056A\u0561\u0574\u0561\u0576\u0561\u056F\u0561\u0570\u0561\u057F\u057E\u0561\u056E\u0568\u0589",
        ka: "\u10E1\u10EA\u10D0\u10D3\u10D4\u10D7 \u10D6\u10DD\u10D2\u10D8\u10D4\u10E0\u10D7\u10D8 \u10E4\u10D8\u10DA\u10E2\u10E0\u10D8\u10E1 \u10DB\u10DD\u10EE\u10E1\u10DC\u10D0 \u10D0\u10DC \u10DE\u10D4\u10E0\u10D8\u10DD\u10D3\u10D8\u10E1 \u10D2\u10D0\u10E4\u10D0\u10E0\u10D7\u10DD\u10D4\u10D1\u10D0."
    },
    go_import: {
        uk: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u0434\u043E \u0456\u043C\u043F\u043E\u0440\u0442\u0443",
        en: "Go to import",
        hy: "\u0531\u0576\u0581\u0576\u0565\u056C \u0576\u0565\u0580\u0574\u0578\u0582\u056E\u0574\u0561\u0576\u0568",
        ka: "\u10D8\u10DB\u10DE\u10DD\u10E0\u10E2\u10D6\u10D4 \u10D2\u10D0\u10D3\u10D0\u10E1\u10D5\u10DA\u10D0"
    },
    new_row: {
        uk: "\u0429\u043E\u0439\u043D\u043E \u043D\u0430\u0434\u0456\u0441\u043B\u0430\u043D\u043E",
        en: "Just submitted",
        hy: "\u0540\u0565\u0576\u0581 \u0576\u0578\u0580 \u0578\u0582\u0572\u0561\u0580\u056F\u057E\u0561\u056E",
        ka: "\u10D0\u10EE\u10DA\u10D0\u10EE\u10D0\u10DC \u10D2\u10D0\u10D2\u10D6\u10D0\u10D5\u10DC\u10D8\u10DA\u10D8"
    },
    refresh: {
        uk: "\u041E\u043D\u043E\u0432\u0438\u0442\u0438",
        en: "Refresh",
        hy: "\u0539\u0561\u0580\u0574\u0561\u0581\u0576\u0565\u056C",
        ka: "\u10D2\u10D0\u10DC\u10D0\u10EE\u10DA\u10D4\u10D1\u10D0"
    }
};
const $fc3f36407bc5ec6c$export$63f54f62a76a9e58 = {
    page_sub: {
        uk: "\u041F\u043E\u0437\u0438\u0446\u0456\u0457 \u0442\u0430 \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u0438 \u0437\u0430 \u0432\u0438\u0431\u0440\u0430\u043D\u0438\u0439 \u0434\u0435\u043D\u044C",
        en: "Positions and routes for the selected day",
        hy: "\u0534\u056B\u0580\u0584\u0565\u0580\u0568 \u0587 \u0565\u0580\u0569\u0578\u0582\u0572\u056B\u0576\u0565\u0580\u0568 \u0568\u0576\u057F\u0580\u057E\u0561\u056E \u0585\u0580\u057E\u0561 \u0570\u0561\u0574\u0561\u0580",
        ka: "\u10DE\u10DD\u10D6\u10D8\u10EA\u10D8\u10D4\u10D1\u10D8 \u10D3\u10D0 \u10DB\u10D0\u10E0\u10E8\u10E0\u10E3\u10E2\u10D4\u10D1\u10D8 \u10D0\u10E0\u10E9\u10D4\u10E3\u10DA\u10D8 \u10D3\u10E6\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1"
    },
    day: {
        uk: "\u0414\u0435\u043D\u044C",
        en: "Day",
        hy: "\u0555\u0580",
        ka: "\u10D3\u10E6\u10D4"
    },
    today: {
        uk: "\u0421\u044C\u043E\u0433\u043E\u0434\u043D\u0456",
        en: "Today",
        hy: "\u0531\u0575\u057D\u0585\u0580",
        ka: "\u10D3\u10E6\u10D4\u10E1"
    },
    refresh: {
        uk: "\u041E\u043D\u043E\u0432\u0438\u0442\u0438",
        en: "Refresh",
        hy: "\u0539\u0561\u0580\u0574\u0561\u0581\u0576\u0565\u056C",
        ka: "\u10D2\u10D0\u10DC\u10D0\u10EE\u10DA\u10D4\u10D1\u10D0"
    },
    updated: {
        uk: "\u041E\u043D\u043E\u0432\u043B\u0435\u043D\u043E {time}",
        en: "Updated {time}",
        hy: "\u0539\u0561\u0580\u0574\u0561\u0581\u057E\u0565\u056C \u0567 {time}",
        ka: "\u10D2\u10D0\u10DC\u10D0\u10EE\u10DA\u10D3\u10D0 {time}"
    },
    st_in_visit: {
        uk: "\u0423 {point} \xb7 \u0437 {time}",
        en: "At {point} \xb7 since {time}",
        hy: "{point} \xb7 {time}-\u056B\u0581",
        ka: "{point} \xb7 {time}-\u10D3\u10D0\u10DC"
    },
    st_open_stale: {
        uk: "\u041D\u0435 \u0437\u0430\u043A\u0440\u0438\u0442\u043E \xb7 {point} \xb7 \u0437 {time}",
        en: "Not closed \xb7 {point} \xb7 since {time}",
        hy: "\u0549\u0583\u0561\u056F\u057E\u0561\u056E \xb7 {point} \xb7 {time}-\u056B\u0581",
        ka: "\u10D3\u10D0\u10E3\u10EE\u10E3\u10E0\u10D0\u10D5\u10D8 \xb7 {point} \xb7 {time}-\u10D3\u10D0\u10DC"
    },
    st_between: {
        uk: "\u041E\u0441\u0442\u0430\u043D\u043D\u0456\u0439 \xb7 {point} \xb7 {time}",
        en: "Last \xb7 {point} \xb7 {time}",
        hy: "\u054E\u0565\u0580\u057B\u056B\u0576 \xb7 {point} \xb7 {time}",
        ka: "\u10D1\u10DD\u10DA\u10DD \xb7 {point} \xb7 {time}"
    },
    st_idle: {
        uk: "\u041D\u0435\u043C\u0430\u0454 \u0432\u0456\u0437\u0438\u0442\u0456\u0432",
        en: "No visits",
        hy: "\u0531\u0575\u0581\u0565\u0580 \u0579\u056F\u0561\u0576",
        ka: "\u10D5\u10D8\u10D6\u10D8\u10E2\u10D4\u10D1\u10D8 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1"
    },
    no_coords: {
        uk: "\u041D\u0435\u043C\u0430\u0454 \u043A\u043E\u043E\u0440\u0434\u0438\u043D\u0430\u0442",
        en: "No coordinates",
        hy: "\u053F\u0578\u0578\u0580\u0564\u056B\u0576\u0561\u057F\u0576\u0565\u0580 \u0579\u056F\u0561\u0576",
        ka: "\u10D9\u10DD\u10DD\u10E0\u10D3\u10D8\u10DC\u10D0\u10E2\u10D4\u10D1\u10D8 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1"
    },
    seq_title: {
        uk: "\u0412\u0456\u0434\u0432\u0456\u0434\u0430\u043D\u0456 \u0442\u043E\u0447\u043A\u0438",
        en: "Visited points",
        hy: "\u0531\u0575\u0581\u0565\u056C\u057E\u0561\u056E \u056F\u0565\u057F\u0565\u0580",
        ka: "\u10DB\u10DD\u10DC\u10D0\u10EE\u10E3\u10DA\u10D4\u10D1\u10E3\u10DA\u10D8 \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8"
    },
    plan_title: {
        uk: "\u0417\u0430\u043F\u043B\u0430\u043D\u043E\u0432\u0430\u043D\u0438\u0439 \u043C\u0430\u0440\u0448\u0440\u0443\u0442",
        en: "Planned route",
        hy: "\u054A\u056C\u0561\u0576\u0561\u057E\u0578\u0580\u057E\u0561\u056E \u0565\u0580\u0569\u0578\u0582\u0572\u056B",
        ka: "\u10D3\u10D0\u10D2\u10D4\u10D2\u10DB\u10D8\u10DA\u10D8 \u10DB\u10D0\u10E0\u10E8\u10E0\u10E3\u10E2\u10D8"
    },
    plan_pending: {
        uk: "\u0417\u0430\u043F\u043B\u0430\u043D\u043E\u0432\u0430\u043D\u043E, \u043D\u0435 \u0432\u0456\u0434\u0432\u0456\u0434\u0430\u043D\u043E",
        en: "Planned, not visited",
        hy: "\u054A\u056C\u0561\u0576\u0561\u057E\u0578\u0580\u057E\u0561\u056E, \u0579\u0561\u0575\u0581\u0565\u056C\u057E\u0561\u056E",
        ka: "\u10D3\u10D0\u10D2\u10D4\u10D2\u10DB\u10D8\u10DA\u10D8, \u10D0\u10E0 \u10DB\u10DD\u10DC\u10D0\u10EE\u10E3\u10DA\u10D4\u10D1\u10E3\u10DA\u10D8"
    },
    no_plan: {
        uk: "\u041D\u0435\u043C\u0430\u0454 \u0437\u0430\u043F\u043B\u0430\u043D\u043E\u0432\u0430\u043D\u043E\u0433\u043E \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u0443 \u043D\u0430 \u0446\u0435\u0439 \u0434\u0435\u043D\u044C",
        en: "No planned route for this day",
        hy: "\u0531\u0575\u057D \u0585\u0580\u057E\u0561 \u0570\u0561\u0574\u0561\u0580 \u057A\u056C\u0561\u0576\u0561\u057E\u0578\u0580\u057E\u0561\u056E \u0565\u0580\u0569\u0578\u0582\u0572\u056B \u0579\u056F\u0561",
        ka: "\u10D0\u10DB \u10D3\u10E6\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1 \u10D3\u10D0\u10D2\u10D4\u10D2\u10DB\u10D8\u10DA\u10D8 \u10DB\u10D0\u10E0\u10E8\u10E0\u10E3\u10E2\u10D8 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1"
    },
    here_now: {
        uk: "\u0417\u0430\u0440\u0430\u0437 \u0442\u0443\u0442",
        en: "Here now",
        hy: "\u0540\u056B\u0574\u0561 \u0561\u0575\u057D\u057F\u0565\u0572",
        ka: "\u10D0\u10EE\u10DA\u10D0 \u10D0\u10E5"
    },
    on_route: {
        uk: "\u0417\u0430 \u043F\u043B\u0430\u043D\u043E\u043C",
        en: "Planned",
        hy: "\u0538\u057D\u057F \u057A\u056C\u0561\u0576\u056B",
        ka: "\u10D2\u10D4\u10D2\u10DB\u10D8\u10E1 \u10DB\u10D8\u10EE\u10D4\u10D3\u10D5\u10D8\u10D7"
    },
    off_route: {
        uk: "\u041F\u043E\u0437\u0430 \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u043E\u043C",
        en: "Off route",
        hy: "\u0535\u0580\u0569\u0578\u0582\u0572\u0578\u0582\u0581 \u0564\u0578\u0582\u0580\u057D",
        ka: "\u10DB\u10D0\u10E0\u10E8\u10E0\u10E3\u10E2\u10D8\u10E1 \u10D2\u10D0\u10E0\u10D4\u10D7"
    },
    dur_h: {
        uk: "{n} \u0433\u043E\u0434",
        en: "{n} h",
        hy: "{n} \u056A",
        ka: "{n} \u10E1\u10D7"
    },
    dur_m: {
        uk: "{n} \u0445\u0432",
        en: "{n} min",
        hy: "{n} \u0580",
        ka: "{n} \u10EC\u10D7"
    },
    points_visited: {
        uk: "\u0422\u043E\u0447\u043E\u043A: {n}",
        en: "Points: {n}",
        hy: "\u053F\u0565\u057F\u0565\u0580\u055D {n}",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8: {n}"
    },
    show_team: {
        uk: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u0432\u0441\u044E \u043A\u043E\u043C\u0430\u043D\u0434\u0443",
        en: "Show whole team",
        hy: "\u0551\u0578\u0582\u0575\u0581 \u057F\u0561\u056C \u0578\u0572\u057B \u0569\u056B\u0574\u0568",
        ka: "\u10DB\u10D7\u10D4\u10DA\u10D8 \u10D2\u10E3\u10DC\u10D3\u10D8\u10E1 \u10E9\u10D5\u10D4\u10DC\u10D4\u10D1\u10D0"
    },
    call: {
        uk: "\u041F\u043E\u0434\u0437\u0432\u043E\u043D\u0438\u0442\u0438",
        en: "Call",
        hy: "\u0536\u0561\u0576\u0563\u0561\u0570\u0561\u0580\u0565\u056C",
        ka: "\u10D3\u10D0\u10E0\u10D4\u10D9\u10D5\u10D0"
    },
    open_visit: {
        uk: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u0432\u0456\u0437\u0438\u0442",
        en: "Open visit",
        hy: "\u0532\u0561\u0581\u0565\u056C \u0561\u0575\u0581\u0568",
        ka: "\u10D5\u10D8\u10D6\u10D8\u10E2\u10D8\u10E1 \u10D2\u10D0\u10EE\u10E1\u10DC\u10D0"
    },
    empty_map_title: {
        uk: "\u041D\u0456\u043A\u043E\u0433\u043E \u043D\u0430 \u043A\u0430\u0440\u0442\u0456",
        en: "Nobody on the map",
        hy: "\u0554\u0561\u0580\u057F\u0565\u0566\u056B\u0576 \u0578\u0579 \u0578\u0584 \u0579\u056F\u0561",
        ka: "\u10E0\u10E3\u10D9\u10D0\u10D6\u10D4 \u10D0\u10E0\u10D0\u10D5\u10D8\u10DC\u10D0\u10D0"
    },
    empty_map_desc: {
        uk: "\u041D\u0435\u043C\u0430\u0454 \u0432\u0456\u0437\u0438\u0442\u0456\u0432 \u0437 \u043A\u043E\u043E\u0440\u0434\u0438\u043D\u0430\u0442\u0430\u043C\u0438 \u0437\u0430 \u0446\u0435\u0439 \u0434\u0435\u043D\u044C.",
        en: "No visits with coordinates for this day.",
        hy: "\u0531\u0575\u057D \u0585\u0580\u057E\u0561 \u0570\u0561\u0574\u0561\u0580 \u056F\u0578\u0578\u0580\u0564\u056B\u0576\u0561\u057F\u0576\u0565\u0580\u0578\u057E \u0561\u0575\u0581\u0565\u0580 \u0579\u056F\u0561\u0576\u0589",
        ka: "\u10D0\u10DB \u10D3\u10E6\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1 \u10D9\u10DD\u10DD\u10E0\u10D3\u10D8\u10DC\u10D0\u10E2\u10D4\u10D1\u10D8\u10D7 \u10D5\u10D8\u10D6\u10D8\u10E2\u10D4\u10D1\u10D8 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1."
    },
    empty_roster_title: {
        uk: "\u041D\u0435\u043C\u0430\u0454 \u043C\u0435\u0440\u0447\u0430\u043D\u0434\u0430\u0439\u0437\u0435\u0440\u0456\u0432",
        en: "No merchandisers",
        hy: "\u0544\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580\u0576\u0565\u0580 \u0579\u056F\u0561\u0576",
        ka: "\u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D4\u10D1\u10D8 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1"
    },
    empty_roster_desc: {
        uk: "\u0414\u043E \u0432\u0430\u0441 \u043D\u0435 \u0437\u0430\u043A\u0440\u0456\u043F\u043B\u0435\u043D\u043E \u0430\u043A\u0442\u0438\u0432\u043D\u0438\u0445 \u043C\u0435\u0440\u0447\u0430\u043D\u0434\u0430\u0439\u0437\u0435\u0440\u0456\u0432.",
        en: "There are no active merchandisers assigned to you.",
        hy: "\u0541\u0565\u0566 \u0561\u0574\u0580\u0561\u0563\u0580\u057E\u0561\u056E \u0561\u056F\u057F\u056B\u057E \u0574\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580\u0576\u0565\u0580 \u0579\u056F\u0561\u0576\u0589",
        ka: "\u10D7\u10E5\u10D5\u10D4\u10DC\u10D6\u10D4 \u10DB\u10D8\u10DB\u10D0\u10D2\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8 \u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D8 \u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D4\u10D1\u10D8 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1."
    },
    truncated: {
        uk: "\u041F\u043E\u043A\u0430\u0437\u0430\u043D\u043E \u0432\u0456\u0437\u0438\u0442\u0456\u0432: {shown} \u0437 {total}",
        en: "Visits shown: {shown} of {total}",
        hy: "\u0551\u0578\u0582\u0581\u0561\u0564\u0580\u057E\u0561\u056E \u0561\u0575\u0581\u0565\u0580\u055D {shown} / {total}",
        ka: "\u10DC\u10D0\u10E9\u10D5\u10D4\u10DC\u10D4\u10D1\u10D8 \u10D5\u10D8\u10D6\u10D8\u10E2\u10D4\u10D1\u10D8: {shown} / {total}"
    },
    map_unavailable: {
        uk: "\u041A\u0430\u0440\u0442\u0430 \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430",
        en: "Map unavailable",
        hy: "\u0554\u0561\u0580\u057F\u0565\u0566\u0568 \u0570\u0561\u057D\u0561\u0576\u0565\u056C\u056B \u0579\u0567",
        ka: "\u10E0\u10E3\u10D9\u10D0 \u10DB\u10D8\u10E3\u10EC\u10D5\u10D3\u10DD\u10DB\u10D4\u10DA\u10D8\u10D0"
    },
    load_error: {
        uk: "\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0434\u0435\u043D\u044C",
        en: "Could not load the day",
        hy: "\u0549\u0570\u0561\u057B\u0578\u0572\u057E\u0565\u0581 \u0562\u0565\u057C\u0576\u0565\u056C \u0585\u0580\u0568",
        ka: "\u10D3\u10E6\u10D8\u10E1 \u10E9\u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D0 \u10D5\u10D4\u10E0 \u10DB\u10DD\u10EE\u10D4\u10E0\u10EE\u10D3\u10D0"
    },
    retry: {
        uk: "\u0421\u043F\u0440\u043E\u0431\u0443\u0432\u0430\u0442\u0438 \u0449\u0435",
        en: "Retry",
        hy: "\u053F\u0580\u056F\u0576\u0565\u056C",
        ka: "\u10EE\u10D4\u10DA\u10D0\u10EE\u10DA\u10D0"
    }
};
const $fc3f36407bc5ec6c$export$4402302c977bcdb5 = {
    title: {
        uk: "\u042F\u043A \u043F\u0440\u0430\u0446\u044E\u0454 \u0434\u0430\u0448\u0431\u043E\u0440\u0434",
        en: "How the dashboard works",
        hy: "\u053B\u0576\u0579\u057A\u0565\u057D \u0567 \u0561\u0577\u056D\u0561\u057F\u0578\u0582\u0574 \u0564\u0561\u0577\u0562\u0578\u0580\u0564\u0568",
        ka: "\u10E0\u10DD\u10D2\u10DD\u10E0 \u10DB\u10E3\u10E8\u10D0\u10DD\u10D1\u10E1 \u10D3\u10D4\u10E8\u10D1\u10DD\u10E0\u10D3\u10D8"
    },
    subtitle: {
        uk: "\u0423\u0441\u0456 \u0435\u043A\u0440\u0430\u043D\u0438 \u0432 \u043E\u0434\u043D\u043E\u043C\u0443 \u043C\u0456\u0441\u0446\u0456: \u0434\u043B\u044F \u0447\u043E\u0433\u043E \u043A\u043E\u0436\u0435\u043D, \u0449\u043E \u043D\u0430 \u043D\u044C\u043E\u043C\u0443 \u043C\u043E\u0436\u043D\u0430 \u0440\u043E\u0431\u0438\u0442\u0438, \u0456 \u043A\u043E\u0440\u043E\u0442\u043A\u0430 \u0430\u043D\u0456\u043C\u0430\u0446\u0456\u044F. \u0423 \u043F\u0440\u0438\u043A\u043B\u0430\u0434\u0430\u0445 \u2014 \u0432\u0438\u0433\u0430\u0434\u0430\u043D\u0430 \u043A\u043E\u043C\u043F\u0430\u043D\u0456\u044F.",
        en: "Every screen in one place: what it is for, what you can do there, and a short animation of it in use. The examples show a fictional company.",
        hy: "\u0532\u0578\u056C\u0578\u0580 \u0567\u056F\u0580\u0561\u0576\u0576\u0565\u0580\u0568 \u0574\u0565\u056F \u057F\u0565\u0572\u0578\u0582\u0574. \u056B\u0576\u0579\u056B \u0570\u0561\u0574\u0561\u0580 \u0567 \u0575\u0578\u0582\u0580\u0561\u0584\u0561\u0576\u0579\u0575\u0578\u0582\u0580\u0568, \u056B\u0576\u0579 \u056F\u0561\u0580\u0565\u056C\u056B \u0567 \u0561\u0576\u0565\u056C \u0561\u0575\u0576\u057F\u0565\u0572, \u0587 \u056F\u0561\u0580\u0573 \u0561\u0576\u056B\u0574\u0561\u0581\u056B\u0561\u0589 \u0555\u0580\u056B\u0576\u0561\u056F\u0576\u0565\u0580\u0578\u0582\u0574 \u057A\u0561\u057F\u056F\u0565\u0580\u057E\u0561\u056E \u0567 \u0570\u0578\u0580\u056B\u0576\u057E\u0561\u056E \u0568\u0576\u056F\u0565\u0580\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0589",
        ka: "\u10E7\u10D5\u10D4\u10DA\u10D0 \u10D4\u10D9\u10E0\u10D0\u10DC\u10D8 \u10D4\u10E0\u10D7 \u10D0\u10D3\u10D2\u10D8\u10DA\u10D0\u10E1: \u10E0\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1 \u10D0\u10E0\u10D8\u10E1 \u10D7\u10D8\u10D7\u10DD\u10D4\u10E3\u10DA\u10D8, \u10E0\u10D0 \u10E8\u10D4\u10D2\u10D8\u10EB\u10DA\u10D8\u10D0\u10D7 \u10D2\u10D0\u10D0\u10D9\u10D4\u10D7\u10DD\u10D7 \u10D3\u10D0 \u10DB\u10DD\u10D9\u10DA\u10D4 \u10D0\u10DC\u10D8\u10DB\u10D0\u10EA\u10D8\u10D0. \u10DB\u10D0\u10D2\u10D0\u10DA\u10D8\u10D7\u10D4\u10D1\u10E8\u10D8 \u10D2\u10D0\u10DB\u10DD\u10D2\u10DD\u10DC\u10D8\u10DA\u10D8 \u10D9\u10DD\u10DB\u10DE\u10D0\u10DC\u10D8\u10D0\u10D0."
    },
    rail_label: {
        uk: "\u041D\u0430 \u0446\u0456\u0439 \u0441\u0442\u043E\u0440\u0456\u043D\u0446\u0456",
        en: "On this page",
        hy: "\u0531\u0575\u057D \u0567\u057B\u0578\u0582\u0574",
        ka: "\u10D0\u10DB \u10D2\u10D5\u10D4\u10E0\u10D3\u10D6\u10D4"
    },
    support_title: {
        uk: "\u041F\u043E\u0442\u0440\u0456\u0431\u043D\u0430 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u0430?",
        en: "Still need help?",
        hy: "\u0534\u0565\u057C \u0585\u0563\u0576\u0578\u0582\u0569\u0575\u0561\u0576 \u056F\u0561\u0580\u056B\u0584 \u0578\u0582\u0576\u0565\u055E\u0584",
        ka: "\u10D9\u10D8\u10D3\u10D4\u10D5 \u10D2\u10ED\u10D8\u10E0\u10D3\u10D4\u10D1\u10D0\u10D7 \u10D3\u10D0\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D0?"
    },
    support_desc: {
        uk: "\u041D\u0430\u0434\u0456\u0448\u043B\u0456\u0442\u044C \u0437\u0430\u043F\u0438\u0442 \u2014 \u0441\u043B\u0443\u0436\u0431\u0430 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u043A\u0438 \u0437\u0432\u02BC\u044F\u0436\u0435\u0442\u044C\u0441\u044F \u0437 \u0432\u0430\u043C\u0438 \u0432 Telegram.",
        en: "Send a request and the support team will contact you in Telegram.",
        hy: "\u0548\u0582\u0572\u0561\u0580\u056F\u0565\u0584 \u0570\u0561\u0580\u0581\u0578\u0582\u0574, \u0587 \u0561\u057B\u0561\u056F\u0581\u0578\u0582\u0569\u0575\u0561\u0576 \u0569\u056B\u0574\u0568 \u056F\u0561\u057A \u056F\u0570\u0561\u057D\u057F\u0561\u057F\u056B \u0571\u0565\u0566 \u0570\u0565\u057F Telegram-\u0578\u0582\u0574\u0589",
        ka: "\u10D2\u10D0\u10D2\u10D6\u10D0\u10D5\u10DC\u10D4\u10D7 \u10DB\u10DD\u10D7\u10EE\u10DD\u10D5\u10DC\u10D0 \u10D3\u10D0 \u10DB\u10EE\u10D0\u10E0\u10D3\u10D0\u10ED\u10D4\u10E0\u10D8\u10E1 \u10D2\u10E3\u10DC\u10D3\u10D8 \u10D3\u10D0\u10D2\u10D8\u10D9\u10D0\u10D5\u10E8\u10D8\u10E0\u10D3\u10D4\u10D1\u10D0\u10D7 Telegram-\u10E8\u10D8."
    },
    support_btn: {
        uk: "\u0417\u0432\u0435\u0440\u043D\u0443\u0442\u0438\u0441\u044F \u0432 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u043A\u0443",
        en: "Contact support",
        hy: "\u053F\u0561\u057A \u0561\u057B\u0561\u056F\u0581\u0578\u0582\u0569\u0575\u0561\u0576 \u0570\u0565\u057F",
        ka: "\u10DB\u10EE\u10D0\u10E0\u10D3\u10D0\u10ED\u10D4\u10E0\u10D0\u10E1\u10D7\u10D0\u10DC \u10D3\u10D0\u10D9\u10D0\u10D5\u10E8\u10D8\u10E0\u10D4\u10D1\u10D0"
    },
    /* --- shell --- */ search_title: {
        uk: "\u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u0438\u0439 \u043F\u043E\u0448\u0443\u043A",
        en: "Global search",
        hy: "\u0538\u0576\u0564\u0570\u0561\u0576\u0578\u0582\u0580 \u0578\u0580\u0578\u0576\u0578\u0582\u0574",
        ka: "\u10D2\u10DA\u10DD\u10D1\u10D0\u10DA\u10E3\u10E0\u10D8 \u10EB\u10D8\u10D4\u10D1\u10D0"
    },
    search_desc: {
        uk: "\u041F\u043E\u043B\u0435 \u043F\u043E\u0448\u0443\u043A\u0443 \u0443 \u0432\u0435\u0440\u0445\u043D\u0456\u0439 \u043F\u0430\u043D\u0435\u043B\u0456 \u0448\u0443\u043A\u0430\u0454 \u043E\u0434\u0440\u0430\u0437\u0443 \u0441\u0435\u0440\u0435\u0434 \u0442\u043E\u0447\u043E\u043A, \u043C\u0435\u0440\u0447\u0430\u043D\u0434\u0430\u0439\u0437\u0435\u0440\u0456\u0432, \u0432\u0456\u0437\u0438\u0442\u0456\u0432, \u043E\u043F\u0438\u0442\u0443\u0432\u0430\u043D\u044C \u0456 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0456\u0432 \u0456 \u0432\u0456\u0434\u043A\u0440\u0438\u0432\u0430\u0454 \u0437\u0430\u043F\u0438\u0441 \u043E\u0434\u043D\u0438\u043C \u043A\u043B\u0456\u043A\u043E\u043C.",
        en: "The search box in the top bar finds points, merchandisers, visits, surveys and documents at once, and opens the record in one click.",
        hy: "\u054E\u0565\u0580\u0587\u056B \u057E\u0561\u0570\u0561\u0576\u0561\u056F\u056B \u0578\u0580\u0578\u0576\u0574\u0561\u0576 \u0564\u0561\u0577\u057F\u0568 \u0574\u056B\u0561\u056A\u0561\u0574\u0561\u0576\u0561\u056F \u0563\u057F\u0576\u0578\u0582\u0574 \u0567 \u056F\u0565\u057F\u0565\u0580, \u0574\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580\u0576\u0565\u0580, \u0561\u0575\u0581\u0565\u0580, \u0570\u0561\u0580\u0581\u0578\u0582\u0574\u0576\u0565\u0580 \u0587 \u0583\u0561\u057D\u057F\u0561\u0569\u0572\u0569\u0565\u0580 \u0587 \u0562\u0561\u0581\u0578\u0582\u0574 \u0567 \u0563\u0580\u0561\u057C\u0578\u0582\u0574\u0568 \u0574\u0565\u056F \u057D\u0565\u0572\u0574\u0578\u0582\u0574\u0578\u057E\u0589",
        ka: "\u10D6\u10D4\u10D3\u10D0 \u10DE\u10D0\u10DC\u10D4\u10DA\u10D8\u10E1 \u10E1\u10D0\u10EB\u10D8\u10D4\u10D1\u10DD \u10D5\u10D4\u10DA\u10D8 \u10D4\u10E0\u10D7\u10D3\u10E0\u10DD\u10E3\u10DA\u10D0\u10D3 \u10DE\u10DD\u10E3\u10DA\u10DD\u10D1\u10E1 \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10E1, \u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D4\u10D1\u10E1, \u10D5\u10D8\u10D6\u10D8\u10E2\u10D4\u10D1\u10E1, \u10D2\u10D0\u10DB\u10DD\u10D9\u10D8\u10D7\u10EE\u10D5\u10D4\u10D1\u10E1\u10D0 \u10D3\u10D0 \u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D4\u10D1\u10E1 \u10D3\u10D0 \u10D4\u10E0\u10D7\u10D8 \u10D3\u10D0\u10EC\u10D9\u10D0\u10DE\u10E3\u10DC\u10D4\u10D1\u10D8\u10D7 \u10EE\u10E1\u10DC\u10D8\u10E1 \u10E9\u10D0\u10DC\u10D0\u10EC\u10D4\u10E0\u10E1."
    },
    search_b1: {
        uk: "\u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C / \u043D\u0430 \u0431\u0443\u0434\u044C-\u044F\u043A\u0456\u0439 \u0441\u0442\u043E\u0440\u0456\u043D\u0446\u0456, \u0449\u043E\u0431 \u043F\u0435\u0440\u0435\u0439\u0442\u0438 \u0432 \u043F\u043E\u043B\u0435 \u043F\u043E\u0448\u0443\u043A\u0443.",
        en: "Press / anywhere to focus the box.",
        hy: "\u054D\u0565\u0572\u0574\u0565\u0584 / \u0581\u0561\u0576\u056F\u0561\u0581\u0561\u056E \u0567\u057B\u0578\u0582\u0574\u055D \u0578\u0580\u0578\u0576\u0574\u0561\u0576 \u0564\u0561\u0577\u057F\u056B\u0576 \u0561\u0576\u0581\u0576\u0565\u056C\u0578\u0582 \u0570\u0561\u0574\u0561\u0580\u0589",
        ka: "\u10D3\u10D0\u10D0\u10ED\u10D8\u10E0\u10D4\u10D7 / \u10DC\u10D4\u10D1\u10D8\u10E1\u10DB\u10D8\u10D4\u10E0 \u10D2\u10D5\u10D4\u10E0\u10D3\u10D6\u10D4, \u10E0\u10DD\u10DB \u10E1\u10D0\u10EB\u10D8\u10D4\u10D1\u10DD \u10D5\u10D4\u10DA\u10D6\u10D4 \u10D2\u10D0\u10D3\u10D0\u10EE\u10D5\u10D8\u10D3\u10D4\u10D7."
    },
    search_b2: {
        uk: "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u0449\u043E\u043D\u0430\u0439\u043C\u0435\u043D\u0448\u0435 3 \u0441\u0438\u043C\u0432\u043E\u043B\u0438. \u041A\u043E\u0436\u043D\u0435 \u0441\u043B\u043E\u0432\u043E \u043C\u0430\u0454 \u0437\u0431\u0456\u0433\u0430\u0442\u0438\u0441\u044F, \u0442\u043E\u0436 \xabBluefinch Central\xbb \u0437\u043D\u0430\u0439\u0434\u0435 \u0442\u043E\u0447\u043A\u0443 \u0437\u0430 \u043C\u0435\u0440\u0435\u0436\u0435\u044E \u0456 \u043D\u0430\u0441\u0435\u043B\u0435\u043D\u0438\u043C \u043F\u0443\u043D\u043A\u0442\u043E\u043C \u0440\u0430\u0437\u043E\u043C.",
        en: "Type at least 3 characters. Every word must match, so \xabBluefinch Central\xbb finds a point by its network and its locality together.",
        hy: "\u0544\u0578\u0582\u057F\u0584\u0561\u0563\u0580\u0565\u0584 \u0561\u057C\u0576\u057E\u0561\u0566\u0576 3 \u0576\u056B\u0577\u0589 \u0545\u0578\u0582\u0580\u0561\u0584\u0561\u0576\u0579\u0575\u0578\u0582\u0580 \u0562\u0561\u057C\u0568 \u057A\u0565\u057F\u0584 \u0567 \u0570\u0561\u0574\u0568\u0576\u056F\u0576\u056B, \u0561\u0575\u0576\u057A\u0565\u057D \u0578\u0580 \xabBluefinch Central\xbb-\u0568 \u0563\u057F\u0576\u0578\u0582\u0574 \u0567 \u056F\u0565\u057F\u0568 \u0581\u0561\u0576\u0581\u0578\u057E \u0587 \u0562\u0576\u0561\u056F\u0561\u057E\u0561\u0575\u0580\u0578\u057E \u0574\u056B\u0561\u057D\u056B\u0576\u0589",
        ka: "\u10E8\u10D4\u10D8\u10E7\u10D5\u10D0\u10DC\u10D4\u10D7 \u10DB\u10D8\u10DC\u10D8\u10DB\u10E3\u10DB 3 \u10E1\u10D8\u10DB\u10D1\u10DD\u10DA\u10DD. \u10E7\u10D5\u10D4\u10DA\u10D0 \u10E1\u10D8\u10E2\u10E7\u10D5\u10D0 \u10E3\u10DC\u10D3\u10D0 \u10D3\u10D0\u10D4\u10DB\u10D7\u10EE\u10D5\u10D4\u10E1, \u10D0\u10E1\u10D4 \u10E0\u10DD\u10DB \xabBluefinch Central\xbb \u10DE\u10DD\u10E3\u10DA\u10DD\u10D1\u10E1 \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10E1 \u10E5\u10E1\u10D4\u10DA\u10D8\u10D7\u10D0 \u10D3\u10D0 \u10D3\u10D0\u10E1\u10D0\u10EE\u10DA\u10D4\u10D1\u10D8\u10D7 \u10D4\u10E0\u10D7\u10D0\u10D3."
    },
    search_b3: {
        uk: "\u2191 \u2193 \u2014 \u0440\u0443\u0445 \u043C\u0456\u0436 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0430\u043C\u0438, Enter \u0432\u0456\u0434\u043A\u0440\u0438\u0432\u0430\u0454, Esc \u0437\u0430\u043A\u0440\u0438\u0432\u0430\u0454.",
        en: "\u2191 \u2193 move between results, Enter opens, Esc closes.",
        hy: "\u2191 \u2193\u055D \u0561\u0580\u0564\u0575\u0578\u0582\u0576\u0584\u0576\u0565\u0580\u056B \u0574\u056B\u057B\u0587 \u0561\u0576\u0581\u0578\u0582\u0574, Enter\u055D \u0562\u0561\u0581\u0565\u056C, Esc\u055D \u0583\u0561\u056F\u0565\u056C\u0589",
        ka: "\u2191 \u2193 \u2014 \u10D2\u10D0\u10D3\u10D0\u10D0\u10D3\u10D2\u10D8\u10DA\u10D4\u10D1\u10D0 \u10E8\u10D4\u10D3\u10D4\u10D2\u10D4\u10D1\u10E1 \u10E8\u10DD\u10E0\u10D8\u10E1, Enter \u10EE\u10E1\u10DC\u10D8\u10E1, Esc \u10EE\u10E3\u10E0\u10D0\u10D5\u10E1."
    },
    search_b4: {
        uk: "\u041F\u043E\u0440\u043E\u0436\u043D\u0454 \u043F\u043E\u043B\u0435 \u043F\u043E\u043A\u0430\u0437\u0443\u0454 \u043E\u0441\u0442\u0430\u043D\u043D\u0456 \u043F\u043E\u0448\u0443\u043A\u0438. \xab\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u0432\u0441\u0435\xbb \u0437\u0432\u0443\u0436\u0443\u0454 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0438 \u0434\u043E \u043E\u0434\u043D\u043E\u0433\u043E \u0442\u0438\u043F\u0443.",
        en: "An empty box shows your recent searches. \xabSee all\xbb narrows the results to one type.",
        hy: "\u0534\u0561\u057F\u0561\u0580\u056F \u0564\u0561\u0577\u057F\u0568 \u0581\u0578\u0582\u0575\u0581 \u0567 \u057F\u0561\u056C\u056B\u057D \u057E\u0565\u0580\u057B\u056B\u0576 \u0578\u0580\u0578\u0576\u0578\u0582\u0574\u0576\u0565\u0580\u0568\u0589 \xab\u054F\u0565\u057D\u0576\u0565\u056C \u0562\u0578\u056C\u0578\u0580\u0568\xbb \u0576\u0565\u0572\u0561\u0581\u0576\u0578\u0582\u0574 \u0567 \u0561\u0580\u0564\u0575\u0578\u0582\u0576\u0584\u0576\u0565\u0580\u0568 \u0574\u0565\u056F \u057F\u0565\u057D\u0561\u056F\u056B\u0589",
        ka: "\u10EA\u10D0\u10E0\u10D8\u10D4\u10DA\u10D8 \u10D5\u10D4\u10DA\u10D8 \u10D0\u10E9\u10D5\u10D4\u10DC\u10D4\u10D1\u10E1 \u10D1\u10DD\u10DA\u10DD \u10EB\u10D8\u10D4\u10D1\u10D4\u10D1\u10E1. \xab\u10E7\u10D5\u10D4\u10DA\u10D0\u10E1 \u10DC\u10D0\u10EE\u10D5\u10D0\xbb \u10E8\u10D4\u10D3\u10D4\u10D2\u10D4\u10D1\u10E1 \u10D4\u10E0\u10D7 \u10E2\u10D8\u10DE\u10D0\u10DB\u10D3\u10D4 \u10D0\u10D5\u10D8\u10EC\u10E0\u10DD\u10D4\u10D1\u10E1."
    },
    notifications_title: {
        uk: "\u0421\u043F\u043E\u0432\u0456\u0449\u0435\u043D\u043D\u044F",
        en: "Notifications",
        hy: "\u053E\u0561\u0576\u0578\u0582\u0581\u0578\u0582\u0574\u0576\u0565\u0580",
        ka: "\u10E8\u10D4\u10E2\u10E7\u10DD\u10D1\u10D8\u10DC\u10D4\u10D1\u10D4\u10D1\u10D8"
    },
    notifications_desc: {
        uk: "\u0414\u0437\u0432\u0456\u043D\u043E\u0447\u043E\u043A \u043F\u043E\u043A\u0430\u0437\u0443\u0454, \u0449\u043E \u043F\u043E\u0442\u0440\u0435\u0431\u0443\u0454 \u0443\u0432\u0430\u0433\u0438 \u0441\u0430\u043C\u0435 \u0437\u0430\u0440\u0430\u0437. \u0427\u0438\u0441\u043B\u0430 \u043E\u0431\u0447\u0438\u0441\u043B\u044E\u044E\u0442\u044C\u0441\u044F \u0437 \u0430\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u0438\u0445 \u0434\u0430\u043D\u0438\u0445 \u043F\u0440\u0438 \u043A\u043E\u0436\u043D\u043E\u043C\u0443 \u0432\u0456\u0434\u043A\u0440\u0438\u0442\u0442\u0456, \u0442\u043E\u043C\u0443 \u043D\u0456\u0447\u043E\u0433\u043E \u043D\u0435 \u0442\u0440\u0435\u0431\u0430 \u0437\u0430\u043A\u0440\u0438\u0432\u0430\u0442\u0438 \u043F\u043E \u043E\u0434\u043D\u043E\u043C\u0443.",
        en: "The bell shows what needs attention right now. The numbers are computed from live data each time you open it, so nothing has to be dismissed one by one.",
        hy: "\u0536\u0561\u0576\u0563\u0561\u056F\u0568 \u0581\u0578\u0582\u0575\u0581 \u0567 \u057F\u0561\u056C\u056B\u057D, \u0569\u0565 \u056B\u0576\u0579\u0576 \u0567 \u0570\u056B\u0574\u0561 \u0578\u0582\u0577\u0561\u0564\u0580\u0578\u0582\u0569\u0575\u0561\u0576 \u056F\u0561\u0580\u056B\u0584 \u0578\u0582\u0576\u0565\u0576\u0578\u0582\u0574\u0589 \u0539\u057E\u0565\u0580\u0568 \u0570\u0561\u0577\u057E\u0561\u0580\u056F\u057E\u0578\u0582\u0574 \u0565\u0576 \u0569\u0561\u0580\u0574 \u057F\u057E\u0575\u0561\u056C\u0576\u0565\u0580\u056B\u0581 \u0561\u0574\u0565\u0576 \u0562\u0561\u0581\u0565\u056C\u056B\u057D, \u0561\u0575\u0576\u057A\u0565\u057D \u0578\u0580 \u0578\u0579\u056B\u0576\u0579 \u0574\u0565\u056F-\u0574\u0565\u056F \u0583\u0561\u056F\u0565\u056C\u0578\u0582 \u056F\u0561\u0580\u056B\u0584 \u0579\u056F\u0561\u0589",
        ka: "\u10D6\u10D0\u10E0\u10D8 \u10D0\u10E9\u10D5\u10D4\u10DC\u10D4\u10D1\u10E1, \u10E0\u10D0\u10E1 \u10E1\u10ED\u10D8\u10E0\u10D3\u10D4\u10D1\u10D0 \u10E7\u10E3\u10E0\u10D0\u10D3\u10E6\u10D4\u10D1\u10D0 \u10D0\u10EE\u10DA\u10D0. \u10E0\u10D8\u10EA\u10EE\u10D5\u10D4\u10D1\u10D8 \u10E7\u10DD\u10D5\u10D4\u10DA\u10D8 \u10D2\u10D0\u10EE\u10E1\u10DC\u10D8\u10E1\u10D0\u10E1 \u10DB\u10D8\u10DB\u10D3\u10D8\u10DC\u10D0\u10E0\u10D4 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8\u10D3\u10D0\u10DC \u10D8\u10D7\u10D5\u10DA\u10D4\u10D1\u10D0, \u10D0\u10DB\u10D8\u10E2\u10DD\u10DB \u10D0\u10E0\u10D0\u10E4\u10E0\u10D8\u10E1 \u10E1\u10D0\u10D7\u10D8\u10D7\u10D0\u10DD\u10D3 \u10D3\u10D0\u10EE\u10E3\u10E0\u10D5\u10D0 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1 \u10E1\u10D0\u10ED\u10D8\u10E0\u10DD."
    },
    notifications_b1: {
        uk: "\u0422\u0440\u0438 \u0441\u0438\u0433\u043D\u0430\u043B\u0438: \u0432\u0456\u0437\u0438\u0442\u0438 \u043D\u0430 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0446\u0456, \u043C\u0435\u0440\u0447\u0430\u043D\u0434\u0430\u0439\u0437\u0435\u0440\u0438 \u0431\u0435\u0437 \u0432\u0456\u0437\u0438\u0442\u0456\u0432 \u043A\u0456\u043B\u044C\u043A\u0430 \u0434\u043D\u0456\u0432, \u043E\u043F\u0438\u0442\u0443\u0432\u0430\u043D\u043D\u044F, \u0449\u043E \u0441\u043A\u043E\u0440\u043E \u0437\u0430\u043A\u0440\u0438\u0432\u0430\u044E\u0442\u044C\u0441\u044F.",
        en: "Three signals: visits awaiting verification, merchandisers with no visits for several days, surveys that close soon.",
        hy: "\u0535\u0580\u0565\u0584 \u0561\u0566\u0564\u0561\u0576\u0577\u0561\u0576\u055D \u057D\u057F\u0578\u0582\u0563\u0574\u0561\u0576 \u057D\u057A\u0561\u057D\u0578\u0572 \u0561\u0575\u0581\u0565\u0580, \u0574\u056B \u0584\u0561\u0576\u056B \u0585\u0580 \u0561\u0575\u0581 \u0579\u0578\u0582\u0576\u0565\u0581\u0578\u0572 \u0574\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580\u0576\u0565\u0580, \u0577\u0578\u0582\u057F\u0578\u057E \u0583\u0561\u056F\u057E\u0578\u0572 \u0570\u0561\u0580\u0581\u0578\u0582\u0574\u0576\u0565\u0580\u0589",
        ka: "\u10E1\u10D0\u10DB\u10D8 \u10E1\u10D8\u10D2\u10DC\u10D0\u10DA\u10D8: \u10E8\u10D4\u10DB\u10DD\u10EC\u10DB\u10D4\u10D1\u10D8\u10E1 \u10DB\u10DD\u10DA\u10DD\u10D3\u10D8\u10DC\u10E8\u10D8 \u10DB\u10E7\u10DD\u10E4\u10D8 \u10D5\u10D8\u10D6\u10D8\u10E2\u10D4\u10D1\u10D8, \u10E0\u10D0\u10DB\u10D3\u10D4\u10DC\u10D8\u10DB\u10D4 \u10D3\u10E6\u10D4 \u10D5\u10D8\u10D6\u10D8\u10E2\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10E0\u10D4\u10E8\u10D4 \u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D4\u10D1\u10D8, \u10DB\u10D0\u10DA\u10D4 \u10D3\u10D0\u10EE\u10E3\u10E0\u10D5\u10D0\u10D3\u10D8 \u10D2\u10D0\u10DB\u10DD\u10D9\u10D8\u10D7\u10EE\u10D5\u10D4\u10D1\u10D8."
    },
    notifications_b2: {
        uk: "\u041A\u0440\u0430\u043F\u043A\u0430 \u043D\u0430 \u0434\u0437\u0432\u0456\u043D\u043E\u0447\u043A\u0443 \u0437\u043D\u0438\u043A\u0430\u0454, \u0449\u043E\u0439\u043D\u043E \u0432\u0438 \u0432\u0456\u0434\u043A\u0440\u0438\u0454\u0442\u0435 \u0441\u043F\u0438\u0441\u043E\u043A, \u0456 \u043F\u043E\u0432\u0435\u0440\u0442\u0430\u0454\u0442\u044C\u0441\u044F, \u043A\u043E\u043B\u0438 \u044F\u043A\u0435\u0441\u044C \u0447\u0438\u0441\u043B\u043E \u0437\u043C\u0456\u043D\u0438\u0442\u044C\u0441\u044F.",
        en: "The dot on the bell disappears once you open the list and comes back when a number changes.",
        hy: "\u0536\u0561\u0576\u0563\u0561\u056F\u056B \u056F\u0565\u057F\u0568 \u0561\u0576\u0570\u0565\u057F\u0561\u0576\u0578\u0582\u0574 \u0567, \u0565\u0580\u0562 \u0562\u0561\u0581\u0578\u0582\u0574 \u0565\u0584 \u0581\u0578\u0582\u0581\u0561\u056F\u0568, \u0587 \u057E\u0565\u0580\u0561\u0564\u0561\u057C\u0576\u0578\u0582\u0574 \u0567, \u0565\u0580\u0562 \u0578\u0580\u0587\u0567 \u0569\u056B\u057E \u0583\u0578\u056D\u057E\u0578\u0582\u0574 \u0567\u0589",
        ka: "\u10D6\u10D0\u10E0\u10D6\u10D4 \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8 \u10E5\u10E0\u10D4\u10D1\u10D0 \u10E1\u10D8\u10D8\u10E1 \u10D2\u10D0\u10EE\u10E1\u10DC\u10D8\u10E1\u10D0\u10E1 \u10D3\u10D0 \u10D1\u10E0\u10E3\u10DC\u10D3\u10D4\u10D1\u10D0, \u10E0\u10DD\u10EA\u10D0 \u10E0\u10DD\u10DB\u10D4\u10DA\u10D8\u10DB\u10D4 \u10E0\u10D8\u10EA\u10EE\u10D5\u10D8 \u10D8\u10EA\u10D5\u10DA\u10D4\u10D1\u10D0."
    },
    notifications_b3: {
        uk: "\u041A\u043E\u0436\u0435\u043D \u0440\u044F\u0434\u043E\u043A \u0432\u0456\u0434\u043A\u0440\u0438\u0432\u0430\u0454 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443, \u0434\u0435 \u0454 \u0446\u044F \u0440\u043E\u0431\u043E\u0442\u0430.",
        en: "Each row opens the page where the work is.",
        hy: "\u0545\u0578\u0582\u0580\u0561\u0584\u0561\u0576\u0579\u0575\u0578\u0582\u0580 \u057F\u0578\u0572 \u0562\u0561\u0581\u0578\u0582\u0574 \u0567 \u0561\u0575\u0576 \u0567\u057B\u0568, \u0578\u0580\u057F\u0565\u0572 \u0561\u0577\u056D\u0561\u057F\u0561\u0576\u0584\u0576 \u0567\u0589",
        ka: "\u10D7\u10D8\u10D7\u10DD\u10D4\u10E3\u10DA\u10D8 \u10E1\u10E2\u10E0\u10D8\u10E5\u10DD\u10DC\u10D8 \u10EE\u10E1\u10DC\u10D8\u10E1 \u10D2\u10D5\u10D4\u10E0\u10D3\u10E1, \u10E1\u10D0\u10D3\u10D0\u10EA \u10E1\u10D0\u10DB\u10E3\u10E8\u10D0\u10DD\u10D0."
    },
    account_title: {
        uk: "\u041C\u043E\u0432\u0430, \u043F\u0440\u043E\u0444\u0456\u043B\u044C \u0456 \u0432\u0438\u0445\u0456\u0434",
        en: "Language, profile and sign-out",
        hy: "\u053C\u0565\u0566\u0578\u0582, \u057A\u0580\u0578\u0586\u056B\u056C \u0587 \u0565\u056C\u0584",
        ka: "\u10D4\u10DC\u10D0, \u10DE\u10E0\u10DD\u10E4\u10D8\u10DA\u10D8 \u10D3\u10D0 \u10D2\u10D0\u10E1\u10D5\u10DA\u10D0"
    },
    account_desc: {
        uk: "\u041F\u0440\u0430\u0432\u043E\u0440\u0443\u0447 \u0443 \u0432\u0435\u0440\u0445\u043D\u0456\u0439 \u043F\u0430\u043D\u0435\u043B\u0456 \u2014 \u043F\u0435\u0440\u0435\u043C\u0438\u043A\u0430\u0447 \u043C\u043E\u0432\u0438 \u0442\u0430 \u043C\u0435\u043D\u044E \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u043E\u0433\u043E \u0437\u0430\u043F\u0438\u0441\u0443 \u0437 \u0432\u0430\u0448\u0438\u043C \u0456\u043C\u02BC\u044F\u043C \u0456 \u0440\u043E\u043B\u043B\u044E.",
        en: "The right side of the top bar holds the language switcher and your account menu with your name and role.",
        hy: "\u054E\u0565\u0580\u0587\u056B \u057E\u0561\u0570\u0561\u0576\u0561\u056F\u056B \u0561\u057B \u056F\u0578\u0572\u0574\u0578\u0582\u0574 \u0565\u0576 \u056C\u0565\u0566\u057E\u056B \u0583\u0578\u056D\u0561\u0580\u056F\u056B\u0579\u0568 \u0587 \u0571\u0565\u0580 \u0570\u0561\u0577\u057E\u056B \u0568\u0576\u057F\u0580\u0561\u0581\u0561\u0576\u056F\u0568\u055D \u0561\u0576\u0578\u0582\u0576\u0578\u057E \u0587 \u0564\u0565\u0580\u0578\u057E\u0589",
        ka: "\u10D6\u10D4\u10D3\u10D0 \u10DE\u10D0\u10DC\u10D4\u10DA\u10D8\u10E1 \u10DB\u10D0\u10E0\u10EF\u10D5\u10D4\u10DC\u10D0 \u10DB\u10EE\u10D0\u10E0\u10D4\u10E1 \u10D0\u10E0\u10D8\u10E1 \u10D4\u10DC\u10D8\u10E1 \u10D2\u10D0\u10D3\u10D0\u10DB\u10E0\u10D7\u10D5\u10D4\u10DA\u10D8 \u10D3\u10D0 \u10D7\u10E5\u10D5\u10D4\u10DC\u10D8 \u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10D8\u10E1 \u10DB\u10D4\u10DC\u10D8\u10E3 \u10E1\u10D0\u10EE\u10D4\u10DA\u10D8\u10D7\u10D0 \u10D3\u10D0 \u10E0\u10DD\u10DA\u10D8\u10D7."
    },
    account_b1: {
        uk: "\u0412\u0438\u0431\u0456\u0440 \u043C\u043E\u0432\u0438 \u0437\u0431\u0435\u0440\u0456\u0433\u0430\u0454\u0442\u044C\u0441\u044F \u0443 \u0432\u0430\u0448\u043E\u043C\u0443 \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u043E\u043C\u0443 \u0437\u0430\u043F\u0438\u0441\u0456, \u043F\u0456\u0441\u043B\u044F \u0447\u043E\u0433\u043E \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0430 \u043F\u0435\u0440\u0435\u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0443\u0454\u0442\u044C\u0441\u044F.",
        en: "Picking a language saves it to your account and reloads the page.",
        hy: "\u053C\u0565\u0566\u057E\u056B \u0568\u0576\u057F\u0580\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0568 \u057A\u0561\u0570\u057E\u0578\u0582\u0574 \u0567 \u0571\u0565\u0580 \u0570\u0561\u0577\u057E\u0578\u0582\u0574, \u0578\u0580\u056B\u0581 \u0570\u0565\u057F\u0578 \u0567\u057B\u0568 \u057E\u0565\u0580\u0561\u0562\u0565\u057C\u0576\u057E\u0578\u0582\u0574 \u0567\u0589",
        ka: "\u10D4\u10DC\u10D8\u10E1 \u10D0\u10E0\u10E9\u10D4\u10D5\u10D0 \u10D8\u10DC\u10D0\u10EE\u10D4\u10D1\u10D0 \u10D7\u10E5\u10D5\u10D4\u10DC\u10E1 \u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10E8\u10D8 \u10D3\u10D0 \u10D2\u10D5\u10D4\u10E0\u10D3\u10D8 \u10D7\u10D0\u10D5\u10D8\u10D3\u10D0\u10DC \u10D8\u10E2\u10D5\u10D8\u10E0\u10D7\u10D4\u10D1\u10D0."
    },
    account_b2: {
        uk: "\u041C\u0456\u0439 \u043F\u0440\u043E\u0444\u0430\u0439\u043B: \u0456\u043C\u02BC\u044F, \u043F\u043E\u0441\u0430\u0434\u0430, Telegram, \u0440\u0435\u0433\u0456\u043E\u043D, \u0444\u043E\u0442\u043E. \u0422\u0435\u043B\u0435\u0444\u043E\u043D \u0456 \u0440\u043E\u043B\u044C \u0437\u043C\u0456\u043D\u0438\u0442\u0438 \u043D\u0435 \u043C\u043E\u0436\u043D\u0430.",
        en: "My profile: name, position, Telegram, county, photo. The phone number and role are read-only.",
        hy: "\u053B\u0574 \u057A\u0580\u0578\u0586\u056B\u056C\u0568\u055D \u0561\u0576\u0578\u0582\u0576, \u057A\u0561\u0577\u057F\u0578\u0576, Telegram, \u0574\u0561\u0580\u0566, \u056C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580\u0589 \u0540\u0565\u057C\u0561\u056D\u0578\u057D\u0568 \u0587 \u0564\u0565\u0580\u0568 \u0583\u0578\u056D\u0565\u056C \u0570\u0576\u0561\u0580\u0561\u057E\u0578\u0580 \u0579\u0567\u0589",
        ka: "\u10E9\u10D4\u10DB\u10D8 \u10DE\u10E0\u10DD\u10E4\u10D8\u10DA\u10D8: \u10E1\u10D0\u10EE\u10D4\u10DA\u10D8, \u10D7\u10D0\u10DC\u10D0\u10DB\u10D3\u10D4\u10D1\u10DD\u10D1\u10D0, Telegram, \u10E0\u10D4\u10D2\u10D8\u10DD\u10DC\u10D8, \u10E4\u10DD\u10E2\u10DD. \u10E2\u10D4\u10DA\u10D4\u10E4\u10DD\u10DC\u10D8 \u10D3\u10D0 \u10E0\u10DD\u10DA\u10D8 \u10D0\u10E0 \u10D8\u10EA\u10D5\u10DA\u10D4\u10D1\u10D0."
    },
    account_b3: {
        uk: "\u041A\u043D\u043E\u043F\u043A\u0430 \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043D\u044F \u0437\u02BC\u044F\u0432\u043B\u044F\u0454\u0442\u044C\u0441\u044F \u0432\u043D\u0438\u0437\u0443 \u043B\u0438\u0448\u0435 \u0442\u043E\u0434\u0456, \u043A\u043E\u043B\u0438 \u0449\u043E\u0441\u044C \u0437\u043C\u0456\u043D\u0435\u043D\u043E.",
        en: "Save appears at the bottom only when something has changed.",
        hy: "\u054A\u0561\u0570\u057A\u0561\u0576\u0565\u056C\u0578\u0582 \u056F\u0578\u0573\u0561\u056F\u0568 \u0576\u0565\u0580\u0584\u0587\u0578\u0582\u0574 \u0570\u0561\u0575\u057F\u0576\u057E\u0578\u0582\u0574 \u0567 \u0574\u056B\u0561\u0575\u0576 \u0561\u0575\u0576 \u056A\u0561\u0574\u0561\u0576\u0561\u056F, \u0565\u0580\u0562 \u056B\u0576\u0579-\u0578\u0580 \u0562\u0561\u0576 \u0583\u0578\u056D\u057E\u0565\u056C \u0567\u0589",
        ka: "\u10E8\u10D4\u10DC\u10D0\u10EE\u10D5\u10D8\u10E1 \u10E6\u10D8\u10DA\u10D0\u10D9\u10D8 \u10E5\u10D5\u10D4\u10DB\u10DD\u10D7 \u10E9\u10DC\u10D3\u10D4\u10D1\u10D0 \u10DB\u10EE\u10DD\u10DA\u10DD\u10D3 \u10DB\u10D0\u10E8\u10D8\u10DC, \u10E0\u10DD\u10EA\u10D0 \u10E0\u10D0\u10DB\u10D4 \u10E8\u10D4\u10D8\u10EA\u10D5\u10D0\u10DA\u10D0."
    },
    account_b4: {
        uk: "\xab\u0414\u043E\u043F\u043E\u043C\u043E\u0433\u0430\xbb \u0432\u0456\u0434\u043A\u0440\u0438\u0432\u0430\u0454 \u0446\u044E \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443, \xab\u0412\u0438\u0439\u0442\u0438\xbb \u0437\u0430\u0432\u0435\u0440\u0448\u0443\u0454 \u0441\u0435\u0430\u043D\u0441.",
        en: "Help opens this page; Sign out ends the session.",
        hy: "\xab\u0555\u0563\u0576\u0578\u0582\u0569\u0575\u0578\u0582\u0576\xbb-\u0568 \u0562\u0561\u0581\u0578\u0582\u0574 \u0567 \u0561\u0575\u057D \u0567\u057B\u0568, \xab\u0535\u056C\u0584\xbb-\u0568 \u0561\u057E\u0561\u0580\u057F\u0578\u0582\u0574 \u0567 \u0576\u057D\u057F\u0561\u0577\u0580\u057B\u0561\u0576\u0568\u0589",
        ka: "\xab\u10D3\u10D0\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10D0\xbb \u10EE\u10E1\u10DC\u10D8\u10E1 \u10D0\u10DB \u10D2\u10D5\u10D4\u10E0\u10D3\u10E1, \xab\u10D2\u10D0\u10E1\u10D5\u10DA\u10D0\xbb \u10D0\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10E1 \u10E1\u10D4\u10E1\u10D8\u10D0\u10E1."
    },
    /* --- the common list grammar --- */ lists_title: {
        uk: "\u042F\u043A \u043F\u0440\u0430\u0446\u044E\u044E\u0442\u044C \u0441\u043F\u0438\u0441\u043A\u0438",
        en: "How lists work",
        hy: "\u053B\u0576\u0579\u057A\u0565\u057D \u0565\u0576 \u0561\u0577\u056D\u0561\u057F\u0578\u0582\u0574 \u0581\u0578\u0582\u0581\u0561\u056F\u0576\u0565\u0580\u0568",
        ka: "\u10E0\u10DD\u10D2\u10DD\u10E0 \u10DB\u10E3\u10E8\u10D0\u10DD\u10D1\u10E1 \u10E1\u10D8\u10D4\u10D1\u10D8"
    },
    lists_desc: {
        uk: "\u0412\u0456\u0437\u0438\u0442\u0438, \u0437\u0430\u0434\u0430\u0447\u0456, \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0456, \u043C\u0435\u0440\u0447\u0430\u043D\u0434\u0430\u0439\u0437\u0435\u0440\u0438, \u0442\u043E\u0447\u043A\u0438 \u0442\u0430 \u0456\u043D\u0448\u0456 \u0441\u043F\u0438\u0441\u043A\u0438 \u043C\u0430\u044E\u0442\u044C \u043E\u0434\u043D\u0430\u043A\u043E\u0432\u0456 \u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0438 \u043A\u0435\u0440\u0443\u0432\u0430\u043D\u043D\u044F. \u0414\u043E\u0441\u0438\u0442\u044C \u0432\u0438\u0432\u0447\u0438\u0442\u0438 \u0457\u0445 \u043E\u0434\u0438\u043D \u0440\u0430\u0437.",
        en: "Visits, tasks, answers, merchandisers, points and the other lists share one set of controls. Learn them once.",
        hy: "\u0531\u0575\u0581\u0565\u0580\u0568, \u0561\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0576\u0565\u0580\u0568, \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0576\u0565\u0580\u0568, \u0574\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580\u0576\u0565\u0580\u0568, \u056F\u0565\u057F\u0565\u0580\u0568 \u0587 \u0574\u0575\u0578\u0582\u057D \u0581\u0578\u0582\u0581\u0561\u056F\u0576\u0565\u0580\u0568 \u0578\u0582\u0576\u0565\u0576 \u0576\u0578\u0582\u0575\u0576 \u056F\u0561\u057C\u0561\u057E\u0561\u0580\u0574\u0561\u0576 \u057F\u0561\u0580\u0580\u0565\u0580\u0568\u0589 \u0532\u0561\u057E\u0561\u056F\u0561\u0576 \u0567 \u0564\u0580\u0561\u0576\u0584 \u0574\u0565\u056F \u0561\u0576\u0563\u0561\u0574 \u057D\u0578\u057E\u0578\u0580\u0565\u056C\u0589",
        ka: "\u10D5\u10D8\u10D6\u10D8\u10E2\u10D4\u10D1\u10E1, \u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D4\u10D1\u10E1, \u10DE\u10D0\u10E1\u10E3\u10EE\u10D4\u10D1\u10E1, \u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D4\u10D1\u10E1, \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10E1\u10D0 \u10D3\u10D0 \u10E1\u10EE\u10D5\u10D0 \u10E1\u10D8\u10D4\u10D1\u10E1 \u10D4\u10E0\u10D7\u10D8 \u10D3\u10D0 \u10D8\u10D2\u10D8\u10D5\u10D4 \u10DB\u10D0\u10E0\u10D7\u10D5\u10D8\u10E1 \u10D4\u10DA\u10D4\u10DB\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8 \u10D0\u10E5\u10D5\u10E1. \u10E1\u10D0\u10D9\u10DB\u10D0\u10E0\u10D8\u10E1\u10D8\u10D0 \u10D4\u10E0\u10D7\u10EE\u10D4\u10DA \u10D8\u10E1\u10EC\u10D0\u10D5\u10DA\u10DD\u10D7."
    },
    lists_b1: {
        uk: "\u0424\u0456\u043B\u044C\u0442\u0440\u0438 \u0437\u0430\u0441\u0442\u043E\u0441\u043E\u0432\u0443\u044E\u0442\u044C\u0441\u044F \u043E\u0434\u0440\u0430\u0437\u0443, \u043A\u043D\u043E\u043F\u043A\u0438 \xab\u0417\u0430\u0441\u0442\u043E\u0441\u0443\u0432\u0430\u0442\u0438\xbb \u043D\u0435\u043C\u0430\u0454. \u0417\u0430\u0441\u0442\u043E\u0441\u043E\u0432\u0430\u043D\u0456 \u0444\u0456\u043B\u044C\u0442\u0440\u0438 \u043F\u043E\u043A\u0430\u0437\u0430\u043D\u0456 \u044F\u043A \u043C\u0456\u0442\u043A\u0438, \u044F\u043A\u0456 \u043C\u043E\u0436\u043D\u0430 \u043F\u0440\u0438\u0431\u0440\u0430\u0442\u0438.",
        en: "Filters apply as you change them; there is no Apply button. Applied filters show as chips you can remove.",
        hy: "\u0536\u057F\u056B\u0579\u0576\u0565\u0580\u0568 \u056F\u056B\u0580\u0561\u057C\u057E\u0578\u0582\u0574 \u0565\u0576 \u0583\u0578\u056D\u0565\u056C\u0578\u0582\u0576 \u057A\u0565\u057D, \xab\u053F\u056B\u0580\u0561\u057C\u0565\u056C\xbb \u056F\u0578\u0573\u0561\u056F \u0579\u056F\u0561\u0589 \u053F\u056B\u0580\u0561\u057C\u057E\u0561\u056E \u0566\u057F\u056B\u0579\u0576\u0565\u0580\u0568 \u0581\u0578\u0582\u0581\u0561\u0564\u0580\u057E\u0578\u0582\u0574 \u0565\u0576 \u057A\u056B\u057F\u0561\u056F\u0576\u0565\u0580\u056B \u057F\u0565\u057D\u0584\u0578\u057E, \u0578\u0580\u0578\u0576\u0584 \u056F\u0561\u0580\u0565\u056C\u056B \u0567 \u0570\u0565\u057C\u0561\u0581\u0576\u0565\u056C\u0589",
        ka: "\u10E4\u10D8\u10DA\u10E2\u10E0\u10D4\u10D1\u10D8 \u10DB\u10D0\u10E8\u10D8\u10DC\u10D5\u10D4 \u10DB\u10DD\u10E5\u10DB\u10D4\u10D3\u10D4\u10D1\u10E1, \xab\u10D2\u10D0\u10DB\u10DD\u10E7\u10D4\u10DC\u10D4\u10D1\u10D0\xbb \u10E6\u10D8\u10DA\u10D0\u10D9\u10D8 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1. \u10D2\u10D0\u10DB\u10DD\u10E7\u10D4\u10DC\u10D4\u10D1\u10E3\u10DA\u10D8 \u10E4\u10D8\u10DA\u10E2\u10E0\u10D4\u10D1\u10D8 \u10E9\u10D0\u10DC\u10E1 \u10E9\u10D8\u10DE\u10D4\u10D1\u10D0\u10D3, \u10E0\u10DD\u10DB\u10DA\u10D4\u10D1\u10D8\u10EA \u10E8\u10D4\u10D2\u10D8\u10EB\u10DA\u10D8\u10D0\u10D7 \u10DB\u10DD\u10EE\u10E1\u10DC\u10D0\u10D7."
    },
    lists_b2: {
        uk: "\u041F\u0435\u0440\u0456\u043E\u0434 \u043E\u0431\u043C\u0435\u0436\u0435\u043D\u0438\u0439: 14 \u0434\u043D\u0456\u0432 \u0437\u0430 \u0437\u0430\u043C\u043E\u0432\u0447\u0443\u0432\u0430\u043D\u043D\u044F\u043C, \u0434\u043E 90 \u0434\u043D\u0456\u0432 \u0443 \u0431\u0456\u043B\u044C\u0448\u043E\u0441\u0442\u0456 \u0441\u043F\u0438\u0441\u043A\u0456\u0432 \u0456 62 \u0434\u043D\u0456 \u0443 \u0444\u043E\u0442\u043E\u0437\u0432\u0456\u0442\u0456. \u0417\u0430\u0434\u0430\u0447\u0456 \u0444\u0456\u043B\u044C\u0442\u0440\u0443\u044E\u0442\u044C\u0441\u044F \u0437\u0430 \u0434\u0435\u0434\u043B\u0430\u0439\u043D\u043E\u043C, \u0442\u043E\u043C\u0443 \u0442\u0430\u043C \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0456 \u043C\u0430\u0439\u0431\u0443\u0442\u043D\u0456 \u0434\u0430\u0442\u0438.",
        en: "The period is capped: 14 days by default, up to 90 days on most lists and 62 days on the photo report. Tasks filter by deadline, so future dates are allowed there.",
        hy: "\u053A\u0561\u0574\u0561\u0576\u0561\u056F\u0561\u0570\u0561\u057F\u057E\u0561\u056E\u0568 \u057D\u0561\u0570\u0574\u0561\u0576\u0561\u0583\u0561\u056F \u0567\u055D \u056C\u057C\u0565\u056C\u0575\u0561\u0575\u0576 14 \u0585\u0580, \u0581\u0578\u0582\u0581\u0561\u056F\u0576\u0565\u0580\u056B \u0574\u0565\u056E \u0574\u0561\u057D\u0578\u0582\u0574 \u0574\u056B\u0576\u0579\u0587 90 \u0585\u0580, \u056C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580\u0576\u0565\u0580\u056B \u0570\u0561\u0577\u057E\u0565\u057F\u057E\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0578\u0582\u0574\u055D 62 \u0585\u0580\u0589 \u0531\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0576\u0565\u0580\u0568 \u0566\u057F\u057E\u0578\u0582\u0574 \u0565\u0576 \u057E\u0565\u0580\u057B\u0576\u0561\u056A\u0561\u0574\u056F\u0565\u057F\u0578\u057E, \u0561\u0575\u0576\u057A\u0565\u057D \u0578\u0580 \u0561\u0575\u0576\u057F\u0565\u0572 \u0561\u057A\u0561\u0563\u0561 \u0561\u0574\u057D\u0561\u0569\u057E\u0565\u0580\u0568 \u0570\u0561\u057D\u0561\u0576\u0565\u056C\u056B \u0565\u0576\u0589",
        ka: "\u10DE\u10D4\u10E0\u10D8\u10DD\u10D3\u10D8 \u10E8\u10D4\u10D6\u10E6\u10E3\u10D3\u10E3\u10DA\u10D8\u10D0: \u10DC\u10D0\u10D2\u10E3\u10DA\u10D8\u10E1\u10EE\u10DB\u10D4\u10D5\u10D0\u10D3 14 \u10D3\u10E6\u10D4, \u10E1\u10D8\u10D4\u10D1\u10D8\u10E1 \u10E3\u10DB\u10D4\u10E2\u10D4\u10E1\u10DD\u10D1\u10D0\u10E8\u10D8 90 \u10D3\u10E6\u10D4\u10DB\u10D3\u10D4, \u10E4\u10DD\u10E2\u10DD\u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10E8\u10D8 62 \u10D3\u10E6\u10D4. \u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8 \u10D5\u10D0\u10D3\u10D8\u10E1 \u10DB\u10D8\u10EE\u10D4\u10D3\u10D5\u10D8\u10D7 \u10D8\u10E4\u10D8\u10DA\u10E2\u10E0\u10D4\u10D1\u10D0, \u10D0\u10DB\u10D8\u10E2\u10DD\u10DB \u10D8\u10E5 \u10DB\u10DD\u10DB\u10D0\u10D5\u10D0\u10DA\u10D8 \u10D7\u10D0\u10E0\u10D8\u10E6\u10D4\u10D1\u10D8\u10EA \u10E8\u10D4\u10D8\u10EB\u10DA\u10D4\u10D1\u10D0."
    },
    lists_b3: {
        uk: "\u0410\u0434\u0440\u0435\u0441\u043D\u0438\u0439 \u0440\u044F\u0434\u043E\u043A \u043C\u0456\u0441\u0442\u0438\u0442\u044C \u0444\u0456\u043B\u044C\u0442\u0440\u0438, \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443 \u0439 \u0441\u043E\u0440\u0442\u0443\u0432\u0430\u043D\u043D\u044F, \u0442\u043E\u0436 \u0441\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u0435 \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u0432\u0456\u0434\u043A\u0440\u0438\u0432\u0430\u0454 \u0442\u043E\u0439 \u0441\u0430\u043C\u0438\u0439 \u0432\u0438\u0433\u043B\u044F\u0434, \u0430 \xab\u041D\u0430\u0437\u0430\u0434\xbb \u043F\u043E\u0432\u0435\u0440\u0442\u0430\u0454 \u0434\u043E \u043D\u044C\u043E\u0433\u043E.",
        en: "The address bar holds the filters, page and sort, so a copied link opens the same view and Back returns to it.",
        hy: "\u0540\u0561\u057D\u0581\u0565\u056B \u057F\u0578\u0572\u0568 \u057A\u0561\u0570\u0578\u0582\u0574 \u0567 \u0566\u057F\u056B\u0579\u0576\u0565\u0580\u0568, \u0567\u057B\u0568 \u0587 \u0564\u0561\u057D\u0561\u057E\u0578\u0580\u0578\u0582\u0574\u0568, \u0561\u0575\u0576\u057A\u0565\u057D \u0578\u0580 \u057A\u0561\u057F\u0573\u0565\u0576\u057E\u0561\u056E \u0570\u0572\u0578\u0582\u0574\u0568 \u0562\u0561\u0581\u0578\u0582\u0574 \u0567 \u0576\u0578\u0582\u0575\u0576 \u057F\u0565\u057D\u0584\u0568, \u056B\u057D\u056F \xab\u0540\u0565\u057F\xbb-\u0568 \u057E\u0565\u0580\u0561\u0564\u0561\u0580\u0571\u0576\u0578\u0582\u0574 \u0567 \u0564\u0580\u0561\u0576\u0589",
        ka: "\u10DB\u10D8\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10D8\u10E1 \u10D5\u10D4\u10DA\u10D8 \u10D8\u10DC\u10D0\u10EE\u10D0\u10D5\u10E1 \u10E4\u10D8\u10DA\u10E2\u10E0\u10D4\u10D1\u10E1, \u10D2\u10D5\u10D4\u10E0\u10D3\u10E1\u10D0 \u10D3\u10D0 \u10D3\u10D0\u10DA\u10D0\u10D2\u10D4\u10D1\u10D0\u10E1, \u10D0\u10E1\u10D4 \u10E0\u10DD\u10DB \u10D9\u10DD\u10DE\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8 \u10D1\u10DB\u10E3\u10DA\u10D8 \u10D8\u10DB\u10D0\u10D5\u10D4 \u10EE\u10D4\u10D3\u10E1 \u10EE\u10E1\u10DC\u10D8\u10E1 \u10D3\u10D0 \xab\u10E3\u10D9\u10D0\u10DC\xbb \u10DB\u10D0\u10E1\u10D6\u10D4 \u10D0\u10D1\u10E0\u10E3\u10DC\u10D4\u10D1\u10E1."
    },
    lists_b4: {
        uk: "\u0421\u043E\u0440\u0442\u0443\u044E\u0442\u044C\u0441\u044F \u043B\u0438\u0448\u0435 \u0442\u0456 \u043A\u043E\u043B\u043E\u043D\u043A\u0438, \u044F\u043A\u0456 \u043C\u043E\u0436\u0435 \u0432\u0456\u0434\u0441\u043E\u0440\u0442\u0443\u0432\u0430\u0442\u0438 \u0441\u0435\u0440\u0432\u0435\u0440. \xab\u0417\u0430\u043F\u0438\u0441\u0456\u0432: N\xbb \u043F\u0456\u0434 \u0442\u0430\u0431\u043B\u0438\u0446\u0435\u044E \u2014 \u0437\u0430\u0433\u0430\u043B\u044C\u043D\u0430 \u043A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C \u0437\u0430 \u043F\u043E\u0442\u043E\u0447\u043D\u0438\u043C\u0438 \u0444\u0456\u043B\u044C\u0442\u0440\u0430\u043C\u0438.",
        en: "Only columns the server can sort are sortable. \xabRecords: N\xbb under the table is the total for the current filters.",
        hy: "\u0534\u0561\u057D\u0561\u057E\u0578\u0580\u057E\u0578\u0582\u0574 \u0565\u0576 \u0574\u056B\u0561\u0575\u0576 \u0561\u0575\u0576 \u057D\u0575\u0578\u0582\u0576\u0561\u056F\u0576\u0565\u0580\u0568, \u0578\u0580\u0578\u0576\u0584 \u057D\u0565\u0580\u057E\u0565\u0580\u0568 \u056F\u0561\u0580\u0578\u0572 \u0567 \u0564\u0561\u057D\u0561\u057E\u0578\u0580\u0565\u056C\u0589 \u0531\u0572\u0575\u0578\u0582\u057D\u0561\u056F\u056B \u057F\u0561\u056F \u0563\u057F\u0576\u057E\u0578\u0572 \xab\u0533\u0580\u0561\u057C\u0578\u0582\u0574\u0576\u0565\u0580\u055D N\xbb-\u0568 \u0568\u0576\u0569\u0561\u0581\u056B\u056F \u0566\u057F\u056B\u0579\u0576\u0565\u0580\u0578\u057E \u0568\u0576\u0564\u0570\u0561\u0576\u0578\u0582\u0580 \u0584\u0561\u0576\u0561\u056F\u0576 \u0567\u0589",
        ka: "\u10D3\u10D0\u10DA\u10D0\u10D2\u10D4\u10D1\u10D0 \u10DB\u10EE\u10DD\u10DA\u10DD\u10D3 \u10D8\u10DB \u10E1\u10D5\u10D4\u10E2\u10D4\u10D1\u10D8\u10D7 \u10E8\u10D4\u10D8\u10EB\u10DA\u10D4\u10D1\u10D0, \u10E0\u10DD\u10DB\u10DA\u10D4\u10D1\u10E1\u10D0\u10EA \u10E1\u10D4\u10E0\u10D5\u10D4\u10E0\u10D8 \u10D0\u10DA\u10D0\u10D2\u10D4\u10D1\u10E1. \u10EA\u10EE\u10E0\u10D8\u10DA\u10D8\u10E1 \u10E5\u10D5\u10D4\u10E8 \xab\u10E9\u10D0\u10DC\u10D0\u10EC\u10D4\u10E0\u10D4\u10D1\u10D8: N\xbb \u10DB\u10D8\u10DB\u10D3\u10D8\u10DC\u10D0\u10E0\u10D4 \u10E4\u10D8\u10DA\u10E2\u10E0\u10D4\u10D1\u10D8\u10E1 \u10EF\u10D0\u10DB\u10E3\u10E0\u10D8 \u10E0\u10D0\u10DD\u10D3\u10D4\u10DC\u10DD\u10D1\u10D0\u10D0."
    },
    lists_b5: {
        uk: "\u0412\u0438\u0434\u0456\u043B\u0456\u0442\u044C \u0440\u044F\u0434\u043A\u0438 \u0434\u043B\u044F \u043C\u0430\u0441\u043E\u0432\u043E\u0457 \u0434\u0456\u0457. \xab\u0412\u0438\u0431\u0440\u0430\u0442\u0438 \u0432\u0441\u0435\xbb \u0432\u0438\u0434\u0456\u043B\u044F\u0454 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u0443 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0443, \u0430 \u043D\u0435 \u0432\u0441\u0456 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u043D\u0456 \u0437\u0430\u043F\u0438\u0441\u0438.",
        en: "Select rows for a bulk action. \xabSelect all\xbb selects the loaded page, not every matching record.",
        hy: "\u0538\u0576\u057F\u0580\u0565\u0584 \u057F\u0578\u0572\u0565\u0580\u0568 \u0566\u0561\u0576\u0563\u057E\u0561\u056E\u0561\u0575\u056B\u0576 \u0563\u0578\u0580\u056E\u0578\u0572\u0578\u0582\u0569\u0575\u0561\u0576 \u0570\u0561\u0574\u0561\u0580\u0589 \xab\u0538\u0576\u057F\u0580\u0565\u056C \u0562\u0578\u056C\u0578\u0580\u0568\xbb \u0568\u0576\u057F\u0580\u0578\u0582\u0574 \u0567 \u0562\u0565\u057C\u0576\u057E\u0561\u056E \u0567\u057B\u0568, \u0578\u0579 \u0569\u0565 \u0562\u0578\u056C\u0578\u0580 \u0570\u0561\u0574\u0561\u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576 \u0563\u0580\u0561\u057C\u0578\u0582\u0574\u0576\u0565\u0580\u0568\u0589",
        ka: "\u10DB\u10DD\u10DC\u10D8\u10E8\u10DC\u10D4\u10D7 \u10E1\u10E2\u10E0\u10D8\u10E5\u10DD\u10DC\u10D4\u10D1\u10D8 \u10EF\u10D2\u10E3\u10E4\u10E3\u10E0\u10D8 \u10DB\u10DD\u10E5\u10DB\u10D4\u10D3\u10D4\u10D1\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1. \xab\u10E7\u10D5\u10D4\u10DA\u10D0\u10E1 \u10DB\u10DD\u10DC\u10D8\u10E8\u10D5\u10DC\u10D0\xbb \u10DB\u10DD\u10DC\u10D8\u10E8\u10DC\u10D0\u10D5\u10E1 \u10E9\u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10E3\u10DA \u10D2\u10D5\u10D4\u10E0\u10D3\u10E1 \u10D3\u10D0 \u10D0\u10E0\u10D0 \u10E7\u10D5\u10D4\u10DA\u10D0 \u10E8\u10D4\u10E1\u10D0\u10D1\u10D0\u10DB\u10D8\u10E1 \u10E9\u10D0\u10DC\u10D0\u10EC\u10D4\u10E0\u10E1."
    },
    lists_b6: {
        uk: "\u0410\u0440\u0445\u0456\u0432\u0443\u0432\u0430\u0442\u0438 \u0439 \u0434\u0435\u0430\u043A\u0442\u0438\u0432\u0443\u0432\u0430\u0442\u0438 \u2014 \u0440\u0456\u0437\u043D\u0456 \u0434\u0456\u0457: \u0430\u0440\u0445\u0456\u0432\u043E\u0432\u0430\u043D\u0438\u0439 \u0437\u0430\u043F\u0438\u0441 \u043F\u0440\u0438\u0445\u043E\u0432\u0430\u043D\u043E, \u0439\u043E\u0433\u043E \u043C\u043E\u0436\u043D\u0430 \u0432\u0456\u0434\u043D\u043E\u0432\u0438\u0442\u0438; \u0434\u0435\u0430\u043A\u0442\u0438\u0432\u043E\u0432\u0430\u043D\u0438\u0439 \u043B\u0438\u0448\u0430\u0454\u0442\u044C\u0441\u044F \u0432 \u0441\u043F\u0438\u0441\u043A\u0430\u0445 \u044F\u043A \u043D\u0435\u0430\u043A\u0442\u0438\u0432\u043D\u0438\u0439.",
        en: "Archive and Deactivate are different: an archived record is hidden and can be restored; a deactivated one stays in lists as inactive.",
        hy: "\u0531\u0580\u056D\u056B\u057E\u0561\u0581\u0576\u0565\u056C\u0568 \u0587 \u0561\u057A\u0561\u0561\u056F\u057F\u056B\u057E\u0561\u0581\u0576\u0565\u056C\u0568 \u057F\u0561\u0580\u0562\u0565\u0580 \u0563\u0578\u0580\u056E\u0578\u0572\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580 \u0565\u0576\u055D \u0561\u0580\u056D\u056B\u057E\u0561\u0581\u057E\u0561\u056E \u0563\u0580\u0561\u057C\u0578\u0582\u0574\u0568 \u0569\u0561\u0584\u0581\u057E\u0561\u056E \u0567 \u0587 \u056F\u0561\u0580\u0565\u056C\u056B \u0567 \u057E\u0565\u0580\u0561\u056F\u0561\u0576\u0563\u0576\u0565\u056C, \u0561\u057A\u0561\u0561\u056F\u057F\u056B\u057E\u0561\u0581\u057E\u0561\u056E\u0568 \u0574\u0576\u0578\u0582\u0574 \u0567 \u0581\u0578\u0582\u0581\u0561\u056F\u0576\u0565\u0580\u0578\u0582\u0574\u055D \u0578\u0579 \u0561\u056F\u057F\u056B\u057E\u0589",
        ka: "\u10D3\u10D0\u10D0\u10E0\u10E5\u10D8\u10D5\u10D4\u10D1\u10D0 \u10D3\u10D0 \u10D3\u10D4\u10D0\u10E5\u10E2\u10D8\u10D5\u10D0\u10EA\u10D8\u10D0 \u10E1\u10EE\u10D5\u10D0\u10D3\u10D0\u10E1\u10EE\u10D5\u10D0 \u10DB\u10DD\u10E5\u10DB\u10D4\u10D3\u10D4\u10D1\u10D0\u10D0: \u10D3\u10D0\u10D0\u10E0\u10E5\u10D8\u10D5\u10D4\u10D1\u10E3\u10DA\u10D8 \u10E9\u10D0\u10DC\u10D0\u10EC\u10D4\u10E0\u10D8 \u10D3\u10D0\u10DB\u10D0\u10DA\u10E3\u10DA\u10D8\u10D0 \u10D3\u10D0 \u10E8\u10D4\u10D8\u10EB\u10DA\u10D4\u10D1\u10D0 \u10D0\u10E6\u10D3\u10D2\u10D4\u10E1, \u10D3\u10D4\u10D0\u10E5\u10E2\u10D8\u10D5\u10D8\u10E0\u10D4\u10D1\u10E3\u10DA\u10D8 \u10E1\u10D8\u10D4\u10D1\u10E8\u10D8 \u10E0\u10E9\u10D4\u10D1\u10D0 \u10D0\u10E0\u10D0\u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D0\u10D3."
    },
    /* --- pages, in nav order --- */ overview_desc: {
        uk: "\u041E\u0434\u0438\u043D \u043C\u0456\u0441\u044F\u0446\u044C \u043A\u043E\u043C\u043F\u0430\u043D\u0456\u0457 \u043D\u0430 \u043E\u0434\u043D\u043E\u043C\u0443 \u0435\u043A\u0440\u0430\u043D\u0456: \u043B\u044E\u0434\u0438, \u0432\u0456\u0437\u0438\u0442\u0438, \u0437\u0432\u0456\u0442\u0438, \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0456 \u0439 \u043E\u043F\u0438\u0442\u0443\u0432\u0430\u043D\u043D\u044F \u0437\u0456 \u0437\u043C\u0456\u043D\u043E\u044E \u0432\u0456\u0434\u043D\u043E\u0441\u043D\u043E \u043F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u044C\u043E\u0433\u043E \u043C\u0456\u0441\u044F\u0446\u044F.",
        en: "One month of the company at a glance: people, visits, reports, answers and surveys, with the change against the previous month.",
        hy: "\u0538\u0576\u056F\u0565\u0580\u0578\u0582\u0569\u0575\u0561\u0576 \u0574\u0565\u056F \u0561\u0574\u056B\u057D\u0568 \u0574\u0565\u056F \u0567\u056F\u0580\u0561\u0576\u056B\u0576\u055D \u0574\u0561\u0580\u0564\u056B\u056F, \u0561\u0575\u0581\u0565\u0580, \u0570\u0561\u0577\u057E\u0565\u057F\u057E\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580, \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0576\u0565\u0580 \u0587 \u0570\u0561\u0580\u0581\u0578\u0582\u0574\u0576\u0565\u0580 \u0576\u0561\u056D\u0578\u0580\u0564 \u0561\u0574\u057D\u057E\u0561 \u0570\u0561\u0574\u0565\u0574\u0561\u057F \u0583\u0578\u0583\u0578\u056D\u0578\u0582\u0569\u0575\u0561\u0574\u0562\u0589",
        ka: "\u10D9\u10DD\u10DB\u10DE\u10D0\u10DC\u10D8\u10D8\u10E1 \u10D4\u10E0\u10D7\u10D8 \u10D7\u10D5\u10D4 \u10D4\u10E0\u10D7 \u10D4\u10D9\u10E0\u10D0\u10DC\u10D6\u10D4: \u10D0\u10D3\u10D0\u10DB\u10D8\u10D0\u10DC\u10D4\u10D1\u10D8, \u10D5\u10D8\u10D6\u10D8\u10E2\u10D4\u10D1\u10D8, \u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10D4\u10D1\u10D8, \u10DE\u10D0\u10E1\u10E3\u10EE\u10D4\u10D1\u10D8 \u10D3\u10D0 \u10D2\u10D0\u10DB\u10DD\u10D9\u10D8\u10D7\u10EE\u10D5\u10D4\u10D1\u10D8 \u10EC\u10D8\u10DC\u10D0 \u10D7\u10D5\u10D4\u10E1\u10D7\u10D0\u10DC \u10EA\u10D5\u10DA\u10D8\u10DA\u10D4\u10D1\u10D8\u10D7."
    },
    overview_b1: {
        uk: "\u041F\u0435\u0440\u0435\u043C\u0438\u043A\u0430\u0447 \u043C\u0456\u0441\u044F\u0446\u044F \u0432\u0433\u043E\u0440\u0456 \u2014 \u0454\u0434\u0438\u043D\u0438\u0439 \u0435\u043B\u0435\u043C\u0435\u043D\u0442, \u0449\u043E \u043F\u0435\u0440\u0435\u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0443\u0454 \u0434\u0430\u043D\u0456.",
        en: "The month stepper at the top is the only control that reloads the data.",
        hy: "\u054E\u0565\u0580\u0587\u056B \u0561\u0574\u057D\u057E\u0561 \u0583\u0578\u056D\u0561\u0580\u056F\u056B\u0579\u0568 \u0574\u056B\u0561\u056F \u057F\u0561\u0580\u0580\u0576 \u0567, \u0578\u0580\u0568 \u057E\u0565\u0580\u0561\u0562\u0565\u057C\u0576\u0578\u0582\u0574 \u0567 \u057F\u057E\u0575\u0561\u056C\u0576\u0565\u0580\u0568\u0589",
        ka: "\u10D6\u10D4\u10D3\u10D0 \u10D7\u10D5\u10D8\u10E1 \u10D2\u10D0\u10D3\u10D0\u10DB\u10E0\u10D7\u10D5\u10D4\u10DA\u10D8 \u10D4\u10E0\u10D7\u10D0\u10D3\u10D4\u10E0\u10D7\u10D8 \u10D4\u10DA\u10D4\u10DB\u10D4\u10DC\u10E2\u10D8\u10D0, \u10E0\u10DD\u10DB\u10D4\u10DA\u10D8\u10EA \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10E1 \u10D7\u10D0\u10D5\u10D8\u10D3\u10D0\u10DC \u10E2\u10D5\u10D8\u10E0\u10D7\u10D0\u10D5\u10E1."
    },
    overview_b2: {
        uk: "\u041A\u0430\u0440\u0442\u043A\u0438 KPI \u043F\u043E\u043A\u0430\u0437\u0443\u044E\u0442\u044C \u043F\u0456\u0434\u0441\u0443\u043C\u043E\u043A \u0437\u0430 \u043C\u0456\u0441\u044F\u0446\u044C \u0456 \u0440\u0456\u0437\u043D\u0438\u0446\u044E \u0437 \u043F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u0456\u043C \u043C\u0456\u0441\u044F\u0446\u0435\u043C.",
        en: "KPI cards show the month total and the delta against the previous month.",
        hy: "KPI \u0584\u0561\u0580\u057F\u0565\u0580\u0568 \u0581\u0578\u0582\u0575\u0581 \u0565\u0576 \u057F\u0561\u056C\u056B\u057D \u0561\u0574\u057D\u057E\u0561 \u0568\u0576\u0564\u0570\u0561\u0576\u0578\u0582\u0580\u0568 \u0587 \u0576\u0561\u056D\u0578\u0580\u0564 \u0561\u0574\u057D\u057E\u0561 \u0570\u0565\u057F \u057F\u0561\u0580\u0562\u0565\u0580\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0568\u0589",
        ka: "KPI \u10D1\u10D0\u10E0\u10D0\u10D7\u10D4\u10D1\u10D8 \u10D0\u10E9\u10D5\u10D4\u10DC\u10D4\u10D1\u10E1 \u10D7\u10D5\u10D8\u10E1 \u10EF\u10D0\u10DB\u10E1 \u10D3\u10D0 \u10EC\u10D8\u10DC\u10D0 \u10D7\u10D5\u10D4\u10E1\u10D7\u10D0\u10DC \u10E1\u10EE\u10D5\u10D0\u10DD\u10D1\u10D0\u10E1."
    },
    overview_b3: {
        uk: "\u0413\u0440\u0430\u0444\u0456\u043A\u0438: \u0430\u043A\u0442\u0438\u0432\u043D\u0456\u0441\u0442\u044C \u043F\u043E \u0434\u043D\u044F\u0445, \u0441\u0442\u0430\u0442\u0443\u0441\u0438 \u0432\u0456\u0437\u0438\u0442\u0456\u0432, \u043F\u043E\u0442\u0456\u043A \u0444\u043E\u0442\u043E, \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0456 \u0437\u0430 \u0442\u0438\u043F\u0430\u043C\u0438, \u0440\u0435\u0433\u0456\u043E\u043D\u0438, \u0430\u043A\u0442\u0438\u0432\u043D\u0456\u0441\u0442\u044C \u043E\u043F\u0438\u0442\u0443\u0432\u0430\u043D\u044C, \u043D\u0430\u0439\u0430\u043A\u0442\u0438\u0432\u043D\u0456\u0448\u0456 \u043C\u0435\u0440\u0447\u0430\u043D\u0434\u0430\u0439\u0437\u0435\u0440\u0438, \u043A\u0430\u043B\u0435\u043D\u0434\u0430\u0440 \u0432\u0456\u0437\u0438\u0442\u0456\u0432.",
        en: "Charts: activity by day, visit statuses, the photo pipeline, answers by type, counties, survey activity, top merchandisers, a visit calendar.",
        hy: "\u0533\u056E\u0561\u057A\u0561\u057F\u056F\u0565\u0580\u0576\u0565\u0580\u055D \u0561\u056F\u057F\u056B\u057E\u0578\u0582\u0569\u0575\u0578\u0582\u0576 \u0585\u0580\u0565\u0580\u0578\u057E, \u0561\u0575\u0581\u0565\u0580\u056B \u056F\u0561\u0580\u0563\u0561\u057E\u056B\u0573\u0561\u056F\u0576\u0565\u0580, \u056C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580\u0576\u0565\u0580\u056B \u0570\u0578\u057D\u0584, \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0576\u0565\u0580 \u0568\u057D\u057F \u057F\u0565\u057D\u0561\u056F\u056B, \u0574\u0561\u0580\u0566\u0565\u0580, \u0570\u0561\u0580\u0581\u0578\u0582\u0574\u0576\u0565\u0580\u056B \u0561\u056F\u057F\u056B\u057E\u0578\u0582\u0569\u0575\u0578\u0582\u0576, \u056C\u0561\u057E\u0561\u0563\u0578\u0582\u0575\u0576 \u0574\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580\u0576\u0565\u0580, \u0561\u0575\u0581\u0565\u0580\u056B \u0585\u0580\u0561\u0581\u0578\u0582\u0575\u0581\u0589",
        ka: "\u10D3\u10D8\u10D0\u10D2\u10E0\u10D0\u10DB\u10D4\u10D1\u10D8: \u10D0\u10E5\u10E2\u10D8\u10D5\u10DD\u10D1\u10D0 \u10D3\u10E6\u10D4\u10D4\u10D1\u10D8\u10E1 \u10DB\u10D8\u10EE\u10D4\u10D3\u10D5\u10D8\u10D7, \u10D5\u10D8\u10D6\u10D8\u10E2\u10D4\u10D1\u10D8\u10E1 \u10E1\u10E2\u10D0\u10E2\u10E3\u10E1\u10D4\u10D1\u10D8, \u10E4\u10DD\u10E2\u10DD\u10D4\u10D1\u10D8\u10E1 \u10DC\u10D0\u10D9\u10D0\u10D3\u10D8, \u10DE\u10D0\u10E1\u10E3\u10EE\u10D4\u10D1\u10D8 \u10E2\u10D8\u10DE\u10D4\u10D1\u10D8\u10E1 \u10DB\u10D8\u10EE\u10D4\u10D3\u10D5\u10D8\u10D7, \u10E0\u10D4\u10D2\u10D8\u10DD\u10DC\u10D4\u10D1\u10D8, \u10D2\u10D0\u10DB\u10DD\u10D9\u10D8\u10D7\u10EE\u10D5\u10D4\u10D1\u10D8\u10E1 \u10D0\u10E5\u10E2\u10D8\u10D5\u10DD\u10D1\u10D0, \u10E1\u10D0\u10E3\u10D9\u10D4\u10D7\u10D4\u10E1\u10DD \u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D4\u10D1\u10D8, \u10D5\u10D8\u10D6\u10D8\u10E2\u10D4\u10D1\u10D8\u10E1 \u10D9\u10D0\u10DA\u10D4\u10DC\u10D3\u10D0\u10E0\u10D8."
    },
    overview_b4: {
        uk: "\u0422\u0430\u0431\u043B\u0438\u0446\u044F \u043C\u0435\u0440\u0447\u0430\u043D\u0434\u0430\u0439\u0437\u0435\u0440\u0456\u0432 \u0443\u043D\u0438\u0437\u0443 \u0448\u0443\u043A\u0430\u0454 \u0439 \u043F\u0435\u0440\u0435\u0433\u043E\u0440\u0442\u0430\u0454 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438 \u043C\u0438\u0442\u0442\u0454\u0432\u043E, \u0431\u0435\u0437 \u043D\u043E\u0432\u043E\u0433\u043E \u0437\u0430\u043F\u0438\u0442\u0443.",
        en: "The merchandiser table at the bottom searches and pages instantly, without a new request.",
        hy: "\u0546\u0565\u0580\u0584\u0587\u056B \u0574\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580\u0576\u0565\u0580\u056B \u0561\u0572\u0575\u0578\u0582\u057D\u0561\u056F\u0568 \u0578\u0580\u0578\u0576\u0578\u0582\u0574 \u0587 \u0569\u0565\u0580\u0569\u0578\u0582\u0574 \u0567 \u0561\u0576\u0574\u056B\u057B\u0561\u057A\u0565\u057D, \u0561\u057C\u0561\u0576\u0581 \u0576\u0578\u0580 \u0570\u0561\u0580\u0581\u0574\u0561\u0576\u0589",
        ka: "\u10E5\u10D5\u10D4\u10D3\u10D0 \u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D4\u10D1\u10D8\u10E1 \u10EA\u10EE\u10E0\u10D8\u10DA\u10D8 \u10D4\u10EB\u10D4\u10D1\u10E1 \u10D3\u10D0 \u10D2\u10D5\u10D4\u10E0\u10D3\u10D4\u10D1\u10E1 \u10DB\u10E7\u10D8\u10E1\u10D8\u10D4\u10E0\u10D0\u10D3 \u10EA\u10D5\u10DA\u10D8\u10E1, \u10D0\u10EE\u10D0\u10DA\u10D8 \u10DB\u10DD\u10D7\u10EE\u10DD\u10D5\u10DC\u10D8\u10E1 \u10D2\u10D0\u10E0\u10D4\u10E8\u10D4."
    },
    photo_review_desc: {
        uk: "\u0424\u043E\u0442\u043E, \u0437\u0440\u043E\u0431\u043B\u0435\u043D\u0456 \u043C\u0435\u0440\u0447\u0430\u043D\u0434\u0430\u0439\u0437\u0435\u0440\u0430\u043C\u0438 \u0432 \u0442\u043E\u0447\u043A\u0430\u0445, \u0443 \u0432\u0438\u0433\u043B\u044F\u0434\u0456 \u0441\u0456\u0442\u043A\u0438, \u0433\u043E\u0442\u043E\u0432\u0456 \u0434\u043E \u0440\u0456\u0448\u0435\u043D\u043D\u044F. \u0422\u0443\u0442 \u0432\u0456\u0434\u0431\u0443\u0432\u0430\u0454\u0442\u044C\u0441\u044F \u0431\u0456\u043B\u044C\u0448\u0430 \u0447\u0430\u0441\u0442\u0438\u043D\u0430 \u0449\u043E\u0434\u0435\u043D\u043D\u043E\u0457 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u043A\u0438.",
        en: "Photos merchandisers took at points, in a grid, ready for a verdict. This is where most of the daily review happens.",
        hy: "\u0544\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580\u0576\u0565\u0580\u056B \u056F\u0565\u057F\u0565\u0580\u0578\u0582\u0574 \u0561\u0580\u057E\u0561\u056E \u056C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580\u0576\u0565\u0580\u0568 \u0581\u0561\u0576\u0581\u056B \u057F\u0565\u057D\u0584\u0578\u057E, \u057A\u0561\u057F\u0580\u0561\u057D\u057F \u0578\u0580\u0578\u0577\u0574\u0561\u0576\u0589 \u0531\u0575\u057D\u057F\u0565\u0572 \u0567 \u056F\u0561\u057F\u0561\u0580\u057E\u0578\u0582\u0574 \u0561\u0574\u0565\u0576\u0585\u0580\u0575\u0561 \u057D\u057F\u0578\u0582\u0563\u0574\u0561\u0576 \u0574\u0565\u056E \u0574\u0561\u057D\u0568\u0589",
        ka: "\u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D4\u10D1\u10D8\u10E1 \u10DB\u10D8\u10D4\u10E0 \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D6\u10D4 \u10D2\u10D0\u10D3\u10D0\u10E6\u10D4\u10D1\u10E3\u10DA\u10D8 \u10E4\u10DD\u10E2\u10DD\u10D4\u10D1\u10D8 \u10D1\u10D0\u10D3\u10D8\u10E1 \u10E1\u10D0\u10EE\u10D8\u10D7, \u10D2\u10D0\u10D3\u10D0\u10EC\u10E7\u10D5\u10D4\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1 \u10DB\u10D6\u10D0\u10D3. \u10E7\u10DD\u10D5\u10D4\u10DA\u10D3\u10E6\u10D8\u10E3\u10E0\u10D8 \u10E8\u10D4\u10DB\u10DD\u10EC\u10DB\u10D4\u10D1\u10D8\u10E1 \u10E3\u10DB\u10D4\u10E2\u10D4\u10E1\u10D8 \u10DC\u10D0\u10EC\u10D8\u10DA\u10D8 \u10D0\u10E5 \u10EE\u10D3\u10D4\u10D1\u10D0."
    },
    photo_review_b1: {
        uk: "\u0424\u0456\u043B\u044C\u0442\u0440\u0443\u0439\u0442\u0435 \u0437\u0430 \u043F\u0435\u0440\u0456\u043E\u0434\u043E\u043C (\u0434\u043E 62 \u0434\u043D\u0456\u0432), \u0440\u0435\u0433\u0456\u043E\u043D\u043E\u043C, \u043C\u0435\u0440\u0435\u0436\u0435\u044E, \u0442\u043E\u0447\u043A\u0430\u043C\u0438, \u043C\u0435\u0440\u0447\u0430\u043D\u0434\u0430\u0439\u0437\u0435\u0440\u0430\u043C\u0438, \u0442\u043E\u0432\u0430\u0440\u0430\u043C\u0438 \u0439 \u0442\u0435\u0433\u0430\u043C\u0438. \u041D\u0430\u0431\u0456\u0440 \u0444\u0456\u043B\u044C\u0442\u0440\u0456\u0432 \u043C\u043E\u0436\u043D\u0430 \u0437\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u044F\u043A \u0448\u0430\u0431\u043B\u043E\u043D.",
        en: "Filter by period (up to 62 days), county, network, points, merchandisers, products and tags. Save a filter set as a preset.",
        hy: "\u0536\u057F\u0565\u0584 \u0568\u057D\u057F \u056A\u0561\u0574\u0561\u0576\u0561\u056F\u0561\u0570\u0561\u057F\u057E\u0561\u056E\u056B (\u0574\u056B\u0576\u0579\u0587 62 \u0585\u0580), \u0574\u0561\u0580\u0566\u056B, \u0581\u0561\u0576\u0581\u056B, \u056F\u0565\u057F\u0565\u0580\u056B, \u0574\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580\u0576\u0565\u0580\u056B, \u0561\u057A\u0580\u0561\u0576\u0584\u0576\u0565\u0580\u056B \u0587 \u057A\u056B\u057F\u0561\u056F\u0576\u0565\u0580\u056B\u0589 \u0536\u057F\u056B\u0579\u0576\u0565\u0580\u056B \u0570\u0561\u057E\u0561\u0584\u0561\u056E\u0578\u0582\u0576 \u056F\u0561\u0580\u0565\u056C\u056B \u0567 \u057A\u0561\u0570\u0565\u056C \u0578\u0580\u057A\u0565\u057D \u0576\u0561\u056D\u0561\u057A\u0561\u057F\u0580\u0561\u057D\u057F\u0589",
        ka: "\u10D2\u10D0\u10E4\u10D8\u10DA\u10E2\u10E0\u10D4\u10D7 \u10DE\u10D4\u10E0\u10D8\u10DD\u10D3\u10D8\u10D7 (62 \u10D3\u10E6\u10D4\u10DB\u10D3\u10D4), \u10E0\u10D4\u10D2\u10D8\u10DD\u10DC\u10D8\u10D7, \u10E5\u10E1\u10D4\u10DA\u10D8\u10D7, \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8\u10D7, \u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D4\u10D1\u10D8\u10D7, \u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10E2\u10D4\u10D1\u10D8\u10D7\u10D0 \u10D3\u10D0 \u10E2\u10D4\u10D2\u10D4\u10D1\u10D8\u10D7. \u10E4\u10D8\u10DA\u10E2\u10E0\u10D4\u10D1\u10D8\u10E1 \u10DC\u10D0\u10D9\u10E0\u10D4\u10D1\u10D8 \u10E8\u10D4\u10D2\u10D8\u10EB\u10DA\u10D8\u10D0\u10D7 \u10E8\u10D0\u10D1\u10DA\u10DD\u10DC\u10D0\u10D3 \u10E8\u10D4\u10D8\u10DC\u10D0\u10EE\u10DD\u10D7."
    },
    photo_review_b2: {
        uk: "\u041F\u0435\u0440\u0435\u043C\u0438\u043A\u0430\u0447 \u0441\u0442\u0430\u0442\u0443\u0441\u0443 (\u043D\u0430 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0446\u0456, \u0441\u0445\u0432\u0430\u043B\u0435\u043D\u043E, \u0432\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043E) \u0437\u0432\u0443\u0436\u0443\u0454 \u0432\u0436\u0435 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u0456 \u0444\u043E\u0442\u043E; \u0437\u0430\u0433\u0430\u043B\u044C\u043D\u0430 \u043A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C \u043D\u0430 \u0446\u0456\u0439 \u0441\u0442\u043E\u0440\u0456\u043D\u0446\u0456 \u043D\u0435 \u043F\u043E\u043A\u0430\u0437\u0443\u0454\u0442\u044C\u0441\u044F.",
        en: "The status segment (pending, approved, rejected) narrows the photos already loaded; this page shows no total.",
        hy: "\u053F\u0561\u0580\u0563\u0561\u057E\u056B\u0573\u0561\u056F\u056B \u0583\u0578\u056D\u0561\u0580\u056F\u056B\u0579\u0568 (\u057D\u057A\u0561\u057D\u0578\u0582\u0574 \u0567, \u0570\u0561\u057D\u057F\u0561\u057F\u057E\u0561\u056E, \u0574\u0565\u0580\u056A\u057E\u0561\u056E) \u0576\u0565\u0572\u0561\u0581\u0576\u0578\u0582\u0574 \u0567 \u0561\u0580\u0564\u0565\u0576 \u0562\u0565\u057C\u0576\u057E\u0561\u056E \u056C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580\u0576\u0565\u0580\u0568. \u0561\u0575\u057D \u0567\u057B\u0578\u0582\u0574 \u0568\u0576\u0564\u0570\u0561\u0576\u0578\u0582\u0580 \u0584\u0561\u0576\u0561\u056F\u0568 \u0579\u056B \u0581\u0578\u0582\u0581\u0561\u0564\u0580\u057E\u0578\u0582\u0574\u0589",
        ka: "\u10E1\u10E2\u10D0\u10E2\u10E3\u10E1\u10D8\u10E1 \u10D2\u10D0\u10D3\u10D0\u10DB\u10E0\u10D7\u10D5\u10D4\u10DA\u10D8 (\u10DB\u10DD\u10DA\u10DD\u10D3\u10D8\u10DC\u10E8\u10D8, \u10D3\u10D0\u10DB\u10E2\u10D9\u10D8\u10EA\u10D4\u10D1\u10E3\u10DA\u10D8, \u10E3\u10D0\u10E0\u10E7\u10DD\u10E4\u10D8\u10DA\u10D8) \u10E3\u10D9\u10D5\u10D4 \u10E9\u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10E3\u10DA \u10E4\u10DD\u10E2\u10DD\u10D4\u10D1\u10E1 \u10D0\u10D5\u10D8\u10EC\u10E0\u10DD\u10D4\u10D1\u10E1; \u10D0\u10DB \u10D2\u10D5\u10D4\u10E0\u10D3\u10D6\u10D4 \u10EF\u10D0\u10DB\u10E3\u10E0\u10D8 \u10E0\u10D0\u10DD\u10D3\u10D4\u10DC\u10DD\u10D1\u10D0 \u10D0\u10E0 \u10E9\u10D0\u10DC\u10E1."
    },
    photo_review_b3: {
        uk: "\u0421\u0445\u0432\u0430\u043B\u044E\u0439\u0442\u0435 \u043F\u0440\u044F\u043C\u043E \u0437 \u043A\u0430\u0440\u0442\u043A\u0438 \u0430\u0431\u043E \u0432\u0456\u0434\u0445\u0438\u043B\u044F\u0439\u0442\u0435 \u0437 \u043F\u0440\u0438\u0447\u0438\u043D\u043E\u044E. \u0412\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043D\u044F \u0441\u0442\u0432\u043E\u0440\u044E\u0454 \u0434\u043B\u044F \u043C\u0435\u0440\u0447\u0430\u043D\u0434\u0430\u0439\u0437\u0435\u0440\u0430 \u043A\u043E\u0440\u0438\u0433\u0443\u0432\u0430\u043B\u044C\u043D\u0443 \u0437\u0430\u0434\u0430\u0447\u0443.",
        en: "Approve from the card, or reject with a reason. A rejection creates a corrective task for the merchandiser.",
        hy: "\u0540\u0561\u057D\u057F\u0561\u057F\u0565\u0584 \u0561\u0576\u0574\u056B\u057B\u0561\u057A\u0565\u057D \u0584\u0561\u0580\u057F\u056B\u0581 \u056F\u0561\u0574 \u0574\u0565\u0580\u056A\u0565\u0584 \u057A\u0561\u057F\u0573\u0561\u057C\u0578\u057E\u0589 \u0544\u0565\u0580\u056A\u0578\u0582\u0574\u0568 \u0574\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580\u056B \u0570\u0561\u0574\u0561\u0580 \u0578\u0582\u0572\u0572\u056B\u0579 \u0561\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584 \u0567 \u057D\u057F\u0565\u0572\u056E\u0578\u0582\u0574\u0589",
        ka: "\u10D3\u10D0\u10D0\u10DB\u10E2\u10D9\u10D8\u10EA\u10D4\u10D7 \u10DE\u10D8\u10E0\u10D3\u10D0\u10DE\u10D8\u10E0 \u10D1\u10D0\u10E0\u10D0\u10D7\u10D8\u10D3\u10D0\u10DC \u10D0\u10DC \u10E3\u10D0\u10E0\u10E7\u10D0\u10D5\u10D8\u10D7 \u10DB\u10D8\u10D6\u10D4\u10D6\u10D8\u10D7. \u10E3\u10D0\u10E0\u10E7\u10DD\u10E4\u10D0 \u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10E1 \u10DB\u10D0\u10D9\u10DD\u10E0\u10D4\u10E5\u10E2\u10D8\u10E0\u10D4\u10D1\u10D4\u10DA \u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D0\u10E1 \u10E3\u10E5\u10DB\u10DC\u10D8\u10E1."
    },
    photo_review_b4: {
        uk: "\u0423 \u043F\u0435\u0440\u0435\u0433\u043B\u044F\u0434\u0430\u0447\u0456: \u2190 \u2192 \u043F\u0435\u0440\u0435\u0445\u0456\u0434 \u043C\u0456\u0436 \u0444\u043E\u0442\u043E, A \u2014 \u0441\u0445\u0432\u0430\u043B\u0438\u0442\u0438, R \u2014 \u0432\u0456\u0434\u0445\u0438\u043B\u0438\u0442\u0438, Esc \u2014 \u0437\u0430\u043A\u0440\u0438\u0442\u0438.",
        en: "In the viewer: \u2190 \u2192 move between photos, A approves, R rejects, Esc closes.",
        hy: "\u0534\u056B\u057F\u056B\u0579\u0578\u0582\u0574\u055D \u2190 \u2192 \u0561\u0576\u0581\u0578\u0582\u0574 \u056C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580\u0576\u0565\u0580\u056B \u0574\u056B\u057B\u0587, A\u055D \u0570\u0561\u057D\u057F\u0561\u057F\u0565\u056C, R\u055D \u0574\u0565\u0580\u056A\u0565\u056C, Esc\u055D \u0583\u0561\u056F\u0565\u056C\u0589",
        ka: "\u10DB\u10DC\u10D0\u10EE\u10D5\u10D4\u10DA\u10E8\u10D8: \u2190 \u2192 \u10E4\u10DD\u10E2\u10DD\u10D4\u10D1\u10E1 \u10E8\u10DD\u10E0\u10D8\u10E1 \u10D2\u10D0\u10D3\u10D0\u10E1\u10D5\u10DA\u10D0, A \u2014 \u10D3\u10D0\u10DB\u10E2\u10D9\u10D8\u10EA\u10D4\u10D1\u10D0, R \u2014 \u10E3\u10D0\u10E0\u10E7\u10DD\u10E4\u10D0, Esc \u2014 \u10D3\u10D0\u10EE\u10E3\u10E0\u10D5\u10D0."
    },
    photo_review_b5: {
        uk: "\u0412\u0438\u0434\u0456\u043B\u0456\u0442\u044C \u043A\u0456\u043B\u044C\u043A\u0430 \u0444\u043E\u0442\u043E, \u0449\u043E\u0431 \u0441\u0445\u0432\u0430\u043B\u0438\u0442\u0438, \u0432\u0456\u0434\u0445\u0438\u043B\u0438\u0442\u0438 \u0430\u0431\u043E \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0457\u0445 \u0440\u0430\u0437\u043E\u043C. \u0414\u0440\u0443\u043A \u0456 \xab\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0432\u0441\u0435\xbb \u2014 \u0443 \u0437\u0430\u0433\u043E\u043B\u043E\u0432\u043A\u0443 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438.",
        en: "Select several photos to approve, reject or download them together. Print and Download all are in the page head.",
        hy: "\u0538\u0576\u057F\u0580\u0565\u0584 \u0574\u056B \u0584\u0561\u0576\u056B \u056C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580\u055D \u0574\u056B\u0561\u057D\u056B\u0576 \u0570\u0561\u057D\u057F\u0561\u057F\u0565\u056C\u0578\u0582, \u0574\u0565\u0580\u056A\u0565\u056C\u0578\u0582 \u056F\u0561\u0574 \u0576\u0565\u0580\u0562\u0565\u057C\u0576\u0565\u056C\u0578\u0582 \u0570\u0561\u0574\u0561\u0580\u0589 \u054F\u057A\u0565\u056C\u0568 \u0587 \xab\u0546\u0565\u0580\u0562\u0565\u057C\u0576\u0565\u056C \u0562\u0578\u056C\u0578\u0580\u0568\xbb \u0563\u057F\u0576\u057E\u0578\u0582\u0574 \u0565\u0576 \u0567\u057B\u056B \u057E\u0565\u0580\u0576\u0561\u0563\u0580\u0578\u0582\u0574\u0589",
        ka: "\u10DB\u10DD\u10DC\u10D8\u10E8\u10DC\u10D4\u10D7 \u10E0\u10D0\u10DB\u10D3\u10D4\u10DC\u10D8\u10DB\u10D4 \u10E4\u10DD\u10E2\u10DD \u10D4\u10E0\u10D7\u10D0\u10D3 \u10D3\u10D0\u10DB\u10E2\u10D9\u10D8\u10EA\u10D4\u10D1\u10D8\u10E1, \u10E3\u10D0\u10E0\u10E7\u10DD\u10E4\u10D8\u10E1 \u10D0\u10DC \u10E9\u10D0\u10DB\u10DD\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1. \u10D1\u10D4\u10ED\u10D3\u10D5\u10D0 \u10D3\u10D0 \xab\u10E7\u10D5\u10D4\u10DA\u10D0\u10E1 \u10E9\u10D0\u10DB\u10DD\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D0\xbb \u10D2\u10D5\u10D4\u10E0\u10D3\u10D8\u10E1 \u10E1\u10D0\u10D7\u10D0\u10E3\u10E0\u10E8\u10D8\u10D0."
    },
    visits_desc: {
        uk: "\u0423\u0441\u0456 \u0432\u0456\u0437\u0438\u0442\u0438 \u043C\u0435\u0440\u0447\u0430\u043D\u0434\u0430\u0439\u0437\u0435\u0440\u0456\u0432 \u0437 \u0440\u0456\u0448\u0435\u043D\u043D\u044F\u043C \u043F\u043E \u043A\u043E\u0436\u043D\u043E\u043C\u0443. \u0412\u0456\u0434\u043A\u0440\u0438\u0439\u0442\u0435 \u0432\u0456\u0437\u0438\u0442, \u0449\u043E\u0431 \u043F\u0435\u0440\u0435\u0433\u043B\u044F\u043D\u0443\u0442\u0438 \u0432\u0441\u0435 \u0437\u0456\u0431\u0440\u0430\u043D\u0435 \u043F\u0456\u0434 \u0447\u0430\u0441 \u043D\u044C\u043E\u0433\u043E \u0432 \u043E\u0434\u043D\u043E\u043C\u0443 \u0440\u043E\u0431\u043E\u0447\u043E\u043C\u0443 \u043F\u0440\u043E\u0441\u0442\u043E\u0440\u0456.",
        en: "Every visit a merchandiser made, with its verdict. Open one to review everything collected during it in a single workspace.",
        hy: "\u0544\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580\u0576\u0565\u0580\u056B \u0562\u0578\u056C\u0578\u0580 \u0561\u0575\u0581\u0565\u0580\u0568\u055D \u0575\u0578\u0582\u0580\u0561\u0584\u0561\u0576\u0579\u0575\u0578\u0582\u0580\u056B \u0578\u0580\u0578\u0577\u0574\u0561\u0574\u0562\u0589 \u0532\u0561\u0581\u0565\u0584 \u0561\u0575\u0581\u0568\u055D \u0564\u0580\u0561 \u0568\u0576\u0569\u0561\u0581\u0584\u0578\u0582\u0574 \u0570\u0561\u057E\u0561\u0584\u057E\u0561\u056E \u0561\u0574\u0565\u0576 \u056B\u0576\u0579 \u0574\u0565\u056F \u0561\u0577\u056D\u0561\u057F\u0561\u0576\u0584\u0561\u0575\u056B\u0576 \u057F\u0561\u0580\u0561\u056E\u0584\u0578\u0582\u0574 \u0564\u056B\u057F\u0565\u056C\u0578\u0582 \u0570\u0561\u0574\u0561\u0580\u0589",
        ka: "\u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D4\u10D1\u10D8\u10E1 \u10E7\u10D5\u10D4\u10DA\u10D0 \u10D5\u10D8\u10D6\u10D8\u10E2\u10D8 \u10D7\u10D8\u10D7\u10DD\u10D4\u10E3\u10DA\u10D8\u10E1 \u10D2\u10D0\u10D3\u10D0\u10EC\u10E7\u10D5\u10D4\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8\u10D7. \u10D2\u10D0\u10EE\u10E1\u10D4\u10DC\u10D8\u10D7 \u10D5\u10D8\u10D6\u10D8\u10E2\u10D8, \u10E0\u10DD\u10DB \u10DB\u10D8\u10E1 \u10D3\u10E0\u10DD\u10E1 \u10E8\u10D4\u10D2\u10E0\u10DD\u10D5\u10D4\u10D1\u10E3\u10DA\u10D8 \u10E7\u10D5\u10D4\u10DA\u10D0\u10E4\u10D4\u10E0\u10D8 \u10D4\u10E0\u10D7 \u10E1\u10D0\u10DB\u10E3\u10E8\u10D0\u10DD \u10E1\u10D8\u10D5\u10E0\u10EA\u10D4\u10E8\u10D8 \u10DC\u10D0\u10EE\u10DD\u10D7."
    },
    visits_b1: {
        uk: "\u0424\u0456\u043B\u044C\u0442\u0440\u0443\u0439\u0442\u0435 \u0437\u0430 \u043F\u0435\u0440\u0456\u043E\u0434\u043E\u043C (\u0437\u0430 \u043F\u043E\u0447\u0430\u0442\u043A\u043E\u043C \u0432\u0456\u0437\u0438\u0442\u0443), \u0440\u0435\u0433\u0456\u043E\u043D\u043E\u043C, \u043C\u0435\u0440\u0435\u0436\u0435\u044E, \u043C\u0435\u0440\u0447\u0430\u043D\u0434\u0430\u0439\u0437\u0435\u0440\u0430\u043C\u0438, \u0441\u0443\u043F\u0435\u0440\u0432\u0430\u0439\u0437\u0435\u0440\u0430\u043C\u0438 \u0439 \u0442\u043E\u0447\u043A\u0430\u043C\u0438. \u041F\u0435\u0440\u0435\u043C\u0438\u043A\u0430\u0447 \u0441\u0442\u0430\u0442\u0443\u0441\u0443 \u0440\u043E\u0437\u0434\u0456\u043B\u044F\u0454 \xab\u043D\u0430 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0446\u0456\xbb, \xab\u0441\u0445\u0432\u0430\u043B\u0435\u043D\u043E\xbb \u0439 \xab\u0432\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043E\xbb.",
        en: "Filter by period (matched on the visit start), county, network, merchandisers, supervisors and points. The status segment splits pending, approved and rejected.",
        hy: "\u0536\u057F\u0565\u0584 \u0568\u057D\u057F \u056A\u0561\u0574\u0561\u0576\u0561\u056F\u0561\u0570\u0561\u057F\u057E\u0561\u056E\u056B (\u0561\u0575\u0581\u056B \u057D\u056F\u0566\u0562\u0578\u057E), \u0574\u0561\u0580\u0566\u056B, \u0581\u0561\u0576\u0581\u056B, \u0574\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580\u0576\u0565\u0580\u056B, \u057D\u0578\u0582\u057A\u0565\u0580\u057E\u0561\u0575\u0566\u0565\u0580\u0576\u0565\u0580\u056B \u0587 \u056F\u0565\u057F\u0565\u0580\u056B\u0589 \u053F\u0561\u0580\u0563\u0561\u057E\u056B\u0573\u0561\u056F\u056B \u0583\u0578\u056D\u0561\u0580\u056F\u056B\u0579\u0568 \u0562\u0561\u056A\u0561\u0576\u0578\u0582\u0574 \u0567 \u057D\u057A\u0561\u057D\u0578\u0572, \u0570\u0561\u057D\u057F\u0561\u057F\u057E\u0561\u056E \u0587 \u0574\u0565\u0580\u056A\u057E\u0561\u056E \u0561\u0575\u0581\u0565\u0580\u0568\u0589",
        ka: "\u10D2\u10D0\u10E4\u10D8\u10DA\u10E2\u10E0\u10D4\u10D7 \u10DE\u10D4\u10E0\u10D8\u10DD\u10D3\u10D8\u10D7 (\u10D5\u10D8\u10D6\u10D8\u10E2\u10D8\u10E1 \u10D3\u10D0\u10EC\u10E7\u10D4\u10D1\u10D8\u10D7), \u10E0\u10D4\u10D2\u10D8\u10DD\u10DC\u10D8\u10D7, \u10E5\u10E1\u10D4\u10DA\u10D8\u10D7, \u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D4\u10D1\u10D8\u10D7, \u10E1\u10E3\u10DE\u10D4\u10E0\u10D5\u10D0\u10D8\u10D6\u10D4\u10E0\u10D4\u10D1\u10D8\u10D7\u10D0 \u10D3\u10D0 \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8\u10D7. \u10E1\u10E2\u10D0\u10E2\u10E3\u10E1\u10D8\u10E1 \u10D2\u10D0\u10D3\u10D0\u10DB\u10E0\u10D7\u10D5\u10D4\u10DA\u10D8 \u10E7\u10DD\u10E4\u10E1 \u10DB\u10DD\u10DA\u10DD\u10D3\u10D8\u10DC\u10E8\u10D8, \u10D3\u10D0\u10DB\u10E2\u10D9\u10D8\u10EA\u10D4\u10D1\u10E3\u10DA \u10D3\u10D0 \u10E3\u10D0\u10E0\u10E7\u10DD\u10E4\u10D8\u10DA \u10D5\u10D8\u10D6\u10D8\u10E2\u10D4\u10D1\u10E1."
    },
    visits_b2: {
        uk: "\u0421\u0445\u0432\u0430\u043B\u044E\u0439\u0442\u0435 \u0447\u0438 \u0432\u0456\u0434\u0445\u0438\u043B\u044F\u0439\u0442\u0435 \u0437 \u043C\u0435\u043D\u044E \u0440\u044F\u0434\u043A\u0430 \u0430\u0431\u043E \u043A\u0456\u043B\u044C\u043A\u0430 \u043E\u0434\u0440\u0430\u0437\u0443 \u0437 \u043F\u0430\u043D\u0435\u043B\u0456, \u0449\u043E \u0437\u02BC\u044F\u0432\u043B\u044F\u0454\u0442\u044C\u0441\u044F \u043F\u0456\u0434 \u0432\u0438\u0434\u0456\u043B\u0435\u043D\u043D\u044F\u043C.",
        en: "Approve or reject from the row menu, or several at once from the bar that appears under a selection.",
        hy: "\u0540\u0561\u057D\u057F\u0561\u057F\u0565\u0584 \u056F\u0561\u0574 \u0574\u0565\u0580\u056A\u0565\u0584 \u057F\u0578\u0572\u056B \u0568\u0576\u057F\u0580\u0561\u0581\u0561\u0576\u056F\u056B\u0581, \u056F\u0561\u0574 \u0574\u056B \u0584\u0561\u0576\u056B\u057D\u0568 \u0574\u056B\u0561\u057D\u056B\u0576\u055D \u0568\u0576\u057F\u0580\u0578\u0582\u0569\u0575\u0561\u0576 \u057F\u0561\u056F \u0570\u0561\u0575\u057F\u0576\u057E\u0578\u0572 \u057E\u0561\u0570\u0561\u0576\u0561\u056F\u056B\u0581\u0589",
        ka: "\u10D3\u10D0\u10D0\u10DB\u10E2\u10D9\u10D8\u10EA\u10D4\u10D7 \u10D0\u10DC \u10E3\u10D0\u10E0\u10E7\u10D0\u10D5\u10D8\u10D7 \u10E1\u10E2\u10E0\u10D8\u10E5\u10DD\u10DC\u10D8\u10E1 \u10DB\u10D4\u10DC\u10D8\u10E3\u10D3\u10D0\u10DC, \u10D0\u10DC \u10E0\u10D0\u10DB\u10D3\u10D4\u10DC\u10D8\u10DB\u10D4 \u10D4\u10E0\u10D7\u10D3\u10E0\u10DD\u10E3\u10DA\u10D0\u10D3 \u10DB\u10DD\u10DC\u10D8\u10E8\u10D5\u10DC\u10D8\u10E1 \u10E5\u10D5\u10D4\u10E8 \u10D2\u10D0\u10DB\u10DD\u10E9\u10D4\u10DC\u10D8\u10DA\u10D8 \u10DE\u10D0\u10DC\u10D4\u10DA\u10D8\u10D3\u10D0\u10DC."
    },
    visits_b3: {
        uk: "\u0421\u0442\u043E\u0440\u0456\u043D\u043A\u0430 \u0432\u0456\u0437\u0438\u0442\u0443 \u0432\u0456\u0434\u043A\u0440\u0438\u0432\u0430\u0454\u0442\u044C\u0441\u044F \u0447\u0435\u0440\u0433\u043E\u044E \xab\u041F\u043E\u0442\u0440\u0435\u0431\u0443\u0454 \u0432\u0430\u0448\u043E\u0457 \u0443\u0432\u0430\u0433\u0438\xbb \u0437 \u0443\u0441\u0456\u043C \u0449\u0435 \u043D\u0435 \u0432\u0438\u0440\u0456\u0448\u0435\u043D\u0438\u043C, \u0434\u0430\u043B\u0456 \u2014 \u043F\u043E \u043E\u0434\u043D\u043E\u043C\u0443 \u0440\u043E\u0437\u0434\u0456\u043B\u0443: \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F, \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F, \u043E\u043F\u043B\u0430\u0442\u0438, \u0444\u043E\u0442\u043E\u0437\u0432\u0456\u0442\u0438, \u0437\u0430\u0434\u0430\u0447\u0456, \u043C\u043E\u043D\u0456\u0442\u043E\u0440\u0438\u043D\u0433 \u0446\u0456\u043D, \u043E\u043F\u0438\u0442\u0443\u0432\u0430\u043D\u043D\u044F, GPS-\u0442\u0440\u0435\u043A, \u0436\u0443\u0440\u043D\u0430\u043B.",
        en: "The visit page opens with a \xabNeeds your attention\xbb queue of everything still undecided, then one section at a time: orders, returns, payments, photo reports, tasks, price monitoring, surveys, GPS track, log.",
        hy: "\u0531\u0575\u0581\u056B \u0567\u057B\u0568 \u0562\u0561\u0581\u057E\u0578\u0582\u0574 \u0567 \xab\u0541\u0565\u0580 \u0578\u0582\u0577\u0561\u0564\u0580\u0578\u0582\u0569\u0575\u0561\u0576 \u056F\u0561\u0580\u056B\u0584\u0576 \u0578\u0582\u0576\u056B\xbb \u0570\u0565\u0580\u0569\u0578\u057E\u055D \u0564\u0565\u057C \u0579\u0578\u0580\u0578\u0577\u057E\u0561\u056E\u0578\u057E, \u0561\u057A\u0561 \u0574\u0565\u056F \u0562\u0561\u056A\u056B\u0576 \u0574\u056B\u0561\u056A\u0561\u0574\u0561\u0576\u0561\u056F\u055D \u057A\u0561\u057F\u057E\u0565\u0580\u0576\u0565\u0580, \u057E\u0565\u0580\u0561\u0564\u0561\u0580\u0571\u0576\u0565\u0580, \u057E\u0573\u0561\u0580\u0578\u0582\u0574\u0576\u0565\u0580, \u056C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580\u0576\u0565\u0580\u056B \u0570\u0561\u0577\u057E\u0565\u057F\u057E\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580, \u0561\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0576\u0565\u0580, \u0563\u0576\u0565\u0580\u056B \u0574\u0578\u0576\u056B\u057F\u0578\u0580\u056B\u0576\u0563, \u0570\u0561\u0580\u0581\u0578\u0582\u0574\u0576\u0565\u0580, GPS \u0570\u0565\u057F\u0561\u0563\u056B\u056E, \u0574\u0561\u057F\u0575\u0561\u0576\u0589",
        ka: "\u10D5\u10D8\u10D6\u10D8\u10E2\u10D8\u10E1 \u10D2\u10D5\u10D4\u10E0\u10D3\u10D8 \u10D8\u10EE\u10E1\u10DC\u10D4\u10D1\u10D0 \xab\u10D7\u10E5\u10D5\u10D4\u10DC\u10E1 \u10E7\u10E3\u10E0\u10D0\u10D3\u10E6\u10D4\u10D1\u10D0\u10E1 \u10E1\u10D0\u10ED\u10D8\u10E0\u10DD\u10D4\u10D1\u10E1\xbb \u10E0\u10D8\u10D2\u10D8\u10D7, \u10E1\u10D0\u10D3\u10D0\u10EA \u10E7\u10D5\u10D4\u10DA\u10D0 \u10D2\u10D0\u10D3\u10D0\u10E3\u10EC\u10E7\u10D5\u10D4\u10E2\u10D4\u10DA\u10D8\u10D0, \u10E8\u10D4\u10DB\u10D3\u10D4\u10D2 \u10D7\u10D8\u10D7\u10DD \u10E1\u10D4\u10E5\u10EA\u10D8\u10D0: \u10E8\u10D4\u10D9\u10D5\u10D4\u10D7\u10D4\u10D1\u10D8, \u10D3\u10D0\u10D1\u10E0\u10E3\u10DC\u10D4\u10D1\u10D4\u10D1\u10D8, \u10D2\u10D0\u10D3\u10D0\u10EE\u10D3\u10D4\u10D1\u10D8, \u10E4\u10DD\u10E2\u10DD\u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10D4\u10D1\u10D8, \u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8, \u10E4\u10D0\u10E1\u10D4\u10D1\u10D8\u10E1 \u10DB\u10DD\u10DC\u10D8\u10E2\u10DD\u10E0\u10D8\u10DC\u10D2\u10D8, \u10D2\u10D0\u10DB\u10DD\u10D9\u10D8\u10D7\u10EE\u10D5\u10D4\u10D1\u10D8, GPS \u10E2\u10E0\u10D4\u10D9\u10D8, \u10DF\u10E3\u10E0\u10DC\u10D0\u10DA\u10D8."
    },
    visits_b4: {
        uk: "\u041A\u043B\u0430\u0432\u0456\u0448\u0456 [ \u0456 ] \u043F\u0435\u0440\u0435\u0445\u043E\u0434\u044F\u0442\u044C \u0434\u043E \u043F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u044C\u043E\u0433\u043E \u0439 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u043E\u0433\u043E \u0432\u0456\u0437\u0438\u0442\u0443 \u0443 \u0432\u0456\u0434\u0444\u0456\u043B\u044C\u0442\u0440\u043E\u0432\u0430\u043D\u043E\u043C\u0443 \u0441\u043F\u0438\u0441\u043A\u0443 \u0431\u0435\u0437 \u043F\u043E\u0432\u0435\u0440\u043D\u0435\u043D\u043D\u044F \u043D\u0430\u0437\u0430\u0434.",
        en: "The [ and ] keys step to the previous and next visit in the filtered list without going back.",
        hy: "[ \u0587 ] \u057D\u057F\u0565\u0572\u0576\u0565\u0580\u0568 \u0561\u0576\u0581\u0576\u0578\u0582\u0574 \u0565\u0576 \u0566\u057F\u057E\u0561\u056E \u0581\u0578\u0582\u0581\u0561\u056F\u056B \u0576\u0561\u056D\u0578\u0580\u0564 \u0587 \u0570\u0561\u057B\u0578\u0580\u0564 \u0561\u0575\u0581\u056B\u0576\u055D \u0561\u057C\u0561\u0576\u0581 \u0570\u0565\u057F \u057E\u0565\u0580\u0561\u0564\u0561\u057C\u0576\u0561\u056C\u0578\u0582\u0589",
        ka: "[ \u10D3\u10D0 ] \u10D9\u10DA\u10D0\u10D5\u10D8\u10E8\u10D4\u10D1\u10D8 \u10D2\u10D0\u10E4\u10D8\u10DA\u10E2\u10E0\u10E3\u10DA \u10E1\u10D8\u10D0\u10E8\u10D8 \u10EC\u10D8\u10DC\u10D0 \u10D3\u10D0 \u10E8\u10D4\u10DB\u10D3\u10D4\u10D2 \u10D5\u10D8\u10D6\u10D8\u10E2\u10D6\u10D4 \u10D2\u10D0\u10D3\u10D0\u10D3\u10D8\u10E1 \u10E3\u10D9\u10D0\u10DC \u10D3\u10D0\u10D1\u10E0\u10E3\u10DC\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10E0\u10D4\u10E8\u10D4."
    },
    tracking_desc: {
        uk: "\u0414\u0435 \u0441\u044C\u043E\u0433\u043E\u0434\u043D\u0456 \u043A\u043E\u043C\u0430\u043D\u0434\u0430 \u2014 \u0437\u0430 \u0434\u0430\u043D\u0438\u043C\u0438 \u0432\u0456\u0437\u0438\u0442\u0456\u0432. \u041F\u043E\u0437\u0438\u0446\u0456\u044F \u2014 \u0446\u0435 \u0442\u043E\u0447\u043A\u0430 \u0432\u0456\u0434\u043A\u0440\u0438\u0442\u043E\u0433\u043E \u0432\u0456\u0437\u0438\u0442\u0443, \u0430 \u043D\u0435 GPS \u0443 \u0440\u0435\u0430\u043B\u044C\u043D\u043E\u043C\u0443 \u0447\u0430\u0441\u0456, \u0442\u043E\u043C\u0443 \u0432\u043E\u043D\u0430 \u0442\u0430\u043A\u0430 \u0436 \u0441\u0432\u0456\u0436\u0430, \u044F\u043A \u043E\u0441\u0442\u0430\u043D\u043D\u0454 \u0432\u0456\u0434\u043A\u0440\u0438\u0442\u0442\u044F \u0447\u0438 \u0437\u0430\u043A\u0440\u0438\u0442\u0442\u044F \u0432\u0456\u0437\u0438\u0442\u0443.",
        en: "Where the team is today, from visit data. A position is the point of an open visit, not a live GPS fix, so it is as fresh as the last visit opened or closed.",
        hy: "\u0548\u0580\u057F\u0565\u0572 \u0567 \u0569\u056B\u0574\u0576 \u0561\u0575\u057D\u0585\u0580\u055D \u0568\u057D\u057F \u0561\u0575\u0581\u0565\u0580\u056B \u057F\u057E\u0575\u0561\u056C\u0576\u0565\u0580\u056B\u0589 \u0534\u056B\u0580\u0584\u0568 \u0562\u0561\u0581 \u0561\u0575\u0581\u056B \u056F\u0565\u057F\u0576 \u0567, \u0578\u0579 \u0569\u0565 \u056B\u0580\u0561\u056F\u0561\u0576 \u056A\u0561\u0574\u0561\u0576\u0561\u056F\u056B GPS, \u0561\u0575\u0576\u057A\u0565\u057D \u0578\u0580 \u0561\u0575\u0576 \u0576\u0578\u0582\u0575\u0576\u0584\u0561\u0576 \u0569\u0561\u0580\u0574 \u0567, \u0578\u0580\u0584\u0561\u0576 \u0561\u0575\u0581\u056B \u057E\u0565\u0580\u057B\u056B\u0576 \u0562\u0561\u0581\u0578\u0582\u0574\u0568 \u056F\u0561\u0574 \u0583\u0561\u056F\u0578\u0582\u0574\u0568\u0589",
        ka: "\u10E1\u10D0\u10D3 \u10D0\u10E0\u10D8\u10E1 \u10D2\u10E3\u10DC\u10D3\u10D8 \u10D3\u10E6\u10D4\u10E1 \u2014 \u10D5\u10D8\u10D6\u10D8\u10E2\u10D4\u10D1\u10D8\u10E1 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8\u10D7. \u10DE\u10DD\u10D6\u10D8\u10EA\u10D8\u10D0 \u10E6\u10D8\u10D0 \u10D5\u10D8\u10D6\u10D8\u10E2\u10D8\u10E1 \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8\u10D0 \u10D3\u10D0 \u10D0\u10E0\u10D0 \u10E0\u10D4\u10D0\u10DA\u10E3\u10E0 \u10D3\u10E0\u10DD\u10E8\u10D8 GPS, \u10D0\u10DB\u10D8\u10E2\u10DD\u10DB \u10D8\u10E1 \u10D8\u10DB\u10D3\u10D4\u10DC\u10D0\u10D3 \u10D0\u10EE\u10D0\u10DA\u10D8\u10D0, \u10E0\u10D0\u10DB\u10D3\u10D4\u10DC\u10D0\u10D3\u10D0\u10EA \u10D5\u10D8\u10D6\u10D8\u10E2\u10D8\u10E1 \u10D1\u10DD\u10DA\u10DD \u10D2\u10D0\u10EE\u10E1\u10DC\u10D0 \u10D0\u10DC \u10D3\u10D0\u10EE\u10E3\u10E0\u10D5\u10D0."
    },
    tracking_b1: {
        uk: "\u0427\u043E\u0442\u0438\u0440\u0438 \u0441\u0442\u0430\u043D\u0438, \u043D\u0430\u0439\u0432\u0430\u0436\u043B\u0438\u0432\u0456\u0448\u0456 \u0432\u0433\u043E\u0440\u0456: \u0443 \u0432\u0456\u0437\u0438\u0442\u0456, \u0432\u0456\u0437\u0438\u0442 \u0432\u0456\u0434\u043A\u0440\u0438\u0442\u0438\u0439 \u0437\u0430\u043D\u0430\u0434\u0442\u043E \u0434\u043E\u0432\u0433\u043E (\u0437\u0430\u0431\u0443\u043B\u0438 \u0437\u0430\u043A\u0440\u0438\u0442\u0438), \u043C\u0456\u0436 \u0432\u0456\u0437\u0438\u0442\u0430\u043C\u0438, \u0431\u0435\u0437 \u0432\u0456\u0437\u0438\u0442\u0456\u0432 \u0441\u044C\u043E\u0433\u043E\u0434\u043D\u0456.",
        en: "Four states, most urgent on top: in a visit, visit open too long (a forgotten close), between visits, no visits today.",
        hy: "\u0549\u0578\u0580\u057D \u056F\u0561\u0580\u0563\u0561\u057E\u056B\u0573\u0561\u056F, \u0561\u0574\u0565\u0576\u0561\u056F\u0561\u0580\u0587\u0578\u0580\u0568 \u057E\u0565\u0580\u0587\u0578\u0582\u0574\u055D \u0561\u0575\u0581\u056B \u0574\u0565\u057B, \u0561\u0575\u0581\u0568 \u0579\u0561\u0583\u0561\u0566\u0561\u0576\u0581 \u0565\u0580\u056F\u0561\u0580 \u0562\u0561\u0581 \u0567 (\u0574\u0578\u057C\u0561\u0581\u0565\u056C \u0565\u0576 \u0583\u0561\u056F\u0565\u056C), \u0561\u0575\u0581\u0565\u0580\u056B \u0574\u056B\u057B\u0587, \u0561\u0575\u057D\u0585\u0580 \u0561\u0575\u0581\u0565\u0580 \u0579\u056F\u0561\u0576\u0589",
        ka: "\u10DD\u10D7\u10EE\u10D8 \u10DB\u10D3\u10D2\u10DD\u10DB\u10D0\u10E0\u10D4\u10DD\u10D1\u10D0, \u10E7\u10D5\u10D4\u10DA\u10D0\u10D6\u10D4 \u10DB\u10DC\u10D8\u10E8\u10D5\u10DC\u10D4\u10DA\u10DD\u10D5\u10D0\u10DC\u10D8 \u10D6\u10D4\u10DB\u10DD\u10D7: \u10D5\u10D8\u10D6\u10D8\u10E2\u10E8\u10D8, \u10D5\u10D8\u10D6\u10D8\u10E2\u10D8 \u10EB\u10D0\u10DA\u10D8\u10D0\u10DC \u10D3\u10D8\u10D3\u10EE\u10D0\u10DC\u10E1 \u10E6\u10D8\u10D0\u10D0 (\u10D3\u10D0\u10EE\u10E3\u10E0\u10D5\u10D0 \u10D3\u10D0\u10D0\u10D5\u10D8\u10EC\u10E7\u10D3\u10D0\u10D7), \u10D5\u10D8\u10D6\u10D8\u10E2\u10D4\u10D1\u10E1 \u10E8\u10DD\u10E0\u10D8\u10E1, \u10D3\u10E6\u10D4\u10E1 \u10D5\u10D8\u10D6\u10D8\u10E2\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10E0\u10D4\u10E8\u10D4."
    },
    tracking_b2: {
        uk: "\u0417\u0435\u043B\u0435\u043D\u0456 \u0439 \u0436\u043E\u0432\u0442\u0456 \u043C\u0430\u0440\u043A\u0435\u0440\u0438 \u2014 \u0432\u0456\u0434\u043A\u0440\u0438\u0442\u0456 \u0432\u0456\u0437\u0438\u0442\u0438, \u0441\u0456\u0440\u0456 \u2014 \u0442\u043E\u0447\u043A\u0430 \u043E\u0441\u0442\u0430\u043D\u043D\u044C\u043E\u0433\u043E \u0437\u0430\u043A\u0440\u0438\u0442\u043E\u0433\u043E \u0432\u0456\u0437\u0438\u0442\u0443.",
        en: "Green and amber pins are open visits; grey pins are the point of the last closed visit.",
        hy: "\u053F\u0561\u0576\u0561\u0579 \u0587 \u0564\u0565\u0572\u056B\u0576 \u0584\u0578\u0580\u0578\u0581\u0576\u0565\u0580\u0568 \u0562\u0561\u0581 \u0561\u0575\u0581\u0565\u0580 \u0565\u0576, \u0574\u0578\u056D\u0580\u0561\u0563\u0578\u0582\u0575\u0576\u0576\u0565\u0580\u0568\u055D \u057E\u0565\u0580\u057B\u056B\u0576 \u0583\u0561\u056F\u057E\u0561\u056E \u0561\u0575\u0581\u056B \u056F\u0565\u057F\u0568\u0589",
        ka: "\u10DB\u10EC\u10D5\u10D0\u10DC\u10D4 \u10D3\u10D0 \u10E7\u10D5\u10D8\u10D7\u10D4\u10DA\u10D8 \u10DE\u10D8\u10DC\u10D4\u10D1\u10D8 \u10E6\u10D8\u10D0 \u10D5\u10D8\u10D6\u10D8\u10E2\u10D4\u10D1\u10D8\u10D0, \u10DC\u10D0\u10EA\u10E0\u10D8\u10E1\u10E4\u10D4\u10E0\u10D8 \u2014 \u10D1\u10DD\u10DA\u10DD \u10D3\u10D0\u10EE\u10E3\u10E0\u10E3\u10DA\u10D8 \u10D5\u10D8\u10D6\u10D8\u10E2\u10D8\u10E1 \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8."
    },
    tracking_b3: {
        uk: "\u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C \u043C\u0430\u0440\u043A\u0435\u0440 \u0430\u0431\u043E \u0440\u044F\u0434\u043E\u043A, \u0449\u043E\u0431 \u043F\u043E\u0431\u0430\u0447\u0438\u0442\u0438 \u0434\u0435\u043D\u044C \u043B\u044E\u0434\u0438\u043D\u0438: \u0432\u0456\u0437\u0438\u0442\u0438 \u043F\u043E \u043F\u043E\u0440\u044F\u0434\u043A\u0443 \u0442\u0430 \u0437\u0430\u043F\u043B\u0430\u043D\u043E\u0432\u0430\u043D\u0438\u0439 \u043C\u0430\u0440\u0448\u0440\u0443\u0442 \u043F\u043E\u0440\u0443\u0447 \u0456\u0437 \u0444\u0430\u043A\u0442\u0438\u0447\u043D\u0438\u043C.",
        en: "Click a pin or a row to see that person's day: the visits in order and the planned route beside the actual one.",
        hy: "\u054D\u0565\u0572\u0574\u0565\u0584 \u0584\u0578\u0580\u0578\u0581\u056B \u056F\u0561\u0574 \u057F\u0578\u0572\u056B \u057E\u0580\u0561\u055D \u0574\u0561\u0580\u0564\u0578\u0582 \u0585\u0580\u0568 \u057F\u0565\u057D\u0576\u0565\u056C\u0578\u0582 \u0570\u0561\u0574\u0561\u0580. \u0561\u0575\u0581\u0565\u0580\u0568 \u0570\u0565\u0580\u0569\u0561\u056F\u0561\u0576\u0578\u0582\u0569\u0575\u0561\u0574\u0562 \u0587 \u057A\u056C\u0561\u0576\u0561\u057E\u0578\u0580\u057E\u0561\u056E \u0565\u0580\u0569\u0578\u0582\u0572\u056B\u0576 \u0583\u0561\u057D\u057F\u0561\u0581\u056B\u056B \u056F\u0578\u0572\u0584\u056B\u0576\u0589",
        ka: "\u10D3\u10D0\u10D0\u10EC\u10D9\u10D0\u10DE\u10E3\u10DC\u10D4\u10D7 \u10DE\u10D8\u10DC\u10D6\u10D4 \u10D0\u10DC \u10E1\u10E2\u10E0\u10D8\u10E5\u10DD\u10DC\u10D6\u10D4, \u10E0\u10DD\u10DB \u10D0\u10D3\u10D0\u10DB\u10D8\u10D0\u10DC\u10D8\u10E1 \u10D3\u10E6\u10D4 \u10DC\u10D0\u10EE\u10DD\u10D7: \u10D5\u10D8\u10D6\u10D8\u10E2\u10D4\u10D1\u10D8 \u10D7\u10D0\u10DC\u10DB\u10D8\u10DB\u10D3\u10D4\u10D5\u10E0\u10DD\u10D1\u10D8\u10D7 \u10D3\u10D0 \u10D3\u10D0\u10D2\u10D4\u10D2\u10DB\u10D8\u10DA\u10D8 \u10DB\u10D0\u10E0\u10E8\u10E0\u10E3\u10E2\u10D8 \u10E4\u10D0\u10E5\u10E2\u10DD\u10D1\u10E0\u10D8\u10D5\u10D8\u10E1 \u10D2\u10D5\u10D4\u10E0\u10D3\u10D8\u10D7."
    },
    tracking_b4: {
        uk: "\u0421\u044C\u043E\u0433\u043E\u0434\u043D\u0456\u0448\u043D\u0456\u0439 \u0434\u0435\u043D\u044C \u043E\u043D\u043E\u0432\u043B\u044E\u0454\u0442\u044C\u0441\u044F \u0449\u043E\u0445\u0432\u0438\u043B\u0438\u043D\u0438; \u0432\u0430\u0448 \u043C\u0430\u0441\u0448\u0442\u0430\u0431 \u0456 \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u043D\u044F \u043A\u0430\u0440\u0442\u0438 \u0437\u0431\u0435\u0440\u0456\u0433\u0430\u044E\u0442\u044C\u0441\u044F. \u0406\u043D\u0448\u0438\u0439 \u0434\u0435\u043D\u044C \u043E\u0431\u0438\u0440\u0430\u0439\u0442\u0435 \u0432 \u043A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u0456.",
        en: "Today refreshes every minute; your pan and zoom are kept. Pick another day with the date picker.",
        hy: "\u0531\u0575\u057D\u0585\u0580\u057E\u0561 \u0585\u0580\u0568 \u0569\u0561\u0580\u0574\u0561\u0581\u057E\u0578\u0582\u0574 \u0567 \u0561\u0574\u0565\u0576 \u0580\u0578\u057A\u0565, \u0571\u0565\u0580 \u0574\u0561\u057D\u0577\u057F\u0561\u0562\u0568 \u0587 \u0584\u0561\u0580\u057F\u0565\u0566\u056B \u0564\u056B\u0580\u0584\u0568 \u057A\u0561\u0570\u057A\u0561\u0576\u057E\u0578\u0582\u0574 \u0565\u0576\u0589 \u0531\u0575\u056C \u0585\u0580 \u0568\u0576\u057F\u0580\u0565\u0584 \u0585\u0580\u0561\u0581\u0578\u0582\u0575\u0581\u0578\u0582\u0574\u0589",
        ka: "\u10D3\u10E6\u10D4\u10D5\u10D0\u10DC\u10D3\u10D4\u10DA\u10D8 \u10D3\u10E6\u10D4 \u10E7\u10DD\u10D5\u10D4\u10DA \u10EC\u10E3\u10D7\u10E1 \u10D0\u10EE\u10DA\u10D3\u10D4\u10D1\u10D0; \u10D7\u10E5\u10D5\u10D4\u10DC\u10D8 \u10DB\u10D0\u10E1\u10E8\u10E2\u10D0\u10D1\u10D8 \u10D3\u10D0 \u10E0\u10E3\u10D9\u10D8\u10E1 \u10DE\u10DD\u10D6\u10D8\u10EA\u10D8\u10D0 \u10D8\u10DC\u10D0\u10EE\u10D4\u10D1\u10D0. \u10E1\u10EE\u10D5\u10D0 \u10D3\u10E6\u10D4 \u10D9\u10D0\u10DA\u10D4\u10DC\u10D3\u10D0\u10E0\u10E8\u10D8 \u10D0\u10D8\u10E0\u10E9\u10D8\u10D4\u10D7."
    },
    bi_reports_desc: {
        uk: "\u0414\u0430\u0448\u0431\u043E\u0440\u0434\u0438 Power BI, \u043F\u0456\u0434\u0433\u043E\u0442\u043E\u0432\u043B\u0435\u043D\u0456 \u0434\u043B\u044F \u0432\u0430\u0448\u043E\u0457 \u043A\u043E\u043C\u043F\u0430\u043D\u0456\u0457, \u0432\u0431\u0443\u0434\u043E\u0432\u0430\u043D\u0456 \u0432 \u0437\u0430\u0441\u0442\u043E\u0441\u0443\u043D\u043E\u043A.",
        en: "Power BI dashboards prepared for your company, embedded in the app.",
        hy: "\u0541\u0565\u0580 \u0568\u0576\u056F\u0565\u0580\u0578\u0582\u0569\u0575\u0561\u0576 \u0570\u0561\u0574\u0561\u0580 \u057A\u0561\u057F\u0580\u0561\u057D\u057F\u057E\u0561\u056E Power BI \u0564\u0561\u0577\u0562\u0578\u0580\u0564\u0576\u0565\u0580\u055D \u0576\u0565\u0580\u056F\u0561\u057C\u0578\u0582\u0581\u057E\u0561\u056E \u0570\u0561\u057E\u0565\u056C\u057E\u0561\u056E\u0578\u0582\u0574\u0589",
        ka: "\u10D7\u10E5\u10D5\u10D4\u10DC\u10D8 \u10D9\u10DD\u10DB\u10DE\u10D0\u10DC\u10D8\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1 \u10DB\u10DD\u10DB\u10D6\u10D0\u10D3\u10D4\u10D1\u10E3\u10DA\u10D8 Power BI \u10D3\u10D4\u10E8\u10D1\u10DD\u10E0\u10D3\u10D4\u10D1\u10D8, \u10D0\u10DE\u10DA\u10D8\u10D9\u10D0\u10EA\u10D8\u10D0\u10E8\u10D8 \u10E9\u10D0\u10E8\u10D4\u10DC\u10D4\u10D1\u10E3\u10DA\u10D8."
    },
    bi_reports_b1: {
        uk: "\u041E\u0434\u043D\u043E\u0447\u0430\u0441\u043D\u043E \u0432\u0456\u0434\u043A\u0440\u0438\u0442\u0438\u0439 \u043E\u0434\u0438\u043D \u0437\u0432\u0456\u0442; \u0432\u0456\u0434\u043A\u0440\u0438\u0442\u0442\u044F \u0456\u043D\u0448\u043E\u0433\u043E \u0437\u0430\u043A\u0440\u0438\u0432\u0430\u0454 \u043F\u0435\u0440\u0448\u0438\u0439.",
        en: "One report is open at a time; opening another closes the first.",
        hy: "\u0544\u056B\u0561\u056A\u0561\u0574\u0561\u0576\u0561\u056F \u0562\u0561\u0581 \u0567 \u0574\u0565\u056F \u0570\u0561\u0577\u057E\u0565\u057F\u057E\u0578\u0582\u0569\u0575\u0578\u0582\u0576, \u0574\u0575\u0578\u0582\u057D\u0568 \u0562\u0561\u0581\u0565\u056C\u0568 \u0583\u0561\u056F\u0578\u0582\u0574 \u0567 \u0561\u057C\u0561\u057B\u056B\u0576\u0568\u0589",
        ka: "\u10D4\u10E0\u10D7\u10D3\u10E0\u10DD\u10E3\u10DA\u10D0\u10D3 \u10D4\u10E0\u10D7\u10D8 \u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10D8\u10D0 \u10E6\u10D8\u10D0; \u10DB\u10D4\u10DD\u10E0\u10D8\u10E1 \u10D2\u10D0\u10EE\u10E1\u10DC\u10D0 \u10DE\u10D8\u10E0\u10D5\u10D4\u10DA\u10E1 \u10EE\u10E3\u10E0\u10D0\u10D5\u10E1."
    },
    bi_reports_b2: {
        uk: "\xab\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u0432 \u043D\u043E\u0432\u0456\u0439 \u0432\u043A\u043B\u0430\u0434\u0446\u0456\xbb \u043F\u043E\u043A\u0430\u0437\u0443\u0454 \u0437\u0432\u0456\u0442 \u043D\u0430 \u0432\u0435\u0441\u044C \u0435\u043A\u0440\u0430\u043D.",
        en: "\xabOpen in new tab\xbb shows the report full-size.",
        hy: "\xab\u0532\u0561\u0581\u0565\u056C \u0576\u0578\u0580 \u0576\u0565\u0580\u0564\u056B\u0580\u0578\u0582\u0574\xbb \u0581\u0578\u0582\u0575\u0581 \u0567 \u057F\u0561\u056C\u056B\u057D \u0570\u0561\u0577\u057E\u0565\u057F\u057E\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0568 \u056C\u056B\u0561\u0567\u056F\u0580\u0561\u0576\u0589",
        ka: "\xab\u10D0\u10EE\u10D0\u10DA \u10E9\u10D0\u10DC\u10D0\u10E0\u10D7\u10E8\u10D8 \u10D2\u10D0\u10EE\u10E1\u10DC\u10D0\xbb \u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10E1 \u10E1\u10E0\u10E3\u10DA \u10D6\u10DD\u10DB\u10D0\u10E8\u10D8 \u10D0\u10E9\u10D5\u10D4\u10DC\u10D4\u10D1\u10E1."
    },
    bi_reports_b3: {
        uk: "\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438\u0439 \u0437\u0432\u0456\u0442 \u0437\u0431\u0435\u0440\u0456\u0433\u0430\u0454\u0442\u044C\u0441\u044F \u0432 \u0430\u0434\u0440\u0435\u0441\u043D\u043E\u043C\u0443 \u0440\u044F\u0434\u043A\u0443, \u0442\u043E\u0436 \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0438 \u0439 \xab\u041D\u0430\u0437\u0430\u0434\xbb \u043F\u043E\u0432\u0435\u0440\u0442\u0430\u044E\u0442\u044C \u0434\u043E \u043D\u044C\u043E\u0433\u043E.",
        en: "The open report is kept in the address bar, so reload and Back return to it.",
        hy: "\u0532\u0561\u0581 \u0570\u0561\u0577\u057E\u0565\u057F\u057E\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0568 \u057A\u0561\u0570\u057E\u0578\u0582\u0574 \u0567 \u0570\u0561\u057D\u0581\u0565\u056B \u057F\u0578\u0572\u0578\u0582\u0574, \u0561\u0575\u0576\u057A\u0565\u057D \u0578\u0580 \u057E\u0565\u0580\u0561\u0562\u0565\u057C\u0576\u0578\u0582\u0574\u0568 \u0587 \xab\u0540\u0565\u057F\xbb-\u0568 \u057E\u0565\u0580\u0561\u0564\u0561\u0580\u0571\u0576\u0578\u0582\u0574 \u0565\u0576 \u0564\u0580\u0561\u0576\u0589",
        ka: "\u10E6\u10D8\u10D0 \u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10D8 \u10DB\u10D8\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10D8\u10E1 \u10D5\u10D4\u10DA\u10E8\u10D8 \u10D8\u10DC\u10D0\u10EE\u10D4\u10D1\u10D0, \u10D0\u10E1\u10D4 \u10E0\u10DD\u10DB \u10D2\u10D0\u10DC\u10D0\u10EE\u10DA\u10D4\u10D1\u10D0 \u10D3\u10D0 \xab\u10E3\u10D9\u10D0\u10DC\xbb \u10DB\u10D0\u10E1\u10D6\u10D4 \u10D0\u10D1\u10E0\u10E3\u10DC\u10D4\u10D1\u10E1."
    },
    tasks_desc: {
        uk: "\u0429\u043E \u043C\u0435\u0440\u0447\u0430\u043D\u0434\u0430\u0439\u0437\u0435\u0440\u0438 \u043C\u0430\u044E\u0442\u044C \u0437\u0440\u043E\u0431\u0438\u0442\u0438 \u0432 \u0442\u043E\u0447\u043A\u0430\u0445 \u0456 \u0447\u0438\u043C \u0437\u0430\u0432\u0435\u0440\u0448\u0438\u043B\u043E\u0441\u044F \u043A\u043E\u0436\u043D\u0435 \u0434\u043E\u0440\u0443\u0447\u0435\u043D\u043D\u044F. \u041D\u0430 \u0437\u0430\u0434\u0430\u0447\u0443 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0430\u044E\u0442\u044C \u0456\u0437 \u043C\u043E\u0431\u0456\u043B\u044C\u043D\u043E\u0433\u043E \u0437\u0430\u0441\u0442\u043E\u0441\u0443\u043D\u043A\u0443, \u0456 \u0441\u0442\u0430\u0442\u0443\u0441 \u0432\u0438\u0437\u043D\u0430\u0447\u0430\u0454 \u043D\u0430\u0439\u043D\u043E\u0432\u0456\u0448\u0430 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u044C.",
        en: "What merchandisers are asked to do at points, and how each request ended. A task is answered from the mobile app, and the newest answer decides its status.",
        hy: "\u053B\u0576\u0579 \u057A\u0565\u057F\u0584 \u0567 \u0561\u0576\u0565\u0576 \u0574\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580\u0576\u0565\u0580\u0568 \u056F\u0565\u057F\u0565\u0580\u0578\u0582\u0574 \u0587 \u056B\u0576\u0579\u057A\u0565\u057D \u0561\u057E\u0561\u0580\u057F\u057E\u0565\u0581 \u0575\u0578\u0582\u0580\u0561\u0584\u0561\u0576\u0579\u0575\u0578\u0582\u0580 \u0570\u0561\u0576\u0571\u0576\u0561\u0580\u0561\u0580\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0589 \u0531\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u056B\u0576 \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0578\u0582\u0574 \u0565\u0576 \u0562\u057B\u057B\u0561\u0575\u056B\u0576 \u0570\u0561\u057E\u0565\u056C\u057E\u0561\u056E\u056B\u0581, \u0587 \u056F\u0561\u0580\u0563\u0561\u057E\u056B\u0573\u0561\u056F\u0568 \u0578\u0580\u0578\u0577\u0578\u0582\u0574 \u0567 \u0561\u0574\u0565\u0576\u0561\u057E\u0565\u0580\u057B\u056B\u0576 \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0568\u0589",
        ka: "\u10E0\u10D0 \u10E3\u10DC\u10D3\u10D0 \u10D2\u10D0\u10D0\u10D9\u10D4\u10D7\u10DD\u10DC \u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D4\u10D1\u10DB\u10D0 \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D6\u10D4 \u10D3\u10D0 \u10E0\u10DD\u10D2\u10DD\u10E0 \u10D3\u10D0\u10E1\u10E0\u10E3\u10DA\u10D3\u10D0 \u10D7\u10D8\u10D7\u10DD\u10D4\u10E3\u10DA\u10D8 \u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D0. \u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D0\u10E1 \u10DB\u10DD\u10D1\u10D8\u10DA\u10E3\u10E0\u10D8 \u10D0\u10DE\u10DA\u10D8\u10D9\u10D0\u10EA\u10D8\u10D8\u10D3\u10D0\u10DC \u10DE\u10D0\u10E1\u10E3\u10EE\u10DD\u10D1\u10D4\u10DC \u10D3\u10D0 \u10E1\u10E2\u10D0\u10E2\u10E3\u10E1\u10E1 \u10E3\u10D0\u10EE\u10DA\u10D4\u10E1\u10D8 \u10DE\u10D0\u10E1\u10E3\u10EE\u10D8 \u10D2\u10D0\u10DC\u10E1\u10D0\u10D6\u10E6\u10D5\u10E0\u10D0\u10D5\u10E1."
    },
    tasks_b1: {
        uk: "\u0427\u043E\u0442\u0438\u0440\u0438 \u0441\u0442\u0430\u0442\u0443\u0441\u0438: \u043E\u0447\u0456\u043A\u0443\u0454 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0456, \u043D\u0430 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0446\u0456, \u0441\u0445\u0432\u0430\u043B\u0435\u043D\u043E, \u0432\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043E. \u041C\u0456\u0442\u043A\u0438 \u0434\u043E\u0434\u0430\u044E\u0442\u044C \xab\u041F\u0440\u043E\u0441\u0440\u043E\u0447\u0435\u043D\u0456\xbb, \xab\u0417 \u043D\u0435\u0433\u0430\u0442\u0438\u0432\u043D\u0438\u043C\u0438 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u044F\u043C\u0438\xbb \u0442\u0430 \xab\u041D\u0435\u0430\u043A\u0442\u0438\u0432\u043D\u0456\xbb.",
        en: "Four statuses: awaiting an answer, on review, approved, rejected. Chips add Overdue, With negative answers and Inactive.",
        hy: "\u0549\u0578\u0580\u057D \u056F\u0561\u0580\u0563\u0561\u057E\u056B\u0573\u0561\u056F\u055D \u057D\u057A\u0561\u057D\u0578\u0582\u0574 \u0567 \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u056B, \u057D\u057F\u0578\u0582\u0563\u0574\u0561\u0576 \u0574\u0565\u057B, \u0570\u0561\u057D\u057F\u0561\u057F\u057E\u0561\u056E, \u0574\u0565\u0580\u056A\u057E\u0561\u056E\u0589 \u054A\u056B\u057F\u0561\u056F\u0576\u0565\u0580\u0568 \u0561\u057E\u0565\u056C\u0561\u0581\u0576\u0578\u0582\u0574 \u0565\u0576 \xab\u053A\u0561\u0574\u056F\u0565\u057F\u0561\u0576\u0581\xbb, \xab\u0532\u0561\u0581\u0561\u057D\u0561\u056F\u0561\u0576 \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0576\u0565\u0580\u0578\u057E\xbb \u0587 \xab\u0548\u0579 \u0561\u056F\u057F\u056B\u057E\xbb\u0589",
        ka: "\u10DD\u10D7\u10EE\u10D8 \u10E1\u10E2\u10D0\u10E2\u10E3\u10E1\u10D8: \u10DE\u10D0\u10E1\u10E3\u10EE\u10D8\u10E1 \u10DB\u10DD\u10DA\u10DD\u10D3\u10D8\u10DC\u10E8\u10D8, \u10E8\u10D4\u10DB\u10DD\u10EC\u10DB\u10D4\u10D1\u10D0\u10D6\u10D4, \u10D3\u10D0\u10DB\u10E2\u10D9\u10D8\u10EA\u10D4\u10D1\u10E3\u10DA\u10D8, \u10E3\u10D0\u10E0\u10E7\u10DD\u10E4\u10D8\u10DA\u10D8. \u10E9\u10D8\u10DE\u10D4\u10D1\u10D8 \u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10E1 \xab\u10D5\u10D0\u10D3\u10D0\u10D2\u10D0\u10D3\u10D0\u10EA\u10D8\u10DA\u10D4\u10D1\u10E3\u10DA\u10E1\xbb, \xab\u10E3\u10D0\u10E0\u10E7\u10DD\u10E4\u10D8\u10D7\u10D8 \u10DE\u10D0\u10E1\u10E3\u10EE\u10D4\u10D1\u10D8\u10D7\xbb \u10D3\u10D0 \xab\u10D0\u10E0\u10D0\u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10E1\xbb."
    },
    tasks_b2: {
        uk: "\u041D\u043E\u0432\u0430 \u0437\u0430\u0434\u0430\u0447\u0430 \u2014 \u0434\u043B\u044F \u043E\u0434\u043D\u0456\u0454\u0457 \u0442\u043E\u0447\u043A\u0438, \u0446\u0456\u043B\u043E\u0457 \u043C\u0435\u0440\u0435\u0436\u0456 (\u043F\u043E \u0437\u0430\u0434\u0430\u0447\u0456 \u043D\u0430 \u043A\u043E\u0436\u043D\u0443 \u0457\u0457 \u0442\u043E\u0447\u043A\u0443) \u0430\u0431\u043E \u0433\u0440\u0443\u043F\u0438 \u0442\u043E\u0447\u043E\u043A. \u0428\u0430\u0431\u043B\u043E\u043D \u0432\u0438\u0437\u043D\u0430\u0447\u0430\u0454, \u0449\u043E \u0441\u0430\u043C\u0435 \u0437\u0430\u043F\u0438\u0442\u0443\u044E\u0442\u044C \u0443 \u043C\u0435\u0440\u0447\u0430\u043D\u0434\u0430\u0439\u0437\u0435\u0440\u0430.",
        en: "New task targets one point, a whole network (one task per point in it) or a point group. The template decides what the merchandiser is asked for.",
        hy: "\u0546\u0578\u0580 \u0561\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0568 \u0574\u0565\u056F \u056F\u0565\u057F\u056B, \u0561\u0574\u0562\u0578\u0572\u057B \u0581\u0561\u0576\u0581\u056B (\u0575\u0578\u0582\u0580\u0561\u0584\u0561\u0576\u0579\u0575\u0578\u0582\u0580 \u056F\u0565\u057F\u056B \u0570\u0561\u0574\u0561\u0580 \u0574\u0565\u056F \u0561\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584) \u056F\u0561\u0574 \u056F\u0565\u057F\u0565\u0580\u056B \u056D\u0574\u0562\u056B \u0570\u0561\u0574\u0561\u0580 \u0567\u0589 \u0541\u0587\u0561\u0576\u0574\u0578\u0582\u0577\u0568 \u0578\u0580\u0578\u0577\u0578\u0582\u0574 \u0567, \u0569\u0565 \u056B\u0576\u0579 \u0567 \u057A\u0561\u0570\u0561\u0576\u057B\u057E\u0578\u0582\u0574 \u0574\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580\u056B\u0581\u0589",
        ka: "\u10D0\u10EE\u10D0\u10DA\u10D8 \u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D0 \u10D4\u10E0\u10D7\u10D8 \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1, \u10DB\u10D7\u10D4\u10DA\u10D8 \u10E5\u10E1\u10D4\u10DA\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1 (\u10D7\u10D8\u10D7\u10DD \u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D0 \u10DB\u10D8\u10E1 \u10E7\u10DD\u10D5\u10D4\u10DA \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D6\u10D4) \u10D0\u10DC \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1 \u10EF\u10D2\u10E3\u10E4\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1. \u10E8\u10D0\u10D1\u10DA\u10DD\u10DC\u10D8 \u10D2\u10D0\u10DC\u10E1\u10D0\u10D6\u10E6\u10D5\u10E0\u10D0\u10D5\u10E1, \u10E0\u10D0\u10E1 \u10E1\u10D7\u10EE\u10DD\u10D5\u10D4\u10DC \u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10E1."
    },
    tasks_b3: {
        uk: "\u041F\u0435\u0440\u0456\u043E\u0434 \u0444\u0456\u043B\u044C\u0442\u0440\u0443\u0454 \u0437\u0430 \u0434\u0435\u0434\u043B\u0430\u0439\u043D\u043E\u043C, \u0437\u0430 \u0437\u0430\u043C\u043E\u0432\u0447\u0443\u0432\u0430\u043D\u043D\u044F\u043C \u2014 \u0442\u0438\u0436\u0434\u0435\u043D\u044C \u043D\u0430\u0437\u0430\u0434 \u0456 \u0442\u0438\u0436\u0434\u0435\u043D\u044C \u0443\u043F\u0435\u0440\u0435\u0434.",
        en: "The period filters by deadline and defaults to a week back and a week ahead.",
        hy: "\u053A\u0561\u0574\u0561\u0576\u0561\u056F\u0561\u0570\u0561\u057F\u057E\u0561\u056E\u0568 \u0566\u057F\u0578\u0582\u0574 \u0567 \u057E\u0565\u0580\u057B\u0576\u0561\u056A\u0561\u0574\u056F\u0565\u057F\u0578\u057E, \u056C\u057C\u0565\u056C\u0575\u0561\u0575\u0576\u055D \u0574\u0565\u056F \u0577\u0561\u0562\u0561\u0569 \u0561\u057C\u0561\u057B \u0587 \u0574\u0565\u056F \u0577\u0561\u0562\u0561\u0569 \u0570\u0565\u057F\u0578\u0589",
        ka: "\u10DE\u10D4\u10E0\u10D8\u10DD\u10D3\u10D8 \u10D5\u10D0\u10D3\u10D8\u10E1 \u10DB\u10D8\u10EE\u10D4\u10D3\u10D5\u10D8\u10D7 \u10E4\u10D8\u10DA\u10E2\u10E0\u10D0\u10D5\u10E1, \u10DC\u10D0\u10D2\u10E3\u10DA\u10D8\u10E1\u10EE\u10DB\u10D4\u10D5\u10D0\u10D3 \u2014 \u10D9\u10D5\u10D8\u10E0\u10D0 \u10E3\u10D9\u10D0\u10DC \u10D3\u10D0 \u10D9\u10D5\u10D8\u10E0\u10D0 \u10EC\u10D8\u10DC."
    },
    tasks_b4: {
        uk: "\u0417\u0430\u0434\u0430\u0447\u0443 \u0434\u0435\u0430\u043A\u0442\u0438\u0432\u0443\u044E\u0442\u044C, \u0430 \u043D\u0435 \u0432\u0438\u0434\u0430\u043B\u044F\u044E\u0442\u044C. \u041D\u0430 \u0441\u0442\u043E\u0440\u0456\u043D\u0446\u0456 \u0437\u0430\u0434\u0430\u0447\u0456 \u043C\u043E\u0436\u043D\u0430 \u0441\u0445\u0432\u0430\u043B\u0438\u0442\u0438 \u0447\u0438 \u0432\u0456\u0434\u0445\u0438\u043B\u0438\u0442\u0438 \u043E\u0441\u0442\u0430\u043D\u043D\u044E \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u044C \u0456 \u0437\u043C\u0456\u043D\u0438\u0442\u0438 \u043E\u043F\u0438\u0441, \u0434\u0430\u0442\u0438, \u0448\u0430\u0431\u043B\u043E\u043D \u0456 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F.",
        en: "A task is deactivated, never deleted. On the task page you approve or reject its newest answer and edit the description, dates, template and images.",
        hy: "\u0531\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0568 \u0561\u057A\u0561\u0561\u056F\u057F\u056B\u057E\u0561\u0581\u057E\u0578\u0582\u0574 \u0567, \u0578\u0579 \u0569\u0565 \u057B\u0576\u057B\u057E\u0578\u0582\u0574\u0589 \u0531\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u056B \u0567\u057B\u0578\u0582\u0574 \u056F\u0561\u0580\u0565\u056C\u056B \u0567 \u0570\u0561\u057D\u057F\u0561\u057F\u0565\u056C \u056F\u0561\u0574 \u0574\u0565\u0580\u056A\u0565\u056C \u057E\u0565\u0580\u057B\u056B\u0576 \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0568 \u0587 \u0583\u0578\u056D\u0565\u056C \u0576\u056F\u0561\u0580\u0561\u0563\u0580\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0568, \u0561\u0574\u057D\u0561\u0569\u057E\u0565\u0580\u0568, \u0571\u0587\u0561\u0576\u0574\u0578\u0582\u0577\u0568 \u0587 \u057A\u0561\u057F\u056F\u0565\u0580\u0576\u0565\u0580\u0568\u0589",
        ka: "\u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D0 \u10D3\u10D4\u10D0\u10E5\u10E2\u10D8\u10D5\u10D8\u10E0\u10D3\u10D4\u10D1\u10D0 \u10D3\u10D0 \u10D0\u10E0\u10D0 \u10D8\u10E8\u10DA\u10D4\u10D1\u10D0. \u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D5\u10D4\u10E0\u10D3\u10D6\u10D4 \u10E8\u10D4\u10D2\u10D8\u10EB\u10DA\u10D8\u10D0\u10D7 \u10D3\u10D0\u10D0\u10DB\u10E2\u10D9\u10D8\u10EA\u10DD\u10D7 \u10D0\u10DC \u10E3\u10D0\u10E0\u10E7\u10DD\u10D7 \u10E3\u10D0\u10EE\u10DA\u10D4\u10E1\u10D8 \u10DE\u10D0\u10E1\u10E3\u10EE\u10D8 \u10D3\u10D0 \u10E8\u10D4\u10EA\u10D5\u10D0\u10DA\u10DD\u10D7 \u10D0\u10E6\u10EC\u10D4\u10E0\u10D0, \u10D7\u10D0\u10E0\u10D8\u10E6\u10D4\u10D1\u10D8, \u10E8\u10D0\u10D1\u10DA\u10DD\u10DC\u10D8 \u10D3\u10D0 \u10E1\u10E3\u10E0\u10D0\u10D7\u10D4\u10D1\u10D8."
    },
    answers_desc: {
        uk: "\u0423\u0441\u0456 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0456 \u043C\u0435\u0440\u0447\u0430\u043D\u0434\u0430\u0439\u0437\u0435\u0440\u0456\u0432 \u043D\u0430 \u0437\u0430\u0434\u0430\u0447\u0456 \u2014 \u044F\u043A \u0447\u0435\u0440\u0433\u0430 \u043D\u0430 \u0432\u0430\u0448\u0435 \u0440\u0456\u0448\u0435\u043D\u043D\u044F.",
        en: "Every answer merchandisers gave to tasks, as a queue for your verdict.",
        hy: "\u0544\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580\u0576\u0565\u0580\u056B \u0562\u0578\u056C\u0578\u0580 \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0576\u0565\u0580\u0568 \u0561\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0576\u0565\u0580\u056B\u0576\u055D \u0578\u0580\u057A\u0565\u057D \u0570\u0565\u0580\u0569 \u0571\u0565\u0580 \u0578\u0580\u0578\u0577\u0574\u0561\u0576 \u0570\u0561\u0574\u0561\u0580\u0589",
        ka: "\u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D4\u10D1\u10D8\u10E1 \u10E7\u10D5\u10D4\u10DA\u10D0 \u10DE\u10D0\u10E1\u10E3\u10EE\u10D8 \u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D4\u10D1\u10D6\u10D4 \u2014 \u10E0\u10D8\u10D2\u10D8 \u10D7\u10E5\u10D5\u10D4\u10DC\u10D8 \u10D2\u10D0\u10D3\u10D0\u10EC\u10E7\u10D5\u10D4\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1\u10D7\u10D5\u10D8\u10E1."
    },
    answers_b1: {
        uk: "\u0424\u0456\u043B\u044C\u0442\u0440\u0443\u0439\u0442\u0435 \u0437\u0430 \u043F\u0435\u0440\u0456\u043E\u0434\u043E\u043C, \u0440\u0435\u0433\u0456\u043E\u043D\u043E\u043C, \u043C\u0435\u0440\u0435\u0436\u0435\u044E, \u0448\u0430\u0431\u043B\u043E\u043D\u043E\u043C, \u043C\u0435\u0440\u0447\u0430\u043D\u0434\u0430\u0439\u0437\u0435\u0440\u043E\u043C, \u0441\u0443\u043F\u0435\u0440\u0432\u0430\u0439\u0437\u0435\u0440\u043E\u043C \u0456 \u0442\u043E\u0447\u043A\u0430\u043C\u0438; \u043C\u0456\u0442\u043A\u0430 \xab\u041D\u0435\u0433\u0430\u0442\u0438\u0432\u043D\u0456\xbb \u0437\u0430\u043B\u0438\u0448\u0430\u0454 \u043B\u0438\u0448\u0435 \u043D\u0435\u0433\u0430\u0442\u0438\u0432\u043D\u0456 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0456.",
        en: "Filter by period, county, network, template, merchandiser, supervisor and points; the Negative chip keeps only negative answers.",
        hy: "\u0536\u057F\u0565\u0584 \u0568\u057D\u057F \u056A\u0561\u0574\u0561\u0576\u0561\u056F\u0561\u0570\u0561\u057F\u057E\u0561\u056E\u056B, \u0574\u0561\u0580\u0566\u056B, \u0581\u0561\u0576\u0581\u056B, \u0571\u0587\u0561\u0576\u0574\u0578\u0582\u0577\u056B, \u0574\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580\u056B, \u057D\u0578\u0582\u057A\u0565\u0580\u057E\u0561\u0575\u0566\u0565\u0580\u056B \u0587 \u056F\u0565\u057F\u0565\u0580\u056B. \xab\u0532\u0561\u0581\u0561\u057D\u0561\u056F\u0561\u0576\xbb \u057A\u056B\u057F\u0561\u056F\u0568 \u0569\u0578\u0572\u0576\u0578\u0582\u0574 \u0567 \u0574\u056B\u0561\u0575\u0576 \u0562\u0561\u0581\u0561\u057D\u0561\u056F\u0561\u0576 \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0576\u0565\u0580\u0568\u0589",
        ka: "\u10D2\u10D0\u10E4\u10D8\u10DA\u10E2\u10E0\u10D4\u10D7 \u10DE\u10D4\u10E0\u10D8\u10DD\u10D3\u10D8\u10D7, \u10E0\u10D4\u10D2\u10D8\u10DD\u10DC\u10D8\u10D7, \u10E5\u10E1\u10D4\u10DA\u10D8\u10D7, \u10E8\u10D0\u10D1\u10DA\u10DD\u10DC\u10D8\u10D7, \u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D8\u10D7, \u10E1\u10E3\u10DE\u10D4\u10E0\u10D5\u10D0\u10D8\u10D6\u10D4\u10E0\u10D8\u10D7\u10D0 \u10D3\u10D0 \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8\u10D7; \xab\u10E3\u10D0\u10E0\u10E7\u10DD\u10E4\u10D8\u10D7\u10D8\xbb \u10E9\u10D8\u10DE\u10D8 \u10DB\u10EE\u10DD\u10DA\u10DD\u10D3 \u10E3\u10D0\u10E0\u10E7\u10DD\u10E4\u10D8\u10D7 \u10DE\u10D0\u10E1\u10E3\u10EE\u10D4\u10D1\u10E1 \u10E2\u10DD\u10D5\u10D4\u10D1\u10E1."
    },
    answers_b2: {
        uk: "\u0412\u0456\u0434\u043A\u0440\u0438\u0439\u0442\u0435 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u044C, \u0449\u043E\u0431 \u043F\u043E\u0431\u0430\u0447\u0438\u0442\u0438 \u0444\u043E\u0442\u043E, \u0449\u043E \u0437\u0430\u043F\u0438\u0442\u0443\u0432\u0430\u043B\u0438 \u0456 \u0449\u043E \u043D\u0430\u0434\u0456\u0439\u0448\u043B\u043E, \u0437 \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F\u043C\u0438 \u043D\u0430 \u0437\u0430\u0434\u0430\u0447\u0443 \u0442\u0430 \u0432\u0456\u0437\u0438\u0442.",
        en: "Open an answer to see the photos, what was asked and what came back, with links to the task and the visit.",
        hy: "\u0532\u0561\u0581\u0565\u0584 \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0568\u055D \u056C\u0578\u0582\u057D\u0561\u0576\u056F\u0561\u0580\u0576\u0565\u0580\u0568, \u0570\u0561\u0580\u0581\u057E\u0561\u056E\u0568 \u0587 \u057D\u057F\u0561\u0581\u057E\u0561\u056E\u0568 \u057F\u0565\u057D\u0576\u0565\u056C\u0578\u0582 \u0570\u0561\u0574\u0561\u0580, \u0561\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u056B \u0587 \u0561\u0575\u0581\u056B \u0570\u0572\u0578\u0582\u0574\u0576\u0565\u0580\u0578\u057E\u0589",
        ka: "\u10D2\u10D0\u10EE\u10E1\u10D4\u10DC\u10D8\u10D7 \u10DE\u10D0\u10E1\u10E3\u10EE\u10D8, \u10E0\u10DD\u10DB \u10DC\u10D0\u10EE\u10DD\u10D7 \u10E4\u10DD\u10E2\u10DD\u10D4\u10D1\u10D8, \u10E0\u10D0 \u10D8\u10D9\u10D8\u10D7\u10EE\u10D4\u10E1 \u10D3\u10D0 \u10E0\u10D0 \u10DB\u10DD\u10D5\u10D8\u10D3\u10D0, \u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D8\u10E1\u10D0 \u10D3\u10D0 \u10D5\u10D8\u10D6\u10D8\u10E2\u10D8\u10E1 \u10D1\u10DB\u10E3\u10DA\u10D4\u10D1\u10D8\u10D7."
    },
    answers_b3: {
        uk: "\u0421\u0445\u0432\u0430\u043B\u044E\u0439\u0442\u0435 \u0430\u0431\u043E \u0432\u0456\u0434\u0445\u0438\u043B\u044F\u0439\u0442\u0435 \u0437 \u043F\u0440\u0438\u0447\u0438\u043D\u043E\u044E; \u0432\u0456\u0434\u0445\u0438\u043B\u0435\u043D\u043D\u044F \u0441\u0442\u0432\u043E\u0440\u044E\u0454 \u043A\u043E\u0440\u0438\u0433\u0443\u0432\u0430\u043B\u044C\u043D\u0443 \u0437\u0430\u0434\u0430\u0447\u0443. \u0417\u0456 \u0441\u043F\u0438\u0441\u043A\u0443 \u043C\u043E\u0436\u043D\u0430 \u0441\u0445\u0432\u0430\u043B\u0438\u0442\u0438 \u043A\u0456\u043B\u044C\u043A\u0430 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0435\u0439 \u043E\u0434\u0440\u0430\u0437\u0443.",
        en: "Approve, or reject with a reason; a rejection creates a corrective task. From the list, several answers can be approved at once.",
        hy: "\u0540\u0561\u057D\u057F\u0561\u057F\u0565\u0584 \u056F\u0561\u0574 \u0574\u0565\u0580\u056A\u0565\u0584 \u057A\u0561\u057F\u0573\u0561\u057C\u0578\u057E. \u0574\u0565\u0580\u056A\u0578\u0582\u0574\u0568 \u0578\u0582\u0572\u0572\u056B\u0579 \u0561\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584 \u0567 \u057D\u057F\u0565\u0572\u056E\u0578\u0582\u0574\u0589 \u0551\u0578\u0582\u0581\u0561\u056F\u056B\u0581 \u056F\u0561\u0580\u0565\u056C\u056B \u0567 \u0574\u056B \u0584\u0561\u0576\u056B \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576 \u0574\u056B\u0561\u057D\u056B\u0576 \u0570\u0561\u057D\u057F\u0561\u057F\u0565\u056C\u0589",
        ka: "\u10D3\u10D0\u10D0\u10DB\u10E2\u10D9\u10D8\u10EA\u10D4\u10D7 \u10D0\u10DC \u10E3\u10D0\u10E0\u10E7\u10D0\u10D5\u10D8\u10D7 \u10DB\u10D8\u10D6\u10D4\u10D6\u10D8\u10D7; \u10E3\u10D0\u10E0\u10E7\u10DD\u10E4\u10D0 \u10DB\u10D0\u10D9\u10DD\u10E0\u10D4\u10E5\u10E2\u10D8\u10E0\u10D4\u10D1\u10D4\u10DA \u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D0\u10E1 \u10E5\u10DB\u10DC\u10D8\u10E1. \u10E1\u10D8\u10D8\u10D3\u10D0\u10DC \u10E0\u10D0\u10DB\u10D3\u10D4\u10DC\u10D8\u10DB\u10D4 \u10DE\u10D0\u10E1\u10E3\u10EE\u10D8\u10E1 \u10D4\u10E0\u10D7\u10D3\u10E0\u10DD\u10E3\u10DA\u10D0\u10D3 \u10D3\u10D0\u10DB\u10E2\u10D9\u10D8\u10EA\u10D4\u10D1\u10D0 \u10E8\u10D4\u10D8\u10EB\u10DA\u10D4\u10D1\u10D0."
    },
    answers_b4: {
        uk: "[ \u0456 ] \u043F\u0435\u0440\u0435\u0445\u043E\u0434\u044F\u0442\u044C \u043F\u043E \u0447\u0435\u0440\u0437\u0456; \u043F\u0456\u0441\u043B\u044F \u0440\u0456\u0448\u0435\u043D\u043D\u044F \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0430 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u044C \u0432\u0456\u0434\u043A\u0440\u0438\u0432\u0430\u0454\u0442\u044C\u0441\u044F \u0441\u0430\u043C\u0430.",
        en: "[ and ] step through the queue; after a verdict the next answer opens by itself.",
        hy: "[ \u0587 ] \u0561\u0576\u0581\u0576\u0578\u0582\u0574 \u0565\u0576 \u0570\u0565\u0580\u0569\u0578\u057E, \u0578\u0580\u0578\u0577\u0578\u0582\u0574\u056B\u0581 \u0570\u0565\u057F\u0578 \u0570\u0561\u057B\u0578\u0580\u0564 \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0576 \u056B\u0576\u0584\u0576 \u0567 \u0562\u0561\u0581\u057E\u0578\u0582\u0574\u0589",
        ka: "[ \u10D3\u10D0 ] \u10E0\u10D8\u10D2\u10E8\u10D8 \u10D2\u10D0\u10D3\u10D0\u10D3\u10D8\u10E1; \u10D2\u10D0\u10D3\u10D0\u10EC\u10E7\u10D5\u10D4\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D3\u10D4\u10D2 \u10E8\u10D4\u10DB\u10D3\u10D4\u10D2\u10D8 \u10DE\u10D0\u10E1\u10E3\u10EE\u10D8 \u10D7\u10D0\u10D5\u10D0\u10D3 \u10D8\u10EE\u10E1\u10DC\u10D4\u10D1\u10D0."
    },
    import_title: {
        uk: "\u0406\u043C\u043F\u043E\u0440\u0442 \u0456 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F",
        en: "Import and uploads",
        hy: "\u0546\u0565\u0580\u0574\u0578\u0582\u056E\u0578\u0582\u0574 \u0587 \u0562\u0565\u057C\u0576\u0578\u0582\u0574\u0576\u0565\u0580",
        ka: "\u10D8\u10DB\u10DE\u10DD\u10E0\u10E2\u10D8 \u10D3\u10D0 \u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D4\u10D1\u10D8"
    },
    import_desc: {
        uk: "\u0421\u0442\u0432\u043E\u0440\u044E\u0439\u0442\u0435 \u0431\u0430\u0433\u0430\u0442\u043E \u0437\u0430\u0434\u0430\u0447 \u0430\u0431\u043E \u0430\u0441\u043E\u0440\u0442\u0438\u043C\u0435\u043D\u0442\u043D\u0443 \u043C\u0430\u0442\u0440\u0438\u0446\u044E \u0437 \u0444\u0430\u0439\u043B\u0443 \u0437\u0430\u043C\u0456\u0441\u0442\u044C \u0442\u043E\u0433\u043E, \u0449\u043E\u0431 \u0440\u043E\u0431\u0438\u0442\u0438 \u0446\u0435 \u043F\u043E \u043E\u0434\u043D\u0456\u0439. \u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442 \u043A\u043E\u0436\u043D\u043E\u0433\u043E \u043F\u0430\u043A\u0435\u0442\u0430 \u2014 \u043D\u0430 \u0441\u0442\u043E\u0440\u0456\u043D\u0446\u0456 \xab\u041C\u043E\u0457 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F\xbb.",
        en: "Create many tasks or an assortment matrix from a file instead of one by one. The result of each batch lives on My uploads.",
        hy: "\u054D\u057F\u0565\u0572\u056E\u0565\u0584 \u0562\u0561\u0566\u0574\u0561\u0569\u056B\u057E \u0561\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0576\u0565\u0580 \u056F\u0561\u0574 \u057F\u0565\u057D\u0561\u056F\u0561\u0576\u0578\u0582 \u0574\u0561\u057F\u0580\u056B\u0581\u0561 \u0586\u0561\u0575\u056C\u056B\u0581\u055D \u0574\u0565\u056F-\u0574\u0565\u056F \u0561\u0576\u0565\u056C\u0578\u0582 \u0583\u0578\u056D\u0561\u0580\u0565\u0576\u0589 \u0545\u0578\u0582\u0580\u0561\u0584\u0561\u0576\u0579\u0575\u0578\u0582\u0580 \u0583\u0561\u0569\u0565\u0569\u056B \u0561\u0580\u0564\u0575\u0578\u0582\u0576\u0584\u0568 \xab\u053B\u0574 \u0562\u0565\u057C\u0576\u0578\u0582\u0574\u0576\u0565\u0580\u0568\xbb \u0567\u057B\u0578\u0582\u0574 \u0567\u0589",
        ka: "\u10E8\u10D4\u10E5\u10DB\u10D4\u10DC\u10D8\u10D7 \u10D1\u10D4\u10D5\u10E0\u10D8 \u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D0 \u10D0\u10DC \u10D0\u10E1\u10DD\u10E0\u10E2\u10D8\u10DB\u10D4\u10DC\u10E2\u10D8\u10E1 \u10DB\u10D0\u10E2\u10E0\u10D8\u10EA\u10D0 \u10E4\u10D0\u10D8\u10DA\u10D8\u10D3\u10D0\u10DC \u10E1\u10D0\u10D7\u10D8\u10D7\u10D0\u10DD\u10E1 \u10DC\u10D0\u10EA\u10D5\u10DA\u10D0\u10D3. \u10D7\u10D8\u10D7\u10DD\u10D4\u10E3\u10DA\u10D8 \u10DE\u10D0\u10D9\u10D4\u10E2\u10D8\u10E1 \u10E8\u10D4\u10D3\u10D4\u10D2\u10D8 \xab\u10E9\u10D4\u10DB\u10D8 \u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D4\u10D1\u10D8\xbb \u10D2\u10D5\u10D4\u10E0\u10D3\u10D6\u10D4\u10D0."
    },
    import_b1: {
        uk: "\u0422\u0440\u0438 \u0432\u0438\u0434\u0438: \u0437\u0430\u0434\u0430\u0447\u0456 \u0437\u0456 \u0441\u043F\u0456\u043B\u044C\u043D\u043E\u044E \u0442\u043E\u0447\u043A\u043E\u044E \u0447\u0438 \u043C\u0435\u0440\u0435\u0436\u0435\u044E, \u0437\u0430\u0434\u0430\u0447\u0456 \u0437 \u0442\u043E\u0447\u043A\u043E\u044E \u0447\u0438 \u043C\u0435\u0440\u0435\u0436\u0435\u044E \u0432 \u043A\u043E\u0436\u043D\u043E\u043C\u0443 \u0440\u044F\u0434\u043A\u0443 \u0442\u0430 \u0430\u0441\u043E\u0440\u0442\u0438\u043C\u0435\u043D\u0442\u043D\u0430 \u043C\u0430\u0442\u0440\u0438\u0446\u044F.",
        en: "Three kinds: tasks with one shared point or network, tasks with the point or network in each row, and an assortment matrix.",
        hy: "\u0535\u0580\u0565\u0584 \u057F\u0565\u057D\u0561\u056F\u055D \u0561\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0576\u0565\u0580 \u0568\u0576\u0564\u0570\u0561\u0576\u0578\u0582\u0580 \u056F\u0565\u057F\u0578\u057E \u056F\u0561\u0574 \u0581\u0561\u0576\u0581\u0578\u057E, \u0561\u057C\u0561\u057B\u0561\u0564\u0580\u0561\u0576\u0584\u0576\u0565\u0580 \u0575\u0578\u0582\u0580\u0561\u0584\u0561\u0576\u0579\u0575\u0578\u0582\u0580 \u057F\u0578\u0572\u0578\u0582\u0574 \u056F\u0565\u057F\u0578\u057E \u056F\u0561\u0574 \u0581\u0561\u0576\u0581\u0578\u057E, \u0587 \u057F\u0565\u057D\u0561\u056F\u0561\u0576\u0578\u0582 \u0574\u0561\u057F\u0580\u056B\u0581\u0561\u0589",
        ka: "\u10E1\u10D0\u10DB\u10D8 \u10E1\u10D0\u10EE\u10D4\u10DD\u10D1\u10D0: \u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8 \u10E1\u10D0\u10D4\u10E0\u10D7\u10DD \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8\u10D7 \u10D0\u10DC \u10E5\u10E1\u10D4\u10DA\u10D8\u10D7, \u10D3\u10D0\u10D5\u10D0\u10DA\u10D4\u10D1\u10D4\u10D1\u10D8 \u10E7\u10DD\u10D5\u10D4\u10DA \u10E1\u10E2\u10E0\u10D8\u10E5\u10DD\u10DC\u10E8\u10D8 \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8\u10D7 \u10D0\u10DC \u10E5\u10E1\u10D4\u10DA\u10D8\u10D7, \u10D3\u10D0 \u10D0\u10E1\u10DD\u10E0\u10E2\u10D8\u10DB\u10D4\u10DC\u10E2\u10D8\u10E1 \u10DB\u10D0\u10E2\u10E0\u10D8\u10EA\u10D0."
    },
    import_b2: {
        uk: "CSV \u0456 XLSX \u0447\u0438\u0442\u0430\u044E\u0442\u044C\u0441\u044F \u0432 \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0456; \u043A\u043E\u0436\u0435\u043D \u0440\u044F\u0434\u043E\u043A \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u044F\u0454\u0442\u044C\u0441\u044F \u043D\u0430 \u0444\u043E\u0440\u043C\u0443, \u0456 \u043D\u0430\u0434\u0441\u0438\u043B\u0430\u044E\u0442\u044C\u0441\u044F \u043B\u0438\u0448\u0435 \u043A\u043E\u0440\u0435\u043A\u0442\u043D\u0456. \u041A\u043E\u0434\u0438 \u0442\u043E\u0447\u043E\u043A, \u0442\u043E\u0432\u0430\u0440\u0456\u0432 \u0456 \u0448\u0430\u0431\u043B\u043E\u043D\u0456\u0432 \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u044F\u0454 \u0441\u0435\u0440\u0432\u0435\u0440.",
        en: "CSV and XLSX are read in the browser; each row is checked for shape and only valid rows are sent. Codes of points, products and templates are checked by the server.",
        hy: "CSV \u0587 XLSX \u0586\u0561\u0575\u056C\u0565\u0580\u0568 \u056F\u0561\u0580\u0564\u0561\u0581\u057E\u0578\u0582\u0574 \u0565\u0576 \u0562\u0580\u0561\u0578\u0582\u0566\u0565\u0580\u0578\u0582\u0574, \u0575\u0578\u0582\u0580\u0561\u0584\u0561\u0576\u0579\u0575\u0578\u0582\u0580 \u057F\u0578\u0572\u0568 \u057D\u057F\u0578\u0582\u0563\u057E\u0578\u0582\u0574 \u0567 \u0571\u0587\u0578\u057E, \u0587 \u0578\u0582\u0572\u0561\u0580\u056F\u057E\u0578\u0582\u0574 \u0565\u0576 \u0574\u056B\u0561\u0575\u0576 \u057E\u0561\u057E\u0565\u0580 \u057F\u0578\u0572\u0565\u0580\u0568\u0589 \u053F\u0565\u057F\u0565\u0580\u056B, \u0561\u057A\u0580\u0561\u0576\u0584\u0576\u0565\u0580\u056B \u0587 \u0571\u0587\u0561\u0576\u0574\u0578\u0582\u0577\u0576\u0565\u0580\u056B \u056F\u0578\u0564\u0565\u0580\u0568 \u057D\u057F\u0578\u0582\u0563\u0578\u0582\u0574 \u0567 \u057D\u0565\u0580\u057E\u0565\u0580\u0568\u0589",
        ka: "CSV \u10D3\u10D0 XLSX \u10D1\u10E0\u10D0\u10E3\u10D6\u10D4\u10E0\u10E8\u10D8 \u10D8\u10D9\u10D8\u10D7\u10EE\u10D4\u10D1\u10D0; \u10E7\u10DD\u10D5\u10D4\u10DA\u10D8 \u10E1\u10E2\u10E0\u10D8\u10E5\u10DD\u10DC\u10D8 \u10E4\u10DD\u10E0\u10DB\u10D8\u10D7 \u10DB\u10DD\u10EC\u10DB\u10D3\u10D4\u10D1\u10D0 \u10D3\u10D0 \u10DB\u10EE\u10DD\u10DA\u10DD\u10D3 \u10E1\u10EC\u10DD\u10E0\u10D8 \u10D8\u10D2\u10D6\u10D0\u10D5\u10DC\u10D4\u10D1\u10D0. \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1, \u10DE\u10E0\u10DD\u10D3\u10E3\u10E5\u10E2\u10D4\u10D1\u10D8\u10E1\u10D0 \u10D3\u10D0 \u10E8\u10D0\u10D1\u10DA\u10DD\u10DC\u10D4\u10D1\u10D8\u10E1 \u10D9\u10DD\u10D3\u10D4\u10D1\u10E1 \u10E1\u10D4\u10E0\u10D5\u10D4\u10E0\u10D8 \u10D0\u10DB\u10DD\u10EC\u10DB\u10D4\u10D1\u10E1."
    },
    import_b3: {
        uk: "\u041E\u0431\u0440\u043E\u0431\u043A\u0430 \u0430\u0441\u0438\u043D\u0445\u0440\u043E\u043D\u043D\u0430: \u043F\u0456\u0441\u043B\u044F \u043D\u0430\u0434\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u0432\u0438 \u043F\u043E\u0442\u0440\u0430\u043F\u043B\u044F\u0454\u0442\u0435 \u043D\u0430 \xab\u041C\u043E\u0457 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F\xbb, \u0434\u0435 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0430 \u043E\u043D\u043E\u0432\u043B\u044E\u0454\u0442\u044C\u0441\u044F, \u043F\u043E\u043A\u0438 \u043F\u0430\u043A\u0435\u0442 \u043E\u0431\u0440\u043E\u0431\u043B\u044F\u0454\u0442\u044C\u0441\u044F, \u0430 \u043F\u043E\u0442\u0456\u043C \u043F\u043E\u043A\u0430\u0437\u0443\u0454 \u0439\u043E\u0433\u043E \u0436\u0443\u0440\u043D\u0430\u043B.",
        en: "Processing is asynchronous: after submitting you land on My uploads, which refreshes while the batch is pending and then shows its logs.",
        hy: "\u0544\u0577\u0561\u056F\u0578\u0582\u0574\u0568 \u0561\u057D\u056B\u0576\u056D\u0580\u0578\u0576 \u0567. \u0578\u0582\u0572\u0561\u0580\u056F\u0565\u056C\u0578\u0582\u0581 \u0570\u0565\u057F\u0578 \u0570\u0561\u0575\u057F\u0576\u057E\u0578\u0582\u0574 \u0565\u0584 \xab\u053B\u0574 \u0562\u0565\u057C\u0576\u0578\u0582\u0574\u0576\u0565\u0580\u0568\xbb \u0567\u057B\u0578\u0582\u0574, \u0578\u0580\u0568 \u0569\u0561\u0580\u0574\u0561\u0581\u057E\u0578\u0582\u0574 \u0567, \u0574\u056B\u0576\u0579 \u0583\u0561\u0569\u0565\u0569\u0568 \u057D\u057A\u0561\u057D\u0574\u0561\u0576 \u0574\u0565\u057B \u0567, \u0561\u057A\u0561 \u0581\u0578\u0582\u0575\u0581 \u0567 \u057F\u0561\u056C\u056B\u057D \u0564\u0580\u0561 \u0574\u0561\u057F\u0575\u0561\u0576\u0568\u0589",
        ka: "\u10D3\u10D0\u10DB\u10E3\u10E8\u10D0\u10D5\u10D4\u10D1\u10D0 \u10D0\u10E1\u10D8\u10DC\u10E5\u10E0\u10DD\u10DC\u10E3\u10DA\u10D8\u10D0: \u10D2\u10D0\u10D2\u10D6\u10D0\u10D5\u10DC\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D3\u10D4\u10D2 \xab\u10E9\u10D4\u10DB\u10D8 \u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D4\u10D1\u10D8\xbb \u10D2\u10D5\u10D4\u10E0\u10D3\u10D6\u10D4 \u10EE\u10D5\u10D3\u10D4\u10D1\u10D8\u10D7, \u10E0\u10DD\u10DB\u10D4\u10DA\u10D8\u10EA \u10D0\u10EE\u10DA\u10D3\u10D4\u10D1\u10D0, \u10E1\u10D0\u10DC\u10D0\u10DB \u10DE\u10D0\u10D9\u10D4\u10E2\u10D8 \u10DB\u10DD\u10DA\u10DD\u10D3\u10D8\u10DC\u10E8\u10D8\u10D0, \u10E8\u10D4\u10DB\u10D3\u10D4\u10D2 \u10D9\u10D8 \u10DB\u10D8\u10E1 \u10DF\u10E3\u10E0\u10DC\u10D0\u10DA\u10E1 \u10D0\u10E9\u10D5\u10D4\u10DC\u10D4\u10D1\u10E1."
    },
    import_b4: {
        uk: "\xab\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0434\u0430\u043D\u0456\xbb \u043F\u0440\u0438\u0431\u0438\u0440\u0430\u0454 \u0432\u0441\u0435, \u0449\u043E \u0441\u0442\u0432\u043E\u0440\u0438\u0432 \u043F\u0430\u043A\u0435\u0442. \xab\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u0448\u0430\u0431\u043B\u043E\u043D\xbb \u0434\u0430\u0454 \u043E\u0447\u0456\u043A\u0443\u0432\u0430\u043D\u0456 \u043A\u043E\u043B\u043E\u043D\u043A\u0438 \u0437 \u0440\u044F\u0434\u043A\u043E\u043C-\u043F\u0440\u0438\u043A\u043B\u0430\u0434\u043E\u043C.",
        en: "Delete data removes everything a batch created. Download template gives the expected columns with an example row.",
        hy: "\xab\u054B\u0576\u057B\u0565\u056C \u057F\u057E\u0575\u0561\u056C\u0576\u0565\u0580\u0568\xbb \u0570\u0565\u057C\u0561\u0581\u0576\u0578\u0582\u0574 \u0567 \u0583\u0561\u0569\u0565\u0569\u056B \u057D\u057F\u0565\u0572\u056E\u0561\u056E \u0561\u0574\u0565\u0576 \u056B\u0576\u0579\u0589 \xab\u0546\u0565\u0580\u0562\u0565\u057C\u0576\u0565\u056C \u0571\u0587\u0561\u0576\u0574\u0578\u0582\u0577\u0568\xbb \u057F\u0561\u056C\u056B\u057D \u0567 \u057D\u057A\u0561\u057D\u057E\u0578\u0572 \u057D\u0575\u0578\u0582\u0576\u0561\u056F\u0576\u0565\u0580\u0568 \u0585\u0580\u056B\u0576\u0561\u056F \u057F\u0578\u0572\u0578\u057E\u0589",
        ka: "\xab\u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8\u10E1 \u10EC\u10D0\u10E8\u10DA\u10D0\xbb \u10E8\u10DA\u10D8\u10E1 \u10E7\u10D5\u10D4\u10DA\u10D0\u10E4\u10D4\u10E0\u10E1, \u10E0\u10D0\u10EA \u10DE\u10D0\u10D9\u10D4\u10E2\u10DB\u10D0 \u10E8\u10D4\u10E5\u10DB\u10DC\u10D0. \xab\u10E8\u10D0\u10D1\u10DA\u10DD\u10DC\u10D8\u10E1 \u10E9\u10D0\u10DB\u10DD\u10E2\u10D5\u10D8\u10E0\u10D7\u10D5\u10D0\xbb \u10DB\u10DD\u10E1\u10D0\u10DA\u10DD\u10D3\u10DC\u10D4\u10DA \u10E1\u10D5\u10D4\u10E2\u10D4\u10D1\u10E1 \u10DB\u10D0\u10D2\u10D0\u10DA\u10D8\u10D7\u10D8\u10E1 \u10E1\u10E2\u10E0\u10D8\u10E5\u10DD\u10DC\u10D8\u10D7 \u10D8\u10EB\u10DA\u10D4\u10D5\u10D0."
    },
    merchandisers_desc: {
        uk: "\u0412\u0430\u0448\u0430 \u043A\u043E\u043C\u0430\u043D\u0434\u0430: \u0445\u0442\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0438\u0439, \u0445\u0442\u043E \u043D\u043E\u0432\u0430\u0447\u043E\u043A, \u0443 \u043A\u043E\u0433\u043E \u043D\u0435\u043C\u0430\u0454 \u0442\u043E\u0447\u043E\u043A, \u0430 \u0442\u0430\u043A\u043E\u0436 \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u0438, \u0442\u043E\u0447\u043A\u0438, \u0432\u0456\u0437\u0438\u0442\u0438 \u0439 \u0432\u0456\u0434\u0441\u0443\u0442\u043D\u043E\u0441\u0442\u0456 \u043A\u043E\u0436\u043D\u043E\u0433\u043E.",
        en: "Your team: who is available, who is new, who has no points to visit, and each person's routes, points, visits and absences.",
        hy: "\u0541\u0565\u0580 \u0569\u056B\u0574\u0568\u055D \u0578\u057E \u0567 \u0570\u0561\u057D\u0561\u0576\u0565\u056C\u056B, \u0578\u057E \u0567 \u0576\u0578\u0580\u0565\u056F, \u0578\u057E \u056F\u0565\u057F\u0565\u0580 \u0579\u0578\u0582\u0576\u056B, \u056B\u0576\u0579\u057A\u0565\u057D \u0576\u0561\u0587 \u0575\u0578\u0582\u0580\u0561\u0584\u0561\u0576\u0579\u0575\u0578\u0582\u0580\u056B \u0565\u0580\u0569\u0578\u0582\u0572\u056B\u0576\u0565\u0580\u0568, \u056F\u0565\u057F\u0565\u0580\u0568, \u0561\u0575\u0581\u0565\u0580\u0568 \u0587 \u0562\u0561\u0581\u0561\u056F\u0561\u0575\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580\u0568\u0589",
        ka: "\u10D7\u10E5\u10D5\u10D4\u10DC\u10D8 \u10D2\u10E3\u10DC\u10D3\u10D8: \u10D5\u10D8\u10DC \u10D0\u10E0\u10D8\u10E1 \u10EE\u10D4\u10DA\u10DB\u10D8\u10E1\u10D0\u10EC\u10D5\u10D3\u10DD\u10DB\u10D8, \u10D5\u10D8\u10DC \u10D0\u10E0\u10D8\u10E1 \u10D0\u10EE\u10D0\u10DA\u10D8, \u10D5\u10D8\u10E1 \u10D0\u10E0 \u10D0\u10E5\u10D5\u10E1 \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8, \u10D3\u10D0 \u10D7\u10D8\u10D7\u10DD\u10D4\u10E3\u10DA\u10D8\u10E1 \u10DB\u10D0\u10E0\u10E8\u10E0\u10E3\u10E2\u10D4\u10D1\u10D8, \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8, \u10D5\u10D8\u10D6\u10D8\u10E2\u10D4\u10D1\u10D8 \u10D3\u10D0 \u10D2\u10D0\u10EA\u10D3\u10D4\u10DC\u10D4\u10D1\u10D8."
    },
    merchandisers_b1: {
        uk: "\u041C\u0456\u0442\u043A\u0438 \xab\u0412\u0456\u0434\u0441\u0443\u0442\u043D\u0456 \u0441\u044C\u043E\u0433\u043E\u0434\u043D\u0456\xbb, \xab\u041D\u043E\u0432\u0430\u0447\u043A\u0438\xbb \u0439 \xab\u0411\u0435\u0437 \u0442\u043E\u0447\u043E\u043A\xbb; \u043F\u0435\u0440\u0435\u043C\u0438\u043A\u0430\u0447 \u0440\u043E\u0437\u0434\u0456\u043B\u044F\u0454 \u0430\u043A\u0442\u0438\u0432\u043D\u0438\u0445 \u0456 \u043D\u0435\u0430\u043A\u0442\u0438\u0432\u043D\u0438\u0445.",
        en: "Chips for Absent today, Newbie and No points; the segment splits active and inactive.",
        hy: "\xab\u0531\u0575\u057D\u0585\u0580 \u0562\u0561\u0581\u0561\u056F\u0561\xbb, \xab\u0546\u0578\u0580\u0565\u056F\xbb \u0587 \xab\u053F\u0565\u057F\u0565\u0580 \u0579\u056F\u0561\u0576\xbb \u057A\u056B\u057F\u0561\u056F\u0576\u0565\u0580. \u0583\u0578\u056D\u0561\u0580\u056F\u056B\u0579\u0568 \u0562\u0561\u056A\u0561\u0576\u0578\u0582\u0574 \u0567 \u0561\u056F\u057F\u056B\u057E \u0587 \u0578\u0579 \u0561\u056F\u057F\u056B\u057E\u0589",
        ka: "\u10E9\u10D8\u10DE\u10D4\u10D1\u10D8 \xab\u10D3\u10E6\u10D4\u10E1 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1\xbb, \xab\u10D0\u10EE\u10D0\u10DA\u10D1\u10D4\u10D3\u10D0\xbb \u10D3\u10D0 \xab\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10E0\u10D4\u10E8\u10D4\xbb; \u10D2\u10D0\u10D3\u10D0\u10DB\u10E0\u10D7\u10D5\u10D4\u10DA\u10D8 \u10E7\u10DD\u10E4\u10E1 \u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D4\u10D1\u10E1\u10D0 \u10D3\u10D0 \u10D0\u10E0\u10D0\u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D4\u10D1\u10E1."
    },
    merchandisers_b2: {
        uk: "\u0423 \u043F\u0440\u043E\u0444\u0456\u043B\u0456 \u0447\u043E\u0442\u0438\u0440\u0438 \u0432\u043A\u043B\u0430\u0434\u043A\u0438, \u0449\u043E \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0443\u044E\u0442\u044C\u0441\u044F \u043F\u043E \u043E\u0434\u043D\u0456\u0439: \xab\u041C\u0430\u0440\u0448\u0440\u0443\u0442\u0438\xbb, \xab\u0417\u0430\u043A\u0440\u0456\u043F\u043B\u0435\u043D\u043D\u044F\xbb (\u0442\u043E\u0447\u043A\u0438), \xab\u0412\u0456\u0437\u0438\u0442\u0438\xbb \u0439 \xab\u041F\u0440\u0438\u0441\u0443\u0442\u043D\u0456\u0441\u0442\u044C\xbb (\u0432\u0456\u0434\u0441\u0443\u0442\u043D\u043E\u0441\u0442\u0456).",
        en: "The profile has four tabs, loaded one at a time: Routes, Assignment (points), Visits and Presence (absences).",
        hy: "\u054A\u0580\u0578\u0586\u056B\u056C\u0576 \u0578\u0582\u0576\u056B \u0579\u0578\u0580\u057D \u0576\u0565\u0580\u0564\u056B\u0580, \u0578\u0580\u0578\u0576\u0584 \u0562\u0565\u057C\u0576\u057E\u0578\u0582\u0574 \u0565\u0576 \u0574\u0565\u056F-\u0574\u0565\u056F\u055D \u0535\u0580\u0569\u0578\u0582\u0572\u056B\u0576\u0565\u0580, \u0531\u0574\u0580\u0561\u0563\u0580\u0578\u0582\u0574 (\u056F\u0565\u057F\u0565\u0580), \u0531\u0575\u0581\u0565\u0580 \u0587 \u0546\u0565\u0580\u056F\u0561\u0575\u0578\u0582\u0569\u0575\u0578\u0582\u0576 (\u0562\u0561\u0581\u0561\u056F\u0561\u0575\u0578\u0582\u0569\u0575\u0578\u0582\u0576\u0576\u0565\u0580)\u0589",
        ka: "\u10DE\u10E0\u10DD\u10E4\u10D8\u10DA\u10E1 \u10DD\u10D7\u10EE\u10D8 \u10E9\u10D0\u10DC\u10D0\u10E0\u10D7\u10D8 \u10D0\u10E5\u10D5\u10E1, \u10E1\u10D0\u10D7\u10D8\u10D7\u10D0\u10DD\u10D3 \u10E9\u10D0\u10E2\u10D5\u10D8\u10E0\u10D7\u10E3\u10DA\u10D8: \u10DB\u10D0\u10E0\u10E8\u10E0\u10E3\u10E2\u10D4\u10D1\u10D8, \u10DB\u10D8\u10DB\u10D0\u10D2\u10E0\u10D4\u10D1\u10D0 (\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8), \u10D5\u10D8\u10D6\u10D8\u10E2\u10D4\u10D1\u10D8 \u10D3\u10D0 \u10D3\u10D0\u10E1\u10EC\u10E0\u10D4\u10D1\u10D0 (\u10D2\u10D0\u10EA\u10D3\u10D4\u10DC\u10D4\u10D1\u10D8)."
    },
    merchandisers_b3: {
        uk: "\u041C\u0430\u0440\u0448\u0440\u0443\u0442\u0438 \u2014 \u0442\u0440\u0438 \u0448\u0430\u0440\u0438 \u043D\u0430 \u043A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u0456: \u0442\u0438\u0436\u043D\u0435\u0432\u0430 \u043E\u0441\u043D\u043E\u0432\u0430, \u0434\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0456 \u0442\u043E\u0447\u043A\u0438 \u0432 N-\u0439 \u0434\u0435\u043D\u044C \u0442\u0438\u0436\u043D\u044F \u043C\u0456\u0441\u044F\u0446\u044F \u0442\u0430 \u0440\u0430\u0437\u043E\u0432\u0456 \u0442\u043E\u0447\u043A\u0438 \u043D\u0430 \u043A\u043E\u043D\u043A\u0440\u0435\u0442\u043D\u0443 \u0434\u0430\u0442\u0443.",
        en: "Routes are three layers on a calendar: a weekly base, extras on the Nth weekday of a month, and one-off stops on a single date.",
        hy: "\u0535\u0580\u0569\u0578\u0582\u0572\u056B\u0576\u0565\u0580\u0568 \u0585\u0580\u0561\u0581\u0578\u0582\u0575\u0581\u056B \u0565\u0580\u0565\u0584 \u0577\u0565\u0580\u057F \u0565\u0576\u055D \u0577\u0561\u0562\u0561\u0569\u0561\u056F\u0561\u0576 \u0570\u056B\u0574\u0584, \u0570\u0561\u057E\u0565\u056C\u0575\u0561\u056C \u056F\u0565\u057F\u0565\u0580 \u0561\u0574\u057D\u057E\u0561 N-\u0580\u0564 \u0577\u0561\u0562\u0561\u0569\u057E\u0561 \u0585\u0580\u0568 \u0587 \u0574\u056B\u0561\u0576\u0563\u0561\u0574\u0575\u0561 \u056F\u0565\u057F\u0565\u0580 \u056F\u0578\u0576\u056F\u0580\u0565\u057F \u0561\u0574\u057D\u0561\u0569\u057E\u056B\u0589",
        ka: "\u10DB\u10D0\u10E0\u10E8\u10E0\u10E3\u10E2\u10D4\u10D1\u10D8 \u10D9\u10D0\u10DA\u10D4\u10DC\u10D3\u10D0\u10E0\u10D6\u10D4 \u10E1\u10D0\u10DB\u10D8 \u10E4\u10D4\u10DC\u10D0\u10D0: \u10D9\u10D5\u10D8\u10E0\u10D4\u10E3\u10DA\u10D8 \u10E1\u10D0\u10E4\u10E3\u10EB\u10D5\u10D4\u10DA\u10D8, \u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D8\u10D7\u10D8 \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8 \u10D7\u10D5\u10D8\u10E1 N-\u10D4 \u10D9\u10D5\u10D8\u10E0\u10D8\u10E1 \u10D3\u10E6\u10D4\u10E1 \u10D3\u10D0 \u10D4\u10E0\u10D7\u10EF\u10D4\u10E0\u10D0\u10D3\u10D8 \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8 \u10D9\u10DD\u10DC\u10D9\u10E0\u10D4\u10E2\u10E3\u10DA \u10D7\u10D0\u10E0\u10D8\u10E6\u10D6\u10D4."
    },
    merchandisers_b4: {
        uk: "\u0414\u043E\u0434\u0430\u0439\u0442\u0435 \u0432\u0456\u0434\u0441\u0443\u0442\u043D\u0456\u0441\u0442\u044C \u0456\u0437 \u043F\u0440\u0438\u0447\u0438\u043D\u043E\u044E, \u0440\u0435\u0434\u0430\u0433\u0443\u0439\u0442\u0435 \u043F\u0440\u043E\u0444\u0456\u043B\u044C, \u0434\u0435\u0430\u043A\u0442\u0438\u0432\u0443\u0439\u0442\u0435 \u0447\u0438 \u0430\u043A\u0442\u0438\u0432\u0443\u0439\u0442\u0435. \xab\u041D\u043E\u0432\u0438\u0439 \u043C\u0435\u0440\u0447\u0430\u043D\u0434\u0430\u0439\u0437\u0435\u0440\xbb \u0441\u0442\u0432\u043E\u0440\u044E\u0454 \u043E\u0431\u043B\u0456\u043A\u043E\u0432\u0438\u0439 \u0437\u0430\u043F\u0438\u0441.",
        en: "Add an absence with a reason, edit the profile, deactivate or activate. New merchandiser creates an account.",
        hy: "\u0531\u057E\u0565\u056C\u0561\u0581\u0580\u0565\u0584 \u0562\u0561\u0581\u0561\u056F\u0561\u0575\u0578\u0582\u0569\u0575\u0578\u0582\u0576 \u057A\u0561\u057F\u0573\u0561\u057C\u0578\u057E, \u056D\u0574\u0562\u0561\u0563\u0580\u0565\u0584 \u057A\u0580\u0578\u0586\u056B\u056C\u0568, \u0561\u057A\u0561\u0561\u056F\u057F\u056B\u057E\u0561\u0581\u0580\u0565\u0584 \u056F\u0561\u0574 \u0561\u056F\u057F\u056B\u057E\u0561\u0581\u0580\u0565\u0584\u0589 \xab\u0546\u0578\u0580 \u0574\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580\xbb-\u0568 \u0570\u0561\u0577\u056B\u057E \u0567 \u057D\u057F\u0565\u0572\u056E\u0578\u0582\u0574\u0589",
        ka: "\u10D3\u10D0\u10D0\u10DB\u10D0\u10E2\u10D4\u10D7 \u10D2\u10D0\u10EA\u10D3\u10D4\u10DC\u10D0 \u10DB\u10D8\u10D6\u10D4\u10D6\u10D8\u10D7, \u10D3\u10D0\u10D0\u10E0\u10D4\u10D3\u10D0\u10E5\u10E2\u10D8\u10E0\u10D4\u10D7 \u10DE\u10E0\u10DD\u10E4\u10D8\u10DA\u10D8, \u10D3\u10D4\u10D0\u10E5\u10E2\u10D8\u10D5\u10D8\u10E0\u10D4\u10D7 \u10D0\u10DC \u10D2\u10D0\u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D4\u10D7. \xab\u10D0\u10EE\u10D0\u10DA\u10D8 \u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D8\xbb \u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10E1 \u10E5\u10DB\u10DC\u10D8\u10E1."
    },
    supervisors_desc: {
        uk: "\u0425\u0442\u043E \u0437\u0430 \u0449\u043E \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0430\u0454: \u0440\u0435\u0433\u0456\u043E\u043D, \u0442\u043E\u0447\u043A\u0438 \u0439 \u043A\u043E\u043C\u0430\u043D\u0434\u0430 \u043A\u043E\u0436\u043D\u043E\u0433\u043E \u0441\u0443\u043F\u0435\u0440\u0432\u0430\u0439\u0437\u0435\u0440\u0430.",
        en: "Who covers what: each supervisor's county, points and team.",
        hy: "\u0548\u057E \u056B\u0576\u0579\u056B \u0570\u0561\u0574\u0561\u0580 \u0567 \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0561\u057F\u0578\u0582\u055D \u0575\u0578\u0582\u0580\u0561\u0584\u0561\u0576\u0579\u0575\u0578\u0582\u0580 \u057D\u0578\u0582\u057A\u0565\u0580\u057E\u0561\u0575\u0566\u0565\u0580\u056B \u0574\u0561\u0580\u0566\u0568, \u056F\u0565\u057F\u0565\u0580\u0568 \u0587 \u0569\u056B\u0574\u0568\u0589",
        ka: "\u10D5\u10D8\u10DC \u10E0\u10D0\u10D6\u10D4\u10D0 \u10DE\u10D0\u10E1\u10E3\u10EE\u10D8\u10E1\u10DB\u10D2\u10D4\u10D1\u10D4\u10DA\u10D8: \u10D7\u10D8\u10D7\u10DD\u10D4\u10E3\u10DA\u10D8 \u10E1\u10E3\u10DE\u10D4\u10E0\u10D5\u10D0\u10D8\u10D6\u10D4\u10E0\u10D8\u10E1 \u10E0\u10D4\u10D2\u10D8\u10DD\u10DC\u10D8, \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8 \u10D3\u10D0 \u10D2\u10E3\u10DC\u10D3\u10D8."
    },
    supervisors_b1: {
        uk: "\u0424\u0456\u043B\u044C\u0442\u0440\u0443\u0439\u0442\u0435 \u0437\u0430 \u0440\u0435\u0433\u0456\u043E\u043D\u043E\u043C; \u043C\u0456\u0442\u043A\u0430 \xab\u0411\u0435\u0437 \u0442\u043E\u0447\u043E\u043A\xbb \u0437\u043D\u0430\u0445\u043E\u0434\u0438\u0442\u044C \u0441\u0443\u043F\u0435\u0440\u0432\u0430\u0439\u0437\u0435\u0440\u0456\u0432, \u044F\u043A\u0456 \u043D\u0456 \u0437\u0430 \u0449\u043E \u043D\u0435 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0430\u044E\u0442\u044C.",
        en: "Filter by county; the No points chip finds supervisors responsible for nothing.",
        hy: "\u0536\u057F\u0565\u0584 \u0568\u057D\u057F \u0574\u0561\u0580\u0566\u056B. \xab\u053F\u0565\u057F\u0565\u0580 \u0579\u056F\u0561\u0576\xbb \u057A\u056B\u057F\u0561\u056F\u0568 \u0563\u057F\u0576\u0578\u0582\u0574 \u0567 \u0578\u0579\u0576\u0579\u056B \u0570\u0561\u0574\u0561\u0580 \u057A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0561\u057F\u0578\u0582 \u0579\u0570\u0561\u0576\u0564\u056B\u057D\u0561\u0581\u0578\u0572 \u057D\u0578\u0582\u057A\u0565\u0580\u057E\u0561\u0575\u0566\u0565\u0580\u0576\u0565\u0580\u056B\u0576\u0589",
        ka: "\u10D2\u10D0\u10E4\u10D8\u10DA\u10E2\u10E0\u10D4\u10D7 \u10E0\u10D4\u10D2\u10D8\u10DD\u10DC\u10D8\u10D7; \xab\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10E0\u10D4\u10E8\u10D4\xbb \u10E9\u10D8\u10DE\u10D8 \u10DE\u10DD\u10E3\u10DA\u10DD\u10D1\u10E1 \u10E1\u10E3\u10DE\u10D4\u10E0\u10D5\u10D0\u10D8\u10D6\u10D4\u10E0\u10D4\u10D1\u10E1, \u10E0\u10DD\u10DB\u10DA\u10D4\u10D1\u10D8\u10EA \u10D0\u10E0\u10D0\u10E4\u10D4\u10E0\u10D6\u10D4 \u10D0\u10E0\u10D8\u10D0\u10DC \u10DE\u10D0\u10E1\u10E3\u10EE\u10D8\u10E1\u10DB\u10D2\u10D4\u10D1\u10D4\u10DA\u10D8."
    },
    supervisors_b2: {
        uk: "\u0423 \u043F\u0440\u043E\u0444\u0456\u043B\u0456 \u0432\u043A\u043B\u0430\u0434\u043A\u0438 \xab\u0422\u043E\u0447\u043A\u0438\xbb \u0439 \xab\u041A\u043E\u043C\u0430\u043D\u0434\u0430\xbb \u0434\u043E\u0434\u0430\u044E\u0442\u044C \u0430\u0431\u043E \u043F\u0440\u0438\u0431\u0438\u0440\u0430\u044E\u0442\u044C \u0442\u043E\u0447\u043A\u0438 \u0439 \u043C\u0435\u0440\u0447\u0430\u043D\u0434\u0430\u0439\u0437\u0435\u0440\u0456\u0432. \u0414\u043E\u0434\u0430\u0432\u0430\u043D\u043D\u044F \u043D\u0456\u043A\u043E\u043B\u0438 \u043D\u0435 \u0437\u0430\u043C\u0456\u043D\u044E\u0454 \u0432\u0436\u0435 \u0437\u0430\u043A\u0440\u0456\u043F\u043B\u0435\u043D\u0435.",
        en: "On the profile, the Points and Team tabs add or remove points and merchandisers. Adding never replaces what is already assigned.",
        hy: "\u054A\u0580\u0578\u0586\u056B\u056C\u0578\u0582\u0574 \xab\u053F\u0565\u057F\u0565\u0580\xbb \u0587 \xab\u0539\u056B\u0574\xbb \u0576\u0565\u0580\u0564\u056B\u0580\u0576\u0565\u0580\u0568 \u0561\u057E\u0565\u056C\u0561\u0581\u0576\u0578\u0582\u0574 \u056F\u0561\u0574 \u0570\u0565\u057C\u0561\u0581\u0576\u0578\u0582\u0574 \u0565\u0576 \u056F\u0565\u057F\u0565\u0580 \u0587 \u0574\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580\u0576\u0565\u0580\u0589 \u0531\u057E\u0565\u056C\u0561\u0581\u0578\u0582\u0574\u0568 \u0565\u0580\u0562\u0565\u0584 \u0579\u056B \u0583\u0578\u056D\u0561\u0580\u056B\u0576\u0578\u0582\u0574 \u0561\u0580\u0564\u0565\u0576 \u0561\u0574\u0580\u0561\u0563\u0580\u057E\u0561\u056E\u0568\u0589",
        ka: "\u10DE\u10E0\u10DD\u10E4\u10D8\u10DA\u10E8\u10D8 \xab\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8\xbb \u10D3\u10D0 \xab\u10D2\u10E3\u10DC\u10D3\u10D8\xbb \u10E9\u10D0\u10DC\u10D0\u10E0\u10D7\u10D4\u10D1\u10D8 \u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10E1 \u10D0\u10DC \u10E8\u10DA\u10D8\u10E1 \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10E1\u10D0 \u10D3\u10D0 \u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D4\u10D1\u10E1. \u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D0 \u10D0\u10E0\u10D0\u10E1\u10D3\u10E0\u10DD\u10E1 \u10EA\u10D5\u10DA\u10D8\u10E1 \u10E3\u10D9\u10D5\u10D4 \u10DB\u10D8\u10DB\u10D0\u10D2\u10E0\u10D4\u10D1\u10E3\u10DA\u10E1."
    },
    supervisors_b3: {
        uk: "\u0414\u0435\u0430\u043A\u0442\u0438\u0432\u0443\u0439\u0442\u0435 \u0447\u0438 \u0430\u043A\u0442\u0438\u0432\u0443\u0439\u0442\u0435 \u0441\u0443\u043F\u0435\u0440\u0432\u0430\u0439\u0437\u0435\u0440\u0430 \u0437\u0456 \u0441\u043F\u0438\u0441\u043A\u0443 \u0430\u0431\u043E \u043F\u0440\u043E\u0444\u0456\u043B\u044E. \u041E\u0431\u043B\u0456\u043A\u043E\u0432\u0456 \u0437\u0430\u043F\u0438\u0441\u0438 \u0442\u0443\u0442 \u043D\u0435 \u0441\u0442\u0432\u043E\u0440\u044E\u044E\u0442\u044C\u0441\u044F.",
        en: "Deactivate or activate a supervisor from the list or the profile. Accounts are not created here.",
        hy: "\u0531\u057A\u0561\u0561\u056F\u057F\u056B\u057E\u0561\u0581\u0580\u0565\u0584 \u056F\u0561\u0574 \u0561\u056F\u057F\u056B\u057E\u0561\u0581\u0580\u0565\u0584 \u057D\u0578\u0582\u057A\u0565\u0580\u057E\u0561\u0575\u0566\u0565\u0580\u056B\u0576 \u0581\u0578\u0582\u0581\u0561\u056F\u056B\u0581 \u056F\u0561\u0574 \u057A\u0580\u0578\u0586\u056B\u056C\u056B\u0581\u0589 \u0540\u0561\u0577\u056B\u057E\u0576\u0565\u0580 \u0561\u0575\u057D\u057F\u0565\u0572 \u0579\u0565\u0576 \u057D\u057F\u0565\u0572\u056E\u057E\u0578\u0582\u0574\u0589",
        ka: "\u10D3\u10D4\u10D0\u10E5\u10E2\u10D8\u10D5\u10D8\u10E0\u10D4\u10D7 \u10D0\u10DC \u10D2\u10D0\u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10D4\u10D7 \u10E1\u10E3\u10DE\u10D4\u10E0\u10D5\u10D0\u10D8\u10D6\u10D4\u10E0\u10D8 \u10E1\u10D8\u10D8\u10D3\u10D0\u10DC \u10D0\u10DC \u10DE\u10E0\u10DD\u10E4\u10D8\u10DA\u10D8\u10D3\u10D0\u10DC. \u10D0\u10DC\u10D2\u10D0\u10E0\u10D8\u10E8\u10D4\u10D1\u10D8 \u10D0\u10E5 \u10D0\u10E0 \u10D8\u10E5\u10DB\u10DC\u10D4\u10D1\u10D0."
    },
    documents_desc: {
        uk: "\u0421\u043F\u0456\u043B\u044C\u043D\u0456 \u0444\u0430\u0439\u043B\u0438 \u043A\u043E\u043C\u043F\u0430\u043D\u0456\u0457: \u0456\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0456\u0457, \u043F\u043B\u0430\u043D\u043E\u0433\u0440\u0430\u043C\u0438, \u043F\u0440\u0430\u0439\u0441\u0438.",
        en: "Shared files for the company: instructions, planograms, price lists.",
        hy: "\u0538\u0576\u056F\u0565\u0580\u0578\u0582\u0569\u0575\u0561\u0576 \u0568\u0576\u0564\u0570\u0561\u0576\u0578\u0582\u0580 \u0586\u0561\u0575\u056C\u0565\u0580\u055D \u0570\u0580\u0561\u0570\u0561\u0576\u0563\u0576\u0565\u0580, \u057A\u056C\u0561\u0576\u0578\u0563\u0580\u0561\u0574\u0576\u0565\u0580, \u0563\u0576\u0561\u0581\u0578\u0582\u0581\u0561\u056F\u0576\u0565\u0580\u0589",
        ka: "\u10D9\u10DD\u10DB\u10DE\u10D0\u10DC\u10D8\u10D8\u10E1 \u10E1\u10D0\u10D6\u10D8\u10D0\u10E0\u10DD \u10E4\u10D0\u10D8\u10DA\u10D4\u10D1\u10D8: \u10D8\u10DC\u10E1\u10E2\u10E0\u10E3\u10E5\u10EA\u10D8\u10D4\u10D1\u10D8, \u10DE\u10DA\u10D0\u10DC\u10DD\u10D2\u10E0\u10D0\u10DB\u10D4\u10D1\u10D8, \u10E4\u10D0\u10E1\u10D4\u10D1\u10D8\u10E1 \u10E1\u10D8\u10D4\u10D1\u10D8."
    },
    documents_b1: {
        uk: "\xab\u0414\u043E\u0434\u0430\u0442\u0438 \u0444\u0430\u0439\u043B\xbb \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0443\u0454 \u043E\u0434\u0438\u043D \u0444\u0430\u0439\u043B \u0456\u0437 \u043D\u0430\u0437\u0432\u043E\u044E; \u0448\u0443\u043A\u0430\u0439\u0442\u0435 \u0439 \u0441\u043E\u0440\u0442\u0443\u0439\u0442\u0435 \u0437\u0430 \u043D\u0430\u0437\u0432\u043E\u044E \u0430\u0431\u043E \u0434\u0430\u0442\u043E\u044E.",
        en: "Add file uploads one file with a name; search and sort by name or date.",
        hy: "\xab\u0531\u057E\u0565\u056C\u0561\u0581\u0576\u0565\u056C \u0586\u0561\u0575\u056C\xbb-\u0568 \u0562\u0565\u057C\u0576\u0578\u0582\u0574 \u0567 \u0574\u0565\u056F \u0586\u0561\u0575\u056C \u0561\u0576\u057E\u0561\u0576\u0578\u0582\u0574\u0578\u057E, \u0578\u0580\u0578\u0576\u0565\u0584 \u0587 \u0564\u0561\u057D\u0561\u057E\u0578\u0580\u0565\u0584 \u0568\u057D\u057F \u0561\u0576\u057E\u0561\u0576 \u056F\u0561\u0574 \u0561\u0574\u057D\u0561\u0569\u057E\u056B\u0589",
        ka: "\xab\u10E4\u10D0\u10D8\u10DA\u10D8\u10E1 \u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D0\xbb \u10D4\u10E0\u10D7 \u10E4\u10D0\u10D8\u10DA\u10E1 \u10E1\u10D0\u10EE\u10D4\u10DA\u10D8\u10D7 \u10E2\u10D5\u10D8\u10E0\u10D7\u10D0\u10D5\u10E1; \u10DB\u10DD\u10EB\u10D4\u10D1\u10DC\u10D4\u10D7 \u10D3\u10D0 \u10D3\u10D0\u10D0\u10DA\u10D0\u10D2\u10D4\u10D7 \u10E1\u10D0\u10EE\u10D4\u10DA\u10D8\u10D7 \u10D0\u10DC \u10D7\u10D0\u10E0\u10D8\u10E6\u10D8\u10D7."
    },
    documents_b2: {
        uk: "\u041A\u043D\u043E\u043F\u043A\u0430 \u0432\u0456\u0434\u043A\u0440\u0438\u0442\u0442\u044F \u0432 \u0440\u044F\u0434\u043A\u0443 \u0432\u0456\u0434\u043A\u0440\u0438\u0432\u0430\u0454 \u0444\u0430\u0439\u043B \u0443 \u043D\u043E\u0432\u0456\u0439 \u0432\u043A\u043B\u0430\u0434\u0446\u0456; \u0441\u0430\u043C \u0440\u044F\u0434\u043E\u043A \u043D\u0435 \u0454 \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F\u043C.",
        en: "The open button on a row opens the file in a new tab; the row itself is not a link.",
        hy: "\u054F\u0578\u0572\u056B \u0562\u0561\u0581\u0565\u056C\u0578\u0582 \u056F\u0578\u0573\u0561\u056F\u0568 \u0562\u0561\u0581\u0578\u0582\u0574 \u0567 \u0586\u0561\u0575\u056C\u0568 \u0576\u0578\u0580 \u0576\u0565\u0580\u0564\u056B\u0580\u0578\u0582\u0574, \u057F\u0578\u0572\u0576 \u056B\u0576\u0584\u0568 \u0570\u0572\u0578\u0582\u0574 \u0579\u0567\u0589",
        ka: "\u10E1\u10E2\u10E0\u10D8\u10E5\u10DD\u10DC\u10D8\u10E1 \u10D2\u10D0\u10EE\u10E1\u10DC\u10D8\u10E1 \u10E6\u10D8\u10DA\u10D0\u10D9\u10D8 \u10E4\u10D0\u10D8\u10DA\u10E1 \u10D0\u10EE\u10D0\u10DA \u10E9\u10D0\u10DC\u10D0\u10E0\u10D7\u10E8\u10D8 \u10EE\u10E1\u10DC\u10D8\u10E1; \u10D7\u10D0\u10D5\u10D0\u10D3 \u10E1\u10E2\u10E0\u10D8\u10E5\u10DD\u10DC\u10D8 \u10D1\u10DB\u10E3\u10DA\u10D8 \u10D0\u10E0 \u10D0\u10E0\u10D8\u10E1."
    },
    documents_b3: {
        uk: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438 \u0442\u0430\u043A\u043E\u0436 \u0437\u02BC\u044F\u0432\u043B\u044F\u044E\u0442\u044C\u0441\u044F \u0432 \u0433\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u043E\u043C\u0443 \u043F\u043E\u0448\u0443\u043A\u0443.",
        en: "Documents also appear in global search.",
        hy: "\u0553\u0561\u057D\u057F\u0561\u0569\u0572\u0569\u0565\u0580\u0568 \u0570\u0561\u0575\u057F\u0576\u057E\u0578\u0582\u0574 \u0565\u0576 \u0576\u0561\u0587 \u0568\u0576\u0564\u0570\u0561\u0576\u0578\u0582\u0580 \u0578\u0580\u0578\u0576\u0574\u0561\u0576 \u0574\u0565\u057B\u0589",
        ka: "\u10D3\u10DD\u10D9\u10E3\u10DB\u10D4\u10DC\u10E2\u10D4\u10D1\u10D8 \u10D2\u10DA\u10DD\u10D1\u10D0\u10DA\u10E3\u10E0 \u10EB\u10D8\u10D4\u10D1\u10D0\u10E8\u10D8\u10EA \u10E9\u10D0\u10DC\u10E1."
    },
    surveys_desc: {
        uk: "\u0410\u043D\u043A\u0435\u0442\u0438, \u044F\u043A\u0456 \u043C\u0435\u0440\u0447\u0430\u043D\u0434\u0430\u0439\u0437\u0435\u0440\u0438 \u0437\u0430\u043F\u043E\u0432\u043D\u044E\u044E\u0442\u044C \u0443 \u0442\u043E\u0447\u043A\u0430\u0445 \u043F\u0456\u0434 \u0447\u0430\u0441 \u0432\u0456\u0437\u0438\u0442\u0443: \u0449\u043E \u0437\u0430\u043F\u0438\u0442\u0443\u0432\u0430\u0442\u0438, \u0443 \u043A\u043E\u0433\u043E \u0456 \u043A\u043E\u043B\u0438.",
        en: "Questionnaires merchandisers fill in at points during a visit: what to ask, whom to ask, and when.",
        hy: "\u0540\u0561\u0580\u0581\u0561\u0569\u0565\u0580\u0569\u056B\u056F\u0576\u0565\u0580, \u0578\u0580\u0578\u0576\u0584 \u0574\u0565\u0580\u0579\u0565\u0576\u0564\u0561\u0575\u0566\u0565\u0580\u0576\u0565\u0580\u0568 \u056C\u0580\u0561\u0581\u0576\u0578\u0582\u0574 \u0565\u0576 \u056F\u0565\u057F\u0565\u0580\u0578\u0582\u0574 \u0561\u0575\u0581\u056B \u0568\u0576\u0569\u0561\u0581\u0584\u0578\u0582\u0574\u055D \u056B\u0576\u0579 \u0570\u0561\u0580\u0581\u0576\u0565\u056C, \u0578\u0582\u0574 \u0587 \u0565\u0580\u0562\u0589",
        ka: "\u10D9\u10D8\u10D7\u10EE\u10D5\u10D0\u10E0\u10D4\u10D1\u10D8, \u10E0\u10DD\u10DB\u10DA\u10D4\u10D1\u10E1\u10D0\u10EA \u10DB\u10D4\u10E0\u10E9\u10D4\u10DC\u10D3\u10D0\u10D8\u10D6\u10D4\u10E0\u10D4\u10D1\u10D8 \u10D5\u10D8\u10D6\u10D8\u10E2\u10D8\u10E1 \u10D3\u10E0\u10DD\u10E1 \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D6\u10D4 \u10D0\u10D5\u10E1\u10D4\u10D1\u10D4\u10DC: \u10E0\u10D0 \u10D5\u10D9\u10D8\u10D7\u10EE\u10DD\u10D7, \u10D5\u10D8\u10E1 \u10D3\u10D0 \u10E0\u10DD\u10D3\u10D8\u10E1."
    },
    surveys_b1: {
        uk: "\u041E\u043F\u0438\u0442\u0443\u0432\u0430\u043D\u043D\u044F \u043C\u0430\u0454 \u043D\u0430\u0437\u0432\u0443, \u043F\u0435\u0440\u0456\u043E\u0434 \u0434\u0456\u0457 \u0442\u0430 \u0430\u0443\u0434\u0438\u0442\u043E\u0440\u0456\u044E: \u0442\u043E\u0447\u043A\u0438, \u0433\u0440\u0443\u043F\u0438 \u0442\u043E\u0447\u043E\u043A \u0430\u0431\u043E \u043C\u0435\u0440\u0435\u0436\u0456.",
        en: "A survey has a title, an active period and an audience: points, point groups or networks.",
        hy: "\u0540\u0561\u0580\u0581\u0578\u0582\u0574\u0576 \u0578\u0582\u0576\u056B \u057E\u0565\u0580\u0576\u0561\u0563\u056B\u0580, \u0563\u0578\u0580\u056E\u0578\u0572\u0578\u0582\u0569\u0575\u0561\u0576 \u056A\u0561\u0574\u0561\u0576\u0561\u056F\u0561\u0570\u0561\u057F\u057E\u0561\u056E \u0587 \u056C\u057D\u0561\u0580\u0561\u0576\u055D \u056F\u0565\u057F\u0565\u0580, \u056F\u0565\u057F\u0565\u0580\u056B \u056D\u0574\u0562\u0565\u0580 \u056F\u0561\u0574 \u0581\u0561\u0576\u0581\u0565\u0580\u0589",
        ka: "\u10D2\u10D0\u10DB\u10DD\u10D9\u10D8\u10D7\u10EE\u10D5\u10D0\u10E1 \u10D0\u10E5\u10D5\u10E1 \u10E1\u10D0\u10D7\u10D0\u10E3\u10E0\u10D8, \u10DB\u10DD\u10E5\u10DB\u10D4\u10D3\u10D4\u10D1\u10D8\u10E1 \u10DE\u10D4\u10E0\u10D8\u10DD\u10D3\u10D8 \u10D3\u10D0 \u10D0\u10E3\u10D3\u10D8\u10E2\u10DD\u10E0\u10D8\u10D0: \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8, \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1 \u10EF\u10D2\u10E3\u10E4\u10D4\u10D1\u10D8 \u10D0\u10DC \u10E5\u10E1\u10D4\u10DA\u10D4\u10D1\u10D8."
    },
    surveys_b2: {
        uk: "\u0417\u0430\u043F\u0438\u0442\u0430\u043D\u043D\u044F \u0434\u043E\u0434\u0430\u044E\u0442\u044C\u0441\u044F \u0432 \u0440\u0435\u0434\u0430\u043A\u0442\u043E\u0440\u0456, \u043A\u043E\u0436\u043D\u0435 \u0437\u0456 \u0441\u0432\u043E\u0457\u043C \u0442\u0438\u043F\u043E\u043C, \u043E\u0431\u043E\u0432\u02BC\u044F\u0437\u043A\u043E\u0432\u0456\u0441\u0442\u044E, \u043F\u0440\u0456\u043E\u0440\u0438\u0442\u0435\u0442\u043E\u043C \u0456 \u0432\u043B\u0430\u0441\u043D\u0438\u043C \u0442\u0430\u0440\u0433\u0435\u0442\u0438\u043D\u0433\u043E\u043C.",
        en: "Questions are added in the editor, each with its type, required flag, priority and its own targeting.",
        hy: "\u0540\u0561\u0580\u0581\u0565\u0580\u0576 \u0561\u057E\u0565\u056C\u0561\u0581\u057E\u0578\u0582\u0574 \u0565\u0576 \u056D\u0574\u0562\u0561\u0563\u0580\u056B\u0579\u0578\u0582\u0574, \u0575\u0578\u0582\u0580\u0561\u0584\u0561\u0576\u0579\u0575\u0578\u0582\u0580\u0568 \u056B\u0580 \u057F\u0565\u057D\u0561\u056F\u0578\u057E, \u057A\u0561\u0580\u057F\u0561\u0564\u056B\u0580 \u056C\u056B\u0576\u0565\u056C\u0578\u057E, \u0561\u057C\u0561\u057B\u0576\u0561\u0570\u0565\u0580\u0569\u0578\u0582\u0569\u0575\u0561\u0574\u0562 \u0587 \u057D\u0565\u0583\u0561\u056F\u0561\u0576 \u0569\u056B\u0580\u0561\u056D\u0561\u057E\u0578\u0580\u0574\u0561\u0574\u0562\u0589",
        ka: "\u10D9\u10D8\u10D7\u10EE\u10D5\u10D4\u10D1\u10D8 \u10E0\u10D4\u10D3\u10D0\u10E5\u10E2\u10DD\u10E0\u10E8\u10D8 \u10D4\u10DB\u10D0\u10E2\u10D4\u10D1\u10D0, \u10D7\u10D8\u10D7\u10DD\u10D4\u10E3\u10DA\u10D8 \u10D7\u10D0\u10D5\u10D8\u10E1\u10D8 \u10E2\u10D8\u10DE\u10D8\u10D7, \u10E1\u10D0\u10D5\u10D0\u10DA\u10D3\u10D4\u10D1\u10E3\u10DA\u10DD\u10DD\u10D1\u10D8\u10D7, \u10DE\u10E0\u10D8\u10DD\u10E0\u10D8\u10E2\u10D4\u10E2\u10D8\u10D7\u10D0 \u10D3\u10D0 \u10E1\u10D0\u10D9\u10E3\u10D7\u10D0\u10E0\u10D8 \u10DB\u10D8\u10D6\u10DC\u10DD\u10D1\u10E0\u10D8\u10DD\u10D1\u10D8\u10D7."
    },
    surveys_b3: {
        uk: "\u0410\u0440\u0445\u0456\u0432\u0443\u0439\u0442\u0435 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0435 \u043E\u043F\u0438\u0442\u0443\u0432\u0430\u043D\u043D\u044F; \xab\u0412\u0456\u0434\u043D\u043E\u0432\u0438\u0442\u0438\xbb \u043F\u043E\u0432\u0435\u0440\u0442\u0430\u0454 \u0439\u043E\u0433\u043E.",
        en: "Archive a survey that is over; Restore brings it back.",
        hy: "\u0531\u0580\u056D\u056B\u057E\u0561\u0581\u0580\u0565\u0584 \u0561\u057E\u0561\u0580\u057F\u057E\u0561\u056E \u0570\u0561\u0580\u0581\u0578\u0582\u0574\u0568, \xab\u054E\u0565\u0580\u0561\u056F\u0561\u0576\u0563\u0576\u0565\u056C\xbb-\u0568 \u057E\u0565\u0580\u0561\u0564\u0561\u0580\u0571\u0576\u0578\u0582\u0574 \u0567 \u0561\u0575\u0576\u0589",
        ka: "\u10D3\u10D0\u10D0\u10E0\u10E5\u10D8\u10D5\u10D4\u10D7 \u10D3\u10D0\u10E1\u10E0\u10E3\u10DA\u10D4\u10D1\u10E3\u10DA\u10D8 \u10D2\u10D0\u10DB\u10DD\u10D9\u10D8\u10D7\u10EE\u10D5\u10D0; \xab\u10D0\u10E6\u10D3\u10D2\u10D4\u10DC\u10D0\xbb \u10DB\u10D0\u10E1 \u10D0\u10D1\u10E0\u10E3\u10DC\u10D4\u10D1\u10E1."
    },
    surveys_b4: {
        uk: "\u0412\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u0456 \u0437\u02BC\u044F\u0432\u043B\u044F\u044E\u0442\u044C\u0441\u044F \u0432 \u0440\u043E\u0437\u0434\u0456\u043B\u0456 \xab\u041E\u043F\u0438\u0442\u0443\u0432\u0430\u043D\u043D\u044F\xbb \u0432\u0456\u0437\u0438\u0442\u0443 \u0442\u0430 \u0432 \u043A\u0430\u0440\u0442\u0446\u0456 \u0430\u043A\u0442\u0438\u0432\u043D\u043E\u0441\u0442\u0456 \u043E\u043F\u0438\u0442\u0443\u0432\u0430\u043D\u044C \u043D\u0430 \u041E\u0433\u043B\u044F\u0434\u0456.",
        en: "Answers appear in the visit's Surveys section and in the survey activity card on Overview.",
        hy: "\u054A\u0561\u057F\u0561\u057D\u056D\u0561\u0576\u0576\u0565\u0580\u0568 \u0570\u0561\u0575\u057F\u0576\u057E\u0578\u0582\u0574 \u0565\u0576 \u0561\u0575\u0581\u056B \xab\u0540\u0561\u0580\u0581\u0578\u0582\u0574\u0576\u0565\u0580\xbb \u0562\u0561\u056A\u0576\u0578\u0582\u0574 \u0587 \u0531\u056F\u0576\u0561\u0580\u056F\u056B \u0570\u0561\u0580\u0581\u0578\u0582\u0574\u0576\u0565\u0580\u056B \u0561\u056F\u057F\u056B\u057E\u0578\u0582\u0569\u0575\u0561\u0576 \u0584\u0561\u0580\u057F\u0578\u0582\u0574\u0589",
        ka: "\u10DE\u10D0\u10E1\u10E3\u10EE\u10D4\u10D1\u10D8 \u10E9\u10D0\u10DC\u10E1 \u10D5\u10D8\u10D6\u10D8\u10E2\u10D8\u10E1 \xab\u10D2\u10D0\u10DB\u10DD\u10D9\u10D8\u10D7\u10EE\u10D5\u10D4\u10D1\u10D8\xbb \u10E1\u10D4\u10E5\u10EA\u10D8\u10D0\u10E8\u10D8 \u10D3\u10D0 \u10DB\u10D8\u10DB\u10DD\u10EE\u10D8\u10DA\u10D5\u10D8\u10E1 \u10D2\u10D0\u10DB\u10DD\u10D9\u10D8\u10D7\u10EE\u10D5\u10D4\u10D1\u10D8\u10E1 \u10D0\u10E5\u10E2\u10D8\u10D5\u10DD\u10D1\u10D8\u10E1 \u10D1\u10D0\u10E0\u10D0\u10D7\u10D6\u10D4."
    },
    reference_title: {
        uk: "\u0422\u043E\u0447\u043A\u0438 \u0442\u0430 \u0434\u043E\u0432\u0456\u0434\u043D\u0438\u043A\u0438",
        en: "Points and reference data",
        hy: "\u053F\u0565\u057F\u0565\u0580 \u0587 \u057F\u0565\u0572\u0565\u056F\u0561\u057F\u0578\u0582 \u057F\u057E\u0575\u0561\u056C\u0576\u0565\u0580",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8 \u10D3\u10D0 \u10E1\u10D0\u10EA\u10DC\u10DD\u10D1\u10D0\u10E0\u10DD \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8"
    },
    reference_desc: {
        uk: "\u0422\u043E\u0447\u043A\u0438, \u043C\u0435\u0440\u0435\u0436\u0456, \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0456\u0457, \u043A\u0440\u0430\u0457\u043D\u0438, \u0440\u0435\u0433\u0456\u043E\u043D\u0438, \u043D\u0430\u0441\u0435\u043B\u0435\u043D\u0456 \u043F\u0443\u043D\u043A\u0442\u0438 \u0439 \u0433\u0440\u0443\u043F\u0438 \u0442\u043E\u0447\u043E\u043A \u043C\u0430\u044E\u0442\u044C \u0441\u043F\u0456\u043B\u044C\u043D\u0438\u0439 \u0441\u043F\u0438\u0441\u043E\u043A \u0456 \u0440\u0435\u0434\u0430\u043A\u0442\u043E\u0440. \u0414\u043B\u044F \u0442\u043E\u0447\u043E\u043A \u0454 \u0434\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0456 \u0456\u043D\u0441\u0442\u0440\u0443\u043C\u0435\u043D\u0442\u0438 \u044F\u043A\u043E\u0441\u0442\u0456 \u0434\u0430\u043D\u0438\u0445.",
        en: "Points, networks, categories, countries, counties, localities and point groups share one list and one editor. Points get extra tools for data quality.",
        hy: "\u053F\u0565\u057F\u0565\u0580\u0568, \u0581\u0561\u0576\u0581\u0565\u0580\u0568, \u056F\u0561\u057F\u0565\u0563\u0578\u0580\u056B\u0561\u0576\u0565\u0580\u0568, \u0565\u0580\u056F\u0580\u0576\u0565\u0580\u0568, \u0574\u0561\u0580\u0566\u0565\u0580\u0568, \u0562\u0576\u0561\u056F\u0561\u057E\u0561\u0575\u0580\u0565\u0580\u0568 \u0587 \u056F\u0565\u057F\u0565\u0580\u056B \u056D\u0574\u0562\u0565\u0580\u0568 \u0578\u0582\u0576\u0565\u0576 \u0568\u0576\u0564\u0570\u0561\u0576\u0578\u0582\u0580 \u0581\u0578\u0582\u0581\u0561\u056F \u0587 \u056D\u0574\u0562\u0561\u0563\u0580\u056B\u0579\u0589 \u053F\u0565\u057F\u0565\u0580\u056B \u0570\u0561\u0574\u0561\u0580 \u056F\u0561\u0576 \u057F\u057E\u0575\u0561\u056C\u0576\u0565\u0580\u056B \u0578\u0580\u0561\u056F\u056B \u0570\u0561\u057E\u0565\u056C\u0575\u0561\u056C \u0563\u0578\u0580\u056E\u056B\u0584\u0576\u0565\u0580\u0589",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10E1, \u10E5\u10E1\u10D4\u10DA\u10D4\u10D1\u10E1, \u10D9\u10D0\u10E2\u10D4\u10D2\u10DD\u10E0\u10D8\u10D4\u10D1\u10E1, \u10E5\u10D5\u10D4\u10E7\u10DC\u10D4\u10D1\u10E1, \u10E0\u10D4\u10D2\u10D8\u10DD\u10DC\u10D4\u10D1\u10E1, \u10D3\u10D0\u10E1\u10D0\u10EE\u10DA\u10D4\u10D1\u10D4\u10D1\u10E1\u10D0 \u10D3\u10D0 \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8\u10E1 \u10EF\u10D2\u10E3\u10E4\u10D4\u10D1\u10E1 \u10E1\u10D0\u10D4\u10E0\u10D7\u10DD \u10E1\u10D8\u10D0 \u10D3\u10D0 \u10E0\u10D4\u10D3\u10D0\u10E5\u10E2\u10DD\u10E0\u10D8 \u10D0\u10E5\u10D5\u10E1. \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10E1 \u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D7\u10D0 \u10EE\u10D0\u10E0\u10D8\u10E1\u10EE\u10D8\u10E1 \u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D8\u10D7\u10D8 \u10EE\u10D4\u10DA\u10E1\u10D0\u10EC\u10E7\u10DD\u10D4\u10D1\u10D8 \u10D0\u10E5\u10D5\u10E1."
    },
    reference_b1: {
        uk: "\u0422\u043E\u0447\u043A\u0438: \u043C\u0456\u0442\u043A\u0438 \xab\u0411\u0435\u0437 \u043A\u043E\u043E\u0440\u0434\u0438\u043D\u0430\u0442\xbb (\u0432\u0456\u0437\u0438\u0442 \u0442\u0443\u0434\u0438 \u043D\u0435\u043C\u043E\u0436\u043B\u0438\u0432\u043E \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0438\u0442\u0438) \u0456 \xab\u041D\u0435 \u0437\u0430\u043A\u0440\u0456\u043F\u043B\u0435\u043D\u0456\xbb (\u043D\u0456\u0445\u0442\u043E \u043D\u0435 \u0457\u0434\u0435); \u043F\u0435\u0440\u0435\u043C\u0438\u043A\u0430\u0447 \u0440\u043E\u0437\u0434\u0456\u043B\u044F\u0454 \u0430\u043A\u0442\u0438\u0432\u043D\u0456, \u043D\u0435\u0430\u043A\u0442\u0438\u0432\u043D\u0456 \u0439 \u0430\u0440\u0445\u0456\u0432\u043E\u0432\u0430\u043D\u0456.",
        en: "Points: chips for No coordinates (a visit there can never be verified) and Unassigned (nobody is going); the segment splits active, inactive and archived.",
        hy: "\u053F\u0565\u057F\u0565\u0580\u055D \xab\u0531\u057C\u0561\u0576\u0581 \u056F\u0578\u0578\u0580\u0564\u056B\u0576\u0561\u057F\u0576\u0565\u0580\u056B\xbb (\u0561\u0575\u0576\u057F\u0565\u0572 \u0561\u0575\u0581\u0568 \u0570\u0576\u0561\u0580\u0561\u057E\u0578\u0580 \u0579\u0567 \u057D\u057F\u0578\u0582\u0563\u0565\u056C) \u0587 \xab\u0549\u0561\u0574\u0580\u0561\u0563\u0580\u057E\u0561\u056E\xbb (\u0578\u0579 \u0578\u0584 \u0579\u056B \u0563\u0576\u0578\u0582\u0574) \u057A\u056B\u057F\u0561\u056F\u0576\u0565\u0580. \u0583\u0578\u056D\u0561\u0580\u056F\u056B\u0579\u0568 \u0562\u0561\u056A\u0561\u0576\u0578\u0582\u0574 \u0567 \u0561\u056F\u057F\u056B\u057E, \u0578\u0579 \u0561\u056F\u057F\u056B\u057E \u0587 \u0561\u0580\u056D\u056B\u057E\u0561\u0581\u057E\u0561\u056E\u0589",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8: \u10E9\u10D8\u10DE\u10D4\u10D1\u10D8 \xab\u10D9\u10DD\u10DD\u10E0\u10D3\u10D8\u10DC\u10D0\u10E2\u10D4\u10D1\u10D8\u10E1 \u10D2\u10D0\u10E0\u10D4\u10E8\u10D4\xbb (\u10D8\u10E5 \u10D5\u10D8\u10D6\u10D8\u10E2\u10D8 \u10D5\u10D4\u10E0 \u10E8\u10D4\u10DB\u10DD\u10EC\u10DB\u10D3\u10D4\u10D1\u10D0) \u10D3\u10D0 \xab\u10DB\u10D8\u10E3\u10DB\u10D0\u10D2\u10E0\u10D4\u10D1\u10D4\u10DA\u10D8\xbb (\u10D0\u10E0\u10D0\u10D5\u10D8\u10DC \u10DB\u10D8\u10D3\u10D8\u10E1); \u10D2\u10D0\u10D3\u10D0\u10DB\u10E0\u10D7\u10D5\u10D4\u10DA\u10D8 \u10E7\u10DD\u10E4\u10E1 \u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10E1, \u10D0\u10E0\u10D0\u10D0\u10E5\u10E2\u10D8\u10E3\u10E0\u10E1\u10D0 \u10D3\u10D0 \u10D3\u10D0\u10D0\u10E0\u10E5\u10D8\u10D5\u10D4\u10D1\u10E3\u10DA\u10E1."
    },
    reference_b2: {
        uk: "\u0423 \u0440\u0435\u0434\u0430\u043A\u0442\u043E\u0440\u0456 \u0442\u043E\u0447\u043A\u0438 \u043F\u0435\u0440\u0435\u0442\u044F\u0433\u043D\u0456\u0442\u044C \u043C\u0430\u0440\u043A\u0435\u0440 \u0430\u0431\u043E \u043D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C \u043D\u0430 \u043A\u0430\u0440\u0442\u0443, \u0449\u043E\u0431 \u0437\u0430\u0434\u0430\u0442\u0438 \u043A\u043E\u043E\u0440\u0434\u0438\u043D\u0430\u0442\u0438; \u043C\u0430\u0441\u0448\u0442\u0430\u0431\u0443\u0439\u0442\u0435 \u043A\u043D\u043E\u043F\u043A\u0430\u043C\u0438.",
        en: "In the point editor, drag the pin or click the map to set coordinates; zoom with the buttons.",
        hy: "\u053F\u0565\u057F\u056B \u056D\u0574\u0562\u0561\u0563\u0580\u056B\u0579\u0578\u0582\u0574 \u0584\u0561\u0577\u0565\u0584 \u0584\u0578\u0580\u0578\u0581\u0568 \u056F\u0561\u0574 \u057D\u0565\u0572\u0574\u0565\u0584 \u0584\u0561\u0580\u057F\u0565\u0566\u056B \u057E\u0580\u0561\u055D \u056F\u0578\u0578\u0580\u0564\u056B\u0576\u0561\u057F\u0576\u0565\u0580\u0568 \u057D\u0561\u0570\u0574\u0561\u0576\u0565\u056C\u0578\u0582 \u0570\u0561\u0574\u0561\u0580, \u0574\u0561\u057D\u0577\u057F\u0561\u0562\u0561\u057E\u0578\u0580\u0565\u0584 \u056F\u0578\u0573\u0561\u056F\u0576\u0565\u0580\u0578\u057E\u0589",
        ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D8\u10E1 \u10E0\u10D4\u10D3\u10D0\u10E5\u10E2\u10DD\u10E0\u10E8\u10D8 \u10D2\u10D0\u10D3\u10D0\u10D0\u10D7\u10E0\u10D8\u10D4\u10D7 \u10DE\u10D8\u10DC\u10D8 \u10D0\u10DC \u10D3\u10D0\u10D0\u10EC\u10D9\u10D0\u10DE\u10E3\u10DC\u10D4\u10D7 \u10E0\u10E3\u10D9\u10D0\u10D6\u10D4 \u10D9\u10DD\u10DD\u10E0\u10D3\u10D8\u10DC\u10D0\u10E2\u10D4\u10D1\u10D8\u10E1 \u10D3\u10D0\u10E1\u10D0\u10E7\u10D4\u10DC\u10D4\u10D1\u10DA\u10D0\u10D3; \u10DB\u10D0\u10E1\u10E8\u10E2\u10D0\u10D1\u10D8 \u10E6\u10D8\u10DA\u10D0\u10D9\u10D4\u10D1\u10D8\u10D7 \u10E8\u10D4\u10EA\u10D5\u10D0\u10DA\u10D4\u10D7."
    },
    reference_b3: {
        uk: "\u0412\u0438\u0434\u0456\u043B\u0456\u0442\u044C \u0442\u043E\u0447\u043A\u0438 \u0439 \u043D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C \xab\u0414\u043E\u0434\u0430\u0442\u0438 \u0432 \u0433\u0440\u0443\u043F\u0443\xbb, \u0449\u043E\u0431 \u0434\u043E\u0434\u0430\u0442\u0438 \u0457\u0445 \u0434\u043E \u043D\u0430\u044F\u0432\u043D\u043E\u0457 \u0430\u0431\u043E \u043D\u043E\u0432\u043E\u0457 \u0433\u0440\u0443\u043F\u0438. \u0421\u043A\u043B\u0430\u0434 \u0433\u0440\u0443\u043F\u0438 \u0434\u043E\u043F\u043E\u0432\u043D\u044E\u0454\u0442\u044C\u0441\u044F, \u0430 \u043D\u0435 \u0437\u0430\u043C\u0456\u043D\u044E\u0454\u0442\u044C\u0441\u044F.",
        en: "Select points and use Add to group to put them in an existing or new group. Membership is merged, never replaced.",
        hy: "\u0538\u0576\u057F\u0580\u0565\u0584 \u056F\u0565\u057F\u0565\u0580\u0568 \u0587 \u0585\u0563\u057F\u0561\u0563\u0578\u0580\u056E\u0565\u0584 \xab\u0531\u057E\u0565\u056C\u0561\u0581\u0576\u0565\u056C \u056D\u0574\u0562\u0578\u0582\u0574\xbb\u055D \u0564\u0580\u0561\u0576\u0584 \u0563\u0578\u0575\u0578\u0582\u0569\u0575\u0578\u0582\u0576 \u0578\u0582\u0576\u0565\u0581\u0578\u0572 \u056F\u0561\u0574 \u0576\u0578\u0580 \u056D\u0574\u0562\u0578\u0582\u0574 \u057F\u0565\u0572\u0561\u0564\u0580\u0565\u056C\u0578\u0582 \u0570\u0561\u0574\u0561\u0580\u0589 \u053D\u0574\u0562\u056B \u056F\u0561\u0566\u0574\u0568 \u056C\u0580\u0561\u0581\u057E\u0578\u0582\u0574 \u0567, \u0578\u0579 \u0569\u0565 \u0583\u0578\u056D\u0561\u0580\u056B\u0576\u057E\u0578\u0582\u0574\u0589",
        ka: "\u10DB\u10DD\u10DC\u10D8\u10E8\u10DC\u10D4\u10D7 \u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8 \u10D3\u10D0 \u10D2\u10D0\u10DB\u10DD\u10D8\u10E7\u10D4\u10DC\u10D4\u10D7 \xab\u10EF\u10D2\u10E3\u10E4\u10E8\u10D8 \u10D3\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10D0\xbb \u10D0\u10E0\u10E1\u10D4\u10D1\u10E3\u10DA \u10D0\u10DC \u10D0\u10EE\u10D0\u10DA \u10EF\u10D2\u10E3\u10E4\u10E8\u10D8 \u10E9\u10D0\u10E1\u10D0\u10DB\u10D0\u10E2\u10D4\u10D1\u10DA\u10D0\u10D3. \u10EF\u10D2\u10E3\u10E4\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D0\u10D3\u10D2\u10D4\u10DC\u10DA\u10DD\u10D1\u10D0 \u10D8\u10D5\u10E1\u10D4\u10D1\u10D0 \u10D3\u10D0 \u10D0\u10E0\u10D0 \u10D8\u10EA\u10D5\u10DA\u10D4\u10D1\u10D0."
    },
    reference_b4: {
        uk: "\u041A\u043E\u0436\u0435\u043D \u0440\u0435\u0434\u0430\u043A\u0442\u043E\u0440 \u043C\u0430\u0454 \u043A\u0430\u0440\u0442\u043A\u0443 \xab\u042F\u043A\u0456\u0441\u0442\u044C \u0434\u0430\u043D\u0438\u0445\xbb \u0437\u0456 \u0441\u043F\u0438\u0441\u043A\u043E\u043C \u0442\u043E\u0433\u043E, \u0447\u043E\u0433\u043E \u043D\u0435 \u0432\u0438\u0441\u0442\u0430\u0447\u0430\u0454; \u043D\u0430\u0442\u0438\u0441\u043A\u0430\u043D\u043D\u044F \u043F\u0435\u0440\u0435\u0432\u043E\u0434\u0438\u0442\u044C \u0444\u043E\u043A\u0443\u0441 \u043D\u0430 \u043F\u043E\u043B\u0435. \u0426\u0456 \u0441\u043F\u0438\u0441\u043A\u0438 \u0437\u0430\u043F\u0430\u043C\u02BC\u044F\u0442\u043E\u0432\u0443\u044E\u0442\u044C \u0444\u0456\u043B\u044C\u0442\u0440\u0438 \u043E\u043A\u0440\u0435\u043C\u043E, \u0430 \u043D\u0435 \u0432 \u0430\u0434\u0440\u0435\u0441\u043D\u043E\u043C\u0443 \u0440\u044F\u0434\u043A\u0443.",
        en: "Each editor shows a Data quality card listing what is missing; clicking an item focuses the field. These lists remember their filters per list rather than in the address bar.",
        hy: "\u0545\u0578\u0582\u0580\u0561\u0584\u0561\u0576\u0579\u0575\u0578\u0582\u0580 \u056D\u0574\u0562\u0561\u0563\u0580\u056B\u0579 \u0578\u0582\u0576\u056B \xab\u054F\u057E\u0575\u0561\u056C\u0576\u0565\u0580\u056B \u0578\u0580\u0561\u056F\xbb \u0584\u0561\u0580\u057F, \u0578\u0580\u057F\u0565\u0572 \u0576\u0577\u057E\u0561\u056E \u0567, \u0569\u0565 \u056B\u0576\u0579 \u0567 \u0562\u0561\u0581\u0561\u056F\u0561\u0575\u0578\u0582\u0574. \u057D\u0565\u0572\u0574\u0565\u056C\u0568 \u056F\u0565\u0576\u057F\u0580\u0578\u0576\u0561\u0581\u0576\u0578\u0582\u0574 \u0567 \u0564\u0561\u0577\u057F\u0568\u0589 \u0531\u0575\u057D \u0581\u0578\u0582\u0581\u0561\u056F\u0576\u0565\u0580\u0568 \u0566\u057F\u056B\u0579\u0576\u0565\u0580\u0568 \u0570\u056B\u0577\u0578\u0582\u0574 \u0565\u0576 \u0561\u057C\u0561\u0576\u0571\u056B\u0576, \u0578\u0579 \u0569\u0565 \u0570\u0561\u057D\u0581\u0565\u056B \u057F\u0578\u0572\u0578\u0582\u0574\u0589",
        ka: "\u10D7\u10D8\u10D7\u10DD\u10D4\u10E3\u10DA \u10E0\u10D4\u10D3\u10D0\u10E5\u10E2\u10DD\u10E0\u10E1 \u10D0\u10E5\u10D5\u10E1 \xab\u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D7\u10D0 \u10EE\u10D0\u10E0\u10D8\u10E1\u10EE\u10D8\xbb \u10D1\u10D0\u10E0\u10D0\u10D7\u10D8, \u10E1\u10D0\u10D3\u10D0\u10EA \u10E9\u10D0\u10DC\u10E1, \u10E0\u10D0 \u10D0\u10D9\u10DA\u10D8\u10D0; \u10D3\u10D0\u10EC\u10D9\u10D0\u10DE\u10E3\u10DC\u10D4\u10D1\u10D0 \u10D5\u10D4\u10DA\u10D6\u10D4 \u10E4\u10DD\u10D9\u10E3\u10E1\u10E1 \u10D2\u10D0\u10D3\u10D0\u10D8\u10E2\u10D0\u10DC\u10E1. \u10D4\u10E1 \u10E1\u10D8\u10D4\u10D1\u10D8 \u10E4\u10D8\u10DA\u10E2\u10E0\u10D4\u10D1\u10E1 \u10EA\u10D0\u10DA\u10D9\u10D4 \u10D8\u10DB\u10D0\u10EE\u10E1\u10DD\u10D5\u10E0\u10D4\u10D1\u10E1 \u10D3\u10D0 \u10D0\u10E0\u10D0 \u10DB\u10D8\u10E1\u10D0\u10DB\u10D0\u10E0\u10D7\u10D8\u10E1 \u10D5\u10D4\u10DA\u10E8\u10D8."
    }
};



const $91ea30cb49819b9a$export$498d10c55d12eec5 = "https://api.picsell.com.ua/login/";
const $91ea30cb49819b9a$export$8cc80cbeeab961c9 = "https://api.picsell.com.ua/web/v1/";
const $91ea30cb49819b9a$export$d5a0ec7c9e524fbb = undefined;
const $91ea30cb49819b9a$export$7a30a33cf2617bd2 = undefined;
const $91ea30cb49819b9a$export$be750171172fb886 = 50;
const $91ea30cb49819b9a$export$8e5d48d2b3bed316 = 500;
const $91ea30cb49819b9a$export$da688e121885cf48 = {
    merchandiser: "merchandisers",
    merchandisers: "merchandisers/",
    supervisor: "supervisors/",
    created_by: "supervisors-and-supervisor-managers/",
    filters: "filters/",
    route: "routes",
    task: "tasks",
    clients: "clients/",
    point: "points",
    points: "points",
    point_groups: "point_groups",
    visit: "visits",
    network: "networks/",
    point__network: "networks/",
    networks: "networks/",
    point__networks: "networks/",
    county: "counties/",
    locality: "localities",
    country: "countries/",
    countries: "countries/",
    categories_point: "categories_point/",
    language: "language",
    brand: "brands",
    brands: "brands",
    product: "products",
    products: "products",
    categories: "categories/",
    subcategory: "subcategories/",
    subcategories: "subcategories/",
    tag: "tags/",
    tags: "tags/",
    component: "components",
    company: "companies",
    template: "templates/",
    absence_reason_templates: "absence-reason-templates/"
};
const $91ea30cb49819b9a$export$a6a26ddb3e5b4d30 = {
    task_negative: [
        {
            id: true,
            name: "\u0422\u0410\u041A"
        },
        {
            id: false,
            name: "\u041D\u0406"
        }
    ],
    task_deadline: [
        {
            id: true,
            name: "\u0422\u0410\u041A"
        },
        {
            id: false,
            name: "\u041D\u0406"
        }
    ],
    task_status: [
        {
            id: "no_answers",
            name: "\u041D\u0435 \u0432\u0438\u043A\u043E\u043D\u0430\u043D\u0456"
        },
        {
            id: "on_review",
            name: "\u041D\u0430 \u0437\u0430\u0442\u0432\u0435\u0440\u0434\u0436\u0435\u043D\u0456"
        },
        {
            id: "done",
            name: "\u0412\u0438\u043A\u043E\u043D\u0430\u043D\u0456"
        }
    ]
};
const $91ea30cb49819b9a$export$846d38fa3865c245 = {
    filters: {
        action: "list",
        title: (c)=>c.label,
        selectTitle: "custom_filter"
    },
    merchandiser: {
        action: "list",
        title: (c)=>c.first_name + " " + c.last_name,
        selectTitle: "merchandiser"
    },
    merchandisers: {
        action: "list",
        title: (c)=>c.first_name + " " + c.last_name,
        selectTitle: "merchandisers"
    },
    supervisor: {
        action: "list",
        title: (c)=>c.first_name + " " + c.last_name,
        selectTitle: "supervisor"
    },
    // Was missing entirely, so the clients dropdown rendered with no placeholder at all.
    clients: {
        action: "list",
        title: (c)=>c.name,
        selectTitle: "clients"
    },
    point: {
        action: "list",
        title: (c)=>c.name + " " + c.address,
        selectTitle: "point"
    },
    points: {
        action: "list",
        title: (c)=>c.name + " " + c.address,
        selectTitle: "points"
    },
    point_groups: {
        action: "list",
        title: (c)=>c.name,
        selectTitle: "group_point_select_placeholder"
    },
    network: {
        action: "list",
        title: (c)=>c.name,
        selectTitle: "network"
    },
    point__network: {
        action: "list",
        title: (c)=>c.name,
        selectTitle: "network"
    },
    point__networks: {
        action: "list",
        title: (c)=>c.name,
        selectTitle: "network"
    },
    networks: {
        action: "list",
        title: (c)=>c.name,
        selectTitle: "networks"
    },
    created_by: {
        action: "list",
        title: (c)=>c.name,
        selectTitle: "created_by"
    },
    county: {
        action: "list",
        title: (c)=>c.name,
        selectTitle: "region"
    },
    locality: {
        action: "list",
        title: (c)=>c.name,
        selectTitle: "city"
    },
    country: {
        action: "list",
        title: (c)=>c.name,
        selectTitle: "country"
    },
    countries: {
        action: "list",
        title: (c)=>c.name,
        selectTitle: "countries"
    },
    categories_point: {
        action: "list",
        title: (c)=>c.name,
        selectTitle: "category"
    },
    brand: {
        action: "list",
        title: (c)=>c.name,
        selectTitle: "brand"
    },
    brands: {
        action: "list",
        title: (c)=>c.name,
        selectTitle: "brands"
    },
    product: {
        action: "list",
        title: (c)=>c.name,
        selectTitle: "product"
    },
    products: {
        action: "list",
        title: (c)=>c.name,
        selectTitle: "products"
    },
    category: {
        action: "list",
        title: (c)=>c.name,
        selectTitle: "category"
    },
    categories: {
        action: "list",
        title: (c)=>c.name,
        selectTitle: "categories"
    },
    subcategory: {
        action: "list",
        title: (c)=>c.name,
        selectTitle: "subcategories"
    },
    subcategories: {
        action: "list",
        title: (c)=>c.name,
        selectTitle: "subcategories"
    },
    tag: {
        action: "list",
        title: (c)=>c.name,
        selectTitle: "tag"
    },
    tags: {
        action: "list",
        title: (c)=>c.name,
        selectTitle: "tags"
    },
    component: {
        action: "list",
        title: (c)=>c.name,
        selectTitle: "component"
    },
    template: {
        action: "list",
        title: (c)=>c.name,
        selectTitle: "template"
    },
    absence_reason_templates: {
        action: "list",
        title: (c)=>c.reason,
        selectTitle: "absence_reason_templates"
    },
    task_status: {
        action: "list",
        title: (c)=>c.name,
        selectTitle: "task_status"
    },
    task_negative: {
        action: "list",
        title: (c)=>c.name,
        selectTitle: "task_negative"
    },
    task_deadline: {
        action: "list",
        title: (c)=>c.name,
        selectTitle: "task_deadline"
    },
    date_range: {
        action: "list",
        title: (c)=>c.name,
        selectTitle: "date_range"
    }
};
const $91ea30cb49819b9a$export$7ac3753ee4f78186 = {
    sizePerPage: 50,
    page: 1,
    totalDataSize: 0,
    sizePerPageList: [
        50,
        100,
        1000
    ],
    pageStartIndex: 1,
    paginationSize: 3,
    prePage: "Previous",
    nextPage: "Next",
    firstPage: "First",
    lastPage: "Last",
    paging: false
};



const $c9936523dc38c641$var$HEADERS = {
    "Accept": "application/json",
    "Content-Type": "application/json",
    "X-Frame-Options": "deny"
};
const $c9936523dc38c641$var$GENERIC_ERROR = {
    uk: "\u0429\u043E\u0441\u044C \u043F\u0456\u0448\u043B\u043E \u043D\u0435 \u0442\u0430\u043A. \u0421\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0449\u0435 \u0440\u0430\u0437.",
    en: "Something went wrong. Please try again.",
    hy: "\u053B\u0576\u0579-\u0578\u0580 \u0562\u0561\u0576 \u057D\u056D\u0561\u056C \u0563\u0576\u0561\u0581\u0589 \u053D\u0576\u0564\u0580\u0578\u0582\u0574 \u0565\u0576\u0584 \u0583\u0578\u0580\u0571\u0565\u056C \u056F\u0580\u056F\u056B\u0576\u0589",
    ka: "\u10E0\u10D0\u10E6\u10D0\u10EA \u10E8\u10D4\u10EA\u10D3\u10DD\u10DB\u10D0 \u10DB\u10DD\u10EE\u10D3\u10D0. \u10D2\u10D7\u10EE\u10DD\u10D5\u10D7, \u10E1\u10EA\u10D0\u10D3\u10DD\u10D7 \u10D7\u10D0\u10D5\u10D8\u10D3\u10D0\u10DC."
};
// Safe read of persisted auth state — never throws on missing/corrupt localStorage
// (loadState is try/catch wrapped and returns undefined on failure).
function $c9936523dc38c641$var$readState() {
    return (0, $67f64b78c4102acd$export$ea32cbdd559da174)() || null;
}
// Benign stand-in handed to a callback when a request fails, so loading states clear
// without crashing the caller: `.id`/`.detail` are undefined (success paths skip) and
// `.results`/`.count` satisfy the many list callers that .map/.length over them.
// ⚠ It is TRUTHY — `Boolean(response)` scored a failed request as a success, which is how bulk
// approve toasted an error AND a success for the same batch (PICSELL-1581 #10). `failed` is the
// marker; write-path callers check `isOk(response)` instead of truthiness.
function $c9936523dc38c641$var$failedResponse() {
    return {
        results: [],
        count: 0,
        failed: true
    };
}
function $c9936523dc38c641$export$71a04ee6075aae31(response) {
    return Boolean(response) && !response.failed && !(response.status >= 400);
}
function $c9936523dc38c641$var$notifyFailure(state) {
    const lang = state?.me?.language || "en";
    (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).error($c9936523dc38c641$var$GENERIC_ERROR[lang] || $c9936523dc38c641$var$GENERIC_ERROR.en);
}
// Expired/invalid token: clear the user and bounce to login. Covers any 401/403, not
// just the exact "Invalid token." body string the app used to match on.
function $c9936523dc38c641$var$handleUnauthorized() {
    (0, $67f64b78c4102acd$export$fb931cd598921492)({
        me: null
    });
    window.location.replace("/login");
}
async function $c9936523dc38c641$export$45fc6b2d335e3c39(response) {
    const out = {
        __ok: false,
        fields: {},
        message: ""
    };
    try {
        const body = await response.json();
        if (body && typeof body === "object") {
            Object.entries(body).forEach(([k, v])=>{
                out.fields[k] = Array.isArray(v) ? v.join(", ") : String(v);
            });
            out.message = Object.values(out.fields).join("; ");
        }
    } catch (e) {
    /* non-JSON body */ }
    return out;
}
function $c9936523dc38c641$export$848feb93d8f32b9b(body = {}, cb, customHeaders = {}, isBlob = false) {
    const headers = new Headers($c9936523dc38c641$var$HEADERS);
    let state = $c9936523dc38c641$var$readState();
    headers.append("Authorization", `Token ${state?.me?.key || null}`);
    if (customHeaders) Object.entries(customHeaders).map((header)=>{
        headers.append(header[0], header[1]);
    });
    let params = {
        method: body.method,
        headers: headers,
        mode: "cors",
        cache: "default"
    };
    if ([
        "POST",
        "PATCH",
        "PUT"
    ].indexOf(body.method) !== -1) params.body = JSON.stringify(body.post);
    let url = (0, $91ea30cb49819b9a$export$8cc80cbeeab961c9) + body.url;
    if (body.outforz) url = "https://dev.api.outforz.com/api/contents/";
    if (isBlob) fetch(url, params).then((response)=>{
        if (!response || response.status >= 500) {
            $c9936523dc38c641$var$notifyFailure(state);
            if (cb) cb();
            return null;
        }
        if (response.status === 401 || response.status === 403) {
            $c9936523dc38c641$var$handleUnauthorized();
            return null;
        }
        return response.blob();
    }).then((blob)=>{
        if (!blob) return; // failure already handled above
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = "export.zip";
        document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
        a.click();
        a.remove(); //afterwards we remove the element again
        if (cb) cb();
    }).catch((err)=>{
        console.error("Request failed:", err);
        $c9936523dc38c641$var$notifyFailure(state);
        if (cb) cb();
    });
    else fetch(url, params).then(async (response)=>{
        if (!response) {
            $c9936523dc38c641$var$notifyFailure(state);
            cb($c9936523dc38c641$var$failedResponse());
            return;
        }
        if (response.status === 401 || response.status === 403) {
            $c9936523dc38c641$var$handleUnauthorized();
            return;
        }
        // Any 5xx, not just 500: the photo-report proxy answers 502 when Outforz is
        // unreachable, and a 502 that fell through to `.json()` arrived at the caller as a
        // body with no `results` — indistinguishable from an empty page, with no toast.
        if (response.status >= 500) {
            $c9936523dc38c641$var$notifyFailure(state);
            cb($c9936523dc38c641$var$failedResponse());
            return;
        }
        // 400/204 callers expect the raw Response (they parse it themselves).
        if (response.status === 400) {
            cb(response);
            return;
        }
        if (response.status === 204) {
            cb(response);
            return;
        }
        let data = null;
        try {
            data = await response.json();
        } catch (e) {
            data = null; // empty / non-JSON body — don't let .json() reject silently
        }
        if (data?.detail === "Invalid token.") {
            $c9936523dc38c641$var$handleUnauthorized();
            return;
        }
        cb(data != null ? data : $c9936523dc38c641$var$failedResponse());
    }).catch((err)=>{
        console.error("Request failed:", err);
        $c9936523dc38c641$var$notifyFailure(state);
        cb($c9936523dc38c641$var$failedResponse());
    });
}
function $c9936523dc38c641$export$46f383001bf60e04(body = {}, cb, customHeaders = {}, isBlob = false) {
    const headers = new Headers($c9936523dc38c641$var$HEADERS);
    let state = $c9936523dc38c641$var$readState();
    headers.append("Authorization", `Token ${state?.me?.key || null}`);
    if (customHeaders) Object.entries(customHeaders).map((header)=>{
        headers.append(header[0], header[1]);
    });
    let params = {
        method: body.method,
        headers: headers,
        mode: "cors",
        cache: "default"
    };
    if ([
        "POST",
        "PATCH",
        "PUT"
    ].indexOf(body.method) !== -1) params.body = JSON.stringify(body.post);
    let url = (0, $91ea30cb49819b9a$export$8cc80cbeeab961c9) + body.url;
    if (body.outforz) url = "https://dev.api.outforz.com/api/contents/";
    if (isBlob) fetch(url, params).then((response)=>{
        if (!response || response.status >= 500) {
            $c9936523dc38c641$var$notifyFailure(state);
            if (cb) cb();
            return null;
        }
        if (response.status === 401 || response.status === 403) {
            $c9936523dc38c641$var$handleUnauthorized();
            return null;
        }
        return response.blob();
    }).then((blob)=>{
        if (!blob) return;
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = "export.zip";
        document.body.appendChild(a);
        a.click();
        a.remove();
        if (cb) cb();
    }).catch((err)=>{
        console.error("Request failed:", err);
        $c9936523dc38c641$var$notifyFailure(state);
        if (cb) cb();
    });
    else fetch(url, params).then(async (response)=>{
        if (!response) {
            $c9936523dc38c641$var$notifyFailure(state);
            cb($c9936523dc38c641$var$failedResponse());
            return;
        }
        if (response.status === 401 || response.status === 403) {
            $c9936523dc38c641$var$handleUnauthorized();
            return;
        }
        // Any 5xx, not just 500: the photo-report proxy answers 502 when Outforz is
        // unreachable, and a 502 that fell through to `.json()` arrived at the caller as a
        // body with no `results` — indistinguishable from an empty page, with no toast.
        if (response.status >= 500) {
            $c9936523dc38c641$var$notifyFailure(state);
            cb($c9936523dc38c641$var$failedResponse());
            return;
        }
        if (response.status === 400) {
            cb(response);
            return;
        }
        // httpRequest intentionally hands 200/204 back as the raw Response.
        if (response.status === 204 || response.status === 200) {
            cb(response);
            return;
        }
        let data = null;
        try {
            data = await response.json();
        } catch (e) {
            data = null;
        }
        if (data?.detail === "Invalid token.") {
            $c9936523dc38c641$var$handleUnauthorized();
            return;
        }
        cb(data != null ? data : $c9936523dc38c641$var$failedResponse());
    }).catch((err)=>{
        console.error("Request failed:", err);
        $c9936523dc38c641$var$notifyFailure(state);
        cb($c9936523dc38c641$var$failedResponse());
    });
}
const $c9936523dc38c641$export$ae8c526ac59e8cc8 = async (body = {}, cb)=>{
    const headers = new Headers($c9936523dc38c641$var$HEADERS);
    let state = $c9936523dc38c641$var$readState();
    headers.append("Authorization", `Token ${state?.me?.key || null}`);
    let params = {
        method: body.method,
        headers: headers,
        mode: "cors",
        cache: "default"
    };
    if ([
        "POST",
        "PATCH",
        "PUT"
    ].indexOf(body.method) !== -1) params.body = JSON.stringify(body.post);
    let url = (0, $91ea30cb49819b9a$export$8cc80cbeeab961c9) + body.url;
    if (body.outforz) url = "https://dev.api.outforz.com/api/contents/";
    fetch(url, params).then(async (response)=>{
        if (!response) {
            $c9936523dc38c641$var$notifyFailure(state);
            cb($c9936523dc38c641$var$failedResponse());
            return;
        }
        if (response.status === 401 || response.status === 403) {
            $c9936523dc38c641$var$handleUnauthorized();
            return;
        }
        if (response.status >= 500) {
            $c9936523dc38c641$var$notifyFailure(state);
            cb($c9936523dc38c641$var$failedResponse());
            return;
        }
        let data = null;
        try {
            data = await response.json();
        } catch (e) {
            data = null;
        }
        if (data?.detail === "Invalid token.") {
            $c9936523dc38c641$var$handleUnauthorized();
            return;
        }
        cb(data != null ? data : $c9936523dc38c641$var$failedResponse());
    }).catch((err)=>{
        console.error("Request failed:", err);
        $c9936523dc38c641$var$notifyFailure(state);
        cb($c9936523dc38c641$var$failedResponse());
    });
};
function $c9936523dc38c641$export$86557ef9e0794d10(url, signal) {
    const headers = new Headers($c9936523dc38c641$var$HEADERS);
    const state = $c9936523dc38c641$var$readState();
    headers.append("Authorization", `Token ${state?.me?.key || null}`);
    return fetch((0, $91ea30cb49819b9a$export$8cc80cbeeab961c9) + url, {
        method: "GET",
        headers: headers,
        mode: "cors",
        signal: signal
    }).then((response)=>{
        if (response.status === 401 || response.status === 403) {
            $c9936523dc38c641$var$handleUnauthorized();
            return null;
        }
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return response.json();
    });
}
function $c9936523dc38c641$export$73693bad9f5880b0(body = {}) {
    const headers = new Headers($c9936523dc38c641$var$HEADERS);
    let params = {
        method: "POST",
        headers: headers,
        mode: "cors",
        cache: "default"
    };
    params.body = JSON.stringify(body);
    return new Promise((resolve, reject)=>{
        fetch(`${(0, $91ea30cb49819b9a$export$498d10c55d12eec5)}`, params).then((response)=>response.json()).then(resolve).catch(reject);
    });
}
function $c9936523dc38c641$export$e9af2f996ea0b059(body = {}, cb) {
    const headers = new Headers();
    let state = $c9936523dc38c641$var$readState();
    headers.append("Authorization", `Token ${state?.me?.key || null}`);
    // No Content-Type: the browser sets multipart/form-data; boundary automatically.
    const params = {
        method: body.method,
        headers: headers,
        mode: "cors",
        cache: "default",
        body: body.post
    };
    const url = (0, $91ea30cb49819b9a$export$8cc80cbeeab961c9) + body.url;
    fetch(url, params).then(async (response)=>{
        if (!response) {
            $c9936523dc38c641$var$notifyFailure(state);
            cb($c9936523dc38c641$var$failedResponse());
            return;
        }
        if (response.status === 401 || response.status === 403) {
            $c9936523dc38c641$var$handleUnauthorized();
            return;
        }
        if (response.status >= 500) {
            $c9936523dc38c641$var$notifyFailure(state);
            cb($c9936523dc38c641$var$failedResponse());
            return;
        }
        if (response.status === 400) {
            cb(response);
            return;
        }
        if (response.status === 204) {
            cb(response);
            return;
        }
        let data = null;
        try {
            data = await response.json();
        } catch (e) {
            data = null;
        }
        if (data?.detail === "Invalid token.") {
            $c9936523dc38c641$var$handleUnauthorized();
            return;
        }
        cb(data != null ? data : $c9936523dc38c641$var$failedResponse());
    }).catch((err)=>{
        console.error("Request failed:", err);
        $c9936523dc38c641$var$notifyFailure(state);
        cb($c9936523dc38c641$var$failedResponse());
    });
}
function $c9936523dc38c641$export$a3c8e1472dc2ed84(body = {}, cb) {
    const headers = new Headers();
    let state = $c9936523dc38c641$var$readState();
    headers.append("Authorization", `Token ${state?.me?.key || null}`);
    let params = {
        method: body.method,
        headers: headers,
        mode: "cors",
        cache: "default"
    };
    params.body = body.post;
    let url = (0, $91ea30cb49819b9a$export$8cc80cbeeab961c9) + body.url;
    fetch(url, params).then((response)=>{
        if (response.status === 401 || response.status === 403) {
            $c9936523dc38c641$var$handleUnauthorized();
            throw new Error("Unauthorized");
        }
        if (!response.ok) // Surface the server error message; fall back to a generic toast if the
        // error body isn't JSON (so a non-JSON 5xx doesn't get swallowed silently).
        return response.json().then((errData)=>{
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).error(String(errData?.error || $c9936523dc38c641$var$GENERIC_ERROR[state?.me?.language || "en"] || $c9936523dc38c641$var$GENERIC_ERROR.en), {
                position: "top"
            });
            throw errData;
        }, ()=>{
            $c9936523dc38c641$var$notifyFailure(state);
            throw new Error("Upload failed");
        });
        return response.json();
    }).then((res)=>{
        cb(res);
    }).catch((err)=>{
        console.error("Upload failed:", err);
    });
}


"use strict";
function $73106adb55132987$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}



var $4dBQg = parcelRequire("4dBQg");
"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $c2bf92a64ef6699d$var$toString } = Object.prototype;
const { getPrototypeOf: $c2bf92a64ef6699d$var$getPrototypeOf } = Object;
const { iterator: $c2bf92a64ef6699d$var$iterator, toStringTag: $c2bf92a64ef6699d$var$toStringTag } = Symbol;
/* Creating a function that will check if an object has a property. */ const $c2bf92a64ef6699d$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Walk the prototype chain (excluding the shared Object.prototype) looking for
 * an own `prop`. This distinguishes genuine own/inherited members — including
 * class accessors and template prototypes — from members injected via
 * Object.prototype pollution (e.g. `Object.prototype.username = '...'`), which
 * live on Object.prototype itself and are therefore never matched.
 *
 * @param {*} thing The value whose chain to inspect
 * @param {string|symbol} prop The property key to look for
 *
 * @returns {boolean} True when `prop` is owned below Object.prototype
 */ const $c2bf92a64ef6699d$var$hasOwnInPrototypeChain = (thing, prop)=>{
    let obj = thing;
    const seen = [];
    while(obj != null && obj !== Object.prototype){
        if (seen.indexOf(obj) !== -1) return false;
        seen.push(obj);
        if ($c2bf92a64ef6699d$var$hasOwnProperty(obj, prop)) return true;
        obj = $c2bf92a64ef6699d$var$getPrototypeOf(obj);
    }
    return false;
};
/**
 * Read `obj[prop]` only when it is safe from Object.prototype pollution. Own
 * properties and members inherited from a non-Object.prototype source (a class
 * instance or template object) are honored; a value reachable only through a
 * polluted Object.prototype is ignored and `undefined` is returned.
 *
 * @param {*} obj The source object
 * @param {string|symbol} prop The property key to read
 *
 * @returns {*} The resolved value, or undefined when unsafe/absent
 */ const $c2bf92a64ef6699d$var$getSafeProp = (obj, prop)=>obj != null && $c2bf92a64ef6699d$var$hasOwnInPrototypeChain(obj, prop) ? obj[prop] : undefined;
const $c2bf92a64ef6699d$var$kindOf = ((cache)=>(thing)=>{
        const str = $c2bf92a64ef6699d$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $c2bf92a64ef6699d$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$c2bf92a64ef6699d$var$kindOf(thing) === type;
};
const $c2bf92a64ef6699d$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is a non-null object
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $c2bf92a64ef6699d$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $c2bf92a64ef6699d$var$isUndefined = $c2bf92a64ef6699d$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $c2bf92a64ef6699d$var$isBuffer(val) {
    return val !== null && !$c2bf92a64ef6699d$var$isUndefined(val) && val.constructor !== null && !$c2bf92a64ef6699d$var$isUndefined(val.constructor) && $c2bf92a64ef6699d$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $c2bf92a64ef6699d$var$isArrayBuffer = $c2bf92a64ef6699d$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $c2bf92a64ef6699d$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $c2bf92a64ef6699d$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $c2bf92a64ef6699d$var$isString = $c2bf92a64ef6699d$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $c2bf92a64ef6699d$var$isFunction = $c2bf92a64ef6699d$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $c2bf92a64ef6699d$var$isNumber = $c2bf92a64ef6699d$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $c2bf92a64ef6699d$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $c2bf92a64ef6699d$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $c2bf92a64ef6699d$var$isPlainObject = (val)=>{
    if (!$c2bf92a64ef6699d$var$isObject(val)) return false;
    const prototype = $c2bf92a64ef6699d$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || $c2bf92a64ef6699d$var$getPrototypeOf(prototype) === null) && // Treat any genuine (non-Object.prototype-polluted) Symbol.toStringTag or
    // Symbol.iterator as evidence the value is a tagged/iterable type rather
    // than a plain object, while ignoring keys injected onto Object.prototype.
    !$c2bf92a64ef6699d$var$hasOwnInPrototypeChain(val, $c2bf92a64ef6699d$var$toStringTag) && !$c2bf92a64ef6699d$var$hasOwnInPrototypeChain(val, $c2bf92a64ef6699d$var$iterator);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $c2bf92a64ef6699d$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$c2bf92a64ef6699d$var$isObject(val) || $c2bf92a64ef6699d$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $c2bf92a64ef6699d$var$isDate = $c2bf92a64ef6699d$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c2bf92a64ef6699d$var$isFile = $c2bf92a64ef6699d$var$kindOfTest("File");
/**
 * Determine if a value is a React Native Blob
 * React Native "blob": an object with a `uri` attribute. Optionally, it can
 * also have a `name` and `type` attribute to specify filename and content type
 *
 * @see https://github.com/facebook/react-native/blob/26684cf3adf4094eb6c405d345a75bf8c7c0bf88/Libraries/Network/FormData.js#L68-L71
 *
 * @param {*} value The value to test
 *
 * @returns {boolean} True if value is a React Native Blob, otherwise false
 */ const $c2bf92a64ef6699d$var$isReactNativeBlob = (value)=>{
    return !!(value && typeof value.uri !== "undefined");
};
/**
 * Determine if environment is React Native
 * ReactNative `FormData` has a non-standard `getParts()` method
 *
 * @param {*} formData The formData to test
 *
 * @returns {boolean} True if environment is React Native, otherwise false
 */ const $c2bf92a64ef6699d$var$isReactNative = (formData)=>formData && typeof formData.getParts !== "undefined";
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $c2bf92a64ef6699d$var$isBlob = $c2bf92a64ef6699d$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a FileList, otherwise false
 */ const $c2bf92a64ef6699d$var$isFileList = $c2bf92a64ef6699d$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $c2bf92a64ef6699d$var$isStream = (val)=>$c2bf92a64ef6699d$var$isObject(val) && $c2bf92a64ef6699d$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $c2bf92a64ef6699d$var$getGlobal() {
    if (typeof globalThis !== "undefined") return globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    return {};
}
const $c2bf92a64ef6699d$var$G = $c2bf92a64ef6699d$var$getGlobal();
const $c2bf92a64ef6699d$var$FormDataCtor = typeof $c2bf92a64ef6699d$var$G.FormData !== "undefined" ? $c2bf92a64ef6699d$var$G.FormData : undefined;
const $c2bf92a64ef6699d$var$isFormData = (thing)=>{
    if (!thing) return false;
    if ($c2bf92a64ef6699d$var$FormDataCtor && thing instanceof $c2bf92a64ef6699d$var$FormDataCtor) return true;
    // Reject plain objects inheriting directly from Object.prototype so prototype-pollution gadgets can't spoof FormData.
    const proto = $c2bf92a64ef6699d$var$getPrototypeOf(thing);
    if (!proto || proto === Object.prototype) return false;
    if (!$c2bf92a64ef6699d$var$isFunction(thing.append)) return false;
    const kind = $c2bf92a64ef6699d$var$kindOf(thing);
    return kind === "formdata" || // detect form-data instance
    kind === "object" && $c2bf92a64ef6699d$var$isFunction(thing.toString) && thing.toString() === "[object FormData]";
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $c2bf92a64ef6699d$var$isURLSearchParams = $c2bf92a64ef6699d$var$kindOfTest("URLSearchParams");
const [$c2bf92a64ef6699d$var$isReadableStream, $c2bf92a64ef6699d$var$isRequest, $c2bf92a64ef6699d$var$isResponse, $c2bf92a64ef6699d$var$isHeaders] = [
    "ReadableStream",
    "Request",
    "Response",
    "Headers"
].map($c2bf92a64ef6699d$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $c2bf92a64ef6699d$var$trim = (str)=>{
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array<unknown>} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys = false]
 * @returns {any}
 */ function $c2bf92a64ef6699d$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($c2bf92a64ef6699d$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($c2bf92a64ef6699d$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
/**
 * Finds a key in an object, case-insensitive, returning the actual key name.
 * Returns null if the object is a Buffer or if no match is found.
 *
 * @param {Object} obj - The object to search.
 * @param {string} key - The key to find (case-insensitive).
 * @returns {?string} The actual key name if found, otherwise null.
 */ function $c2bf92a64ef6699d$var$findKey(obj, key) {
    if ($c2bf92a64ef6699d$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $c2bf92a64ef6699d$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $c2bf92a64ef6699d$var$isContextDefined = (context)=>!$c2bf92a64ef6699d$var$isUndefined(context) && context !== $c2bf92a64ef6699d$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * const result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $c2bf92a64ef6699d$var$merge(...objs) {
    const { caseless: caseless, skipUndefined: skipUndefined } = $c2bf92a64ef6699d$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        // Skip dangerous property names to prevent prototype pollution
        if (key === "__proto__" || key === "constructor" || key === "prototype") return;
        // findKey lowercases the key, so caseless lookup only applies to strings —
        // symbol keys are identity-matched.
        const targetKey = caseless && typeof key === "string" && $c2bf92a64ef6699d$var$findKey(result, key) || key;
        // Read via own-prop only — a bare `result[targetKey]` walks the prototype
        // chain, so a polluted Object.prototype value could surface here and get
        // copied into the merged result.
        const existing = $c2bf92a64ef6699d$var$hasOwnProperty(result, targetKey) ? result[targetKey] : undefined;
        if ($c2bf92a64ef6699d$var$isPlainObject(existing) && $c2bf92a64ef6699d$var$isPlainObject(val)) result[targetKey] = $c2bf92a64ef6699d$var$merge(existing, val);
        else if ($c2bf92a64ef6699d$var$isPlainObject(val)) result[targetKey] = $c2bf92a64ef6699d$var$merge({}, val);
        else if ($c2bf92a64ef6699d$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$c2bf92a64ef6699d$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = objs.length; i < l; i++){
        const source = objs[i];
        if (!source || $c2bf92a64ef6699d$var$isBuffer(source)) continue;
        $c2bf92a64ef6699d$var$forEach(source, assignValue);
        if (typeof source !== "object" || $c2bf92a64ef6699d$var$isArray(source)) continue;
        const symbols = Object.getOwnPropertySymbols(source);
        for(let j = 0; j < symbols.length; j++){
            const symbol = symbols[j];
            if ($c2bf92a64ef6699d$var$propertyIsEnumerable.call(source, symbol)) assignValue(source[symbol], symbol);
        }
    }
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $c2bf92a64ef6699d$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $c2bf92a64ef6699d$var$forEach(b, (val, key)=>{
        if (thisArg && $c2bf92a64ef6699d$var$isFunction(val)) Object.defineProperty(a, key, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot
            // hijack defineProperty's accessor-vs-data resolution.
            __proto__: null,
            value: (0, $73106adb55132987$export$2e2bcd8739ae039)(val, thisArg),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else Object.defineProperty(a, key, {
            __proto__: null,
            value: val,
            writable: true,
            enumerable: true,
            configurable: true
        });
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $c2bf92a64ef6699d$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $c2bf92a64ef6699d$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    Object.defineProperty(constructor.prototype, "constructor", {
        __proto__: null,
        value: constructor,
        writable: true,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(constructor, "super", {
        __proto__: null,
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $c2bf92a64ef6699d$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $c2bf92a64ef6699d$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $c2bf92a64ef6699d$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $c2bf92a64ef6699d$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($c2bf92a64ef6699d$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$c2bf92a64ef6699d$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $c2bf92a64ef6699d$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $c2bf92a64ef6699d$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $c2bf92a64ef6699d$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$c2bf92a64ef6699d$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $c2bf92a64ef6699d$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $c2bf92a64ef6699d$var$isHTMLForm = $c2bf92a64ef6699d$var$kindOfTest("HTMLFormElement");
const $c2bf92a64ef6699d$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
const { propertyIsEnumerable: $c2bf92a64ef6699d$var$propertyIsEnumerable } = Object.prototype;
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $c2bf92a64ef6699d$var$isRegExp = $c2bf92a64ef6699d$var$kindOfTest("RegExp");
const $c2bf92a64ef6699d$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $c2bf92a64ef6699d$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $c2bf92a64ef6699d$var$freezeMethods = (obj)=>{
    $c2bf92a64ef6699d$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($c2bf92a64ef6699d$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].includes(name)) return false;
        const value = obj[name];
        if (!$c2bf92a64ef6699d$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
/**
 * Converts an array or a delimited string into an object set with values as keys and true as values.
 * Useful for fast membership checks.
 *
 * @param {Array|string} arrayOrString - The array or string to convert.
 * @param {string} delimiter - The delimiter to use if input is a string.
 * @returns {Object} An object with keys from the array or string, values set to true.
 */ const $c2bf92a64ef6699d$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $c2bf92a64ef6699d$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $c2bf92a64ef6699d$var$noop = ()=>{};
const $c2bf92a64ef6699d$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $c2bf92a64ef6699d$var$isSpecCompliantForm(thing) {
    return !!(thing && $c2bf92a64ef6699d$var$isFunction(thing.append) && thing[$c2bf92a64ef6699d$var$toStringTag] === "FormData" && thing[$c2bf92a64ef6699d$var$iterator]);
}
/**
 * Recursively converts an object to a JSON-compatible object, handling circular references and Buffers.
 *
 * @param {Object} obj - The object to convert.
 * @returns {Object} The JSON-compatible object.
 */ const $c2bf92a64ef6699d$var$toJSONObject = (obj)=>{
    const visited = new WeakSet();
    const visit = (source)=>{
        if ($c2bf92a64ef6699d$var$isObject(source)) {
            if (visited.has(source)) return;
            //Buffer check
            if ($c2bf92a64ef6699d$var$isBuffer(source)) return source;
            if (!("toJSON" in source)) {
                // add-on descent / delete-on-ascent: preserves path semantics, so DAG nodes serialise at every occurrence (see #7230).
                visited.add(source);
                const target = $c2bf92a64ef6699d$var$isArray(source) ? [] : {};
                $c2bf92a64ef6699d$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value);
                    !$c2bf92a64ef6699d$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                visited.delete(source);
                return target;
            }
        }
        return source;
    };
    return visit(obj);
};
/**
 * Determines if a value is an async function.
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is an async function, otherwise false.
 */ const $c2bf92a64ef6699d$var$isAsyncFn = $c2bf92a64ef6699d$var$kindOfTest("AsyncFunction");
/**
 * Determines if a value is thenable (has then and catch methods).
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is thenable, otherwise false.
 */ const $c2bf92a64ef6699d$var$isThenable = (thing)=>thing && ($c2bf92a64ef6699d$var$isObject(thing) || $c2bf92a64ef6699d$var$isFunction(thing)) && $c2bf92a64ef6699d$var$isFunction(thing.then) && $c2bf92a64ef6699d$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
/**
 * Provides a cross-platform setImmediate implementation.
 * Uses native setImmediate if available, otherwise falls back to postMessage or setTimeout.
 *
 * @param {boolean} setImmediateSupported - Whether setImmediate is supported.
 * @param {boolean} postMessageSupported - Whether postMessage is supported.
 * @returns {Function} A function to schedule a callback asynchronously.
 */ const $c2bf92a64ef6699d$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $c2bf92a64ef6699d$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $c2bf92a64ef6699d$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $c2bf92a64ef6699d$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === "function", $c2bf92a64ef6699d$var$isFunction($c2bf92a64ef6699d$var$_global.postMessage));
/**
 * Schedules a microtask or asynchronous callback as soon as possible.
 * Uses queueMicrotask if available, otherwise falls back to process.nextTick or _setImmediate.
 *
 * @type {Function}
 */ const $c2bf92a64ef6699d$var$asap = typeof queueMicrotask !== "undefined" ? queueMicrotask.bind($c2bf92a64ef6699d$var$_global) : typeof $4dBQg !== "undefined" && $4dBQg.nextTick || $c2bf92a64ef6699d$var$_setImmediate;
// *********************
const $c2bf92a64ef6699d$var$isIterable = (thing)=>thing != null && $c2bf92a64ef6699d$var$isFunction(thing[$c2bf92a64ef6699d$var$iterator]);
/**
 * Determine if a value is iterable via an iterator that is NOT sourced solely
 * from a polluted Object.prototype. Use this instead of `isIterable` whenever
 * the iterable comes from untrusted input (e.g. user-supplied header sources),
 * so `Object.prototype[Symbol.iterator] = ...` cannot turn an ordinary object
 * into an attacker-controlled entries iterator.
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value has a non-polluted iterator
 */ const $c2bf92a64ef6699d$var$isSafeIterable = (thing)=>thing != null && $c2bf92a64ef6699d$var$hasOwnInPrototypeChain(thing, $c2bf92a64ef6699d$var$iterator) && $c2bf92a64ef6699d$var$isIterable(thing);
var $c2bf92a64ef6699d$export$2e2bcd8739ae039 = {
    isArray: $c2bf92a64ef6699d$var$isArray,
    isArrayBuffer: $c2bf92a64ef6699d$var$isArrayBuffer,
    isBuffer: $c2bf92a64ef6699d$var$isBuffer,
    isFormData: $c2bf92a64ef6699d$var$isFormData,
    isArrayBufferView: $c2bf92a64ef6699d$var$isArrayBufferView,
    isString: $c2bf92a64ef6699d$var$isString,
    isNumber: $c2bf92a64ef6699d$var$isNumber,
    isBoolean: $c2bf92a64ef6699d$var$isBoolean,
    isObject: $c2bf92a64ef6699d$var$isObject,
    isPlainObject: $c2bf92a64ef6699d$var$isPlainObject,
    isEmptyObject: $c2bf92a64ef6699d$var$isEmptyObject,
    isReadableStream: $c2bf92a64ef6699d$var$isReadableStream,
    isRequest: $c2bf92a64ef6699d$var$isRequest,
    isResponse: $c2bf92a64ef6699d$var$isResponse,
    isHeaders: $c2bf92a64ef6699d$var$isHeaders,
    isUndefined: $c2bf92a64ef6699d$var$isUndefined,
    isDate: $c2bf92a64ef6699d$var$isDate,
    isFile: $c2bf92a64ef6699d$var$isFile,
    isReactNativeBlob: $c2bf92a64ef6699d$var$isReactNativeBlob,
    isReactNative: $c2bf92a64ef6699d$var$isReactNative,
    isBlob: $c2bf92a64ef6699d$var$isBlob,
    isRegExp: $c2bf92a64ef6699d$var$isRegExp,
    isFunction: $c2bf92a64ef6699d$var$isFunction,
    isStream: $c2bf92a64ef6699d$var$isStream,
    isURLSearchParams: $c2bf92a64ef6699d$var$isURLSearchParams,
    isTypedArray: $c2bf92a64ef6699d$var$isTypedArray,
    isFileList: $c2bf92a64ef6699d$var$isFileList,
    forEach: $c2bf92a64ef6699d$var$forEach,
    merge: $c2bf92a64ef6699d$var$merge,
    extend: $c2bf92a64ef6699d$var$extend,
    trim: $c2bf92a64ef6699d$var$trim,
    stripBOM: $c2bf92a64ef6699d$var$stripBOM,
    inherits: $c2bf92a64ef6699d$var$inherits,
    toFlatObject: $c2bf92a64ef6699d$var$toFlatObject,
    kindOf: $c2bf92a64ef6699d$var$kindOf,
    kindOfTest: $c2bf92a64ef6699d$var$kindOfTest,
    endsWith: $c2bf92a64ef6699d$var$endsWith,
    toArray: $c2bf92a64ef6699d$var$toArray,
    forEachEntry: $c2bf92a64ef6699d$var$forEachEntry,
    matchAll: $c2bf92a64ef6699d$var$matchAll,
    isHTMLForm: $c2bf92a64ef6699d$var$isHTMLForm,
    hasOwnProperty: $c2bf92a64ef6699d$var$hasOwnProperty,
    hasOwnProp: $c2bf92a64ef6699d$var$hasOwnProperty,
    hasOwnInPrototypeChain: $c2bf92a64ef6699d$var$hasOwnInPrototypeChain,
    getSafeProp: $c2bf92a64ef6699d$var$getSafeProp,
    reduceDescriptors: $c2bf92a64ef6699d$var$reduceDescriptors,
    freezeMethods: $c2bf92a64ef6699d$var$freezeMethods,
    toObjectSet: $c2bf92a64ef6699d$var$toObjectSet,
    toCamelCase: $c2bf92a64ef6699d$var$toCamelCase,
    noop: $c2bf92a64ef6699d$var$noop,
    toFiniteNumber: $c2bf92a64ef6699d$var$toFiniteNumber,
    findKey: $c2bf92a64ef6699d$var$findKey,
    global: $c2bf92a64ef6699d$var$_global,
    isContextDefined: $c2bf92a64ef6699d$var$isContextDefined,
    isSpecCompliantForm: $c2bf92a64ef6699d$var$isSpecCompliantForm,
    toJSONObject: $c2bf92a64ef6699d$var$toJSONObject,
    isAsyncFn: $c2bf92a64ef6699d$var$isAsyncFn,
    isThenable: $c2bf92a64ef6699d$var$isThenable,
    setImmediate: $c2bf92a64ef6699d$var$_setImmediate,
    asap: $c2bf92a64ef6699d$var$asap,
    isIterable: $c2bf92a64ef6699d$var$isIterable,
    isSafeIterable: $c2bf92a64ef6699d$var$isSafeIterable
};









"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $0cad027e2ffba15a$var$ignoreDuplicateOf = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $0cad027e2ffba15a$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $0cad027e2ffba15a$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};



"use strict";
function $fedefcd4ca7e05ca$var$trimSPorHTAB(str) {
    let start = 0;
    let end = str.length;
    while(start < end){
        const code = str.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = str.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === str.length ? str : str.slice(start, end);
}
// The control-code ranges are intentional: header sanitization strips C0/DEL bytes.
// eslint-disable-next-line no-control-regex
const $fedefcd4ca7e05ca$var$INVALID_UNICODE_HEADER_VALUE_CHARS = new RegExp("[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+", "g");
// eslint-disable-next-line no-control-regex
const $fedefcd4ca7e05ca$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS = new RegExp("[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+", "g");
function $fedefcd4ca7e05ca$var$sanitizeValue(value, invalidChars) {
    if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isArray(value)) return value.map((item)=>$fedefcd4ca7e05ca$var$sanitizeValue(item, invalidChars));
    return $fedefcd4ca7e05ca$var$trimSPorHTAB(String(value).replace(invalidChars, ""));
}
const $fedefcd4ca7e05ca$export$9e344cffce061a22 = (value)=>$fedefcd4ca7e05ca$var$sanitizeValue(value, $fedefcd4ca7e05ca$var$INVALID_UNICODE_HEADER_VALUE_CHARS);
const $fedefcd4ca7e05ca$export$59dd66c2a12d8f62 = (value)=>$fedefcd4ca7e05ca$var$sanitizeValue(value, $fedefcd4ca7e05ca$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS);
function $fedefcd4ca7e05ca$export$c30c72bb7e677d54(headers) {
    const byteStringHeaders = Object.create(null);
    (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).forEach(headers.toJSON(), (value, header)=>{
        byteStringHeaders[header] = $fedefcd4ca7e05ca$export$59dd66c2a12d8f62(value);
    });
    return byteStringHeaders;
}


"use strict";
const $f2bfae2f47cdd2a8$var$$internals = Symbol("internals");
function $f2bfae2f47cdd2a8$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $f2bfae2f47cdd2a8$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isArray(value) ? value.map($f2bfae2f47cdd2a8$var$normalizeValue) : (0, $fedefcd4ca7e05ca$export$9e344cffce061a22)(String(value));
}
function $f2bfae2f47cdd2a8$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $f2bfae2f47cdd2a8$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $f2bfae2f47cdd2a8$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $f2bfae2f47cdd2a8$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $f2bfae2f47cdd2a8$var$buildAccessors(obj, header) {
    const accessorName = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $f2bfae2f47cdd2a8$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $f2bfae2f47cdd2a8$var$normalizeHeader(_header);
            if (!lHeader) return;
            const key = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $f2bfae2f47cdd2a8$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$f2bfae2f47cdd2a8$var$isValidHeaderName(header)) setHeaders((0, $0cad027e2ffba15a$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isObject(header) && (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isSafeIterable(header)) {
            let obj = Object.create(null), dest, key;
            for (const entry of header){
                if (!(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isArray(entry)) throw new TypeError("Object iterator must return a key-value pair");
                key = entry[0];
                if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).hasOwnProp(obj, key)) {
                    dest = obj[key];
                    obj[key] = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isArray(dest) ? [
                        ...dest,
                        entry[1]
                    ] : [
                        dest,
                        entry[1]
                    ];
                } else obj[key] = entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $f2bfae2f47cdd2a8$var$normalizeHeader(header);
        if (header) {
            const key = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $f2bfae2f47cdd2a8$var$parseTokens(value);
                if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $f2bfae2f47cdd2a8$var$normalizeHeader(header);
        if (header) {
            const key = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $f2bfae2f47cdd2a8$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $f2bfae2f47cdd2a8$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $f2bfae2f47cdd2a8$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $f2bfae2f47cdd2a8$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $f2bfae2f47cdd2a8$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $f2bfae2f47cdd2a8$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $f2bfae2f47cdd2a8$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    getSetCookie() {
        return this.get("set-cookie") || [];
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$f2bfae2f47cdd2a8$var$$internals] = this[$f2bfae2f47cdd2a8$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $f2bfae2f47cdd2a8$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $f2bfae2f47cdd2a8$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$f2bfae2f47cdd2a8$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).reduceDescriptors($f2bfae2f47cdd2a8$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).freezeMethods($f2bfae2f47cdd2a8$var$AxiosHeaders);
var $f2bfae2f47cdd2a8$export$2e2bcd8739ae039 = $f2bfae2f47cdd2a8$var$AxiosHeaders;


"use strict";
const $ea1e0e5414f1ba5b$var$REDACTED = "[REDACTED ****]";
function $ea1e0e5414f1ba5b$var$hasOwnOrPrototypeToJSON(source) {
    if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).hasOwnProp(source, "toJSON")) return true;
    let prototype = Object.getPrototypeOf(source);
    while(prototype && prototype !== Object.prototype){
        if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).hasOwnProp(prototype, "toJSON")) return true;
        prototype = Object.getPrototypeOf(prototype);
    }
    return false;
}
// Build a plain-object snapshot of `config` and replace the value of any key
// (case-insensitive) listed in `redactKeys` with REDACTED. Walks through arrays
// and AxiosHeaders, and short-circuits on circular references.
function $ea1e0e5414f1ba5b$var$redactConfig(config, redactKeys) {
    const lowerKeys = new Set(redactKeys.map((k)=>String(k).toLowerCase()));
    const seen = [];
    const visit = (source)=>{
        if (source === null || typeof source !== "object") return source;
        if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isBuffer(source)) return source;
        if (seen.indexOf(source) !== -1) return undefined;
        if (source instanceof (0, $f2bfae2f47cdd2a8$export$2e2bcd8739ae039)) source = source.toJSON();
        seen.push(source);
        let result;
        if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isArray(source)) {
            result = [];
            source.forEach((v, i)=>{
                const reducedValue = visit(v);
                if (!(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isUndefined(reducedValue)) result[i] = reducedValue;
            });
        } else {
            if (!(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isPlainObject(source) && $ea1e0e5414f1ba5b$var$hasOwnOrPrototypeToJSON(source)) {
                seen.pop();
                return source;
            }
            result = Object.create(null);
            for (const [key, value] of Object.entries(source)){
                const reducedValue = lowerKeys.has(key.toLowerCase()) ? $ea1e0e5414f1ba5b$var$REDACTED : visit(value);
                if (!(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isUndefined(reducedValue)) result[key] = reducedValue;
            }
        }
        seen.pop();
        return result;
    };
    return visit(config);
}
class $ea1e0e5414f1ba5b$var$AxiosError extends Error {
    static from(error, code, config, request, response, customProps) {
        const axiosError = new $ea1e0e5414f1ba5b$var$AxiosError(error.message, code || error.code, config, request, response);
        // Match native `Error` `cause` semantics: non-enumerable. The wrapped
        // error often carries circular internals (sockets, requests, agents), so
        // an enumerable `cause` makes structured loggers (pino/winston) and any
        // own-property walk throw "Converting circular structure to JSON".
        // Regression from #6982; see #7205. `__proto__: null` mirrors the
        // `message` descriptor below (prototype-pollution-safe descriptor).
        Object.defineProperty(axiosError, "cause", {
            __proto__: null,
            value: error,
            writable: true,
            enumerable: false,
            configurable: true
        });
        axiosError.name = error.name;
        // Preserve status from the original error if not already set from response
        if (error.status != null && axiosError.status == null) axiosError.status = error.status;
        customProps && Object.assign(axiosError, customProps);
        return axiosError;
    }
    /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */ constructor(message, code, config, request, response){
        super(message);
        // Make message enumerable to maintain backward compatibility
        // The native Error constructor sets message as non-enumerable,
        // but axios < v1.13.3 had it as enumerable
        Object.defineProperty(this, "message", {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: message,
            enumerable: true,
            writable: true,
            configurable: true
        });
        this.name = "AxiosError";
        this.isAxiosError = true;
        code && (this.code = code);
        config && (this.config = config);
        request && (this.request = request);
        if (response) {
            this.response = response;
            this.status = response.status;
        }
    }
    toJSON() {
        // Opt-in redaction: when the request config carries a `redact` array, the
        // value of any matching key (case-insensitive, at any depth) is replaced
        // with REDACTED in the serialized snapshot. Undefined or empty leaves the
        // existing serialization behavior unchanged.
        const config = this.config;
        const redactKeys = config && (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).hasOwnProp(config, "redact") ? config.redact : undefined;
        const serializedConfig = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isArray(redactKeys) && redactKeys.length > 0 ? $ea1e0e5414f1ba5b$var$redactConfig(config, redactKeys) : (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).toJSONObject(config);
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: serializedConfig,
            code: this.code,
            status: this.status
        };
    }
}
// This can be changed to static properties as soon as the parser options in .eslint.cjs are updated.
$ea1e0e5414f1ba5b$var$AxiosError.ERR_BAD_OPTION_VALUE = "ERR_BAD_OPTION_VALUE";
$ea1e0e5414f1ba5b$var$AxiosError.ERR_BAD_OPTION = "ERR_BAD_OPTION";
$ea1e0e5414f1ba5b$var$AxiosError.ECONNABORTED = "ECONNABORTED";
$ea1e0e5414f1ba5b$var$AxiosError.ETIMEDOUT = "ETIMEDOUT";
$ea1e0e5414f1ba5b$var$AxiosError.ECONNREFUSED = "ECONNREFUSED";
$ea1e0e5414f1ba5b$var$AxiosError.ERR_NETWORK = "ERR_NETWORK";
$ea1e0e5414f1ba5b$var$AxiosError.ERR_FR_TOO_MANY_REDIRECTS = "ERR_FR_TOO_MANY_REDIRECTS";
$ea1e0e5414f1ba5b$var$AxiosError.ERR_DEPRECATED = "ERR_DEPRECATED";
$ea1e0e5414f1ba5b$var$AxiosError.ERR_BAD_RESPONSE = "ERR_BAD_RESPONSE";
$ea1e0e5414f1ba5b$var$AxiosError.ERR_BAD_REQUEST = "ERR_BAD_REQUEST";
$ea1e0e5414f1ba5b$var$AxiosError.ERR_CANCELED = "ERR_CANCELED";
$ea1e0e5414f1ba5b$var$AxiosError.ERR_NOT_SUPPORT = "ERR_NOT_SUPPORT";
$ea1e0e5414f1ba5b$var$AxiosError.ERR_INVALID_URL = "ERR_INVALID_URL";
$ea1e0e5414f1ba5b$var$AxiosError.ERR_FORM_DATA_DEPTH_EXCEEDED = "ERR_FORM_DATA_DEPTH_EXCEEDED";
var $ea1e0e5414f1ba5b$export$2e2bcd8739ae039 = $ea1e0e5414f1ba5b$var$AxiosError;


// eslint-disable-next-line strict
var $4b784fc05ded8112$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $46b8ab9ed5acde5f$export$a143d493d941bafc;
var $46b8ab9ed5acde5f$export$e4cf37d7f6fb9e0a;
var $46b8ab9ed5acde5f$export$f99ded8fe4b79145;
var $46b8ab9ed5acde5f$export$599f31c3813fae4d;
"use strict";
var $9f15c0b4b37a5ac3$export$a48f0734ac7c2329;
var $9f15c0b4b37a5ac3$export$d622b2ad8d90c771;
var $9f15c0b4b37a5ac3$export$6100ba28696e12de;
"use strict";
$9f15c0b4b37a5ac3$export$a48f0734ac7c2329 = $9f15c0b4b37a5ac3$var$byteLength;
$9f15c0b4b37a5ac3$export$d622b2ad8d90c771 = $9f15c0b4b37a5ac3$var$toByteArray;
$9f15c0b4b37a5ac3$export$6100ba28696e12de = $9f15c0b4b37a5ac3$var$fromByteArray;
var $9f15c0b4b37a5ac3$var$lookup = [];
var $9f15c0b4b37a5ac3$var$revLookup = [];
var $9f15c0b4b37a5ac3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $9f15c0b4b37a5ac3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $9f15c0b4b37a5ac3$var$i = 0, $9f15c0b4b37a5ac3$var$len = $9f15c0b4b37a5ac3$var$code.length; $9f15c0b4b37a5ac3$var$i < $9f15c0b4b37a5ac3$var$len; ++$9f15c0b4b37a5ac3$var$i){
    $9f15c0b4b37a5ac3$var$lookup[$9f15c0b4b37a5ac3$var$i] = $9f15c0b4b37a5ac3$var$code[$9f15c0b4b37a5ac3$var$i];
    $9f15c0b4b37a5ac3$var$revLookup[$9f15c0b4b37a5ac3$var$code.charCodeAt($9f15c0b4b37a5ac3$var$i)] = $9f15c0b4b37a5ac3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$9f15c0b4b37a5ac3$var$revLookup["-".charCodeAt(0)] = 62;
$9f15c0b4b37a5ac3$var$revLookup["_".charCodeAt(0)] = 63;
function $9f15c0b4b37a5ac3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $9f15c0b4b37a5ac3$var$byteLength(b64) {
    var lens = $9f15c0b4b37a5ac3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $9f15c0b4b37a5ac3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $9f15c0b4b37a5ac3$var$toByteArray(b64) {
    var tmp;
    var lens = $9f15c0b4b37a5ac3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $9f15c0b4b37a5ac3$var$Arr($9f15c0b4b37a5ac3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $9f15c0b4b37a5ac3$var$revLookup[b64.charCodeAt(i)] << 18 | $9f15c0b4b37a5ac3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $9f15c0b4b37a5ac3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $9f15c0b4b37a5ac3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $9f15c0b4b37a5ac3$var$revLookup[b64.charCodeAt(i)] << 2 | $9f15c0b4b37a5ac3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $9f15c0b4b37a5ac3$var$revLookup[b64.charCodeAt(i)] << 10 | $9f15c0b4b37a5ac3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $9f15c0b4b37a5ac3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $9f15c0b4b37a5ac3$var$tripletToBase64(num) {
    return $9f15c0b4b37a5ac3$var$lookup[num >> 18 & 0x3F] + $9f15c0b4b37a5ac3$var$lookup[num >> 12 & 0x3F] + $9f15c0b4b37a5ac3$var$lookup[num >> 6 & 0x3F] + $9f15c0b4b37a5ac3$var$lookup[num & 0x3F];
}
function $9f15c0b4b37a5ac3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($9f15c0b4b37a5ac3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $9f15c0b4b37a5ac3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($9f15c0b4b37a5ac3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($9f15c0b4b37a5ac3$var$lookup[tmp >> 2] + $9f15c0b4b37a5ac3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($9f15c0b4b37a5ac3$var$lookup[tmp >> 10] + $9f15c0b4b37a5ac3$var$lookup[tmp >> 4 & 0x3F] + $9f15c0b4b37a5ac3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $da651c57892e471c$export$aafa59e2e03f2942;
var $da651c57892e471c$export$68d8715fc104d294;
$da651c57892e471c$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$da651c57892e471c$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $46b8ab9ed5acde5f$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$46b8ab9ed5acde5f$export$a143d493d941bafc = $46b8ab9ed5acde5f$var$Buffer;
$46b8ab9ed5acde5f$export$e4cf37d7f6fb9e0a = $46b8ab9ed5acde5f$var$SlowBuffer;
$46b8ab9ed5acde5f$export$f99ded8fe4b79145 = 50;
const $46b8ab9ed5acde5f$var$K_MAX_LENGTH = 0x7fffffff;
$46b8ab9ed5acde5f$export$599f31c3813fae4d = $46b8ab9ed5acde5f$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $46b8ab9ed5acde5f$var$Buffer.TYPED_ARRAY_SUPPORT = $46b8ab9ed5acde5f$var$typedArraySupport();
if (!$46b8ab9ed5acde5f$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $46b8ab9ed5acde5f$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($46b8ab9ed5acde5f$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$46b8ab9ed5acde5f$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($46b8ab9ed5acde5f$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$46b8ab9ed5acde5f$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $46b8ab9ed5acde5f$var$createBuffer(length) {
    if (length > $46b8ab9ed5acde5f$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $46b8ab9ed5acde5f$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $46b8ab9ed5acde5f$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $46b8ab9ed5acde5f$var$allocUnsafe(arg);
    }
    return $46b8ab9ed5acde5f$var$from(arg, encodingOrOffset, length);
}
$46b8ab9ed5acde5f$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $46b8ab9ed5acde5f$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $46b8ab9ed5acde5f$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $46b8ab9ed5acde5f$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($46b8ab9ed5acde5f$var$isInstance(value, ArrayBuffer) || value && $46b8ab9ed5acde5f$var$isInstance(value.buffer, ArrayBuffer)) return $46b8ab9ed5acde5f$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($46b8ab9ed5acde5f$var$isInstance(value, SharedArrayBuffer) || value && $46b8ab9ed5acde5f$var$isInstance(value.buffer, SharedArrayBuffer))) return $46b8ab9ed5acde5f$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $46b8ab9ed5acde5f$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $46b8ab9ed5acde5f$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $46b8ab9ed5acde5f$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $46b8ab9ed5acde5f$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $46b8ab9ed5acde5f$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($46b8ab9ed5acde5f$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($46b8ab9ed5acde5f$var$Buffer, Uint8Array);
function $46b8ab9ed5acde5f$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $46b8ab9ed5acde5f$var$alloc(size, fill, encoding) {
    $46b8ab9ed5acde5f$var$assertSize(size);
    if (size <= 0) return $46b8ab9ed5acde5f$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $46b8ab9ed5acde5f$var$createBuffer(size).fill(fill, encoding) : $46b8ab9ed5acde5f$var$createBuffer(size).fill(fill);
    return $46b8ab9ed5acde5f$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $46b8ab9ed5acde5f$var$Buffer.alloc = function(size, fill, encoding) {
    return $46b8ab9ed5acde5f$var$alloc(size, fill, encoding);
};
function $46b8ab9ed5acde5f$var$allocUnsafe(size) {
    $46b8ab9ed5acde5f$var$assertSize(size);
    return $46b8ab9ed5acde5f$var$createBuffer(size < 0 ? 0 : $46b8ab9ed5acde5f$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $46b8ab9ed5acde5f$var$Buffer.allocUnsafe = function(size) {
    return $46b8ab9ed5acde5f$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $46b8ab9ed5acde5f$var$Buffer.allocUnsafeSlow = function(size) {
    return $46b8ab9ed5acde5f$var$allocUnsafe(size);
};
function $46b8ab9ed5acde5f$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$46b8ab9ed5acde5f$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $46b8ab9ed5acde5f$var$byteLength(string, encoding) | 0;
    let buf = $46b8ab9ed5acde5f$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $46b8ab9ed5acde5f$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $46b8ab9ed5acde5f$var$checked(array.length) | 0;
    const buf = $46b8ab9ed5acde5f$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $46b8ab9ed5acde5f$var$fromArrayView(arrayView) {
    if ($46b8ab9ed5acde5f$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $46b8ab9ed5acde5f$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $46b8ab9ed5acde5f$var$fromArrayLike(arrayView);
}
function $46b8ab9ed5acde5f$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $46b8ab9ed5acde5f$var$Buffer.prototype);
    return buf;
}
function $46b8ab9ed5acde5f$var$fromObject(obj) {
    if ($46b8ab9ed5acde5f$var$Buffer.isBuffer(obj)) {
        const len = $46b8ab9ed5acde5f$var$checked(obj.length) | 0;
        const buf = $46b8ab9ed5acde5f$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $46b8ab9ed5acde5f$var$numberIsNaN(obj.length)) return $46b8ab9ed5acde5f$var$createBuffer(0);
        return $46b8ab9ed5acde5f$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $46b8ab9ed5acde5f$var$fromArrayLike(obj.data);
}
function $46b8ab9ed5acde5f$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $46b8ab9ed5acde5f$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $46b8ab9ed5acde5f$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $46b8ab9ed5acde5f$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $46b8ab9ed5acde5f$var$Buffer.alloc(+length);
}
$46b8ab9ed5acde5f$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $46b8ab9ed5acde5f$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$46b8ab9ed5acde5f$var$Buffer.compare = function compare(a, b) {
    if ($46b8ab9ed5acde5f$var$isInstance(a, Uint8Array)) a = $46b8ab9ed5acde5f$var$Buffer.from(a, a.offset, a.byteLength);
    if ($46b8ab9ed5acde5f$var$isInstance(b, Uint8Array)) b = $46b8ab9ed5acde5f$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$46b8ab9ed5acde5f$var$Buffer.isBuffer(a) || !$46b8ab9ed5acde5f$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$46b8ab9ed5acde5f$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$46b8ab9ed5acde5f$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $46b8ab9ed5acde5f$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $46b8ab9ed5acde5f$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($46b8ab9ed5acde5f$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$46b8ab9ed5acde5f$var$Buffer.isBuffer(buf)) buf = $46b8ab9ed5acde5f$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$46b8ab9ed5acde5f$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $46b8ab9ed5acde5f$var$byteLength(string, encoding) {
    if ($46b8ab9ed5acde5f$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $46b8ab9ed5acde5f$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $46b8ab9ed5acde5f$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $46b8ab9ed5acde5f$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $46b8ab9ed5acde5f$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$46b8ab9ed5acde5f$var$Buffer.byteLength = $46b8ab9ed5acde5f$var$byteLength;
function $46b8ab9ed5acde5f$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $46b8ab9ed5acde5f$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $46b8ab9ed5acde5f$var$utf8Slice(this, start, end);
        case "ascii":
            return $46b8ab9ed5acde5f$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $46b8ab9ed5acde5f$var$latin1Slice(this, start, end);
        case "base64":
            return $46b8ab9ed5acde5f$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $46b8ab9ed5acde5f$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$46b8ab9ed5acde5f$var$Buffer.prototype._isBuffer = true;
function $46b8ab9ed5acde5f$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$46b8ab9ed5acde5f$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$46b8ab9ed5acde5f$var$swap(this, i, i + 1);
    return this;
};
$46b8ab9ed5acde5f$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $46b8ab9ed5acde5f$var$swap(this, i, i + 3);
        $46b8ab9ed5acde5f$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$46b8ab9ed5acde5f$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $46b8ab9ed5acde5f$var$swap(this, i, i + 7);
        $46b8ab9ed5acde5f$var$swap(this, i + 1, i + 6);
        $46b8ab9ed5acde5f$var$swap(this, i + 2, i + 5);
        $46b8ab9ed5acde5f$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$46b8ab9ed5acde5f$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $46b8ab9ed5acde5f$var$utf8Slice(this, 0, length);
    return $46b8ab9ed5acde5f$var$slowToString.apply(this, arguments);
};
$46b8ab9ed5acde5f$var$Buffer.prototype.toLocaleString = $46b8ab9ed5acde5f$var$Buffer.prototype.toString;
$46b8ab9ed5acde5f$var$Buffer.prototype.equals = function equals(b) {
    if (!$46b8ab9ed5acde5f$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $46b8ab9ed5acde5f$var$Buffer.compare(this, b) === 0;
};
$46b8ab9ed5acde5f$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $46b8ab9ed5acde5f$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($46b8ab9ed5acde5f$var$customInspectSymbol) $46b8ab9ed5acde5f$var$Buffer.prototype[$46b8ab9ed5acde5f$var$customInspectSymbol] = $46b8ab9ed5acde5f$var$Buffer.prototype.inspect;
$46b8ab9ed5acde5f$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($46b8ab9ed5acde5f$var$isInstance(target, Uint8Array)) target = $46b8ab9ed5acde5f$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$46b8ab9ed5acde5f$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $46b8ab9ed5acde5f$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($46b8ab9ed5acde5f$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $46b8ab9ed5acde5f$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($46b8ab9ed5acde5f$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $46b8ab9ed5acde5f$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $46b8ab9ed5acde5f$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $46b8ab9ed5acde5f$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$46b8ab9ed5acde5f$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$46b8ab9ed5acde5f$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $46b8ab9ed5acde5f$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$46b8ab9ed5acde5f$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $46b8ab9ed5acde5f$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $46b8ab9ed5acde5f$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($46b8ab9ed5acde5f$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $46b8ab9ed5acde5f$var$utf8Write(buf, string, offset, length) {
    return $46b8ab9ed5acde5f$var$blitBuffer($46b8ab9ed5acde5f$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $46b8ab9ed5acde5f$var$asciiWrite(buf, string, offset, length) {
    return $46b8ab9ed5acde5f$var$blitBuffer($46b8ab9ed5acde5f$var$asciiToBytes(string), buf, offset, length);
}
function $46b8ab9ed5acde5f$var$base64Write(buf, string, offset, length) {
    return $46b8ab9ed5acde5f$var$blitBuffer($46b8ab9ed5acde5f$var$base64ToBytes(string), buf, offset, length);
}
function $46b8ab9ed5acde5f$var$ucs2Write(buf, string, offset, length) {
    return $46b8ab9ed5acde5f$var$blitBuffer($46b8ab9ed5acde5f$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$46b8ab9ed5acde5f$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $46b8ab9ed5acde5f$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $46b8ab9ed5acde5f$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $46b8ab9ed5acde5f$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $46b8ab9ed5acde5f$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $46b8ab9ed5acde5f$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$46b8ab9ed5acde5f$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $46b8ab9ed5acde5f$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $9f15c0b4b37a5ac3$export$6100ba28696e12de(buf);
    else return $9f15c0b4b37a5ac3$export$6100ba28696e12de(buf.slice(start, end));
}
function $46b8ab9ed5acde5f$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $46b8ab9ed5acde5f$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $46b8ab9ed5acde5f$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $46b8ab9ed5acde5f$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $46b8ab9ed5acde5f$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $46b8ab9ed5acde5f$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $46b8ab9ed5acde5f$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $46b8ab9ed5acde5f$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $46b8ab9ed5acde5f$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $46b8ab9ed5acde5f$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $46b8ab9ed5acde5f$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$46b8ab9ed5acde5f$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $46b8ab9ed5acde5f$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $46b8ab9ed5acde5f$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$46b8ab9ed5acde5f$var$Buffer.prototype.readUintLE = $46b8ab9ed5acde5f$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$46b8ab9ed5acde5f$var$Buffer.prototype.readUintBE = $46b8ab9ed5acde5f$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$46b8ab9ed5acde5f$var$Buffer.prototype.readUint8 = $46b8ab9ed5acde5f$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$46b8ab9ed5acde5f$var$Buffer.prototype.readUint16LE = $46b8ab9ed5acde5f$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$46b8ab9ed5acde5f$var$Buffer.prototype.readUint16BE = $46b8ab9ed5acde5f$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$46b8ab9ed5acde5f$var$Buffer.prototype.readUint32LE = $46b8ab9ed5acde5f$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$46b8ab9ed5acde5f$var$Buffer.prototype.readUint32BE = $46b8ab9ed5acde5f$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$46b8ab9ed5acde5f$var$Buffer.prototype.readBigUInt64LE = $46b8ab9ed5acde5f$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $46b8ab9ed5acde5f$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $46b8ab9ed5acde5f$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$46b8ab9ed5acde5f$var$Buffer.prototype.readBigUInt64BE = $46b8ab9ed5acde5f$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $46b8ab9ed5acde5f$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $46b8ab9ed5acde5f$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$46b8ab9ed5acde5f$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$46b8ab9ed5acde5f$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$46b8ab9ed5acde5f$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$46b8ab9ed5acde5f$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$46b8ab9ed5acde5f$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$46b8ab9ed5acde5f$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$46b8ab9ed5acde5f$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$46b8ab9ed5acde5f$var$Buffer.prototype.readBigInt64LE = $46b8ab9ed5acde5f$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $46b8ab9ed5acde5f$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $46b8ab9ed5acde5f$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$46b8ab9ed5acde5f$var$Buffer.prototype.readBigInt64BE = $46b8ab9ed5acde5f$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $46b8ab9ed5acde5f$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $46b8ab9ed5acde5f$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$46b8ab9ed5acde5f$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkOffset(offset, 4, this.length);
    return $da651c57892e471c$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$46b8ab9ed5acde5f$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkOffset(offset, 4, this.length);
    return $da651c57892e471c$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$46b8ab9ed5acde5f$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkOffset(offset, 8, this.length);
    return $da651c57892e471c$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$46b8ab9ed5acde5f$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkOffset(offset, 8, this.length);
    return $da651c57892e471c$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $46b8ab9ed5acde5f$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$46b8ab9ed5acde5f$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$46b8ab9ed5acde5f$var$Buffer.prototype.writeUintLE = $46b8ab9ed5acde5f$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $46b8ab9ed5acde5f$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$46b8ab9ed5acde5f$var$Buffer.prototype.writeUintBE = $46b8ab9ed5acde5f$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $46b8ab9ed5acde5f$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$46b8ab9ed5acde5f$var$Buffer.prototype.writeUint8 = $46b8ab9ed5acde5f$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$46b8ab9ed5acde5f$var$Buffer.prototype.writeUint16LE = $46b8ab9ed5acde5f$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$46b8ab9ed5acde5f$var$Buffer.prototype.writeUint16BE = $46b8ab9ed5acde5f$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$46b8ab9ed5acde5f$var$Buffer.prototype.writeUint32LE = $46b8ab9ed5acde5f$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$46b8ab9ed5acde5f$var$Buffer.prototype.writeUint32BE = $46b8ab9ed5acde5f$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $46b8ab9ed5acde5f$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $46b8ab9ed5acde5f$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $46b8ab9ed5acde5f$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $46b8ab9ed5acde5f$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$46b8ab9ed5acde5f$var$Buffer.prototype.writeBigUInt64LE = $46b8ab9ed5acde5f$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $46b8ab9ed5acde5f$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$46b8ab9ed5acde5f$var$Buffer.prototype.writeBigUInt64BE = $46b8ab9ed5acde5f$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $46b8ab9ed5acde5f$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$46b8ab9ed5acde5f$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $46b8ab9ed5acde5f$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$46b8ab9ed5acde5f$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $46b8ab9ed5acde5f$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$46b8ab9ed5acde5f$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$46b8ab9ed5acde5f$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$46b8ab9ed5acde5f$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$46b8ab9ed5acde5f$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$46b8ab9ed5acde5f$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$46b8ab9ed5acde5f$var$Buffer.prototype.writeBigInt64LE = $46b8ab9ed5acde5f$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $46b8ab9ed5acde5f$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$46b8ab9ed5acde5f$var$Buffer.prototype.writeBigInt64BE = $46b8ab9ed5acde5f$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $46b8ab9ed5acde5f$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $46b8ab9ed5acde5f$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $46b8ab9ed5acde5f$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $da651c57892e471c$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$46b8ab9ed5acde5f$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $46b8ab9ed5acde5f$var$writeFloat(this, value, offset, true, noAssert);
};
$46b8ab9ed5acde5f$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $46b8ab9ed5acde5f$var$writeFloat(this, value, offset, false, noAssert);
};
function $46b8ab9ed5acde5f$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $46b8ab9ed5acde5f$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $da651c57892e471c$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$46b8ab9ed5acde5f$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $46b8ab9ed5acde5f$var$writeDouble(this, value, offset, true, noAssert);
};
$46b8ab9ed5acde5f$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $46b8ab9ed5acde5f$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$46b8ab9ed5acde5f$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$46b8ab9ed5acde5f$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$46b8ab9ed5acde5f$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$46b8ab9ed5acde5f$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $46b8ab9ed5acde5f$var$Buffer.isBuffer(val) ? val : $46b8ab9ed5acde5f$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $46b8ab9ed5acde5f$var$errors = {};
function $46b8ab9ed5acde5f$var$E(sym, getMessage, Base) {
    $46b8ab9ed5acde5f$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$46b8ab9ed5acde5f$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$46b8ab9ed5acde5f$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$46b8ab9ed5acde5f$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $46b8ab9ed5acde5f$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $46b8ab9ed5acde5f$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $46b8ab9ed5acde5f$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $46b8ab9ed5acde5f$var$checkBounds(buf, offset, byteLength) {
    $46b8ab9ed5acde5f$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $46b8ab9ed5acde5f$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $46b8ab9ed5acde5f$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $46b8ab9ed5acde5f$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $46b8ab9ed5acde5f$var$checkBounds(buf, offset, byteLength);
}
function $46b8ab9ed5acde5f$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $46b8ab9ed5acde5f$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $46b8ab9ed5acde5f$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $46b8ab9ed5acde5f$var$validateNumber(value, type);
        throw new $46b8ab9ed5acde5f$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $46b8ab9ed5acde5f$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $46b8ab9ed5acde5f$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $46b8ab9ed5acde5f$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $46b8ab9ed5acde5f$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($46b8ab9ed5acde5f$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $46b8ab9ed5acde5f$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $46b8ab9ed5acde5f$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $46b8ab9ed5acde5f$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $46b8ab9ed5acde5f$var$base64ToBytes(str) {
    return $9f15c0b4b37a5ac3$export$d622b2ad8d90c771($46b8ab9ed5acde5f$var$base64clean(str));
}
function $46b8ab9ed5acde5f$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $46b8ab9ed5acde5f$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $46b8ab9ed5acde5f$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $46b8ab9ed5acde5f$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $46b8ab9ed5acde5f$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $46b8ab9ed5acde5f$var$BufferBigIntNotDefined : fn;
}
function $46b8ab9ed5acde5f$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}


var $8470289dbcea46c9$require$Buffer = $46b8ab9ed5acde5f$export$a143d493d941bafc;
"use strict";
const $8470289dbcea46c9$export$659081b45d03227d = 100;
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $8470289dbcea46c9$var$isVisitable(thing) {
    return (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $8470289dbcea46c9$var$removeBrackets(key) {
    return (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $8470289dbcea46c9$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $8470289dbcea46c9$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $8470289dbcea46c9$var$isFlatArray(arr) {
    return (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isArray(arr) && !arr.some($8470289dbcea46c9$var$isVisitable);
}
const $8470289dbcea46c9$var$predicates = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).toFlatObject((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $8470289dbcea46c9$var$toFormData(obj, formData, options) {
    if (!(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $4b784fc05ded8112$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const maxDepth = options.maxDepth === undefined ? $8470289dbcea46c9$export$659081b45d03227d : options.maxDepth;
    const useBlob = _Blob && (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    const stack = [];
    if (!(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039)("Blob is not supported. Use a Buffer instead.");
        if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isTypedArray(value)) {
            if (useBlob && typeof _Blob === "function") return new _Blob([
                value
            ]);
            if (typeof $8470289dbcea46c9$require$Buffer !== "undefined") return $8470289dbcea46c9$require$Buffer.from(value);
            throw new (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039)("Blob is not supported. Use a Buffer instead.", (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).ERR_NOT_SUPPORT);
        }
        return value;
    }
    function throwIfMaxDepthExceeded(depth) {
        if (depth > maxDepth) throw new (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039)("Object is too deeply nested (" + depth + " levels). Max depth: " + maxDepth, (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).ERR_FORM_DATA_DEPTH_EXCEEDED);
    }
    function stringifyWithDepthLimit(value, depth) {
        if (maxDepth === Infinity) return JSON.stringify(value);
        const ancestors = [];
        return JSON.stringify(value, function limitDepth(_key, currentValue) {
            if (!(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isObject(currentValue)) return currentValue;
            while(ancestors.length && ancestors[ancestors.length - 1] !== this)ancestors.pop();
            ancestors.push(currentValue);
            throwIfMaxDepthExceeded(depth + ancestors.length - 1);
            return currentValue;
        });
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isReactNative(formData) && (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isReactNativeBlob(value)) {
            formData.append($8470289dbcea46c9$var$renderKey(path, key, dots), convertValue(value));
            return false;
        }
        if (value && !path && typeof value === "object") {
            if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = stringifyWithDepthLimit(value, 1);
            } else if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isArray(value) && $8470289dbcea46c9$var$isFlatArray(value) || ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isFileList(value) || (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).endsWith(key, "[]")) && (arr = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $8470289dbcea46c9$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $8470289dbcea46c9$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($8470289dbcea46c9$var$isVisitable(value)) return true;
        formData.append($8470289dbcea46c9$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const exposedHelpers = Object.assign($8470289dbcea46c9$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $8470289dbcea46c9$var$isVisitable
    });
    function build(value, path, depth = 0) {
        if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isUndefined(value)) return;
        throwIfMaxDepthExceeded(depth);
        if (stack.indexOf(value) !== -1) throw new Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ], depth + 1);
        });
        stack.pop();
    }
    if (!(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $8470289dbcea46c9$export$2e2bcd8739ae039 = $8470289dbcea46c9$var$toFormData;


"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $2984ab788188fc29$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $2984ab788188fc29$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $8470289dbcea46c9$export$2e2bcd8739ae039)(params, this, options);
}
const $2984ab788188fc29$var$prototype = $2984ab788188fc29$var$AxiosURLSearchParams.prototype;
$2984ab788188fc29$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$2984ab788188fc29$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? (value)=>encoder.call(this, value, $2984ab788188fc29$var$encode) : $2984ab788188fc29$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $2984ab788188fc29$export$2e2bcd8739ae039 = $2984ab788188fc29$var$AxiosURLSearchParams;


"use strict";
function $9fdbd2405fb5a936$export$c564cdbbe6da493(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function $9fdbd2405fb5a936$export$2e2bcd8739ae039(url, params, options) {
    if (!params) return url;
    url = url || "";
    const _options = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isFunction(options) ? {
        serialize: options
    } : options;
    // Read serializer options pollution-safely: own properties and methods on a
    // class/template prototype are honored, but values injected onto a polluted
    // Object.prototype are ignored.
    const _encode = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).getSafeProp(_options, "encode") || $9fdbd2405fb5a936$export$c564cdbbe6da493;
    const serializeFn = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).getSafeProp(_options, "serialize");
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, _options);
    else serializedParams = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $2984ab788188fc29$export$2e2bcd8739ae039)(params, _options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}



"use strict";
class $f212a01b1e58726a$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $f212a01b1e58726a$export$2e2bcd8739ae039 = $f212a01b1e58726a$var$InterceptorManager;





"use strict";
var $76ece2fc1dbc15e7$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false,
    legacyInterceptorReqResOrdering: true,
    advertiseZstdAcceptEncoding: false,
    validateStatusUndefinedResolves: true
};






"use strict";
var $edc0ec2fa4fda0f2$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $2984ab788188fc29$export$2e2bcd8739ae039);


"use strict";
var $011e1ac7a2545910$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;


"use strict";
var $94b766e74d8de5cc$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;


var $a0f199a78f0a0f37$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $edc0ec2fa4fda0f2$export$2e2bcd8739ae039,
        FormData: $011e1ac7a2545910$export$2e2bcd8739ae039,
        Blob: $94b766e74d8de5cc$export$2e2bcd8739ae039
    },
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};


var $203661fd244d1f21$exports = {};

$parcel$export($203661fd244d1f21$exports, "hasBrowserEnv", function () { return $203661fd244d1f21$export$c4996c4b7b93b0bf; });
$parcel$export($203661fd244d1f21$exports, "navigator", function () { return $203661fd244d1f21$export$ec7c8efa7f5790ae; });
$parcel$export($203661fd244d1f21$exports, "hasStandardBrowserEnv", function () { return $203661fd244d1f21$export$c0bcc9250309d66; });
$parcel$export($203661fd244d1f21$exports, "hasStandardBrowserWebWorkerEnv", function () { return $203661fd244d1f21$export$c81692cf5af97dac; });
$parcel$export($203661fd244d1f21$exports, "origin", function () { return $203661fd244d1f21$export$f710a83a91838a36; });
const $203661fd244d1f21$export$c4996c4b7b93b0bf = typeof window !== "undefined" && typeof document !== "undefined";
const $203661fd244d1f21$export$ec7c8efa7f5790ae = typeof navigator === "object" && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $203661fd244d1f21$export$c0bcc9250309d66 = $203661fd244d1f21$export$c4996c4b7b93b0bf && (!$203661fd244d1f21$export$ec7c8efa7f5790ae || [
    "ReactNative",
    "NativeScript",
    "NS"
].indexOf($203661fd244d1f21$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $203661fd244d1f21$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();
const $203661fd244d1f21$export$f710a83a91838a36 = $203661fd244d1f21$export$c4996c4b7b93b0bf && window.location.href || "http://localhost";


var $cce75ba43a375f9c$export$2e2bcd8739ae039 = {
    ...$203661fd244d1f21$exports,
    ...(0, $a0f199a78f0a0f37$export$2e2bcd8739ae039)
};


"use strict";
function $11bf77d4b4b7132f$export$2e2bcd8739ae039(data, options) {
    return (0, $8470289dbcea46c9$export$2e2bcd8739ae039)(data, new (0, $cce75ba43a375f9c$export$2e2bcd8739ae039).classes.URLSearchParams(), {
        visitor: function(value, key, path, helpers) {
            if ((0, $cce75ba43a375f9c$export$2e2bcd8739ae039).isNode && (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        },
        ...options
    });
}






"use strict";
const $b89d98899f472588$var$MAX_DEPTH = (0, $8470289dbcea46c9$export$659081b45d03227d);
function $b89d98899f472588$var$throwIfDepthExceeded(index) {
    if (index > $b89d98899f472588$var$MAX_DEPTH) throw new (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039)("FormData field is too deeply nested (" + index + " levels). Max depth: " + $b89d98899f472588$var$MAX_DEPTH, (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).ERR_FORM_DATA_DEPTH_EXCEEDED);
}
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $b89d98899f472588$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    const path = [];
    const pattern = /\w+|\[(\w*)]/g;
    let match;
    while((match = pattern.exec(name)) !== null){
        $b89d98899f472588$var$throwIfDepthExceeded(path.length);
        path.push(match[0] === "[]" ? "" : match[1] || match[0]);
    }
    return path;
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $b89d98899f472588$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $b89d98899f472588$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        $b89d98899f472588$var$throwIfDepthExceeded(index);
        let name = path[index++];
        if (name === "__proto__") return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isArray(target[name]) ? target[name].concat(value) : [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).hasOwnProp(target, name) || !(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $b89d98899f472588$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isFormData(formData) && (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($b89d98899f472588$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $b89d98899f472588$export$2e2bcd8739ae039 = $b89d98899f472588$var$formDataToJSON;


"use strict";
const $184c4cdd344f1efc$var$own = (obj, key)=>obj != null && (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).hasOwnProp(obj, key) ? obj[key] : undefined;
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $184c4cdd344f1efc$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $184c4cdd344f1efc$var$defaults = {
    transitional: (0, $76ece2fc1dbc15e7$export$2e2bcd8739ae039),
    adapter: [
        "xhr",
        "http",
        "fetch"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $b89d98899f472588$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isBuffer(data) || (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isStream(data) || (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isFile(data) || (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isBlob(data) || (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                const formSerializer = $184c4cdd344f1efc$var$own(this, "formSerializer");
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $11bf77d4b4b7132f$export$2e2bcd8739ae039)(data, formSerializer).toString();
                if ((isFileList = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const env = $184c4cdd344f1efc$var$own(this, "env");
                    const _FormData = env && env.FormData;
                    return (0, $8470289dbcea46c9$export$2e2bcd8739ae039)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $184c4cdd344f1efc$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = $184c4cdd344f1efc$var$own(this, "transitional") || $184c4cdd344f1efc$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const responseType = $184c4cdd344f1efc$var$own(this, "responseType");
            const JSONRequested = responseType === "json";
            if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isResponse(data) || (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, $184c4cdd344f1efc$var$own(this, "parseReviver"));
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).from(e, (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, $184c4cdd344f1efc$var$own(this, "response"));
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $cce75ba43a375f9c$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $cce75ba43a375f9c$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch",
    "query"
], (method)=>{
    $184c4cdd344f1efc$var$defaults.headers[method] = {};
});
var $184c4cdd344f1efc$export$2e2bcd8739ae039 = $184c4cdd344f1efc$var$defaults;



"use strict";
function $80af61ecafd50432$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $184c4cdd344f1efc$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $f2bfae2f47cdd2a8$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


"use strict";
function $6e6cee9820798cde$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}




"use strict";
class $a5df0d634bea0233$var$CanceledError extends (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039) {
    /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */ constructor(message, config, request){
        super(message == null ? "canceled" : message, (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
        this.name = "CanceledError";
        this.__CANCEL__ = true;
    }
}
var $a5df0d634bea0233$export$2e2bcd8739ae039 = $a5df0d634bea0233$var$CanceledError;







"use strict";
function $689903c39f023422$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039)("Request failed with status code " + response.status, response.status >= 400 && response.status < 500 ? (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).ERR_BAD_REQUEST : (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, response.config, response.request, response));
}





"use strict";
function $16df5e6ad05e5e91$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25}):(?:\/\/)?/.exec(url);
    return match && match[1] || "";
}




"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $1a263c1daccc761b$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $1a263c1daccc761b$export$2e2bcd8739ae039 = $1a263c1daccc761b$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $c1a93cb7d352d968$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $c1a93cb7d352d968$export$2e2bcd8739ae039 = $c1a93cb7d352d968$var$throttle;



const $574ee5c20ce465fe$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $1a263c1daccc761b$export$2e2bcd8739ae039)(50, 250);
    return (0, $c1a93cb7d352d968$export$2e2bcd8739ae039)((e)=>{
        if (!e || typeof e.loaded !== "number") return;
        const rawLoaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const loaded = total != null ? Math.min(rawLoaded, total) : rawLoaded;
        const progressBytes = Math.max(0, loaded - bytesNotified);
        const rate = _speedometer(progressBytes);
        bytesNotified = Math.max(bytesNotified, loaded);
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? "download" : "upload"]: true
        };
        listener(data);
    }, freq);
};
const $574ee5c20ce465fe$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $574ee5c20ce465fe$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).asap(()=>fn(...args));






var $54cb450fa094077a$export$2e2bcd8739ae039 = (0, $cce75ba43a375f9c$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $cce75ba43a375f9c$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $cce75ba43a375f9c$export$2e2bcd8739ae039).origin), (0, $cce75ba43a375f9c$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $cce75ba43a375f9c$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $0c2a5c079e8404e1$export$2e2bcd8739ae039 = (0, $cce75ba43a375f9c$export$2e2bcd8739ae039).hasStandardBrowserEnv ? {
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === "undefined") return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isString(path)) cookie.push(`path=${path}`);
        if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push("secure");
        if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join("; ");
    },
    read (name) {
        if (typeof document === "undefined") return null;
        // Match name=value by splitting on the semicolon separator instead of building a
        // RegExp from `name` — interpolating an unescaped string into a RegExp would let
        // metacharacters (e.g. `.+?` in an attacker-influenced cookie name) cause ReDoS or
        // match the wrong cookie. Browsers may serialize cookie pairs as either ";" or
        // "; ", so ignore optional whitespace before each cookie name.
        const cookies = document.cookie.split(";");
        for(let i = 0; i < cookies.length; i++){
            const cookie = cookies[i].replace(/^\s+/, "");
            const eq = cookie.indexOf("=");
            if (eq !== -1 && cookie.slice(0, eq) === name) try {
                return decodeURIComponent(cookie.slice(eq + 1));
            } catch (e) {
                return cookie.slice(eq + 1);
            }
        }
        return null;
    },
    remove (name) {
        this.write(name, "", Date.now() - 86400000, "/");
    }
} : {
    write () {},
    read () {
        return null;
    },
    remove () {}
};



"use strict";
function $7d7627e70192e49a$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    if (typeof url !== "string") return false;
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


"use strict";
function $a9b1899b57910fee$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}


"use strict";
const $6361e242ceddf2ba$var$malformedHttpProtocol = /^https?:(?!\/\/)/i;
const $6361e242ceddf2ba$var$httpProtocolControlCharacters = /[\t\n\r]/g;
function $6361e242ceddf2ba$var$stripLeadingC0ControlOrSpace(url) {
    let i = 0;
    while(i < url.length && url.charCodeAt(i) <= 0x20)i++;
    return url.slice(i);
}
function $6361e242ceddf2ba$var$normalizeURLForProtocolCheck(url) {
    return $6361e242ceddf2ba$var$stripLeadingC0ControlOrSpace(url).replace($6361e242ceddf2ba$var$httpProtocolControlCharacters, "");
}
function $6361e242ceddf2ba$var$assertValidHttpProtocolURL(url, config) {
    if (typeof url === "string" && $6361e242ceddf2ba$var$malformedHttpProtocol.test($6361e242ceddf2ba$var$normalizeURLForProtocolCheck(url))) throw new (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039)('Invalid URL: missing "//" after protocol', (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).ERR_INVALID_URL, config);
}
function $6361e242ceddf2ba$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls, config) {
    $6361e242ceddf2ba$var$assertValidHttpProtocolURL(requestedURL, config);
    let isRelativeUrl = !(0, $7d7627e70192e49a$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls === false)) {
        $6361e242ceddf2ba$var$assertValidHttpProtocolURL(baseURL, config);
        return (0, $a9b1899b57910fee$export$2e2bcd8739ae039)(baseURL, requestedURL);
    }
    return requestedURL;
}




"use strict";
const $30616137bb4dc682$var$headersToObject = (thing)=>thing instanceof (0, $f2bfae2f47cdd2a8$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $30616137bb4dc682$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config1 = config1 || {};
    config2 = config2 || {};
    // Use a null-prototype object so that downstream reads such as `config.auth`
    // or `config.baseURL` cannot inherit polluted values from Object.prototype.
    // `hasOwnProperty` is restored as a non-enumerable own slot to preserve
    // ergonomics for user code that relies on it.
    const config = Object.create(null);
    Object.defineProperty(config, "hasOwnProperty", {
        // Null-proto descriptor so a polluted Object.prototype.get cannot turn
        // this data descriptor into an accessor descriptor on the way in.
        __proto__: null,
        value: Object.prototype.hasOwnProperty,
        enumerable: false,
        writable: true,
        configurable: true
    });
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isPlainObject(target) && (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    function getMergedTransitionalOption(prop) {
        const transitional2 = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).hasOwnProp(config2, "transitional") ? config2.transitional : undefined;
        if (!(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isUndefined(transitional2)) {
            if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isPlainObject(transitional2)) {
                if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).hasOwnProp(transitional2, prop)) return transitional2[prop];
            } else return undefined;
        }
        const transitional1 = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).hasOwnProp(config1, "transitional") ? config1.transitional : undefined;
        if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isPlainObject(transitional1) && (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).hasOwnProp(transitional1, prop)) return transitional1[prop];
        return undefined;
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).hasOwnProp(config2, prop)) return getMergedValue(a, b);
        else if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).hasOwnProp(config1, prop)) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        allowedSocketPaths: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($30616137bb4dc682$var$headersToObject(a), $30616137bb4dc682$var$headersToObject(b), prop, true)
    };
    (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).forEach(Object.keys({
        ...config1,
        ...config2
    }), function computeConfigValue(prop) {
        if (prop === "__proto__" || prop === "constructor" || prop === "prototype") return;
        const merge = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        const a = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).hasOwnProp(config1, prop) ? config1[prop] : undefined;
        const b = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).hasOwnProp(config2, prop) ? config2[prop] : undefined;
        const configValue = merge(a, b, prop);
        (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).hasOwnProp(config2, "validateStatus") && (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isUndefined(config2.validateStatus) && getMergedTransitionalOption("validateStatusUndefinedResolves") === false) {
        if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).hasOwnProp(config1, "validateStatus")) config.validateStatus = getMergedValue(undefined, config1.validateStatus);
        else delete config.validateStatus;
    }
    return config;
}




const $2e7700064c1edbb3$var$FORM_DATA_CONTENT_HEADERS = [
    "content-type",
    "content-length"
];
function $2e7700064c1edbb3$var$setFormDataHeaders(headers, formHeaders, policy) {
    if (policy !== "content-only") {
        headers.set(formHeaders);
        return;
    }
    Object.entries(formHeaders || {}).forEach(([key, val])=>{
        if ($2e7700064c1edbb3$var$FORM_DATA_CONTENT_HEADERS.includes(key.toLowerCase())) headers.set(key, val);
    });
}
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $2e7700064c1edbb3$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
function $2e7700064c1edbb3$var$resolveConfig(config) {
    const newConfig = (0, $30616137bb4dc682$export$2e2bcd8739ae039)({}, config);
    // Read only own properties to prevent prototype pollution gadgets
    // (e.g. Object.prototype.baseURL = 'https://evil.com').
    const own = (key)=>(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).hasOwnProp(newConfig, key) ? newConfig[key] : undefined;
    const data = own("data");
    let withXSRFToken = own("withXSRFToken");
    const xsrfHeaderName = own("xsrfHeaderName");
    const xsrfCookieName = own("xsrfCookieName");
    let headers = own("headers");
    const auth = own("auth");
    const baseURL = own("baseURL");
    const allowAbsoluteUrls = own("allowAbsoluteUrls");
    const url = own("url");
    newConfig.headers = headers = (0, $f2bfae2f47cdd2a8$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $9fdbd2405fb5a936$export$2e2bcd8739ae039)((0, $6361e242ceddf2ba$export$2e2bcd8739ae039)(baseURL, url, allowAbsoluteUrls, newConfig), own("params"), own("paramsSerializer"));
    // HTTP basic authentication
    if (auth) {
        const username = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).getSafeProp(auth, "username") || "";
        const password = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).getSafeProp(auth, "password") || "";
        try {
            headers.set("Authorization", "Basic " + btoa(username + ":" + (password ? $2e7700064c1edbb3$var$encodeUTF8(password) : "")));
        } catch (e) {
            throw (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).from(e, (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE, config);
        }
    }
    if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $cce75ba43a375f9c$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $cce75ba43a375f9c$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv || (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isReactNative(data)) headers.setContentType(undefined); // browser/web worker/RN handles it
        else if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isFunction(data.getHeaders)) // Node.js FormData (like form-data package)
        $2e7700064c1edbb3$var$setFormDataHeaders(headers, data.getHeaders(), own("formDataHeaderPolicy"));
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $cce75ba43a375f9c$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isFunction(withXSRFToken)) withXSRFToken = withXSRFToken(newConfig);
        // Strict boolean check — prevents proto-pollution gadgets (e.g. Object.prototype.withXSRFToken = 1)
        // and misconfigurations (e.g. "false") from short-circuiting the same-origin check and leaking
        // the XSRF token cross-origin.
        const shouldSendXSRF = withXSRFToken === true || withXSRFToken == null && (0, $54cb450fa094077a$export$2e2bcd8739ae039)(newConfig.url);
        if (shouldSendXSRF) {
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $0c2a5c079e8404e1$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
}
var $2e7700064c1edbb3$export$2e2bcd8739ae039 = $2e7700064c1edbb3$var$resolveConfig;



const $d113720e80db7587$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $d113720e80db7587$export$2e2bcd8739ae039 = $d113720e80db7587$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $2e7700064c1edbb3$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $f2bfae2f47cdd2a8$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener("abort", onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $f2bfae2f47cdd2a8$export$2e2bcd8739ae039).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $689903c39f023422$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.startsWith("file:"))) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039)("Request aborted", (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : "Network Error";
            const err = new (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039)(msg, (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            done();
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? "timeout of " + _config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = _config.transitional || (0, $76ece2fc1dbc15e7$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).ETIMEDOUT : (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).forEach((0, $fedefcd4ca7e05ca$export$c30c72bb7e677d54)(requestHeaders), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $574ee5c20ce465fe$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener("progress", downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $574ee5c20ce465fe$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener("progress", uploadThrottled);
            request.upload.addEventListener("loadend", flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $a5df0d634bea0233$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                done();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $16df5e6ad05e5e91$export$2e2bcd8739ae039)(_config.url);
        if (protocol && !(0, $cce75ba43a375f9c$export$2e2bcd8739ae039).protocols.includes(protocol)) {
            reject(new (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039)("Unsupported protocol " + protocol + ":", (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            done();
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $8e0bffe21a94187f$var$composeSignals = (signals, timeout)=>{
    signals = signals ? signals.filter(Boolean) : [];
    if (!timeout && !signals.length) return;
    const controller = new AbortController();
    let aborted = false;
    const onabort = function(reason) {
        if (!aborted) {
            aborted = true;
            unsubscribe();
            const err = reason instanceof Error ? reason : this.reason;
            controller.abort(err instanceof (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039) ? err : new (0, $a5df0d634bea0233$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
        }
    };
    let timer = timeout && setTimeout(()=>{
        timer = null;
        onabort(new (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039)(`timeout of ${timeout}ms exceeded`, (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).ETIMEDOUT));
    }, timeout);
    const unsubscribe = ()=>{
        if (!signals) return;
        timer && clearTimeout(timer);
        timer = null;
        signals.forEach((signal)=>{
            signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener("abort", onabort);
        });
        signals = null;
    };
    signals.forEach((signal)=>signal.addEventListener("abort", onabort, {
            once: true
        }));
    const { signal: signal } = controller;
    signal.unsubscribe = ()=>(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).asap(unsubscribe);
    return signal;
};
var $8e0bffe21a94187f$export$2e2bcd8739ae039 = $8e0bffe21a94187f$var$composeSignals;


const $ccf1b4b4dd341368$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $ccf1b4b4dd341368$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $ccf1b4b4dd341368$var$readStream(iterable))yield* $ccf1b4b4dd341368$export$71b051935044bd5d(chunk, chunkSize);
};
const $ccf1b4b4dd341368$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $ccf1b4b4dd341368$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $ccf1b4b4dd341368$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






/**
 * Estimate decoded byte length of a data:// URL *without* allocating large buffers.
 * - For base64: compute exact decoded size using length and padding;
 *               handle %XX at the character-count level (no string allocation).
 * - For non-base64: compute the exact percent-decoded UTF-8 byte length.
 *
 * @param {string} url
 * @returns {number}
 */ const $64ab4e5d2b8b685e$var$isHexDigit = (charCode)=>charCode >= 48 && charCode <= 57 || charCode >= 65 && charCode <= 70 || charCode >= 97 && charCode <= 102;
const $64ab4e5d2b8b685e$var$isPercentEncodedByte = (str, i, len)=>i + 2 < len && $64ab4e5d2b8b685e$var$isHexDigit(str.charCodeAt(i + 1)) && $64ab4e5d2b8b685e$var$isHexDigit(str.charCodeAt(i + 2));
function $64ab4e5d2b8b685e$export$2e2bcd8739ae039(url) {
    if (!url || typeof url !== "string") return 0;
    if (!url.startsWith("data:")) return 0;
    const comma = url.indexOf(",");
    if (comma < 0) return 0;
    const meta = url.slice(5, comma);
    const body = url.slice(comma + 1);
    const isBase64 = /;base64/i.test(meta);
    if (isBase64) {
        let effectiveLen = body.length;
        const len = body.length; // cache length
        for(let i = 0; i < len; i++)if (body.charCodeAt(i) === 37 /* '%' */  && i + 2 < len) {
            const a = body.charCodeAt(i + 1);
            const b = body.charCodeAt(i + 2);
            const isHex = $64ab4e5d2b8b685e$var$isHexDigit(a) && $64ab4e5d2b8b685e$var$isHexDigit(b);
            if (isHex) {
                effectiveLen -= 2;
                i += 2;
            }
        }
        let pad = 0;
        let idx = len - 1;
        const tailIsPct3D = (j)=>j >= 2 && body.charCodeAt(j - 2) === 37 && // '%'
            body.charCodeAt(j - 1) === 51 && // '3'
            (body.charCodeAt(j) === 68 || body.charCodeAt(j) === 100); // 'D' or 'd'
        if (idx >= 0) {
            if (body.charCodeAt(idx) === 61 /* '=' */ ) {
                pad++;
                idx--;
            } else if (tailIsPct3D(idx)) {
                pad++;
                idx -= 3;
            }
        }
        if (pad === 1 && idx >= 0) {
            if (body.charCodeAt(idx) === 61 /* '=' */ ) pad++;
            else if (tailIsPct3D(idx)) pad++;
        }
        const groups = Math.floor(effectiveLen / 4);
        const bytes = groups * 3 - (pad || 0);
        return bytes > 0 ? bytes : 0;
    }
    // Compute UTF-8 byte length directly from UTF-16 code units without allocating
    // a byte buffer (TextEncoder.encode would defeat the DoS guard on large bodies).
    // Valid %XX triplets count as one decoded byte; this matches the bytes that
    // decodeURIComponent(body) would produce before Buffer re-encodes the string.
    let bytes = 0;
    for(let i = 0, len = body.length; i < len; i++){
        const c = body.charCodeAt(i);
        if (c === 37 /* '%' */  && $64ab4e5d2b8b685e$var$isPercentEncodedByte(body, i, len)) {
            bytes += 1;
            i += 2;
        } else if (c < 0x80) bytes += 1;
        else if (c < 0x800) bytes += 2;
        else if (c >= 0xd800 && c <= 0xdbff && i + 1 < len) {
            const next = body.charCodeAt(i + 1);
            if (next >= 0xdc00 && next <= 0xdfff) {
                bytes += 4;
                i++;
            } else bytes += 3;
        } else bytes += 3;
    }
    return bytes;
}


const $6abdf23ff0a1f127$export$a4ad2735b021c132 = "1.18.1";



const $dfd83a5db13fb7d7$var$DEFAULT_CHUNK_SIZE = 65536;
const { isFunction: $dfd83a5db13fb7d7$var$isFunction } = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039);
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $dfd83a5db13fb7d7$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
// Node's WHATWG URL parser returns `username` and `password` percent-encoded.
// Decode before composing the `auth` option so credentials such as
// `my%40email.com:pass` are sent as `my@email.com:pass`. Falls back to the
// original value for malformed input so a bad encoding never throws.
const $dfd83a5db13fb7d7$var$decodeURIComponentSafe = (value)=>{
    if (!(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isString(value)) return value;
    try {
        return decodeURIComponent(value);
    } catch (error) {
        return value;
    }
};
const $dfd83a5db13fb7d7$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $dfd83a5db13fb7d7$var$maybeWithAuthCredentials = (url)=>{
    const protocolIndex = url.indexOf("://");
    let urlToCheck = url;
    if (protocolIndex !== -1) urlToCheck = urlToCheck.slice(protocolIndex + 3);
    return urlToCheck.includes("@") || urlToCheck.includes(":");
};
const $dfd83a5db13fb7d7$var$factory = (env)=>{
    const globalObject = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).global !== undefined && (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).global !== null ? (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).global : globalThis;
    const { ReadableStream: ReadableStream, TextEncoder: TextEncoder } = globalObject;
    env = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).merge.call({
        skipUndefined: true
    }, {
        Request: globalObject.Request,
        Response: globalObject.Response
    }, env);
    const { fetch: envFetch, Request: Request, Response: Response } = env;
    const isFetchSupported = envFetch ? $dfd83a5db13fb7d7$var$isFunction(envFetch) : typeof fetch === "function";
    const isRequestSupported = $dfd83a5db13fb7d7$var$isFunction(Request);
    const isResponseSupported = $dfd83a5db13fb7d7$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $dfd83a5db13fb7d7$var$isFunction(ReadableStream);
    const encodeText = isFetchSupported && (typeof TextEncoder === "function" ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $dfd83a5db13fb7d7$var$test(()=>{
        let duplexAccessed = false;
        const request = new Request((0, $cce75ba43a375f9c$export$2e2bcd8739ae039).origin, {
            body: new ReadableStream(),
            method: "POST",
            get duplex () {
                duplexAccessed = true;
                return "half";
            }
        });
        const hasContentType = request.headers.has("Content-Type");
        if (request.body != null) request.body.cancel();
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $dfd83a5db13fb7d7$var$test(()=>(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isReadableStream(new Response("").body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            "text",
            "arrayBuffer",
            "blob",
            "formData",
            "stream"
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isBlob(body)) return body.size;
        if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
            const _request = new Request((0, $cce75ba43a375f9c$export$2e2bcd8739ae039).origin, {
                method: "POST",
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
        if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + "";
        if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = "same-origin", fetchOptions: fetchOptions, maxContentLength: maxContentLength, maxBodyLength: maxBodyLength } = (0, $2e7700064c1edbb3$export$2e2bcd8739ae039)(config);
        const hasMaxContentLength = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isNumber(maxContentLength) && maxContentLength > -1;
        const hasMaxBodyLength = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isNumber(maxBodyLength) && maxBodyLength > -1;
        const own = (key)=>(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).hasOwnProp(config, key) ? config[key] : undefined;
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + "").toLowerCase() : "text";
        let composedSignal = (0, $8e0bffe21a94187f$export$2e2bcd8739ae039)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        // AxiosError we raise while the request body is being streamed. Captured
        // by identity so the catch block can surface it directly, regardless of
        // how the runtime wraps the resulting fetch rejection (undici exposes it
        // as `err.cause`; some browsers drop the original error entirely).
        let pendingBodyError = null;
        const maxBodyLengthError = ()=>new (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039)("Request body larger than maxBodyLength limit", (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config, request);
        try {
            // HTTP basic authentication
            let auth = undefined;
            const configAuth = own("auth");
            if (configAuth) {
                const username = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).getSafeProp(configAuth, "username") || "";
                const password = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).getSafeProp(configAuth, "password") || "";
                auth = {
                    username: username,
                    password: password
                };
            }
            if ($dfd83a5db13fb7d7$var$maybeWithAuthCredentials(url)) {
                const parsedURL = new URL(url, (0, $cce75ba43a375f9c$export$2e2bcd8739ae039).origin);
                if (!auth && (parsedURL.username || parsedURL.password)) {
                    const urlUsername = $dfd83a5db13fb7d7$var$decodeURIComponentSafe(parsedURL.username);
                    const urlPassword = $dfd83a5db13fb7d7$var$decodeURIComponentSafe(parsedURL.password);
                    auth = {
                        username: urlUsername,
                        password: urlPassword
                    };
                }
                if (parsedURL.username || parsedURL.password) {
                    parsedURL.username = "";
                    parsedURL.password = "";
                    url = parsedURL.href;
                }
            }
            if (auth) {
                headers.delete("authorization");
                headers.set("Authorization", "Basic " + btoa($dfd83a5db13fb7d7$var$encodeUTF8((auth.username || "") + ":" + (auth.password || ""))));
            }
            // Enforce maxContentLength for data: URLs up-front so we never materialize
            // an oversized payload. The HTTP adapter applies the same check (see http.js
            // "if (protocol === 'data:')" branch).
            if (hasMaxContentLength && typeof url === "string" && url.startsWith("data:")) {
                const estimated = (0, $64ab4e5d2b8b685e$export$2e2bcd8739ae039)(url);
                if (estimated > maxContentLength) throw new (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039)("maxContentLength size of " + maxContentLength + " exceeded", (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            // Enforce maxBodyLength against known-size bodies before dispatch using
            // the body's *actual* size — never a caller-declared Content-Length,
            // which could under-report to slip an oversized body past the check.
            // Unknown-size streams return undefined here and are counted per-chunk
            // below as fetch consumes them.
            if (hasMaxBodyLength && method !== "get" && method !== "head") {
                const outboundLength = await getBodyLength(data);
                if (typeof outboundLength === "number" && isFinite(outboundLength)) {
                    requestContentLength = outboundLength;
                    if (outboundLength > maxBodyLength) throw maxBodyLengthError();
                }
            }
            // A streamed body under maxBodyLength must be counted as fetch consumes
            // it; its size is never trusted from a caller-declared Content-Length.
            const mustEnforceStreamBody = hasMaxBodyLength && ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isReadableStream(data) || (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isStream(data));
            const trackRequestStream = (stream, onProgress, flush)=>(0, $ccf1b4b4dd341368$export$b0119225647bd83)(stream, $dfd83a5db13fb7d7$var$DEFAULT_CHUNK_SIZE, (loadedBytes)=>{
                    if (hasMaxBodyLength && loadedBytes > maxBodyLength) throw pendingBodyError = maxBodyLengthError();
                    onProgress && onProgress(loadedBytes);
                }, flush);
            if (supportsRequestStream && method !== "get" && method !== "head" && (onUploadProgress || mustEnforceStreamBody)) {
                requestContentLength = requestContentLength == null ? await resolveBodyLength(headers, data) : requestContentLength;
                // A declared length of 0 is only trusted to skip the wrap when we are
                // not enforcing a stream limit (which must not rely on that header).
                if (requestContentLength !== 0 || mustEnforceStreamBody) {
                    let _request = new Request(url, {
                        method: "POST",
                        body: data,
                        duplex: "half"
                    });
                    let contentTypeHeader;
                    if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get("content-type"))) headers.setContentType(contentTypeHeader);
                    if (_request.body) {
                        const [onProgress, flush] = onUploadProgress && (0, $574ee5c20ce465fe$export$d9fadd12586c18d6)(requestContentLength, (0, $574ee5c20ce465fe$export$c1b28109d46c3592)((0, $574ee5c20ce465fe$export$5d35863c355a22a9)(onUploadProgress))) || [];
                        data = trackRequestStream(_request.body, onProgress, flush);
                    }
                }
            } else if (mustEnforceStreamBody && !isRequestSupported && isReadableStreamSupported && method !== "get" && method !== "head") data = trackRequestStream(data);
            else if (mustEnforceStreamBody && isRequestSupported && !supportsRequestStream && method !== "get" && method !== "head") throw new (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039)("Stream request bodies are not supported by the current fetch implementation", (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config, request);
            if (!(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? "include" : "omit";
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && "credentials" in Request.prototype;
            // If data is FormData and Content-Type is multipart/form-data without boundary,
            // delete it so fetch can set it correctly with the boundary
            if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isFormData(data)) {
                const contentType = headers.getContentType();
                if (contentType && /^multipart\/form-data/i.test(contentType) && !/boundary=/i.test(contentType)) headers.delete("content-type");
            }
            // Set User-Agent header if not already set (fetch defaults to 'node' in Node.js)
            headers.set("User-Agent", "axios/" + (0, $6abdf23ff0a1f127$export$a4ad2735b021c132), false);
            const resolvedOptions = {
                ...fetchOptions,
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: (0, $fedefcd4ca7e05ca$export$c30c72bb7e677d54)(headers.normalize()),
                body: data,
                duplex: "half",
                credentials: isCredentialsSupported ? withCredentials : undefined
            };
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, fetchOptions) : _fetch(url, resolvedOptions));
            const responseHeaders = (0, $f2bfae2f47cdd2a8$export$2e2bcd8739ae039).from(response.headers);
            // Cheap pre-check: if the server honestly declares a content-length that
            // already exceeds the cap, reject before we start streaming.
            if (hasMaxContentLength) {
                const declaredLength = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).toFiniteNumber(responseHeaders.getContentLength());
                if (declaredLength != null && declaredLength > maxContentLength) throw new (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039)("maxContentLength size of " + maxContentLength + " exceeded", (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            const isStreamResponse = supportsResponseStream && (responseType === "stream" || responseType === "response");
            if (supportsResponseStream && response.body && (onDownloadProgress || hasMaxContentLength || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    "status",
                    "statusText",
                    "headers"
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).toFiniteNumber(responseHeaders.getContentLength());
                const [onProgress, flush] = onDownloadProgress && (0, $574ee5c20ce465fe$export$d9fadd12586c18d6)(responseContentLength, (0, $574ee5c20ce465fe$export$c1b28109d46c3592)((0, $574ee5c20ce465fe$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
                let bytesRead = 0;
                const onChunkProgress = (loadedBytes)=>{
                    if (hasMaxContentLength) {
                        bytesRead = loadedBytes;
                        if (bytesRead > maxContentLength) throw new (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039)("maxContentLength size of " + maxContentLength + " exceeded", (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
                    }
                    onProgress && onProgress(loadedBytes);
                };
                response = new Response((0, $ccf1b4b4dd341368$export$b0119225647bd83)(response.body, $dfd83a5db13fb7d7$var$DEFAULT_CHUNK_SIZE, onChunkProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || "text";
            let responseData = await resolvers[(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).findKey(resolvers, responseType) || "text"](response, config);
            // Fallback enforcement for environments without ReadableStream support
            // (legacy runtimes). Detect materialized size from typed output; skip
            // streams/Response passthrough since the user will read those themselves.
            if (hasMaxContentLength && !supportsResponseStream && !isStreamResponse) {
                let materializedSize;
                if (responseData != null) {
                    if (typeof responseData.byteLength === "number") materializedSize = responseData.byteLength;
                    else if (typeof responseData.size === "number") materializedSize = responseData.size;
                    else if (typeof responseData === "string") materializedSize = typeof TextEncoder === "function" ? new TextEncoder().encode(responseData).byteLength : responseData.length;
                }
                if (typeof materializedSize === "number" && materializedSize > maxContentLength) throw new (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039)("maxContentLength size of " + maxContentLength + " exceeded", (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $689903c39f023422$export$2e2bcd8739ae039)(resolve, reject, {
                    data: responseData,
                    headers: (0, $f2bfae2f47cdd2a8$export$2e2bcd8739ae039).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            // Safari can surface fetch aborts as a DOMException-like object whose
            // branded getters throw. Prefer our composed signal reason before reading
            // the caught error, preserving timeout vs cancellation semantics.
            if (composedSignal && composedSignal.aborted && composedSignal.reason instanceof (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039)) {
                const canceledError = composedSignal.reason;
                canceledError.config = config;
                request && (canceledError.request = request);
                if (err !== canceledError) // Non-enumerable to match native Error `cause` semantics so loggers
                // don't recurse into circular fetch internals (see #7205).
                Object.defineProperty(canceledError, "cause", {
                    __proto__: null,
                    value: err,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                throw canceledError;
            }
            // Surface a maxBodyLength violation we raised while the request body was
            // being streamed. Matching by identity (rather than reading
            // `err.cause.isAxiosError`) keeps the error deterministic across runtimes
            // and avoids both prototype-pollution reads and mis-attributing a foreign
            // AxiosError that merely happened to land in `err.cause`.
            if (pendingBodyError) {
                request && !pendingBodyError.request && (pendingBodyError.request = request);
                throw pendingBodyError;
            }
            // Re-throw AxiosErrors we raised synchronously (data: URL / content-length
            // pre-checks, response size enforcement) without re-wrapping them.
            if (err instanceof (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039)) {
                request && !err.request && (err.request = request);
                throw err;
            }
            if (err && err.name === "TypeError" && /Load failed|fetch/i.test(err.message)) {
                const networkError = new (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039)("Network Error", (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).ERR_NETWORK, config, request, err && err.response);
                // Non-enumerable to match native Error `cause` semantics so loggers
                // don't recurse into circular fetch internals (see #7205).
                Object.defineProperty(networkError, "cause", {
                    __proto__: null,
                    value: err.cause || err,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                throw networkError;
            }
            throw (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).from(err, err && err.code, config, request, err && err.response);
        }
    };
};
const $dfd83a5db13fb7d7$var$seedCache = new Map();
const $dfd83a5db13fb7d7$export$3105c6651375d4fa = (config)=>{
    let env = config && config.env || {};
    const { fetch: fetch1, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = $dfd83a5db13fb7d7$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $dfd83a5db13fb7d7$var$factory(env));
        map = target;
    }
    return target;
};
const $dfd83a5db13fb7d7$var$adapter = $dfd83a5db13fb7d7$export$3105c6651375d4fa();
var $dfd83a5db13fb7d7$export$2e2bcd8739ae039 = $dfd83a5db13fb7d7$var$adapter;



/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 *
 * @type {Object<string, Function|Object>}
 */ const $537fd1576cc57544$var$knownAdapters = {
    http: (0, $4b784fc05ded8112$export$2e2bcd8739ae039),
    xhr: (0, $d113720e80db7587$export$2e2bcd8739ae039),
    fetch: {
        get: $dfd83a5db13fb7d7$export$3105c6651375d4fa
    }
};
// Assign adapter names for easier debugging and identification
(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).forEach($537fd1576cc57544$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            // Null-proto descriptors so a polluted Object.prototype.get cannot turn
            // these data descriptors into accessor descriptors on the way in.
            Object.defineProperty(fn, "name", {
                __proto__: null,
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            __proto__: null,
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 *
 * @param {string} reason
 * @returns {string}
 */ const $537fd1576cc57544$var$renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 *
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const $537fd1576cc57544$var$isResolvedHandle = (adapter)=>(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 *
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $537fd1576cc57544$var$getAdapter(adapters, config) {
    adapters = (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length: length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!$537fd1576cc57544$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $537fd1576cc57544$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || "#" + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
        let s = length ? reasons.length > 1 ? "since :\n" + reasons.map($537fd1576cc57544$var$renderReason).join("\n") : " " + $537fd1576cc57544$var$renderReason(reasons[0]) : "as no adapter specified";
        throw new (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).ERR_NOT_SUPPORT);
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $537fd1576cc57544$export$2e2bcd8739ae039 = {
    getAdapter: /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ $537fd1576cc57544$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $537fd1576cc57544$var$knownAdapters
};


"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $f8407ebbdfc354ed$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $a5df0d634bea0233$export$2e2bcd8739ae039)(null, config);
}
function $f8407ebbdfc354ed$export$2e2bcd8739ae039(config) {
    $f8407ebbdfc354ed$var$throwIfCancellationRequested(config);
    config.headers = (0, $f2bfae2f47cdd2a8$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $80af61ecafd50432$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $537fd1576cc57544$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $184c4cdd344f1efc$export$2e2bcd8739ae039).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $f8407ebbdfc354ed$var$throwIfCancellationRequested(config);
        // Expose the current response on config so that transformResponse can
        // attach it to any AxiosError it throws (e.g. on JSON parse failure).
        // We clean it up afterwards to avoid polluting the config object.
        config.response = response;
        try {
            response.data = (0, $80af61ecafd50432$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        } finally{
            delete config.response;
        }
        response.headers = (0, $f2bfae2f47cdd2a8$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $6e6cee9820798cde$export$2e2bcd8739ae039)(reason)) {
            $f8407ebbdfc354ed$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                config.response = reason.response;
                try {
                    reason.response.data = (0, $80af61ecafd50432$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                } finally{
                    delete config.response;
                }
                reason.response.headers = (0, $f2bfae2f47cdd2a8$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}






"use strict";
const $160fd64fd0d48ee8$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $160fd64fd0d48ee8$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $160fd64fd0d48ee8$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $160fd64fd0d48ee8$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $6abdf23ff0a1f127$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$160fd64fd0d48ee8$var$deprecatedWarnings[opt]) {
            $160fd64fd0d48ee8$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$160fd64fd0d48ee8$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $160fd64fd0d48ee8$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object" || options === null) throw new (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039)("options must be an object", (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        // Use hasOwnProperty so a polluted Object.prototype.<opt> cannot supply
        // a non-function validator and cause a TypeError.
        const validator = Object.prototype.hasOwnProperty.call(schema, opt) ? schema[opt] : undefined;
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039)("option " + opt + " must be " + result, (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039)("Unknown option " + opt, (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $160fd64fd0d48ee8$export$2e2bcd8739ae039 = {
    assertOptions: $160fd64fd0d48ee8$var$assertOptions,
    validators: $160fd64fd0d48ee8$var$validators
};




"use strict";
const $9a007e79cde364ce$var$validators = (0, $160fd64fd0d48ee8$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $9a007e79cde364ce$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $f212a01b1e58726a$export$2e2bcd8739ae039)(),
            response: new (0, $f212a01b1e58726a$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = (()=>{
                    if (!dummy.stack) return "";
                    const firstNewlineIndex = dummy.stack.indexOf("\n");
                    return firstNewlineIndex === -1 ? "" : dummy.stack.slice(firstNewlineIndex + 1);
                })();
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack) {
                        const firstNewlineIndex = stack.indexOf("\n");
                        const secondNewlineIndex = firstNewlineIndex === -1 ? -1 : stack.indexOf("\n", firstNewlineIndex + 1);
                        const stackWithoutTwoTopLines = secondNewlineIndex === -1 ? "" : stack.slice(secondNewlineIndex + 1);
                        if (!String(err.stack).endsWith(stackWithoutTwoTopLines)) err.stack += "\n" + stack;
                    }
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $30616137bb4dc682$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $160fd64fd0d48ee8$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $9a007e79cde364ce$var$validators.transitional($9a007e79cde364ce$var$validators.boolean),
            forcedJSONParsing: $9a007e79cde364ce$var$validators.transitional($9a007e79cde364ce$var$validators.boolean),
            clarifyTimeoutError: $9a007e79cde364ce$var$validators.transitional($9a007e79cde364ce$var$validators.boolean),
            legacyInterceptorReqResOrdering: $9a007e79cde364ce$var$validators.transitional($9a007e79cde364ce$var$validators.boolean),
            advertiseZstdAcceptEncoding: $9a007e79cde364ce$var$validators.transitional($9a007e79cde364ce$var$validators.boolean),
            validateStatusUndefinedResolves: $9a007e79cde364ce$var$validators.transitional($9a007e79cde364ce$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $160fd64fd0d48ee8$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $9a007e79cde364ce$var$validators.function,
                serialize: $9a007e79cde364ce$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $160fd64fd0d48ee8$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $9a007e79cde364ce$var$validators.spelling("baseURL"),
            withXsrfToken: $9a007e79cde364ce$var$validators.spelling("withXSRFToken")
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "query",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $f2bfae2f47cdd2a8$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            const transitional = config.transitional || (0, $76ece2fc1dbc15e7$export$2e2bcd8739ae039);
            const legacyInterceptorReqResOrdering = transitional && transitional.legacyInterceptorReqResOrdering;
            if (legacyInterceptorReqResOrdering) requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
            else requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $f8407ebbdfc354ed$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $f8407ebbdfc354ed$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $30616137bb4dc682$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $6361e242ceddf2ba$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls, config);
        return (0, $9fdbd2405fb5a936$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $9a007e79cde364ce$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $30616137bb4dc682$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: config && (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).hasOwnProp(config, "data") ? config.data : undefined
        }));
    };
});
(0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).forEach([
    "post",
    "put",
    "patch",
    "query"
], function forEachMethodWithData(method) {
    function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $30616137bb4dc682$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $9a007e79cde364ce$var$Axios.prototype[method] = generateHTTPMethod();
    // QUERY is a safe/idempotent read method; multipart form bodies don't fit
    // its semantics, so no queryForm shorthand is generated.
    if (method !== "query") $9a007e79cde364ce$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $9a007e79cde364ce$export$2e2bcd8739ae039 = $9a007e79cde364ce$var$Axios;







"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $fc3444b47ee8f8bb$var$CancelToken {
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $a5df0d634bea0233$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $fc3444b47ee8f8bb$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $fc3444b47ee8f8bb$export$2e2bcd8739ae039 = $fc3444b47ee8f8bb$var$CancelToken;






"use strict";
function $3d241cd593ab10a8$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



"use strict";
function $17f11fafd04806be$export$2e2bcd8739ae039(payload) {
    return (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $77aa84cf79cf2933$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($77aa84cf79cf2933$var$HttpStatusCode).forEach(([key, value])=>{
    $77aa84cf79cf2933$var$HttpStatusCode[value] = key;
});
var $77aa84cf79cf2933$export$2e2bcd8739ae039 = $77aa84cf79cf2933$var$HttpStatusCode;


"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $6af2f97559267bd3$var$createInstance(defaultConfig) {
    const context = new (0, $9a007e79cde364ce$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $73106adb55132987$export$2e2bcd8739ae039)((0, $9a007e79cde364ce$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).extend(instance, (0, $9a007e79cde364ce$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $6af2f97559267bd3$var$createInstance((0, $30616137bb4dc682$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $6af2f97559267bd3$var$axios = $6af2f97559267bd3$var$createInstance((0, $184c4cdd344f1efc$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$6af2f97559267bd3$var$axios.Axios = (0, $9a007e79cde364ce$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$6af2f97559267bd3$var$axios.CanceledError = (0, $a5df0d634bea0233$export$2e2bcd8739ae039);
$6af2f97559267bd3$var$axios.CancelToken = (0, $fc3444b47ee8f8bb$export$2e2bcd8739ae039);
$6af2f97559267bd3$var$axios.isCancel = (0, $6e6cee9820798cde$export$2e2bcd8739ae039);
$6af2f97559267bd3$var$axios.VERSION = (0, $6abdf23ff0a1f127$export$a4ad2735b021c132);
$6af2f97559267bd3$var$axios.toFormData = (0, $8470289dbcea46c9$export$2e2bcd8739ae039);
// Expose AxiosError class
$6af2f97559267bd3$var$axios.AxiosError = (0, $ea1e0e5414f1ba5b$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$6af2f97559267bd3$var$axios.Cancel = $6af2f97559267bd3$var$axios.CanceledError;
// Expose all/spread
$6af2f97559267bd3$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$6af2f97559267bd3$var$axios.spread = (0, $3d241cd593ab10a8$export$2e2bcd8739ae039);
// Expose isAxiosError
$6af2f97559267bd3$var$axios.isAxiosError = (0, $17f11fafd04806be$export$2e2bcd8739ae039);
// Expose mergeConfig
$6af2f97559267bd3$var$axios.mergeConfig = (0, $30616137bb4dc682$export$2e2bcd8739ae039);
$6af2f97559267bd3$var$axios.AxiosHeaders = (0, $f2bfae2f47cdd2a8$export$2e2bcd8739ae039);
$6af2f97559267bd3$var$axios.formToJSON = (thing)=>(0, $b89d98899f472588$export$2e2bcd8739ae039)((0, $c2bf92a64ef6699d$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$6af2f97559267bd3$var$axios.getAdapter = (0, $537fd1576cc57544$export$2e2bcd8739ae039).getAdapter;
$6af2f97559267bd3$var$axios.HttpStatusCode = (0, $77aa84cf79cf2933$export$2e2bcd8739ae039);
$6af2f97559267bd3$var$axios.default = $6af2f97559267bd3$var$axios;
var // this module should only have a default export
$6af2f97559267bd3$export$2e2bcd8739ae039 = $6af2f97559267bd3$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $53dded68048b5996$export$1c00760e9e5a4e95, AxiosError: $53dded68048b5996$export$c1fbed17c2f6a328, CanceledError: $53dded68048b5996$export$1ab0c6b20d94fa14, isCancel: $53dded68048b5996$export$3b22524397b493c6, CancelToken: $53dded68048b5996$export$fd08e3cb425f0d61, VERSION: $53dded68048b5996$export$a4ad2735b021c132, all: $53dded68048b5996$export$84bf76cd7afc7469, Cancel: $53dded68048b5996$export$848c9b7ead0df967, isAxiosError: $53dded68048b5996$export$fbafdbe06a5b5a9a, spread: $53dded68048b5996$export$3ae0fd4797ed47c8, toFormData: $53dded68048b5996$export$10ae0d317ea97f8b, AxiosHeaders: $53dded68048b5996$export$4e7d6ff0f3e6520, HttpStatusCode: $53dded68048b5996$export$a972f69c851492b3, formToJSON: $53dded68048b5996$export$86d7c59254d6a2c9, getAdapter: $53dded68048b5996$export$17ddc20a97d669e2, mergeConfig: $53dded68048b5996$export$7ec1ebcfa9d8bd6a, create: $53dded68048b5996$export$185802fd694ee1f5 } = (0, $6af2f97559267bd3$export$2e2bcd8739ae039);



const $6f1c09625235f1f0$export$3241045aa1844a20 = {
    0: "monday",
    1: "tuesday",
    2: "wednesday",
    3: "thursday",
    4: "friday",
    5: "saturday",
    6: "sunday"
};
const $6f1c09625235f1f0$export$bb34f3538ba26c7e = {
    3: "Low",
    2: "Medium",
    1: "High",
    0: "Required"
};
const $6f1c09625235f1f0$export$8e11240bfd4abd6 = {
    "on_foot": "On foot",
    "motorcycle": "Motorcycle",
    "bike/scooter": "Bike or scooter",
    "automobile": "Automobile",
    "public_transport": "Public transport"
};
const $6f1c09625235f1f0$export$d0cb6a45517a7efd = [
    {
        value: 3,
        label: "Low"
    },
    {
        value: 2,
        label: "Medium"
    },
    {
        value: 1,
        label: "High"
    },
    {
        value: 0,
        label: "Required"
    }
];
const $6f1c09625235f1f0$export$1c3f0fce8ac301f1 = [
    {
        value: "boolean",
        label: "boolean"
    },
    {
        value: "photo",
        label: "photo"
    },
    {
        value: "text",
        label: "text"
    }
];
const $6f1c09625235f1f0$export$dd427c62fc59153a = [
    {
        value: "on_foot",
        label: "On foot"
    },
    {
        value: "motorcycle",
        label: "Motorcycle"
    },
    {
        value: "bike/scooter",
        label: "Bike or scooter"
    },
    {
        value: "automobile",
        label: "Automobile"
    },
    {
        value: "public_transport",
        label: "Public transport"
    }
];
const $6f1c09625235f1f0$export$fcbd761be6b3946e = [
    {
        value: true,
        label: "Active"
    },
    {
        value: false,
        label: "Not Active"
    }
];
const $6f1c09625235f1f0$export$d473fe3206ac7fed = [
    {
        value: "direct",
        label: "NKA Direct"
    },
    {
        value: "indirect",
        label: "NKA Indirect"
    }
];
const $6f1c09625235f1f0$export$9fa78f64b50a636c = [
    {
        value: "photo",
        label: "photo"
    },
    {
        value: "price",
        label: "price"
    },
    {
        value: "sale_price",
        label: "sale_price"
    },
    {
        value: "comment",
        label: "comment"
    }
];
const $6f1c09625235f1f0$export$18af5ff50af8d1b5 = [
    {
        value: "created",
        label: "created"
    },
    {
        value: "ready_for_neural_network",
        label: "ready_for_neural_network"
    },
    {
        value: "in_neural_network",
        label: "in_neural_network"
    },
    {
        value: "got_an_error_in_neural_network",
        label: "got_an_error_in_neural_network"
    },
    {
        value: "open",
        label: "open"
    },
    {
        value: "in_progress",
        label: "in_progress"
    },
    {
        value: "review",
        label: "review"
    },
    {
        value: "done",
        label: "done"
    },
    {
        value: "closed",
        label: "closed"
    }
];
const $6f1c09625235f1f0$export$a32e78025ed8daad = {
    boolean: "\u0442\u0430\u043A/\u043D\u0456",
    photo: "\u0444\u043E\u0442\u043E",
    text: "\u0442\u0435\u043A\u0441\u0442"
};




const $3b579ca6158bc61b$var$me = (0, $81aca8a46f6ecb51$export$6fec604aa7293d0c)().getState().me;
function $3b579ca6158bc61b$export$b25c9bd295a2cb07(items, entity) {
    if (!Array.isArray(items)) return;
    items.forEach((item, idx)=>{
        let label = item?.name || "";
        if (entity === "merchandiser") label = item.first_name + " " + item.last_name;
        if (entity === "merchandisers") label = item.first_name + " " + item.last_name;
        if (entity === "supervisor") label = item.first_name + " " + item.last_name;
        if (entity === "created_by") label = item.first_name + " " + item.last_name;
        if (entity === "point" || entity === "points") label = item.name + ", " + item.locality.name;
        if (entity === "component") label = (0, $6f1c09625235f1f0$export$a32e78025ed8daad)?.[item.name] || item.name;
        if (entity === "absence_reason_templates") {
            label = item.reason;
            item.id = idx + 1;
        }
        items[idx] = {
            ...item,
            value: item.id,
            label: label
        };
        if (entity === "component") items[idx] = {
            ...item,
            value: item.id,
            label: label,
            name: label
        };
        else items[idx] = {
            ...item,
            value: item.id,
            label: label
        };
    });
    return items;
}
function $3b579ca6158bc61b$export$6daeeb4cea31fc5(type, post, task_type = "single") {
    let errors = {};
    if (!post.title) errors.title = $3b579ca6158bc61b$export$d73ee8ef04f5226a((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "need_title_task_msg", $3b579ca6158bc61b$var$me.language);
    if (!post.template) errors.template = $3b579ca6158bc61b$export$d73ee8ef04f5226a((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "need_choose_task_msg", $3b579ca6158bc61b$var$me.language);
    if (task_type === "single") {
        if (!post.point) errors.template = $3b579ca6158bc61b$export$d73ee8ef04f5226a((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "need_choose_point_msg", $3b579ca6158bc61b$var$me.language);
    } else if (task_type === "network") {
        if (!post.network) errors.network = $3b579ca6158bc61b$export$d73ee8ef04f5226a((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "need_choose_network_msg", $3b579ca6158bc61b$var$me.language);
    } else if (task_type === "point_groups") {
        if (!post.point_groups) errors.template = $3b579ca6158bc61b$export$d73ee8ef04f5226a((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "need_choose_point_group_msg", $3b579ca6158bc61b$var$me.language);
        if (!post.title_group_uploads) errors.template = $3b579ca6158bc61b$export$d73ee8ef04f5226a((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "need_choose_point_group_name_msg", $3b579ca6158bc61b$var$me.language);
    }
    return {
        validate: Object.values(errors).length === 0,
        errors: errors
    };
}
function $3b579ca6158bc61b$export$73d9c7f6399747fc(imgUrl, cb) {
    (0, $6af2f97559267bd3$export$2e2bcd8739ae039)({
        method: "get",
        url: imgUrl,
        headers: {
            "Content-Type": "image/jpeg",
            "Access-Control-Allow-Origin": "*"
        },
        responseType: "blob"
    }).then((r)=>{
        var reader = new FileReader();
        reader.readAsDataURL(r.data);
        reader.onloadend = function() {
            var base64data = reader.result;
            cb(base64data);
        };
    });
}
function $3b579ca6158bc61b$export$320fa92043a195a9(imageUrl, blob) {
    return blob.replace("data:image/jpeg;base64,", "data:image/jpg;base64,");
}
const $3b579ca6158bc61b$export$6339e4f5afb1eeb0 = (me)=>{
    const c = me && me.county;
    if (c === null || c === undefined || c === "") return null;
    return typeof c === "object" ? c.id ?? null : c;
};
const $3b579ca6158bc61b$export$9563e054e6f787fb = (template, vars)=>Object.keys(vars).reduce((out, key)=>out.split(`{${key}}`).join(vars[key]), template || "");
/* A missing key renders as nothing at all, and plenty of keys are computed (`st_${status}`,
   SEGMENTS tuples, descriptor `label`s), so grepping for literals does not find them. In dev it
   says so — once per key, since this runs on every render. */ const $3b579ca6158bc61b$var$warned = new Set();
const $3b579ca6158bc61b$export$d73ee8ef04f5226a = (group, name, lang)=>{
    const entry = group[name];
    if (!entry) return null;
    // Prefer the requested language, then fall back to English, then Ukrainian,
    // so newly-added languages (e.g. hy, ka) never render blank for untranslated keys.
    return entry[lang] || entry.en || entry.uk || null;
};
const $3b579ca6158bc61b$export$f76670bfb9d67b64 = (startDateString, group, lang, author)=>{
    const startDate = new Date(startDateString);
    const now = new Date();
    const elapsedMilliseconds = now - startDate;
    const seconds = Math.floor(elapsedMilliseconds / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const months = Math.floor(days / 30);
    const years = Math.floor(months / 12);
    let unit, value;
    if (seconds < 60) {
        unit = "seconds";
        value = seconds;
    } else if (minutes < 60) {
        unit = "minutes";
        value = minutes;
    } else if (hours < 24) {
        unit = "hours";
        value = hours;
    } else if (days < 30) {
        unit = "days";
        value = days;
    } else if (months < 12) {
        unit = "months";
        value = months;
    } else {
        unit = "years";
        value = years > 1 ? "more than 1 year" : "1 year";
    }
    const translatedUnit = $3b579ca6158bc61b$export$d73ee8ef04f5226a(group, unit, lang);
    const translatedStart = $3b579ca6158bc61b$export$d73ee8ef04f5226a(group, "point_started_title", lang);
    const translatedAgo = $3b579ca6158bc61b$export$d73ee8ef04f5226a(group, "point_agoby_title", lang);
    return `${translatedStart} ${value} ${translatedUnit} ${translatedAgo} ${author}`;
};
function $3b579ca6158bc61b$export$547caeb1f7e674d3(imgUrl, owner, cb) {
    (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
        method: "POST",
        url: "images/convert_image_to_base64/",
        post: {
            image: imgUrl
        }
    }, (object)=>{
        const base64 = $3b579ca6158bc61b$export$320fa92043a195a9(imgUrl, object.image);
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "POST",
            url: "images/",
            post: {
                owner: owner,
                image: base64
            }
        }, (image)=>{
            if (image && image.id) cb(image);
            else console.log(image);
        });
    });
}
const $3b579ca6158bc61b$export$d6f5c7e166773679 = async (imgUrl, owner, cb)=>{
    await (0, $c9936523dc38c641$export$ae8c526ac59e8cc8)({
        method: "POST",
        url: "images/convert_image_to_base64/",
        post: {
            image: imgUrl
        }
    }, async (object)=>{
        const base64 = $3b579ca6158bc61b$export$320fa92043a195a9(imgUrl, object.image);
        await (0, $c9936523dc38c641$export$ae8c526ac59e8cc8)({
            method: "POST",
            url: "images/",
            post: {
                owner: owner,
                image: base64
            }
        }, (image)=>{
            if (image?.id) cb(image);
            else console.log(image);
        });
    });
};
function $3b579ca6158bc61b$export$c29ae74e18ca569f(imagepath) {
    function toDataUrl(url, callback) {
        var xhr = new XMLHttpRequest();
        xhr.onload = function() {
            var reader = new FileReader();
            reader.onloadend = function() {
                callback(reader.result);
            };
            reader.readAsDataURL(xhr.response);
        };
        xhr.open("GET", url);
        xhr.responseType = "blob";
        xhr.send();
    }
    toDataUrl(imagepath, function(myBase64) {
        console.log("myBase64", myBase64); // myBase64 is the base64 string
    });
}
const $3b579ca6158bc61b$export$de8d7796f5e34b0c = {
    fieldIsRequired: $3b579ca6158bc61b$export$d73ee8ef04f5226a((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), "empty_field_msg", $3b579ca6158bc61b$var$me?.language ? $3b579ca6158bc61b$var$me.language : "en")
};
const $3b579ca6158bc61b$export$ddec11078e1d813a = (message = $3b579ca6158bc61b$export$de8d7796f5e34b0c.fieldIsRequired)=>{
    return message;
};
const $3b579ca6158bc61b$export$e5432d4c8eb97ea7 = ()=>{
    const data = localStorage.getItem("state");
    const user = JSON.parse(data);
    return user.me.role === "supervisor_manager" ? true : false;
};


/**
 * Icon and tone per signal kind, reusing the search panel's per-entity palette so the same
 * entity looks the same everywhere.
 */ const $4663a1b8135c9c05$var$KIND = {
    visit: {
        Icon: (0, $d6c8837c82724a15$export$2e2bcd8739ae039),
        tone: "visit"
    },
    merchandiser: {
        Icon: (0, $e85f2e3cc711f245$export$2e2bcd8739ae039),
        tone: "merchandiser"
    },
    survey: {
        Icon: (0, $170c031fa50279f7$export$2e2bcd8739ae039),
        tone: "survey"
    }
};
/**
 * "Seen" is per-device, and storing it server-side would need a model plus a writer, so it lives
 * here: a signature of the current signals. Anything not in the stored signature is unread.
 */ const $4663a1b8135c9c05$var$SEEN_KEY = "picsell.notificationsSeen";
const $4663a1b8135c9c05$var$signatureOf = (items)=>items.map((i)=>`${i.key}:${i.count}`).join("|");
const $4663a1b8135c9c05$var$readSeen = ()=>{
    try {
        return localStorage.getItem($4663a1b8135c9c05$var$SEEN_KEY) || "";
    } catch  {
        return "";
    }
};
function $4663a1b8135c9c05$export$2e2bcd8739ae039() {
    const me = (0, $b83e93e5ef3de8b0$export$2105062e25df4afe)((state)=>state.me);
    const lang = me?.language;
    const history = (0, $6f5d68f762d5488a$export$3420e1dc2c4a518c)();
    const [items, setItems] = (0, $cQmXV.useState)([]);
    const [loading, setLoading] = (0, $cQmXV.useState)(true);
    const [seen, setSeen] = (0, $cQmXV.useState)($4663a1b8135c9c05$var$readSeen);
    const [open, setOpen] = (0, $cQmXV.useState)(false);
    const t = (0, $cQmXV.useCallback)((key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$a37c17837c5ca0c5), key, lang), [
        lang
    ]);
    (0, $cQmXV.useEffect)(()=>{
        let alive = true;
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "GET",
            url: "stats/notifications/"
        }, (r)=>{
            if (!alive) return;
            setItems(Array.isArray(r?.items) ? r.items : []);
            setLoading(false);
        });
        return ()=>{
            alive = false;
        };
    }, []);
    const signature = (0, $cQmXV.useMemo)(()=>$4663a1b8135c9c05$var$signatureOf(items), [
        items
    ]);
    /* Unread while the current set of signals differs from what was last acknowledged. */ const unread = items.length > 0 && signature !== seen;
    const markAllRead = (0, $cQmXV.useCallback)(()=>{
        try {
            localStorage.setItem($4663a1b8135c9c05$var$SEEN_KEY, signature);
        } catch  {
        /* private mode — it will read as unread again next load */ }
        setSeen(signature);
    }, [
        signature
    ]);
    const label = (item)=>{
        const text = t(`notif_${item.key}`);
        return item.days != null ? (text || "").replace("{n}", item.days) : text;
    };
    const go = (item)=>{
        setOpen(false);
        markAllRead();
        history.push(item.url);
    };
    const panel = /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
        className: "shell-notif",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                className: "shell-notif__head",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "shell-notif__title",
                        children: t("notifications")
                    }),
                    unread ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("button", {
                        className: "shell-notif__action",
                        type: "button",
                        onClick: markAllRead,
                        children: t("mark_all_read")
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                className: "shell-notif__list",
                children: loading ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("p", {
                    className: "shell-notif__empty",
                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $62b8cbcd99b9ffa2$export$2e2bcd8739ae039), {
                        size: "small"
                    })
                }) : !items.length ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("p", {
                    className: "shell-notif__empty",
                    children: t("notif_empty")
                }) : items.map((item)=>{
                    const meta = $4663a1b8135c9c05$var$KIND[item.kind] || $4663a1b8135c9c05$var$KIND.visit;
                    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("button", {
                        className: `shell-notif__item shell-notif__item--${meta.tone}${unread ? " is-unread" : ""}`,
                        type: "button",
                        onClick: ()=>go(item),
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                className: "shell-notif__icon",
                                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)(meta.Icon, {})
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                className: "shell-notif__body",
                                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                    className: "shell-notif__text",
                                    children: label(item)
                                })
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                className: "shell-notif__count",
                                children: item.count
                            })
                        ]
                    }, item.key);
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $30ddd2d6a9f4b7d6$export$2e2bcd8739ae039), {
        open: open,
        onOpenChange: setOpen,
        trigger: [
            "click"
        ],
        placement: "bottomRight",
        classNames: {
            root: "shell-notifmenu"
        },
        popupRender: ()=>panel,
        menu: {
            items: []
        },
        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("button", {
            className: "shell-iconbtn",
            type: "button",
            "aria-label": t("notifications"),
            children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b5470af5a9674a86$export$2e2bcd8739ae039), {
                dot: unread,
                offset: [
                    -2,
                    2
                ],
                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $1005916731c83b87$export$2e2bcd8739ae039), {})
            })
        })
    });
}




var $cQmXV = parcelRequire("cQmXV");


var $cQmXV = parcelRequire("cQmXV");
var $8db42fc00a6658a4$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($8db42fc00a6658a4$exports, "__esModule", {
    value: true
});
var $8db42fc00a6658a4$var$PushpinOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M878.3 392.1L631.9 145.7c-6.5-6.5-15-9.7-23.5-9.7s-17 3.2-23.5 9.7L423.8 306.9c-12.2-1.4-24.5-2-36.8-2-73.2 0-146.4 24.1-206.5 72.3a33.23 33.23 0 00-2.7 49.4l181.7 181.7-215.4 215.2a15.8 15.8 0 00-4.6 9.8l-3.4 37.2c-.9 9.4 6.6 17.4 15.9 17.4.5 0 1 0 1.5-.1l37.2-3.4c3.7-.3 7.2-2 9.8-4.6l215.4-215.4 181.7 181.7c6.5 6.5 15 9.7 23.5 9.7 9.7 0 19.3-4.2 25.9-12.4 56.3-70.3 79.7-158.3 70.2-243.4l161.1-161.1c12.9-12.8 12.9-33.8 0-46.8zM666.2 549.3l-24.5 24.5 3.8 34.4a259.92 259.92 0 01-30.4 153.9L262 408.8c12.9-7.1 26.3-13.1 40.3-17.9 27.2-9.4 55.7-14.1 84.7-14.1 9.6 0 19.3.5 28.9 1.6l34.4 3.8 24.5-24.5L608.5 224 800 415.5 666.2 549.3z"
                }
            }
        ]
    },
    "name": "pushpin",
    "theme": "outlined"
};
$8db42fc00a6658a4$exports.default = $8db42fc00a6658a4$var$PushpinOutlined;



function $a1f80a723f71d713$var$_extends() {
    $a1f80a723f71d713$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a1f80a723f71d713$var$_extends.apply(this, arguments);
}
const $a1f80a723f71d713$var$PushpinOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $a1f80a723f71d713$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8db42fc00a6658a4$exports)))
    }));
/**![pushpin](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg3OC4zIDM5Mi4xTDYzMS45IDE0NS43Yy02LjUtNi41LTE1LTkuNy0yMy41LTkuN3MtMTcgMy4yLTIzLjUgOS43TDQyMy44IDMwNi45Yy0xMi4yLTEuNC0yNC41LTItMzYuOC0yLTczLjIgMC0xNDYuNCAyNC4xLTIwNi41IDcyLjNhMzMuMjMgMzMuMjMgMCAwMC0yLjcgNDkuNGwxODEuNyAxODEuNy0yMTUuNCAyMTUuMmExNS44IDE1LjggMCAwMC00LjYgOS44bC0zLjQgMzcuMmMtLjkgOS40IDYuNiAxNy40IDE1LjkgMTcuNC41IDAgMSAwIDEuNS0uMWwzNy4yLTMuNGMzLjctLjMgNy4yLTIgOS44LTQuNmwyMTUuNC0yMTUuNCAxODEuNyAxODEuN2M2LjUgNi41IDE1IDkuNyAyMy41IDkuNyA5LjcgMCAxOS4zLTQuMiAyNS45LTEyLjQgNTYuMy03MC4zIDc5LjctMTU4LjMgNzAuMi0yNDMuNGwxNjEuMS0xNjEuMWMxMi45LTEyLjggMTIuOS0zMy44IDAtNDYuOHpNNjY2LjIgNTQ5LjNsLTI0LjUgMjQuNSAzLjggMzQuNGEyNTkuOTIgMjU5LjkyIDAgMDEtMzAuNCAxNTMuOUwyNjIgNDA4LjhjMTIuOS03LjEgMjYuMy0xMy4xIDQwLjMtMTcuOSAyNy4yLTkuNCA1NS43LTE0LjEgODQuNy0xNC4xIDkuNiAwIDE5LjMuNSAyOC45IDEuNmwzNC40IDMuOCAyNC41LTI0LjVMNjA4LjUgMjI0IDgwMCA0MTUuNSA2NjYuMiA1NDkuM3oiIC8+PC9zdmc+) */ const $a1f80a723f71d713$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($a1f80a723f71d713$var$PushpinOutlined);
var $a1f80a723f71d713$export$2e2bcd8739ae039 = $a1f80a723f71d713$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $63e7fe5f1be78c44$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($63e7fe5f1be78c44$exports, "__esModule", {
    value: true
});
var $63e7fe5f1be78c44$var$FileTextOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494zM504 618H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM312 490v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8z"
                }
            }
        ]
    },
    "name": "file-text",
    "theme": "outlined"
};
$63e7fe5f1be78c44$exports.default = $63e7fe5f1be78c44$var$FileTextOutlined;



function $3ad3610a8cd8d8e0$var$_extends() {
    $3ad3610a8cd8d8e0$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3ad3610a8cd8d8e0$var$_extends.apply(this, arguments);
}
const $3ad3610a8cd8d8e0$var$FileTextOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $3ad3610a8cd8d8e0$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($63e7fe5f1be78c44$exports)))
    }));
/**![file-text](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg1NC42IDI4OC42TDYzOS40IDczLjRjLTYtNi0xNC4xLTkuNC0yMi42LTkuNEgxOTJjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjgzMmMwIDE3LjcgMTQuMyAzMiAzMiAzMmg2NDBjMTcuNyAwIDMyLTE0LjMgMzItMzJWMzExLjNjMC04LjUtMy40LTE2LjctOS40LTIyLjd6TTc5MC4yIDMyNkg2MDJWMTM3LjhMNzkwLjIgMzI2em0xLjggNTYySDIzMlYxMzZoMzAydjIxNmE0MiA0MiAwIDAwNDIgNDJoMjE2djQ5NHpNNTA0IDYxOEgzMjBjLTQuNCAwLTggMy42LTggOHY0OGMwIDQuNCAzLjYgOCA4IDhoMTg0YzQuNCAwIDgtMy42IDgtOHYtNDhjMC00LjQtMy42LTgtOC04ek0zMTIgNDkwdjQ4YzAgNC40IDMuNiA4IDggOGgzODRjNC40IDAgOC0zLjYgOC04di00OGMwLTQuNC0zLjYtOC04LThIMzIwYy00LjQgMC04IDMuNi04IDh6IiAvPjwvc3ZnPg==) */ const $3ad3610a8cd8d8e0$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($3ad3610a8cd8d8e0$var$FileTextOutlined);
var $3ad3610a8cd8d8e0$export$2e2bcd8739ae039 = $3ad3610a8cd8d8e0$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $16be1ef99b574fa6$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($16be1ef99b574fa6$exports, "__esModule", {
    value: true
});
var $16be1ef99b574fa6$var$SearchOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z"
                }
            }
        ]
    },
    "name": "search",
    "theme": "outlined"
};
$16be1ef99b574fa6$exports.default = $16be1ef99b574fa6$var$SearchOutlined;



function $20a259d46bffcb08$var$_extends() {
    $20a259d46bffcb08$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $20a259d46bffcb08$var$_extends.apply(this, arguments);
}
const $20a259d46bffcb08$var$SearchOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $20a259d46bffcb08$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($16be1ef99b574fa6$exports)))
    }));
/**![search](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkwOS42IDg1NC41TDY0OS45IDU5NC44QzY5MC4yIDU0Mi43IDcxMiA0NzkgNzEyIDQxMmMwLTgwLjItMzEuMy0xNTUuNC04Ny45LTIxMi4xLTU2LjYtNTYuNy0xMzItODcuOS0yMTIuMS04Ny45cy0xNTUuNSAzMS4zLTIxMi4xIDg3LjlDMTQzLjIgMjU2LjUgMTEyIDMzMS44IDExMiA0MTJjMCA4MC4xIDMxLjMgMTU1LjUgODcuOSAyMTIuMUMyNTYuNSA2ODAuOCAzMzEuOCA3MTIgNDEyIDcxMmM2NyAwIDEzMC42LTIxLjggMTgyLjctNjJsMjU5LjcgMjU5LjZhOC4yIDguMiAwIDAwMTEuNiAwbDQzLjYtNDMuNWE4LjIgOC4yIDAgMDAwLTExLjZ6TTU3MC40IDU3MC40QzUyOCA2MTIuNyA0NzEuOCA2MzYgNDEyIDYzNnMtMTE2LTIzLjMtMTU4LjQtNjUuNkMyMTEuMyA1MjggMTg4IDQ3MS44IDE4OCA0MTJzMjMuMy0xMTYuMSA2NS42LTE1OC40QzI5NiAyMTEuMyAzNTIuMiAxODggNDEyIDE4OHMxMTYuMSAyMy4yIDE1OC40IDY1LjZTNjM2IDM1Mi4yIDYzNiA0MTJzLTIzLjMgMTE2LjEtNjUuNiAxNTguNHoiIC8+PC9zdmc+) */ const $20a259d46bffcb08$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($20a259d46bffcb08$var$SearchOutlined);
var $20a259d46bffcb08$export$2e2bcd8739ae039 = $20a259d46bffcb08$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $d028bebd1e945c86$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($d028bebd1e945c86$exports, "__esModule", {
    value: true
});
var $d028bebd1e945c86$var$HistoryOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M536.1 273H488c-4.4 0-8 3.6-8 8v275.3c0 2.6 1.2 5 3.3 6.5l165.3 120.7c3.6 2.6 8.6 1.9 11.2-1.7l28.6-39c2.7-3.7 1.9-8.7-1.7-11.2L544.1 528.5V281c0-4.4-3.6-8-8-8zm219.8 75.2l156.8 38.3c5 1.2 9.9-2.6 9.9-7.7l.8-161.5c0-6.7-7.7-10.5-12.9-6.3L752.9 334.1a8 8 0 003 14.1zm167.7 301.1l-56.7-19.5a8 8 0 00-10.1 4.8c-1.9 5.1-3.9 10.1-6 15.1-17.8 42.1-43.3 80-75.9 112.5a353 353 0 01-112.5 75.9 352.18 352.18 0 01-137.7 27.8c-47.8 0-94.1-9.3-137.7-27.8a353 353 0 01-112.5-75.9c-32.5-32.5-58-70.4-75.9-112.5A353.44 353.44 0 01171 512c0-47.8 9.3-94.2 27.8-137.8 17.8-42.1 43.3-80 75.9-112.5a353 353 0 01112.5-75.9C430.6 167.3 477 158 524.8 158s94.1 9.3 137.7 27.8A353 353 0 01775 261.7c10.2 10.3 19.8 21 28.6 32.3l59.8-46.8C784.7 146.6 662.2 81.9 524.6 82 285 82.1 92.6 276.7 95 516.4 97.4 751.9 288.9 942 524.8 942c185.5 0 343.5-117.6 403.7-282.3 1.5-4.2-.7-8.9-4.9-10.4z"
                }
            }
        ]
    },
    "name": "history",
    "theme": "outlined"
};
$d028bebd1e945c86$exports.default = $d028bebd1e945c86$var$HistoryOutlined;



function $6c0489580aed4320$var$_extends() {
    $6c0489580aed4320$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6c0489580aed4320$var$_extends.apply(this, arguments);
}
const $6c0489580aed4320$var$HistoryOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $6c0489580aed4320$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d028bebd1e945c86$exports)))
    }));
/**![history](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUzNi4xIDI3M0g0ODhjLTQuNCAwLTggMy42LTggOHYyNzUuM2MwIDIuNiAxLjIgNSAzLjMgNi41bDE2NS4zIDEyMC43YzMuNiAyLjYgOC42IDEuOSAxMS4yLTEuN2wyOC42LTM5YzIuNy0zLjcgMS45LTguNy0xLjctMTEuMkw1NDQuMSA1MjguNVYyODFjMC00LjQtMy42LTgtOC04em0yMTkuOCA3NS4ybDE1Ni44IDM4LjNjNSAxLjIgOS45LTIuNiA5LjktNy43bC44LTE2MS41YzAtNi43LTcuNy0xMC41LTEyLjktNi4zTDc1Mi45IDMzNC4xYTggOCAwIDAwMyAxNC4xem0xNjcuNyAzMDEuMWwtNTYuNy0xOS41YTggOCAwIDAwLTEwLjEgNC44Yy0xLjkgNS4xLTMuOSAxMC4xLTYgMTUuMS0xNy44IDQyLjEtNDMuMyA4MC03NS45IDExMi41YTM1MyAzNTMgMCAwMS0xMTIuNSA3NS45IDM1Mi4xOCAzNTIuMTggMCAwMS0xMzcuNyAyNy44Yy00Ny44IDAtOTQuMS05LjMtMTM3LjctMjcuOGEzNTMgMzUzIDAgMDEtMTEyLjUtNzUuOWMtMzIuNS0zMi41LTU4LTcwLjQtNzUuOS0xMTIuNUEzNTMuNDQgMzUzLjQ0IDAgMDExNzEgNTEyYzAtNDcuOCA5LjMtOTQuMiAyNy44LTEzNy44IDE3LjgtNDIuMSA0My4zLTgwIDc1LjktMTEyLjVhMzUzIDM1MyAwIDAxMTEyLjUtNzUuOUM0MzAuNiAxNjcuMyA0NzcgMTU4IDUyNC44IDE1OHM5NC4xIDkuMyAxMzcuNyAyNy44QTM1MyAzNTMgMCAwMTc3NSAyNjEuN2MxMC4yIDEwLjMgMTkuOCAyMSAyOC42IDMyLjNsNTkuOC00Ni44Qzc4NC43IDE0Ni42IDY2Mi4yIDgxLjkgNTI0LjYgODIgMjg1IDgyLjEgOTIuNiAyNzYuNyA5NSA1MTYuNCA5Ny40IDc1MS45IDI4OC45IDk0MiA1MjQuOCA5NDJjMTg1LjUgMCAzNDMuNS0xMTcuNiA0MDMuNy0yODIuMyAxLjUtNC4yLS43LTguOS00LjktMTAuNHoiIC8+PC9zdmc+) */ const $6c0489580aed4320$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($6c0489580aed4320$var$HistoryOutlined);
var $6c0489580aed4320$export$2e2bcd8739ae039 = $6c0489580aed4320$var$RefIcon;







/* Mirrors MIN_QUERY on the endpoint — below this it returns nothing, so don't ask. Three, not
   two, and it is an index constraint rather than a nicety: a two-character needle yields no
   trigram, so `LIKE '%ab%'` cannot use the search indexes at all and degrades to a full scan.
   The two constants move together. */ const $fa443a9269f390c9$var$MIN_QUERY = 3;
const $fa443a9269f390c9$var$DEBOUNCE_MS = 250;
/* The search words, split exactly as the endpoint and DRF's `SearchFilter` split them: NULs
   stripped, a comma treated as a separator, then any whitespace. Worth mirroring rather than
   approximating — "See all" hands this same string to a list page that filters through
   SearchFilter, so a different split here would highlight words the list never searched for. */ const $fa443a9269f390c9$var$words = (q)=>q.split("\0").join("").split(/[\s,]+/).filter(Boolean);
/* Mirrors the endpoint's guard: the words are ANDed, so ONE word long enough to drive the trigram
   index is enough — the short ones then narrow an already-small result set. Only a query whose
   every word is short can use no index at all, and that is the one we refuse. This is why the
   floor is on the longest word rather than on the whole string: "watsons ky" is a normal thing to
   have typed halfway through, and rejecting it on total length would be wrong in the other
   direction. */ const $fa443a9269f390c9$var$searchable = (q)=>$fa443a9269f390c9$var$words(q).some((w)=>w.length >= $fa443a9269f390c9$var$MIN_QUERY);
/** Bounded so a long session can't grow the cache without limit. */ const $fa443a9269f390c9$var$CACHE_MAX = 40;
const $fa443a9269f390c9$var$RECENT_KEY = "picsell.recentSearches";
const $fa443a9269f390c9$var$RECENT_MAX = 5;
/**
 * Result groups, in display order. Labels reuse the nav's nouns rather than translating five
 * words twice. Each row's icon and colour match the design's per-entity tile — the tint lives in
 * shell.scss as `--tone` per `.shell-search__row--<key>`.
 *
 * No `task` group: the endpoint dropped that category (templated titles made its rows
 * near-identical, and its query could not use the indexes at scale — see the view's docstring).
 * A response that still carries one, from an API not yet redeployed, is ignored because rendering
 * iterates this list.
 *
 * `path` builds the detail route; every one of these exists in router.js — except `document`,
 * which has only a list route, so those rows carry a file `url` from the API and open it instead.
 *
 * `list` is where "see all" goes, with the term handed over as `?q=` — the param every redesigned
 * list page reads into its search box. `visit` has none: its filter card has no free-text search
 * (and `VisitWebFilter` has no `search` param to back one), so that group narrows the scope here
 * instead.
 */ const $fa443a9269f390c9$var$GROUPS = [
    {
        key: "point",
        label: "pt_points",
        Icon: (0, $a1f80a723f71d713$export$2e2bcd8739ae039),
        path: (id)=>`/points/${id}`,
        list: "/points"
    },
    {
        key: "merchandiser",
        label: "merchandiser",
        Icon: (0, $e85f2e3cc711f245$export$2e2bcd8739ae039),
        path: (id)=>`/merchandiser/${id}`,
        list: "/merchandiser"
    },
    {
        key: "visit",
        label: "visit",
        Icon: (0, $d6c8837c82724a15$export$2e2bcd8739ae039),
        path: (id)=>`/visit/${id}`
    },
    {
        key: "survey",
        label: "pt_surveys",
        Icon: (0, $170c031fa50279f7$export$2e2bcd8739ae039),
        path: (id)=>`/surveys/${id}`,
        list: "/surveys"
    },
    // Documents have only a list route, so these rows carry a file `url` and open it instead.
    {
        key: "document",
        label: "documents",
        Icon: (0, $3ad3610a8cd8d8e0$export$2e2bcd8739ae039),
        path: ()=>"/document",
        list: "/document"
    }
];
const $fa443a9269f390c9$var$GROUP_BY_KEY = Object.fromEntries($fa443a9269f390c9$var$GROUPS.map((g)=>[
        g.key,
        g
    ]));
const $fa443a9269f390c9$var$readRecents = ()=>{
    try {
        const raw = JSON.parse(localStorage.getItem($fa443a9269f390c9$var$RECENT_KEY));
        return Array.isArray(raw) ? raw.filter((x)=>typeof x === "string").slice(0, $fa443a9269f390c9$var$RECENT_MAX) : [];
    } catch  {
        return [];
    }
};
const $fa443a9269f390c9$var$escapeRe = (s)=>s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
/* Wraps every matched WORD so the user can see *why* a row matched. One span for the whole query
   was wrong once the endpoint started ANDing words across fields: "watsons kyiv" appears nowhere
   contiguously in a row whose network is Watsons and locality is Kyiv, so the row matched and
   nothing was highlighted. Longest word first, so a short word overlapping a longer one does not
   chop it into pieces; `split` on a capturing group puts the matches at the odd indices. */ function $fa443a9269f390c9$var$Highlight({ text: text, term: term }) {
    const value = text || "";
    const parts = $fa443a9269f390c9$var$words(term).sort((a, b)=>b.length - a.length);
    if (!parts.length) return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $575603080129eb00$exports.Fragment), {
        children: value
    });
    const re = new RegExp(`(${parts.map($fa443a9269f390c9$var$escapeRe).join("|")})`, "gi");
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $575603080129eb00$exports.Fragment), {
        children: value.split(re).map((chunk, i)=>i % 2 ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("mark", {
                children: chunk
            }, i) : chunk)
    });
}
function $fa443a9269f390c9$export$2e2bcd8739ae039() {
    const me = (0, $b83e93e5ef3de8b0$export$2105062e25df4afe)((state)=>state.me);
    const lang = me?.language;
    const history = (0, $6f5d68f762d5488a$export$3420e1dc2c4a518c)();
    const [term, setTerm] = (0, $cQmXV.useState)("");
    const [scope, setScope] = (0, $cQmXV.useState)("all");
    const [open, setOpen] = (0, $cQmXV.useState)(false);
    const [loading, setLoading] = (0, $cQmXV.useState)(false);
    const [groups, setGroups] = (0, $cQmXV.useState)({});
    const [cursor, setCursor] = (0, $cQmXV.useState)(-1);
    const [recents, setRecents] = (0, $cQmXV.useState)($fa443a9269f390c9$var$readRecents);
    const wrapRef = (0, $cQmXV.useRef)(null);
    const inputRef = (0, $cQmXV.useRef)(null);
    const abortRef = (0, $cQmXV.useRef)(null);
    const timerRef = (0, $cQmXV.useRef)(null);
    /** query string -> groups. Re-typing a query already seen costs no request. */ const cacheRef = (0, $cQmXV.useRef)(new Map());
    const t = (0, $cQmXV.useCallback)((key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$74880610319600c9), key, lang), [
        lang
    ]);
    const groupLabel = (0, $cQmXV.useCallback)((key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$72266474e9355649), $fa443a9269f390c9$var$GROUP_BY_KEY[key].label, lang), [
        lang
    ]);
    const query = term.trim();
    /* Recents belong to an EMPTY box only. Gating them on `< MIN_QUERY` instead meant that anyone
   with search history typed two characters, got a list of unrelated past searches, and was never
   told the query was below the floor — the one thing they needed to know at that moment. */ const showRecents = query.length === 0 && recents.length > 0;
    /* One flat list of everything selectable, so ↑/↓ walk results across group boundaries — and
     across the recent-searches list when that is what is on screen. */ const rows = (0, $cQmXV.useMemo)(()=>{
        if (showRecents) return recents.map((r)=>({
                recent: r
            }));
        const out = [];
        for (const g of $fa443a9269f390c9$var$GROUPS){
            const hit = groups[g.key];
            if (!hit) continue;
            for (const r of hit.results)out.push({
                ...r,
                type: g.key
            });
        }
        return out;
    }, [
        groups,
        recents,
        showRecents
    ]);
    const reset = (0, $cQmXV.useCallback)(()=>{
        setGroups({});
        setCursor(-1);
        setLoading(false);
    }, []);
    /* Debounced, cancellable fetch. Every keystroke aborts the request it supersedes, so a fast
     typist leaves one in-flight request rather than one per character — and a slow response for
     "at" can never overwrite the results for "atb". */ (0, $cQmXV.useEffect)(()=>{
        clearTimeout(timerRef.current);
        abortRef.current?.abort();
        if (!$fa443a9269f390c9$var$searchable(query)) {
            reset();
            return;
        }
        const cacheKey = `${scope}::${query}`;
        const cached = cacheRef.current.get(cacheKey);
        if (cached) {
            setGroups(cached);
            setCursor(-1);
            setLoading(false);
            return;
        }
        setLoading(true);
        timerRef.current = setTimeout(()=>{
            const controller = new AbortController();
            abortRef.current = controller;
            const url = `search/?q=${encodeURIComponent(query)}${scope === "all" ? "" : `&scope=${scope}`}`;
            (0, $c9936523dc38c641$export$86557ef9e0794d10)(url, controller.signal).then((data)=>{
                if (controller.signal.aborted || !data) return;
                const next = data.groups || {};
                if (cacheRef.current.size >= $fa443a9269f390c9$var$CACHE_MAX) cacheRef.current.delete(cacheRef.current.keys().next().value);
                cacheRef.current.set(cacheKey, next);
                setGroups(next);
                setCursor(-1);
            }).catch((err)=>{
                /* An aborted request is the expected outcome of typing, not a failure. */ if (err?.name !== "AbortError") setGroups({});
            }).finally(()=>{
                if (!controller.signal.aborted) setLoading(false);
            });
        }, $fa443a9269f390c9$var$DEBOUNCE_MS);
        return ()=>clearTimeout(timerRef.current);
    }, [
        query,
        scope,
        reset
    ]);
    /* Abort whatever is in flight when the bar unmounts. */ (0, $cQmXV.useEffect)(()=>()=>abortRef.current?.abort(), []);
    /* "/" focuses search from anywhere, unless the user is already typing somewhere. */ (0, $cQmXV.useEffect)(()=>{
        const onKey = (e)=>{
            if (e.key !== "/" || e.metaKey || e.ctrlKey || e.altKey) return;
            const el = document.activeElement;
            const typing = el && (el.tagName === "INPUT" || el.tagName === "TEXTAREA" || el.isContentEditable);
            if (typing) return;
            e.preventDefault();
            inputRef.current?.focus();
        };
        document.addEventListener("keydown", onKey);
        return ()=>document.removeEventListener("keydown", onKey);
    }, []);
    /* Click outside closes the panel. */ (0, $cQmXV.useEffect)(()=>{
        if (!open) return;
        const onDown = (e)=>{
            if (!wrapRef.current?.contains(e.target)) setOpen(false);
        };
        document.addEventListener("mousedown", onDown);
        return ()=>document.removeEventListener("mousedown", onDown);
    }, [
        open
    ]);
    const remember = (0, $cQmXV.useCallback)((value)=>{
        const next = [
            value,
            ...$fa443a9269f390c9$var$readRecents().filter((r)=>r !== value)
        ].slice(0, $fa443a9269f390c9$var$RECENT_MAX);
        try {
            localStorage.setItem($fa443a9269f390c9$var$RECENT_KEY, JSON.stringify(next));
        } catch  {
        /* private mode — recents just won't survive a reload */ }
        setRecents(next);
    }, []);
    const go = (0, $cQmXV.useCallback)((row)=>{
        /* Opening a result is the signal that this query was the useful one. */ if (query) remember(query);
        setOpen(false);
        setTerm("");
        /* A document has no detail page; the row carries its file URL, so open that. noopener so
         the new context never gets a handle back on this window. */ if (row.url) {
            window.open(row.url, "_blank", "noopener,noreferrer");
            return;
        }
        history.push($fa443a9269f390c9$var$GROUP_BY_KEY[row.type].path(row.id));
    }, [
        history,
        query,
        remember
    ]);
    /* "See all" hands the term to the category's own list page as `?q=`, where the full result set
     lives with its filters, sorting and paging. Two cases fall back to narrowing the scope in the
     panel, which is all this used to do: a group with no list search (`visit`), and standing on the
     destination already — those pages read the URL once, on mount, so a push would not reach them. */ const seeAll = (0, $cQmXV.useCallback)((g)=>{
        if (!g.list || history.location.pathname === g.list) {
            setScope(g.key);
            inputRef.current?.focus();
            return;
        }
        if (query) remember(query);
        setOpen(false);
        setTerm("");
        history.push(`${g.list}?q=${encodeURIComponent(query)}`);
    }, [
        history,
        query,
        remember
    ]);
    const activate = (0, $cQmXV.useCallback)((row)=>{
        if (row.recent !== undefined) {
            setTerm(row.recent);
            inputRef.current?.focus();
            return;
        }
        go(row);
    }, [
        go
    ]);
    const onKeyDown = (e)=>{
        if (e.key === "Escape") {
            setOpen(false);
            inputRef.current?.blur();
            return;
        }
        if (e.key === "ArrowDown" || e.key === "ArrowUp") {
            if (!rows.length) return;
            e.preventDefault();
            setCursor((c)=>{
                const step = e.key === "ArrowDown" ? 1 : -1;
                return (c + step + rows.length) % rows.length;
            });
            setOpen(true);
            return;
        }
        if (e.key === "Enter" && cursor >= 0 && rows[cursor]) {
            e.preventDefault();
            activate(rows[cursor]);
        }
    };
    /* Counts come free with the results — the endpoint already fetched LIMIT+1 per category, so
     "5+" is known without a COUNT query. */ const scopeCount = (key)=>{
        const hit = groups[key];
        if (!hit) return null;
        return `${hit.results.length}${hit.has_more ? "+" : ""}`;
    };
    const hasResults = !showRecents && rows.length > 0;
    let flatIndex = -1;
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
        className: `shell-search${term ? " has-query" : ""}`,
        ref: wrapRef,
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                className: "shell-search__box",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $20a259d46bffcb08$export$2e2bcd8739ae039), {
                        className: "shell-search__icon"
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("input", {
                        ref: inputRef,
                        id: "global-search",
                        name: "global-search",
                        type: "text",
                        value: term,
                        onChange: (e)=>{
                            setTerm(e.target.value);
                            setOpen(true);
                        },
                        onFocus: ()=>setOpen(true),
                        onKeyDown: onKeyDown,
                        placeholder: t("search_placeholder"),
                        "aria-label": t("search_label"),
                        role: "combobox",
                        "aria-expanded": open,
                        "aria-controls": "shell-search-panel",
                        "aria-autocomplete": "list",
                        autoComplete: "off"
                    }),
                    loading ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $62b8cbcd99b9ffa2$export$2e2bcd8739ae039), {
                        size: "small"
                    }) : null,
                    term ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("button", {
                        className: "shell-search__clear",
                        type: "button",
                        "aria-label": t("search_clear"),
                        onClick: ()=>{
                            setTerm("");
                            inputRef.current?.focus();
                        },
                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $837faca566926e3c$export$2e2bcd8739ae039), {})
                    }) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "shell-search__kbd",
                        "aria-hidden": "true",
                        children: "/"
                    })
                ]
            }),
            open ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                className: "shell-search__panel",
                id: "shell-search-panel",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                        className: "shell-search__scopes",
                        children: [
                            {
                                key: "all",
                                label: t("search_all")
                            },
                            ...$fa443a9269f390c9$var$GROUPS.map((g)=>({
                                    key: g.key,
                                    label: groupLabel(g.key)
                                }))
                        ].map((s)=>{
                            const n = s.key === "all" ? null : scopeCount(s.key);
                            return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("button", {
                                className: "shell-search__scope",
                                type: "button",
                                "aria-pressed": scope === s.key,
                                onClick: ()=>{
                                    setScope(s.key);
                                    inputRef.current?.focus();
                                },
                                children: [
                                    s.label,
                                    n ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                        className: "shell-search__n",
                                        children: n
                                    }) : null
                                ]
                            }, s.key);
                        })
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                        className: "shell-search__results",
                        role: "listbox",
                        "aria-label": t("search_label"),
                        children: showRecents ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $575603080129eb00$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                                    className: "shell-search__glabel",
                                    children: t("recent_searches")
                                }),
                                recents.map((r, i)=>{
                                    flatIndex += 1;
                                    const active = flatIndex === cursor;
                                    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("button", {
                                        className: `shell-search__recent${active ? " is-cursor" : ""}`,
                                        type: "button",
                                        role: "option",
                                        "aria-selected": active,
                                        onMouseEnter: ()=>setCursor(i),
                                        onClick: ()=>activate({
                                                recent: r
                                            }),
                                        children: [
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $6c0489580aed4320$export$2e2bcd8739ae039), {}),
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                                children: r
                                            })
                                        ]
                                    }, r);
                                })
                            ]
                        }) : !$fa443a9269f390c9$var$searchable(query) ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("p", {
                            className: "shell-search__empty",
                            children: (0, $3b579ca6158bc61b$export$9563e054e6f787fb)(t("search_hint"), {
                                n: $fa443a9269f390c9$var$MIN_QUERY
                            })
                        }) : !hasResults ? loading ? null : /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("p", {
                            className: "shell-search__empty",
                            children: [
                                t("search_no_results"),
                                " \u201C",
                                query,
                                "\u201D"
                            ]
                        }) : $fa443a9269f390c9$var$GROUPS.map((g)=>{
                            const hit = groups[g.key];
                            if (!hit) return null;
                            return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                                        className: "shell-search__glabel",
                                        children: [
                                            groupLabel(g.key),
                                            " \xb7 ",
                                            hit.results.length,
                                            hit.has_more ? "+" : "",
                                            hit.recent_days ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                                className: "shell-search__window",
                                                children: (0, $3b579ca6158bc61b$export$9563e054e6f787fb)(t("window_days"), {
                                                    n: hit.recent_days
                                                })
                                            }) : null
                                        ]
                                    }),
                                    hit.results.map((r)=>{
                                        flatIndex += 1;
                                        const active = flatIndex === cursor;
                                        const idx = flatIndex;
                                        return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("button", {
                                            className: `shell-search__row shell-search__row--${g.key}${active ? " is-cursor" : ""}`,
                                            type: "button",
                                            role: "option",
                                            "aria-selected": active,
                                            onMouseEnter: ()=>setCursor(idx),
                                            onClick: ()=>activate({
                                                    ...r,
                                                    type: g.key
                                                }),
                                            children: [
                                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                                    className: "shell-search__row-icon",
                                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)(g.Icon, {})
                                                }),
                                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                                                    className: "shell-search__row-body",
                                                    children: [
                                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                                            className: "shell-search__row-title",
                                                            children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($fa443a9269f390c9$var$Highlight, {
                                                                text: r.title,
                                                                term: query
                                                            })
                                                        }),
                                                        r.meta ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                                            className: "shell-search__row-meta",
                                                            children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($fa443a9269f390c9$var$Highlight, {
                                                                text: r.meta,
                                                                term: query
                                                            })
                                                        }) : null
                                                    ]
                                                })
                                            ]
                                        }, `${g.key}-${r.id}`);
                                    }),
                                    hit.has_more && (g.list || scope === "all") ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("button", {
                                        className: "shell-search__more",
                                        type: "button",
                                        onClick: ()=>seeAll(g),
                                        children: [
                                            t("see_all"),
                                            " \u2192"
                                        ]
                                    }) : null
                                ]
                            }, g.key);
                        })
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                        className: "shell-search__foot",
                        "aria-hidden": "true",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                        className: "shell-search__kbd",
                                        children: "\u2191"
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                        className: "shell-search__kbd",
                                        children: "\u2193"
                                    }),
                                    t("kb_navigate")
                                ]
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                        className: "shell-search__kbd",
                                        children: "\u21B5"
                                    }),
                                    t("kb_open")
                                ]
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                        className: "shell-search__kbd",
                                        children: "esc"
                                    }),
                                    t("kb_close")
                                ]
                            })
                        ]
                    })
                ]
            }) : null
        ]
    });
}





const $cca4416321e611bf$export$596d806903d1f59e = (user)=>(dispatch)=>dispatch({
            type: (0, $7e11c65b70d794b3$export$1fa6c04dd35d59ff).LOGIN,
            body: user
        });
const $cca4416321e611bf$export$6503ec6e8aabbaf = (user)=>(dispatch)=>dispatch({
            type: (0, $7e11c65b70d794b3$export$1fa6c04dd35d59ff).REGISTER,
            body: user
        });
const $cca4416321e611bf$export$a0973bcfe11b05c9 = ()=>(dispatch)=>dispatch({
            type: (0, $7e11c65b70d794b3$export$1fa6c04dd35d59ff).LOGOUT
        });
const $cca4416321e611bf$export$953a134f6e0e87ac = (user)=>(dispatch)=>dispatch({
            type: (0, $7e11c65b70d794b3$export$1fa6c04dd35d59ff).UPDATE_ME,
            body: user
        });



function $f3884d5bd7e34aad$var$initialsOf(me) {
    const a = me?.first_name?.[0] || "";
    const b = me?.last_name?.[0] || "";
    return (a + b).toUpperCase() || "?";
}
function $f3884d5bd7e34aad$var$Avatar({ me: me, onError: onError, imgFailed: imgFailed }) {
    const fullName = `${me?.first_name || ""} ${me?.last_name || ""}`.trim();
    if (me?.photo && !imgFailed) return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("img", {
        className: "shell-avatar shell-avatar--img",
        src: me.photo,
        alt: fullName,
        onError: onError
    });
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
        className: "shell-avatar",
        "aria-hidden": "true",
        children: $f3884d5bd7e34aad$var$initialsOf(me)
    });
}
/** The language lives on the user record, so switching it is a write, not local state. */ function $f3884d5bd7e34aad$var$LanguageMenu({ me: me, lang: lang }) {
    const dispatch = (0, $b83e93e5ef3de8b0$export$8ad76b76a4c905f8)();
    const [saving, setSaving] = (0, $cQmXV.useState)(false);
    const change = (code)=>{
        if (code === lang || saving || !me?.id) return;
        setSaving(true);
        /* PATCH, not PUT: the profile page PUTs the whole record, and sending a partial record
       there would clobber fields. One key is all that changes here. */ (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "PATCH",
            url: "users/" + me.id + "/",
            post: {
                language: code
            }
        }, (r)=>{
            setSaving(false);
            if (!r || !r.id) {
                (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).warning("Could not change the language. " + JSON.stringify(r));
                return;
            }
            dispatch((0, $cca4416321e611bf$export$953a134f6e0e87ac)({
                ...me,
                ...r
            }));
            /* Most of the app reads me.language at render time from module-scope state, so a reload
         is still how a language change reaches every screen. Same as the profile page. */ setTimeout(()=>window.location.reload(), 150);
        });
    };
    const items = (0, $2753457ad00c82b6$export$b4b5a31092c79bca).map((l)=>({
            key: l.code,
            label: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                className: "shell-langitem",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        children: l.label
                    }),
                    l.native ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "shell-langitem__native",
                        children: l.native
                    }) : null,
                    l.code === lang ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $77ccca814b0c39fe$export$2e2bcd8739ae039), {
                        className: "shell-langitem__tick"
                    }) : null
                ]
            })
        }));
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $30ddd2d6a9f4b7d6$export$2e2bcd8739ae039), {
        trigger: [
            "click"
        ],
        placement: "bottomRight",
        classNames: {
            root: "shell-langmenu"
        },
        autoFocus: true,
        /* see the user menu below — the rows are unreachable by keyboard without it */ menu: {
            items: items,
            selectable: true,
            selectedKeys: [
                lang
            ],
            onClick: ({ key: key })=>change(key)
        },
        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
            className: "shell-lang",
            "aria-label": (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$7926257c0571e339), "language", lang) || "Language",
            children: [
                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                    className: "shell-lang__code",
                    children: (lang || (0, $2753457ad00c82b6$export$90898903f0729f34)).toUpperCase()
                }),
                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e7119b602540b2c5$export$2e2bcd8739ae039), {
                    className: "shell-lang__chev"
                })
            ]
        })
    });
}
const $f3884d5bd7e34aad$var$ROLE_KEY = {
    supervisor_manager: "role_supervisor_manager",
    supervisor: "role_supervisor"
};
function $f3884d5bd7e34aad$var$UserMenu({ me: me, lang: lang }) {
    const dispatch = (0, $b83e93e5ef3de8b0$export$8ad76b76a4c905f8)();
    const [imgFailed, setImgFailed] = (0, $cQmXV.useState)(false);
    const fullName = `${me?.first_name || ""} ${me?.last_name || ""}`.trim();
    /* The design shows the ROLE under the name, not the free-text position — and `position` is
     empty on most accounts, so the line simply vanished. */ const roleLabel = $f3884d5bd7e34aad$var$ROLE_KEY[me?.role] ? (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$e24f02e1b5477764), $f3884d5bd7e34aad$var$ROLE_KEY[me.role], lang) : me?.role || "";
    const items = [
        {
            key: "profile",
            icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $7804300d9b621775$export$2e2bcd8739ae039), {}),
            label: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $50f22649d61cdefc$export$a6c7ac8248d6e38a), {
                to: "/profile",
                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$7926257c0571e339), "my_profile", lang)
            })
        },
        {
            key: "help",
            icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $9e51bdaef216a39c$export$2e2bcd8739ae039), {}),
            label: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $50f22649d61cdefc$export$a6c7ac8248d6e38a), {
                to: "/help",
                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$7926257c0571e339), "my_help", lang)
            })
        },
        {
            type: "divider"
        },
        {
            key: "logout",
            danger: true,
            icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $27dfd059157cea02$export$2e2bcd8739ae039), {}),
            label: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$7926257c0571e339), "exit", lang) || (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$72266474e9355649), "logout", lang),
            onClick: ()=>dispatch((0, $cca4416321e611bf$export$a0973bcfe11b05c9)())
        }
    ];
    /* The identity block is our own markup above the menu, not a menu group. As a `type: "group"`
     it inherited antd's group-title and group-list padding, whose selectors carry more classes
     than any override we could sanely write — the design's "identity block, then a bordered list
     of rows" came out with the rows flush to the panel edges. `popupRender` hands us the menu
     node to wrap, so antd keeps the roving-focus keyboard handling and we keep the layout.
     Same shape AppNotifications already uses. */ const panel = (menu)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
            className: "shell-usermenu__panel",
            /* rc-dropdown's autoFocus calls `.focus()` on whatever popupRender returns. A plain div
         swallows that — and since keydown bubbles up rather than down, focus parked on the
         wrapper never reaches the menu's own arrow-key handling. So take the focus and hand it
         straight on to the list. */ tabIndex: -1,
            onFocus: (e)=>{
                if (e.target === e.currentTarget) e.currentTarget.querySelector(".ant-dropdown-menu")?.focus();
            },
            children: [
                /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                    className: "shell-usermenu__id",
                    children: [
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($f3884d5bd7e34aad$var$Avatar, {
                            me: me,
                            imgFailed: imgFailed,
                            onError: ()=>setImgFailed(true)
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                    className: "shell-usermenu__nm",
                                    children: fullName
                                }),
                                roleLabel ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                    className: "shell-usermenu__rl",
                                    children: roleLabel
                                }) : null
                            ]
                        })
                    ]
                }),
                menu
            ]
        });
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $30ddd2d6a9f4b7d6$export$2e2bcd8739ae039), {
        trigger: [
            "click"
        ],
        placement: "bottomRight",
        classNames: {
            root: "shell-usermenu"
        },
        popupRender: panel,
        /* Without it the menu opens but focus stays on the trigger: ↓ does nothing and Tab walks
         past the rows to the next bar control, so the menu is mouse-only. */ autoFocus: true,
        menu: {
            items: items
        },
        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("button", {
            className: "shell-userchip",
            type: "button",
            children: [
                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($f3884d5bd7e34aad$var$Avatar, {
                    me: me,
                    imgFailed: imgFailed,
                    onError: ()=>setImgFailed(true)
                }),
                /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                    className: "shell-userchip__meta",
                    children: [
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                            className: "shell-userchip__name",
                            children: fullName
                        }),
                        roleLabel ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                            className: "shell-userchip__role",
                            children: roleLabel
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e7119b602540b2c5$export$2e2bcd8739ae039), {
                    className: "shell-userchip__chev"
                })
            ]
        })
    });
}
function $f3884d5bd7e34aad$export$2e2bcd8739ae039({ onOpenNav: onOpenNav }) {
    const me = (0, $b83e93e5ef3de8b0$export$2105062e25df4afe)((state)=>state.me);
    const lang = me?.language;
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("header", {
        className: "shell-bar",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("button", {
                className: "shell-iconbtn shell-burger",
                type: "button",
                onClick: onOpenNav,
                "aria-label": "Open navigation",
                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $214f3d80484a9230$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $fa443a9269f390c9$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                className: "shell-bar__spacer"
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $4663a1b8135c9c05$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($f3884d5bd7e34aad$var$LanguageMenu, {
                me: me,
                lang: lang
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($f3884d5bd7e34aad$var$UserMenu, {
                me: me,
                lang: lang
            })
        ]
    });
}




var $cQmXV = parcelRequire("cQmXV");


var $cQmXV = parcelRequire("cQmXV");
var $a1e70965c9cda8c1$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($a1e70965c9cda8c1$exports, "__esModule", {
    value: true
});
var $a1e70965c9cda8c1$var$DashboardOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M924.8 385.6a446.7 446.7 0 00-96-142.4 446.7 446.7 0 00-142.4-96C631.1 123.8 572.5 112 512 112s-119.1 11.8-174.4 35.2a446.7 446.7 0 00-142.4 96 446.7 446.7 0 00-96 142.4C75.8 440.9 64 499.5 64 560c0 132.7 58.3 257.7 159.9 343.1l1.7 1.4c5.8 4.8 13.1 7.5 20.6 7.5h531.7c7.5 0 14.8-2.7 20.6-7.5l1.7-1.4C901.7 817.7 960 692.7 960 560c0-60.5-11.9-119.1-35.2-174.4zM761.4 836H262.6A371.12 371.12 0 01140 560c0-99.4 38.7-192.8 109-263 70.3-70.3 163.7-109 263-109 99.4 0 192.8 38.7 263 109 70.3 70.3 109 163.7 109 263 0 105.6-44.5 205.5-122.6 276zM623.5 421.5a8.03 8.03 0 00-11.3 0L527.7 506c-18.7-5-39.4-.2-54.1 14.5a55.95 55.95 0 000 79.2 55.95 55.95 0 0079.2 0 55.87 55.87 0 0014.5-54.1l84.5-84.5c3.1-3.1 3.1-8.2 0-11.3l-28.3-28.3zM490 320h44c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8h-44c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8zm260 218v44c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-44c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8zm12.7-197.2l-31.1-31.1a8.03 8.03 0 00-11.3 0l-56.6 56.6a8.03 8.03 0 000 11.3l31.1 31.1c3.1 3.1 8.2 3.1 11.3 0l56.6-56.6c3.1-3.1 3.1-8.2 0-11.3zm-458.6-31.1a8.03 8.03 0 00-11.3 0l-31.1 31.1a8.03 8.03 0 000 11.3l56.6 56.6c3.1 3.1 8.2 3.1 11.3 0l31.1-31.1c3.1-3.1 3.1-8.2 0-11.3l-56.6-56.6zM262 530h-80c-4.4 0-8 3.6-8 8v44c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-44c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "dashboard",
    "theme": "outlined"
};
$a1e70965c9cda8c1$exports.default = $a1e70965c9cda8c1$var$DashboardOutlined;



function $71d4184078fbbc48$var$_extends() {
    $71d4184078fbbc48$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $71d4184078fbbc48$var$_extends.apply(this, arguments);
}
const $71d4184078fbbc48$var$DashboardOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $71d4184078fbbc48$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($a1e70965c9cda8c1$exports)))
    }));
/**![dashboard](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkyNC44IDM4NS42YTQ0Ni43IDQ0Ni43IDAgMDAtOTYtMTQyLjQgNDQ2LjcgNDQ2LjcgMCAwMC0xNDIuNC05NkM2MzEuMSAxMjMuOCA1NzIuNSAxMTIgNTEyIDExMnMtMTE5LjEgMTEuOC0xNzQuNCAzNS4yYTQ0Ni43IDQ0Ni43IDAgMDAtMTQyLjQgOTYgNDQ2LjcgNDQ2LjcgMCAwMC05NiAxNDIuNEM3NS44IDQ0MC45IDY0IDQ5OS41IDY0IDU2MGMwIDEzMi43IDU4LjMgMjU3LjcgMTU5LjkgMzQzLjFsMS43IDEuNGM1LjggNC44IDEzLjEgNy41IDIwLjYgNy41aDUzMS43YzcuNSAwIDE0LjgtMi43IDIwLjYtNy41bDEuNy0xLjRDOTAxLjcgODE3LjcgOTYwIDY5Mi43IDk2MCA1NjBjMC02MC41LTExLjktMTE5LjEtMzUuMi0xNzQuNHpNNzYxLjQgODM2SDI2Mi42QTM3MS4xMiAzNzEuMTIgMCAwMTE0MCA1NjBjMC05OS40IDM4LjctMTkyLjggMTA5LTI2MyA3MC4zLTcwLjMgMTYzLjctMTA5IDI2My0xMDkgOTkuNCAwIDE5Mi44IDM4LjcgMjYzIDEwOSA3MC4zIDcwLjMgMTA5IDE2My43IDEwOSAyNjMgMCAxMDUuNi00NC41IDIwNS41LTEyMi42IDI3NnpNNjIzLjUgNDIxLjVhOC4wMyA4LjAzIDAgMDAtMTEuMyAwTDUyNy43IDUwNmMtMTguNy01LTM5LjQtLjItNTQuMSAxNC41YTU1Ljk1IDU1Ljk1IDAgMDAwIDc5LjIgNTUuOTUgNTUuOTUgMCAwMDc5LjIgMCA1NS44NyA1NS44NyAwIDAwMTQuNS01NC4xbDg0LjUtODQuNWMzLjEtMy4xIDMuMS04LjIgMC0xMS4zbC0yOC4zLTI4LjN6TTQ5MCAzMjBoNDRjNC40IDAgOC0zLjYgOC04di04MGMwLTQuNC0zLjYtOC04LThoLTQ0Yy00LjQgMC04IDMuNi04IDh2ODBjMCA0LjQgMy42IDggOCA4em0yNjAgMjE4djQ0YzAgNC40IDMuNiA4IDggOGg4MGM0LjQgMCA4LTMuNiA4LTh2LTQ0YzAtNC40LTMuNi04LTgtOGgtODBjLTQuNCAwLTggMy42LTggOHptMTIuNy0xOTcuMmwtMzEuMS0zMS4xYTguMDMgOC4wMyAwIDAwLTExLjMgMGwtNTYuNiA1Ni42YTguMDMgOC4wMyAwIDAwMCAxMS4zbDMxLjEgMzEuMWMzLjEgMy4xIDguMiAzLjEgMTEuMyAwbDU2LjYtNTYuNmMzLjEtMy4xIDMuMS04LjIgMC0xMS4zem0tNDU4LjYtMzEuMWE4LjAzIDguMDMgMCAwMC0xMS4zIDBsLTMxLjEgMzEuMWE4LjAzIDguMDMgMCAwMDAgMTEuM2w1Ni42IDU2LjZjMy4xIDMuMSA4LjIgMy4xIDExLjMgMGwzMS4xLTMxLjFjMy4xLTMuMSAzLjEtOC4yIDAtMTEuM2wtNTYuNi01Ni42ek0yNjIgNTMwaC04MGMtNC40IDAtOCAzLjYtOCA4djQ0YzAgNC40IDMuNiA4IDggOGg4MGM0LjQgMCA4LTMuNiA4LTh2LTQ0YzAtNC40LTMuNi04LTgtOHoiIC8+PC9zdmc+) */ const $71d4184078fbbc48$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($71d4184078fbbc48$var$DashboardOutlined);
var $71d4184078fbbc48$export$2e2bcd8739ae039 = $71d4184078fbbc48$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $0c55cc6e5a78b797$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($0c55cc6e5a78b797$exports, "__esModule", {
    value: true
});
var $0c55cc6e5a78b797$var$CameraOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M864 248H728l-32.4-90.8a32.07 32.07 0 00-30.2-21.2H358.6c-13.5 0-25.6 8.5-30.1 21.2L296 248H160c-44.2 0-80 35.8-80 80v456c0 44.2 35.8 80 80 80h704c44.2 0 80-35.8 80-80V328c0-44.2-35.8-80-80-80zm8 536c0 4.4-3.6 8-8 8H160c-4.4 0-8-3.6-8-8V328c0-4.4 3.6-8 8-8h186.7l17.1-47.8 22.9-64.2h250.5l22.9 64.2 17.1 47.8H864c4.4 0 8 3.6 8 8v456zM512 384c-88.4 0-160 71.6-160 160s71.6 160 160 160 160-71.6 160-160-71.6-160-160-160zm0 256c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z"
                }
            }
        ]
    },
    "name": "camera",
    "theme": "outlined"
};
$0c55cc6e5a78b797$exports.default = $0c55cc6e5a78b797$var$CameraOutlined;



function $3602cb83fb466795$var$_extends() {
    $3602cb83fb466795$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3602cb83fb466795$var$_extends.apply(this, arguments);
}
const $3602cb83fb466795$var$CameraOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $3602cb83fb466795$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($0c55cc6e5a78b797$exports)))
    }));
/**![camera](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg2NCAyNDhINzI4bC0zMi40LTkwLjhhMzIuMDcgMzIuMDcgMCAwMC0zMC4yLTIxLjJIMzU4LjZjLTEzLjUgMC0yNS42IDguNS0zMC4xIDIxLjJMMjk2IDI0OEgxNjBjLTQ0LjIgMC04MCAzNS44LTgwIDgwdjQ1NmMwIDQ0LjIgMzUuOCA4MCA4MCA4MGg3MDRjNDQuMiAwIDgwLTM1LjggODAtODBWMzI4YzAtNDQuMi0zNS44LTgwLTgwLTgwem04IDUzNmMwIDQuNC0zLjYgOC04IDhIMTYwYy00LjQgMC04LTMuNi04LThWMzI4YzAtNC40IDMuNi04IDgtOGgxODYuN2wxNy4xLTQ3LjggMjIuOS02NC4yaDI1MC41bDIyLjkgNjQuMiAxNy4xIDQ3LjhIODY0YzQuNCAwIDggMy42IDggOHY0NTZ6TTUxMiAzODRjLTg4LjQgMC0xNjAgNzEuNi0xNjAgMTYwczcxLjYgMTYwIDE2MCAxNjAgMTYwLTcxLjYgMTYwLTE2MC03MS42LTE2MC0xNjAtMTYwem0wIDI1NmMtNTMgMC05Ni00My05Ni05NnM0My05NiA5Ni05NiA5NiA0MyA5NiA5Ni00MyA5Ni05NiA5NnoiIC8+PC9zdmc+) */ const $3602cb83fb466795$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($3602cb83fb466795$var$CameraOutlined);
var $3602cb83fb466795$export$2e2bcd8739ae039 = $3602cb83fb466795$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $5ba5098b823d4e83$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($5ba5098b823d4e83$exports, "__esModule", {
    value: true
});
var $5ba5098b823d4e83$var$NodeIndexOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M843.5 737.4c-12.4-75.2-79.2-129.1-155.3-125.4S550.9 676 546 752c-153.5-4.8-208-40.7-199.1-113.7 3.3-27.3 19.8-41.9 50.1-49 18.4-4.3 38.8-4.9 57.3-3.2 1.7.2 3.5.3 5.2.5 11.3 2.7 22.8 5 34.3 6.8 34.1 5.6 68.8 8.4 101.8 6.6 92.8-5 156-45.9 159.2-132.7 3.1-84.1-54.7-143.7-147.9-183.6-29.9-12.8-61.6-22.7-93.3-30.2-14.3-3.4-26.3-5.7-35.2-7.2-7.9-75.9-71.5-133.8-147.8-134.4-76.3-.6-140.9 56.1-150.1 131.9s40 146.3 114.2 163.9c74.2 17.6 149.9-23.3 175.7-95.1 9.4 1.7 18.7 3.6 28 5.8 28.2 6.6 56.4 15.4 82.4 26.6 70.7 30.2 109.3 70.1 107.5 119.9-1.6 44.6-33.6 65.2-96.2 68.6-27.5 1.5-57.6-.9-87.3-5.8-8.3-1.4-15.9-2.8-22.6-4.3-3.9-.8-6.6-1.5-7.8-1.8l-3.1-.6c-2.2-.3-5.9-.8-10.7-1.3-25-2.3-52.1-1.5-78.5 4.6-55.2 12.9-93.9 47.2-101.1 105.8-15.7 126.2 78.6 184.7 276 188.9 29.1 70.4 106.4 107.9 179.6 87 73.3-20.9 119.3-93.4 106.9-168.6zM329.1 345.2a83.3 83.3 0 11.01-166.61 83.3 83.3 0 01-.01 166.61zM695.6 845a83.3 83.3 0 11.01-166.61A83.3 83.3 0 01695.6 845z"
                }
            }
        ]
    },
    "name": "node-index",
    "theme": "outlined"
};
$5ba5098b823d4e83$exports.default = $5ba5098b823d4e83$var$NodeIndexOutlined;



function $5432cf81954535cc$var$_extends() {
    $5432cf81954535cc$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5432cf81954535cc$var$_extends.apply(this, arguments);
}
const $5432cf81954535cc$var$NodeIndexOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $5432cf81954535cc$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5ba5098b823d4e83$exports)))
    }));
/**![node-index](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg0My41IDczNy40Yy0xMi40LTc1LjItNzkuMi0xMjkuMS0xNTUuMy0xMjUuNFM1NTAuOSA2NzYgNTQ2IDc1MmMtMTUzLjUtNC44LTIwOC00MC43LTE5OS4xLTExMy43IDMuMy0yNy4zIDE5LjgtNDEuOSA1MC4xLTQ5IDE4LjQtNC4zIDM4LjgtNC45IDU3LjMtMy4yIDEuNy4yIDMuNS4zIDUuMi41IDExLjMgMi43IDIyLjggNSAzNC4zIDYuOCAzNC4xIDUuNiA2OC44IDguNCAxMDEuOCA2LjYgOTIuOC01IDE1Ni00NS45IDE1OS4yLTEzMi43IDMuMS04NC4xLTU0LjctMTQzLjctMTQ3LjktMTgzLjYtMjkuOS0xMi44LTYxLjYtMjIuNy05My4zLTMwLjItMTQuMy0zLjQtMjYuMy01LjctMzUuMi03LjItNy45LTc1LjktNzEuNS0xMzMuOC0xNDcuOC0xMzQuNC03Ni4zLS42LTE0MC45IDU2LjEtMTUwLjEgMTMxLjlzNDAgMTQ2LjMgMTE0LjIgMTYzLjljNzQuMiAxNy42IDE0OS45LTIzLjMgMTc1LjctOTUuMSA5LjQgMS43IDE4LjcgMy42IDI4IDUuOCAyOC4yIDYuNiA1Ni40IDE1LjQgODIuNCAyNi42IDcwLjcgMzAuMiAxMDkuMyA3MC4xIDEwNy41IDExOS45LTEuNiA0NC42LTMzLjYgNjUuMi05Ni4yIDY4LjYtMjcuNSAxLjUtNTcuNi0uOS04Ny4zLTUuOC04LjMtMS40LTE1LjktMi44LTIyLjYtNC4zLTMuOS0uOC02LjYtMS41LTcuOC0xLjhsLTMuMS0uNmMtMi4yLS4zLTUuOS0uOC0xMC43LTEuMy0yNS0yLjMtNTIuMS0xLjUtNzguNSA0LjYtNTUuMiAxMi45LTkzLjkgNDcuMi0xMDEuMSAxMDUuOC0xNS43IDEyNi4yIDc4LjYgMTg0LjcgMjc2IDE4OC45IDI5LjEgNzAuNCAxMDYuNCAxMDcuOSAxNzkuNiA4NyA3My4zLTIwLjkgMTE5LjMtOTMuNCAxMDYuOS0xNjguNnpNMzI5LjEgMzQ1LjJhODMuMyA4My4zIDAgMTEuMDEtMTY2LjYxIDgzLjMgODMuMyAwIDAxLS4wMSAxNjYuNjF6TTY5NS42IDg0NWE4My4zIDgzLjMgMCAxMS4wMS0xNjYuNjFBODMuMyA4My4zIDAgMDE2OTUuNiA4NDV6IiAvPjwvc3ZnPg==) */ const $5432cf81954535cc$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($5432cf81954535cc$var$NodeIndexOutlined);
var $5432cf81954535cc$export$2e2bcd8739ae039 = $5432cf81954535cc$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $f8ca5ef143d55dfa$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($f8ca5ef143d55dfa$exports, "__esModule", {
    value: true
});
var $f8ca5ef143d55dfa$var$BarChartOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-600-80h56c4.4 0 8-3.6 8-8V560c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8zm152 0h56c4.4 0 8-3.6 8-8V384c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v320c0 4.4 3.6 8 8 8zm152 0h56c4.4 0 8-3.6 8-8V462c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v242c0 4.4 3.6 8 8 8zm152 0h56c4.4 0 8-3.6 8-8V304c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v400c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    },
    "name": "bar-chart",
    "theme": "outlined"
};
$f8ca5ef143d55dfa$exports.default = $f8ca5ef143d55dfa$var$BarChartOutlined;



function $235e2c6c1e527cba$var$_extends() {
    $235e2c6c1e527cba$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $235e2c6c1e527cba$var$_extends.apply(this, arguments);
}
const $235e2c6c1e527cba$var$BarChartOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $235e2c6c1e527cba$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($f8ca5ef143d55dfa$exports)))
    }));
/**![bar-chart](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg4OCA3OTJIMjAwVjE2OGMwLTQuNC0zLjYtOC04LThoLTU2Yy00LjQgMC04IDMuNi04IDh2Njg4YzAgNC40IDMuNiA4IDggOGg3NTJjNC40IDAgOC0zLjYgOC04di01NmMwLTQuNC0zLjYtOC04LTh6bS02MDAtODBoNTZjNC40IDAgOC0zLjYgOC04VjU2MGMwLTQuNC0zLjYtOC04LThoLTU2Yy00LjQgMC04IDMuNi04IDh2MTQ0YzAgNC40IDMuNiA4IDggOHptMTUyIDBoNTZjNC40IDAgOC0zLjYgOC04VjM4NGMwLTQuNC0zLjYtOC04LThoLTU2Yy00LjQgMC04IDMuNi04IDh2MzIwYzAgNC40IDMuNiA4IDggOHptMTUyIDBoNTZjNC40IDAgOC0zLjYgOC04VjQ2MmMwLTQuNC0zLjYtOC04LThoLTU2Yy00LjQgMC04IDMuNi04IDh2MjQyYzAgNC40IDMuNiA4IDggOHptMTUyIDBoNTZjNC40IDAgOC0zLjYgOC04VjMwNGMwLTQuNC0zLjYtOC04LThoLTU2Yy00LjQgMC04IDMuNi04IDh2NDAwYzAgNC40IDMuNiA4IDggOHoiIC8+PC9zdmc+) */ const $235e2c6c1e527cba$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($235e2c6c1e527cba$var$BarChartOutlined);
var $235e2c6c1e527cba$export$2e2bcd8739ae039 = $235e2c6c1e527cba$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $f3215a5a46599f93$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($f3215a5a46599f93$exports, "__esModule", {
    value: true
});
var $f3215a5a46599f93$var$CarryOutOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v584zM688 420h-55.2c-5.1 0-10 2.5-13 6.6L468.9 634.4l-64.7-89c-3-4.1-7.8-6.6-13-6.6H336c-6.5 0-10.3 7.4-6.5 12.7l126.4 174a16.1 16.1 0 0026 0l212.6-292.7c3.8-5.4 0-12.8-6.5-12.8z"
                }
            }
        ]
    },
    "name": "carry-out",
    "theme": "outlined"
};
$f3215a5a46599f93$exports.default = $f3215a5a46599f93$var$CarryOutOutlined;



function $f76885e21060a150$var$_extends() {
    $f76885e21060a150$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f76885e21060a150$var$_extends.apply(this, arguments);
}
const $f76885e21060a150$var$CarryOutOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $f76885e21060a150$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($f3215a5a46599f93$exports)))
    }));
/**![carry-out](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg4MCAxODRINzEydi02NGMwLTQuNC0zLjYtOC04LThoLTU2Yy00LjQgMC04IDMuNi04IDh2NjRIMzg0di02NGMwLTQuNC0zLjYtOC04LThoLTU2Yy00LjQgMC04IDMuNi04IDh2NjRIMTQ0Yy0xNy43IDAtMzIgMTQuMy0zMiAzMnY2NjRjMCAxNy43IDE0LjMgMzIgMzIgMzJoNzM2YzE3LjcgMCAzMi0xNC4zIDMyLTMyVjIxNmMwLTE3LjctMTQuMy0zMi0zMi0zMnptLTQwIDY1NkgxODRWMjU2aDEyOHY0OGMwIDQuNCAzLjYgOCA4IDhoNTZjNC40IDAgOC0zLjYgOC04di00OGgyNTZ2NDhjMCA0LjQgMy42IDggOCA4aDU2YzQuNCAwIDgtMy42IDgtOHYtNDhoMTI4djU4NHpNNjg4IDQyMGgtNTUuMmMtNS4xIDAtMTAgMi41LTEzIDYuNkw0NjguOSA2MzQuNGwtNjQuNy04OWMtMy00LjEtNy44LTYuNi0xMy02LjZIMzM2Yy02LjUgMC0xMC4zIDcuNC02LjUgMTIuN2wxMjYuNCAxNzRhMTYuMSAxNi4xIDAgMDAyNiAwbDIxMi42LTI5Mi43YzMuOC01LjQgMC0xMi44LTYuNS0xMi44eiIgLz48L3N2Zz4=) */ const $f76885e21060a150$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($f76885e21060a150$var$CarryOutOutlined);
var $f76885e21060a150$export$2e2bcd8739ae039 = $f76885e21060a150$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $c8289fb3a80cd5b1$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($c8289fb3a80cd5b1$exports, "__esModule", {
    value: true
});
var $c8289fb3a80cd5b1$var$SolutionOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M688 264c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48zm-8 136H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM480 544H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-48 308H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm356.8-74.4c29-26.3 47.2-64.3 47.2-106.6 0-79.5-64.5-144-144-144s-144 64.5-144 144c0 42.3 18.2 80.3 47.2 106.6-57 32.5-96.2 92.7-99.2 162.1-.2 4.5 3.5 8.3 8 8.3h48.1c4.2 0 7.7-3.3 8-7.6C564 871.2 621.7 816 692 816s128 55.2 131.9 124.4c.2 4.2 3.7 7.6 8 7.6H880c4.6 0 8.2-3.8 8-8.3-2.9-69.5-42.2-129.6-99.2-162.1zM692 591c44.2 0 80 35.8 80 80s-35.8 80-80 80-80-35.8-80-80 35.8-80 80-80z"
                }
            }
        ]
    },
    "name": "solution",
    "theme": "outlined"
};
$c8289fb3a80cd5b1$exports.default = $c8289fb3a80cd5b1$var$SolutionOutlined;



function $d94a0f59d1b3bbaa$var$_extends() {
    $d94a0f59d1b3bbaa$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d94a0f59d1b3bbaa$var$_extends.apply(this, arguments);
}
const $d94a0f59d1b3bbaa$var$SolutionOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $d94a0f59d1b3bbaa$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($c8289fb3a80cd5b1$exports)))
    }));
/**![solution](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTY4OCAyNjRjMC00LjQtMy42LTgtOC04SDI5NmMtNC40IDAtOCAzLjYtOCA4djQ4YzAgNC40IDMuNiA4IDggOGgzODRjNC40IDAgOC0zLjYgOC04di00OHptLTggMTM2SDI5NmMtNC40IDAtOCAzLjYtOCA4djQ4YzAgNC40IDMuNiA4IDggOGgzODRjNC40IDAgOC0zLjYgOC04di00OGMwLTQuNC0zLjYtOC04LTh6TTQ4MCA1NDRIMjk2Yy00LjQgMC04IDMuNi04IDh2NDhjMCA0LjQgMy42IDggOCA4aDE4NGM0LjQgMCA4LTMuNiA4LTh2LTQ4YzAtNC40LTMuNi04LTgtOHptLTQ4IDMwOEgyMDhWMTQ4aDU2MHYzNDRjMCA0LjQgMy42IDggOCA4aDU2YzQuNCAwIDgtMy42IDgtOFYxMDhjMC0xNy43LTE0LjMtMzItMzItMzJIMTY4Yy0xNy43IDAtMzIgMTQuMy0zMiAzMnY3ODRjMCAxNy43IDE0LjMgMzIgMzIgMzJoMjY0YzQuNCAwIDgtMy42IDgtOHYtNTZjMC00LjQtMy42LTgtOC04em0zNTYuOC03NC40YzI5LTI2LjMgNDcuMi02NC4zIDQ3LjItMTA2LjYgMC03OS41LTY0LjUtMTQ0LTE0NC0xNDRzLTE0NCA2NC41LTE0NCAxNDRjMCA0Mi4zIDE4LjIgODAuMyA0Ny4yIDEwNi42LTU3IDMyLjUtOTYuMiA5Mi43LTk5LjIgMTYyLjEtLjIgNC41IDMuNSA4LjMgOCA4LjNoNDguMWM0LjIgMCA3LjctMy4zIDgtNy42QzU2NCA4NzEuMiA2MjEuNyA4MTYgNjkyIDgxNnMxMjggNTUuMiAxMzEuOSAxMjQuNGMuMiA0LjIgMy43IDcuNiA4IDcuNkg4ODBjNC42IDAgOC4yLTMuOCA4LTguMy0yLjktNjkuNS00Mi4yLTEyOS42LTk5LjItMTYyLjF6TTY5MiA1OTFjNDQuMiAwIDgwIDM1LjggODAgODBzLTM1LjggODAtODAgODAtODAtMzUuOC04MC04MCAzNS44LTgwIDgwLTgweiIgLz48L3N2Zz4=) */ const $d94a0f59d1b3bbaa$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($d94a0f59d1b3bbaa$var$SolutionOutlined);
var $d94a0f59d1b3bbaa$export$2e2bcd8739ae039 = $d94a0f59d1b3bbaa$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $07e032723ca8dde6$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($07e032723ca8dde6$exports, "__esModule", {
    value: true
});
var $07e032723ca8dde6$var$UploadOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M400 317.7h73.9V656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V317.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 163a8 8 0 00-12.6 0l-112 141.7c-4.1 5.3-.4 13 6.3 13zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "upload",
    "theme": "outlined"
};
$07e032723ca8dde6$exports.default = $07e032723ca8dde6$var$UploadOutlined;



function $08a66dd72a6d5552$var$_extends() {
    $08a66dd72a6d5552$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $08a66dd72a6d5552$var$_extends.apply(this, arguments);
}
const $08a66dd72a6d5552$var$UploadOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $08a66dd72a6d5552$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($07e032723ca8dde6$exports)))
    }));
/**![upload](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTQwMCAzMTcuN2g3My45VjY1NmMwIDQuNCAzLjYgOCA4IDhoNjBjNC40IDAgOC0zLjYgOC04VjMxNy43SDYyNGM2LjcgMCAxMC40LTcuNyA2LjMtMTIuOUw1MTguMyAxNjNhOCA4IDAgMDAtMTIuNiAwbC0xMTIgMTQxLjdjLTQuMSA1LjMtLjQgMTMgNi4zIDEzek04NzggNjI2aC02MGMtNC40IDAtOCAzLjYtOCA4djE1NEgyMTRWNjM0YzAtNC40LTMuNi04LTgtOGgtNjBjLTQuNCAwLTggMy42LTggOHYxOThjMCAxNy43IDE0LjMgMzIgMzIgMzJoNjg0YzE3LjcgMCAzMi0xNC4zIDMyLTMyVjYzNGMwLTQuNC0zLjYtOC04LTh6IiAvPjwvc3ZnPg==) */ const $08a66dd72a6d5552$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($08a66dd72a6d5552$var$UploadOutlined);
var $08a66dd72a6d5552$export$2e2bcd8739ae039 = $08a66dd72a6d5552$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $c5bedbf32b67201e$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($c5bedbf32b67201e$exports, "__esModule", {
    value: true
});
var $c5bedbf32b67201e$var$CloudUploadOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M518.3 459a8 8 0 00-12.6 0l-112 141.7a7.98 7.98 0 006.3 12.9h73.9V856c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V613.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 459z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M811.4 366.7C765.6 245.9 648.9 160 512.2 160S258.8 245.8 213 366.6C127.3 389.1 64 467.2 64 560c0 110.5 89.5 200 199.9 200H304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8h-40.1c-33.7 0-65.4-13.4-89-37.7-23.5-24.2-36-56.8-34.9-90.6.9-26.4 9.9-51.2 26.2-72.1 16.7-21.3 40.1-36.8 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0152.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10C846.1 454.5 884 503.8 884 560c0 33.1-12.9 64.3-36.3 87.7a123.07 123.07 0 01-87.6 36.3H720c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h40.1C870.5 760 960 670.5 960 560c0-92.7-63.1-170.7-148.6-193.3z"
                }
            }
        ]
    },
    "name": "cloud-upload",
    "theme": "outlined"
};
$c5bedbf32b67201e$exports.default = $c5bedbf32b67201e$var$CloudUploadOutlined;



function $1a05577e1774d0d9$var$_extends() {
    $1a05577e1774d0d9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1a05577e1774d0d9$var$_extends.apply(this, arguments);
}
const $1a05577e1774d0d9$var$CloudUploadOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $1a05577e1774d0d9$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($c5bedbf32b67201e$exports)))
    }));
/**![cloud-upload](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxOC4zIDQ1OWE4IDggMCAwMC0xMi42IDBsLTExMiAxNDEuN2E3Ljk4IDcuOTggMCAwMDYuMyAxMi45aDczLjlWODU2YzAgNC40IDMuNiA4IDggOGg2MGM0LjQgMCA4LTMuNiA4LThWNjEzLjdINjI0YzYuNyAwIDEwLjQtNy43IDYuMy0xMi45TDUxOC4zIDQ1OXoiIC8+PHBhdGggZD0iTTgxMS40IDM2Ni43Qzc2NS42IDI0NS45IDY0OC45IDE2MCA1MTIuMiAxNjBTMjU4LjggMjQ1LjggMjEzIDM2Ni42QzEyNy4zIDM4OS4xIDY0IDQ2Ny4yIDY0IDU2MGMwIDExMC41IDg5LjUgMjAwIDE5OS45IDIwMEgzMDRjNC40IDAgOC0zLjYgOC04di02MGMwLTQuNC0zLjYtOC04LThoLTQwLjFjLTMzLjcgMC02NS40LTEzLjQtODktMzcuNy0yMy41LTI0LjItMzYtNTYuOC0zNC45LTkwLjYuOS0yNi40IDkuOS01MS4yIDI2LjItNzIuMSAxNi43LTIxLjMgNDAuMS0zNi44IDY2LjEtNDMuN2wzNy45LTkuOSAxMy45LTM2LjZjOC42LTIyLjggMjAuNi00NC4xIDM1LjctNjMuNGEyNDUuNiAyNDUuNiAwIDAxNTIuNC00OS45YzQxLjEtMjguOSA4OS41LTQ0LjIgMTQwLTQ0LjJzOTguOSAxNS4zIDE0MCA0NC4yYzE5LjkgMTQgMzcuNSAzMC44IDUyLjQgNDkuOSAxNS4xIDE5LjMgMjcuMSA0MC43IDM1LjcgNjMuNGwxMy44IDM2LjUgMzcuOCAxMEM4NDYuMSA0NTQuNSA4ODQgNTAzLjggODg0IDU2MGMwIDMzLjEtMTIuOSA2NC4zLTM2LjMgODcuN2ExMjMuMDcgMTIzLjA3IDAgMDEtODcuNiAzNi4zSDcyMGMtNC40IDAtOCAzLjYtOCA4djYwYzAgNC40IDMuNiA4IDggOGg0MC4xQzg3MC41IDc2MCA5NjAgNjcwLjUgOTYwIDU2MGMwLTkyLjctNjMuMS0xNzAuNy0xNDguNi0xOTMuM3oiIC8+PC9zdmc+) */ const $1a05577e1774d0d9$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($1a05577e1774d0d9$var$CloudUploadOutlined);
var $1a05577e1774d0d9$export$2e2bcd8739ae039 = $1a05577e1774d0d9$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $4ab94d1a3bad75f3$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($4ab94d1a3bad75f3$exports, "__esModule", {
    value: true
});
var $4ab94d1a3bad75f3$var$TeamOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M824.2 699.9a301.55 301.55 0 00-86.4-60.4C783.1 602.8 812 546.8 812 484c0-110.8-92.4-201.7-203.2-200-109.1 1.7-197 90.6-197 200 0 62.8 29 118.8 74.2 155.5a300.95 300.95 0 00-86.4 60.4C345 754.6 314 826.8 312 903.8a8 8 0 008 8.2h56c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5A226.62 226.62 0 01612 684c60.9 0 118.2 23.7 161.3 66.8C814.5 792 838 846.3 840 904.3c.1 4.3 3.7 7.7 8 7.7h56a8 8 0 008-8.2c-2-77-33-149.2-87.8-203.9zM612 612c-34.2 0-66.4-13.3-90.5-37.5a126.86 126.86 0 01-37.5-91.8c.3-32.8 13.4-64.5 36.3-88 24-24.6 56.1-38.3 90.4-38.7 33.9-.3 66.8 12.9 91 36.6 24.8 24.3 38.4 56.8 38.4 91.4 0 34.2-13.3 66.3-37.5 90.5A127.3 127.3 0 01612 612zM361.5 510.4c-.9-8.7-1.4-17.5-1.4-26.4 0-15.9 1.5-31.4 4.3-46.5.7-3.6-1.2-7.3-4.5-8.8-13.6-6.1-26.1-14.5-36.9-25.1a127.54 127.54 0 01-38.7-95.4c.9-32.1 13.8-62.6 36.3-85.6 24.7-25.3 57.9-39.1 93.2-38.7 31.9.3 62.7 12.6 86 34.4 7.9 7.4 14.7 15.6 20.4 24.4 2 3.1 5.9 4.4 9.3 3.2 17.6-6.1 36.2-10.4 55.3-12.4 5.6-.6 8.8-6.6 6.3-11.6-32.5-64.3-98.9-108.7-175.7-109.9-110.9-1.7-203.3 89.2-203.3 199.9 0 62.8 28.9 118.8 74.2 155.5-31.8 14.7-61.1 35-86.5 60.4-54.8 54.7-85.8 126.9-87.8 204a8 8 0 008 8.2h56.1c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5 29.4-29.4 65.4-49.8 104.7-59.7 3.9-1 6.5-4.7 6-8.7z"
                }
            }
        ]
    },
    "name": "team",
    "theme": "outlined"
};
$4ab94d1a3bad75f3$exports.default = $4ab94d1a3bad75f3$var$TeamOutlined;



function $d5baeea001a6abe5$var$_extends() {
    $d5baeea001a6abe5$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d5baeea001a6abe5$var$_extends.apply(this, arguments);
}
const $d5baeea001a6abe5$var$TeamOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $d5baeea001a6abe5$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4ab94d1a3bad75f3$exports)))
    }));
/**![team](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTgyNC4yIDY5OS45YTMwMS41NSAzMDEuNTUgMCAwMC04Ni40LTYwLjRDNzgzLjEgNjAyLjggODEyIDU0Ni44IDgxMiA0ODRjMC0xMTAuOC05Mi40LTIwMS43LTIwMy4yLTIwMC0xMDkuMSAxLjctMTk3IDkwLjYtMTk3IDIwMCAwIDYyLjggMjkgMTE4LjggNzQuMiAxNTUuNWEzMDAuOTUgMzAwLjk1IDAgMDAtODYuNCA2MC40QzM0NSA3NTQuNiAzMTQgODI2LjggMzEyIDkwMy44YTggOCAwIDAwOCA4LjJoNTZjNC4zIDAgNy45LTMuNCA4LTcuNyAxLjktNTggMjUuNC0xMTIuMyA2Ni43LTE1My41QTIyNi42MiAyMjYuNjIgMCAwMTYxMiA2ODRjNjAuOSAwIDExOC4yIDIzLjcgMTYxLjMgNjYuOEM4MTQuNSA3OTIgODM4IDg0Ni4zIDg0MCA5MDQuM2MuMSA0LjMgMy43IDcuNyA4IDcuN2g1NmE4IDggMCAwMDgtOC4yYy0yLTc3LTMzLTE0OS4yLTg3LjgtMjAzLjl6TTYxMiA2MTJjLTM0LjIgMC02Ni40LTEzLjMtOTAuNS0zNy41YTEyNi44NiAxMjYuODYgMCAwMS0zNy41LTkxLjhjLjMtMzIuOCAxMy40LTY0LjUgMzYuMy04OCAyNC0yNC42IDU2LjEtMzguMyA5MC40LTM4LjcgMzMuOS0uMyA2Ni44IDEyLjkgOTEgMzYuNiAyNC44IDI0LjMgMzguNCA1Ni44IDM4LjQgOTEuNCAwIDM0LjItMTMuMyA2Ni4zLTM3LjUgOTAuNUExMjcuMyAxMjcuMyAwIDAxNjEyIDYxMnpNMzYxLjUgNTEwLjRjLS45LTguNy0xLjQtMTcuNS0xLjQtMjYuNCAwLTE1LjkgMS41LTMxLjQgNC4zLTQ2LjUuNy0zLjYtMS4yLTcuMy00LjUtOC44LTEzLjYtNi4xLTI2LjEtMTQuNS0zNi45LTI1LjFhMTI3LjU0IDEyNy41NCAwIDAxLTM4LjctOTUuNGMuOS0zMi4xIDEzLjgtNjIuNiAzNi4zLTg1LjYgMjQuNy0yNS4zIDU3LjktMzkuMSA5My4yLTM4LjcgMzEuOS4zIDYyLjcgMTIuNiA4NiAzNC40IDcuOSA3LjQgMTQuNyAxNS42IDIwLjQgMjQuNCAyIDMuMSA1LjkgNC40IDkuMyAzLjIgMTcuNi02LjEgMzYuMi0xMC40IDU1LjMtMTIuNCA1LjYtLjYgOC44LTYuNiA2LjMtMTEuNi0zMi41LTY0LjMtOTguOS0xMDguNy0xNzUuNy0xMDkuOS0xMTAuOS0xLjctMjAzLjMgODkuMi0yMDMuMyAxOTkuOSAwIDYyLjggMjguOSAxMTguOCA3NC4yIDE1NS41LTMxLjggMTQuNy02MS4xIDM1LTg2LjUgNjAuNC01NC44IDU0LjctODUuOCAxMjYuOS04Ny44IDIwNGE4IDggMCAwMDggOC4yaDU2LjFjNC4zIDAgNy45LTMuNCA4LTcuNyAxLjktNTggMjUuNC0xMTIuMyA2Ni43LTE1My41IDI5LjQtMjkuNCA2NS40LTQ5LjggMTA0LjctNTkuNyAzLjktMSA2LjUtNC43IDYtOC43eiIgLz48L3N2Zz4=) */ const $d5baeea001a6abe5$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($d5baeea001a6abe5$var$TeamOutlined);
var $d5baeea001a6abe5$export$2e2bcd8739ae039 = $d5baeea001a6abe5$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $86901ca787e5a70d$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($86901ca787e5a70d$exports, "__esModule", {
    value: true
});
var $86901ca787e5a70d$var$ClusterOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M888 680h-54V540H546v-92h238c8.8 0 16-7.2 16-16V168c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16v264c0 8.8 7.2 16 16 16h238v92H190v140h-54c-4.4 0-8 3.6-8 8v176c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8V688c0-4.4-3.6-8-8-8h-54v-72h220v72h-54c-4.4 0-8 3.6-8 8v176c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8V688c0-4.4-3.6-8-8-8h-54v-72h220v72h-54c-4.4 0-8 3.6-8 8v176c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8V688c0-4.4-3.6-8-8-8zM256 805.3c0 1.5-1.2 2.7-2.7 2.7h-58.7c-1.5 0-2.7-1.2-2.7-2.7v-58.7c0-1.5 1.2-2.7 2.7-2.7h58.7c1.5 0 2.7 1.2 2.7 2.7v58.7zm288 0c0 1.5-1.2 2.7-2.7 2.7h-58.7c-1.5 0-2.7-1.2-2.7-2.7v-58.7c0-1.5 1.2-2.7 2.7-2.7h58.7c1.5 0 2.7 1.2 2.7 2.7v58.7zM288 384V216h448v168H288zm544 421.3c0 1.5-1.2 2.7-2.7 2.7h-58.7c-1.5 0-2.7-1.2-2.7-2.7v-58.7c0-1.5 1.2-2.7 2.7-2.7h58.7c1.5 0 2.7 1.2 2.7 2.7v58.7zM360 300a40 40 0 1080 0 40 40 0 10-80 0z"
                }
            }
        ]
    },
    "name": "cluster",
    "theme": "outlined"
};
$86901ca787e5a70d$exports.default = $86901ca787e5a70d$var$ClusterOutlined;



function $f48fe90789d2a71a$var$_extends() {
    $f48fe90789d2a71a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f48fe90789d2a71a$var$_extends.apply(this, arguments);
}
const $f48fe90789d2a71a$var$ClusterOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $f48fe90789d2a71a$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($86901ca787e5a70d$exports)))
    }));
/**![cluster](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg4OCA2ODBoLTU0VjU0MEg1NDZ2LTkyaDIzOGM4LjggMCAxNi03LjIgMTYtMTZWMTY4YzAtOC44LTcuMi0xNi0xNi0xNkgyNDBjLTguOCAwLTE2IDcuMi0xNiAxNnYyNjRjMCA4LjggNy4yIDE2IDE2IDE2aDIzOHY5MkgxOTB2MTQwaC01NGMtNC40IDAtOCAzLjYtOCA4djE3NmMwIDQuNCAzLjYgOCA4IDhoMTc2YzQuNCAwIDgtMy42IDgtOFY2ODhjMC00LjQtMy42LTgtOC04aC01NHYtNzJoMjIwdjcyaC01NGMtNC40IDAtOCAzLjYtOCA4djE3NmMwIDQuNCAzLjYgOCA4IDhoMTc2YzQuNCAwIDgtMy42IDgtOFY2ODhjMC00LjQtMy42LTgtOC04aC01NHYtNzJoMjIwdjcyaC01NGMtNC40IDAtOCAzLjYtOCA4djE3NmMwIDQuNCAzLjYgOCA4IDhoMTc2YzQuNCAwIDgtMy42IDgtOFY2ODhjMC00LjQtMy42LTgtOC04ek0yNTYgODA1LjNjMCAxLjUtMS4yIDIuNy0yLjcgMi43aC01OC43Yy0xLjUgMC0yLjctMS4yLTIuNy0yLjd2LTU4LjdjMC0xLjUgMS4yLTIuNyAyLjctMi43aDU4LjdjMS41IDAgMi43IDEuMiAyLjcgMi43djU4Ljd6bTI4OCAwYzAgMS41LTEuMiAyLjctMi43IDIuN2gtNTguN2MtMS41IDAtMi43LTEuMi0yLjctMi43di01OC43YzAtMS41IDEuMi0yLjcgMi43LTIuN2g1OC43YzEuNSAwIDIuNyAxLjIgMi43IDIuN3Y1OC43ek0yODggMzg0VjIxNmg0NDh2MTY4SDI4OHptNTQ0IDQyMS4zYzAgMS41LTEuMiAyLjctMi43IDIuN2gtNTguN2MtMS41IDAtMi43LTEuMi0yLjctMi43di01OC43YzAtMS41IDEuMi0yLjcgMi43LTIuN2g1OC43YzEuNSAwIDIuNyAxLjIgMi43IDIuN3Y1OC43ek0zNjAgMzAwYTQwIDQwIDAgMTA4MCAwIDQwIDQwIDAgMTAtODAgMHoiIC8+PC9zdmc+) */ const $f48fe90789d2a71a$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($f48fe90789d2a71a$var$ClusterOutlined);
var $f48fe90789d2a71a$export$2e2bcd8739ae039 = $f48fe90789d2a71a$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $003ba31ac8c5d1e8$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($003ba31ac8c5d1e8$exports, "__esModule", {
    value: true
});
var $003ba31ac8c5d1e8$var$AppstoreOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M464 144H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H212V212h200v200zm452-268H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H612V212h200v200zM464 544H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H212V612h200v200zm452-268H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H612V612h200v200z"
                }
            }
        ]
    },
    "name": "appstore",
    "theme": "outlined"
};
$003ba31ac8c5d1e8$exports.default = $003ba31ac8c5d1e8$var$AppstoreOutlined;



function $e6f9777135677668$var$_extends() {
    $e6f9777135677668$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e6f9777135677668$var$_extends.apply(this, arguments);
}
const $e6f9777135677668$var$AppstoreOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $e6f9777135677668$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($003ba31ac8c5d1e8$exports)))
    }));
/**![appstore](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTQ2NCAxNDRIMTYwYy04LjggMC0xNiA3LjItMTYgMTZ2MzA0YzAgOC44IDcuMiAxNiAxNiAxNmgzMDRjOC44IDAgMTYtNy4yIDE2LTE2VjE2MGMwLTguOC03LjItMTYtMTYtMTZ6bS01MiAyNjhIMjEyVjIxMmgyMDB2MjAwem00NTItMjY4SDU2MGMtOC44IDAtMTYgNy4yLTE2IDE2djMwNGMwIDguOCA3LjIgMTYgMTYgMTZoMzA0YzguOCAwIDE2LTcuMiAxNi0xNlYxNjBjMC04LjgtNy4yLTE2LTE2LTE2em0tNTIgMjY4SDYxMlYyMTJoMjAwdjIwMHpNNDY0IDU0NEgxNjBjLTguOCAwLTE2IDcuMi0xNiAxNnYzMDRjMCA4LjggNy4yIDE2IDE2IDE2aDMwNGM4LjggMCAxNi03LjIgMTYtMTZWNTYwYzAtOC44LTcuMi0xNi0xNi0xNnptLTUyIDI2OEgyMTJWNjEyaDIwMHYyMDB6bTQ1Mi0yNjhINTYwYy04LjggMC0xNiA3LjItMTYgMTZ2MzA0YzAgOC44IDcuMiAxNiAxNiAxNmgzMDRjOC44IDAgMTYtNy4yIDE2LTE2VjU2MGMwLTguOC03LjItMTYtMTYtMTZ6bS01MiAyNjhINjEyVjYxMmgyMDB2MjAweiIgLz48L3N2Zz4=) */ const $e6f9777135677668$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($e6f9777135677668$var$AppstoreOutlined);
var $e6f9777135677668$export$2e2bcd8739ae039 = $e6f9777135677668$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $43e61a5d07e292c2$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($43e61a5d07e292c2$exports, "__esModule", {
    value: true
});
var $43e61a5d07e292c2$var$GlobalOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M854.4 800.9c.2-.3.5-.6.7-.9C920.6 722.1 960 621.7 960 512s-39.4-210.1-104.8-288c-.2-.3-.5-.5-.7-.8-1.1-1.3-2.1-2.5-3.2-3.7-.4-.5-.8-.9-1.2-1.4l-4.1-4.7-.1-.1c-1.5-1.7-3.1-3.4-4.6-5.1l-.1-.1c-3.2-3.4-6.4-6.8-9.7-10.1l-.1-.1-4.8-4.8-.3-.3c-1.5-1.5-3-2.9-4.5-4.3-.5-.5-1-1-1.6-1.5-1-1-2-1.9-3-2.8-.3-.3-.7-.6-1-1C736.4 109.2 629.5 64 512 64s-224.4 45.2-304.3 119.2c-.3.3-.7.6-1 1-1 .9-2 1.9-3 2.9-.5.5-1 1-1.6 1.5-1.5 1.4-3 2.9-4.5 4.3l-.3.3-4.8 4.8-.1.1c-3.3 3.3-6.5 6.7-9.7 10.1l-.1.1c-1.6 1.7-3.1 3.4-4.6 5.1l-.1.1c-1.4 1.5-2.8 3.1-4.1 4.7-.4.5-.8.9-1.2 1.4-1.1 1.2-2.1 2.5-3.2 3.7-.2.3-.5.5-.7.8C103.4 301.9 64 402.3 64 512s39.4 210.1 104.8 288c.2.3.5.6.7.9l3.1 3.7c.4.5.8.9 1.2 1.4l4.1 4.7c0 .1.1.1.1.2 1.5 1.7 3 3.4 4.6 5l.1.1c3.2 3.4 6.4 6.8 9.6 10.1l.1.1c1.6 1.6 3.1 3.2 4.7 4.7l.3.3c3.3 3.3 6.7 6.5 10.1 9.6 80.1 74 187 119.2 304.5 119.2s224.4-45.2 304.3-119.2a300 300 0 0010-9.6l.3-.3c1.6-1.6 3.2-3.1 4.7-4.7l.1-.1c3.3-3.3 6.5-6.7 9.6-10.1l.1-.1c1.5-1.7 3.1-3.3 4.6-5 0-.1.1-.1.1-.2 1.4-1.5 2.8-3.1 4.1-4.7.4-.5.8-.9 1.2-1.4a99 99 0 003.3-3.7zm4.1-142.6c-13.8 32.6-32 62.8-54.2 90.2a444.07 444.07 0 00-81.5-55.9c11.6-46.9 18.8-98.4 20.7-152.6H887c-3 40.9-12.6 80.6-28.5 118.3zM887 484H743.5c-1.9-54.2-9.1-105.7-20.7-152.6 29.3-15.6 56.6-34.4 81.5-55.9A373.86 373.86 0 01887 484zM658.3 165.5c39.7 16.8 75.8 40 107.6 69.2a394.72 394.72 0 01-59.4 41.8c-15.7-45-35.8-84.1-59.2-115.4 3.7 1.4 7.4 2.9 11 4.4zm-90.6 700.6c-9.2 7.2-18.4 12.7-27.7 16.4V697a389.1 389.1 0 01115.7 26.2c-8.3 24.6-17.9 47.3-29 67.8-17.4 32.4-37.8 58.3-59 75.1zm59-633.1c11 20.6 20.7 43.3 29 67.8A389.1 389.1 0 01540 327V141.6c9.2 3.7 18.5 9.1 27.7 16.4 21.2 16.7 41.6 42.6 59 75zM540 640.9V540h147.5c-1.6 44.2-7.1 87.1-16.3 127.8l-.3 1.2A445.02 445.02 0 00540 640.9zm0-156.9V383.1c45.8-2.8 89.8-12.5 130.9-28.1l.3 1.2c9.2 40.7 14.7 83.5 16.3 127.8H540zm-56 56v100.9c-45.8 2.8-89.8 12.5-130.9 28.1l-.3-1.2c-9.2-40.7-14.7-83.5-16.3-127.8H484zm-147.5-56c1.6-44.2 7.1-87.1 16.3-127.8l.3-1.2c41.1 15.6 85 25.3 130.9 28.1V484H336.5zM484 697v185.4c-9.2-3.7-18.5-9.1-27.7-16.4-21.2-16.7-41.7-42.7-59.1-75.1-11-20.6-20.7-43.3-29-67.8 37.2-14.6 75.9-23.3 115.8-26.1zm0-370a389.1 389.1 0 01-115.7-26.2c8.3-24.6 17.9-47.3 29-67.8 17.4-32.4 37.8-58.4 59.1-75.1 9.2-7.2 18.4-12.7 27.7-16.4V327zM365.7 165.5c3.7-1.5 7.3-3 11-4.4-23.4 31.3-43.5 70.4-59.2 115.4-21-12-40.9-26-59.4-41.8 31.8-29.2 67.9-52.4 107.6-69.2zM165.5 365.7c13.8-32.6 32-62.8 54.2-90.2 24.9 21.5 52.2 40.3 81.5 55.9-11.6 46.9-18.8 98.4-20.7 152.6H137c3-40.9 12.6-80.6 28.5-118.3zM137 540h143.5c1.9 54.2 9.1 105.7 20.7 152.6a444.07 444.07 0 00-81.5 55.9A373.86 373.86 0 01137 540zm228.7 318.5c-39.7-16.8-75.8-40-107.6-69.2 18.5-15.8 38.4-29.7 59.4-41.8 15.7 45 35.8 84.1 59.2 115.4-3.7-1.4-7.4-2.9-11-4.4zm292.6 0c-3.7 1.5-7.3 3-11 4.4 23.4-31.3 43.5-70.4 59.2-115.4 21 12 40.9 26 59.4 41.8a373.81 373.81 0 01-107.6 69.2z"
                }
            }
        ]
    },
    "name": "global",
    "theme": "outlined"
};
$43e61a5d07e292c2$exports.default = $43e61a5d07e292c2$var$GlobalOutlined;



function $8afda6637c46830f$var$_extends() {
    $8afda6637c46830f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8afda6637c46830f$var$_extends.apply(this, arguments);
}
const $8afda6637c46830f$var$GlobalOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $8afda6637c46830f$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($43e61a5d07e292c2$exports)))
    }));
/**![global](data:image/svg+xml;base64,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) */ const $8afda6637c46830f$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($8afda6637c46830f$var$GlobalOutlined);
var $8afda6637c46830f$export$2e2bcd8739ae039 = $8afda6637c46830f$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $43e557bece7e5675$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($43e557bece7e5675$exports, "__esModule", {
    value: true
});
var $43e557bece7e5675$var$CompassOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm198.4-588.1a32 32 0 00-24.5.5L414.9 415 296.4 686c-3.6 8.2-3.6 17.5 0 25.7 3.4 7.8 9.7 13.9 17.7 17 3.8 1.5 7.7 2.2 11.7 2.2 4.4 0 8.7-.9 12.8-2.7l271-118.6 118.5-271a32.06 32.06 0 00-17.7-42.7zM576.8 534.4l26.2 26.2-42.4 42.4-26.2-26.2L380 644.4 447.5 490 422 464.4l42.4-42.4 25.5 25.5L644.4 380l-67.6 154.4zM464.4 422L422 464.4l25.5 25.6 86.9 86.8 26.2 26.2 42.4-42.4-26.2-26.2-86.8-86.9z"
                }
            }
        ]
    },
    "name": "compass",
    "theme": "outlined"
};
$43e557bece7e5675$exports.default = $43e557bece7e5675$var$CompassOutlined;



function $68eebcef827bb540$var$_extends() {
    $68eebcef827bb540$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $68eebcef827bb540$var$_extends.apply(this, arguments);
}
const $68eebcef827bb540$var$CompassOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $68eebcef827bb540$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($43e557bece7e5675$exports)))
    }));
/**![compass](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0wIDgyMGMtMjA1LjQgMC0zNzItMTY2LjYtMzcyLTM3MnMxNjYuNi0zNzIgMzcyLTM3MiAzNzIgMTY2LjYgMzcyIDM3Mi0xNjYuNiAzNzItMzcyIDM3MnptMTk4LjQtNTg4LjFhMzIgMzIgMCAwMC0yNC41LjVMNDE0LjkgNDE1IDI5Ni40IDY4NmMtMy42IDguMi0zLjYgMTcuNSAwIDI1LjcgMy40IDcuOCA5LjcgMTMuOSAxNy43IDE3IDMuOCAxLjUgNy43IDIuMiAxMS43IDIuMiA0LjQgMCA4LjctLjkgMTIuOC0yLjdsMjcxLTExOC42IDExOC41LTI3MWEzMi4wNiAzMi4wNiAwIDAwLTE3LjctNDIuN3pNNTc2LjggNTM0LjRsMjYuMiAyNi4yLTQyLjQgNDIuNC0yNi4yLTI2LjJMMzgwIDY0NC40IDQ0Ny41IDQ5MCA0MjIgNDY0LjRsNDIuNC00Mi40IDI1LjUgMjUuNUw2NDQuNCAzODBsLTY3LjYgMTU0LjR6TTQ2NC40IDQyMkw0MjIgNDY0LjRsMjUuNSAyNS42IDg2LjkgODYuOCAyNi4yIDI2LjIgNDIuNC00Mi40LTI2LjItMjYuMi04Ni44LTg2Ljl6IiAvPjwvc3ZnPg==) */ const $68eebcef827bb540$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($68eebcef827bb540$var$CompassOutlined);
var $68eebcef827bb540$export$2e2bcd8739ae039 = $68eebcef827bb540$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $07b73b60041c51a3$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($07b73b60041c51a3$exports, "__esModule", {
    value: true
});
var $07b73b60041c51a3$var$ApartmentOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M908 640H804V488c0-4.4-3.6-8-8-8H548v-96h108c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h108v96H228c-4.4 0-8 3.6-8 8v152H116c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16V656c0-8.8-7.2-16-16-16H292v-88h440v88H620c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16V656c0-8.8-7.2-16-16-16zm-564 76v168H176V716h168zm84-408V140h168v168H428zm420 576H680V716h168v168z"
                }
            }
        ]
    },
    "name": "apartment",
    "theme": "outlined"
};
$07b73b60041c51a3$exports.default = $07b73b60041c51a3$var$ApartmentOutlined;



function $68e85fc2f9283018$var$_extends() {
    $68e85fc2f9283018$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $68e85fc2f9283018$var$_extends.apply(this, arguments);
}
const $68e85fc2f9283018$var$ApartmentOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $68e85fc2f9283018$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($07b73b60041c51a3$exports)))
    }));
/**![apartment](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkwOCA2NDBIODA0VjQ4OGMwLTQuNC0zLjYtOC04LThINTQ4di05NmgxMDhjOC44IDAgMTYtNy4yIDE2LTE2VjgwYzAtOC44LTcuMi0xNi0xNi0xNkgzNjhjLTguOCAwLTE2IDcuMi0xNiAxNnYyODhjMCA4LjggNy4yIDE2IDE2IDE2aDEwOHY5NkgyMjhjLTQuNCAwLTggMy42LTggOHYxNTJIMTE2Yy04LjggMC0xNiA3LjItMTYgMTZ2Mjg4YzAgOC44IDcuMiAxNiAxNiAxNmgyODhjOC44IDAgMTYtNy4yIDE2LTE2VjY1NmMwLTguOC03LjItMTYtMTYtMTZIMjkydi04OGg0NDB2ODhINjIwYy04LjggMC0xNiA3LjItMTYgMTZ2Mjg4YzAgOC44IDcuMiAxNiAxNiAxNmgyODhjOC44IDAgMTYtNy4yIDE2LTE2VjY1NmMwLTguOC03LjItMTYtMTYtMTZ6bS01NjQgNzZ2MTY4SDE3NlY3MTZoMTY4em04NC00MDhWMTQwaDE2OHYxNjhINDI4em00MjAgNTc2SDY4MFY3MTZoMTY4djE2OHoiIC8+PC9zdmc+) */ const $68e85fc2f9283018$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($68e85fc2f9283018$var$ApartmentOutlined);
var $68e85fc2f9283018$export$2e2bcd8739ae039 = $68e85fc2f9283018$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $9c3ea9cf5e216b30$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($9c3ea9cf5e216b30$exports, "__esModule", {
    value: true
});
var $9c3ea9cf5e216b30$var$GroupOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M912 820.1V203.9c28-9.9 48-36.6 48-67.9 0-39.8-32.2-72-72-72-31.3 0-58 20-67.9 48H203.9C194 84 167.3 64 136 64c-39.8 0-72 32.2-72 72 0 31.3 20 58 48 67.9v616.2C84 830 64 856.7 64 888c0 39.8 32.2 72 72 72 31.3 0 58-20 67.9-48h616.2c9.9 28 36.6 48 67.9 48 39.8 0 72-32.2 72-72 0-31.3-20-58-48-67.9zM888 112c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zM136 912c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0-752c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm704 680H184V184h656v656zm48 72c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M288 474h448c8.8 0 16-7.2 16-16V282c0-8.8-7.2-16-16-16H288c-8.8 0-16 7.2-16 16v176c0 8.8 7.2 16 16 16zm56-136h336v64H344v-64zm-56 420h448c8.8 0 16-7.2 16-16V566c0-8.8-7.2-16-16-16H288c-8.8 0-16 7.2-16 16v176c0 8.8 7.2 16 16 16zm56-136h336v64H344v-64z"
                }
            }
        ]
    },
    "name": "group",
    "theme": "outlined"
};
$9c3ea9cf5e216b30$exports.default = $9c3ea9cf5e216b30$var$GroupOutlined;



function $8e67197b587f6486$var$_extends() {
    $8e67197b587f6486$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8e67197b587f6486$var$_extends.apply(this, arguments);
}
const $8e67197b587f6486$var$GroupOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $8e67197b587f6486$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9c3ea9cf5e216b30$exports)))
    }));
/**![group](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkxMiA4MjAuMVYyMDMuOWMyOC05LjkgNDgtMzYuNiA0OC02Ny45IDAtMzkuOC0zMi4yLTcyLTcyLTcyLTMxLjMgMC01OCAyMC02Ny45IDQ4SDIwMy45QzE5NCA4NCAxNjcuMyA2NCAxMzYgNjRjLTM5LjggMC03MiAzMi4yLTcyIDcyIDAgMzEuMyAyMCA1OCA0OCA2Ny45djYxNi4yQzg0IDgzMCA2NCA4NTYuNyA2NCA4ODhjMCAzOS44IDMyLjIgNzIgNzIgNzIgMzEuMyAwIDU4LTIwIDY3LjktNDhoNjE2LjJjOS45IDI4IDM2LjYgNDggNjcuOSA0OCAzOS44IDAgNzItMzIuMiA3Mi03MiAwLTMxLjMtMjAtNTgtNDgtNjcuOXpNODg4IDExMmMxMy4zIDAgMjQgMTAuNyAyNCAyNHMtMTAuNyAyNC0yNCAyNC0yNC0xMC43LTI0LTI0IDEwLjctMjQgMjQtMjR6TTEzNiA5MTJjLTEzLjMgMC0yNC0xMC43LTI0LTI0czEwLjctMjQgMjQtMjQgMjQgMTAuNyAyNCAyNC0xMC43IDI0LTI0IDI0em0wLTc1MmMtMTMuMyAwLTI0LTEwLjctMjQtMjRzMTAuNy0yNCAyNC0yNCAyNCAxMC43IDI0IDI0LTEwLjcgMjQtMjQgMjR6bTcwNCA2ODBIMTg0VjE4NGg2NTZ2NjU2em00OCA3MmMtMTMuMyAwLTI0LTEwLjctMjQtMjRzMTAuNy0yNCAyNC0yNCAyNCAxMC43IDI0IDI0LTEwLjcgMjQtMjQgMjR6IiAvPjxwYXRoIGQ9Ik0yODggNDc0aDQ0OGM4LjggMCAxNi03LjIgMTYtMTZWMjgyYzAtOC44LTcuMi0xNi0xNi0xNkgyODhjLTguOCAwLTE2IDcuMi0xNiAxNnYxNzZjMCA4LjggNy4yIDE2IDE2IDE2em01Ni0xMzZoMzM2djY0SDM0NHYtNjR6bS01NiA0MjBoNDQ4YzguOCAwIDE2LTcuMiAxNi0xNlY1NjZjMC04LjgtNy4yLTE2LTE2LTE2SDI4OGMtOC44IDAtMTYgNy4yLTE2IDE2djE3NmMwIDguOCA3LjIgMTYgMTYgMTZ6bTU2LTEzNmgzMzZ2NjRIMzQ0di02NHoiIC8+PC9zdmc+) */ const $8e67197b587f6486$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($8e67197b587f6486$var$GroupOutlined);
var $8e67197b587f6486$export$2e2bcd8739ae039 = $8e67197b587f6486$var$RefIcon;







/**
 * Navigation model. `icon` names come from the verified mapping in
 * docs/design/spec/02-components.md#icons — 20 entries, all distinct, so no two nav rows share
 * a glyph. `role` gates visibility; "all" means every signed-in role.
 */ const $c6c8415f44fd661c$var$MENU = [
    {
        type: "section",
        key: "sec_overview",
        label: {
            uk: "\u041E\u0433\u043B\u044F\u0434",
            en: "Overview",
            hy: "\u0531\u056F\u0576\u0561\u0580\u056F",
            ka: "\u10DB\u10D8\u10DB\u10DD\u10EE\u10D8\u10DA\u10D5\u10D0"
        },
        role: [
            "all"
        ]
    },
    {
        name: "overview",
        path: "/overview",
        Icon: (0, $71d4184078fbbc48$export$2e2bcd8739ae039),
        role: [
            "all"
        ]
    },
    {
        type: "section",
        key: "sec_main",
        label: {
            uk: "\u041E\u0441\u043D\u043E\u0432\u043D\u0435",
            en: "Main",
            hy: "\u0540\u056B\u0574\u0576\u0561\u056F\u0561\u0576",
            ka: "\u10DB\u10D7\u10D0\u10D5\u10D0\u10E0\u10D8"
        },
        role: [
            "all"
        ]
    },
    {
        name: "photo_report",
        path: "/photo-review",
        Icon: (0, $3602cb83fb466795$export$2e2bcd8739ae039),
        role: [
            "all"
        ]
    },
    {
        name: "visit",
        path: "/visit",
        Icon: (0, $d6c8837c82724a15$export$2e2bcd8739ae039),
        role: [
            "all"
        ]
    },
    {
        name: "tracking",
        path: "/tracking",
        Icon: (0, $5432cf81954535cc$export$2e2bcd8739ae039),
        role: [
            "all"
        ]
    },
    {
        name: "all_reports",
        path: "/bi-report",
        Icon: (0, $235e2c6c1e527cba$export$2e2bcd8739ae039),
        role: [
            "all"
        ]
    },
    {
        type: "section",
        key: "sec_management",
        label: {
            uk: "\u0423\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F",
            en: "Management",
            hy: "\u053F\u0561\u057C\u0561\u057E\u0561\u0580\u0578\u0582\u0574",
            ka: "\u10DB\u10D0\u10E0\u10D7\u10D5\u10D0"
        },
        role: [
            "all"
        ]
    },
    {
        name: "tasks",
        path: "/task",
        Icon: (0, $f76885e21060a150$export$2e2bcd8739ae039),
        role: [
            "all"
        ]
    },
    {
        name: "answers",
        path: "/answers",
        Icon: (0, $d94a0f59d1b3bbaa$export$2e2bcd8739ae039),
        role: [
            "all"
        ]
    },
    /* Two rows, two routes. They used to be `/tasks-import/3` and `/tasks-import` — one route with
     the tab index in the path — which `activeKey` resolved correctly only by the accident that
     `/tasks-import/3` is the longer string. */ {
        name: "my_uploads",
        path: "/uploads",
        Icon: (0, $08a66dd72a6d5552$export$2e2bcd8739ae039),
        role: [
            "supervisor_manager"
        ]
    },
    {
        name: "task_uploading",
        path: "/import",
        Icon: (0, $1a05577e1774d0d9$export$2e2bcd8739ae039),
        role: [
            "supervisor_manager"
        ]
    },
    {
        type: "section",
        key: "sec_personnel",
        label: {
            uk: "\u0423\u043F\u0440\u0430\u0432\u043B\u0456\u043D\u043D\u044F \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u043E\u043C",
            en: "Personnel management",
            hy: "\u0531\u0576\u0571\u0576\u0561\u056F\u0561\u0566\u0574\u056B \u056F\u0561\u057C\u0561\u057E\u0561\u0580\u0578\u0582\u0574",
            ka: "\u10DE\u10D4\u10E0\u10E1\u10DD\u10DC\u10D0\u10DA\u10D8\u10E1 \u10DB\u10D0\u10E0\u10D7\u10D5\u10D0"
        },
        role: [
            "all"
        ]
    },
    {
        name: "merchandiser",
        path: "/merchandiser",
        Icon: (0, $e85f2e3cc711f245$export$2e2bcd8739ae039),
        role: [
            "all"
        ]
    },
    {
        name: "supervisors",
        path: "/supervisors",
        Icon: (0, $d5baeea001a6abe5$export$2e2bcd8739ae039),
        role: [
            "supervisor_manager"
        ]
    },
    {
        type: "section",
        key: "sec_data",
        label: {
            uk: "\u0414\u0430\u043D\u0456",
            en: "Data",
            hy: "\u054F\u057E\u0575\u0561\u056C\u0576\u0565\u0580",
            ka: "\u10DB\u10DD\u10DC\u10D0\u10EA\u10D4\u10DB\u10D4\u10D1\u10D8"
        },
        role: [
            "supervisor_manager",
            "supervisor"
        ]
    },
    {
        name: "documents",
        path: "/document",
        Icon: (0, $3ad3610a8cd8d8e0$export$2e2bcd8739ae039),
        role: [
            "all"
        ]
    },
    {
        type: "section",
        key: "sec_surveys",
        label: {
            uk: "\u041E\u043F\u0438\u0442\u0443\u0432\u0430\u043D\u043D\u044F",
            en: "Surveys",
            hy: "\u0540\u0561\u0580\u0581\u0578\u0582\u0574\u0576\u0565\u0580",
            ka: "\u10D2\u10D0\u10DB\u10DD\u10D9\u10D8\u10D7\u10EE\u10D5\u10D4\u10D1\u10D8"
        },
        role: [
            "supervisor_manager",
            "supervisor"
        ]
    },
    {
        name: "pt_surveys",
        path: "/surveys",
        Icon: (0, $170c031fa50279f7$export$2e2bcd8739ae039),
        role: [
            "supervisor_manager",
            "supervisor"
        ]
    },
    {
        type: "section",
        key: "sec_points",
        label: {
            uk: "\u0422\u043E\u0447\u043A\u0438",
            en: "Points",
            hy: "\u053F\u0565\u057F\u0565\u0580",
            ka: "\u10EC\u10D4\u10E0\u10E2\u10D8\u10DA\u10D4\u10D1\u10D8"
        },
        role: [
            "supervisor_manager",
            "supervisor"
        ]
    },
    {
        name: "pt_points",
        path: "/points",
        Icon: (0, $a1f80a723f71d713$export$2e2bcd8739ae039),
        role: [
            "supervisor_manager",
            "supervisor"
        ]
    },
    {
        name: "pt_networks",
        path: "/networks",
        Icon: (0, $f48fe90789d2a71a$export$2e2bcd8739ae039),
        role: [
            "supervisor_manager",
            "supervisor"
        ]
    },
    {
        name: "pt_categories",
        path: "/categories",
        Icon: (0, $e6f9777135677668$export$2e2bcd8739ae039),
        role: [
            "supervisor_manager",
            "supervisor"
        ]
    },
    {
        name: "pt_countries",
        path: "/countries",
        Icon: (0, $8afda6637c46830f$export$2e2bcd8739ae039),
        role: [
            "supervisor_manager",
            "supervisor"
        ]
    },
    {
        name: "pt_counties",
        path: "/counties",
        Icon: (0, $68eebcef827bb540$export$2e2bcd8739ae039),
        role: [
            "supervisor_manager",
            "supervisor"
        ]
    },
    {
        name: "pt_localities",
        path: "/localities",
        Icon: (0, $68e85fc2f9283018$export$2e2bcd8739ae039),
        role: [
            "supervisor_manager",
            "supervisor"
        ]
    },
    {
        name: "pt_point_groups",
        path: "/point_groups",
        Icon: (0, $8e67197b587f6486$export$2e2bcd8739ae039),
        role: [
            "supervisor_manager",
            "supervisor"
        ]
    }
];
const $c6c8415f44fd661c$var$hasRole = (itemRole, userRole)=>Array.isArray(itemRole) ? itemRole.includes(userRole) || itemRole.includes("all") : itemRole === userRole || itemRole === "all";
const $c6c8415f44fd661c$export$e9d5f14ba05b3c5d = (path, role)=>$c6c8415f44fd661c$var$MENU.some((i)=>i.path === path && $c6c8415f44fd661c$var$hasRole(i.role, role));
/** Longest matching path wins, so /points/12 highlights Points rather than nothing. */ function $c6c8415f44fd661c$var$activeKey(pathname, items) {
    const paths = items.filter((i)=>!i.type).map((i)=>i.path);
    const matches = paths.filter((p)=>pathname === p || pathname.startsWith(p + "/"));
    return matches.sort((a, b)=>b.length - a.length)[0];
}
function $c6c8415f44fd661c$export$2e2bcd8739ae039({ onNavigate: onNavigate }) {
    const me = (0, $b83e93e5ef3de8b0$export$2105062e25df4afe)((state)=>state.me);
    const dispatch = (0, $b83e93e5ef3de8b0$export$8ad76b76a4c905f8)();
    const { pathname: pathname } = (0, $6f5d68f762d5488a$export$45d76561a5302f2b)();
    const lang = me?.language;
    const items = (0, $cQmXV.useMemo)(()=>{
        const visible = $c6c8415f44fd661c$var$MENU.filter((i)=>$c6c8415f44fd661c$var$hasRole(i.role, me?.role));
        const out = [];
        for (const item of visible){
            if (item.type === "section") {
                out.push({
                    key: item.key,
                    type: "group",
                    label: item.label[lang] || item.label.en || item.label.uk
                });
                continue;
            }
            const label = (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$72266474e9355649), item.name, lang) || item.name;
            out.push({
                key: item.path,
                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)(item.Icon, {}),
                label: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $50f22649d61cdefc$export$a6c7ac8248d6e38a), {
                    to: item.path,
                    onClick: onNavigate,
                    children: label
                })
            });
        }
        return out;
    }, [
        me?.role,
        lang,
        onNavigate
    ]);
    const logoutLabel = (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$72266474e9355649), "logout", lang) || "Logout";
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $575603080129eb00$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $9669e71ca8202aee$export$2e2bcd8739ae039), {
                className: "shell-nav",
                theme: "dark",
                mode: "inline",
                /* Groups are not selectable, so a group key can never be "selected" here. */ selectedKeys: [
                    $c6c8415f44fd661c$var$activeKey(pathname, $c6c8415f44fd661c$var$MENU)
                ].filter(Boolean),
                items: items
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                className: "shell-nav__foot",
                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("button", {
                    className: "shell-logout",
                    type: "button",
                    onClick: ()=>dispatch((0, $cca4416321e611bf$export$a0973bcfe11b05c9)()),
                    children: [
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $27dfd059157cea02$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                            children: logoutLabel
                        })
                    ]
                })
            })
        ]
    });
}



/** Matches the `max-width: 900px` breakpoint in shell.scss, where the sidebar becomes a drawer. */ const $bad73bdcced7d027$var$MOBILE_QUERY = "(max-width: 900px)";
function $bad73bdcced7d027$var$Brand() {
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
        className: "shell-brand",
        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($39824af573644a06$exports))),
            alt: "Picsell"
        })
    });
}
function $bad73bdcced7d027$export$2e2bcd8739ae039({ lang: lang, children: children }) {
    const location = (0, $6f5d68f762d5488a$export$45d76561a5302f2b)();
    const [navOpen, setNavOpen] = (0, $cQmXV.useState)(false);
    const [isMobile, setIsMobile] = (0, $cQmXV.useState)(()=>window.matchMedia($bad73bdcced7d027$var$MOBILE_QUERY).matches);
    (0, $cQmXV.useEffect)(()=>{
        const mq = window.matchMedia($bad73bdcced7d027$var$MOBILE_QUERY);
        const sync = (e)=>{
            setIsMobile(e.matches);
            /* Widening past the breakpoint leaves the drawer mounted over a sidebar that is now
         visible anyway — close it so there is exactly one nav on screen. */ if (!e.matches) setNavOpen(false);
        };
        mq.addEventListener("change", sync);
        return ()=>mq.removeEventListener("change", sync);
    }, []);
    /* index.html hardcodes lang="en", so without this the document keeps claiming English no
     matter which language the user picked. Screen-reader pronunciation and the Armenian /
     Georgian font fallbacks both key off it. */ (0, $cQmXV.useEffect)(()=>{
        if (lang) document.documentElement.lang = lang;
    }, [
        lang
    ]);
    /* Navigating from inside the drawer should dismiss it. */ (0, $cQmXV.useEffect)(()=>setNavOpen(false), [
        location.pathname
    ]);
    const closeNav = (0, $cQmXV.useCallback)(()=>setNavOpen(false), []);
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5764e43cf38ca965$export$2e2bcd8739ae039), {
        locale: (0, $d40125f317306d19$export$699e2fca28693f3d)(lang),
        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
            className: "shell",
            children: [
                isMobile ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $265dbad0185b5dfc$export$2e2bcd8739ae039), {
                    open: navOpen,
                    onClose: closeNav,
                    placement: "left",
                    width: 260,
                    closable: false,
                    classNames: {
                        body: "shell-drawer__body"
                    },
                    styles: {
                        body: {
                            padding: 0
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($bad73bdcced7d027$var$Brand, {}),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $c6c8415f44fd661c$export$2e2bcd8739ae039), {
                            onNavigate: closeNav
                        })
                    ]
                }) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("aside", {
                    className: "shell-side",
                    children: [
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($bad73bdcced7d027$var$Brand, {}),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $c6c8415f44fd661c$export$2e2bcd8739ae039), {})
                    ]
                }),
                /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                    className: "shell-main",
                    children: [
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $f3884d5bd7e34aad$export$2e2bcd8739ae039), {
                            onOpenNav: ()=>setNavOpen(true)
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $c4ecd91a3fcb0ac8$export$2e2bcd8739ae039), {
                                children: children
                            }, location.pathname)
                        })
                    ]
                })
            ]
        })
    });
}



var $cQmXV = parcelRequire("cQmXV");
const $422de08ffd33db6b$export$214e5fb64d34c1fc = /*#__PURE__*/ (0, $cQmXV.createContext)();





const $a1d7e4e3ae62364a$export$c84671f46d6a1ca = (props)=>{
    const updateLangFn = ()=>{
        setLang((prevState)=>({
                ...prevState,
                updateLang: !prevState.updateLang
            }));
    };
    const [lang, setLang] = (0, $cQmXV.useState)({
        updateLang: false,
        updateLangFn: updateLangFn
    });
    /* Subscribed, not read once from the store: the app bar's language switcher and the profile
     page both write `me`, and the shell has to re-render when they do. */ const language = (0, $b83e93e5ef3de8b0$export$2105062e25df4afe)((state)=>state.me?.language);
    // Keep the logged-in user's default region (me.county) fresh and as a FULL object, regardless
    // of when they last logged in or whether a profile save reduced it to a bare id. Region
    // filters read me.county to pre-select and label the region without their own backend call.
    (0, $cQmXV.useEffect)(()=>{
        const meState = (0, $81aca8a46f6ecb51$export$6fec604aa7293d0c)().getState().me;
        if (!meState || !meState.id) return;
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "GET",
            url: "users/" + meState.id + "/"
        }, (r)=>{
            if (r && r.id && "county" in r) {
                const cur = (0, $81aca8a46f6ecb51$export$6fec604aa7293d0c)().getState().me;
                (0, $81aca8a46f6ecb51$export$6fec604aa7293d0c)().dispatch((0, $cca4416321e611bf$export$953a134f6e0e87ac)({
                    ...cur,
                    county: r.county
                }));
            }
        });
    }, []);
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $422de08ffd33db6b$export$214e5fb64d34c1fc).Provider, {
        value: lang,
        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $bad73bdcced7d027$export$2e2bcd8739ae039), {
            lang: language,
            children: props.children
        })
    });
};




var $cQmXV = parcelRequire("cQmXV");



var $cQmXV = parcelRequire("cQmXV");







var $cQmXV = parcelRequire("cQmXV");

function $158e6f23169c3b42$export$2e2bcd8739ae039(value) {
    const [cacheValue, setCacheValue] = (0, $f0cf805f93abd5af$export$2e2bcd8739ae039)(value);
    $cQmXV.useEffect(()=>{
        setCacheValue(value, {
            ms: value.length ? 0 : 10
        });
    }, [
        value
    ]);
    return cacheValue;
}







const $c0d3fde1cc38c060$var$genFormValidateMotionStyle = (token)=>{
    const { componentCls: componentCls, motionDurationFast: motionDurationFast, motionEaseInOut: motionEaseInOut } = token;
    const helpCls = `${componentCls}-show-help`;
    const helpItemCls = `${componentCls}-show-help-item`;
    return {
        [helpCls]: {
            // Explain holder
            transition: `opacity ${motionDurationFast} ${motionEaseInOut}`,
            "&-appear, &-enter": {
                opacity: 0,
                "&-active": {
                    opacity: 1
                }
            },
            "&-leave": {
                opacity: 1,
                "&-active": {
                    opacity: 0
                }
            },
            // Explain
            [helpItemCls]: {
                overflow: "hidden",
                transition: `${[
                    "height",
                    "opacity",
                    "transform"
                ].map((prop)=>`${prop} ${motionDurationFast} ${motionEaseInOut}`).join(", ")} !important`,
                [`&${helpItemCls}-appear, &${helpItemCls}-enter`]: {
                    transform: `translateY(-5px)`,
                    opacity: 0,
                    "&-active": {
                        transform: "translateY(0)",
                        opacity: 1
                    }
                },
                [`&${helpItemCls}-leave-active`]: {
                    transform: `translateY(-5px)`
                }
            }
        }
    };
};
var $c0d3fde1cc38c060$export$2e2bcd8739ae039 = $c0d3fde1cc38c060$var$genFormValidateMotionStyle;


const $21ff9303541a4a86$var$resetForm = (token)=>({
        legend: {
            display: "block",
            width: "100%",
            marginBottom: token.marginLG,
            padding: 0,
            color: token.colorTextDescription,
            fontSize: token.fontSizeLG,
            lineHeight: "inherit",
            border: 0,
            borderBottom: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
        },
        'input[type="search"]': {
            boxSizing: "border-box"
        },
        // Position radios and checkboxes better
        'input[type="radio"], input[type="checkbox"]': {
            lineHeight: "normal"
        },
        'input[type="file"]': {
            display: "block"
        },
        // Make range inputs behave like textual form controls
        'input[type="range"]': {
            display: "block",
            width: "100%"
        },
        // Make multiple select elements height not fixed
        "select[multiple], select[size]": {
            height: "auto"
        },
        // Focus for file, radio, and checkbox
        "input[type='file']:focus, input[type='radio']:focus, input[type='checkbox']:focus": {
            outline: 0,
            boxShadow: `0 0 0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.controlOutlineWidth)} ${token.controlOutline}`
        },
        // Adjust output element
        output: {
            display: "block",
            paddingTop: 15,
            color: token.colorText,
            fontSize: token.fontSize,
            lineHeight: token.lineHeight
        }
    });
const $21ff9303541a4a86$var$genFormSize = (token, height)=>{
    const { formItemCls: formItemCls } = token;
    return {
        [formItemCls]: {
            [`${formItemCls}-label > label`]: {
                height: height
            },
            [`${formItemCls}-control-input`]: {
                minHeight: height
            }
        }
    };
};
const $21ff9303541a4a86$var$genFormStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: {
            ...(0, $519d20bf207ce864$export$23997c3e44cc1c59)(token),
            ...$21ff9303541a4a86$var$resetForm(token),
            [`${componentCls}-text`]: {
                display: "inline-block",
                paddingInlineEnd: token.paddingSM
            },
            // ================================================================
            // =                             Size                             =
            // ================================================================
            "&-small": {
                ...$21ff9303541a4a86$var$genFormSize(token, token.controlHeightSM)
            },
            "&-large": {
                ...$21ff9303541a4a86$var$genFormSize(token, token.controlHeightLG)
            }
        }
    };
};
const $21ff9303541a4a86$var$genFormItemStyle = (token)=>{
    const { formItemCls: formItemCls, iconCls: iconCls, rootPrefixCls: rootPrefixCls, antCls: antCls, labelRequiredMarkColor: labelRequiredMarkColor, labelColor: labelColor, labelFontSize: labelFontSize, labelHeight: labelHeight, labelColonMarginInlineStart: labelColonMarginInlineStart, labelColonMarginInlineEnd: labelColonMarginInlineEnd, itemMarginBottom: itemMarginBottom } = token;
    const [varName] = (0, $6870d4d7c14ae0bb$export$d82b8f66c5649e14)(antCls, "grid");
    return {
        [formItemCls]: {
            ...(0, $519d20bf207ce864$export$23997c3e44cc1c59)(token),
            marginBottom: itemMarginBottom,
            verticalAlign: "top",
            "&-with-help": {
                transition: "none"
            },
            [`&-hidden,
        &-hidden${antCls}-row`]: {
                // https://github.com/ant-design/ant-design/issues/26141
                display: "none"
            },
            // ==============================================================
            // =                            Label                           =
            // ==============================================================
            [`${formItemCls}-label`]: {
                flexGrow: 0,
                overflow: "hidden",
                whiteSpace: "nowrap",
                textAlign: "end",
                verticalAlign: "middle",
                "&-left": {
                    textAlign: "start"
                },
                "&-wrap": {
                    overflow: "unset",
                    lineHeight: token.lineHeight,
                    whiteSpace: "unset",
                    "> label": {
                        verticalAlign: "middle",
                        textWrap: "balance"
                    }
                },
                "> label": {
                    position: "relative",
                    display: "inline-flex",
                    alignItems: "center",
                    maxWidth: "100%",
                    height: labelHeight,
                    color: labelColor,
                    fontSize: labelFontSize,
                    [`> ${iconCls}`]: {
                        fontSize: token.fontSize,
                        verticalAlign: "top"
                    },
                    [`&${formItemCls}-required`]: {
                        "&::before": {
                            display: "inline-block",
                            marginInlineEnd: token.marginXXS,
                            color: labelRequiredMarkColor,
                            fontSize: token.fontSize,
                            fontFamily: "sans-serif",
                            lineHeight: 1,
                            content: '"*"'
                        },
                        [`&${formItemCls}-required-mark-hidden, &${formItemCls}-required-mark-optional`]: {
                            "&::before": {
                                display: "none"
                            }
                        }
                    },
                    // Optional mark
                    [`${formItemCls}-optional`]: {
                        display: "inline-block",
                        marginInlineStart: token.marginXXS,
                        color: token.colorTextDescription,
                        [`&${formItemCls}-required-mark-hidden`]: {
                            display: "none"
                        }
                    },
                    // Optional mark
                    [`${formItemCls}-tooltip`]: {
                        color: token.colorTextDescription,
                        cursor: "help",
                        writingMode: "horizontal-tb",
                        marginInlineStart: token.marginXXS
                    },
                    "&::after": {
                        content: '":"',
                        position: "relative",
                        marginBlock: 0,
                        marginInlineStart: labelColonMarginInlineStart,
                        marginInlineEnd: labelColonMarginInlineEnd
                    },
                    [`&${formItemCls}-no-colon::after`]: {
                        content: '"\\a0"'
                    }
                }
            },
            // ==============================================================
            // =                            Input                           =
            // ==============================================================
            [`${formItemCls}-control`]: {
                [varName("display")]: "flex",
                flexDirection: "column",
                flexGrow: 1,
                [`&:first-child:not([class^="'${rootPrefixCls}-col-'"]):not([class*="' ${rootPrefixCls}-col-'"])`]: {
                    width: "100%"
                },
                "&-input": {
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                    minHeight: token.controlHeight,
                    "&-content": {
                        flex: "auto",
                        maxWidth: "100%",
                        // Fix https://github.com/ant-design/ant-design/issues/54042
                        // Remove impact of whitespaces
                        [`&:has(> ${antCls}-switch:only-child, > ${antCls}-rate:only-child)`]: {
                            display: "flex",
                            alignItems: "center"
                        }
                    }
                }
            },
            // ==============================================================
            // =                           Explain                          =
            // ==============================================================
            [formItemCls]: {
                "&-additional": {
                    display: "flex",
                    flexDirection: "column"
                },
                "&-explain, &-extra": {
                    clear: "both",
                    color: token.colorTextDescription,
                    fontSize: token.fontSize,
                    lineHeight: token.lineHeight
                },
                "&-explain-connected": {
                    width: "100%"
                },
                "&-extra": {
                    minHeight: token.controlHeightSM,
                    transition: `color ${token.motionDurationMid} ${token.motionEaseOut}` // sync input color transition
                },
                "&-explain": {
                    "&-error": {
                        color: token.colorError
                    },
                    "&-warning": {
                        color: token.colorWarning
                    }
                }
            },
            [`&-with-help ${formItemCls}-explain`]: {
                height: "auto",
                opacity: 1
            },
            // ==============================================================
            // =                        Feedback Icon                       =
            // ==============================================================
            [`${formItemCls}-feedback-icon`]: {
                fontSize: token.fontSize,
                textAlign: "center",
                visibility: "visible",
                animationName: (0, $35f7d6eebd10a5fe$export$3b71758b3ed5255f),
                animationDuration: token.motionDurationMid,
                animationTimingFunction: token.motionEaseOutBack,
                pointerEvents: "none",
                "&-success": {
                    color: token.colorSuccess
                },
                "&-error": {
                    color: token.colorError
                },
                "&-warning": {
                    color: token.colorWarning
                },
                "&-validating": {
                    color: token.colorPrimary
                }
            }
        }
    };
};
const $21ff9303541a4a86$var$makeVerticalLayoutLabel = (token)=>({
        padding: token.verticalLabelPadding,
        margin: token.verticalLabelMargin,
        whiteSpace: "initial",
        textAlign: "start",
        "> label": {
            margin: 0,
            "&::after": {
                // https://github.com/ant-design/ant-design/issues/43538
                visibility: "hidden"
            }
        }
    });
const $21ff9303541a4a86$var$genHorizontalStyle = (token)=>{
    const { antCls: antCls, formItemCls: formItemCls } = token;
    return {
        [`${formItemCls}-horizontal`]: {
            [`${formItemCls}-label`]: {
                flexGrow: 0
            },
            [`${formItemCls}-control`]: {
                flex: "1 1 0",
                // https://github.com/ant-design/ant-design/issues/32777
                // https://github.com/ant-design/ant-design/issues/33773
                minWidth: 0
            },
            // Do not change this to `ant-col-24`! `-24` match all the responsive rules
            // https://github.com/ant-design/ant-design/issues/32980
            // https://github.com/ant-design/ant-design/issues/34903
            // https://github.com/ant-design/ant-design/issues/44538
            [`${formItemCls}-label[class$='-24'], ${formItemCls}-label[class*='-24 ']`]: {
                [`& + ${formItemCls}-control`]: {
                    minWidth: "unset"
                }
            },
            [`${antCls}-col-24${formItemCls}-label,
        ${antCls}-col-xl-24${formItemCls}-label`]: $21ff9303541a4a86$var$makeVerticalLayoutLabel(token)
        }
    };
};
const $21ff9303541a4a86$var$genInlineStyle = (token)=>{
    const { componentCls: componentCls, formItemCls: formItemCls, inlineItemMarginBottom: inlineItemMarginBottom } = token;
    return {
        [`${componentCls}-inline`]: {
            display: "flex",
            flexWrap: "wrap",
            [`${formItemCls}-inline`]: {
                flex: "none",
                marginInlineEnd: token.margin,
                marginBottom: inlineItemMarginBottom,
                "&-row": {
                    flexWrap: "nowrap"
                },
                [`> ${formItemCls}-label,
        > ${formItemCls}-control`]: {
                    display: "inline-block",
                    verticalAlign: "top"
                },
                [`> ${formItemCls}-label`]: {
                    flex: "none"
                },
                [`${componentCls}-text`]: {
                    display: "inline-block"
                },
                [`${formItemCls}-has-feedback`]: {
                    display: "inline-block"
                }
            }
        }
    };
};
const $21ff9303541a4a86$var$makeVerticalLayout = (token)=>{
    const { componentCls: componentCls, formItemCls: formItemCls, rootPrefixCls: rootPrefixCls } = token;
    return {
        [`${formItemCls} ${formItemCls}-label`]: $21ff9303541a4a86$var$makeVerticalLayoutLabel(token),
        // ref: https://github.com/ant-design/ant-design/issues/45122
        [`${componentCls}:not(${componentCls}-inline)`]: {
            [formItemCls]: {
                flexWrap: "wrap",
                [`${formItemCls}-label, ${formItemCls}-control`]: {
                    // When developer pass `xs: { span }`,
                    // It should follow the `xs` screen config
                    // ref: https://github.com/ant-design/ant-design/issues/44386
                    [`&:not([class*=" ${rootPrefixCls}-col-xs"])`]: {
                        flex: "0 0 100%",
                        maxWidth: "100%"
                    }
                }
            }
        }
    };
};
const $21ff9303541a4a86$var$genVerticalStyle = (token)=>{
    const { componentCls: componentCls, formItemCls: formItemCls, antCls: antCls, verticalLabelHeight: verticalLabelHeight } = token;
    return {
        [`${formItemCls}-vertical`]: {
            [`${formItemCls}-row`]: {
                flexDirection: "column"
            },
            [`${formItemCls}-label > label`]: {
                height: verticalLabelHeight
            },
            [`${formItemCls}-control`]: {
                width: "100%"
            },
            [`${formItemCls}-label,
        ${antCls}-col-24${formItemCls}-label,
        ${antCls}-col-xl-24${formItemCls}-label`]: $21ff9303541a4a86$var$makeVerticalLayoutLabel(token)
        },
        [`@media (max-width: ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.screenXSMax)})`]: [
            $21ff9303541a4a86$var$makeVerticalLayout(token),
            {
                [componentCls]: {
                    [`${formItemCls}:not(${formItemCls}-horizontal)`]: {
                        [`${antCls}-col-xs-24${formItemCls}-label`]: $21ff9303541a4a86$var$makeVerticalLayoutLabel(token)
                    }
                }
            }
        ],
        [`@media (max-width: ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.screenSMMax)})`]: {
            [componentCls]: {
                [`${formItemCls}:not(${formItemCls}-horizontal)`]: {
                    [`${antCls}-col-sm-24${formItemCls}-label`]: $21ff9303541a4a86$var$makeVerticalLayoutLabel(token)
                }
            }
        },
        [`@media (max-width: ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.screenMDMax)})`]: {
            [componentCls]: {
                [`${formItemCls}:not(${formItemCls}-horizontal)`]: {
                    [`${antCls}-col-md-24${formItemCls}-label`]: $21ff9303541a4a86$var$makeVerticalLayoutLabel(token)
                }
            }
        },
        [`@media (max-width: ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.screenLGMax)})`]: {
            [componentCls]: {
                [`${formItemCls}:not(${formItemCls}-horizontal)`]: {
                    [`${antCls}-col-lg-24${formItemCls}-label`]: $21ff9303541a4a86$var$makeVerticalLayoutLabel(token)
                }
            }
        }
    };
};
const $21ff9303541a4a86$export$9ca1be8807fe0675 = (token)=>({
        labelRequiredMarkColor: token.colorError,
        labelColor: token.colorTextHeading,
        labelFontSize: token.fontSize,
        labelHeight: token.controlHeight,
        verticalLabelHeight: token.labelHeight ?? "auto",
        labelColonMarginInlineStart: token.marginXXS / 2,
        labelColonMarginInlineEnd: token.marginXS,
        itemMarginBottom: token.marginLG,
        verticalLabelPadding: `0 0 ${token.paddingXS}px`,
        verticalLabelMargin: 0,
        inlineItemMarginBottom: 0
    });
const $21ff9303541a4a86$export$362fb92a8f81bbf9 = (token, rootPrefixCls)=>{
    const formToken = (0, $fef50f256b80dfa5$export$4950aa0f605343fb)(token, {
        formItemCls: `${token.componentCls}-item`,
        rootPrefixCls: rootPrefixCls
    });
    return formToken;
};
var $21ff9303541a4a86$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$51ec95de45185b42)("Form", (token, { rootPrefixCls: rootPrefixCls })=>{
    const formToken = $21ff9303541a4a86$export$362fb92a8f81bbf9(token, rootPrefixCls);
    return [
        $21ff9303541a4a86$var$genFormStyle(formToken),
        $21ff9303541a4a86$var$genFormItemStyle(formToken),
        (0, $c0d3fde1cc38c060$export$2e2bcd8739ae039)(formToken),
        $21ff9303541a4a86$var$genHorizontalStyle(formToken),
        $21ff9303541a4a86$var$genInlineStyle(formToken),
        $21ff9303541a4a86$var$genVerticalStyle(formToken),
        (0, $3576e621578e370a$export$2e2bcd8739ae039)(formToken),
        (0, $35f7d6eebd10a5fe$export$3b71758b3ed5255f)
    ];
}, $21ff9303541a4a86$export$9ca1be8807fe0675, {
    // Let From style before the Grid
    // ref https://github.com/ant-design/ant-design/issues/44386
    order: -1000
});


"use client";
const $728e3c806ae967f7$var$EMPTY_LIST = [];
function $728e3c806ae967f7$var$toErrorEntity(error, prefix, errorStatus, index = 0) {
    return {
        key: typeof error === "string" ? error : `${prefix}-${index}`,
        error: error,
        errorStatus: errorStatus
    };
}
const $728e3c806ae967f7$var$ErrorList = ({ help: help, helpStatus: helpStatus, errors: errors = $728e3c806ae967f7$var$EMPTY_LIST, warnings: warnings = $728e3c806ae967f7$var$EMPTY_LIST, className: rootClassName, fieldId: fieldId, onVisibleChanged: onVisibleChanged })=>{
    const { prefixCls: prefixCls } = $cQmXV.useContext((0, $7a3804f153d8a19d$export$fb6582d3042cc879));
    const { classNames: contextClassNames, styles: contextStyles } = $cQmXV.useContext((0, $7a3804f153d8a19d$export$c24727297075ec6a));
    const baseClassName = `${prefixCls}-item-explain`;
    const rootCls = (0, $2237081acd3cfc09$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $21ff9303541a4a86$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const collapseMotion = $cQmXV.useMemo(()=>(0, $047a5f051ebda8ba$export$2e2bcd8739ae039)(prefixCls), [
        prefixCls
    ]);
    // We have to debounce here again since somewhere use ErrorList directly still need no shaking
    // ref: https://github.com/ant-design/ant-design/issues/36336
    const debounceErrors = (0, $158e6f23169c3b42$export$2e2bcd8739ae039)(errors);
    const debounceWarnings = (0, $158e6f23169c3b42$export$2e2bcd8739ae039)(warnings);
    const hasHelp = (0, $8e2d153a3c855782$export$826fff653a329e83)(help);
    const fullKeyList = $cQmXV.useMemo(()=>{
        if (hasHelp) return [
            $728e3c806ae967f7$var$toErrorEntity(help, "help", helpStatus)
        ];
        return [].concat((0, $68381b18b974dc9f$export$2e2bcd8739ae039)(debounceErrors.map((error, index)=>$728e3c806ae967f7$var$toErrorEntity(error, "error", "error", index))), (0, $68381b18b974dc9f$export$2e2bcd8739ae039)(debounceWarnings.map((warning, index)=>$728e3c806ae967f7$var$toErrorEntity(warning, "warning", "warning", index))));
    }, [
        help,
        helpStatus,
        hasHelp,
        debounceErrors,
        debounceWarnings
    ]);
    const filledKeyFullKeyList = $cQmXV.useMemo(()=>{
        const keysCount = {};
        fullKeyList.forEach(({ key: key })=>{
            keysCount[key] = (keysCount[key] || 0) + 1;
        });
        return fullKeyList.map((entity, index)=>({
                ...entity,
                key: keysCount[entity.key] > 1 ? `${entity.key}-fallback-${index}` : entity.key
            }));
    }, [
        fullKeyList
    ]);
    const helpProps = {};
    if (fieldId) helpProps.id = `${fieldId}_help`;
    return /*#__PURE__*/ $cQmXV.createElement((0, $04c53b89814950f8$export$2e2bcd8739ae039), {
        motionDeadline: collapseMotion.motionDeadline,
        motionName: `${prefixCls}-show-help`,
        visible: !!filledKeyFullKeyList.length,
        onVisibleChanged: onVisibleChanged
    }, (holderProps)=>{
        const { className: holderClassName, style: holderStyle } = holderProps;
        return /*#__PURE__*/ $cQmXV.createElement("div", {
            ...helpProps,
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(baseClassName, holderClassName, contextClassNames?.help, cssVarCls, rootCls, rootClassName, hashId),
            style: {
                ...contextStyles?.help,
                ...holderStyle
            }
        }, /*#__PURE__*/ $cQmXV.createElement((0, $26c73d1f8271409e$export$2e2bcd8739ae039), {
            keys: filledKeyFullKeyList,
            ...(0, $047a5f051ebda8ba$export$2e2bcd8739ae039)(prefixCls),
            motionName: `${prefixCls}-show-help-item`,
            component: false
        }, (itemProps)=>{
            const { key: key, error: error, errorStatus: errorStatus, className: itemClassName, style: itemStyle } = itemProps;
            return /*#__PURE__*/ $cQmXV.createElement("div", {
                key: key,
                className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(itemClassName, contextClassNames?.helpItem, {
                    [`${baseClassName}-${errorStatus}`]: errorStatus
                }),
                style: {
                    ...contextStyles?.helpItem,
                    ...itemStyle
                }
            }, error);
        }));
    });
};
var $728e3c806ae967f7$export$2e2bcd8739ae039 = $728e3c806ae967f7$var$ErrorList;



var $cQmXV = parcelRequire("cQmXV");











var $cQmXV = parcelRequire("cQmXV");


const $be3018275885fde7$var$t = (t)=>"object" == typeof t && null != t && 1 === t.nodeType, $be3018275885fde7$var$e = (t, e)=>(!e || "hidden" !== t) && "visible" !== t && "clip" !== t, $be3018275885fde7$var$n = (t, n)=>{
    if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
        const o = getComputedStyle(t, null);
        return $be3018275885fde7$var$e(o.overflowY, n) || $be3018275885fde7$var$e(o.overflowX, n) || ((t)=>{
            const e = ((t)=>{
                if (!t.ownerDocument || !t.ownerDocument.defaultView) return null;
                try {
                    return t.ownerDocument.defaultView.frameElement;
                } catch (t) {
                    return null;
                }
            })(t);
            return !!e && (e.clientHeight < t.scrollHeight || e.clientWidth < t.scrollWidth);
        })(t);
    }
    return !1;
}, $be3018275885fde7$var$o = (t, e, n, o, l, r, i, s)=>r < t && i > e || r > t && i < e ? 0 : r <= t && s <= n || i >= e && s >= n ? r - t - o : i > e && s < n || r < t && s > n ? i - e + l : 0, $be3018275885fde7$var$l = (t)=>{
    const e = t.parentElement;
    return null == e ? t.getRootNode().host || null : e;
}, $be3018275885fde7$export$3b12cb22b12b954b = (e, r)=>{
    var i, s, d, h;
    if ("undefined" == typeof document) return [];
    const { scrollMode: c, block: f, inline: u, boundary: a, skipOverflowHiddenElements: g } = r, p = "function" == typeof a ? a : (t)=>t !== a;
    if (!$be3018275885fde7$var$t(e)) throw new TypeError("Invalid target");
    const m = document.scrollingElement || document.documentElement, w = [];
    let W = e;
    for(; $be3018275885fde7$var$t(W) && p(W);){
        if (W = $be3018275885fde7$var$l(W), W === m) {
            w.push(W);
            break;
        }
        null != W && W === document.body && $be3018275885fde7$var$n(W) && !$be3018275885fde7$var$n(document.documentElement) || null != W && $be3018275885fde7$var$n(W, g) && w.push(W);
    }
    const b = null != (s = null == (i = window.visualViewport) ? void 0 : i.width) ? s : innerWidth, H = null != (h = null == (d = window.visualViewport) ? void 0 : d.height) ? h : innerHeight, { scrollX: y, scrollY: M } = window, { height: v, width: E, top: x, right: C, bottom: I, left: R } = e.getBoundingClientRect(), { top: T, right: B, bottom: F, left: V } = ((t)=>{
        const e = window.getComputedStyle(t);
        return {
            top: parseFloat(e.scrollMarginTop) || 0,
            right: parseFloat(e.scrollMarginRight) || 0,
            bottom: parseFloat(e.scrollMarginBottom) || 0,
            left: parseFloat(e.scrollMarginLeft) || 0
        };
    })(e);
    let k = "start" === f || "nearest" === f ? x - T : "end" === f ? I + F : x + v / 2 - T + F, D = "center" === u ? R + E / 2 - V + B : "end" === u ? C + B : R - V;
    const L = [];
    for(let t = 0; t < w.length; t++){
        const e = w[t], { height: l, width: r, top: i, right: s, bottom: d, left: h } = e.getBoundingClientRect();
        if ("if-needed" === c && x >= 0 && R >= 0 && I <= H && C <= b && (e === m && !$be3018275885fde7$var$n(e) || x >= i && I <= d && R >= h && C <= s)) return L;
        const a = getComputedStyle(e), g = parseInt(a.borderLeftWidth, 10), p = parseInt(a.borderTopWidth, 10), W = parseInt(a.borderRightWidth, 10), T = parseInt(a.borderBottomWidth, 10);
        let B = 0, F = 0;
        const V = "offsetWidth" in e ? e.offsetWidth - e.clientWidth - g - W : 0, S = "offsetHeight" in e ? e.offsetHeight - e.clientHeight - p - T : 0, X = "offsetWidth" in e ? 0 === e.offsetWidth ? 0 : r / e.offsetWidth : 0, Y = "offsetHeight" in e ? 0 === e.offsetHeight ? 0 : l / e.offsetHeight : 0;
        if (m === e) B = "start" === f ? k : "end" === f ? k - H : "nearest" === f ? $be3018275885fde7$var$o(M, M + H, H, p, T, M + k, M + k + v, v) : k - H / 2, F = "start" === u ? D : "center" === u ? D - b / 2 : "end" === u ? D - b : $be3018275885fde7$var$o(y, y + b, b, g, W, y + D, y + D + E, E), B = Math.max(0, B + M), F = Math.max(0, F + y);
        else {
            B = "start" === f ? k - i - p : "end" === f ? k - d + T + S : "nearest" === f ? $be3018275885fde7$var$o(i, d, l, p, T + S, k, k + v, v) : k - (i + l / 2) + S / 2, F = "start" === u ? D - h - g : "center" === u ? D - (h + r / 2) + V / 2 : "end" === u ? D - s + W + V : $be3018275885fde7$var$o(h, s, r, g, W + V, D, D + E, E);
            const { scrollLeft: t, scrollTop: n } = e;
            B = 0 === Y ? 0 : Math.max(0, Math.min(n + B / Y, e.scrollHeight - l / Y + S)), F = 0 === X ? 0 : Math.max(0, Math.min(t + F / X, e.scrollWidth - r / X + V)), k += n - B, D += t - F;
        }
        L.push({
            el: e,
            top: B,
            left: F
        });
    }
    return L;
};


const $01bbd7cb34e4099b$var$o = (t)=>!1 === t ? {
        block: "end",
        inline: "nearest"
    } : ((t)=>t === Object(t) && 0 !== Object.keys(t).length)(t) ? t : {
        block: "start",
        inline: "nearest"
    };
function $01bbd7cb34e4099b$export$2e2bcd8739ae039(e, r) {
    if (!e.isConnected || !((t)=>{
        let o = t;
        for(; o && o.parentNode;){
            if (o.parentNode === document) return !0;
            o = o.parentNode instanceof ShadowRoot ? o.parentNode.host : o.parentNode;
        }
        return !1;
    })(e)) return;
    const n = ((t)=>{
        const o = window.getComputedStyle(t);
        return {
            top: parseFloat(o.scrollMarginTop) || 0,
            right: parseFloat(o.scrollMarginRight) || 0,
            bottom: parseFloat(o.scrollMarginBottom) || 0,
            left: parseFloat(o.scrollMarginLeft) || 0
        };
    })(e);
    if (((t)=>"object" == typeof t && "function" == typeof t.behavior)(r)) return r.behavior((0, $be3018275885fde7$export$3b12cb22b12b954b)(e, r));
    const l = "boolean" == typeof r || null == r ? void 0 : r.behavior;
    for (const { el: a, top: i, left: s } of (0, $be3018275885fde7$export$3b12cb22b12b954b)(e, $01bbd7cb34e4099b$var$o(r))){
        const t = i - n.top + n.bottom, o = s - n.left + n.right;
        a.scroll({
            top: t,
            left: o,
            behavior: l
        });
    }
}



// form item name black list.  in form ,you can use form.id get the form item element.
// use object hasOwnProperty will get better performance if black list is longer.
const $88e30d45d91e2cb7$var$formItemNameBlackList = [
    "parentNode"
];
// default form item id prefix.
const $88e30d45d91e2cb7$var$defaultItemNamePrefixCls = "form_item";
function $88e30d45d91e2cb7$export$45b10814cc054894(candidate) {
    if (candidate === undefined || candidate === false) return [];
    return Array.isArray(candidate) ? candidate : [
        candidate
    ];
}
function $88e30d45d91e2cb7$export$f4457e83c74ac000(namePath, formName) {
    if (!namePath.length) return undefined;
    const mergedId = namePath.join("_");
    if (formName) return `${formName}_${mergedId}`;
    const isIllegalName = $88e30d45d91e2cb7$var$formItemNameBlackList.includes(mergedId);
    return isIllegalName ? `${$88e30d45d91e2cb7$var$defaultItemNamePrefixCls}_${mergedId}` : mergedId;
}
function $88e30d45d91e2cb7$export$b70265791d2079d4(errors, warnings, meta, defaultValidateStatus, hasFeedback, validateStatus) {
    let status = defaultValidateStatus;
    if (validateStatus !== undefined) status = validateStatus;
    else if (meta.validating) status = "validating";
    else if (errors.length) status = "error";
    else if (warnings.length) status = "warning";
    else if (meta.touched || hasFeedback && meta.validated) // success feedback should display when pass hasFeedback prop and current value is valid value
    status = "success";
    return status;
}


function $64ccfaf5ba9e6521$export$368b682c15953eea(name) {
    const namePath = (0, $88e30d45d91e2cb7$export$45b10814cc054894)(name);
    return namePath.join("_");
}
function $64ccfaf5ba9e6521$var$getFieldDOMNode(name, wrapForm) {
    const field = wrapForm.getFieldInstance(name);
    const fieldDom = (0, $d3fb35d553a86e29$export$9aa546fdc20ae5b3)(field);
    if (fieldDom) return fieldDom;
    const fieldId = (0, $88e30d45d91e2cb7$export$f4457e83c74ac000)((0, $88e30d45d91e2cb7$export$45b10814cc054894)(name), wrapForm.__INTERNAL__.name);
    if (fieldId) return document.getElementById(fieldId);
}
function $64ccfaf5ba9e6521$export$2e2bcd8739ae039(form) {
    const [rcForm] = (0, $616d24d3edb0e567$export$2e2bcd8739ae039)();
    const itemsRef = $cQmXV.useRef({});
    const wrapForm = $cQmXV.useMemo(()=>form ?? {
            ...rcForm,
            __INTERNAL__: {
                itemRef: (name)=>(node)=>{
                        const namePathStr = $64ccfaf5ba9e6521$export$368b682c15953eea(name);
                        if (node) itemsRef.current[namePathStr] = node;
                        else delete itemsRef.current[namePathStr];
                    }
            },
            scrollToField: (name, options = {})=>{
                const { focus: focus, ...restOpt } = options;
                const node = $64ccfaf5ba9e6521$var$getFieldDOMNode(name, wrapForm);
                if (node) {
                    (0, $01bbd7cb34e4099b$export$2e2bcd8739ae039)(node, {
                        scrollMode: "if-needed",
                        block: "nearest",
                        ...restOpt
                    });
                    // Focus if scroll success
                    if (focus) wrapForm.focusField(name);
                }
            },
            focusField: (name)=>{
                const itemRef = wrapForm.getFieldInstance(name);
                if ((0, $8e2d153a3c855782$export$f6e2535fb5126e54)(itemRef?.focus)) itemRef.focus();
                else $64ccfaf5ba9e6521$var$getFieldDOMNode(name, wrapForm)?.focus?.();
            },
            getFieldInstance: (name)=>{
                const namePathStr = $64ccfaf5ba9e6521$export$368b682c15953eea(name);
                return itemsRef.current[namePathStr];
            }
        }, [
        form,
        rcForm
    ]);
    return [
        wrapForm
    ];
}





"use client";
const $11c0390163969183$var$InternalForm = (props, ref)=>{
    const contextDisabled = $cQmXV.useContext((0, $4f0e1ea30330557c$export$2e2bcd8739ae039));
    const { getPrefixCls: getPrefixCls, direction: direction, requiredMark: contextRequiredMark, colon: contextColon, scrollToFirstError: contextScrollToFirstError, className: contextClassName, style: contextStyle, styles: contextStyles, classNames: contextClassNames, tooltip: contextTooltip, labelAlign: contextLabelAlign, labelWrap: contextLabelWrap } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("form");
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, size: size, disabled: disabled = contextDisabled, form: form, colon: colon, labelAlign: labelAlign, labelWrap: labelWrap, labelCol: labelCol, wrapperCol: wrapperCol, layout: layout = "horizontal", scrollToFirstError: scrollToFirstError, requiredMark: requiredMark, onFinishFailed: onFinishFailed, name: name, style: style, feedbackIcons: feedbackIcons, variant: variant, classNames: classNames, styles: styles, tooltip: tooltip, ...restFormProps } = props;
    const mergedSize = (0, $78cdfb6138721329$export$2e2bcd8739ae039)(size);
    const contextValidateMessages = $cQmXV.useContext((0, $d111de4f04aff124$export$2e2bcd8739ae039));
    const mergedRequiredMark = $cQmXV.useMemo(()=>{
        if (requiredMark !== undefined) return requiredMark;
        if (contextRequiredMark !== undefined) return contextRequiredMark;
        return true;
    }, [
        requiredMark,
        contextRequiredMark
    ]);
    const mergedColon = colon ?? contextColon;
    const mergedLabelAlign = labelAlign ?? contextLabelAlign;
    const mergedLabelWrap = labelWrap ?? contextLabelWrap;
    const mergedTooltip = {
        ...contextTooltip,
        ...tooltip
    };
    const prefixCls = getPrefixCls("form", customizePrefixCls);
    // Style
    const rootCls = (0, $2237081acd3cfc09$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $21ff9303541a4a86$export$2e2bcd8739ae039)(prefixCls, rootCls);
    // =========== Merged Props for Semantic ===========
    const mergedProps = {
        ...props,
        size: mergedSize,
        disabled: disabled,
        layout: layout,
        colon: mergedColon,
        requiredMark: mergedRequiredMark,
        labelAlign: mergedLabelAlign,
        labelWrap: mergedLabelWrap
    };
    const contextStyleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $30c5f9f911d4f61b$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: mergedProps
    });
    const formClassName = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-${layout}`, {
        [`${prefixCls}-hide-required-mark`]: mergedRequiredMark === false,
        // todo: remove in next major version
        [`${prefixCls}-rtl`]: direction === "rtl",
        [`${prefixCls}-large`]: mergedSize === "large",
        [`${prefixCls}-small`]: mergedSize === "small"
    }, cssVarCls, rootCls, hashId, contextClassName, className, rootClassName, mergedClassNames.root);
    const [wrapForm] = (0, $64ccfaf5ba9e6521$export$2e2bcd8739ae039)(form);
    const { __INTERNAL__: __INTERNAL__ } = wrapForm;
    __INTERNAL__.name = name;
    const formContextValue = $cQmXV.useMemo(()=>({
            name: name,
            labelAlign: mergedLabelAlign,
            labelCol: labelCol,
            labelWrap: mergedLabelWrap,
            wrapperCol: wrapperCol,
            layout: layout,
            colon: mergedColon,
            requiredMark: mergedRequiredMark,
            itemRef: __INTERNAL__.itemRef,
            form: wrapForm,
            feedbackIcons: feedbackIcons,
            tooltip: mergedTooltip,
            classNames: mergedClassNames,
            styles: mergedStyles
        }), [
        name,
        mergedLabelAlign,
        mergedLabelWrap,
        labelCol,
        wrapperCol,
        layout,
        mergedColon,
        mergedRequiredMark,
        wrapForm,
        feedbackIcons,
        mergedClassNames,
        mergedStyles,
        mergedTooltip
    ]);
    const nativeElementRef = $cQmXV.useRef(null);
    $cQmXV.useImperativeHandle(ref, ()=>({
            ...wrapForm,
            nativeElement: nativeElementRef.current?.nativeElement
        }));
    const scrollToField = (options, fieldName)=>{
        if (options) {
            let defaultScrollToFirstError = {
                block: "nearest"
            };
            if ((0, $8e2d153a3c855782$export$53b83ca8eaab0383)(options)) defaultScrollToFirstError = {
                ...defaultScrollToFirstError,
                ...options
            };
            wrapForm.scrollToField(fieldName, defaultScrollToFirstError);
        }
    };
    const onInternalFinishFailed = (errorInfo)=>{
        onFinishFailed?.(errorInfo);
        if (errorInfo.errorFields.length) {
            const fieldName = errorInfo.errorFields[0].name;
            if (scrollToFirstError !== undefined) {
                scrollToField(scrollToFirstError, fieldName);
                return;
            }
            if (contextScrollToFirstError !== undefined) scrollToField(contextScrollToFirstError, fieldName);
        }
    };
    return /*#__PURE__*/ $cQmXV.createElement((0, $7a3804f153d8a19d$export$6f0555dad42725fb).Provider, {
        value: variant
    }, /*#__PURE__*/ $cQmXV.createElement((0, $4f0e1ea30330557c$export$6adb5f3b918b11bb), {
        disabled: disabled
    }, /*#__PURE__*/ $cQmXV.createElement((0, $767e8ef819e95b6d$export$2e2bcd8739ae039).Provider, {
        value: mergedSize
    }, /*#__PURE__*/ $cQmXV.createElement((0, $7a3804f153d8a19d$export$8ce1ff4f94d08846), {
        // This is not list in API, we pass with spread
        validateMessages: contextValidateMessages
    }, /*#__PURE__*/ $cQmXV.createElement((0, $7a3804f153d8a19d$export$c24727297075ec6a).Provider, {
        value: formContextValue
    }, /*#__PURE__*/ $cQmXV.createElement((0, $7a3804f153d8a19d$export$80e4c53cb85dcab1), {
        status: true
    }, /*#__PURE__*/ $cQmXV.createElement((0, $13cc7c1e34a7da5c$export$2e2bcd8739ae039), {
        id: name,
        ...restFormProps,
        name: name,
        onFinishFailed: onInternalFinishFailed,
        form: wrapForm,
        ref: nativeElementRef,
        style: mergedStyles?.root,
        className: formClassName
    })))))));
};
const $11c0390163969183$var$Form = /*#__PURE__*/ $cQmXV.forwardRef($11c0390163969183$var$InternalForm);
var $11c0390163969183$export$2e2bcd8739ae039 = $11c0390163969183$var$Form;




var $cQmXV = parcelRequire("cQmXV");











const $d0e179d69fc4fa42$var$useChildren = (children)=>{
    if ((0, $8e2d153a3c855782$export$f6e2535fb5126e54)(children)) return children;
    const childList = (0, $cd966a313e0a92ff$export$2e2bcd8739ae039)(children);
    return childList.length <= 1 ? childList[0] : childList;
};
var $d0e179d69fc4fa42$export$2e2bcd8739ae039 = $d0e179d69fc4fa42$var$useChildren;



var $cQmXV = parcelRequire("cQmXV");


const $b1fea847123271bb$var$useFormItemStatus = ()=>{
    const { status: status, errors: errors = [], warnings: warnings = [] } = $cQmXV.useContext((0, $7a3804f153d8a19d$export$bbb5553c6c7a14ed));
    return {
        status: status,
        errors: errors,
        warnings: warnings
    };
};
// Only used for compatible package. Not promise this will work on future version.
$b1fea847123271bb$var$useFormItemStatus.Context = (0, $7a3804f153d8a19d$export$bbb5553c6c7a14ed);
var $b1fea847123271bb$export$2e2bcd8739ae039 = $b1fea847123271bb$var$useFormItemStatus;



var $cQmXV = parcelRequire("cQmXV");

function $a4517f42cc2cc301$export$2e2bcd8739ae039(defaultValue) {
    const [value, setValue] = $cQmXV.useState(defaultValue);
    const frameRef = $cQmXV.useRef(null);
    const batchRef = $cQmXV.useRef([]);
    const destroyRef = $cQmXV.useRef(false);
    $cQmXV.useEffect(()=>{
        destroyRef.current = false;
        return ()=>{
            destroyRef.current = true;
            (0, $905c53b807de704e$export$2e2bcd8739ae039).cancel(frameRef.current);
            frameRef.current = null;
        };
    }, []);
    function setFrameValue(updater) {
        if (destroyRef.current) return;
        if (frameRef.current === null) {
            batchRef.current = [];
            frameRef.current = (0, $905c53b807de704e$export$2e2bcd8739ae039)(()=>{
                frameRef.current = null;
                setValue((prevValue)=>{
                    let current = prevValue;
                    batchRef.current.forEach((func)=>{
                        current = func(current);
                    });
                    return current;
                });
            });
        }
        batchRef.current.push(updater);
    }
    return [
        value,
        setFrameValue
    ];
}



var $cQmXV = parcelRequire("cQmXV");



const $b5e9c9d29868b4e2$var$useItemRef = ()=>{
    const { itemRef: itemRef } = $cQmXV.useContext((0, $7a3804f153d8a19d$export$c24727297075ec6a));
    const cacheRef = $cQmXV.useRef({});
    const getRef = (name, children)=>{
        // Outer caller already check the `supportRef`
        const childrenRef = children && (0, $8e2d153a3c855782$export$53b83ca8eaab0383)(children) && (0, $10341b937b26f69d$export$7465e5c0bf44f19a)(children);
        const nameStr = name.join("_");
        if (cacheRef.current.name !== nameStr || cacheRef.current.originRef !== childrenRef) {
            cacheRef.current.name = nameStr;
            cacheRef.current.originRef = childrenRef;
            cacheRef.current.ref = (0, $10341b937b26f69d$export$ab452c34e8e05029)(itemRef(name), childrenRef);
        }
        return cacheRef.current.ref;
    };
    return getRef;
};
var $b5e9c9d29868b4e2$export$2e2bcd8739ae039 = $b5e9c9d29868b4e2$var$useItemRef;





var $cQmXV = parcelRequire("cQmXV");




var $cQmXV = parcelRequire("cQmXV");



var $cQmXV = parcelRequire("cQmXV");


const $93a56f4fa79d4cc2$export$74c1bf8296b1541f = [
    "xxxl",
    "xxl",
    "xl",
    "lg",
    "md",
    "sm",
    "xs"
];
const $93a56f4fa79d4cc2$export$9af3fe7b7131195 = [].concat($93a56f4fa79d4cc2$export$74c1bf8296b1541f).reverse();
const $93a56f4fa79d4cc2$var$getResponsiveMap = (token)=>({
        xs: `(max-width: ${token.screenXSMax}px)`,
        sm: `(min-width: ${token.screenSM}px)`,
        md: `(min-width: ${token.screenMD}px)`,
        lg: `(min-width: ${token.screenLG}px)`,
        xl: `(min-width: ${token.screenXL}px)`,
        xxl: `(min-width: ${token.screenXXL}px)`,
        xxxl: `(min-width: ${token.screenXXXL}px)`
    });
/**
 * Ensures that the breakpoints token are valid, in good order
 * For each breakpoint : screenMin <= screen <= screenMax and screenMax <= nextScreenMin
 */ const $93a56f4fa79d4cc2$var$validateBreakpoints = (token)=>{
    const indexableToken = token;
    const revBreakpoints = [].concat($93a56f4fa79d4cc2$export$74c1bf8296b1541f).reverse();
    revBreakpoints.forEach((breakpoint, i)=>{
        const breakpointUpper = breakpoint.toUpperCase();
        const screenMin = `screen${breakpointUpper}Min`;
        const screen = `screen${breakpointUpper}`;
        if (!(indexableToken[screenMin] <= indexableToken[screen])) throw new Error(`${screenMin}<=${screen} fails : !(${indexableToken[screenMin]}<=${indexableToken[screen]})`);
        if (i < revBreakpoints.length - 1) {
            const screenMax = `screen${breakpointUpper}Max`;
            if (!(indexableToken[screen] <= indexableToken[screenMax])) throw new Error(`${screen}<=${screenMax} fails : !(${indexableToken[screen]}<=${indexableToken[screenMax]})`);
            const nextBreakpointUpperMin = revBreakpoints[i + 1].toUpperCase();
            const nextScreenMin = `screen${nextBreakpointUpperMin}Min`;
            if (!(indexableToken[screenMax] <= indexableToken[nextScreenMin])) throw new Error(`${screenMax}<=${nextScreenMin} fails : !(${indexableToken[screenMax]}<=${indexableToken[nextScreenMin]})`);
        }
    });
    return token;
};
const $93a56f4fa79d4cc2$export$862220c15691d248 = (screens, screenSizes)=>{
    if (!screenSizes) return;
    for (const breakpoint of $93a56f4fa79d4cc2$export$74c1bf8296b1541f){
        if (screens[breakpoint] && screenSizes?.[breakpoint] !== undefined) return screenSizes[breakpoint];
    }
};
const $93a56f4fa79d4cc2$var$useResponsiveObserver = ()=>{
    const [, token] = (0, $b22e03a54a548614$export$2e2bcd8739ae039)();
    const responsiveMap = $93a56f4fa79d4cc2$var$getResponsiveMap($93a56f4fa79d4cc2$var$validateBreakpoints(token));
    // To avoid repeat create instance, we add `useMemo` here.
    return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useMemo(()=>{
        const subscribers = new Map();
        let subUid = -1;
        let screens = {};
        return {
            responsiveMap: responsiveMap,
            matchHandlers: {},
            dispatch (pointMap) {
                screens = pointMap;
                subscribers.forEach((func)=>{
                    func(screens);
                });
                return subscribers.size >= 1;
            },
            subscribe (func) {
                if (!subscribers.size) this.register();
                subUid += 1;
                subscribers.set(subUid, func);
                func(screens);
                return subUid;
            },
            unsubscribe (paramToken) {
                subscribers.delete(paramToken);
                if (!subscribers.size) this.unregister();
            },
            register () {
                Object.entries(responsiveMap).forEach(([screen, mediaQuery])=>{
                    const listener = ({ matches: matches })=>{
                        this.dispatch({
                            ...screens,
                            [screen]: matches
                        });
                    };
                    const mql = window.matchMedia(mediaQuery);
                    if ((0, $8e2d153a3c855782$export$f6e2535fb5126e54)(mql.addEventListener)) mql.addEventListener("change", listener);
                    this.matchHandlers[mediaQuery] = {
                        mql: mql,
                        listener: listener
                    };
                    listener(mql);
                });
            },
            unregister () {
                Object.values(responsiveMap).forEach((mediaQuery)=>{
                    const handler = this.matchHandlers[mediaQuery];
                    if ((0, $8e2d153a3c855782$export$f6e2535fb5126e54)(handler?.mql.removeEventListener)) handler.mql.removeEventListener("change", handler?.listener);
                });
                subscribers.clear();
            }
        };
    }, [
        responsiveMap
    ]);
};
var $93a56f4fa79d4cc2$export$2e2bcd8739ae039 = $93a56f4fa79d4cc2$var$useResponsiveObserver;




var $cQmXV = parcelRequire("cQmXV");


var $cQmXV = parcelRequire("cQmXV");
const $4ba220b3356f61b8$export$91db9bc4f8ac944a = ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useReducer((ori)=>ori + 1, 0);
};



"use client";
function $27af0f2a794acde0$var$useBreakpoint(refreshOnChange = true, defaultScreens = {}) {
    const screensRef = (0, $cQmXV.useRef)(defaultScreens);
    const [, forceUpdate] = (0, $4ba220b3356f61b8$export$91db9bc4f8ac944a)();
    const responsiveObserver = (0, $93a56f4fa79d4cc2$export$2e2bcd8739ae039)();
    (0, $7673d874dab69d07$export$2e2bcd8739ae039)(()=>{
        const token = responsiveObserver.subscribe((supportScreens)=>{
            screensRef.current = supportScreens;
            if (refreshOnChange) forceUpdate();
        });
        return ()=>responsiveObserver.unsubscribe(token);
    }, [
        refreshOnChange
    ]);
    return screensRef.current;
}
var $27af0f2a794acde0$export$2e2bcd8739ae039 = $27af0f2a794acde0$var$useBreakpoint;




function $763bdf0630a6f401$export$2e2bcd8739ae039(gutter, screens) {
    const results = [
        undefined,
        undefined
    ];
    const normalizedGutter = Array.isArray(gutter) ? gutter : [
        gutter,
        undefined
    ];
    // By default use as `xs`
    const mergedScreens = screens || {
        xs: true,
        sm: true,
        md: true,
        lg: true,
        xl: true,
        xxl: true,
        xxxl: true
    };
    normalizedGutter.forEach((g, index)=>{
        if ((0, $8e2d153a3c855782$export$53b83ca8eaab0383)(g)) for(let i = 0; i < (0, $93a56f4fa79d4cc2$export$74c1bf8296b1541f).length; i++){
            const breakpoint = (0, $93a56f4fa79d4cc2$export$74c1bf8296b1541f)[i];
            if (mergedScreens[breakpoint] && g[breakpoint] !== undefined) {
                results[index] = g[breakpoint];
                break;
            }
        }
        else results[index] = g;
    });
    return results;
}



var $cQmXV = parcelRequire("cQmXV");
const $925da5c441787e39$var$RowContext = /*#__PURE__*/ (0, $cQmXV.createContext)({});
var $925da5c441787e39$export$2e2bcd8739ae039 = $925da5c441787e39$var$RowContext;





// ============================== Row-Shared ==============================
const $55bc859fb97e8d96$var$genGridRowStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        // Grid system
        [componentCls]: {
            display: "flex",
            flexFlow: "row wrap",
            minWidth: 0,
            "&::before, &::after": {
                display: "flex"
            },
            "&-no-wrap": {
                flexWrap: "nowrap"
            },
            // The origin of the X-axis
            "&-start": {
                justifyContent: "flex-start"
            },
            // The center of the X-axis
            "&-center": {
                justifyContent: "center"
            },
            // The opposite of the X-axis
            "&-end": {
                justifyContent: "flex-end"
            },
            "&-space-between": {
                justifyContent: "space-between"
            },
            "&-space-around": {
                justifyContent: "space-around"
            },
            "&-space-evenly": {
                justifyContent: "space-evenly"
            },
            // Align at the top
            "&-top": {
                alignItems: "flex-start"
            },
            // Align at the center
            "&-middle": {
                alignItems: "center"
            },
            "&-bottom": {
                alignItems: "flex-end"
            }
        }
    };
};
// ============================== Col-Shared ==============================
const $55bc859fb97e8d96$var$genGridColStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        // Grid system
        [componentCls]: {
            position: "relative",
            maxWidth: "100%",
            // Prevent columns from collapsing when empty
            minHeight: 1
        }
    };
};
const $55bc859fb97e8d96$var$genLoopGridColumnsStyle = (token, sizeCls)=>{
    const { componentCls: componentCls, gridColumns: gridColumns, antCls: antCls } = token;
    const [gridVarName, gridVarRef] = (0, $6870d4d7c14ae0bb$export$d82b8f66c5649e14)(antCls, "grid");
    const [, colVarRef] = (0, $6870d4d7c14ae0bb$export$d82b8f66c5649e14)(antCls, "col");
    const gridColumnsStyle = {};
    for(let i = gridColumns; i >= 0; i--)if (i === 0) {
        gridColumnsStyle[`${componentCls}${sizeCls}-${i}`] = {
            display: "none"
        };
        gridColumnsStyle[`${componentCls}-push-${i}`] = {
            insetInlineStart: "auto"
        };
        gridColumnsStyle[`${componentCls}-pull-${i}`] = {
            insetInlineEnd: "auto"
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-push-${i}`] = {
            insetInlineStart: "auto"
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-pull-${i}`] = {
            insetInlineEnd: "auto"
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-offset-${i}`] = {
            marginInlineStart: 0
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-order-${i}`] = {
            order: 0
        };
    } else {
        gridColumnsStyle[`${componentCls}${sizeCls}-${i}`] = [
            // https://github.com/ant-design/ant-design/issues/44456
            // Form set `display: flex` on Col which will override `display: block`.
            // Let's get it from css variable to support override.
            {
                [gridVarName("display")]: "block",
                // Fallback to display if variable not support
                display: "block"
            },
            {
                display: gridVarRef("display"),
                flex: `0 0 ${i / gridColumns * 100}%`,
                maxWidth: `${i / gridColumns * 100}%`
            }
        ];
        gridColumnsStyle[`${componentCls}${sizeCls}-push-${i}`] = {
            insetInlineStart: `${i / gridColumns * 100}%`
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-pull-${i}`] = {
            insetInlineEnd: `${i / gridColumns * 100}%`
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-offset-${i}`] = {
            marginInlineStart: `${i / gridColumns * 100}%`
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-order-${i}`] = {
            order: i
        };
    }
    // Flex CSS Var
    gridColumnsStyle[`${componentCls}${sizeCls}-flex`] = {
        flex: colVarRef(`${sizeCls.replace(/-/, "")}-flex`)
    };
    return gridColumnsStyle;
};
const $55bc859fb97e8d96$var$genGridStyle = (token, sizeCls)=>$55bc859fb97e8d96$var$genLoopGridColumnsStyle(token, sizeCls);
const $55bc859fb97e8d96$var$genGridMediaStyle = (token, screenSize, sizeCls)=>({
        [`@media (min-width: ${(0, $05f34ed03d41967d$export$523c0b569236b342)(screenSize)})`]: {
            ...$55bc859fb97e8d96$var$genGridStyle(token, sizeCls)
        }
    });
const $55bc859fb97e8d96$export$519f4f378a4f8e85 = ()=>({});
const $55bc859fb97e8d96$export$5504d86ab3175593 = ()=>({});
const $55bc859fb97e8d96$export$b0d9c6b8be4e14cd = (0, $6870d4d7c14ae0bb$export$51ec95de45185b42)("Grid", $55bc859fb97e8d96$var$genGridRowStyle, $55bc859fb97e8d96$export$519f4f378a4f8e85);
const $55bc859fb97e8d96$export$6353f655434817c5 = (token)=>{
    const mediaSizesMap = {
        xs: token.screenXSMin,
        sm: token.screenSMMin,
        md: token.screenMDMin,
        lg: token.screenLGMin,
        xl: token.screenXLMin,
        xxl: token.screenXXLMin,
        xxxl: token.screenXXXLMin
    };
    return mediaSizesMap;
};
const $55bc859fb97e8d96$export$4d3e83959861592f = (0, $6870d4d7c14ae0bb$export$51ec95de45185b42)("Grid", (token)=>{
    const gridToken = (0, $fef50f256b80dfa5$export$4950aa0f605343fb)(token, {
        gridColumns: 24 // Row is divided into 24 parts in Grid
    });
    const gridMediaSizesMap = $55bc859fb97e8d96$export$6353f655434817c5(gridToken);
    delete gridMediaSizesMap.xs;
    return [
        $55bc859fb97e8d96$var$genGridColStyle(gridToken),
        $55bc859fb97e8d96$var$genGridStyle(gridToken, ""),
        $55bc859fb97e8d96$var$genGridStyle(gridToken, "-xs"),
        Object.keys(gridMediaSizesMap).map((key)=>$55bc859fb97e8d96$var$genGridMediaStyle(gridToken, gridMediaSizesMap[key], `-${key}`)).reduce((pre, cur)=>({
                ...pre,
                ...cur
            }), {})
    ];
}, $55bc859fb97e8d96$export$5504d86ab3175593);


"use client";
const $fd356af97d0ed2ba$var$_RowAligns = [
    "top",
    "middle",
    "bottom",
    "stretch"
];
const $fd356af97d0ed2ba$var$_RowJustify = [
    "start",
    "end",
    "center",
    "space-around",
    "space-between",
    "space-evenly"
];
const $fd356af97d0ed2ba$var$useMergedPropByScreen = (oriProp, screen)=>{
    const [prop, setProp] = $cQmXV.useState(()=>(0, $8e2d153a3c855782$export$844ec244b1367d54)(oriProp) ? oriProp : "");
    const calcMergedAlignOrJustify = ()=>{
        if ((0, $8e2d153a3c855782$export$844ec244b1367d54)(oriProp)) setProp(oriProp);
        if (!(0, $8e2d153a3c855782$export$53b83ca8eaab0383)(oriProp)) return;
        for(let i = 0; i < (0, $93a56f4fa79d4cc2$export$74c1bf8296b1541f).length; i++){
            const breakpoint = (0, $93a56f4fa79d4cc2$export$74c1bf8296b1541f)[i];
            // if do not match, do nothing
            if (!screen || !screen[breakpoint]) continue;
            const curVal = oriProp[breakpoint];
            if (curVal !== undefined) {
                setProp(curVal);
                return;
            }
        }
    };
    $cQmXV.useEffect(()=>{
        calcMergedAlignOrJustify();
    }, [
        JSON.stringify(oriProp),
        screen
    ]);
    return prop;
};
const $fd356af97d0ed2ba$var$Row = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, justify: justify, align: align, className: className, style: style, children: children, gutter: gutter = 0, wrap: wrap, ...others } = props;
    const { getPrefixCls: getPrefixCls, direction: direction } = $cQmXV.useContext((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    const screens = (0, $27af0f2a794acde0$export$2e2bcd8739ae039)(true, null);
    const mergedAlign = $fd356af97d0ed2ba$var$useMergedPropByScreen(align, screens);
    const mergedJustify = $fd356af97d0ed2ba$var$useMergedPropByScreen(justify, screens);
    const prefixCls = getPrefixCls("row", customizePrefixCls);
    const [hashId, cssVarCls] = (0, $55bc859fb97e8d96$export$b0d9c6b8be4e14cd)(prefixCls);
    const gutters = (0, $763bdf0630a6f401$export$2e2bcd8739ae039)(gutter, screens);
    const classes = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, {
        [`${prefixCls}-no-wrap`]: wrap === false,
        [`${prefixCls}-${mergedJustify}`]: mergedJustify,
        [`${prefixCls}-${mergedAlign}`]: mergedAlign,
        [`${prefixCls}-rtl`]: direction === "rtl"
    }, className, hashId, cssVarCls);
    // Add gutter related style
    const rowStyle = {};
    if (gutters?.[0]) {
        const horizontalGutter = (0, $8e2d153a3c855782$export$7e4aa119212bc614)(gutters[0]) ? `${gutters[0] / -2}px` : `calc(${gutters[0]} / -2)`;
        rowStyle.marginInline = horizontalGutter;
    }
    // "gutters" is a new array in each rendering phase, it'll make 'React.useMemo' effectless.
    // So we deconstruct "gutters" variable here.
    const [gutterH, gutterV] = gutters;
    rowStyle.rowGap = gutterV;
    const rowContext = $cQmXV.useMemo(()=>({
            gutter: [
                gutterH,
                gutterV
            ],
            wrap: wrap
        }), [
        gutterH,
        gutterV,
        wrap
    ]);
    return /*#__PURE__*/ $cQmXV.createElement((0, $925da5c441787e39$export$2e2bcd8739ae039).Provider, {
        value: rowContext
    }, /*#__PURE__*/ $cQmXV.createElement("div", {
        ...others,
        className: classes,
        style: {
            ...rowStyle,
            ...style
        },
        ref: ref
    }, children));
});
var $fd356af97d0ed2ba$export$2e2bcd8739ae039 = $fd356af97d0ed2ba$var$Row;





var $cQmXV = parcelRequire("cQmXV");





var $cQmXV = parcelRequire("cQmXV");







"use client";
function $fb529cf764bdab11$var$parseFlex(flex) {
    if (flex === "auto") return "1 1 auto";
    if ((0, $8e2d153a3c855782$export$7e4aa119212bc614)(flex)) return `${flex} ${flex} auto`;
    if (/^\d+(\.\d+)?(px|em|rem|%)$/.test(flex)) return `0 0 ${flex}`;
    return flex;
}
const $fb529cf764bdab11$var$Col = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { getPrefixCls: getPrefixCls, direction: direction } = $cQmXV.useContext((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    const { gutter: gutter, wrap: wrap } = $cQmXV.useContext((0, $925da5c441787e39$export$2e2bcd8739ae039));
    const { prefixCls: customizePrefixCls, span: span, order: order, offset: offset, push: push, pull: pull, className: className, children: children, flex: flex, style: style, ...others } = props;
    const prefixCls = getPrefixCls("col", customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    const [hashId, cssVarCls] = (0, $55bc859fb97e8d96$export$4d3e83959861592f)(prefixCls);
    const [varName] = (0, $6870d4d7c14ae0bb$export$d82b8f66c5649e14)(rootPrefixCls, "col");
    // ===================== Size ======================
    const sizeStyle = {};
    let sizeClassObj = {};
    (0, $93a56f4fa79d4cc2$export$9af3fe7b7131195).forEach((size)=>{
        let sizeProps = {};
        const propSize = props[size];
        if ((0, $8e2d153a3c855782$export$7e4aa119212bc614)(propSize)) sizeProps.span = propSize;
        else if ((0, $8e2d153a3c855782$export$53b83ca8eaab0383)(propSize)) sizeProps = propSize || {};
        delete others[size];
        sizeClassObj = {
            ...sizeClassObj,
            [`${prefixCls}-${size}-${sizeProps.span}`]: (0, $8e2d153a3c855782$export$826fff653a329e83)(sizeProps.span),
            [`${prefixCls}-${size}-order-${sizeProps.order}`]: sizeProps.order || sizeProps.order === 0,
            [`${prefixCls}-${size}-offset-${sizeProps.offset}`]: sizeProps.offset || sizeProps.offset === 0,
            [`${prefixCls}-${size}-push-${sizeProps.push}`]: sizeProps.push || sizeProps.push === 0,
            [`${prefixCls}-${size}-pull-${sizeProps.pull}`]: sizeProps.pull || sizeProps.pull === 0,
            [`${prefixCls}-rtl`]: direction === "rtl"
        };
        // Responsive flex layout
        if (sizeProps.flex || sizeProps.flex === 0) {
            sizeClassObj[`${prefixCls}-${size}-flex`] = true;
            sizeStyle[varName(`${size}-flex`)] = $fb529cf764bdab11$var$parseFlex(sizeProps.flex);
        }
    });
    // ==================== Normal =====================
    const classes = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, {
        [`${prefixCls}-${span}`]: span !== undefined,
        [`${prefixCls}-order-${order}`]: order,
        [`${prefixCls}-offset-${offset}`]: offset,
        [`${prefixCls}-push-${push}`]: push,
        [`${prefixCls}-pull-${pull}`]: pull
    }, className, sizeClassObj, hashId, cssVarCls);
    const mergedStyle = {};
    // Horizontal gutter use padding
    if (gutter?.[0]) {
        const horizontalGutter = (0, $8e2d153a3c855782$export$7e4aa119212bc614)(gutter[0]) ? `${gutter[0] / 2}px` : `calc(${gutter[0]} / 2)`;
        mergedStyle.paddingInline = horizontalGutter;
    }
    if (flex || flex === 0) {
        mergedStyle.flex = $fb529cf764bdab11$var$parseFlex(flex);
        // Hack for Firefox to avoid size issue
        // https://github.com/ant-design/ant-design/pull/20023#issuecomment-564389553
        if (wrap === false && !mergedStyle.minWidth) mergedStyle.minWidth = 0;
    }
    // ==================== Render =====================
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        ...others,
        style: {
            ...mergedStyle,
            ...style,
            ...sizeStyle
        },
        className: classes,
        ref: ref
    }, children);
});
var $fb529cf764bdab11$export$2e2bcd8739ae039 = $fb529cf764bdab11$var$Col;




/**
 * Fallback of IE.
 * Safe to remove.
 */ 

// ============================= Fallback =============================
const $c2c95ba626675953$var$genFallbackStyle = (token)=>{
    const { formItemCls: formItemCls } = token;
    return {
        "@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)": {
            // Fallback for IE, safe to remove we not support it anymore
            [`${formItemCls}-control`]: {
                display: "flex"
            }
        }
    };
};
var // ============================== Export ==============================
$c2c95ba626675953$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$1537386bc155ea56)([
    "Form",
    "item-item"
], (token, { rootPrefixCls: rootPrefixCls })=>{
    const formToken = (0, $21ff9303541a4a86$export$362fb92a8f81bbf9)(token, rootPrefixCls);
    return $c2c95ba626675953$var$genFallbackStyle(formToken);
});


"use client";
const $d5548a03c1c347a1$var$GRID_MAX = 24;
const $d5548a03c1c347a1$var$FormItemInput = (props)=>{
    const { prefixCls: prefixCls, status: status, labelCol: labelCol, wrapperCol: wrapperCol, children: children, errors: errors, warnings: warnings, _internalItemRender: formItemRender, extra: extra, help: help, fieldId: fieldId, marginBottom: marginBottom, onErrorVisibleChanged: onErrorVisibleChanged, label: label } = props;
    const baseClassName = `${prefixCls}-item`;
    const formContext = $cQmXV.useContext((0, $7a3804f153d8a19d$export$c24727297075ec6a));
    const { classNames: contextClassNames, styles: contextStyles } = formContext;
    const mergedWrapperCol = $cQmXV.useMemo(()=>{
        let mergedWrapper = {
            ...wrapperCol || formContext.wrapperCol || {}
        };
        if (label === null && !labelCol && !wrapperCol && formContext.labelCol) {
            const list = [
                undefined
            ].concat((0, $68381b18b974dc9f$export$2e2bcd8739ae039)((0, $93a56f4fa79d4cc2$export$9af3fe7b7131195)));
            list.forEach((size)=>{
                const _size = size ? [
                    size
                ] : [];
                const formLabel = (0, $bb62aae17cbc8bd7$export$2e2bcd8739ae039)(formContext.labelCol, _size);
                const formLabelObj = (0, $8e2d153a3c855782$export$53b83ca8eaab0383)(formLabel) ? formLabel : {};
                const wrapper = (0, $bb62aae17cbc8bd7$export$2e2bcd8739ae039)(mergedWrapper, _size);
                const wrapperObj = (0, $8e2d153a3c855782$export$53b83ca8eaab0383)(wrapper) ? wrapper : {};
                if ("span" in formLabelObj && !("offset" in wrapperObj) && formLabelObj.span < $d5548a03c1c347a1$var$GRID_MAX) mergedWrapper = (0, $a3099986deccaee4$export$2e2bcd8739ae039)(mergedWrapper, [].concat(_size, [
                    "offset"
                ]), formLabelObj.span);
            });
        }
        return mergedWrapper;
    }, [
        wrapperCol,
        formContext.wrapperCol,
        formContext.labelCol,
        label,
        labelCol
    ]);
    const className = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${baseClassName}-control`, mergedWrapperCol.className);
    // Pass to sub FormItem should not with col info
    const subFormContext = $cQmXV.useMemo(()=>{
        const { labelCol: _labelCol, wrapperCol: _wrapperCol, ...rest } = formContext;
        return rest;
    }, [
        formContext
    ]);
    const extraRef = $cQmXV.useRef(null);
    const [extraHeight, setExtraHeight] = $cQmXV.useState(0);
    (0, $7673d874dab69d07$export$2e2bcd8739ae039)(()=>{
        if (extra && extraRef.current) setExtraHeight(extraRef.current.clientHeight);
        else setExtraHeight(0);
    }, [
        extra
    ]);
    const inputDom = /*#__PURE__*/ $cQmXV.createElement("div", {
        className: `${baseClassName}-control-input`
    }, /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${baseClassName}-control-input-content`, contextClassNames?.content),
        style: contextStyles?.content
    }, children));
    const formItemContext = $cQmXV.useMemo(()=>({
            prefixCls: prefixCls,
            status: status
        }), [
        prefixCls,
        status
    ]);
    const errorListDom = marginBottom !== null || errors.length || warnings.length ? /*#__PURE__*/ $cQmXV.createElement((0, $7a3804f153d8a19d$export$fb6582d3042cc879).Provider, {
        value: formItemContext
    }, /*#__PURE__*/ $cQmXV.createElement((0, $728e3c806ae967f7$export$2e2bcd8739ae039), {
        fieldId: fieldId,
        errors: errors,
        warnings: warnings,
        help: help,
        helpStatus: status,
        className: `${baseClassName}-explain-connected`,
        onVisibleChanged: onErrorVisibleChanged
    })) : null;
    const extraProps = {};
    if (fieldId) extraProps.id = `${fieldId}_extra`;
    // If extra = 0, && will goes wrong
    // 0&&error -> 0
    const extraDom = extra ? /*#__PURE__*/ $cQmXV.createElement("div", {
        ...extraProps,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${baseClassName}-extra`, contextClassNames?.extra),
        style: contextStyles?.extra,
        ref: extraRef
    }, extra) : null;
    const additionalDom = errorListDom || extraDom ? /*#__PURE__*/ $cQmXV.createElement("div", {
        className: `${baseClassName}-additional`,
        style: marginBottom ? {
            minHeight: marginBottom + extraHeight
        } : {}
    }, errorListDom, extraDom) : null;
    const dom = formItemRender && formItemRender.mark === "pro_table_render" && formItemRender.render ? formItemRender.render(props, {
        input: inputDom,
        errorList: errorListDom,
        extra: extraDom
    }) : /*#__PURE__*/ $cQmXV.createElement($cQmXV.Fragment, null, inputDom, additionalDom);
    return /*#__PURE__*/ $cQmXV.createElement((0, $7a3804f153d8a19d$export$c24727297075ec6a).Provider, {
        value: subFormContext
    }, /*#__PURE__*/ $cQmXV.createElement((0, $fb529cf764bdab11$export$2e2bcd8739ae039), {
        ...mergedWrapperCol,
        className: className
    }, dom), /*#__PURE__*/ $cQmXV.createElement((0, $c2c95ba626675953$export$2e2bcd8739ae039), {
        prefixCls: prefixCls
    }));
};
var $d5548a03c1c347a1$export$2e2bcd8739ae039 = $d5548a03c1c347a1$var$FormItemInput;



var $cQmXV = parcelRequire("cQmXV");



var $cQmXV = parcelRequire("cQmXV");

const $fc1ac9c4f9ad632b$var$convertToTooltipProps = (tooltip, context)=>{
    if (!(0, $8e2d153a3c855782$export$72280d5f896dac9a)(tooltip)) return null;
    if ((0, $8e2d153a3c855782$export$53b83ca8eaab0383)(tooltip) && !/*#__PURE__*/ (0, $cQmXV.isValidElement)(tooltip)) return {
        ...context,
        ...tooltip
    };
    return {
        ...context,
        title: tooltip
    };
};
var $fc1ac9c4f9ad632b$export$2e2bcd8739ae039 = $fc1ac9c4f9ad632b$var$convertToTooltipProps;








"use client";
const $88c0cb5619fff4f6$var$FormItemLabel = ({ prefixCls: prefixCls, label: label, htmlFor: htmlFor, labelCol: labelCol, labelAlign: labelAlign, colon: colon, required: required, requiredMark: requiredMark, tooltip: tooltip, vertical: vertical })=>{
    const [formLocale] = (0, $c953dac9d015386e$export$2e2bcd8739ae039)("Form");
    const { labelAlign: contextLabelAlign, labelCol: contextLabelCol, labelWrap: labelWrap, colon: contextColon, classNames: contextClassNames, styles: contextStyles, tooltip: contextTooltip } = $cQmXV.useContext((0, $7a3804f153d8a19d$export$c24727297075ec6a));
    if (!label) return null;
    const mergedLabelCol = labelCol || contextLabelCol || {};
    const mergedLabelAlign = labelAlign || contextLabelAlign;
    const labelClsBasic = `${prefixCls}-item-label`;
    const labelColClassName = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(labelClsBasic, mergedLabelAlign === "left" && `${labelClsBasic}-left`, mergedLabelCol.className, {
        [`${labelClsBasic}-wrap`]: !!labelWrap
    });
    let labelChildren = label;
    // Keep label is original where there should have no colon
    const computedColon = colon === true || contextColon !== false && colon !== false;
    const haveColon = computedColon && !vertical;
    // Remove duplicated user input colon
    if (haveColon && typeof label === "string" && label.trim()) labelChildren = label.replace(/[:|：]\s*$/, "");
    const tooltipProps = (0, $fc1ac9c4f9ad632b$export$2e2bcd8739ae039)(tooltip, contextTooltip);
    if (tooltipProps) {
        const tooltipNode = /*#__PURE__*/ $cQmXV.createElement((0, $1e5256cf9d329b2c$export$2e2bcd8739ae039), {
            ...tooltipProps
        }, /*#__PURE__*/ $cQmXV.createElement("span", {
            className: `${prefixCls}-item-tooltip`,
            onClick: (e)=>{
                e.preventDefault();
            },
            tabIndex: -1
        }, tooltipProps.icon || tooltipProps.children || /*#__PURE__*/ $cQmXV.createElement((0, $9e51bdaef216a39c$export$2e2bcd8739ae039), null)));
        labelChildren = /*#__PURE__*/ $cQmXV.createElement($cQmXV.Fragment, null, labelChildren, tooltipNode);
    }
    // Required Mark
    const isOptionalMark = requiredMark === "optional";
    const isRenderMark = (0, $8e2d153a3c855782$export$f6e2535fb5126e54)(requiredMark);
    const hideRequiredMark = requiredMark === false;
    if (isRenderMark) labelChildren = requiredMark(labelChildren, {
        required: !!required
    });
    else if (isOptionalMark && !required) labelChildren = /*#__PURE__*/ $cQmXV.createElement($cQmXV.Fragment, null, labelChildren, /*#__PURE__*/ $cQmXV.createElement("span", {
        className: `${prefixCls}-item-optional`
    }, formLocale?.optional || (0, $4ab0c7032ff9de6a$export$2e2bcd8739ae039).Form?.optional));
    // https://github.com/ant-design/ant-design/pull/52950#discussion_r1980880316
    let markType;
    if (hideRequiredMark) markType = "hidden";
    else if (isOptionalMark || isRenderMark) markType = "optional";
    const labelClassName = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(contextClassNames?.label, {
        [`${prefixCls}-item-required`]: required,
        [`${prefixCls}-item-required-mark-${markType}`]: markType,
        [`${prefixCls}-item-no-colon`]: !computedColon
    });
    return /*#__PURE__*/ $cQmXV.createElement((0, $fb529cf764bdab11$export$2e2bcd8739ae039), {
        ...mergedLabelCol,
        className: labelColClassName
    }, /*#__PURE__*/ $cQmXV.createElement("label", {
        htmlFor: htmlFor,
        className: labelClassName,
        style: contextStyles?.label,
        title: typeof label === "string" ? label : undefined
    }, labelChildren));
};
var $88c0cb5619fff4f6$export$2e2bcd8739ae039 = $88c0cb5619fff4f6$var$FormItemLabel;





var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");
var $e7524148021ec48d$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($e7524148021ec48d$exports, "__esModule", {
    value: true
});
var $e7524148021ec48d$var$CheckCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z"
                }
            }
        ]
    },
    "name": "check-circle",
    "theme": "filled"
};
$e7524148021ec48d$exports.default = $e7524148021ec48d$var$CheckCircleFilled;



function $017e758d1ebbd854$var$_extends() {
    $017e758d1ebbd854$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $017e758d1ebbd854$var$_extends.apply(this, arguments);
}
const $017e758d1ebbd854$var$CheckCircleFilled = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $017e758d1ebbd854$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e7524148021ec48d$exports)))
    }));
/**![check-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0xOTMuNSAzMDEuN2wtMjEwLjYgMjkyYTMxLjggMzEuOCAwIDAxLTUxLjcgMEwzMTguNSA0ODQuOWMtMy44LTUuMyAwLTEyLjcgNi41LTEyLjdoNDYuOWMxMC4yIDAgMTkuOSA0LjkgMjUuOSAxMy4zbDcxLjIgOTguOCAxNTcuMi0yMThjNi04LjMgMTUuNi0xMy4zIDI1LjktMTMuM0g2OTljNi41IDAgMTAuMyA3LjQgNi41IDEyLjd6IiAvPjwvc3ZnPg==) */ const $017e758d1ebbd854$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($017e758d1ebbd854$var$CheckCircleFilled);
var $017e758d1ebbd854$export$2e2bcd8739ae039 = $017e758d1ebbd854$var$RefIcon;



var $cQmXV = parcelRequire("cQmXV");
var $d7ff4605e10715e7$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($d7ff4605e10715e7$exports, "__esModule", {
    value: true
});
var $d7ff4605e10715e7$var$CloseCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "fill-rule": "evenodd",
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z"
                }
            }
        ]
    },
    "name": "close-circle",
    "theme": "filled"
};
$d7ff4605e10715e7$exports.default = $d7ff4605e10715e7$var$CloseCircleFilled;



function $ff9add21dbbc2684$var$_extends() {
    $ff9add21dbbc2684$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ff9add21dbbc2684$var$_extends.apply(this, arguments);
}
const $ff9add21dbbc2684$var$CloseCircleFilled = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $ff9add21dbbc2684$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d7ff4605e10715e7$exports)))
    }));
/**![close-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdmlld0JveD0iNjQgNjQgODk2IDg5NiIgZm9jdXNhYmxlPSJmYWxzZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNTEyIDY0YzI0Ny40IDAgNDQ4IDIwMC42IDQ0OCA0NDhTNzU5LjQgOTYwIDUxMiA5NjAgNjQgNzU5LjQgNjQgNTEyIDI2NC42IDY0IDUxMiA2NHptMTI3Ljk4IDI3NC44MmgtLjA0bC0uMDguMDZMNTEyIDQ2Ni43NSAzODQuMTQgMzM4Ljg4Yy0uMDQtLjA1LS4wNi0uMDYtLjA4LS4wNmEuMTIuMTIgMCAwMC0uMDcgMGMtLjAzIDAtLjA1LjAxLS4wOS4wNWwtNDUuMDIgNDUuMDJhLjIuMiAwIDAwLS4wNS4wOS4xMi4xMiAwIDAwMCAuMDd2LjAyYS4yNy4yNyAwIDAwLjA2LjA2TDQ2Ni43NSA1MTIgMzM4Ljg4IDYzOS44NmMtLjA1LjA0LS4wNi4wNi0uMDYuMDhhLjEyLjEyIDAgMDAwIC4wN2MwIC4wMy4wMS4wNS4wNS4wOWw0NS4wMiA0NS4wMmEuMi4yIDAgMDAuMDkuMDUuMTIuMTIgMCAwMC4wNyAwYy4wMiAwIC4wNC0uMDEuMDgtLjA1TDUxMiA1NTcuMjVsMTI3Ljg2IDEyNy44N2MuMDQuMDQuMDYuMDUuMDguMDVhLjEyLjEyIDAgMDAuMDcgMGMuMDMgMCAuMDUtLjAxLjA5LS4wNWw0NS4wMi00NS4wMmEuMi4yIDAgMDAuMDUtLjA5LjEyLjEyIDAgMDAwLS4wN3YtLjAyYS4yNy4yNyAwIDAwLS4wNS0uMDZMNTU3LjI1IDUxMmwxMjcuODctMTI3Ljg2Yy4wNC0uMDQuMDUtLjA2LjA1LS4wOGEuMTIuMTIgMCAwMDAtLjA3YzAtLjAzLS4wMS0uMDUtLjA1LS4wOWwtNDUuMDItNDUuMDJhLjIuMiAwIDAwLS4wOS0uMDUuMTIuMTIgMCAwMC0uMDcgMHoiIC8+PC9zdmc+) */ const $ff9add21dbbc2684$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($ff9add21dbbc2684$var$CloseCircleFilled);
var $ff9add21dbbc2684$export$2e2bcd8739ae039 = $ff9add21dbbc2684$var$RefIcon;



var $cQmXV = parcelRequire("cQmXV");
var $e94d2531fcc52a29$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($e94d2531fcc52a29$exports, "__esModule", {
    value: true
});
var $e94d2531fcc52a29$var$ExclamationCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z"
                }
            }
        ]
    },
    "name": "exclamation-circle",
    "theme": "filled"
};
$e94d2531fcc52a29$exports.default = $e94d2531fcc52a29$var$ExclamationCircleFilled;



function $39711bf58c19fcd8$var$_extends() {
    $39711bf58c19fcd8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $39711bf58c19fcd8$var$_extends.apply(this, arguments);
}
const $39711bf58c19fcd8$var$ExclamationCircleFilled = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $39711bf58c19fcd8$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e94d2531fcc52a29$exports)))
    }));
/**![exclamation-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0tMzIgMjMyYzAtNC40IDMuNi04IDgtOGg0OGM0LjQgMCA4IDMuNiA4IDh2MjcyYzAgNC40LTMuNiA4LTggOGgtNDhjLTQuNCAwLTgtMy42LTgtOFYyOTZ6bTMyIDQ0MGE0OC4wMSA0OC4wMSAwIDAxMC05NiA0OC4wMSA0OC4wMSAwIDAxMCA5NnoiIC8+PC9zdmc+) */ const $39711bf58c19fcd8$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($39711bf58c19fcd8$var$ExclamationCircleFilled);
var $39711bf58c19fcd8$export$2e2bcd8739ae039 = $39711bf58c19fcd8$var$RefIcon;






"use client";
const $a5a263fbb181a426$var$iconMap = {
    success: (0, $017e758d1ebbd854$export$2e2bcd8739ae039),
    warning: (0, $39711bf58c19fcd8$export$2e2bcd8739ae039),
    error: (0, $ff9add21dbbc2684$export$2e2bcd8739ae039),
    validating: (0, $bf7996ca956facd7$export$2e2bcd8739ae039)
};
function $a5a263fbb181a426$var$StatusProvider({ children: children, errors: errors, warnings: warnings, hasFeedback: hasFeedback, validateStatus: validateStatus, prefixCls: prefixCls, meta: meta, noStyle: noStyle, name: name }) {
    const itemPrefixCls = `${prefixCls}-item`;
    const { feedbackIcons: feedbackIcons } = $cQmXV.useContext((0, $7a3804f153d8a19d$export$c24727297075ec6a));
    const mergedValidateStatus = (0, $88e30d45d91e2cb7$export$b70265791d2079d4)(errors, warnings, meta, null, !!hasFeedback, validateStatus);
    const { isFormItemInput: parentIsFormItemInput, status: parentStatus, hasFeedback: parentHasFeedback, feedbackIcon: parentFeedbackIcon, name: parentName } = $cQmXV.useContext((0, $7a3804f153d8a19d$export$bbb5553c6c7a14ed));
    // ====================== Context =======================
    const formItemStatusContext = $cQmXV.useMemo(()=>{
        let feedbackIcon;
        if (hasFeedback) {
            const customIcons = hasFeedback !== true && hasFeedback.icons || feedbackIcons;
            const customIconNode = mergedValidateStatus && customIcons?.({
                status: mergedValidateStatus,
                errors: errors,
                warnings: warnings
            })?.[mergedValidateStatus];
            const IconNode = mergedValidateStatus ? $a5a263fbb181a426$var$iconMap[mergedValidateStatus] : null;
            feedbackIcon = customIconNode !== false && IconNode ? /*#__PURE__*/ $cQmXV.createElement("span", {
                className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${itemPrefixCls}-feedback-icon`, `${itemPrefixCls}-feedback-icon-${mergedValidateStatus}`)
            }, customIconNode || /*#__PURE__*/ $cQmXV.createElement(IconNode, null)) : null;
        }
        const context = {
            status: mergedValidateStatus || "",
            errors: errors,
            warnings: warnings,
            hasFeedback: !!hasFeedback,
            feedbackIcon: feedbackIcon,
            isFormItemInput: true,
            name: name
        };
        // No style will follow parent context
        if (noStyle) {
            context.status = (mergedValidateStatus ?? parentStatus) || "";
            context.isFormItemInput = parentIsFormItemInput;
            context.hasFeedback = !!(hasFeedback ?? parentHasFeedback);
            context.feedbackIcon = hasFeedback !== undefined ? context.feedbackIcon : parentFeedbackIcon;
            context.name = name ?? parentName;
        }
        return context;
    }, [
        mergedValidateStatus,
        errors,
        warnings,
        hasFeedback,
        feedbackIcons,
        noStyle,
        name,
        parentIsFormItemInput,
        parentStatus,
        itemPrefixCls,
        parentHasFeedback,
        parentFeedbackIcon,
        parentName
    ]);
    // ======================= Render =======================
    return /*#__PURE__*/ $cQmXV.createElement((0, $7a3804f153d8a19d$export$bbb5553c6c7a14ed).Provider, {
        value: formItemStatusContext
    }, children);
}
var $a5a263fbb181a426$export$2e2bcd8739ae039 = $a5a263fbb181a426$var$StatusProvider;


"use client";
function $d0dab8e35c0950cd$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, className: className, rootClassName: rootClassName, style: style, help: help, errors: errors, warnings: warnings, validateStatus: validateStatus, meta: meta, hasFeedback: hasFeedback, hidden: hidden, children: children, fieldId: fieldId, required: required, isRequired: isRequired, onSubItemMetaChange: onSubItemMetaChange, layout: propsLayout, name: name, ...restProps } = props;
    const itemPrefixCls = `${prefixCls}-item`;
    const { requiredMark: requiredMark, layout: formLayout } = $cQmXV.useContext((0, $7a3804f153d8a19d$export$c24727297075ec6a));
    const layout = propsLayout || formLayout;
    const vertical = layout === "vertical";
    // ======================== Margin ========================
    const itemRef = $cQmXV.useRef(null);
    const debounceErrors = (0, $158e6f23169c3b42$export$2e2bcd8739ae039)(errors);
    const debounceWarnings = (0, $158e6f23169c3b42$export$2e2bcd8739ae039)(warnings);
    const hasHelp = (0, $8e2d153a3c855782$export$826fff653a329e83)(help);
    const hasError = !!(hasHelp || errors.length || warnings.length);
    const isOnScreen = !!itemRef.current && (0, $c70640475a7bd353$export$2e2bcd8739ae039)(itemRef.current);
    const [marginBottom, setMarginBottom] = $cQmXV.useState(null);
    (0, $7673d874dab69d07$export$2e2bcd8739ae039)(()=>{
        if (hasError && itemRef.current) {
            // The element must be part of the DOMTree to use getComputedStyle
            // https://stackoverflow.com/questions/35360711/getcomputedstyle-returns-a-cssstyledeclaration-but-all-properties-are-empty-on-a
            const itemStyle = getComputedStyle(itemRef.current);
            setMarginBottom(Number.parseInt(itemStyle.marginBottom, 10));
        }
    }, [
        hasError,
        isOnScreen
    ]);
    const onErrorVisibleChanged = (nextVisible)=>{
        if (!nextVisible) setMarginBottom(null);
    };
    // ======================== Status ========================
    const getValidateState = (isDebounce = false)=>{
        const _errors = isDebounce ? debounceErrors : meta.errors;
        const _warnings = isDebounce ? debounceWarnings : meta.warnings;
        return (0, $88e30d45d91e2cb7$export$b70265791d2079d4)(_errors, _warnings, meta, "", !!hasFeedback, validateStatus);
    };
    const mergedValidateStatus = getValidateState();
    // ======================== Render ========================
    const itemClassName = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(itemPrefixCls, className, rootClassName, {
        [`${itemPrefixCls}-with-help`]: hasHelp || debounceErrors.length || debounceWarnings.length,
        // Status
        [`${itemPrefixCls}-has-feedback`]: mergedValidateStatus && hasFeedback,
        [`${itemPrefixCls}-has-success`]: mergedValidateStatus === "success",
        [`${itemPrefixCls}-has-warning`]: mergedValidateStatus === "warning",
        [`${itemPrefixCls}-has-error`]: mergedValidateStatus === "error",
        [`${itemPrefixCls}-is-validating`]: mergedValidateStatus === "validating",
        [`${itemPrefixCls}-hidden`]: hidden,
        // Layout
        [`${itemPrefixCls}-${layout}`]: layout
    });
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        className: itemClassName,
        style: style,
        ref: itemRef
    }, /*#__PURE__*/ $cQmXV.createElement((0, $fd356af97d0ed2ba$export$2e2bcd8739ae039), {
        className: `${itemPrefixCls}-row`,
        ...(0, $e8c5093aebad6025$export$2e2bcd8739ae039)(restProps, [
            "_internalItemRender",
            "colon",
            "dependencies",
            "extra",
            "fieldKey",
            "getValueFromEvent",
            "getValueProps",
            "htmlFor",
            "id",
            // It is deprecated because `htmlFor` is its replacement.
            "initialValue",
            "isListField",
            "label",
            "labelAlign",
            "labelCol",
            "labelWrap",
            "messageVariables",
            "name",
            "normalize",
            "noStyle",
            "preserve",
            "requiredMark",
            "rules",
            "shouldUpdate",
            "trigger",
            "tooltip",
            "validateFirst",
            "validateTrigger",
            "valuePropName",
            "wrapperCol",
            "validateDebounce"
        ])
    }, /*#__PURE__*/ $cQmXV.createElement((0, $88c0cb5619fff4f6$export$2e2bcd8739ae039), {
        htmlFor: fieldId,
        ...props,
        requiredMark: requiredMark,
        required: required ?? isRequired,
        prefixCls: prefixCls,
        vertical: vertical
    }), /*#__PURE__*/ $cQmXV.createElement((0, $d5548a03c1c347a1$export$2e2bcd8739ae039), {
        ...props,
        ...meta,
        errors: debounceErrors,
        warnings: debounceWarnings,
        prefixCls: prefixCls,
        status: mergedValidateStatus,
        help: help,
        marginBottom: marginBottom,
        onErrorVisibleChanged: onErrorVisibleChanged
    }, /*#__PURE__*/ $cQmXV.createElement((0, $7a3804f153d8a19d$export$d718247e9f9b0b9e).Provider, {
        value: onSubItemMetaChange
    }, /*#__PURE__*/ $cQmXV.createElement((0, $a5a263fbb181a426$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        meta: meta,
        errors: meta.errors,
        warnings: meta.warnings,
        hasFeedback: hasFeedback,
        // Already calculated
        validateStatus: mergedValidateStatus,
        name: name
    }, children)))), !!marginBottom && /*#__PURE__*/ $cQmXV.createElement("div", {
        className: `${itemPrefixCls}-margin-offset`,
        style: {
            marginBottom: -marginBottom
        }
    }));
}



"use client";
const $923303217277ac4b$var$NAME_SPLIT = "__SPLIT__";
const $923303217277ac4b$var$_ValidateStatuses = [
    "success",
    "warning",
    "error",
    "validating",
    ""
];
// https://github.com/ant-design/ant-design/issues/46417
// `getValueProps` may modify the value props name,
// we should check if the control is similar.
function $923303217277ac4b$var$isSimilarControl(a, b) {
    const keysA = Object.keys(a);
    const keysB = Object.keys(b);
    return keysA.length === keysB.length && keysA.every((key)=>{
        const propValueA = a[key];
        const propValueB = b[key];
        return propValueA === propValueB || (0, $8e2d153a3c855782$export$f6e2535fb5126e54)(propValueA) || (0, $8e2d153a3c855782$export$f6e2535fb5126e54)(propValueB);
    });
}
const $923303217277ac4b$var$MemoInput = /*#__PURE__*/ $cQmXV.memo((props)=>props.children, (prev, next)=>$923303217277ac4b$var$isSimilarControl(prev.control, next.control) && prev.update === next.update && prev.childProps.length === next.childProps.length && prev.childProps.every((value, index)=>value === next.childProps[index]));
function $923303217277ac4b$var$genEmptyMeta() {
    return {
        errors: [],
        warnings: [],
        touched: false,
        validating: false,
        name: [],
        validated: false
    };
}
function $923303217277ac4b$var$InternalFormItem(props) {
    const { name: name, noStyle: noStyle, className: className, dependencies: dependencies, prefixCls: customizePrefixCls, shouldUpdate: shouldUpdate, rules: rules, children: children, required: required, label: label, messageVariables: messageVariables, trigger: trigger = "onChange", validateTrigger: validateTrigger, hidden: hidden, help: help, layout: layout } = props;
    const { getPrefixCls: getPrefixCls } = $cQmXV.useContext((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    const { name: formName } = $cQmXV.useContext((0, $7a3804f153d8a19d$export$c24727297075ec6a));
    const mergedChildren = (0, $d0e179d69fc4fa42$export$2e2bcd8739ae039)(children);
    const isRenderProps = (0, $8e2d153a3c855782$export$f6e2535fb5126e54)(mergedChildren);
    const notifyParentMetaChange = $cQmXV.useContext((0, $7a3804f153d8a19d$export$d718247e9f9b0b9e));
    const { validateTrigger: contextValidateTrigger } = $cQmXV.useContext((0, $7b2f48a2d7a9ccda$export$2e2bcd8739ae039));
    const mergedValidateTrigger = (0, $8e2d153a3c855782$export$826fff653a329e83)(validateTrigger) ? validateTrigger : contextValidateTrigger;
    const hasName = (0, $8e2d153a3c855782$export$826fff653a329e83)(name);
    const prefixCls = getPrefixCls("form", customizePrefixCls);
    // Style
    const rootCls = (0, $2237081acd3cfc09$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $21ff9303541a4a86$export$2e2bcd8739ae039)(prefixCls, rootCls);
    // ========================= Warn =========================
    const warning = (0, $b5822acdae823465$export$e02e8dff7b78de83)("Form.Item");
    // ========================= MISC =========================
    // Get `noStyle` required info
    const listContext = $cQmXV.useContext((0, $e8f8acdce8879be3$export$2e2bcd8739ae039));
    const fieldKeyPathRef = $cQmXV.useRef(null);
    // ======================== Errors ========================
    // >>>>> Collect sub field errors
    const [subFieldErrors, setSubFieldErrors] = (0, $a4517f42cc2cc301$export$2e2bcd8739ae039)({});
    // >>>>> Current field errors
    const [meta, setMeta] = (0, $8caa85071cca5555$export$2e2bcd8739ae039)(()=>$923303217277ac4b$var$genEmptyMeta());
    const onMetaChange = (nextMeta)=>{
        // This keyInfo is not correct when field is removed
        // Since origin keyManager no longer keep the origin key anymore
        // Which means we need cache origin one and reuse when removed
        const keyInfo = listContext?.getKey(nextMeta.name);
        // Destroy will reset all the meta
        setMeta(nextMeta.destroy ? $923303217277ac4b$var$genEmptyMeta() : nextMeta, true);
        // Bump to parent since noStyle
        if (noStyle && help !== false && notifyParentMetaChange) {
            let namePath = nextMeta.name;
            if (!nextMeta.destroy) {
                if (keyInfo !== undefined) {
                    const [fieldKey, restPath] = keyInfo;
                    namePath = [
                        fieldKey
                    ].concat((0, $68381b18b974dc9f$export$2e2bcd8739ae039)(restPath));
                    fieldKeyPathRef.current = namePath;
                }
            } else // Use origin cache data
            namePath = fieldKeyPathRef.current || namePath;
            notifyParentMetaChange(nextMeta, namePath);
        }
    };
    // >>>>> Collect noStyle Field error to the top FormItem
    const onSubItemMetaChange = (subMeta, uniqueKeys)=>{
        // Only `noStyle` sub item will trigger
        setSubFieldErrors((prevSubFieldErrors)=>{
            const clone = {
                ...prevSubFieldErrors
            };
            // name: ['user', 1] + key: [4] = ['user', 4]
            const mergedNamePath = [].concat((0, $68381b18b974dc9f$export$2e2bcd8739ae039)(subMeta.name.slice(0, -1)), (0, $68381b18b974dc9f$export$2e2bcd8739ae039)(uniqueKeys));
            const mergedNameKey = mergedNamePath.join($923303217277ac4b$var$NAME_SPLIT);
            if (subMeta.destroy) // Remove
            delete clone[mergedNameKey];
            else // Update
            clone[mergedNameKey] = subMeta;
            return clone;
        });
    };
    // >>>>> Get merged errors
    const [mergedErrors, mergedWarnings] = $cQmXV.useMemo(()=>{
        const errorList = (0, $68381b18b974dc9f$export$2e2bcd8739ae039)(meta.errors);
        const warningList = (0, $68381b18b974dc9f$export$2e2bcd8739ae039)(meta.warnings);
        Object.values(subFieldErrors).forEach((subFieldError)=>{
            errorList.push.apply(errorList, (0, $68381b18b974dc9f$export$2e2bcd8739ae039)(subFieldError.errors || []));
            warningList.push.apply(warningList, (0, $68381b18b974dc9f$export$2e2bcd8739ae039)(subFieldError.warnings || []));
        });
        return [
            errorList,
            warningList
        ];
    }, [
        subFieldErrors,
        meta.errors,
        meta.warnings
    ]);
    // ===================== Children Ref =====================
    const getItemRef = (0, $b5e9c9d29868b4e2$export$2e2bcd8739ae039)();
    // ======================== Render ========================
    function renderLayout(baseChildren, fieldId, isRequired) {
        if (noStyle && !hidden) return /*#__PURE__*/ $cQmXV.createElement((0, $a5a263fbb181a426$export$2e2bcd8739ae039), {
            prefixCls: prefixCls,
            hasFeedback: props.hasFeedback,
            validateStatus: props.validateStatus,
            meta: meta,
            errors: mergedErrors,
            warnings: mergedWarnings,
            noStyle: true,
            name: name
        }, baseChildren);
        return /*#__PURE__*/ $cQmXV.createElement((0, $d0dab8e35c0950cd$export$2e2bcd8739ae039), {
            key: "row",
            ...props,
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(className, cssVarCls, rootCls, hashId),
            prefixCls: prefixCls,
            fieldId: fieldId,
            isRequired: isRequired,
            errors: mergedErrors,
            warnings: mergedWarnings,
            meta: meta,
            onSubItemMetaChange: onSubItemMetaChange,
            layout: layout,
            name: name
        }, baseChildren);
    }
    if (!hasName && !isRenderProps && !dependencies) return renderLayout(mergedChildren);
    let variables = {};
    if (typeof label === "string") variables.label = label;
    else if (name) variables.label = String(name);
    if (messageVariables) variables = {
        ...variables,
        ...messageVariables
    };
    // >>>>> With Field
    return /*#__PURE__*/ $cQmXV.createElement((0, $d1298bc083b1892f$export$2e2bcd8739ae039), {
        ...props,
        messageVariables: variables,
        trigger: trigger,
        validateTrigger: mergedValidateTrigger,
        onMetaChange: onMetaChange
    }, (control, renderMeta, context)=>{
        const mergedName = (0, $88e30d45d91e2cb7$export$45b10814cc054894)(name).length && renderMeta ? renderMeta.name : [];
        const fieldId = (0, $88e30d45d91e2cb7$export$f4457e83c74ac000)(mergedName, formName);
        const isRequired = required !== undefined ? required : rules?.some((rule)=>{
            if ((0, $8e2d153a3c855782$export$53b83ca8eaab0383)(rule) && rule.required && !rule.warningOnly) return true;
            if ((0, $8e2d153a3c855782$export$f6e2535fb5126e54)(rule)) {
                const ruleEntity = rule(context);
                return ruleEntity?.required && !ruleEntity?.warningOnly;
            }
            return false;
        });
        // ======================= Children =======================
        const mergedControl = {
            ...control
        };
        let childNode = null;
        if (Array.isArray(mergedChildren) && hasName) childNode = mergedChildren;
        else if (isRenderProps && (!(shouldUpdate || dependencies) || hasName)) ;
        else if (dependencies && !isRenderProps && !hasName) ;
        else if (/*#__PURE__*/ $cQmXV.isValidElement(mergedChildren)) {
            const childProps = {
                ...mergedChildren.props,
                ...mergedControl
            };
            if (!childProps.id) childProps.id = fieldId;
            if (help || mergedErrors.length > 0 || mergedWarnings.length > 0 || props.extra) {
                const describedbyArr = [];
                if (help || mergedErrors.length > 0) describedbyArr.push(`${fieldId}_help`);
                if (props.extra) describedbyArr.push(`${fieldId}_extra`);
                childProps["aria-describedby"] = describedbyArr.join(" ");
            }
            if (mergedErrors.length > 0) childProps["aria-invalid"] = "true";
            if (isRequired) childProps["aria-required"] = "true";
            if ((0, $10341b937b26f69d$export$c1cec34af06bcf7)(mergedChildren)) childProps.ref = getItemRef(mergedName, mergedChildren);
            // We should keep user origin event handler
            const triggers = new Set([].concat((0, $68381b18b974dc9f$export$2e2bcd8739ae039)((0, $88e30d45d91e2cb7$export$45b10814cc054894)(trigger)), (0, $68381b18b974dc9f$export$2e2bcd8739ae039)((0, $88e30d45d91e2cb7$export$45b10814cc054894)(mergedValidateTrigger))));
            triggers.forEach((eventName)=>{
                childProps[eventName] = (...args)=>{
                    mergedControl[eventName]?.(...args);
                    mergedChildren.props[eventName]?.(...args);
                };
            });
            // List of props that need to be watched for changes -> if changes are detected in MemoInput -> rerender
            const watchingChildProps = [
                childProps["aria-required"],
                childProps["aria-invalid"],
                childProps["aria-describedby"]
            ];
            childNode = /*#__PURE__*/ $cQmXV.createElement($923303217277ac4b$var$MemoInput, {
                control: mergedControl,
                update: mergedChildren,
                childProps: watchingChildProps
            }, (0, $a91ef204d03d8eec$export$e530037191fcd5d7)(mergedChildren, childProps));
        } else if (isRenderProps && (shouldUpdate || dependencies) && !hasName) childNode = mergedChildren(context);
        else childNode = mergedChildren;
        return renderLayout(childNode, fieldId, isRequired);
    });
}
const $923303217277ac4b$var$FormItem = $923303217277ac4b$var$InternalFormItem;
$923303217277ac4b$var$FormItem.useStatus = (0, $b1fea847123271bb$export$2e2bcd8739ae039);
var $923303217277ac4b$export$2e2bcd8739ae039 = $923303217277ac4b$var$FormItem;



var $cQmXV = parcelRequire("cQmXV");





"use client";
const $193d7a016f3c334a$var$FormList = ({ prefixCls: customizePrefixCls, children: children, ...props })=>{
    const { getPrefixCls: getPrefixCls } = $cQmXV.useContext((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls("form", customizePrefixCls);
    const contextValue = $cQmXV.useMemo(()=>({
            prefixCls: prefixCls,
            status: "error"
        }), [
        prefixCls
    ]);
    return /*#__PURE__*/ $cQmXV.createElement((0, $257bd90c8a7c2d10$export$2e2bcd8739ae039), {
        ...props
    }, (fields, operation, meta)=>/*#__PURE__*/ $cQmXV.createElement((0, $7a3804f153d8a19d$export$fb6582d3042cc879).Provider, {
            value: contextValue
        }, children(fields.map((field)=>({
                ...field,
                fieldKey: field.key
            })), operation, {
            errors: meta.errors,
            warnings: meta.warnings
        })));
};
var $193d7a016f3c334a$export$2e2bcd8739ae039 = $193d7a016f3c334a$var$FormList;



var $cQmXV = parcelRequire("cQmXV");

function $e8e8a4c7b74cb653$export$2e2bcd8739ae039() {
    const { form: form } = $cQmXV.useContext((0, $7a3804f153d8a19d$export$c24727297075ec6a));
    return form;
}


"use client";
const $e9904e0132e26ce3$var$Form = (0, $11c0390163969183$export$2e2bcd8739ae039);
$e9904e0132e26ce3$var$Form.Item = (0, $923303217277ac4b$export$2e2bcd8739ae039);
$e9904e0132e26ce3$var$Form.List = (0, $193d7a016f3c334a$export$2e2bcd8739ae039);
$e9904e0132e26ce3$var$Form.ErrorList = (0, $728e3c806ae967f7$export$2e2bcd8739ae039);
$e9904e0132e26ce3$var$Form.useForm = (0, $64ccfaf5ba9e6521$export$2e2bcd8739ae039);
$e9904e0132e26ce3$var$Form.useFormInstance = (0, $e8e8a4c7b74cb653$export$2e2bcd8739ae039);
$e9904e0132e26ce3$var$Form.useWatch = (0, $1e547a634d237262$export$2e2bcd8739ae039);
$e9904e0132e26ce3$var$Form.Provider = (0, $7a3804f153d8a19d$export$8ce1ff4f94d08846);
var $e9904e0132e26ce3$export$2e2bcd8739ae039 = $e9904e0132e26ce3$var$Form;


var $cQmXV = parcelRequire("cQmXV");










function $5e693f0c6e8784bd$export$a157d95850191a12(token) {
    return (0, $fef50f256b80dfa5$export$4950aa0f605343fb)(token, {
        inputAffixPadding: token.paddingXXS
    });
}
const $5e693f0c6e8784bd$export$bd8b682992bc9781 = (token)=>{
    const { controlHeight: controlHeight, fontSize: fontSize, lineHeight: lineHeight, lineWidth: lineWidth, lineWidthFocus: lineWidthFocus, controlHeightSM: controlHeightSM, controlHeightLG: controlHeightLG, fontSizeLG: fontSizeLG, lineHeightLG: lineHeightLG, paddingSM: paddingSM, controlPaddingHorizontalSM: controlPaddingHorizontalSM, controlPaddingHorizontal: controlPaddingHorizontal, colorFillAlter: colorFillAlter, colorPrimaryHover: colorPrimaryHover, colorPrimary: colorPrimary, controlOutlineWidth: controlOutlineWidth, controlOutline: controlOutline, colorErrorOutline: colorErrorOutline, colorWarningOutline: colorWarningOutline, colorBgContainer: colorBgContainer, inputFontSize: inputFontSize, inputFontSizeLG: inputFontSizeLG, inputFontSizeSM: inputFontSizeSM } = token;
    const mergedFontSize = inputFontSize || fontSize;
    const mergedFontSizeSM = inputFontSizeSM || mergedFontSize;
    const mergedFontSizeLG = inputFontSizeLG || fontSizeLG;
    const paddingBlock = Math.round((controlHeight - mergedFontSize * lineHeight) / 2 * 10) / 10 - lineWidth;
    const paddingBlockSM = Math.round((controlHeightSM - mergedFontSizeSM * lineHeight) / 2 * 10) / 10 - lineWidth;
    const paddingBlockLG = Math.ceil((controlHeightLG - mergedFontSizeLG * lineHeightLG) / 2 * 10) / 10 - lineWidth;
    const componentToken = {
        lineWidthFocus: lineWidthFocus === 0 ? 0 : lineWidth,
        paddingBlock: Math.max(paddingBlock, 0),
        paddingBlockSM: Math.max(paddingBlockSM, 0),
        paddingBlockLG: Math.max(paddingBlockLG, 0),
        paddingInline: paddingSM - lineWidth,
        paddingInlineSM: controlPaddingHorizontalSM - lineWidth,
        paddingInlineLG: controlPaddingHorizontal - lineWidth,
        addonBg: colorFillAlter,
        activeBorderColor: colorPrimary,
        hoverBorderColor: colorPrimaryHover,
        activeShadow: `0 0 0 ${controlOutlineWidth}px ${controlOutline}`,
        errorActiveShadow: `0 0 0 ${controlOutlineWidth}px ${colorErrorOutline}`,
        warningActiveShadow: `0 0 0 ${controlOutlineWidth}px ${colorWarningOutline}`,
        hoverBg: colorBgContainer,
        activeBg: colorBgContainer,
        inputFontSize: mergedFontSize,
        inputFontSizeLG: mergedFontSizeLG,
        inputFontSizeSM: mergedFontSizeSM
    };
    return componentToken;
};




const $189bffeae8a9954a$export$bf820fba296f2fd8 = (token)=>({
        borderColor: token.hoverBorderColor,
        backgroundColor: token.hoverBg
    });
const $189bffeae8a9954a$export$12789f962d420a93 = (token)=>({
        color: token.colorTextDisabled,
        backgroundColor: token.colorBgContainerDisabled,
        borderColor: token.colorBorderDisabled,
        boxShadow: "none",
        cursor: "not-allowed",
        opacity: 1,
        "input[disabled], textarea[disabled]": {
            cursor: "not-allowed"
        },
        "&:hover:not([disabled])": {
            ...$189bffeae8a9954a$export$bf820fba296f2fd8((0, $fef50f256b80dfa5$export$4950aa0f605343fb)(token, {
                hoverBorderColor: token.colorBorderDisabled,
                hoverBg: token.colorBgContainerDisabled
            }))
        }
    });
const $189bffeae8a9954a$export$8c569e4cc3fd115f = (token, options)=>({
        background: token.colorBgContainer,
        borderWidth: token.lineWidth,
        borderStyle: token.lineType,
        borderColor: options.borderColor,
        "&:hover": {
            borderColor: options.hoverBorderColor,
            backgroundColor: token.hoverBg
        },
        "&:focus, &:focus-within": {
            borderColor: options.activeBorderColor,
            boxShadow: options.activeShadow,
            outline: 0,
            backgroundColor: token.activeBg
        }
    });
const $189bffeae8a9954a$var$genOutlinedStatusStyle = (token, options)=>({
        [`&${token.componentCls}-status-${options.status}:not(${token.componentCls}-disabled)`]: {
            ...$189bffeae8a9954a$export$8c569e4cc3fd115f(token, options),
            [`${token.componentCls}-prefix, ${token.componentCls}-suffix`]: {
                color: options.affixColor
            }
        },
        [`&${token.componentCls}-status-${options.status}${token.componentCls}-disabled`]: {
            borderColor: options.borderColor
        }
    });
const $189bffeae8a9954a$export$53795bafd774ce02 = (token, extraStyles)=>({
        "&-outlined": {
            ...$189bffeae8a9954a$export$8c569e4cc3fd115f(token, {
                borderColor: token.colorBorder,
                hoverBorderColor: token.hoverBorderColor,
                activeBorderColor: token.activeBorderColor,
                activeShadow: token.activeShadow
            }),
            [`&${token.componentCls}-disabled, &[disabled]`]: {
                ...$189bffeae8a9954a$export$12789f962d420a93(token)
            },
            ...$189bffeae8a9954a$var$genOutlinedStatusStyle(token, {
                status: "error",
                borderColor: token.colorError,
                hoverBorderColor: token.colorErrorBorderHover,
                activeBorderColor: token.colorError,
                activeShadow: token.errorActiveShadow,
                affixColor: token.colorErrorAffix
            }),
            ...$189bffeae8a9954a$var$genOutlinedStatusStyle(token, {
                status: "warning",
                borderColor: token.colorWarning,
                hoverBorderColor: token.colorWarningBorderHover,
                activeBorderColor: token.colorWarning,
                activeShadow: token.warningActiveShadow,
                affixColor: token.colorWarningAffix
            }),
            ...extraStyles
        }
    });
const $189bffeae8a9954a$var$genOutlinedGroupStatusStyle = (token, options)=>({
        [`&${token.componentCls}-group-wrapper-status-${options.status}`]: {
            [`${token.componentCls}-group-addon`]: {
                borderColor: options.addonBorderColor,
                color: options.addonColor
            }
        }
    });
const $189bffeae8a9954a$export$8f88f32c046ff727 = (token)=>({
        "&-outlined": {
            [`${token.componentCls}-group`]: {
                "&-addon": {
                    background: token.addonBg,
                    border: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
                },
                "&-addon:first-child": {
                    borderInlineEnd: 0
                },
                "&-addon:last-child": {
                    borderInlineStart: 0
                }
            },
            ...$189bffeae8a9954a$var$genOutlinedGroupStatusStyle(token, {
                status: "error",
                addonBorderColor: token.colorError,
                addonColor: token.colorErrorText
            }),
            ...$189bffeae8a9954a$var$genOutlinedGroupStatusStyle(token, {
                status: "warning",
                addonBorderColor: token.colorWarning,
                addonColor: token.colorWarningText
            }),
            [`&${token.componentCls}-group-wrapper-disabled`]: {
                [`${token.componentCls}-group-addon`]: {
                    ...$189bffeae8a9954a$export$12789f962d420a93(token)
                }
            }
        }
    });
/* ============ Borderless ============ */ const $189bffeae8a9954a$var$borderlessFocusVisibleSelector = "&:focus-visible, &:has(input:focus-visible), &:has(textarea:focus-visible)";
const $189bffeae8a9954a$var$genBorderlessFocusVisibleStyle = (token, outlineColor)=>({
        outline: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidthFocus)} ${token.lineType} ${outlineColor}`,
        outlineOffset: (0, $05f34ed03d41967d$export$523c0b569236b342)(token.calc(token.lineWidth).mul(-1).equal()),
        transition: [
            `outline-offset`,
            `outline`
        ].map((prop)=>`${prop} 0s`).join(", ")
    });
const $189bffeae8a9954a$var$genBorderlessStatusStyle = (token, options)=>({
        "&, & input, & textarea": {
            color: options.color
        },
        [$189bffeae8a9954a$var$borderlessFocusVisibleSelector]: $189bffeae8a9954a$var$genBorderlessFocusVisibleStyle(token, options.color),
        [`${token.componentCls}-prefix, ${token.componentCls}-suffix`]: {
            color: options.affixColor
        }
    });
const $189bffeae8a9954a$export$b6de5da7f39edfcb = (token, extraStyles)=>{
    const { componentCls: componentCls } = token;
    return {
        "&-borderless": {
            background: "transparent",
            border: "none",
            // Compensate for the removed border to maintain consistent height with other components
            // (e.g. Select borderless) that keep a transparent border.
            paddingBlock: token.calc(token.paddingBlock).add(token.lineWidth).equal(),
            [`&${componentCls}-sm, &${componentCls}-affix-wrapper-sm`]: {
                paddingBlock: token.calc(token.paddingBlockSM).add(token.lineWidth).equal()
            },
            [`&${componentCls}-lg, &${componentCls}-affix-wrapper-lg`]: {
                paddingBlock: token.calc(token.paddingBlockLG).add(token.lineWidth).equal()
            },
            "&:focus, &:focus-within": {
                outline: "none"
            },
            [$189bffeae8a9954a$var$borderlessFocusVisibleSelector]: $189bffeae8a9954a$var$genBorderlessFocusVisibleStyle(token, token.activeBorderColor),
            // >>>>> Disabled
            [`&${componentCls}-disabled, &[disabled]`]: {
                color: token.colorTextDisabled,
                cursor: "not-allowed"
            },
            // >>>>> Status
            [`&${componentCls}-status-error`]: $189bffeae8a9954a$var$genBorderlessStatusStyle(token, {
                color: token.colorError,
                affixColor: token.colorErrorAffix
            }),
            [`&${componentCls}-status-warning`]: $189bffeae8a9954a$var$genBorderlessStatusStyle(token, {
                color: token.colorWarning,
                affixColor: token.colorWarningAffix
            }),
            ...extraStyles
        }
    };
};
/* ============== Filled ============== */ const $189bffeae8a9954a$var$genBaseFilledStyle = (token, options)=>({
        background: options.bg,
        borderWidth: token.lineWidth,
        borderStyle: token.lineType,
        borderColor: "transparent",
        "input&, & input, textarea&, & textarea": {
            color: options?.inputColor ?? "unset"
        },
        "&:hover": {
            background: options.hoverBg
        },
        "&:focus, &:focus-within": {
            outline: 0,
            borderColor: options.activeBorderColor,
            backgroundColor: token.activeBg
        }
    });
const $189bffeae8a9954a$var$genFilledStatusStyle = (token, options)=>({
        [`&${token.componentCls}-status-${options.status}:not(${token.componentCls}-disabled)`]: {
            ...$189bffeae8a9954a$var$genBaseFilledStyle(token, options),
            [`${token.componentCls}-prefix, ${token.componentCls}-suffix`]: {
                color: options.affixColor
            }
        }
    });
const $189bffeae8a9954a$export$b8365cd7e6671d79 = (token, extraStyles)=>({
        "&-filled": {
            ...$189bffeae8a9954a$var$genBaseFilledStyle(token, {
                bg: token.colorFillTertiary,
                hoverBg: token.colorFillSecondary,
                activeBorderColor: token.activeBorderColor,
                inputColor: token.colorText
            }),
            [`&${token.componentCls}-disabled, &[disabled]`]: {
                ...$189bffeae8a9954a$export$12789f962d420a93(token)
            },
            ...$189bffeae8a9954a$var$genFilledStatusStyle(token, {
                status: "error",
                bg: token.colorErrorBg,
                hoverBg: token.colorErrorBgHover,
                activeBorderColor: token.colorError,
                inputColor: token.colorErrorText,
                affixColor: token.colorErrorAffix
            }),
            ...$189bffeae8a9954a$var$genFilledStatusStyle(token, {
                status: "warning",
                bg: token.colorWarningBg,
                hoverBg: token.colorWarningBgHover,
                activeBorderColor: token.colorWarning,
                inputColor: token.colorWarningText,
                affixColor: token.colorWarningAffix
            }),
            ...extraStyles
        }
    });
const $189bffeae8a9954a$var$genFilledGroupStatusStyle = (token, options)=>({
        [`&${token.componentCls}-group-wrapper-status-${options.status}`]: {
            [`${token.componentCls}-group-addon`]: {
                background: options.addonBg,
                color: options.addonColor
            }
        }
    });
const $189bffeae8a9954a$export$542c0fce51b1d515 = (token)=>({
        "&-filled": {
            [`${token.componentCls}-group-addon`]: {
                background: token.colorFillTertiary,
                "&:last-child": {
                    position: "static"
                }
            },
            ...$189bffeae8a9954a$var$genFilledGroupStatusStyle(token, {
                status: "error",
                addonBg: token.colorErrorBg,
                addonColor: token.colorErrorText
            }),
            ...$189bffeae8a9954a$var$genFilledGroupStatusStyle(token, {
                status: "warning",
                addonBg: token.colorWarningBg,
                addonColor: token.colorWarningText
            }),
            [`&${token.componentCls}-group-wrapper-disabled`]: {
                [`${token.componentCls}-group`]: {
                    "&-addon": {
                        background: token.colorFillTertiary,
                        color: token.colorTextDisabled
                    },
                    "&-addon:first-child": {
                        borderInlineStart: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                        borderTop: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                        borderBottom: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
                    },
                    "&-addon:last-child": {
                        borderInlineEnd: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                        borderTop: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                        borderBottom: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
                    }
                }
            }
        }
    });
const $189bffeae8a9954a$export$7617a11352d704b9 = (token, options)=>({
        background: token.colorBgContainer,
        borderWidth: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidth)} 0`,
        borderStyle: `${token.lineType} none`,
        borderColor: `transparent transparent ${options.borderColor} transparent`,
        borderRadius: 0,
        "&:hover": {
            borderColor: `transparent transparent ${options.hoverBorderColor} transparent`,
            backgroundColor: token.hoverBg
        },
        "&:focus, &:focus-within": {
            borderColor: `transparent transparent ${options.activeBorderColor} transparent`,
            outline: 0,
            backgroundColor: token.activeBg
        }
    });
const $189bffeae8a9954a$var$genUnderlinedStatusStyle = (token, options)=>({
        [`&${token.componentCls}-status-${options.status}:not(${token.componentCls}-disabled)`]: {
            ...$189bffeae8a9954a$export$7617a11352d704b9(token, options),
            [`${token.componentCls}-prefix, ${token.componentCls}-suffix`]: {
                color: options.affixColor
            }
        },
        [`&${token.componentCls}-status-${options.status}${token.componentCls}-disabled`]: {
            borderColor: `transparent transparent ${options.borderColor} transparent`
        }
    });
const $189bffeae8a9954a$export$34771e60e0439351 = (token, extraStyles)=>({
        "&-underlined": {
            ...$189bffeae8a9954a$export$7617a11352d704b9(token, {
                borderColor: token.colorBorder,
                hoverBorderColor: token.hoverBorderColor,
                activeBorderColor: token.activeBorderColor,
                activeShadow: token.activeShadow
            }),
            // >>>>> Disabled
            [`&${token.componentCls}-disabled, &[disabled]`]: {
                color: token.colorTextDisabled,
                boxShadow: "none",
                cursor: "not-allowed",
                "&:hover": {
                    borderColor: `transparent transparent ${token.colorBorder} transparent`
                }
            },
            "input[disabled], textarea[disabled]": {
                cursor: "not-allowed"
            },
            ...$189bffeae8a9954a$var$genUnderlinedStatusStyle(token, {
                status: "error",
                borderColor: token.colorError,
                hoverBorderColor: token.colorErrorBorderHover,
                activeBorderColor: token.colorError,
                activeShadow: token.errorActiveShadow,
                affixColor: token.colorErrorAffix
            }),
            ...$189bffeae8a9954a$var$genUnderlinedStatusStyle(token, {
                status: "warning",
                borderColor: token.colorWarning,
                hoverBorderColor: token.colorWarningBorderHover,
                activeBorderColor: token.colorWarning,
                activeShadow: token.warningActiveShadow,
                affixColor: token.colorWarningAffix
            }),
            ...extraStyles
        }
    });


const $8c2dcdcd3819e8c0$export$92095d0f4c77bd56 = (color)=>({
        // Firefox
        "&::-moz-placeholder": {
            opacity: 1
        },
        "&::placeholder": {
            color: color,
            userSelect: "none" // https://github.com/ant-design/ant-design/pull/32639
        },
        "&:placeholder-shown": {
            textOverflow: "ellipsis"
        }
    });
const $8c2dcdcd3819e8c0$export$3fe86db3643510f9 = (token)=>({
        borderColor: token.activeBorderColor,
        boxShadow: token.activeShadow,
        outline: 0,
        backgroundColor: token.activeBg
    });
const $8c2dcdcd3819e8c0$export$88e04420bb2dc003 = (token)=>{
    const { paddingBlockLG: paddingBlockLG, lineHeightLG: lineHeightLG, borderRadiusLG: borderRadiusLG, paddingInlineLG: paddingInlineLG } = token;
    return {
        padding: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(paddingBlockLG)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(paddingInlineLG)}`,
        fontSize: token.inputFontSizeLG,
        lineHeight: lineHeightLG,
        borderRadius: borderRadiusLG
    };
};
const $8c2dcdcd3819e8c0$export$bb047f62c5a56f90 = (token)=>({
        padding: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.paddingBlockSM)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.paddingInlineSM)}`,
        fontSize: token.inputFontSizeSM,
        borderRadius: token.borderRadiusSM
    });
const $8c2dcdcd3819e8c0$export$8c9a381315f3ebcd = (token, option = {})=>({
        position: "relative",
        display: "inline-block",
        width: "100%",
        minWidth: 0,
        padding: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.paddingBlock)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.paddingInline)}`,
        color: token.colorText,
        fontSize: token.inputFontSize,
        lineHeight: token.lineHeight,
        borderRadius: token.borderRadius,
        transition: `all ${token.motionDurationMid}`,
        ...$8c2dcdcd3819e8c0$export$92095d0f4c77bd56(token.colorTextPlaceholder),
        // Size
        "&-lg": {
            ...$8c2dcdcd3819e8c0$export$88e04420bb2dc003(token),
            ...option.largeStyle
        },
        "&-sm": {
            ...$8c2dcdcd3819e8c0$export$bb047f62c5a56f90(token),
            ...option.smallStyle
        },
        // RTL
        "&-rtl, &-textarea-rtl": {
            direction: "rtl"
        }
    });
const $8c2dcdcd3819e8c0$export$ffe8b2a9bd2e5cfe = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    return {
        position: "relative",
        display: "table",
        width: "100%",
        borderCollapse: "separate",
        borderSpacing: 0,
        // Undo padding and float of grid classes
        "&[class*='col-']": {
            paddingInlineEnd: token.paddingXS,
            "&:last-child": {
                paddingInlineEnd: 0
            }
        },
        // Sizing options
        [`&-lg ${componentCls}, &-lg > ${componentCls}-group-addon`]: {
            ...$8c2dcdcd3819e8c0$export$88e04420bb2dc003(token)
        },
        [`&-sm ${componentCls}, &-sm > ${componentCls}-group-addon`]: {
            ...$8c2dcdcd3819e8c0$export$bb047f62c5a56f90(token)
        },
        // Fix https://github.com/ant-design/ant-design/issues/5754
        [`&-lg ${antCls}-select-single`]: {
            height: token.controlHeightLG
        },
        [`&-sm ${antCls}-select-single`]: {
            height: token.controlHeightSM
        },
        [`> ${componentCls}`]: {
            display: "table-cell",
            "&:not(:first-child):not(:last-child)": {
                borderRadius: 0
            }
        },
        [`${componentCls}-group`]: {
            "&-addon, &-wrap": {
                display: "table-cell",
                width: 1,
                whiteSpace: "nowrap",
                verticalAlign: "middle",
                "&:not(:first-child):not(:last-child)": {
                    borderRadius: 0
                }
            },
            "&-wrap > *": {
                display: "block !important"
            },
            "&-addon": {
                position: "relative",
                padding: `0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.paddingInline)}`,
                color: token.colorText,
                fontWeight: "normal",
                fontSize: token.inputFontSize,
                textAlign: "center",
                borderRadius: token.borderRadius,
                transition: `all ${token.motionDurationSlow}`,
                lineHeight: 1,
                // Reset Select's style in addon
                [`${antCls}-select`]: {
                    margin: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.calc(token.paddingBlock).add(1).mul(-1).equal())} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.calc(token.paddingInline).mul(-1).equal())}`,
                    [`&${antCls}-select-single:not(${antCls}-select-customize-input):not(${antCls}-pagination-size-changer)`]: {
                        backgroundColor: "inherit",
                        border: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} transparent`,
                        boxShadow: "none"
                    }
                },
                // https://github.com/ant-design/ant-design/issues/31333
                [`${antCls}-cascader-picker`]: {
                    margin: `-9px ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.calc(token.paddingInline).mul(-1).equal())}`,
                    backgroundColor: "transparent",
                    [`${antCls}-cascader-input`]: {
                        textAlign: "start",
                        border: 0,
                        boxShadow: "none"
                    }
                }
            }
        },
        [componentCls]: {
            width: "100%",
            marginBottom: 0,
            textAlign: "inherit",
            "&:focus": {
                zIndex: 1,
                // Fix https://gw.alipayobjects.com/zos/rmsportal/DHNpoqfMXSfrSnlZvhsJ.png
                borderInlineEndWidth: 1
            },
            "&:hover": {
                zIndex: 1,
                borderInlineEndWidth: 1
            }
        },
        // Reset rounded corners
        [`> ${componentCls}:first-child, ${componentCls}-group-addon:first-child`]: {
            borderStartEndRadius: 0,
            borderEndEndRadius: 0,
            // Reset Select's style in addon
            [`${antCls}-select`]: {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0
            }
        },
        [`> ${componentCls}-affix-wrapper`]: {
            [`&:not(:first-child) ${componentCls}`]: {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
            },
            [`&:not(:last-child) ${componentCls}`]: {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0
            }
        },
        [`> ${componentCls}:last-child, ${componentCls}-group-addon:last-child`]: {
            borderStartStartRadius: 0,
            borderEndStartRadius: 0,
            // Reset Select's style in addon
            [`${antCls}-select`]: {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
            }
        },
        [`${componentCls}-affix-wrapper`]: {
            "&:not(:last-child)": {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0
            },
            "&:not(:first-child)": {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
            }
        },
        [`&${componentCls}-group-compact`]: {
            display: "block",
            ...(0, $519d20bf207ce864$export$8c467e8859fdef13)(),
            [`${componentCls}-group-addon, ${componentCls}-group-wrap, > ${componentCls}`]: {
                "&:not(:first-child):not(:last-child)": {
                    borderInlineEndWidth: token.lineWidth,
                    "&:hover, &:focus": {
                        zIndex: 1
                    }
                }
            },
            "& > *": {
                display: "inline-flex",
                float: "none",
                verticalAlign: "top",
                // https://github.com/ant-design/ant-design-pro/issues/139
                borderRadius: 0
            },
            [`
        & > ${componentCls}-affix-wrapper,
        & > ${componentCls}-number-affix-wrapper,
        & > ${antCls}-picker-range
      `]: {
                display: "inline-flex"
            },
            "& > *:not(:last-child)": {
                marginInlineEnd: token.calc(token.lineWidth).mul(-1).equal(),
                borderInlineEndWidth: token.lineWidth
            },
            // Undo float for .ant-input-group .ant-input
            [componentCls]: {
                float: "none"
            },
            // reset border for Select, DatePicker, AutoComplete, Cascader, Mention, TimePicker, Input
            [`& > ${antCls}-select,
      & > ${antCls}-select-auto-complete ${componentCls},
      & > ${antCls}-cascader-picker ${componentCls},
      & > ${componentCls}-group-wrapper ${componentCls}`]: {
                borderInlineEndWidth: token.lineWidth,
                borderRadius: 0,
                "&:hover, &:focus": {
                    zIndex: 1
                }
            },
            [`& > ${antCls}-select-focused`]: {
                zIndex: 1
            },
            // update z-index for arrow icon
            [`& > ${antCls}-select > ${antCls}-select-arrow`]: {
                zIndex: 1 // https://github.com/ant-design/ant-design/issues/20371
            },
            [`& > *:first-child,
      & > ${antCls}-select:first-child,
      & > ${antCls}-select-auto-complete:first-child ${componentCls},
      & > ${antCls}-cascader-picker:first-child ${componentCls}`]: {
                borderStartStartRadius: token.borderRadius,
                borderEndStartRadius: token.borderRadius
            },
            [`& > *:last-child,
      & > ${antCls}-select:last-child,
      & > ${antCls}-cascader-picker:last-child ${componentCls},
      & > ${antCls}-cascader-picker-focused:last-child ${componentCls}`]: {
                borderInlineEndWidth: token.lineWidth,
                borderStartEndRadius: token.borderRadius,
                borderEndEndRadius: token.borderRadius
            },
            // https://github.com/ant-design/ant-design/issues/12493
            [`& > ${antCls}-select-auto-complete ${componentCls}`]: {
                verticalAlign: "top"
            },
            [`${componentCls}-group-wrapper + ${componentCls}-group-wrapper`]: {
                marginInlineStart: token.calc(token.lineWidth).mul(-1).equal(),
                [`${componentCls}-affix-wrapper`]: {
                }
            }
        }
    };
};
const $8c2dcdcd3819e8c0$export$9a752c3888370836 = (token)=>{
    const { componentCls: componentCls, controlHeightSM: controlHeightSM, lineWidth: lineWidth, calc: calc } = token;
    const FIXED_CHROME_COLOR_HEIGHT = 16;
    const colorSmallPadding = calc(controlHeightSM).sub(calc(lineWidth).mul(2)).sub(FIXED_CHROME_COLOR_HEIGHT).div(2).equal();
    return {
        [componentCls]: {
            ...(0, $519d20bf207ce864$export$23997c3e44cc1c59)(token),
            ...$8c2dcdcd3819e8c0$export$8c9a381315f3ebcd(token),
            // Variants
            ...(0, $189bffeae8a9954a$export$53795bafd774ce02)(token),
            ...(0, $189bffeae8a9954a$export$b8365cd7e6671d79)(token),
            ...(0, $189bffeae8a9954a$export$b6de5da7f39edfcb)(token),
            ...(0, $189bffeae8a9954a$export$34771e60e0439351)(token),
            '&[type="color"]': {
                height: token.controlHeight,
                [`&${componentCls}-lg`]: {
                    height: token.controlHeightLG
                },
                [`&${componentCls}-sm`]: {
                    height: controlHeightSM,
                    paddingTop: colorSmallPadding,
                    paddingBottom: colorSmallPadding
                }
            },
            '&[type="search"]::-webkit-search-cancel-button, &[type="search"]::-webkit-search-decoration': {
                appearance: "none"
            }
        }
    };
};
const $8c2dcdcd3819e8c0$var$genAllowClearStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        // ========================= Input =========================
        [`${componentCls}-clear-icon`]: {
            margin: 0,
            padding: 0,
            lineHeight: 0,
            color: token.colorTextQuaternary,
            fontSize: token.fontSizeIcon,
            verticalAlign: -1,
            // https://github.com/ant-design/ant-design/pull/18151
            // https://codesandbox.io/s/wizardly-sun-u10br
            cursor: "pointer",
            transition: `color ${token.motionDurationSlow}`,
            border: "none",
            outline: "none",
            backgroundColor: "transparent",
            "&:hover": {
                color: token.colorIcon
            },
            "&:focus-visible": {
                color: token.colorIcon,
                borderRadius: token.borderRadiusSM,
                ...(0, $519d20bf207ce864$export$6539948f0a737e39)(token)
            },
            "&:active": {
                color: token.colorText
            },
            "&-hidden": {
                visibility: "hidden"
            },
            "&-has-suffix": {
                margin: `0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.inputAffixPadding)}`
            }
        }
    };
};
const $8c2dcdcd3819e8c0$export$77a75da75a374eb9 = (token)=>{
    const { componentCls: componentCls, inputAffixPadding: inputAffixPadding, colorTextDescription: colorTextDescription, motionDurationSlow: motionDurationSlow, colorIcon: colorIcon, colorIconHover: colorIconHover } = token;
    const affixCls = `${componentCls}-affix-wrapper`;
    const affixClsDisabled = `${componentCls}-affix-wrapper-disabled`;
    return {
        [affixCls]: {
            ...$8c2dcdcd3819e8c0$export$8c9a381315f3ebcd(token),
            display: "inline-flex",
            "&-focused, &:focus": {
                zIndex: 1
            },
            [`> input${componentCls}`]: {
                padding: 0
            },
            [`> input${componentCls}, > textarea${componentCls}`]: {
                fontSize: "inherit",
                border: "none",
                borderRadius: 0,
                outline: "none",
                background: "transparent",
                color: "inherit",
                "&::-ms-reveal": {
                    display: "none"
                },
                "&:focus": {
                    boxShadow: "none !important"
                }
            },
            "&::before": {
                display: "inline-block",
                width: 0,
                visibility: "hidden",
                content: '"\\a0"'
            },
            [componentCls]: {
                "&-prefix, &-suffix": {
                    display: "flex",
                    flex: "none",
                    alignItems: "center",
                    "> *:not(:last-child)": {
                        marginInlineEnd: token.paddingXS
                    }
                },
                "&-show-count-suffix": {
                    color: colorTextDescription,
                    direction: "ltr"
                },
                "&-show-count-has-suffix": {
                    marginInlineEnd: token.paddingXXS
                },
                "&-prefix": {
                    marginInlineEnd: inputAffixPadding
                },
                "&-suffix": {
                    marginInlineStart: inputAffixPadding
                },
                // password
                "&-password-icon": {
                    display: "inline-flex",
                    color: colorIcon,
                    cursor: "pointer",
                    transition: `all ${motionDurationSlow}`,
                    "&:hover": {
                        color: colorIconHover
                    }
                }
            },
            ...$8c2dcdcd3819e8c0$var$genAllowClearStyle(token)
        },
        // 覆盖 affix-wrapper borderRadius！
        [`${componentCls}-underlined`]: {
            borderRadius: 0
        },
        [affixClsDisabled]: {
            // password disabled
            [`${componentCls}-password-icon`]: {
                color: colorIcon,
                cursor: "not-allowed",
                "&:hover": {
                    color: colorIcon
                }
            }
        }
    };
};
const $8c2dcdcd3819e8c0$var$genGroupStyle = (token)=>{
    const { componentCls: componentCls, borderRadiusLG: borderRadiusLG, borderRadiusSM: borderRadiusSM } = token;
    return {
        [`${componentCls}-group`]: {
            // Style for input-group: input with label, with button or dropdown...
            ...(0, $519d20bf207ce864$export$23997c3e44cc1c59)(token),
            ...$8c2dcdcd3819e8c0$export$ffe8b2a9bd2e5cfe(token),
            "&-rtl": {
                direction: "rtl"
            },
            "&-wrapper": {
                display: "inline-block",
                width: "100%",
                textAlign: "start",
                verticalAlign: "top",
                // https://github.com/ant-design/ant-design/issues/6403
                "&-rtl": {
                    direction: "rtl"
                },
                // Size
                "&-lg": {
                    [`${componentCls}-group-addon`]: {
                        borderRadius: borderRadiusLG,
                        fontSize: token.inputFontSizeLG
                    }
                },
                "&-sm": {
                    [`${componentCls}-group-addon`]: {
                        borderRadius: borderRadiusSM
                    }
                },
                // Variants
                ...(0, $189bffeae8a9954a$export$8f88f32c046ff727)(token),
                ...(0, $189bffeae8a9954a$export$542c0fce51b1d515)(token),
                // '&-disabled': {
                //   [`${componentCls}-group-addon`]: {
                //     ...genDisabledStyle(token),
                //   },
                // },
                // Fix the issue of using icons in Space Compact mode
                // https://github.com/ant-design/ant-design/issues/42122
                [`&:not(${componentCls}-compact-first-item):not(${componentCls}-compact-last-item)${componentCls}-compact-item`]: {
                    [`${componentCls}, ${componentCls}-group-addon`]: {
                        borderRadius: 0
                    }
                },
                [`&:not(${componentCls}-compact-last-item)${componentCls}-compact-first-item`]: {
                    [`${componentCls}, ${componentCls}-group-addon`]: {
                        borderStartEndRadius: 0,
                        borderEndEndRadius: 0
                    }
                },
                [`&:not(${componentCls}-compact-first-item)${componentCls}-compact-last-item`]: {
                    [`${componentCls}, ${componentCls}-group-addon`]: {
                        borderStartStartRadius: 0,
                        borderEndStartRadius: 0
                    }
                },
                // Fix the issue of input use show-count param in space compact mode
                // https://github.com/ant-design/ant-design/issues/46872
                [`&:not(${componentCls}-compact-last-item)${componentCls}-compact-item`]: {
                    [`${componentCls}-affix-wrapper`]: {
                        borderStartEndRadius: 0,
                        borderEndEndRadius: 0
                    }
                },
                // Fix the issue of input use `addonAfter` param in space compact mode
                // https://github.com/ant-design/ant-design/issues/52483
                [`&:not(${componentCls}-compact-first-item)${componentCls}-compact-item`]: {
                    [`${componentCls}-affix-wrapper`]: {
                        borderStartStartRadius: 0,
                        borderEndStartRadius: 0
                    }
                }
            }
        }
    };
};
// ============================== Range ===============================
const $8c2dcdcd3819e8c0$var$genRangeStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-out-of-range`]: {
            [`&, & input, & textarea, ${componentCls}-show-count-suffix, ${componentCls}-data-count`]: {
                color: token.colorError
            }
        }
    };
};
const $8c2dcdcd3819e8c0$export$de732caeaad5f68e = (0, $6870d4d7c14ae0bb$export$51ec95de45185b42)([
    "Input",
    "Shared"
], (token)=>{
    const inputToken = (0, $fef50f256b80dfa5$export$4950aa0f605343fb)(token, (0, $5e693f0c6e8784bd$export$a157d95850191a12)(token));
    return [
        $8c2dcdcd3819e8c0$export$9a752c3888370836(inputToken),
        $8c2dcdcd3819e8c0$export$77a75da75a374eb9(inputToken)
    ];
}, (0, $5e693f0c6e8784bd$export$bd8b682992bc9781), {
    resetFont: false
});
var $8c2dcdcd3819e8c0$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$51ec95de45185b42)([
    "Input",
    "Component"
], (token)=>{
    const inputToken = (0, $fef50f256b80dfa5$export$4950aa0f605343fb)(token, (0, $5e693f0c6e8784bd$export$a157d95850191a12)(token));
    return [
        $8c2dcdcd3819e8c0$var$genGroupStyle(inputToken),
        $8c2dcdcd3819e8c0$var$genRangeStyle(inputToken),
        // =====================================================
        // ==             Space Compact                       ==
        // =====================================================
        (0, $6e46145470fc0a51$export$b1208b23589b4b73)(inputToken, {
            focus: true,
            focusElCls: `${inputToken.componentCls}-affix-wrapper-focused`
        })
    ];
}, (0, $5e693f0c6e8784bd$export$bd8b682992bc9781), {
    resetFont: false
});


"use client";
/** @deprecated Please use `Space.Compact` */ const $dd018f91a6c9077f$var$Group = (props)=>{
    const { getPrefixCls: getPrefixCls, direction: direction } = (0, $cQmXV.useContext)((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    const { prefixCls: customizePrefixCls, className: className } = props;
    const prefixCls = getPrefixCls("input-group", customizePrefixCls);
    const inputPrefixCls = getPrefixCls("input");
    const [hashId, cssVarCls] = (0, $8c2dcdcd3819e8c0$export$2e2bcd8739ae039)(inputPrefixCls);
    const cls = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, cssVarCls, {
        [`${prefixCls}-lg`]: props.size === "large",
        [`${prefixCls}-sm`]: props.size === "small",
        [`${prefixCls}-compact`]: props.compact,
        [`${prefixCls}-rtl`]: direction === "rtl"
    }, hashId, className);
    const formItemContext = (0, $cQmXV.useContext)((0, $7a3804f153d8a19d$export$bbb5553c6c7a14ed));
    const groupFormItemContext = (0, $cQmXV.useMemo)(()=>({
            ...formItemContext,
            isFormItemInput: false
        }), [
        formItemContext
    ]);
    return /*#__PURE__*/ $cQmXV.createElement((0, $7a3804f153d8a19d$export$bbb5553c6c7a14ed).Provider, {
        value: groupFormItemContext
    }, /*#__PURE__*/ $cQmXV.createElement((0, $eb1133c43d00490b$export$2e2bcd8739ae039).Compact, {
        className: cls,
        style: props.style,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        onFocus: props.onFocus,
        onBlur: props.onBlur
    }, props.children));
};
var $dd018f91a6c9077f$export$2e2bcd8739ae039 = $dd018f91a6c9077f$var$Group;



var $cQmXV = parcelRequire("cQmXV");


var $cQmXV = parcelRequire("cQmXV");
function $e26b9820b23aae67$export$ae6255aa850a31d1(props) {
    return !!(props.addonBefore || props.addonAfter);
}
function $e26b9820b23aae67$export$a19010aeeaa0c7a(props) {
    return !!(props.prefix || props.suffix || props.allowClear);
}
// TODO: It's better to use `Proxy` replace the `element.value`. But we still need support IE11.
function $e26b9820b23aae67$var$cloneEvent(event, target, value) {
    // A bug report filed on WebKit's Bugzilla tracker, dating back to 2009, specifically addresses the issue of cloneNode() not copying files of <input type="file"> elements.
    // As of the last update, this bug was still marked as "NEW," indicating that it might not have been resolved yet​​.
    // https://bugs.webkit.org/show_bug.cgi?id=28123
    const currentTarget = target.cloneNode(true);
    // click clear icon
    const newEvent = Object.create(event, {
        target: {
            value: currentTarget
        },
        currentTarget: {
            value: currentTarget
        }
    });
    // Fill data
    currentTarget.value = value;
    // Fill selection. Some type like `email` not support selection
    // https://github.com/ant-design/ant-design/issues/47833
    if (typeof target.selectionStart === "number" && typeof target.selectionEnd === "number") {
        currentTarget.selectionStart = target.selectionStart;
        currentTarget.selectionEnd = target.selectionEnd;
    }
    currentTarget.setSelectionRange = (...args)=>{
        target.setSelectionRange(...args);
    };
    return newEvent;
}
function $e26b9820b23aae67$export$c28984794956ddc0(target, e, onChange, targetValue) {
    if (!onChange) return;
    let event = e;
    if (e.type === "click") {
        // Clone a new target for event.
        // Avoid the following usage, the setQuery method gets the original value.
        //
        // const [query, setQuery] = React.useState('');
        // <Input
        //   allowClear
        //   value={query}
        //   onChange={(e)=> {
        //     setQuery((prevStatus) => e.target.value);
        //   }}
        // />
        event = $e26b9820b23aae67$var$cloneEvent(e, target, "");
        onChange(event);
        return;
    }
    // Trigger by composition event, this means we need force change the input value
    // https://github.com/ant-design/ant-design/issues/45737
    // https://github.com/ant-design/ant-design/issues/46598
    if (target.type !== "file" && targetValue !== undefined) {
        event = $e26b9820b23aae67$var$cloneEvent(e, target, targetValue);
        onChange(event);
        return;
    }
    onChange(event);
}


function $48f4f63fa4370229$var$_extends() {
    $48f4f63fa4370229$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $48f4f63fa4370229$var$_extends.apply(this, arguments);
}
const $48f4f63fa4370229$var$BaseInput = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).forwardRef((props, ref)=>{
    const { inputElement: inputEl, children: children, prefixCls: prefixCls, prefix: prefix, suffix: suffix, addonBefore: addonBefore, addonAfter: addonAfter, className: className, style: style, disabled: disabled, readOnly: readOnly, focused: focused, triggerFocus: triggerFocus, allowClear: allowClear, value: value, handleReset: handleReset, hidden: hidden, classes: classes, classNames: classNames, dataAttrs: dataAttrs, styles: styles, components: components, onClear: onClear } = props;
    const inputElement = children ?? inputEl;
    const AffixWrapperComponent = components?.affixWrapper || "span";
    const GroupWrapperComponent = components?.groupWrapper || "span";
    const WrapperComponent = components?.wrapper || "span";
    const GroupAddonComponent = components?.groupAddon || "span";
    const containerRef = (0, $cQmXV.useRef)(null);
    const onInputClick = (e)=>{
        if (containerRef.current?.contains(e.target)) triggerFocus?.();
    };
    const hasAffix = (0, $e26b9820b23aae67$export$a19010aeeaa0c7a)(props);
    let element = /*#__PURE__*/ (0, $cQmXV.cloneElement)(inputElement, {
        value: value,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(inputElement.props?.className, !hasAffix && classNames?.variant) || null
    });
    // ======================== Ref ======================== //
    const groupRef = (0, $cQmXV.useRef)(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useImperativeHandle(ref, ()=>({
            nativeElement: groupRef.current || containerRef.current
        }));
    // ================== Prefix & Suffix ================== //
    if (hasAffix) {
        // ================== Clear Icon ================== //
        let clearIcon = null;
        if (allowClear) {
            const needClear = !disabled && !readOnly && value && !(typeof allowClear === "object" && allowClear.disabled);
            const clearIconCls = `${prefixCls}-clear-icon`;
            const iconNode = typeof allowClear === "object" && allowClear?.clearIcon ? allowClear.clearIcon : "\u2716";
            clearIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("button", {
                type: "button",
                onClick: (event)=>{
                    handleReset?.(event);
                    onClear?.();
                },
                onMouseDown: (e)=>e.preventDefault(),
                className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(clearIconCls, {
                    [`${clearIconCls}-hidden`]: !needClear,
                    [`${clearIconCls}-has-suffix`]: !!suffix
                }, classNames?.clear),
                style: styles?.clear
            }, iconNode);
        }
        const affixWrapperPrefixCls = `${prefixCls}-affix-wrapper`;
        const affixWrapperCls = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(affixWrapperPrefixCls, {
            [`${prefixCls}-disabled`]: disabled,
            [`${affixWrapperPrefixCls}-disabled`]: disabled,
            // Not used, but keep it
            [`${affixWrapperPrefixCls}-focused`]: focused,
            // Not used, but keep it
            [`${affixWrapperPrefixCls}-readonly`]: readOnly,
            [`${affixWrapperPrefixCls}-input-with-clear-btn`]: suffix && allowClear && value
        }, classes?.affixWrapper, classNames?.affixWrapper, classNames?.variant);
        const suffixNode = (suffix || allowClear) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("span", {
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-suffix`, classNames?.suffix),
            style: styles?.suffix
        }, clearIcon, suffix);
        element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement(AffixWrapperComponent, $48f4f63fa4370229$var$_extends({
            className: affixWrapperCls,
            style: styles?.affixWrapper,
            onClick: onInputClick
        }, dataAttrs?.affixWrapper, {
            ref: containerRef
        }), prefix && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("span", {
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-prefix`, classNames?.prefix),
            style: styles?.prefix
        }, prefix), element, suffixNode);
    }
    // ================== Addon ================== //
    if ((0, $e26b9820b23aae67$export$ae6255aa850a31d1)(props)) {
        const wrapperCls = `${prefixCls}-group`;
        const addonCls = `${wrapperCls}-addon`;
        const groupWrapperCls = `${wrapperCls}-wrapper`;
        const mergedWrapperClassName = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-wrapper`, wrapperCls, classes?.wrapper, classNames?.wrapper);
        const mergedGroupClassName = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(groupWrapperCls, {
            [`${groupWrapperCls}-disabled`]: disabled
        }, classes?.group, classNames?.groupWrapper);
        // Need another wrapper for changing display:table to display:inline-block
        // and put style prop in wrapper
        element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement(GroupWrapperComponent, {
            className: mergedGroupClassName,
            ref: groupRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement(WrapperComponent, {
            className: mergedWrapperClassName
        }, addonBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement(GroupAddonComponent, {
            className: addonCls
        }, addonBefore), element, addonAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement(GroupAddonComponent, {
            className: addonCls
        }, addonAfter)));
    }
    // `className` and `style` are always on the root element
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).cloneElement(element, {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(element.props?.className, className) || null,
        style: {
            ...element.props?.style,
            ...style
        },
        hidden: hidden
    });
});
var $48f4f63fa4370229$export$2e2bcd8739ae039 = $48f4f63fa4370229$var$BaseInput;





var $cQmXV = parcelRequire("cQmXV");


var $cQmXV = parcelRequire("cQmXV");
function $f8f801862f7ca09e$export$7a29f0d5cac613ba(value, countConfig) {
    if (!countConfig.max) return true;
    const count = countConfig.strategy(value);
    return count <= countConfig.max;
}
function $f8f801862f7ca09e$export$2e2bcd8739ae039(count, showCount) {
    return $cQmXV.useMemo(()=>{
        let mergedConfig = {};
        if (showCount) mergedConfig.show = typeof showCount === "object" && showCount.formatter ? showCount.formatter : !!showCount;
        mergedConfig = {
            ...mergedConfig,
            ...count
        };
        const { show: show, ...rest } = mergedConfig;
        return {
            ...rest,
            show: !!show,
            showFormatter: typeof show === "function" ? show : undefined,
            strategy: rest.strategy || ((value)=>value.length)
        };
    }, [
        count,
        showCount
    ]);
}



var $cQmXV = parcelRequire("cQmXV");
function $648ade6d2a4bd95a$export$2e2bcd8739ae039({ countConfig: countConfig, value: value, maxLength: maxLength }) {
    return $cQmXV.useMemo(()=>{
        const mergedMax = countConfig.max ?? maxLength;
        const valueLength = countConfig.strategy(value);
        const isOutOfRange = !!mergedMax && valueLength > mergedMax;
        const hasMaxLength = Number(mergedMax) > 0;
        const dataCount = countConfig.show ? countConfig.showFormatter ? countConfig.showFormatter({
            value: value,
            count: valueLength,
            maxLength: mergedMax
        }) : `${valueLength}${hasMaxLength ? ` / ${mergedMax}` : ""}` : undefined;
        return {
            mergedMax: mergedMax,
            isOutOfRange: isOutOfRange,
            dataCount: dataCount
        };
    }, [
        countConfig,
        maxLength,
        value
    ]);
}



var $cQmXV = parcelRequire("cQmXV");
function $2822186c8bc647c1$export$2e2bcd8739ae039({ countConfig: countConfig, getTarget: getTarget }) {
    const [selection, setSelection] = $cQmXV.useState(null);
    const getTargetRef = $cQmXV.useRef(getTarget);
    $cQmXV.useEffect(()=>{
        getTargetRef.current = getTarget;
    }, [
        getTarget
    ]);
    $cQmXV.useEffect(()=>{
        if (selection) {
            getTargetRef.current()?.setSelectionRange(...selection);
            setSelection(null);
        }
    }, [
        selection
    ]);
    const getExceedValue = $cQmXV.useCallback((currentValue, isComposing)=>{
        let nextValue = currentValue;
        if (!isComposing && countConfig.exceedFormatter && countConfig.max && countConfig.strategy(currentValue) > countConfig.max) {
            nextValue = countConfig.exceedFormatter(currentValue, {
                max: countConfig.max
            });
            if (currentValue !== nextValue) setSelection([
                getTargetRef.current()?.selectionStart || 0,
                getTargetRef.current()?.selectionEnd || 0
            ]);
        }
        return nextValue;
    }, [
        countConfig
    ]);
    return getExceedValue;
}



function $a7564743a392dd09$export$2e2bcd8739ae039(defaultValue, controlledValue) {
    const [value, setValue] = (0, $a51866d781137e08$export$2e2bcd8739ae039)(defaultValue, controlledValue);
    const formatValue = value === undefined || value === null ? "" : String(value);
    return {
        value: value,
        setValue: setValue,
        formatValue: formatValue
    };
}



function $a0cf90e3da82c2f0$var$_extends() {
    $a0cf90e3da82c2f0$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a0cf90e3da82c2f0$var$_extends.apply(this, arguments);
}
const $a0cf90e3da82c2f0$var$Input = /*#__PURE__*/ (0, $cQmXV.forwardRef)((props, ref)=>{
    const { autoComplete: autoComplete, onChange: onChange, onFocus: onFocus, onBlur: onBlur, onPressEnter: onPressEnter, onKeyDown: onKeyDown, onKeyUp: onKeyUp, prefixCls: prefixCls = "rc-input", disabled: disabled, htmlSize: htmlSize, className: className, maxLength: maxLength, suffix: suffix, showCount: showCount, count: count, type: type = "text", classes: classes, classNames: classNames, styles: styles, onCompositionStart: onCompositionStart, onCompositionEnd: onCompositionEnd, ...rest } = props;
    const [focused, setFocused] = (0, $cQmXV.useState)(false);
    const compositionRef = (0, $cQmXV.useRef)(false);
    const keyLockRef = (0, $cQmXV.useRef)(false);
    const inputRef = (0, $cQmXV.useRef)(null);
    const holderRef = (0, $cQmXV.useRef)(null);
    const focus = (option)=>{
        if (inputRef.current) (0, $7aa1eaa901116c60$export$2b92016deb0b7aad)(inputRef.current, option);
    };
    // ====================== Value =======================
    const { setValue: setValue, formatValue: formatValue } = (0, $a7564743a392dd09$export$2e2bcd8739ae039)(props.defaultValue, props.value);
    const countConfig = (0, $f8f801862f7ca09e$export$2e2bcd8739ae039)(count, showCount);
    const { isOutOfRange: isOutOfRange, dataCount: dataCount } = (0, $648ade6d2a4bd95a$export$2e2bcd8739ae039)({
        countConfig: countConfig,
        value: formatValue,
        maxLength: maxLength
    });
    const getExceedValue = (0, $2822186c8bc647c1$export$2e2bcd8739ae039)({
        countConfig: countConfig,
        getTarget: ()=>inputRef.current
    });
    // ======================= Ref ========================
    (0, $cQmXV.useImperativeHandle)(ref, ()=>({
            focus: focus,
            blur: ()=>{
                inputRef.current?.blur();
            },
            setSelectionRange: (start, end, direction)=>{
                inputRef.current?.setSelectionRange(start, end, direction);
            },
            select: ()=>{
                inputRef.current?.select();
            },
            input: inputRef.current,
            nativeElement: holderRef.current?.nativeElement || inputRef.current
        }));
    (0, $cQmXV.useEffect)(()=>{
        if (keyLockRef.current) keyLockRef.current = false;
        setFocused((prev)=>prev && disabled ? false : prev);
    }, [
        disabled
    ]);
    const triggerChange = (e, currentValue, info)=>{
        const cutValue = getExceedValue(currentValue, compositionRef.current);
        if (info.source === "compositionEnd" && currentValue === cutValue) // Avoid triggering twice
        // https://github.com/ant-design/ant-design/issues/46587
        return;
        setValue(cutValue);
        if (inputRef.current) (0, $e26b9820b23aae67$export$c28984794956ddc0)(inputRef.current, e, onChange, cutValue);
    };
    const onInternalChange = (e)=>{
        triggerChange(e, e.target.value, {
            source: "change"
        });
    };
    const onInternalCompositionEnd = (e)=>{
        compositionRef.current = false;
        triggerChange(e, e.currentTarget.value, {
            source: "compositionEnd"
        });
        onCompositionEnd?.(e);
    };
    const handleKeyDown = (e)=>{
        if (onPressEnter && e.key === "Enter" && !keyLockRef.current && !e.nativeEvent.isComposing) {
            keyLockRef.current = true;
            onPressEnter(e);
        }
        onKeyDown?.(e);
    };
    const handleKeyUp = (e)=>{
        if (e.key === "Enter") keyLockRef.current = false;
        onKeyUp?.(e);
    };
    const handleFocus = (e)=>{
        setFocused(true);
        onFocus?.(e);
    };
    const handleBlur = (e)=>{
        if (keyLockRef.current) keyLockRef.current = false;
        setFocused(false);
        onBlur?.(e);
    };
    const handleReset = (e)=>{
        setValue("");
        focus();
        if (inputRef.current) (0, $e26b9820b23aae67$export$c28984794956ddc0)(inputRef.current, e, onChange);
    };
    // ====================== Input =======================
    const outOfRangeCls = isOutOfRange && `${prefixCls}-out-of-range`;
    const getInputElement = ()=>{
        // Fix https://fb.me/react-unknown-prop
        const otherProps = (0, $e8c5093aebad6025$export$2e2bcd8739ae039)(props, [
            "prefixCls",
            "onPressEnter",
            "addonBefore",
            "addonAfter",
            "prefix",
            "suffix",
            "allowClear",
            // Input elements must be either controlled or uncontrolled,
            // specify either the value prop, or the defaultValue prop, but not both.
            "defaultValue",
            "showCount",
            "count",
            "classes",
            "htmlSize",
            "styles",
            "classNames",
            "onClear"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("input", $a0cf90e3da82c2f0$var$_extends({
            autoComplete: autoComplete
        }, otherProps, {
            onChange: onInternalChange,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onKeyDown: handleKeyDown,
            onKeyUp: handleKeyUp,
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, {
                [`${prefixCls}-disabled`]: disabled
            }, classNames?.input),
            style: styles?.input,
            ref: inputRef,
            size: htmlSize,
            type: type,
            onCompositionStart: (e)=>{
                compositionRef.current = true;
                onCompositionStart?.(e);
            },
            onCompositionEnd: onInternalCompositionEnd
        }));
    };
    const getSuffix = ()=>{
        // Max length value
        if (suffix || countConfig.show) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Fragment, null, countConfig.show && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("span", {
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-show-count-suffix`, {
                [`${prefixCls}-show-count-has-suffix`]: !!suffix
            }, classNames?.count),
            style: {
                ...styles?.count
            }
        }, dataCount), suffix);
        return null;
    };
    // ====================== Render ======================
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $48f4f63fa4370229$export$2e2bcd8739ae039), $a0cf90e3da82c2f0$var$_extends({}, rest, {
        prefixCls: prefixCls,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(className, outOfRangeCls),
        handleReset: handleReset,
        value: formatValue,
        focused: focused,
        triggerFocus: focus,
        suffix: getSuffix(),
        disabled: disabled,
        classes: classes,
        classNames: classNames,
        styles: styles,
        ref: holderRef
    }), getInputElement());
});
var $a0cf90e3da82c2f0$export$2e2bcd8739ae039 = $a0cf90e3da82c2f0$var$Input;




var $cQmXV = parcelRequire("cQmXV");









var $cQmXV = parcelRequire("cQmXV");
// Thanks to https://github.com/andreypopp/react-textarea-autosize/
/**
 * calculateNodeHeight(uiTextNode, useCache = false)
 */ const $faf9597daa8c5654$var$HIDDEN_TEXTAREA_STYLE = `
  min-height:0 !important;
  max-height:none !important;
  height:0 !important;
  visibility:hidden !important;
  overflow:hidden !important;
  position:absolute !important;
  z-index:-1000 !important;
  top:0 !important;
  right:0 !important;
  pointer-events: none !important;
`;
const $faf9597daa8c5654$var$SIZING_STYLE = [
    "letter-spacing",
    "line-height",
    "padding-top",
    "padding-bottom",
    "font-family",
    "font-weight",
    "font-size",
    "font-variant",
    "text-rendering",
    "text-transform",
    "width",
    "text-indent",
    "padding-left",
    "padding-right",
    "border-width",
    "box-sizing",
    "word-break",
    "white-space"
];
const $faf9597daa8c5654$var$computedStyleCache = {};
let $faf9597daa8c5654$var$hiddenTextarea;
function $faf9597daa8c5654$export$1a56dc6a39385a18(node, useCache = false) {
    const nodeRef = node.getAttribute("id") || node.getAttribute("data-reactid") || node.getAttribute("name");
    if (useCache && $faf9597daa8c5654$var$computedStyleCache[nodeRef]) return $faf9597daa8c5654$var$computedStyleCache[nodeRef];
    const style = window.getComputedStyle(node);
    const boxSizing = style.getPropertyValue("box-sizing") || style.getPropertyValue("-moz-box-sizing") || style.getPropertyValue("-webkit-box-sizing");
    const paddingSize = parseFloat(style.getPropertyValue("padding-bottom")) + parseFloat(style.getPropertyValue("padding-top"));
    const borderSize = parseFloat(style.getPropertyValue("border-bottom-width")) + parseFloat(style.getPropertyValue("border-top-width"));
    const sizingStyle = $faf9597daa8c5654$var$SIZING_STYLE.map((name)=>`${name}:${style.getPropertyValue(name)}`).join(";");
    const nodeInfo = {
        sizingStyle: sizingStyle,
        paddingSize: paddingSize,
        borderSize: borderSize,
        boxSizing: boxSizing
    };
    if (useCache && nodeRef) $faf9597daa8c5654$var$computedStyleCache[nodeRef] = nodeInfo;
    return nodeInfo;
}
function $faf9597daa8c5654$export$2e2bcd8739ae039(uiTextNode, useCache = false, minRows = null, maxRows = null) {
    if (!$faf9597daa8c5654$var$hiddenTextarea) {
        $faf9597daa8c5654$var$hiddenTextarea = document.createElement("textarea");
        $faf9597daa8c5654$var$hiddenTextarea.setAttribute("tab-index", "-1");
        $faf9597daa8c5654$var$hiddenTextarea.setAttribute("aria-hidden", "true");
        // fix: A form field element should have an id or name attribute
        // A form field element has neither an id nor a name attribute. This might prevent the browser from correctly autofilling the form.
        // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/textarea
        $faf9597daa8c5654$var$hiddenTextarea.setAttribute("name", "hiddenTextarea");
        document.body.appendChild($faf9597daa8c5654$var$hiddenTextarea);
    }
    // Fix wrap="off" issue
    // https://github.com/ant-design/ant-design/issues/6577
    if (uiTextNode.getAttribute("wrap")) $faf9597daa8c5654$var$hiddenTextarea.setAttribute("wrap", uiTextNode.getAttribute("wrap"));
    else $faf9597daa8c5654$var$hiddenTextarea.removeAttribute("wrap");
    // Copy all CSS properties that have an impact on the height of the content in
    // the textbox
    const { paddingSize: paddingSize, borderSize: borderSize, boxSizing: boxSizing, sizingStyle: sizingStyle } = $faf9597daa8c5654$export$1a56dc6a39385a18(uiTextNode, useCache);
    // Need to have the overflow attribute to hide the scrollbar otherwise
    // text-lines will not calculated properly as the shadow will technically be
    // narrower for content
    $faf9597daa8c5654$var$hiddenTextarea.setAttribute("style", `${sizingStyle};${$faf9597daa8c5654$var$HIDDEN_TEXTAREA_STYLE}`);
    $faf9597daa8c5654$var$hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || "";
    let minHeight;
    let maxHeight;
    let overflowY;
    let height = $faf9597daa8c5654$var$hiddenTextarea.scrollHeight;
    if (boxSizing === "border-box") // border-box: add border, since height = content + padding + border
    height += borderSize;
    else if (boxSizing === "content-box") // remove padding, since height = content
    height -= paddingSize;
    if (minRows !== null || maxRows !== null) {
        // measure height of a textarea with a single row
        $faf9597daa8c5654$var$hiddenTextarea.value = " ";
        const singleRowHeight = $faf9597daa8c5654$var$hiddenTextarea.scrollHeight - paddingSize;
        if (minRows !== null) {
            minHeight = singleRowHeight * minRows;
            if (boxSizing === "border-box") minHeight = minHeight + paddingSize + borderSize;
            height = Math.max(minHeight, height);
        }
        if (maxRows !== null) {
            maxHeight = singleRowHeight * maxRows;
            if (boxSizing === "border-box") maxHeight = maxHeight + paddingSize + borderSize;
            overflowY = height > maxHeight ? undefined : "hidden";
            height = Math.min(maxHeight, height);
        }
    }
    const style = {
        height: height,
        overflowY: overflowY,
        resize: "none"
    };
    if (minHeight) style.minHeight = minHeight;
    if (maxHeight) style.maxHeight = maxHeight;
    return style;
}


function $7f0e40079e514760$var$_extends() {
    $7f0e40079e514760$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7f0e40079e514760$var$_extends.apply(this, arguments);
}
const $7f0e40079e514760$var$RESIZE_START = 0;
const $7f0e40079e514760$var$RESIZE_MEASURING = 1;
const $7f0e40079e514760$var$RESIZE_STABLE = 2;
const $7f0e40079e514760$var$ResizableTextArea = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { prefixCls: prefixCls, defaultValue: defaultValue, value: value, autoSize: autoSize, onResize: onResize, className: className, style: style, disabled: disabled, onChange: onChange, onInternalAutoSize: // Test only
    onInternalAutoSize, ...restProps } = props;
    // =============================== Value ================================
    const [internalValue, setMergedValue] = (0, $a51866d781137e08$export$2e2bcd8739ae039)(defaultValue, value);
    const mergedValue = internalValue ?? "";
    const onInternalChange = (event)=>{
        setMergedValue(event.target.value);
        onChange?.(event);
    };
    // ================================ Ref =================================
    const textareaRef = $cQmXV.useRef(null);
    $cQmXV.useImperativeHandle(ref, ()=>({
            textArea: textareaRef.current
        }));
    // ============================== AutoSize ==============================
    const [minRows, maxRows] = $cQmXV.useMemo(()=>{
        if (autoSize && typeof autoSize === "object") return [
            autoSize.minRows,
            autoSize.maxRows
        ];
        return [];
    }, [
        autoSize
    ]);
    const needAutoSize = !!autoSize;
    // =============================== Resize ===============================
    const [resizeState, setResizeState] = $cQmXV.useState($7f0e40079e514760$var$RESIZE_STABLE);
    const [autoSizeStyle, setAutoSizeStyle] = $cQmXV.useState();
    const startResize = ()=>{
        setResizeState($7f0e40079e514760$var$RESIZE_START);
    };
    // Change to trigger resize measure
    (0, $7673d874dab69d07$export$2e2bcd8739ae039)(()=>{
        if (needAutoSize) startResize();
    }, [
        value,
        minRows,
        maxRows,
        needAutoSize
    ]);
    (0, $7673d874dab69d07$export$2e2bcd8739ae039)(()=>{
        if (resizeState === $7f0e40079e514760$var$RESIZE_START) setResizeState($7f0e40079e514760$var$RESIZE_MEASURING);
        else if (resizeState === $7f0e40079e514760$var$RESIZE_MEASURING) {
            const textareaStyles = (0, $faf9597daa8c5654$export$2e2bcd8739ae039)(textareaRef.current, false, minRows, maxRows);
            setResizeState($7f0e40079e514760$var$RESIZE_STABLE);
            setAutoSizeStyle(textareaStyles);
        }
    }, [
        resizeState
    ]);
    // We lock resize trigger by raf to avoid Safari warning
    const resizeRafRef = $cQmXV.useRef(undefined);
    const cleanRaf = ()=>{
        if (resizeRafRef.current !== undefined) (0, $905c53b807de704e$export$2e2bcd8739ae039).cancel(resizeRafRef.current);
    };
    const onInternalResize = (size)=>{
        if (resizeState === $7f0e40079e514760$var$RESIZE_STABLE) {
            onResize?.(size);
            if (autoSize) {
                cleanRaf();
                resizeRafRef.current = (0, $905c53b807de704e$export$2e2bcd8739ae039)(()=>{
                    startResize();
                });
            }
        }
    };
    $cQmXV.useEffect(()=>cleanRaf, []);
    // =============================== Render ===============================
    const mergedAutoSizeStyle = needAutoSize ? autoSizeStyle : null;
    const mergedStyle = {
        ...style,
        ...mergedAutoSizeStyle
    };
    if (resizeState === $7f0e40079e514760$var$RESIZE_START || resizeState === $7f0e40079e514760$var$RESIZE_MEASURING) {
        mergedStyle.overflowY = "hidden";
        mergedStyle.overflowX = "hidden";
    }
    return /*#__PURE__*/ $cQmXV.createElement((0, $1d6306c05e604045$export$2e2bcd8739ae039), {
        onResize: onInternalResize,
        disabled: !(autoSize || onResize)
    }, /*#__PURE__*/ $cQmXV.createElement("textarea", $7f0e40079e514760$var$_extends({}, restProps, {
        ref: textareaRef,
        style: mergedStyle,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, className, {
            [`${prefixCls}-disabled`]: disabled
        }),
        disabled: disabled,
        value: mergedValue,
        onChange: onInternalChange
    })));
});
var $7f0e40079e514760$export$2e2bcd8739ae039 = $7f0e40079e514760$var$ResizableTextArea;



function $fb7b4ce957d6ad1a$var$_extends() {
    $fb7b4ce957d6ad1a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $fb7b4ce957d6ad1a$var$_extends.apply(this, arguments);
}
const $fb7b4ce957d6ad1a$var$TextArea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).forwardRef(({ defaultValue: defaultValue, value: customValue, onFocus: onFocus, onBlur: onBlur, onChange: onChange, allowClear: allowClear, maxLength: maxLength, onCompositionStart: onCompositionStart, onCompositionEnd: onCompositionEnd, suffix: suffix, prefixCls: prefixCls = "rc-textarea", showCount: showCount, count: count, className: className, style: style, disabled: disabled, hidden: hidden, classNames: classNames, styles: styles, onResize: onResize, onClear: onClear, onPressEnter: onPressEnter, readOnly: readOnly, autoSize: autoSize, onKeyDown: onKeyDown, ...rest }, ref)=>{
    const [focused, setFocused] = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useState(false);
    const compositionRef = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useRef(false);
    const [textareaResized, setTextareaResized] = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useState(null);
    // =============================== Ref ================================
    const holderRef = (0, $cQmXV.useRef)(null);
    const resizableTextAreaRef = (0, $cQmXV.useRef)(null);
    const getTextArea = ()=>resizableTextAreaRef.current?.textArea || null;
    const { setValue: setValue, formatValue: formatValue } = (0, $a7564743a392dd09$export$2e2bcd8739ae039)(defaultValue, customValue);
    const countConfig = (0, $f8f801862f7ca09e$export$2e2bcd8739ae039)(count, showCount);
    const { isOutOfRange: isOutOfRange, dataCount: dataCount } = (0, $648ade6d2a4bd95a$export$2e2bcd8739ae039)({
        countConfig: countConfig,
        value: formatValue,
        maxLength: maxLength
    });
    const getExceedValue = (0, $2822186c8bc647c1$export$2e2bcd8739ae039)({
        countConfig: countConfig,
        getTarget: ()=>resizableTextAreaRef.current?.textArea || null
    });
    const focus = ()=>{
        getTextArea()?.focus();
    };
    (0, $cQmXV.useImperativeHandle)(ref, ()=>({
            resizableTextArea: resizableTextAreaRef.current,
            focus: focus,
            blur: ()=>{
                getTextArea()?.blur();
            },
            nativeElement: holderRef.current?.nativeElement || getTextArea()
        }));
    (0, $cQmXV.useEffect)(()=>{
        setFocused((prev)=>!disabled && prev);
    }, [
        disabled
    ]);
    // ============================== Count ===============================
    // ============================== Change ==============================
    const triggerChange = (e, currentValue)=>{
        const cutValue = getExceedValue(currentValue, compositionRef.current);
        setValue(cutValue);
        (0, $e26b9820b23aae67$export$c28984794956ddc0)(e.currentTarget, e, onChange, cutValue);
    };
    // =========================== Value Update ===========================
    const onInternalCompositionStart = (e)=>{
        compositionRef.current = true;
        onCompositionStart?.(e);
    };
    const onInternalCompositionEnd = (e)=>{
        compositionRef.current = false;
        triggerChange(e, e.currentTarget.value);
        onCompositionEnd?.(e);
    };
    const onInternalChange = (e)=>{
        triggerChange(e, e.target.value);
    };
    const handleKeyDown = (e)=>{
        if (e.key === "Enter" && onPressEnter && !e.nativeEvent.isComposing) onPressEnter(e);
        onKeyDown?.(e);
    };
    const handleFocus = (e)=>{
        setFocused(true);
        onFocus?.(e);
    };
    const handleBlur = (e)=>{
        setFocused(false);
        onBlur?.(e);
    };
    // ============================== Reset ===============================
    const handleReset = (e)=>{
        setValue("");
        focus();
        const textarea = getTextArea();
        if (textarea) (0, $e26b9820b23aae67$export$c28984794956ddc0)(textarea, e, onChange);
    };
    let suffixNode = suffix;
    if (countConfig.show) suffixNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Fragment, null, suffixNode, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("span", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-data-count`, classNames?.count),
        style: styles?.count
    }, dataCount));
    const handleResize = (size)=>{
        onResize?.(size);
        if (getTextArea()?.style.height) setTextareaResized(true);
    };
    const isPureTextArea = !autoSize && !showCount && !allowClear;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $48f4f63fa4370229$export$2e2bcd8739ae039), {
        ref: holderRef,
        value: formatValue,
        allowClear: allowClear,
        handleReset: handleReset,
        suffix: suffixNode,
        prefixCls: prefixCls,
        classNames: {
            ...classNames,
            affixWrapper: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(classNames?.affixWrapper, {
                [`${prefixCls}-show-count`]: showCount,
                [`${prefixCls}-textarea-allow-clear`]: allowClear
            })
        },
        disabled: disabled,
        focused: focused,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(className, isOutOfRange && `${prefixCls}-out-of-range`),
        style: {
            ...style,
            ...textareaResized && !isPureTextArea ? {
                height: "auto"
            } : {}
        },
        dataAttrs: typeof dataCount === "string" ? {
            affixWrapper: {
                "data-count": dataCount
            }
        } : undefined,
        styles: styles,
        hidden: hidden,
        readOnly: readOnly,
        onClear: onClear
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $7f0e40079e514760$export$2e2bcd8739ae039), $fb7b4ce957d6ad1a$var$_extends({}, rest, {
        autoSize: autoSize,
        maxLength: maxLength,
        onKeyDown: handleKeyDown,
        onChange: onInternalChange,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onCompositionStart: onInternalCompositionStart,
        onCompositionEnd: onInternalCompositionEnd,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(classNames?.textarea),
        style: {
            resize: style?.resize,
            ...styles?.textarea
        },
        disabled: disabled,
        prefixCls: prefixCls,
        onResize: handleResize,
        ref: resizableTextAreaRef,
        readOnly: readOnly
    })));
});
var $fb7b4ce957d6ad1a$export$2e2bcd8739ae039 = $fb7b4ce957d6ad1a$var$TextArea;



var $115e83441c1f2287$export$2e2bcd8739ae039 = (0, $a0cf90e3da82c2f0$export$2e2bcd8739ae039);






var $cQmXV = parcelRequire("cQmXV");

/**
 * Search for the first non-undefined value in the arguments and return it.
 *
 * ```js
 * const mergedIcon = fallbackProp(propIcon, contextIcon, defaultIcon);
 * ```
 *
 * Note: it is different from `??` operator which skips null
 */ function $55c1e81905598a5b$export$2e2bcd8739ae039(...args) {
    return args.find((arg)=>arg !== undefined);
}




"use client";
const $7dfc6f571d3c00af$export$9ea6397a890aa3e5 = (options)=>{
    const { allowClear: allowClear, clearIcon: clearIcon, contextAllowClear: contextAllowClear, contextClearIcon: contextClearIcon, defaultAllowClear: defaultAllowClear, componentName: componentName } = options;
    return (0, $cQmXV.useMemo)(()=>{
        const mergedAllowClear = allowClear ?? contextAllowClear ?? defaultAllowClear;
        if (!mergedAllowClear) return false;
        return {
            clearIcon: (0, $55c1e81905598a5b$export$2e2bcd8739ae039)((0, $8e2d153a3c855782$export$53b83ca8eaab0383)(allowClear) ? allowClear?.clearIcon : clearIcon, (0, $8e2d153a3c855782$export$53b83ca8eaab0383)(contextAllowClear) ? contextAllowClear?.clearIcon : contextClearIcon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $ff9add21dbbc2684$export$2e2bcd8739ae039), null)),
            disabled: ((0, $8e2d153a3c855782$export$53b83ca8eaab0383)(allowClear) ? allowClear?.disabled : undefined) ?? ((0, $8e2d153a3c855782$export$53b83ca8eaab0383)(contextAllowClear) ? contextAllowClear?.disabled : undefined)
        };
    }, [
        allowClear,
        clearIcon,
        contextAllowClear,
        contextClearIcon,
        defaultAllowClear
    ]);
};











var $cQmXV = parcelRequire("cQmXV");


/**
 * Compatible for legacy `bordered` prop.
 */ const $11c15dfa3883fb6f$var$useVariant = (component, variant, legacyBordered, fallbackComponent)=>{
    const config = $cQmXV.useContext((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    const { variant: configVariant, [component]: componentConfig } = config;
    const ctxVariant = $cQmXV.useContext((0, $7a3804f153d8a19d$export$6f0555dad42725fb));
    const fallbackComponentConfig = fallbackComponent ? config[fallbackComponent] : undefined;
    const configComponentVariant = componentConfig?.variant ?? fallbackComponentConfig?.variant;
    const isVariantConfigured = typeof variant !== "undefined" || legacyBordered === false || typeof ctxVariant !== "undefined" || typeof configComponentVariant !== "undefined" || typeof configVariant !== "undefined";
    let mergedVariant;
    if (typeof variant !== "undefined") mergedVariant = variant;
    else if (legacyBordered === false) mergedVariant = "borderless";
    else // form variant > component global variant > fallback component global variant > global variant
    mergedVariant = ctxVariant ?? configComponentVariant ?? configVariant ?? "outlined";
    const enableVariantCls = (0, $82ffd17441b57982$export$fa216ce2679a073b).includes(mergedVariant);
    return [
        mergedVariant,
        enableVariantCls,
        isVariantConfigured
    ];
};
var $11c15dfa3883fb6f$export$2e2bcd8739ae039 = $11c15dfa3883fb6f$var$useVariant;




var $cQmXV = parcelRequire("cQmXV");
function $a637c5daf8d19d89$export$2e2bcd8739ae039(inputRef, triggerOnMount) {
    const removePasswordTimeoutRef = (0, $cQmXV.useRef)([]);
    const removePasswordTimeout = ()=>{
        removePasswordTimeoutRef.current.push(setTimeout(()=>{
            if (inputRef.current?.input && inputRef.current?.input.getAttribute("type") === "password" && inputRef.current?.input.hasAttribute("value")) inputRef.current?.input.removeAttribute("value");
        }));
    };
    (0, $cQmXV.useEffect)(()=>{
        if (triggerOnMount) removePasswordTimeout();
        return ()=>removePasswordTimeoutRef.current.forEach((timer)=>{
                if (timer) clearTimeout(timer);
            });
    }, [
        triggerOnMount
    ]);
    return removePasswordTimeout;
}



function $40abe7d210eef572$export$a19010aeeaa0c7a(props) {
    return !!(props.prefix || props.suffix || props.allowClear || props.showCount);
}


"use client";
const $056dbba933a63236$var$Input = /*#__PURE__*/ (0, $cQmXV.forwardRef)((props, ref)=>{
    const { prefixCls: customizePrefixCls, bordered: bordered = true, status: customStatus, size: customSize, disabled: customDisabled, onBlur: onBlur, onFocus: onFocus, suffix: suffix, allowClear: allowClear, addonAfter: addonAfter, addonBefore: addonBefore, className: className, style: style, styles: styles, rootClassName: rootClassName, onChange: onChange, classNames: classNames, variant: customVariant, ...rest } = props;
    var prop, newProp;
    const { getPrefixCls: getPrefixCls, direction: direction, allowClear: contextAllowClear, autoComplete: contextAutoComplete, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("input");
    const prefixCls = getPrefixCls("input", customizePrefixCls);
    const inputRef = (0, $cQmXV.useRef)(null);
    // Style
    const rootCls = (0, $2237081acd3cfc09$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $8c2dcdcd3819e8c0$export$de732caeaad5f68e)(prefixCls, rootClassName);
    (0, $8c2dcdcd3819e8c0$export$2e2bcd8739ae039)(prefixCls, rootCls);
    // ===================== Compact Item =====================
    const { compactSize: compactSize, compactItemClassnames: compactItemClassnames } = (0, $68fddf51400eda11$export$cd8cf9d7bab8dd4)(prefixCls, direction);
    // ===================== Size =====================
    const mergedSize = (0, $78cdfb6138721329$export$2e2bcd8739ae039)((ctx)=>customSize ?? compactSize ?? ctx);
    // ===================== Disabled =====================
    const disabled = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useContext((0, $4f0e1ea30330557c$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled ?? disabled;
    // =========== Merged Props for Semantic ==========
    const mergedProps = {
        ...props,
        size: mergedSize,
        disabled: mergedDisabled
    };
    const contextStyleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $30c5f9f911d4f61b$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: mergedProps
    });
    // ===================== Status =====================
    const { status: contextStatus, hasFeedback: hasFeedback, feedbackIcon: feedbackIcon } = (0, $cQmXV.useContext)((0, $7a3804f153d8a19d$export$bbb5553c6c7a14ed));
    const mergedStatus = (0, $4a3ea1f9228016b7$export$314e193082d7ba49)(contextStatus, customStatus);
    // ===================== Focus warning =====================
    const inputHasPrefixSuffix = (0, $40abe7d210eef572$export$a19010aeeaa0c7a)(props) || !!hasFeedback;
    const prevHasPrefixSuffixRef = (0, $cQmXV.useRef)(inputHasPrefixSuffix);
    // ===================== Remove Password value =====================
    const removePasswordTimeout = (0, $a637c5daf8d19d89$export$2e2bcd8739ae039)(inputRef, true);
    const handleBlur = (e)=>{
        removePasswordTimeout();
        onBlur?.(e);
    };
    const handleFocus = (e)=>{
        removePasswordTimeout();
        onFocus?.(e);
    };
    const handleChange = (e)=>{
        removePasswordTimeout();
        onChange?.(e);
    };
    const suffixNode = (hasFeedback || suffix) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Fragment, null, suffix, hasFeedback && feedbackIcon);
    const mergedAllowClear = (0, $7dfc6f571d3c00af$export$9ea6397a890aa3e5)({
        allowClear: allowClear,
        contextAllowClear: contextAllowClear,
        componentName: "Input"
    });
    const [variant, enableVariantCls] = (0, $11c15dfa3883fb6f$export$2e2bcd8739ae039)("input", customVariant, bordered);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $115e83441c1f2287$export$2e2bcd8739ae039), {
        ref: (0, $10341b937b26f69d$export$ab452c34e8e05029)(ref, inputRef),
        prefixCls: prefixCls,
        autoComplete: contextAutoComplete,
        ...rest,
        disabled: mergedDisabled,
        onBlur: handleBlur,
        onFocus: handleFocus,
        style: mergedStyles.root,
        styles: mergedStyles,
        suffix: suffixNode,
        allowClear: mergedAllowClear,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(className, rootClassName, cssVarCls, rootCls, compactItemClassnames, contextClassName, mergedClassNames.root),
        onChange: handleChange,
        addonBefore: addonBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $1585084388e75c84$export$2e2bcd8739ae039), {
            form: true,
            space: true
        }, addonBefore),
        addonAfter: addonAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $1585084388e75c84$export$2e2bcd8739ae039), {
            form: true,
            space: true
        }, addonAfter),
        classNames: {
            ...mergedClassNames,
            input: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)({
                [`${prefixCls}-sm`]: mergedSize === "small",
                [`${prefixCls}-lg`]: mergedSize === "large",
                [`${prefixCls}-rtl`]: direction === "rtl"
            }, mergedClassNames.input, hashId),
            variant: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)({
                [`${prefixCls}-${variant}`]: enableVariantCls
            }, (0, $4a3ea1f9228016b7$export$b08e7b47149942a2)(prefixCls, mergedStatus)),
            affixWrapper: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)({
                [`${prefixCls}-affix-wrapper-sm`]: mergedSize === "small",
                [`${prefixCls}-affix-wrapper-lg`]: mergedSize === "large",
                [`${prefixCls}-affix-wrapper-rtl`]: direction === "rtl"
            }, hashId),
            wrapper: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)({
                [`${prefixCls}-group-rtl`]: direction === "rtl"
            }, hashId),
            groupWrapper: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)({
                [`${prefixCls}-group-wrapper-sm`]: mergedSize === "small",
                [`${prefixCls}-group-wrapper-lg`]: mergedSize === "large",
                [`${prefixCls}-group-wrapper-rtl`]: direction === "rtl",
                [`${prefixCls}-group-wrapper-${variant}`]: enableVariantCls
            }, (0, $4a3ea1f9228016b7$export$b08e7b47149942a2)(`${prefixCls}-group-wrapper`, mergedStatus, hasFeedback), hashId)
        }
    });
});
var $056dbba933a63236$export$2e2bcd8739ae039 = $056dbba933a63236$var$Input;




var $cQmXV = parcelRequire("cQmXV");












// =============================== OTP ================================
const $24f5265b8f0f88a9$var$genOTPStyle = (token)=>{
    const { componentCls: componentCls, paddingXS: paddingXS } = token;
    return {
        [componentCls]: {
            display: "inline-flex",
            alignItems: "center",
            flexWrap: "nowrap",
            columnGap: paddingXS,
            [`${componentCls}-input-wrapper`]: {
                position: "relative",
                [`${componentCls}-mask-icon`]: {
                    position: "absolute",
                    zIndex: "1",
                    top: "50%",
                    right: "50%",
                    transform: "translate(50%, -50%)",
                    pointerEvents: "none"
                },
                [`${componentCls}-mask-input`]: {
                    color: "transparent",
                    caretColor: token.colorText,
                    "&::selection": {
                        color: "transparent"
                    }
                },
                [`${componentCls}-mask-input[type=number]::-webkit-inner-spin-button`]: {
                    "-webkit-appearance": "none",
                    margin: 0
                },
                [`${componentCls}-mask-input[type=number]`]: {
                    "-moz-appearance": "textfield"
                }
            },
            "&-rtl": {
                direction: "rtl"
            },
            [`${componentCls}-input`]: {
                textAlign: "center",
                paddingInline: token.paddingXXS
            },
            // ================= Size =================
            [`&${componentCls}-sm ${componentCls}-input`]: {
                paddingInline: token.calc(token.paddingXXS).div(2).equal()
            },
            [`&${componentCls}-lg ${componentCls}-input`]: {
                paddingInline: token.paddingXS
            }
        }
    };
};
var // ============================== Export ==============================
$24f5265b8f0f88a9$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$51ec95de45185b42)([
    "Input",
    "OTP"
], (token)=>{
    const inputToken = (0, $fef50f256b80dfa5$export$4950aa0f605343fb)(token, (0, $5e693f0c6e8784bd$export$a157d95850191a12)(token));
    return $24f5265b8f0f88a9$var$genOTPStyle(inputToken);
}, (0, $5e693f0c6e8784bd$export$bd8b682992bc9781));



var $cQmXV = parcelRequire("cQmXV");




"use client";
const $6e5da3b64422266e$var$DEFAULT_MASK_VALUE = "\u2022";
const $6e5da3b64422266e$var$OTPInput = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { className: className, value: value, onChange: onChange, onActiveChange: onActiveChange, index: index, mask: mask, onFocus: onFocus, type: type, ...restProps } = props;
    const { getPrefixCls: getPrefixCls } = $cQmXV.useContext((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls("otp");
    const maskValue = typeof mask === "string" ? mask : $6e5da3b64422266e$var$DEFAULT_MASK_VALUE;
    // ========================== Ref ===========================
    const inputRef = $cQmXV.useRef(null);
    $cQmXV.useImperativeHandle(ref, ()=>inputRef.current);
    // ========================= Input ==========================
    const onInternalChange = (e)=>{
        onChange(index, e.target.value);
    };
    // ========================= Focus ==========================
    const syncSelection = ()=>{
        (0, $905c53b807de704e$export$2e2bcd8739ae039)(()=>{
            const inputEle = inputRef.current?.input;
            if (document.activeElement === inputEle && inputEle) inputEle.select();
        });
    };
    const onInternalFocus = (e)=>{
        onFocus?.(e);
        syncSelection();
    };
    // ======================== Keyboard ========================
    const onInternalKeyDown = (event)=>{
        const { key: key, ctrlKey: ctrlKey, metaKey: metaKey } = event;
        if (key === "ArrowLeft") onActiveChange(index - 1);
        else if (key === "ArrowRight") onActiveChange(index + 1);
        else if (key === "z" && (ctrlKey || metaKey)) event.preventDefault();
        else if (key === "Backspace" && !value) onActiveChange(index - 1);
        syncSelection();
    };
    // ========================= Render =========================
    return /*#__PURE__*/ $cQmXV.createElement("span", {
        className: `${prefixCls}-input-wrapper`,
        role: "presentation"
    }, mask && value !== "" && value !== undefined && /*#__PURE__*/ $cQmXV.createElement("span", {
        className: `${prefixCls}-mask-icon`,
        "aria-hidden": "true"
    }, maskValue), /*#__PURE__*/ $cQmXV.createElement((0, $056dbba933a63236$export$2e2bcd8739ae039), {
        "aria-label": `OTP Input ${index + 1}`,
        ...restProps,
        type: type ?? (mask ? "password" : "text"),
        ref: inputRef,
        value: value,
        onInput: onInternalChange,
        onFocus: onInternalFocus,
        onKeyDown: onInternalKeyDown,
        onMouseDown: syncSelection,
        onMouseUp: syncSelection,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(className, {
            [`${prefixCls}-mask-input`]: mask
        })
    }));
});
var $6e5da3b64422266e$export$2e2bcd8739ae039 = $6e5da3b64422266e$var$OTPInput;


"use client";
function $f3e88b9735dbd806$var$strToArr(str) {
    return (str || "").split("");
}
const $f3e88b9735dbd806$var$Separator = (props)=>{
    const { index: index, prefixCls: prefixCls, separator: separator, className: semanticClassName, style: semanticStyle } = props;
    const separatorNode = (0, $8e2d153a3c855782$export$f6e2535fb5126e54)(separator) ? separator(index) : separator;
    if (!separatorNode) return null;
    return /*#__PURE__*/ $cQmXV.createElement("span", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-separator`, semanticClassName),
        style: semanticStyle
    }, separatorNode);
};
const $f3e88b9735dbd806$var$OTP = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, length: length = 6, size: customSize, defaultValue: defaultValue, value: value, onChange: onChange, formatter: formatter, separator: separator, variant: customizeVariant, disabled: disabled, status: customStatus, autoFocus: autoFocus, mask: mask, type: type, autoComplete: autoComplete, onInput: onInput, onFocus: onFocus, inputMode: inputMode, classNames: classNames, styles: styles, className: className, style: style, ...restProps } = props;
    const { classNames: contextClassNames, styles: contextStyles, getPrefixCls: getPrefixCls, direction: direction, style: contextStyle, className: contextClassName } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("otp");
    const prefixCls = getPrefixCls("otp", customizePrefixCls);
    const [variant] = (0, $11c15dfa3883fb6f$export$2e2bcd8739ae039)("otp", customizeVariant, undefined, "input");
    const mergedProps = {
        ...props,
        length: length,
        variant: variant
    };
    const contextStyleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $30c5f9f911d4f61b$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: mergedProps
    });
    const domAttrs = (0, $4b5c733d1d7bb306$export$2e2bcd8739ae039)(restProps, {
        aria: true,
        data: true,
        attr: true
    });
    // ========================= Root =========================
    // Style
    const [hashId, cssVarCls] = (0, $24f5265b8f0f88a9$export$2e2bcd8739ae039)(prefixCls);
    // ========================= Size =========================
    const mergedSize = (0, $78cdfb6138721329$export$2e2bcd8739ae039)((ctx)=>customSize ?? ctx);
    // ======================== Status ========================
    const formContext = $cQmXV.useContext((0, $7a3804f153d8a19d$export$bbb5553c6c7a14ed));
    const mergedStatus = (0, $4a3ea1f9228016b7$export$314e193082d7ba49)(formContext.status, customStatus);
    const proxyFormContext = $cQmXV.useMemo(()=>({
            ...formContext,
            status: mergedStatus,
            hasFeedback: false,
            feedbackIcon: null
        }), [
        formContext,
        mergedStatus
    ]);
    // ========================= Refs =========================
    const containerRef = $cQmXV.useRef(null);
    const inputsRef = $cQmXV.useRef({});
    $cQmXV.useImperativeHandle(ref, ()=>({
            focus: ()=>{
                inputsRef.current[0]?.focus();
            },
            blur: ()=>{
                for(let i = 0; i < length; i += 1)inputsRef.current[i]?.blur();
            },
            nativeElement: containerRef.current
        }));
    // ======================= Formatter ======================
    const internalFormatter = (txt)=>formatter ? formatter(txt) : txt;
    // ======================== Values ========================
    const [valueCells, setValueCells] = $cQmXV.useState(()=>$f3e88b9735dbd806$var$strToArr(internalFormatter(defaultValue || "")));
    $cQmXV.useEffect(()=>{
        if (value !== undefined) setValueCells($f3e88b9735dbd806$var$strToArr(value));
    }, [
        value
    ]);
    const triggerValueCellsChange = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((nextValueCells)=>{
        setValueCells(nextValueCells);
        if (onInput) onInput(nextValueCells);
        // Trigger if all cells are filled
        if (onChange && nextValueCells.length === length && nextValueCells.every((c)=>c) && nextValueCells.some((c, index)=>valueCells[index] !== c)) onChange(nextValueCells.join(""));
    });
    const patchValue = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((index, txt)=>{
        let nextCells = (0, $68381b18b974dc9f$export$2e2bcd8739ae039)(valueCells);
        // Fill cells till index
        for(let i = 0; i < index; i += 1)if (!nextCells[i]) nextCells[i] = "";
        if (txt.length <= 1) nextCells[index] = txt;
        else nextCells = nextCells.slice(0, index).concat($f3e88b9735dbd806$var$strToArr(txt));
        nextCells = nextCells.slice(0, length);
        // Clean the last empty cell
        for(let i = nextCells.length - 1; i >= 0; i -= 1){
            if (nextCells[i]) break;
            nextCells.pop();
        }
        // Format if needed
        const formattedValue = internalFormatter(nextCells.map((c)=>c || " ").join(""));
        nextCells = $f3e88b9735dbd806$var$strToArr(formattedValue).map((c, i)=>{
            if (c === " " && !nextCells[i]) return nextCells[i];
            return c;
        });
        return nextCells;
    });
    // ======================== Change ========================
    const onInputChange = (index, txt)=>{
        const nextCells = patchValue(index, txt);
        const nextIndex = Math.min(index + txt.length, length - 1);
        if (nextIndex !== index && nextCells[index] !== undefined) inputsRef.current[nextIndex]?.focus();
        triggerValueCellsChange(nextCells);
    };
    const onInputActiveChange = (nextIndex)=>{
        inputsRef.current[nextIndex]?.focus();
    };
    // ======================== Focus ========================
    const onInputFocus = (event, index)=>{
        // keep focus on the first empty cell
        for(let i = 0; i < index; i += 1)if (!inputsRef.current[i]?.input?.value) {
            inputsRef.current[i]?.focus();
            break;
        }
        onFocus?.(event);
    };
    // ======================== Render ========================
    const inputSharedProps = {
        variant: variant,
        disabled: disabled,
        status: mergedStatus,
        mask: mask,
        type: type,
        inputMode: inputMode,
        autoComplete: autoComplete
    };
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        ...domAttrs,
        ref: containerRef,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(className, prefixCls, {
            [`${prefixCls}-sm`]: mergedSize === "small",
            [`${prefixCls}-lg`]: mergedSize === "large",
            [`${prefixCls}-rtl`]: direction === "rtl"
        }, cssVarCls, hashId, contextClassName, mergedClassNames.root),
        style: mergedStyles.root,
        role: "group"
    }, /*#__PURE__*/ $cQmXV.createElement((0, $7a3804f153d8a19d$export$bbb5553c6c7a14ed).Provider, {
        value: proxyFormContext
    }, Array.from({
        length: length
    }).map((_, index)=>{
        const key = `otp-${index}`;
        const singleValue = valueCells[index] || "";
        return /*#__PURE__*/ $cQmXV.createElement($cQmXV.Fragment, {
            key: key
        }, /*#__PURE__*/ $cQmXV.createElement((0, $6e5da3b64422266e$export$2e2bcd8739ae039), {
            ref: (inputEle)=>{
                inputsRef.current[index] = inputEle;
            },
            index: index,
            size: mergedSize,
            htmlSize: 1,
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(mergedClassNames.input, `${prefixCls}-input`),
            style: mergedStyles.input,
            onChange: onInputChange,
            value: singleValue,
            onActiveChange: onInputActiveChange,
            autoFocus: index === 0 && autoFocus,
            onFocus: (event)=>onInputFocus(event, index),
            ...inputSharedProps
        }), index < length - 1 && /*#__PURE__*/ $cQmXV.createElement($f3e88b9735dbd806$var$Separator, {
            separator: separator,
            index: index,
            prefixCls: prefixCls,
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(mergedClassNames.separator),
            style: mergedStyles.separator
        }));
    })));
});
var $f3e88b9735dbd806$export$2e2bcd8739ae039 = $f3e88b9735dbd806$var$OTP;



var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");
var $9b5d1a1f52a44d36$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($9b5d1a1f52a44d36$exports, "__esModule", {
    value: true
});
var $9b5d1a1f52a44d36$var$EyeInvisibleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5zm-63.57-320.64L836 122.88a8 8 0 00-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 000 11.31L155.17 889a8 8 0 0011.31 0l712.15-712.12a8 8 0 000-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 00-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 01146.2-106.69L401.31 546.2A112 112 0 01396 512z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 00227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 01-112 112z"
                }
            }
        ]
    },
    "name": "eye-invisible",
    "theme": "outlined"
};
$9b5d1a1f52a44d36$exports.default = $9b5d1a1f52a44d36$var$EyeInvisibleOutlined;



function $dedc0c30730e75dc$var$_extends() {
    $dedc0c30730e75dc$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $dedc0c30730e75dc$var$_extends.apply(this, arguments);
}
const $dedc0c30730e75dc$var$EyeInvisibleOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $dedc0c30730e75dc$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9b5d1a1f52a44d36$exports)))
    }));
/**![eye-invisible](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTk0Mi4yIDQ4Ni4yUTg4OS40NyAzNzUuMTEgODE2LjcgMzA1bC01MC44OCA1MC44OEM4MDcuMzEgMzk1LjUzIDg0My40NSA0NDcuNCA4NzQuNyA1MTIgNzkxLjUgNjg0LjIgNjczLjQgNzY2IDUxMiA3NjZxLTcyLjY3IDAtMTMzLjg3LTIyLjM4TDMyMyA3OTguNzVRNDA4IDgzOCA1MTIgODM4cTI4OC4zIDAgNDMwLjItMzAwLjNhNjAuMjkgNjAuMjkgMCAwMDAtNTEuNXptLTYzLjU3LTMyMC42NEw4MzYgMTIyLjg4YTggOCAwIDAwLTExLjMyIDBMNzE1LjMxIDIzMi4yUTYyNC44NiAxODYgNTEyIDE4NnEtMjg4LjMgMC00MzAuMiAzMDAuM2E2MC4zIDYwLjMgMCAwMDAgNTEuNXE1Ni42OSAxMTkuNCAxMzYuNSAxOTEuNDFMMTEyLjQ4IDgzNWE4IDggMCAwMDAgMTEuMzFMMTU1LjE3IDg4OWE4IDggMCAwMDExLjMxIDBsNzEyLjE1LTcxMi4xMmE4IDggMCAwMDAtMTEuMzJ6TTE0OS4zIDUxMkMyMzIuNiAzMzkuOCAzNTAuNyAyNTggNTEyIDI1OGM1NC41NCAwIDEwNC4xMyA5LjM2IDE0OS4xMiAyOC4zOWwtNzAuMyA3MC4zYTE3NiAxNzYgMCAwMC0yMzguMTMgMjM4LjEzbC04My40MiA4My40MkMyMjMuMSA2MzcuNDkgMTgzLjMgNTgyLjI4IDE0OS4zIDUxMnptMjQ2LjcgMGExMTIuMTEgMTEyLjExIDAgMDExNDYuMi0xMDYuNjlMNDAxLjMxIDU0Ni4yQTExMiAxMTIgMCAwMTM5NiA1MTJ6IiAvPjxwYXRoIGQ9Ik01MDggNjI0Yy0zLjQ2IDAtNi44Ny0uMTYtMTAuMjUtLjQ3bC01Mi44MiA1Mi44MmExNzYuMDkgMTc2LjA5IDAgMDAyMjcuNDItMjI3LjQybC01Mi44MiA1Mi44MmMuMzEgMy4zOC40NyA2Ljc5LjQ3IDEwLjI1YTExMS45NCAxMTEuOTQgMCAwMS0xMTIgMTEyeiIgLz48L3N2Zz4=) */ const $dedc0c30730e75dc$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($dedc0c30730e75dc$var$EyeInvisibleOutlined);
var $dedc0c30730e75dc$export$2e2bcd8739ae039 = $dedc0c30730e75dc$var$RefIcon;



var $cQmXV = parcelRequire("cQmXV");
var $8da2364827de4223$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($8da2364827de4223$exports, "__esModule", {
    value: true
});
var $8da2364827de4223$var$EyeOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z"
                }
            }
        ]
    },
    "name": "eye",
    "theme": "outlined"
};
$8da2364827de4223$exports.default = $8da2364827de4223$var$EyeOutlined;



function $976919bf69465b09$var$_extends() {
    $976919bf69465b09$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $976919bf69465b09$var$_extends.apply(this, arguments);
}
const $976919bf69465b09$var$EyeOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $976919bf69465b09$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8da2364827de4223$exports)))
    }));
/**![eye](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTk0Mi4yIDQ4Ni4yQzg0Ny40IDI4Ni41IDcwNC4xIDE4NiA1MTIgMTg2Yy0xOTIuMiAwLTMzNS40IDEwMC41LTQzMC4yIDMwMC4zYTYwLjMgNjAuMyAwIDAwMCA1MS41QzE3Ni42IDczNy41IDMxOS45IDgzOCA1MTIgODM4YzE5Mi4yIDAgMzM1LjQtMTAwLjUgNDMwLjItMzAwLjMgNy43LTE2LjIgNy43LTM1IDAtNTEuNXpNNTEyIDc2NmMtMTYxLjMgMC0yNzkuNC04MS44LTM2Mi43LTI1NEMyMzIuNiAzMzkuOCAzNTAuNyAyNTggNTEyIDI1OGMxNjEuMyAwIDI3OS40IDgxLjggMzYyLjcgMjU0Qzc5MS41IDY4NC4yIDY3My40IDc2NiA1MTIgNzY2em0tNC00MzBjLTk3LjIgMC0xNzYgNzguOC0xNzYgMTc2czc4LjggMTc2IDE3NiAxNzYgMTc2LTc4LjggMTc2LTE3Ni03OC44LTE3Ni0xNzYtMTc2em0wIDI4OGMtNjEuOSAwLTExMi01MC4xLTExMi0xMTJzNTAuMS0xMTIgMTEyLTExMiAxMTIgNTAuMSAxMTIgMTEyLTUwLjEgMTEyLTExMiAxMTJ6IiAvPjwvc3ZnPg==) */ const $976919bf69465b09$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($976919bf69465b09$var$EyeOutlined);
var $976919bf69465b09$export$2e2bcd8739ae039 = $976919bf69465b09$var$RefIcon;












"use client";
const $e76f2eac908a8b62$var$defaultIconRender = (visible)=>visible ? /*#__PURE__*/ $cQmXV.createElement((0, $976919bf69465b09$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $cQmXV.createElement((0, $dedc0c30730e75dc$export$2e2bcd8739ae039), null);
const $e76f2eac908a8b62$var$actionMap = {
    click: "onClick",
    hover: "onMouseOver"
};
const $e76f2eac908a8b62$var$Password = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { disabled: customDisabled, action: action = "click", visibilityToggle: visibilityToggle = true, iconRender: iconRender, prefixCls: customizePrefixCls, inputPrefixCls: customizeInputPrefixCls, suffix: suffix, className: className, style: style, classNames: classNames, styles: styles, variant: customizeVariant, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles, iconRender: contextIconRender } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("inputPassword");
    const [variant] = (0, $11c15dfa3883fb6f$export$2e2bcd8739ae039)("inputPassword", customizeVariant, props.bordered, "input");
    const [locale] = (0, $c953dac9d015386e$export$2e2bcd8739ae039)("global");
    // ===================== Disabled =====================
    const disabled = $cQmXV.useContext((0, $4f0e1ea30330557c$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled ?? disabled;
    // =========== Merged Props for Semantic ==========
    const mergedProps = {
        ...props,
        disabled: mergedDisabled,
        variant: variant
    };
    const contextStyleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $30c5f9f911d4f61b$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: mergedProps
    });
    const visibilityControlled = (0, $8e2d153a3c855782$export$53b83ca8eaab0383)(visibilityToggle) && visibilityToggle.visible !== undefined;
    const [visible, setVisible] = (0, $cQmXV.useState)(()=>visibilityControlled ? visibilityToggle.visible : false);
    const inputRef = (0, $cQmXV.useRef)(null);
    $cQmXV.useEffect(()=>{
        if (visibilityControlled) setVisible(visibilityToggle.visible);
    }, [
        visibilityControlled,
        visibilityToggle
    ]);
    // Remove Password value
    const removePasswordTimeout = (0, $a637c5daf8d19d89$export$2e2bcd8739ae039)(inputRef);
    const onVisibleChange = ()=>{
        if (mergedDisabled) return;
        if (visible) removePasswordTimeout();
        const nextVisible = !visible;
        setVisible(nextVisible);
        if ((0, $8e2d153a3c855782$export$53b83ca8eaab0383)(visibilityToggle)) visibilityToggle.onVisibleChange?.(nextVisible);
    };
    const getIcon = (prefixCls)=>{
        const iconTrigger = $e76f2eac908a8b62$var$actionMap[action] || "";
        const iconRenderer = iconRender || contextIconRender || $e76f2eac908a8b62$var$defaultIconRender;
        const icon = iconRenderer(visible);
        const iconTabIndex = (0, $8e2d153a3c855782$export$53b83ca8eaab0383)(visibilityToggle) ? visibilityToggle.tabIndex : undefined;
        return /*#__PURE__*/ $cQmXV.createElement("span", {
            key: "passwordIcon",
            role: "button",
            tabIndex: mergedDisabled ? -1 : iconTabIndex ?? 0,
            className: `${prefixCls}-icon`,
            "aria-disabled": mergedDisabled,
            "aria-pressed": visible,
            "aria-label": visible ? locale.hide : locale.show,
            onMouseDown: (e)=>{
                // Prevent focused state lost
                // https://github.com/ant-design/ant-design/issues/15173
                e.preventDefault();
            },
            onMouseUp: (e)=>{
                // Prevent caret position change
                // https://github.com/ant-design/ant-design/issues/23524
                e.preventDefault();
            },
            onKeyDown: (e)=>{
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    onVisibleChange();
                }
            },
            [iconTrigger]: onVisibleChange
        }, icon);
    };
    const inputPrefixCls = getPrefixCls("input", customizeInputPrefixCls);
    const prefixCls = getPrefixCls("input-password", customizePrefixCls);
    const suffixIcon = visibilityToggle && getIcon(prefixCls);
    const inputClassName = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, contextClassName, className, {
        [`${prefixCls}-${props.size}`]: !!props.size
    });
    const inputProps = {
        ...restProps,
        type: visible ? "text" : "password",
        prefixCls: inputPrefixCls,
        suffix: /*#__PURE__*/ $cQmXV.createElement($cQmXV.Fragment, null, suffixIcon, suffix),
        disabled: mergedDisabled,
        className: inputClassName,
        classNames: mergedClassNames,
        styles: mergedStyles,
        variant: variant
    };
    return /*#__PURE__*/ $cQmXV.createElement((0, $056dbba933a63236$export$2e2bcd8739ae039), {
        ref: (0, $10341b937b26f69d$export$ab452c34e8e05029)(ref, inputRef),
        ...inputProps
    });
});
var $e76f2eac908a8b62$export$2e2bcd8739ae039 = $e76f2eac908a8b62$var$Password;



var $cQmXV = parcelRequire("cQmXV");

















const $0a56ecd3a2701a06$var$genSearchStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls, calc: calc, max: max } = token;
    const btnCls = `${componentCls}-btn`;
    const [varName, varRef] = (0, $6870d4d7c14ae0bb$export$d82b8f66c5649e14)(antCls, "input-search");
    const inputFontSizeSM = token.inputFontSizeSM ?? token.fontSize;
    const smallButtonHeight = max(token.controlHeightSM, calc(inputFontSizeSM).mul(token.lineHeight).add(calc(token.paddingBlockSM).mul(2)).add(calc(token.lineWidth).mul(2)).equal());
    return {
        [componentCls]: {
            [varName("btn-height")]: (0, $05f34ed03d41967d$export$523c0b569236b342)(token.controlHeight),
            width: "100%",
            // =========================== Button ===========================
            [btnCls]: {
                height: varRef("btn-height"),
                "&:focus-visible": {
                    zIndex: 5
                },
                [`&${antCls}-btn-icon-only`]: {
                    width: varRef("btn-height")
                },
                "&-filled": {
                    background: token.colorFillTertiary,
                    "&:not(:disabled)": {
                        "&:hover": {
                            background: token.colorFillSecondary
                        },
                        "&:active": {
                            background: token.colorFill
                        }
                    }
                }
            },
            [`&${componentCls}-large`]: {
                [varName("btn-height")]: (0, $05f34ed03d41967d$export$523c0b569236b342)(token.controlHeightLG)
            },
            [`&${componentCls}-small`]: {
                [varName("btn-height")]: (0, $05f34ed03d41967d$export$523c0b569236b342)(token.controlHeightSM)
            },
            [`&${componentCls}-small ${btnCls}`]: {
                minHeight: smallButtonHeight,
                [`&${token.antCls}-btn-icon-only`]: {
                    minWidth: smallButtonHeight
                }
            }
        }
    };
};
var $0a56ecd3a2701a06$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$51ec95de45185b42)([
    "Input",
    "Search"
], (token)=>{
    const inputToken = (0, $fef50f256b80dfa5$export$4950aa0f605343fb)(token, (0, $5e693f0c6e8784bd$export$a157d95850191a12)(token));
    return $0a56ecd3a2701a06$var$genSearchStyle(inputToken);
}, (0, $5e693f0c6e8784bd$export$bd8b682992bc9781));


"use client";
const $39d6675fbaabfe72$var$Search = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, inputPrefixCls: customizeInputPrefixCls, className: className, size: customizeSize, style: style, enterButton: enterButton = false, searchIcon: customizeSearchIcon, addonAfter: addonAfter, loading: loading, disabled: disabled, onSearch: customOnSearch, onChange: customOnChange, onCompositionStart: onCompositionStart, onCompositionEnd: onCompositionEnd, variant: customizeVariant, onPressEnter: customOnPressEnter, classNames: classNames, styles: styles, hidden: hidden, ...restProps } = props;
    const { direction: direction, getPrefixCls: getPrefixCls, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles, searchIcon: contextSearchIcon } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("inputSearch");
    const contextDisabled = $cQmXV.useContext((0, $4f0e1ea30330557c$export$2e2bcd8739ae039));
    const mergedDisabled = disabled ?? contextDisabled;
    const [mergedVariant, , isVariantConfigured] = (0, $11c15dfa3883fb6f$export$2e2bcd8739ae039)("inputSearch", customizeVariant, props.bordered);
    const variant = isVariantConfigured ? mergedVariant : undefined;
    const [inputVariant] = (0, $11c15dfa3883fb6f$export$2e2bcd8739ae039)("inputSearch", customizeVariant, props.bordered, "input");
    const mergedProps = {
        ...props,
        enterButton: enterButton,
        variant: variant
    };
    const contextStyleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $30c5f9f911d4f61b$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: mergedProps
    }, {
        button: {
            _default: "root"
        }
    });
    const composedRef = $cQmXV.useRef(false);
    const prefixCls = getPrefixCls("input-search", customizePrefixCls);
    const inputPrefixCls = getPrefixCls("input", customizeInputPrefixCls);
    const [hashId, cssVarCls] = (0, $0a56ecd3a2701a06$export$2e2bcd8739ae039)(prefixCls);
    const { compactSize: compactSize } = (0, $68fddf51400eda11$export$cd8cf9d7bab8dd4)(prefixCls, direction);
    const size = (0, $78cdfb6138721329$export$2e2bcd8739ae039)((ctx)=>customizeSize ?? compactSize ?? ctx);
    const inputRef = $cQmXV.useRef(null);
    const onChange = (e)=>{
        if (e?.target && e.type === "click" && customOnSearch) customOnSearch(e.target.value, e, {
            source: "clear"
        });
        customOnChange?.(e);
    };
    const onMouseDown = (e)=>{
        if (document.activeElement === inputRef.current?.input) e.preventDefault();
    };
    const onSearch = (e)=>{
        if (customOnSearch) customOnSearch(inputRef.current?.input?.value, e, {
            source: "input"
        });
    };
    const onPressEnter = (e)=>{
        if (composedRef.current || loading) return;
        customOnPressEnter?.(e);
        onSearch(e);
    };
    const searchIcon = typeof enterButton === "boolean" ? (0, $55c1e81905598a5b$export$2e2bcd8739ae039)(customizeSearchIcon, contextSearchIcon, /*#__PURE__*/ $cQmXV.createElement((0, $20a259d46bffcb08$export$2e2bcd8739ae039), null)) : null;
    const btnPrefixCls = `${prefixCls}-btn`;
    const btnClassName = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(btnPrefixCls, {
        [`${btnPrefixCls}-${variant}`]: variant
    });
    let button;
    const enterButtonAsElement = enterButton || {};
    const isAntdButton = enterButtonAsElement.type && enterButtonAsElement.type.__ANT_BUTTON === true;
    if (isAntdButton || enterButtonAsElement.type === "button") {
        const enterButtonProps = enterButtonAsElement.props;
        button = (0, $a91ef204d03d8eec$export$e530037191fcd5d7)(enterButtonAsElement, {
            disabled: mergedDisabled || enterButtonProps.disabled || !isAntdButton && loading,
            onMouseDown: onMouseDown,
            onClick: (e)=>{
                enterButtonAsElement?.props?.onClick?.(e);
                onSearch(e);
            },
            key: "enterButton",
            ...isAntdButton ? {
                className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(btnClassName, enterButtonProps.className),
                loading: loading || enterButtonProps.loading,
                size: size
            } : {}
        });
    } else button = /*#__PURE__*/ $cQmXV.createElement((0, $1fc505710073cde5$export$2e2bcd8739ae039), {
        classNames: mergedClassNames.button,
        styles: mergedStyles.button,
        className: btnClassName,
        color: enterButton ? "primary" : "default",
        size: size,
        disabled: disabled,
        key: "enterButton",
        onMouseDown: onMouseDown,
        onClick: onSearch,
        loading: loading,
        icon: searchIcon,
        variant: variant === "borderless" || variant === "filled" || variant === "underlined" ? "text" : enterButton ? "solid" : undefined
    }, enterButton);
    if (addonAfter) button = [
        button,
        (0, $a91ef204d03d8eec$export$e530037191fcd5d7)(addonAfter, {
            key: "addonAfter"
        })
    ];
    const mergedClassName = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, cssVarCls, {
        [`${prefixCls}-rtl`]: direction === "rtl",
        [`${prefixCls}-${size}`]: !!size,
        [`${prefixCls}-with-button`]: !!enterButton
    }, className, contextClassName, hashId, mergedClassNames.root);
    const handleOnCompositionStart = (e)=>{
        composedRef.current = true;
        onCompositionStart?.(e);
    };
    const handleOnCompositionEnd = (e)=>{
        composedRef.current = false;
        onCompositionEnd?.(e);
    };
    // ========================== Render ==========================
    // >>> Root Props
    const rootProps = (0, $4b5c733d1d7bb306$export$2e2bcd8739ae039)(restProps, {
        data: true
    });
    const inputProps = (0, $e8c5093aebad6025$export$2e2bcd8739ae039)({
        ...restProps,
        classNames: (0, $e8c5093aebad6025$export$2e2bcd8739ae039)(mergedClassNames, [
            "button",
            "root"
        ]),
        styles: (0, $e8c5093aebad6025$export$2e2bcd8739ae039)(mergedStyles, [
            "button",
            "root"
        ]),
        prefixCls: inputPrefixCls,
        type: "search",
        size: size,
        variant: inputVariant,
        onPressEnter: onPressEnter,
        onCompositionStart: handleOnCompositionStart,
        onCompositionEnd: handleOnCompositionEnd,
        onChange: onChange,
        disabled: disabled
    }, Object.keys(rootProps));
    return /*#__PURE__*/ $cQmXV.createElement((0, $68fddf51400eda11$export$2e2bcd8739ae039), {
        className: mergedClassName,
        style: mergedStyles.root,
        ...rootProps,
        hidden: hidden
    }, /*#__PURE__*/ $cQmXV.createElement((0, $056dbba933a63236$export$2e2bcd8739ae039), {
        ref: (0, $10341b937b26f69d$export$ab452c34e8e05029)(inputRef, ref),
        ...inputProps
    }), button);
});
var $39d6675fbaabfe72$export$2e2bcd8739ae039 = $39d6675fbaabfe72$var$Search;



var $cQmXV = parcelRequire("cQmXV");


















const $07b40bba4b0044f1$var$genTextAreaStyle = (token)=>{
    const { componentCls: componentCls, paddingLG: paddingLG } = token;
    const textareaPrefixCls = `${componentCls}-textarea`;
    return {
        // Raw Textarea
        [`textarea${componentCls}`]: {
            maxWidth: "100%",
            // prevent textarea resize from coming out of its container
            height: "auto",
            minHeight: token.controlHeight,
            lineHeight: token.lineHeight,
            verticalAlign: "bottom",
            transition: `all ${token.motionDurationSlow}`,
            resize: "vertical",
            "@media (hover: none) and (pointer: coarse)": {
                resize: "none"
            },
            [`&${componentCls}-mouse-active`]: {
                transition: `all ${token.motionDurationSlow}, height 0s, width 0s`
            }
        },
        // Wrapper for resize
        [`${componentCls}-textarea-affix-wrapper-resize-dirty`]: {
            width: "auto"
        },
        [textareaPrefixCls]: {
            position: "relative",
            "&-show-count": {
                [`${componentCls}-data-count`]: {
                    position: "absolute",
                    bottom: token.calc(token.fontSize).mul(token.lineHeight).mul(-1).equal(),
                    insetInlineEnd: 0,
                    color: token.colorTextDescription,
                    whiteSpace: "nowrap",
                    pointerEvents: "none"
                }
            },
            [`
        &-allow-clear > ${componentCls},
        &-affix-wrapper${textareaPrefixCls}-has-feedback ${componentCls}
      `]: {
                paddingInlineEnd: paddingLG
            },
            [`&-affix-wrapper${componentCls}-affix-wrapper`]: {
                padding: 0,
                [`> textarea${componentCls}`]: {
                    fontSize: "inherit",
                    border: "none",
                    outline: "none",
                    background: "transparent",
                    minHeight: token.calc(token.controlHeight).sub(token.calc(token.lineWidth).mul(2)).equal(),
                    "&:focus": {
                        boxShadow: "none !important"
                    }
                },
                [`${componentCls}-suffix`]: {
                    margin: 0,
                    "> *:not(:last-child)": {
                        marginInline: 0
                    },
                    // Clear Icon
                    [`${componentCls}-clear-icon`]: {
                        position: "absolute",
                        insetInlineEnd: token.paddingInline,
                        insetBlockStart: token.paddingXS
                    },
                    // Feedback Icon
                    [`${textareaPrefixCls}-suffix`]: {
                        position: "absolute",
                        top: 0,
                        insetInlineEnd: token.paddingInline,
                        bottom: 0,
                        zIndex: 1,
                        display: "inline-flex",
                        alignItems: "center",
                        margin: "auto",
                        pointerEvents: "none"
                    }
                }
            },
            [`&-affix-wrapper${componentCls}-affix-wrapper-rtl`]: {
                [`${componentCls}-suffix`]: {
                    [`${componentCls}-data-count`]: {
                        direction: "ltr",
                        insetInlineStart: 0
                    }
                }
            },
            [`&-affix-wrapper${componentCls}-affix-wrapper-sm`]: {
                [`${componentCls}-suffix`]: {
                    [`${componentCls}-clear-icon`]: {
                        insetInlineEnd: token.paddingInlineSM
                    }
                }
            }
        }
    };
};
var // ============================== Export ==============================
$07b40bba4b0044f1$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$51ec95de45185b42)([
    "Input",
    "TextArea"
], (token)=>{
    const inputToken = (0, $fef50f256b80dfa5$export$4950aa0f605343fb)(token, (0, $5e693f0c6e8784bd$export$a157d95850191a12)(token));
    return $07b40bba4b0044f1$var$genTextAreaStyle(inputToken);
}, (0, $5e693f0c6e8784bd$export$bd8b682992bc9781), {
    resetFont: false
});


"use client";
const $685f39e72eec13cf$var$TextArea = /*#__PURE__*/ (0, $cQmXV.forwardRef)((props, ref)=>{
    const { prefixCls: customizePrefixCls, bordered: bordered = true, size: customizeSize, disabled: customDisabled, status: customStatus, allowClear: allowClear, classNames: classNames, rootClassName: rootClassName, className: className, style: style, styles: styles, variant: customVariant, showCount: showCount, onMouseDown: onMouseDown, onResize: onResize, ...rest } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, allowClear: contextAllowClear, autoComplete: contextAutoComplete, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("textArea");
    // =================== Disabled ===================
    const disabled = $cQmXV.useContext((0, $4f0e1ea30330557c$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled ?? disabled;
    // ==================== Status ====================
    const { status: contextStatus, hasFeedback: hasFeedback, feedbackIcon: feedbackIcon } = $cQmXV.useContext((0, $7a3804f153d8a19d$export$bbb5553c6c7a14ed));
    const mergedStatus = (0, $4a3ea1f9228016b7$export$314e193082d7ba49)(contextStatus, customStatus);
    const contextStyleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $30c5f9f911d4f61b$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: props
    });
    // ===================== Ref ======================
    const innerRef = $cQmXV.useRef(null);
    $cQmXV.useImperativeHandle(ref, ()=>({
            resizableTextArea: innerRef.current?.resizableTextArea,
            focus: (option)=>{
                (0, $7aa1eaa901116c60$export$2b92016deb0b7aad)(innerRef.current?.resizableTextArea?.textArea, option);
            },
            blur: ()=>innerRef.current?.blur(),
            nativeElement: innerRef.current?.nativeElement || null
        }));
    const prefixCls = getPrefixCls("input", customizePrefixCls);
    // ==================== Style =====================
    const rootCls = (0, $2237081acd3cfc09$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $8c2dcdcd3819e8c0$export$de732caeaad5f68e)(prefixCls, rootClassName);
    (0, $07b40bba4b0044f1$export$2e2bcd8739ae039)(prefixCls, rootCls);
    // ================= Compact Item =================
    const { compactSize: compactSize, compactItemClassnames: compactItemClassnames } = (0, $68fddf51400eda11$export$cd8cf9d7bab8dd4)(prefixCls, direction);
    // ===================== Size =====================
    const mergedSize = (0, $78cdfb6138721329$export$2e2bcd8739ae039)((ctx)=>customizeSize ?? compactSize ?? ctx);
    const [variant, enableVariantCls] = (0, $11c15dfa3883fb6f$export$2e2bcd8739ae039)("textArea", customVariant, bordered);
    const mergedAllowClear = (0, $7dfc6f571d3c00af$export$9ea6397a890aa3e5)({
        allowClear: allowClear,
        contextAllowClear: contextAllowClear,
        componentName: "TextArea"
    });
    // ==================== Resize ====================
    // https://github.com/ant-design/ant-design/issues/51594
    const [isMouseDown, setIsMouseDown] = $cQmXV.useState(false);
    // When has wrapper, resize will make as dirty for `resize: both` style
    const [resizeDirty, setResizeDirty] = $cQmXV.useState(false);
    const onInternalMouseDown = (e)=>{
        setIsMouseDown(true);
        onMouseDown?.(e);
        const onMouseUp = ()=>{
            setIsMouseDown(false);
            document.removeEventListener("mouseup", onMouseUp);
        };
        document.addEventListener("mouseup", onMouseUp);
    };
    const onInternalResize = (size)=>{
        onResize?.(size);
        // Change to dirty since this maybe from the `resize: both` style
        if (isMouseDown && (0, $8e2d153a3c855782$export$f6e2535fb5126e54)(getComputedStyle)) {
            const ele = innerRef.current?.nativeElement?.querySelector("textarea");
            if (ele && getComputedStyle(ele).resize === "both") setResizeDirty(true);
        }
    };
    // ==================== Render ====================
    return /*#__PURE__*/ $cQmXV.createElement((0, $fb7b4ce957d6ad1a$export$2e2bcd8739ae039), {
        autoComplete: contextAutoComplete,
        ...rest,
        style: mergedStyles.root,
        styles: mergedStyles,
        disabled: mergedDisabled,
        allowClear: mergedAllowClear,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(cssVarCls, rootCls, className, rootClassName, compactItemClassnames, contextClassName, mergedClassNames.root, // Only for wrapper
        {
            [`${prefixCls}-textarea-affix-wrapper-resize-dirty`]: resizeDirty
        }),
        classNames: {
            ...mergedClassNames,
            textarea: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)({
                [`${prefixCls}-sm`]: mergedSize === "small",
                [`${prefixCls}-lg`]: mergedSize === "large"
            }, hashId, mergedClassNames.textarea, isMouseDown && `${prefixCls}-mouse-active`),
            variant: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)({
                [`${prefixCls}-${variant}`]: enableVariantCls
            }, (0, $4a3ea1f9228016b7$export$b08e7b47149942a2)(prefixCls, mergedStatus)),
            affixWrapper: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-textarea-affix-wrapper`, {
                [`${prefixCls}-affix-wrapper-rtl`]: direction === "rtl",
                [`${prefixCls}-affix-wrapper-sm`]: mergedSize === "small",
                [`${prefixCls}-affix-wrapper-lg`]: mergedSize === "large",
                [`${prefixCls}-textarea-show-count`]: showCount || props.count?.show
            }, hashId)
        },
        prefixCls: prefixCls,
        suffix: hasFeedback && /*#__PURE__*/ $cQmXV.createElement("span", {
            className: `${prefixCls}-textarea-suffix`
        }, feedbackIcon),
        showCount: showCount,
        ref: innerRef,
        onResize: onInternalResize,
        onMouseDown: onInternalMouseDown
    });
});
var $685f39e72eec13cf$export$2e2bcd8739ae039 = $685f39e72eec13cf$var$TextArea;


"use client";
const $0883e7f8083c01b0$var$Input = (0, $056dbba933a63236$export$2e2bcd8739ae039);
$0883e7f8083c01b0$var$Input.Group = (0, $dd018f91a6c9077f$export$2e2bcd8739ae039);
$0883e7f8083c01b0$var$Input.Search = (0, $39d6675fbaabfe72$export$2e2bcd8739ae039);
$0883e7f8083c01b0$var$Input.TextArea = (0, $685f39e72eec13cf$export$2e2bcd8739ae039);
$0883e7f8083c01b0$var$Input.Password = (0, $e76f2eac908a8b62$export$2e2bcd8739ae039);
$0883e7f8083c01b0$var$Input.OTP = (0, $f3e88b9735dbd806$export$2e2bcd8739ae039);
var $0883e7f8083c01b0$export$2e2bcd8739ae039 = $0883e7f8083c01b0$var$Input;


var $cQmXV = parcelRequire("cQmXV");





var $cQmXV = parcelRequire("cQmXV");
var $ae188708959c6070$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($ae188708959c6070$exports, "__esModule", {
    value: true
});
var $ae188708959c6070$var$InfoCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z"
                }
            }
        ]
    },
    "name": "info-circle",
    "theme": "filled"
};
$ae188708959c6070$exports.default = $ae188708959c6070$var$InfoCircleFilled;



function $a164337416b087a0$var$_extends() {
    $a164337416b087a0$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a164337416b087a0$var$_extends.apply(this, arguments);
}
const $a164337416b087a0$var$InfoCircleFilled = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $a164337416b087a0$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ae188708959c6070$exports)))
    }));
/**![info-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0zMiA2NjRjMCA0LjQtMy42IDgtOCA4aC00OGMtNC40IDAtOC0zLjYtOC04VjQ1NmMwLTQuNCAzLjYtOCA4LThoNDhjNC40IDAgOCAzLjYgOCA4djI3MnptLTMyLTM0NGE0OC4wMSA0OC4wMSAwIDAxMC05NiA0OC4wMSA0OC4wMSAwIDAxMCA5NnoiIC8+PC9zdmc+) */ const $a164337416b087a0$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($a164337416b087a0$var$InfoCircleFilled);
var $a164337416b087a0$export$2e2bcd8739ae039 = $a164337416b087a0$var$RefIcon;












const $960c8d1628bf206b$var$genAlertTypeStyle = (bgColor, iconColor, alertCls)=>({
        background: bgColor,
        [`${alertCls}-icon`]: {
            color: iconColor
        }
    });
const $960c8d1628bf206b$export$5ca74f7be820a85 = (token)=>{
    const { componentCls: componentCls, motionDurationSlow: duration, marginXS: marginXS, marginSM: marginSM, fontSize: fontSize, fontSizeLG: fontSizeLG, lineHeight: lineHeight, motionEaseInOutCirc: motionEaseInOutCirc, borderRadius: borderRadius, withDescriptionIconSize: withDescriptionIconSize, colorText: colorText, colorTextHeading: colorTextHeading, withDescriptionPadding: withDescriptionPadding, defaultPadding: defaultPadding, lineWidth: lineWidth, lineType: lineType, colorSuccessBorder: colorSuccessBorder, colorWarningBorder: colorWarningBorder, colorErrorBorder: colorErrorBorder, colorInfoBorder: colorInfoBorder } = token;
    return {
        [componentCls]: {
            ...(0, $519d20bf207ce864$export$23997c3e44cc1c59)(token),
            position: "relative",
            display: "flex",
            alignItems: "center",
            padding: defaultPadding,
            wordWrap: "break-word",
            borderRadius: borderRadius,
            borderWidth: (0, $05f34ed03d41967d$export$523c0b569236b342)(lineWidth),
            borderStyle: lineType,
            [`&${componentCls}-success`]: {
                borderColor: colorSuccessBorder
            },
            [`&${componentCls}-info`]: {
                borderColor: colorInfoBorder
            },
            [`&${componentCls}-warning`]: {
                borderColor: colorWarningBorder
            },
            [`&${componentCls}-error`]: {
                borderColor: colorErrorBorder
            },
            [`&${componentCls}-filled`]: {
                borderColor: "transparent"
            },
            [`&${componentCls}-rtl`]: {
                direction: "rtl"
            },
            [`${componentCls}-section`]: {
                flex: 1,
                minWidth: 0
            },
            [`${componentCls}-icon`]: {
                marginInlineEnd: marginXS,
                lineHeight: 0
            },
            "&-description": {
                display: "none",
                fontSize: fontSize,
                lineHeight: lineHeight
            },
            "&-title": {
                color: colorTextHeading
            },
            [`&${componentCls}-motion-leave`]: {
                overflow: "hidden",
                opacity: 1,
                transition: [
                    `max-height`,
                    `opacity`,
                    `padding-top`,
                    `padding-bottom`,
                    `margin-bottom`
                ].map((prop)=>`${prop} ${duration} ${motionEaseInOutCirc}`).join(", ")
            },
            [`&${componentCls}-motion-leave-active`]: {
                maxHeight: 0,
                marginBottom: "0 !important",
                paddingTop: 0,
                paddingBottom: 0,
                opacity: 0
            },
            [`&${componentCls}-with-description`]: {
                alignItems: "flex-start",
                padding: withDescriptionPadding,
                [`${componentCls}-icon`]: {
                    marginInlineEnd: marginSM,
                    fontSize: withDescriptionIconSize,
                    lineHeight: 0
                },
                [`${componentCls}-title`]: {
                    display: "block",
                    marginBottom: marginXS,
                    color: colorTextHeading,
                    fontSize: fontSizeLG
                },
                [`${componentCls}-description`]: {
                    display: "block",
                    color: colorText
                }
            },
            [`&${componentCls}-banner`]: {
                marginBottom: 0,
                border: "0 !important",
                borderRadius: 0
            }
        }
    };
};
const $960c8d1628bf206b$export$289eb6d482898146 = (token)=>{
    const { componentCls: componentCls, colorSuccess: colorSuccess, colorSuccessBg: colorSuccessBg, colorWarning: colorWarning, colorWarningBg: colorWarningBg, colorError: colorError, colorErrorBg: colorErrorBg, colorInfo: colorInfo, colorInfoBg: colorInfoBg } = token;
    return {
        [componentCls]: {
            "&-success": $960c8d1628bf206b$var$genAlertTypeStyle(colorSuccessBg, colorSuccess, componentCls),
            "&-info": $960c8d1628bf206b$var$genAlertTypeStyle(colorInfoBg, colorInfo, componentCls),
            "&-warning": $960c8d1628bf206b$var$genAlertTypeStyle(colorWarningBg, colorWarning, componentCls),
            "&-error": {
                ...$960c8d1628bf206b$var$genAlertTypeStyle(colorErrorBg, colorError, componentCls),
                [`${componentCls}-description > pre`]: {
                    margin: 0,
                    padding: 0
                }
            }
        }
    };
};
const $960c8d1628bf206b$export$5ecc051c674d512 = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, motionDurationMid: motionDurationMid, marginXS: marginXS, fontSizeIcon: fontSizeIcon, colorIcon: colorIcon, colorIconHover: colorIconHover } = token;
    return {
        [componentCls]: {
            [`${componentCls}-actions`]: {
                marginInlineStart: marginXS
            },
            [`${componentCls}-close-icon`]: {
                marginInlineStart: marginXS,
                padding: 0,
                overflow: "hidden",
                fontSize: fontSizeIcon,
                lineHeight: (0, $05f34ed03d41967d$export$523c0b569236b342)(fontSizeIcon),
                backgroundColor: "transparent",
                border: "none",
                cursor: "pointer",
                ...(0, $519d20bf207ce864$export$a44db842bcb28231)(token),
                [`${iconCls}-close`]: {
                    color: colorIcon,
                    transition: `color ${motionDurationMid}`,
                    "&:hover": {
                        color: colorIconHover
                    }
                }
            },
            "&-close-text": {
                color: colorIcon,
                transition: `color ${motionDurationMid}`,
                "&:hover": {
                    color: colorIconHover
                }
            }
        }
    };
};
const $960c8d1628bf206b$export$9ca1be8807fe0675 = (token)=>{
    const paddingHorizontal = 12; // Fixed value here.
    return {
        borderRadius: token.borderRadiusLG,
        withDescriptionIconSize: token.fontSizeHeading3,
        defaultPadding: `${token.paddingContentVerticalSM}px ${paddingHorizontal}px`,
        withDescriptionPadding: `${token.paddingMD}px ${token.paddingContentHorizontalLG}px`
    };
};
var $960c8d1628bf206b$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$51ec95de45185b42)("Alert", (token)=>[
        $960c8d1628bf206b$export$5ca74f7be820a85(token),
        $960c8d1628bf206b$export$289eb6d482898146(token),
        $960c8d1628bf206b$export$5ecc051c674d512(token)
    ], $960c8d1628bf206b$export$9ca1be8807fe0675);


"use client";
const $2f0083d7c47aa27b$var$IconNode = (props)=>{
    const { icon: icon, type: type, className: className, style: style, successIcon: successIcon, infoIcon: infoIcon, warningIcon: warningIcon, errorIcon: errorIcon } = props;
    const iconMapFilled = {
        success: successIcon ?? /*#__PURE__*/ $cQmXV.createElement((0, $017e758d1ebbd854$export$2e2bcd8739ae039), null),
        info: infoIcon ?? /*#__PURE__*/ $cQmXV.createElement((0, $a164337416b087a0$export$2e2bcd8739ae039), null),
        error: errorIcon ?? /*#__PURE__*/ $cQmXV.createElement((0, $ff9add21dbbc2684$export$2e2bcd8739ae039), null),
        warning: warningIcon ?? /*#__PURE__*/ $cQmXV.createElement((0, $39711bf58c19fcd8$export$2e2bcd8739ae039), null)
    };
    return /*#__PURE__*/ $cQmXV.createElement("span", {
        className: className,
        style: style
    }, icon ?? iconMapFilled[type]);
};
const $2f0083d7c47aa27b$var$CloseIconNode = (props)=>{
    const { isClosable: isClosable, prefixCls: prefixCls, closeIcon: closeIcon, handleClose: handleClose, ariaProps: ariaProps, className: className, style: style } = props;
    const mergedCloseIcon = closeIcon === true || closeIcon === undefined ? /*#__PURE__*/ $cQmXV.createElement((0, $837faca566926e3c$export$2e2bcd8739ae039), null) : closeIcon;
    return isClosable ? /*#__PURE__*/ $cQmXV.createElement("button", {
        type: "button",
        onClick: handleClose,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-close-icon`, className),
        tabIndex: 0,
        style: style,
        ...ariaProps
    }, mergedCloseIcon) : null;
};
const $2f0083d7c47aa27b$var$Alert = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { description: description, prefixCls: customizePrefixCls, message: message, title: title, banner: banner, className: className, rootClassName: rootClassName, style: style, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onClick: onClick, afterClose: afterClose, showIcon: showIcon, closable: closable, closeText: closeText, closeIcon: closeIcon, action: action, id: id, styles: styles, classNames: classNames, ...otherProps } = props;
    const mergedTitle = title ?? message;
    const [closed, setClosed] = $cQmXV.useState(false);
    var deprecatedName, newName;
    const internalRef = $cQmXV.useRef(null);
    $cQmXV.useImperativeHandle(ref, ()=>({
            nativeElement: internalRef.current
        }));
    const { getPrefixCls: getPrefixCls, direction: direction, variant: contextVariant, closable: contextClosable, closeIcon: contextCloseIcon, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles, successIcon: successIcon, infoIcon: infoIcon, warningIcon: warningIcon, errorIcon: errorIcon } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("alert");
    const prefixCls = getPrefixCls("alert", customizePrefixCls);
    const [hashId, cssVarCls] = (0, $960c8d1628bf206b$export$2e2bcd8739ae039)(prefixCls);
    const { onClose: closableOnClose, afterClose: closableAfterClose } = (0, $8e2d153a3c855782$export$53b83ca8eaab0383)(closable) ? closable : {};
    const handleClose = (e)=>{
        setClosed(true);
        (closableOnClose ?? props.onClose)?.(e);
    };
    const type = $cQmXV.useMemo(()=>{
        if (props.type !== undefined) return props.type;
        // banner mode defaults to 'warning'
        return banner ? "warning" : "info";
    }, [
        props.type,
        banner
    ]);
    const mergedVariant = props.variant ?? contextVariant ?? "outlined";
    // closeable when closeText or closeIcon is assigned
    const isClosable = $cQmXV.useMemo(()=>{
        if ((0, $8e2d153a3c855782$export$53b83ca8eaab0383)(closable)) return true;
        if (closeText) return true;
        if (typeof closable === "boolean") return closable;
        // should be true when closeIcon is 0 or ''
        if (closeIcon !== false && (0, $8e2d153a3c855782$export$826fff653a329e83)(closeIcon)) return true;
        return !!contextClosable;
    }, [
        closeText,
        closeIcon,
        closable,
        contextClosable
    ]);
    // banner mode defaults to Icon
    const isShowIcon = banner && showIcon === undefined ? true : showIcon;
    // =========== Merged Props for Semantic ==========
    const mergedProps = {
        ...props,
        prefixCls: prefixCls,
        variant: mergedVariant,
        type: type,
        showIcon: isShowIcon,
        closable: isClosable
    };
    const contextStyleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $30c5f9f911d4f61b$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: mergedProps
    });
    const alertCls = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-${type}`, `${prefixCls}-${mergedVariant}`, {
        [`${prefixCls}-with-description`]: !!description,
        [`${prefixCls}-no-icon`]: !isShowIcon,
        [`${prefixCls}-banner`]: !!banner,
        [`${prefixCls}-rtl`]: direction === "rtl"
    }, contextClassName, className, rootClassName, mergedClassNames.root, cssVarCls, hashId);
    const restProps = (0, $4b5c733d1d7bb306$export$2e2bcd8739ae039)(otherProps, {
        aria: true,
        data: true
    });
    const mergedCloseIcon = $cQmXV.useMemo(()=>{
        if ((0, $8e2d153a3c855782$export$53b83ca8eaab0383)(closable) && closable.closeIcon) return closable.closeIcon;
        if (closeText) return closeText;
        if (closeIcon !== undefined) return closeIcon;
        if ((0, $8e2d153a3c855782$export$53b83ca8eaab0383)(contextClosable) && contextClosable.closeIcon) return contextClosable.closeIcon;
        return contextCloseIcon;
    }, [
        closeIcon,
        closable,
        contextClosable,
        closeText,
        contextCloseIcon
    ]);
    const mergedAriaProps = $cQmXV.useMemo(()=>{
        const merged = closable ?? contextClosable;
        if ((0, $8e2d153a3c855782$export$53b83ca8eaab0383)(merged)) return (0, $4b5c733d1d7bb306$export$2e2bcd8739ae039)(merged, {
            data: true,
            aria: true
        });
        return {};
    }, [
        closable,
        contextClosable
    ]);
    return /*#__PURE__*/ $cQmXV.createElement((0, $04c53b89814950f8$export$2e2bcd8739ae039), {
        visible: !closed,
        motionName: `${prefixCls}-motion`,
        motionAppear: false,
        motionEnter: false,
        onLeaveStart: (node)=>({
                maxHeight: node.offsetHeight
            }),
        onLeaveEnd: closableAfterClose ?? afterClose
    }, ({ className: motionClassName, style: motionStyle }, setRef)=>/*#__PURE__*/ $cQmXV.createElement("div", {
            id: id,
            ref: (0, $10341b937b26f69d$export$ab452c34e8e05029)(internalRef, setRef),
            "data-show": !closed,
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(alertCls, motionClassName),
            style: {
                ...mergedStyles.root,
                ...motionStyle
            },
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onClick: onClick,
            role: "alert",
            ...restProps
        }, isShowIcon ? /*#__PURE__*/ $cQmXV.createElement($2f0083d7c47aa27b$var$IconNode, {
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-icon`, mergedClassNames.icon),
            style: mergedStyles.icon,
            description: description,
            icon: props.icon,
            prefixCls: prefixCls,
            type: type,
            successIcon: successIcon,
            infoIcon: infoIcon,
            warningIcon: warningIcon,
            errorIcon: errorIcon
        }) : null, /*#__PURE__*/ $cQmXV.createElement("div", {
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-section`, mergedClassNames.section),
            style: mergedStyles.section
        }, mergedTitle ? /*#__PURE__*/ $cQmXV.createElement("div", {
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-title`, mergedClassNames.title),
            style: mergedStyles.title
        }, mergedTitle) : null, description ? /*#__PURE__*/ $cQmXV.createElement("div", {
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-description`, mergedClassNames.description),
            style: mergedStyles.description
        }, description) : null), action ? /*#__PURE__*/ $cQmXV.createElement("div", {
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-actions`, mergedClassNames.actions),
            style: mergedStyles.actions
        }, action) : null, /*#__PURE__*/ $cQmXV.createElement($2f0083d7c47aa27b$var$CloseIconNode, {
            className: mergedClassNames.close,
            style: mergedStyles.close,
            isClosable: isClosable,
            prefixCls: prefixCls,
            closeIcon: mergedCloseIcon,
            handleClose: handleClose,
            ariaProps: mergedAriaProps
        })));
});
var $2f0083d7c47aa27b$export$2e2bcd8739ae039 = $2f0083d7c47aa27b$var$Alert;







function $c9207ae63c5858d7$export$2e2bcd8739ae039(t, o, e) {
    return o = (0, $5b4fe65c74408c52$export$2e2bcd8739ae039)(o), (0, $33c3c70a2b283b30$export$2e2bcd8739ae039)(t, (0, $5d696402a43f7962$export$2e2bcd8739ae039)() ? Reflect.construct(o, e || [], (0, $5b4fe65c74408c52$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}




var $cQmXV = parcelRequire("cQmXV");


"use client";
let $e246c09f818ceea3$var$ErrorBoundary = /*#__PURE__*/ function(_React$PureComponent) {
    function ErrorBoundary() {
        var _this;
        (0, $07be749aeca07699$export$2e2bcd8739ae039)(this, ErrorBoundary);
        _this = (0, $c9207ae63c5858d7$export$2e2bcd8739ae039)(this, ErrorBoundary, arguments);
        _this.state = {
            error: undefined,
            info: {}
        };
        return _this;
    }
    (0, $97a7799c9b277eb6$export$2e2bcd8739ae039)(ErrorBoundary, _React$PureComponent);
    return (0, $c180160353ceabc3$export$2e2bcd8739ae039)(ErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, info) {
                this.setState({
                    error: error,
                    info: info
                });
            }
        },
        {
            key: "render",
            value: function render() {
                const { message: message, title: title, description: description, id: id, children: children } = this.props;
                const { error: error, info: info } = this.state;
                const mergedTitle = title ?? message;
                const componentStack = info?.componentStack || null;
                const errorMessage = (0, $8e2d153a3c855782$export$826fff653a329e83)(mergedTitle) ? mergedTitle : error?.toString();
                const errorDescription = (0, $8e2d153a3c855782$export$826fff653a329e83)(description) ? description : componentStack;
                if (error) return /*#__PURE__*/ $cQmXV.createElement((0, $2f0083d7c47aa27b$export$2e2bcd8739ae039), {
                    id: id,
                    type: "error",
                    title: errorMessage,
                    description: /*#__PURE__*/ $cQmXV.createElement("pre", {
                        style: {
                            fontSize: "0.9em",
                            overflowX: "auto"
                        }
                    }, errorDescription)
                });
                return children;
            }
        }
    ]);
}($cQmXV.PureComponent);
var $e246c09f818ceea3$export$2e2bcd8739ae039 = $e246c09f818ceea3$var$ErrorBoundary;


"use client";
const $dc33dcdb2d24fbd9$var$Alert = (0, $2f0083d7c47aa27b$export$2e2bcd8739ae039);
$dc33dcdb2d24fbd9$var$Alert.ErrorBoundary = (0, $e246c09f818ceea3$export$2e2bcd8739ae039);
var $dc33dcdb2d24fbd9$export$2e2bcd8739ae039 = $dc33dcdb2d24fbd9$var$Alert;



var $cQmXV = parcelRequire("cQmXV");
var $796c004619a0cd2e$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($796c004619a0cd2e$exports, "__esModule", {
    value: true
});
var $796c004619a0cd2e$var$ArrowLeftOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M872 474H286.9l350.2-304c5.6-4.9 2.2-14-5.2-14h-88.5c-3.9 0-7.6 1.4-10.5 3.9L155 487.8a31.96 31.96 0 000 48.3L535.1 866c1.5 1.3 3.3 2 5.2 2h91.5c7.4 0 10.8-9.2 5.2-14L286.9 550H872c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "arrow-left",
    "theme": "outlined"
};
$796c004619a0cd2e$exports.default = $796c004619a0cd2e$var$ArrowLeftOutlined;



function $e460634cb20318d4$var$_extends() {
    $e460634cb20318d4$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e460634cb20318d4$var$_extends.apply(this, arguments);
}
const $e460634cb20318d4$var$ArrowLeftOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $e460634cb20318d4$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($796c004619a0cd2e$exports)))
    }));
/**![arrow-left](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg3MiA0NzRIMjg2LjlsMzUwLjItMzA0YzUuNi00LjkgMi4yLTE0LTUuMi0xNGgtODguNWMtMy45IDAtNy42IDEuNC0xMC41IDMuOUwxNTUgNDg3LjhhMzEuOTYgMzEuOTYgMCAwMDAgNDguM0w1MzUuMSA4NjZjMS41IDEuMyAzLjMgMiA1LjIgMmg5MS41YzcuNCAwIDEwLjgtOS4yIDUuMi0xNEwyODYuOSA1NTBIODcyYzQuNCAwIDgtMy42IDgtOHYtNjBjMC00LjQtMy42LTgtOC04eiIgLz48L3N2Zz4=) */ const $e460634cb20318d4$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($e460634cb20318d4$var$ArrowLeftOutlined);
var $e460634cb20318d4$export$2e2bcd8739ae039 = $e460634cb20318d4$var$RefIcon;






var $cQmXV = parcelRequire("cQmXV");








function $c059d29b2c848302$export$5fd4b484410e2ff0() {
    const [lang, setLangState] = (0, $cQmXV.useState)((0, $2753457ad00c82b6$export$fd43f4122341a86b));
    const setLang = (0, $cQmXV.useCallback)((code)=>{
        const next = (0, $2753457ad00c82b6$export$5054ee9bb15d330e)(code) ? code : (0, $2753457ad00c82b6$export$90898903f0729f34);
        /* Only a hand-picked language is ever written, which is exactly what makes the stored key
       mean "deliberate" and lets it outrank detection on every later visit. */ (0, $2753457ad00c82b6$export$3d819036c4c4fbb5)(next);
        setLangState(next);
    }, []);
    /* Screen readers and `lang`-sensitive font stacks both need this to match the copy. */ (0, $cQmXV.useEffect)(()=>{
        document.documentElement.lang = lang;
    }, [
        lang
    ]);
    const t = (0, $cQmXV.useCallback)((key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$78a94b7660ec0e3b), key, lang), [
        lang
    ]);
    return {
        lang: lang,
        setLang: setLang,
        t: t
    };
}
function $c059d29b2c848302$export$ea17b4a2d592acf1(form, lang) {
    const first = (0, $cQmXV.useRef)(true);
    (0, $cQmXV.useEffect)(()=>{
        /* Nothing can be showing on mount, and clearing here would fight autoFocus. */ if (first.current) {
            first.current = false;
            return;
        }
        const failing = form.getFieldsError().filter((f)=>f.errors.length).map((f)=>({
                name: f.name,
                errors: []
            }));
        if (failing.length) form.setFields(failing);
    }, [
        lang,
        form
    ]);
}
function $c059d29b2c848302$var$LanguagePicker({ lang: lang, setLang: setLang, t: t }) {
    const [open, setOpen] = (0, $cQmXV.useState)(false);
    const current = (0, $2753457ad00c82b6$export$b4b5a31092c79bca).find((l)=>l.code === lang) || (0, $2753457ad00c82b6$export$b4b5a31092c79bca)[0];
    const items = (0, $2753457ad00c82b6$export$b4b5a31092c79bca).map((l)=>({
            key: l.code,
            label: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                className: "auth-langitem",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        children: l.label
                    }),
                    l.native ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "auth-langitem__native",
                        children: l.native
                    }) : null,
                    l.code === lang ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $77ccca814b0c39fe$export$2e2bcd8739ae039), {
                        className: "auth-langitem__tick"
                    }) : null
                ]
            })
        }));
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
        className: "auth-langwrap",
        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $30ddd2d6a9f4b7d6$export$2e2bcd8739ae039), {
            open: open,
            onOpenChange: setOpen,
            trigger: [
                "click"
            ],
            placement: "bottomRight",
            classNames: {
                root: "auth-langmenu"
            },
            menu: {
                items: items,
                selectable: true,
                selectedKeys: [
                    lang
                ],
                onClick: ({ key: key })=>setLang(key)
            },
            children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("button", {
                className: "auth-lang",
                type: "button",
                "aria-label": t("language"),
                "aria-expanded": open,
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        children: current.label
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e7119b602540b2c5$export$2e2bcd8739ae039), {
                        className: "auth-lang__chev"
                    })
                ]
            })
        })
    });
}
function $c059d29b2c848302$export$2e2bcd8739ae039({ lang: lang, setLang: setLang, t: t, children: children }) {
    const headline = t("headline") || "";
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5764e43cf38ca965$export$2e2bcd8739ae039), {
        locale: (0, $d40125f317306d19$export$699e2fca28693f3d)(lang),
        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
            className: "auth",
            children: [
                /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("aside", {
                    className: "auth-brand",
                    children: [
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("img", {
                            className: "auth-logo",
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($39824af573644a06$exports))),
                            alt: "Picsell"
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("h1", {
                                    className: "auth-headline",
                                    children: headline
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("p", {
                                    className: "auth-subhead",
                                    children: t("subhead")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("ul", {
                            className: "auth-features",
                            children: [
                                "feat1",
                                "feat2",
                                "feat3"
                            ].map((key)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $77ccca814b0c39fe$export$2e2bcd8739ae039), {
                                            className: "auth-features__tick",
                                            "aria-hidden": "true"
                                        }),
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                            children: t(key)
                                        })
                                    ]
                                }, key))
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($c059d29b2c848302$var$LanguagePicker, {
                    lang: lang,
                    setLang: setLang,
                    t: t
                }),
                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("main", {
                    className: "auth-pane",
                    children: children
                })
            ]
        })
    });
}


/* Deliberately permissive about formatting (spaces, dashes, parens) and only checks for a
   plausible digit count — authoritative validation is the server's job. */ const $0c0a79c705228dbe$var$isPhone = (value)=>{
    if (!/^\+?[\d\s()\-]+$/.test(value)) return false;
    const digits = value.replace(/\D/g, "").length;
    return digits >= 9 && digits <= 15;
};
function $0c0a79c705228dbe$var$requestPasswordReset(phone_number) {
    if (!(0, $91ea30cb49819b9a$export$7a30a33cf2617bd2)) return Promise.reject(new Error("NOT_CONFIGURED"));
    return fetch((0, $91ea30cb49819b9a$export$7a30a33cf2617bd2), {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        mode: "cors",
        body: JSON.stringify({
            phone_number: phone_number
        })
    }).then((response)=>{
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return response.json().catch(()=>({}));
    });
}
function $0c0a79c705228dbe$var$BackToSignIn({ t: t }) {
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
        className: "auth-backrow",
        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $50f22649d61cdefc$export$a6c7ac8248d6e38a), {
            className: "auth-link auth-link--back",
            to: "/login",
            children: [
                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e460634cb20318d4$export$2e2bcd8739ae039), {
                    "aria-hidden": "true"
                }),
                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                    children: t("back_link")
                })
            ]
        })
    });
}
function $0c0a79c705228dbe$export$2e2bcd8739ae039() {
    const { lang: lang, setLang: setLang, t: t } = (0, $c059d29b2c848302$export$5fd4b484410e2ff0)();
    const [form] = (0, $e9904e0132e26ce3$export$2e2bcd8739ae039).useForm();
    (0, $c059d29b2c848302$export$ea17b4a2d592acf1)(form, lang);
    const [loading, setLoading] = (0, $cQmXV.useState)(false);
    const [failure, setFailure] = (0, $cQmXV.useState)(null);
    /* Holds the number the request was made for. Non-null means "show the confirmation" — the
     number is needed to render it, so the two can't drift apart. */ const [sentTo, setSentTo] = (0, $cQmXV.useState)(null);
    const submit = ({ phone_number: phone_number })=>{
        const phone = phone_number.trim();
        setFailure(null);
        setLoading(true);
        $0c0a79c705228dbe$var$requestPasswordReset(phone).then(()=>setSentTo(phone)).catch((err)=>{
            /* Never claim a message was sent when it wasn't. Unconfigured and failed look the same
           to the user — both mean "can't do this right now" — but only one is worth logging.
           Either way this beats the dead button that shipped before. */ if (err.message === "NOT_CONFIGURED") console.warn("API_PASSWORD_RESET is not set; password reset cannot be requested.");
            setFailure(t("err_reset_unavailable"));
        }).finally(()=>setLoading(false));
    };
    if (sentTo) return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $c059d29b2c848302$export$2e2bcd8739ae039), {
        lang: lang,
        setLang: setLang,
        t: t,
        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
            className: "auth-form auth-form--sent",
            children: [
                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                    className: "auth-sent__icon",
                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $77ccca814b0c39fe$export$2e2bcd8739ae039), {
                        "aria-hidden": "true"
                    })
                }),
                /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                    className: "auth-form__head",
                    children: [
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("h2", {
                            className: "auth-title",
                            children: t("sent_title")
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("p", {
                            className: "auth-subtitle",
                            children: (t("sent_sub") || "").replace("{phone}", sentTo)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($0c0a79c705228dbe$var$BackToSignIn, {
                    t: t
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $c059d29b2c848302$export$2e2bcd8739ae039), {
        lang: lang,
        setLang: setLang,
        t: t,
        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039), {
            form: form,
            className: "auth-form",
            layout: "vertical",
            requiredMark: false,
            onFinish: submit,
            validateTrigger: "onChange",
            children: [
                /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                    className: "auth-form__head",
                    children: [
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("h2", {
                            className: "auth-title",
                            children: t("forgot_title")
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("p", {
                            className: "auth-subtitle",
                            children: t("forgot_sub")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                    className: "auth-fields",
                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                        name: "phone_number",
                        label: t("phone_label"),
                        rules: [
                            {
                                required: true,
                                whitespace: true,
                                message: t("err_required")
                            },
                            {
                                validator: (_, value)=>!value || $0c0a79c705228dbe$var$isPhone(value.trim()) ? Promise.resolve() : Promise.reject(new Error(t("err_phone")))
                            }
                        ],
                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0883e7f8083c01b0$export$2e2bcd8739ae039), {
                            size: "large",
                            type: "tel",
                            autoComplete: "tel",
                            autoFocus: true,
                            placeholder: t("phone_ph"),
                            onChange: ()=>setFailure(null)
                        })
                    })
                }),
                /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                    className: "auth-actions",
                    children: [
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                            className: "auth-submit",
                            type: "primary",
                            size: "large",
                            htmlType: "submit",
                            loading: loading,
                            children: t("send_btn")
                        }),
                        failure ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $dc33dcdb2d24fbd9$export$2e2bcd8739ae039), {
                            className: "auth-alert",
                            type: "warning",
                            showIcon: true,
                            title: failure,
                            role: "alert"
                        }) : null,
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($0c0a79c705228dbe$var$BackToSignIn, {
                            t: t
                        })
                    ]
                })
            ]
        })
    });
}




var $cQmXV = parcelRequire("cQmXV");










/* Roles allowed into the supervisor dashboard. Anything else authenticates but is turned away. */ const $d840257e31fd14f4$var$ALLOWED_ROLES = [
    "supervisor",
    "supervisor_manager"
];
function $d840257e31fd14f4$var$Login({ dispatch: dispatch, history: history }) {
    const { lang: lang, setLang: setLang, t: t } = (0, $c059d29b2c848302$export$5fd4b484410e2ff0)();
    const [form] = (0, $e9904e0132e26ce3$export$2e2bcd8739ae039).useForm();
    (0, $c059d29b2c848302$export$ea17b4a2d592acf1)(form, lang);
    const [loading, setLoading] = (0, $cQmXV.useState)(false);
    const [failure, setFailure] = (0, $cQmXV.useState)(null);
    const submit = ({ phone_number: phone_number, password: password })=>{
        setFailure(null);
        setLoading(true);
        (0, $c9936523dc38c641$export$73693bad9f5880b0)({
            phone_number: phone_number.trim(),
            password: password
        }).then((res)=>{
            if (!res || !res.user) {
                setFailure((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$62d0a6d9a23c818), "login_error_msg", lang));
                return;
            }
            if (!$d840257e31fd14f4$var$ALLOWED_ROLES.includes(res.user.role)) {
                setFailure(t("err_role"));
                return;
            }
            const me = {
                ...res.user,
                key: res.key,
                company: res.related?.company,
                client: res.related?.client,
                county: res.related?.county
            };
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$62d0a6d9a23c818), "login_success_msg", lang));
            dispatch((0, $cca4416321e611bf$export$596d806903d1f59e)(me));
            history.replace("/photo-review");
            /* The legacy layout reads persisted state at module scope, so a reload is still the
           reliable way to hand off after sign-in. Remove once Layout derives from the store. */ window.location.reload();
        }).catch((err)=>setFailure(String(err && err.message ? err.message : err))).finally(()=>setLoading(false));
    };
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $c059d29b2c848302$export$2e2bcd8739ae039), {
        lang: lang,
        setLang: setLang,
        t: t,
        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039), {
            form: form,
            className: "auth-form",
            layout: "vertical",
            requiredMark: false,
            onFinish: submit,
            /* onChange, not onSubmit: a field that was never touched is never validated, so a
           pristine form stays unflagged — but once an error is showing it clears as soon as
           the user fixes it, instead of sitting there until the next submit. */ validateTrigger: "onChange",
            children: [
                /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                    className: "auth-form__head",
                    children: [
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("h2", {
                            className: "auth-title",
                            children: t("signin_title")
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("p", {
                            className: "auth-subtitle",
                            children: t("signin_sub")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                    className: "auth-fields",
                    children: [
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                            name: "phone_number",
                            label: t("phone_label"),
                            rules: [
                                {
                                    required: true,
                                    whitespace: true,
                                    message: t("err_required")
                                }
                            ],
                            children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0883e7f8083c01b0$export$2e2bcd8739ae039), {
                                size: "large",
                                type: "tel",
                                autoComplete: "tel",
                                autoFocus: true,
                                placeholder: t("phone_ph"),
                                onChange: ()=>setFailure(null)
                            })
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                            name: "password",
                            label: t("password_label"),
                            rules: [
                                {
                                    required: true,
                                    message: t("err_required")
                                }
                            ],
                            children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0883e7f8083c01b0$export$2e2bcd8739ae039).Password, {
                                size: "large",
                                autoComplete: "current-password",
                                placeholder: t("password_ph"),
                                onChange: ()=>setFailure(null),
                                iconRender: (visible)=>visible ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $976919bf69465b09$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $dedc0c30730e75dc$export$2e2bcd8739ae039), {}),
                                visibilityToggle: {
                                    "aria-label": t("show_password")
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                            className: "auth-linkrow",
                            children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $50f22649d61cdefc$export$a6c7ac8248d6e38a), {
                                className: "auth-link",
                                to: "/forgot-password",
                                children: t("forgot_link")
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                    className: "auth-actions",
                    children: [
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                            className: "auth-submit",
                            type: "primary",
                            size: "large",
                            htmlType: "submit",
                            loading: loading,
                            children: t("signin_btn")
                        }),
                        failure ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $dc33dcdb2d24fbd9$export$2e2bcd8739ae039), {
                            className: "auth-alert",
                            type: "error",
                            showIcon: true,
                            title: failure,
                            role: "alert"
                        }) : null,
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("p", {
                            className: "auth-note",
                            children: t("role_note")
                        })
                    ]
                })
            ]
        })
    });
}
var $d840257e31fd14f4$export$2e2bcd8739ae039 = (0, $6f5d68f762d5488a$export$369b6b2b30582e8e)((0, $b83e93e5ef3de8b0$export$64605811ab45167f)((state)=>({
        me: state.me
    }))($d840257e31fd14f4$var$Login));


/* BI reports — the index of Power BI dashboards shared with this account.

   No mockup exists for this screen. Normative rules: docs/design/spec/. The shape is archetype A
   (spec/03#page-archetypes) with nothing to filter and nothing to select: page head → accordion.

   ONE REPORT IS MOUNTED AT A TIME (spec/03#mount-one-section-at-a-time). The page this replaced
   put every report's <iframe> on screen at once — N Power BI sessions, each loading a dataset,
   for a user who is going to read one of them. The accordion is single-open and
   `destroyOnHidden`, so collapsing a panel actually unmounts its frame.

   That is a deliberate exception to rule 3 of that section ("cache once"): a BI embed kept alive
   behind a closed panel keeps polling, so reloading on reopen costs less than the connection we
   would be holding. Everything else about the rule stands — nothing is fetched until opened.

   The open report rides in `?r=<id>`, so a reload and Back land on the same one. */ 

var $cQmXV = parcelRequire("cQmXV");



var $cQmXV = parcelRequire("cQmXV");








const $fa1c875b3ee2af88$export$6773a72e15c6c21d = [
    "wrap",
    "nowrap",
    "wrap-reverse"
];
const $fa1c875b3ee2af88$export$fc1ed670ad7f670d = [
    "flex-start",
    "flex-end",
    "start",
    "end",
    "center",
    "space-between",
    "space-around",
    "space-evenly",
    "stretch",
    "normal",
    "left",
    "right"
];
const $fa1c875b3ee2af88$export$4a0bd4174fc92cb3 = [
    "center",
    "start",
    "end",
    "flex-start",
    "flex-end",
    "self-start",
    "self-end",
    "baseline",
    "normal",
    "stretch"
];
const $fa1c875b3ee2af88$var$genClsWrap = (prefixCls, props)=>{
    const wrap = props.wrap === true ? "wrap" : props.wrap;
    return {
        [`${prefixCls}-wrap-${wrap}`]: wrap && $fa1c875b3ee2af88$export$6773a72e15c6c21d.includes(wrap)
    };
};
const $fa1c875b3ee2af88$var$genClsAlign = (prefixCls, props)=>{
    const alignCls = {};
    $fa1c875b3ee2af88$export$4a0bd4174fc92cb3.forEach((cssKey)=>{
        alignCls[`${prefixCls}-align-${cssKey}`] = props.align === cssKey;
    });
    alignCls[`${prefixCls}-align-stretch`] = !props.align && !!props.vertical;
    return alignCls;
};
const $fa1c875b3ee2af88$var$genClsJustify = (prefixCls, props)=>{
    const justifyCls = {};
    $fa1c875b3ee2af88$export$fc1ed670ad7f670d.forEach((cssKey)=>{
        justifyCls[`${prefixCls}-justify-${cssKey}`] = props.justify === cssKey;
    });
    return justifyCls;
};
const $fa1c875b3ee2af88$var$createFlexClassNames = (prefixCls, props)=>{
    return (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)({
        ...$fa1c875b3ee2af88$var$genClsWrap(prefixCls, props),
        ...$fa1c875b3ee2af88$var$genClsAlign(prefixCls, props),
        ...$fa1c875b3ee2af88$var$genClsJustify(prefixCls, props)
    });
};
var $fa1c875b3ee2af88$export$2e2bcd8739ae039 = $fa1c875b3ee2af88$var$createFlexClassNames;


const $9d0564ff4575fbc3$var$genFlexStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: {
            display: "flex",
            margin: 0,
            padding: 0,
            "&-vertical": {
                flexDirection: "column"
            },
            "&-rtl": {
                direction: "rtl"
            },
            "&:empty": {
                display: "none"
            }
        }
    };
};
const $9d0564ff4575fbc3$var$genFlexGapStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: {
            "&-gap-small": {
                gap: token.flexGapSM
            },
            "&-gap-medium, &-gap-middle": {
                gap: token.flexGap
            },
            "&-gap-large": {
                gap: token.flexGapLG
            }
        }
    };
};
const $9d0564ff4575fbc3$var$genFlexWrapStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const wrapStyle = {};
    (0, $fa1c875b3ee2af88$export$6773a72e15c6c21d).forEach((value)=>{
        wrapStyle[`${componentCls}-wrap-${value}`] = {
            flexWrap: value
        };
    });
    return wrapStyle;
};
const $9d0564ff4575fbc3$var$genAlignItemsStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const alignStyle = {};
    (0, $fa1c875b3ee2af88$export$4a0bd4174fc92cb3).forEach((value)=>{
        alignStyle[`${componentCls}-align-${value}`] = {
            alignItems: value
        };
    });
    return alignStyle;
};
const $9d0564ff4575fbc3$var$genJustifyContentStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const justifyStyle = {};
    (0, $fa1c875b3ee2af88$export$fc1ed670ad7f670d).forEach((value)=>{
        justifyStyle[`${componentCls}-justify-${value}`] = {
            justifyContent: value
        };
    });
    return justifyStyle;
};
const $9d0564ff4575fbc3$export$9ca1be8807fe0675 = ()=>({});
var $9d0564ff4575fbc3$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$51ec95de45185b42)("Flex", (token)=>{
    const { paddingXS: paddingXS, padding: padding, paddingLG: paddingLG } = token;
    const flexToken = (0, $fef50f256b80dfa5$export$4950aa0f605343fb)(token, {
        flexGapSM: paddingXS,
        flexGap: padding,
        flexGapLG: paddingLG
    });
    return [
        $9d0564ff4575fbc3$var$genFlexStyle(flexToken),
        $9d0564ff4575fbc3$var$genFlexGapStyle(flexToken),
        $9d0564ff4575fbc3$var$genFlexWrapStyle(flexToken),
        $9d0564ff4575fbc3$var$genAlignItemsStyle(flexToken),
        $9d0564ff4575fbc3$var$genJustifyContentStyle(flexToken)
    ];
}, $9d0564ff4575fbc3$export$9ca1be8807fe0675, {
    // Flex component don't apply extra font style
    // https://github.com/ant-design/ant-design/issues/46403
    resetStyle: false
});



"use client";
const $3007e7c4e76d64e0$var$Flex = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, rootClassName: rootClassName, className: className, style: style, flex: flex, gap: gap, vertical: vertical, orientation: orientation, component: Component = "div", children: children, ...othersProps } = props;
    const { flex: ctxFlex, direction: ctxDirection, getPrefixCls: getPrefixCls } = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useContext((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls("flex", customizePrefixCls);
    const [hashId, cssVarCls] = (0, $9d0564ff4575fbc3$export$2e2bcd8739ae039)(prefixCls);
    const [, mergedVertical] = (0, $78e4f9cb51a5af1c$export$550084c67147f6c4)(orientation, vertical ?? ctxFlex?.vertical);
    const mergedCls = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(className, rootClassName, ctxFlex?.className, prefixCls, hashId, cssVarCls, (0, $fa1c875b3ee2af88$export$2e2bcd8739ae039)(prefixCls, {
        ...props,
        vertical: mergedVertical
    }), {
        [`${prefixCls}-rtl`]: ctxDirection === "rtl",
        [`${prefixCls}-gap-${gap}`]: (0, $a3ff185e46cc584b$export$f5153c3888a6824e)(gap),
        [`${prefixCls}-vertical`]: mergedVertical
    });
    const mergedStyle = {
        ...ctxFlex?.style,
        ...style
    };
    if ((0, $8e2d153a3c855782$export$826fff653a329e83)(flex)) mergedStyle.flex = flex;
    if ((0, $8e2d153a3c855782$export$826fff653a329e83)(gap) && !(0, $a3ff185e46cc584b$export$f5153c3888a6824e)(gap)) mergedStyle.gap = gap;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement(Component, {
        ref: ref,
        className: mergedCls,
        style: mergedStyle,
        ...(0, $e8c5093aebad6025$export$2e2bcd8739ae039)(othersProps, [
            "justify",
            "wrap",
            "align"
        ])
    }, children);
});
var $3007e7c4e76d64e0$export$2e2bcd8739ae039 = $3007e7c4e76d64e0$var$Flex;


var $cQmXV = parcelRequire("cQmXV");




var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");
var $f53ad0c56b1af026$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($f53ad0c56b1af026$exports, "__esModule", {
    value: true
});
var $f53ad0c56b1af026$var$EditOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M257.7 752c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 000-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 009.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89zM880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32z"
                }
            }
        ]
    },
    "name": "edit",
    "theme": "outlined"
};
$f53ad0c56b1af026$exports.default = $f53ad0c56b1af026$var$EditOutlined;



function $1141984d2e96fc67$var$_extends() {
    $1141984d2e96fc67$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1141984d2e96fc67$var$_extends.apply(this, arguments);
}
const $1141984d2e96fc67$var$EditOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $1141984d2e96fc67$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($f53ad0c56b1af026$exports)))
    }));
/**![edit](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTI1Ny43IDc1MmMyIDAgNC0uMiA2LS41TDQzMS45IDcyMmMyLS40IDMuOS0xLjMgNS4zLTIuOGw0MjMuOS00MjMuOWE5Ljk2IDkuOTYgMCAwMDAtMTQuMUw2OTQuOSAxMTQuOWMtMS45LTEuOS00LjQtMi45LTcuMS0yLjlzLTUuMiAxLTcuMSAyLjlMMjU2LjggNTM4LjhjLTEuNSAxLjUtMi40IDMuMy0yLjggNS4zbC0yOS41IDE2OC4yYTMzLjUgMzMuNSAwIDAwOS40IDI5LjhjNi42IDYuNCAxNC45IDkuOSAyMy44IDkuOXptNjcuNC0xNzQuNEw2ODcuOCAyMTVsNzMuMyA3My4zLTM2Mi43IDM2Mi42LTg4LjkgMTUuNyAxNS42LTg5ek04ODAgODM2SDE0NGMtMTcuNyAwLTMyIDE0LjMtMzIgMzJ2MzZjMCA0LjQgMy42IDggOCA4aDc4NGM0LjQgMCA4LTMuNiA4LTh2LTM2YzAtMTcuNy0xNC4zLTMyLTMyLTMyeiIgLz48L3N2Zz4=) */ const $1141984d2e96fc67$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($1141984d2e96fc67$var$EditOutlined);
var $1141984d2e96fc67$export$2e2bcd8739ae039 = $1141984d2e96fc67$var$RefIcon;










var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");
var $8ed37c5d374ca53c$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($8ed37c5d374ca53c$exports, "__esModule", {
    value: true
});
var $8ed37c5d374ca53c$var$EnterOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M864 170h-60c-4.4 0-8 3.6-8 8v518H310v-73c0-6.7-7.8-10.5-13-6.3l-141.9 112a8 8 0 000 12.6l141.9 112c5.3 4.2 13 .4 13-6.3v-75h498c35.3 0 64-28.7 64-64V178c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "enter",
    "theme": "outlined"
};
$8ed37c5d374ca53c$exports.default = $8ed37c5d374ca53c$var$EnterOutlined;



function $12940bd9967e6202$var$_extends() {
    $12940bd9967e6202$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $12940bd9967e6202$var$_extends.apply(this, arguments);
}
const $12940bd9967e6202$var$EnterOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $12940bd9967e6202$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8ed37c5d374ca53c$exports)))
    }));
/**![enter](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg2NCAxNzBoLTYwYy00LjQgMC04IDMuNi04IDh2NTE4SDMxMHYtNzNjMC02LjctNy44LTEwLjUtMTMtNi4zbC0xNDEuOSAxMTJhOCA4IDAgMDAwIDEyLjZsMTQxLjkgMTEyYzUuMyA0LjIgMTMgLjQgMTMtNi4zdi03NWg0OThjMzUuMyAwIDY0LTI4LjcgNjQtNjRWMTc4YzAtNC40LTMuNi04LTgtOHoiIC8+PC9zdmc+) */ const $12940bd9967e6202$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($12940bd9967e6202$var$EnterOutlined);
var $12940bd9967e6202$export$2e2bcd8739ae039 = $12940bd9967e6202$var$RefIcon;








/*
.typography-title(@fontSize; @fontWeight; @lineHeight; @headingColor; @headingMarginBottom;) {
 margin-bottom: @headingMarginBottom;
 color: @headingColor;
 font-weight: @fontWeight;
 fontSize: @fontSize;
 line-height: @lineHeight;
}
*/ 


const $6ca0a16945f613fd$var$getTitleStyle = (fontSize, lineHeight, color, token)=>{
    const { titleMarginBottom: titleMarginBottom, fontWeightStrong: fontWeightStrong } = token;
    return {
        marginBottom: titleMarginBottom,
        color: color,
        fontWeight: fontWeightStrong,
        fontSize: fontSize,
        lineHeight: lineHeight
    };
};
const $6ca0a16945f613fd$export$83146cf7d1bec659 = (token)=>{
    const headings = [
        1,
        2,
        3,
        4,
        5
    ];
    const styles = {};
    headings.forEach((headingLevel)=>{
        styles[`
      h${headingLevel}&,
      div&-h${headingLevel},
      div&-h${headingLevel} > textarea,
      h${headingLevel}
    `] = $6ca0a16945f613fd$var$getTitleStyle(token[`fontSizeHeading${headingLevel}`], token[`lineHeightHeading${headingLevel}`], token.colorTextHeading, token);
    });
    return styles;
};
const $6ca0a16945f613fd$export$566f4066c7caac18 = (token)=>{
    const { componentCls: componentCls } = token;
    const linkCls = `${componentCls}-link`;
    return {
        [`&${linkCls}`]: {
            ...(0, $519d20bf207ce864$export$9a16e7694a707ab4)(token),
            userSelect: "text",
            [`&[disabled], &${componentCls}-disabled`]: {
                color: token.colorTextDisabled,
                cursor: "not-allowed",
                "&:active, &:hover": {
                    color: token.colorTextDisabled
                },
                "&:active": {
                    pointerEvents: "none",
                    // Action buttons (copy, edit, expand) must remain interactive even when
                    // the disabled link is being clicked, otherwise their click events get
                    // swallowed by the parent's pointer-events: none during :active.
                    [`${componentCls}-actions`]: {
                        pointerEvents: "auto"
                    }
                }
            }
        }
    };
};
const $6ca0a16945f613fd$export$977383a86f45014b = (token)=>({
        code: {
            margin: "0 0.2em",
            paddingInline: "0.4em",
            paddingBlock: "0.2em 0.1em",
            fontSize: "85%",
            fontFamily: token.fontFamilyCode,
            background: "rgba(150, 150, 150, 0.1)",
            border: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} rgba(100, 100, 100, 0.2)`,
            borderRadius: 3
        },
        kbd: {
            margin: "0 0.2em",
            paddingInline: "0.4em",
            paddingBlock: "0.15em 0.1em",
            fontSize: "90%",
            fontFamily: token.fontFamilyCode,
            background: "rgba(150, 150, 150, 0.06)",
            border: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} rgba(100, 100, 100, 0.2)`,
            borderBottomWidth: 2,
            borderRadius: 3
        },
        mark: {
            padding: 0,
            // FIXME hardcode in v4
            backgroundColor: (0, $bac0cac4764de8cf$export$c24201f7fe3571d8)[2]
        },
        "u, ins": {
            textDecoration: "underline",
            textDecorationSkipInk: "auto"
        },
        "s, del": {
            textDecoration: "line-through"
        },
        strong: {
            fontWeight: token.fontWeightStrong
        },
        // list
        "ul, ol": {
            marginInline: 0,
            marginBlock: "0 1em",
            padding: 0,
            li: {
                marginInline: "20px 0",
                marginBlock: 0,
                paddingInline: "4px 0",
                paddingBlock: 0
            }
        },
        ul: {
            listStyleType: "circle",
            ul: {
                listStyleType: "disc"
            }
        },
        ol: {
            listStyleType: "decimal"
        },
        // pre & block
        "pre, blockquote": {
            margin: "1em 0"
        },
        pre: {
            padding: "0.4em 0.6em",
            whiteSpace: "pre-wrap",
            wordWrap: "break-word",
            background: "rgba(150, 150, 150, 0.1)",
            border: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} rgba(100, 100, 100, 0.2)`,
            borderRadius: 3,
            fontFamily: token.fontFamilyCode,
            // Compatible for marked
            code: {
                display: "inline",
                margin: 0,
                padding: 0,
                fontSize: "inherit",
                fontFamily: "inherit",
                background: "transparent",
                border: 0
            }
        },
        blockquote: {
            paddingInline: "0.6em 0",
            paddingBlock: 0,
            borderInlineStart: "4px solid rgba(100, 100, 100, 0.2)",
            opacity: 0.85
        },
        // table - Follow Table component default style
        table: {
            width: "100%",
            textAlign: "start",
            borderCollapse: "separate",
            borderSpacing: 0,
            marginBlock: "1em",
            "th, td": {
                padding: (0, $05f34ed03d41967d$export$523c0b569236b342)(token.padding),
                overflowWrap: "break-word",
                borderBottom: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorSplit}`
            },
            "thead > tr:first-child > th:first-child": {
                borderStartStartRadius: token.borderRadiusLG
            },
            "thead > tr:first-child > th:last-child": {
                borderStartEndRadius: token.borderRadiusLG
            },
            "thead > tr > th": {
                textAlign: "start",
                position: "relative",
                color: token.colorTextHeading,
                fontWeight: token.fontWeightStrong,
                backgroundColor: token.colorFillAlter,
                transition: `background-color ${token.motionDurationMid} ease`,
                "&:not(:last-child)::before": {
                    position: "absolute",
                    top: "50%",
                    insetInlineEnd: 0,
                    width: 1,
                    height: "1.6em",
                    backgroundColor: token.colorSplit,
                    transform: "translateY(-50%)",
                    content: '""'
                }
            },
            "tbody > tr": {
                "> th, > td": {
                    transition: `background-color ${token.motionDurationMid} ease`
                },
                "&:hover > th, &:hover > td": {
                    backgroundColor: token.colorFillAlter
                }
            }
        }
    });
const $6ca0a16945f613fd$export$2667badb03518972 = (token)=>{
    const { componentCls: componentCls, paddingSM: paddingSM } = token;
    const inputShift = paddingSM;
    return {
        "&-edit-content": {
            position: "relative",
            "div&": {
                insetInlineStart: token.calc(token.paddingSM).mul(-1).equal(),
                insetBlockStart: token.calc(inputShift).div(-2).add(1).equal(),
                marginBottom: token.calc(inputShift).div(2).sub(2).equal()
            },
            [`${componentCls}-edit-content-confirm`]: {
                position: "absolute",
                insetInlineEnd: token.calc(token.marginXS).add(2).equal(),
                insetBlockEnd: token.marginXS,
                color: token.colorIcon,
                // default style
                fontWeight: "normal",
                fontSize: token.fontSize,
                fontStyle: "normal",
                pointerEvents: "none"
            },
            // Double the `-edit-content` class to raise this selector's specificity
            // above Input's own `textarea.ant-input { line-height: token.lineHeight }`
            // rule. Both otherwise share the same (0,1,1) specificity and Input is
            // injected after Typography, so on the raw TextArea path the Input rule
            // would win the cascade and the inherited font props below (notably
            // `line-height`) would not apply.
            [`&${componentCls}-edit-content textarea`]: {
                margin: "0!important",
                // Inherit the edited element's typography so the editing textarea
                // matches the rendered text (including customized heading tokens such
                // as `fontSizeHeading1` and the strong heading weight), keeping editing
                // WYSIWYG. Browsers do not inherit font properties for form controls by
                // default, so they are set explicitly here.
                fontSize: "inherit",
                lineHeight: "inherit",
                fontFamily: "inherit",
                fontWeight: "inherit",
                // Fix Editable Textarea flash in Firefox
                MozTransition: "none",
                height: "1em"
            }
        }
    };
};
const $6ca0a16945f613fd$export$34755446404037a5 = (token)=>({
        [`${token.componentCls}-copy-success`]: {
            "&, &:hover, &:focus": {
                color: token.colorSuccess
            }
        },
        [`${token.componentCls}-copy-icon-only`]: {
            marginInlineStart: 0
        }
    });
const $6ca0a16945f613fd$export$d9556a50eba3003b = ()=>({
        "a&-ellipsis, span&-ellipsis": {
            display: "inline-block",
            maxWidth: "100%"
        },
        "&-ellipsis-single-line": {
            ...(0, $519d20bf207ce864$export$b2b65df0d0824629),
            // https://blog.csdn.net/iefreer/article/details/50421025
            "a&, span&": {
                verticalAlign: "bottom"
            },
            "> code": {
                paddingBlock: 0,
                maxWidth: "calc(100% - 1.2em)",
                display: "inline-block",
                overflow: "hidden",
                textOverflow: "ellipsis",
                verticalAlign: "bottom",
                // https://github.com/ant-design/ant-design/issues/45953
                boxSizing: "content-box"
            }
        },
        "&-ellipsis-multiple-line": {
            display: "-webkit-box",
            overflow: "hidden",
            WebkitLineClamp: 3,
            WebkitBoxOrient: "vertical"
        }
    });


const $5981230a89bafa8d$var$genTypographyStyle = (token)=>{
    const { componentCls: componentCls, titleMarginTop: titleMarginTop } = token;
    return {
        [componentCls]: {
            color: token.colorText,
            wordBreak: "break-word",
            lineHeight: token.lineHeight,
            [`&${componentCls}-secondary, &${componentCls}-link${componentCls}-secondary`]: {
                color: token.colorTextDescription
            },
            [`&${componentCls}-success, &${componentCls}-link${componentCls}-success`]: {
                color: token.colorSuccessText
            },
            [`&${componentCls}-warning, &${componentCls}-link${componentCls}-warning`]: {
                color: token.colorWarningText
            },
            [`&${componentCls}-danger, &${componentCls}-link${componentCls}-danger`]: {
                color: token.colorErrorText,
                [`&${componentCls}-link:active, &${componentCls}-link:focus`]: {
                    color: token.colorErrorTextActive
                },
                [`&${componentCls}-link:hover`]: {
                    color: token.colorErrorTextHover
                }
            },
            [`&${componentCls}-disabled`]: {
                color: token.colorTextDisabled,
                cursor: "not-allowed",
                userSelect: "none"
            },
            "div&, p": {
                marginBottom: "1em"
            },
            ...(0, $6ca0a16945f613fd$export$83146cf7d1bec659)(token),
            [`& + h1${componentCls}, & + h2${componentCls}, & + h3${componentCls}, & + h4${componentCls}, & + h5${componentCls}`]: {
                marginTop: titleMarginTop
            },
            "div, ul, li, p, h1, h2, h3, h4, h5": {
                "+ h1, + h2, + h3, + h4, + h5": {
                    marginTop: titleMarginTop
                }
            },
            ...(0, $6ca0a16945f613fd$export$977383a86f45014b)(token),
            ...(0, $6ca0a16945f613fd$export$566f4066c7caac18)(token),
            // Operation
            [`${componentCls}-actions`]: {
                display: "inline"
            },
            [`
        ${componentCls}-expand,
        ${componentCls}-collapse,
        ${componentCls}-edit,
        ${componentCls}-copy
      `]: {
                ...(0, $519d20bf207ce864$export$9a16e7694a707ab4)(token),
                marginInlineStart: token.marginXXS
            },
            [`${componentCls}-actions-start`]: {
                [`
          ${componentCls}-expand,
          ${componentCls}-collapse,
          ${componentCls}-edit,
          ${componentCls}-copy:not(${componentCls}-copy-icon-only)
        `]: {
                    marginInlineStart: 0,
                    marginInlineEnd: token.marginXXS
                }
            },
            ...(0, $6ca0a16945f613fd$export$2667badb03518972)(token),
            ...(0, $6ca0a16945f613fd$export$34755446404037a5)(token),
            ...(0, $6ca0a16945f613fd$export$d9556a50eba3003b)(),
            "&-rtl": {
                direction: "rtl"
            }
        }
    };
};
const $5981230a89bafa8d$export$9ca1be8807fe0675 = ()=>({
        titleMarginTop: "1.2em",
        titleMarginBottom: "0.5em"
    });
var // ============================== Export ==============================
$5981230a89bafa8d$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$51ec95de45185b42)("Typography", $5981230a89bafa8d$var$genTypographyStyle, $5981230a89bafa8d$export$9ca1be8807fe0675);


"use client";
const $c95d6280031c1235$var$Editable = (props)=>{
    const { prefixCls: prefixCls, "aria-label": ariaLabel, className: className, style: style, classNames: classNames, styles: styles, direction: direction, maxLength: maxLength, autoSize: autoSize = true, value: value, onSave: onSave, onCancel: onCancel, onEnd: onEnd, component: component, enterIcon: enterIcon = /*#__PURE__*/ $cQmXV.createElement((0, $12940bd9967e6202$export$2e2bcd8739ae039), null) } = props;
    const ref = $cQmXV.useRef(null);
    const inCompositionRef = $cQmXV.useRef(false);
    const lastKeyCodeRef = $cQmXV.useRef(null);
    const [current, setCurrent] = $cQmXV.useState(value);
    $cQmXV.useEffect(()=>{
        setCurrent(value);
    }, [
        value
    ]);
    $cQmXV.useEffect(()=>{
        if (ref.current?.resizableTextArea) {
            const { textArea: textArea } = ref.current.resizableTextArea;
            textArea.focus();
            const { length: length } = textArea.value;
            textArea.setSelectionRange(length, length);
        }
    }, []);
    const onChange = ({ target: target })=>{
        setCurrent(target.value.replace(/[\n\r]/g, ""));
    };
    const onCompositionStart = ()=>{
        inCompositionRef.current = true;
    };
    const onCompositionEnd = ()=>{
        inCompositionRef.current = false;
    };
    const onKeyDown = ({ keyCode: keyCode })=>{
        // We don't record keyCode when IME is using
        if (inCompositionRef.current) return;
        lastKeyCodeRef.current = keyCode;
    };
    const confirmChange = ()=>{
        onSave(current.trim());
    };
    const onKeyUp = ({ keyCode: keyCode, ctrlKey: ctrlKey, altKey: altKey, metaKey: metaKey, shiftKey: shiftKey })=>{
        // Check if it's a real key
        if (lastKeyCodeRef.current !== keyCode || inCompositionRef.current || ctrlKey || altKey || metaKey || shiftKey) return;
        if (keyCode === (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).ENTER) {
            confirmChange();
            onEnd?.();
        } else if (keyCode === (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).ESC) onCancel();
    };
    const onBlur = ()=>{
        confirmChange();
    };
    const [hashId, cssVarCls] = (0, $5981230a89bafa8d$export$2e2bcd8739ae039)(prefixCls);
    const textAreaClassName = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-edit-content`, {
        [`${prefixCls}-rtl`]: direction === "rtl",
        [`${prefixCls}-${component}`]: !!component
    }, className, classNames.root, hashId, cssVarCls);
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        className: textAreaClassName,
        style: {
            ...styles.root,
            ...style
        }
    }, /*#__PURE__*/ $cQmXV.createElement((0, $685f39e72eec13cf$export$2e2bcd8739ae039), {
        ref: ref,
        maxLength: maxLength,
        value: current,
        onChange: onChange,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onCompositionStart: onCompositionStart,
        onCompositionEnd: onCompositionEnd,
        onBlur: onBlur,
        "aria-label": ariaLabel,
        rows: 1,
        autoSize: autoSize,
        className: classNames.textarea,
        style: styles.textarea
    }), enterIcon !== null ? (0, $a91ef204d03d8eec$export$e530037191fcd5d7)(enterIcon, {
        className: `${prefixCls}-edit-content-confirm`
    }) : null);
};
var $c95d6280031c1235$export$2e2bcd8739ae039 = $c95d6280031c1235$var$Editable;



var $cQmXV = parcelRequire("cQmXV");


const $54b2fe0c82ad220e$var$execCopy = (text, isHtmlFormat)=>{
    let copySuccess = false;
    const onCopy = (event)=>{
        event.stopPropagation();
        event.preventDefault();
        event.clipboardData?.clearData();
        event.clipboardData?.setData("text/plain", text);
        if (isHtmlFormat) event.clipboardData?.setData("text/html", text);
        copySuccess = true;
    };
    try {
        document.addEventListener("copy", onCopy, {
            capture: true
        });
        document.execCommand("copy");
        return copySuccess;
    } catch  {
        return false;
    } finally{
        document.removeEventListener("copy", onCopy, {
            capture: true
        });
    }
};
const $54b2fe0c82ad220e$var$asyncCopy = async (text, isHtmlFormat)=>{
    try {
        if (isHtmlFormat) await navigator.clipboard.write([
            new ClipboardItem({
                "text/html": new Blob([
                    text
                ], {
                    type: "text/html"
                }),
                "text/plain": new Blob([
                    text
                ], {
                    type: "text/plain"
                })
            })
        ]);
        else await navigator.clipboard.writeText(text);
        return true;
    } catch  {
        return false;
    }
};
async function $54b2fe0c82ad220e$var$copy(text, config) {
    if (typeof text !== "string") return false;
    const isHtmlFormat = config?.format === "text/html";
    if (await $54b2fe0c82ad220e$var$asyncCopy(text, isHtmlFormat)) return true;
    if ($54b2fe0c82ad220e$var$execCopy(text, isHtmlFormat)) return true;
    return false;
}
var $54b2fe0c82ad220e$export$2e2bcd8739ae039 = $54b2fe0c82ad220e$var$copy;




const $ea73fca50b756fae$var$toList = (val, config = {})=>{
    if (!(0, $8e2d153a3c855782$export$826fff653a329e83)(val) && config?.skipEmpty) return [];
    return Array.isArray(val) ? val : [
        val
    ];
};
var $ea73fca50b756fae$export$2e2bcd8739ae039 = $ea73fca50b756fae$var$toList;


const $c9b227d02f191d02$var$useCopyClick = ({ copyConfig: copyConfig, children: children })=>{
    const [copied, setCopied] = (0, $f0cf805f93abd5af$export$2e2bcd8739ae039)(false);
    const [copyLoading, setCopyLoading] = $cQmXV.useState(false);
    const copyOptions = {};
    if (copyConfig.format) copyOptions.format = copyConfig.format;
    // Keep copy action up to date
    const onClick = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)(async (e)=>{
        e?.preventDefault();
        e?.stopPropagation();
        setCopyLoading(true);
        try {
            const text = (0, $8e2d153a3c855782$export$f6e2535fb5126e54)(copyConfig.text) ? await copyConfig.text() : copyConfig.text;
            await (0, $54b2fe0c82ad220e$export$2e2bcd8739ae039)(text || (0, $ea73fca50b756fae$export$2e2bcd8739ae039)(children, {
                skipEmpty: true
            }).join("") || "", copyOptions);
            setCopyLoading(false);
            setCopied(true, true);
            // Trigger tips update
            setCopied(false, {
                ms: 3000
            });
            copyConfig.onCopy?.(e);
        } catch (error) {
            setCopyLoading(false);
            throw error;
        }
    });
    return {
        copied: copied,
        copyLoading: copyLoading,
        onClick: onClick
    };
};
var $c9b227d02f191d02$export$2e2bcd8739ae039 = $c9b227d02f191d02$var$useCopyClick;



var $cQmXV = parcelRequire("cQmXV");

const $ad4664532a52a675$var$useMergedConfig = (propConfig, templateConfig)=>{
    const support = Boolean(propConfig);
    return $cQmXV.useMemo(()=>{
        const config = {
            ...templateConfig,
            ...support && (0, $8e2d153a3c855782$export$53b83ca8eaab0383)(propConfig) ? propConfig : null
        };
        return [
            support,
            config
        ];
    }, [
        support,
        propConfig,
        templateConfig
    ]);
};
var $ad4664532a52a675$export$2e2bcd8739ae039 = $ad4664532a52a675$var$useMergedConfig;



var $cQmXV = parcelRequire("cQmXV");
const $a30f10b8815fa84a$var$usePrevious = (value)=>{
    const ref = (0, $cQmXV.useRef)(undefined);
    (0, $cQmXV.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
};
var $a30f10b8815fa84a$export$2e2bcd8739ae039 = $a30f10b8815fa84a$var$usePrevious;



var $cQmXV = parcelRequire("cQmXV");

const $ff97ca84904a1e58$var$useTooltipProps = (tooltip, editConfigText, children)=>(0, $cQmXV.useMemo)(()=>{
        if (tooltip === true) return {
            title: editConfigText ?? children
        };
        if (/*#__PURE__*/ (0, $cQmXV.isValidElement)(tooltip)) return {
            title: tooltip
        };
        if ((0, $8e2d153a3c855782$export$53b83ca8eaab0383)(tooltip)) return {
            title: editConfigText ?? children,
            ...tooltip
        };
        return {
            title: tooltip
        };
    }, [
        tooltip,
        editConfigText,
        children
    ]);
var $ff97ca84904a1e58$export$2e2bcd8739ae039 = $ff97ca84904a1e58$var$useTooltipProps;



var $cQmXV = parcelRequire("cQmXV");


const $d1878575e482e128$export$b5d9abe3479853dc = (customizePrefixCls, classNames, styles, typographyDirection, props)=>{
    const { getPrefixCls: getPrefixCls, direction: contextDirection, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("typography");
    const direction = typographyDirection ?? contextDirection;
    const prefixCls = getPrefixCls("typography", customizePrefixCls);
    const mergedProps = {
        ...props,
        prefixCls: prefixCls,
        direction: direction
    };
    const contextClassNamesObject = (0, $cQmXV.useMemo)(()=>({
            root: contextClassName
        }), [
        contextClassName
    ]);
    const contextStyleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(contextStyle);
    const [mergedClassNames, mergedStyles] = (0, $30c5f9f911d4f61b$export$648566b068f28737)([
        contextClassNamesObject,
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles
    ], {
        props: mergedProps
    });
    return [
        mergedClassNames,
        mergedStyles,
        prefixCls,
        direction
    ];
};



var $cQmXV = parcelRequire("cQmXV");



"use client";
const $585794d93a3a7525$export$eb9bd2b66ef4fd8d = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { component: Component = "article", className: className, rootClassName: rootClassName, children: children, direction: direction, style: style, classNames: classNames, styles: styles, prefixCls: prefixCls, ...restProps } = props;
    const [hashId, cssVarCls] = (0, $5981230a89bafa8d$export$2e2bcd8739ae039)(prefixCls);
    const componentClassName = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, {
        [`${prefixCls}-rtl`]: direction === "rtl"
    }, className, rootClassName, hashId, cssVarCls, classNames?.root);
    const mergedStyle = {
        ...styles?.root,
        ...style
    };
    return /*#__PURE__*/ $cQmXV.createElement(Component, {
        ...restProps,
        className: componentClassName,
        style: mergedStyle,
        ref: ref
    }, children);
});
const $585794d93a3a7525$var$Typography = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, direction: typographyDirection, classNames: classNames, styles: styles, ...restProps } = props;
    const [mergedClassNames, mergedStyles, mergedPrefixCls, mergedDirection] = (0, $d1878575e482e128$export$b5d9abe3479853dc)(customizePrefixCls, classNames, styles, typographyDirection, props);
    return /*#__PURE__*/ $cQmXV.createElement($585794d93a3a7525$export$eb9bd2b66ef4fd8d, {
        ref: ref,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(className, rootClassName),
        direction: mergedDirection,
        classNames: mergedClassNames,
        styles: mergedStyles,
        prefixCls: mergedPrefixCls,
        ...restProps
    });
});
var $585794d93a3a7525$export$2e2bcd8739ae039 = $585794d93a3a7525$var$Typography;



var $cQmXV = parcelRequire("cQmXV");


var $cQmXV = parcelRequire("cQmXV");
var $f3a564d37650c59b$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($f3a564d37650c59b$exports, "__esModule", {
    value: true
});
var $f3a564d37650c59b$var$CopyOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z"
                }
            }
        ]
    },
    "name": "copy",
    "theme": "outlined"
};
$f3a564d37650c59b$exports.default = $f3a564d37650c59b$var$CopyOutlined;



function $37ec80fabde4926c$var$_extends() {
    $37ec80fabde4926c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $37ec80fabde4926c$var$_extends.apply(this, arguments);
}
const $37ec80fabde4926c$var$CopyOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $37ec80fabde4926c$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($f3a564d37650c59b$exports)))
    }));
/**![copy](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTgzMiA2NEgyOTZjLTQuNCAwLTggMy42LTggOHY1NmMwIDQuNCAzLjYgOCA4IDhoNDk2djY4OGMwIDQuNCAzLjYgOCA4IDhoNTZjNC40IDAgOC0zLjYgOC04Vjk2YzAtMTcuNy0xNC4zLTMyLTMyLTMyek03MDQgMTkySDE5MmMtMTcuNyAwLTMyIDE0LjMtMzIgMzJ2NTMwLjdjMCA4LjUgMy40IDE2LjYgOS40IDIyLjZsMTczLjMgMTczLjNjMi4yIDIuMiA0LjcgNCA3LjQgNS41djEuOWg0LjJjMy41IDEuMyA3LjIgMiAxMSAySDcwNGMxNy43IDAgMzItMTQuMyAzMi0zMlYyMjRjMC0xNy43LTE0LjMtMzItMzItMzJ6TTM1MCA4NTYuMkwyNjMuOSA3NzBIMzUwdjg2LjJ6TTY2NCA4ODhINDE0Vjc0NmMwLTIyLjEtMTcuOS00MC00MC00MEgyMzJWMjY0aDQzMnY2MjR6IiAvPjwvc3ZnPg==) */ const $37ec80fabde4926c$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($37ec80fabde4926c$var$CopyOutlined);
var $37ec80fabde4926c$export$2e2bcd8739ae039 = $37ec80fabde4926c$var$RefIcon;






const $7a263d04e13355d8$export$54c946ade31abb75 = (val)=>{
    if (val === false) return [
        false,
        false
    ];
    return (0, $ea73fca50b756fae$export$2e2bcd8739ae039)(val);
};
function $7a263d04e13355d8$export$3f778c4e796a1f9c(dom, defaultNode, needDom) {
    if (dom === true || dom === undefined) return defaultNode;
    return dom || needDom && defaultNode;
}
function $7a263d04e13355d8$export$5714fcf57d9d6988(ele) {
    // Create a new div to get the size
    const childDiv = document.createElement("em");
    ele.appendChild(childDiv);
    const rect = ele.getBoundingClientRect();
    const childRect = childDiv.getBoundingClientRect();
    // Reset
    ele.removeChild(childDiv);
    // Range checker
    return(// Horizontal out of range
    rect.left > childRect.left || childRect.right > rect.right || // Vertical out of range
    rect.top > childRect.top || childRect.bottom > rect.bottom);
}
const $7a263d04e13355d8$export$a748c1acb7702f51 = (val)=>[
        "string",
        "number"
    ].includes(typeof val);


"use client";
const $afd9b7f31912c716$var$CopyBtn = (props)=>{
    const { prefixCls: prefixCls, copied: copied, locale: locale, iconOnly: iconOnly, tooltips: tooltips, icon: icon, tabIndex: tabIndex, onCopy: onCopy, loading: btnLoading, className: className, style: style } = props;
    const tooltipNodes = (0, $7a263d04e13355d8$export$54c946ade31abb75)(tooltips);
    const iconNodes = (0, $7a263d04e13355d8$export$54c946ade31abb75)(icon);
    const { copied: copiedText, copy: copyText } = locale ?? {};
    const systemStr = copied ? copiedText : copyText;
    const copyTitle = (0, $7a263d04e13355d8$export$3f778c4e796a1f9c)(tooltipNodes[copied ? 1 : 0], systemStr);
    const ariaLabel = typeof copyTitle === "string" ? copyTitle : systemStr;
    return /*#__PURE__*/ $cQmXV.createElement((0, $1e5256cf9d329b2c$export$2e2bcd8739ae039), {
        title: copyTitle
    }, /*#__PURE__*/ $cQmXV.createElement("button", {
        type: "button",
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-copy`, className, {
            [`${prefixCls}-copy-success`]: copied,
            [`${prefixCls}-copy-icon-only`]: iconOnly
        }),
        style: style,
        onClick: onCopy,
        "aria-label": ariaLabel,
        tabIndex: tabIndex
    }, copied ? (0, $7a263d04e13355d8$export$3f778c4e796a1f9c)(iconNodes[1], /*#__PURE__*/ $cQmXV.createElement((0, $77ccca814b0c39fe$export$2e2bcd8739ae039), null), true) : (0, $7a263d04e13355d8$export$3f778c4e796a1f9c)(iconNodes[0], btnLoading ? /*#__PURE__*/ $cQmXV.createElement((0, $bf7996ca956facd7$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $cQmXV.createElement((0, $37ec80fabde4926c$export$2e2bcd8739ae039), null), true)));
};
var $afd9b7f31912c716$export$2e2bcd8739ae039 = $afd9b7f31912c716$var$CopyBtn;




var $cQmXV = parcelRequire("cQmXV");


"use client";
const $a98b3fe2918d31b2$var$MeasureText = /*#__PURE__*/ $cQmXV.forwardRef(({ style: style, children: children }, ref)=>{
    const spanRef = $cQmXV.useRef(null);
    $cQmXV.useImperativeHandle(ref, ()=>({
            isExceed: ()=>{
                const span = spanRef.current;
                return span.scrollHeight > span.clientHeight;
            },
            getHeight: ()=>spanRef.current.clientHeight
        }));
    return /*#__PURE__*/ $cQmXV.createElement("span", {
        "aria-hidden": true,
        ref: spanRef,
        style: {
            position: "fixed",
            display: "block",
            left: 0,
            top: 0,
            pointerEvents: "none",
            backgroundColor: "rgba(255, 0, 0, 0.65)",
            ...style
        }
    }, children);
});
const $a98b3fe2918d31b2$var$getNodesLen = (nodeList)=>nodeList.reduce((totalLen, node)=>totalLen + ((0, $7a263d04e13355d8$export$a748c1acb7702f51)(node) ? String(node).length : 1), 0);
function $a98b3fe2918d31b2$var$sliceNodes(nodeList, len) {
    let currLen = 0;
    const currentNodeList = [];
    for(let i = 0; i < nodeList.length; i += 1){
        // Match to return
        if (currLen === len) return currentNodeList;
        const node = nodeList[i];
        const canCut = (0, $7a263d04e13355d8$export$a748c1acb7702f51)(node);
        const nodeLen = canCut ? String(node).length : 1;
        const nextLen = currLen + nodeLen;
        // Exceed but current not which means we need cut this
        // This will not happen on validate ReactElement
        if (nextLen > len) {
            const restLen = len - currLen;
            currentNodeList.push(String(node).slice(0, restLen));
            return currentNodeList;
        }
        currentNodeList.push(node);
        currLen = nextLen;
    }
    return nodeList;
}
// Measure for the `text` is exceed the `rows` or not
const $a98b3fe2918d31b2$var$STATUS_MEASURE_NONE = 0;
const $a98b3fe2918d31b2$var$STATUS_MEASURE_PREPARE = 1;
const $a98b3fe2918d31b2$var$STATUS_MEASURE_START = 2;
const $a98b3fe2918d31b2$var$STATUS_MEASURE_NEED_ELLIPSIS = 3;
const $a98b3fe2918d31b2$var$STATUS_MEASURE_NO_NEED_ELLIPSIS = 4;
const $a98b3fe2918d31b2$var$lineClipStyle = {
    display: "-webkit-box",
    overflow: "hidden",
    WebkitBoxOrient: "vertical"
};
function $a98b3fe2918d31b2$export$2e2bcd8739ae039(props) {
    const { enableMeasure: enableMeasure, width: width, text: text, children: children, rows: rows, expanded: expanded, measureDeps: measureDeps, miscDeps: miscDeps, onEllipsis: onEllipsis } = props;
    const nodeList = $cQmXV.useMemo(()=>(0, $cd966a313e0a92ff$export$2e2bcd8739ae039)(text), [
        text
    ]);
    const nodeLen = $cQmXV.useMemo(()=>$a98b3fe2918d31b2$var$getNodesLen(nodeList), [
        text
    ]);
    // ========================= Full Content =========================
    // Used for measure only, which means it's always render as no need ellipsis
    const fullContent = $cQmXV.useMemo(()=>children(nodeList, false), [
        text
    ].concat((0, $68381b18b974dc9f$export$2e2bcd8739ae039)(measureDeps)));
    // ========================= Cut Content ==========================
    const [ellipsisCutIndex, setEllipsisCutIndex] = $cQmXV.useState(null);
    const cutMidRef = $cQmXV.useRef(null);
    // ========================= NeedEllipsis =========================
    const measureWhiteSpaceRef = $cQmXV.useRef(null);
    const needEllipsisRef = $cQmXV.useRef(null);
    // Measure for `rows-1` height, to avoid operation exceed the line height
    const descRowsEllipsisRef = $cQmXV.useRef(null);
    const symbolRowEllipsisRef = $cQmXV.useRef(null);
    const [canEllipsis, setCanEllipsis] = $cQmXV.useState(false);
    const [needEllipsis, setNeedEllipsis] = $cQmXV.useState($a98b3fe2918d31b2$var$STATUS_MEASURE_NONE);
    const [ellipsisHeight, setEllipsisHeight] = $cQmXV.useState(0);
    const [parentWhiteSpace, setParentWhiteSpace] = $cQmXV.useState(null);
    // Trigger start measure
    (0, $7673d874dab69d07$export$2e2bcd8739ae039)(()=>{
        if (enableMeasure && width && nodeLen) setNeedEllipsis($a98b3fe2918d31b2$var$STATUS_MEASURE_PREPARE);
        else setNeedEllipsis($a98b3fe2918d31b2$var$STATUS_MEASURE_NONE);
    }, [
        width,
        text,
        rows,
        enableMeasure,
        nodeList
    ].concat((0, $68381b18b974dc9f$export$2e2bcd8739ae039)(measureDeps)));
    // Measure process
    (0, $7673d874dab69d07$export$2e2bcd8739ae039)(()=>{
        if (needEllipsis === $a98b3fe2918d31b2$var$STATUS_MEASURE_PREPARE) {
            setNeedEllipsis($a98b3fe2918d31b2$var$STATUS_MEASURE_START);
            // Parent ref `white-space`
            const nextWhiteSpace = measureWhiteSpaceRef.current && getComputedStyle(measureWhiteSpaceRef.current).whiteSpace;
            setParentWhiteSpace(nextWhiteSpace);
        } else if (needEllipsis === $a98b3fe2918d31b2$var$STATUS_MEASURE_START) {
            const isOverflow = !!needEllipsisRef.current?.isExceed();
            setNeedEllipsis(isOverflow ? $a98b3fe2918d31b2$var$STATUS_MEASURE_NEED_ELLIPSIS : $a98b3fe2918d31b2$var$STATUS_MEASURE_NO_NEED_ELLIPSIS);
            setEllipsisCutIndex(isOverflow ? [
                0,
                nodeLen
            ] : null);
            setCanEllipsis(isOverflow);
            // Get the basic height of ellipsis rows
            const baseRowsEllipsisHeight = needEllipsisRef.current?.getHeight() || 0;
            // Get the height of `rows - 1` + symbol height
            const descRowsEllipsisHeight = rows === 1 ? 0 : descRowsEllipsisRef.current?.getHeight() || 0;
            const symbolRowEllipsisHeight = symbolRowEllipsisRef.current?.getHeight() || 0;
            const maxRowsHeight = Math.max(baseRowsEllipsisHeight, // height of rows with ellipsis
            descRowsEllipsisHeight + symbolRowEllipsisHeight);
            setEllipsisHeight(maxRowsHeight + 1);
            onEllipsis(isOverflow);
        }
    }, [
        needEllipsis
    ]);
    // ========================= Cut Measure ==========================
    const cutMidIndex = ellipsisCutIndex ? Math.ceil((ellipsisCutIndex[0] + ellipsisCutIndex[1]) / 2) : 0;
    (0, $7673d874dab69d07$export$2e2bcd8739ae039)(()=>{
        const [minIndex, maxIndex] = ellipsisCutIndex || [
            0,
            0
        ];
        if (minIndex !== maxIndex) {
            const midHeight = cutMidRef.current?.getHeight() || 0;
            const isOverflow = midHeight > ellipsisHeight;
            let targetMidIndex = cutMidIndex;
            if (maxIndex - minIndex === 1) targetMidIndex = isOverflow ? minIndex : maxIndex;
            setEllipsisCutIndex(isOverflow ? [
                minIndex,
                targetMidIndex
            ] : [
                targetMidIndex,
                maxIndex
            ]);
        }
    }, [
        ellipsisCutIndex,
        cutMidIndex
    ]);
    // ========================= Text Content =========================
    const finalContent = $cQmXV.useMemo(()=>{
        // Skip everything if `enableMeasure` is disabled
        if (!enableMeasure) return children(nodeList, false);
        if (needEllipsis !== $a98b3fe2918d31b2$var$STATUS_MEASURE_NEED_ELLIPSIS || !ellipsisCutIndex || ellipsisCutIndex[0] !== ellipsisCutIndex[1]) {
            const content = children(nodeList, false);
            // Limit the max line count to avoid scrollbar blink unless no need ellipsis
            // https://github.com/ant-design/ant-design/issues/42958
            if ([
                $a98b3fe2918d31b2$var$STATUS_MEASURE_NO_NEED_ELLIPSIS,
                $a98b3fe2918d31b2$var$STATUS_MEASURE_NONE
            ].includes(needEllipsis)) return content;
            return /*#__PURE__*/ $cQmXV.createElement("span", {
                style: {
                    ...$a98b3fe2918d31b2$var$lineClipStyle,
                    WebkitLineClamp: rows
                }
            }, content);
        }
        return children(expanded ? nodeList : $a98b3fe2918d31b2$var$sliceNodes(nodeList, ellipsisCutIndex[0]), canEllipsis);
    }, [
        expanded,
        needEllipsis,
        ellipsisCutIndex,
        nodeList
    ].concat((0, $68381b18b974dc9f$export$2e2bcd8739ae039)(miscDeps)));
    // ============================ Render ============================
    const measureStyle = {
        width: width,
        margin: 0,
        padding: 0,
        whiteSpace: parentWhiteSpace === "nowrap" ? "normal" : "inherit"
    };
    return /*#__PURE__*/ $cQmXV.createElement($cQmXV.Fragment, null, finalContent, needEllipsis === $a98b3fe2918d31b2$var$STATUS_MEASURE_START && /*#__PURE__*/ $cQmXV.createElement($cQmXV.Fragment, null, /*#__PURE__*/ $cQmXV.createElement($a98b3fe2918d31b2$var$MeasureText, {
        style: {
            ...measureStyle,
            ...$a98b3fe2918d31b2$var$lineClipStyle,
            WebkitLineClamp: rows
        },
        ref: needEllipsisRef
    }, fullContent), /*#__PURE__*/ $cQmXV.createElement($a98b3fe2918d31b2$var$MeasureText, {
        style: {
            ...measureStyle,
            ...$a98b3fe2918d31b2$var$lineClipStyle,
            WebkitLineClamp: rows - 1
        },
        ref: descRowsEllipsisRef
    }, fullContent), /*#__PURE__*/ $cQmXV.createElement($a98b3fe2918d31b2$var$MeasureText, {
        style: {
            ...measureStyle,
            ...$a98b3fe2918d31b2$var$lineClipStyle,
            WebkitLineClamp: 1
        },
        ref: symbolRowEllipsisRef
    }, children([], true))), needEllipsis === $a98b3fe2918d31b2$var$STATUS_MEASURE_NEED_ELLIPSIS && ellipsisCutIndex && ellipsisCutIndex[0] !== ellipsisCutIndex[1] && /*#__PURE__*/ $cQmXV.createElement($a98b3fe2918d31b2$var$MeasureText, {
        style: {
            ...measureStyle,
            top: 400
        },
        ref: cutMidRef
    }, children($a98b3fe2918d31b2$var$sliceNodes(nodeList, cutMidIndex), true)), needEllipsis === $a98b3fe2918d31b2$var$STATUS_MEASURE_PREPARE && /*#__PURE__*/ $cQmXV.createElement("span", {
        style: {
            whiteSpace: "inherit"
        },
        ref: measureWhiteSpaceRef
    }));
}



var $cQmXV = parcelRequire("cQmXV");

"use client";
const $3b814dc30ebebbe4$var$EllipsisTooltip = ({ enableEllipsis: enableEllipsis, isEllipsis: isEllipsis, disabled: disabled, children: children, tooltipProps: tooltipProps })=>{
    if (!tooltipProps?.title || !enableEllipsis) return children;
    return /*#__PURE__*/ $cQmXV.createElement((0, $1e5256cf9d329b2c$export$2e2bcd8739ae039), {
        ...tooltipProps,
        disabled: !isEllipsis || disabled
    }, children);
};
var $3b814dc30ebebbe4$export$2e2bcd8739ae039 = $3b814dc30ebebbe4$var$EllipsisTooltip;



"use client";
function $55a17c4ad8e08183$var$wrapperDecorations({ mark: mark, code: code, underline: underline, delete: del, strong: strong, keyboard: keyboard, italic: italic }, content) {
    let currentContent = content;
    function wrap(tag, needed) {
        if (!needed) return;
        currentContent = /*#__PURE__*/ $cQmXV.createElement(tag, {}, currentContent);
    }
    wrap("strong", strong);
    wrap("u", underline);
    wrap("del", del);
    wrap("code", code);
    wrap("mark", mark);
    wrap("kbd", keyboard);
    wrap("i", italic);
    return currentContent;
}
const $55a17c4ad8e08183$var$ELLIPSIS_STR = "...";
const $55a17c4ad8e08183$var$DECORATION_PROPS = [
    "delete",
    "mark",
    "code",
    "underline",
    "strong",
    "keyboard",
    "italic"
];
const $55a17c4ad8e08183$var$Base = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, className: className, style: style, classNames: classNames, styles: styles, direction: typographyDirection, type: type, disabled: disabled, children: children, ellipsis: ellipsis, editable: editable, copyable: copyable, actions: actions, component: component, title: title, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, ...restProps } = props;
    const [textLocale] = (0, $c953dac9d015386e$export$2e2bcd8739ae039)("Text");
    const typographyRef = $cQmXV.useRef(null);
    const editIconRef = $cQmXV.useRef(null);
    const [mergedClassNames, mergedStyles, prefixCls, direction] = (0, $d1878575e482e128$export$b5d9abe3479853dc)(customizePrefixCls, classNames, styles, typographyDirection, props);
    const textProps = (0, $e8c5093aebad6025$export$2e2bcd8739ae039)(restProps, $55a17c4ad8e08183$var$DECORATION_PROPS);
    // ========================== Editable ==========================
    const [enableEdit, editConfig] = (0, $ad4664532a52a675$export$2e2bcd8739ae039)(editable);
    const [editing, setEditing] = (0, $a51866d781137e08$export$2e2bcd8739ae039)(false, editConfig.editing);
    const { triggerType: triggerType = [
        "icon"
    ] } = editConfig;
    const triggerEdit = (edit)=>{
        if (edit) editConfig.onStart?.();
        setEditing(edit);
    };
    // Focus edit icon when back
    const prevEditing = (0, $a30f10b8815fa84a$export$2e2bcd8739ae039)(editing);
    (0, $7673d874dab69d07$export$2e2bcd8739ae039)(()=>{
        if (!editing && prevEditing) editIconRef.current?.focus();
    }, [
        editing
    ]);
    const onEditClick = (e)=>{
        e?.preventDefault();
        triggerEdit(true);
    };
    const onEditChange = (value)=>{
        editConfig.onChange?.(value);
        triggerEdit(false);
    };
    const onEditCancel = ()=>{
        editConfig.onCancel?.();
        triggerEdit(false);
    };
    // ========================== Copyable ==========================
    const [enableCopy, copyConfig] = (0, $ad4664532a52a675$export$2e2bcd8739ae039)(copyable);
    const { placement: placement = "end" } = actions ?? {};
    const { copied: copied, copyLoading: copyLoading, onClick: onCopyClick } = (0, $c9b227d02f191d02$export$2e2bcd8739ae039)({
        copyConfig: copyConfig,
        children: children
    });
    // ========================== Ellipsis ==========================
    const [isLineClampSupport, setIsLineClampSupport] = $cQmXV.useState(false);
    const [isTextOverflowSupport, setIsTextOverflowSupport] = $cQmXV.useState(false);
    const [isJsEllipsis, setIsJsEllipsis] = $cQmXV.useState(false);
    const [isNativeEllipsis, setIsNativeEllipsis] = $cQmXV.useState(false);
    const [isNativeVisible, setIsNativeVisible] = $cQmXV.useState(true);
    const [enableEllipsis, ellipsisConfig] = (0, $ad4664532a52a675$export$2e2bcd8739ae039)(ellipsis, {
        expandable: false,
        symbol: (isExpanded)=>isExpanded ? textLocale?.collapse : textLocale?.expand
    });
    const [expanded, setExpanded] = (0, $a51866d781137e08$export$2e2bcd8739ae039)(ellipsisConfig.defaultExpanded || false, ellipsisConfig.expanded);
    const mergedEnableEllipsis = enableEllipsis && (!expanded || ellipsisConfig.expandable === "collapsible");
    // Shared prop to reduce bundle size
    const { rows: rows = 1 } = ellipsisConfig;
    const needMeasureEllipsis = $cQmXV.useMemo(()=>// Disable ellipsis
        mergedEnableEllipsis && // Provide suffix
        (ellipsisConfig.suffix !== undefined || ellipsisConfig.onEllipsis || // Can't use css ellipsis since we need to provide the place for button
        ellipsisConfig.expandable || enableEdit || enableCopy), [
        mergedEnableEllipsis,
        ellipsisConfig,
        enableEdit,
        enableCopy
    ]);
    (0, $7673d874dab69d07$export$2e2bcd8739ae039)(()=>{
        if (enableEllipsis && !needMeasureEllipsis) {
            setIsLineClampSupport((0, $c2057eea61f67d6e$export$d616d7831008e86c)("webkitLineClamp"));
            setIsTextOverflowSupport((0, $c2057eea61f67d6e$export$d616d7831008e86c)("textOverflow"));
        }
    }, [
        needMeasureEllipsis,
        enableEllipsis
    ]);
    const [cssEllipsis, setCssEllipsis] = $cQmXV.useState(mergedEnableEllipsis);
    const canUseCssEllipsis = $cQmXV.useMemo(()=>{
        if (needMeasureEllipsis) return false;
        if (rows === 1) return isTextOverflowSupport;
        return isLineClampSupport;
    }, [
        needMeasureEllipsis,
        rows,
        isLineClampSupport,
        isTextOverflowSupport
    ]);
    // We use effect to change from css ellipsis to js ellipsis.
    // To make SSR still can see the ellipsis.
    (0, $7673d874dab69d07$export$2e2bcd8739ae039)(()=>{
        setCssEllipsis(canUseCssEllipsis && mergedEnableEllipsis);
    }, [
        canUseCssEllipsis,
        mergedEnableEllipsis
    ]);
    const tooltipProps = (0, $ff97ca84904a1e58$export$2e2bcd8739ae039)(ellipsisConfig.tooltip, editConfig.text, children);
    const needNativeEllipsisMeasure = cssEllipsis && !!tooltipProps.title;
    const isMergedEllipsis = mergedEnableEllipsis && (cssEllipsis ? needNativeEllipsisMeasure && isNativeEllipsis : isJsEllipsis);
    const cssTextOverflow = mergedEnableEllipsis && rows === 1 && cssEllipsis;
    const cssLineClamp = mergedEnableEllipsis && rows > 1 && cssEllipsis;
    // >>>>> Expand
    const onExpandClick = (e, info)=>{
        setExpanded(info.expanded);
        ellipsisConfig.onExpand?.(e, info);
    };
    const [ellipsisWidth, setEllipsisWidth] = $cQmXV.useState(0);
    const [isHoveringOperations, setIsHoveringOperations] = (0, $f0cf805f93abd5af$export$2e2bcd8739ae039)(false);
    const isHoveringTypographyRef = $cQmXV.useRef(false);
    const onResize = ({ offsetWidth: offsetWidth })=>{
        setEllipsisWidth(offsetWidth);
    };
    // >>>>> JS Ellipsis
    const onJsEllipsis = (jsEllipsis)=>{
        setIsJsEllipsis(jsEllipsis);
        // Trigger if changed
        if (isJsEllipsis !== jsEllipsis) ellipsisConfig.onEllipsis?.(jsEllipsis);
    };
    // >>>>> Native ellipsis
    const measureNativeEllipsis = $cQmXV.useCallback(()=>{
        const textEle = typographyRef.current;
        if (enableEllipsis && needNativeEllipsisMeasure && textEle) {
            const currentEllipsis = (0, $7a263d04e13355d8$export$5714fcf57d9d6988)(textEle);
            setIsNativeEllipsis((prev)=>prev === currentEllipsis ? prev : currentEllipsis);
        }
    }, [
        enableEllipsis,
        needNativeEllipsisMeasure
    ]);
    // Keep the result current while the Typography is hovered, but do not force every
    // Typography instance to read layout during a bulk render or resize.
    $cQmXV.useEffect(()=>{
        if (isHoveringTypographyRef.current) measureNativeEllipsis();
    }, [
        measureNativeEllipsis,
        children,
        cssLineClamp,
        isNativeVisible,
        ellipsisWidth
    ]);
    // https://github.com/ant-design/ant-design/issues/36786
    // Use IntersectionObserver to check if element is invisible
    $cQmXV.useEffect(()=>{
        const textEle = typographyRef.current;
        if (typeof IntersectionObserver === "undefined" || !textEle || !needNativeEllipsisMeasure || !mergedEnableEllipsis) return;
        const observer = new IntersectionObserver(()=>{
            setIsNativeVisible(!!textEle.offsetParent);
        });
        observer.observe(textEle);
        return ()=>{
            observer.disconnect();
        };
    }, [
        needNativeEllipsisMeasure,
        mergedEnableEllipsis
    ]);
    // ========================== Tooltip ===========================
    const topAriaLabel = $cQmXV.useMemo(()=>{
        if (!enableEllipsis || cssEllipsis) return undefined;
        return [
            editConfig.text,
            children,
            title,
            tooltipProps.title
        ].find((0, $7a263d04e13355d8$export$a748c1acb7702f51));
    }, [
        enableEllipsis,
        cssEllipsis,
        title,
        tooltipProps.title,
        isMergedEllipsis,
        editConfig.text
    ]);
    // =========================== Render ===========================
    // >>>>>>>>>>> Editing input
    if (editing) return /*#__PURE__*/ $cQmXV.createElement((0, $c95d6280031c1235$export$2e2bcd8739ae039), {
        value: editConfig.text ?? (typeof children === "string" ? children : ""),
        onSave: onEditChange,
        onCancel: onEditCancel,
        onEnd: editConfig.onEnd,
        prefixCls: prefixCls,
        className: className,
        style: style,
        direction: direction,
        component: component,
        maxLength: editConfig.maxLength,
        autoSize: editConfig.autoSize,
        enterIcon: editConfig.enterIcon,
        classNames: mergedClassNames,
        styles: mergedStyles
    });
    // >>>>>>>>>>> Typography
    // Expand
    const renderExpand = ()=>{
        const { expandable: expandable, symbol: symbol } = ellipsisConfig;
        return expandable ? /*#__PURE__*/ $cQmXV.createElement("button", {
            type: "button",
            key: "expand",
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-${expanded ? "collapse" : "expand"}`, mergedClassNames.action),
            style: mergedStyles.action,
            onClick: (e)=>onExpandClick(e, {
                    expanded: !expanded
                }),
            "aria-label": expanded ? textLocale.collapse : textLocale?.expand
        }, (0, $8e2d153a3c855782$export$f6e2535fb5126e54)(symbol) ? symbol(expanded) : symbol) : null;
    };
    // Edit
    const renderEdit = ()=>{
        if (!enableEdit) return;
        const { icon: icon, tooltip: tooltip, tabIndex: tabIndex } = editConfig;
        const editTitle = (0, $cd966a313e0a92ff$export$2e2bcd8739ae039)(tooltip)[0] || textLocale?.edit;
        const ariaLabel = typeof editTitle === "string" ? editTitle : "";
        return triggerType.includes("icon") ? /*#__PURE__*/ $cQmXV.createElement((0, $1e5256cf9d329b2c$export$2e2bcd8739ae039), {
            key: "edit",
            title: tooltip === false ? "" : editTitle
        }, /*#__PURE__*/ $cQmXV.createElement("button", {
            type: "button",
            ref: editIconRef,
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-edit`, mergedClassNames.action),
            style: mergedStyles.action,
            onClick: onEditClick,
            "aria-label": ariaLabel,
            tabIndex: tabIndex
        }, icon || /*#__PURE__*/ $cQmXV.createElement((0, $1141984d2e96fc67$export$2e2bcd8739ae039), {
            role: "button"
        }))) : null;
    };
    // Copy
    const renderCopy = ()=>{
        if (!enableCopy) return null;
        return /*#__PURE__*/ $cQmXV.createElement((0, $afd9b7f31912c716$export$2e2bcd8739ae039), {
            key: "copy",
            ...copyConfig,
            prefixCls: prefixCls,
            copied: copied,
            locale: textLocale,
            onCopy: onCopyClick,
            loading: copyLoading,
            iconOnly: !(0, $8e2d153a3c855782$export$72280d5f896dac9a)(children),
            className: mergedClassNames.action,
            style: mergedStyles.action
        });
    };
    const renderOperations = (canEllipsis)=>{
        const expandNode = canEllipsis && renderExpand();
        const editNode = renderEdit();
        const copyNode = renderCopy();
        if (!expandNode && !editNode && !copyNode) return null;
        return /*#__PURE__*/ $cQmXV.createElement("span", {
            key: "operations",
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-actions`, mergedClassNames.actions, {
                [`${prefixCls}-actions-start`]: placement === "start"
            }),
            style: mergedStyles.actions,
            onMouseEnter: ()=>setIsHoveringOperations(true, true),
            onMouseLeave: ()=>setIsHoveringOperations(false, {
                    // Delay 500ms for better user experience
                    ms: 500
                })
        }, expandNode, editNode, copyNode);
    };
    const renderEllipsis = (canEllipsis)=>[
            canEllipsis && !expanded && /*#__PURE__*/ $cQmXV.createElement("span", {
                "aria-hidden": true,
                key: "ellipsis"
            }, $55a17c4ad8e08183$var$ELLIPSIS_STR),
            ellipsisConfig.suffix
        ];
    return /*#__PURE__*/ $cQmXV.createElement((0, $1d6306c05e604045$export$2e2bcd8739ae039), {
        onResize: onResize,
        disabled: !mergedEnableEllipsis
    }, (resizeRef)=>/*#__PURE__*/ $cQmXV.createElement((0, $3b814dc30ebebbe4$export$2e2bcd8739ae039), {
            tooltipProps: tooltipProps,
            enableEllipsis: mergedEnableEllipsis,
            isEllipsis: isMergedEllipsis,
            disabled: isHoveringOperations
        }, /*#__PURE__*/ $cQmXV.createElement((0, $585794d93a3a7525$export$eb9bd2b66ef4fd8d), {
            onMouseEnter: (e)=>{
                isHoveringTypographyRef.current = true;
                measureNativeEllipsis();
                onMouseEnter?.(e);
            },
            onMouseLeave: (e)=>{
                isHoveringTypographyRef.current = false;
                onMouseLeave?.(e);
            },
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)({
                [`${prefixCls}-${type}`]: type,
                [`${prefixCls}-disabled`]: disabled,
                [`${prefixCls}-ellipsis`]: enableEllipsis,
                [`${prefixCls}-ellipsis-single-line`]: cssTextOverflow,
                [`${prefixCls}-ellipsis-multiple-line`]: cssLineClamp,
                [`${prefixCls}-link`]: component === "a"
            }, className),
            classNames: mergedClassNames,
            styles: mergedStyles,
            prefixCls: prefixCls,
            style: {
                ...style,
                WebkitLineClamp: cssLineClamp ? rows : undefined
            },
            component: component,
            ref: (0, $10341b937b26f69d$export$ab452c34e8e05029)(resizeRef, typographyRef, ref),
            direction: direction,
            onClick: triggerType.includes("text") ? onEditClick : undefined,
            "aria-label": topAriaLabel?.toString(),
            title: title,
            ...textProps
        }, /*#__PURE__*/ $cQmXV.createElement((0, $a98b3fe2918d31b2$export$2e2bcd8739ae039), {
            enableMeasure: mergedEnableEllipsis && !cssEllipsis,
            text: children,
            rows: rows,
            width: ellipsisWidth,
            onEllipsis: onJsEllipsis,
            expanded: expanded,
            measureDeps: [
                placement
            ],
            miscDeps: [
                copied,
                expanded,
                copyLoading,
                enableEdit,
                enableCopy,
                placement,
                textLocale
            ].concat((0, $68381b18b974dc9f$export$2e2bcd8739ae039)($55a17c4ad8e08183$var$DECORATION_PROPS.map((key)=>props[key])))
        }, (node, canEllipsis)=>$55a17c4ad8e08183$var$wrapperDecorations(props, /*#__PURE__*/ $cQmXV.createElement($cQmXV.Fragment, null, placement === "start" ? renderOperations(canEllipsis) : null, node.length > 0 && canEllipsis && !expanded && topAriaLabel ? /*#__PURE__*/ $cQmXV.createElement("span", {
                key: "show-content",
                "aria-hidden": true
            }, node) : node, renderEllipsis(canEllipsis), placement === "start" ? null : renderOperations(canEllipsis)))))));
});
var $55a17c4ad8e08183$export$2e2bcd8739ae039 = $55a17c4ad8e08183$var$Base;


"use client";
const $f2ba07fb7b5145a1$var$Link = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { ellipsis: ellipsis, rel: rel, children: children, // @ts-expect-error: https://github.com/ant-design/ant-design/issues/26622
    navigate: _navigate, ...restProps } = props;
    const mergedProps = {
        ...restProps,
        rel: rel === undefined && restProps.target === "_blank" ? "noopener noreferrer" : rel
    };
    return /*#__PURE__*/ $cQmXV.createElement((0, $55a17c4ad8e08183$export$2e2bcd8739ae039), {
        ...mergedProps,
        ref: ref,
        ellipsis: !!ellipsis,
        component: "a"
    }, children);
});
var $f2ba07fb7b5145a1$export$2e2bcd8739ae039 = $f2ba07fb7b5145a1$var$Link;



var $cQmXV = parcelRequire("cQmXV");

"use client";
const $92e35303bc3837f8$var$Paragraph = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { children: children, ...restProps } = props;
    return /*#__PURE__*/ $cQmXV.createElement((0, $55a17c4ad8e08183$export$2e2bcd8739ae039), {
        ref: ref,
        ...restProps,
        component: "div"
    }, children);
});
var $92e35303bc3837f8$export$2e2bcd8739ae039 = $92e35303bc3837f8$var$Paragraph;



var $cQmXV = parcelRequire("cQmXV");




"use client";
const $e115042fe7dc8369$var$Text = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { ellipsis: ellipsis, children: children, ...restProps } = props;
    const mergedEllipsis = $cQmXV.useMemo(()=>{
        if ((0, $8e2d153a3c855782$export$53b83ca8eaab0383)(ellipsis)) return (0, $e8c5093aebad6025$export$2e2bcd8739ae039)(ellipsis, [
            "expandable",
            "rows"
        ]);
        return ellipsis;
    }, [
        ellipsis
    ]);
    return /*#__PURE__*/ $cQmXV.createElement((0, $55a17c4ad8e08183$export$2e2bcd8739ae039), {
        ref: ref,
        ...restProps,
        ellipsis: mergedEllipsis,
        component: "span"
    }, children);
});
var $e115042fe7dc8369$export$2e2bcd8739ae039 = $e115042fe7dc8369$var$Text;



var $cQmXV = parcelRequire("cQmXV");


"use client";
const $0ec91893b4ec5652$var$TITLE_ELE_LIST = [
    1,
    2,
    3,
    4,
    5
];
const $0ec91893b4ec5652$var$Title = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { level: level = 1, children: children, ...restProps } = props;
    const component = $0ec91893b4ec5652$var$TITLE_ELE_LIST.includes(level) ? `h${level}` : `h1`;
    return /*#__PURE__*/ $cQmXV.createElement((0, $55a17c4ad8e08183$export$2e2bcd8739ae039), {
        ref: ref,
        ...restProps,
        component: component
    }, children);
});
var $0ec91893b4ec5652$export$2e2bcd8739ae039 = $0ec91893b4ec5652$var$Title;



"use client";
const $5ff14f79745d0994$var$Typography = (0, $585794d93a3a7525$export$2e2bcd8739ae039);
$5ff14f79745d0994$var$Typography.Text = (0, $e115042fe7dc8369$export$2e2bcd8739ae039);
$5ff14f79745d0994$var$Typography.Link = (0, $f2ba07fb7b5145a1$export$2e2bcd8739ae039);
$5ff14f79745d0994$var$Typography.Title = (0, $0ec91893b4ec5652$export$2e2bcd8739ae039);
$5ff14f79745d0994$var$Typography.Paragraph = (0, $92e35303bc3837f8$export$2e2bcd8739ae039);
var $5ff14f79745d0994$export$2e2bcd8739ae039 = $5ff14f79745d0994$var$Typography;


var $cQmXV = parcelRequire("cQmXV");






var $cQmXV = parcelRequire("cQmXV");



const $8b322a4664b21de7$export$2ee4fbe37e2c4285 = (color, background)=>{
    if (color?.startsWith("var(") || background?.startsWith("var(")) return color;
    return new (0, $3bb84f07fb2a2f32$export$2c4f38d6c0ecc25a)(color).onBackground(background).toHexString();
};


"use client";
const $851141b77278b178$var$Empty = ()=>{
    const [, token] = (0, $b22e03a54a548614$export$2e2bcd8739ae039)();
    const [locale] = (0, $c953dac9d015386e$export$2e2bcd8739ae039)("Empty");
    const { colorBgContainer: colorBgContainer, colorFill: colorFill, colorFillSecondary: colorFillSecondary, colorFillTertiary: colorFillTertiary, colorTextQuaternary: colorTextQuaternary } = token;
    const { panelBgColor: panelBgColor, borderColor: borderColor, detailColor: detailColor, shadowColor: shadowColor, iconColor: iconColor } = (0, $cQmXV.useMemo)(()=>({
            panelBgColor: (0, $8b322a4664b21de7$export$2ee4fbe37e2c4285)(colorFillTertiary, colorBgContainer),
            borderColor: (0, $8b322a4664b21de7$export$2ee4fbe37e2c4285)(colorTextQuaternary, colorBgContainer),
            detailColor: (0, $8b322a4664b21de7$export$2ee4fbe37e2c4285)(colorFill, colorBgContainer),
            shadowColor: (0, $8b322a4664b21de7$export$2ee4fbe37e2c4285)(colorFillSecondary, colorBgContainer),
            iconColor: colorBgContainer
        }), [
        colorBgContainer,
        colorFill,
        colorFillSecondary,
        colorFillTertiary,
        colorTextQuaternary
    ]);
    return /*#__PURE__*/ $cQmXV.createElement("svg", {
        width: "184",
        height: "152",
        viewBox: "0 0 184 152",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $cQmXV.createElement("title", null, locale?.description || "Empty"), /*#__PURE__*/ $cQmXV.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ $cQmXV.createElement("g", {
        transform: "translate(24 31.7)"
    }, /*#__PURE__*/ $cQmXV.createElement("ellipse", {
        fillOpacity: ".8",
        fill: shadowColor,
        cx: "67.8",
        cy: "106.9",
        rx: "67.8",
        ry: "12.7"
    }), /*#__PURE__*/ $cQmXV.createElement("path", {
        fill: borderColor,
        d: "M122 69.7 98.1 40.2a6 6 0 0 0-4.6-2.2H42.1a6 6 0 0 0-4.6 2.2l-24 29.5V85H122z"
    }), /*#__PURE__*/ $cQmXV.createElement("path", {
        fill: panelBgColor,
        d: "M33.8 0h68a4 4 0 0 1 4 4v93.3a4 4 0 0 1-4 4h-68a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4"
    }), /*#__PURE__*/ $cQmXV.createElement("path", {
        fill: detailColor,
        d: "M42.7 10h50.2a2 2 0 0 1 2 2v25a2 2 0 0 1-2 2H42.7a2 2 0 0 1-2-2V12a2 2 0 0 1 2-2m.2 39.8h49.8a2.3 2.3 0 1 1 0 4.5H42.9a2.3 2.3 0 0 1 0-4.5m0 11.7h49.8a2.3 2.3 0 1 1 0 4.6H42.9a2.3 2.3 0 0 1 0-4.6m79 43.5a7 7 0 0 1-6.8 5.4H20.5a7 7 0 0 1-6.7-5.4l-.2-1.8V69.7h26.3c2.9 0 5.2 2.4 5.2 5.4s2.4 5.4 5.3 5.4h34.8c2.9 0 5.3-2.4 5.3-5.4s2.3-5.4 5.2-5.4H122v33.5q0 1-.2 1.8"
    })), /*#__PURE__*/ $cQmXV.createElement("path", {
        fill: detailColor,
        d: "m149.1 33.3-6.8 2.6a1 1 0 0 1-1.3-1.2l2-6.2q-4.1-4.5-4.2-10.4c0-10 10.1-18.1 22.6-18.1S184 8.1 184 18.1s-10.1 18-22.6 18q-6.8 0-12.3-2.8"
    }), /*#__PURE__*/ $cQmXV.createElement("g", {
        fill: iconColor,
        transform: "translate(149.7 15.4)"
    }, /*#__PURE__*/ $cQmXV.createElement("circle", {
        cx: "20.7",
        cy: "3.2",
        r: "2.8"
    }), /*#__PURE__*/ $cQmXV.createElement("path", {
        d: "M5.7 5.6H0L2.9.7zM9.3.7h5v5h-5z"
    }))));
};
var $851141b77278b178$export$2e2bcd8739ae039 = $851141b77278b178$var$Empty;



var $cQmXV = parcelRequire("cQmXV");



"use client";
const $164cc74e27effe25$var$Simple = ()=>{
    const [, token] = (0, $b22e03a54a548614$export$2e2bcd8739ae039)();
    const [locale] = (0, $c953dac9d015386e$export$2e2bcd8739ae039)("Empty");
    const { colorFill: colorFill, colorFillTertiary: colorFillTertiary, colorFillQuaternary: colorFillQuaternary, colorBgContainer: colorBgContainer } = token;
    const { borderColor: borderColor, shadowColor: shadowColor, contentColor: contentColor } = (0, $cQmXV.useMemo)(()=>({
            borderColor: (0, $8b322a4664b21de7$export$2ee4fbe37e2c4285)(colorFill, colorBgContainer),
            shadowColor: (0, $8b322a4664b21de7$export$2ee4fbe37e2c4285)(colorFillTertiary, colorBgContainer),
            contentColor: (0, $8b322a4664b21de7$export$2ee4fbe37e2c4285)(colorFillQuaternary, colorBgContainer)
        }), [
        colorFill,
        colorFillTertiary,
        colorFillQuaternary,
        colorBgContainer
    ]);
    return /*#__PURE__*/ $cQmXV.createElement("svg", {
        width: "64",
        height: "41",
        viewBox: "0 0 64 41",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $cQmXV.createElement("title", null, locale?.description || "Empty"), /*#__PURE__*/ $cQmXV.createElement("g", {
        transform: "translate(0 1)",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ $cQmXV.createElement("ellipse", {
        fill: shadowColor,
        cx: "32",
        cy: "33",
        rx: "32",
        ry: "7"
    }), /*#__PURE__*/ $cQmXV.createElement("g", {
        fillRule: "nonzero",
        stroke: borderColor
    }, /*#__PURE__*/ $cQmXV.createElement("path", {
        d: "M55 12.8 44.9 1.3Q44 0 42.9 0H21.1q-1.2 0-2 1.3L9 12.8V22h46z"
    }), /*#__PURE__*/ $cQmXV.createElement("path", {
        d: "M41.6 16c0-1.7 1-3 2.2-3H55v18.1c0 2.2-1.3 3.9-3 3.9H12c-1.7 0-3-1.7-3-3.9V13h11.2c1.2 0 2.2 1.3 2.2 3s1 2.9 2.2 2.9h14.8c1.2 0 2.2-1.4 2.2-3",
        fill: contentColor
    }))));
};
var $164cc74e27effe25$export$2e2bcd8739ae039 = $164cc74e27effe25$var$Simple;



// ============================== Shared ==============================
const $ff8e973a4f5adf71$var$genSharedEmptyStyle = (token)=>{
    const { componentCls: componentCls, margin: margin, marginXS: marginXS, marginXL: marginXL, fontSize: fontSize, lineHeight: lineHeight } = token;
    return {
        [componentCls]: {
            marginInline: marginXS,
            fontSize: fontSize,
            lineHeight: lineHeight,
            textAlign: "center",
            // 原来 &-image 没有父子结构，现在为了外层承担我们的 hashId，改成父子结构
            [`${componentCls}-image`]: {
                height: token.emptyImgHeight,
                marginBottom: marginXS,
                opacity: token.opacityImage,
                img: {
                    height: "100%"
                },
                svg: {
                    maxWidth: "100%",
                    height: "100%",
                    margin: "auto"
                }
            },
            [`${componentCls}-description`]: {
                color: token.colorTextDescription
            },
            // 原来 &-footer 没有父子结构，现在为了外层承担我们的 hashId，改成父子结构
            [`${componentCls}-footer`]: {
                marginTop: margin
            },
            "&-normal": {
                marginBlock: marginXL,
                color: token.colorTextDescription,
                [`${componentCls}-description`]: {
                    color: token.colorTextDescription
                },
                [`${componentCls}-image`]: {
                    height: token.emptyImgHeightMD
                }
            },
            "&-small": {
                marginBlock: marginXS,
                color: token.colorTextDescription,
                [`${componentCls}-image`]: {
                    height: token.emptyImgHeightSM
                }
            }
        }
    };
};
var // ============================== Export ==============================
$ff8e973a4f5adf71$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$51ec95de45185b42)("Empty", (token)=>{
    const { componentCls: componentCls, controlHeightLG: controlHeightLG, calc: calc } = token;
    const emptyToken = (0, $fef50f256b80dfa5$export$4950aa0f605343fb)(token, {
        emptyImgCls: `${componentCls}-img`,
        emptyImgHeight: calc(controlHeightLG).mul(2.5).equal(),
        emptyImgHeightMD: controlHeightLG,
        emptyImgHeightSM: calc(controlHeightLG).mul(0.875).equal()
    });
    return $ff8e973a4f5adf71$var$genSharedEmptyStyle(emptyToken);
});


"use client";
const $99350450b877904c$var$defaultEmptyImg = /*#__PURE__*/ $cQmXV.createElement((0, $851141b77278b178$export$2e2bcd8739ae039), null);
const $99350450b877904c$var$simpleEmptyImg = /*#__PURE__*/ $cQmXV.createElement((0, $164cc74e27effe25$export$2e2bcd8739ae039), null);
const $99350450b877904c$var$Empty = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { className: className, rootClassName: rootClassName, prefixCls: customizePrefixCls, image: image, description: description, children: children, imageStyle: imageStyle, style: style, classNames: classNames, styles: styles, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles, image: contextImage } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("empty");
    const prefixCls = getPrefixCls("empty", customizePrefixCls);
    const [hashId, cssVarCls] = (0, $ff8e973a4f5adf71$export$2e2bcd8739ae039)(prefixCls);
    const contextStyleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $30c5f9f911d4f61b$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: props
    });
    const [locale] = (0, $c953dac9d015386e$export$2e2bcd8739ae039)("Empty");
    const des = typeof description !== "undefined" ? description : locale?.description;
    const alt = typeof des === "string" ? des : "empty";
    const mergedImage = image ?? contextImage ?? $99350450b877904c$var$defaultEmptyImg;
    let imageNode = null;
    if (typeof mergedImage === "string") imageNode = /*#__PURE__*/ $cQmXV.createElement("img", {
        draggable: false,
        alt: alt,
        src: mergedImage
    });
    else imageNode = mergedImage;
    var deprecatedName, newName;
    const nativeElementRef = $cQmXV.useRef(null);
    $cQmXV.useImperativeHandle(ref, ()=>({
            nativeElement: nativeElementRef.current
        }));
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        ref: nativeElementRef,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(hashId, cssVarCls, prefixCls, contextClassName, {
            [`${prefixCls}-normal`]: mergedImage === $99350450b877904c$var$simpleEmptyImg,
            [`${prefixCls}-rtl`]: direction === "rtl"
        }, className, rootClassName, mergedClassNames.root),
        style: mergedStyles.root,
        ...restProps
    }, /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-image`, mergedClassNames.image),
        style: {
            ...imageStyle,
            ...mergedStyles.image
        }
    }, imageNode), des && /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-description`, mergedClassNames.description),
        style: mergedStyles.description
    }, des), children && /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-footer`, mergedClassNames.footer),
        style: mergedStyles.footer
    }, children));
});
$99350450b877904c$var$Empty.PRESENTED_IMAGE_DEFAULT = $99350450b877904c$var$defaultEmptyImg;
$99350450b877904c$var$Empty.PRESENTED_IMAGE_SIMPLE = $99350450b877904c$var$simpleEmptyImg;
var $99350450b877904c$export$2e2bcd8739ae039 = $99350450b877904c$var$Empty;



var $cQmXV = parcelRequire("cQmXV");
var $e4c90fcf8b7183cf$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($e4c90fcf8b7183cf$exports, "__esModule", {
    value: true
});
var $e4c90fcf8b7183cf$var$ExportOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "fill-rule": "evenodd",
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M880 912H144c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32h360c4.4 0 8 3.6 8 8v56c0 4.4-3.6 8-8 8H184v656h656V520c0-4.4 3.6-8 8-8h56c4.4 0 8 3.6 8 8v360c0 17.7-14.3 32-32 32zM770.87 199.13l-52.2-52.2a8.01 8.01 0 014.7-13.6l179.4-21c5.1-.6 9.5 3.7 8.9 8.9l-21 179.4c-.8 6.6-8.9 9.4-13.6 4.7l-52.4-52.4-256.2 256.2a8.03 8.03 0 01-11.3 0l-42.4-42.4a8.03 8.03 0 010-11.3l256.1-256.3z"
                }
            }
        ]
    },
    "name": "export",
    "theme": "outlined"
};
$e4c90fcf8b7183cf$exports.default = $e4c90fcf8b7183cf$var$ExportOutlined;



function $357da3723e13ae38$var$_extends() {
    $357da3723e13ae38$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $357da3723e13ae38$var$_extends.apply(this, arguments);
}
const $357da3723e13ae38$var$ExportOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $357da3723e13ae38$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e4c90fcf8b7183cf$exports)))
    }));
/**![export](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdmlld0JveD0iNjQgNjQgODk2IDg5NiIgZm9jdXNhYmxlPSJmYWxzZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNODgwIDkxMkgxNDRjLTE3LjcgMC0zMi0xNC4zLTMyLTMyVjE0NGMwLTE3LjcgMTQuMy0zMiAzMi0zMmgzNjBjNC40IDAgOCAzLjYgOCA4djU2YzAgNC40LTMuNiA4LTggOEgxODR2NjU2aDY1NlY1MjBjMC00LjQgMy42LTggOC04aDU2YzQuNCAwIDggMy42IDggOHYzNjBjMCAxNy43LTE0LjMgMzItMzIgMzJ6TTc3MC44NyAxOTkuMTNsLTUyLjItNTIuMmE4LjAxIDguMDEgMCAwMTQuNy0xMy42bDE3OS40LTIxYzUuMS0uNiA5LjUgMy43IDguOSA4LjlsLTIxIDE3OS40Yy0uOCA2LjYtOC45IDkuNC0xMy42IDQuN2wtNTIuNC01Mi40LTI1Ni4yIDI1Ni4yYTguMDMgOC4wMyAwIDAxLTExLjMgMGwtNDIuNC00Mi40YTguMDMgOC4wMyAwIDAxMC0xMS4zbDI1Ni4xLTI1Ni4zeiIgLz48L3N2Zz4=) */ const $357da3723e13ae38$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($357da3723e13ae38$var$ExportOutlined);
var $357da3723e13ae38$export$2e2bcd8739ae039 = $357da3723e13ae38$var$RefIcon;






const $d24c7edf7011cb65$var$View = ()=>{
    const lang = (0, $b83e93e5ef3de8b0$export$2105062e25df4afe)((state)=>state.me?.language || "en");
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b94fa0d6ced71581), key, lang);
    const history = (0, $6f5d68f762d5488a$export$3420e1dc2c4a518c)();
    const location = (0, $6f5d68f762d5488a$export$45d76561a5302f2b)();
    const openKey = new URLSearchParams(location.search).get("r") || null;
    const [list, setList] = (0, $cQmXV.useState)([]);
    const [status, setStatus] = (0, $cQmXV.useState)("loading"); // loading | ready | error
    /* Which report's frame has finished loading, rather than a bare boolean — comparing against the
     open key is what resets the skeleton when the user switches reports, with no effect needed. */ const [loadedKey, setLoadedKey] = (0, $cQmXV.useState)(null);
    const load = (0, $cQmXV.useCallback)(()=>{
        setStatus("loading");
        /* `call` answers a failure with `{results: [], count: 0}`, so the array is the success test. */ (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "GET",
            url: "reports/"
        }, (r)=>{
            if (!Array.isArray(r)) return setStatus("error");
            setList(r);
            setStatus("ready");
        });
    }, []);
    (0, $cQmXV.useEffect)(load, [
        load
    ]);
    const setOpen = (key)=>{
        const search = key ? `?r=${encodeURIComponent(key)}` : "";
        history.replace(location.pathname + search);
    };
    if (status === "loading") return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
        vertical: true,
        gap: "middle",
        className: "shell-content bi",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e855c7114b2916ed$export$2e2bcd8739ae039), {
                active: true,
                paragraph: {
                    rows: 1
                }
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e855c7114b2916ed$export$2e2bcd8739ae039), {
                active: true,
                title: false,
                paragraph: {
                    rows: 4
                }
            })
        ]
    });
    const items = list.map((report)=>({
            key: String(report.id),
            label: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                className: "bi-row",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $235e2c6c1e527cba$export$2e2bcd8739ae039), {
                        className: "bi-row__icon"
                    }),
                    report.name
                ]
            }),
            extra: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                type: "text",
                size: "small",
                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $357da3723e13ae38$export$2e2bcd8739ae039), {}),
                href: report.url,
                target: "_blank",
                rel: "noopener noreferrer",
                /* The header toggles the panel; the link must not. */ onClick: (event)=>event.stopPropagation(),
                children: t("open_new_tab")
            }),
            children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                className: "bi-frame",
                children: [
                    loadedKey !== String(report.id) && /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e855c7114b2916ed$export$2e2bcd8739ae039), {
                        active: true,
                        className: "bi-frame__skeleton",
                        paragraph: {
                            rows: 6
                        }
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("iframe", {
                        className: "bi-frame__embed",
                        src: report.url,
                        title: report.name,
                        allowFullScreen: true,
                        onLoad: ()=>setLoadedKey(String(report.id))
                    })
                ]
            })
        }));
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
        vertical: true,
        gap: "middle",
        className: "shell-content bi",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                vertical: true,
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Title, {
                        level: 1,
                        className: "bi-title",
                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$72266474e9355649), "all_reports", lang)
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Paragraph, {
                        type: "secondary",
                        className: "bi-sub",
                        children: status === "ready" && list.length > 0 ? `${t("available")}: ${list.length}` : t("subtitle")
                    })
                ]
            }),
            status === "error" && /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $dc33dcdb2d24fbd9$export$2e2bcd8739ae039), {
                type: "error",
                showIcon: true,
                message: t("error"),
                action: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                    size: "small",
                    onClick: load,
                    children: t("retry")
                })
            }),
            status === "ready" && list.length === 0 && /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $99350450b877904c$export$2e2bcd8739ae039), {
                description: t("empty")
            }),
            items.length > 0 && /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $23bd4bba91b7ee72$export$2e2bcd8739ae039), {
                accordion: true,
                destroyOnHidden: true,
                className: "bi-list",
                activeKey: openKey ? [
                    openKey
                ] : [],
                onChange: (keys)=>setOpen(keys[keys.length - 1] || null),
                items: items
            })
        ]
    });
};
var $d24c7edf7011cb65$export$2e2bcd8739ae039 = $d24c7edf7011cb65$var$View;


/* Documents — the shared file list.
   No mockup for this screen; the shape is spec/03 archetype A, built from the shared list chrome
   (`component/list-page.scss`) and the shared cell primitives, so it reads as the same product as
   /visit and /supervisors.

   The filter card is the shared one — `lp-filters`, `<Form layout="vertical" component={false}>`,
   `FIELD_COL` tracks, the `FilterChips` row and the `lp-filters__foot` with Reset — even though
   `GET documents/` offers exactly one narrowing (search). One reduction against the archetype:
   **no segments and no quality chips**, since a document has no lifecycle state to split on and
   nothing derived to call out.

   A document has no detail route, so the row is not clickable at all: opening the file is an
   explicit per-row button (`ExportOutlined`, new tab), since leaving the app should be aimed at
   rather than a side effect of clicking a row.

   Functionality is unchanged from the pre-redesign page: search, sort by name or date, paging,
   upload (name + file), download, delete. Delete now confirms first, per spec/03. */ 

var $cQmXV = parcelRequire("cQmXV");



var $cQmXV = parcelRequire("cQmXV");





var $cQmXV = parcelRequire("cQmXV");
















var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");




"use client";
const $6d18b68c8fb73984$var$ActionButton = (props)=>{
    const { type: type, children: children, prefixCls: prefixCls, buttonProps: buttonProps, close: close, autoFocus: autoFocus, emitEvent: emitEvent, isSilent: isSilent, quitOnNullishReturnValue: quitOnNullishReturnValue, actionFn: actionFn } = props;
    const clickedRef = $cQmXV.useRef(false);
    const buttonRef = $cQmXV.useRef(null);
    const [loading, setLoading] = (0, $8caa85071cca5555$export$2e2bcd8739ae039)(false);
    const onInternalClose = (...args)=>{
        close?.(...args);
    };
    $cQmXV.useEffect(()=>{
        let timeoutId = null;
        if (autoFocus) timeoutId = setTimeout(()=>{
            buttonRef.current?.focus({
                preventScroll: true
            });
        });
        return ()=>{
            if (timeoutId) clearTimeout(timeoutId);
        };
    }, [
        autoFocus
    ]);
    const handlePromiseOnOk = (returnValueOfOnOk)=>{
        if (!(0, $8e2d153a3c855782$export$f5b060c2914b97c8)(returnValueOfOnOk)) return;
        setLoading(true);
        returnValueOfOnOk.then((...args)=>{
            setLoading(false, true);
            onInternalClose.apply(void 0, args);
            clickedRef.current = false;
        }, (e)=>{
            // See: https://github.com/ant-design/ant-design/issues/6183
            setLoading(false, true);
            clickedRef.current = false;
            // Do not throw if is `await` mode
            if (isSilent?.()) return;
            return Promise.reject(e);
        });
    };
    const onClick = (e)=>{
        if (clickedRef.current) return;
        clickedRef.current = true;
        if (!actionFn) {
            onInternalClose();
            return;
        }
        let returnValueOfOnOk;
        if (emitEvent) {
            returnValueOfOnOk = actionFn(e);
            if (quitOnNullishReturnValue && !(0, $8e2d153a3c855782$export$f5b060c2914b97c8)(returnValueOfOnOk)) {
                clickedRef.current = false;
                onInternalClose(e);
                return;
            }
        } else if (actionFn.length) {
            returnValueOfOnOk = actionFn(close);
            // https://github.com/ant-design/ant-design/issues/23358
            clickedRef.current = false;
        } else {
            returnValueOfOnOk = actionFn();
            if (!(0, $8e2d153a3c855782$export$f5b060c2914b97c8)(returnValueOfOnOk)) {
                onInternalClose();
                return;
            }
        }
        handlePromiseOnOk(returnValueOfOnOk);
    };
    return /*#__PURE__*/ $cQmXV.createElement((0, $1fc505710073cde5$export$2e2bcd8739ae039), {
        ...(0, $62e55ded4111e367$export$19bc9a290855952)(type),
        onClick: onClick,
        loading: loading,
        prefixCls: prefixCls,
        ...buttonProps,
        ref: buttonRef
    }, children);
};
var $6d18b68c8fb73984$export$2e2bcd8739ae039 = $6d18b68c8fb73984$var$ActionButton;



var $cQmXV = parcelRequire("cQmXV");
const $082c89892c23fb74$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createContext({});
const { Provider: $082c89892c23fb74$export$7c9538f5f3c365e9 } = $082c89892c23fb74$export$ab57792b9b6974a6;


"use client";
const $4bdd37f1840bccd1$var$ConfirmCancelBtn = ()=>{
    const { autoFocusButton: autoFocusButton, cancelButtonProps: cancelButtonProps, cancelTextLocale: cancelTextLocale, isSilent: isSilent, mergedOkCancel: mergedOkCancel, rootPrefixCls: rootPrefixCls, close: close, onCancel: onCancel, onConfirm: onConfirm, onClose: onClose } = (0, $cQmXV.useContext)((0, $082c89892c23fb74$export$ab57792b9b6974a6));
    return mergedOkCancel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $6d18b68c8fb73984$export$2e2bcd8739ae039), {
        isSilent: isSilent,
        actionFn: onCancel,
        close: (...args)=>{
            close?.(...args);
            onConfirm?.(false);
            onClose?.();
        },
        autoFocus: autoFocusButton === "cancel",
        buttonProps: cancelButtonProps,
        prefixCls: `${rootPrefixCls}-btn`
    }, cancelTextLocale) : null;
};
var $4bdd37f1840bccd1$export$2e2bcd8739ae039 = $4bdd37f1840bccd1$var$ConfirmCancelBtn;



var $cQmXV = parcelRequire("cQmXV");


"use client";
const $26fdee6a6282db39$var$ConfirmOkBtn = ()=>{
    const { autoFocusButton: autoFocusButton, close: close, isSilent: isSilent, okButtonProps: okButtonProps, rootPrefixCls: rootPrefixCls, okTextLocale: okTextLocale, okType: okType, onConfirm: onConfirm, onOk: onOk, onClose: onClose } = (0, $cQmXV.useContext)((0, $082c89892c23fb74$export$ab57792b9b6974a6));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $6d18b68c8fb73984$export$2e2bcd8739ae039), {
        isSilent: isSilent,
        type: okType || "primary",
        actionFn: onOk,
        close: (...args)=>{
            close?.(...args);
            onConfirm?.(true);
            onClose?.();
        },
        autoFocus: autoFocusButton === "ok",
        buttonProps: okButtonProps,
        prefixCls: `${rootPrefixCls}-btn`
    }, okTextLocale);
};
var $26fdee6a6282db39$export$2e2bcd8739ae039 = $26fdee6a6282db39$var$ConfirmOkBtn;




var $cQmXV = parcelRequire("cQmXV");



var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");
const $2a0fa8251ff4e268$export$ee4e38b469b6f5d1 = /*#__PURE__*/ $cQmXV.createContext({});





var $cQmXV = parcelRequire("cQmXV");
// =============================== Motion ===============================
function $37e16f62421bd510$export$ec1a7ebf4579c1c3(prefixCls, transitionName, animationName) {
    let motionName = transitionName;
    if (!motionName && animationName) motionName = `${prefixCls}-${animationName}`;
    return motionName;
}
// =============================== Offset ===============================
function $37e16f62421bd510$var$getScroll(w, top) {
    let ret = w[`page${top ? "Y" : "X"}Offset`];
    const method = `scroll${top ? "Top" : "Left"}`;
    if (typeof ret !== "number") {
        const d = w.document;
        ret = d.documentElement[method];
        if (typeof ret !== "number") ret = d.body[method];
    }
    return ret;
}
function $37e16f62421bd510$export$cc800923e997bb8(el) {
    const rect = el.getBoundingClientRect();
    const pos = {
        left: rect.left,
        top: rect.top
    };
    const doc = el.ownerDocument;
    const w = doc.defaultView || doc.parentWindow;
    pos.left += $37e16f62421bd510$var$getScroll(w);
    pos.top += $37e16f62421bd510$var$getScroll(w, true);
    return pos;
}



var $cQmXV = parcelRequire("cQmXV");






var $cQmXV = parcelRequire("cQmXV");


var $cQmXV = parcelRequire("cQmXV");
var $3d58fe1b796a9635$export$2e2bcd8739ae039 = /*#__PURE__*/ $cQmXV.memo(({ children: children })=>children, (_, { shouldUpdate: shouldUpdate })=>!shouldUpdate);


function $6a4ad2e35a066f94$var$_extends() {
    $6a4ad2e35a066f94$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6a4ad2e35a066f94$var$_extends.apply(this, arguments);
}
const $6a4ad2e35a066f94$var$Panel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).forwardRef((props, ref)=>{
    const { prefixCls: prefixCls, className: className, style: style, title: title, ariaId: ariaId, footer: footer, closable: closable, closeIcon: closeIcon, onClose: onClose, children: children, bodyStyle: bodyStyle, bodyProps: bodyProps, modalRender: modalRender, onMouseDown: onMouseDown, onMouseUp: onMouseUp, holderRef: holderRef, visible: visible, forceRender: forceRender, width: width, height: height, classNames: modalClassNames, styles: modalStyles, isFixedPos: isFixedPos, focusTrap: focusTrap } = props;
    // ================================= Refs =================================
    const { panel: panelRef } = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useContext((0, $2a0fa8251ff4e268$export$ee4e38b469b6f5d1));
    const internalRef = (0, $cQmXV.useRef)(null);
    const mergedRef = (0, $10341b937b26f69d$export$1d1c999670a1285d)(holderRef, panelRef, internalRef);
    const [ignoreElement] = (0, $7aa1eaa901116c60$export$9e3bf6f439c42dc9)(visible && isFixedPos && focusTrap !== false, ()=>internalRef.current);
    (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useImperativeHandle(ref, ()=>({
            focus: ()=>{
                internalRef.current?.focus({
                    preventScroll: true
                });
            }
        }));
    // ================================ Style =================================
    const contentStyle = {};
    if (width !== undefined) contentStyle.width = width;
    if (height !== undefined) contentStyle.height = height;
    // ================================ Render ================================
    const footerNode = footer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-footer`, modalClassNames?.footer),
        style: {
            ...modalStyles?.footer
        }
    }, footer) : null;
    const headerNode = title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-header`, modalClassNames?.header),
        style: {
            ...modalStyles?.header
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-title`, modalClassNames?.title),
        id: ariaId,
        style: {
            ...modalStyles?.title
        }
    }, title)) : null;
    const closableObj = (0, $cQmXV.useMemo)(()=>{
        if (typeof closable === "object" && closable !== null) return closable;
        if (closable) return {
            closeIcon: closeIcon ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("span", {
                className: `${prefixCls}-close-x`
            })
        };
        return {};
    }, [
        closable,
        closeIcon,
        prefixCls
    ]);
    const ariaProps = (0, $4b5c733d1d7bb306$export$2e2bcd8739ae039)(closableObj, true);
    const closeBtnIsDisabled = typeof closable === "object" && closable.disabled;
    const closerNode = closable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("button", $6a4ad2e35a066f94$var$_extends({
        type: "button",
        onClick: onClose,
        "aria-label": "Close"
    }, ariaProps, {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-close`, modalClassNames?.close),
        disabled: closeBtnIsDisabled,
        style: modalStyles?.close
    }), closableObj.closeIcon) : null;
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-container`, modalClassNames?.container),
        style: modalStyles?.container
    }, closerNode, headerNode, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", $6a4ad2e35a066f94$var$_extends({
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-body`, modalClassNames?.body),
        style: {
            ...bodyStyle,
            ...modalStyles?.body
        }
    }, bodyProps), children), footerNode);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
        key: "dialog-element",
        role: "dialog",
        "aria-labelledby": title ? ariaId : null,
        "aria-modal": "true",
        ref: mergedRef,
        style: {
            ...style,
            ...contentStyle
        },
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, className),
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        tabIndex: -1,
        onFocus: (e)=>{
            ignoreElement(e.target);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $3d58fe1b796a9635$export$2e2bcd8739ae039), {
        shouldUpdate: visible || forceRender
    }, modalRender ? modalRender(content) : content));
});
var $6a4ad2e35a066f94$export$2e2bcd8739ae039 = $6a4ad2e35a066f94$var$Panel;


function $700deee8f10ef94c$var$_extends() {
    $700deee8f10ef94c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $700deee8f10ef94c$var$_extends.apply(this, arguments);
}
const $700deee8f10ef94c$var$Content = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { prefixCls: prefixCls, title: title, style: style, className: className, visible: visible, forceRender: forceRender, destroyOnHidden: destroyOnHidden, motionName: motionName, ariaId: ariaId, onVisibleChanged: onVisibleChanged, mousePosition: mousePosition } = props;
    const dialogRef = (0, $cQmXV.useRef)(null);
    const panelRef = (0, $cQmXV.useRef)(null);
    // ============================== Refs ==============================
    $cQmXV.useImperativeHandle(ref, ()=>({
            ...panelRef.current,
            inMotion: dialogRef.current.inMotion,
            enableMotion: dialogRef.current.enableMotion
        }));
    // ============================= Style ==============================
    const [transformOrigin, setTransformOrigin] = $cQmXV.useState();
    const contentStyle = {};
    if (transformOrigin) contentStyle.transformOrigin = transformOrigin;
    function onPrepare() {
        if (!dialogRef.current?.nativeElement) return;
        const elementOffset = (0, $37e16f62421bd510$export$cc800923e997bb8)(dialogRef.current.nativeElement);
        setTransformOrigin(mousePosition && (mousePosition.x || mousePosition.y) ? `${mousePosition.x - elementOffset.left}px ${mousePosition.y - elementOffset.top}px` : "");
    }
    // ============================= Render =============================
    return /*#__PURE__*/ $cQmXV.createElement((0, $04c53b89814950f8$export$2e2bcd8739ae039), {
        visible: visible,
        onVisibleChanged: onVisibleChanged,
        onAppearPrepare: onPrepare,
        onEnterPrepare: onPrepare,
        forceRender: forceRender,
        motionName: motionName,
        removeOnLeave: destroyOnHidden,
        ref: dialogRef
    }, ({ className: motionClassName, style: motionStyle }, motionRef)=>/*#__PURE__*/ $cQmXV.createElement((0, $6a4ad2e35a066f94$export$2e2bcd8739ae039), $700deee8f10ef94c$var$_extends({}, props, {
            ref: panelRef,
            title: title,
            ariaId: ariaId,
            prefixCls: prefixCls,
            holderRef: motionRef,
            style: {
                ...motionStyle,
                ...style,
                ...contentStyle
            },
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(className, motionClassName)
        })));
});
var $700deee8f10ef94c$export$2e2bcd8739ae039 = $700deee8f10ef94c$var$Content;



var $cQmXV = parcelRequire("cQmXV");


function $254ce519a3d50abc$var$_extends() {
    $254ce519a3d50abc$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $254ce519a3d50abc$var$_extends.apply(this, arguments);
}
const $254ce519a3d50abc$var$Mask = (props)=>{
    const { prefixCls: prefixCls, style: style, visible: visible, maskProps: maskProps, motionName: motionName, className: className } = props;
    return /*#__PURE__*/ $cQmXV.createElement((0, $04c53b89814950f8$export$2e2bcd8739ae039), {
        key: "mask",
        visible: visible,
        motionName: motionName,
        leavedClassName: `${prefixCls}-mask-hidden`
    }, ({ className: motionClassName, style: motionStyle }, ref)=>/*#__PURE__*/ $cQmXV.createElement("div", $254ce519a3d50abc$var$_extends({
            ref: ref,
            style: {
                ...motionStyle,
                ...style
            },
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-mask`, motionClassName, className)
        }, maskProps)));
};
var $254ce519a3d50abc$export$2e2bcd8739ae039 = $254ce519a3d50abc$var$Mask;


function $56c876b086d5e384$var$_extends() {
    $56c876b086d5e384$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $56c876b086d5e384$var$_extends.apply(this, arguments);
}
const $56c876b086d5e384$var$Dialog = (props)=>{
    const { prefixCls: prefixCls = "rc-dialog", zIndex: zIndex, visible: visible = false, focusTriggerAfterClose: focusTriggerAfterClose = true, wrapStyle: wrapStyle, wrapClassName: wrapClassName, wrapProps: wrapProps, onClose: onClose, afterOpenChange: afterOpenChange, afterClose: afterClose, transitionName: // Dialog
    transitionName, animation: animation, closable: closable = true, mask: // Mask
    mask = true, maskTransitionName: maskTransitionName, maskAnimation: maskAnimation, maskClosable: maskClosable = true, maskStyle: maskStyle, maskProps: maskProps, rootClassName: rootClassName, rootStyle: rootStyle, classNames: modalClassNames, styles: modalStyles } = props;
    var prop;
    const lastOutSideActiveElementRef = (0, $cQmXV.useRef)(null);
    const wrapperRef = (0, $cQmXV.useRef)(null);
    const contentRef = (0, $cQmXV.useRef)(null);
    const [animatedVisible, setAnimatedVisible] = $cQmXV.useState(visible);
    const [isFixedPos, setIsFixedPos] = $cQmXV.useState(false);
    // ========================== Init ==========================
    const ariaId = (0, $a2da91bb60e2cbfb$export$2e2bcd8739ae039)();
    function saveLastOutSideActiveElementRef() {
        if (!(0, $2971d4d077005d97$export$2e2bcd8739ae039)(wrapperRef.current, document.activeElement)) lastOutSideActiveElementRef.current = document.activeElement;
    }
    function focusDialogContent() {
        if (!(0, $2971d4d077005d97$export$2e2bcd8739ae039)(wrapperRef.current, document.activeElement)) contentRef.current?.focus();
    }
    // ========================= Events =========================
    // Close action will trigger by:
    //   1. When hide motion end
    //   2. Controlled `open` to `false` immediately after set to `true` which will not trigger motion
    function doClose() {
        // Clean up scroll bar & focus back
        setAnimatedVisible(false);
        if (mask && lastOutSideActiveElementRef.current && focusTriggerAfterClose) {
            try {
                lastOutSideActiveElementRef.current.focus({
                    preventScroll: true
                });
            } catch (e) {
            // Do nothing
            }
            lastOutSideActiveElementRef.current = null;
        }
        // Trigger afterClose only when change visible from true to false
        if (animatedVisible) afterClose?.();
    }
    function onDialogVisibleChanged(newVisible) {
        // Try to focus
        if (newVisible) focusDialogContent();
        else doClose();
        afterOpenChange?.(newVisible);
    }
    function onInternalClose(e) {
        onClose?.(e);
    }
    // >>> Content
    const mouseDownOnMaskRef = (0, $cQmXV.useRef)(false);
    // >>> Wrapper
    // Close only when element not on dialog
    let onWrapperClick = null;
    if (maskClosable) onWrapperClick = (e)=>{
        if (wrapperRef.current === e.target && mouseDownOnMaskRef.current) onInternalClose(e);
    };
    function onWrapperMouseDown(e) {
        mouseDownOnMaskRef.current = e.target === wrapperRef.current;
    }
    // ========================= Effect =========================
    (0, $cQmXV.useEffect)(()=>{
        if (visible) {
            mouseDownOnMaskRef.current = false;
            setAnimatedVisible(true);
            saveLastOutSideActiveElementRef();
            // Calc the position style
            if (wrapperRef.current) {
                const computedWrapStyle = getComputedStyle(wrapperRef.current);
                setIsFixedPos(computedWrapStyle.position === "fixed");
            }
        } else if (animatedVisible && contentRef.current.enableMotion() && !contentRef.current.inMotion()) doClose();
    }, [
        visible
    ]);
    const mergedStyle = {
        zIndex: zIndex,
        ...wrapStyle,
        ...modalStyles?.wrapper,
        display: !animatedVisible ? "none" : null
    };
    // ========================= Render =========================
    return /*#__PURE__*/ $cQmXV.createElement("div", $56c876b086d5e384$var$_extends({
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-root`, rootClassName),
        style: rootStyle
    }, (0, $4b5c733d1d7bb306$export$2e2bcd8739ae039)(props, {
        data: true
    })), /*#__PURE__*/ $cQmXV.createElement((0, $254ce519a3d50abc$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        visible: mask && visible,
        motionName: (0, $37e16f62421bd510$export$ec1a7ebf4579c1c3)(prefixCls, maskTransitionName, maskAnimation),
        style: {
            zIndex: zIndex,
            ...maskStyle,
            ...modalStyles?.mask
        },
        maskProps: maskProps,
        className: modalClassNames?.mask
    }), /*#__PURE__*/ $cQmXV.createElement("div", $56c876b086d5e384$var$_extends({
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-wrap`, wrapClassName, modalClassNames?.wrapper),
        ref: wrapperRef,
        onClick: onWrapperClick,
        onMouseDown: onWrapperMouseDown,
        style: mergedStyle
    }, wrapProps), /*#__PURE__*/ $cQmXV.createElement((0, $700deee8f10ef94c$export$2e2bcd8739ae039), $56c876b086d5e384$var$_extends({}, props, {
        isFixedPos: isFixedPos,
        ref: contentRef,
        closable: closable,
        ariaId: ariaId,
        prefixCls: prefixCls,
        visible: visible && animatedVisible,
        onClose: onInternalClose,
        onVisibleChanged: onDialogVisibleChanged,
        motionName: (0, $37e16f62421bd510$export$ec1a7ebf4579c1c3)(prefixCls, transitionName, animation)
    }))));
};
var $56c876b086d5e384$export$2e2bcd8739ae039 = $56c876b086d5e384$var$Dialog;


function $69232ce867aa36f4$var$_extends() {
    $69232ce867aa36f4$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $69232ce867aa36f4$var$_extends.apply(this, arguments);
}
// fix issue #10656
/*
 * getContainer remarks
 * Custom container should not be return, because in the Portal component, it will remove the
 * return container element here, if the custom container is the only child of it's component,
 * like issue #10656, It will has a conflict with removeChild method in react-dom.
 * So here should add a child (div element) to custom container.
 * */ const $69232ce867aa36f4$var$DialogWrap = (props)=>{
    const { visible: visible, getContainer: getContainer, forceRender: forceRender, destroyOnHidden: destroyOnHidden = false, afterClose: afterClose, closable: closable, panelRef: panelRef, keyboard: keyboard = true, scrollLock: scrollLock = true, onClose: onClose } = props;
    const { scrollLock: _, ...restProps } = props;
    const [animatedVisible, setAnimatedVisible] = $cQmXV.useState(visible);
    const refContext = $cQmXV.useMemo(()=>({
            panel: panelRef
        }), [
        panelRef
    ]);
    const onEsc = ({ top: top, event: event })=>{
        if (top && keyboard) {
            event.stopPropagation();
            onClose?.(event);
            return;
        }
    };
    $cQmXV.useEffect(()=>{
        if (visible) setAnimatedVisible(true);
    }, [
        visible
    ]);
    // Destroy on close will remove wrapped div
    if (!forceRender && destroyOnHidden && !animatedVisible) return null;
    return /*#__PURE__*/ $cQmXV.createElement((0, $2a0fa8251ff4e268$export$ee4e38b469b6f5d1).Provider, {
        value: refContext
    }, /*#__PURE__*/ $cQmXV.createElement((0, $aa72a6fdf7676c76$export$2e2bcd8739ae039), {
        open: visible || forceRender || animatedVisible,
        onEsc: onEsc,
        autoDestroy: false,
        getContainer: getContainer,
        autoLock: scrollLock && (visible || animatedVisible)
    }, /*#__PURE__*/ $cQmXV.createElement((0, $56c876b086d5e384$export$2e2bcd8739ae039), $69232ce867aa36f4$var$_extends({}, restProps, {
        destroyOnHidden: destroyOnHidden,
        afterClose: ()=>{
            const closableObj = closable && typeof closable === "object" ? closable : {};
            const { afterClose: closableAfterClose } = closableObj || {};
            closableAfterClose?.();
            afterClose?.();
            setAnimatedVisible(false);
        }
    }))));
};
var $69232ce867aa36f4$export$2e2bcd8739ae039 = $69232ce867aa36f4$var$DialogWrap;



var $a9b31d366a3333bc$export$2e2bcd8739ae039 = (0, $69232ce867aa36f4$export$2e2bcd8739ae039);










const $9580af07fc1cd6bb$export$7dbdadf5e9653129 = ()=>(0, $78361969822ad097$export$2e2bcd8739ae039)() && window.document.documentElement;











var $cQmXV = parcelRequire("cQmXV");





var $cQmXV = parcelRequire("cQmXV");


"use client";
const $d774f7a58a781ecb$var$NormalCancelBtn = ()=>{
    const { cancelButtonProps: cancelButtonProps, cancelTextLocale: cancelTextLocale, onCancel: onCancel } = (0, $cQmXV.useContext)((0, $082c89892c23fb74$export$ab57792b9b6974a6));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $1fc505710073cde5$export$2e2bcd8739ae039), {
        onClick: onCancel,
        ...cancelButtonProps
    }, cancelTextLocale);
};
var $d774f7a58a781ecb$export$2e2bcd8739ae039 = $d774f7a58a781ecb$var$NormalCancelBtn;



var $cQmXV = parcelRequire("cQmXV");



"use client";
const $f7a80caaa0b460ee$var$NormalOkBtn = ()=>{
    const { confirmLoading: confirmLoading, okButtonProps: okButtonProps, okType: okType, okTextLocale: okTextLocale, onOk: onOk } = (0, $cQmXV.useContext)((0, $082c89892c23fb74$export$ab57792b9b6974a6));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $1fc505710073cde5$export$2e2bcd8739ae039), {
        ...(0, $62e55ded4111e367$export$19bc9a290855952)(okType),
        loading: confirmLoading,
        onClick: onOk,
        ...okButtonProps
    }, okTextLocale);
};
var $f7a80caaa0b460ee$export$2e2bcd8739ae039 = $f7a80caaa0b460ee$var$NormalOkBtn;




"use client";
function $ff18fe854a1cc3f1$export$97c34646962d356e(prefixCls, closeIcon) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("span", {
        className: `${prefixCls}-close-x`
    }, closeIcon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $837faca566926e3c$export$2e2bcd8739ae039), {
        className: `${prefixCls}-close-icon`
    }));
}
const $ff18fe854a1cc3f1$export$a06f1c675e846f6f = (props)=>{
    const { okText: okText, okType: okType = "primary", cancelText: cancelText, confirmLoading: confirmLoading, onOk: onOk, onCancel: onCancel, okButtonProps: okButtonProps, cancelButtonProps: cancelButtonProps, footer: footer } = props;
    const [locale] = (0, $c953dac9d015386e$export$2e2bcd8739ae039)("Modal", (0, $66f33989f9adff20$export$1b6004afda18cd51)());
    // ================== Locale Text ==================
    const okTextLocale = okText || locale?.okText;
    const cancelTextLocale = cancelText || locale?.cancelText;
    const memoizedValue = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useMemo(()=>{
        return {
            confirmLoading: confirmLoading,
            okButtonProps: okButtonProps,
            cancelButtonProps: cancelButtonProps,
            okTextLocale: okTextLocale,
            cancelTextLocale: cancelTextLocale,
            okType: okType,
            onOk: onOk,
            onCancel: onCancel
        };
    }, [
        confirmLoading,
        okButtonProps,
        cancelButtonProps,
        okTextLocale,
        cancelTextLocale,
        okType,
        onOk,
        onCancel
    ]);
    let footerNode;
    if ((0, $8e2d153a3c855782$export$f6e2535fb5126e54)(footer) || typeof footer === "undefined") {
        footerNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $d774f7a58a781ecb$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $f7a80caaa0b460ee$export$2e2bcd8739ae039), null));
        if ((0, $8e2d153a3c855782$export$f6e2535fb5126e54)(footer)) footerNode = footer(footerNode, {
            OkBtn: (0, $f7a80caaa0b460ee$export$2e2bcd8739ae039),
            CancelBtn: (0, $d774f7a58a781ecb$export$2e2bcd8739ae039)
        });
        footerNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $082c89892c23fb74$export$7c9538f5f3c365e9), {
            value: memoizedValue
        }, footerNode);
    } else footerNode = footer;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $4f0e1ea30330557c$export$6adb5f3b918b11bb), {
        disabled: false
    }, footerNode);
};








function $a9d8dac8425075a6$var$box(position) {
    return {
        position: position,
        inset: 0
    };
}
const $a9d8dac8425075a6$export$8bb6dada04673ddd = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    return [
        {
            [`${componentCls}-root`]: {
                [`${componentCls}${antCls}-zoom-enter, ${componentCls}${antCls}-zoom-appear`]: {
                    // reset scale avoid mousePosition bug
                    transform: "none",
                    opacity: 0,
                    animationDuration: token.motionDurationSlow,
                    // https://github.com/ant-design/ant-design/issues/11777
                    userSelect: "none"
                },
                // https://github.com/ant-design/ant-design/issues/37329
                // https://github.com/ant-design/ant-design/issues/40272
                [`${componentCls}${antCls}-zoom-leave ${componentCls}-container`]: {
                    pointerEvents: "none"
                },
                [`${componentCls}-mask`]: {
                    ...$a9d8dac8425075a6$var$box("fixed"),
                    zIndex: token.zIndexPopupBase,
                    height: "100%",
                    backgroundColor: token.colorBgMask,
                    pointerEvents: "none",
                    [`&${componentCls}-mask-blur`]: {
                        backdropFilter: "blur(4px)"
                    },
                    [`${componentCls}-hidden`]: {
                        display: "none"
                    }
                },
                [`${componentCls}-wrap`]: {
                    ...$a9d8dac8425075a6$var$box("fixed"),
                    zIndex: token.zIndexPopupBase,
                    overflow: "auto",
                    outline: 0,
                    WebkitOverflowScrolling: "touch"
                }
            }
        },
        {
            [`${componentCls}-root`]: (0, $3fd8fb5c97e7786c$export$2909268c8354a12)(token)
        }
    ];
};
const $a9d8dac8425075a6$var$genModalStyle = (token)=>{
    const { componentCls: componentCls, motionDurationMid: motionDurationMid } = token;
    return [
        // ======================== Root =========================
        {
            [`${componentCls}-root`]: {
                [`${componentCls}-wrap-rtl`]: {
                    direction: "rtl"
                },
                [`${componentCls}-centered`]: {
                    textAlign: "center",
                    "&::before": {
                        display: "inline-block",
                        width: 0,
                        height: "100%",
                        verticalAlign: "middle",
                        content: '""'
                    },
                    [componentCls]: {
                        top: 0,
                        display: "inline-block",
                        paddingBottom: 0,
                        textAlign: "start",
                        verticalAlign: "middle"
                    }
                },
                [`@media (max-width: ${token.screenSMMax}px)`]: {
                    [componentCls]: {
                        maxWidth: "calc(100vw - 16px)",
                        margin: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.marginXS)} auto`
                    },
                    [`${componentCls}-centered`]: {
                        [componentCls]: {
                            flex: 1
                        }
                    }
                }
            }
        },
        // ======================== Modal ========================
        {
            [componentCls]: {
                ...(0, $519d20bf207ce864$export$23997c3e44cc1c59)(token),
                pointerEvents: "none",
                position: "relative",
                top: 100,
                width: "auto",
                maxWidth: `calc(100vw - ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.calc(token.margin).mul(2).equal())})`,
                margin: "0 auto",
                "&:focus-visible": {
                    borderRadius: token.borderRadiusLG,
                    ...(0, $519d20bf207ce864$export$6539948f0a737e39)(token)
                },
                [`${componentCls}-title`]: {
                    margin: 0,
                    color: token.titleColor,
                    fontWeight: token.fontWeightStrong,
                    fontSize: token.titleFontSize,
                    lineHeight: token.titleLineHeight,
                    wordWrap: "break-word"
                },
                [`${componentCls}-container`]: {
                    position: "relative",
                    backgroundColor: token.contentBg,
                    backgroundClip: "padding-box",
                    border: 0,
                    borderRadius: token.borderRadiusLG,
                    boxShadow: token.boxShadow,
                    pointerEvents: "auto",
                    padding: token.contentPadding
                },
                [`${componentCls}-close`]: {
                    position: "absolute",
                    top: token.calc(token.modalHeaderHeight).sub(token.modalCloseBtnSize).div(2).equal(),
                    insetInlineEnd: token.calc(token.modalHeaderHeight).sub(token.modalCloseBtnSize).div(2).equal(),
                    zIndex: token.calc(token.zIndexPopupBase).add(10).equal(),
                    padding: 0,
                    color: token.modalCloseIconColor,
                    fontWeight: token.fontWeightStrong,
                    lineHeight: 1,
                    textDecoration: "none",
                    background: "transparent",
                    borderRadius: token.borderRadiusSM,
                    width: token.modalCloseBtnSize,
                    height: token.modalCloseBtnSize,
                    border: 0,
                    outline: 0,
                    cursor: "pointer",
                    transition: [
                        "color",
                        "background-color"
                    ].map((prop)=>`${prop} ${motionDurationMid}`).join(", "),
                    "&-x": {
                        display: "flex",
                        fontSize: token.fontSizeLG,
                        fontStyle: "normal",
                        lineHeight: (0, $05f34ed03d41967d$export$523c0b569236b342)(token.modalCloseBtnSize),
                        justifyContent: "center",
                        textTransform: "none",
                        textRendering: "auto"
                    },
                    "&:disabled": {
                        pointerEvents: "none"
                    },
                    "&:hover": {
                        color: token.modalCloseIconHoverColor,
                        backgroundColor: token.colorBgTextHover,
                        textDecoration: "none"
                    },
                    "&:active": {
                        backgroundColor: token.colorBgTextActive
                    },
                    ...(0, $519d20bf207ce864$export$a44db842bcb28231)(token)
                },
                [`${componentCls}-header`]: {
                    color: token.colorText,
                    background: token.headerBg,
                    borderRadius: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.borderRadiusLG)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.borderRadiusLG)} 0 0`,
                    marginBottom: token.headerMarginBottom,
                    padding: token.headerPadding,
                    borderBottom: token.headerBorderBottom
                },
                [`${componentCls}-body`]: {
                    fontSize: token.fontSize,
                    lineHeight: token.lineHeight,
                    wordWrap: "break-word",
                    padding: token.bodyPadding,
                    [`${componentCls}-body-skeleton`]: {
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        margin: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.margin)} auto`
                    }
                },
                [`${componentCls}-footer`]: {
                    textAlign: "end",
                    background: token.footerBg,
                    marginTop: token.footerMarginTop,
                    padding: token.footerPadding,
                    borderTop: token.footerBorderTop,
                    borderRadius: token.footerBorderRadius,
                    [`> ${token.antCls}-btn + ${token.antCls}-btn`]: {
                        marginInlineStart: token.marginXS
                    }
                },
                [`${componentCls}-open`]: {
                    overflow: "hidden"
                }
            }
        },
        // ======================== Pure =========================
        {
            [`${componentCls}-pure-panel`]: {
                top: "auto",
                padding: 0,
                display: "flex",
                flexDirection: "column",
                [`${componentCls}-container,
          ${componentCls}-body,
          ${componentCls}-confirm-body-wrapper`]: {
                    display: "flex",
                    flexDirection: "column",
                    flex: "auto"
                },
                [`${componentCls}-confirm-body`]: {
                    marginBottom: "auto"
                }
            }
        }
    ];
};
const $a9d8dac8425075a6$var$genRTLStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-root`]: {
            [`${componentCls}-wrap-rtl`]: {
                direction: "rtl",
                [`${componentCls}-confirm-body`]: {
                    direction: "rtl"
                }
            }
        }
    };
};
const $a9d8dac8425075a6$var$genResponsiveWidthStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const oriGridMediaSizesMap = (0, $55bc859fb97e8d96$export$6353f655434817c5)(token);
    const gridMediaSizesMap = {
        ...oriGridMediaSizesMap
    };
    delete gridMediaSizesMap.xs;
    const cssVarPrefix = `--${componentCls.replace(".", "")}-`;
    const responsiveStyles = Object.keys(gridMediaSizesMap).map((key)=>({
            [`@media (min-width: ${(0, $05f34ed03d41967d$export$523c0b569236b342)(gridMediaSizesMap[key])})`]: {
                width: `var(${cssVarPrefix}${key}-width)`
            }
        }));
    return {
        [`${componentCls}-root`]: {
            [componentCls]: [].concat((0, $68381b18b974dc9f$export$2e2bcd8739ae039)(Object.keys(oriGridMediaSizesMap).map((currentKey, index)=>{
                const previousKey = Object.keys(oriGridMediaSizesMap)[index - 1];
                return previousKey ? {
                    [`${cssVarPrefix}${currentKey}-width`]: `var(${cssVarPrefix}${previousKey}-width)`
                } : null;
            })), [
                {
                    width: `var(${cssVarPrefix}xs-width)`
                }
            ], (0, $68381b18b974dc9f$export$2e2bcd8739ae039)(responsiveStyles))
        }
    };
};
const $a9d8dac8425075a6$export$362fb92a8f81bbf9 = (token)=>{
    const headerPaddingVertical = token.padding;
    const headerFontSize = token.fontSizeHeading5;
    const headerLineHeight = token.lineHeightHeading5;
    const modalToken = (0, $fef50f256b80dfa5$export$4950aa0f605343fb)(token, {
        modalHeaderHeight: token.calc(token.calc(headerLineHeight).mul(headerFontSize).equal()).add(token.calc(headerPaddingVertical).mul(2).equal()).equal(),
        modalFooterBorderColorSplit: token.colorSplit,
        modalFooterBorderStyle: token.lineType,
        modalFooterBorderWidth: token.lineWidth,
        modalCloseIconColor: token.colorIcon,
        modalCloseIconHoverColor: token.colorIconHover,
        modalCloseBtnSize: token.controlHeight,
        modalConfirmIconSize: token.fontHeight,
        modalTitleHeight: token.calc(token.titleFontSize).mul(token.titleLineHeight).equal()
    });
    return modalToken;
};
const $a9d8dac8425075a6$export$9ca1be8807fe0675 = (token)=>({
        footerBg: "transparent",
        headerBg: "transparent",
        titleLineHeight: token.lineHeightHeading5,
        titleFontSize: token.fontSizeHeading5,
        contentBg: token.colorBgElevated,
        titleColor: token.colorTextHeading,
        // internal
        contentPadding: token.wireframe ? 0 : `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.paddingMD)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.paddingContentHorizontalLG)}`,
        headerPadding: token.wireframe ? `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.padding)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.paddingLG)}` : 0,
        headerBorderBottom: token.wireframe ? `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorSplit}` : "none",
        headerMarginBottom: token.wireframe ? 0 : token.marginXS,
        bodyPadding: token.wireframe ? token.paddingLG : 0,
        footerPadding: token.wireframe ? `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.paddingXS)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.padding)}` : 0,
        footerBorderTop: token.wireframe ? `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorSplit}` : "none",
        footerBorderRadius: token.wireframe ? `0 0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.borderRadiusLG)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.borderRadiusLG)}` : 0,
        footerMarginTop: token.wireframe ? 0 : token.marginSM,
        confirmBodyPadding: token.wireframe ? `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.padding * 2)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.padding * 2)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.paddingLG)}` : 0,
        confirmIconMarginInlineEnd: token.wireframe ? token.margin : token.marginSM,
        confirmBtnsMarginTop: token.wireframe ? token.marginLG : token.marginSM,
        mask: true
    });
var $a9d8dac8425075a6$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$51ec95de45185b42)("Modal", (token)=>{
    const modalToken = $a9d8dac8425075a6$export$362fb92a8f81bbf9(token);
    return [
        $a9d8dac8425075a6$var$genModalStyle(modalToken),
        $a9d8dac8425075a6$var$genRTLStyle(modalToken),
        $a9d8dac8425075a6$export$8bb6dada04673ddd(modalToken),
        (0, $35f7d6eebd10a5fe$export$f5d123412490d9dc)(modalToken, "zoom"),
        $a9d8dac8425075a6$var$genResponsiveWidthStyle(modalToken)
    ];
}, $a9d8dac8425075a6$export$9ca1be8807fe0675, {
    unitless: {
        titleLineHeight: true
    }
});


"use client";
let $be18ea0779130850$var$mousePosition;
// ref: https://github.com/ant-design/ant-design/issues/15795
const $be18ea0779130850$var$getClickPosition = (e)=>{
    $be18ea0779130850$var$mousePosition = {
        x: e.pageX,
        y: e.pageY
    };
    // 100ms 内发生过点击事件，则从点击位置动画展示
    // 否则直接 zoom 展示
    // 这样可以兼容非点击方式展开
    setTimeout(()=>{
        $be18ea0779130850$var$mousePosition = null;
    }, 100);
};
// 只有点击事件支持从鼠标位置动画展开
if ((0, $9580af07fc1cd6bb$export$7dbdadf5e9653129)()) document.documentElement.addEventListener("click", $be18ea0779130850$var$getClickPosition, true);
const $be18ea0779130850$var$Modal = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, open: open, wrapClassName: wrapClassName, centered: centered, getContainer: getContainer, style: style, width: width = 520, footer: footer, classNames: classNames, styles: styles, children: children, loading: loading, confirmLoading: confirmLoading, zIndex: customizeZIndex, mousePosition: customizeMousePosition, onOk: onOk, onCancel: onCancel, okButtonProps: okButtonProps, cancelButtonProps: cancelButtonProps, destroyOnHidden: destroyOnHidden, destroyOnClose: destroyOnClose, panelRef: panelRef = null, closable: closable, mask: modalMask, modalRender: modalRender, maskClosable: maskClosable, _semanticOmit: _semanticOmit, scrollLock: scrollLock, focusTriggerAfterClose: // Focusable
    focusTriggerAfterClose, focusable: focusable, _renderSemanticContent: _renderSemanticContent, ...restProps } = props;
    const { getPopupContainer: getContextPopupContainer, getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles, centered: contextCentered, cancelButtonProps: contextCancelButtonProps, okButtonProps: contextOkButtonProps, mask: contextMask, focusable: contextFocusable } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("modal");
    const { modal: modalContext } = $cQmXV.useContext((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    const [closableAfterClose, onClose] = $cQmXV.useMemo(()=>{
        if (typeof closable === "boolean") return [
            undefined,
            undefined
        ];
        return [
            closable?.afterClose,
            closable?.onClose
        ];
    }, [
        closable
    ]);
    const prefixCls = getPrefixCls("modal", customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    // ============================ Mask ============================
    const [mergedMask, maskBlurClassName, mergeMaskClosable] = (0, $43591a623a20c2b6$export$a4ac1bdd74570410)(modalMask, contextMask, prefixCls, maskClosable);
    // ========================== Focusable =========================
    const mergedFocusable = (0, $16771e6a3398e203$export$2e2bcd8739ae039)({
        ...contextFocusable,
        ...focusable
    }, mergedMask, focusTriggerAfterClose);
    // ============================ Open ============================
    const handleCancel = (e)=>{
        if (confirmLoading) return;
        onCancel?.(e);
        onClose?.();
    };
    const handleOk = (e)=>{
        onOk?.(e);
        onClose?.();
    };
    var deprecatedName, newName;
    // Style
    const rootCls = (0, $2237081acd3cfc09$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $a9d8dac8425075a6$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const wrapClassNameExtended = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(wrapClassName, {
        [`${prefixCls}-centered`]: centered ?? contextCentered,
        [`${prefixCls}-wrap-rtl`]: direction === "rtl"
    });
    const dialogFooter = footer !== null && !loading ? /*#__PURE__*/ $cQmXV.createElement((0, $ff18fe854a1cc3f1$export$a06f1c675e846f6f), {
        ...props,
        okButtonProps: {
            ...contextOkButtonProps,
            ...okButtonProps
        },
        onOk: handleOk,
        cancelButtonProps: {
            ...contextCancelButtonProps,
            ...cancelButtonProps
        },
        onCancel: handleCancel
    }) : null;
    const [rawClosable, mergedCloseIcon, closeBtnIsDisabled, ariaProps] = (0, $d68006bfa4b86b8f$export$aa101db403ccf5f3)((0, $d68006bfa4b86b8f$export$51ad9c30389f050b)(props), (0, $d68006bfa4b86b8f$export$51ad9c30389f050b)(modalContext), {
        closable: true,
        closeIcon: /*#__PURE__*/ $cQmXV.createElement((0, $837faca566926e3c$export$2e2bcd8739ae039), {
            className: `${prefixCls}-close-icon`
        }),
        closeIconRender: (icon)=>(0, $ff18fe854a1cc3f1$export$97c34646962d356e)(prefixCls, icon)
    });
    const mergedClosable = rawClosable ? {
        disabled: closeBtnIsDisabled,
        closeIcon: mergedCloseIcon,
        afterClose: closableAfterClose,
        ...ariaProps
    } : false;
    // ============================ modalRender ============================
    const mergedModalRender = modalRender ? (node)=>/*#__PURE__*/ $cQmXV.createElement("div", {
            className: `${prefixCls}-render`
        }, modalRender(node)) : undefined;
    // ============================ Refs ============================
    // Select `ant-modal-container` by `panelRef`
    const panelClassName = `.${prefixCls}-${modalRender ? "render" : "container"}`;
    const innerPanelRef = (0, $f1d001121ad33e46$export$94ab53417567be34)(panelClassName);
    const mergedPanelRef = (0, $10341b937b26f69d$export$ab452c34e8e05029)(panelRef, innerPanelRef);
    // ============================ zIndex ============================
    const [zIndex, contextZIndex] = (0, $b2b300e6909d7707$export$3e7906d4075187a4)("Modal", customizeZIndex);
    const mergedProps = {
        ...props,
        width: width,
        panelRef: panelRef,
        focusTriggerAfterClose: mergedFocusable.focusTriggerAfterClose,
        focusable: mergedFocusable,
        mask: mergedMask,
        maskClosable: mergeMaskClosable,
        zIndex: zIndex
    };
    const [mergedClassNames, mergedStyles] = (0, $30c5f9f911d4f61b$export$648566b068f28737)([
        contextClassNames,
        classNames,
        maskBlurClassName
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    const dialogClassNames = _semanticOmit ? (0, $e8c5093aebad6025$export$2e2bcd8739ae039)(mergedClassNames, _semanticOmit) : mergedClassNames;
    const dialogStyles = _semanticOmit ? (0, $e8c5093aebad6025$export$2e2bcd8739ae039)(mergedStyles, _semanticOmit) : mergedStyles;
    const semanticContent = _renderSemanticContent ? _renderSemanticContent({
        classNames: mergedClassNames,
        styles: mergedStyles
    }) : children;
    // =========================== Width ============================
    const [numWidth, responsiveWidth] = $cQmXV.useMemo(()=>{
        if ((0, $8e2d153a3c855782$export$53b83ca8eaab0383)(width)) return [
            undefined,
            width
        ];
        return [
            width,
            undefined
        ];
    }, [
        width
    ]);
    const responsiveWidthVars = $cQmXV.useMemo(()=>{
        const vars = {};
        if (responsiveWidth) Object.keys(responsiveWidth).forEach((breakpoint)=>{
            const breakpointWidth = responsiveWidth[breakpoint];
            if ((0, $8e2d153a3c855782$export$826fff653a329e83)(breakpointWidth)) vars[`--${prefixCls}-${breakpoint}-width`] = (0, $8e2d153a3c855782$export$7e4aa119212bc614)(breakpointWidth) ? `${breakpointWidth}px` : breakpointWidth;
        });
        return vars;
    }, [
        prefixCls,
        responsiveWidth
    ]);
    // =========================== Render ===========================
    return /*#__PURE__*/ $cQmXV.createElement((0, $1585084388e75c84$export$2e2bcd8739ae039), {
        form: true,
        space: true
    }, /*#__PURE__*/ $cQmXV.createElement((0, $2a7b32ec1626bb34$export$2e2bcd8739ae039).Provider, {
        value: contextZIndex
    }, /*#__PURE__*/ $cQmXV.createElement((0, $a9b31d366a3333bc$export$2e2bcd8739ae039), {
        width: numWidth,
        ...restProps,
        zIndex: zIndex,
        getContainer: getContainer === undefined ? getContextPopupContainer : getContainer,
        prefixCls: prefixCls,
        rootClassName: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(hashId, rootClassName, cssVarCls, rootCls, dialogClassNames.root),
        rootStyle: dialogStyles.root,
        footer: dialogFooter,
        visible: open,
        mousePosition: customizeMousePosition ?? $be18ea0779130850$var$mousePosition,
        onClose: handleCancel,
        closable: mergedClosable,
        closeIcon: mergedCloseIcon,
        transitionName: (0, $047a5f051ebda8ba$export$27c72201b1d09951)(rootPrefixCls, "zoom", props.transitionName),
        maskTransitionName: (0, $047a5f051ebda8ba$export$27c72201b1d09951)(rootPrefixCls, "fade", props.maskTransitionName),
        mask: mergedMask,
        maskClosable: mergeMaskClosable,
        scrollLock: scrollLock,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(hashId, className, contextClassName),
        style: {
            ...contextStyle,
            ...style,
            ...responsiveWidthVars
        },
        classNames: {
            ...dialogClassNames,
            wrapper: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(dialogClassNames.wrapper, wrapClassNameExtended)
        },
        styles: dialogStyles,
        panelRef: mergedPanelRef,
        destroyOnHidden: destroyOnHidden ?? destroyOnClose,
        modalRender: mergedModalRender,
        // Focusable
        focusTriggerAfterClose: mergedFocusable.focusTriggerAfterClose,
        focusTrap: mergedFocusable.trap
    }, loading ? /*#__PURE__*/ $cQmXV.createElement((0, $e855c7114b2916ed$export$2e2bcd8739ae039), {
        active: true,
        title: false,
        paragraph: {
            rows: 4
        },
        className: `${prefixCls}-body-skeleton`
    }) : semanticContent)));
};
var $be18ea0779130850$export$2e2bcd8739ae039 = $be18ea0779130850$var$Modal;






// ============================= Confirm ==============================
const $804421cdad7d9868$var$genModalConfirmStyle = (token)=>{
    const { componentCls: componentCls, titleFontSize: titleFontSize, titleLineHeight: titleLineHeight, modalConfirmIconSize: modalConfirmIconSize, fontSize: fontSize, lineHeight: lineHeight, modalTitleHeight: modalTitleHeight, fontHeight: fontHeight, confirmBodyPadding: confirmBodyPadding } = token;
    const confirmComponentCls = `${componentCls}-confirm`;
    return {
        [confirmComponentCls]: {
            "&-rtl": {
                direction: "rtl"
            },
            [`${token.antCls}-modal-header`]: {
                display: "none"
            },
            [`${confirmComponentCls}-body-wrapper`]: {
                ...(0, $519d20bf207ce864$export$8c467e8859fdef13)()
            },
            [`&${componentCls} ${componentCls}-body`]: {
                padding: confirmBodyPadding
            },
            // ====================== Body ======================
            [`${confirmComponentCls}-body`]: {
                display: "flex",
                flexWrap: "nowrap",
                alignItems: "start",
                [`> ${token.iconCls}`]: {
                    flex: "none",
                    fontSize: modalConfirmIconSize,
                    marginInlineEnd: token.confirmIconMarginInlineEnd,
                    marginTop: token.calc(token.calc(fontHeight).sub(modalConfirmIconSize).equal()).div(2).equal()
                },
                [`&-has-title > ${token.iconCls}`]: {
                    marginTop: token.calc(token.calc(modalTitleHeight).sub(modalConfirmIconSize).equal()).div(2).equal()
                }
            },
            [`${confirmComponentCls}-paragraph`]: {
                display: "flex",
                flexDirection: "column",
                flex: "auto",
                rowGap: token.marginXS,
                // https://github.com/ant-design/ant-design/issues/51912
                maxWidth: `calc(100% - ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.marginSM)})`
            },
            [`${confirmComponentCls}-body-no-icon ${confirmComponentCls}-paragraph`]: {
                maxWidth: "100%"
            },
            // https://github.com/ant-design/ant-design/issues/48159
            [`${token.iconCls} + ${confirmComponentCls}-paragraph`]: {
                maxWidth: `calc(100% - ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.calc(token.modalConfirmIconSize).add(token.marginSM).equal())})`
            },
            [`${confirmComponentCls}-title`]: {
                color: token.colorTextHeading,
                fontWeight: token.fontWeightStrong,
                fontSize: titleFontSize,
                lineHeight: titleLineHeight
            },
            [`${confirmComponentCls}-container`]: {
                color: token.colorText,
                fontSize: fontSize,
                lineHeight: lineHeight
            },
            // ===================== Footer =====================
            [`${confirmComponentCls}-btns`]: {
                textAlign: "end",
                marginTop: token.confirmBtnsMarginTop,
                [`${token.antCls}-btn + ${token.antCls}-btn`]: {
                    marginBottom: 0,
                    marginInlineStart: token.marginXS
                }
            }
        },
        [`${confirmComponentCls}-error ${confirmComponentCls}-body > ${token.iconCls}`]: {
            color: token.colorError
        },
        [`${confirmComponentCls}-warning ${confirmComponentCls}-body > ${token.iconCls},
        ${confirmComponentCls}-confirm ${confirmComponentCls}-body > ${token.iconCls}`]: {
            color: token.colorWarning
        },
        [`${confirmComponentCls}-info ${confirmComponentCls}-body > ${token.iconCls}`]: {
            color: token.colorInfo
        },
        [`${confirmComponentCls}-success ${confirmComponentCls}-body > ${token.iconCls}`]: {
            color: token.colorSuccess
        }
    };
};
var // ============================== Export ==============================
$804421cdad7d9868$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$1537386bc155ea56)([
    "Modal",
    "confirm"
], (token)=>{
    const modalToken = (0, $a9d8dac8425075a6$export$362fb92a8f81bbf9)(token);
    return $804421cdad7d9868$var$genModalConfirmStyle(modalToken);
}, (0, $a9d8dac8425075a6$export$9ca1be8807fe0675), {
    // confirm is weak than modal since no conflict here
    order: -1000
});


"use client";
const $ace70434c6abc6f1$var$CONFIRM_OMIT_SEMANTIC_NAMES = [
    "body"
];
const $ace70434c6abc6f1$export$78cf841dc2c9f0b5 = (props)=>{
    const { prefixCls: prefixCls, icon: icon, okText: okText, cancelText: cancelText, confirmPrefixCls: confirmPrefixCls, type: type, okCancel: okCancel, footer: footer, // Legacy for static function usage
    locale: staticLocale, autoFocusButton: autoFocusButton, focusable: focusable, contentClassName: contentClassName, contentStyle: contentStyle, ...restProps } = props;
    const { infoIcon: infoIcon, successIcon: successIcon, errorIcon: errorIcon, warningIcon: warningIcon } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("modal");
    // Icon
    let mergedIcon = icon;
    // 支持传入 { icon: null } 或 { icon: false } 来隐藏`Modal.confirm`默认的Icon
    if (icon === undefined) switch(type){
        case "info":
            mergedIcon = (0, $55c1e81905598a5b$export$2e2bcd8739ae039)(infoIcon, /*#__PURE__*/ $cQmXV.createElement((0, $a164337416b087a0$export$2e2bcd8739ae039), null));
            break;
        case "success":
            mergedIcon = (0, $55c1e81905598a5b$export$2e2bcd8739ae039)(successIcon, /*#__PURE__*/ $cQmXV.createElement((0, $017e758d1ebbd854$export$2e2bcd8739ae039), null));
            break;
        case "error":
            mergedIcon = (0, $55c1e81905598a5b$export$2e2bcd8739ae039)(errorIcon, /*#__PURE__*/ $cQmXV.createElement((0, $ff9add21dbbc2684$export$2e2bcd8739ae039), null));
            break;
        default:
            mergedIcon = (0, $55c1e81905598a5b$export$2e2bcd8739ae039)(warningIcon, /*#__PURE__*/ $cQmXV.createElement((0, $39711bf58c19fcd8$export$2e2bcd8739ae039), null));
    }
    // 默认为 true，保持向下兼容
    const mergedOkCancel = okCancel ?? type === "confirm";
    const mergedAutoFocusButton = $cQmXV.useMemo(()=>{
        const base = focusable?.autoFocusButton || autoFocusButton;
        return base || base === null ? base : "ok";
    }, [
        autoFocusButton,
        focusable?.autoFocusButton
    ]);
    const [locale] = (0, $c953dac9d015386e$export$2e2bcd8739ae039)("Modal");
    const mergedLocale = staticLocale || locale;
    // ================== Locale Text ==================
    const okTextLocale = okText || (mergedOkCancel ? mergedLocale?.okText : mergedLocale?.justOkText);
    const cancelTextLocale = cancelText || mergedLocale?.cancelText;
    // ================= Context Value =================
    const { closable: closable } = restProps;
    const { onClose: onClose } = (0, $8e2d153a3c855782$export$53b83ca8eaab0383)(closable) ? closable : {};
    const memoizedValue = $cQmXV.useMemo(()=>{
        return {
            autoFocusButton: mergedAutoFocusButton,
            cancelTextLocale: cancelTextLocale,
            okTextLocale: okTextLocale,
            mergedOkCancel: mergedOkCancel,
            onClose: onClose,
            ...restProps
        };
    }, [
        mergedAutoFocusButton,
        cancelTextLocale,
        okTextLocale,
        mergedOkCancel,
        onClose,
        restProps
    ]);
    // ====================== Footer Origin Node ======================
    const footerOriginNode = /*#__PURE__*/ $cQmXV.createElement($cQmXV.Fragment, null, /*#__PURE__*/ $cQmXV.createElement((0, $4bdd37f1840bccd1$export$2e2bcd8739ae039), null), /*#__PURE__*/ $cQmXV.createElement((0, $26fdee6a6282db39$export$2e2bcd8739ae039), null));
    const hasTitle = (0, $8e2d153a3c855782$export$72280d5f896dac9a)(props.title);
    const hasIcon = (0, $8e2d153a3c855782$export$72280d5f896dac9a)(mergedIcon);
    const bodyCls = `${confirmPrefixCls}-body`;
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        className: `${confirmPrefixCls}-body-wrapper`
    }, /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(bodyCls, {
            [`${bodyCls}-has-title`]: hasTitle,
            [`${bodyCls}-no-icon`]: !hasIcon
        })
    }, mergedIcon, /*#__PURE__*/ $cQmXV.createElement("div", {
        className: `${confirmPrefixCls}-paragraph`
    }, hasTitle && /*#__PURE__*/ $cQmXV.createElement("span", {
        className: `${confirmPrefixCls}-title`
    }, props.title), /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${confirmPrefixCls}-content`, contentClassName),
        style: contentStyle
    }, props.content))), footer === undefined || (0, $8e2d153a3c855782$export$f6e2535fb5126e54)(footer) ? /*#__PURE__*/ $cQmXV.createElement((0, $082c89892c23fb74$export$7c9538f5f3c365e9), {
        value: memoizedValue
    }, /*#__PURE__*/ $cQmXV.createElement("div", {
        className: `${confirmPrefixCls}-btns`
    }, (0, $8e2d153a3c855782$export$f6e2535fb5126e54)(footer) ? footer(footerOriginNode, {
        OkBtn: $26fdee6a6282db39$export$2e2bcd8739ae039,
        CancelBtn: $4bdd37f1840bccd1$export$2e2bcd8739ae039
    }) : footerOriginNode)) : footer, /*#__PURE__*/ $cQmXV.createElement((0, $804421cdad7d9868$export$2e2bcd8739ae039), {
        prefixCls: prefixCls
    }));
};
const $ace70434c6abc6f1$var$ConfirmDialog = (props)=>{
    const { close: close, zIndex: zIndex, maskStyle: maskStyle, direction: direction, prefixCls: prefixCls, wrapClassName: wrapClassName, rootPrefixCls: rootPrefixCls, bodyStyle: bodyStyle, closable: closable = false, onConfirm: onConfirm, styles: styles, title: title, mask: mask, maskClosable: maskClosable, okButtonProps: okButtonProps, cancelButtonProps: cancelButtonProps } = props;
    const { cancelButtonProps: contextCancelButtonProps, okButtonProps: contextOkButtonProps } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("modal");
    var deprecatedName, newName;
    const confirmPrefixCls = `${prefixCls}-confirm`;
    const width = props.width || 416;
    const style = props.style || {};
    const semanticStyles = (0, $8e2d153a3c855782$export$f6e2535fb5126e54)(styles) ? (info)=>({
            body: bodyStyle,
            mask: maskStyle,
            ...styles(info)
        }) : {
        body: bodyStyle,
        mask: maskStyle,
        ...styles
    };
    const modalProps = (0, $e8c5093aebad6025$export$2e2bcd8739ae039)(props, [
        "bodyStyle",
        "maskStyle"
    ]);
    const classString = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(confirmPrefixCls, `${confirmPrefixCls}-${props.type}`, {
        [`${confirmPrefixCls}-rtl`]: direction === "rtl"
    }, props.className);
    // ========================== Mask ==========================
    // 默认为 false，保持旧版默认行为
    const mergedMask = $cQmXV.useMemo(()=>{
        const nextMaskConfig = (0, $43591a623a20c2b6$export$c0a98b854d121670)(mask, maskClosable);
        nextMaskConfig.closable ?? (nextMaskConfig.closable = false);
        return nextMaskConfig;
    }, [
        mask,
        maskClosable
    ]);
    // ========================= zIndex =========================
    const [, token] = (0, $b22e03a54a548614$export$2e2bcd8739ae039)();
    const mergedZIndex = $cQmXV.useMemo(()=>{
        if (zIndex !== undefined) return zIndex;
        // Static always use max zIndex
        return token.zIndexPopupBase + (0, $b2b300e6909d7707$export$33ada7d8845f7e5);
    }, [
        zIndex,
        token
    ]);
    // ========================= Render =========================
    return /*#__PURE__*/ $cQmXV.createElement((0, $be18ea0779130850$export$2e2bcd8739ae039), {
        ...modalProps,
        className: classString,
        wrapClassName: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)({
            [`${confirmPrefixCls}-centered`]: !!props.centered
        }, wrapClassName),
        onCancel: ()=>{
            close?.({
                triggerCancel: true
            });
            onConfirm?.(false);
        },
        title: title,
        footer: null,
        transitionName: (0, $047a5f051ebda8ba$export$27c72201b1d09951)(rootPrefixCls || "", "zoom", props.transitionName),
        maskTransitionName: (0, $047a5f051ebda8ba$export$27c72201b1d09951)(rootPrefixCls || "", "fade", props.maskTransitionName),
        mask: mergedMask,
        style: style,
        styles: semanticStyles,
        width: width,
        zIndex: mergedZIndex,
        closable: closable,
        _semanticOmit: $ace70434c6abc6f1$var$CONFIRM_OMIT_SEMANTIC_NAMES,
        _renderSemanticContent: ({ classNames: mergedClassNames, styles: mergedStyles })=>/*#__PURE__*/ $cQmXV.createElement($ace70434c6abc6f1$export$78cf841dc2c9f0b5, {
                ...props,
                confirmPrefixCls: confirmPrefixCls,
                okButtonProps: {
                    ...contextOkButtonProps,
                    ...okButtonProps
                },
                cancelButtonProps: {
                    ...contextCancelButtonProps,
                    ...cancelButtonProps
                },
                contentClassName: mergedClassNames.body,
                contentStyle: mergedStyles.body
            })
    });
};
const $ace70434c6abc6f1$var$ConfirmDialogWrapper = (props)=>{
    const { rootPrefixCls: rootPrefixCls, iconPrefixCls: iconPrefixCls, direction: direction, theme: theme } = props;
    return /*#__PURE__*/ $cQmXV.createElement((0, $5764e43cf38ca965$export$2e2bcd8739ae039), {
        prefixCls: rootPrefixCls,
        iconPrefixCls: iconPrefixCls,
        direction: direction,
        theme: theme
    }, /*#__PURE__*/ $cQmXV.createElement($ace70434c6abc6f1$var$ConfirmDialog, {
        ...props
    }));
};
var $ace70434c6abc6f1$export$2e2bcd8739ae039 = $ace70434c6abc6f1$var$ConfirmDialogWrapper;


const $a8536a885c54e4a2$var$destroyFns = [];
var $a8536a885c54e4a2$export$2e2bcd8739ae039 = $a8536a885c54e4a2$var$destroyFns;



"use client";
let $798d44bf86f1caed$var$defaultRootPrefixCls = "";
function $798d44bf86f1caed$var$getRootPrefixCls() {
    return $798d44bf86f1caed$var$defaultRootPrefixCls;
}
const $798d44bf86f1caed$var$ConfirmDialogWrapper = (props)=>{
    const { prefixCls: customizePrefixCls, getContainer: getContainer, direction: direction } = props;
    const runtimeLocale = (0, $66f33989f9adff20$export$1b6004afda18cd51)();
    const config = (0, $cQmXV.useContext)((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    const rootPrefixCls = $798d44bf86f1caed$var$getRootPrefixCls() || config.getPrefixCls();
    // because Modal.config set rootPrefixCls, which is different from other components
    const prefixCls = customizePrefixCls || `${rootPrefixCls}-modal`;
    let mergedGetContainer = getContainer;
    if (mergedGetContainer === false) mergedGetContainer = undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $ace70434c6abc6f1$export$2e2bcd8739ae039), {
        ...props,
        rootPrefixCls: rootPrefixCls,
        prefixCls: prefixCls,
        iconPrefixCls: config.iconPrefixCls,
        theme: config.theme,
        direction: direction ?? config.direction,
        locale: config.locale?.Modal ?? runtimeLocale,
        getContainer: mergedGetContainer
    });
};
function $798d44bf86f1caed$export$2e2bcd8739ae039(config) {
    const global = (0, $5764e43cf38ca965$export$f9cd1e43211d8a4a)();
    const container = document.createDocumentFragment();
    let currentConfig = {
        ...config,
        close: close,
        open: true
    };
    let timeoutId;
    function destroy(...args) {
        const triggerCancel = args.some((param)=>param?.triggerCancel);
        if (triggerCancel) config.onCancel?.(()=>{}, ...args.slice(1));
        for(let i = 0; i < (0, $a8536a885c54e4a2$export$2e2bcd8739ae039).length; i++){
            const fn = (0, $a8536a885c54e4a2$export$2e2bcd8739ae039)[i];
            if (fn === close) {
                (0, $a8536a885c54e4a2$export$2e2bcd8739ae039).splice(i, 1);
                break;
            }
        }
        (0, $462099a4eea3a68d$export$121e2d597d222bad)(container).then(()=>{
        // Do nothing
        });
    }
    const scheduleRender = (props)=>{
        clearTimeout(timeoutId);
        /**
     * https://github.com/ant-design/ant-design/issues/23623
     *
     * Sync render blocks React event. Let's make this async.
     */ timeoutId = setTimeout(()=>{
            const rootPrefixCls = global.getPrefixCls(undefined, $798d44bf86f1caed$var$getRootPrefixCls());
            const iconPrefixCls = global.getIconPrefixCls();
            const theme = global.getTheme();
            const dom = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($798d44bf86f1caed$var$ConfirmDialogWrapper, {
                ...props
            });
            (0, $462099a4eea3a68d$export$b3890eb0ae9dca99)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $5764e43cf38ca965$export$2e2bcd8739ae039), {
                prefixCls: rootPrefixCls,
                iconPrefixCls: iconPrefixCls,
                theme: theme
            }, (0, $8e2d153a3c855782$export$f6e2535fb5126e54)(global.holderRender) ? global.holderRender(dom) : dom), container);
        });
    };
    function close(...args) {
        currentConfig = {
            ...currentConfig,
            open: false,
            afterClose: ()=>{
                if ((0, $8e2d153a3c855782$export$f6e2535fb5126e54)(config.afterClose)) config.afterClose();
                // @ts-ignore
                destroy.apply(this, args);
            }
        };
        scheduleRender(currentConfig);
    }
    function update(configUpdate) {
        if ((0, $8e2d153a3c855782$export$f6e2535fb5126e54)(configUpdate)) currentConfig = configUpdate(currentConfig);
        else currentConfig = {
            ...currentConfig,
            ...configUpdate
        };
        scheduleRender(currentConfig);
    }
    scheduleRender(currentConfig);
    (0, $a8536a885c54e4a2$export$2e2bcd8739ae039).push(close);
    return {
        destroy: close,
        update: update
    };
}
function $798d44bf86f1caed$export$503fa8fed137d104(props) {
    return {
        ...props,
        type: "warning"
    };
}
function $798d44bf86f1caed$export$2f728eab0dacbb2e(props) {
    return {
        ...props,
        type: "info"
    };
}
function $798d44bf86f1caed$export$2b5f8d7f29c805d4(props) {
    return {
        ...props,
        type: "success"
    };
}
function $798d44bf86f1caed$export$60e9e0884ce12b55(props) {
    return {
        ...props,
        type: "error"
    };
}
function $798d44bf86f1caed$export$665b64399d4af99c(props) {
    return {
        ...props,
        type: "confirm"
    };
}
function $798d44bf86f1caed$export$ff0b30c638ae2396({ rootPrefixCls: rootPrefixCls }) {
    $798d44bf86f1caed$var$defaultRootPrefixCls = rootPrefixCls;
}





var $cQmXV = parcelRequire("cQmXV");










"use client";
const $3b3f1bade0a37e51$var$PurePanel = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, closeIcon: closeIcon, closable: closable, type: type, title: title, children: children, footer: footer, style: style, classNames: classNames, styles: styles, ...restProps } = props;
    const { getPrefixCls: getPrefixCls } = $cQmXV.useContext((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    const { className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("modal");
    const rootPrefixCls = getPrefixCls();
    const prefixCls = customizePrefixCls || getPrefixCls("modal");
    const rootCls = (0, $2237081acd3cfc09$export$2e2bcd8739ae039)(rootPrefixCls);
    const [hashId, cssVarCls] = (0, $a9d8dac8425075a6$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const contextStyleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $30c5f9f911d4f61b$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: props
    });
    const confirmPrefixCls = `${prefixCls}-confirm`;
    // Choose target props by confirm mark
    let additionalProps = {};
    if (type) additionalProps = {
        closable: closable ?? false,
        title: "",
        footer: "",
        children: /*#__PURE__*/ $cQmXV.createElement((0, $ace70434c6abc6f1$export$78cf841dc2c9f0b5), {
            ...props,
            prefixCls: prefixCls,
            confirmPrefixCls: confirmPrefixCls,
            rootPrefixCls: rootPrefixCls,
            content: children
        })
    };
    else additionalProps = {
        closable: closable ?? true,
        title: title,
        footer: footer !== null && /*#__PURE__*/ $cQmXV.createElement((0, $ff18fe854a1cc3f1$export$a06f1c675e846f6f), {
            ...props
        }),
        children: children
    };
    return /*#__PURE__*/ $cQmXV.createElement((0, $6a4ad2e35a066f94$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(hashId, `${prefixCls}-pure-panel`, type && confirmPrefixCls, type && `${confirmPrefixCls}-${type}`, className, contextClassName, cssVarCls, rootCls, mergedClassNames.root),
        style: mergedStyles.root,
        ...restProps,
        closeIcon: (0, $ff18fe854a1cc3f1$export$97c34646962d356e)(prefixCls, closeIcon),
        closable: closable,
        classNames: mergedClassNames,
        styles: mergedStyles,
        ...additionalProps
    });
};
var $3b3f1bade0a37e51$export$2e2bcd8739ae039 = (0, $f2e41308375833b9$export$29e2a8c3cdb34b03)($3b3f1bade0a37e51$var$PurePanel);




var $cQmXV = parcelRequire("cQmXV");


var $cQmXV = parcelRequire("cQmXV");
const $0b98e369541a8ab3$export$26425c9dd59b4436 = ()=>{
    const [elements, setElements] = $cQmXV.useState([]);
    const patchElement = $cQmXV.useCallback((element)=>{
        // append a new element to elements (and create a new ref)
        setElements((originElements)=>[].concat((0, $68381b18b974dc9f$export$2e2bcd8739ae039)(originElements), [
                element
            ]));
        // return a function that removes the new element out of elements (and create a new ref)
        // it works a little like useEffect
        return ()=>{
            setElements((originElements)=>originElements.filter((ele)=>ele !== element));
        };
    }, []);
    return [
        elements,
        patchElement
    ];
};





var $cQmXV = parcelRequire("cQmXV");





"use client";
const $2fa313390b8c0cdd$var$HookModal = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { afterClose: hookAfterClose, config: config, ...restProps } = props;
    const [open, setOpen] = $cQmXV.useState(true);
    const [innerConfig, setInnerConfig] = $cQmXV.useState(config);
    const { direction: direction, getPrefixCls: getPrefixCls } = $cQmXV.useContext((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls("modal");
    const rootPrefixCls = getPrefixCls();
    const afterClose = ()=>{
        hookAfterClose();
        innerConfig.afterClose?.();
    };
    const close = (...args)=>{
        setOpen(false);
        const triggerCancel = args.some((param)=>param?.triggerCancel);
        if (triggerCancel) innerConfig.onCancel?.(()=>{}, ...args.slice(1));
    };
    $cQmXV.useImperativeHandle(ref, ()=>({
            destroy: close,
            update: (newConfig)=>{
                setInnerConfig((originConfig)=>{
                    const nextConfig = (0, $8e2d153a3c855782$export$f6e2535fb5126e54)(newConfig) ? newConfig(originConfig) : newConfig;
                    return {
                        ...originConfig,
                        ...nextConfig
                    };
                });
            }
        }));
    const mergedOkCancel = innerConfig.okCancel ?? innerConfig.type === "confirm";
    const [contextLocale] = (0, $c953dac9d015386e$export$2e2bcd8739ae039)("Modal", (0, $4ab0c7032ff9de6a$export$2e2bcd8739ae039).Modal);
    return /*#__PURE__*/ $cQmXV.createElement((0, $ace70434c6abc6f1$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        rootPrefixCls: rootPrefixCls,
        ...innerConfig,
        close: close,
        open: open,
        afterClose: afterClose,
        okText: innerConfig.okText || (mergedOkCancel ? contextLocale?.okText : contextLocale?.justOkText),
        direction: innerConfig.direction || direction,
        cancelText: innerConfig.cancelText || contextLocale?.cancelText,
        ...restProps
    });
});
var $2fa313390b8c0cdd$export$2e2bcd8739ae039 = $2fa313390b8c0cdd$var$HookModal;


"use client";
let $8ae684fb3eaf2f43$var$uuid = 0;
const $8ae684fb3eaf2f43$var$ElementsHolder = /*#__PURE__*/ $cQmXV.memo(/*#__PURE__*/ $cQmXV.forwardRef((_props, ref)=>{
    const [elements, patchElement] = (0, $0b98e369541a8ab3$export$26425c9dd59b4436)();
    $cQmXV.useImperativeHandle(ref, ()=>({
            patchElement: patchElement
        }), [
        patchElement
    ]);
    return /*#__PURE__*/ $cQmXV.createElement($cQmXV.Fragment, null, elements);
}));
function $8ae684fb3eaf2f43$var$useModal() {
    const holderRef = $cQmXV.useRef(null);
    // ========================== Effect ==========================
    const [actionQueue, setActionQueue] = $cQmXV.useState([]);
    $cQmXV.useEffect(()=>{
        if (actionQueue.length) {
            const cloneQueue = (0, $68381b18b974dc9f$export$2e2bcd8739ae039)(actionQueue);
            cloneQueue.forEach((action)=>{
                action();
            });
            setActionQueue([]);
        }
    }, [
        actionQueue
    ]);
    // =========================== Hook ===========================
    const getConfirmFunc = $cQmXV.useCallback((withFunc)=>function hookConfirm(config) {
            $8ae684fb3eaf2f43$var$uuid += 1;
            const modalRef = /*#__PURE__*/ $cQmXV.createRef();
            // Proxy to promise with `onClose`
            let resolvePromise;
            const promise = new Promise((resolve)=>{
                resolvePromise = resolve;
            });
            let silent = false;
            let closeFunc;
            const modal = /*#__PURE__*/ $cQmXV.createElement((0, $2fa313390b8c0cdd$export$2e2bcd8739ae039), {
                key: `modal-${$8ae684fb3eaf2f43$var$uuid}`,
                config: withFunc(config),
                ref: modalRef,
                afterClose: ()=>{
                    closeFunc?.();
                },
                isSilent: ()=>silent,
                onConfirm: (confirmed)=>{
                    resolvePromise(confirmed);
                }
            });
            closeFunc = holderRef.current?.patchElement(modal);
            if (closeFunc) (0, $a8536a885c54e4a2$export$2e2bcd8739ae039).push(closeFunc);
            const instance = {
                destroy: ()=>{
                    function destroyAction() {
                        modalRef.current?.destroy();
                    }
                    if (modalRef.current) destroyAction();
                    else setActionQueue((prev)=>[].concat((0, $68381b18b974dc9f$export$2e2bcd8739ae039)(prev), [
                            destroyAction
                        ]));
                },
                update: (newConfig)=>{
                    function updateAction() {
                        modalRef.current?.update(newConfig);
                    }
                    if (modalRef.current) updateAction();
                    else setActionQueue((prev)=>[].concat((0, $68381b18b974dc9f$export$2e2bcd8739ae039)(prev), [
                            updateAction
                        ]));
                },
                then: (resolve)=>{
                    silent = true;
                    return promise.then(resolve);
                }
            };
            return instance;
        }, []);
    const fns = $cQmXV.useMemo(()=>({
            info: getConfirmFunc((0, $798d44bf86f1caed$export$2f728eab0dacbb2e)),
            success: getConfirmFunc((0, $798d44bf86f1caed$export$2b5f8d7f29c805d4)),
            error: getConfirmFunc((0, $798d44bf86f1caed$export$60e9e0884ce12b55)),
            warning: getConfirmFunc((0, $798d44bf86f1caed$export$503fa8fed137d104)),
            confirm: getConfirmFunc((0, $798d44bf86f1caed$export$665b64399d4af99c))
        }), [
        getConfirmFunc
    ]);
    return [
        fns,
        /*#__PURE__*/ $cQmXV.createElement($8ae684fb3eaf2f43$var$ElementsHolder, {
            key: "modal-holder",
            ref: holderRef
        })
    ];
}
var $8ae684fb3eaf2f43$export$2e2bcd8739ae039 = $8ae684fb3eaf2f43$var$useModal;


"use client";
function $05a90c67d3627fd9$var$modalWarn(props) {
    return (0, $798d44bf86f1caed$export$2e2bcd8739ae039)((0, $798d44bf86f1caed$export$503fa8fed137d104)(props));
}
const $05a90c67d3627fd9$var$Modal = (0, $be18ea0779130850$export$2e2bcd8739ae039);
$05a90c67d3627fd9$var$Modal.useModal = (0, $8ae684fb3eaf2f43$export$2e2bcd8739ae039);
$05a90c67d3627fd9$var$Modal.info = function infoFn(props) {
    return (0, $798d44bf86f1caed$export$2e2bcd8739ae039)((0, $798d44bf86f1caed$export$2f728eab0dacbb2e)(props));
};
$05a90c67d3627fd9$var$Modal.success = function successFn(props) {
    return (0, $798d44bf86f1caed$export$2e2bcd8739ae039)((0, $798d44bf86f1caed$export$2b5f8d7f29c805d4)(props));
};
$05a90c67d3627fd9$var$Modal.error = function errorFn(props) {
    return (0, $798d44bf86f1caed$export$2e2bcd8739ae039)((0, $798d44bf86f1caed$export$60e9e0884ce12b55)(props));
};
$05a90c67d3627fd9$var$Modal.warning = $05a90c67d3627fd9$var$modalWarn;
$05a90c67d3627fd9$var$Modal.warn = $05a90c67d3627fd9$var$modalWarn;
$05a90c67d3627fd9$var$Modal.confirm = function confirmFn(props) {
    return (0, $798d44bf86f1caed$export$2e2bcd8739ae039)((0, $798d44bf86f1caed$export$665b64399d4af99c)(props));
};
$05a90c67d3627fd9$var$Modal.destroyAll = function destroyAllFn() {
    while((0, $a8536a885c54e4a2$export$2e2bcd8739ae039).length){
        const close = (0, $a8536a885c54e4a2$export$2e2bcd8739ae039).pop();
        if (close) close();
    }
};
$05a90c67d3627fd9$var$Modal.config = (0, $798d44bf86f1caed$export$ff0b30c638ae2396);
$05a90c67d3627fd9$var$Modal._InternalPanelDoNotUseOrYouWillBeFired = (0, $3b3f1bade0a37e51$export$2e2bcd8739ae039);
var $05a90c67d3627fd9$export$2e2bcd8739ae039 = $05a90c67d3627fd9$var$Modal;


var $cQmXV = parcelRequire("cQmXV");












var $cQmXV = parcelRequire("cQmXV");









// ============================== Styles ==============================
const $3262048170780820$var$genBaseStyle = (token)=>{
    const { paddingXXS: paddingXXS, lineWidth: lineWidth, tagPaddingHorizontal: tagPaddingHorizontal, componentCls: componentCls, calc: calc } = token;
    const paddingInline = calc(tagPaddingHorizontal).sub(lineWidth).equal();
    const iconMarginInline = calc(paddingXXS).sub(lineWidth).equal();
    return {
        // Result
        [componentCls]: {
            ...(0, $519d20bf207ce864$export$23997c3e44cc1c59)(token),
            display: "inline-block",
            height: "auto",
            paddingInline: paddingInline,
            fontSize: token.tagFontSize,
            lineHeight: token.tagLineHeight,
            whiteSpace: "nowrap",
            backgroundColor: token.defaultBg,
            border: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
            borderRadius: token.borderRadiusSM,
            opacity: 1,
            transition: `all ${token.motionDurationMid}`,
            textAlign: "start",
            position: "relative",
            // RTL
            [`&${componentCls}-rtl`]: {
                direction: "rtl"
            },
            "&, a, a:hover": {
                color: token.defaultColor
            },
            [`${componentCls}-close-icon`]: {
                marginInlineStart: iconMarginInline,
                fontSize: token.tagIconSize,
                color: token.colorIcon,
                cursor: "pointer",
                transition: `all ${token.motionDurationMid}`,
                "&:hover": {
                    color: token.colorTextHeading
                }
            },
            "&-checkable": {
                backgroundColor: "transparent",
                borderColor: "transparent",
                cursor: "pointer",
                [`&:not(${componentCls}-checkable-checked):hover`]: {
                    color: token.colorPrimary,
                    backgroundColor: token.colorFillSecondary
                },
                "&:active, &-checked": {
                    color: token.colorTextLightSolid
                },
                "&-checked": {
                    backgroundColor: token.colorPrimary,
                    "&:hover": {
                        backgroundColor: token.colorPrimaryHover
                    }
                },
                "&:active": {
                    backgroundColor: token.colorPrimaryActive
                },
                "&-disabled": {
                    cursor: "not-allowed",
                    [`&:not(${componentCls}-checkable-checked)`]: {
                        color: token.colorTextDisabled,
                        "&:hover": {
                            backgroundColor: "transparent"
                        }
                    },
                    [`&${componentCls}-checkable-checked`]: {
                        color: token.colorTextDisabled,
                        backgroundColor: token.colorBgContainerDisabled
                    },
                    "&:hover, &:active": {
                        backgroundColor: token.colorBgContainerDisabled,
                        color: token.colorTextDisabled
                    },
                    [`&:not(${componentCls}-checkable-checked):hover`]: {
                        color: token.colorTextDisabled
                    }
                },
                "&-group": {
                    display: "flex",
                    flexWrap: "wrap",
                    gap: token.paddingXS
                }
            },
            "&-hidden": {
                display: "none"
            },
            // Icons from third-party libraries are a bare `<svg>`, which none of the `.anticon`
            // rules reach. An `<svg>` has no baseline of its own, so it is aligned by its bottom
            // margin edge (CSS 2.1 §10.8.1) and rides above the text. Centre it instead: unlike an
            // `.anticon` (whose `<svg>` is always `1em`, so a fixed `-0.125em` nudge suffices), a
            // third-party `<svg>` may be sized in `px`, so the correction must not depend on size.
            // `display: inline-block` keeps it an atomic inline box so `vertical-align` still applies even
            // under a CSS reset that forces `svg { display: block }` (e.g. Tailwind Preflight), which would
            // otherwise drop the icon onto its own line. `vertical-align: middle` centres the margin box on
            // the x-height line; `margin-block-end` then lifts it by half its own value onto the cap-height
            // centre (capHeight − xHeight ≈ 0.2em across typical fonts), keeping it centred at any icon size.
            // Only matches a bare `<svg>`: an `.anticon` keeps its `<svg>` one level deeper.
            "> svg": {
                display: "inline-block",
                verticalAlign: "middle",
                marginBlockEnd: "0.2em"
            },
            // To ensure that a space will be placed between character and `Icon`.
            [`> ${token.iconCls} + span, > span + ${token.iconCls}, > svg + span, > span + svg`]: {
                marginInlineStart: paddingInline
            }
        },
        [`&${token.componentCls}-solid`]: {
            borderColor: "transparent",
            color: token.colorTextLightSolid,
            backgroundColor: token.colorBgSolid,
            [`&${componentCls}-default`]: {
                color: token.solidTextColor
            }
        },
        [`${componentCls}-filled`]: {
            borderColor: "transparent",
            backgroundColor: token.tagBorderlessBg
        },
        [`&${componentCls}-disabled`]: {
            color: token.colorTextDisabled,
            cursor: "not-allowed",
            backgroundColor: token.colorBgContainerDisabled,
            a: {
                cursor: "not-allowed",
                pointerEvents: "none",
                color: token.colorTextDisabled,
                "&:hover": {
                    color: token.colorTextDisabled
                }
            },
            "a&": {
                "&:hover, &:active": {
                    color: token.colorTextDisabled
                }
            },
            [`&${componentCls}-outlined`]: {
                borderColor: token.colorBorderDisabled
            },
            [`&${componentCls}-solid, &${componentCls}-filled`]: {
                color: token.colorTextDisabled,
                [`${componentCls}-close-icon`]: {
                    color: token.colorTextDisabled
                }
            },
            [`${componentCls}-close-icon`]: {
                cursor: "not-allowed",
                color: token.colorTextDisabled,
                "&:hover": {
                    color: token.colorTextDisabled
                }
            }
        }
    };
};
const $3262048170780820$export$362fb92a8f81bbf9 = (token)=>{
    const { lineWidth: lineWidth, fontSizeIcon: fontSizeIcon, calc: calc } = token;
    const tagFontSize = token.fontSizeSM;
    const tagToken = (0, $fef50f256b80dfa5$export$4950aa0f605343fb)(token, {
        tagFontSize: tagFontSize,
        tagLineHeight: (0, $05f34ed03d41967d$export$523c0b569236b342)(calc(token.lineHeightSM).mul(tagFontSize).equal()),
        tagIconSize: calc(fontSizeIcon).sub(calc(lineWidth).mul(2)).equal(),
        // Tag icon is much smaller
        tagPaddingHorizontal: 8,
        // Fixed padding.
        tagBorderlessBg: token.defaultBg
    });
    return tagToken;
};
const $3262048170780820$export$9ca1be8807fe0675 = (token)=>{
    const solidTextColor = (0, $41a5307a3420cf5b$export$6341b37cb79161da)(new (0, $e572682ae9022769$export$e8cc8a2e87e145b4)(token.colorBgSolid), "#fff") ? "#000" : "#fff";
    return {
        defaultBg: new (0, $3bb84f07fb2a2f32$export$2c4f38d6c0ecc25a)(token.colorFillTertiary).onBackground(token.colorBgContainer).toHexString(),
        defaultColor: token.colorText,
        solidTextColor: solidTextColor
    };
};
var $3262048170780820$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$51ec95de45185b42)("Tag", (token)=>{
    const tagToken = $3262048170780820$export$362fb92a8f81bbf9(token);
    return $3262048170780820$var$genBaseStyle(tagToken);
}, $3262048170780820$export$9ca1be8807fe0675);


"use client";
const $e92c1e6c7cc1e084$var$CheckableTag = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, style: style, className: className, checked: checked, children: children, icon: icon, onChange: onChange, onClick: onClick, onKeyDown: onKeyDown, disabled: customDisabled, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, tag: tag } = $cQmXV.useContext((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    const disabled = $cQmXV.useContext((0, $4f0e1ea30330557c$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled ?? disabled;
    const handleClick = (e)=>{
        if (mergedDisabled) return;
        onChange?.(!checked);
        onClick?.(e);
    };
    const handleKeyDown = (e)=>{
        onKeyDown?.(e);
        if (e.defaultPrevented || mergedDisabled) return;
        if (e.key === " ") {
            e.preventDefault();
            onChange?.(!checked);
        }
    };
    const prefixCls = getPrefixCls("tag", customizePrefixCls);
    // Style
    const [hashId, cssVarCls] = (0, $3262048170780820$export$2e2bcd8739ae039)(prefixCls);
    const cls = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-checkable`, {
        [`${prefixCls}-checkable-checked`]: checked,
        [`${prefixCls}-checkable-disabled`]: mergedDisabled
    }, tag?.className, className, hashId, cssVarCls);
    return /*#__PURE__*/ $cQmXV.createElement("span", {
        ...restProps,
        ref: ref,
        role: "checkbox",
        "aria-checked": checked,
        "aria-disabled": mergedDisabled || undefined,
        tabIndex: mergedDisabled ? -1 : 0,
        style: {
            ...style,
            ...tag?.style
        },
        className: cls,
        onClick: handleClick,
        onKeyDown: handleKeyDown
    }, icon, /*#__PURE__*/ $cQmXV.createElement("span", null, children));
});
var $e92c1e6c7cc1e084$export$2e2bcd8739ae039 = $e92c1e6c7cc1e084$var$CheckableTag;




var $cQmXV = parcelRequire("cQmXV");








"use client";
const $9b887b15b4b750bb$var$CheckableTagGroup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).forwardRef((props, ref)=>{
    const { id: id, prefixCls: customizePrefixCls, rootClassName: rootClassName, className: className, style: style, classNames: classNames, styles: styles, disabled: disabled, options: options, value: value, defaultValue: defaultValue, onChange: onChange, multiple: multiple, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("tag");
    const prefixCls = getPrefixCls("tag", customizePrefixCls);
    const groupPrefixCls = `${prefixCls}-checkable-group`;
    const rootCls = (0, $2237081acd3cfc09$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $3262048170780820$export$2e2bcd8739ae039)(prefixCls, rootCls);
    // ====================== Styles ======================
    const contextStyleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $30c5f9f911d4f61b$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: props
    });
    // =============================== Option ===============================
    const parsedOptions = (0, $cQmXV.useMemo)(()=>{
        if (!Array.isArray(options)) return [];
        return options.map((option)=>{
            if ((0, $8e2d153a3c855782$export$53b83ca8eaab0383)(option)) return option;
            return {
                value: option,
                label: option
            };
        });
    }, [
        options
    ]);
    // =============================== Values ===============================
    const [mergedValue, setMergedValue] = (0, $a51866d781137e08$export$2e2bcd8739ae039)(defaultValue, value);
    const handleChange = (checked, option)=>{
        let newValue = null;
        if (multiple) {
            const valueList = mergedValue || [];
            newValue = checked ? [].concat((0, $68381b18b974dc9f$export$2e2bcd8739ae039)(valueList), [
                option.value
            ]) : valueList.filter((item)=>item !== option.value);
        } else newValue = checked ? option.value : null;
        setMergedValue(newValue);
        onChange?.(newValue); // TS not support generic type in function call
    };
    // ================================ Refs ================================
    const divRef = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useRef(null);
    (0, $cQmXV.useImperativeHandle)(ref, ()=>({
            nativeElement: divRef.current
        }));
    // ================================ ARIA ================================
    const ariaProps = (0, $4b5c733d1d7bb306$export$2e2bcd8739ae039)(restProps, {
        aria: true,
        data: true
    });
    // =============================== Render ===============================
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
        ...ariaProps,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(groupPrefixCls, contextClassName, rootClassName, {
            [`${groupPrefixCls}-disabled`]: disabled,
            [`${groupPrefixCls}-rtl`]: direction === "rtl"
        }, hashId, cssVarCls, className, mergedClassNames.root),
        style: mergedStyles.root,
        id: id,
        ref: divRef
    }, parsedOptions.map((option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $e92c1e6c7cc1e084$export$2e2bcd8739ae039), {
            key: option.value,
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${groupPrefixCls}-item`, mergedClassNames.item, option.className),
            style: {
                ...mergedStyles.item,
                ...option.style
            },
            checked: multiple ? (mergedValue || []).includes(option.value) : mergedValue === option.value,
            onChange: (checked)=>handleChange(checked, option),
            disabled: disabled
        }, option.label)));
});
var $9b887b15b4b750bb$export$2e2bcd8739ae039 = $9b887b15b4b750bb$var$CheckableTagGroup;



var $cQmXV = parcelRequire("cQmXV");


function $c16fe1726155c51c$export$2e2bcd8739ae039(props, contextVariant) {
    const { color: color, variant: variant, bordered: bordered } = props;
    return $cQmXV.useMemo(()=>{
        const isInverseColor = color?.endsWith("-inverse");
        // =================== Variant ===================
        let nextVariant;
        if (variant) // `variant` first
        nextVariant = variant;
        else if (isInverseColor) // Fallback if using inverse color
        nextVariant = "solid";
        else if (bordered === false) // Fallback if using filled
        nextVariant = "filled";
        else // Finally not conflict, use context
        nextVariant = contextVariant || "filled";
        // ==================== Color ====================
        let nextColor = isInverseColor ? color?.replace("-inverse", "") : color;
        if (nextColor === undefined && nextVariant === "solid") nextColor = "default";
        // =============== Preset & Status ===============
        const nextIsPreset = (0, $4cbe68e4e955ed41$export$ee62ebd6a58c4884)(nextColor);
        const nextIsStatus = (0, $4cbe68e4e955ed41$export$88a0ba1f7d1ea40e)(nextColor);
        // ================== Customize ==================
        // When `color` is not preset color,
        // dynamic calculate the color pair.
        const tagStyle = {};
        if (!nextIsPreset && !nextIsStatus && nextColor) {
            if (nextVariant === "solid") tagStyle.backgroundColor = color;
            else {
                const hsl = new (0, $3bb84f07fb2a2f32$export$2c4f38d6c0ecc25a)(nextColor).toHsl();
                hsl.l = 0.95;
                tagStyle.backgroundColor = new (0, $3bb84f07fb2a2f32$export$2c4f38d6c0ecc25a)(hsl).toHexString();
                tagStyle.color = color;
                if (nextVariant === "outlined") tagStyle.borderColor = color;
            }
        }
        return [
            nextVariant,
            nextColor,
            nextIsPreset,
            nextIsStatus,
            tagStyle
        ];
    }, [
        color,
        variant,
        bordered,
        contextVariant
    ]);
}



// Style as status component


// ============================== Preset ==============================
const $14fd8feb9f6cec76$var$genPresetStyle = (token)=>(0, $7c652e13f0bdefc8$export$2e2bcd8739ae039)(token, (colorKey, { textColor: textColor, lightBorderColor: lightBorderColor, lightColor: lightColor, darkColor: darkColor })=>({
            [`${token.componentCls}${token.componentCls}-${colorKey}:not(${token.componentCls}-disabled)`]: {
                [`&${token.componentCls}-outlined`]: {
                    backgroundColor: lightColor,
                    borderColor: lightBorderColor,
                    color: textColor
                },
                [`&${token.componentCls}-solid`]: {
                    backgroundColor: darkColor,
                    borderColor: darkColor,
                    color: token.colorTextLightSolid
                },
                [`&${token.componentCls}-filled`]: {
                    backgroundColor: lightColor,
                    color: textColor
                }
            }
        }));
var // ============================== Export ==============================
$14fd8feb9f6cec76$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$1537386bc155ea56)([
    "Tag",
    "preset"
], (token)=>{
    const tagToken = (0, $3262048170780820$export$362fb92a8f81bbf9)(token);
    return $14fd8feb9f6cec76$var$genPresetStyle(tagToken);
}, (0, $3262048170780820$export$9ca1be8807fe0675));



function $cde3550ffa33ed38$export$2e2bcd8739ae039(str) {
    if (typeof str !== "string") return str;
    const ret = str.charAt(0).toUpperCase() + str.slice(1);
    return ret;
}



const $ffc1353c8f3314ca$var$genTagStatusStyle = (token, status, cssVariableType)=>{
    const capitalizedCssVariableType = (0, $cde3550ffa33ed38$export$2e2bcd8739ae039)(cssVariableType);
    return {
        [`${token.componentCls}${token.componentCls}-${status}:not(${token.componentCls}-disabled)`]: {
            [`&${token.componentCls}-outlined`]: {
                backgroundColor: token[`color${capitalizedCssVariableType}Bg`],
                borderColor: token[`color${capitalizedCssVariableType}Border`],
                color: token[`color${cssVariableType}`]
            },
            [`&${token.componentCls}-solid`]: {
                backgroundColor: token[`color${cssVariableType}`],
                borderColor: token[`color${cssVariableType}`]
            },
            [`&${token.componentCls}-filled`]: {
                backgroundColor: token[`color${capitalizedCssVariableType}Bg`],
                color: token[`color${cssVariableType}`]
            }
        }
    };
};
var // ============================== Export ==============================
$ffc1353c8f3314ca$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$1537386bc155ea56)([
    "Tag",
    "status"
], (token)=>{
    const tagToken = (0, $3262048170780820$export$362fb92a8f81bbf9)(token);
    return [
        $ffc1353c8f3314ca$var$genTagStatusStyle(tagToken, "success", "Success"),
        $ffc1353c8f3314ca$var$genTagStatusStyle(tagToken, "processing", "Info"),
        $ffc1353c8f3314ca$var$genTagStatusStyle(tagToken, "error", "Error"),
        $ffc1353c8f3314ca$var$genTagStatusStyle(tagToken, "warning", "Warning")
    ];
}, (0, $3262048170780820$export$9ca1be8807fe0675));


"use client";
const $602120e6d17ff12a$var$InternalTag = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, style: style, children: children, icon: icon, color: color, variant: _variant, onClose: onClose, bordered: bordered, disabled: customDisabled, href: href, target: target, styles: styles, classNames: classNames, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, variant: contextVariant, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("tag");
    // ====================== Colors ======================
    const [mergedVariant, mergedColor, isPreset, isStatus, customTagStyle] = (0, $c16fe1726155c51c$export$2e2bcd8739ae039)(props, contextVariant);
    const isInternalColor = isPreset || isStatus;
    // ===================== Disabled =====================
    const disabled = $cQmXV.useContext((0, $4f0e1ea30330557c$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled ?? disabled;
    const { tag: tagContext } = $cQmXV.useContext((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    const [visible, setVisible] = $cQmXV.useState(true);
    const domProps = (0, $e8c5093aebad6025$export$2e2bcd8739ae039)(restProps, [
        "closeIcon",
        "closable"
    ]);
    // =========== Merged Props for Semantic ===========
    const mergedProps = {
        ...props,
        color: mergedColor,
        variant: mergedVariant,
        disabled: mergedDisabled
    };
    // ====================== Styles ======================
    const contextStyleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $30c5f9f911d4f61b$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: mergedProps
    });
    const tagStyle = $cQmXV.useMemo(()=>{
        let nextTagStyle = mergedStyles.root;
        if (!mergedDisabled) nextTagStyle = {
            ...customTagStyle,
            ...nextTagStyle
        };
        return nextTagStyle;
    }, [
        mergedStyles.root,
        customTagStyle,
        mergedDisabled
    ]);
    const prefixCls = getPrefixCls("tag", customizePrefixCls);
    const [hashId, cssVarCls] = (0, $3262048170780820$export$2e2bcd8739ae039)(prefixCls);
    const tagClassName = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, contextClassName, mergedClassNames.root, `${prefixCls}-${mergedVariant}`, {
        [`${prefixCls}-${mergedColor}`]: isInternalColor,
        [`${prefixCls}-hidden`]: !visible,
        [`${prefixCls}-rtl`]: direction === "rtl",
        [`${prefixCls}-disabled`]: mergedDisabled
    }, className, rootClassName, hashId, cssVarCls);
    // ===================== Closable =====================
    const triggerClose = (e)=>{
        if (mergedDisabled) return;
        e.stopPropagation();
        onClose?.(e);
        if (e.defaultPrevented) return;
        if (href) e.preventDefault();
        setVisible(false);
    };
    const handleCloseKeyDown = (e)=>{
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            e.currentTarget.click();
        }
    };
    const [, mergedCloseIcon] = (0, $d68006bfa4b86b8f$export$aa101db403ccf5f3)((0, $d68006bfa4b86b8f$export$51ad9c30389f050b)(props), (0, $d68006bfa4b86b8f$export$51ad9c30389f050b)(tagContext), {
        closable: false,
        closeIconRender: (iconNode)=>{
            const replacement = /*#__PURE__*/ $cQmXV.createElement("span", {
                role: "button",
                tabIndex: mergedDisabled ? -1 : 0,
                "aria-disabled": mergedDisabled || undefined,
                className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-close-icon`, mergedClassNames.close),
                onClick: triggerClose,
                onKeyDown: handleCloseKeyDown,
                style: mergedStyles.close
            }, iconNode);
            return (0, $a91ef204d03d8eec$export$2dfe578f95754f6a)(iconNode, replacement, (originProps)=>({
                    onClick: (e)=>{
                        originProps?.onClick?.(e);
                        triggerClose(e);
                    },
                    onKeyDown: (e)=>{
                        originProps?.onKeyDown?.(e);
                        if (!e.defaultPrevented) handleCloseKeyDown(e);
                    },
                    role: "button",
                    tabIndex: mergedDisabled ? -1 : 0,
                    "aria-disabled": mergedDisabled || undefined,
                    className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(originProps?.className, `${prefixCls}-close-icon`, mergedClassNames.close),
                    style: {
                        ...mergedStyles.close,
                        ...originProps?.style
                    }
                }));
        }
    });
    // ====================== Render ======================
    const isNeedWave = (0, $8e2d153a3c855782$export$f6e2535fb5126e54)(restProps.onClick) || children && children.type === "a";
    const iconNode = (0, $a91ef204d03d8eec$export$e530037191fcd5d7)(icon, {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(/*#__PURE__*/ $cQmXV.isValidElement(icon) ? icon.props?.className : undefined, mergedClassNames.icon),
        style: mergedStyles.icon
    });
    const child = iconNode ? /*#__PURE__*/ $cQmXV.createElement($cQmXV.Fragment, null, iconNode, children && /*#__PURE__*/ $cQmXV.createElement("span", {
        className: mergedClassNames.content,
        style: mergedStyles.content
    }, children)) : children;
    const TagWrapper = href ? "a" : "span";
    const tagNode = /*#__PURE__*/ $cQmXV.createElement(TagWrapper, {
        ...domProps,
        ref: ref,
        className: tagClassName,
        style: tagStyle,
        href: mergedDisabled ? undefined : href,
        target: target,
        onClick: mergedDisabled ? undefined : domProps.onClick,
        ...href && mergedDisabled ? {
            "aria-disabled": true
        } : {}
    }, child, mergedCloseIcon, isPreset && /*#__PURE__*/ $cQmXV.createElement((0, $14fd8feb9f6cec76$export$2e2bcd8739ae039), {
        key: "preset",
        prefixCls: prefixCls
    }), isStatus && /*#__PURE__*/ $cQmXV.createElement((0, $ffc1353c8f3314ca$export$2e2bcd8739ae039), {
        key: "status",
        prefixCls: prefixCls
    }));
    return isNeedWave ? /*#__PURE__*/ $cQmXV.createElement((0, $02f5adbd0068e010$export$2e2bcd8739ae039), {
        component: "Tag"
    }, tagNode) : tagNode;
});
const $602120e6d17ff12a$var$Tag = $602120e6d17ff12a$var$InternalTag;
$602120e6d17ff12a$var$Tag.CheckableTag = (0, $e92c1e6c7cc1e084$export$2e2bcd8739ae039);
$602120e6d17ff12a$var$Tag.CheckableTagGroup = (0, $9b887b15b4b750bb$export$2e2bcd8739ae039);
var $602120e6d17ff12a$export$2e2bcd8739ae039 = $602120e6d17ff12a$var$Tag;


var $cQmXV = parcelRequire("cQmXV");









var $cQmXV = parcelRequire("cQmXV");



var $cQmXV = parcelRequire("cQmXV");
var $38931726b696bc9a$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($38931726b696bc9a$exports, "__esModule", {
    value: true
});
var $38931726b696bc9a$var$PlusOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M192 474h672q8 0 8 8v60q0 8-8 8H160q-8 0-8-8v-60q0-8 8-8z"
                }
            }
        ]
    },
    "name": "plus",
    "theme": "outlined"
};
$38931726b696bc9a$exports.default = $38931726b696bc9a$var$PlusOutlined;



function $fa25166ced813feb$var$_extends() {
    $fa25166ced813feb$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $fa25166ced813feb$var$_extends.apply(this, arguments);
}
const $fa25166ced813feb$var$PlusOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $fa25166ced813feb$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($38931726b696bc9a$exports)))
    }));
/**![plus](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTQ4MiAxNTJoNjBxOCAwIDggOHY3MDRxMCA4LTggOGgtNjBxLTggMC04LThWMTYwcTAtOCA4LTh6IiAvPjxwYXRoIGQ9Ik0xOTIgNDc0aDY3MnE4IDAgOCA4djYwcTAgOC04IDhIMTYwcS04IDAtOC04di02MHEwLTggOC04eiIgLz48L3N2Zz4=) */ const $fa25166ced813feb$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($fa25166ced813feb$var$PlusOutlined);
var $fa25166ced813feb$export$2e2bcd8739ae039 = $fa25166ced813feb$var$RefIcon;





var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");
var $8171f2ace8df4897$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $cQmXV.createContext)(null);


// zombieJ: To compatible with `renderTabBar` usage.

var $cQmXV = parcelRequire("cQmXV");




var $cQmXV = parcelRequire("cQmXV");



var $cQmXV = parcelRequire("cQmXV");
const $8308faddf025a3e1$var$useIndicator = (options)=>{
    const { activeTabOffset: activeTabOffset, horizontal: horizontal, rtl: rtl, indicator: indicator = {} } = options;
    const { size: size, align: align = "center" } = indicator;
    const [inkStyle, setInkStyle] = (0, $cQmXV.useState)();
    const inkBarRafRef = (0, $cQmXV.useRef)(undefined);
    const getLength = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useCallback((origin)=>{
        if (typeof size === "function") return size(origin);
        if (typeof size === "number") return size;
        return origin;
    }, [
        size
    ]);
    // Delay set ink style to avoid remove tab blink
    function cleanInkBarRaf() {
        (0, $905c53b807de704e$export$2e2bcd8739ae039).cancel(inkBarRafRef.current);
    }
    (0, $cQmXV.useEffect)(()=>{
        const newInkStyle = {};
        if (activeTabOffset) {
            if (horizontal) {
                newInkStyle.width = getLength(activeTabOffset.width);
                const key = rtl ? "right" : "left";
                if (align === "start") newInkStyle[key] = activeTabOffset[key];
                if (align === "center") {
                    newInkStyle[key] = activeTabOffset[key] + activeTabOffset.width / 2;
                    newInkStyle.transform = rtl ? "translateX(50%)" : "translateX(-50%)";
                }
                if (align === "end") {
                    newInkStyle[key] = activeTabOffset[key] + activeTabOffset.width;
                    newInkStyle.transform = "translateX(-100%)";
                }
            } else {
                newInkStyle.height = getLength(activeTabOffset.height);
                if (align === "start") newInkStyle.top = activeTabOffset.top;
                if (align === "center") {
                    newInkStyle.top = activeTabOffset.top + activeTabOffset.height / 2;
                    newInkStyle.transform = "translateY(-50%)";
                }
                if (align === "end") {
                    newInkStyle.top = activeTabOffset.top + activeTabOffset.height;
                    newInkStyle.transform = "translateY(-100%)";
                }
            }
        }
        cleanInkBarRaf();
        inkBarRafRef.current = (0, $905c53b807de704e$export$2e2bcd8739ae039)(()=>{
            // Avoid jitter caused by tiny numerical differences
            // fix https://github.com/ant-design/ant-design/issues/53378
            const isEqual = inkStyle && newInkStyle && Object.keys(newInkStyle).every((key)=>{
                const newValue = newInkStyle[key];
                const oldValue = inkStyle[key];
                return typeof newValue === "number" && typeof oldValue === "number" ? Math.round(newValue) === Math.round(oldValue) : newValue === oldValue;
            });
            if (!isEqual) setInkStyle(newInkStyle);
        });
        return cleanInkBarRaf;
    }, [
        JSON.stringify(activeTabOffset),
        horizontal,
        rtl,
        align,
        getLength
    ]);
    return {
        style: inkStyle
    };
};
var $8308faddf025a3e1$export$2e2bcd8739ae039 = $8308faddf025a3e1$var$useIndicator;



var $cQmXV = parcelRequire("cQmXV");
const $364297248e7382ef$var$DEFAULT_SIZE = {
    width: 0,
    height: 0,
    left: 0,
    top: 0
};
function $364297248e7382ef$export$2e2bcd8739ae039(tabs, tabSizes, holderScrollWidth) {
    return (0, $cQmXV.useMemo)(()=>{
        const map = new Map();
        const lastOffset = tabSizes.get(tabs[0]?.key) || $364297248e7382ef$var$DEFAULT_SIZE;
        const rightOffset = lastOffset.left + lastOffset.width;
        for(let i = 0; i < tabs.length; i += 1){
            const { key: key } = tabs[i];
            let data = tabSizes.get(key);
            // Reuse last one when not exist yet
            if (!data) data = tabSizes.get(tabs[i - 1]?.key) || $364297248e7382ef$var$DEFAULT_SIZE;
            const entity = map.get(key) || {
                ...data
            };
            // Right
            entity.right = rightOffset - entity.left - entity.width;
            // Update entity
            map.set(key, entity);
        }
        return map;
    }, [
        tabs.map((tab)=>tab.key).join("_"),
        tabSizes,
        holderScrollWidth
    ]);
}



var $cQmXV = parcelRequire("cQmXV");
function $4ebc66b2bd70e784$export$2e2bcd8739ae039(defaultState, onChange) {
    const stateRef = $cQmXV.useRef(defaultState);
    const [, forceUpdate] = $cQmXV.useState({});
    function setState(updater) {
        const newValue = typeof updater === "function" ? updater(stateRef.current) : updater;
        if (newValue !== stateRef.current) onChange(newValue, stateRef.current);
        stateRef.current = newValue;
        forceUpdate({});
    }
    return [
        stateRef.current,
        setState
    ];
}



var $cQmXV = parcelRequire("cQmXV");
const $b548d597aac108c5$var$MIN_SWIPE_DISTANCE = 0.1;
const $b548d597aac108c5$var$STOP_SWIPE_DISTANCE = 0.01;
const $b548d597aac108c5$var$REFRESH_INTERVAL = 20;
const $b548d597aac108c5$var$SPEED_OFF_MULTIPLE = 0.995 ** $b548d597aac108c5$var$REFRESH_INTERVAL;
function $b548d597aac108c5$export$2e2bcd8739ae039(ref, onOffset) {
    const [touchPosition, setTouchPosition] = (0, $cQmXV.useState)();
    const [lastTimestamp, setLastTimestamp] = (0, $cQmXV.useState)(0);
    const [lastTimeDiff, setLastTimeDiff] = (0, $cQmXV.useState)(0);
    const [lastOffset, setLastOffset] = (0, $cQmXV.useState)();
    const motionRef = (0, $cQmXV.useRef)(undefined);
    // ========================= Events =========================
    // >>> Touch events
    function onTouchStart(e) {
        const { screenX: screenX, screenY: screenY } = e.touches[0];
        setTouchPosition({
            x: screenX,
            y: screenY
        });
        window.clearInterval(motionRef.current);
    }
    function onTouchMove(e) {
        if (!touchPosition) return;
        // e.preventDefault();
        const { screenX: screenX, screenY: screenY } = e.touches[0];
        setTouchPosition({
            x: screenX,
            y: screenY
        });
        const offsetX = screenX - touchPosition.x;
        const offsetY = screenY - touchPosition.y;
        onOffset(offsetX, offsetY);
        const now = Date.now();
        setLastTimestamp(now);
        setLastTimeDiff(now - lastTimestamp);
        setLastOffset({
            x: offsetX,
            y: offsetY
        });
    }
    function onTouchEnd() {
        if (!touchPosition) return;
        setTouchPosition(null);
        setLastOffset(null);
        // Swipe if needed
        if (lastOffset) {
            const distanceX = lastOffset.x / lastTimeDiff;
            const distanceY = lastOffset.y / lastTimeDiff;
            const absX = Math.abs(distanceX);
            const absY = Math.abs(distanceY);
            // Skip swipe if low distance
            if (Math.max(absX, absY) < $b548d597aac108c5$var$MIN_SWIPE_DISTANCE) return;
            let currentX = distanceX;
            let currentY = distanceY;
            motionRef.current = window.setInterval(()=>{
                if (Math.abs(currentX) < $b548d597aac108c5$var$STOP_SWIPE_DISTANCE && Math.abs(currentY) < $b548d597aac108c5$var$STOP_SWIPE_DISTANCE) {
                    window.clearInterval(motionRef.current);
                    return;
                }
                currentX *= $b548d597aac108c5$var$SPEED_OFF_MULTIPLE;
                currentY *= $b548d597aac108c5$var$SPEED_OFF_MULTIPLE;
                onOffset(currentX * $b548d597aac108c5$var$REFRESH_INTERVAL, currentY * $b548d597aac108c5$var$REFRESH_INTERVAL);
            }, $b548d597aac108c5$var$REFRESH_INTERVAL);
        }
    }
    // >>> Wheel event
    const lastWheelDirectionRef = (0, $cQmXV.useRef)(undefined);
    function onWheel(e) {
        const { deltaX: deltaX, deltaY: deltaY } = e;
        // Convert both to x & y since wheel only happened on PC
        let mixed;
        const absX = Math.abs(deltaX);
        const absY = Math.abs(deltaY);
        if (absX === absY) mixed = lastWheelDirectionRef.current === "x" ? deltaX : deltaY;
        else if (absX > absY) {
            mixed = deltaX;
            lastWheelDirectionRef.current = "x";
        } else {
            mixed = deltaY;
            lastWheelDirectionRef.current = "y";
        }
        if (onOffset(-mixed, -mixed)) e.preventDefault();
    }
    // ========================= Effect =========================
    const touchEventsRef = (0, $cQmXV.useRef)(null);
    touchEventsRef.current = {
        onTouchStart: onTouchStart,
        onTouchMove: onTouchMove,
        onTouchEnd: onTouchEnd,
        onWheel: onWheel
    };
    $cQmXV.useEffect(()=>{
        function onProxyTouchStart(e) {
            touchEventsRef.current.onTouchStart(e);
        }
        function onProxyTouchMove(e) {
            touchEventsRef.current.onTouchMove(e);
        }
        function onProxyTouchEnd(e) {
            touchEventsRef.current.onTouchEnd(e);
        }
        function onProxyWheel(e) {
            touchEventsRef.current.onWheel(e);
        }
        document.addEventListener("touchmove", onProxyTouchMove, {
            passive: false
        });
        document.addEventListener("touchend", onProxyTouchEnd, {
            passive: true
        });
        // No need to clean up since element removed
        ref.current.addEventListener("touchstart", onProxyTouchStart, {
            passive: true
        });
        ref.current.addEventListener("wheel", onProxyWheel, {
            passive: false
        });
        return ()=>{
            document.removeEventListener("touchmove", onProxyTouchMove);
            document.removeEventListener("touchend", onProxyTouchEnd);
        };
    }, []);
}




var $cQmXV = parcelRequire("cQmXV");
function $4b4d2d81f5b8e11b$export$2e2bcd8739ae039(callback) {
    const [count, setCount] = (0, $cQmXV.useState)(0);
    const effectRef = (0, $cQmXV.useRef)(0);
    const callbackRef = (0, $cQmXV.useRef)(undefined);
    callbackRef.current = callback;
    // Trigger on `useLayoutEffect`
    (0, $7673d874dab69d07$export$9283e56bae2f7b0f)(()=>{
        callbackRef.current?.();
    }, [
        count
    ]);
    // Trigger to update count
    return ()=>{
        if (effectRef.current !== count) return;
        effectRef.current += 1;
        setCount(effectRef.current);
    };
}
function $4b4d2d81f5b8e11b$export$aefd2a30eb6d999e(defaultState) {
    const batchRef = (0, $cQmXV.useRef)([]);
    const [, forceUpdate] = (0, $cQmXV.useState)({});
    const state = (0, $cQmXV.useRef)(typeof defaultState === "function" ? defaultState() : defaultState);
    const flushUpdate = $4b4d2d81f5b8e11b$export$2e2bcd8739ae039(()=>{
        let current = state.current;
        batchRef.current.forEach((callback)=>{
            current = callback(current);
        });
        batchRef.current = [];
        state.current = current;
        forceUpdate({});
    });
    function updater(callback) {
        batchRef.current.push(callback);
        flushUpdate();
    }
    return [
        state.current,
        updater
    ];
}



var $cQmXV = parcelRequire("cQmXV");
const $df769d4dd1c7f2a6$var$DEFAULT_SIZE = {
    width: 0,
    height: 0,
    left: 0,
    top: 0,
    right: 0
};
function $df769d4dd1c7f2a6$export$2e2bcd8739ae039(tabOffsets, visibleTabContentValue, transform, tabContentSizeValue, addNodeSizeValue, operationNodeSizeValue, { tabs: tabs, tabPosition: tabPosition, rtl: rtl }) {
    let charUnit;
    let position;
    let transformSize;
    if ([
        "top",
        "bottom"
    ].includes(tabPosition)) {
        charUnit = "width";
        position = rtl ? "right" : "left";
        transformSize = Math.abs(transform);
    } else {
        charUnit = "height";
        position = "top";
        transformSize = -transform;
    }
    return (0, $cQmXV.useMemo)(()=>{
        if (!tabs.length) return [
            0,
            0
        ];
        const len = tabs.length;
        let endIndex = len;
        for(let i = 0; i < len; i += 1){
            const offset = tabOffsets.get(tabs[i].key) || $df769d4dd1c7f2a6$var$DEFAULT_SIZE;
            if (Math.floor(offset[position] + offset[charUnit]) > Math.floor(transformSize + visibleTabContentValue)) {
                endIndex = i - 1;
                break;
            }
        }
        let startIndex = 0;
        for(let i = len - 1; i >= 0; i -= 1){
            const offset = tabOffsets.get(tabs[i].key) || $df769d4dd1c7f2a6$var$DEFAULT_SIZE;
            if (offset[position] < transformSize) {
                startIndex = i + 1;
                break;
            }
        }
        return startIndex > endIndex ? [
            0,
            -1
        ] : [
            startIndex,
            endIndex
        ];
    }, [
        tabOffsets,
        visibleTabContentValue,
        tabContentSizeValue,
        addNodeSizeValue,
        operationNodeSizeValue,
        transformSize,
        tabPosition,
        tabs.map((tab)=>tab.key).join("_"),
        rtl
    ]);
}


/**
 * We trade Map as deps which may change with same value but different ref object.
 * We should make it as hash for deps
 * */ function $5b6816ad77c3c0e7$export$fac44ee5b035f737(obj) {
    let tgt;
    if (obj instanceof Map) {
        tgt = {};
        obj.forEach((v, k)=>{
            tgt[k] = v;
        });
    } else tgt = obj;
    return JSON.stringify(tgt);
}
const $5b6816ad77c3c0e7$var$RC_TABS_DOUBLE_QUOTE = "TABS_DQ";
function $5b6816ad77c3c0e7$export$c55417729a96230c(key) {
    return String(key).replace(/"/g, $5b6816ad77c3c0e7$var$RC_TABS_DOUBLE_QUOTE);
}
function $5b6816ad77c3c0e7$export$eab31ca11b8b073(closable, closeIcon, editable, disabled) {
    if (// Only editable tabs can be removed
    !editable || // Tabs cannot be removed when disabled
    disabled || // closable is false
    closable === false || // If closable is undefined, the remove button should be hidden when closeIcon is null or false
    closable === undefined && (closeIcon === false || closeIcon === null)) return false;
    return true;
}



var $cQmXV = parcelRequire("cQmXV");
const $c5b002ebd33b01ad$var$AddButton = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { prefixCls: prefixCls, editable: editable, locale: locale, style: style } = props;
    if (!editable || editable.showAdd === false) return null;
    return /*#__PURE__*/ $cQmXV.createElement("button", {
        ref: ref,
        type: "button",
        className: `${prefixCls}-nav-add`,
        style: style,
        "aria-label": locale?.addAriaLabel || "Add tab",
        onClick: (event)=>{
            editable.onEdit("add", {
                event: event
            });
        }
    }, editable.addIcon || "+");
});
var $c5b002ebd33b01ad$export$2e2bcd8739ae039 = $c5b002ebd33b01ad$var$AddButton;



var $cQmXV = parcelRequire("cQmXV");
const $25d05cd5462bfe89$var$ExtraContent = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { position: position, prefixCls: prefixCls, extra: extra } = props;
    if (!extra) return null;
    let content;
    // Parse extra
    let assertExtra = {};
    if (typeof extra === "object" && !/*#__PURE__*/ $cQmXV.isValidElement(extra)) assertExtra = extra;
    else assertExtra.right = extra;
    if (position === "right") content = assertExtra.right;
    if (position === "left") content = assertExtra.left;
    return content ? /*#__PURE__*/ $cQmXV.createElement("div", {
        className: `${prefixCls}-extra-content`,
        ref: ref
    }, content) : null;
});
var $25d05cd5462bfe89$export$2e2bcd8739ae039 = $25d05cd5462bfe89$var$ExtraContent;







var $cQmXV = parcelRequire("cQmXV");


function $3e0c57c4fb664303$var$_extends() {
    $3e0c57c4fb664303$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3e0c57c4fb664303$var$_extends.apply(this, arguments);
}
const $3e0c57c4fb664303$var$OperationNode = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { prefixCls: prefixCls, id: id, tabs: tabs, locale: locale, mobile: mobile, more: moreProps = {}, style: style, className: className, editable: editable, tabBarGutter: tabBarGutter, rtl: rtl, removeAriaLabel: removeAriaLabel, onTabClick: onTabClick, getPopupContainer: getPopupContainer, popupClassName: popupClassName, popupStyle: popupStyle, classNames: classNames, styles: styles } = props;
    // ======================== Dropdown ========================
    const [open, setOpen] = (0, $cQmXV.useState)(false);
    const [selectedKey, setSelectedKey] = (0, $cQmXV.useState)(null);
    const { icon: moreIcon = "More", popupRender: popupRender } = moreProps;
    const popupId = `${id}-more-popup`;
    const dropdownPrefix = `${prefixCls}-dropdown`;
    const selectedItemId = selectedKey !== null ? `${popupId}-${selectedKey}` : null;
    const dropdownAriaLabel = locale?.dropdownAriaLabel;
    function onRemoveTab(event, key) {
        event.preventDefault();
        event.stopPropagation();
        editable.onEdit("remove", {
            key: key,
            event: event
        });
    }
    const menu = /*#__PURE__*/ $cQmXV.createElement((0, $f2204382bfad12ac$export$2e2bcd8739ae039), {
        onClick: ({ key: key, domEvent: domEvent })=>{
            onTabClick(key, domEvent);
            setOpen(false);
        },
        prefixCls: `${dropdownPrefix}-menu`,
        id: popupId,
        tabIndex: -1,
        role: "listbox",
        "aria-activedescendant": selectedItemId,
        selectedKeys: [
            selectedKey
        ],
        "aria-label": dropdownAriaLabel !== undefined ? dropdownAriaLabel : "expanded dropdown"
    }, tabs.map((tab)=>{
        const { closable: closable, disabled: disabled, closeIcon: closeIcon, key: key, label: label } = tab;
        const removable = (0, $5b6816ad77c3c0e7$export$eab31ca11b8b073)(closable, closeIcon, editable, disabled);
        return /*#__PURE__*/ $cQmXV.createElement((0, $dc497472bf4ea988$export$2e2bcd8739ae039), {
            key: key,
            id: `${popupId}-${key}`,
            role: "option",
            "aria-controls": id && `${id}-panel-${key}`,
            disabled: disabled
        }, /*#__PURE__*/ $cQmXV.createElement("span", null, label), removable && /*#__PURE__*/ $cQmXV.createElement("button", {
            type: "button",
            "aria-label": removeAriaLabel || "remove",
            tabIndex: 0,
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${dropdownPrefix}-menu-item-remove`, classNames?.remove),
            style: styles?.remove,
            onClick: (e)=>{
                e.stopPropagation();
                onRemoveTab(e, key);
            }
        }, closeIcon || editable.removeIcon || "\xd7"));
    }));
    const overlay = popupRender ? popupRender(menu, {
        restTabs: tabs,
        onClose: ()=>setOpen(false)
    }) : menu;
    function selectOffset(offset) {
        const enabledTabs = tabs.filter((tab)=>!tab.disabled);
        let selectedIndex = enabledTabs.findIndex((tab)=>tab.key === selectedKey) || 0;
        const len = enabledTabs.length;
        for(let i = 0; i < len; i += 1){
            selectedIndex = (selectedIndex + offset + len) % len;
            const tab = enabledTabs[selectedIndex];
            if (!tab.disabled) {
                setSelectedKey(tab.key);
                return;
            }
        }
    }
    function onKeyDown(e) {
        const { which: which } = e;
        if (!open) {
            if ([
                (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).DOWN,
                (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).SPACE,
                (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).ENTER
            ].includes(which)) {
                setOpen(true);
                e.preventDefault();
            }
            return;
        }
        switch(which){
            case (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).UP:
                selectOffset(-1);
                e.preventDefault();
                break;
            case (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).DOWN:
                selectOffset(1);
                e.preventDefault();
                break;
            case (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).ESC:
                setOpen(false);
                break;
            case (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).SPACE:
            case (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).ENTER:
                if (selectedKey !== null) onTabClick(selectedKey, e);
                break;
        }
    }
    // ========================= Effect =========================
    (0, $cQmXV.useEffect)(()=>{
        // We use query element here to avoid React strict warning
        const ele = document.getElementById(selectedItemId);
        if (ele?.scrollIntoView) ele.scrollIntoView(false);
    }, [
        selectedItemId,
        selectedKey
    ]);
    (0, $cQmXV.useEffect)(()=>{
        if (!open) setSelectedKey(null);
    }, [
        open
    ]);
    // ========================= Render =========================
    const moreStyle = {
        marginInlineStart: tabBarGutter
    };
    if (!tabs.length) {
        moreStyle.visibility = "hidden";
        moreStyle.order = 1;
    }
    const overlayClassName = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(popupClassName, {
        [`${dropdownPrefix}-rtl`]: rtl
    });
    const moreNode = mobile ? null : /*#__PURE__*/ $cQmXV.createElement((0, $2674fedb26eedb51$export$2e2bcd8739ae039), $3e0c57c4fb664303$var$_extends({
        prefixCls: dropdownPrefix,
        overlay: overlay,
        visible: tabs.length ? open : false,
        onVisibleChange: setOpen,
        overlayClassName: overlayClassName,
        overlayStyle: popupStyle,
        mouseEnterDelay: 0.1,
        mouseLeaveDelay: 0.1,
        getPopupContainer: getPopupContainer
    }, moreProps), /*#__PURE__*/ $cQmXV.createElement("button", {
        type: "button",
        className: `${prefixCls}-nav-more`,
        style: moreStyle,
        "aria-haspopup": "listbox",
        "aria-controls": popupId,
        id: `${id}-more`,
        "aria-expanded": open,
        onKeyDown: onKeyDown
    }, moreIcon));
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-nav-operations`, className),
        style: style,
        ref: ref
    }, moreNode, /*#__PURE__*/ $cQmXV.createElement((0, $c5b002ebd33b01ad$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        locale: locale,
        editable: editable
    }));
});
var $3e0c57c4fb664303$export$2e2bcd8739ae039 = /*#__PURE__*/ $cQmXV.memo($3e0c57c4fb664303$var$OperationNode, (_, next)=>// https://github.com/ant-design/ant-design/issues/32544
    // We'd better remove syntactic sugar in `rc-menu` since this has perf issue
    next.tabMoving);




var $cQmXV = parcelRequire("cQmXV");

const $ba9385df55ea4b80$var$TabNode = (props)=>{
    const { prefixCls: prefixCls, id: id, active: active, focus: focus, tab: { key: key, label: label, disabled: disabled, closeIcon: closeIcon, icon: icon }, closable: closable, renderWrapper: renderWrapper, removeAriaLabel: removeAriaLabel, editable: editable, onClick: onClick, onFocus: onFocus, onBlur: onBlur, onKeyDown: onKeyDown, onMouseDown: onMouseDown, onMouseUp: onMouseUp, styles: styles, classNames: tabNodeClassNames, tabCount: tabCount, currentPosition: currentPosition } = props;
    const tabPrefix = `${prefixCls}-tab`;
    const removable = (0, $5b6816ad77c3c0e7$export$eab31ca11b8b073)(closable, closeIcon, editable, disabled);
    function onInternalClick(e) {
        if (disabled) return;
        onClick(e);
    }
    function onRemoveTab(event) {
        event.preventDefault();
        event.stopPropagation();
        editable.onEdit("remove", {
            key: key,
            event: event
        });
    }
    const labelNode = $cQmXV.useMemo(()=>icon && typeof label === "string" ? /*#__PURE__*/ $cQmXV.createElement("span", null, label) : label, [
        label,
        icon
    ]);
    const btnRef = $cQmXV.useRef(null);
    $cQmXV.useEffect(()=>{
        if (focus && btnRef.current) btnRef.current.focus();
    }, [
        focus
    ]);
    const node = /*#__PURE__*/ $cQmXV.createElement("div", {
        key: key,
        "data-node-key": (0, $5b6816ad77c3c0e7$export$c55417729a96230c)(key),
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(tabPrefix, tabNodeClassNames?.item, {
            [`${tabPrefix}-with-remove`]: removable,
            [`${tabPrefix}-active`]: active,
            [`${tabPrefix}-disabled`]: disabled,
            [`${tabPrefix}-focus`]: focus
        }),
        style: styles?.item,
        onClick: onInternalClick
    }, /*#__PURE__*/ $cQmXV.createElement("div", {
        ref: btnRef,
        role: "tab",
        "aria-selected": active,
        id: id && `${id}-tab-${key}`,
        className: `${tabPrefix}-btn`,
        "aria-controls": id && `${id}-panel-${key}`,
        "aria-disabled": disabled,
        tabIndex: disabled ? null : active ? 0 : -1,
        onClick: (e)=>{
            e.stopPropagation();
            onInternalClick(e);
        },
        onKeyDown: onKeyDown,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onFocus: onFocus,
        onBlur: onBlur
    }, focus && /*#__PURE__*/ $cQmXV.createElement("div", {
        "aria-live": "polite",
        style: {
            width: 0,
            height: 0,
            position: "absolute",
            overflow: "hidden",
            opacity: 0
        }
    }, `Tab ${currentPosition} of ${tabCount}`), icon && /*#__PURE__*/ $cQmXV.createElement("span", {
        className: `${tabPrefix}-icon`
    }, icon), label && labelNode), removable && /*#__PURE__*/ $cQmXV.createElement("button", {
        type: "button",
        "aria-label": removeAriaLabel || "remove",
        tabIndex: active ? 0 : -1,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${tabPrefix}-remove`, tabNodeClassNames?.remove),
        style: styles?.remove,
        onClick: (e)=>{
            e.stopPropagation();
            onRemoveTab(e);
        }
    }, closeIcon || editable.removeIcon || "\xd7"));
    return renderWrapper ? renderWrapper(node) : node;
};
var $ba9385df55ea4b80$export$2e2bcd8739ae039 = $ba9385df55ea4b80$var$TabNode;


function $a667102234c63f79$var$_extends() {
    $a667102234c63f79$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a667102234c63f79$var$_extends.apply(this, arguments);
}
const $a667102234c63f79$var$getTabSize = (tab, containerRect)=>{
    // tabListRef
    const { offsetWidth: offsetWidth, offsetHeight: offsetHeight, offsetTop: offsetTop, offsetLeft: offsetLeft } = tab;
    const { width: width, height: height, left: left, top: top } = tab.getBoundingClientRect();
    // Use getBoundingClientRect to avoid decimal inaccuracy
    if (Math.abs(width - offsetWidth) < 1) return [
        width,
        height,
        left - containerRect.left,
        top - containerRect.top
    ];
    return [
        offsetWidth,
        offsetHeight,
        offsetLeft,
        offsetTop
    ];
};
const $a667102234c63f79$var$getSize = (refObj)=>{
    const { offsetWidth: offsetWidth = 0, offsetHeight: offsetHeight = 0 } = refObj.current || {};
    // Use getBoundingClientRect to avoid decimal inaccuracy
    if (refObj.current) {
        const { width: width, height: height } = refObj.current.getBoundingClientRect();
        if (Math.abs(width - offsetWidth) < 1) return [
            width,
            height
        ];
    }
    return [
        offsetWidth,
        offsetHeight
    ];
};
/**
 * Convert `SizeInfo` to unit value. Such as [123, 456] with `top` position get `123`
 */ const $a667102234c63f79$var$getUnitValue = (size, tabPositionTopOrBottom)=>{
    return size[tabPositionTopOrBottom ? 0 : 1];
};
const $a667102234c63f79$var$TabNavList = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { className: className, style: style, id: id, animated: animated, activeKey: activeKey, rtl: rtl, extra: extra, editable: editable, locale: locale, tabPosition: tabPosition, tabBarGutter: tabBarGutter, children: children, onTabClick: onTabClick, onTabScroll: onTabScroll, indicator: indicator, classNames: tabsClassNames, styles: styles } = props;
    const { prefixCls: prefixCls, tabs: tabs } = $cQmXV.useContext((0, $8171f2ace8df4897$export$2e2bcd8739ae039));
    const containerRef = (0, $cQmXV.useRef)(null);
    const extraLeftRef = (0, $cQmXV.useRef)(null);
    const extraRightRef = (0, $cQmXV.useRef)(null);
    const tabsWrapperRef = (0, $cQmXV.useRef)(null);
    const tabListRef = (0, $cQmXV.useRef)(null);
    const operationsRef = (0, $cQmXV.useRef)(null);
    const innerAddButtonRef = (0, $cQmXV.useRef)(null);
    const tabPositionTopOrBottom = tabPosition === "top" || tabPosition === "bottom";
    const [transformLeft, setTransformLeft] = (0, $4ebc66b2bd70e784$export$2e2bcd8739ae039)(0, (next, prev)=>{
        if (tabPositionTopOrBottom && onTabScroll) onTabScroll({
            direction: next > prev ? "left" : "right"
        });
    });
    const [transformTop, setTransformTop] = (0, $4ebc66b2bd70e784$export$2e2bcd8739ae039)(0, (next, prev)=>{
        if (!tabPositionTopOrBottom && onTabScroll) onTabScroll({
            direction: next > prev ? "top" : "bottom"
        });
    });
    const [containerExcludeExtraSize, setContainerExcludeExtraSize] = (0, $cQmXV.useState)([
        0,
        0
    ]);
    const [tabContentSize, setTabContentSize] = (0, $cQmXV.useState)([
        0,
        0
    ]);
    const [addSize, setAddSize] = (0, $cQmXV.useState)([
        0,
        0
    ]);
    const [operationSize, setOperationSize] = (0, $cQmXV.useState)([
        0,
        0
    ]);
    const [tabSizes, setTabSizes] = (0, $4b4d2d81f5b8e11b$export$aefd2a30eb6d999e)(new Map());
    const tabOffsets = (0, $364297248e7382ef$export$2e2bcd8739ae039)(tabs, tabSizes, tabContentSize[0]);
    // ========================== Unit =========================
    const containerExcludeExtraSizeValue = $a667102234c63f79$var$getUnitValue(containerExcludeExtraSize, tabPositionTopOrBottom);
    const tabContentSizeValue = $a667102234c63f79$var$getUnitValue(tabContentSize, tabPositionTopOrBottom);
    const addSizeValue = $a667102234c63f79$var$getUnitValue(addSize, tabPositionTopOrBottom);
    const operationSizeValue = $a667102234c63f79$var$getUnitValue(operationSize, tabPositionTopOrBottom);
    const needScroll = Math.floor(containerExcludeExtraSizeValue) < Math.floor(tabContentSizeValue + addSizeValue);
    const visibleTabContentValue = needScroll ? containerExcludeExtraSizeValue - operationSizeValue : containerExcludeExtraSizeValue - addSizeValue;
    // ========================== Util =========================
    const operationsHiddenClassName = `${prefixCls}-nav-operations-hidden`;
    let transformMin = 0;
    let transformMax = 0;
    if (!tabPositionTopOrBottom) {
        transformMin = Math.min(0, visibleTabContentValue - tabContentSizeValue);
        transformMax = 0;
    } else if (rtl) {
        transformMin = 0;
        transformMax = Math.max(0, tabContentSizeValue - visibleTabContentValue);
    } else {
        transformMin = Math.min(0, visibleTabContentValue - tabContentSizeValue);
        transformMax = 0;
    }
    function alignInRange(value) {
        if (value < transformMin) return transformMin;
        if (value > transformMax) return transformMax;
        return value;
    }
    // ========================= Mobile ========================
    const touchMovingRef = (0, $cQmXV.useRef)(null);
    const [lockAnimation, setLockAnimation] = (0, $cQmXV.useState)();
    function doLockAnimation() {
        setLockAnimation(Date.now());
    }
    function clearTouchMoving() {
        if (touchMovingRef.current) clearTimeout(touchMovingRef.current);
    }
    (0, $b548d597aac108c5$export$2e2bcd8739ae039)(tabsWrapperRef, (offsetX, offsetY)=>{
        function doMove(setState, offset) {
            setState((value)=>{
                const newValue = alignInRange(value + offset);
                return newValue;
            });
        }
        // Skip scroll if place is enough
        if (!needScroll) return false;
        if (tabPositionTopOrBottom) doMove(setTransformLeft, offsetX);
        else doMove(setTransformTop, offsetY);
        clearTouchMoving();
        doLockAnimation();
        return true;
    });
    (0, $cQmXV.useEffect)(()=>{
        clearTouchMoving();
        if (lockAnimation) touchMovingRef.current = setTimeout(()=>{
            setLockAnimation(0);
        }, 100);
        return clearTouchMoving;
    }, [
        lockAnimation
    ]);
    // ===================== Visible Range =====================
    // Render tab node & collect tab offset
    const [visibleStart, visibleEnd] = (0, $df769d4dd1c7f2a6$export$2e2bcd8739ae039)(tabOffsets, // Container
    visibleTabContentValue, // Transform
    tabPositionTopOrBottom ? transformLeft : transformTop, // Tabs
    tabContentSizeValue, // Add
    addSizeValue, // Operation
    operationSizeValue, {
        ...props,
        tabs: tabs
    });
    // ========================= Scroll ========================
    const scrollToTab = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((key = activeKey)=>{
        const tabOffset = tabOffsets.get(key) || {
            width: 0,
            height: 0,
            left: 0,
            right: 0,
            top: 0
        };
        if (tabPositionTopOrBottom) {
            // ============ Align with top & bottom ============
            let newTransform = transformLeft;
            // RTL
            if (rtl) {
                if (tabOffset.right < transformLeft) newTransform = tabOffset.right;
                else if (tabOffset.right + tabOffset.width > transformLeft + visibleTabContentValue) newTransform = tabOffset.right + tabOffset.width - visibleTabContentValue;
            } else if (tabOffset.left < -transformLeft) newTransform = -tabOffset.left;
            else if (tabOffset.left + tabOffset.width > -transformLeft + visibleTabContentValue) newTransform = -(tabOffset.left + tabOffset.width - visibleTabContentValue);
            setTransformTop(0);
            setTransformLeft(alignInRange(newTransform));
        } else {
            // ============ Align with left & right ============
            let newTransform = transformTop;
            if (tabOffset.top < -transformTop) newTransform = -tabOffset.top;
            else if (tabOffset.top + tabOffset.height > -transformTop + visibleTabContentValue) newTransform = -(tabOffset.top + tabOffset.height - visibleTabContentValue);
            setTransformLeft(0);
            setTransformTop(alignInRange(newTransform));
        }
    });
    // ========================= Focus =========================
    const [focusKey, setFocusKey] = (0, $cQmXV.useState)();
    const [isMouse, setIsMouse] = (0, $cQmXV.useState)(false);
    const enabledTabs = tabs.filter((tab)=>!tab.disabled).map((tab)=>tab.key);
    const onOffset = (offset)=>{
        const currentIndex = enabledTabs.indexOf(focusKey || activeKey);
        const len = enabledTabs.length;
        const nextIndex = (currentIndex + offset + len) % len;
        const newKey = enabledTabs[nextIndex];
        setFocusKey(newKey);
    };
    const handleRemoveTab = (removalTabKey, e)=>{
        const removeIndex = enabledTabs.indexOf(removalTabKey);
        const removeTab = tabs.find((tab)=>tab.key === removalTabKey);
        const removable = (0, $5b6816ad77c3c0e7$export$eab31ca11b8b073)(removeTab?.closable, removeTab?.closeIcon, editable, removeTab?.disabled);
        if (removable) {
            e.preventDefault();
            e.stopPropagation();
            editable.onEdit("remove", {
                key: removalTabKey,
                event: e
            });
            // when remove last tab, focus previous tab
            if (removeIndex === enabledTabs.length - 1) onOffset(-1);
            else onOffset(1);
        }
    };
    const handleMouseDown = (key, e)=>{
        setIsMouse(true);
        // Middle mouse button
        if (e.button === 1) handleRemoveTab(key, e);
    };
    const handleKeyDown = (e)=>{
        const { code: code } = e;
        const isRTL = rtl && tabPositionTopOrBottom;
        const firstEnabledTab = enabledTabs[0];
        const lastEnabledTab = enabledTabs[enabledTabs.length - 1];
        switch(code){
            // LEFT
            case "ArrowLeft":
                if (tabPositionTopOrBottom) onOffset(isRTL ? 1 : -1);
                break;
            // RIGHT
            case "ArrowRight":
                if (tabPositionTopOrBottom) onOffset(isRTL ? -1 : 1);
                break;
            // UP
            case "ArrowUp":
                e.preventDefault();
                if (!tabPositionTopOrBottom) onOffset(-1);
                break;
            // DOWN
            case "ArrowDown":
                e.preventDefault();
                if (!tabPositionTopOrBottom) onOffset(1);
                break;
            // HOME
            case "Home":
                e.preventDefault();
                setFocusKey(firstEnabledTab);
                break;
            // END
            case "End":
                e.preventDefault();
                setFocusKey(lastEnabledTab);
                break;
            // Enter & Space
            case "Enter":
            case "Space":
                e.preventDefault();
                onTabClick(focusKey ?? activeKey, e);
                break;
            // Backspace
            case "Backspace":
            case "Delete":
                handleRemoveTab(focusKey, e);
                break;
        }
    };
    // ========================== Tab ==========================
    const tabNodeStyle = {};
    if (tabPositionTopOrBottom) tabNodeStyle.marginInlineStart = tabBarGutter;
    else tabNodeStyle.marginTop = tabBarGutter;
    const tabNodes = tabs.map((tab, i)=>{
        const { key: key } = tab;
        return /*#__PURE__*/ $cQmXV.createElement((0, $ba9385df55ea4b80$export$2e2bcd8739ae039), {
            id: id,
            prefixCls: prefixCls,
            key: key,
            tab: tab,
            classNames: {
                item: tabsClassNames?.item,
                remove: tabsClassNames?.remove
            },
            styles: {
                /* first node should not have margin left */ item: i === 0 ? styles?.item : {
                    ...tabNodeStyle,
                    ...styles?.item
                },
                remove: styles?.remove
            },
            closable: tab.closable,
            editable: editable,
            active: key === activeKey,
            focus: key === focusKey,
            renderWrapper: children,
            removeAriaLabel: locale?.removeAriaLabel,
            tabCount: enabledTabs.length,
            currentPosition: i + 1,
            onClick: (e)=>{
                onTabClick(key, e);
            },
            onKeyDown: handleKeyDown,
            onFocus: ()=>{
                if (!isMouse) setFocusKey(key);
                scrollToTab(key);
                doLockAnimation();
                if (!tabsWrapperRef.current) return;
                // Focus element will make scrollLeft change which we should reset back
                if (!rtl) tabsWrapperRef.current.scrollLeft = 0;
                tabsWrapperRef.current.scrollTop = 0;
            },
            onBlur: ()=>{
                setFocusKey(undefined);
            },
            onMouseDown: (e)=>handleMouseDown(key, e),
            onMouseUp: ()=>{
                setIsMouse(false);
            }
        });
    });
    // Update buttons records
    const updateTabSizes = ()=>setTabSizes(()=>{
            const newSizes = new Map();
            const listRect = tabListRef.current?.getBoundingClientRect();
            tabs.forEach(({ key: key })=>{
                const btnNode = tabListRef.current?.querySelector(`[data-node-key="${(0, $5b6816ad77c3c0e7$export$c55417729a96230c)(key)}"]`);
                if (btnNode) {
                    const [width, height, left, top] = $a667102234c63f79$var$getTabSize(btnNode, listRect);
                    newSizes.set(key, {
                        width: width,
                        height: height,
                        left: left,
                        top: top
                    });
                }
            });
            return newSizes;
        });
    (0, $cQmXV.useEffect)(()=>{
        updateTabSizes();
    }, [
        tabs.map((tab)=>tab.key).join("_")
    ]);
    const onListHolderResize = (0, $4b4d2d81f5b8e11b$export$2e2bcd8739ae039)(()=>{
        // Update wrapper records
        const containerSize = $a667102234c63f79$var$getSize(containerRef);
        const extraLeftSize = $a667102234c63f79$var$getSize(extraLeftRef);
        const extraRightSize = $a667102234c63f79$var$getSize(extraRightRef);
        setContainerExcludeExtraSize([
            containerSize[0] - extraLeftSize[0] - extraRightSize[0],
            containerSize[1] - extraLeftSize[1] - extraRightSize[1]
        ]);
        const newAddSize = $a667102234c63f79$var$getSize(innerAddButtonRef);
        setAddSize(newAddSize);
        const newOperationSize = $a667102234c63f79$var$getSize(operationsRef);
        setOperationSize(newOperationSize);
        // Which includes add button size
        const tabContentFullSize = $a667102234c63f79$var$getSize(tabListRef);
        setTabContentSize([
            tabContentFullSize[0] - newAddSize[0],
            tabContentFullSize[1] - newAddSize[1]
        ]);
        // Update buttons records
        updateTabSizes();
    });
    // ======================== Dropdown =======================
    const startHiddenTabs = tabs.slice(0, visibleStart);
    const endHiddenTabs = tabs.slice(visibleEnd + 1);
    const hiddenTabs = [
        ...startHiddenTabs,
        ...endHiddenTabs
    ];
    // =================== Link & Operations ===================
    const activeTabOffset = tabOffsets.get(activeKey);
    const { style: indicatorStyle } = (0, $8308faddf025a3e1$export$2e2bcd8739ae039)({
        activeTabOffset: activeTabOffset,
        horizontal: tabPositionTopOrBottom,
        indicator: indicator,
        rtl: rtl
    });
    // ========================= Effect ========================
    (0, $cQmXV.useEffect)(()=>{
        scrollToTab();
    }, [
        activeKey,
        transformMin,
        transformMax,
        (0, $5b6816ad77c3c0e7$export$fac44ee5b035f737)(activeTabOffset),
        (0, $5b6816ad77c3c0e7$export$fac44ee5b035f737)(tabOffsets),
        tabPositionTopOrBottom
    ]);
    // Should recalculate when rtl changed
    (0, $cQmXV.useEffect)(()=>{
        onListHolderResize();
    // eslint-disable-next-line
    }, [
        rtl
    ]);
    // ========================= Render ========================
    const hasDropdown = !!hiddenTabs.length;
    const wrapPrefix = `${prefixCls}-nav-wrap`;
    let pingLeft;
    let pingRight;
    let pingTop;
    let pingBottom;
    if (tabPositionTopOrBottom) {
        if (rtl) {
            pingRight = transformLeft > 0;
            pingLeft = transformLeft !== transformMax;
        } else {
            pingLeft = transformLeft < 0;
            pingRight = transformLeft !== transformMin;
        }
    } else {
        pingTop = transformTop < 0;
        pingBottom = transformTop !== transformMin;
    }
    return /*#__PURE__*/ $cQmXV.createElement((0, $1d6306c05e604045$export$2e2bcd8739ae039), {
        onResize: onListHolderResize
    }, /*#__PURE__*/ $cQmXV.createElement("div", {
        ref: (0, $10341b937b26f69d$export$1d1c999670a1285d)(ref, containerRef),
        role: "tablist",
        "aria-orientation": tabPositionTopOrBottom ? "horizontal" : "vertical",
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-nav`, className, tabsClassNames?.header),
        style: {
            ...styles?.header,
            ...style
        },
        onKeyDown: ()=>{
            // No need animation when use keyboard
            doLockAnimation();
        }
    }, /*#__PURE__*/ $cQmXV.createElement((0, $25d05cd5462bfe89$export$2e2bcd8739ae039), {
        ref: extraLeftRef,
        position: "left",
        extra: extra,
        prefixCls: prefixCls
    }), /*#__PURE__*/ $cQmXV.createElement((0, $1d6306c05e604045$export$2e2bcd8739ae039), {
        onResize: onListHolderResize
    }, /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(wrapPrefix, {
            [`${wrapPrefix}-ping-left`]: pingLeft,
            [`${wrapPrefix}-ping-right`]: pingRight,
            [`${wrapPrefix}-ping-top`]: pingTop,
            [`${wrapPrefix}-ping-bottom`]: pingBottom
        }),
        ref: tabsWrapperRef
    }, /*#__PURE__*/ $cQmXV.createElement((0, $1d6306c05e604045$export$2e2bcd8739ae039), {
        onResize: onListHolderResize
    }, /*#__PURE__*/ $cQmXV.createElement("div", {
        ref: tabListRef,
        className: `${prefixCls}-nav-list`,
        style: {
            transform: `translate(${transformLeft}px, ${transformTop}px)`,
            transition: lockAnimation ? "none" : undefined
        }
    }, tabNodes, /*#__PURE__*/ $cQmXV.createElement((0, $c5b002ebd33b01ad$export$2e2bcd8739ae039), {
        ref: innerAddButtonRef,
        prefixCls: prefixCls,
        locale: locale,
        editable: editable,
        style: {
            ...tabNodes.length === 0 ? undefined : tabNodeStyle,
            visibility: hasDropdown ? "hidden" : null
        }
    }), /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-ink-bar`, tabsClassNames?.indicator, {
            [`${prefixCls}-ink-bar-animated`]: animated.inkBar
        }),
        style: {
            ...indicatorStyle,
            ...styles?.indicator
        }
    }))))), /*#__PURE__*/ $cQmXV.createElement((0, $3e0c57c4fb664303$export$2e2bcd8739ae039), $a667102234c63f79$var$_extends({}, props, {
        removeAriaLabel: locale?.removeAriaLabel,
        ref: operationsRef,
        prefixCls: prefixCls,
        tabs: hiddenTabs,
        className: !hasDropdown && operationsHiddenClassName,
        popupStyle: styles?.popup,
        tabMoving: !!lockAnimation
    })), /*#__PURE__*/ $cQmXV.createElement((0, $25d05cd5462bfe89$export$2e2bcd8739ae039), {
        ref: extraRightRef,
        position: "right",
        extra: extra,
        prefixCls: prefixCls
    })));
/* eslint-enable */ });
var $a667102234c63f79$export$2e2bcd8739ae039 = $a667102234c63f79$var$TabNavList;


// We have to create a TabNavList components.
const $8d7cbdda6282dec7$var$TabNavListWrapper = ({ renderTabBar: renderTabBar, ...restProps })=>{
    if (renderTabBar) return renderTabBar(restProps, (0, $a667102234c63f79$export$2e2bcd8739ae039));
    return /*#__PURE__*/ $cQmXV.createElement((0, $a667102234c63f79$export$2e2bcd8739ae039), restProps);
};
var $8d7cbdda6282dec7$export$2e2bcd8739ae039 = $8d7cbdda6282dec7$var$TabNavListWrapper;





var $cQmXV = parcelRequire("cQmXV");



var $cQmXV = parcelRequire("cQmXV");
const $b7310f47e39a9856$var$TabPane = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { prefixCls: prefixCls, className: className, style: style, id: id, active: active, tabKey: tabKey, children: children } = props;
    const hasContent = $cQmXV.Children.count(children) > 0;
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        id: id && `${id}-panel-${tabKey}`,
        role: "tabpanel",
        tabIndex: active && hasContent ? 0 : -1,
        "aria-labelledby": id && `${id}-tab-${tabKey}`,
        "aria-hidden": !active,
        style: style,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, active && `${prefixCls}-active`, className),
        ref: ref
    }, children);
});
var $b7310f47e39a9856$export$2e2bcd8739ae039 = $b7310f47e39a9856$var$TabPane;


function $6b496a352d71832f$var$_extends() {
    $6b496a352d71832f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6b496a352d71832f$var$_extends.apply(this, arguments);
}
const $6b496a352d71832f$var$TabPanelList = (props)=>{
    const { id: id, activeKey: activeKey, animated: animated, tabPosition: tabPosition, destroyOnHidden: destroyOnHidden, bodyStyle: bodyStyle, bodyClassName: bodyClassName, contentStyle: contentStyle, contentClassName: contentClassName } = props;
    const { prefixCls: prefixCls, tabs: tabs } = $cQmXV.useContext((0, $8171f2ace8df4897$export$2e2bcd8739ae039));
    const tabPaneAnimated = animated.tabPane;
    const bodyPrefixCls = `${prefixCls}-body`;
    const contentPrefixCls = `${prefixCls}-content`;
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${bodyPrefixCls}-holder`)
    }, /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(bodyPrefixCls, `${bodyPrefixCls}-${tabPosition}`, {
            [`${bodyPrefixCls}-animated`]: tabPaneAnimated
        }, bodyClassName),
        style: bodyStyle
    }, tabs.map((item)=>{
        const { key: key, forceRender: forceRender, style: paneStyle, className: paneClassName, destroyOnHidden: itemDestroyOnHidden, ...restTabProps } = item;
        const active = key === activeKey;
        return /*#__PURE__*/ $cQmXV.createElement((0, $04c53b89814950f8$export$2e2bcd8739ae039), $6b496a352d71832f$var$_extends({
            key: key,
            visible: active,
            forceRender: forceRender,
            removeOnLeave: !!(destroyOnHidden ?? itemDestroyOnHidden),
            leavedClassName: `${contentPrefixCls}-hidden`
        }, animated.tabPaneMotion), ({ style: motionStyle, className: motionClassName }, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $b7310f47e39a9856$export$2e2bcd8739ae039), $6b496a352d71832f$var$_extends({}, restTabProps, {
                prefixCls: contentPrefixCls,
                id: id,
                tabKey: key,
                animated: tabPaneAnimated,
                active: active,
                style: {
                    ...contentStyle,
                    ...paneStyle,
                    ...motionStyle
                },
                className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(contentClassName, paneClassName, motionClassName),
                ref: ref
            })));
    })));
};
var $6b496a352d71832f$export$2e2bcd8739ae039 = $6b496a352d71832f$var$TabPanelList;



function $ea11ffa3d49ac33d$export$2e2bcd8739ae039(animated = {
    inkBar: true,
    tabPane: false
}) {
    let mergedAnimated;
    if (animated === false) mergedAnimated = {
        inkBar: false,
        tabPane: false
    };
    else if (animated === true) mergedAnimated = {
        inkBar: true,
        tabPane: false
    };
    else mergedAnimated = {
        inkBar: true,
        ...typeof animated === "object" ? animated : {}
    };
    // Enable tabPane animation if provide motion
    if (mergedAnimated.tabPaneMotion && mergedAnimated.tabPane === undefined) mergedAnimated.tabPane = true;
    if (!mergedAnimated.tabPaneMotion && mergedAnimated.tabPane) mergedAnimated.tabPane = false;
    return mergedAnimated;
}


function $947e0e17b2d281d3$var$_extends() {
    $947e0e17b2d281d3$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $947e0e17b2d281d3$var$_extends.apply(this, arguments);
}
/**
 * Should added antd:
 * - type
 *
 * Removed:
 * - onNextClick
 * - onPrevClick
 * - keyboard
 */ // Used for accessibility
let $947e0e17b2d281d3$var$uuid = 0;
const $947e0e17b2d281d3$var$Tabs = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { id: id, prefixCls: prefixCls = "rc-tabs", className: className, items: items, direction: direction, activeKey: activeKey, defaultActiveKey: defaultActiveKey, editable: editable, animated: animated, tabPosition: tabPosition = "top", tabBarGutter: tabBarGutter, tabBarStyle: tabBarStyle, tabBarExtraContent: tabBarExtraContent, locale: locale, more: more, destroyOnHidden: destroyOnHidden, renderTabBar: renderTabBar, onChange: onChange, onTabClick: onTabClick, onTabScroll: onTabScroll, getPopupContainer: getPopupContainer, popupClassName: popupClassName, indicator: indicator, classNames: tabsClassNames, styles: styles, ...restProps } = props;
    const tabs = $cQmXV.useMemo(()=>(items || []).filter((item)=>item && typeof item === "object" && "key" in item), [
        items
    ]);
    const rtl = direction === "rtl";
    const mergedAnimated = (0, $ea11ffa3d49ac33d$export$2e2bcd8739ae039)(animated);
    // ======================== Mobile ========================
    const [mobile, setMobile] = (0, $cQmXV.useState)(false);
    (0, $cQmXV.useEffect)(()=>{
        // Only update on the client side
        setMobile((0, $2bf5fcb531762fb8$export$2e2bcd8739ae039)());
    }, []);
    // ====================== Active Key ======================
    const [mergedActiveKey, setMergedActiveKey] = (0, $a51866d781137e08$export$2e2bcd8739ae039)(defaultActiveKey ?? tabs[0]?.key, activeKey);
    const [activeIndex, setActiveIndex] = (0, $cQmXV.useState)(()=>tabs.findIndex((tab)=>tab.key === mergedActiveKey));
    // Reset active key if not exist anymore
    (0, $cQmXV.useEffect)(()=>{
        let newActiveIndex = tabs.findIndex((tab)=>tab.key === mergedActiveKey);
        if (newActiveIndex === -1) {
            newActiveIndex = Math.max(0, Math.min(activeIndex, tabs.length - 1));
            setMergedActiveKey(tabs[newActiveIndex]?.key);
        }
        setActiveIndex(newActiveIndex);
    }, [
        tabs.map((tab)=>tab.key).join("_"),
        mergedActiveKey,
        activeIndex
    ]);
    // ===================== Accessibility ====================
    const [mergedId, setMergedId] = (0, $a51866d781137e08$export$2e2bcd8739ae039)(null, id);
    // Async generate id to avoid ssr mapping failed
    (0, $cQmXV.useEffect)(()=>{
        if (!id) {
            setMergedId(`rc-tabs-${$947e0e17b2d281d3$var$uuid}`);
            $947e0e17b2d281d3$var$uuid += 1;
        }
    }, []);
    // ======================== Events ========================
    function onInternalTabClick(key, e) {
        onTabClick?.(key, e);
        const isActiveChanged = key !== mergedActiveKey;
        setMergedActiveKey(key);
        if (isActiveChanged) onChange?.(key);
    }
    // ======================== Render ========================
    const sharedProps = {
        id: mergedId,
        activeKey: mergedActiveKey,
        animated: mergedAnimated,
        tabPosition: tabPosition,
        rtl: rtl,
        mobile: mobile
    };
    const tabNavBarProps = {
        ...sharedProps,
        editable: editable,
        locale: locale,
        more: more,
        tabBarGutter: tabBarGutter,
        onTabClick: onInternalTabClick,
        onTabScroll: onTabScroll,
        extra: tabBarExtraContent,
        style: tabBarStyle,
        getPopupContainer: getPopupContainer,
        popupClassName: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(popupClassName, tabsClassNames?.popup),
        indicator: indicator,
        styles: styles,
        classNames: tabsClassNames
    };
    const memoizedValue = $cQmXV.useMemo(()=>{
        return {
            tabs: tabs,
            prefixCls: prefixCls
        };
    }, [
        tabs,
        prefixCls
    ]);
    return /*#__PURE__*/ $cQmXV.createElement((0, $8171f2ace8df4897$export$2e2bcd8739ae039).Provider, {
        value: memoizedValue
    }, /*#__PURE__*/ $cQmXV.createElement("div", $947e0e17b2d281d3$var$_extends({
        ref: ref,
        id: id,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-${tabPosition}`, {
            [`${prefixCls}-mobile`]: mobile,
            [`${prefixCls}-editable`]: editable,
            [`${prefixCls}-rtl`]: rtl
        }, className)
    }, restProps), /*#__PURE__*/ $cQmXV.createElement((0, $8d7cbdda6282dec7$export$2e2bcd8739ae039), $947e0e17b2d281d3$var$_extends({}, tabNavBarProps, {
        renderTabBar: renderTabBar
    })), /*#__PURE__*/ $cQmXV.createElement((0, $6b496a352d71832f$export$2e2bcd8739ae039), $947e0e17b2d281d3$var$_extends({
        destroyOnHidden: destroyOnHidden
    }, sharedProps, {
        bodyStyle: styles?.body,
        bodyClassName: tabsClassNames?.body,
        contentStyle: styles?.content,
        contentClassName: tabsClassNames?.content,
        animated: mergedAnimated
    }))));
});
var $947e0e17b2d281d3$export$2e2bcd8739ae039 = $947e0e17b2d281d3$var$Tabs;


var $a81a207d4460e366$export$2e2bcd8739ae039 = (0, $947e0e17b2d281d3$export$2e2bcd8739ae039);











const $bc75fef2814bca50$var$motion = {
    motionAppear: false,
    motionEnter: true,
    motionLeave: true
};
function $bc75fef2814bca50$export$2e2bcd8739ae039(prefixCls, animated = {
    inkBar: true,
    tabPane: false
}) {
    let mergedAnimated;
    if (animated === false) mergedAnimated = {
        inkBar: false,
        tabPane: false
    };
    else if (animated === true) mergedAnimated = {
        inkBar: true,
        tabPane: true
    };
    else mergedAnimated = {
        inkBar: true,
        ...(0, $8e2d153a3c855782$export$53b83ca8eaab0383)(animated) ? animated : {}
    };
    if (mergedAnimated.tabPane) mergedAnimated.tabPaneMotion = {
        ...$bc75fef2814bca50$var$motion,
        motionName: (0, $047a5f051ebda8ba$export$27c72201b1d09951)(prefixCls, "switch")
    };
    return mergedAnimated;
}



var $cQmXV = parcelRequire("cQmXV");


function $44699107f839df0b$var$filter(items) {
    return items.filter((item)=>item);
}
function $44699107f839df0b$var$useLegacyItems(items, children) {
    if (items) return items.map((item)=>({
            ...item,
            destroyOnHidden: item.destroyOnHidden ?? item.destroyInactiveTabPane
        }));
    const childrenItems = (0, $cd966a313e0a92ff$export$2e2bcd8739ae039)(children).map((node)=>{
        if (/*#__PURE__*/ $cQmXV.isValidElement(node)) {
            const { key: key, props: props } = node;
            const { tab: tab, ...restProps } = props || {};
            const item = {
                key: String(key),
                ...restProps,
                label: tab
            };
            return item;
        }
        return null;
    });
    return $44699107f839df0b$var$filter(childrenItems);
}
var $44699107f839df0b$export$2e2bcd8739ae039 = $44699107f839df0b$var$useLegacyItems;







const $f7ef0838d1d1453e$var$genMotionStyle = (token)=>{
    const { componentCls: componentCls, motionDurationSlow: motionDurationSlow } = token;
    return [
        {
            [componentCls]: {
                [`${componentCls}-switch`]: {
                    "&-appear, &-enter": {
                        transition: "none",
                        "&-start": {
                            opacity: 0
                        },
                        "&-active": {
                            opacity: 1,
                            transition: `opacity ${motionDurationSlow}`
                        }
                    },
                    "&-leave": {
                        position: "absolute",
                        transition: "none",
                        inset: 0,
                        "&-start": {
                            opacity: 1
                        },
                        "&-active": {
                            opacity: 0,
                            transition: `opacity ${motionDurationSlow}`
                        }
                    }
                }
            }
        },
        // Follow code may reuse in other components
        [
            (0, $ff153a7980a78f00$export$9018e60daecf7a6c)(token, "slide-up"),
            (0, $ff153a7980a78f00$export$9018e60daecf7a6c)(token, "slide-down")
        ]
    ];
};
var $f7ef0838d1d1453e$export$2e2bcd8739ae039 = $f7ef0838d1d1453e$var$genMotionStyle;


const $01e726f9a3ebb445$var$genCardStyle = (token)=>{
    const { componentCls: componentCls, tabsCardPadding: tabsCardPadding, cardBg: cardBg, cardGutter: cardGutter, colorBorderSecondary: colorBorderSecondary, itemSelectedColor: itemSelectedColor } = token;
    return {
        [`${componentCls}-card`]: {
            [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                [`${componentCls}-tab`]: {
                    margin: 0,
                    padding: tabsCardPadding,
                    background: cardBg,
                    border: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${colorBorderSecondary}`,
                    transition: `all ${token.motionDurationSlow} ${token.motionEaseInOut}`
                },
                [`${componentCls}-tab-active`]: {
                    color: itemSelectedColor,
                    background: token.colorBgContainer
                },
                [`${componentCls}-tab-focus:has(${componentCls}-tab-btn:focus-visible)`]: (0, $519d20bf207ce864$export$6539948f0a737e39)(token, -3),
                [`& ${componentCls}-tab${componentCls}-tab-focus ${componentCls}-tab-btn:focus-visible`]: {
                    outline: "none"
                },
                [`${componentCls}-ink-bar`]: {
                    visibility: "hidden"
                }
            },
            // ========================== Top & Bottom ==========================
            [`&${componentCls}-top, &${componentCls}-bottom`]: {
                [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                    [`${componentCls}-tab + ${componentCls}-tab`]: {
                        marginLeft: {
                            _skip_check_: true,
                            value: (0, $05f34ed03d41967d$export$523c0b569236b342)(cardGutter)
                        }
                    }
                }
            },
            [`&${componentCls}-top`]: {
                [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                    [`${componentCls}-tab`]: {
                        borderRadius: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.borderRadiusLG)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.borderRadiusLG)} 0 0`
                    },
                    [`${componentCls}-tab-active`]: {
                        borderBottomColor: token.colorBgContainer
                    }
                }
            },
            [`&${componentCls}-bottom`]: {
                [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                    [`${componentCls}-tab`]: {
                        borderRadius: `0 0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.borderRadiusLG)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.borderRadiusLG)}`
                    },
                    [`${componentCls}-tab-active`]: {
                        borderTopColor: token.colorBgContainer
                    }
                }
            },
            // ========================== Left & Right ==========================
            [`&${componentCls}-left, &${componentCls}-right`]: {
                [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                    [`${componentCls}-tab + ${componentCls}-tab`]: {
                        marginTop: (0, $05f34ed03d41967d$export$523c0b569236b342)(cardGutter)
                    }
                }
            },
            [`&${componentCls}-left`]: {
                [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                    [`${componentCls}-tab`]: {
                        borderRadius: {
                            _skip_check_: true,
                            value: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.borderRadiusLG)} 0 0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.borderRadiusLG)}`
                        }
                    },
                    [`${componentCls}-tab-active`]: {
                        borderRightColor: {
                            _skip_check_: true,
                            value: token.colorBgContainer
                        }
                    }
                }
            },
            [`&${componentCls}-right`]: {
                [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                    [`${componentCls}-tab`]: {
                        borderRadius: {
                            _skip_check_: true,
                            value: `0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.borderRadiusLG)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.borderRadiusLG)} 0`
                        }
                    },
                    [`${componentCls}-tab-active`]: {
                        borderLeftColor: {
                            _skip_check_: true,
                            value: token.colorBgContainer
                        }
                    }
                }
            }
        }
    };
};
const $01e726f9a3ebb445$var$genDropdownStyle = (token)=>{
    const { antCls: antCls, componentCls: componentCls, itemHoverColor: itemHoverColor, dropdownEdgeChildVerticalPadding: dropdownEdgeChildVerticalPadding } = token;
    return {
        [`${componentCls}-dropdown`]: {
            ...(0, $519d20bf207ce864$export$23997c3e44cc1c59)(token),
            position: "absolute",
            top: -9999,
            left: {
                _skip_check_: true,
                value: -9999
            },
            zIndex: token.zIndexPopup,
            display: "block",
            "&-hidden": {
                display: "none"
            },
            // When position is not enough for tabs dropdown, the placement will revert.
            // We will handle this with revert motion name.
            [`&${antCls}-slide-down-enter${antCls}-slide-down-enter-active${componentCls}-dropdown-placement-bottomLeft,
        &${antCls}-slide-down-appear${antCls}-slide-down-appear-active${componentCls}-dropdown-placement-bottomLeft,
        &${antCls}-slide-down-enter${antCls}-slide-down-enter-active${componentCls}-dropdown-placement-bottom,
        &${antCls}-slide-down-appear${antCls}-slide-down-appear-active${componentCls}-dropdown-placement-bottom,
        &${antCls}-slide-down-enter${antCls}-slide-down-enter-active${componentCls}-dropdown-placement-bottomRight,
        &${antCls}-slide-down-appear${antCls}-slide-down-appear-active${componentCls}-dropdown-placement-bottomRight`]: {
                animationName: (0, $ff153a7980a78f00$export$e801b802b037de6a)
            },
            [`&${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-dropdown-placement-topLeft,
        &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-dropdown-placement-topLeft,
        &${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-dropdown-placement-top,
        &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-dropdown-placement-top,
        &${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-dropdown-placement-topRight,
        &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-dropdown-placement-topRight`]: {
                animationName: (0, $ff153a7980a78f00$export$dd9f089fa5e819fe)
            },
            [`&${antCls}-slide-down-leave${antCls}-slide-down-leave-active${componentCls}-dropdown-placement-bottomLeft,
        &${antCls}-slide-down-leave${antCls}-slide-down-leave-active${componentCls}-dropdown-placement-bottom,
        &${antCls}-slide-down-leave${antCls}-slide-down-leave-active${componentCls}-dropdown-placement-bottomRight`]: {
                animationName: (0, $ff153a7980a78f00$export$f40f41df328ebc38)
            },
            [`&${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-dropdown-placement-topLeft,
        &${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-dropdown-placement-top,
        &${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-dropdown-placement-topRight`]: {
                animationName: (0, $ff153a7980a78f00$export$f7243fdb9c27c3b7)
            },
            [`${componentCls}-dropdown-menu`]: {
                maxHeight: token.tabsDropdownHeight,
                margin: 0,
                padding: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(dropdownEdgeChildVerticalPadding)} 0`,
                overflowX: "hidden",
                overflowY: "auto",
                textAlign: {
                    _skip_check_: true,
                    value: "left"
                },
                listStyleType: "none",
                backgroundColor: token.colorBgContainer,
                backgroundClip: "padding-box",
                borderRadius: token.borderRadiusLG,
                outline: "none",
                boxShadow: token.boxShadowSecondary,
                "&-item": {
                    ...(0, $519d20bf207ce864$export$b2b65df0d0824629),
                    display: "flex",
                    alignItems: "center",
                    minWidth: token.tabsDropdownWidth,
                    margin: 0,
                    padding: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.paddingXXS)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.paddingSM)}`,
                    color: token.colorText,
                    fontWeight: "normal",
                    fontSize: token.fontSize,
                    lineHeight: token.lineHeight,
                    cursor: "pointer",
                    transition: `all ${token.motionDurationSlow}`,
                    "> span": {
                        flex: 1,
                        whiteSpace: "nowrap"
                    },
                    "&-remove": {
                        flex: "none",
                        marginLeft: {
                            _skip_check_: true,
                            value: token.marginSM
                        },
                        color: token.colorIcon,
                        fontSize: token.fontSizeSM,
                        background: "transparent",
                        border: 0,
                        cursor: "pointer",
                        "&:hover": {
                            color: itemHoverColor
                        }
                    },
                    "&:hover": {
                        background: token.controlItemBgHover
                    },
                    "&-disabled": {
                        "&, &:hover": {
                            color: token.colorTextDisabled,
                            background: "transparent",
                            cursor: "not-allowed"
                        }
                    }
                }
            }
        }
    };
};
const $01e726f9a3ebb445$var$genPositionStyle = (token)=>{
    const { componentCls: componentCls, margin: margin, colorBorderSecondary: colorBorderSecondary, horizontalMargin: horizontalMargin, verticalItemPadding: verticalItemPadding, verticalItemMargin: verticalItemMargin, motionDurationSlow: motionDurationSlow, calc: calc } = token;
    return {
        // ========================== Top & Bottom ==========================
        [`${componentCls}-top, ${componentCls}-bottom`]: {
            flexDirection: "column",
            [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                margin: horizontalMargin,
                "&::before": {
                    position: "absolute",
                    right: {
                        _skip_check_: true,
                        value: 0
                    },
                    left: {
                        _skip_check_: true,
                        value: 0
                    },
                    borderBottom: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${colorBorderSecondary}`,
                    content: "''"
                },
                [`${componentCls}-ink-bar`]: {
                    height: token.lineWidthBold,
                    "&-animated": {
                        transition: [
                            "width",
                            "left",
                            "right"
                        ].map((prop)=>`${prop} ${motionDurationSlow}`).join(", ")
                    }
                },
                [`${componentCls}-nav-wrap`]: {
                    "&::before, &::after": {
                        top: 0,
                        bottom: 0,
                        width: token.controlHeight
                    },
                    "&::before": {
                        left: {
                            _skip_check_: true,
                            value: 0
                        },
                        boxShadow: token.boxShadowTabsOverflowLeft
                    },
                    "&::after": {
                        right: {
                            _skip_check_: true,
                            value: 0
                        },
                        boxShadow: token.boxShadowTabsOverflowRight
                    },
                    [`&${componentCls}-nav-wrap-ping-left::before`]: {
                        opacity: 1
                    },
                    [`&${componentCls}-nav-wrap-ping-right::after`]: {
                        opacity: 1
                    }
                }
            }
        },
        [`${componentCls}-top`]: {
            [`> ${componentCls}-nav,
        > div > ${componentCls}-nav`]: {
                "&::before": {
                    bottom: 0
                },
                [`${componentCls}-ink-bar`]: {
                    bottom: 0
                }
            }
        },
        [`${componentCls}-bottom`]: {
            [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                order: 1,
                marginTop: margin,
                marginBottom: 0,
                "&::before": {
                    top: 0
                },
                [`${componentCls}-ink-bar`]: {
                    top: 0
                }
            },
            [`> ${componentCls}-body-holder, > div > ${componentCls}-body-holder`]: {
                order: 0
            }
        },
        // ========================== Left & Right ==========================
        [`${componentCls}-left, ${componentCls}-right`]: {
            [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                flexDirection: "column",
                minWidth: calc(token.controlHeight).mul(1.25).equal(),
                // >>>>>>>>>>> Tab
                [`${componentCls}-tab`]: {
                    padding: verticalItemPadding,
                    textAlign: "center"
                },
                [`${componentCls}-tab + ${componentCls}-tab`]: {
                    margin: verticalItemMargin
                },
                // >>>>>>>>>>> Nav
                [`${componentCls}-nav-wrap`]: {
                    flexDirection: "column",
                    "&::before, &::after": {
                        right: {
                            _skip_check_: true,
                            value: 0
                        },
                        left: {
                            _skip_check_: true,
                            value: 0
                        },
                        height: token.controlHeight
                    },
                    "&::before": {
                        top: 0,
                        boxShadow: token.boxShadowTabsOverflowTop
                    },
                    "&::after": {
                        bottom: 0,
                        boxShadow: token.boxShadowTabsOverflowBottom
                    },
                    [`&${componentCls}-nav-wrap-ping-top::before`]: {
                        opacity: 1
                    },
                    [`&${componentCls}-nav-wrap-ping-bottom::after`]: {
                        opacity: 1
                    }
                },
                // >>>>>>>>>>> Ink Bar
                [`${componentCls}-ink-bar`]: {
                    width: token.lineWidthBold,
                    "&-animated": {
                        transition: [
                            "height",
                            "top"
                        ].map((prop)=>`${prop} ${motionDurationSlow}`).join(", ")
                    }
                },
                [`${componentCls}-nav-list, ${componentCls}-nav-operations`]: {
                    flex: "1 0 auto",
                    // fix safari scroll problem
                    flexDirection: "column"
                }
            }
        },
        [`${componentCls}-left`]: {
            [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                [`${componentCls}-ink-bar`]: {
                    right: {
                        _skip_check_: true,
                        value: 0
                    }
                }
            },
            [`> ${componentCls}-body-holder, > div > ${componentCls}-body-holder`]: {
                marginLeft: {
                    _skip_check_: true,
                    value: (0, $05f34ed03d41967d$export$523c0b569236b342)(calc(token.lineWidth).mul(-1).equal())
                },
                borderLeft: {
                    _skip_check_: true,
                    value: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
                },
                [`> ${componentCls}-body > ${componentCls}-content`]: {
                    paddingLeft: {
                        _skip_check_: true,
                        value: token.paddingLG
                    }
                }
            }
        },
        [`${componentCls}-right`]: {
            [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                order: 1,
                [`${componentCls}-ink-bar`]: {
                    left: {
                        _skip_check_: true,
                        value: 0
                    }
                }
            },
            [`> ${componentCls}-body-holder, > div > ${componentCls}-body-holder`]: {
                order: 0,
                marginRight: {
                    _skip_check_: true,
                    value: calc(token.lineWidth).mul(-1).equal()
                },
                borderRight: {
                    _skip_check_: true,
                    value: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
                },
                [`> ${componentCls}-body > ${componentCls}-content`]: {
                    paddingRight: {
                        _skip_check_: true,
                        value: token.paddingLG
                    }
                }
            }
        }
    };
};
const $01e726f9a3ebb445$var$genSizeStyle = (token)=>{
    const { componentCls: componentCls, cardPaddingSM: cardPaddingSM, cardPaddingLG: cardPaddingLG, cardHeightSM: cardHeightSM, cardHeightLG: cardHeightLG, horizontalItemPaddingSM: horizontalItemPaddingSM, horizontalItemPaddingLG: horizontalItemPaddingLG } = token;
    return {
        // >>>>> shared
        [componentCls]: {
            "&-small": {
                [`> ${componentCls}-nav`]: {
                    [`${componentCls}-tab`]: {
                        padding: horizontalItemPaddingSM,
                        fontSize: token.titleFontSizeSM
                    }
                }
            },
            "&-large": {
                [`> ${componentCls}-nav`]: {
                    [`${componentCls}-tab`]: {
                        padding: horizontalItemPaddingLG,
                        fontSize: token.titleFontSizeLG,
                        lineHeight: token.lineHeightLG
                    }
                }
            }
        },
        // >>>>> card
        [`${componentCls}-card`]: {
            // Small
            [`&${componentCls}-small`]: {
                [`> ${componentCls}-nav`]: {
                    [`${componentCls}-tab`]: {
                        padding: cardPaddingSM
                    },
                    [`${componentCls}-nav-add`]: {
                        minWidth: cardHeightSM,
                        minHeight: cardHeightSM
                    }
                },
                [`&${componentCls}-bottom`]: {
                    [`> ${componentCls}-nav ${componentCls}-tab`]: {
                        borderRadius: `0 0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.borderRadius)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.borderRadius)}`
                    }
                },
                [`&${componentCls}-top`]: {
                    [`> ${componentCls}-nav ${componentCls}-tab`]: {
                        borderRadius: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.borderRadius)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.borderRadius)} 0 0`
                    }
                },
                [`&${componentCls}-right`]: {
                    [`> ${componentCls}-nav ${componentCls}-tab`]: {
                        borderRadius: {
                            _skip_check_: true,
                            value: `0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.borderRadius)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.borderRadius)} 0`
                        }
                    }
                },
                [`&${componentCls}-left`]: {
                    [`> ${componentCls}-nav ${componentCls}-tab`]: {
                        borderRadius: {
                            _skip_check_: true,
                            value: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.borderRadius)} 0 0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.borderRadius)}`
                        }
                    }
                }
            },
            // Large
            [`&${componentCls}-large`]: {
                [`> ${componentCls}-nav`]: {
                    [`${componentCls}-tab`]: {
                        padding: cardPaddingLG
                    },
                    [`${componentCls}-nav-add`]: {
                        minWidth: cardHeightLG,
                        minHeight: cardHeightLG
                    }
                }
            }
        }
    };
};
const $01e726f9a3ebb445$var$genTabStyle = (token)=>{
    const { componentCls: componentCls, itemActiveColor: itemActiveColor, itemHoverColor: itemHoverColor, iconCls: iconCls, tabsHorizontalItemMargin: tabsHorizontalItemMargin, horizontalItemPadding: horizontalItemPadding, itemSelectedColor: itemSelectedColor, itemColor: itemColor } = token;
    const tabCls = `${componentCls}-tab`;
    return {
        [tabCls]: {
            position: "relative",
            WebkitTouchCallout: "none",
            WebkitTapHighlightColor: "transparent",
            display: "inline-flex",
            alignItems: "center",
            padding: horizontalItemPadding,
            fontSize: token.titleFontSize,
            background: "transparent",
            border: 0,
            outline: "none",
            cursor: "pointer",
            color: itemColor,
            "&-btn, &-remove": {
                "&:focus:not(:focus-visible), &:active": {
                    color: itemActiveColor
                }
            },
            "&-btn": {
                outline: "none",
                transition: `all ${token.motionDurationSlow}`,
                [`${tabCls}-icon:not(:last-child)`]: {
                    marginInlineEnd: token.marginSM
                },
                // Icons from third-party libraries render as a bare `<svg>` inside the icon wrapper,
                // which the `.anticon` reset never reaches. An `<svg>` has no baseline of its own, so it
                // is aligned by its bottom margin edge (CSS 2.1 §10.8.1) and rides above the label.
                // `display: inline-block` keeps it an atomic inline box so `vertical-align` still applies
                // even under a CSS reset that forces `svg { display: block }` (e.g. Tailwind Preflight),
                // which would otherwise drop the icon onto its own line. `vertical-align: middle` centres its
                // margin box on the x-height line; `margin-block-end` then lifts it by half its own value onto
                // the cap-height centre (capHeight − xHeight ≈ 0.2em across typical fonts), keeping it centred
                // at any icon size.
                // Only matches a bare `<svg>`: an `.anticon` keeps its `<svg>` one level deeper.
                [`${tabCls}-icon > svg`]: {
                    display: "inline-block",
                    verticalAlign: "middle",
                    marginBlockEnd: "0.2em"
                }
            },
            "&-remove": {
                flex: "none",
                lineHeight: 1,
                marginRight: {
                    _skip_check_: true,
                    value: token.calc(token.marginXXS).mul(-1).equal()
                },
                marginLeft: {
                    _skip_check_: true,
                    value: token.marginXS
                },
                color: token.colorIcon,
                fontSize: token.fontSizeSM,
                background: "transparent",
                border: "none",
                outline: "none",
                cursor: "pointer",
                transition: `all ${token.motionDurationSlow}`,
                "&:hover": {
                    color: token.colorTextHeading
                },
                ...(0, $519d20bf207ce864$export$a44db842bcb28231)(token)
            },
            "&:hover": {
                color: itemHoverColor
            },
            [`&${tabCls}-active ${tabCls}-btn`]: {
                color: itemSelectedColor
            },
            [`&${tabCls}-focus ${tabCls}-btn:focus-visible`]: (0, $519d20bf207ce864$export$6539948f0a737e39)(token),
            [`&${tabCls}-disabled`]: {
                color: token.colorTextDisabled,
                cursor: "not-allowed"
            },
            [`&${tabCls}-disabled ${tabCls}-btn, &${tabCls}-disabled ${componentCls}-remove`]: {
                "&:focus, &:active": {
                    color: token.colorTextDisabled
                }
            },
            [`& ${tabCls}-remove ${iconCls}`]: {
                margin: 0,
                verticalAlign: "middle"
            },
            [`${iconCls}:not(:last-child)`]: {
                marginRight: {
                    _skip_check_: true,
                    value: token.marginSM
                }
            }
        },
        [`${tabCls} + ${tabCls}`]: {
            margin: {
                _skip_check_: true,
                value: tabsHorizontalItemMargin
            }
        }
    };
};
const $01e726f9a3ebb445$var$genRtlStyle = (token)=>{
    const { componentCls: componentCls, tabsHorizontalItemMarginRTL: tabsHorizontalItemMarginRTL, iconCls: iconCls, cardGutter: cardGutter, calc: calc } = token;
    const rtlCls = `${componentCls}-rtl`;
    return {
        [rtlCls]: {
            direction: "rtl",
            [`${componentCls}-nav`]: {
                [`${componentCls}-tab`]: {
                    margin: {
                        _skip_check_: true,
                        value: tabsHorizontalItemMarginRTL
                    },
                    [`${componentCls}-tab:last-of-type`]: {
                        marginLeft: {
                            _skip_check_: true,
                            value: 0
                        }
                    },
                    [iconCls]: {
                        marginRight: {
                            _skip_check_: true,
                            value: 0
                        },
                        marginLeft: {
                            _skip_check_: true,
                            value: token.marginSM
                        }
                    },
                    [`${componentCls}-tab-remove`]: {
                        marginRight: {
                            _skip_check_: true,
                            value: token.marginXS
                        },
                        marginLeft: {
                            _skip_check_: true,
                            value: calc(token.marginXXS).mul(-1).equal()
                        },
                        [iconCls]: {
                            margin: 0
                        }
                    }
                }
            },
            [`&${componentCls}-left`]: {
                [`> ${componentCls}-nav`]: {
                    order: 1
                },
                [`> ${componentCls}-body-holder`]: {
                    order: 0
                }
            },
            [`&${componentCls}-right`]: {
                [`> ${componentCls}-nav`]: {
                    order: 0
                },
                [`> ${componentCls}-body-holder`]: {
                    order: 1
                }
            },
            // ====================== Card ======================
            [`&${componentCls}-card${componentCls}-top, &${componentCls}-card${componentCls}-bottom`]: {
                [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                    [`${componentCls}-tab + ${componentCls}-tab`]: {
                        marginRight: {
                            _skip_check_: true,
                            value: cardGutter
                        },
                        marginLeft: {
                            _skip_check_: true,
                            value: 0
                        }
                    }
                }
            }
        },
        [`${componentCls}-dropdown-rtl`]: {
            direction: "rtl"
        },
        [`${componentCls}-menu-item`]: {
            [`${componentCls}-dropdown-rtl`]: {
                textAlign: {
                    _skip_check_: true,
                    value: "right"
                }
            }
        }
    };
};
const $01e726f9a3ebb445$var$genTabsStyle = (token)=>{
    const { componentCls: componentCls, tabsCardPadding: tabsCardPadding, cardHeight: cardHeight, cardGutter: cardGutter, itemHoverColor: itemHoverColor, itemActiveColor: itemActiveColor, colorBorderSecondary: colorBorderSecondary } = token;
    return {
        [componentCls]: {
            ...(0, $519d20bf207ce864$export$23997c3e44cc1c59)(token),
            display: "flex",
            // ========================== Navigation ==========================
            [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                position: "relative",
                display: "flex",
                flex: "none",
                alignItems: "center",
                [`${componentCls}-nav-wrap`]: {
                    position: "relative",
                    display: "flex",
                    flex: "auto",
                    alignSelf: "stretch",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    transform: "translate(0)",
                    // Fix chrome render bug
                    // >>>>> Ping shadow
                    "&::before, &::after": {
                        position: "absolute",
                        zIndex: 1,
                        opacity: 0,
                        transition: `opacity ${token.motionDurationSlow}`,
                        content: "''",
                        pointerEvents: "none"
                    }
                },
                [`${componentCls}-nav-list`]: {
                    position: "relative",
                    display: "flex",
                    transition: `opacity ${token.motionDurationSlow}`
                },
                // >>>>>>>> Operations
                [`${componentCls}-nav-operations`]: {
                    display: "flex",
                    alignSelf: "stretch"
                },
                [`${componentCls}-nav-operations-hidden`]: {
                    position: "absolute",
                    visibility: "hidden",
                    pointerEvents: "none"
                },
                [`${componentCls}-nav-more`]: {
                    position: "relative",
                    padding: tabsCardPadding,
                    background: "transparent",
                    border: 0,
                    color: token.colorText,
                    "&::after": {
                        position: "absolute",
                        right: {
                            _skip_check_: true,
                            value: 0
                        },
                        bottom: 0,
                        left: {
                            _skip_check_: true,
                            value: 0
                        },
                        height: token.calc(token.controlHeightLG).div(8).equal(),
                        transform: "translateY(100%)",
                        content: "''"
                    }
                },
                [`${componentCls}-nav-add`]: {
                    minWidth: cardHeight,
                    minHeight: cardHeight,
                    marginLeft: {
                        _skip_check_: true,
                        value: cardGutter
                    },
                    background: "transparent",
                    border: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${colorBorderSecondary}`,
                    borderRadius: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.borderRadiusLG)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.borderRadiusLG)} 0 0`,
                    outline: "none",
                    cursor: "pointer",
                    color: token.colorText,
                    transition: `all ${token.motionDurationSlow} ${token.motionEaseInOut}`,
                    "&:hover": {
                        color: itemHoverColor
                    },
                    "&:active, &:focus:not(:focus-visible)": {
                        color: itemActiveColor
                    },
                    ...(0, $519d20bf207ce864$export$a44db842bcb28231)(token, -3)
                }
            },
            [`${componentCls}-extra-content`]: {
                flex: "none"
            },
            // ============================ InkBar ============================
            [`${componentCls}-ink-bar`]: {
                position: "absolute",
                background: token.inkBarColor,
                pointerEvents: "none"
            },
            // ============================= Tabs =============================
            ...$01e726f9a3ebb445$var$genTabStyle(token),
            // =========================== TabPanes ===========================
            [`${componentCls}-body`]: {
                position: "relative",
                width: "100%"
            },
            [`${componentCls}-body-holder`]: {
                flex: "auto",
                minWidth: 0,
                minHeight: 0
            },
            [`${componentCls}-content`]: {
                ...(0, $519d20bf207ce864$export$a44db842bcb28231)(token),
                "&-hidden": {
                    display: "none"
                }
            }
        },
        [`${componentCls}-centered`]: {
            [`> ${componentCls}-nav, > div > ${componentCls}-nav`]: {
                [`${componentCls}-nav-wrap`]: {
                    [`&:not([class*='${componentCls}-nav-wrap-ping']) > ${componentCls}-nav-list`]: {
                        margin: "auto"
                    }
                }
            }
        }
    };
};
const $01e726f9a3ebb445$export$9ca1be8807fe0675 = (token)=>{
    const { cardHeight: cardHeight, cardHeightSM: cardHeightSM, cardHeightLG: cardHeightLG, controlHeight: controlHeight, controlHeightLG: controlHeightLG } = token;
    const mergedCardHeight = cardHeight || controlHeightLG;
    const mergedCardHeightSM = cardHeightSM || controlHeight;
    // `controlHeight` missing XL variable, so we directly write it here:
    const mergedCardHeightLG = cardHeightLG || controlHeightLG + 8;
    return {
        zIndexPopup: token.zIndexPopupBase + 50,
        cardBg: token.colorFillAlter,
        // We can not pass this as valid value,
        // Since `cardHeight` will lock nav add button height.
        cardHeight: mergedCardHeight,
        cardHeightSM: mergedCardHeightSM,
        cardHeightLG: mergedCardHeightLG,
        // Initialize with empty string, because cardPadding will be calculated with cardHeight by default.
        cardPadding: `${(mergedCardHeight - token.fontHeight) / 2 - token.lineWidth}px ${token.padding}px`,
        cardPaddingSM: `${(mergedCardHeightSM - token.fontHeight) / 2 - token.lineWidth}px ${token.paddingXS}px`,
        cardPaddingLG: `${(mergedCardHeightLG - token.fontHeightLG) / 2 - token.lineWidth}px ${token.padding}px`,
        titleFontSize: token.fontSize,
        titleFontSizeLG: token.fontSizeLG,
        titleFontSizeSM: token.fontSize,
        inkBarColor: token.colorPrimary,
        horizontalMargin: `0 0 ${token.margin}px 0`,
        horizontalItemGutter: 32,
        // Fixed Value
        // Initialize with empty string, because horizontalItemMargin will be calculated with horizontalItemGutter by default.
        horizontalItemMargin: ``,
        horizontalItemMarginRTL: ``,
        horizontalItemPadding: `${token.paddingSM}px 0`,
        horizontalItemPaddingSM: `${token.paddingXS}px 0`,
        horizontalItemPaddingLG: `${token.padding}px 0`,
        verticalItemPadding: `${token.paddingXS}px ${token.paddingLG}px`,
        verticalItemMargin: `${token.margin}px 0 0 0`,
        itemColor: token.colorText,
        itemSelectedColor: token.colorPrimary,
        itemHoverColor: token.colorPrimaryHover,
        itemActiveColor: token.colorPrimaryActive,
        cardGutter: token.marginXXS / 2
    };
};
var // ============================== Export ==============================
$01e726f9a3ebb445$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$51ec95de45185b42)("Tabs", (token)=>{
    const tabsToken = (0, $fef50f256b80dfa5$export$4950aa0f605343fb)(token, {
        // `cardPadding` is empty by default, so we could calculate with dynamic `cardHeight`
        tabsCardPadding: token.cardPadding,
        dropdownEdgeChildVerticalPadding: token.paddingXXS,
        tabsDropdownHeight: 200,
        tabsDropdownWidth: 120,
        tabsHorizontalItemMargin: `0 0 0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.horizontalItemGutter)}`,
        tabsHorizontalItemMarginRTL: `0 0 0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.horizontalItemGutter)}`
    });
    return [
        $01e726f9a3ebb445$var$genSizeStyle(tabsToken),
        $01e726f9a3ebb445$var$genRtlStyle(tabsToken),
        $01e726f9a3ebb445$var$genPositionStyle(tabsToken),
        $01e726f9a3ebb445$var$genDropdownStyle(tabsToken),
        $01e726f9a3ebb445$var$genCardStyle(tabsToken),
        $01e726f9a3ebb445$var$genTabsStyle(tabsToken),
        (0, $f7ef0838d1d1453e$export$2e2bcd8739ae039)(tabsToken)
    ];
}, $01e726f9a3ebb445$export$9ca1be8807fe0675);


const $18ad1ea3de29f0cf$var$TabPane = ()=>null;
var $18ad1ea3de29f0cf$export$2e2bcd8739ae039 = $18ad1ea3de29f0cf$var$TabPane;


"use client";
const $cf7a430748488e77$var$InternalTabs = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { type: type, className: className, rootClassName: rootClassName, size: customSize, onEdit: onEdit, hideAdd: hideAdd, centered: centered, addIcon: addIcon, removeIcon: removeIcon, moreIcon: moreIcon, more: more, popupClassName: popupClassName, children: children, items: items, animated: animated, style: style, indicatorSize: indicatorSize, indicator: indicator, classNames: classNames, styles: styles, destroyInactiveTabPane: destroyInactiveTabPane, destroyOnHidden: destroyOnHidden, tabPlacement: tabPlacement, tabPosition: tabPosition, ...restProps } = props;
    const { prefixCls: customizePrefixCls } = restProps;
    const { getPrefixCls: getPrefixCls, direction: direction, getPopupContainer: getPopupContainer, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("tabs");
    const { tabs: tabs } = $cQmXV.useContext((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls("tabs", customizePrefixCls);
    const rootCls = (0, $2237081acd3cfc09$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $01e726f9a3ebb445$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const tabsRef = $cQmXV.useRef(null);
    $cQmXV.useImperativeHandle(ref, ()=>({
            nativeElement: tabsRef.current
        }));
    let editable;
    if (type === "editable-card") editable = {
        onEdit: (editType, { key: key, event: event })=>{
            onEdit?.(editType === "add" ? event : key, editType);
        },
        removeIcon: removeIcon ?? tabs?.removeIcon ?? /*#__PURE__*/ $cQmXV.createElement((0, $837faca566926e3c$export$2e2bcd8739ae039), null),
        addIcon: (addIcon ?? tabs?.addIcon) || /*#__PURE__*/ $cQmXV.createElement((0, $fa25166ced813feb$export$2e2bcd8739ae039), null),
        showAdd: hideAdd !== true
    };
    const rootPrefixCls = getPrefixCls();
    var deprecatedName, newName, item;
    const size = (0, $78cdfb6138721329$export$2e2bcd8739ae039)(customSize);
    const mergedItems = (0, $44699107f839df0b$export$2e2bcd8739ae039)(items, children);
    const mergedAnimated = (0, $bc75fef2814bca50$export$2e2bcd8739ae039)(prefixCls, animated);
    const mergedIndicator = {
        align: indicator?.align ?? tabs?.indicator?.align,
        size: indicator?.size ?? indicatorSize ?? tabs?.indicator?.size ?? tabs?.indicatorSize
    };
    const mergedPlacement = $cQmXV.useMemo(()=>{
        const placement = tabPlacement ?? tabPosition ?? undefined;
        const isRTL = direction === "rtl";
        switch(placement){
            case "start":
                return isRTL ? "right" : "left";
            case "end":
                return isRTL ? "left" : "right";
            default:
                return placement;
        }
    }, [
        tabPlacement,
        tabPosition,
        direction
    ]);
    // =========== Merged Props for Semantic ===========
    const mergedProps = {
        ...props,
        size: size,
        tabPlacement: mergedPlacement,
        items: mergedItems
    };
    // ========================= Style ==========================
    const contextStyleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $30c5f9f911d4f61b$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: mergedProps
    }, {
        popup: {
            _default: "root"
        }
    });
    return /*#__PURE__*/ $cQmXV.createElement((0, $a81a207d4460e366$export$2e2bcd8739ae039), {
        ref: tabsRef,
        direction: direction,
        getPopupContainer: getPopupContainer,
        ...restProps,
        items: mergedItems,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)({
            [`${prefixCls}-large`]: size === "large",
            [`${prefixCls}-small`]: size === "small",
            [`${prefixCls}-card`]: [
                "card",
                "editable-card"
            ].includes(type),
            [`${prefixCls}-editable-card`]: type === "editable-card",
            [`${prefixCls}-centered`]: centered
        }, contextClassName, className, rootClassName, mergedClassNames.root, hashId, cssVarCls, rootCls),
        classNames: {
            ...mergedClassNames,
            popup: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(popupClassName, hashId, cssVarCls, rootCls, mergedClassNames.popup?.root)
        },
        styles: mergedStyles,
        style: mergedStyles.root,
        editable: editable,
        more: {
            icon: tabs?.more?.icon ?? tabs?.moreIcon ?? moreIcon ?? /*#__PURE__*/ $cQmXV.createElement((0, $f172eb883972dae9$export$2e2bcd8739ae039), null),
            transitionName: `${rootPrefixCls}-slide-up`,
            ...more
        },
        prefixCls: prefixCls,
        animated: mergedAnimated,
        indicator: mergedIndicator,
        destroyOnHidden: destroyOnHidden ?? destroyInactiveTabPane,
        tabPosition: mergedPlacement
    });
});
const $cf7a430748488e77$var$Tabs = $cf7a430748488e77$var$InternalTabs;
$cf7a430748488e77$var$Tabs.TabPane = (0, $18ad1ea3de29f0cf$export$2e2bcd8739ae039);
var $cf7a430748488e77$export$2e2bcd8739ae039 = $cf7a430748488e77$var$Tabs;



var $cQmXV = parcelRequire("cQmXV");


"use client";
const $9d7b5a20ce6db5e4$var$CardGrid = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { prefixCls: prefixCls, className: className, hoverable: hoverable = true, ...rest } = props;
    const { getPrefixCls: getPrefixCls } = $cQmXV.useContext((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    const prefix = getPrefixCls("card", prefixCls);
    const classString = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefix}-grid`, className, {
        [`${prefix}-grid-hoverable`]: hoverable
    });
    const nativeElementRef = $cQmXV.useRef(null);
    $cQmXV.useImperativeHandle(ref, ()=>({
            nativeElement: nativeElementRef.current
        }));
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        ref: nativeElementRef,
        ...rest,
        className: classString
    });
});
var $9d7b5a20ce6db5e4$export$2e2bcd8739ae039 = $9d7b5a20ce6db5e4$var$CardGrid;





// ============================== Styles ==============================
// ============================== Head ==============================
const $258091baf7aaca91$var$genCardHeadStyle = (token)=>{
    const { antCls: antCls, componentCls: componentCls, headerHeight: headerHeight, headerPadding: headerPadding, tabsMarginBottom: tabsMarginBottom } = token;
    return {
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        minHeight: headerHeight,
        marginBottom: -1,
        // Fix card grid overflow bug: https://gw.alipayobjects.com/zos/rmsportal/XonYxBikwpgbqIQBeuhk.png
        padding: `0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(headerPadding)}`,
        color: token.colorTextHeading,
        fontWeight: token.fontWeightStrong,
        fontSize: token.headerFontSize,
        background: token.headerBg,
        borderBottom: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorderSecondary}`,
        borderRadius: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.borderRadiusLG)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.borderRadiusLG)} 0 0`,
        ...(0, $519d20bf207ce864$export$8c467e8859fdef13)(),
        "&-wrapper": {
            width: "100%",
            display: "flex",
            alignItems: "center"
        },
        "&-title": {
            display: "inline-block",
            flex: 1,
            ...(0, $519d20bf207ce864$export$b2b65df0d0824629),
            [`
          > ${componentCls}-typography,
          > ${componentCls}-typography-edit-content
        `]: {
                insetInlineStart: 0,
                marginTop: 0,
                marginBottom: 0
            }
        },
        [`${antCls}-tabs-top`]: {
            clear: "both",
            marginBottom: tabsMarginBottom,
            color: token.colorText,
            fontWeight: "normal",
            fontSize: token.fontSize,
            "&-bar": {
                borderBottom: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorderSecondary}`
            }
        }
    };
};
// ============================== Grid ==============================
const $258091baf7aaca91$var$genCardGridStyle = (token)=>{
    const { cardPaddingBase: cardPaddingBase, colorBorderSecondary: colorBorderSecondary, cardShadow: cardShadow, lineWidth: lineWidth } = token;
    return {
        width: "33.33%",
        padding: cardPaddingBase,
        border: 0,
        borderRadius: 0,
        boxShadow: `
      ${(0, $05f34ed03d41967d$export$523c0b569236b342)(lineWidth)} 0 0 0 ${colorBorderSecondary},
      0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(lineWidth)} 0 0 ${colorBorderSecondary},
      ${(0, $05f34ed03d41967d$export$523c0b569236b342)(lineWidth)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(lineWidth)} 0 0 ${colorBorderSecondary},
      ${(0, $05f34ed03d41967d$export$523c0b569236b342)(lineWidth)} 0 0 0 ${colorBorderSecondary} inset,
      0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(lineWidth)} 0 0 ${colorBorderSecondary} inset;
    `,
        transition: `all ${token.motionDurationMid}`,
        "&-hoverable:hover": {
            position: "relative",
            zIndex: 1,
            boxShadow: cardShadow
        }
    };
};
// ============================== Actions ==============================
const $258091baf7aaca91$var$genCardActionsStyle = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, actionsLiMargin: actionsLiMargin, cardActionsIconSize: cardActionsIconSize, colorBorderSecondary: colorBorderSecondary, actionsBg: actionsBg } = token;
    return {
        margin: 0,
        padding: 0,
        listStyle: "none",
        background: actionsBg,
        borderTop: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${colorBorderSecondary}`,
        display: "flex",
        borderRadius: `0 0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.borderRadiusLG)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.borderRadiusLG)}`,
        ...(0, $519d20bf207ce864$export$8c467e8859fdef13)(),
        "& > li": {
            margin: actionsLiMargin,
            color: token.colorTextDescription,
            textAlign: "center",
            "> span": {
                position: "relative",
                display: "block",
                minWidth: token.calc(token.cardActionsIconSize).mul(2).equal(),
                fontSize: token.fontSize,
                lineHeight: token.lineHeight,
                cursor: "pointer",
                "&:hover": {
                    color: token.colorPrimary,
                    transition: `color ${token.motionDurationMid}`
                },
                [`a:not(${componentCls}-btn), > ${iconCls}`]: {
                    display: "inline-block",
                    width: "100%",
                    color: token.colorIcon,
                    lineHeight: (0, $05f34ed03d41967d$export$523c0b569236b342)(token.fontHeight),
                    transition: `color ${token.motionDurationMid}`,
                    "&:hover": {
                        color: token.colorPrimary
                    }
                },
                [`> ${iconCls}`]: {
                    fontSize: cardActionsIconSize,
                    lineHeight: (0, $05f34ed03d41967d$export$523c0b569236b342)(token.calc(cardActionsIconSize).mul(token.lineHeight).equal())
                }
            },
            "&:not(:last-child)": {
                borderInlineEnd: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${colorBorderSecondary}`
            }
        }
    };
};
// ============================== Meta ==============================
const $258091baf7aaca91$var$genCardMetaStyle = (token)=>({
        margin: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.calc(token.marginXXS).mul(-1).equal())} 0`,
        display: "flex",
        ...(0, $519d20bf207ce864$export$8c467e8859fdef13)(),
        "&-avatar": {
            paddingInlineEnd: token.padding
        },
        "&-section": {
            overflow: "hidden",
            flex: 1,
            "> div:not(:last-child)": {
                marginBottom: token.marginXS
            }
        },
        "&-title": {
            color: token.colorTextHeading,
            fontWeight: token.fontWeightStrong,
            fontSize: token.fontSizeLG,
            ...(0, $519d20bf207ce864$export$b2b65df0d0824629)
        },
        "&-description": {
            color: token.colorTextDescription
        }
    });
// ============================== Inner ==============================
const $258091baf7aaca91$var$genCardTypeInnerStyle = (token)=>{
    const { componentCls: componentCls, colorFillAlter: colorFillAlter, headerPadding: headerPadding, bodyPadding: bodyPadding } = token;
    return {
        [`${componentCls}-head`]: {
            padding: `0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(headerPadding)}`,
            background: colorFillAlter,
            "&-title": {
                fontSize: token.fontSize
            }
        },
        [`${componentCls}-body`]: {
            padding: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.padding)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(bodyPadding)}`
        }
    };
};
// ============================== Loading ==============================
const $258091baf7aaca91$var$genCardLoadingStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        overflow: "hidden",
        [`${componentCls}-body`]: {
            userSelect: "none"
        }
    };
};
// ============================== Basic ==============================
const $258091baf7aaca91$var$genCardStyle = (token)=>{
    const { componentCls: componentCls, cardShadow: cardShadow, cardHeadPadding: cardHeadPadding, colorBorderSecondary: colorBorderSecondary, boxShadowTertiary: boxShadowTertiary, bodyPadding: bodyPadding, extraColor: extraColor, motionDurationMid: motionDurationMid } = token;
    return {
        [componentCls]: {
            ...(0, $519d20bf207ce864$export$23997c3e44cc1c59)(token),
            position: "relative",
            background: token.colorBgContainer,
            borderRadius: token.borderRadiusLG,
            [`&:not(${componentCls}-bordered)`]: {
                boxShadow: boxShadowTertiary
            },
            [`${componentCls}-head`]: $258091baf7aaca91$var$genCardHeadStyle(token),
            [`${componentCls}-extra`]: {
                // https://stackoverflow.com/a/22429853/3040605
                marginInlineStart: "auto",
                color: extraColor,
                fontWeight: "normal",
                fontSize: token.fontSize
            },
            [`${componentCls}-body`]: {
                padding: bodyPadding,
                borderRadius: `0 0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.borderRadiusLG)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.borderRadiusLG)}`,
                "&:first-child": {
                    borderStartStartRadius: token.borderRadiusLG,
                    borderStartEndRadius: token.borderRadiusLG
                },
                "&:not(:last-child)": {
                    borderEndStartRadius: 0,
                    borderEndEndRadius: 0
                }
            },
            [`${componentCls}-grid`]: $258091baf7aaca91$var$genCardGridStyle(token),
            [`${componentCls}-cover`]: {
                "> *": {
                    display: "block",
                    width: "100%",
                    borderRadius: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.borderRadiusLG)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.borderRadiusLG)} 0 0`
                }
            },
            [`${componentCls}-actions`]: $258091baf7aaca91$var$genCardActionsStyle(token),
            [`${componentCls}-meta`]: $258091baf7aaca91$var$genCardMetaStyle(token)
        },
        [`${componentCls}-bordered`]: {
            border: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${colorBorderSecondary}`,
            [`${componentCls}-cover`]: {
                marginTop: -1,
                marginInlineStart: -1,
                marginInlineEnd: -1
            }
        },
        [`${componentCls}-hoverable`]: {
            cursor: "pointer",
            transition: [
                `box-shadow`,
                `border-color`
            ].map((prop)=>`${prop} ${motionDurationMid}`).join(", "),
            "&:hover": {
                borderColor: "transparent",
                boxShadow: cardShadow
            }
        },
        [`${componentCls}-contain-grid`]: {
            borderRadius: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.borderRadiusLG)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.borderRadiusLG)} 0 0 `,
            // Reset border radius when no head exists
            [`&:not(:has(> ${componentCls}-head))`]: {
                borderRadius: 0
            },
            [`${componentCls}-body`]: {
                display: "flex",
                flexWrap: "wrap"
            },
            [`&:not(${componentCls}-loading) ${componentCls}-body`]: {
                marginBlockStart: token.calc(token.lineWidth).mul(-1).equal(),
                marginInlineStart: token.calc(token.lineWidth).mul(-1).equal(),
                padding: 0
            }
        },
        [`${componentCls}-contain-tabs`]: {
            [`> div${componentCls}-head`]: {
                minHeight: 0,
                [`${componentCls}-head-title, ${componentCls}-extra`]: {
                    paddingTop: cardHeadPadding
                }
            }
        },
        [`${componentCls}-type-inner`]: $258091baf7aaca91$var$genCardTypeInnerStyle(token),
        [`${componentCls}-loading`]: $258091baf7aaca91$var$genCardLoadingStyle(token),
        [`${componentCls}-rtl`]: {
            direction: "rtl"
        }
    };
};
// ============================== Size ==============================
const $258091baf7aaca91$var$genCardSizeStyle = (token)=>{
    const { componentCls: componentCls, bodyPaddingSM: bodyPaddingSM, headerPaddingSM: headerPaddingSM, headerHeightSM: headerHeightSM, headerFontSizeSM: headerFontSizeSM } = token;
    return {
        [`${componentCls}-small`]: {
            [`> ${componentCls}-head`]: {
                minHeight: headerHeightSM,
                padding: `0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(headerPaddingSM)}`,
                fontSize: headerFontSizeSM,
                [`> ${componentCls}-head-wrapper`]: {
                    [`> ${componentCls}-extra`]: {
                        fontSize: token.fontSize
                    }
                }
            },
            [`> ${componentCls}-body`]: {
                padding: bodyPaddingSM
            }
        },
        [`${componentCls}-small${componentCls}-contain-tabs`]: {
            [`> ${componentCls}-head`]: {
                [`${componentCls}-head-title, ${componentCls}-extra`]: {
                    paddingTop: 0,
                    display: "flex",
                    alignItems: "center"
                }
            }
        }
    };
};
const $258091baf7aaca91$export$9ca1be8807fe0675 = (token)=>({
        headerBg: "transparent",
        headerFontSize: token.fontSizeLG,
        headerFontSizeSM: token.fontSize,
        headerHeight: token.fontSizeLG * token.lineHeightLG + token.padding * 2,
        headerHeightSM: token.fontSize * token.lineHeight + token.paddingXS * 2,
        actionsBg: token.colorBgContainer,
        actionsLiMargin: `${token.paddingSM}px 0`,
        tabsMarginBottom: -token.padding - token.lineWidth,
        extraColor: token.colorText,
        bodyPaddingSM: 12,
        // Fixed padding.
        headerPaddingSM: 12,
        bodyPadding: token.bodyPadding ?? token.paddingLG,
        headerPadding: token.headerPadding ?? token.paddingLG
    });
var // ============================== Export ==============================
$258091baf7aaca91$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$51ec95de45185b42)("Card", (token)=>{
    const cardToken = (0, $fef50f256b80dfa5$export$4950aa0f605343fb)(token, {
        cardShadow: token.boxShadowCard,
        cardHeadPadding: token.padding,
        cardPaddingBase: token.paddingLG,
        cardActionsIconSize: token.fontSize
    });
    return [
        // Style
        $258091baf7aaca91$var$genCardStyle(cardToken),
        // Size
        $258091baf7aaca91$var$genCardSizeStyle(cardToken)
    ];
}, $258091baf7aaca91$export$9ca1be8807fe0675);


"use client";
const $f18984d72b7be9dc$var$ActionNode = (props)=>{
    const { actionClasses: actionClasses, actions: actions = [], actionStyle: actionStyle } = props;
    return /*#__PURE__*/ $cQmXV.createElement("ul", {
        className: actionClasses,
        style: actionStyle
    }, actions.map((action, index)=>{
        // Move this out since eslint not allow index key
        // And eslint-disable makes conflict with rollup
        // ref https://github.com/ant-design/ant-design/issues/46022
        const key = `action-${index}`;
        return /*#__PURE__*/ $cQmXV.createElement("li", {
            style: {
                width: `${100 / actions.length}%`
            },
            key: key
        }, /*#__PURE__*/ $cQmXV.createElement("span", null, action));
    }));
};
const $f18984d72b7be9dc$var$Card = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, style: style, extra: extra, headStyle: headStyle = {}, bodyStyle: bodyStyle = {}, title: title, loading: loading, bordered: bordered, variant: customVariant, size: customizeSize, type: type, cover: cover, actions: actions, tabList: tabList, children: children, activeTabKey: activeTabKey, defaultActiveTabKey: defaultActiveTabKey, tabBarExtraContent: tabBarExtraContent, hoverable: hoverable, tabProps: tabProps = {}, classNames: classNames, styles: styles, ...rest } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("card");
    const [variant] = (0, $11c15dfa3883fb6f$export$2e2bcd8739ae039)("card", customVariant, bordered);
    const mergedSize = (0, $78cdfb6138721329$export$2e2bcd8739ae039)(customizeSize);
    // =========== Merged Props for Semantic ==========
    const mergedProps = {
        ...props,
        size: mergedSize,
        variant: variant
    };
    const contextStyleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $30c5f9f911d4f61b$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: mergedProps
    });
    var deprecatedName, newName;
    const onTabChange = (key)=>{
        props.onTabChange?.(key);
    };
    const childNodes = $cQmXV.useMemo(()=>(0, $cd966a313e0a92ff$export$2e2bcd8739ae039)(children), [
        children
    ]);
    const isContainGrid = $cQmXV.useMemo(()=>childNodes.some((child)=>/*#__PURE__*/ $cQmXV.isValidElement(child) && child.type === (0, $9d7b5a20ce6db5e4$export$2e2bcd8739ae039)), [
        childNodes
    ]);
    const prefixCls = getPrefixCls("card", customizePrefixCls);
    const [hashId, cssVarCls] = (0, $258091baf7aaca91$export$2e2bcd8739ae039)(prefixCls);
    const loadingBlock = /*#__PURE__*/ $cQmXV.createElement((0, $e855c7114b2916ed$export$2e2bcd8739ae039), {
        loading: true,
        active: true,
        paragraph: {
            rows: 4
        },
        title: false
    }, children);
    const hasActiveTabKey = activeTabKey !== undefined;
    const extraProps = {
        ...tabProps,
        [hasActiveTabKey ? "activeKey" : "defaultActiveKey"]: hasActiveTabKey ? activeTabKey : defaultActiveTabKey,
        tabBarExtraContent: tabBarExtraContent
    };
    let head;
    const tabSize = mergedSize !== "small" ? "large" : mergedSize;
    const tabs = tabList ? /*#__PURE__*/ $cQmXV.createElement((0, $cf7a430748488e77$export$2e2bcd8739ae039), {
        size: tabSize,
        ...extraProps,
        className: `${prefixCls}-head-tabs`,
        onChange: onTabChange,
        items: tabList.map(({ tab: tab, ...item })=>({
                label: tab,
                ...item
            }))
    }) : null;
    if (title || extra || tabs) {
        const headClasses = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-head`, mergedClassNames.header);
        const titleClasses = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-head-title`, mergedClassNames.title);
        const extraClasses = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-extra`, mergedClassNames.extra);
        const mergedHeadStyle = {
            ...headStyle,
            ...mergedStyles.header
        };
        head = /*#__PURE__*/ $cQmXV.createElement("div", {
            className: headClasses,
            style: mergedHeadStyle
        }, /*#__PURE__*/ $cQmXV.createElement("div", {
            className: `${prefixCls}-head-wrapper`
        }, title && /*#__PURE__*/ $cQmXV.createElement("div", {
            className: titleClasses,
            style: mergedStyles.title
        }, title), extra && /*#__PURE__*/ $cQmXV.createElement("div", {
            className: extraClasses,
            style: mergedStyles.extra
        }, extra)), tabs);
    }
    const coverClasses = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-cover`, mergedClassNames.cover);
    const coverDom = cover ? /*#__PURE__*/ $cQmXV.createElement("div", {
        className: coverClasses,
        style: mergedStyles.cover
    }, cover) : null;
    const bodyClasses = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-body`, mergedClassNames.body);
    const mergedBodyStyle = {
        ...bodyStyle,
        ...mergedStyles.body
    };
    const body = loading || childNodes.length ? /*#__PURE__*/ $cQmXV.createElement("div", {
        className: bodyClasses,
        style: mergedBodyStyle
    }, loading ? loadingBlock : children) : null;
    const actionClasses = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-actions`, mergedClassNames.actions);
    const actionDom = actions?.length ? /*#__PURE__*/ $cQmXV.createElement($f18984d72b7be9dc$var$ActionNode, {
        actionClasses: actionClasses,
        actionStyle: mergedStyles.actions,
        actions: actions
    }) : null;
    const divProps = (0, $e8c5093aebad6025$export$2e2bcd8739ae039)(rest, [
        "onTabChange"
    ]);
    const classString = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, contextClassName, {
        [`${prefixCls}-loading`]: loading,
        [`${prefixCls}-bordered`]: variant !== "borderless",
        [`${prefixCls}-hoverable`]: hoverable,
        [`${prefixCls}-contain-grid`]: isContainGrid,
        [`${prefixCls}-contain-tabs`]: tabList?.length,
        [`${prefixCls}-small`]: mergedSize === "small",
        [`${prefixCls}-type-${type}`]: !!type,
        [`${prefixCls}-rtl`]: direction === "rtl"
    }, className, rootClassName, hashId, cssVarCls, mergedClassNames.root);
    const mergedStyle = {
        ...mergedStyles.root
    };
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        ref: ref,
        ...divProps,
        className: classString,
        style: mergedStyle
    }, head, coverDom, body, actionDom);
});
var $f18984d72b7be9dc$export$2e2bcd8739ae039 = $f18984d72b7be9dc$var$Card;




var $cQmXV = parcelRequire("cQmXV");



"use client";
const $819636142b5d33c2$var$CardMeta = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, className: className, avatar: avatar, title: title, description: description, style: style, classNames: cardMetaClassNames, styles: styles, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("cardMeta");
    const prefixCls = getPrefixCls("card", customizePrefixCls);
    const metaPrefixCls = `${prefixCls}-meta`;
    const contextStyleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $30c5f9f911d4f61b$export$648566b068f28737)([
        contextClassNames,
        cardMetaClassNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: props
    });
    const rootClassNames = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(metaPrefixCls, className, contextClassName, mergedClassNames.root);
    const rootStyles = {
        ...mergedStyles.root
    };
    const avatarClassNames = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${metaPrefixCls}-avatar`, mergedClassNames.avatar);
    const titleClassNames = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${metaPrefixCls}-title`, mergedClassNames.title);
    const descriptionClassNames = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${metaPrefixCls}-description`, mergedClassNames.description);
    const sectionClassNames = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${metaPrefixCls}-section`, mergedClassNames.section);
    const avatarDom = avatar ? /*#__PURE__*/ $cQmXV.createElement("div", {
        className: avatarClassNames,
        style: mergedStyles.avatar
    }, avatar) : null;
    const titleDom = title ? /*#__PURE__*/ $cQmXV.createElement("div", {
        className: titleClassNames,
        style: mergedStyles.title
    }, title) : null;
    const descriptionDom = description ? /*#__PURE__*/ $cQmXV.createElement("div", {
        className: descriptionClassNames,
        style: mergedStyles.description
    }, description) : null;
    const MetaDetail = titleDom || descriptionDom ? /*#__PURE__*/ $cQmXV.createElement("div", {
        className: sectionClassNames,
        style: mergedStyles.section
    }, titleDom, descriptionDom) : null;
    const nativeElementRef = $cQmXV.useRef(null);
    $cQmXV.useImperativeHandle(ref, ()=>({
            nativeElement: nativeElementRef.current
        }));
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        ref: nativeElementRef,
        ...restProps,
        className: rootClassNames,
        style: rootStyles
    }, avatarDom, MetaDetail);
});
var $819636142b5d33c2$export$2e2bcd8739ae039 = $819636142b5d33c2$var$CardMeta;


"use client";
const $b4fda840b736e640$var$Card = (0, $f18984d72b7be9dc$export$2e2bcd8739ae039);
$b4fda840b736e640$var$Card.Grid = (0, $9d7b5a20ce6db5e4$export$2e2bcd8739ae039);
$b4fda840b736e640$var$Card.Meta = (0, $819636142b5d33c2$export$2e2bcd8739ae039);
var $b4fda840b736e640$export$2e2bcd8739ae039 = $b4fda840b736e640$var$Card;


"use client";
var $db6c3adada49524e$export$2e2bcd8739ae039 = (0, $fd356af97d0ed2ba$export$2e2bcd8739ae039);


"use client";
var $cde227eb983ae1d2$export$2e2bcd8739ae039 = (0, $fb529cf764bdab11$export$2e2bcd8739ae039);


var $cQmXV = parcelRequire("cQmXV");
const $9848d298b42e15e6$export$e1053575ddfcb301 = {};
const $9848d298b42e15e6$export$91b75cf262680225 = "rc-table-internal-hook";




var $cQmXV = parcelRequire("cQmXV");

var $3h5eW = parcelRequire("3h5eW");
function $1100d1e67da77ebd$export$fd42f52fd3ae1109(defaultValue) {
    const Context = /*#__PURE__*/ $cQmXV.createContext(undefined);
    const Provider = ({ value: value, children: children })=>{
        const valueRef = $cQmXV.useRef(value);
        valueRef.current = value;
        const [context] = $cQmXV.useState(()=>({
                getValue: ()=>valueRef.current,
                listeners: new Set()
            }));
        (0, $7673d874dab69d07$export$2e2bcd8739ae039)(()=>{
            (0, $3h5eW.unstable_batchedUpdates)(()=>{
                context.listeners.forEach((listener)=>{
                    listener(value);
                });
            });
        }, [
            value
        ]);
        return /*#__PURE__*/ $cQmXV.createElement(Context.Provider, {
            value: context
        }, children);
    };
    return {
        Context: Context,
        Provider: Provider,
        defaultValue: defaultValue
    };
}
function $1100d1e67da77ebd$export$fae74005e78b1a27(holder, selector) {
    const eventSelector = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)(typeof selector === "function" ? selector : (ctx)=>{
        if (selector === undefined) return ctx;
        if (!Array.isArray(selector)) return ctx[selector];
        const obj = {};
        selector.forEach((key)=>{
            obj[key] = ctx[key];
        });
        return obj;
    });
    const context = $cQmXV.useContext(holder?.Context);
    const { listeners: listeners, getValue: getValue } = context || {};
    const valueRef = $cQmXV.useRef();
    valueRef.current = eventSelector(context ? getValue() : holder?.defaultValue);
    const [, forceUpdate] = $cQmXV.useState({});
    (0, $7673d874dab69d07$export$2e2bcd8739ae039)(()=>{
        if (!context) return;
        function trigger(nextValue) {
            const nextSelectorValue = eventSelector(nextValue);
            if (!(0, $3f19ee2a2ff4618a$export$2e2bcd8739ae039)(valueRef.current, nextSelectorValue, true)) forceUpdate({});
        }
        listeners.add(trigger);
        return ()=>{
            listeners.delete(trigger);
        };
    }, [
        context
    ]);
    return valueRef.current;
}




var $cQmXV = parcelRequire("cQmXV");
function $6c7b30f3cc2df9d9$var$_extends() {
    $6c7b30f3cc2df9d9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6c7b30f3cc2df9d9$var$_extends.apply(this, arguments);
}
function $6c7b30f3cc2df9d9$export$2e2bcd8739ae039() {
    const ImmutableContext = /*#__PURE__*/ $cQmXV.createContext(null);
    /**
   * Get render update mark by `makeImmutable` root.
   * Do not deps on the return value as render times
   * but only use for `useMemo` or `useCallback` deps.
   */ function useImmutableMark() {
        return $cQmXV.useContext(ImmutableContext);
    }
    /**
  * Wrapped Component will be marked as Immutable.
  * When Component parent trigger render,
  * it will notice children component (use with `responseImmutable`) node that parent has updated.
  * @param Component Passed Component
  * @param triggerRender Customize trigger `responseImmutable` children re-render logic. Default will always trigger re-render when this component re-render.
  */ function makeImmutable(Component, shouldTriggerRender) {
        const refAble = (0, $10341b937b26f69d$export$c1cec34af06bcf7)(Component);
        const ImmutableComponent = (props, ref)=>{
            const refProps = refAble ? {
                ref: ref
            } : {};
            const renderTimesRef = $cQmXV.useRef(0);
            const prevProps = $cQmXV.useRef(props);
            // If parent has the context, we do not wrap it
            const mark = useImmutableMark();
            if (mark !== null) return /*#__PURE__*/ $cQmXV.createElement(Component, $6c7b30f3cc2df9d9$var$_extends({}, props, refProps));
            if (// Always trigger re-render if `shouldTriggerRender` is not provided
            !shouldTriggerRender || shouldTriggerRender(prevProps.current, props)) renderTimesRef.current += 1;
            prevProps.current = props;
            return /*#__PURE__*/ $cQmXV.createElement(ImmutableContext.Provider, {
                value: renderTimesRef.current
            }, /*#__PURE__*/ $cQmXV.createElement(Component, $6c7b30f3cc2df9d9$var$_extends({}, props, refProps)));
        };
        return refAble ? /*#__PURE__*/ $cQmXV.forwardRef(ImmutableComponent) : ImmutableComponent;
    }
    /**
   * Wrapped Component with `React.memo`.
   * But will rerender when parent with `makeImmutable` rerender.
   */ function responseImmutable(Component, propsAreEqual) {
        const refAble = (0, $10341b937b26f69d$export$c1cec34af06bcf7)(Component);
        const ImmutableComponent = (props, ref)=>{
            const refProps = refAble ? {
                ref: ref
            } : {};
            useImmutableMark();
            return /*#__PURE__*/ $cQmXV.createElement(Component, $6c7b30f3cc2df9d9$var$_extends({}, props, refProps));
        };
        return /*#__PURE__*/ $cQmXV.memo(refAble ? /*#__PURE__*/ $cQmXV.forwardRef(ImmutableComponent) : ImmutableComponent, propsAreEqual);
    }
    return {
        makeImmutable: makeImmutable,
        responseImmutable: responseImmutable,
        useImmutableMark: useImmutableMark
    };
}


// For legacy usage, we export it directly
const { makeImmutable: $ff93043188aa923f$export$ffd6d5bef5eaf0a4, responseImmutable: $ff93043188aa923f$export$e9e4cb9eb9e2b4c4, useImmutableMark: $ff93043188aa923f$export$c5d829a463bd3201 } = (0, $6c7b30f3cc2df9d9$export$2e2bcd8739ae039)();



var $cQmXV = parcelRequire("cQmXV");

const { makeImmutable: $8ff93ffc4f10aaf4$export$ffd6d5bef5eaf0a4, responseImmutable: $8ff93ffc4f10aaf4$export$e9e4cb9eb9e2b4c4, useImmutableMark: $8ff93ffc4f10aaf4$export$c5d829a463bd3201 } = (0, $6c7b30f3cc2df9d9$export$2e2bcd8739ae039)();
const $8ff93ffc4f10aaf4$var$TableContext = (0, $1100d1e67da77ebd$export$fd42f52fd3ae1109)();
var $8ff93ffc4f10aaf4$export$2e2bcd8739ae039 = $8ff93ffc4f10aaf4$var$TableContext;


/* istanbul ignore file */ 
var $cQmXV = parcelRequire("cQmXV");
function $c818c4d40967abe4$var$useRenderTimes(props, debug) {
    // Render times
    const timesRef = $cQmXV.useRef(0);
    timesRef.current += 1;
    // Props changed
    const propsRef = $cQmXV.useRef(props);
    const keys = [];
    Object.keys(props || {}).map((key)=>{
        if (props?.[key] !== propsRef.current?.[key]) keys.push(key);
    });
    propsRef.current = props;
    // Cache keys since React rerender may cause it lost
    const keysRef = $cQmXV.useRef([]);
    if (keys.length) keysRef.current = keys;
    $cQmXV.useDebugValue(timesRef.current);
    $cQmXV.useDebugValue(keysRef.current.join(", "));
    if (debug) console.log(`${debug}:`, timesRef.current, keysRef.current);
    return timesRef.current;
}
var $c818c4d40967abe4$export$2e2bcd8739ae039 = ()=>{};
const $c818c4d40967abe4$export$e57c788cafefed4f = /*#__PURE__*/ $cQmXV.memo(()=>{
    const times = $c818c4d40967abe4$var$useRenderTimes();
    return /*#__PURE__*/ $cQmXV.createElement("h1", null, "Render Times: ", times);
});



var $cQmXV = parcelRequire("cQmXV");



var $cQmXV = parcelRequire("cQmXV");




var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");
// TODO: Remove when use `responsiveImmutable`
const $91976f4a74d60508$var$PerfContext = /*#__PURE__*/ $cQmXV.createContext({
    renderWithProps: false
});
var $91976f4a74d60508$export$2e2bcd8739ae039 = $91976f4a74d60508$var$PerfContext;


const $435e6e552a98f20a$var$INTERNAL_KEY_PREFIX = "RC_TABLE_KEY";
function $435e6e552a98f20a$var$toArray(arr) {
    if (arr === undefined || arr === null) return [];
    return Array.isArray(arr) ? arr : [
        arr
    ];
}
function $435e6e552a98f20a$export$fd2ca5407d9be470(columns) {
    const columnKeys = [];
    const keys = {};
    columns.forEach((column)=>{
        const { key: key, dataIndex: dataIndex } = column || {};
        let mergedKey = key || $435e6e552a98f20a$var$toArray(dataIndex).join("-") || $435e6e552a98f20a$var$INTERNAL_KEY_PREFIX;
        while(keys[mergedKey])mergedKey = `${mergedKey}_next`;
        keys[mergedKey] = true;
        columnKeys.push(mergedKey);
    });
    return columnKeys;
}
function $435e6e552a98f20a$export$b76e9316566cc26e(val) {
    return val !== null && val !== undefined;
}
function $435e6e552a98f20a$export$b1cd2bdabe361feb(value) {
    return typeof value === "number" && !Number.isNaN(value);
}



function $2f89ec430f1be7fa$var$isRenderCell(data) {
    return data && typeof data === "object" && !Array.isArray(data) && !/*#__PURE__*/ $cQmXV.isValidElement(data);
}
function $2f89ec430f1be7fa$export$2e2bcd8739ae039(record, dataIndex, renderIndex, children, render, shouldCellUpdate) {
    // TODO: Remove this after next major version
    const perfRecord = $cQmXV.useContext((0, $91976f4a74d60508$export$2e2bcd8739ae039));
    const mark = (0, $8ff93ffc4f10aaf4$export$c5d829a463bd3201)();
    // ======================== Render ========================
    const retData = (0, $d627c2941353b4cb$export$2e2bcd8739ae039)(()=>{
        if ((0, $435e6e552a98f20a$export$b76e9316566cc26e)(children)) return [
            children
        ];
        const path = dataIndex === null || dataIndex === undefined || dataIndex === "" ? [] : Array.isArray(dataIndex) ? dataIndex : [
            dataIndex
        ];
        const value = (0, $bb62aae17cbc8bd7$export$2e2bcd8739ae039)(record, path);
        // Customize render node
        let returnChildNode = value;
        let returnCellProps = undefined;
        if (render) {
            const renderData = render(value, record, renderIndex);
            if ($2f89ec430f1be7fa$var$isRenderCell(renderData)) {
                returnChildNode = renderData.children;
                returnCellProps = renderData.props;
                perfRecord.renderWithProps = true;
            } else returnChildNode = renderData;
        }
        return [
            returnChildNode,
            returnCellProps
        ];
    }, [
        // Force update deps
        mark,
        // Normal deps
        record,
        children,
        dataIndex,
        render,
        renderIndex
    ], (prev, next)=>{
        if (shouldCellUpdate) {
            const [, prevRecord] = prev;
            const [, nextRecord] = next;
            return shouldCellUpdate(nextRecord, prevRecord);
        }
        // Legacy mode should always update
        if (perfRecord.renderWithProps) return true;
        return !(0, $3f19ee2a2ff4618a$export$2e2bcd8739ae039)(prev, next, true);
    });
    return retData;
}




/** Check if cell is in hover range */ function $4383ff8d39647875$var$inHoverRange(cellStartRow, cellRowSpan, startRow, endRow) {
    const cellEndRow = cellStartRow + cellRowSpan - 1;
    return cellStartRow <= endRow && cellEndRow >= startRow;
}
function $4383ff8d39647875$export$2e2bcd8739ae039(rowIndex, rowSpan) {
    return (0, $1100d1e67da77ebd$export$fae74005e78b1a27)((0, $8ff93ffc4f10aaf4$export$2e2bcd8739ae039), (ctx)=>{
        const hovering = $4383ff8d39647875$var$inHoverRange(rowIndex, rowSpan || 1, ctx.hoverStartRow, ctx.hoverEndRow);
        return [
            hovering,
            ctx.onHover
        ];
    });
}



function $c5712ffce408ad73$var$_extends() {
    $c5712ffce408ad73$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c5712ffce408ad73$var$_extends.apply(this, arguments);
}
const $c5712ffce408ad73$var$getTitleFromCellRenderChildren = ({ ellipsis: ellipsis, rowType: rowType, children: children })=>{
    let title;
    const ellipsisConfig = ellipsis === true ? {
        showTitle: true
    } : ellipsis;
    if (ellipsisConfig && (ellipsisConfig.showTitle || rowType === "header")) {
        if (typeof children === "string" || typeof children === "number") title = children.toString();
        else if (/*#__PURE__*/ $cQmXV.isValidElement(children) && typeof children.props?.children === "string") title = children.props?.children;
    }
    return title;
};
const $c5712ffce408ad73$var$Cell = (props)=>{
    const { component: Component, children: children, ellipsis: ellipsis, scope: scope, prefixCls: // Style
    prefixCls, className: className, style: style, align: align, record: // Value
    record, render: render, dataIndex: dataIndex, renderIndex: renderIndex, shouldCellUpdate: shouldCellUpdate, index: // Row
    index, rowType: rowType, colSpan: // Span
    colSpan, rowSpan: rowSpan, fixStart: // Fixed
    fixStart, fixEnd: fixEnd, fixedStartShadow: fixedStartShadow, fixedEndShadow: fixedEndShadow, offsetFixedStartShadow: offsetFixedStartShadow, offsetFixedEndShadow: offsetFixedEndShadow, zIndex: zIndex, zIndexReverse: zIndexReverse, appendNode: // Private
    appendNode, additionalProps: additionalProps = {}, originRowSpan: originRowSpan, isSticky: isSticky } = props;
    const cellPrefixCls = `${prefixCls}-cell`;
    const { allColumnsFixedLeft: allColumnsFixedLeft, rowHoverable: rowHoverable } = (0, $1100d1e67da77ebd$export$fae74005e78b1a27)((0, $8ff93ffc4f10aaf4$export$2e2bcd8739ae039), [
        "allColumnsFixedLeft",
        "rowHoverable"
    ]);
    // ====================== Value =======================
    const [childNode, legacyCellProps] = (0, $2f89ec430f1be7fa$export$2e2bcd8739ae039)(record, dataIndex, renderIndex, children, render, shouldCellUpdate);
    // ====================== Fixed =======================
    const fixedStyle = {};
    const isFixStart = typeof fixStart === "number" && !allColumnsFixedLeft;
    const isFixEnd = typeof fixEnd === "number" && !allColumnsFixedLeft;
    const [showFixStartShadow, showFixEndShadow] = (0, $1100d1e67da77ebd$export$fae74005e78b1a27)((0, $8ff93ffc4f10aaf4$export$2e2bcd8739ae039), ({ scrollInfo: scrollInfo })=>{
        if (!isFixStart && !isFixEnd) return [
            false,
            false
        ];
        const [absScroll, scrollWidth] = scrollInfo;
        const showStartShadow = (isFixStart && fixedStartShadow && absScroll) - // For precision, we not show shadow by default which has better user experience.
        offsetFixedStartShadow >= 1;
        const showEndShadow = (isFixEnd && fixedEndShadow && scrollWidth - absScroll) - // Same as above
        offsetFixedEndShadow > 1;
        return [
            showStartShadow,
            showEndShadow
        ];
    });
    if (isFixStart) {
        fixedStyle.insetInlineStart = fixStart;
        fixedStyle["--z-offset"] = zIndex;
        fixedStyle["--z-offset-reverse"] = zIndexReverse;
    }
    if (isFixEnd) {
        fixedStyle.insetInlineEnd = fixEnd;
        fixedStyle["--z-offset"] = zIndex;
        fixedStyle["--z-offset-reverse"] = zIndexReverse;
    }
    // ================ RowSpan & ColSpan =================
    const mergedColSpan = legacyCellProps?.colSpan ?? additionalProps.colSpan ?? colSpan ?? 1;
    const mergedRowSpan = legacyCellProps?.rowSpan ?? additionalProps.rowSpan ?? rowSpan ?? 1;
    const mergedHoverRowSpan = legacyCellProps?.rowSpan ?? originRowSpan ?? mergedRowSpan;
    // ====================== Hover =======================
    const [hovering, onHover] = (0, $4383ff8d39647875$export$2e2bcd8739ae039)(index, mergedHoverRowSpan);
    const onMouseEnter = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((event)=>{
        if (record) onHover(index, index + mergedHoverRowSpan - 1);
        additionalProps?.onMouseEnter?.(event);
    });
    const onMouseLeave = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((event)=>{
        if (record) onHover(-1, -1);
        additionalProps?.onMouseLeave?.(event);
    });
    // ====================== Render ======================
    if (mergedColSpan === 0 || mergedRowSpan === 0) return null;
    // >>>>> Title
    const title = additionalProps.title ?? $c5712ffce408ad73$var$getTitleFromCellRenderChildren({
        rowType: rowType,
        ellipsis: ellipsis,
        children: childNode
    });
    // >>>>> ClassName
    const mergedClassName = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(cellPrefixCls, className, {
        // Fixed
        [`${cellPrefixCls}-fix`]: isFixStart || isFixEnd,
        [`${cellPrefixCls}-fix-start`]: isFixStart,
        [`${cellPrefixCls}-fix-end`]: isFixEnd,
        // Fixed shadow
        [`${cellPrefixCls}-fix-start-shadow`]: fixedStartShadow,
        [`${cellPrefixCls}-fix-start-shadow-show`]: fixedStartShadow && showFixStartShadow,
        [`${cellPrefixCls}-fix-end-shadow`]: fixedEndShadow,
        [`${cellPrefixCls}-fix-end-shadow-show`]: fixedEndShadow && showFixEndShadow,
        [`${cellPrefixCls}-ellipsis`]: ellipsis,
        [`${cellPrefixCls}-with-append`]: appendNode,
        [`${cellPrefixCls}-fix-sticky`]: (isFixStart || isFixEnd) && isSticky,
        [`${cellPrefixCls}-row-hover`]: !legacyCellProps && hovering
    }, additionalProps.className, legacyCellProps?.className);
    // >>>>> Style
    const alignStyle = {};
    if (align) alignStyle.textAlign = align;
    // The order is important since user can overwrite style.
    // For example ant-design/ant-design#51763
    const mergedStyle = {
        ...legacyCellProps?.style,
        ...fixedStyle,
        ...alignStyle,
        ...additionalProps.style,
        ...style
    };
    // >>>>> Children Node
    let mergedChildNode = childNode;
    // Not crash if final `childNode` is not validate ReactNode
    if (typeof mergedChildNode === "object" && !Array.isArray(mergedChildNode) && !/*#__PURE__*/ $cQmXV.isValidElement(mergedChildNode)) mergedChildNode = null;
    if (ellipsis && (fixedStartShadow || fixedEndShadow)) mergedChildNode = /*#__PURE__*/ $cQmXV.createElement("span", {
        className: `${cellPrefixCls}-content`
    }, mergedChildNode);
    return /*#__PURE__*/ $cQmXV.createElement(Component, $c5712ffce408ad73$var$_extends({}, legacyCellProps, additionalProps, {
        className: mergedClassName,
        style: mergedStyle,
        title: title,
        scope: scope,
        onMouseEnter: rowHoverable ? onMouseEnter : undefined,
        onMouseLeave: rowHoverable ? onMouseLeave : undefined,
        colSpan: mergedColSpan !== 1 ? mergedColSpan : null,
        rowSpan: mergedRowSpan !== 1 ? mergedRowSpan : null
    }), appendNode, mergedChildNode);
};
var $c5712ffce408ad73$export$2e2bcd8739ae039 = /*#__PURE__*/ $cQmXV.memo($c5712ffce408ad73$var$Cell);




function $a021d55cd4d0d0b9$var$isFixedStart(column) {
    return column.fixed === "start";
}
function $a021d55cd4d0d0b9$var$isFixedEnd(column) {
    return column.fixed === "end";
}
function $a021d55cd4d0d0b9$export$695db918331141f3(colStart, colEnd, columns, stickyOffsets) {
    const startColumn = columns[colStart] || {};
    const endColumn = columns[colEnd] || {};
    let fixStart = null;
    let fixEnd = null;
    if ($a021d55cd4d0d0b9$var$isFixedStart(startColumn) && $a021d55cd4d0d0b9$var$isFixedStart(endColumn)) fixStart = stickyOffsets.start[colStart];
    else if ($a021d55cd4d0d0b9$var$isFixedEnd(endColumn) && $a021d55cd4d0d0b9$var$isFixedEnd(startColumn)) fixEnd = stickyOffsets.end[colEnd];
    // check if need to add shadow
    let fixedStartShadow = false;
    let fixedEndShadow = false;
    // Calc `zIndex`.
    // first fixed start (start -> end) column `zIndex` should be greater than next column.
    // first fixed end (end -> start) column `zIndex` should be greater than next column.
    let zIndex = 0;
    let zIndexReverse = 0;
    if (fixStart !== null) {
        fixedStartShadow = !columns[colEnd + 1] || !$a021d55cd4d0d0b9$var$isFixedStart(columns[colEnd + 1]);
        zIndex = columns.length * 2 - colStart; // Fix start always overlay fix end
        zIndexReverse = columns.length + colStart;
    }
    if (fixEnd !== null) {
        fixedEndShadow = !columns[colStart - 1] || !$a021d55cd4d0d0b9$var$isFixedEnd(columns[colStart - 1]);
        zIndex = colEnd;
        zIndexReverse = columns.length - colEnd; // Fix end always overlay fix start
    }
    // Check if scrollLeft will show the shadow
    let offsetFixedStartShadow = 0;
    let offsetFixedEndShadow = 0;
    if (fixedStartShadow) {
        for(let i = 0; i < colStart; i += 1)if (!$a021d55cd4d0d0b9$var$isFixedStart(columns[i])) offsetFixedStartShadow += stickyOffsets.widths[i] || 0;
    }
    if (fixedEndShadow) {
        for(let i = columns.length - 1; i > colEnd; i -= 1)if (!$a021d55cd4d0d0b9$var$isFixedEnd(columns[i])) offsetFixedEndShadow += stickyOffsets.widths[i] || 0;
    }
    return {
        fixStart: fixStart,
        fixEnd: fixEnd,
        fixedStartShadow: fixedStartShadow,
        fixedEndShadow: fixedEndShadow,
        offsetFixedStartShadow: offsetFixedStartShadow,
        offsetFixedEndShadow: offsetFixedEndShadow,
        isSticky: stickyOffsets.isSticky,
        zIndex: zIndex,
        zIndexReverse: zIndexReverse
    };
}



var $cQmXV = parcelRequire("cQmXV");
const $195eb1a2b89bf5d8$var$SummaryContext = /*#__PURE__*/ $cQmXV.createContext({});
var $195eb1a2b89bf5d8$export$2e2bcd8739ae039 = $195eb1a2b89bf5d8$var$SummaryContext;


function $7b83e1623406a4e8$var$_extends() {
    $7b83e1623406a4e8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7b83e1623406a4e8$var$_extends.apply(this, arguments);
}
const $7b83e1623406a4e8$var$SummaryCell = (props)=>{
    const { className: className, index: index, children: children, colSpan: colSpan = 1, rowSpan: rowSpan, align: align } = props;
    const { prefixCls: prefixCls } = (0, $1100d1e67da77ebd$export$fae74005e78b1a27)((0, $8ff93ffc4f10aaf4$export$2e2bcd8739ae039), [
        "prefixCls"
    ]);
    const { scrollColumnIndex: scrollColumnIndex, stickyOffsets: stickyOffsets, flattenColumns: flattenColumns } = $cQmXV.useContext((0, $195eb1a2b89bf5d8$export$2e2bcd8739ae039));
    const lastIndex = index + colSpan - 1;
    const mergedColSpan = lastIndex + 1 === scrollColumnIndex ? colSpan + 1 : colSpan;
    const fixedInfo = $cQmXV.useMemo(()=>(0, $a021d55cd4d0d0b9$export$695db918331141f3)(index, index + mergedColSpan - 1, flattenColumns, stickyOffsets), [
        index,
        mergedColSpan,
        flattenColumns,
        stickyOffsets
    ]);
    return /*#__PURE__*/ $cQmXV.createElement((0, $c5712ffce408ad73$export$2e2bcd8739ae039), $7b83e1623406a4e8$var$_extends({
        className: className,
        index: index,
        component: "td",
        prefixCls: prefixCls,
        record: null,
        dataIndex: null,
        align: align,
        colSpan: mergedColSpan,
        rowSpan: rowSpan,
        render: ()=>children
    }, fixedInfo));
};
var $7b83e1623406a4e8$export$2e2bcd8739ae039 = $7b83e1623406a4e8$var$SummaryCell;



var $cQmXV = parcelRequire("cQmXV");
const $231d80c563418888$var$FooterRow = (props)=>{
    const { children: children, ...restProps } = props;
    return /*#__PURE__*/ $cQmXV.createElement("tr", restProps, children);
};
var $231d80c563418888$export$2e2bcd8739ae039 = $231d80c563418888$var$FooterRow;


/**
 * Syntactic sugar. Do not support HOC.
 */ const $c6cee2d66e4793e6$var$Summary = (props)=>{
    const { children: children } = props;
    return children;
};
$c6cee2d66e4793e6$var$Summary.Row = (0, $231d80c563418888$export$2e2bcd8739ae039);
$c6cee2d66e4793e6$var$Summary.Cell = (0, $7b83e1623406a4e8$export$2e2bcd8739ae039);
var $c6cee2d66e4793e6$export$2e2bcd8739ae039 = $c6cee2d66e4793e6$var$Summary;



const $a9a17de46d12194c$var$Footer = (props)=>{
    const { children: children, stickyOffsets: stickyOffsets, flattenColumns: flattenColumns } = props;
    const prefixCls = (0, $1100d1e67da77ebd$export$fae74005e78b1a27)((0, $8ff93ffc4f10aaf4$export$2e2bcd8739ae039), "prefixCls");
    const lastColumnIndex = flattenColumns.length - 1;
    const scrollColumn = flattenColumns[lastColumnIndex];
    const summaryContext = $cQmXV.useMemo(()=>({
            stickyOffsets: stickyOffsets,
            flattenColumns: flattenColumns,
            scrollColumnIndex: scrollColumn?.scrollbar ? lastColumnIndex : null
        }), [
        scrollColumn,
        flattenColumns,
        lastColumnIndex,
        stickyOffsets
    ]);
    return /*#__PURE__*/ $cQmXV.createElement((0, $195eb1a2b89bf5d8$export$2e2bcd8739ae039).Provider, {
        value: summaryContext
    }, /*#__PURE__*/ $cQmXV.createElement("tfoot", {
        className: `${prefixCls}-summary`
    }, children));
};
var $a9a17de46d12194c$export$2e2bcd8739ae039 = (0, $8ff93ffc4f10aaf4$export$e9e4cb9eb9e2b4c4)($a9a17de46d12194c$var$Footer);
const $a9a17de46d12194c$export$d605f3af09eef683 = (0, $c6cee2d66e4793e6$export$2e2bcd8739ae039);


/* istanbul ignore next */ /**
 * This is a syntactic sugar for `columns` prop.
 * So HOC will not work on this.
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
function $083980fbff62992e$var$Column(_) {
    return null;
}
var $083980fbff62992e$export$2e2bcd8739ae039 = $083980fbff62992e$var$Column;


/* istanbul ignore next */ /**
 * This is a syntactic sugar for `columns` prop.
 * So HOC will not work on this.
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
function $3b02a9334ab90b52$var$ColumnGroup(_) {
    return null;
}
var $3b02a9334ab90b52$export$2e2bcd8739ae039 = $3b02a9334ab90b52$var$ColumnGroup;






var $cQmXV = parcelRequire("cQmXV");


var $cQmXV = parcelRequire("cQmXV");




var $cQmXV = parcelRequire("cQmXV");
// recursion (flat tree structure)
function $c84b77e36f423551$var$fillRecords(list, record, indent, childrenColumnName, expandedKeys, getRowKey, index) {
    const key = getRowKey(record, index);
    list.push({
        record: record,
        indent: indent,
        index: index,
        rowKey: key
    });
    const expanded = expandedKeys?.has(key);
    if (record && Array.isArray(record[childrenColumnName]) && expanded) // expanded state, flat record
    for(let i = 0; i < record[childrenColumnName].length; i += 1)$c84b77e36f423551$var$fillRecords(list, record[childrenColumnName][i], indent + 1, childrenColumnName, expandedKeys, getRowKey, i);
}
function $c84b77e36f423551$export$2e2bcd8739ae039(data, childrenColumnName, expandedKeys, getRowKey) {
    const arr = $cQmXV.useMemo(()=>{
        if (expandedKeys?.size) {
            const list = [];
            // collect flattened record
            for(let i = 0; i < data?.length; i += 1){
                const record = data[i];
                // using array.push or spread operator may cause "Maximum call stack size exceeded" exception if array size is big enough.
                $c84b77e36f423551$var$fillRecords(list, record, 0, childrenColumnName, expandedKeys, getRowKey, i);
            }
            return list;
        }
        return data?.map((item, index)=>{
            return {
                record: item,
                indent: 0,
                index: index,
                rowKey: getRowKey(item, index)
            };
        });
    }, [
        data,
        childrenColumnName,
        expandedKeys,
        getRowKey
    ]);
    return arr;
}






var $cQmXV = parcelRequire("cQmXV");








function $9708cd947c7f3f82$export$2e2bcd8739ae039(record, rowKey, recordIndex, indent) {
    const context = (0, $1100d1e67da77ebd$export$fae74005e78b1a27)((0, $8ff93ffc4f10aaf4$export$2e2bcd8739ae039), [
        "prefixCls",
        "fixedInfoList",
        "flattenColumns",
        "expandableType",
        "expandRowByClick",
        "onTriggerExpand",
        "rowClassName",
        "expandedRowClassName",
        "indentSize",
        "expandIcon",
        "expandedRowRender",
        "forceRender",
        "expandIconColumnIndex",
        "expandedKeys",
        "childrenColumnName",
        "rowExpandable",
        "onRow"
    ]);
    const { flattenColumns: flattenColumns, expandableType: expandableType, expandedKeys: expandedKeys, childrenColumnName: childrenColumnName, onTriggerExpand: onTriggerExpand, rowExpandable: rowExpandable, onRow: onRow, expandRowByClick: expandRowByClick, rowClassName: rowClassName } = context;
    // ======================= Expandable =======================
    // Only when row is not expandable and `children` exist in record
    const nestExpandable = expandableType === "nest";
    const rowSupportExpand = expandableType === "row" && (!rowExpandable || rowExpandable(record));
    const mergedExpandable = rowSupportExpand || nestExpandable;
    const expanded = expandedKeys && expandedKeys.has(rowKey);
    const hasNestChildren = childrenColumnName && record && record[childrenColumnName];
    const onInternalTriggerExpand = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)(onTriggerExpand);
    // ========================= onRow ==========================
    const rowProps = onRow?.(record, recordIndex);
    const onRowClick = rowProps?.onClick;
    const onClick = (event, ...args)=>{
        if (expandRowByClick && mergedExpandable) onTriggerExpand(record, event);
        onRowClick?.(event, ...args);
    };
    // ====================== RowClassName ======================
    let computeRowClassName;
    if (typeof rowClassName === "string") computeRowClassName = rowClassName;
    else if (typeof rowClassName === "function") computeRowClassName = rowClassName(record, recordIndex, indent);
    // ========================= Column =========================
    const columnsKey = (0, $435e6e552a98f20a$export$fd2ca5407d9be470)(flattenColumns);
    return {
        ...context,
        columnsKey: columnsKey,
        nestExpandable: nestExpandable,
        expanded: expanded,
        hasNestChildren: hasNestChildren,
        record: record,
        onTriggerExpand: onInternalTriggerExpand,
        rowSupportExpand: rowSupportExpand,
        expandable: mergedExpandable,
        rowProps: {
            ...rowProps,
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(computeRowClassName, rowProps?.className),
            onClick: onClick
        }
    };
}




var $cQmXV = parcelRequire("cQmXV");



const $beabb922f5c31eba$var$ExpandedRow = (props)=>{
    const { prefixCls: prefixCls, children: children, component: Component, cellComponent: cellComponent, className: className, expanded: expanded, colSpan: colSpan, isEmpty: isEmpty, stickyOffset: stickyOffset = 0 } = props;
    const { scrollbarSize: scrollbarSize, fixHeader: fixHeader, fixColumn: fixColumn, componentWidth: componentWidth, horizonScroll: horizonScroll } = (0, $1100d1e67da77ebd$export$fae74005e78b1a27)((0, $8ff93ffc4f10aaf4$export$2e2bcd8739ae039), [
        "scrollbarSize",
        "fixHeader",
        "fixColumn",
        "componentWidth",
        "horizonScroll"
    ]);
    // Cache render node
    let contentNode = children;
    if (isEmpty ? horizonScroll && componentWidth : fixColumn) contentNode = /*#__PURE__*/ $cQmXV.createElement("div", {
        style: {
            width: componentWidth - stickyOffset - (fixHeader && !isEmpty ? scrollbarSize : 0),
            position: "sticky",
            left: stickyOffset,
            overflow: "hidden"
        },
        className: `${prefixCls}-expanded-row-fixed`
    }, contentNode);
    return /*#__PURE__*/ $cQmXV.createElement(Component, {
        className: className,
        style: {
            display: expanded ? null : "none"
        }
    }, /*#__PURE__*/ $cQmXV.createElement((0, $c5712ffce408ad73$export$2e2bcd8739ae039), {
        component: cellComponent,
        prefixCls: prefixCls,
        colSpan: colSpan
    }, contentNode));
};
var $beabb922f5c31eba$export$2e2bcd8739ae039 = $beabb922f5c31eba$var$ExpandedRow;



var $cQmXV = parcelRequire("cQmXV");

function $4241324b3d4de179$export$ae14373a7f810e33({ prefixCls: prefixCls, record: record, onExpand: onExpand, expanded: expanded, expandable: expandable }) {
    const expandClassName = `${prefixCls}-row-expand-icon`;
    if (!expandable) return /*#__PURE__*/ $cQmXV.createElement("span", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(expandClassName, `${prefixCls}-row-spaced`)
    });
    const onClick = (event)=>{
        onExpand(record, event);
        event.stopPropagation();
    };
    return /*#__PURE__*/ $cQmXV.createElement("span", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(expandClassName, {
            [`${prefixCls}-row-expanded`]: expanded,
            [`${prefixCls}-row-collapsed`]: !expanded
        }),
        onClick: onClick
    });
}
function $4241324b3d4de179$export$49bec56f6055f375(data, getRowKey, childrenColumnName) {
    const keys = [];
    function dig(list) {
        (list || []).forEach((item, index)=>{
            keys.push(getRowKey(item, index));
            dig(item[childrenColumnName]);
        });
    }
    dig(data);
    return keys;
}
function $4241324b3d4de179$export$c5c465afb98f57b6(cls, record, index, indent) {
    if (typeof cls === "string") return cls;
    if (typeof cls === "function") return cls(record, index, indent);
    return "";
}


function $49da4ac3f43ec6a8$var$_extends() {
    $49da4ac3f43ec6a8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $49da4ac3f43ec6a8$var$_extends.apply(this, arguments);
}
function $49da4ac3f43ec6a8$export$16400ac709c56616(rowInfo, column, colIndex, indent, index, rowKeys = [], expandedRowOffset = 0) {
    const { record: record, prefixCls: prefixCls, columnsKey: columnsKey, fixedInfoList: fixedInfoList, expandIconColumnIndex: expandIconColumnIndex, nestExpandable: nestExpandable, indentSize: indentSize, expandIcon: expandIcon, expanded: expanded, hasNestChildren: hasNestChildren, onTriggerExpand: onTriggerExpand, expandable: expandable, expandedKeys: expandedKeys } = rowInfo;
    const key = columnsKey[colIndex];
    const fixedInfo = fixedInfoList[colIndex];
    // ============= Used for nest expandable =============
    let appendCellNode;
    if (colIndex === (expandIconColumnIndex || 0) && nestExpandable) appendCellNode = /*#__PURE__*/ $cQmXV.createElement($cQmXV.Fragment, null, /*#__PURE__*/ $cQmXV.createElement("span", {
        style: {
            paddingLeft: `${indentSize * indent}px`
        },
        className: `${prefixCls}-row-indent indent-level-${indent}`
    }), expandIcon({
        prefixCls: prefixCls,
        expanded: expanded,
        expandable: hasNestChildren,
        record: record,
        onExpand: onTriggerExpand
    }));
    const additionalCellProps = {
        ...column.onCell?.(record, index)
    };
    let originRowSpan;
    // Expandable row has offset
    if (expandedRowOffset) {
        const { rowSpan: rowSpan = 1 } = additionalCellProps;
        // For expandable row with rowSpan,
        // We should increase the rowSpan if the row is expanded
        if (expandable && rowSpan && colIndex < expandedRowOffset) {
            originRowSpan = rowSpan;
            let currentRowSpan = rowSpan;
            for(let i = index; i < index + rowSpan; i += 1){
                const rowKey = rowKeys[i];
                if (expandedKeys.has(rowKey)) currentRowSpan += 1;
            }
            additionalCellProps.rowSpan = currentRowSpan;
        }
    }
    return {
        key: key,
        fixedInfo: fixedInfo,
        appendCellNode: appendCellNode,
        additionalCellProps: additionalCellProps,
        originRowSpan: originRowSpan
    };
}
// ==================================================================================
// ==                                 getCellProps                                 ==
// ==================================================================================
const $49da4ac3f43ec6a8$var$BodyRow = (props)=>{
    const { className: className, style: style, classNames: classNames, styles: styles, record: record, index: index, renderIndex: renderIndex, rowKey: rowKey, rowKeys: rowKeys, indent: indent = 0, rowComponent: RowComponent, cellComponent: cellComponent, scopeCellComponent: scopeCellComponent, expandedRowInfo: expandedRowInfo } = props;
    const rowInfo = (0, $9708cd947c7f3f82$export$2e2bcd8739ae039)(record, rowKey, index, indent);
    const { prefixCls: prefixCls, flattenColumns: flattenColumns, expandedRowClassName: expandedRowClassName, expandedRowRender: expandedRowRender, forceRender: forceRender, rowProps: rowProps, expanded: // Misc
    expanded, rowSupportExpand: rowSupportExpand } = rowInfo;
    // Keep the expanded row mounted after it has been expanded
    const expandedRef = $cQmXV.useRef(false);
    expandedRef.current ||= expanded;
    // 若没有 expandedRowRender 参数, 将使用 baseRowNode 渲染 Children
    // 此时如果 level > 1 则说明是 expandedRow, 一样需要附加 computedExpandedRowClassName
    const expandedClsName = (0, $4241324b3d4de179$export$c5c465afb98f57b6)(expandedRowClassName, record, index, indent);
    // ======================== Base tr row ========================
    const baseRowNode = /*#__PURE__*/ $cQmXV.createElement(RowComponent, $49da4ac3f43ec6a8$var$_extends({}, rowProps, {
        "data-row-key": rowKey,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(className, `${prefixCls}-row`, `${prefixCls}-row-level-${indent}`, rowProps?.className, classNames.row, {
            [expandedClsName]: indent >= 1
        }),
        style: {
            ...style,
            ...rowProps?.style,
            ...styles.row
        }
    }), flattenColumns.map((column, colIndex)=>{
        const { render: render, dataIndex: dataIndex, className: columnClassName } = column;
        const { key: key, fixedInfo: fixedInfo, appendCellNode: appendCellNode, additionalCellProps: additionalCellProps, originRowSpan: originRowSpan } = $49da4ac3f43ec6a8$export$16400ac709c56616(rowInfo, column, colIndex, indent, index, rowKeys, expandedRowInfo?.offset);
        return /*#__PURE__*/ $cQmXV.createElement((0, $c5712ffce408ad73$export$2e2bcd8739ae039), $49da4ac3f43ec6a8$var$_extends({
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(columnClassName, classNames.cell),
            style: styles.cell,
            ellipsis: column.ellipsis,
            align: column.align,
            scope: column.rowScope,
            component: column.rowScope ? scopeCellComponent : cellComponent,
            prefixCls: prefixCls,
            key: key,
            record: record,
            index: index,
            renderIndex: renderIndex,
            dataIndex: dataIndex,
            render: render,
            shouldCellUpdate: column.shouldCellUpdate
        }, fixedInfo, {
            appendNode: appendCellNode,
            additionalProps: additionalCellProps,
            originRowSpan: originRowSpan
        }));
    }));
    // ======================== Expand Row =========================
    let expandRowNode;
    if (rowSupportExpand && (forceRender || expandedRef.current || expanded)) {
        const expandContent = expandedRowRender(record, index, indent + 1, expanded);
        expandRowNode = /*#__PURE__*/ $cQmXV.createElement((0, $beabb922f5c31eba$export$2e2bcd8739ae039), {
            expanded: expanded,
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-expanded-row`, `${prefixCls}-expanded-row-level-${indent + 1}`, expandedClsName),
            prefixCls: prefixCls,
            component: RowComponent,
            cellComponent: cellComponent,
            colSpan: expandedRowInfo ? expandedRowInfo.colSpan : flattenColumns.length,
            isEmpty: false,
            stickyOffset: expandedRowInfo?.sticky
        }, expandContent);
    }
    return /*#__PURE__*/ $cQmXV.createElement($cQmXV.Fragment, null, baseRowNode, expandRowNode);
};
var $49da4ac3f43ec6a8$export$2e2bcd8739ae039 = (0, $8ff93ffc4f10aaf4$export$e9e4cb9eb9e2b4c4)($49da4ac3f43ec6a8$var$BodyRow);




var $cQmXV = parcelRequire("cQmXV");


var $cQmXV = parcelRequire("cQmXV");


const $0d6623fa359560f6$var$MeasureCell = (props)=>{
    const { columnKey: columnKey, onColumnResize: onColumnResize, title: title } = props;
    const cellRef = $cQmXV.useRef(null);
    (0, $7673d874dab69d07$export$2e2bcd8739ae039)(()=>{
        if (cellRef.current) onColumnResize(columnKey, cellRef.current.offsetWidth);
    }, []);
    return /*#__PURE__*/ $cQmXV.createElement((0, $1d6306c05e604045$export$2e2bcd8739ae039), {
        data: columnKey
    }, /*#__PURE__*/ $cQmXV.createElement("td", {
        ref: cellRef,
        style: {
            paddingTop: 0,
            paddingBottom: 0,
            borderTop: 0,
            borderBottom: 0,
            height: 0
        }
    }, /*#__PURE__*/ $cQmXV.createElement("div", {
        style: {
            height: 0,
            overflow: "hidden",
            fontWeight: "bold"
        }
    }, title || "\xa0")));
};
var $0d6623fa359560f6$export$2e2bcd8739ae039 = $0d6623fa359560f6$var$MeasureCell;





const $6a00aae2efa85aee$var$MeasureRow = ({ prefixCls: prefixCls, columnsKey: columnsKey, onColumnResize: onColumnResize, columns: columns })=>{
    const ref = $cQmXV.useRef(null);
    const { measureRowRender: measureRowRender } = (0, $1100d1e67da77ebd$export$fae74005e78b1a27)((0, $8ff93ffc4f10aaf4$export$2e2bcd8739ae039), [
        "measureRowRender"
    ]);
    const measureRow = /*#__PURE__*/ $cQmXV.createElement("tr", {
        "aria-hidden": "true",
        className: `${prefixCls}-measure-row`,
        style: {
            height: 0
        },
        ref: ref
    }, /*#__PURE__*/ $cQmXV.createElement((0, $1d6306c05e604045$export$2e2bcd8739ae039).Collection, {
        onBatchResize: (infoList)=>{
            if ((0, $c70640475a7bd353$export$2e2bcd8739ae039)(ref.current)) infoList.forEach(({ data: columnKey, size: size })=>{
                onColumnResize(columnKey, size.offsetWidth);
            });
        }
    }, columnsKey.map((columnKey)=>{
        const column = columns.find((col)=>col.key === columnKey);
        const rawTitle = column?.title;
        const titleForMeasure = /*#__PURE__*/ $cQmXV.isValidElement(rawTitle) ? /*#__PURE__*/ $cQmXV.cloneElement(rawTitle, {
            ref: null
        }) : rawTitle;
        return /*#__PURE__*/ $cQmXV.createElement((0, $0d6623fa359560f6$export$2e2bcd8739ae039), {
            key: columnKey,
            columnKey: columnKey,
            onColumnResize: onColumnResize,
            title: titleForMeasure
        });
    })));
    return typeof measureRowRender === "function" ? measureRowRender(measureRow) : measureRow;
};
var $6a00aae2efa85aee$export$2e2bcd8739ae039 = $6a00aae2efa85aee$var$MeasureRow;


const $a273a480146db45f$var$Body = (props)=>{
    const { data: data, measureColumnWidth: measureColumnWidth } = props;
    const { prefixCls: prefixCls, getComponent: getComponent, onColumnResize: onColumnResize, flattenColumns: flattenColumns, getRowKey: getRowKey, expandedKeys: expandedKeys, childrenColumnName: childrenColumnName, emptyNode: emptyNode, classNames: classNames, styles: styles, expandedRowOffset: expandedRowOffset = 0, colWidths: colWidths } = (0, $1100d1e67da77ebd$export$fae74005e78b1a27)((0, $8ff93ffc4f10aaf4$export$2e2bcd8739ae039), [
        "prefixCls",
        "getComponent",
        "onColumnResize",
        "flattenColumns",
        "getRowKey",
        "expandedKeys",
        "childrenColumnName",
        "emptyNode",
        "classNames",
        "styles",
        "expandedRowOffset",
        "fixedInfoList",
        "colWidths"
    ]);
    const { body: bodyCls = {} } = classNames || {};
    const { body: bodyStyles = {} } = styles || {};
    const flattenData = (0, $c84b77e36f423551$export$2e2bcd8739ae039)(data, childrenColumnName, expandedKeys, getRowKey);
    const rowKeys = $cQmXV.useMemo(()=>flattenData.map((item)=>item.rowKey), [
        flattenData
    ]);
    // =================== Performance ====================
    const perfRef = $cQmXV.useRef({
        renderWithProps: false
    });
    // ===================== Expanded =====================
    // `expandedRowOffset` data is same for all the rows.
    // Let's calc on Body side to save performance.
    const expandedRowInfo = $cQmXV.useMemo(()=>{
        const expandedColSpan = flattenColumns.length - expandedRowOffset;
        let expandedStickyStart = 0;
        for(let i = 0; i < expandedRowOffset; i += 1)expandedStickyStart += colWidths[i] || 0;
        return {
            offset: expandedRowOffset,
            colSpan: expandedColSpan,
            sticky: expandedStickyStart
        };
    }, [
        flattenColumns.length,
        expandedRowOffset,
        colWidths
    ]);
    // ====================== Render ======================
    const WrapperComponent = getComponent([
        "body",
        "wrapper"
    ], "tbody");
    const trComponent = getComponent([
        "body",
        "row"
    ], "tr");
    const tdComponent = getComponent([
        "body",
        "cell"
    ], "td");
    const thComponent = getComponent([
        "body",
        "cell"
    ], "th");
    let rows;
    if (data.length) rows = flattenData.map((item, idx)=>{
        const { record: record, indent: indent, index: renderIndex, rowKey: rowKey } = item;
        return /*#__PURE__*/ $cQmXV.createElement((0, $49da4ac3f43ec6a8$export$2e2bcd8739ae039), {
            classNames: bodyCls,
            styles: bodyStyles,
            key: rowKey,
            rowKey: rowKey,
            rowKeys: rowKeys,
            record: record,
            index: idx,
            renderIndex: renderIndex,
            rowComponent: trComponent,
            cellComponent: tdComponent,
            scopeCellComponent: thComponent,
            indent: indent,
            expandedRowInfo: expandedRowInfo
        });
    });
    else rows = /*#__PURE__*/ $cQmXV.createElement((0, $beabb922f5c31eba$export$2e2bcd8739ae039), {
        expanded: true,
        className: `${prefixCls}-placeholder`,
        prefixCls: prefixCls,
        component: trComponent,
        cellComponent: tdComponent,
        colSpan: flattenColumns.length,
        isEmpty: true
    }, emptyNode);
    const columnsKey = (0, $435e6e552a98f20a$export$fd2ca5407d9be470)(flattenColumns);
    return /*#__PURE__*/ $cQmXV.createElement((0, $91976f4a74d60508$export$2e2bcd8739ae039).Provider, {
        value: perfRef.current
    }, /*#__PURE__*/ $cQmXV.createElement(WrapperComponent, {
        style: bodyStyles.wrapper,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-tbody`, bodyCls.wrapper)
    }, measureColumnWidth && /*#__PURE__*/ $cQmXV.createElement((0, $6a00aae2efa85aee$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        columnsKey: columnsKey,
        onColumnResize: onColumnResize,
        columns: flattenColumns
    }), rows));
};
var $a273a480146db45f$export$2e2bcd8739ae039 = (0, $8ff93ffc4f10aaf4$export$e9e4cb9eb9e2b4c4)($a273a480146db45f$var$Body);



var $cQmXV = parcelRequire("cQmXV");

const $94bfd0c932f33df8$export$f8dba99c0d5b6b87 = "RC_TABLE_INTERNAL_COL_DEFINE";
function $94bfd0c932f33df8$export$e215b9806eacdfb5(props) {
    const { expandable: expandable, ...legacyExpandableConfig } = props;
    let config;
    if ("expandable" in props) config = {
        ...legacyExpandableConfig,
        ...expandable
    };
    else config = legacyExpandableConfig;
    if (config.showExpandColumn === false) config.expandIconColumnIndex = -1;
    return config;
}




function $4ee844eec16001e9$var$_extends() {
    $4ee844eec16001e9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4ee844eec16001e9$var$_extends.apply(this, arguments);
}
const $4ee844eec16001e9$var$ColGroup = (props)=>{
    const { colWidths: colWidths, columns: columns, columCount: columCount } = props;
    const { tableLayout: tableLayout } = (0, $1100d1e67da77ebd$export$fae74005e78b1a27)((0, $8ff93ffc4f10aaf4$export$2e2bcd8739ae039), [
        "tableLayout"
    ]);
    const cols = [];
    const len = columCount || columns.length;
    // Only insert col with width & additional props
    // Skip if rest col do not have any useful info
    let mustInsert = false;
    for(let i = len - 1; i >= 0; i -= 1){
        const width = colWidths[i];
        const column = columns && columns[i];
        let additionalProps;
        let minWidth;
        if (column) {
            additionalProps = column[0, $94bfd0c932f33df8$export$f8dba99c0d5b6b87];
            // fixed will cause layout problems
            if (tableLayout === "auto") minWidth = column.minWidth;
        }
        if (width || minWidth || additionalProps || mustInsert) {
            const { columnType: columnType, ...restAdditionalProps } = additionalProps || {};
            cols.unshift(/*#__PURE__*/ $cQmXV.createElement("col", $4ee844eec16001e9$var$_extends({
                key: i,
                style: {
                    width: width,
                    minWidth: minWidth
                }
            }, restAdditionalProps)));
            mustInsert = true;
        }
    }
    return cols.length > 0 ? /*#__PURE__*/ $cQmXV.createElement("colgroup", null, cols) : null;
};
var $4ee844eec16001e9$export$2e2bcd8739ae039 = $4ee844eec16001e9$var$ColGroup;








var $cQmXV = parcelRequire("cQmXV");



function $7e53d259ab703a1d$var$useColumnWidth(colWidths, columCount) {
    return (0, $cQmXV.useMemo)(()=>{
        const cloneColumns = [];
        for(let i = 0; i < columCount; i += 1){
            const val = colWidths[i];
            if (val !== undefined) cloneColumns[i] = val;
            else return null;
        }
        return cloneColumns;
    }, [
        colWidths.join("_"),
        columCount
    ]);
}
const $7e53d259ab703a1d$var$FixedHolder = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { className: className, style: style, noData: noData, columns: columns, flattenColumns: flattenColumns, colWidths: colWidths, colGroup: colGroup, columCount: columCount, stickyOffsets: stickyOffsets, direction: direction, fixHeader: fixHeader, stickyTopOffset: stickyTopOffset, stickyBottomOffset: stickyBottomOffset, stickyClassName: stickyClassName, scrollX: scrollX, tableLayout: tableLayout = "fixed", onScroll: onScroll, maxContentScroll: maxContentScroll, children: children, ...restProps } = props;
    const { prefixCls: prefixCls, scrollbarSize: scrollbarSize, isSticky: isSticky, getComponent: getComponent } = (0, $1100d1e67da77ebd$export$fae74005e78b1a27)((0, $8ff93ffc4f10aaf4$export$2e2bcd8739ae039), [
        "prefixCls",
        "scrollbarSize",
        "isSticky",
        "getComponent"
    ]);
    const TableComponent = getComponent([
        "header",
        "table"
    ], "table");
    const combinationScrollBarSize = isSticky && !fixHeader ? 0 : scrollbarSize;
    // Pass wheel to scroll event
    const scrollRef = $cQmXV.useRef(null);
    const setScrollRef = $cQmXV.useCallback((element)=>{
        (0, $10341b937b26f69d$export$f17fd18fa51dcb5b)(ref, element);
        (0, $10341b937b26f69d$export$f17fd18fa51dcb5b)(scrollRef, element);
    }, []);
    $cQmXV.useEffect(()=>{
        function onWheel(e) {
            const { currentTarget: currentTarget, deltaX: deltaX } = e;
            if (deltaX) {
                const { scrollLeft: scrollLeft, scrollWidth: scrollWidth, clientWidth: clientWidth } = currentTarget;
                const maxScrollWidth = scrollWidth - clientWidth;
                let nextScroll = scrollLeft + deltaX;
                if (direction === "rtl") {
                    nextScroll = Math.max(-maxScrollWidth, nextScroll);
                    nextScroll = Math.min(0, nextScroll);
                } else {
                    nextScroll = Math.min(maxScrollWidth, nextScroll);
                    nextScroll = Math.max(0, nextScroll);
                }
                onScroll({
                    currentTarget: currentTarget,
                    scrollLeft: nextScroll
                });
                e.preventDefault();
            }
        }
        const scrollEle = scrollRef.current;
        scrollEle?.addEventListener("wheel", onWheel, {
            passive: false
        });
        return ()=>{
            scrollEle?.removeEventListener("wheel", onWheel);
        };
    }, []);
    // Add scrollbar column
    const lastColumn = flattenColumns[flattenColumns.length - 1];
    const ScrollBarColumn = {
        fixed: lastColumn ? lastColumn.fixed : null,
        scrollbar: true,
        onHeaderCell: ()=>({
                className: `${prefixCls}-cell-scrollbar`
            })
    };
    const columnsWithScrollbar = (0, $cQmXV.useMemo)(()=>combinationScrollBarSize ? [
            ...columns,
            ScrollBarColumn
        ] : columns, [
        combinationScrollBarSize,
        columns
    ]);
    const flattenColumnsWithScrollbar = (0, $cQmXV.useMemo)(()=>combinationScrollBarSize ? [
            ...flattenColumns,
            ScrollBarColumn
        ] : flattenColumns, [
        combinationScrollBarSize,
        flattenColumns
    ]);
    // Calculate the sticky offsets
    const headerStickyOffsets = (0, $cQmXV.useMemo)(()=>{
        const { start: start, end: end } = stickyOffsets;
        return {
            ...stickyOffsets,
            // left:
            //   direction === 'rtl' ? [...left.map(width => width + combinationScrollBarSize), 0] : left,
            // right:
            //   direction === 'rtl' ? right : [...right.map(width => width + combinationScrollBarSize), 0],
            start: start,
            end: [
                ...end.map((width)=>width + combinationScrollBarSize),
                0
            ],
            isSticky: isSticky
        };
    }, [
        combinationScrollBarSize,
        stickyOffsets,
        isSticky
    ]);
    const mergedColumnWidth = $7e53d259ab703a1d$var$useColumnWidth(colWidths, columCount);
    const isColGroupEmpty = (0, $cQmXV.useMemo)(()=>{
        // use original ColGroup if no data or no calculated column width, otherwise use calculated column width
        // Return original colGroup if no data, or mergedColumnWidth is empty, or all widths are falsy
        const noWidth = !mergedColumnWidth || !mergedColumnWidth.length || mergedColumnWidth.every((w)=>!w);
        return noData || noWidth;
    }, [
        noData,
        mergedColumnWidth
    ]);
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        style: {
            overflow: "hidden",
            ...isSticky ? {
                top: stickyTopOffset,
                bottom: stickyBottomOffset
            } : {},
            ...style
        },
        ref: setScrollRef,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(className, {
            [stickyClassName]: !!stickyClassName
        })
    }, /*#__PURE__*/ $cQmXV.createElement(TableComponent, {
        style: {
            tableLayout: tableLayout,
            minWidth: "100%",
            // https://github.com/ant-design/ant-design/issues/54894
            width: scrollX
        }
    }, isColGroupEmpty ? colGroup : /*#__PURE__*/ $cQmXV.createElement((0, $4ee844eec16001e9$export$2e2bcd8739ae039), {
        colWidths: [
            ...mergedColumnWidth,
            combinationScrollBarSize
        ],
        columCount: columCount + 1,
        columns: flattenColumnsWithScrollbar
    }), children({
        ...restProps,
        stickyOffsets: headerStickyOffsets,
        columns: columnsWithScrollbar,
        flattenColumns: flattenColumnsWithScrollbar
    })));
});
var /** Return a table in div as fixed element which contains sticky info */ // export default responseImmutable(FixedHolder);
$7e53d259ab703a1d$export$2e2bcd8739ae039 = /*#__PURE__*/ $cQmXV.memo($7e53d259ab703a1d$var$FixedHolder);





var $cQmXV = parcelRequire("cQmXV");





var $cQmXV = parcelRequire("cQmXV");





function $3249e07e376e84c6$var$_extends() {
    $3249e07e376e84c6$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3249e07e376e84c6$var$_extends.apply(this, arguments);
}
const $3249e07e376e84c6$var$HeaderRow = (props)=>{
    const { cells: cells, stickyOffsets: stickyOffsets, flattenColumns: flattenColumns, rowComponent: RowComponent, cellComponent: CellComponent, onHeaderRow: onHeaderRow, index: index, classNames: classNames, styles: styles } = props;
    const { prefixCls: prefixCls } = (0, $1100d1e67da77ebd$export$fae74005e78b1a27)((0, $8ff93ffc4f10aaf4$export$2e2bcd8739ae039), [
        "prefixCls"
    ]);
    let rowProps;
    if (onHeaderRow) rowProps = onHeaderRow(cells.map((cell)=>cell.column), index);
    const columnsKey = (0, $435e6e552a98f20a$export$fd2ca5407d9be470)(cells.map((cell)=>cell.column));
    return /*#__PURE__*/ $cQmXV.createElement(RowComponent, $3249e07e376e84c6$var$_extends({}, rowProps, {
        className: classNames.row,
        style: styles.row
    }), cells.map((cell, cellIndex)=>{
        const { column: column, colStart: colStart, colEnd: colEnd, colSpan: colSpan } = cell;
        const fixedInfo = (0, $a021d55cd4d0d0b9$export$695db918331141f3)(colStart, colEnd, flattenColumns, stickyOffsets);
        const additionalProps = column?.onHeaderCell?.(column) || {};
        return /*#__PURE__*/ $cQmXV.createElement((0, $c5712ffce408ad73$export$2e2bcd8739ae039), $3249e07e376e84c6$var$_extends({}, cell, {
            scope: column.title ? colSpan > 1 ? "colgroup" : "col" : null,
            ellipsis: column.ellipsis,
            align: column.align,
            component: CellComponent,
            prefixCls: prefixCls,
            key: columnsKey[cellIndex]
        }, fixedInfo, {
            additionalProps: additionalProps,
            rowType: "header"
        }));
    }));
};
var $3249e07e376e84c6$export$2e2bcd8739ae039 = $3249e07e376e84c6$var$HeaderRow;


function $99758f74f83ed588$var$parseHeaderRows(rootColumns, classNames, styles) {
    const rows = [];
    function fillRowCells(columns, colIndex, rowIndex = 0) {
        // Init rows
        rows[rowIndex] = rows[rowIndex] || [];
        let currentColIndex = colIndex;
        const colSpans = columns.filter(Boolean).map((column)=>{
            const cell = {
                key: column.key,
                className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(column.className, classNames.cell) || "",
                style: styles.cell,
                children: column.title,
                column: column,
                colStart: currentColIndex
            };
            let colSpan = 1;
            const subColumns = column.children;
            if (subColumns && subColumns.length > 0) {
                colSpan = fillRowCells(subColumns, currentColIndex, rowIndex + 1).reduce((total, count)=>total + count, 0);
                cell.hasSubColumns = true;
            }
            if ("colSpan" in column) ({ colSpan: colSpan } = column);
            if ("rowSpan" in column) cell.rowSpan = column.rowSpan;
            cell.colSpan = colSpan;
            cell.colEnd = cell.colStart + colSpan - 1;
            rows[rowIndex].push(cell);
            currentColIndex += colSpan;
            return colSpan;
        });
        return colSpans;
    }
    // Generate `rows` cell data
    fillRowCells(rootColumns, 0);
    // Handle `rowSpan`
    const rowCount = rows.length;
    for(let rowIndex = 0; rowIndex < rowCount; rowIndex += 1)rows[rowIndex].forEach((cell)=>{
        if (!("rowSpan" in cell) && !cell.hasSubColumns) // eslint-disable-next-line no-param-reassign
        cell.rowSpan = rowCount - rowIndex;
    });
    return rows;
}
const $99758f74f83ed588$var$Header = (props)=>{
    const { stickyOffsets: stickyOffsets, columns: columns, flattenColumns: flattenColumns, onHeaderRow: onHeaderRow } = props;
    const { prefixCls: prefixCls, getComponent: getComponent, classNames: classNames, styles: styles } = (0, $1100d1e67da77ebd$export$fae74005e78b1a27)((0, $8ff93ffc4f10aaf4$export$2e2bcd8739ae039), [
        "prefixCls",
        "getComponent",
        "classNames",
        "styles"
    ]);
    const { header: headerCls = {} } = classNames || {};
    const { header: headerStyles = {} } = styles || {};
    const rows = $cQmXV.useMemo(()=>$99758f74f83ed588$var$parseHeaderRows(columns, headerCls, headerStyles), [
        columns,
        headerCls,
        headerStyles
    ]);
    const WrapperComponent = getComponent([
        "header",
        "wrapper"
    ], "thead");
    const trComponent = getComponent([
        "header",
        "row"
    ], "tr");
    const thComponent = getComponent([
        "header",
        "cell"
    ], "th");
    return /*#__PURE__*/ $cQmXV.createElement(WrapperComponent, {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-thead`, headerCls.wrapper),
        style: headerStyles.wrapper
    }, rows.map((row, rowIndex)=>{
        const rowNode = /*#__PURE__*/ $cQmXV.createElement((0, $3249e07e376e84c6$export$2e2bcd8739ae039), {
            classNames: headerCls,
            styles: headerStyles,
            key: rowIndex,
            flattenColumns: flattenColumns,
            cells: row,
            stickyOffsets: stickyOffsets,
            rowComponent: trComponent,
            cellComponent: thComponent,
            onHeaderRow: onHeaderRow,
            index: rowIndex
        });
        return rowNode;
    }));
};
var $99758f74f83ed588$export$2e2bcd8739ae039 = (0, $8ff93ffc4f10aaf4$export$e9e4cb9eb9e2b4c4)($99758f74f83ed588$var$Header);




var $cQmXV = parcelRequire("cQmXV");



var $cQmXV = parcelRequire("cQmXV");
function $6dcba2b5df481e52$var$parseColWidth(totalWidth, width = "") {
    if (typeof width === "number") return width;
    if (width.endsWith("%")) return totalWidth * parseFloat(width) / 100;
    return null;
}
function $6dcba2b5df481e52$export$2e2bcd8739ae039(flattenColumns, scrollWidth, clientWidth) {
    return $cQmXV.useMemo(()=>{
        // Fill width if needed
        if (scrollWidth && scrollWidth > 0) {
            let totalWidth = 0;
            let missWidthCount = 0;
            // collect not given width column
            flattenColumns.forEach((col)=>{
                const colWidth = $6dcba2b5df481e52$var$parseColWidth(scrollWidth, col.width);
                if (colWidth) totalWidth += colWidth;
                else missWidthCount += 1;
            });
            // Fill width
            const maxFitWidth = Math.max(scrollWidth, clientWidth);
            let restWidth = Math.max(maxFitWidth - totalWidth, missWidthCount);
            let restCount = missWidthCount;
            const avgWidth = restWidth / missWidthCount;
            let realTotal = 0;
            const filledColumns = flattenColumns.map((col)=>{
                const clone = {
                    ...col
                };
                const colWidth = $6dcba2b5df481e52$var$parseColWidth(scrollWidth, clone.width);
                if (colWidth) clone.width = colWidth;
                else {
                    const colAvgWidth = Math.floor(avgWidth);
                    clone.width = restCount === 1 ? restWidth : colAvgWidth;
                    restWidth -= colAvgWidth;
                    restCount -= 1;
                }
                realTotal += clone.width;
                return clone;
            });
            // If realTotal is less than clientWidth,
            // We need extend column width
            if (realTotal < maxFitWidth) {
                const scale = maxFitWidth / realTotal;
                restWidth = maxFitWidth;
                filledColumns.forEach((col, index)=>{
                    const colWidth = Math.floor(col.width * scale);
                    col.width = index === filledColumns.length - 1 ? restWidth : colWidth;
                    restWidth -= colWidth;
                });
            }
            return [
                filledColumns,
                Math.max(realTotal, maxFitWidth)
            ];
        }
        return [
            flattenColumns,
            scrollWidth
        ];
    }, [
        flattenColumns,
        scrollWidth,
        clientWidth
    ]);
}


function $582dcd0e4b930539$export$d87a97eba44e0f9c(children) {
    return (0, $cd966a313e0a92ff$export$2e2bcd8739ae039)(children).filter((node)=>/*#__PURE__*/ $cQmXV.isValidElement(node)).map((node)=>{
        const { key: key, props: props } = node;
        const { children: nodeChildren, ...restProps } = props;
        const column = {
            key: key,
            ...restProps
        };
        if (nodeChildren) column.children = $582dcd0e4b930539$export$d87a97eba44e0f9c(nodeChildren);
        return column;
    });
}
function $582dcd0e4b930539$var$filterHiddenColumns(columns) {
    return columns.filter((column)=>column && typeof column === "object" && !column.hidden).map((column)=>{
        const subColumns = column.children;
        if (subColumns && subColumns.length > 0) return {
            ...column,
            children: $582dcd0e4b930539$var$filterHiddenColumns(subColumns)
        };
        return column;
    });
}
function $582dcd0e4b930539$var$flatColumns(columns, parentKey = "key") {
    return columns.filter((column)=>column && typeof column === "object").reduce((list, column, index)=>{
        const { fixed: fixed } = column;
        const parsedFixed = fixed === true || fixed === "left" ? "start" : fixed === "right" ? "end" : fixed;
        const mergedKey = `${parentKey}-${index}`;
        const subColumns = column.children;
        if (subColumns && subColumns.length > 0) return [
            ...list,
            ...$582dcd0e4b930539$var$flatColumns(subColumns, mergedKey).map((subColum)=>({
                    ...subColum,
                    fixed: subColum.fixed ?? parsedFixed
                }))
        ];
        return [
            ...list,
            {
                key: mergedKey,
                ...column,
                fixed: parsedFixed
            }
        ];
    }, []);
}
/**
 * Parse `columns` & `children` into `columns`.
 */ function $582dcd0e4b930539$var$useColumns({ prefixCls: prefixCls, columns: columns, children: children, expandable: expandable, expandedKeys: expandedKeys, columnTitle: columnTitle, getRowKey: getRowKey, onTriggerExpand: onTriggerExpand, expandIcon: expandIcon, rowExpandable: rowExpandable, expandIconColumnIndex: expandIconColumnIndex, expandedRowOffset: expandedRowOffset = 0, direction: direction, expandRowByClick: expandRowByClick, columnWidth: columnWidth, fixed: fixed, scrollWidth: scrollWidth, clientWidth: clientWidth }, transformColumns) {
    const baseColumns = $cQmXV.useMemo(()=>{
        const newColumns = columns || $582dcd0e4b930539$export$d87a97eba44e0f9c(children) || [];
        return $582dcd0e4b930539$var$filterHiddenColumns(newColumns.slice());
    }, [
        columns,
        children
    ]);
    // ========================== Expand ==========================
    const withExpandColumns = $cQmXV.useMemo(()=>{
        if (expandable) {
            let cloneColumns = baseColumns.slice();
            // >>> Insert expand column if not exist
            if (!cloneColumns.includes((0, $9848d298b42e15e6$export$e1053575ddfcb301))) {
                const expandColIndex = expandIconColumnIndex || 0;
                const insertIndex = expandColIndex === 0 && (fixed === "right" || fixed === "end") ? baseColumns.length : expandColIndex;
                if (insertIndex >= 0) cloneColumns.splice(insertIndex, 0, (0, $9848d298b42e15e6$export$e1053575ddfcb301));
            }
            const expandColumnIndex = cloneColumns.indexOf((0, $9848d298b42e15e6$export$e1053575ddfcb301));
            cloneColumns = cloneColumns.filter((column, index)=>column !== (0, $9848d298b42e15e6$export$e1053575ddfcb301) || index === expandColumnIndex);
            // >>> Check if expand column need to fixed
            const prevColumn = baseColumns[expandColumnIndex];
            let fixedColumn;
            if (fixed) fixedColumn = fixed;
            else fixedColumn = prevColumn ? prevColumn.fixed : null;
            // >>> Create expandable column
            const expandColumn = {
                [(0, $94bfd0c932f33df8$export$f8dba99c0d5b6b87)]: {
                    className: `${prefixCls}-expand-icon-col`,
                    columnType: "EXPAND_COLUMN"
                },
                title: columnTitle,
                fixed: fixedColumn,
                className: `${prefixCls}-row-expand-icon-cell`,
                width: columnWidth,
                render: (_, record, index)=>{
                    const rowKey = getRowKey(record, index);
                    const expanded = expandedKeys.has(rowKey);
                    const recordExpandable = rowExpandable ? rowExpandable(record) : true;
                    const icon = expandIcon({
                        prefixCls: prefixCls,
                        expanded: expanded,
                        expandable: recordExpandable,
                        record: record,
                        onExpand: onTriggerExpand
                    });
                    if (expandRowByClick) return /*#__PURE__*/ $cQmXV.createElement("span", {
                        onClick: (e)=>e.stopPropagation()
                    }, icon);
                    return icon;
                }
            };
            return cloneColumns.map((col, index)=>{
                const column = col === (0, $9848d298b42e15e6$export$e1053575ddfcb301) ? expandColumn : col;
                if (index < expandedRowOffset) return {
                    ...column,
                    fixed: column.fixed || "start"
                };
                return column;
            });
        }
        return baseColumns.filter((col)=>col !== (0, $9848d298b42e15e6$export$e1053575ddfcb301));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        expandable,
        baseColumns,
        getRowKey,
        expandedKeys,
        expandIcon,
        direction,
        expandedRowOffset
    ]);
    // ========================= Transform ========================
    const mergedColumns = $cQmXV.useMemo(()=>{
        let finalColumns = withExpandColumns;
        if (transformColumns) finalColumns = transformColumns(finalColumns);
        // Always provides at least one column for table display
        if (!finalColumns.length) finalColumns = [
            {
                render: ()=>null
            }
        ];
        return finalColumns;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        transformColumns,
        withExpandColumns,
        direction
    ]);
    // ========================== Flatten =========================
    const flattenColumns = $cQmXV.useMemo(()=>$582dcd0e4b930539$var$flatColumns(mergedColumns), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        mergedColumns,
        direction,
        scrollWidth
    ]);
    // ========================= FillWidth ========================
    const [filledColumns, realScrollWidth] = (0, $6dcba2b5df481e52$export$2e2bcd8739ae039)(flattenColumns, scrollWidth, clientWidth);
    return [
        mergedColumns,
        filledColumns,
        realScrollWidth
    ];
}
var $582dcd0e4b930539$export$2e2bcd8739ae039 = $582dcd0e4b930539$var$useColumns;




var $cQmXV = parcelRequire("cQmXV");



function $9829f8b019fac50e$export$2e2bcd8739ae039(props, mergedData, getRowKey) {
    const expandableConfig = (0, $94bfd0c932f33df8$export$e215b9806eacdfb5)(props);
    const { expandIcon: expandIcon, expandedRowKeys: expandedRowKeys, defaultExpandedRowKeys: defaultExpandedRowKeys, defaultExpandAllRows: defaultExpandAllRows, expandedRowRender: expandedRowRender, onExpand: onExpand, onExpandedRowsChange: onExpandedRowsChange, childrenColumnName: childrenColumnName } = expandableConfig;
    const mergedExpandIcon = expandIcon || (0, $4241324b3d4de179$export$ae14373a7f810e33);
    const mergedChildrenColumnName = childrenColumnName || "children";
    const expandableType = $cQmXV.useMemo(()=>{
        if (expandedRowRender) return "row";
        /* eslint-disable no-underscore-dangle */ /**
     * Fix https://github.com/ant-design/ant-design/issues/21154
     * This is a workaround to not to break current behavior.
     * We can remove follow code after final release.
     *
     * To other developer:
     *  Do not use `__PARENT_RENDER_ICON__` in prod since we will remove this when refactor
     */ if (props.expandable && props.internalHooks === (0, $9848d298b42e15e6$export$91b75cf262680225) && props.expandable.__PARENT_RENDER_ICON__ || mergedData.some((record)=>record && typeof record === "object" && record[mergedChildrenColumnName])) return "nest";
        /* eslint-enable */ return false;
    }, [
        !!expandedRowRender,
        mergedData
    ]);
    const [innerExpandedKeys, setInnerExpandedKeys] = $cQmXV.useState(()=>{
        if (defaultExpandedRowKeys) return defaultExpandedRowKeys;
        if (defaultExpandAllRows) return (0, $4241324b3d4de179$export$49bec56f6055f375)(mergedData, getRowKey, mergedChildrenColumnName);
        return [];
    });
    const mergedExpandedKeys = $cQmXV.useMemo(()=>new Set(expandedRowKeys || innerExpandedKeys || []), [
        expandedRowKeys,
        innerExpandedKeys
    ]);
    const onTriggerExpand = $cQmXV.useCallback((record)=>{
        const key = getRowKey(record, mergedData.indexOf(record));
        let newExpandedKeys;
        const hasKey = mergedExpandedKeys.has(key);
        if (hasKey) {
            mergedExpandedKeys.delete(key);
            newExpandedKeys = [
                ...mergedExpandedKeys
            ];
        } else newExpandedKeys = [
            ...mergedExpandedKeys,
            key
        ];
        setInnerExpandedKeys(newExpandedKeys);
        if (onExpand) onExpand(!hasKey, record);
        if (onExpandedRowsChange) onExpandedRowsChange(newExpandedKeys);
    }, [
        getRowKey,
        mergedExpandedKeys,
        mergedData,
        onExpand,
        onExpandedRowsChange
    ]);
    return [
        expandableConfig,
        expandableType,
        mergedExpandedKeys,
        mergedExpandIcon,
        mergedChildrenColumnName,
        onTriggerExpand
    ];
}





var $cQmXV = parcelRequire("cQmXV");
function $e44eebfb7e673e63$export$2e2bcd8739ae039(flattenColumns, stickyOffsets) {
    const fixedInfoList = $cQmXV.useMemo(()=>flattenColumns.map((_, colIndex)=>(0, $a021d55cd4d0d0b9$export$695db918331141f3)(colIndex, colIndex, flattenColumns, stickyOffsets)), [
        flattenColumns,
        stickyOffsets
    ]);
    return (0, $d627c2941353b4cb$export$2e2bcd8739ae039)(()=>fixedInfoList, [
        fixedInfoList
    ], (prev, next)=>!(0, $3f19ee2a2ff4618a$export$2e2bcd8739ae039)(prev, next));
}



var $cQmXV = parcelRequire("cQmXV");
function $341756d6dd741f5e$export$510e4dd13e0b67dd(defaultState) {
    const stateRef = (0, $cQmXV.useRef)(defaultState);
    const [, forceUpdate] = (0, $cQmXV.useState)({});
    const lastPromiseRef = (0, $cQmXV.useRef)(null);
    const updateBatchRef = (0, $cQmXV.useRef)([]);
    function setFrameState(updater) {
        updateBatchRef.current.push(updater);
        const promise = Promise.resolve();
        lastPromiseRef.current = promise;
        promise.then(()=>{
            if (lastPromiseRef.current === promise) {
                const prevBatch = updateBatchRef.current;
                const prevState = stateRef.current;
                updateBatchRef.current = [];
                prevBatch.forEach((batchUpdater)=>{
                    stateRef.current = batchUpdater(stateRef.current);
                });
                lastPromiseRef.current = null;
                if (prevState !== stateRef.current) forceUpdate({});
            }
        });
    }
    (0, $cQmXV.useEffect)(()=>()=>{
            lastPromiseRef.current = null;
        }, []);
    return [
        stateRef.current,
        setFrameState
    ];
}
function $341756d6dd741f5e$export$d63c72d5e6d02249(defaultState) {
    const frameRef = (0, $cQmXV.useRef)(defaultState || null);
    const timeoutRef = (0, $cQmXV.useRef)(null);
    function cleanUp() {
        clearTimeout(timeoutRef.current);
    }
    function setState(newState) {
        frameRef.current = newState;
        cleanUp();
        timeoutRef.current = setTimeout(()=>{
            frameRef.current = null;
            timeoutRef.current = undefined;
        }, 100);
    }
    function getState() {
        return frameRef.current;
    }
    (0, $cQmXV.useEffect)(()=>cleanUp, []);
    return [
        setState,
        getState
    ];
}



var $cQmXV = parcelRequire("cQmXV");
function $b3d711d6c1d69b49$export$2e2bcd8739ae039() {
    const [startRow, setStartRow] = $cQmXV.useState(-1);
    const [endRow, setEndRow] = $cQmXV.useState(-1);
    const onHover = $cQmXV.useCallback((start, end)=>{
        setStartRow(start);
        setEndRow(end);
    }, []);
    return [
        startRow,
        endRow,
        onHover
    ];
}



var $cQmXV = parcelRequire("cQmXV");

// fix ssr render
const $39bb6e08ec6a7f2c$var$defaultContainer = (0, $78361969822ad097$export$2e2bcd8739ae039)() ? window : null;
function $39bb6e08ec6a7f2c$export$2e2bcd8739ae039(sticky, prefixCls) {
    const { offsetHeader: offsetHeader = 0, offsetSummary: offsetSummary = 0, offsetScroll: offsetScroll = 0, getContainer: getContainer = ()=>$39bb6e08ec6a7f2c$var$defaultContainer } = typeof sticky === "object" ? sticky : {};
    const container = getContainer() || $39bb6e08ec6a7f2c$var$defaultContainer;
    const isSticky = !!sticky;
    return $cQmXV.useMemo(()=>{
        return {
            isSticky: isSticky,
            stickyClassName: isSticky ? `${prefixCls}-sticky-holder` : "",
            offsetHeader: offsetHeader,
            offsetSummary: offsetSummary,
            offsetScroll: offsetScroll,
            container: container
        };
    }, [
        isSticky,
        offsetScroll,
        offsetHeader,
        offsetSummary,
        prefixCls,
        container
    ]);
}



var $cQmXV = parcelRequire("cQmXV");
/**
 * Get sticky column offset width
 */ function $5e26096c6768ce4e$var$useStickyOffsets(colWidths, flattenColumns) {
    const stickyOffsets = (0, $cQmXV.useMemo)(()=>{
        const columnCount = flattenColumns.length;
        const getOffsets = (startIndex, endIndex, offset)=>{
            const offsets = [];
            let total = 0;
            for(let i = startIndex; i !== endIndex; i += offset){
                offsets.push(total);
                if (flattenColumns[i].fixed) total += colWidths[i] || 0;
            }
            return offsets;
        };
        const startOffsets = getOffsets(0, columnCount, 1);
        const endOffsets = getOffsets(columnCount - 1, -1, -1).reverse();
        return {
            start: startOffsets,
            end: endOffsets,
            widths: colWidths
        };
    }, [
        colWidths,
        flattenColumns
    ]);
    return stickyOffsets;
}
var $5e26096c6768ce4e$export$2e2bcd8739ae039 = $5e26096c6768ce4e$var$useStickyOffsets;



var $cQmXV = parcelRequire("cQmXV");
const $36c0ba3ebcfe8d04$var$Panel = (props)=>{
    const { children: children, className: className, style: style } = props;
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        className: className,
        style: style
    }, children);
};
var $36c0ba3ebcfe8d04$export$2e2bcd8739ae039 = $36c0ba3ebcfe8d04$var$Panel;






var $cQmXV = parcelRequire("cQmXV");



function $fc60b17434e9fa37$export$622cea445a1c5b7d(node) {
    const element = (0, $d3fb35d553a86e29$export$9aa546fdc20ae5b3)(node);
    const box = element.getBoundingClientRect();
    const docElem = document.documentElement;
    // < ie8 not support win.pageXOffset, use docElem.scrollLeft instead
    return {
        left: box.left + (window.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || document.body.clientLeft || 0),
        top: box.top + (window.pageYOffset || docElem.scrollTop) - (docElem.clientTop || document.body.clientTop || 0)
    };
}


const $7388bac66c8edcea$var$MOUSEUP_EVENT = "mouseup";
const $7388bac66c8edcea$var$MOUSEMOVE_EVENT = "mousemove";
const $7388bac66c8edcea$var$SCROLL_EVENT = "scroll";
const $7388bac66c8edcea$var$RESIZE_EVENT = "resize";
const $7388bac66c8edcea$var$StickyScrollBar = (props, ref)=>{
    const { scrollBodyRef: scrollBodyRef, onScroll: onScroll, offsetScroll: offsetScroll, container: container, direction: direction } = props;
    const prefixCls = (0, $1100d1e67da77ebd$export$fae74005e78b1a27)((0, $8ff93ffc4f10aaf4$export$2e2bcd8739ae039), "prefixCls");
    const bodyScrollWidth = scrollBodyRef.current?.scrollWidth || 0;
    const bodyWidth = scrollBodyRef.current?.clientWidth || 0;
    const scrollBarWidth = bodyScrollWidth && bodyWidth * (bodyWidth / bodyScrollWidth);
    const scrollBarRef = $cQmXV.useRef(null);
    const [scrollState, setScrollState] = (0, $341756d6dd741f5e$export$510e4dd13e0b67dd)({
        scrollLeft: 0,
        isHiddenScrollBar: true
    });
    const refState = $cQmXV.useRef({
        delta: 0,
        x: 0
    });
    const [isActive, setActive] = $cQmXV.useState(false);
    const rafRef = $cQmXV.useRef(null);
    $cQmXV.useEffect(()=>()=>{
            (0, $905c53b807de704e$export$2e2bcd8739ae039).cancel(rafRef.current);
        }, []);
    const onMouseUp = ()=>{
        setActive(false);
    };
    const onMouseDown = (event)=>{
        event.persist();
        refState.current.delta = event.pageX - scrollState.scrollLeft;
        refState.current.x = 0;
        setActive(true);
        event.preventDefault();
    };
    const onMouseMove = (event)=>{
        // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/buttons
        const { buttons: buttons } = event || window?.event;
        if (!isActive || buttons === 0) {
            // If out body mouse up, we can set isActive false when mouse move
            if (isActive) setActive(false);
            return;
        }
        let left = refState.current.x + event.pageX - refState.current.x - refState.current.delta;
        const isRTL = direction === "rtl";
        // Limit scroll range
        left = Math.max(isRTL ? scrollBarWidth - bodyWidth : 0, Math.min(isRTL ? 0 : bodyWidth - scrollBarWidth, left));
        // Calculate the scroll position and update
        const shouldScroll = !isRTL || Math.abs(left) + Math.abs(scrollBarWidth) < bodyWidth;
        if (shouldScroll) {
            onScroll({
                scrollLeft: left / bodyWidth * (bodyScrollWidth + 2)
            });
            refState.current.x = event.pageX;
        }
    };
    const checkScrollBarVisible = ()=>{
        (0, $905c53b807de704e$export$2e2bcd8739ae039).cancel(rafRef.current);
        rafRef.current = (0, $905c53b807de704e$export$2e2bcd8739ae039)(()=>{
            if (!scrollBodyRef.current) return;
            const tableOffsetTop = (0, $fc60b17434e9fa37$export$622cea445a1c5b7d)(scrollBodyRef.current).top;
            const tableBottomOffset = tableOffsetTop + scrollBodyRef.current.offsetHeight;
            const currentClientOffset = container === window ? document.documentElement.scrollTop + window.innerHeight : (0, $fc60b17434e9fa37$export$622cea445a1c5b7d)(container).top + container.clientHeight;
            if (tableBottomOffset - (0, $14f2e271a4ead6fa$export$2e2bcd8739ae039)() <= currentClientOffset || tableOffsetTop >= currentClientOffset - offsetScroll) setScrollState((state)=>({
                    ...state,
                    isHiddenScrollBar: true
                }));
            else setScrollState((state)=>({
                    ...state,
                    isHiddenScrollBar: false
                }));
        });
    };
    const setScrollLeft = (left)=>{
        setScrollState((state)=>{
            return {
                ...state,
                scrollLeft: left / bodyScrollWidth * bodyWidth || 0
            };
        });
    };
    $cQmXV.useImperativeHandle(ref, ()=>({
            setScrollLeft: setScrollLeft,
            checkScrollBarVisible: checkScrollBarVisible
        }));
    $cQmXV.useEffect(()=>{
        document.body.addEventListener($7388bac66c8edcea$var$MOUSEUP_EVENT, onMouseUp, false);
        document.body.addEventListener($7388bac66c8edcea$var$MOUSEMOVE_EVENT, onMouseMove, false);
        checkScrollBarVisible();
        return ()=>{
            document.body.removeEventListener($7388bac66c8edcea$var$MOUSEUP_EVENT, onMouseUp);
            document.body.removeEventListener($7388bac66c8edcea$var$MOUSEMOVE_EVENT, onMouseMove);
        };
    }, [
        scrollBarWidth,
        isActive
    ]);
    // Loop for scroll event check
    $cQmXV.useEffect(()=>{
        if (scrollBodyRef.current) {
            const scrollParents = [];
            let parent = (0, $d3fb35d553a86e29$export$9aa546fdc20ae5b3)(scrollBodyRef.current);
            while(parent){
                scrollParents.push(parent);
                parent = parent.parentElement;
            }
            scrollParents.forEach((p)=>{
                p.addEventListener($7388bac66c8edcea$var$SCROLL_EVENT, checkScrollBarVisible, false);
            });
            window.addEventListener($7388bac66c8edcea$var$RESIZE_EVENT, checkScrollBarVisible, false);
            window.addEventListener($7388bac66c8edcea$var$SCROLL_EVENT, checkScrollBarVisible, false);
            container.addEventListener($7388bac66c8edcea$var$SCROLL_EVENT, checkScrollBarVisible, false);
            return ()=>{
                scrollParents.forEach((p)=>{
                    p.removeEventListener($7388bac66c8edcea$var$SCROLL_EVENT, checkScrollBarVisible);
                });
                window.removeEventListener($7388bac66c8edcea$var$RESIZE_EVENT, checkScrollBarVisible);
                window.removeEventListener($7388bac66c8edcea$var$SCROLL_EVENT, checkScrollBarVisible);
                container.removeEventListener($7388bac66c8edcea$var$SCROLL_EVENT, checkScrollBarVisible);
            };
        }
    }, [
        container
    ]);
    $cQmXV.useEffect(()=>{
        if (!scrollState.isHiddenScrollBar) setScrollState((state)=>{
            const bodyNode = scrollBodyRef.current;
            if (!bodyNode) return state;
            return {
                ...state,
                scrollLeft: bodyNode.scrollLeft / bodyNode.scrollWidth * bodyNode.clientWidth
            };
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        scrollState.isHiddenScrollBar
    ]);
    if (bodyScrollWidth <= bodyWidth || !scrollBarWidth || scrollState.isHiddenScrollBar) return null;
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        style: {
            height: (0, $14f2e271a4ead6fa$export$2e2bcd8739ae039)(),
            width: bodyWidth,
            bottom: offsetScroll
        },
        className: `${prefixCls}-sticky-scroll`
    }, /*#__PURE__*/ $cQmXV.createElement("div", {
        onMouseDown: onMouseDown,
        ref: scrollBarRef,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-sticky-scroll-bar`, {
            [`${prefixCls}-sticky-scroll-bar-active`]: isActive
        }),
        style: {
            width: `${scrollBarWidth}px`,
            transform: `translate3d(${scrollState.scrollLeft}px, 0, 0)`
        }
    }));
};
var $7388bac66c8edcea$export$2e2bcd8739ae039 = /*#__PURE__*/ $cQmXV.forwardRef($7388bac66c8edcea$var$StickyScrollBar);





function $eea5fa165d97b5a0$var$_extends() {
    $eea5fa165d97b5a0$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $eea5fa165d97b5a0$var$_extends.apply(this, arguments);
}
const $eea5fa165d97b5a0$export$c42ed95a478b1ec5 = "rc-table";
// Used for conditions cache
const $eea5fa165d97b5a0$var$EMPTY_DATA = [];
// Used for customize scroll
const $eea5fa165d97b5a0$var$EMPTY_SCROLL_TARGET = {};
function $eea5fa165d97b5a0$var$defaultEmpty() {
    return "No Data";
}
const $eea5fa165d97b5a0$var$Table = (tableProps, ref)=>{
    const props = {
        rowKey: "key",
        prefixCls: $eea5fa165d97b5a0$export$c42ed95a478b1ec5,
        emptyText: $eea5fa165d97b5a0$var$defaultEmpty,
        ...tableProps
    };
    const { prefixCls: prefixCls, className: className, rowClassName: rowClassName, style: style, classNames: classNames, styles: styles, data: data, rowKey: rowKey, scroll: scroll, tableLayout: tableLayout, direction: direction, title: // Additional Part
    title, footer: footer, summary: summary, caption: caption, id: // Customize
    id, showHeader: showHeader, components: components, emptyText: emptyText, onRow: onRow, onHeaderRow: onHeaderRow, measureRowRender: // Measure Row
    measureRowRender, onScroll: // Events
    onScroll, internalHooks: // Internal
    internalHooks, transformColumns: transformColumns, internalRefs: internalRefs, tailor: tailor, getContainerWidth: getContainerWidth, sticky: sticky, rowHoverable: rowHoverable = true } = props;
    const mergedData = data || $eea5fa165d97b5a0$var$EMPTY_DATA;
    const hasData = !!mergedData.length;
    const useInternalHooks = internalHooks === (0, $9848d298b42e15e6$export$91b75cf262680225);
    var name;
    // ==================== Customize =====================
    const getComponent = $cQmXV.useCallback((path, defaultComponent)=>(0, $bb62aae17cbc8bd7$export$2e2bcd8739ae039)(components, path) || defaultComponent, [
        components
    ]);
    const getRowKey = $cQmXV.useMemo(()=>{
        if (typeof rowKey === "function") return rowKey;
        return (record)=>{
            const key = record && record[rowKey];
            return key;
        };
    }, [
        rowKey
    ]);
    const customizeScrollBody = getComponent([
        "body"
    ]);
    // ====================== Hover =======================
    const [startRow, endRow, onHover] = (0, $b3d711d6c1d69b49$export$2e2bcd8739ae039)();
    // ====================== Expand ======================
    const [expandableConfig, expandableType, mergedExpandedKeys, mergedExpandIcon, mergedChildrenColumnName, onTriggerExpand] = (0, $9829f8b019fac50e$export$2e2bcd8739ae039)(props, mergedData, getRowKey);
    // ====================== Column ======================
    const scrollX = scroll?.x;
    const [componentWidth, setComponentWidth] = $cQmXV.useState(0);
    const [columns, flattenColumns, flattenScrollX] = (0, $582dcd0e4b930539$export$2e2bcd8739ae039)({
        ...props,
        ...expandableConfig,
        expandable: !!expandableConfig.expandedRowRender,
        columnTitle: expandableConfig.columnTitle,
        expandedKeys: mergedExpandedKeys,
        getRowKey: getRowKey,
        onTriggerExpand: // https://github.com/ant-design/ant-design/issues/23894
        onTriggerExpand,
        expandIcon: mergedExpandIcon,
        expandIconColumnIndex: expandableConfig.expandIconColumnIndex,
        direction: direction,
        scrollWidth: useInternalHooks && tailor && typeof scrollX === "number" ? scrollX : null,
        clientWidth: componentWidth
    }, useInternalHooks ? transformColumns : null);
    const mergedScrollX = flattenScrollX ?? scrollX;
    const columnContext = $cQmXV.useMemo(()=>({
            columns: columns,
            flattenColumns: flattenColumns
        }), [
        columns,
        flattenColumns
    ]);
    // ======================= Refs =======================
    const fullTableRef = $cQmXV.useRef(null);
    const scrollHeaderRef = $cQmXV.useRef(null);
    const scrollBodyRef = $cQmXV.useRef(null);
    const scrollBodyContainerRef = $cQmXV.useRef(null);
    $cQmXV.useImperativeHandle(ref, ()=>{
        return {
            nativeElement: fullTableRef.current,
            scrollTo: (config)=>{
                if (scrollBodyRef.current instanceof HTMLElement) {
                    // Native scroll
                    const { index: index, top: top, key: key, offset: offset, align: align = "nearest" } = config;
                    if ((0, $435e6e552a98f20a$export$b1cd2bdabe361feb)(top)) // In top mode, offset is ignored
                    scrollBodyRef.current?.scrollTo({
                        top: top
                    });
                    else {
                        const mergedKey = key ?? getRowKey(mergedData[index]);
                        const targetElement = scrollBodyRef.current.querySelector(`[data-row-key="${mergedKey}"]`);
                        if (targetElement) {
                            targetElement.scrollIntoView({
                                block: align
                            });
                            if (offset) {
                                const container = scrollBodyRef.current;
                                container.scrollTo({
                                    top: container.scrollTop + offset
                                });
                            }
                        }
                    }
                } else if (scrollBodyRef.current?.scrollTo) // Pass to proxy
                scrollBodyRef.current.scrollTo(config);
            }
        };
    });
    // ====================== Scroll ======================
    const scrollSummaryRef = $cQmXV.useRef(null);
    const [shadowStart, setShadowStart] = $cQmXV.useState(false);
    const [shadowEnd, setShadowEnd] = $cQmXV.useState(false);
    const [colsWidths, updateColsWidths] = $cQmXV.useState(new Map());
    // Convert map to number width
    const colsKeys = (0, $435e6e552a98f20a$export$fd2ca5407d9be470)(flattenColumns);
    const pureColWidths = colsKeys.map((columnKey)=>colsWidths.get(columnKey));
    const colWidths = $cQmXV.useMemo(()=>pureColWidths, [
        pureColWidths.join("_")
    ]);
    const stickyOffsets = (0, $5e26096c6768ce4e$export$2e2bcd8739ae039)(colWidths, flattenColumns);
    const fixHeader = scroll && (0, $435e6e552a98f20a$export$b76e9316566cc26e)(scroll.y);
    const horizonScroll = scroll && (0, $435e6e552a98f20a$export$b76e9316566cc26e)(mergedScrollX) || Boolean(expandableConfig.fixed);
    const fixColumn = horizonScroll && flattenColumns.some(({ fixed: fixed })=>fixed);
    // Sticky
    const stickyRef = $cQmXV.useRef(null);
    const { isSticky: isSticky, offsetHeader: offsetHeader, offsetSummary: offsetSummary, offsetScroll: offsetScroll, stickyClassName: stickyClassName, container: container } = (0, $39bb6e08ec6a7f2c$export$2e2bcd8739ae039)(sticky, prefixCls);
    // Footer (Fix footer must fixed header)
    const summaryNode = $cQmXV.useMemo(()=>summary?.(mergedData), [
        summary,
        mergedData
    ]);
    const fixFooter = (fixHeader || isSticky) && /*#__PURE__*/ $cQmXV.isValidElement(summaryNode) && summaryNode.type === (0, $c6cee2d66e4793e6$export$2e2bcd8739ae039) && summaryNode.props.fixed;
    // Scroll
    let scrollXStyle;
    let scrollYStyle;
    let scrollTableStyle;
    if (fixHeader) scrollYStyle = {
        overflowY: hasData ? "scroll" : "auto",
        maxHeight: scroll.y
    };
    if (horizonScroll) {
        scrollXStyle = {
            overflowX: "auto"
        };
        // When no vertical scrollbar, should hide it
        // https://github.com/ant-design/ant-design/pull/20705
        // https://github.com/ant-design/ant-design/issues/21879
        if (!fixHeader) scrollYStyle = {
            overflowY: "hidden"
        };
        scrollTableStyle = {
            width: mergedScrollX === true ? "auto" : mergedScrollX,
            minWidth: "100%"
        };
    }
    const onColumnResize = $cQmXV.useCallback((columnKey, width)=>{
        updateColsWidths((widths)=>{
            if (widths.get(columnKey) !== width) {
                const newWidths = new Map(widths);
                newWidths.set(columnKey, width);
                return newWidths;
            }
            return widths;
        });
    }, []);
    const [setScrollTarget, getScrollTarget] = (0, $341756d6dd741f5e$export$d63c72d5e6d02249)(null);
    const [scrollRetryTimeoutMap] = $cQmXV.useState(()=>new WeakMap());
    function forceScroll(scrollLeft, target) {
        if (!target) return;
        if (typeof target === "function") {
            target(scrollLeft);
            return;
        }
        const scrollRetryTimeout = scrollRetryTimeoutMap.get(target);
        if (scrollRetryTimeout) clearTimeout(scrollRetryTimeout);
        if (target.scrollLeft !== scrollLeft) {
            target.scrollLeft = scrollLeft;
            // Delay to force scroll position if not sync
            // ref: https://github.com/ant-design/ant-design/issues/37179
            const retryTimeout = setTimeout(()=>{
                if (target.scrollLeft !== scrollLeft) target.scrollLeft = scrollLeft;
            }, 0);
            scrollRetryTimeoutMap.set(target, retryTimeout);
        }
    }
    const [scrollInfo, setScrollInfo] = $cQmXV.useState([
        0,
        0
    ]);
    const onInternalScroll = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)(({ currentTarget: currentTarget, scrollLeft: scrollLeft })=>{
        const mergedScrollLeft = typeof scrollLeft === "number" ? scrollLeft : currentTarget.scrollLeft;
        const compareTarget = currentTarget || $eea5fa165d97b5a0$var$EMPTY_SCROLL_TARGET;
        if (!getScrollTarget() || getScrollTarget() === compareTarget) {
            setScrollTarget(compareTarget);
            forceScroll(mergedScrollLeft, scrollHeaderRef.current);
            forceScroll(mergedScrollLeft, scrollBodyRef.current);
            forceScroll(mergedScrollLeft, scrollSummaryRef.current);
            forceScroll(mergedScrollLeft, stickyRef.current?.setScrollLeft);
        }
        const measureTarget = currentTarget || scrollHeaderRef.current;
        if (measureTarget) {
            const scrollWidth = // Should use mergedScrollX in virtual table(useInternalHooks && tailor === true)
            useInternalHooks && tailor && typeof mergedScrollX === "number" ? mergedScrollX : measureTarget.scrollWidth;
            const clientWidth = measureTarget.clientWidth;
            const absScrollStart = Math.abs(mergedScrollLeft);
            setScrollInfo((ori)=>{
                const nextScrollInfo = [
                    absScrollStart,
                    scrollWidth - clientWidth
                ];
                return (0, $3f19ee2a2ff4618a$export$2e2bcd8739ae039)(ori, nextScrollInfo) ? ori : nextScrollInfo;
            });
            // There is no space to scroll
            if (scrollWidth === clientWidth) {
                setShadowStart(false);
                setShadowEnd(false);
                return;
            }
            setShadowStart(absScrollStart > 0);
            setShadowEnd(absScrollStart < scrollWidth - clientWidth - 1);
        }
    });
    const onBodyScroll = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((e)=>{
        onInternalScroll(e);
        onScroll?.(e);
    });
    const triggerOnScroll = ()=>{
        if (horizonScroll && scrollBodyRef.current) onInternalScroll({
            currentTarget: (0, $d3fb35d553a86e29$export$9aa546fdc20ae5b3)(scrollBodyRef.current),
            scrollLeft: scrollBodyRef.current?.scrollLeft
        });
        else {
            setShadowStart(false);
            setShadowEnd(false);
        }
    };
    const onFullTableResize = (offsetWidth)=>{
        stickyRef.current?.checkScrollBarVisible();
        let mergedWidth = offsetWidth ?? fullTableRef.current?.offsetWidth ?? 0;
        if (useInternalHooks && getContainerWidth && fullTableRef.current) mergedWidth = getContainerWidth(fullTableRef.current, mergedWidth) || mergedWidth;
        if (mergedWidth !== componentWidth) {
            triggerOnScroll();
            setComponentWidth(mergedWidth);
        }
    };
    // fix https://github.com/ant-design/ant-design/issues/49279
    (0, $7673d874dab69d07$export$2e2bcd8739ae039)(()=>{
        if (horizonScroll) onFullTableResize();
    }, [
        horizonScroll
    ]);
    // Sync scroll bar when init or `horizonScroll`, `data` and `columns.length` changed
    const mounted = $cQmXV.useRef(false);
    $cQmXV.useEffect(()=>{
        // onFullTableResize will be trigger once when ResizeObserver is mounted
        // This will reduce one duplicated triggerOnScroll time
        if (mounted.current) triggerOnScroll();
    }, [
        horizonScroll,
        data,
        columns.length
    ]);
    $cQmXV.useEffect(()=>{
        mounted.current = true;
    }, []);
    // ===================== Effects ======================
    const [scrollbarSize, setScrollbarSize] = $cQmXV.useState(0);
    (0, $7673d874dab69d07$export$2e2bcd8739ae039)(()=>{
        if (!tailor || !useInternalHooks) {
            if (scrollBodyRef.current instanceof Element) setScrollbarSize((0, $14f2e271a4ead6fa$export$4f3ef2310365b56a)(scrollBodyRef.current).width);
            else setScrollbarSize((0, $14f2e271a4ead6fa$export$4f3ef2310365b56a)(scrollBodyContainerRef.current).width);
        }
    }, []);
    // ================== INTERNAL HOOKS ==================
    $cQmXV.useEffect(()=>{
        if (useInternalHooks && internalRefs) internalRefs.body.current = scrollBodyRef.current;
    });
    // ========================================================================
    // ==                               Render                               ==
    // ========================================================================
    // =================== Render: Func ===================
    const renderFixedHeaderTable = $cQmXV.useCallback((fixedHolderPassProps)=>/*#__PURE__*/ $cQmXV.createElement($cQmXV.Fragment, null, /*#__PURE__*/ $cQmXV.createElement((0, $99758f74f83ed588$export$2e2bcd8739ae039), fixedHolderPassProps), fixFooter === "top" && /*#__PURE__*/ $cQmXV.createElement((0, $a9a17de46d12194c$export$2e2bcd8739ae039), fixedHolderPassProps, summaryNode)), [
        fixFooter,
        summaryNode
    ]);
    const renderFixedFooterTable = $cQmXV.useCallback((fixedHolderPassProps)=>/*#__PURE__*/ $cQmXV.createElement((0, $a9a17de46d12194c$export$2e2bcd8739ae039), fixedHolderPassProps, summaryNode), [
        summaryNode
    ]);
    // =================== Render: Node ===================
    const TableComponent = getComponent([
        "table"
    ], "table");
    // Table layout
    const mergedTableLayout = $cQmXV.useMemo(()=>{
        if (tableLayout) return tableLayout;
        // https://github.com/ant-design/ant-design/issues/25227
        // When scroll.x is max-content, no need to fix table layout
        // it's width should stretch out to fit content
        if (fixColumn) return mergedScrollX === "max-content" ? "auto" : "fixed";
        if (fixHeader || isSticky || flattenColumns.some(({ ellipsis: ellipsis })=>ellipsis)) return "fixed";
        return "auto";
    }, [
        fixHeader,
        fixColumn,
        flattenColumns,
        tableLayout,
        isSticky
    ]);
    let groupTableNode;
    // Header props
    const headerProps = {
        colWidths: colWidths,
        columCount: flattenColumns.length,
        stickyOffsets: stickyOffsets,
        onHeaderRow: onHeaderRow,
        fixHeader: fixHeader,
        scroll: scroll
    };
    // Empty
    const emptyNode = $cQmXV.useMemo(()=>{
        if (hasData) return null;
        if (typeof emptyText === "function") return emptyText();
        return emptyText;
    }, [
        hasData,
        emptyText
    ]);
    // Body
    const bodyTable = /*#__PURE__*/ $cQmXV.createElement((0, $a273a480146db45f$export$2e2bcd8739ae039), {
        data: mergedData,
        measureColumnWidth: fixHeader || horizonScroll || isSticky
    });
    const bodyColGroup = /*#__PURE__*/ $cQmXV.createElement((0, $4ee844eec16001e9$export$2e2bcd8739ae039), {
        colWidths: flattenColumns.map(({ width: width })=>width),
        columns: flattenColumns
    });
    const captionElement = caption !== null && caption !== undefined ? /*#__PURE__*/ $cQmXV.createElement("caption", {
        className: `${prefixCls}-caption`
    }, caption) : undefined;
    const dataProps = (0, $4b5c733d1d7bb306$export$2e2bcd8739ae039)(props, {
        data: true
    });
    const ariaProps = (0, $4b5c733d1d7bb306$export$2e2bcd8739ae039)(props, {
        aria: true
    });
    if (fixHeader || isSticky) {
        // >>>>>> Fixed Header
        let bodyContent;
        if (typeof customizeScrollBody === "function") {
            bodyContent = customizeScrollBody(mergedData, {
                scrollbarSize: scrollbarSize,
                ref: scrollBodyRef,
                onScroll: onInternalScroll
            });
            headerProps.colWidths = flattenColumns.map(({ width: width }, index)=>{
                const colWidth = index === flattenColumns.length - 1 ? width - scrollbarSize : width;
                if (typeof colWidth === "number" && !Number.isNaN(colWidth)) return colWidth;
                return 0;
            });
        } else bodyContent = /*#__PURE__*/ $cQmXV.createElement("div", {
            style: {
                ...scrollXStyle,
                ...scrollYStyle
            },
            onScroll: onBodyScroll,
            ref: scrollBodyRef,
            className: `${prefixCls}-body`
        }, /*#__PURE__*/ $cQmXV.createElement(TableComponent, $eea5fa165d97b5a0$var$_extends({
            style: {
                ...scrollTableStyle,
                tableLayout: mergedTableLayout
            }
        }, ariaProps), captionElement, bodyColGroup, bodyTable, !fixFooter && summaryNode && /*#__PURE__*/ $cQmXV.createElement((0, $a9a17de46d12194c$export$2e2bcd8739ae039), {
            stickyOffsets: stickyOffsets,
            flattenColumns: flattenColumns
        }, summaryNode)));
        // Fixed holder share the props
        const fixedHolderProps = {
            noData: !mergedData.length,
            maxContentScroll: horizonScroll && mergedScrollX === "max-content",
            ...headerProps,
            ...columnContext,
            direction: direction,
            stickyClassName: stickyClassName,
            scrollX: mergedScrollX,
            tableLayout: mergedTableLayout,
            onScroll: onInternalScroll
        };
        groupTableNode = /*#__PURE__*/ $cQmXV.createElement($cQmXV.Fragment, null, showHeader !== false && /*#__PURE__*/ $cQmXV.createElement((0, $7e53d259ab703a1d$export$2e2bcd8739ae039), $eea5fa165d97b5a0$var$_extends({}, fixedHolderProps, {
            stickyTopOffset: offsetHeader,
            className: `${prefixCls}-header`,
            ref: scrollHeaderRef,
            colGroup: bodyColGroup
        }), renderFixedHeaderTable), bodyContent, fixFooter && fixFooter !== "top" && /*#__PURE__*/ $cQmXV.createElement((0, $7e53d259ab703a1d$export$2e2bcd8739ae039), $eea5fa165d97b5a0$var$_extends({}, fixedHolderProps, {
            stickyBottomOffset: offsetSummary,
            className: `${prefixCls}-summary`,
            ref: scrollSummaryRef,
            colGroup: bodyColGroup
        }), renderFixedFooterTable), isSticky && scrollBodyRef.current && scrollBodyRef.current instanceof Element && /*#__PURE__*/ $cQmXV.createElement((0, $7388bac66c8edcea$export$2e2bcd8739ae039), {
            ref: stickyRef,
            offsetScroll: offsetScroll,
            scrollBodyRef: scrollBodyRef,
            onScroll: onInternalScroll,
            container: container,
            direction: direction
        }));
    } else // >>>>>> Unique table
    groupTableNode = /*#__PURE__*/ $cQmXV.createElement("div", {
        style: {
            ...scrollXStyle,
            ...scrollYStyle,
            ...styles?.content
        },
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-content`, classNames?.content),
        onScroll: onInternalScroll,
        ref: scrollBodyRef
    }, /*#__PURE__*/ $cQmXV.createElement(TableComponent, $eea5fa165d97b5a0$var$_extends({
        style: {
            ...scrollTableStyle,
            tableLayout: mergedTableLayout
        }
    }, ariaProps), captionElement, bodyColGroup, showHeader !== false && /*#__PURE__*/ $cQmXV.createElement((0, $99758f74f83ed588$export$2e2bcd8739ae039), $eea5fa165d97b5a0$var$_extends({}, headerProps, columnContext)), bodyTable, summaryNode && /*#__PURE__*/ $cQmXV.createElement((0, $a9a17de46d12194c$export$2e2bcd8739ae039), {
        stickyOffsets: stickyOffsets,
        flattenColumns: flattenColumns
    }, summaryNode)));
    const tableStyle = {
        ...style
    };
    // Add css var for sticky header `zIndex` calc
    if (isSticky) tableStyle["--columns-count"] = flattenColumns.length;
    let fullTable = /*#__PURE__*/ $cQmXV.createElement("div", $eea5fa165d97b5a0$var$_extends({
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, className, {
            [`${prefixCls}-rtl`]: direction === "rtl",
            [`${prefixCls}-fix-start-shadow`]: horizonScroll,
            [`${prefixCls}-fix-end-shadow`]: horizonScroll,
            [`${prefixCls}-fix-start-shadow-show`]: horizonScroll && shadowStart,
            [`${prefixCls}-fix-end-shadow-show`]: horizonScroll && shadowEnd,
            [`${prefixCls}-layout-fixed`]: tableLayout === "fixed",
            [`${prefixCls}-fixed-header`]: fixHeader,
            /** No used but for compatible */ [`${prefixCls}-fixed-column`]: fixColumn,
            [`${prefixCls}-scroll-horizontal`]: horizonScroll,
            [`${prefixCls}-has-fix-start`]: flattenColumns[0]?.fixed,
            [`${prefixCls}-has-fix-end`]: flattenColumns[flattenColumns.length - 1]?.fixed === "end"
        }),
        style: tableStyle,
        id: id,
        ref: fullTableRef
    }, dataProps), title && /*#__PURE__*/ $cQmXV.createElement((0, $36c0ba3ebcfe8d04$export$2e2bcd8739ae039), {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-title`, classNames?.title),
        style: styles?.title
    }, title(mergedData)), /*#__PURE__*/ $cQmXV.createElement("div", {
        ref: scrollBodyContainerRef,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-container`, classNames?.section),
        style: styles?.section
    }, groupTableNode), footer && /*#__PURE__*/ $cQmXV.createElement((0, $36c0ba3ebcfe8d04$export$2e2bcd8739ae039), {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-footer`, classNames?.footer),
        style: styles?.footer
    }, footer(mergedData)));
    if (horizonScroll) fullTable = /*#__PURE__*/ $cQmXV.createElement((0, $1d6306c05e604045$export$2e2bcd8739ae039), {
        onResize: ({ offsetWidth: offsetWidth })=>onFullTableResize(offsetWidth)
    }, fullTable);
    const fixedInfoList = (0, $e44eebfb7e673e63$export$2e2bcd8739ae039)(flattenColumns, stickyOffsets);
    const TableContextValue = $cQmXV.useMemo(()=>({
            // Scroll
            scrollX: mergedScrollX,
            scrollInfo: scrollInfo,
            classNames: classNames,
            styles: styles,
            prefixCls: // Table
            prefixCls,
            getComponent: getComponent,
            scrollbarSize: scrollbarSize,
            direction: direction,
            fixedInfoList: fixedInfoList,
            isSticky: isSticky,
            componentWidth: componentWidth,
            fixHeader: fixHeader,
            fixColumn: fixColumn,
            horizonScroll: horizonScroll,
            // Body
            tableLayout: mergedTableLayout,
            rowClassName: rowClassName,
            expandedRowClassName: expandableConfig.expandedRowClassName,
            expandIcon: mergedExpandIcon,
            expandableType: expandableType,
            expandRowByClick: expandableConfig.expandRowByClick,
            expandedRowRender: expandableConfig.expandedRowRender,
            forceRender: expandableConfig.forceRender ?? false,
            expandedRowOffset: expandableConfig.expandedRowOffset,
            onTriggerExpand: onTriggerExpand,
            expandIconColumnIndex: expandableConfig.expandIconColumnIndex,
            indentSize: expandableConfig.indentSize,
            allColumnsFixedLeft: flattenColumns.every((col)=>col.fixed === "start"),
            emptyNode: emptyNode,
            columns: // Column
            columns,
            flattenColumns: flattenColumns,
            onColumnResize: onColumnResize,
            colWidths: colWidths,
            // Row
            hoverStartRow: startRow,
            hoverEndRow: endRow,
            onHover: onHover,
            rowExpandable: expandableConfig.rowExpandable,
            onRow: onRow,
            getRowKey: getRowKey,
            expandedKeys: mergedExpandedKeys,
            childrenColumnName: mergedChildrenColumnName,
            rowHoverable: rowHoverable,
            measureRowRender: // Measure Row
            measureRowRender
        }), [
        // Scroll
        mergedScrollX,
        scrollInfo,
        classNames,
        styles,
        // Table
        prefixCls,
        getComponent,
        scrollbarSize,
        direction,
        fixedInfoList,
        isSticky,
        componentWidth,
        fixHeader,
        fixColumn,
        horizonScroll,
        // Body
        mergedTableLayout,
        rowClassName,
        expandableConfig.expandedRowClassName,
        mergedExpandIcon,
        expandableType,
        expandableConfig.expandRowByClick,
        expandableConfig.expandedRowRender,
        expandableConfig.forceRender,
        expandableConfig.expandedRowOffset,
        onTriggerExpand,
        expandableConfig.expandIconColumnIndex,
        expandableConfig.indentSize,
        emptyNode,
        // Column
        columns,
        flattenColumns,
        onColumnResize,
        colWidths,
        // Row
        startRow,
        endRow,
        onHover,
        expandableConfig.rowExpandable,
        onRow,
        getRowKey,
        mergedExpandedKeys,
        mergedChildrenColumnName,
        rowHoverable,
        measureRowRender
    ]);
    return /*#__PURE__*/ $cQmXV.createElement((0, $8ff93ffc4f10aaf4$export$2e2bcd8739ae039).Provider, {
        value: TableContextValue
    }, fullTable);
};
const $eea5fa165d97b5a0$var$RefTable = /*#__PURE__*/ $cQmXV.forwardRef($eea5fa165d97b5a0$var$Table);
const $eea5fa165d97b5a0$export$13da147d1fdf3e3c = (shouldTriggerRender)=>{
    return (0, $8ff93ffc4f10aaf4$export$ffd6d5bef5eaf0a4)($eea5fa165d97b5a0$var$RefTable, shouldTriggerRender);
};
const $eea5fa165d97b5a0$var$ImmutableTable = $eea5fa165d97b5a0$export$13da147d1fdf3e3c();
$eea5fa165d97b5a0$var$ImmutableTable.EXPAND_COLUMN = (0, $9848d298b42e15e6$export$e1053575ddfcb301);
$eea5fa165d97b5a0$var$ImmutableTable.INTERNAL_HOOKS = (0, $9848d298b42e15e6$export$91b75cf262680225);
$eea5fa165d97b5a0$var$ImmutableTable.Column = (0, $083980fbff62992e$export$2e2bcd8739ae039);
$eea5fa165d97b5a0$var$ImmutableTable.ColumnGroup = (0, $3b02a9334ab90b52$export$2e2bcd8739ae039);
$eea5fa165d97b5a0$var$ImmutableTable.Summary = (0, $a9a17de46d12194c$export$d605f3af09eef683);
var $eea5fa165d97b5a0$export$2e2bcd8739ae039 = $eea5fa165d97b5a0$var$ImmutableTable;






var $cQmXV = parcelRequire("cQmXV");








var $cQmXV = parcelRequire("cQmXV");

var $3h5eW = parcelRequire("3h5eW");

var $cQmXV = parcelRequire("cQmXV");


function $19ebe74c3da0ce8f$var$_extends() {
    $19ebe74c3da0ce8f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $19ebe74c3da0ce8f$var$_extends.apply(this, arguments);
}
/**
 * Fill component to provided the scroll content real height.
 */ const $19ebe74c3da0ce8f$var$Filler = /*#__PURE__*/ $cQmXV.forwardRef(({ height: height, offsetY: offsetY, offsetX: offsetX, children: children, prefixCls: prefixCls, onInnerResize: onInnerResize, innerProps: innerProps, rtl: rtl, extra: extra }, ref)=>{
    let outerStyle = {};
    let innerStyle = {
        display: "flex",
        flexDirection: "column"
    };
    if (offsetY !== undefined) {
        // Not set `width` since this will break `sticky: right`
        outerStyle = {
            height: height,
            position: "relative",
            overflow: "hidden"
        };
        innerStyle = {
            ...innerStyle,
            transform: `translateY(${offsetY}px)`,
            [rtl ? "marginRight" : "marginLeft"]: -offsetX,
            position: "absolute",
            left: 0,
            right: 0,
            top: 0
        };
    }
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        style: outerStyle
    }, /*#__PURE__*/ $cQmXV.createElement((0, $1d6306c05e604045$export$2e2bcd8739ae039), {
        onResize: ({ offsetHeight: offsetHeight })=>{
            if (offsetHeight && onInnerResize) onInnerResize();
        }
    }, /*#__PURE__*/ $cQmXV.createElement("div", $19ebe74c3da0ce8f$var$_extends({
        style: innerStyle,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)({
            [`${prefixCls}-holder-inner`]: prefixCls
        }),
        ref: ref
    }, innerProps), children, extra)));
});
$19ebe74c3da0ce8f$var$Filler.displayName = "Filler";
var $19ebe74c3da0ce8f$export$2e2bcd8739ae039 = $19ebe74c3da0ce8f$var$Filler;



var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");
function $a58e91f0afc814e1$export$6d08773d2e66f8f2({ children: children, setRef: setRef }) {
    const refFunc = $cQmXV.useCallback((node)=>{
        setRef(node);
    }, [
        setRef
    ]);
    return /*#__PURE__*/ $cQmXV.cloneElement(children, {
        ref: refFunc
    });
}


function $2d65b79d651f2d8b$export$2e2bcd8739ae039(list, startIndex, endIndex, scrollWidth, offsetX, setNodeRef, renderFunc, { getKey: getKey }) {
    return list.slice(startIndex, endIndex + 1).map((item, index)=>{
        const eleIndex = startIndex + index;
        const node = renderFunc(item, eleIndex, {
            style: {
                width: scrollWidth
            },
            offsetX: offsetX
        });
        const key = getKey(item);
        return /*#__PURE__*/ $cQmXV.createElement((0, $a58e91f0afc814e1$export$6d08773d2e66f8f2), {
            key: key,
            setRef: (ele)=>setNodeRef(item, ele)
        }, node);
    });
}



var $cQmXV = parcelRequire("cQmXV");
/**
 * Get index with specific start index one by one. e.g.
 * min: 3, max: 9, start: 6
 *
 * Return index is:
 * [0]: 6
 * [1]: 7
 * [2]: 5
 * [3]: 8
 * [4]: 4
 * [5]: 9
 * [6]: 3
 */ function $05e60afd20173c0a$export$38f9023d45dd4a23(min, max, start, index) {
    const beforeCount = start - min;
    const afterCount = max - start;
    const balanceCount = Math.min(beforeCount, afterCount) * 2;
    // Balance
    if (index <= balanceCount) {
        const stepIndex = Math.floor(index / 2);
        if (index % 2) return start + stepIndex + 1;
        return start - stepIndex;
    }
    // One is out of range
    if (beforeCount > afterCount) return start - (index - afterCount);
    return start + (index - beforeCount);
}
function $05e60afd20173c0a$export$418b8d8b03eefdf5(originList, targetList, getKey) {
    const originLen = originList.length;
    const targetLen = targetList.length;
    let shortList;
    let longList;
    if (originLen === 0 && targetLen === 0) return null;
    if (originLen < targetLen) {
        shortList = originList;
        longList = targetList;
    } else {
        shortList = targetList;
        longList = originList;
    }
    const notExistKey = {
        __EMPTY_ITEM__: true
    };
    function getItemKey(item) {
        if (item !== undefined) return getKey(item);
        return notExistKey;
    }
    // Loop to find diff one
    let diffIndex = null;
    let multiple = Math.abs(originLen - targetLen) !== 1;
    for(let i = 0; i < longList.length; i += 1){
        const shortKey = getItemKey(shortList[i]);
        const longKey = getItemKey(longList[i]);
        if (shortKey !== longKey) {
            diffIndex = i;
            multiple = multiple || shortKey !== getItemKey(longList[i + 1]);
            break;
        }
    }
    return diffIndex === null ? null : {
        index: diffIndex,
        multiple: multiple
    };
}


function $769026c2a70b5f1b$export$2e2bcd8739ae039(data, getKey, onDiff) {
    const [prevData, setPrevData] = $cQmXV.useState(data);
    const [diffItem, setDiffItem] = $cQmXV.useState(null);
    $cQmXV.useEffect(()=>{
        const diff = (0, $05e60afd20173c0a$export$418b8d8b03eefdf5)(prevData || [], data || [], getKey);
        if (diff?.index !== undefined) {
            onDiff?.(diff.index);
            setDiffItem(data[diff.index]);
        }
        setPrevData(data);
    }, [
        data
    ]);
    return [
        diffItem
    ];
}




var $cQmXV = parcelRequire("cQmXV");
const $4b01b2470de51941$var$isFF = typeof navigator === "object" && /Firefox/i.test(navigator.userAgent);
var $4b01b2470de51941$export$2e2bcd8739ae039 = $4b01b2470de51941$var$isFF;



var $cQmXV = parcelRequire("cQmXV");
var $0f5a2a86eabfa2b4$export$2e2bcd8739ae039 = (isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight)=>{
    // Do lock for a wheel when scrolling
    const lockRef = (0, $cQmXV.useRef)(false);
    const lockTimeoutRef = (0, $cQmXV.useRef)(null);
    function lockScroll() {
        clearTimeout(lockTimeoutRef.current);
        lockRef.current = true;
        lockTimeoutRef.current = setTimeout(()=>{
            lockRef.current = false;
        }, 50);
    }
    // Pass to ref since global add is in closure
    const scrollPingRef = (0, $cQmXV.useRef)({
        top: isScrollAtTop,
        bottom: isScrollAtBottom,
        left: isScrollAtLeft,
        right: isScrollAtRight
    });
    scrollPingRef.current.top = isScrollAtTop;
    scrollPingRef.current.bottom = isScrollAtBottom;
    scrollPingRef.current.left = isScrollAtLeft;
    scrollPingRef.current.right = isScrollAtRight;
    return (isHorizontal, delta, smoothOffset = false)=>{
        const originScroll = isHorizontal ? // Pass origin wheel when on the left
        delta < 0 && scrollPingRef.current.left || // Pass origin wheel when on the right
        delta > 0 && scrollPingRef.current.right // Pass origin wheel when on the top
         : delta < 0 && scrollPingRef.current.top || // Pass origin wheel when on the bottom
        delta > 0 && scrollPingRef.current.bottom;
        if (smoothOffset && originScroll) {
            // No need lock anymore when it's smooth offset from touchMove interval
            clearTimeout(lockTimeoutRef.current);
            lockRef.current = false;
        } else if (!originScroll || lockRef.current) lockScroll();
        return !lockRef.current && originScroll;
    };
};


function $4455ce171004e236$export$2e2bcd8739ae039(inVirtual, isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight, horizontalScroll, /***
 * Return `true` when you need to prevent default event
 */ onWheelDelta) {
    const offsetRef = (0, $cQmXV.useRef)(0);
    const nextFrameRef = (0, $cQmXV.useRef)(null);
    // Firefox patch
    const wheelValueRef = (0, $cQmXV.useRef)(null);
    const isMouseScrollRef = (0, $cQmXV.useRef)(false);
    // Scroll status sync
    const originScroll = (0, $0f5a2a86eabfa2b4$export$2e2bcd8739ae039)(isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight);
    function onWheelY(e, deltaY) {
        (0, $905c53b807de704e$export$2e2bcd8739ae039).cancel(nextFrameRef.current);
        // Do nothing when scroll at the edge, Skip check when is in scroll
        if (originScroll(false, deltaY)) return;
        // Skip if nest List has handled this event
        const event = e;
        if (!event._virtualHandled) event._virtualHandled = true;
        else return;
        offsetRef.current += deltaY;
        wheelValueRef.current = deltaY;
        // Proxy of scroll events
        if (!(0, $4b01b2470de51941$export$2e2bcd8739ae039)) event.preventDefault();
        nextFrameRef.current = (0, $905c53b807de704e$export$2e2bcd8739ae039)(()=>{
            // Patch a multiple for Firefox to fix wheel number too small
            // ref: https://github.com/ant-design/ant-design/issues/26372#issuecomment-679460266
            const patchMultiple = isMouseScrollRef.current ? 10 : 1;
            onWheelDelta(offsetRef.current * patchMultiple, false);
            offsetRef.current = 0;
        });
    }
    function onWheelX(event, deltaX) {
        onWheelDelta(deltaX, true);
        if (!(0, $4b01b2470de51941$export$2e2bcd8739ae039)) event.preventDefault();
    }
    // Check for which direction does wheel do. `sx` means `shift + wheel`
    const wheelDirectionRef = (0, $cQmXV.useRef)(null);
    const wheelDirectionCleanRef = (0, $cQmXV.useRef)(null);
    function onWheel(event) {
        if (!inVirtual) return;
        // Wait for 2 frame to clean direction
        (0, $905c53b807de704e$export$2e2bcd8739ae039).cancel(wheelDirectionCleanRef.current);
        wheelDirectionCleanRef.current = (0, $905c53b807de704e$export$2e2bcd8739ae039)(()=>{
            wheelDirectionRef.current = null;
        }, 2);
        const { deltaX: deltaX, deltaY: deltaY, shiftKey: shiftKey } = event;
        let mergedDeltaX = deltaX;
        let mergedDeltaY = deltaY;
        if (wheelDirectionRef.current === "sx" || !wheelDirectionRef.current && (shiftKey || false) && deltaY && !deltaX) {
            mergedDeltaX = deltaY;
            mergedDeltaY = 0;
            wheelDirectionRef.current = "sx";
        }
        const absX = Math.abs(mergedDeltaX);
        const absY = Math.abs(mergedDeltaY);
        if (wheelDirectionRef.current === null) wheelDirectionRef.current = horizontalScroll && absX > absY ? "x" : "y";
        if (wheelDirectionRef.current === "y") onWheelY(event, mergedDeltaY);
        else onWheelX(event, mergedDeltaX);
    }
    // A patch for firefox
    function onFireFoxScroll(event) {
        if (!inVirtual) return;
        isMouseScrollRef.current = event.detail === wheelValueRef.current;
    }
    return [
        onWheel,
        onFireFoxScroll
    ];
}



var $cQmXV = parcelRequire("cQmXV");
function $1a32278096d38b1d$export$a1d82723752af087(mergedData, getKey, heights, itemHeight) {
    const [key2Index, bottomList] = $cQmXV.useMemo(()=>[
            new Map(),
            []
        ], [
        mergedData,
        heights.id,
        itemHeight
    ]);
    const getSize = (startKey, endKey = startKey)=>{
        // Get from cache first
        let startIndex = key2Index.get(startKey);
        let endIndex = key2Index.get(endKey);
        // Loop to fill the cache
        if (startIndex === undefined || endIndex === undefined) {
            const dataLen = mergedData.length;
            for(let i = bottomList.length; i < dataLen; i += 1){
                const item = mergedData[i];
                const key = getKey(item);
                key2Index.set(key, i);
                const cacheHeight = heights.get(key) ?? itemHeight;
                bottomList[i] = (bottomList[i - 1] || 0) + cacheHeight;
                if (key === startKey) startIndex = i;
                if (key === endKey) endIndex = i;
                if (startIndex !== undefined && endIndex !== undefined) break;
            }
        }
        return {
            top: bottomList[startIndex - 1] || 0,
            bottom: bottomList[endIndex]
        };
    };
    return getSize;
}



var $cQmXV = parcelRequire("cQmXV");
// Firefox has low performance of map.
class $8391bc245dc570f8$var$CacheMap {
    maps;
    // Used for cache key
    // `useMemo` no need to update if `id` not change
    id = 0;
    diffRecords = new Map();
    constructor(){
        this.maps = Object.create(null);
    }
    set(key, value) {
        // Record prev value
        this.diffRecords.set(key, this.maps[key]);
        this.maps[key] = value;
        this.id += 1;
    }
    get(key) {
        return this.maps[key];
    }
    /**
   * CacheMap will record the key changed.
   * To help to know what's update in the next render.
   */ resetRecord() {
        this.diffRecords.clear();
    }
    getRecord() {
        return this.diffRecords;
    }
}
var $8391bc245dc570f8$export$2e2bcd8739ae039 = $8391bc245dc570f8$var$CacheMap;


function $315cb379062ce934$var$parseNumber(value) {
    const num = parseFloat(value);
    return isNaN(num) ? 0 : num;
}
function $315cb379062ce934$export$2e2bcd8739ae039(getKey, onItemAdd, onItemRemove) {
    const [updatedMark, setUpdatedMark] = $cQmXV.useState(0);
    const instanceRef = (0, $cQmXV.useRef)(new Map());
    const heightsRef = (0, $cQmXV.useRef)(new (0, $8391bc245dc570f8$export$2e2bcd8739ae039)());
    const promiseIdRef = (0, $cQmXV.useRef)(0);
    function cancelRaf() {
        promiseIdRef.current += 1;
    }
    function collectHeight(sync = false) {
        cancelRaf();
        const doCollect = ()=>{
            let changed = false;
            instanceRef.current.forEach((element, key)=>{
                if (element && element.offsetParent) {
                    const { offsetHeight: offsetHeight } = element;
                    const { marginTop: marginTop, marginBottom: marginBottom } = getComputedStyle(element);
                    const marginTopNum = $315cb379062ce934$var$parseNumber(marginTop);
                    const marginBottomNum = $315cb379062ce934$var$parseNumber(marginBottom);
                    const totalHeight = offsetHeight + marginTopNum + marginBottomNum;
                    if (heightsRef.current.get(key) !== totalHeight) {
                        heightsRef.current.set(key, totalHeight);
                        changed = true;
                    }
                }
            });
            // Always trigger update mark to tell parent that should re-calculate heights when resized
            if (changed) setUpdatedMark((c)=>c + 1);
        };
        if (sync) doCollect();
        else {
            promiseIdRef.current += 1;
            const id = promiseIdRef.current;
            Promise.resolve().then(()=>{
                if (id === promiseIdRef.current) doCollect();
            });
        }
    }
    function setInstanceRef(item, instance) {
        const key = getKey(item);
        const origin = instanceRef.current.get(key);
        if (instance) {
            instanceRef.current.set(key, instance);
            collectHeight();
        } else instanceRef.current.delete(key);
        // Instance changed
        if (!origin !== !instance) {
            if (instance) onItemAdd?.(item);
            else onItemRemove?.(item);
        }
    }
    (0, $cQmXV.useEffect)(()=>{
        return cancelRaf;
    }, []);
    return [
        setInstanceRef,
        collectHeight,
        heightsRef.current,
        updatedMark
    ];
}




var $cQmXV = parcelRequire("cQmXV");
const $cb59dff4496add05$var$SMOOTH_PTG = 14 / 15;
function $cb59dff4496add05$export$2e2bcd8739ae039(inVirtual, listRef, callback) {
    const touchedRef = (0, $cQmXV.useRef)(false);
    const touchXRef = (0, $cQmXV.useRef)(0);
    const touchYRef = (0, $cQmXV.useRef)(0);
    const elementRef = (0, $cQmXV.useRef)(null);
    // Smooth scroll
    const intervalRef = (0, $cQmXV.useRef)(null);
    /* eslint-disable prefer-const */ let cleanUpEvents;
    const onTouchMove = (e)=>{
        if (touchedRef.current) {
            const currentX = Math.ceil(e.touches[0].pageX);
            const currentY = Math.ceil(e.touches[0].pageY);
            let offsetX = touchXRef.current - currentX;
            let offsetY = touchYRef.current - currentY;
            const isHorizontal = Math.abs(offsetX) > Math.abs(offsetY);
            if (isHorizontal) touchXRef.current = currentX;
            else touchYRef.current = currentY;
            const scrollHandled = callback(isHorizontal, isHorizontal ? offsetX : offsetY, false, e);
            if (scrollHandled) e.preventDefault();
            // Smooth interval
            clearInterval(intervalRef.current);
            if (scrollHandled) intervalRef.current = setInterval(()=>{
                if (isHorizontal) offsetX *= $cb59dff4496add05$var$SMOOTH_PTG;
                else offsetY *= $cb59dff4496add05$var$SMOOTH_PTG;
                const offset = Math.floor(isHorizontal ? offsetX : offsetY);
                if (!callback(isHorizontal, offset, true) || Math.abs(offset) <= 0.1) clearInterval(intervalRef.current);
            }, 16);
        }
    };
    const onTouchEnd = ()=>{
        touchedRef.current = false;
        cleanUpEvents();
    };
    const onTouchStart = (e)=>{
        cleanUpEvents();
        if (e.touches.length === 1 && !touchedRef.current) {
            touchedRef.current = true;
            touchXRef.current = Math.ceil(e.touches[0].pageX);
            touchYRef.current = Math.ceil(e.touches[0].pageY);
            elementRef.current = e.target;
            elementRef.current.addEventListener("touchmove", onTouchMove, {
                passive: false
            });
            elementRef.current.addEventListener("touchend", onTouchEnd, {
                passive: true
            });
        }
    };
    cleanUpEvents = ()=>{
        if (elementRef.current) {
            elementRef.current.removeEventListener("touchmove", onTouchMove);
            elementRef.current.removeEventListener("touchend", onTouchEnd);
        }
    };
    (0, $7673d874dab69d07$export$2e2bcd8739ae039)(()=>{
        if (inVirtual) listRef.current.addEventListener("touchstart", onTouchStart, {
            passive: true
        });
        return ()=>{
            listRef.current?.removeEventListener("touchstart", onTouchStart);
            cleanUpEvents();
            clearInterval(intervalRef.current);
        };
    }, [
        inVirtual
    ]);
}





var $cQmXV = parcelRequire("cQmXV");
function $eccb9d9a7888a0eb$var$smoothScrollOffset(offset) {
    return Math.floor(offset ** 0.5);
}
function $eccb9d9a7888a0eb$export$dbd0143e191dc2e5(e, horizontal) {
    const obj = "touches" in e ? e.touches[0] : e;
    return obj[horizontal ? "pageX" : "pageY"] - window[horizontal ? "scrollX" : "scrollY"];
}
function $eccb9d9a7888a0eb$export$2e2bcd8739ae039(inVirtual, componentRef, onScrollOffset) {
    $cQmXV.useEffect(()=>{
        const ele = componentRef.current;
        if (inVirtual && ele) {
            let mouseDownLock = false;
            let rafId;
            let offset;
            const stopScroll = ()=>{
                (0, $905c53b807de704e$export$2e2bcd8739ae039).cancel(rafId);
            };
            const continueScroll = ()=>{
                stopScroll();
                rafId = (0, $905c53b807de704e$export$2e2bcd8739ae039)(()=>{
                    onScrollOffset(offset);
                    continueScroll();
                });
            };
            const clearDragState = ()=>{
                mouseDownLock = false;
                stopScroll();
            };
            const onMouseDown = (e)=>{
                // Skip if element set draggable
                if (e.target.draggable || e.button !== 0) return;
                // Skip if nest List has handled this event
                const event = e;
                if (!event._virtualHandled) {
                    event._virtualHandled = true;
                    mouseDownLock = true;
                }
            };
            const onMouseMove = (e)=>{
                if (mouseDownLock) {
                    const mouseY = $eccb9d9a7888a0eb$export$dbd0143e191dc2e5(e, false);
                    const { top: top, bottom: bottom } = ele.getBoundingClientRect();
                    if (mouseY <= top) {
                        const diff = top - mouseY;
                        offset = -$eccb9d9a7888a0eb$var$smoothScrollOffset(diff);
                        continueScroll();
                    } else if (mouseY >= bottom) {
                        const diff = mouseY - bottom;
                        offset = $eccb9d9a7888a0eb$var$smoothScrollOffset(diff);
                        continueScroll();
                    } else stopScroll();
                }
            };
            ele.addEventListener("mousedown", onMouseDown);
            ele.ownerDocument.addEventListener("mouseup", clearDragState);
            ele.ownerDocument.addEventListener("mousemove", onMouseMove);
            ele.ownerDocument.addEventListener("dragend", clearDragState);
            return ()=>{
                ele.removeEventListener("mousedown", onMouseDown);
                ele.ownerDocument.removeEventListener("mouseup", clearDragState);
                ele.ownerDocument.removeEventListener("mousemove", onMouseMove);
                ele.ownerDocument.removeEventListener("dragend", clearDragState);
                stopScroll();
            };
        }
    }, [
        inVirtual
    ]);
}



var $cQmXV = parcelRequire("cQmXV");

const $1138e5d3e2733f61$var$MAX_TIMES = 10;
function $1138e5d3e2733f61$var$getOffset(rawOffset, info) {
    const resolvedOffset = typeof rawOffset === "function" ? rawOffset(info) : rawOffset;
    return Number.isFinite(resolvedOffset) ? resolvedOffset : 0;
}
function $1138e5d3e2733f61$export$2e2bcd8739ae039(containerRef, data, heights, itemHeight, getKey, getSize, collectHeight, syncScrollTop, triggerFlash) {
    const scrollRef = $cQmXV.useRef(undefined);
    const [syncState, setSyncState] = $cQmXV.useState(null);
    // ========================== Sync Scroll ==========================
    (0, $7673d874dab69d07$export$2e2bcd8739ae039)(()=>{
        if (syncState && syncState.times < $1138e5d3e2733f61$var$MAX_TIMES) {
            // Never reach
            if (!containerRef.current) {
                setSyncState((ori)=>({
                        ...ori
                    }));
                return;
            }
            collectHeight();
            const { targetAlign: targetAlign, originAlign: originAlign, offset: rawOffset } = syncState;
            const index = syncState.index >= 0 ? syncState.index : data.findIndex((item)=>getKey(item) === syncState.key);
            const mergedAlign = targetAlign || originAlign;
            const offset = $1138e5d3e2733f61$var$getOffset(rawOffset, {
                getSize: getSize,
                align: mergedAlign
            });
            const height = containerRef.current.clientHeight;
            let needCollectHeight = index < 0;
            let newTargetAlign = targetAlign;
            let targetTop = null;
            // Go to next frame if height not exist
            if (height && index >= 0) {
                // Get top & bottom
                let stackTop = 0;
                let itemTop = 0;
                let itemBottom = 0;
                const maxLen = Math.min(data.length - 1, index);
                for(let i = 0; i <= maxLen; i += 1){
                    const key = getKey(data[i]);
                    itemTop = stackTop;
                    const cacheHeight = heights.get(key);
                    itemBottom = itemTop + (cacheHeight === undefined ? itemHeight : cacheHeight);
                    stackTop = itemBottom;
                }
                // Check if need sync height (visible range has item not record height)
                let leftHeight = mergedAlign === "top" ? offset : height - offset;
                for(let i = maxLen; i >= 0; i -= 1){
                    const key = getKey(data[i]);
                    const cacheHeight = heights.get(key);
                    if (cacheHeight === undefined) {
                        needCollectHeight = true;
                        break;
                    }
                    leftHeight -= cacheHeight;
                    if (leftHeight <= 0) break;
                }
                // Scroll to
                switch(mergedAlign){
                    case "top":
                        targetTop = itemTop - offset;
                        break;
                    case "bottom":
                        targetTop = itemBottom - height + offset;
                        break;
                    default:
                        {
                            const { scrollTop: scrollTop } = containerRef.current;
                            const scrollBottom = scrollTop + height;
                            if (itemTop < scrollTop) newTargetAlign = "top";
                            else if (itemBottom > scrollBottom) newTargetAlign = "bottom";
                        }
                }
                if (targetTop !== null) syncScrollTop(targetTop);
                // One more time for sync
                if (targetTop !== syncState.lastTop) needCollectHeight = true;
            }
            // Trigger next effect
            if (needCollectHeight) setSyncState((prev)=>({
                    ...prev,
                    times: prev.times + 1,
                    index: index,
                    targetAlign: newTargetAlign,
                    lastTop: targetTop
                }));
        }
    }, [
        syncState,
        containerRef.current
    ]);
    // =========================== Scroll To ===========================
    return (arg)=>{
        // When not argument provided, we think dev may want to show the scrollbar
        if (arg === null || arg === undefined) {
            triggerFlash();
            return;
        }
        // Normal scroll logic
        (0, $905c53b807de704e$export$2e2bcd8739ae039).cancel(scrollRef.current);
        if (typeof arg === "number") syncScrollTop(arg);
        else if (arg && typeof arg === "object") {
            let index;
            let key;
            const { align: align } = arg;
            if ("index" in arg) ({ index: index } = arg);
            else {
                key = arg.key;
                index = data.findIndex((item)=>getKey(item) === key);
            }
            const { offset: rawOffset = 0 } = arg;
            setSyncState({
                times: 0,
                index: index,
                key: key,
                offset: rawOffset,
                originAlign: align
            });
        }
    };
}





var $cQmXV = parcelRequire("cQmXV");

function $fe57611f43cb692c$var$getScrollOffsetByThumbTop(thumbTop, enabledScrollRange, enabledOffsetRange) {
    if (enabledScrollRange <= 0 || enabledOffsetRange <= 0) return 0;
    const mergedThumbTop = Math.max(Math.min(thumbTop, enabledOffsetRange), 0);
    const ptg = mergedThumbTop / enabledOffsetRange;
    let nextScrollOffset = Math.ceil(ptg * enabledScrollRange);
    nextScrollOffset = Math.max(nextScrollOffset, 0);
    nextScrollOffset = Math.min(nextScrollOffset, enabledScrollRange);
    return nextScrollOffset;
}
const $fe57611f43cb692c$var$ScrollBar = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { prefixCls: prefixCls, rtl: rtl, scrollOffset: scrollOffset, scrollRange: scrollRange, onStartMove: onStartMove, onStopMove: onStopMove, onScroll: onScroll, horizontal: horizontal, spinSize: spinSize, containerSize: containerSize, style: style, thumbStyle: propsThumbStyle, showScrollBar: showScrollBar } = props;
    const [dragging, setDragging] = $cQmXV.useState(false);
    const [pageXY, setPageXY] = $cQmXV.useState(null);
    const [startTop, setStartTop] = $cQmXV.useState(null);
    const isLTR = !rtl;
    // ========================= Refs =========================
    const scrollbarRef = $cQmXV.useRef(null);
    const thumbRef = $cQmXV.useRef(null);
    // ======================= Visible ========================
    const [visible, setVisible] = $cQmXV.useState(showScrollBar);
    const visibleTimeoutRef = $cQmXV.useRef(undefined);
    const delayHidden = ()=>{
        if (showScrollBar === true || showScrollBar === false) return;
        clearTimeout(visibleTimeoutRef.current);
        setVisible(true);
        visibleTimeoutRef.current = setTimeout(()=>{
            setVisible(false);
        }, 3000);
    };
    // ======================== Range =========================
    const enableScrollRange = scrollRange - containerSize || 0;
    const enableOffsetRange = containerSize - spinSize || 0;
    // ========================= Top ==========================
    const top = $cQmXV.useMemo(()=>{
        if (scrollOffset === 0 || enableScrollRange === 0) return 0;
        const ptg = scrollOffset / enableScrollRange;
        return ptg * enableOffsetRange;
    }, [
        scrollOffset,
        enableScrollRange,
        enableOffsetRange
    ]);
    // ====================== Container =======================
    const isThumbTarget = (target)=>{
        return !!target && thumbRef.current?.contains(target);
    };
    const scrollToTrackPosition = (e)=>{
        const scrollbarEle = scrollbarRef.current;
        if (!scrollbarEle) return;
        const rect = scrollbarEle.getBoundingClientRect();
        const pagePosition = (0, $eccb9d9a7888a0eb$export$dbd0143e191dc2e5)(e, horizontal);
        let nextTop;
        if (!Number.isFinite(pagePosition)) return;
        if (horizontal) {
            const horizontalStart = isLTR ? rect.left : rect.right;
            if (!Number.isFinite(horizontalStart)) return;
            nextTop = (isLTR ? pagePosition - horizontalStart : horizontalStart - pagePosition) - spinSize / 2;
        } else {
            if (!Number.isFinite(rect.top)) return;
            nextTop = pagePosition - rect.top - spinSize / 2;
        }
        onScroll($fe57611f43cb692c$var$getScrollOffsetByThumbTop(nextTop, enableScrollRange, enableOffsetRange), horizontal);
    };
    const onContainerMouseDown = (e)=>{
        e.stopPropagation();
        e.preventDefault();
        if (e.button !== 0 || isThumbTarget(e.target)) return;
        scrollToTrackPosition(e);
    };
    // ======================== Thumb =========================
    const stateRef = $cQmXV.useRef({
        top: top,
        dragging: dragging,
        pageY: pageXY,
        startTop: startTop
    });
    stateRef.current = {
        top: top,
        dragging: dragging,
        pageY: pageXY,
        startTop: startTop
    };
    const onThumbMouseDown = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((e)=>{
        setDragging(true);
        setPageXY((0, $eccb9d9a7888a0eb$export$dbd0143e191dc2e5)(e, horizontal));
        setStartTop(stateRef.current.top);
        onStartMove();
        e.stopPropagation();
        e.preventDefault();
    });
    // ======================== Effect ========================
    // React make event as passive, but we need to preventDefault
    // Add event on dom directly instead.
    // ref: https://github.com/facebook/react/issues/9809
    $cQmXV.useEffect(()=>{
        const onScrollbarTouchStart = (e)=>{
            e.preventDefault();
        };
        const scrollbarEle = scrollbarRef.current;
        const thumbEle = thumbRef.current;
        scrollbarEle.addEventListener("touchstart", onScrollbarTouchStart, {
            passive: false
        });
        thumbEle.addEventListener("touchstart", onThumbMouseDown, {
            passive: false
        });
        return ()=>{
            scrollbarEle.removeEventListener("touchstart", onScrollbarTouchStart);
            thumbEle.removeEventListener("touchstart", onThumbMouseDown);
        };
    }, [
        onThumbMouseDown
    ]);
    // Pass to effect
    const enableScrollRangeRef = $cQmXV.useRef(undefined);
    enableScrollRangeRef.current = enableScrollRange;
    const enableOffsetRangeRef = $cQmXV.useRef(undefined);
    enableOffsetRangeRef.current = enableOffsetRange;
    $cQmXV.useEffect(()=>{
        if (dragging) {
            let moveRafId;
            const onMouseMove = (e)=>{
                const { dragging: stateDragging, pageY: statePageY, startTop: stateStartTop } = stateRef.current;
                (0, $905c53b807de704e$export$2e2bcd8739ae039).cancel(moveRafId);
                const rect = scrollbarRef.current.getBoundingClientRect();
                const scale = containerSize / (horizontal ? rect.width : rect.height);
                if (stateDragging) {
                    const offset = ((0, $eccb9d9a7888a0eb$export$dbd0143e191dc2e5)(e, horizontal) - statePageY) * scale;
                    let newTop = stateStartTop;
                    if (!isLTR && horizontal) newTop -= offset;
                    else newTop += offset;
                    const tmpEnableScrollRange = enableScrollRangeRef.current;
                    const tmpEnableOffsetRange = enableOffsetRangeRef.current;
                    const newScrollTop = $fe57611f43cb692c$var$getScrollOffsetByThumbTop(newTop, tmpEnableScrollRange, tmpEnableOffsetRange);
                    moveRafId = (0, $905c53b807de704e$export$2e2bcd8739ae039)(()=>{
                        onScroll(newScrollTop, horizontal);
                    });
                }
            };
            const onMouseUp = ()=>{
                setDragging(false);
                onStopMove();
            };
            window.addEventListener("mousemove", onMouseMove, {
                passive: true
            });
            window.addEventListener("touchmove", onMouseMove, {
                passive: true
            });
            window.addEventListener("mouseup", onMouseUp, {
                passive: true
            });
            window.addEventListener("touchend", onMouseUp, {
                passive: true
            });
            return ()=>{
                window.removeEventListener("mousemove", onMouseMove);
                window.removeEventListener("touchmove", onMouseMove);
                window.removeEventListener("mouseup", onMouseUp);
                window.removeEventListener("touchend", onMouseUp);
                (0, $905c53b807de704e$export$2e2bcd8739ae039).cancel(moveRafId);
            };
        }
    }, [
        dragging
    ]);
    $cQmXV.useEffect(()=>{
        delayHidden();
        return ()=>{
            clearTimeout(visibleTimeoutRef.current);
        };
    }, [
        scrollOffset
    ]);
    // ====================== Imperative ======================
    $cQmXV.useImperativeHandle(ref, ()=>({
            delayHidden: delayHidden
        }));
    // ======================== Render ========================
    const scrollbarPrefixCls = `${prefixCls}-scrollbar`;
    const containerStyle = {
        position: "absolute",
        visibility: visible ? null : "hidden"
    };
    const thumbStyle = {
        position: "absolute",
        borderRadius: 99,
        background: "var(--rc-virtual-list-scrollbar-bg, rgba(0, 0, 0, 0.5))",
        cursor: "pointer",
        userSelect: "none"
    };
    if (horizontal) {
        Object.assign(containerStyle, {
            height: 8,
            left: 0,
            right: 0,
            bottom: 0
        });
        Object.assign(thumbStyle, {
            height: "100%",
            width: spinSize,
            [isLTR ? "left" : "right"]: top
        });
    } else {
        Object.assign(containerStyle, {
            width: 8,
            top: 0,
            bottom: 0,
            [isLTR ? "right" : "left"]: 0
        });
        Object.assign(thumbStyle, {
            width: "100%",
            height: spinSize,
            top: top
        });
    }
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        ref: scrollbarRef,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(scrollbarPrefixCls, {
            [`${scrollbarPrefixCls}-horizontal`]: horizontal,
            [`${scrollbarPrefixCls}-vertical`]: !horizontal,
            [`${scrollbarPrefixCls}-visible`]: visible
        }),
        style: {
            ...containerStyle,
            ...style
        },
        onMouseDown: onContainerMouseDown,
        onMouseMove: delayHidden
    }, /*#__PURE__*/ $cQmXV.createElement("div", {
        ref: thumbRef,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${scrollbarPrefixCls}-thumb`, {
            [`${scrollbarPrefixCls}-thumb-moving`]: dragging
        }),
        style: {
            ...thumbStyle,
            ...propsThumbStyle
        },
        onMouseDown: onThumbMouseDown
    }));
});
var $fe57611f43cb692c$export$2e2bcd8739ae039 = $fe57611f43cb692c$var$ScrollBar;


const $eeaa6c50a0c65e4a$var$MIN_SIZE = 20;
function $eeaa6c50a0c65e4a$export$f2ca68955ab35ace(containerSize = 0, scrollRange = 0) {
    let baseSize = containerSize / scrollRange * containerSize;
    if (isNaN(baseSize)) baseSize = 0;
    baseSize = Math.max(baseSize, $eeaa6c50a0c65e4a$var$MIN_SIZE);
    return Math.floor(baseSize);
}


function $afc9e4bdb43f49fe$var$_extends() {
    $afc9e4bdb43f49fe$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $afc9e4bdb43f49fe$var$_extends.apply(this, arguments);
}
const $afc9e4bdb43f49fe$var$EMPTY_DATA = [];
const $afc9e4bdb43f49fe$var$ScrollStyle = {
    overflowY: "auto",
    overflowAnchor: "none"
};
function $afc9e4bdb43f49fe$export$cc3be4e46e8486ed(props, ref) {
    const { prefixCls: prefixCls = "rc-virtual-list", className: className, height: height, itemHeight: itemHeight, fullHeight: fullHeight = true, style: style, data: data, children: children, itemKey: itemKey, virtual: virtual, direction: direction, scrollWidth: scrollWidth, component: Component = "div", onScroll: onScroll, onVirtualScroll: onVirtualScroll, onVisibleChange: onVisibleChange, innerProps: innerProps, extraRender: extraRender, styles: styles, showScrollBar: showScrollBar = "optional", ...restProps } = props;
    // =============================== Item Key ===============================
    const getKey = $cQmXV.useCallback((item)=>{
        if (typeof itemKey === "function") return itemKey(item);
        return item?.[itemKey];
    }, [
        itemKey
    ]);
    // ================================ Height ================================
    const [setInstanceRef, collectHeight, heights, heightUpdatedMark] = (0, $315cb379062ce934$export$2e2bcd8739ae039)(getKey, null, null);
    // ================================= MISC =================================
    const useVirtual = !!(virtual !== false && height && itemHeight);
    const containerHeight = $cQmXV.useMemo(()=>Object.values(heights.maps).reduce((total, curr)=>total + curr, 0), [
        heights.id,
        heights.maps
    ]);
    const inVirtual = useVirtual && data && (Math.max(itemHeight * data.length, containerHeight) > height || !!scrollWidth);
    const isRTL = direction === "rtl";
    const mergedClassName = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, {
        [`${prefixCls}-rtl`]: isRTL
    }, className);
    const mergedData = data || $afc9e4bdb43f49fe$var$EMPTY_DATA;
    const componentRef = (0, $cQmXV.useRef)(null);
    const fillerInnerRef = (0, $cQmXV.useRef)(null);
    const containerRef = (0, $cQmXV.useRef)(null);
    // =============================== Item Key ===============================
    const [offsetTop, setOffsetTop] = (0, $cQmXV.useState)(0);
    const [offsetLeft, setOffsetLeft] = (0, $cQmXV.useState)(0);
    const [scrollMoving, setScrollMoving] = (0, $cQmXV.useState)(false);
    const onScrollbarStartMove = ()=>{
        setScrollMoving(true);
    };
    const onScrollbarStopMove = ()=>{
        setScrollMoving(false);
    };
    const sharedConfig = {
        getKey: getKey
    };
    // ================================ Scroll ================================
    function syncScrollTop(newTop) {
        setOffsetTop((origin)=>{
            let value;
            if (typeof newTop === "function") value = newTop(origin);
            else value = newTop;
            const alignedTop = keepInRange(value);
            componentRef.current.scrollTop = alignedTop;
            return alignedTop;
        });
    }
    // ================================ Legacy ================================
    // Put ref here since the range is generate by follow
    const rangeRef = (0, $cQmXV.useRef)({
        start: 0,
        end: mergedData.length
    });
    const diffItemRef = (0, $cQmXV.useRef)(undefined);
    const [diffItem] = (0, $769026c2a70b5f1b$export$2e2bcd8739ae039)(mergedData, getKey);
    diffItemRef.current = diffItem;
    // ========================== Visible Calculation =========================
    const { scrollHeight: scrollHeight, start: start, end: end, offset: fillerOffset } = $cQmXV.useMemo(()=>{
        if (!useVirtual) return {
            scrollHeight: undefined,
            start: 0,
            end: mergedData.length - 1,
            offset: undefined
        };
        // Always use virtual scroll bar in avoid shaking
        if (!inVirtual) return {
            scrollHeight: fillerInnerRef.current?.offsetHeight || 0,
            start: 0,
            end: mergedData.length - 1,
            offset: undefined
        };
        let itemTop = 0;
        let startIndex;
        let startOffset;
        let endIndex;
        const dataLen = mergedData.length;
        for(let i = 0; i < dataLen; i += 1){
            const item = mergedData[i];
            const key = getKey(item);
            const cacheHeight = heights.get(key);
            const currentItemBottom = itemTop + (cacheHeight === undefined ? itemHeight : cacheHeight);
            // Check item top in the range
            if (currentItemBottom >= offsetTop && startIndex === undefined) {
                startIndex = i;
                startOffset = itemTop;
            }
            // Check item bottom in the range. We will render additional one item for motion usage
            if (currentItemBottom > offsetTop + height && endIndex === undefined) endIndex = i;
            itemTop = currentItemBottom;
        }
        // When scrollTop at the end but data cut to small count will reach this
        if (startIndex === undefined) {
            startIndex = 0;
            startOffset = 0;
            endIndex = Math.ceil(height / itemHeight);
        }
        if (endIndex === undefined) endIndex = mergedData.length - 1;
        // Give cache to improve scroll experience
        endIndex = Math.min(endIndex + 1, mergedData.length - 1);
        return {
            scrollHeight: itemTop,
            start: startIndex,
            end: endIndex,
            offset: startOffset
        };
    }, [
        inVirtual,
        useVirtual,
        offsetTop,
        mergedData,
        heightUpdatedMark,
        height
    ]);
    rangeRef.current.start = start;
    rangeRef.current.end = end;
    // When scroll up, first visible item get real height may not same as `itemHeight`,
    // Which will make scroll jump.
    // Let's sync scroll top to avoid jump
    $cQmXV.useLayoutEffect(()=>{
        const changedRecord = heights.getRecord();
        if (changedRecord.size === 1) {
            const recordKey = Array.from(changedRecord.keys())[0];
            const prevCacheHeight = changedRecord.get(recordKey);
            // Quick switch data may cause `start` not in `mergedData` anymore
            const startItem = mergedData[start];
            if (startItem && prevCacheHeight === undefined) {
                const startIndexKey = getKey(startItem);
                if (startIndexKey === recordKey) {
                    const realStartHeight = heights.get(recordKey);
                    const diffHeight = realStartHeight - itemHeight;
                    syncScrollTop((ori)=>{
                        return ori + diffHeight;
                    });
                }
            }
        }
        heights.resetRecord();
    }, [
        scrollHeight
    ]);
    // ================================= Size =================================
    const [size, setSize] = $cQmXV.useState({
        width: 0,
        height: height
    });
    const onHolderResize = (sizeInfo)=>{
        setSize({
            width: sizeInfo.offsetWidth,
            height: sizeInfo.offsetHeight
        });
    };
    // Hack on scrollbar to enable flash call
    const verticalScrollBarRef = (0, $cQmXV.useRef)(null);
    const horizontalScrollBarRef = (0, $cQmXV.useRef)(null);
    const horizontalScrollBarSpinSize = $cQmXV.useMemo(()=>(0, $eeaa6c50a0c65e4a$export$f2ca68955ab35ace)(size.width, scrollWidth), [
        size.width,
        scrollWidth
    ]);
    const verticalScrollBarSpinSize = $cQmXV.useMemo(()=>(0, $eeaa6c50a0c65e4a$export$f2ca68955ab35ace)(size.height, scrollHeight), [
        size.height,
        scrollHeight
    ]);
    // =============================== In Range ===============================
    const maxScrollHeight = scrollHeight - height;
    const maxScrollHeightRef = (0, $cQmXV.useRef)(maxScrollHeight);
    maxScrollHeightRef.current = maxScrollHeight;
    function keepInRange(newScrollTop) {
        let newTop = newScrollTop;
        if (!Number.isNaN(maxScrollHeightRef.current)) newTop = Math.min(newTop, maxScrollHeightRef.current);
        newTop = Math.max(newTop, 0);
        return newTop;
    }
    const isScrollAtTop = offsetTop <= 0;
    const isScrollAtBottom = offsetTop >= maxScrollHeight;
    const isScrollAtLeft = offsetLeft <= 0;
    const isScrollAtRight = offsetLeft >= scrollWidth;
    const originScroll = (0, $0f5a2a86eabfa2b4$export$2e2bcd8739ae039)(isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight);
    // ================================ Scroll ================================
    const getVirtualScrollInfo = ()=>({
            x: isRTL ? -offsetLeft : offsetLeft,
            y: offsetTop
        });
    const lastVirtualScrollInfoRef = (0, $cQmXV.useRef)(getVirtualScrollInfo());
    const triggerScroll = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((params)=>{
        if (onVirtualScroll) {
            const nextInfo = {
                ...getVirtualScrollInfo(),
                ...params
            };
            // Trigger when offset changed
            if (lastVirtualScrollInfoRef.current.x !== nextInfo.x || lastVirtualScrollInfoRef.current.y !== nextInfo.y) {
                onVirtualScroll(nextInfo);
                lastVirtualScrollInfoRef.current = nextInfo;
            }
        }
    });
    function onScrollBar(newScrollOffset, horizontal) {
        const newOffset = newScrollOffset;
        if (horizontal) {
            (0, $3h5eW.flushSync)(()=>{
                setOffsetLeft(newOffset);
            });
            triggerScroll();
        } else syncScrollTop(newOffset);
    }
    // When data size reduce. It may trigger native scroll event back to fit scroll position
    function onFallbackScroll(e) {
        const { scrollTop: newScrollTop } = e.currentTarget;
        if (newScrollTop !== offsetTop) syncScrollTop(newScrollTop);
        // Trigger origin onScroll
        onScroll?.(e);
        triggerScroll();
    }
    const keepInHorizontalRange = (nextOffsetLeft)=>{
        let tmpOffsetLeft = nextOffsetLeft;
        const max = !!scrollWidth ? scrollWidth - size.width : 0;
        tmpOffsetLeft = Math.max(tmpOffsetLeft, 0);
        tmpOffsetLeft = Math.min(tmpOffsetLeft, max);
        return tmpOffsetLeft;
    };
    const onWheelDelta = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((offsetXY, fromHorizontal)=>{
        if (fromHorizontal) {
            (0, $3h5eW.flushSync)(()=>{
                setOffsetLeft((left)=>{
                    const nextOffsetLeft = left + (isRTL ? -offsetXY : offsetXY);
                    return keepInHorizontalRange(nextOffsetLeft);
                });
            });
            triggerScroll();
        } else syncScrollTop((top)=>{
            const newTop = top + offsetXY;
            return newTop;
        });
    });
    // Since this added in global,should use ref to keep update
    const [onRawWheel, onFireFoxScroll] = (0, $4455ce171004e236$export$2e2bcd8739ae039)(useVirtual, isScrollAtTop, isScrollAtBottom, isScrollAtLeft, isScrollAtRight, !!scrollWidth, onWheelDelta);
    // Mobile touch move
    (0, $cb59dff4496add05$export$2e2bcd8739ae039)(useVirtual, componentRef, (isHorizontal, delta, smoothOffset, e)=>{
        const event = e;
        if (originScroll(isHorizontal, delta, smoothOffset)) return false;
        // Fix nest List trigger TouchMove event
        if (!event || !event._virtualHandled) {
            if (event) event._virtualHandled = true;
            onRawWheel({
                preventDefault () {},
                deltaX: isHorizontal ? delta : 0,
                deltaY: isHorizontal ? 0 : delta
            });
            return true;
        }
        return false;
    });
    // MouseDown drag for scroll
    (0, $eccb9d9a7888a0eb$export$2e2bcd8739ae039)(inVirtual, componentRef, (offset)=>{
        syncScrollTop((top)=>top + offset);
    });
    (0, $7673d874dab69d07$export$2e2bcd8739ae039)(()=>{
        // Firefox only
        function onMozMousePixelScroll(e) {
            // scrolling at top/bottom limit
            const scrollingUpAtTop = isScrollAtTop && e.detail < 0;
            const scrollingDownAtBottom = isScrollAtBottom && e.detail > 0;
            if (useVirtual && !scrollingUpAtTop && !scrollingDownAtBottom) e.preventDefault();
        }
        const componentEle = componentRef.current;
        componentEle.addEventListener("wheel", onRawWheel, {
            passive: false
        });
        componentEle.addEventListener("DOMMouseScroll", onFireFoxScroll, {
            passive: true
        });
        componentEle.addEventListener("MozMousePixelScroll", onMozMousePixelScroll, {
            passive: false
        });
        return ()=>{
            componentEle.removeEventListener("wheel", onRawWheel);
            componentEle.removeEventListener("DOMMouseScroll", onFireFoxScroll);
            componentEle.removeEventListener("MozMousePixelScroll", onMozMousePixelScroll);
        };
    }, [
        useVirtual,
        isScrollAtTop,
        isScrollAtBottom
    ]);
    // Sync scroll left
    (0, $7673d874dab69d07$export$2e2bcd8739ae039)(()=>{
        if (scrollWidth) {
            const newOffsetLeft = keepInHorizontalRange(offsetLeft);
            setOffsetLeft(newOffsetLeft);
            triggerScroll({
                x: newOffsetLeft
            });
        }
    }, [
        size.width,
        scrollWidth
    ]);
    // ================================= Ref ==================================
    const delayHideScrollBar = ()=>{
        verticalScrollBarRef.current?.delayHidden();
        horizontalScrollBarRef.current?.delayHidden();
    };
    const getSize = (0, $1a32278096d38b1d$export$a1d82723752af087)(mergedData, getKey, heights, itemHeight);
    const scrollTo = (0, $1138e5d3e2733f61$export$2e2bcd8739ae039)(componentRef, mergedData, heights, itemHeight, getKey, getSize, ()=>collectHeight(true), syncScrollTop, delayHideScrollBar);
    $cQmXV.useImperativeHandle(ref, ()=>({
            nativeElement: containerRef.current,
            getScrollInfo: getVirtualScrollInfo,
            scrollTo: (config)=>{
                function isPosScroll(arg) {
                    return arg && typeof arg === "object" && ("left" in arg || "top" in arg);
                }
                if (isPosScroll(config)) {
                    // Scroll X
                    if (config.left !== undefined) setOffsetLeft(keepInHorizontalRange(config.left));
                    // Scroll Y
                    scrollTo(config.top);
                } else scrollTo(config);
            }
        }));
    // ================================ Effect ================================
    /** We need told outside that some list not rendered */ (0, $7673d874dab69d07$export$2e2bcd8739ae039)(()=>{
        if (onVisibleChange) {
            const renderList = mergedData.slice(start, end + 1);
            onVisibleChange(renderList, mergedData);
        }
    }, [
        start,
        end,
        mergedData
    ]);
    // ================================ Extra =================================
    const extraContent = extraRender?.({
        start: start,
        end: end,
        virtual: inVirtual,
        offsetX: offsetLeft,
        scrollTop: offsetTop,
        offsetY: fillerOffset,
        rtl: isRTL,
        getSize: getSize
    });
    // ================================ Render ================================
    const listChildren = (0, $2d65b79d651f2d8b$export$2e2bcd8739ae039)(mergedData, start, end, scrollWidth, offsetLeft, setInstanceRef, children, sharedConfig);
    let componentStyle = null;
    if (height) {
        componentStyle = {
            [fullHeight ? "height" : "maxHeight"]: height,
            ...$afc9e4bdb43f49fe$var$ScrollStyle
        };
        if (useVirtual) {
            componentStyle.overflowY = "hidden";
            if (scrollWidth) componentStyle.overflowX = "hidden";
            if (scrollMoving) componentStyle.pointerEvents = "none";
        }
    }
    const containerProps = {};
    if (isRTL) containerProps.dir = "rtl";
    return /*#__PURE__*/ $cQmXV.createElement("div", $afc9e4bdb43f49fe$var$_extends({
        ref: containerRef,
        style: {
            ...style,
            position: "relative"
        },
        className: mergedClassName
    }, containerProps, restProps), /*#__PURE__*/ $cQmXV.createElement((0, $1d6306c05e604045$export$2e2bcd8739ae039), {
        onResize: onHolderResize
    }, /*#__PURE__*/ $cQmXV.createElement(Component, {
        className: `${prefixCls}-holder`,
        style: componentStyle,
        ref: componentRef,
        onScroll: onFallbackScroll,
        onMouseEnter: delayHideScrollBar
    }, /*#__PURE__*/ $cQmXV.createElement((0, $19ebe74c3da0ce8f$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        height: scrollHeight,
        offsetX: offsetLeft,
        offsetY: fillerOffset,
        scrollWidth: scrollWidth,
        onInnerResize: collectHeight,
        ref: fillerInnerRef,
        innerProps: innerProps,
        rtl: isRTL,
        extra: extraContent
    }, listChildren))), inVirtual && scrollHeight > height && /*#__PURE__*/ $cQmXV.createElement((0, $fe57611f43cb692c$export$2e2bcd8739ae039), {
        ref: verticalScrollBarRef,
        prefixCls: prefixCls,
        scrollOffset: offsetTop,
        scrollRange: scrollHeight,
        rtl: isRTL,
        onScroll: onScrollBar,
        onStartMove: onScrollbarStartMove,
        onStopMove: onScrollbarStopMove,
        spinSize: verticalScrollBarSpinSize,
        containerSize: size.height,
        style: styles?.verticalScrollBar,
        thumbStyle: styles?.verticalScrollBarThumb,
        showScrollBar: showScrollBar
    }), inVirtual && scrollWidth > size.width && /*#__PURE__*/ $cQmXV.createElement((0, $fe57611f43cb692c$export$2e2bcd8739ae039), {
        ref: horizontalScrollBarRef,
        prefixCls: prefixCls,
        scrollOffset: offsetLeft,
        scrollRange: scrollWidth,
        rtl: isRTL,
        onScroll: onScrollBar,
        onStartMove: onScrollbarStartMove,
        onStopMove: onScrollbarStopMove,
        spinSize: horizontalScrollBarSpinSize,
        containerSize: size.width,
        horizontal: true,
        style: styles?.horizontalScrollBar,
        thumbStyle: styles?.horizontalScrollBarThumb,
        showScrollBar: showScrollBar
    }));
}
const $afc9e4bdb43f49fe$var$List = /*#__PURE__*/ $cQmXV.forwardRef($afc9e4bdb43f49fe$export$cc3be4e46e8486ed);
$afc9e4bdb43f49fe$var$List.displayName = "List";
var $afc9e4bdb43f49fe$export$2e2bcd8739ae039 = $afc9e4bdb43f49fe$var$List;



var $cQmXV = parcelRequire("cQmXV");

const $4771092a8cd8f901$var$List = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>(0, $afc9e4bdb43f49fe$export$cc3be4e46e8486ed)({
        ...props,
        virtual: false
    }, ref));
$4771092a8cd8f901$var$List.displayName = "List";
var $4771092a8cd8f901$export$2e2bcd8739ae039 = $4771092a8cd8f901$var$List;


var $a9f0fc634fe20e3d$export$2e2bcd8739ae039 = (0, $afc9e4bdb43f49fe$export$2e2bcd8739ae039);



var $cQmXV = parcelRequire("cQmXV");





var $cQmXV = parcelRequire("cQmXV");






var $cQmXV = parcelRequire("cQmXV");



const $16b3c46e0cd49941$export$fbb76fda59aa02a2 = (0, $1100d1e67da77ebd$export$fd42f52fd3ae1109)(null);
const $16b3c46e0cd49941$export$11cae3e04ab99fae = (0, $1100d1e67da77ebd$export$fd42f52fd3ae1109)(null);


function $f40856484fdd0f69$var$_extends() {
    $f40856484fdd0f69$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f40856484fdd0f69$var$_extends.apply(this, arguments);
}
function $f40856484fdd0f69$export$dfa11a34ceba822(colIndex, colSpan, columnsOffset) {
    const mergedColSpan = colSpan || 1;
    return columnsOffset[colIndex + mergedColSpan] - (columnsOffset[colIndex] || 0);
}
const $f40856484fdd0f69$var$VirtualCell = (props)=>{
    const { rowInfo: rowInfo, column: column, colIndex: colIndex, indent: indent, index: index, component: component, renderIndex: renderIndex, record: record, style: style, className: className, inverse: inverse, getHeight: getHeight } = props;
    const { render: render, dataIndex: dataIndex, className: columnClassName, width: colWidth } = column;
    const { columnsOffset: columnsOffset } = (0, $1100d1e67da77ebd$export$fae74005e78b1a27)((0, $16b3c46e0cd49941$export$11cae3e04ab99fae), [
        "columnsOffset"
    ]);
    // TODO: support `expandableRowOffset`
    const { key: key, fixedInfo: fixedInfo, appendCellNode: appendCellNode, additionalCellProps: additionalCellProps, originRowSpan: originRowSpan } = (0, $49da4ac3f43ec6a8$export$16400ac709c56616)(rowInfo, column, colIndex, indent, index);
    const { style: cellStyle, colSpan: colSpan = 1, rowSpan: rowSpan = 1 } = additionalCellProps;
    // ========================= ColWidth =========================
    // column width
    const startColIndex = colIndex - 1;
    const concatColWidth = $f40856484fdd0f69$export$dfa11a34ceba822(startColIndex, colSpan, columnsOffset);
    // margin offset
    const marginOffset = colSpan > 1 ? colWidth - concatColWidth : 0;
    // ========================== Style ===========================
    const mergedStyle = {
        ...cellStyle,
        ...style,
        flex: `0 0 ${concatColWidth}px`,
        width: `${concatColWidth}px`,
        marginRight: marginOffset,
        pointerEvents: "auto"
    };
    // When `colSpan` or `rowSpan` is `0`, should skip render.
    const needHide = $cQmXV.useMemo(()=>{
        if (inverse) return rowSpan <= 1;
        else return colSpan === 0 || rowSpan === 0 || rowSpan > 1;
    }, [
        rowSpan,
        colSpan,
        inverse
    ]);
    // 0 rowSpan or colSpan should not render
    if (needHide) mergedStyle.visibility = "hidden";
    else if (inverse) mergedStyle.height = getHeight?.(rowSpan);
    const mergedRender = needHide ? ()=>null : render;
    // ========================== Render ==========================
    const cellSpan = {};
    // Virtual should reset `colSpan` & `rowSpan`
    if (rowSpan === 0 || colSpan === 0) {
        cellSpan.rowSpan = 1;
        cellSpan.colSpan = 1;
    }
    return /*#__PURE__*/ $cQmXV.createElement((0, $c5712ffce408ad73$export$2e2bcd8739ae039), $f40856484fdd0f69$var$_extends({
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(columnClassName, className),
        ellipsis: column.ellipsis,
        align: column.align,
        scope: column.rowScope,
        component: component,
        prefixCls: rowInfo.prefixCls,
        key: key,
        record: record,
        index: index,
        renderIndex: renderIndex,
        dataIndex: dataIndex,
        render: mergedRender,
        shouldCellUpdate: column.shouldCellUpdate
    }, fixedInfo, {
        appendNode: appendCellNode,
        originRowSpan: originRowSpan,
        additionalProps: {
            ...additionalCellProps,
            style: mergedStyle,
            ...cellSpan
        }
    }));
};
var $f40856484fdd0f69$export$2e2bcd8739ae039 = $f40856484fdd0f69$var$VirtualCell;




function $95e53f7b7162cffa$var$_extends() {
    $95e53f7b7162cffa$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $95e53f7b7162cffa$var$_extends.apply(this, arguments);
}
const $95e53f7b7162cffa$var$BodyLine = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { data: data, index: index, className: className, rowKey: rowKey, style: style, extra: extra, getHeight: getHeight, ...restProps } = props;
    const { record: record, indent: indent, index: renderIndex } = data;
    const { scrollX: scrollX, flattenColumns: flattenColumns, prefixCls: prefixCls, fixColumn: fixColumn, componentWidth: componentWidth, classNames: classNames, styles: styles } = (0, $1100d1e67da77ebd$export$fae74005e78b1a27)((0, $8ff93ffc4f10aaf4$export$2e2bcd8739ae039), [
        "prefixCls",
        "flattenColumns",
        "fixColumn",
        "componentWidth",
        "scrollX",
        "classNames",
        "styles"
    ]);
    const { getComponent: getComponent } = (0, $1100d1e67da77ebd$export$fae74005e78b1a27)((0, $16b3c46e0cd49941$export$fbb76fda59aa02a2), [
        "getComponent"
    ]);
    const rowInfo = (0, $9708cd947c7f3f82$export$2e2bcd8739ae039)(record, rowKey, index, indent);
    const RowComponent = getComponent([
        "body",
        "row"
    ], "div");
    const cellComponent = getComponent([
        "body",
        "cell"
    ], "div");
    // ========================== Expand ==========================
    const { rowSupportExpand: rowSupportExpand, expanded: expanded, rowProps: rowProps, expandedRowRender: expandedRowRender, expandedRowClassName: expandedRowClassName, forceRender: forceRender } = rowInfo;
    const expandedClsName = (0, $4241324b3d4de179$export$c5c465afb98f57b6)(expandedRowClassName, record, index, indent);
    let expandRowNode;
    if (!extra && rowSupportExpand && (forceRender || expanded)) {
        const expandContent = expandedRowRender(record, index, indent + 1, expanded);
        let additionalProps = {};
        if (fixColumn) additionalProps = {
            style: {
                ["--virtual-width"]: `${componentWidth}px`
            }
        };
        const rowCellCls = `${prefixCls}-expanded-row-cell`;
        expandRowNode = /*#__PURE__*/ $cQmXV.createElement(RowComponent, {
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-expanded-row`, `${prefixCls}-expanded-row-level-${indent + 1}`, expandedClsName),
            style: {
                display: expanded ? undefined : "none"
            }
        }, /*#__PURE__*/ $cQmXV.createElement((0, $c5712ffce408ad73$export$2e2bcd8739ae039), {
            component: cellComponent,
            prefixCls: prefixCls,
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(rowCellCls, {
                [`${rowCellCls}-fixed`]: fixColumn
            }),
            additionalProps: additionalProps
        }, expandContent));
    }
    // ========================== Render ==========================
    const rowStyle = {
        ...style,
        width: scrollX
    };
    if (extra) {
        rowStyle.position = "absolute";
        rowStyle.pointerEvents = "none";
    }
    const rowNode = /*#__PURE__*/ $cQmXV.createElement(RowComponent, $95e53f7b7162cffa$var$_extends({}, rowProps, restProps, {
        "data-row-key": rowKey,
        ref: rowSupportExpand ? null : ref,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(className, `${prefixCls}-row`, rowProps?.className, classNames?.body?.row, {
            [expandedClsName]: indent >= 1,
            [`${prefixCls}-row-extra`]: extra
        }),
        style: {
            ...rowStyle,
            ...rowProps?.style,
            ...styles?.body?.row
        }
    }), flattenColumns.map((column, colIndex)=>{
        return /*#__PURE__*/ $cQmXV.createElement((0, $f40856484fdd0f69$export$2e2bcd8739ae039), {
            key: colIndex,
            className: classNames?.body?.cell,
            style: styles?.body?.cell,
            component: cellComponent,
            rowInfo: rowInfo,
            column: column,
            colIndex: colIndex,
            indent: indent,
            index: index,
            renderIndex: renderIndex,
            record: record,
            inverse: extra,
            getHeight: getHeight
        });
    }));
    if (rowSupportExpand) return /*#__PURE__*/ $cQmXV.createElement("div", {
        ref: ref
    }, rowNode, expandRowNode);
    return rowNode;
});
const $95e53f7b7162cffa$var$ResponseBodyLine = (0, $8ff93ffc4f10aaf4$export$e9e4cb9eb9e2b4c4)($95e53f7b7162cffa$var$BodyLine);
var $95e53f7b7162cffa$export$2e2bcd8739ae039 = $95e53f7b7162cffa$var$ResponseBodyLine;



const $4d0985478edd0fb1$var$ALIGN_MAP = {
    start: "top",
    end: "bottom",
    nearest: "auto"
};
const $4d0985478edd0fb1$var$Grid = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { data: data, onScroll: onScroll } = props;
    const { flattenColumns: flattenColumns, onColumnResize: onColumnResize, getRowKey: getRowKey, expandedKeys: expandedKeys, prefixCls: prefixCls, childrenColumnName: childrenColumnName, scrollX: scrollX, direction: direction } = (0, $1100d1e67da77ebd$export$fae74005e78b1a27)((0, $8ff93ffc4f10aaf4$export$2e2bcd8739ae039), [
        "flattenColumns",
        "onColumnResize",
        "getRowKey",
        "prefixCls",
        "expandedKeys",
        "childrenColumnName",
        "scrollX",
        "direction"
    ]);
    const { sticky: sticky, scrollY: scrollY, listItemHeight: listItemHeight, getComponent: getComponent, onScroll: onTablePropScroll } = (0, $1100d1e67da77ebd$export$fae74005e78b1a27)((0, $16b3c46e0cd49941$export$fbb76fda59aa02a2));
    // =========================== Ref ============================
    const listRef = $cQmXV.useRef(null);
    // =========================== Data ===========================
    const flattenData = (0, $c84b77e36f423551$export$2e2bcd8739ae039)(data, childrenColumnName, expandedKeys, getRowKey);
    // ========================== Column ==========================
    const columnsWidth = $cQmXV.useMemo(()=>{
        let total = 0;
        return flattenColumns.map(({ width: width, minWidth: minWidth, key: key })=>{
            const finalWidth = Math.max(width || 0, minWidth || 0);
            total += finalWidth;
            return [
                key,
                finalWidth,
                total
            ];
        });
    }, [
        flattenColumns
    ]);
    const columnsOffset = $cQmXV.useMemo(()=>columnsWidth.map((colWidth)=>colWidth[2]), [
        columnsWidth
    ]);
    $cQmXV.useEffect(()=>{
        columnsWidth.forEach(([key, width])=>{
            onColumnResize(key, width);
        });
    }, [
        columnsWidth
    ]);
    // =========================== Ref ============================
    $cQmXV.useImperativeHandle(ref, ()=>{
        const obj = {
            scrollTo: (config)=>{
                const { align: align, offset: offset, ...restConfig } = config;
                const virtualAlign = $4d0985478edd0fb1$var$ALIGN_MAP[align] ?? (offset ? "top" : "auto");
                listRef.current?.scrollTo({
                    ...restConfig,
                    offset: offset,
                    align: virtualAlign
                });
            },
            nativeElement: listRef.current?.nativeElement
        };
        Object.defineProperty(obj, "scrollLeft", {
            get: ()=>listRef.current?.getScrollInfo().x || 0,
            set: (value)=>{
                listRef.current?.scrollTo({
                    left: value
                });
            }
        });
        // https://github.com/ant-design/ant-design/issues/54734
        Object.defineProperty(obj, "scrollTop", {
            get: ()=>listRef.current?.getScrollInfo().y || 0,
            set: (value)=>{
                listRef.current?.scrollTo({
                    top: value
                });
            }
        });
        return obj;
    });
    // ======================= Col/Row Span =======================
    const getRowSpan = (column, index)=>{
        const record = flattenData[index]?.record;
        const { onCell: onCell } = column;
        if (onCell) {
            const cellProps = onCell(record, index);
            return cellProps?.rowSpan ?? 1;
        }
        return 1;
    };
    const extraRender = (info)=>{
        const { start: start, end: end, getSize: getSize, offsetY: offsetY } = info;
        // Do nothing if no data
        if (end < 0) return null;
        // Find first rowSpan column
        let firstRowSpanColumns = flattenColumns.filter(// rowSpan is 0
        (column)=>getRowSpan(column, start) === 0);
        let startIndex = start;
        for(let i = start; i >= 0; i -= 1){
            firstRowSpanColumns = firstRowSpanColumns.filter((column)=>getRowSpan(column, i) === 0);
            if (!firstRowSpanColumns.length) {
                startIndex = i;
                break;
            }
        }
        // Find last rowSpan column
        let lastRowSpanColumns = flattenColumns.filter(// rowSpan is not 1
        (column)=>getRowSpan(column, end) !== 1);
        let endIndex = end;
        for(let i = end; i < flattenData.length; i += 1){
            lastRowSpanColumns = lastRowSpanColumns.filter((column)=>getRowSpan(column, i) !== 1);
            if (!lastRowSpanColumns.length) {
                endIndex = Math.max(i - 1, end);
                break;
            }
        }
        // Collect the line who has rowSpan
        const spanLines = [];
        for(let i = startIndex; i <= endIndex; i += 1){
            const item = flattenData[i];
            // This code will never reach, just incase
            if (!item) continue;
            if (flattenColumns.some((column)=>getRowSpan(column, i) > 1)) spanLines.push(i);
        }
        // Patch extra line on the page
        const nodes = spanLines.map((index)=>{
            const item = flattenData[index];
            const rowKey = getRowKey(item.record, index);
            const getHeight = (rowSpan)=>{
                const endItemIndex = index + rowSpan - 1;
                const endItem = flattenData[endItemIndex];
                if (!endItem || !endItem.record) {
                    // clamp 到当前可用的最后一行，或退化为默认高度
                    const safeEndIndex = Math.min(endItemIndex, flattenData.length - 1);
                    const safeEndItem = flattenData[safeEndIndex];
                    const endItemKey = getRowKey(safeEndItem.record, safeEndIndex);
                    const sizeInfo = getSize(rowKey, endItemKey);
                    return sizeInfo.bottom - sizeInfo.top;
                }
                const endItemKey = getRowKey(endItem.record, endItemIndex);
                const sizeInfo = getSize(rowKey, endItemKey);
                return sizeInfo.bottom - sizeInfo.top;
            };
            const sizeInfo = getSize(rowKey);
            return /*#__PURE__*/ $cQmXV.createElement((0, $95e53f7b7162cffa$export$2e2bcd8739ae039), {
                key: index,
                data: item,
                rowKey: rowKey,
                index: index,
                style: {
                    top: -offsetY + sizeInfo.top
                },
                extra: true,
                getHeight: getHeight
            });
        });
        return nodes;
    };
    // ========================= Context ==========================
    const gridContext = $cQmXV.useMemo(()=>({
            columnsOffset: columnsOffset
        }), [
        columnsOffset
    ]);
    // ========================== Render ==========================
    const tblPrefixCls = `${prefixCls}-tbody`;
    // default 'div' in @rc-component/virtual-list
    const wrapperComponent = getComponent([
        "body",
        "wrapper"
    ]);
    // ========================== Sticky Scroll Bar ==========================
    const horizontalScrollBarStyle = {};
    if (sticky) {
        horizontalScrollBarStyle.position = "sticky";
        horizontalScrollBarStyle.bottom = 0;
        if (typeof sticky === "object" && sticky.offsetScroll) horizontalScrollBarStyle.bottom = sticky.offsetScroll;
    }
    return /*#__PURE__*/ $cQmXV.createElement((0, $16b3c46e0cd49941$export$11cae3e04ab99fae).Provider, {
        value: gridContext
    }, /*#__PURE__*/ $cQmXV.createElement((0, $a9f0fc634fe20e3d$export$2e2bcd8739ae039), {
        fullHeight: false,
        ref: listRef,
        prefixCls: `${tblPrefixCls}-virtual`,
        styles: {
            horizontalScrollBar: horizontalScrollBarStyle
        },
        className: tblPrefixCls,
        height: scrollY,
        itemHeight: listItemHeight || 24,
        data: flattenData,
        itemKey: (item)=>getRowKey(item.record),
        component: wrapperComponent,
        scrollWidth: scrollX,
        direction: direction,
        onVirtualScroll: ({ x: x })=>{
            onScroll({
                currentTarget: listRef.current?.nativeElement,
                scrollLeft: x
            });
        },
        onScroll: onTablePropScroll,
        extraRender: extraRender
    }, (item, index, itemProps)=>{
        const rowKey = getRowKey(item.record, index);
        return /*#__PURE__*/ $cQmXV.createElement((0, $95e53f7b7162cffa$export$2e2bcd8739ae039), {
            data: item,
            rowKey: rowKey,
            index: index,
            style: itemProps.style
        });
    }));
});
const $4d0985478edd0fb1$var$ResponseGrid = (0, $8ff93ffc4f10aaf4$export$e9e4cb9eb9e2b4c4)($4d0985478edd0fb1$var$Grid);
var $4d0985478edd0fb1$export$2e2bcd8739ae039 = $4d0985478edd0fb1$var$ResponseGrid;



function $b4a9be2a461e4ebd$var$_extends() {
    $b4a9be2a461e4ebd$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b4a9be2a461e4ebd$var$_extends.apply(this, arguments);
}
const $b4a9be2a461e4ebd$var$renderBody = (rawData, props)=>{
    const { ref: ref, onScroll: onScroll } = props;
    return /*#__PURE__*/ $cQmXV.createElement((0, $4d0985478edd0fb1$export$2e2bcd8739ae039), {
        ref: ref,
        data: rawData,
        onScroll: onScroll
    });
};
const $b4a9be2a461e4ebd$var$VirtualTable = (props, ref)=>{
    const { data: data, columns: columns, scroll: scroll, sticky: sticky, prefixCls: prefixCls = (0, $eea5fa165d97b5a0$export$c42ed95a478b1ec5), className: className, listItemHeight: listItemHeight, components: components, onScroll: onScroll } = props;
    let { x: scrollX, y: scrollY } = scroll || {};
    // Fill scrollX
    if (typeof scrollX !== "number") scrollX = 1;
    // Fill scrollY
    if (typeof scrollY !== "number") scrollY = 500;
    const getComponent = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((path, defaultComponent)=>(0, $bb62aae17cbc8bd7$export$2e2bcd8739ae039)(components, path) || defaultComponent);
    // Memo this
    const onInternalScroll = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)(onScroll);
    // ========================= Context ==========================
    const context = $cQmXV.useMemo(()=>({
            sticky: sticky,
            scrollY: scrollY,
            listItemHeight: listItemHeight,
            getComponent: getComponent,
            onScroll: onInternalScroll
        }), [
        sticky,
        scrollY,
        listItemHeight,
        getComponent,
        onInternalScroll
    ]);
    // ========================== Render ==========================
    return /*#__PURE__*/ $cQmXV.createElement((0, $16b3c46e0cd49941$export$fbb76fda59aa02a2).Provider, {
        value: context
    }, /*#__PURE__*/ $cQmXV.createElement((0, $eea5fa165d97b5a0$export$2e2bcd8739ae039), $b4a9be2a461e4ebd$var$_extends({}, props, {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(className, `${prefixCls}-virtual`),
        scroll: {
            ...scroll,
            x: scrollX
        },
        components: {
            ...components,
            // fix https://github.com/ant-design/ant-design/issues/48991
            body: data?.length ? $b4a9be2a461e4ebd$var$renderBody : undefined
        },
        columns: columns,
        internalHooks: (0, $9848d298b42e15e6$export$91b75cf262680225),
        tailor: true,
        ref: ref
    })));
};
const $b4a9be2a461e4ebd$var$RefVirtualTable = /*#__PURE__*/ $cQmXV.forwardRef($b4a9be2a461e4ebd$var$VirtualTable);
const $b4a9be2a461e4ebd$export$4747b79b36862360 = (shouldTriggerRender)=>{
    return (0, $8ff93ffc4f10aaf4$export$ffd6d5bef5eaf0a4)($b4a9be2a461e4ebd$var$RefVirtualTable, shouldTriggerRender);
};
var $b4a9be2a461e4ebd$export$2e2bcd8739ae039 = $b4a9be2a461e4ebd$export$4747b79b36862360();



var $f3a587cf9ca0ff28$export$2e2bcd8739ae039 = (0, $eea5fa165d97b5a0$export$2e2bcd8739ae039);


/* istanbul ignore next */ /** This is a syntactic sugar for `columns` prop. So HOC will not work on this. */ const $8713c088cd428ad0$var$Column = (_)=>null;
var $8713c088cd428ad0$export$2e2bcd8739ae039 = $8713c088cd428ad0$var$Column;


/* istanbul ignore next */ /** This is a syntactic sugar for `columns` prop. So HOC will not work on this. */ const $dbd4a530607439a8$var$ColumnGroup = (_)=>null;
var $dbd4a530607439a8$export$2e2bcd8739ae039 = $dbd4a530607439a8$var$ColumnGroup;




var $cQmXV = parcelRequire("cQmXV");





var $cQmXV = parcelRequire("cQmXV");
/**
 * Webpack has bug for import loop, which is not the same behavior as ES module.
 * When util.js imports the TreeNode for tree generate will cause treeContextTypes be empty.
 */ 
var $cQmXV = parcelRequire("cQmXV");
const $4b1e270ea77a2a43$export$dfae7d399eea2568 = /*#__PURE__*/ $cQmXV.createContext(null);
const $4b1e270ea77a2a43$export$e508d6f1a100e5dd = /*#__PURE__*/ $cQmXV.createContext({});



var $cQmXV = parcelRequire("cQmXV");
const $940c264849f39785$var$DropIndicator = (props)=>{
    const { dropPosition: dropPosition, dropLevelOffset: dropLevelOffset, indent: indent } = props;
    const style = {
        pointerEvents: "none",
        position: "absolute",
        right: 0,
        backgroundColor: "red",
        height: 2
    };
    switch(dropPosition){
        case -1:
            style.top = 0;
            style.left = -dropLevelOffset * indent;
            break;
        case 1:
            style.bottom = 0;
            style.left = -dropLevelOffset * indent;
            break;
        case 0:
            style.bottom = 0;
            style.left = indent;
            break;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
        style: style
    });
};
var $940c264849f39785$export$2e2bcd8739ae039 = $940c264849f39785$var$DropIndicator;





var $cQmXV = parcelRequire("cQmXV");




var $cQmXV = parcelRequire("cQmXV");


var $cQmXV = parcelRequire("cQmXV");





var $cQmXV = parcelRequire("cQmXV");
const $2416f488ca08cd0d$var$Indent = ({ prefixCls: prefixCls, level: level, isStart: isStart, isEnd: isEnd })=>{
    const baseClassName = `${prefixCls}-indent-unit`;
    const list = [];
    for(let i = 0; i < level; i += 1)list.push(/*#__PURE__*/ $cQmXV.createElement("span", {
        key: i,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(baseClassName, {
            [`${baseClassName}-start`]: isStart[i],
            [`${baseClassName}-end`]: isEnd[i]
        })
    }));
    return /*#__PURE__*/ $cQmXV.createElement("span", {
        "aria-hidden": "true",
        className: `${prefixCls}-indent`
    }, list);
};
var $2416f488ca08cd0d$export$2e2bcd8739ae039 = /*#__PURE__*/ $cQmXV.memo($2416f488ca08cd0d$var$Indent);


function $0c5b17dbfbfa5f0f$export$2e2bcd8739ae039(keyEntities, key) {
    return keyEntities[key];
}




function $718db4e60315df95$export$1690e12b840569b9(level, index) {
    return `${level}-${index}`;
}
function $718db4e60315df95$export$1c189858aa1437d7(node) {
    return node && node.type && node.type.isTreeNode;
}
function $718db4e60315df95$export$a47fb462a08de82f(key, pos) {
    if (key !== null && key !== undefined) return key;
    return pos;
}
function $718db4e60315df95$export$6c519d302dced239(fieldNames) {
    const { title: title, _title: _title, key: key, children: children } = fieldNames || {};
    const mergedTitle = title || "title";
    return {
        title: mergedTitle,
        _title: _title || [
            mergedTitle
        ],
        key: key || "key",
        children: children || "children"
    };
}
function $718db4e60315df95$export$702780ec64d148df(treeData, fieldNames) {
    const keys = new Map();
    function dig(list, path = "") {
        (list || []).forEach((treeNode)=>{
            const key = treeNode[fieldNames.key];
            const children = treeNode[fieldNames.children];
            (0, $26d7cf6379fe7659$export$2e2bcd8739ae039)(key !== null && key !== undefined, `Tree node must have a certain key: [${path}${key}]`);
            const recordKey = String(key);
            (0, $26d7cf6379fe7659$export$2e2bcd8739ae039)(!keys.has(recordKey) || key === null || key === undefined, `Same 'key' exist in the Tree: ${recordKey}`);
            keys.set(recordKey, true);
            dig(children, `${path}${recordKey} > `);
        });
    }
    dig(treeData);
}
function $718db4e60315df95$export$6d8b10995563b669(rootNodes) {
    function dig(node) {
        const treeNodes = (0, $cd966a313e0a92ff$export$2e2bcd8739ae039)(node);
        return treeNodes.map((treeNode)=>{
            // Filter invalidate node
            if (!$718db4e60315df95$export$1c189858aa1437d7(treeNode)) {
                (0, $26d7cf6379fe7659$export$2e2bcd8739ae039)(!treeNode, "Tree/TreeNode can only accept TreeNode as children.");
                return null;
            }
            const { key: key } = treeNode;
            const { children: children, ...rest } = treeNode.props;
            const dataNode = {
                key: key,
                ...rest
            };
            const parsedChildren = dig(children);
            if (parsedChildren.length) dataNode.children = parsedChildren;
            return dataNode;
        }).filter((dataNode)=>dataNode);
    }
    return dig(rootNodes);
}
function $718db4e60315df95$export$215c1b4f1ba88b23(treeNodeList, expandedKeys, fieldNames) {
    const { _title: fieldTitles, key: fieldKey, children: fieldChildren } = $718db4e60315df95$export$6c519d302dced239(fieldNames);
    const expandedKeySet = new Set(expandedKeys === true ? [] : expandedKeys);
    const flattenList = [];
    function dig(list, parent = null) {
        return list.map((treeNode, index)=>{
            const pos = $718db4e60315df95$export$1690e12b840569b9(parent ? parent.pos : "0", index);
            const mergedKey = $718db4e60315df95$export$a47fb462a08de82f(treeNode[fieldKey], pos);
            // Pick matched title in field title list
            let mergedTitle;
            for(let i = 0; i < fieldTitles.length; i += 1){
                const fieldTitle = fieldTitles[i];
                if (treeNode[fieldTitle] !== undefined) {
                    mergedTitle = treeNode[fieldTitle];
                    break;
                }
            }
            // Add FlattenDataNode into list
            // We use `Object.assign` here to save perf since babel's `objectSpread` has perf issue
            const flattenNode = Object.assign((0, $e8c5093aebad6025$export$2e2bcd8739ae039)(treeNode, [
                ...fieldTitles,
                fieldKey,
                fieldChildren
            ]), {
                title: mergedTitle,
                key: mergedKey,
                parent: parent,
                pos: pos,
                children: null,
                data: treeNode,
                isStart: [
                    ...parent ? parent.isStart : [],
                    index === 0
                ],
                isEnd: [
                    ...parent ? parent.isEnd : [],
                    index === list.length - 1
                ]
            });
            flattenList.push(flattenNode);
            // Loop treeNode children
            if (expandedKeys === true || expandedKeySet.has(mergedKey)) flattenNode.children = dig(treeNode[fieldChildren] || [], flattenNode);
            else flattenNode.children = [];
            return flattenNode;
        });
    }
    dig(treeNodeList);
    return flattenList;
}
function $718db4e60315df95$export$4b2e27469b557f9d(dataNodes, callback, // To avoid too many params, let use config instead of origin param
config) {
    const mergedConfig = typeof config === "object" ? config || {} : {
        externalGetKey: config
    };
    // Init config
    const { childrenPropName: childrenPropName, externalGetKey: externalGetKey, fieldNames: fieldNames } = mergedConfig;
    const { key: fieldKey, children: fieldChildren } = $718db4e60315df95$export$6c519d302dced239(fieldNames);
    const mergeChildrenPropName = childrenPropName || fieldChildren;
    // Get keys
    let syntheticGetKey;
    if (externalGetKey) {
        if (typeof externalGetKey === "string") syntheticGetKey = (node)=>node[externalGetKey];
        else if (typeof externalGetKey === "function") syntheticGetKey = (node)=>externalGetKey(node);
    } else syntheticGetKey = (node, pos)=>$718db4e60315df95$export$a47fb462a08de82f(node[fieldKey], pos);
    // Process
    function processNode(node, index, parent, pathNodes) {
        const children = node ? node[mergeChildrenPropName] : dataNodes;
        const pos = node ? $718db4e60315df95$export$1690e12b840569b9(parent.pos, index) : "0";
        const connectNodes = node ? [
            ...pathNodes,
            node
        ] : [];
        // Process node if is not root
        if (node) {
            const key = syntheticGetKey(node, pos);
            const data = {
                node: node,
                index: index,
                pos: pos,
                key: key,
                parentPos: parent.node ? parent.pos : null,
                level: parent.level + 1,
                nodes: connectNodes
            };
            callback(data);
        }
        // Process children node
        if (children) children.forEach((subNode, subIndex)=>{
            processNode(subNode, subIndex, {
                node: node,
                pos: pos,
                level: parent ? parent.level + 1 : -1
            }, connectNodes);
        });
    }
    processNode(null);
}
function $718db4e60315df95$export$e5d831ce033a4615(dataNodes, { initWrapper: initWrapper, processEntity: processEntity, onProcessFinished: onProcessFinished, externalGetKey: externalGetKey, childrenPropName: childrenPropName, fieldNames: fieldNames } = {}, /** @deprecated Use `config.externalGetKey` instead */ legacyExternalGetKey) {
    // Init config
    const mergedExternalGetKey = externalGetKey || legacyExternalGetKey;
    const posEntities = {};
    const keyEntities = {};
    let wrapper = {
        posEntities: posEntities,
        keyEntities: keyEntities
    };
    if (initWrapper) wrapper = initWrapper(wrapper) || wrapper;
    $718db4e60315df95$export$4b2e27469b557f9d(dataNodes, (item)=>{
        const { node: node, index: index, pos: pos, key: key, parentPos: parentPos, level: level, nodes: nodes } = item;
        const entity = {
            node: node,
            nodes: nodes,
            index: index,
            key: key,
            pos: pos,
            level: level
        };
        const mergedKey = $718db4e60315df95$export$a47fb462a08de82f(key, pos);
        posEntities[pos] = entity;
        keyEntities[mergedKey] = entity;
        // Fill children
        entity.parent = posEntities[parentPos];
        if (entity.parent) {
            entity.parent.children = entity.parent.children || [];
            entity.parent.children.push(entity);
        }
        if (processEntity) processEntity(entity, wrapper);
    }, {
        externalGetKey: mergedExternalGetKey,
        childrenPropName: childrenPropName,
        fieldNames: fieldNames
    });
    if (onProcessFinished) onProcessFinished(wrapper);
    return wrapper;
}
function $718db4e60315df95$export$335db82b86111fd1(isLeaf, loadData, hasChildren, loaded) {
    if (isLeaf === false) return false;
    return isLeaf || !loadData && !hasChildren || loadData && loaded && !hasChildren;
}
function $718db4e60315df95$export$d961fd523a514db5(key, { expandedKeys: expandedKeys, selectedKeys: selectedKeys, loadedKeys: loadedKeys, loadingKeys: loadingKeys, checkedKeys: checkedKeys, halfCheckedKeys: halfCheckedKeys, dragOverNodeKey: dragOverNodeKey, dropPosition: dropPosition, keyEntities: keyEntities }) {
    const entity = (0, $0c5b17dbfbfa5f0f$export$2e2bcd8739ae039)(keyEntities, key);
    const treeNodeProps = {
        eventKey: key,
        expanded: expandedKeys.indexOf(key) !== -1,
        selected: selectedKeys.indexOf(key) !== -1,
        loaded: loadedKeys.indexOf(key) !== -1,
        loading: loadingKeys.indexOf(key) !== -1,
        checked: checkedKeys.indexOf(key) !== -1,
        halfChecked: halfCheckedKeys.indexOf(key) !== -1,
        pos: String(entity ? entity.pos : ""),
        // [Legacy] Drag props
        // Since the interaction of drag is changed, the semantic of the props are
        // not accuracy, I think it should be finally removed
        dragOver: dragOverNodeKey === key && dropPosition === 0,
        dragOverGapTop: dragOverNodeKey === key && dropPosition === -1,
        dragOverGapBottom: dragOverNodeKey === key && dropPosition === 1
    };
    return treeNodeProps;
}
function $718db4e60315df95$export$7bd1b0fd4a8b540b(props) {
    const { data: data, expanded: expanded, selected: selected, checked: checked, loaded: loaded, loading: loading, halfChecked: halfChecked, dragOver: dragOver, dragOverGapTop: dragOverGapTop, dragOverGapBottom: dragOverGapBottom, pos: pos, active: active, eventKey: eventKey } = props;
    const eventData = {
        ...data,
        expanded: expanded,
        selected: selected,
        checked: checked,
        loaded: loaded,
        loading: loading,
        halfChecked: halfChecked,
        dragOver: dragOver,
        dragOverGapTop: dragOverGapTop,
        dragOverGapBottom: dragOverGapBottom,
        pos: pos,
        active: active,
        key: eventKey
    };
    if (!("props" in eventData)) Object.defineProperty(eventData, "props", {
        get () {
            (0, $26d7cf6379fe7659$export$2e2bcd8739ae039)(false, "Second param return from event is node data instead of TreeNode instance. Please read value directly instead of reading from `props`.");
            return props;
        }
    });
    return eventData;
}


function $b5ea155769c296e7$var$_extends() {
    $b5ea155769c296e7$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b5ea155769c296e7$var$_extends.apply(this, arguments);
}
const $b5ea155769c296e7$var$ICON_OPEN = "open";
const $b5ea155769c296e7$var$ICON_CLOSE = "close";
const $b5ea155769c296e7$var$defaultTitle = "---";
const $b5ea155769c296e7$var$TreeNode = (props)=>{
    const { eventKey: eventKey, className: className, style: style, dragOver: dragOver, dragOverGapTop: dragOverGapTop, dragOverGapBottom: dragOverGapBottom, isLeaf: isLeaf, isStart: isStart, isEnd: isEnd, expanded: expanded, selected: selected, checked: checked, halfChecked: halfChecked, loading: loading, domRef: domRef, active: active, data: data, onMouseMove: onMouseMove, selectable: selectable, treeId: treeId, ...otherProps } = props;
    const nodeId = (0, $a2da91bb60e2cbfb$export$218c8c3169c024d2)(treeId, eventKey);
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useContext((0, $4b1e270ea77a2a43$export$dfae7d399eea2568));
    const { classNames: treeClassNames, styles: styles } = context || {};
    const unstableContext = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useContext((0, $4b1e270ea77a2a43$export$e508d6f1a100e5dd));
    const selectHandleRef = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useRef(null);
    const [dragNodeHighlight, setDragNodeHighlight] = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useState(false);
    // ======= State: Disabled State =======
    const isDisabled = !!(context.disabled || props.disabled || unstableContext.nodeDisabled?.(data));
    const isCheckable = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useMemo(()=>{
        // Return false if tree or treeNode is not checkable
        if (!context.checkable || props.checkable === false) return false;
        return context.checkable;
    }, [
        context.checkable,
        props.checkable
    ]);
    // ======= Event Handlers: Selection and Check =======
    const onSelect = (e)=>{
        if (isDisabled) return;
        context.onNodeSelect(e, (0, $718db4e60315df95$export$7bd1b0fd4a8b540b)(props));
    };
    const onCheck = (e)=>{
        if (isDisabled) return;
        if (!isCheckable || props.disableCheckbox) return;
        context.onNodeCheck(e, (0, $718db4e60315df95$export$7bd1b0fd4a8b540b)(props), !checked);
    };
    // ======= State: Selectable Check =======
    const isSelectable = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useMemo(()=>{
        // Ignore when selectable is undefined or null
        if (typeof selectable === "boolean") return selectable;
        return context.selectable;
    }, [
        selectable,
        context.selectable
    ]);
    const onSelectorClick = (e)=>{
        // Click trigger before select/check operation
        context.onNodeClick(e, (0, $718db4e60315df95$export$7bd1b0fd4a8b540b)(props));
        if (isSelectable) onSelect(e);
        else onCheck(e);
    };
    const onSelectorDoubleClick = (e)=>{
        context.onNodeDoubleClick(e, (0, $718db4e60315df95$export$7bd1b0fd4a8b540b)(props));
    };
    const onMouseEnter = (e)=>{
        context.onNodeMouseEnter(e, (0, $718db4e60315df95$export$7bd1b0fd4a8b540b)(props));
    };
    const onMouseLeave = (e)=>{
        context.onNodeMouseLeave(e, (0, $718db4e60315df95$export$7bd1b0fd4a8b540b)(props));
    };
    const onContextMenu = (e)=>{
        context.onNodeContextMenu(e, (0, $718db4e60315df95$export$7bd1b0fd4a8b540b)(props));
    };
    // ======= Drag: Drag Enabled =======
    const isDraggable = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useMemo(()=>{
        return !!(context.draggable && (!context.draggable.nodeDraggable || context.draggable.nodeDraggable(data)));
    }, [
        context.draggable,
        data
    ]);
    // ======= Drag: Drag Event Handlers =======
    const onDragStart = (e)=>{
        e.stopPropagation();
        setDragNodeHighlight(true);
        context.onNodeDragStart(e, props);
        try {
            // ie throw error
            // firefox-need-it
            e.dataTransfer.setData("text/plain", "");
        } catch  {
        // empty
        }
    };
    const onDragEnter = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        context.onNodeDragEnter(e, props);
    };
    const onDragOver = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        context.onNodeDragOver(e, props);
    };
    const onDragLeave = (e)=>{
        e.stopPropagation();
        context.onNodeDragLeave(e, props);
    };
    const onDragEnd = (e)=>{
        e.stopPropagation();
        setDragNodeHighlight(false);
        context.onNodeDragEnd(e, props);
    };
    const onDrop = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        setDragNodeHighlight(false);
        context.onNodeDrop(e, props);
    };
    // ======= Expand: Node Expansion =======
    const onExpand = (e)=>{
        if (loading) return;
        context.onNodeExpand(e, (0, $718db4e60315df95$export$7bd1b0fd4a8b540b)(props));
    };
    // ======= State: Has Children =======
    const hasChildren = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useMemo(()=>{
        const { children: children } = (0, $0c5b17dbfbfa5f0f$export$2e2bcd8739ae039)(context.keyEntities, eventKey) || {};
        return Boolean((children || []).length);
    }, [
        context.keyEntities,
        eventKey
    ]);
    // ======= State: Leaf Check =======
    const memoizedIsLeaf = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useMemo(()=>{
        return (0, $718db4e60315df95$export$335db82b86111fd1)(isLeaf, context.loadData, hasChildren, props.loaded);
    }, [
        isLeaf,
        context.loadData,
        hasChildren,
        props.loaded
    ]);
    // ============== Effect ==============
    (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useEffect(()=>{
        // Load data to avoid default expanded tree without data
        if (loading) return;
        // read from state to avoid loadData at same time
        if (typeof context.loadData === "function" && expanded && !memoizedIsLeaf && !props.loaded) // We needn't reload data when has children in sync logic
        // It's only needed in node expanded
        context.onNodeLoad((0, $718db4e60315df95$export$7bd1b0fd4a8b540b)(props));
    }, [
        loading,
        context.loadData,
        context.onNodeLoad,
        expanded,
        memoizedIsLeaf,
        props
    ]);
    // ==================== Render: Drag Handler ====================
    const dragHandlerNode = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useMemo(()=>{
        if (!context.draggable?.icon) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("span", {
            className: `${context.prefixCls}-draggable-icon`
        }, context.draggable.icon);
    }, [
        context.draggable
    ]);
    // ====================== Render: Switcher ======================
    const renderSwitcherIconDom = (isInternalLeaf)=>{
        const switcherIcon = props.switcherIcon || context.switcherIcon;
        // if switcherIconDom is null, no render switcher span
        if (typeof switcherIcon === "function") return switcherIcon({
            ...props,
            isLeaf: isInternalLeaf
        });
        return switcherIcon;
    };
    // Switcher
    const renderSwitcher = ()=>{
        if (memoizedIsLeaf) {
            // if switcherIconDom is null, no render switcher span
            const switcherIconDom = renderSwitcherIconDom(true);
            return switcherIconDom !== false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("span", {
                className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${context.prefixCls}-switcher`, `${context.prefixCls}-switcher-noop`, treeClassNames?.itemSwitcher),
                style: styles?.itemSwitcher
            }, switcherIconDom) : null;
        }
        const switcherIconDom = renderSwitcherIconDom(false);
        return switcherIconDom !== false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("span", {
            onClick: onExpand,
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${context.prefixCls}-switcher`, `${context.prefixCls}-switcher_${expanded ? $b5ea155769c296e7$var$ICON_OPEN : $b5ea155769c296e7$var$ICON_CLOSE}`, treeClassNames?.itemSwitcher),
            style: styles?.itemSwitcher
        }, switcherIconDom) : null;
    };
    // ====================== Checkbox ======================
    const checkboxNode = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useMemo(()=>{
        if (!isCheckable) return null;
        // [Legacy] Custom element should be separate with `checkable` in future
        const $custom = typeof isCheckable !== "boolean" ? isCheckable : null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("span", {
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${context.prefixCls}-checkbox`, {
                [`${context.prefixCls}-checkbox-checked`]: checked,
                [`${context.prefixCls}-checkbox-indeterminate`]: !checked && halfChecked,
                [`${context.prefixCls}-checkbox-disabled`]: isDisabled || props.disableCheckbox
            }),
            onClick: onCheck,
            role: "checkbox",
            "aria-checked": halfChecked ? "mixed" : checked,
            "aria-disabled": isDisabled || props.disableCheckbox,
            "aria-labelledby": nodeId
        }, $custom);
    }, [
        isCheckable,
        checked,
        halfChecked,
        isDisabled,
        props.disableCheckbox,
        nodeId
    ]);
    // ============== State: Node State (Open/Close) ==============
    const nodeState = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useMemo(()=>{
        if (memoizedIsLeaf) return null;
        return expanded ? $b5ea155769c296e7$var$ICON_OPEN : $b5ea155769c296e7$var$ICON_CLOSE;
    }, [
        memoizedIsLeaf,
        expanded
    ]);
    // ==================== Render: Title + Icon ====================
    const iconNode = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useMemo(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("span", {
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(treeClassNames?.itemIcon, `${context.prefixCls}-iconEle`, `${context.prefixCls}-icon__${nodeState || "docu"}`, {
                [`${context.prefixCls}-icon_loading`]: loading
            }),
            style: styles?.itemIcon
        });
    }, [
        context.prefixCls,
        nodeState,
        loading
    ]);
    // =================== Drop Indicator ===================
    const dropIndicatorNode = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useMemo(()=>{
        const rootDraggable = Boolean(context.draggable);
        // allowDrop is calculated in Tree.tsx, there is no need for calc it here
        const showIndicator = !props.disabled && rootDraggable && context.dragOverNodeKey === eventKey;
        if (!showIndicator) return null;
        return context.dropIndicatorRender({
            dropPosition: context.dropPosition,
            dropLevelOffset: context.dropLevelOffset,
            indent: context.indent,
            prefixCls: context.prefixCls,
            direction: context.direction
        });
    }, [
        context.dropPosition,
        context.dropLevelOffset,
        context.indent,
        context.prefixCls,
        context.direction,
        context.draggable,
        context.dragOverNodeKey,
        context.dropIndicatorRender
    ]);
    // Icon + Title
    const selectorNode = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useMemo(()=>{
        const { title: title = $b5ea155769c296e7$var$defaultTitle } = props;
        const wrapClass = `${context.prefixCls}-node-content-wrapper`;
        // Icon - Still show loading icon when loading without showIcon
        let $icon;
        if (context.showIcon) {
            const currentIcon = props.icon || context.icon;
            $icon = currentIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("span", {
                className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(treeClassNames?.itemIcon, `${context.prefixCls}-iconEle`, `${context.prefixCls}-icon__customize`),
                style: styles?.itemIcon
            }, typeof currentIcon === "function" ? currentIcon(props) : currentIcon) : iconNode;
        } else if (context.loadData && loading) $icon = iconNode;
        // Title
        let titleNode;
        if (typeof title === "function") titleNode = title(data);
        else if (context.titleRender) titleNode = context.titleRender(data);
        else titleNode = title;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("span", {
            ref: selectHandleRef,
            title: typeof title === "string" ? title : "",
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(wrapClass, `${wrapClass}-${nodeState || "normal"}`, {
                [`${context.prefixCls}-node-selected`]: !isDisabled && (selected || dragNodeHighlight)
            }),
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onContextMenu: onContextMenu,
            onClick: onSelectorClick,
            onDoubleClick: onSelectorDoubleClick
        }, $icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("span", {
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${context.prefixCls}-title`, treeClassNames?.itemTitle),
            style: styles?.itemTitle
        }, titleNode), dropIndicatorNode);
    }, [
        context.prefixCls,
        context.showIcon,
        props,
        context.icon,
        iconNode,
        context.titleRender,
        data,
        nodeState,
        onMouseEnter,
        onMouseLeave,
        onContextMenu,
        onSelectorClick,
        onSelectorDoubleClick
    ]);
    const dataOrAriaAttributeProps = (0, $4b5c733d1d7bb306$export$2e2bcd8739ae039)(otherProps, {
        aria: true,
        data: true
    });
    const { level: level } = (0, $0c5b17dbfbfa5f0f$export$2e2bcd8739ae039)(context.keyEntities, eventKey) || {};
    const isEndNode = isEnd[isEnd.length - 1];
    const draggableWithoutDisabled = !isDisabled && isDraggable;
    const dragging = context.draggingNodeKey === eventKey;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", $b5ea155769c296e7$var$_extends({
        ref: domRef,
        role: "treeitem",
        id: nodeId,
        "aria-expanded": memoizedIsLeaf ? undefined : expanded,
        "aria-selected": isSelectable && !isDisabled ? selected : undefined,
        "aria-checked": isCheckable && !isDisabled ? halfChecked ? "mixed" : checked : undefined,
        "aria-disabled": isDisabled,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(className, `${context.prefixCls}-treenode`, treeClassNames?.item, {
            [`${context.prefixCls}-treenode-disabled`]: isDisabled,
            [`${context.prefixCls}-treenode-switcher-${expanded ? "open" : "close"}`]: !isLeaf,
            [`${context.prefixCls}-treenode-checkbox-checked`]: checked,
            [`${context.prefixCls}-treenode-checkbox-indeterminate`]: halfChecked,
            [`${context.prefixCls}-treenode-selected`]: selected,
            [`${context.prefixCls}-treenode-loading`]: loading,
            [`${context.prefixCls}-treenode-active`]: active,
            [`${context.prefixCls}-treenode-leaf-last`]: isEndNode,
            [`${context.prefixCls}-treenode-draggable`]: isDraggable,
            dragging: dragging,
            "drop-target": context.dropTargetKey === eventKey,
            "drop-container": context.dropContainerKey === eventKey,
            "drag-over": !isDisabled && dragOver,
            "drag-over-gap-top": !isDisabled && dragOverGapTop,
            "drag-over-gap-bottom": !isDisabled && dragOverGapBottom,
            "filter-node": context.filterTreeNode?.((0, $718db4e60315df95$export$7bd1b0fd4a8b540b)(props)),
            [`${context.prefixCls}-treenode-leaf`]: memoizedIsLeaf
        }),
        style: {
            ...style,
            ...styles?.item
        },
        draggable: draggableWithoutDisabled,
        onDragStart: draggableWithoutDisabled ? onDragStart : undefined,
        onDragEnter: isDraggable ? onDragEnter : undefined,
        onDragOver: isDraggable ? onDragOver : undefined,
        onDragLeave: isDraggable ? onDragLeave : undefined,
        onDrop: isDraggable ? onDrop : undefined,
        onDragEnd: isDraggable ? onDragEnd : undefined,
        onMouseMove: onMouseMove
    }, dataOrAriaAttributeProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $2416f488ca08cd0d$export$2e2bcd8739ae039), {
        prefixCls: context.prefixCls,
        level: level,
        isStart: isStart,
        isEnd: isEnd
    }), dragHandlerNode, renderSwitcher(), checkboxNode, selectorNode);
};
$b5ea155769c296e7$var$TreeNode.isTreeNode = 1;
var $b5ea155769c296e7$export$2e2bcd8739ae039 = $b5ea155769c296e7$var$TreeNode;



var $cQmXV = parcelRequire("cQmXV");

/**
 * Trigger only when component unmount
 */ function $5cc56a0d8449edae$var$useUnmount(triggerStart, triggerEnd) {
    const [firstMount, setFirstMount] = $cQmXV.useState(false);
    (0, $7673d874dab69d07$export$2e2bcd8739ae039)(()=>{
        if (firstMount) {
            triggerStart();
            return ()=>{
                triggerEnd();
            };
        }
    }, [
        firstMount
    ]);
    (0, $7673d874dab69d07$export$2e2bcd8739ae039)(()=>{
        setFirstMount(true);
        return ()=>{
            setFirstMount(false);
        };
    }, []);
}
var $5cc56a0d8449edae$export$2e2bcd8739ae039 = $5cc56a0d8449edae$var$useUnmount;



function $2522406ccf549dcc$var$_extends() {
    $2522406ccf549dcc$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2522406ccf549dcc$var$_extends.apply(this, arguments);
}
const $2522406ccf549dcc$var$MotionTreeNode = /*#__PURE__*/ $cQmXV.forwardRef((oriProps, ref)=>{
    const { className: className, style: style, motion: motion, motionNodes: motionNodes, motionType: motionType, onMotionStart: onOriginMotionStart, onMotionEnd: onOriginMotionEnd, active: active, treeNodeRequiredProps: treeNodeRequiredProps, ...props } = oriProps;
    const [visible, setVisible] = $cQmXV.useState(true);
    const { prefixCls: prefixCls } = $cQmXV.useContext((0, $4b1e270ea77a2a43$export$dfae7d399eea2568));
    // Calculate target visible here.
    // And apply in effect to make `leave` motion work.
    const targetVisible = motionNodes && motionType !== "hide";
    (0, $7673d874dab69d07$export$2e2bcd8739ae039)(()=>{
        if (motionNodes) {
            if (targetVisible !== visible) setVisible(targetVisible);
        }
    }, [
        motionNodes
    ]);
    const triggerMotionStart = ()=>{
        if (motionNodes) onOriginMotionStart();
    };
    // Should only trigger once
    const triggerMotionEndRef = $cQmXV.useRef(false);
    const triggerMotionEnd = ()=>{
        if (motionNodes && !triggerMotionEndRef.current) {
            triggerMotionEndRef.current = true;
            onOriginMotionEnd();
        }
    };
    // Effect if unmount
    (0, $5cc56a0d8449edae$export$2e2bcd8739ae039)(triggerMotionStart, triggerMotionEnd);
    // Motion end event
    const onVisibleChanged = (nextVisible)=>{
        if (targetVisible === nextVisible) triggerMotionEnd();
    };
    if (motionNodes) return /*#__PURE__*/ $cQmXV.createElement((0, $04c53b89814950f8$export$2e2bcd8739ae039), $2522406ccf549dcc$var$_extends({
        ref: ref,
        visible: visible
    }, motion, {
        motionAppear: motionType === "show",
        onVisibleChanged: onVisibleChanged
    }), ({ className: motionClassName, style: motionStyle }, motionRef)=>/*#__PURE__*/ $cQmXV.createElement("div", {
            ref: motionRef,
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-treenode-motion`, motionClassName),
            style: motionStyle
        }, motionNodes.map((treeNode)=>{
            const { data: { ...restProps }, title: title, key: key, isStart: isStart, isEnd: isEnd } = treeNode;
            delete restProps.children;
            const treeNodeProps = (0, $718db4e60315df95$export$d961fd523a514db5)(key, treeNodeRequiredProps);
            return /*#__PURE__*/ $cQmXV.createElement((0, $b5ea155769c296e7$export$2e2bcd8739ae039), $2522406ccf549dcc$var$_extends({}, restProps, treeNodeProps, {
                title: title,
                active: active,
                data: treeNode.data,
                key: key,
                isStart: isStart,
                isEnd: isEnd
            }));
        })));
    return /*#__PURE__*/ $cQmXV.createElement((0, $b5ea155769c296e7$export$2e2bcd8739ae039), $2522406ccf549dcc$var$_extends({
        domRef: ref,
        className: className,
        style: style
    }, props, {
        active: active
    }));
});
var $2522406ccf549dcc$export$2e2bcd8739ae039 = $2522406ccf549dcc$var$MotionTreeNode;


function $7723b1542d9bb1bf$export$d561f9b5d6be9236(prev = [], next = []) {
    const prevLen = prev.length;
    const nextLen = next.length;
    if (Math.abs(prevLen - nextLen) !== 1) return {
        add: false,
        key: null
    };
    function find(shorter, longer) {
        const cache = new Map();
        shorter.forEach((key)=>{
            cache.set(key, true);
        });
        const keys = longer.filter((key)=>!cache.has(key));
        return keys.length === 1 ? keys[0] : null;
    }
    if (prevLen < nextLen) return {
        add: true,
        key: find(prev, next)
    };
    return {
        add: false,
        key: find(next, prev)
    };
}
function $7723b1542d9bb1bf$export$d9cfb1169163442d(shorter, longer, key) {
    const shorterStartIndex = shorter.findIndex((data)=>data.key === key);
    const shorterEndNode = shorter[shorterStartIndex + 1];
    const longerStartIndex = longer.findIndex((data)=>data.key === key);
    if (shorterEndNode) {
        const longerEndIndex = longer.findIndex((data)=>data.key === shorterEndNode.key);
        return longer.slice(longerStartIndex + 1, longerEndIndex);
    }
    return longer.slice(longerStartIndex + 1);
}



function $92f07d99d8eaa73a$var$_extends() {
    $92f07d99d8eaa73a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $92f07d99d8eaa73a$var$_extends.apply(this, arguments);
}
const $92f07d99d8eaa73a$export$17c02cdd52a7d889 = `RC_TREE_MOTION_${Math.random()}`;
const $92f07d99d8eaa73a$var$MotionNode = {
    key: $92f07d99d8eaa73a$export$17c02cdd52a7d889
};
const $92f07d99d8eaa73a$export$2d18abad5109a402 = {
    key: $92f07d99d8eaa73a$export$17c02cdd52a7d889,
    level: 0,
    index: 0,
    pos: "0",
    node: $92f07d99d8eaa73a$var$MotionNode,
    nodes: [
        $92f07d99d8eaa73a$var$MotionNode
    ]
};
const $92f07d99d8eaa73a$var$MotionFlattenData = {
    parent: null,
    children: [],
    pos: $92f07d99d8eaa73a$export$2d18abad5109a402.pos,
    data: $92f07d99d8eaa73a$var$MotionNode,
    title: null,
    key: $92f07d99d8eaa73a$export$17c02cdd52a7d889,
    /** Hold empty list here since we do not use it */ isStart: [],
    isEnd: []
};
function $92f07d99d8eaa73a$export$435bacc8d7a01e14(list, virtual, height, itemHeight) {
    if (virtual === false || !height) return list;
    return list.slice(0, Math.ceil(height / itemHeight) + 1);
}
function $92f07d99d8eaa73a$var$itemKey(item) {
    const { key: key, pos: pos } = item;
    return (0, $718db4e60315df95$export$a47fb462a08de82f)(key, pos);
}
const $92f07d99d8eaa73a$var$NodeList = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { prefixCls: prefixCls, data: data, selectable: selectable, checkable: checkable, expandedKeys: expandedKeys, selectedKeys: selectedKeys, checkedKeys: checkedKeys, loadedKeys: loadedKeys, loadingKeys: loadingKeys, halfCheckedKeys: halfCheckedKeys, keyEntities: keyEntities, disabled: disabled, dragging: dragging, dragOverNodeKey: dragOverNodeKey, dropPosition: dropPosition, motion: motion, height: height, itemHeight: itemHeight, virtual: virtual, scrollWidth: scrollWidth, focusable: focusable, activeItem: activeItem, tabIndex: tabIndex, onKeyDown: onKeyDown, onFocus: onFocus, onBlur: onBlur, onMouseDown: onMouseDown, onActiveChange: onActiveChange, onListChangeStart: onListChangeStart, onListChangeEnd: onListChangeEnd, ...domProps } = props;
    const treeId = (0, $a2da91bb60e2cbfb$export$2e2bcd8739ae039)();
    // =============================== Ref ================================
    const listRef = $cQmXV.useRef(null);
    const indentMeasurerRef = $cQmXV.useRef(null);
    $cQmXV.useImperativeHandle(ref, ()=>({
            scrollTo: (scroll)=>{
                listRef.current.scrollTo(scroll);
            },
            getIndentWidth: ()=>indentMeasurerRef.current.offsetWidth
        }));
    // ============================== Motion ==============================
    const [prevExpandedKeys, setPrevExpandedKeys] = $cQmXV.useState(expandedKeys);
    const [prevData, setPrevData] = $cQmXV.useState(data);
    const [transitionData, setTransitionData] = $cQmXV.useState(data);
    const [transitionRange, setTransitionRange] = $cQmXV.useState([]);
    const [motionType, setMotionType] = $cQmXV.useState(null);
    // When motion end but data change, this will makes data back to previous one
    const dataRef = $cQmXV.useRef(data);
    dataRef.current = data;
    function onMotionEnd() {
        const latestData = dataRef.current;
        setPrevData(latestData);
        setTransitionData(latestData);
        setTransitionRange([]);
        setMotionType(null);
        onListChangeEnd();
    }
    // Do animation if expanded keys changed
    // layoutEffect here to avoid blink of node removing
    (0, $7673d874dab69d07$export$2e2bcd8739ae039)(()=>{
        setPrevExpandedKeys(expandedKeys);
        const diffExpanded = (0, $7723b1542d9bb1bf$export$d561f9b5d6be9236)(prevExpandedKeys, expandedKeys);
        if (diffExpanded.key !== null) {
            if (diffExpanded.add) {
                const keyIndex = prevData.findIndex(({ key: key })=>key === diffExpanded.key);
                const rangeNodes = $92f07d99d8eaa73a$export$435bacc8d7a01e14((0, $7723b1542d9bb1bf$export$d9cfb1169163442d)(prevData, data, diffExpanded.key), virtual, height, itemHeight);
                const newTransitionData = prevData.slice();
                newTransitionData.splice(keyIndex + 1, 0, $92f07d99d8eaa73a$var$MotionFlattenData);
                setTransitionData(newTransitionData);
                setTransitionRange(rangeNodes);
                setMotionType("show");
            } else {
                const keyIndex = data.findIndex(({ key: key })=>key === diffExpanded.key);
                const rangeNodes = $92f07d99d8eaa73a$export$435bacc8d7a01e14((0, $7723b1542d9bb1bf$export$d9cfb1169163442d)(data, prevData, diffExpanded.key), virtual, height, itemHeight);
                const newTransitionData = data.slice();
                newTransitionData.splice(keyIndex + 1, 0, $92f07d99d8eaa73a$var$MotionFlattenData);
                setTransitionData(newTransitionData);
                setTransitionRange(rangeNodes);
                setMotionType("hide");
            }
        } else if (prevData !== data) {
            // If whole data changed, we just refresh the list
            setPrevData(data);
            setTransitionData(data);
        }
    }, [
        expandedKeys,
        data
    ]);
    // We should clean up motion if is changed by dragging
    $cQmXV.useEffect(()=>{
        if (!dragging) onMotionEnd();
    }, [
        dragging
    ]);
    const mergedData = motion ? transitionData : data;
    const treeNodeRequiredProps = {
        expandedKeys: expandedKeys,
        selectedKeys: selectedKeys,
        loadedKeys: loadedKeys,
        loadingKeys: loadingKeys,
        checkedKeys: checkedKeys,
        halfCheckedKeys: halfCheckedKeys,
        dragOverNodeKey: dragOverNodeKey,
        dropPosition: dropPosition,
        keyEntities: keyEntities
    };
    return /*#__PURE__*/ $cQmXV.createElement($cQmXV.Fragment, null, /*#__PURE__*/ $cQmXV.createElement("div", {
        className: `${prefixCls}-treenode`,
        "aria-hidden": true,
        style: {
            position: "absolute",
            pointerEvents: "none",
            visibility: "hidden",
            height: 0,
            overflow: "hidden",
            border: 0,
            padding: 0
        }
    }, /*#__PURE__*/ $cQmXV.createElement("div", {
        className: `${prefixCls}-indent`
    }, /*#__PURE__*/ $cQmXV.createElement("div", {
        ref: indentMeasurerRef,
        className: `${prefixCls}-indent-unit`
    }))), /*#__PURE__*/ $cQmXV.createElement((0, $a9f0fc634fe20e3d$export$2e2bcd8739ae039), $92f07d99d8eaa73a$var$_extends({}, domProps, {
        data: mergedData,
        itemKey: $92f07d99d8eaa73a$var$itemKey,
        height: height,
        fullHeight: false,
        virtual: virtual,
        itemHeight: itemHeight,
        scrollWidth: scrollWidth,
        prefixCls: `${prefixCls}-list`,
        ref: listRef,
        role: "tree",
        tabIndex: focusable !== false && !disabled ? tabIndex : undefined,
        "aria-activedescendant": activeItem ? (0, $a2da91bb60e2cbfb$export$218c8c3169c024d2)(treeId, activeItem.key) : undefined,
        onKeyDown: onKeyDown,
        onFocus: onFocus,
        onBlur: onBlur,
        onMouseDown: onMouseDown,
        onVisibleChange: (originList)=>{
            // The best match is using `fullList` - `originList` = `restList`
            // and check the `restList` to see if has the MOTION_KEY node
            // but this will cause performance issue for long list compare
            // we just check `originList` and repeat trigger `onMotionEnd`
            if (originList.every((item)=>$92f07d99d8eaa73a$var$itemKey(item) !== $92f07d99d8eaa73a$export$17c02cdd52a7d889)) onMotionEnd();
        }
    }), (treeNode)=>{
        const { pos: pos, data: { ...restProps }, title: title, key: key, isStart: isStart, isEnd: isEnd } = treeNode;
        const mergedKey = (0, $718db4e60315df95$export$a47fb462a08de82f)(key, pos);
        delete restProps.key;
        delete restProps.children;
        const treeNodeProps = (0, $718db4e60315df95$export$d961fd523a514db5)(mergedKey, treeNodeRequiredProps);
        return /*#__PURE__*/ $cQmXV.createElement((0, $2522406ccf549dcc$export$2e2bcd8739ae039), $92f07d99d8eaa73a$var$_extends({}, restProps, treeNodeProps, {
            title: title,
            active: !!activeItem && key === activeItem.key,
            pos: pos,
            data: treeNode.data,
            isStart: isStart,
            isEnd: isEnd,
            motion: motion,
            motionNodes: key === $92f07d99d8eaa73a$export$17c02cdd52a7d889 ? transitionRange : null,
            motionType: motionType,
            onMotionStart: onListChangeStart,
            onMotionEnd: onMotionEnd,
            treeNodeRequiredProps: treeNodeRequiredProps,
            treeId: treeId,
            onMouseMove: ()=>{
                onActiveChange(null);
            }
        }));
    }));
});
var $92f07d99d8eaa73a$export$2e2bcd8739ae039 = $92f07d99d8eaa73a$var$NodeList;





var $cQmXV = parcelRequire("cQmXV");



function $9f5f4c60f5f7fe12$var$_extends() {
    $9f5f4c60f5f7fe12$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9f5f4c60f5f7fe12$var$_extends.apply(this, arguments);
}
function $9f5f4c60f5f7fe12$export$5bfb9ff497fe2298(list, value) {
    if (!list) return [];
    const clone = list.slice();
    const index = clone.indexOf(value);
    if (index >= 0) clone.splice(index, 1);
    return clone;
}
function $9f5f4c60f5f7fe12$export$10663f6bbd2fd717(list, value) {
    const clone = (list || []).slice();
    if (clone.indexOf(value) === -1) clone.push(value);
    return clone;
}
function $9f5f4c60f5f7fe12$export$ddaee97dc8907312(pos) {
    return pos.split("-");
}
function $9f5f4c60f5f7fe12$export$b0610c44bcbb051c(dragNodeKey, keyEntities) {
    // not contains self
    // self for left or right drag
    const dragChildrenKeys = [];
    const entity = (0, $0c5b17dbfbfa5f0f$export$2e2bcd8739ae039)(keyEntities, dragNodeKey);
    function dig(list = []) {
        list.forEach(({ key: key, children: children })=>{
            dragChildrenKeys.push(key);
            dig(children);
        });
    }
    dig(entity.children);
    return dragChildrenKeys;
}
function $9f5f4c60f5f7fe12$export$a9933931a4af6704(treeNodeEntity) {
    if (treeNodeEntity.parent) {
        const posArr = $9f5f4c60f5f7fe12$export$ddaee97dc8907312(treeNodeEntity.pos);
        return Number(posArr[posArr.length - 1]) === treeNodeEntity.parent.children.length - 1;
    }
    return false;
}
function $9f5f4c60f5f7fe12$export$b823688e4155eb8d(treeNodeEntity) {
    const posArr = $9f5f4c60f5f7fe12$export$ddaee97dc8907312(treeNodeEntity.pos);
    return Number(posArr[posArr.length - 1]) === 0;
}
function $9f5f4c60f5f7fe12$export$78a5519d0fb779c3(event, dragNodeProps, targetNodeProps, indent, startMousePosition, allowDrop, flattenedNodes, keyEntities, expandKeys, direction) {
    const { clientX: clientX, clientY: clientY } = event;
    const { top: top, height: height } = event.target.getBoundingClientRect();
    // optional chain for testing
    const horizontalMouseOffset = (direction === "rtl" ? -1 : 1) * ((startMousePosition?.x || 0) - clientX);
    const rawDropLevelOffset = (horizontalMouseOffset - 12) / indent;
    // Filter the expanded keys to exclude the node that not has children currently (like async nodes).
    const filteredExpandKeys = expandKeys.filter((key)=>keyEntities[key]?.children?.length);
    // find abstract drop node by horizontal offset
    let abstractDropNodeEntity = (0, $0c5b17dbfbfa5f0f$export$2e2bcd8739ae039)(keyEntities, targetNodeProps.eventKey);
    if (clientY < top + height / 2) {
        // first half, set abstract drop node to previous node
        const nodeIndex = flattenedNodes.findIndex((flattenedNode)=>flattenedNode.key === abstractDropNodeEntity.key);
        const prevNodeIndex = nodeIndex <= 0 ? 0 : nodeIndex - 1;
        const prevNodeKey = flattenedNodes[prevNodeIndex].key;
        abstractDropNodeEntity = (0, $0c5b17dbfbfa5f0f$export$2e2bcd8739ae039)(keyEntities, prevNodeKey);
    }
    const initialAbstractDropNodeKey = abstractDropNodeEntity.key;
    const abstractDragOverEntity = abstractDropNodeEntity;
    const dragOverNodeKey = abstractDropNodeEntity.key;
    let dropPosition = 0;
    let dropLevelOffset = 0;
    // Only allow cross level drop when dragging on a non-expanded node
    if (!filteredExpandKeys.includes(initialAbstractDropNodeKey)) for(let i = 0; i < rawDropLevelOffset; i += 1){
        if ($9f5f4c60f5f7fe12$export$a9933931a4af6704(abstractDropNodeEntity)) {
            abstractDropNodeEntity = abstractDropNodeEntity.parent;
            dropLevelOffset += 1;
        } else break;
    }
    const abstractDragDataNode = dragNodeProps.data;
    const abstractDropDataNode = abstractDropNodeEntity.node;
    let dropAllowed = true;
    if ($9f5f4c60f5f7fe12$export$b823688e4155eb8d(abstractDropNodeEntity) && abstractDropNodeEntity.level === 0 && clientY < top + height / 2 && allowDrop({
        dragNode: abstractDragDataNode,
        dropNode: abstractDropDataNode,
        dropPosition: -1
    }) && abstractDropNodeEntity.key === targetNodeProps.eventKey) // first half of first node in first level
    dropPosition = -1;
    else if ((abstractDragOverEntity.children || []).length && filteredExpandKeys.includes(dragOverNodeKey)) {
        // drop on expanded node
        // only allow drop inside
        if (allowDrop({
            dragNode: abstractDragDataNode,
            dropNode: abstractDropDataNode,
            dropPosition: 0
        })) dropPosition = 0;
        else dropAllowed = false;
    } else if (dropLevelOffset === 0) {
        if (rawDropLevelOffset > -1.5) {
            // | Node     | <- abstractDropNode
            // | -^-===== | <- mousePosition
            // 1. try drop after
            // 2. do not allow drop
            if (allowDrop({
                dragNode: abstractDragDataNode,
                dropNode: abstractDropDataNode,
                dropPosition: 1
            })) dropPosition = 1;
            else dropAllowed = false;
        } else {
            // | Node     | <- abstractDropNode
            // | ---==^== | <- mousePosition
            // whether it has children or doesn't has children
            // always
            // 1. try drop inside
            // 2. try drop after
            // 3. do not allow drop
            if (allowDrop({
                dragNode: abstractDragDataNode,
                dropNode: abstractDropDataNode,
                dropPosition: 0
            })) dropPosition = 0;
            else if (allowDrop({
                dragNode: abstractDragDataNode,
                dropNode: abstractDropDataNode,
                dropPosition: 1
            })) dropPosition = 1;
            else dropAllowed = false;
        }
    } else // | Node1 | <- abstractDropNode
    //      |  Node2  |
    // --^--|----=====| <- mousePosition
    // 1. try insert after Node1
    // 2. do not allow drop
    if (allowDrop({
        dragNode: abstractDragDataNode,
        dropNode: abstractDropDataNode,
        dropPosition: 1
    })) dropPosition = 1;
    else dropAllowed = false;
    return {
        dropPosition: dropPosition,
        dropLevelOffset: dropLevelOffset,
        dropTargetKey: abstractDropNodeEntity.key,
        dropTargetPos: abstractDropNodeEntity.pos,
        dragOverNodeKey: dragOverNodeKey,
        dropContainerKey: dropPosition === 0 ? null : abstractDropNodeEntity.parent?.key || null,
        dropAllowed: dropAllowed
    };
}
function $9f5f4c60f5f7fe12$export$fffc10811828fd68(selectedKeys, props) {
    if (!selectedKeys) return undefined;
    const { multiple: multiple } = props;
    if (multiple) return selectedKeys.slice();
    if (selectedKeys.length) return [
        selectedKeys[0]
    ];
    return selectedKeys;
}
const $9f5f4c60f5f7fe12$var$internalProcessProps = (props)=>props;
function $9f5f4c60f5f7fe12$export$b28621e8354d6749(treeData, processor) {
    if (!treeData) return [];
    const { processProps: processProps = $9f5f4c60f5f7fe12$var$internalProcessProps } = processor || {};
    const list = Array.isArray(treeData) ? treeData : [
        treeData
    ];
    return list.map(({ children: children, ...props })=>{
        const childrenNodes = $9f5f4c60f5f7fe12$export$b28621e8354d6749(children, processor);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $b5ea155769c296e7$export$2e2bcd8739ae039), $9f5f4c60f5f7fe12$var$_extends({
            key: props.key
        }, processProps(props)), childrenNodes);
    });
}
function $9f5f4c60f5f7fe12$export$29d4989c23990d41(keys) {
    if (!keys) return null;
    // Convert keys to object format
    let keyProps;
    if (Array.isArray(keys)) // [Legacy] Follow the api doc
    keyProps = {
        checkedKeys: keys,
        halfCheckedKeys: undefined
    };
    else if (typeof keys === "object") keyProps = {
        checkedKeys: keys.checked || undefined,
        halfCheckedKeys: keys.halfChecked || undefined
    };
    else {
        (0, $26d7cf6379fe7659$export$2e2bcd8739ae039)(false, "`checkedKeys` is not an array or an object");
        return null;
    }
    return keyProps;
}
function $9f5f4c60f5f7fe12$export$fac4a40c345ccd80(keyList, keyEntities) {
    const expandedKeys = new Set();
    function conductUp(key) {
        if (expandedKeys.has(key)) return;
        const entity = (0, $0c5b17dbfbfa5f0f$export$2e2bcd8739ae039)(keyEntities, key);
        if (!entity) return;
        expandedKeys.add(key);
        const { parent: parent, node: node } = entity;
        if (node.disabled) return;
        if (parent) conductUp(parent.key);
    }
    (keyList || []).forEach((key)=>{
        conductUp(key);
    });
    return [
        ...expandedKeys
    ];
}




function $22d84263da5951d2$var$removeFromCheckedKeys(halfCheckedKeys, checkedKeys) {
    const filteredKeys = new Set();
    halfCheckedKeys.forEach((key)=>{
        if (!checkedKeys.has(key)) filteredKeys.add(key);
    });
    return filteredKeys;
}
function $22d84263da5951d2$export$ab01c86170b1dea0(node) {
    const { disabled: disabled, disableCheckbox: disableCheckbox, checkable: checkable } = node || {};
    return !!(disabled || disableCheckbox) || checkable === false;
}
// Fill miss keys
function $22d84263da5951d2$var$fillConductCheck(keys, levelEntities, maxLevel, syntheticGetCheckDisabled) {
    const checkedKeys = new Set(keys);
    const halfCheckedKeys = new Set();
    // Add checked keys top to bottom
    for(let level = 0; level <= maxLevel; level += 1){
        const entities = levelEntities.get(level) || new Set();
        entities.forEach((entity)=>{
            const { key: key, node: node, children: children = [] } = entity;
            if (checkedKeys.has(key) && !syntheticGetCheckDisabled(node)) children.filter((childEntity)=>!syntheticGetCheckDisabled(childEntity.node)).forEach((childEntity)=>{
                checkedKeys.add(childEntity.key);
            });
        });
    }
    // Add checked keys from bottom to top
    const visitedKeys = new Set();
    for(let level = maxLevel; level >= 0; level -= 1){
        const entities = levelEntities.get(level) || new Set();
        entities.forEach((entity)=>{
            const { parent: parent, node: node } = entity;
            // Skip if no need to check
            if (syntheticGetCheckDisabled(node) || !entity.parent || visitedKeys.has(entity.parent.key)) return;
            // Skip if parent is disabled
            if (syntheticGetCheckDisabled(entity.parent.node)) {
                visitedKeys.add(parent.key);
                return;
            }
            let allChecked = true;
            let partialChecked = false;
            (parent.children || []).filter((childEntity)=>!syntheticGetCheckDisabled(childEntity.node)).forEach(({ key: key })=>{
                const checked = checkedKeys.has(key);
                if (allChecked && !checked) allChecked = false;
                if (!partialChecked && (checked || halfCheckedKeys.has(key))) partialChecked = true;
            });
            if (allChecked) checkedKeys.add(parent.key);
            if (partialChecked) halfCheckedKeys.add(parent.key);
            visitedKeys.add(parent.key);
        });
    }
    return {
        checkedKeys: Array.from(checkedKeys),
        halfCheckedKeys: Array.from($22d84263da5951d2$var$removeFromCheckedKeys(halfCheckedKeys, checkedKeys))
    };
}
// Remove useless key
function $22d84263da5951d2$var$cleanConductCheck(keys, halfKeys, levelEntities, maxLevel, syntheticGetCheckDisabled) {
    const checkedKeys = new Set(keys);
    let halfCheckedKeys = new Set(halfKeys);
    // Remove checked keys from top to bottom
    for(let level = 0; level <= maxLevel; level += 1){
        const entities = levelEntities.get(level) || new Set();
        entities.forEach((entity)=>{
            const { key: key, node: node, children: children = [] } = entity;
            if (!checkedKeys.has(key) && !halfCheckedKeys.has(key) && !syntheticGetCheckDisabled(node)) children.filter((childEntity)=>!syntheticGetCheckDisabled(childEntity.node)).forEach((childEntity)=>{
                checkedKeys.delete(childEntity.key);
            });
        });
    }
    // Remove checked keys form bottom to top
    halfCheckedKeys = new Set();
    const visitedKeys = new Set();
    for(let level = maxLevel; level >= 0; level -= 1){
        const entities = levelEntities.get(level) || new Set();
        entities.forEach((entity)=>{
            const { parent: parent, node: node } = entity;
            // Skip if no need to check
            if (syntheticGetCheckDisabled(node) || !entity.parent || visitedKeys.has(entity.parent.key)) return;
            // Skip if parent is disabled
            if (syntheticGetCheckDisabled(entity.parent.node)) {
                visitedKeys.add(parent.key);
                return;
            }
            let allChecked = true;
            let partialChecked = false;
            (parent.children || []).filter((childEntity)=>!syntheticGetCheckDisabled(childEntity.node)).forEach(({ key: key })=>{
                const checked = checkedKeys.has(key);
                if (allChecked && !checked) allChecked = false;
                if (!partialChecked && (checked || halfCheckedKeys.has(key))) partialChecked = true;
            });
            if (!allChecked) checkedKeys.delete(parent.key);
            if (partialChecked) halfCheckedKeys.add(parent.key);
            visitedKeys.add(parent.key);
        });
    }
    return {
        checkedKeys: Array.from(checkedKeys),
        halfCheckedKeys: Array.from($22d84263da5951d2$var$removeFromCheckedKeys(halfCheckedKeys, checkedKeys))
    };
}
function $22d84263da5951d2$export$43adf2c483e3e633(keyList, checked, keyEntities, getCheckDisabled) {
    const warningMissKeys = [];
    let syntheticGetCheckDisabled;
    if (getCheckDisabled) syntheticGetCheckDisabled = getCheckDisabled;
    else syntheticGetCheckDisabled = $22d84263da5951d2$export$ab01c86170b1dea0;
    // We only handle exist keys
    const keys = new Set(keyList.filter((key)=>{
        const hasEntity = !!(0, $0c5b17dbfbfa5f0f$export$2e2bcd8739ae039)(keyEntities, key);
        if (!hasEntity) warningMissKeys.push(key);
        return hasEntity;
    }));
    const levelEntities = new Map();
    let maxLevel = 0;
    // Convert entities by level for calculation
    Object.keys(keyEntities).forEach((key)=>{
        const entity = keyEntities[key];
        const { level: level } = entity;
        let levelSet = levelEntities.get(level);
        if (!levelSet) {
            levelSet = new Set();
            levelEntities.set(level, levelSet);
        }
        levelSet.add(entity);
        maxLevel = Math.max(maxLevel, level);
    });
    (0, $26d7cf6379fe7659$export$2e2bcd8739ae039)(!warningMissKeys.length, `Tree missing follow keys: ${warningMissKeys.slice(0, 100).map((key)=>`'${key}'`).join(", ")}`);
    let result;
    if (checked === true) result = $22d84263da5951d2$var$fillConductCheck(keys, levelEntities, maxLevel, syntheticGetCheckDisabled);
    else result = $22d84263da5951d2$var$cleanConductCheck(keys, checked.halfCheckedKeys, levelEntities, maxLevel, syntheticGetCheckDisabled);
    return result;
}




function $105186323c304ca2$var$_extends() {
    $105186323c304ca2$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $105186323c304ca2$var$_extends.apply(this, arguments);
}
const $105186323c304ca2$var$MAX_RETRY_TIMES = 10;
class $105186323c304ca2$var$Tree extends $cQmXV.Component {
    static defaultProps = {
        prefixCls: "rc-tree",
        showLine: false,
        showIcon: true,
        selectable: true,
        multiple: false,
        checkable: false,
        disabled: false,
        checkStrictly: false,
        draggable: false,
        defaultExpandParent: true,
        autoExpandParent: false,
        defaultExpandAll: false,
        defaultExpandedKeys: [],
        defaultCheckedKeys: [],
        defaultSelectedKeys: [],
        dropIndicatorRender: (0, $940c264849f39785$export$2e2bcd8739ae039),
        allowDrop: ()=>true,
        expandAction: false
    };
    static TreeNode = (0, $b5ea155769c296e7$export$2e2bcd8739ae039);
    destroyed = false;
    delayedDragEnterLogic;
    loadingRetryTimes = {};
    state = {
        keyEntities: {},
        indent: null,
        selectedKeys: [],
        checkedKeys: [],
        halfCheckedKeys: [],
        loadedKeys: [],
        loadingKeys: [],
        expandedKeys: [],
        draggingNodeKey: null,
        dragChildrenKeys: [],
        // dropTargetKey is the key of abstract-drop-node
        // the abstract-drop-node is the real drop node when drag and drop
        // not the DOM drag over node
        dropTargetKey: null,
        dropPosition: null,
        // the drop position of abstract-drop-node, inside 0, top -1, bottom 1
        dropContainerKey: null,
        // the container key of abstract-drop-node if dropPosition is -1 or 1
        dropLevelOffset: null,
        // the drop level offset of abstract-drag-over-node
        dropTargetPos: null,
        // the pos of abstract-drop-node
        dropAllowed: true,
        // if drop to abstract-drop-node is allowed
        // the abstract-drag-over-node
        // if mouse is on the bottom of top dom node or no the top of the bottom dom node
        // abstract-drag-over-node is the top node
        dragOverNodeKey: null,
        treeData: [],
        flattenNodes: [],
        activeKey: null,
        listChanging: false,
        prevProps: null,
        fieldNames: (0, $718db4e60315df95$export$6c519d302dced239)()
    };
    dragStartMousePosition = null;
    dragNodeProps = null;
    currentMouseOverDroppableNodeKey = null;
    focusedByMouse = false;
    listRef = /*#__PURE__*/ $cQmXV.createRef();
    componentDidMount() {
        this.destroyed = false;
        this.onUpdated();
        window.addEventListener("mouseup", this.onGlobalMouseUp);
    }
    componentDidUpdate() {
        this.onUpdated();
    }
    onUpdated() {
        const { activeKey: activeKey, itemScrollOffset: itemScrollOffset = 0 } = this.props;
        if (activeKey !== undefined && activeKey !== this.state.activeKey) {
            this.setState({
                activeKey: activeKey
            });
            if (activeKey !== null) this.scrollTo({
                key: activeKey,
                offset: itemScrollOffset
            });
        }
    }
    componentWillUnmount() {
        window.removeEventListener("dragend", this.onWindowDragEnd);
        window.removeEventListener("mouseup", this.onGlobalMouseUp);
        this.destroyed = true;
    }
    static getDerivedStateFromProps(props, prevState) {
        const { prevProps: prevProps } = prevState;
        const newState = {
            prevProps: props
        };
        function needSync(name) {
            return !prevProps && props.hasOwnProperty(name) || prevProps && prevProps[name] !== props[name];
        }
        // ================== Tree Node ==================
        let treeData;
        // fieldNames
        let { fieldNames: fieldNames } = prevState;
        if (needSync("fieldNames")) {
            fieldNames = (0, $718db4e60315df95$export$6c519d302dced239)(props.fieldNames);
            newState.fieldNames = fieldNames;
        }
        // Check if `treeData` or `children` changed and save into the state.
        if (needSync("treeData")) ({ treeData: treeData } = props);
        else if (needSync("children")) {
            (0, $26d7cf6379fe7659$export$2e2bcd8739ae039)(false, "`children` of Tree is deprecated. Please use `treeData` instead.");
            treeData = (0, $718db4e60315df95$export$6d8b10995563b669)(props.children);
        }
        // Save flatten nodes info and convert `treeData` into keyEntities
        if (treeData) {
            newState.treeData = treeData;
            const entitiesMap = (0, $718db4e60315df95$export$e5d831ce033a4615)(treeData, {
                fieldNames: fieldNames
            });
            newState.keyEntities = {
                [(0, $92f07d99d8eaa73a$export$17c02cdd52a7d889)]: (0, $92f07d99d8eaa73a$export$2d18abad5109a402),
                ...entitiesMap.keyEntities
            };
        }
        const keyEntities = newState.keyEntities || prevState.keyEntities;
        // ================ expandedKeys =================
        if (needSync("expandedKeys") || prevProps && needSync("autoExpandParent")) newState.expandedKeys = props.autoExpandParent || !prevProps && props.defaultExpandParent ? (0, $9f5f4c60f5f7fe12$export$fac4a40c345ccd80)(props.expandedKeys, keyEntities) : props.expandedKeys;
        else if (!prevProps && props.defaultExpandAll) {
            const cloneKeyEntities = {
                ...keyEntities
            };
            delete cloneKeyEntities[0, $92f07d99d8eaa73a$export$17c02cdd52a7d889];
            // Only take the key who has the children to enhance the performance
            const nextExpandedKeys = [];
            Object.keys(cloneKeyEntities).forEach((key)=>{
                const entity = cloneKeyEntities[key];
                if (entity.children && entity.children.length) nextExpandedKeys.push(entity.key);
            });
            newState.expandedKeys = nextExpandedKeys;
        } else if (!prevProps && props.defaultExpandedKeys) newState.expandedKeys = props.autoExpandParent || props.defaultExpandParent ? (0, $9f5f4c60f5f7fe12$export$fac4a40c345ccd80)(props.defaultExpandedKeys, keyEntities) : props.defaultExpandedKeys;
        if (!newState.expandedKeys) delete newState.expandedKeys;
        // ================ flattenNodes =================
        if (treeData || newState.expandedKeys) {
            const flattenNodes = (0, $718db4e60315df95$export$215c1b4f1ba88b23)(treeData || prevState.treeData, newState.expandedKeys || prevState.expandedKeys, fieldNames);
            newState.flattenNodes = flattenNodes;
        }
        // ================ selectedKeys =================
        if (props.selectable) {
            if (needSync("selectedKeys")) newState.selectedKeys = (0, $9f5f4c60f5f7fe12$export$fffc10811828fd68)(props.selectedKeys, props);
            else if (!prevProps && props.defaultSelectedKeys) newState.selectedKeys = (0, $9f5f4c60f5f7fe12$export$fffc10811828fd68)(props.defaultSelectedKeys, props);
        }
        // ================= checkedKeys =================
        if (props.checkable) {
            let checkedKeyEntity;
            if (needSync("checkedKeys")) checkedKeyEntity = (0, $9f5f4c60f5f7fe12$export$29d4989c23990d41)(props.checkedKeys) || {};
            else if (!prevProps && props.defaultCheckedKeys) checkedKeyEntity = (0, $9f5f4c60f5f7fe12$export$29d4989c23990d41)(props.defaultCheckedKeys) || {};
            else if (treeData) // If `treeData` changed, we also need check it
            checkedKeyEntity = (0, $9f5f4c60f5f7fe12$export$29d4989c23990d41)(props.checkedKeys) || {
                checkedKeys: prevState.checkedKeys,
                halfCheckedKeys: prevState.halfCheckedKeys
            };
            if (checkedKeyEntity) {
                let { checkedKeys: checkedKeys = [], halfCheckedKeys: halfCheckedKeys = [] } = checkedKeyEntity;
                if (!props.checkStrictly) {
                    const conductKeys = (0, $22d84263da5951d2$export$43adf2c483e3e633)(checkedKeys, true, keyEntities);
                    ({ checkedKeys: checkedKeys, halfCheckedKeys: halfCheckedKeys } = conductKeys);
                }
                newState.checkedKeys = checkedKeys;
                newState.halfCheckedKeys = halfCheckedKeys;
            }
        }
        // ================= loadedKeys ==================
        if (needSync("loadedKeys")) newState.loadedKeys = props.loadedKeys;
        return newState;
    }
    onNodeDragStart = (event, nodeProps)=>{
        const { expandedKeys: expandedKeys, keyEntities: keyEntities } = this.state;
        const { onDragStart: onDragStart } = this.props;
        const { eventKey: eventKey } = nodeProps;
        this.dragNodeProps = nodeProps;
        this.dragStartMousePosition = {
            x: event.clientX,
            y: event.clientY
        };
        const newExpandedKeys = (0, $9f5f4c60f5f7fe12$export$5bfb9ff497fe2298)(expandedKeys, eventKey);
        this.setState({
            draggingNodeKey: eventKey,
            dragChildrenKeys: (0, $9f5f4c60f5f7fe12$export$b0610c44bcbb051c)(eventKey, keyEntities),
            indent: this.listRef.current.getIndentWidth()
        });
        this.setExpandedKeys(newExpandedKeys);
        window.addEventListener("dragend", this.onWindowDragEnd);
        onDragStart?.({
            event: event,
            node: (0, $718db4e60315df95$export$7bd1b0fd4a8b540b)(nodeProps)
        });
    };
    /**
   * [Legacy] Select handler is smaller than node,
   * so that this will trigger when drag enter node or select handler.
   * This is a little tricky if customize css without padding.
   * Better for use mouse move event to refresh drag state.
   * But let's just keep it to avoid event trigger logic change.
   */ onNodeDragEnter = (event, nodeProps)=>{
        const { expandedKeys: expandedKeys, keyEntities: keyEntities, dragChildrenKeys: dragChildrenKeys, flattenNodes: flattenNodes, indent: indent } = this.state;
        const { onDragEnter: onDragEnter, onExpand: onExpand, allowDrop: allowDrop, direction: direction } = this.props;
        const { pos: pos, eventKey: eventKey } = nodeProps;
        // record the key of node which is latest entered, used in dragleave event.
        if (this.currentMouseOverDroppableNodeKey !== eventKey) this.currentMouseOverDroppableNodeKey = eventKey;
        if (!this.dragNodeProps) {
            this.resetDragState();
            return;
        }
        const { dropPosition: dropPosition, dropLevelOffset: dropLevelOffset, dropTargetKey: dropTargetKey, dropContainerKey: dropContainerKey, dropTargetPos: dropTargetPos, dropAllowed: dropAllowed, dragOverNodeKey: dragOverNodeKey } = (0, $9f5f4c60f5f7fe12$export$78a5519d0fb779c3)(event, this.dragNodeProps, nodeProps, indent, this.dragStartMousePosition, allowDrop, flattenNodes, keyEntities, expandedKeys, direction);
        if (// don't allow drop inside its children
        dragChildrenKeys.includes(dropTargetKey) || // don't allow drop when drop is not allowed caculated by calcDropPosition
        !dropAllowed) {
            this.resetDragState();
            return;
        }
        // Side effect for delay drag
        if (!this.delayedDragEnterLogic) this.delayedDragEnterLogic = {};
        Object.keys(this.delayedDragEnterLogic).forEach((key)=>{
            clearTimeout(this.delayedDragEnterLogic[key]);
        });
        if (this.dragNodeProps.eventKey !== nodeProps.eventKey) {
            // hoist expand logic here
            // since if logic is on the bottom
            // it will be blocked by abstract dragover node check
            //   => if you dragenter from top, you mouse will still be consider as in the top node
            event.persist();
            this.delayedDragEnterLogic[pos] = window.setTimeout(()=>{
                if (this.state.draggingNodeKey === null) return;
                let newExpandedKeys = [
                    ...expandedKeys
                ];
                const entity = (0, $0c5b17dbfbfa5f0f$export$2e2bcd8739ae039)(keyEntities, nodeProps.eventKey);
                if (entity && (entity.children || []).length) newExpandedKeys = (0, $9f5f4c60f5f7fe12$export$10663f6bbd2fd717)(expandedKeys, nodeProps.eventKey);
                this.setExpandedKeys(newExpandedKeys);
                onExpand?.(newExpandedKeys, {
                    node: (0, $718db4e60315df95$export$7bd1b0fd4a8b540b)(nodeProps),
                    expanded: true,
                    nativeEvent: event.nativeEvent
                });
            }, 800);
        }
        // Skip if drag node is self
        if (this.dragNodeProps.eventKey === dropTargetKey && dropLevelOffset === 0) {
            this.resetDragState();
            return;
        }
        // Update drag over node and drag state
        this.setState({
            dragOverNodeKey: dragOverNodeKey,
            dropPosition: dropPosition,
            dropLevelOffset: dropLevelOffset,
            dropTargetKey: dropTargetKey,
            dropContainerKey: dropContainerKey,
            dropTargetPos: dropTargetPos,
            dropAllowed: dropAllowed
        });
        onDragEnter?.({
            event: event,
            node: (0, $718db4e60315df95$export$7bd1b0fd4a8b540b)(nodeProps),
            expandedKeys: expandedKeys
        });
    };
    onNodeDragOver = (event, nodeProps)=>{
        const { dragChildrenKeys: dragChildrenKeys, flattenNodes: flattenNodes, keyEntities: keyEntities, expandedKeys: expandedKeys, indent: indent } = this.state;
        const { onDragOver: onDragOver, allowDrop: allowDrop, direction: direction } = this.props;
        if (!this.dragNodeProps) return;
        const { dropPosition: dropPosition, dropLevelOffset: dropLevelOffset, dropTargetKey: dropTargetKey, dropContainerKey: dropContainerKey, dropTargetPos: dropTargetPos, dropAllowed: dropAllowed, dragOverNodeKey: dragOverNodeKey } = (0, $9f5f4c60f5f7fe12$export$78a5519d0fb779c3)(event, this.dragNodeProps, nodeProps, indent, this.dragStartMousePosition, allowDrop, flattenNodes, keyEntities, expandedKeys, direction);
        if (dragChildrenKeys.includes(dropTargetKey) || !dropAllowed) // don't allow drop inside its children
        // don't allow drop when drop is not allowed calculated by calcDropPosition
        return;
        // Update drag position
        if (this.dragNodeProps.eventKey === dropTargetKey && dropLevelOffset === 0) {
            if (!(this.state.dropPosition === null && this.state.dropLevelOffset === null && this.state.dropTargetKey === null && this.state.dropContainerKey === null && this.state.dropTargetPos === null && this.state.dropAllowed === false && this.state.dragOverNodeKey === null)) this.resetDragState();
        } else if (!(dropPosition === this.state.dropPosition && dropLevelOffset === this.state.dropLevelOffset && dropTargetKey === this.state.dropTargetKey && dropContainerKey === this.state.dropContainerKey && dropTargetPos === this.state.dropTargetPos && dropAllowed === this.state.dropAllowed && dragOverNodeKey === this.state.dragOverNodeKey)) this.setState({
            dropPosition: dropPosition,
            dropLevelOffset: dropLevelOffset,
            dropTargetKey: dropTargetKey,
            dropContainerKey: dropContainerKey,
            dropTargetPos: dropTargetPos,
            dropAllowed: dropAllowed,
            dragOverNodeKey: dragOverNodeKey
        });
        onDragOver?.({
            event: event,
            node: (0, $718db4e60315df95$export$7bd1b0fd4a8b540b)(nodeProps)
        });
    };
    onNodeDragLeave = (event, nodeProps)=>{
        // if it is outside the droppable area
        // currentMouseOverDroppableNodeKey will be updated in dragenter event when into another droppable receiver.
        if (this.currentMouseOverDroppableNodeKey === nodeProps.eventKey && !event.currentTarget.contains(event.relatedTarget)) {
            this.resetDragState();
            this.currentMouseOverDroppableNodeKey = null;
        }
        const { onDragLeave: onDragLeave } = this.props;
        onDragLeave?.({
            event: event,
            node: (0, $718db4e60315df95$export$7bd1b0fd4a8b540b)(nodeProps)
        });
    };
    // since stopPropagation() is called in treeNode
    // if onWindowDrag is called, whice means state is keeped, drag state should be cleared
    onWindowDragEnd = (event)=>{
        this.onNodeDragEnd(event, null, true);
        window.removeEventListener("dragend", this.onWindowDragEnd);
    };
    // if onNodeDragEnd is called, onWindowDragEnd won't be called since stopPropagation() is called
    onNodeDragEnd = (event, nodeProps)=>{
        const { onDragEnd: onDragEnd } = this.props;
        this.setState({
            dragOverNodeKey: null
        });
        this.cleanDragState();
        onDragEnd?.({
            event: event,
            node: (0, $718db4e60315df95$export$7bd1b0fd4a8b540b)(nodeProps)
        });
        this.dragNodeProps = null;
        window.removeEventListener("dragend", this.onWindowDragEnd);
    };
    onNodeDrop = (event, _, outsideTree = false)=>{
        const { dragChildrenKeys: dragChildrenKeys, dropPosition: dropPosition, dropTargetKey: dropTargetKey, dropTargetPos: dropTargetPos, dropAllowed: dropAllowed } = this.state;
        if (!dropAllowed) return;
        const { onDrop: onDrop } = this.props;
        this.setState({
            dragOverNodeKey: null
        });
        this.cleanDragState();
        if (dropTargetKey === null) return;
        const abstractDropNodeProps = {
            ...(0, $718db4e60315df95$export$d961fd523a514db5)(dropTargetKey, this.getTreeNodeRequiredProps()),
            active: this.getActiveItem()?.key === dropTargetKey,
            data: (0, $0c5b17dbfbfa5f0f$export$2e2bcd8739ae039)(this.state.keyEntities, dropTargetKey).node
        };
        const dropToChild = dragChildrenKeys.includes(dropTargetKey);
        (0, $26d7cf6379fe7659$export$2e2bcd8739ae039)(!dropToChild, "Can not drop to dragNode's children node. This is a bug of rc-tree. Please report an issue.");
        const posArr = (0, $9f5f4c60f5f7fe12$export$ddaee97dc8907312)(dropTargetPos);
        const dropResult = {
            event: event,
            node: (0, $718db4e60315df95$export$7bd1b0fd4a8b540b)(abstractDropNodeProps),
            dragNode: this.dragNodeProps ? (0, $718db4e60315df95$export$7bd1b0fd4a8b540b)(this.dragNodeProps) : null,
            dragNodesKeys: [
                this.dragNodeProps.eventKey
            ].concat(dragChildrenKeys),
            dropToGap: dropPosition !== 0,
            dropPosition: dropPosition + Number(posArr[posArr.length - 1])
        };
        if (!outsideTree) onDrop?.(dropResult);
        this.dragNodeProps = null;
    };
    resetDragState() {
        this.setState({
            dragOverNodeKey: null,
            dropPosition: null,
            dropLevelOffset: null,
            dropTargetKey: null,
            dropContainerKey: null,
            dropTargetPos: null,
            dropAllowed: false
        });
    }
    cleanDragState = ()=>{
        const { draggingNodeKey: draggingNodeKey } = this.state;
        if (draggingNodeKey !== null) this.setState({
            draggingNodeKey: null,
            dropPosition: null,
            dropContainerKey: null,
            dropTargetKey: null,
            dropLevelOffset: null,
            dropAllowed: true,
            dragOverNodeKey: null
        });
        this.dragStartMousePosition = null;
        this.currentMouseOverDroppableNodeKey = null;
    };
    triggerExpandActionExpand = (e, treeNode)=>{
        const { expandedKeys: expandedKeys, flattenNodes: flattenNodes } = this.state;
        const { expanded: expanded, key: key, isLeaf: isLeaf } = treeNode;
        if (isLeaf || e.shiftKey || e.metaKey || e.ctrlKey) return;
        const node = flattenNodes.filter((nodeItem)=>nodeItem.key === key)[0];
        const eventNode = (0, $718db4e60315df95$export$7bd1b0fd4a8b540b)({
            ...(0, $718db4e60315df95$export$d961fd523a514db5)(key, this.getTreeNodeRequiredProps()),
            data: node.data
        });
        this.setExpandedKeys(expanded ? (0, $9f5f4c60f5f7fe12$export$5bfb9ff497fe2298)(expandedKeys, key) : (0, $9f5f4c60f5f7fe12$export$10663f6bbd2fd717)(expandedKeys, key));
        this.onNodeExpand(e, eventNode);
    };
    onNodeClick = (e, treeNode)=>{
        const { onClick: onClick, expandAction: expandAction } = this.props;
        if (expandAction === "click") this.triggerExpandActionExpand(e, treeNode);
        onClick?.(e, treeNode);
    };
    onNodeDoubleClick = (e, treeNode)=>{
        const { onDoubleClick: onDoubleClick, expandAction: expandAction } = this.props;
        if (expandAction === "doubleClick") this.triggerExpandActionExpand(e, treeNode);
        onDoubleClick?.(e, treeNode);
    };
    onNodeSelect = (e, treeNode)=>{
        let { selectedKeys: selectedKeys } = this.state;
        const { keyEntities: keyEntities, fieldNames: fieldNames } = this.state;
        const { onSelect: onSelect, multiple: multiple } = this.props;
        const { selected: selected } = treeNode;
        const key = treeNode[fieldNames.key];
        const targetSelected = !selected;
        // Update selected keys
        if (!targetSelected) selectedKeys = (0, $9f5f4c60f5f7fe12$export$5bfb9ff497fe2298)(selectedKeys, key);
        else if (!multiple) selectedKeys = [
            key
        ];
        else selectedKeys = (0, $9f5f4c60f5f7fe12$export$10663f6bbd2fd717)(selectedKeys, key);
        // [Legacy] Not found related usage in doc or upper libs
        const selectedNodes = selectedKeys.map((selectedKey)=>{
            const entity = (0, $0c5b17dbfbfa5f0f$export$2e2bcd8739ae039)(keyEntities, selectedKey);
            return entity ? entity.node : null;
        }).filter(Boolean);
        this.setUncontrolledState({
            selectedKeys: selectedKeys
        });
        onSelect?.(selectedKeys, {
            event: "select",
            selected: targetSelected,
            node: treeNode,
            selectedNodes: selectedNodes,
            nativeEvent: e.nativeEvent
        });
    };
    onNodeCheck = (e, treeNode, checked)=>{
        const { keyEntities: keyEntities, checkedKeys: oriCheckedKeys, halfCheckedKeys: oriHalfCheckedKeys } = this.state;
        const { checkStrictly: checkStrictly, onCheck: onCheck } = this.props;
        const { key: key } = treeNode;
        // Prepare trigger arguments
        let checkedObj;
        const eventObj = {
            event: "check",
            node: treeNode,
            checked: checked,
            nativeEvent: e.nativeEvent
        };
        if (checkStrictly) {
            const checkedKeys = checked ? (0, $9f5f4c60f5f7fe12$export$10663f6bbd2fd717)(oriCheckedKeys, key) : (0, $9f5f4c60f5f7fe12$export$5bfb9ff497fe2298)(oriCheckedKeys, key);
            const halfCheckedKeys = (0, $9f5f4c60f5f7fe12$export$5bfb9ff497fe2298)(oriHalfCheckedKeys, key);
            checkedObj = {
                checked: checkedKeys,
                halfChecked: halfCheckedKeys
            };
            eventObj.checkedNodes = checkedKeys.map((checkedKey)=>(0, $0c5b17dbfbfa5f0f$export$2e2bcd8739ae039)(keyEntities, checkedKey)).filter(Boolean).map((entity)=>entity.node);
            this.setUncontrolledState({
                checkedKeys: checkedKeys
            });
        } else {
            // Always fill first
            let { checkedKeys: checkedKeys, halfCheckedKeys: halfCheckedKeys } = (0, $22d84263da5951d2$export$43adf2c483e3e633)([
                ...oriCheckedKeys,
                key
            ], true, keyEntities);
            // If remove, we do it again to correction
            if (!checked) {
                const keySet = new Set(checkedKeys);
                keySet.delete(key);
                ({ checkedKeys: checkedKeys, halfCheckedKeys: halfCheckedKeys } = (0, $22d84263da5951d2$export$43adf2c483e3e633)(Array.from(keySet), {
                    checked: false,
                    halfCheckedKeys: halfCheckedKeys
                }, keyEntities));
            }
            checkedObj = checkedKeys;
            // [Legacy] This is used for `rc-tree-select`
            eventObj.checkedNodes = [];
            eventObj.checkedNodesPositions = [];
            eventObj.halfCheckedKeys = halfCheckedKeys;
            checkedKeys.forEach((checkedKey)=>{
                const entity = (0, $0c5b17dbfbfa5f0f$export$2e2bcd8739ae039)(keyEntities, checkedKey);
                if (!entity) return;
                const { node: node, pos: pos } = entity;
                eventObj.checkedNodes.push(node);
                eventObj.checkedNodesPositions.push({
                    node: node,
                    pos: pos
                });
            });
            this.setUncontrolledState({
                checkedKeys: checkedKeys
            }, false, {
                halfCheckedKeys: halfCheckedKeys
            });
        }
        onCheck?.(checkedObj, eventObj);
    };
    onNodeLoad = (treeNode)=>{
        const { key: key } = treeNode;
        const { keyEntities: keyEntities } = this.state;
        // Skip if has children already
        const entity = (0, $0c5b17dbfbfa5f0f$export$2e2bcd8739ae039)(keyEntities, key);
        if (entity?.children?.length) return;
        const loadPromise = new Promise((resolve, reject)=>{
            // We need to get the latest state of loading/loaded keys
            this.setState(({ loadedKeys: loadedKeys = [], loadingKeys: loadingKeys = [] })=>{
                const { loadData: loadData, onLoad: onLoad } = this.props;
                if (!loadData || loadedKeys.includes(key) || loadingKeys.includes(key)) return null;
                // Process load data
                const promise = loadData(treeNode);
                promise.then(()=>{
                    const { loadedKeys: currentLoadedKeys } = this.state;
                    const newLoadedKeys = (0, $9f5f4c60f5f7fe12$export$10663f6bbd2fd717)(currentLoadedKeys, key);
                    // onLoad should trigger before internal setState to avoid `loadData` trigger twice.
                    // https://github.com/ant-design/ant-design/issues/12464
                    onLoad?.(newLoadedKeys, {
                        event: "load",
                        node: treeNode
                    });
                    this.setUncontrolledState({
                        loadedKeys: newLoadedKeys
                    });
                    this.setState((prevState)=>({
                            loadingKeys: (0, $9f5f4c60f5f7fe12$export$5bfb9ff497fe2298)(prevState.loadingKeys, key)
                        }));
                    resolve();
                }).catch((e)=>{
                    this.setState((prevState)=>({
                            loadingKeys: (0, $9f5f4c60f5f7fe12$export$5bfb9ff497fe2298)(prevState.loadingKeys, key)
                        }));
                    // If exceed max retry times, we give up retry
                    this.loadingRetryTimes[key] = (this.loadingRetryTimes[key] || 0) + 1;
                    if (this.loadingRetryTimes[key] >= $105186323c304ca2$var$MAX_RETRY_TIMES) {
                        const { loadedKeys: currentLoadedKeys } = this.state;
                        (0, $26d7cf6379fe7659$export$2e2bcd8739ae039)(false, "Retry for `loadData` many times but still failed. No more retry.");
                        this.setUncontrolledState({
                            loadedKeys: (0, $9f5f4c60f5f7fe12$export$10663f6bbd2fd717)(currentLoadedKeys, key)
                        });
                        resolve();
                    }
                    reject(e);
                });
                return {
                    loadingKeys: (0, $9f5f4c60f5f7fe12$export$10663f6bbd2fd717)(loadingKeys, key)
                };
            });
        });
        // Not care warning if we ignore this
        loadPromise.catch(()=>{});
        return loadPromise;
    };
    onNodeMouseEnter = (event, node)=>{
        const { onMouseEnter: onMouseEnter } = this.props;
        onMouseEnter?.({
            event: event,
            node: node
        });
    };
    onNodeMouseLeave = (event, node)=>{
        const { onMouseLeave: onMouseLeave } = this.props;
        onMouseLeave?.({
            event: event,
            node: node
        });
    };
    onNodeContextMenu = (event, node)=>{
        const { onRightClick: onRightClick } = this.props;
        if (onRightClick) {
            event.preventDefault();
            onRightClick({
                event: event,
                node: node
            });
        }
    };
    onMouseDown = (event)=>{
        this.focusedByMouse = true;
        const { onMouseDown: onMouseDown } = this.props;
        onMouseDown?.(event);
    };
    onGlobalMouseUp = ()=>{
        this.focusedByMouse = false;
    };
    onFocus = (...args)=>{
        const { onFocus: onFocus, disabled: disabled } = this.props;
        const { activeKey: activeKey, selectedKeys: selectedKeys, flattenNodes: flattenNodes } = this.state;
        if (!this.focusedByMouse && !disabled && activeKey === null) {
            const visibleSelectedKey = selectedKeys.find((key)=>{
                return flattenNodes.some((nodeItem)=>nodeItem.key === key);
            });
            if (visibleSelectedKey !== undefined) this.onActiveChange(visibleSelectedKey);
            else this.onActiveChange(flattenNodes?.[0]?.key || null);
        }
        onFocus?.(...args);
    };
    onBlur = (...args)=>{
        const { onBlur: onBlur } = this.props;
        this.onActiveChange(null);
        onBlur?.(...args);
    };
    getTreeNodeRequiredProps = ()=>{
        const { expandedKeys: expandedKeys, selectedKeys: selectedKeys, loadedKeys: loadedKeys, loadingKeys: loadingKeys, checkedKeys: checkedKeys, halfCheckedKeys: halfCheckedKeys, dragOverNodeKey: dragOverNodeKey, dropPosition: dropPosition, keyEntities: keyEntities } = this.state;
        return {
            expandedKeys: expandedKeys || [],
            selectedKeys: selectedKeys || [],
            loadedKeys: loadedKeys || [],
            loadingKeys: loadingKeys || [],
            checkedKeys: checkedKeys || [],
            halfCheckedKeys: halfCheckedKeys || [],
            dragOverNodeKey: dragOverNodeKey,
            dropPosition: dropPosition,
            keyEntities: keyEntities
        };
    };
    // =========================== Expanded ===========================
    /** Set uncontrolled `expandedKeys`. This will also auto update `flattenNodes`. */ setExpandedKeys = (expandedKeys)=>{
        // When `expandedKeys` is controlled, `setUncontrolledState` with `atomic` will be a no-op.
        if (this.props.hasOwnProperty("expandedKeys")) return;
        const { treeData: treeData, fieldNames: fieldNames } = this.state;
        const flattenNodes = (0, $718db4e60315df95$export$215c1b4f1ba88b23)(treeData, expandedKeys, fieldNames);
        this.setUncontrolledState({
            expandedKeys: expandedKeys,
            flattenNodes: flattenNodes
        }, true);
    };
    onNodeExpand = (e, treeNode)=>{
        let { expandedKeys: expandedKeys } = this.state;
        const { listChanging: listChanging, fieldNames: fieldNames } = this.state;
        const { onExpand: onExpand, loadData: loadData } = this.props;
        const { expanded: expanded } = treeNode;
        const key = treeNode[fieldNames.key];
        // Do nothing when motion is in progress
        if (listChanging) return;
        // Update selected keys
        const certain = expandedKeys.includes(key);
        const targetExpanded = !expanded;
        (0, $26d7cf6379fe7659$export$2e2bcd8739ae039)(expanded && certain || !expanded && !certain, "Expand state not sync with index check");
        expandedKeys = targetExpanded ? (0, $9f5f4c60f5f7fe12$export$10663f6bbd2fd717)(expandedKeys, key) : (0, $9f5f4c60f5f7fe12$export$5bfb9ff497fe2298)(expandedKeys, key);
        this.setExpandedKeys(expandedKeys);
        onExpand?.(expandedKeys, {
            node: treeNode,
            expanded: targetExpanded,
            nativeEvent: e.nativeEvent
        });
        // Async Load data
        if (targetExpanded && loadData) {
            const loadPromise = this.onNodeLoad(treeNode);
            if (loadPromise) loadPromise.then(()=>{
                // [Legacy] Refresh logic
                const newFlattenTreeData = (0, $718db4e60315df95$export$215c1b4f1ba88b23)(this.state.treeData, expandedKeys, fieldNames);
                this.setUncontrolledState({
                    flattenNodes: newFlattenTreeData
                });
            }).catch(()=>{
                const { expandedKeys: currentExpandedKeys } = this.state;
                const expandedKeysToRestore = (0, $9f5f4c60f5f7fe12$export$5bfb9ff497fe2298)(currentExpandedKeys, key);
                this.setExpandedKeys(expandedKeysToRestore);
            });
        }
    };
    onListChangeStart = ()=>{
        this.setUncontrolledState({
            listChanging: true
        });
    };
    onListChangeEnd = ()=>{
        setTimeout(()=>{
            this.setUncontrolledState({
                listChanging: false
            });
        });
    };
    // =========================== Keyboard ===========================
    onActiveChange = (newActiveKey)=>{
        const { activeKey: activeKey } = this.state;
        const { onActiveChange: onActiveChange, itemScrollOffset: itemScrollOffset = 0 } = this.props;
        if (activeKey === newActiveKey) return;
        this.setState({
            activeKey: newActiveKey
        });
        if (newActiveKey !== null) this.scrollTo({
            key: newActiveKey,
            offset: itemScrollOffset
        });
        onActiveChange?.(newActiveKey);
    };
    getActiveItem = ()=>{
        const { activeKey: activeKey, flattenNodes: flattenNodes } = this.state;
        if (activeKey === null) return null;
        return flattenNodes.find(({ key: key })=>key === activeKey) || null;
    };
    offsetActiveKey = (offset)=>{
        const { flattenNodes: flattenNodes, activeKey: activeKey } = this.state;
        let index = flattenNodes.findIndex(({ key: key })=>key === activeKey);
        // Align with index
        if (index === -1 && offset < 0) index = flattenNodes.length;
        index = (index + offset + flattenNodes.length) % flattenNodes.length;
        const item = flattenNodes[index];
        if (item) {
            const { key: key } = item;
            this.onActiveChange(key);
        } else this.onActiveChange(null);
    };
    onKeyDown = (event)=>{
        const { activeKey: activeKey, expandedKeys: expandedKeys, checkedKeys: checkedKeys, flattenNodes: flattenNodes, keyEntities: keyEntities } = this.state;
        const { onKeyDown: onKeyDown, checkable: checkable, selectable: selectable, disabled: disabled, loadData: loadData } = this.props;
        if (disabled) return;
        // >>>>>>>>>> Direction
        switch(event.key){
            case "ArrowUp":
                this.offsetActiveKey(-1);
                event.preventDefault();
                break;
            case "ArrowDown":
                this.offsetActiveKey(1);
                event.preventDefault();
                break;
            case "Home":
                this.onActiveChange(flattenNodes?.[0]?.key);
                event.preventDefault();
                break;
            case "End":
                this.onActiveChange(flattenNodes?.[flattenNodes.length - 1]?.key);
                event.preventDefault();
                break;
        }
        // >>>>>>>>>> Expand & Selection
        const activeItem = this.getActiveItem();
        if (activeItem && activeItem.data) {
            const treeNodeRequiredProps = this.getTreeNodeRequiredProps();
            const eventNode = (0, $718db4e60315df95$export$7bd1b0fd4a8b540b)({
                ...(0, $718db4e60315df95$export$d961fd523a514db5)(activeKey, treeNodeRequiredProps),
                data: activeItem.data,
                active: true
            });
            const entity = (0, $0c5b17dbfbfa5f0f$export$2e2bcd8739ae039)(keyEntities, activeKey);
            const hasChildren = !!entity?.children?.length;
            const expandable = !(0, $718db4e60315df95$export$335db82b86111fd1)(activeItem.data.isLeaf, loadData, hasChildren, eventNode.loaded);
            const canCheck = checkable && !eventNode.disabled && eventNode.checkable !== false && !eventNode.disableCheckbox;
            const canSelect = !checkable && selectable && !eventNode.disabled && eventNode.selectable !== false;
            switch(event.key){
                // >>> Expand
                case "ArrowLeft":
                    // Collapse if possible
                    if (expandable && expandedKeys.includes(activeKey)) this.onNodeExpand({}, eventNode);
                    else if (activeItem.parent) this.onActiveChange(activeItem.parent.key);
                    event.preventDefault();
                    break;
                case "ArrowRight":
                    // Expand if possible
                    if (expandable && !expandedKeys.includes(activeKey)) this.onNodeExpand({}, eventNode);
                    else if (activeItem.children && activeItem.children.length) this.onActiveChange(activeItem.children[0].key);
                    event.preventDefault();
                    break;
                case "Enter":
                    if (expandable) {
                        event.preventDefault();
                        this.onNodeExpand({}, eventNode);
                    } else if (canCheck) {
                        if (!checkedKeys.includes(activeKey)) {
                            event.preventDefault();
                            this.onNodeCheck({}, eventNode, true);
                        }
                    } else if (canSelect && !eventNode.selected) {
                        event.preventDefault();
                        this.onNodeSelect({}, eventNode);
                    }
                    break;
                case " ":
                    if (canCheck) {
                        event.preventDefault();
                        this.onNodeCheck({}, eventNode, !checkedKeys.includes(activeKey));
                    } else if (canSelect) {
                        event.preventDefault();
                        this.onNodeSelect({}, eventNode);
                    }
                    break;
            }
        }
        onKeyDown?.(event);
    };
    /**
   * Only update the value which is not in props
   */ setUncontrolledState = (state, atomic = false, forceState = null)=>{
        if (!this.destroyed) {
            let needSync = false;
            let allPassed = true;
            const newState = {};
            Object.keys(state).forEach((name)=>{
                if (this.props.hasOwnProperty(name)) {
                    allPassed = false;
                    return;
                }
                needSync = true;
                newState[name] = state[name];
            });
            if (needSync && (!atomic || allPassed)) this.setState({
                ...newState,
                ...forceState
            });
        }
    };
    scrollTo = (scroll)=>{
        if (scroll && typeof scroll === "object" && scroll.autoExpand) this.setExpandedKeys((0, $9f5f4c60f5f7fe12$export$10663f6bbd2fd717)(this.state.expandedKeys, scroll.key));
        this.listRef.current.scrollTo(scroll);
    };
    render() {
        const { flattenNodes: flattenNodes, keyEntities: keyEntities, draggingNodeKey: draggingNodeKey, dropLevelOffset: dropLevelOffset, dropContainerKey: dropContainerKey, dropTargetKey: dropTargetKey, dropPosition: dropPosition, dragOverNodeKey: dragOverNodeKey, indent: indent } = this.state;
        const { prefixCls: prefixCls, className: className, style: style, styles: styles, classNames: treeClassNames, showLine: showLine, focusable: focusable, tabIndex: tabIndex = 0, selectable: selectable, showIcon: showIcon, icon: icon, switcherIcon: switcherIcon, draggable: draggable, checkable: checkable, checkStrictly: checkStrictly, disabled: disabled, motion: motion, loadData: loadData, filterTreeNode: filterTreeNode, height: height, itemHeight: itemHeight, scrollWidth: scrollWidth, virtual: virtual, titleRender: titleRender, dropIndicatorRender: dropIndicatorRender, onContextMenu: onContextMenu, onScroll: onScroll, direction: direction, rootClassName: rootClassName, rootStyle: rootStyle } = this.props;
        const domProps = (0, $4b5c733d1d7bb306$export$2e2bcd8739ae039)(this.props, {
            aria: true,
            data: true
        });
        // It's better move to hooks but we just simply keep here
        let draggableConfig;
        if (draggable) {
            if (typeof draggable === "object") draggableConfig = draggable;
            else if (typeof draggable === "function") draggableConfig = {
                nodeDraggable: draggable
            };
            else draggableConfig = {};
        }
        const contextValue = {
            styles: styles,
            classNames: treeClassNames,
            prefixCls: prefixCls,
            selectable: selectable,
            showIcon: showIcon,
            icon: icon,
            switcherIcon: switcherIcon,
            draggable: draggableConfig,
            draggingNodeKey: draggingNodeKey,
            checkable: checkable,
            checkStrictly: checkStrictly,
            disabled: disabled,
            keyEntities: keyEntities,
            dropLevelOffset: dropLevelOffset,
            dropContainerKey: dropContainerKey,
            dropTargetKey: dropTargetKey,
            dropPosition: dropPosition,
            dragOverNodeKey: dragOverNodeKey,
            indent: indent,
            direction: direction,
            dropIndicatorRender: dropIndicatorRender,
            loadData: loadData,
            filterTreeNode: filterTreeNode,
            titleRender: titleRender,
            onNodeClick: this.onNodeClick,
            onNodeDoubleClick: this.onNodeDoubleClick,
            onNodeExpand: this.onNodeExpand,
            onNodeSelect: this.onNodeSelect,
            onNodeCheck: this.onNodeCheck,
            onNodeLoad: this.onNodeLoad,
            onNodeMouseEnter: this.onNodeMouseEnter,
            onNodeMouseLeave: this.onNodeMouseLeave,
            onNodeContextMenu: this.onNodeContextMenu,
            onNodeDragStart: this.onNodeDragStart,
            onNodeDragEnter: this.onNodeDragEnter,
            onNodeDragOver: this.onNodeDragOver,
            onNodeDragLeave: this.onNodeDragLeave,
            onNodeDragEnd: this.onNodeDragEnd,
            onNodeDrop: this.onNodeDrop
        };
        return /*#__PURE__*/ $cQmXV.createElement((0, $4b1e270ea77a2a43$export$dfae7d399eea2568).Provider, {
            value: contextValue
        }, /*#__PURE__*/ $cQmXV.createElement("div", {
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, className, rootClassName, {
                [`${prefixCls}-show-line`]: showLine
            }),
            style: rootStyle
        }, /*#__PURE__*/ $cQmXV.createElement((0, $92f07d99d8eaa73a$export$2e2bcd8739ae039), $105186323c304ca2$var$_extends({
            ref: this.listRef,
            prefixCls: prefixCls,
            style: style,
            data: flattenNodes,
            disabled: disabled,
            selectable: selectable,
            checkable: !!checkable,
            motion: motion,
            dragging: draggingNodeKey !== null,
            height: height,
            itemHeight: itemHeight,
            virtual: virtual,
            focusable: focusable,
            tabIndex: tabIndex,
            activeItem: this.getActiveItem(),
            onFocus: this.onFocus,
            onMouseDown: this.onMouseDown,
            onBlur: this.onBlur,
            onKeyDown: this.onKeyDown,
            onActiveChange: this.onActiveChange,
            onListChangeStart: this.onListChangeStart,
            onListChangeEnd: this.onListChangeEnd,
            onContextMenu: onContextMenu,
            onScroll: onScroll,
            scrollWidth: scrollWidth
        }, this.getTreeNodeRequiredProps(), domProps))));
    }
}
var $105186323c304ca2$export$2e2bcd8739ae039 = $105186323c304ca2$var$Tree;





var $cQmXV = parcelRequire("cQmXV");


function $18439d3d43b6f08f$export$2e2bcd8739ae039(treeData, config) {
    const { fieldNames: fieldNames } = config;
    const keyEntities = $cQmXV.useMemo(()=>{
        const { keyEntities: keyEntities } = (0, $718db4e60315df95$export$e5d831ce033a4615)(treeData, {
            fieldNames: fieldNames
        });
        return keyEntities;
    }, [
        treeData,
        fieldNames
    ]);
    const getPath = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((key)=>{
        const path = [];
        let entity = (0, $0c5b17dbfbfa5f0f$export$2e2bcd8739ae039)(keyEntities, key);
        while(entity){
            path.unshift(entity);
            entity = entity.parent;
        }
        return path;
    });
    return {
        getPath: getPath
    };
}






var $ae1764cccb2daebe$export$2e2bcd8739ae039 = (0, $105186323c304ca2$export$2e2bcd8739ae039);





var $cQmXV = parcelRequire("cQmXV");
const $b5da25dd25a6ebd7$export$3f339a531a4f3fb4 = (getKey)=>{
    const [prevSelectedIndex, setPrevSelectedIndex] = (0, $cQmXV.useState)(null);
    const multipleSelect = (0, $cQmXV.useCallback)((currentSelectedIndex, data, selectedKeys)=>{
        const configPrevSelectedIndex = prevSelectedIndex ?? currentSelectedIndex;
        // add/delete the selected range
        const startIndex = Math.min(configPrevSelectedIndex || 0, currentSelectedIndex);
        const endIndex = Math.max(configPrevSelectedIndex || 0, currentSelectedIndex);
        const rangeKeys = data.slice(startIndex, endIndex + 1).map(getKey);
        const shouldSelected = rangeKeys.some((rangeKey)=>!selectedKeys.has(rangeKey));
        const changedKeys = [];
        rangeKeys.forEach((item)=>{
            if (shouldSelected) {
                if (!selectedKeys.has(item)) changedKeys.push(item);
                selectedKeys.add(item);
            } else {
                selectedKeys.delete(item);
                changedKeys.push(item);
            }
        });
        setPrevSelectedIndex(shouldSelected ? endIndex : null);
        return changedKeys;
    }, [
        prevSelectedIndex
    ]);
    return [
        multipleSelect,
        setPrevSelectedIndex
    ];
};





var $cQmXV = parcelRequire("cQmXV");



var $cQmXV = parcelRequire("cQmXV");
function $293184ba40cdd0a0$var$_extends() {
    $293184ba40cdd0a0$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $293184ba40cdd0a0$var$_extends.apply(this, arguments);
}
const $293184ba40cdd0a0$export$48513f6b9f8ce62d = /*#__PURE__*/ (0, $cQmXV.forwardRef)((props, ref)=>{
    const { prefixCls: prefixCls = "rc-checkbox", className: className, style: style, checked: checked, disabled: disabled, defaultChecked: defaultChecked = false, type: type = "checkbox", title: title, onChange: onChange, ...inputProps } = props;
    const inputRef = (0, $cQmXV.useRef)(null);
    const holderRef = (0, $cQmXV.useRef)(null);
    const [rawValue, setRawValue] = (0, $a51866d781137e08$export$2e2bcd8739ae039)(defaultChecked, checked);
    (0, $cQmXV.useImperativeHandle)(ref, ()=>({
            focus: (options)=>{
                inputRef.current?.focus(options);
            },
            blur: ()=>{
                inputRef.current?.blur();
            },
            input: inputRef.current,
            nativeElement: holderRef.current
        }));
    const classString = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, className, {
        [`${prefixCls}-checked`]: rawValue,
        [`${prefixCls}-disabled`]: disabled
    });
    const handleChange = (e)=>{
        if (disabled) return;
        if (!("checked" in props)) setRawValue(e.target.checked);
        onChange?.({
            target: {
                ...props,
                type: type,
                checked: e.target.checked
            },
            stopPropagation () {
                e.stopPropagation();
            },
            preventDefault () {
                e.preventDefault();
            },
            nativeEvent: e.nativeEvent
        });
    };
    return /*#__PURE__*/ $cQmXV.createElement("span", {
        className: classString,
        title: title,
        style: style,
        ref: holderRef
    }, /*#__PURE__*/ $cQmXV.createElement("input", $293184ba40cdd0a0$var$_extends({}, inputProps, {
        className: `${prefixCls}-input`,
        ref: inputRef,
        onChange: handleChange,
        disabled: disabled,
        checked: !!rawValue,
        type: type
    })));
});
var $293184ba40cdd0a0$export$2e2bcd8739ae039 = $293184ba40cdd0a0$export$48513f6b9f8ce62d;














var $cQmXV = parcelRequire("cQmXV");
const $bd16ffc4d3f54e1e$var$GroupContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createContext(null);
var $bd16ffc4d3f54e1e$export$2e2bcd8739ae039 = $bd16ffc4d3f54e1e$var$GroupContext;






const $7a6ee65743f4824d$export$92a97fe1d1148438 = (token)=>{
    const { checkboxCls: checkboxCls, checkboxSize: checkboxSize, lineWidth: lineWidth } = token;
    const wrapperCls = `${checkboxCls}-wrapper`;
    const hoverMediaQuery = "@media (hover: hover) and (pointer: fine)";
    return [
        // ===================== Basic =====================
        {
            // Group
            [`${checkboxCls}-group`]: {
                ...(0, $519d20bf207ce864$export$23997c3e44cc1c59)(token),
                display: "inline-flex",
                flexWrap: "wrap",
                columnGap: token.marginXS,
                // Group > Grid
                [`> ${token.antCls}-row`]: {
                    flex: 1
                }
            },
            // Wrapper
            [wrapperCls]: {
                ...(0, $519d20bf207ce864$export$23997c3e44cc1c59)(token),
                display: "inline-flex",
                alignItems: "baseline",
                cursor: "pointer",
                // Fix checkbox & radio in flex align #30260
                "&:after": {
                    display: "inline-block",
                    width: 0,
                    overflow: "hidden",
                    content: "'\\a0'"
                },
                // Checkbox near checkbox
                [`& + ${wrapperCls}`]: {
                    marginInlineStart: 0
                }
            },
            // Wrapper > Checkbox
            [checkboxCls]: {
                ...(0, $519d20bf207ce864$export$23997c3e44cc1c59)(token),
                position: "relative",
                whiteSpace: "nowrap",
                lineHeight: 1,
                cursor: "pointer",
                // To make alignment right when `controlHeight` is changed
                // Ref: https://github.com/ant-design/ant-design/issues/41564
                alignSelf: "center",
                // Styles moved from inner
                boxSizing: "border-box",
                display: "block",
                width: checkboxSize,
                height: checkboxSize,
                direction: "ltr",
                backgroundColor: token.colorBgContainer,
                border: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(lineWidth)} ${token.lineType} ${token.colorBorder}`,
                borderRadius: token.borderRadiusSM,
                borderCollapse: "separate",
                transition: `all ${token.motionDurationSlow}`,
                flex: "none",
                ...(0, $e111c624d18c33f1$export$c5b4e7cabb00fc99)(),
                // Checkmark
                "&:after": {
                    boxSizing: "border-box",
                    position: "absolute",
                    top: `calc(${checkboxSize} / 2 - ${lineWidth})`,
                    insetInlineStart: `calc(${checkboxSize} / 4 - ${lineWidth})`,
                    display: "table",
                    width: token.calc(checkboxSize).div(14).mul(5).equal(),
                    height: token.calc(checkboxSize).div(14).mul(8).equal(),
                    border: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidthBold)} solid ${token.colorWhite}`,
                    borderTop: 0,
                    borderInlineStart: 0,
                    transform: "rotate(45deg) scale(0) translate(-50%,-50%)",
                    opacity: 0,
                    content: '""',
                    transition: `all ${token.motionDurationFast} ${token.motionEaseInBack}, opacity ${token.motionDurationFast}`,
                    ...(0, $e111c624d18c33f1$export$a2e3d2d19d960234)()
                },
                // Wrapper > Checkbox > input
                [`${checkboxCls}-input`]: {
                    position: "absolute",
                    // Since baseline align will get additional space offset,
                    // we need to move input to top to make it align with text.
                    // Ref: https://github.com/ant-design/ant-design/issues/38926#issuecomment-1486137799
                    inset: `calc(-1 * (${lineWidth}))`,
                    zIndex: 1,
                    cursor: "pointer",
                    opacity: 0,
                    margin: 0
                },
                // Focus outline on checkbox when input is focus-visible
                [`&:has(${checkboxCls}-input:focus-visible)`]: (0, $519d20bf207ce864$export$6539948f0a737e39)(token),
                // Wrapper > Checkbox + Text
                "& + span": {
                    paddingInlineStart: token.paddingXS,
                    paddingInlineEnd: token.paddingXS
                }
            }
        },
        // ===================== Hover =====================
        {
            [hoverMediaQuery]: {
                // Wrapper & Wrapper > Checkbox
                [`
          ${wrapperCls}:not(${wrapperCls}-disabled),
          ${checkboxCls}:not(${checkboxCls}-disabled)
        `]: {
                    [`&:hover ${checkboxCls}`]: {
                        borderColor: token.colorPrimary
                    }
                },
                [`${wrapperCls}:not(${wrapperCls}-disabled)`]: {
                    [`&:hover ${checkboxCls}-checked:not(${checkboxCls}-disabled)`]: {
                        backgroundColor: token.colorPrimaryHover,
                        borderColor: "transparent"
                    }
                }
            }
        },
        // ==================== Checked ====================
        {
            // Wrapper > Checkbox
            [`${checkboxCls}-checked`]: {
                backgroundColor: token.colorPrimary,
                borderColor: token.colorPrimary,
                "&:after": {
                    opacity: 1,
                    transform: "rotate(45deg) scale(1) translate(-50%,-50%)",
                    transition: `all ${token.motionDurationMid} ${token.motionEaseOutBack} ${token.motionDurationFast}`,
                    ...(0, $e111c624d18c33f1$export$a2e3d2d19d960234)()
                },
                [hoverMediaQuery]: {
                    // Hover on checked checkbox directly
                    [`&:not(${checkboxCls}-disabled):hover`]: {
                        backgroundColor: token.colorPrimaryHover,
                        borderColor: "transparent"
                    }
                }
            }
        },
        // ================= Indeterminate =================
        {
            [checkboxCls]: {
                "&-indeterminate": {
                    backgroundColor: token.colorBgContainer,
                    borderColor: token.colorBorder,
                    "&:after": {
                        top: "50%",
                        insetInlineStart: "50%",
                        width: token.calc(token.fontSizeLG).div(2).equal(),
                        height: token.calc(token.fontSizeLG).div(2).equal(),
                        backgroundColor: token.colorPrimary,
                        border: 0,
                        transform: "translate(-50%, -50%) scale(1)",
                        opacity: 1,
                        content: '""'
                    },
                    [hoverMediaQuery]: {
                        // https://github.com/ant-design/ant-design/issues/50074
                        [`&:not(${checkboxCls}-disabled):hover`]: {
                            backgroundColor: token.colorBgContainer,
                            borderColor: token.colorPrimary
                        }
                    }
                }
            }
        },
        // ==================== Disable ====================
        {
            // Wrapper
            [`${wrapperCls}-disabled`]: {
                cursor: "not-allowed"
            },
            // Wrapper > Checkbox
            [`${checkboxCls}-disabled`]: {
                // Wrapper > Checkbox > input
                [`&, ${checkboxCls}-input`]: {
                    cursor: "not-allowed",
                    // Disabled for native input to enable Tooltip event handler
                    // ref: https://github.com/ant-design/ant-design/issues/39822#issuecomment-1365075901
                    pointerEvents: "none"
                },
                // Disabled checkbox styles
                background: token.colorBgContainerDisabled,
                borderColor: token.colorBorder,
                "&:after": {
                    borderColor: token.colorTextDisabled
                },
                "& + span": {
                    color: token.colorTextDisabled
                },
                [`&${checkboxCls}-indeterminate::after`]: {
                    background: token.colorTextDisabled
                }
            }
        }
    ];
};
function $7a6ee65743f4824d$export$3d2f074408bd1b82(prefixCls, token) {
    const checkboxToken = (0, $fef50f256b80dfa5$export$4950aa0f605343fb)(token, {
        checkboxCls: `.${prefixCls}`,
        checkboxSize: token.controlInteractiveSize
    });
    return $7a6ee65743f4824d$export$92a97fe1d1148438(checkboxToken);
}
var $7a6ee65743f4824d$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$51ec95de45185b42)("Checkbox", (token, { prefixCls: prefixCls })=>[
        $7a6ee65743f4824d$export$3d2f074408bd1b82(prefixCls, token)
    ]);



var $cQmXV = parcelRequire("cQmXV");

function $8510b23b609ef788$export$2e2bcd8739ae039(onOriginInputClick) {
    const labelClickLockRef = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useRef(null);
    const clearLock = ()=>{
        (0, $905c53b807de704e$export$2e2bcd8739ae039).cancel(labelClickLockRef.current);
        labelClickLockRef.current = null;
    };
    const onLabelClick = ()=>{
        clearLock();
        labelClickLockRef.current = (0, $905c53b807de704e$export$2e2bcd8739ae039)(()=>{
            labelClickLockRef.current = null;
        });
    };
    const onInputClick = (e)=>{
        if (labelClickLockRef.current) {
            e.stopPropagation();
            clearLock();
        }
        onOriginInputClick?.(e);
    };
    return [
        onLabelClick,
        onInputClick
    ];
}


"use client";
const $57d3876427e226c6$var$InternalCheckbox = (props, ref)=>{
    const { prefixCls: customizePrefixCls, children: children, indeterminate: indeterminate = false, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, skipGroup: skipGroup = false, disabled: disabled, rootClassName: // Style
    rootClassName, className: className, style: style, classNames: classNames, styles: styles, name: // Name
    name, value: // Value
    value, checked: // Checked
    checked, defaultChecked: defaultChecked, onChange: onChange, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("checkbox");
    const checkboxGroup = $cQmXV.useContext((0, $bd16ffc4d3f54e1e$export$2e2bcd8739ae039));
    const { isFormItemInput: isFormItemInput } = $cQmXV.useContext((0, $7a3804f153d8a19d$export$bbb5553c6c7a14ed));
    const contextDisabled = $cQmXV.useContext((0, $4f0e1ea30330557c$export$2e2bcd8739ae039));
    const mergedDisabled = (checkboxGroup?.disabled || disabled) ?? contextDisabled;
    // ============================= Checked ==============================
    const [innerChecked, setInnerChecked] = (0, $a51866d781137e08$export$2e2bcd8739ae039)(defaultChecked, checked);
    let mergedChecked = innerChecked;
    const onInternalChange = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((event)=>{
        setInnerChecked(event.target.checked);
        onChange?.(event);
        if (!skipGroup && checkboxGroup?.toggleOption) checkboxGroup.toggleOption({
            label: children,
            value: value
        });
    });
    // ============================== Group ===============================
    if (checkboxGroup && !skipGroup) mergedChecked = checkboxGroup.value.includes(value);
    const checkboxRef = $cQmXV.useRef(null);
    const mergedRef = (0, $10341b937b26f69d$export$1d1c999670a1285d)(ref, checkboxRef);
    $cQmXV.useEffect(()=>{
        if (skipGroup || !checkboxGroup) return;
        checkboxGroup.registerValue(value);
        return ()=>{
            checkboxGroup.cancelValue(value);
        };
    }, [
        value,
        skipGroup
    ]);
    // ========================== Indeterminate ===========================
    $cQmXV.useEffect(()=>{
        if (checkboxRef.current?.input) checkboxRef.current.input.indeterminate = indeterminate;
    }, [
        indeterminate
    ]);
    // ============================== Style ===============================
    const prefixCls = getPrefixCls("checkbox", customizePrefixCls);
    const rootCls = (0, $2237081acd3cfc09$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $7a6ee65743f4824d$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const checkboxProps = {
        ...restProps
    };
    // =========== Merged Props for Semantic ==========
    const mergedProps = {
        ...props,
        indeterminate: indeterminate,
        disabled: mergedDisabled,
        checked: mergedChecked
    };
    const contextStyleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $30c5f9f911d4f61b$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: mergedProps
    });
    const classString = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-wrapper`, {
        [`${prefixCls}-rtl`]: direction === "rtl",
        [`${prefixCls}-wrapper-checked`]: mergedChecked,
        [`${prefixCls}-wrapper-disabled`]: mergedDisabled,
        [`${prefixCls}-wrapper-in-form-item`]: isFormItemInput
    }, contextClassName, className, mergedClassNames.root, rootClassName, cssVarCls, rootCls, hashId);
    const checkboxClass = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(mergedClassNames.icon, {
        [`${prefixCls}-indeterminate`]: indeterminate
    }, (0, $1f1e565d7b1db8d0$export$23466a5792b7a5d3), hashId);
    // ============================ Event Lock ============================
    const [onLabelClick, onInputClick] = (0, $8510b23b609ef788$export$2e2bcd8739ae039)(checkboxProps.onClick);
    // ============================== Render ==============================
    return /*#__PURE__*/ $cQmXV.createElement((0, $02f5adbd0068e010$export$2e2bcd8739ae039), {
        component: "Checkbox",
        disabled: mergedDisabled
    }, /*#__PURE__*/ $cQmXV.createElement("label", {
        className: classString,
        style: mergedStyles.root,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onClick: onLabelClick
    }, /*#__PURE__*/ $cQmXV.createElement((0, $293184ba40cdd0a0$export$2e2bcd8739ae039), {
        ...checkboxProps,
        name: !skipGroup && checkboxGroup ? checkboxGroup.name : name,
        checked: mergedChecked,
        onClick: onInputClick,
        onChange: onInternalChange,
        prefixCls: prefixCls,
        className: checkboxClass,
        style: mergedStyles.icon,
        disabled: mergedDisabled,
        ref: mergedRef,
        value: value
    }), (0, $8e2d153a3c855782$export$72280d5f896dac9a)(children) && /*#__PURE__*/ $cQmXV.createElement("span", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-label`, mergedClassNames.label),
        style: mergedStyles.label
    }, children)));
};
const $57d3876427e226c6$var$Checkbox = /*#__PURE__*/ $cQmXV.forwardRef($57d3876427e226c6$var$InternalCheckbox);
var $57d3876427e226c6$export$2e2bcd8739ae039 = $57d3876427e226c6$var$Checkbox;




var $cQmXV = parcelRequire("cQmXV");








"use client";
const $89c17bfd6627b947$var$CheckboxGroup = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { defaultValue: defaultValue, children: children, options: options = [], prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, style: style, onChange: onChange, role: role = "group", ...restProps } = props;
    const { getPrefixCls: getPrefixCls, direction: direction } = $cQmXV.useContext((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    const [value, setValue] = $cQmXV.useState(restProps.value || defaultValue || []);
    const [registeredValues, setRegisteredValues] = $cQmXV.useState([]);
    $cQmXV.useEffect(()=>{
        if ("value" in restProps) setValue(restProps.value || []);
    }, [
        restProps.value
    ]);
    const memoizedOptions = $cQmXV.useMemo(()=>{
        return options.map((option)=>{
            if ((0, $8e2d153a3c855782$export$844ec244b1367d54)(option) || (0, $8e2d153a3c855782$export$7e4aa119212bc614)(option)) return {
                label: option,
                value: option
            };
            return option;
        }).filter((item)=>(0, $8e2d153a3c855782$export$826fff653a329e83)(item) && (0, $8e2d153a3c855782$export$826fff653a329e83)(item.value));
    }, [
        options
    ]);
    const cancelValue = (val)=>{
        setRegisteredValues((prevValues)=>prevValues.filter((v)=>v !== val));
    };
    const registerValue = (val)=>{
        setRegisteredValues((prevValues)=>[].concat((0, $68381b18b974dc9f$export$2e2bcd8739ae039)(prevValues), [
                val
            ]));
    };
    const toggleOption = (option)=>{
        const optionIndex = value.indexOf(option.value);
        const newValue = (0, $68381b18b974dc9f$export$2e2bcd8739ae039)(value);
        if (optionIndex === -1) newValue.push(option.value);
        else newValue.splice(optionIndex, 1);
        if (!("value" in restProps)) setValue(newValue);
        onChange?.(newValue.filter((val)=>registeredValues.includes(val)).sort((a, b)=>{
            const indexA = memoizedOptions.findIndex((opt)=>opt.value === a);
            const indexB = memoizedOptions.findIndex((opt)=>opt.value === b);
            return indexA - indexB;
        }));
    };
    const prefixCls = getPrefixCls("checkbox", customizePrefixCls);
    const groupPrefixCls = `${prefixCls}-group`;
    const rootCls = (0, $2237081acd3cfc09$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $7a6ee65743f4824d$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const domProps = (0, $e8c5093aebad6025$export$2e2bcd8739ae039)(restProps, [
        "value",
        "disabled"
    ]);
    const childrenNode = Array.isArray(memoizedOptions) && memoizedOptions.length > 0 ? memoizedOptions.map((option)=>/*#__PURE__*/ $cQmXV.createElement((0, $57d3876427e226c6$export$2e2bcd8739ae039), {
            prefixCls: prefixCls,
            key: option.value.toString(),
            disabled: "disabled" in option ? option.disabled : restProps.disabled,
            value: option.value,
            checked: value.includes(option.value),
            onChange: option.onChange,
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${groupPrefixCls}-item`, option.className),
            style: option.style,
            title: option.title,
            id: option.id,
            required: option.required
        }, option.label)) : children;
    const memoizedContext = $cQmXV.useMemo(()=>({
            toggleOption: toggleOption,
            value: value,
            disabled: restProps.disabled,
            name: restProps.name,
            registerValue: // https://github.com/ant-design/ant-design/issues/16376
            registerValue,
            cancelValue: cancelValue
        }), [
        toggleOption,
        value,
        restProps.disabled,
        restProps.name,
        registerValue,
        cancelValue
    ]);
    const classString = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(groupPrefixCls, {
        [`${groupPrefixCls}-rtl`]: direction === "rtl"
    }, className, rootClassName, cssVarCls, rootCls, hashId);
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        className: classString,
        style: style,
        role: role,
        ...domProps,
        ref: ref
    }, /*#__PURE__*/ $cQmXV.createElement((0, $bd16ffc4d3f54e1e$export$2e2bcd8739ae039).Provider, {
        value: memoizedContext
    }, childrenNode));
});
var $89c17bfd6627b947$export$2e2bcd8739ae039 = $89c17bfd6627b947$var$CheckboxGroup;


"use client";
const $7a650444b7c2c328$var$Checkbox = (0, $57d3876427e226c6$export$2e2bcd8739ae039);
$7a650444b7c2c328$var$Checkbox.Group = (0, $89c17bfd6627b947$export$2e2bcd8739ae039);
$7a650444b7c2c328$var$Checkbox.__ANT_CHECKBOX = true;
var $7a650444b7c2c328$export$2e2bcd8739ae039 = $7a650444b7c2c328$var$Checkbox;




var $cQmXV = parcelRequire("cQmXV");










var $cQmXV = parcelRequire("cQmXV");
const $fa172403d1332f4a$var$RadioGroupContext = /*#__PURE__*/ $cQmXV.createContext(undefined);
const $fa172403d1332f4a$export$67d4730aee04efd2 = $fa172403d1332f4a$var$RadioGroupContext.Provider;
var $fa172403d1332f4a$export$2e2bcd8739ae039 = $fa172403d1332f4a$var$RadioGroupContext;
const $fa172403d1332f4a$export$4fbd9581b41e971f = /*#__PURE__*/ $cQmXV.createContext(undefined);
const $fa172403d1332f4a$export$1b5d1f64a577990e = $fa172403d1332f4a$export$4fbd9581b41e971f.Provider;



var $cQmXV = parcelRequire("cQmXV");

















// ============================== Styles ==============================
// styles from RadioGroup only
const $5717f17ca466ea76$var$getGroupRadioStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls, lineWidth: lineWidth, borderRadius: borderRadius, borderRadiusLG: borderRadiusLG, borderRadiusSM: borderRadiusSM, calc: calc } = token;
    const groupPrefixCls = `${componentCls}-group`;
    const buttonWrapperCls = `${componentCls}-button-wrapper`;
    const badgeCls = `${antCls}-badge`;
    const genVerticalBadgeButtonStyle = (radius)=>({
            [`> ${badgeCls}`]: {
                width: "auto"
            },
            [`> ${badgeCls} > ${buttonWrapperCls}`]: {
                width: "100%"
            },
            [`> ${badgeCls}:not(:last-child)`]: {
                marginBlockEnd: calc(lineWidth).mul(-1).equal()
            },
            [`> ${badgeCls} > ${buttonWrapperCls}:not(:last-child)`]: {
                marginBlockEnd: 0
            },
            [`> ${badgeCls}:first-child > ${buttonWrapperCls}`]: {
                borderStartStartRadius: radius,
                borderStartEndRadius: radius,
                borderEndStartRadius: 0,
                borderEndEndRadius: 0
            },
            [`> ${badgeCls}:last-child > ${buttonWrapperCls}`]: {
                borderStartStartRadius: 0,
                borderStartEndRadius: 0,
                borderEndStartRadius: radius,
                borderEndEndRadius: radius
            },
            [`> ${badgeCls}:not(:first-child):not(:last-child) > ${buttonWrapperCls}`]: {
                borderRadius: 0
            },
            [`> ${badgeCls}:first-child:last-child > ${buttonWrapperCls}`]: {
                borderRadius: radius
            }
        });
    return {
        [groupPrefixCls]: {
            ...(0, $519d20bf207ce864$export$23997c3e44cc1c59)(token),
            display: "inline-block",
            fontSize: 0,
            // RTL
            [`&${groupPrefixCls}-rtl`]: {
                direction: "rtl"
            },
            [`&${groupPrefixCls}-block`]: {
                display: "flex"
            },
            [`${antCls}-badge ${antCls}-badge-count`]: {
                zIndex: 1
            },
            [`> ${antCls}-badge:not(:first-child) > ${antCls}-button-wrapper`]: {
                borderInlineStart: "none"
            },
            "&-vertical": {
                display: "flex",
                flexDirection: "column",
                rowGap: token.marginXS,
                [`&:has(> ${buttonWrapperCls}, > ${badgeCls} > ${buttonWrapperCls})`]: {
                    rowGap: 0
                },
                [`${componentCls}-wrapper`]: {
                    marginInlineEnd: 0
                },
                ...genVerticalBadgeButtonStyle(borderRadius),
                [`&${groupPrefixCls}-large`]: {
                    ...genVerticalBadgeButtonStyle(borderRadiusLG)
                },
                [`&${groupPrefixCls}-small`]: {
                    ...genVerticalBadgeButtonStyle(borderRadiusSM)
                }
            }
        }
    };
};
// Styles from radio-wrapper
const $5717f17ca466ea76$var$getRadioBasicStyle = (token)=>{
    const { componentCls: componentCls, wrapperMarginInlineEnd: wrapperMarginInlineEnd, colorPrimary: colorPrimary, colorPrimaryHover: colorPrimaryHover, radioSize: radioSize, motionDurationSlow: motionDurationSlow, motionDurationMid: motionDurationMid, motionEaseInOutCirc: motionEaseInOutCirc, colorBgContainer: colorBgContainer, colorBorder: colorBorder, lineWidth: lineWidth, colorBgContainerDisabled: colorBgContainerDisabled, colorTextDisabled: colorTextDisabled, paddingXS: paddingXS, dotColorDisabled: dotColorDisabled, dotSize: dotSize, lineType: lineType, radioColor: radioColor, radioBgColor: radioBgColor } = token;
    return {
        [`${componentCls}-wrapper`]: {
            ...(0, $519d20bf207ce864$export$23997c3e44cc1c59)(token),
            display: "inline-flex",
            alignItems: "baseline",
            marginInlineStart: 0,
            marginInlineEnd: wrapperMarginInlineEnd,
            cursor: "pointer",
            "&:last-child": {
                marginInlineEnd: 0
            },
            // RTL
            [`&${componentCls}-wrapper-rtl`]: {
                direction: "rtl"
            },
            "&-disabled": {
                cursor: "not-allowed",
                color: token.colorTextDisabled
            },
            "&::after": {
                display: "inline-block",
                width: 0,
                overflow: "hidden",
                content: '"\\a0"'
            },
            "&-block": {
                flex: 1,
                justifyContent: "center"
            },
            // ===================== Radio =====================
            [componentCls]: {
                ...(0, $519d20bf207ce864$export$23997c3e44cc1c59)(token),
                position: "relative",
                whiteSpace: "nowrap",
                lineHeight: 1,
                cursor: "pointer",
                alignSelf: "center",
                // Styles moved from inner
                boxSizing: "border-box",
                display: "block",
                width: `calc(${radioSize} * 1px)`,
                height: `calc(${radioSize} * 1px)`,
                backgroundColor: colorBgContainer,
                border: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(lineWidth)} ${lineType} ${colorBorder}`,
                borderRadius: "50%",
                transition: `all ${motionDurationMid}`,
                flex: "none",
                // Dot
                "&:after": {
                    content: '""',
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%) scale(0)",
                    width: `calc(${dotSize} * 1px)`,
                    height: `calc(${dotSize} * 1px)`,
                    backgroundColor: radioColor,
                    borderRadius: "50%",
                    transformOrigin: "50% 50%",
                    opacity: 0,
                    transition: `all ${motionDurationSlow} ${motionEaseInOutCirc}`
                },
                // Wrapper > Radio > input
                [`${componentCls}-input`]: {
                    position: "absolute",
                    inset: 0,
                    zIndex: 1,
                    cursor: "pointer",
                    opacity: 0,
                    margin: 0
                },
                // Focus outline on radio when input is focus-visible
                [`&:has(${componentCls}-input:focus-visible)`]: (0, $519d20bf207ce864$export$6539948f0a737e39)(token)
            },
            // ===================== Hover =====================
            [`&:hover:not(${componentCls}-wrapper-disabled) ${componentCls}`]: {
                borderColor: colorPrimary
            },
            [`&:hover ${componentCls}-checked:not(${componentCls}-disabled)`]: {
                backgroundColor: colorPrimaryHover,
                borderColor: "transparent"
            },
            // ==================== Checked ====================
            [`${componentCls}-checked`]: {
                backgroundColor: radioBgColor,
                borderColor: colorPrimary,
                "&::after": {
                    transform: `translate(-50%, -50%)`,
                    opacity: 1
                }
            },
            // ==================== Disable ====================
            [`${componentCls}-disabled`]: {
                // Wrapper > Radio > input
                [`&, ${componentCls}-input`]: {
                    cursor: "not-allowed",
                    // Disabled for native input to enable Tooltip event handler
                    pointerEvents: "none"
                },
                // Disabled radio styles
                background: colorBgContainerDisabled,
                borderColor: colorBorder,
                "&::after": {
                    backgroundColor: dotColorDisabled
                }
            },
            [`${componentCls}-disabled + span`]: {
                color: colorTextDisabled,
                cursor: "not-allowed"
            },
            [`span${componentCls} + *`]: {
                paddingInlineStart: paddingXS,
                paddingInlineEnd: paddingXS
            }
        }
    };
};
// Styles from radio-button
const $5717f17ca466ea76$var$getRadioButtonStyle = (token)=>{
    const { buttonColor: buttonColor, controlHeight: controlHeight, componentCls: componentCls, lineWidth: lineWidth, lineType: lineType, colorBorder: colorBorder, motionDurationMid: motionDurationMid, buttonPaddingInline: buttonPaddingInline, fontSize: fontSize, buttonBg: buttonBg, fontSizeLG: fontSizeLG, controlHeightLG: controlHeightLG, controlHeightSM: controlHeightSM, paddingXS: paddingXS, borderRadius: borderRadius, borderRadiusSM: borderRadiusSM, borderRadiusLG: borderRadiusLG, buttonCheckedBg: buttonCheckedBg, buttonSolidCheckedColor: buttonSolidCheckedColor, colorTextDisabled: colorTextDisabled, colorBgContainerDisabled: colorBgContainerDisabled, buttonCheckedBgDisabled: buttonCheckedBgDisabled, buttonCheckedColorDisabled: buttonCheckedColorDisabled, colorPrimary: colorPrimary, colorPrimaryHover: colorPrimaryHover, colorPrimaryActive: colorPrimaryActive, buttonSolidCheckedBg: buttonSolidCheckedBg, buttonSolidCheckedHoverBg: buttonSolidCheckedHoverBg, buttonSolidCheckedActiveBg: buttonSolidCheckedActiveBg, calc: calc } = token;
    return {
        [`${componentCls}-button-wrapper`]: {
            position: "relative",
            display: "inline-block",
            height: controlHeight,
            margin: 0,
            paddingInline: buttonPaddingInline,
            paddingBlock: 0,
            color: buttonColor,
            fontSize: fontSize,
            lineHeight: (0, $05f34ed03d41967d$export$523c0b569236b342)(calc(controlHeight).sub(calc(lineWidth).mul(2)).equal()),
            background: buttonBg,
            border: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(lineWidth)} ${lineType} ${colorBorder}`,
            // strange align fix for chrome but works
            // https://gw.alipayobjects.com/zos/rmsportal/VFTfKXJuogBAXcvfAUWJ.gif
            borderBlockStartWidth: calc(lineWidth).add(0.02).equal(),
            borderInlineEndWidth: lineWidth,
            cursor: "pointer",
            transition: [
                `color`,
                `background-color`,
                `box-shadow`
            ].map((prop)=>`${prop} ${motionDurationMid}`).join(","),
            a: {
                color: buttonColor
            },
            [`> ${componentCls}-button`]: {
                position: "absolute",
                insetBlockStart: 0,
                insetInlineStart: 0,
                zIndex: -1,
                width: "100%",
                height: "100%"
            },
            "&:not(:last-child)": {
                marginInlineEnd: calc(lineWidth).mul(-1).equal()
            },
            "&:first-child": {
                borderInlineStart: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(lineWidth)} ${lineType} ${colorBorder}`,
                borderStartStartRadius: borderRadius,
                borderEndStartRadius: borderRadius
            },
            "&:last-child": {
                borderStartEndRadius: borderRadius,
                borderEndEndRadius: borderRadius
            },
            "&:first-child:last-child": {
                borderRadius: borderRadius
            },
            [`${componentCls}-group-large &`]: {
                height: controlHeightLG,
                fontSize: fontSizeLG,
                lineHeight: (0, $05f34ed03d41967d$export$523c0b569236b342)(calc(controlHeightLG).sub(calc(lineWidth).mul(2)).equal()),
                "&:first-child": {
                    borderStartStartRadius: borderRadiusLG,
                    borderEndStartRadius: borderRadiusLG
                },
                "&:last-child": {
                    borderStartEndRadius: borderRadiusLG,
                    borderEndEndRadius: borderRadiusLG
                }
            },
            [`${componentCls}-group-small &`]: {
                height: controlHeightSM,
                paddingInline: calc(paddingXS).sub(lineWidth).equal(),
                paddingBlock: 0,
                lineHeight: (0, $05f34ed03d41967d$export$523c0b569236b342)(calc(controlHeightSM).sub(calc(lineWidth).mul(2)).equal()),
                "&:first-child": {
                    borderStartStartRadius: borderRadiusSM,
                    borderEndStartRadius: borderRadiusSM
                },
                "&:last-child": {
                    borderStartEndRadius: borderRadiusSM,
                    borderEndEndRadius: borderRadiusSM
                }
            },
            [`${componentCls}-group-vertical > &`]: {
                marginInlineEnd: 0,
                borderRadius: 0,
                "&:not(:last-child)": {
                    marginBlockEnd: calc(lineWidth).mul(-1).equal()
                },
                "&:first-child": {
                    borderStartStartRadius: borderRadius,
                    borderStartEndRadius: borderRadius,
                    borderEndStartRadius: 0,
                    borderEndEndRadius: 0
                },
                "&:last-child": {
                    borderStartStartRadius: 0,
                    borderStartEndRadius: 0,
                    borderEndStartRadius: borderRadius,
                    borderEndEndRadius: borderRadius
                },
                "&:first-child:last-child": {
                    borderRadius: borderRadius
                }
            },
            [`${componentCls}-group-vertical${componentCls}-group-large > &`]: {
                "&:first-child": {
                    borderStartStartRadius: borderRadiusLG,
                    borderStartEndRadius: borderRadiusLG
                },
                "&:last-child": {
                    borderEndStartRadius: borderRadiusLG,
                    borderEndEndRadius: borderRadiusLG
                },
                "&:first-child:last-child": {
                    borderRadius: borderRadiusLG
                }
            },
            [`${componentCls}-group-vertical${componentCls}-group-small > &`]: {
                "&:first-child": {
                    borderStartStartRadius: borderRadiusSM,
                    borderStartEndRadius: borderRadiusSM
                },
                "&:last-child": {
                    borderEndStartRadius: borderRadiusSM,
                    borderEndEndRadius: borderRadiusSM
                },
                "&:first-child:last-child": {
                    borderRadius: borderRadiusSM
                }
            },
            "&:hover": {
                position: "relative",
                color: colorPrimary
            },
            "&:has(:focus-visible)": (0, $519d20bf207ce864$export$6539948f0a737e39)(token),
            [`${componentCls}, input[type='checkbox'], input[type='radio']`]: {
                width: 0,
                height: 0,
                opacity: 0,
                pointerEvents: "none"
            },
            [`&-checked:not(${componentCls}-button-wrapper-disabled)`]: {
                zIndex: 1,
                color: colorPrimary,
                background: buttonCheckedBg,
                borderColor: colorPrimary,
                "&::before": {
                    backgroundColor: colorPrimary
                },
                "&:first-child": {
                    borderColor: colorPrimary
                },
                "&:hover": {
                    color: colorPrimaryHover,
                    borderColor: colorPrimaryHover,
                    "&::before": {
                        backgroundColor: colorPrimaryHover
                    }
                },
                "&:active": {
                    color: colorPrimaryActive,
                    borderColor: colorPrimaryActive,
                    "&::before": {
                        backgroundColor: colorPrimaryActive
                    }
                }
            },
            [`${componentCls}-group-solid &-checked:not(${componentCls}-button-wrapper-disabled)`]: {
                color: buttonSolidCheckedColor,
                background: buttonSolidCheckedBg,
                borderColor: buttonSolidCheckedBg,
                "&:hover": {
                    color: buttonSolidCheckedColor,
                    background: buttonSolidCheckedHoverBg,
                    borderColor: buttonSolidCheckedHoverBg
                },
                "&:active": {
                    color: buttonSolidCheckedColor,
                    background: buttonSolidCheckedActiveBg,
                    borderColor: buttonSolidCheckedActiveBg
                }
            },
            "&-disabled": {
                color: colorTextDisabled,
                backgroundColor: colorBgContainerDisabled,
                borderColor: colorBorder,
                cursor: "not-allowed",
                "&:first-child, &:hover": {
                    color: colorTextDisabled,
                    backgroundColor: colorBgContainerDisabled,
                    borderColor: colorBorder
                }
            },
            [`&-disabled${componentCls}-button-wrapper-checked`]: {
                color: buttonCheckedColorDisabled,
                backgroundColor: buttonCheckedBgDisabled,
                borderColor: colorBorder,
                boxShadow: "none"
            },
            "&-block": {
                flex: 1,
                textAlign: "center"
            }
        }
    };
};
const $5717f17ca466ea76$export$9ca1be8807fe0675 = (token)=>{
    const { wireframe: wireframe, padding: padding, marginXS: marginXS, lineWidth: lineWidth, fontSizeLG: fontSizeLG, colorText: colorText, colorBgContainer: colorBgContainer, colorTextDisabled: colorTextDisabled, controlItemBgActiveDisabled: controlItemBgActiveDisabled, colorTextLightSolid: colorTextLightSolid, colorPrimary: colorPrimary, colorPrimaryHover: colorPrimaryHover, colorPrimaryActive: colorPrimaryActive, colorWhite: colorWhite } = token;
    const dotPadding = 4; // Fixed value
    const radioSize = fontSizeLG;
    const radioDotSize = wireframe ? radioSize - dotPadding * 2 : radioSize - (dotPadding + lineWidth) * 2;
    return {
        radioSize: // Radio
        radioSize,
        dotSize: radioDotSize,
        dotColorDisabled: colorTextDisabled,
        // Radio buttons
        buttonSolidCheckedColor: colorTextLightSolid,
        buttonSolidCheckedBg: colorPrimary,
        buttonSolidCheckedHoverBg: colorPrimaryHover,
        buttonSolidCheckedActiveBg: colorPrimaryActive,
        buttonBg: colorBgContainer,
        buttonCheckedBg: colorBgContainer,
        buttonColor: colorText,
        buttonCheckedBgDisabled: controlItemBgActiveDisabled,
        buttonCheckedColorDisabled: colorTextDisabled,
        buttonPaddingInline: padding - lineWidth,
        wrapperMarginInlineEnd: marginXS,
        // internal
        radioColor: wireframe ? colorPrimary : colorWhite,
        radioBgColor: wireframe ? colorBgContainer : colorPrimary
    };
};
var $5717f17ca466ea76$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$51ec95de45185b42)("Radio", (token)=>{
    const { controlOutline: controlOutline, controlOutlineWidth: controlOutlineWidth } = token;
    const radioFocusShadow = `0 0 0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(controlOutlineWidth)} ${controlOutline}`;
    const radioButtonFocusShadow = radioFocusShadow;
    const radioToken = (0, $fef50f256b80dfa5$export$4950aa0f605343fb)(token, {
        radioFocusShadow: radioFocusShadow,
        radioButtonFocusShadow: radioButtonFocusShadow
    });
    return [
        $5717f17ca466ea76$var$getGroupRadioStyle(radioToken),
        $5717f17ca466ea76$var$getRadioBasicStyle(radioToken),
        $5717f17ca466ea76$var$getRadioButtonStyle(radioToken)
    ];
}, $5717f17ca466ea76$export$9ca1be8807fe0675, {
    unitless: {
        radioSize: true,
        dotSize: true
    }
});


"use client";
const $8aec2d7f6aef583b$var$InternalRadio = (props, ref)=>{
    const groupContext = $cQmXV.useContext((0, $fa172403d1332f4a$export$2e2bcd8739ae039));
    const radioOptionTypeContext = $cQmXV.useContext((0, $fa172403d1332f4a$export$4fbd9581b41e971f));
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("radio");
    const innerRef = $cQmXV.useRef(null);
    const mergedRef = (0, $10341b937b26f69d$export$ab452c34e8e05029)(ref, innerRef);
    const { isFormItemInput: isFormItemInput } = $cQmXV.useContext((0, $7a3804f153d8a19d$export$bbb5553c6c7a14ed));
    const onChange = (e)=>{
        props.onChange?.(e);
        groupContext?.onChange?.(e);
    };
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, children: children, style: style, title: title, classNames: classNames, styles: styles, checked: checked, ...restProps } = props;
    const radioPrefixCls = getPrefixCls("radio", customizePrefixCls);
    const isButtonType = (groupContext?.optionType || radioOptionTypeContext) === "button";
    const prefixCls = isButtonType ? `${radioPrefixCls}-button` : radioPrefixCls;
    // Style
    const rootCls = (0, $2237081acd3cfc09$export$2e2bcd8739ae039)(radioPrefixCls);
    const [hashId, cssVarCls] = (0, $5717f17ca466ea76$export$2e2bcd8739ae039)(radioPrefixCls, rootCls);
    const radioProps = {
        ...restProps
    };
    // ===================== Disabled =====================
    const disabled = $cQmXV.useContext((0, $4f0e1ea30330557c$export$2e2bcd8739ae039));
    // ====================== Checked ======================
    const hasChecked = "checked" in props;
    let mergedChecked = checked;
    if (groupContext) {
        radioProps.name = groupContext.name;
        radioProps.onChange = onChange;
        mergedChecked = props.value === groupContext.value;
        radioProps.disabled = radioProps.disabled ?? groupContext.disabled;
    }
    if (hasChecked || groupContext) radioProps.checked = mergedChecked;
    radioProps.disabled = radioProps.disabled ?? disabled;
    // =========== Merged Props for Semantic ===========
    const mergedProps = {
        ...props,
        ...radioProps,
        checked: mergedChecked
    };
    const contextStyleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $30c5f9f911d4f61b$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: mergedProps
    });
    const wrapperClassString = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-wrapper`, {
        [`${prefixCls}-wrapper-checked`]: mergedChecked,
        [`${prefixCls}-wrapper-disabled`]: radioProps.disabled,
        [`${prefixCls}-wrapper-rtl`]: direction === "rtl",
        [`${prefixCls}-wrapper-in-form-item`]: isFormItemInput,
        [`${prefixCls}-wrapper-block`]: !!groupContext?.block
    }, contextClassName, className, rootClassName, mergedClassNames.root, hashId, cssVarCls, rootCls);
    // ============================ Event Lock ============================
    const [onLabelClick, onInputClick] = (0, $8510b23b609ef788$export$2e2bcd8739ae039)(radioProps.onClick);
    // ============================== Render ==============================
    return /*#__PURE__*/ $cQmXV.createElement((0, $02f5adbd0068e010$export$2e2bcd8739ae039), {
        component: "Radio",
        disabled: radioProps.disabled
    }, /*#__PURE__*/ $cQmXV.createElement("label", {
        className: wrapperClassString,
        style: mergedStyles.root,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        title: title,
        onClick: onLabelClick
    }, /*#__PURE__*/ $cQmXV.createElement((0, $293184ba40cdd0a0$export$2e2bcd8739ae039), {
        ...radioProps,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(mergedClassNames.icon, {
            [(0, $1f1e565d7b1db8d0$export$23466a5792b7a5d3)]: !isButtonType
        }),
        style: mergedStyles.icon,
        type: "radio",
        prefixCls: prefixCls,
        ref: mergedRef,
        onClick: onInputClick
    }), (0, $8e2d153a3c855782$export$72280d5f896dac9a)(children) ? /*#__PURE__*/ $cQmXV.createElement("span", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-label`, mergedClassNames.label),
        style: mergedStyles.label
    }, children) : null));
};
const $8aec2d7f6aef583b$var$Radio = /*#__PURE__*/ $cQmXV.forwardRef($8aec2d7f6aef583b$var$InternalRadio);
var $8aec2d7f6aef583b$export$2e2bcd8739ae039 = $8aec2d7f6aef583b$var$Radio;



"use client";
const $2b014885561bf54d$var$RadioGroup = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { getPrefixCls: getPrefixCls, direction: direction } = $cQmXV.useContext((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    const { name: formItemName } = $cQmXV.useContext((0, $7a3804f153d8a19d$export$bbb5553c6c7a14ed));
    const defaultName = (0, $a2da91bb60e2cbfb$export$2e2bcd8739ae039)((0, $64ccfaf5ba9e6521$export$368b682c15953eea)(formItemName));
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, options: options, buttonStyle: buttonStyle = "outline", disabled: disabled, children: children, size: customizeSize, style: style, id: id, optionType: optionType, name: name = defaultName, defaultValue: defaultValue, value: customizedValue, block: block = false, onChange: onChange, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onFocus: onFocus, onBlur: onBlur, orientation: orientation, vertical: vertical, role: role = "radiogroup" } = props;
    const [value, setValue] = (0, $a51866d781137e08$export$2e2bcd8739ae039)(defaultValue, customizedValue);
    const onRadioChange = $cQmXV.useCallback((event)=>{
        const lastValue = value;
        const val = event.target.value;
        if (!("value" in props)) setValue(val);
        if (val !== lastValue) onChange?.(event);
    }, [
        value,
        setValue,
        onChange
    ]);
    const prefixCls = getPrefixCls("radio", customizePrefixCls);
    const groupPrefixCls = `${prefixCls}-group`;
    // Style
    const rootCls = (0, $2237081acd3cfc09$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $5717f17ca466ea76$export$2e2bcd8739ae039)(prefixCls, rootCls);
    let childrenToRender = children;
    // 如果存在 options, 优先使用
    if (options && options.length > 0) childrenToRender = options.map((option)=>{
        if (typeof option === "string" || (0, $8e2d153a3c855782$export$7e4aa119212bc614)(option)) // 此处类型自动推导为 string
        return /*#__PURE__*/ $cQmXV.createElement((0, $8aec2d7f6aef583b$export$2e2bcd8739ae039), {
            key: option.toString(),
            prefixCls: prefixCls,
            disabled: disabled,
            value: option,
            checked: value === option
        }, option);
        // 此处类型自动推导为 { label: string value: string }
        return /*#__PURE__*/ $cQmXV.createElement((0, $8aec2d7f6aef583b$export$2e2bcd8739ae039), {
            key: `radio-group-value-options-${option.value}`,
            prefixCls: prefixCls,
            disabled: option.disabled || disabled,
            value: option.value,
            checked: value === option.value,
            title: option.title,
            style: option.style,
            className: option.className,
            id: option.id,
            required: option.required
        }, option.label);
    });
    const mergedSize = (0, $78cdfb6138721329$export$2e2bcd8739ae039)(customizeSize);
    const [, mergedVertical] = (0, $78e4f9cb51a5af1c$export$550084c67147f6c4)(orientation, vertical);
    const classString = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(groupPrefixCls, `${groupPrefixCls}-${buttonStyle}`, {
        [`${groupPrefixCls}-large`]: mergedSize === "large",
        [`${groupPrefixCls}-small`]: mergedSize === "small",
        [`${groupPrefixCls}-rtl`]: direction === "rtl",
        [`${groupPrefixCls}-block`]: block
    }, className, rootClassName, hashId, cssVarCls, rootCls);
    const memoizedValue = $cQmXV.useMemo(()=>({
            onChange: onRadioChange,
            value: value,
            disabled: disabled,
            name: name,
            optionType: optionType,
            block: block
        }), [
        onRadioChange,
        value,
        disabled,
        name,
        optionType,
        block
    ]);
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        ...(0, $4b5c733d1d7bb306$export$2e2bcd8739ae039)(props, {
            aria: true,
            data: true
        }),
        role: role,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(classString, {
            [`${prefixCls}-group-vertical`]: mergedVertical
        }),
        style: style,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onFocus: onFocus,
        onBlur: onBlur,
        id: id,
        ref: ref
    }, /*#__PURE__*/ $cQmXV.createElement((0, $fa172403d1332f4a$export$67d4730aee04efd2), {
        value: memoizedValue
    }, childrenToRender));
});
var $2b014885561bf54d$export$2e2bcd8739ae039 = /*#__PURE__*/ $cQmXV.memo($2b014885561bf54d$var$RadioGroup);




var $cQmXV = parcelRequire("cQmXV");



"use client";
const $a51e5de91ab58742$var$RadioButton = (props, ref)=>{
    const { getPrefixCls: getPrefixCls } = $cQmXV.useContext((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    const { prefixCls: customizePrefixCls, ...radioProps } = props;
    const prefixCls = getPrefixCls("radio", customizePrefixCls);
    return /*#__PURE__*/ $cQmXV.createElement((0, $fa172403d1332f4a$export$1b5d1f64a577990e), {
        value: "button"
    }, /*#__PURE__*/ $cQmXV.createElement((0, $8aec2d7f6aef583b$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        ...radioProps,
        type: "radio",
        ref: ref
    }));
};
var $a51e5de91ab58742$export$2e2bcd8739ae039 = /*#__PURE__*/ $cQmXV.forwardRef($a51e5de91ab58742$var$RadioButton);


"use client";
const $7f149e59454cb955$var$Radio = (0, $8aec2d7f6aef583b$export$2e2bcd8739ae039);
$7f149e59454cb955$var$Radio.Button = (0, $a51e5de91ab58742$export$2e2bcd8739ae039);
$7f149e59454cb955$var$Radio.Group = (0, $2b014885561bf54d$export$2e2bcd8739ae039);
$7f149e59454cb955$var$Radio.__ANT_RADIO = true;
var $7f149e59454cb955$export$2e2bcd8739ae039 = $7f149e59454cb955$var$Radio;


"use client";
const $c3a712de976be5d3$export$ed10248435b8f218 = {};
const $c3a712de976be5d3$export$14159cd9e2a500c8 = "SELECT_ALL";
const $c3a712de976be5d3$export$625c4f68eaaf8cfd = "SELECT_INVERT";
const $c3a712de976be5d3$export$c1a725540f5a63bd = "SELECT_NONE";
const $c3a712de976be5d3$var$EMPTY_LIST = [];
const $c3a712de976be5d3$var$flattenData = (childrenColumnName, data, list = [])=>{
    (data || []).forEach((record)=>{
        list.push(record);
        if ((0, $8e2d153a3c855782$export$53b83ca8eaab0383)(record) && childrenColumnName in record) $c3a712de976be5d3$var$flattenData(childrenColumnName, record[childrenColumnName], list);
    });
    return list;
};
const $c3a712de976be5d3$var$useSelection = (config, rowSelection)=>{
    const { preserveSelectedRowKeys: preserveSelectedRowKeys, selectedRowKeys: selectedRowKeys, defaultSelectedRowKeys: defaultSelectedRowKeys, getCheckboxProps: getCheckboxProps, getTitleCheckboxProps: getTitleCheckboxProps, onChange: onSelectionChange, onSelect: onSelect, onSelectAll: onSelectAll, onSelectInvert: onSelectInvert, onSelectNone: onSelectNone, onSelectMultiple: onSelectMultiple, columnWidth: selectionColWidth, type: selectionType, selections: selections, fixed: fixed, renderCell: customizeRenderCell, hideSelectAll: hideSelectAll, checkStrictly: checkStrictly = true } = rowSelection || {};
    const { prefixCls: prefixCls, data: data, pageData: pageData, getRecordByKey: getRecordByKey, getRowKey: getRowKey, expandType: expandType, childrenColumnName: childrenColumnName, locale: tableLocale, getPopupContainer: getPopupContainer } = config;
    const warning = (0, $b5822acdae823465$export$cf977aa92c751e61)("Table");
    // ========================= MultipleSelect =========================
    const [multipleSelect, updatePrevSelectedIndex] = (0, $b5da25dd25a6ebd7$export$3f339a531a4f3fb4)((item)=>item);
    // ========================= Keys =========================
    const [mergedSelectedKeys, setMergedSelectedKeys] = (0, $a51866d781137e08$export$2e2bcd8739ae039)(defaultSelectedRowKeys || $c3a712de976be5d3$var$EMPTY_LIST, selectedRowKeys);
    const mergedSelectedKeyList = mergedSelectedKeys ?? $c3a712de976be5d3$var$EMPTY_LIST;
    // ======================== Caches ========================
    const preserveRecordsRef = $cQmXV.useRef(new Map());
    const updatePreserveRecordsCache = (0, $cQmXV.useCallback)((keys)=>{
        if (preserveSelectedRowKeys) {
            const newCache = new Map();
            // Keep key if mark as preserveSelectedRowKeys
            keys.forEach((key)=>{
                let record = getRecordByKey(key);
                if (!record && preserveRecordsRef.current.has(key)) record = preserveRecordsRef.current.get(key);
                newCache.set(key, record);
            });
            // Refresh to new cache
            preserveRecordsRef.current = newCache;
        }
    }, [
        getRecordByKey,
        preserveSelectedRowKeys
    ]);
    // Update cache with selectedKeys
    $cQmXV.useEffect(()=>{
        updatePreserveRecordsCache(mergedSelectedKeyList);
    }, [
        mergedSelectedKeyList,
        updatePreserveRecordsCache
    ]);
    // Get flatten data
    const flattedData = (0, $cQmXV.useMemo)(()=>$c3a712de976be5d3$var$flattenData(childrenColumnName, pageData), [
        childrenColumnName,
        pageData
    ]);
    const { keyEntities: keyEntities } = (0, $cQmXV.useMemo)(()=>{
        if (checkStrictly) return {
            keyEntities: null
        };
        let convertData = data;
        if (preserveSelectedRowKeys) {
            // use flattedData keys
            const keysSet = new Set(flattedData.map(getRowKey));
            // remove preserveRecords that duplicate data
            const preserveRecords = Array.from(preserveRecordsRef.current).reduce((total, [key, value])=>keysSet.has(key) ? total : total.concat(value), []);
            convertData = [].concat((0, $68381b18b974dc9f$export$2e2bcd8739ae039)(convertData), (0, $68381b18b974dc9f$export$2e2bcd8739ae039)(preserveRecords));
        }
        return (0, $718db4e60315df95$export$e5d831ce033a4615)(convertData, {
            externalGetKey: getRowKey,
            childrenPropName: childrenColumnName
        });
    }, [
        data,
        getRowKey,
        checkStrictly,
        childrenColumnName,
        preserveSelectedRowKeys,
        flattedData
    ]);
    // Get all checkbox props
    const checkboxPropsMap = (0, $cQmXV.useMemo)(()=>{
        const map = new Map();
        flattedData.forEach((record, index)=>{
            const key = getRowKey(record, index);
            const checkboxProps = (getCheckboxProps ? getCheckboxProps(record) : null) || {};
            map.set(key, checkboxProps);
        });
        return map;
    }, [
        flattedData,
        getRowKey,
        getCheckboxProps
    ]);
    const isCheckboxDisabled = (0, $cQmXV.useCallback)((r)=>{
        const rowKey = getRowKey(r);
        let checkboxProps;
        if (checkboxPropsMap.has(rowKey)) checkboxProps = checkboxPropsMap.get(getRowKey(r));
        else checkboxProps = getCheckboxProps ? getCheckboxProps(r) : undefined;
        return !!checkboxProps?.disabled;
    }, [
        checkboxPropsMap,
        getRowKey
    ]);
    const [derivedSelectedKeys, derivedHalfSelectedKeys] = (0, $cQmXV.useMemo)(()=>{
        if (checkStrictly) return [
            mergedSelectedKeyList,
            []
        ];
        const { checkedKeys: checkedKeys, halfCheckedKeys: halfCheckedKeys } = (0, $22d84263da5951d2$export$43adf2c483e3e633)(mergedSelectedKeyList, true, keyEntities, isCheckboxDisabled);
        return [
            checkedKeys || [],
            halfCheckedKeys
        ];
    }, [
        mergedSelectedKeyList,
        checkStrictly,
        keyEntities,
        isCheckboxDisabled
    ]);
    const derivedSelectedKeySet = (0, $cQmXV.useMemo)(()=>{
        const keys = selectionType === "radio" ? derivedSelectedKeys.slice(0, 1) : derivedSelectedKeys;
        return new Set(keys);
    }, [
        derivedSelectedKeys,
        selectionType
    ]);
    const derivedHalfSelectedKeySet = (0, $cQmXV.useMemo)(()=>selectionType === "radio" ? new Set() : new Set(derivedHalfSelectedKeys), [
        derivedHalfSelectedKeys,
        selectionType
    ]);
    // Reset if rowSelection reset
    $cQmXV.useEffect(()=>{
        if (!rowSelection) setMergedSelectedKeys($c3a712de976be5d3$var$EMPTY_LIST);
    }, [
        !!rowSelection
    ]);
    const setSelectedKeys = (0, $cQmXV.useCallback)((keys, method)=>{
        let availableKeys;
        let records;
        updatePreserveRecordsCache(keys);
        if (preserveSelectedRowKeys) {
            availableKeys = keys;
            records = keys.map((key)=>preserveRecordsRef.current.get(key));
        } else {
            // Filter key which not exist in the `dataSource`
            availableKeys = [];
            records = [];
            keys.forEach((key)=>{
                const record = getRecordByKey(key);
                if (record !== undefined) {
                    availableKeys.push(key);
                    records.push(record);
                }
            });
        }
        setMergedSelectedKeys(availableKeys);
        onSelectionChange?.(availableKeys, records, {
            type: method
        });
    }, [
        setMergedSelectedKeys,
        getRecordByKey,
        onSelectionChange,
        preserveSelectedRowKeys
    ]);
    // ====================== Selections ======================
    // Trigger single `onSelect` event
    const triggerSingleSelection = (0, $cQmXV.useCallback)((key, selected, keys, event)=>{
        if (onSelect) {
            const rows = keys.map(getRecordByKey);
            onSelect(getRecordByKey(key), selected, rows, event);
        }
        setSelectedKeys(keys, "single");
    }, [
        onSelect,
        getRecordByKey,
        setSelectedKeys
    ]);
    const mergedSelections = (0, $cQmXV.useMemo)(()=>{
        if (!selections || hideSelectAll) return null;
        const selectionList = selections === true ? [
            $c3a712de976be5d3$export$14159cd9e2a500c8,
            $c3a712de976be5d3$export$625c4f68eaaf8cfd,
            $c3a712de976be5d3$export$c1a725540f5a63bd
        ] : selections;
        return selectionList.map((selection)=>{
            let mergedSelection;
            if (selection === $c3a712de976be5d3$export$14159cd9e2a500c8) mergedSelection = {
                key: "all",
                text: tableLocale.selectionAll,
                onSelect () {
                    setSelectedKeys(data.reduce((keys, record, index)=>{
                        const key = getRowKey(record, index);
                        if (!isCheckboxDisabled(record) || derivedSelectedKeySet.has(key)) keys.push(key);
                        return keys;
                    }, []), "all");
                }
            };
            else if (selection === $c3a712de976be5d3$export$625c4f68eaaf8cfd) mergedSelection = {
                key: "invert",
                text: tableLocale.selectInvert,
                onSelect () {
                    const keySet = new Set(derivedSelectedKeySet);
                    pageData.forEach((record, index)=>{
                        const key = getRowKey(record, index);
                        const checkProps = checkboxPropsMap.get(key);
                        if (!checkProps?.disabled) {
                            if (keySet.has(key)) keySet.delete(key);
                            else keySet.add(key);
                        }
                    });
                    const keys = Array.from(keySet);
                    if (onSelectInvert) {
                        warning.deprecated(false, "onSelectInvert", "onChange");
                        onSelectInvert(keys);
                    }
                    setSelectedKeys(keys, "invert");
                }
            };
            else if (selection === $c3a712de976be5d3$export$c1a725540f5a63bd) mergedSelection = {
                key: "none",
                text: tableLocale.selectNone,
                onSelect () {
                    onSelectNone?.();
                    setSelectedKeys(Array.from(derivedSelectedKeySet).filter((key)=>{
                        const checkProps = checkboxPropsMap.get(key);
                        return checkProps?.disabled;
                    }), "none");
                }
            };
            else mergedSelection = selection;
            return {
                ...mergedSelection,
                onSelect: (currentRowKeys)=>{
                    mergedSelection.onSelect?.(currentRowKeys);
                    updatePrevSelectedIndex(null);
                }
            };
        });
    }, [
        selections,
        hideSelectAll,
        tableLocale.selectionAll,
        tableLocale.selectInvert,
        tableLocale.selectNone,
        checkboxPropsMap,
        isCheckboxDisabled,
        derivedSelectedKeySet,
        data,
        pageData,
        getRowKey,
        onSelectInvert,
        setSelectedKeys
    ]);
    // ======================= Columns ========================
    const transformColumns = (0, $cQmXV.useCallback)((columns)=>{
        // >>>>>>>>>>> Skip if not exists `rowSelection`
        if (!rowSelection) return columns.filter((col)=>col !== $c3a712de976be5d3$export$ed10248435b8f218);
        // >>>>>>>>>>> Support selection
        let cloneColumns = (0, $68381b18b974dc9f$export$2e2bcd8739ae039)(columns);
        const keySet = new Set(derivedSelectedKeySet);
        // Record key only need check with enabled
        const recordKeys = flattedData.reduce((keys, record, index)=>{
            const key = getRowKey(record, index);
            if (!checkboxPropsMap.get(key).disabled) keys.push(key);
            return keys;
        }, []);
        const checkedCurrentAll = recordKeys.every((key)=>keySet.has(key));
        const checkedCurrentSome = recordKeys.some((key)=>keySet.has(key));
        const onSelectAllChange = ()=>{
            const changeKeys = [];
            if (checkedCurrentAll) recordKeys.forEach((key)=>{
                keySet.delete(key);
                changeKeys.push(key);
            });
            else recordKeys.forEach((key)=>{
                if (!keySet.has(key)) {
                    keySet.add(key);
                    changeKeys.push(key);
                }
            });
            const keys = Array.from(keySet);
            onSelectAll?.(!checkedCurrentAll, keys.map(getRecordByKey), changeKeys.map(getRecordByKey));
            setSelectedKeys(keys, "all");
            updatePrevSelectedIndex(null);
        };
        // ===================== Render =====================
        // Title Cell
        let title;
        let columnTitleCheckbox;
        if (selectionType !== "radio") {
            let customizeSelections;
            if (mergedSelections) {
                const menu = {
                    getPopupContainer: getPopupContainer,
                    items: mergedSelections.map((selection, index)=>{
                        const { key: key, text: text, onSelect: onSelectionClick } = selection;
                        return {
                            key: key ?? index,
                            onClick: ()=>{
                                onSelectionClick?.(recordKeys);
                            },
                            label: text
                        };
                    })
                };
                customizeSelections = /*#__PURE__*/ $cQmXV.createElement("div", {
                    className: `${prefixCls}-selection-extra`
                }, /*#__PURE__*/ $cQmXV.createElement((0, $30ddd2d6a9f4b7d6$export$2e2bcd8739ae039), {
                    menu: menu,
                    getPopupContainer: getPopupContainer
                }, /*#__PURE__*/ $cQmXV.createElement("span", null, /*#__PURE__*/ $cQmXV.createElement((0, $e7119b602540b2c5$export$2e2bcd8739ae039), null))));
            }
            const allDisabledData = flattedData.reduce((list, record, index)=>{
                const key = getRowKey(record, index);
                const checkboxProps = checkboxPropsMap.get(key) || {};
                const item = {
                    checked: keySet.has(key),
                    ...checkboxProps
                };
                if (item.disabled) list.push(item);
                return list;
            }, []);
            const allDisabled = !!allDisabledData.length && allDisabledData.length === flattedData.length;
            const allDisabledAndChecked = allDisabled && allDisabledData.every(({ checked: checked })=>checked);
            const allDisabledSomeChecked = allDisabled && allDisabledData.some(({ checked: checked })=>checked);
            const customCheckboxProps = getTitleCheckboxProps?.() || {};
            const { onChange: onChange, disabled: disabled } = customCheckboxProps;
            columnTitleCheckbox = /*#__PURE__*/ $cQmXV.createElement((0, $7a650444b7c2c328$export$2e2bcd8739ae039), {
                "aria-label": customizeSelections ? "Custom selection" : "Select all",
                ...customCheckboxProps,
                checked: !allDisabled ? !!flattedData.length && checkedCurrentAll : allDisabledAndChecked,
                indeterminate: !allDisabled ? !checkedCurrentAll && checkedCurrentSome : !allDisabledAndChecked && allDisabledSomeChecked,
                onChange: (e)=>{
                    onSelectAllChange();
                    onChange?.(e);
                },
                disabled: disabled ?? (flattedData.length === 0 || allDisabled),
                skipGroup: true
            });
            title = !hideSelectAll && /*#__PURE__*/ $cQmXV.createElement("div", {
                className: `${prefixCls}-selection`
            }, columnTitleCheckbox, customizeSelections);
        }
        // Body Cell
        let renderCell;
        if (selectionType === "radio") renderCell = (_, record, index)=>{
            const key = getRowKey(record, index);
            const checked = keySet.has(key);
            const checkboxProps = checkboxPropsMap.get(key);
            const defaultAriaLabel = `Select row ${index + 1}`;
            return {
                node: /*#__PURE__*/ $cQmXV.createElement((0, $7f149e59454cb955$export$2e2bcd8739ae039), {
                    "aria-label": defaultAriaLabel,
                    ...checkboxProps,
                    checked: checked,
                    onClick: (e)=>{
                        e.stopPropagation();
                        checkboxProps?.onClick?.(e);
                    },
                    onChange: (event)=>{
                        if (!keySet.has(key)) triggerSingleSelection(key, true, [
                            key
                        ], event.nativeEvent);
                        checkboxProps?.onChange?.(event);
                    }
                }),
                checked: checked
            };
        };
        else renderCell = (_, record, index)=>{
            const key = getRowKey(record, index);
            const checked = keySet.has(key);
            const indeterminate = derivedHalfSelectedKeySet.has(key);
            const checkboxProps = checkboxPropsMap.get(key);
            let mergedIndeterminate;
            if (expandType === "nest") mergedIndeterminate = indeterminate;
            else mergedIndeterminate = checkboxProps?.indeterminate ?? indeterminate;
            const defaultAriaLabel = checked ? `Row ${index + 1} selected` : `Select row ${index + 1}`;
            // Record checked
            return {
                node: /*#__PURE__*/ $cQmXV.createElement((0, $7a650444b7c2c328$export$2e2bcd8739ae039), {
                    "aria-label": defaultAriaLabel,
                    ...checkboxProps,
                    indeterminate: mergedIndeterminate,
                    checked: checked,
                    skipGroup: true,
                    onClick: (e)=>{
                        e.stopPropagation();
                        checkboxProps?.onClick?.(e);
                    },
                    onChange: (event)=>{
                        const { nativeEvent: nativeEvent } = event;
                        const { shiftKey: shiftKey } = nativeEvent;
                        const currentSelectedIndex = recordKeys.indexOf(key);
                        const isMultiple = derivedSelectedKeySet.size > 0 && recordKeys.some((key)=>derivedSelectedKeySet.has(key));
                        if (shiftKey && checkStrictly && isMultiple) {
                            const changedKeys = multipleSelect(currentSelectedIndex, recordKeys, keySet);
                            const keys = Array.from(keySet);
                            onSelectMultiple?.(!checked, keys.map(getRecordByKey), changedKeys.map(getRecordByKey));
                            setSelectedKeys(keys, "multiple");
                        } else {
                            // Single record selected
                            const originCheckedKeys = derivedSelectedKeys;
                            if (checkStrictly) {
                                const checkedKeys = checked ? (0, $9f5f4c60f5f7fe12$export$5bfb9ff497fe2298)(originCheckedKeys, key) : (0, $9f5f4c60f5f7fe12$export$10663f6bbd2fd717)(originCheckedKeys, key);
                                triggerSingleSelection(key, !checked, checkedKeys, nativeEvent);
                            } else {
                                // Always fill first
                                const result = (0, $22d84263da5951d2$export$43adf2c483e3e633)([].concat((0, $68381b18b974dc9f$export$2e2bcd8739ae039)(originCheckedKeys), [
                                    key
                                ]), true, keyEntities, isCheckboxDisabled);
                                const { checkedKeys: checkedKeys, halfCheckedKeys: halfCheckedKeys } = result;
                                let nextCheckedKeys = checkedKeys;
                                // If remove, we do it again to correction
                                if (checked) {
                                    const tempKeySet = new Set(checkedKeys);
                                    tempKeySet.delete(key);
                                    nextCheckedKeys = (0, $22d84263da5951d2$export$43adf2c483e3e633)(Array.from(tempKeySet), {
                                        checked: false,
                                        halfCheckedKeys: halfCheckedKeys
                                    }, keyEntities, isCheckboxDisabled).checkedKeys;
                                }
                                triggerSingleSelection(key, !checked, nextCheckedKeys, nativeEvent);
                            }
                        }
                        if (checked) updatePrevSelectedIndex(null);
                        else updatePrevSelectedIndex(currentSelectedIndex);
                        checkboxProps?.onChange?.(event);
                    }
                }),
                checked: checked
            };
        };
        const renderSelectionCell = (_, record, index)=>{
            const { node: node, checked: checked } = renderCell(_, record, index);
            if (customizeRenderCell) return customizeRenderCell(checked, record, index, node);
            return node;
        };
        // Insert selection column if not exist
        if (!cloneColumns.includes($c3a712de976be5d3$export$ed10248435b8f218)) {
            // Always after expand icon
            if (cloneColumns.findIndex((col)=>col[0, $94bfd0c932f33df8$export$f8dba99c0d5b6b87]?.columnType === "EXPAND_COLUMN") === 0) {
                const [expandColumn, ...restColumns] = cloneColumns;
                cloneColumns = [
                    expandColumn,
                    $c3a712de976be5d3$export$ed10248435b8f218
                ].concat((0, $68381b18b974dc9f$export$2e2bcd8739ae039)(restColumns));
            } else // Normal insert at first column
            cloneColumns = [
                $c3a712de976be5d3$export$ed10248435b8f218
            ].concat((0, $68381b18b974dc9f$export$2e2bcd8739ae039)(cloneColumns));
        }
        // Deduplicate selection column
        const selectionColumnIndex = cloneColumns.indexOf($c3a712de976be5d3$export$ed10248435b8f218);
        cloneColumns = cloneColumns.filter((column, index)=>column !== $c3a712de976be5d3$export$ed10248435b8f218 || index === selectionColumnIndex);
        // Fixed column logic
        const prevCol = cloneColumns[selectionColumnIndex - 1];
        const nextCol = cloneColumns[selectionColumnIndex + 1];
        let mergedFixed = fixed;
        if (mergedFixed === undefined) {
            if (nextCol?.fixed !== undefined) mergedFixed = nextCol.fixed;
            else if (prevCol?.fixed !== undefined) mergedFixed = prevCol.fixed;
        }
        if (mergedFixed && prevCol && prevCol[0, $94bfd0c932f33df8$export$f8dba99c0d5b6b87]?.columnType === "EXPAND_COLUMN" && prevCol.fixed === undefined) prevCol.fixed = mergedFixed;
        const columnCls = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-selection-col`, {
            [`${prefixCls}-selection-col-with-dropdown`]: selections && selectionType === "checkbox"
        });
        const renderColumnTitle = ()=>{
            if (!rowSelection?.columnTitle) return title;
            if ((0, $8e2d153a3c855782$export$f6e2535fb5126e54)(rowSelection.columnTitle)) return rowSelection.columnTitle(columnTitleCheckbox);
            return rowSelection.columnTitle;
        };
        // Replace with real selection column
        const selectionColumn = {
            fixed: mergedFixed,
            width: selectionColWidth,
            className: `${prefixCls}-selection-column`,
            title: renderColumnTitle(),
            render: renderSelectionCell,
            onCell: rowSelection.onCell,
            align: rowSelection.align,
            [(0, $94bfd0c932f33df8$export$f8dba99c0d5b6b87)]: {
                className: columnCls
            }
        };
        return cloneColumns.map((col)=>col === $c3a712de976be5d3$export$ed10248435b8f218 ? selectionColumn : col);
    }, [
        getRowKey,
        flattedData,
        rowSelection,
        derivedSelectedKeys,
        derivedSelectedKeySet,
        derivedHalfSelectedKeySet,
        selectionColWidth,
        mergedSelections,
        expandType,
        checkboxPropsMap,
        onSelectMultiple,
        triggerSingleSelection,
        isCheckboxDisabled
    ]);
    return [
        transformColumns,
        derivedSelectedKeySet
    ];
};
var $c3a712de976be5d3$export$2e2bcd8739ae039 = $c3a712de976be5d3$var$useSelection;



var $cQmXV = parcelRequire("cQmXV");



// Proxy the dom ref with `{ nativeElement, otherFn }` type
// ref: https://github.com/ant-design/ant-design/discussions/45242

var $cQmXV = parcelRequire("cQmXV");
const $0de7c436be0f1609$var$fillProxy = (element, handler)=>{
    element._antProxy = element._antProxy || {};
    Object.keys(handler).forEach((key)=>{
        if (!(key in element._antProxy)) {
            const ori = element[key];
            element._antProxy[key] = ori;
            element[key] = handler[key];
        }
    });
    return element;
};
const $0de7c436be0f1609$export$8edbe0145ad77a36 = (ref, init)=>{
    return (0, $cQmXV.useImperativeHandle)(ref, ()=>{
        const refObj = init();
        const { nativeElement: nativeElement } = refObj;
        if (typeof Proxy !== "undefined") return new Proxy(nativeElement, {
            get (obj, prop) {
                if (refObj[prop]) return refObj[prop];
                return Reflect.get(obj, prop);
            }
        });
        // Fallback of IE
        return $0de7c436be0f1609$var$fillProxy(nativeElement, refObj);
    });
};





function $7920d6a1981c65d9$export$24656b269d8df7d6(t, b, c, d) {
    const cc = c - b;
    t /= d / 2;
    if (t < 1) return cc / 2 * t * t * t + b;
    // biome-ignore lint: it is a common easing function
    return cc / 2 * ((t -= 2) * t * t + 2) + b;
}



const $764c529cb0981ab5$var$getScroll = (target)=>{
    if (typeof window === "undefined") /* istanbul ignore next */ return 0;
    let result = 0;
    if ((0, $8e2d153a3c855782$export$5a096129d439f843)(target)) result = target.pageYOffset;
    else if ((0, $8e2d153a3c855782$export$62858bae88b53fd0)(target)) result = target.documentElement.scrollTop;
    else if ((0, $8e2d153a3c855782$export$1b3bfaa9684536aa)(target)) result = target.scrollTop;
    else if (target) // According to the type inference, the `target` is `never` type.
    // Since we configured the loose mode type checking, and supports mocking the target with such shape below::
    //    `{ documentElement: { scrollLeft: 200, scrollTop: 400 } }`,
    //    the program may falls into this branch.
    // Check the corresponding tests for details. Don't sure what is the real scenario this happens.
    /* biome-ignore lint/complexity/useLiteralKeys: target is a never type */ /* eslint-disable-next-line dot-notation */ result = target["scrollTop"];
    if (target && !(0, $8e2d153a3c855782$export$5a096129d439f843)(target) && !(0, $8e2d153a3c855782$export$7e4aa119212bc614)(result)) result = (target.ownerDocument ?? target).documentElement?.scrollTop;
    return result;
};
var $764c529cb0981ab5$export$2e2bcd8739ae039 = $764c529cb0981ab5$var$getScroll;



const $355a55ff8bfb603e$var$scrollTo = (y, options = {})=>{
    const { getContainer: getContainer = ()=>window, callback: callback, duration: duration = 450 } = options;
    const container = getContainer();
    const scrollTop = (0, $764c529cb0981ab5$export$2e2bcd8739ae039)(container);
    const scroll = (top)=>{
        if ((0, $8e2d153a3c855782$export$5a096129d439f843)(container)) container.scrollTo(window.pageXOffset, top);
        else if ((0, $8e2d153a3c855782$export$62858bae88b53fd0)(container)) container.documentElement.scrollTop = top;
        else container.scrollTop = top;
    };
    if (duration <= 0) {
        scroll(y);
        if ((0, $8e2d153a3c855782$export$f6e2535fb5126e54)(callback)) callback();
        return ()=>{};
    }
    const startTime = Date.now();
    let rafId;
    const frameFunc = ()=>{
        const timestamp = Date.now();
        const time = timestamp - startTime;
        const nextScrollTop = (0, $7920d6a1981c65d9$export$24656b269d8df7d6)(time > duration ? duration : time, scrollTop, y, duration);
        scroll(nextScrollTop);
        if (time < duration) rafId = (0, $905c53b807de704e$export$2e2bcd8739ae039)(frameFunc);
        else if ((0, $8e2d153a3c855782$export$f6e2535fb5126e54)(callback)) callback();
    };
    rafId = (0, $905c53b807de704e$export$2e2bcd8739ae039)(frameFunc);
    return ()=>{
        (0, $905c53b807de704e$export$2e2bcd8739ae039).cancel(rafId);
    };
};
var $355a55ff8bfb603e$export$2e2bcd8739ae039 = $355a55ff8bfb603e$var$scrollTo;






var $cQmXV = parcelRequire("cQmXV");


"use client";
const $3f2744634b9eeb0b$var$DefaultRenderEmpty = (props)=>{
    const { componentName: componentName } = props;
    const { getPrefixCls: getPrefixCls } = (0, $cQmXV.useContext)((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    const prefix = getPrefixCls("empty");
    switch(componentName){
        case "Table":
        case "List":
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $99350450b877904c$export$2e2bcd8739ae039), {
                image: (0, $99350450b877904c$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE
            });
        case "Select":
        case "TreeSelect":
        case "Cascader":
        case "Transfer":
        case "Mentions":
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $99350450b877904c$export$2e2bcd8739ae039), {
                image: (0, $99350450b877904c$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE,
                className: `${prefix}-small`
            });
        /**
     * This type of component should satisfy the nullish coalescing operator(??) on the left-hand side.
     * to let the component itself implement the logic.
     * For example `Table.filter`.
     */ case "Table.filter":
            // why `null`? legacy react16 node type `undefined` is not allowed.
            return null;
        default:
            // Should never hit if we take all the component into consider.
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $99350450b877904c$export$2e2bcd8739ae039), null);
    }
};
var $3f2744634b9eeb0b$export$2e2bcd8739ae039 = $3f2744634b9eeb0b$var$DefaultRenderEmpty;








var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");
var $e685765cae709cf7$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($e685765cae709cf7$exports, "__esModule", {
    value: true
});
var $e685765cae709cf7$var$DoubleLeftOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M272.9 512l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L186.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H532c6.7 0 10.4-7.7 6.3-12.9L272.9 512zm304 0l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L490.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H836c6.7 0 10.4-7.7 6.3-12.9L576.9 512z"
                }
            }
        ]
    },
    "name": "double-left",
    "theme": "outlined"
};
$e685765cae709cf7$exports.default = $e685765cae709cf7$var$DoubleLeftOutlined;



function $e3da9ea1c6385a97$var$_extends() {
    $e3da9ea1c6385a97$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e3da9ea1c6385a97$var$_extends.apply(this, arguments);
}
const $e3da9ea1c6385a97$var$DoubleLeftOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $e3da9ea1c6385a97$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e685765cae709cf7$exports)))
    }));
/**![double-left](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTI3Mi45IDUxMmwyNjUuNC0zMzkuMWM0LjEtNS4yLjQtMTIuOS02LjMtMTIuOWgtNzcuM2MtNC45IDAtOS42IDIuMy0xMi42IDYuMUwxODYuOCA0OTIuM2EzMS45OSAzMS45OSAwIDAwMCAzOS41bDI1NS4zIDMyNi4xYzMgMy45IDcuNyA2LjEgMTIuNiA2LjFINTMyYzYuNyAwIDEwLjQtNy43IDYuMy0xMi45TDI3Mi45IDUxMnptMzA0IDBsMjY1LjQtMzM5LjFjNC4xLTUuMi40LTEyLjktNi4zLTEyLjloLTc3LjNjLTQuOSAwLTkuNiAyLjMtMTIuNiA2LjFMNDkwLjggNDkyLjNhMzEuOTkgMzEuOTkgMCAwMDAgMzkuNWwyNTUuMyAzMjYuMWMzIDMuOSA3LjcgNi4xIDEyLjYgNi4xSDgzNmM2LjcgMCAxMC40LTcuNyA2LjMtMTIuOUw1NzYuOSA1MTJ6IiAvPjwvc3ZnPg==) */ const $e3da9ea1c6385a97$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($e3da9ea1c6385a97$var$DoubleLeftOutlined);
var $e3da9ea1c6385a97$export$2e2bcd8739ae039 = $e3da9ea1c6385a97$var$RefIcon;



var $cQmXV = parcelRequire("cQmXV");
var $fbf8007bd7e67345$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($fbf8007bd7e67345$exports, "__esModule", {
    value: true
});
var $fbf8007bd7e67345$var$DoubleRightOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M533.2 492.3L277.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H188c-6.7 0-10.4 7.7-6.3 12.9L447.1 512 181.7 851.1A7.98 7.98 0 00188 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5zm304 0L581.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H492c-6.7 0-10.4 7.7-6.3 12.9L751.1 512 485.7 851.1A7.98 7.98 0 00492 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5z"
                }
            }
        ]
    },
    "name": "double-right",
    "theme": "outlined"
};
$fbf8007bd7e67345$exports.default = $fbf8007bd7e67345$var$DoubleRightOutlined;



function $1e8d754253c41ae7$var$_extends() {
    $1e8d754253c41ae7$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1e8d754253c41ae7$var$_extends.apply(this, arguments);
}
const $1e8d754253c41ae7$var$DoubleRightOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $1e8d754253c41ae7$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fbf8007bd7e67345$exports)))
    }));
/**![double-right](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUzMy4yIDQ5Mi4zTDI3Ny45IDE2Ni4xYy0zLTMuOS03LjctNi4xLTEyLjYtNi4xSDE4OGMtNi43IDAtMTAuNCA3LjctNi4zIDEyLjlMNDQ3LjEgNTEyIDE4MS43IDg1MS4xQTcuOTggNy45OCAwIDAwMTg4IDg2NGg3Ny4zYzQuOSAwIDkuNi0yLjMgMTIuNi02LjFsMjU1LjMtMzI2LjFjOS4xLTExLjcgOS4xLTI3LjkgMC0zOS41em0zMDQgMEw1ODEuOSAxNjYuMWMtMy0zLjktNy43LTYuMS0xMi42LTYuMUg0OTJjLTYuNyAwLTEwLjQgNy43LTYuMyAxMi45TDc1MS4xIDUxMiA0ODUuNyA4NTEuMUE3Ljk4IDcuOTggMCAwMDQ5MiA4NjRoNzcuM2M0LjkgMCA5LjYtMi4zIDEyLjYtNi4xbDI1NS4zLTMyNi4xYzkuMS0xMS43IDkuMS0yNy45IDAtMzkuNXoiIC8+PC9zdmc+) */ const $1e8d754253c41ae7$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($1e8d754253c41ae7$var$DoubleRightOutlined);
var $1e8d754253c41ae7$export$2e2bcd8739ae039 = $1e8d754253c41ae7$var$RefIcon;








var $cQmXV = parcelRequire("cQmXV");
const $937660311fe3df6b$var$locale = {
    // Options
    items_per_page: "\u6761/\u9875",
    jump_to: "\u8DF3\u81F3",
    jump_to_confirm: "\u786E\u5B9A",
    page: "\u9875",
    // Pagination
    prev_page: "\u4E0A\u4E00\u9875",
    next_page: "\u4E0B\u4E00\u9875",
    prev_5: "\u5411\u524D 5 \u9875",
    next_5: "\u5411\u540E 5 \u9875",
    prev_3: "\u5411\u524D 3 \u9875",
    next_3: "\u5411\u540E 3 \u9875",
    page_size: "\u9875\u7801"
};
var $937660311fe3df6b$export$2e2bcd8739ae039 = $937660311fe3df6b$var$locale;




var $cQmXV = parcelRequire("cQmXV");
const $4b2df549ee7bde27$var$defaultPageSizeOptions = [
    10,
    20,
    50,
    100
];
const $4b2df549ee7bde27$var$Options = (props)=>{
    const { pageSizeOptions: pageSizeOptions = $4b2df549ee7bde27$var$defaultPageSizeOptions, locale: locale, changeSize: changeSize, pageSize: pageSize, goButton: goButton, quickGo: quickGo, rootPrefixCls: rootPrefixCls, disabled: disabled, buildOptionText: buildOptionText, showSizeChanger: showSizeChanger, sizeChangerRender: sizeChangerRender } = props;
    const [goInputText, setGoInputText] = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useState("");
    const getValidValue = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useMemo(()=>{
        return !goInputText || Number.isNaN(goInputText) ? undefined : Number(goInputText);
    }, [
        goInputText
    ]);
    const mergeBuildOptionText = typeof buildOptionText === "function" ? buildOptionText : (value)=>`${value} ${locale.items_per_page}`;
    const handleChange = (e)=>{
        const value = e.target.value;
        if (/^\d*$/.test(value)) setGoInputText(value);
    };
    const handleBlur = (e)=>{
        if (goButton || goInputText === "") return;
        setGoInputText("");
        if (e.relatedTarget && (e.relatedTarget.className.includes(`${rootPrefixCls}-item-link`) || e.relatedTarget.className.includes(`${rootPrefixCls}-item`))) return;
        quickGo?.(getValidValue);
    };
    const go = (e)=>{
        if (goInputText === "") return;
        if (e.keyCode === (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).ENTER || e.type === "click") {
            setGoInputText("");
            quickGo?.(getValidValue);
        }
    };
    const getPageSizeOptions = ()=>{
        if (pageSizeOptions.some((option)=>option.toString() === pageSize.toString())) return pageSizeOptions;
        return pageSizeOptions.concat([
            pageSize
        ]).sort((a, b)=>{
            const numberA = Number.isNaN(Number(a)) ? 0 : Number(a);
            const numberB = Number.isNaN(Number(b)) ? 0 : Number(b);
            return numberA - numberB;
        });
    };
    // ============== cls ==============
    const prefixCls = `${rootPrefixCls}-options`;
    // ============== render ==============
    if (!showSizeChanger && !quickGo) return null;
    let changeSelect = null;
    let goInput = null;
    let gotoButton = null;
    // >>>>> Size Changer
    if (showSizeChanger && sizeChangerRender) changeSelect = sizeChangerRender({
        disabled: disabled,
        size: pageSize,
        onSizeChange: (nextValue)=>{
            changeSize?.(Number(nextValue));
        },
        "aria-label": locale.page_size,
        className: `${prefixCls}-size-changer`,
        options: getPageSizeOptions().map((opt)=>({
                label: mergeBuildOptionText(opt),
                value: opt
            }))
    });
    // >>>>> Quick Go
    if (quickGo) {
        if (goButton) gotoButton = typeof goButton === "boolean" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("button", {
            type: "button",
            onClick: go,
            onKeyUp: go,
            disabled: disabled,
            className: `${prefixCls}-quick-jumper-button`
        }, locale.jump_to_confirm) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("span", {
            onClick: go,
            onKeyUp: go
        }, goButton);
        goInput = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
            className: `${prefixCls}-quick-jumper`
        }, locale.jump_to, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("input", {
            disabled: disabled,
            type: "text",
            value: goInputText,
            onChange: handleChange,
            onKeyUp: go,
            onBlur: handleBlur,
            "aria-label": locale.page
        }), locale.page, gotoButton);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("li", {
        className: prefixCls
    }, changeSelect, goInput);
};
var $4b2df549ee7bde27$export$2e2bcd8739ae039 = $4b2df549ee7bde27$var$Options;


/* eslint react/prop-types: 0 */ 

var $cQmXV = parcelRequire("cQmXV");
const $95d26955a25a9d37$var$Pager = (props)=>{
    const { rootPrefixCls: rootPrefixCls, page: page, active: active, className: className, style: style, showTitle: showTitle, onClick: onClick, onKeyPress: onKeyPress, itemRender: itemRender } = props;
    const prefixCls = `${rootPrefixCls}-item`;
    const cls = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-${page}`, {
        [`${prefixCls}-active`]: active,
        [`${prefixCls}-disabled`]: !page
    }, className);
    const handleClick = ()=>{
        onClick(page);
    };
    const handleKeyPress = (e)=>{
        onKeyPress(e, onClick, page);
    };
    const pager = itemRender(page, "page", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("a", {
        rel: "nofollow"
    }, page));
    return pager ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("li", {
        title: showTitle ? String(page) : null,
        className: cls,
        style: style,
        onClick: handleClick,
        onKeyDown: handleKeyPress,
        tabIndex: 0
    }, pager) : null;
};
var $95d26955a25a9d37$export$2e2bcd8739ae039 = $95d26955a25a9d37$var$Pager;


function $e7888fdfe5e784c3$var$_extends() {
    $e7888fdfe5e784c3$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e7888fdfe5e784c3$var$_extends.apply(this, arguments);
}
const $e7888fdfe5e784c3$var$defaultItemRender = (_, __, element)=>element;
function $e7888fdfe5e784c3$var$noop() {}
function $e7888fdfe5e784c3$var$isInteger(v) {
    const value = Number(v);
    return typeof value === "number" && !Number.isNaN(value) && isFinite(value) && Math.floor(value) === value;
}
function $e7888fdfe5e784c3$var$calculatePage(p, pageSize, total) {
    const _pageSize = typeof p === "undefined" ? pageSize : p;
    return Math.floor((total - 1) / _pageSize) + 1;
}
const $e7888fdfe5e784c3$var$Pagination = (props)=>{
    const { prefixCls: // cls
    prefixCls = "rc-pagination", selectPrefixCls: selectPrefixCls = "rc-select", className: className, classNames: paginationClassNames, styles: styles, // control
    current: currentProp, defaultCurrent: defaultCurrent = 1, total: total = 0, pageSize: pageSizeProp, defaultPageSize: defaultPageSize = 10, onChange: onChange = $e7888fdfe5e784c3$var$noop, hideOnSinglePage: // config
    hideOnSinglePage, align: align, showPrevNextJumpers: showPrevNextJumpers = true, showQuickJumper: showQuickJumper, showLessItems: showLessItems, showTitle: showTitle = true, onShowSizeChange: onShowSizeChange = $e7888fdfe5e784c3$var$noop, locale: locale = (0, $937660311fe3df6b$export$2e2bcd8739ae039), style: style, totalBoundaryShowSizeChanger: totalBoundaryShowSizeChanger = 50, disabled: disabled, simple: simple, showTotal: showTotal, showSizeChanger: showSizeChanger = total > totalBoundaryShowSizeChanger, sizeChangerRender: sizeChangerRender, pageSizeOptions: pageSizeOptions, itemRender: // render
    itemRender = $e7888fdfe5e784c3$var$defaultItemRender, jumpPrevIcon: jumpPrevIcon, jumpNextIcon: jumpNextIcon, prevIcon: prevIcon, nextIcon: nextIcon } = props;
    const paginationRef = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useRef(null);
    const [pageSize, setPageSize] = (0, $a51866d781137e08$export$2e2bcd8739ae039)(defaultPageSize, pageSizeProp);
    const [internalCurrent, setCurrent] = (0, $a51866d781137e08$export$2e2bcd8739ae039)(defaultCurrent, currentProp);
    const current = Math.max(1, Math.min(internalCurrent, $e7888fdfe5e784c3$var$calculatePage(undefined, pageSize, total)));
    const [internalInputVal, setInternalInputVal] = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useState(current);
    (0, $cQmXV.useEffect)(()=>{
        setInternalInputVal(current);
    }, [
        current
    ]);
    const hasOnChange = onChange !== $e7888fdfe5e784c3$var$noop;
    const hasCurrent = "current" in props;
    const jumpPrevPage = Math.max(1, current - (showLessItems ? 3 : 5));
    const jumpNextPage = Math.min($e7888fdfe5e784c3$var$calculatePage(undefined, pageSize, total), current + (showLessItems ? 3 : 5));
    function getItemIcon(icon, label) {
        let iconNode = icon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("button", {
            type: "button",
            "aria-label": label,
            className: `${prefixCls}-item-link`
        });
        if (typeof icon === "function") iconNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement(icon, props);
        return iconNode;
    }
    function getValidValue(e) {
        const inputValue = e.target.value;
        const allPages = $e7888fdfe5e784c3$var$calculatePage(undefined, pageSize, total);
        let value;
        if (inputValue === "") value = inputValue;
        else if (Number.isNaN(Number(inputValue))) value = internalInputVal;
        else if (inputValue >= allPages) value = allPages;
        else value = Number(inputValue);
        return value;
    }
    function isValid(page) {
        return $e7888fdfe5e784c3$var$isInteger(page) && page !== current && $e7888fdfe5e784c3$var$isInteger(total) && total > 0;
    }
    const shouldDisplayQuickJumper = total > pageSize ? showQuickJumper : false;
    /**
   * prevent "up arrow" key reseting cursor position within textbox
   * @see https://stackoverflow.com/a/1081114
   */ function handleKeyDown(event) {
        if (event.keyCode === (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).UP || event.keyCode === (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).DOWN) event.preventDefault();
    }
    function handleKeyUp(event) {
        const value = getValidValue(event);
        if (value !== internalInputVal) setInternalInputVal(value);
        switch(event.keyCode){
            case (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).ENTER:
                handleChange(value);
                break;
            case (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).UP:
                handleChange(value - 1);
                break;
            case (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).DOWN:
                handleChange(value + 1);
                break;
            default:
                break;
        }
    }
    function handleBlur(event) {
        handleChange(getValidValue(event));
    }
    function changePageSize(size) {
        const newCurrent = $e7888fdfe5e784c3$var$calculatePage(size, pageSize, total);
        const nextCurrent = current > newCurrent && newCurrent !== 0 ? newCurrent : current;
        setPageSize(size);
        setInternalInputVal(nextCurrent);
        onShowSizeChange?.(current, size);
        setCurrent(nextCurrent);
        onChange?.(nextCurrent, size);
    }
    function handleChange(page) {
        if (isValid(page) && !disabled) {
            const currentPage = $e7888fdfe5e784c3$var$calculatePage(undefined, pageSize, total);
            let newPage = page;
            if (page > currentPage) newPage = currentPage;
            else if (page < 1) newPage = 1;
            if (newPage !== internalInputVal) setInternalInputVal(newPage);
            setCurrent(newPage);
            onChange?.(newPage, pageSize);
            return newPage;
        }
        return current;
    }
    const hasPrev = current > 1;
    const hasNext = current < $e7888fdfe5e784c3$var$calculatePage(undefined, pageSize, total);
    function prevHandle() {
        if (hasPrev) handleChange(current - 1);
    }
    function nextHandle() {
        if (hasNext) handleChange(current + 1);
    }
    function jumpPrevHandle() {
        handleChange(jumpPrevPage);
    }
    function jumpNextHandle() {
        handleChange(jumpNextPage);
    }
    function runIfEnter(event, callback, ...restParams) {
        if (event.key === "Enter" || event.charCode === (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).ENTER || event.keyCode === (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).ENTER) callback(...restParams);
    }
    function runIfEnterPrev(event) {
        runIfEnter(event, prevHandle);
    }
    function runIfEnterNext(event) {
        runIfEnter(event, nextHandle);
    }
    function runIfEnterJumpPrev(event) {
        runIfEnter(event, jumpPrevHandle);
    }
    function runIfEnterJumpNext(event) {
        runIfEnter(event, jumpNextHandle);
    }
    function renderPrev(prevPage) {
        const prevButton = itemRender(prevPage, "prev", getItemIcon(prevIcon, "prev page"));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).isValidElement(prevButton) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).cloneElement(prevButton, {
            disabled: !hasPrev
        }) : prevButton;
    }
    function renderNext(nextPage) {
        const nextButton = itemRender(nextPage, "next", getItemIcon(nextIcon, "next page"));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).isValidElement(nextButton) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).cloneElement(nextButton, {
            disabled: !hasNext
        }) : nextButton;
    }
    function handleGoTO(event) {
        if (event.type === "click" || event.keyCode === (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).ENTER) handleChange(internalInputVal);
    }
    let jumpPrev = null;
    const dataOrAriaAttributeProps = (0, $4b5c733d1d7bb306$export$2e2bcd8739ae039)(props, {
        aria: true,
        data: true
    });
    const totalText = showTotal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("li", {
        className: `${prefixCls}-total-text`
    }, showTotal(total, [
        total === 0 ? 0 : (current - 1) * pageSize + 1,
        current * pageSize > total ? total : current * pageSize
    ]));
    let jumpNext = null;
    const allPages = $e7888fdfe5e784c3$var$calculatePage(undefined, pageSize, total);
    // ================== Render ==================
    // When hideOnSinglePage is true and there is only 1 page, hide the pager
    if (hideOnSinglePage && total <= pageSize) return null;
    const pagerList = [];
    const pagerProps = {
        rootPrefixCls: prefixCls,
        onClick: handleChange,
        onKeyPress: runIfEnter,
        showTitle: showTitle,
        itemRender: itemRender,
        page: -1,
        className: paginationClassNames?.item,
        style: styles?.item
    };
    const prevPage = current - 1 > 0 ? current - 1 : 0;
    const nextPage = current + 1 < allPages ? current + 1 : allPages;
    const goButton = showQuickJumper && showQuickJumper.goButton;
    // ================== Simple ==================
    // FIXME: ts type
    const isReadOnly = typeof simple === "object" ? simple.readOnly : !simple;
    let gotoButton = goButton;
    let simplePager = null;
    if (simple) {
        // ====== Simple quick jump ======
        if (goButton) {
            if (typeof goButton === "boolean") gotoButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("button", {
                type: "button",
                onClick: handleGoTO,
                onKeyUp: handleGoTO
            }, locale.jump_to_confirm);
            else gotoButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("span", {
                onClick: handleGoTO,
                onKeyUp: handleGoTO
            }, goButton);
            gotoButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("li", {
                title: showTitle ? `${locale.jump_to}${current}/${allPages}` : null,
                className: `${prefixCls}-simple-pager`
            }, gotoButton);
        }
        simplePager = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("li", {
            title: showTitle ? `${current}/${allPages}` : null,
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-simple-pager`, paginationClassNames?.item),
            style: styles?.item
        }, isReadOnly ? internalInputVal : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("input", {
            type: "text",
            "aria-label": locale.jump_to,
            value: internalInputVal,
            disabled: disabled,
            onKeyDown: handleKeyDown,
            onKeyUp: handleKeyUp,
            onChange: handleKeyUp,
            onBlur: handleBlur,
            size: 3
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("span", {
            className: `${prefixCls}-slash`
        }, "/"), allPages);
    }
    // ====================== Normal ======================
    const pageBufferSize = showLessItems ? 1 : 2;
    if (allPages <= 3 + pageBufferSize * 2) {
        if (!allPages) pagerList.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $95d26955a25a9d37$export$2e2bcd8739ae039), $e7888fdfe5e784c3$var$_extends({}, pagerProps, {
            key: "noPager",
            page: 1,
            className: `${prefixCls}-item-disabled`
        })));
        for(let i = 1; i <= allPages; i += 1)pagerList.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $95d26955a25a9d37$export$2e2bcd8739ae039), $e7888fdfe5e784c3$var$_extends({}, pagerProps, {
            key: i,
            page: i,
            active: current === i
        })));
    } else {
        const prevItemTitle = showLessItems ? locale.prev_3 : locale.prev_5;
        const nextItemTitle = showLessItems ? locale.next_3 : locale.next_5;
        const jumpPrevContent = itemRender(jumpPrevPage, "jump-prev", getItemIcon(jumpPrevIcon, "prev page"));
        const jumpNextContent = itemRender(jumpNextPage, "jump-next", getItemIcon(jumpNextIcon, "next page"));
        if (showPrevNextJumpers) {
            jumpPrev = jumpPrevContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("li", {
                title: showTitle ? prevItemTitle : null,
                key: "prev",
                onClick: jumpPrevHandle,
                tabIndex: 0,
                onKeyDown: runIfEnterJumpPrev,
                className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-jump-prev`, {
                    [`${prefixCls}-jump-prev-custom-icon`]: !!jumpPrevIcon
                })
            }, jumpPrevContent) : null;
            jumpNext = jumpNextContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("li", {
                title: showTitle ? nextItemTitle : null,
                key: "next",
                onClick: jumpNextHandle,
                tabIndex: 0,
                onKeyDown: runIfEnterJumpNext,
                className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-jump-next`, {
                    [`${prefixCls}-jump-next-custom-icon`]: !!jumpNextIcon
                })
            }, jumpNextContent) : null;
        }
        let left = Math.max(1, current - pageBufferSize);
        let right = Math.min(current + pageBufferSize, allPages);
        if (current - 1 <= pageBufferSize) right = 1 + pageBufferSize * 2;
        if (allPages - current <= pageBufferSize) left = allPages - pageBufferSize * 2;
        const hasJumpPrev = !!jumpPrev && current - 1 >= pageBufferSize * 2 && current !== 3;
        const hasJumpNext = !!jumpNext && allPages - current >= pageBufferSize * 2 && current !== allPages - 2;
        if (!showLessItems && hasJumpPrev && right !== allPages) left += 1;
        if (!showLessItems && hasJumpNext && left !== 1) right -= 1;
        for(let i = left; i <= right; i += 1)pagerList.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $95d26955a25a9d37$export$2e2bcd8739ae039), $e7888fdfe5e784c3$var$_extends({}, pagerProps, {
            key: i,
            page: i,
            active: current === i
        })));
        if (hasJumpPrev) {
            pagerList[0] = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).cloneElement(pagerList[0], {
                className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-item-after-jump-prev`, pagerList[0].props.className)
            });
            pagerList.unshift(jumpPrev);
        }
        if (hasJumpNext) {
            const lastOne = pagerList[pagerList.length - 1];
            pagerList[pagerList.length - 1] = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).cloneElement(lastOne, {
                className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-item-before-jump-next`, lastOne.props.className)
            });
            pagerList.push(jumpNext);
        }
        if (left !== 1) pagerList.unshift(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $95d26955a25a9d37$export$2e2bcd8739ae039), $e7888fdfe5e784c3$var$_extends({}, pagerProps, {
            key: 1,
            page: 1
        })));
        if (right !== allPages) pagerList.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $95d26955a25a9d37$export$2e2bcd8739ae039), $e7888fdfe5e784c3$var$_extends({}, pagerProps, {
            key: allPages,
            page: allPages
        })));
    }
    let prev = renderPrev(prevPage);
    if (prev) {
        const prevDisabled = !hasPrev || !allPages;
        prev = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("li", {
            title: showTitle ? locale.prev_page : null,
            onClick: prevHandle,
            tabIndex: prevDisabled ? null : 0,
            onKeyDown: runIfEnterPrev,
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-prev`, paginationClassNames?.item, {
                [`${prefixCls}-disabled`]: prevDisabled
            }),
            style: styles?.item,
            "aria-disabled": prevDisabled
        }, prev);
    }
    let next = renderNext(nextPage);
    if (next) {
        let nextDisabled, nextTabIndex;
        if (simple) {
            nextDisabled = !hasNext;
            nextTabIndex = hasPrev ? 0 : null;
        } else {
            nextDisabled = !hasNext || !allPages;
            nextTabIndex = nextDisabled ? null : 0;
        }
        next = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("li", {
            title: showTitle ? locale.next_page : null,
            onClick: nextHandle,
            tabIndex: nextTabIndex,
            onKeyDown: runIfEnterNext,
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-next`, paginationClassNames?.item, {
                [`${prefixCls}-disabled`]: nextDisabled
            }),
            style: styles?.item,
            "aria-disabled": nextDisabled
        }, next);
    }
    const cls = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, className, {
        [`${prefixCls}-start`]: align === "start",
        [`${prefixCls}-center`]: align === "center",
        [`${prefixCls}-end`]: align === "end",
        [`${prefixCls}-simple`]: simple,
        [`${prefixCls}-disabled`]: disabled
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("ul", $e7888fdfe5e784c3$var$_extends({
        className: cls,
        style: style,
        ref: paginationRef
    }, dataOrAriaAttributeProps), totalText, prev, simple ? simplePager : pagerList, next, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $4b2df549ee7bde27$export$2e2bcd8739ae039), {
        locale: locale,
        rootPrefixCls: prefixCls,
        disabled: disabled,
        selectPrefixCls: selectPrefixCls,
        changeSize: changePageSize,
        pageSize: pageSize,
        pageSizeOptions: pageSizeOptions,
        quickGo: shouldDisplayQuickJumper ? handleChange : null,
        goButton: gotoButton,
        showSizeChanger: showSizeChanger,
        sizeChangerRender: sizeChangerRender
    }));
};
var $e7888fdfe5e784c3$export$2e2bcd8739ae039 = $e7888fdfe5e784c3$var$Pagination;














var $cQmXV = parcelRequire("cQmXV");


var $cQmXV = parcelRequire("cQmXV");



var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");
const $5bbe7a07702f6383$export$9ea6397a890aa3e5 = (prefixCls, displayValues, allowClear, clearIcon, disabled = false, mergedSearchValue, mode)=>{
    // Convert boolean to object first
    const allowClearConfig = (0, $cQmXV.useMemo)(()=>{
        if (typeof allowClear === "boolean") return {
            allowClear: allowClear
        };
        if (allowClear && typeof allowClear === "object") return allowClear;
        return {
            allowClear: false
        };
    }, [
        allowClear
    ]);
    return (0, $cQmXV.useMemo)(()=>{
        const mergedAllowClear = !disabled && allowClearConfig.allowClear !== false && (displayValues.length || mergedSearchValue) && !(mode === "combobox" && mergedSearchValue === "");
        return {
            allowClear: mergedAllowClear,
            clearIcon: mergedAllowClear ? allowClearConfig.clearIcon || clearIcon || "\xd7" : null,
            label: mergedAllowClear ? allowClearConfig.label ?? "Clear" : ""
        };
    }, [
        allowClearConfig,
        clearIcon,
        disabled,
        displayValues.length,
        mergedSearchValue,
        mode
    ]);
};


/**
 * BaseSelect provide some parsed data into context.
 * You can use this hooks to get them.
 */ 
var $cQmXV = parcelRequire("cQmXV");
const $55a8e8da9f434170$export$8234047c0aea33cf = /*#__PURE__*/ $cQmXV.createContext(null);
function $55a8e8da9f434170$export$2e2bcd8739ae039() {
    return $cQmXV.useContext($55a8e8da9f434170$export$8234047c0aea33cf);
}



var $cQmXV = parcelRequire("cQmXV");
function $c747d4db0f166ed1$export$2e2bcd8739ae039(duration = 250) {
    const lockRef = $cQmXV.useRef(null);
    const timeoutRef = $cQmXV.useRef(null);
    // Clean up
    $cQmXV.useEffect(()=>()=>{
            window.clearTimeout(timeoutRef.current);
        }, []);
    function doLock(locked) {
        if (locked || lockRef.current === null) lockRef.current = locked;
        window.clearTimeout(timeoutRef.current);
        timeoutRef.current = window.setTimeout(()=>{
            lockRef.current = null;
        }, duration);
    }
    return [
        ()=>lockRef.current,
        doLock
    ];
}



var $cQmXV = parcelRequire("cQmXV");

function $244314a99075d747$export$4ac6a1c95deee4c5(elements, target) {
    return elements.filter((element)=>element).some((element)=>element.contains(target) || element === target);
}
function $244314a99075d747$export$2e2bcd8739ae039(elements, open, triggerOpen, customizedTrigger) {
    const onGlobalMouseDown = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((event)=>{
        // If trigger is customized, Trigger will take control of popupVisible
        if (customizedTrigger) return;
        let target = event.target;
        if (target.shadowRoot && event.composed) target = event.composedPath()[0] || target;
        if (event._ori_target) target = event._ori_target;
        if (open && // Marked by SelectInput mouseDown event
        !$244314a99075d747$export$4ac6a1c95deee4c5(elements(), target)) // Should trigger close
        triggerOpen(false);
    });
    $cQmXV.useEffect(()=>{
        window.addEventListener("mousedown", onGlobalMouseDown);
        return ()=>window.removeEventListener("mousedown", onGlobalMouseDown);
    }, [
        onGlobalMouseDown
    ]);
}





var $cQmXV = parcelRequire("cQmXV");
function $75385ddd88522f51$var$_extends() {
    $75385ddd88522f51$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $75385ddd88522f51$var$_extends.apply(this, arguments);
}
const $75385ddd88522f51$var$getBuiltInPlacements = (popupMatchSelectWidth)=>{
    // Enable horizontal overflow auto-adjustment when a custom dropdown width is provided
    const adjustX = popupMatchSelectWidth === true ? 0 : 1;
    return {
        bottomLeft: {
            points: [
                "tl",
                "bl"
            ],
            offset: [
                0,
                4
            ],
            overflow: {
                adjustX: adjustX,
                adjustY: 1
            },
            htmlRegion: "scroll"
        },
        bottomRight: {
            points: [
                "tr",
                "br"
            ],
            offset: [
                0,
                4
            ],
            overflow: {
                adjustX: adjustX,
                adjustY: 1
            },
            htmlRegion: "scroll"
        },
        topLeft: {
            points: [
                "bl",
                "tl"
            ],
            offset: [
                0,
                -4
            ],
            overflow: {
                adjustX: adjustX,
                adjustY: 1
            },
            htmlRegion: "scroll"
        },
        topRight: {
            points: [
                "br",
                "tr"
            ],
            offset: [
                0,
                -4
            ],
            overflow: {
                adjustX: adjustX,
                adjustY: 1
            },
            htmlRegion: "scroll"
        }
    };
};
const $75385ddd88522f51$var$SelectTrigger = (props, ref)=>{
    const { prefixCls: prefixCls, disabled: disabled, visible: visible, children: children, popupElement: popupElement, animation: animation, transitionName: transitionName, popupStyle: popupStyle, popupClassName: popupClassName, direction: direction = "ltr", placement: placement, builtinPlacements: builtinPlacements, popupMatchSelectWidth: popupMatchSelectWidth, popupRender: popupRender, popupAlign: popupAlign, getPopupContainer: getPopupContainer, empty: empty, onPopupVisibleChange: onPopupVisibleChange, onPopupMouseEnter: onPopupMouseEnter, onPopupMouseDown: onPopupMouseDown, onPopupBlur: onPopupBlur, ...restProps } = props;
    // We still use `dropdown` className to keep compatibility
    // This is used for:
    // 1. Styles
    // 2. Animation
    // 3. Theme customization
    // Please do not modify this since it's a breaking change
    const popupPrefixCls = `${prefixCls}-dropdown`;
    let popupNode = popupElement;
    if (popupRender) popupNode = popupRender(popupElement);
    const mergedBuiltinPlacements = $cQmXV.useMemo(()=>builtinPlacements || $75385ddd88522f51$var$getBuiltInPlacements(popupMatchSelectWidth), [
        builtinPlacements,
        popupMatchSelectWidth
    ]);
    // ===================== Motion ======================
    const mergedTransitionName = animation ? `${popupPrefixCls}-${animation}` : transitionName;
    // =================== Popup Width ===================
    const isNumberPopupWidth = typeof popupMatchSelectWidth === "number";
    const stretch = $cQmXV.useMemo(()=>{
        return popupMatchSelectWidth === false || isNumberPopupWidth ? "minWidth" : "width";
    }, [
        popupMatchSelectWidth,
        isNumberPopupWidth
    ]);
    let mergedPopupStyle = popupStyle;
    if (isNumberPopupWidth) mergedPopupStyle = {
        ...popupStyle,
        width: popupMatchSelectWidth
    };
    // ======================= Ref =======================
    const triggerPopupRef = $cQmXV.useRef(null);
    $cQmXV.useImperativeHandle(ref, ()=>({
            getPopupElement: ()=>triggerPopupRef.current?.popupElement
        }));
    return /*#__PURE__*/ $cQmXV.createElement((0, $c77226a956f109d7$export$2e2bcd8739ae039), $75385ddd88522f51$var$_extends({}, restProps, {
        showAction: onPopupVisibleChange ? [
            "click"
        ] : [],
        hideAction: onPopupVisibleChange ? [
            "click"
        ] : [],
        popupPlacement: placement || (direction === "rtl" ? "bottomRight" : "bottomLeft"),
        builtinPlacements: mergedBuiltinPlacements,
        prefixCls: popupPrefixCls,
        popupMotion: {
            motionName: mergedTransitionName
        },
        popup: /*#__PURE__*/ $cQmXV.createElement("div", {
            onMouseEnter: onPopupMouseEnter,
            onMouseDown: onPopupMouseDown,
            onBlur: onPopupBlur
        }, popupNode),
        ref: triggerPopupRef,
        stretch: stretch,
        popupAlign: popupAlign,
        popupVisible: visible,
        getPopupContainer: getPopupContainer,
        popupClassName: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(popupClassName, {
            [`${popupPrefixCls}-empty`]: empty
        }),
        popupStyle: mergedPopupStyle,
        onPopupVisibleChange: onPopupVisibleChange
    }), children);
};
const $75385ddd88522f51$var$RefSelectTrigger = /*#__PURE__*/ $cQmXV.forwardRef($75385ddd88522f51$var$SelectTrigger);
var $75385ddd88522f51$export$2e2bcd8739ae039 = $75385ddd88522f51$var$RefSelectTrigger;



function $46a03b35f5ed52b3$var$getKey(data, index) {
    const { key: key } = data;
    let value;
    if ("value" in data) ({ value: value } = data);
    if (key !== null && key !== undefined) return key;
    if (value !== undefined) return value;
    return `rc-index-key-${index}`;
}
function $46a03b35f5ed52b3$export$be48fd776273e509(value) {
    return typeof value !== "undefined" && !Number.isNaN(value);
}
function $46a03b35f5ed52b3$export$6c519d302dced239(fieldNames, childrenAsData) {
    const { label: label, value: value, options: options, groupLabel: groupLabel } = fieldNames || {};
    const mergedLabel = label || (childrenAsData ? "children" : "label");
    return {
        label: mergedLabel,
        value: value || "value",
        options: options || "options",
        groupLabel: groupLabel || mergedLabel
    };
}
function $46a03b35f5ed52b3$export$7baa7c13b358b002(options, { fieldNames: fieldNames, childrenAsData: childrenAsData } = {}) {
    const flattenList = [];
    const { label: fieldLabel, value: fieldValue, options: fieldOptions, groupLabel: groupLabel } = $46a03b35f5ed52b3$export$6c519d302dced239(fieldNames, false);
    function dig(list, isGroupOption) {
        if (!Array.isArray(list)) return;
        list.forEach((data)=>{
            if (isGroupOption || !(fieldOptions in data)) {
                const value = data[fieldValue];
                // Option
                flattenList.push({
                    key: $46a03b35f5ed52b3$var$getKey(data, flattenList.length),
                    groupOption: isGroupOption,
                    data: data,
                    label: data[fieldLabel],
                    value: value
                });
            } else {
                let grpLabel = data[groupLabel];
                if (grpLabel === undefined && childrenAsData) grpLabel = data.label;
                // Option Group
                flattenList.push({
                    key: $46a03b35f5ed52b3$var$getKey(data, flattenList.length),
                    group: true,
                    data: data,
                    label: grpLabel
                });
                dig(data[fieldOptions], true);
            }
        });
    }
    dig(options, false);
    return flattenList;
}
function $46a03b35f5ed52b3$export$d0b21b213c8c013c(option) {
    const newOption = {
        ...option
    };
    if (!("props" in newOption)) Object.defineProperty(newOption, "props", {
        get () {
            (0, $26d7cf6379fe7659$export$2e2bcd8739ae039)(false, "Return type is option instead of Option instance. Please read value directly instead of reading from `props`.");
            return newOption;
        }
    });
    return newOption;
}
const $46a03b35f5ed52b3$export$a09ca2a89e052b14 = (text, tokens, end)=>{
    if (!tokens || !tokens.length) return null;
    let match = false;
    const separate = (str, [token, ...restTokens])=>{
        if (!token) return [
            str
        ];
        const list = str.split(token);
        match = match || list.length > 1;
        return list.reduce((prevList, unitStr)=>[
                ...prevList,
                ...separate(unitStr, restTokens)
            ], []).filter(Boolean);
    };
    const list = separate(text, tokens);
    if (match) return typeof end !== "undefined" ? list.slice(0, end) : list;
    else return null;
};



var $cQmXV = parcelRequire("cQmXV");
function $c01ee40425dfc000$export$2e2bcd8739ae039(props) {
    const { visible: visible, values: values } = props;
    if (!visible) return null;
    // Only cut part of values since it's a screen reader
    const MAX_COUNT = 50;
    return /*#__PURE__*/ $cQmXV.createElement("span", {
        "aria-live": "polite",
        style: {
            width: 0,
            height: 0,
            position: "absolute",
            overflow: "hidden",
            opacity: 0
        }
    }, `${values.slice(0, MAX_COUNT).map(({ label: label, value: value })=>[
            "number",
            "string"
        ].includes(typeof label) ? label : value).join(", ")}`, values.length > MAX_COUNT ? ", ..." : null);
}




var $cQmXV = parcelRequire("cQmXV");
const $3269bfbea626bbf3$var$internalMacroTask = (fn)=>{
    const channel = new MessageChannel();
    channel.port1.onmessage = fn;
    channel.port2.postMessage(null);
};
const $3269bfbea626bbf3$export$f1309b2412c6fa89 = (fn, times = 1)=>{
    if (times <= 0) {
        fn();
        return;
    }
    $3269bfbea626bbf3$var$internalMacroTask(()=>{
        $3269bfbea626bbf3$export$f1309b2412c6fa89(fn, times - 1);
    });
};
function $3269bfbea626bbf3$export$2e2bcd8739ae039(defaultOpen, propOpen, onOpen, postOpen) {
    // SSR not support Portal which means we need delay `open` for the first time render
    const [rendered, setRendered] = (0, $cQmXV.useState)(false);
    (0, $cQmXV.useEffect)(()=>{
        setRendered(true);
    }, []);
    const [stateOpen, internalSetOpen] = (0, $a51866d781137e08$export$2e2bcd8739ae039)(defaultOpen, propOpen);
    // Lock for options update
    const [lock, setLock] = (0, $cQmXV.useState)(false);
    // During SSR, always return false for open state
    const ssrSafeOpen = rendered ? stateOpen : false;
    const mergedOpen = postOpen(ssrSafeOpen);
    const taskIdRef = (0, $cQmXV.useRef)(0);
    const triggerEvent = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((nextOpen)=>{
        if (onOpen && mergedOpen !== nextOpen) onOpen(nextOpen);
        internalSetOpen(nextOpen);
    });
    const toggleOpen = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((nextOpen, config = {})=>{
        const { cancelFun: cancelFun } = config;
        taskIdRef.current += 1;
        const id = taskIdRef.current;
        const nextOpenVal = typeof nextOpen === "boolean" ? nextOpen : !mergedOpen;
        setLock(!nextOpenVal);
        function triggerUpdate() {
            if (// Always check if id is match
            id === taskIdRef.current && // Check if need to cancel
            !cancelFun?.()) {
                triggerEvent(nextOpenVal);
                setLock(false);
            }
        }
        // Weak update can be ignored
        if (nextOpenVal) triggerUpdate();
        else $3269bfbea626bbf3$export$f1309b2412c6fa89(()=>{
            triggerUpdate();
        });
    });
    return [
        ssrSafeOpen,
        mergedOpen,
        toggleOpen,
        lock
    ];
}



var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");
function $2744b0aa61a6ad2e$export$2e2bcd8739ae039(props) {
    const { children: children, ...restProps } = props;
    if (!children) return null;
    return /*#__PURE__*/ $cQmXV.createElement("div", restProps, children);
}



var $cQmXV = parcelRequire("cQmXV");


var $cQmXV = parcelRequire("cQmXV");


var $cQmXV = parcelRequire("cQmXV");


var $cQmXV = parcelRequire("cQmXV");
const $e6a8f1906529bc20$var$SelectInputContext = /*#__PURE__*/ $cQmXV.createContext(null);
function $e6a8f1906529bc20$export$7785dec5a5aec756() {
    return $cQmXV.useContext($e6a8f1906529bc20$var$SelectInputContext);
}
var $e6a8f1906529bc20$export$2e2bcd8739ae039 = $e6a8f1906529bc20$var$SelectInputContext;




const $ab6afd782bab2b6b$var$Input = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { onChange: onChange, onKeyDown: onKeyDown, onBlur: onBlur, style: style, syncWidth: syncWidth, value: value, className: className, autoComplete: autoComplete, ...restProps } = props;
    const { prefixCls: prefixCls, mode: mode, onSearch: onSearch, onSearchSubmit: onSearchSubmit, onInputBlur: onInputBlur, autoFocus: autoFocus, tokenWithEnter: tokenWithEnter, placeholder: placeholder, components: { input: InputComponent = "input" } } = (0, $e6a8f1906529bc20$export$7785dec5a5aec756)();
    const { id: id, classNames: classNames, styles: styles, open: open, activeDescendantId: activeDescendantId, role: role, disabled: disabled } = (0, $55a8e8da9f434170$export$2e2bcd8739ae039)() || {};
    const inputCls = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-input`, classNames?.input, className);
    // Used to handle input method composition status
    const compositionStatusRef = $cQmXV.useRef(false);
    // Used to handle paste content, similar to original Selector implementation
    const pastedTextRef = $cQmXV.useRef(null);
    // ============================== Refs ==============================
    const inputRef = $cQmXV.useRef(null);
    $cQmXV.useImperativeHandle(ref, ()=>inputRef.current);
    // ============================== Data ==============================
    // Handle input changes
    const handleChange = (event)=>{
        let { value: nextVal } = event.target;
        // Handle pasted text with tokenWithEnter, similar to original Selector implementation
        if (tokenWithEnter && pastedTextRef.current && /[\r\n]/.test(pastedTextRef.current)) {
            // CRLF will be treated as a single space for input element
            const replacedText = pastedTextRef.current.replace(/[\r\n]+$/, "").replace(/\r\n/g, " ").replace(/[\r\n]/g, " ");
            nextVal = nextVal.replace(replacedText, pastedTextRef.current);
        }
        // Reset pasted text reference
        pastedTextRef.current = null;
        // Call onSearch callback
        if (onSearch) onSearch(nextVal, true, compositionStatusRef.current);
        // Call original onChange callback
        onChange?.(event);
    };
    // ============================ Keyboard ============================
    // Handle keyboard events
    const handleKeyDown = (event)=>{
        const { key: key } = event;
        const { value: nextVal } = event.currentTarget;
        // Handle Enter key submission - referencing Selector implementation
        if (key === "Enter" && mode === "tags" && !open && !compositionStatusRef.current && onSearchSubmit) onSearchSubmit(nextVal);
        // Call original onKeyDown callback
        onKeyDown?.(event);
    };
    // Handle blur events
    const handleBlur = (event)=>{
        // Call onInputBlur callback
        onInputBlur?.();
        // Call original onBlur callback
        onBlur?.(event);
    };
    // Handle input method composition start
    const handleCompositionStart = ()=>{
        compositionStatusRef.current = true;
    };
    // Handle input method composition end
    const handleCompositionEnd = (event)=>{
        compositionStatusRef.current = false;
        // Trigger search when input method composition ends, similar to original Selector
        if (mode !== "combobox") {
            const { value: nextVal } = event.currentTarget;
            onSearch?.(nextVal, true, false);
        }
    };
    // Handle paste events to track pasted content
    const handlePaste = (event)=>{
        const { clipboardData: clipboardData } = event;
        const pastedValue = clipboardData?.getData("text");
        pastedTextRef.current = pastedValue || "";
    };
    // ============================= Width ==============================
    const [widthCssVar, setWidthCssVar] = $cQmXV.useState(undefined);
    // When syncWidth is enabled, adjust input width based on content
    (0, $7673d874dab69d07$export$2e2bcd8739ae039)(()=>{
        const input = inputRef.current;
        if (syncWidth && input) {
            input.style.width = "0px";
            const scrollWidth = input.scrollWidth;
            setWidthCssVar(scrollWidth);
            // Reset input style
            input.style.width = "";
        }
    }, [
        syncWidth,
        value
    ]);
    // ============================= Render =============================
    // Extract shared input props
    const sharedInputProps = {
        id: id,
        type: "text",
        ...restProps,
        ref: inputRef,
        style: {
            ...styles?.input,
            ...style,
            "--select-input-width": widthCssVar
        },
        autoFocus: autoFocus,
        autoComplete: autoComplete || "new-password",
        className: inputCls,
        disabled: disabled,
        value: value || "",
        onChange: handleChange,
        onKeyDown: handleKeyDown,
        onBlur: handleBlur,
        onPaste: handlePaste,
        onCompositionStart: handleCompositionStart,
        onCompositionEnd: handleCompositionEnd,
        // Accessibility attributes
        role: role || "combobox",
        "aria-expanded": open || false,
        "aria-haspopup": "listbox",
        "aria-owns": open ? `${id}_list` : undefined,
        "aria-autocomplete": "list",
        "aria-controls": open ? `${id}_list` : undefined,
        "aria-activedescendant": open ? activeDescendantId : undefined
    };
    // Handle different InputComponent types
    if (/*#__PURE__*/ $cQmXV.isValidElement(InputComponent)) {
        // If InputComponent is a ReactElement, use cloneElement with merged props
        const existingProps = InputComponent.props || {};
        // Start with shared props as base
        const mergedProps = {
            placeholder: props.placeholder || placeholder,
            ...sharedInputProps,
            ...existingProps
        };
        // Batch update function calls
        Object.keys(existingProps).forEach((key)=>{
            const existingValue = existingProps[key];
            if (typeof existingValue === "function") // Merge event handlers
            mergedProps[key] = (...args)=>{
                existingValue(...args);
                sharedInputProps[key]?.(...args);
            };
        });
        // Update ref
        mergedProps.ref = (0, $10341b937b26f69d$export$ab452c34e8e05029)(InputComponent.ref, sharedInputProps.ref);
        return /*#__PURE__*/ $cQmXV.cloneElement(InputComponent, mergedProps);
    }
    // If InputComponent is a component type, render normally
    const Component = InputComponent;
    return /*#__PURE__*/ $cQmXV.createElement(Component, sharedInputProps);
});
var $ab6afd782bab2b6b$export$2e2bcd8739ae039 = $ab6afd782bab2b6b$var$Input;





var $cQmXV = parcelRequire("cQmXV");



function $93a29812cbff4c28$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, placeholder: placeholder, displayValues: displayValues } = (0, $e6a8f1906529bc20$export$7785dec5a5aec756)();
    const { classNames: classNames, styles: styles } = (0, $55a8e8da9f434170$export$2e2bcd8739ae039)();
    const { show: show = true } = props;
    if (displayValues.length) return null;
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-placeholder`, classNames?.placeholder),
        style: {
            ...show ? {} : {
                visibility: "hidden"
            },
            ...styles?.placeholder
        }
    }, placeholder);
}



var $cQmXV = parcelRequire("cQmXV");
// Use any here since we do not get the type during compilation
/**
 * SelectContext is only used for Select. BaseSelect should not consume this context.
 */ const $8b26feb71ab0689b$var$SelectContext = /*#__PURE__*/ $cQmXV.createContext(null);
var $8b26feb71ab0689b$export$2e2bcd8739ae039 = $8b26feb71ab0689b$var$SelectContext;


function $27094fd2b2012af1$export$45b10814cc054894(value) {
    if (Array.isArray(value)) return value;
    return value !== undefined ? [
        value
    ] : [];
}
const $27094fd2b2012af1$export$7383f122bf48ec30 = typeof window !== "undefined" && window.document && window.document.documentElement;
const $27094fd2b2012af1$export$df7146797a248522 = $27094fd2b2012af1$export$7383f122bf48ec30;
function $27094fd2b2012af1$export$96bdbc84526f3739(value) {
    return value !== undefined && value !== null;
}
function $27094fd2b2012af1$export$9d186c3672bb89c6(value) {
    return !value && value !== 0;
}
function $27094fd2b2012af1$var$isTitleType(title) {
    return [
        "string",
        "number"
    ].includes(typeof title);
}
function $27094fd2b2012af1$export$70d1bf7729efff40(item) {
    let title = undefined;
    if (item) {
        if ($27094fd2b2012af1$var$isTitleType(item.title)) title = item.title.toString();
        else if ($27094fd2b2012af1$var$isTitleType(item.label)) title = item.label.toString();
    }
    return title;
}


function $1c60b676808bd25d$var$_extends() {
    $1c60b676808bd25d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1c60b676808bd25d$var$_extends.apply(this, arguments);
}
const $1c60b676808bd25d$var$SingleContent = /*#__PURE__*/ $cQmXV.forwardRef(({ inputProps: inputProps }, ref)=>{
    const { prefixCls: prefixCls, searchValue: searchValue, activeValue: activeValue, displayValues: displayValues, maxLength: maxLength, mode: mode, components: components } = (0, $e6a8f1906529bc20$export$7785dec5a5aec756)();
    const { triggerOpen: triggerOpen, title: rootTitle, showSearch: showSearch, classNames: classNames, styles: styles } = (0, $55a8e8da9f434170$export$2e2bcd8739ae039)();
    const selectContext = $cQmXV.useContext((0, $8b26feb71ab0689b$export$2e2bcd8739ae039));
    const [inputChanged, setInputChanged] = $cQmXV.useState(false);
    const combobox = mode === "combobox";
    const displayValue = displayValues[0];
    // Implement the same logic as the old SingleSelector
    const mergedSearchValue = $cQmXV.useMemo(()=>{
        if (combobox && activeValue && !inputChanged && triggerOpen) return activeValue;
        return showSearch ? searchValue : "";
    }, [
        combobox,
        activeValue,
        inputChanged,
        triggerOpen,
        searchValue,
        showSearch
    ]);
    const [optionClassName, optionStyle, optionTitle, hasOptionStyle] = $cQmXV.useMemo(()=>{
        let className;
        let style;
        let titleValue;
        if (displayValue && selectContext?.flattenOptions) {
            const option = selectContext.flattenOptions.find((opt)=>opt.value === displayValue.value);
            if (option?.data) {
                className = option.data.className;
                style = option.data.style;
                titleValue = (0, $27094fd2b2012af1$export$70d1bf7729efff40)(option.data);
            }
        }
        if (displayValue && !titleValue) titleValue = (0, $27094fd2b2012af1$export$70d1bf7729efff40)(displayValue);
        if (rootTitle !== undefined) titleValue = rootTitle;
        const nextHasStyle = !!className || !!style;
        return [
            className,
            style,
            titleValue,
            nextHasStyle
        ];
    }, [
        displayValue,
        selectContext?.flattenOptions,
        rootTitle
    ]);
    $cQmXV.useEffect(()=>{
        if (combobox) setInputChanged(false);
    }, [
        combobox,
        activeValue
    ]);
    // ========================== Render ==========================
    const showHasValueCls = displayValue && displayValue.label !== null && displayValue.label !== undefined && String(displayValue.label).trim() !== "";
    // Render value
    // Only render value when not using custom input in combobox mode
    const shouldRenderValue = !(combobox && components?.input);
    const renderValue = shouldRenderValue ? displayValue ? hasOptionStyle ? /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-content-value`, optionClassName),
        style: {
            ...mergedSearchValue ? {
                visibility: "hidden"
            } : {},
            ...optionStyle
        },
        title: optionTitle
    }, displayValue.label) : displayValue.label : /*#__PURE__*/ $cQmXV.createElement((0, $93a29812cbff4c28$export$2e2bcd8739ae039), {
        show: !mergedSearchValue
    }) : null;
    // Render
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-content`, showHasValueCls && `${prefixCls}-content-has-value`, mergedSearchValue && `${prefixCls}-content-has-search-value`, hasOptionStyle && `${prefixCls}-content-has-option-style`, classNames?.content),
        style: styles?.content,
        title: hasOptionStyle ? undefined : optionTitle
    }, renderValue, /*#__PURE__*/ $cQmXV.createElement((0, $ab6afd782bab2b6b$export$2e2bcd8739ae039), $1c60b676808bd25d$var$_extends({
        ref: ref
    }, inputProps, {
        value: mergedSearchValue,
        maxLength: mode === "combobox" ? maxLength : undefined,
        onChange: (e)=>{
            setInputChanged(true);
            inputProps.onChange?.(e);
        }
    })));
});
var $1c60b676808bd25d$export$2e2bcd8739ae039 = $1c60b676808bd25d$var$SingleContent;



var $cQmXV = parcelRequire("cQmXV");





var $cQmXV = parcelRequire("cQmXV");

/**
 * Small wrapper for Select icons (clear/arrow/etc.).
 * Prevents default mousedown to avoid blurring or caret moves, and
 * renders a custom icon or a fallback icon span.
 *
 * DOM structure:
 * <span className={className} ...>
 *   { icon || <span className={`${className}-icon`}>{children}</span> }
 * </span>
 */ const $a8c8b33f809dd1e1$var$TransBtn = (props)=>{
    const { className: className, style: style, customizeIcon: customizeIcon, customizeIconProps: customizeIconProps, children: children, onMouseDown: onMouseDown, onClick: onClick } = props;
    const icon = typeof customizeIcon === "function" ? customizeIcon(customizeIconProps) : customizeIcon;
    return /*#__PURE__*/ $cQmXV.createElement("span", {
        className: className,
        onMouseDown: (event)=>{
            event.preventDefault();
            onMouseDown?.(event);
        },
        style: {
            userSelect: "none",
            WebkitUserSelect: "none",
            ...style
        },
        unselectable: "on",
        onClick: onClick,
        "aria-hidden": true
    }, icon !== undefined ? icon : /*#__PURE__*/ $cQmXV.createElement("span", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(className.split(/\s+/).map((cls)=>`${cls}-icon`))
    }, children));
};
var $a8c8b33f809dd1e1$export$2e2bcd8739ae039 = $a8c8b33f809dd1e1$var$TransBtn;





function $8206f6dd938cb15e$var$_extends() {
    $8206f6dd938cb15e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8206f6dd938cb15e$var$_extends.apply(this, arguments);
}
function $8206f6dd938cb15e$var$itemKey(value) {
    return value.key ?? value.value;
}
const $8206f6dd938cb15e$var$onPreventMouseDown = (event)=>{
    event.preventDefault();
    event.stopPropagation();
};
var $8206f6dd938cb15e$export$2e2bcd8739ae039 = /*#__PURE__*/ $cQmXV.forwardRef(function MultipleContent({ inputProps: inputProps }, ref) {
    const { prefixCls: prefixCls, displayValues: displayValues, searchValue: searchValue, mode: mode, onSelectorRemove: onSelectorRemove, removeIcon: removeIconFromContext } = (0, $e6a8f1906529bc20$export$7785dec5a5aec756)();
    const { disabled: disabled, showSearch: showSearch, triggerOpen: triggerOpen, rawOpen: rawOpen, toggleOpen: toggleOpen, autoClearSearchValue: autoClearSearchValue, tagRender: tagRenderFromContext, maxTagPlaceholder: maxTagPlaceholderFromContext, maxTagTextLength: maxTagTextLength, maxTagCount: maxTagCount, classNames: classNames, styles: styles } = (0, $55a8e8da9f434170$export$2e2bcd8739ae039)();
    const selectionItemPrefixCls = `${prefixCls}-selection-item`;
    // ===================== Search ======================
    // Apply autoClearSearchValue logic: when dropdown is closed and autoClearSearchValue is not false (default true), clear search value
    // Use rawOpen to avoid clearing search when emptyListContent blocks open
    let computedSearchValue = searchValue;
    if (!rawOpen && mode === "multiple" && autoClearSearchValue !== false) computedSearchValue = "";
    const inputValue = showSearch ? computedSearchValue || "" : "";
    const inputEditable = showSearch && !disabled;
    // Props from context with safe defaults
    const removeIcon = removeIconFromContext ?? "\xd7";
    const maxTagPlaceholder = maxTagPlaceholderFromContext ?? ((omittedValues)=>`+ ${omittedValues.length} ...`);
    const tagRender = tagRenderFromContext;
    const onToggleOpen = (newOpen)=>{
        toggleOpen(newOpen);
    };
    const onRemove = (value)=>{
        onSelectorRemove?.(value);
    };
    // ======================== Item ========================
    // >>> Render Selector Node. Includes Item & Rest
    const defaultRenderSelector = (item, content, itemDisabled, closable, onClose)=>/*#__PURE__*/ $cQmXV.createElement("span", {
            title: (0, $27094fd2b2012af1$export$70d1bf7729efff40)(item),
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(selectionItemPrefixCls, {
                [`${selectionItemPrefixCls}-disabled`]: itemDisabled
            }, classNames?.item),
            style: styles?.item
        }, /*#__PURE__*/ $cQmXV.createElement("span", {
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${selectionItemPrefixCls}-content`, classNames?.itemContent),
            style: styles?.itemContent
        }, content), closable && /*#__PURE__*/ $cQmXV.createElement((0, $a8c8b33f809dd1e1$export$2e2bcd8739ae039), {
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${selectionItemPrefixCls}-remove`, classNames?.itemRemove),
            style: styles?.itemRemove,
            onMouseDown: $8206f6dd938cb15e$var$onPreventMouseDown,
            onClick: onClose,
            customizeIcon: removeIcon
        }, "\xd7"));
    const customizeRenderSelector = (value, content, itemDisabled, closable, onClose, isMaxTag, info)=>{
        const onMouseDown = (e)=>{
            $8206f6dd938cb15e$var$onPreventMouseDown(e);
            onToggleOpen(!triggerOpen);
        };
        return /*#__PURE__*/ $cQmXV.createElement("span", {
            onMouseDown: onMouseDown
        }, tagRender({
            label: content,
            value: value,
            index: info?.index,
            disabled: itemDisabled,
            closable: closable,
            onClose: onClose,
            isMaxTag: !!isMaxTag
        }));
    };
    // ====================== Overflow ======================
    const renderItem = (valueItem, info)=>{
        const { disabled: itemDisabled, label: label, value: value } = valueItem;
        const closable = !disabled && !itemDisabled;
        let displayLabel = label;
        if (typeof maxTagTextLength === "number") {
            if (typeof label === "string" || typeof label === "number") {
                const strLabel = String(displayLabel);
                if (strLabel.length > maxTagTextLength) displayLabel = `${strLabel.slice(0, maxTagTextLength)}...`;
            }
        }
        const onClose = (event)=>{
            if (event) event.stopPropagation();
            onRemove(valueItem);
        };
        return typeof tagRender === "function" ? customizeRenderSelector(value, displayLabel, itemDisabled, closable, onClose, undefined, info) : defaultRenderSelector(valueItem, displayLabel, itemDisabled, closable, onClose);
    };
    const renderRest = (omittedValues)=>{
        // https://github.com/ant-design/ant-design/issues/48930
        if (!displayValues.length) return null;
        const content = typeof maxTagPlaceholder === "function" ? maxTagPlaceholder(omittedValues) : maxTagPlaceholder;
        return typeof tagRender === "function" ? customizeRenderSelector(undefined, content, false, false, undefined, true) : defaultRenderSelector({
            title: content
        }, content, false);
    };
    // ======================= Render =======================
    return /*#__PURE__*/ $cQmXV.createElement((0, $788a6a69bf396d02$export$2e2bcd8739ae039), {
        prefixCls: `${prefixCls}-content`,
        className: classNames?.content,
        style: styles?.content,
        prefix: !displayValues.length && !inputValue && /*#__PURE__*/ $cQmXV.createElement((0, $93a29812cbff4c28$export$2e2bcd8739ae039), null),
        data: displayValues,
        renderItem: renderItem,
        renderRest: renderRest,
        suffix: /*#__PURE__*/ $cQmXV.createElement((0, $ab6afd782bab2b6b$export$2e2bcd8739ae039), $8206f6dd938cb15e$var$_extends({
            ref: ref,
            disabled: disabled,
            readOnly: !inputEditable
        }, inputProps, {
            value: inputValue || "",
            syncWidth: true
        })),
        itemKey: $8206f6dd938cb15e$var$itemKey,
        maxCount: maxTagCount
    });
});




const $0821c9f3bc959cca$var$SelectContent = /*#__PURE__*/ $cQmXV.forwardRef(function SelectContent(_, ref) {
    const { multiple: multiple, onInputKeyDown: onInputKeyDown, tabIndex: tabIndex } = (0, $e6a8f1906529bc20$export$7785dec5a5aec756)();
    const baseProps = (0, $55a8e8da9f434170$export$2e2bcd8739ae039)();
    const { showSearch: showSearch } = baseProps;
    const ariaProps = (0, $4b5c733d1d7bb306$export$2e2bcd8739ae039)(baseProps, {
        aria: true
    });
    const sharedInputProps = {
        ...ariaProps,
        onKeyDown: onInputKeyDown,
        readOnly: !showSearch,
        tabIndex: tabIndex
    };
    if (multiple) return /*#__PURE__*/ $cQmXV.createElement((0, $8206f6dd938cb15e$export$2e2bcd8739ae039), {
        ref: ref,
        inputProps: sharedInputProps
    });
    return /*#__PURE__*/ $cQmXV.createElement((0, $1c60b676808bd25d$export$2e2bcd8739ae039), {
        ref: ref,
        inputProps: sharedInputProps
    });
});
var $0821c9f3bc959cca$export$2e2bcd8739ae039 = $0821c9f3bc959cca$var$SelectContent;






function $1749a8d1ce0da0a3$export$48ac81d4a07c29c(currentKeyCode) {
    return(// Undefined for Edge bug:
    // https://github.com/ant-design/ant-design/issues/51292
    currentKeyCode && // Other keys
    ![
        // System function button
        (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).ESC,
        (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).SHIFT,
        (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).BACKSPACE,
        (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).TAB,
        (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).WIN_KEY,
        (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).ALT,
        (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).META,
        (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).WIN_KEY_RIGHT,
        (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).CTRL,
        (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).SEMICOLON,
        (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).EQUALS,
        (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).CAPS_LOCK,
        (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).CONTEXT_MENU,
        // Arrow keys - should not trigger open when navigating in input
        (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).UP,
        // KeyCode.DOWN,
        (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).LEFT,
        (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).RIGHT,
        // F1-F12
        (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).F1,
        (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).F2,
        (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).F3,
        (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).F4,
        (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).F5,
        (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).F6,
        (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).F7,
        (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).F8,
        (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).F9,
        (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).F10,
        (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).F11,
        (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).F12
    ].includes(currentKeyCode));
}



function $d7b2cabdbd70f286$var$_extends() {
    $d7b2cabdbd70f286$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d7b2cabdbd70f286$var$_extends.apply(this, arguments);
}
const $d7b2cabdbd70f286$var$DEFAULT_OMIT_PROPS = [
    "value",
    "onChange",
    "removeIcon",
    "placeholder",
    "maxTagCount",
    "maxTagTextLength",
    "maxTagPlaceholder",
    "choiceTransitionName",
    "onInputKeyDown",
    "onPopupScroll",
    "tabIndex",
    "activeValue",
    "onSelectorRemove",
    "focused"
];
var $d7b2cabdbd70f286$export$2e2bcd8739ae039 = /*#__PURE__*/ $cQmXV.forwardRef(function SelectInput(props, ref) {
    const { prefixCls: // Style
    prefixCls, className: className, style: style, prefix: // UI
    prefix, suffix: suffix, clearIcon: clearIcon, clearLabel: clearLabel, children: children, multiple: // Data
    multiple, displayValues: displayValues, placeholder: placeholder, mode: mode, searchValue: // Search
    searchValue, onSearch: onSearch, onSearchSubmit: onSearchSubmit, onInputBlur: onInputBlur, maxLength: // Input
    maxLength, autoFocus: autoFocus, onMouseDown: // Events
    onMouseDown, onClearMouseDown: onClearMouseDown, onInputKeyDown: onInputKeyDown, onSelectorRemove: onSelectorRemove, tokenWithEnter: // Token handling
    tokenWithEnter, components: // Components
    components, ...restProps } = props;
    const { triggerOpen: triggerOpen, toggleOpen: toggleOpen, showSearch: showSearch, disabled: disabled, loading: loading, classNames: classNames, styles: styles } = (0, $55a8e8da9f434170$export$2e2bcd8739ae039)();
    const rootRef = $cQmXV.useRef(null);
    const inputRef = $cQmXV.useRef(null);
    // Handle keyboard events similar to original Selector
    const onInternalInputKeyDown = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((event)=>{
        const { which: which } = event;
        // Compatible with multiple lines in TextArea
        const isTextAreaElement = inputRef.current instanceof HTMLTextAreaElement;
        // Prevent default behavior for up/down arrows when dropdown is open
        if (!isTextAreaElement && triggerOpen && (which === (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).UP || which === (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).DOWN)) event.preventDefault();
        // Call the original onInputKeyDown callback
        if (onInputKeyDown) onInputKeyDown(event);
        // Move within the text box for TextArea
        if (isTextAreaElement && !triggerOpen && ~[
            (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).UP,
            (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).DOWN,
            (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).LEFT,
            (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).RIGHT
        ].indexOf(which)) return;
        // Open dropdown when a valid open key is pressed
        const isModifier = event.ctrlKey || event.altKey || event.metaKey;
        if (!isModifier && (0, $1749a8d1ce0da0a3$export$48ac81d4a07c29c)(which)) toggleOpen(true);
    });
    // ====================== Refs ======================
    $cQmXV.useImperativeHandle(ref, ()=>{
        return {
            focus: (options)=>{
                // Focus the inner input if available, otherwise fall back to root div.
                (inputRef.current || rootRef.current).focus?.(options);
            },
            blur: ()=>{
                (inputRef.current || rootRef.current).blur?.();
            },
            // Use getDOM to handle nested nativeElement structure (e.g., when RootComponent is antd Input)
            nativeElement: (0, $d3fb35d553a86e29$export$9aa546fdc20ae5b3)(rootRef.current)
        };
    });
    // ====================== Open ======================
    const onInternalMouseDown = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((event)=>{
        if (!disabled) {
            const inputDOM = (0, $d3fb35d553a86e29$export$9aa546fdc20ae5b3)(inputRef.current);
            // https://github.com/ant-design/ant-design/issues/56002
            // Tell `useSelectTriggerControl` to ignore this event
            // When icon is dynamic render, the parentNode will miss
            // so we need to mark the event directly
            event.nativeEvent._ori_target = inputDOM;
            const isClickOnInput = inputDOM === event.target || inputDOM?.contains(event.target);
            if (inputDOM && !isClickOnInput) event.preventDefault();
            // Check if we should prevent closing when clicking on selector
            // Don't close if: open && not multiple && (combobox mode || showSearch)
            const shouldPreventCloseOnSingle = triggerOpen && !multiple && (mode === "combobox" || showSearch);
            // Don't close if: open && multiple && click on input
            const shouldPreventCloseOnMultipleInput = triggerOpen && multiple && isClickOnInput;
            const shouldPreventClose = shouldPreventCloseOnSingle || shouldPreventCloseOnMultipleInput;
            if (!event.nativeEvent._select_lazy) {
                inputRef.current?.focus();
                // Only toggle open if we should not prevent close
                if (!shouldPreventClose) toggleOpen();
            } else if (triggerOpen && !multiple) // Lazy should also close when click clear icon in single select.
            toggleOpen(false);
        }
        onMouseDown?.(event);
    });
    // =================== Components ===================
    const { root: RootComponent } = components;
    // ===================== Render =====================
    const domProps = (0, $e8c5093aebad6025$export$2e2bcd8739ae039)(restProps, $d7b2cabdbd70f286$var$DEFAULT_OMIT_PROPS);
    const ariaProps = (0, $4b5c733d1d7bb306$export$2e2bcd8739ae039)(domProps, {
        aria: true
    });
    const ariaKeys = Object.keys(ariaProps);
    // Create context value with wrapped callbacks
    const contextValue = {
        ...props,
        onInputKeyDown: onInternalInputKeyDown
    };
    if (RootComponent) {
        const originProps = RootComponent.props || {};
        const mergedProps = {
            ...originProps,
            ...domProps
        };
        Object.keys(originProps).forEach((key)=>{
            const originVal = originProps[key];
            const domVal = domProps[key];
            if (typeof originVal === "function" && typeof domVal === "function") mergedProps[key] = (...args)=>{
                domVal(...args);
                originVal(...args);
            };
        });
        if (/*#__PURE__*/ $cQmXV.isValidElement(RootComponent)) return /*#__PURE__*/ $cQmXV.cloneElement(RootComponent, {
            ...mergedProps,
            ref: (0, $10341b937b26f69d$export$ab452c34e8e05029)(RootComponent.ref, rootRef)
        });
        return /*#__PURE__*/ $cQmXV.createElement(RootComponent, $d7b2cabdbd70f286$var$_extends({}, mergedProps, {
            ref: rootRef
        }));
    }
    return /*#__PURE__*/ $cQmXV.createElement((0, $e6a8f1906529bc20$export$2e2bcd8739ae039).Provider, {
        value: contextValue
    }, /*#__PURE__*/ $cQmXV.createElement("div", $d7b2cabdbd70f286$var$_extends({}, (0, $e8c5093aebad6025$export$2e2bcd8739ae039)(domProps, ariaKeys), {
        // Style
        ref: rootRef,
        className: className,
        style: style,
        onMouseDown: onInternalMouseDown
    }), /*#__PURE__*/ $cQmXV.createElement((0, $2744b0aa61a6ad2e$export$2e2bcd8739ae039), {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-prefix`, classNames?.prefix),
        style: styles?.prefix
    }, prefix), /*#__PURE__*/ $cQmXV.createElement((0, $0821c9f3bc959cca$export$2e2bcd8739ae039), {
        ref: inputRef
    }), /*#__PURE__*/ $cQmXV.createElement((0, $2744b0aa61a6ad2e$export$2e2bcd8739ae039), {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-suffix`, {
            [`${prefixCls}-suffix-loading`]: loading
        }, classNames?.suffix),
        style: styles?.suffix
    }, suffix), clearIcon && /*#__PURE__*/ $cQmXV.createElement("button", {
        type: "button",
        "aria-label": clearLabel,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-clear`, classNames?.clear),
        style: styles?.clear,
        onMouseDown: (e)=>{
            // Keep focus on the input and mark the native event so the root
            // `onInternalMouseDown` handler does not open the dropdown.
            // This must run on mousedown because the root handler fires
            // before the button's onClick.
            e.preventDefault();
            e.nativeEvent._select_lazy = true;
        },
        onClick: onClearMouseDown
    }, clearIcon), children));
});



var $cQmXV = parcelRequire("cQmXV");
function $bff553ef9e072da1$export$2e2bcd8739ae039(components, getInputElement, getRawInputElement) {
    return $cQmXV.useMemo(()=>{
        let { root: root, input: input } = components || {};
        // root: getRawInputElement
        if (getRawInputElement) root = getRawInputElement();
        // input: getInputElement
        if (getInputElement) input = getInputElement();
        return {
            root: root,
            input: input
        };
    }, [
        components,
        getInputElement,
        getRawInputElement
    ]);
}


function $5ac3fa1f5d4717fa$var$_extends() {
    $5ac3fa1f5d4717fa$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5ac3fa1f5d4717fa$var$_extends.apply(this, arguments);
}
const $5ac3fa1f5d4717fa$export$7f654ad2a77ad2ac = (mode)=>mode === "tags" || mode === "multiple";
const $5ac3fa1f5d4717fa$var$BaseSelect = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { id: id, prefixCls: prefixCls, className: className, styles: styles, classNames: classNames, showSearch: showSearch, tagRender: tagRender, showScrollBar: showScrollBar = "optional", direction: direction, omitDomProps: omitDomProps, displayValues: // Value
    displayValues, onDisplayValuesChange: onDisplayValuesChange, emptyOptions: emptyOptions, notFoundContent: notFoundContent = "Not Found", onClear: onClear, maxCount: maxCount, placeholder: placeholder, mode: // Mode
    mode, disabled: // Status
    disabled, loading: loading, getInputElement: // Customize Input
    getInputElement, getRawInputElement: getRawInputElement, open: // Open
    open, defaultOpen: defaultOpen, onPopupVisibleChange: onPopupVisibleChange, activeValue: // Active
    activeValue, onActiveValueChange: onActiveValueChange, activeDescendantId: activeDescendantId, searchValue: // Search
    searchValue, autoClearSearchValue: autoClearSearchValue, onSearch: onSearch, onSearchSplit: onSearchSplit, tokenSeparators: tokenSeparators, allowClear: // Icons
    allowClear, prefix: prefix, suffix: suffix, suffixIcon: suffixIcon, clearIcon: clearIcon, OptionList: // Dropdown
    OptionList, animation: animation, transitionName: transitionName, popupStyle: popupStyle, popupClassName: popupClassName, popupMatchSelectWidth: popupMatchSelectWidth, popupRender: popupRender, popupAlign: popupAlign, placement: placement, builtinPlacements: builtinPlacements, getPopupContainer: getPopupContainer, showAction: // Focus
    showAction = [], onFocus: onFocus, onBlur: onBlur, onKeyUp: // Rest Events
    onKeyUp, onKeyDown: onKeyDown, onMouseDown: onMouseDown, components: // Components
    components, // Rest Props
    ...restProps } = props;
    // ============================== MISC ==============================
    const multiple = $5ac3fa1f5d4717fa$export$7f654ad2a77ad2ac(mode);
    // ============================== Refs ==============================
    const containerRef = $cQmXV.useRef(null);
    const triggerRef = $cQmXV.useRef(null);
    const listRef = $cQmXV.useRef(null);
    /** Used for component focused management */ const [focused, setFocused] = $cQmXV.useState(false);
    // =========================== Imperative ===========================
    $cQmXV.useImperativeHandle(ref, ()=>({
            focus: containerRef.current?.focus,
            blur: containerRef.current?.blur,
            scrollTo: (arg)=>listRef.current?.scrollTo(arg),
            nativeElement: (0, $d3fb35d553a86e29$export$9aa546fdc20ae5b3)(containerRef.current)
        }));
    // =========================== Components ===========================
    const mergedComponents = (0, $bff553ef9e072da1$export$2e2bcd8739ae039)(components, getInputElement, getRawInputElement);
    // ========================== Search Value ==========================
    const mergedSearchValue = $cQmXV.useMemo(()=>{
        if (mode !== "combobox") return searchValue;
        const val = displayValues[0]?.value;
        return typeof val === "string" || typeof val === "number" ? String(val) : "";
    }, [
        searchValue,
        mode,
        displayValues
    ]);
    // ========================== Custom Input ==========================
    // Only works in `combobox`
    const customizeInputElement = mode === "combobox" && typeof getInputElement === "function" && getInputElement() || null;
    // ============================== Open ==============================
    // Not trigger `open` when `notFoundContent` is empty
    const emptyListContent = !notFoundContent && emptyOptions;
    const [rawOpen, mergedOpen, triggerOpen, lockOptions] = (0, $3269bfbea626bbf3$export$2e2bcd8739ae039)(defaultOpen || false, open, onPopupVisibleChange, (nextOpen)=>disabled || emptyListContent ? false : nextOpen);
    // ============================= Search =============================
    const tokenWithEnter = $cQmXV.useMemo(()=>typeof tokenSeparators === "function" || (tokenSeparators || []).some((tokenSeparator)=>[
                "\n",
                "\r\n"
            ].includes(tokenSeparator)), [
        tokenSeparators
    ]);
    const splitByTokenSeparators = $cQmXV.useMemo(()=>{
        if (typeof tokenSeparators === "function") return (input, end)=>{
            const tokens = tokenSeparators(input);
            const isUnchanged = Array.isArray(tokens) && tokens.length === 1 && tokens[0] === input;
            if (!Array.isArray(tokens) || !tokens.length || isUnchanged) return null;
            return typeof end !== "undefined" ? tokens.slice(0, end) : tokens;
        };
        return (input, end)=>(0, $46a03b35f5ed52b3$export$a09ca2a89e052b14)(input, tokenSeparators, end);
    }, [
        tokenSeparators
    ]);
    const onInternalSearch = (searchText, fromTyping, isCompositing)=>{
        if (multiple && (0, $46a03b35f5ed52b3$export$be48fd776273e509)(maxCount) && displayValues.length >= maxCount) return;
        let ret = true;
        let newSearchText = searchText;
        onActiveValueChange?.(null);
        const cap = (0, $46a03b35f5ed52b3$export$be48fd776273e509)(maxCount) ? maxCount - displayValues.length : undefined;
        const patchLabels = isCompositing ? null : splitByTokenSeparators(searchText, cap);
        // Ignore combobox since it's not split-able
        if (mode !== "combobox" && patchLabels) {
            newSearchText = "";
            onSearchSplit?.(patchLabels);
            // Should close when paste finish
            triggerOpen(false);
            // Tell Selector that break next actions
            ret = false;
        }
        if (onSearch && mergedSearchValue !== newSearchText) onSearch(newSearchText, {
            source: fromTyping ? "typing" : "effect"
        });
        // Open if from typing
        if (searchText && fromTyping && ret) triggerOpen(true);
        return ret;
    };
    // Only triggered when menu is closed & mode is tags
    // If menu is open, OptionList will take charge
    // If mode isn't tags, press enter is not meaningful when you can't see any option
    const onInternalSearchSubmit = (searchText)=>{
        // prevent empty tags from appearing when you click the Enter button
        if (!searchText || !searchText.trim()) return;
        onSearch(searchText, {
            source: "submit"
        });
    };
    // Clean up search value when the dropdown is closed.
    // We use `rawOpen` here to avoid clearing the search input when the dropdown is
    // programmatically closed due to `notFoundContent={null}` and no matching options.
    // This allows the user to continue typing their search query.
    $cQmXV.useEffect(()=>{
        if (!rawOpen && !multiple && mode !== "combobox") onInternalSearch("", false, false);
    }, [
        rawOpen
    ]);
    // ============================ Disabled ============================
    // Close dropdown & remove focus state when disabled change
    $cQmXV.useEffect(()=>{
        // After onBlur is triggered, the focused does not need to be reset
        if (disabled) {
            triggerOpen(false);
            setFocused(false);
        }
    }, [
        disabled,
        mergedOpen
    ]);
    // ============================ Keyboard ============================
    /**
   * We record input value here to check if can press to clean up by backspace
   * - null: Key is not down, this is reset by key up
   * - true: Search text is empty when first time backspace down
   * - false: Search text is not empty when first time backspace down
   */ const [getClearLock, setClearLock] = (0, $c747d4db0f166ed1$export$2e2bcd8739ae039)();
    const keyLockRef = $cQmXV.useRef(false);
    // KeyDown
    const onInternalKeyDown = (event)=>{
        const clearLock = getClearLock();
        const { key: key } = event;
        const isEnterKey = key === "Enter";
        const isSpaceKey = key === " ";
        // Enter or Space opens dropdown (ARIA combobox: spacebar should open)
        if (isEnterKey || isSpaceKey) {
            // Do not submit form when type in the input; prevent Space from scrolling page
            const isCombobox = mode === "combobox";
            const isEditable = isCombobox || showSearch;
            if (isSpaceKey && !isEditable || isEnterKey && !isCombobox) event.preventDefault();
            // We only manage open state here, close logic should handle by list component
            if (!mergedOpen) triggerOpen(true);
        }
        setClearLock(!!mergedSearchValue);
        // Remove value by `backspace`
        if (key === "Backspace" && !clearLock && multiple && !mergedSearchValue && displayValues.length) {
            const cloneDisplayValues = [
                ...displayValues
            ];
            let removedDisplayValue = null;
            for(let i = cloneDisplayValues.length - 1; i >= 0; i -= 1){
                const current = cloneDisplayValues[i];
                if (!current.disabled) {
                    cloneDisplayValues.splice(i, 1);
                    removedDisplayValue = current;
                    break;
                }
            }
            if (removedDisplayValue) onDisplayValuesChange(cloneDisplayValues, {
                type: "remove",
                values: [
                    removedDisplayValue
                ]
            });
        }
        if (mergedOpen && (!isEnterKey || !keyLockRef.current) && !isSpaceKey) {
            // Lock the Enter key after it is pressed to avoid repeated triggering of the onChange event.
            if (isEnterKey) keyLockRef.current = true;
            listRef.current?.onKeyDown(event);
        }
        onKeyDown?.(event);
    };
    // KeyUp
    const onInternalKeyUp = (event, ...rest)=>{
        if (mergedOpen) listRef.current?.onKeyUp(event, ...rest);
        if (event.key === "Enter") keyLockRef.current = false;
        onKeyUp?.(event, ...rest);
    };
    // ============================ Selector ============================
    const onSelectorRemove = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((val)=>{
        const newValues = displayValues.filter((i)=>i !== val);
        onDisplayValuesChange(newValues, {
            type: "remove",
            values: [
                val
            ]
        });
    });
    const onInputBlur = ()=>{
        // Unlock the Enter key after the input blur; otherwise, the Enter key needs to be pressed twice to trigger the correct effect.
        keyLockRef.current = false;
    };
    // ========================== Focus / Blur ==========================
    const getSelectElements = ()=>[
            (0, $d3fb35d553a86e29$export$9aa546fdc20ae5b3)(containerRef.current),
            triggerRef.current?.getPopupElement()
        ];
    // Close when click on non-select element
    (0, $244314a99075d747$export$2e2bcd8739ae039)(getSelectElements, mergedOpen, triggerOpen, !!mergedComponents.root);
    // ========================== Focus / Blur ==========================
    const internalMouseDownRef = $cQmXV.useRef(false);
    const onInternalFocus = (event)=>{
        setFocused(true);
        if (!disabled) {
            // `showAction` should handle `focus` if set
            if (showAction.includes("focus")) triggerOpen(true);
            onFocus?.(event);
        }
    };
    const onRootBlur = ()=>{
        // Delay close should check the activeElement
        if (mergedOpen && !internalMouseDownRef.current) triggerOpen(false, {
            cancelFun: ()=>(0, $244314a99075d747$export$4ac6a1c95deee4c5)(getSelectElements(), document.activeElement)
        });
    };
    const onInternalBlur = (event)=>{
        setFocused(false);
        if (mergedSearchValue) {
            // `tags` mode should move `searchValue` into values
            if (mode === "tags") onSearch(mergedSearchValue, {
                source: "submit"
            });
            else if (mode === "multiple") // `multiple` mode only clean the search value but not trigger event
            onSearch("", {
                source: "blur"
            });
        }
        onRootBlur();
        if (!disabled) onBlur?.(event);
    };
    const onRootMouseDown = (event, ...restArgs)=>{
        const { target: target } = event;
        const popupElement = triggerRef.current?.getPopupElement();
        // We should give focus back to selector if clicked item is not focusable
        if (popupElement?.contains(target) && triggerOpen) // Tell `open` not to close since it's safe in the popup
        triggerOpen(true);
        onMouseDown?.(event, ...restArgs);
        internalMouseDownRef.current = true;
        (0, $3269bfbea626bbf3$export$f1309b2412c6fa89)(()=>{
            internalMouseDownRef.current = false;
        });
    };
    // ============================ Dropdown ============================
    const [, forceUpdate] = $cQmXV.useState({});
    // We need force update here since popup dom is render async
    function onPopupMouseEnter() {
        forceUpdate({});
    }
    // Used for raw custom input trigger
    let onTriggerVisibleChange;
    if (!!mergedComponents.root) onTriggerVisibleChange = (newOpen)=>{
        triggerOpen(newOpen);
    };
    // ============================ Context =============================
    const baseSelectContext = $cQmXV.useMemo(()=>({
            ...props,
            notFoundContent: notFoundContent,
            open: mergedOpen,
            triggerOpen: mergedOpen,
            rawOpen: rawOpen,
            id: id,
            showSearch: showSearch,
            multiple: multiple,
            toggleOpen: triggerOpen,
            showScrollBar: showScrollBar,
            styles: styles,
            classNames: classNames,
            lockOptions: lockOptions
        }), [
        props,
        notFoundContent,
        triggerOpen,
        id,
        showSearch,
        multiple,
        mergedOpen,
        rawOpen,
        showScrollBar,
        styles,
        classNames,
        lockOptions
    ]);
    // ==================================================================
    // ==                            Render                            ==
    // ==================================================================
    // ============================= Suffix =============================
    const mergedSuffixIcon = $cQmXV.useMemo(()=>{
        const nextSuffix = suffix ?? suffixIcon;
        if (typeof nextSuffix === "function") return nextSuffix({
            searchValue: mergedSearchValue,
            open: mergedOpen,
            focused: focused,
            showSearch: showSearch,
            loading: loading
        });
        return nextSuffix;
    }, [
        suffix,
        suffixIcon,
        mergedSearchValue,
        mergedOpen,
        focused,
        showSearch,
        loading
    ]);
    // ============================= Clear ==============================
    const onClearMouseDown = ()=>{
        onClear?.();
        containerRef.current?.focus();
        onDisplayValuesChange([], {
            type: "clear",
            values: displayValues
        });
        onInternalSearch("", false, false);
    };
    const { allowClear: mergedAllowClear, clearIcon: clearNode, label: clearLabel } = (0, $5bbe7a07702f6383$export$9ea6397a890aa3e5)(prefixCls, displayValues, allowClear, clearIcon, disabled, mergedSearchValue, mode);
    // =========================== OptionList ===========================
    const optionList = /*#__PURE__*/ $cQmXV.createElement(OptionList, {
        ref: listRef
    });
    // ============================= Select =============================
    const mergedClassName = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, className, {
        [`${prefixCls}-focused`]: focused,
        [`${prefixCls}-multiple`]: multiple,
        [`${prefixCls}-single`]: !multiple,
        [`${prefixCls}-allow-clear`]: mergedAllowClear,
        [`${prefixCls}-show-arrow`]: mergedSuffixIcon !== undefined && mergedSuffixIcon !== null,
        [`${prefixCls}-disabled`]: disabled,
        [`${prefixCls}-loading`]: loading,
        [`${prefixCls}-open`]: mergedOpen,
        [`${prefixCls}-customize-input`]: customizeInputElement,
        [`${prefixCls}-show-search`]: showSearch
    });
    // >>> Render
    let renderNode = /*#__PURE__*/ $cQmXV.createElement((0, $d7b2cabdbd70f286$export$2e2bcd8739ae039), $5ac3fa1f5d4717fa$var$_extends({}, restProps, {
        // Ref
        ref: containerRef,
        prefixCls: prefixCls,
        className: mergedClassName,
        focused: focused,
        prefix: prefix,
        suffix: mergedSuffixIcon,
        clearIcon: clearNode,
        clearLabel: clearLabel,
        multiple: multiple,
        mode: mode,
        displayValues: displayValues,
        placeholder: placeholder,
        searchValue: mergedSearchValue,
        activeValue: activeValue,
        onSearch: onInternalSearch,
        onSearchSubmit: onInternalSearchSubmit,
        onInputBlur: onInputBlur,
        onFocus: onInternalFocus,
        onBlur: onInternalBlur,
        onClearMouseDown: onClearMouseDown,
        onKeyDown: onInternalKeyDown,
        onKeyUp: onInternalKeyUp,
        onSelectorRemove: onSelectorRemove,
        tokenWithEnter: tokenWithEnter,
        onMouseDown: onRootMouseDown,
        components: mergedComponents
    }));
    renderNode = /*#__PURE__*/ $cQmXV.createElement((0, $75385ddd88522f51$export$2e2bcd8739ae039), {
        ref: triggerRef,
        disabled: disabled,
        prefixCls: prefixCls,
        visible: mergedOpen,
        popupElement: optionList,
        animation: animation,
        transitionName: transitionName,
        popupStyle: popupStyle,
        popupClassName: popupClassName,
        direction: direction,
        popupMatchSelectWidth: popupMatchSelectWidth,
        popupRender: popupRender,
        popupAlign: popupAlign,
        placement: placement,
        builtinPlacements: builtinPlacements,
        getPopupContainer: getPopupContainer,
        empty: emptyOptions,
        onPopupVisibleChange: onTriggerVisibleChange,
        onPopupMouseEnter: onPopupMouseEnter,
        onPopupMouseDown: onRootMouseDown,
        onPopupBlur: onRootBlur
    }, renderNode);
    return /*#__PURE__*/ $cQmXV.createElement((0, $55a8e8da9f434170$export$8234047c0aea33cf).Provider, {
        value: baseSelectContext
    }, /*#__PURE__*/ $cQmXV.createElement((0, $c01ee40425dfc000$export$2e2bcd8739ae039), {
        visible: focused && !mergedOpen,
        values: displayValues
    }), renderNode);
});
var $5ac3fa1f5d4717fa$export$2e2bcd8739ae039 = $5ac3fa1f5d4717fa$var$BaseSelect;


/* istanbul ignore file */ /** This is a placeholder, not real render in dom */ const $a77affc9f9453370$var$OptGroup = ()=>null;
$a77affc9f9453370$var$OptGroup.isSelectOptGroup = true;
var $a77affc9f9453370$export$2e2bcd8739ae039 = $a77affc9f9453370$var$OptGroup;


/* istanbul ignore file */ /** This is a placeholder, not real render in dom */ const $e2be968a818eff80$var$Option = ()=>null;
$e2be968a818eff80$var$Option.isSelectOption = true;
var $e2be968a818eff80$export$2e2bcd8739ae039 = $e2be968a818eff80$var$Option;






var $cQmXV = parcelRequire("cQmXV");



/* istanbul ignore file */ function $3840ef3800216e4e$export$3bbcfec016973a77() {
    return /(mac\sos|macintosh)/i.test(navigator.appVersion);
}



function $92f5fee8c45009b6$var$_extends() {
    $92f5fee8c45009b6$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $92f5fee8c45009b6$var$_extends.apply(this, arguments);
}
// export interface OptionListProps<OptionsType extends object[]> {
function $92f5fee8c45009b6$var$isTitleType(content) {
    return typeof content === "string" || typeof content === "number";
}
/**
 * Using virtual list of option display.
 * Will fallback to dom if use customize render.
 */ const $92f5fee8c45009b6$var$OptionList = (_, ref)=>{
    const { prefixCls: prefixCls, id: id, open: open, multiple: multiple, mode: mode, searchValue: searchValue, toggleOpen: toggleOpen, notFoundContent: notFoundContent, onPopupScroll: onPopupScroll, showScrollBar: showScrollBar, lockOptions: lockOptions } = (0, $55a8e8da9f434170$export$2e2bcd8739ae039)();
    const { maxCount: maxCount, flattenOptions: flattenOptions, onActiveValue: onActiveValue, defaultActiveFirstOption: defaultActiveFirstOption, onSelect: onSelect, menuItemSelectedIcon: menuItemSelectedIcon, rawValues: rawValues, fieldNames: fieldNames, virtual: virtual, direction: direction, listHeight: listHeight, listItemHeight: listItemHeight, optionRender: optionRender, classNames: contextClassNames, styles: contextStyles } = $cQmXV.useContext((0, $8b26feb71ab0689b$export$2e2bcd8739ae039));
    const itemPrefixCls = `${prefixCls}-item`;
    const memoFlattenOptions = (0, $d627c2941353b4cb$export$2e2bcd8739ae039)(()=>flattenOptions, [
        open,
        lockOptions
    ], (prev, next)=>next[0] && !next[1]);
    // =========================== List ===========================
    const listRef = $cQmXV.useRef(null);
    const overMaxCount = $cQmXV.useMemo(()=>multiple && (0, $46a03b35f5ed52b3$export$be48fd776273e509)(maxCount) && rawValues?.size >= maxCount, [
        multiple,
        maxCount,
        rawValues?.size
    ]);
    const onListMouseDown = (event)=>{
        event.preventDefault();
    };
    const scrollIntoView = (args)=>{
        listRef.current?.scrollTo(typeof args === "number" ? {
            index: args
        } : args);
    };
    // https://github.com/ant-design/ant-design/issues/34975
    const isSelected = $cQmXV.useCallback((value)=>{
        if (mode === "combobox") return false;
        return rawValues.has(value);
    }, [
        mode,
        [
            ...rawValues
        ].toString(),
        rawValues.size
    ]);
    // ========================== Active ==========================
    const getEnabledActiveIndex = (index, offset = 1)=>{
        const len = memoFlattenOptions.length;
        for(let i = 0; i < len; i += 1){
            const current = (index + i * offset + len) % len;
            const { group: group, data: data } = memoFlattenOptions[current] || {};
            if (!group && !data?.disabled && (isSelected(data.value) || !overMaxCount)) return current;
        }
        return -1;
    };
    const [activeIndex, setActiveIndex] = $cQmXV.useState(()=>getEnabledActiveIndex(0));
    const setActive = (index, fromKeyboard = false)=>{
        setActiveIndex(index);
        const info = {
            source: fromKeyboard ? "keyboard" : "mouse"
        };
        // Trigger active event
        const flattenItem = memoFlattenOptions[index];
        if (!flattenItem) {
            onActiveValue(null, -1, info);
            return;
        }
        onActiveValue(flattenItem.value, index, info);
    };
    // Auto active first item when list length or searchValue changed
    (0, $cQmXV.useEffect)(()=>{
        setActive(defaultActiveFirstOption !== false ? getEnabledActiveIndex(0) : -1);
    }, [
        memoFlattenOptions.length,
        searchValue
    ]);
    // https://github.com/ant-design/ant-design/issues/48036
    const isAriaSelected = $cQmXV.useCallback((value)=>{
        if (mode === "combobox") return String(value).toLowerCase() === searchValue.toLowerCase();
        return rawValues.has(value);
    }, [
        mode,
        searchValue,
        [
            ...rawValues
        ].toString(),
        rawValues.size
    ]);
    // Auto scroll to item position in single mode
    (0, $cQmXV.useEffect)(()=>{
        /**
     * React will skip `onChange` when component update.
     * `setActive` function will call root accessibility state update which makes re-render.
     * So we need to delay to let Input component trigger onChange first.
     */ let timeoutId;
        if (!multiple && open && rawValues.size === 1) {
            const value = Array.from(rawValues)[0];
            // Scroll to the option closest to the searchValue if searching.
            const index = memoFlattenOptions.findIndex(({ data: data })=>searchValue ? String(data.value).startsWith(searchValue) : data.value === value);
            if (index !== -1) {
                setActive(index);
                timeoutId = setTimeout(()=>{
                    scrollIntoView(index);
                });
            }
        }
        // Force trigger scrollbar visible when open
        if (open) listRef.current?.scrollTo(undefined);
        return ()=>clearTimeout(timeoutId);
    }, [
        open,
        searchValue
    ]);
    // ========================== Values ==========================
    const onSelectValue = (value)=>{
        if (value !== undefined) onSelect(value, {
            selected: !rawValues.has(value)
        });
        // Single mode should always close by select
        if (!multiple) toggleOpen(false);
    };
    // ========================= Keyboard =========================
    $cQmXV.useImperativeHandle(ref, ()=>({
            onKeyDown: (event)=>{
                const { which: which, ctrlKey: ctrlKey } = event;
                switch(which){
                    // >>> Arrow keys & ctrl + n/p on Mac
                    case (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).N:
                    case (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).P:
                    case (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).UP:
                    case (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).DOWN:
                        {
                            let offset = 0;
                            if (which === (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).UP) offset = -1;
                            else if (which === (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).DOWN) offset = 1;
                            else if ((0, $3840ef3800216e4e$export$3bbcfec016973a77)() && ctrlKey) {
                                if (which === (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).N) offset = 1;
                                else if (which === (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).P) offset = -1;
                            }
                            if (offset !== 0) {
                                const nextActiveIndex = getEnabledActiveIndex(activeIndex + offset, offset);
                                scrollIntoView(nextActiveIndex);
                                setActive(nextActiveIndex, true);
                            }
                            break;
                        }
                    // >>> Select (Tab / Enter)
                    case (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).TAB:
                    case (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).ENTER:
                        {
                            // value
                            const item = memoFlattenOptions[activeIndex];
                            if (!item || item.data.disabled) return onSelectValue(undefined);
                            if (!overMaxCount || rawValues.has(item.value)) onSelectValue(item.value);
                            else onSelectValue(undefined);
                            if (open) event.preventDefault();
                            break;
                        }
                    // >>> Close
                    case (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).ESC:
                        toggleOpen(false);
                        if (open) event.stopPropagation();
                }
            },
            onKeyUp: ()=>{},
            scrollTo: (index)=>{
                scrollIntoView(index);
            }
        }));
    // ========================== Render ==========================
    if (memoFlattenOptions.length === 0) return /*#__PURE__*/ $cQmXV.createElement("div", {
        role: "listbox",
        id: `${id}_list`,
        className: `${itemPrefixCls}-empty`,
        onMouseDown: onListMouseDown
    }, notFoundContent);
    const omitFieldNameList = Object.keys(fieldNames).map((key)=>fieldNames[key]);
    const getLabel = (item)=>item.label;
    function getItemAriaProps(item, index) {
        const { group: group } = item;
        return {
            role: group ? "presentation" : "option",
            id: `${id}_list_${index}`
        };
    }
    const renderItem = (index)=>{
        const item = memoFlattenOptions[index];
        if (!item) return null;
        const itemData = item.data || {};
        const { value: value, disabled: disabled } = itemData;
        const { group: group } = item;
        const attrs = (0, $4b5c733d1d7bb306$export$2e2bcd8739ae039)(itemData, true);
        const mergedLabel = getLabel(item);
        return item ? /*#__PURE__*/ $cQmXV.createElement("div", $92f5fee8c45009b6$var$_extends({
            "aria-label": typeof mergedLabel === "string" && !group ? mergedLabel : null
        }, attrs, {
            key: index
        }, getItemAriaProps(item, index), {
            "aria-selected": isAriaSelected(value),
            "aria-disabled": disabled
        }), value) : null;
    };
    const a11yProps = {
        role: "listbox",
        id: `${id}_list`
    };
    return /*#__PURE__*/ $cQmXV.createElement($cQmXV.Fragment, null, virtual && /*#__PURE__*/ $cQmXV.createElement("div", $92f5fee8c45009b6$var$_extends({}, a11yProps, {
        style: {
            height: 0,
            width: 0,
            overflow: "hidden"
        }
    }), renderItem(activeIndex - 1), renderItem(activeIndex), renderItem(activeIndex + 1)), /*#__PURE__*/ $cQmXV.createElement((0, $a9f0fc634fe20e3d$export$2e2bcd8739ae039), {
        prefixCls: `${prefixCls}-dropdown-list`,
        itemKey: "key",
        ref: listRef,
        data: memoFlattenOptions,
        height: listHeight,
        itemHeight: listItemHeight,
        fullHeight: false,
        onMouseDown: onListMouseDown,
        onScroll: onPopupScroll,
        virtual: virtual,
        direction: direction,
        innerProps: virtual ? null : a11yProps,
        showScrollBar: showScrollBar,
        className: contextClassNames?.popup?.list,
        style: contextStyles?.popup?.list
    }, (item, itemIndex)=>{
        const { group: group, groupOption: groupOption, data: data, label: label, value: value } = item;
        const { key: key } = data;
        // Group
        if (group) {
            const groupTitle = data.title ?? ($92f5fee8c45009b6$var$isTitleType(label) ? label.toString() : undefined);
            return /*#__PURE__*/ $cQmXV.createElement("div", {
                className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(itemPrefixCls, `${itemPrefixCls}-group`, data.className),
                title: groupTitle
            }, label !== undefined ? label : key);
        }
        const { disabled: disabled, title: title, children: children, style: style, className: className, ...otherProps } = data;
        const passedProps = (0, $e8c5093aebad6025$export$2e2bcd8739ae039)(otherProps, omitFieldNameList);
        // Option
        const selected = isSelected(value);
        const mergedDisabled = disabled || !selected && overMaxCount;
        const optionPrefixCls = `${itemPrefixCls}-option`;
        const optionClassName = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(itemPrefixCls, optionPrefixCls, className, contextClassNames?.popup?.listItem, {
            [`${optionPrefixCls}-grouped`]: groupOption,
            [`${optionPrefixCls}-active`]: activeIndex === itemIndex && !mergedDisabled,
            [`${optionPrefixCls}-disabled`]: mergedDisabled,
            [`${optionPrefixCls}-selected`]: selected
        });
        const mergedLabel = getLabel(item);
        const iconVisible = !menuItemSelectedIcon || typeof menuItemSelectedIcon === "function" || selected;
        // https://github.com/ant-design/ant-design/issues/34145
        const content = typeof mergedLabel === "number" ? mergedLabel : mergedLabel || value;
        // https://github.com/ant-design/ant-design/issues/26717
        let optionTitle = $92f5fee8c45009b6$var$isTitleType(content) ? content.toString() : undefined;
        if (title !== undefined) optionTitle = title;
        return /*#__PURE__*/ $cQmXV.createElement("div", $92f5fee8c45009b6$var$_extends({}, (0, $4b5c733d1d7bb306$export$2e2bcd8739ae039)(passedProps), !virtual ? getItemAriaProps(item, itemIndex) : {}, {
            "aria-selected": virtual ? undefined : isAriaSelected(value),
            "aria-disabled": mergedDisabled,
            className: optionClassName,
            title: optionTitle,
            onMouseMove: ()=>{
                if (activeIndex === itemIndex || mergedDisabled) return;
                setActive(itemIndex);
            },
            onClick: ()=>{
                if (!mergedDisabled) onSelectValue(value);
            },
            style: {
                ...contextStyles?.popup?.listItem,
                ...style
            }
        }), /*#__PURE__*/ $cQmXV.createElement("div", {
            className: `${optionPrefixCls}-content`
        }, typeof optionRender === "function" ? optionRender(item, {
            index: itemIndex
        }) : content), /*#__PURE__*/ $cQmXV.isValidElement(menuItemSelectedIcon) || selected, iconVisible && /*#__PURE__*/ $cQmXV.createElement((0, $a8c8b33f809dd1e1$export$2e2bcd8739ae039), {
            className: `${itemPrefixCls}-option-state`,
            customizeIcon: menuItemSelectedIcon,
            customizeIconProps: {
                value: value,
                disabled: mergedDisabled,
                isSelected: selected
            }
        }, selected ? "\u2713" : null));
    }));
};
const $92f5fee8c45009b6$var$RefOptionList = /*#__PURE__*/ $cQmXV.forwardRef($92f5fee8c45009b6$var$OptionList);
var $92f5fee8c45009b6$export$2e2bcd8739ae039 = $92f5fee8c45009b6$var$RefOptionList;




var $cQmXV = parcelRequire("cQmXV");
var /**
 * Cache `value` related LabeledValue & options.
 */ $92ead185de6a3886$export$2e2bcd8739ae039 = (labeledValues, valueOptions)=>{
    const cacheRef = $cQmXV.useRef({
        values: new Map(),
        options: new Map()
    });
    const filledLabeledValues = $cQmXV.useMemo(()=>{
        const { values: prevValueCache, options: prevOptionCache } = cacheRef.current;
        // Fill label by cache
        const patchedValues = labeledValues.map((item)=>{
            if (item.label === undefined) return {
                ...item,
                label: prevValueCache.get(item.value)?.label
            };
            return item;
        });
        // Refresh cache
        const valueCache = new Map();
        const optionCache = new Map();
        patchedValues.forEach((item)=>{
            valueCache.set(item.value, item);
            optionCache.set(item.value, valueOptions.get(item.value) || prevOptionCache.get(item.value));
        });
        cacheRef.current.values = valueCache;
        cacheRef.current.options = optionCache;
        return patchedValues;
    }, [
        labeledValues,
        valueOptions
    ]);
    const getOption = $cQmXV.useCallback((val)=>valueOptions.get(val) || cacheRef.current.options.get(val), [
        valueOptions
    ]);
    return [
        filledLabeledValues,
        getOption
    ];
};



var $cQmXV = parcelRequire("cQmXV");


function $c8ee3e574f8b5e46$var$includes(test, search) {
    return (0, $27094fd2b2012af1$export$45b10814cc054894)(test).join("").toUpperCase().includes(search);
}
var $c8ee3e574f8b5e46$export$2e2bcd8739ae039 = (options, fieldNames, searchValue, filterOption, optionFilterProp)=>{
    return $cQmXV.useMemo(()=>{
        if (!searchValue || filterOption === false) return options;
        const { options: fieldOptions, label: fieldLabel, value: fieldValue } = fieldNames;
        const filteredOptions = [];
        const customizeFilter = typeof filterOption === "function";
        const upperSearch = searchValue.toUpperCase();
        const filterFunc = customizeFilter ? filterOption : (_, option)=>{
            // Use provided `optionFilterProp`
            if (optionFilterProp && optionFilterProp.length) return optionFilterProp.some((prop)=>$c8ee3e574f8b5e46$var$includes(option[prop], upperSearch));
            // Auto select `label` or `value` by option type
            if (option[fieldOptions]) // hack `fieldLabel` since `OptionGroup` children is not `label`
            return $c8ee3e574f8b5e46$var$includes(option[fieldLabel !== "children" ? fieldLabel : "label"], upperSearch);
            return $c8ee3e574f8b5e46$var$includes(option[fieldValue], upperSearch);
        };
        const wrapOption = customizeFilter ? (opt)=>(0, $46a03b35f5ed52b3$export$d0b21b213c8c013c)(opt) : (opt)=>opt;
        options.forEach((item)=>{
            // Group should check child options
            if (item[fieldOptions]) {
                // Check group first
                const matchGroup = filterFunc(searchValue, wrapOption(item));
                if (matchGroup) filteredOptions.push(item);
                else {
                    // Check option
                    const subOptions = item[fieldOptions].filter((subItem)=>filterFunc(searchValue, wrapOption(subItem)));
                    if (subOptions.length) filteredOptions.push({
                        ...item,
                        [fieldOptions]: subOptions
                    });
                }
                return;
            }
            if (filterFunc(searchValue, wrapOption(item))) filteredOptions.push(item);
        });
        return filteredOptions;
    }, [
        options,
        filterOption,
        optionFilterProp,
        searchValue,
        fieldNames
    ]);
};



var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");

function $ade78ab225210d9e$var$convertNodeToOption(node) {
    const { key: key, props: { children: children, value: value, ...restProps } } = node;
    return {
        key: key,
        value: value !== undefined ? value : key,
        children: children,
        ...restProps
    };
}
function $ade78ab225210d9e$export$3beca35db74c3985(nodes, optionOnly = false) {
    return (0, $cd966a313e0a92ff$export$2e2bcd8739ae039)(nodes).map((node, index)=>{
        if (!/*#__PURE__*/ $cQmXV.isValidElement(node) || !node.type) return null;
        const { type: { isSelectOptGroup: isSelectOptGroup }, key: key, props: { children: children, ...restProps } } = node;
        if (optionOnly || !isSelectOptGroup) return $ade78ab225210d9e$var$convertNodeToOption(node);
        return {
            key: `__RC_SELECT_GRP__${key === null ? index : key}__`,
            label: key,
            ...restProps,
            options: $ade78ab225210d9e$export$3beca35db74c3985(children)
        };
    }).filter((data)=>data);
}


/**
 * Parse `children` to `options` if `options` is not provided.
 * Then flatten the `options`.
 */ const $4dc87f94831e6a05$var$useOptions = (options, children, fieldNames, optionFilterProp, optionLabelProp)=>{
    return $cQmXV.useMemo(()=>{
        let mergedOptions = options;
        const childrenAsData = !options;
        if (childrenAsData) mergedOptions = (0, $ade78ab225210d9e$export$3beca35db74c3985)(children);
        const valueOptions = new Map();
        const labelOptions = new Map();
        const setLabelOptions = (labelOptionsMap, option, key)=>{
            if (key && typeof key === "string") labelOptionsMap.set(option[key], option);
        };
        const dig = (optionList, isChildren = false)=>{
            // for loop to speed up collection speed
            for(let i = 0; i < optionList.length; i += 1){
                const option = optionList[i];
                if (!option[fieldNames.options] || isChildren) {
                    valueOptions.set(option[fieldNames.value], option);
                    setLabelOptions(labelOptions, option, fieldNames.label);
                    // https://github.com/ant-design/ant-design/issues/35304
                    optionFilterProp.forEach((prop)=>{
                        setLabelOptions(labelOptions, option, prop);
                    });
                    setLabelOptions(labelOptions, option, optionLabelProp);
                } else dig(option[fieldNames.options], true);
            }
        };
        dig(mergedOptions);
        return {
            options: mergedOptions,
            valueOptions: valueOptions,
            labelOptions: labelOptions
        };
    }, [
        options,
        children,
        fieldNames,
        optionFilterProp,
        optionLabelProp
    ]);
};
var $4dc87f94831e6a05$export$2e2bcd8739ae039 = $4dc87f94831e6a05$var$useOptions;



var $cQmXV = parcelRequire("cQmXV");
function $45362202b6442635$export$2e2bcd8739ae039(callback) {
    const funcRef = $cQmXV.useRef(callback);
    funcRef.current = callback;
    const cacheFn = $cQmXV.useCallback((...args)=>{
        return funcRef.current(...args);
    }, []);
    return cacheFn;
}






var $cQmXV = parcelRequire("cQmXV");



function $9c821222718b50cf$var$warningProps(props) {
    const { mode: mode, options: options, children: children, backfill: backfill, allowClear: allowClear, placeholder: placeholder, getInputElement: getInputElement, showSearch: showSearch, onSearch: onSearch, defaultOpen: defaultOpen, autoFocus: autoFocus, labelInValue: labelInValue, value: value, optionLabelProp: optionLabelProp } = props;
    const multiple = (0, $5ac3fa1f5d4717fa$export$7f654ad2a77ad2ac)(mode);
    const mergedShowSearch = showSearch !== undefined ? showSearch : multiple || mode === "combobox";
    const mergedOptions = options || (0, $ade78ab225210d9e$export$3beca35db74c3985)(children);
    // `tags` should not set option as disabled
    (0, $26d7cf6379fe7659$export$2e2bcd8739ae039)(mode !== "tags" || mergedOptions.every((opt)=>!opt.disabled), "Please avoid setting option to disabled in tags mode since user can always type text as tag.");
    // `combobox` & `tags` should option be `string` type
    if (mode === "tags" || mode === "combobox") {
        const hasNumberValue = mergedOptions.some((item)=>{
            if (item.options) return item.options.some((opt)=>typeof ("value" in opt ? opt.value : opt.key) === "number");
            return typeof ("value" in item ? item.value : item.key) === "number";
        });
        (0, $26d7cf6379fe7659$export$2e2bcd8739ae039)(!hasNumberValue, "`value` of Option should not use number type when `mode` is `tags` or `combobox`.");
    }
    // `combobox` should not use `optionLabelProp`
    (0, $26d7cf6379fe7659$export$2e2bcd8739ae039)(mode !== "combobox" || !optionLabelProp, "`combobox` mode not support `optionLabelProp`. Please set `value` on Option directly.");
    // Only `combobox` support `backfill`
    (0, $26d7cf6379fe7659$export$2e2bcd8739ae039)(mode === "combobox" || !backfill, "`backfill` only works with `combobox` mode.");
    // Only `combobox` support `getInputElement`
    (0, $26d7cf6379fe7659$export$2e2bcd8739ae039)(mode === "combobox" || !getInputElement, "`getInputElement` only work with `combobox` mode.");
    // Customize `getInputElement` should not use `allowClear` & `placeholder`
    (0, $26d7cf6379fe7659$export$89ff31684837bbbf)(mode !== "combobox" || !getInputElement || !allowClear || !placeholder, "Customize `getInputElement` should customize clear and placeholder logic instead of configuring `allowClear` and `placeholder`.");
    // `onSearch` should use in `combobox` or `showSearch`
    if (onSearch && !mergedShowSearch && mode !== "combobox" && mode !== "tags") (0, $26d7cf6379fe7659$export$2e2bcd8739ae039)(false, "`onSearch` should work with `showSearch` instead of use alone.");
    (0, $26d7cf6379fe7659$export$89ff31684837bbbf)(!defaultOpen || autoFocus, "`defaultOpen` makes Select open without focus which means it will not close by click outside. You can set `autoFocus` if needed.");
    if (value !== undefined && value !== null) {
        const values = (0, $27094fd2b2012af1$export$45b10814cc054894)(value);
        (0, $26d7cf6379fe7659$export$2e2bcd8739ae039)(!labelInValue || values.every((val)=>typeof val === "object" && ("key" in val || "value" in val)), "`value` should in shape of `{ value: string | number, label?: ReactNode }` when you set `labelInValue` to `true`");
        (0, $26d7cf6379fe7659$export$2e2bcd8739ae039)(!multiple || Array.isArray(value), "`value` should be array when `mode` is `multiple` or `tags`");
    }
    // Syntactic sugar should use correct children type
    if (children) {
        let invalidateChildType = null;
        (0, $cd966a313e0a92ff$export$2e2bcd8739ae039)(children).some((node)=>{
            if (!/*#__PURE__*/ $cQmXV.isValidElement(node) || !node.type) return false;
            const { type: type } = node;
            if (type.isSelectOption) return false;
            if (type.isSelectOptGroup) {
                const allChildrenValid = (0, $cd966a313e0a92ff$export$2e2bcd8739ae039)(node.props.children).every((subNode)=>{
                    if (!/*#__PURE__*/ $cQmXV.isValidElement(subNode) || !node.type || subNode.type.isSelectOption) return true;
                    invalidateChildType = subNode.type;
                    return false;
                });
                if (allChildrenValid) return false;
                return true;
            }
            invalidateChildType = type;
            return true;
        });
        if (invalidateChildType) (0, $26d7cf6379fe7659$export$2e2bcd8739ae039)(false, `\`children\` should be \`Select.Option\` or \`Select.OptGroup\` instead of \`${invalidateChildType.displayName || invalidateChildType.name || invalidateChildType}\`.`);
    }
}
function $9c821222718b50cf$export$c33a1be4de1ec2c(options, fieldNames) {
    if (options) {
        const recursiveOptions = (optionsList, inGroup = false)=>{
            for(let i = 0; i < optionsList.length; i++){
                const option = optionsList[i];
                if (option[fieldNames?.value] === null) {
                    (0, $26d7cf6379fe7659$export$2e2bcd8739ae039)(false, "`value` in Select options should not be `null`.");
                    return true;
                }
                if (!inGroup && Array.isArray(option[fieldNames?.options]) && recursiveOptions(option[fieldNames?.options], true)) break;
            }
        };
        recursiveOptions(options);
    }
}
var $9c821222718b50cf$export$2e2bcd8739ae039 = $9c821222718b50cf$var$warningProps;



var $cQmXV = parcelRequire("cQmXV");
function $25b395787f28a654$export$2e2bcd8739ae039(showSearch, props, mode) {
    const { filterOption: filterOption, searchValue: searchValue, optionFilterProp: optionFilterProp, filterSort: filterSort, onSearch: onSearch, autoClearSearchValue: autoClearSearchValue } = props;
    return $cQmXV.useMemo(()=>{
        const isObject = typeof showSearch === "object";
        const searchConfig = {
            filterOption: filterOption,
            searchValue: searchValue,
            optionFilterProp: optionFilterProp,
            filterSort: filterSort,
            onSearch: onSearch,
            autoClearSearchValue: autoClearSearchValue,
            ...isObject ? showSearch : {}
        };
        return [
            isObject || mode === "combobox" || mode === "tags" || mode === "multiple" && showSearch === undefined ? true : showSearch,
            searchConfig
        ];
    }, [
        mode,
        showSearch,
        filterOption,
        searchValue,
        optionFilterProp,
        filterSort,
        onSearch,
        autoClearSearchValue
    ]);
}


function $d9ba107569c49cad$var$_extends() {
    $d9ba107569c49cad$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d9ba107569c49cad$var$_extends.apply(this, arguments);
}
const $d9ba107569c49cad$var$OMIT_DOM_PROPS = [
    "inputValue"
];
function $d9ba107569c49cad$var$isRawValue(value) {
    return !value || typeof value !== "object";
}
const $d9ba107569c49cad$var$Select = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { id: id, mode: mode, prefixCls: prefixCls = "rc-select", backfill: backfill, fieldNames: fieldNames, showSearch: // Search
    showSearch, searchValue: legacySearchValue, onSearch: legacyOnSearch, autoClearSearchValue: legacyAutoClearSearchValue, filterOption: legacyFilterOption, optionFilterProp: legacyOptionFilterProp, filterSort: legacyFilterSort, onSelect: // Select
    onSelect, onDeselect: onDeselect, onActive: onActive, popupMatchSelectWidth: popupMatchSelectWidth = true, optionLabelProp: optionLabelProp, options: options, optionRender: optionRender, children: children, defaultActiveFirstOption: defaultActiveFirstOption, menuItemSelectedIcon: menuItemSelectedIcon, virtual: virtual, direction: direction, listHeight: listHeight = 200, listItemHeight: listItemHeight = 20, labelRender: labelRender, value: // Value
    value, defaultValue: defaultValue, labelInValue: labelInValue, onChange: onChange, maxCount: maxCount, classNames: classNames, styles: styles, ...restProps } = props;
    const searchProps = {
        searchValue: legacySearchValue,
        onSearch: legacyOnSearch,
        autoClearSearchValue: legacyAutoClearSearchValue,
        filterOption: legacyFilterOption,
        optionFilterProp: legacyOptionFilterProp,
        filterSort: legacyFilterSort
    };
    const [mergedShowSearch, searchConfig] = (0, $25b395787f28a654$export$2e2bcd8739ae039)(showSearch, searchProps, mode);
    const { filterOption: filterOption, searchValue: searchValue, optionFilterProp: optionFilterProp, filterSort: filterSort, onSearch: onSearch, autoClearSearchValue: autoClearSearchValue = true } = searchConfig;
    const normalizedOptionFilterProp = $cQmXV.useMemo(()=>{
        if (!optionFilterProp) return [];
        return Array.isArray(optionFilterProp) ? optionFilterProp : [
            optionFilterProp
        ];
    }, [
        optionFilterProp
    ]);
    const mergedId = (0, $a2da91bb60e2cbfb$export$2e2bcd8739ae039)(id);
    const multiple = (0, $5ac3fa1f5d4717fa$export$7f654ad2a77ad2ac)(mode);
    const childrenAsData = !!(!options && children);
    const mergedFilterOption = $cQmXV.useMemo(()=>{
        if (filterOption === undefined && mode === "combobox") return false;
        return filterOption;
    }, [
        filterOption,
        mode
    ]);
    // ========================= FieldNames =========================
    const mergedFieldNames = $cQmXV.useMemo(()=>(0, $46a03b35f5ed52b3$export$6c519d302dced239)(fieldNames, childrenAsData), /* eslint-disable react-hooks/exhaustive-deps */ [
        // We stringify fieldNames to avoid unnecessary re-renders.
        JSON.stringify(fieldNames),
        childrenAsData
    ]);
    // =========================== Search ===========================
    const [internalSearchValue, setSearchValue] = (0, $a51866d781137e08$export$2e2bcd8739ae039)("", searchValue);
    const mergedSearchValue = internalSearchValue || "";
    // =========================== Option ===========================
    const parsedOptions = (0, $4dc87f94831e6a05$export$2e2bcd8739ae039)(options, children, mergedFieldNames, normalizedOptionFilterProp, optionLabelProp);
    const { valueOptions: valueOptions, labelOptions: labelOptions, options: mergedOptions } = parsedOptions;
    // ========================= Wrap Value =========================
    const convert2LabelValues = $cQmXV.useCallback((draftValues)=>{
        // Convert to array
        const valueList = (0, $27094fd2b2012af1$export$45b10814cc054894)(draftValues);
        // Convert to labelInValue type
        return valueList.map((val)=>{
            let rawValue;
            let rawLabel;
            let rawDisabled;
            let rawTitle;
            // Fill label & value
            if ($d9ba107569c49cad$var$isRawValue(val)) rawValue = val;
            else {
                rawLabel = val.label;
                rawValue = val.value;
            }
            const option = valueOptions.get(rawValue);
            if (option) {
                // Fill missing props
                if (rawLabel === undefined) rawLabel = option?.[optionLabelProp || mergedFieldNames.label];
                rawDisabled = option?.disabled;
                rawTitle = option?.title;
            }
            return {
                label: rawLabel,
                value: rawValue,
                key: rawValue,
                disabled: rawDisabled,
                title: rawTitle
            };
        });
    }, [
        mergedFieldNames,
        optionLabelProp,
        valueOptions
    ]);
    // =========================== Values ===========================
    const [internalValue, setInternalValue] = (0, $a51866d781137e08$export$2e2bcd8739ae039)(defaultValue, value);
    // Merged value with LabelValueType
    const rawLabeledValues = $cQmXV.useMemo(()=>{
        const newInternalValue = multiple && internalValue === null ? [] : internalValue;
        const values = convert2LabelValues(newInternalValue);
        // combobox no need save value when it's no value (exclude value equal 0)
        if (mode === "combobox" && (0, $27094fd2b2012af1$export$9d186c3672bb89c6)(values[0]?.value)) return [];
        return values;
    }, [
        internalValue,
        convert2LabelValues,
        mode,
        multiple
    ]);
    // Fill label with cache to avoid option remove
    const [mergedValues, getMixedOption] = (0, $92ead185de6a3886$export$2e2bcd8739ae039)(rawLabeledValues, valueOptions);
    const displayValues = $cQmXV.useMemo(()=>{
        // `null` need show as placeholder instead
        // https://github.com/ant-design/ant-design/issues/25057
        if (!mode && mergedValues.length === 1) {
            const firstValue = mergedValues[0];
            if (firstValue.value === null && (firstValue.label === null || firstValue.label === undefined)) return [];
        }
        return mergedValues.map((item)=>({
                ...item,
                label: (typeof labelRender === "function" ? labelRender(item) : item.label) ?? item.value
            }));
    }, [
        mode,
        mergedValues,
        labelRender
    ]);
    /** Convert `displayValues` to raw value type set */ const rawValues = $cQmXV.useMemo(()=>new Set(mergedValues.map((val)=>val.value)), [
        mergedValues
    ]);
    $cQmXV.useEffect(()=>{
        if (mode === "combobox") {
            const strValue = mergedValues[0]?.value;
            setSearchValue((0, $27094fd2b2012af1$export$96bdbc84526f3739)(strValue) ? String(strValue) : "");
        }
    }, [
        mergedValues
    ]);
    // ======================= Display Option =======================
    // Create a placeholder item if not exist in `options`
    const createTagOption = (0, $45362202b6442635$export$2e2bcd8739ae039)((val, label)=>{
        const mergedLabel = label ?? val;
        return {
            [mergedFieldNames.value]: val,
            [mergedFieldNames.label]: mergedLabel
        };
    });
    // Fill tag as option if mode is `tags`
    const filledTagOptions = $cQmXV.useMemo(()=>{
        if (mode !== "tags") return mergedOptions;
        // >>> Tag mode
        const cloneOptions = [
            ...mergedOptions
        ];
        // Check if value exist in options (include new patch item)
        const existOptions = (val)=>valueOptions.has(val);
        // Fill current value as option
        [
            ...mergedValues
        ].sort((a, b)=>a.value < b.value ? -1 : 1).forEach((item)=>{
            const val = item.value;
            if (!existOptions(val)) cloneOptions.push(createTagOption(val, item.label));
        });
        return cloneOptions;
    }, [
        createTagOption,
        mergedOptions,
        valueOptions,
        mergedValues,
        mode
    ]);
    const filteredOptions = (0, $c8ee3e574f8b5e46$export$2e2bcd8739ae039)(filledTagOptions, mergedFieldNames, mergedSearchValue, mergedFilterOption, normalizedOptionFilterProp);
    // Fill options with search value if needed
    const filledSearchOptions = $cQmXV.useMemo(()=>{
        const hasItemMatchingSearch = (item)=>{
            if (normalizedOptionFilterProp.length) return normalizedOptionFilterProp.some((prop)=>item?.[prop] === mergedSearchValue);
            return item?.value === mergedSearchValue;
        };
        if (mode !== "tags" || !mergedSearchValue || filteredOptions.some((item)=>hasItemMatchingSearch(item))) return filteredOptions;
        // ignore when search value equal select input value
        if (filteredOptions.some((item)=>item[mergedFieldNames.value] === mergedSearchValue)) return filteredOptions;
        // Skip creating temp tag option if it matches a disabled option value
        if (valueOptions.get(mergedSearchValue)?.disabled) return filteredOptions;
        // Fill search value as option
        return [
            createTagOption(mergedSearchValue),
            ...filteredOptions
        ];
    }, [
        createTagOption,
        normalizedOptionFilterProp,
        mode,
        filteredOptions,
        mergedSearchValue,
        mergedFieldNames,
        valueOptions
    ]);
    const sorter = (inputOptions)=>{
        const sortedOptions = [
            ...inputOptions
        ].sort((a, b)=>filterSort(a, b, {
                searchValue: mergedSearchValue
            }));
        return sortedOptions.map((item)=>{
            if (Array.isArray(item.options)) return {
                ...item,
                options: item.options.length > 0 ? sorter(item.options) : item.options
            };
            return item;
        });
    };
    const orderedFilteredOptions = $cQmXV.useMemo(()=>{
        if (!filterSort) return filledSearchOptions;
        return sorter(filledSearchOptions);
    }, [
        filledSearchOptions,
        filterSort,
        mergedSearchValue
    ]);
    const displayOptions = $cQmXV.useMemo(()=>(0, $46a03b35f5ed52b3$export$7baa7c13b358b002)(orderedFilteredOptions, {
            fieldNames: mergedFieldNames,
            childrenAsData: childrenAsData
        }), [
        orderedFilteredOptions,
        mergedFieldNames,
        childrenAsData
    ]);
    // =========================== Change ===========================
    const triggerChange = (values)=>{
        const labeledValues = convert2LabelValues(values);
        setInternalValue(labeledValues);
        if (onChange && // Trigger event only when value changed
        (labeledValues.length !== mergedValues.length || labeledValues.some((newVal, index)=>mergedValues[index]?.value !== newVal?.value))) {
            const returnValues = labelInValue ? labeledValues.map(({ label: l, value: v })=>({
                    label: l,
                    value: v
                })) : labeledValues.map((v)=>v.value);
            const returnOptions = labeledValues.map((v)=>(0, $46a03b35f5ed52b3$export$d0b21b213c8c013c)(getMixedOption(v.value)));
            onChange(// Value
            multiple ? returnValues : returnValues[0], // Option
            multiple ? returnOptions : returnOptions[0]);
        }
    };
    // ======================= Accessibility ========================
    const [activeValue, setActiveValue] = $cQmXV.useState(null);
    const [accessibilityIndex, setAccessibilityIndex] = $cQmXV.useState(0);
    const mergedDefaultActiveFirstOption = defaultActiveFirstOption !== undefined ? defaultActiveFirstOption : mode !== "combobox";
    const activeEventRef = $cQmXV.useRef(undefined);
    const onActiveValue = $cQmXV.useCallback((active, index, { source: source = "keyboard" } = {})=>{
        setAccessibilityIndex(index);
        if (backfill && mode === "combobox" && active !== null && source === "keyboard") setActiveValue(String(active));
        // Active will call multiple times.
        // We only need trigger the last one.
        const promise = Promise.resolve().then(()=>{
            if (activeEventRef.current === promise) onActive?.(active);
        });
        activeEventRef.current = promise;
    }, [
        backfill,
        mode,
        onActive
    ]);
    // ========================= OptionList =========================
    const triggerSelect = (val, selected, type)=>{
        const getSelectEnt = ()=>{
            const option = getMixedOption(val);
            return [
                labelInValue ? {
                    label: option?.[mergedFieldNames.label],
                    value: val
                } : val,
                (0, $46a03b35f5ed52b3$export$d0b21b213c8c013c)(option)
            ];
        };
        if (selected && onSelect) {
            const [wrappedValue, option] = getSelectEnt();
            onSelect(wrappedValue, option);
        } else if (!selected && onDeselect && type !== "clear") {
            const [wrappedValue, option] = getSelectEnt();
            onDeselect(wrappedValue, option);
        }
    };
    // Used for OptionList selection
    const onInternalSelect = (0, $45362202b6442635$export$2e2bcd8739ae039)((val, info)=>{
        let cloneValues;
        // Single mode always trigger select only with option list
        const mergedSelect = multiple ? info.selected : true;
        if (mergedSelect) cloneValues = multiple ? [
            ...mergedValues,
            val
        ] : [
            val
        ];
        else cloneValues = mergedValues.filter((v)=>v.value !== val);
        triggerChange(cloneValues);
        triggerSelect(val, mergedSelect);
        // Clean search value if single or configured
        if (mode === "combobox") setActiveValue("");
        else if (!(0, $5ac3fa1f5d4717fa$export$7f654ad2a77ad2ac) || autoClearSearchValue) {
            setSearchValue("");
            setActiveValue("");
        }
    });
    // ======================= Display Change =======================
    // BaseSelect display values change
    const onDisplayValuesChange = (nextValues, info)=>{
        triggerChange(nextValues);
        const { type: type, values: values } = info;
        if (type === "remove" || type === "clear") values.forEach((item)=>{
            triggerSelect(item.value, false, type);
        });
    };
    // =========================== Search ===========================
    const onInternalSearch = (searchText, info)=>{
        setSearchValue(searchText);
        setActiveValue(null);
        // [Submit] Tag mode should flush input
        if (info.source === "submit") {
            const formatted = (searchText || "").trim();
            // prevent empty tags from appearing when you click the Enter button
            if (formatted) {
                // Skip disabled options in tags mode
                if (valueOptions.get(formatted)?.disabled) {
                    setSearchValue("");
                    return;
                }
                const newRawValues = Array.from(new Set([
                    ...rawValues,
                    formatted
                ]));
                triggerChange(newRawValues);
                triggerSelect(formatted, true);
                setSearchValue("");
            }
            return;
        }
        if (info.source !== "blur") {
            if (mode === "combobox") triggerChange(searchText);
            onSearch?.(searchText);
        }
    };
    const onInternalSearchSplit = (words)=>{
        let patchValues = words;
        if (mode !== "tags") patchValues = words.map((word)=>{
            const opt = labelOptions.get(word);
            return opt?.value;
        }).filter((val)=>val !== undefined);
        // Filter out disabled option values in tags mode
        if (mode === "tags") patchValues = patchValues.filter((val)=>!valueOptions.get(val)?.disabled);
        const newRawValues = Array.from(new Set([
            ...rawValues,
            ...patchValues
        ]));
        triggerChange(newRawValues);
        newRawValues.forEach((newRawValue)=>{
            triggerSelect(newRawValue, true);
        });
    };
    // ========================== Context ===========================
    const selectContext = $cQmXV.useMemo(()=>{
        const realVirtual = virtual !== false && popupMatchSelectWidth !== false;
        return {
            ...parsedOptions,
            flattenOptions: displayOptions,
            onActiveValue: onActiveValue,
            defaultActiveFirstOption: mergedDefaultActiveFirstOption,
            onSelect: onInternalSelect,
            menuItemSelectedIcon: menuItemSelectedIcon,
            rawValues: rawValues,
            fieldNames: mergedFieldNames,
            virtual: realVirtual,
            direction: direction,
            listHeight: listHeight,
            listItemHeight: listItemHeight,
            childrenAsData: childrenAsData,
            maxCount: maxCount,
            optionRender: optionRender,
            classNames: classNames,
            styles: styles
        };
    }, [
        maxCount,
        parsedOptions,
        displayOptions,
        onActiveValue,
        mergedDefaultActiveFirstOption,
        onInternalSelect,
        menuItemSelectedIcon,
        rawValues,
        mergedFieldNames,
        virtual,
        popupMatchSelectWidth,
        direction,
        listHeight,
        listItemHeight,
        childrenAsData,
        optionRender,
        classNames,
        styles
    ]);
    // ==============================================================
    // ==                          Render                          ==
    // ==============================================================
    return /*#__PURE__*/ $cQmXV.createElement((0, $8b26feb71ab0689b$export$2e2bcd8739ae039).Provider, {
        value: selectContext
    }, /*#__PURE__*/ $cQmXV.createElement((0, $5ac3fa1f5d4717fa$export$2e2bcd8739ae039), $d9ba107569c49cad$var$_extends({}, restProps, {
        // >>> MISC
        id: mergedId,
        prefixCls: prefixCls,
        ref: ref,
        omitDomProps: $d9ba107569c49cad$var$OMIT_DOM_PROPS,
        mode: mode,
        classNames: classNames,
        styles: styles,
        displayValues: displayValues,
        onDisplayValuesChange: onDisplayValuesChange,
        maxCount: maxCount,
        direction: direction,
        showSearch: mergedShowSearch,
        searchValue: mergedSearchValue,
        onSearch: onInternalSearch,
        autoClearSearchValue: autoClearSearchValue,
        onSearchSplit: onInternalSearchSplit,
        popupMatchSelectWidth: popupMatchSelectWidth,
        OptionList: (0, $92f5fee8c45009b6$export$2e2bcd8739ae039),
        emptyOptions: !displayOptions.length,
        activeValue: activeValue,
        activeDescendantId: `${mergedId}_list_${accessibilityIndex}`
    })));
});
const $d9ba107569c49cad$var$TypedSelect = $d9ba107569c49cad$var$Select;
$d9ba107569c49cad$var$TypedSelect.Option = (0, $e2be968a818eff80$export$2e2bcd8739ae039);
$d9ba107569c49cad$var$TypedSelect.OptGroup = (0, $a77affc9f9453370$export$2e2bcd8739ae039);
var $d9ba107569c49cad$export$2e2bcd8739ae039 = $d9ba107569c49cad$var$TypedSelect;






var $069c1790c3865d68$export$2e2bcd8739ae039 = (0, $d9ba107569c49cad$export$2e2bcd8739ae039);







const $ccaf7339afd5c582$var$normalizeIcon = (value, key, fallback)=>{
    if (value === false) return null; // Explicitly return null when value is false
    if (value === true) return fallback; // Return fallback when value is true
    // More explicit if statement, avoiding inline if
    if (value && key && value[key] !== undefined) return value[key]; // Return value[key] if it's explicitly defined
    return fallback; // Return fallback when no value is found
};
var $ccaf7339afd5c582$export$2e2bcd8739ae039 = $ccaf7339afd5c582$var$normalizeIcon;















const $02b6d2f2bde71f39$var$getBuiltInPlacements = (popupOverflow)=>{
    const htmlRegion = popupOverflow === "scroll" ? "scroll" : "visible";
    const sharedConfig = {
        overflow: {
            adjustX: true,
            adjustY: true,
            shiftY: true
        },
        htmlRegion: htmlRegion,
        dynamicInset: true
    };
    return {
        bottomLeft: {
            ...sharedConfig,
            points: [
                "tl",
                "bl"
            ],
            offset: [
                0,
                4
            ]
        },
        bottomRight: {
            ...sharedConfig,
            points: [
                "tr",
                "br"
            ],
            offset: [
                0,
                4
            ]
        },
        topLeft: {
            ...sharedConfig,
            points: [
                "bl",
                "tl"
            ],
            offset: [
                0,
                -4
            ]
        },
        topRight: {
            ...sharedConfig,
            points: [
                "br",
                "tr"
            ],
            offset: [
                0,
                -4
            ]
        }
    };
};
function $02b6d2f2bde71f39$var$mergedBuiltinPlacements(buildInPlacements, popupOverflow) {
    return buildInPlacements || $02b6d2f2bde71f39$var$getBuiltInPlacements(popupOverflow);
}
var $02b6d2f2bde71f39$export$2e2bcd8739ae039 = $02b6d2f2bde71f39$var$mergedBuiltinPlacements;







const $34c68a181bd101cb$var$genItemStyle = (token)=>{
    const { optionHeight: optionHeight, optionFontSize: optionFontSize, optionLineHeight: optionLineHeight, optionPadding: optionPadding } = token;
    return {
        position: "relative",
        display: "block",
        minHeight: optionHeight,
        padding: optionPadding,
        color: token.colorText,
        fontWeight: "normal",
        fontSize: optionFontSize,
        lineHeight: optionLineHeight,
        boxSizing: "border-box"
    };
};
const $34c68a181bd101cb$var$genSingleStyle = (token)=>{
    const { antCls: antCls, componentCls: componentCls } = token;
    const selectItemCls = `${componentCls}-item`;
    const slideUpEnterActive = `&${antCls}-slide-up-enter${antCls}-slide-up-enter-active`;
    const slideUpAppearActive = `&${antCls}-slide-up-appear${antCls}-slide-up-appear-active`;
    const slideUpLeaveActive = `&${antCls}-slide-up-leave${antCls}-slide-up-leave-active`;
    const dropdownPlacementCls = `${componentCls}-dropdown-placement-`;
    const selectedItemCls = `${selectItemCls}-option-selected`;
    return [
        {
            [`${componentCls}-dropdown`]: {
                // ========================== Popup ==========================
                ...(0, $519d20bf207ce864$export$23997c3e44cc1c59)(token),
                position: "absolute",
                top: -9999,
                zIndex: token.zIndexPopup,
                boxSizing: "border-box",
                padding: token.paddingXXS,
                overflow: "hidden",
                fontSize: token.fontSize,
                // Fix select render lag of long text in chrome
                // https://github.com/ant-design/ant-design/issues/11456
                // https://github.com/ant-design/ant-design/issues/11843
                fontVariant: "initial",
                backgroundColor: token.colorBgElevated,
                borderRadius: token.borderRadiusLG,
                outline: "none",
                boxShadow: token.boxShadowSecondary,
                [`
          ${slideUpEnterActive}${dropdownPlacementCls}bottomLeft,
          ${slideUpAppearActive}${dropdownPlacementCls}bottomLeft
        `]: {
                    animationName: (0, $ff153a7980a78f00$export$e801b802b037de6a)
                },
                [`
          ${slideUpEnterActive}${dropdownPlacementCls}topLeft,
          ${slideUpAppearActive}${dropdownPlacementCls}topLeft,
          ${slideUpEnterActive}${dropdownPlacementCls}topRight,
          ${slideUpAppearActive}${dropdownPlacementCls}topRight
        `]: {
                    animationName: (0, $ff153a7980a78f00$export$dd9f089fa5e819fe)
                },
                [`${slideUpLeaveActive}${dropdownPlacementCls}bottomLeft`]: {
                    animationName: (0, $ff153a7980a78f00$export$f40f41df328ebc38)
                },
                [`
          ${slideUpLeaveActive}${dropdownPlacementCls}topLeft,
          ${slideUpLeaveActive}${dropdownPlacementCls}topRight
        `]: {
                    animationName: (0, $ff153a7980a78f00$export$f7243fdb9c27c3b7)
                },
                "&-hidden": {
                    display: "none"
                },
                [`${componentCls}-dropdown-list-scrollbar`]: {
                    cursor: "pointer",
                    "&:hover": {
                        backgroundColor: token.colorFillQuaternary
                    }
                },
                [selectItemCls]: {
                    ...$34c68a181bd101cb$var$genItemStyle(token),
                    cursor: "pointer",
                    transition: `background-color ${token.motionDurationSlow} ease`,
                    borderRadius: token.borderRadiusSM,
                    // =========== Group ============
                    "&-group": {
                        color: token.colorTextDescription,
                        fontSize: token.fontSizeSM,
                        cursor: "default"
                    },
                    // =========== Option ===========
                    "&-option": {
                        display: "flex",
                        "&-content": {
                            flex: "auto",
                            ...(0, $519d20bf207ce864$export$b2b65df0d0824629)
                        },
                        "&-state": {
                            flex: "none",
                            display: "flex",
                            alignItems: "center"
                        },
                        [`&-selected:not(${selectItemCls}-option-disabled)`]: {
                            color: token.optionSelectedColor,
                            fontWeight: token.optionSelectedFontWeight,
                            backgroundColor: token.optionSelectedBg,
                            [`${selectItemCls}-option-state`]: {
                                color: token.colorPrimary
                            }
                        },
                        [`&-active:not(${selectItemCls}-option-disabled)`]: {
                            backgroundColor: token.optionActiveBg
                        },
                        [`&-selected${selectItemCls}-option-active:not(${selectItemCls}-option-disabled)`]: {
                            backgroundColor: token.controlItemBgActiveHover
                        },
                        "&-disabled": {
                            [`&${selectItemCls}-option-selected`]: {
                                backgroundColor: token.colorBgContainerDisabled
                            },
                            color: token.colorTextDisabled,
                            cursor: "not-allowed"
                        },
                        "&-grouped": {
                            paddingInlineStart: token.calc(token.controlPaddingHorizontal).mul(2).equal()
                        }
                    },
                    "&-empty": {
                        ...$34c68a181bd101cb$var$genItemStyle(token),
                        color: token.colorTextDisabled
                    }
                },
                // https://github.com/ant-design/ant-design/pull/46646
                [`${selectedItemCls}:has(+ ${selectedItemCls})`]: {
                    borderEndStartRadius: 0,
                    borderEndEndRadius: 0,
                    [`& + ${selectedItemCls}`]: {
                        borderStartStartRadius: 0,
                        borderStartEndRadius: 0
                    }
                },
                // =========================== RTL ===========================
                "&-rtl": {
                    direction: "rtl"
                }
            }
        },
        // Follow code may reuse in other components
        (0, $ff153a7980a78f00$export$9018e60daecf7a6c)(token, "slide-up"),
        (0, $ff153a7980a78f00$export$9018e60daecf7a6c)(token, "slide-down"),
        (0, $23de50b91f818ff9$export$913b1b7e3288c319)(token, "move-up"),
        (0, $23de50b91f818ff9$export$913b1b7e3288c319)(token, "move-down")
    ];
};
var $34c68a181bd101cb$export$2e2bcd8739ae039 = $34c68a181bd101cb$var$genSingleStyle;





const $ef64af83665c0ccf$var$genSelectInputCustomizeStyle = (token)=>{
    const { antCls: antCls, componentCls: componentCls } = token;
    const transparentBackground = {
        background: "transparent"
    };
    const disabledCustomizedInputSelector = [
        "> input[disabled]",
        "> textarea[disabled]",
        `> ${componentCls}-input`,
        `> ${antCls}-input-affix-wrapper-disabled`,
        `> ${antCls}-input-search`
    ].join(", ");
    return {
        [`&${componentCls}-customize`]: {
            border: 0,
            padding: 0,
            fontSize: "inherit",
            lineHeight: "inherit",
            [`${componentCls}-placeholder`]: {
                display: "none"
            },
            [`${componentCls}-content`]: {
                margin: 0,
                padding: 0,
                "&-value": {
                    display: "none"
                }
            },
            [`&${componentCls}-filled ${componentCls}-content`]: {
                [`${antCls}-input-filled`]: transparentBackground
            },
            [`&${componentCls}-disabled ${componentCls}-content`]: {
                [disabledCustomizedInputSelector]: transparentBackground,
                "input[disabled], textarea[disabled]": transparentBackground
            }
        }
    };
};
var $ef64af83665c0ccf$export$2e2bcd8739ae039 = $ef64af83665c0ccf$var$genSelectInputCustomizeStyle;




const $61f50474a6a64735$var$FIXED_INPUT_MIN_WIDTH = 4;
const $61f50474a6a64735$var$genSelectInputMultipleStyle = (token)=>{
    const { componentCls: componentCls, calc: calc, iconCls: iconCls, paddingXS: paddingXS, paddingXXS: paddingXXS, INTERNAL_FIXED_ITEM_MARGIN: INTERNAL_FIXED_ITEM_MARGIN, lineWidth: lineWidth, lineType: lineType, colorIcon: colorIcon, colorIconHover: colorIconHover, inputPaddingHorizontalBase: inputPaddingHorizontalBase, antCls: antCls } = token;
    const [varName, varRef] = (0, $6870d4d7c14ae0bb$export$d82b8f66c5649e14)(antCls, "select");
    return {
        "&-multiple": {
            [varName("multi-item-background")]: token.multipleItemBg,
            [varName("multi-item-border-color")]: "transparent",
            [varName("multi-item-border-radius")]: token.borderRadiusSM,
            [varName("multi-item-height")]: token.multipleItemHeight,
            [varName("multi-padding-base")]: `calc((${varRef("height")} - ${varRef("multi-item-height")}) / 2)`,
            [varName("multi-padding-vertical")]: `calc(${varRef("multi-padding-base")} - ${INTERNAL_FIXED_ITEM_MARGIN} - ${lineWidth})`,
            [varName("multi-item-padding-horizontal")]: `calc(${inputPaddingHorizontalBase} - ${varRef("multi-padding-vertical")} - ${lineWidth} * 2)`,
            // ========================================================
            // ==                        Base                        ==
            // ========================================================
            // ========================= Root =========================
            paddingBlock: varRef("multi-padding-vertical"),
            paddingInlineStart: `calc(${varRef("multi-padding-base")} - ${lineWidth})`,
            // ======================== Prefix ========================
            [`${componentCls}-prefix`]: {
                marginInlineStart: varRef("multi-item-padding-horizontal")
            },
            [`${componentCls}-prefix + ${componentCls}-content`]: {
                [`${componentCls}-placeholder`]: {
                    insetInlineStart: 0
                },
                [`${componentCls}-content-item${componentCls}-content-item-suffix`]: {
                    marginInlineStart: 0
                }
            },
            // ===================== Placeholder ======================
            [`${componentCls}-placeholder`]: {
                position: "absolute",
                lineHeight: varRef("line-height"),
                insetInlineStart: varRef("multi-item-padding-horizontal"),
                width: `calc(100% - ${varRef("multi-item-padding-horizontal")})`,
                top: "50%",
                transform: "translateY(-50%)"
            },
            // ======================= Content ========================
            [`${componentCls}-content`]: {
                flexWrap: "wrap",
                alignItems: "center",
                lineHeight: 1,
                "&-item-prefix": {
                    height: varRef("font-size")
                },
                "&-item": {
                    lineHeight: 1,
                    maxWidth: `calc(100% - ${$61f50474a6a64735$var$FIXED_INPUT_MIN_WIDTH}px)`
                },
                [`${componentCls}-content-item-prefix + ${componentCls}-content-item-suffix,
          ${componentCls}-content-item-suffix:first-child`]: {
                    marginInlineStart: varRef("multi-item-padding-horizontal")
                },
                [`${componentCls}-selection-item`]: {
                    lineHeight: `calc(${varRef("multi-item-height")} - ${lineWidth} * 2)`,
                    border: `${lineWidth} ${lineType} ${varRef("multi-item-border-color")}`,
                    display: "flex",
                    marginBlock: INTERNAL_FIXED_ITEM_MARGIN,
                    marginInlineEnd: calc(INTERNAL_FIXED_ITEM_MARGIN).mul(2).equal(),
                    background: varRef("multi-item-background"),
                    borderRadius: varRef("multi-item-border-radius"),
                    paddingInlineStart: paddingXS,
                    paddingInlineEnd: paddingXXS,
                    transition: [
                        "height",
                        "line-height",
                        "padding"
                    ].map((key)=>`${key} ${token.motionDurationSlow}`).join(","),
                    // >>> Content
                    "&-content": {
                        ...(0, $519d20bf207ce864$export$b2b65df0d0824629),
                        marginInlineEnd: paddingXXS
                    },
                    // >>> Remove
                    "&-remove": {
                        ...(0, $519d20bf207ce864$export$171ccda7bc085e59)(),
                        display: "inline-flex",
                        alignItems: "center",
                        color: colorIcon,
                        fontWeight: "bold",
                        fontSize: 10,
                        lineHeight: "inherit",
                        cursor: "pointer",
                        [`> ${iconCls}`]: {
                            verticalAlign: "-0.2em"
                        },
                        "&:hover": {
                            color: colorIconHover
                        }
                    }
                },
                [`${componentCls}-input`]: {
                    lineHeight: calc(INTERNAL_FIXED_ITEM_MARGIN).mul(2).add(varRef("multi-item-height")).equal(),
                    width: `calc(var(--select-input-width, 0) * 1px)`,
                    minWidth: $61f50474a6a64735$var$FIXED_INPUT_MIN_WIDTH,
                    maxWidth: "100%",
                    transition: `line-height ${token.motionDurationSlow}`
                }
            },
            // ========================================================
            // ==                        Size                        ==
            // ========================================================
            [`&${componentCls}-sm`]: {
                [varName("multi-item-height")]: token.multipleItemHeightSM,
                [varName("multi-item-border-radius")]: token.borderRadiusXS
            },
            [`&${componentCls}-lg`]: {
                [varName("multi-item-height")]: token.multipleItemHeightLG,
                [varName("multi-item-border-radius")]: token.borderRadius
            },
            // ========================================================
            // ==                      Variants                      ==
            // ========================================================
            [`&${componentCls}-filled`]: {
                [varName("multi-item-border-color")]: token.colorSplit,
                [varName("multi-item-background")]: token.colorBgContainer,
                [`&${componentCls}-disabled`]: {
                    [varName("multi-item-border-color")]: "transparent"
                }
            }
        }
    };
};
var $61f50474a6a64735$export$2e2bcd8739ae039 = $61f50474a6a64735$var$genSelectInputMultipleStyle;


/** Set CSS variables and hover/focus styles for a Select input based on provided colors. */ const $590d12bd35aab779$var$genSelectInputVariableStyle = (token, colors)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    const [varName] = (0, $6870d4d7c14ae0bb$export$d82b8f66c5649e14)(antCls, "select");
    const { border: border, borderHover: borderHover, borderActive: borderActive, borderOutline: borderOutline } = colors;
    const baseBG = colors.background || token.selectorBg || token.colorBgContainer;
    return {
        [varName("border-color")]: border,
        [varName("background-color")]: baseBG,
        [varName("affix-color")]: colors.affixColor,
        [`&:not(${componentCls}-disabled)`]: {
            "&:hover": {
                [varName("border-color")]: borderHover,
                [varName("background-color")]: colors.backgroundHover || baseBG
            },
            [`&${componentCls}-focused`]: {
                [varName("border-color")]: borderActive,
                [varName("background-color")]: colors.backgroundActive || baseBG,
                boxShadow: `0 0 0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.controlOutlineWidth)} ${borderOutline}`
            }
        },
        [`&${componentCls}-disabled`]: {
            [varName("border-color")]: colors.borderDisabled || colors.border,
            [varName("background-color")]: colors.backgroundDisabled || colors.background
        }
    };
};
/** Generate variant-scoped variable styles and status overrides for a Select input */ const $590d12bd35aab779$var$genSelectInputVariantStyle = (token, variant, colors, errorColors, warningColors, patchStyle)=>{
    const { componentCls: componentCls } = token;
    return {
        [`&${componentCls}-${variant}`]: [
            $590d12bd35aab779$var$genSelectInputVariableStyle(token, colors),
            {
                [`&${componentCls}-status-error`]: $590d12bd35aab779$var$genSelectInputVariableStyle(token, {
                    ...colors,
                    ...errorColors
                }),
                [`&${componentCls}-status-warning`]: $590d12bd35aab779$var$genSelectInputVariableStyle(token, {
                    ...colors,
                    ...warningColors
                })
            },
            patchStyle
        ]
    };
};
const $590d12bd35aab779$var$genSelectInputFocusVisibleStyle = (token, outlineColor)=>({
        outline: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidthFocus)} ${token.lineType} ${outlineColor}`,
        outlineOffset: (0, $05f34ed03d41967d$export$523c0b569236b342)(token.calc(token.lineWidth).mul(-1).equal()),
        transition: [
            `outline-offset`,
            `outline`
        ].map((prop)=>`${prop} 0s`).join(", ")
    });
const $590d12bd35aab779$var$genSelectInputStyle = (token)=>{
    const { componentCls: componentCls, fontHeight: fontHeight, controlHeight: controlHeight, fontSizeIcon: fontSizeIcon, showArrowPaddingInlineEnd: showArrowPaddingInlineEnd, iconCls: iconCls, antCls: antCls, max: max, calc: calc } = token;
    const [varName, varRef] = (0, $6870d4d7c14ae0bb$export$d82b8f66c5649e14)(antCls, "select");
    const contentMarginInlineEnd = max(calc(showArrowPaddingInlineEnd).sub(fontSizeIcon).equal(), 0);
    return {
        [componentCls]: [
            {
                // Border
                [varName("border-radius")]: token.borderRadius,
                [varName("border-color")]: "#000",
                [varName("border-size")]: token.lineWidth,
                // Background
                [varName("background-color")]: token.colorBgContainer,
                // Font
                [varName("font-size")]: token.fontSize,
                [varName("line-height")]: token.lineHeight,
                [varName("font-height")]: fontHeight,
                [varName("color")]: token.colorText,
                [varName("affix-color")]: token.colorText,
                // Size
                [varName("height")]: controlHeight,
                [varName("padding-horizontal")]: calc(token.paddingSM).sub(token.lineWidth).equal(),
                [varName("padding-vertical")]: `calc((${varRef("height")} - ${varRef("font-height")}) / 2 - ${varRef("border-size")})`,
                // ==========================================================
                // ==                         Base                         ==
                // ==========================================================
                ...(0, $519d20bf207ce864$export$23997c3e44cc1c59)(token),
                display: "inline-flex",
                // gap: calc(token.paddingXXS).mul(1.5).equal(),
                flexWrap: "nowrap",
                position: "relative",
                transition: `all ${token.motionDurationSlow}`,
                alignItems: "flex-start",
                outline: 0,
                cursor: "pointer",
                // Border
                borderRadius: varRef("border-radius"),
                borderWidth: varRef("border-size"),
                borderStyle: token.lineType,
                borderColor: varRef("border-color"),
                // Background
                background: varRef("background-color"),
                // Font
                fontSize: varRef("font-size"),
                lineHeight: varRef("line-height"),
                color: varRef("color"),
                // Padding
                paddingInline: varRef("padding-horizontal"),
                paddingBlock: varRef("padding-vertical"),
                // ========================= Prefix =========================
                [`${componentCls}-prefix`]: {
                    color: varRef("affix-color"),
                    flex: "none",
                    lineHeight: 1
                },
                // ====================== Placeholder =======================
                [`${componentCls}-placeholder`]: {
                    ...(0, $519d20bf207ce864$export$b2b65df0d0824629),
                    color: token.colorTextPlaceholder,
                    pointerEvents: "none",
                    zIndex: 1
                },
                // ======================== Content =========================
                [`${componentCls}-content`]: {
                    flex: "auto",
                    minWidth: 0,
                    position: "relative",
                    display: "flex",
                    marginInlineEnd: contentMarginInlineEnd,
                    "&:before": {
                        content: '"\\a0"',
                        width: 0,
                        overflow: "hidden"
                    },
                    // >>> Value
                    "&-value": {
                        visibility: "inherit"
                    },
                    // >>> Input: should only take effect for not customize mode
                    // input element with readOnly use cursor pointer
                    "input[readonly]": {
                        cursor: "inherit",
                        caretColor: "transparent"
                    }
                },
                // ========================= Suffix =========================
                [`${componentCls}-suffix`]: {
                    flex: "none",
                    color: token.colorTextQuaternary,
                    fontSize: token.fontSizeIcon,
                    lineHeight: 1,
                    transition: [
                        "opacity",
                        "color"
                    ].map((prop)=>`${prop} ${token.motionDurationMid} ease`).join(", "),
                    "> :not(:last-child)": {
                        marginInlineEnd: token.marginXS
                    }
                },
                [`${componentCls}-prefix, ${componentCls}-suffix`]: {
                    alignSelf: "center",
                    [iconCls]: {
                        verticalAlign: "top"
                    }
                },
                // ==========================================================
                // ==                       Disabled                       ==
                // ==========================================================
                "&-disabled": {
                    background: token.colorBgContainerDisabled,
                    [varName("color")]: token.colorTextDisabled,
                    cursor: "not-allowed",
                    input: {
                        cursor: "not-allowed"
                    }
                },
                // ==========================================================
                // ==                         Size                         ==
                // ==========================================================
                "&-sm": {
                    [varName("height")]: token.controlHeightSM,
                    [varName("padding-horizontal")]: calc(token.paddingXS).sub(token.lineWidth).equal(),
                    [varName("border-radius")]: token.borderRadiusSM,
                    [`${componentCls}-clear`]: {
                        insetInlineEnd: varRef("padding-horizontal")
                    }
                },
                "&-lg": {
                    [varName("height")]: token.controlHeightLG,
                    [varName("font-size")]: token.fontSizeLG,
                    [varName("line-height")]: token.lineHeightLG,
                    [varName("font-height")]: token.fontHeightLG,
                    [varName("border-radius")]: token.borderRadiusLG
                }
            },
            // ============================================================
            // ==                         Input                          ==
            // ============================================================
            {
                [`&:not(${componentCls}-customize)`]: {
                    [`${componentCls}-input`]: {
                        outline: "none",
                        background: "transparent",
                        appearance: "none",
                        border: 0,
                        margin: 0,
                        padding: 0,
                        color: varRef("color"),
                        fontFamily: "inherit",
                        fontSize: "inherit",
                        "&::-webkit-search-cancel-button": {
                            display: "none",
                            appearance: "none"
                        }
                    }
                }
            },
            // ============================================================
            // ==                         Single                         ==
            // ============================================================
            {
                [`&-single:not(${componentCls}-customize)`]: {
                    [`${componentCls}-input`]: {
                        position: "absolute",
                        inset: 0,
                        lineHeight: "inherit"
                    },
                    // Content center align
                    [`${componentCls}-content`]: {
                        ...(0, $519d20bf207ce864$export$b2b65df0d0824629),
                        alignSelf: "center",
                        "&-has-value": {
                            display: "block",
                            "&:before": {
                                display: "none"
                            }
                        },
                        "&-has-search-value": {
                            color: "transparent",
                            [`> *:not(${componentCls}-input)`]: {
                                opacity: 0
                            }
                        },
                        // >>> Value
                        "&-value": {
                            transition: `all ${token.motionDurationMid} ${token.motionEaseInOut}`,
                            zIndex: 1,
                            opacity: 1
                        }
                    },
                    // Dim the selected content while the dropdown is open. Shared by all select-like
                    // components (Select / Cascader / TreeSelect) since they render through the same
                    // `content` structure.
                    [`&${componentCls}-open ${componentCls}-content`]: {
                        "&-has-value": {
                            opacity: 0.25
                        },
                        "&-has-search-value": {
                            opacity: 1,
                            transition: `opacity ${token.motionDurationMid} ${token.motionEaseInOut}`,
                            color: "transparent",
                            [`> *:not(${componentCls}-input)`]: {
                                opacity: 0
                            }
                        }
                    }
                }
            },
            // ======================== Show Search =======================
            {
                [`&-show-search:not(${componentCls}-customize-input):not(${componentCls}-disabled)`]: {
                    cursor: "text"
                }
            },
            // ============================================================
            // ==                        Multiple                        ==
            // ============================================================
            (0, $61f50474a6a64735$export$2e2bcd8739ae039)(token),
            // ========================= Variant ==========================
            // >>> Outlined
            $590d12bd35aab779$var$genSelectInputVariantStyle(token, "outlined", {
                border: token.colorBorder,
                borderHover: token.hoverBorderColor,
                borderActive: token.activeBorderColor,
                borderOutline: token.activeOutlineColor,
                borderDisabled: token.colorBorderDisabled
            }, // Error
            {
                border: token.colorError,
                borderHover: token.colorErrorBorderHover,
                borderActive: token.colorError,
                borderOutline: token.colorErrorOutline,
                affixColor: token.colorErrorAffix
            }, // Warning
            {
                border: token.colorWarning,
                borderHover: token.colorWarningHover,
                borderActive: token.colorWarning,
                borderOutline: token.colorWarningOutline,
                affixColor: token.colorWarningAffix
            }),
            // >>> Filled
            $590d12bd35aab779$var$genSelectInputVariantStyle(token, "filled", {
                border: "transparent",
                borderHover: "transparent",
                borderActive: token.activeBorderColor,
                borderOutline: "transparent",
                borderDisabled: token.colorBorderDisabled,
                background: token.colorFillTertiary,
                backgroundHover: token.colorFillSecondary,
                backgroundActive: token.colorBgContainer
            }, // Error
            {
                color: token.colorErrorText,
                background: token.colorErrorBg,
                backgroundHover: token.colorErrorBgHover,
                borderActive: token.colorError
            }, // Warning
            {
                background: token.colorWarningBg,
                backgroundHover: token.colorWarningBgHover,
                borderActive: token.colorWarning
            }),
            // >>> Borderless
            $590d12bd35aab779$var$genSelectInputVariantStyle(token, "borderless", {
                border: "transparent",
                borderHover: "transparent",
                borderActive: "transparent",
                borderOutline: "transparent",
                background: "transparent"
            }, {}, {}, {
                [`&:not(${componentCls}-disabled):has(input:focus-visible), &:not(${componentCls}-disabled):has(textarea:focus-visible)`]: $590d12bd35aab779$var$genSelectInputFocusVisibleStyle(token, token.activeBorderColor),
                [`&${componentCls}-status-error:not(${componentCls}-disabled):has(input:focus-visible), &${componentCls}-status-error:not(${componentCls}-disabled):has(textarea:focus-visible)`]: $590d12bd35aab779$var$genSelectInputFocusVisibleStyle(token, token.colorError),
                [`&${componentCls}-status-warning:not(${componentCls}-disabled):has(input:focus-visible), &${componentCls}-status-warning:not(${componentCls}-disabled):has(textarea:focus-visible)`]: $590d12bd35aab779$var$genSelectInputFocusVisibleStyle(token, token.colorWarning)
            }),
            // Underlined
            $590d12bd35aab779$var$genSelectInputVariantStyle(token, "underlined", {
                border: token.colorBorder,
                borderHover: token.hoverBorderColor,
                borderActive: token.activeBorderColor,
                borderOutline: "transparent"
            }, // Error
            {
                border: token.colorError,
                borderHover: token.colorErrorBorderHover,
                borderActive: token.colorError
            }, // Warning
            {
                border: token.colorWarning,
                borderHover: token.colorWarningHover,
                borderActive: token.colorWarning
            }, {
                borderRadius: 0,
                borderTopColor: "transparent",
                borderInlineColor: "transparent"
            }),
            // ============================================================
            // ==                         Custom                         ==
            // ============================================================
            (0, $ef64af83665c0ccf$export$2e2bcd8739ae039)(token)
        ]
    };
};
var $590d12bd35aab779$export$2e2bcd8739ae039 = $590d12bd35aab779$var$genSelectInputStyle;


const $1f5c1fd8d16df42e$export$9ca1be8807fe0675 = (token)=>{
    const { fontSize: fontSize, lineHeight: lineHeight, lineWidth: lineWidth, lineWidthFocus: lineWidthFocus, controlHeight: controlHeight, controlHeightSM: controlHeightSM, controlHeightLG: controlHeightLG, paddingXXS: paddingXXS, controlPaddingHorizontal: controlPaddingHorizontal, zIndexPopupBase: zIndexPopupBase, colorText: colorText, fontWeightStrong: fontWeightStrong, controlItemBgActive: controlItemBgActive, controlItemBgHover: controlItemBgHover, colorBgContainer: colorBgContainer, colorFillSecondary: colorFillSecondary, colorBgContainerDisabled: colorBgContainerDisabled, colorTextDisabled: colorTextDisabled, colorPrimaryHover: colorPrimaryHover, colorPrimary: colorPrimary, controlOutline: controlOutline } = token;
    // Item height default use `controlHeight - 2 * paddingXXS`,
    // but some case `paddingXXS=0`.
    // Let's fallback it.
    const dblPaddingXXS = paddingXXS * 2;
    const dblLineWidth = lineWidth * 2;
    const multipleItemHeight = Math.min(controlHeight - dblPaddingXXS, controlHeight - dblLineWidth);
    const multipleItemHeightSM = Math.min(controlHeightSM - dblPaddingXXS, controlHeightSM - dblLineWidth);
    const multipleItemHeightLG = Math.min(controlHeightLG - dblPaddingXXS, controlHeightLG - dblLineWidth);
    // FIXED_ITEM_MARGIN is a hardcode calculation since calc not support rounding
    const INTERNAL_FIXED_ITEM_MARGIN = Math.floor(paddingXXS / 2);
    const componentToken = {
        lineWidthFocus: lineWidthFocus === 0 ? 0 : lineWidth,
        INTERNAL_FIXED_ITEM_MARGIN: INTERNAL_FIXED_ITEM_MARGIN,
        zIndexPopup: zIndexPopupBase + 50,
        optionSelectedColor: colorText,
        optionSelectedFontWeight: fontWeightStrong,
        optionSelectedBg: controlItemBgActive,
        optionActiveBg: controlItemBgHover,
        optionPadding: `${(controlHeight - fontSize * lineHeight) / 2}px ${controlPaddingHorizontal}px`,
        optionFontSize: fontSize,
        optionLineHeight: lineHeight,
        optionHeight: controlHeight,
        selectorBg: colorBgContainer,
        clearBg: colorBgContainer,
        singleItemHeightLG: controlHeightLG,
        multipleItemBg: colorFillSecondary,
        multipleItemBorderColor: "transparent",
        multipleItemHeight: multipleItemHeight,
        multipleItemHeightSM: multipleItemHeightSM,
        multipleItemHeightLG: multipleItemHeightLG,
        multipleSelectorBgDisabled: colorBgContainerDisabled,
        multipleItemColorDisabled: colorTextDisabled,
        multipleItemBorderColorDisabled: "transparent",
        showArrowPaddingInlineEnd: Math.ceil(token.fontSize * 1.25),
        hoverBorderColor: colorPrimaryHover,
        activeBorderColor: colorPrimary,
        activeOutlineColor: controlOutline,
        selectAffixPadding: paddingXXS
    };
    return componentToken;
};


// =============================== Base ===============================
const $659e225ed882e4d0$var$genBaseStyle = (token)=>{
    const { antCls: antCls, componentCls: componentCls, motionDurationMid: motionDurationMid, inputPaddingHorizontalBase: inputPaddingHorizontalBase } = token;
    const hoverShowClearStyle = {
        [`${componentCls}-clear`]: {
            opacity: 1
        },
        [`${componentCls}-suffix:not(:last-child)`]: {
            opacity: 0,
            pointerEvents: "none"
        },
        [`&${componentCls}-allow-clear:not(${componentCls}-show-arrow) ${componentCls}-content`]: {
            marginInlineEnd: token.showArrowPaddingInlineEnd
        }
    };
    return {
        [componentCls]: {
            ...(0, $519d20bf207ce864$export$23997c3e44cc1c59)(token),
            // ======================== Selection ========================
            [`${componentCls}-selection-item`]: {
                flex: 1,
                fontWeight: "normal",
                position: "relative",
                userSelect: "none",
                ...(0, $519d20bf207ce864$export$b2b65df0d0824629),
                // https://github.com/ant-design/ant-design/issues/40421
                [`> ${antCls}-typography`]: {
                    display: "inline"
                }
            },
            // ========================= Prefix ==========================
            [`${componentCls}-prefix`]: {
                flex: "none",
                marginInlineEnd: token.selectAffixPadding
            },
            // ========================== Clear ==========================
            [`${componentCls}-clear`]: {
                position: "absolute",
                top: "50%",
                insetInlineStart: "auto",
                insetInlineEnd: inputPaddingHorizontalBase,
                zIndex: 1,
                display: "inline-block",
                width: token.fontSizeIcon,
                height: token.fontSizeIcon,
                marginTop: token.calc(token.fontSizeIcon).mul(-1).div(2).equal(),
                padding: 0,
                background: "transparent",
                color: token.colorTextQuaternary,
                fontSize: token.fontSizeIcon,
                fontFamily: "inherit",
                fontStyle: "normal",
                lineHeight: 1,
                textAlign: "center",
                textTransform: "none",
                appearance: "none",
                border: 0,
                cursor: "pointer",
                opacity: 0,
                transition: [
                    "color",
                    "opacity"
                ].map((prop)=>`${prop} ${motionDurationMid} ease`).join(", "),
                textRendering: "auto",
                // https://github.com/ant-design/ant-design/issues/54205
                // Force GPU compositing on Safari to prevent flickering on opacity/transform transitions
                transform: "translateZ(0)",
                "&:before": {
                    display: "block"
                },
                "&:hover": {
                    color: token.colorIcon
                }
            },
            "@media(hover:none)": hoverShowClearStyle,
            "&:hover": hoverShowClearStyle
        },
        // ========================= Feedback ==========================
        [`${componentCls}-status`]: {
            "&-error, &-warning, &-success, &-validating": {
                [`&${componentCls}-has-feedback`]: {
                    [`${componentCls}-clear`]: {
                        insetInlineEnd: token.calc(inputPaddingHorizontalBase).add(token.fontSize).add(token.paddingXS).equal()
                    }
                }
            }
        }
    };
};
// ============================== Styles ==============================
const $659e225ed882e4d0$var$genSelectStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return [
        {
            [componentCls]: {
                // ==================== In Form ====================
                [`&${componentCls}-in-form-item`]: {
                    width: "100%"
                }
            }
        },
        // =====================================================
        // ==                       LTR                       ==
        // =====================================================
        // Base
        $659e225ed882e4d0$var$genBaseStyle(token),
        // Dropdown
        (0, $34c68a181bd101cb$export$2e2bcd8739ae039)(token),
        // =====================================================
        // ==                       RTL                       ==
        // =====================================================
        {
            [`${componentCls}-rtl`]: {
                direction: "rtl"
            }
        },
        // =====================================================
        // ==             Space Compact                       ==
        // =====================================================
        (0, $6e46145470fc0a51$export$b1208b23589b4b73)(token, {
            focusElCls: `${componentCls}-focused`
        })
    ];
};
var // ============================== Export ==============================
$659e225ed882e4d0$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$51ec95de45185b42)("Select", (token, { rootPrefixCls: rootPrefixCls })=>{
    const selectToken = (0, $fef50f256b80dfa5$export$4950aa0f605343fb)(token, {
        rootPrefixCls: rootPrefixCls,
        inputPaddingHorizontalBase: token.calc(token.paddingSM).sub(token.lineWidth).equal(),
        multipleSelectItemHeight: token.multipleItemHeight,
        selectHeight: token.controlHeight
    });
    return [
        $659e225ed882e4d0$var$genSelectStyle(selectToken),
        (0, $590d12bd35aab779$export$2e2bcd8739ae039)(selectToken)
    ];
}, (0, $1f5c1fd8d16df42e$export$9ca1be8807fe0675), {
    unitless: {
        optionLineHeight: true,
        optionSelectedFontWeight: true
    }
});



var $cQmXV = parcelRequire("cQmXV");








"use client";
function $1fdab3ae39c037b4$export$2e2bcd8739ae039({ suffixIcon: suffixIcon, contextSuffixIcon: contextSuffixIcon, clearIcon: clearIcon, contextClearIcon: contextClearIcon, menuItemSelectedIcon: menuItemSelectedIcon, contextMenuItemSelectedIcon: contextMenuItemSelectedIcon, removeIcon: removeIcon, contextRemoveIcon: contextRemoveIcon, loading: loading, loadingIcon: loadingIcon, contextLoadingIcon: contextLoadingIcon, searchIcon: searchIcon, contextSearchIcon: contextSearchIcon, multiple: multiple, hasFeedback: hasFeedback, showSuffixIcon: showSuffixIcon, feedbackIcon: feedbackIcon, showArrow: showArrow, componentName: componentName }) {
    return $cQmXV.useMemo(()=>{
        // Clear Icon
        const mergedClearIcon = (0, $55c1e81905598a5b$export$2e2bcd8739ae039)(clearIcon, contextClearIcon, /*#__PURE__*/ $cQmXV.createElement((0, $ff9add21dbbc2684$export$2e2bcd8739ae039), null));
        // Validation Feedback Icon
        const getSuffixIconNode = (arrowIcon)=>{
            if (suffixIcon === null && !hasFeedback && !showArrow) return null;
            return /*#__PURE__*/ $cQmXV.createElement($cQmXV.Fragment, null, showSuffixIcon !== false && arrowIcon, hasFeedback && feedbackIcon);
        };
        // Arrow item icon
        let mergedSuffixIcon = null;
        if (suffixIcon !== undefined) mergedSuffixIcon = getSuffixIconNode(suffixIcon);
        else if (loading) mergedSuffixIcon = getSuffixIconNode((0, $55c1e81905598a5b$export$2e2bcd8739ae039)(loadingIcon, contextLoadingIcon, /*#__PURE__*/ $cQmXV.createElement((0, $bf7996ca956facd7$export$2e2bcd8739ae039), {
            spin: true
        })));
        else mergedSuffixIcon = ({ open: open, showSearch: showSearch })=>{
            if (open && showSearch) return getSuffixIconNode((0, $55c1e81905598a5b$export$2e2bcd8739ae039)(searchIcon, contextSearchIcon, /*#__PURE__*/ $cQmXV.createElement((0, $20a259d46bffcb08$export$2e2bcd8739ae039), null)));
            return getSuffixIconNode((0, $55c1e81905598a5b$export$2e2bcd8739ae039)(contextSuffixIcon, /*#__PURE__*/ $cQmXV.createElement((0, $e7119b602540b2c5$export$2e2bcd8739ae039), null)));
        };
        // Checked item icon
        const mergedItemIcon = (0, $55c1e81905598a5b$export$2e2bcd8739ae039)(menuItemSelectedIcon, contextMenuItemSelectedIcon, multiple ? /*#__PURE__*/ $cQmXV.createElement((0, $77ccca814b0c39fe$export$2e2bcd8739ae039), null) : null);
        const mergedRemoveIcon = (0, $55c1e81905598a5b$export$2e2bcd8739ae039)(removeIcon, contextRemoveIcon, /*#__PURE__*/ $cQmXV.createElement((0, $837faca566926e3c$export$2e2bcd8739ae039), null));
        return {
            clearIcon: mergedClearIcon,
            suffixIcon: mergedSuffixIcon,
            itemIcon: mergedItemIcon,
            removeIcon: mergedRemoveIcon
        };
    }, [
        suffixIcon,
        contextSuffixIcon,
        clearIcon,
        contextClearIcon,
        menuItemSelectedIcon,
        contextMenuItemSelectedIcon,
        removeIcon,
        contextRemoveIcon,
        loading,
        loadingIcon,
        contextLoadingIcon,
        searchIcon,
        contextSearchIcon,
        multiple,
        hasFeedback,
        showSuffixIcon,
        feedbackIcon,
        showArrow
    ]);
}



var $cQmXV = parcelRequire("cQmXV");

"use client";
function $cd4490c652ca4547$var$usePopupRender(renderFn) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useMemo(()=>{
        if (!renderFn) return undefined;
        return (...args)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $1585084388e75c84$export$2e2bcd8739ae039), {
                space: true
            }, renderFn.apply(void 0, args));
    }, [
        renderFn
    ]);
}
var $cd4490c652ca4547$export$2e2bcd8739ae039 = $cd4490c652ca4547$var$usePopupRender;


/**
 * Since Select, TreeSelect, Cascader is same Select like component.
 * We just use same hook to handle this logic.
 *
 * If `suffixIcon` is not equal to `null`, always show it.
 */ function $f7ff87ae1c31aeb4$export$2e2bcd8739ae039(suffixIcon, showArrow) {
    return showArrow !== undefined ? showArrow : suffixIcon !== null;
}


"use client";
const $872fd39f1285217b$var$SECRET_COMBOBOX_MODE_DO_NOT_USE = "SECRET_COMBOBOX_MODE_DO_NOT_USE";
const $872fd39f1285217b$var$InternalSelect = (props, ref)=>{
    const { prefixCls: customizePrefixCls, bordered: bordered, className: className, rootClassName: rootClassName, getPopupContainer: getPopupContainer, popupClassName: popupClassName, dropdownClassName: dropdownClassName, listHeight: listHeight = 256, placement: placement, listItemHeight: customListItemHeight, size: customizeSize, disabled: customDisabled, notFoundContent: notFoundContent, status: customStatus, builtinPlacements: builtinPlacements, dropdownMatchSelectWidth: dropdownMatchSelectWidth, popupMatchSelectWidth: popupMatchSelectWidth, direction: propDirection, style: style, allowClear: allowClear, variant: customizeVariant, popupStyle: popupStyle, dropdownStyle: dropdownStyle, transitionName: transitionName, tagRender: tagRender, maxCount: maxCount, prefix: prefix, dropdownRender: dropdownRender, popupRender: /**
     * @since 5.25.0
     */ popupRender, onDropdownVisibleChange: onDropdownVisibleChange, onOpenChange: onOpenChange, styles: styles, classNames: classNames, clearIcon: clearIcon, showSearch: showSearch, ...rest } = props;
    const { getPopupContainer: getContextPopupContainer, getPrefixCls: getPrefixCls, renderEmpty: renderEmpty, direction: contextDirection, virtual: virtual, popupMatchSelectWidth: contextPopupMatchSelectWidth, popupOverflow: popupOverflow } = $cQmXV.useContext((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    const { showSearch: contextShowSearch, allowClear: contextAllowClear, style: contextStyle, styles: contextStyles, className: contextClassName, classNames: contextClassNames, clearIcon: contextClearIcon, loadingIcon: contextLoadingIcon, menuItemSelectedIcon: contextMenuItemSelectedIcon, removeIcon: contextRemoveIcon, suffixIcon: contextSuffixIcon } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("select");
    const [, token] = (0, $b22e03a54a548614$export$2e2bcd8739ae039)();
    const listItemHeight = customListItemHeight ?? token?.controlHeight;
    const prefixCls = getPrefixCls("select", customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    const direction = propDirection ?? contextDirection;
    const { compactSize: compactSize, compactItemClassnames: compactItemClassnames } = (0, $68fddf51400eda11$export$cd8cf9d7bab8dd4)(prefixCls, direction);
    const [variant, enableVariantCls] = (0, $11c15dfa3883fb6f$export$2e2bcd8739ae039)("select", customizeVariant, bordered);
    const rootCls = (0, $2237081acd3cfc09$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $659e225ed882e4d0$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const mode = $cQmXV.useMemo(()=>{
        const { mode: m } = props;
        if (m === "combobox") return undefined;
        if (m === $872fd39f1285217b$var$SECRET_COMBOBOX_MODE_DO_NOT_USE) return "combobox";
        return m;
    }, [
        props.mode
    ]);
    const isMultiple = mode === "multiple" || mode === "tags";
    const showSuffixIcon = (0, $f7ff87ae1c31aeb4$export$2e2bcd8739ae039)(props.suffixIcon, props.showArrow);
    const mergedPopupMatchSelectWidth = popupMatchSelectWidth ?? dropdownMatchSelectWidth ?? contextPopupMatchSelectWidth;
    const mergedPopupRender = (0, $cd4490c652ca4547$export$2e2bcd8739ae039)(popupRender || dropdownRender);
    const mergedOnOpenChange = onOpenChange || onDropdownVisibleChange;
    // ===================== Form Status =====================
    const { status: contextStatus, hasFeedback: hasFeedback, isFormItemInput: isFormItemInput, feedbackIcon: feedbackIcon } = $cQmXV.useContext((0, $7a3804f153d8a19d$export$bbb5553c6c7a14ed));
    const mergedStatus = (0, $4a3ea1f9228016b7$export$314e193082d7ba49)(contextStatus, customStatus);
    // ===================== Empty =====================
    let mergedNotFound;
    if (notFoundContent !== undefined) mergedNotFound = notFoundContent;
    else if (mode === "combobox") mergedNotFound = null;
    else mergedNotFound = renderEmpty?.("Select") || /*#__PURE__*/ $cQmXV.createElement((0, $3f2744634b9eeb0b$export$2e2bcd8739ae039), {
        componentName: "Select"
    });
    // ===================== Icons =====================
    const { suffixIcon: suffixIcon, itemIcon: itemIcon, removeIcon: removeIcon, clearIcon: mergedClearIcon } = (0, $1fdab3ae39c037b4$export$2e2bcd8739ae039)({
        ...rest,
        multiple: isMultiple,
        hasFeedback: hasFeedback,
        feedbackIcon: feedbackIcon,
        showSuffixIcon: showSuffixIcon,
        prefixCls: prefixCls,
        componentName: "Select",
        clearIcon: clearIcon,
        searchIcon: (0, $ccaf7339afd5c582$export$2e2bcd8739ae039)(showSearch, "searchIcon"),
        contextClearIcon: contextClearIcon,
        contextLoadingIcon: contextLoadingIcon,
        contextMenuItemSelectedIcon: contextMenuItemSelectedIcon,
        contextRemoveIcon: contextRemoveIcon,
        contextSearchIcon: (0, $ccaf7339afd5c582$export$2e2bcd8739ae039)(contextShowSearch, "searchIcon"),
        contextSuffixIcon: contextSuffixIcon
    });
    const finalAllowClear = allowClear ?? contextAllowClear;
    const mergedAllowClear = finalAllowClear === true ? {
        clearIcon: mergedClearIcon
    } : finalAllowClear;
    const mergedShowSearch = showSearch ?? contextShowSearch;
    const selectProps = (0, $e8c5093aebad6025$export$2e2bcd8739ae039)(rest, [
        "suffixIcon",
        "itemIcon"
    ]);
    const mergedSize = (0, $78cdfb6138721329$export$2e2bcd8739ae039)((ctx)=>customizeSize ?? compactSize ?? ctx);
    // ===================== Disabled =====================
    const disabled = $cQmXV.useContext((0, $4f0e1ea30330557c$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled ?? disabled;
    // ========== Merged Props for Semantic ==================
    const mergedProps = {
        ...props,
        variant: variant,
        status: mergedStatus,
        disabled: mergedDisabled,
        size: mergedSize
    };
    const contextStyleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $30c5f9f911d4f61b$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: mergedProps
    }, {
        popup: {
            _default: "root"
        }
    });
    const mergedPopupClassName = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(mergedClassNames.popup.root, popupClassName, dropdownClassName, {
        [`${prefixCls}-dropdown-${direction}`]: direction === "rtl"
    }, rootClassName, cssVarCls, rootCls, hashId);
    const mergedPopupStyle = {
        ...mergedStyles.popup?.root,
        ...popupStyle ?? dropdownStyle
    };
    const mergedClassName = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)({
        [`${prefixCls}-lg`]: mergedSize === "large",
        [`${prefixCls}-sm`]: mergedSize === "small",
        [`${prefixCls}-rtl`]: direction === "rtl",
        [`${prefixCls}-${variant}`]: enableVariantCls,
        [`${prefixCls}-in-form-item`]: isFormItemInput
    }, (0, $4a3ea1f9228016b7$export$b08e7b47149942a2)(prefixCls, mergedStatus, hasFeedback), compactItemClassnames, contextClassName, className, mergedClassNames.root, rootClassName, cssVarCls, rootCls, hashId);
    // ===================== Placement =====================
    const memoPlacement = $cQmXV.useMemo(()=>{
        if (placement !== undefined) return placement;
        return direction === "rtl" ? "bottomRight" : "bottomLeft";
    }, [
        placement,
        direction
    ]);
    var oldProp, newProp;
    // ====================== zIndex =========================
    const [zIndex] = (0, $b2b300e6909d7707$export$3e7906d4075187a4)("SelectLike", mergedStyles.popup.root?.zIndex ?? mergedPopupStyle.zIndex);
    // ====================== Render =======================
    return /*#__PURE__*/ $cQmXV.createElement((0, $069c1790c3865d68$export$2e2bcd8739ae039), {
        ref: ref,
        virtual: virtual,
        classNames: mergedClassNames,
        styles: mergedStyles,
        showSearch: mergedShowSearch,
        ...selectProps,
        style: mergedStyles.root,
        popupMatchSelectWidth: mergedPopupMatchSelectWidth,
        transitionName: (0, $047a5f051ebda8ba$export$27c72201b1d09951)(rootPrefixCls, "slide-up", transitionName),
        builtinPlacements: (0, $02b6d2f2bde71f39$export$2e2bcd8739ae039)(builtinPlacements, popupOverflow),
        listHeight: listHeight,
        listItemHeight: listItemHeight,
        mode: mode,
        prefixCls: prefixCls,
        placement: memoPlacement,
        direction: direction,
        prefix: prefix,
        suffixIcon: suffixIcon,
        menuItemSelectedIcon: itemIcon,
        removeIcon: removeIcon,
        allowClear: mergedAllowClear,
        notFoundContent: mergedNotFound,
        className: mergedClassName,
        getPopupContainer: getPopupContainer || getContextPopupContainer,
        popupClassName: mergedPopupClassName,
        disabled: mergedDisabled,
        popupStyle: {
            ...mergedStyles.popup.root,
            ...mergedPopupStyle,
            zIndex: zIndex
        },
        maxCount: isMultiple ? maxCount : undefined,
        tagRender: isMultiple ? tagRender : undefined,
        popupRender: mergedPopupRender,
        onPopupVisibleChange: mergedOnOpenChange
    });
};
const $872fd39f1285217b$var$Select = /*#__PURE__*/ $cQmXV.forwardRef($872fd39f1285217b$var$InternalSelect);
// We don't care debug panel
/* istanbul ignore next */ const $872fd39f1285217b$var$PurePanel = (0, $f2e41308375833b9$export$2e2bcd8739ae039)($872fd39f1285217b$var$Select, "popupAlign");
$872fd39f1285217b$var$Select.SECRET_COMBOBOX_MODE_DO_NOT_USE = $872fd39f1285217b$var$SECRET_COMBOBOX_MODE_DO_NOT_USE;
$872fd39f1285217b$var$Select.Option = (0, $e2be968a818eff80$export$2e2bcd8739ae039);
$872fd39f1285217b$var$Select.OptGroup = (0, $a77affc9f9453370$export$2e2bcd8739ae039);
$872fd39f1285217b$var$Select._InternalPanelDoNotUseOrYouWillBeFired = $872fd39f1285217b$var$PurePanel;
var $872fd39f1285217b$export$2e2bcd8739ae039 = $872fd39f1285217b$var$Select;









const $61dc151943960caf$var$genPaginationDisabledStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-disabled`]: {
            "&, &:hover": {
                cursor: "not-allowed",
                [`${componentCls}-item-link`]: {
                    color: token.colorTextDisabled,
                    cursor: "not-allowed"
                }
            },
            "&:focus-visible": {
                cursor: "not-allowed",
                [`${componentCls}-item-link`]: {
                    color: token.colorTextDisabled,
                    cursor: "not-allowed"
                }
            }
        },
        [`&${componentCls}-disabled`]: {
            cursor: "not-allowed",
            [`${componentCls}-item`]: {
                cursor: "not-allowed",
                backgroundColor: "transparent",
                "&:hover, &:active": {
                    backgroundColor: "transparent"
                },
                a: {
                    color: token.colorTextDisabled,
                    backgroundColor: "transparent",
                    border: "none",
                    cursor: "not-allowed"
                },
                "&-active": {
                    borderColor: token.colorBorder,
                    backgroundColor: token.itemActiveBgDisabled,
                    "&:hover, &:active": {
                        backgroundColor: token.itemActiveBgDisabled
                    },
                    a: {
                        color: token.itemActiveColorDisabled
                    }
                }
            },
            [`${componentCls}-item-link`]: {
                color: token.colorTextDisabled,
                cursor: "not-allowed",
                "&:hover, &:active": {
                    backgroundColor: "transparent"
                },
                [`${componentCls}-simple&`]: {
                    backgroundColor: "transparent",
                    "&:hover, &:active": {
                        backgroundColor: "transparent"
                    }
                }
            },
            [`${componentCls}-simple-pager`]: {
                color: token.colorTextDisabled
            },
            [`${componentCls}-jump-prev, ${componentCls}-jump-next`]: {
                [`${componentCls}-item-link-icon`]: {
                    opacity: 0
                },
                [`${componentCls}-item-ellipsis`]: {
                    opacity: 1
                }
            }
        }
    };
};
const $61dc151943960caf$var$genPaginationSmallStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`&${componentCls}-small ${componentCls}-options`]: {
            marginInlineStart: token.paginationMiniOptionsMarginInlineStart,
            "&-quick-jumper": {
                input: {
                    ...(0, $8c2dcdcd3819e8c0$export$bb047f62c5a56f90)(token),
                    width: token.paginationMiniQuickJumperInputWidth
                }
            }
        }
    };
};
const $61dc151943960caf$var$genPaginationLargeStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`&${componentCls}-large ${componentCls}-options`]: {
            "&-quick-jumper": {
                input: {
                    ...(0, $8c2dcdcd3819e8c0$export$88e04420bb2dc003)(token)
                }
            }
        }
    };
};
const $61dc151943960caf$var$genPaginationSimpleStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    const [, varRef] = (0, $6870d4d7c14ae0bb$export$d82b8f66c5649e14)(antCls, "pagination");
    return {
        [`&${componentCls}-simple`]: {
            [`${componentCls}-prev, ${componentCls}-next`]: {
                height: varRef(`item-size-actual`),
                lineHeight: varRef(`item-size-actual`),
                verticalAlign: "top",
                [`${componentCls}-item-link`]: {
                    height: varRef(`item-size-actual`),
                    backgroundColor: "transparent",
                    border: 0,
                    "&:hover": {
                        backgroundColor: token.colorBgTextHover
                    },
                    "&:active": {
                        backgroundColor: token.colorBgTextActive
                    },
                    "&::after": {
                        height: varRef(`item-size-actual`),
                        lineHeight: varRef(`item-size-actual`)
                    }
                }
            },
            [`${componentCls}-simple-pager`]: {
                display: "inline-flex",
                alignItems: "center",
                height: varRef(`item-size-actual`),
                marginInlineEnd: varRef(`item-spacing-actual`),
                input: {
                    boxSizing: "border-box",
                    height: "100%",
                    width: token.quickJumperInputWidth,
                    padding: `0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.paginationItemPaddingInline)}`,
                    textAlign: "center",
                    backgroundColor: token.itemInputBg,
                    border: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                    borderRadius: token.borderRadius,
                    outline: "none",
                    transition: `border-color ${token.motionDurationMid}`,
                    color: "inherit",
                    "&:hover": {
                        borderColor: token.colorPrimary
                    },
                    "&:focus": {
                        borderColor: token.colorPrimaryHover,
                        boxShadow: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.inputOutlineOffset)} 0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.controlOutlineWidth)} ${token.controlOutline}`
                    },
                    "&[disabled]": {
                        color: token.colorTextDisabled,
                        backgroundColor: token.colorBgContainerDisabled,
                        borderColor: token.colorBorder,
                        cursor: "not-allowed"
                    }
                }
            },
            [`&${componentCls}-disabled`]: {
                [`${componentCls}-prev, ${componentCls}-next`]: {
                    [`${componentCls}-item-link`]: {
                        "&:hover, &:active": {
                            backgroundColor: "transparent"
                        }
                    }
                }
            },
            [`&${componentCls}-small`]: {
                [`${componentCls}-simple-pager`]: {
                    input: {
                        width: token.paginationMiniQuickJumperInputWidth
                    }
                }
            }
        }
    };
};
const $61dc151943960caf$var$genPaginationInputVariantStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const inputSelector = `${componentCls}-options-quick-jumper input, ${componentCls}-simple-pager input`;
    return {
        [`&${componentCls}-filled`]: {
            [inputSelector]: {
                background: token.colorFillTertiary,
                borderColor: "transparent",
                "&:hover": {
                    background: token.colorFillSecondary
                },
                "&:focus": {
                    borderColor: token.activeBorderColor,
                    outline: 0,
                    backgroundColor: token.activeBg
                },
                "&[disabled]": {
                    ...(0, $189bffeae8a9954a$export$12789f962d420a93)(token)
                }
            }
        },
        [`&${componentCls}-borderless`]: {
            [inputSelector]: {
                background: "transparent",
                border: "none",
                "&:focus": {
                    outline: "none",
                    boxShadow: "none"
                },
                "&[disabled]": {
                    color: token.colorTextDisabled,
                    cursor: "not-allowed"
                }
            }
        },
        [`&${componentCls}-underlined`]: {
            [inputSelector]: {
                background: token.colorBgContainer,
                borderWidth: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidth)} 0`,
                borderStyle: `${token.lineType} none`,
                borderColor: `transparent transparent ${token.colorBorder} transparent`,
                borderRadius: 0,
                "&:hover": {
                    borderColor: `transparent transparent ${token.hoverBorderColor} transparent`,
                    backgroundColor: token.hoverBg
                },
                "&:focus": {
                    borderColor: `transparent transparent ${token.activeBorderColor} transparent`,
                    outline: 0,
                    backgroundColor: token.activeBg
                },
                "&[disabled]": {
                    color: token.colorTextDisabled,
                    boxShadow: "none",
                    cursor: "not-allowed"
                }
            }
        }
    };
};
const $61dc151943960caf$var$genPaginationJumpStyle = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, sizeLG: sizeLG, antCls: antCls } = token;
    const [, varRef] = (0, $6870d4d7c14ae0bb$export$d82b8f66c5649e14)(antCls, "pagination");
    return {
        [`${componentCls}-jump-prev, ${componentCls}-jump-next`]: {
            outline: 0,
            [`${componentCls}-item-container`]: {
                position: "relative",
                [`${componentCls}-item-link-icon`]: {
                    color: token.colorPrimary,
                    fontSize: token.fontSizeSM,
                    opacity: 0,
                    transition: `all ${token.motionDurationMid}`,
                    "&-svg": {
                        top: 0,
                        insetInlineEnd: 0,
                        bottom: 0,
                        insetInlineStart: 0,
                        margin: "auto"
                    }
                },
                [`${componentCls}-item-ellipsis`]: {
                    position: "absolute",
                    inset: 0,
                    display: "inline-flex",
                    justifyContent: "center",
                    alignItems: "center",
                    margin: "auto",
                    color: token.colorTextDisabled,
                    textAlign: "center",
                    opacity: 1,
                    transition: `all ${token.motionDurationMid}`,
                    [`${iconCls}-ellipsis > svg`]: {
                        width: sizeLG,
                        height: sizeLG
                    }
                }
            },
            "&:hover": {
                [`${componentCls}-item-link-icon`]: {
                    opacity: 1
                },
                [`${componentCls}-item-ellipsis`]: {
                    opacity: 0
                }
            }
        },
        [`
    ${componentCls}-prev,
    ${componentCls}-jump-prev,
    ${componentCls}-jump-next
    `]: {
            marginInlineEnd: varRef(`item-spacing-actual`)
        },
        [`
    ${componentCls}-prev,
    ${componentCls}-next,
    ${componentCls}-jump-prev,
    ${componentCls}-jump-next
    `]: {
            display: "inline-block",
            minWidth: varRef(`item-size-actual`),
            height: varRef(`item-size-actual`),
            color: token.colorText,
            fontFamily: token.fontFamily,
            lineHeight: varRef(`item-size-actual`),
            textAlign: "center",
            verticalAlign: "middle",
            listStyle: "none",
            borderRadius: token.borderRadius,
            cursor: "pointer",
            transition: `all ${token.motionDurationMid}`
        },
        [`${componentCls}-prev, ${componentCls}-next`]: {
            outline: 0,
            button: {
                color: token.colorText,
                cursor: "pointer",
                userSelect: "none"
            },
            [`${componentCls}-item-link`]: {
                display: "block",
                width: "100%",
                height: "100%",
                padding: 0,
                fontSize: token.fontSizeSM,
                textAlign: "center",
                backgroundColor: "transparent",
                border: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} transparent`,
                borderRadius: token.borderRadius,
                outline: "none",
                transition: `all ${token.motionDurationMid}`
            },
            [`&:hover ${componentCls}-item-link`]: {
                backgroundColor: token.colorBgTextHover
            },
            [`&:active ${componentCls}-item-link`]: {
                backgroundColor: token.colorBgTextActive
            },
            [`&${componentCls}-disabled:hover`]: {
                [`${componentCls}-item-link`]: {
                    backgroundColor: "transparent"
                }
            }
        },
        [`${componentCls}-slash`]: {
            marginInlineEnd: token.paginationSlashMarginInlineEnd,
            marginInlineStart: token.paginationSlashMarginInlineStart
        },
        [`${componentCls}-options`]: {
            display: "inline-block",
            marginInlineStart: token.margin,
            verticalAlign: "middle",
            [`&-size-changer, &-size-changer${componentCls}-options-size-changer-select`]: {
                width: "auto"
            },
            "&-quick-jumper": {
                display: "inline-block",
                height: varRef(`item-size-actual`),
                marginInlineStart: token.marginXS,
                lineHeight: varRef(`item-size-actual`),
                verticalAlign: "baseline",
                input: {
                    ...(0, $8c2dcdcd3819e8c0$export$8c9a381315f3ebcd)(token),
                    ...(0, $189bffeae8a9954a$export$8c569e4cc3fd115f)(token, {
                        borderColor: token.colorBorder,
                        hoverBorderColor: token.colorPrimaryHover,
                        activeBorderColor: token.colorPrimary,
                        activeShadow: token.activeShadow
                    }),
                    "&[disabled]": {
                        ...(0, $189bffeae8a9954a$export$12789f962d420a93)(token)
                    },
                    width: token.quickJumperInputWidth,
                    height: varRef(`item-size-actual`),
                    boxSizing: "border-box",
                    margin: 0,
                    marginInlineStart: varRef(`item-spacing-actual`),
                    marginInlineEnd: varRef(`item-spacing-actual`)
                }
            }
        }
    };
};
const $61dc151943960caf$var$genPaginationItemStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    const [, varRef] = (0, $6870d4d7c14ae0bb$export$d82b8f66c5649e14)(antCls, "pagination");
    return {
        [`${componentCls}-item`]: {
            display: "inline-block",
            minWidth: varRef(`item-size-actual`),
            height: varRef(`item-size-actual`),
            marginInlineEnd: varRef(`item-spacing-actual`),
            fontFamily: token.fontFamily,
            lineHeight: (0, $05f34ed03d41967d$export$523c0b569236b342)(token.calc(varRef("item-size-actual")).sub(2).equal()),
            textAlign: "center",
            verticalAlign: "middle",
            listStyle: "none",
            backgroundColor: token.itemBg,
            border: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} transparent`,
            borderRadius: token.borderRadius,
            outline: 0,
            cursor: "pointer",
            userSelect: "none",
            a: {
                display: "block",
                padding: `0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.paginationItemPaddingInline)}`,
                color: token.colorText,
                "&:hover": {
                    textDecoration: "none"
                }
            },
            [`&:not(${componentCls}-item-active)`]: {
                "&:hover": {
                    transition: `all ${token.motionDurationMid}`,
                    backgroundColor: token.colorBgTextHover
                },
                "&:active": {
                    backgroundColor: token.colorBgTextActive
                }
            },
            "&-active": {
                fontWeight: token.fontWeightStrong,
                backgroundColor: token.itemActiveBg,
                borderColor: token.colorPrimary,
                a: {
                    color: token.itemActiveColor
                },
                "&:hover": {
                    borderColor: token.colorPrimaryHover
                },
                "&:hover a": {
                    color: token.itemActiveColorHover
                }
            }
        }
    };
};
const $61dc151943960caf$var$genPaginationStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    const [varName, varRef] = (0, $6870d4d7c14ae0bb$export$d82b8f66c5649e14)(antCls, "pagination");
    return {
        [componentCls]: {
            [varName(`item-size-actual`)]: (0, $05f34ed03d41967d$export$523c0b569236b342)(token.itemSize),
            [varName(`item-spacing-actual`)]: (0, $05f34ed03d41967d$export$523c0b569236b342)(token.marginXS),
            "&-small": {
                [varName(`item-size-actual`)]: (0, $05f34ed03d41967d$export$523c0b569236b342)(token.itemSizeSM),
                [varName(`item-spacing-actual`)]: (0, $05f34ed03d41967d$export$523c0b569236b342)(token.marginXXS)
            },
            "&-large": {
                [varName(`item-size-actual`)]: (0, $05f34ed03d41967d$export$523c0b569236b342)(token.itemSizeLG),
                [varName(`item-spacing-actual`)]: (0, $05f34ed03d41967d$export$523c0b569236b342)(token.marginSM)
            },
            ...(0, $519d20bf207ce864$export$23997c3e44cc1c59)(token),
            display: "flex",
            alignItems: "center",
            "&-start": {
                justifyContent: "start"
            },
            "&-center": {
                justifyContent: "center"
            },
            "&-end": {
                justifyContent: "end"
            },
            "ul, ol": {
                margin: 0,
                padding: 0,
                listStyle: "none"
            },
            "&::after": {
                display: "block",
                clear: "both",
                height: 0,
                overflow: "hidden",
                visibility: "hidden",
                content: '""'
            },
            [`${componentCls}-total-text`]: {
                display: "inline-block",
                height: varRef(`item-size-actual`),
                marginInlineEnd: varRef(`item-spacing-actual`),
                lineHeight: (0, $05f34ed03d41967d$export$523c0b569236b342)(token.calc(varRef(`item-size-actual`)).sub(2).equal()),
                verticalAlign: "middle"
            },
            // item style
            ...$61dc151943960caf$var$genPaginationItemStyle(token),
            // jump btn style
            ...$61dc151943960caf$var$genPaginationJumpStyle(token),
            // simple style
            ...$61dc151943960caf$var$genPaginationSimpleStyle(token),
            // input variant style
            ...$61dc151943960caf$var$genPaginationInputVariantStyle(token),
            // size style
            ...$61dc151943960caf$var$genPaginationSmallStyle(token),
            ...$61dc151943960caf$var$genPaginationLargeStyle(token),
            // disabled style
            ...$61dc151943960caf$var$genPaginationDisabledStyle(token),
            // media query style
            [`@media only screen and (max-width: ${token.screenLG}px)`]: {
                [`${componentCls}-item`]: {
                    "&-after-jump-prev, &-before-jump-next": {
                        display: "none"
                    }
                }
            },
            [`@media only screen and (max-width: ${token.screenSM}px)`]: {
                [`${componentCls}-options`]: {
                    display: "none"
                }
            }
        },
        // rtl style
        [`&${token.componentCls}-rtl`]: {
            direction: "rtl"
        }
    };
};
const $61dc151943960caf$var$genPaginationFocusStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}:not(${componentCls}-disabled)`]: {
            [`${componentCls}-item`]: {
                ...(0, $519d20bf207ce864$export$a44db842bcb28231)(token)
            },
            [`${componentCls}-jump-prev, ${componentCls}-jump-next`]: {
                "&:focus-visible": {
                    [`${componentCls}-item-link-icon`]: {
                        opacity: 1
                    },
                    [`${componentCls}-item-ellipsis`]: {
                        opacity: 0
                    },
                    ...(0, $519d20bf207ce864$export$6539948f0a737e39)(token)
                }
            },
            [`${componentCls}-prev, ${componentCls}-next`]: {
                [`&:focus-visible ${componentCls}-item-link`]: (0, $519d20bf207ce864$export$6539948f0a737e39)(token)
            }
        }
    };
};
const $61dc151943960caf$export$9ca1be8807fe0675 = (token)=>({
        itemBg: token.colorBgContainer,
        itemSize: token.controlHeight,
        itemSizeSM: token.controlHeightSM,
        itemSizeLG: token.controlHeightLG,
        itemActiveBg: token.colorBgContainer,
        itemActiveColor: token.colorPrimary,
        itemActiveColorHover: token.colorPrimaryHover,
        itemLinkBg: token.colorBgContainer,
        itemActiveColorDisabled: token.colorTextDisabled,
        itemActiveBgDisabled: token.controlItemBgActiveDisabled,
        itemInputBg: token.colorBgContainer,
        miniOptionsSizeChangerTop: 0,
        ...(0, $5e693f0c6e8784bd$export$bd8b682992bc9781)(token)
    });
const $61dc151943960caf$export$362fb92a8f81bbf9 = (token)=>(0, $fef50f256b80dfa5$export$4950aa0f605343fb)(token, {
        inputOutlineOffset: 0,
        quickJumperInputWidth: token.calc(token.controlHeightLG).mul(1.25).equal(),
        paginationMiniOptionsMarginInlineStart: token.calc(token.marginXXS).div(2).equal(),
        paginationMiniQuickJumperInputWidth: token.calc(token.controlHeightLG).mul(1.1).equal(),
        paginationItemPaddingInline: token.calc(token.marginXXS).mul(1.5).equal(),
        paginationEllipsisLetterSpacing: token.calc(token.marginXXS).div(2).equal(),
        paginationSlashMarginInlineStart: token.marginSM,
        paginationSlashMarginInlineEnd: token.marginSM,
        paginationEllipsisTextIndent: "0.13em" // magic for ui experience
    }, (0, $5e693f0c6e8784bd$export$a157d95850191a12)(token));
var // ============================== Export ==============================
$61dc151943960caf$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$51ec95de45185b42)("Pagination", (token)=>{
    const paginationToken = $61dc151943960caf$export$362fb92a8f81bbf9(token);
    return [
        $61dc151943960caf$var$genPaginationStyle(paginationToken),
        $61dc151943960caf$var$genPaginationFocusStyle(paginationToken)
    ];
}, $61dc151943960caf$export$9ca1be8807fe0675);





const $cae7ed9c796409da$var$genBorderedStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}${componentCls}-bordered${componentCls}-disabled`]: {
            "&, &:hover": {
                [`${componentCls}-item-link`]: {
                    borderColor: token.colorBorder
                }
            },
            "&:focus-visible": {
                [`${componentCls}-item-link`]: {
                    borderColor: token.colorBorder
                }
            },
            [`${componentCls}-item, ${componentCls}-item-link`]: {
                backgroundColor: token.colorBgContainerDisabled,
                borderColor: token.colorBorder,
                [`&:hover:not(${componentCls}-item-active)`]: {
                    backgroundColor: token.colorBgContainerDisabled,
                    borderColor: token.colorBorder,
                    a: {
                        color: token.colorTextDisabled
                    }
                },
                [`&${componentCls}-item-active`]: {
                    backgroundColor: token.itemActiveBgDisabled
                }
            },
            [`${componentCls}-prev, ${componentCls}-next`]: {
                "&:hover button": {
                    backgroundColor: token.colorBgContainerDisabled,
                    borderColor: token.colorBorder,
                    color: token.colorTextDisabled
                },
                [`${componentCls}-item-link`]: {
                    backgroundColor: token.colorBgContainerDisabled,
                    borderColor: token.colorBorder
                }
            }
        },
        [`${componentCls}${componentCls}-bordered`]: {
            [`${componentCls}-prev, ${componentCls}-next`]: {
                "&:hover button": {
                    borderColor: token.colorPrimaryHover,
                    backgroundColor: token.itemBg
                },
                [`${componentCls}-item-link`]: {
                    backgroundColor: token.itemLinkBg,
                    borderColor: token.colorBorder
                },
                [`&:hover ${componentCls}-item-link`]: {
                    borderColor: token.colorPrimary,
                    backgroundColor: token.itemBg,
                    color: token.colorPrimary
                },
                [`&${componentCls}-disabled`]: {
                    [`${componentCls}-item-link`]: {
                        borderColor: token.colorBorder,
                        color: token.colorTextDisabled
                    }
                }
            },
            [`${componentCls}-item`]: {
                backgroundColor: token.itemBg,
                border: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                [`&:hover:not(${componentCls}-item-active)`]: {
                    borderColor: token.colorPrimary,
                    backgroundColor: token.itemBg,
                    a: {
                        color: token.colorPrimary
                    }
                },
                "&-active": {
                    borderColor: token.colorPrimary
                }
            }
        }
    };
};
var $cae7ed9c796409da$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$1537386bc155ea56)([
    "Pagination",
    "bordered"
], (token)=>{
    const paginationToken = (0, $61dc151943960caf$export$362fb92a8f81bbf9)(token);
    return $cae7ed9c796409da$var$genBorderedStyle(paginationToken);
}, (0, $61dc151943960caf$export$9ca1be8807fe0675));



var $cQmXV = parcelRequire("cQmXV");

function $d2db1f4386277c2d$export$2e2bcd8739ae039(showSizeChanger) {
    return (0, $cQmXV.useMemo)(()=>{
        if (typeof showSizeChanger === "boolean") return [
            showSizeChanger,
            {}
        ];
        if ((0, $8e2d153a3c855782$export$53b83ca8eaab0383)(showSizeChanger)) return [
            true,
            showSizeChanger
        ];
        return [
            undefined,
            undefined
        ];
    }, [
        showSizeChanger
    ]);
}


"use client";
const $d37cf4d4a3fea39b$var$Pagination = (props)=>{
    const { align: align, prefixCls: customizePrefixCls, selectPrefixCls: customizeSelectPrefixCls, className: className, rootClassName: rootClassName, style: style, size: customizeSize, locale: customLocale, responsive: responsive, showSizeChanger: showSizeChanger, components: components, selectComponentClass: selectComponentClass, pageSizeOptions: pageSizeOptions, styles: styles, classNames: classNames, ...restProps } = props;
    const { xs: xs } = (0, $27af0f2a794acde0$export$2e2bcd8739ae039)(responsive);
    const [, token] = (0, $b22e03a54a548614$export$2e2bcd8739ae039)();
    const { getPrefixCls: getPrefixCls, direction: direction, showSizeChanger: contextShowSizeChangerConfig, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles, totalBoundaryShowSizeChanger: contextTotalBoundaryShowSizeChanger } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("pagination");
    const prefixCls = getPrefixCls("pagination", customizePrefixCls);
    // Style
    const [hashId, cssVarCls] = (0, $61dc151943960caf$export$2e2bcd8739ae039)(prefixCls);
    // ============================== Size ==============================
    const mergedSize = (0, $78cdfb6138721329$export$2e2bcd8739ae039)(customizeSize);
    const isSmall = mergedSize === "small" || !!(xs && !mergedSize && responsive);
    const [inputVariant, enableInputVariantCls] = (0, $11c15dfa3883fb6f$export$2e2bcd8739ae039)("input");
    // =========== Merged Props for Semantic ==========
    const mergedProps = {
        ...props,
        size: mergedSize
    };
    // ========================= Style ==========================
    const contextStyleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $30c5f9f911d4f61b$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: mergedProps
    });
    // ============================= Locale =============================
    const [contextLocale] = (0, $c953dac9d015386e$export$2e2bcd8739ae039)("Pagination", (0, $879775c0fcd9ca37$export$2e2bcd8739ae039));
    const locale = {
        ...contextLocale,
        ...customLocale
    };
    // ========================== Size Changer ==========================
    // Merge the props showSizeChanger
    const [propShowSizeChanger, propSizeChangerSelectProps] = (0, $d2db1f4386277c2d$export$2e2bcd8739ae039)(showSizeChanger);
    const [contextShowSizeChanger, contextSizeChangerSelectProps] = (0, $d2db1f4386277c2d$export$2e2bcd8739ae039)(contextShowSizeChangerConfig);
    const mergedShowSizeChanger = propShowSizeChanger ?? contextShowSizeChanger;
    const mergedShowSizeChangerSelectProps = propSizeChangerSelectProps ?? contextSizeChangerSelectProps;
    const SizeChanger = selectComponentClass || (0, $872fd39f1285217b$export$2e2bcd8739ae039);
    // Generate options
    const mergedPageSizeOptions = $cQmXV.useMemo(()=>{
        return pageSizeOptions ? pageSizeOptions.map(Number) : undefined;
    }, [
        pageSizeOptions
    ]);
    // Render size changer
    const sizeChangerRender = (info)=>{
        const { disabled: disabled, size: pageSize, onSizeChange: onSizeChange, "aria-label": ariaLabel, className: sizeChangerClassName, options: options } = info;
        const SizeChangerComponent = components?.sizeChanger;
        if (SizeChangerComponent) return /*#__PURE__*/ $cQmXV.createElement(SizeChangerComponent, {
            value: pageSize,
            onChange: onSizeChange,
            disabled: !!disabled,
            className: sizeChangerClassName
        });
        const { className: propSizeChangerClassName, onChange: propSizeChangerOnChange } = mergedShowSizeChangerSelectProps || {};
        // Origin Select is using Select.Option,
        // So it make the option value must be string
        // Just for compatible
        const selectedValue = options.find((option)=>String(option.value) === String(pageSize))?.value;
        return /*#__PURE__*/ $cQmXV.createElement(SizeChanger, {
            disabled: disabled,
            showSearch: true,
            popupMatchSelectWidth: false,
            getPopupContainer: (triggerNode)=>triggerNode.parentNode,
            "aria-label": ariaLabel,
            options: options,
            ...mergedShowSizeChangerSelectProps,
            value: selectedValue,
            onChange: (nextSize, option)=>{
                onSizeChange?.(nextSize);
                propSizeChangerOnChange?.(nextSize, option);
            },
            size: mergedSize,
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-options-size-changer-select`, sizeChangerClassName, propSizeChangerClassName)
        });
    };
    // ============================= Render =============================
    const iconsProps = $cQmXV.useMemo(()=>{
        const ellipsis = /*#__PURE__*/ $cQmXV.createElement("span", {
            className: `${prefixCls}-item-ellipsis`
        }, /*#__PURE__*/ $cQmXV.createElement((0, $f172eb883972dae9$export$2e2bcd8739ae039), null));
        const prevIcon = /*#__PURE__*/ $cQmXV.createElement("button", {
            className: `${prefixCls}-item-link`,
            type: "button",
            tabIndex: -1
        }, direction === "rtl" ? /*#__PURE__*/ $cQmXV.createElement((0, $89db7229a7e10f8f$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $cQmXV.createElement((0, $0f3c6d60b091c877$export$2e2bcd8739ae039), null));
        const nextIcon = /*#__PURE__*/ $cQmXV.createElement("button", {
            className: `${prefixCls}-item-link`,
            type: "button",
            tabIndex: -1
        }, direction === "rtl" ? /*#__PURE__*/ $cQmXV.createElement((0, $0f3c6d60b091c877$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $cQmXV.createElement((0, $89db7229a7e10f8f$export$2e2bcd8739ae039), null));
        const jumpPrevIcon = /*#__PURE__*/ $cQmXV.createElement("a", {
            className: `${prefixCls}-item-link`
        }, /*#__PURE__*/ $cQmXV.createElement("div", {
            className: `${prefixCls}-item-container`
        }, direction === "rtl" ? /*#__PURE__*/ $cQmXV.createElement((0, $1e8d754253c41ae7$export$2e2bcd8739ae039), {
            className: `${prefixCls}-item-link-icon`
        }) : /*#__PURE__*/ $cQmXV.createElement((0, $e3da9ea1c6385a97$export$2e2bcd8739ae039), {
            className: `${prefixCls}-item-link-icon`
        }), ellipsis));
        const jumpNextIcon = /*#__PURE__*/ $cQmXV.createElement("a", {
            className: `${prefixCls}-item-link`
        }, /*#__PURE__*/ $cQmXV.createElement("div", {
            className: `${prefixCls}-item-container`
        }, direction === "rtl" ? /*#__PURE__*/ $cQmXV.createElement((0, $e3da9ea1c6385a97$export$2e2bcd8739ae039), {
            className: `${prefixCls}-item-link-icon`
        }) : /*#__PURE__*/ $cQmXV.createElement((0, $1e8d754253c41ae7$export$2e2bcd8739ae039), {
            className: `${prefixCls}-item-link-icon`
        }), ellipsis));
        return {
            prevIcon: prevIcon,
            nextIcon: nextIcon,
            jumpPrevIcon: jumpPrevIcon,
            jumpNextIcon: jumpNextIcon
        };
    }, [
        direction,
        prefixCls
    ]);
    const selectPrefixCls = getPrefixCls("select", customizeSelectPrefixCls);
    const extendedClassName = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)({
        [`${prefixCls}-${align}`]: !!align,
        [`${prefixCls}-${mergedSize}`]: mergedSize,
        [`${prefixCls}-${inputVariant}`]: enableInputVariantCls && inputVariant !== "outlined",
        /** @deprecated Should be removed in v7 */ [`${prefixCls}-mini`]: isSmall,
        [`${prefixCls}-rtl`]: direction === "rtl",
        [`${prefixCls}-bordered`]: token.wireframe
    }, contextClassName, className, rootClassName, mergedClassNames.root, hashId, cssVarCls);
    const mergedStyle = {
        ...mergedStyles.root
    };
    return /*#__PURE__*/ $cQmXV.createElement($cQmXV.Fragment, null, token.wireframe && /*#__PURE__*/ $cQmXV.createElement((0, $cae7ed9c796409da$export$2e2bcd8739ae039), {
        prefixCls: prefixCls
    }), /*#__PURE__*/ $cQmXV.createElement((0, $e7888fdfe5e784c3$export$2e2bcd8739ae039), {
        ...iconsProps,
        ...restProps,
        styles: mergedStyles,
        classNames: mergedClassNames,
        style: mergedStyle,
        prefixCls: prefixCls,
        selectPrefixCls: selectPrefixCls,
        className: extendedClassName,
        locale: locale,
        pageSizeOptions: mergedPageSizeOptions,
        showSizeChanger: mergedShowSizeChanger,
        totalBoundaryShowSizeChanger: restProps.totalBoundaryShowSizeChanger ?? contextTotalBoundaryShowSizeChanger,
        sizeChangerRender: sizeChangerRender
    }));
};
var $d37cf4d4a3fea39b$export$2e2bcd8739ae039 = $d37cf4d4a3fea39b$var$Pagination;


"use client";
var $d12a15546f53270f$export$2e2bcd8739ae039 = (0, $d37cf4d4a3fea39b$export$2e2bcd8739ae039);





var $cQmXV = parcelRequire("cQmXV");

"use client";
function $cd48f9e57ec43261$var$renderExpandIcon(locale) {
    return (props)=>{
        const { prefixCls: prefixCls, onExpand: onExpand, record: record, expanded: expanded, expandable: expandable } = props;
        const iconPrefix = `${prefixCls}-row-expand-icon`;
        return /*#__PURE__*/ $cQmXV.createElement("button", {
            type: "button",
            onClick: (e)=>{
                onExpand(record, e);
                e.stopPropagation();
            },
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(iconPrefix, {
                [`${iconPrefix}-spaced`]: !expandable,
                [`${iconPrefix}-expanded`]: expandable && expanded,
                [`${iconPrefix}-collapsed`]: expandable && !expanded
            }),
            "aria-label": expanded ? locale.collapse : locale.expand,
            "aria-expanded": expanded
        });
    };
}
var $cd48f9e57ec43261$export$2e2bcd8739ae039 = $cd48f9e57ec43261$var$renderExpandIcon;



var $cQmXV = parcelRequire("cQmXV");

const $9ccd3ed80466adfb$var$getMergedFilters = (filters)=>{
    const mergedFilters = {};
    for (const [key, value] of Object.entries(filters))if ((0, $8e2d153a3c855782$export$826fff653a329e83)(value)) mergedFilters[key] = value;
    return mergedFilters;
};
const $9ccd3ed80466adfb$var$useColumnTitleProps = (sorterTitleProps, filters)=>{
    const columnTitleProps = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useMemo(()=>{
        return {
            ...sorterTitleProps,
            filters: $9ccd3ed80466adfb$var$getMergedFilters(filters)
        };
    }, [
        sorterTitleProps,
        filters
    ]);
    return columnTitleProps;
};
var $9ccd3ed80466adfb$export$2e2bcd8739ae039 = $9ccd3ed80466adfb$var$useColumnTitleProps;


function $8ea7415ad0b1a757$export$2e2bcd8739ae039(prefixCls) {
    const getContainerWidth = (ele, width)=>{
        const container = ele.querySelector(`.${prefixCls}-container`);
        let returnWidth = width;
        if (container) {
            const style = getComputedStyle(container);
            const borderLeft = Number.parseInt(style.borderLeftWidth, 10);
            const borderRight = Number.parseInt(style.borderRightWidth, 10);
            returnWidth = width - borderLeft - borderRight;
        }
        return returnWidth;
    };
    return getContainerWidth;
}



var $cQmXV = parcelRequire("cQmXV");



const $ecd540434d598912$var$useFilledColumns = (columns, column)=>$cQmXV.useMemo(()=>{
        if (!column) return columns;
        const fillColumns = (currentColumns)=>currentColumns.map((col)=>{
                if (col === (0, $c3a712de976be5d3$export$ed10248435b8f218) || col === (0, $9848d298b42e15e6$export$e1053575ddfcb301)) return col;
                if ("children" in col && Array.isArray(col.children)) {
                    const mergedColumn = (0, $5bb86b4f753905a4$export$2e2bcd8739ae039)(column, col);
                    return {
                        ...mergedColumn,
                        children: fillColumns(col.children)
                    };
                }
                const columnWithoutChildren = (0, $e8c5093aebad6025$export$2e2bcd8739ae039)(column, [
                    "children"
                ]);
                return (0, $5bb86b4f753905a4$export$2e2bcd8739ae039)(columnWithoutChildren, col);
            });
        return fillColumns(columns);
    }, [
        columns,
        column
    ]);
var $ecd540434d598912$export$2e2bcd8739ae039 = $ecd540434d598912$var$useFilledColumns;




var $cQmXV = parcelRequire("cQmXV");


const $b811e249bf5f95a4$export$480219a02f196e72 = (column, defaultKey)=>{
    if ("key" in column && (0, $8e2d153a3c855782$export$826fff653a329e83)(column.key)) return column.key;
    if (column.dataIndex) return Array.isArray(column.dataIndex) ? column.dataIndex.join(".") : column.dataIndex;
    return defaultKey;
};
function $b811e249bf5f95a4$export$7e4db04adce9b4db(index, pos) {
    return pos ? `${pos}-${index}` : `${index}`;
}
const $b811e249bf5f95a4$export$cfda450db2088de7 = (title, props)=>{
    if ((0, $8e2d153a3c855782$export$f6e2535fb5126e54)(title)) return title(props);
    return title;
};
const $b811e249bf5f95a4$export$1c24e0676a106839 = (title, props)=>{
    const result = $b811e249bf5f95a4$export$cfda450db2088de7(title, props);
    if ((0, $8e2d153a3c855782$export$53b83ca8eaab0383)(result) || Array.isArray(result)) return "";
    return result;
};
const $b811e249bf5f95a4$export$54152637af0f17a7 = (pos)=>{
    const lowerPos = pos.toLowerCase();
    if (lowerPos.includes("center")) return "center";
    return lowerPos.includes("left") || lowerPos.includes("start") ? "start" : "end";
};
const $b811e249bf5f95a4$export$ff0688c2106d1e55 = (paginationSize, mergedSize)=>{
    if (paginationSize) return paginationSize;
    if (mergedSize === "small" || mergedSize === "medium") return "small";
    return undefined;
};




var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");
var $57fc2533fce1cb38$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($57fc2533fce1cb38$exports, "__esModule", {
    value: true
});
var $57fc2533fce1cb38$var$FilterFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M349 838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V642H349v196zm531.1-684H143.9c-24.5 0-39.8 26.7-27.5 48l221.3 376h348.8l221.3-376c12.1-21.3-3.2-48-27.7-48z"
                }
            }
        ]
    },
    "name": "filter",
    "theme": "filled"
};
$57fc2533fce1cb38$exports.default = $57fc2533fce1cb38$var$FilterFilled;



function $b234cc74575cfd65$var$_extends() {
    $b234cc74575cfd65$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b234cc74575cfd65$var$_extends.apply(this, arguments);
}
const $b234cc74575cfd65$var$FilterFilled = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $b234cc74575cfd65$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($57fc2533fce1cb38$exports)))
    }));
/**![filter](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTM0OSA4MzhjMCAxNy43IDE0LjIgMzIgMzEuOCAzMmgyNjIuNGMxNy42IDAgMzEuOC0xNC4zIDMxLjgtMzJWNjQySDM0OXYxOTZ6bTUzMS4xLTY4NEgxNDMuOWMtMjQuNSAwLTM5LjggMjYuNy0yNy41IDQ4bDIyMS4zIDM3NmgzNDguOGwyMjEuMy0zNzZjMTIuMS0yMS4zLTMuMi00OC0yNy43LTQ4eiIgLz48L3N2Zz4=) */ const $b234cc74575cfd65$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($b234cc74575cfd65$var$FilterFilled);
var $b234cc74575cfd65$export$2e2bcd8739ae039 = $b234cc74575cfd65$var$RefIcon;





var $cQmXV = parcelRequire("cQmXV");

const $6bbcacb14b126c6b$export$bd58d1a153fd4998 = (initialValue)=>{
    const ref = $cQmXV.useRef(initialValue);
    const [, forceUpdate] = (0, $4ba220b3356f61b8$export$91db9bc4f8ac944a)();
    return [
        ()=>ref.current,
        (newValue)=>{
            ref.current = newValue;
            forceUpdate();
        }
    ];
};















var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");
var $5b4dad798c3f85a0$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($5b4dad798c3f85a0$exports, "__esModule", {
    value: true
});
var $5b4dad798c3f85a0$var$FileOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494z"
                }
            }
        ]
    },
    "name": "file",
    "theme": "outlined"
};
$5b4dad798c3f85a0$exports.default = $5b4dad798c3f85a0$var$FileOutlined;



function $cf187e4b16fb1e1e$var$_extends() {
    $cf187e4b16fb1e1e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $cf187e4b16fb1e1e$var$_extends.apply(this, arguments);
}
const $cf187e4b16fb1e1e$var$FileOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $cf187e4b16fb1e1e$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5b4dad798c3f85a0$exports)))
    }));
/**![file](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg1NC42IDI4OC42TDYzOS40IDczLjRjLTYtNi0xNC4xLTkuNC0yMi42LTkuNEgxOTJjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjgzMmMwIDE3LjcgMTQuMyAzMiAzMiAzMmg2NDBjMTcuNyAwIDMyLTE0LjMgMzItMzJWMzExLjNjMC04LjUtMy40LTE2LjctOS40LTIyLjd6TTc5MC4yIDMyNkg2MDJWMTM3LjhMNzkwLjIgMzI2em0xLjggNTYySDIzMlYxMzZoMzAydjIxNmE0MiA0MiAwIDAwNDIgNDJoMjE2djQ5NHoiIC8+PC9zdmc+) */ const $cf187e4b16fb1e1e$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($cf187e4b16fb1e1e$var$FileOutlined);
var $cf187e4b16fb1e1e$export$2e2bcd8739ae039 = $cf187e4b16fb1e1e$var$RefIcon;



var $cQmXV = parcelRequire("cQmXV");
var $34528ac33cabd6ec$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($34528ac33cabd6ec$exports, "__esModule", {
    value: true
});
var $34528ac33cabd6ec$var$FolderOpenOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 00-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zM136 256h188.5l119.6 114.4H748V444H238c-13 0-24.8 7.9-29.7 20L136 643.2V256zm635.3 512H159l103.3-256h612.4L771.3 768z"
                }
            }
        ]
    },
    "name": "folder-open",
    "theme": "outlined"
};
$34528ac33cabd6ec$exports.default = $34528ac33cabd6ec$var$FolderOpenOutlined;



function $9432f33b30bd03c9$var$_extends() {
    $9432f33b30bd03c9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9432f33b30bd03c9$var$_extends.apply(this, arguments);
}
const $9432f33b30bd03c9$var$FolderOpenOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $9432f33b30bd03c9$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($34528ac33cabd6ec$exports)))
    }));
/**![folder-open](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkyOCA0NDRIODIwVjMzMC40YzAtMTcuNy0xNC4zLTMyLTMyLTMySDQ3M0wzNTUuNyAxODYuMmE4LjE1IDguMTUgMCAwMC01LjUtMi4ySDk2Yy0xNy43IDAtMzIgMTQuMy0zMiAzMnY1OTJjMCAxNy43IDE0LjMgMzIgMzIgMzJoNjk4YzEzIDAgMjQuOC03LjkgMjkuNy0yMGwxMzQtMzMyYzEuNS0zLjggMi4zLTcuOSAyLjMtMTIgMC0xNy43LTE0LjMtMzItMzItMzJ6TTEzNiAyNTZoMTg4LjVsMTE5LjYgMTE0LjRINzQ4VjQ0NEgyMzhjLTEzIDAtMjQuOCA3LjktMjkuNyAyMEwxMzYgNjQzLjJWMjU2em02MzUuMyA1MTJIMTU5bDEwMy4zLTI1Nmg2MTIuNEw3NzEuMyA3Njh6IiAvPjwvc3ZnPg==) */ const $9432f33b30bd03c9$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($9432f33b30bd03c9$var$FolderOpenOutlined);
var $9432f33b30bd03c9$export$2e2bcd8739ae039 = $9432f33b30bd03c9$var$RefIcon;



var $cQmXV = parcelRequire("cQmXV");
var $dab3c5bb61eff0b7$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($dab3c5bb61eff0b7$exports, "__esModule", {
    value: true
});
var $dab3c5bb61eff0b7$var$FolderOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M880 298.4H521L403.7 186.2a8.15 8.15 0 00-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z"
                }
            }
        ]
    },
    "name": "folder",
    "theme": "outlined"
};
$dab3c5bb61eff0b7$exports.default = $dab3c5bb61eff0b7$var$FolderOutlined;



function $98f23cd1dae7e57a$var$_extends() {
    $98f23cd1dae7e57a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $98f23cd1dae7e57a$var$_extends.apply(this, arguments);
}
const $98f23cd1dae7e57a$var$FolderOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $98f23cd1dae7e57a$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dab3c5bb61eff0b7$exports)))
    }));
/**![folder](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg4MCAyOTguNEg1MjFMNDAzLjcgMTg2LjJhOC4xNSA4LjE1IDAgMDAtNS41LTIuMkgxNDRjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjU5MmMwIDE3LjcgMTQuMyAzMiAzMiAzMmg3MzZjMTcuNyAwIDMyLTE0LjMgMzItMzJWMzMwLjRjMC0xNy43LTE0LjMtMzItMzItMzJ6TTg0MCA3NjhIMTg0VjI1NmgxODguNWwxMTkuNiAxMTQuNEg4NDBWNzY4eiIgLz48L3N2Zz4=) */ const $98f23cd1dae7e57a$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($98f23cd1dae7e57a$var$FolderOutlined);
var $98f23cd1dae7e57a$export$2e2bcd8739ae039 = $98f23cd1dae7e57a$var$RefIcon;






var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");
var $1fd56ff8a1d9cc78$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($1fd56ff8a1d9cc78$exports, "__esModule", {
    value: true
});
var $1fd56ff8a1d9cc78$var$HolderOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M300 276.5a56 56 0 1056-97 56 56 0 00-56 97zm0 284a56 56 0 1056-97 56 56 0 00-56 97zM640 228a56 56 0 10112 0 56 56 0 00-112 0zm0 284a56 56 0 10112 0 56 56 0 00-112 0zM300 844.5a56 56 0 1056-97 56 56 0 00-56 97zM640 796a56 56 0 10112 0 56 56 0 00-112 0z"
                }
            }
        ]
    },
    "name": "holder",
    "theme": "outlined"
};
$1fd56ff8a1d9cc78$exports.default = $1fd56ff8a1d9cc78$var$HolderOutlined;



function $6567d5702c12b1b9$var$_extends() {
    $6567d5702c12b1b9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6567d5702c12b1b9$var$_extends.apply(this, arguments);
}
const $6567d5702c12b1b9$var$HolderOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $6567d5702c12b1b9$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1fd56ff8a1d9cc78$exports)))
    }));
/**![holder](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTMwMCAyNzYuNWE1NiA1NiAwIDEwNTYtOTcgNTYgNTYgMCAwMC01NiA5N3ptMCAyODRhNTYgNTYgMCAxMDU2LTk3IDU2IDU2IDAgMDAtNTYgOTd6TTY0MCAyMjhhNTYgNTYgMCAxMDExMiAwIDU2IDU2IDAgMDAtMTEyIDB6bTAgMjg0YTU2IDU2IDAgMTAxMTIgMCA1NiA1NiAwIDAwLTExMiAwek0zMDAgODQ0LjVhNTYgNTYgMCAxMDU2LTk3IDU2IDU2IDAgMDAtNTYgOTd6TTY0MCA3OTZhNTYgNTYgMCAxMDExMiAwIDU2IDU2IDAgMDAtMTEyIDB6IiAvPjwvc3ZnPg==) */ const $6567d5702c12b1b9$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($6567d5702c12b1b9$var$HolderOutlined);
var $6567d5702c12b1b9$export$2e2bcd8739ae039 = $6567d5702c12b1b9$var$RefIcon;
















// ============================ Directory =============================
const $729d20baec4e7325$export$2f47474ee6fcebcf = ({ treeCls: treeCls, treeNodeCls: treeNodeCls, directoryNodeSelectedBg: directoryNodeSelectedBg, directoryNodeSelectedColor: directoryNodeSelectedColor, motionDurationMid: motionDurationMid, borderRadius: borderRadius, controlItemBgHover: controlItemBgHover })=>({
        [`${treeCls}${treeCls}-directory ${treeNodeCls}`]: {
            // >>> Title
            [`${treeCls}-node-content-wrapper`]: {
                position: "static",
                [`&:has(${treeCls}-drop-indicator)`]: {
                    position: "relative"
                },
                [`> *:not(${treeCls}-drop-indicator)`]: {
                    position: "relative"
                },
                "&:hover": {
                    background: "transparent"
                },
                // Expand interactive area to whole line
                "&:before": {
                    position: "absolute",
                    inset: 0,
                    transition: `background-color ${motionDurationMid}`,
                    content: '""',
                    borderRadius: borderRadius
                },
                "&:hover:before": {
                    background: controlItemBgHover
                }
            },
            [`${treeCls}-switcher, ${treeCls}-checkbox, ${treeCls}-draggable-icon`]: {
                zIndex: 1
            },
            // ============= Selected =============
            "&-selected": {
                background: directoryNodeSelectedBg,
                borderRadius: borderRadius,
                [`${treeCls}-switcher, ${treeCls}-draggable-icon`]: {
                    color: directoryNodeSelectedColor
                },
                // >>> Title
                [`${treeCls}-node-content-wrapper`]: {
                    color: directoryNodeSelectedColor,
                    background: "transparent",
                    "&, &:hover": {
                        color: directoryNodeSelectedColor
                    },
                    "&:before, &:hover:before": {
                        background: directoryNodeSelectedBg
                    }
                }
            }
        }
    });


// ============================ Keyframes =============================
const $46aba4acab4b1935$var$treeNodeFX = new (0, $e928d3664c9ed565$export$2e2bcd8739ae039)("ant-tree-node-fx-do-not-use", {
    "0%": {
        opacity: 0
    },
    "100%": {
        opacity: 1
    }
});
// ============================== Switch ==============================
const $46aba4acab4b1935$var$getSwitchStyle = (prefixCls, token)=>({
        [`.${prefixCls}-switcher-icon`]: {
            display: "inline-block",
            fontSize: 10,
            verticalAlign: "baseline",
            svg: {
                transition: `transform ${token.motionDurationSlow}`
            }
        }
    });
// =============================== Drop ===============================
const $46aba4acab4b1935$var$getDropIndicatorStyle = (prefixCls, token)=>({
        [`.${prefixCls}-drop-indicator`]: {
            position: "absolute",
            // it should displayed over the following node
            zIndex: 1,
            height: 2,
            backgroundColor: token.colorPrimary,
            borderRadius: 1,
            pointerEvents: "none",
            "&:after": {
                position: "absolute",
                top: -3,
                insetInlineStart: -6,
                width: 8,
                height: 8,
                backgroundColor: "transparent",
                border: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidthBold)} solid ${token.colorPrimary}`,
                borderRadius: "50%",
                content: '""'
            }
        }
    });
const $46aba4acab4b1935$export$5ca74f7be820a85 = (prefixCls, token)=>{
    const { treeCls: treeCls, treeNodeCls: treeNodeCls, treeNodePadding: treeNodePadding, titleHeight: titleHeight, indentSize: indentSize, switcherSize: switcherSize, motionDurationMid: motionDurationMid, nodeSelectedBg: nodeSelectedBg, nodeHoverBg: nodeHoverBg, colorTextQuaternary: colorTextQuaternary, controlItemBgActiveDisabled: controlItemBgActiveDisabled } = token;
    return {
        [treeCls]: {
            ...(0, $519d20bf207ce864$export$23997c3e44cc1c59)(token),
            // fix https://github.com/ant-design/ant-design/issues/50316
            ["--rc-virtual-list-scrollbar-bg"]: token.colorSplit,
            background: token.colorBgContainer,
            borderRadius: token.borderRadius,
            transition: `background-color ${token.motionDurationSlow}`,
            "&-rtl": {
                direction: "rtl"
            },
            [`&${treeCls}-rtl ${treeCls}-switcher_close ${treeCls}-switcher-icon svg`]: {
                transform: "rotate(90deg)"
            },
            // =================== Virtual List ===================
            [`${treeCls}-list`]: {
                "&:focus-visible": {
                    outline: "none",
                    [`${treeNodeCls}-active ${treeCls}-node-content-wrapper`]: {
                        ...(0, $519d20bf207ce864$export$6539948f0a737e39)(token)
                    }
                }
            },
            [`${treeCls}-list-scrollbar`]: {
                cursor: "pointer",
                "&:hover": {
                    backgroundColor: token.colorFillQuaternary
                }
            },
            [`${treeCls}-list-holder-inner`]: {
                alignItems: "flex-start"
            },
            [`&${treeCls}-block-node`]: {
                [`${treeCls}-list-holder-inner`]: {
                    alignItems: "stretch",
                    // >>> Title
                    [`${treeCls}-node-content-wrapper`]: {
                        flex: "auto"
                    },
                    // >>> Drag
                    [`${treeNodeCls}.dragging:after`]: {
                        position: "absolute",
                        inset: 0,
                        border: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorPrimary}`,
                        opacity: 0,
                        animationName: $46aba4acab4b1935$var$treeNodeFX,
                        animationDuration: token.motionDurationSlow,
                        animationPlayState: "running",
                        animationFillMode: "forwards",
                        content: '""',
                        pointerEvents: "none",
                        borderRadius: token.borderRadius
                    }
                }
            },
            // ===================== TreeNode =====================
            [treeNodeCls]: {
                display: "flex",
                alignItems: "flex-start",
                marginBottom: treeNodePadding,
                lineHeight: (0, $05f34ed03d41967d$export$523c0b569236b342)(titleHeight),
                position: "relative",
                // 非常重要，避免 drop-indicator 在拖拽过程中闪烁
                "&:before": {
                    content: '""',
                    position: "absolute",
                    zIndex: 1,
                    insetInlineStart: 0,
                    width: "100%",
                    top: "100%",
                    height: treeNodePadding
                },
                // Disabled
                [`&-disabled ${treeCls}-node-content-wrapper`]: {
                    color: token.colorTextDisabled,
                    cursor: "not-allowed",
                    "&:hover": {
                        background: "transparent"
                    }
                },
                [`${treeCls}-checkbox-disabled + ${treeCls}-node-selected,&${treeNodeCls}-disabled${treeNodeCls}-selected ${treeCls}-node-content-wrapper`]: {
                    backgroundColor: controlItemBgActiveDisabled
                },
                // we can not set pointer-events to none for checkbox in tree
                // ref: https://github.com/ant-design/ant-design/issues/39822#issuecomment-2605234058
                [`${treeCls}-checkbox-disabled`]: {
                    pointerEvents: "unset"
                },
                // not disable
                [`&:not(${treeNodeCls}-disabled)`]: {
                    // >>> Title
                    [`${treeCls}-node-content-wrapper`]: {
                        "&:hover": {
                            color: token.nodeHoverColor
                        }
                    }
                },
                [`&-active ${treeCls}-node-content-wrapper`]: {
                    background: token.controlItemBgHover
                },
                [`&:not(${treeNodeCls}-disabled).filter-node ${treeCls}-title`]: {
                    color: token.colorPrimary,
                    fontWeight: token.fontWeightStrong
                },
                "&-draggable": {
                    cursor: "grab",
                    [`${treeCls}-draggable-icon`]: {
                        // https://github.com/ant-design/ant-design/issues/41915
                        flexShrink: 0,
                        width: switcherSize,
                        textAlign: "center",
                        visibility: "visible",
                        color: colorTextQuaternary
                    },
                    [`&${treeNodeCls}-disabled ${treeCls}-draggable-icon`]: {
                        visibility: "hidden"
                    }
                }
            },
            // >>> Indent
            [`${treeCls}-indent`]: {
                alignSelf: "stretch",
                whiteSpace: "nowrap",
                userSelect: "none",
                "&-unit": {
                    display: "inline-block",
                    width: indentSize
                }
            },
            // >>> Drag Handler
            [`${treeCls}-draggable-icon`]: {
                visibility: "hidden"
            },
            // Switcher / Checkbox
            [`${treeCls}-switcher, ${treeCls}-checkbox`]: {
                marginInlineEnd: token.calc(token.calc(switcherSize).sub(token.controlInteractiveSize)).div(2).equal()
            },
            // >>> Checkbox
            // https://github.com/ant-design/ant-design/issues/56957
            [`${treeCls}-checkbox`]: {
                flexShrink: 0,
                // When the title spans multiple lines, the checkbox aligns vertically centered with other elements
                // However, the switcher aligns to flex-start, causing a vertical alignment discrepancy in the parent node
                // Currently, the checkbox uses start alignment, but this causes it to stick to the top, resulting in a visually higher position
                // By setting the switcher's lineHeight to titleHeight, the required margin-block-start distance can be calculated to correct the alignment
                alignSelf: "flex-start",
                marginBlockStart: token.calc(token.calc(titleHeight).sub(token.controlInteractiveSize)).div(2).equal()
            },
            // >>> Switcher
            [`${treeCls}-switcher`]: {
                ...$46aba4acab4b1935$var$getSwitchStyle(prefixCls, token),
                position: "relative",
                flex: "none",
                alignSelf: "stretch",
                width: switcherSize,
                textAlign: "center",
                cursor: "pointer",
                userSelect: "none",
                transition: `all ${token.motionDurationSlow}`,
                "&-noop": {
                    cursor: "unset"
                },
                "&:before": {
                    pointerEvents: "none",
                    content: '""',
                    width: switcherSize,
                    height: titleHeight,
                    position: "absolute",
                    left: {
                        _skip_check_: true,
                        value: 0
                    },
                    top: 0,
                    borderRadius: token.borderRadius,
                    transition: `all ${token.motionDurationSlow}`
                },
                [`&:not(${treeCls}-switcher-noop):hover:before`]: {
                    backgroundColor: token.colorBgTextHover
                },
                [`&_close ${treeCls}-switcher-icon svg`]: {
                    transform: "rotate(-90deg)"
                },
                "&-loading-icon": {
                    color: token.colorPrimary
                },
                "&-leaf-line": {
                    position: "relative",
                    zIndex: 1,
                    display: "inline-block",
                    width: "100%",
                    height: "100%",
                    // https://github.com/ant-design/ant-design/issues/31884
                    "&:before": {
                        position: "absolute",
                        top: 0,
                        insetInlineEnd: token.calc(switcherSize).div(2).equal(),
                        bottom: token.calc(treeNodePadding).mul(-1).equal(),
                        marginInlineStart: token.calc(token.lineWidth).mul(-1).equal(),
                        borderInlineEnd: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                        content: '""'
                    },
                    "&:after": {
                        position: "absolute",
                        width: token.calc(token.calc(switcherSize).div(2).equal()).mul(0.8).equal(),
                        height: token.calc(titleHeight).div(2).equal(),
                        borderBottom: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                        content: '""'
                    }
                }
            },
            // >>> Title
            // add `${treeCls}-checkbox + span` to cover checkbox `${checkboxCls} + span`
            [`${treeCls}-node-content-wrapper`]: {
                position: "relative",
                minHeight: titleHeight,
                paddingBlock: 0,
                paddingInline: token.paddingXS,
                background: "transparent",
                borderRadius: token.borderRadius,
                cursor: "pointer",
                transition: [
                    `all ${motionDurationMid}`,
                    "border 0s",
                    "line-height 0s",
                    "box-shadow 0s"
                ].join(", "),
                ...$46aba4acab4b1935$var$getDropIndicatorStyle(prefixCls, token),
                "&:hover": {
                    backgroundColor: nodeHoverBg
                },
                [`&${treeCls}-node-selected`]: {
                    color: token.nodeSelectedColor,
                    backgroundColor: nodeSelectedBg
                },
                // Icon
                [`${treeCls}-iconEle`]: {
                    display: "inline-block",
                    width: switcherSize,
                    height: titleHeight,
                    textAlign: "center",
                    verticalAlign: "top",
                    "&:empty": {
                        display: "none"
                    }
                }
            },
            // https://github.com/ant-design/ant-design/issues/28217
            [`${treeCls}-unselectable ${treeCls}-node-content-wrapper:hover`]: {
                backgroundColor: "transparent"
            },
            [`${treeNodeCls}.drop-container > [draggable]`]: {
                boxShadow: `0 0 0 2px ${token.colorPrimary}`
            },
            // ==================== Show Line =====================
            "&-show-line": {
                // ================ Indent lines ================
                [`${treeCls}-indent-unit`]: {
                    position: "relative",
                    height: "100%",
                    "&:before": {
                        position: "absolute",
                        top: 0,
                        insetInlineEnd: token.calc(switcherSize).div(2).equal(),
                        bottom: token.calc(treeNodePadding).mul(-1).equal(),
                        borderInlineEnd: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                        content: '""'
                    },
                    "&-end:before": {
                        display: "none"
                    }
                },
                // ============== Cover Background ==============
                [`${treeCls}-switcher`]: {
                    background: "transparent",
                    "&-line-icon": {
                        // https://github.com/ant-design/ant-design/issues/32813
                        verticalAlign: "-0.15em"
                    }
                }
            },
            [`${treeNodeCls}-leaf-last ${treeCls}-switcher-leaf-line:before`]: {
                top: "auto !important",
                bottom: "auto !important",
                height: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.calc(titleHeight).div(2).equal())} !important`
            }
        }
    };
};
const $46aba4acab4b1935$export$6543b952798356f2 = (prefixCls, token, /**
 * @descCN 是否启用目录树样式
 * @descEN Whether to enable directory style
 * @default true
 */ enableDirectory = true)=>{
    const treeCls = `.${prefixCls}`;
    const treeNodeCls = `${treeCls}-treenode`;
    const treeNodePadding = token.calc(token.paddingXS).div(2).equal();
    const treeToken = (0, $fef50f256b80dfa5$export$4950aa0f605343fb)(token, {
        treeCls: treeCls,
        treeNodeCls: treeNodeCls,
        treeNodePadding: treeNodePadding
    });
    return [
        // Basic
        $46aba4acab4b1935$export$5ca74f7be820a85(prefixCls, treeToken),
        // Directory
        enableDirectory && (0, $729d20baec4e7325$export$2f47474ee6fcebcf)(treeToken)
    ].filter(Boolean);
};
const $46aba4acab4b1935$export$bd8b682992bc9781 = (token)=>{
    const { controlHeightSM: controlHeightSM, controlItemBgHover: controlItemBgHover, controlItemBgActive: controlItemBgActive } = token;
    const titleHeight = controlHeightSM;
    return {
        titleHeight: titleHeight,
        switcherSize: titleHeight,
        indentSize: titleHeight,
        nodeHoverBg: controlItemBgHover,
        nodeHoverColor: token.colorText,
        nodeSelectedBg: controlItemBgActive,
        nodeSelectedColor: token.colorText
    };
};
const $46aba4acab4b1935$export$9ca1be8807fe0675 = (token)=>{
    const { colorTextLightSolid: colorTextLightSolid, colorPrimary: colorPrimary } = token;
    return {
        ...$46aba4acab4b1935$export$bd8b682992bc9781(token),
        directoryNodeSelectedColor: colorTextLightSolid,
        directoryNodeSelectedBg: colorPrimary
    };
};
var $46aba4acab4b1935$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$51ec95de45185b42)("Tree", (token, { prefixCls: prefixCls })=>[
        {
            [token.componentCls]: (0, $7a6ee65743f4824d$export$3d2f074408bd1b82)(`${prefixCls}-checkbox`, token)
        },
        $46aba4acab4b1935$export$6543b952798356f2(prefixCls, token),
        (0, $3576e621578e370a$export$2e2bcd8739ae039)(token)
    ], $46aba4acab4b1935$export$9ca1be8807fe0675);



var $cQmXV = parcelRequire("cQmXV");
"use client";
const $cb611b35554c6b54$export$cc800923e997bb8 = 4;
const $cb611b35554c6b54$var$dropIndicatorRender = (props)=>{
    const { dropPosition: dropPosition, dropLevelOffset: dropLevelOffset, prefixCls: prefixCls, indent: indent, direction: direction = "ltr" } = props;
    const startPosition = direction === "ltr" ? "left" : "right";
    const endPosition = direction === "ltr" ? "right" : "left";
    const style = {
        [startPosition]: -dropLevelOffset * indent + $cb611b35554c6b54$export$cc800923e997bb8,
        [endPosition]: 0
    };
    switch(dropPosition){
        case -1:
            style.top = -3;
            break;
        case 1:
            style.bottom = -3;
            break;
        default:
            // dropPosition === 0
            style.bottom = -3;
            style[startPosition] = indent + $cb611b35554c6b54$export$cc800923e997bb8;
            break;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
        style: style,
        className: `${prefixCls}-drop-indicator`
    });
};
var $cb611b35554c6b54$export$2e2bcd8739ae039 = $cb611b35554c6b54$var$dropIndicatorRender;



var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");
var $41fccea9241e7bd7$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($41fccea9241e7bd7$exports, "__esModule", {
    value: true
});
var $41fccea9241e7bd7$var$CaretDownFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z"
                }
            }
        ]
    },
    "name": "caret-down",
    "theme": "filled"
};
$41fccea9241e7bd7$exports.default = $41fccea9241e7bd7$var$CaretDownFilled;



function $87629ebd6d137a13$var$_extends() {
    $87629ebd6d137a13$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $87629ebd6d137a13$var$_extends.apply(this, arguments);
}
const $87629ebd6d137a13$var$CaretDownFilled = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $87629ebd6d137a13$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($41fccea9241e7bd7$exports)))
    }));
/**![caret-down](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg0MC40IDMwMEgxODMuNmMtMTkuNyAwLTMwLjcgMjAuOC0xOC41IDM1bDMyOC40IDM4MC44YzkuNCAxMC45IDI3LjUgMTAuOSAzNyAwTDg1OC45IDMzNWMxMi4yLTE0LjIgMS4yLTM1LTE4LjUtMzV6IiAvPjwvc3ZnPg==) */ const $87629ebd6d137a13$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($87629ebd6d137a13$var$CaretDownFilled);
var $87629ebd6d137a13$export$2e2bcd8739ae039 = $87629ebd6d137a13$var$RefIcon;





var $cQmXV = parcelRequire("cQmXV");
var $0ac7adde932bb25b$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($0ac7adde932bb25b$exports, "__esModule", {
    value: true
});
var $0ac7adde932bb25b$var$MinusSquareOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M328 544h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    },
    "name": "minus-square",
    "theme": "outlined"
};
$0ac7adde932bb25b$exports.default = $0ac7adde932bb25b$var$MinusSquareOutlined;



function $b3788e5030b1f245$var$_extends() {
    $b3788e5030b1f245$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b3788e5030b1f245$var$_extends.apply(this, arguments);
}
const $b3788e5030b1f245$var$MinusSquareOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $b3788e5030b1f245$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($0ac7adde932bb25b$exports)))
    }));
/**![minus-square](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTMyOCA1NDRoMzY4YzQuNCAwIDgtMy42IDgtOHYtNDhjMC00LjQtMy42LTgtOC04SDMyOGMtNC40IDAtOCAzLjYtOCA4djQ4YzAgNC40IDMuNiA4IDggOHoiIC8+PHBhdGggZD0iTTg4MCAxMTJIMTQ0Yy0xNy43IDAtMzIgMTQuMy0zMiAzMnY3MzZjMCAxNy43IDE0LjMgMzIgMzIgMzJoNzM2YzE3LjcgMCAzMi0xNC4zIDMyLTMyVjE0NGMwLTE3LjctMTQuMy0zMi0zMi0zMnptLTQwIDcyOEgxODRWMTg0aDY1NnY2NTZ6IiAvPjwvc3ZnPg==) */ const $b3788e5030b1f245$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($b3788e5030b1f245$var$MinusSquareOutlined);
var $b3788e5030b1f245$export$2e2bcd8739ae039 = $b3788e5030b1f245$var$RefIcon;



var $cQmXV = parcelRequire("cQmXV");
var $210bd0b5a4895084$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($210bd0b5a4895084$exports, "__esModule", {
    value: true
});
var $210bd0b5a4895084$var$PlusSquareOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M328 544h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    },
    "name": "plus-square",
    "theme": "outlined"
};
$210bd0b5a4895084$exports.default = $210bd0b5a4895084$var$PlusSquareOutlined;



function $02d965e23ae5a462$var$_extends() {
    $02d965e23ae5a462$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $02d965e23ae5a462$var$_extends.apply(this, arguments);
}
const $02d965e23ae5a462$var$PlusSquareOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $02d965e23ae5a462$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($210bd0b5a4895084$exports)))
    }));
/**![plus-square](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTMyOCA1NDRoMTUydjE1MmMwIDQuNCAzLjYgOCA4IDhoNDhjNC40IDAgOC0zLjYgOC04VjU0NGgxNTJjNC40IDAgOC0zLjYgOC04di00OGMwLTQuNC0zLjYtOC04LThINTQ0VjMyOGMwLTQuNC0zLjYtOC04LThoLTQ4Yy00LjQgMC04IDMuNi04IDh2MTUySDMyOGMtNC40IDAtOCAzLjYtOCA4djQ4YzAgNC40IDMuNiA4IDggOHoiIC8+PHBhdGggZD0iTTg4MCAxMTJIMTQ0Yy0xNy43IDAtMzIgMTQuMy0zMiAzMnY3MzZjMCAxNy43IDE0LjMgMzIgMzIgMzJoNzM2YzE3LjcgMCAzMi0xNC4zIDMyLTMyVjE0NGMwLTE3LjctMTQuMy0zMi0zMi0zMnptLTQwIDcyOEgxODRWMTg0aDY1NnY2NTZ6IiAvPjwvc3ZnPg==) */ const $02d965e23ae5a462$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($02d965e23ae5a462$var$PlusSquareOutlined);
var $02d965e23ae5a462$export$2e2bcd8739ae039 = $02d965e23ae5a462$var$RefIcon;





"use client";
const $b41159a01c8cc0b8$var$SwitcherIconCom = (props)=>{
    const { prefixCls: prefixCls, switcherIcon: switcherIcon, treeNodeProps: treeNodeProps, showLine: showLine, switcherLoadingIcon: switcherLoadingIcon } = props;
    const { isLeaf: isLeaf, expanded: expanded, loading: loading } = treeNodeProps;
    if (loading) {
        if (/*#__PURE__*/ $cQmXV.isValidElement(switcherLoadingIcon)) return switcherLoadingIcon;
        return /*#__PURE__*/ $cQmXV.createElement((0, $bf7996ca956facd7$export$2e2bcd8739ae039), {
            className: `${prefixCls}-switcher-loading-icon`
        });
    }
    let showLeafIcon;
    if ((0, $8e2d153a3c855782$export$53b83ca8eaab0383)(showLine)) showLeafIcon = showLine.showLeafIcon;
    if (isLeaf) {
        if (!showLine) return null;
        if (typeof showLeafIcon !== "boolean" && showLeafIcon) {
            const leafIcon = (0, $8e2d153a3c855782$export$f6e2535fb5126e54)(showLeafIcon) ? showLeafIcon(treeNodeProps) : showLeafIcon;
            const leafCls = `${prefixCls}-switcher-line-custom-icon`;
            if (/*#__PURE__*/ $cQmXV.isValidElement(leafIcon)) return (0, $a91ef204d03d8eec$export$e530037191fcd5d7)(leafIcon, {
                className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(leafIcon.props?.className, leafCls)
            });
            return leafIcon;
        }
        return showLeafIcon ? /*#__PURE__*/ $cQmXV.createElement((0, $cf187e4b16fb1e1e$export$2e2bcd8739ae039), {
            className: `${prefixCls}-switcher-line-icon`
        }) : /*#__PURE__*/ $cQmXV.createElement("span", {
            className: `${prefixCls}-switcher-leaf-line`
        });
    }
    const switcherCls = `${prefixCls}-switcher-icon`;
    const switcher = (0, $8e2d153a3c855782$export$f6e2535fb5126e54)(switcherIcon) ? switcherIcon(treeNodeProps) : switcherIcon;
    if (/*#__PURE__*/ $cQmXV.isValidElement(switcher)) return (0, $a91ef204d03d8eec$export$e530037191fcd5d7)(switcher, {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(switcher.props?.className, showLine ? `${prefixCls}-switcher-line-icon` : switcherCls)
    });
    if (switcher !== undefined) return switcher;
    if (showLine) return expanded ? /*#__PURE__*/ $cQmXV.createElement((0, $b3788e5030b1f245$export$2e2bcd8739ae039), {
        className: `${prefixCls}-switcher-line-icon`
    }) : /*#__PURE__*/ $cQmXV.createElement((0, $02d965e23ae5a462$export$2e2bcd8739ae039), {
        className: `${prefixCls}-switcher-line-icon`
    });
    return /*#__PURE__*/ $cQmXV.createElement((0, $87629ebd6d137a13$export$2e2bcd8739ae039), {
        className: switcherCls
    });
};
var $b41159a01c8cc0b8$export$2e2bcd8739ae039 = $b41159a01c8cc0b8$var$SwitcherIconCom;


"use client";
const $72790e319e8424bd$var$Tree = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).forwardRef((props, ref)=>{
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("tree");
    const { virtual: virtual } = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useContext((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    const { prefixCls: customizePrefixCls, className: className, showIcon: showIcon = false, showLine: showLine, switcherIcon: switcherIcon, switcherLoadingIcon: switcherLoadingIcon, blockNode: blockNode = false, children: children, checkable: checkable = false, selectable: selectable = true, draggable: draggable, disabled: disabled, motion: customMotion, style: style, rootClassName: rootClassName, rootStyle: rootStyle, classNames: classNames, styles: styles, icon: icon } = props;
    const contextDisabled = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useContext((0, $4f0e1ea30330557c$export$2e2bcd8739ae039));
    const mergedDisabled = disabled ?? contextDisabled;
    const prefixCls = getPrefixCls("tree", customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    const motion = customMotion ?? {
        ...(0, $047a5f051ebda8ba$export$2e2bcd8739ae039)(rootPrefixCls),
        motionAppear: false
    };
    // =========== Merged Props for Semantic ==========
    const mergedProps = {
        ...props,
        showIcon: showIcon,
        blockNode: blockNode,
        checkable: checkable,
        selectable: selectable,
        disabled: mergedDisabled,
        motion: motion
    };
    const rootStyleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(rootStyle);
    const [mergedClassNames, mergedStyles] = (0, $30c5f9f911d4f61b$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        rootStyleRoot,
        styles
    ], {
        props: mergedProps
    });
    const newProps = {
        ...mergedProps,
        showLine: Boolean(showLine),
        icon: icon,
        dropIndicatorRender: (0, $cb611b35554c6b54$export$2e2bcd8739ae039)
    };
    const [hashId, cssVarCls] = (0, $46aba4acab4b1935$export$2e2bcd8739ae039)(prefixCls);
    const [, token] = (0, $b22e03a54a548614$export$2e2bcd8739ae039)();
    const itemHeight = token.paddingXS / 2 + (token.Tree?.titleHeight || token.controlHeightSM);
    const draggableConfig = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useMemo(()=>{
        if (!draggable) return false;
        let mergedDraggable = {};
        switch(typeof draggable){
            case "function":
                mergedDraggable.nodeDraggable = draggable;
                break;
            case "object":
                mergedDraggable = {
                    ...draggable
                };
                break;
            default:
                break;
        }
        if (mergedDraggable.icon !== false) mergedDraggable.icon = mergedDraggable.icon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $6567d5702c12b1b9$export$2e2bcd8739ae039), null);
        return mergedDraggable;
    }, [
        draggable
    ]);
    const renderSwitcherIcon = (nodeProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $b41159a01c8cc0b8$export$2e2bcd8739ae039), {
            prefixCls: prefixCls,
            switcherIcon: switcherIcon,
            switcherLoadingIcon: switcherLoadingIcon,
            treeNodeProps: nodeProps,
            showLine: showLine
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $ae1764cccb2daebe$export$2e2bcd8739ae039), {
        itemHeight: itemHeight,
        ref: ref,
        virtual: virtual,
        ...newProps,
        // newProps may contain style so declare style below it
        prefixCls: prefixCls,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)({
            [`${prefixCls}-icon-hide`]: !showIcon,
            [`${prefixCls}-block-node`]: blockNode,
            [`${prefixCls}-unselectable`]: !selectable,
            [`${prefixCls}-rtl`]: direction === "rtl",
            [`${prefixCls}-disabled`]: mergedDisabled
        }, contextClassName, className, hashId, cssVarCls),
        style: {
            ...contextStyle,
            ...style
        },
        rootClassName: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(mergedClassNames.root, rootClassName),
        rootStyle: mergedStyles.root,
        classNames: mergedClassNames,
        styles: mergedStyles,
        direction: direction,
        checkable: checkable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("span", {
            className: `${prefixCls}-checkbox-inner`
        }) : checkable,
        selectable: selectable,
        switcherIcon: renderSwitcherIcon,
        draggable: draggableConfig
    }, children);
});
var $72790e319e8424bd$export$2e2bcd8739ae039 = $72790e319e8424bd$var$Tree;




const $c7344c1cd90df985$var$RECORD_NONE = 0;
const $c7344c1cd90df985$var$RECORD_START = 1;
const $c7344c1cd90df985$var$RECORD_END = 2;
function $c7344c1cd90df985$var$traverseNodesKey(treeData, callback, fieldNames) {
    const { key: fieldKey, children: fieldChildren } = fieldNames;
    function processNode(dataNode) {
        const key = dataNode[fieldKey];
        const children = dataNode[fieldChildren];
        if (callback(key, dataNode) !== false) $c7344c1cd90df985$var$traverseNodesKey(children || [], callback, fieldNames);
    }
    treeData.forEach(processNode);
}
function $c7344c1cd90df985$export$aad0b800290b42ab({ treeData: treeData, expandedKeys: expandedKeys, startKey: startKey, endKey: endKey, fieldNames: fieldNames }) {
    const keys = [];
    let record = $c7344c1cd90df985$var$RECORD_NONE;
    if (startKey && startKey === endKey) return [
        startKey
    ];
    if (!startKey || !endKey) return [];
    function matchKey(key) {
        return key === startKey || key === endKey;
    }
    $c7344c1cd90df985$var$traverseNodesKey(treeData, (key)=>{
        if (record === $c7344c1cd90df985$var$RECORD_END) return false;
        if (matchKey(key)) {
            // Match test
            keys.push(key);
            if (record === $c7344c1cd90df985$var$RECORD_NONE) record = $c7344c1cd90df985$var$RECORD_START;
            else if (record === $c7344c1cd90df985$var$RECORD_START) {
                record = $c7344c1cd90df985$var$RECORD_END;
                return false;
            }
        } else if (record === $c7344c1cd90df985$var$RECORD_START) // Append selection
        keys.push(key);
        return expandedKeys.includes(key);
    }, (0, $718db4e60315df95$export$6c519d302dced239)(fieldNames));
    return keys;
}
function $c7344c1cd90df985$export$7d40a46ab3886826(treeData, keys, fieldNames) {
    const restKeys = (0, $68381b18b974dc9f$export$2e2bcd8739ae039)(keys);
    const nodes = [];
    $c7344c1cd90df985$var$traverseNodesKey(treeData, (key, node)=>{
        const index = restKeys.indexOf(key);
        if (index !== -1) {
            nodes.push(node);
            restKeys.splice(index, 1);
        }
        return !!restKeys.length;
    }, (0, $718db4e60315df95$export$6c519d302dced239)(fieldNames));
    return nodes;
}


"use client";
function $2998ae6708ffe4a3$var$getIcon(props) {
    const { isLeaf: isLeaf, expanded: expanded } = props;
    if (isLeaf) return /*#__PURE__*/ $cQmXV.createElement((0, $cf187e4b16fb1e1e$export$2e2bcd8739ae039), null);
    return expanded ? /*#__PURE__*/ $cQmXV.createElement((0, $9432f33b30bd03c9$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $cQmXV.createElement((0, $98f23cd1dae7e57a$export$2e2bcd8739ae039), null);
}
function $2998ae6708ffe4a3$var$getTreeData({ treeData: treeData, children: children }) {
    return treeData || (0, $718db4e60315df95$export$6d8b10995563b669)(children);
}
const $2998ae6708ffe4a3$var$DirectoryTree = /*#__PURE__*/ $cQmXV.forwardRef((oriProps, ref)=>{
    const { defaultExpandAll: defaultExpandAll, defaultExpandParent: defaultExpandParent = true, defaultExpandedKeys: defaultExpandedKeys, ...props } = oriProps;
    // Shift click usage
    const lastSelectedKeyRef = $cQmXV.useRef(null);
    const cachedSelectedKeysRef = $cQmXV.useRef(null);
    const getInitExpandedKeys = ()=>{
        const { keyEntities: keyEntities } = (0, $718db4e60315df95$export$e5d831ce033a4615)($2998ae6708ffe4a3$var$getTreeData(props), {
            fieldNames: props.fieldNames
        });
        let initExpandedKeys;
        const mergedExpandedKeys = props.expandedKeys || defaultExpandedKeys || [];
        // Expanded keys
        if (defaultExpandAll) initExpandedKeys = Object.keys(keyEntities);
        else if (defaultExpandParent) initExpandedKeys = (0, $9f5f4c60f5f7fe12$export$fac4a40c345ccd80)(mergedExpandedKeys, keyEntities);
        else initExpandedKeys = mergedExpandedKeys;
        return initExpandedKeys;
    };
    const [selectedKeys, setSelectedKeys] = $cQmXV.useState(props.selectedKeys || props.defaultSelectedKeys || []);
    const [expandedKeys, setExpandedKeys] = $cQmXV.useState(()=>getInitExpandedKeys());
    $cQmXV.useEffect(()=>{
        if ("selectedKeys" in props) setSelectedKeys(props.selectedKeys);
    }, [
        props.selectedKeys
    ]);
    $cQmXV.useEffect(()=>{
        if ("expandedKeys" in props) setExpandedKeys(props.expandedKeys);
    }, [
        props.expandedKeys
    ]);
    const onExpand = (keys, info)=>{
        if (!("expandedKeys" in props)) setExpandedKeys(keys);
        // Call origin function
        return props.onExpand?.(keys, info);
    };
    const onSelect = (keys, event)=>{
        const { multiple: multiple, fieldNames: fieldNames } = props;
        const { node: node, nativeEvent: nativeEvent } = event;
        const { key: key = "" } = node;
        const treeData = $2998ae6708ffe4a3$var$getTreeData(props);
        // We need wrap this event since some value is not same
        const newEvent = {
            ...event,
            selected: true // Directory selected always true
        };
        // Windows / Mac single pick
        const ctrlPick = nativeEvent?.ctrlKey || nativeEvent?.metaKey;
        const shiftPick = nativeEvent?.shiftKey;
        // Generate new selected keys
        let newSelectedKeys;
        if (multiple && ctrlPick) {
            // Control click
            newSelectedKeys = keys;
            lastSelectedKeyRef.current = key;
            cachedSelectedKeysRef.current = newSelectedKeys;
            newEvent.selectedNodes = (0, $c7344c1cd90df985$export$7d40a46ab3886826)(treeData, newSelectedKeys, fieldNames);
        } else if (multiple && shiftPick) {
            // Shift click
            newSelectedKeys = Array.from(new Set([].concat((0, $68381b18b974dc9f$export$2e2bcd8739ae039)(cachedSelectedKeysRef.current || []), (0, $68381b18b974dc9f$export$2e2bcd8739ae039)((0, $c7344c1cd90df985$export$aad0b800290b42ab)({
                treeData: treeData,
                expandedKeys: expandedKeys,
                startKey: key,
                endKey: lastSelectedKeyRef.current,
                fieldNames: fieldNames
            })))));
            newEvent.selectedNodes = (0, $c7344c1cd90df985$export$7d40a46ab3886826)(treeData, newSelectedKeys, fieldNames);
        } else {
            // Single click
            newSelectedKeys = [
                key
            ];
            lastSelectedKeyRef.current = key;
            cachedSelectedKeysRef.current = newSelectedKeys;
            newEvent.selectedNodes = (0, $c7344c1cd90df985$export$7d40a46ab3886826)(treeData, newSelectedKeys, fieldNames);
        }
        props.onSelect?.(newSelectedKeys, newEvent);
        if (!("selectedKeys" in props)) setSelectedKeys(newSelectedKeys);
    };
    const { getPrefixCls: getPrefixCls, direction: direction } = $cQmXV.useContext((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    const { prefixCls: customizePrefixCls, className: className, showIcon: showIcon = true, expandAction: expandAction = "click", ...restProps } = props;
    const prefixCls = getPrefixCls("tree", customizePrefixCls);
    const connectClassName = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-directory`, {
        [`${prefixCls}-directory-rtl`]: direction === "rtl"
    }, className);
    return /*#__PURE__*/ $cQmXV.createElement((0, $72790e319e8424bd$export$2e2bcd8739ae039), {
        icon: $2998ae6708ffe4a3$var$getIcon,
        ref: ref,
        blockNode: true,
        ...restProps,
        showIcon: showIcon,
        expandAction: expandAction,
        prefixCls: prefixCls,
        className: connectClassName,
        defaultExpandParent: defaultExpandParent,
        expandedKeys: expandedKeys,
        selectedKeys: selectedKeys,
        onSelect: onSelect,
        onExpand: onExpand
    });
});
var $2998ae6708ffe4a3$export$2e2bcd8739ae039 = $2998ae6708ffe4a3$var$DirectoryTree;



"use client";
const $ee21ec6bdb7efb9e$var$Tree = (0, $72790e319e8424bd$export$2e2bcd8739ae039);
$ee21ec6bdb7efb9e$var$Tree.DirectoryTree = (0, $2998ae6708ffe4a3$export$2e2bcd8739ae039);
$ee21ec6bdb7efb9e$var$Tree.TreeNode = (0, $b5ea155769c296e7$export$2e2bcd8739ae039);
$ee21ec6bdb7efb9e$var$Tree.useTree = (0, $18439d3d43b6f08f$export$2e2bcd8739ae039);
var $ee21ec6bdb7efb9e$export$2e2bcd8739ae039 = $ee21ec6bdb7efb9e$var$Tree;




var $cQmXV = parcelRequire("cQmXV");


"use client";
const $1231756b5da6bfb2$var$FilterSearch = (props)=>{
    const { value: value, filterSearch: filterSearch, tablePrefixCls: tablePrefixCls, locale: locale, onChange: onChange } = props;
    if (!filterSearch) return null;
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        className: `${tablePrefixCls}-filter-dropdown-search`
    }, /*#__PURE__*/ $cQmXV.createElement((0, $056dbba933a63236$export$2e2bcd8739ae039), {
        prefix: /*#__PURE__*/ $cQmXV.createElement((0, $20a259d46bffcb08$export$2e2bcd8739ae039), null),
        placeholder: locale.filterSearchPlaceholder,
        onChange: onChange,
        value: value,
        // for skip min-width of input
        htmlSize: 1,
        className: `${tablePrefixCls}-filter-dropdown-search-input`
    }));
};
var $1231756b5da6bfb2$export$2e2bcd8739ae039 = $1231756b5da6bfb2$var$FilterSearch;



var $cQmXV = parcelRequire("cQmXV");

"use client";
const $027f537d5943efd9$var$onKeyDown = (event)=>{
    const { keyCode: keyCode } = event;
    if (keyCode === (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).ENTER) event.stopPropagation();
};
const $027f537d5943efd9$var$FilterDropdownMenuWrapper = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>/*#__PURE__*/ $cQmXV.createElement("div", {
        className: props.className,
        onClick: (e)=>e.stopPropagation(),
        onKeyDown: $027f537d5943efd9$var$onKeyDown,
        ref: ref,
        role: "presentation"
    }, props.children));
var $027f537d5943efd9$export$2e2bcd8739ae039 = $027f537d5943efd9$var$FilterDropdownMenuWrapper;


"use client";
function $835927ca82c81505$export$50792ddeed01ab0a(filters) {
    let keys = [];
    (filters || []).forEach(({ value: value, children: children })=>{
        keys.push(value);
        if (children) keys = [].concat((0, $68381b18b974dc9f$export$2e2bcd8739ae039)(keys), (0, $68381b18b974dc9f$export$2e2bcd8739ae039)($835927ca82c81505$export$50792ddeed01ab0a(children)));
    });
    return keys;
}
function $835927ca82c81505$var$hasSubMenu(filters) {
    return filters.some(({ children: children })=>children);
}
const $835927ca82c81505$var$searchValueMatched = (normalizedSearchValue, text)=>{
    if (typeof text === "string" || (0, $8e2d153a3c855782$export$7e4aa119212bc614)(text)) return text.toString().toLowerCase().includes(normalizedSearchValue);
    return false;
};
const $835927ca82c81505$var$renderFilterItems = (options)=>{
    const { filters: filters, prefixCls: prefixCls, filteredKeys: filteredKeys, filterMultiple: filterMultiple, searchValue: searchValue, normalizedSearchValue: normalizedSearchValue, filterSearch: filterSearch } = options;
    return filters.map((filter, index)=>{
        const key = String(filter.value);
        if (filter.children) return {
            key: key || index,
            label: filter.text,
            popupClassName: `${prefixCls}-dropdown-submenu`,
            children: $835927ca82c81505$var$renderFilterItems({
                filters: filter.children,
                prefixCls: prefixCls,
                filteredKeys: filteredKeys,
                filterMultiple: filterMultiple,
                searchValue: searchValue,
                normalizedSearchValue: normalizedSearchValue,
                filterSearch: filterSearch
            })
        };
        const Component = filterMultiple ? (0, $7a650444b7c2c328$export$2e2bcd8739ae039) : (0, $7f149e59454cb955$export$2e2bcd8739ae039);
        const item = {
            key: filter.value !== undefined ? key : index,
            label: /*#__PURE__*/ $cQmXV.createElement($cQmXV.Fragment, null, /*#__PURE__*/ $cQmXV.createElement(Component, {
                checked: filteredKeys.includes(key)
            }), /*#__PURE__*/ $cQmXV.createElement("span", null, filter.text))
        };
        if (normalizedSearchValue) {
            if ((0, $8e2d153a3c855782$export$f6e2535fb5126e54)(filterSearch)) return filterSearch(normalizedSearchValue, filter) ? item : null;
            return $835927ca82c81505$var$searchValueMatched(normalizedSearchValue, filter.text) ? item : null;
        }
        return item;
    });
};
function $835927ca82c81505$var$wrapStringListType(keys) {
    return keys || [];
}
const $835927ca82c81505$var$FilterDropdown = (props)=>{
    const { tablePrefixCls: tablePrefixCls, prefixCls: prefixCls, column: column, dropdownPrefixCls: dropdownPrefixCls, columnKey: columnKey, filterOnClose: filterOnClose, filterMultiple: filterMultiple, filterMode: filterMode = "menu", filterSearch: filterSearch = false, filterState: filterState, triggerFilter: triggerFilter, locale: locale, children: children, getPopupContainer: getPopupContainer, rootClassName: rootClassName } = props;
    const { filterResetToDefaultFilteredValue: filterResetToDefaultFilteredValue, defaultFilteredValue: defaultFilteredValue, filterDropdownProps: filterDropdownProps = {}, filterDropdownOpen: // Deprecated
    filterDropdownOpen, onFilterDropdownOpenChange: onFilterDropdownOpenChange } = column;
    const [visible, setVisible] = $cQmXV.useState(false);
    const inMeasureRow = $cQmXV.useContext((0, $618736959620ab5c$export$2e2bcd8739ae039));
    const filtered = !!(filterState && (filterState.filteredKeys?.length || filterState.forceFiltered));
    const triggerVisible = (newVisible)=>{
        setVisible(newVisible);
        filterDropdownProps.onOpenChange?.(newVisible);
        // deprecated
        onFilterDropdownOpenChange?.(newVisible);
    };
    var deprecatedName, newName;
    const mergedVisible = filterDropdownProps.open ?? filterDropdownOpen ?? // deprecated
    visible; // inner state
    // ===================== Select Keys =====================
    const propFilteredKeys = filterState?.filteredKeys;
    const [getFilteredKeysSync, setFilteredKeysSync] = (0, $6bbcacb14b126c6b$export$bd58d1a153fd4998)($835927ca82c81505$var$wrapStringListType(propFilteredKeys));
    const onSelectKeys = ({ selectedKeys: selectedKeys })=>{
        setFilteredKeysSync(selectedKeys);
    };
    const onCheck = (keys, { node: node, checked: checked })=>{
        if (!filterMultiple) onSelectKeys({
            selectedKeys: checked && node.key ? [
                node.key
            ] : []
        });
        else onSelectKeys({
            selectedKeys: keys
        });
    };
    $cQmXV.useEffect(()=>{
        if (!mergedVisible) return;
        onSelectKeys({
            selectedKeys: $835927ca82c81505$var$wrapStringListType(propFilteredKeys)
        });
    }, [
        propFilteredKeys,
        mergedVisible
    ]);
    // ====================== Open Keys ======================
    const [openKeys, setOpenKeys] = $cQmXV.useState([]);
    const onOpenChange = (keys)=>{
        setOpenKeys(keys);
    };
    // search in tree mode column filter
    const [searchValue, setSearchValue] = $cQmXV.useState("");
    const normalizedSearchValue = $cQmXV.useMemo(()=>searchValue.trim().toLowerCase(), [
        searchValue
    ]);
    const onSearch = (e)=>{
        const { value: value } = e.target;
        setSearchValue(value);
    };
    // clear search value after close filter dropdown
    $cQmXV.useEffect(()=>{
        if (!mergedVisible) setSearchValue("");
    }, [
        mergedVisible
    ]);
    // ======================= Submit ========================
    const internalTriggerFilter = (keys)=>{
        const mergedKeys = keys?.length ? keys : null;
        if (mergedKeys === null && (!filterState || !filterState.filteredKeys)) return null;
        if ((0, $3f19ee2a2ff4618a$export$2e2bcd8739ae039)(mergedKeys, filterState?.filteredKeys, true)) return null;
        triggerFilter({
            column: column,
            key: columnKey,
            filteredKeys: mergedKeys
        });
    };
    const onConfirm = ()=>{
        triggerVisible(false);
        internalTriggerFilter(getFilteredKeysSync());
    };
    const onReset = ({ confirm: confirm, closeDropdown: closeDropdown } = {
        confirm: false,
        closeDropdown: false
    })=>{
        if (confirm) internalTriggerFilter([]);
        if (closeDropdown) triggerVisible(false);
        setSearchValue("");
        if (filterResetToDefaultFilteredValue) setFilteredKeysSync((defaultFilteredValue || []).map(String));
        else setFilteredKeysSync([]);
    };
    const doFilter = ({ closeDropdown: closeDropdown } = {
        closeDropdown: true
    })=>{
        if (closeDropdown) triggerVisible(false);
        internalTriggerFilter(getFilteredKeysSync());
    };
    const onVisibleChange = (newVisible, info)=>{
        if (info.source === "trigger") {
            if (newVisible && propFilteredKeys !== undefined) // Sync filteredKeys on appear in controlled mode (propFilteredKeys !== undefined)
            setFilteredKeysSync($835927ca82c81505$var$wrapStringListType(propFilteredKeys));
            triggerVisible(newVisible);
            if (!newVisible && !column.filterDropdown && filterOnClose) onConfirm();
        }
    };
    // ======================== Style ========================
    const dropdownMenuClass = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)({
        [`${dropdownPrefixCls}-menu-without-submenu`]: !$835927ca82c81505$var$hasSubMenu(column.filters || [])
    });
    const onCheckAll = (e)=>{
        if (e.target.checked) {
            const allFilterKeys = $835927ca82c81505$export$50792ddeed01ab0a(column?.filters).map(String);
            setFilteredKeysSync(allFilterKeys);
        } else setFilteredKeysSync([]);
    };
    const getTreeData = ({ filters: filters })=>(filters || []).map((filter, index)=>{
            const key = String(filter.value);
            const item = {
                title: filter.text,
                key: filter.value !== undefined ? key : String(index)
            };
            if (filter.children) item.children = getTreeData({
                filters: filter.children
            });
            return item;
        });
    const getFilterData = (node)=>({
            ...node,
            text: node.title,
            value: node.key,
            children: node.children?.map(getFilterData) || []
        });
    let dropdownContent;
    const { direction: direction, renderEmpty: renderEmpty } = $cQmXV.useContext((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    if ((0, $8e2d153a3c855782$export$f6e2535fb5126e54)(column.filterDropdown)) dropdownContent = column.filterDropdown({
        prefixCls: `${dropdownPrefixCls}-custom`,
        setSelectedKeys: (selectedKeys)=>onSelectKeys({
                selectedKeys: selectedKeys
            }),
        selectedKeys: getFilteredKeysSync(),
        confirm: doFilter,
        clearFilters: onReset,
        filters: column.filters,
        visible: mergedVisible,
        close: ()=>{
            triggerVisible(false);
        }
    });
    else if (column.filterDropdown) dropdownContent = column.filterDropdown;
    else {
        const selectedKeys = getFilteredKeysSync() || [];
        const getFilterComponent = ()=>{
            const empty = renderEmpty?.("Table.filter") ?? /*#__PURE__*/ $cQmXV.createElement((0, $99350450b877904c$export$2e2bcd8739ae039), {
                image: (0, $99350450b877904c$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE,
                description: locale.filterEmptyText,
                styles: {
                    image: {
                        height: 24
                    }
                },
                style: {
                    margin: 0,
                    padding: "16px 0"
                }
            });
            if ((column.filters || []).length === 0) return empty;
            if (filterMode === "tree") return /*#__PURE__*/ $cQmXV.createElement($cQmXV.Fragment, null, /*#__PURE__*/ $cQmXV.createElement((0, $1231756b5da6bfb2$export$2e2bcd8739ae039), {
                filterSearch: filterSearch,
                value: searchValue,
                onChange: onSearch,
                tablePrefixCls: tablePrefixCls,
                locale: locale
            }), /*#__PURE__*/ $cQmXV.createElement("div", {
                className: `${tablePrefixCls}-filter-dropdown-tree`
            }, filterMultiple ? /*#__PURE__*/ $cQmXV.createElement((0, $7a650444b7c2c328$export$2e2bcd8739ae039), {
                checked: selectedKeys.length === $835927ca82c81505$export$50792ddeed01ab0a(column.filters).length,
                indeterminate: selectedKeys.length > 0 && selectedKeys.length < $835927ca82c81505$export$50792ddeed01ab0a(column.filters).length,
                className: `${tablePrefixCls}-filter-dropdown-checkall`,
                onChange: onCheckAll
            }, locale?.filterCheckall ?? locale?.filterCheckAll) : null, /*#__PURE__*/ $cQmXV.createElement((0, $ee21ec6bdb7efb9e$export$2e2bcd8739ae039), {
                checkable: true,
                selectable: false,
                blockNode: true,
                multiple: filterMultiple,
                checkStrictly: !filterMultiple,
                className: `${dropdownPrefixCls}-menu`,
                onCheck: onCheck,
                checkedKeys: selectedKeys,
                selectedKeys: selectedKeys,
                showIcon: false,
                treeData: getTreeData({
                    filters: column.filters
                }),
                autoExpandParent: true,
                defaultExpandAll: true,
                filterTreeNode: normalizedSearchValue ? (node)=>{
                    if ((0, $8e2d153a3c855782$export$f6e2535fb5126e54)(filterSearch)) return filterSearch(searchValue, getFilterData(node));
                    return $835927ca82c81505$var$searchValueMatched(normalizedSearchValue, node.title);
                } : undefined
            })));
            const items = $835927ca82c81505$var$renderFilterItems({
                filters: column.filters || [],
                filterSearch: filterSearch,
                prefixCls: prefixCls,
                filteredKeys: getFilteredKeysSync(),
                filterMultiple: filterMultiple,
                searchValue: searchValue,
                normalizedSearchValue: normalizedSearchValue
            });
            const isEmpty = items.every((item)=>item === null);
            return /*#__PURE__*/ $cQmXV.createElement($cQmXV.Fragment, null, /*#__PURE__*/ $cQmXV.createElement((0, $1231756b5da6bfb2$export$2e2bcd8739ae039), {
                filterSearch: filterSearch,
                value: searchValue,
                onChange: onSearch,
                tablePrefixCls: tablePrefixCls,
                locale: locale
            }), isEmpty ? empty : /*#__PURE__*/ $cQmXV.createElement((0, $9669e71ca8202aee$export$2e2bcd8739ae039), {
                selectable: true,
                multiple: filterMultiple,
                prefixCls: `${dropdownPrefixCls}-menu`,
                className: dropdownMenuClass,
                onSelect: onSelectKeys,
                onDeselect: onSelectKeys,
                selectedKeys: selectedKeys,
                getPopupContainer: getPopupContainer,
                openKeys: openKeys,
                onOpenChange: onOpenChange,
                items: items
            }));
        };
        const getResetDisabled = ()=>{
            if (filterResetToDefaultFilteredValue) return (0, $3f19ee2a2ff4618a$export$2e2bcd8739ae039)((defaultFilteredValue || []).map(String), selectedKeys, true);
            return selectedKeys.length === 0;
        };
        dropdownContent = /*#__PURE__*/ $cQmXV.createElement($cQmXV.Fragment, null, getFilterComponent(), /*#__PURE__*/ $cQmXV.createElement("div", {
            className: `${prefixCls}-dropdown-btns`
        }, /*#__PURE__*/ $cQmXV.createElement((0, $1fc505710073cde5$export$2e2bcd8739ae039), {
            type: "link",
            size: "small",
            disabled: getResetDisabled(),
            onClick: ()=>onReset()
        }, locale.filterReset), /*#__PURE__*/ $cQmXV.createElement((0, $1fc505710073cde5$export$2e2bcd8739ae039), {
            type: "primary",
            size: "small",
            onClick: onConfirm
        }, locale.filterConfirm)));
    }
    // We should not block customize Menu with additional props
    if (column.filterDropdown) dropdownContent = /*#__PURE__*/ $cQmXV.createElement((0, $7e4ae2ec58dd3044$export$9bd434816b0530d0), {
        selectable: undefined
    }, dropdownContent);
    dropdownContent = /*#__PURE__*/ $cQmXV.createElement((0, $027f537d5943efd9$export$2e2bcd8739ae039), {
        className: `${prefixCls}-dropdown`
    }, dropdownContent);
    const getDropdownTrigger = ()=>{
        let filterIcon;
        if ((0, $8e2d153a3c855782$export$f6e2535fb5126e54)(column.filterIcon)) filterIcon = column.filterIcon(filtered);
        else if (column.filterIcon) filterIcon = column.filterIcon;
        else filterIcon = /*#__PURE__*/ $cQmXV.createElement((0, $b234cc74575cfd65$export$2e2bcd8739ae039), null);
        return /*#__PURE__*/ $cQmXV.createElement("span", {
            role: "button",
            tabIndex: -1,
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-trigger`, {
                active: filtered
            }),
            onClick: (e)=>{
                e.stopPropagation();
            }
        }, filterIcon);
    };
    const triggerNode = getDropdownTrigger();
    // MeasureRow：仅渲染静态 trigger，不渲染 Dropdown 实例
    if (inMeasureRow) return /*#__PURE__*/ $cQmXV.createElement("div", {
        className: `${prefixCls}-column`
    }, /*#__PURE__*/ $cQmXV.createElement("span", {
        className: `${tablePrefixCls}-column-title`
    }, children), triggerNode);
    const mergedDropdownProps = (0, $5bb86b4f753905a4$export$2e2bcd8739ae039)({
        trigger: [
            "click"
        ],
        placement: direction === "rtl" ? "bottomLeft" : "bottomRight",
        children: triggerNode,
        getPopupContainer: getPopupContainer
    }, {
        ...filterDropdownProps,
        rootClassName: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(rootClassName, filterDropdownProps.rootClassName),
        open: mergedVisible,
        onOpenChange: onVisibleChange,
        popupRender: ()=>{
            if ((0, $8e2d153a3c855782$export$f6e2535fb5126e54)(filterDropdownProps?.dropdownRender)) return filterDropdownProps.dropdownRender(dropdownContent);
            return dropdownContent;
        }
    });
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        className: `${prefixCls}-column`
    }, /*#__PURE__*/ $cQmXV.createElement("span", {
        className: `${tablePrefixCls}-column-title`
    }, children), /*#__PURE__*/ $cQmXV.createElement((0, $30ddd2d6a9f4b7d6$export$2e2bcd8739ae039), {
        ...mergedDropdownProps
    }));
};
var $835927ca82c81505$export$2e2bcd8739ae039 = $835927ca82c81505$var$FilterDropdown;


"use client";
const $264470bfb0abbd48$var$collectFilterStates = (columns, init, pos)=>{
    let filterStates = [];
    (columns || []).forEach((column, index)=>{
        const columnPos = (0, $b811e249bf5f95a4$export$7e4db04adce9b4db)(index, pos);
        const filterDropdownIsDefined = column.filterDropdown !== undefined;
        if (column.filters || filterDropdownIsDefined || "onFilter" in column) {
            if ("filteredValue" in column) {
                // Controlled
                let filteredValues = column.filteredValue;
                if (!filterDropdownIsDefined) filteredValues = filteredValues?.map(String) ?? filteredValues;
                filterStates.push({
                    column: column,
                    key: (0, $b811e249bf5f95a4$export$480219a02f196e72)(column, columnPos),
                    filteredKeys: filteredValues,
                    forceFiltered: column.filtered
                });
            } else // Uncontrolled
            filterStates.push({
                column: column,
                key: (0, $b811e249bf5f95a4$export$480219a02f196e72)(column, columnPos),
                filteredKeys: init && column.defaultFilteredValue ? column.defaultFilteredValue : undefined,
                forceFiltered: column.filtered
            });
        }
        if ("children" in column) filterStates = [].concat((0, $68381b18b974dc9f$export$2e2bcd8739ae039)(filterStates), (0, $68381b18b974dc9f$export$2e2bcd8739ae039)($264470bfb0abbd48$var$collectFilterStates(column.children, init, columnPos)));
    });
    return filterStates;
};
function $264470bfb0abbd48$var$injectFilter(prefixCls, dropdownPrefixCls, columns, filterStates, locale, triggerFilter, getPopupContainer, pos, rootClassName) {
    return columns.map((column, index)=>{
        const columnPos = (0, $b811e249bf5f95a4$export$7e4db04adce9b4db)(index, pos);
        const { filterOnClose: filterOnClose = true, filterMultiple: filterMultiple = true, filterMode: filterMode, filterSearch: filterSearch } = column;
        let newColumn = column;
        if (newColumn.filters || newColumn.filterDropdown) {
            const columnKey = (0, $b811e249bf5f95a4$export$480219a02f196e72)(newColumn, columnPos);
            const filterState = filterStates.find(({ key: key })=>columnKey === key);
            newColumn = {
                ...newColumn,
                title: (renderProps)=>/*#__PURE__*/ $cQmXV.createElement((0, $835927ca82c81505$export$2e2bcd8739ae039), {
                        tablePrefixCls: prefixCls,
                        prefixCls: `${prefixCls}-filter`,
                        dropdownPrefixCls: dropdownPrefixCls,
                        column: newColumn,
                        columnKey: columnKey,
                        filterState: filterState,
                        filterOnClose: filterOnClose,
                        filterMultiple: filterMultiple,
                        filterMode: filterMode,
                        filterSearch: filterSearch,
                        triggerFilter: triggerFilter,
                        locale: locale,
                        getPopupContainer: getPopupContainer,
                        rootClassName: rootClassName
                    }, (0, $b811e249bf5f95a4$export$cfda450db2088de7)(column.title, renderProps))
            };
        }
        if ("children" in newColumn) newColumn = {
            ...newColumn,
            children: $264470bfb0abbd48$var$injectFilter(prefixCls, dropdownPrefixCls, newColumn.children, filterStates, locale, triggerFilter, getPopupContainer, columnPos, rootClassName)
        };
        return newColumn;
    });
}
const $264470bfb0abbd48$var$generateFilterInfo = (filterStates)=>{
    const currentFilters = {};
    filterStates.forEach(({ key: key, filteredKeys: filteredKeys, column: column })=>{
        const keyAsString = key;
        const { filters: filters, filterDropdown: filterDropdown } = column;
        if (filterDropdown) currentFilters[keyAsString] = filteredKeys || null;
        else if (Array.isArray(filteredKeys)) {
            const keys = (0, $835927ca82c81505$export$50792ddeed01ab0a)(filters);
            currentFilters[keyAsString] = keys.filter((originKey)=>filteredKeys.includes(String(originKey)));
        } else currentFilters[keyAsString] = null;
    });
    return currentFilters;
};
const $264470bfb0abbd48$export$37643bb40f4c1c56 = (data, filterStates, childrenColumnName)=>{
    const filterDatas = filterStates.reduce((currentData, filterState)=>{
        const { column: { onFilter: onFilter, filters: filters }, filteredKeys: filteredKeys } = filterState;
        if (onFilter && filteredKeys && filteredKeys.length) {
            // Preprocess the keys corresponding to the filter tree,
            // use Map to improve lookup performance to O(1).
            const flatKeys = (0, $835927ca82c81505$export$50792ddeed01ab0a)(filters);
            const keyMap = new Map();
            flatKeys.forEach((k)=>{
                const strKey = String(k);
                if (!keyMap.has(strKey)) keyMap.set(strKey, k);
            });
            const realKeys = filteredKeys.map((key)=>{
                const strKey = String(key);
                return keyMap.get(strKey) ?? key;
            });
            const internalFilter = (subset)=>subset.reduce((acc, record)=>{
                    const clonedRecord = {
                        ...record
                    };
                    if (clonedRecord[childrenColumnName]) clonedRecord[childrenColumnName] = $264470bfb0abbd48$export$37643bb40f4c1c56(clonedRecord[childrenColumnName], filterStates, childrenColumnName);
                    if (realKeys.some((realKey)=>onFilter(realKey, clonedRecord))) acc.push(clonedRecord);
                    return acc;
                }, []);
            return internalFilter(currentData);
        }
        return currentData;
    }, data);
    return filterDatas;
};
const $264470bfb0abbd48$var$getMergedColumns = (rawMergedColumns)=>rawMergedColumns.flatMap((column)=>{
        if ("children" in column) return [
            column
        ].concat((0, $68381b18b974dc9f$export$2e2bcd8739ae039)($264470bfb0abbd48$var$getMergedColumns(column.children || [])));
        return [
            column
        ];
    });
const $264470bfb0abbd48$var$useFilter = (props)=>{
    const { prefixCls: prefixCls, dropdownPrefixCls: dropdownPrefixCls, mergedColumns: rawMergedColumns, onFilterChange: onFilterChange, getPopupContainer: getPopupContainer, locale: tableLocale, rootClassName: rootClassName } = props;
    const warning = (0, $b5822acdae823465$export$cf977aa92c751e61)("Table");
    const mergedColumns = $cQmXV.useMemo(()=>$264470bfb0abbd48$var$getMergedColumns(rawMergedColumns || []), [
        rawMergedColumns
    ]);
    const [filterStates, setFilterStates] = $cQmXV.useState(()=>$264470bfb0abbd48$var$collectFilterStates(mergedColumns, true));
    const mergedFilterStates = $cQmXV.useMemo(()=>{
        const collectedStates = $264470bfb0abbd48$var$collectFilterStates(mergedColumns, false);
        if (collectedStates.length === 0) return collectedStates;
        let filteredKeysIsAllNotControlled = true;
        let filteredKeysIsAllControlled = true;
        collectedStates.forEach(({ filteredKeys: filteredKeys })=>{
            if (filteredKeys !== undefined) filteredKeysIsAllNotControlled = false;
            else filteredKeysIsAllControlled = false;
        });
        // Return if not controlled
        if (filteredKeysIsAllNotControlled) {
            // Filter column may have been removed
            const keyList = (mergedColumns || []).map((column, index)=>(0, $b811e249bf5f95a4$export$480219a02f196e72)(column, (0, $b811e249bf5f95a4$export$7e4db04adce9b4db)(index)));
            return filterStates.reduce((list, item)=>{
                const keyIndex = keyList.indexOf(item.key);
                if (keyIndex !== -1) {
                    const col = mergedColumns[keyIndex];
                    list.push({
                        ...item,
                        column: {
                            ...item.column,
                            ...col
                        },
                        forceFiltered: col.filtered
                    });
                }
                return list;
            }, []);
        }
        return collectedStates;
    }, [
        mergedColumns,
        filterStates
    ]);
    const filters = $cQmXV.useMemo(()=>$264470bfb0abbd48$var$generateFilterInfo(mergedFilterStates), [
        mergedFilterStates
    ]);
    const triggerFilter = (filterState)=>{
        const newFilterStates = mergedFilterStates.filter(({ key: key })=>key !== filterState.key);
        newFilterStates.push(filterState);
        setFilterStates(newFilterStates);
        onFilterChange($264470bfb0abbd48$var$generateFilterInfo(newFilterStates), newFilterStates);
    };
    const transformColumns = (innerColumns)=>$264470bfb0abbd48$var$injectFilter(prefixCls, dropdownPrefixCls, innerColumns, mergedFilterStates, tableLocale, triggerFilter, getPopupContainer, undefined, rootClassName);
    return [
        transformColumns,
        mergedFilterStates,
        filters
    ];
};
var $264470bfb0abbd48$export$2e2bcd8739ae039 = $264470bfb0abbd48$var$useFilter;



var $cQmXV = parcelRequire("cQmXV");

const $0a69084e46484209$var$useLazyKVMap = (data, childrenColumnName, getRowKey)=>{
    const mapCacheRef = $cQmXV.useRef({});
    function getRecordByKey(key) {
        if (!mapCacheRef.current || mapCacheRef.current.data !== data || mapCacheRef.current.childrenColumnName !== childrenColumnName || mapCacheRef.current.getRowKey !== getRowKey) {
            const kvMap = new Map();
            function dig(records) {
                records.forEach((record, index)=>{
                    const rowKey = getRowKey(record, index);
                    kvMap.set(rowKey, record);
                    if ((0, $8e2d153a3c855782$export$53b83ca8eaab0383)(record) && childrenColumnName in record) dig(record[childrenColumnName] || []);
                });
            }
            dig(data);
            mapCacheRef.current = {
                data: data,
                childrenColumnName: childrenColumnName,
                kvMap: kvMap,
                getRowKey: getRowKey
            };
        }
        return mapCacheRef.current.kvMap?.get(key);
    }
    return [
        getRecordByKey
    ];
};
var $0a69084e46484209$export$2e2bcd8739ae039 = $0a69084e46484209$var$useLazyKVMap;



var $cQmXV = parcelRequire("cQmXV");


const $09fbec7c68c4ecab$export$5716e8bcb003888d = 10;
function $09fbec7c68c4ecab$export$27eceeed7bf0f4c2(mergedPagination, pagination) {
    const param = {
        current: mergedPagination.current,
        pageSize: mergedPagination.pageSize
    };
    const paginationObj = (0, $8e2d153a3c855782$export$53b83ca8eaab0383)(pagination) ? pagination : {};
    Object.keys(paginationObj).forEach((pageProp)=>{
        const value = mergedPagination[pageProp];
        if (!(0, $8e2d153a3c855782$export$f6e2535fb5126e54)(value)) param[pageProp] = value;
    });
    return param;
}
function $09fbec7c68c4ecab$var$usePagination(total, onChange, pagination) {
    const { total: paginationTotal = 0, ...paginationObj } = (0, $8e2d153a3c855782$export$53b83ca8eaab0383)(pagination) ? pagination : {};
    const [innerPagination, setInnerPagination] = (0, $cQmXV.useState)(()=>({
            current: "defaultCurrent" in paginationObj ? paginationObj.defaultCurrent : 1,
            pageSize: "defaultPageSize" in paginationObj ? paginationObj.defaultPageSize : $09fbec7c68c4ecab$export$5716e8bcb003888d
        }));
    // ============ Basic Pagination Config ============
    const mergedPagination = (0, $5bb86b4f753905a4$export$2e2bcd8739ae039)(innerPagination, paginationObj, {
        total: paginationTotal > 0 ? paginationTotal : total
    });
    // Reset `current` if data length or pageSize changed
    const maxPage = Math.ceil((paginationTotal || total) / mergedPagination.pageSize);
    if (mergedPagination.current > maxPage) // Prevent a maximum page count of 0
    mergedPagination.current = maxPage || 1;
    const refreshPagination = (current, pageSize)=>{
        setInnerPagination({
            current: current ?? 1,
            pageSize: pageSize || mergedPagination.pageSize
        });
    };
    const onInternalChange = (current, pageSize)=>{
        if (pagination) pagination.onChange?.(current, pageSize);
        refreshPagination(current, pageSize);
        onChange(current, pageSize || mergedPagination?.pageSize);
    };
    if (pagination === false) return [
        {},
        ()=>{}
    ];
    return [
        {
            ...mergedPagination,
            onChange: onInternalChange
        },
        refreshPagination
    ];
}
var $09fbec7c68c4ecab$export$2e2bcd8739ae039 = $09fbec7c68c4ecab$var$usePagination;





var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");
var $dafd18a767756bd0$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($dafd18a767756bd0$exports, "__esModule", {
    value: true
});
var $dafd18a767756bd0$var$CaretDownOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z"
                }
            }
        ]
    },
    "name": "caret-down",
    "theme": "outlined"
};
$dafd18a767756bd0$exports.default = $dafd18a767756bd0$var$CaretDownOutlined;



function $461cd5c6b430cb0c$var$_extends() {
    $461cd5c6b430cb0c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $461cd5c6b430cb0c$var$_extends.apply(this, arguments);
}
const $461cd5c6b430cb0c$var$CaretDownOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $461cd5c6b430cb0c$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dafd18a767756bd0$exports)))
    }));
/**![caret-down](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg0MC40IDMwMEgxODMuNmMtMTkuNyAwLTMwLjcgMjAuOC0xOC41IDM1bDMyOC40IDM4MC44YzkuNCAxMC45IDI3LjUgMTAuOSAzNyAwTDg1OC45IDMzNWMxMi4yLTE0LjIgMS4yLTM1LTE4LjUtMzV6IiAvPjwvc3ZnPg==) */ const $461cd5c6b430cb0c$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($461cd5c6b430cb0c$var$CaretDownOutlined);
var $461cd5c6b430cb0c$export$2e2bcd8739ae039 = $461cd5c6b430cb0c$var$RefIcon;



var $cQmXV = parcelRequire("cQmXV");
var $ce6bd49c3ea20d3f$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($ce6bd49c3ea20d3f$exports, "__esModule", {
    value: true
});
var $ce6bd49c3ea20d3f$var$CaretUpOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z"
                }
            }
        ]
    },
    "name": "caret-up",
    "theme": "outlined"
};
$ce6bd49c3ea20d3f$exports.default = $ce6bd49c3ea20d3f$var$CaretUpOutlined;



function $d3890568c0c331ac$var$_extends() {
    $d3890568c0c331ac$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d3890568c0c331ac$var$_extends.apply(this, arguments);
}
const $d3890568c0c331ac$var$CaretUpOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $d3890568c0c331ac$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ce6bd49c3ea20d3f$exports)))
    }));
/**![caret-up](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg1OC45IDY4OUw1MzAuNSAzMDguMmMtOS40LTEwLjktMjcuNS0xMC45LTM3IDBMMTY1LjEgNjg5Yy0xMi4yIDE0LjItMS4yIDM1IDE4LjUgMzVoNjU2LjhjMTkuNyAwIDMwLjctMjAuOCAxOC41LTM1eiIgLz48L3N2Zz4=) */ const $d3890568c0c331ac$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($d3890568c0c331ac$var$CaretUpOutlined);
var $d3890568c0c331ac$export$2e2bcd8739ae039 = $d3890568c0c331ac$var$RefIcon;







"use client";
const $c9628492dcc55189$var$ASCEND = "ascend";
const $c9628492dcc55189$var$DESCEND = "descend";
const $c9628492dcc55189$var$getMultiplePriority = (column)=>{
    if ((0, $8e2d153a3c855782$export$53b83ca8eaab0383)(column.sorter) && (0, $8e2d153a3c855782$export$7e4aa119212bc614)(column.sorter.multiple)) return column.sorter.multiple;
    return false;
};
const $c9628492dcc55189$var$getSortFunction = (sorter)=>{
    if ((0, $8e2d153a3c855782$export$f6e2535fb5126e54)(sorter)) return sorter;
    if ((0, $8e2d153a3c855782$export$53b83ca8eaab0383)(sorter) && sorter.compare) return sorter.compare;
    return false;
};
const $c9628492dcc55189$var$nextSortDirection = (sortDirections, current)=>{
    if (!current) return sortDirections[0];
    return sortDirections[sortDirections.indexOf(current) + 1];
};
const $c9628492dcc55189$var$collectSortStates = (columns, init, pos)=>{
    let sortStates = [];
    const pushState = (column, columnPos)=>{
        sortStates.push({
            column: column,
            key: (0, $b811e249bf5f95a4$export$480219a02f196e72)(column, columnPos),
            multiplePriority: $c9628492dcc55189$var$getMultiplePriority(column),
            sortOrder: column.sortOrder
        });
    };
    (columns || []).forEach((column, index)=>{
        const columnPos = (0, $b811e249bf5f95a4$export$7e4db04adce9b4db)(index, pos);
        if (column.children) {
            if ("sortOrder" in column) // Controlled
            pushState(column, columnPos);
            sortStates = [].concat((0, $68381b18b974dc9f$export$2e2bcd8739ae039)(sortStates), (0, $68381b18b974dc9f$export$2e2bcd8739ae039)($c9628492dcc55189$var$collectSortStates(column.children, init, columnPos)));
        } else if (column.sorter) {
            if ("sortOrder" in column) // Controlled
            pushState(column, columnPos);
            else if (init && column.defaultSortOrder) // Default sorter
            sortStates.push({
                column: column,
                key: (0, $b811e249bf5f95a4$export$480219a02f196e72)(column, columnPos),
                multiplePriority: $c9628492dcc55189$var$getMultiplePriority(column),
                sortOrder: column.defaultSortOrder
            });
        }
    });
    return sortStates;
};
const $c9628492dcc55189$var$injectSorter = (prefixCls, columns, sorterStates, triggerSorter, defaultSortDirections, tableLocale, tableShowSorterTooltip, pos, a11yLocale)=>{
    const finalColumns = (columns || []).map((column, index)=>{
        const columnPos = (0, $b811e249bf5f95a4$export$7e4db04adce9b4db)(index, pos);
        let newColumn = column;
        if (newColumn.sorter) {
            const sortDirections = newColumn.sortDirections || defaultSortDirections;
            const showSorterTooltip = newColumn.showSorterTooltip === undefined ? tableShowSorterTooltip : newColumn.showSorterTooltip;
            const columnKey = (0, $b811e249bf5f95a4$export$480219a02f196e72)(newColumn, columnPos);
            const sorterState = sorterStates.find(({ key: key })=>key === columnKey);
            const sortOrder = sorterState ? sorterState.sortOrder : null;
            const nextSortOrder = $c9628492dcc55189$var$nextSortDirection(sortDirections, sortOrder);
            let sorter;
            if (column.sortIcon) sorter = column.sortIcon({
                sortOrder: sortOrder
            });
            else {
                const upNode = sortDirections.includes($c9628492dcc55189$var$ASCEND) && /*#__PURE__*/ $cQmXV.createElement((0, $d3890568c0c331ac$export$2e2bcd8739ae039), {
                    className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-column-sorter-up`, {
                        active: sortOrder === $c9628492dcc55189$var$ASCEND
                    })
                });
                const downNode = sortDirections.includes($c9628492dcc55189$var$DESCEND) && /*#__PURE__*/ $cQmXV.createElement((0, $461cd5c6b430cb0c$export$2e2bcd8739ae039), {
                    className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-column-sorter-down`, {
                        active: sortOrder === $c9628492dcc55189$var$DESCEND
                    })
                });
                sorter = /*#__PURE__*/ $cQmXV.createElement("span", {
                    className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-column-sorter`, {
                        [`${prefixCls}-column-sorter-full`]: !!(upNode && downNode)
                    })
                }, /*#__PURE__*/ $cQmXV.createElement("span", {
                    className: `${prefixCls}-column-sorter-inner`,
                    "aria-hidden": "true"
                }, upNode, downNode));
            }
            const { cancelSort: cancelSort, triggerAsc: triggerAsc, triggerDesc: triggerDesc } = tableLocale || {};
            let sortTip = cancelSort;
            if (nextSortOrder === $c9628492dcc55189$var$DESCEND) sortTip = triggerDesc;
            else if (nextSortOrder === $c9628492dcc55189$var$ASCEND) sortTip = triggerAsc;
            const tooltipProps = (0, $8e2d153a3c855782$export$53b83ca8eaab0383)(showSorterTooltip) ? {
                title: sortTip,
                ...showSorterTooltip
            } : {
                title: sortTip
            };
            newColumn = {
                ...newColumn,
                className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(newColumn.className, {
                    [`${prefixCls}-column-sort`]: sortOrder
                }),
                title: (renderProps)=>{
                    const columnSortersClass = `${prefixCls}-column-sorters`;
                    const renderColumnTitleWrapper = /*#__PURE__*/ $cQmXV.createElement("span", {
                        className: `${prefixCls}-column-title`
                    }, (0, $b811e249bf5f95a4$export$cfda450db2088de7)(column.title, renderProps));
                    const renderSortTitle = /*#__PURE__*/ $cQmXV.createElement("div", {
                        className: columnSortersClass
                    }, renderColumnTitleWrapper, sorter);
                    if (showSorterTooltip) {
                        if (typeof showSorterTooltip !== "boolean" && showSorterTooltip?.target === "sorter-icon") return /*#__PURE__*/ $cQmXV.createElement("div", {
                            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(columnSortersClass, `${columnSortersClass}-tooltip-target-sorter`)
                        }, renderColumnTitleWrapper, /*#__PURE__*/ $cQmXV.createElement((0, $1e5256cf9d329b2c$export$2e2bcd8739ae039), {
                            ...tooltipProps
                        }, sorter));
                        return /*#__PURE__*/ $cQmXV.createElement((0, $1e5256cf9d329b2c$export$2e2bcd8739ae039), {
                            ...tooltipProps
                        }, renderSortTitle);
                    }
                    return renderSortTitle;
                },
                onHeaderCell: (col)=>{
                    const cell = column.onHeaderCell?.(col) || {};
                    const originOnClick = cell.onClick;
                    const originOKeyDown = cell.onKeyDown;
                    cell.onClick = (event)=>{
                        triggerSorter({
                            column: column,
                            key: columnKey,
                            sortOrder: nextSortOrder,
                            multiplePriority: $c9628492dcc55189$var$getMultiplePriority(column)
                        });
                        originOnClick?.(event);
                    };
                    cell.onKeyDown = (event)=>{
                        if (event.keyCode === (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).ENTER) {
                            triggerSorter({
                                column: column,
                                key: columnKey,
                                sortOrder: nextSortOrder,
                                multiplePriority: $c9628492dcc55189$var$getMultiplePriority(column)
                            });
                            originOKeyDown?.(event);
                        }
                    };
                    const renderTitle = (0, $b811e249bf5f95a4$export$1c24e0676a106839)(column.title, {});
                    const displayTitle = renderTitle?.toString();
                    // Inform the screen-reader so it can tell the visually impaired user which column is sorted
                    if (sortOrder) cell["aria-sort"] = sortOrder === "ascend" ? "ascending" : "descending";
                    // Inform the screen-reader so it can tell the visually impaired user that this column can be sorted
                    cell["aria-description"] = a11yLocale?.sortable;
                    cell["aria-label"] = displayTitle || "";
                    cell.className = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(cell.className, `${prefixCls}-column-has-sorters`);
                    cell.tabIndex = 0;
                    if (column.ellipsis) cell.title = (renderTitle ?? "").toString();
                    return cell;
                }
            };
        }
        if ("children" in newColumn) newColumn = {
            ...newColumn,
            children: $c9628492dcc55189$var$injectSorter(prefixCls, newColumn.children, sorterStates, triggerSorter, defaultSortDirections, tableLocale, tableShowSorterTooltip, columnPos, a11yLocale)
        };
        return newColumn;
    });
    return finalColumns;
};
const $c9628492dcc55189$var$stateToInfo = (sorterState)=>{
    const { column: column, sortOrder: sortOrder } = sorterState;
    return {
        column: column,
        order: sortOrder,
        field: column.dataIndex,
        columnKey: column.key
    };
};
const $c9628492dcc55189$var$generateSorterInfo = (sorterStates)=>{
    const activeSorters = sorterStates.reduce((list, sorterState)=>{
        if (sorterState.sortOrder) list.push($c9628492dcc55189$var$stateToInfo(sorterState));
        return list;
    }, []);
    // =========== Legacy compatible support ===========
    // https://github.com/ant-design/ant-design/pull/19226
    if (activeSorters.length === 0 && sorterStates.length) {
        const lastIndex = sorterStates.length - 1;
        return {
            ...$c9628492dcc55189$var$stateToInfo(sorterStates[lastIndex]),
            column: undefined,
            order: undefined,
            field: undefined,
            columnKey: undefined
        };
    }
    if (activeSorters.length <= 1) return activeSorters[0] || {};
    return activeSorters;
};
const $c9628492dcc55189$export$594b2c8da4a70ee = (data, sortStates, childrenColumnName)=>{
    const innerSorterStates = sortStates.slice().sort((a, b)=>b.multiplePriority - a.multiplePriority);
    const cloneData = data.slice();
    const runningSorters = innerSorterStates.filter(({ column: { sorter: sorter }, sortOrder: sortOrder })=>$c9628492dcc55189$var$getSortFunction(sorter) && sortOrder);
    // Skip if no sorter needed
    if (!runningSorters.length) return cloneData;
    return cloneData.sort((record1, record2)=>{
        for(let i = 0; i < runningSorters.length; i += 1){
            const sorterState = runningSorters[i];
            const { column: { sorter: sorter }, sortOrder: sortOrder } = sorterState;
            const compareFn = $c9628492dcc55189$var$getSortFunction(sorter);
            if (compareFn && sortOrder) {
                const compareResult = compareFn(record1, record2, sortOrder);
                if (compareResult !== 0) return sortOrder === $c9628492dcc55189$var$ASCEND ? compareResult : -compareResult;
            }
        }
        return 0;
    }).map((record)=>{
        const subRecords = record[childrenColumnName];
        if (subRecords) return {
            ...record,
            [childrenColumnName]: $c9628492dcc55189$export$594b2c8da4a70ee(subRecords, sortStates, childrenColumnName)
        };
        return record;
    });
};
const $c9628492dcc55189$var$useFilterSorter = (props)=>{
    const { prefixCls: prefixCls, mergedColumns: mergedColumns, baseColumns: baseColumns, sortDirections: sortDirections, tableLocale: tableLocale, showSorterTooltip: showSorterTooltip, onSorterChange: onSorterChange, globalLocale: globalLocale } = props;
    // Use base (pre-responsive) columns to seed sort states so that
    // `defaultSortOrder` on a `responsive` column is honored even when the
    // column is not visible at the current breakpoint.
    // See: https://github.com/ant-design/ant-design/issues/32847
    const collectColumns = baseColumns ?? mergedColumns;
    const [sortStates, setSortStates] = $cQmXV.useState(()=>$c9628492dcc55189$var$collectSortStates(collectColumns, true));
    const getColumnKeys = (columns, pos)=>{
        const newKeys = [];
        columns.forEach((item, index)=>{
            const columnPos = (0, $b811e249bf5f95a4$export$7e4db04adce9b4db)(index, pos);
            newKeys.push((0, $b811e249bf5f95a4$export$480219a02f196e72)(item, columnPos));
            if (Array.isArray(item.children)) {
                const childKeys = getColumnKeys(item.children, columnPos);
                newKeys.push.apply(newKeys, (0, $68381b18b974dc9f$export$2e2bcd8739ae039)(childKeys));
            }
        });
        return newKeys;
    };
    const mergedSorterStates = $cQmXV.useMemo(()=>{
        let validate = true;
        // Collect controlled `sortOrder` from the full (pre-responsive) column
        // set so that a controlled `sortOrder` on a hidden responsive column
        // still applies to the sorted data.
        const collectedStates = $c9628492dcc55189$var$collectSortStates(collectColumns, false);
        // Return if not controlled
        if (!collectedStates.length) {
            const collectColumnsKeys = getColumnKeys(collectColumns);
            return sortStates.filter(({ key: key })=>collectColumnsKeys.includes(key));
        }
        const validateStates = [];
        function patchStates(state) {
            if (validate) validateStates.push(state);
            else validateStates.push({
                ...state,
                sortOrder: null
            });
        }
        let multipleMode = null;
        collectedStates.forEach((state)=>{
            if (multipleMode === null) {
                patchStates(state);
                if (state.sortOrder) {
                    if (state.multiplePriority === false) validate = false;
                    else multipleMode = true;
                }
            } else if (multipleMode && state.multiplePriority !== false) patchStates(state);
            else {
                validate = false;
                patchStates(state);
            }
        });
        return validateStates;
    }, [
        collectColumns,
        sortStates
    ]);
    // Get render columns title required props
    const columnTitleSorterProps = $cQmXV.useMemo(()=>{
        const sortColumns = mergedSorterStates.map(({ column: column, sortOrder: sortOrder })=>({
                column: column,
                order: sortOrder
            }));
        return {
            sortColumns: sortColumns,
            // Legacy
            sortColumn: sortColumns[0]?.column,
            sortOrder: sortColumns[0]?.order
        };
    }, [
        mergedSorterStates
    ]);
    const triggerSorter = (sortState)=>{
        let newSorterStates;
        if (sortState.multiplePriority === false || !mergedSorterStates.length || mergedSorterStates[0].multiplePriority === false) newSorterStates = [
            sortState
        ];
        else newSorterStates = [].concat((0, $68381b18b974dc9f$export$2e2bcd8739ae039)(mergedSorterStates.filter(({ key: key })=>key !== sortState.key)), [
            sortState
        ]);
        setSortStates(newSorterStates);
        onSorterChange($c9628492dcc55189$var$generateSorterInfo(newSorterStates), newSorterStates);
    };
    const transformColumns = (innerColumns)=>$c9628492dcc55189$var$injectSorter(prefixCls, innerColumns, mergedSorterStates, triggerSorter, sortDirections, tableLocale, showSorterTooltip, undefined, globalLocale);
    const getSorters = ()=>$c9628492dcc55189$var$generateSorterInfo(mergedSorterStates);
    return [
        transformColumns,
        mergedSorterStates,
        columnTitleSorterProps,
        getSorters
    ];
};
var $c9628492dcc55189$export$2e2bcd8739ae039 = $c9628492dcc55189$var$useFilterSorter;



var $cQmXV = parcelRequire("cQmXV");

const $d8a4a3429379d159$var$useSpinProps = (loading)=>{
    const spinProps = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useMemo(()=>{
        if (typeof loading === "boolean") return {
            spinning: loading
        };
        if ((0, $8e2d153a3c855782$export$53b83ca8eaab0383)(loading)) return {
            spinning: true,
            ...loading
        };
        return {};
    }, [
        loading
    ]);
    return spinProps;
};
var $d8a4a3429379d159$export$2e2bcd8739ae039 = $d8a4a3429379d159$var$useSpinProps;



var $cQmXV = parcelRequire("cQmXV");

const $9cd854fa575602d5$var$fillTitle = (columns, columnTitleProps)=>{
    const finalColumns = columns.map((column)=>{
        const cloneColumn = {
            ...column
        };
        cloneColumn.title = (0, $b811e249bf5f95a4$export$cfda450db2088de7)(column.title, columnTitleProps);
        if ("children" in cloneColumn) cloneColumn.children = $9cd854fa575602d5$var$fillTitle(cloneColumn.children, columnTitleProps);
        return cloneColumn;
    });
    return finalColumns;
};
const $9cd854fa575602d5$var$useTitleColumns = (columnTitleProps)=>{
    const filledColumns = $cQmXV.useCallback((columns)=>$9cd854fa575602d5$var$fillTitle(columns, columnTitleProps), [
        columnTitleProps
    ]);
    return [
        filledColumns
    ];
};
var $9cd854fa575602d5$export$2e2bcd8739ae039 = $9cd854fa575602d5$var$useTitleColumns;



"use client";
/**
 * Same as `rc-component/table` but we modify trigger children update logic instead.
 */ const $fe08f834e8448dc2$var$RcTable = (0, $eea5fa165d97b5a0$export$13da147d1fdf3e3c)((prev, next)=>{
    const { _renderTimes: prevRenderTimes } = prev;
    const { _renderTimes: nextRenderTimes } = next;
    return prevRenderTimes !== nextRenderTimes;
});
var $fe08f834e8448dc2$export$2e2bcd8739ae039 = $fe08f834e8448dc2$var$RcTable;



"use client";
/**
 * Same as `rc-component/table` but we modify trigger children update logic instead.
 */ const $9ccadeb73dccc509$var$RcVirtualTable = (0, $b4a9be2a461e4ebd$export$4747b79b36862360)((prev, next)=>{
    const { _renderTimes: prevRenderTimes } = prev;
    const { _renderTimes: nextRenderTimes } = next;
    return prevRenderTimes !== nextRenderTimes;
});
var $9ccadeb73dccc509$export$2e2bcd8739ae039 = $9ccadeb73dccc509$var$RcVirtualTable;








const $af91009bff85f2d1$var$genBorderedStyle = (token)=>{
    const { antCls: antCls, componentCls: componentCls, lineWidth: lineWidth, lineType: lineType, tableBorderColor: tableBorderColor, tableHeaderBg: tableHeaderBg, tablePaddingVertical: tablePaddingVertical, tablePaddingHorizontal: tablePaddingHorizontal, calc: calc } = token;
    const tableBorder = `${(0, $05f34ed03d41967d$export$523c0b569236b342)(lineWidth)} ${lineType} ${tableBorderColor}`;
    const [varName, varRef] = (0, $6870d4d7c14ae0bb$export$d82b8f66c5649e14)(antCls, "table");
    const getSizeBorderStyle = (size, paddingVertical, paddingHorizontal)=>({
            [`&${componentCls}-${size}`]: {
                [`> ${componentCls}-container`]: {
                    [`> ${componentCls}-content, > ${componentCls}-body`]: {
                        "> table > tbody > tr > th, > table > tbody > tr > td": {
                            [`> ${componentCls}-expanded-row-fixed`]: {
                                margin: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(calc(paddingVertical).mul(-1).equal())}
              ${(0, $05f34ed03d41967d$export$523c0b569236b342)(calc(calc(paddingHorizontal).add(lineWidth)).mul(-1).equal())}`
                            }
                        }
                    }
                }
            }
        });
    return {
        [`${componentCls}-wrapper`]: {
            [varName("nested-border-top")]: tableBorder,
            [`${componentCls}${componentCls}-bordered`]: {
                // ============================ Title =============================
                [`> ${componentCls}-title`]: {
                    border: tableBorder,
                    borderBottom: 0
                },
                // ============================ Content ============================
                [`> ${componentCls}-container`]: {
                    borderInlineStart: tableBorder,
                    borderTop: tableBorder,
                    "&:first-child": {
                        borderTop: varRef("nested-border-top", tableBorder)
                    },
                    [`> ${componentCls}-header${componentCls}-sticky-holder`]: {
                        marginTop: calc(lineWidth).mul(-1).equal(),
                        borderTop: tableBorder
                    },
                    [`> ${componentCls}-content, > ${componentCls}-header, > ${componentCls}-body, > ${componentCls}-summary`]: {
                        "> table": {
                            // ============================= Cell =============================
                            "> thead > tr > th, > thead > tr > td, > tbody > tr > th, > tbody > tr > td, > tfoot > tr > th, > tfoot > tr > td": {
                                borderInlineEnd: tableBorder
                            },
                            // ============================ Header ============================
                            "> thead": {
                                "> tr:not(:last-child) > th": {
                                    borderBottom: tableBorder
                                },
                                "> tr > th::before": {
                                    backgroundColor: "transparent !important"
                                }
                            },
                            // Fixed right should provides additional border
                            // Only add separator border when there are multiple fixed-right columns
                            // (i.e. fix-right-first is not also fix-right-last), otherwise the
                            // ::after border doubles up with the cell's own borderInlineEnd and
                            // creates a spurious extra vertical line. See #56287.
                            "> thead > tr, > tbody > tr, > tfoot > tr": {
                                [`> ${componentCls}-cell-fix-right-first:not(${componentCls}-cell-fix-right-last)::after`]: {
                                    borderInlineEnd: tableBorder
                                }
                            },
                            // ========================== Expandable ==========================
                            "> tbody > tr > th, > tbody > tr > td": {
                                [`> ${componentCls}-expanded-row-fixed`]: {
                                    margin: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(calc(tablePaddingVertical).mul(-1).equal())} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(calc(calc(tablePaddingHorizontal).add(lineWidth)).mul(-1).equal())}`,
                                    "&::after": {
                                        position: "absolute",
                                        top: 0,
                                        insetInlineEnd: lineWidth,
                                        bottom: 0,
                                        borderInlineEnd: tableBorder,
                                        content: '""'
                                    }
                                }
                            }
                        }
                    }
                },
                // ============================ Scroll ============================
                [`&${componentCls}-scroll-horizontal`]: {
                    [`> ${componentCls}-container > ${componentCls}-body`]: {
                        "> table > tbody": {
                            [`
                > tr${componentCls}-expanded-row,
                > tr${componentCls}-placeholder
              `]: {
                                "> th, > td": {
                                    borderInlineEnd: 0
                                }
                            }
                        }
                    }
                },
                // ============================ Size ============================
                ...getSizeBorderStyle("medium", token.tablePaddingVerticalMiddle, token.tablePaddingHorizontalMiddle),
                ...getSizeBorderStyle("small", token.tablePaddingVerticalSmall, token.tablePaddingHorizontalSmall),
                // ============================ Footer ============================
                [`> ${componentCls}-footer`]: {
                    border: tableBorder,
                    borderTop: 0
                }
            },
            // ============================ Nested ============================
            [`${componentCls}-cell`]: {
                [`
          > ${componentCls}-wrapper:only-child,
          > ${componentCls}-expanded-row-fixed > ${componentCls}-wrapper:only-child
        `]: {
                    [varName("nested-border-top")]: 0
                },
                // https://github.com/ant-design/ant-design/issues/35577
                "&-scrollbar:not([rowspan])": {
                    boxShadow: `0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(lineWidth)} 0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(lineWidth)} ${tableHeaderBg}`
                }
            },
            [`${componentCls}-bordered ${componentCls}-cell-scrollbar`]: {
                borderInlineEnd: tableBorder
            }
        }
    };
};
var $af91009bff85f2d1$export$2e2bcd8739ae039 = $af91009bff85f2d1$var$genBorderedStyle;



const $ee19806b4802f07e$var$genEllipsisStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-wrapper`]: {
            [`${componentCls}-cell-ellipsis`]: {
                ...(0, $519d20bf207ce864$export$b2b65df0d0824629),
                wordBreak: "keep-all",
                // Fixed first or last should special process
                [`
          &${componentCls}-cell-fix-start-shadow,
          &${componentCls}-cell-fix-end-shadow
        `]: {
                    overflow: "visible",
                    [`${componentCls}-cell-content`]: {
                        ...(0, $519d20bf207ce864$export$b2b65df0d0824629),
                        display: "block"
                    }
                },
                [`${componentCls}-column-title`]: {
                    ...(0, $519d20bf207ce864$export$b2b65df0d0824629),
                    wordBreak: "keep-all"
                }
            }
        }
    };
};
var $ee19806b4802f07e$export$2e2bcd8739ae039 = $ee19806b4802f07e$var$genEllipsisStyle;


// ========================= Placeholder ==========================
const $4f866ffc08b42d8c$var$genEmptyStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-wrapper`]: {
            [`${componentCls}-tbody > tr${componentCls}-placeholder`]: {
                textAlign: "center",
                color: token.colorTextDisabled,
                "&:hover > th, &:hover > td": {
                    background: token.colorBgContainer
                }
            }
        }
    };
};
var $4f866ffc08b42d8c$export$2e2bcd8739ae039 = $4f866ffc08b42d8c$var$genEmptyStyle;




const $5088736d5aa2fd5d$var$genExpandStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls, motionDurationSlow: motionDurationSlow, lineWidth: lineWidth, paddingXS: paddingXS, lineType: lineType, tableBorderColor: tableBorderColor, tableExpandIconBg: tableExpandIconBg, tableExpandColumnWidth: tableExpandColumnWidth, borderRadius: borderRadius, tablePaddingVertical: tablePaddingVertical, tablePaddingHorizontal: tablePaddingHorizontal, tableExpandedRowBg: tableExpandedRowBg, paddingXXS: paddingXXS, expandIconMarginTop: expandIconMarginTop, expandIconSize: expandIconSize, expandIconHalfInner: expandIconHalfInner, expandIconScale: expandIconScale, calc: calc } = token;
    const tableBorder = `${(0, $05f34ed03d41967d$export$523c0b569236b342)(lineWidth)} ${lineType} ${tableBorderColor}`;
    const expandIconLineOffset = calc(paddingXXS).sub(lineWidth).equal();
    return {
        [`${componentCls}-wrapper`]: {
            [`${componentCls}-expand-icon-col`]: {
                width: tableExpandColumnWidth
            },
            [`${componentCls}-row-expand-icon-cell`]: {
                textAlign: "center",
                [`${componentCls}-row-expand-icon`]: {
                    display: "inline-flex",
                    float: "none",
                    verticalAlign: "sub"
                }
            },
            [`${componentCls}-row-indent`]: {
                height: 1,
                float: "left"
            },
            [`${componentCls}-row-expand-icon`]: {
                ...(0, $519d20bf207ce864$export$9a16e7694a707ab4)(token),
                position: "relative",
                float: "left",
                width: expandIconSize,
                height: expandIconSize,
                color: "inherit",
                lineHeight: (0, $05f34ed03d41967d$export$523c0b569236b342)(expandIconSize),
                background: tableExpandIconBg,
                border: tableBorder,
                borderRadius: borderRadius,
                transform: `scale(${expandIconScale})`,
                "&:focus, &:hover, &:active": {
                    borderColor: "currentcolor"
                },
                "&::before, &::after": {
                    position: "absolute",
                    background: "currentcolor",
                    transition: `transform ${motionDurationSlow} ease-out`,
                    content: '""'
                },
                "&::before": {
                    top: expandIconHalfInner,
                    insetInlineEnd: expandIconLineOffset,
                    insetInlineStart: expandIconLineOffset,
                    height: lineWidth
                },
                "&::after": {
                    top: expandIconLineOffset,
                    bottom: expandIconLineOffset,
                    insetInlineStart: expandIconHalfInner,
                    width: lineWidth,
                    transform: "rotate(90deg)"
                },
                // Motion effect
                "&-collapsed::before": {
                    transform: "rotate(-180deg)"
                },
                "&-collapsed::after": {
                    transform: "rotate(0deg)"
                },
                "&-spaced": {
                    "&::before, &::after": {
                        display: "none",
                        content: "none"
                    },
                    background: "transparent",
                    border: 0,
                    visibility: "hidden"
                }
            },
            [`${componentCls}-row-indent + ${componentCls}-row-expand-icon`]: {
                marginTop: expandIconMarginTop,
                marginInlineEnd: paddingXS
            },
            [`tr${componentCls}-expanded-row`]: {
                "&, &:hover": {
                    "> th, > td": {
                        background: tableExpandedRowBg
                    }
                },
                // https://github.com/ant-design/ant-design/issues/25573
                [`${antCls}-descriptions-view`]: {
                    display: "flex",
                    table: {
                        flex: "auto",
                        width: "100%"
                    }
                }
            },
            // With fixed
            [`${componentCls}-expanded-row-fixed`]: {
                position: "relative",
                margin: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(calc(tablePaddingVertical).mul(-1).equal())} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(calc(tablePaddingHorizontal).mul(-1).equal())}`,
                padding: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(tablePaddingVertical)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(tablePaddingHorizontal)}`
            }
        }
    };
};
var $5088736d5aa2fd5d$export$2e2bcd8739ae039 = $5088736d5aa2fd5d$var$genExpandStyle;




const $43bbfc9de1dfa2a2$var$genFilterStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls, iconCls: iconCls, tableFilterDropdownWidth: tableFilterDropdownWidth, tableFilterDropdownSearchWidth: tableFilterDropdownSearchWidth, paddingXXS: paddingXXS, paddingXS: paddingXS, colorText: colorText, lineWidth: lineWidth, lineType: lineType, tableBorderColor: tableBorderColor, headerIconColor: headerIconColor, fontSizeSM: fontSizeSM, tablePaddingHorizontal: tablePaddingHorizontal, borderRadius: borderRadius, motionDurationSlow: motionDurationSlow, colorIcon: colorIcon, colorPrimary: colorPrimary, tableHeaderFilterActiveBg: tableHeaderFilterActiveBg, colorTextDisabled: colorTextDisabled, tableFilterDropdownBg: tableFilterDropdownBg, tableFilterDropdownHeight: tableFilterDropdownHeight, controlItemBgHover: controlItemBgHover, controlItemBgActive: controlItemBgActive, boxShadowSecondary: boxShadowSecondary, filterDropdownMenuBg: filterDropdownMenuBg, calc: calc } = token;
    const dropdownPrefixCls = `${antCls}-dropdown`;
    const tableFilterDropdownPrefixCls = `${componentCls}-filter-dropdown`;
    const treePrefixCls = `${antCls}-tree`;
    const tableBorder = `${(0, $05f34ed03d41967d$export$523c0b569236b342)(lineWidth)} ${lineType} ${tableBorderColor}`;
    return [
        {
            [`${componentCls}-wrapper`]: {
                [`${componentCls}-filter-column`]: {
                    display: "flex",
                    justifyContent: "space-between"
                },
                [`${componentCls}-filter-trigger`]: {
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                    marginBlock: calc(paddingXXS).mul(-1).equal(),
                    marginInline: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(paddingXXS)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(calc(tablePaddingHorizontal).div(2).mul(-1).equal())}`,
                    padding: `0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(paddingXXS)}`,
                    color: headerIconColor,
                    fontSize: fontSizeSM,
                    borderRadius: borderRadius,
                    cursor: "pointer",
                    transition: `all ${motionDurationSlow}`,
                    "&:hover": {
                        color: colorIcon,
                        background: tableHeaderFilterActiveBg
                    },
                    "&.active": {
                        color: colorPrimary
                    }
                }
            }
        },
        {
            // Dropdown
            [`${antCls}-dropdown`]: {
                [tableFilterDropdownPrefixCls]: {
                    ...(0, $519d20bf207ce864$export$23997c3e44cc1c59)(token),
                    minWidth: tableFilterDropdownWidth,
                    backgroundColor: tableFilterDropdownBg,
                    borderRadius: borderRadius,
                    boxShadow: boxShadowSecondary,
                    overflow: "hidden",
                    // Reset menu
                    [`${dropdownPrefixCls}-menu`]: {
                        // https://github.com/ant-design/ant-design/issues/4916
                        // https://github.com/ant-design/ant-design/issues/19542
                        maxHeight: tableFilterDropdownHeight,
                        overflowX: "hidden",
                        border: 0,
                        boxShadow: "none",
                        borderRadius: "unset",
                        backgroundColor: filterDropdownMenuBg,
                        "&:empty::after": {
                            display: "block",
                            padding: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(paddingXS)} 0`,
                            color: colorTextDisabled,
                            fontSize: fontSizeSM,
                            textAlign: "center",
                            content: '"Not Found"'
                        }
                    },
                    [`${tableFilterDropdownPrefixCls}-tree`]: {
                        paddingBlock: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(paddingXS)} 0`,
                        paddingInline: paddingXS,
                        [treePrefixCls]: {
                            padding: 0
                        },
                        [`${treePrefixCls}-treenode ${treePrefixCls}-node-content-wrapper:hover`]: {
                            backgroundColor: controlItemBgHover
                        },
                        [`${treePrefixCls}-treenode-checkbox-checked ${treePrefixCls}-node-content-wrapper`]: {
                            "&, &:hover": {
                                backgroundColor: controlItemBgActive
                            }
                        }
                    },
                    [`${tableFilterDropdownPrefixCls}-search`]: {
                        padding: paddingXS,
                        borderBottom: tableBorder,
                        "&-input": {
                            input: {
                                minWidth: tableFilterDropdownSearchWidth
                            },
                            [iconCls]: {
                                color: colorTextDisabled
                            }
                        }
                    },
                    [`${tableFilterDropdownPrefixCls}-checkall`]: {
                        width: "100%",
                        marginBottom: paddingXXS,
                        marginInlineStart: paddingXXS
                    },
                    // Operation
                    [`${tableFilterDropdownPrefixCls}-btns`]: {
                        display: "flex",
                        justifyContent: "space-between",
                        padding: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(calc(paddingXS).sub(lineWidth).equal())} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(paddingXS)}`,
                        overflow: "hidden",
                        borderTop: tableBorder
                    }
                }
            }
        },
        // Dropdown Menu & SubMenu
        {
            // submenu of table filter dropdown
            [`${antCls}-dropdown ${tableFilterDropdownPrefixCls}, ${tableFilterDropdownPrefixCls}-submenu`]: {
                // Checkbox
                [`${antCls}-checkbox-wrapper + span`]: {
                    paddingInlineStart: paddingXS,
                    color: colorText
                },
                "> ul": {
                    maxHeight: "calc(100vh - 130px)",
                    overflowX: "hidden",
                    overflowY: "auto"
                }
            }
        }
    ];
};
var $43bbfc9de1dfa2a2$export$2e2bcd8739ae039 = $43bbfc9de1dfa2a2$var$genFilterStyle;


function $6437a426b6bae160$export$a16fd84c5da6565a({ colorSplit: shadowColor }) {
    const leftShadowStyle = {
        boxShadow: `inset 10px 0 8px -8px ${shadowColor}`
    };
    const rightShadowStyle = {
        boxShadow: `inset -10px 0 8px -8px ${shadowColor}`
    };
    return [
        leftShadowStyle,
        rightShadowStyle
    ];
}
const $6437a426b6bae160$var$genFixedStyle = (token)=>{
    const { componentCls: componentCls, lineWidth: lineWidth, motionDurationSlow: motionDurationSlow, zIndexTableFixed: zIndexTableFixed, tableBg: tableBg, calc: calc } = token;
    const cellCls = `${componentCls}-cell`;
    const fixCellCls = `${cellCls}-fix`;
    const sharedShadowStyle = {
        position: "absolute",
        top: 0,
        bottom: calc(lineWidth).mul(-1).equal(),
        width: 30,
        transition: `box-shadow ${motionDurationSlow}`,
        content: '""',
        pointerEvents: "none"
    };
    const [leftShadowStyle, rightShadowStyle] = $6437a426b6bae160$export$a16fd84c5da6565a(token);
    // Follow style is magic of shadow which should not follow token:
    return {
        [`${componentCls}-wrapper`]: {
            // ====================== Cell ======================
            [`${cellCls}${fixCellCls}`]: {
                position: "sticky"
            },
            [fixCellCls]: {
                zIndex: `calc(var(--z-offset-reverse) + ${zIndexTableFixed})`,
                background: tableBg,
                "&:after": sharedShadowStyle,
                // Position
                "&-start:after": {
                    insetInlineStart: "100%"
                },
                "&-end:after": {
                    insetInlineEnd: "100%"
                },
                // visible
                "&-start-shadow-show:after": leftShadowStyle,
                "&-end-shadow-show:after": rightShadowStyle
            },
            // =================== Container ====================
            [`${componentCls}-container`]: {
                position: "relative",
                "&:before, &:after": {
                    ...sharedShadowStyle,
                    zIndex: `calc(var(--columns-count) * 2 + ${zIndexTableFixed} + 1)`
                },
                "&:before": {
                    insetInlineStart: 0
                },
                "&:after": {
                    insetInlineEnd: 0
                }
            },
            [`${componentCls}-has-fix-start ${componentCls}-container:before`]: {
                display: "none"
            },
            [`${componentCls}-has-fix-end ${componentCls}-container:after`]: {
                display: "none"
            },
            [`${componentCls}-fix-start-shadow-show ${componentCls}-container:before`]: leftShadowStyle,
            [`${componentCls}-fix-end-shadow-show ${componentCls}-container:after`]: rightShadowStyle
        }
    };
};
var $6437a426b6bae160$export$2e2bcd8739ae039 = $6437a426b6bae160$var$genFixedStyle;



const $98fcaf2f4fa2a8f0$var$genPaginationStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls, margin: margin } = token;
    return {
        [`${componentCls}-wrapper`]: {
            // ========================== Pagination ==========================
            [`${componentCls}-pagination${antCls}-pagination`]: {
                margin: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(margin)} 0`
            },
            [`${componentCls}-pagination`]: {
                display: "flex",
                flexWrap: "wrap",
                rowGap: token.paddingXS,
                "> *": {
                    flex: "none"
                },
                "&-start": {
                    justifyContent: "flex-start"
                },
                "&-center": {
                    justifyContent: "center"
                },
                "&-end": {
                    justifyContent: "flex-end"
                }
            }
        }
    };
};
var $98fcaf2f4fa2a8f0$export$2e2bcd8739ae039 = $98fcaf2f4fa2a8f0$var$genPaginationStyle;



const $417daace03d27ea5$var$genRadiusStyle = (token)=>{
    const { componentCls: componentCls, tableRadius: tableRadius } = token;
    return {
        [`${componentCls}-wrapper`]: {
            [componentCls]: {
                // https://github.com/ant-design/ant-design/issues/39115#issuecomment-1362314574
                [`${componentCls}-title, ${componentCls}-header`]: {
                    borderRadius: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(tableRadius)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(tableRadius)} 0 0`
                },
                [`${componentCls}-title + ${componentCls}-container`]: {
                    borderStartStartRadius: 0,
                    borderStartEndRadius: 0,
                    // https://github.com/ant-design/ant-design/issues/41975
                    [`${componentCls}-header, table`]: {
                        borderRadius: 0
                    },
                    "table > thead > tr:first-child": {
                        "th:first-child, th:last-child, td:first-child, td:last-child": {
                            borderRadius: 0
                        }
                    }
                },
                "&-container": {
                    borderStartStartRadius: tableRadius,
                    borderStartEndRadius: tableRadius,
                    "&::before": {
                        borderStartStartRadius: tableRadius
                    },
                    "&::after": {
                        borderStartEndRadius: tableRadius
                    },
                    [`> ${componentCls}-content`]: {
                        borderStartStartRadius: tableRadius,
                        borderStartEndRadius: tableRadius
                    },
                    "table > thead > tr:first-child": {
                        "> *:first-child": {
                            borderStartStartRadius: tableRadius
                        },
                        "> *:last-child": {
                            borderStartEndRadius: tableRadius
                        }
                    }
                },
                "&-footer": {
                    borderRadius: `0 0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(tableRadius)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(tableRadius)}`
                }
            }
        }
    };
};
var $417daace03d27ea5$export$2e2bcd8739ae039 = $417daace03d27ea5$var$genRadiusStyle;



const $50f77f12808f1623$var$genStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const [leftShadowStyle, rightShadowStyle] = (0, $6437a426b6bae160$export$a16fd84c5da6565a)(token);
    return {
        [`${componentCls}-wrapper-rtl`]: {
            direction: "rtl",
            table: {
                direction: "rtl"
            },
            [`${componentCls}-row-expand-icon`]: {
                float: "right",
                "&::after": {
                    transform: "rotate(-90deg)"
                },
                "&-collapsed::before": {
                    transform: "rotate(180deg)"
                },
                "&-collapsed::after": {
                    transform: "rotate(0deg)"
                }
            },
            // ====================== Cell ======================
            [`${componentCls}-cell-fix`]: {
                "&-start-shadow-show:after": rightShadowStyle,
                "&-end-shadow-show:after": leftShadowStyle
            },
            // =================== Container ====================
            [`${componentCls}-container`]: {
                [`${componentCls}-row-indent`]: {
                    float: "right"
                }
            },
            [`${componentCls}-fix-start-shadow-show ${componentCls}-container:before`]: rightShadowStyle,
            [`${componentCls}-fix-end-shadow-show ${componentCls}-container:after`]: leftShadowStyle
        }
    };
};
var $50f77f12808f1623$export$2e2bcd8739ae039 = $50f77f12808f1623$var$genStyle;



const $5716db32927e4337$var$genSelectionStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls, iconCls: iconCls, fontSizeIcon: fontSizeIcon, padding: padding, paddingXS: paddingXS, headerIconColor: headerIconColor, headerIconHoverColor: headerIconHoverColor, tableSelectionColumnWidth: tableSelectionColumnWidth, tableSelectedRowBg: tableSelectedRowBg, tableSelectedRowHoverBg: tableSelectedRowHoverBg, tableRowHoverBg: tableRowHoverBg, tablePaddingHorizontal: tablePaddingHorizontal, calc: calc } = token;
    return {
        [`${componentCls}-wrapper`]: {
            // ========================== Selections ==========================
            [`${componentCls}-selection-col`]: {
                width: tableSelectionColumnWidth,
                [`&${componentCls}-selection-col-with-dropdown`]: {
                    width: calc(tableSelectionColumnWidth).add(fontSizeIcon).add(calc(padding).div(4)).equal()
                }
            },
            [`${componentCls}-bordered ${componentCls}-selection-col`]: {
                width: calc(tableSelectionColumnWidth).add(calc(paddingXS).mul(2)).equal(),
                [`&${componentCls}-selection-col-with-dropdown`]: {
                    width: calc(tableSelectionColumnWidth).add(fontSizeIcon).add(calc(padding).div(4)).add(calc(paddingXS).mul(2)).equal()
                }
            },
            [`
        table tr th${componentCls}-selection-column,
        table tr td${componentCls}-selection-column,
        ${componentCls}-selection-column
      `]: {
                paddingInlineEnd: token.paddingXS,
                paddingInlineStart: token.paddingXS,
                textAlign: "center",
                [`${antCls}-radio-wrapper`]: {
                    marginInlineEnd: 0
                }
            },
            [`table tr th${componentCls}-selection-column${componentCls}-cell-fix-left`]: {
                zIndex: calc(token.zIndexTableFixed).add(1).equal({
                    unit: false
                })
            },
            [`table tr th${componentCls}-selection-column::after`]: {
                backgroundColor: "transparent !important"
            },
            [`${componentCls}-selection`]: {
                position: "relative",
                display: "inline-flex",
                flexDirection: "column"
            },
            [`${componentCls}-selection-extra`]: {
                position: "absolute",
                top: 0,
                zIndex: 1,
                cursor: "pointer",
                transition: `all ${token.motionDurationSlow}`,
                marginInlineStart: "100%",
                paddingInlineStart: (0, $05f34ed03d41967d$export$523c0b569236b342)(calc(tablePaddingHorizontal).div(4).equal()),
                [iconCls]: {
                    color: headerIconColor,
                    fontSize: fontSizeIcon,
                    verticalAlign: "baseline",
                    "&:hover": {
                        color: headerIconHoverColor
                    }
                }
            },
            // ============================= Rows =============================
            [`${componentCls}-tbody`]: {
                [`${componentCls}-row`]: {
                    [`&${componentCls}-row-selected`]: {
                        [`> ${componentCls}-cell`]: {
                            background: tableSelectedRowBg,
                            "&-row-hover": {
                                background: tableSelectedRowHoverBg
                            }
                        }
                    },
                    [`> ${componentCls}-cell-row-hover`]: {
                        background: tableRowHoverBg
                    }
                }
            }
        }
    };
};
var $5716db32927e4337$export$2e2bcd8739ae039 = $5716db32927e4337$var$genSelectionStyle;



const $977879c06479ea82$var$genSizeStyle = (token)=>{
    const { componentCls: componentCls, tableExpandColumnWidth: tableExpandColumnWidth, calc: calc } = token;
    const getSizeStyle = (size, paddingVertical, paddingHorizontal, fontSize)=>({
            [`${componentCls}${componentCls}-${size}`]: {
                fontSize: fontSize,
                [`
        ${componentCls}-title,
        ${componentCls}-footer,
        ${componentCls}-cell,
        ${componentCls}-thead > tr > th,
        ${componentCls}-tbody > tr > th,
        ${componentCls}-tbody > tr > td,
        tfoot > tr > th,
        tfoot > tr > td
      `]: {
                    padding: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(paddingVertical)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(paddingHorizontal)}`
                },
                [`${componentCls}-filter-trigger`]: {
                    marginInlineEnd: (0, $05f34ed03d41967d$export$523c0b569236b342)(calc(paddingHorizontal).div(2).mul(-1).equal())
                },
                [`${componentCls}-expanded-row-fixed`]: {
                    margin: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(calc(paddingVertical).mul(-1).equal())} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(calc(paddingHorizontal).mul(-1).equal())}`
                },
                [`${componentCls}-tbody`]: {
                    // ========================= Nest Table ===========================
                    [`${componentCls}-wrapper:only-child ${componentCls}`]: {
                        marginBlock: (0, $05f34ed03d41967d$export$523c0b569236b342)(calc(paddingVertical).mul(-1).equal()),
                        marginInline: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(calc(tableExpandColumnWidth).sub(paddingHorizontal).equal())} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(calc(paddingHorizontal).mul(-1).equal())}`
                    }
                },
                // https://github.com/ant-design/ant-design/issues/35167
                [`${componentCls}-selection-extra`]: {
                    paddingInlineStart: (0, $05f34ed03d41967d$export$523c0b569236b342)(calc(paddingHorizontal).div(4).equal())
                }
            }
        });
    return {
        [`${componentCls}-wrapper`]: {
            ...getSizeStyle("medium", token.tablePaddingVerticalMiddle, token.tablePaddingHorizontalMiddle, token.tableFontSizeMiddle),
            ...getSizeStyle("small", token.tablePaddingVerticalSmall, token.tablePaddingHorizontalSmall, token.tableFontSizeSmall)
        }
    };
};
var $977879c06479ea82$export$2e2bcd8739ae039 = $977879c06479ea82$var$genSizeStyle;


const $c35ae7cfc64b7eab$var$genSorterStyle = (token)=>{
    const { componentCls: componentCls, marginXXS: marginXXS, fontSizeIcon: fontSizeIcon, headerIconColor: headerIconColor, headerIconHoverColor: headerIconHoverColor } = token;
    return {
        [`${componentCls}-wrapper`]: {
            [`${componentCls}-thead th${componentCls}-column-has-sorters`]: {
                outline: "none",
                cursor: "pointer",
                // why left 0s? Avoid column header move with transition when left is changed
                // https://github.com/ant-design/ant-design/issues/50588
                transition: `all ${token.motionDurationSlow}, left 0s`,
                "&:hover": {
                    background: token.tableHeaderSortHoverBg,
                    "&::before": {
                        backgroundColor: "transparent !important"
                    }
                },
                "&:focus-visible": {
                    color: token.colorPrimary
                },
                // https://github.com/ant-design/ant-design/issues/30969
                [`
          &${componentCls}-cell-fix-left:hover,
          &${componentCls}-cell-fix-right:hover
        `]: {
                    background: token.tableFixedHeaderSortActiveBg
                }
            },
            [`${componentCls}-thead th${componentCls}-column-sort`]: {
                background: token.tableHeaderSortBg,
                "&::before": {
                    backgroundColor: "transparent !important"
                }
            },
            [`td${componentCls}-column-sort`]: {
                background: token.tableBodySortBg
            },
            [`${componentCls}-column-title`]: {
                position: "relative",
                zIndex: 1,
                flex: 1,
                minWidth: 0
            },
            [`${componentCls}-column-sorters`]: {
                display: "flex",
                flex: "auto",
                alignItems: "center",
                justifyContent: "space-between",
                "&::after": {
                    position: "absolute",
                    inset: 0,
                    width: "100%",
                    height: "100%",
                    content: '""'
                }
            },
            [`${componentCls}-column-sorters-tooltip-target-sorter`]: {
                "&::after": {
                    content: "none"
                }
            },
            [`${componentCls}-column-sorter`]: {
                marginInlineStart: marginXXS,
                color: headerIconColor,
                fontSize: 0,
                transition: `color ${token.motionDurationSlow}`,
                "&-inner": {
                    display: "inline-flex",
                    flexDirection: "column",
                    alignItems: "center"
                },
                "&-up, &-down": {
                    fontSize: fontSizeIcon,
                    "&.active": {
                        color: token.colorPrimary
                    }
                },
                [`${componentCls}-column-sorter-up + ${componentCls}-column-sorter-down`]: {
                    marginTop: "-0.3em"
                }
            },
            [`${componentCls}-column-sorters:hover ${componentCls}-column-sorter`]: {
                color: headerIconHoverColor
            }
        }
    };
};
var $c35ae7cfc64b7eab$export$2e2bcd8739ae039 = $c35ae7cfc64b7eab$var$genSorterStyle;



const $c6597ca327dff0f8$var$genStickyStyle = (token)=>{
    const { componentCls: componentCls, opacityLoading: opacityLoading, tableScrollThumbBg: tableScrollThumbBg, tableScrollThumbBgHover: tableScrollThumbBgHover, tableScrollThumbSize: tableScrollThumbSize, tableScrollBg: tableScrollBg, stickyScrollBarBorderRadius: stickyScrollBarBorderRadius, lineWidth: lineWidth, lineType: lineType, tableBorderColor: tableBorderColor, zIndexTableFixed: zIndexTableFixed } = token;
    const tableBorder = `${(0, $05f34ed03d41967d$export$523c0b569236b342)(lineWidth)} ${lineType} ${tableBorderColor}`;
    return {
        [`${componentCls}-wrapper`]: {
            [`${componentCls}-sticky`]: {
                "&-holder": {
                    position: "sticky",
                    zIndex: `calc(var(--columns-count) * 2 + ${zIndexTableFixed} + 1)`,
                    background: token.colorBgContainer
                },
                "&-scroll": {
                    position: "sticky",
                    bottom: 0,
                    height: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(tableScrollThumbSize)} !important`,
                    zIndex: `calc(var(--columns-count) * 2 + ${zIndexTableFixed} + 1)`,
                    display: "flex",
                    alignItems: "center",
                    background: tableScrollBg,
                    borderTop: tableBorder,
                    opacity: opacityLoading,
                    "&:hover": {
                        transformOrigin: "center bottom"
                    },
                    // fake scrollbar style of sticky
                    "&-bar": {
                        height: tableScrollThumbSize,
                        backgroundColor: tableScrollThumbBg,
                        borderRadius: stickyScrollBarBorderRadius,
                        transition: `all ${token.motionDurationSlow}, transform 0s`,
                        position: "absolute",
                        bottom: 0,
                        "&:hover, &-active": {
                            backgroundColor: tableScrollThumbBgHover
                        }
                    }
                }
            }
        }
    };
};
var $c6597ca327dff0f8$export$2e2bcd8739ae039 = $c6597ca327dff0f8$var$genStickyStyle;



const $a2db56136c77ae3f$var$genSummaryStyle = (token)=>{
    const { componentCls: componentCls, lineWidth: lineWidth, tableBorderColor: tableBorderColor, calc: calc } = token;
    const tableBorder = `${(0, $05f34ed03d41967d$export$523c0b569236b342)(lineWidth)} ${token.lineType} ${tableBorderColor}`;
    return {
        [`${componentCls}-wrapper`]: {
            [`${componentCls}-summary`]: {
                position: "relative",
                zIndex: token.zIndexTableFixed,
                background: token.tableBg,
                "> tr": {
                    "> th, > td": {
                        borderBottom: tableBorder
                    }
                }
            },
            [`div${componentCls}-summary`]: {
                boxShadow: `0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(calc(lineWidth).mul(-1).equal())} 0 ${tableBorderColor}`
            }
        }
    };
};
var $a2db56136c77ae3f$export$2e2bcd8739ae039 = $a2db56136c77ae3f$var$genSummaryStyle;



const $8663bf2663325808$var$genVirtualStyle = (token)=>{
    const { componentCls: componentCls, motionDurationMid: motionDurationMid, lineWidth: lineWidth, lineType: lineType, tableBorderColor: tableBorderColor, calc: calc } = token;
    const tableBorder = `${(0, $05f34ed03d41967d$export$523c0b569236b342)(lineWidth)} ${lineType} ${tableBorderColor}`;
    const rowCellCls = `${componentCls}-expanded-row-cell`;
    return {
        [`${componentCls}-wrapper`]: {
            // ========================== Row ==========================
            [`${componentCls}-tbody-virtual`]: {
                [`${componentCls}-tbody-virtual-scrollbar`]: {
                    cursor: "pointer",
                    "&:hover": {
                        backgroundColor: token.colorFillQuaternary
                    }
                },
                [`${componentCls}-tbody-virtual-holder-inner`]: {
                    [`
            & > ${componentCls}-row,
            & > div:not(${componentCls}-row) > ${componentCls}-row
          `]: {
                        display: "flex",
                        boxSizing: "border-box",
                        width: "100%"
                    }
                },
                [`${componentCls}-cell`]: {
                    borderBottom: tableBorder,
                    transition: `background-color ${motionDurationMid}`
                },
                [`${componentCls}-expanded-row`]: {
                    [`${rowCellCls}${rowCellCls}-fixed`]: {
                        position: "sticky",
                        insetInlineStart: 0,
                        overflow: "hidden",
                        width: `calc(var(--virtual-width) - ${(0, $05f34ed03d41967d$export$523c0b569236b342)(lineWidth)})`,
                        borderInlineEnd: "none"
                    }
                }
            },
            // ======================== Border =========================
            [`${componentCls}-bordered`]: {
                [`${componentCls}-tbody-virtual`]: {
                    "&:after": {
                        content: '""',
                        insetInline: 0,
                        bottom: 0,
                        borderBottom: tableBorder,
                        position: "absolute"
                    },
                    [`${componentCls}-cell`]: {
                        borderInlineEnd: tableBorder,
                        [`&${componentCls}-cell-fix-right-first:before`]: {
                            content: '""',
                            position: "absolute",
                            insetBlock: 0,
                            insetInlineStart: calc(lineWidth).mul(-1).equal(),
                            borderInlineStart: tableBorder
                        }
                    }
                },
                // Empty placeholder
                [`&${componentCls}-virtual`]: {
                    [`${componentCls}-placeholder ${componentCls}-cell`]: {
                        borderInlineEnd: tableBorder,
                        borderBottom: tableBorder
                    }
                }
            }
        }
    };
};
var $8663bf2663325808$export$2e2bcd8739ae039 = $8663bf2663325808$var$genVirtualStyle;


const $07d024ff1be0230e$var$genTableStyle = (token)=>{
    const { componentCls: componentCls, fontWeightStrong: fontWeightStrong, tablePaddingVertical: tablePaddingVertical, tablePaddingHorizontal: tablePaddingHorizontal, tableExpandColumnWidth: tableExpandColumnWidth, lineWidth: lineWidth, lineType: lineType, tableBorderColor: tableBorderColor, tableFontSize: tableFontSize, tableBg: tableBg, tableRadius: tableRadius, tableHeaderTextColor: tableHeaderTextColor, motionDurationMid: motionDurationMid, tableHeaderBg: tableHeaderBg, tableHeaderCellSplitColor: tableHeaderCellSplitColor, tableFooterTextColor: tableFooterTextColor, tableFooterBg: tableFooterBg, calc: calc } = token;
    const tableBorder = `${(0, $05f34ed03d41967d$export$523c0b569236b342)(lineWidth)} ${lineType} ${tableBorderColor}`;
    return {
        [`${componentCls}-wrapper`]: {
            clear: "both",
            maxWidth: "100%",
            // fix https://github.com/ant-design/ant-design/issues/46177
            ["--rc-virtual-list-scrollbar-bg"]: token.tableScrollBg,
            ...(0, $519d20bf207ce864$export$8c467e8859fdef13)(),
            [componentCls]: {
                ...(0, $519d20bf207ce864$export$23997c3e44cc1c59)(token),
                fontSize: tableFontSize,
                background: tableBg,
                borderRadius: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(tableRadius)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(tableRadius)} 0 0`,
                // https://github.com/ant-design/ant-design/issues/47486
                scrollbarColor: `${token.tableScrollThumbBg} ${token.tableScrollBg}`
            },
            // https://github.com/ant-design/ant-design/issues/17611
            table: {
                width: "100%",
                textAlign: "start",
                borderRadius: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(tableRadius)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(tableRadius)} 0 0`,
                borderCollapse: "separate",
                borderSpacing: 0
            },
            // ============================= Cell ==============================
            [`
          ${componentCls}-cell,
          ${componentCls}-thead > tr > th,
          ${componentCls}-tbody > tr > th,
          ${componentCls}-tbody > tr > td,
          tfoot > tr > th,
          tfoot > tr > td
        `]: {
                position: "relative",
                padding: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(tablePaddingVertical)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(tablePaddingHorizontal)}`,
                overflowWrap: "break-word"
            },
            // ============================ Title =============================
            [`${componentCls}-title`]: {
                padding: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(tablePaddingVertical)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(tablePaddingHorizontal)}`
            },
            // ============================ Header ============================
            [`${componentCls}-thead`]: {
                "> tr > th, > tr > td": {
                    position: "relative",
                    color: tableHeaderTextColor,
                    fontWeight: fontWeightStrong,
                    textAlign: "start",
                    background: tableHeaderBg,
                    borderBottom: tableBorder,
                    transition: `background-color ${motionDurationMid} ease`,
                    "&[colspan]:not([colspan='1'])": {
                        textAlign: "center"
                    },
                    [`&:not(:last-child):not(${componentCls}-selection-column):not(${componentCls}-row-expand-icon-cell):not([colspan])::before`]: {
                        position: "absolute",
                        top: "50%",
                        insetInlineEnd: 0,
                        width: 1,
                        height: "1.6em",
                        backgroundColor: tableHeaderCellSplitColor,
                        transform: "translateY(-50%)",
                        transition: `background-color ${motionDurationMid}`,
                        content: '""'
                    }
                },
                "> tr:not(:last-child) > th[colspan]": {
                    borderBottom: 0
                }
            },
            // ============================ Body ============================
            [`${componentCls}-tbody`]: {
                "> tr": {
                    "> th, > td": {
                        borderBottom: tableBorder,
                        transition: [
                            `background-color`,
                            `border-color`
                        ].map((prop)=>`${prop} ${motionDurationMid}`).join(", "),
                        // ========================= Nest Table ===========================
                        [`
              > ${componentCls}-wrapper:only-child,
              > ${componentCls}-expanded-row-fixed > ${componentCls}-wrapper:only-child
            `]: {
                            [componentCls]: {
                                marginBlock: (0, $05f34ed03d41967d$export$523c0b569236b342)(calc(tablePaddingVertical).mul(-1).equal()),
                                marginInline: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(calc(tableExpandColumnWidth).sub(tablePaddingHorizontal).equal())}
                ${(0, $05f34ed03d41967d$export$523c0b569236b342)(calc(tablePaddingHorizontal).mul(-1).equal())}`,
                                [`${componentCls}-tbody > tr:last-child > td`]: {
                                    borderBottomWidth: 0,
                                    "&:first-child, &:last-child": {
                                        borderRadius: 0
                                    }
                                }
                            }
                        }
                    },
                    "> th": {
                        position: "relative",
                        color: tableHeaderTextColor,
                        fontWeight: fontWeightStrong,
                        textAlign: "start",
                        background: tableHeaderBg,
                        borderBottom: tableBorder,
                        transition: `background-color ${motionDurationMid} ease`
                    },
                    // measure cell styles
                    [`& > ${componentCls}-measure-cell`]: {
                        paddingBlock: `0 !important`,
                        borderBlock: `0 !important`,
                        [`${componentCls}-measure-cell-content`]: {
                            height: 0,
                            overflow: "hidden",
                            pointerEvents: "none"
                        }
                    }
                }
            },
            // ============================ Footer ============================
            [`${componentCls}-footer`]: {
                padding: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(tablePaddingVertical)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(tablePaddingHorizontal)}`,
                color: tableFooterTextColor,
                background: tableFooterBg
            }
        }
    };
};
const $07d024ff1be0230e$export$9ca1be8807fe0675 = (token)=>{
    const { colorFillAlter: colorFillAlter, colorBgContainer: colorBgContainer, colorTextHeading: colorTextHeading, colorFillSecondary: colorFillSecondary, colorFillContent: colorFillContent, controlItemBgActive: controlItemBgActive, controlItemBgActiveHover: controlItemBgActiveHover, padding: padding, paddingSM: paddingSM, paddingXS: paddingXS, colorBorderSecondary: colorBorderSecondary, borderRadiusLG: borderRadiusLG, controlHeight: controlHeight, colorTextPlaceholder: colorTextPlaceholder, fontSize: fontSize, fontSizeSM: fontSizeSM, lineHeight: lineHeight, lineWidth: lineWidth, colorIcon: colorIcon, colorIconHover: colorIconHover, opacityLoading: opacityLoading, controlInteractiveSize: controlInteractiveSize } = token;
    const colorFillSecondarySolid = new (0, $3bb84f07fb2a2f32$export$2c4f38d6c0ecc25a)(colorFillSecondary).onBackground(colorBgContainer).toHexString();
    const colorFillContentSolid = new (0, $3bb84f07fb2a2f32$export$2c4f38d6c0ecc25a)(colorFillContent).onBackground(colorBgContainer).toHexString();
    const colorFillAlterSolid = new (0, $3bb84f07fb2a2f32$export$2c4f38d6c0ecc25a)(colorFillAlter).onBackground(colorBgContainer).toHexString();
    const baseColorAction = new (0, $3bb84f07fb2a2f32$export$2c4f38d6c0ecc25a)(colorIcon);
    const baseColorActionHover = new (0, $3bb84f07fb2a2f32$export$2c4f38d6c0ecc25a)(colorIconHover);
    const expandIconHalfInner = controlInteractiveSize / 2 - lineWidth;
    const expandIconSize = expandIconHalfInner * 2 + lineWidth * 3;
    return {
        headerBg: colorFillAlterSolid,
        headerColor: colorTextHeading,
        headerSortActiveBg: colorFillSecondarySolid,
        headerSortHoverBg: colorFillContentSolid,
        bodySortBg: colorFillAlterSolid,
        rowHoverBg: colorFillAlterSolid,
        rowSelectedBg: controlItemBgActive,
        rowSelectedHoverBg: controlItemBgActiveHover,
        rowExpandedBg: colorFillAlter,
        cellPaddingBlock: padding,
        cellPaddingInline: padding,
        cellPaddingBlockMD: paddingSM,
        cellPaddingInlineMD: paddingXS,
        cellPaddingBlockSM: paddingXS,
        cellPaddingInlineSM: paddingXS,
        borderColor: colorBorderSecondary,
        headerBorderRadius: borderRadiusLG,
        footerBg: colorFillAlterSolid,
        footerColor: colorTextHeading,
        cellFontSize: fontSize,
        cellFontSizeMD: fontSize,
        cellFontSizeSM: fontSize,
        headerSplitColor: colorBorderSecondary,
        fixedHeaderSortActiveBg: colorFillSecondarySolid,
        headerFilterHoverBg: colorFillContent,
        filterDropdownMenuBg: colorBgContainer,
        filterDropdownBg: colorBgContainer,
        expandIconBg: colorBgContainer,
        selectionColumnWidth: controlHeight,
        stickyScrollBarBg: colorTextPlaceholder,
        stickyScrollBarBorderRadius: 100,
        expandIconMarginTop: (fontSize * lineHeight - lineWidth * 3) / 2 - Math.ceil((fontSizeSM * 1.4 - lineWidth * 3) / 2),
        headerIconColor: baseColorAction.clone().setA(baseColorAction.a * opacityLoading).toRgbString(),
        headerIconHoverColor: baseColorActionHover.clone().setA(baseColorActionHover.a * opacityLoading).toRgbString(),
        expandIconHalfInner: expandIconHalfInner,
        expandIconSize: expandIconSize,
        expandIconScale: controlInteractiveSize / expandIconSize
    };
};
const $07d024ff1be0230e$var$zIndexTableFixed = 2;
var // ============================== Export ==============================
$07d024ff1be0230e$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$51ec95de45185b42)("Table", (token)=>{
    const { colorTextHeading: colorTextHeading, colorSplit: colorSplit, colorBgContainer: colorBgContainer, controlInteractiveSize: checkboxSize, headerBg: headerBg, headerColor: headerColor, headerSortActiveBg: headerSortActiveBg, headerSortHoverBg: headerSortHoverBg, bodySortBg: bodySortBg, rowHoverBg: rowHoverBg, rowSelectedBg: rowSelectedBg, rowSelectedHoverBg: rowSelectedHoverBg, rowExpandedBg: rowExpandedBg, cellPaddingBlock: cellPaddingBlock, cellPaddingInline: cellPaddingInline, cellPaddingBlockMD: cellPaddingBlockMD, cellPaddingInlineMD: cellPaddingInlineMD, cellPaddingBlockSM: cellPaddingBlockSM, cellPaddingInlineSM: cellPaddingInlineSM, borderColor: borderColor, footerBg: footerBg, footerColor: footerColor, headerBorderRadius: headerBorderRadius, cellFontSize: cellFontSize, cellFontSizeMD: cellFontSizeMD, cellFontSizeSM: cellFontSizeSM, headerSplitColor: headerSplitColor, fixedHeaderSortActiveBg: fixedHeaderSortActiveBg, headerFilterHoverBg: headerFilterHoverBg, filterDropdownBg: filterDropdownBg, expandIconBg: expandIconBg, selectionColumnWidth: selectionColumnWidth, stickyScrollBarBg: stickyScrollBarBg, calc: calc } = token;
    const tableToken = (0, $fef50f256b80dfa5$export$4950aa0f605343fb)(token, {
        tableFontSize: cellFontSize,
        tableBg: colorBgContainer,
        tableRadius: headerBorderRadius,
        tablePaddingVertical: cellPaddingBlock,
        tablePaddingHorizontal: cellPaddingInline,
        tablePaddingVerticalMiddle: cellPaddingBlockMD,
        tablePaddingHorizontalMiddle: cellPaddingInlineMD,
        tablePaddingVerticalSmall: cellPaddingBlockSM,
        tablePaddingHorizontalSmall: cellPaddingInlineSM,
        tableBorderColor: borderColor,
        tableHeaderTextColor: headerColor,
        tableHeaderBg: headerBg,
        tableFooterTextColor: footerColor,
        tableFooterBg: footerBg,
        tableHeaderCellSplitColor: headerSplitColor,
        tableHeaderSortBg: headerSortActiveBg,
        tableHeaderSortHoverBg: headerSortHoverBg,
        tableBodySortBg: bodySortBg,
        tableFixedHeaderSortActiveBg: fixedHeaderSortActiveBg,
        tableHeaderFilterActiveBg: headerFilterHoverBg,
        tableFilterDropdownBg: filterDropdownBg,
        tableRowHoverBg: rowHoverBg,
        tableSelectedRowBg: rowSelectedBg,
        tableSelectedRowHoverBg: rowSelectedHoverBg,
        zIndexTableFixed: $07d024ff1be0230e$var$zIndexTableFixed,
        tableFontSizeMiddle: cellFontSizeMD,
        tableFontSizeSmall: cellFontSizeSM,
        tableSelectionColumnWidth: selectionColumnWidth,
        tableExpandIconBg: expandIconBg,
        tableExpandColumnWidth: calc(checkboxSize).add(calc(token.padding).mul(2)).equal(),
        tableExpandedRowBg: rowExpandedBg,
        // Dropdown
        tableFilterDropdownWidth: 120,
        tableFilterDropdownHeight: 264,
        tableFilterDropdownSearchWidth: 140,
        // Virtual Scroll Bar
        tableScrollThumbSize: 8,
        // Mac scroll bar size
        tableScrollThumbBg: stickyScrollBarBg,
        tableScrollThumbBgHover: colorTextHeading,
        tableScrollBg: colorSplit
    });
    return [
        $07d024ff1be0230e$var$genTableStyle(tableToken),
        (0, $98fcaf2f4fa2a8f0$export$2e2bcd8739ae039)(tableToken),
        (0, $a2db56136c77ae3f$export$2e2bcd8739ae039)(tableToken),
        (0, $c35ae7cfc64b7eab$export$2e2bcd8739ae039)(tableToken),
        (0, $43bbfc9de1dfa2a2$export$2e2bcd8739ae039)(tableToken),
        (0, $af91009bff85f2d1$export$2e2bcd8739ae039)(tableToken),
        (0, $417daace03d27ea5$export$2e2bcd8739ae039)(tableToken),
        (0, $5088736d5aa2fd5d$export$2e2bcd8739ae039)(tableToken),
        (0, $a2db56136c77ae3f$export$2e2bcd8739ae039)(tableToken),
        (0, $4f866ffc08b42d8c$export$2e2bcd8739ae039)(tableToken),
        (0, $5716db32927e4337$export$2e2bcd8739ae039)(tableToken),
        (0, $6437a426b6bae160$export$2e2bcd8739ae039)(tableToken),
        (0, $c6597ca327dff0f8$export$2e2bcd8739ae039)(tableToken),
        (0, $ee19806b4802f07e$export$2e2bcd8739ae039)(tableToken),
        (0, $977879c06479ea82$export$2e2bcd8739ae039)(tableToken),
        (0, $50f77f12808f1623$export$2e2bcd8739ae039)(tableToken),
        (0, $8663bf2663325808$export$2e2bcd8739ae039)(tableToken)
    ];
}, $07d024ff1be0230e$export$9ca1be8807fe0675, {
    resetFont: false,
    unitless: {
        expandIconScale: true
    }
});




"use client";
const $fff43bc68431898c$var$EMPTY_LIST = [];
const $fff43bc68431898c$var$HeaderTableContext = /*#__PURE__*/ $cQmXV.createContext({});
const $fff43bc68431898c$var$HeaderTable = (props)=>{
    const { ariaProps: ariaProps, component: component = "table" } = $cQmXV.useContext($fff43bc68431898c$var$HeaderTableContext);
    return /*#__PURE__*/ $cQmXV.createElement(component, {
        ...ariaProps,
        ...props
    });
};
const $fff43bc68431898c$var$InternalTable = (props, ref)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, style: style, classNames: classNames, styles: styles, size: customizeSize, bordered: bordered, dropdownPrefixCls: customizeDropdownPrefixCls, dataSource: dataSource, pagination: pagination, rowSelection: customizeRowSelection, rowKey: customizeRowKey, rowClassName: rowClassName, column: column, columns: columns, children: children, childrenColumnName: legacyChildrenColumnName, onChange: onChange, getPopupContainer: getPopupContainer, loading: loading, expandIcon: expandIcon, expandable: expandable, expandedRowRender: expandedRowRender, expandIconColumnIndex: expandIconColumnIndex, indentSize: indentSize, scroll: scroll, sortDirections: sortDirections, locale: locale, showSorterTooltip: showSorterTooltip = {
        target: "full-header"
    }, virtual: virtual } = props;
    const warning = (0, $b5822acdae823465$export$cf977aa92c751e61)("Table");
    const rawColumns = $cQmXV.useMemo(()=>columns || (0, $582dcd0e4b930539$export$d87a97eba44e0f9c)(children), [
        columns,
        children
    ]);
    const baseColumns = (0, $ecd540434d598912$export$2e2bcd8739ae039)(rawColumns, column);
    const needResponsive = $cQmXV.useMemo(()=>baseColumns.some((col)=>col.responsive), [
        baseColumns
    ]);
    const screens = (0, $27af0f2a794acde0$export$2e2bcd8739ae039)(needResponsive);
    const mergedColumns = $cQmXV.useMemo(()=>{
        const matched = new Set(Object.keys(screens).filter((m)=>screens[m]));
        return baseColumns.filter((c)=>!c.responsive || c.responsive.some((r)=>matched.has(r)));
    }, [
        baseColumns,
        screens
    ]);
    const tableProps = (0, $e8c5093aebad6025$export$2e2bcd8739ae039)(props, [
        "className",
        "style",
        "column",
        "columns"
    ]);
    const components = tableProps.components;
    const ariaProps = (0, $4b5c733d1d7bb306$export$2e2bcd8739ae039)(tableProps, {
        aria: true
    });
    const hasAriaProps = Object.keys(ariaProps).length > 0;
    const headerTableContext = $cQmXV.useMemo(()=>({
            ariaProps: ariaProps,
            component: components?.header?.table
        }), [
        ariaProps,
        components?.header?.table
    ]);
    const mergedComponents = $cQmXV.useMemo(()=>{
        if (!hasAriaProps) return components;
        return {
            ...components,
            header: {
                ...components?.header,
                table: $fff43bc68431898c$var$HeaderTable
            }
        };
    }, [
        components,
        hasAriaProps
    ]);
    const { locale: contextLocale = (0, $4ab0c7032ff9de6a$export$2e2bcd8739ae039), table: table } = $cQmXV.useContext((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    const { getPrefixCls: getPrefixCls, direction: direction, renderEmpty: renderEmpty, getPopupContainer: getContextPopupContainer, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("table");
    const mergedSize = (0, $78cdfb6138721329$export$2e2bcd8739ae039)((ctx)=>customizeSize === "middle" ? "medium" : customizeSize ?? ctx);
    // =========== Merged Props for Semantic ==========
    const mergedProps = {
        ...props,
        size: mergedSize,
        bordered: bordered
    };
    const contextStyleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $30c5f9f911d4f61b$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: mergedProps
    }, {
        pagination: {
            _default: "root"
        },
        header: {
            _default: "wrapper"
        },
        body: {
            _default: "wrapper"
        }
    });
    const tableLocale = {
        ...contextLocale.Table,
        ...locale
    };
    const [globalLocale] = (0, $c953dac9d015386e$export$2e2bcd8739ae039)("global", (0, $4ab0c7032ff9de6a$export$2e2bcd8739ae039).global);
    const rawData = dataSource || $fff43bc68431898c$var$EMPTY_LIST;
    const prefixCls = getPrefixCls("table", customizePrefixCls);
    const dropdownPrefixCls = getPrefixCls("dropdown", customizeDropdownPrefixCls);
    const [, token] = (0, $b22e03a54a548614$export$2e2bcd8739ae039)();
    const mergedRowSelection = $cQmXV.useMemo(()=>{
        return (0, $8e2d153a3c855782$export$53b83ca8eaab0383)(customizeRowSelection) ? {
            columnWidth: token.Table?.selectionColumnWidth,
            ...customizeRowSelection
        } : customizeRowSelection;
    }, [
        customizeRowSelection,
        token.Table?.selectionColumnWidth
    ]);
    const rootCls = (0, $2237081acd3cfc09$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $07d024ff1be0230e$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const mergedExpandable = {
        childrenColumnName: legacyChildrenColumnName,
        expandIconColumnIndex: expandIconColumnIndex,
        ...expandable,
        expandIcon: expandable?.expandIcon ?? table?.expandable?.expandIcon
    };
    const { childrenColumnName: childrenColumnName = "children" } = mergedExpandable;
    const expandType = $cQmXV.useMemo(()=>{
        if (rawData.some((item)=>item?.[childrenColumnName])) return "nest";
        if (expandedRowRender || expandable?.expandedRowRender) return "row";
        return null;
    }, [
        childrenColumnName,
        rawData
    ]);
    const internalRef = {
        body: $cQmXV.useRef(null)
    };
    // ============================ Width =============================
    const getContainerWidth = (0, $8ea7415ad0b1a757$export$2e2bcd8739ae039)(prefixCls);
    // ============================= Refs =============================
    const rootRef = $cQmXV.useRef(null);
    const tblRef = $cQmXV.useRef(null);
    (0, $0de7c436be0f1609$export$8edbe0145ad77a36)(ref, ()=>({
            ...tblRef.current,
            nativeElement: rootRef.current
        }));
    // ============================ RowKey ============================
    const rowKey = customizeRowKey || table?.rowKey || "key";
    // ============================ Scroll ============================
    const mergedScroll = scroll ?? table?.scroll;
    const getRowKey = $cQmXV.useMemo(()=>{
        if ((0, $8e2d153a3c855782$export$f6e2535fb5126e54)(rowKey)) return rowKey;
        return (record)=>record?.[rowKey];
    }, [
        rowKey
    ]);
    const [getRecordByKey] = (0, $0a69084e46484209$export$2e2bcd8739ae039)(rawData, childrenColumnName, getRowKey);
    // ============================ Events =============================
    const changeEventInfo = {};
    const triggerOnChange = (info, action, reset = false)=>{
        const changeInfo = {
            ...changeEventInfo,
            ...info
        };
        if (reset) {
            changeEventInfo.resetPagination?.();
            // Reset event param
            if (changeInfo.pagination?.current) changeInfo.pagination.current = 1;
            // Trigger pagination events
            if (pagination) pagination.onChange?.(1, changeInfo.pagination?.pageSize);
        }
        if (scroll && scroll.scrollToFirstRowOnChange !== false && internalRef.body.current) (0, $355a55ff8bfb603e$export$2e2bcd8739ae039)(0, {
            getContainer: ()=>internalRef.body.current
        });
        onChange?.(changeInfo.pagination, changeInfo.filters, changeInfo.sorter, {
            currentDataSource: (0, $264470bfb0abbd48$export$37643bb40f4c1c56)((0, $c9628492dcc55189$export$594b2c8da4a70ee)(rawData, changeInfo.sorterStates, childrenColumnName), changeInfo.filterStates, childrenColumnName),
            action: action
        });
    };
    /**
   * Controlled state in `columns` is not a good idea that makes too many code (1000+ line?) to read
   * state out and then put it back to title render. Move these code into `hooks` but still too
   * complex. We should provides Table props like `sorter` & `filter` to handle control in next big
   * version.
   */ // ============================ Sorter =============================
    const onSorterChange = (sorter, sorterStates)=>{
        triggerOnChange({
            sorter: sorter,
            sorterStates: sorterStates
        }, "sort", false);
    };
    const [transformSorterColumns, sortStates, sorterTitleProps, getSorters] = (0, $c9628492dcc55189$export$2e2bcd8739ae039)({
        prefixCls: prefixCls,
        mergedColumns: mergedColumns,
        baseColumns: // Pass `baseColumns` (pre-responsive) so `defaultSortOrder` and controlled
        // `sortOrder` on a `responsive` column are still honored when the column
        // is hidden at the current breakpoint.
        // See: https://github.com/ant-design/ant-design/issues/32847
        baseColumns,
        onSorterChange: onSorterChange,
        sortDirections: sortDirections || [
            "ascend",
            "descend"
        ],
        tableLocale: tableLocale,
        showSorterTooltip: showSorterTooltip,
        globalLocale: globalLocale
    });
    const sortedData = $cQmXV.useMemo(()=>(0, $c9628492dcc55189$export$594b2c8da4a70ee)(rawData, sortStates, childrenColumnName), [
        childrenColumnName,
        rawData,
        sortStates
    ]);
    changeEventInfo.sorter = getSorters();
    changeEventInfo.sorterStates = sortStates;
    // ============================ Filter ============================
    const onFilterChange = (filters, filterStates)=>{
        triggerOnChange({
            filters: filters,
            filterStates: filterStates
        }, "filter", true);
    };
    const [transformFilterColumns, filterStates, filters] = (0, $264470bfb0abbd48$export$2e2bcd8739ae039)({
        prefixCls: prefixCls,
        locale: tableLocale,
        dropdownPrefixCls: dropdownPrefixCls,
        mergedColumns: mergedColumns,
        onFilterChange: onFilterChange,
        getPopupContainer: getPopupContainer || getContextPopupContainer,
        rootClassName: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(rootClassName, rootCls)
    });
    const mergedData = (0, $264470bfb0abbd48$export$37643bb40f4c1c56)(sortedData, filterStates, childrenColumnName);
    changeEventInfo.filters = filters;
    changeEventInfo.filterStates = filterStates;
    // ============================ Column ============================
    const columnTitleProps = (0, $9ccd3ed80466adfb$export$2e2bcd8739ae039)(sorterTitleProps, filters);
    const [transformTitleColumns] = (0, $9cd854fa575602d5$export$2e2bcd8739ae039)(columnTitleProps);
    // ========================== Pagination ==========================
    const onPaginationChange = (current, pageSize)=>{
        triggerOnChange({
            pagination: {
                ...changeEventInfo.pagination,
                current: current,
                pageSize: pageSize
            }
        }, "paginate");
    };
    const [mergedPagination, resetPagination] = (0, $09fbec7c68c4ecab$export$2e2bcd8739ae039)(mergedData.length, onPaginationChange, pagination);
    changeEventInfo.pagination = pagination === false ? {} : (0, $09fbec7c68c4ecab$export$27eceeed7bf0f4c2)(mergedPagination, pagination);
    changeEventInfo.resetPagination = resetPagination;
    // ============================= Data =============================
    const pageData = $cQmXV.useMemo(()=>{
        if (pagination === false || !mergedPagination.pageSize) return mergedData;
        const { current: current = 1, total: total, pageSize: pageSize = (0, $09fbec7c68c4ecab$export$5716e8bcb003888d) } = mergedPagination;
        // Dynamic table data
        if (mergedData.length < total) {
            if (mergedData.length > pageSize) return mergedData.slice((current - 1) * pageSize, current * pageSize);
            return mergedData;
        }
        return mergedData.slice((current - 1) * pageSize, current * pageSize);
    }, [
        !!pagination,
        mergedData,
        mergedPagination?.current,
        mergedPagination?.pageSize,
        mergedPagination?.total
    ]);
    // ========================== Selections ==========================
    const [transformSelectionColumns, selectedKeySet] = (0, $c3a712de976be5d3$export$2e2bcd8739ae039)({
        prefixCls: prefixCls,
        data: mergedData,
        pageData: pageData,
        getRowKey: getRowKey,
        getRecordByKey: getRecordByKey,
        expandType: expandType,
        childrenColumnName: childrenColumnName,
        locale: tableLocale,
        getPopupContainer: getPopupContainer || getContextPopupContainer
    }, mergedRowSelection);
    const internalRowClassName = (record, index, indent)=>{
        return (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)({
            [`${prefixCls}-row-selected`]: selectedKeySet.has(getRowKey(record, index))
        }, (0, $8e2d153a3c855782$export$f6e2535fb5126e54)(rowClassName) ? rowClassName(record, index, indent) : rowClassName);
    };
    // ========================== Expandable ==========================
    // Pass origin render status into `@rc-component/table`, this can be removed when refactor with `@rc-component/table`
    mergedExpandable.__PARENT_RENDER_ICON__ = mergedExpandable.expandIcon;
    // Customize expandable icon
    mergedExpandable.expandIcon = mergedExpandable.expandIcon || expandIcon || (0, $cd48f9e57ec43261$export$2e2bcd8739ae039)(tableLocale);
    // Adjust expand icon index, no overwrite expandIconColumnIndex if set.
    if (expandType === "nest" && mergedExpandable.expandIconColumnIndex === undefined) mergedExpandable.expandIconColumnIndex = mergedRowSelection ? 1 : 0;
    else if (mergedExpandable.expandIconColumnIndex > 0 && mergedRowSelection) mergedExpandable.expandIconColumnIndex -= 1;
    // Indent size
    if (!(0, $8e2d153a3c855782$export$7e4aa119212bc614)(mergedExpandable.indentSize)) mergedExpandable.indentSize = (0, $8e2d153a3c855782$export$7e4aa119212bc614)(indentSize) ? indentSize : 15;
    // ============================ Render ============================
    const transformColumns = $cQmXV.useCallback((innerColumns)=>transformTitleColumns(transformSelectionColumns(transformFilterColumns(transformSorterColumns(innerColumns)))), [
        transformSorterColumns,
        transformFilterColumns,
        transformSelectionColumns
    ]);
    let topPaginationNode;
    let bottomPaginationNode;
    if (pagination !== false && mergedPagination?.total) {
        const paginationSize = (0, $b811e249bf5f95a4$export$ff0688c2106d1e55)(mergedPagination.size, mergedSize);
        const renderPagination = (placement = "end")=>/*#__PURE__*/ $cQmXV.createElement((0, $d12a15546f53270f$export$2e2bcd8739ae039), {
                ...mergedPagination,
                classNames: mergedClassNames.pagination,
                styles: mergedStyles.pagination,
                className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-pagination`, `${prefixCls}-pagination-${placement}`, mergedPagination.className),
                size: paginationSize
            });
        const { placement: placement, position: position } = mergedPagination;
        const mergedPlacement = placement ?? position;
        if (Array.isArray(mergedPlacement)) {
            const [topPos, bottomPos] = [
                "top",
                "bottom"
            ].map((dir)=>mergedPlacement.find((p)=>p.includes(dir)));
            const isDisable = mergedPlacement.every((p)=>`${p}` === "none");
            if (!topPos && !bottomPos && !isDisable) bottomPaginationNode = renderPagination();
            if (topPos) topPaginationNode = renderPagination((0, $b811e249bf5f95a4$export$54152637af0f17a7)(topPos));
            if (bottomPos) bottomPaginationNode = renderPagination((0, $b811e249bf5f95a4$export$54152637af0f17a7)(bottomPos));
        } else bottomPaginationNode = renderPagination();
    }
    // >>>>>>>>> Spinning
    const spinProps = (0, $d8a4a3429379d159$export$2e2bcd8739ae039)(loading);
    const wrappercls = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(cssVarCls, rootCls, `${prefixCls}-wrapper`, contextClassName, {
        [`${prefixCls}-wrapper-rtl`]: direction === "rtl"
    }, className, rootClassName, mergedClassNames.root, hashId);
    // ========== empty ==========
    const mergedEmptyNode = $cQmXV.useMemo(()=>{
        // When dataSource is null/undefined (detected by reference equality with EMPTY_LIST),
        // and the table is in a loading state, we only show the loading spinner without the empty placeholder.
        // For empty arrays (datasource={[]}), both loading and empty states would normally be shown.
        // discussion https://github.com/ant-design/ant-design/issues/54601#issuecomment-3158091383
        if (spinProps?.spinning && rawData === $fff43bc68431898c$var$EMPTY_LIST) return null;
        if (typeof locale?.emptyText !== "undefined") return locale.emptyText;
        return renderEmpty?.("Table") || /*#__PURE__*/ $cQmXV.createElement((0, $3f2744634b9eeb0b$export$2e2bcd8739ae039), {
            componentName: "Table"
        });
    }, [
        spinProps?.spinning,
        rawData,
        locale?.emptyText,
        renderEmpty
    ]);
    // ========================== Render ==========================
    const TableComponent = virtual ? (0, $9ccadeb73dccc509$export$2e2bcd8739ae039) : (0, $fe08f834e8448dc2$export$2e2bcd8739ae039);
    // >>> Virtual Table props. We set height here since it will affect height collection
    const virtualProps = {};
    const listItemHeight = $cQmXV.useMemo(()=>{
        const { fontSize: fontSize, lineHeight: lineHeight, lineWidth: lineWidth, padding: padding, paddingXS: paddingXS, paddingSM: paddingSM } = token;
        const fontHeight = Math.floor(fontSize * lineHeight);
        switch(mergedSize){
            case "medium":
                return paddingSM * 2 + fontHeight + lineWidth;
            case "small":
                return paddingXS * 2 + fontHeight + lineWidth;
            default:
                return padding * 2 + fontHeight + lineWidth;
        }
    }, [
        token,
        mergedSize
    ]);
    if (virtual) virtualProps.listItemHeight = listItemHeight;
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        ref: rootRef,
        className: wrappercls,
        style: mergedStyles.root
    }, /*#__PURE__*/ $cQmXV.createElement((0, $62b8cbcd99b9ffa2$export$2e2bcd8739ae039), {
        spinning: false,
        ...spinProps
    }, topPaginationNode, /*#__PURE__*/ $cQmXV.createElement($fff43bc68431898c$var$HeaderTableContext.Provider, {
        value: headerTableContext
    }, /*#__PURE__*/ $cQmXV.createElement(TableComponent, {
        ...virtualProps,
        ...tableProps,
        components: mergedComponents,
        scroll: mergedScroll,
        classNames: mergedClassNames,
        styles: mergedStyles,
        ref: tblRef,
        columns: mergedColumns,
        direction: direction,
        expandable: mergedExpandable,
        prefixCls: prefixCls,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)({
            [`${prefixCls}-medium`]: mergedSize === "medium",
            [`${prefixCls}-small`]: mergedSize === "small",
            [`${prefixCls}-bordered`]: bordered,
            [`${prefixCls}-empty`]: rawData.length === 0
        }, cssVarCls, rootCls, hashId),
        data: pageData,
        rowKey: getRowKey,
        rowClassName: internalRowClassName,
        emptyText: mergedEmptyNode,
        // Internal
        internalHooks: (0, $9848d298b42e15e6$export$91b75cf262680225),
        internalRefs: internalRef,
        transformColumns: transformColumns,
        getContainerWidth: getContainerWidth,
        measureRowRender: (measureRow)=>/*#__PURE__*/ $cQmXV.createElement((0, $618736959620ab5c$export$2e2bcd8739ae039).Provider, {
                value: true
            }, /*#__PURE__*/ $cQmXV.createElement((0, $5764e43cf38ca965$export$2e2bcd8739ae039), {
                getPopupContainer: (node)=>node
            }, measureRow))
    })), bottomPaginationNode));
};
var $fff43bc68431898c$export$2e2bcd8739ae039 = /*#__PURE__*/ $cQmXV.forwardRef($fff43bc68431898c$var$InternalTable);


"use client";
const $b4a1e0456b61d988$var$Table = (props, ref)=>{
    const renderTimesRef = $cQmXV.useRef(0);
    renderTimesRef.current += 1;
    return /*#__PURE__*/ $cQmXV.createElement((0, $fff43bc68431898c$export$2e2bcd8739ae039), {
        ...props,
        ref: ref,
        _renderTimes: renderTimesRef.current
    });
};
const $b4a1e0456b61d988$var$ForwardTable = /*#__PURE__*/ $cQmXV.forwardRef($b4a1e0456b61d988$var$Table);
$b4a1e0456b61d988$var$ForwardTable.SELECTION_COLUMN = (0, $c3a712de976be5d3$export$ed10248435b8f218);
$b4a1e0456b61d988$var$ForwardTable.EXPAND_COLUMN = (0, $9848d298b42e15e6$export$e1053575ddfcb301);
$b4a1e0456b61d988$var$ForwardTable.SELECTION_ALL = (0, $c3a712de976be5d3$export$14159cd9e2a500c8);
$b4a1e0456b61d988$var$ForwardTable.SELECTION_INVERT = (0, $c3a712de976be5d3$export$625c4f68eaaf8cfd);
$b4a1e0456b61d988$var$ForwardTable.SELECTION_NONE = (0, $c3a712de976be5d3$export$c1a725540f5a63bd);
$b4a1e0456b61d988$var$ForwardTable.Column = (0, $8713c088cd428ad0$export$2e2bcd8739ae039);
$b4a1e0456b61d988$var$ForwardTable.ColumnGroup = (0, $dbd4a530607439a8$export$2e2bcd8739ae039);
$b4a1e0456b61d988$var$ForwardTable.Summary = (0, $a9a17de46d12194c$export$d605f3af09eef683);
var $b4a1e0456b61d988$export$2e2bcd8739ae039 = $b4a1e0456b61d988$var$ForwardTable;


"use client";
var $dff4d45d201c6dfe$export$2e2bcd8739ae039 = (0, $b4a1e0456b61d988$export$2e2bcd8739ae039);


var $cQmXV = parcelRequire("cQmXV");


var $cQmXV = parcelRequire("cQmXV");

var $3h5eW = parcelRequire("3h5eW");

var $cQmXV = parcelRequire("cQmXV");



var $cQmXV = parcelRequire("cQmXV");

var $9b461e4c7f86cd5e$export$2e2bcd8739ae039 = (file, acceptedFiles)=>{
    if (file && acceptedFiles) {
        const acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(",");
        const fileName = file.name || "";
        const mimeType = file.type || "";
        const baseMimeType = mimeType.replace(/\/.*$/, "");
        return acceptedFilesArray.some((type)=>{
            const validType = type.trim();
            // This is something like */*,*  allow all files
            if (/^\*(\/\*)?$/.test(type)) return true;
            // like .jpg, .png
            if (validType.charAt(0) === ".") {
                const lowerFileName = fileName.toLowerCase();
                const lowerType = validType.toLowerCase();
                let affixList = [
                    lowerType
                ];
                if (lowerType === ".jpg" || lowerType === ".jpeg") affixList = [
                    ".jpg",
                    ".jpeg"
                ];
                return affixList.some((affix)=>lowerFileName.endsWith(affix));
            }
            // This is something like a image/* mime type
            if (/\/\*$/.test(validType)) return baseMimeType === validType.replace(/\/.*$/, "");
            // Full match
            if (mimeType === validType) return true;
            // Invalidate type should skip
            if (/^\w+$/.test(validType)) {
                (0, $26d7cf6379fe7659$export$2e2bcd8739ae039)(false, `Upload takes an invalidate 'accept' type '${validType}'.Skip for check.`);
                return true;
            }
            return false;
        });
    }
    return true;
};


function $defb73ca8a85391e$var$getError(option, xhr) {
    const msg = `cannot ${option.method} ${option.action} ${xhr.status}'`;
    const err = new Error(msg);
    err.status = xhr.status;
    err.method = option.method;
    err.url = option.action;
    return err;
}
function $defb73ca8a85391e$var$getBody(xhr) {
    const text = xhr.responseText || xhr.response;
    if (!text) return text;
    try {
        return JSON.parse(text);
    } catch (e) {
        return text;
    }
}
function $defb73ca8a85391e$export$2e2bcd8739ae039(option) {
    // eslint-disable-next-line no-undef
    const xhr = new XMLHttpRequest();
    if (option.onProgress && xhr.upload) xhr.upload.onprogress = function progress(e) {
        if (e.total > 0) e.percent = e.loaded / e.total * 100;
        option.onProgress(e);
    };
    // eslint-disable-next-line no-undef
    const formData = new FormData();
    if (option.data) Object.keys(option.data).forEach((key)=>{
        const value = option.data[key];
        // support key-value array data
        if (Array.isArray(value)) {
            value.forEach((item)=>{
                // { list: [ 11, 22 ] }
                // formData.append('list[]', 11);
                formData.append(`${key}[]`, item);
            });
            return;
        }
        formData.append(key, value);
    });
    // eslint-disable-next-line no-undef
    if (option.file instanceof Blob) formData.append(option.filename, option.file, option.file.name);
    else formData.append(option.filename, option.file);
    xhr.onerror = function error(e) {
        option.onError(e);
    };
    xhr.onload = function onload() {
        // allow success when 2xx status
        // see https://github.com/react-component/upload/issues/34
        if (xhr.status < 200 || xhr.status >= 300) return option.onError($defb73ca8a85391e$var$getError(option, xhr), $defb73ca8a85391e$var$getBody(xhr));
        return option.onSuccess($defb73ca8a85391e$var$getBody(xhr), xhr);
    };
    xhr.open(option.method, option.action, true);
    // Has to be after `.open()`. See https://github.com/enyo/dropzone/issues/179
    if (option.withCredentials && "withCredentials" in xhr) xhr.withCredentials = true;
    const headers = option.headers || {};
    // when set headers['X-Requested-With'] = null , can close default XHR header
    // see https://github.com/react-component/upload/issues/33
    if (headers["X-Requested-With"] !== null) xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    Object.keys(headers).forEach((h)=>{
        if (headers[h] !== null) xhr.setRequestHeader(h, headers[h]);
    });
    xhr.send(formData);
    return {
        abort () {
            xhr.abort();
        }
    };
}


// https://github.com/ant-design/ant-design/issues/50080
const $a53b467638a06310$var$traverseFileTree = async (files, isAccepted)=>{
    const flattenFileList = [];
    const progressFileList = [];
    files.forEach((file)=>progressFileList.push(file.webkitGetAsEntry()));
    async function readDirectory(directory) {
        const dirReader = directory.createReader();
        const entries = [];
        while(true){
            const results = await new Promise((resolve)=>{
                dirReader.readEntries(resolve, ()=>resolve([]));
            });
            const n = results.length;
            if (!n) break;
            for(let i = 0; i < n; i++)entries.push(results[i]);
        }
        return entries;
    }
    async function readFile(item) {
        return new Promise((reslove)=>{
            item.file((file)=>{
                if (isAccepted(file)) {
                    // https://github.com/ant-design/ant-design/issues/16426
                    if (item.fullPath && !file.webkitRelativePath) {
                        Object.defineProperties(file, {
                            webkitRelativePath: {
                                writable: true
                            }
                        });
                        // eslint-disable-next-line no-param-reassign
                        file.webkitRelativePath = item.fullPath.replace(/^\//, "");
                        Object.defineProperties(file, {
                            webkitRelativePath: {
                                writable: false
                            }
                        });
                    }
                    reslove(file);
                } else reslove(null);
            });
        });
    }
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const _traverseFileTree = async (item, path)=>{
        if (!item) return;
        // eslint-disable-next-line no-param-reassign
        item.path = path || "";
        if (item.isFile) {
            const file = await readFile(item);
            if (file) flattenFileList.push(file);
        } else if (item.isDirectory) {
            const entries = await readDirectory(item);
            progressFileList.push(...entries);
        }
    };
    let wipIndex = 0;
    while(wipIndex < progressFileList.length){
        await _traverseFileTree(progressFileList[wipIndex]);
        wipIndex++;
    }
    return flattenFileList;
};
var $a53b467638a06310$export$2e2bcd8739ae039 = $a53b467638a06310$var$traverseFileTree;


const $778c5115be354fa1$var$now = +new Date();
let $778c5115be354fa1$var$index = 0;
function $778c5115be354fa1$export$2e2bcd8739ae039() {
    // eslint-disable-next-line no-plusplus
    return `rc-upload-${$778c5115be354fa1$var$now}-${++$778c5115be354fa1$var$index}`;
}


function $8b004010b11a4717$var$_extends() {
    $8b004010b11a4717$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8b004010b11a4717$var$_extends.apply(this, arguments);
}
class $8b004010b11a4717$var$AjaxUploader extends (0, $cQmXV.Component) {
    state = {
        uid: (0, $778c5115be354fa1$export$2e2bcd8739ae039)()
    };
    reqs = {};
    fileInput;
    _isMounted;
    filterFile = (file, force = false)=>{
        const { accept: accept, directory: directory } = this.props;
        let filterFn;
        let acceptFormat;
        if (typeof accept === "string") acceptFormat = accept;
        else {
            const { filter: filter, format: format } = accept || {};
            acceptFormat = format;
            if (filter === "native") filterFn = ()=>true;
            else filterFn = filter;
        }
        const mergedFilter = filterFn || (directory || force ? (currentFile)=>(0, $9b461e4c7f86cd5e$export$2e2bcd8739ae039)(currentFile, acceptFormat) : ()=>true);
        return mergedFilter(file);
    };
    onChange = (e)=>{
        const { files: files } = e.target;
        const acceptedFiles = [
            ...files
        ].filter((file)=>this.filterFile(file));
        this.uploadFiles(acceptedFiles);
        this.reset();
    };
    onClick = (event)=>{
        const el = this.fileInput;
        if (!el) return;
        const target = event.target;
        const { onClick: onClick } = this.props;
        if (target && target.tagName === "BUTTON") {
            const parent = el.parentNode;
            parent.focus();
            target.blur();
        }
        el.click();
        if (onClick) onClick(event);
    };
    onKeyDown = (e)=>{
        if (e.key === "Enter") this.onClick(e);
    };
    onDataTransferFiles = async (dataTransfer, existFileCallback)=>{
        const { multiple: multiple, directory: directory } = this.props;
        const items = [
            ...dataTransfer.items || []
        ];
        let files = [
            ...dataTransfer.files || []
        ];
        if (files.length > 0 || items.some((item)=>item.kind === "file")) existFileCallback?.();
        if (directory) {
            files = await (0, $a53b467638a06310$export$2e2bcd8739ae039)(Array.prototype.slice.call(items), this.filterFile);
            this.uploadFiles(files);
        } else {
            let acceptFiles = [
                ...files
            ].filter((file)=>this.filterFile(file, true));
            if (multiple === false) acceptFiles = files.slice(0, 1);
            this.uploadFiles(acceptFiles);
        }
    };
    onFilePaste = async (e)=>{
        const { pastable: pastable } = this.props;
        if (!pastable) return;
        if (e.type === "paste") {
            const clipboardData = e.clipboardData;
            return this.onDataTransferFiles(clipboardData, ()=>{
                e.preventDefault();
            });
        }
    };
    onFileDragOver = (e)=>{
        e.preventDefault();
    };
    onFileDrop = async (e)=>{
        e.preventDefault();
        if (e.type === "drop") {
            const dataTransfer = e.dataTransfer;
            return this.onDataTransferFiles(dataTransfer);
        }
    };
    componentDidMount() {
        this._isMounted = true;
        const { pastable: pastable } = this.props;
        if (pastable) document.addEventListener("paste", this.onFilePaste);
    }
    componentWillUnmount() {
        this._isMounted = false;
        this.abort();
        document.removeEventListener("paste", this.onFilePaste);
    }
    componentDidUpdate(prevProps) {
        const { pastable: pastable } = this.props;
        if (pastable && !prevProps.pastable) document.addEventListener("paste", this.onFilePaste);
        else if (!pastable && prevProps.pastable) document.removeEventListener("paste", this.onFilePaste);
    }
    uploadFiles = (files)=>{
        const originFiles = [
            ...files
        ];
        const postFiles = originFiles.map((file)=>{
            // eslint-disable-next-line no-param-reassign
            file.uid = (0, $778c5115be354fa1$export$2e2bcd8739ae039)();
            return this.processFile(file, originFiles);
        });
        // Batch upload files
        Promise.all(postFiles).then((fileList)=>{
            const { onBatchStart: onBatchStart } = this.props;
            onBatchStart?.(fileList.map(({ origin: origin, parsedFile: parsedFile })=>({
                    file: origin,
                    parsedFile: parsedFile
                })));
            fileList.filter((file)=>file.parsedFile !== null).forEach((file)=>{
                this.post(file);
            });
        });
    };
    /**
   * Process file before upload. When all the file is ready, we start upload.
   */ processFile = async (file, fileList)=>{
        const { beforeUpload: beforeUpload } = this.props;
        let transformedFile = file;
        if (beforeUpload) {
            try {
                transformedFile = await beforeUpload(file, fileList);
            } catch (e) {
                // Rejection will also trade as false
                transformedFile = false;
            }
            if (transformedFile === false) return {
                origin: file,
                parsedFile: null,
                action: null,
                data: null
            };
        }
        // Get latest action
        const { action: action } = this.props;
        let mergedAction;
        if (typeof action === "function") mergedAction = await action(file);
        else mergedAction = action;
        // Get latest data
        const { data: data } = this.props;
        let mergedData;
        if (typeof data === "function") mergedData = await data(file);
        else mergedData = data;
        const parsedData = // string type is from legacy `transformFile`.
        // Not sure if this will work since no related test case works with it
        (typeof transformedFile === "object" || typeof transformedFile === "string") && transformedFile ? transformedFile : file;
        let parsedFile;
        if (parsedData instanceof File) parsedFile = parsedData;
        else parsedFile = new File([
            parsedData
        ], file.name, {
            type: file.type
        });
        const mergedParsedFile = parsedFile;
        mergedParsedFile.uid = file.uid;
        return {
            origin: file,
            data: mergedData,
            parsedFile: mergedParsedFile,
            action: mergedAction
        };
    };
    post({ data: data, origin: origin, action: action, parsedFile: parsedFile }) {
        if (!this._isMounted) return;
        const { onStart: onStart, customRequest: customRequest, name: name, headers: headers, withCredentials: withCredentials, method: method } = this.props;
        const { uid: uid } = origin;
        const request = customRequest || (0, $defb73ca8a85391e$export$2e2bcd8739ae039);
        const requestOption = {
            action: action,
            filename: name,
            data: data,
            file: parsedFile,
            headers: headers,
            withCredentials: withCredentials,
            method: method || "post",
            onProgress: (e)=>{
                const { onProgress: onProgress } = this.props;
                onProgress?.(e, parsedFile);
            },
            onSuccess: (ret, xhr)=>{
                const { onSuccess: onSuccess } = this.props;
                onSuccess?.(ret, parsedFile, xhr);
                delete this.reqs[uid];
            },
            onError: (err, ret)=>{
                const { onError: onError } = this.props;
                onError?.(err, ret, parsedFile);
                delete this.reqs[uid];
            }
        };
        onStart(origin);
        this.reqs[uid] = request(requestOption, {
            defaultRequest: $defb73ca8a85391e$export$2e2bcd8739ae039
        });
    }
    reset() {
        this.setState({
            uid: (0, $778c5115be354fa1$export$2e2bcd8739ae039)()
        });
    }
    abort(file) {
        const { reqs: reqs } = this;
        if (file) {
            const uid = file.uid ? file.uid : file;
            if (reqs[uid] && reqs[uid].abort) reqs[uid].abort();
            delete reqs[uid];
        } else Object.keys(reqs).forEach((uid)=>{
            if (reqs[uid] && reqs[uid].abort) reqs[uid].abort();
            delete reqs[uid];
        });
    }
    saveFileInput = (node)=>{
        this.fileInput = node;
    };
    render() {
        const { component: Tag, prefixCls: prefixCls, className: className, classNames: classNames = {}, disabled: disabled, id: id, name: name, style: style, styles: styles = {}, multiple: multiple, accept: accept, capture: capture, children: children, directory: directory, openFileDialogOnClick: openFileDialogOnClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, hasControlInside: hasControlInside, ...otherProps } = this.props;
        // Extract accept format for input element
        const acceptFormat = typeof accept === "string" ? accept : accept?.format;
        const cls = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, {
            [`${prefixCls}-disabled`]: disabled,
            [className]: className
        });
        // because input don't have directory/webkitdirectory type declaration
        const dirProps = directory ? {
            directory: "directory",
            webkitdirectory: "webkitdirectory"
        } : {};
        const events = disabled ? {} : {
            onClick: openFileDialogOnClick ? this.onClick : ()=>{},
            onKeyDown: openFileDialogOnClick ? this.onKeyDown : ()=>{},
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onDrop: this.onFileDrop,
            onDragOver: this.onFileDragOver,
            tabIndex: hasControlInside ? undefined : "0"
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement(Tag, $8b004010b11a4717$var$_extends({}, events, {
            className: cls,
            role: hasControlInside ? undefined : "button",
            style: style
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("input", $8b004010b11a4717$var$_extends({}, (0, $4b5c733d1d7bb306$export$2e2bcd8739ae039)(otherProps, {
            aria: true,
            data: true
        }), {
            id: id,
            name: name,
            disabled: disabled,
            type: "file",
            ref: this.saveFileInput,
            onClick: (e)=>e.stopPropagation() // https://github.com/ant-design/ant-design/issues/19948
            ,
            key: this.state.uid,
            style: {
                display: "none",
                ...styles.input
            },
            className: classNames.input,
            accept: acceptFormat
        }, dirProps, {
            multiple: multiple,
            onChange: this.onChange
        }, capture != null ? {
            capture: capture
        } : {})), children);
    }
}
var $8b004010b11a4717$export$2e2bcd8739ae039 = $8b004010b11a4717$var$AjaxUploader;


function $0772274fa86c832c$var$_extends() {
    $0772274fa86c832c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0772274fa86c832c$var$_extends.apply(this, arguments);
}
function $0772274fa86c832c$var$empty() {}
class $0772274fa86c832c$var$Upload extends (0, $cQmXV.Component) {
    static defaultProps = {
        component: "span",
        prefixCls: "rc-upload",
        data: {},
        headers: {},
        name: "file",
        multipart: false,
        onStart: $0772274fa86c832c$var$empty,
        onError: $0772274fa86c832c$var$empty,
        onSuccess: $0772274fa86c832c$var$empty,
        multiple: false,
        beforeUpload: null,
        customRequest: null,
        withCredentials: false,
        openFileDialogOnClick: true,
        hasControlInside: false
    };
    uploader;
    abort(file) {
        this.uploader.abort(file);
    }
    saveUploader = (node)=>{
        this.uploader = node;
    };
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $8b004010b11a4717$export$2e2bcd8739ae039), $0772274fa86c832c$var$_extends({}, this.props, {
            ref: this.saveUploader
        }));
    }
}
var $0772274fa86c832c$export$2e2bcd8739ae039 = $0772274fa86c832c$var$Upload;


var $80f406473f616ccd$export$2e2bcd8739ae039 = (0, $0772274fa86c832c$export$2e2bcd8739ae039);
















const $33cbbb3e6891660c$var$genDraggerStyle = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls } = token;
    return {
        [`${componentCls}-wrapper`]: {
            [`${componentCls}-drag`]: {
                position: "relative",
                width: "100%",
                height: "100%",
                textAlign: "center",
                background: token.colorFillAlter,
                border: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidth)} dashed ${token.colorBorder}`,
                borderRadius: token.borderRadiusLG,
                cursor: "pointer",
                transition: `border-color ${token.motionDurationSlow}`,
                [componentCls]: {
                    padding: token.padding
                },
                [`${componentCls}-btn`]: {
                    display: "table",
                    width: "100%",
                    height: "100%",
                    outline: "none",
                    borderRadius: token.borderRadiusLG,
                    "&:focus-visible": {
                        outline: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidthFocus)} solid ${token.colorPrimaryBorder}`
                    }
                },
                [`${componentCls}-drag-container`]: {
                    display: "table-cell",
                    verticalAlign: "middle"
                },
                [`
          &:not(${componentCls}-disabled):hover,
          &-hover:not(${componentCls}-disabled)
        `]: {
                    borderColor: token.colorPrimaryHover
                },
                [`p${componentCls}-drag-icon`]: {
                    marginBottom: token.margin,
                    [iconCls]: {
                        color: token.colorPrimary,
                        fontSize: token.uploadThumbnailSize
                    }
                },
                [`p${componentCls}-text`]: {
                    margin: `0 0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.marginXXS)}`,
                    color: token.colorTextHeading,
                    fontSize: token.fontSizeLG
                },
                [`p${componentCls}-hint`]: {
                    color: token.colorTextDescription,
                    fontSize: token.fontSize
                },
                // ===================== Disabled =====================
                [`&${componentCls}-disabled`]: {
                    [`p${componentCls}-drag-icon ${iconCls},
            p${componentCls}-text,
            p${componentCls}-hint
          `]: {
                        color: token.colorTextDisabled
                    }
                }
            }
        }
    };
};
var $33cbbb3e6891660c$export$2e2bcd8739ae039 = $33cbbb3e6891660c$var$genDraggerStyle;




const $bde350731a43b145$var$genListStyle = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, fontSize: fontSize, lineHeight: lineHeight, motionDurationSlow: motionDurationSlow, calc: calc } = token;
    const itemCls = `${componentCls}-list-item`;
    const actionsCls = `${itemCls}-actions`;
    const actionCls = `${itemCls}-action`;
    return {
        [`${componentCls}-wrapper`]: {
            [`${componentCls}-list`]: {
                ...(0, $519d20bf207ce864$export$8c467e8859fdef13)(),
                lineHeight: token.lineHeight,
                [itemCls]: {
                    position: "relative",
                    height: calc(token.lineHeight).mul(fontSize).equal(),
                    marginTop: token.marginXS,
                    fontSize: fontSize,
                    display: "flex",
                    alignItems: "center",
                    transition: `background-color ${motionDurationSlow}`,
                    borderRadius: token.borderRadiusSM,
                    "&:hover": {
                        backgroundColor: token.controlItemBgHover
                    },
                    [`${itemCls}-name`]: {
                        ...(0, $519d20bf207ce864$export$b2b65df0d0824629),
                        padding: `0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.paddingXS)}`,
                        lineHeight: lineHeight,
                        flex: "auto",
                        transition: `all ${motionDurationSlow}`
                    },
                    [actionsCls]: {
                        whiteSpace: "nowrap",
                        [actionCls]: {
                            opacity: 0
                        },
                        "@media (hover: none), (pointer: coarse)": {
                            [actionCls]: {
                                opacity: 1
                            }
                        },
                        [iconCls]: {
                            color: token.actionsColor,
                            transition: `all ${motionDurationSlow}`
                        },
                        [`
              ${actionCls}:focus-visible,
              &.picture ${actionCls}
            `]: {
                            opacity: 1
                        }
                    },
                    [`${componentCls}-icon ${iconCls}`]: {
                        color: token.colorIcon,
                        fontSize: fontSize
                    },
                    [`${itemCls}-progress`]: {
                        position: "absolute",
                        bottom: token.calc(token.uploadProgressOffset).mul(-1).equal(),
                        width: "100%",
                        paddingInlineStart: calc(fontSize).add(token.paddingXS).equal(),
                        fontSize: fontSize,
                        lineHeight: 0,
                        pointerEvents: "none",
                        "> div": {
                            margin: 0
                        }
                    }
                },
                [`${itemCls}:hover ${actionCls}`]: {
                    opacity: 1
                },
                [`${itemCls}-error`]: {
                    color: token.colorError,
                    [`${itemCls}-name, ${componentCls}-icon ${iconCls}`]: {
                        color: token.colorError
                    },
                    [actionsCls]: {
                        [`${iconCls}, ${iconCls}:hover`]: {
                            color: token.colorError
                        },
                        [actionCls]: {
                            opacity: 1
                        }
                    }
                },
                [`${componentCls}-list-item-container`]: {
                    transition: [
                        "opacity",
                        "height"
                    ].map((prop)=>`${prop} ${motionDurationSlow}`).join(", "),
                    // For smooth removing animation
                    "&::before": {
                        display: "table",
                        width: 0,
                        height: 0,
                        content: '""'
                    }
                }
            }
        }
    };
};
var $bde350731a43b145$export$2e2bcd8739ae039 = $bde350731a43b145$var$genListStyle;




// =========================== Motion ===========================
const $48b0c1c73f934c67$var$genMotionStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const uploadAnimateInlineIn = new (0, $e928d3664c9ed565$export$2e2bcd8739ae039)("uploadAnimateInlineIn", {
        from: {
            width: 0,
            height: 0,
            padding: 0,
            opacity: 0,
            margin: token.calc(token.marginXS).div(-2).equal()
        }
    });
    const uploadAnimateInlineOut = new (0, $e928d3664c9ed565$export$2e2bcd8739ae039)("uploadAnimateInlineOut", {
        to: {
            width: 0,
            height: 0,
            padding: 0,
            opacity: 0,
            margin: token.calc(token.marginXS).div(-2).equal()
        }
    });
    const inlineCls = `${componentCls}-animate-inline`;
    return [
        {
            [`${componentCls}-wrapper`]: {
                [`${inlineCls}-appear, ${inlineCls}-enter, ${inlineCls}-leave`]: {
                    animationDuration: token.motionDurationSlow,
                    animationTimingFunction: token.motionEaseInOutCirc,
                    animationFillMode: "forwards"
                },
                [`${inlineCls}-appear, ${inlineCls}-enter`]: {
                    animationName: uploadAnimateInlineIn
                },
                [`${inlineCls}-leave`]: {
                    animationName: uploadAnimateInlineOut
                }
            }
        },
        {
            [`${componentCls}-wrapper`]: (0, $3fd8fb5c97e7786c$export$2909268c8354a12)(token)
        },
        uploadAnimateInlineIn,
        uploadAnimateInlineOut
    ];
};
var $48b0c1c73f934c67$export$2e2bcd8739ae039 = $48b0c1c73f934c67$var$genMotionStyle;




const $17c29459369f0ad2$export$353fdbacdd19997a = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, uploadThumbnailSize: uploadThumbnailSize, uploadProgressOffset: uploadProgressOffset, calc: calc } = token;
    const listCls = `${componentCls}-list`;
    const itemCls = `${listCls}-item`;
    return {
        [`${componentCls}-wrapper`]: {
            // ${listCls} 增加优先级
            [`
        ${listCls}${listCls}-picture,
        ${listCls}${listCls}-picture-card,
        ${listCls}${listCls}-picture-circle
      `]: {
                [itemCls]: {
                    position: "relative",
                    height: calc(uploadThumbnailSize).add(calc(token.lineWidth).mul(2)).add(calc(token.paddingXS).mul(2)).equal(),
                    padding: token.paddingXS,
                    border: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                    borderRadius: token.borderRadiusLG,
                    "&:hover": {
                        background: "transparent"
                    },
                    [`${itemCls}-thumbnail`]: {
                        ...(0, $519d20bf207ce864$export$b2b65df0d0824629),
                        width: uploadThumbnailSize,
                        height: uploadThumbnailSize,
                        lineHeight: (0, $05f34ed03d41967d$export$523c0b569236b342)(calc(uploadThumbnailSize).add(token.paddingSM).equal()),
                        textAlign: "center",
                        flex: "none",
                        [iconCls]: {
                            fontSize: token.fontSizeHeading2,
                            color: token.colorPrimary
                        },
                        img: {
                            display: "block",
                            width: "100%",
                            height: "100%",
                            overflow: "hidden"
                        }
                    },
                    [`${itemCls}-progress`]: {
                        bottom: calc(token.fontSize).mul(token.lineHeight).div(2).add(uploadProgressOffset).equal(),
                        width: `calc(100% - ${(0, $05f34ed03d41967d$export$523c0b569236b342)(calc(token.paddingSM).mul(2).equal())})`,
                        marginTop: 0,
                        paddingInlineStart: calc(uploadThumbnailSize).add(token.paddingXS).equal()
                    }
                },
                [`${itemCls}-error`]: {
                    borderColor: token.colorError,
                    [`${itemCls}-thumbnail${itemCls}-file ${iconCls}`]: {
                        color: token.colorError
                    }
                },
                [`${itemCls}-uploading`]: {
                    borderStyle: "dashed",
                    [`${itemCls}-name`]: {
                        marginBottom: uploadProgressOffset
                    }
                }
            },
            [`${listCls}${listCls}-picture-circle ${itemCls}`]: {
                [`&, &::before, ${itemCls}-thumbnail`]: {
                    borderRadius: "50%"
                }
            }
        }
    };
};
const $17c29459369f0ad2$export$31311f200c99910f = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, fontSizeLG: fontSizeLG, colorTextLightSolid: colorTextLightSolid, calc: calc } = token;
    const listCls = `${componentCls}-list`;
    const itemCls = `${listCls}-item`;
    const uploadPictureCardSize = token.uploadPicCardSize;
    return {
        [`
      ${componentCls}-wrapper${componentCls}-picture-card-wrapper,
      ${componentCls}-wrapper${componentCls}-picture-circle-wrapper
    `]: {
            ...(0, $519d20bf207ce864$export$8c467e8859fdef13)(),
            display: "block",
            [`${componentCls}${componentCls}-select`]: {
                width: uploadPictureCardSize,
                height: uploadPictureCardSize,
                textAlign: "center",
                verticalAlign: "top",
                backgroundColor: token.colorFillAlter,
                border: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidth)} dashed ${token.colorBorder}`,
                borderRadius: token.borderRadiusLG,
                cursor: "pointer",
                transition: `border-color ${token.motionDurationSlow}`,
                [`> ${componentCls}`]: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                    textAlign: "center"
                },
                [`&:not(${componentCls}-disabled):hover`]: {
                    borderColor: token.colorPrimary
                }
            },
            // list
            [`${listCls}${listCls}-picture-card, ${listCls}${listCls}-picture-circle`]: {
                display: "flex",
                flexWrap: "wrap",
                "&:not(:empty)": {
                    minHeight: uploadPictureCardSize
                },
                "@supports not (gap: 1px)": {
                    "& > *": {
                        marginBlockEnd: token.marginXS,
                        marginInlineEnd: token.marginXS
                    }
                },
                "@supports (gap: 1px)": {
                    gap: token.marginXS
                },
                [`${listCls}-item-container`]: {
                    display: "inline-block",
                    width: uploadPictureCardSize,
                    height: uploadPictureCardSize,
                    verticalAlign: "top"
                },
                "&::after": {
                    display: "none"
                },
                "&::before": {
                    display: "none"
                },
                [itemCls]: {
                    height: "100%",
                    margin: 0,
                    "&::before": {
                        position: "absolute",
                        zIndex: 1,
                        width: `calc(100% - ${(0, $05f34ed03d41967d$export$523c0b569236b342)(calc(token.paddingXS).mul(2).equal())})`,
                        height: `calc(100% - ${(0, $05f34ed03d41967d$export$523c0b569236b342)(calc(token.paddingXS).mul(2).equal())})`,
                        backgroundColor: token.colorBgMask,
                        opacity: 0,
                        transition: `all ${token.motionDurationSlow}`,
                        content: '" "'
                    }
                },
                [`${itemCls}:hover`]: {
                    [`&::before, ${itemCls}-actions`]: {
                        opacity: 1
                    }
                },
                [`${itemCls}-actions`]: {
                    position: "absolute",
                    insetInlineStart: 0,
                    zIndex: 10,
                    width: "100%",
                    whiteSpace: "nowrap",
                    textAlign: "center",
                    opacity: 0,
                    transition: `all ${token.motionDurationSlow}`,
                    [`
            ${iconCls}-eye,
            ${iconCls}-download,
            ${iconCls}-delete
          `]: {
                        zIndex: 10,
                        width: fontSizeLG,
                        margin: `0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.marginXXS)}`,
                        fontSize: fontSizeLG,
                        cursor: "pointer",
                        transition: `all ${token.motionDurationSlow}`,
                        color: colorTextLightSolid,
                        "&:hover": {
                            color: colorTextLightSolid
                        },
                        svg: {
                            verticalAlign: "baseline"
                        }
                    }
                },
                [`${itemCls}-thumbnail, ${itemCls}-thumbnail img`]: {
                    position: "static",
                    display: "block",
                    width: "100%",
                    height: "100%",
                    objectFit: "contain"
                },
                [`${itemCls}-name`]: {
                    display: "none",
                    textAlign: "center"
                },
                [`${itemCls}-file + ${itemCls}-name`]: {
                    position: "absolute",
                    bottom: token.margin,
                    display: "block",
                    width: `calc(100% - ${(0, $05f34ed03d41967d$export$523c0b569236b342)(calc(token.paddingXS).mul(2).equal())})`
                },
                [`${itemCls}-uploading`]: {
                    [`&${itemCls}`]: {
                        backgroundColor: token.colorFillAlter
                    },
                    [`&::before, ${iconCls}-eye, ${iconCls}-download, ${iconCls}-delete`]: {
                        display: "none"
                    }
                },
                [`${itemCls}-progress`]: {
                    bottom: token.marginXL,
                    width: `calc(100% - ${(0, $05f34ed03d41967d$export$523c0b569236b342)(calc(token.paddingXS).mul(2).equal())})`,
                    paddingInlineStart: 0
                }
            }
        },
        [`${componentCls}-wrapper${componentCls}-picture-circle-wrapper`]: {
            [`${componentCls}${componentCls}-select`]: {
                borderRadius: "50%"
            }
        }
    };
};


// =========================== Motion ===========================
const $4b39649a055ab551$var$genRtlStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-rtl`]: {
            direction: "rtl"
        }
    };
};
var $4b39649a055ab551$export$2e2bcd8739ae039 = $4b39649a055ab551$var$genRtlStyle;


const $4c1cc03801c301db$var$genBaseStyle = (token)=>{
    const { componentCls: componentCls, colorTextDisabled: colorTextDisabled } = token;
    return {
        [`${componentCls}-wrapper`]: {
            ...(0, $519d20bf207ce864$export$23997c3e44cc1c59)(token),
            [componentCls]: {
                outline: 0,
                "input[type='file']": {
                    cursor: "pointer"
                }
            },
            [`${componentCls}-select`]: {
                display: "inline-block"
            },
            [`${componentCls}-hidden`]: {
                display: "none"
            },
            [`${componentCls}-disabled`]: {
                color: colorTextDisabled,
                cursor: "not-allowed"
            }
        }
    };
};
const $4c1cc03801c301db$export$9ca1be8807fe0675 = (token)=>({
        actionsColor: token.colorIcon,
        pictureCardSize: token.controlHeightLG * 2.55
    });
var // ============================== Export ==============================
$4c1cc03801c301db$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$51ec95de45185b42)("Upload", (token)=>{
    const { fontSizeHeading3: fontSizeHeading3, marginXS: marginXS, lineWidth: lineWidth, pictureCardSize: pictureCardSize, calc: calc } = token;
    const uploadToken = (0, $fef50f256b80dfa5$export$4950aa0f605343fb)(token, {
        uploadThumbnailSize: calc(fontSizeHeading3).mul(2).equal(),
        uploadProgressOffset: calc(calc(marginXS).div(2)).add(lineWidth).equal(),
        uploadPicCardSize: pictureCardSize
    });
    return [
        $4c1cc03801c301db$var$genBaseStyle(uploadToken),
        (0, $33cbbb3e6891660c$export$2e2bcd8739ae039)(uploadToken),
        (0, $17c29459369f0ad2$export$353fdbacdd19997a)(uploadToken),
        (0, $17c29459369f0ad2$export$31311f200c99910f)(uploadToken),
        (0, $bde350731a43b145$export$2e2bcd8739ae039)(uploadToken),
        (0, $48b0c1c73f934c67$export$2e2bcd8739ae039)(uploadToken),
        (0, $4b39649a055ab551$export$2e2bcd8739ae039)(uploadToken),
        (0, $3576e621578e370a$export$2e2bcd8739ae039)(uploadToken)
    ];
}, $4c1cc03801c301db$export$9ca1be8807fe0675);




var $cQmXV = parcelRequire("cQmXV");



var $cQmXV = parcelRequire("cQmXV");
var $8b36c9b0c72ca7e8$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($8b36c9b0c72ca7e8$exports, "__esModule", {
    value: true
});
var $8b36c9b0c72ca7e8$var$PaperClipOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M779.3 196.6c-94.2-94.2-247.6-94.2-341.7 0l-261 260.8c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l261-260.8c32.4-32.4 75.5-50.2 121.3-50.2s88.9 17.8 121.2 50.2c32.4 32.4 50.2 75.5 50.2 121.2 0 45.8-17.8 88.8-50.2 121.2l-266 265.9-43.1 43.1c-40.3 40.3-105.8 40.3-146.1 0-19.5-19.5-30.2-45.4-30.2-73s10.7-53.5 30.2-73l263.9-263.8c6.7-6.6 15.5-10.3 24.9-10.3h.1c9.4 0 18.1 3.7 24.7 10.3 6.7 6.7 10.3 15.5 10.3 24.9 0 9.3-3.7 18.1-10.3 24.7L372.4 653c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l215.6-215.6c19.9-19.9 30.8-46.3 30.8-74.4s-11-54.6-30.8-74.4c-41.1-41.1-107.9-41-149 0L463 364 224.8 602.1A172.22 172.22 0 00174 724.8c0 46.3 18.1 89.8 50.8 122.5 33.9 33.8 78.3 50.7 122.7 50.7 44.4 0 88.8-16.9 122.6-50.7l309.2-309C824.8 492.7 850 432 850 367.5c.1-64.6-25.1-125.3-70.7-170.9z"
                }
            }
        ]
    },
    "name": "paper-clip",
    "theme": "outlined"
};
$8b36c9b0c72ca7e8$exports.default = $8b36c9b0c72ca7e8$var$PaperClipOutlined;



function $c6dcba9ec81c8bd9$var$_extends() {
    $c6dcba9ec81c8bd9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c6dcba9ec81c8bd9$var$_extends.apply(this, arguments);
}
const $c6dcba9ec81c8bd9$var$PaperClipOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $c6dcba9ec81c8bd9$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8b36c9b0c72ca7e8$exports)))
    }));
/**![paper-clip](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTc3OS4zIDE5Ni42Yy05NC4yLTk0LjItMjQ3LjYtOTQuMi0zNDEuNyAwbC0yNjEgMjYwLjhjLTEuNyAxLjctMi42IDQtMi42IDYuNHMuOSA0LjcgMi42IDYuNGwzNi45IDM2LjlhOSA5IDAgMDAxMi43IDBsMjYxLTI2MC44YzMyLjQtMzIuNCA3NS41LTUwLjIgMTIxLjMtNTAuMnM4OC45IDE3LjggMTIxLjIgNTAuMmMzMi40IDMyLjQgNTAuMiA3NS41IDUwLjIgMTIxLjIgMCA0NS44LTE3LjggODguOC01MC4yIDEyMS4ybC0yNjYgMjY1LjktNDMuMSA0My4xYy00MC4zIDQwLjMtMTA1LjggNDAuMy0xNDYuMSAwLTE5LjUtMTkuNS0zMC4yLTQ1LjQtMzAuMi03M3MxMC43LTUzLjUgMzAuMi03M2wyNjMuOS0yNjMuOGM2LjctNi42IDE1LjUtMTAuMyAyNC45LTEwLjNoLjFjOS40IDAgMTguMSAzLjcgMjQuNyAxMC4zIDYuNyA2LjcgMTAuMyAxNS41IDEwLjMgMjQuOSAwIDkuMy0zLjcgMTguMS0xMC4zIDI0LjdMMzcyLjQgNjUzYy0xLjcgMS43LTIuNiA0LTIuNiA2LjRzLjkgNC43IDIuNiA2LjRsMzYuOSAzNi45YTkgOSAwIDAwMTIuNyAwbDIxNS42LTIxNS42YzE5LjktMTkuOSAzMC44LTQ2LjMgMzAuOC03NC40cy0xMS01NC42LTMwLjgtNzQuNGMtNDEuMS00MS4xLTEwNy45LTQxLTE0OSAwTDQ2MyAzNjQgMjI0LjggNjAyLjFBMTcyLjIyIDE3Mi4yMiAwIDAwMTc0IDcyNC44YzAgNDYuMyAxOC4xIDg5LjggNTAuOCAxMjIuNSAzMy45IDMzLjggNzguMyA1MC43IDEyMi43IDUwLjcgNDQuNCAwIDg4LjgtMTYuOSAxMjIuNi01MC43bDMwOS4yLTMwOUM4MjQuOCA0OTIuNyA4NTAgNDMyIDg1MCAzNjcuNWMuMS02NC42LTI1LjEtMTI1LjMtNzAuNy0xNzAuOXoiIC8+PC9zdmc+) */ const $c6dcba9ec81c8bd9$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($c6dcba9ec81c8bd9$var$PaperClipOutlined);
var $c6dcba9ec81c8bd9$export$2e2bcd8739ae039 = $c6dcba9ec81c8bd9$var$RefIcon;



var $cQmXV = parcelRequire("cQmXV");
var $f0f2c91d2d46d4df$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($f0f2c91d2d46d4df$exports, "__esModule", {
    value: true
});
var $f0f2c91d2d46d4df$var$PictureOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136v-39.9l138.5-164.3 150.1 178L658.1 489 888 761.6V792zm0-129.8L664.2 396.8c-3.2-3.8-9-3.8-12.2 0L424.6 666.4l-144-170.7c-3.2-3.8-9-3.8-12.2 0L136 652.7V232h752v430.2zM304 456a88 88 0 100-176 88 88 0 000 176zm0-116c15.5 0 28 12.5 28 28s-12.5 28-28 28-28-12.5-28-28 12.5-28 28-28z"
                }
            }
        ]
    },
    "name": "picture",
    "theme": "outlined"
};
$f0f2c91d2d46d4df$exports.default = $f0f2c91d2d46d4df$var$PictureOutlined;



function $9f1db3a3fd7715e2$var$_extends() {
    $9f1db3a3fd7715e2$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9f1db3a3fd7715e2$var$_extends.apply(this, arguments);
}
const $9f1db3a3fd7715e2$var$PictureOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $9f1db3a3fd7715e2$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($f0f2c91d2d46d4df$exports)))
    }));
/**![picture](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkyOCAxNjBIOTZjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjY0MGMwIDE3LjcgMTQuMyAzMiAzMiAzMmg4MzJjMTcuNyAwIDMyLTE0LjMgMzItMzJWMTkyYzAtMTcuNy0xNC4zLTMyLTMyLTMyem0tNDAgNjMySDEzNnYtMzkuOWwxMzguNS0xNjQuMyAxNTAuMSAxNzhMNjU4LjEgNDg5IDg4OCA3NjEuNlY3OTJ6bTAtMTI5LjhMNjY0LjIgMzk2LjhjLTMuMi0zLjgtOS0zLjgtMTIuMiAwTDQyNC42IDY2Ni40bC0xNDQtMTcwLjdjLTMuMi0zLjgtOS0zLjgtMTIuMiAwTDEzNiA2NTIuN1YyMzJoNzUydjQzMC4yek0zMDQgNDU2YTg4IDg4IDAgMTAwLTE3NiA4OCA4OCAwIDAwMCAxNzZ6bTAtMTE2YzE1LjUgMCAyOCAxMi41IDI4IDI4cy0xMi41IDI4LTI4IDI4LTI4LTEyLjUtMjgtMjggMTIuNS0yOCAyOC0yOHoiIC8+PC9zdmc+) */ const $9f1db3a3fd7715e2$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($9f1db3a3fd7715e2$var$PictureOutlined);
var $9f1db3a3fd7715e2$export$2e2bcd8739ae039 = $9f1db3a3fd7715e2$var$RefIcon;












function $5365409924cb9894$export$6dc848fd109e803d(file) {
    return {
        ...file,
        lastModified: file.lastModified,
        lastModifiedDate: file.lastModifiedDate,
        name: file.name,
        size: file.size,
        type: file.type,
        uid: file.uid,
        percent: 0,
        originFileObj: file
    };
}
function $5365409924cb9894$export$65c2063f64290f37(file, fileList) {
    const nextFileList = (0, $68381b18b974dc9f$export$2e2bcd8739ae039)(fileList);
    const fileIndex = nextFileList.findIndex(({ uid: uid })=>uid === file.uid);
    if (fileIndex === -1) nextFileList.push(file);
    else nextFileList[fileIndex] = file;
    return nextFileList;
}
function $5365409924cb9894$export$1165ac073f485fae(file, fileList) {
    const matchKey = file.uid !== undefined ? "uid" : "name";
    return fileList.filter((item)=>item[matchKey] === file[matchKey])[0];
}
function $5365409924cb9894$export$f3bced642db28a96(file, fileList) {
    const matchKey = file.uid !== undefined ? "uid" : "name";
    const removed = fileList.filter((item)=>item[matchKey] !== file[matchKey]);
    if (removed.length === fileList.length) return null;
    return removed;
}
// ==================== Default Image Preview ====================
const $5365409924cb9894$var$extname = (url = "")=>{
    const temp = url.split("/");
    const filename = temp[temp.length - 1];
    const filenameWithoutSuffix = filename.split(/#|\?/)[0];
    return (/\.[^./\\]*$/.exec(filenameWithoutSuffix) || [
        ""
    ])[0];
};
const $5365409924cb9894$var$isImageFileType = (type)=>type.indexOf("image/") === 0;
const $5365409924cb9894$var$imageExtensions = [
    ".avif",
    ".bmp",
    ".dpg",
    ".gif",
    ".heic",
    ".heif",
    ".ico",
    ".jfif",
    ".jpg",
    ".jpeg",
    ".png",
    ".svg",
    ".tif",
    ".tiff",
    ".webp"
];
const $5365409924cb9894$export$431d13c2db3f6781 = (file)=>{
    if (file.type && !file.thumbUrl) return $5365409924cb9894$var$isImageFileType(file.type);
    const url = file.thumbUrl || file.url || "";
    const extension = $5365409924cb9894$var$extname(url || file.name);
    if (/^data:image\//.test(url) || $5365409924cb9894$var$imageExtensions.includes(extension?.toLowerCase() || "")) return true;
    if (/^data:/.test(url)) // other file types of base64
    return false;
    if (extension) // other file types which have extension
    return false;
    return true;
};
const $5365409924cb9894$var$MEASURE_SIZE = 200;
function $5365409924cb9894$export$b5db251096956c0d(file) {
    return new Promise((resolve)=>{
        if (!file.type || !$5365409924cb9894$var$isImageFileType(file.type)) {
            resolve("");
            return;
        }
        const canvas = document.createElement("canvas");
        canvas.width = $5365409924cb9894$var$MEASURE_SIZE;
        canvas.height = $5365409924cb9894$var$MEASURE_SIZE;
        canvas.style.cssText = `position: fixed; left: 0; top: 0; width: ${$5365409924cb9894$var$MEASURE_SIZE}px; height: ${$5365409924cb9894$var$MEASURE_SIZE}px; z-index: 9999; display: none;`;
        document.body.appendChild(canvas);
        const ctx = canvas.getContext("2d");
        const img = new Image();
        img.onload = ()=>{
            const { width: width, height: height } = img;
            let drawWidth = $5365409924cb9894$var$MEASURE_SIZE;
            let drawHeight = $5365409924cb9894$var$MEASURE_SIZE;
            let offsetX = 0;
            let offsetY = 0;
            if (width > height) {
                drawHeight = height * ($5365409924cb9894$var$MEASURE_SIZE / width);
                offsetY = -(drawHeight - drawWidth) / 2;
            } else {
                drawWidth = width * ($5365409924cb9894$var$MEASURE_SIZE / height);
                offsetX = -(drawWidth - drawHeight) / 2;
            }
            ctx.drawImage(img, offsetX, offsetY, drawWidth, drawHeight);
            const dataURL = canvas.toDataURL();
            document.body.removeChild(canvas);
            window.URL.revokeObjectURL(img.src);
            resolve(dataURL);
        };
        img.crossOrigin = "anonymous";
        if (file.type.startsWith("image/svg+xml")) {
            const reader = new FileReader();
            reader.onload = ()=>{
                if (reader.result && typeof reader.result === "string") img.src = reader.result;
            };
            reader.readAsDataURL(file);
        } else if (file.type.startsWith("image/gif")) {
            const reader = new FileReader();
            reader.onload = ()=>{
                if (reader.result) resolve(reader.result);
            };
            reader.readAsDataURL(file);
        } else img.src = window.URL.createObjectURL(file);
    });
}



var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");
var $a8e132a0fb04ded9$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($a8e132a0fb04ded9$exports, "__esModule", {
    value: true
});
var $a8e132a0fb04ded9$var$DeleteOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z"
                }
            }
        ]
    },
    "name": "delete",
    "theme": "outlined"
};
$a8e132a0fb04ded9$exports.default = $a8e132a0fb04ded9$var$DeleteOutlined;



function $5234c28d879e38c1$var$_extends() {
    $5234c28d879e38c1$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5234c28d879e38c1$var$_extends.apply(this, arguments);
}
const $5234c28d879e38c1$var$DeleteOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $5234c28d879e38c1$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($a8e132a0fb04ded9$exports)))
    }));
/**![delete](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTM2MCAxODRoLThjNC40IDAgOC0zLjYgOC04djhoMzA0di04YzAgNC40IDMuNiA4IDggOGgtOHY3Mmg3MnYtODBjMC0zNS4zLTI4LjctNjQtNjQtNjRIMzUyYy0zNS4zIDAtNjQgMjguNy02NCA2NHY4MGg3MnYtNzJ6bTUwNCA3MkgxNjBjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjMyYzAgNC40IDMuNiA4IDggOGg2MC40bDI0LjcgNTIzYzEuNiAzNC4xIDI5LjggNjEgNjMuOSA2MWg0NTRjMzQuMiAwIDYyLjMtMjYuOCA2My45LTYxbDI0LjctNTIzSDg4OGM0LjQgMCA4LTMuNiA4LTh2LTMyYzAtMTcuNy0xNC4zLTMyLTMyLTMyek03MzEuMyA4NDBIMjkyLjdsLTI0LjItNTEyaDQ4N2wtMjQuMiA1MTJ6IiAvPjwvc3ZnPg==) */ const $5234c28d879e38c1$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($5234c28d879e38c1$var$DeleteOutlined);
var $5234c28d879e38c1$export$2e2bcd8739ae039 = $5234c28d879e38c1$var$RefIcon;



var $cQmXV = parcelRequire("cQmXV");
var $9bf6a8ce813499fa$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($9bf6a8ce813499fa$exports, "__esModule", {
    value: true
});
var $9bf6a8ce813499fa$var$DownloadOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M505.7 661a8 8 0 0012.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9h-74.1V168c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "download",
    "theme": "outlined"
};
$9bf6a8ce813499fa$exports.default = $9bf6a8ce813499fa$var$DownloadOutlined;



function $a8f7d355c4714d40$var$_extends() {
    $a8f7d355c4714d40$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a8f7d355c4714d40$var$_extends.apply(this, arguments);
}
const $a8f7d355c4714d40$var$DownloadOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $a8f7d355c4714d40$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9bf6a8ce813499fa$exports)))
    }));
/**![download](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUwNS43IDY2MWE4IDggMCAwMDEyLjYgMGwxMTItMTQxLjdjNC4xLTUuMi40LTEyLjktNi4zLTEyLjloLTc0LjFWMTY4YzAtNC40LTMuNi04LTgtOGgtNjBjLTQuNCAwLTggMy42LTggOHYzMzguM0g0MDBjLTYuNyAwLTEwLjQgNy43LTYuMyAxMi45bDExMiAxNDEuOHpNODc4IDYyNmgtNjBjLTQuNCAwLTggMy42LTggOHYxNTRIMjE0VjYzNGMwLTQuNC0zLjYtOC04LThoLTYwYy00LjQgMC04IDMuNi04IDh2MTk4YzAgMTcuNyAxNC4zIDMyIDMyIDMyaDY4NGMxNy43IDAgMzItMTQuMyAzMi0zMlY2MzRjMC00LjQtMy42LTgtOC04eiIgLz48L3N2Zz4=) */ const $a8f7d355c4714d40$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($a8f7d355c4714d40$var$DownloadOutlined);
var $a8f7d355c4714d40$export$2e2bcd8739ae039 = $a8f7d355c4714d40$var$RefIcon;









var $cQmXV = parcelRequire("cQmXV");












var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");


var $cQmXV = parcelRequire("cQmXV");
const $e03e328471b976a0$export$9c21a3269931e1e6 = {
    percent: 0,
    prefixCls: "rc-progress",
    strokeColor: "#2db7f5",
    strokeLinecap: "round",
    strokeWidth: 1,
    railColor: "#D9D9D9",
    railWidth: 1,
    gapPosition: "bottom",
    loading: false
};
const $e03e328471b976a0$export$7685006d504ecf0b = ()=>{
    const pathsRef = (0, $cQmXV.useRef)([]);
    const prevTimeStamp = (0, $cQmXV.useRef)(null);
    (0, $cQmXV.useEffect)(()=>{
        const now = Date.now();
        let updated = false;
        pathsRef.current.forEach((path)=>{
            if (!path) return;
            updated = true;
            const pathStyle = path.style;
            pathStyle.transitionDuration = ".3s, .3s, .3s, .06s";
            if (prevTimeStamp.current && now - prevTimeStamp.current < 100) pathStyle.transitionDuration = "0s, 0s";
        });
        if (updated) prevTimeStamp.current = Date.now();
    });
    return pathsRef.current;
};



var $cQmXV = parcelRequire("cQmXV");
var $4ce3dd07c2f90da8$export$2e2bcd8739ae039 = (options)=>{
    const { id: id, percent: percent, strokeLinecap: strokeLinecap, strokeWidth: strokeWidth, loading: loading } = options;
    if (!loading) return {
        indeterminateStyleProps: {},
        indeterminateStyleAnimation: null
    };
    const animationName = `${id}-indeterminate-animate`;
    const strokeDashOffset = 100 - (percent + (strokeLinecap === "round" ? strokeWidth : 0));
    return {
        indeterminateStyleProps: {
            strokeDasharray: `${percent} 100`,
            animation: `${animationName} .6s linear alternate infinite`,
            strokeDashoffset: 0
        },
        indeterminateStyleAnimation: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("style", null, `@keyframes ${animationName} {
            0% { stroke-dashoffset: 0; }
            100% { stroke-dashoffset: -${strokeDashOffset};
          }`)
    };
};



function $d9f16409469375f3$var$_extends() {
    $d9f16409469375f3$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d9f16409469375f3$var$_extends.apply(this, arguments);
}
const $d9f16409469375f3$var$Line = (props)=>{
    const { id: id, className: className, percent: percent, prefixCls: prefixCls, strokeColor: strokeColor, strokeLinecap: strokeLinecap, strokeWidth: strokeWidth, style: style, railColor: railColor, railWidth: railWidth, transition: transition, loading: loading, ...restProps } = {
        ...(0, $e03e328471b976a0$export$9c21a3269931e1e6),
        ...props
    };
    const mergedId = (0, $a2da91bb60e2cbfb$export$2e2bcd8739ae039)(id);
    // eslint-disable-next-line no-param-reassign
    delete restProps.gapPosition;
    const percentList = Array.isArray(percent) ? percent : [
        percent
    ];
    const strokeColorList = Array.isArray(strokeColor) ? strokeColor : [
        strokeColor
    ];
    const paths = (0, $e03e328471b976a0$export$7685006d504ecf0b)();
    const center = strokeWidth / 2;
    const right = 100 - strokeWidth / 2;
    const pathString = `M ${strokeLinecap === "round" ? center : 0},${center}
         L ${strokeLinecap === "round" ? right : 100},${center}`;
    const viewBoxString = `0 0 100 ${strokeWidth}`;
    let stackPtg = 0;
    const { indeterminateStyleProps: indeterminateStyleProps, indeterminateStyleAnimation: indeterminateStyleAnimation } = (0, $4ce3dd07c2f90da8$export$2e2bcd8739ae039)({
        id: mergedId,
        loading: loading,
        percent: percentList[0],
        strokeLinecap: strokeLinecap,
        strokeWidth: strokeWidth
    });
    return /*#__PURE__*/ $cQmXV.createElement("svg", $d9f16409469375f3$var$_extends({
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-line`, className),
        viewBox: viewBoxString,
        preserveAspectRatio: "none",
        style: style
    }, restProps), /*#__PURE__*/ $cQmXV.createElement("path", {
        className: `${prefixCls}-line-rail`,
        d: pathString,
        strokeLinecap: strokeLinecap,
        stroke: railColor,
        strokeWidth: railWidth || strokeWidth,
        fillOpacity: "0"
    }), percentList.map((ptg, index)=>{
        let dashPercent = 1;
        switch(strokeLinecap){
            case "round":
                dashPercent = 1 - strokeWidth / 100;
                break;
            case "square":
                dashPercent = 1 - strokeWidth / 2 / 100;
                break;
            default:
                dashPercent = 1;
                break;
        }
        const pathStyle = {
            strokeDasharray: `${ptg * dashPercent}px, 100px`,
            strokeDashoffset: `-${stackPtg}px`,
            transition: transition || "stroke-dashoffset 0.3s ease 0s, stroke-dasharray .3s ease 0s, stroke 0.3s linear",
            ...indeterminateStyleProps
        };
        const color = strokeColorList[index] || strokeColorList[strokeColorList.length - 1];
        stackPtg += ptg;
        return /*#__PURE__*/ $cQmXV.createElement("path", {
            key: index,
            className: `${prefixCls}-line-path`,
            d: pathString,
            strokeLinecap: strokeLinecap,
            stroke: color,
            strokeWidth: strokeWidth,
            fillOpacity: "0",
            ref: (elem)=>{
                // https://reactjs.org/docs/refs-and-the-dom.html#callback-refs
                // React will call the ref callback with the DOM element when the component mounts,
                // and call it with `null` when it unmounts.
                // Refs are guaranteed to be up-to-date before componentDidMount or componentDidUpdate fires.
                paths[index] = elem;
            },
            style: pathStyle
        });
    }), indeterminateStyleAnimation);
};
var $d9f16409469375f3$export$2e2bcd8739ae039 = $d9f16409469375f3$var$Line;



var $cQmXV = parcelRequire("cQmXV");




var $cQmXV = parcelRequire("cQmXV");

const $d92cdce5dbf4ccf2$var$Block = ({ bg: bg, children: children })=>/*#__PURE__*/ $cQmXV.createElement("div", {
        style: {
            width: "100%",
            height: "100%",
            background: bg
        }
    }, children);
function $d92cdce5dbf4ccf2$var$getPtgColors(color, scale) {
    return Object.keys(color).map((key)=>{
        const parsedKey = parseFloat(key);
        const ptgKey = `${Math.floor(parsedKey * scale)}%`;
        return `${color[key]} ${ptgKey}`;
    });
}
const $d92cdce5dbf4ccf2$var$PtgCircle = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { prefixCls: prefixCls, color: color, gradientId: gradientId, radius: radius, className: className, style: circleStyleForStack, ptg: ptg, strokeLinecap: strokeLinecap, strokeWidth: strokeWidth, size: size, gapDegree: gapDegree } = props;
    const isGradient = color && typeof color === "object";
    const stroke = isGradient ? `#FFF` : undefined;
    // ========================== Circle ==========================
    const halfSize = size / 2;
    const circleNode = /*#__PURE__*/ $cQmXV.createElement("circle", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-circle-path`, className),
        r: radius,
        cx: halfSize,
        cy: halfSize,
        stroke: stroke,
        strokeLinecap: strokeLinecap,
        strokeWidth: strokeWidth,
        opacity: ptg === 0 ? 0 : 1,
        style: circleStyleForStack,
        ref: ref
    });
    // ========================== Render ==========================
    if (!isGradient) return circleNode;
    const maskId = `${gradientId}-conic`;
    const fromDeg = gapDegree ? `${180 + gapDegree / 2}deg` : "0deg";
    const conicColors = $d92cdce5dbf4ccf2$var$getPtgColors(color, (360 - gapDegree) / 360);
    const linearColors = $d92cdce5dbf4ccf2$var$getPtgColors(color, 1);
    const conicColorBg = `conic-gradient(from ${fromDeg}, ${conicColors.join(", ")})`;
    const linearColorBg = `linear-gradient(to ${gapDegree ? "bottom" : "top"}, ${linearColors.join(", ")})`;
    return /*#__PURE__*/ $cQmXV.createElement($cQmXV.Fragment, null, /*#__PURE__*/ $cQmXV.createElement("mask", {
        id: maskId
    }, circleNode), /*#__PURE__*/ $cQmXV.createElement("foreignObject", {
        x: 0,
        y: 0,
        width: size,
        height: size,
        mask: `url(#${maskId})`
    }, /*#__PURE__*/ $cQmXV.createElement($d92cdce5dbf4ccf2$var$Block, {
        bg: linearColorBg
    }, /*#__PURE__*/ $cQmXV.createElement($d92cdce5dbf4ccf2$var$Block, {
        bg: conicColorBg
    }))));
});
var $d92cdce5dbf4ccf2$export$2e2bcd8739ae039 = $d92cdce5dbf4ccf2$var$PtgCircle;


const $2c8db893cb4d715b$export$b8239b3abadfb141 = 100;
const $2c8db893cb4d715b$export$b0aaf64d8cc0f6db = (perimeter, perimeterWithoutGap, offset, percent, rotateDeg, gapDegree, gapPosition, strokeColor, strokeLinecap, strokeWidth, stepSpace = 0)=>{
    const offsetDeg = offset / 100 * 360 * ((360 - gapDegree) / 360);
    const positionDeg = gapDegree === 0 ? 0 : ({
        bottom: 0,
        top: 180,
        left: 90,
        right: -90
    })[gapPosition];
    let strokeDashoffset = (100 - percent) / 100 * perimeterWithoutGap;
    // Fix percent accuracy when strokeLinecap is round
    // https://github.com/ant-design/ant-design/issues/35009
    if (strokeLinecap === "round" && percent !== 100) {
        strokeDashoffset += strokeWidth / 2;
        // when percent is small enough (<= 1%), keep smallest value to avoid it's disappearance
        if (strokeDashoffset >= perimeterWithoutGap) strokeDashoffset = perimeterWithoutGap - 0.01;
    }
    const halfSize = $2c8db893cb4d715b$export$b8239b3abadfb141 / 2;
    return {
        stroke: typeof strokeColor === "string" ? strokeColor : undefined,
        strokeDasharray: `${perimeterWithoutGap}px ${perimeter}`,
        strokeDashoffset: strokeDashoffset + stepSpace,
        transform: `rotate(${rotateDeg + offsetDeg + positionDeg}deg)`,
        transformOrigin: `${halfSize}px ${halfSize}px`,
        transition: "stroke-dashoffset .3s ease 0s, stroke-dasharray .3s ease 0s, stroke .3s, stroke-width .06s ease .3s, opacity .3s ease 0s",
        fillOpacity: 0
    };
};



var $cQmXV = parcelRequire("cQmXV");
var $fa0ff4a1264eca2c$export$2e2bcd8739ae039 = ({ id: id, loading: loading })=>{
    if (!loading) return {
        indeterminateStyleProps: {},
        indeterminateStyleAnimation: null
    };
    const animationName = `${id}-indeterminate-animate`;
    return {
        indeterminateStyleProps: {
            transform: "rotate(0deg)",
            animation: `${animationName} 1s linear infinite`
        },
        indeterminateStyleAnimation: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("style", null, `@keyframes ${animationName} {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }`)
    };
};


function $f4b6f352164273a8$var$_extends() {
    $f4b6f352164273a8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f4b6f352164273a8$var$_extends.apply(this, arguments);
}
function $f4b6f352164273a8$var$toArray(value) {
    const mergedValue = value ?? [];
    return Array.isArray(mergedValue) ? mergedValue : [
        mergedValue
    ];
}
const $f4b6f352164273a8$var$Circle = (props)=>{
    const { id: id, prefixCls: prefixCls, classNames: classNames = {}, styles: styles = {}, steps: steps, strokeWidth: strokeWidth, railWidth: railWidth, gapDegree: gapDegree = 0, gapPosition: gapPosition, railColor: railColor, strokeLinecap: strokeLinecap, style: style, className: className, strokeColor: strokeColor, percent: percent, loading: loading, ...restProps } = {
        ...(0, $e03e328471b976a0$export$9c21a3269931e1e6),
        ...props
    };
    const halfSize = (0, $2c8db893cb4d715b$export$b8239b3abadfb141) / 2;
    const mergedId = (0, $a2da91bb60e2cbfb$export$2e2bcd8739ae039)(id);
    const gradientId = `${mergedId}-gradient`;
    const radius = halfSize - strokeWidth / 2;
    const perimeter = Math.PI * 2 * radius;
    const rotateDeg = gapDegree > 0 ? 90 + gapDegree / 2 : -90;
    const perimeterWithoutGap = perimeter * ((360 - gapDegree) / 360);
    const { count: stepCount, gap: stepGap } = typeof steps === "object" ? steps : {
        count: steps,
        gap: 2
    };
    const percentList = $f4b6f352164273a8$var$toArray(percent);
    const strokeColorList = $f4b6f352164273a8$var$toArray(strokeColor);
    const gradient = strokeColorList.find((color)=>color && typeof color === "object");
    const isConicGradient = gradient && typeof gradient === "object";
    const mergedStrokeLinecap = isConicGradient ? "butt" : strokeLinecap;
    const { indeterminateStyleProps: indeterminateStyleProps, indeterminateStyleAnimation: indeterminateStyleAnimation } = (0, $fa0ff4a1264eca2c$export$2e2bcd8739ae039)({
        id: mergedId,
        loading: loading
    });
    const circleStyle = (0, $2c8db893cb4d715b$export$b0aaf64d8cc0f6db)(perimeter, perimeterWithoutGap, 0, 100, rotateDeg, gapDegree, gapPosition, railColor, mergedStrokeLinecap, strokeWidth);
    const paths = (0, $e03e328471b976a0$export$7685006d504ecf0b)();
    const getStokeList = ()=>{
        let stackPtg = 0;
        return percentList.map((ptg, index)=>{
            const color = strokeColorList[index] || strokeColorList[strokeColorList.length - 1];
            const circleStyleForStack = (0, $2c8db893cb4d715b$export$b0aaf64d8cc0f6db)(perimeter, perimeterWithoutGap, stackPtg, ptg, rotateDeg, gapDegree, gapPosition, color, mergedStrokeLinecap, strokeWidth);
            stackPtg += ptg;
            return /*#__PURE__*/ $cQmXV.createElement((0, $d92cdce5dbf4ccf2$export$2e2bcd8739ae039), {
                key: index,
                color: color,
                ptg: ptg,
                radius: radius,
                prefixCls: prefixCls,
                gradientId: gradientId,
                className: classNames.track,
                style: {
                    ...circleStyleForStack,
                    ...indeterminateStyleProps,
                    ...styles.track
                },
                strokeLinecap: mergedStrokeLinecap,
                strokeWidth: strokeWidth,
                gapDegree: gapDegree,
                ref: (elem)=>{
                    // https://reactjs.org/docs/refs-and-the-dom.html#callback-refs
                    // React will call the ref callback with the DOM element when the component mounts,
                    // and call it with `null` when it unmounts.
                    // Refs are guaranteed to be up-to-date before componentDidMount or componentDidUpdate fires.
                    paths[index] = elem;
                },
                size: (0, $2c8db893cb4d715b$export$b8239b3abadfb141)
            });
        }).reverse();
    };
    const getStepStokeList = ()=>{
        // only show the first percent when pass steps
        const current = Math.round(stepCount * (percentList[0] / 100));
        const stepPtg = 100 / stepCount;
        let stackPtg = 0;
        return new Array(stepCount).fill(null).map((_, index)=>{
            const color = index <= current - 1 ? strokeColorList[0] : railColor;
            const stroke = color && typeof color === "object" ? `url(#${gradientId})` : undefined;
            const circleStyleForStack = (0, $2c8db893cb4d715b$export$b0aaf64d8cc0f6db)(perimeter, perimeterWithoutGap, stackPtg, stepPtg, rotateDeg, gapDegree, gapPosition, color, "butt", strokeWidth, stepGap);
            stackPtg += (perimeterWithoutGap - circleStyleForStack.strokeDashoffset + stepGap) * 100 / perimeterWithoutGap;
            return /*#__PURE__*/ $cQmXV.createElement("circle", {
                key: index,
                className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-circle-path`, classNames.track),
                r: radius,
                cx: halfSize,
                cy: halfSize,
                stroke: stroke,
                strokeWidth: strokeWidth,
                opacity: 1,
                style: {
                    ...circleStyleForStack,
                    ...styles.track
                },
                ref: (elem)=>{
                    paths[index] = elem;
                }
            });
        });
    };
    return /*#__PURE__*/ $cQmXV.createElement("svg", $f4b6f352164273a8$var$_extends({
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-circle`, classNames.root, className),
        viewBox: `0 0 ${(0, $2c8db893cb4d715b$export$b8239b3abadfb141)} ${(0, $2c8db893cb4d715b$export$b8239b3abadfb141)}`,
        style: {
            ...styles.root,
            ...style
        },
        id: id,
        role: "presentation"
    }, restProps), !stepCount && /*#__PURE__*/ $cQmXV.createElement("circle", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-circle-rail`, classNames.rail),
        r: radius,
        cx: halfSize,
        cy: halfSize,
        stroke: railColor,
        strokeLinecap: mergedStrokeLinecap,
        strokeWidth: railWidth || strokeWidth,
        style: {
            ...circleStyle,
            ...styles.rail
        }
    }), stepCount ? getStepStokeList() : getStokeList(), indeterminateStyleAnimation);
};
var $f4b6f352164273a8$export$2e2bcd8739ae039 = $f4b6f352164273a8$var$Circle;











function $21f724def245d757$export$2caef35201f951a0(progress) {
    if (!progress || progress < 0) return 0;
    if (progress > 100) return 100;
    return progress;
}
function $21f724def245d757$export$4ab1c09ce4ee99b({ success: success }) {
    let percent;
    if (success && "percent" in success) percent = success.percent;
    return percent;
}
const $21f724def245d757$export$6712e0f6cd0ea03 = ({ percent: percent, success: success })=>{
    const realSuccessPercent = $21f724def245d757$export$2caef35201f951a0($21f724def245d757$export$4ab1c09ce4ee99b({
        success: success
    }));
    return [
        realSuccessPercent,
        $21f724def245d757$export$2caef35201f951a0($21f724def245d757$export$2caef35201f951a0(percent) - realSuccessPercent)
    ];
};
const $21f724def245d757$export$a73db48ef11a2bc3 = ({ success: success = {}, strokeColor: strokeColor })=>{
    const { strokeColor: successColor } = success;
    return [
        successColor || (0, $bac0cac4764de8cf$export$3968a3afc810b5f5).green,
        strokeColor || null
    ];
};
const $21f724def245d757$export$31b21d0167753bb4 = (size, type, extra)=>{
    let width = -1;
    let height = -1;
    if (type === "step") {
        const steps = extra.steps;
        const strokeWidth = extra.strokeWidth;
        if (typeof size === "string" || typeof size === "undefined") {
            width = size === "small" ? 2 : 14;
            height = strokeWidth ?? 8;
        } else if ((0, $8e2d153a3c855782$export$7e4aa119212bc614)(size)) [width, height] = [
            size,
            size
        ];
        else [width = 14, height = 8] = Array.isArray(size) ? size : [
            size.width,
            size.height
        ];
        width *= steps;
    } else if (type === "line") {
        const strokeWidth = extra?.strokeWidth;
        if (typeof size === "string" || typeof size === "undefined") height = strokeWidth || (size === "small" ? 6 : 8);
        else if ((0, $8e2d153a3c855782$export$7e4aa119212bc614)(size)) [width, height] = [
            size,
            size
        ];
        else [width = -1, height = 8] = Array.isArray(size) ? size : [
            size.width,
            size.height
        ];
    } else if (type === "circle" || type === "dashboard") {
        if (typeof size === "string" || typeof size === "undefined") [width, height] = size === "small" ? [
            60,
            60
        ] : [
            120,
            120
        ];
        else if ((0, $8e2d153a3c855782$export$7e4aa119212bc614)(size)) [width, height] = [
            size,
            size
        ];
        else if (Array.isArray(size)) {
            width = size[0] ?? size[1] ?? 120;
            height = size[0] ?? size[1] ?? 120;
        }
    }
    return [
        width,
        height
    ];
};


"use client";
const $0be6abc1ff0be0fc$var$CIRCLE_MIN_STROKE_WIDTH = 3;
const $0be6abc1ff0be0fc$var$getMinPercent = (width)=>$0be6abc1ff0be0fc$var$CIRCLE_MIN_STROKE_WIDTH / width * 100;
const $0be6abc1ff0be0fc$var$OMIT_SEMANTIC_NAMES = [
    "root",
    "body",
    "indicator"
];
const $0be6abc1ff0be0fc$var$Circle = (props)=>{
    const { prefixCls: prefixCls, classNames: classNames, styles: styles, railColor: railColor, trailColor: trailColor, strokeLinecap: strokeLinecap = "round", gapPosition: gapPosition, gapPlacement: gapPlacement, gapDegree: gapDegree, width: originWidth = 120, type: type, children: children, success: success, size: size = originWidth, steps: steps } = props;
    const { direction: direction } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("progress");
    const mergedRailColor = railColor ?? trailColor;
    const [width, height] = (0, $21f724def245d757$export$31b21d0167753bb4)(size, "circle");
    let { strokeWidth: strokeWidth } = props;
    if (strokeWidth === undefined) strokeWidth = Math.max($0be6abc1ff0be0fc$var$getMinPercent(width), 6);
    const circleStyle = {
        width: width,
        height: height,
        fontSize: width * 0.15 + 6
    };
    const realGapDegree = $cQmXV.useMemo(()=>{
        // Support gapDeg = 0 when type = 'dashboard'
        if (gapDegree || gapDegree === 0) return gapDegree;
        if (type === "dashboard") return 75;
        return undefined;
    }, [
        gapDegree,
        type
    ]);
    const percentArray = (0, $21f724def245d757$export$6712e0f6cd0ea03)(props);
    const gapPos = $cQmXV.useMemo(()=>{
        const mergedPlacement = (gapPlacement ?? gapPosition) || type === "dashboard" && "bottom" || undefined;
        const isRTL = direction === "rtl";
        switch(mergedPlacement){
            case "start":
                return isRTL ? "right" : "left";
            case "end":
                return isRTL ? "left" : "right";
            default:
                return mergedPlacement;
        }
    }, [
        direction,
        gapPlacement,
        gapPosition,
        type
    ]);
    // using className to style stroke color
    const isGradient = (0, $8e2d153a3c855782$export$53b83ca8eaab0383)(props.strokeColor);
    const strokeColor = (0, $21f724def245d757$export$a73db48ef11a2bc3)({
        success: success,
        strokeColor: props.strokeColor
    });
    const wrapperClassName = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-body`, {
        [`${prefixCls}-circle-gradient`]: isGradient
    }, classNames.body);
    const circleContent = /*#__PURE__*/ $cQmXV.createElement((0, $f4b6f352164273a8$export$2e2bcd8739ae039), {
        steps: steps,
        percent: steps ? percentArray[1] : percentArray,
        strokeWidth: strokeWidth,
        railWidth: strokeWidth,
        strokeColor: steps ? strokeColor[1] : strokeColor,
        strokeLinecap: strokeLinecap,
        railColor: mergedRailColor,
        prefixCls: prefixCls,
        gapDegree: realGapDegree,
        gapPosition: gapPos,
        classNames: (0, $e8c5093aebad6025$export$2e2bcd8739ae039)(classNames, $0be6abc1ff0be0fc$var$OMIT_SEMANTIC_NAMES),
        styles: (0, $e8c5093aebad6025$export$2e2bcd8739ae039)(styles, $0be6abc1ff0be0fc$var$OMIT_SEMANTIC_NAMES)
    });
    const smallCircle = width <= 20;
    const node = /*#__PURE__*/ $cQmXV.createElement("div", {
        className: wrapperClassName,
        style: {
            ...circleStyle,
            ...styles.body
        }
    }, circleContent, !smallCircle && children);
    if (smallCircle) return /*#__PURE__*/ $cQmXV.createElement((0, $1e5256cf9d329b2c$export$2e2bcd8739ae039), {
        title: children
    }, node);
    return node;
};
var $0be6abc1ff0be0fc$export$2e2bcd8739ae039 = $0be6abc1ff0be0fc$var$Circle;



var $cQmXV = parcelRequire("cQmXV");






const $f6e7c3be7c89a26d$export$ce7447cfda329128 = "--progress-line-stroke-color";
const $f6e7c3be7c89a26d$var$genAntProgressActive = (isRtl)=>{
    const direction = isRtl ? "100%" : "-100%";
    return new (0, $e928d3664c9ed565$export$2e2bcd8739ae039)(`antProgress${isRtl ? "RTL" : "LTR"}Active`, {
        "0%": {
            transform: `translateX(${direction}) scaleX(0)`,
            opacity: 0.1
        },
        "20%": {
            transform: `translateX(${direction}) scaleX(0)`,
            opacity: 0.5
        },
        to: {
            transform: "translateX(0) scaleX(1)",
            opacity: 0
        }
    });
};
// ====================================================================
// ==                              Base                              ==
// ====================================================================
const $f6e7c3be7c89a26d$var$genBaseStyle = (token)=>{
    const { componentCls: progressCls, iconCls: iconPrefixCls } = token;
    return {
        [progressCls]: {
            ...(0, $519d20bf207ce864$export$23997c3e44cc1c59)(token),
            display: "inline-flex",
            "&-rtl": {
                direction: "rtl"
            },
            [`${progressCls}-indicator`]: {
                color: token.colorText,
                lineHeight: 1,
                whiteSpace: "nowrap",
                verticalAlign: "middle",
                wordBreak: "normal",
                [iconPrefixCls]: {
                    fontSize: token.fontSize
                }
            },
            [`&${progressCls}-status-exception`]: {
                [`${progressCls}-indicator`]: {
                    color: token.colorError
                }
            },
            [`&${progressCls}-status-success`]: {
                [`${progressCls}-indicator`]: {
                    color: token.colorSuccess
                }
            }
        }
    };
};
// ====================================================================
// ==                              Line                              ==
// ====================================================================
const $f6e7c3be7c89a26d$var$genLineStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-line`]: {
            position: "relative",
            width: "100%",
            fontSize: token.fontSize,
            [`${componentCls}-body`]: {
                display: "inline-flex",
                alignItems: "center",
                width: "100%",
                gap: token.marginXS
            },
            [`${componentCls}-rail`]: {
                flex: "auto",
                background: token.remainingColor,
                borderRadius: token.lineBorderRadius,
                position: "relative",
                width: "100%",
                overflow: "hidden"
            },
            [`&${componentCls}-status-active`]: {
                [`${componentCls}-track:after`]: {
                    content: '""',
                    position: "absolute",
                    inset: 0,
                    backgroundColor: token.colorBgContainer,
                    borderRadius: "inherit",
                    opacity: 0,
                    animationName: $f6e7c3be7c89a26d$var$genAntProgressActive(),
                    animationDuration: token.progressActiveMotionDuration,
                    animationTimingFunction: token.motionEaseOutQuint,
                    animationIterationCount: "infinite"
                }
            },
            [`${componentCls}-track`]: {
                position: "absolute",
                insetInlineStart: 0,
                insetBlock: 0,
                borderRadius: "inherit",
                background: token.defaultColor,
                transition: `all ${token.motionDurationSlow} ${token.motionEaseInOutCirc}`,
                minWidth: "max-content",
                display: "flex",
                alignItems: "center",
                "&-success": {
                    background: token.colorSuccess
                }
            },
            [`&${componentCls}-status-exception`]: {
                [`${componentCls}-track`]: {
                    background: token.colorError
                }
            },
            [`&${componentCls}-status-success`]: {
                [`${componentCls}-track`]: {
                    background: token.colorSuccess
                }
            },
            // >>>>> indicator
            // >>> Outer
            [`${componentCls}-indicator-outer`]: {
                [`&${componentCls}-indicator-start`]: {
                    order: -1
                }
            },
            [`${componentCls}-body-layout-bottom`]: {
                flexDirection: "column",
                alignItems: "center",
                gap: token.marginXXS
            },
            // >>> Inner
            [`${componentCls}-indicator${componentCls}-indicator-inner`]: {
                color: token.colorWhite,
                paddingInline: token.paddingXXS,
                width: "100%",
                display: "flex",
                justifyContent: "center",
                [`&${componentCls}-indicator-end`]: {
                    justifyContent: "end"
                },
                [`&${componentCls}-indicator-start`]: {
                    justifyContent: "start"
                },
                [`&${componentCls}-indicator-bright`]: {
                    color: "rgba(0, 0, 0, 0.45)"
                }
            }
        }
    };
};
// ====================================================================
// ==                             Circle                             ==
// ====================================================================
const $f6e7c3be7c89a26d$var$genCircleStyle = (token)=>{
    const { componentCls: progressCls, iconCls: iconPrefixCls } = token;
    return {
        [`${progressCls}-circle`]: {
            [`${progressCls}-circle-rail`]: {
                stroke: token.remainingColor
            },
            [`${progressCls}-body:not(${progressCls}-circle-gradient)`]: {
                [`${progressCls}-circle-path`]: {
                    stroke: token.defaultColor
                }
            },
            [`${progressCls}-body`]: {
                position: "relative",
                lineHeight: 1,
                backgroundColor: "transparent"
            },
            [`${progressCls}-indicator`]: {
                position: "absolute",
                insetBlockStart: "50%",
                insetInlineStart: 0,
                width: "100%",
                margin: 0,
                padding: 0,
                color: token.circleTextColor,
                fontSize: token.circleTextFontSize,
                lineHeight: 1,
                whiteSpace: "normal",
                textAlign: "center",
                transform: "translateY(-50%)",
                [iconPrefixCls]: {
                    fontSize: token.circleIconFontSize
                }
            },
            [`&${progressCls}-status-exception`]: {
                [`${progressCls}-body:not(${progressCls}-circle-gradient)`]: {
                    [`${progressCls}-circle-path`]: {
                        stroke: token.colorError
                    }
                }
            },
            [`&${progressCls}-status-success`]: {
                [`${progressCls}-body:not(${progressCls}-circle-gradient)`]: {
                    [`${progressCls}-circle-path`]: {
                        stroke: token.colorSuccess
                    }
                }
            }
        },
        [`${progressCls}-inline-circle`]: {
            lineHeight: 1,
            [`${progressCls}-inner`]: {
                verticalAlign: "bottom"
            }
        }
    };
};
// ====================================================================
// ==                              Step                              ==
// ====================================================================
const $f6e7c3be7c89a26d$var$genStepStyle = (token)=>{
    const { componentCls: progressCls } = token;
    return {
        [progressCls]: {
            [`${progressCls}-steps`]: {
                display: "inline-block",
                "&-body": {
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: token.progressStepMarginInlineEnd,
                    [`${progressCls}-indicator`]: {
                        marginInlineStart: token.marginXS
                    }
                },
                "&-item": {
                    flexShrink: 0,
                    minWidth: token.progressStepMinWidth,
                    backgroundColor: token.remainingColor,
                    transition: `all ${token.motionDurationSlow}`,
                    "&-active": {
                        backgroundColor: token.defaultColor
                    }
                }
            }
        }
    };
};
// ====================================================================
// ==                           Small Line                           ==
// ====================================================================
const $f6e7c3be7c89a26d$var$genSmallLine = (token)=>{
    const { componentCls: progressCls, iconCls: iconPrefixCls } = token;
    return {
        [progressCls]: {
            [`${progressCls}-small&-line, ${progressCls}-small&-line ${progressCls}-indicator ${iconPrefixCls}`]: {
                fontSize: token.fontSizeSM
            }
        }
    };
};
const $f6e7c3be7c89a26d$export$9ca1be8807fe0675 = (token)=>({
        circleTextColor: token.colorText,
        defaultColor: token.colorInfo,
        remainingColor: token.colorFillSecondary,
        lineBorderRadius: 100,
        // magic for capsule shape, should be a very large number
        circleTextFontSize: "1em",
        circleIconFontSize: `${token.fontSize / token.fontSizeSM}em`
    });
var $f6e7c3be7c89a26d$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$51ec95de45185b42)("Progress", (token)=>{
    const progressStepMarginInlineEnd = token.calc(token.marginXXS).div(2).equal();
    const progressToken = (0, $fef50f256b80dfa5$export$4950aa0f605343fb)(token, {
        progressStepMarginInlineEnd: progressStepMarginInlineEnd,
        progressStepMinWidth: progressStepMarginInlineEnd,
        progressActiveMotionDuration: "2.4s"
    });
    return [
        $f6e7c3be7c89a26d$var$genBaseStyle(progressToken),
        $f6e7c3be7c89a26d$var$genLineStyle(progressToken),
        $f6e7c3be7c89a26d$var$genCircleStyle(progressToken),
        $f6e7c3be7c89a26d$var$genStepStyle(progressToken),
        $f6e7c3be7c89a26d$var$genSmallLine(progressToken)
    ];
}, $f6e7c3be7c89a26d$export$9ca1be8807fe0675);



"use client";
const $3a21b0fb1ecd4063$export$8947b167cf78cbe = (gradients)=>{
    let tempArr = [];
    Object.keys(gradients).forEach((key)=>{
        const formattedKey = Number.parseFloat(key.replace(/%/g, ""));
        if (!Number.isNaN(formattedKey)) tempArr.push({
            key: formattedKey,
            value: gradients[key]
        });
    });
    tempArr = tempArr.sort((a, b)=>a.key - b.key);
    return tempArr.map(({ key: key, value: value })=>`${value} ${key}%`).join(", ");
};
const $3a21b0fb1ecd4063$export$22b6122229807a9f = (strokeColor, directionConfig)=>{
    const { from: from = (0, $bac0cac4764de8cf$export$3968a3afc810b5f5).blue, to: to = (0, $bac0cac4764de8cf$export$3968a3afc810b5f5).blue, direction: direction = directionConfig === "rtl" ? "to left" : "to right", ...rest } = strokeColor;
    if (Object.keys(rest).length !== 0) {
        const sortedGradients = $3a21b0fb1ecd4063$export$8947b167cf78cbe(rest);
        const background = `linear-gradient(${direction}, ${sortedGradients})`;
        return {
            background: background,
            [(0, $f6e7c3be7c89a26d$export$ce7447cfda329128)]: background
        };
    }
    const background = `linear-gradient(${direction}, ${from}, ${to})`;
    return {
        background: background,
        [(0, $f6e7c3be7c89a26d$export$ce7447cfda329128)]: background
    };
};
const $3a21b0fb1ecd4063$var$Line = (props)=>{
    const { prefixCls: prefixCls, classNames: classNames, styles: styles, direction: directionConfig, percent: percent, size: size, strokeWidth: strokeWidth, strokeColor: strokeColor, strokeLinecap: strokeLinecap = "round", children: children, railColor: railColor, trailColor: trailColor, percentPosition: percentPosition, success: success } = props;
    const { align: infoAlign, type: infoPosition } = percentPosition;
    const mergedRailColor = railColor ?? trailColor;
    const borderRadius = strokeLinecap === "square" || strokeLinecap === "butt" ? 0 : undefined;
    // ========================= Size =========================
    const mergedSize = size ?? [
        -1,
        strokeWidth || (size === "small" ? 6 : 8)
    ];
    const [width, height] = (0, $21f724def245d757$export$31b21d0167753bb4)(mergedSize, "line", {
        strokeWidth: strokeWidth
    });
    // ========================= Rail =========================
    const railStyle = {
        backgroundColor: mergedRailColor || undefined,
        borderRadius: borderRadius,
        height: height
    };
    // ======================== Tracks ========================
    const trackCls = `${prefixCls}-track`;
    const backgroundProps = strokeColor && typeof strokeColor !== "string" ? $3a21b0fb1ecd4063$export$22b6122229807a9f(strokeColor, directionConfig) : {
        [(0, $f6e7c3be7c89a26d$export$ce7447cfda329128)]: strokeColor,
        background: strokeColor
    };
    const percentTrackStyle = {
        width: `${(0, $21f724def245d757$export$2caef35201f951a0)(percent)}%`,
        height: height,
        borderRadius: borderRadius,
        ...backgroundProps
    };
    const successPercent = (0, $21f724def245d757$export$4ab1c09ce4ee99b)(props);
    const successTrackStyle = {
        width: `${(0, $21f724def245d757$export$2caef35201f951a0)(successPercent)}%`,
        height: height,
        borderRadius: borderRadius,
        backgroundColor: success?.strokeColor
    };
    // ======================== Render ========================
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-body`, classNames.body, {
            [`${prefixCls}-body-layout-bottom`]: infoAlign === "center" && infoPosition === "outer"
        }),
        style: {
            width: width > 0 ? width : "100%",
            ...styles.body
        }
    }, /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-rail`, classNames.rail),
        style: {
            ...railStyle,
            ...styles.rail
        }
    }, /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(trackCls, classNames.track),
        style: {
            ...percentTrackStyle,
            ...styles.track
        }
    }, infoPosition === "inner" && children), successPercent !== undefined && /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(trackCls, `${trackCls}-success`, classNames.track),
        style: {
            ...successTrackStyle,
            ...styles.track
        }
    })), infoPosition === "outer" && children);
};
var $3a21b0fb1ecd4063$export$2e2bcd8739ae039 = $3a21b0fb1ecd4063$var$Line;



var $cQmXV = parcelRequire("cQmXV");


"use client";
const $5bb7669c4f2061cc$var$Steps = (props)=>{
    const { classNames: classNames, styles: styles, size: size, steps: steps, rounding: customRounding = Math.round, percent: percent = 0, strokeWidth: strokeWidth = 8, strokeColor: strokeColor, railColor: railColor, trailColor: trailColor, prefixCls: prefixCls, children: children } = props;
    const current = customRounding(steps * (percent / 100));
    const stepWidth = size === "small" ? 2 : 14;
    const mergedSize = size ?? [
        stepWidth,
        strokeWidth
    ];
    const [width, height] = (0, $21f724def245d757$export$31b21d0167753bb4)(mergedSize, "step", {
        steps: steps,
        strokeWidth: strokeWidth
    });
    const unitWidth = width / steps;
    const styledSteps = Array.from({
        length: steps
    });
    const mergedRailColor = railColor ?? trailColor;
    for(let i = 0; i < steps; i++){
        const color = Array.isArray(strokeColor) ? strokeColor[i] : strokeColor;
        styledSteps[i] = /*#__PURE__*/ $cQmXV.createElement("div", {
            key: i,
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-steps-item`, {
                [`${prefixCls}-steps-item-active`]: i <= current - 1
            }, classNames.track),
            style: {
                backgroundColor: i <= current - 1 ? color : mergedRailColor,
                width: unitWidth,
                height: height,
                ...styles.track
            }
        });
    }
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-steps-body`, classNames.body),
        style: styles.body
    }, styledSteps, children);
};
var $5bb7669c4f2061cc$export$2e2bcd8739ae039 = $5bb7669c4f2061cc$var$Steps;




"use client";
const $57fe73fabcc3dc75$export$e54ebc7fe4b5dc4e = [
    "line",
    "circle",
    "dashboard"
];
const $57fe73fabcc3dc75$var$ProgressStatuses = [
    "normal",
    "exception",
    "active",
    "success"
];
const $57fe73fabcc3dc75$var$Progress = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, classNames: classNames, styles: styles, steps: steps, strokeColor: strokeColor, percent: percent = 0, size: size = "medium", showInfo: showInfo = true, type: type = "line", status: status, format: format, style: style, percentPosition: percentPosition = {}, ...restProps } = props;
    // ========================= MISC =========================
    const { align: infoAlign = "end", type: infoPosition = "outer" } = percentPosition;
    const strokeColorNotArray = Array.isArray(strokeColor) ? strokeColor[0] : strokeColor;
    const strokeColorNotGradient = typeof strokeColor === "string" || Array.isArray(strokeColor) ? strokeColor : undefined;
    const strokeColorIsBright = $cQmXV.useMemo(()=>{
        if (strokeColorNotArray) {
            const color = typeof strokeColorNotArray === "string" ? strokeColorNotArray : Object.values(strokeColorNotArray)[0];
            return new (0, $3bb84f07fb2a2f32$export$2c4f38d6c0ecc25a)(color).isLight();
        }
        return false;
    }, [
        strokeColor
    ]);
    const percentNumber = $cQmXV.useMemo(()=>{
        const successPercent = (0, $21f724def245d757$export$4ab1c09ce4ee99b)(props);
        return Number.parseInt(successPercent !== undefined ? (successPercent ?? 0)?.toString() : (percent ?? 0)?.toString(), 10);
    }, [
        percent,
        props.success
    ]);
    const progressStatus = $cQmXV.useMemo(()=>{
        if (!$57fe73fabcc3dc75$var$ProgressStatuses.includes(status) && percentNumber >= 100) return "success";
        return status || "normal";
    }, [
        status,
        percentNumber
    ]);
    // ======================= Context ========================
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("progress");
    const prefixCls = getPrefixCls("progress", customizePrefixCls);
    const [hashId, cssVarCls] = (0, $f6e7c3be7c89a26d$export$2e2bcd8739ae039)(prefixCls);
    const mergedProps = {
        ...props,
        percent: percent,
        type: type,
        size: size,
        showInfo: showInfo,
        percentPosition: percentPosition
    };
    // ======================== Styles ========================
    const contextStyleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $30c5f9f911d4f61b$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: mergedProps
    });
    // ========================= Info =========================
    const isLineType = type === "line";
    const isPureLineType = isLineType && !steps;
    const progressInfo = $cQmXV.useMemo(()=>{
        if (!showInfo) return null;
        const successPercent = (0, $21f724def245d757$export$4ab1c09ce4ee99b)(props);
        let text;
        const textFormatter = format || ((number)=>`${number}%`);
        const isBrightInnerColor = isLineType && strokeColorIsBright && infoPosition === "inner";
        if (infoPosition === "inner" || format || progressStatus !== "exception" && progressStatus !== "success") text = textFormatter((0, $21f724def245d757$export$2caef35201f951a0)(percent), (0, $21f724def245d757$export$2caef35201f951a0)(successPercent));
        else if (progressStatus === "exception") text = isLineType ? /*#__PURE__*/ $cQmXV.createElement((0, $ff9add21dbbc2684$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $cQmXV.createElement((0, $837faca566926e3c$export$2e2bcd8739ae039), null);
        else if (progressStatus === "success") text = isLineType ? /*#__PURE__*/ $cQmXV.createElement((0, $017e758d1ebbd854$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $cQmXV.createElement((0, $77ccca814b0c39fe$export$2e2bcd8739ae039), null);
        return /*#__PURE__*/ $cQmXV.createElement("span", {
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-indicator`, {
                [`${prefixCls}-indicator-bright`]: isBrightInnerColor,
                [`${prefixCls}-indicator-${infoAlign}`]: isPureLineType,
                [`${prefixCls}-indicator-${infoPosition}`]: isPureLineType
            }, mergedClassNames.indicator),
            style: mergedStyles.indicator,
            title: typeof text === "string" ? text : undefined
        }, text);
    }, [
        showInfo,
        percent,
        percentNumber,
        progressStatus,
        type,
        prefixCls,
        format,
        isLineType,
        strokeColorIsBright,
        infoPosition,
        infoAlign,
        isPureLineType,
        mergedClassNames.indicator,
        mergedStyles.indicator
    ]);
    var deprecatedName, newName;
    // ======================== Render ========================
    const sharedProps = {
        ...props,
        classNames: mergedClassNames,
        styles: mergedStyles
    };
    let progress;
    // Render progress shape
    if (type === "line") progress = steps ? /*#__PURE__*/ $cQmXV.createElement((0, $5bb7669c4f2061cc$export$2e2bcd8739ae039), {
        ...sharedProps,
        strokeColor: strokeColorNotGradient,
        prefixCls: prefixCls,
        steps: (0, $8e2d153a3c855782$export$53b83ca8eaab0383)(steps) ? steps.count : steps
    }, progressInfo) : /*#__PURE__*/ $cQmXV.createElement((0, $3a21b0fb1ecd4063$export$2e2bcd8739ae039), {
        ...sharedProps,
        strokeColor: strokeColorNotArray,
        prefixCls: prefixCls,
        direction: direction,
        percentPosition: {
            align: infoAlign,
            type: infoPosition
        }
    }, progressInfo);
    else if (type === "circle" || type === "dashboard") progress = /*#__PURE__*/ $cQmXV.createElement((0, $0be6abc1ff0be0fc$export$2e2bcd8739ae039), {
        ...sharedProps,
        strokeColor: strokeColorNotArray,
        prefixCls: prefixCls,
        progressStatus: progressStatus
    }, progressInfo);
    const classString = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-status-${progressStatus}`, {
        [`${prefixCls}-${type === "dashboard" && "circle" || type}`]: type !== "line",
        [`${prefixCls}-inline-circle`]: type === "circle" && (0, $21f724def245d757$export$31b21d0167753bb4)(size, "circle")[0] <= 20,
        [`${prefixCls}-line`]: isPureLineType,
        [`${prefixCls}-line-align-${infoAlign}`]: isPureLineType,
        [`${prefixCls}-line-position-${infoPosition}`]: isPureLineType,
        [`${prefixCls}-steps`]: steps,
        [`${prefixCls}-show-info`]: showInfo,
        [`${prefixCls}-small`]: size === "small",
        [`${prefixCls}-rtl`]: direction === "rtl"
    }, contextClassName, className, rootClassName, mergedClassNames.root, hashId, cssVarCls);
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        ref: ref,
        style: mergedStyles.root,
        className: classString,
        role: "progressbar",
        "aria-valuenow": percentNumber,
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        ...(0, $e8c5093aebad6025$export$2e2bcd8739ae039)(restProps, [
            "railColor",
            "trailColor",
            "strokeWidth",
            "width",
            "gapDegree",
            "gapPosition",
            "gapPlacement",
            "strokeLinecap",
            "success"
        ])
    }, progress);
});
var $57fe73fabcc3dc75$export$2e2bcd8739ae039 = $57fe73fabcc3dc75$var$Progress;


"use client";
var $deaf5cd30ff4a7d3$export$2e2bcd8739ae039 = (0, $57fe73fabcc3dc75$export$2e2bcd8739ae039);



"use client";
const $368e316c797e9af6$var$ListItem = /*#__PURE__*/ $cQmXV.forwardRef(({ prefixCls: prefixCls, className: className, style: style, classNames: itemClassNames, styles: styles, locale: locale, listType: listType, file: file, items: items, progress: progressProps, iconRender: iconRender, actionIconRender: actionIconRender, itemRender: itemRender, isImgUrl: isImgUrl, showPreviewIcon: showPreviewIcon, showRemoveIcon: showRemoveIcon, showDownloadIcon: showDownloadIcon, previewIcon: customPreviewIcon, removeIcon: customRemoveIcon, downloadIcon: customDownloadIcon, extra: customExtra, onPreview: onPreview, onDownload: onDownload, onClose: onClose }, ref)=>{
    // Status: which will ignore `removed` status
    const { status: status } = file;
    const [mergedStatus, setMergedStatus] = $cQmXV.useState(status);
    $cQmXV.useEffect(()=>{
        if (status !== "removed") setMergedStatus(status);
    }, [
        status
    ]);
    // Delay to show the progress bar
    const [showProgress, setShowProgress] = (0, $f0cf805f93abd5af$export$2e2bcd8739ae039)(false);
    $cQmXV.useEffect(()=>{
        setShowProgress(true, {
            ms: 300
        });
    }, []);
    const iconNode = iconRender(file);
    let icon = /*#__PURE__*/ $cQmXV.createElement("div", {
        className: `${prefixCls}-icon`
    }, iconNode);
    if (listType === "picture" || listType === "picture-card" || listType === "picture-circle") {
        if (mergedStatus === "uploading" || !file.thumbUrl && !file.url) {
            const uploadingClassName = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-list-item-thumbnail`, {
                [`${prefixCls}-list-item-file`]: mergedStatus !== "uploading"
            });
            icon = /*#__PURE__*/ $cQmXV.createElement("div", {
                className: uploadingClassName
            }, iconNode);
        } else {
            const thumbnail = isImgUrl?.(file) ? /*#__PURE__*/ $cQmXV.createElement("img", {
                src: file.thumbUrl || file.url,
                alt: file.name,
                className: `${prefixCls}-list-item-image`,
                crossOrigin: file.crossOrigin
            }) : iconNode;
            const aClassName = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-list-item-thumbnail`, {
                [`${prefixCls}-list-item-file`]: isImgUrl && !isImgUrl(file)
            });
            icon = /*#__PURE__*/ $cQmXV.createElement("a", {
                className: aClassName,
                onClick: (e)=>onPreview(file, e),
                href: file.url || file.thumbUrl,
                target: "_blank",
                rel: "noopener noreferrer"
            }, thumbnail);
        }
    }
    const listItemClassName = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-list-item`, `${prefixCls}-list-item-${mergedStatus}`, itemClassNames?.item);
    const linkProps = typeof file.linkProps === "string" ? JSON.parse(file.linkProps) : file.linkProps;
    const removeIcon = ((0, $8e2d153a3c855782$export$f6e2535fb5126e54)(showRemoveIcon) ? showRemoveIcon(file) : showRemoveIcon) ? actionIconRender(((0, $8e2d153a3c855782$export$f6e2535fb5126e54)(customRemoveIcon) ? customRemoveIcon(file) : customRemoveIcon) || /*#__PURE__*/ $cQmXV.createElement((0, $5234c28d879e38c1$export$2e2bcd8739ae039), null), ()=>onClose(file), prefixCls, locale.removeFile, // acceptUploadDisabled is true, only remove icon will follow Upload disabled prop
    // https://github.com/ant-design/ant-design/issues/46171
    true) : null;
    const downloadIcon = ((0, $8e2d153a3c855782$export$f6e2535fb5126e54)(showDownloadIcon) ? showDownloadIcon(file) : showDownloadIcon) && mergedStatus === "done" ? actionIconRender(((0, $8e2d153a3c855782$export$f6e2535fb5126e54)(customDownloadIcon) ? customDownloadIcon(file) : customDownloadIcon) || /*#__PURE__*/ $cQmXV.createElement((0, $a8f7d355c4714d40$export$2e2bcd8739ae039), null), ()=>onDownload(file), prefixCls, locale.downloadFile) : null;
    const downloadOrDelete = listType !== "picture-card" && listType !== "picture-circle" && /*#__PURE__*/ $cQmXV.createElement("span", {
        key: "download-delete",
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-list-item-actions`, {
            picture: listType === "picture"
        })
    }, downloadIcon, removeIcon);
    const extraContent = (0, $8e2d153a3c855782$export$f6e2535fb5126e54)(customExtra) ? customExtra(file) : customExtra;
    const extra = extraContent && /*#__PURE__*/ $cQmXV.createElement("span", {
        className: `${prefixCls}-list-item-extra`
    }, extraContent);
    const listItemNameClass = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-list-item-name`);
    const onPreviewKeyDown = (e)=>{
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onPreview(file, e);
        }
    };
    const fileName = file.url ? /*#__PURE__*/ $cQmXV.createElement("a", {
        key: "view",
        target: "_blank",
        rel: "noopener noreferrer",
        className: listItemNameClass,
        title: file.name,
        ...linkProps,
        href: file.url,
        onClick: (e)=>onPreview(file, e)
    }, file.name, extra) : /*#__PURE__*/ $cQmXV.createElement("span", {
        key: "view",
        role: "button",
        tabIndex: 0,
        className: listItemNameClass,
        onClick: (e)=>onPreview(file, e),
        onKeyDown: onPreviewKeyDown,
        title: file.name
    }, file.name, extra);
    const previewIcon = ((0, $8e2d153a3c855782$export$f6e2535fb5126e54)(showPreviewIcon) ? showPreviewIcon(file) : showPreviewIcon) && (file.url || file.thumbUrl) ? /*#__PURE__*/ $cQmXV.createElement("a", {
        href: file.url || file.thumbUrl,
        target: "_blank",
        rel: "noopener noreferrer",
        onClick: (e)=>onPreview(file, e),
        title: locale.previewFile
    }, (0, $8e2d153a3c855782$export$f6e2535fb5126e54)(customPreviewIcon) ? customPreviewIcon(file) : customPreviewIcon || /*#__PURE__*/ $cQmXV.createElement((0, $976919bf69465b09$export$2e2bcd8739ae039), null)) : null;
    const pictureCardActions = (listType === "picture-card" || listType === "picture-circle") && mergedStatus !== "uploading" && /*#__PURE__*/ $cQmXV.createElement("span", {
        className: `${prefixCls}-list-item-actions`
    }, previewIcon, mergedStatus === "done" && downloadIcon, removeIcon);
    const { getPrefixCls: getPrefixCls } = $cQmXV.useContext((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    const rootPrefixCls = getPrefixCls();
    const dom = /*#__PURE__*/ $cQmXV.createElement("div", {
        className: listItemClassName,
        style: styles?.item
    }, icon, fileName, downloadOrDelete, pictureCardActions, showProgress && /*#__PURE__*/ $cQmXV.createElement((0, $04c53b89814950f8$export$2e2bcd8739ae039), {
        motionName: `${rootPrefixCls}-fade`,
        visible: mergedStatus === "uploading",
        motionDeadline: 2000
    }, ({ className: motionClassName })=>{
        // show loading icon if upload progress listener is disabled
        const loadingProgress = "percent" in file ? /*#__PURE__*/ $cQmXV.createElement((0, $deaf5cd30ff4a7d3$export$2e2bcd8739ae039), {
            type: "line",
            percent: file.percent,
            "aria-label": file["aria-label"],
            "aria-labelledby": file["aria-labelledby"],
            ...progressProps
        }) : null;
        return /*#__PURE__*/ $cQmXV.createElement("div", {
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-list-item-progress`, motionClassName)
        }, loadingProgress);
    }));
    const message = file.response && typeof file.response === "string" ? file.response : file.error?.statusText || file.error?.message || locale.uploadError;
    const item = mergedStatus === "error" ? /*#__PURE__*/ $cQmXV.createElement((0, $1e5256cf9d329b2c$export$2e2bcd8739ae039), {
        title: message,
        getPopupContainer: (node)=>node.parentNode
    }, dom) : dom;
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-list-item-container`, className),
        style: style,
        ref: ref
    }, itemRender ? itemRender(item, file, items, {
        download: onDownload.bind(null, file),
        preview: onPreview.bind(null, file),
        remove: onClose.bind(null, file)
    }) : item);
});
var $368e316c797e9af6$export$2e2bcd8739ae039 = $368e316c797e9af6$var$ListItem;


"use client";
const $3c3dcff9373b8341$var$InternalUploadList = (props, ref)=>{
    const { listType: listType = "text", previewFile: previewFile = (0, $5365409924cb9894$export$b5db251096956c0d), onPreview: onPreview, onDownload: onDownload, onRemove: onRemove, locale: locale, iconRender: iconRender, isImageUrl: isImgUrl = (0, $5365409924cb9894$export$431d13c2db3f6781), prefixCls: customizePrefixCls, items: items = [], showPreviewIcon: showPreviewIcon = true, showRemoveIcon: showRemoveIcon = true, showDownloadIcon: showDownloadIcon = false, removeIcon: removeIcon, previewIcon: previewIcon, downloadIcon: downloadIcon, extra: extra, progress: progress = {
        size: [
            -1,
            2
        ],
        showInfo: false
    }, appendAction: appendAction, appendActionVisible: appendActionVisible = true, itemRender: itemRender, disabled: disabled, classNames: uploadListClassNames, styles: styles } = props;
    const [, forceUpdate] = (0, $4ba220b3356f61b8$export$91db9bc4f8ac944a)();
    const [motionAppear, setMotionAppear] = $cQmXV.useState(false);
    const isPictureCardOrCirle = [
        "picture-card",
        "picture-circle"
    ].includes(listType);
    // ============================= Effect =============================
    $cQmXV.useEffect(()=>{
        if (!listType.startsWith("picture")) return;
        (items || []).forEach((file)=>{
            if (!(file.originFileObj instanceof File || file.originFileObj instanceof Blob) || file.thumbUrl !== undefined) return;
            file.thumbUrl = "";
            previewFile?.(file.originFileObj).then((previewDataUrl)=>{
                // Need append '' to avoid dead loop
                file.thumbUrl = previewDataUrl || "";
                forceUpdate();
            });
        });
    }, [
        listType,
        items,
        previewFile
    ]);
    $cQmXV.useEffect(()=>{
        setMotionAppear(true);
    }, []);
    // ============================= Events =============================
    const onInternalPreview = (file, e)=>{
        if (!onPreview) return;
        e?.preventDefault();
        return onPreview(file);
    };
    const onInternalDownload = (file)=>{
        if ((0, $8e2d153a3c855782$export$f6e2535fb5126e54)(onDownload)) onDownload(file);
        else if (file.url) window.open(file.url, "_blank", "noopener");
    };
    const onInternalClose = (file)=>{
        onRemove?.(file);
    };
    const internalIconRender = (file)=>{
        if (iconRender) return iconRender(file, listType);
        const isLoading = file.status === "uploading";
        if (listType.startsWith("picture")) {
            const loadingIcon = listType === "picture" ? /*#__PURE__*/ $cQmXV.createElement((0, $bf7996ca956facd7$export$2e2bcd8739ae039), null) : locale.uploading;
            const fileIcon = isImgUrl?.(file) ? /*#__PURE__*/ $cQmXV.createElement((0, $9f1db3a3fd7715e2$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $cQmXV.createElement((0, $cf187e4b16fb1e1e$export$2e2bcd8739ae039), null);
            return isLoading ? loadingIcon : fileIcon;
        }
        return isLoading ? /*#__PURE__*/ $cQmXV.createElement((0, $bf7996ca956facd7$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $cQmXV.createElement((0, $c6dcba9ec81c8bd9$export$2e2bcd8739ae039), null);
    };
    const actionIconRender = (customIcon, callback, prefixCls, title, acceptUploadDisabled)=>{
        const btnProps = {
            type: "text",
            size: "small",
            title: title,
            onClick: (e)=>{
                callback();
                if (/*#__PURE__*/ $cQmXV.isValidElement(customIcon)) customIcon.props.onClick?.(e);
            },
            className: `${prefixCls}-list-item-action`,
            disabled: acceptUploadDisabled ? disabled : false
        };
        return /*#__PURE__*/ $cQmXV.isValidElement(customIcon) ? /*#__PURE__*/ $cQmXV.createElement((0, $1fc505710073cde5$export$2e2bcd8739ae039), {
            ...btnProps,
            icon: (0, $a91ef204d03d8eec$export$e530037191fcd5d7)(customIcon, {
                ...customIcon.props,
                onClick: ()=>{}
            })
        }) : /*#__PURE__*/ $cQmXV.createElement((0, $1fc505710073cde5$export$2e2bcd8739ae039), {
            ...btnProps
        }, /*#__PURE__*/ $cQmXV.createElement("span", null, customIcon));
    };
    // ============================== Ref ===============================
    // Test needs
    $cQmXV.useImperativeHandle(ref, ()=>({
            handlePreview: onInternalPreview,
            handleDownload: onInternalDownload
        }));
    const { getPrefixCls: getPrefixCls } = $cQmXV.useContext((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    // ============================= Render =============================
    const prefixCls = getPrefixCls("upload", customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    const listClassNames = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-list`, `${prefixCls}-list-${listType}`, uploadListClassNames?.list);
    const listItemMotion = $cQmXV.useMemo(()=>(0, $e8c5093aebad6025$export$2e2bcd8739ae039)((0, $047a5f051ebda8ba$export$2e2bcd8739ae039)(rootPrefixCls), [
            "onAppearEnd",
            "onEnterEnd",
            "onLeaveEnd"
        ]), [
        rootPrefixCls
    ]);
    const motionConfig = {
        ...isPictureCardOrCirle ? {} : listItemMotion,
        motionDeadline: 2000,
        motionName: `${prefixCls}-${isPictureCardOrCirle ? "animate-inline" : "animate"}`,
        keys: (0, $68381b18b974dc9f$export$2e2bcd8739ae039)(items.map((file)=>({
                key: file.uid,
                file: file
            }))),
        motionAppear: motionAppear
    };
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        className: listClassNames,
        style: styles?.list
    }, /*#__PURE__*/ $cQmXV.createElement((0, $26c73d1f8271409e$export$2e2bcd8739ae039), {
        ...motionConfig,
        component: false
    }, ({ key: key, file: file, className: motionClassName, style: motionStyle })=>/*#__PURE__*/ $cQmXV.createElement((0, $368e316c797e9af6$export$2e2bcd8739ae039), {
            key: key,
            locale: locale,
            prefixCls: prefixCls,
            className: motionClassName,
            style: motionStyle,
            classNames: uploadListClassNames,
            styles: styles,
            file: file,
            items: items,
            progress: progress,
            listType: listType,
            isImgUrl: isImgUrl,
            showPreviewIcon: showPreviewIcon,
            showRemoveIcon: showRemoveIcon,
            showDownloadIcon: showDownloadIcon,
            removeIcon: removeIcon,
            previewIcon: previewIcon,
            downloadIcon: downloadIcon,
            extra: extra,
            iconRender: internalIconRender,
            actionIconRender: actionIconRender,
            itemRender: itemRender,
            onPreview: onInternalPreview,
            onDownload: onInternalDownload,
            onClose: onInternalClose
        })), appendAction && /*#__PURE__*/ $cQmXV.createElement((0, $04c53b89814950f8$export$2e2bcd8739ae039), {
        ...motionConfig,
        visible: appendActionVisible,
        forceRender: true
    }, ({ className: motionClassName, style: motionStyle })=>(0, $a91ef204d03d8eec$export$e530037191fcd5d7)(appendAction, (oriProps)=>({
                className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(oriProps.className, motionClassName),
                style: {
                    ...motionStyle,
                    // prevent the element has hover css pseudo-class that may cause animation to end prematurely.
                    pointerEvents: motionClassName ? "none" : undefined,
                    ...oriProps.style
                }
            }))));
};
const $3c3dcff9373b8341$var$UploadList = /*#__PURE__*/ $cQmXV.forwardRef($3c3dcff9373b8341$var$InternalUploadList);
var $3c3dcff9373b8341$export$2e2bcd8739ae039 = $3c3dcff9373b8341$var$UploadList;



"use client";
const $5095ff83a2fe54e7$export$8f9bb9ff126b1bf5 = `__LIST_IGNORE_${Date.now()}__`;
const $5095ff83a2fe54e7$var$InternalUpload = (props, ref)=>{
    const config = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("upload");
    const { fileList: fileList, defaultFileList: defaultFileList, onRemove: onRemove, showUploadList: showUploadList = true, listType: listType = "text", onPreview: onPreview, onDownload: onDownload, onChange: onChange, onDrop: onDrop, previewFile: previewFile, disabled: customDisabled, locale: propLocale, iconRender: iconRender, isImageUrl: isImageUrl, progress: customProgress, prefixCls: customizePrefixCls, className: className, type: type = "select", children: children, style: style, itemRender: itemRender, maxCount: maxCount, data: data = {}, multiple: multiple = false, hasControlInside: hasControlInside = true, action: action = "", accept: customAccept, supportServerRender: supportServerRender = true, rootClassName: rootClassName, styles: styles, classNames: classNames } = props;
    // ===================== Disabled =====================
    const disabled = $cQmXV.useContext((0, $4f0e1ea30330557c$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled ?? disabled;
    const customRequest = props.customRequest || config.customRequest;
    const mergedProgress = config.progress || customProgress ? {
        ...config.progress,
        ...customProgress
    } : undefined;
    const mergedAccept = (0, $55c1e81905598a5b$export$2e2bcd8739ae039)(customAccept, config.accept, "");
    const [internalFileList, setMergedFileList] = (0, $a51866d781137e08$export$2e2bcd8739ae039)(defaultFileList, fileList);
    const mergedFileList = internalFileList || [];
    const [dragState, setDragState] = $cQmXV.useState("drop");
    const uploadRef = $cQmXV.useRef(null);
    const wrapRef = $cQmXV.useRef(null);
    // Control mode will auto fill file uid if not provided
    $cQmXV.useMemo(()=>{
        const timestamp = Date.now();
        (fileList || []).forEach((file, index)=>{
            if (!file.uid && !Object.isFrozen(file)) file.uid = `__AUTO__${timestamp}_${index}__`;
        });
    }, [
        fileList
    ]);
    const onInternalChange = (file, changedFileList, event)=>{
        let cloneList = (0, $68381b18b974dc9f$export$2e2bcd8739ae039)(changedFileList);
        let exceedMaxCount = false;
        // Cut to match count
        if (maxCount === 1) cloneList = cloneList.slice(-1);
        else if (maxCount) {
            exceedMaxCount = cloneList.length > maxCount;
            cloneList = cloneList.slice(0, maxCount);
        }
        // Prevent React18 auto batch since input[upload] trigger process at same time
        // which makes fileList closure problem
        // eslint-disable-next-line react-dom/no-flush-sync
        (0, $3h5eW.flushSync)(()=>{
            setMergedFileList(cloneList);
        });
        const changeInfo = {
            file: file,
            fileList: cloneList
        };
        if (event) changeInfo.event = event;
        if (!exceedMaxCount || file.status === "removed" || // We should ignore event if current file is exceed `maxCount`
        cloneList.some((f)=>f.uid === file.uid)) // eslint-disable-next-line react-dom/no-flush-sync
        (0, $3h5eW.flushSync)(()=>{
            onChange?.(changeInfo);
        });
    };
    const mergedBeforeUpload = async (file, fileListArgs)=>{
        const { beforeUpload: beforeUpload } = props;
        let parsedFile = file;
        if (beforeUpload) {
            const result = await beforeUpload(file, fileListArgs);
            if (result === false) return false;
            // Hack for LIST_IGNORE, we add additional info to remove from the list
            delete file[$5095ff83a2fe54e7$export$8f9bb9ff126b1bf5];
            if (result === $5095ff83a2fe54e7$export$8f9bb9ff126b1bf5) {
                Object.defineProperty(file, $5095ff83a2fe54e7$export$8f9bb9ff126b1bf5, {
                    value: true,
                    configurable: true
                });
                return false;
            }
            if ((0, $8e2d153a3c855782$export$53b83ca8eaab0383)(result)) parsedFile = result;
        }
        return parsedFile;
    };
    const onBatchStart = (batchFileInfoList)=>{
        // Skip file which marked as `LIST_IGNORE`, these file will not add to file list
        const filteredFileInfoList = batchFileInfoList.filter((info)=>!info.file[$5095ff83a2fe54e7$export$8f9bb9ff126b1bf5]);
        // Nothing to do since no file need upload
        if (!filteredFileInfoList.length) return;
        const objectFileList = filteredFileInfoList.map((info)=>(0, $5365409924cb9894$export$6dc848fd109e803d)(info.file));
        // Concat new files with prev files
        let newFileList = (0, $68381b18b974dc9f$export$2e2bcd8739ae039)(mergedFileList);
        objectFileList.forEach((fileObj)=>{
            // Replace file if exist
            newFileList = (0, $5365409924cb9894$export$65c2063f64290f37)(fileObj, newFileList);
        });
        objectFileList.forEach((fileObj, index)=>{
            // Repeat trigger `onChange` event for compatible
            let triggerFileObj = fileObj;
            if (!filteredFileInfoList[index].parsedFile) {
                // `beforeUpload` return false
                const { originFileObj: originFileObj } = fileObj;
                let clone;
                try {
                    clone = new File([
                        originFileObj
                    ], originFileObj.name, {
                        type: originFileObj.type
                    });
                } catch  {
                    clone = new Blob([
                        originFileObj
                    ], {
                        type: originFileObj.type
                    });
                    clone.name = originFileObj.name;
                    clone.lastModifiedDate = new Date();
                    clone.lastModified = new Date().getTime();
                }
                clone.uid = fileObj.uid;
                triggerFileObj = clone;
            } else // Inject `uploading` status
            fileObj.status = "uploading";
            onInternalChange(triggerFileObj, newFileList);
        });
    };
    const onSuccess = (response, file, xhr)=>{
        try {
            if (typeof response === "string") response = JSON.parse(response);
        } catch  {
        /* do nothing */ }
        // removed
        if (!(0, $5365409924cb9894$export$1165ac073f485fae)(file, mergedFileList)) return;
        const targetItem = (0, $5365409924cb9894$export$6dc848fd109e803d)(file);
        targetItem.status = "done";
        targetItem.percent = 100;
        targetItem.response = response;
        targetItem.xhr = xhr;
        const nextFileList = (0, $5365409924cb9894$export$65c2063f64290f37)(targetItem, mergedFileList);
        onInternalChange(targetItem, nextFileList);
    };
    const onProgress = (e, file)=>{
        // removed
        if (!(0, $5365409924cb9894$export$1165ac073f485fae)(file, mergedFileList)) return;
        const targetItem = (0, $5365409924cb9894$export$6dc848fd109e803d)(file);
        targetItem.status = "uploading";
        targetItem.percent = e.percent;
        const nextFileList = (0, $5365409924cb9894$export$65c2063f64290f37)(targetItem, mergedFileList);
        onInternalChange(targetItem, nextFileList, e);
    };
    const onError = (error, response, file)=>{
        // removed
        if (!(0, $5365409924cb9894$export$1165ac073f485fae)(file, mergedFileList)) return;
        const targetItem = (0, $5365409924cb9894$export$6dc848fd109e803d)(file);
        targetItem.error = error;
        targetItem.response = response;
        targetItem.status = "error";
        const nextFileList = (0, $5365409924cb9894$export$65c2063f64290f37)(targetItem, mergedFileList);
        onInternalChange(targetItem, nextFileList);
    };
    const handleRemove = (file)=>{
        let currentFile;
        Promise.resolve((0, $8e2d153a3c855782$export$f6e2535fb5126e54)(onRemove) ? onRemove(file) : onRemove).then((ret)=>{
            // Prevent removing file
            if (ret === false) return;
            const removedFileList = (0, $5365409924cb9894$export$f3bced642db28a96)(file, mergedFileList);
            if (removedFileList) {
                currentFile = {
                    ...file,
                    status: "removed"
                };
                mergedFileList?.forEach((item)=>{
                    const matchKey = currentFile.uid !== undefined ? "uid" : "name";
                    if (item[matchKey] === currentFile[matchKey] && !Object.isFrozen(item)) item.status = "removed";
                });
                uploadRef.current?.abort(currentFile);
                onInternalChange(currentFile, removedFileList);
            }
        });
    };
    const onFileDrop = (e)=>{
        setDragState(e.type);
        if (e.type === "drop") onDrop?.(e);
    };
    // Test needs
    $cQmXV.useImperativeHandle(ref, ()=>({
            onBatchStart: onBatchStart,
            onSuccess: onSuccess,
            onProgress: onProgress,
            onError: onError,
            fileList: mergedFileList,
            upload: uploadRef.current,
            nativeElement: wrapRef.current
        }));
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("upload");
    const prefixCls = getPrefixCls("upload", customizePrefixCls);
    // =========== Merged Props for Semantic ==========
    const mergedProps = {
        ...props,
        listType: listType,
        showUploadList: showUploadList,
        type: type,
        multiple: multiple,
        hasControlInside: hasControlInside,
        supportServerRender: supportServerRender,
        disabled: mergedDisabled
    };
    const contextTriggerStyle = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(contextStyle, "trigger");
    const triggerStyle = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(style, "trigger");
    const [mergedClassNames, mergedStyles] = (0, $30c5f9f911d4f61b$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextTriggerStyle,
        styles,
        triggerStyle
    ], {
        props: mergedProps
    });
    const rcUploadProps = {
        onBatchStart: onBatchStart,
        onError: onError,
        onProgress: onProgress,
        onSuccess: onSuccess,
        ...props,
        customRequest: customRequest,
        data: data,
        multiple: multiple,
        action: action,
        accept: mergedAccept,
        supportServerRender: supportServerRender,
        prefixCls: prefixCls,
        disabled: mergedDisabled,
        beforeUpload: mergedBeforeUpload,
        onChange: undefined,
        hasControlInside: hasControlInside
    };
    delete rcUploadProps.className;
    delete rcUploadProps.style;
    // Remove id to avoid open by label when trigger is hidden
    // !children: https://github.com/ant-design/ant-design/issues/14298
    // disabled: https://github.com/ant-design/ant-design/issues/16478
    //           https://github.com/ant-design/ant-design/issues/24197
    if (!children || mergedDisabled) delete rcUploadProps.id;
    const wrapperCls = `${prefixCls}-wrapper`;
    const [hashId, cssVarCls] = (0, $4c1cc03801c301db$export$2e2bcd8739ae039)(prefixCls, wrapperCls);
    const [contextLocale] = (0, $c953dac9d015386e$export$2e2bcd8739ae039)("Upload", (0, $4ab0c7032ff9de6a$export$2e2bcd8739ae039).Upload);
    const { showRemoveIcon: showRemoveIcon, showPreviewIcon: showPreviewIcon, showDownloadIcon: showDownloadIcon, removeIcon: removeIcon, previewIcon: previewIcon, downloadIcon: downloadIcon, extra: extra } = typeof showUploadList === "boolean" ? {} : showUploadList;
    // use showRemoveIcon if it is specified explicitly
    const realShowRemoveIcon = typeof showRemoveIcon === "undefined" ? !mergedDisabled : showRemoveIcon;
    const renderUploadList = (button, buttonVisible)=>{
        if (!showUploadList) return button;
        return /*#__PURE__*/ $cQmXV.createElement((0, $3c3dcff9373b8341$export$2e2bcd8739ae039), {
            classNames: mergedClassNames,
            styles: mergedStyles,
            prefixCls: prefixCls,
            listType: listType,
            items: mergedFileList,
            previewFile: previewFile,
            onPreview: onPreview,
            onDownload: onDownload,
            onRemove: handleRemove,
            showRemoveIcon: realShowRemoveIcon,
            showPreviewIcon: showPreviewIcon,
            showDownloadIcon: showDownloadIcon,
            removeIcon: removeIcon,
            previewIcon: previewIcon,
            downloadIcon: downloadIcon,
            iconRender: iconRender,
            extra: extra,
            locale: {
                ...contextLocale,
                ...propLocale
            },
            isImageUrl: isImageUrl,
            progress: mergedProgress,
            appendAction: button,
            appendActionVisible: buttonVisible,
            itemRender: itemRender,
            disabled: mergedDisabled
        });
    };
    const mergedRootCls = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(wrapperCls, className, rootClassName, hashId, cssVarCls, contextClassName, mergedClassNames.root, {
        [`${prefixCls}-rtl`]: direction === "rtl",
        [`${prefixCls}-picture-card-wrapper`]: listType === "picture-card",
        [`${prefixCls}-picture-circle-wrapper`]: listType === "picture-circle"
    });
    const mergedRootStyle = {
        ...mergedStyles.root
    };
    // ======================== Render ========================
    if (type === "drag") {
        const dragCls = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(hashId, prefixCls, `${prefixCls}-drag`, {
            [`${prefixCls}-drag-uploading`]: mergedFileList.some((file)=>file.status === "uploading"),
            [`${prefixCls}-drag-hover`]: dragState === "dragover",
            [`${prefixCls}-disabled`]: mergedDisabled,
            [`${prefixCls}-rtl`]: direction === "rtl"
        }, mergedClassNames.trigger);
        return /*#__PURE__*/ $cQmXV.createElement("span", {
            className: mergedRootCls,
            ref: wrapRef,
            style: mergedRootStyle
        }, /*#__PURE__*/ $cQmXV.createElement("div", {
            className: dragCls,
            style: mergedStyles.trigger,
            onDrop: onFileDrop,
            onDragOver: onFileDrop,
            onDragLeave: onFileDrop
        }, /*#__PURE__*/ $cQmXV.createElement((0, $80f406473f616ccd$export$2e2bcd8739ae039), {
            ...rcUploadProps,
            ref: uploadRef,
            className: `${prefixCls}-btn`
        }, /*#__PURE__*/ $cQmXV.createElement("div", {
            className: `${prefixCls}-drag-container`
        }, children))), renderUploadList());
    }
    const uploadBtnCls = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-select`, {
        [`${prefixCls}-disabled`]: mergedDisabled,
        [`${prefixCls}-hidden`]: !children
    }, mergedClassNames.trigger);
    const uploadButton = /*#__PURE__*/ $cQmXV.createElement("div", {
        className: uploadBtnCls,
        style: mergedStyles.trigger
    }, /*#__PURE__*/ $cQmXV.createElement((0, $80f406473f616ccd$export$2e2bcd8739ae039), {
        ...rcUploadProps,
        ref: uploadRef
    }));
    if (listType === "picture-card" || listType === "picture-circle") return /*#__PURE__*/ $cQmXV.createElement("span", {
        className: mergedRootCls,
        ref: wrapRef,
        style: mergedRootStyle
    }, renderUploadList(uploadButton, !!children));
    return /*#__PURE__*/ $cQmXV.createElement("span", {
        className: mergedRootCls,
        ref: wrapRef,
        style: mergedRootStyle
    }, uploadButton, renderUploadList());
};
const $5095ff83a2fe54e7$var$Upload = /*#__PURE__*/ $cQmXV.forwardRef($5095ff83a2fe54e7$var$InternalUpload);
var $5095ff83a2fe54e7$export$2e2bcd8739ae039 = $5095ff83a2fe54e7$var$Upload;


"use client";
const $3b06740eff11d1ec$var$Dragger = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { style: style, height: height, hasControlInside: hasControlInside = false, children: children, ...restProps } = props;
    const mergedStyle = {
        ...style,
        height: height
    };
    return /*#__PURE__*/ $cQmXV.createElement((0, $5095ff83a2fe54e7$export$2e2bcd8739ae039), {
        ref: ref,
        hasControlInside: hasControlInside,
        ...restProps,
        style: mergedStyle,
        type: "drag"
    }, children);
});
var $3b06740eff11d1ec$export$2e2bcd8739ae039 = $3b06740eff11d1ec$var$Dragger;



"use client";
const $b615b6e60c753ce5$var$Upload = (0, $5095ff83a2fe54e7$export$2e2bcd8739ae039);
$b615b6e60c753ce5$var$Upload.Dragger = (0, $3b06740eff11d1ec$export$2e2bcd8739ae039);
$b615b6e60c753ce5$var$Upload.LIST_IGNORE = (0, $5095ff83a2fe54e7$export$8f9bb9ff126b1bf5);
var $b615b6e60c753ce5$export$2e2bcd8739ae039 = $b615b6e60c753ce5$var$Upload;



var $cQmXV = parcelRequire("cQmXV");
var $56adfe55419a56fe$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($56adfe55419a56fe$exports, "__esModule", {
    value: true
});
var $56adfe55419a56fe$var$FilePdfOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M531.3 574.4l.3-1.4c5.8-23.9 13.1-53.7 7.4-80.7-3.8-21.3-19.5-29.6-32.9-30.2-15.8-.7-29.9 8.3-33.4 21.4-6.6 24-.7 56.8 10.1 98.6-13.6 32.4-35.3 79.5-51.2 107.5-29.6 15.3-69.3 38.9-75.2 68.7-1.2 5.5.2 12.5 3.5 18.8 3.7 7 9.6 12.4 16.5 15 3 1.1 6.6 2 10.8 2 17.6 0 46.1-14.2 84.1-79.4 5.8-1.9 11.8-3.9 17.6-5.9 27.2-9.2 55.4-18.8 80.9-23.1 28.2 15.1 60.3 24.8 82.1 24.8 21.6 0 30.1-12.8 33.3-20.5 5.6-13.5 2.9-30.5-6.2-39.6-13.2-13-45.3-16.4-95.3-10.2-24.6-15-40.7-35.4-52.4-65.8zM421.6 726.3c-13.9 20.2-24.4 30.3-30.1 34.7 6.7-12.3 19.8-25.3 30.1-34.7zm87.6-235.5c5.2 8.9 4.5 35.8.5 49.4-4.9-19.9-5.6-48.1-2.7-51.4.8.1 1.5.7 2.2 2zm-1.6 120.5c10.7 18.5 24.2 34.4 39.1 46.2-21.6 4.9-41.3 13-58.9 20.2-4.2 1.7-8.3 3.4-12.3 5 13.3-24.1 24.4-51.4 32.1-71.4zm155.6 65.5c.1.2.2.5-.4.9h-.2l-.2.3c-.8.5-9 5.3-44.3-8.6 40.6-1.9 45 7.3 45.1 7.4zm191.4-388.2L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494z"
                }
            }
        ]
    },
    "name": "file-pdf",
    "theme": "outlined"
};
$56adfe55419a56fe$exports.default = $56adfe55419a56fe$var$FilePdfOutlined;



function $48c531267acac240$var$_extends() {
    $48c531267acac240$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $48c531267acac240$var$_extends.apply(this, arguments);
}
const $48c531267acac240$var$FilePdfOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $48c531267acac240$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($56adfe55419a56fe$exports)))
    }));
/**![file-pdf](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUzMS4zIDU3NC40bC4zLTEuNGM1LjgtMjMuOSAxMy4xLTUzLjcgNy40LTgwLjctMy44LTIxLjMtMTkuNS0yOS42LTMyLjktMzAuMi0xNS44LS43LTI5LjkgOC4zLTMzLjQgMjEuNC02LjYgMjQtLjcgNTYuOCAxMC4xIDk4LjYtMTMuNiAzMi40LTM1LjMgNzkuNS01MS4yIDEwNy41LTI5LjYgMTUuMy02OS4zIDM4LjktNzUuMiA2OC43LTEuMiA1LjUuMiAxMi41IDMuNSAxOC44IDMuNyA3IDkuNiAxMi40IDE2LjUgMTUgMyAxLjEgNi42IDIgMTAuOCAyIDE3LjYgMCA0Ni4xLTE0LjIgODQuMS03OS40IDUuOC0xLjkgMTEuOC0zLjkgMTcuNi01LjkgMjcuMi05LjIgNTUuNC0xOC44IDgwLjktMjMuMSAyOC4yIDE1LjEgNjAuMyAyNC44IDgyLjEgMjQuOCAyMS42IDAgMzAuMS0xMi44IDMzLjMtMjAuNSA1LjYtMTMuNSAyLjktMzAuNS02LjItMzkuNi0xMy4yLTEzLTQ1LjMtMTYuNC05NS4zLTEwLjItMjQuNi0xNS00MC43LTM1LjQtNTIuNC02NS44ek00MjEuNiA3MjYuM2MtMTMuOSAyMC4yLTI0LjQgMzAuMy0zMC4xIDM0LjcgNi43LTEyLjMgMTkuOC0yNS4zIDMwLjEtMzQuN3ptODcuNi0yMzUuNWM1LjIgOC45IDQuNSAzNS44LjUgNDkuNC00LjktMTkuOS01LjYtNDguMS0yLjctNTEuNC44LjEgMS41LjcgMi4yIDJ6bS0xLjYgMTIwLjVjMTAuNyAxOC41IDI0LjIgMzQuNCAzOS4xIDQ2LjItMjEuNiA0LjktNDEuMyAxMy01OC45IDIwLjItNC4yIDEuNy04LjMgMy40LTEyLjMgNSAxMy4zLTI0LjEgMjQuNC01MS40IDMyLjEtNzEuNHptMTU1LjYgNjUuNWMuMS4yLjIuNS0uNC45aC0uMmwtLjIuM2MtLjguNS05IDUuMy00NC4zLTguNiA0MC42LTEuOSA0NSA3LjMgNDUuMSA3LjR6bTE5MS40LTM4OC4yTDYzOS40IDczLjRjLTYtNi0xNC4xLTkuNC0yMi42LTkuNEgxOTJjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjgzMmMwIDE3LjcgMTQuMyAzMiAzMiAzMmg2NDBjMTcuNyAwIDMyLTE0LjMgMzItMzJWMzExLjNjMC04LjUtMy40LTE2LjctOS40LTIyLjd6TTc5MC4yIDMyNkg2MDJWMTM3LjhMNzkwLjIgMzI2em0xLjggNTYySDIzMlYxMzZoMzAydjIxNmE0MiA0MiAwIDAwNDIgNDJoMjE2djQ5NHoiIC8+PC9zdmc+) */ const $48c531267acac240$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($48c531267acac240$var$FilePdfOutlined);
var $48c531267acac240$export$2e2bcd8739ae039 = $48c531267acac240$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $2eb74e890a4f6e36$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($2eb74e890a4f6e36$exports, "__esModule", {
    value: true
});
var $2eb74e890a4f6e36$var$FileWordOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494zM528.1 472h-32.2c-5.5 0-10.3 3.7-11.6 9.1L434.6 680l-46.1-198.7c-1.3-5.4-6.1-9.3-11.7-9.3h-35.4a12.02 12.02 0 00-11.6 15.1l74.2 276c1.4 5.2 6.2 8.9 11.6 8.9h32c5.4 0 10.2-3.6 11.6-8.9l52.8-197 52.8 197c1.4 5.2 6.2 8.9 11.6 8.9h31.8c5.4 0 10.2-3.6 11.6-8.9l74.4-276a12.04 12.04 0 00-11.6-15.1H647c-5.6 0-10.4 3.9-11.7 9.3l-45.8 199.1-49.8-199.3c-1.3-5.4-6.1-9.1-11.6-9.1z"
                }
            }
        ]
    },
    "name": "file-word",
    "theme": "outlined"
};
$2eb74e890a4f6e36$exports.default = $2eb74e890a4f6e36$var$FileWordOutlined;



function $bff3f28c90294548$var$_extends() {
    $bff3f28c90294548$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bff3f28c90294548$var$_extends.apply(this, arguments);
}
const $bff3f28c90294548$var$FileWordOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $bff3f28c90294548$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2eb74e890a4f6e36$exports)))
    }));
/**![file-word](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg1NC42IDI4OC42TDYzOS40IDczLjRjLTYtNi0xNC4xLTkuNC0yMi42LTkuNEgxOTJjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjgzMmMwIDE3LjcgMTQuMyAzMiAzMiAzMmg2NDBjMTcuNyAwIDMyLTE0LjMgMzItMzJWMzExLjNjMC04LjUtMy40LTE2LjctOS40LTIyLjd6TTc5MC4yIDMyNkg2MDJWMTM3LjhMNzkwLjIgMzI2em0xLjggNTYySDIzMlYxMzZoMzAydjIxNmE0MiA0MiAwIDAwNDIgNDJoMjE2djQ5NHpNNTI4LjEgNDcyaC0zMi4yYy01LjUgMC0xMC4zIDMuNy0xMS42IDkuMUw0MzQuNiA2ODBsLTQ2LjEtMTk4LjdjLTEuMy01LjQtNi4xLTkuMy0xMS43LTkuM2gtMzUuNGExMi4wMiAxMi4wMiAwIDAwLTExLjYgMTUuMWw3NC4yIDI3NmMxLjQgNS4yIDYuMiA4LjkgMTEuNiA4LjloMzJjNS40IDAgMTAuMi0zLjYgMTEuNi04LjlsNTIuOC0xOTcgNTIuOCAxOTdjMS40IDUuMiA2LjIgOC45IDExLjYgOC45aDMxLjhjNS40IDAgMTAuMi0zLjYgMTEuNi04LjlsNzQuNC0yNzZhMTIuMDQgMTIuMDQgMCAwMC0xMS42LTE1LjFINjQ3Yy01LjYgMC0xMC40IDMuOS0xMS43IDkuM2wtNDUuOCAxOTkuMS00OS44LTE5OS4zYy0xLjMtNS40LTYuMS05LjEtMTEuNi05LjF6IiAvPjwvc3ZnPg==) */ const $bff3f28c90294548$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($bff3f28c90294548$var$FileWordOutlined);
var $bff3f28c90294548$export$2e2bcd8739ae039 = $bff3f28c90294548$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $bfd3ba8fc03224c4$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($bfd3ba8fc03224c4$exports, "__esModule", {
    value: true
});
var $bfd3ba8fc03224c4$var$FileExcelOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494zM514.1 580.1l-61.8-102.4c-2.2-3.6-6.1-5.8-10.3-5.8h-38.4c-2.3 0-4.5.6-6.4 1.9-5.6 3.5-7.3 10.9-3.7 16.6l82.3 130.4-83.4 132.8a12.04 12.04 0 0010.2 18.4h34.5c4.2 0 8-2.2 10.2-5.7L510 664.8l62.3 101.4c2.2 3.6 6.1 5.7 10.2 5.7H620c2.3 0 4.5-.7 6.5-1.9 5.6-3.6 7.2-11 3.6-16.6l-84-130.4 85.3-132.5a12.04 12.04 0 00-10.1-18.5h-35.7c-4.2 0-8.1 2.2-10.3 5.8l-61.2 102.3z"
                }
            }
        ]
    },
    "name": "file-excel",
    "theme": "outlined"
};
$bfd3ba8fc03224c4$exports.default = $bfd3ba8fc03224c4$var$FileExcelOutlined;



function $3e7ed8d791051c11$var$_extends() {
    $3e7ed8d791051c11$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3e7ed8d791051c11$var$_extends.apply(this, arguments);
}
const $3e7ed8d791051c11$var$FileExcelOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $3e7ed8d791051c11$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bfd3ba8fc03224c4$exports)))
    }));
/**![file-excel](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg1NC42IDI4OC42TDYzOS40IDczLjRjLTYtNi0xNC4xLTkuNC0yMi42LTkuNEgxOTJjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjgzMmMwIDE3LjcgMTQuMyAzMiAzMiAzMmg2NDBjMTcuNyAwIDMyLTE0LjMgMzItMzJWMzExLjNjMC04LjUtMy40LTE2LjctOS40LTIyLjd6TTc5MC4yIDMyNkg2MDJWMTM3LjhMNzkwLjIgMzI2em0xLjggNTYySDIzMlYxMzZoMzAydjIxNmE0MiA0MiAwIDAwNDIgNDJoMjE2djQ5NHpNNTE0LjEgNTgwLjFsLTYxLjgtMTAyLjRjLTIuMi0zLjYtNi4xLTUuOC0xMC4zLTUuOGgtMzguNGMtMi4zIDAtNC41LjYtNi40IDEuOS01LjYgMy41LTcuMyAxMC45LTMuNyAxNi42bDgyLjMgMTMwLjQtODMuNCAxMzIuOGExMi4wNCAxMi4wNCAwIDAwMTAuMiAxOC40aDM0LjVjNC4yIDAgOC0yLjIgMTAuMi01LjdMNTEwIDY2NC44bDYyLjMgMTAxLjRjMi4yIDMuNiA2LjEgNS43IDEwLjIgNS43SDYyMGMyLjMgMCA0LjUtLjcgNi41LTEuOSA1LjYtMy42IDcuMi0xMSAzLjYtMTYuNmwtODQtMTMwLjQgODUuMy0xMzIuNWExMi4wNCAxMi4wNCAwIDAwLTEwLjEtMTguNWgtMzUuN2MtNC4yIDAtOC4xIDIuMi0xMC4zIDUuOGwtNjEuMiAxMDIuM3oiIC8+PC9zdmc+) */ const $3e7ed8d791051c11$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($3e7ed8d791051c11$var$FileExcelOutlined);
var $3e7ed8d791051c11$export$2e2bcd8739ae039 = $3e7ed8d791051c11$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $d31d7a5476c882c9$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($d31d7a5476c882c9$exports, "__esModule", {
    value: true
});
var $d31d7a5476c882c9$var$FileImageOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M553.1 509.1l-77.8 99.2-41.1-52.4a8 8 0 00-12.6 0l-99.8 127.2a7.98 7.98 0 006.3 12.9H696c6.7 0 10.4-7.7 6.3-12.9l-136.5-174a8.1 8.1 0 00-12.7 0zM360 442a40 40 0 1080 0 40 40 0 10-80 0zm494.6-153.4L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494z"
                }
            }
        ]
    },
    "name": "file-image",
    "theme": "outlined"
};
$d31d7a5476c882c9$exports.default = $d31d7a5476c882c9$var$FileImageOutlined;



function $c3b8d7d247171904$var$_extends() {
    $c3b8d7d247171904$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c3b8d7d247171904$var$_extends.apply(this, arguments);
}
const $c3b8d7d247171904$var$FileImageOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $c3b8d7d247171904$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d31d7a5476c882c9$exports)))
    }));
/**![file-image](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTU1My4xIDUwOS4xbC03Ny44IDk5LjItNDEuMS01Mi40YTggOCAwIDAwLTEyLjYgMGwtOTkuOCAxMjcuMmE3Ljk4IDcuOTggMCAwMDYuMyAxMi45SDY5NmM2LjcgMCAxMC40LTcuNyA2LjMtMTIuOWwtMTM2LjUtMTc0YTguMSA4LjEgMCAwMC0xMi43IDB6TTM2MCA0NDJhNDAgNDAgMCAxMDgwIDAgNDAgNDAgMCAxMC04MCAwem00OTQuNi0xNTMuNEw2MzkuNCA3My40Yy02LTYtMTQuMS05LjQtMjIuNi05LjRIMTkyYy0xNy43IDAtMzIgMTQuMy0zMiAzMnY4MzJjMCAxNy43IDE0LjMgMzIgMzIgMzJoNjQwYzE3LjcgMCAzMi0xNC4zIDMyLTMyVjMxMS4zYzAtOC41LTMuNC0xNi43LTkuNC0yMi43ek03OTAuMiAzMjZINjAyVjEzNy44TDc5MC4yIDMyNnptMS44IDU2MkgyMzJWMTM2aDMwMnYyMTZhNDIgNDIgMCAwMDQyIDQyaDIxNnY0OTR6IiAvPjwvc3ZnPg==) */ const $c3b8d7d247171904$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($c3b8d7d247171904$var$FileImageOutlined);
var $c3b8d7d247171904$export$2e2bcd8739ae039 = $c3b8d7d247171904$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $f3201d48cecf0a22$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($f3201d48cecf0a22$exports, "__esModule", {
    value: true
});
var $f3201d48cecf0a22$var$FileZipOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M296 392h64v64h-64zm0 190v160h128V582h-64v-62h-64v62zm80 48v64h-32v-64h32zm-16-302h64v64h-64zm-64-64h64v64h-64zm64 192h64v64h-64zm0-256h64v64h-64zm494.6 88.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h64v64h64v-64h174v216a42 42 0 0042 42h216v494z"
                }
            }
        ]
    },
    "name": "file-zip",
    "theme": "outlined"
};
$f3201d48cecf0a22$exports.default = $f3201d48cecf0a22$var$FileZipOutlined;



function $e69ab3e85be6c099$var$_extends() {
    $e69ab3e85be6c099$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e69ab3e85be6c099$var$_extends.apply(this, arguments);
}
const $e69ab3e85be6c099$var$FileZipOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $e69ab3e85be6c099$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($f3201d48cecf0a22$exports)))
    }));
/**![file-zip](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTI5NiAzOTJoNjR2NjRoLTY0em0wIDE5MHYxNjBoMTI4VjU4MmgtNjR2LTYyaC02NHY2MnptODAgNDh2NjRoLTMydi02NGgzMnptLTE2LTMwMmg2NHY2NGgtNjR6bS02NC02NGg2NHY2NGgtNjR6bTY0IDE5Mmg2NHY2NGgtNjR6bTAtMjU2aDY0djY0aC02NHptNDk0LjYgODguNkw2MzkuNCA3My40Yy02LTYtMTQuMS05LjQtMjIuNi05LjRIMTkyYy0xNy43IDAtMzIgMTQuMy0zMiAzMnY4MzJjMCAxNy43IDE0LjMgMzIgMzIgMzJoNjQwYzE3LjcgMCAzMi0xNC4zIDMyLTMyVjMxMS4zYzAtOC41LTMuNC0xNi43LTkuNC0yMi43ek03OTAuMiAzMjZINjAyVjEzNy44TDc5MC4yIDMyNnptMS44IDU2MkgyMzJWMTM2aDY0djY0aDY0di02NGgxNzR2MjE2YTQyIDQyIDAgMDA0MiA0MmgyMTZ2NDk0eiIgLz48L3N2Zz4=) */ const $e69ab3e85be6c099$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($e69ab3e85be6c099$var$FileZipOutlined);
var $e69ab3e85be6c099$export$2e2bcd8739ae039 = $e69ab3e85be6c099$var$RefIcon;



/* FilterChips — the row of active-filter pills under a filter card.
 *
 * Every redesigned list page draws the same thing (`docs/design/photo-review.html`,
 * `visits.html`): one `<Tag closable>` per applied filter, reading `Label: value`, and clicking
 * the × clears that one filter. It is a component rather than a copied block because the pill
 * shape and the brand tint are not something antd's `<Tag>` can express — its own `color`
 * presets are the status palette, which this is not — so a second copy would mean a second
 * definition of those styles going out of sync.
 *
 * ```jsx
 * const { remember, nameFor } = useLabelCache();
 * <FilterChips items={chips} onClose={clearChip} closeLabel={t("a_remove_filter")} />
 * ```
 */ 

var $cQmXV = parcelRequire("cQmXV");



const $a9e321bb60aaf998$var$idOf = (v)=>v && typeof v === "object" ? v.id ?? v.value : v;
function $a9e321bb60aaf998$export$243aa1fcbfd1886a(persistKey) {
    /* ⚠ Optionally PERSISTED, because component state alone dies on unmount and takes every chip's
     label with it. Navigating from a filtered list to another page and back left the filter state
     restored (that lives in sessionStorage) beside an empty cache, so the chip rendered its raw id —
     "Точки: 11" where the outlet's name had been, and a refresh could not fix it because the filter
     itself survived (PICSELL-1574 #11). The names have to be as durable as the filters they label.
     Opt-in: a caller passes a key, and lists that do not are unchanged. */ const [labels, setLabels] = (0, $cQmXV.useState)(()=>{
        if (!persistKey) return {};
        try {
            return JSON.parse(sessionStorage.getItem(persistKey) || "{}") || {};
        } catch (_) {
            return {};
        }
    });
    (0, $cQmXV.useEffect)(()=>{
        if (!persistKey) return;
        try {
            sessionStorage.setItem(persistKey, JSON.stringify(labels));
        } catch (_) {
        /* storage unavailable (private mode) — chips fall back to ids, as before */ }
    }, [
        persistKey,
        labels
    ]);
    const remember = (0, $cQmXV.useCallback)((key)=>(list)=>setLabels((prev)=>{
                const next = {
                    ...prev
                };
                let changed = false;
                (list || []).forEach((option)=>{
                    const cacheKey = `${key}:${$a9e321bb60aaf998$var$idOf(option)}`;
                    const name = option && typeof option === "object" ? option.label || option.name : null;
                    if (name && next[cacheKey] !== name) {
                        next[cacheKey] = name;
                        changed = true;
                    }
                });
                return changed ? next : prev;
            }), []);
    /* ⚠ The first step must only accept an OBJECT's own name. A bare id is a truthy non-object, so
     a `nameOf`-style helper that returns non-objects unchanged short-circuits the `||` and the
     cache is never consulted. */ const cache = (0, $cQmXV.useRef)(labels);
    cache.current = labels;
    const nameFor = (0, $cQmXV.useCallback)((key, value)=>{
        const own = value && typeof value === "object" ? value.label || value.name : null;
        return own || cache.current[`${key}:${$a9e321bb60aaf998$var$idOf(value)}`] || String($a9e321bb60aaf998$var$idOf(value) ?? "");
    }, []);
    return {
        labels: labels,
        remember: remember,
        nameFor: nameFor
    };
}
function $a9e321bb60aaf998$export$2e2bcd8739ae039({ items: items, onClose: onClose, closeLabel: closeLabel, className: className = "" }) {
    if (!items?.length) return null;
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
        className: `fchips ${className}`,
        gap: "small",
        wrap: true,
        flex: "1",
        children: items.map((chip)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $602120e6d17ff12a$export$2e2bcd8739ae039), {
                className: "fchip",
                closable: true,
                closeIcon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $837faca566926e3c$export$2e2bcd8739ae039), {
                    "aria-label": closeLabel
                }),
                onClose: ()=>onClose(chip.key, chip.id),
                children: [
                    chip.label,
                    ": ",
                    chip.value
                ]
            }, `${chip.key}-${chip.id ?? chip.value}`))
    });
}


/* Table cell primitives and the table footer — the parts every redesigned table draws the same
 * way, in one place.
 *
 * They were three copies before this: the visits list, the supervisors list and the supervisor
 * detail's tabs each had their own status glyph, their own avatar-plus-name cell, their own
 * two-line title cell and their own rows-per-page footer. The copies drifted — the detail's team
 * table showed status as a *word* where both lists show the status ICON, its name cell was not
 * bold where the lists' are, and its row action was a bare trash button where the lists use a
 * `MoreOutlined` menu. Three tables of the same records did not look like the same product.
 *
 * The styles live in `component/list-page.scss` (`lp-*`), which is imported once from
 * `src/index.js` — see the note there about why `@use` per page is wrong.
 *
 * Everything here is presentational. Columns still belong to the page: only the page knows what
 * its records mean.
 */ 

var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");











var $cQmXV = parcelRequire("cQmXV");
const $84a97bd0e40c4727$var$AvatarContext = /*#__PURE__*/ $cQmXV.createContext({});
var $84a97bd0e40c4727$export$2e2bcd8739ae039 = $84a97bd0e40c4727$var$AvatarContext;





const $d0b17755fc351781$var$genBaseStyle = (token)=>{
    const { antCls: antCls, componentCls: componentCls, iconCls: iconCls, avatarBg: avatarBg, avatarColor: avatarColor, containerSize: containerSize, containerSizeLG: containerSizeLG, containerSizeSM: containerSizeSM, textFontSize: textFontSize, textFontSizeLG: textFontSizeLG, textFontSizeSM: textFontSizeSM, iconFontSize: iconFontSize, iconFontSizeLG: iconFontSizeLG, iconFontSizeSM: iconFontSizeSM, borderRadius: borderRadius, borderRadiusLG: borderRadiusLG, borderRadiusSM: borderRadiusSM, lineWidth: lineWidth, lineType: lineType } = token;
    // Avatar size style
    const avatarSizeStyle = (size, fontSize, iconFontSize, radius)=>({
            width: size,
            height: size,
            borderRadius: "50%",
            fontSize: fontSize,
            [`&${componentCls}-square`]: {
                borderRadius: radius
            },
            [`&${componentCls}-icon`]: {
                fontSize: iconFontSize,
                [`> ${iconCls}`]: {
                    margin: 0
                }
            }
        });
    return {
        [componentCls]: {
            ...(0, $519d20bf207ce864$export$23997c3e44cc1c59)(token),
            position: "relative",
            display: "inline-flex",
            justifyContent: "center",
            alignItems: "center",
            overflow: "hidden",
            color: avatarColor,
            whiteSpace: "nowrap",
            textAlign: "center",
            verticalAlign: "middle",
            background: avatarBg,
            border: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(lineWidth)} ${lineType} transparent`,
            "&-image": {
                background: "transparent"
            },
            [`${antCls}-image-img`]: {
                display: "block"
            },
            ...avatarSizeStyle(containerSize, textFontSize, iconFontSize, borderRadius),
            "&-lg": {
                ...avatarSizeStyle(containerSizeLG, textFontSizeLG, iconFontSizeLG, borderRadiusLG)
            },
            "&-sm": {
                ...avatarSizeStyle(containerSizeSM, textFontSizeSM, iconFontSizeSM, borderRadiusSM)
            },
            "> img": {
                display: "block",
                width: "100%",
                height: "100%",
                objectFit: "cover"
            }
        }
    };
};
const $d0b17755fc351781$var$genGroupStyle = (token)=>{
    const { componentCls: componentCls, groupBorderColor: groupBorderColor, groupOverlapping: groupOverlapping, groupSpace: groupSpace } = token;
    return {
        [`${componentCls}-group`]: {
            display: "inline-flex",
            [componentCls]: {
                borderColor: groupBorderColor
            },
            "> *:not(:first-child)": {
                marginInlineStart: groupOverlapping
            }
        },
        [`${componentCls}-group-popover`]: {
            [`${componentCls} + ${componentCls}`]: {
                marginInlineStart: groupSpace
            }
        }
    };
};
const $d0b17755fc351781$export$9ca1be8807fe0675 = (token)=>{
    const { controlHeight: controlHeight, controlHeightLG: controlHeightLG, controlHeightSM: controlHeightSM, fontSize: fontSize, fontSizeLG: fontSizeLG, fontSizeXL: fontSizeXL, fontSizeHeading3: fontSizeHeading3, marginXS: marginXS, marginXXS: marginXXS, colorBorderBg: colorBorderBg } = token;
    return {
        containerSize: controlHeight,
        containerSizeLG: controlHeightLG,
        containerSizeSM: controlHeightSM,
        textFontSize: fontSize,
        textFontSizeLG: fontSize,
        textFontSizeSM: fontSize,
        iconFontSize: Math.round((fontSizeLG + fontSizeXL) / 2),
        iconFontSizeLG: fontSizeHeading3,
        iconFontSizeSM: fontSize,
        groupSpace: marginXXS,
        groupOverlapping: -marginXS,
        groupBorderColor: colorBorderBg
    };
};
var $d0b17755fc351781$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$51ec95de45185b42)("Avatar", (token)=>{
    const { colorTextLightSolid: colorTextLightSolid, colorTextPlaceholder: colorTextPlaceholder } = token;
    const avatarToken = (0, $fef50f256b80dfa5$export$4950aa0f605343fb)(token, {
        avatarBg: colorTextPlaceholder,
        avatarColor: colorTextLightSolid
    });
    return [
        $d0b17755fc351781$var$genBaseStyle(avatarToken),
        $d0b17755fc351781$var$genGroupStyle(avatarToken)
    ];
}, $d0b17755fc351781$export$9ca1be8807fe0675);


"use client";
const $478a6c7f75a78a0f$var$Avatar = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, shape: shape, size: customSize, src: src, srcSet: srcSet, icon: icon, className: className, rootClassName: rootClassName, style: style, alt: alt, draggable: draggable, children: children, crossOrigin: crossOrigin, gap: gap = 4, onError: onError, ...others } = props;
    const [scale, setScale] = $cQmXV.useState(1);
    const [mounted, setMounted] = $cQmXV.useState(false);
    const [isImgExist, setIsImgExist] = $cQmXV.useState(true);
    const avatarNodeRef = $cQmXV.useRef(null);
    const avatarChildrenRef = $cQmXV.useRef(null);
    const avatarNodeMergedRef = (0, $10341b937b26f69d$export$ab452c34e8e05029)(ref, avatarNodeRef);
    const { getPrefixCls: getPrefixCls, className: contextClassName, style: contextStyle } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("avatar");
    const avatarCtx = $cQmXV.useContext((0, $84a97bd0e40c4727$export$2e2bcd8739ae039));
    const setScaleParam = ()=>{
        if (!avatarChildrenRef.current || !avatarNodeRef.current) return;
        const childrenWidth = avatarChildrenRef.current.offsetWidth; // offsetWidth avoid affecting be transform scale
        const nodeWidth = avatarNodeRef.current.offsetWidth;
        // denominator is 0 is no meaning
        if (childrenWidth !== 0 && nodeWidth !== 0) {
            if (gap * 2 < nodeWidth) setScale(nodeWidth - gap * 2 < childrenWidth ? (nodeWidth - gap * 2) / childrenWidth : 1);
        }
    };
    $cQmXV.useEffect(()=>{
        setMounted(true);
    }, []);
    $cQmXV.useEffect(()=>{
        setIsImgExist(true);
        setScale(1);
    }, [
        src
    ]);
    $cQmXV.useEffect(setScaleParam, [
        gap
    ]);
    const handleImgLoadError = ()=>{
        const errorFlag = onError?.();
        if (errorFlag !== false) setIsImgExist(false);
    };
    const size = (0, $78cdfb6138721329$export$2e2bcd8739ae039)((ctxSize)=>customSize ?? avatarCtx?.size ?? ctxSize ?? "medium");
    const needResponsive = Object.keys((0, $8e2d153a3c855782$export$53b83ca8eaab0383)(size) ? size || {} : {}).some((key)=>(0, $93a56f4fa79d4cc2$export$74c1bf8296b1541f).includes(key));
    const screens = (0, $27af0f2a794acde0$export$2e2bcd8739ae039)(needResponsive);
    const responsiveSizeStyle = $cQmXV.useMemo(()=>{
        if (!(0, $8e2d153a3c855782$export$53b83ca8eaab0383)(size)) return {};
        const currentBreakpoint = (0, $93a56f4fa79d4cc2$export$74c1bf8296b1541f).find((screen)=>screens[screen]);
        const currentSize = size[currentBreakpoint];
        return currentSize ? {
            width: currentSize,
            height: currentSize,
            fontSize: currentSize && (icon || children) ? currentSize / 2 : 18
        } : {};
    }, [
        screens,
        size,
        icon,
        children
    ]);
    const prefixCls = getPrefixCls("avatar", customizePrefixCls);
    const rootCls = (0, $2237081acd3cfc09$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $d0b17755fc351781$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const sizeCls = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)({
        [`${prefixCls}-lg`]: size === "large",
        [`${prefixCls}-sm`]: size === "small"
    });
    const hasImageElement = /*#__PURE__*/ $cQmXV.isValidElement(src);
    const mergedShape = shape || avatarCtx?.shape || "circle";
    const classString = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, sizeCls, contextClassName, `${prefixCls}-${mergedShape}`, {
        [`${prefixCls}-image`]: hasImageElement || src && isImgExist,
        [`${prefixCls}-icon`]: !!icon
    }, cssVarCls, rootCls, className, rootClassName, hashId);
    const sizeStyle = (0, $8e2d153a3c855782$export$7e4aa119212bc614)(size) ? {
        width: size,
        height: size,
        fontSize: icon ? size / 2 : 18
    } : {};
    let childrenToRender;
    if (typeof src === "string" && isImgExist) childrenToRender = /*#__PURE__*/ $cQmXV.createElement("img", {
        src: src,
        draggable: draggable,
        srcSet: srcSet,
        onError: handleImgLoadError,
        alt: alt,
        crossOrigin: crossOrigin
    });
    else if (hasImageElement) childrenToRender = src;
    else if (icon) childrenToRender = icon;
    else if (mounted || scale !== 1) {
        const transformString = `scale(${scale})`;
        const childrenStyle = {
            msTransform: transformString,
            WebkitTransform: transformString,
            transform: transformString
        };
        childrenToRender = /*#__PURE__*/ $cQmXV.createElement((0, $1d6306c05e604045$export$2e2bcd8739ae039), {
            onResize: setScaleParam
        }, /*#__PURE__*/ $cQmXV.createElement("span", {
            className: `${prefixCls}-string`,
            ref: avatarChildrenRef,
            style: childrenStyle
        }, children));
    } else childrenToRender = /*#__PURE__*/ $cQmXV.createElement("span", {
        className: `${prefixCls}-string`,
        style: {
            opacity: 0
        },
        ref: avatarChildrenRef
    }, children);
    return /*#__PURE__*/ $cQmXV.createElement("span", {
        ...others,
        style: {
            ...sizeStyle,
            ...responsiveSizeStyle,
            ...contextStyle,
            ...style
        },
        className: classString,
        ref: avatarNodeMergedRef
    }, childrenToRender);
});
var $478a6c7f75a78a0f$export$2e2bcd8739ae039 = $478a6c7f75a78a0f$var$Avatar;



var $cQmXV = parcelRequire("cQmXV");







var $cQmXV = parcelRequire("cQmXV");



const $6b33481525a35462$export$15e5fca53711d340 = (propValue)=>{
    if (!(0, $8e2d153a3c855782$export$72280d5f896dac9a)(propValue)) return null;
    return (0, $8e2d153a3c855782$export$f6e2535fb5126e54)(propValue) ? propValue() : propValue;
};










var $cQmXV = parcelRequire("cQmXV");












const $440d17b3f5384f8f$var$FALL_BACK_ORIGIN = "50%";
const $440d17b3f5384f8f$var$genBaseStyle = (token)=>{
    const { componentCls: componentCls, popoverColor: popoverColor, titleMinWidth: titleMinWidth, fontWeightStrong: fontWeightStrong, innerPadding: innerPadding, dropShadowPopover: dropShadowPopover, colorTextHeading: colorTextHeading, borderRadiusLG: borderRadiusLG, zIndexPopup: zIndexPopup, titleMarginBottom: titleMarginBottom, colorBgElevated: colorBgElevated, popoverBg: popoverBg, titleBorderBottom: titleBorderBottom, innerContentPadding: innerContentPadding, titlePadding: titlePadding, antCls: antCls } = token;
    const [varName, varRef] = (0, $6870d4d7c14ae0bb$export$d82b8f66c5649e14)(antCls, "tooltip");
    return [
        {
            [componentCls]: {
                ...(0, $519d20bf207ce864$export$23997c3e44cc1c59)(token),
                position: "absolute",
                top: 0,
                // use `left` to fix https://github.com/ant-design/ant-design/issues/39195
                left: {
                    _skip_check_: true,
                    value: 0
                },
                zIndex: zIndexPopup,
                fontWeight: "normal",
                whiteSpace: "normal",
                textAlign: "start",
                cursor: "auto",
                userSelect: "text",
                filter: dropShadowPopover,
                // When use `autoArrow`, origin will follow the arrow position
                [varName("valid-offset-x")]: varRef("arrow-offset-x", "var(--arrow-x)"),
                transformOrigin: [
                    varRef("valid-offset-x", $440d17b3f5384f8f$var$FALL_BACK_ORIGIN),
                    `var(--arrow-y, ${$440d17b3f5384f8f$var$FALL_BACK_ORIGIN})`
                ].join(" "),
                [varName("arrow-background-color")]: colorBgElevated,
                width: "max-content",
                maxWidth: "100vw",
                "&-rtl": {
                    direction: "rtl"
                },
                "&-hidden": {
                    display: "none"
                },
                [`${componentCls}-content`]: {
                    position: "relative"
                },
                [`${componentCls}-container`]: {
                    backgroundColor: popoverBg,
                    backgroundClip: "padding-box",
                    borderRadius: borderRadiusLG,
                    padding: innerPadding
                },
                [`${componentCls}-title`]: {
                    minWidth: titleMinWidth,
                    marginBottom: titleMarginBottom,
                    color: colorTextHeading,
                    fontWeight: fontWeightStrong,
                    borderBottom: titleBorderBottom,
                    padding: titlePadding
                },
                [`${componentCls}-content`]: {
                    color: popoverColor,
                    padding: innerContentPadding
                }
            }
        },
        // Arrow Style
        (0, $dc42b38f8ad9a4d1$export$2e2bcd8739ae039)(token, varRef("arrow-background-color"), {
            arrowShadow: false
        }),
        // Pure Render
        {
            [`${componentCls}-pure`]: {
                position: "relative",
                maxWidth: "none",
                margin: token.sizePopupArrow,
                display: "inline-block"
            }
        }
    ];
};
const $440d17b3f5384f8f$var$genColorStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    const [varName] = (0, $6870d4d7c14ae0bb$export$d82b8f66c5649e14)(antCls, "tooltip");
    return {
        [componentCls]: (0, $ade5e73b59dc3f96$export$6d4fe3a00a1811ad).map((colorKey)=>{
            const lightColor = token[`${colorKey}6`];
            return {
                [`&${componentCls}-${colorKey}`]: {
                    [varName("arrow-background-color")]: lightColor,
                    [`${componentCls}-inner`]: {
                        backgroundColor: lightColor
                    },
                    [`${componentCls}-arrow`]: {
                        background: "transparent"
                    }
                }
            };
        })
    };
};
const $440d17b3f5384f8f$export$9ca1be8807fe0675 = (token)=>{
    const { lineWidth: lineWidth, controlHeight: controlHeight, fontHeight: fontHeight, padding: padding, wireframe: wireframe, zIndexPopupBase: zIndexPopupBase, borderRadiusLG: borderRadiusLG, marginXS: marginXS, lineType: lineType, colorSplit: colorSplit, paddingSM: paddingSM } = token;
    const titlePaddingBlockDist = controlHeight - fontHeight;
    const popoverTitlePaddingBlockTop = titlePaddingBlockDist / 2;
    const popoverTitlePaddingBlockBottom = titlePaddingBlockDist / 2 - lineWidth;
    const popoverPaddingHorizontal = padding;
    return {
        titleMinWidth: 177,
        zIndexPopup: zIndexPopupBase + 30,
        ...(0, $e1e9e0ec17db0365$export$87e38ee403661ccc)(token),
        ...(0, $dc42b38f8ad9a4d1$export$bddc192327bb9823)({
            contentRadius: borderRadiusLG,
            limitVerticalRadius: true
        }),
        // internal
        innerPadding: wireframe ? 0 : 12,
        titleMarginBottom: wireframe ? 0 : marginXS,
        titlePadding: wireframe ? `${popoverTitlePaddingBlockTop}px ${popoverPaddingHorizontal}px ${popoverTitlePaddingBlockBottom}px` : 0,
        titleBorderBottom: wireframe ? `${lineWidth}px ${lineType} ${colorSplit}` : "none",
        innerContentPadding: wireframe ? `${paddingSM}px ${popoverPaddingHorizontal}px` : 0
    };
};
var $440d17b3f5384f8f$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$51ec95de45185b42)("Popover", (token)=>{
    const { colorBgElevated: colorBgElevated, colorText: colorText } = token;
    const popoverToken = (0, $fef50f256b80dfa5$export$4950aa0f605343fb)(token, {
        popoverBg: colorBgElevated,
        popoverColor: colorText
    });
    return [
        $440d17b3f5384f8f$var$genBaseStyle(popoverToken),
        $440d17b3f5384f8f$var$genColorStyle(popoverToken),
        (0, $35f7d6eebd10a5fe$export$f5d123412490d9dc)(popoverToken, "zoom-big")
    ];
}, $440d17b3f5384f8f$export$9ca1be8807fe0675, {
    resetStyle: false,
    deprecatedTokens: [
        [
            "width",
            "titleMinWidth"
        ],
        [
            "minWidth",
            "titleMinWidth"
        ]
    ]
});


"use client";
const $8ff13a211d3e959f$export$c6fdb837b070b4ff = (props)=>{
    const { title: title, content: content, prefixCls: prefixCls, classNames: classNames, styles: styles } = props;
    if (!(0, $8e2d153a3c855782$export$72280d5f896dac9a)(title) && !(0, $8e2d153a3c855782$export$72280d5f896dac9a)(content)) return null;
    return /*#__PURE__*/ $cQmXV.createElement($cQmXV.Fragment, null, (0, $8e2d153a3c855782$export$72280d5f896dac9a)(title) && /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-title`, classNames?.title),
        style: styles?.title
    }, title), (0, $8e2d153a3c855782$export$72280d5f896dac9a)(content) && /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-content`, classNames?.content),
        style: styles?.content
    }, content));
};
const $8ff13a211d3e959f$export$c40925af82c95d5b = (props)=>{
    const { hashId: hashId, prefixCls: prefixCls, className: className, style: style, placement: placement = "top", title: title, content: content, children: children, classNames: classNames, styles: styles } = props;
    const titleNode = (0, $6b33481525a35462$export$15e5fca53711d340)(title);
    const contentNode = (0, $6b33481525a35462$export$15e5fca53711d340)(content);
    const mergedProps = {
        ...props,
        placement: placement
    };
    const [mergedClassNames, mergedStyles] = (0, $30c5f9f911d4f61b$export$648566b068f28737)([
        classNames
    ], [
        styles
    ], {
        props: mergedProps
    });
    const rootClassName = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(hashId, prefixCls, `${prefixCls}-pure`, `${prefixCls}-placement-${placement}`, className);
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        className: rootClassName,
        style: style
    }, /*#__PURE__*/ $cQmXV.createElement("div", {
        className: `${prefixCls}-arrow`
    }), /*#__PURE__*/ $cQmXV.createElement((0, $0c7c49576d1200b8$export$2e2bcd8739ae039), {
        ...props,
        className: hashId,
        prefixCls: prefixCls,
        classNames: mergedClassNames,
        styles: mergedStyles
    }, children || /*#__PURE__*/ $cQmXV.createElement($8ff13a211d3e959f$export$c6fdb837b070b4ff, {
        prefixCls: prefixCls,
        title: titleNode,
        content: contentNode,
        classNames: mergedClassNames,
        styles: mergedStyles
    })));
};
const $8ff13a211d3e959f$var$PurePanel = (props)=>{
    const { prefixCls: customizePrefixCls, className: className, ...restProps } = props;
    const { getPrefixCls: getPrefixCls } = $cQmXV.useContext((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls("popover", customizePrefixCls);
    const [hashId, cssVarCls] = (0, $440d17b3f5384f8f$export$2e2bcd8739ae039)(prefixCls);
    return /*#__PURE__*/ $cQmXV.createElement($8ff13a211d3e959f$export$c40925af82c95d5b, {
        ...restProps,
        prefixCls: prefixCls,
        hashId: hashId,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(className, cssVarCls)
    });
};
var $8ff13a211d3e959f$export$2e2bcd8739ae039 = $8ff13a211d3e959f$var$PurePanel;



"use client";
const $81ac8d1f20faf53f$var$InternalPopover = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, title: title, content: content, overlayClassName: overlayClassName, placement: placement = "top", trigger: trigger, children: children, mouseEnterDelay: mouseEnterDelay, mouseLeaveDelay: mouseLeaveDelay, onOpenChange: onOpenChange, overlayStyle: overlayStyle = {}, styles: styles, classNames: classNames, motion: motion, arrow: popoverArrow, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles, arrow: contextArrow, trigger: contextTrigger, mouseEnterDelay: contextMouseEnterDelay, mouseLeaveDelay: contextMouseLeaveDelay } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("popover");
    const mergedMouseEnterDelay = mouseEnterDelay ?? contextMouseEnterDelay ?? 0.1;
    const mergedMouseLeaveDelay = mouseLeaveDelay ?? contextMouseLeaveDelay ?? 0.1;
    const prefixCls = getPrefixCls("popover", customizePrefixCls);
    const [hashId, cssVarCls] = (0, $440d17b3f5384f8f$export$2e2bcd8739ae039)(prefixCls);
    const rootPrefixCls = getPrefixCls();
    const mergedArrow = (0, $91d7bcfa626b18b0$export$2e2bcd8739ae039)(popoverArrow, contextArrow);
    const mergedTrigger = trigger || contextTrigger || "hover";
    // ============================= Styles =============================
    const mergedProps = {
        ...props,
        placement: placement,
        trigger: mergedTrigger,
        mouseEnterDelay: mergedMouseEnterDelay,
        mouseLeaveDelay: mergedMouseLeaveDelay,
        overlayStyle: overlayStyle,
        styles: styles,
        classNames: classNames
    };
    const contextStyleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(contextStyle);
    const overlayStyleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(overlayStyle);
    const [mergedClassNames, mergedStyles] = (0, $30c5f9f911d4f61b$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        overlayStyleRoot
    ], {
        props: mergedProps
    });
    const rootClassNames = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(overlayClassName, hashId, cssVarCls, contextClassName, mergedClassNames.root);
    const [open, setOpen] = (0, $a51866d781137e08$export$2e2bcd8739ae039)(props.defaultOpen ?? false, props.open);
    const settingOpen = (value)=>{
        setOpen(value);
        onOpenChange?.(value);
    };
    const titleNode = (0, $6b33481525a35462$export$15e5fca53711d340)(title);
    const contentNode = (0, $6b33481525a35462$export$15e5fca53711d340)(content);
    return /*#__PURE__*/ $cQmXV.createElement((0, $1e5256cf9d329b2c$export$2e2bcd8739ae039), {
        unique: false,
        arrow: mergedArrow,
        placement: placement,
        trigger: mergedTrigger,
        mouseEnterDelay: mergedMouseEnterDelay,
        mouseLeaveDelay: mergedMouseLeaveDelay,
        ...restProps,
        prefixCls: prefixCls,
        classNames: {
            root: rootClassNames,
            container: mergedClassNames.container,
            arrow: mergedClassNames.arrow
        },
        styles: {
            root: mergedStyles.root,
            container: mergedStyles.container,
            arrow: mergedStyles.arrow
        },
        ref: ref,
        open: open,
        onOpenChange: settingOpen,
        overlay: (0, $8e2d153a3c855782$export$72280d5f896dac9a)(titleNode) || (0, $8e2d153a3c855782$export$72280d5f896dac9a)(contentNode) ? /*#__PURE__*/ $cQmXV.createElement((0, $8ff13a211d3e959f$export$c6fdb837b070b4ff), {
            prefixCls: prefixCls,
            title: titleNode,
            content: contentNode,
            classNames: mergedClassNames,
            styles: mergedStyles
        }) : null,
        motion: {
            motionName: (0, $047a5f051ebda8ba$export$27c72201b1d09951)(rootPrefixCls, "zoom-big", typeof motion?.motionName === "string" ? motion?.motionName : undefined)
        },
        "data-popover-inject": true
    }, children);
});
const $81ac8d1f20faf53f$var$Popover = $81ac8d1f20faf53f$var$InternalPopover;
$81ac8d1f20faf53f$var$Popover._InternalPanelDoNotUseOrYouWillBeFired = (0, $8ff13a211d3e959f$export$2e2bcd8739ae039);
var $81ac8d1f20faf53f$export$2e2bcd8739ae039 = $81ac8d1f20faf53f$var$Popover;





"use client";
const $0659618d1f973078$var$AvatarContextProvider = (props)=>{
    const { size: size, shape: shape } = $cQmXV.useContext((0, $84a97bd0e40c4727$export$2e2bcd8739ae039));
    const avatarContextValue = $cQmXV.useMemo(()=>({
            size: props.size || size,
            shape: props.shape || shape
        }), [
        props.size,
        props.shape,
        size,
        shape
    ]);
    return /*#__PURE__*/ $cQmXV.createElement((0, $84a97bd0e40c4727$export$2e2bcd8739ae039).Provider, {
        value: avatarContextValue
    }, props.children);
};
const $0659618d1f973078$var$AvatarGroup = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { getPrefixCls: getPrefixCls, direction: direction } = $cQmXV.useContext((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, style: style, maxCount: maxCount, maxStyle: maxStyle, size: size, shape: shape, maxPopoverPlacement: maxPopoverPlacement, maxPopoverTrigger: maxPopoverTrigger, children: children, max: max } = props;
    var deprecatedName, newName;
    const prefixCls = getPrefixCls("avatar", customizePrefixCls);
    const groupPrefixCls = `${prefixCls}-group`;
    const rootCls = (0, $2237081acd3cfc09$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $d0b17755fc351781$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const cls = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(groupPrefixCls, {
        [`${groupPrefixCls}-rtl`]: direction === "rtl"
    }, cssVarCls, rootCls, className, rootClassName, hashId);
    const childrenWithProps = (0, $cd966a313e0a92ff$export$2e2bcd8739ae039)(children).map((child, index)=>(0, $a91ef204d03d8eec$export$e530037191fcd5d7)(child, {
            // eslint-disable-next-line react/no-array-index-key
            key: `avatar-key-${index}`
        }));
    const nativeElementRef = $cQmXV.useRef(null);
    $cQmXV.useImperativeHandle(ref, ()=>({
            nativeElement: nativeElementRef.current
        }));
    const mergeCount = max?.count || maxCount;
    const numOfChildren = childrenWithProps.length;
    if (mergeCount && mergeCount < numOfChildren) {
        const childrenShow = childrenWithProps.slice(0, mergeCount);
        const childrenHidden = childrenWithProps.slice(mergeCount, numOfChildren);
        const mergeStyle = max?.style || maxStyle;
        const mergePopoverTrigger = max?.popover?.trigger || maxPopoverTrigger || "hover";
        const mergePopoverPlacement = max?.popover?.placement || maxPopoverPlacement || "top";
        const popoverProps = {
            content: childrenHidden,
            ...max?.popover,
            placement: mergePopoverPlacement,
            trigger: mergePopoverTrigger,
            rootClassName: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${groupPrefixCls}-popover`, max?.popover?.rootClassName)
        };
        childrenShow.push(/*#__PURE__*/ $cQmXV.createElement((0, $81ac8d1f20faf53f$export$2e2bcd8739ae039), {
            key: "avatar-popover-key",
            destroyOnHidden: true,
            ...popoverProps
        }, /*#__PURE__*/ $cQmXV.createElement((0, $478a6c7f75a78a0f$export$2e2bcd8739ae039), {
            style: mergeStyle
        }, `+${numOfChildren - mergeCount}`)));
        return /*#__PURE__*/ $cQmXV.createElement($0659618d1f973078$var$AvatarContextProvider, {
            shape: shape,
            size: size
        }, /*#__PURE__*/ $cQmXV.createElement("div", {
            ref: nativeElementRef,
            className: cls,
            style: style
        }, childrenShow));
    }
    return /*#__PURE__*/ $cQmXV.createElement($0659618d1f973078$var$AvatarContextProvider, {
        shape: shape,
        size: size
    }, /*#__PURE__*/ $cQmXV.createElement("div", {
        ref: nativeElementRef,
        className: cls,
        style: style
    }, childrenWithProps));
});
var $0659618d1f973078$export$2e2bcd8739ae039 = $0659618d1f973078$var$AvatarGroup;


"use client";
const $72b7444d01b36e98$var$Avatar = (0, $478a6c7f75a78a0f$export$2e2bcd8739ae039);
$72b7444d01b36e98$var$Avatar.Group = (0, $0659618d1f973078$export$2e2bcd8739ae039);
var $72b7444d01b36e98$export$2e2bcd8739ae039 = $72b7444d01b36e98$var$Avatar;



var $cQmXV = parcelRequire("cQmXV");
var $868f99d9a6ff505d$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($868f99d9a6ff505d$exports, "__esModule", {
    value: true
});
var $868f99d9a6ff505d$var$MoreOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M456 231a56 56 0 10112 0 56 56 0 10-112 0zm0 280a56 56 0 10112 0 56 56 0 10-112 0zm0 280a56 56 0 10112 0 56 56 0 10-112 0z"
                }
            }
        ]
    },
    "name": "more",
    "theme": "outlined"
};
$868f99d9a6ff505d$exports.default = $868f99d9a6ff505d$var$MoreOutlined;



function $34f5362a86269156$var$_extends() {
    $34f5362a86269156$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $34f5362a86269156$var$_extends.apply(this, arguments);
}
const $34f5362a86269156$var$MoreOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $34f5362a86269156$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($868f99d9a6ff505d$exports)))
    }));
/**![more](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTQ1NiAyMzFhNTYgNTYgMCAxMDExMiAwIDU2IDU2IDAgMTAtMTEyIDB6bTAgMjgwYTU2IDU2IDAgMTAxMTIgMCA1NiA1NiAwIDEwLTExMiAwem0wIDI4MGE1NiA1NiAwIDEwMTEyIDAgNTYgNTYgMCAxMC0xMTIgMHoiIC8+PC9zdmc+) */ const $34f5362a86269156$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($34f5362a86269156$var$MoreOutlined);
var $34f5362a86269156$export$2e2bcd8739ae039 = $34f5362a86269156$var$RefIcon;


function $66539b2560a58e4e$export$f44b992e82788e9() {
    const cap = ()=>window.innerWidth > 900 ? "62vh" : undefined;
    const [scrollY, setScrollY] = (0, $cQmXV.useState)(cap);
    (0, $cQmXV.useEffect)(()=>{
        const onResize = ()=>setScrollY(cap());
        window.addEventListener("resize", onResize);
        return ()=>window.removeEventListener("resize", onResize);
    }, []);
    return scrollY;
}
const $66539b2560a58e4e$export$eb03490a10c3abc9 = /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
    className: "lp-dash",
    children: "\u2014"
});
const $66539b2560a58e4e$export$1d6cfa7493842c29 = (user)=>[
        user?.first_name,
        user?.last_name
    ].filter(Boolean).join(" ");
const $66539b2560a58e4e$export$f6a098653d630c23 = (name)=>(name || "").split(" ").filter(Boolean).map((word)=>word[0]).slice(0, 2).join("").toUpperCase();
function $66539b2560a58e4e$export$b131c49b26d3f427({ Icon: Icon, tone: tone, label: label }) {
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $1e5256cf9d329b2c$export$2e2bcd8739ae039), {
        title: label,
        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)(Icon, {
            className: `lp-status-icon lp-status-icon--${tone}`,
            "aria-label": label,
            role: "img"
        })
    });
}
const $66539b2560a58e4e$export$81ff514f95f0c424 = (render)=>({
        key: "status",
        title: "",
        width: 44,
        align: "center",
        fixed: "left",
        render: render
    });
function $66539b2560a58e4e$export$8a3d0b92eb0904a5({ user: user, name: name, photo: photo, strong: strong = true }) {
    const label = name ?? $66539b2560a58e4e$export$1d6cfa7493842c29(user);
    if (!label) return $66539b2560a58e4e$export$eb03490a10c3abc9;
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
        align: "center",
        gap: 8,
        className: "lp-main",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $72b7444d01b36e98$export$2e2bcd8739ae039), {
                size: 28,
                className: "lp-who__av",
                style: {
                    fontSize: 12
                },
                src: photo ?? user?.photo ?? null,
                children: $66539b2560a58e4e$export$f6a098653d630c23(label)
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                strong: strong,
                ellipsis: {
                    tooltip: label
                },
                children: label
            })
        ]
    });
}
function $66539b2560a58e4e$export$2692b073ef5fee01({ title: title, sub: sub }) {
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
        vertical: true,
        className: "lp-main",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                strong: true,
                ellipsis: {
                    tooltip: title
                },
                children: title || $66539b2560a58e4e$export$eb03490a10c3abc9
            }),
            sub ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                type: "secondary",
                className: "lp-main__sub",
                ellipsis: {
                    tooltip: sub
                },
                children: sub
            }) : null
        ]
    });
}
function $66539b2560a58e4e$export$523acc1bb0ce2e43({ items: items, onClick: onClick, label: label }) {
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $30ddd2d6a9f4b7d6$export$2e2bcd8739ae039), {
        trigger: [
            "click"
        ],
        menu: {
            items: items,
            onClick: ({ key: key, domEvent: domEvent })=>{
                domEvent.stopPropagation();
                onClick(key);
            }
        },
        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
            type: "text",
            size: "small",
            icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $34f5362a86269156$export$2e2bcd8739ae039), {}),
            "aria-label": label,
            onClick: (event)=>event.stopPropagation()
        })
    });
}
const $66539b2560a58e4e$export$b0493221521ca587 = (render)=>({
        key: "actions",
        title: "",
        width: 56,
        fixed: "right",
        render: render
    });
function $66539b2560a58e4e$export$6cb97cd1ceda576d({ id: id, page: page, size: size, total: total, sizes: sizes, onPage: onPage, onSize: onSize, labels: labels }) {
    const from = total ? (page - 1) * size + 1 : 0;
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
        className: "lp-table__foot",
        align: "center",
        gap: "small",
        wrap: true,
        children: [
            sizes ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                className: "lp-sizesel",
                align: "center",
                gap: 8,
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                        type: "secondary",
                        id: `${id}-size`,
                        children: labels.perPage
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $872fd39f1285217b$export$2e2bcd8739ae039), {
                        size: "small",
                        value: size,
                        "aria-labelledby": `${id}-size`,
                        options: sizes.map((n)=>({
                                value: n,
                                label: n
                            })),
                        onChange: onSize
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                className: "lp-spacer"
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                type: "secondary",
                className: "lp-num",
                "aria-live": "polite",
                children: labels.range.split("{from}").join(from).split("{to}").join(Math.min(page * size, total)).split("{n}").join(total)
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $d12a15546f53270f$export$2e2bcd8739ae039), {
                current: page,
                pageSize: size,
                total: total,
                showSizeChanger: false,
                onChange: onPage
            })
        ]
    });
}
function $66539b2560a58e4e$export$616d7706d7176288({ id: id, page: page, size: size, hasNext: hasNext, sizes: sizes, onPage: onPage, onSize: onSize, labels: labels }) {
    /* Nothing to draw on a single short page: no total means "page 1 with no next" is the only way
     to say "this is all of it", and a lone disabled pager says it worse than nothing does. */ if (page <= 1 && !hasNext && !sizes) return null;
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
        className: "lp-table__foot",
        align: "center",
        gap: "small",
        wrap: true,
        children: [
            sizes ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                className: "lp-sizesel",
                align: "center",
                gap: 8,
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                        type: "secondary",
                        id: `${id}-size`,
                        children: labels.perPage
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $872fd39f1285217b$export$2e2bcd8739ae039), {
                        size: "small",
                        value: size,
                        "aria-labelledby": `${id}-size`,
                        options: sizes.map((n)=>({
                                value: n,
                                label: n
                            })),
                        onChange: onSize
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                className: "lp-spacer"
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                type: "secondary",
                className: "lp-num",
                "aria-live": "polite",
                children: labels.page.split("{n}").join(page)
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                size: "small",
                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0f3c6d60b091c877$export$2e2bcd8739ae039), {}),
                disabled: page <= 1,
                onClick: ()=>onPage(page - 1),
                children: labels.prev
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                size: "small",
                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $89db7229a7e10f8f$export$2e2bcd8739ae039), {}),
                iconPosition: "end",
                disabled: !hasNext,
                onClick: ()=>onPage(page + 1),
                children: labels.next
            })
        ]
    });
}





/* Column renderers shared by the points-admin descriptors and /document.
 *
 * This file used to carry ~70 exports for the pre-redesign EntityTable screens. All but six lost
 * their last caller when /route, /dashboard, /k-form and the visit tabs went; the rest is deleted
 * rather than kept as a second, drifting copy of what `component/table-cells.js` already draws.
 *
 * The person/network cells now go through `PersonCell` for the reason CLAUDE.md gives: an avatar
 * is the subject's INITIALS with the photo preferred, never a generic glyph. These six were the
 * last renderers in the app still emitting a Material Symbols `person`/`store` span, which is what
 * made the points-admin tables look like a different product from every other table.
 *
 * Signature is `(value, item)` — the descriptor column contract — except `dateTimeCreated`, which
 * takes the record.
 */ 
parcelRequire("cQmXV");
/* The app's dayjs instance — antd v6's DatePicker/RangePicker date library.
 *
 * Monday-first in every locale (docs/design/spec/04-content-i18n.md#dates-numbers-coordinates).
 * uk / hy / ka already start the week on Monday; antd's `en_US` pulls dayjs' `en` locale, which
 * starts on Sunday, so that one has to be corrected. Import this module (not `dayjs`) anywhere a
 * date is built for antd, or the calendar's first column silently disagrees with the rest of the
 * product.
 */ var $4e90e9a8d027100a$exports = {};
!function(t, e) {
    $4e90e9a8d027100a$exports = e();
}($4e90e9a8d027100a$exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|YYYY|YY|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), Y = _.prototype;
    return O.prototype = Y, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        Y[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});


var $bf248c2f85c608e3$exports = {};
!function(e, t) {
    $bf248c2f85c608e3$exports = t();
}($bf248c2f85c608e3$exports, function() {
    "use strict";
    var e = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    }, t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|Q|YYYY|YY?|ww?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d/, r = /\d\d/, i = /\d\d?/, o = /\d*[^-_:/,()\s\d]+/, s = {}, a = function(e) {
        return (e = +e) + (e > 68 ? 1900 : 2e3);
    };
    var f = function(e) {
        return function(t) {
            this[e] = +t;
        };
    }, h = [
        /[+-]\d\d:?(\d\d)?|Z/,
        function(e) {
            (this.zone || (this.zone = {})).offset = function(e) {
                if (!e) return 0;
                if ("Z" === e) return 0;
                var t = e.match(/([+-]|\d\d)/g), n = 60 * t[1] + (+t[2] || 0);
                return 0 === n ? 0 : "+" === t[0] ? -n : n;
            }(e);
        }
    ], u = function(e) {
        var t = s[e];
        return t && (t.indexOf ? t : t.s.concat(t.f));
    }, d = function(e, t) {
        var n, r = s.meridiem;
        if (r) {
            for(var i = 1; i <= 24; i += 1)if (e.indexOf(r(i, 0, t)) > -1) {
                n = i > 12;
                break;
            }
        } else n = e === (t ? "pm" : "PM");
        return n;
    }, c = {
        A: [
            o,
            function(e) {
                this.afternoon = d(e, !1);
            }
        ],
        a: [
            o,
            function(e) {
                this.afternoon = d(e, !0);
            }
        ],
        Q: [
            n,
            function(e) {
                this.month = 3 * (e - 1) + 1;
            }
        ],
        S: [
            n,
            function(e) {
                this.milliseconds = 100 * +e;
            }
        ],
        SS: [
            r,
            function(e) {
                this.milliseconds = 10 * +e;
            }
        ],
        SSS: [
            /\d{3}/,
            function(e) {
                this.milliseconds = +e;
            }
        ],
        s: [
            i,
            f("seconds")
        ],
        ss: [
            i,
            f("seconds")
        ],
        m: [
            i,
            f("minutes")
        ],
        mm: [
            i,
            f("minutes")
        ],
        H: [
            i,
            f("hours")
        ],
        h: [
            i,
            f("hours")
        ],
        HH: [
            i,
            f("hours")
        ],
        hh: [
            i,
            f("hours")
        ],
        D: [
            i,
            f("day")
        ],
        DD: [
            r,
            f("day")
        ],
        Do: [
            o,
            function(e) {
                var t = s.ordinal, n = e.match(/\d+/);
                if (this.day = n[0], t) for(var r = 1; r <= 31; r += 1)t(r).replace(/\[|\]/g, "") === e && (this.day = r);
            }
        ],
        w: [
            i,
            f("week")
        ],
        ww: [
            r,
            f("week")
        ],
        M: [
            i,
            f("month")
        ],
        MM: [
            r,
            f("month")
        ],
        MMM: [
            o,
            function(e) {
                var t = u("months"), n = (u("monthsShort") || t.map(function(e) {
                    return e.slice(0, 3);
                })).indexOf(e) + 1;
                if (n < 1) throw new Error;
                this.month = n % 12 || n;
            }
        ],
        MMMM: [
            o,
            function(e) {
                var t = u("months").indexOf(e) + 1;
                if (t < 1) throw new Error;
                this.month = t % 12 || t;
            }
        ],
        Y: [
            /[+-]?\d+/,
            f("year")
        ],
        YY: [
            r,
            function(e) {
                this.year = a(e);
            }
        ],
        YYYY: [
            /\d{4}/,
            f("year")
        ],
        Z: h,
        ZZ: h
    };
    function l(n) {
        var r, i;
        r = n, i = s && s.formats;
        for(var o = (n = r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, n, r) {
            var o = r && r.toUpperCase();
            return n || i[r] || e[r] || i[o].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, n) {
                return t || n.slice(1);
            });
        })).match(t), a = o.length, f = 0; f < a; f += 1){
            var h = o[f], u = c[h], d = u && u[0], l = u && u[1];
            o[f] = l ? {
                regex: d,
                parser: l
            } : h.replace(/^\[|\]$/g, "");
        }
        return function(e) {
            for(var t = {}, n = 0, r = 0; n < a; n += 1){
                var i = o[n];
                if ("string" == typeof i) r += i.length;
                else {
                    var s = i.regex, f = i.parser, h = e.slice(r), u = s.exec(h)[0];
                    f.call(t, u), e = e.replace(u, "");
                }
            }
            return function(e) {
                var t = e.afternoon;
                if (void 0 !== t) {
                    var n = e.hours;
                    t ? n < 12 && (e.hours += 12) : 12 === n && (e.hours = 0), delete e.afternoon;
                }
            }(t), t;
        };
    }
    return function(e, t, n) {
        n.p.customParseFormat = !0, e && e.parseTwoDigitYear && (a = e.parseTwoDigitYear);
        var r = t.prototype, i = r.parse;
        r.parse = function(e) {
            var t = e.date, r = e.utc, o = e.args;
            this.$u = r;
            var a = o[1];
            if ("string" == typeof a) {
                var f = !0 === o[2], h = !0 === o[3], u = f || h, d = o[2];
                h && (d = o[2]), s = this.$locale(), !f && d && (s = n.Ls[d]), this.$d = function(e, t, n, r) {
                    try {
                        if ([
                            "x",
                            "X"
                        ].indexOf(t) > -1) return new Date(("X" === t ? 1e3 : 1) * e);
                        var i = l(t)(e), o = i.year, s = i.month, a = i.day, f = i.hours, h = i.minutes, u = i.seconds, d = i.milliseconds, c = i.zone, m = i.week, M = new Date, Y = a || (o || s ? 1 : M.getDate()), p = o || M.getFullYear(), v = 0;
                        o && !s || (v = s > 0 ? s - 1 : M.getMonth());
                        var D, w = f || 0, g = h || 0, y = u || 0, L = d || 0;
                        return c ? new Date(Date.UTC(p, v, Y, w, g, y, L + 60 * c.offset * 1e3)) : n ? new Date(Date.UTC(p, v, Y, w, g, y, L)) : (D = new Date(p, v, Y, w, g, y, L), m && (D = r(D).week(m).toDate()), D);
                    } catch (e) {
                        return new Date("");
                    }
                }(t, a, r, n), this.init(), d && !0 !== d && (this.$L = this.locale(d).$L), u && t != this.format(a) && (this.$d = new Date("")), s = {};
            } else if (a instanceof Array) for(var c = a.length, m = 1; m <= c; m += 1){
                o[1] = a[m - 1];
                var M = n.apply(this, o);
                if (M.isValid()) {
                    this.$d = M.$d, this.$L = M.$L, this.init();
                    break;
                }
                m === c && (this.$d = new Date(""));
            }
            else i.call(this, e);
        };
    };
});


var $62bab72102f1b479$exports = {};
!function(e, t) {
    $62bab72102f1b479$exports = t();
}($62bab72102f1b479$exports, function() {
    "use strict";
    function e() {
        return e = Object.assign || function(e) {
            for(var t = 1; t < arguments.length; t++){
                var n = arguments[t];
                for(var o in n)Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
            }
            return e;
        }, e.apply(this, arguments);
    }
    return function(t, n, o) {
        o.updateLocale = function(t, n) {
            var r = o.Ls[t];
            if (r) return (n ? Object.keys(n) : []).forEach(function(t) {
                r[t] && n[t] && "object" == typeof r[t] && "object" == typeof n[t] && !Array.isArray(r[t]) ? r[t] = e({}, r[t], n[t]) : r[t] = n[t];
            }), r;
        };
    };
});


(0, (/*@__PURE__*/$parcel$interopDefault($4e90e9a8d027100a$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($62bab72102f1b479$exports))));
/* `dayjs(text, "DD/MM/YYYY", true)` — needed by the import parser, which must be able to tell a
   real date in a spreadsheet cell from a plausible-looking string. Without the plugin the format
   argument is ignored and dayjs falls back to `Date.parse`, which reads `31/12/2026` as Invalid
   and `01/09/2026` as the 9th of January — silently importing every date with the parts swapped. */ (0, (/*@__PURE__*/$parcel$interopDefault($4e90e9a8d027100a$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($bf248c2f85c608e3$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($4e90e9a8d027100a$exports))).updateLocale("en", {
    weekStart: 1
});
var $c2a1b4c9c0ea4716$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($4e90e9a8d027100a$exports)));




function $b79edb411f97c469$export$2a939cfc6449d94d(i, item) {
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
        children: item.locality?.name
    });
}
function $b79edb411f97c469$export$c1c72f42e43ef7e9(i, item) {
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
        children: [
            " ",
            item && (0, $6f1c09625235f1f0$export$8e11240bfd4abd6)[item.movement]
        ]
    });
}
function $b79edb411f97c469$export$c86d3ca66f38ed60(i, item) {
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $66539b2560a58e4e$export$8a3d0b92eb0904a5), {
        user: item
    });
}
function $b79edb411f97c469$export$99f62f7c9ad8c7ce(i, item) {
    return item.created_by ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $66539b2560a58e4e$export$8a3d0b92eb0904a5), {
        user: item.created_by
    }) : null;
}
function $b79edb411f97c469$export$c2dc1fe4fd2f6ef2(i, item) {
    return item.network ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $66539b2560a58e4e$export$8a3d0b92eb0904a5), {
        name: item.network.name,
        photo: item.network.image
    }) : null;
}
function $b79edb411f97c469$export$236fe9b998ba9793(item) {
    if (!item || !item.created) return "\u2014";
    // Humanized, unambiguous format, e.g. "20 Jul 2026, 14:30".
    return (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)(item.created).format("DD MMM YYYY, HH:mm");
}


const $8410c4bcf771fa83$var$PAGE_SIZES = [
    25,
    50,
    100
];
/* Column key → the field the API orders on. A key missing here is not sortable. */ const $8410c4bcf771fa83$var$ORDERING = {
    title: "title",
    created: "created"
};
/* The same field track as every other filter card (spec/02): a third of the row from xl down. */ const $8410c4bcf771fa83$var$FIELD_COL = {
    xs: {
        flex: "0 0 100%"
    },
    md: {
        flex: "0 0 50%"
    },
    xl: {
        flex: "0 0 33.3333%"
    }
};
const $8410c4bcf771fa83$var$DEFAULT_SORT = {
    key: "created",
    dir: "descend"
};
const $8410c4bcf771fa83$var$sortKey = (sort)=>sort ? `${sort.dir === "descend" ? "-" : ""}${sort.key}` : "";
/* URL ↔ state, the same round trip the other list pages do: a filtered view is shareable, and
   `history.replace` keeps filtering out of the history stack. */ function $8410c4bcf771fa83$var$stateToSearch({ search: search, page: page, size: size, sort: sort }) {
    const p = new URLSearchParams();
    if (search) p.set("q", search);
    if (page > 1) p.set("page", String(page));
    if (size !== $8410c4bcf771fa83$var$PAGE_SIZES[0]) p.set("size", String(size));
    if ($8410c4bcf771fa83$var$sortKey(sort) !== $8410c4bcf771fa83$var$sortKey($8410c4bcf771fa83$var$DEFAULT_SORT)) p.set("sort", $8410c4bcf771fa83$var$sortKey(sort));
    return p.toString();
}
function $8410c4bcf771fa83$var$searchToState(locationSearch) {
    const p = new URLSearchParams(locationSearch);
    const sort = p.get("sort");
    return {
        search: p.get("q") || "",
        page: Math.max(1, Number(p.get("page")) || 1),
        size: $8410c4bcf771fa83$var$PAGE_SIZES.includes(Number(p.get("size"))) ? Number(p.get("size")) : $8410c4bcf771fa83$var$PAGE_SIZES[0],
        sort: sort === null ? $8410c4bcf771fa83$var$DEFAULT_SORT : $8410c4bcf771fa83$var$ORDERING[sort.replace(/^-/, "")] ? {
            key: sort.replace(/^-/, ""),
            dir: sort[0] === "-" ? "descend" : "ascend"
        } : null
    };
}
const $8410c4bcf771fa83$var$FILE_ICON = {
    pdf: (0, $48c531267acac240$export$2e2bcd8739ae039),
    doc: (0, $bff3f28c90294548$export$2e2bcd8739ae039),
    docx: (0, $bff3f28c90294548$export$2e2bcd8739ae039),
    xls: (0, $3e7ed8d791051c11$export$2e2bcd8739ae039),
    xlsx: (0, $3e7ed8d791051c11$export$2e2bcd8739ae039),
    csv: (0, $3e7ed8d791051c11$export$2e2bcd8739ae039),
    png: (0, $c3b8d7d247171904$export$2e2bcd8739ae039),
    jpg: (0, $c3b8d7d247171904$export$2e2bcd8739ae039),
    jpeg: (0, $c3b8d7d247171904$export$2e2bcd8739ae039),
    gif: (0, $c3b8d7d247171904$export$2e2bcd8739ae039),
    svg: (0, $c3b8d7d247171904$export$2e2bcd8739ae039),
    webp: (0, $c3b8d7d247171904$export$2e2bcd8739ae039),
    zip: (0, $e69ab3e85be6c099$export$2e2bcd8739ae039),
    rar: (0, $e69ab3e85be6c099$export$2e2bcd8739ae039),
    txt: (0, $3ad3610a8cd8d8e0$export$2e2bcd8739ae039)
};
const $8410c4bcf771fa83$var$extensionOf = (url)=>{
    if (!url) return "";
    const name = url.split("/").pop().split("?")[0];
    return name.includes(".") ? name.split(".").pop().toLowerCase() : "";
};
const $8410c4bcf771fa83$var$View = ()=>{
    const history = (0, $6f5d68f762d5488a$export$3420e1dc2c4a518c)();
    const location = (0, $6f5d68f762d5488a$export$45d76561a5302f2b)();
    const me = (0, $b83e93e5ef3de8b0$export$2105062e25df4afe)((state)=>state.me);
    const lang = me?.language || "en";
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$2cbd0be658ac061c), key, lang);
    const tp = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b8441a9a81ffc5d6), key, lang);
    const ta = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ac552071080927b0), key, lang);
    const tv = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), key, lang);
    const tdl = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f544127b46daf517), key, lang);
    const te = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), key, lang);
    const tb = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b94fa0d6ced71581), key, lang);
    /* Read once. After mount this component owns the state and writes the URL, not the reverse. */ const initial = (0, $cQmXV.useRef)($8410c4bcf771fa83$var$searchToState(location.search)).current;
    /* Typing is separate from the applied term: the field must not lag the keystroke while the
     request it will eventually cause is still debounced. */ const [typed, setTyped] = (0, $cQmXV.useState)(initial.search);
    const [search, setSearch] = (0, $cQmXV.useState)(initial.search);
    const [page, setPage] = (0, $cQmXV.useState)(initial.page);
    const [size, setSize] = (0, $cQmXV.useState)(initial.size);
    const [sort, setSort] = (0, $cQmXV.useState)(initial.sort);
    const [rows, setRows] = (0, $cQmXV.useState)([]);
    const [total, setTotal] = (0, $cQmXV.useState)(0);
    const [loading, setLoading] = (0, $cQmXV.useState)(true);
    const [open, setOpen] = (0, $cQmXV.useState)(false);
    const [saving, setSaving] = (0, $cQmXV.useState)(false);
    const [form] = (0, $e9904e0132e26ce3$export$2e2bcd8739ae039).useForm();
    const query = (0, $cQmXV.useMemo)(()=>{
        const p = new URLSearchParams();
        p.set("page", String(page));
        p.set("page_size", String(size));
        if (search) p.set("search", search);
        if (sort) p.set("ordering", `${sort.dir === "descend" ? "-" : ""}${$8410c4bcf771fa83$var$ORDERING[sort.key]}`);
        return p.toString();
    }, [
        search,
        page,
        size,
        sort
    ]);
    const [reloads, setReloads] = (0, $cQmXV.useState)(0);
    const reload = ()=>setReloads((n)=>n + 1);
    (0, $cQmXV.useEffect)(()=>{
        const controller = new AbortController();
        setLoading(true);
        (0, $c9936523dc38c641$export$86557ef9e0794d10)(`documents/?${query}`, controller.signal).then((response)=>{
            if (!response) return;
            setRows(response.results || []);
            setTotal(response.count || 0);
            setLoading(false);
        }).catch((error)=>{
            if (error.name === "AbortError") return;
            setRows([]);
            setTotal(0);
            setLoading(false);
        });
        return ()=>controller.abort();
    }, [
        query,
        reloads
    ]);
    /* The URL trails the state; `replace` so filtering does not fill the history stack. */ (0, $cQmXV.useEffect)(()=>{
        const next = $8410c4bcf771fa83$var$stateToSearch({
            search: search,
            page: page,
            size: size,
            sort: sort
        });
        if (next !== location.search.replace(/^\?/, "")) history.replace({
            search: next
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        search,
        page,
        size,
        sort
    ]);
    /* 250ms, matching every other search box in the app: one request per pause, not per keystroke. */ (0, $cQmXV.useEffect)(()=>{
        if (typed === search) return undefined;
        const timer = setTimeout(()=>{
            setSearch(typed);
            setPage(1);
        }, 250);
        return ()=>clearTimeout(timer);
    }, [
        typed,
        search
    ]);
    /* No `useLabelCache` here: the one filter is free text, so a chip can always label itself. */ // eslint-disable-next-line react-hooks/exhaustive-deps
    const chips = (0, $cQmXV.useMemo)(()=>search ? [
            {
                key: "q",
                label: t("search"),
                value: search
            }
        ] : [], [
        search,
        lang
    ]);
    const clearSearch = ()=>{
        setTyped("");
        setSearch("");
        setPage(1);
    };
    const clearChip = (key)=>key === "q" && clearSearch();
    const resetFilters = ()=>{
        clearSearch();
        setSort($8410c4bcf771fa83$var$DEFAULT_SORT);
    };
    const scrollY = (0, $66539b2560a58e4e$export$f44b992e82788e9)();
    const openFile = (row)=>row.document && window.open(row.document, "_blank", "noopener");
    const remove = (row)=>(0, $05a90c67d3627fd9$export$2e2bcd8739ae039).confirm({
            title: (0, $3b579ca6158bc61b$export$9563e054e6f787fb)(t("confirm_delete"), {
                name: row.title
            }),
            okText: ta("delete_btn"),
            okButtonProps: {
                danger: true
            },
            /* `Modal.confirm` is a static call: it renders outside the tree and does not inherit
         `AppShell`'s `ConfigProvider locale`, so the buttons need explicit labels. */ cancelText: tdl("cancel"),
            onOk: ()=>new Promise((resolve)=>{
                    (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
                        method: "DELETE",
                        url: `documents/${row.id}/`
                    }, ()=>{
                        (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success(t("file_deleted"), {
                            position: "top-right"
                        });
                        /* Refetch rather than splice: the row leaving changes the page's contents, and the
               server owns which record moves up into it. */ reload();
                        resolve();
                    });
                })
        });
    const submit = (values)=>{
        const picked = values.file[0];
        const fd = new FormData();
        fd.append("document", picked.originFileObj || picked);
        fd.append("title", values.title);
        setSaving(true);
        (0, $c9936523dc38c641$export$e9af2f996ea0b059)({
            method: "POST",
            url: "documents/",
            post: fd
        }, (response)=>{
            setSaving(false);
            if (!response?.id) {
                (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).error(ta("save_error"), {
                    position: "top-right"
                });
                return;
            }
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success(t("file_successfully_uploaded"), {
                position: "top-right"
            });
            setOpen(false);
            form.resetFields();
            setPage(1);
            reload();
        });
    };
    const columns = (0, $cQmXV.useMemo)(()=>[
            {
                key: "title",
                title: t("file_name"),
                width: 320,
                fixed: "left",
                ellipsis: true,
                sorter: true,
                sortOrder: sort?.key === "title" ? sort.dir : null,
                render: (value, row)=>{
                    const Icon = $8410c4bcf771fa83$var$FILE_ICON[$8410c4bcf771fa83$var$extensionOf(row.document)] || (0, $cf187e4b16fb1e1e$export$2e2bcd8739ae039);
                    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                        align: "center",
                        gap: 8,
                        className: "lp-main",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                type: "secondary",
                                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)(Icon, {
                                    style: {
                                        fontSize: 18
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                strong: true,
                                ellipsis: {
                                    tooltip: row.title
                                },
                                children: row.title || (0, $66539b2560a58e4e$export$eb03490a10c3abc9)
                            })
                        ]
                    });
                }
            },
            {
                key: "type",
                title: t("f_type"),
                width: 110,
                render: (value, row)=>{
                    const ext = $8410c4bcf771fa83$var$extensionOf(row.document);
                    return ext ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $602120e6d17ff12a$export$2e2bcd8739ae039), {
                        children: ext.toUpperCase()
                    }) : (0, $66539b2560a58e4e$export$eb03490a10c3abc9);
                }
            },
            {
                key: "created",
                title: t("creation_time"),
                width: 200,
                sorter: true,
                sortOrder: sort?.key === "created" ? sort.dir : null,
                render: (value, row)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "lp-num",
                        children: (0, $b79edb411f97c469$export$236fe9b998ba9793)(row)
                    })
            },
            {
                /* Opening the file is an explicit control, not a row click — the row is not a navigation,
           and a click that leaves the app should have to be aimed at. The menu keeps the row's
           remaining action so the affordance stays where it is on every other table. */ ...(0, $66539b2560a58e4e$export$b0493221521ca587)((value, row)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                        align: "center",
                        justify: "flex-end",
                        gap: 4,
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $1e5256cf9d329b2c$export$2e2bcd8739ae039), {
                                title: tb("open_new_tab"),
                                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                    type: "text",
                                    size: "small",
                                    icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $357da3723e13ae38$export$2e2bcd8739ae039), {}),
                                    "aria-label": tb("open_new_tab"),
                                    disabled: !row.document,
                                    onClick: ()=>openFile(row)
                                })
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $66539b2560a58e4e$export$523acc1bb0ce2e43), {
                                label: tv("row_actions"),
                                items: [
                                    {
                                        key: "delete",
                                        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5234c28d879e38c1$export$2e2bcd8739ae039), {}),
                                        label: ta("delete_btn"),
                                        danger: true
                                    }
                                ],
                                onClick: ()=>remove(row)
                            })
                        ]
                    })),
                width: 92
            }
        ], // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        lang,
        sort
    ]);
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
        vertical: true,
        gap: "middle",
        className: "shell-content lp",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                className: "lp-head",
                justify: "space-between",
                align: "flex-end",
                gap: "middle",
                wrap: true,
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                        vertical: true,
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Title, {
                                level: 1,
                                className: "lp-title",
                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$72266474e9355649), "documents", lang)
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Paragraph, {
                                type: "secondary",
                                className: "lp-sub",
                                children: t("page_sub")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                        type: "primary",
                        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $08a66dd72a6d5552$export$2e2bcd8739ae039), {}),
                        onClick: ()=>setOpen(true),
                        children: t("add_file")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b4fda840b736e640$export$2e2bcd8739ae039), {
                className: "lp-filters",
                variant: "outlined",
                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039), {
                    layout: "vertical",
                    component: false,
                    colon: false,
                    children: [
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $db6c3adada49524e$export$2e2bcd8739ae039), {
                            gutter: [
                                12,
                                12
                            ],
                            children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $cde227eb983ae1d2$export$2e2bcd8739ae039), {
                                ...$8410c4bcf771fa83$var$FIELD_COL,
                                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                    label: t("search"),
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0883e7f8083c01b0$export$2e2bcd8739ae039), {
                                        allowClear: true,
                                        prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $20a259d46bffcb08$export$2e2bcd8739ae039), {}),
                                        placeholder: t("search_ph"),
                                        "aria-label": t("search"),
                                        value: typed,
                                        onChange: (event)=>setTyped(event.target.value)
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $a9e321bb60aaf998$export$2e2bcd8739ae039), {
                            className: "lp-chips",
                            items: chips,
                            closeLabel: tp("a_remove_filter"),
                            onClose: clearChip
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                            className: "lp-filters__foot",
                            align: "center",
                            gap: "small",
                            wrap: true,
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                    className: "lp-spacer"
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                    size: "small",
                                    onClick: resetFilters,
                                    children: te("filter_reset")
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $b4fda840b736e640$export$2e2bcd8739ae039), {
                className: "lp-table",
                variant: "outlined",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                        className: "lp-table__bar",
                        align: "center",
                        gap: "small",
                        wrap: true,
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                strong: true,
                                className: "lp-table__title",
                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$72266474e9355649), "documents", lang)
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                type: "secondary",
                                "aria-live": "polite",
                                children: [
                                    tp("records_count"),
                                    ": ",
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                        strong: true,
                                        children: total
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $dff4d45d201c6dfe$export$2e2bcd8739ae039), {
                        className: "lp-table__grid",
                        rowKey: "id",
                        size: "middle",
                        columns: columns,
                        dataSource: rows,
                        loading: loading,
                        scroll: {
                            x: 700,
                            y: scrollY
                        },
                        /* Paging is the footer below, so with `pagination={false}` the only thing left for the
             table's own onChange is the sorter. */ onChange: (pagination, filters, sorter)=>{
                            const next = sorter?.order && $8410c4bcf771fa83$var$ORDERING[sorter.columnKey] ? {
                                key: sorter.columnKey,
                                dir: sorter.order
                            } : null;
                            if (JSON.stringify(next) === JSON.stringify(sort)) return;
                            setSort(next);
                            setPage(1);
                        },
                        pagination: false,
                        locale: {
                            /* "nothing here yet" and "no results for this search" are different states and get
               different copy (spec/03). */ emptyText: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $99350450b877904c$export$2e2bcd8739ae039), {
                                image: (0, $99350450b877904c$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE,
                                description: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                    vertical: true,
                                    gap: 4,
                                    children: [
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                            strong: true,
                                            children: search ? t("empty_search_title") : t("empty_title")
                                        }),
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                            type: "secondary",
                                            children: search ? t("empty_search_desc") : t("empty_desc")
                                        })
                                    ]
                                })
                            })
                        }
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $66539b2560a58e4e$export$6cb97cd1ceda576d), {
                        id: "doc",
                        page: page,
                        size: size,
                        total: total,
                        sizes: $8410c4bcf771fa83$var$PAGE_SIZES,
                        labels: {
                            perPage: tv("rows_per_page"),
                            range: tv("range_of")
                        },
                        onPage: setPage,
                        onSize: (next)=>{
                            setSize(next);
                            setPage(1);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $05a90c67d3627fd9$export$2e2bcd8739ae039), {
                open: open,
                title: t("add_file"),
                okText: t("add_file"),
                cancelText: tdl("cancel"),
                confirmLoading: saving,
                onOk: ()=>form.submit(),
                onCancel: ()=>setOpen(false),
                destroyOnHidden: true,
                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039), {
                    form: form,
                    layout: "vertical",
                    requiredMark: false,
                    onFinish: submit,
                    preserve: false,
                    children: [
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                            name: "title",
                            label: t("file_name"),
                            rules: [
                                {
                                    required: true,
                                    message: t("file_name_cannot_be_empty")
                                }
                            ],
                            children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0883e7f8083c01b0$export$2e2bcd8739ae039), {
                                maxLength: 255
                            })
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                            name: "file",
                            valuePropName: "fileList",
                            /* `beforeUpload: false` keeps the file local, so the event carries the picked list. */ getValueFromEvent: (event)=>event?.fileList,
                            /* An explicit validator, not `required`: async-validator treats an unspecified rule as
               a string, so an empty `fileList` passes `required` and `values.file[0]` then throws
               on submit. */ rules: [
                                {
                                    validator: (rule, value)=>value && value.length ? Promise.resolve() : Promise.reject(new Error(t("need_to_add_file")))
                                }
                            ],
                            children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $b615b6e60c753ce5$export$2e2bcd8739ae039).Dragger, {
                                beforeUpload: ()=>false,
                                maxCount: 1,
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                        type: "secondary",
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $1a05577e1774d0d9$export$2e2bcd8739ae039), {
                                            style: {
                                                fontSize: 28
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Paragraph, {
                                        type: "secondary",
                                        style: {
                                            margin: 0
                                        },
                                        children: t("click_or_drag_files_here")
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $8410c4bcf771fa83$export$2e2bcd8739ae039 = $8410c4bcf771fa83$var$View;




var $cQmXV = parcelRequire("cQmXV");



var $cQmXV = parcelRequire("cQmXV");






var $cQmXV = parcelRequire("cQmXV");





var $cQmXV = parcelRequire("cQmXV");
const $8265580409d4a62a$var$calcThumbStyle = (targetElement, vertical)=>{
    if (!targetElement) return null;
    const style = {
        left: targetElement.offsetLeft,
        right: targetElement.parentElement.clientWidth - targetElement.clientWidth - targetElement.offsetLeft,
        width: targetElement.clientWidth,
        top: targetElement.offsetTop,
        bottom: targetElement.parentElement.clientHeight - targetElement.clientHeight - targetElement.offsetTop,
        height: targetElement.clientHeight
    };
    if (vertical) // Adjusts positioning and size for vertical layout by setting horizontal properties to 0 and using vertical properties from the style object.
    return {
        left: 0,
        right: 0,
        width: 0,
        top: style.top,
        bottom: style.bottom,
        height: style.height
    };
    return {
        left: style.left,
        right: style.right,
        width: style.width,
        top: 0,
        bottom: 0,
        height: 0
    };
};
const $8265580409d4a62a$var$toPX = (value)=>value !== undefined ? `${value}px` : undefined;
function $8265580409d4a62a$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, containerRef: containerRef, value: value, getValueIndex: getValueIndex, motionName: motionName, onMotionStart: onMotionStart, onMotionEnd: onMotionEnd, direction: direction, vertical: vertical = false } = props;
    const thumbRef = $cQmXV.useRef(null);
    const [prevValue, setPrevValue] = $cQmXV.useState(value);
    // =========================== Effect ===========================
    const findValueElement = (val)=>{
        const index = getValueIndex(val);
        const ele = containerRef.current?.querySelectorAll(`.${prefixCls}-item`)[index];
        return ele?.offsetParent && ele;
    };
    const [prevStyle, setPrevStyle] = $cQmXV.useState(null);
    const [nextStyle, setNextStyle] = $cQmXV.useState(null);
    (0, $7673d874dab69d07$export$2e2bcd8739ae039)(()=>{
        if (prevValue !== value) {
            const prev = findValueElement(prevValue);
            const next = findValueElement(value);
            const calcPrevStyle = $8265580409d4a62a$var$calcThumbStyle(prev, vertical);
            const calcNextStyle = $8265580409d4a62a$var$calcThumbStyle(next, vertical);
            setPrevValue(value);
            setPrevStyle(calcPrevStyle);
            setNextStyle(calcNextStyle);
            if (prev && next) onMotionStart();
            else onMotionEnd();
        }
    }, [
        value
    ]);
    const thumbStart = $cQmXV.useMemo(()=>{
        if (vertical) return $8265580409d4a62a$var$toPX(prevStyle?.top ?? 0);
        if (direction === "rtl") return $8265580409d4a62a$var$toPX(-prevStyle?.right);
        return $8265580409d4a62a$var$toPX(prevStyle?.left);
    }, [
        vertical,
        direction,
        prevStyle
    ]);
    const thumbActive = $cQmXV.useMemo(()=>{
        if (vertical) return $8265580409d4a62a$var$toPX(nextStyle?.top ?? 0);
        if (direction === "rtl") return $8265580409d4a62a$var$toPX(-nextStyle?.right);
        return $8265580409d4a62a$var$toPX(nextStyle?.left);
    }, [
        vertical,
        direction,
        nextStyle
    ]);
    // =========================== Motion ===========================
    const onAppearStart = ()=>{
        if (vertical) return {
            transform: "translateY(var(--thumb-start-top))",
            height: "var(--thumb-start-height)"
        };
        return {
            transform: "translateX(var(--thumb-start-left))",
            width: "var(--thumb-start-width)"
        };
    };
    const onAppearActive = ()=>{
        if (vertical) return {
            transform: "translateY(var(--thumb-active-top))",
            height: "var(--thumb-active-height)"
        };
        return {
            transform: "translateX(var(--thumb-active-left))",
            width: "var(--thumb-active-width)"
        };
    };
    const onVisibleChanged = ()=>{
        setPrevStyle(null);
        setNextStyle(null);
        onMotionEnd();
    };
    // =========================== Render ===========================
    // No need motion when nothing exist in queue
    if (!prevStyle || !nextStyle) return null;
    return /*#__PURE__*/ $cQmXV.createElement((0, $04c53b89814950f8$export$2e2bcd8739ae039), {
        visible: true,
        motionName: motionName,
        motionAppear: true,
        onAppearStart: onAppearStart,
        onAppearActive: onAppearActive,
        onVisibleChanged: onVisibleChanged
    }, ({ className: motionClassName, style: motionStyle }, ref)=>{
        const mergedStyle = {
            ...motionStyle,
            "--thumb-start-left": thumbStart,
            "--thumb-start-width": $8265580409d4a62a$var$toPX(prevStyle?.width),
            "--thumb-active-left": thumbActive,
            "--thumb-active-width": $8265580409d4a62a$var$toPX(nextStyle?.width),
            "--thumb-start-top": thumbStart,
            "--thumb-start-height": $8265580409d4a62a$var$toPX(prevStyle?.height),
            "--thumb-active-top": thumbActive,
            "--thumb-active-height": $8265580409d4a62a$var$toPX(nextStyle?.height)
        };
        // It's little ugly which should be refactor when @umi/test update to latest jsdom
        const motionProps = {
            ref: (0, $10341b937b26f69d$export$ab452c34e8e05029)(thumbRef, ref),
            style: mergedStyle,
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-thumb`, motionClassName)
        };
        return /*#__PURE__*/ $cQmXV.createElement("div", motionProps);
    });
}


function $f87ce7a7485a7a68$var$getValidTitle(option) {
    if (typeof option.title !== "undefined") return option.title;
    // read `label` when title is `undefined`
    if (typeof option.label !== "object") return option.label?.toString();
}
function $f87ce7a7485a7a68$var$normalizeOptions(options) {
    return options.map((option)=>{
        if (typeof option === "object" && option !== null) {
            const validTitle = $f87ce7a7485a7a68$var$getValidTitle(option);
            return {
                ...option,
                title: validTitle
            };
        }
        return {
            label: option?.toString(),
            title: option?.toString(),
            value: option
        };
    });
}
const $f87ce7a7485a7a68$var$InternalSegmentedOption = ({ prefixCls: prefixCls, className: className, style: style, styles: styles, classNames: segmentedClassNames, data: data, disabled: disabled, checked: checked, label: label, title: title, value: value, name: name, onChange: onChange, onFocus: onFocus, onBlur: onBlur, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, itemRender: itemRender = (node)=>node })=>{
    const handleChange = (event)=>{
        if (disabled) return;
        onChange(event, value);
    };
    const itemContent = /*#__PURE__*/ $cQmXV.createElement("label", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(className, {
            [`${prefixCls}-item-disabled`]: disabled
        }),
        style: style,
        onMouseDown: onMouseDown
    }, /*#__PURE__*/ $cQmXV.createElement("input", {
        name: name,
        className: `${prefixCls}-item-input`,
        type: "radio",
        disabled: disabled,
        checked: checked,
        onChange: handleChange,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp
    }), /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-item-label`, segmentedClassNames?.label),
        title: title,
        style: styles?.label
    }, label));
    return itemRender(itemContent, {
        item: data
    });
};
const $f87ce7a7485a7a68$var$Segmented = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { prefixCls: prefixCls = "rc-segmented", direction: direction, vertical: vertical, options: options = [], disabled: disabled, defaultValue: defaultValue, value: value, name: name, onChange: onChange, className: className = "", style: style, styles: styles, classNames: segmentedClassNames, motionName: motionName = "thumb-motion", itemRender: itemRender, ...restProps } = props;
    const containerRef = $cQmXV.useRef(null);
    const mergedRef = $cQmXV.useMemo(()=>(0, $10341b937b26f69d$export$ab452c34e8e05029)(containerRef, ref), [
        containerRef,
        ref
    ]);
    const segmentedOptions = $cQmXV.useMemo(()=>{
        return $f87ce7a7485a7a68$var$normalizeOptions(options);
    }, [
        options
    ]);
    // Note: We should not auto switch value when value not exist in options
    // which may break single source of truth.
    const [rawValue, setRawValue] = (0, $a51866d781137e08$export$2e2bcd8739ae039)(defaultValue ?? segmentedOptions[0]?.value, value);
    // ======================= Change ========================
    const [thumbShow, setThumbShow] = $cQmXV.useState(false);
    const handleChange = (event, val)=>{
        setRawValue(val);
        onChange?.(val);
    };
    const divProps = (0, $e8c5093aebad6025$export$2e2bcd8739ae039)(restProps, [
        "children"
    ]);
    // ======================= Focus ========================
    const [isKeyboard, setIsKeyboard] = $cQmXV.useState(false);
    const [isFocused, setIsFocused] = $cQmXV.useState(false);
    const handleFocus = ()=>{
        setIsFocused(true);
    };
    const handleBlur = ()=>{
        setIsFocused(false);
    };
    const handleMouseDown = ()=>{
        setIsKeyboard(false);
    };
    // capture keyboard tab interaction for correct focus style
    const handleKeyUp = (event)=>{
        if (event.key === "Tab") setIsKeyboard(true);
    };
    // ======================= Keyboard ========================
    const onOffset = (offset)=>{
        const currentIndex = segmentedOptions.findIndex((option)=>option.value === rawValue);
        const total = segmentedOptions.length;
        const nextIndex = (currentIndex + offset + total) % total;
        const nextOption = segmentedOptions[nextIndex];
        if (nextOption) {
            setRawValue(nextOption.value);
            onChange?.(nextOption.value);
        }
    };
    const handleKeyDown = (event)=>{
        switch(event.key){
            case "ArrowLeft":
            case "ArrowUp":
                onOffset(-1);
                break;
            case "ArrowRight":
            case "ArrowDown":
                onOffset(1);
                break;
        }
    };
    const renderOption = (segmentedOption)=>{
        const { value: optionValue, disabled: optionDisabled } = segmentedOption;
        return /*#__PURE__*/ $cQmXV.createElement($f87ce7a7485a7a68$var$InternalSegmentedOption, (0, $e69a41570260c349$export$2e2bcd8739ae039)({}, segmentedOption, {
            name: name,
            data: segmentedOption,
            itemRender: itemRender,
            key: optionValue,
            prefixCls: prefixCls,
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(segmentedOption.className, `${prefixCls}-item`, segmentedClassNames?.item, {
                [`${prefixCls}-item-selected`]: optionValue === rawValue && !thumbShow,
                [`${prefixCls}-item-focused`]: isFocused && isKeyboard && optionValue === rawValue
            }),
            style: styles?.item,
            classNames: segmentedClassNames,
            styles: styles,
            checked: optionValue === rawValue,
            onChange: handleChange,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onKeyDown: handleKeyDown,
            onKeyUp: handleKeyUp,
            onMouseDown: handleMouseDown,
            disabled: !!disabled || !!optionDisabled
        }));
    };
    return /*#__PURE__*/ $cQmXV.createElement("div", (0, $e69a41570260c349$export$2e2bcd8739ae039)({
        role: "radiogroup",
        "aria-label": "segmented control",
        tabIndex: disabled ? undefined : 0,
        "aria-orientation": vertical ? "vertical" : "horizontal",
        style: style
    }, divProps, {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, {
            [`${prefixCls}-rtl`]: direction === "rtl",
            [`${prefixCls}-disabled`]: disabled,
            [`${prefixCls}-vertical`]: vertical
        }, className),
        ref: mergedRef
    }), /*#__PURE__*/ $cQmXV.createElement("div", {
        className: `${prefixCls}-group`
    }, /*#__PURE__*/ $cQmXV.createElement((0, $8265580409d4a62a$export$2e2bcd8739ae039), {
        vertical: vertical,
        prefixCls: prefixCls,
        value: rawValue,
        containerRef: containerRef,
        motionName: `${prefixCls}-${motionName}`,
        direction: direction,
        getValueIndex: (val)=>segmentedOptions.findIndex((n)=>n.value === val),
        onMotionStart: ()=>{
            setThumbShow(true);
        },
        onMotionEnd: ()=>{
            setThumbShow(false);
        }
    }), segmentedOptions.map(renderOption)));
});
const $f87ce7a7485a7a68$var$TypedSegmented = $f87ce7a7485a7a68$var$Segmented;
var $f87ce7a7485a7a68$export$2e2bcd8739ae039 = $f87ce7a7485a7a68$var$TypedSegmented;













// ============================== Mixins ==============================
function $432f99a830c1249c$var$getItemDisabledStyle(cls, token) {
    return {
        [`${cls}, ${cls}:hover, ${cls}:focus`]: {
            color: token.colorTextDisabled,
            cursor: "not-allowed"
        }
    };
}
const $432f99a830c1249c$var$getItemSelectedStyle = (token)=>{
    return {
        background: token.itemSelectedBg,
        boxShadow: token.boxShadowTertiary
    };
};
const $432f99a830c1249c$var$segmentedTextEllipsisCss = {
    overflow: "hidden",
    // handle text ellipsis
    ...(0, $519d20bf207ce864$export$b2b65df0d0824629)
};
// ============================== Styles ==============================
const $432f99a830c1249c$var$genSegmentedStyle = (token)=>{
    const { componentCls: componentCls, motionDurationSlow: motionDurationSlow, motionEaseInOut: motionEaseInOut, motionDurationMid: motionDurationMid } = token;
    const labelHeight = token.calc(token.controlHeight).sub(token.calc(token.trackPadding).mul(2)).equal();
    const labelHeightLG = token.calc(token.controlHeightLG).sub(token.calc(token.trackPadding).mul(2)).equal();
    const labelHeightSM = token.calc(token.controlHeightSM).sub(token.calc(token.trackPadding).mul(2)).equal();
    return {
        [componentCls]: {
            ...(0, $519d20bf207ce864$export$23997c3e44cc1c59)(token),
            display: "inline-block",
            padding: token.trackPadding,
            color: token.itemColor,
            background: token.trackBg,
            borderRadius: token.borderRadius,
            transition: `all ${motionDurationMid}`,
            ...(0, $519d20bf207ce864$export$a44db842bcb28231)(token),
            [`${componentCls}-group`]: {
                position: "relative",
                display: "flex",
                alignItems: "stretch",
                justifyItems: "flex-start",
                flexDirection: "row",
                width: "100%"
            },
            // RTL styles
            [`&${componentCls}-rtl`]: {
                direction: "rtl"
            },
            [`&${componentCls}-vertical`]: {
                [`${componentCls}-group`]: {
                    flexDirection: "column"
                },
                [`${componentCls}-thumb`]: {
                    width: "100%",
                    height: 0,
                    padding: `0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.paddingXXS)}`
                }
            },
            // block styles
            [`&${componentCls}-block`]: {
                display: "flex"
            },
            [`&${componentCls}-block ${componentCls}-item`]: {
                flex: 1,
                minWidth: 0
            },
            // item styles
            [`${componentCls}-item`]: {
                position: "relative",
                textAlign: "center",
                cursor: "pointer",
                transition: `color ${motionDurationMid}`,
                borderRadius: token.borderRadiusSM,
                // Fix Safari render bug
                // https://github.com/ant-design/ant-design/issues/45250
                transform: "translateZ(0)",
                "&-selected": {
                    ...$432f99a830c1249c$var$getItemSelectedStyle(token),
                    color: token.itemSelectedColor
                },
                "&-focused": (0, $519d20bf207ce864$export$6539948f0a737e39)(token),
                "&::after": {
                    content: '""',
                    position: "absolute",
                    zIndex: -1,
                    width: "100%",
                    height: "100%",
                    top: 0,
                    insetInlineStart: 0,
                    borderRadius: "inherit",
                    opacity: 0,
                    // This is mandatory to make it not clickable or hoverable
                    // Ref: https://github.com/ant-design/ant-design/issues/40888
                    pointerEvents: "none",
                    transition: [
                        "opacity",
                        "background-color"
                    ].map((prop)=>`${prop} ${motionDurationMid}`).join(", ")
                },
                [`&:not(${componentCls}-item-selected):not(${componentCls}-item-disabled)`]: {
                    "&:hover, &:active": {
                        color: token.itemHoverColor
                    },
                    "&:hover::after": {
                        opacity: 1,
                        backgroundColor: token.itemHoverBg
                    },
                    "&:active::after": {
                        opacity: 1,
                        backgroundColor: token.itemActiveBg
                    }
                },
                "&-label": {
                    minHeight: labelHeight,
                    lineHeight: (0, $05f34ed03d41967d$export$523c0b569236b342)(labelHeight),
                    padding: `0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.segmentedPaddingHorizontal)}`,
                    ...$432f99a830c1249c$var$segmentedTextEllipsisCss
                },
                // syntactic sugar to add `icon` for Segmented Item
                "&-icon + *": {
                    marginInlineStart: token.calc(token.marginSM).div(2).equal()
                },
                // Icons from third-party libraries render as a bare `<svg>` inside the icon wrapper,
                // which the `.anticon` reset never reaches. An `<svg>` has no baseline of its own, so it
                // is aligned by its bottom margin edge (CSS 2.1 §10.8.1) and rides above the label.
                // `display: inline-block` keeps it an atomic inline box so `vertical-align` still applies
                // even under a CSS reset that forces `svg { display: block }` (e.g. Tailwind Preflight),
                // which would otherwise drop the icon onto its own line. `vertical-align: middle` centres its
                // margin box on the x-height line; `margin-block-end` then lifts it by half its own value onto
                // the cap-height centre (capHeight − xHeight ≈ 0.2em across typical fonts), keeping it centred
                // at any icon size.
                // Only matches a bare `<svg>`: an `.anticon` keeps its `<svg>` one level deeper.
                "&-icon > svg": {
                    display: "inline-block",
                    verticalAlign: "middle",
                    marginBlockEnd: "0.2em"
                },
                "&-input": {
                    position: "absolute",
                    insetBlockStart: 0,
                    insetInlineStart: 0,
                    width: 0,
                    height: 0,
                    opacity: 0,
                    pointerEvents: "none"
                }
            },
            // thumb styles
            [`${componentCls}-thumb`]: {
                ...$432f99a830c1249c$var$getItemSelectedStyle(token),
                position: "absolute",
                insetBlockStart: 0,
                insetInlineStart: 0,
                width: 0,
                height: "100%",
                padding: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.paddingXXS)} 0`,
                borderRadius: token.borderRadiusSM,
                [`& ~ ${componentCls}-item:not(${componentCls}-item-selected):not(${componentCls}-item-disabled)::after`]: {
                    backgroundColor: "transparent"
                }
            },
            // size styles
            [`&${componentCls}-lg`]: {
                borderRadius: token.borderRadiusLG,
                [`${componentCls}-item-label`]: {
                    minHeight: labelHeightLG,
                    lineHeight: (0, $05f34ed03d41967d$export$523c0b569236b342)(labelHeightLG),
                    padding: `0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.segmentedPaddingHorizontal)}`,
                    fontSize: token.fontSizeLG
                },
                [`${componentCls}-item, ${componentCls}-thumb`]: {
                    borderRadius: token.borderRadius
                }
            },
            [`&${componentCls}-sm`]: {
                borderRadius: token.borderRadiusSM,
                [`${componentCls}-item-label`]: {
                    minHeight: labelHeightSM,
                    lineHeight: (0, $05f34ed03d41967d$export$523c0b569236b342)(labelHeightSM),
                    padding: `0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.segmentedPaddingHorizontalSM)}`
                },
                [`${componentCls}-item, ${componentCls}-thumb`]: {
                    borderRadius: token.borderRadiusXS
                }
            },
            // disabled styles
            ...$432f99a830c1249c$var$getItemDisabledStyle(`&-disabled ${componentCls}-item`, token),
            ...$432f99a830c1249c$var$getItemDisabledStyle(`${componentCls}-item-disabled`, token),
            // transition effect when `appear-active`
            [`${componentCls}-thumb-motion-appear-active`]: {
                willChange: "transform, width",
                transition: [
                    `transform`,
                    `width`
                ].map((prop)=>`${prop} ${motionDurationSlow} ${motionEaseInOut}`).join(", ")
            },
            [`&${componentCls}-shape-round`]: {
                borderRadius: 9999,
                [`${componentCls}-item, ${componentCls}-thumb`]: {
                    borderRadius: 9999
                }
            }
        }
    };
};
const $432f99a830c1249c$export$9ca1be8807fe0675 = (token)=>{
    const { colorTextLabel: colorTextLabel, colorText: colorText, colorFillSecondary: colorFillSecondary, colorBgElevated: colorBgElevated, colorFill: colorFill, lineWidthBold: lineWidthBold, colorBgLayout: colorBgLayout } = token;
    return {
        trackPadding: lineWidthBold,
        trackBg: colorBgLayout,
        itemColor: colorTextLabel,
        itemHoverColor: colorText,
        itemHoverBg: colorFillSecondary,
        itemSelectedBg: colorBgElevated,
        itemActiveBg: colorFill,
        itemSelectedColor: colorText
    };
};
var $432f99a830c1249c$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$51ec95de45185b42)("Segmented", (token)=>{
    const { lineWidth: lineWidth, calc: calc } = token;
    const segmentedToken = (0, $fef50f256b80dfa5$export$4950aa0f605343fb)(token, {
        segmentedPaddingHorizontal: calc(token.controlPaddingHorizontal).sub(lineWidth).equal(),
        segmentedPaddingHorizontalSM: calc(token.controlPaddingHorizontalSM).sub(lineWidth).equal()
    });
    return $432f99a830c1249c$var$genSegmentedStyle(segmentedToken);
}, $432f99a830c1249c$export$9ca1be8807fe0675);


"use client";
function $ac40310dc424be23$var$isSegmentedLabeledOptionWithIcon(option) {
    return (0, $8e2d153a3c855782$export$53b83ca8eaab0383)(option) && !!option?.icon;
}
const $ac40310dc424be23$var$InternalSegmented = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const defaultName = (0, $a2da91bb60e2cbfb$export$2e2bcd8739ae039)();
    const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, block: block, options: options = [], size: customSize, style: style, vertical: vertical, orientation: orientation, shape: shape = "default", name: name = defaultName, styles: styles, classNames: classNames, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("segmented");
    const mergedProps = {
        ...props,
        options: options,
        size: customSize,
        shape: shape
    };
    const contextStyleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $30c5f9f911d4f61b$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: mergedProps
    });
    const prefixCls = getPrefixCls("segmented", customizePrefixCls);
    // Style
    const [hashId, cssVarCls] = (0, $432f99a830c1249c$export$2e2bcd8739ae039)(prefixCls);
    // ===================== Size =====================
    const mergedSize = (0, $78cdfb6138721329$export$2e2bcd8739ae039)(customSize);
    // syntactic sugar to support `icon` for Segmented Item
    const extendedOptions = $cQmXV.useMemo(()=>options.map((option)=>{
            if ($ac40310dc424be23$var$isSegmentedLabeledOptionWithIcon(option)) {
                const { icon: icon, label: label, ...restOption } = option;
                return {
                    ...restOption,
                    label: /*#__PURE__*/ $cQmXV.createElement($cQmXV.Fragment, null, /*#__PURE__*/ $cQmXV.createElement("span", {
                        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-item-icon`, mergedClassNames.icon),
                        style: mergedStyles.icon
                    }, icon), label && /*#__PURE__*/ $cQmXV.createElement("span", null, label))
                };
            }
            return option;
        }), [
        options,
        prefixCls,
        mergedClassNames.icon,
        mergedStyles.icon
    ]);
    const [, mergedVertical] = (0, $78e4f9cb51a5af1c$export$550084c67147f6c4)(orientation, vertical);
    const cls = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(className, rootClassName, contextClassName, mergedClassNames.root, {
        [`${prefixCls}-block`]: block,
        [`${prefixCls}-sm`]: mergedSize === "small",
        [`${prefixCls}-lg`]: mergedSize === "large",
        [`${prefixCls}-vertical`]: mergedVertical,
        [`${prefixCls}-shape-${shape}`]: shape === "round"
    }, hashId, cssVarCls);
    const itemRender = (node, { item: item })=>{
        if (!item.tooltip) return node;
        const tooltipProps = (0, $8e2d153a3c855782$export$53b83ca8eaab0383)(item.tooltip) ? item.tooltip : {
            title: item.tooltip
        };
        return /*#__PURE__*/ $cQmXV.createElement((0, $1e5256cf9d329b2c$export$2e2bcd8739ae039), {
            ...tooltipProps
        }, node);
    };
    return /*#__PURE__*/ $cQmXV.createElement((0, $f87ce7a7485a7a68$export$2e2bcd8739ae039), {
        ...restProps,
        name: name,
        className: cls,
        style: mergedStyles.root,
        classNames: mergedClassNames,
        styles: mergedStyles,
        itemRender: itemRender,
        options: extendedOptions,
        ref: ref,
        prefixCls: prefixCls,
        direction: direction,
        vertical: mergedVertical
    });
});
const $ac40310dc424be23$var$Segmented = $ac40310dc424be23$var$InternalSegmented;
var $ac40310dc424be23$export$2e2bcd8739ae039 = $ac40310dc424be23$var$Segmented;



var $cQmXV = parcelRequire("cQmXV");
var $d81c0c10837648f6$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($d81c0c10837648f6$exports, "__esModule", {
    value: true
});
var $d81c0c10837648f6$var$CheckCircleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0051.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            }
        ]
    },
    "name": "check-circle",
    "theme": "outlined"
};
$d81c0c10837648f6$exports.default = $d81c0c10837648f6$var$CheckCircleOutlined;



function $45839ed7c4a7faa2$var$_extends() {
    $45839ed7c4a7faa2$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $45839ed7c4a7faa2$var$_extends.apply(this, arguments);
}
const $45839ed7c4a7faa2$var$CheckCircleOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $45839ed7c4a7faa2$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d81c0c10837648f6$exports)))
    }));
/**![check-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTY5OSAzNTNoLTQ2LjljLTEwLjIgMC0xOS45IDQuOS0yNS45IDEzLjNMNDY5IDU4NC4zbC03MS4yLTk4LjhjLTYtOC4zLTE1LjYtMTMuMy0yNS45LTEzLjNIMzI1Yy02LjUgMC0xMC4zIDcuNC02LjUgMTIuN2wxMjQuNiAxNzIuOGEzMS44IDMxLjggMCAwMDUxLjcgMGwyMTAuNi0yOTJjMy45LTUuMy4xLTEyLjctNi40LTEyLjd6IiAvPjxwYXRoIGQ9Ik01MTIgNjRDMjY0LjYgNjQgNjQgMjY0LjYgNjQgNTEyczIwMC42IDQ0OCA0NDggNDQ4IDQ0OC0yMDAuNiA0NDgtNDQ4Uzc1OS40IDY0IDUxMiA2NHptMCA4MjBjLTIwNS40IDAtMzcyLTE2Ni42LTM3Mi0zNzJzMTY2LjYtMzcyIDM3Mi0zNzIgMzcyIDE2Ni42IDM3MiAzNzItMTY2LjYgMzcyLTM3MiAzNzJ6IiAvPjwvc3ZnPg==) */ const $45839ed7c4a7faa2$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($45839ed7c4a7faa2$var$CheckCircleOutlined);
var $45839ed7c4a7faa2$export$2e2bcd8739ae039 = $45839ed7c4a7faa2$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $2fb083977effbbee$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($2fb083977effbbee$exports, "__esModule", {
    value: true
});
var $2fb083977effbbee$var$MinusCircleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M696 480H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            }
        ]
    },
    "name": "minus-circle",
    "theme": "outlined"
};
$2fb083977effbbee$exports.default = $2fb083977effbbee$var$MinusCircleOutlined;



function $e539a200877e5e8f$var$_extends() {
    $e539a200877e5e8f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e539a200877e5e8f$var$_extends.apply(this, arguments);
}
const $e539a200877e5e8f$var$MinusCircleOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $e539a200877e5e8f$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2fb083977effbbee$exports)))
    }));
/**![minus-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTY5NiA0ODBIMzI4Yy00LjQgMC04IDMuNi04IDh2NDhjMCA0LjQgMy42IDggOCA4aDM2OGM0LjQgMCA4LTMuNiA4LTh2LTQ4YzAtNC40LTMuNi04LTgtOHoiIC8+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0wIDgyMGMtMjA1LjQgMC0zNzItMTY2LjYtMzcyLTM3MnMxNjYuNi0zNzIgMzcyLTM3MiAzNzIgMTY2LjYgMzcyIDM3Mi0xNjYuNiAzNzItMzcyIDM3MnoiIC8+PC9zdmc+) */ const $e539a200877e5e8f$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($e539a200877e5e8f$var$MinusCircleOutlined);
var $e539a200877e5e8f$export$2e2bcd8739ae039 = $e539a200877e5e8f$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $3b09aa7a5fc7969f$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($3b09aa7a5fc7969f$exports, "__esModule", {
    value: true
});
var $3b09aa7a5fc7969f$var$CalendarOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zM184 392V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136H184z"
                }
            }
        ]
    },
    "name": "calendar",
    "theme": "outlined"
};
$3b09aa7a5fc7969f$exports.default = $3b09aa7a5fc7969f$var$CalendarOutlined;



function $3368c84d60c50017$var$_extends() {
    $3368c84d60c50017$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3368c84d60c50017$var$_extends.apply(this, arguments);
}
const $3368c84d60c50017$var$CalendarOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $3368c84d60c50017$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3b09aa7a5fc7969f$exports)))
    }));
/**![calendar](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg4MCAxODRINzEydi02NGMwLTQuNC0zLjYtOC04LThoLTU2Yy00LjQgMC04IDMuNi04IDh2NjRIMzg0di02NGMwLTQuNC0zLjYtOC04LThoLTU2Yy00LjQgMC04IDMuNi04IDh2NjRIMTQ0Yy0xNy43IDAtMzIgMTQuMy0zMiAzMnY2NjRjMCAxNy43IDE0LjMgMzIgMzIgMzJoNzM2YzE3LjcgMCAzMi0xNC4zIDMyLTMyVjIxNmMwLTE3LjctMTQuMy0zMi0zMi0zMnptLTQwIDY1NkgxODRWNDYwaDY1NnYzODB6TTE4NCAzOTJWMjU2aDEyOHY0OGMwIDQuNCAzLjYgOCA4IDhoNTZjNC40IDAgOC0zLjYgOC04di00OGgyNTZ2NDhjMCA0LjQgMy42IDggOCA4aDU2YzQuNCAwIDgtMy42IDgtOHYtNDhoMTI4djEzNkgxODR6IiAvPjwvc3ZnPg==) */ const $3368c84d60c50017$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($3368c84d60c50017$var$CalendarOutlined);
var $3368c84d60c50017$export$2e2bcd8739ae039 = $3368c84d60c50017$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $aaebab2064b55825$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($aaebab2064b55825$exports, "__esModule", {
    value: true
});
var $aaebab2064b55825$var$CarOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M380 704h264c4.4 0 8-3.6 8-8v-84c0-4.4-3.6-8-8-8h-40c-4.4 0-8 3.6-8 8v36H428v-36c0-4.4-3.6-8-8-8h-40c-4.4 0-8 3.6-8 8v84c0 4.4 3.6 8 8 8zm340-123a40 40 0 1080 0 40 40 0 10-80 0zm239-167.6L935.3 372a8 8 0 00-10.9-2.9l-50.7 29.6-78.3-216.2a63.9 63.9 0 00-60.9-44.4H301.2c-34.7 0-65.5 22.4-76.2 55.5l-74.6 205.2-50.8-29.6a8 8 0 00-10.9 2.9L65 413.4c-2.2 3.8-.9 8.6 2.9 10.8l60.4 35.2-14.5 40c-1.2 3.2-1.8 6.6-1.8 10v348.2c0 15.7 11.8 28.4 26.3 28.4h67.6c12.3 0 23-9.3 25.6-22.3l7.7-37.7h545.6l7.7 37.7c2.7 13 13.3 22.3 25.6 22.3h67.6c14.5 0 26.3-12.7 26.3-28.4V509.4c0-3.4-.6-6.8-1.8-10l-14.5-40 60.3-35.2a8 8 0 003-10.8zM840 517v237H184V517l15.6-43h624.8l15.6 43zM292.7 218.1l.5-1.3.4-1.3c1.1-3.3 4.1-5.5 7.6-5.5h427.6l75.4 208H220l72.7-199.9zM224 581a40 40 0 1080 0 40 40 0 10-80 0z"
                }
            }
        ]
    },
    "name": "car",
    "theme": "outlined"
};
$aaebab2064b55825$exports.default = $aaebab2064b55825$var$CarOutlined;



function $16a2a08666f58b1c$var$_extends() {
    $16a2a08666f58b1c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $16a2a08666f58b1c$var$_extends.apply(this, arguments);
}
const $16a2a08666f58b1c$var$CarOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $16a2a08666f58b1c$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($aaebab2064b55825$exports)))
    }));
/**![car](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTM4MCA3MDRoMjY0YzQuNCAwIDgtMy42IDgtOHYtODRjMC00LjQtMy42LTgtOC04aC00MGMtNC40IDAtOCAzLjYtOCA4djM2SDQyOHYtMzZjMC00LjQtMy42LTgtOC04aC00MGMtNC40IDAtOCAzLjYtOCA4djg0YzAgNC40IDMuNiA4IDggOHptMzQwLTEyM2E0MCA0MCAwIDEwODAgMCA0MCA0MCAwIDEwLTgwIDB6bTIzOS0xNjcuNkw5MzUuMyAzNzJhOCA4IDAgMDAtMTAuOS0yLjlsLTUwLjcgMjkuNi03OC4zLTIxNi4yYTYzLjkgNjMuOSAwIDAwLTYwLjktNDQuNEgzMDEuMmMtMzQuNyAwLTY1LjUgMjIuNC03Ni4yIDU1LjVsLTc0LjYgMjA1LjItNTAuOC0yOS42YTggOCAwIDAwLTEwLjkgMi45TDY1IDQxMy40Yy0yLjIgMy44LS45IDguNiAyLjkgMTAuOGw2MC40IDM1LjItMTQuNSA0MGMtMS4yIDMuMi0xLjggNi42LTEuOCAxMHYzNDguMmMwIDE1LjcgMTEuOCAyOC40IDI2LjMgMjguNGg2Ny42YzEyLjMgMCAyMy05LjMgMjUuNi0yMi4zbDcuNy0zNy43aDU0NS42bDcuNyAzNy43YzIuNyAxMyAxMy4zIDIyLjMgMjUuNiAyMi4zaDY3LjZjMTQuNSAwIDI2LjMtMTIuNyAyNi4zLTI4LjRWNTA5LjRjMC0zLjQtLjYtNi44LTEuOC0xMGwtMTQuNS00MCA2MC4zLTM1LjJhOCA4IDAgMDAzLTEwLjh6TTg0MCA1MTd2MjM3SDE4NFY1MTdsMTUuNi00M2g2MjQuOGwxNS42IDQzek0yOTIuNyAyMTguMWwuNS0xLjMuNC0xLjNjMS4xLTMuMyA0LjEtNS41IDcuNi01LjVoNDI3LjZsNzUuNCAyMDhIMjIwbDcyLjctMTk5Ljl6TTIyNCA1ODFhNDAgNDAgMCAxMDgwIDAgNDAgNDAgMCAxMC04MCAweiIgLz48L3N2Zz4=) */ const $16a2a08666f58b1c$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($16a2a08666f58b1c$var$CarOutlined);
var $16a2a08666f58b1c$export$2e2bcd8739ae039 = $16a2a08666f58b1c$var$RefIcon;



/* EntitySelect — the antd entity dropdown: server-side search, page-on-scroll.
 *
 * docs/design/spec/02-components.md maps the mockups' `.combo` to
 * `<Select showSearch onPopupScroll>`; this is that component, sharing `modelMap`,
 * `EntityDropDownSettings` and `maptoSelect2Objects` with the legacy react-select
 * `EntityDropdown` so option shapes stay identical across both.
 *
 * Why not reuse `EntityDropdown` directly: it renders react-select, which cannot take the
 * `ConfigProvider` theme — a filter row would mix two control kits, two focus rings and two
 * radii on one line. Migrate a screen's dropdowns to this component when that screen is
 * redesigned; do not swap it in under a legacy page.
 *
 * Value contract, deliberately the same as EntityDropdown's so `filterUrl()` keeps working:
 *   isMulti  → an array of full option objects  (`{...entity, value, label}`)
 *   single   → whatever the caller stores; an id or a full object are both accepted in,
 *              and `onChange` always hands back the full option object (or null).
 * A bare id cannot render its own label, so pass `seed` when one is preselected (e.g. the
 * supervisor's own county, which rides on `me` as a full object; an ARRAY of them for a multi
 * select fed from a label cache) — otherwise the first page of options is fetched on mount to
 * resolve it.
 */ 

var $cQmXV = parcelRequire("cQmXV");







/** How close to the bottom of the option list counts as "load the next page". */ const $b6929c6a194abc34$var$SCROLL_SLACK = 48;
/** Rows the `+N` popover lists before it gives up and counts the rest. */ const $b6929c6a194abc34$var$REST_POPOVER_MAX = 30;
const $b6929c6a194abc34$var$idOf = (v)=>v && typeof v === "object" ? v.id ?? v.value : v;
const $b6929c6a194abc34$var$labelOf = (o)=>{
    if (!o || typeof o !== "object") return String(o ?? "");
    return o.label || o.name || [
        o.first_name,
        o.last_name
    ].filter(Boolean).join(" ") || String(o.id ?? "");
};
/** antd wants `{value,label}`; we keep the full entity object beside it for `filterUrl`. */ const $b6929c6a194abc34$var$toAntd = (o)=>({
        value: $b6929c6a194abc34$var$idOf(o),
        label: $b6929c6a194abc34$var$labelOf(o)
    });
function $b6929c6a194abc34$export$2e2bcd8739ae039({ entity: entity, value: value, onChange: onChange, isMulti: isMulti = false, seed: seed = null, county: county, moduleFilter: moduleFilter, extraQuery: extraQuery, prefix: prefix, placeholder: placeholder, disabled: disabled, allowClear: allowClear = true, className: className = "", id: id, maxTagCount: /* Chip overflow. A tight filter row keeps the design's one-chip-plus-`+N`; a full-width form
     field passes `"responsive"` so it shows as many chips as fit.
     ⚠ NO destructuring default here, deliberately. It used to be `maxTagCount = 1`, which meant
     `maxTagCount={undefined}` — precisely what a caller passes to say "no limit" — landed back on
     1. Every `tall` field, including the one built to show a whole group's points in a scrollable
     area, collapsed to one chip plus `+N` with the tall box's extra height sitting empty
     (PICSELL-1574 #34, #23). A default cannot express "unlimited"; `tagLimit` below can. */ maxTagCount, tall: /* A tall, wrapping, scrollable chip area (a group's point list) instead of the default one-row
     control. Overrides the nowrap chrome in `entity-select.scss`, and defaults the chip limit to
     unlimited — showing every chip is the whole reason for the taller box. */ tall = false, ariaLabel: /* For a select with no visible <label> of its own — every field needs an accessible name. */ ariaLabel, onResolve: /**
   * Called with the full option objects once bare ids have been resolved to labels.
   *
   * A shared or bookmarked URL carries ids only, so a caller that restores its state from one
   * holds `{ id: 52 }` and can only render "52". This component already fetches page 1 to name
   * such a value for its own display; the callback hands that work back rather than making every
   * caller repeat the request.
   */ onResolve }) {
    const lang = (0, $b83e93e5ef3de8b0$export$2105062e25df4afe)((state)=>state.me?.language) || "en";
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), key, lang);
    const [options, setOptions] = (0, $cQmXV.useState)([]);
    /* ⚠ Every option ever seen in this scope, by id. `options` holds only the CURRENT page/query and a
     search replaces it wholesale, so resolving a selected id against `options` alone meant that
     typing a new search term turned the existing chips into their raw ids — three chosen points
     became "10 +2", which reads as the selection having been lost (PICSELL-1574 #22, #31). Labels
     have to outlive the option list that supplied them. Kept in state, not a ref, because a chip
     re-renders when a name arrives; `remember` returns the previous Map untouched when nothing is
     new, so it cannot loop. */ const [known, setKnown] = (0, $cQmXV.useState)(()=>new Map());
    const [loading, setLoading] = (0, $cQmXV.useState)(false);
    const [hasMore, setHasMore] = (0, $cQmXV.useState)(true);
    /* How many rows exist server-side, for the panel's `loaded / total` counter — the design's
     `.combo__foot`, which is what tells the user the list is paged rather than short. */ const [total, setTotal] = (0, $cQmXV.useState)(0);
    const page = (0, $cQmXV.useRef)(1);
    const term = (0, $cQmXV.useRef)("");
    /* Only the newest request may paint: a fast typist otherwise gets an older page's
     options landing on top of the current query's. */ const seq = (0, $cQmXV.useRef)(0);
    const debounce = (0, $cQmXV.useRef)(null);
    const seeded = (0, $cQmXV.useRef)(false);
    const scope = `${entity}|${county ?? ""}|${moduleFilter ?? ""}|${JSON.stringify(extraQuery || null)}`;
    const remember = (0, $cQmXV.useCallback)((list)=>{
        setKnown((prev)=>{
            let next = prev;
            list.forEach((o)=>{
                const key = String($b6929c6a194abc34$var$idOf(o));
                if (key && key !== "undefined" && !next.has(key)) {
                    if (next === prev) next = new Map(prev);
                    next.set(key, o);
                }
            });
            return next;
        });
    }, []);
    const buildUrl = (0, $cQmXV.useCallback)((nextPage, query)=>{
        const base = String((0, $91ea30cb49819b9a$export$da688e121885cf48)[entity] || entity).replace(/\/+$/, "");
        let url = `${base}?page=${nextPage}&page_size=${(0, $91ea30cb49819b9a$export$be750171172fb886)}`;
        if (query) url += `&search=${encodeURIComponent(query)}`;
        // Points are scoped by the region and network filters that sit beside them.
        if (entity === "point" || entity === "points") url += `&locality__county=${county || ""}&network=${moduleFilter || ""}`;
        Object.entries(extraQuery || {}).forEach(([k, v])=>{
            if (v !== undefined && v !== null && v !== "") url += `&${k}=${encodeURIComponent(v)}`;
        });
        return url;
    }, [
        entity,
        county,
        moduleFilter,
        extraQuery
    ]);
    const fetchPage = (0, $cQmXV.useCallback)((nextPage, query, append)=>{
        const mine = ++seq.current;
        setLoading(true);
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "GET",
            url: buildUrl(nextPage, query)
        }, (response)=>{
            if (mine !== seq.current) return;
            const rows = Array.isArray(response) ? response : response?.results || [];
            const mapped = (0, $3b579ca6158bc61b$export$b25c9bd295a2cb07)(rows.slice(), entity) || [];
            page.current = nextPage;
            setHasMore(Array.isArray(response) ? false : Boolean(response?.next));
            setTotal(Array.isArray(response) ? response.length : response?.count ?? 0);
            remember(mapped);
            setOptions((prev)=>{
                const byValue = new Map((append ? prev : []).map((o)=>[
                        o.value,
                        o
                    ]));
                mapped.forEach((o)=>byValue.set(o.value, o));
                return Array.from(byValue.values());
            });
            setLoading(false);
        });
    }, [
        entity,
        buildUrl,
        remember
    ]);
    /* Names a preselected id WITHOUT touching the visible option list.
     ⚠ This used to be `fetchPage(1, "", false)`, which replaced `options` with unfiltered page 1 —
     so the moment a chip could not name itself, an active search's results were wiped out and the
     search looked broken (PICSELL-1574 #22). It also bumped `seq`, cancelling the in-flight query.
     Feeding only the label cache keeps the two concerns apart. */ const resolveNames = (0, $cQmXV.useCallback)(()=>{
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "GET",
            url: buildUrl(1, "")
        }, (response)=>{
            const rows = Array.isArray(response) ? response : response?.results || [];
            remember((0, $3b579ca6158bc61b$export$b25c9bd295a2cb07)(rows.slice(), entity) || []);
        });
    }, [
        entity,
        buildUrl,
        remember
    ]);
    /* A scope change (region → points, network → points) invalidates the loaded list; keeping it
     would serve the previous scope's options until the user scrolled. */ (0, $cQmXV.useEffect)(()=>{
        setOptions([]);
        // Cleared with the options: ids are only unique per entity, so a cached label from the previous
        // scope could name the wrong record.
        setKnown(new Map());
        setHasMore(true);
        setTotal(0);
        page.current = 1;
        term.current = "";
        seeded.current = false;
    }, [
        scope
    ]);
    /* Resolve a preselected value to a label. A full object is self-describing; `seed` covers a
     bare id without a request (the supervisor's own county); anything still unresolved falls
     back to showing the raw id and triggers one page-1 fetch to try to name it. That last case
     is how a shared/bookmarked URL arrives — it carries ids only, so a value outside the first
     page of options (points, products) stays as its id. Filtering is still correct. */ const selected = (0, $cQmXV.useMemo)(()=>{
        const list = isMulti ? Array.isArray(value) ? value : [] : value === "" || value === null || value === undefined ? [] : [
            value
        ];
        return list.map((v)=>{
            if (v && typeof v === "object" && (v.label || v.name || v.first_name || v.last_name)) return v;
            const key = $b6929c6a194abc34$var$idOf(v);
            const fromSeed = [].concat(seed || []).find((s)=>s && String($b6929c6a194abc34$var$idOf(s)) === String(key));
            if (fromSeed) return fromSeed;
            return known.get(String(key)) || {
                id: key,
                label: String(key),
                unresolved: true
            };
        });
    }, [
        value,
        isMulti,
        seed,
        known
    ]);
    const hasUnresolved = selected.some((o)=>o.unresolved);
    (0, $cQmXV.useEffect)(()=>{
        if (hasUnresolved && !seeded.current) {
            seeded.current = true;
            resolveNames();
        }
    }, [
        hasUnresolved,
        resolveNames
    ]);
    /* Report the names back up. The signature guard is what keeps this from looping: a caller that
     stores the label re-renders this component, which recomputes `selected` to the same values —
     without it, "report → parent state → re-render → report" would never settle. */ const reported = (0, $cQmXV.useRef)("");
    (0, $cQmXV.useEffect)(()=>{
        if (!onResolve) return;
        const named = selected.filter((o)=>o && !o.unresolved && $b6929c6a194abc34$var$labelOf(o));
        if (!named.length) return;
        // \u0000 / \u0001 as separators, written as ESCAPES not literal bytes: a raw NUL in the
        // source makes the whole file test as binary, and grep then skips it silently on every
        // repo-wide search.
        const signature = named.map((o)=>`${$b6929c6a194abc34$var$idOf(o)}\u0000${$b6929c6a194abc34$var$labelOf(o)}`).join("\x01");
        if (signature === reported.current) return;
        reported.current = signature;
        onResolve(named);
    }, [
        selected,
        onResolve
    ]);
    const handleOpen = (open)=>{
        if (open && !options.length && !loading) fetchPage(1, term.current, false);
    };
    const handleSearch = (query)=>{
        term.current = query;
        clearTimeout(debounce.current);
        debounce.current = setTimeout(()=>fetchPage(1, query, false), (0, $91ea30cb49819b9a$export$8e5d48d2b3bed316));
    };
    const handleScroll = (event)=>{
        const el = event.currentTarget;
        if (loading || !hasMore) return;
        if (el.scrollTop + el.clientHeight >= el.scrollHeight - $b6929c6a194abc34$var$SCROLL_SLACK) fetchPage(page.current + 1, term.current, true);
    };
    /* antd hands back its own `{value,label}` plus the option object it came from; the caller
     needs the entity object (it carries `code` / `name`, which `filterUrl` reads). */ const handleChange = (next, option)=>{
        /* ⚠ Reconstruct from `next` rather than filtering `option`. rc-select hands back `{}` for an
       entry it could not match to a loaded option, so `.map(o => o.entity).filter(Boolean)` DROPPED
       that selection outright — a silent value loss, worst exactly where the labels were already
       unresolved. `next` always carries `{value,label}` (labelInValue), so an unmatched entry can
       still be preserved by id and keep the label rc-select cached for it. */ const fromValue = (v)=>{
            const key = String($b6929c6a194abc34$var$idOf(v));
            return known.get(key) || {
                id: $b6929c6a194abc34$var$idOf(v),
                label: v?.label ?? key
            };
        };
        if (isMulti) {
            const picked = Array.isArray(option) ? option : [];
            const values = Array.isArray(next) ? next : [];
            onChange(values.map((v, i)=>picked[i]?.entity || fromValue(v)));
            return;
        }
        if (next === undefined || next === null) {
            onChange(null);
            return;
        }
        onChange(option?.entity || fromValue(next));
    };
    /* Selected rows are merged in so a value chosen on an earlier page still labels itself, and
     so the tick renders — antd matches by `value`, not by object identity. */ const antdOptions = (0, $cQmXV.useMemo)(()=>{
        const byValue = new Map();
        selected.forEach((o)=>byValue.set($b6929c6a194abc34$var$idOf(o), {
                ...$b6929c6a194abc34$var$toAntd(o),
                entity: o
            }));
        options.forEach((o)=>byValue.set(o.value, {
                ...$b6929c6a194abc34$var$toAntd(o),
                entity: o
            }));
        return Array.from(byValue.values());
    }, [
        options,
        selected
    ]);
    const antdValue = isMulti ? selected.map($b6929c6a194abc34$var$toAntd) : selected.length ? $b6929c6a194abc34$var$toAntd(selected[0]) : undefined;
    /* An explicit prop wins; otherwise a tall control shows every chip and a normal one shows one. */ const tagLimit = maxTagCount !== undefined ? maxTagCount : tall ? undefined : 1;
    /* The matched run is marked, as in the design. Searching is the point of a 600-row list, and
     without it the user has to re-read every row to see why it came back. */ const highlight = (label)=>{
        const query = term.current.trim();
        if (!query) return label;
        const at = label.toLowerCase().indexOf(query.toLowerCase());
        if (at < 0) return label;
        return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $575603080129eb00$exports.Fragment), {
            children: [
                label.slice(0, at),
                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("mark", {
                    children: label.slice(at, at + query.length)
                }),
                label.slice(at + query.length)
            ]
        });
    };
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $872fd39f1285217b$export$2e2bcd8739ae039), {
        id: id,
        "aria-label": ariaLabel,
        className: `es ${tall ? "es--tall" : ""} ${className}`,
        /* `popupClassName` is deprecated in antd v6; the popup's classes live under `classNames`. */ classNames: {
            popup: {
                root: "es-panel"
            }
        },
        mode: isMulti ? "multiple" : undefined,
        labelInValue: true,
        showSearch: true,
        // Search runs on the server; filtering the fetched page again would hide valid rows.
        filterOption: false,
        allowClear: allowClear,
        /* Defaults to one chip plus a `+N` (the design's filter-row behaviour — see the note in
         `entity-select.scss`); a wide form field overrides to `"responsive"`. */ maxTagCount: tagLimit,
        /* antd's default rest label is `+ N ...`; the design's is a bare `+N`. It carried the hidden
         values on a `title` attribute only, which is a slow reveal on a mouse and no reveal at all
         on a touch screen — so "there is no way to see what is actually selected" (PICSELL-1574
         #34, #23). rc-select renders this as a plain span with no popover of its own, so the
         affordance has to be added here. */ maxTagPlaceholder: (rest)=>{
            const hidden = rest.map((r)=>r.label).join(", ");
            return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $81ac8d1f20faf53f$export$2e2bcd8739ae039), {
                trigger: [
                    "hover",
                    "click"
                ],
                content: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                    className: "es-rest",
                    children: [
                        rest.slice(0, $b6929c6a194abc34$var$REST_POPOVER_MAX).map((r)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                                className: "es-rest__row",
                                children: r.label
                            }, String(r.value))),
                        rest.length > $b6929c6a194abc34$var$REST_POPOVER_MAX && /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                            className: "es-rest__more",
                            children: [
                                "+",
                                rest.length - $b6929c6a194abc34$var$REST_POPOVER_MAX
                            ]
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                    title: hidden,
                    "aria-label": hidden,
                    onClick: (event)=>event.stopPropagation(),
                    children: [
                        "+",
                        rest.length
                    ]
                })
            });
        },
        // 264px, the design's `.combo__list` — a little over seven rows, so the list reads as scrollable.
        listHeight: 264,
        disabled: disabled,
        value: antdValue,
        options: antdOptions,
        optionRender: (option)=>highlight(String(option.label ?? "")),
        loading: loading,
        notFoundContent: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
            className: "es-row",
            children: [
                loading ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $62b8cbcd99b9ffa2$export$2e2bcd8739ae039), {
                    size: "small"
                }) : null,
                t(loading ? "option_loading" : "option_no_matches")
            ]
        }),
        /* The design's panel foot: how much of the list is loaded, and whether scrolling brings
         more. Without it a 20-of-620 list looks like a 20-row list. */ popupRender: (menu)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $575603080129eb00$exports.Fragment), {
                children: [
                    menu,
                    options.length > 0 && /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                        className: "es-foot",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                                className: "es-foot__count",
                                children: [
                                    options.length,
                                    " / ",
                                    total || options.length
                                ]
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                children: hasMore ? t("option_scroll_more") : null
                            })
                        ]
                    })
                ]
            }),
        placeholder: placeholder || t((0, $91ea30cb49819b9a$export$846d38fa3865c245)[entity]?.selectTitle) || undefined,
        prefix: prefix,
        onOpenChange: handleOpen,
        onSearch: handleSearch,
        onPopupScroll: handleScroll,
        onChange: handleChange
    });
}








/* How a merchandiser gets around, as a label.
 *
 * ⚠ The option VALUES and their lang keys do not match, and cannot be made to: `bike/scooter`
 * carries a slash. Deriving the key from the value therefore needs a map, and the two call sites
 * that tried to derive it inline instead — `mv_${value}` with a hand-patch for the slash — asked
 * for `mv_public_transport`, which does not exist. `translate()` returned null, so one site fell
 * back to `MOVEMENTS_OPT`'s hardcoded English "Public transport" in ALL FOUR locales and the other
 * two rendered blank (PICSELL-1574 #6). The map lives here so a new movement is one edit, not four.
 *
 * Its own module rather than `MerchList.js` (where a copy of it lived) so the list's stylesheet and
 * deps are not dragged into the detail page's bundle.
 */ 

const $2d75b0952f39a412$var$MOVEMENT_LANG_KEY = {
    "on_foot": "mv_on_foot",
    "motorcycle": "mv_motorcycle",
    "bike/scooter": "mv_bike",
    "automobile": "mv_automobile",
    "public_transport": "mv_public"
};
const $2d75b0952f39a412$export$511554380935107b = (value, lang)=>{
    const key = $2d75b0952f39a412$var$MOVEMENT_LANG_KEY[value];
    return key && (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$20c290c14cdb1327), key, lang) || value || "";
};



const $0460c6defa8dc216$var$PAGE_SIZES = [
    25,
    50,
    100
];
const $0460c6defa8dc216$var$SEGMENTS = [
    [
        "all",
        "seg_all"
    ],
    [
        "active",
        "seg_active"
    ],
    [
        "inactive",
        "seg_inactive"
    ]
];
const $0460c6defa8dc216$var$ORDERING = {
    name: "first_name"
};
const $0460c6defa8dc216$var$FIELD_COL = {
    xs: {
        flex: "0 0 100%"
    },
    md: {
        flex: "0 0 50%"
    },
    xl: {
        flex: "0 0 25%"
    }
};
const $0460c6defa8dc216$var$SEARCH_COL = {
    xs: {
        flex: "0 0 100%"
    },
    md: {
        flex: "0 0 50%"
    }
};
const $0460c6defa8dc216$var$idOf = (v)=>v && typeof v === "object" ? v.id ?? v.value : v;
function $0460c6defa8dc216$var$buildQuery({ search: search, movement: movement, supervisor: supervisor, county: county, segment: segment, absent: absent, newbie: newbie, noPoints: noPoints, page: page, size: size, sort: sort }) {
    const p = new URLSearchParams();
    p.set("page", String(page));
    p.set("page_size", String(size));
    if (search) p.set("search", search);
    if (movement) p.set("movement", movement);
    if (supervisor) p.set("supervisor", String($0460c6defa8dc216$var$idOf(supervisor)));
    if (county) p.set("county", String($0460c6defa8dc216$var$idOf(county)));
    if (segment !== "all") p.set("is_active", segment === "active" ? "true" : "false");
    if (absent) p.set("absent", "true");
    if (newbie) p.set("newbie", "true");
    if (noPoints) p.set("no_points", "true");
    if (sort) p.set("ordering", `${sort.dir === "descend" ? "-" : ""}${$0460c6defa8dc216$var$ORDERING[sort.key]}`);
    return p.toString();
}
function $0460c6defa8dc216$var$stateToSearch({ search: search, movement: movement, supervisor: supervisor, county: county, segment: segment, absent: absent, newbie: newbie, noPoints: noPoints, page: page, size: size, sort: sort }) {
    const p = new URLSearchParams();
    if (search) p.set("q", search);
    if (movement) p.set("movement", movement);
    if (supervisor) p.set("supervisor", String($0460c6defa8dc216$var$idOf(supervisor)));
    if (county) p.set("county", String($0460c6defa8dc216$var$idOf(county)));
    if (segment !== "all") p.set("segment", segment);
    if (absent) p.set("absent", "1");
    if (newbie) p.set("newbie", "1");
    if (noPoints) p.set("no_points", "1");
    if (page > 1) p.set("page", String(page));
    if (size !== $0460c6defa8dc216$var$PAGE_SIZES[0]) p.set("size", String(size));
    if (sort) p.set("sort", `${sort.dir === "descend" ? "-" : ""}${sort.key}`);
    return p.toString();
}
function $0460c6defa8dc216$var$searchToState(locationSearch) {
    const p = new URLSearchParams(locationSearch);
    const sort = p.get("sort");
    return {
        search: p.get("q") || "",
        movement: p.get("movement") || "",
        supervisor: p.get("supervisor") || "",
        /* ⚠ No default region. This used to seed the supervisor's own county on first load, which was
       harmless only because the API dropped `?county=` silently — the control looked live and
       narrowed nothing. Now that `MerchandiserWebFilter` backs it, seeding would hide every
       merchandiser whose county is unset (the column is nullable and was never even serialized) and
       the default view could come up empty. A region nobody picked must not hide people. */ county: p.get("county") || "",
        segment: $0460c6defa8dc216$var$SEGMENTS.some(([value])=>value === p.get("segment")) ? p.get("segment") : "all",
        absent: p.get("absent") === "1",
        newbie: p.get("newbie") === "1",
        noPoints: p.get("no_points") === "1",
        page: Math.max(1, Number(p.get("page")) || 1),
        size: $0460c6defa8dc216$var$PAGE_SIZES.includes(Number(p.get("size"))) ? Number(p.get("size")) : $0460c6defa8dc216$var$PAGE_SIZES[0],
        sort: sort && $0460c6defa8dc216$var$ORDERING[sort.replace(/^-/, "")] ? {
            key: sort.replace(/^-/, ""),
            dir: sort[0] === "-" ? "descend" : "ascend"
        } : null
    };
}
const $0460c6defa8dc216$var$MerchList = ()=>{
    const history = (0, $6f5d68f762d5488a$export$3420e1dc2c4a518c)();
    const location = (0, $6f5d68f762d5488a$export$45d76561a5302f2b)();
    const me = (0, $b83e93e5ef3de8b0$export$2105062e25df4afe)((state)=>state.me);
    const lang = me?.language || "en";
    const movementLabelOf = (key)=>(0, $2d75b0952f39a412$export$511554380935107b)(key, lang);
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$20c290c14cdb1327), key, lang);
    const td = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), key, lang);
    const tp = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b8441a9a81ffc5d6), key, lang);
    const tv = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), key, lang);
    const initial = (0, $cQmXV.useRef)($0460c6defa8dc216$var$searchToState(location.search)).current;
    const [search, setSearch] = (0, $cQmXV.useState)(initial.search);
    const [movement, setMovement] = (0, $cQmXV.useState)(initial.movement);
    const [supervisor, setSupervisor] = (0, $cQmXV.useState)(initial.supervisor);
    const [county, setCounty] = (0, $cQmXV.useState)(initial.county);
    const [segment, setSegment] = (0, $cQmXV.useState)(initial.segment);
    const [absent, setAbsent] = (0, $cQmXV.useState)(initial.absent);
    const [newbie, setNewbie] = (0, $cQmXV.useState)(initial.newbie);
    const [noPoints, setNoPoints] = (0, $cQmXV.useState)(initial.noPoints);
    const [page, setPage] = (0, $cQmXV.useState)(initial.page);
    const [size, setSize] = (0, $cQmXV.useState)(initial.size);
    const [sort, setSort] = (0, $cQmXV.useState)(initial.sort);
    const [chosenCounty, setChosenCounty] = (0, $cQmXV.useState)(null);
    const [chosenSupervisor, setChosenSupervisor] = (0, $cQmXV.useState)(null);
    const [typed, setTyped] = (0, $cQmXV.useState)(initial.search);
    const [rows, setRows] = (0, $cQmXV.useState)([]);
    const [total, setTotal] = (0, $cQmXV.useState)(0);
    const [loading, setLoading] = (0, $cQmXV.useState)(true);
    const [selected, setSelected] = (0, $cQmXV.useState)([]);
    const [busy, setBusy] = (0, $cQmXV.useState)(false);
    const query = (0, $cQmXV.useMemo)(()=>$0460c6defa8dc216$var$buildQuery({
            search: search,
            movement: movement,
            supervisor: supervisor,
            county: county,
            segment: segment,
            absent: absent,
            newbie: newbie,
            noPoints: noPoints,
            page: page,
            size: size,
            sort: sort
        }), [
        search,
        movement,
        supervisor,
        county,
        segment,
        absent,
        newbie,
        noPoints,
        page,
        size,
        sort
    ]);
    (0, $cQmXV.useEffect)(()=>{
        const controller = new AbortController();
        setLoading(true);
        (0, $c9936523dc38c641$export$86557ef9e0794d10)(`merchandisers/?${query}`, controller.signal).then((response)=>{
            if (!response) return;
            setRows(response.results || []);
            setTotal(response.count || 0);
            setLoading(false);
        }).catch((error)=>{
            if (error.name === "AbortError") return;
            setRows([]);
            setTotal(0);
            setLoading(false);
        });
        return ()=>controller.abort();
    }, [
        query
    ]);
    (0, $cQmXV.useEffect)(()=>{
        if (typed === search) return undefined;
        const timer = setTimeout(()=>{
            setSearch(typed);
            setPage(1);
            setSelected([]);
        }, 250);
        return ()=>clearTimeout(timer);
    }, [
        typed,
        search
    ]);
    (0, $cQmXV.useEffect)(()=>{
        const next = $0460c6defa8dc216$var$stateToSearch({
            search: search,
            movement: movement,
            supervisor: supervisor,
            county: county,
            segment: segment,
            absent: absent,
            newbie: newbie,
            noPoints: noPoints,
            page: page,
            size: size,
            sort: sort
        });
        if (next !== location.search.replace(/^\?/, "")) history.replace({
            search: next
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        search,
        movement,
        supervisor,
        county,
        segment,
        absent,
        newbie,
        noPoints,
        page,
        size,
        sort
    ]);
    const narrow = (fn)=>(...args)=>{
            setPage(1);
            setSelected([]);
            fn(...args);
        };
    const resetFilters = narrow(()=>{
        setTyped("");
        setSearch("");
        setMovement("");
        setSupervisor("");
        setChosenSupervisor(null);
        setCounty("");
        setChosenCounty(null);
        setSegment("all");
        setAbsent(false);
        setNewbie(false);
        setNoPoints(false);
        setSort(null);
    });
    const { labels: labels, remember: remember, nameFor: nameFor } = (0, $a9e321bb60aaf998$export$243aa1fcbfd1886a)();
    const chips = (0, $cQmXV.useMemo)(()=>{
        const out = [];
        if (search) out.push({
            key: "q",
            label: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$2cbd0be658ac061c), "search", lang),
            value: search
        });
        if (movement) out.push({
            key: "movement",
            label: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$37c2c40e726df6), "movement", lang),
            value: movementLabelOf(movement)
        });
        if (supervisor) out.push({
            key: "supervisor",
            label: td("supervisor"),
            value: nameFor("supervisor", chosenSupervisor ?? supervisor)
        });
        if (county) out.push({
            key: "county",
            label: td("region"),
            value: nameFor("county", chosenCounty ?? county)
        });
        if (absent) out.push({
            key: "absent",
            label: t("flag_absent")
        });
        if (newbie) out.push({
            key: "newbie",
            label: t("flag_newbie")
        });
        if (noPoints) out.push({
            key: "no_points",
            label: t("flag_no_points")
        });
        return out;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        search,
        movement,
        supervisor,
        chosenSupervisor,
        county,
        chosenCounty,
        absent,
        newbie,
        noPoints,
        labels,
        lang
    ]);
    const clearChip = narrow((key)=>{
        if (key === "q") {
            setTyped("");
            setSearch("");
        } else if (key === "movement") setMovement("");
        else if (key === "supervisor") {
            setSupervisor("");
            setChosenSupervisor(null);
        } else if (key === "county") {
            setCounty("");
            setChosenCounty(null);
        } else if (key === "absent") setAbsent(false);
        else if (key === "newbie") setNewbie(false);
        else if (key === "no_points") setNoPoints(false);
    });
    const patchActive = (row, value)=>new Promise((resolve)=>{
            (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
                method: "PATCH",
                url: `merchandisers/${row.id}/`,
                post: {
                    is_active: value
                }
            }, (response)=>resolve(Boolean(response)));
        });
    const applyLocally = (ids, value)=>{
        setRows((prev)=>prev.map((row)=>ids.includes(row.id) ? {
                    ...row,
                    is_active: value
                } : row));
    };
    const runChange = async (targets, value)=>{
        if (!targets.length) {
            setSelected([]);
            return;
        }
        setBusy(true);
        const results = await Promise.all(targets.map((row)=>patchActive(row, value)));
        setBusy(false);
        const done = targets.filter((row, i)=>results[i]);
        if (done.length) {
            applyLocally(done.map((row)=>row.id), value);
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success((0, $3b579ca6158bc61b$export$9563e054e6f787fb)(t(value ? "activated_msg" : "deactivated_msg"), {
                n: done.length
            }), {
                position: "top-right"
            });
        }
        if (done.length < targets.length) (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).warning((0, $3b579ca6158bc61b$export$9563e054e6f787fb)(t("change_failed_msg"), {
            n: targets.length - done.length
        }), {
            position: "top-right"
        });
        setSelected([]);
    };
    const changeSelected = (value)=>{
        const targets = rows.filter((row)=>selected.includes(row.id) && row.is_active !== value);
        if (value) {
            runChange(targets, true);
            return;
        }
        (0, $05a90c67d3627fd9$export$2e2bcd8739ae039).confirm({
            title: (0, $3b579ca6158bc61b$export$9563e054e6f787fb)(t("confirm_deactivate"), {
                n: targets.length
            }),
            okText: t("deactivate"),
            okButtonProps: {
                danger: true
            },
            cancelText: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f544127b46daf517), "cancel", lang),
            onOk: ()=>runChange(targets, false)
        });
    };
    const openMerch = (row)=>history.push(`/merchandiser/${row.id}`);
    const movementOptions = (0, $cQmXV.useMemo)(()=>Object.keys((0, $6f1c09625235f1f0$export$8e11240bfd4abd6)).map((key)=>({
                value: key,
                label: movementLabelOf(key)
            })), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        lang
    ]);
    const dShort = (d)=>{
        if (!d) return "";
        const date = typeof d === "string" ? new Date(d) : d;
        return date.toLocaleDateString(lang === "uk" ? "uk-UA" : lang === "hy" ? "hy-AM" : lang === "ka" ? "ka-GE" : "en-GB", {
            day: "2-digit",
            month: "short"
        });
    };
    const dOnly = (d)=>{
        if (!d) return "";
        const date = typeof d === "string" ? new Date(d) : d;
        return date.toLocaleDateString(lang === "uk" ? "uk-UA" : lang === "hy" ? "hy-AM" : lang === "ka" ? "ka-GE" : "en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric"
        });
    };
    const columns = (0, $cQmXV.useMemo)(()=>[
            (0, $66539b2560a58e4e$export$81ff514f95f0c424)((value, row)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $66539b2560a58e4e$export$b131c49b26d3f427), {
                    Icon: row.is_active ? (0, $45839ed7c4a7faa2$export$2e2bcd8739ae039) : (0, $e539a200877e5e8f$export$2e2bcd8739ae039),
                    tone: row.is_active ? "ok" : "off",
                    label: t(row.is_active ? "status_active" : "status_inactive")
                })),
            {
                key: "name",
                title: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ac552071080927b0), "f_name", lang),
                width: 260,
                fixed: "left",
                ellipsis: true,
                sorter: true,
                render: (value, row)=>{
                    const name = (0, $66539b2560a58e4e$export$1d6cfa7493842c29)(row);
                    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                        className: "mc-who",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $72b7444d01b36e98$export$2e2bcd8739ae039), {
                                size: 28,
                                className: "lp-who__av",
                                style: {
                                    fontSize: 12
                                },
                                src: row.photo ?? null,
                                children: (0, $66539b2560a58e4e$export$f6a098653d630c23)(name)
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                                className: "mc-who__info",
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                        strong: true,
                                        ellipsis: {
                                            tooltip: name
                                        },
                                        children: name || (0, $66539b2560a58e4e$export$eb03490a10c3abc9)
                                    }),
                                    row.phone_number && /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                        className: "mc-who__phone",
                                        children: row.phone_number
                                    })
                                ]
                            })
                        ]
                    });
                }
            },
            {
                key: "availability",
                title: t("availability"),
                width: 200,
                render: (value, row)=>{
                    if (!row.is_active) return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                        className: "mc-pill mc-pill--off",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e539a200877e5e8f$export$2e2bcd8739ae039), {
                                className: "mc-pill__icon"
                            }),
                            t("status_inactive")
                        ]
                    });
                    const away = row.current_absence;
                    const next = row.next_absence;
                    const isNew = row.is_newbie;
                    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                        className: "mc-avail",
                        children: [
                            away ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                                className: "mc-pill mc-pill--warn",
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3368c84d60c50017$export$2e2bcd8739ae039), {
                                        className: "mc-pill__icon"
                                    }),
                                    t("away_until"),
                                    " ",
                                    dShort(away.end)
                                ]
                            }) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                                className: "mc-pill mc-pill--ok",
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $45839ed7c4a7faa2$export$2e2bcd8739ae039), {
                                        className: "mc-pill__icon"
                                    }),
                                    t("available")
                                ]
                            }),
                            !away && next && /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                                className: "mc-tag",
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3368c84d60c50017$export$2e2bcd8739ae039), {
                                        className: "mc-tag__icon"
                                    }),
                                    dShort(next.start)
                                ]
                            }),
                            isNew && /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                className: "mc-tag mc-tag--new",
                                children: t("newbie")
                            })
                        ]
                    });
                }
            },
            {
                key: "movement",
                title: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$37c2c40e726df6), "movement", lang),
                width: 170,
                render: (value, row)=>{
                    if (!row.movement) return 0, $66539b2560a58e4e$export$eb03490a10c3abc9;
                    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                        className: "mc-mv",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $16a2a08666f58b1c$export$2e2bcd8739ae039), {
                                className: "mc-mv__icon"
                            }),
                            movementLabelOf(row.movement)
                        ]
                    });
                }
            },
            /* No coverage COUNT and no 7-day visit COUNT — both were per-row aggregates that Django 3.1
         re-runs inside the list's pagination `COUNT(*)` (see CLAUDE.md). The "no points" question
         is still askable, and better: it is the chip in the filter row, which the server answers
         with an `Exists`. `last_visit` replaces the visit count — one indexed subquery, and the
         date answers "are they working" more directly than a 7-day total.
         Neither is sortable: `ordering` accepts only what `ORDERING` maps. */ {
                key: "last_visit",
                title: t("last_visit"),
                dataIndex: "last_visit",
                width: 130,
                align: "right",
                render: (value)=>value ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "lp-num",
                        children: dShort(value)
                    }) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                        type: "secondary",
                        children: t("never_visited")
                    })
            },
            {
                key: "supervisor_name",
                title: td("supervisor"),
                width: 170,
                ellipsis: true,
                render: (value, row)=>row.supervisor_name || (0, $66539b2560a58e4e$export$eb03490a10c3abc9)
            },
            {
                key: "tenure",
                title: t("tenure"),
                width: 140,
                render: (value, row)=>{
                    if (!row.date_joined) return 0, $66539b2560a58e4e$export$eb03490a10c3abc9;
                    const joined = new Date(row.date_joined);
                    const days = Math.round((Date.now() - joined.getTime()) / 864e5);
                    const years = Math.floor(days / 365);
                    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                        vertical: true,
                        className: "lp-main",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                strong: true,
                                className: "lp-num",
                                children: years >= 1 ? `${years} ${t("yr_short")}` : `${days} ${t("days_short")}`
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                type: "secondary",
                                className: "lp-main__sub",
                                children: dOnly(row.date_joined)
                            })
                        ]
                    });
                }
            },
            (0, $66539b2560a58e4e$export$b0493221521ca587)((value, row)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $66539b2560a58e4e$export$523acc1bb0ce2e43), {
                    label: tv("row_actions"),
                    items: [
                        {
                            key: "open",
                            icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $357da3723e13ae38$export$2e2bcd8739ae039), {}),
                            label: t("open")
                        },
                        {
                            key: "absence",
                            icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3368c84d60c50017$export$2e2bcd8739ae039), {}),
                            label: t("add_absence")
                        },
                        row.is_active ? {
                            key: "deactivate",
                            icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e539a200877e5e8f$export$2e2bcd8739ae039), {}),
                            label: t("deactivate"),
                            danger: true
                        } : {
                            key: "activate",
                            icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $45839ed7c4a7faa2$export$2e2bcd8739ae039), {}),
                            label: t("activate")
                        }
                    ],
                    onClick: (key)=>{
                        if (key === "open") openMerch(row);
                        else if (key === "absence") history.push(`/merchandiser/${row.id}`);
                        else if (key === "activate") runChange([
                            row
                        ], true);
                        else (0, $05a90c67d3627fd9$export$2e2bcd8739ae039).confirm({
                            title: (0, $3b579ca6158bc61b$export$9563e054e6f787fb)(t("confirm_deactivate"), {
                                n: 1
                            }),
                            okText: t("deactivate"),
                            okButtonProps: {
                                danger: true
                            },
                            cancelText: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f544127b46daf517), "cancel", lang),
                            onOk: ()=>runChange([
                                    row
                                ], false)
                        });
                    }
                }))
        ], // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        lang,
        rows
    ]);
    const scrollY = (0, $66539b2560a58e4e$export$f44b992e82788e9)();
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
        vertical: true,
        gap: "middle",
        className: "shell-content lp mc",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                className: "lp-head",
                justify: "space-between",
                align: "flex-end",
                gap: "middle",
                wrap: true,
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                        vertical: true,
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Title, {
                                level: 1,
                                className: "lp-title",
                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$72266474e9355649), "merchandiser", lang)
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Paragraph, {
                                type: "secondary",
                                className: "lp-sub",
                                children: t("page_sub")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                        type: "primary",
                        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $fa25166ced813feb$export$2e2bcd8739ae039), {}),
                        onClick: ()=>history.push("/merchandiser/new"),
                        children: t("new_merch")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b4fda840b736e640$export$2e2bcd8739ae039), {
                className: "lp-filters",
                variant: "outlined",
                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039), {
                    layout: "vertical",
                    component: false,
                    colon: false,
                    children: [
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $db6c3adada49524e$export$2e2bcd8739ae039), {
                            gutter: [
                                12,
                                12
                            ],
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $cde227eb983ae1d2$export$2e2bcd8739ae039), {
                                    ...$0460c6defa8dc216$var$SEARCH_COL,
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                        label: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$2cbd0be658ac061c), "search", lang),
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0883e7f8083c01b0$export$2e2bcd8739ae039), {
                                            allowClear: true,
                                            prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $20a259d46bffcb08$export$2e2bcd8739ae039), {}),
                                            placeholder: t("search_ph"),
                                            value: typed,
                                            onChange: (event)=>setTyped(event.target.value)
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $cde227eb983ae1d2$export$2e2bcd8739ae039), {
                                    ...$0460c6defa8dc216$var$FIELD_COL,
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                        label: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$37c2c40e726df6), "movement", lang),
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $872fd39f1285217b$export$2e2bcd8739ae039), {
                                            allowClear: true,
                                            placeholder: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$37c2c40e726df6), "movement", lang),
                                            value: movement || undefined,
                                            options: movementOptions,
                                            onChange: narrow((v)=>setMovement(v || ""))
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $cde227eb983ae1d2$export$2e2bcd8739ae039), {
                                    ...$0460c6defa8dc216$var$FIELD_COL,
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                        label: td("supervisor"),
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b6929c6a194abc34$export$2e2bcd8739ae039), {
                                            entity: "supervisor",
                                            value: supervisor,
                                            seed: chosenSupervisor,
                                            prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $d5baeea001a6abe5$export$2e2bcd8739ae039), {}),
                                            onChange: narrow((option)=>{
                                                setChosenSupervisor(option);
                                                setSupervisor(option ? $0460c6defa8dc216$var$idOf(option) : "");
                                            }),
                                            onResolve: remember("supervisor")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $cde227eb983ae1d2$export$2e2bcd8739ae039), {
                                    ...$0460c6defa8dc216$var$FIELD_COL,
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                        label: td("region"),
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b6929c6a194abc34$export$2e2bcd8739ae039), {
                                            entity: "county",
                                            value: county,
                                            seed: chosenCounty || (me?.county && typeof me.county === "object" ? me.county : null),
                                            prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $68eebcef827bb540$export$2e2bcd8739ae039), {}),
                                            onChange: narrow((option)=>{
                                                setChosenCounty(option);
                                                setCounty(option ? $0460c6defa8dc216$var$idOf(option) : "");
                                            }),
                                            onResolve: remember("county")
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $a9e321bb60aaf998$export$2e2bcd8739ae039), {
                            className: "lp-chips",
                            items: chips,
                            closeLabel: tp("a_remove_filter"),
                            onClose: clearChip
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                            className: "lp-filters__foot",
                            align: "center",
                            gap: "small",
                            wrap: true,
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $ac40310dc424be23$export$2e2bcd8739ae039), {
                                    value: segment,
                                    onChange: narrow(setSegment),
                                    options: $0460c6defa8dc216$var$SEGMENTS.map(([value, key])=>({
                                            value: value,
                                            label: t(key)
                                        }))
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $602120e6d17ff12a$export$2e2bcd8739ae039).CheckableTag, {
                                    className: "mc-chip",
                                    checked: absent,
                                    onChange: narrow(setAbsent),
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $eb1133c43d00490b$export$2e2bcd8739ae039), {
                                        size: 6,
                                        children: [
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3368c84d60c50017$export$2e2bcd8739ae039), {}),
                                            t("flag_absent")
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $602120e6d17ff12a$export$2e2bcd8739ae039).CheckableTag, {
                                    className: "mc-chip",
                                    checked: newbie,
                                    onChange: narrow(setNewbie),
                                    children: t("flag_newbie")
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $602120e6d17ff12a$export$2e2bcd8739ae039).CheckableTag, {
                                    className: "mc-chip",
                                    checked: noPoints,
                                    onChange: narrow(setNoPoints),
                                    children: t("flag_no_points")
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                    className: "lp-spacer"
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                    size: "small",
                                    onClick: resetFilters,
                                    children: td("filter_reset")
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $b4fda840b736e640$export$2e2bcd8739ae039), {
                className: "lp-table",
                variant: "outlined",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                        className: "lp-table__bar",
                        align: "center",
                        gap: "small",
                        wrap: true,
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                strong: true,
                                className: "lp-table__title",
                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$72266474e9355649), "merchandiser", lang)
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                type: "secondary",
                                "aria-live": "polite",
                                children: [
                                    tp("records_count"),
                                    ": ",
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                        strong: true,
                                        children: total
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $dff4d45d201c6dfe$export$2e2bcd8739ae039), {
                        className: "lp-table__grid",
                        rowKey: "id",
                        size: "middle",
                        columns: columns,
                        dataSource: rows,
                        loading: loading,
                        scroll: {
                            x: 1100,
                            y: scrollY
                        },
                        rowClassName: (row)=>selected.includes(row.id) ? "lp-row lp-row--on" : "lp-row",
                        rowSelection: {
                            fixed: true,
                            selectedRowKeys: selected,
                            onChange: (keys)=>setSelected(keys)
                        },
                        onRow: (row)=>({
                                onClick: (event)=>{
                                    if (event.target.closest(".ant-table-selection-column, .ant-dropdown, .ant-btn")) return;
                                    openMerch(row);
                                }
                            }),
                        onChange: (pagination, filters, sorter)=>{
                            const next = sorter?.order && $0460c6defa8dc216$var$ORDERING[sorter.columnKey] ? {
                                key: sorter.columnKey,
                                dir: sorter.order
                            } : null;
                            if (JSON.stringify(next) === JSON.stringify(sort)) return;
                            setSort(next);
                            setPage(1);
                        },
                        pagination: false,
                        locale: {
                            emptyText: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $99350450b877904c$export$2e2bcd8739ae039), {
                                image: (0, $99350450b877904c$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE,
                                description: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                    vertical: true,
                                    gap: 4,
                                    children: [
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                            strong: true,
                                            children: t("empty_title")
                                        }),
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                            type: "secondary",
                                            children: t("empty_desc")
                                        })
                                    ]
                                })
                            })
                        }
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $66539b2560a58e4e$export$6cb97cd1ceda576d), {
                        id: "mc",
                        page: page,
                        size: size,
                        total: total,
                        sizes: $0460c6defa8dc216$var$PAGE_SIZES,
                        labels: {
                            perPage: tv("rows_per_page"),
                            range: tv("range_of")
                        },
                        onPage: (next)=>{
                            setPage(next);
                            setSelected([]);
                        },
                        onSize: (next)=>{
                            setSize(next);
                            setPage(1);
                            setSelected([]);
                        }
                    })
                ]
            }),
            selected.length > 0 && /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                className: "lp-bulkbar",
                align: "center",
                gap: "middle",
                wrap: true,
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                        className: "lp-bulkbar__n",
                        children: (0, $3b579ca6158bc61b$export$9563e054e6f787fb)(tp("w_selected"), {
                            n: selected.length
                        })
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $eb1133c43d00490b$export$2e2bcd8739ae039), {
                        size: 8,
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                size: "small",
                                onClick: ()=>setSelected([]),
                                children: tp("clear_selection")
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                size: "small",
                                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $45839ed7c4a7faa2$export$2e2bcd8739ae039), {}),
                                loading: busy,
                                onClick: ()=>changeSelected(true),
                                children: t("activate")
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                size: "small",
                                danger: true,
                                type: "primary",
                                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e539a200877e5e8f$export$2e2bcd8739ae039), {}),
                                loading: busy,
                                onClick: ()=>changeSelected(false),
                                children: t("deactivate")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $0460c6defa8dc216$export$2e2bcd8739ae039 = $0460c6defa8dc216$var$MerchList;


/* Merchandiser detail — one person, their profile, routes, tasks, visits, absences.
   Archetype B (spec/03): two-column grid, sticky command bar, view/edit toggle,
   one tab mounted at a time.

   deactivation is `is_active` via PATCH — one flag, no archive.
   Routes tab reuses the existing `Route.js` component (already functional/modern).
   Absences are fetched per tab, not embedded in the merchandiser record. */ 

var $cQmXV = parcelRequire("cQmXV");



var $cQmXV = parcelRequire("cQmXV");








const $eb515b8ef1d95a99$var$DEFAULT_COLUMN_MAP = {
    xxxl: 4,
    xxl: 3,
    xl: 3,
    lg: 3,
    md: 3,
    sm: 2,
    xs: 1
};
var $eb515b8ef1d95a99$export$2e2bcd8739ae039 = $eb515b8ef1d95a99$var$DEFAULT_COLUMN_MAP;



var $cQmXV = parcelRequire("cQmXV");
const $96f708a61aec115b$var$DescriptionsContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createContext(null);
var $96f708a61aec115b$export$2e2bcd8739ae039 = $96f708a61aec115b$var$DescriptionsContext;



var $cQmXV = parcelRequire("cQmXV");



// Convert children into items
const $1072ac9c2d859b3a$var$transChildren2Items = (childNodes)=>(0, $cd966a313e0a92ff$export$2e2bcd8739ae039)(childNodes).map((node)=>({
            ...node?.props,
            key: node.key
        }));
function $1072ac9c2d859b3a$export$2e2bcd8739ae039(screens, items, children) {
    const mergedItems = $cQmXV.useMemo(()=>// Take `items` first or convert `children` into items
        items || $1072ac9c2d859b3a$var$transChildren2Items(children), [
        items,
        children
    ]);
    const responsiveItems = $cQmXV.useMemo(()=>mergedItems.map(({ span: span, ...restItem })=>{
            if (span === "filled") return {
                ...restItem,
                filled: true
            };
            return {
                ...restItem,
                span: (0, $8e2d153a3c855782$export$7e4aa119212bc614)(span) ? span : (0, $93a56f4fa79d4cc2$export$862220c15691d248)(screens, span)
            };
        }), [
        mergedItems,
        screens
    ]);
    return responsiveItems;
}



var $cQmXV = parcelRequire("cQmXV");

// Calculate the sum of span in a row
function $d9e437715d88b284$var$getCalcRows(rowItems, mergedColumn) {
    let rows = [];
    let tmpRow = [];
    let exceed = false;
    let count = 0;
    rowItems.filter((n)=>n).forEach((rowItem)=>{
        const { filled: filled, ...restItem } = rowItem;
        if (filled) {
            tmpRow.push(restItem);
            rows.push(tmpRow);
            // reset
            tmpRow = [];
            count = 0;
            return;
        }
        const restSpan = mergedColumn - count;
        count += rowItem.span || 1;
        if (count >= mergedColumn) {
            if (count > mergedColumn) {
                exceed = true;
                tmpRow.push({
                    ...restItem,
                    span: restSpan
                });
            } else tmpRow.push(restItem);
            rows.push(tmpRow);
            // reset
            tmpRow = [];
            count = 0;
        } else tmpRow.push(restItem);
    });
    if (tmpRow.length > 0) rows.push(tmpRow);
    rows = rows.map((rows)=>{
        const count = rows.reduce((acc, item)=>acc + (item.span || 1), 0);
        if (count < mergedColumn) {
            // If the span of the last element in the current row is less than the column, then add its span to the remaining columns
            const last = rows[rows.length - 1];
            last.span = mergedColumn - (count - (last.span || 1));
            return rows;
        }
        return rows;
    });
    return [
        rows,
        exceed
    ];
}
const $d9e437715d88b284$var$useRow = (mergedColumn, items)=>{
    const [rows, exceed] = (0, $cQmXV.useMemo)(()=>$d9e437715d88b284$var$getCalcRows(items, mergedColumn), [
        items,
        mergedColumn
    ]);
    return rows;
};
var $d9e437715d88b284$export$2e2bcd8739ae039 = $d9e437715d88b284$var$useRow;


// JSX Structure Syntactic Sugar. Never reach the render code.
/* istanbul ignore next */ const $97a8bdadc1559f4e$var$DescriptionsItem = (props)=>{
    return props.children;
};
var $97a8bdadc1559f4e$export$2e2bcd8739ae039 = $97a8bdadc1559f4e$var$DescriptionsItem;



var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");




"use client";
const $73df140d8def76ac$var$Cell = (props)=>{
    const { itemPrefixCls: itemPrefixCls, component: component, span: span, className: className, style: style, labelStyle: labelStyle, contentStyle: contentStyle, bordered: bordered, label: label, content: content, colon: colon, type: type, styles: styles, classNames: classNames } = props;
    const Component = component;
    const { classNames: contextClassNames, styles: contextStyles } = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useContext((0, $96f708a61aec115b$export$2e2bcd8739ae039));
    const [mergedClassNames, mergedStyles] = (0, $30c5f9f911d4f61b$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: props
    });
    const mergedLabelStyle = {
        ...labelStyle,
        ...mergedStyles.label
    };
    const mergedContentStyle = {
        ...contentStyle,
        ...mergedStyles.content
    };
    if (bordered) {
        // The cell element (<th>/<td>) carries the `ant-descriptions-item-label`
        // or `ant-descriptions-item-content` class, so `labelStyle` /
        // `contentStyle` (and the semantic `styles.label` / `styles.content`)
        // must be applied to that cell rather than to the inner <span> wrapper.
        //
        // Both bordered paths in `Row.tsx` (horizontal and vertical) forward
        // the per-type merged style via `styles` and pass the raw item `style`
        // separately, so `Cell` can unconditionally merge `typeStyle` onto the
        // cell here without needing to know which branch produced it.
        let typeStyle;
        if (type === "label") typeStyle = mergedLabelStyle;
        if (type === "content") typeStyle = mergedContentStyle;
        const mergedCellStyle = typeStyle ? {
            ...style,
            ...typeStyle
        } : style;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement(Component, {
            colSpan: span,
            style: mergedCellStyle,
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(className, {
                [`${itemPrefixCls}-item-${type}`]: type === "label" || type === "content",
                [mergedClassNames.label]: mergedClassNames.label && type === "label",
                [mergedClassNames.content]: mergedClassNames.content && type === "content"
            })
        }, (0, $8e2d153a3c855782$export$72280d5f896dac9a)(label) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("span", null, label), (0, $8e2d153a3c855782$export$72280d5f896dac9a)(content) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("span", null, content));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement(Component, {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${itemPrefixCls}-item`, className),
        style: style,
        colSpan: span
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
        className: `${itemPrefixCls}-item-container`
    }, (0, $8e2d153a3c855782$export$72280d5f896dac9a)(label) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("span", {
        style: mergedLabelStyle,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${itemPrefixCls}-item-label`, mergedClassNames.label, {
            [`${itemPrefixCls}-item-no-colon`]: !colon
        })
    }, label), (0, $8e2d153a3c855782$export$72280d5f896dac9a)(content) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("span", {
        style: mergedContentStyle,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${itemPrefixCls}-item-content`, mergedClassNames.content)
    }, content)));
};
var $73df140d8def76ac$export$2e2bcd8739ae039 = $73df140d8def76ac$var$Cell;



"use client";
function $edbea5835295237c$var$renderCells(items, { colon: colon, prefixCls: prefixCls, bordered: bordered }, { component: component, type: type, showLabel: showLabel, showContent: showContent, labelStyle: rootLabelStyle, contentStyle: rootContentStyle, styles: rootStyles }) {
    return items.map(({ label: label, children: children, prefixCls: itemPrefixCls = prefixCls, className: className, style: style, labelStyle: labelStyle, contentStyle: contentStyle, span: span = 1, key: key, styles: styles, classNames: classNames }, index)=>{
        if (typeof component === "string") return /*#__PURE__*/ $cQmXV.createElement((0, $73df140d8def76ac$export$2e2bcd8739ae039), {
            key: `${type}-${key || index}`,
            className: className,
            style: style,
            classNames: classNames,
            styles: {
                label: {
                    ...rootLabelStyle,
                    ...rootStyles?.label,
                    ...labelStyle,
                    ...styles?.label
                },
                content: {
                    ...rootContentStyle,
                    ...rootStyles?.content,
                    ...contentStyle,
                    ...styles?.content
                }
            },
            span: span,
            colon: colon,
            component: component,
            itemPrefixCls: itemPrefixCls,
            bordered: bordered,
            label: showLabel ? label : null,
            content: showContent ? children : null,
            type: type
        });
        const mergedStyles = {
            label: {
                ...rootLabelStyle,
                ...rootStyles?.label,
                ...labelStyle,
                ...styles?.label
            },
            content: {
                ...rootContentStyle,
                ...rootStyles?.content,
                ...contentStyle,
                ...styles?.content
            }
        };
        return [
            /*#__PURE__*/ $cQmXV.createElement((0, $73df140d8def76ac$export$2e2bcd8739ae039), {
                key: `label-${key || index}`,
                className: className,
                style: style,
                classNames: classNames,
                styles: mergedStyles,
                span: 1,
                colon: colon,
                component: component[0],
                itemPrefixCls: itemPrefixCls,
                bordered: bordered,
                label: label,
                type: "label"
            }),
            /*#__PURE__*/ $cQmXV.createElement((0, $73df140d8def76ac$export$2e2bcd8739ae039), {
                key: `content-${key || index}`,
                className: className,
                style: style,
                classNames: classNames,
                styles: mergedStyles,
                span: span * 2 - 1,
                component: component[1],
                itemPrefixCls: itemPrefixCls,
                bordered: bordered,
                content: children,
                type: "content"
            })
        ];
    });
}
const $edbea5835295237c$var$Row = (props)=>{
    const descContext = $cQmXV.useContext((0, $96f708a61aec115b$export$2e2bcd8739ae039));
    const { prefixCls: prefixCls, vertical: vertical, row: row, index: index, bordered: bordered } = props;
    if (vertical) return /*#__PURE__*/ $cQmXV.createElement($cQmXV.Fragment, null, /*#__PURE__*/ $cQmXV.createElement("tr", {
        key: `label-${index}`,
        className: `${prefixCls}-row`
    }, $edbea5835295237c$var$renderCells(row, props, {
        component: "th",
        type: "label",
        showLabel: true,
        ...descContext
    })), /*#__PURE__*/ $cQmXV.createElement("tr", {
        key: `content-${index}`,
        className: `${prefixCls}-row`
    }, $edbea5835295237c$var$renderCells(row, props, {
        component: "td",
        type: "content",
        showContent: true,
        ...descContext
    })));
    return /*#__PURE__*/ $cQmXV.createElement("tr", {
        key: index,
        className: `${prefixCls}-row`
    }, $edbea5835295237c$var$renderCells(row, props, {
        component: bordered ? [
            "th",
            "td"
        ] : "td",
        type: "item",
        showLabel: true,
        showContent: true,
        ...descContext
    }));
};
var $edbea5835295237c$export$2e2bcd8739ae039 = $edbea5835295237c$var$Row;





const $90febec7c787bb98$var$genBorderedStyle = (token)=>{
    const { componentCls: componentCls, labelBg: labelBg } = token;
    return {
        [`&${componentCls}-bordered`]: {
            [`> ${componentCls}-view`]: {
                border: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorSplit}`,
                "> table": {
                    tableLayout: "auto"
                },
                [`${componentCls}-row`]: {
                    borderBottom: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorSplit}`,
                    "&:first-child": {
                        "> th:first-child, > td:first-child": {
                            borderStartStartRadius: token.borderRadiusLG
                        }
                    },
                    "&:last-child": {
                        borderBottom: "none",
                        "> th:first-child, > td:first-child": {
                            borderEndStartRadius: token.borderRadiusLG
                        }
                    },
                    [`> ${componentCls}-item-label, > ${componentCls}-item-content`]: {
                        padding: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.padding)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.paddingLG)}`,
                        borderInlineEnd: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorSplit}`,
                        "&:last-child": {
                            borderInlineEnd: "none"
                        }
                    },
                    [`> ${componentCls}-item-label`]: {
                        color: token.colorTextSecondary,
                        backgroundColor: labelBg,
                        "&::after": {
                            display: "none"
                        }
                    }
                }
            },
            [`&${componentCls}-medium`]: {
                [`${componentCls}-row`]: {
                    [`> ${componentCls}-item-label, > ${componentCls}-item-content`]: {
                        padding: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.paddingSM)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.paddingLG)}`
                    }
                }
            },
            [`&${componentCls}-small`]: {
                [`${componentCls}-row`]: {
                    [`> ${componentCls}-item-label, > ${componentCls}-item-content`]: {
                        padding: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.paddingXS)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.padding)}`
                    }
                }
            }
        }
    };
};
const $90febec7c787bb98$var$genDescriptionStyles = (token)=>{
    const { componentCls: componentCls, extraColor: extraColor, itemPaddingBottom: itemPaddingBottom, itemPaddingEnd: itemPaddingEnd, colonMarginRight: colonMarginRight, colonMarginLeft: colonMarginLeft, titleMarginBottom: titleMarginBottom } = token;
    return {
        [componentCls]: {
            ...(0, $519d20bf207ce864$export$23997c3e44cc1c59)(token),
            ...$90febec7c787bb98$var$genBorderedStyle(token),
            "&-rtl": {
                direction: "rtl"
            },
            [`${componentCls}-header`]: {
                display: "flex",
                alignItems: "center",
                marginBottom: titleMarginBottom
            },
            [`${componentCls}-title`]: {
                ...(0, $519d20bf207ce864$export$b2b65df0d0824629),
                flex: "auto",
                color: token.titleColor,
                fontWeight: token.fontWeightStrong,
                fontSize: token.fontSizeLG,
                lineHeight: token.lineHeightLG
            },
            [`${componentCls}-extra`]: {
                marginInlineStart: "auto",
                color: extraColor,
                fontSize: token.fontSize
            },
            [`${componentCls}-view`]: {
                // #54268 used `width: 0` with `min-width: 100%` to avoid oversized
                // intrinsic widths in max-content ancestors. Keep the wrapper at
                // `width: 100%` so it remains measurable in shrink-to-fit containers
                // like Popover (#58574), while the inner table preserves the minimum.
                width: "100%",
                borderRadius: token.borderRadiusLG,
                table: {
                    minWidth: "100%",
                    tableLayout: "fixed",
                    borderCollapse: "collapse"
                }
            },
            [`${componentCls}-row`]: {
                "> th, > td": {
                    paddingBottom: itemPaddingBottom,
                    paddingInlineEnd: itemPaddingEnd
                },
                "> th:last-child, > td:last-child": {
                    paddingInlineEnd: 0
                },
                "&:last-child": {
                    borderBottom: "none",
                    "> th, > td": {
                        paddingBottom: 0
                    }
                }
            },
            [`${componentCls}-item-label`]: {
                color: token.labelColor,
                fontWeight: "normal",
                fontSize: token.fontSize,
                lineHeight: token.lineHeight,
                textAlign: "start",
                "&::after": {
                    content: '":"',
                    position: "relative",
                    top: -0.5,
                    // magic for position
                    marginInline: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(colonMarginLeft)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(colonMarginRight)}`
                },
                [`&${componentCls}-item-no-colon::after`]: {
                    content: '""'
                }
            },
            [`${componentCls}-item-no-label`]: {
                "&::after": {
                    margin: 0,
                    content: '""'
                }
            },
            [`${componentCls}-item-content`]: {
                display: "table-cell",
                flex: 1,
                color: token.contentColor,
                fontSize: token.fontSize,
                lineHeight: token.lineHeight,
                wordBreak: "break-word",
                overflowWrap: "break-word"
            },
            [`${componentCls}-item`]: {
                paddingBottom: 0,
                verticalAlign: "top",
                "&-container": {
                    display: "flex",
                    [`${componentCls}-item-label`]: {
                        display: "inline-flex",
                        alignItems: "baseline"
                    },
                    [`${componentCls}-item-content`]: {
                        display: "inline-flex",
                        alignItems: "baseline",
                        minWidth: "1em"
                    }
                }
            },
            "&-medium": {
                [`${componentCls}-row`]: {
                    "> th, > td": {
                        paddingBottom: token.paddingSM
                    }
                }
            },
            "&-small": {
                [`${componentCls}-row`]: {
                    "> th, > td": {
                        paddingBottom: token.paddingXS
                    }
                }
            }
        }
    };
};
const $90febec7c787bb98$export$9ca1be8807fe0675 = (token)=>({
        labelBg: token.colorFillAlter,
        labelColor: token.colorTextTertiary,
        titleColor: token.colorText,
        titleMarginBottom: token.fontSizeSM * token.lineHeightSM,
        itemPaddingBottom: token.padding,
        itemPaddingEnd: token.padding,
        colonMarginRight: token.marginXS,
        colonMarginLeft: token.marginXXS / 2,
        contentColor: token.colorText,
        extraColor: token.colorText
    });
var // ============================== Export ==============================
$90febec7c787bb98$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$51ec95de45185b42)("Descriptions", (token)=>{
    const descriptionToken = (0, $fef50f256b80dfa5$export$4950aa0f605343fb)(token, {});
    return $90febec7c787bb98$var$genDescriptionStyles(descriptionToken);
}, $90febec7c787bb98$export$9ca1be8807fe0675);


"use client";
const $47da64cf901a0567$var$Descriptions = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, title: title, extra: extra, column: column, colon: colon = true, bordered: bordered, layout: layout, children: children, className: className, rootClassName: rootClassName, style: style, size: customizeSize, labelStyle: labelStyle, contentStyle: contentStyle, styles: styles, items: items, classNames: classNames, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("descriptions");
    const prefixCls = getPrefixCls("descriptions", customizePrefixCls);
    const screens = (0, $27af0f2a794acde0$export$2e2bcd8739ae039)();
    var deprecatedName, newName;
    // Column count
    // Mobile-first cascade: try the user-supplied map first (scanning large→small
    // over cumulative min-width screens, so a lower breakpoint like `md` is still
    // "active" on an `lg` viewport).  Only fall back to DEFAULT_COLUMN_MAP when
    // no user-supplied breakpoint is active at all.
    const mergedColumn = $cQmXV.useMemo(()=>{
        if ((0, $8e2d153a3c855782$export$7e4aa119212bc614)(column)) return column;
        return (0, $93a56f4fa79d4cc2$export$862220c15691d248)(screens, column) ?? (0, $93a56f4fa79d4cc2$export$862220c15691d248)(screens, (0, $eb515b8ef1d95a99$export$2e2bcd8739ae039)) ?? 3;
    }, [
        screens,
        column
    ]);
    // Items with responsive
    const mergedItems = (0, $1072ac9c2d859b3a$export$2e2bcd8739ae039)(screens, items, children);
    const mergedSize = (0, $78cdfb6138721329$export$2e2bcd8739ae039)(customizeSize);
    const rows = (0, $d9e437715d88b284$export$2e2bcd8739ae039)(mergedColumn, mergedItems);
    const [hashId, cssVarCls] = (0, $90febec7c787bb98$export$2e2bcd8739ae039)(prefixCls);
    // =========== Merged Props for Semantic ==========
    const mergedProps = {
        ...props,
        column: mergedColumn,
        items: mergedItems,
        size: mergedSize
    };
    const contextStyleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $30c5f9f911d4f61b$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: mergedProps
    });
    // ======================== Render ========================
    const memoizedValue = $cQmXV.useMemo(()=>({
            labelStyle: labelStyle,
            contentStyle: contentStyle,
            styles: {
                label: mergedStyles.label,
                content: mergedStyles.content
            },
            classNames: {
                label: mergedClassNames.label,
                content: mergedClassNames.content
            }
        }), [
        labelStyle,
        contentStyle,
        mergedStyles.label,
        mergedStyles.content,
        mergedClassNames.label,
        mergedClassNames.content
    ]);
    const nativeElementRef = $cQmXV.useRef(null);
    $cQmXV.useImperativeHandle(ref, ()=>({
            nativeElement: nativeElementRef.current
        }));
    return /*#__PURE__*/ $cQmXV.createElement((0, $96f708a61aec115b$export$2e2bcd8739ae039).Provider, {
        value: memoizedValue
    }, /*#__PURE__*/ $cQmXV.createElement("div", {
        ref: nativeElementRef,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, contextClassName, mergedClassNames.root, {
            [`${prefixCls}-medium`]: mergedSize === "medium" || mergedSize === "middle",
            [`${prefixCls}-small`]: mergedSize === "small",
            [`${prefixCls}-bordered`]: !!bordered,
            [`${prefixCls}-rtl`]: direction === "rtl"
        }, className, rootClassName, hashId, cssVarCls),
        style: mergedStyles.root,
        ...restProps
    }, (title || extra) && /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-header`, mergedClassNames.header),
        style: mergedStyles.header
    }, title && /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-title`, mergedClassNames.title),
        style: mergedStyles.title
    }, title), extra && /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-extra`, mergedClassNames.extra),
        style: mergedStyles.extra
    }, extra)), /*#__PURE__*/ $cQmXV.createElement("div", {
        className: `${prefixCls}-view`
    }, /*#__PURE__*/ $cQmXV.createElement("table", null, /*#__PURE__*/ $cQmXV.createElement("tbody", null, rows.map((row, index)=>/*#__PURE__*/ $cQmXV.createElement((0, $edbea5835295237c$export$2e2bcd8739ae039), {
            key: index,
            index: index,
            colon: colon,
            prefixCls: prefixCls,
            vertical: layout === "vertical",
            bordered: bordered,
            row: row
        })))))));
});
$47da64cf901a0567$var$Descriptions.Item = (0, $97a8bdadc1559f4e$export$2e2bcd8739ae039);
var $47da64cf901a0567$export$2e2bcd8739ae039 = $47da64cf901a0567$var$Descriptions;


var $a914e32fa31b69a7$exports = {};
!function(e, t) {
    $a914e32fa31b69a7$exports = t();
}($a914e32fa31b69a7$exports, function() {
    "use strict";
    return function(e, t) {
        t.prototype.weekday = function(e) {
            var t = this.$locale().weekStart || 0, i = this.$W, n = (i < t ? i + 7 : i) - t;
            return this.$utils().u(e) ? n : this.subtract(n, "day").add(e, "day");
        };
    };
});


var $7dcbfb65013b8558$exports = {};
!function(n, e) {
    $7dcbfb65013b8558$exports = e();
}($7dcbfb65013b8558$exports, function() {
    "use strict";
    return function(n, e, t) {
        var r = e.prototype, o = function(n) {
            return n && (n.indexOf ? n : n.s);
        }, u = function(n, e, t, r, u) {
            var i = n.name ? n : n.$locale(), a = o(i[e]), s = o(i[t]), f = a || s.map(function(n) {
                return n.slice(0, r);
            });
            if (!u) return f;
            var d = i.weekStart;
            return f.map(function(n, e) {
                return f[(e + (d || 0)) % 7];
            });
        }, i = function() {
            return t.Ls[t.locale()];
        }, a = function(n, e) {
            return n.formats[e] || function(n) {
                return n.replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(n, e, t) {
                    return e || t.slice(1);
                });
            }(n.formats[e.toUpperCase()]);
        }, s = function() {
            var n = this;
            return {
                months: function(e) {
                    return e ? e.format("MMMM") : u(n, "months");
                },
                monthsShort: function(e) {
                    return e ? e.format("MMM") : u(n, "monthsShort", "months", 3);
                },
                firstDayOfWeek: function() {
                    return n.$locale().weekStart || 0;
                },
                weekdays: function(e) {
                    return e ? e.format("dddd") : u(n, "weekdays");
                },
                weekdaysMin: function(e) {
                    return e ? e.format("dd") : u(n, "weekdaysMin", "weekdays", 2);
                },
                weekdaysShort: function(e) {
                    return e ? e.format("ddd") : u(n, "weekdaysShort", "weekdays", 3);
                },
                longDateFormat: function(e) {
                    return a(n.$locale(), e);
                },
                meridiem: this.$locale().meridiem,
                ordinal: this.$locale().ordinal
            };
        };
        r.localeData = function() {
            return s.bind(this)();
        }, t.localeData = function() {
            var n = i();
            return {
                firstDayOfWeek: function() {
                    return n.weekStart || 0;
                },
                weekdays: function() {
                    return t.weekdays();
                },
                weekdaysShort: function() {
                    return t.weekdaysShort();
                },
                weekdaysMin: function() {
                    return t.weekdaysMin();
                },
                months: function() {
                    return t.months();
                },
                monthsShort: function() {
                    return t.monthsShort();
                },
                longDateFormat: function(e) {
                    return a(n, e);
                },
                meridiem: n.meridiem,
                ordinal: n.ordinal
            };
        }, t.months = function() {
            return u(i(), "months");
        }, t.monthsShort = function() {
            return u(i(), "monthsShort", "months", 3);
        }, t.weekdays = function(n) {
            return u(i(), "weekdays", null, null, n);
        }, t.weekdaysShort = function(n) {
            return u(i(), "weekdaysShort", "weekdays", 3, n);
        }, t.weekdaysMin = function(n) {
            return u(i(), "weekdaysMin", "weekdays", 2, n);
        };
    };
});


var $c4f7d402ffac65f4$exports = {};
!function(e, t) {
    $c4f7d402ffac65f4$exports = t();
}($c4f7d402ffac65f4$exports, function() {
    "use strict";
    var e = "week", t = "year";
    return function(i, n, r) {
        var f = n.prototype;
        f.week = function(i) {
            if (void 0 === i && (i = null), null !== i) return this.add(7 * (i - this.week()), "day");
            var n = this.$locale().yearStart || 1;
            if (11 === this.month() && this.date() > 25) {
                var f = r(this).startOf(t).add(1, t).date(n), s = r(this).endOf(e);
                if (f.isBefore(s)) return 1;
            }
            var a = r(this).startOf(t).date(n).startOf(e).subtract(1, "millisecond"), o = this.diff(a, e, !0);
            return o < 0 ? r(this).startOf("week").week() : Math.ceil(o);
        }, f.weeks = function(e) {
            return void 0 === e && (e = null), this.week(e);
        };
    };
});


var $7a72e76b83189f89$exports = {};
!function(e, t) {
    $7a72e76b83189f89$exports = t();
}($7a72e76b83189f89$exports, function() {
    "use strict";
    return function(e, t) {
        t.prototype.weekYear = function() {
            var e = this.month(), t = this.week(), n = this.year();
            return 1 === t && 11 === e ? n + 1 : 0 === e && t >= 52 ? n - 1 : n;
        };
    };
});


var $899b8288db57e676$exports = {};
!function(e, t) {
    $899b8288db57e676$exports = t();
}($899b8288db57e676$exports, function() {
    "use strict";
    return function(e, t) {
        var r = t.prototype, n = r.format;
        r.format = function(e) {
            var t = this, r = this.$locale();
            if (!this.isValid()) return n.bind(this)(e);
            var s = this.$utils(), a = (e || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, function(e) {
                switch(e){
                    case "Q":
                        return Math.ceil((t.$M + 1) / 3);
                    case "Do":
                        return r.ordinal(t.$D);
                    case "gggg":
                        return t.weekYear();
                    case "GGGG":
                        return t.isoWeekYear();
                    case "wo":
                        return r.ordinal(t.week(), "W");
                    case "w":
                    case "ww":
                        return s.s(t.week(), "w" === e ? 1 : 2, "0");
                    case "W":
                    case "WW":
                        return s.s(t.isoWeek(), "W" === e ? 1 : 2, "0");
                    case "k":
                    case "kk":
                        return s.s(String(0 === t.$H ? 24 : t.$H), "k" === e ? 1 : 2, "0");
                    case "X":
                        return Math.floor(t.$d.getTime() / 1e3);
                    case "x":
                        return t.$d.getTime();
                    case "z":
                        return "[" + t.offsetName() + "]";
                    case "zzz":
                        return "[" + t.offsetName("long") + "]";
                    default:
                        return e;
                }
            });
            return n.bind(this)(a);
        };
    };
});



(0, (/*@__PURE__*/$parcel$interopDefault($4e90e9a8d027100a$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($bf248c2f85c608e3$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($4e90e9a8d027100a$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($899b8288db57e676$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($4e90e9a8d027100a$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($a914e32fa31b69a7$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($4e90e9a8d027100a$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($7dcbfb65013b8558$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($4e90e9a8d027100a$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($c4f7d402ffac65f4$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($4e90e9a8d027100a$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($7a72e76b83189f89$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($4e90e9a8d027100a$exports))).extend((o, c)=>{
    // todo support Wo (ISO week)
    const proto = c.prototype;
    const oldFormat = proto.format;
    proto.format = function f(formatStr) {
        const str = (formatStr || "").replace("Wo", "wo");
        return oldFormat.bind(this)(str);
    };
});
const $ea5f06974ef1da16$var$localeMap = {
    // ar_EG:
    // az_AZ:
    // bg_BG:
    bn_BD: "bn-bd",
    by_BY: "be",
    // ca_ES:
    // cs_CZ:
    // da_DK:
    // de_DE:
    // el_GR:
    en_GB: "en-gb",
    en_US: "en",
    // es_ES:
    // et_EE:
    // fa_IR:
    // fi_FI:
    fr_BE: "fr",
    // todo: dayjs has no fr_BE locale, use fr at present
    fr_CA: "fr-ca",
    // fr_FR:
    // ga_IE:
    // gl_ES:
    // he_IL:
    // hi_IN:
    // hr_HR:
    // hu_HU:
    hy_AM: "hy-am",
    // id_ID:
    // is_IS:
    // it_IT:
    // ja_JP:
    // ka_GE:
    // kk_KZ:
    // km_KH:
    kmr_IQ: "ku",
    // kn_IN:
    // ko_KR:
    // ku_IQ: // previous ku in antd
    // lt_LT:
    // lv_LV:
    // mk_MK:
    // ml_IN:
    // mn_MN:
    // ms_MY:
    // nb_NO:
    // ne_NP:
    nl_BE: "nl-be",
    // nl_NL:
    // pl_PL:
    pt_BR: "pt-br",
    // pt_PT:
    // ro_RO:
    // ru_RU:
    // sk_SK:
    // sl_SI:
    // sr_RS:
    // sv_SE:
    // ta_IN:
    // th_TH:
    // tr_TR:
    // uk_UA:
    // ur_PK:
    // vi_VN:
    zh_CN: "zh-cn",
    zh_HK: "zh-hk",
    zh_TW: "zh-tw"
};
const $ea5f06974ef1da16$var$parseLocale = (locale)=>{
    const mapLocale = $ea5f06974ef1da16$var$localeMap[locale];
    return mapLocale || locale.split("_")[0];
};
/* istanbul ignore next */ const $ea5f06974ef1da16$var$parseNoMatchNotice = ()=>{
// zombieJ:
// When user typing, its always miss match format.
// This check is meaningless.
// https://github.com/ant-design/ant-design/issues/51839
// noteOnce(false, 'Not match any format. Please help to fire a issue about this.');
};
// Use internal dayjs instance to avoid implicit dependency on plugins extended by external dayjs versions
const $ea5f06974ef1da16$var$getUDayjs = (value)=>{
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($4e90e9a8d027100a$exports))).isDayjs(value) || value instanceof (0, (/*@__PURE__*/$parcel$interopDefault($4e90e9a8d027100a$exports)))) return value;
    return (0, (/*@__PURE__*/$parcel$interopDefault($4e90e9a8d027100a$exports)))(value.valueOf());
};
const $ea5f06974ef1da16$var$generateConfig = {
    // get
    getNow: ()=>{
        const now = (0, (/*@__PURE__*/$parcel$interopDefault($4e90e9a8d027100a$exports)))();
        // https://github.com/ant-design/ant-design/discussions/50934
        if (typeof now.tz === "function") return now.tz(); // use default timezone
        return now;
    },
    getFixedDate: (string)=>(0, (/*@__PURE__*/$parcel$interopDefault($4e90e9a8d027100a$exports)))(string, [
            "YYYY-M-DD",
            "YYYY-MM-DD"
        ]),
    getEndDate: (date)=>$ea5f06974ef1da16$var$getUDayjs(date).endOf("month"),
    getWeekDay: (date)=>{
        const clone = $ea5f06974ef1da16$var$getUDayjs(date).locale("en");
        return clone.weekday() + clone.localeData().firstDayOfWeek();
    },
    getYear: (date)=>$ea5f06974ef1da16$var$getUDayjs(date).year(),
    getMonth: (date)=>$ea5f06974ef1da16$var$getUDayjs(date).month(),
    getDate: (date)=>$ea5f06974ef1da16$var$getUDayjs(date).date(),
    getHour: (date)=>$ea5f06974ef1da16$var$getUDayjs(date).hour(),
    getMinute: (date)=>$ea5f06974ef1da16$var$getUDayjs(date).minute(),
    getSecond: (date)=>$ea5f06974ef1da16$var$getUDayjs(date).second(),
    getMillisecond: (date)=>$ea5f06974ef1da16$var$getUDayjs(date).millisecond(),
    // set
    addYear: (date, diff)=>$ea5f06974ef1da16$var$getUDayjs(date).add(diff, "year"),
    addMonth: (date, diff)=>$ea5f06974ef1da16$var$getUDayjs(date).add(diff, "month"),
    addDate: (date, diff)=>$ea5f06974ef1da16$var$getUDayjs(date).add(diff, "day"),
    setYear: (date, year)=>$ea5f06974ef1da16$var$getUDayjs(date).year(year),
    setMonth: (date, month)=>$ea5f06974ef1da16$var$getUDayjs(date).month(month),
    setDate: (date, num)=>$ea5f06974ef1da16$var$getUDayjs(date).date(num),
    setHour: (date, hour)=>$ea5f06974ef1da16$var$getUDayjs(date).hour(hour),
    setMinute: (date, minute)=>$ea5f06974ef1da16$var$getUDayjs(date).minute(minute),
    setSecond: (date, second)=>$ea5f06974ef1da16$var$getUDayjs(date).second(second),
    setMillisecond: (date, milliseconds)=>$ea5f06974ef1da16$var$getUDayjs(date).millisecond(milliseconds),
    // Compare
    isAfter: (date1, date2)=>$ea5f06974ef1da16$var$getUDayjs(date1).isAfter($ea5f06974ef1da16$var$getUDayjs(date2)),
    isValidate: (date)=>$ea5f06974ef1da16$var$getUDayjs(date).isValid(),
    locale: {
        getWeekFirstDay: (locale)=>(0, (/*@__PURE__*/$parcel$interopDefault($4e90e9a8d027100a$exports)))().locale($ea5f06974ef1da16$var$parseLocale(locale)).localeData().firstDayOfWeek(),
        getWeekFirstDate: (locale, date)=>$ea5f06974ef1da16$var$getUDayjs(date).locale($ea5f06974ef1da16$var$parseLocale(locale)).weekday(0),
        getWeek: (locale, date)=>$ea5f06974ef1da16$var$getUDayjs(date).locale($ea5f06974ef1da16$var$parseLocale(locale)).week(),
        getShortWeekDays: (locale)=>(0, (/*@__PURE__*/$parcel$interopDefault($4e90e9a8d027100a$exports)))().locale($ea5f06974ef1da16$var$parseLocale(locale)).localeData().weekdaysMin(),
        getShortMonths: (locale)=>(0, (/*@__PURE__*/$parcel$interopDefault($4e90e9a8d027100a$exports)))().locale($ea5f06974ef1da16$var$parseLocale(locale)).localeData().monthsShort(),
        format: (locale, date, format)=>$ea5f06974ef1da16$var$getUDayjs(date).locale($ea5f06974ef1da16$var$parseLocale(locale)).format(format),
        parse: (locale, text, formats)=>{
            const localeStr = $ea5f06974ef1da16$var$parseLocale(locale);
            for(let i = 0; i < formats.length; i += 1){
                const format = formats[i];
                const formatText = text;
                if (format.includes("wo") || format.includes("Wo")) {
                    // parse Wo
                    const year = formatText.split("-")[0];
                    const weekStr = formatText.split("-")[1];
                    const firstWeek = (0, (/*@__PURE__*/$parcel$interopDefault($4e90e9a8d027100a$exports)))(year, "YYYY").startOf("year").locale(localeStr);
                    for(let j = 0; j <= 52; j += 1){
                        const nextWeek = firstWeek.add(j, "week");
                        if (nextWeek.format("Wo") === weekStr) return nextWeek;
                    }
                    $ea5f06974ef1da16$var$parseNoMatchNotice();
                    return null;
                }
                const date = (0, (/*@__PURE__*/$parcel$interopDefault($4e90e9a8d027100a$exports)))(formatText, format, true).locale(localeStr);
                if (date.isValid()) return date;
            }
            if (text) $ea5f06974ef1da16$var$parseNoMatchNotice();
            return null;
        }
    }
};
var $ea5f06974ef1da16$export$2e2bcd8739ae039 = $ea5f06974ef1da16$var$generateConfig;




var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");
var $b8147282712765d7$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($b8147282712765d7$exports, "__esModule", {
    value: true
});
var $b8147282712765d7$var$SwapRightOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M873.1 596.2l-164-208A32 32 0 00684 376h-64.8c-6.7 0-10.4 7.7-6.3 13l144.3 183H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h695.9c26.8 0 41.7-30.8 25.2-51.8z"
                }
            }
        ]
    },
    "name": "swap-right",
    "theme": "outlined"
};
$b8147282712765d7$exports.default = $b8147282712765d7$var$SwapRightOutlined;



function $67f47a6420dc3c51$var$_extends() {
    $67f47a6420dc3c51$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $67f47a6420dc3c51$var$_extends.apply(this, arguments);
}
const $67f47a6420dc3c51$var$SwapRightOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $67f47a6420dc3c51$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($b8147282712765d7$exports)))
    }));
/**![swap-right](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg3My4xIDU5Ni4ybC0xNjQtMjA4QTMyIDMyIDAgMDA2ODQgMzc2aC02NC44Yy02LjcgMC0xMC40IDcuNy02LjMgMTNsMTQ0LjMgMTgzSDE1MmMtNC40IDAtOCAzLjYtOCA4djYwYzAgNC40IDMuNiA4IDggOGg2OTUuOWMyNi44IDAgNDEuNy0zMC44IDI1LjItNTEuOHoiIC8+PC9zdmc+) */ const $67f47a6420dc3c51$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($67f47a6420dc3c51$var$SwapRightOutlined);
var $67f47a6420dc3c51$export$2e2bcd8739ae039 = $67f47a6420dc3c51$var$RefIcon;


/**
 * What's new?
 * - Common
 *  - [Break] Support special year format, all the year will follow the locale config.
 *  - Blur all of field will trigger `onChange` if validate
 *  - Support `preserveInvalidOnBlur` to not to clean input if invalid and remove `changeOnBlur`
 *  - `pickerValue` is now full controlled
 *    - `defaultPickerValue` will take effect on every field active with popup opening.
 *  - [Break] clear button return the event with `onClick`
 *
 * - Locale
 *  - Remove `dateFormat` since it's never used
 *  - Remove `dateTimeFormat` since it's never used
 *
 * - Picker
 *  - TimePicker support `changeOnScroll`
 *  - TimePicker support `millisecond`
 *  - Support cellMeridiemFormat for AM/PM
 *  - Get correct `disabledHours` when set `use12Hours`
 *  - Support `showWeek`
 *
 * - RangePicker
 *  - [Break] RangePicker is now not limit the range of clicked field.
 *  - Trigger `onCalendarChange` when type correct
 *  - [Break] Not order `value` if given `value` is wrong order.
 *  - Hover `presets` will show date in input field.
 *  - [Break] RangePicker go to end field, `pickerValue` will follow the start field if not controlled.
 */ 


var $cQmXV = parcelRequire("cQmXV");



var $cQmXV = parcelRequire("cQmXV");
// ====================== Mode ======================
function $9b6a397e237bc0d2$export$a8767447b6867aa6(placement, rtl) {
    if (placement !== undefined) return placement;
    return rtl ? "bottomRight" : "bottomLeft";
}



var $cQmXV = parcelRequire("cQmXV");
const $8ffb82fb472fb634$var$PickerContext = /*#__PURE__*/ $cQmXV.createContext(null);
var $8ffb82fb472fb634$export$2e2bcd8739ae039 = $8ffb82fb472fb634$var$PickerContext;


const $65f9edc43638c2a4$var$BUILT_IN_PLACEMENTS = {
    bottomLeft: {
        points: [
            "tl",
            "bl"
        ],
        offset: [
            0,
            4
        ],
        overflow: {
            adjustX: 1,
            adjustY: 1
        }
    },
    bottomRight: {
        points: [
            "tr",
            "br"
        ],
        offset: [
            0,
            4
        ],
        overflow: {
            adjustX: 1,
            adjustY: 1
        }
    },
    topLeft: {
        points: [
            "bl",
            "tl"
        ],
        offset: [
            0,
            -4
        ],
        overflow: {
            adjustX: 0,
            adjustY: 1
        }
    },
    topRight: {
        points: [
            "br",
            "tr"
        ],
        offset: [
            0,
            -4
        ],
        overflow: {
            adjustX: 0,
            adjustY: 1
        }
    }
};
function $65f9edc43638c2a4$var$PickerTrigger({ popupElement: popupElement, popupStyle: popupStyle, popupClassName: popupClassName, popupAlign: popupAlign, transitionName: transitionName, getPopupContainer: getPopupContainer, children: children, range: range, placement: placement, builtinPlacements: builtinPlacements = $65f9edc43638c2a4$var$BUILT_IN_PLACEMENTS, direction: direction, visible: // Visible
visible, onClose: onClose }) {
    const { prefixCls: prefixCls } = $cQmXV.useContext((0, $8ffb82fb472fb634$export$2e2bcd8739ae039));
    const dropdownPrefixCls = `${prefixCls}-dropdown`;
    const realPlacement = (0, $9b6a397e237bc0d2$export$a8767447b6867aa6)(placement, direction === "rtl");
    return /*#__PURE__*/ $cQmXV.createElement((0, $c77226a956f109d7$export$2e2bcd8739ae039), {
        showAction: [],
        hideAction: [
            "click"
        ],
        popupPlacement: realPlacement,
        builtinPlacements: builtinPlacements,
        prefixCls: dropdownPrefixCls,
        popupMotion: {
            motionName: transitionName
        },
        popup: popupElement,
        popupAlign: popupAlign,
        popupVisible: visible,
        popupClassName: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(popupClassName, {
            [`${dropdownPrefixCls}-range`]: range,
            [`${dropdownPrefixCls}-rtl`]: direction === "rtl"
        }),
        popupStyle: popupStyle,
        stretch: "minWidth",
        getPopupContainer: getPopupContainer,
        onPopupVisibleChange: (nextVisible)=>{
            if (!nextVisible) onClose();
        }
    }, children);
}
var $65f9edc43638c2a4$export$2e2bcd8739ae039 = $65f9edc43638c2a4$var$PickerTrigger;


function $03e7a71a94f7692c$export$cbb503201166aab7(str, length, fill = "0") {
    let current = String(str);
    while(current.length < length)current = `${fill}${current}`;
    return current;
}
function $03e7a71a94f7692c$export$45b10814cc054894(val) {
    if (val === null || val === undefined) return [];
    return Array.isArray(val) ? val : [
        val
    ];
}
function $03e7a71a94f7692c$export$4284846c29a21d02(ori, index, value) {
    const clone = [
        ...ori
    ];
    clone[index] = value;
    return clone;
}
function $03e7a71a94f7692c$export$1b696fb20abaa06c(props, keys) {
    const clone = {};
    const mergedKeys = keys || Object.keys(props);
    mergedKeys.forEach((key)=>{
        if (props[key] !== undefined) clone[key] = props[key];
    });
    return clone;
}
function $03e7a71a94f7692c$export$58de47dfcd2733ec(picker, locale, format) {
    if (format) return format;
    switch(picker){
        // All from the `locale.fieldXXXFormat` first
        case "time":
            return locale.fieldTimeFormat;
        case "datetime":
            return locale.fieldDateTimeFormat;
        case "month":
            return locale.fieldMonthFormat;
        case "year":
            return locale.fieldYearFormat;
        case "quarter":
            return locale.fieldQuarterFormat;
        case "week":
            return locale.fieldWeekFormat;
        default:
            return locale.fieldDateFormat;
    }
}
function $03e7a71a94f7692c$export$25071452d0014c32(calendarValues, triggeredFields, activeIndex) {
    const firstValuedIndex = triggeredFields.find((index)=>calendarValues[index]);
    return activeIndex !== firstValuedIndex ? calendarValues[firstValuedIndex] : undefined;
}


function $d366afafb0a5ce51$export$a11cc4b953869c91(props) {
    return (0, $03e7a71a94f7692c$export$1b696fb20abaa06c)(props, [
        "placement",
        "builtinPlacements",
        "popupAlign",
        "getPopupContainer",
        "transitionName",
        "direction"
    ]);
}






var $cQmXV = parcelRequire("cQmXV");
function $86c2958c1a46dbcf$export$2e2bcd8739ae039(cellRender, dateRender, monthCellRender, range) {
    // ======================== Render ========================
    // Merged render
    const mergedCellRender = $cQmXV.useMemo(()=>{
        if (cellRender) return cellRender;
        return (current, info)=>{
            const date = current;
            if (dateRender && info.type === "date") return dateRender(date, info.today);
            if (monthCellRender && info.type === "month") return monthCellRender(date, info.locale);
            return info.originNode;
        };
    }, [
        cellRender,
        monthCellRender,
        dateRender
    ]);
    // Cell render
    const onInternalCellRender = $cQmXV.useCallback((date, info)=>mergedCellRender(date, {
            ...info,
            range: range
        }), [
        mergedCellRender,
        range
    ]);
    return onInternalCellRender;
}




var $cQmXV = parcelRequire("cQmXV");
function $c696947bae675ffe$export$2e2bcd8739ae039(calendarValue, isInvalidateDate, allowEmpty = []) {
    const [fieldsInvalidates, setFieldsInvalidates] = $cQmXV.useState([
        false,
        false
    ]);
    const onSelectorInvalid = (invalid, index)=>{
        setFieldsInvalidates((ori)=>(0, $03e7a71a94f7692c$export$4284846c29a21d02)(ori, index, invalid));
    };
    /**
   * For the Selector Input to mark as `aria-disabled`
   */ const submitInvalidates = $cQmXV.useMemo(()=>{
        return fieldsInvalidates.map((invalid, index)=>{
            // If typing invalidate
            if (invalid) return true;
            const current = calendarValue[index];
            // Not check if all empty
            if (!current) return false;
            // Not allow empty
            if (!allowEmpty[index] && !current) return true;
            // Invalidate
            if (current && isInvalidateDate(current, {
                activeIndex: index
            })) return true;
            return false;
        });
    }, [
        calendarValue,
        fieldsInvalidates,
        isInvalidateDate,
        allowEmpty
    ]);
    return [
        submitInvalidates,
        onSelectorInvalid
    ];
}




var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");
function $3e4d9c579ec94f76$export$e1dd595565d70a51(showHour, showMinute, showSecond, showMillisecond, showMeridiem) {
    // Base HH:mm:ss
    const cells = [];
    if (showHour) cells.push(showMeridiem ? "hh" : "HH");
    if (showMinute) cells.push("mm");
    if (showSecond) cells.push("ss");
    let timeFormat = cells.join(":");
    // Millisecond
    if (showMillisecond) timeFormat += ".SSS";
    // Meridiem
    if (showMeridiem) timeFormat += " A";
    return timeFormat;
}
/**
 * Used for `useFilledProps` since it already in the React.useMemo
 */ function $3e4d9c579ec94f76$var$fillLocale(locale, showHour, showMinute, showSecond, showMillisecond, use12Hours) {
    // Not fill `monthFormat` since `locale.shortMonths` handle this
    // Not fill `cellMeridiemFormat` since AM & PM by default
    const { fieldDateTimeFormat: // Input Field
    fieldDateTimeFormat, fieldDateFormat: fieldDateFormat, fieldTimeFormat: fieldTimeFormat, fieldMonthFormat: fieldMonthFormat, fieldYearFormat: fieldYearFormat, fieldWeekFormat: fieldWeekFormat, fieldQuarterFormat: fieldQuarterFormat, yearFormat: // Header Format
    yearFormat, cellYearFormat: // monthFormat,
    // Cell format
    cellYearFormat, cellQuarterFormat: cellQuarterFormat, dayFormat: dayFormat, cellDateFormat: cellDateFormat } = locale;
    const timeFormat = $3e4d9c579ec94f76$export$e1dd595565d70a51(showHour, showMinute, showSecond, showMillisecond, use12Hours);
    return {
        ...locale,
        fieldDateTimeFormat: fieldDateTimeFormat || `YYYY-MM-DD ${timeFormat}`,
        fieldDateFormat: fieldDateFormat || "YYYY-MM-DD",
        fieldTimeFormat: fieldTimeFormat || timeFormat,
        fieldMonthFormat: fieldMonthFormat || "YYYY-MM",
        fieldYearFormat: fieldYearFormat || "YYYY",
        fieldWeekFormat: fieldWeekFormat || "gggg-wo",
        fieldQuarterFormat: fieldQuarterFormat || "YYYY-[Q]Q",
        yearFormat: yearFormat || "YYYY",
        cellYearFormat: cellYearFormat || "YYYY",
        cellQuarterFormat: cellQuarterFormat || "[Q]Q",
        cellDateFormat: cellDateFormat || dayFormat || "D"
    };
}
function $3e4d9c579ec94f76$export$2e2bcd8739ae039(locale, showProps) {
    const { showHour: showHour, showMinute: showMinute, showSecond: showSecond, showMillisecond: showMillisecond, use12Hours: use12Hours } = showProps;
    return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useMemo(()=>$3e4d9c579ec94f76$var$fillLocale(locale, showHour, showMinute, showSecond, showMillisecond, use12Hours), [
        locale,
        showHour,
        showMinute,
        showSecond,
        showMillisecond,
        use12Hours
    ]);
}




function $e2836a545f48c154$var$checkShow(format, keywords, show) {
    return show ?? keywords.some((keyword)=>format.includes(keyword));
}
const $e2836a545f48c154$var$showTimeKeys = [
    // 'format',
    "showNow",
    "showHour",
    "showMinute",
    "showSecond",
    "showMillisecond",
    "use12Hours",
    "hourStep",
    "minuteStep",
    "secondStep",
    "millisecondStep",
    "hideDisabledOptions",
    "defaultValue",
    "disabledHours",
    "disabledMinutes",
    "disabledSeconds",
    "disabledMilliseconds",
    "disabledTime",
    "changeOnScroll",
    "defaultOpenValue"
];
/**
 * Get SharedTimeProps from props.
 */ function $e2836a545f48c154$var$pickTimeProps(props) {
    const timeProps = (0, $03e7a71a94f7692c$export$1b696fb20abaa06c)(props, $e2836a545f48c154$var$showTimeKeys);
    const { format: format, picker: picker } = props;
    let propFormat = null;
    if (format) {
        propFormat = format;
        if (Array.isArray(propFormat)) propFormat = propFormat[0];
        propFormat = typeof propFormat === "object" ? propFormat.format : propFormat;
    }
    if (picker === "time") timeProps.format = propFormat;
    return [
        timeProps,
        propFormat
    ];
}
function $e2836a545f48c154$var$isStringFormat(format) {
    return format && typeof format === "string";
}
/** Check if all the showXXX is `undefined` */ function $e2836a545f48c154$var$existShowConfig(showHour, showMinute, showSecond, showMillisecond) {
    return [
        showHour,
        showMinute,
        showSecond,
        showMillisecond
    ].some((show)=>show !== undefined);
}
/** Fill the showXXX if needed */ function $e2836a545f48c154$var$fillShowConfig(hasShowConfig, showHour, showMinute, showSecond, showMillisecond) {
    let parsedShowHour = showHour;
    let parsedShowMinute = showMinute;
    let parsedShowSecond = showSecond;
    if (!hasShowConfig && !parsedShowHour && !parsedShowMinute && !parsedShowSecond && !showMillisecond) {
        parsedShowHour = true;
        parsedShowMinute = true;
        parsedShowSecond = true;
    } else if (hasShowConfig) {
        const existFalse = [
            parsedShowHour,
            parsedShowMinute,
            parsedShowSecond
        ].some((show)=>show === false);
        const existTrue = [
            parsedShowHour,
            parsedShowMinute,
            parsedShowSecond
        ].some((show)=>show === true);
        const defaultShow = existFalse ? true : !existTrue;
        parsedShowHour = parsedShowHour ?? defaultShow;
        parsedShowMinute = parsedShowMinute ?? defaultShow;
        parsedShowSecond = parsedShowSecond ?? defaultShow;
    }
    return [
        parsedShowHour,
        parsedShowMinute,
        parsedShowSecond,
        showMillisecond
    ];
}
function $e2836a545f48c154$export$6c7e3619a08d795a(componentProps) {
    const { showTime: showTime } = componentProps;
    const [pickedProps, propFormat] = $e2836a545f48c154$var$pickTimeProps(componentProps);
    const showTimeConfig = showTime && typeof showTime === "object" ? showTime : {};
    const timeConfig = {
        defaultOpenValue: showTimeConfig.defaultOpenValue || showTimeConfig.defaultValue,
        ...pickedProps,
        ...showTimeConfig
    };
    const { showMillisecond: showMillisecond } = timeConfig;
    let { showHour: showHour, showMinute: showMinute, showSecond: showSecond } = timeConfig;
    const hasShowConfig = $e2836a545f48c154$var$existShowConfig(showHour, showMinute, showSecond, showMillisecond);
    [showHour, showMinute, showSecond] = $e2836a545f48c154$var$fillShowConfig(hasShowConfig, showHour, showMinute, showSecond, showMillisecond);
    return [
        timeConfig,
        {
            ...timeConfig,
            showHour: showHour,
            showMinute: showMinute,
            showSecond: showSecond,
            showMillisecond: showMillisecond
        },
        timeConfig.format,
        propFormat
    ];
}
function $e2836a545f48c154$export$901cd53a4926b425(picker, showTimeFormat, propFormat, timeConfig, locale) {
    const isTimePicker = picker === "time";
    if (picker === "datetime" || isTimePicker) {
        const pickedProps = timeConfig;
        // ====================== BaseFormat ======================
        const defaultLocaleFormat = (0, $03e7a71a94f7692c$export$58de47dfcd2733ec)(picker, locale, null);
        let baselineFormat = defaultLocaleFormat;
        const formatList = [
            showTimeFormat,
            propFormat
        ];
        for(let i = 0; i < formatList.length; i += 1){
            const format = (0, $03e7a71a94f7692c$export$45b10814cc054894)(formatList[i])[0];
            if ($e2836a545f48c154$var$isStringFormat(format)) {
                baselineFormat = format;
                break;
            }
        }
        // ========================= Show =========================
        let { showHour: showHour, showMinute: showMinute, showSecond: showSecond, showMillisecond: showMillisecond } = pickedProps;
        const { use12Hours: use12Hours } = pickedProps;
        const showMeridiem = $e2836a545f48c154$var$checkShow(baselineFormat, [
            "a",
            "A",
            "LT",
            "LLL",
            "LTS"
        ], use12Hours);
        const hasShowConfig = $e2836a545f48c154$var$existShowConfig(showHour, showMinute, showSecond, showMillisecond);
        // Fill with format, if needed
        if (!hasShowConfig) {
            showHour = $e2836a545f48c154$var$checkShow(baselineFormat, [
                "H",
                "h",
                "k",
                "LT",
                "LLL"
            ]);
            showMinute = $e2836a545f48c154$var$checkShow(baselineFormat, [
                "m",
                "LT",
                "LLL"
            ]);
            showSecond = $e2836a545f48c154$var$checkShow(baselineFormat, [
                "s",
                "LTS"
            ]);
            showMillisecond = $e2836a545f48c154$var$checkShow(baselineFormat, [
                "SSS"
            ]);
        }
        // Fallback if all can not see
        [showHour, showMinute, showSecond] = $e2836a545f48c154$var$fillShowConfig(hasShowConfig, showHour, showMinute, showSecond, showMillisecond);
        // ======================== Format ========================
        const timeFormat = showTimeFormat || (0, $3e4d9c579ec94f76$export$e1dd595565d70a51)(showHour, showMinute, showSecond, showMillisecond, showMeridiem);
        // ======================== Props =========================
        return {
            ...pickedProps,
            // Format
            format: timeFormat,
            showHour: // Show Config
            showHour,
            showMinute: showMinute,
            showSecond: showSecond,
            showMillisecond: showMillisecond,
            use12Hours: showMeridiem
        };
    }
    return null;
}





var $cQmXV = parcelRequire("cQmXV");
function $687afa3943783a82$export$cd2d9d0fa9dec03f(prefixCls, allowClear, clearIcon) {
    if (allowClear === false) return null;
    const config = allowClear && typeof allowClear === "object" ? allowClear : {};
    return config.clearIcon || clearIcon || /*#__PURE__*/ $cQmXV.createElement("span", {
        className: `${prefixCls}-clear-btn`
    });
}



const $56194b7cc1a1787c$export$fe62c2dddb4d77ea = 7;
/**
 * Wrap the compare logic.
 * This will compare the each of value is empty first.
 * 1. All is empty, return true.
 * 2. One is empty, return false.
 * 3. return customize compare logic.
 */ function $56194b7cc1a1787c$var$nullableCompare(value1, value2, oriCompareFn) {
    if (!value1 && !value2 || value1 === value2) return true;
    if (!value1 || !value2) return false;
    return oriCompareFn();
}
function $56194b7cc1a1787c$export$22ab546651b3be18(generateConfig, decade1, decade2) {
    return $56194b7cc1a1787c$var$nullableCompare(decade1, decade2, ()=>{
        const num1 = Math.floor(generateConfig.getYear(decade1) / 10);
        const num2 = Math.floor(generateConfig.getYear(decade2) / 10);
        return num1 === num2;
    });
}
function $56194b7cc1a1787c$export$5841f9eb9773f25f(generateConfig, year1, year2) {
    return $56194b7cc1a1787c$var$nullableCompare(year1, year2, ()=>generateConfig.getYear(year1) === generateConfig.getYear(year2));
}
function $56194b7cc1a1787c$export$de90a4bb31c25221(generateConfig, date) {
    const quota = Math.floor(generateConfig.getMonth(date) / 3);
    return quota + 1;
}
function $56194b7cc1a1787c$export$5c60e4190867161c(generateConfig, quarter1, quarter2) {
    return $56194b7cc1a1787c$var$nullableCompare(quarter1, quarter2, ()=>$56194b7cc1a1787c$export$5841f9eb9773f25f(generateConfig, quarter1, quarter2) && $56194b7cc1a1787c$export$de90a4bb31c25221(generateConfig, quarter1) === $56194b7cc1a1787c$export$de90a4bb31c25221(generateConfig, quarter2));
}
function $56194b7cc1a1787c$export$a18c89cbd24170ff(generateConfig, month1, month2) {
    return $56194b7cc1a1787c$var$nullableCompare(month1, month2, ()=>$56194b7cc1a1787c$export$5841f9eb9773f25f(generateConfig, month1, month2) && generateConfig.getMonth(month1) === generateConfig.getMonth(month2));
}
function $56194b7cc1a1787c$export$a8b2a21161763694(generateConfig, date1, date2) {
    return $56194b7cc1a1787c$var$nullableCompare(date1, date2, ()=>$56194b7cc1a1787c$export$5841f9eb9773f25f(generateConfig, date1, date2) && $56194b7cc1a1787c$export$a18c89cbd24170ff(generateConfig, date1, date2) && generateConfig.getDate(date1) === generateConfig.getDate(date2));
}
function $56194b7cc1a1787c$export$dd2b4b46b4a2f5c9(generateConfig, time1, time2) {
    return $56194b7cc1a1787c$var$nullableCompare(time1, time2, ()=>generateConfig.getHour(time1) === generateConfig.getHour(time2) && generateConfig.getMinute(time1) === generateConfig.getMinute(time2) && generateConfig.getSecond(time1) === generateConfig.getSecond(time2));
}
function $56194b7cc1a1787c$export$730a188731b5a146(generateConfig, time1, time2) {
    return $56194b7cc1a1787c$var$nullableCompare(time1, time2, ()=>$56194b7cc1a1787c$export$a8b2a21161763694(generateConfig, time1, time2) && $56194b7cc1a1787c$export$dd2b4b46b4a2f5c9(generateConfig, time1, time2) && generateConfig.getMillisecond(time1) === generateConfig.getMillisecond(time2));
}
function $56194b7cc1a1787c$export$6ea683876c36b8d2(generateConfig, locale, date1, date2) {
    return $56194b7cc1a1787c$var$nullableCompare(date1, date2, ()=>{
        const weekStartDate1 = generateConfig.locale.getWeekFirstDate(locale, date1);
        const weekStartDate2 = generateConfig.locale.getWeekFirstDate(locale, date2);
        return $56194b7cc1a1787c$export$5841f9eb9773f25f(generateConfig, weekStartDate1, weekStartDate2) && generateConfig.locale.getWeek(locale, date1) === generateConfig.locale.getWeek(locale, date2);
    });
}
function $56194b7cc1a1787c$export$18ac18efd9e98d41(generateConfig, locale, source, target, type) {
    switch(type){
        case "date":
            return $56194b7cc1a1787c$export$a8b2a21161763694(generateConfig, source, target);
        case "week":
            return $56194b7cc1a1787c$export$6ea683876c36b8d2(generateConfig, locale.locale, source, target);
        case "month":
            return $56194b7cc1a1787c$export$a18c89cbd24170ff(generateConfig, source, target);
        case "quarter":
            return $56194b7cc1a1787c$export$5c60e4190867161c(generateConfig, source, target);
        case "year":
            return $56194b7cc1a1787c$export$5841f9eb9773f25f(generateConfig, source, target);
        case "decade":
            return $56194b7cc1a1787c$export$22ab546651b3be18(generateConfig, source, target);
        case "time":
            return $56194b7cc1a1787c$export$dd2b4b46b4a2f5c9(generateConfig, source, target);
        default:
            return $56194b7cc1a1787c$export$730a188731b5a146(generateConfig, source, target);
    }
}
function $56194b7cc1a1787c$export$6dabbcb26357acf4(generateConfig, startDate, endDate, current) {
    if (!startDate || !endDate || !current) return false;
    return generateConfig.isAfter(current, startDate) && generateConfig.isAfter(endDate, current);
}
function $56194b7cc1a1787c$export$a663815b3d4a2ed6(generateConfig, locale, date1, date2, type) {
    if ($56194b7cc1a1787c$export$18ac18efd9e98d41(generateConfig, locale, date1, date2, type)) return true;
    return generateConfig.isAfter(date1, date2);
}
function $56194b7cc1a1787c$export$e91829c600881133(locale, generateConfig, value) {
    const weekFirstDay = generateConfig.locale.getWeekFirstDay(locale);
    const monthStartDate = generateConfig.setDate(value, 1);
    const startDateWeekDay = generateConfig.getWeekDay(monthStartDate);
    let alignStartDate = generateConfig.addDate(monthStartDate, weekFirstDay - startDateWeekDay);
    if (generateConfig.getMonth(alignStartDate) === generateConfig.getMonth(value) && generateConfig.getDate(alignStartDate) > 1) alignStartDate = generateConfig.addDate(alignStartDate, -7);
    return alignStartDate;
}
function $56194b7cc1a1787c$export$7c4d25c0c3217d8c(value, { generateConfig: generateConfig, locale: locale, format: format }) {
    if (!value) return "";
    return typeof format === "function" ? format(value) : generateConfig.locale.format(locale.locale, value, format);
}
function $56194b7cc1a1787c$export$48199fabfd385f2f(generateConfig, date, time) {
    let tmpDate = date;
    const getFn = [
        "getHour",
        "getMinute",
        "getSecond",
        "getMillisecond"
    ];
    const setFn = [
        "setHour",
        "setMinute",
        "setSecond",
        "setMillisecond"
    ];
    setFn.forEach((fn, index)=>{
        if (time) tmpDate = generateConfig[fn](tmpDate, generateConfig[getFn[index]](time));
        else tmpDate = generateConfig[fn](tmpDate, 0);
    });
    return tmpDate;
}


function $9b6f419e71b091f9$export$2e2bcd8739ae039(generateConfig, locale, disabledDate, minDate, maxDate) {
    const mergedDisabledDate = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((date, info)=>{
        if (disabledDate && disabledDate(date, info)) return true;
        if (minDate && generateConfig.isAfter(minDate, date) && !(0, $56194b7cc1a1787c$export$18ac18efd9e98d41)(generateConfig, locale, minDate, date, info.type)) return true;
        if (maxDate && generateConfig.isAfter(date, maxDate) && !(0, $56194b7cc1a1787c$export$18ac18efd9e98d41)(generateConfig, locale, maxDate, date, info.type)) return true;
        return false;
    });
    return mergedDisabledDate;
}



var $cQmXV = parcelRequire("cQmXV");

function $133e1bbdb4ba4a69$export$3880d22e26eb363c(picker, locale, format) {
    return $cQmXV.useMemo(()=>{
        const rawFormat = (0, $03e7a71a94f7692c$export$58de47dfcd2733ec)(picker, locale, format);
        const formatList = (0, $03e7a71a94f7692c$export$45b10814cc054894)(rawFormat);
        const firstFormat = formatList[0];
        const maskFormat = typeof firstFormat === "object" && firstFormat.type === "mask" ? firstFormat.format : null;
        return [
            // Format list
            formatList.map((config)=>typeof config === "string" || typeof config === "function" ? config : config.format),
            // Mask Format
            maskFormat
        ];
    }, [
        picker,
        locale,
        format
    ]);
}


function $9ee829060430492c$export$2e2bcd8739ae039(formatList, inputReadOnly, multiple) {
    if (typeof formatList[0] === "function" || multiple) return true;
    return inputReadOnly;
}



function $a0cb549aa56e1b2b$export$2e2bcd8739ae039(generateConfig, picker, disabledDate, showTime) {
    // Check disabled date
    const isInvalidate = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((date, info)=>{
        const outsideInfo = {
            type: picker,
            ...info
        };
        delete outsideInfo.activeIndex;
        if (// Date object is invalid
        !generateConfig.isValidate(date) || // Date is disabled by `disabledDate`
        disabledDate && disabledDate(date, outsideInfo)) return true;
        if ((picker === "date" || picker === "time") && showTime) {
            const range = info && info.activeIndex === 1 ? "end" : "start";
            const { disabledHours: disabledHours, disabledMinutes: disabledMinutes, disabledSeconds: disabledSeconds, disabledMilliseconds: disabledMilliseconds } = showTime.disabledTime?.(date, range, {
                from: outsideInfo.from
            }) || {};
            const { disabledHours: legacyDisabledHours, disabledMinutes: legacyDisabledMinutes, disabledSeconds: legacyDisabledSeconds } = showTime;
            const mergedDisabledHours = disabledHours || legacyDisabledHours;
            const mergedDisabledMinutes = disabledMinutes || legacyDisabledMinutes;
            const mergedDisabledSeconds = disabledSeconds || legacyDisabledSeconds;
            const hour = generateConfig.getHour(date);
            const minute = generateConfig.getMinute(date);
            const second = generateConfig.getSecond(date);
            const millisecond = generateConfig.getMillisecond(date);
            if (mergedDisabledHours && mergedDisabledHours().includes(hour)) return true;
            if (mergedDisabledMinutes && mergedDisabledMinutes(hour).includes(minute)) return true;
            if (mergedDisabledSeconds && mergedDisabledSeconds(hour, minute).includes(second)) return true;
            if (disabledMilliseconds && disabledMilliseconds(hour, minute, second).includes(millisecond)) return true;
        }
        return false;
    });
    return isInvalidate;
}


function $6f88bc1a75df9e02$var$useList(value, fillMode = false) {
    const values = $cQmXV.useMemo(()=>{
        const list = value ? (0, $03e7a71a94f7692c$export$45b10814cc054894)(value) : value;
        if (fillMode && list) list[1] = list[1] || list[0];
        return list;
    }, [
        value,
        fillMode
    ]);
    return values;
}
function $6f88bc1a75df9e02$export$2e2bcd8739ae039(props, updater) {
    const { generateConfig: generateConfig, locale: locale, picker: picker = "date", prefixCls: prefixCls = "rc-picker", previewValue: previewValue = "hover", styles: styles = {}, classNames: classNames = {}, order: order = true, components: components = {}, inputRender: inputRender, allowClear: allowClear, clearIcon: clearIcon, needConfirm: needConfirm, multiple: multiple, format: format, inputReadOnly: inputReadOnly, disabledDate: disabledDate, minDate: minDate, maxDate: maxDate, showTime: showTime, value: value, defaultValue: defaultValue, pickerValue: pickerValue, defaultPickerValue: defaultPickerValue } = props;
    const values = $6f88bc1a75df9e02$var$useList(value);
    const defaultValues = $6f88bc1a75df9e02$var$useList(defaultValue);
    const pickerValues = $6f88bc1a75df9e02$var$useList(pickerValue);
    const defaultPickerValues = $6f88bc1a75df9e02$var$useList(defaultPickerValue);
    // ======================== Picker ========================
    /** Almost same as `picker`, but add `datetime` for `date` with `showTime` */ const internalPicker = picker === "date" && showTime ? "datetime" : picker;
    /** The picker is `datetime` or `time` */ const multipleInteractivePicker = internalPicker === "time" || internalPicker === "datetime";
    const complexPicker = multipleInteractivePicker || multiple;
    const mergedNeedConfirm = needConfirm ?? multipleInteractivePicker;
    // ========================== Time ==========================
    // Auto `format` need to check `showTime.showXXX` first.
    // And then merge the `locale` into `mergedShowTime`.
    const [timeProps, localeTimeProps, showTimeFormat, propFormat] = (0, $e2836a545f48c154$export$6c7e3619a08d795a)(props);
    // ======================= Locales ========================
    const mergedLocale = (0, $3e4d9c579ec94f76$export$2e2bcd8739ae039)(locale, localeTimeProps);
    const mergedShowTime = $cQmXV.useMemo(()=>(0, $e2836a545f48c154$export$901cd53a4926b425)(internalPicker, showTimeFormat, propFormat, timeProps, mergedLocale), [
        internalPicker,
        showTimeFormat,
        propFormat,
        timeProps,
        mergedLocale
    ]);
    var key;
    // ======================== Props =========================
    const filledProps = $cQmXV.useMemo(()=>({
            ...props,
            previewValue: previewValue,
            prefixCls: prefixCls,
            locale: mergedLocale,
            picker: picker,
            styles: styles,
            classNames: classNames,
            order: order,
            components: {
                input: inputRender,
                ...components
            },
            clearIcon: (0, $687afa3943783a82$export$cd2d9d0fa9dec03f)(prefixCls, allowClear, clearIcon),
            showTime: mergedShowTime,
            value: values,
            defaultValue: defaultValues,
            pickerValue: pickerValues,
            defaultPickerValue: defaultPickerValues,
            ...updater?.()
        }), [
        props
    ]);
    // ======================== Format ========================
    const [formatList, maskFormat] = (0, $133e1bbdb4ba4a69$export$3880d22e26eb363c)(internalPicker, mergedLocale, format);
    // ======================= ReadOnly =======================
    const mergedInputReadOnly = (0, $9ee829060430492c$export$2e2bcd8739ae039)(formatList, inputReadOnly, multiple);
    // ======================= Boundary =======================
    const disabledBoundaryDate = (0, $9b6f419e71b091f9$export$2e2bcd8739ae039)(generateConfig, locale, disabledDate, minDate, maxDate);
    // ====================== Invalidate ======================
    const isInvalidateDate = (0, $a0cb549aa56e1b2b$export$2e2bcd8739ae039)(generateConfig, picker, disabledBoundaryDate, mergedShowTime);
    // ======================== Merged ========================
    const mergedProps = $cQmXV.useMemo(()=>({
            ...filledProps,
            needConfirm: mergedNeedConfirm,
            inputReadOnly: mergedInputReadOnly,
            disabledDate: disabledBoundaryDate
        }), [
        filledProps,
        mergedNeedConfirm,
        mergedInputReadOnly,
        disabledBoundaryDate
    ]);
    return [
        mergedProps,
        internalPicker,
        complexPicker,
        formatList,
        maskFormat,
        isInvalidateDate
    ];
}




var $cQmXV = parcelRequire("cQmXV");
function $3a79bd058cf8ac77$export$9bd4f980f61191a(target, containers) {
    return containers.some((container)=>!!container && (container === target || container.contains(target)));
}
function $3a79bd058cf8ac77$export$2e2bcd8739ae039(isInternalElement, onFocus, onBlur, onConfirmedBlur) {
    // Keep the actual focused field so every field focus causes a render. This
    // gives `useFocusLock` a commit in which it can correct an invalid switch.
    // 记录实际获得焦点的 field，使每次 field focus 都会触发渲染；
    // `useFocusLock` 因此可以在 commit 后纠正不允许的切换。
    const [focusedIndex, setFocusedIndex] = $cQmXV.useState(null);
    const onFieldFocus = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((index, _source, event)=>{
        setFocusedIndex(index);
        onFocus?.(index, event);
    });
    const onFieldBlur = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((index, _source, event)=>{
        if (!isInternalElement(event.relatedTarget)) {
            setFocusedIndex(null);
            onConfirmedBlur?.(index, event);
        }
        onBlur?.(index, event);
    });
    return [
        focusedIndex !== null,
        onFieldFocus,
        onFieldBlur
    ];
}




var $cQmXV = parcelRequire("cQmXV");

function $fde2991fc5919375$export$2e2bcd8739ae039(index, forceFocus, selectorRef, popupRef, triggerOpen) {
    const openPicker = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)(()=>{
        triggerOpen(true);
    });
    // Only a strong transition actively opens the Picker and moves DOM focus.
    // Weak transitions keep the expected index without stealing external focus.
    // 仅强切换会主动打开 Picker 并移动 DOM 焦点；弱切换只保留预期 index，
    // 不抢占外部元素的焦点。
    $cQmXV.useEffect(()=>{
        if (index !== null && forceFocus) {
            openPicker();
            selectorRef.current?.focus(index);
        }
    }, [
        index,
        forceFocus,
        openPicker
    ]);
    // DOM focus may change while `index` stays the same, so check after every commit.
    // DOM 焦点变化时 `index` 可能保持不变，因此每次 commit 后都需要检查。
    (0, $7673d874dab69d07$export$2e2bcd8739ae039)(()=>{
        if (index === null) return;
        const inputFields = [
            selectorRef.current?.startInput,
            selectorRef.current?.endInput
        ];
        const inputRoot = inputFields[index]?.getRootNode();
        // `document.activeElement` stops at the shadow host. Read from the input's
        // own root first so focus locking can identify the actual field.
        // `document.activeElement` 在 Shadow DOM 中只会返回 host。优先读取 input
        // 所属 root，才能识别实际聚焦的 field。
        const activeElement = inputRoot?.activeElement ?? document.activeElement;
        if ((0, $3a79bd058cf8ac77$export$9bd4f980f61191a)(activeElement, [
            popupRef.current
        ])) return;
        const focusInOtherField = inputFields.some((field, fieldIndex)=>fieldIndex !== index && (0, $3a79bd058cf8ac77$export$9bd4f980f61191a)(activeElement, [
                field
            ]));
        if (focusInOtherField) inputFields[index]?.focus();
    });
}




var $cQmXV = parcelRequire("cQmXV");
function $5ab2c30d241f81bd$export$2e2bcd8739ae039(value, defaultValue, onChange) {
    const [state, setState] = (0, $a51866d781137e08$export$2e2bcd8739ae039)(defaultValue, value);
    // Need force update to ensure React re-render
    const [, forceUpdate] = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useState({});
    const triggerUpdate = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((nextState)=>{
        setState(nextState);
        forceUpdate({});
    });
    const nextValueRef = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useRef(value);
    // ============================= Update =============================
    const rafRef = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useRef(undefined);
    const cancelRaf = ()=>{
        (0, $905c53b807de704e$export$2e2bcd8739ae039).cancel(rafRef.current);
    };
    const doUpdate = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)(()=>{
        triggerUpdate(nextValueRef.current);
        if (onChange && state !== nextValueRef.current) onChange(nextValueRef.current);
    });
    const updateValue = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((next, immediately)=>{
        cancelRaf();
        nextValueRef.current = next;
        if (next || immediately) doUpdate();
        else rafRef.current = (0, $905c53b807de704e$export$2e2bcd8739ae039)(doUpdate);
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useEffect(()=>cancelRaf, []);
    return [
        state,
        updateValue
    ];
}


function $baa68117c464c322$export$2e2bcd8739ae039(open, defaultOpen, disabledList = [], onOpenChange) {
    const mergedOpen = disabledList.every((disabled)=>disabled) ? false : open;
    // Delay for handle the open state, in case fast shift from `open` -> `close` -> `open`
    // const [rafOpen, setRafOpen] = useLockState(open, defaultOpen || false, onOpenChange);
    const [rafOpen, setRafOpen] = (0, $5ab2c30d241f81bd$export$2e2bcd8739ae039)(mergedOpen, defaultOpen || false, onOpenChange);
    function setOpen(next, config = {}) {
        if (!config.inherit || rafOpen) setRafOpen(next, config.force);
    }
    return [
        rafOpen,
        setOpen
    ];
}



var $cQmXV = parcelRequire("cQmXV");
function $e3a9d639e28d3613$export$2e2bcd8739ae039(ref) {
    const selectorRef = $cQmXV.useRef(null);
    $cQmXV.useImperativeHandle(ref, ()=>({
            nativeElement: selectorRef.current?.nativeElement,
            focus: (options)=>{
                selectorRef.current?.focus(options);
            },
            blur: ()=>{
                selectorRef.current?.blur();
            }
        }));
    return selectorRef;
}



var $cQmXV = parcelRequire("cQmXV");

function $58fb6cd5d787b224$export$2e2bcd8739ae039(presets, legacyRanges) {
    return $cQmXV.useMemo(()=>{
        if (presets) return presets;
        if (legacyRanges) {
            (0, $26d7cf6379fe7659$export$2e2bcd8739ae039)(false, "`ranges` is deprecated. Please use `presets` instead.");
            return Object.entries(legacyRanges).map(([label, value])=>({
                    label: label,
                    value: value
                }));
        }
        return [];
    }, [
        presets,
        legacyRanges
    ]);
}




function $d44032b209773016$export$2e2bcd8739ae039(values, disabled, activeIndex, triggeredFields, generateConfig, locale, disabledDate) {
    const rangeDisabledDate = (date, info)=>{
        const [start, end] = values;
        const mergedInfo = {
            ...info,
            from: (0, $03e7a71a94f7692c$export$25071452d0014c32)(values, triggeredFields, activeIndex)
        };
        // ============================ Disabled ============================
        // Should not select days before the start date
        if (activeIndex === 1 && disabled[0] && start && // Same date isOK
        !(0, $56194b7cc1a1787c$export$18ac18efd9e98d41)(generateConfig, locale, start, date, mergedInfo.type) && // Before start date
        generateConfig.isAfter(start, date)) return true;
        // Should not select days after the end date
        if (activeIndex === 0 && disabled[1] && end && // Same date isOK
        !(0, $56194b7cc1a1787c$export$18ac18efd9e98d41)(generateConfig, locale, end, date, mergedInfo.type) && // After end date
        generateConfig.isAfter(date, end)) return true;
        // ============================= Origin =============================
        return disabledDate?.(date, mergedInfo);
    };
    return rangeDisabledDate;
}




var $cQmXV = parcelRequire("cQmXV");

function $58210ec7ad711cce$export$b0e4aff419ae4233(generateConfig, picker, date, offset) {
    switch(picker){
        case "date":
        case "week":
            return generateConfig.addMonth(date, offset);
        case "month":
        case "quarter":
            return generateConfig.addYear(date, offset);
        case "year":
            return generateConfig.addYear(date, offset * 10);
        case "decade":
            return generateConfig.addYear(date, offset * 100);
        default:
            return date;
    }
}
const $58210ec7ad711cce$var$EMPTY_LIST = [];
function $58210ec7ad711cce$export$2e2bcd8739ae039(generateConfig, locale, calendarValue, modes, open, preserveOnFieldChange, activeIndex, pickerMode, multiplePanel, defaultPickerValue = $58210ec7ad711cce$var$EMPTY_LIST, pickerValue = $58210ec7ad711cce$var$EMPTY_LIST, // This is legacy from origin logic.
// We will take `showTime.defaultValue` as the part of `pickerValue`
timeDefaultValue = $58210ec7ad711cce$var$EMPTY_LIST, onPickerValueChange, minDate, maxDate) {
    const isTimePicker = pickerMode === "time";
    // ======================== Active ========================
    // `activeIndex` must be valid to avoid getting empty `pickerValue`
    const mergedActiveIndex = activeIndex || 0;
    const [startCalendarValue, endCalendarValue] = calendarValue;
    const activeCalendarValue = mergedActiveIndex === 0 ? startCalendarValue : endCalendarValue;
    const inactiveCalendarValue = mergedActiveIndex === 0 ? endCalendarValue : startCalendarValue;
    // ===================== Picker Value =====================
    const getDefaultPickerValue = (index)=>{
        let now = generateConfig.getNow();
        if (isTimePicker) now = (0, $56194b7cc1a1787c$export$48199fabfd385f2f)(generateConfig, now);
        const calendarDate = index === 0 ? startCalendarValue : endCalendarValue;
        return defaultPickerValue[index] || calendarDate || now;
    };
    // Align `pickerValue` with `showTime.defaultValue`
    const [startPickerValue, endPickerValue] = pickerValue;
    // PickerValue state
    const [mergedStartPickerValue, setStartPickerValue] = (0, $a51866d781137e08$export$2e2bcd8739ae039)(()=>getDefaultPickerValue(0), startPickerValue);
    const [mergedEndPickerValue, setEndPickerValue] = (0, $a51866d781137e08$export$2e2bcd8739ae039)(()=>getDefaultPickerValue(1), endPickerValue);
    // Current PickerValue
    const currentPickerValue = $cQmXV.useMemo(()=>{
        const current = [
            mergedStartPickerValue,
            mergedEndPickerValue
        ][mergedActiveIndex];
        // Merge the `showTime.defaultValue` into `pickerValue`
        return isTimePicker ? current : (0, $56194b7cc1a1787c$export$48199fabfd385f2f)(generateConfig, current, timeDefaultValue[mergedActiveIndex]);
    }, [
        isTimePicker,
        mergedStartPickerValue,
        mergedEndPickerValue,
        mergedActiveIndex,
        generateConfig,
        timeDefaultValue
    ]);
    const setCurrentPickerValue = (nextPickerValue, source = "panel")=>{
        const updater = [
            setStartPickerValue,
            setEndPickerValue
        ][mergedActiveIndex];
        updater(nextPickerValue);
        const clone = [
            mergedStartPickerValue,
            mergedEndPickerValue
        ];
        clone[mergedActiveIndex] = nextPickerValue;
        if (onPickerValueChange && (!(0, $56194b7cc1a1787c$export$18ac18efd9e98d41)(generateConfig, locale, mergedStartPickerValue, clone[0], pickerMode) || !(0, $56194b7cc1a1787c$export$18ac18efd9e98d41)(generateConfig, locale, mergedEndPickerValue, clone[1], pickerMode))) onPickerValueChange(clone, {
            source: source,
            range: mergedActiveIndex === 1 ? "end" : "start",
            mode: modes
        });
    };
    // ======================== Effect ========================
    // Check whether two dates belong to the same panel.
    // 判断两个日期是否属于同一个面板。
    const isSamePanel = (date1, date2)=>{
        if (pickerMode === "year") return Math.floor(generateConfig.getYear(date1) / 10) === Math.floor(generateConfig.getYear(date2) / 10);
        const panelMode = pickerMode === "month" || pickerMode === "quarter" ? "year" : "month";
        return (0, $56194b7cc1a1787c$export$18ac18efd9e98d41)(generateConfig, locale, date1, date2, panelMode);
    };
    // Keep both values in the two visible panels when possible. Otherwise put
    // the end value in the second panel.
    // 尽量在双面板内同时展示两个值；无法容纳时，将 end 值放在右侧面板。
    const getEndDatePickerValue = (startDate, endDate)=>{
        if (!multiplePanel || !startDate) return endDate;
        const nextPanelDate = $58210ec7ad711cce$export$b0e4aff419ae4233(generateConfig, pickerMode, startDate, 1);
        const endInPanels = isSamePanel(startDate, endDate) || isSamePanel(nextPanelDate, endDate);
        return endInPanels ? startDate : $58210ec7ad711cce$export$b0e4aff419ae4233(generateConfig, pickerMode, endDate, -1);
    };
    // >>> When switch field, reset the picker value as prev field picker value
    const prevActiveIndexRef = $cQmXV.useRef(null);
    (0, $7673d874dab69d07$export$2e2bcd8739ae039)(()=>{
        if (open) {
            if (!defaultPickerValue[mergedActiveIndex]) {
                let nextPickerValue = isTimePicker ? null : generateConfig.getNow();
                /**
         * 1. If focus switches inside the open Picker, keep the current panels
         * 2. If current field has value, sync it to the panels
         *    - Start: use the start value
         *    - End: keep start when both values fit, otherwise put end on the second panel
         * 3. If current field has no value but another field has value, use another field value
         * 4. Else use now (not any `calendarValue` can ref)
         */ if (preserveOnFieldChange && prevActiveIndexRef.current !== null && prevActiveIndexRef.current !== mergedActiveIndex) // If from another field, not jump picker value
                nextPickerValue = [
                    mergedStartPickerValue,
                    mergedEndPickerValue
                ][mergedActiveIndex ^ 1];
                else if (activeCalendarValue) // Current field has value
                nextPickerValue = mergedActiveIndex === 0 ? startCalendarValue : getEndDatePickerValue(startCalendarValue, endCalendarValue);
                else if (inactiveCalendarValue) // Current field has no value but another field has value
                nextPickerValue = inactiveCalendarValue;
                // Only sync when has value, this will sync in the `min-max` logic
                if (nextPickerValue) {
                    // nextPickerValue < minDate
                    if (minDate && generateConfig.isAfter(minDate, nextPickerValue)) nextPickerValue = minDate;
                    // maxDate < nextPickerValue
                    const offsetPickerValue = multiplePanel ? $58210ec7ad711cce$export$b0e4aff419ae4233(generateConfig, pickerMode, nextPickerValue, 1) : nextPickerValue;
                    if (maxDate && generateConfig.isAfter(offsetPickerValue, maxDate)) nextPickerValue = multiplePanel ? $58210ec7ad711cce$export$b0e4aff419ae4233(generateConfig, pickerMode, maxDate, -1) : maxDate;
                    setCurrentPickerValue(nextPickerValue, "reset");
                }
            }
        }
    }, [
        open,
        preserveOnFieldChange,
        mergedActiveIndex,
        calendarValue[mergedActiveIndex]
    ]);
    // >>> Track previous field only during one continuous Picker focus session
    $cQmXV.useEffect(()=>{
        if (open && preserveOnFieldChange) prevActiveIndexRef.current = mergedActiveIndex;
        else prevActiveIndexRef.current = null;
    }, [
        open,
        preserveOnFieldChange,
        mergedActiveIndex
    ]);
    // >>> defaultPickerValue: Resync to `defaultPickerValue` for each panel focused
    (0, $7673d874dab69d07$export$2e2bcd8739ae039)(()=>{
        if (open && defaultPickerValue) {
            if (defaultPickerValue[mergedActiveIndex]) setCurrentPickerValue(defaultPickerValue[mergedActiveIndex], "reset");
        }
    }, [
        open,
        mergedActiveIndex
    ]);
    return [
        currentPickerValue,
        setCurrentPickerValue
    ];
}




var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");
function $6fa0cdfe255658d8$export$2e2bcd8739ae039(defaultValue, controlledValue) {
    const valueRef = $cQmXV.useRef(defaultValue);
    const [, forceUpdate] = $cQmXV.useState({});
    const getter = (useControlledValueFirst)=>useControlledValueFirst && controlledValue !== undefined ? controlledValue : valueRef.current;
    const setter = (nextValue)=>{
        valueRef.current = nextValue;
        forceUpdate({});
    };
    return [
        getter,
        setter,
        getter(true)
    ];
}




const $546b4a1e52e84023$var$EMPTY_VALUE = [];
// Submit Logic:
// * ✅ Value:
//    * merged value using controlled value, if not, use stateValue
//    * When merged value change, [1] resync calendar value and submit value
// * ✅ Calender Value:
//    * 💻 When user typing is validate, change the calendar value
//    * 🌅 When user click on the panel, change the calendar value
// * Submit Value:
//    * 💻 When user blur the input, flush calendar value to submit value
//    * 🌅 When user click on the panel is no needConfirm, flush calendar value to submit value
//    * 🌅 When user click on the panel is needConfirm and click OK, flush calendar value to submit value
// * Blur logic & close logic:
//    * ✅ For value, always try flush submit
//    * ✅ If `needConfirm`, reset as [1]
//    * Else (`!needConfirm`)
//      * If has another index field, active another index
// * ✅ Flush submit:
//    * If all the start & end field is confirmed or all blur or panel closed
//    * Update `needSubmit` mark to true
//    * trigger onChange by `needSubmit` and update stateValue
function $546b4a1e52e84023$var$useUtil(generateConfig, locale, formatList) {
    const getDateTexts = (dates)=>{
        return dates.map((date)=>(0, $56194b7cc1a1787c$export$7c4d25c0c3217d8c)(date, {
                generateConfig: generateConfig,
                locale: locale,
                format: formatList[0]
            }));
    };
    const isSameDates = (source, target)=>{
        const maxLen = Math.max(source.length, target.length);
        let diffIndex = -1;
        for(let i = 0; i < maxLen; i += 1){
            const prev = source[i] || null;
            const next = target[i] || null;
            if (prev !== next && !(0, $56194b7cc1a1787c$export$730a188731b5a146)(generateConfig, prev, next)) {
                diffIndex = i;
                break;
            }
        }
        return [
            diffIndex < 0,
            diffIndex !== 0
        ];
    };
    return [
        getDateTexts,
        isSameDates
    ];
}
function $546b4a1e52e84023$var$orderDates(dates, generateConfig) {
    return [
        ...dates
    ].sort((a, b)=>generateConfig.isAfter(a, b) ? 1 : -1);
}
/**
 * Used for internal value management.
 * It should always use `mergedValue` in render logic
 */ function $546b4a1e52e84023$var$useCalendarValue(mergedValue) {
    const [calendarValue, setCalendarValue] = (0, $6fa0cdfe255658d8$export$2e2bcd8739ae039)(mergedValue);
    /** Sync calendarValue & submitValue back with value */ const syncWithValue = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)(()=>{
        setCalendarValue(mergedValue);
    });
    $cQmXV.useEffect(()=>{
        syncWithValue();
    }, [
        mergedValue
    ]);
    return [
        calendarValue,
        setCalendarValue
    ];
}
function $546b4a1e52e84023$export$eef0e5a163935805(generateConfig, locale, formatList, /** Used for RangePicker. `true` means [DateType, DateType] or will be DateType[] */ rangeValue, /**
 * Trigger order when trigger calendar value change.
 * This should only used in SinglePicker with `multiple` mode.
 * So when `rangeValue` is `true`, order will be ignored.
 */ order, defaultValue, value, onCalendarChange, onOk) {
    // This is the root value which will sync with controlled or uncontrolled value
    const [innerValue, setInnerValue] = (0, $a51866d781137e08$export$2e2bcd8739ae039)(defaultValue, value);
    const mergedValue = innerValue || $546b4a1e52e84023$var$EMPTY_VALUE;
    // ========================= Inner Values =========================
    const [calendarValue, setCalendarValue] = $546b4a1e52e84023$var$useCalendarValue(mergedValue);
    // ============================ Change ============================
    const [getDateTexts, isSameDates] = $546b4a1e52e84023$var$useUtil(generateConfig, locale, formatList);
    const triggerCalendarChange = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((nextCalendarValues)=>{
        let clone = [
            ...nextCalendarValues
        ];
        if (rangeValue) for(let i = 0; i < 2; i += 1)clone[i] = clone[i] || null;
        else if (order) clone = $546b4a1e52e84023$var$orderDates(clone.filter((date)=>date), generateConfig);
        // Update merged value
        const [isSameMergedDates, isSameStart] = isSameDates(calendarValue(), clone);
        if (!isSameMergedDates) {
            setCalendarValue(clone);
            // Trigger calendar change event
            if (onCalendarChange) {
                const cellTexts = getDateTexts(clone);
                onCalendarChange(clone, cellTexts, {
                    range: isSameStart ? "end" : "start"
                });
            }
        }
    });
    const triggerOk = ()=>{
        if (onOk) onOk(calendarValue());
    };
    return [
        mergedValue,
        setInnerValue,
        calendarValue,
        triggerCalendarChange,
        triggerOk
    ];
}
function $546b4a1e52e84023$export$2e2bcd8739ae039(info, mergedValue, setInnerValue, getCalendarValue, triggerCalendarChange, disabled, formatList, isInvalidateDate) {
    const { generateConfig: // MISC
    generateConfig, locale: locale, picker: picker, onChange: onChange, allowEmpty: // Checker
    allowEmpty, order: order } = info;
    const orderOnChange = disabled.some((d)=>d) ? false : order;
    // ============================= Util =============================
    const [getDateTexts, isSameDates] = $546b4a1e52e84023$var$useUtil(generateConfig, locale, formatList);
    // ============================ Values ============================
    // Used for trigger `onChange` event.
    // Record current value which is wait for submit.
    const [submitValue, setSubmitValue] = (0, $6fa0cdfe255658d8$export$2e2bcd8739ae039)(mergedValue);
    /** Sync calendarValue & submitValue back with value */ const syncWithValue = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)(()=>{
        setSubmitValue(mergedValue);
    });
    $cQmXV.useEffect(()=>{
        syncWithValue();
    }, [
        mergedValue
    ]);
    // ============================ Submit ============================
    const triggerSubmit = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((nextValue)=>{
        const isNullValue = nextValue === null;
        let clone = [
            ...nextValue || submitValue()
        ];
        // Fill null value
        if (isNullValue) {
            const maxLen = Math.max(disabled.length, clone.length);
            for(let i = 0; i < maxLen; i += 1)if (!disabled[i]) clone[i] = null;
        }
        // Only when exist value to sort
        if (orderOnChange && clone[0] && clone[1]) clone = $546b4a1e52e84023$var$orderDates(clone, generateConfig);
        // Sync `calendarValue`
        triggerCalendarChange(clone);
        // ========= Validate check =========
        const [start, end] = clone;
        // >>> Empty
        const startEmpty = !start;
        const endEmpty = !end;
        const validateEmptyDateRange = allowEmpty ? // Validate empty start
        (!startEmpty || allowEmpty[0]) && // Validate empty end
        (!endEmpty || allowEmpty[1]) : true;
        // >>> Order
        const validateOrder = !order || startEmpty || endEmpty || (0, $56194b7cc1a1787c$export$18ac18efd9e98d41)(generateConfig, locale, start, end, picker) || generateConfig.isAfter(end, start);
        // >>> Invalid
        const validateDates = // Validate start
        (disabled[0] || !start || !isInvalidateDate(start, {
            activeIndex: 0
        })) && // Validate end
        (disabled[1] || !end || !isInvalidateDate(end, {
            from: start,
            activeIndex: 1
        }));
        // >>> Result
        const allPassed = // Null value is from clear button
        isNullValue || // Normal check
        validateEmptyDateRange && validateOrder && validateDates;
        if (allPassed) {
            // Sync value with submit value
            setInnerValue(clone);
            const [isSameMergedDates] = isSameDates(clone, mergedValue);
            // Trigger `onChange` if needed
            if (onChange && !isSameMergedDates) {
                const everyEmpty = clone.every((val)=>!val);
                onChange(// Return null directly if all date are empty
                isNullValue && everyEmpty ? null : clone, everyEmpty ? null : getDateTexts(clone));
            }
        }
        return allPassed;
    });
    // ========================= Flush Submit =========================
    const flushSubmit = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((index, needTriggerChange)=>{
        const nextSubmitValue = (0, $03e7a71a94f7692c$export$4284846c29a21d02)(submitValue(), index, getCalendarValue()[index]);
        setSubmitValue(nextSubmitValue);
        if (needTriggerChange) triggerSubmit();
    });
    const resetValue = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((index)=>{
        if (index === undefined) {
            triggerCalendarChange(mergedValue);
            syncWithValue();
            return;
        }
        triggerCalendarChange((0, $03e7a71a94f7692c$export$4284846c29a21d02)(getCalendarValue(), index, mergedValue[index]));
        setSubmitValue((0, $03e7a71a94f7692c$export$4284846c29a21d02)(submitValue(), index, mergedValue[index]));
    });
    // ============================ Return ============================
    return [
        flushSubmit,
        triggerSubmit,
        resetValue
    ];
}




var $cQmXV = parcelRequire("cQmXV");
function $9166225084aa8aea$export$2e2bcd8739ae039(fieldCount, needConfirm, allowEmpty, getCalendarValue, triggerCalendarChange, flushSubmit, resetValue) {
    // ============================= State =============================
    // Record fields involved in the current interaction and whether each field
    // has been modified since it became active.
    // 记录当前一轮交互中触发过的 field，以及它从本次激活后是否发生过修改。
    const triggeredFieldsRef = $cQmXV.useRef([]);
    // Track the last explicitly confirmed field. `triggeredFields` also records
    // focus, so it cannot tell confirmed and unconfirmed values apart.
    // 记录最后一个明确确认过的 field。`triggeredFields` 同时记录 focus，
    // 因此无法单独区分已确认值与未确认值。
    const confirmedIndexRef = $cQmXV.useRef(null);
    // Mark whether the latest value update came from the input.
    // 标记最近一次值更新是否来自 input。
    const isLastInputRef = $cQmXV.useRef(false);
    // Keep a render value and a synchronous getter for event handlers.
    // 同时保存渲染值，以及供事件处理函数同步读取的 getter。
    const [getCurrentIndex, setCurrentIndex] = (0, $ca0e9e88b17f6373$export$2e2bcd8739ae039)(null);
    // Record whether the latest index transition must actively move DOM focus.
    // 记录最近一次 index 切换是否需要主动移动 DOM 焦点。
    const [getForceFocus, setForceFocus] = (0, $ca0e9e88b17f6373$export$2e2bcd8739ae039)(false);
    // Keep the latest accepted field for panel and selector rendering.
    // 保留最后一个被业务接受的 field，供 panel 和 selector 渲染使用；
    const lastValidIndexRef = $cQmXV.useRef(undefined);
    // ============================= Reset =============================
    // End the current interaction without changing CalendarValue or the
    // committed value. External events such as Clear can reset bookkeeping and
    // handle their own value update separately.
    // 结束当前交互，但不修改 CalendarValue 或已提交值。Clear 等外部事件可先
    // 重置交互记录，再独立处理自身的值变更。
    const reset = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)(()=>{
        triggeredFieldsRef.current = [];
        confirmedIndexRef.current = null;
        isLastInputRef.current = false;
        setCurrentIndex(null);
        setForceFocus(false);
    });
    // ============================= Record ============================
    // Keep fields unique while preserving their first-triggered order. Omit
    // `modified` to keep the existing state, or pass it to start a new field
    // visit and record a modification.
    // field 保持唯一并保留首次触发顺序。省略 `modified` 时保留原状态；传入时
    // 用于开始一次新的 field 访问，或记录本次修改。
    const recordTriggeredField = (index, modified)=>{
        const field = triggeredFieldsRef.current.find((item)=>item.index === index);
        if (field) {
            if (modified !== undefined) field.modified = modified;
        } else triggeredFieldsRef.current = [
            ...triggeredFieldsRef.current,
            {
                index: index,
                modified: modified ?? false
            }
        ];
    };
    // ============================= Submit ============================
    // Flush the current field and report whether the whole round is complete.
    // Index and focus transitions are handled by the resolved action.
    // 提交当前 field，并返回本轮是否已经完成。index 与焦点切换由解析后的
    // action 负责。
    const submitField = (index)=>{
        recordTriggeredField(index);
        // Trigger final change after every field has participated once.
        // 所有 field 都参与过一次后，触发最终 change。
        const allFieldsTriggered = triggeredFieldsRef.current.length >= fieldCount;
        flushSubmit(index, allFieldsTriggered);
        if (allFieldsTriggered) reset();
        return allFieldsTriggered;
    };
    // ============================= Resolve ===========================
    // Resolve an interaction to one action without changing any state.
    // 仅根据当前状态解析 action，不在判断过程中修改任何状态。
    const resolveAction = (currentIndex, index, source, value)=>{
        if (source === "esc") return "resetAll";
        if (currentIndex === null) // Closing the popup after the interaction has completed still needs to
        // discard any temporary CalendarValue left by a controlled value.
        // 一轮交互结束后关闭 popup，仍需清理受控值留下的临时 CalendarValue。
        return source === "popupClose" ? "resetAll" : "abort";
        const currentValue = value === undefined ? getCalendarValue()[currentIndex] : value;
        const currentEmpty = currentValue === null || currentValue === undefined;
        const canSwitch = !currentEmpty || allowEmpty[currentIndex];
        const canSubmit = source === "remove" || canSwitch;
        if (source === "field-switch") {
            if (index === currentIndex) return "abort";
            const nextIndex = (currentIndex + 1) % fieldCount;
            if (index !== nextIndex) return "abort";
            const nextFieldTriggered = triggeredFieldsRef.current.some((field)=>field.index === nextIndex);
            if (needConfirm) {
                if (confirmedIndexRef.current === currentIndex) return "switchNext";
                // An allowEmpty field may be left without confirmation. Discard any
                // unconfirmed CalendarValue before moving to the next field.
                // allowEmpty field 可以在未确认时离开；切换前需要丢弃未确认的
                // CalendarValue，再进入下一个 field。
                return allowEmpty[currentIndex] ? "resetCurrentAndSwitchNext" : "abort";
            }
            if (canSwitch) return "switchNext";
            // Revisiting the next field starts another circular round. Discard the
            // invalid current field and finish the old round before entering it.
            // 再次进入已触发的 next field 表示开始新一轮循环。进入前先丢弃当前
            // 无效 field，并结束旧的一轮。
            return nextFieldTriggered ? "resetCurrentAndSwitchNext" : "resetCurrent";
        }
        if (index !== currentIndex) return "abort";
        if (source === "popupClose") {
            const interactionModified = triggeredFieldsRef.current.some((field)=>field.modified);
            if (!interactionModified) return "finish";
            if (needConfirm) {
                const currentModified = triggeredFieldsRef.current.some((field)=>field.index === currentIndex && field.modified);
                const allFieldsTriggered = triggeredFieldsRef.current.length >= fieldCount;
                // Closing the popup ends the interaction instead of advancing to an
                // unvisited field. When the current field allows empty, discard its
                // unconfirmed value before finishing the round.
                // 关闭 popup 用于结束交互，不应继续推进到尚未访问的 field。当前
                // field 允许为空时，先丢弃未确认值，再结束本轮。
                if (!allFieldsTriggered || !canSwitch) return "resetAll";
                if (currentModified) return allowEmpty[currentIndex] ? "resetCurrentAndSwitchNext" : "resetAll";
                return "switchNext";
            }
            if (!canSubmit) return "resetAll";
            return "switchNext";
        }
        if (source === "input" || source === "panel-intermediate") return "modify";
        if (source === "panel-final") return needConfirm ? "modify" : "switchNext";
        if (source === "keyboard-submit-weak") return canSubmit ? "submitCurrent" : "abort";
        if (source === "keyboard-submit" || source === "confirm" || source === "remove") return canSubmit ? "switchNext" : "abort";
        return "abort";
    };
    // ============================= Trigger ===========================
    // Route every interaction through action resolution, then execute the
    // resolved action in one place.
    // 所有交互先统一解析 action，再在一个位置执行对应操作。
    const triggerChange = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((index, source, value)=>{
        let currentIndex = getCurrentIndex();
        // Popup close consumes the previous update type instead of replacing it.
        // popup 关闭消费上一次更新类型，自身不覆盖该标记。
        if (source !== "popupClose") isLastInputRef.current = source === "input";
        // Start a new interaction from the first non-close event. Closing the
        // popup may clean temporary values but must not create an active field.
        // 第一条非关闭事件用于建立新一轮交互；关闭 popup 可以清理临时值，
        // 但不应因此创建 currentIndex。
        if (currentIndex === null && source !== "popupClose" && source !== "esc") {
            currentIndex = index;
            setCurrentIndex(index);
            setForceFocus(false);
            recordTriggeredField(index, false);
        }
        const action = resolveAction(currentIndex, index, source, value);
        const actionIndex = currentIndex ?? index;
        switch(action){
            case "modify":
                recordTriggeredField(actionIndex, true);
                if (confirmedIndexRef.current === actionIndex) confirmedIndexRef.current = null;
                if (value !== undefined) triggerCalendarChange(actionIndex, value);
                break;
            case "submitCurrent":
                if (needConfirm) confirmedIndexRef.current = actionIndex;
                submitField(actionIndex);
                break;
            case "switchNext":
                {
                    if (source === "panel-final" || value !== undefined) recordTriggeredField(actionIndex, true);
                    if (value !== undefined) triggerCalendarChange(actionIndex, value);
                    if (needConfirm && (source === "keyboard-submit" || source === "confirm")) confirmedIndexRef.current = actionIndex;
                    // Confirm-like operations and panel-originated popup closes must
                    // move focus to the next field. Input-originated closes remain weak.
                    // 确认类操作和面板操作后的 popup 关闭必须主动聚焦下一个 field；
                    // input 操作后的关闭仍保持弱切换。
                    const forceFocus = source === "confirm" || source === "keyboard-submit" || source === "panel-final" || source === "popupClose" && !isLastInputRef.current;
                    const allFieldsTriggered = submitField(actionIndex);
                    if (allFieldsTriggered && source === "field-switch") {
                        // The focus switch finishes the previous round and also starts a
                        // new round from its target field.
                        // 本次 focus 切换既结束上一轮，也以目标 field 开始新一轮。
                        setCurrentIndex(index);
                        setForceFocus(false);
                    } else if (!allFieldsTriggered) {
                        const nextIndex = (actionIndex + 1) % fieldCount;
                        setCurrentIndex(nextIndex);
                        setForceFocus(forceFocus);
                    }
                    if (source === "field-switch") recordTriggeredField(index, false);
                    break;
                }
            case "finish":
                reset();
                break;
            case "resetCurrent":
                resetValue(actionIndex);
                if (confirmedIndexRef.current === actionIndex) confirmedIndexRef.current = null;
                triggeredFieldsRef.current = triggeredFieldsRef.current.filter((field)=>field.index !== actionIndex);
                break;
            case "resetCurrentAndSwitchNext":
                resetValue(actionIndex);
                if (confirmedIndexRef.current === actionIndex) confirmedIndexRef.current = null;
                if (source === "field-switch") {
                    const nextFieldTriggered = triggeredFieldsRef.current.some((field)=>field.index === index);
                    // A reset never submits or checks whether all fields were handled.
                    // Revisiting the target discards the old round before starting the
                    // next one from that target.
                    // reset 不触发提交，也不判断所有 field 是否已处理。再次进入目标
                    // field 时丢弃旧一轮记录，并从该 field 开启新一轮。
                    if (nextFieldTriggered) triggeredFieldsRef.current = [];
                    setCurrentIndex(index);
                    setForceFocus(false);
                    recordTriggeredField(index, false);
                } else // Closing the popup ends the whole Picker interaction instead of
                // focusing the next field.
                // 关闭 popup 表示结束整个 Picker 交互，因此不再聚焦下一个 field。
                reset();
                break;
            case "resetAll":
                resetValue();
                reset();
                break;
            case "abort":
                if (source === "field-switch" && index === actionIndex) recordTriggeredField(index);
                break;
        }
    });
    const currentIndex = getCurrentIndex();
    lastValidIndexRef.current = currentIndex ?? lastValidIndexRef.current ?? 0;
    const triggeredFields = triggeredFieldsRef.current.map((field)=>field.index);
    return [
        currentIndex,
        lastValidIndexRef.current,
        getForceFocus(),
        triggeredFields,
        triggerChange,
        reset
    ];
}


function $b81005c1d5a2d816$export$2e2bcd8739ae039(picker, mode, showNow, showToday, rangePicker) {
    if (mode !== "date" && mode !== "time") return false;
    if (showNow !== undefined) return showNow;
    // Compatible with old version `showToday`
    if (showToday !== undefined) return showToday;
    return !rangePicker && (picker === "date" || picker === "time");
}





var $cQmXV = parcelRequire("cQmXV");




var $cQmXV = parcelRequire("cQmXV");


var $cQmXV = parcelRequire("cQmXV");
function $f4d750fe6872c438$export$fda2dbcfb6a1d654(date, getHourUnits, getMinuteUnits, getSecondUnits, getMillisecondUnits, generateConfig) {
    let nextDate = date;
    function alignValidate(getUnitValue, setUnitValue, units) {
        let nextValue = generateConfig[getUnitValue](nextDate);
        const nextUnit = units.find((unit)=>unit.value === nextValue);
        if (!nextUnit || nextUnit.disabled) {
            // Find most closest unit
            const validateUnits = units.filter((unit)=>!unit.disabled);
            const reverseEnabledUnits = [
                ...validateUnits
            ].reverse();
            const validateUnit = reverseEnabledUnits.find((unit)=>unit.value <= nextValue) || validateUnits[0];
            if (validateUnit) {
                nextValue = validateUnit.value;
                nextDate = generateConfig[setUnitValue](nextDate, nextValue);
            }
        }
        return nextValue;
    }
    // Find validate hour
    const nextHour = alignValidate("getHour", "setHour", getHourUnits());
    // Find validate minute
    const nextMinute = alignValidate("getMinute", "setMinute", getMinuteUnits(nextHour));
    // Find validate second
    const nextSecond = alignValidate("getSecond", "setSecond", getSecondUnits(nextHour, nextMinute));
    // Find validate millisecond
    alignValidate("getMillisecond", "setMillisecond", getMillisecondUnits(nextHour, nextMinute, nextSecond));
    return nextDate;
}



function $da6b058f0d3ed7a1$var$emptyDisabled() {
    return [];
}
function $da6b058f0d3ed7a1$var$generateUnits(start, end, step = 1, hideDisabledOptions = false, disabledUnits = [], pad = 2) {
    const units = [];
    const integerStep = step >= 1 ? step | 0 : 1;
    for(let i = start; i <= end; i += integerStep){
        const disabled = disabledUnits.includes(i);
        if (!disabled || !hideDisabledOptions) units.push({
            label: (0, $03e7a71a94f7692c$export$cbb503201166aab7)(i, pad),
            value: i,
            disabled: disabled
        });
    }
    return units;
}
function $da6b058f0d3ed7a1$export$2e2bcd8739ae039(generateConfig, props = {}, date) {
    const { use12Hours: // Show
    use12Hours, hourStep: // Steps
    hourStep = 1, minuteStep: minuteStep = 1, secondStep: secondStep = 1, millisecondStep: millisecondStep = 100, hideDisabledOptions: // Disabled
    hideDisabledOptions, disabledTime: disabledTime, disabledHours: disabledHours, disabledMinutes: disabledMinutes, disabledSeconds: disabledSeconds } = props || {};
    const mergedDate = $cQmXV.useMemo(()=>date || generateConfig.getNow(), [
        date,
        generateConfig
    ]);
    // ======================== Disabled ========================
    const getDisabledTimes = $cQmXV.useCallback((targetDate)=>{
        const disabledConfig = disabledTime?.(targetDate) || {};
        return [
            disabledConfig.disabledHours || disabledHours || $da6b058f0d3ed7a1$var$emptyDisabled,
            disabledConfig.disabledMinutes || disabledMinutes || $da6b058f0d3ed7a1$var$emptyDisabled,
            disabledConfig.disabledSeconds || disabledSeconds || $da6b058f0d3ed7a1$var$emptyDisabled,
            disabledConfig.disabledMilliseconds || $da6b058f0d3ed7a1$var$emptyDisabled
        ];
    }, [
        disabledTime,
        disabledHours,
        disabledMinutes,
        disabledSeconds
    ]);
    const [mergedDisabledHours, mergedDisabledMinutes, mergedDisabledSeconds, mergedDisabledMilliseconds] = $cQmXV.useMemo(()=>getDisabledTimes(mergedDate), [
        mergedDate,
        getDisabledTimes
    ]);
    // ========================= Column =========================
    const getAllUnits = $cQmXV.useCallback((getDisabledHours, getDisabledMinutes, getDisabledSeconds, getDisabledMilliseconds)=>{
        const hours = $da6b058f0d3ed7a1$var$generateUnits(0, 23, hourStep, hideDisabledOptions, getDisabledHours());
        // Hours
        const rowHourUnits = use12Hours ? hours.map((unit)=>({
                ...unit,
                label: (0, $03e7a71a94f7692c$export$cbb503201166aab7)(unit.value % 12 || 12, 2)
            })) : hours;
        // Minutes
        const getMinuteUnits = (nextHour)=>$da6b058f0d3ed7a1$var$generateUnits(0, 59, minuteStep, hideDisabledOptions, getDisabledMinutes(nextHour));
        // Seconds
        const getSecondUnits = (nextHour, nextMinute)=>$da6b058f0d3ed7a1$var$generateUnits(0, 59, secondStep, hideDisabledOptions, getDisabledSeconds(nextHour, nextMinute));
        // Milliseconds
        const getMillisecondUnits = (nextHour, nextMinute, nextSecond)=>$da6b058f0d3ed7a1$var$generateUnits(0, 999, millisecondStep, hideDisabledOptions, getDisabledMilliseconds(nextHour, nextMinute, nextSecond), 3);
        return [
            rowHourUnits,
            getMinuteUnits,
            getSecondUnits,
            getMillisecondUnits
        ];
    }, [
        hideDisabledOptions,
        hourStep,
        use12Hours,
        millisecondStep,
        minuteStep,
        secondStep
    ]);
    const [rowHourUnits, getMinuteUnits, getSecondUnits, getMillisecondUnits] = $cQmXV.useMemo(()=>getAllUnits(mergedDisabledHours, mergedDisabledMinutes, mergedDisabledSeconds, mergedDisabledMilliseconds), [
        getAllUnits,
        mergedDisabledHours,
        mergedDisabledMinutes,
        mergedDisabledSeconds,
        mergedDisabledMilliseconds
    ]);
    // ======================== Validate ========================
    /**
   * Get validate time with `disabledTime`, `certainDate` to specific the date need to check
   */ const getValidTime = (nextTime, certainDate)=>{
        let getCheckHourUnits = ()=>rowHourUnits;
        let getCheckMinuteUnits = getMinuteUnits;
        let getCheckSecondUnits = getSecondUnits;
        let getCheckMillisecondUnits = getMillisecondUnits;
        if (certainDate) {
            const [targetDisabledHours, targetDisabledMinutes, targetDisabledSeconds, targetDisabledMilliseconds] = getDisabledTimes(certainDate);
            const [targetRowHourUnits, targetGetMinuteUnits, targetGetSecondUnits, targetGetMillisecondUnits] = getAllUnits(targetDisabledHours, targetDisabledMinutes, targetDisabledSeconds, targetDisabledMilliseconds);
            getCheckHourUnits = ()=>targetRowHourUnits;
            getCheckMinuteUnits = targetGetMinuteUnits;
            getCheckSecondUnits = targetGetSecondUnits;
            getCheckMillisecondUnits = targetGetMillisecondUnits;
        }
        const validateDate = (0, $f4d750fe6872c438$export$fda2dbcfb6a1d654)(nextTime, getCheckHourUnits, getCheckMinuteUnits, getCheckSecondUnits, getCheckMillisecondUnits, generateConfig);
        return validateDate;
    };
    return [
        // getValidTime
        getValidTime,
        // Units
        rowHourUnits,
        getMinuteUnits,
        getSecondUnits,
        getMillisecondUnits
    ];
}



function $7b12b11ae04cc075$export$2e2bcd8739ae039(props) {
    const { mode: mode, internalMode: internalMode, renderExtraFooter: renderExtraFooter, showNow: showNow, showTime: showTime, onSubmit: onSubmit, onNow: onNow, invalid: invalid, needConfirm: needConfirm, generateConfig: generateConfig, disabledDate: disabledDate } = props;
    const { prefixCls: prefixCls, locale: locale, button: Button = "button", classNames: classNames, styles: styles } = $cQmXV.useContext((0, $8ffb82fb472fb634$export$2e2bcd8739ae039));
    // >>> Now
    const now = generateConfig.getNow();
    const [getValidTime] = (0, $da6b058f0d3ed7a1$export$2e2bcd8739ae039)(generateConfig, showTime, now);
    // ======================== Extra =========================
    const extraNode = renderExtraFooter?.(mode);
    // ======================== Ranges ========================
    const nowDisabled = disabledDate(now, {
        type: mode
    });
    const onInternalNow = ()=>{
        if (!nowDisabled) {
            const validateNow = getValidTime(now);
            onNow(validateNow);
        }
    };
    const nowPrefixCls = `${prefixCls}-now`;
    const nowBtnPrefixCls = `${nowPrefixCls}-btn`;
    const presetNode = showNow && /*#__PURE__*/ $cQmXV.createElement("li", {
        className: nowPrefixCls
    }, /*#__PURE__*/ $cQmXV.createElement("a", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(nowBtnPrefixCls, nowDisabled && `${nowBtnPrefixCls}-disabled`),
        "aria-disabled": nowDisabled,
        onClick: onInternalNow
    }, internalMode === "date" ? locale.today : locale.now));
    // >>> OK
    const okNode = needConfirm && /*#__PURE__*/ $cQmXV.createElement("li", {
        className: `${prefixCls}-ok`
    }, /*#__PURE__*/ $cQmXV.createElement(Button, {
        disabled: invalid,
        onClick: onSubmit
    }, locale.ok));
    const rangeNode = (presetNode || okNode) && /*#__PURE__*/ $cQmXV.createElement("ul", {
        className: `${prefixCls}-ranges`
    }, presetNode, okNode);
    // ======================== Render ========================
    if (!extraNode && !rangeNode) return null;
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-footer`, classNames.popup.footer),
        style: styles.popup.footer
    }, extraNode && /*#__PURE__*/ $cQmXV.createElement("div", {
        className: `${prefixCls}-footer-extra`
    }, extraNode), rangeNode);
}



var $cQmXV = parcelRequire("cQmXV");



var $cQmXV = parcelRequire("cQmXV");



function $e6951cd73102e980$export$2e2bcd8739ae039(generateConfig, locale, panelMode) {
    function toggleDates(list, target) {
        const index = list.findIndex((date)=>(0, $56194b7cc1a1787c$export$18ac18efd9e98d41)(generateConfig, locale, date, target, panelMode));
        if (index === -1) return [
            ...list,
            target
        ];
        const sliceList = [
            ...list
        ];
        sliceList.splice(index, 1);
        return sliceList;
    }
    return toggleDates;
}







var $cQmXV = parcelRequire("cQmXV");
const $82841072316a6ae1$export$d1173f47489c79e4 = /*#__PURE__*/ $cQmXV.createContext(null);
const $82841072316a6ae1$export$f34532ac99e32150 = /*#__PURE__*/ $cQmXV.createContext(null);
function $82841072316a6ae1$export$2fe6b5e489926495() {
    return $cQmXV.useContext($82841072316a6ae1$export$f34532ac99e32150);
}
function $82841072316a6ae1$export$2ae76d51704c9302(props, panelType) {
    // TODO: this is not good to get from each props.
    // Should move to `SharedPanelContext` instead.
    const { prefixCls: prefixCls, generateConfig: generateConfig, locale: locale, disabledDate: disabledDate, minDate: minDate, maxDate: maxDate, cellRender: cellRender, hoverValue: hoverValue, hoverRangeValue: hoverRangeValue, onHover: onHover, values: values, pickerValue: pickerValue, onSelect: onSelect, prevIcon: // Icons
    prevIcon, nextIcon: nextIcon, superPrevIcon: superPrevIcon, superNextIcon: superNextIcon } = props;
    // ======================= Context ========================
    const { classNames: classNames, styles: styles } = $cQmXV.useContext($82841072316a6ae1$export$d1173f47489c79e4);
    // ========================= MISC =========================
    const now = generateConfig.getNow();
    // ========================= Info =========================
    const info = {
        now: now,
        values: values,
        pickerValue: pickerValue,
        prefixCls: prefixCls,
        classNames: classNames,
        styles: styles,
        disabledDate: disabledDate,
        minDate: minDate,
        maxDate: maxDate,
        cellRender: cellRender,
        hoverValue: hoverValue,
        hoverRangeValue: hoverRangeValue,
        onHover: onHover,
        locale: locale,
        generateConfig: generateConfig,
        onSelect: onSelect,
        panelType: panelType,
        prevIcon: // Icons
        prevIcon,
        nextIcon: nextIcon,
        superPrevIcon: superPrevIcon,
        superNextIcon: superNextIcon
    };
    return [
        info,
        now
    ];
}
const $82841072316a6ae1$export$c3f9070e5d88313b = /*#__PURE__*/ $cQmXV.createContext({});




var $cQmXV = parcelRequire("cQmXV");




var $cQmXV = parcelRequire("cQmXV");


function $b82cb4f3d0221c7b$export$2e2bcd8739ae039(props) {
    const { rowNum: rowNum, colNum: colNum, baseDate: baseDate, getCellDate: getCellDate, prefixColumn: prefixColumn, rowClassName: rowClassName, titleFormat: titleFormat, getCellText: getCellText, getCellClassName: getCellClassName, headerCells: headerCells, cellSelection: cellSelection = true, disabledDate: disabledDate } = props;
    const { prefixCls: prefixCls, classNames: classNames, styles: styles, panelType: type, now: now, disabledDate: contextDisabledDate, cellRender: cellRender, onHover: onHover, hoverValue: hoverValue, hoverRangeValue: hoverRangeValue, generateConfig: generateConfig, values: values, locale: locale, onSelect: onSelect } = (0, $82841072316a6ae1$export$2fe6b5e489926495)();
    const mergedDisabledDate = disabledDate || contextDisabledDate;
    const cellPrefixCls = `${prefixCls}-cell`;
    // ============================= Context ==============================
    const { onCellDblClick: onCellDblClick } = $cQmXV.useContext((0, $82841072316a6ae1$export$c3f9070e5d88313b));
    // ============================== Value ===============================
    const matchValues = (date)=>values.some((singleValue)=>singleValue && (0, $56194b7cc1a1787c$export$18ac18efd9e98d41)(generateConfig, locale, date, singleValue, type));
    // =============================== Body ===============================
    const rows = [];
    for(let row = 0; row < rowNum; row += 1){
        const rowNode = [];
        let rowStartDate;
        for(let col = 0; col < colNum; col += 1){
            const offset = row * colNum + col;
            const currentDate = getCellDate(baseDate, offset);
            const disabled = mergedDisabledDate?.(currentDate, {
                type: type
            });
            // Row Start Cell
            if (col === 0) {
                rowStartDate = currentDate;
                if (prefixColumn) rowNode.push(prefixColumn(rowStartDate));
            }
            // Range
            let inRange = false;
            let rangeStart = false;
            let rangeEnd = false;
            if (cellSelection && hoverRangeValue) {
                const [hoverStart, hoverEnd] = hoverRangeValue;
                inRange = (0, $56194b7cc1a1787c$export$6dabbcb26357acf4)(generateConfig, hoverStart, hoverEnd, currentDate);
                rangeStart = (0, $56194b7cc1a1787c$export$18ac18efd9e98d41)(generateConfig, locale, currentDate, hoverStart, type);
                rangeEnd = (0, $56194b7cc1a1787c$export$18ac18efd9e98d41)(generateConfig, locale, currentDate, hoverEnd, type);
            }
            // Title
            const title = titleFormat ? (0, $56194b7cc1a1787c$export$7c4d25c0c3217d8c)(currentDate, {
                locale: locale,
                format: titleFormat,
                generateConfig: generateConfig
            }) : undefined;
            // Render
            const inner = /*#__PURE__*/ $cQmXV.createElement("div", {
                className: `${cellPrefixCls}-inner`
            }, getCellText(currentDate));
            rowNode.push(/*#__PURE__*/ $cQmXV.createElement("td", {
                key: col,
                title: title,
                className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(cellPrefixCls, classNames.item, {
                    [`${cellPrefixCls}-disabled`]: disabled,
                    [`${cellPrefixCls}-hover`]: (hoverValue || []).some((date)=>(0, $56194b7cc1a1787c$export$18ac18efd9e98d41)(generateConfig, locale, currentDate, date, type)),
                    [`${cellPrefixCls}-in-range`]: inRange && !rangeStart && !rangeEnd,
                    [`${cellPrefixCls}-range-start`]: rangeStart,
                    [`${cellPrefixCls}-range-end`]: rangeEnd,
                    [`${prefixCls}-cell-selected`]: !hoverRangeValue && // WeekPicker use row instead
                    type !== "week" && matchValues(currentDate),
                    ...getCellClassName(currentDate)
                }),
                style: styles.item,
                onClick: ()=>{
                    if (!disabled) onSelect(currentDate);
                },
                onDoubleClick: ()=>{
                    if (!disabled && onCellDblClick) onCellDblClick();
                },
                onMouseEnter: ()=>{
                    if (!disabled) onHover?.(currentDate);
                },
                onMouseLeave: ()=>{
                    if (!disabled) onHover?.(null);
                }
            }, cellRender ? cellRender(currentDate, {
                prefixCls: prefixCls,
                originNode: inner,
                today: now,
                type: type,
                locale: locale
            }) : inner));
        }
        rows.push(/*#__PURE__*/ $cQmXV.createElement("tr", {
            key: row,
            className: rowClassName?.(rowStartDate)
        }, rowNode));
    }
    // ============================== Render ==============================
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-body`, classNames.body),
        style: styles.body
    }, /*#__PURE__*/ $cQmXV.createElement("table", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-content`, classNames.content),
        style: styles.content
    }, headerCells && /*#__PURE__*/ $cQmXV.createElement("thead", null, /*#__PURE__*/ $cQmXV.createElement("tr", null, headerCells)), /*#__PURE__*/ $cQmXV.createElement("tbody", null, rows)));
}




var $cQmXV = parcelRequire("cQmXV");


const $f261539dcfbc375e$var$HIDDEN_STYLE = {
    visibility: "hidden"
};
function $f261539dcfbc375e$var$PanelHeader(props) {
    const { offset: offset, superOffset: superOffset, onChange: onChange, getStart: getStart, getEnd: getEnd, children: children } = props;
    const { prefixCls: prefixCls, classNames: classNames, styles: styles, prevIcon: // Icons
    prevIcon = "\u2039", nextIcon: nextIcon = "\u203A", superPrevIcon: superPrevIcon = "\xab", superNextIcon: superNextIcon = "\xbb", minDate: // Limitation
    minDate, maxDate: maxDate, generateConfig: generateConfig, locale: locale, pickerValue: pickerValue, panelType: type } = (0, $82841072316a6ae1$export$2fe6b5e489926495)();
    const headerPrefixCls = `${prefixCls}-header`;
    const { hidePrev: hidePrev, hideNext: hideNext, hideHeader: hideHeader } = $cQmXV.useContext((0, $82841072316a6ae1$export$c3f9070e5d88313b));
    // ======================= Limitation =======================
    const disabledOffsetPrev = $cQmXV.useMemo(()=>{
        if (!minDate || !offset || !getEnd) return false;
        const prevPanelLimitDate = getEnd(offset(-1, pickerValue));
        return !(0, $56194b7cc1a1787c$export$a663815b3d4a2ed6)(generateConfig, locale, prevPanelLimitDate, minDate, type);
    }, [
        minDate,
        offset,
        pickerValue,
        getEnd,
        generateConfig,
        locale,
        type
    ]);
    const disabledSuperOffsetPrev = $cQmXV.useMemo(()=>{
        if (!minDate || !superOffset || !getEnd) return false;
        const prevPanelLimitDate = getEnd(superOffset(-1, pickerValue));
        return !(0, $56194b7cc1a1787c$export$a663815b3d4a2ed6)(generateConfig, locale, prevPanelLimitDate, minDate, type);
    }, [
        minDate,
        superOffset,
        pickerValue,
        getEnd,
        generateConfig,
        locale,
        type
    ]);
    const disabledOffsetNext = $cQmXV.useMemo(()=>{
        if (!maxDate || !offset || !getStart) return false;
        const nextPanelLimitDate = getStart(offset(1, pickerValue));
        return !(0, $56194b7cc1a1787c$export$a663815b3d4a2ed6)(generateConfig, locale, maxDate, nextPanelLimitDate, type);
    }, [
        maxDate,
        offset,
        pickerValue,
        getStart,
        generateConfig,
        locale,
        type
    ]);
    const disabledSuperOffsetNext = $cQmXV.useMemo(()=>{
        if (!maxDate || !superOffset || !getStart) return false;
        const nextPanelLimitDate = getStart(superOffset(1, pickerValue));
        return !(0, $56194b7cc1a1787c$export$a663815b3d4a2ed6)(generateConfig, locale, maxDate, nextPanelLimitDate, type);
    }, [
        maxDate,
        superOffset,
        pickerValue,
        getStart,
        generateConfig,
        locale,
        type
    ]);
    // ========================= Offset =========================
    const onOffset = (distance)=>{
        if (offset) onChange(offset(distance, pickerValue));
    };
    const onSuperOffset = (distance)=>{
        if (superOffset) onChange(superOffset(distance, pickerValue));
    };
    // ========================= Render =========================
    if (hideHeader) return null;
    const prevBtnCls = `${headerPrefixCls}-prev-btn`;
    const nextBtnCls = `${headerPrefixCls}-next-btn`;
    const superPrevBtnCls = `${headerPrefixCls}-super-prev-btn`;
    const superNextBtnCls = `${headerPrefixCls}-super-next-btn`;
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(headerPrefixCls, classNames.header),
        style: styles.header
    }, superOffset && /*#__PURE__*/ $cQmXV.createElement("button", {
        type: "button",
        "aria-label": locale.previousYear,
        onClick: ()=>onSuperOffset(-1),
        tabIndex: -1,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(superPrevBtnCls, disabledSuperOffsetPrev && `${superPrevBtnCls}-disabled`),
        disabled: disabledSuperOffsetPrev,
        style: hidePrev ? $f261539dcfbc375e$var$HIDDEN_STYLE : {}
    }, superPrevIcon), offset && /*#__PURE__*/ $cQmXV.createElement("button", {
        type: "button",
        "aria-label": locale.previousMonth,
        onClick: ()=>onOffset(-1),
        tabIndex: -1,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prevBtnCls, disabledOffsetPrev && `${prevBtnCls}-disabled`),
        disabled: disabledOffsetPrev,
        style: hidePrev ? $f261539dcfbc375e$var$HIDDEN_STYLE : {}
    }, prevIcon), /*#__PURE__*/ $cQmXV.createElement("div", {
        className: `${headerPrefixCls}-view`
    }, children), offset && /*#__PURE__*/ $cQmXV.createElement("button", {
        type: "button",
        "aria-label": locale.nextMonth,
        onClick: ()=>onOffset(1),
        tabIndex: -1,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(nextBtnCls, disabledOffsetNext && `${nextBtnCls}-disabled`),
        disabled: disabledOffsetNext,
        style: hideNext ? $f261539dcfbc375e$var$HIDDEN_STYLE : {}
    }, nextIcon), superOffset && /*#__PURE__*/ $cQmXV.createElement("button", {
        type: "button",
        "aria-label": locale.nextYear,
        onClick: ()=>onSuperOffset(1),
        tabIndex: -1,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(superNextBtnCls, disabledSuperOffsetNext && `${superNextBtnCls}-disabled`),
        disabled: disabledSuperOffsetNext,
        style: hideNext ? $f261539dcfbc375e$var$HIDDEN_STYLE : {}
    }, superNextIcon));
}
var $f261539dcfbc375e$export$2e2bcd8739ae039 = $f261539dcfbc375e$var$PanelHeader;


function $dce444c7c0ebeb4e$var$_extends() {
    $dce444c7c0ebeb4e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $dce444c7c0ebeb4e$var$_extends.apply(this, arguments);
}
function $dce444c7c0ebeb4e$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, panelName: panelName = "date", locale: locale, generateConfig: generateConfig, pickerValue: pickerValue, onPickerValueChange: onPickerValueChange, onModeChange: onModeChange, mode: mode = "date", disabledDate: disabledDate, onSelect: onSelect, onHover: onHover, showWeek: showWeek } = props;
    const panelPrefixCls = `${prefixCls}-${panelName}-panel`;
    const cellPrefixCls = `${prefixCls}-cell`;
    const isWeek = mode === "week";
    // ========================== Base ==========================
    const [info, now] = (0, $82841072316a6ae1$export$2ae76d51704c9302)(props, mode);
    const weekFirstDay = generateConfig.locale.getWeekFirstDay(locale.locale);
    const monthStartDate = generateConfig.setDate(pickerValue, 1);
    const baseDate = (0, $56194b7cc1a1787c$export$e91829c600881133)(locale.locale, generateConfig, monthStartDate);
    const month = generateConfig.getMonth(pickerValue);
    // =========================== PrefixColumn ===========================
    const showPrefixColumn = showWeek === undefined ? isWeek : showWeek;
    const prefixColumn = showPrefixColumn ? (date)=>{
        // >>> Additional check for disabled
        const disabled = disabledDate?.(date, {
            type: "week"
        });
        return /*#__PURE__*/ $cQmXV.createElement("td", {
            key: "week",
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(cellPrefixCls, `${cellPrefixCls}-week`, {
                [`${cellPrefixCls}-disabled`]: disabled
            }),
            onClick: ()=>{
                if (!disabled) onSelect(date);
            },
            onMouseEnter: ()=>{
                if (!disabled) onHover?.(date);
            },
            onMouseLeave: ()=>{
                if (!disabled) onHover?.(null);
            }
        }, /*#__PURE__*/ $cQmXV.createElement("div", {
            className: `${cellPrefixCls}-inner`
        }, generateConfig.locale.getWeek(locale.locale, date)));
    } : null;
    // ========================= Cells ==========================
    // >>> Header Cells
    const headerCells = [];
    const weekDaysLocale = locale.shortWeekDays || (generateConfig.locale.getShortWeekDays ? generateConfig.locale.getShortWeekDays(locale.locale) : []);
    if (prefixColumn) headerCells.push(/*#__PURE__*/ $cQmXV.createElement("th", {
        key: "empty"
    }, /*#__PURE__*/ $cQmXV.createElement("span", {
        style: {
            width: 0,
            height: 0,
            position: "absolute",
            overflow: "hidden",
            opacity: 0
        }
    }, locale.week)));
    for(let i = 0; i < (0, $56194b7cc1a1787c$export$fe62c2dddb4d77ea); i += 1)headerCells.push(/*#__PURE__*/ $cQmXV.createElement("th", {
        key: i
    }, weekDaysLocale[(i + weekFirstDay) % (0, $56194b7cc1a1787c$export$fe62c2dddb4d77ea)]));
    // >>> Body Cells
    const getCellDate = (date, offset)=>{
        return generateConfig.addDate(date, offset);
    };
    const getCellText = (date)=>{
        return (0, $56194b7cc1a1787c$export$7c4d25c0c3217d8c)(date, {
            locale: locale,
            format: locale.cellDateFormat,
            generateConfig: generateConfig
        });
    };
    const getCellClassName = (date)=>{
        const classObj = {
            [`${prefixCls}-cell-in-view`]: (0, $56194b7cc1a1787c$export$a18c89cbd24170ff)(generateConfig, date, pickerValue),
            [`${prefixCls}-cell-today`]: (0, $56194b7cc1a1787c$export$a8b2a21161763694)(generateConfig, date, now)
        };
        return classObj;
    };
    // ========================= Header =========================
    const monthsLocale = locale.shortMonths || (generateConfig.locale.getShortMonths ? generateConfig.locale.getShortMonths(locale.locale) : []);
    const yearNode = /*#__PURE__*/ $cQmXV.createElement("button", {
        type: "button",
        "aria-label": locale.yearSelect,
        key: "year",
        onClick: ()=>{
            onModeChange("year", pickerValue);
        },
        tabIndex: -1,
        className: `${prefixCls}-year-btn`
    }, (0, $56194b7cc1a1787c$export$7c4d25c0c3217d8c)(pickerValue, {
        locale: locale,
        format: locale.yearFormat,
        generateConfig: generateConfig
    }));
    const monthNode = /*#__PURE__*/ $cQmXV.createElement("button", {
        type: "button",
        "aria-label": locale.monthSelect,
        key: "month",
        onClick: ()=>{
            onModeChange("month", pickerValue);
        },
        tabIndex: -1,
        className: `${prefixCls}-month-btn`
    }, locale.monthFormat ? (0, $56194b7cc1a1787c$export$7c4d25c0c3217d8c)(pickerValue, {
        locale: locale,
        format: locale.monthFormat,
        generateConfig: generateConfig
    }) : monthsLocale[month]);
    const monthYearNodes = locale.monthBeforeYear ? [
        monthNode,
        yearNode
    ] : [
        yearNode,
        monthNode
    ];
    // ========================= Render =========================
    return /*#__PURE__*/ $cQmXV.createElement((0, $82841072316a6ae1$export$f34532ac99e32150).Provider, {
        value: info
    }, /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(panelPrefixCls, showWeek && `${panelPrefixCls}-show-week`)
    }, /*#__PURE__*/ $cQmXV.createElement((0, $f261539dcfbc375e$export$2e2bcd8739ae039), {
        offset: (distance)=>generateConfig.addMonth(pickerValue, distance),
        superOffset: (distance)=>generateConfig.addYear(pickerValue, distance),
        onChange: onPickerValueChange,
        getStart: (date)=>generateConfig.setDate(date, 1),
        getEnd: (date)=>{
            let clone = generateConfig.setDate(date, 1);
            clone = generateConfig.addMonth(clone, 1);
            return generateConfig.addDate(clone, -1);
        }
    }, monthYearNodes), /*#__PURE__*/ $cQmXV.createElement((0, $b82cb4f3d0221c7b$export$2e2bcd8739ae039), $dce444c7c0ebeb4e$var$_extends({
        titleFormat: locale.fieldDateFormat
    }, props, {
        colNum: (0, $56194b7cc1a1787c$export$fe62c2dddb4d77ea),
        rowNum: 6,
        baseDate: baseDate,
        headerCells: headerCells,
        getCellDate: getCellDate,
        getCellText: getCellText,
        getCellClassName: getCellClassName,
        prefixColumn: prefixColumn,
        cellSelection: !isWeek
    }))));
}



var $cQmXV = parcelRequire("cQmXV");





var $cQmXV = parcelRequire("cQmXV");




var $cQmXV = parcelRequire("cQmXV");






var $cQmXV = parcelRequire("cQmXV");



var $cQmXV = parcelRequire("cQmXV");
const $bb37239d6b831787$var$SPEED_PTG = 1 / 3;
function $bb37239d6b831787$export$2e2bcd8739ae039(ulRef, value) {
    // ========================= Scroll =========================
    const scrollingRef = $cQmXV.useRef(false);
    const scrollRafRef = $cQmXV.useRef(null);
    const scrollDistRef = $cQmXV.useRef(null);
    const isScrolling = ()=>scrollingRef.current;
    const stopScroll = ()=>{
        (0, $905c53b807de704e$export$2e2bcd8739ae039).cancel(scrollRafRef.current);
        scrollingRef.current = false;
    };
    const scrollRafTimesRef = $cQmXV.useRef(undefined);
    const startScroll = ()=>{
        const ul = ulRef.current;
        scrollDistRef.current = null;
        scrollRafTimesRef.current = 0;
        if (ul) {
            const targetLi = ul.querySelector(`[data-value="${value}"]`);
            const firstLi = ul.querySelector(`li`);
            const doScroll = ()=>{
                stopScroll();
                scrollingRef.current = true;
                scrollRafTimesRef.current += 1;
                const { scrollTop: currentTop } = ul;
                const firstLiTop = firstLi.offsetTop;
                const targetLiTop = targetLi.offsetTop;
                const targetTop = targetLiTop - firstLiTop;
                // Wait for element exist. 5 frames is enough
                if (targetLiTop === 0 && targetLi !== firstLi || !(0, $c70640475a7bd353$export$2e2bcd8739ae039)(ul)) {
                    if (scrollRafTimesRef.current <= 5) scrollRafRef.current = (0, $905c53b807de704e$export$2e2bcd8739ae039)(doScroll);
                    return;
                }
                const nextTop = currentTop + (targetTop - currentTop) * $bb37239d6b831787$var$SPEED_PTG;
                const dist = Math.abs(targetTop - nextTop);
                // Break if dist get larger, which means user is scrolling
                if (scrollDistRef.current !== null && scrollDistRef.current < dist) {
                    stopScroll();
                    return;
                }
                scrollDistRef.current = dist;
                // Stop when dist is less than 1
                if (dist <= 1) {
                    ul.scrollTop = targetTop;
                    stopScroll();
                    return;
                }
                // IE not support `scrollTo`
                ul.scrollTop = nextTop;
                scrollRafRef.current = (0, $905c53b807de704e$export$2e2bcd8739ae039)(doScroll);
            };
            if (targetLi && firstLi) doScroll();
        }
    };
    // ======================== Trigger =========================
    const syncScroll = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)(startScroll);
    return [
        syncScroll,
        stopScroll,
        isScrolling
    ];
}


const $2b47e56c0c101a27$var$SCROLL_DELAY = 300;
// Not use JSON.stringify to avoid dead loop
function $2b47e56c0c101a27$var$flattenUnits(units) {
    return units.map(({ value: value, label: label, disabled: disabled })=>[
            value,
            label,
            disabled
        ].join(",")).join(";");
}
function $2b47e56c0c101a27$export$2e2bcd8739ae039(props) {
    const { units: units, value: value, optionalValue: optionalValue, type: type, onChange: onChange, onHover: onHover, onDblClick: onDblClick, changeOnScroll: changeOnScroll } = props;
    const { prefixCls: prefixCls, cellRender: cellRender, now: now, locale: locale, classNames: classNames, styles: styles } = (0, $82841072316a6ae1$export$2fe6b5e489926495)();
    const panelPrefixCls = `${prefixCls}-time-panel`;
    const cellPrefixCls = `${prefixCls}-time-panel-cell`;
    // ========================== Refs ==========================
    const ulRef = $cQmXV.useRef(null);
    // ========================= Scroll =========================
    const checkDelayRef = $cQmXV.useRef(undefined);
    const clearDelayCheck = ()=>{
        clearTimeout(checkDelayRef.current);
    };
    // ========================== Sync ==========================
    const [syncScroll, stopScroll, isScrolling] = (0, $bb37239d6b831787$export$2e2bcd8739ae039)(ulRef, value ?? optionalValue);
    // Effect sync value scroll
    (0, $7673d874dab69d07$export$2e2bcd8739ae039)(()=>{
        syncScroll();
        clearDelayCheck();
        return ()=>{
            stopScroll();
            clearDelayCheck();
        };
    }, [
        value,
        optionalValue,
        $2b47e56c0c101a27$var$flattenUnits(units)
    ]);
    // ========================= Change =========================
    // Scroll event if sync onScroll
    const onInternalScroll = (event)=>{
        clearDelayCheck();
        const target = event.target;
        if (!isScrolling() && changeOnScroll) checkDelayRef.current = setTimeout(()=>{
            const ul = ulRef.current;
            const firstLiTop = ul.querySelector(`li`).offsetTop;
            const liList = Array.from(ul.querySelectorAll(`li`));
            const liTopList = liList.map((li)=>li.offsetTop - firstLiTop);
            const liDistList = liTopList.map((top, index)=>{
                if (units[index].disabled) return Number.MAX_SAFE_INTEGER;
                return Math.abs(top - target.scrollTop);
            });
            // Find min distance index
            const minDist = Math.min(...liDistList);
            const minDistIndex = liDistList.findIndex((dist)=>dist === minDist);
            const targetUnit = units[minDistIndex];
            if (targetUnit && !targetUnit.disabled) onChange(targetUnit.value);
        }, $2b47e56c0c101a27$var$SCROLL_DELAY);
    };
    // ========================= Render =========================
    const columnPrefixCls = `${panelPrefixCls}-column`;
    return /*#__PURE__*/ $cQmXV.createElement("ul", {
        className: columnPrefixCls,
        ref: ulRef,
        "data-type": type,
        onScroll: onInternalScroll
    }, units.map(({ label: label, value: unitValue, disabled: disabled })=>{
        const inner = /*#__PURE__*/ $cQmXV.createElement("div", {
            className: `${cellPrefixCls}-inner`
        }, label);
        return /*#__PURE__*/ $cQmXV.createElement("li", {
            key: unitValue,
            style: styles.item,
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(cellPrefixCls, classNames.item, {
                [`${cellPrefixCls}-selected`]: value === unitValue,
                [`${cellPrefixCls}-disabled`]: disabled
            }),
            onClick: ()=>{
                if (!disabled) onChange(unitValue);
            },
            onDoubleClick: ()=>{
                if (!disabled && onDblClick) onDblClick();
            },
            onMouseEnter: ()=>{
                onHover(unitValue);
            },
            onMouseLeave: ()=>{
                onHover(null);
            },
            "data-value": unitValue
        }, cellRender ? cellRender(unitValue, {
            prefixCls: prefixCls,
            originNode: inner,
            today: now,
            type: "time",
            subType: type,
            locale: locale
        }) : inner);
    }));
}



function $eabe8ed6f7c5a2d9$var$_extends() {
    $eabe8ed6f7c5a2d9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $eabe8ed6f7c5a2d9$var$_extends.apply(this, arguments);
}
function $eabe8ed6f7c5a2d9$var$isAM(hour) {
    return hour < 12;
}
function $eabe8ed6f7c5a2d9$export$2e2bcd8739ae039(props) {
    const { showHour: // Show Config
    showHour, showMinute: showMinute, showSecond: showSecond, showMillisecond: showMillisecond, use12Hours: showMeridiem, changeOnScroll: // MISC
    changeOnScroll } = props;
    const { prefixCls: prefixCls, classNames: classNames, styles: styles, values: values, generateConfig: generateConfig, locale: locale, onSelect: onSelect, onHover: onHover = ()=>{}, pickerValue: pickerValue } = (0, $82841072316a6ae1$export$2fe6b5e489926495)();
    const value = values?.[0] || null;
    const { onCellDblClick: onCellDblClick } = $cQmXV.useContext((0, $82841072316a6ae1$export$c3f9070e5d88313b));
    // ========================== Info ==========================
    const [getValidTime, rowHourUnits, getMinuteUnits, getSecondUnits, getMillisecondUnits] = (0, $da6b058f0d3ed7a1$export$2e2bcd8739ae039)(generateConfig, props, value);
    // ========================= Value ==========================
    // PickerValue will tell which one to align on the top
    const getUnitValue = (func)=>{
        const valueUnitVal = value && generateConfig[func](value);
        const pickerUnitValue = pickerValue && generateConfig[func](pickerValue);
        return [
            valueUnitVal,
            pickerUnitValue
        ];
    };
    const [hour, pickerHour] = getUnitValue("getHour");
    const [minute, pickerMinute] = getUnitValue("getMinute");
    const [second, pickerSecond] = getUnitValue("getSecond");
    const [millisecond, pickerMillisecond] = getUnitValue("getMillisecond");
    const meridiem = hour === null ? null : $eabe8ed6f7c5a2d9$var$isAM(hour) ? "am" : "pm";
    // ========================= Column =========================
    // Hours
    const hourUnits = $cQmXV.useMemo(()=>{
        if (!showMeridiem) return rowHourUnits;
        return $eabe8ed6f7c5a2d9$var$isAM(hour) ? rowHourUnits.filter((h)=>$eabe8ed6f7c5a2d9$var$isAM(h.value)) : rowHourUnits.filter((h)=>!$eabe8ed6f7c5a2d9$var$isAM(h.value));
    }, [
        hour,
        rowHourUnits,
        showMeridiem
    ]);
    // >>> Pick Fallback
    const getEnabled = (units, val)=>{
        const enabledUnits = units.filter((unit)=>!unit.disabled);
        return val ?? // Fallback to enabled value
        enabledUnits?.[0]?.value;
    };
    // >>> Minutes
    const validHour = getEnabled(rowHourUnits, hour);
    const minuteUnits = $cQmXV.useMemo(()=>getMinuteUnits(validHour), [
        getMinuteUnits,
        validHour
    ]);
    // >>> Seconds
    const validMinute = getEnabled(minuteUnits, minute);
    const secondUnits = $cQmXV.useMemo(()=>getSecondUnits(validHour, validMinute), [
        getSecondUnits,
        validHour,
        validMinute
    ]);
    // >>> Milliseconds
    const validSecond = getEnabled(secondUnits, second);
    const millisecondUnits = $cQmXV.useMemo(()=>getMillisecondUnits(validHour, validMinute, validSecond), [
        getMillisecondUnits,
        validHour,
        validMinute,
        validSecond
    ]);
    const validMillisecond = getEnabled(millisecondUnits, millisecond);
    // Meridiem
    const meridiemUnits = $cQmXV.useMemo(()=>{
        if (!showMeridiem) return [];
        const base = generateConfig.getNow();
        const amDate = generateConfig.setHour(base, 9);
        const pmDate = generateConfig.setHour(base, 15);
        const formatMeridiem = (date, defaultLabel)=>{
            const { cellMeridiemFormat: cellMeridiemFormat } = locale;
            return cellMeridiemFormat ? (0, $56194b7cc1a1787c$export$7c4d25c0c3217d8c)(date, {
                generateConfig: generateConfig,
                locale: locale,
                format: cellMeridiemFormat
            }) : defaultLabel;
        };
        return [
            {
                label: formatMeridiem(amDate, "AM"),
                value: "am",
                disabled: rowHourUnits.every((h)=>h.disabled || !$eabe8ed6f7c5a2d9$var$isAM(h.value))
            },
            {
                label: formatMeridiem(pmDate, "PM"),
                value: "pm",
                disabled: rowHourUnits.every((h)=>h.disabled || $eabe8ed6f7c5a2d9$var$isAM(h.value))
            }
        ];
    }, [
        rowHourUnits,
        showMeridiem,
        generateConfig,
        locale
    ]);
    // ========================= Change =========================
    /**
   * Check if time is validate or will match to validate one
   */ const triggerChange = (nextDate)=>{
        const validateDate = getValidTime(nextDate);
        onSelect(validateDate);
    };
    // ========================= Column =========================
    // Create a template date for the trigger change event
    const triggerDateTmpl = $cQmXV.useMemo(()=>{
        let tmpl = value || pickerValue || generateConfig.getNow();
        const isNotNull = (num)=>num !== null && num !== undefined;
        if (isNotNull(hour)) {
            tmpl = generateConfig.setHour(tmpl, hour);
            tmpl = generateConfig.setMinute(tmpl, minute);
            tmpl = generateConfig.setSecond(tmpl, second);
            tmpl = generateConfig.setMillisecond(tmpl, millisecond);
        } else if (isNotNull(pickerHour)) {
            tmpl = generateConfig.setHour(tmpl, pickerHour);
            tmpl = generateConfig.setMinute(tmpl, pickerMinute);
            tmpl = generateConfig.setSecond(tmpl, pickerSecond);
            tmpl = generateConfig.setMillisecond(tmpl, pickerMillisecond);
        } else if (isNotNull(validHour)) {
            tmpl = generateConfig.setHour(tmpl, validHour);
            tmpl = generateConfig.setMinute(tmpl, validMinute);
            tmpl = generateConfig.setSecond(tmpl, validSecond);
            tmpl = generateConfig.setMillisecond(tmpl, validMillisecond);
        }
        return tmpl;
    }, [
        value,
        pickerValue,
        hour,
        minute,
        second,
        millisecond,
        validHour,
        validMinute,
        validSecond,
        validMillisecond,
        pickerHour,
        pickerMinute,
        pickerSecond,
        pickerMillisecond,
        generateConfig
    ]);
    // ===================== Columns Change =====================
    const fillColumnValue = (val, func)=>{
        if (val === null) return null;
        return generateConfig[func](triggerDateTmpl, val);
    };
    const getNextHourTime = (val)=>fillColumnValue(val, "setHour");
    const getNextMinuteTime = (val)=>fillColumnValue(val, "setMinute");
    const getNextSecondTime = (val)=>fillColumnValue(val, "setSecond");
    const getNextMillisecondTime = (val)=>fillColumnValue(val, "setMillisecond");
    const getMeridiemTime = (val)=>{
        if (val === null) return null;
        if (val === "am" && !$eabe8ed6f7c5a2d9$var$isAM(hour)) return generateConfig.setHour(triggerDateTmpl, hour - 12);
        else if (val === "pm" && $eabe8ed6f7c5a2d9$var$isAM(hour)) return generateConfig.setHour(triggerDateTmpl, hour + 12);
        return triggerDateTmpl;
    };
    const onHourChange = (val)=>{
        triggerChange(getNextHourTime(val));
    };
    const onMinuteChange = (val)=>{
        triggerChange(getNextMinuteTime(val));
    };
    const onSecondChange = (val)=>{
        triggerChange(getNextSecondTime(val));
    };
    const onMillisecondChange = (val)=>{
        triggerChange(getNextMillisecondTime(val));
    };
    const onMeridiemChange = (val)=>{
        triggerChange(getMeridiemTime(val));
    };
    // ====================== Column Hover ======================
    const onHourHover = (val)=>{
        onHover(getNextHourTime(val));
    };
    const onMinuteHover = (val)=>{
        onHover(getNextMinuteTime(val));
    };
    const onSecondHover = (val)=>{
        onHover(getNextSecondTime(val));
    };
    const onMillisecondHover = (val)=>{
        onHover(getNextMillisecondTime(val));
    };
    const onMeridiemHover = (val)=>{
        onHover(getMeridiemTime(val));
    };
    // ========================= Render =========================
    const sharedColumnProps = {
        onDblClick: onCellDblClick,
        changeOnScroll: changeOnScroll
    };
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-content`, classNames.content),
        style: styles.content
    }, showHour && /*#__PURE__*/ $cQmXV.createElement((0, $2b47e56c0c101a27$export$2e2bcd8739ae039), $eabe8ed6f7c5a2d9$var$_extends({
        units: hourUnits,
        value: hour,
        optionalValue: pickerHour,
        type: "hour",
        onChange: onHourChange,
        onHover: onHourHover
    }, sharedColumnProps)), showMinute && /*#__PURE__*/ $cQmXV.createElement((0, $2b47e56c0c101a27$export$2e2bcd8739ae039), $eabe8ed6f7c5a2d9$var$_extends({
        units: minuteUnits,
        value: minute,
        optionalValue: pickerMinute,
        type: "minute",
        onChange: onMinuteChange,
        onHover: onMinuteHover
    }, sharedColumnProps)), showSecond && /*#__PURE__*/ $cQmXV.createElement((0, $2b47e56c0c101a27$export$2e2bcd8739ae039), $eabe8ed6f7c5a2d9$var$_extends({
        units: secondUnits,
        value: second,
        optionalValue: pickerSecond,
        type: "second",
        onChange: onSecondChange,
        onHover: onSecondHover
    }, sharedColumnProps)), showMillisecond && /*#__PURE__*/ $cQmXV.createElement((0, $2b47e56c0c101a27$export$2e2bcd8739ae039), $eabe8ed6f7c5a2d9$var$_extends({
        units: millisecondUnits,
        value: millisecond,
        optionalValue: pickerMillisecond,
        type: "millisecond",
        onChange: onMillisecondChange,
        onHover: onMillisecondHover
    }, sharedColumnProps)), showMeridiem && /*#__PURE__*/ $cQmXV.createElement((0, $2b47e56c0c101a27$export$2e2bcd8739ae039), $eabe8ed6f7c5a2d9$var$_extends({
        units: meridiemUnits,
        value: meridiem,
        type: "meridiem",
        onChange: onMeridiemChange,
        onHover: onMeridiemHover
    }, sharedColumnProps)));
}


function $2386f32f9f34e0d0$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, value: value, locale: locale, generateConfig: generateConfig, showTime: // Format
    showTime } = props;
    const { format: format } = showTime || {};
    const panelPrefixCls = `${prefixCls}-time-panel`;
    // ========================== Base ==========================
    const [info] = (0, $82841072316a6ae1$export$2ae76d51704c9302)(props, "time");
    // ========================= Render =========================
    return /*#__PURE__*/ $cQmXV.createElement((0, $82841072316a6ae1$export$f34532ac99e32150).Provider, {
        value: info
    }, /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(panelPrefixCls)
    }, /*#__PURE__*/ $cQmXV.createElement((0, $f261539dcfbc375e$export$2e2bcd8739ae039), null, value ? (0, $56194b7cc1a1787c$export$7c4d25c0c3217d8c)(value, {
        locale: locale,
        format: format,
        generateConfig: generateConfig
    }) : "\xa0"), /*#__PURE__*/ $cQmXV.createElement((0, $eabe8ed6f7c5a2d9$export$2e2bcd8739ae039), showTime)));
}


function $6c295b6649ad6979$var$_extends() {
    $6c295b6649ad6979$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6c295b6649ad6979$var$_extends.apply(this, arguments);
}
function $6c295b6649ad6979$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, generateConfig: generateConfig, showTime: showTime, onSelect: onSelect, value: value, pickerValue: pickerValue, onHover: onHover } = props;
    const panelPrefixCls = `${prefixCls}-datetime-panel`;
    // =============================== Time ===============================
    const [getValidTime] = (0, $da6b058f0d3ed7a1$export$2e2bcd8739ae039)(generateConfig, showTime);
    // Merge the time info from `value` or `pickerValue`
    const mergeTime = (date)=>{
        if (value) return (0, $56194b7cc1a1787c$export$48199fabfd385f2f)(generateConfig, date, value);
        return (0, $56194b7cc1a1787c$export$48199fabfd385f2f)(generateConfig, date, pickerValue);
    };
    // ============================== Hover ===============================
    const onDateHover = (date)=>{
        onHover?.(date ? mergeTime(date) : date);
    };
    // ============================== Select ==============================
    const onDateSelect = (date)=>{
        // Merge with current time
        const cloneDate = mergeTime(date);
        onSelect(getValidTime(cloneDate, cloneDate));
    };
    // ============================== Render ==============================
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        className: panelPrefixCls
    }, /*#__PURE__*/ $cQmXV.createElement((0, $dce444c7c0ebeb4e$export$2e2bcd8739ae039), $6c295b6649ad6979$var$_extends({}, props, {
        onSelect: onDateSelect,
        onHover: onDateHover
    })), /*#__PURE__*/ $cQmXV.createElement((0, $2386f32f9f34e0d0$export$2e2bcd8739ae039), props));
}



var $cQmXV = parcelRequire("cQmXV");




function $4eea8dca06c70d47$var$_extends() {
    $4eea8dca06c70d47$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4eea8dca06c70d47$var$_extends.apply(this, arguments);
}
function $4eea8dca06c70d47$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, locale: locale, generateConfig: generateConfig, pickerValue: pickerValue, disabledDate: disabledDate, onPickerValueChange: onPickerValueChange } = props;
    const panelPrefixCls = `${prefixCls}-decade-panel`;
    // ========================== Base ==========================
    const [info] = (0, $82841072316a6ae1$export$2ae76d51704c9302)(props, "decade");
    const getStartYear = (date)=>{
        const startYear = Math.floor(generateConfig.getYear(date) / 100) * 100;
        return generateConfig.setYear(date, startYear);
    };
    const getEndYear = (date)=>{
        const startYear = getStartYear(date);
        return generateConfig.addYear(startYear, 99);
    };
    const startYearDate = getStartYear(pickerValue);
    const endYearDate = getEndYear(pickerValue);
    const baseDate = generateConfig.addYear(startYearDate, -10);
    // ========================= Cells ==========================
    const getCellDate = (date, offset)=>{
        return generateConfig.addYear(date, offset * 10);
    };
    const getCellText = (date)=>{
        const cellYearFormat = locale.cellYearFormat;
        const startYearStr = (0, $56194b7cc1a1787c$export$7c4d25c0c3217d8c)(date, {
            locale: locale,
            format: cellYearFormat,
            generateConfig: generateConfig
        });
        const endYearStr = (0, $56194b7cc1a1787c$export$7c4d25c0c3217d8c)(generateConfig.addYear(date, 9), {
            locale: locale,
            format: cellYearFormat,
            generateConfig: generateConfig
        });
        return `${startYearStr}-${endYearStr}`;
    };
    const getCellClassName = (date)=>{
        return {
            [`${prefixCls}-cell-in-view`]: (0, $56194b7cc1a1787c$export$22ab546651b3be18)(generateConfig, date, startYearDate) || (0, $56194b7cc1a1787c$export$22ab546651b3be18)(generateConfig, date, endYearDate) || (0, $56194b7cc1a1787c$export$6dabbcb26357acf4)(generateConfig, startYearDate, endYearDate, date)
        };
    };
    // ======================== Disabled ========================
    const mergedDisabledDate = disabledDate ? (currentDate, disabledInfo)=>{
        // Start
        const baseStartDate = generateConfig.setDate(currentDate, 1);
        const baseStartMonth = generateConfig.setMonth(baseStartDate, 0);
        const baseStartYear = generateConfig.setYear(baseStartMonth, Math.floor(generateConfig.getYear(baseStartMonth) / 10) * 10);
        // End
        const baseEndYear = generateConfig.addYear(baseStartYear, 10);
        const baseEndDate = generateConfig.addDate(baseEndYear, -1);
        return disabledDate(baseStartYear, disabledInfo) && disabledDate(baseEndDate, disabledInfo);
    } : null;
    // ========================= Header =========================
    const yearNode = `${(0, $56194b7cc1a1787c$export$7c4d25c0c3217d8c)(startYearDate, {
        locale: locale,
        format: locale.yearFormat,
        generateConfig: generateConfig
    })}-${(0, $56194b7cc1a1787c$export$7c4d25c0c3217d8c)(endYearDate, {
        locale: locale,
        format: locale.yearFormat,
        generateConfig: generateConfig
    })}`;
    // ========================= Render =========================
    return /*#__PURE__*/ $cQmXV.createElement((0, $82841072316a6ae1$export$f34532ac99e32150).Provider, {
        value: info
    }, /*#__PURE__*/ $cQmXV.createElement("div", {
        className: panelPrefixCls
    }, /*#__PURE__*/ $cQmXV.createElement((0, $f261539dcfbc375e$export$2e2bcd8739ae039), {
        superOffset: (distance)=>generateConfig.addYear(pickerValue, distance * 100),
        onChange: onPickerValueChange,
        getStart: getStartYear,
        getEnd: getEndYear
    }, yearNode), /*#__PURE__*/ $cQmXV.createElement((0, $b82cb4f3d0221c7b$export$2e2bcd8739ae039), $4eea8dca06c70d47$var$_extends({}, props, {
        disabledDate: mergedDisabledDate,
        colNum: 3,
        rowNum: 4,
        baseDate: baseDate,
        getCellDate: getCellDate,
        getCellText: getCellText,
        getCellClassName: getCellClassName
    }))));
}



var $cQmXV = parcelRequire("cQmXV");




function $15d07e96fdb27b4b$var$_extends() {
    $15d07e96fdb27b4b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $15d07e96fdb27b4b$var$_extends.apply(this, arguments);
}
function $15d07e96fdb27b4b$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, locale: locale, generateConfig: generateConfig, pickerValue: pickerValue, disabledDate: disabledDate, onPickerValueChange: onPickerValueChange, onModeChange: onModeChange } = props;
    const panelPrefixCls = `${prefixCls}-month-panel`;
    // ========================== Base ==========================
    const [info] = (0, $82841072316a6ae1$export$2ae76d51704c9302)(props, "month");
    const baseDate = generateConfig.setMonth(pickerValue, 0);
    // ========================= Month ==========================
    const monthsLocale = locale.shortMonths || (generateConfig.locale.getShortMonths ? generateConfig.locale.getShortMonths(locale.locale) : []);
    // ========================= Cells ==========================
    const getCellDate = (date, offset)=>{
        return generateConfig.addMonth(date, offset);
    };
    const getCellText = (date)=>{
        const month = generateConfig.getMonth(date);
        return locale.monthFormat ? (0, $56194b7cc1a1787c$export$7c4d25c0c3217d8c)(date, {
            locale: locale,
            format: locale.monthFormat,
            generateConfig: generateConfig
        }) : monthsLocale[month];
    };
    const getCellClassName = ()=>({
            [`${prefixCls}-cell-in-view`]: true
        });
    // ======================== Disabled ========================
    const mergedDisabledDate = disabledDate ? (currentDate, disabledInfo)=>{
        const startDate = generateConfig.setDate(currentDate, 1);
        const nextMonthStartDate = generateConfig.setMonth(startDate, generateConfig.getMonth(startDate) + 1);
        const endDate = generateConfig.addDate(nextMonthStartDate, -1);
        return disabledDate(startDate, disabledInfo) && disabledDate(endDate, disabledInfo);
    } : null;
    // ========================= Header =========================
    const yearNode = /*#__PURE__*/ $cQmXV.createElement("button", {
        type: "button",
        key: "year",
        "aria-label": locale.yearSelect,
        onClick: ()=>{
            onModeChange("year");
        },
        tabIndex: -1,
        className: `${prefixCls}-year-btn`
    }, (0, $56194b7cc1a1787c$export$7c4d25c0c3217d8c)(pickerValue, {
        locale: locale,
        format: locale.yearFormat,
        generateConfig: generateConfig
    }));
    // ========================= Render =========================
    return /*#__PURE__*/ $cQmXV.createElement((0, $82841072316a6ae1$export$f34532ac99e32150).Provider, {
        value: info
    }, /*#__PURE__*/ $cQmXV.createElement("div", {
        className: panelPrefixCls
    }, /*#__PURE__*/ $cQmXV.createElement((0, $f261539dcfbc375e$export$2e2bcd8739ae039), {
        superOffset: (distance)=>generateConfig.addYear(pickerValue, distance),
        onChange: onPickerValueChange,
        getStart: (date)=>generateConfig.setMonth(date, 0),
        getEnd: (date)=>generateConfig.setMonth(date, 11)
    }, yearNode), /*#__PURE__*/ $cQmXV.createElement((0, $b82cb4f3d0221c7b$export$2e2bcd8739ae039), $15d07e96fdb27b4b$var$_extends({}, props, {
        disabledDate: mergedDisabledDate,
        titleFormat: locale.fieldMonthFormat,
        colNum: 3,
        rowNum: 4,
        baseDate: baseDate,
        getCellDate: getCellDate,
        getCellText: getCellText,
        getCellClassName: getCellClassName
    }))));
}



var $cQmXV = parcelRequire("cQmXV");




function $84fc6742c4f0558c$var$_extends() {
    $84fc6742c4f0558c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $84fc6742c4f0558c$var$_extends.apply(this, arguments);
}
function $84fc6742c4f0558c$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, locale: locale, generateConfig: generateConfig, pickerValue: pickerValue, onPickerValueChange: onPickerValueChange, onModeChange: onModeChange } = props;
    const panelPrefixCls = `${prefixCls}-quarter-panel`;
    // ========================== Base ==========================
    const [info] = (0, $82841072316a6ae1$export$2ae76d51704c9302)(props, "quarter");
    const baseDate = generateConfig.setMonth(pickerValue, 0);
    // ========================= Cells ==========================
    const getCellDate = (date, offset)=>{
        return generateConfig.addMonth(date, offset * 3);
    };
    const getCellText = (date)=>{
        return (0, $56194b7cc1a1787c$export$7c4d25c0c3217d8c)(date, {
            locale: locale,
            format: locale.cellQuarterFormat,
            generateConfig: generateConfig
        });
    };
    const getCellClassName = ()=>({
            [`${prefixCls}-cell-in-view`]: true
        });
    // ========================= Header =========================
    const yearNode = /*#__PURE__*/ $cQmXV.createElement("button", {
        type: "button",
        key: "year",
        "aria-label": locale.yearSelect,
        onClick: ()=>{
            onModeChange("year");
        },
        tabIndex: -1,
        className: `${prefixCls}-year-btn`
    }, (0, $56194b7cc1a1787c$export$7c4d25c0c3217d8c)(pickerValue, {
        locale: locale,
        format: locale.yearFormat,
        generateConfig: generateConfig
    }));
    // ========================= Render =========================
    return /*#__PURE__*/ $cQmXV.createElement((0, $82841072316a6ae1$export$f34532ac99e32150).Provider, {
        value: info
    }, /*#__PURE__*/ $cQmXV.createElement("div", {
        className: panelPrefixCls
    }, /*#__PURE__*/ $cQmXV.createElement((0, $f261539dcfbc375e$export$2e2bcd8739ae039), {
        superOffset: (distance)=>generateConfig.addYear(pickerValue, distance),
        onChange: onPickerValueChange,
        getStart: (date)=>generateConfig.setMonth(date, 0),
        getEnd: (date)=>generateConfig.setMonth(date, 11)
    }, yearNode), /*#__PURE__*/ $cQmXV.createElement((0, $b82cb4f3d0221c7b$export$2e2bcd8739ae039), $84fc6742c4f0558c$var$_extends({}, props, {
        titleFormat: locale.fieldQuarterFormat,
        colNum: 4,
        rowNum: 1,
        baseDate: baseDate,
        getCellDate: getCellDate,
        getCellText: getCellText,
        getCellClassName: getCellClassName
    }))));
}





var $cQmXV = parcelRequire("cQmXV");


function $0d8afcf8f7e3d46c$var$_extends() {
    $0d8afcf8f7e3d46c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0d8afcf8f7e3d46c$var$_extends.apply(this, arguments);
}
function $0d8afcf8f7e3d46c$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, generateConfig: generateConfig, locale: locale, value: value, hoverValue: hoverValue, hoverRangeValue: hoverRangeValue } = props;
    // =============================== Row ================================
    const localeName = locale.locale;
    const rowPrefixCls = `${prefixCls}-week-panel-row`;
    const rowClassName = (currentDate)=>{
        const rangeCls = {};
        if (hoverRangeValue) {
            const [rangeStart, rangeEnd] = hoverRangeValue;
            const isRangeStart = (0, $56194b7cc1a1787c$export$6ea683876c36b8d2)(generateConfig, localeName, rangeStart, currentDate);
            const isRangeEnd = (0, $56194b7cc1a1787c$export$6ea683876c36b8d2)(generateConfig, localeName, rangeEnd, currentDate);
            rangeCls[`${rowPrefixCls}-range-start`] = isRangeStart;
            rangeCls[`${rowPrefixCls}-range-end`] = isRangeEnd;
            rangeCls[`${rowPrefixCls}-range-hover`] = !isRangeStart && !isRangeEnd && (0, $56194b7cc1a1787c$export$6dabbcb26357acf4)(generateConfig, rangeStart, rangeEnd, currentDate);
        }
        if (hoverValue) rangeCls[`${rowPrefixCls}-hover`] = hoverValue.some((date)=>(0, $56194b7cc1a1787c$export$6ea683876c36b8d2)(generateConfig, localeName, currentDate, date));
        return (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(rowPrefixCls, {
            [`${rowPrefixCls}-selected`]: !hoverRangeValue && (0, $56194b7cc1a1787c$export$6ea683876c36b8d2)(generateConfig, localeName, value, currentDate)
        }, // Patch for hover range
        rangeCls);
    };
    // ============================== Render ==============================
    return /*#__PURE__*/ $cQmXV.createElement((0, $dce444c7c0ebeb4e$export$2e2bcd8739ae039), $0d8afcf8f7e3d46c$var$_extends({}, props, {
        mode: "week",
        panelName: "week",
        rowClassName: rowClassName
    }));
}



var $cQmXV = parcelRequire("cQmXV");




function $8e855b325be6ffe9$var$_extends() {
    $8e855b325be6ffe9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8e855b325be6ffe9$var$_extends.apply(this, arguments);
}
function $8e855b325be6ffe9$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, locale: locale, generateConfig: generateConfig, pickerValue: pickerValue, disabledDate: disabledDate, onPickerValueChange: onPickerValueChange, onModeChange: onModeChange } = props;
    const panelPrefixCls = `${prefixCls}-year-panel`;
    // ========================== Base ==========================
    const [info] = (0, $82841072316a6ae1$export$2ae76d51704c9302)(props, "year");
    const getStartYear = (date)=>{
        const startYear = Math.floor(generateConfig.getYear(date) / 10) * 10;
        return generateConfig.setYear(date, startYear);
    };
    const getEndYear = (date)=>{
        const startYear = getStartYear(date);
        return generateConfig.addYear(startYear, 9);
    };
    const startYearDate = getStartYear(pickerValue);
    const endYearDate = getEndYear(pickerValue);
    const baseDate = generateConfig.addYear(startYearDate, -1);
    // ========================= Cells ==========================
    const getCellDate = (date, offset)=>{
        return generateConfig.addYear(date, offset);
    };
    const getCellText = (date)=>{
        return (0, $56194b7cc1a1787c$export$7c4d25c0c3217d8c)(date, {
            locale: locale,
            format: locale.cellYearFormat,
            generateConfig: generateConfig
        });
    };
    const getCellClassName = (date)=>{
        return {
            [`${prefixCls}-cell-in-view`]: (0, $56194b7cc1a1787c$export$5841f9eb9773f25f)(generateConfig, date, startYearDate) || (0, $56194b7cc1a1787c$export$5841f9eb9773f25f)(generateConfig, date, endYearDate) || (0, $56194b7cc1a1787c$export$6dabbcb26357acf4)(generateConfig, startYearDate, endYearDate, date)
        };
    };
    // ======================== Disabled ========================
    const mergedDisabledDate = disabledDate ? (currentDate, disabledInfo)=>{
        // Start
        const startMonth = generateConfig.setMonth(currentDate, 0);
        const startDate = generateConfig.setDate(startMonth, 1);
        // End
        const endMonth = generateConfig.addYear(startDate, 1);
        const endDate = generateConfig.addDate(endMonth, -1);
        return disabledDate(startDate, disabledInfo) && disabledDate(endDate, disabledInfo);
    } : null;
    // ========================= Header =========================
    const yearNode = /*#__PURE__*/ $cQmXV.createElement("button", {
        type: "button",
        key: "decade",
        "aria-label": locale.decadeSelect,
        onClick: ()=>{
            onModeChange("decade");
        },
        tabIndex: -1,
        className: `${prefixCls}-decade-btn`
    }, (0, $56194b7cc1a1787c$export$7c4d25c0c3217d8c)(startYearDate, {
        locale: locale,
        format: locale.yearFormat,
        generateConfig: generateConfig
    }), "-", (0, $56194b7cc1a1787c$export$7c4d25c0c3217d8c)(endYearDate, {
        locale: locale,
        format: locale.yearFormat,
        generateConfig: generateConfig
    }));
    // ========================= Render =========================
    return /*#__PURE__*/ $cQmXV.createElement((0, $82841072316a6ae1$export$f34532ac99e32150).Provider, {
        value: info
    }, /*#__PURE__*/ $cQmXV.createElement("div", {
        className: panelPrefixCls
    }, /*#__PURE__*/ $cQmXV.createElement((0, $f261539dcfbc375e$export$2e2bcd8739ae039), {
        superOffset: (distance)=>generateConfig.addYear(pickerValue, distance * 10),
        onChange: onPickerValueChange,
        getStart: getStartYear,
        getEnd: getEndYear
    }, yearNode), /*#__PURE__*/ $cQmXV.createElement((0, $b82cb4f3d0221c7b$export$2e2bcd8739ae039), $8e855b325be6ffe9$var$_extends({}, props, {
        disabledDate: mergedDisabledDate,
        titleFormat: locale.fieldYearFormat,
        colNum: 3,
        rowNum: 4,
        baseDate: baseDate,
        getCellDate: getCellDate,
        getCellText: getCellText,
        getCellClassName: getCellClassName
    }))));
}


function $14b1cd9c5ed0d63c$var$_extends() {
    $14b1cd9c5ed0d63c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $14b1cd9c5ed0d63c$var$_extends.apply(this, arguments);
}
const $14b1cd9c5ed0d63c$var$DefaultComponents = {
    date: (0, $dce444c7c0ebeb4e$export$2e2bcd8739ae039),
    datetime: (0, $6c295b6649ad6979$export$2e2bcd8739ae039),
    week: (0, $0d8afcf8f7e3d46c$export$2e2bcd8739ae039),
    month: (0, $15d07e96fdb27b4b$export$2e2bcd8739ae039),
    quarter: (0, $84fc6742c4f0558c$export$2e2bcd8739ae039),
    year: (0, $8e855b325be6ffe9$export$2e2bcd8739ae039),
    decade: (0, $4eea8dca06c70d47$export$2e2bcd8739ae039),
    time: (0, $2386f32f9f34e0d0$export$2e2bcd8739ae039)
};
function $14b1cd9c5ed0d63c$var$PickerPanel(props, ref) {
    const { classNames: panelClassNames, styles: panelStyles, locale: locale, generateConfig: generateConfig, direction: direction, prefixCls: // Style
    prefixCls, tabIndex: tabIndex = 0, multiple: // Value
    multiple, defaultValue: defaultValue, value: value, onChange: onChange, onSelect: onSelect, defaultPickerValue: // Picker control
    defaultPickerValue, pickerValue: pickerValue, onPickerValueChange: onPickerValueChange, mode: // Mode
    mode, onPanelChange: onPanelChange, picker: picker = "date", showTime: showTime, hoverValue: // Hover
    hoverValue, hoverRangeValue: hoverRangeValue, cellRender: // Cell
    cellRender, dateRender: dateRender, monthCellRender: monthCellRender, components: // Components
    components = {}, hideHeader: hideHeader } = props;
    // ======================== Context ========================
    const { prefixCls: contextPrefixCls, classNames: pickerClassNames, styles: pickerStyles } = $cQmXV.useContext((0, $8ffb82fb472fb634$export$2e2bcd8739ae039)) || {};
    // ======================== prefixCls ========================
    const mergedPrefixCls = contextPrefixCls || prefixCls || "rc-picker";
    // ========================== Refs ==========================
    const rootRef = $cQmXV.useRef(null);
    $cQmXV.useImperativeHandle(ref, ()=>({
            nativeElement: rootRef.current
        }));
    // ========================== Time ==========================
    // Auto `format` need to check `showTime.showXXX` first.
    // And then merge the `locale` into `mergedShowTime`.
    const [timeProps, localeTimeProps, showTimeFormat, propFormat] = (0, $e2836a545f48c154$export$6c7e3619a08d795a)(props);
    // ========================= Locale =========================
    const filledLocale = (0, $3e4d9c579ec94f76$export$2e2bcd8739ae039)(locale, localeTimeProps);
    // ========================= Picker =========================
    const internalPicker = picker === "date" && showTime ? "datetime" : picker;
    // ======================== ShowTime ========================
    const mergedShowTime = $cQmXV.useMemo(()=>(0, $e2836a545f48c154$export$901cd53a4926b425)(internalPicker, showTimeFormat, propFormat, timeProps, filledLocale), [
        internalPicker,
        showTimeFormat,
        propFormat,
        timeProps,
        filledLocale
    ]);
    // ========================== Now ===========================
    const now = generateConfig.getNow();
    // ========================== Mode ==========================
    const [mergedMode, setMergedMode] = (0, $a51866d781137e08$export$2e2bcd8739ae039)(picker || "date", mode);
    const internalMode = mergedMode === "date" && mergedShowTime ? "datetime" : mergedMode;
    // ========================= Toggle =========================
    const toggleDates = (0, $e6951cd73102e980$export$2e2bcd8739ae039)(generateConfig, locale, internalPicker);
    // ========================= Value ==========================
    // >>> Real value
    // Interactive with `onChange` event which only trigger when the `mode` is `picker`
    const [innerValue, setMergedValue] = (0, $a51866d781137e08$export$2e2bcd8739ae039)(defaultValue, value);
    const mergedValue = $cQmXV.useMemo(()=>{
        // Clean up `[null]`
        const values = (0, $03e7a71a94f7692c$export$45b10814cc054894)(innerValue).filter((val)=>val);
        return multiple ? values : values.slice(0, 1);
    }, [
        innerValue,
        multiple
    ]);
    // Sync value and only trigger onChange event when changed
    const triggerChange = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((nextValue)=>{
        setMergedValue(nextValue);
        if (onChange && (nextValue === null || mergedValue.length !== nextValue.length || mergedValue.some((ori, index)=>!(0, $56194b7cc1a1787c$export$18ac18efd9e98d41)(generateConfig, locale, ori, nextValue[index], internalPicker)))) onChange?.(multiple ? nextValue : nextValue[0]);
    });
    // >>> CalendarValue
    // CalendarValue is a temp value for user operation
    // which will only trigger `onCalendarChange` but not `onChange`
    const onInternalSelect = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((newDate)=>{
        onSelect?.(newDate);
        if (mergedMode === picker) {
            const nextValues = multiple ? toggleDates(mergedValue, newDate) : [
                newDate
            ];
            triggerChange(nextValues);
        }
    });
    // >>> PickerValue
    // PickerValue is used to control the current displaying panel
    const [mergedPickerValue, setInternalPickerValue] = (0, $a51866d781137e08$export$2e2bcd8739ae039)(defaultPickerValue || mergedValue[0] || now, pickerValue);
    $cQmXV.useEffect(()=>{
        if (mergedValue[0] && !pickerValue) setInternalPickerValue(mergedValue[0]);
    }, [
        mergedValue[0]
    ]);
    // Both trigger when manually pickerValue or mode change
    const triggerPanelChange = (viewDate, nextMode)=>{
        onPanelChange?.(viewDate || pickerValue, nextMode || mergedMode);
    };
    const setPickerValue = (nextPickerValue, triggerPanelEvent = false)=>{
        setInternalPickerValue(nextPickerValue);
        onPickerValueChange?.(nextPickerValue);
        if (triggerPanelEvent) triggerPanelChange(nextPickerValue);
    };
    const triggerModeChange = (nextMode, viewDate)=>{
        setMergedMode(nextMode);
        if (viewDate) setPickerValue(viewDate);
        triggerPanelChange(viewDate, nextMode);
    };
    const onPanelValueSelect = (nextValue)=>{
        onInternalSelect(nextValue);
        setPickerValue(nextValue);
        // Update mode if needed
        if (mergedMode !== picker) {
            const decadeYearQueue = [
                "decade",
                "year"
            ];
            const decadeYearMonthQueue = [
                ...decadeYearQueue,
                "month"
            ];
            const pickerQueue = {
                quarter: [
                    ...decadeYearQueue,
                    "quarter"
                ],
                week: [
                    ...decadeYearMonthQueue,
                    "week"
                ],
                date: [
                    ...decadeYearMonthQueue,
                    "date"
                ]
            };
            const queue = pickerQueue[picker] || decadeYearMonthQueue;
            const index = queue.indexOf(mergedMode);
            const nextMode = queue[index + 1];
            if (nextMode) triggerModeChange(nextMode, nextValue);
        }
    };
    // ======================= Hover Date =======================
    const hoverRangeDate = $cQmXV.useMemo(()=>{
        let start;
        let end;
        if (Array.isArray(hoverRangeValue)) [start, end] = hoverRangeValue;
        else start = hoverRangeValue;
        // Return for not exist
        if (!start && !end) return null;
        // Fill if has empty
        start = start || end;
        end = end || start;
        return generateConfig.isAfter(start, end) ? [
            end,
            start
        ] : [
            start,
            end
        ];
    }, [
        hoverRangeValue,
        generateConfig
    ]);
    // ======================= Components =======================
    // >>> cellRender
    const onInternalCellRender = (0, $86c2958c1a46dbcf$export$2e2bcd8739ae039)(cellRender, dateRender, monthCellRender);
    // ======================= Components =======================
    const PanelComponent = components[internalMode] || $14b1cd9c5ed0d63c$var$DefaultComponents[internalMode] || (0, $dce444c7c0ebeb4e$export$2e2bcd8739ae039);
    // ======================== Context =========================
    const sharedPanelContext = $cQmXV.useMemo(()=>({
            classNames: pickerClassNames?.popup ?? panelClassNames ?? {},
            styles: pickerStyles?.popup ?? panelStyles ?? {}
        }), [
        pickerClassNames,
        panelClassNames,
        pickerStyles,
        panelStyles
    ]);
    const parentHackContext = $cQmXV.useContext((0, $82841072316a6ae1$export$c3f9070e5d88313b));
    const pickerPanelContext = $cQmXV.useMemo(()=>({
            ...parentHackContext,
            hideHeader: hideHeader
        }), [
        parentHackContext,
        hideHeader
    ]);
    var val;
    // ========================= Render =========================
    const panelCls = `${mergedPrefixCls}-panel`;
    const panelProps = (0, $03e7a71a94f7692c$export$1b696fb20abaa06c)(props, [
        // Week
        "showWeek",
        // Icons
        "prevIcon",
        "nextIcon",
        "superPrevIcon",
        "superNextIcon",
        // Disabled
        "disabledDate",
        "minDate",
        "maxDate",
        // Hover
        "onHover"
    ]);
    return /*#__PURE__*/ $cQmXV.createElement((0, $82841072316a6ae1$export$d1173f47489c79e4).Provider, {
        value: sharedPanelContext
    }, /*#__PURE__*/ $cQmXV.createElement((0, $82841072316a6ae1$export$c3f9070e5d88313b).Provider, {
        value: pickerPanelContext
    }, /*#__PURE__*/ $cQmXV.createElement("div", {
        ref: rootRef,
        tabIndex: tabIndex,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(panelCls, {
            [`${panelCls}-rtl`]: direction === "rtl"
        })
    }, /*#__PURE__*/ $cQmXV.createElement(PanelComponent, $14b1cd9c5ed0d63c$var$_extends({}, panelProps, {
        // Time
        showTime: mergedShowTime,
        prefixCls: mergedPrefixCls,
        locale: filledLocale,
        generateConfig: generateConfig,
        onModeChange: triggerModeChange,
        pickerValue: mergedPickerValue,
        onPickerValueChange: (nextPickerValue)=>{
            setPickerValue(nextPickerValue, true);
        },
        value: mergedValue[0],
        onSelect: onPanelValueSelect,
        values: mergedValue,
        cellRender: onInternalCellRender,
        hoverRangeValue: hoverRangeDate,
        hoverValue: hoverValue
    })))));
}
const $14b1cd9c5ed0d63c$var$RefPanelPicker = /*#__PURE__*/ $cQmXV.memo(/*#__PURE__*/ $cQmXV.forwardRef($14b1cd9c5ed0d63c$var$PickerPanel));
var // Make support generic
$14b1cd9c5ed0d63c$export$2e2bcd8739ae039 = $14b1cd9c5ed0d63c$var$RefPanelPicker;





function $c1a461d8bc2d259a$var$_extends() {
    $c1a461d8bc2d259a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c1a461d8bc2d259a$var$_extends.apply(this, arguments);
}
function $c1a461d8bc2d259a$export$2e2bcd8739ae039(props) {
    const { picker: picker, multiplePanel: multiplePanel, pickerValue: pickerValue, onPickerValueChange: onPickerValueChange, needConfirm: needConfirm, onSubmit: onSubmit, range: range, hoverValue: hoverValue } = props;
    const { prefixCls: prefixCls, generateConfig: generateConfig } = $cQmXV.useContext((0, $8ffb82fb472fb634$export$2e2bcd8739ae039));
    // ======================== Offset ========================
    const internalOffsetDate = $cQmXV.useCallback((date, offset)=>{
        return (0, $58210ec7ad711cce$export$b0e4aff419ae4233)(generateConfig, picker, date, offset);
    }, [
        generateConfig,
        picker
    ]);
    const nextPickerValue = $cQmXV.useMemo(()=>internalOffsetDate(pickerValue, 1), [
        pickerValue,
        internalOffsetDate
    ]);
    // Outside
    const onSecondPickerValueChange = (nextDate)=>{
        onPickerValueChange(internalOffsetDate(nextDate, -1));
    };
    // ======================= Context ========================
    const sharedContext = {
        onCellDblClick: ()=>{
            if (needConfirm) onSubmit();
        }
    };
    const hideHeader = picker === "time";
    // ======================== Props =========================
    const pickerProps = {
        ...props,
        hoverValue: null,
        hoverRangeValue: null,
        hideHeader: hideHeader
    };
    if (range) pickerProps.hoverRangeValue = hoverValue;
    else pickerProps.hoverValue = hoverValue;
    // ======================== Render ========================
    // Multiple
    if (multiplePanel) return /*#__PURE__*/ $cQmXV.createElement("div", {
        className: `${prefixCls}-panels`
    }, /*#__PURE__*/ $cQmXV.createElement((0, $82841072316a6ae1$export$c3f9070e5d88313b).Provider, {
        value: {
            ...sharedContext,
            hideNext: true
        }
    }, /*#__PURE__*/ $cQmXV.createElement((0, $14b1cd9c5ed0d63c$export$2e2bcd8739ae039), pickerProps)), /*#__PURE__*/ $cQmXV.createElement((0, $82841072316a6ae1$export$c3f9070e5d88313b).Provider, {
        value: {
            ...sharedContext,
            hidePrev: true
        }
    }, /*#__PURE__*/ $cQmXV.createElement((0, $14b1cd9c5ed0d63c$export$2e2bcd8739ae039), $c1a461d8bc2d259a$var$_extends({}, pickerProps, {
        pickerValue: nextPickerValue,
        onPickerValueChange: onSecondPickerValueChange
    }))));
    // Single
    return /*#__PURE__*/ $cQmXV.createElement((0, $82841072316a6ae1$export$c3f9070e5d88313b).Provider, {
        value: {
            ...sharedContext
        }
    }, /*#__PURE__*/ $cQmXV.createElement((0, $14b1cd9c5ed0d63c$export$2e2bcd8739ae039), pickerProps));
}



var $cQmXV = parcelRequire("cQmXV");
function $ac9c6185379e80d6$var$executeValue(value) {
    return typeof value === "function" ? value() : value;
}
function $ac9c6185379e80d6$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, presets: presets, onClick: onClick, onHover: onHover } = props;
    if (!presets.length) return null;
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        className: `${prefixCls}-presets`
    }, /*#__PURE__*/ $cQmXV.createElement("ul", null, presets.map(({ label: label, value: value }, index)=>/*#__PURE__*/ $cQmXV.createElement("li", {
            key: index,
            onClick: ()=>{
                onClick($ac9c6185379e80d6$var$executeValue(value));
            },
            onMouseEnter: ()=>{
                onHover($ac9c6185379e80d6$var$executeValue(value));
            },
            onMouseLeave: ()=>{
                onHover(null);
            }
        }, label))));
}


function $bee4a9c24fa7de8c$var$_extends() {
    $bee4a9c24fa7de8c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bee4a9c24fa7de8c$var$_extends.apply(this, arguments);
}
function $bee4a9c24fa7de8c$export$2e2bcd8739ae039(props) {
    const { containerRef: containerRef, panelRender: panelRender, internalMode: internalMode, picker: picker, showNow: showNow, range: // Range
    range, multiple: multiple, activeInfo: activeInfo = [
        0,
        0,
        0
    ], presets: // Presets
    presets, onPresetHover: onPresetHover, onPresetSubmit: onPresetSubmit, onFocus: // Focus
    onFocus, onBlur: onBlur, onPanelMouseDown: onPanelMouseDown, direction: // Direction
    direction, value: // Change
    value, onSelect: onSelect, isInvalid: isInvalid, defaultOpenValue: defaultOpenValue, onOk: onOk, onSubmit: onSubmit, classNames: classNames, styles: styles } = props;
    const { prefixCls: prefixCls } = $cQmXV.useContext((0, $8ffb82fb472fb634$export$2e2bcd8739ae039));
    const panelPrefixCls = `${prefixCls}-panel`;
    const rtl = direction === "rtl";
    // ========================= Refs =========================
    const arrowRef = $cQmXV.useRef(null);
    const wrapperRef = $cQmXV.useRef(null);
    // ======================== Offset ========================
    const [containerWidth, setContainerWidth] = $cQmXV.useState(0);
    const [containerOffset, setContainerOffset] = $cQmXV.useState(0);
    const [arrowOffset, setArrowOffset] = $cQmXV.useState(0);
    const onResize = (info)=>{
        if (info.width) setContainerWidth(info.width);
    };
    const [activeInputLeft, activeInputRight, selectorWidth] = activeInfo;
    const [retryTimes, setRetryTimes] = $cQmXV.useState(0);
    $cQmXV.useEffect(()=>{
        setRetryTimes(10);
    }, [
        activeInputLeft
    ]);
    $cQmXV.useEffect(()=>{
        // `activeOffset` is always align with the active input element
        // So we need only check container contains the `activeOffset`
        if (range && wrapperRef.current) {
            // Offset in case container has border radius
            const arrowWidth = arrowRef.current?.offsetWidth || 0;
            // Arrow Offset
            const wrapperRect = wrapperRef.current.getBoundingClientRect();
            if (!wrapperRect.height || wrapperRect.right < 0) {
                setRetryTimes((times)=>Math.max(0, times - 1));
                return;
            }
            const nextArrowOffset = (rtl ? activeInputRight - arrowWidth : activeInputLeft) - wrapperRect.left;
            setArrowOffset(nextArrowOffset);
            // Container Offset
            if (containerWidth && containerWidth < selectorWidth) {
                const offset = rtl ? wrapperRect.right - (activeInputRight - arrowWidth + containerWidth) : activeInputLeft + arrowWidth - wrapperRect.left - containerWidth;
                const safeOffset = Math.max(0, offset);
                setContainerOffset(safeOffset);
            } else setContainerOffset(0);
        }
    }, [
        retryTimes,
        rtl,
        containerWidth,
        activeInputLeft,
        activeInputRight,
        selectorWidth,
        range
    ]);
    // ======================== Custom ========================
    function filterEmpty(list) {
        return list.filter((item)=>item);
    }
    const valueList = $cQmXV.useMemo(()=>filterEmpty((0, $03e7a71a94f7692c$export$45b10814cc054894)(value)), [
        value
    ]);
    const isTimePickerEmptyValue = picker === "time" && !valueList.length;
    const footerSubmitValue = $cQmXV.useMemo(()=>{
        if (isTimePickerEmptyValue) return filterEmpty([
            defaultOpenValue
        ]);
        return valueList;
    }, [
        isTimePickerEmptyValue,
        valueList,
        defaultOpenValue
    ]);
    const popupPanelValue = isTimePickerEmptyValue ? defaultOpenValue : valueList;
    const disableSubmit = $cQmXV.useMemo(()=>{
        // Empty is invalid
        if (!footerSubmitValue.length) return true;
        return footerSubmitValue.some((val)=>isInvalid(val));
    }, [
        footerSubmitValue,
        isInvalid
    ]);
    const onFooterSubmit = ()=>{
        // For TimePicker, we will additional trigger the value update
        if (isTimePickerEmptyValue) onSelect(defaultOpenValue);
        onOk();
        onSubmit();
    };
    let mergedNodes = /*#__PURE__*/ $cQmXV.createElement("div", {
        className: `${prefixCls}-panel-layout`
    }, /*#__PURE__*/ $cQmXV.createElement((0, $ac9c6185379e80d6$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        presets: presets,
        onClick: onPresetSubmit,
        onHover: onPresetHover
    }), /*#__PURE__*/ $cQmXV.createElement("div", null, /*#__PURE__*/ $cQmXV.createElement((0, $c1a461d8bc2d259a$export$2e2bcd8739ae039), $bee4a9c24fa7de8c$var$_extends({}, props, {
        value: popupPanelValue
    })), /*#__PURE__*/ $cQmXV.createElement((0, $7b12b11ae04cc075$export$2e2bcd8739ae039), $bee4a9c24fa7de8c$var$_extends({}, props, {
        showNow: multiple ? false : showNow,
        invalid: disableSubmit,
        onSubmit: onFooterSubmit
    }))));
    if (panelRender) mergedNodes = panelRender(mergedNodes);
    // ======================== Render ========================
    const containerPrefixCls = `${panelPrefixCls}-container`;
    const marginLeft = "marginLeft";
    const marginRight = "marginRight";
    // Container
    let renderNode = /*#__PURE__*/ $cQmXV.createElement("div", {
        ref: containerRef,
        onMouseDown: onPanelMouseDown,
        tabIndex: -1,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(containerPrefixCls, // Used for Today Button style, safe to remove if no need
        `${prefixCls}-${internalMode}-panel-container`, classNames?.popup?.container),
        style: {
            [rtl ? marginRight : marginLeft]: containerOffset,
            [rtl ? marginLeft : marginRight]: "auto",
            ...styles?.popup?.container
        },
        onFocus: onFocus,
        onBlur: onBlur
    }, mergedNodes);
    if (range) renderNode = /*#__PURE__*/ $cQmXV.createElement("div", {
        onMouseDown: onPanelMouseDown,
        ref: wrapperRef,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-range-wrapper`, `${prefixCls}-${picker}-range-wrapper`)
    }, /*#__PURE__*/ $cQmXV.createElement("div", {
        ref: arrowRef,
        className: `${prefixCls}-range-arrow`,
        style: {
            left: arrowOffset
        }
    }), /*#__PURE__*/ $cQmXV.createElement((0, $1d6306c05e604045$export$2e2bcd8739ae039), {
        onResize: onResize
    }, renderNode));
    return renderNode;
}






var $cQmXV = parcelRequire("cQmXV");



var $cQmXV = parcelRequire("cQmXV");

function $9c944ba79672d18a$export$2e2bcd8739ae039(props, /** Used for SinglePicker */ postProps) {
    const { format: format, maskFormat: maskFormat, generateConfig: generateConfig, locale: locale, preserveInvalidOnBlur: preserveInvalidOnBlur, inputReadOnly: inputReadOnly, required: required, "aria-required": ariaRequired, onSubmit: onSubmit, onFocus: onFocus, onBlur: onBlur, onInputChange: onInputChange, onInvalid: onInvalid, open: open, onOpenChange: onOpenChange, onKeyDown: onKeyDown, onChange: onChange, activeHelp: activeHelp, name: name, autoComplete: autoComplete, id: id, value: value, invalid: invalid, placeholder: placeholder, disabled: disabled, activeIndex: activeIndex, allHelp: allHelp, picker: picker } = props;
    // ======================== Parser ========================
    const parseDate = (str, formatStr)=>{
        const parsed = generateConfig.locale.parse(locale.locale, str, [
            formatStr
        ]);
        return parsed && generateConfig.isValidate(parsed) ? parsed : null;
    };
    // ========================= Text =========================
    const firstFormat = format[0];
    const getText = $cQmXV.useCallback((date)=>(0, $56194b7cc1a1787c$export$7c4d25c0c3217d8c)(date, {
            locale: locale,
            format: firstFormat,
            generateConfig: generateConfig
        }), [
        locale,
        generateConfig,
        firstFormat
    ]);
    const valueTexts = $cQmXV.useMemo(()=>value.map(getText), [
        value,
        getText
    ]);
    // ========================= Size =========================
    const size = $cQmXV.useMemo(()=>{
        const defaultSize = picker === "time" ? 8 : 10;
        const length = typeof firstFormat === "function" ? firstFormat(generateConfig.getNow()).length : firstFormat.length;
        return Math.max(defaultSize, length) + 2;
    }, [
        firstFormat,
        picker,
        generateConfig
    ]);
    // ======================= Validate =======================
    const validateFormat = (text)=>{
        for(let i = 0; i < format.length; i += 1){
            const singleFormat = format[i];
            // Only support string type
            if (typeof singleFormat === "string") {
                const parsed = parseDate(text, singleFormat);
                if (parsed) return parsed;
            }
        }
        return false;
    };
    // ======================== Input =========================
    const getInputProps = (index)=>{
        function getProp(propValue) {
            return index !== undefined ? propValue[index] : propValue;
        }
        const pickedAttrs = (0, $4b5c733d1d7bb306$export$2e2bcd8739ae039)(props, {
            aria: true,
            data: true
        });
        const inputProps = {
            ...pickedAttrs,
            // ============== Shared ==============
            format: maskFormat,
            validateFormat: (text)=>!!validateFormat(text),
            preserveInvalidOnBlur: preserveInvalidOnBlur,
            readOnly: inputReadOnly,
            required: required,
            "aria-required": ariaRequired,
            name: name,
            autoComplete: autoComplete,
            size: size,
            // ============= By Index =============
            id: getProp(id),
            value: getProp(valueTexts) || "",
            invalid: getProp(invalid),
            placeholder: getProp(placeholder),
            active: activeIndex === index,
            helped: allHelp || activeHelp && activeIndex === index,
            disabled: getProp(disabled),
            onFocus: (event)=>{
                onFocus(event, index);
            },
            onBlur: (event)=>{
                // Blur do not trigger close
                // Since it may focus to the popup panel
                onBlur(event, index);
            },
            onSubmit: onSubmit,
            // Get validate text value
            onChange: (text)=>{
                onInputChange();
                const parsed = validateFormat(text);
                if (parsed) {
                    onInvalid(false, index);
                    onChange(parsed, index);
                    return;
                }
                // Tell outer that the value typed is invalid.
                // If text is empty, it means valid.
                onInvalid(!!text, index);
            },
            onHelp: ()=>{
                onOpenChange(true, {
                    index: index
                });
            },
            onKeyDown: (event)=>{
                let prevented = false;
                onKeyDown?.(event, ()=>{
                    if ("production" !== "production") (0, $26d7cf6379fe7659$export$2e2bcd8739ae039)(false, "`preventDefault` callback is deprecated. Please call `event.preventDefault` directly.");
                    prevented = true;
                });
                if (!event.defaultPrevented && !prevented) switch(event.key){
                    case "Escape":
                        onOpenChange(false, {
                            index: index
                        });
                        break;
                    case "Enter":
                        if (!open) onOpenChange(true);
                        break;
                }
            },
            // ============ Post Props ============
            ...postProps?.({
                valueTexts: valueTexts
            })
        };
        // ============== Clean Up ==============
        Object.keys(inputProps).forEach((key)=>{
            if (inputProps[key] === undefined) delete inputProps[key];
        });
        return inputProps;
    };
    return [
        getInputProps,
        getText
    ];
}



var $cQmXV = parcelRequire("cQmXV");

const $aa9e86834dc06b68$var$propNames = [
    "onMouseEnter",
    "onMouseLeave"
];
function $aa9e86834dc06b68$export$2e2bcd8739ae039(props) {
    return $cQmXV.useMemo(()=>(0, $03e7a71a94f7692c$export$1b696fb20abaa06c)(props, $aa9e86834dc06b68$var$propNames), [
        props
    ]);
}



var $cQmXV = parcelRequire("cQmXV");


function $b74f54f68bbecac1$var$_extends() {
    $b74f54f68bbecac1$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b74f54f68bbecac1$var$_extends.apply(this, arguments);
}
function $b74f54f68bbecac1$export$2e2bcd8739ae039({ icon: icon, ...restProps }) {
    const { prefixCls: prefixCls, classNames: classNames, styles: styles } = $cQmXV.useContext((0, $8ffb82fb472fb634$export$2e2bcd8739ae039));
    return icon ? /*#__PURE__*/ $cQmXV.createElement("span", $b74f54f68bbecac1$var$_extends({
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-suffix`, classNames.suffix),
        style: styles.suffix
    }, restProps), icon) : null;
}



var $cQmXV = parcelRequire("cQmXV");


function $28ee6e2cf7395fb2$var$_extends() {
    $28ee6e2cf7395fb2$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $28ee6e2cf7395fb2$var$_extends.apply(this, arguments);
}
function $28ee6e2cf7395fb2$export$2e2bcd8739ae039({ icon: icon, onClear: onClear, ...restProps }) {
    const { prefixCls: prefixCls, classNames: classNames, styles: styles, locale: locale } = $cQmXV.useContext((0, $8ffb82fb472fb634$export$2e2bcd8739ae039));
    return /*#__PURE__*/ $cQmXV.createElement("button", $28ee6e2cf7395fb2$var$_extends({}, restProps, {
        type: "button",
        "aria-label": locale.clear,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-clear`, classNames.suffix),
        style: styles.suffix,
        onMouseDown: (e)=>{
            e.preventDefault();
        },
        onClick: (e)=>{
            e.stopPropagation();
            onClear();
        }
    }), icon);
}





var $cQmXV = parcelRequire("cQmXV");




var $cQmXV = parcelRequire("cQmXV");
function $445aef65e82c78c3$export$2e2bcd8739ae039(condition, callback, delayFrames = 1) {
    const callbackRef = $cQmXV.useRef(callback);
    callbackRef.current = callback;
    (0, $7673d874dab69d07$export$9283e56bae2f7b0f)(()=>{
        if (condition) callbackRef.current(condition);
        else {
            const id = (0, $905c53b807de704e$export$2e2bcd8739ae039)(()=>{
                callbackRef.current(condition);
            }, delayFrames);
            return ()=>{
                (0, $905c53b807de704e$export$2e2bcd8739ae039).cancel(id);
            };
        }
    }, [
        condition
    ]);
}



const $9f1d173c35ef8a1e$var$FORMAT_KEYS = [
    "YYYY",
    "MM",
    "DD",
    "HH",
    "mm",
    "ss",
    "SSS"
];
// Use Chinese character to avoid conflict with the mask format
const $9f1d173c35ef8a1e$var$REPLACE_KEY = "\u9867";
class $9f1d173c35ef8a1e$export$2e2bcd8739ae039 {
    format;
    maskFormat;
    cells;
    maskCells;
    constructor(format){
        this.format = format;
        // Generate mask format
        const replaceKeys = $9f1d173c35ef8a1e$var$FORMAT_KEYS.map((key)=>`(${key})`).join("|");
        const replaceReg = new RegExp(replaceKeys, "g");
        this.maskFormat = format.replace(replaceReg, // Use Chinese character to avoid user use it in format
        (key)=>$9f1d173c35ef8a1e$var$REPLACE_KEY.repeat(key.length));
        // Generate cells
        const cellReg = new RegExp(`(${$9f1d173c35ef8a1e$var$FORMAT_KEYS.join("|")})`);
        const strCells = (format.split(cellReg) || []).filter((str)=>str);
        let offset = 0;
        this.cells = strCells.map((text)=>{
            const mask = $9f1d173c35ef8a1e$var$FORMAT_KEYS.includes(text);
            const start = offset;
            const end = offset + text.length;
            offset = end;
            return {
                text: text,
                mask: mask,
                start: start,
                end: end
            };
        });
        // Mask cells
        this.maskCells = this.cells.filter((cell)=>cell.mask);
    }
    getSelection(maskCellIndex) {
        const { start: start, end: end } = this.maskCells[maskCellIndex] || {};
        return [
            start || 0,
            end || 0
        ];
    }
    /** Check given text match format */ match(text) {
        for(let i = 0; i < this.maskFormat.length; i += 1){
            const maskChar = this.maskFormat[i];
            const textChar = text[i];
            if (!textChar || maskChar !== $9f1d173c35ef8a1e$var$REPLACE_KEY && maskChar !== textChar) return false;
        }
        return true;
    }
    /** Get mask cell count */ size() {
        return this.maskCells.length;
    }
    getMaskCellIndex(anchorIndex) {
        let closetDist = Number.MAX_SAFE_INTEGER;
        let closetIndex = 0;
        for(let i = 0; i < this.maskCells.length; i += 1){
            const { start: start, end: end } = this.maskCells[i];
            if (anchorIndex >= start && anchorIndex <= end) return i;
            const dist = Math.min(Math.abs(anchorIndex - start), Math.abs(anchorIndex - end));
            if (dist < closetDist) {
                closetDist = dist;
                closetIndex = i;
            }
        }
        return closetIndex;
    }
}


function $f5a05d2ffd1a7db1$export$8272b5e4a0ae610e(key) {
    const PresetRange = {
        YYYY: [
            0,
            9999,
            new Date().getFullYear()
        ],
        MM: [
            1,
            12
        ],
        DD: [
            1,
            31
        ],
        HH: [
            0,
            23
        ],
        mm: [
            0,
            59
        ],
        ss: [
            0,
            59
        ],
        SSS: [
            0,
            999
        ]
    };
    return PresetRange[key];
}


function $0a066be5e31e02e7$var$_extends() {
    $0a066be5e31e02e7$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0a066be5e31e02e7$var$_extends.apply(this, arguments);
}
// Format logic
//
// First time on focus:
//  1. check if the text is valid, if not fill with format
//  2. set highlight cell to the first cell
// Cells
//  1. Selection the index cell, set inner `cacheValue` to ''
//  2. Key input filter non-number char, patch after the `cacheValue`
//    1. Replace the `cacheValue` with input align the cell length
//    2. Re-selection the mask cell
//  3. If `cacheValue` match the limit length or cell format (like 1 ~ 12 month), go to next cell
const $0a066be5e31e02e7$var$Input = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { className: className, active: active, showActiveCls: showActiveCls = true, suffixIcon: suffixIcon, format: format, validateFormat: validateFormat, onChange: onChange, onInput: onInput, helped: helped, onHelp: onHelp, onSubmit: onSubmit, onKeyDown: onKeyDown, preserveInvalidOnBlur: preserveInvalidOnBlur = false, invalid: invalid, clearIcon: clearIcon, // Pass to input
    ...restProps } = props;
    const { value: value, onFocus: onFocus, onBlur: onBlur, onMouseUp: onMouseUp } = props;
    const { prefixCls: prefixCls, input: Component = "input", classNames: classNames, styles: styles } = $cQmXV.useContext((0, $8ffb82fb472fb634$export$2e2bcd8739ae039));
    const inputPrefixCls = `${prefixCls}-input`;
    // ======================== Value =========================
    const [focused, setFocused] = $cQmXV.useState(false);
    const [internalInputValue, setInputValue] = $cQmXV.useState(value);
    const [focusCellText, setFocusCellText] = $cQmXV.useState("");
    const [focusCellIndex, setFocusCellIndex] = $cQmXV.useState(null);
    const [forceSelectionSyncMark, forceSelectionSync] = $cQmXV.useState(null);
    const inputValue = internalInputValue || "";
    // Sync value if needed
    $cQmXV.useEffect(()=>{
        setInputValue(value);
    }, [
        value
    ]);
    // ========================= Refs =========================
    const holderRef = $cQmXV.useRef(null);
    const inputRef = $cQmXV.useRef(null);
    // When mousedown get focus, defer selection to mouseUp so click position is used
    const mouseDownRef = $cQmXV.useRef(false);
    $cQmXV.useImperativeHandle(ref, ()=>({
            nativeElement: holderRef.current,
            inputElement: inputRef.current,
            focus: (options)=>{
                inputRef.current.focus(options);
            },
            blur: ()=>{
                inputRef.current.blur();
            }
        }));
    // ======================== Format ========================
    const maskFormat = $cQmXV.useMemo(()=>new (0, $9f1d173c35ef8a1e$export$2e2bcd8739ae039)(format || ""), [
        format
    ]);
    const [selectionStart, selectionEnd] = $cQmXV.useMemo(()=>{
        if (helped) return [
            0,
            0
        ];
        return maskFormat.getSelection(focusCellIndex);
    }, [
        maskFormat,
        focusCellIndex,
        helped
    ]);
    // ======================== Modify ========================
    // When input modify content, trigger `onHelp` if is not the format
    const onModify = (text)=>{
        if (text && text !== format && text !== value) onHelp();
    };
    // ======================== Change ========================
    /**
   * Triggered by paste, keyDown and focus to show format
   */ const triggerInputChange = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((text)=>{
        if (validateFormat(text)) onChange(text);
        setInputValue(text);
        onModify(text);
    });
    // Directly trigger `onChange` if `format` is empty
    const onInternalChange = (event)=>{
        // Hack `onChange` with format to do nothing
        if (!format) {
            const text = event.target.value;
            onModify(text);
            setInputValue(text);
            onChange(text);
        }
    };
    const onFormatPaste = (event)=>{
        // Block paste until selection is set (after mouseUp when focus was by mousedown)
        if (mouseDownRef.current) {
            event.preventDefault();
            return;
        }
        // Get paste text
        const pasteText = event.clipboardData.getData("text");
        if (validateFormat(pasteText)) triggerInputChange(pasteText);
    };
    // ======================== Mouse =========================
    // When `mouseDown` get focus, it's better to not to change the selection
    // Since the up position maybe not is the first cell
    const onFormatMouseDown = ()=>{
        mouseDownRef.current = true;
    };
    const onFormatMouseUp = (event)=>{
        const { selectionStart: start } = event.target;
        const closeMaskIndex = maskFormat.getMaskCellIndex(start);
        setFocusCellIndex(closeMaskIndex);
        // Force update the selection
        forceSelectionSync({});
        onMouseUp?.(event);
        mouseDownRef.current = false;
    };
    // ====================== Focus Blur ======================
    const onFormatFocus = (event)=>{
        setFocused(true);
        setFocusCellIndex(0);
        setFocusCellText("");
        onFocus(event);
    };
    const onSharedBlur = (event)=>{
        onBlur(event);
    };
    const onFormatBlur = (event)=>{
        setFocused(false);
        onSharedBlur(event);
    };
    // ======================== Active ========================
    // Check if blur need reset input value
    (0, $445aef65e82c78c3$export$2e2bcd8739ae039)(active, ()=>{
        if (!active && !preserveInvalidOnBlur) setInputValue(value);
    });
    // ======================= Keyboard =======================
    const onSharedKeyDown = (event)=>{
        if (event.key === "Enter" && validateFormat(inputValue)) onSubmit();
        onKeyDown?.(event);
    };
    const onFormatKeyDown = (event)=>{
        // Block key input until selection is set (after mouseUp when focus was by mousedown)
        if (mouseDownRef.current) {
            event.preventDefault();
            return;
        }
        onSharedKeyDown(event);
        const { key: key } = event;
        // Save the cache with cell text
        let nextCellText = null;
        // Fill in the input
        let nextFillText = null;
        const maskCellLen = selectionEnd - selectionStart;
        const cellFormat = format.slice(selectionStart, selectionEnd);
        // Cell Index
        const offsetCellIndex = (offset)=>{
            setFocusCellIndex((idx)=>{
                let nextIndex = idx + offset;
                nextIndex = Math.max(nextIndex, 0);
                nextIndex = Math.min(nextIndex, maskFormat.size() - 1);
                return nextIndex;
            });
        };
        // Range
        const offsetCellValue = (offset)=>{
            const [rangeStart, rangeEnd, rangeDefault] = (0, $f5a05d2ffd1a7db1$export$8272b5e4a0ae610e)(cellFormat);
            const currentText = inputValue.slice(selectionStart, selectionEnd);
            const currentTextNum = Number(currentText);
            if (isNaN(currentTextNum)) return String(rangeDefault ? rangeDefault : offset > 0 ? rangeStart : rangeEnd);
            const num = currentTextNum + offset;
            const range = rangeEnd - rangeStart + 1;
            return String(rangeStart + (range + num - rangeStart) % range);
        };
        switch(key){
            // =============== Remove ===============
            case "Backspace":
            case "Delete":
                nextCellText = "";
                nextFillText = cellFormat;
                break;
            // =============== Arrows ===============
            // Left key
            case "ArrowLeft":
                nextCellText = "";
                offsetCellIndex(-1);
                break;
            // Right key
            case "ArrowRight":
                nextCellText = "";
                offsetCellIndex(1);
                break;
            // Up key
            case "ArrowUp":
                nextCellText = "";
                nextFillText = offsetCellValue(1);
                break;
            // Down key
            case "ArrowDown":
                nextCellText = "";
                nextFillText = offsetCellValue(-1);
                break;
            // =============== Number ===============
            default:
                if (!isNaN(Number(key))) {
                    nextCellText = focusCellText + key;
                    nextFillText = nextCellText;
                }
                break;
        }
        // Update cell text
        if (nextCellText !== null) {
            setFocusCellText(nextCellText);
            if (nextCellText.length >= maskCellLen) {
                // Go to next cell
                offsetCellIndex(1);
                setFocusCellText("");
            }
        }
        // Update the input text
        if (nextFillText !== null) {
            // Replace selection range with `nextCellText`
            const nextFocusValue = // before
            inputValue.slice(0, selectionStart) + // replace
            (0, $03e7a71a94f7692c$export$cbb503201166aab7)(nextFillText, maskCellLen) + // after
            inputValue.slice(selectionEnd);
            triggerInputChange(nextFocusValue.slice(0, format.length));
        }
        // Always trigger selection sync after key down
        forceSelectionSync({});
    };
    // ======================== Format ========================
    const rafRef = $cQmXV.useRef(undefined);
    (0, $7673d874dab69d07$export$2e2bcd8739ae039)(()=>{
        if (!focused || !format || mouseDownRef.current) return;
        // Reset with format if not match
        if (!maskFormat.match(inputValue)) {
            triggerInputChange(format);
            return;
        }
        // Match the selection range
        inputRef.current.setSelectionRange(selectionStart, selectionEnd);
        // Chrome has the bug anchor position looks not correct but actually correct
        rafRef.current = (0, $905c53b807de704e$export$2e2bcd8739ae039)(()=>{
            inputRef.current.setSelectionRange(selectionStart, selectionEnd);
        });
        return ()=>{
            (0, $905c53b807de704e$export$2e2bcd8739ae039).cancel(rafRef.current);
        };
    }, [
        maskFormat,
        format,
        focused,
        inputValue,
        focusCellIndex,
        selectionStart,
        selectionEnd,
        forceSelectionSyncMark,
        triggerInputChange
    ]);
    // ======================== Render ========================
    // Input props for format
    const inputProps = format ? {
        onFocus: onFormatFocus,
        onBlur: onFormatBlur,
        onKeyDown: onFormatKeyDown,
        onMouseDown: onFormatMouseDown,
        onMouseUp: onFormatMouseUp,
        onPaste: onFormatPaste
    } : {};
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        ref: holderRef,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(inputPrefixCls, {
            [`${inputPrefixCls}-active`]: active && showActiveCls,
            [`${inputPrefixCls}-placeholder`]: helped
        }, className)
    }, /*#__PURE__*/ $cQmXV.createElement(Component, $0a066be5e31e02e7$var$_extends({
        ref: inputRef,
        "aria-invalid": invalid,
        autoComplete: "off"
    }, restProps, {
        onKeyDown: onSharedKeyDown,
        onBlur: onSharedBlur
    }, inputProps, {
        // Value
        value: inputValue,
        onChange: onInternalChange,
        className: classNames.input,
        style: styles.input
    })), /*#__PURE__*/ $cQmXV.createElement((0, $b74f54f68bbecac1$export$2e2bcd8739ae039), {
        icon: suffixIcon
    }), clearIcon);
});
var $0a066be5e31e02e7$export$2e2bcd8739ae039 = $0a066be5e31e02e7$var$Input;


function $c2887b04094934a2$var$_extends() {
    $c2887b04094934a2$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c2887b04094934a2$var$_extends.apply(this, arguments);
}
function $c2887b04094934a2$var$RangeSelector(props, ref) {
    const { id: id, prefix: prefix, clearIcon: clearIcon, suffixIcon: suffixIcon, separator: separator = "~", activeIndex: activeIndex, activeHelp: activeHelp, allHelp: allHelp, focused: focused, onFocus: onFocus, onBlur: onBlur, onKeyDown: onKeyDown, locale: locale, generateConfig: generateConfig, placeholder: // Placeholder
    placeholder, className: // Style
    className, style: style, onClick: // Click
    onClick, onClear: onClear, value: // Change
    value, onChange: onChange, onSubmit: onSubmit, onInputChange: onInputChange, format: // Valid
    format, maskFormat: maskFormat, preserveInvalidOnBlur: preserveInvalidOnBlur, onInvalid: onInvalid, disabled: // Disabled
    disabled, invalid: invalid, inputReadOnly: inputReadOnly, direction: // Direction
    direction, onOpenChange: // Open
    onOpenChange, onActiveInfo: // Offset
    onActiveInfo, placement: placement, onMouseDown: // Native
    onMouseDown, required: // Input
    required, "aria-required": ariaRequired, autoFocus: autoFocus, tabIndex: tabIndex, ...restProps } = props;
    const rtl = direction === "rtl";
    // ======================== Prefix ========================
    const { prefixCls: prefixCls, classNames: classNames, styles: styles } = $cQmXV.useContext((0, $8ffb82fb472fb634$export$2e2bcd8739ae039));
    // ========================== Id ==========================
    const ids = $cQmXV.useMemo(()=>{
        if (typeof id === "string") return [
            id
        ];
        const mergedId = id || {};
        return [
            mergedId.start,
            mergedId.end
        ];
    }, [
        id
    ]);
    // ========================= Refs =========================
    const rootRef = $cQmXV.useRef(null);
    const inputStartRef = $cQmXV.useRef(null);
    const inputEndRef = $cQmXV.useRef(null);
    const getInput = (index)=>[
            inputStartRef,
            inputEndRef
        ][index]?.current;
    $cQmXV.useImperativeHandle(ref, ()=>({
            nativeElement: rootRef.current,
            startInput: inputStartRef.current.inputElement,
            endInput: inputEndRef.current.inputElement,
            focus: (options)=>{
                if (typeof options === "object") {
                    const { index: index = 0, ...rest } = options || {};
                    getInput(index)?.focus(rest);
                } else getInput(options ?? 0)?.focus();
            },
            blur: ()=>{
                getInput(0)?.blur();
                getInput(1)?.blur();
            }
        }));
    // ======================== Props =========================
    const rootProps = (0, $aa9e86834dc06b68$export$2e2bcd8739ae039)(restProps);
    // ===================== Placeholder ======================
    const mergedPlaceholder = $cQmXV.useMemo(()=>Array.isArray(placeholder) ? placeholder : [
            placeholder,
            placeholder
        ], [
        placeholder
    ]);
    // ======================== Inputs ========================
    const [getInputProps] = (0, $9c944ba79672d18a$export$2e2bcd8739ae039)({
        ...props,
        id: ids,
        placeholder: mergedPlaceholder
    });
    // ====================== ActiveBar =======================
    const [activeBarStyle, setActiveBarStyle] = $cQmXV.useState({
        position: "absolute",
        width: 0
    });
    const syncActiveOffset = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)(()=>{
        const input = getInput(activeIndex);
        if (input) {
            const inputRect = input.nativeElement.getBoundingClientRect();
            const parentRect = rootRef.current.getBoundingClientRect();
            const rectOffset = inputRect.left - parentRect.left;
            setActiveBarStyle((ori)=>({
                    ...ori,
                    width: inputRect.width,
                    left: rectOffset
                }));
            onActiveInfo([
                inputRect.left,
                inputRect.right,
                parentRect.width
            ]);
        }
    });
    $cQmXV.useEffect(()=>{
        syncActiveOffset();
    }, [
        activeIndex
    ]);
    // ======================== Clear =========================
    const showClear = clearIcon && (value[0] && !disabled[0] || value[1] && !disabled[1]);
    // ======================= Disabled =======================
    const startAutoFocus = autoFocus && !disabled[0];
    const endAutoFocus = autoFocus && !startAutoFocus && !disabled[1];
    // ======================== Render ========================
    return /*#__PURE__*/ $cQmXV.createElement((0, $1d6306c05e604045$export$2e2bcd8739ae039), {
        onResize: syncActiveOffset
    }, /*#__PURE__*/ $cQmXV.createElement("div", $c2887b04094934a2$var$_extends({}, rootProps, {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-range`, {
            [`${prefixCls}-focused`]: focused,
            [`${prefixCls}-disabled`]: disabled.every((i)=>i),
            [`${prefixCls}-invalid`]: invalid.some((i)=>i),
            [`${prefixCls}-rtl`]: rtl
        }, className),
        style: style,
        ref: rootRef,
        onClick: onClick,
        onMouseDown: (e)=>{
            const { target: target } = e;
            if (target !== inputStartRef.current.inputElement && target !== inputEndRef.current.inputElement) e.preventDefault();
            onMouseDown?.(e);
        }
    }), prefix && /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-prefix`, classNames.prefix),
        style: styles.prefix
    }, prefix), /*#__PURE__*/ $cQmXV.createElement((0, $0a066be5e31e02e7$export$2e2bcd8739ae039), $c2887b04094934a2$var$_extends({
        ref: inputStartRef
    }, getInputProps(0), {
        className: `${prefixCls}-input-start`,
        autoFocus: startAutoFocus,
        tabIndex: tabIndex,
        "date-range": "start"
    })), /*#__PURE__*/ $cQmXV.createElement("div", {
        className: `${prefixCls}-range-separator`
    }, separator), /*#__PURE__*/ $cQmXV.createElement((0, $0a066be5e31e02e7$export$2e2bcd8739ae039), $c2887b04094934a2$var$_extends({
        ref: inputEndRef
    }, getInputProps(1), {
        className: `${prefixCls}-input-end`,
        autoFocus: endAutoFocus,
        tabIndex: tabIndex,
        "date-range": "end"
    })), /*#__PURE__*/ $cQmXV.createElement("div", {
        className: `${prefixCls}-active-bar`,
        style: activeBarStyle
    }), /*#__PURE__*/ $cQmXV.createElement((0, $b74f54f68bbecac1$export$2e2bcd8739ae039), {
        icon: suffixIcon
    }), showClear && /*#__PURE__*/ $cQmXV.createElement((0, $28ee6e2cf7395fb2$export$2e2bcd8739ae039), {
        icon: clearIcon,
        onClear: onClear
    })));
}
const $c2887b04094934a2$var$RefRangeSelector = /*#__PURE__*/ $cQmXV.forwardRef($c2887b04094934a2$var$RangeSelector);
var $c2887b04094934a2$export$2e2bcd8739ae039 = $c2887b04094934a2$var$RefRangeSelector;



var $cQmXV = parcelRequire("cQmXV");
function $f0ecc64b7db53c9d$export$2e2bcd8739ae039(classNames, styles) {
    return (0, $cQmXV.useMemo)(()=>{
        const mergedClassNames = {
            ...classNames,
            popup: classNames?.popup || {}
        };
        const mergedStyles = {
            ...styles,
            popup: styles?.popup || {}
        };
        return [
            mergedClassNames,
            mergedStyles
        ];
    }, [
        classNames,
        styles
    ]);
}


function $682295b6bf22f8f5$var$_extends() {
    $682295b6bf22f8f5$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $682295b6bf22f8f5$var$_extends.apply(this, arguments);
}
function $682295b6bf22f8f5$var$separateConfig(config, defaultConfig) {
    const singleConfig = config ?? defaultConfig;
    if (Array.isArray(singleConfig)) return singleConfig;
    return [
        singleConfig,
        singleConfig
    ];
}
/** Used for change event, it should always be not undefined */ function $682295b6bf22f8f5$var$getActiveRange(activeIndex) {
    return activeIndex === 1 ? "end" : "start";
}
function $682295b6bf22f8f5$var$RangePicker(props, ref) {
    // ========================= Prop =========================
    const [filledProps, internalPicker, complexPicker, formatList, maskFormat, isInvalidateDate] = (0, $6f88bc1a75df9e02$export$2e2bcd8739ae039)(props, ()=>{
        const { disabled: disabled, allowEmpty: allowEmpty } = props;
        const mergedDisabled = $682295b6bf22f8f5$var$separateConfig(disabled, false);
        const mergedAllowEmpty = $682295b6bf22f8f5$var$separateConfig(allowEmpty, false);
        return {
            disabled: mergedDisabled,
            allowEmpty: mergedAllowEmpty
        };
    });
    const { prefixCls: // Style
    prefixCls, rootClassName: rootClassName, styles: propStyles, classNames: propClassNames, previewValue: previewValue, defaultValue: // Value
    defaultValue, value: value, needConfirm: needConfirm, onClear: onClear, onKeyDown: onKeyDown, disabled: // Disabled
    disabled, allowEmpty: allowEmpty, disabledDate: disabledDate, minDate: minDate, maxDate: maxDate, defaultOpen: // Open
    defaultOpen, open: open, onOpenChange: onOpenChange, locale: // Picker
    locale, generateConfig: generateConfig, picker: picker, showNow: showNow, showToday: showToday, showTime: showTime, mode: // Mode
    mode, onPanelChange: onPanelChange, onCalendarChange: onCalendarChange, onOk: onOk, defaultPickerValue: // Picker Value
    defaultPickerValue, pickerValue: pickerValue, onPickerValueChange: onPickerValueChange, inputReadOnly: // Format
    inputReadOnly, suffixIcon: suffixIcon, onFocus: // Focus
    onFocus, onBlur: onBlur, presets: // Presets
    presets, ranges: ranges, components: // Render
    components, cellRender: cellRender, dateRender: dateRender, monthCellRender: monthCellRender, onClick: // Native
    onClick } = filledProps;
    // ========================= Refs =========================
    const selectorRef = (0, $e3a9d639e28d3613$export$2e2bcd8739ae039)(ref);
    const popupRef = $cQmXV.useRef(null);
    // ======================= Semantic =======================
    const [mergedClassNames, mergedStyles] = (0, $f0ecc64b7db53c9d$export$2e2bcd8739ae039)(propClassNames, propStyles);
    // ========================= Open =========================
    const [mergedOpen, setMergeOpen] = (0, $baa68117c464c322$export$2e2bcd8739ae039)(open, defaultOpen, disabled, onOpenChange);
    const triggerOpen = (nextOpen, config)=>{
        // No need to open if all disabled
        if (disabled.some((fieldDisabled)=>!fieldDisabled) || !nextOpen) setMergeOpen(nextOpen, config);
    };
    // ======================== Values ========================
    const [mergedValue, setInnerValue, getCalendarValue, triggerCalendarChange, triggerOk] = (0, $546b4a1e52e84023$export$eef0e5a163935805)(generateConfig, locale, formatList, true, false, defaultValue, value, onCalendarChange, onOk);
    const calendarValue = getCalendarValue();
    // ======================== Focus =========================
    const isInternalPickerElement = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((element)=>(0, $3a79bd058cf8ac77$export$9bd4f980f61191a)(element, [
            selectorRef.current.nativeElement,
            popupRef.current
        ]));
    const [focused, onFieldFocus, onFieldBlur] = (0, $3a79bd058cf8ac77$export$2e2bcd8739ae039)(isInternalPickerElement, (index, event)=>{
        onFocus?.(event, {
            range: $682295b6bf22f8f5$var$getActiveRange(index)
        });
    }, (index, event)=>{
        onBlur?.(event, {
            range: $682295b6bf22f8f5$var$getActiveRange(index)
        });
    }, ()=>{
        triggerOpen(false);
    });
    // ======================== Value =========================
    const [/** Trigger `onChange` by check `disabledDate` */ flushSubmit, /** Trigger `onChange` directly without check `disabledDate` */ triggerSubmitChange, /** Reset uncommitted values */ resetValue] = (0, $546b4a1e52e84023$export$2e2bcd8739ae039)(filledProps, mergedValue, setInnerValue, getCalendarValue, triggerCalendarChange, disabled, formatList, isInvalidateDate);
    const triggerFieldCalendarChange = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((index, date)=>{
        triggerCalendarChange((0, $03e7a71a94f7692c$export$4284846c29a21d02)(getCalendarValue(), index, date));
    });
    const flushFieldSubmit = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((index, needTriggerChange)=>{
        flushSubmit(index, needTriggerChange);
        if (needTriggerChange) triggerOpen(false, {
            force: true
        });
    });
    const enabledFieldCount = disabled.filter((fieldDisabled)=>!fieldDisabled).length;
    const [rangeValueIndex, activeIndex, forceFocus, triggeredFields, triggerRangeValueChange, resetRangeValueChange] = (0, $9166225084aa8aea$export$2e2bcd8739ae039)(enabledFieldCount, needConfirm, allowEmpty, getCalendarValue, triggerFieldCalendarChange, flushFieldSubmit, resetValue);
    (0, $fde2991fc5919375$export$2e2bcd8739ae039)(rangeValueIndex, forceFocus, selectorRef, popupRef, triggerOpen);
    // Finalize the current interaction only after the popup is actually closed.
    // 仅在 popup 实际关闭后，统一收口当前交互。
    (0, $7673d874dab69d07$export$2e2bcd8739ae039)((firstMount)=>{
        if (!firstMount && !mergedOpen) triggerRangeValueChange(rangeValueIndex ?? activeIndex, "popupClose");
    }, [
        mergedOpen
    ]);
    // ======================= ShowTime =======================
    /** Used for Popup panel */ const mergedShowTime = $cQmXV.useMemo(()=>{
        if (!showTime) return null;
        const { disabledTime: disabledTime } = showTime;
        const proxyDisabledTime = disabledTime ? (date)=>{
            const range = $682295b6bf22f8f5$var$getActiveRange(activeIndex);
            const fromDate = (0, $03e7a71a94f7692c$export$25071452d0014c32)(calendarValue, triggeredFields, activeIndex);
            return disabledTime(date, range, {
                from: fromDate
            });
        } : undefined;
        return {
            ...showTime,
            disabledTime: proxyDisabledTime
        };
    }, [
        showTime,
        activeIndex,
        calendarValue,
        triggeredFields
    ]);
    // ========================= Mode =========================
    const [modes, setModes] = (0, $a51866d781137e08$export$2e2bcd8739ae039)([
        picker,
        picker
    ], mode);
    const mergedMode = modes[activeIndex] || picker;
    /** Extends from `mergedMode` to patch `datetime` mode */ const internalMode = mergedMode === "date" && mergedShowTime ? "datetime" : mergedMode;
    // ====================== PanelCount ======================
    const multiplePanel = internalMode === picker && internalMode !== "time";
    // ======================= Show Now =======================
    const mergedShowNow = (0, $b81005c1d5a2d816$export$2e2bcd8739ae039)(picker, mergedMode, showNow, showToday, true);
    // ===================== DisabledDate =====================
    const mergedDisabledDate = (0, $d44032b209773016$export$2e2bcd8739ae039)(calendarValue, disabled, activeIndex, triggeredFields, generateConfig, locale, disabledDate);
    // ======================= Validate =======================
    const [submitInvalidates, onSelectorInvalid] = (0, $c696947bae675ffe$export$2e2bcd8739ae039)(calendarValue, isInvalidateDate, allowEmpty);
    // ===================== Picker Value =====================
    const [currentPickerValue, setCurrentPickerValue] = (0, $58210ec7ad711cce$export$2e2bcd8739ae039)(generateConfig, locale, calendarValue, modes, mergedOpen, focused, activeIndex, internalPicker, multiplePanel, defaultPickerValue, pickerValue, mergedShowTime?.defaultOpenValue, onPickerValueChange, minDate, maxDate);
    // >>> Mode need wait for `pickerValue`
    const triggerModeChange = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((nextPickerValue, nextMode, triggerEvent)=>{
        const clone = (0, $03e7a71a94f7692c$export$4284846c29a21d02)(modes, activeIndex, nextMode);
        if (clone[0] !== modes[0] || clone[1] !== modes[1]) setModes(clone);
        // Compatible with `onPanelChange`
        if (onPanelChange && triggerEvent !== false) {
            const clonePickerValue = [
                ...calendarValue
            ];
            if (nextPickerValue) clonePickerValue[activeIndex] = nextPickerValue;
            onPanelChange(clonePickerValue, clone);
        }
    });
    // ======================== Change ========================
    const fillCalendarValue = (date, index)=>// Trigger change only when date changed
        (0, $03e7a71a94f7692c$export$4284846c29a21d02)(calendarValue, index, date);
    // ======================== Submit ========================
    /**
   * Trigger by confirm operation.
   * This function has already handle the `needConfirm` check logic.
   * - Selector: enter key
   * - Panel: OK button
   */ const triggerPartConfirm = (date, source = "confirm")=>{
        triggerRangeValueChange(activeIndex, source, date ?? undefined);
    };
    // ======================== Click =========================
    const onSelectorClick = (event)=>{
        const rootNode = event.target.getRootNode();
        if (!selectorRef.current.nativeElement.contains(rootNode.activeElement ?? document.activeElement)) {
            // Click to focus the enabled input
            const enabledIndex = disabled.findIndex((d)=>!d);
            if (enabledIndex >= 0) selectorRef.current.focus({
                index: enabledIndex
            });
        }
        triggerOpen(true);
        onClick?.(event);
    };
    const onSelectorClear = ()=>{
        resetRangeValueChange();
        triggerSubmitChange(null);
        triggerOpen(false, {
            force: true
        });
        onClear?.();
    };
    // ======================== Hover =========================
    const [hoverSource, setHoverSource] = $cQmXV.useState(null);
    const [internalHoverValues, setInternalHoverValues] = $cQmXV.useState(null);
    const hoverValues = $cQmXV.useMemo(()=>{
        return internalHoverValues || calendarValue;
    }, [
        calendarValue,
        internalHoverValues
    ]);
    // Clean up `internalHoverValues` when closed
    $cQmXV.useEffect(()=>{
        if (!mergedOpen) setInternalHoverValues(null);
    }, [
        mergedOpen
    ]);
    // ========================================================
    // ==                       Panels                       ==
    // ========================================================
    // Save the offset with active bar position
    // const [activeOffset, setActiveOffset] = React.useState(0);
    const [activeInfo, setActiveInfo] = $cQmXV.useState([
        0,
        0,
        0
    ]);
    const onSetHover = (date, source)=>{
        if (previewValue !== "hover") return;
        setInternalHoverValues(date);
        setHoverSource(source);
    };
    // ======================= Presets ========================
    const presetList = (0, $58fb6cd5d787b224$export$2e2bcd8739ae039)(presets, ranges);
    const onPresetHover = (nextValues)=>{
        onSetHover(nextValues, "preset");
    };
    const onPresetSubmit = (nextValues)=>{
        const passed = triggerSubmitChange(nextValues);
        if (passed) triggerOpen(false, {
            force: true
        });
    };
    const onNow = (now)=>{
        triggerPartConfirm(now);
    };
    // ======================== Panel =========================
    const onPanelHover = (date)=>{
        onSetHover(date ? fillCalendarValue(date, activeIndex) : null, "cell");
    };
    // >>> Focus
    const onPanelFocus = (event)=>{
        triggerOpen(true);
        onFieldFocus(activeIndex, "panel", event);
    };
    // >>> Calendar
    const onPanelSelect = (date)=>{
        const panelFinished = !complexPicker && internalPicker === internalMode;
        triggerRangeValueChange(activeIndex, panelFinished ? "panel-final" : "panel-intermediate", date);
    };
    // >>> Close
    const onPopupClose = ()=>{
        triggerOpen(false);
    };
    // >>> cellRender
    const onInternalCellRender = (0, $86c2958c1a46dbcf$export$2e2bcd8739ae039)(cellRender, dateRender, monthCellRender, $682295b6bf22f8f5$var$getActiveRange(activeIndex));
    // >>> Value
    const panelValue = calendarValue[activeIndex] || null;
    // >>> invalid
    const isPopupInvalidateDate = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((date)=>{
        return isInvalidateDate(date, {
            activeIndex: activeIndex
        });
    });
    const panelProps = $cQmXV.useMemo(()=>{
        const domProps = (0, $4b5c733d1d7bb306$export$2e2bcd8739ae039)(filledProps, false);
        const restProps = (0, $e8c5093aebad6025$export$2e2bcd8739ae039)(filledProps, [
            ...Object.keys(domProps),
            "onChange",
            "onCalendarChange",
            "onClear",
            "style",
            "className",
            "onPanelChange",
            "disabledTime",
            "classNames",
            "styles"
        ]);
        return restProps;
    }, [
        filledProps
    ]);
    // >>> Render
    const panel = /*#__PURE__*/ $cQmXV.createElement((0, $bee4a9c24fa7de8c$export$2e2bcd8739ae039), $682295b6bf22f8f5$var$_extends({
        containerRef: popupRef
    }, panelProps, {
        showNow: mergedShowNow,
        showTime: mergedShowTime,
        range: true,
        multiplePanel: multiplePanel,
        activeInfo: activeInfo,
        disabledDate: mergedDisabledDate,
        onFocus: onPanelFocus,
        onBlur: (event)=>onFieldBlur(activeIndex, "panel", event),
        picker: picker,
        mode: mergedMode,
        internalMode: internalMode,
        onPanelChange: triggerModeChange,
        format: maskFormat,
        value: panelValue,
        isInvalid: isPopupInvalidateDate,
        onChange: null,
        onSelect: onPanelSelect,
        pickerValue: currentPickerValue,
        defaultOpenValue: (0, $03e7a71a94f7692c$export$45b10814cc054894)(showTime?.defaultOpenValue)[activeIndex],
        onPickerValueChange: setCurrentPickerValue,
        hoverValue: hoverValues,
        onHover: onPanelHover,
        needConfirm: needConfirm,
        onSubmit: (date)=>triggerPartConfirm(date, "confirm"),
        onOk: triggerOk,
        presets: presetList,
        onPresetHover: onPresetHover,
        onPresetSubmit: onPresetSubmit,
        onNow: onNow,
        cellRender: onInternalCellRender,
        classNames: mergedClassNames,
        styles: mergedStyles
    }));
    // ========================================================
    // ==                      Selector                      ==
    // ========================================================
    // ======================== Change ========================
    const onSelectorChange = (date, index)=>{
        triggerRangeValueChange(index, "input", date);
    };
    const onSelectorInputChange = ()=>{
        triggerRangeValueChange(activeIndex, "input");
    };
    // ======================= Selector =======================
    const onSelectorFocus = (event, index)=>{
        triggerRangeValueChange(index, "field-switch");
        triggerOpen(true, {
            inherit: true
        });
        onFieldFocus(index, "input", event);
    };
    const onSelectorBlur = (event, index)=>{
        onFieldBlur(index, "input", event);
    };
    const onSelectorKeyDown = (event, preventDefault)=>{
        if (event.key === "Tab") triggerPartConfirm(null, "keyboard-submit-weak");
        else if (event.key === "Escape") {
            triggerRangeValueChange(activeIndex, "esc");
            triggerOpen(false);
        }
        onKeyDown?.(event, preventDefault);
    };
    // ======================= Context ========================
    const context = $cQmXV.useMemo(()=>({
            prefixCls: prefixCls,
            locale: locale,
            generateConfig: generateConfig,
            button: components.button,
            input: components.input,
            classNames: mergedClassNames,
            styles: mergedStyles
        }), [
        prefixCls,
        locale,
        generateConfig,
        components.button,
        components.input,
        mergedClassNames,
        mergedStyles
    ]);
    // ======================== Effect ========================
    // >>> Mode
    // Reset for every active
    (0, $7673d874dab69d07$export$2e2bcd8739ae039)(()=>{
        if (mergedOpen && activeIndex !== undefined) // Legacy compatible. This effect update should not trigger `onPanelChange`
        triggerModeChange(null, picker, false);
    }, [
        mergedOpen,
        activeIndex,
        picker
    ]);
    var fieldDisabled, index;
    // ======================== Render ========================
    return /*#__PURE__*/ $cQmXV.createElement((0, $8ffb82fb472fb634$export$2e2bcd8739ae039).Provider, {
        value: context
    }, /*#__PURE__*/ $cQmXV.createElement((0, $65f9edc43638c2a4$export$2e2bcd8739ae039), $682295b6bf22f8f5$var$_extends({}, (0, $d366afafb0a5ce51$export$a11cc4b953869c91)(filledProps), {
        popupElement: panel,
        popupStyle: mergedStyles.popup.root,
        popupClassName: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(rootClassName, mergedClassNames.popup.root),
        visible: mergedOpen,
        onClose: onPopupClose,
        range: true
    }), /*#__PURE__*/ $cQmXV.createElement((0, $c2887b04094934a2$export$2e2bcd8739ae039), $682295b6bf22f8f5$var$_extends({}, filledProps, {
        // Ref
        ref: selectorRef,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(filledProps.className, rootClassName, mergedClassNames.root),
        style: {
            ...mergedStyles.root,
            ...filledProps.style
        },
        suffixIcon: suffixIcon,
        activeIndex: focused || mergedOpen ? activeIndex : null,
        activeHelp: !!internalHoverValues,
        allHelp: !!internalHoverValues && hoverSource === "preset",
        focused: focused,
        onFocus: onSelectorFocus,
        onBlur: onSelectorBlur,
        onKeyDown: onSelectorKeyDown,
        onSubmit: ()=>triggerPartConfirm(null, "keyboard-submit"),
        value: hoverValues,
        maskFormat: maskFormat,
        onChange: onSelectorChange,
        onInputChange: onSelectorInputChange,
        format: formatList,
        inputReadOnly: inputReadOnly,
        disabled: disabled,
        open: mergedOpen,
        onOpenChange: triggerOpen,
        onClick: onSelectorClick,
        onClear: onSelectorClear,
        invalid: submitInvalidates,
        onInvalid: onSelectorInvalid,
        onActiveInfo: setActiveInfo
    }))));
}
const $682295b6bf22f8f5$var$RefRangePicker = /*#__PURE__*/ $cQmXV.forwardRef($682295b6bf22f8f5$var$RangePicker);
var $682295b6bf22f8f5$export$2e2bcd8739ae039 = $682295b6bf22f8f5$var$RefRangePicker;





var $cQmXV = parcelRequire("cQmXV");



















var $cQmXV = parcelRequire("cQmXV");










var $cQmXV = parcelRequire("cQmXV");
function $6f75875efeebb74c$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, value: value, onRemove: onRemove, removeIcon: removeIcon = "\xd7", formatDate: formatDate, disabled: disabled, maxTagCount: maxTagCount, tagRender: tagRender, placeholder: placeholder } = props;
    const selectorCls = `${prefixCls}-selector`;
    const selectionCls = `${prefixCls}-selection`;
    const overflowCls = `${selectionCls}-overflow`;
    // ========================= Item =========================
    function renderSelector(content, onClose) {
        return /*#__PURE__*/ $cQmXV.createElement("span", {
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${selectionCls}-item`),
            title: typeof content === "string" ? content : null
        }, /*#__PURE__*/ $cQmXV.createElement("span", {
            className: `${selectionCls}-item-content`
        }, content), !disabled && onClose && /*#__PURE__*/ $cQmXV.createElement("span", {
            onMouseDown: (e)=>{
                e.preventDefault();
            },
            onClick: onClose,
            className: `${selectionCls}-item-remove`
        }, removeIcon));
    }
    function renderItem(date) {
        const displayLabel = formatDate(date);
        const closable = !disabled;
        const onClose = (event)=>{
            if (event) event.stopPropagation();
            if (!disabled) onRemove(date);
        };
        if (tagRender) return tagRender({
            label: displayLabel,
            value: date,
            disabled: !!disabled,
            closable: closable,
            onClose: onClose
        });
        return renderSelector(displayLabel, onClose);
    }
    // ========================= Rest =========================
    function renderRest(omittedValues) {
        const content = `+ ${omittedValues.length} ...`;
        return renderSelector(content);
    }
    // ======================== Render ========================
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        className: selectorCls
    }, /*#__PURE__*/ $cQmXV.createElement((0, $788a6a69bf396d02$export$2e2bcd8739ae039), {
        prefixCls: overflowCls,
        data: value,
        renderItem: renderItem,
        renderRest: renderRest,
        itemKey: (date)=>formatDate(date),
        maxCount: maxTagCount
    }), !value.length && /*#__PURE__*/ $cQmXV.createElement("span", {
        className: `${prefixCls}-selection-placeholder`
    }, placeholder));
}


function $623905a78283a229$var$_extends() {
    $623905a78283a229$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $623905a78283a229$var$_extends.apply(this, arguments);
}
function $623905a78283a229$var$SingleSelector(props, ref) {
    const { id: id, open: open, prefix: prefix, clearIcon: clearIcon, suffixIcon: suffixIcon, activeHelp: activeHelp, allHelp: allHelp, focused: focused, onFocus: onFocus, onBlur: onBlur, onKeyDown: onKeyDown, locale: locale, generateConfig: generateConfig, placeholder: // Placeholder
    placeholder, className: // Style
    className, style: style, onClick: // Click
    onClick, onClear: onClear, internalPicker: // Change
    internalPicker, value: value, onChange: onChange, onSubmit: onSubmit, onInputChange: onInputChange, multiple: multiple, maxTagCount: maxTagCount, tagRender: tagRender, format: // Valid
    format, maskFormat: maskFormat, preserveInvalidOnBlur: preserveInvalidOnBlur, onInvalid: onInvalid, disabled: // Disabled
    disabled, invalid: invalid, inputReadOnly: inputReadOnly, direction: // Direction
    direction, onOpenChange: // Open
    onOpenChange, onMouseDown: // Native
    onMouseDown, required: // Input
    required, "aria-required": ariaRequired, autoFocus: autoFocus, tabIndex: tabIndex, removeIcon: removeIcon, ...restProps } = props;
    const rtl = direction === "rtl";
    // ======================== Prefix ========================
    const { prefixCls: prefixCls, classNames: classNames, styles: styles } = $cQmXV.useContext((0, $8ffb82fb472fb634$export$2e2bcd8739ae039));
    // ========================= Refs =========================
    const rootRef = $cQmXV.useRef(null);
    const inputRef = $cQmXV.useRef(null);
    $cQmXV.useImperativeHandle(ref, ()=>({
            nativeElement: rootRef.current,
            focus: (options)=>{
                inputRef.current?.focus(options);
            },
            blur: ()=>{
                inputRef.current?.blur();
            }
        }));
    // ======================== Props =========================
    const rootProps = (0, $aa9e86834dc06b68$export$2e2bcd8739ae039)(restProps);
    // ======================== Change ========================
    const onSingleChange = (date)=>{
        onChange([
            date
        ], "input");
    };
    const onMultipleRemove = (date)=>{
        const nextValues = value.filter((oriDate)=>oriDate && !(0, $56194b7cc1a1787c$export$18ac18efd9e98d41)(generateConfig, locale, oriDate, date, internalPicker));
        // An open popup keeps removal temporary until confirmation. Removing while
        // closed is final and submits through the explicit `remove` source.
        // popup 打开时仅保留临时删除值并等待确认；关闭时删除是最终操作，通过
        // 明确的 `remove` 来源提交。
        onChange(nextValues, open ? "input" : "remove");
    };
    // ======================== Inputs ========================
    const [getInputProps, getText] = (0, $9c944ba79672d18a$export$2e2bcd8739ae039)({
        ...props,
        onChange: onSingleChange
    }, ({ valueTexts: valueTexts })=>({
            value: valueTexts[0] || "",
            active: focused
        }));
    // ======================== Clear =========================
    const showClear = !!(clearIcon && value.length && !disabled);
    // ======================= Multiple =======================
    const selectorNode = multiple ? /*#__PURE__*/ $cQmXV.createElement($cQmXV.Fragment, null, /*#__PURE__*/ $cQmXV.createElement((0, $6f75875efeebb74c$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        value: value,
        onRemove: onMultipleRemove,
        formatDate: getText,
        maxTagCount: maxTagCount,
        tagRender: tagRender,
        disabled: disabled,
        removeIcon: removeIcon,
        placeholder: placeholder
    }), /*#__PURE__*/ $cQmXV.createElement("input", {
        className: `${prefixCls}-multiple-input`,
        value: value.map(getText).join(","),
        ref: inputRef,
        readOnly: true,
        autoFocus: autoFocus,
        tabIndex: tabIndex
    }), /*#__PURE__*/ $cQmXV.createElement((0, $b74f54f68bbecac1$export$2e2bcd8739ae039), {
        icon: suffixIcon
    }), showClear && /*#__PURE__*/ $cQmXV.createElement((0, $28ee6e2cf7395fb2$export$2e2bcd8739ae039), {
        icon: clearIcon,
        onClear: onClear
    })) : /*#__PURE__*/ $cQmXV.createElement((0, $0a066be5e31e02e7$export$2e2bcd8739ae039), $623905a78283a229$var$_extends({
        ref: inputRef
    }, getInputProps(), {
        autoFocus: autoFocus,
        tabIndex: tabIndex,
        suffixIcon: suffixIcon,
        clearIcon: showClear && /*#__PURE__*/ $cQmXV.createElement((0, $28ee6e2cf7395fb2$export$2e2bcd8739ae039), {
            icon: clearIcon,
            onClear: onClear
        }),
        showActiveCls: false
    }));
    // ======================== Render ========================
    return /*#__PURE__*/ $cQmXV.createElement("div", $623905a78283a229$var$_extends({}, rootProps, {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, {
            [`${prefixCls}-multiple`]: multiple,
            [`${prefixCls}-focused`]: focused,
            [`${prefixCls}-disabled`]: disabled,
            [`${prefixCls}-invalid`]: invalid,
            [`${prefixCls}-rtl`]: rtl
        }, className),
        style: style,
        ref: rootRef,
        onClick: onClick,
        onMouseDown: (e)=>{
            const { target: target } = e;
            if (target !== inputRef.current?.inputElement) e.preventDefault();
            onMouseDown?.(e);
        }
    }), prefix && /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-prefix`, classNames.prefix),
        style: styles.prefix
    }, prefix), selectorNode);
}
const $623905a78283a229$var$RefSingleSelector = /*#__PURE__*/ $cQmXV.forwardRef($623905a78283a229$var$SingleSelector);
var $623905a78283a229$export$2e2bcd8739ae039 = $623905a78283a229$var$RefSingleSelector;



function $a3505183e38ac921$var$_extends() {
    $a3505183e38ac921$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a3505183e38ac921$var$_extends.apply(this, arguments);
}
// TODO: isInvalidateDate with showTime.disabledTime should not provide `range` prop
/** Internal usage. For cross function get same aligned props */ function $a3505183e38ac921$var$Picker(props, ref) {
    // ========================= Prop =========================
    const [filledProps, internalPicker, complexPicker, formatList, maskFormat, isInvalidateDate] = (0, $6f88bc1a75df9e02$export$2e2bcd8739ae039)(props);
    const { prefixCls: // Style
    prefixCls, rootClassName: rootClassName, styles: propStyles, classNames: propClassNames, previewValue: previewValue, order: // Value
    order, defaultValue: defaultValue, value: value, needConfirm: needConfirm, onChange: onChange, onClear: onClear, onKeyDown: onKeyDown, disabled: // Disabled
    disabled, disabledDate: disabledDate, minDate: minDate, maxDate: maxDate, defaultOpen: // Open
    defaultOpen, open: open, onOpenChange: onOpenChange, locale: // Picker
    locale, generateConfig: generateConfig, picker: picker, showNow: showNow, showToday: showToday, showTime: showTime, mode: // Mode
    mode, onPanelChange: onPanelChange, onCalendarChange: onCalendarChange, onOk: onOk, multiple: multiple, defaultPickerValue: // Picker Value
    defaultPickerValue, pickerValue: pickerValue, onPickerValueChange: onPickerValueChange, inputReadOnly: // Format
    inputReadOnly, suffixIcon: suffixIcon, removeIcon: removeIcon, tagRender: tagRender, onFocus: // Focus
    onFocus, onBlur: onBlur, presets: // Presets
    presets, components: // Render
    components, cellRender: cellRender, dateRender: dateRender, monthCellRender: monthCellRender, onClick: // Native
    onClick } = filledProps;
    // ========================= Refs =========================
    const selectorRef = (0, $e3a9d639e28d3613$export$2e2bcd8739ae039)(ref);
    const popupRef = $cQmXV.useRef(null);
    // ========================= Util =========================
    function pickerParam(values) {
        if (values === null) return null;
        return multiple ? values : values[0];
    }
    const toggleDates = (0, $e6951cd73102e980$export$2e2bcd8739ae039)(generateConfig, locale, internalPicker);
    // ======================= Semantic =======================
    const [mergedClassNames, mergedStyles] = (0, $f0ecc64b7db53c9d$export$2e2bcd8739ae039)(propClassNames, propStyles);
    // ========================= Open =========================
    const [mergedOpen, triggerOpen] = (0, $baa68117c464c322$export$2e2bcd8739ae039)(open, defaultOpen, [
        disabled
    ], onOpenChange);
    // ======================= Calendar =======================
    const onInternalCalendarChange = (dates, dateStrings, info)=>{
        if (onCalendarChange) {
            const filteredInfo = {
                ...info
            };
            delete filteredInfo.range;
            onCalendarChange(pickerParam(dates), pickerParam(dateStrings), filteredInfo);
        }
    };
    const onInternalOk = (dates)=>{
        onOk?.(pickerParam(dates));
    };
    // ======================== Values ========================
    const [mergedValue, setInnerValue, getCalendarValue, triggerCalendarChange, triggerOk] = (0, $546b4a1e52e84023$export$eef0e5a163935805)(generateConfig, locale, formatList, false, order, defaultValue, value, onInternalCalendarChange, onInternalOk);
    const calendarValue = getCalendarValue();
    // ======================== Focus =========================
    const isInternalPickerElement = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((element)=>(0, $3a79bd058cf8ac77$export$9bd4f980f61191a)(element, [
            selectorRef.current.nativeElement,
            popupRef.current
        ]));
    const [focused, onFieldFocus, onFieldBlur] = (0, $3a79bd058cf8ac77$export$2e2bcd8739ae039)(isInternalPickerElement, (_index, event)=>{
        onFocus?.(event, {});
    }, (_index, event)=>{
        onBlur?.(event, {});
    }, ()=>{
        triggerOpen(false);
    });
    // ========================= Mode =========================
    const [mergedMode, setMode] = (0, $a51866d781137e08$export$2e2bcd8739ae039)(picker, mode);
    /** Extends from `mergedMode` to patch `datetime` mode */ const internalMode = mergedMode === "date" && showTime ? "datetime" : mergedMode;
    // ======================= Show Now =======================
    const mergedShowNow = (0, $b81005c1d5a2d816$export$2e2bcd8739ae039)(picker, mergedMode, showNow, showToday);
    // ======================== Value =========================
    const onInternalChange = onChange && ((dates, dateStrings)=>{
        onChange(pickerParam(dates), pickerParam(dateStrings));
    });
    const [, /** Trigger `onChange` directly without check `disabledDate` */ triggerSubmitChange, /** Reset uncommitted values */ resetValue] = (0, $546b4a1e52e84023$export$2e2bcd8739ae039)({
        ...filledProps,
        onChange: onInternalChange
    }, mergedValue, setInnerValue, getCalendarValue, triggerCalendarChange, [], //disabled,
    formatList, isInvalidateDate);
    // Treat the complete SinglePicker value list as one field value. This keeps
    // multiple dates inside field `0` instead of exposing them as extra fields.
    // 将 SinglePicker 的整组值视为一个 field value；multiple 日期仍属于
    // field `0` 内部，不会被当成额外的 field。
    const getFieldCalendarValue = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)(()=>{
        const values = getCalendarValue();
        return [
            values.length ? values : null
        ];
    });
    const triggerFieldCalendarChange = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((_index, nextValues)=>{
        triggerCalendarChange(nextValues);
    });
    const flushFieldSubmit = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((_index, needTriggerChange)=>{
        if (needTriggerChange) {
            triggerSubmitChange(getCalendarValue());
            triggerOpen(false, {
                force: true
            });
        }
    });
    const resetFieldValue = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)(()=>{
        resetValue();
    });
    const [, activeIndex, , , triggerSingleValueChange, resetSingleValueChange] = (0, $9166225084aa8aea$export$2e2bcd8739ae039)(1, needConfirm, [
        false
    ], getFieldCalendarValue, triggerFieldCalendarChange, flushFieldSubmit, resetFieldValue);
    // Finalize the current interaction only after the popup is actually closed.
    // 仅在 popup 实际关闭后，统一收口当前交互。
    (0, $7673d874dab69d07$export$2e2bcd8739ae039)((firstMount)=>{
        if (!firstMount && !mergedOpen) triggerSingleValueChange(0, "popupClose");
    }, [
        mergedOpen
    ]);
    // ======================= Validate =======================
    const [submitInvalidates, onSelectorInvalid] = (0, $c696947bae675ffe$export$2e2bcd8739ae039)(calendarValue, isInvalidateDate);
    const submitInvalidate = $cQmXV.useMemo(()=>submitInvalidates.some((invalidated)=>invalidated), [
        submitInvalidates
    ]);
    // ===================== Picker Value =====================
    // Proxy to single pickerValue
    const onInternalPickerValueChange = (dates, info)=>{
        if (onPickerValueChange) {
            const cleanInfo = {
                ...info,
                mode: info.mode[0]
            };
            delete cleanInfo.range;
            onPickerValueChange(dates[0], cleanInfo);
        }
    };
    const [currentPickerValue, setCurrentPickerValue] = (0, $58210ec7ad711cce$export$2e2bcd8739ae039)(generateConfig, locale, calendarValue, [
        mergedMode
    ], mergedOpen, false, activeIndex, internalPicker, false, // multiplePanel,
    defaultPickerValue, pickerValue, (0, $03e7a71a94f7692c$export$45b10814cc054894)(showTime?.defaultOpenValue), onInternalPickerValueChange, minDate, maxDate);
    // >>> Mode need wait for `pickerValue`
    const triggerModeChange = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((nextPickerValue, nextMode, triggerEvent)=>{
        setMode(nextMode);
        // Compatible with `onPanelChange`
        if (onPanelChange && triggerEvent !== false) {
            const lastPickerValue = nextPickerValue || calendarValue[calendarValue.length - 1];
            onPanelChange(lastPickerValue, nextMode);
        }
    });
    // ======================== Submit ========================
    /**
   * Submit the complete value list stored in SinglePicker field `0`.
   * 提交 SinglePicker field `0` 内保存的整组值。
   */ const triggerConfirm = (source = "confirm")=>{
        triggerSingleValueChange(0, source);
    };
    // ======================== Click =========================
    const onSelectorClick = (event)=>{
        if (!disabled && !selectorRef.current.nativeElement.contains(document.activeElement)) // Click to focus the enabled input
        selectorRef.current.focus();
        triggerOpen(true);
        onClick?.(event);
    };
    const onSelectorClear = ()=>{
        resetSingleValueChange();
        triggerSubmitChange(null);
        triggerOpen(false, {
            force: true
        });
        selectorRef.current.focus();
        onClear?.();
    };
    // ======================== Hover =========================
    const [hoverSource, setHoverSource] = $cQmXV.useState(null);
    const [internalHoverValue, setInternalHoverValue] = $cQmXV.useState(null);
    const hoverValues = $cQmXV.useMemo(()=>{
        const values = [
            internalHoverValue,
            ...calendarValue
        ].filter((date)=>date);
        return multiple ? values : values.slice(0, 1);
    }, [
        calendarValue,
        internalHoverValue,
        multiple
    ]);
    // Selector values is different with RangePicker
    // which can not use `hoverValue` directly
    const selectorValues = $cQmXV.useMemo(()=>{
        if (!multiple && internalHoverValue) return [
            internalHoverValue
        ];
        return calendarValue.filter((date)=>date);
    }, [
        calendarValue,
        internalHoverValue,
        multiple
    ]);
    // Clean up `internalHoverValues` when closed
    $cQmXV.useEffect(()=>{
        if (!mergedOpen) setInternalHoverValue(null);
    }, [
        mergedOpen
    ]);
    const onSetHover = (date, source)=>{
        if (previewValue !== "hover") return;
        setInternalHoverValue(date);
        setHoverSource(source);
    };
    // ========================================================
    // ==                       Panels                       ==
    // ========================================================
    // ======================= Presets ========================
    const presetList = (0, $58fb6cd5d787b224$export$2e2bcd8739ae039)(presets);
    const onPresetHover = (nextValue)=>{
        onSetHover(nextValue, "preset");
    };
    // TODO: handle this
    const onPresetSubmit = (nextValue)=>{
        const nextCalendarValues = multiple ? toggleDates(getCalendarValue(), nextValue) : [
            nextValue
        ];
        const passed = triggerSubmitChange(nextCalendarValues);
        if (passed && !multiple) triggerOpen(false, {
            force: true
        });
    };
    const onNow = (now)=>{
        onPresetSubmit(now);
    };
    // ======================== Panel =========================
    const onPanelHover = (date)=>{
        onSetHover(date, "cell");
    };
    // >>> Focus
    const onPanelFocus = (event)=>{
        triggerOpen(true);
        onFieldFocus(0, "panel", event);
    };
    // >>> Calendar
    const onPanelSelect = (date)=>{
        // Not change values if multiple and current panel is to match with picker
        if (multiple && internalMode !== picker) return;
        const nextValues = multiple ? toggleDates(getCalendarValue(), date) : [
            date
        ];
        const panelFinished = !complexPicker && internalPicker === internalMode;
        triggerSingleValueChange(0, panelFinished ? "panel-final" : "panel-intermediate", nextValues);
    };
    // >>> Close
    const onPopupClose = ()=>{
        // Close popup
        triggerOpen(false);
    };
    // >>> cellRender
    const onInternalCellRender = (0, $86c2958c1a46dbcf$export$2e2bcd8739ae039)(cellRender, dateRender, monthCellRender);
    // >>> invalid
    const panelProps = $cQmXV.useMemo(()=>{
        const domProps = (0, $4b5c733d1d7bb306$export$2e2bcd8739ae039)(filledProps, false);
        const restProps = (0, $e8c5093aebad6025$export$2e2bcd8739ae039)(filledProps, [
            ...Object.keys(domProps),
            "onChange",
            "onCalendarChange",
            "onClear",
            "style",
            "className",
            "onPanelChange",
            "classNames",
            "styles"
        ]);
        return {
            ...restProps,
            multiple: filledProps.multiple
        };
    }, [
        filledProps
    ]);
    // >>> Render
    const panel = /*#__PURE__*/ $cQmXV.createElement((0, $bee4a9c24fa7de8c$export$2e2bcd8739ae039), $a3505183e38ac921$var$_extends({
        containerRef: popupRef
    }, panelProps, {
        showNow: mergedShowNow,
        showTime: showTime,
        disabledDate: disabledDate,
        onFocus: onPanelFocus,
        onBlur: (event)=>onFieldBlur(0, "panel", event),
        picker: picker,
        mode: mergedMode,
        internalMode: internalMode,
        onPanelChange: triggerModeChange,
        format: maskFormat,
        value: calendarValue,
        isInvalid: isInvalidateDate,
        onChange: null,
        onSelect: onPanelSelect,
        pickerValue: currentPickerValue,
        defaultOpenValue: showTime?.defaultOpenValue,
        onPickerValueChange: setCurrentPickerValue,
        hoverValue: hoverValues,
        onHover: onPanelHover,
        needConfirm: needConfirm,
        onSubmit: ()=>triggerConfirm("confirm"),
        onOk: triggerOk,
        presets: presetList,
        onPresetHover: onPresetHover,
        onPresetSubmit: onPresetSubmit,
        onNow: onNow,
        cellRender: onInternalCellRender,
        classNames: mergedClassNames,
        styles: mergedStyles
    }));
    // ========================================================
    // ==                      Selector                      ==
    // ========================================================
    // ======================== Change ========================
    const onSelectorChange = (date, source = "input")=>{
        triggerSingleValueChange(0, source, date);
    };
    const onSelectorInputChange = ()=>{
        triggerSingleValueChange(0, "input");
    };
    // ======================= Selector =======================
    const onSelectorFocus = (event)=>{
        triggerSingleValueChange(0, "field-switch");
        triggerOpen(true, {
            inherit: true
        });
        onFieldFocus(0, "input", event);
    };
    const onSelectorBlur = (event)=>{
        onFieldBlur(0, "input", event);
    };
    const onSelectorKeyDown = (event, preventDefault)=>{
        if (event.key === "Tab") triggerConfirm("keyboard-submit-weak");
        else if (event.key === "Escape") {
            triggerSingleValueChange(0, "esc");
            triggerOpen(false);
        }
        onKeyDown?.(event, preventDefault);
    };
    // ======================= Context ========================
    const context = $cQmXV.useMemo(()=>({
            prefixCls: prefixCls,
            locale: locale,
            generateConfig: generateConfig,
            button: components.button,
            input: components.input,
            classNames: mergedClassNames,
            styles: mergedStyles
        }), [
        prefixCls,
        locale,
        generateConfig,
        components.button,
        components.input,
        mergedClassNames,
        mergedStyles
    ]);
    // ======================== Effect ========================
    // >>> Mode
    // Reset for every active
    (0, $7673d874dab69d07$export$2e2bcd8739ae039)(()=>{
        if (mergedOpen && activeIndex !== undefined) // Legacy compatible. This effect update should not trigger `onPanelChange`
        triggerModeChange(null, picker, false);
    }, [
        mergedOpen,
        activeIndex,
        picker
    ]);
    // ======================== Render ========================
    return /*#__PURE__*/ $cQmXV.createElement((0, $8ffb82fb472fb634$export$2e2bcd8739ae039).Provider, {
        value: context
    }, /*#__PURE__*/ $cQmXV.createElement((0, $65f9edc43638c2a4$export$2e2bcd8739ae039), $a3505183e38ac921$var$_extends({}, (0, $d366afafb0a5ce51$export$a11cc4b953869c91)(filledProps), {
        popupElement: panel,
        popupStyle: mergedStyles.popup.root,
        popupClassName: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(rootClassName, mergedClassNames.popup.root),
        visible: mergedOpen,
        onClose: onPopupClose
    }), /*#__PURE__*/ $cQmXV.createElement((0, $623905a78283a229$export$2e2bcd8739ae039), $a3505183e38ac921$var$_extends({}, filledProps, {
        // Ref
        ref: selectorRef,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(filledProps.className, rootClassName, mergedClassNames.root),
        style: {
            ...mergedStyles.root,
            ...filledProps.style
        },
        suffixIcon: suffixIcon,
        removeIcon: removeIcon,
        tagRender: tagRender,
        activeHelp: !!internalHoverValue,
        allHelp: !!internalHoverValue && hoverSource === "preset",
        focused: focused,
        onFocus: onSelectorFocus,
        onBlur: onSelectorBlur,
        onKeyDown: onSelectorKeyDown,
        onSubmit: ()=>triggerConfirm("keyboard-submit"),
        value: selectorValues,
        maskFormat: maskFormat,
        onChange: onSelectorChange,
        onInputChange: onSelectorInputChange,
        internalPicker: internalPicker,
        format: formatList,
        inputReadOnly: inputReadOnly,
        disabled: disabled,
        open: mergedOpen,
        onOpenChange: triggerOpen,
        onClick: onSelectorClick,
        onClear: onSelectorClear,
        invalid: submitInvalidate,
        onInvalid: (invalid)=>{
            // Only `single` mode support type date.
            // `multiple` mode can not typing.
            onSelectorInvalid(invalid, 0);
        }
    }))));
}
const $a3505183e38ac921$var$RefPicker = /*#__PURE__*/ $cQmXV.forwardRef($a3505183e38ac921$var$Picker);
var $a3505183e38ac921$export$2e2bcd8739ae039 = $a3505183e38ac921$var$RefPicker;



var $e0426c0b99a67cdf$export$2e2bcd8739ae039 = (0, $a3505183e38ac921$export$2e2bcd8739ae039);


















var $cQmXV = parcelRequire("cQmXV");



const $c99d904af5883383$var$useMergedPickerSemantic = (pickerType, classNames, styles, popupClassName, popupStyle, mergedProps, contextStyle)=>{
    const { classNames: contextClassNames, style: componentContextStyle, styles: contextStyles } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)(pickerType);
    const mergedContextStyle = contextStyle === null ? undefined : contextStyle ?? componentContextStyle;
    const contextStyleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(mergedContextStyle);
    const [mergedClassNames, mergedStyles] = (0, $30c5f9f911d4f61b$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles
    ], {
        props: mergedProps
    }, {
        popup: {
            _default: "root"
        }
    });
    return $cQmXV.useMemo(()=>{
        // ClassNames
        const filledClassNames = {
            ...mergedClassNames,
            popup: {
                ...mergedClassNames.popup,
                root: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(mergedClassNames.popup?.root, popupClassName)
            }
        };
        // Styles
        const filledStyles = {
            ...mergedStyles,
            popup: {
                ...mergedStyles.popup,
                root: {
                    ...mergedStyles.popup?.root,
                    ...popupStyle
                }
            }
        };
        // Return
        return [
            filledClassNames,
            filledStyles
        ];
    }, [
        mergedClassNames,
        mergedStyles,
        popupClassName,
        popupStyle
    ]);
};
var $c99d904af5883383$export$2e2bcd8739ae039 = $c99d904af5883383$var$useMergedPickerSemantic;
















const $3a825003773eff12$export$aaa3604bfe071829 = (token)=>{
    const { multipleSelectItemHeight: multipleSelectItemHeight, paddingXXS: paddingXXS, lineWidth: lineWidth, INTERNAL_FIXED_ITEM_MARGIN: INTERNAL_FIXED_ITEM_MARGIN } = token;
    const basePadding = token.max(token.calc(paddingXXS).sub(lineWidth).equal(), 0);
    const containerPadding = token.max(token.calc(basePadding).sub(INTERNAL_FIXED_ITEM_MARGIN).equal(), 0);
    return {
        basePadding: basePadding,
        containerPadding: containerPadding,
        itemHeight: (0, $05f34ed03d41967d$export$523c0b569236b342)(multipleSelectItemHeight),
        itemLineHeight: (0, $05f34ed03d41967d$export$523c0b569236b342)(token.calc(multipleSelectItemHeight).sub(token.calc(token.lineWidth).mul(2)).equal())
    };
};
const $3a825003773eff12$export$b4ab9d1500d7d856 = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, borderRadiusSM: borderRadiusSM, motionDurationSlow: motionDurationSlow, paddingXS: paddingXS, multipleItemColorDisabled: multipleItemColorDisabled, multipleItemBorderColorDisabled: multipleItemBorderColorDisabled, colorIcon: colorIcon, colorIconHover: colorIconHover, INTERNAL_FIXED_ITEM_MARGIN: INTERNAL_FIXED_ITEM_MARGIN } = token;
    const selectOverflowPrefixCls = `${componentCls}-selection-overflow`;
    return {
        /**
     * Do not merge `height` & `line-height` under style with `selection` & `search`, since chrome
     * may update to redesign with its align logic.
     */ // =========================== Overflow ===========================
        [selectOverflowPrefixCls]: {
            position: "relative",
            display: "flex",
            flex: "auto",
            flexWrap: "wrap",
            maxWidth: "100%",
            "&-item": {
                flex: "none",
                alignSelf: "center",
                // https://github.com/ant-design/ant-design/issues/54179
                maxWidth: "calc(100% - 4px)",
                display: "inline-flex"
            },
            // ======================== Selections ==========================
            [`${componentCls}-selection-item`]: {
                display: "flex",
                alignSelf: "center",
                flex: "none",
                boxSizing: "border-box",
                maxWidth: "100%",
                marginBlock: INTERNAL_FIXED_ITEM_MARGIN,
                borderRadius: borderRadiusSM,
                cursor: "default",
                transition: [
                    `font-size`,
                    `line-height`,
                    `height`
                ].map((prop)=>`${prop} ${motionDurationSlow}`).join(", "),
                marginInlineEnd: token.calc(INTERNAL_FIXED_ITEM_MARGIN).mul(2).equal(),
                paddingInlineStart: paddingXS,
                paddingInlineEnd: token.calc(paddingXS).div(2).equal(),
                [`${componentCls}-disabled&`]: {
                    color: multipleItemColorDisabled,
                    borderColor: multipleItemBorderColorDisabled,
                    cursor: "not-allowed"
                },
                // It's ok not to do this, but 24px makes bottom narrow in view should adjust
                "&-content": {
                    display: "inline-block",
                    marginInlineEnd: token.calc(paddingXS).div(2).equal(),
                    overflow: "hidden",
                    whiteSpace: "pre",
                    // fix whitespace wrapping. custom tags display all whitespace within.
                    textOverflow: "ellipsis"
                },
                "&-remove": {
                    ...(0, $519d20bf207ce864$export$171ccda7bc085e59)(),
                    display: "inline-flex",
                    alignItems: "center",
                    color: colorIcon,
                    fontWeight: "bold",
                    fontSize: 10,
                    lineHeight: "inherit",
                    cursor: "pointer",
                    [`> ${iconCls}`]: {
                        verticalAlign: "-0.2em"
                    },
                    "&:hover": {
                        color: colorIconHover
                    }
                }
            }
        }
    };
};


const $166c10224ea771ce$var$genSize = (token, suffix)=>{
    const { componentCls: componentCls, controlHeight: controlHeight } = token;
    const suffixCls = suffix ? `${componentCls}-${suffix}` : "";
    const multipleSelectorUnit = (0, $3a825003773eff12$export$aaa3604bfe071829)(token);
    return [
        // genSelectionStyle(token, suffix),
        {
            [`${componentCls}-multiple${suffixCls}`]: {
                paddingBlock: multipleSelectorUnit.containerPadding,
                paddingInlineStart: multipleSelectorUnit.basePadding,
                minHeight: controlHeight,
                // ======================== Selections ========================
                [`${componentCls}-selection-item`]: {
                    height: multipleSelectorUnit.itemHeight,
                    lineHeight: (0, $05f34ed03d41967d$export$523c0b569236b342)(multipleSelectorUnit.itemLineHeight)
                }
            }
        }
    ];
};
const $166c10224ea771ce$var$genPickerMultipleStyle = (token)=>{
    const { componentCls: componentCls, calc: calc, lineWidth: lineWidth } = token;
    const smallToken = (0, $fef50f256b80dfa5$export$4950aa0f605343fb)(token, {
        fontHeight: token.fontSize,
        selectHeight: token.controlHeightSM,
        multipleSelectItemHeight: token.multipleItemHeightSM,
        borderRadius: token.borderRadiusSM,
        borderRadiusSM: token.borderRadiusXS,
        controlHeight: token.controlHeightSM
    });
    const largeToken = (0, $fef50f256b80dfa5$export$4950aa0f605343fb)(token, {
        fontHeight: calc(token.multipleItemHeightLG).sub(calc(lineWidth).mul(2).equal()).equal(),
        fontSize: token.fontSizeLG,
        selectHeight: token.controlHeightLG,
        multipleSelectItemHeight: token.multipleItemHeightLG,
        borderRadius: token.borderRadiusLG,
        borderRadiusSM: token.borderRadius,
        controlHeight: token.controlHeightLG
    });
    return [
        // ======================== Size ========================
        $166c10224ea771ce$var$genSize(smallToken, "small"),
        $166c10224ea771ce$var$genSize(token),
        $166c10224ea771ce$var$genSize(largeToken, "large"),
        // ====================== Selection ======================
        {
            [`${componentCls}${componentCls}-multiple`]: {
                width: "100%",
                cursor: "text",
                // ==================== Selector =====================
                [`${componentCls}-selector`]: {
                    flex: "auto",
                    padding: 0,
                    position: "relative",
                    "&:after": {
                        margin: 0
                    },
                    // ================== placeholder ==================
                    [`${componentCls}-selection-placeholder`]: {
                        position: "absolute",
                        top: "50%",
                        insetInlineStart: token.inputPaddingHorizontalBase,
                        insetInlineEnd: 0,
                        transform: "translateY(-50%)",
                        transition: `all ${token.motionDurationSlow}`,
                        flex: 1,
                        color: token.colorTextPlaceholder,
                        pointerEvents: "none",
                        ...(0, $519d20bf207ce864$export$b2b65df0d0824629)
                    }
                },
                // ===================== Overflow ====================
                ...(0, $3a825003773eff12$export$b4ab9d1500d7d856)(token),
                // ====================== Input ======================
                // Input is `readonly`, which is used for a11y only
                [`${componentCls}-multiple-input`]: {
                    width: 0,
                    height: 0,
                    border: 0,
                    visibility: "hidden",
                    position: "absolute",
                    zIndex: -1
                }
            }
        }
    ];
};
var $166c10224ea771ce$export$2e2bcd8739ae039 = $166c10224ea771ce$var$genPickerMultipleStyle;




const $df004891b355597c$var$genPickerCellInnerStyle = (token)=>{
    const { pickerCellCls: pickerCellCls, pickerCellInnerCls: pickerCellInnerCls, cellHeight: cellHeight, borderRadiusSM: borderRadiusSM, motionDurationMid: motionDurationMid, cellHoverBg: cellHoverBg, lineWidth: lineWidth, lineType: lineType, colorPrimary: colorPrimary, cellActiveWithRangeBg: cellActiveWithRangeBg, colorTextLightSolid: colorTextLightSolid, colorTextDisabled: colorTextDisabled, cellBgDisabled: cellBgDisabled, colorFillSecondary: colorFillSecondary } = token;
    return {
        "&::before": {
            position: "absolute",
            top: "50%",
            insetInlineStart: 0,
            insetInlineEnd: 0,
            zIndex: 1,
            height: cellHeight,
            transform: "translateY(-50%)",
            content: '""',
            pointerEvents: "none"
        },
        // >>> Default
        [pickerCellInnerCls]: {
            position: "relative",
            zIndex: 2,
            display: "inline-block",
            minWidth: cellHeight,
            height: cellHeight,
            lineHeight: (0, $05f34ed03d41967d$export$523c0b569236b342)(cellHeight),
            borderRadius: borderRadiusSM,
            transition: `background-color ${motionDurationMid}`
        },
        // >>> Hover
        [`&:hover:not(${pickerCellCls}-in-view):not(${pickerCellCls}-disabled),
    &:hover:not(${pickerCellCls}-selected):not(${pickerCellCls}-range-start):not(${pickerCellCls}-range-end):not(${pickerCellCls}-disabled)`]: {
            [pickerCellInnerCls]: {
                background: cellHoverBg
            }
        },
        // >>> Today
        [`&-in-view${pickerCellCls}-today ${pickerCellInnerCls}`]: {
            "&::before": {
                position: "absolute",
                top: 0,
                insetInlineEnd: 0,
                bottom: 0,
                insetInlineStart: 0,
                zIndex: 1,
                border: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(lineWidth)} ${lineType} ${colorPrimary}`,
                borderRadius: borderRadiusSM,
                content: '""'
            }
        },
        // >>> In Range
        [`&-in-view${pickerCellCls}-in-range,
      &-in-view${pickerCellCls}-range-start,
      &-in-view${pickerCellCls}-range-end`]: {
            position: "relative",
            [`&:not(${pickerCellCls}-disabled):before`]: {
                background: cellActiveWithRangeBg
            }
        },
        // >>> Selected
        [`&-in-view${pickerCellCls}-selected,
      &-in-view${pickerCellCls}-range-start,
      &-in-view${pickerCellCls}-range-end`]: {
            [`&:not(${pickerCellCls}-disabled) ${pickerCellInnerCls}`]: {
                color: colorTextLightSolid,
                background: colorPrimary
            },
            [`&${pickerCellCls}-disabled ${pickerCellInnerCls}`]: {
                background: colorFillSecondary
            }
        },
        [`&-in-view${pickerCellCls}-range-start:not(${pickerCellCls}-disabled):before`]: {
            insetInlineStart: "50%"
        },
        [`&-in-view${pickerCellCls}-range-end:not(${pickerCellCls}-disabled):before`]: {
            insetInlineEnd: "50%"
        },
        // range start border-radius
        [`&-in-view${pickerCellCls}-range-start:not(${pickerCellCls}-range-end) ${pickerCellInnerCls}`]: {
            borderStartStartRadius: borderRadiusSM,
            borderEndStartRadius: borderRadiusSM,
            borderStartEndRadius: 0,
            borderEndEndRadius: 0
        },
        // range end border-radius
        [`&-in-view${pickerCellCls}-range-end:not(${pickerCellCls}-range-start) ${pickerCellInnerCls}`]: {
            borderStartStartRadius: 0,
            borderEndStartRadius: 0,
            borderStartEndRadius: borderRadiusSM,
            borderEndEndRadius: borderRadiusSM
        },
        // >>> Disabled
        "&-disabled": {
            color: colorTextDisabled,
            cursor: "not-allowed",
            [pickerCellInnerCls]: {
                background: "transparent"
            },
            "&::before": {
                background: cellBgDisabled
            }
        },
        [`&-disabled${pickerCellCls}-today ${pickerCellInnerCls}::before`]: {
            borderColor: colorTextDisabled
        }
    };
};
const $df004891b355597c$export$da5309fdba1a1b64 = (token)=>{
    const { componentCls: componentCls, pickerCellCls: pickerCellCls, pickerCellInnerCls: pickerCellInnerCls, pickerYearMonthCellWidth: pickerYearMonthCellWidth, pickerControlIconSize: pickerControlIconSize, cellWidth: cellWidth, paddingSM: paddingSM, paddingXS: paddingXS, paddingXXS: paddingXXS, colorBgContainer: colorBgContainer, lineWidth: lineWidth, lineType: lineType, borderRadiusLG: borderRadiusLG, colorPrimary: colorPrimary, colorTextHeading: colorTextHeading, colorSplit: colorSplit, pickerControlIconBorderWidth: pickerControlIconBorderWidth, colorIcon: colorIcon, textHeight: textHeight, motionDurationMid: motionDurationMid, colorIconHover: colorIconHover, fontWeightStrong: fontWeightStrong, cellHeight: cellHeight, pickerCellPaddingVertical: pickerCellPaddingVertical, colorTextDisabled: colorTextDisabled, colorText: colorText, fontSize: fontSize, motionDurationSlow: motionDurationSlow, withoutTimeCellHeight: withoutTimeCellHeight, pickerQuarterPanelContentHeight: pickerQuarterPanelContentHeight, borderRadiusSM: borderRadiusSM, colorTextLightSolid: colorTextLightSolid, cellHoverBg: cellHoverBg, timeColumnHeight: timeColumnHeight, timeColumnWidth: timeColumnWidth, timeCellHeight: timeCellHeight, controlItemBgActive: controlItemBgActive, marginXXS: marginXXS, pickerDatePanelPaddingHorizontal: pickerDatePanelPaddingHorizontal, pickerControlIconMargin: pickerControlIconMargin } = token;
    const pickerPanelWidth = token.calc(cellWidth).mul(7).add(token.calc(pickerDatePanelPaddingHorizontal).mul(2)).equal();
    return {
        [componentCls]: {
            "&-panel": {
                display: "inline-flex",
                flexDirection: "column",
                textAlign: "center",
                background: colorBgContainer,
                borderRadius: borderRadiusLG,
                outline: "none",
                "&-focused": {
                    borderColor: colorPrimary
                },
                "&-rtl": {
                    [`${componentCls}-prev-icon,
              ${componentCls}-super-prev-icon`]: {
                        transform: "rotate(45deg)"
                    },
                    [`${componentCls}-next-icon,
              ${componentCls}-super-next-icon`]: {
                        transform: "rotate(-135deg)"
                    },
                    [`${componentCls}-time-panel`]: {
                        [`${componentCls}-content`]: {
                            direction: "ltr",
                            "> *": {
                                direction: "rtl"
                            }
                        }
                    }
                }
            },
            // ========================================================
            // =                     Shared Panel                     =
            // ========================================================
            "&-decade-panel, &-year-panel, &-quarter-panel, &-month-panel, &-week-panel, &-date-panel, &-time-panel": {
                display: "flex",
                flexDirection: "column",
                width: pickerPanelWidth
            },
            // ======================= Header =======================
            "&-header": {
                display: "flex",
                padding: `0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(paddingXS)}`,
                color: colorTextHeading,
                borderBottom: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(lineWidth)} ${lineType} ${colorSplit}`,
                "> *": {
                    flex: "none"
                },
                button: {
                    padding: 0,
                    color: colorIcon,
                    lineHeight: (0, $05f34ed03d41967d$export$523c0b569236b342)(textHeight),
                    background: "transparent",
                    border: 0,
                    cursor: "pointer",
                    transition: `color ${motionDurationMid}`,
                    fontSize: "inherit",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    "&:empty": {
                        display: "none"
                    }
                },
                "> button": {
                    minWidth: "1.6em",
                    fontSize: fontSize,
                    "&:hover": {
                        color: colorIconHover
                    },
                    "&:disabled": {
                        opacity: 0.25,
                        pointerEvents: "none"
                    }
                },
                "&-view": {
                    flex: "auto",
                    fontWeight: fontWeightStrong,
                    lineHeight: (0, $05f34ed03d41967d$export$523c0b569236b342)(textHeight),
                    "> button": {
                        color: "inherit",
                        fontWeight: "inherit",
                        verticalAlign: "top",
                        "&:not(:first-child)": {
                            marginInlineStart: paddingXS
                        },
                        "&:hover": {
                            color: colorPrimary
                        }
                    }
                }
            },
            // Arrow button
            "&-prev-icon, &-next-icon, &-super-prev-icon, &-super-next-icon": {
                position: "relative",
                width: pickerControlIconSize,
                height: pickerControlIconSize,
                "&::before": {
                    position: "absolute",
                    top: 0,
                    insetInlineStart: 0,
                    width: pickerControlIconSize,
                    height: pickerControlIconSize,
                    border: `0 solid currentcolor`,
                    borderBlockStartWidth: pickerControlIconBorderWidth,
                    borderInlineStartWidth: pickerControlIconBorderWidth,
                    content: '""'
                }
            },
            "&-super-prev-icon, &-super-next-icon": {
                "&::after": {
                    position: "absolute",
                    top: pickerControlIconMargin,
                    insetInlineStart: pickerControlIconMargin,
                    display: "inline-block",
                    width: pickerControlIconSize,
                    height: pickerControlIconSize,
                    border: "0 solid currentcolor",
                    borderBlockStartWidth: pickerControlIconBorderWidth,
                    borderInlineStartWidth: pickerControlIconBorderWidth,
                    content: '""'
                }
            },
            "&-prev-icon, &-super-prev-icon": {
                transform: "rotate(-45deg)"
            },
            "&-next-icon, &-super-next-icon": {
                transform: "rotate(135deg)"
            },
            // ======================== Body ========================
            "&-content": {
                width: "100%",
                tableLayout: "fixed",
                borderCollapse: "collapse",
                "th, td": {
                    position: "relative",
                    minWidth: cellHeight,
                    fontWeight: "normal"
                },
                th: {
                    height: token.calc(cellHeight).add(token.calc(pickerCellPaddingVertical).mul(2)).equal(),
                    color: colorText,
                    verticalAlign: "middle"
                }
            },
            "&-cell": {
                padding: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(pickerCellPaddingVertical)} 0`,
                color: colorTextDisabled,
                cursor: "pointer",
                // In view
                "&-in-view": {
                    color: colorText
                },
                ...$df004891b355597c$var$genPickerCellInnerStyle(token)
            },
            "&-decade-panel, &-year-panel, &-quarter-panel, &-month-panel": {
                [`${componentCls}-content`]: {
                    height: token.calc(withoutTimeCellHeight).mul(4).equal()
                },
                [pickerCellInnerCls]: {
                    padding: `0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(paddingXS)}`
                }
            },
            "&-quarter-panel": {
                [`${componentCls}-content`]: {
                    height: pickerQuarterPanelContentHeight
                }
            },
            // ========================================================
            // =                       Special                        =
            // ========================================================
            // ===================== Decade Panel =====================
            "&-decade-panel": {
                [pickerCellInnerCls]: {
                    padding: `0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.calc(paddingXS).div(2).equal())}`
                },
                [`${componentCls}-cell::before`]: {
                    display: "none"
                }
            },
            // ============= Year & Quarter & Month Panel =============
            "&-year-panel, &-quarter-panel, &-month-panel": {
                [`${componentCls}-body`]: {
                    padding: `0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(paddingXS)}`
                },
                [pickerCellInnerCls]: {
                    width: pickerYearMonthCellWidth
                }
            },
            // ====================== Date Panel ======================
            "&-date-panel": {
                [`${componentCls}-body`]: {
                    padding: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(paddingXS)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(pickerDatePanelPaddingHorizontal)}`
                },
                [`${componentCls}-content th`]: {
                    boxSizing: "border-box",
                    padding: 0
                }
            },
            // ====================== Week Panel ======================
            "&-week-panel-row": {
                td: {
                    "&:before": {
                        transition: `background-color ${motionDurationMid}`
                    },
                    "&:first-child:before": {
                        borderStartStartRadius: borderRadiusSM,
                        borderEndStartRadius: borderRadiusSM
                    },
                    "&:last-child:before": {
                        borderStartEndRadius: borderRadiusSM,
                        borderEndEndRadius: borderRadiusSM
                    }
                },
                "&:hover td:before": {
                    background: cellHoverBg
                },
                "&-range-start td, &-range-end td, &-selected td, &-hover td": {
                    // Rise priority to override hover style
                    [`&${pickerCellCls}`]: {
                        "&:before": {
                            background: colorPrimary
                        },
                        [`&${componentCls}-cell-week`]: {
                            color: new (0, $3bb84f07fb2a2f32$export$2c4f38d6c0ecc25a)(colorTextLightSolid).setA(0.5).toHexString()
                        },
                        [pickerCellInnerCls]: {
                            color: colorTextLightSolid
                        }
                    }
                },
                "&-range-hover td:before": {
                    background: controlItemBgActive
                }
            },
            // >>> ShowWeek
            "&-week-panel, &-date-panel-show-week": {
                [`${componentCls}-body`]: {
                    padding: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(paddingXS)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(paddingSM)}`
                },
                [`${componentCls}-content th`]: {
                    width: "auto"
                }
            },
            // ==================== Datetime Panel ====================
            "&-datetime-panel": {
                display: "flex",
                [`${componentCls}-time-panel`]: {
                    borderInlineStart: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(lineWidth)} ${lineType} ${colorSplit}`
                },
                [`${componentCls}-date-panel,
          ${componentCls}-time-panel`]: {
                    transition: `opacity ${motionDurationSlow}`
                },
                // Keyboard
                "&-active": {
                    [`${componentCls}-date-panel,
            ${componentCls}-time-panel`]: {
                        opacity: 0.3,
                        "&-active": {
                            opacity: 1
                        }
                    }
                }
            },
            // ====================== Time Panel ======================
            "&-time-panel": {
                width: "auto",
                minWidth: "auto",
                [`${componentCls}-content`]: {
                    display: "flex",
                    flex: "auto",
                    height: timeColumnHeight
                },
                "&-column": {
                    flex: "1 0 auto",
                    width: timeColumnWidth,
                    margin: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(paddingXXS)} 0`,
                    padding: 0,
                    overflowY: "auto",
                    textAlign: "start",
                    listStyle: "none",
                    transition: `background-color ${motionDurationMid}`,
                    overflowX: "hidden",
                    "&::-webkit-scrollbar": {
                        width: 8,
                        backgroundColor: "transparent"
                    },
                    "&::-webkit-scrollbar-thumb": {
                        backgroundColor: token.colorTextTertiary,
                        borderRadius: token.borderRadiusSM
                    },
                    // For Firefox
                    "&": {
                        scrollbarWidth: "thin",
                        scrollbarColor: `${token.colorTextTertiary} transparent`
                    },
                    "&::after": {
                        display: "block",
                        height: `calc(100% - ${(0, $05f34ed03d41967d$export$523c0b569236b342)(timeCellHeight)})`,
                        content: '""'
                    },
                    "&:not(:first-child)": {
                        borderInlineStart: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(lineWidth)} ${lineType} ${colorSplit}`
                    },
                    "&-active": {
                        background: new (0, $3bb84f07fb2a2f32$export$2c4f38d6c0ecc25a)(controlItemBgActive).setA(0.2).toHexString()
                    },
                    "> li": {
                        margin: 0,
                        padding: 0,
                        [`&${componentCls}-time-panel-cell`]: {
                            marginInline: marginXXS,
                            [`${componentCls}-time-panel-cell-inner`]: {
                                display: "block",
                                width: token.calc(timeColumnWidth).sub(token.calc(marginXXS).mul(2)).equal(),
                                height: timeCellHeight,
                                margin: 0,
                                paddingBlock: 0,
                                paddingInlineEnd: 0,
                                paddingInlineStart: token.calc(timeColumnWidth).sub(timeCellHeight).div(2).equal(),
                                color: colorText,
                                lineHeight: (0, $05f34ed03d41967d$export$523c0b569236b342)(timeCellHeight),
                                borderRadius: borderRadiusSM,
                                cursor: "pointer",
                                transition: `background-color ${motionDurationMid}`,
                                "&:hover": {
                                    background: cellHoverBg
                                }
                            },
                            "&-selected": {
                                [`${componentCls}-time-panel-cell-inner`]: {
                                    background: controlItemBgActive
                                }
                            },
                            "&-disabled": {
                                [`${componentCls}-time-panel-cell-inner`]: {
                                    color: colorTextDisabled,
                                    background: "transparent",
                                    cursor: "not-allowed"
                                }
                            }
                        }
                    }
                }
            }
        }
    };
};
const $df004891b355597c$var$genPickerPanelStyle = (token)=>{
    const { componentCls: componentCls, textHeight: textHeight, lineWidth: lineWidth, paddingSM: paddingSM, antCls: antCls, colorPrimary: colorPrimary, cellActiveWithRangeBg: cellActiveWithRangeBg, colorPrimaryBorder: colorPrimaryBorder, lineType: lineType, colorSplit: colorSplit } = token;
    return {
        [`${componentCls}-dropdown`]: {
            // ======================== Footer ========================
            [`${componentCls}-footer`]: {
                borderTop: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(lineWidth)} ${lineType} ${colorSplit}`,
                "&-extra": {
                    padding: `0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(paddingSM)}`,
                    lineHeight: (0, $05f34ed03d41967d$export$523c0b569236b342)(token.calc(textHeight).sub(token.calc(lineWidth).mul(2)).equal()),
                    textAlign: "start",
                    "&:not(:last-child)": {
                        borderBottom: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(lineWidth)} ${lineType} ${colorSplit}`
                    }
                }
            },
            // ==================== Footer > Ranges ===================
            [`${componentCls}-panels + ${componentCls}-footer ${componentCls}-ranges`]: {
                justifyContent: "space-between"
            },
            [`${componentCls}-ranges`]: {
                marginBlock: 0,
                paddingInline: (0, $05f34ed03d41967d$export$523c0b569236b342)(paddingSM),
                overflow: "hidden",
                textAlign: "start",
                listStyle: "none",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                "> li": {
                    lineHeight: (0, $05f34ed03d41967d$export$523c0b569236b342)(token.calc(textHeight).sub(token.calc(lineWidth).mul(2)).equal()),
                    display: "inline-block"
                },
                [`${componentCls}-now-btn-disabled`]: {
                    pointerEvents: "none",
                    color: token.colorTextDisabled
                },
                // https://github.com/ant-design/ant-design/issues/23687
                [`${componentCls}-preset > ${antCls}-tag-blue`]: {
                    color: colorPrimary,
                    background: cellActiveWithRangeBg,
                    borderColor: colorPrimaryBorder,
                    cursor: "pointer"
                },
                [`${componentCls}-ok`]: {
                    paddingBlock: token.calc(lineWidth).mul(2).equal(),
                    marginInlineStart: "auto"
                }
            }
        }
    };
};
var $df004891b355597c$export$2e2bcd8739ae039 = $df004891b355597c$var$genPickerPanelStyle;





const $077bc991481cdc3c$export$5f48700d53e3ff1 = (token)=>{
    const { componentCls: componentCls, controlHeightLG: controlHeightLG, paddingXXS: paddingXXS, padding: padding } = token;
    return {
        pickerCellCls: `${componentCls}-cell`,
        pickerCellInnerCls: `${componentCls}-cell-inner`,
        pickerYearMonthCellWidth: token.calc(controlHeightLG).mul(1.5).equal(),
        pickerQuarterPanelContentHeight: token.calc(controlHeightLG).mul(1.4).equal(),
        pickerCellPaddingVertical: token.calc(paddingXXS).add(token.calc(paddingXXS).div(2)).equal(),
        pickerCellBorderGap: 2,
        // Magic for gap between cells
        pickerControlIconSize: 7,
        pickerControlIconMargin: 4,
        pickerControlIconBorderWidth: 1.5,
        pickerDatePanelPaddingHorizontal: token.calc(padding).add(token.calc(paddingXXS).div(2)).equal() // 18 in normal
    };
};
const $077bc991481cdc3c$export$e39429f333f3edb3 = (token)=>{
    const { colorBgContainerDisabled: colorBgContainerDisabled, controlHeight: controlHeight, controlHeightSM: controlHeightSM, controlHeightLG: controlHeightLG, paddingXXS: paddingXXS, lineWidth: lineWidth } = token;
    // Item height default use `controlHeight - 2 * paddingXXS`,
    // but some case `paddingXXS=0`.
    // Let's fallback it.
    const dblPaddingXXS = paddingXXS * 2;
    const dblLineWidth = lineWidth * 2;
    const multipleItemHeight = Math.min(controlHeight - dblPaddingXXS, controlHeight - dblLineWidth);
    const multipleItemHeightSM = Math.min(controlHeightSM - dblPaddingXXS, controlHeightSM - dblLineWidth);
    const multipleItemHeightLG = Math.min(controlHeightLG - dblPaddingXXS, controlHeightLG - dblLineWidth);
    // FIXED_ITEM_MARGIN is a hardcode calculation since calc not support rounding
    const INTERNAL_FIXED_ITEM_MARGIN = Math.floor(paddingXXS / 2);
    const filledToken = {
        INTERNAL_FIXED_ITEM_MARGIN: INTERNAL_FIXED_ITEM_MARGIN,
        cellHoverBg: token.controlItemBgHover,
        cellActiveWithRangeBg: token.controlItemBgActive,
        cellHoverWithRangeBg: new (0, $3bb84f07fb2a2f32$export$2c4f38d6c0ecc25a)(token.colorPrimary).lighten(35).toHexString(),
        cellRangeBorderColor: new (0, $3bb84f07fb2a2f32$export$2c4f38d6c0ecc25a)(token.colorPrimary).lighten(20).toHexString(),
        cellBgDisabled: colorBgContainerDisabled,
        timeColumnWidth: controlHeightLG * 1.4,
        timeColumnHeight: 224,
        timeCellHeight: 28,
        cellWidth: controlHeightSM * 1.5,
        cellHeight: controlHeightSM,
        textHeight: controlHeightLG,
        withoutTimeCellHeight: controlHeightLG * 1.65,
        multipleItemBg: token.colorFillSecondary,
        multipleItemBorderColor: "transparent",
        multipleItemHeight: multipleItemHeight,
        multipleItemHeightSM: multipleItemHeightSM,
        multipleItemHeightLG: multipleItemHeightLG,
        multipleSelectorBgDisabled: colorBgContainerDisabled,
        multipleItemColorDisabled: token.colorTextDisabled,
        multipleItemBorderColorDisabled: "transparent"
    };
    return filledToken;
};
const $077bc991481cdc3c$export$9ca1be8807fe0675 = (token)=>({
        ...(0, $5e693f0c6e8784bd$export$bd8b682992bc9781)(token),
        ...$077bc991481cdc3c$export$e39429f333f3edb3(token),
        ...(0, $e1e9e0ec17db0365$export$87e38ee403661ccc)(token),
        presetsWidth: 120,
        presetsMaxWidth: 200,
        zIndexPopup: token.zIndexPopupBase + 50
    });




const $0a920d3fe968fdbb$var$genVariantsStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: [
            {
                ...(0, $189bffeae8a9954a$export$53795bafd774ce02)(token),
                ...(0, $189bffeae8a9954a$export$34771e60e0439351)(token),
                ...(0, $189bffeae8a9954a$export$b8365cd7e6671d79)(token),
                ...(0, $189bffeae8a9954a$export$b6de5da7f39edfcb)(token)
            },
            // ========================= Multiple =========================
            {
                "&-outlined": {
                    [`&${componentCls}-multiple ${componentCls}-selection-item`]: {
                        background: token.multipleItemBg,
                        border: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.multipleItemBorderColor}`
                    }
                },
                "&-filled": {
                    [`&${componentCls}-multiple ${componentCls}-selection-item`]: {
                        background: token.colorBgContainer,
                        border: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorSplit}`
                    }
                },
                "&-borderless": {
                    [`&${componentCls}-multiple ${componentCls}-selection-item`]: {
                        background: token.multipleItemBg,
                        border: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.multipleItemBorderColor}`
                    }
                },
                "&-underlined": {
                    [`&${componentCls}-multiple ${componentCls}-selection-item`]: {
                        background: token.multipleItemBg,
                        border: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.multipleItemBorderColor}`
                    }
                }
            }
        ]
    };
};
var $0a920d3fe968fdbb$export$2e2bcd8739ae039 = $0a920d3fe968fdbb$var$genVariantsStyle;


const $05dc7401ec198681$var$genPickerPadding = (paddingBlock, paddingInline)=>{
    return {
        padding: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(paddingBlock)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(paddingInline)}`
    };
};
const $05dc7401ec198681$var$genPickerStatusStyle = (token)=>{
    const { componentCls: componentCls, colorError: colorError, colorWarning: colorWarning } = token;
    const [varName] = (0, $6870d4d7c14ae0bb$export$d82b8f66c5649e14)(token.antCls, "date-picker");
    return {
        [`${componentCls}:not(${componentCls}-disabled):not([disabled])`]: {
            [`&${componentCls}-status-error`]: {
                [varName("affix-color")]: token.colorErrorAffix,
                [`${componentCls}-active-bar`]: {
                    background: colorError
                }
            },
            [`&${componentCls}-status-warning`]: {
                [varName("affix-color")]: token.colorWarningAffix,
                [`${componentCls}-active-bar`]: {
                    background: colorWarning
                }
            }
        }
    };
};
const $05dc7401ec198681$var$genPickerStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls, paddingInline: paddingInline, lineWidth: lineWidth, lineType: lineType, colorBorder: colorBorder, borderRadius: borderRadius, motionDurationMid: motionDurationMid, colorTextDisabled: colorTextDisabled, colorTextPlaceholder: colorTextPlaceholder, colorTextQuaternary: colorTextQuaternary, fontSizeLG: fontSizeLG, inputFontSizeLG: inputFontSizeLG, fontSizeSM: fontSizeSM, inputFontSizeSM: inputFontSizeSM, controlHeightSM: controlHeightSM, paddingInlineSM: paddingInlineSM, paddingXS: paddingXS, marginXS: marginXS, colorIcon: colorIcon, lineWidthBold: lineWidthBold, colorPrimary: colorPrimary, motionDurationSlow: motionDurationSlow, zIndexPopup: zIndexPopup, paddingXXS: paddingXXS, sizePopupArrow: sizePopupArrow, colorBgElevated: colorBgElevated, borderRadiusLG: borderRadiusLG, boxShadowSecondary: boxShadowSecondary, borderRadiusSM: borderRadiusSM, colorSplit: colorSplit, cellHoverBg: cellHoverBg, presetsWidth: presetsWidth, presetsMaxWidth: presetsMaxWidth, boxShadowPopoverArrow: boxShadowPopoverArrow, fontHeight: fontHeight, lineHeightLG: lineHeightLG } = token;
    const [varName, varRef] = (0, $6870d4d7c14ae0bb$export$d82b8f66c5649e14)(antCls, "date-picker");
    return [
        {
            [componentCls]: {
                [varName("affix-color")]: "inherit",
                ...(0, $519d20bf207ce864$export$23997c3e44cc1c59)(token),
                ...$05dc7401ec198681$var$genPickerPadding(token.paddingBlock, token.paddingInline),
                position: "relative",
                display: "inline-flex",
                alignItems: "center",
                lineHeight: 1,
                borderRadius: borderRadius,
                transition: [
                    `border`,
                    `box-shadow`,
                    `background-color`
                ].map((prop)=>`${prop} ${motionDurationMid}`).join(", "),
                [`${componentCls}-prefix`]: {
                    color: varRef("affix-color"),
                    flex: "0 0 auto",
                    marginInlineEnd: token.inputAffixPadding
                },
                // ======================== Input =========================
                [`${componentCls}-input`]: {
                    position: "relative",
                    display: "inline-flex",
                    alignItems: "center",
                    width: "100%",
                    "> input": {
                        position: "relative",
                        display: "inline-block",
                        width: "100%",
                        color: "inherit",
                        fontSize: token.inputFontSize ?? token.fontSize,
                        lineHeight: token.lineHeight,
                        transition: `all ${motionDurationMid}`,
                        ...(0, $8c2dcdcd3819e8c0$export$92095d0f4c77bd56)(colorTextPlaceholder),
                        flex: "auto",
                        // Fix Firefox flex not correct:
                        // https://github.com/ant-design/ant-design/pull/20023#issuecomment-564389553
                        minWidth: 1,
                        height: "auto",
                        padding: 0,
                        background: "transparent",
                        border: 0,
                        fontFamily: "inherit",
                        "&:focus": {
                            boxShadow: "none",
                            outline: 0
                        },
                        "&[disabled]": {
                            background: "transparent",
                            color: colorTextDisabled,
                            cursor: "not-allowed"
                        }
                    },
                    "&-placeholder": {
                        "> input": {
                            color: colorTextPlaceholder
                        }
                    }
                },
                // Size
                "&-large": {
                    ...$05dc7401ec198681$var$genPickerPadding(token.paddingBlockLG, token.paddingInlineLG),
                    borderRadius: token.borderRadiusLG,
                    [`${componentCls}-input > input`]: {
                        fontSize: inputFontSizeLG ?? fontSizeLG,
                        lineHeight: lineHeightLG
                    }
                },
                "&-small": {
                    ...$05dc7401ec198681$var$genPickerPadding(token.paddingBlockSM, token.paddingInlineSM),
                    borderRadius: token.borderRadiusSM,
                    [`${componentCls}-input > input`]: {
                        fontSize: inputFontSizeSM ?? fontSizeSM
                    }
                },
                [`${componentCls}-suffix`]: {
                    display: "flex",
                    flex: "none",
                    alignSelf: "center",
                    marginInlineStart: token.calc(paddingXS).div(2).equal(),
                    color: colorTextQuaternary,
                    lineHeight: 1,
                    pointerEvents: "none",
                    transition: [
                        "opacity",
                        "color"
                    ].map((prop)=>`${prop} ${motionDurationMid}`).join(", "),
                    "> *": {
                        verticalAlign: "top",
                        "&:not(:last-child)": {
                            marginInlineEnd: marginXS
                        }
                    }
                },
                [`${componentCls}-clear`]: {
                    position: "absolute",
                    top: "50%",
                    insetInlineEnd: 0,
                    color: colorTextQuaternary,
                    lineHeight: 1,
                    padding: 0,
                    fontSize: "inherit",
                    fontFamily: "inherit",
                    background: "transparent",
                    border: 0,
                    appearance: "none",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    opacity: 0,
                    pointerEvents: "none",
                    transition: [
                        "opacity",
                        "color"
                    ].map((prop)=>`${prop} ${motionDurationMid}`).join(", "),
                    "> *": {
                        verticalAlign: "top"
                    },
                    "&:hover": {
                        color: colorIcon
                    },
                    "&:focus-visible": {
                        color: token.colorIcon,
                        borderRadius: token.borderRadiusSM,
                        ...(0, $519d20bf207ce864$export$6539948f0a737e39)(token)
                    }
                },
                "&:hover, &:focus-within": {
                    [`${componentCls}-clear`]: {
                        opacity: 1,
                        pointerEvents: "auto"
                    },
                    // Should use the following selector, but since `:has` has poor compatibility,
                    // we use `:not(:last-child)` instead, which may cause some problems in some cases.
                    // [`${componentCls}-suffix:has(+ ${componentCls}-clear)`]: {
                    [`${componentCls}-suffix:not(:last-child)`]: {
                        opacity: 0
                    }
                },
                [`${componentCls}-separator`]: {
                    position: "relative",
                    display: "inline-block",
                    width: "1em",
                    height: fontSizeLG,
                    color: colorTextQuaternary,
                    fontSize: fontSizeLG,
                    verticalAlign: "top",
                    cursor: "default",
                    [`${componentCls}-focused &`]: {
                        color: colorIcon
                    },
                    [`${componentCls}-range-separator &`]: {
                        [`${componentCls}-disabled &`]: {
                            cursor: "not-allowed"
                        }
                    }
                },
                // ======================== Range =========================
                "&-range": {
                    position: "relative",
                    display: "inline-flex",
                    // Active bar
                    [`${componentCls}-active-bar`]: {
                        bottom: token.calc(lineWidth).mul(-1).equal(),
                        height: lineWidthBold,
                        background: colorPrimary,
                        opacity: 0,
                        transition: `all ${motionDurationSlow} ease-out`,
                        pointerEvents: "none"
                    },
                    [`&${componentCls}-focused`]: {
                        [`${componentCls}-active-bar`]: {
                            opacity: 1
                        }
                    },
                    [`${componentCls}-range-separator`]: {
                        alignItems: "center",
                        padding: `0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(paddingXS)}`,
                        lineHeight: 1
                    }
                },
                // ======================== Clear =========================
                "&-range, &-multiple": {
                    // Clear
                    [`${componentCls}-clear`]: {
                        insetInlineEnd: paddingInline
                    },
                    [`&${componentCls}-small`]: {
                        [`${componentCls}-clear`]: {
                            insetInlineEnd: paddingInlineSM
                        }
                    }
                },
                // ======================= Dropdown =======================
                "&-dropdown": {
                    ...(0, $519d20bf207ce864$export$23997c3e44cc1c59)(token),
                    ...(0, $df004891b355597c$export$da5309fdba1a1b64)(token),
                    pointerEvents: "none",
                    position: "absolute",
                    // Fix incorrect position of picker popup
                    // https://github.com/ant-design/ant-design/issues/35590
                    top: -9999,
                    left: {
                        _skip_check_: true,
                        value: -9999
                    },
                    zIndex: zIndexPopup,
                    [`&${componentCls}-dropdown-hidden`]: {
                        display: "none"
                    },
                    "&-rtl": {
                        direction: "rtl"
                    },
                    [`&${componentCls}-dropdown-placement-bottomLeft,
            &${componentCls}-dropdown-placement-bottomRight`]: {
                        [`${componentCls}-range-arrow`]: {
                            top: 0,
                            display: "block",
                            transform: "translateY(-100%)"
                        }
                    },
                    [`&${componentCls}-dropdown-placement-topLeft,
            &${componentCls}-dropdown-placement-topRight`]: {
                        [`${componentCls}-range-arrow`]: {
                            bottom: 0,
                            display: "block",
                            transform: "translateY(100%) rotate(180deg)"
                        }
                    },
                    [`&${antCls}-slide-up-appear, &${antCls}-slide-up-enter`]: {
                        [`${componentCls}-range-arrow${componentCls}-range-arrow`]: {
                            transition: "none"
                        }
                    },
                    [`&${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-dropdown-placement-topLeft,
          &${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-dropdown-placement-topRight,
          &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-dropdown-placement-topLeft,
          &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-dropdown-placement-topRight`]: {
                        animationName: (0, $ff153a7980a78f00$export$dd9f089fa5e819fe)
                    },
                    [`&${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-dropdown-placement-bottomLeft,
          &${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-dropdown-placement-bottomRight,
          &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-dropdown-placement-bottomLeft,
          &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-dropdown-placement-bottomRight`]: {
                        animationName: (0, $ff153a7980a78f00$export$e801b802b037de6a)
                    },
                    // https://github.com/ant-design/ant-design/issues/48727
                    [`&${antCls}-slide-up-leave ${componentCls}-panel-container`]: {
                        pointerEvents: "none"
                    },
                    [`&${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-dropdown-placement-topLeft,
          &${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-dropdown-placement-topRight`]: {
                        animationName: (0, $ff153a7980a78f00$export$f7243fdb9c27c3b7)
                    },
                    [`&${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-dropdown-placement-bottomLeft,
          &${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-dropdown-placement-bottomRight`]: {
                        animationName: (0, $ff153a7980a78f00$export$f40f41df328ebc38)
                    },
                    // Time picker with additional style
                    [`${componentCls}-panel > ${componentCls}-time-panel`]: {
                        paddingTop: paddingXXS
                    },
                    // ======================== Ranges ========================
                    [`${componentCls}-range-wrapper`]: {
                        display: "flex",
                        position: "relative"
                    },
                    [`${componentCls}-range-arrow`]: {
                        position: "absolute",
                        zIndex: 1,
                        display: "none",
                        paddingInline: token.calc(paddingInline).mul(1.5).equal(),
                        boxSizing: "content-box",
                        transition: `all ${motionDurationSlow} ease-out`,
                        ...(0, $e1e9e0ec17db0365$export$601fa0375eb80eec)(token, colorBgElevated, boxShadowPopoverArrow),
                        "&:before": {
                            insetInlineStart: token.calc(paddingInline).mul(1.5).equal()
                        }
                    },
                    [`${componentCls}-panel-container`]: {
                        overflow: "hidden",
                        verticalAlign: "top",
                        background: colorBgElevated,
                        borderRadius: borderRadiusLG,
                        boxShadow: boxShadowSecondary,
                        transition: `margin ${motionDurationSlow}`,
                        display: "inline-block",
                        pointerEvents: "auto",
                        // ======================== Layout ========================
                        [`${componentCls}-panel-layout`]: {
                            display: "flex",
                            flexWrap: "nowrap",
                            alignItems: "stretch"
                        },
                        // ======================== Preset ========================
                        [`${componentCls}-presets`]: {
                            display: "flex",
                            flexDirection: "column",
                            minWidth: presetsWidth,
                            maxWidth: presetsMaxWidth,
                            ul: {
                                height: 0,
                                flex: "auto",
                                listStyle: "none",
                                overflow: "auto",
                                margin: 0,
                                padding: paddingXS,
                                borderInlineEnd: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(lineWidth)} ${lineType} ${colorSplit}`,
                                li: {
                                    ...(0, $519d20bf207ce864$export$b2b65df0d0824629),
                                    borderRadius: borderRadiusSM,
                                    paddingInline: paddingXS,
                                    paddingBlock: token.calc(controlHeightSM).sub(fontHeight).div(2).equal(),
                                    cursor: "pointer",
                                    transition: `all ${motionDurationSlow}`,
                                    "+ li": {
                                        marginTop: marginXS
                                    },
                                    "&:hover": {
                                        background: cellHoverBg
                                    }
                                }
                            }
                        },
                        // ======================== Panels ========================
                        [`${componentCls}-panels`]: {
                            display: "inline-flex",
                            flexWrap: "nowrap",
                            // [`${componentCls}-panel`]: {
                            //   borderWidth: `0 0 ${unit(lineWidth)}`,
                            // },
                            "&:last-child": {
                                [`${componentCls}-panel`]: {
                                    borderWidth: 0
                                }
                            }
                        },
                        [`${componentCls}-panel`]: {
                            verticalAlign: "top",
                            background: "transparent",
                            borderRadius: 0,
                            borderWidth: 0,
                            [`${componentCls}-content, table`]: {
                                textAlign: "center"
                            },
                            "&-focused": {
                                borderColor: colorBorder
                            }
                        }
                    }
                },
                "&-dropdown-range": {
                    padding: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.calc(sizePopupArrow).mul(2).div(3).equal())} 0`,
                    "&-hidden": {
                        display: "none"
                    }
                },
                "&-rtl": {
                    direction: "rtl",
                    [`${componentCls}-separator`]: {
                        transform: "scale(-1, 1)"
                    },
                    [`${componentCls}-footer`]: {
                        "&-extra": {
                            direction: "rtl"
                        }
                    }
                }
            }
        },
        // Follow code may reuse in other components
        (0, $ff153a7980a78f00$export$9018e60daecf7a6c)(token, "slide-up"),
        (0, $ff153a7980a78f00$export$9018e60daecf7a6c)(token, "slide-down"),
        (0, $23de50b91f818ff9$export$913b1b7e3288c319)(token, "move-up"),
        (0, $23de50b91f818ff9$export$913b1b7e3288c319)(token, "move-down")
    ];
};
var // ============================== Export ==============================
$05dc7401ec198681$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$51ec95de45185b42)("DatePicker", (token)=>{
    const pickerToken = (0, $fef50f256b80dfa5$export$4950aa0f605343fb)((0, $5e693f0c6e8784bd$export$a157d95850191a12)(token), (0, $077bc991481cdc3c$export$5f48700d53e3ff1)(token), {
        inputPaddingHorizontalBase: token.calc(token.paddingSM).sub(1).equal(),
        multipleSelectItemHeight: token.multipleItemHeight,
        selectHeight: token.controlHeight
    });
    return [
        (0, $df004891b355597c$export$2e2bcd8739ae039)(pickerToken),
        $05dc7401ec198681$var$genPickerStyle(pickerToken),
        (0, $0a920d3fe968fdbb$export$2e2bcd8739ae039)(pickerToken),
        $05dc7401ec198681$var$genPickerStatusStyle(pickerToken),
        (0, $166c10224ea771ce$export$2e2bcd8739ae039)(pickerToken),
        // =====================================================
        // ==             Space Compact                       ==
        // =====================================================
        (0, $6e46145470fc0a51$export$b1208b23589b4b73)(token, {
            focusElCls: `${token.componentCls}-focused`
        })
    ];
}, (0, $077bc991481cdc3c$export$9ca1be8807fe0675));



var $cQmXV = parcelRequire("cQmXV");


const $d992ae964e651aae$export$d3f5c5e0a5023fa0 = (locale, picker, customizePlaceholder)=>{
    if ((0, $8e2d153a3c855782$export$826fff653a329e83)(customizePlaceholder)) return customizePlaceholder;
    if (picker === "year" && locale.lang.yearPlaceholder) return locale.lang.yearPlaceholder;
    if (picker === "quarter" && locale.lang.quarterPlaceholder) return locale.lang.quarterPlaceholder;
    if (picker === "month" && locale.lang.monthPlaceholder) return locale.lang.monthPlaceholder;
    if (picker === "week" && locale.lang.weekPlaceholder) return locale.lang.weekPlaceholder;
    if (picker === "time" && locale.timePickerLocale.placeholder) return locale.timePickerLocale.placeholder;
    return locale.lang.placeholder;
};
const $d992ae964e651aae$export$9793711a144eaeae = (locale, picker, customizePlaceholder)=>{
    if ((0, $8e2d153a3c855782$export$826fff653a329e83)(customizePlaceholder)) return customizePlaceholder;
    if (picker === "year" && locale.lang.rangeYearPlaceholder) return locale.lang.rangeYearPlaceholder;
    if (picker === "quarter" && locale.lang.rangeQuarterPlaceholder) return locale.lang.rangeQuarterPlaceholder;
    if (picker === "month" && locale.lang.rangeMonthPlaceholder) return locale.lang.rangeMonthPlaceholder;
    if (picker === "week" && locale.lang.rangeWeekPlaceholder) return locale.lang.rangeWeekPlaceholder;
    if (picker === "time" && locale.timePickerLocale.rangePlaceholder) return locale.timePickerLocale.rangePlaceholder;
    return locale.lang.rangePlaceholder;
};
const $d992ae964e651aae$export$75b0b37acc90e887 = (props, prefixCls)=>{
    const { allowClear: allowClear = true } = props;
    const { clearIcon: clearIcon, removeIcon: removeIcon } = (0, $1fdab3ae39c037b4$export$2e2bcd8739ae039)({
        ...props,
        prefixCls: prefixCls,
        componentName: "DatePicker"
    });
    const mergedAllowClear = $cQmXV.useMemo(()=>{
        if (allowClear === false) return false;
        const allowClearConfig = allowClear === true ? {} : allowClear;
        return {
            clearIcon: clearIcon,
            ...allowClearConfig
        };
    }, [
        allowClear,
        clearIcon
    ]);
    return [
        mergedAllowClear,
        removeIcon
    ];
};


const [$b055b5ecf5f1166d$export$3241045aa1844a20, $b055b5ecf5f1166d$export$f57ec95c006d390a] = [
    "week",
    "WeekPicker"
];
const [$b055b5ecf5f1166d$export$fa5253a4540f3e3a, $b055b5ecf5f1166d$export$b559b5cedf9ce559] = [
    "month",
    "MonthPicker"
];
const [$b055b5ecf5f1166d$export$90b88dc425a06a95, $b055b5ecf5f1166d$export$f4594efb24b701b2] = [
    "year",
    "YearPicker"
];
const [$b055b5ecf5f1166d$export$b470e30983f4a62f, $b055b5ecf5f1166d$export$1a7d99927693cc9d] = [
    "quarter",
    "QuarterPicker"
];
const [$b055b5ecf5f1166d$export$a9905336c0111a3a, $b055b5ecf5f1166d$export$5d6b097b9c0b7454] = [
    "time",
    "TimePicker"
];



var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");

"use client";
const $79a3f79985d77531$var$PickerButton = (props)=>/*#__PURE__*/ $cQmXV.createElement((0, $1fc505710073cde5$export$2e2bcd8739ae039), {
        size: "small",
        type: "primary",
        ...props
    });
var $79a3f79985d77531$export$2e2bcd8739ae039 = $79a3f79985d77531$var$PickerButton;


function $15afe22d8bb259cb$export$2e2bcd8739ae039(components) {
    return (0, $cQmXV.useMemo)(()=>({
            button: (0, $79a3f79985d77531$export$2e2bcd8739ae039),
            ...components
        }), [
        components
    ]);
}



var $cQmXV = parcelRequire("cQmXV");


var $cQmXV = parcelRequire("cQmXV");
var $565f164a6b0ce44e$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($565f164a6b0ce44e$exports, "__esModule", {
    value: true
});
var $565f164a6b0ce44e$var$ClockCircleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.4c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.8 11.2-1.7l28.6-39c2.6-3.7 1.8-8.7-1.8-11.2z"
                }
            }
        ]
    },
    "name": "clock-circle",
    "theme": "outlined"
};
$565f164a6b0ce44e$exports.default = $565f164a6b0ce44e$var$ClockCircleOutlined;



function $7b23ac4854de9809$var$_extends() {
    $7b23ac4854de9809$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7b23ac4854de9809$var$_extends.apply(this, arguments);
}
const $7b23ac4854de9809$var$ClockCircleOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $7b23ac4854de9809$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($565f164a6b0ce44e$exports)))
    }));
/**![clock-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0wIDgyMGMtMjA1LjQgMC0zNzItMTY2LjYtMzcyLTM3MnMxNjYuNi0zNzIgMzcyLTM3MiAzNzIgMTY2LjYgMzcyIDM3Mi0xNjYuNiAzNzItMzcyIDM3MnoiIC8+PHBhdGggZD0iTTY4Ni43IDYzOC42TDU0NC4xIDUzNS41VjI4OGMwLTQuNC0zLjYtOC04LThINDg4Yy00LjQgMC04IDMuNi04IDh2Mjc1LjRjMCAyLjYgMS4yIDUgMy4zIDYuNWwxNjUuNCAxMjAuNmMzLjYgMi42IDguNiAxLjggMTEuMi0xLjdsMjguNi0zOWMyLjYtMy43IDEuOC04LjctMS44LTExLjJ6IiAvPjwvc3ZnPg==) */ const $7b23ac4854de9809$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($7b23ac4854de9809$var$ClockCircleOutlined);
var $7b23ac4854de9809$export$2e2bcd8739ae039 = $7b23ac4854de9809$var$RefIcon;



"use client";
const $4c62fd11d59dc56f$var$useSuffixIcon = ({ picker: picker, hasFeedback: hasFeedback, feedbackIcon: feedbackIcon, suffixIcon: suffixIcon })=>{
    if (suffixIcon === null || suffixIcon === false) return null;
    if (suffixIcon === true || suffixIcon === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Fragment, null, picker === (0, $b055b5ecf5f1166d$export$a9905336c0111a3a) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $7b23ac4854de9809$export$2e2bcd8739ae039), {
        "aria-hidden": "true"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $3368c84d60c50017$export$2e2bcd8739ae039), {
        "aria-hidden": "true"
    }), hasFeedback && feedbackIcon);
    return suffixIcon;
};
var $4c62fd11d59dc56f$export$2e2bcd8739ae039 = $4c62fd11d59dc56f$var$useSuffixIcon;


"use client";
const $134c795157e9019f$var$generateRangePicker = (generateConfig)=>{
    const RangePicker = /*#__PURE__*/ (0, $cQmXV.forwardRef)((props, ref)=>{
        const { prefixCls: customizePrefixCls, getPopupContainer: customGetPopupContainer, components: components, className: className, style: style, classNames: classNames, styles: styles, placement: placement, size: customizeSize, disabled: customDisabled, bordered: bordered = true, placeholder: placeholder, status: customStatus, variant: customVariant, picker: picker, dropdownClassName: dropdownClassName, popupClassName: popupClassName, popupStyle: popupStyle, rootClassName: rootClassName, suffixIcon: suffixIcon, separator: separator, allowClear: allowClear, clearIcon: clearIcon, ...restProps } = props;
        const pickerType = picker === (0, $b055b5ecf5f1166d$export$a9905336c0111a3a) ? "timePicker" : "datePicker";
        const { suffixIcon: contextSuffixIcon, clearIcon: contextClearIcon, allowClear: contextAllowClear } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)(pickerType);
        var oldProp, newProp;
        const { getPrefixCls: getPrefixCls, direction: direction, getPopupContainer: getPopupContainer, rangePicker: rangePicker } = (0, $cQmXV.useContext)((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
        const innerRef = $cQmXV.useRef(null);
        const prefixCls = getPrefixCls("picker", customizePrefixCls);
        const { compactSize: compactSize, compactItemClassnames: compactItemClassnames } = (0, $68fddf51400eda11$export$cd8cf9d7bab8dd4)(prefixCls, direction);
        const rootPrefixCls = getPrefixCls();
        const mergedSeparator = separator ?? rangePicker?.separator;
        const [variant, enableVariantCls] = (0, $11c15dfa3883fb6f$export$2e2bcd8739ae039)("rangePicker", customVariant, bordered);
        const rootCls = (0, $2237081acd3cfc09$export$2e2bcd8739ae039)(prefixCls);
        const [hashId, cssVarCls] = (0, $05dc7401ec198681$export$2e2bcd8739ae039)(prefixCls, rootCls);
        const mergedRootClassName = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(hashId, cssVarCls, rootCls, rootClassName);
        // ===================== Icon =====================
        const mergedAllowClear = (0, $7dfc6f571d3c00af$export$9ea6397a890aa3e5)({
            componentName: "RangePicker",
            allowClear: allowClear,
            clearIcon: clearIcon,
            contextAllowClear: contextAllowClear,
            contextClearIcon: contextClearIcon,
            defaultAllowClear: true
        });
        // ================== components ==================
        const mergedComponents = (0, $15afe22d8bb259cb$export$2e2bcd8739ae039)(components);
        // ===================== Size =====================
        const mergedSize = (0, $78cdfb6138721329$export$2e2bcd8739ae039)((ctx)=>customizeSize ?? compactSize ?? ctx);
        // ===================== Disabled =====================
        const disabled = $cQmXV.useContext((0, $4f0e1ea30330557c$export$2e2bcd8739ae039));
        const mergedDisabled = customDisabled ?? disabled;
        // =========== Merged Props for Semantic ===========
        const mergedProps = {
            ...props,
            size: mergedSize,
            disabled: mergedDisabled,
            status: customStatus,
            variant: customVariant
        };
        const [mergedClassNames, mergedStyles] = (0, $c99d904af5883383$export$2e2bcd8739ae039)(pickerType, classNames, styles, popupClassName || dropdownClassName, popupStyle, mergedProps, rangePicker?.style ?? null);
        // ===================== FormItemInput =====================
        const formItemContext = (0, $cQmXV.useContext)((0, $7a3804f153d8a19d$export$bbb5553c6c7a14ed));
        const { hasFeedback: hasFeedback, status: contextStatus, feedbackIcon: feedbackIcon } = formItemContext;
        const mergedSuffixIcon = (0, $4c62fd11d59dc56f$export$2e2bcd8739ae039)({
            picker: picker,
            hasFeedback: hasFeedback,
            feedbackIcon: feedbackIcon,
            suffixIcon: suffixIcon === undefined ? contextSuffixIcon : suffixIcon
        });
        (0, $cQmXV.useImperativeHandle)(ref, ()=>innerRef.current);
        const [contextLocale] = (0, $c953dac9d015386e$export$2e2bcd8739ae039)("Calendar", (0, $641f44f02f49e3ed$export$2e2bcd8739ae039));
        const locale = (0, $a3099986deccaee4$export$4950aa0f605343fb)(contextLocale, props.locale || {});
        // ============================ zIndex ============================
        const [zIndex] = (0, $b2b300e6909d7707$export$3e7906d4075187a4)("DatePicker", mergedStyles?.popup?.root?.zIndex);
        return /*#__PURE__*/ $cQmXV.createElement((0, $1585084388e75c84$export$2e2bcd8739ae039), {
            space: true
        }, /*#__PURE__*/ $cQmXV.createElement((0, $682295b6bf22f8f5$export$2e2bcd8739ae039), {
            separator: /*#__PURE__*/ $cQmXV.createElement("span", {
                "aria-label": "to",
                className: `${prefixCls}-separator`
            }, mergedSeparator ?? /*#__PURE__*/ $cQmXV.createElement((0, $67f47a6420dc3c51$export$2e2bcd8739ae039), null)),
            disabled: mergedDisabled,
            ref: innerRef,
            placement: placement,
            placeholder: (0, $d992ae964e651aae$export$9793711a144eaeae)(locale, picker, placeholder),
            suffixIcon: mergedSuffixIcon,
            prevIcon: /*#__PURE__*/ $cQmXV.createElement("span", {
                className: `${prefixCls}-prev-icon`
            }),
            nextIcon: /*#__PURE__*/ $cQmXV.createElement("span", {
                className: `${prefixCls}-next-icon`
            }),
            superPrevIcon: /*#__PURE__*/ $cQmXV.createElement("span", {
                className: `${prefixCls}-super-prev-icon`
            }),
            superNextIcon: /*#__PURE__*/ $cQmXV.createElement("span", {
                className: `${prefixCls}-super-next-icon`
            }),
            transitionName: `${rootPrefixCls}-slide-up`,
            picker: picker,
            ...restProps,
            locale: locale.lang,
            getPopupContainer: customGetPopupContainer || getPopupContainer,
            generateConfig: generateConfig,
            components: mergedComponents,
            direction: direction,
            // Style
            prefixCls: prefixCls,
            rootClassName: mergedRootClassName,
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)({
                [`${prefixCls}-large`]: mergedSize === "large",
                [`${prefixCls}-small`]: mergedSize === "small",
                [`${prefixCls}-${variant}`]: enableVariantCls
            }, (0, $4a3ea1f9228016b7$export$b08e7b47149942a2)(prefixCls, (0, $4a3ea1f9228016b7$export$314e193082d7ba49)(contextStatus, customStatus), hasFeedback), compactItemClassnames, className, rangePicker?.className),
            style: style,
            // Semantic Style
            classNames: mergedClassNames,
            styles: {
                ...mergedStyles,
                popup: {
                    ...mergedStyles.popup,
                    root: {
                        ...mergedStyles.popup.root,
                        zIndex: zIndex
                    }
                }
            },
            allowClear: mergedAllowClear
        }));
    });
    return RangePicker;
};
var $134c795157e9019f$export$2e2bcd8739ae039 = $134c795157e9019f$var$generateRangePicker;



var $cQmXV = parcelRequire("cQmXV");























"use client";
const $4e67cc8b1e9b2302$var$generatePicker = (generateConfig)=>{
    const getPicker = (picker, displayName = "DatePicker")=>{
        const pickerType = displayName === (0, $b055b5ecf5f1166d$export$5d6b097b9c0b7454) ? "timePicker" : "datePicker";
        const Picker = /*#__PURE__*/ (0, $cQmXV.forwardRef)((props, ref)=>{
            const { prefixCls: customizePrefixCls, getPopupContainer: customizeGetPopupContainer, components: components, style: style, className: className, size: customizeSize, bordered: bordered, placement: placement, placeholder: placeholder, disabled: customDisabled, status: customStatus, variant: customVariant, onCalendarChange: onCalendarChange, classNames: classNames, styles: styles, dropdownClassName: dropdownClassName, popupClassName: popupClassName, popupStyle: popupStyle, rootClassName: rootClassName, suffixIcon: suffixIcon, allowClear: allowClear, clearIcon: clearIcon, ...restProps } = props;
            const { suffixIcon: contextSuffixIcon, clearIcon: contextClearIcon, allowClear: contextAllowClear } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)(displayName === (0, $b055b5ecf5f1166d$export$5d6b097b9c0b7454) ? "timePicker" : "datePicker");
            var oldProp, newProp;
            const { getPrefixCls: getPrefixCls, direction: direction, getPopupContainer: getPopupContainer, // Consume different styles according to different names
            [pickerType]: contextPickerConfig } = (0, $cQmXV.useContext)((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
            const prefixCls = getPrefixCls("picker", customizePrefixCls);
            // ===================== Size =====================
            const { compactSize: compactSize, compactItemClassnames: compactItemClassnames } = (0, $68fddf51400eda11$export$cd8cf9d7bab8dd4)(prefixCls, direction);
            const mergedSize = (0, $78cdfb6138721329$export$2e2bcd8739ae039)((ctx)=>customizeSize ?? compactSize ?? ctx);
            // ===================== Disabled =====================
            const disabled = $cQmXV.useContext((0, $4f0e1ea30330557c$export$2e2bcd8739ae039));
            const mergedDisabled = customDisabled ?? disabled;
            // =========== Merged Props for Semantic ===========
            const mergedProps = {
                ...props,
                size: mergedSize,
                disabled: mergedDisabled,
                status: customStatus,
                variant: customVariant
            };
            // ========================= Style ==========================
            // Use original useMergedPickerSemantic for proper popup handling
            const [mergedClassNames, mergedStyles] = (0, $c99d904af5883383$export$2e2bcd8739ae039)(pickerType, classNames, styles, popupClassName || dropdownClassName, popupStyle, mergedProps, contextPickerConfig?.style);
            const innerRef = $cQmXV.useRef(null);
            const [variant, enableVariantCls] = (0, $11c15dfa3883fb6f$export$2e2bcd8739ae039)("datePicker", customVariant, bordered);
            const rootCls = (0, $2237081acd3cfc09$export$2e2bcd8739ae039)(prefixCls);
            const [hashId, cssVarCls] = (0, $05dc7401ec198681$export$2e2bcd8739ae039)(prefixCls, rootCls);
            const mergedRootClassName = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(hashId, cssVarCls, rootCls, rootClassName);
            (0, $cQmXV.useImperativeHandle)(ref, ()=>innerRef.current);
            const additionalProps = {
                showToday: true
            };
            const mergedPicker = picker || props.picker;
            const rootPrefixCls = getPrefixCls();
            // ==================== Legacy =====================
            const { onSelect: onSelect, multiple: multiple } = restProps;
            const hasLegacyOnSelect = onSelect && picker === "time" && !multiple;
            const onInternalCalendarChange = (date, dateStr, info)=>{
                onCalendarChange?.(date, dateStr, info);
                if (hasLegacyOnSelect) onSelect(date);
            };
            // ===================== Icon =====================
            const [, removeIcon] = (0, $d992ae964e651aae$export$75b0b37acc90e887)(props, prefixCls);
            const mergedAllowClear = (0, $7dfc6f571d3c00af$export$9ea6397a890aa3e5)({
                componentName: displayName,
                allowClear: allowClear,
                clearIcon: clearIcon,
                contextAllowClear: contextAllowClear,
                contextClearIcon: contextClearIcon,
                defaultAllowClear: true
            });
            // ================== components ==================
            const mergedComponents = (0, $15afe22d8bb259cb$export$2e2bcd8739ae039)(components);
            // ===================== FormItemInput =====================
            const formItemContext = (0, $cQmXV.useContext)((0, $7a3804f153d8a19d$export$bbb5553c6c7a14ed));
            const { hasFeedback: hasFeedback, status: contextStatus, feedbackIcon: feedbackIcon } = formItemContext;
            const mergedSuffixIcon = (0, $4c62fd11d59dc56f$export$2e2bcd8739ae039)({
                picker: mergedPicker,
                hasFeedback: hasFeedback,
                feedbackIcon: feedbackIcon,
                suffixIcon: suffixIcon === undefined ? contextSuffixIcon : suffixIcon
            });
            const [contextLocale] = (0, $c953dac9d015386e$export$2e2bcd8739ae039)("DatePicker", (0, $641f44f02f49e3ed$export$2e2bcd8739ae039));
            const locale = (0, $a3099986deccaee4$export$4950aa0f605343fb)(contextLocale, props.locale || {});
            // ============================ zIndex ============================
            const [zIndex] = (0, $b2b300e6909d7707$export$3e7906d4075187a4)("DatePicker", mergedStyles?.popup?.root?.zIndex);
            return /*#__PURE__*/ $cQmXV.createElement((0, $1585084388e75c84$export$2e2bcd8739ae039), {
                space: true
            }, /*#__PURE__*/ $cQmXV.createElement((0, $e0426c0b99a67cdf$export$2e2bcd8739ae039), {
                ref: innerRef,
                placeholder: (0, $d992ae964e651aae$export$d3f5c5e0a5023fa0)(locale, mergedPicker, placeholder),
                suffixIcon: mergedSuffixIcon,
                placement: placement,
                prevIcon: /*#__PURE__*/ $cQmXV.createElement("span", {
                    className: `${prefixCls}-prev-icon`
                }),
                nextIcon: /*#__PURE__*/ $cQmXV.createElement("span", {
                    className: `${prefixCls}-next-icon`
                }),
                superPrevIcon: /*#__PURE__*/ $cQmXV.createElement("span", {
                    className: `${prefixCls}-super-prev-icon`
                }),
                superNextIcon: /*#__PURE__*/ $cQmXV.createElement("span", {
                    className: `${prefixCls}-super-next-icon`
                }),
                transitionName: `${rootPrefixCls}-slide-up`,
                picker: picker,
                onCalendarChange: onInternalCalendarChange,
                ...additionalProps,
                ...restProps,
                locale: locale.lang,
                getPopupContainer: customizeGetPopupContainer || getPopupContainer,
                generateConfig: generateConfig,
                components: mergedComponents,
                direction: direction,
                disabled: mergedDisabled,
                // Style
                prefixCls: prefixCls,
                rootClassName: mergedRootClassName,
                className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)({
                    [`${prefixCls}-large`]: mergedSize === "large",
                    [`${prefixCls}-small`]: mergedSize === "small",
                    [`${prefixCls}-${variant}`]: enableVariantCls
                }, (0, $4a3ea1f9228016b7$export$b08e7b47149942a2)(prefixCls, (0, $4a3ea1f9228016b7$export$314e193082d7ba49)(contextStatus, customStatus), hasFeedback), compactItemClassnames, contextPickerConfig?.className, className),
                style: style,
                // Semantic Style
                classNames: mergedClassNames,
                styles: {
                    ...mergedStyles,
                    popup: {
                        ...mergedStyles.popup,
                        root: {
                            ...mergedStyles.popup.root,
                            zIndex: zIndex
                        }
                    }
                },
                allowClear: mergedAllowClear,
                removeIcon: removeIcon
            }));
        });
        return Picker;
    };
    const DatePicker = getPicker();
    const WeekPicker = getPicker((0, $b055b5ecf5f1166d$export$3241045aa1844a20), (0, $b055b5ecf5f1166d$export$f57ec95c006d390a));
    const MonthPicker = getPicker((0, $b055b5ecf5f1166d$export$fa5253a4540f3e3a), (0, $b055b5ecf5f1166d$export$b559b5cedf9ce559));
    const YearPicker = getPicker((0, $b055b5ecf5f1166d$export$90b88dc425a06a95), (0, $b055b5ecf5f1166d$export$f4594efb24b701b2));
    const QuarterPicker = getPicker((0, $b055b5ecf5f1166d$export$b470e30983f4a62f), (0, $b055b5ecf5f1166d$export$1a7d99927693cc9d));
    const TimePicker = getPicker((0, $b055b5ecf5f1166d$export$a9905336c0111a3a), (0, $b055b5ecf5f1166d$export$5d6b097b9c0b7454));
    return {
        DatePicker: DatePicker,
        WeekPicker: WeekPicker,
        MonthPicker: MonthPicker,
        YearPicker: YearPicker,
        TimePicker: TimePicker,
        QuarterPicker: QuarterPicker
    };
};
var $4e67cc8b1e9b2302$export$2e2bcd8739ae039 = $4e67cc8b1e9b2302$var$generatePicker;


"use client";
const $d517312f74c6a184$var$generatePicker = (generateConfig)=>{
    // =========================== Picker ===========================
    const { DatePicker: DatePicker, WeekPicker: WeekPicker, MonthPicker: MonthPicker, YearPicker: YearPicker, TimePicker: TimePicker, QuarterPicker: QuarterPicker } = (0, $4e67cc8b1e9b2302$export$2e2bcd8739ae039)(generateConfig);
    // ======================== Range Picker ========================
    const RangePicker = (0, $134c795157e9019f$export$2e2bcd8739ae039)(generateConfig);
    const MergedDatePicker = DatePicker;
    MergedDatePicker.WeekPicker = WeekPicker;
    MergedDatePicker.MonthPicker = MonthPicker;
    MergedDatePicker.YearPicker = YearPicker;
    MergedDatePicker.RangePicker = RangePicker;
    MergedDatePicker.TimePicker = TimePicker;
    MergedDatePicker.QuarterPicker = QuarterPicker;
    return MergedDatePicker;
};
var $d517312f74c6a184$export$2e2bcd8739ae039 = $d517312f74c6a184$var$generatePicker;


"use client";
const $bf89508d36c51d8b$var$DatePicker = (0, $d517312f74c6a184$export$2e2bcd8739ae039)((0, $ea5f06974ef1da16$export$2e2bcd8739ae039));
// We don't care debug panel
/* istanbul ignore next */ const $bf89508d36c51d8b$var$PurePanel = (0, $f2e41308375833b9$export$2e2bcd8739ae039)($bf89508d36c51d8b$var$DatePicker, "popupAlign", undefined, "picker");
$bf89508d36c51d8b$var$DatePicker._InternalPanelDoNotUseOrYouWillBeFired = $bf89508d36c51d8b$var$PurePanel;
const $bf89508d36c51d8b$var$PureRangePanel = (0, $f2e41308375833b9$export$2e2bcd8739ae039)($bf89508d36c51d8b$var$DatePicker.RangePicker, "popupAlign", undefined, "picker");
$bf89508d36c51d8b$var$DatePicker._InternalRangePanelDoNotUseOrYouWillBeFired = $bf89508d36c51d8b$var$PureRangePanel;
$bf89508d36c51d8b$var$DatePicker.generatePicker = (0, $d517312f74c6a184$export$2e2bcd8739ae039);
var $bf89508d36c51d8b$export$2e2bcd8739ae039 = $bf89508d36c51d8b$var$DatePicker;



var $cQmXV = parcelRequire("cQmXV");
var $de294ab9db7f1634$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($de294ab9db7f1634$exports, "__esModule", {
    value: true
});
var $de294ab9db7f1634$var$StopOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372 0-89 31.3-170.8 83.5-234.8l523.3 523.3C682.8 852.7 601 884 512 884zm288.5-137.2L277.2 223.5C341.2 171.3 423 140 512 140c205.4 0 372 166.6 372 372 0 89-31.3 170.8-83.5 234.8z"
                }
            }
        ]
    },
    "name": "stop",
    "theme": "outlined"
};
$de294ab9db7f1634$exports.default = $de294ab9db7f1634$var$StopOutlined;



function $4d7cc9843b581604$var$_extends() {
    $4d7cc9843b581604$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4d7cc9843b581604$var$_extends.apply(this, arguments);
}
const $4d7cc9843b581604$var$StopOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $4d7cc9843b581604$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($de294ab9db7f1634$exports)))
    }));
/**![stop](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0wIDgyMGMtMjA1LjQgMC0zNzItMTY2LjYtMzcyLTM3MiAwLTg5IDMxLjMtMTcwLjggODMuNS0yMzQuOGw1MjMuMyA1MjMuM0M2ODIuOCA4NTIuNyA2MDEgODg0IDUxMiA4ODR6bTI4OC41LTEzNy4yTDI3Ny4yIDIyMy41QzM0MS4yIDE3MS4zIDQyMyAxNDAgNTEyIDE0MGMyMDUuNCAwIDM3MiAxNjYuNiAzNzIgMzcyIDAgODktMzEuMyAxNzAuOC04My41IDIzNC44eiIgLz48L3N2Zz4=) */ const $4d7cc9843b581604$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($4d7cc9843b581604$var$StopOutlined);
var $4d7cc9843b581604$export$2e2bcd8739ae039 = $4d7cc9843b581604$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $19f11b949c2763e3$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($19f11b949c2763e3$exports, "__esModule", {
    value: true
});
var $19f11b949c2763e3$var$ScheduleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zm-40 568H136V296h120v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h120v496zM416 496H232c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0 136H232c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm308.2-177.4L620.6 598.3l-52.8-73.1c-3-4.2-7.8-6.6-12.9-6.6H500c-6.5 0-10.3 7.4-6.5 12.7l114.1 158.2a15.9 15.9 0 0025.8 0l165-228.7c3.8-5.3 0-12.7-6.5-12.7H737c-5-.1-9.8 2.4-12.8 6.5z"
                }
            }
        ]
    },
    "name": "schedule",
    "theme": "outlined"
};
$19f11b949c2763e3$exports.default = $19f11b949c2763e3$var$ScheduleOutlined;



function $257065bd7ea0ea87$var$_extends() {
    $257065bd7ea0ea87$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $257065bd7ea0ea87$var$_extends.apply(this, arguments);
}
const $257065bd7ea0ea87$var$ScheduleOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $257065bd7ea0ea87$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($19f11b949c2763e3$exports)))
    }));
/**![schedule](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkyOCAyMjRINzY4di01NmMwLTQuNC0zLjYtOC04LThoLTU2Yy00LjQgMC04IDMuNi04IDh2NTZINTQ4di01NmMwLTQuNC0zLjYtOC04LThoLTU2Yy00LjQgMC04IDMuNi04IDh2NTZIMzI4di01NmMwLTQuNC0zLjYtOC04LThoLTU2Yy00LjQgMC04IDMuNi04IDh2NTZIOTZjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjU3NmMwIDE3LjcgMTQuMyAzMiAzMiAzMmg4MzJjMTcuNyAwIDMyLTE0LjMgMzItMzJWMjU2YzAtMTcuNy0xNC4zLTMyLTMyLTMyem0tNDAgNTY4SDEzNlYyOTZoMTIwdjU2YzAgNC40IDMuNiA4IDggOGg1NmM0LjQgMCA4LTMuNiA4LTh2LTU2aDE0OHY1NmMwIDQuNCAzLjYgOCA4IDhoNTZjNC40IDAgOC0zLjYgOC04di01NmgxNDh2NTZjMCA0LjQgMy42IDggOCA4aDU2YzQuNCAwIDgtMy42IDgtOHYtNTZoMTIwdjQ5NnpNNDE2IDQ5NkgyMzJjLTQuNCAwLTggMy42LTggOHY0OGMwIDQuNCAzLjYgOCA4IDhoMTg0YzQuNCAwIDgtMy42IDgtOHYtNDhjMC00LjQtMy42LTgtOC04em0wIDEzNkgyMzJjLTQuNCAwLTggMy42LTggOHY0OGMwIDQuNCAzLjYgOCA4IDhoMTg0YzQuNCAwIDgtMy42IDgtOHYtNDhjMC00LjQtMy42LTgtOC04em0zMDguMi0xNzcuNEw2MjAuNiA1OTguM2wtNTIuOC03My4xYy0zLTQuMi03LjgtNi42LTEyLjktNi42SDUwMGMtNi41IDAtMTAuMyA3LjQtNi41IDEyLjdsMTE0LjEgMTU4LjJhMTUuOSAxNS45IDAgMDAyNS44IDBsMTY1LTIyOC43YzMuOC01LjMgMC0xMi43LTYuNS0xMi43SDczN2MtNS0uMS05LjggMi40LTEyLjggNi41eiIgLz48L3N2Zz4=) */ const $257065bd7ea0ea87$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($257065bd7ea0ea87$var$ScheduleOutlined);
var $257065bd7ea0ea87$export$2e2bcd8739ae039 = $257065bd7ea0ea87$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $4043d3970f84c928$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($4043d3970f84c928$exports, "__esModule", {
    value: true
});
var $4043d3970f84c928$var$ExclamationCircleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M464 688a48 48 0 1096 0 48 48 0 10-96 0zm24-112h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8z"
                }
            }
        ]
    },
    "name": "exclamation-circle",
    "theme": "outlined"
};
$4043d3970f84c928$exports.default = $4043d3970f84c928$var$ExclamationCircleOutlined;



function $798c0df65ce199b6$var$_extends() {
    $798c0df65ce199b6$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $798c0df65ce199b6$var$_extends.apply(this, arguments);
}
const $798c0df65ce199b6$var$ExclamationCircleOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $798c0df65ce199b6$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4043d3970f84c928$exports)))
    }));
/**![exclamation-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0wIDgyMGMtMjA1LjQgMC0zNzItMTY2LjYtMzcyLTM3MnMxNjYuNi0zNzIgMzcyLTM3MiAzNzIgMTY2LjYgMzcyIDM3Mi0xNjYuNiAzNzItMzcyIDM3MnoiIC8+PHBhdGggZD0iTTQ2NCA2ODhhNDggNDggMCAxMDk2IDAgNDggNDggMCAxMC05NiAwem0yNC0xMTJoNDhjNC40IDAgOC0zLjYgOC04VjI5NmMwLTQuNC0zLjYtOC04LThoLTQ4Yy00LjQgMC04IDMuNi04IDh2MjcyYzAgNC40IDMuNiA4IDggOHoiIC8+PC9zdmc+) */ const $798c0df65ce199b6$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($798c0df65ce199b6$var$ExclamationCircleOutlined);
var $798c0df65ce199b6$export$2e2bcd8739ae039 = $798c0df65ce199b6$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $a02d2dac41e4dccc$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($a02d2dac41e4dccc$exports, "__esModule", {
    value: true
});
var $a02d2dac41e4dccc$var$SaveOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M893.3 293.3L730.7 130.7c-7.5-7.5-16.7-13-26.7-16V112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V338.5c0-17-6.7-33.2-18.7-45.2zM384 184h256v104H384V184zm456 656H184V184h136v136c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V205.8l136 136V840zM512 442c-79.5 0-144 64.5-144 144s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144zm0 224c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80z"
                }
            }
        ]
    },
    "name": "save",
    "theme": "outlined"
};
$a02d2dac41e4dccc$exports.default = $a02d2dac41e4dccc$var$SaveOutlined;



function $7f0f32b5e0f33a0e$var$_extends() {
    $7f0f32b5e0f33a0e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7f0f32b5e0f33a0e$var$_extends.apply(this, arguments);
}
const $7f0f32b5e0f33a0e$var$SaveOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $7f0f32b5e0f33a0e$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($a02d2dac41e4dccc$exports)))
    }));
/**![save](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg5My4zIDI5My4zTDczMC43IDEzMC43Yy03LjUtNy41LTE2LjctMTMtMjYuNy0xNlYxMTJIMTQ0Yy0xNy43IDAtMzIgMTQuMy0zMiAzMnY3MzZjMCAxNy43IDE0LjMgMzIgMzIgMzJoNzM2YzE3LjcgMCAzMi0xNC4zIDMyLTMyVjMzOC41YzAtMTctNi43LTMzLjItMTguNy00NS4yek0zODQgMTg0aDI1NnYxMDRIMzg0VjE4NHptNDU2IDY1NkgxODRWMTg0aDEzNnYxMzZjMCAxNy43IDE0LjMgMzIgMzIgMzJoMzIwYzE3LjcgMCAzMi0xNC4zIDMyLTMyVjIwNS44bDEzNiAxMzZWODQwek01MTIgNDQyYy03OS41IDAtMTQ0IDY0LjUtMTQ0IDE0NHM2NC41IDE0NCAxNDQgMTQ0IDE0NC02NC41IDE0NC0xNDQtNjQuNS0xNDQtMTQ0LTE0NHptMCAyMjRjLTQ0LjIgMC04MC0zNS44LTgwLTgwczM1LjgtODAgODAtODAgODAgMzUuOCA4MCA4MC0zNS44IDgwLTgwIDgweiIgLz48L3N2Zz4=) */ const $7f0f32b5e0f33a0e$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($7f0f32b5e0f33a0e$var$SaveOutlined);
var $7f0f32b5e0f33a0e$export$2e2bcd8739ae039 = $7f0f32b5e0f33a0e$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $9709d9b046432c5f$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($9709d9b046432c5f$exports, "__esModule", {
    value: true
});
var $9709d9b046432c5f$var$PhoneOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M877.1 238.7L770.6 132.3c-13-13-30.4-20.3-48.8-20.3s-35.8 7.2-48.8 20.3L558.3 246.8c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l89.6 89.7a405.46 405.46 0 01-86.4 127.3c-36.7 36.9-79.6 66-127.2 86.6l-89.6-89.7c-13-13-30.4-20.3-48.8-20.3a68.2 68.2 0 00-48.8 20.3L132.3 673c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l106.4 106.4c22.2 22.2 52.8 34.9 84.2 34.9 6.5 0 12.8-.5 19.2-1.6 132.4-21.8 263.8-92.3 369.9-198.3C818 606 888.4 474.6 910.4 342.1c6.3-37.6-6.3-76.3-33.3-103.4zm-37.6 91.5c-19.5 117.9-82.9 235.5-178.4 331s-213 158.9-330.9 178.4c-14.8 2.5-30-2.5-40.8-13.2L184.9 721.9 295.7 611l119.8 120 .9.9 21.6-8a481.29 481.29 0 00285.7-285.8l8-21.6-120.8-120.7 110.8-110.9 104.5 104.5c10.8 10.8 15.8 26 13.3 40.8z"
                }
            }
        ]
    },
    "name": "phone",
    "theme": "outlined"
};
$9709d9b046432c5f$exports.default = $9709d9b046432c5f$var$PhoneOutlined;



function $efbc782831576418$var$_extends() {
    $efbc782831576418$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $efbc782831576418$var$_extends.apply(this, arguments);
}
const $efbc782831576418$var$PhoneOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $efbc782831576418$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9709d9b046432c5f$exports)))
    }));
/**![phone](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg3Ny4xIDIzOC43TDc3MC42IDEzMi4zYy0xMy0xMy0zMC40LTIwLjMtNDguOC0yMC4zcy0zNS44IDcuMi00OC44IDIwLjNMNTU4LjMgMjQ2LjhjLTEzIDEzLTIwLjMgMzAuNS0yMC4zIDQ4LjkgMCAxOC41IDcuMiAzNS44IDIwLjMgNDguOWw4OS42IDg5LjdhNDA1LjQ2IDQwNS40NiAwIDAxLTg2LjQgMTI3LjNjLTM2LjcgMzYuOS03OS42IDY2LTEyNy4yIDg2LjZsLTg5LjYtODkuN2MtMTMtMTMtMzAuNC0yMC4zLTQ4LjgtMjAuM2E2OC4yIDY4LjIgMCAwMC00OC44IDIwLjNMMTMyLjMgNjczYy0xMyAxMy0yMC4zIDMwLjUtMjAuMyA0OC45IDAgMTguNSA3LjIgMzUuOCAyMC4zIDQ4LjlsMTA2LjQgMTA2LjRjMjIuMiAyMi4yIDUyLjggMzQuOSA4NC4yIDM0LjkgNi41IDAgMTIuOC0uNSAxOS4yLTEuNiAxMzIuNC0yMS44IDI2My44LTkyLjMgMzY5LjktMTk4LjNDODE4IDYwNiA4ODguNCA0NzQuNiA5MTAuNCAzNDIuMWM2LjMtMzcuNi02LjMtNzYuMy0zMy4zLTEwMy40em0tMzcuNiA5MS41Yy0xOS41IDExNy45LTgyLjkgMjM1LjUtMTc4LjQgMzMxcy0yMTMgMTU4LjktMzMwLjkgMTc4LjRjLTE0LjggMi41LTMwLTIuNS00MC44LTEzLjJMMTg0LjkgNzIxLjkgMjk1LjcgNjExbDExOS44IDEyMCAuOS45IDIxLjYtOGE0ODEuMjkgNDgxLjI5IDAgMDAyODUuNy0yODUuOGw4LTIxLjYtMTIwLjgtMTIwLjcgMTEwLjgtMTEwLjkgMTA0LjUgMTA0LjVjMTAuOCAxMC44IDE1LjggMjYgMTMuMyA0MC44eiIgLz48L3N2Zz4=) */ const $efbc782831576418$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($efbc782831576418$var$PhoneOutlined);
var $efbc782831576418$export$2e2bcd8739ae039 = $efbc782831576418$var$RefIcon;









/* A visit's duration, formatted. Its own module rather than `module/visit/sections.js`, which is
   where it would naturally live: that file imports `LeafletMap`, so reaching into it from the
   visits list and the merchandiser detail would pull Leaflet into two more entry bundles. Same
   reasoning as `util/answer-fields.js`. */ 

const $9277fdae5adb8dfa$export$bc733b0c5cbb3e8a = (value, lang)=>{
    const seconds = Number(value) || 0;
    if (!seconds) return "";
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), key, lang);
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.round(seconds % 3600 / 60);
    return hours ? `${hours}${t("h_short")} ${minutes}${t("m_short")}` : `${minutes}${t("m_short")}`;
};




// Date helpers for the route calendar.
//
// The backend `Route.day_of_the_week` is Monday=0 … Sunday=6, and the Nth-of-month
// resolution mirrors the server filter exactly: nth = (day - 1) // 7 + 1.
// JS `Date.getDay()` is Sunday=0 … Saturday=6, so we convert to the Monday-based index.
const $7d0f78de0b68a104$var$pad = (n)=>String(n).padStart(2, "0");
const $7d0f78de0b68a104$export$56c97ca1cde8c5bb = (date)=>(date.getDay() + 6) % 7;
const $7d0f78de0b68a104$export$83a45ae2ed9f0324 = (date)=>Math.floor((date.getDate() - 1) / 7) + 1;
const $7d0f78de0b68a104$export$6dce03e22a5971e7 = (date)=>`${date.getFullYear()}-${$7d0f78de0b68a104$var$pad(date.getMonth() + 1)}-${$7d0f78de0b68a104$var$pad(date.getDate())}`;
const $7d0f78de0b68a104$export$a1081e8ce57742a4 = (date)=>new Date(date.getFullYear(), date.getMonth(), 1);
const $7d0f78de0b68a104$export$17c93e242b2d3a22 = (date, n)=>new Date(date.getFullYear(), date.getMonth() + n, 1);
const $7d0f78de0b68a104$export$a18c89cbd24170ff = (a, b)=>a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth();
const $7d0f78de0b68a104$export$dd412b56f1e4d8aa = (date, n)=>new Date(date.getFullYear(), date.getMonth(), date.getDate() + n);
const $7d0f78de0b68a104$export$42c81a444fbfb5d4 = (date)=>$7d0f78de0b68a104$export$dd412b56f1e4d8aa(date, -$7d0f78de0b68a104$export$56c97ca1cde8c5bb(date));
// Locale for Intl month/weekday names, keyed by the app's language codes.
const $7d0f78de0b68a104$var$INTL_LOCALE = {
    uk: "uk",
    en: "en-GB",
    hy: "hy",
    ka: "ka"
};
const $7d0f78de0b68a104$export$bd7bed267fc278f2 = (lang)=>$7d0f78de0b68a104$var$INTL_LOCALE[lang] || "en-GB";
const $7d0f78de0b68a104$export$4f81354ee858acb4 = (monthDate, lang)=>new Intl.DateTimeFormat($7d0f78de0b68a104$export$bd7bed267fc278f2(lang), {
        month: "long",
        year: "numeric"
    }).format(monthDate);
const $7d0f78de0b68a104$export$304d353c7b75a1a4 = (monday, lang)=>new Intl.DateTimeFormat($7d0f78de0b68a104$export$bd7bed267fc278f2(lang), {
        day: "numeric",
        month: "short",
        year: "numeric"
    }).formatRange(monday, $7d0f78de0b68a104$export$dd412b56f1e4d8aa(monday, 6));
const $7d0f78de0b68a104$export$1411063a75ad0425 = (monthDate, lang)=>{
    if (lang !== "uk") return $7d0f78de0b68a104$export$4f81354ee858acb4(monthDate, lang);
    const parts = new Intl.DateTimeFormat($7d0f78de0b68a104$export$bd7bed267fc278f2(lang), {
        day: "numeric",
        month: "long",
        year: "numeric"
    }).formatToParts(monthDate);
    const day = parts.findIndex((part)=>part.type === "day");
    if (day === -1) return $7d0f78de0b68a104$export$4f81354ee858acb4(monthDate, lang);
    const neighbour = parts[day + 1]?.type === "literal" ? day + 1 : parts[day - 1]?.type === "literal" ? day - 1 : -1;
    return parts.filter((part, index)=>index !== day && index !== neighbour).map((part)=>part.value).join("").trim();
};
const $7d0f78de0b68a104$export$8d7bfd7870d0d02 = (lang)=>{
    const fmt = new Intl.DateTimeFormat($7d0f78de0b68a104$export$bd7bed267fc278f2(lang), {
        weekday: "short"
    });
    // 2024-01-01 is a Monday.
    return Array.from({
        length: 7
    }, (_, i)=>fmt.format(new Date(2024, 0, 1 + i)));
};
const $7d0f78de0b68a104$export$39af906a0f4e17a1 = (date, lang)=>new Intl.DateTimeFormat($7d0f78de0b68a104$export$bd7bed267fc278f2(lang), {
        day: "numeric",
        month: "short"
    }).format(date);


/* The route editor, inside the merchandiser detail page's Routes tab.
   Normative rules: docs/design/spec/. There is no mockup for this screen — `merch-detail.html`
   covers only the read-only Routes tab and its "Open route editor" button.

   Stops are THREE ADDITIVE LAYERS (`route/routeModel.js`), and the editor shows all three rather
   than flattening them: a weekly base, extras on the Nth occurrence of a weekday in a month, and
   one-off additions on a single date. What a merchandiser visits on a date is
   base ++ weekAdd(nth) ++ dateAdd, deduped by point id. Saving re-materialises the layers into
   self-contained routes and reconciles them against the loaded snapshot, because the mobile app
   resolves one route per date and cannot filter stops by week. */ 

var $cQmXV = parcelRequire("cQmXV");







/* Left pane of the route editor: the points a stop can be added from.
   Normative rules: docs/design/spec/.

   Server-searched (debounced) and PAGINATED — it loads the next page as you scroll
   (`points/?page=N`), so every point is reachable, not just the first page.

   A row is BOTH a drag source and a button. Dragging is the mouse gesture, but native HTML5 drag
   fires no events on a touch screen and cannot be started from the keyboard, so selecting a row
   arms it and the calendar's day cells then offer "Add here". Same action, two routes — see
   docs/design/spec/03-patterns.md#accessibility-floors. */ 

var $cQmXV = parcelRequire("cQmXV");






const $46bcdae26abfb3ba$export$1dad1ee41cc975c4 = "application/x-picsell-point";
// Only the fields the calendar and the save path need.
const $46bcdae26abfb3ba$var$payloadOf = (point)=>({
        id: point.id,
        name: point.name,
        address: point.address,
        locality: point.locality
    });
function $46bcdae26abfb3ba$export$2e2bcd8739ae039({ lang: lang, armed: armed, onArm: onArm }) {
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$7c2d9af61f6af587), key, lang);
    const [term, setTerm] = (0, $cQmXV.useState)("");
    const [results, setResults] = (0, $cQmXV.useState)([]);
    const [hasMore, setHasMore] = (0, $cQmXV.useState)(false);
    const [loading, setLoading] = (0, $cQmXV.useState)(false);
    const pageRef = (0, $cQmXV.useRef)(1);
    const loadingRef = (0, $cQmXV.useRef)(false); // synchronous guard so fast scroll can't double-fetch
    const debounceRef = (0, $cQmXV.useRef)(null);
    const fetchPage = (0, $cQmXV.useCallback)((pageNum, search, append)=>{
        if (loadingRef.current) return;
        loadingRef.current = true;
        setLoading(true);
        const q = search ? `&search=${encodeURIComponent(search)}` : "";
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "GET",
            url: `points/?page=${pageNum}&page_size=${(0, $91ea30cb49819b9a$export$be750171172fb886)}${q}`
        }, (resp)=>{
            const items = Array.isArray(resp) ? resp : resp?.results || [];
            const more = Array.isArray(resp) ? false : Boolean(resp?.next);
            pageRef.current = pageNum;
            setResults((prev)=>append ? [
                    ...prev,
                    ...items
                ] : items);
            setHasMore(more);
            loadingRef.current = false;
            setLoading(false);
        });
    }, []);
    // Debounced search resets to the first page.
    (0, $cQmXV.useEffect)(()=>{
        if (debounceRef.current) clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(()=>fetchPage(1, term, false), (0, $91ea30cb49819b9a$export$8e5d48d2b3bed316));
        return ()=>debounceRef.current && clearTimeout(debounceRef.current);
    }, [
        term,
        fetchPage
    ]);
    const onScroll = (event)=>{
        const el = event.currentTarget;
        if (hasMore && !loadingRef.current && el.scrollTop + el.clientHeight >= el.scrollHeight - 48) fetchPage(pageRef.current + 1, term, true);
    };
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
        vertical: true,
        className: "rc-panel",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                className: "rc-panel__search",
                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0883e7f8083c01b0$export$2e2bcd8739ae039), {
                    value: term,
                    allowClear: true,
                    prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $20a259d46bffcb08$export$2e2bcd8739ae039), {}),
                    placeholder: t("search_placeholder"),
                    "aria-label": t("search_placeholder"),
                    onChange: (event)=>setTerm(event.target.value)
                })
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                className: "rc-panel__armed",
                "aria-live": "polite",
                children: armed ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                    align: "center",
                    gap: 8,
                    children: [
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                            className: "rc-panel__armed-name",
                            ellipsis: {
                                tooltip: armed.name
                            },
                            children: armed.name
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                            type: "secondary",
                            className: "rc-panel__armed-hint",
                            children: t("point_selected")
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                            type: "text",
                            size: "small",
                            icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $837faca566926e3c$export$2e2bcd8739ae039), {}),
                            "aria-label": t("clear_selection"),
                            onClick: ()=>onArm(null)
                        })
                    ]
                }) : null
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                className: "rc-panel__list",
                onScroll: onScroll,
                children: [
                    !loading && results.length === 0 ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $99350450b877904c$export$2e2bcd8739ae039), {
                        image: (0, $99350450b877904c$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE,
                        description: t("no_points_found")
                    }) : results.map((point)=>{
                        const selected = armed?.id === point.id;
                        return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("button", {
                            type: "button",
                            className: `rc-point${selected ? " rc-point--on" : ""}`,
                            "aria-pressed": selected,
                            title: point.address || "",
                            draggable: true,
                            onDragStart: (event)=>{
                                event.dataTransfer.setData($46bcdae26abfb3ba$export$1dad1ee41cc975c4, JSON.stringify($46bcdae26abfb3ba$var$payloadOf(point)));
                                event.dataTransfer.effectAllowed = "copy";
                            },
                            onClick: ()=>onArm(selected ? null : $46bcdae26abfb3ba$var$payloadOf(point)),
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $6567d5702c12b1b9$export$2e2bcd8739ae039), {
                                    className: "rc-point__grip"
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                                    className: "rc-point__body",
                                    children: [
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                            className: "rc-point__name",
                                            children: point.name
                                        }),
                                        point.locality?.name || point.address ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                            className: "rc-point__sub",
                                            children: point.locality?.name || point.address
                                        }) : null
                                    ]
                                })
                            ]
                        }, point.id);
                    }),
                    loading ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e855c7114b2916ed$export$2e2bcd8739ae039), {
                        active: true,
                        paragraph: {
                            rows: 3
                        },
                        title: false,
                        className: "rc-panel__sk"
                    }) : null
                ]
            })
        ]
    });
}


/* The month grid of the route editor.
   Normative rules: docs/design/spec/. No mockup exists for this screen — `merch-detail.html` shows
   only the read-only Routes tab and its "Open route editor" button — so the frame is antd's and the
   cell body is ours.

   antd `<Calendar>` owns the grid: locale weekday headers, the Monday-first column order (from
   `src/util/dayjs.js`), today, out-of-month cells and real `<table>` semantics. We supply
   `headerRender`, because antd's default header is a year + month `<Select>` pair and this editor
   steps one month or one week at a time, and `cellRender`, which is where the stops and the drop
   target live.

   The WEEK view is the same month grid with the five other rows hidden (`rc-calendar--week` +
   `:has(.rc-cell--in)` in style.scss). antd has no week mode, and its six Monday-started rows
   always contain the row of any in-month date, so one grid serves both — no second component, no
   second set of drag-and-drop handlers (PICSELL-1615 #8). In week view the days either side of the
   month that fall inside the week are real, droppable days.

   Two things a supervisor can do to a day, and BOTH must work:
   - drag a point onto it (mouse), and
   - select a point in the panel and activate this day (touch + keyboard).
   Native HTML5 drag fires no events on a touch screen and is unreachable from the keyboard, so the
   second path is not a convenience — see docs/design/spec/03-patterns.md#accessibility-floors. */ 

var $cQmXV = parcelRequire("cQmXV");


var $cQmXV = parcelRequire("cQmXV");









var $cQmXV = parcelRequire("cQmXV");




"use client";
const $2117b5d51f5ff34f$var$YEAR_SELECT_OFFSET = 10;
const $2117b5d51f5ff34f$var$YEAR_SELECT_TOTAL = 20;
function $2117b5d51f5ff34f$var$YearSelect(props) {
    const { fullscreen: fullscreen, validRange: validRange, generateConfig: generateConfig, locale: locale, prefixCls: prefixCls, value: value, onChange: onChange, divRef: divRef } = props;
    const year = generateConfig.getYear(value || generateConfig.getNow());
    let start = year - $2117b5d51f5ff34f$var$YEAR_SELECT_OFFSET;
    let end = start + $2117b5d51f5ff34f$var$YEAR_SELECT_TOTAL;
    if (validRange) {
        start = generateConfig.getYear(validRange[0]);
        end = generateConfig.getYear(validRange[1]) + 1;
    }
    const suffix = locale && locale.year === "\u5E74" ? "\u5E74" : "";
    const options = [];
    for(let index = start; index < end; index++)options.push({
        label: `${index}${suffix}`,
        value: index
    });
    return /*#__PURE__*/ $cQmXV.createElement((0, $872fd39f1285217b$export$2e2bcd8739ae039), {
        size: fullscreen ? undefined : "small",
        options: options,
        value: year,
        className: `${prefixCls}-year-select`,
        onChange: (numYear)=>{
            let newDate = generateConfig.setYear(value, numYear);
            if (validRange) {
                const [startDate, endDate] = validRange;
                const newYear = generateConfig.getYear(newDate);
                const newMonth = generateConfig.getMonth(newDate);
                if (newYear === generateConfig.getYear(endDate) && newMonth > generateConfig.getMonth(endDate)) newDate = generateConfig.setMonth(newDate, generateConfig.getMonth(endDate));
                if (newYear === generateConfig.getYear(startDate) && newMonth < generateConfig.getMonth(startDate)) newDate = generateConfig.setMonth(newDate, generateConfig.getMonth(startDate));
            }
            onChange(newDate);
        },
        getPopupContainer: ()=>divRef.current
    });
}
function $2117b5d51f5ff34f$var$MonthSelect(props) {
    const { prefixCls: prefixCls, fullscreen: fullscreen, validRange: validRange, value: value, generateConfig: generateConfig, locale: locale, onChange: onChange, divRef: divRef } = props;
    const month = generateConfig.getMonth(value || generateConfig.getNow());
    let start = 0;
    let end = 11;
    if (validRange) {
        const [rangeStart, rangeEnd] = validRange;
        const currentYear = generateConfig.getYear(value);
        if (generateConfig.getYear(rangeEnd) === currentYear) end = generateConfig.getMonth(rangeEnd);
        if (generateConfig.getYear(rangeStart) === currentYear) start = generateConfig.getMonth(rangeStart);
    }
    const months = locale.shortMonths || generateConfig.locale.getShortMonths(locale.locale);
    const options = [];
    for(let index = start; index <= end; index += 1)options.push({
        label: months[index],
        value: index
    });
    return /*#__PURE__*/ $cQmXV.createElement((0, $872fd39f1285217b$export$2e2bcd8739ae039), {
        size: fullscreen ? undefined : "small",
        className: `${prefixCls}-month-select`,
        value: month,
        options: options,
        onChange: (newMonth)=>{
            onChange(generateConfig.setMonth(value, newMonth));
        },
        getPopupContainer: ()=>divRef.current
    });
}
function $2117b5d51f5ff34f$var$ModeSwitch(props) {
    const { prefixCls: prefixCls, locale: locale, mode: mode, fullscreen: fullscreen, onModeChange: onModeChange } = props;
    return /*#__PURE__*/ $cQmXV.createElement((0, $2b014885561bf54d$export$2e2bcd8739ae039), {
        onChange: ({ target: { value: value } })=>{
            onModeChange(value);
        },
        value: mode,
        size: fullscreen ? undefined : "small",
        className: `${prefixCls}-mode-switch`
    }, /*#__PURE__*/ $cQmXV.createElement((0, $a51e5de91ab58742$export$2e2bcd8739ae039), {
        value: "month"
    }, locale.month), /*#__PURE__*/ $cQmXV.createElement((0, $a51e5de91ab58742$export$2e2bcd8739ae039), {
        value: "year"
    }, locale.year));
}
function $2117b5d51f5ff34f$var$CalendarHeader(props) {
    const { prefixCls: prefixCls, fullscreen: fullscreen, mode: mode, onChange: onChange, onModeChange: onModeChange, className: className, style: style } = props;
    const divRef = $cQmXV.useRef(null);
    const formItemInputContext = (0, $cQmXV.useContext)((0, $7a3804f153d8a19d$export$bbb5553c6c7a14ed));
    const mergedFormItemInputContext = (0, $cQmXV.useMemo)(()=>({
            ...formItemInputContext,
            isFormItemInput: false
        }), [
        formItemInputContext
    ]);
    const sharedProps = {
        ...props,
        fullscreen: fullscreen,
        divRef: divRef
    };
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-header`, className),
        style: style,
        ref: divRef
    }, /*#__PURE__*/ $cQmXV.createElement((0, $7a3804f153d8a19d$export$bbb5553c6c7a14ed).Provider, {
        value: mergedFormItemInputContext
    }, /*#__PURE__*/ $cQmXV.createElement($2117b5d51f5ff34f$var$YearSelect, {
        ...sharedProps,
        onChange: (v)=>{
            onChange(v, "year");
        }
    }), mode === "month" && /*#__PURE__*/ $cQmXV.createElement($2117b5d51f5ff34f$var$MonthSelect, {
        ...sharedProps,
        onChange: (v)=>{
            onChange(v, "month");
        }
    })), /*#__PURE__*/ $cQmXV.createElement($2117b5d51f5ff34f$var$ModeSwitch, {
        ...sharedProps,
        onModeChange: onModeChange
    }));
}
var $2117b5d51f5ff34f$export$2e2bcd8739ae039 = $2117b5d51f5ff34f$var$CalendarHeader;







const $367514433fba14b4$export$790bf6b82163cd8e = (token)=>{
    const { calendarCls: calendarCls, componentCls: componentCls, fullBg: fullBg, fullPanelBg: fullPanelBg, itemActiveBg: itemActiveBg } = token;
    return {
        [calendarCls]: {
            ...(0, $df004891b355597c$export$da5309fdba1a1b64)(token),
            ...(0, $519d20bf207ce864$export$23997c3e44cc1c59)(token),
            background: fullBg,
            "&-rtl": {
                direction: "rtl"
            },
            [`${calendarCls}-header`]: {
                display: "flex",
                justifyContent: "flex-end",
                padding: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.paddingSM)} 0`,
                [`${calendarCls}-year-select`]: {
                    minWidth: token.yearControlWidth
                },
                [`${calendarCls}-month-select`]: {
                    minWidth: token.monthControlWidth,
                    marginInlineStart: token.marginXS
                },
                [`${calendarCls}-mode-switch`]: {
                    marginInlineStart: token.marginXS
                }
            }
        },
        [`${calendarCls} ${componentCls}-panel`]: {
            background: fullPanelBg,
            border: 0,
            borderTop: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorSplit}`,
            borderRadius: 0,
            [`${componentCls}-month-panel, ${componentCls}-date-panel`]: {
                width: "auto"
            },
            [`${componentCls}-body`]: {
                padding: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.paddingXS)} 0`
            },
            [`${componentCls}-content`]: {
                width: "100%"
            }
        },
        [`${calendarCls}-mini`]: {
            borderRadius: token.borderRadiusLG,
            [`${calendarCls}-header`]: {
                paddingInlineEnd: token.paddingXS,
                paddingInlineStart: token.paddingXS
            },
            [`${componentCls}-panel`]: {
                borderRadius: `0 0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.borderRadiusLG)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.borderRadiusLG)}`
            },
            [`${componentCls}-content`]: {
                height: token.miniContentHeight,
                th: {
                    height: "auto",
                    padding: 0,
                    lineHeight: (0, $05f34ed03d41967d$export$523c0b569236b342)(token.weekHeight)
                }
            },
            [`${componentCls}-cell::before`]: {
                pointerEvents: "none"
            }
        },
        [`${calendarCls}${calendarCls}-full`]: {
            [`${componentCls}-panel`]: {
                display: "block",
                width: "100%",
                textAlign: "end",
                background: fullBg,
                border: 0,
                [`${componentCls}-body`]: {
                    "th, td": {
                        padding: 0
                    },
                    th: {
                        height: "auto",
                        paddingInlineEnd: token.paddingSM,
                        paddingBottom: token.paddingXXS,
                        lineHeight: (0, $05f34ed03d41967d$export$523c0b569236b342)(token.weekHeight)
                    }
                }
            },
            [`${componentCls}-cell-week ${componentCls}-cell-inner`]: {
                display: "block",
                borderRadius: 0,
                borderTop: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidthBold)} ${token.lineType} ${token.colorSplit}`,
                width: "100%",
                height: token.calc(token.dateValueHeight).add(token.dateContentHeight).add(token.calc(token.paddingXS).div(2)).add(token.lineWidthBold).equal()
            },
            [`${componentCls}-cell`]: {
                "&::before": {
                    display: "none"
                },
                "&:hover": {
                    [`${calendarCls}-date`]: {
                        background: token.controlItemBgHover
                    }
                },
                [`${calendarCls}-date-today::before`]: {
                    display: "none"
                },
                // >>> Selected
                [`&-in-view${componentCls}-cell-selected`]: {
                    [`${calendarCls}-date, ${calendarCls}-date-today`]: {
                        background: itemActiveBg
                    }
                },
                "&-selected, &-selected:hover": {
                    [`${calendarCls}-date, ${calendarCls}-date-today`]: {
                        [`${calendarCls}-date-value`]: {
                            color: token.colorPrimary
                        }
                    }
                }
            },
            [`${calendarCls}-date`]: {
                display: "block",
                width: "auto",
                height: "auto",
                margin: `0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.calc(token.marginXS).div(2).equal())}`,
                padding: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.calc(token.paddingXS).div(2).equal())} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.paddingXS)} 0`,
                border: 0,
                borderTop: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidthBold)} ${token.lineType} ${token.colorSplit}`,
                borderRadius: 0,
                transition: `background-color ${token.motionDurationSlow}`,
                "&-value": {
                    lineHeight: (0, $05f34ed03d41967d$export$523c0b569236b342)(token.dateValueHeight),
                    transition: `color ${token.motionDurationSlow}`
                },
                "&-content": {
                    position: "static",
                    width: "auto",
                    height: token.dateContentHeight,
                    overflowY: "auto",
                    color: token.colorText,
                    lineHeight: token.lineHeight,
                    textAlign: "start"
                },
                "&-today": {
                    borderColor: token.colorPrimary,
                    [`${calendarCls}-date-value`]: {
                        color: token.colorText
                    }
                }
            }
        },
        [`@media only screen and (max-width: ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.screenXS)}) `]: {
            [calendarCls]: {
                [`${calendarCls}-header`]: {
                    display: "block",
                    [`${calendarCls}-year-select`]: {
                        width: "50%"
                    },
                    [`${calendarCls}-month-select`]: {
                        width: `calc(50% - ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.paddingXS)})`
                    },
                    [`${calendarCls}-mode-switch`]: {
                        width: "100%",
                        marginTop: token.marginXS,
                        marginInlineStart: 0,
                        "> label": {
                            width: "50%",
                            textAlign: "center"
                        }
                    }
                }
            }
        }
    };
};
const $367514433fba14b4$export$9ca1be8807fe0675 = (token)=>({
        fullBg: token.colorBgContainer,
        fullPanelBg: token.colorBgContainer,
        itemActiveBg: token.controlItemBgActive,
        yearControlWidth: 80,
        monthControlWidth: 70,
        miniContentHeight: 256,
        ...(0, $077bc991481cdc3c$export$e39429f333f3edb3)(token)
    });
var $367514433fba14b4$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$51ec95de45185b42)("Calendar", (token)=>{
    const calendarCls = `${token.componentCls}-calendar`;
    const calendarToken = (0, $fef50f256b80dfa5$export$4950aa0f605343fb)(token, (0, $077bc991481cdc3c$export$5f48700d53e3ff1)(token), {
        calendarCls: calendarCls,
        pickerCellInnerCls: `${token.componentCls}-cell-inner`,
        dateValueHeight: token.controlHeightSM,
        weekHeight: token.calc(token.controlHeightSM).mul(0.75).equal(),
        dateContentHeight: token.calc(token.calc(token.fontHeightSM).add(token.marginXS)).mul(3).add(token.calc(token.lineWidth).mul(2)).equal()
    });
    return $367514433fba14b4$export$790bf6b82163cd8e(calendarToken);
}, $367514433fba14b4$export$9ca1be8807fe0675);


"use client";
const $c069ebac7b106aa5$var$isSameYear = (date1, date2, config)=>{
    const { getYear: getYear } = config;
    return date1 && date2 && getYear(date1) === getYear(date2);
};
const $c069ebac7b106aa5$var$isSameMonth = (date1, date2, config)=>{
    const { getMonth: getMonth } = config;
    return $c069ebac7b106aa5$var$isSameYear(date1, date2, config) && getMonth(date1) === getMonth(date2);
};
const $c069ebac7b106aa5$var$isSameDate = (date1, date2, config)=>{
    const { getDate: getDate } = config;
    return $c069ebac7b106aa5$var$isSameMonth(date1, date2, config) && getDate(date1) === getDate(date2);
};
const $c069ebac7b106aa5$var$generateCalendar = (generateConfig)=>{
    const InternalCalendar = (props, ref)=>{
        const { prefixCls: customizePrefixCls, className: className, rootClassName: rootClassName, style: style, dateFullCellRender: dateFullCellRender, dateCellRender: dateCellRender, monthFullCellRender: monthFullCellRender, monthCellRender: monthCellRender, cellRender: cellRender, fullCellRender: fullCellRender, headerRender: headerRender, value: value, defaultValue: defaultValue, disabledDate: disabledDate, mode: mode, validRange: validRange, fullscreen: fullscreen = true, showWeek: showWeek, onChange: onChange, onPanelChange: onPanelChange, onSelect: onSelect, styles: styles, classNames: classNames } = props;
        const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("calendar");
        // =========== Merged Props for Semantic ===========
        const mergedProps = {
            ...props,
            mode: mode,
            fullscreen: fullscreen,
            showWeek: showWeek
        };
        const contextStyleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(contextStyle);
        const styleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(style);
        const [mergedClassNames, mergedStyles] = (0, $30c5f9f911d4f61b$export$648566b068f28737)([
            contextClassNames,
            classNames
        ], [
            contextStyles,
            contextStyleRoot,
            styles,
            styleRoot
        ], {
            props: mergedProps
        });
        const [rootCls, headerCls, panelClassNames, rootStyle, headerStyle, panelStyles] = $cQmXV.useMemo(()=>{
            const { root: nextRootClassName, header: nextHeaderClassName, ...nextPanelClassNames } = mergedClassNames;
            const { root: nextRootStyle, header: nextHeaderStyle, ...nextPanelStyles } = mergedStyles;
            return [
                nextRootClassName,
                nextHeaderClassName,
                nextPanelClassNames,
                nextRootStyle,
                nextHeaderStyle,
                nextPanelStyles
            ];
        }, [
            mergedClassNames,
            mergedStyles
        ]);
        const mergedItemContentClassName = mergedClassNames.itemContent;
        const mergedItemContentStyle = mergedStyles.itemContent;
        const prefixCls = getPrefixCls("picker", customizePrefixCls);
        const calendarPrefixCls = `${prefixCls}-calendar`;
        const [hashId, cssVarCls] = (0, $367514433fba14b4$export$2e2bcd8739ae039)(prefixCls, calendarPrefixCls);
        const today = generateConfig.getNow();
        var deprecatedName, newName;
        // ====================== State =======================
        // Value
        const [mergedValue, setMergedValue] = (0, $a51866d781137e08$export$2e2bcd8739ae039)(()=>defaultValue || generateConfig.getNow(), value);
        // Mode
        const [mergedMode, setMergedMode] = (0, $a51866d781137e08$export$2e2bcd8739ae039)("month", mode);
        const panelMode = $cQmXV.useMemo(()=>mergedMode === "year" ? "month" : "date", [
            mergedMode
        ]);
        // Disabled Date
        const mergedDisabledDate = $cQmXV.useCallback((date)=>{
            const notInRange = validRange ? generateConfig.isAfter(validRange[0], date) || generateConfig.isAfter(date, validRange[1]) : false;
            return notInRange || !!disabledDate?.(date);
        }, [
            disabledDate,
            validRange
        ]);
        // ====================== Events ======================
        const triggerPanelChange = (date, newMode)=>{
            onPanelChange?.(date, newMode);
        };
        const triggerChange = (date)=>{
            setMergedValue(date);
            if (!$c069ebac7b106aa5$var$isSameDate(date, mergedValue, generateConfig)) {
                // Trigger when month panel switch month
                if (panelMode === "date" && !$c069ebac7b106aa5$var$isSameMonth(date, mergedValue, generateConfig) || panelMode === "month" && !$c069ebac7b106aa5$var$isSameYear(date, mergedValue, generateConfig)) triggerPanelChange(date, mergedMode);
                onChange?.(date);
            }
        };
        const triggerModeChange = (newMode)=>{
            setMergedMode(newMode);
            triggerPanelChange(mergedValue, newMode);
        };
        const onInternalSelect = (date, source)=>{
            triggerChange(date);
            onSelect?.(date, {
                source: source
            });
        };
        // ====================== Render ======================
        const dateRender = $cQmXV.useCallback((date, info)=>{
            if ((0, $8e2d153a3c855782$export$f6e2535fb5126e54)(fullCellRender)) return fullCellRender(date, info);
            if ((0, $8e2d153a3c855782$export$f6e2535fb5126e54)(dateFullCellRender)) return dateFullCellRender(date);
            return /*#__PURE__*/ $cQmXV.createElement("div", {
                className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-cell-inner`, `${calendarPrefixCls}-date`, {
                    [`${calendarPrefixCls}-date-today`]: $c069ebac7b106aa5$var$isSameDate(today, date, generateConfig)
                })
            }, /*#__PURE__*/ $cQmXV.createElement("div", {
                className: `${calendarPrefixCls}-date-value`
            }, String(generateConfig.getDate(date)).padStart(2, "0")), /*#__PURE__*/ $cQmXV.createElement("div", {
                className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${calendarPrefixCls}-date-content`, mergedItemContentClassName),
                style: mergedItemContentStyle
            }, (0, $8e2d153a3c855782$export$f6e2535fb5126e54)(cellRender) ? cellRender(date, info) : dateCellRender?.(date)));
        }, [
            today,
            prefixCls,
            calendarPrefixCls,
            fullCellRender,
            dateFullCellRender,
            cellRender,
            dateCellRender,
            mergedItemContentClassName,
            mergedItemContentStyle
        ]);
        const monthRender = $cQmXV.useCallback((date, info)=>{
            if (fullCellRender) return fullCellRender(date, info);
            if (monthFullCellRender) return monthFullCellRender(date);
            const months = info.locale.shortMonths || generateConfig.locale.getShortMonths(info.locale.locale);
            return /*#__PURE__*/ $cQmXV.createElement("div", {
                className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-cell-inner`, `${calendarPrefixCls}-date`, {
                    [`${calendarPrefixCls}-date-today`]: $c069ebac7b106aa5$var$isSameMonth(today, date, generateConfig)
                })
            }, /*#__PURE__*/ $cQmXV.createElement("div", {
                className: `${calendarPrefixCls}-date-value`
            }, months[generateConfig.getMonth(date)]), /*#__PURE__*/ $cQmXV.createElement("div", {
                className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${calendarPrefixCls}-date-content`, mergedItemContentClassName),
                style: mergedItemContentStyle
            }, (0, $8e2d153a3c855782$export$f6e2535fb5126e54)(cellRender) ? cellRender(date, info) : monthCellRender?.(date)));
        }, [
            today,
            prefixCls,
            calendarPrefixCls,
            fullCellRender,
            monthFullCellRender,
            cellRender,
            monthCellRender,
            mergedItemContentClassName,
            mergedItemContentStyle
        ]);
        const [contextLocale] = (0, $c953dac9d015386e$export$2e2bcd8739ae039)("Calendar", (0, $ee6aa9cc160357b8$export$2e2bcd8739ae039));
        const locale = (0, $a3099986deccaee4$export$4950aa0f605343fb)(contextLocale, props.locale || {});
        const mergedCellRender = (current, info)=>{
            if (info.type === "date") return dateRender(current, info);
            if (info.type === "month") return monthRender(current, {
                ...info,
                locale: locale?.lang
            });
        };
        const nativeElementRef = $cQmXV.useRef(null);
        $cQmXV.useImperativeHandle(ref, ()=>({
                nativeElement: nativeElementRef.current
            }));
        return /*#__PURE__*/ $cQmXV.createElement("div", {
            ref: nativeElementRef,
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(calendarPrefixCls, {
                [`${calendarPrefixCls}-full`]: fullscreen,
                [`${calendarPrefixCls}-mini`]: !fullscreen,
                [`${calendarPrefixCls}-rtl`]: direction === "rtl"
            }, contextClassName, className, rootClassName, rootCls, hashId, cssVarCls),
            style: rootStyle
        }, headerRender ? headerRender({
            value: mergedValue,
            type: mergedMode,
            onChange: (nextDate)=>{
                onInternalSelect(nextDate, "customize");
            },
            onTypeChange: triggerModeChange
        }) : /*#__PURE__*/ $cQmXV.createElement((0, $2117b5d51f5ff34f$export$2e2bcd8739ae039), {
            className: headerCls,
            style: headerStyle,
            prefixCls: calendarPrefixCls,
            value: mergedValue,
            generateConfig: generateConfig,
            mode: mergedMode,
            fullscreen: fullscreen,
            locale: locale?.lang,
            validRange: validRange,
            onChange: onInternalSelect,
            onModeChange: triggerModeChange
        }), /*#__PURE__*/ $cQmXV.createElement((0, $14b1cd9c5ed0d63c$export$2e2bcd8739ae039), {
            classNames: panelClassNames,
            styles: panelStyles,
            value: mergedValue,
            prefixCls: prefixCls,
            locale: locale?.lang,
            generateConfig: generateConfig,
            cellRender: mergedCellRender,
            onSelect: (nextDate)=>{
                onInternalSelect(nextDate, panelMode);
            },
            mode: panelMode,
            picker: panelMode,
            disabledDate: mergedDisabledDate,
            hideHeader: true,
            showWeek: showWeek
        }));
    };
    const Calendar = /*#__PURE__*/ $cQmXV.forwardRef(InternalCalendar);
    return Calendar;
};
var $c069ebac7b106aa5$export$2e2bcd8739ae039 = $c069ebac7b106aa5$var$generateCalendar;


"use client";
const $6d5564adac048079$var$Calendar = (0, $c069ebac7b106aa5$export$2e2bcd8739ae039)((0, $ea5f06974ef1da16$export$2e2bcd8739ae039));
$6d5564adac048079$var$Calendar.generateCalendar = (0, $c069ebac7b106aa5$export$2e2bcd8739ae039);
var $6d5564adac048079$export$2e2bcd8739ae039 = $6d5564adac048079$var$Calendar;



var $cQmXV = parcelRequire("cQmXV");
var $7e01be4f5f19316c$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($7e01be4f5f19316c$exports, "__esModule", {
    value: true
});
var $7e01be4f5f19316c$var$ArrowUpOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M868 545.5L536.1 163a31.96 31.96 0 00-48.3 0L156 545.5a7.97 7.97 0 006 13.2h81c4.6 0 9-2 12.1-5.5L474 300.9V864c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V300.9l218.9 252.3c3 3.5 7.4 5.5 12.1 5.5h81c6.8 0 10.5-8 6-13.2z"
                }
            }
        ]
    },
    "name": "arrow-up",
    "theme": "outlined"
};
$7e01be4f5f19316c$exports.default = $7e01be4f5f19316c$var$ArrowUpOutlined;



function $07363fed012909ee$var$_extends() {
    $07363fed012909ee$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $07363fed012909ee$var$_extends.apply(this, arguments);
}
const $07363fed012909ee$var$ArrowUpOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $07363fed012909ee$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7e01be4f5f19316c$exports)))
    }));
/**![arrow-up](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg2OCA1NDUuNUw1MzYuMSAxNjNhMzEuOTYgMzEuOTYgMCAwMC00OC4zIDBMMTU2IDU0NS41YTcuOTcgNy45NyAwIDAwNiAxMy4yaDgxYzQuNiAwIDktMiAxMi4xLTUuNUw0NzQgMzAwLjlWODY0YzAgNC40IDMuNiA4IDggOGg2MGM0LjQgMCA4LTMuNiA4LThWMzAwLjlsMjE4LjkgMjUyLjNjMyAzLjUgNy40IDUuNSAxMi4xIDUuNWg4MWM2LjggMCAxMC41LTggNi0xMy4yeiIgLz48L3N2Zz4=) */ const $07363fed012909ee$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($07363fed012909ee$var$ArrowUpOutlined);
var $07363fed012909ee$export$2e2bcd8739ae039 = $07363fed012909ee$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $bebbe5e761bce6ac$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($bebbe5e761bce6ac$exports, "__esModule", {
    value: true
});
var $bebbe5e761bce6ac$var$ArrowDownOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M862 465.3h-81c-4.6 0-9 2-12.1 5.5L550 723.1V160c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v563.1L255.1 470.8c-3-3.5-7.4-5.5-12.1-5.5h-81c-6.8 0-10.5 8.1-6 13.2L487.9 861a31.96 31.96 0 0048.3 0L868 478.5c4.5-5.2.8-13.2-6-13.2z"
                }
            }
        ]
    },
    "name": "arrow-down",
    "theme": "outlined"
};
$bebbe5e761bce6ac$exports.default = $bebbe5e761bce6ac$var$ArrowDownOutlined;



function $2421974510732990$var$_extends() {
    $2421974510732990$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2421974510732990$var$_extends.apply(this, arguments);
}
const $2421974510732990$var$ArrowDownOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $2421974510732990$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bebbe5e761bce6ac$exports)))
    }));
/**![arrow-down](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg2MiA0NjUuM2gtODFjLTQuNiAwLTkgMi0xMi4xIDUuNUw1NTAgNzIzLjFWMTYwYzAtNC40LTMuNi04LTgtOGgtNjBjLTQuNCAwLTggMy42LTggOHY1NjMuMUwyNTUuMSA0NzAuOGMtMy0zLjUtNy40LTUuNS0xMi4xLTUuNWgtODFjLTYuOCAwLTEwLjUgOC4xLTYgMTMuMkw0ODcuOSA4NjFhMzEuOTYgMzEuOTYgMCAwMDQ4LjMgMEw4NjggNDc4LjVjNC41LTUuMi44LTEzLjItNi0xMy4yeiIgLz48L3N2Zz4=) */ const $2421974510732990$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($2421974510732990$var$ArrowDownOutlined);
var $2421974510732990$export$2e2bcd8739ae039 = $2421974510732990$var$RefIcon;






// Layered model for the route calendar.
//
// A merchandiser's schedule is edited as three ADDITIVE layers (not self-contained buckets):
//   base[wd]            recurring weekly stops for weekday wd (Mon=0..Sun=6)
//   weekAdd[wd][nth]    EXTRA stops layered on top of base for the Nth occurrence of wd
//   dateAdd[YYYY-MM-DD] EXTRA stops layered on top of base(+weekAdd) for one specific date
//
// The stops a merchandiser actually visits on a date = base ++ weekAdd(that Nth) ++ dateAdd,
// concatenated in that order and de-duplicated by point id. So periodic points always apply
// to every day they recur on, and one-off points are pure additions on a single date.
//
// The mobile API still reads one self-contained route per date (GET /routes then /order, no
// date on /order). So on save we MATERIALIZE each occurrence that has additions into a route
// carrying the full merged stop list, keyed so the server filter resolves the right one:
//   base  -> "w{wd}"        (day_of_the_week=wd, week_of_month=NULL)
//   nth   -> "n{wd}_{nth}"  (day_of_the_week=wd, week_of_month=nth) stops = base+weekAdd
//   date  -> "d{date}"      (day_of_the_week=NULL, start/end=date)  stops = base+weekAdd+dateAdd
/* Explicit `.js` so this module also loads under plain node — `yarn check:routes` imports it
   directly, the same trick `tracking/derive.js` plays for `check:tracking`. */ 
const $29ff8c829ff33c74$export$4565335787d39d1e = (wd)=>`w${wd}`;
const $29ff8c829ff33c74$export$1c909ebeb219bebc = (wd, nth)=>`n${wd}_${nth}`;
const $29ff8c829ff33c74$export$b77d6fb52904647d = (ds)=>`d${ds}`;
const $29ff8c829ff33c74$export$57946e615fde2ef9 = (key)=>key[0] === "w";
const $29ff8c829ff33c74$export$5970e27c1aba6f13 = (key)=>key[0] === "n";
const $29ff8c829ff33c74$export$58e5ef6625e9cc03 = (key)=>key[0] === "d";
const $29ff8c829ff33c74$var$emptyLayers = ()=>({
        base: {},
        week: {},
        date: {}
    });
// Ordered list of point-stops from a route's nested order_set.
// `from` is the day the stop was ADDED (Order.created, date-only): recurring layers do not
// apply before it, so a point dropped on a Wednesday stops showing on every PAST Wednesday
// (PICSELL-1581 #13). ⚠ Approximate by construction: the save reconcile recreates a whole
// route when its stop list changes, which resets every Order's `created` — so an edited
// route's stops date from the edit, not from their first appearance. That errs toward
// showing FEWER past dates, which is the direction the complaint points. Absent `created`
// (mobile serializer, pre-deploy payloads) the stop renders on every date, as before.
const $29ff8c829ff33c74$var$stopsFromRoute = (route)=>(route.points || []).filter((o)=>o && o.point).slice().sort((a, b)=>(a.order ?? 0) - (b.order ?? 0)).map((o)=>({
            point: o.point,
            from: o.created ? String(o.created).slice(0, 10) : null
        }));
const $29ff8c829ff33c74$export$5c77ee1a952795e1 = (route)=>{
    if (route.start) return $29ff8c829ff33c74$export$b77d6fb52904647d(route.start.slice(0, 10));
    if (route.week_of_month != null && route.day_of_the_week != null) return $29ff8c829ff33c74$export$1c909ebeb219bebc(route.day_of_the_week, route.week_of_month);
    if (route.day_of_the_week != null) return $29ff8c829ff33c74$export$4565335787d39d1e(route.day_of_the_week);
    return null;
};
const $29ff8c829ff33c74$var$appendUnique = (arr, stops)=>{
    const seen = new Set(arr.map((s)=>s.point.id));
    stops.forEach((s)=>{
        if (!seen.has(s.point.id)) {
            arr.push(s);
            seen.add(s.point.id);
        }
    });
};
const $29ff8c829ff33c74$export$65638ff2f6061a77 = (routes)=>{
    const layers = $29ff8c829ff33c74$var$emptyLayers();
    const loaded = {};
    const extraDeletedIds = [];
    const list = (routes || []).filter((r)=>$29ff8c829ff33c74$export$5c77ee1a952795e1(r));
    const byKind = (kindTest)=>list.filter((r)=>kindTest($29ff8c829ff33c74$export$5c77ee1a952795e1(r)));
    const register = (key, route)=>{
        if (!loaded[key]) loaded[key] = {
            id: route.id || null,
            pointIds: $29ff8c829ff33c74$var$stopsFromRoute(route).map((s)=>s.point.id)
        };
        else if (route.id) extraDeletedIds.push(route.id); // duplicate slot -> delete extra on save
    };
    // 1) base (week_of_month = NULL)
    byKind($29ff8c829ff33c74$export$57946e615fde2ef9).forEach((route)=>{
        const wd = route.day_of_the_week;
        layers.base[wd] = layers.base[wd] || [];
        $29ff8c829ff33c74$var$appendUnique(layers.base[wd], $29ff8c829ff33c74$var$stopsFromRoute(route));
        register($29ff8c829ff33c74$export$4565335787d39d1e(wd), route);
    });
    // 2) Nth-weekday: extras = route stops not already in base[wd]
    byKind($29ff8c829ff33c74$export$5970e27c1aba6f13).forEach((route)=>{
        const wd = route.day_of_the_week;
        const nth = route.week_of_month;
        const baseIds = new Set((layers.base[wd] || []).map((s)=>s.point.id));
        layers.week[wd] = layers.week[wd] || {};
        layers.week[wd][nth] = layers.week[wd][nth] || [];
        $29ff8c829ff33c74$var$appendUnique(layers.week[wd][nth], $29ff8c829ff33c74$var$stopsFromRoute(route).filter((s)=>!baseIds.has(s.point.id)));
        register($29ff8c829ff33c74$export$1c909ebeb219bebc(wd, nth), route);
    });
    // 3) one-off date: extras = route stops not already in base(+weekAdd for that occurrence)
    byKind($29ff8c829ff33c74$export$58e5ef6625e9cc03).forEach((route)=>{
        const ds = route.start.slice(0, 10);
        const [y, m, d] = ds.split("-").map(Number);
        const dt = new Date(y, m - 1, d);
        const wd = (0, $7d0f78de0b68a104$export$56c97ca1cde8c5bb)(dt);
        const nth = (0, $7d0f78de0b68a104$export$83a45ae2ed9f0324)(dt);
        const covered = new Set([
            ...(layers.base[wd] || []).map((s)=>s.point.id),
            ...(layers.week[wd] && layers.week[wd][nth] || []).map((s)=>s.point.id)
        ]);
        layers.date[ds] = layers.date[ds] || [];
        $29ff8c829ff33c74$var$appendUnique(layers.date[ds], $29ff8c829ff33c74$var$stopsFromRoute(route).filter((s)=>!covered.has(s.point.id)));
        register($29ff8c829ff33c74$export$b77d6fb52904647d(ds), route);
    });
    return {
        layers: layers,
        loaded: loaded,
        extraDeletedIds: extraDeletedIds
    };
};
const $29ff8c829ff33c74$export$2a8916ca8520a9cf = (date, layers)=>{
    const wd = (0, $7d0f78de0b68a104$export$56c97ca1cde8c5bb)(date);
    const nth = (0, $7d0f78de0b68a104$export$83a45ae2ed9f0324)(date);
    const ds = (0, $7d0f78de0b68a104$export$6dce03e22a5971e7)(date);
    const out = [];
    const seen = new Set();
    /* `gate`: recurring layers do not apply before the day their stop was added (#1581 #13).
     A one-off IS its date, so the date layer is never gated. YYYY-MM-DD compares as a string. */ const take = (arr, layer, layerKey, gate)=>(arr || []).forEach((s)=>{
            if (gate && s.from && ds < s.from) return;
            if (!seen.has(s.point.id)) {
                seen.add(s.point.id);
                out.push({
                    point: s.point,
                    layer: layer,
                    layerKey: layerKey
                });
            }
        });
    take(layers.base[wd], "base", $29ff8c829ff33c74$export$4565335787d39d1e(wd), true);
    take(layers.week[wd] && layers.week[wd][nth], "week", $29ff8c829ff33c74$export$1c909ebeb219bebc(wd, nth), true);
    take(layers.date[ds], "date", $29ff8c829ff33c74$export$b77d6fb52904647d(ds), false);
    return out;
};
const $29ff8c829ff33c74$export$7a2b93116fc1d87 = (key, { userId: userId, createdBy: createdBy, title: title })=>{
    const spec = {
        title: title || "",
        user: userId,
        created_by: createdBy ?? null,
        day_of_the_week: null,
        week_of_month: null,
        start: null,
        end: null
    };
    if ($29ff8c829ff33c74$export$57946e615fde2ef9(key)) spec.day_of_the_week = Number(key.slice(1));
    else if ($29ff8c829ff33c74$export$5970e27c1aba6f13(key)) {
        const [wd, nth] = key.slice(1).split("_").map(Number);
        spec.day_of_the_week = wd;
        spec.week_of_month = nth;
    } else if ($29ff8c829ff33c74$export$58e5ef6625e9cc03(key)) {
        const d = key.slice(1);
        spec.start = `${d}T00:00:00`;
        spec.end = `${d}T23:59:59`;
    }
    return spec;
};
const $29ff8c829ff33c74$var$mergeStops = (...lists)=>{
    const out = [];
    const seen = new Set();
    lists.forEach((list)=>(list || []).forEach((s)=>{
            if (!seen.has(s.point.id)) {
                seen.add(s.point.id);
                out.push({
                    point: s.point
                });
            }
        }));
    return out;
};
const $29ff8c829ff33c74$export$9f54b2050a902133 = (layers)=>{
    const out = [];
    Object.entries(layers.base).forEach(([wd, stops])=>{
        if (stops && stops.length) out.push({
            key: $29ff8c829ff33c74$export$4565335787d39d1e(Number(wd)),
            stops: stops.slice()
        });
    });
    Object.entries(layers.week).forEach(([wd, byNth])=>Object.entries(byNth || {}).forEach(([nth, stops])=>{
            if (stops && stops.length) out.push({
                key: $29ff8c829ff33c74$export$1c909ebeb219bebc(Number(wd), Number(nth)),
                stops: $29ff8c829ff33c74$var$mergeStops(layers.base[wd], stops)
            });
        }));
    Object.entries(layers.date).forEach(([ds, stops])=>{
        if (stops && stops.length) {
            const [y, m, d] = ds.split("-").map(Number);
            const dt = new Date(y, m - 1, d);
            const wd = (0, $7d0f78de0b68a104$export$56c97ca1cde8c5bb)(dt);
            const nth = (0, $7d0f78de0b68a104$export$83a45ae2ed9f0324)(dt);
            out.push({
                key: $29ff8c829ff33c74$export$b77d6fb52904647d(ds),
                stops: $29ff8c829ff33c74$var$mergeStops(layers.base[wd], layers.week[wd] && layers.week[wd][nth], stops)
            });
        }
    });
    return out;
};
const $29ff8c829ff33c74$export$3e8e9e58c013b76b = (routeId, stops)=>(stops || []).map((s, idx)=>({
            route: routeId,
            point: s.point.id,
            order: idx
        }));
// ---- immutable layer edits -------------------------------------------------
const $29ff8c829ff33c74$var$cloneLayers = (layers)=>({
        base: {
            ...layers.base
        },
        week: Object.fromEntries(Object.entries(layers.week).map(([wd, byNth])=>[
                wd,
                {
                    ...byNth
                }
            ])),
        date: {
            ...layers.date
        }
    });
// Which layer array a scope writes to for a given date.
const $29ff8c829ff33c74$var$containerFor = (layers, scope, wd, nth, ds)=>{
    if (scope === "every") return {
        get: ()=>layers.base[wd],
        set: (v)=>layers.base[wd] = v
    };
    if (scope === "nth") {
        layers.week[wd] = {
            ...layers.week[wd] || {}
        };
        return {
            get: ()=>layers.week[wd][nth],
            set: (v)=>layers.week[wd][nth] = v
        };
    }
    return {
        get: ()=>layers.date[ds],
        set: (v)=>layers.date[ds] = v
    };
};
// True if the point is already effective for `scope` on `date` (avoids cross-layer dupes).
const $29ff8c829ff33c74$var$alreadyPresent = (layers, scope, wd, nth, ds, pointId)=>{
    const inArr = (arr)=>(arr || []).some((s)=>s.point.id === pointId);
    if (inArr(layers.base[wd])) return true;
    if (scope === "every") return false;
    if (inArr(layers.week[wd] && layers.week[wd][nth])) return true;
    if (scope === "nth") return false;
    return inArr(layers.date[ds]);
};
const $29ff8c829ff33c74$export$7ed91a9c68d5a769 = (layers, scope, date, point)=>{
    const wd = (0, $7d0f78de0b68a104$export$56c97ca1cde8c5bb)(date);
    const nth = (0, $7d0f78de0b68a104$export$83a45ae2ed9f0324)(date);
    const ds = (0, $7d0f78de0b68a104$export$6dce03e22a5971e7)(date);
    if ($29ff8c829ff33c74$var$alreadyPresent(layers, scope, wd, nth, ds, point.id)) return layers;
    const next = $29ff8c829ff33c74$var$cloneLayers(layers);
    const c = $29ff8c829ff33c74$var$containerFor(next, scope, wd, nth, ds);
    /* `from` = today, which is also what Order.created will say after the save — the editor and
     the reloaded state agree on which past dates the stop does NOT apply to. */ c.set([
        ...c.get() || [],
        {
            point: point,
            from: (0, $7d0f78de0b68a104$export$6dce03e22a5971e7)(new Date())
        }
    ]);
    return next;
};
const $29ff8c829ff33c74$export$141714a8c5e66bf1 = (date)=>{
    const nth = (0, $7d0f78de0b68a104$export$83a45ae2ed9f0324)(date);
    if (nth === 1 || nth === 3) return [
        1,
        3
    ];
    if (nth === 2 || nth === 4) return [
        2,
        4
    ];
    return null; // a 5th occurrence pairs with nothing
};
const $29ff8c829ff33c74$export$370a25ad77fd0302 = (layers, date, point)=>{
    const pair = $29ff8c829ff33c74$export$141714a8c5e66bf1(date);
    if (!pair) return layers;
    const wd = (0, $7d0f78de0b68a104$export$56c97ca1cde8c5bb)(date);
    const ds = (0, $7d0f78de0b68a104$export$6dce03e22a5971e7)(date);
    const from = (0, $7d0f78de0b68a104$export$6dce03e22a5971e7)(new Date());
    let next = layers;
    pair.forEach((nth)=>{
        if ($29ff8c829ff33c74$var$alreadyPresent(next, "nth", wd, nth, ds, point.id)) return;
        next = $29ff8c829ff33c74$var$cloneLayers(next);
        const c = $29ff8c829ff33c74$var$containerFor(next, "nth", wd, nth, ds);
        c.set([
            ...c.get() || [],
            {
                point: point,
                from: from
            }
        ]);
    });
    return next;
};
const $29ff8c829ff33c74$var$parseLayerKey = (key)=>{
    if ($29ff8c829ff33c74$export$57946e615fde2ef9(key)) return {
        kind: "base",
        wd: Number(key.slice(1))
    };
    if ($29ff8c829ff33c74$export$5970e27c1aba6f13(key)) {
        const [wd, nth] = key.slice(1).split("_").map(Number);
        return {
            kind: "week",
            wd: wd,
            nth: nth
        };
    }
    return {
        kind: "date",
        ds: key.slice(1)
    };
};
const $29ff8c829ff33c74$var$layerArray = (layers, layerKey)=>{
    const p = $29ff8c829ff33c74$var$parseLayerKey(layerKey);
    if (p.kind === "base") return layers.base[p.wd] || [];
    if (p.kind === "week") return layers.week[p.wd] && layers.week[p.wd][p.nth] || [];
    return layers.date[p.ds] || [];
};
const $29ff8c829ff33c74$var$setLayerArray = (layers, layerKey, arr)=>{
    const p = $29ff8c829ff33c74$var$parseLayerKey(layerKey);
    if (p.kind === "base") {
        if (arr.length) layers.base[p.wd] = arr;
        else delete layers.base[p.wd];
    } else if (p.kind === "week") {
        layers.week[p.wd] = {
            ...layers.week[p.wd] || {}
        };
        if (arr.length) layers.week[p.wd][p.nth] = arr;
        else delete layers.week[p.wd][p.nth];
    } else if (arr.length) layers.date[p.ds] = arr;
    else delete layers.date[p.ds];
};
const $29ff8c829ff33c74$export$60c41cdd2b94234a = (layers, layerKey, pointId)=>{
    const next = $29ff8c829ff33c74$var$cloneLayers(layers);
    $29ff8c829ff33c74$var$setLayerArray(next, layerKey, $29ff8c829ff33c74$var$layerArray(next, layerKey).filter((s)=>s.point.id !== pointId));
    return next;
};
const $29ff8c829ff33c74$export$31938668dbeb9fa6 = (layers, layerKey, pointId, dir)=>{
    const arr = $29ff8c829ff33c74$var$layerArray(layers, layerKey).slice();
    const i = arr.findIndex((s)=>s.point.id === pointId);
    const j = i + dir;
    if (i < 0 || j < 0 || j >= arr.length) return layers;
    const next = $29ff8c829ff33c74$var$cloneLayers(layers);
    [arr[i], arr[j]] = [
        arr[j],
        arr[i]
    ];
    $29ff8c829ff33c74$var$setLayerArray(next, layerKey, arr);
    return next;
};



const $32cae9e7215e741e$var$ORDINAL_KEY = {
    1: "ord_first",
    2: "ord_second",
    3: "ord_third",
    4: "ord_fourth",
    5: "ord_fifth"
};
/* The absence covering a date, if any. Absence.start/end are datetimes; date-only compare keeps
   both boundary days inside the range. */ const $32cae9e7215e741e$var$absenceFor = (absences, date)=>{
    const ds = (0, $7d0f78de0b68a104$export$6dce03e22a5971e7)(date);
    return (absences || []).find((a)=>a.start && a.end && String(a.start).slice(0, 10) <= ds && ds <= String(a.end).slice(0, 10)) || null;
};
/**
 * Which layer a stop came from, as a `<Tag>`.
 *
 * The three layers are additive and a day shows all of them at once, so the badge is the only thing
 * saying whether removing this stop affects one date or every matching weekday. It is a word, not
 * just a colour (spec/01: colour is never the only signal).
 */ const $32cae9e7215e741e$var$layerBadge = (stop, date, lang)=>{
    if ((0, $29ff8c829ff33c74$export$58e5ef6625e9cc03)(stop.layerKey)) return {
        text: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$7c2d9af61f6af587), "badge_date", lang),
        tone: "date"
    };
    if ((0, $29ff8c829ff33c74$export$5970e27c1aba6f13)(stop.layerKey)) return {
        text: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$7c2d9af61f6af587), $32cae9e7215e741e$var$ORDINAL_KEY[(0, $7d0f78de0b68a104$export$83a45ae2ed9f0324)(date)], lang),
        tone: "nth"
    };
    return {
        text: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$7c2d9af61f6af587), "badge_weekly", lang),
        tone: "weekly"
    };
};
function $32cae9e7215e741e$var$DayCell({ date: date, inMonth: inMonth, layers: layers, lang: lang, armed: armed, absence: absence, onDrop: onDrop, onPlace: onPlace, onRemove: onRemove, onMove: onMove }) {
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$7c2d9af61f6af587), key, lang);
    const [over, setOver] = (0, $cQmXV.useState)(false);
    const stops = inMonth ? (0, $29ff8c829ff33c74$export$2a8916ca8520a9cf)(date, layers) : [];
    /* An absence day refuses NEW stops (drop + place) but keeps showing what is already planned,
     and remove/move stay available — the lock is on assignment, not on cleanup (#1581 #14). */ const locked = Boolean(absence);
    const handleDrop = (event)=>{
        event.preventDefault();
        setOver(false);
        if (!inMonth || locked) return;
        const raw = event.dataTransfer.getData((0, $46bcdae26abfb3ba$export$1dad1ee41cc975c4));
        if (!raw) return;
        try {
            onDrop(date, JSON.parse(raw));
        } catch (_) {
        /* ignore malformed payloads */ }
    };
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
        className: `rc-cell${inMonth ? " rc-cell--in" : ""}${over ? " rc-cell--over" : ""}${armed && inMonth && !locked ? " rc-cell--armed" : ""}${locked && inMonth ? " rc-cell--absent" : ""}`,
        onDragOver: (event)=>{
            if (!inMonth || locked) return;
            event.preventDefault();
            event.dataTransfer.dropEffect = "copy";
            if (!over) setOver(true);
        },
        onDragLeave: ()=>over && setOver(false),
        onDrop: handleDrop,
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                vertical: true,
                gap: 4,
                className: "rc-cell__stops",
                children: stops.map((stop, index)=>{
                    const badge = $32cae9e7215e741e$var$layerBadge(stop, date, lang);
                    /* A stop only reorders within its OWN layer — the base order is the recurring route's
             order and moving across layers would mean nothing. */ const canUp = index > 0 && stops[index - 1].layerKey === stop.layerKey;
                    const canDown = index < stops.length - 1 && stops[index + 1].layerKey === stop.layerKey;
                    return(/* Two lines, name first. A month grid gives each column ~115px, which a badge, a name
               and three buttons cannot share — measured at the earlier ~84px, the name collapsed
               to 0px wide. The name is what is being read, so it gets the full width and the
               badge sits under it. */ /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                        className: "rc-stop",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                className: "rc-stop__name",
                                ellipsis: {
                                    tooltip: stop.point.address || stop.point.name
                                },
                                children: stop.point.name
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $602120e6d17ff12a$export$2e2bcd8739ae039), {
                                variant: "filled",
                                className: `rc-badge rc-badge--${badge.tone}`,
                                children: badge.text
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                className: "rc-stop__acts",
                                gap: 0,
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                        type: "text",
                                        size: "small",
                                        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $07363fed012909ee$export$2e2bcd8739ae039), {}),
                                        disabled: !canUp,
                                        "aria-label": t("move_up"),
                                        onClick: ()=>onMove(stop.layerKey, stop.point.id, -1)
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                        type: "text",
                                        size: "small",
                                        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2421974510732990$export$2e2bcd8739ae039), {}),
                                        disabled: !canDown,
                                        "aria-label": t("move_down"),
                                        onClick: ()=>onMove(stop.layerKey, stop.point.id, 1)
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                        type: "text",
                                        size: "small",
                                        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $837faca566926e3c$export$2e2bcd8739ae039), {}),
                                        "aria-label": t("remove_stop"),
                                        onClick: ()=>onRemove(stop.layerKey, stop.point.id)
                                    })
                                ]
                            })
                        ]
                    }, `${stop.layerKey}_${stop.point.id}`));
                })
            }),
            locked && inMonth ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $602120e6d17ff12a$export$2e2bcd8739ae039), {
                variant: "filled",
                className: "rc-badge rc-badge--absent",
                title: absence.reason || undefined,
                children: absence.reason || t("absent_day")
            }) : null,
            armed && inMonth && !locked ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                className: "rc-cell__place",
                size: "small",
                type: "dashed",
                block: true,
                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $fa25166ced813feb$export$2e2bcd8739ae039), {}),
                onClick: ()=>onPlace(date),
                children: t("add_here")
            }) : null
        ]
    });
}
function $32cae9e7215e741e$export$2e2bcd8739ae039({ monthDate: monthDate, view: view = "month", onView: onView, layers: layers, lang: lang, armed: armed, absences: absences, onPrev: onPrev, onNext: onNext, onDrop: onDrop, onPlace: onPlace, onRemove: onRemove, onMove: onMove }) {
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$7c2d9af61f6af587), key, lang);
    /* Week view: the week containing the cursor, Monday first. The panel is given the MONDAY, so
     antd draws the Monday's month and that week is always one of its six rows — the cursor itself
     stays where the month view left it (see Route.js). */ const week = view === "week";
    const weekStart = (0, $7d0f78de0b68a104$export$42c81a444fbfb5d4)(monthDate);
    const weekEnd = (0, $7d0f78de0b68a104$export$dd412b56f1e4d8aa)(weekStart, 7);
    const inView = (date)=>week ? weekStart <= date && date < weekEnd : (0, $7d0f78de0b68a104$export$a18c89cbd24170ff)(date, monthDate);
    /* antd works in dayjs; the route model works in native `Date` (its keys are built from local
     Y-M-D, and the backend runs with USE_TZ=False). `.toDate()` is the boundary, once per cell. */ const value = (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)(week ? weekStart : monthDate);
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
        className: `rc-calendar${week ? " rc-calendar--week" : ""}`,
        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $6d5564adac048079$export$2e2bcd8739ae039), {
            value: value,
            /* The panel is driven by the toolbar's stepper, not by clicking a day — a day click is
           "place the selected point here", which the cell's own button owns. */ onSelect: ()=>{},
            headerRender: ()=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                    className: "rc-cal__head",
                    align: "center",
                    justify: "center",
                    gap: "small",
                    wrap: true,
                    children: [
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                            type: "text",
                            icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0f3c6d60b091c877$export$2e2bcd8739ae039), {}),
                            "aria-label": t(week ? "prev_week" : "prev_month"),
                            onClick: onPrev
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                            strong: true,
                            className: "rc-cal__month",
                            children: week ? (0, $7d0f78de0b68a104$export$304d353c7b75a1a4)(weekStart, lang) : (0, $7d0f78de0b68a104$export$4f81354ee858acb4)(monthDate, lang)
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                            type: "text",
                            icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $89db7229a7e10f8f$export$2e2bcd8739ae039), {}),
                            "aria-label": t(week ? "next_week" : "next_month"),
                            onClick: onNext
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $ac40310dc424be23$export$2e2bcd8739ae039), {
                            size: "small",
                            className: "rc-cal__view",
                            value: view,
                            onChange: onView,
                            options: [
                                {
                                    value: "month",
                                    label: t("view_month")
                                },
                                {
                                    value: "week",
                                    label: t("view_week")
                                }
                            ]
                        })
                    ]
                }),
            cellRender: (current, info)=>{
                if (info.type !== "date") return info.originNode;
                const date = current.toDate();
                return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($32cae9e7215e741e$var$DayCell, {
                    date: date,
                    inMonth: inView(date),
                    layers: layers,
                    lang: lang,
                    armed: armed,
                    absence: $32cae9e7215e741e$var$absenceFor(absences, date),
                    onDrop: onDrop,
                    onPlace: onPlace,
                    onRemove: onRemove,
                    onMove: onMove
                });
            }
        })
    });
}


/* Shown after a point lands on a day, whether by drag or by "Add here". It asks how the stop
   recurs, which is the one thing the gesture cannot express:
     every → the base weekly series for that weekday
     nth   → only the Nth occurrence of that weekday each month
     date  → only that exact calendar date (one-off)

   antd `<Modal>` per docs/design/spec/02-components.md, which also brings the mask, the focus trap,
   focus return and Escape — the hand-rolled backdrop this replaced had none of them. */ 
parcelRequire("cQmXV");


var $cQmXV = parcelRequire("cQmXV");
var $b2439da999b61b0b$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($b2439da999b61b0b$exports, "__esModule", {
    value: true
});
var $b2439da999b61b0b$var$RetweetOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M136 552h63.6c4.4 0 8-3.6 8-8V288.7h528.6v72.6c0 1.9.6 3.7 1.8 5.2a8.3 8.3 0 0011.7 1.4L893 255.4c4.3-5 3.6-10.3 0-13.2L749.7 129.8a8.22 8.22 0 00-5.2-1.8c-4.6 0-8.4 3.8-8.4 8.4V209H199.7c-39.5 0-71.7 32.2-71.7 71.8V544c0 4.4 3.6 8 8 8zm752-80h-63.6c-4.4 0-8 3.6-8 8v255.3H287.8v-72.6c0-1.9-.6-3.7-1.8-5.2a8.3 8.3 0 00-11.7-1.4L131 768.6c-4.3 5-3.6 10.3 0 13.2l143.3 112.4c1.5 1.2 3.3 1.8 5.2 1.8 4.6 0 8.4-3.8 8.4-8.4V815h536.6c39.5 0 71.7-32.2 71.7-71.8V480c-.2-4.4-3.8-8-8.2-8z"
                }
            }
        ]
    },
    "name": "retweet",
    "theme": "outlined"
};
$b2439da999b61b0b$exports.default = $b2439da999b61b0b$var$RetweetOutlined;



function $a9f3ba7e688c31df$var$_extends() {
    $a9f3ba7e688c31df$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a9f3ba7e688c31df$var$_extends.apply(this, arguments);
}
const $a9f3ba7e688c31df$var$RetweetOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $a9f3ba7e688c31df$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($b2439da999b61b0b$exports)))
    }));
/**![retweet](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTEzNiA1NTJoNjMuNmM0LjQgMCA4LTMuNiA4LThWMjg4LjdoNTI4LjZ2NzIuNmMwIDEuOS42IDMuNyAxLjggNS4yYTguMyA4LjMgMCAwMDExLjcgMS40TDg5MyAyNTUuNGM0LjMtNSAzLjYtMTAuMyAwLTEzLjJMNzQ5LjcgMTI5LjhhOC4yMiA4LjIyIDAgMDAtNS4yLTEuOGMtNC42IDAtOC40IDMuOC04LjQgOC40VjIwOUgxOTkuN2MtMzkuNSAwLTcxLjcgMzIuMi03MS43IDcxLjhWNTQ0YzAgNC40IDMuNiA4IDggOHptNzUyLTgwaC02My42Yy00LjQgMC04IDMuNi04IDh2MjU1LjNIMjg3Ljh2LTcyLjZjMC0xLjktLjYtMy43LTEuOC01LjJhOC4zIDguMyAwIDAwLTExLjctMS40TDEzMSA3NjguNmMtNC4zIDUtMy42IDEwLjMgMCAxMy4ybDE0My4zIDExMi40YzEuNSAxLjIgMy4zIDEuOCA1LjIgMS44IDQuNiAwIDguNC0zLjggOC40LTguNFY4MTVoNTM2LjZjMzkuNSAwIDcxLjctMzIuMiA3MS43LTcxLjhWNDgwYy0uMi00LjQtMy44LTgtOC4yLTh6IiAvPjwvc3ZnPg==) */ const $a9f3ba7e688c31df$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($a9f3ba7e688c31df$var$RetweetOutlined);
var $a9f3ba7e688c31df$export$2e2bcd8739ae039 = $a9f3ba7e688c31df$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $24d26457e787ed3b$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($24d26457e787ed3b$exports, "__esModule", {
    value: true
});
var $24d26457e787ed3b$var$SyncOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M168 504.2c1-43.7 10-86.1 26.9-126 17.3-41 42.1-77.7 73.7-109.4S337 212.3 378 195c42.4-17.9 87.4-27 133.9-27s91.5 9.1 133.8 27A341.5 341.5 0 01755 268.8c9.9 9.9 19.2 20.4 27.8 31.4l-60.2 47a8 8 0 003 14.1l175.7 43c5 1.2 9.9-2.6 9.9-7.7l.8-180.9c0-6.7-7.7-10.5-12.9-6.3l-56.4 44.1C765.8 155.1 646.2 92 511.8 92 282.7 92 96.3 275.6 92 503.8a8 8 0 008 8.2h60c4.4 0 7.9-3.5 8-7.8zm756 7.8h-60c-4.4 0-7.9 3.5-8 7.8-1 43.7-10 86.1-26.9 126-17.3 41-42.1 77.8-73.7 109.4A342.45 342.45 0 01512.1 856a342.24 342.24 0 01-243.2-100.8c-9.9-9.9-19.2-20.4-27.8-31.4l60.2-47a8 8 0 00-3-14.1l-175.7-43c-5-1.2-9.9 2.6-9.9 7.7l-.7 181c0 6.7 7.7 10.5 12.9 6.3l56.4-44.1C258.2 868.9 377.8 932 512.2 932c229.2 0 415.5-183.7 419.8-411.8a8 8 0 00-8-8.2z"
                }
            }
        ]
    },
    "name": "sync",
    "theme": "outlined"
};
$24d26457e787ed3b$exports.default = $24d26457e787ed3b$var$SyncOutlined;



function $f7bd1bff2e09922f$var$_extends() {
    $f7bd1bff2e09922f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f7bd1bff2e09922f$var$_extends.apply(this, arguments);
}
const $f7bd1bff2e09922f$var$SyncOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $f7bd1bff2e09922f$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($24d26457e787ed3b$exports)))
    }));
/**![sync](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTE2OCA1MDQuMmMxLTQzLjcgMTAtODYuMSAyNi45LTEyNiAxNy4zLTQxIDQyLjEtNzcuNyA3My43LTEwOS40UzMzNyAyMTIuMyAzNzggMTk1YzQyLjQtMTcuOSA4Ny40LTI3IDEzMy45LTI3czkxLjUgOS4xIDEzMy44IDI3QTM0MS41IDM0MS41IDAgMDE3NTUgMjY4LjhjOS45IDkuOSAxOS4yIDIwLjQgMjcuOCAzMS40bC02MC4yIDQ3YTggOCAwIDAwMyAxNC4xbDE3NS43IDQzYzUgMS4yIDkuOS0yLjYgOS45LTcuN2wuOC0xODAuOWMwLTYuNy03LjctMTAuNS0xMi45LTYuM2wtNTYuNCA0NC4xQzc2NS44IDE1NS4xIDY0Ni4yIDkyIDUxMS44IDkyIDI4Mi43IDkyIDk2LjMgMjc1LjYgOTIgNTAzLjhhOCA4IDAgMDA4IDguMmg2MGM0LjQgMCA3LjktMy41IDgtNy44em03NTYgNy44aC02MGMtNC40IDAtNy45IDMuNS04IDcuOC0xIDQzLjctMTAgODYuMS0yNi45IDEyNi0xNy4zIDQxLTQyLjEgNzcuOC03My43IDEwOS40QTM0Mi40NSAzNDIuNDUgMCAwMTUxMi4xIDg1NmEzNDIuMjQgMzQyLjI0IDAgMDEtMjQzLjItMTAwLjhjLTkuOS05LjktMTkuMi0yMC40LTI3LjgtMzEuNGw2MC4yLTQ3YTggOCAwIDAwLTMtMTQuMWwtMTc1LjctNDNjLTUtMS4yLTkuOSAyLjYtOS45IDcuN2wtLjcgMTgxYzAgNi43IDcuNyAxMC41IDEyLjkgNi4zbDU2LjQtNDQuMUMyNTguMiA4NjguOSAzNzcuOCA5MzIgNTEyLjIgOTMyYzIyOS4yIDAgNDE1LjUtMTgzLjcgNDE5LjgtNDExLjhhOCA4IDAgMDAtOC04LjJ6IiAvPjwvc3ZnPg==) */ const $f7bd1bff2e09922f$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($f7bd1bff2e09922f$var$SyncOutlined);
var $f7bd1bff2e09922f$export$2e2bcd8739ae039 = $f7bd1bff2e09922f$var$RefIcon;






// Ukrainian grammatical forms for the route recurrence options.
// Ukrainian requires the genitive case here (not the nominative Intl gives), and the
// determiner + ordinal must agree with the weekday's gender:
//   every  -> "Кожного понеділка" (m) / "Кожної неділі" (f)
//   Nth    -> "Лише кожного 2-го понеділка щомісяця" (m) / "Лише кожної 2-ї неділі щомісяця" (f)
// Weekday index is Monday=0..Sunday=6 (matches Route.day_of_the_week).
const $90c88f283d4f9d07$var$UK_WEEKDAY = {
    0: {
        gen: "\u043F\u043E\u043D\u0435\u0434\u0456\u043B\u043A\u0430",
        g: "m"
    },
    1: {
        gen: "\u0432\u0456\u0432\u0442\u043E\u0440\u043A\u0430",
        g: "m"
    },
    2: {
        gen: "\u0441\u0435\u0440\u0435\u0434\u0438",
        g: "f"
    },
    3: {
        gen: "\u0447\u0435\u0442\u0432\u0435\u0440\u0433\u0430",
        g: "m"
    },
    4: {
        gen: "\u043F'\u044F\u0442\u043D\u0438\u0446\u0456",
        g: "f"
    },
    5: {
        gen: "\u0441\u0443\u0431\u043E\u0442\u0438",
        g: "f"
    },
    6: {
        gen: "\u043D\u0435\u0434\u0456\u043B\u0456",
        g: "f"
    }
};
const $90c88f283d4f9d07$var$UK_ORDINAL_GEN = {
    m: {
        1: "1-\u0433\u043E",
        2: "2-\u0433\u043E",
        3: "3-\u0433\u043E",
        4: "4-\u0433\u043E",
        5: "5-\u0433\u043E"
    },
    f: {
        1: "1-\u0457",
        2: "2-\u0457",
        3: "3-\u0457",
        4: "4-\u0457",
        5: "5-\u0457"
    }
};
const $90c88f283d4f9d07$export$dde48402f449aa64 = (wd)=>{
    const w = $90c88f283d4f9d07$var$UK_WEEKDAY[wd];
    if (!w) return "";
    return `${w.g === "m" ? "\u041A\u043E\u0436\u043D\u043E\u0433\u043E" : "\u041A\u043E\u0436\u043D\u043E\u0457"} ${w.gen}`;
};
const $90c88f283d4f9d07$export$f810c562da12f316 = (wd, nth)=>{
    const w = $90c88f283d4f9d07$var$UK_WEEKDAY[wd];
    if (!w) return "";
    const determiner = w.g === "m" ? "\u043A\u043E\u0436\u043D\u043E\u0433\u043E" : "\u043A\u043E\u0436\u043D\u043E\u0457";
    const ord = ($90c88f283d4f9d07$var$UK_ORDINAL_GEN[w.g] || {})[nth] || `${nth}-${w.g === "m" ? "\u0433\u043E" : "\u0457"}`;
    return `\u{41B}\u{438}\u{448}\u{435} ${determiner} ${ord} ${w.gen} \u{449}\u{43E}\u{43C}\u{456}\u{441}\u{44F}\u{446}\u{44F}`;
};
const $90c88f283d4f9d07$export$e8d6a5454ecaf93d = (wd, [a, b])=>{
    const w = $90c88f283d4f9d07$var$UK_WEEKDAY[wd];
    if (!w) return "";
    const ords = $90c88f283d4f9d07$var$UK_ORDINAL_GEN[w.g] || {};
    return `\u{420}\u{430}\u{437} \u{43D}\u{430} \u{434}\u{432}\u{430} \u{442}\u{438}\u{436}\u{43D}\u{456} (${ords[a] || a} \u{456} ${ords[b] || b} ${w.gen})`;
};


const $977a580fdf6cb607$var$ORDINAL_KEY = {
    1: "ord_first",
    2: "ord_second",
    3: "ord_third",
    4: "ord_fourth",
    5: "ord_fifth"
};
function $977a580fdf6cb607$export$2e2bcd8739ae039({ date: date, point: point, lang: lang, onChoose: onChoose, onCancel: onCancel }) {
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$7c2d9af61f6af587), key, lang);
    const wd = (0, $7d0f78de0b68a104$export$56c97ca1cde8c5bb)(date);
    const localeWeekday = new Intl.DateTimeFormat((0, $7d0f78de0b68a104$export$bd7bed267fc278f2)(lang), {
        weekday: "long"
    }).format(date);
    const nth = (0, $7d0f78de0b68a104$export$83a45ae2ed9f0324)(date);
    /* Ukrainian needs genitive + gender agreement, which a flat template cannot express; those two
     phrases are built explicitly. Other languages use the {day}/{ord} template. */ const everyLabel = lang === "uk" ? (0, $90c88f283d4f9d07$export$dde48402f449aa64)(wd) : (0, $3b579ca6158bc61b$export$9563e054e6f787fb)(t("scope_every"), {
        day: localeWeekday
    });
    const nthLabel = lang === "uk" ? (0, $90c88f283d4f9d07$export$f810c562da12f316)(wd, nth) : (0, $3b579ca6158bc61b$export$9563e054e6f787fb)(t("scope_nth"), {
        ord: t($977a580fdf6cb607$var$ORDINAL_KEY[nth]),
        day: localeWeekday
    });
    /* "Once every two weeks" = the 1st+3rd or 2nd+4th slot pair (routeModel.biweeklyNths); a 5th
     occurrence pairs with nothing, so the option simply isn't offered there. */ const pair = (0, $29ff8c829ff33c74$export$141714a8c5e66bf1)(date);
    const biweeklyLabel = pair ? lang === "uk" ? (0, $90c88f283d4f9d07$export$e8d6a5454ecaf93d)(wd, pair) : (0, $3b579ca6158bc61b$export$9563e054e6f787fb)(t("scope_biweekly"), {
        ordA: t($977a580fdf6cb607$var$ORDINAL_KEY[pair[0]]),
        ordB: t($977a580fdf6cb607$var$ORDINAL_KEY[pair[1]]),
        day: localeWeekday
    }) : null;
    const options = [
        {
            type: "every",
            label: everyLabel,
            icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $a9f3ba7e688c31df$export$2e2bcd8739ae039), {})
        },
        {
            type: "nth",
            label: nthLabel,
            icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3368c84d60c50017$export$2e2bcd8739ae039), {})
        },
        ...biweeklyLabel ? [
            {
                type: "biweekly",
                label: biweeklyLabel,
                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $f7bd1bff2e09922f$export$2e2bcd8739ae039), {})
            }
        ] : [],
        {
            type: "date",
            label: (0, $3b579ca6158bc61b$export$9563e054e6f787fb)(t("scope_date"), {
                date: (0, $7d0f78de0b68a104$export$39af906a0f4e17a1)(date, lang)
            }),
            icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $a1f80a723f71d713$export$2e2bcd8739ae039), {})
        }
    ];
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $05a90c67d3627fd9$export$2e2bcd8739ae039), {
        open: true,
        rootClassName: "rc-scope",
        title: t("scope_title"),
        /* The three options ARE the actions; a footer of OK/Cancel would leave the primary action
         ambiguous. Cancel stays available as the modal's own close and Escape. */ footer: null,
        width: 440,
        centered: true,
        onCancel: onCancel,
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                type: "secondary",
                className: "rc-scope__point",
                children: point?.name
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                vertical: true,
                gap: "small",
                className: "rc-scope__opts",
                children: options.map((option)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                        className: "rc-scope__opt",
                        size: "large",
                        block: true,
                        icon: option.icon,
                        onClick: ()=>onChoose(option.type),
                        children: option.label
                    }, option.type))
            })
        ]
    });
}





const $8d3742188f51b6e5$var$callP = (body)=>new Promise((resolve)=>(0, $c9936523dc38c641$export$848feb93d8f32b9b)(body, resolve));
const $8d3742188f51b6e5$var$enWeekday = (wd)=>new Intl.DateTimeFormat("en", {
        weekday: "long"
    }).format(new Date(2024, 0, 1 + wd));
const $8d3742188f51b6e5$var$sameIds = (a, b)=>a.length === b.length && a.every((v, i)=>v === b[i]);
const $8d3742188f51b6e5$var$titleForKey = (key)=>{
    if ((0, $29ff8c829ff33c74$export$57946e615fde2ef9)(key)) return $8d3742188f51b6e5$var$enWeekday(Number(key.slice(1)));
    if ((0, $29ff8c829ff33c74$export$5970e27c1aba6f13)(key)) {
        const [wd, nth] = key.slice(1).split("_").map(Number);
        return `${nth} ${$8d3742188f51b6e5$var$enWeekday(wd)}`;
    }
    return key.slice(1);
};
// Diff the layers against the routes as loaded → routes to (re)create and ids to delete.
const $8d3742188f51b6e5$var$computeReconcile = (layers, loaded, extraDeletedIds)=>{
    const desired = (0, $29ff8c829ff33c74$export$9f54b2050a902133)(layers);
    const desiredKeys = new Set(desired.map((r)=>r.key));
    const toDelete = new Set(extraDeletedIds);
    const toCreate = [];
    desired.forEach(({ key: key, stops: stops })=>{
        const want = stops.map((s)=>s.point.id);
        const prev = loaded[key];
        if (prev && $8d3742188f51b6e5$var$sameIds(want, prev.pointIds)) return; // unchanged
        if (prev && prev.id) toDelete.add(prev.id); // replace: recreate with new stops/order
        toCreate.push({
            key: key,
            stops: stops
        });
    });
    Object.keys(loaded).forEach((key)=>{
        if (!desiredKeys.has(key) && loaded[key].id) toDelete.add(loaded[key].id);
    });
    return {
        toCreate: toCreate,
        toDelete: [
            ...toDelete
        ]
    };
};
function $8d3742188f51b6e5$export$2e2bcd8739ae039({ user: user }) {
    const me = (0, $81aca8a46f6ecb51$export$6fec604aa7293d0c)().getState().me;
    const lang = me?.language || "en";
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$7c2d9af61f6af587), key, lang);
    const [layers, setLayers] = (0, $cQmXV.useState)({
        base: {},
        week: {},
        date: {}
    });
    const [loaded, setLoaded] = (0, $cQmXV.useState)({});
    const [extraDeletedIds, setExtraDeletedIds] = (0, $cQmXV.useState)([]);
    /* Days inside a recorded absence refuse new stops (PICSELL-1581 #14). One fetch per
     merchandiser; the presence tab pages the same endpoint, here 100 covers a person's records. */ const [absences, setAbsences] = (0, $cQmXV.useState)([]);
    /* `monthDate` is a CURSOR: the month view shows its month, the week view the week containing it
     (RouteCalendar derives the Monday). ⚠ Switching views must not move it. Snapping it to the
     week's Monday put September's cursor on 31 August, so week → month came back on AUGUST — where
     every stop added this month is gated out by its `from` date and the route "disappeared". The
     layers are the whole person's routes either way, so a switch costs no request (PICSELL-1615 #8). */ const [monthDate, setMonthDate] = (0, $cQmXV.useState)(()=>(0, $7d0f78de0b68a104$export$a1081e8ce57742a4)(new Date()));
    const [view, setView] = (0, $cQmXV.useState)("month");
    const step = (n)=>setMonthDate((d)=>view === "week" ? (0, $7d0f78de0b68a104$export$dd412b56f1e4d8aa)(d, 7 * n) : (0, $7d0f78de0b68a104$export$17c93e242b2d3a22)(d, n));
    const [pendingDrop, setPendingDrop] = (0, $cQmXV.useState)(null);
    /* The point selected in the panel, waiting for a day. This is what makes the editor usable
     without a mouse — see PointSearchPanel. */ const [armed, setArmed] = (0, $cQmXV.useState)(null);
    const [saving, setSaving] = (0, $cQmXV.useState)(false);
    const load = (0, $cQmXV.useCallback)(()=>{
        if (!user?.id) return;
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "GET",
            url: "routes?user=" + user.id
        }, (resp)=>{
            const list = Array.isArray(resp) ? resp : resp?.results || [];
            /* ⚠ Load-bearing, not belt-and-braces — the same client-side filter /tracking carries.
         The endpoint is company-wide for a manager now (PICSELL-1595), so if `?user=` is ever
         dropped again (the filterset_class fix has already been lost to a deploy gap once),
         this line is what keeps the editor from merging EVERY merchandiser's routes into one
         calendar — and its save reconcile from then DELETING them. */ const mine = list.filter((route)=>(route.user?.id ?? route.user) === user.id);
            const { layers: l, loaded: ld, extraDeletedIds: ex } = (0, $29ff8c829ff33c74$export$65638ff2f6061a77)(mine);
            setLayers(l);
            setLoaded(ld);
            setExtraDeletedIds(ex);
        });
    }, [
        user?.id
    ]);
    (0, $cQmXV.useEffect)(()=>{
        load();
    }, [
        load
    ]);
    const userId = user?.id;
    (0, $cQmXV.useEffect)(()=>{
        if (!userId) return;
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "GET",
            url: `absences?merchandiser=${userId}&page_size=100`
        }, (resp)=>{
            setAbsences(Array.isArray(resp) ? resp : resp?.results || []);
        });
    }, [
        userId
    ]);
    const { toCreate: toCreate, toDelete: toDelete } = (0, $cQmXV.useMemo)(()=>$8d3742188f51b6e5$var$computeReconcile(layers, loaded, extraDeletedIds), [
        layers,
        loaded,
        extraDeletedIds
    ]);
    const hasChanges = toCreate.length > 0 || toDelete.length > 0;
    const addWithScope = (date, point, scope)=>setLayers((l)=>scope === "biweekly" ? (0, $29ff8c829ff33c74$export$370a25ad77fd0302)(l, date, point) : (0, $29ff8c829ff33c74$export$7ed91a9c68d5a769)(l, scope, date, point));
    const removeStop = (layerKey, pointId)=>setLayers((l)=>(0, $29ff8c829ff33c74$export$60c41cdd2b94234a)(l, layerKey, pointId));
    const moveStop = (layerKey, pointId, dir)=>setLayers((l)=>(0, $29ff8c829ff33c74$export$31938668dbeb9fa6)(l, layerKey, pointId, dir));
    const save = async ()=>{
        if (!hasChanges || saving) return;
        setSaving(true);
        try {
            // Create first, then delete — a failed create leaves old routes intact (recoverable
            // duplicate, consolidated on next load) instead of losing data.
            for (const { key: key, stops: stops } of toCreate){
                const spec = (0, $29ff8c829ff33c74$export$7a2b93116fc1d87)(key, {
                    userId: user.id,
                    createdBy: me?.id ?? null,
                    title: $8d3742188f51b6e5$var$titleForKey(key)
                });
                const created = await $8d3742188f51b6e5$var$callP({
                    method: "POST",
                    url: "routes/",
                    post: spec
                });
                if (!created || !created.id) throw new Error("route create failed: " + JSON.stringify(created));
                const orders = (0, $29ff8c829ff33c74$export$3e8e9e58c013b76b)(created.id, stops);
                if (orders.length) await $8d3742188f51b6e5$var$callP({
                    method: "POST",
                    url: "order/",
                    post: orders
                });
            }
            for (const id of toDelete)await $8d3742188f51b6e5$var$callP({
                method: "DELETE",
                url: `routes/${id}/`
            }); // orders cascade-delete
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$38fc5682710cdf86), "data_successfully_saved", lang), {
                position: "bottom-right"
            });
            load();
        } catch (e) {
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).warning(t("save_failed"), {
                position: "bottom-right"
            });
        } finally{
            setSaving(false);
        }
    };
    const stopCount = (0, $cQmXV.useMemo)(()=>{
        let n = 0;
        Object.values(layers.base).forEach((a)=>n += a.length);
        Object.values(layers.week).forEach((byNth)=>Object.values(byNth).forEach((a)=>n += a.length));
        Object.values(layers.date).forEach((a)=>n += a.length);
        return n;
    }, [
        layers
    ]);
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
        vertical: true,
        gap: "middle",
        className: "rc",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                className: "rc-bar",
                align: "center",
                gap: "small",
                wrap: true,
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3368c84d60c50017$export$2e2bcd8739ae039), {
                        className: "rc-bar__icon"
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                        strong: true,
                        children: t("heading")
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $602120e6d17ff12a$export$2e2bcd8739ae039), {
                        variant: "filled",
                        className: "rc-bar__count",
                        children: [
                            t("stops_label"),
                            " ",
                            stopCount
                        ]
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "rc-spacer"
                    }),
                    hasChanges ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                        type: "secondary",
                        className: "rc-bar__dirty",
                        "aria-live": "polite",
                        children: t("unsaved_changes")
                    }) : null,
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                        type: "primary",
                        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $7f0f32b5e0f33a0e$export$2e2bcd8739ae039), {}),
                        loading: saving,
                        disabled: !hasChanges,
                        onClick: save,
                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$38fc5682710cdf86), "save_btn", lang)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                className: "rc-layout",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $46bcdae26abfb3ba$export$2e2bcd8739ae039), {
                        lang: lang,
                        armed: armed,
                        onArm: setArmed
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $32cae9e7215e741e$export$2e2bcd8739ae039), {
                        monthDate: monthDate,
                        view: view,
                        onView: setView,
                        layers: layers,
                        lang: lang,
                        armed: armed,
                        absences: absences,
                        onPrev: ()=>step(-1),
                        onNext: ()=>step(1),
                        onDrop: (date, point)=>setPendingDrop({
                                date: date,
                                point: point
                            }),
                        onPlace: (date)=>armed && setPendingDrop({
                                date: date,
                                point: armed
                            }),
                        onRemove: removeStop,
                        onMove: moveStop
                    })
                ]
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                type: "secondary",
                className: "rc-legend",
                children: t("legend")
            }),
            pendingDrop ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $977a580fdf6cb607$export$2e2bcd8739ae039), {
                date: pendingDrop.date,
                point: pendingDrop.point,
                lang: lang,
                onChoose: (scope)=>{
                    addWithScope(pendingDrop.date, pendingDrop.point, scope);
                    setPendingDrop(null);
                    /* The point has been placed; keeping it armed would litter every cell with "Add here"
               after the user is done. */ setArmed(null);
                },
                onCancel: ()=>setPendingDrop(null)
            }) : null
        ]
    });
}



const $c99a2835eadd6e89$var$PHONE_RE = /^\+[1-9]\d{6,14}$/;
// no per-movement icon mapping — antd has no bike/motorcycle glyphs;
// the list uses CarOutlined for all, and we just show the label here.
const $c99a2835eadd6e89$var$TABS = [
    "routes",
    "assignment",
    "visits",
    "presence"
];
const $c99a2835eadd6e89$var$PAGE_SIZES = [
    10,
    25,
    50
];
/* Module scope so the state initialisers above can call it — a `const` inside the component would
   sit in the temporal dead zone while `useState` runs. */ const $c99a2835eadd6e89$var$newItem = ()=>({
        first_name: "",
        last_name: "",
        phone_number: "",
        movement: "on_foot",
        is_active: true,
        /* ⚠ date_joined is a DateTimeField server-side — a bare date 400s with "Datetime has wrong
     format" (DRF 3.11 has no date fallback), same rule as the absences POST below. */ date_joined: `${new Date().toISOString().slice(0, 10)}T00:00:00`,
        date_deactivated: null,
        date_till_newbie: null,
        supervisor: null,
        county: null,
        password: ""
    });
const $c99a2835eadd6e89$var$Page = ()=>{
    const { id: id } = (0, $6f5d68f762d5488a$export$99eaa27ddbbb95ef)();
    const history = (0, $6f5d68f762d5488a$export$3420e1dc2c4a518c)();
    const location = (0, $6f5d68f762d5488a$export$45d76561a5302f2b)();
    const me = (0, $b83e93e5ef3de8b0$export$2105062e25df4afe)((state)=>state.me);
    const lang = me?.language || "en";
    const isNew = id === "new";
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ec1daa9e9f53b5f3), key, lang);
    const tl = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$20c290c14cdb1327), key, lang);
    const tm = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$38fc5682710cdf86), key, lang);
    const tv = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), key, lang);
    const ta = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$437eb927da0bf418), key, lang);
    /* What the server actually said. `call` hands a 400 back as the raw `Response`, so the old
     `JSON.stringify(response)` printed `Error: {}` on every validation failure. */ const reportFailure = (response)=>{
        if (response && typeof response.json === "function") {
            (0, $c9936523dc38c641$export$45fc6b2d335e3c39)(response).then((parsed)=>(0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).warning(parsed.message || t("save_error"), {
                    position: "top-right"
                }));
            return;
        }
        (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).warning(t("save_error"), {
            position: "top-right"
        });
    };
    /* ---------------------------------------------------------------- state */ /* ⚠ Seeded for a new record, not left null. `status` starts "ready" when `isNew`, so neither the
     loading return nor the not-found guard (written `!item && !isNew`, which excludes this case on
     purpose) fires — and the first render walked straight into `item.is_active` in the status-pill
     block with `item` still null. Every click of "New Merchandiser" hit the ErrorBoundary, 100% of
     the time (PICSELL-1574 #20). Two calls rather than one shared object so `original` cannot alias
     `item`. */ const [item, setItem] = (0, $cQmXV.useState)(()=>isNew ? $c99a2835eadd6e89$var$newItem() : null);
    const [original, setOriginal] = (0, $cQmXV.useState)(()=>isNew ? $c99a2835eadd6e89$var$newItem() : null);
    const [status, setStatus] = (0, $cQmXV.useState)(isNew ? "ready" : "loading");
    const [mode, setMode] = (0, $cQmXV.useState)(isNew ? "EDIT" : "VIEW");
    const [busy, setBusy] = (0, $cQmXV.useState)(false);
    const [showErrors, setShowErrors] = (0, $cQmXV.useState)(false);
    /* Tab, page and size round-trip through the query string, as /visit's filters do, so Back from
     a visit lands on the same page of this tab and not on page 1 (PICSELL-1615 #3). */ const initialSearch = new URLSearchParams(location.search);
    const initialTab = $c99a2835eadd6e89$var$TABS.includes(initialSearch.get("t")) ? initialSearch.get("t") : "routes";
    const initialSize = Number(initialSearch.get("size"));
    const [tab, setTab] = (0, $cQmXV.useState)(initialTab);
    const [tabData, setTabData] = (0, $cQmXV.useState)({});
    const [tabPage, setTabPage] = (0, $cQmXV.useState)({
        assignment: 1,
        visits: 1,
        presence: 1,
        [initialTab]: Math.max(1, Number(initialSearch.get("page")) || 1)
    });
    const [tabSize, setTabSize] = (0, $cQmXV.useState)($c99a2835eadd6e89$var$PAGE_SIZES.includes(initialSize) ? initialSize : $c99a2835eadd6e89$var$PAGE_SIZES[0]);
    const loadingTabs = (0, $cQmXV.useRef)(new Set());
    const [absenceOpen, setAbsenceOpen] = (0, $cQmXV.useState)(false);
    const [absForm, setAbsForm] = (0, $cQmXV.useState)({
        start: null,
        end: null,
        reason: ""
    });
    const barRef = (0, $cQmXV.useRef)(null);
    const editing = mode === "EDIT";
    /* ---------------------------------------------------------------- load */ const load = (0, $cQmXV.useCallback)(()=>{
        // Nothing to fetch for a new record — it is seeded into state at declaration, not here. An
        // effect could not do it: it runs AFTER the first render, which is the render that crashed.
        if (isNew) return;
        setStatus("loading");
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "GET",
            url: `merchandisers/${id}/`
        }, (response)=>{
            if (!response?.id) return setStatus("error");
            setItem(response);
            setOriginal(structuredClone(response));
            setStatus("ready");
        });
    }, [
        id,
        isNew
    ]);
    (0, $cQmXV.useEffect)(load, [
        load
    ]);
    /* ---------------------------------------------------------------- dirty */ const signature = (obj)=>{
        if (!obj) return "";
        return JSON.stringify(obj);
    };
    const dirty = item && original ? signature(item) !== signature(original) : false;
    const canSave = isNew || dirty;
    /* ---------------------------------------------------------------- validate */ const validate = ()=>{
        const errs = [];
        if (!item?.first_name?.trim()) errs.push({
            field: "first_name",
            key: "v_first_required"
        });
        if (!item?.last_name?.trim()) errs.push({
            field: "last_name",
            key: "v_last_required"
        });
        if (item?.phone_number && !$c99a2835eadd6e89$var$PHONE_RE.test(item.phone_number.trim())) errs.push({
            field: "phone_number",
            key: "v_phone_invalid"
        });
        if (isNew && item?.password && item.password.length < 1) errs.push({
            field: "password",
            key: "v_first_required"
        });
        return errs;
    };
    const errors = showErrors ? validate() : [];
    /* ---------------------------------------------------------------- field change */ const onChange = (field, value)=>{
        setItem((prev)=>({
                ...prev,
                [field]: value
            }));
    };
    /* ---------------------------------------------------------------- save */ const save = ()=>{
        setShowErrors(true);
        const errs = validate();
        if (errs.length) {
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).warning(t("v_fix_first"), {
                position: "top-right"
            });
            return;
        }
        setBusy(true);
        const payload = {
            ...item
        };
        delete payload.photo;
        if (me?.company?.id) payload.company = me.company.id;
        if (item.supervisor && typeof item.supervisor === "object") payload.supervisor = item.supervisor.id;
        if (item.county && typeof item.county === "object") payload.county = item.county.id;
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: item.id ? "PATCH" : "POST",
            url: item.id ? `merchandisers/${item.id}/` : "merchandisers/",
            post: payload
        }, (response)=>{
            setBusy(false);
            if (response?.id) {
                setItem(response);
                setOriginal(structuredClone(response));
                setShowErrors(false);
                setMode("VIEW");
                (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success(t("data_saved"), {
                    position: "top-right"
                });
                if (isNew) history.replace(`/merchandiser/${response.id}`);
            } else reportFailure(response);
        });
    };
    /* ---------------------------------------------------------------- mode toggle */ const enterEdit = ()=>{
        setMode("EDIT");
    };
    const cancelEdit = ()=>{
        if (dirty) (0, $05a90c67d3627fd9$export$2e2bcd8739ae039).confirm({
            title: t("discard_confirm"),
            okText: t("yes_lc"),
            okButtonProps: {
                danger: true
            },
            cancelText: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f544127b46daf517), "cancel", lang),
            onOk: ()=>{
                setItem(structuredClone(original));
                setShowErrors(false);
                setMode("VIEW");
            }
        });
        else {
            setShowErrors(false);
            setMode("VIEW");
        }
    };
    /* ---------------------------------------------------------------- activate / deactivate */ const setActive = (value)=>{
        const run = ()=>{
            setBusy(true);
            (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
                method: "PATCH",
                url: `merchandisers/${id}/`,
                post: {
                    is_active: value
                }
            }, (response)=>{
                setBusy(false);
                if (!response) return;
                setItem((prev)=>({
                        ...prev,
                        is_active: value,
                        date_deactivated: value ? null : new Date().toISOString().slice(0, 10)
                    }));
                setOriginal((prev)=>({
                        ...prev,
                        is_active: value,
                        date_deactivated: value ? null : new Date().toISOString().slice(0, 10)
                    }));
                (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success(t(value ? "activated_msg" : "deactivated_msg"), {
                    position: "top-right"
                });
            });
        };
        if (value) return run();
        (0, $05a90c67d3627fd9$export$2e2bcd8739ae039).confirm({
            title: t("confirm_deactivate"),
            okText: tl("deactivate"),
            okButtonProps: {
                danger: true
            },
            cancelText: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f544127b46daf517), "cancel", lang),
            onOk: run
        });
    };
    /* ---------------------------------------------------------------- tabs */ const tabUrl = (0, $cQmXV.useCallback)((key, page, size)=>{
        const paging = `page=${page}&page_size=${size}`;
        /* `?user=` was never a param `TaskFilter` accepted, and django-filter drops unknown params
         silently — so this tab has been listing EVERY task in the company rather than this
         merchandiser's. A task carries no user of its own; the point's responsible merchandiser is
         the only link, which is the filter picsell-api's `TaskWebFilter` now exposes. */ if (key === "assignment") return `tasks?merchandiser=${id}&${paging}`;
        if (key === "visits") return `visits?user=${id}&${paging}`;
        if (key === "presence") return `absences?merchandiser=${id}&${paging}`;
        return null;
    }, [
        id
    ]);
    const loadTab = (0, $cQmXV.useCallback)((key, page)=>{
        if (key === "routes") return;
        const stamp = `${key}:${page}:${tabSize}`;
        if (loadingTabs.current.has(stamp)) return;
        loadingTabs.current.add(stamp);
        setTabData((prev)=>({
                ...prev,
                [key]: undefined
            }));
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "GET",
            url: tabUrl(key, page, tabSize)
        }, (response)=>{
            loadingTabs.current.delete(stamp);
            if (Array.isArray(response)) setTabData((prev)=>({
                    ...prev,
                    [key]: {
                        rows: response,
                        count: response.length
                    }
                }));
            else if (response?.results) setTabData((prev)=>({
                    ...prev,
                    [key]: {
                        rows: response.results,
                        count: response.count ?? response.results.length
                    }
                }));
            else setTabData((prev)=>({
                    ...prev,
                    [key]: null
                }));
        });
    }, [
        tabUrl,
        tabSize
    ]);
    (0, $cQmXV.useEffect)(()=>{
        if (status !== "ready" || isNew || tab === "routes") return;
        if (tabData[tab] !== undefined) return;
        if ([
            ...loadingTabs.current
        ].some((stamp)=>stamp.startsWith(`${tab}:`))) return;
        loadTab(tab, tabPage[tab] || 1);
    }, [
        tab,
        status,
        isNew,
        tabData,
        tabPage,
        loadTab
    ]);
    (0, $cQmXV.useEffect)(()=>{
        const next = new URLSearchParams(location.search);
        next.set("t", tab);
        const page = tabPage[tab] || 1;
        if (page > 1) next.set("page", String(page));
        else next.delete("page");
        if (tabSize !== $c99a2835eadd6e89$var$PAGE_SIZES[0]) next.set("size", String(tabSize));
        else next.delete("size");
        if (next.toString() !== location.search.replace(/^\?/, "")) history.replace({
            search: next.toString()
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        tab,
        tabPage,
        tabSize
    ]);
    /* ---------------------------------------------------------------- sticky offsets */ (0, $cQmXV.useEffect)(()=>{
        if (!barRef.current) return;
        const ro = new ResizeObserver((entries)=>{
            for (const e of entries)document.documentElement.style.setProperty("--md-bar-h", Math.round(e.contentRect.height) + "px");
        });
        ro.observe(barRef.current);
        return ()=>ro.disconnect();
    }, []);
    /* ---------------------------------------------------------------- beforeunload */ (0, $cQmXV.useEffect)(()=>{
        const handler = (e)=>{
            if (!editing || !dirty) return;
            e.preventDefault();
            e.returnValue = "";
        };
        window.addEventListener("beforeunload", handler);
        return ()=>window.removeEventListener("beforeunload", handler);
    }, [
        editing,
        dirty
    ]);
    /* ---------------------------------------------------------------- absence */ const openAbsence = ()=>{
        setAbsForm({
            start: null,
            end: null,
            reason: ""
        });
        setAbsenceOpen(true);
    };
    const submitAbsence = ()=>{
        if (!absForm.start || !absForm.end || !absForm.reason?.trim()) {
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).warning(t("absence_incomplete"), {
                position: "top-right"
            });
            return;
        }
        if (absForm.end.isBefore(absForm.start)) {
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).warning(t("v_to_after_from"), {
                position: "top-right"
            });
            return;
        }
        setBusy(true);
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "POST",
            url: "absences/",
            post: {
                merchandiser: item.id,
                created_by: me?.id,
                /* ⚠ `Absence.start`/`end` are DATETIMEs (`TimeFramedModel`), and DRF 3.11's
             `DateTimeField` has no date-only fallback — `parse_datetime("2026-08-14")` returns
             None, so a bare date 400s with "Datetime has wrong format" and adding an absence
             failed every time. The day is inclusive at both ends, as `dateStart`/`dateEnd` read
             it. */ start: absForm.start.format("YYYY-MM-DDT00:00:00"),
                end: absForm.end.format("YYYY-MM-DDT23:59:59"),
                reason: absForm.reason.trim()
            }
        }, (response)=>{
            setBusy(false);
            if (response?.id) {
                setAbsenceOpen(false);
                (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success(t("absence_saved"), {
                    position: "top-right"
                });
                if (tab === "presence") {
                    setTabData((prev)=>({
                            ...prev,
                            presence: undefined
                        }));
                    loadTab("presence", tabPage.presence || 1);
                } else {
                    setTab("presence");
                    setTabData((prev)=>({
                            ...prev,
                            presence: undefined
                        }));
                }
            } else reportFailure(response);
        });
    };
    const removeAbsence = (row)=>{
        (0, $05a90c67d3627fd9$export$2e2bcd8739ae039).confirm({
            title: t("confirm_remove_absence"),
            content: `${fmtDate(row.start)} \u{2192} ${fmtDate(row.end)}${row.reason ? ` \xb7 ${row.reason}` : ""}`,
            okText: t("remove"),
            okButtonProps: {
                danger: true
            },
            cancelText: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f544127b46daf517), "cancel", lang),
            onOk: ()=>new Promise((resolve)=>{
                    (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
                        method: "DELETE",
                        url: `absences/${row.id}/`
                    }, (response)=>{
                        resolve();
                        /* DELETE answers 204 with no body — `call` hands the raw Response back. Anything
               else already toasted its own failure; don't stack a success on top of it. */ if (!response || response.status !== 204) return;
                        (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success(t("absence_removed"), {
                            position: "top-right"
                        });
                        setTabData((prev)=>({
                                ...prev,
                                presence: undefined
                            }));
                        loadTab("presence", tabPage.presence || 1);
                    });
                })
        });
    };
    /* ---------------------------------------------------------------- helpers */ const name = item ? (0, $66539b2560a58e4e$export$1d6cfa7493842c29)(item) || "\u2014" : "\u2014";
    const avHue = ((Number(id) || 700) * 37 + 200) % 360;
    const movementKey = item?.movement || "on_foot";
    /* ⚠ `Intl`, not dayjs. No dayjs locale is loaded anywhere in this app — `util/dayjs.js` imports
     only `customParseFormat` and `updateLocale` — so `format("DD MMM")` emitted dayjs' built-in
     ENGLISH month names whatever `me.language` said: "14 Nov 2023" on a Ukrainian account, and
     "Aug"/"Jul" in the visits table (PICSELL-1574 #3, #4). `localeFor` is the app's lang → BCP-47
     mapping, already shared by eight modules. A formatter per call, as `visit/sections.js` does;
     dayjs stays for the DatePicker values and the `.diff()` arithmetic, neither of which needs a
     locale. */ const fmtWith = (d, options)=>{
        if (!d) return "\u2014";
        const date = new Date(d);
        if (Number.isNaN(date.getTime())) return "\u2014";
        return new Intl.DateTimeFormat((0, $7d0f78de0b68a104$export$bd7bed267fc278f2)(lang), options).format(date);
    };
    const fmtDate = (d)=>fmtWith(d, {
            day: "2-digit",
            month: "short",
            year: "numeric"
        });
    const fmtShort = (d)=>fmtWith(d, {
            day: "2-digit",
            month: "short"
        });
    const fmtDateTime = (d)=>fmtWith(d, {
            day: "2-digit",
            month: "short",
            hour: "2-digit",
            minute: "2-digit"
        });
    const tenureDays = ()=>{
        if (!item?.date_joined) return "\u2014";
        return Math.max(0, (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)().diff((0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)(item.date_joined), "day"));
    };
    const isNewbie = ()=>item?.date_till_newbie && (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)(item.date_till_newbie).isAfter((0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)());
    const absenceNow = ()=>{
        const absences = tabData.presence?.rows;
        if (!absences) return null;
        const now = (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)();
        return absences.find((a)=>(0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)(a.start).isBefore(now) && (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)(a.end).isAfter(now)) || null;
    };
    const nextAbsence = ()=>{
        const absences = tabData.presence?.rows;
        if (!absences) return null;
        const now = (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)();
        return absences.filter((a)=>(0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)(a.start).isAfter(now)).sort((a, b)=>(0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)(a.start).diff((0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)(b.start)))[0] || null;
    };
    const absenceStatus = (a)=>{
        const now = (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)();
        if ((0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)(a.end).isBefore(now)) return "past";
        if ((0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)(a.start).isBefore(now)) return "now";
        return "next";
    };
    /* ---------------------------------------------------------------- tab columns */ const assignmentColumns = [
        /* `row.network` does not exist: a Task has no network column, so `fields = "__all__"` never
       emitted one and this rendered a dash for every row. The network of the task's OUTLET is what
       the column means, and `TaskPointSerializer` names it. */ {
            key: "network",
            title: tm("network_title"),
            width: 160,
            ellipsis: true,
            render: (_, row)=>row.point?.network?.name || (0, $66539b2560a58e4e$export$eb03490a10c3abc9)
        },
        {
            key: "title",
            title: tm("title_title"),
            ellipsis: true,
            render: (_, row)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("strong", {
                    children: row.title || (0, $66539b2560a58e4e$export$eb03490a10c3abc9)
                })
        },
        {
            key: "start",
            title: tm("start_title"),
            width: 140,
            render: (_, row)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                    className: "md-wnum",
                    children: fmtDate(row.date_start || row.start)
                })
        },
        {
            key: "end",
            title: tm("end_title"),
            width: 140,
            render: (_, row)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                    className: "md-wnum",
                    children: fmtDate(row.date_end || row.end)
                })
        }
    ];
    const visitColumns = [
        {
            key: "start",
            title: tm("start_title"),
            width: 180,
            render: (_, row)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                    className: "md-wnum",
                    children: fmtDateTime(row.date_start || row.start)
                })
        },
        {
            key: "end",
            title: tm("completion_title"),
            width: 180,
            render: (_, row)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                    className: "md-wnum",
                    children: fmtDateTime(row.date_end || row.end)
                })
        },
        {
            key: "duration",
            title: t("duration"),
            width: 110,
            align: "right",
            /* `time_spent` is SECONDS, as a string — it was being labelled minutes and interpolated raw,
         so 58 seconds read "58.0 хв" and 98 hours read "354359.0 хв". `row.duration` was a dead
         fallback: it is a queryset annotation no serializer exposes. */ render: (_, row)=>(0, $9277fdae5adb8dfa$export$bc733b0c5cbb3e8a)(row.time_spent, lang) || (0, $66539b2560a58e4e$export$eb03490a10c3abc9)
        },
        {
            key: "point",
            title: tm("point_title"),
            ellipsis: true,
            render: (_, row)=>{
                const p = row.point || {};
                return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $66539b2560a58e4e$export$2692b073ef5fee01), {
                    title: p.name || p.title || "\u2014",
                    sub: p.locality?.name || p.locality || ""
                });
            }
        }
    ];
    const presenceColumns = [
        {
            key: "period",
            title: t("period"),
            width: 230,
            render: (_, row)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                    className: "md-wnum",
                    children: [
                        fmtDate(row.start),
                        " \u2192 ",
                        fmtDate(row.end)
                    ]
                })
        },
        {
            key: "duration",
            title: t("duration"),
            width: 110,
            align: "right",
            render: (_, row)=>{
                const days = (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)(row.end).diff((0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)(row.start), "day") + 1;
                return `${days} ${tl("days_short")}`;
            }
        },
        {
            key: "reason",
            title: t("reason"),
            ellipsis: true,
            render: (_, row)=>row.reason || (0, $66539b2560a58e4e$export$eb03490a10c3abc9)
        },
        {
            key: "status",
            title: "",
            width: 120,
            render: (_, row)=>{
                const st = absenceStatus(row);
                return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $602120e6d17ff12a$export$2e2bcd8739ae039), {
                    className: `md-abs-tag${st === "now" ? " md-abs-tag--now" : ""}`,
                    variant: "filled",
                    children: t(`abs_${st}`)
                });
            }
        },
        {
            key: "actions",
            title: "",
            width: 48,
            /* Offered on past records too — a mistaken entry is exactly what needs deleting, and it
         can be past-dated by the time anyone notices (PICSELL-1581 #15). */ render: (_, row)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                    type: "text",
                    size: "small",
                    icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $837faca566926e3c$export$2e2bcd8739ae039), {}),
                    onClick: ()=>removeAbsence(row),
                    "aria-label": t("remove")
                })
        }
    ];
    /* ---------------------------------------------------------------- tab render */ const renderDataTab = (key, columns, onRowClick)=>{
        const data = tabData[key];
        if (data === undefined) return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e855c7114b2916ed$export$2e2bcd8739ae039), {
            active: true,
            title: false,
            paragraph: {
                rows: 4
            }
        });
        if (data === null) return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $99350450b877904c$export$2e2bcd8739ae039), {
            image: (0, $99350450b877904c$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE,
            description: t("load_error"),
            children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                size: "small",
                onClick: ()=>loadTab(key, tabPage[key] || 1),
                children: t("retry")
            })
        });
        return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $575603080129eb00$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $dff4d45d201c6dfe$export$2e2bcd8739ae039), {
                    className: "lp-table__grid",
                    rowKey: "id",
                    size: "middle",
                    columns: columns,
                    dataSource: data.rows,
                    pagination: false,
                    scroll: {
                        x: 620
                    },
                    rowClassName: onRowClick ? "lp-row" : undefined,
                    onRow: onRowClick ? (row)=>({
                            onClick: (event)=>{
                                if (event.target.closest(".ant-table-selection-column, .ant-dropdown, .ant-btn")) return;
                                onRowClick(row);
                            }
                        }) : undefined,
                    locale: {
                        emptyText: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $99350450b877904c$export$2e2bcd8739ae039), {
                            image: (0, $99350450b877904c$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE,
                            description: t("empty_tab")
                        })
                    }
                }),
                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $66539b2560a58e4e$export$6cb97cd1ceda576d), {
                    id: `md-${key}`,
                    page: tabPage[key] || 1,
                    size: tabSize,
                    total: data.count,
                    sizes: $c99a2835eadd6e89$var$PAGE_SIZES,
                    labels: {
                        perPage: tv("rows_per_page"),
                        range: tv("range_of")
                    },
                    onPage: (next)=>{
                        setTabPage((prev)=>({
                                ...prev,
                                [key]: next
                            }));
                        loadTab(key, next);
                    },
                    onSize: (next)=>{
                        setTabSize(next);
                        setTabPage((prev)=>({
                                ...prev,
                                [key]: 1
                            }));
                        setTabData({});
                    }
                })
            ]
        });
    };
    const tabItems = $c99a2835eadd6e89$var$TABS.map((key)=>{
        const labels = {
            routes: tm("routes"),
            assignment: tm("assignment"),
            visits: tm("visits"),
            presence: tm("presence")
        };
        const counts = {
            assignment: tabData.assignment?.count,
            visits: tabData.visits?.count,
            presence: tabData.presence?.count
        };
        return {
            key: key,
            label: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $eb1133c43d00490b$export$2e2bcd8739ae039), {
                size: 6,
                children: [
                    labels[key],
                    counts[key] != null ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "md-cnt",
                        children: counts[key]
                    }) : null
                ]
            }),
            children: key === "routes" ? !isNew && item?.id ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $8d3742188f51b6e5$export$2e2bcd8739ae039), {
                user: item
            }) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $99350450b877904c$export$2e2bcd8739ae039), {
                image: (0, $99350450b877904c$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE,
                description: t("empty_tab")
            }) : key === "presence" ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                vertical: true,
                gap: "small",
                children: [
                    renderDataTab("presence", presenceColumns),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                            icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $fa25166ced813feb$export$2e2bcd8739ae039), {}),
                            onClick: openAbsence,
                            children: tl("add_absence")
                        })
                    })
                ]
            }) : key === "visits" ? renderDataTab("visits", visitColumns, (row)=>history.push(`/visit/${row.id}`)) : renderDataTab(key, assignmentColumns)
        };
    });
    /* ---------------------------------------------------------------- render: loading / error */ if (status === "loading") return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
        vertical: true,
        gap: "middle",
        className: "shell-content lp md",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e855c7114b2916ed$export$2e2bcd8739ae039), {
                active: true,
                avatar: true,
                paragraph: {
                    rows: 2
                }
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e855c7114b2916ed$export$2e2bcd8739ae039), {
                active: true,
                title: false,
                paragraph: {
                    rows: 6
                }
            })
        ]
    });
    if (status === "error" || !item && !isNew) return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
        vertical: true,
        gap: "middle",
        className: "shell-content lp md",
        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $99350450b877904c$export$2e2bcd8739ae039), {
            image: (0, $99350450b877904c$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE,
            description: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                vertical: true,
                gap: 4,
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                        strong: true,
                        children: t("not_found_title")
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                        type: "secondary",
                        children: t("not_found_desc")
                    })
                ]
            }),
            children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                onClick: ()=>history.push("/merchandiser"),
                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$72266474e9355649), "merchandiser", lang)
            })
        })
    });
    /* ---------------------------------------------------------------- render: pills */ const away = absenceNow();
    const statusPills = [];
    if (!item.is_active) statusPills.push(/*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $602120e6d17ff12a$export$2e2bcd8739ae039), {
        className: "mc-pill mc-pill--off",
        variant: "filled",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $4d7cc9843b581604$export$2e2bcd8739ae039), {
                className: "mc-pill__icon"
            }),
            " ",
            tl("status_inactive")
        ]
    }, "off"));
    else if (away) statusPills.push(/*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $602120e6d17ff12a$export$2e2bcd8739ae039), {
        className: "mc-pill mc-pill--warn",
        variant: "filled",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $257065bd7ea0ea87$export$2e2bcd8739ae039), {
                className: "mc-pill__icon"
            }),
            " ",
            tl("away_until"),
            " ",
            fmtShort(away.end)
        ]
    }, "away"));
    else statusPills.push(/*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $602120e6d17ff12a$export$2e2bcd8739ae039), {
        className: "mc-pill mc-pill--ok",
        variant: "filled",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $45839ed7c4a7faa2$export$2e2bcd8739ae039), {
                className: "mc-pill__icon"
            }),
            " ",
            tl("available")
        ]
    }, "ok"));
    if (item.is_active && isNewbie()) statusPills.push(/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $602120e6d17ff12a$export$2e2bcd8739ae039), {
        className: "md-tg md-tg--new",
        variant: "filled",
        children: tl("newbie")
    }, "new"));
    /* ---------------------------------------------------------------- render: page */ return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
        vertical: true,
        gap: "middle",
        className: "shell-content lp md",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                className: "md-bar",
                ref: barRef,
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                        className: "md-bar__crumb",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("a", {
                                onClick: ()=>history.push("/merchandiser"),
                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$72266474e9355649), "merchandiser", lang)
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                className: "md-bar__sep",
                                children: "/"
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("b", {
                                children: isNew ? t("new_merch") : name
                            }),
                            !isNew && statusPills
                        ]
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                        className: "md-bar__acts",
                        children: [
                            editing && showErrors && errors.length > 0 && /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                                className: "md-bar__state md-bar__state--err",
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $798c0df65ce199b6$export$2e2bcd8739ae039), {}),
                                    " ",
                                    errors.length
                                ]
                            }),
                            editing && !showErrors && dirty && /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                className: "md-bar__state md-bar__state--dirty",
                                children: t("unsaved")
                            }),
                            editing && !dirty && !showErrors && /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                className: "md-bar__state",
                                children: t("all_saved")
                            }),
                            editing ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $575603080129eb00$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                        size: "small",
                                        onClick: cancelEdit,
                                        children: t("cancel_btn")
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                        type: "primary",
                                        size: "small",
                                        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $7f0f32b5e0f33a0e$export$2e2bcd8739ae039), {}),
                                        disabled: !canSave,
                                        loading: busy,
                                        onClick: save,
                                        children: t("save_btn")
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $575603080129eb00$exports.Fragment), {
                                children: [
                                    !isNew && /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                        size: "small",
                                        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $257065bd7ea0ea87$export$2e2bcd8739ae039), {}),
                                        onClick: openAbsence,
                                        children: tl("add_absence")
                                    }),
                                    !isNew && (item.is_active ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                        size: "small",
                                        danger: true,
                                        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e539a200877e5e8f$export$2e2bcd8739ae039), {}),
                                        loading: busy,
                                        onClick: ()=>setActive(false),
                                        children: tl("deactivate")
                                    }) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                        size: "small",
                                        type: "primary",
                                        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $45839ed7c4a7faa2$export$2e2bcd8739ae039), {}),
                                        loading: busy,
                                        onClick: ()=>setActive(true),
                                        children: tl("activate")
                                    })),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                        type: "primary",
                                        size: "small",
                                        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $1141984d2e96fc67$export$2e2bcd8739ae039), {}),
                                        onClick: enterEdit,
                                        children: t("edit_btn")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                className: "md-grid",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                        className: "md-main",
                        children: [
                            !isNew && /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b4fda840b736e640$export$2e2bcd8739ae039), {
                                className: "md-ident",
                                variant: "outlined",
                                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                    align: "center",
                                    gap: "middle",
                                    wrap: true,
                                    children: [
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $72b7444d01b36e98$export$2e2bcd8739ae039), {
                                            size: 46,
                                            className: "md-av",
                                            style: {
                                                "fontSize": 16,
                                                "--h": avHue
                                            },
                                            src: item.photo || null,
                                            children: (0, $66539b2560a58e4e$export$f6a098653d630c23)(name)
                                        }),
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                            vertical: true,
                                            flex: "1 1 200px",
                                            style: {
                                                minWidth: 0
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                                    strong: true,
                                                    className: "md-ident__name",
                                                    children: name
                                                }),
                                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                                    className: "md-ident__sub",
                                                    align: "center",
                                                    gap: "small",
                                                    wrap: true,
                                                    children: [
                                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                                                            className: "md-wnum",
                                                            children: [
                                                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $efbc782831576418$export$2e2bcd8739ae039), {}),
                                                                " ",
                                                                item.phone_number || "\u2014"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                                                            className: "mc-mv",
                                                            children: [
                                                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $16a2a08666f58b1c$export$2e2bcd8739ae039), {
                                                                    className: "mc-mv__icon"
                                                                }),
                                                                (0, $2d75b0952f39a412$export$511554380935107b)(movementKey, lang)
                                                            ]
                                                        }),
                                                        item.county_name && /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $68eebcef827bb540$export$2e2bcd8739ae039), {}),
                                                                " ",
                                                                item.county_name
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                            className: "md-ident__metrics",
                                            gap: "large",
                                            children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                                vertical: true,
                                                align: "center",
                                                className: "md-metric",
                                                children: [
                                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                                        className: "md-metric__v",
                                                        children: item.last_visit ? fmtShort(item.last_visit) : "\u2014"
                                                    }),
                                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                                        className: "md-metric__k",
                                                        children: tl("last_visit")
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $b4fda840b736e640$export$2e2bcd8739ae039), {
                                variant: "outlined",
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                                        className: "md-sec__h",
                                        children: [
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $7804300d9b621775$export$2e2bcd8739ae039), {}),
                                            " ",
                                            t("sec_basic")
                                        ]
                                    }),
                                    editing ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                                        className: "md-form",
                                        children: [
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                                label: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $575603080129eb00$exports.Fragment), {
                                                    children: [
                                                        t("first_name"),
                                                        " ",
                                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                                            className: "md-req",
                                                            children: "*"
                                                        })
                                                    ]
                                                }),
                                                validateStatus: showErrors && !item.first_name?.trim() ? "error" : "",
                                                help: showErrors && !item.first_name?.trim() ? t("v_first_required") : null,
                                                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0883e7f8083c01b0$export$2e2bcd8739ae039), {
                                                    value: item.first_name,
                                                    onChange: (e)=>onChange("first_name", e.target.value)
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                                label: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $575603080129eb00$exports.Fragment), {
                                                    children: [
                                                        t("last_name"),
                                                        " ",
                                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                                            className: "md-req",
                                                            children: "*"
                                                        })
                                                    ]
                                                }),
                                                validateStatus: showErrors && !item.last_name?.trim() ? "error" : "",
                                                help: showErrors && !item.last_name?.trim() ? t("v_last_required") : null,
                                                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0883e7f8083c01b0$export$2e2bcd8739ae039), {
                                                    value: item.last_name,
                                                    onChange: (e)=>onChange("last_name", e.target.value)
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                                label: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $575603080129eb00$exports.Fragment), {
                                                    children: [
                                                        t("f_phone"),
                                                        " ",
                                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                                            className: "md-req",
                                                            children: "*"
                                                        })
                                                    ]
                                                }),
                                                validateStatus: showErrors && item.phone_number && !$c99a2835eadd6e89$var$PHONE_RE.test(item.phone_number.trim()) ? "error" : "",
                                                help: showErrors && item.phone_number && !$c99a2835eadd6e89$var$PHONE_RE.test(item.phone_number.trim()) ? t("v_phone_invalid") : null,
                                                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0883e7f8083c01b0$export$2e2bcd8739ae039), {
                                                    value: item.phone_number,
                                                    onChange: (e)=>onChange("phone_number", e.target.value)
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                                label: t("f_movement"),
                                                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $872fd39f1285217b$export$2e2bcd8739ae039), {
                                                    value: item.movement,
                                                    onChange: (v)=>onChange("movement", v),
                                                    options: (0, $6f1c09625235f1f0$export$dd427c62fc59153a).map((o)=>({
                                                            value: o.value,
                                                            label: (0, $2d75b0952f39a412$export$511554380935107b)(o.value, lang)
                                                        }))
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                                label: t("supervisor"),
                                                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b6929c6a194abc34$export$2e2bcd8739ae039), {
                                                    entity: "supervisors",
                                                    value: item.supervisor,
                                                    seed: item.supervisor,
                                                    onChange: (v)=>onChange("supervisor", v),
                                                    ariaLabel: t("supervisor")
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                                label: t("f_county"),
                                                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b6929c6a194abc34$export$2e2bcd8739ae039), {
                                                    entity: "counties",
                                                    value: item.county,
                                                    seed: item.county,
                                                    onChange: (v)=>onChange("county", v),
                                                    ariaLabel: t("f_county")
                                                })
                                            }),
                                            isNew && /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                                label: t("password"),
                                                className: "md-form--wide",
                                                children: [
                                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0883e7f8083c01b0$export$2e2bcd8739ae039).Password, {
                                                        value: item.password,
                                                        placeholder: t("password_ph"),
                                                        onChange: (e)=>onChange("password", e.target.value)
                                                    }),
                                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                                                        className: "md-hint",
                                                        children: t("password_hint")
                                                    })
                                                ]
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $47da64cf901a0567$export$2e2bcd8739ae039), {
                                        column: 1,
                                        size: "small",
                                        colon: false,
                                        children: [
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $47da64cf901a0567$export$2e2bcd8739ae039).Item, {
                                                label: t("f_name"),
                                                children: name
                                            }),
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $47da64cf901a0567$export$2e2bcd8739ae039).Item, {
                                                label: t("f_phone"),
                                                children: item.phone_number || (0, $66539b2560a58e4e$export$eb03490a10c3abc9)
                                            }),
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $47da64cf901a0567$export$2e2bcd8739ae039).Item, {
                                                label: t("f_movement"),
                                                children: (0, $2d75b0952f39a412$export$511554380935107b)(movementKey, lang)
                                            }),
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $47da64cf901a0567$export$2e2bcd8739ae039).Item, {
                                                label: t("supervisor"),
                                                children: item.supervisor?.name || item.supervisor_name || (0, $66539b2560a58e4e$export$eb03490a10c3abc9)
                                            }),
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $47da64cf901a0567$export$2e2bcd8739ae039).Item, {
                                                label: t("f_county"),
                                                children: item.county?.name || item.county_name || (0, $66539b2560a58e4e$export$eb03490a10c3abc9)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $b4fda840b736e640$export$2e2bcd8739ae039), {
                                variant: "outlined",
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                                        className: "md-sec__h",
                                        children: [
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3368c84d60c50017$export$2e2bcd8739ae039), {}),
                                            " ",
                                            t("sec_employment")
                                        ]
                                    }),
                                    editing ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                                        className: "md-form",
                                        children: [
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                                label: t("joined"),
                                                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $bf89508d36c51d8b$export$2e2bcd8739ae039), {
                                                    value: item.date_joined ? (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)(item.date_joined) : null,
                                                    onChange: (d)=>onChange("date_joined", d ? d.format("YYYY-MM-DDT00:00:00") : null),
                                                    style: {
                                                        width: "100%"
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                                label: t("date_till_newbie"),
                                                children: [
                                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $bf89508d36c51d8b$export$2e2bcd8739ae039), {
                                                        value: item.date_till_newbie ? (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)(item.date_till_newbie) : null,
                                                        onChange: (d)=>onChange("date_till_newbie", d ? d.format("YYYY-MM-DDT00:00:00") : null),
                                                        style: {
                                                            width: "100%"
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                                                        className: "md-hint",
                                                        children: t("newbie_hint")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                                label: " ",
                                                colon: false,
                                                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $7a650444b7c2c328$export$2e2bcd8739ae039), {
                                                    checked: item.is_active,
                                                    onChange: (e)=>onChange("is_active", e.target.checked),
                                                    children: t("f_is_active")
                                                })
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $47da64cf901a0567$export$2e2bcd8739ae039), {
                                        column: 1,
                                        size: "small",
                                        colon: false,
                                        children: [
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $47da64cf901a0567$export$2e2bcd8739ae039).Item, {
                                                label: t("joined"),
                                                children: fmtDate(item.date_joined)
                                            }),
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $47da64cf901a0567$export$2e2bcd8739ae039).Item, {
                                                label: tl("tenure"),
                                                children: [
                                                    tenureDays(),
                                                    " ",
                                                    tl("days_short")
                                                ]
                                            }),
                                            isNewbie() && /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $47da64cf901a0567$export$2e2bcd8739ae039).Item, {
                                                label: t("date_till_newbie"),
                                                children: fmtDate(item.date_till_newbie)
                                            }),
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $47da64cf901a0567$export$2e2bcd8739ae039).Item, {
                                                label: t("f_is_active"),
                                                children: item.is_active ? t("yes_lc") : t("no_lc")
                                            }),
                                            item.date_deactivated && /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $47da64cf901a0567$export$2e2bcd8739ae039).Item, {
                                                label: t("date_deactivated"),
                                                children: fmtDate(item.date_deactivated)
                                            }),
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $47da64cf901a0567$export$2e2bcd8739ae039).Item, {
                                                label: t("visits_total"),
                                                children: item.visits_total ?? "\u2014"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                        className: "md-rail",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b4fda840b736e640$export$2e2bcd8739ae039), {
                                variant: "outlined",
                                title: tl("availability"),
                                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $47da64cf901a0567$export$2e2bcd8739ae039), {
                                    column: 1,
                                    size: "small",
                                    colon: false,
                                    children: [
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $47da64cf901a0567$export$2e2bcd8739ae039).Item, {
                                            label: t("status"),
                                            children: !item.is_active ? tl("status_inactive") : away ? tl("away") : tl("available")
                                        }),
                                        away && /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $47da64cf901a0567$export$2e2bcd8739ae039).Item, {
                                            label: tl("away_until"),
                                            children: fmtShort(away.end)
                                        }),
                                        !away && nextAbsence() && /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $47da64cf901a0567$export$2e2bcd8739ae039).Item, {
                                            label: t("next_absence"),
                                            children: fmtShort(nextAbsence().start)
                                        }),
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $47da64cf901a0567$export$2e2bcd8739ae039).Item, {
                                            label: tl("newbie"),
                                            children: isNewbie() ? fmtShort(item.date_till_newbie) : t("no_lc")
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b4fda840b736e640$export$2e2bcd8739ae039), {
                                variant: "outlined",
                                title: t("summary"),
                                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $47da64cf901a0567$export$2e2bcd8739ae039), {
                                    column: 1,
                                    size: "small",
                                    colon: false,
                                    children: [
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $47da64cf901a0567$export$2e2bcd8739ae039).Item, {
                                            label: t("weekly_stops"),
                                            children: item.weekly_stops ?? "\u2014"
                                        }),
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $47da64cf901a0567$export$2e2bcd8739ae039).Item, {
                                            label: t("visits_total"),
                                            children: item.visits_total ?? "\u2014"
                                        }),
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $47da64cf901a0567$export$2e2bcd8739ae039).Item, {
                                            label: tl("tenure"),
                                            children: [
                                                tenureDays(),
                                                " ",
                                                tl("days_short")
                                            ]
                                        })
                                    ]
                                })
                            }),
                            editing && showErrors && errors.length > 0 && /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b4fda840b736e640$export$2e2bcd8739ae039), {
                                variant: "outlined",
                                title: t("v_readiness"),
                                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                    vertical: true,
                                    gap: "small",
                                    children: errors.map((e)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                            align: "center",
                                            gap: "small",
                                            className: "md-issue",
                                            children: [
                                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $798c0df65ce199b6$export$2e2bcd8739ae039), {
                                                    style: {
                                                        color: "var(--danger-700)"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                                    type: "danger",
                                                    children: t(e.key)
                                                })
                                            ]
                                        }, e.field))
                                })
                            })
                        ]
                    })
                ]
            }),
            !isNew && item?.id && /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b4fda840b736e640$export$2e2bcd8739ae039), {
                variant: "outlined",
                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $cf7a430748488e77$export$2e2bcd8739ae039), {
                    activeKey: tab,
                    onChange: setTab,
                    items: tabItems,
                    destroyOnHidden: true
                })
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $05a90c67d3627fd9$export$2e2bcd8739ae039), {
                open: absenceOpen,
                title: tl("add_absence"),
                okText: t("save_btn"),
                okButtonProps: {
                    disabled: !absForm.start || !absForm.end || !absForm.reason?.trim(),
                    loading: busy
                },
                cancelText: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f544127b46daf517), "cancel", lang),
                onOk: submitAbsence,
                onCancel: ()=>setAbsenceOpen(false),
                destroyOnHidden: true,
                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                    vertical: true,
                    gap: "middle",
                    style: {
                        paddingTop: 16
                    },
                    children: [
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                            label: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $575603080129eb00$exports.Fragment), {
                                children: [
                                    t("date_from"),
                                    " ",
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                        className: "md-req",
                                        children: "*"
                                    })
                                ]
                            }),
                            children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $bf89508d36c51d8b$export$2e2bcd8739ae039), {
                                value: absForm.start,
                                onChange: (d)=>setAbsForm((prev)=>({
                                            ...prev,
                                            start: d
                                        })),
                                style: {
                                    width: "100%"
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                            label: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $575603080129eb00$exports.Fragment), {
                                children: [
                                    t("date_to"),
                                    " ",
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                        className: "md-req",
                                        children: "*"
                                    })
                                ]
                            }),
                            children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $bf89508d36c51d8b$export$2e2bcd8739ae039), {
                                value: absForm.end,
                                onChange: (d)=>setAbsForm((prev)=>({
                                            ...prev,
                                            end: d
                                        })),
                                style: {
                                    width: "100%"
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                            label: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $575603080129eb00$exports.Fragment), {
                                children: [
                                    t("reason"),
                                    " ",
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                        className: "md-req",
                                        children: "*"
                                    })
                                ]
                            }),
                            children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0883e7f8083c01b0$export$2e2bcd8739ae039), {
                                value: absForm.reason,
                                placeholder: t("absence_reason"),
                                onChange: (e)=>setAbsForm((prev)=>({
                                            ...prev,
                                            reason: e.target.value
                                        }))
                            })
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                            label: ta("absence_short_reason_title"),
                            children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b6929c6a194abc34$export$2e2bcd8739ae039), {
                                entity: "absence_reason_templates",
                                placeholder: ta("absence_short_reason"),
                                value: absForm.reason || null,
                                onChange: (option)=>setAbsForm((prev)=>({
                                            ...prev,
                                            reason: option?.label || ""
                                        }))
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $c99a2835eadd6e89$export$2e2bcd8739ae039 = $c99a2835eadd6e89$var$Page;


/* Overview — the signed-in landing page.
   Visual reference: docs/design/overview.html. Normative rules: docs/design/spec/.

   Everything on this page comes from one request (`stats/dashboard/`). The page
   shows every card at once, so splitting it per card would only trade one
   round trip for nine — and the month stepper is the only thing that refetches:
   the merchandiser table searches and pages the rows it already has. Paging it
   server-side meant re-running every card's SQL for one table page. */ 

var $cQmXV = parcelRequire("cQmXV");



var $cQmXV = parcelRequire("cQmXV");
var $f30ee0a7eb580ee6$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($f30ee0a7eb580ee6$exports, "__esModule", {
    value: true
});
var $f30ee0a7eb580ee6$var$RiseOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M917 211.1l-199.2 24c-6.6.8-9.4 8.9-4.7 13.6l59.3 59.3-226 226-101.8-101.7c-6.3-6.3-16.4-6.2-22.6 0L100.3 754.1a8.03 8.03 0 000 11.3l45 45.2c3.1 3.1 8.2 3.1 11.3 0L433.3 534 535 635.7c6.3 6.2 16.4 6.2 22.6 0L829 364.5l59.3 59.3a8.01 8.01 0 0013.6-4.7l24-199.2c.7-5.1-3.7-9.5-8.9-8.8z"
                }
            }
        ]
    },
    "name": "rise",
    "theme": "outlined"
};
$f30ee0a7eb580ee6$exports.default = $f30ee0a7eb580ee6$var$RiseOutlined;



function $1c94f5240fc505a2$var$_extends() {
    $1c94f5240fc505a2$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1c94f5240fc505a2$var$_extends.apply(this, arguments);
}
const $1c94f5240fc505a2$var$RiseOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $1c94f5240fc505a2$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($f30ee0a7eb580ee6$exports)))
    }));
/**![rise](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkxNyAyMTEuMWwtMTk5LjIgMjRjLTYuNi44LTkuNCA4LjktNC43IDEzLjZsNTkuMyA1OS4zLTIyNiAyMjYtMTAxLjgtMTAxLjdjLTYuMy02LjMtMTYuNC02LjItMjIuNiAwTDEwMC4zIDc1NC4xYTguMDMgOC4wMyAwIDAwMCAxMS4zbDQ1IDQ1LjJjMy4xIDMuMSA4LjIgMy4xIDExLjMgMEw0MzMuMyA1MzQgNTM1IDYzNS43YzYuMyA2LjIgMTYuNCA2LjIgMjIuNiAwTDgyOSAzNjQuNWw1OS4zIDU5LjNhOC4wMSA4LjAxIDAgMDAxMy42LTQuN2wyNC0xOTkuMmMuNy01LjEtMy43LTkuNS04LjktOC44eiIgLz48L3N2Zz4=) */ const $1c94f5240fc505a2$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($1c94f5240fc505a2$var$RiseOutlined);
var $1c94f5240fc505a2$export$2e2bcd8739ae039 = $1c94f5240fc505a2$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $5b228ea485fdf420$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($5b228ea485fdf420$exports, "__esModule", {
    value: true
});
var $5b228ea485fdf420$var$FallOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M925.9 804l-24-199.2c-.8-6.6-8.9-9.4-13.6-4.7L829 659.5 557.7 388.3c-6.3-6.2-16.4-6.2-22.6 0L433.3 490 156.6 213.3a8.03 8.03 0 00-11.3 0l-45 45.2a8.03 8.03 0 000 11.3L422 591.7c6.2 6.3 16.4 6.3 22.6 0L546.4 490l226.1 226-59.3 59.3a8.01 8.01 0 004.7 13.6l199.2 24c5.1.7 9.5-3.7 8.8-8.9z"
                }
            }
        ]
    },
    "name": "fall",
    "theme": "outlined"
};
$5b228ea485fdf420$exports.default = $5b228ea485fdf420$var$FallOutlined;



function $3ebb5094d17c7fda$var$_extends() {
    $3ebb5094d17c7fda$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3ebb5094d17c7fda$var$_extends.apply(this, arguments);
}
const $3ebb5094d17c7fda$var$FallOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $3ebb5094d17c7fda$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5b228ea485fdf420$exports)))
    }));
/**![fall](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkyNS45IDgwNGwtMjQtMTk5LjJjLS44LTYuNi04LjktOS40LTEzLjYtNC43TDgyOSA2NTkuNSA1NTcuNyAzODguM2MtNi4zLTYuMi0xNi40LTYuMi0yMi42IDBMNDMzLjMgNDkwIDE1Ni42IDIxMy4zYTguMDMgOC4wMyAwIDAwLTExLjMgMGwtNDUgNDUuMmE4LjAzIDguMDMgMCAwMDAgMTEuM0w0MjIgNTkxLjdjNi4yIDYuMyAxNi40IDYuMyAyMi42IDBMNTQ2LjQgNDkwbDIyNi4xIDIyNi01OS4zIDU5LjNhOC4wMSA4LjAxIDAgMDA0LjcgMTMuNmwxOTkuMiAyNGM1LjEuNyA5LjUtMy43IDguOC04Ljl6IiAvPjwvc3ZnPg==) */ const $3ebb5094d17c7fda$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($3ebb5094d17c7fda$var$FallOutlined);
var $3ebb5094d17c7fda$export$2e2bcd8739ae039 = $3ebb5094d17c7fda$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $131ae14be0b73553$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($131ae14be0b73553$exports, "__esModule", {
    value: true
});
var $131ae14be0b73553$var$MinusOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M872 474H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "minus",
    "theme": "outlined"
};
$131ae14be0b73553$exports.default = $131ae14be0b73553$var$MinusOutlined;



function $886bddec374e5a95$var$_extends() {
    $886bddec374e5a95$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $886bddec374e5a95$var$_extends.apply(this, arguments);
}
const $886bddec374e5a95$var$MinusOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $886bddec374e5a95$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($131ae14be0b73553$exports)))
    }));
/**![minus](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg3MiA0NzRIMTUyYy00LjQgMC04IDMuNi04IDh2NjBjMCA0LjQgMy42IDggOCA4aDcyMGM0LjQgMCA4LTMuNiA4LTh2LTYwYzAtNC40LTMuNi04LTgtOHoiIC8+PC9zdmc+) */ const $886bddec374e5a95$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($886bddec374e5a95$var$MinusOutlined);
var $886bddec374e5a95$export$2e2bcd8739ae039 = $886bddec374e5a95$var$RefIcon;


/* ECharts wiring for the Overview page.
   Visual reference: docs/design/overview.html. Normative rules: docs/design/spec/.

   ECharts is registered here rather than in each component so the module list is
   in one place: only the four chart types and five components the Overview
   actually draws are pulled in, which is what keeps the tree-shaken build a
   fraction of the full `echarts` bundle. */ 
var $cQmXV = parcelRequire("cQmXV");
var $3ffd465796cef3c9$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $c5cdd91bf8145e66$exports = {};
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Core API from echarts/src/echarts
var $8d957d74809727b8$exports = {};

$parcel$export($8d957d74809727b8$exports, "version", function () { return $8d957d74809727b8$export$83d89fbfd8236492; });
$parcel$export($8d957d74809727b8$exports, "dependencies", function () { return $8d957d74809727b8$export$b74ff737e0e298b5; });
$parcel$export($8d957d74809727b8$exports, "PRIORITY", function () { return $8d957d74809727b8$export$bb34f3538ba26c7e; });
$parcel$export($8d957d74809727b8$exports, "init", function () { return $8d957d74809727b8$export$2cd8252107eb640b; });
$parcel$export($8d957d74809727b8$exports, "getInstanceByDom", function () { return $8d957d74809727b8$export$33b6fbccd4f643f8; });
$parcel$export($8d957d74809727b8$exports, "connect", function () { return $8d957d74809727b8$export$64605811ab45167f; });
$parcel$export($8d957d74809727b8$exports, "disconnect", function () { return $8d957d74809727b8$export$37dfea93db2e14ed; });
$parcel$export($8d957d74809727b8$exports, "disConnect", function () { return $8d957d74809727b8$export$87cd6834112ecb52; });
$parcel$export($8d957d74809727b8$exports, "dispose", function () { return $8d957d74809727b8$export$fcfbbcec2cb820d5; });
$parcel$export($8d957d74809727b8$exports, "getInstanceById", function () { return $8d957d74809727b8$export$89b4be35062c4a3f; });
$parcel$export($8d957d74809727b8$exports, "registerTheme", function () { return $8d957d74809727b8$export$f9c59eed5de5ff80; });
$parcel$export($8d957d74809727b8$exports, "registerPreprocessor", function () { return $8d957d74809727b8$export$77095792a057b768; });
$parcel$export($8d957d74809727b8$exports, "registerProcessor", function () { return $8d957d74809727b8$export$d575e6557ac1729f; });
$parcel$export($8d957d74809727b8$exports, "registerPostInit", function () { return $8d957d74809727b8$export$c8c249911ee8c1ed; });
$parcel$export($8d957d74809727b8$exports, "registerUpdateLifecycle", function () { return $8d957d74809727b8$export$c9ec4b5faef04865; });
$parcel$export($8d957d74809727b8$exports, "registerPostUpdate", function () { return $8d957d74809727b8$export$99560909c18c76bb; });
$parcel$export($8d957d74809727b8$exports, "registerAction", function () { return $8d957d74809727b8$export$408c24786cd729c6; });
$parcel$export($8d957d74809727b8$exports, "registerCoordinateSystem", function () { return $8d957d74809727b8$export$1dd5e025a8a37dd; });
$parcel$export($8d957d74809727b8$exports, "getCoordinateSystemDimensions", function () { return $8d957d74809727b8$export$fc2638719e4159b9; });
$parcel$export($8d957d74809727b8$exports, "registerCustomSeries", function () { return $8d957d74809727b8$export$c3e61191887968da; });
$parcel$export($8d957d74809727b8$exports, "registerLayout", function () { return $8d957d74809727b8$export$d768f97700ca6bea; });
$parcel$export($8d957d74809727b8$exports, "registerVisual", function () { return $8d957d74809727b8$export$5f32c1eb94c381bb; });
$parcel$export($8d957d74809727b8$exports, "registerLoading", function () { return $8d957d74809727b8$export$e06b68a82007c015; });
$parcel$export($8d957d74809727b8$exports, "setCanvasCreator", function () { return $8d957d74809727b8$export$10425ea7a243b114; });
$parcel$export($8d957d74809727b8$exports, "registerMap", function () { return $8d957d74809727b8$export$d456de060be2dba1; });
$parcel$export($8d957d74809727b8$exports, "getMap", function () { return $8d957d74809727b8$export$b8586192aead8a7e; });
$parcel$export($8d957d74809727b8$exports, "registerTransform", function () { return $8d957d74809727b8$export$f01d71dd0389d7e4; });
$parcel$export($8d957d74809727b8$exports, "dataTool", function () { return $8d957d74809727b8$export$73cae5e090579589; });
$parcel$export($8d957d74809727b8$exports, "registerLocale", function () { return $89683316752ed4c5$export$bab6a7822cc1e2cd; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $418c8561bd4b31f8$var$extendStatics = function(d, b) {
    $418c8561bd4b31f8$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $418c8561bd4b31f8$var$extendStatics(d, b);
};
function $418c8561bd4b31f8$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $418c8561bd4b31f8$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $418c8561bd4b31f8$export$18ce0697a983be9b = function() {
    $418c8561bd4b31f8$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $418c8561bd4b31f8$export$18ce0697a983be9b.apply(this, arguments);
};
function $418c8561bd4b31f8$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $418c8561bd4b31f8$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $418c8561bd4b31f8$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $418c8561bd4b31f8$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $418c8561bd4b31f8$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $418c8561bd4b31f8$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $418c8561bd4b31f8$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $418c8561bd4b31f8$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $418c8561bd4b31f8$export$45d3717a4c69092e(o, m, p);
}
function $418c8561bd4b31f8$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $418c8561bd4b31f8$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $418c8561bd4b31f8$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($418c8561bd4b31f8$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $418c8561bd4b31f8$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $418c8561bd4b31f8$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || from);
}
function $418c8561bd4b31f8$export$10c90e4f7922046c(v) {
    return this instanceof $418c8561bd4b31f8$export$10c90e4f7922046c ? (this.v = v, this) : new $418c8561bd4b31f8$export$10c90e4f7922046c(v);
}
function $418c8561bd4b31f8$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $418c8561bd4b31f8$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $418c8561bd4b31f8$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $418c8561bd4b31f8$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $418c8561bd4b31f8$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $418c8561bd4b31f8$export$19a8beecd37a4c45 === "function" ? $418c8561bd4b31f8$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $418c8561bd4b31f8$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $418c8561bd4b31f8$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $418c8561bd4b31f8$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $418c8561bd4b31f8$export$45d3717a4c69092e(result, mod, k);
    }
    $418c8561bd4b31f8$var$__setModuleDefault(result, mod);
    return result;
}
function $418c8561bd4b31f8$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $418c8561bd4b31f8$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $418c8561bd4b31f8$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}


var $08a7e718789e144c$exports = {};

$parcel$export($08a7e718789e144c$exports, "init", function () { return $08a7e718789e144c$export$2cd8252107eb640b; });
$parcel$export($08a7e718789e144c$exports, "dispose", function () { return $08a7e718789e144c$export$fcfbbcec2cb820d5; });
$parcel$export($08a7e718789e144c$exports, "disposeAll", function () { return $08a7e718789e144c$export$825f692fb04800ef; });
$parcel$export($08a7e718789e144c$exports, "getInstance", function () { return $08a7e718789e144c$export$8bedcca5bbd73999; });
$parcel$export($08a7e718789e144c$exports, "registerPainter", function () { return $08a7e718789e144c$export$a3e793ccb11823a5; });
$parcel$export($08a7e718789e144c$exports, "getElementSSRData", function () { return $08a7e718789e144c$export$dd7015a5412ca583; });
$parcel$export($08a7e718789e144c$exports, "registerSSRDataGetter", function () { return $08a7e718789e144c$export$e7a09d7fe68a4f7; });
$parcel$export($08a7e718789e144c$exports, "version", function () { return $08a7e718789e144c$export$83d89fbfd8236492; });
/*!
* ZRender, a high performance 2d drawing library.
*
* Copyright (c) 2013, Baidu Inc.
* All rights reserved.
*
* LICENSE
* https://github.com/ecomfe/zrender/blob/master/LICENSE
*/ var $a84633bb9c74d89c$var$Browser = function() {
    function Browser() {
        this.firefox = false;
        this.ie = false;
        this.edge = false;
        this.newEdge = false;
        this.weChat = false;
    }
    return Browser;
}();
var $a84633bb9c74d89c$var$Env = function() {
    function Env() {
        this.browser = new $a84633bb9c74d89c$var$Browser();
        this.node = false;
        this.wxa = false;
        this.worker = false;
        this.svgSupported = false;
        this.touchEventsSupported = false;
        this.pointerEventsSupported = false;
        this.domSupported = false;
        this.transformSupported = false;
        this.transform3dSupported = false;
        this.hasGlobalWindow = typeof window !== "undefined";
    }
    return Env;
}();
var $a84633bb9c74d89c$var$env = new $a84633bb9c74d89c$var$Env();
if (typeof wx === "object" && typeof wx.getSystemInfoSync === "function") {
    $a84633bb9c74d89c$var$env.wxa = true;
    $a84633bb9c74d89c$var$env.touchEventsSupported = true;
} else if (typeof document === "undefined" && typeof self !== "undefined") $a84633bb9c74d89c$var$env.worker = true;
else if (!$a84633bb9c74d89c$var$env.hasGlobalWindow || "Deno" in window || typeof navigator !== "undefined" && typeof navigator.userAgent === "string" && navigator.userAgent.indexOf("Node.js") > -1) {
    $a84633bb9c74d89c$var$env.node = true;
    $a84633bb9c74d89c$var$env.svgSupported = true;
} else $a84633bb9c74d89c$var$detect(navigator.userAgent, $a84633bb9c74d89c$var$env);
function $a84633bb9c74d89c$var$detect(ua, env) {
    var browser = env.browser;
    var firefox = ua.match(/Firefox\/([\d.]+)/);
    var ie = ua.match(/MSIE\s([\d.]+)/) || ua.match(/Trident\/.+?rv:(([\d.]+))/);
    var edge = ua.match(/Edge?\/([\d.]+)/);
    var weChat = /micromessenger/i.test(ua);
    if (firefox) {
        browser.firefox = true;
        browser.version = firefox[1];
    }
    if (ie) {
        browser.ie = true;
        browser.version = ie[1];
    }
    if (edge) {
        browser.edge = true;
        browser.version = edge[1];
        browser.newEdge = +edge[1].split(".")[0] > 18;
    }
    if (weChat) browser.weChat = true;
    env.svgSupported = typeof SVGRect !== "undefined";
    env.touchEventsSupported = "ontouchstart" in window && !browser.ie && !browser.edge;
    env.pointerEventsSupported = "onpointerdown" in window && (browser.edge || browser.ie && +browser.version >= 11);
    var domSupported = env.domSupported = typeof document !== "undefined";
    if (domSupported) {
        var style = document.documentElement.style;
        env.transform3dSupported = (browser.ie && "transition" in style || browser.edge || "WebKitCSSMatrix" in window && "m11" in new WebKitCSSMatrix() || "MozPerspective" in style) && !("OTransition" in style);
        env.transformSupported = env.transform3dSupported || browser.ie && +browser.version >= 9;
    }
}
var $a84633bb9c74d89c$export$2e2bcd8739ae039 = $a84633bb9c74d89c$var$env;


var $43e0a445ed6711da$exports = {};

$parcel$export($43e0a445ed6711da$exports, "reduce", function () { return $43e0a445ed6711da$export$533b26079ad0b4b; });
$parcel$export($43e0a445ed6711da$exports, "guid", function () { return $43e0a445ed6711da$export$46e8f25c7328f77e; });
$parcel$export($43e0a445ed6711da$exports, "logError", function () { return $43e0a445ed6711da$export$58da9968c3170cb1; });
$parcel$export($43e0a445ed6711da$exports, "clone", function () { return $43e0a445ed6711da$export$9cd59f9826255e47; });
$parcel$export($43e0a445ed6711da$exports, "isPrimitive", function () { return $43e0a445ed6711da$export$c3825b437cbdea5c; });
$parcel$export($43e0a445ed6711da$exports, "isDom", function () { return $43e0a445ed6711da$export$9f57505b7bd8dae; });
$parcel$export($43e0a445ed6711da$exports, "merge", function () { return $43e0a445ed6711da$export$4950aa0f605343fb; });
$parcel$export($43e0a445ed6711da$exports, "isObject", function () { return $43e0a445ed6711da$export$a6cdc56e425d0d0a; });
$parcel$export($43e0a445ed6711da$exports, "isArray", function () { return $43e0a445ed6711da$export$43bee75e5e14138e; });
$parcel$export($43e0a445ed6711da$exports, "isBuiltInObject", function () { return $43e0a445ed6711da$export$fa523b2c4941fd4f; });
$parcel$export($43e0a445ed6711da$exports, "mergeAll", function () { return $43e0a445ed6711da$export$18aef43295bbe906; });
$parcel$export($43e0a445ed6711da$exports, "extend", function () { return $43e0a445ed6711da$export$8b58be045bf06082; });
$parcel$export($43e0a445ed6711da$exports, "assignProps", function () { return $43e0a445ed6711da$export$2b3af8009eff404f; });
$parcel$export($43e0a445ed6711da$exports, "defaults", function () { return $43e0a445ed6711da$export$ebe90cb607ad99e; });
$parcel$export($43e0a445ed6711da$exports, "keys", function () { return $43e0a445ed6711da$export$ed97f33186d4b816; });
$parcel$export($43e0a445ed6711da$exports, "createCanvas", function () { return $43e0a445ed6711da$export$cd3d1f114b139967; });
$parcel$export($43e0a445ed6711da$exports, "indexOf", function () { return $43e0a445ed6711da$export$305f7d4e9d4624f2; });
$parcel$export($43e0a445ed6711da$exports, "inherits", function () { return $43e0a445ed6711da$export$69f1b2dcda23c5f8; });
$parcel$export($43e0a445ed6711da$exports, "mixin", function () { return $43e0a445ed6711da$export$e36fc9d62a853069; });
$parcel$export($43e0a445ed6711da$exports, "isArrayLike", function () { return $43e0a445ed6711da$export$1e2f57719e155213; });
$parcel$export($43e0a445ed6711da$exports, "each", function () { return $43e0a445ed6711da$export$79b2f7037acddd43; });
$parcel$export($43e0a445ed6711da$exports, "map", function () { return $43e0a445ed6711da$export$871de8747c9eaa88; });
$parcel$export($43e0a445ed6711da$exports, "slice", function () { return $43e0a445ed6711da$export$58adb3bec8346d0f; });
$parcel$export($43e0a445ed6711da$exports, "filter", function () { return $43e0a445ed6711da$export$3dea766d36a8935f; });
$parcel$export($43e0a445ed6711da$exports, "find", function () { return $43e0a445ed6711da$export$71aa6c912b956294; });
$parcel$export($43e0a445ed6711da$exports, "bind", function () { return $43e0a445ed6711da$export$2385a24977818dd0; });
$parcel$export($43e0a445ed6711da$exports, "isFunction", function () { return $43e0a445ed6711da$export$f6e2535fb5126e54; });
$parcel$export($43e0a445ed6711da$exports, "curry", function () { return $43e0a445ed6711da$export$c3095a23b368d1f2; });
$parcel$export($43e0a445ed6711da$exports, "isString", function () { return $43e0a445ed6711da$export$844ec244b1367d54; });
$parcel$export($43e0a445ed6711da$exports, "isStringSafe", function () { return $43e0a445ed6711da$export$29d0bb2a4e07b252; });
$parcel$export($43e0a445ed6711da$exports, "isNumber", function () { return $43e0a445ed6711da$export$7e4aa119212bc614; });
$parcel$export($43e0a445ed6711da$exports, "isTypedArray", function () { return $43e0a445ed6711da$export$b119cc7e1840e59c; });
$parcel$export($43e0a445ed6711da$exports, "isGradientObject", function () { return $43e0a445ed6711da$export$fa2c283003ed971c; });
$parcel$export($43e0a445ed6711da$exports, "isImagePatternObject", function () { return $43e0a445ed6711da$export$a49bbf3a55dcef7b; });
$parcel$export($43e0a445ed6711da$exports, "isRegExp", function () { return $43e0a445ed6711da$export$49841c62b9eff15; });
$parcel$export($43e0a445ed6711da$exports, "eqNaN", function () { return $43e0a445ed6711da$export$7d667b9a0c48c975; });
$parcel$export($43e0a445ed6711da$exports, "retrieve", function () { return $43e0a445ed6711da$export$8a4d17b6e8486e66; });
$parcel$export($43e0a445ed6711da$exports, "retrieve2", function () { return $43e0a445ed6711da$export$995e01f2f5c9d030; });
$parcel$export($43e0a445ed6711da$exports, "retrieve3", function () { return $43e0a445ed6711da$export$2e94551289abb95b; });
$parcel$export($43e0a445ed6711da$exports, "normalizeCssArray", function () { return $43e0a445ed6711da$export$f3a38102c49f4268; });
$parcel$export($43e0a445ed6711da$exports, "assert", function () { return $43e0a445ed6711da$export$a7a9523472993e97; });
$parcel$export($43e0a445ed6711da$exports, "trim", function () { return $43e0a445ed6711da$export$87c2784dc9fc4ab; });
$parcel$export($43e0a445ed6711da$exports, "setAsPrimitive", function () { return $43e0a445ed6711da$export$112e66431016387b; });
$parcel$export($43e0a445ed6711da$exports, "HashMap", function () { return $43e0a445ed6711da$export$60ef0b43d585640a; });
$parcel$export($43e0a445ed6711da$exports, "createHashMap", function () { return $43e0a445ed6711da$export$55f8aa7ef875b0a4; });
$parcel$export($43e0a445ed6711da$exports, "concatArray", function () { return $43e0a445ed6711da$export$4fd8af2c48c43416; });
$parcel$export($43e0a445ed6711da$exports, "createObject", function () { return $43e0a445ed6711da$export$79c7e160a7743efd; });
$parcel$export($43e0a445ed6711da$exports, "disableUserSelect", function () { return $43e0a445ed6711da$export$23a5d775868fdd2c; });
$parcel$export($43e0a445ed6711da$exports, "hasOwn", function () { return $43e0a445ed6711da$export$b5a638e9b3fff9f3; });
$parcel$export($43e0a445ed6711da$exports, "noop", function () { return $43e0a445ed6711da$export$8793edee2d425525; });
$parcel$export($43e0a445ed6711da$exports, "RADIAN_TO_DEGREE", function () { return $43e0a445ed6711da$export$bce8e055322a0ce6; });
$parcel$export($43e0a445ed6711da$exports, "EPSILON", function () { return $43e0a445ed6711da$export$fd293b15f47e270; });
var $08c3209e6efc839a$export$b1461457ea2c1179 = 12;
var $08c3209e6efc839a$export$2653e0d5dd45b294 = "sans-serif";
var $08c3209e6efc839a$export$7d7a232b6d2cc80c = $08c3209e6efc839a$export$b1461457ea2c1179 + "px " + $08c3209e6efc839a$export$2653e0d5dd45b294;
var $08c3209e6efc839a$var$OFFSET = 20;
var $08c3209e6efc839a$var$SCALE = 100;
var $08c3209e6efc839a$var$defaultWidthMapStr = "007LLmW'55;N0500LLLLLLLLLL00NNNLzWW\\\\WQb\\0FWLg\\bWb\\WQ\\WrWWQ000CL5LLFLL0LL**F*gLLLL5F0LF\\FFF5.5N";
function $08c3209e6efc839a$var$getTextWidthMap(mapStr) {
    var map = {};
    if (typeof JSON === "undefined") return map;
    for(var i = 0; i < mapStr.length; i++){
        var char = String.fromCharCode(i + 32);
        var size = (mapStr.charCodeAt(i) - $08c3209e6efc839a$var$OFFSET) / $08c3209e6efc839a$var$SCALE;
        map[char] = size;
    }
    return map;
}
var $08c3209e6efc839a$export$69462fcc6bf851a4 = $08c3209e6efc839a$var$getTextWidthMap($08c3209e6efc839a$var$defaultWidthMapStr);
var $08c3209e6efc839a$export$ef5e599365494451 = {
    createCanvas: function() {
        return typeof document !== "undefined" && document.createElement("canvas");
    },
    measureText: function() {
        var _ctx;
        var _cachedFont;
        return function(text, font) {
            if (!_ctx) {
                var canvas = $08c3209e6efc839a$export$ef5e599365494451.createCanvas();
                _ctx = canvas && canvas.getContext("2d");
            }
            if (_ctx) {
                if (_cachedFont !== font) _cachedFont = _ctx.font = font || $08c3209e6efc839a$export$7d7a232b6d2cc80c;
                return _ctx.measureText(text);
            } else {
                text = text || "";
                font = font || $08c3209e6efc839a$export$7d7a232b6d2cc80c;
                var res = /((?:\d+)?\.?\d*)px/.exec(font);
                var fontSize = res && +res[1] || $08c3209e6efc839a$export$b1461457ea2c1179;
                var width = 0;
                if (font.indexOf("mono") >= 0) width = fontSize * text.length;
                else for(var i = 0; i < text.length; i++){
                    var preCalcWidth = $08c3209e6efc839a$export$69462fcc6bf851a4[text[i]];
                    width += preCalcWidth == null ? fontSize : preCalcWidth * fontSize;
                }
                return {
                    width: width
                };
            }
        };
    }(),
    loadImage: function(src, onload, onerror) {
        var image = new Image();
        image.onload = onload;
        image.onerror = onerror;
        image.src = src;
        return image;
    },
    getTime: function() {
        return Date.now ? Date.now() : +new Date();
    }
};
function $08c3209e6efc839a$export$61bcfd79465c1b7c(newPlatformApis) {
    for(var key in $08c3209e6efc839a$export$ef5e599365494451)if ($08c3209e6efc839a$export$ef5e599365494451.hasOwnProperty(key) && newPlatformApis[key]) $08c3209e6efc839a$export$ef5e599365494451[key] = newPlatformApis[key];
}


var $43e0a445ed6711da$var$BUILTIN_OBJECT = $43e0a445ed6711da$export$533b26079ad0b4b([
    "Function",
    "RegExp",
    "Date",
    "Error",
    "CanvasGradient",
    "CanvasPattern",
    "Image",
    "Canvas"
], function(obj, val) {
    obj["[object " + val + "]"] = true;
    return obj;
}, {});
var $43e0a445ed6711da$var$TYPED_ARRAY = $43e0a445ed6711da$export$533b26079ad0b4b([
    "Int8",
    "Uint8",
    "Uint8Clamped",
    "Int16",
    "Uint16",
    "Int32",
    "Uint32",
    "Float32",
    "Float64"
], function(obj, val) {
    obj["[object " + val + "Array]"] = true;
    return obj;
}, {});
var $43e0a445ed6711da$var$objToString = Object.prototype.toString;
var $43e0a445ed6711da$var$arrayProto = Array.prototype;
var $43e0a445ed6711da$var$nativeForEach = $43e0a445ed6711da$var$arrayProto.forEach;
var $43e0a445ed6711da$var$nativeFilter = $43e0a445ed6711da$var$arrayProto.filter;
var $43e0a445ed6711da$var$nativeSlice = $43e0a445ed6711da$var$arrayProto.slice;
var $43e0a445ed6711da$var$nativeMap = $43e0a445ed6711da$var$arrayProto.map;
var $43e0a445ed6711da$var$ctorFunction = (function() {}).constructor;
var $43e0a445ed6711da$var$protoFunction = $43e0a445ed6711da$var$ctorFunction ? $43e0a445ed6711da$var$ctorFunction.prototype : null;
var $43e0a445ed6711da$var$protoKey = "__proto__";
var $43e0a445ed6711da$var$idStart = 0x0907;
var $43e0a445ed6711da$var$MAX_SAFE_INTEGER = Math.pow(2, 53) - 1;
function $43e0a445ed6711da$export$46e8f25c7328f77e() {
    if ($43e0a445ed6711da$var$idStart >= $43e0a445ed6711da$var$MAX_SAFE_INTEGER) $43e0a445ed6711da$var$idStart = 0;
    return $43e0a445ed6711da$var$idStart++;
}
function $43e0a445ed6711da$export$58da9968c3170cb1() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    if (typeof console !== "undefined") console.error.apply(console, args);
}
function $43e0a445ed6711da$export$9cd59f9826255e47(source) {
    if (source == null || typeof source !== "object") return source;
    var result = source;
    var typeStr = $43e0a445ed6711da$var$objToString.call(source);
    if (typeStr === "[object Array]") {
        if (!$43e0a445ed6711da$export$c3825b437cbdea5c(source)) {
            result = [];
            for(var i = 0, len = source.length; i < len; i++)result[i] = $43e0a445ed6711da$export$9cd59f9826255e47(source[i]);
        }
    } else if ($43e0a445ed6711da$var$TYPED_ARRAY[typeStr]) {
        if (!$43e0a445ed6711da$export$c3825b437cbdea5c(source)) {
            var Ctor = source.constructor;
            if (Ctor.from) result = Ctor.from(source);
            else {
                result = new Ctor(source.length);
                for(var i = 0, len = source.length; i < len; i++)result[i] = source[i];
            }
        }
    } else if (!$43e0a445ed6711da$var$BUILTIN_OBJECT[typeStr] && !$43e0a445ed6711da$export$c3825b437cbdea5c(source) && !$43e0a445ed6711da$export$9f57505b7bd8dae(source)) {
        result = {};
        for(var key in source)if (source.hasOwnProperty(key) && key !== $43e0a445ed6711da$var$protoKey) result[key] = $43e0a445ed6711da$export$9cd59f9826255e47(source[key]);
    }
    return result;
}
function $43e0a445ed6711da$export$4950aa0f605343fb(target, source, overwrite) {
    if (!$43e0a445ed6711da$export$a6cdc56e425d0d0a(source) || !$43e0a445ed6711da$export$a6cdc56e425d0d0a(target)) return overwrite ? $43e0a445ed6711da$export$9cd59f9826255e47(source) : target;
    for(var key in source)if (source.hasOwnProperty(key) && key !== $43e0a445ed6711da$var$protoKey) {
        var targetProp = target[key];
        var sourceProp = source[key];
        if ($43e0a445ed6711da$export$a6cdc56e425d0d0a(sourceProp) && $43e0a445ed6711da$export$a6cdc56e425d0d0a(targetProp) && !$43e0a445ed6711da$export$43bee75e5e14138e(sourceProp) && !$43e0a445ed6711da$export$43bee75e5e14138e(targetProp) && !$43e0a445ed6711da$export$9f57505b7bd8dae(sourceProp) && !$43e0a445ed6711da$export$9f57505b7bd8dae(targetProp) && !$43e0a445ed6711da$export$fa523b2c4941fd4f(sourceProp) && !$43e0a445ed6711da$export$fa523b2c4941fd4f(targetProp) && !$43e0a445ed6711da$export$c3825b437cbdea5c(sourceProp) && !$43e0a445ed6711da$export$c3825b437cbdea5c(targetProp)) $43e0a445ed6711da$export$4950aa0f605343fb(targetProp, sourceProp, overwrite);
        else if (overwrite || !(key in target)) target[key] = $43e0a445ed6711da$export$9cd59f9826255e47(source[key]);
    }
    return target;
}
function $43e0a445ed6711da$export$18aef43295bbe906(targetAndSources, overwrite) {
    var result = targetAndSources[0];
    for(var i = 1, len = targetAndSources.length; i < len; i++)result = $43e0a445ed6711da$export$4950aa0f605343fb(result, targetAndSources[i], overwrite);
    return result;
}
function $43e0a445ed6711da$export$8b58be045bf06082(target, source) {
    if (Object.assign) Object.assign(target, source);
    else {
        for(var key in source)if (source.hasOwnProperty(key) && key !== $43e0a445ed6711da$var$protoKey) target[key] = source[key];
    }
    return target;
}
function $43e0a445ed6711da$export$2b3af8009eff404f(tar, src, props) {
    tar = tar || {};
    for(var idx = 0; idx < props.length; idx++){
        var prop = props[idx];
        tar[prop] = src[prop];
    }
    return tar;
}
function $43e0a445ed6711da$export$ebe90cb607ad99e(target, source, overlay) {
    var keysArr = $43e0a445ed6711da$export$ed97f33186d4b816(source);
    for(var i = 0, len = keysArr.length; i < len; i++){
        var key = keysArr[i];
        if (overlay ? source[key] != null : target[key] == null) target[key] = source[key];
    }
    return target;
}
var $43e0a445ed6711da$export$cd3d1f114b139967 = (0, $08c3209e6efc839a$export$ef5e599365494451).createCanvas;
function $43e0a445ed6711da$export$305f7d4e9d4624f2(array, value) {
    if (array) {
        if (array.indexOf) return array.indexOf(value);
        for(var i = 0, len = array.length; i < len; i++){
            if (array[i] === value) return i;
        }
    }
    return -1;
}
function $43e0a445ed6711da$export$69f1b2dcda23c5f8(clazz, baseClazz) {
    var clazzPrototype = clazz.prototype;
    function F() {}
    F.prototype = baseClazz.prototype;
    clazz.prototype = new F();
    for(var prop in clazzPrototype)if (clazzPrototype.hasOwnProperty(prop)) clazz.prototype[prop] = clazzPrototype[prop];
    clazz.prototype.constructor = clazz;
    clazz.superClass = baseClazz;
}
function $43e0a445ed6711da$export$e36fc9d62a853069(target, source, override) {
    target = "prototype" in target ? target.prototype : target;
    source = "prototype" in source ? source.prototype : source;
    if (Object.getOwnPropertyNames) {
        var keyList = Object.getOwnPropertyNames(source);
        for(var i = 0; i < keyList.length; i++){
            var key = keyList[i];
            if (key !== "constructor") {
                if (override ? source[key] != null : target[key] == null) target[key] = source[key];
            }
        }
    } else $43e0a445ed6711da$export$ebe90cb607ad99e(target, source, override);
}
function $43e0a445ed6711da$export$1e2f57719e155213(data) {
    if (!data) return false;
    if (typeof data === "string") return false;
    return typeof data.length === "number";
}
function $43e0a445ed6711da$export$79b2f7037acddd43(arr, cb, context) {
    if (!(arr && cb)) return;
    if (arr.forEach && arr.forEach === $43e0a445ed6711da$var$nativeForEach) arr.forEach(cb, context);
    else if (arr.length === +arr.length) for(var i = 0, len = arr.length; i < len; i++)cb.call(context, arr[i], i, arr);
    else {
        for(var key in arr)if (arr.hasOwnProperty(key)) cb.call(context, arr[key], key, arr);
    }
}
function $43e0a445ed6711da$export$871de8747c9eaa88(arr, cb, context) {
    if (!arr) return [];
    if (!cb) return $43e0a445ed6711da$export$58adb3bec8346d0f(arr);
    if (arr.map && arr.map === $43e0a445ed6711da$var$nativeMap) return arr.map(cb, context);
    else {
        var result = [];
        for(var i = 0, len = arr.length; i < len; i++)result.push(cb.call(context, arr[i], i, arr));
        return result;
    }
}
function $43e0a445ed6711da$export$533b26079ad0b4b(arr, cb, memo, context) {
    if (!(arr && cb)) return;
    for(var i = 0, len = arr.length; i < len; i++)memo = cb.call(context, memo, arr[i], i, arr);
    return memo;
}
function $43e0a445ed6711da$export$3dea766d36a8935f(arr, cb, context) {
    if (!arr) return [];
    if (!cb) return $43e0a445ed6711da$export$58adb3bec8346d0f(arr);
    if (arr.filter && arr.filter === $43e0a445ed6711da$var$nativeFilter) return arr.filter(cb, context);
    else {
        var result = [];
        for(var i = 0, len = arr.length; i < len; i++)if (cb.call(context, arr[i], i, arr)) result.push(arr[i]);
        return result;
    }
}
function $43e0a445ed6711da$export$71aa6c912b956294(arr, cb, context) {
    if (!(arr && cb)) return;
    for(var i = 0, len = arr.length; i < len; i++){
        if (cb.call(context, arr[i], i, arr)) return arr[i];
    }
}
function $43e0a445ed6711da$export$ed97f33186d4b816(obj) {
    if (!obj) return [];
    if (Object.keys) return Object.keys(obj);
    var keyList = [];
    for(var key in obj)if (obj.hasOwnProperty(key)) keyList.push(key);
    return keyList;
}
function $43e0a445ed6711da$var$bindPolyfill(func, context) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    return function() {
        return func.apply(context, args.concat($43e0a445ed6711da$var$nativeSlice.call(arguments)));
    };
}
var $43e0a445ed6711da$export$2385a24977818dd0 = $43e0a445ed6711da$var$protoFunction && $43e0a445ed6711da$export$f6e2535fb5126e54($43e0a445ed6711da$var$protoFunction.bind) ? $43e0a445ed6711da$var$protoFunction.call.bind($43e0a445ed6711da$var$protoFunction.bind) : $43e0a445ed6711da$var$bindPolyfill;
function $43e0a445ed6711da$export$c3095a23b368d1f2(func) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    return function() {
        return func.apply(this, args.concat($43e0a445ed6711da$var$nativeSlice.call(arguments)));
    };
}
function $43e0a445ed6711da$export$43bee75e5e14138e(value) {
    if (Array.isArray) return Array.isArray(value);
    return $43e0a445ed6711da$var$objToString.call(value) === "[object Array]";
}
function $43e0a445ed6711da$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
}
function $43e0a445ed6711da$export$844ec244b1367d54(value) {
    return typeof value === "string";
}
function $43e0a445ed6711da$export$29d0bb2a4e07b252(value) {
    return $43e0a445ed6711da$var$objToString.call(value) === "[object String]";
}
function $43e0a445ed6711da$export$7e4aa119212bc614(value) {
    return typeof value === "number";
}
function $43e0a445ed6711da$export$a6cdc56e425d0d0a(value) {
    var type = typeof value;
    return type === "function" || !!value && type === "object";
}
function $43e0a445ed6711da$export$fa523b2c4941fd4f(value) {
    return !!$43e0a445ed6711da$var$BUILTIN_OBJECT[$43e0a445ed6711da$var$objToString.call(value)];
}
function $43e0a445ed6711da$export$b119cc7e1840e59c(value) {
    return !!$43e0a445ed6711da$var$TYPED_ARRAY[$43e0a445ed6711da$var$objToString.call(value)];
}
function $43e0a445ed6711da$export$9f57505b7bd8dae(value) {
    return typeof value === "object" && typeof value.nodeType === "number" && typeof value.ownerDocument === "object";
}
function $43e0a445ed6711da$export$fa2c283003ed971c(value) {
    return value.colorStops != null;
}
function $43e0a445ed6711da$export$a49bbf3a55dcef7b(value) {
    return value.image != null;
}
function $43e0a445ed6711da$export$49841c62b9eff15(value) {
    return $43e0a445ed6711da$var$objToString.call(value) === "[object RegExp]";
}
function $43e0a445ed6711da$export$7d667b9a0c48c975(value) {
    return value !== value;
}
function $43e0a445ed6711da$export$8a4d17b6e8486e66() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    for(var i = 0, len = args.length; i < len; i++){
        if (args[i] != null) return args[i];
    }
}
function $43e0a445ed6711da$export$995e01f2f5c9d030(value0, value1) {
    return value0 != null ? value0 : value1;
}
function $43e0a445ed6711da$export$2e94551289abb95b(value0, value1, value2) {
    return value0 != null ? value0 : value1 != null ? value1 : value2;
}
function $43e0a445ed6711da$export$58adb3bec8346d0f(arr) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    return $43e0a445ed6711da$var$nativeSlice.apply(arr, args);
}
function $43e0a445ed6711da$export$f3a38102c49f4268(val) {
    if (typeof val === "number") return [
        val,
        val,
        val,
        val
    ];
    var len = val.length;
    if (len === 2) return [
        val[0],
        val[1],
        val[0],
        val[1]
    ];
    else if (len === 3) return [
        val[0],
        val[1],
        val[2],
        val[1]
    ];
    return val;
}
function $43e0a445ed6711da$export$a7a9523472993e97(condition, message) {
    if (!condition) throw new Error(message);
}
function $43e0a445ed6711da$export$87c2784dc9fc4ab(str) {
    if (str == null) return null;
    else if (typeof str.trim === "function") return str.trim();
    else return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
}
var $43e0a445ed6711da$var$primitiveKey = "__ec_primitive__";
function $43e0a445ed6711da$export$112e66431016387b(obj) {
    obj[$43e0a445ed6711da$var$primitiveKey] = true;
}
function $43e0a445ed6711da$export$c3825b437cbdea5c(obj) {
    return obj[$43e0a445ed6711da$var$primitiveKey];
}
var $43e0a445ed6711da$var$MapPolyfill = function() {
    function MapPolyfill() {
        this.data = {};
    }
    MapPolyfill.prototype["delete"] = function(key) {
        var existed = this.has(key);
        if (existed) delete this.data[key];
        return existed;
    };
    MapPolyfill.prototype.has = function(key) {
        return this.data.hasOwnProperty(key);
    };
    MapPolyfill.prototype.get = function(key) {
        return this.data[key];
    };
    MapPolyfill.prototype.set = function(key, value) {
        this.data[key] = value;
        return this;
    };
    MapPolyfill.prototype.keys = function() {
        return $43e0a445ed6711da$export$ed97f33186d4b816(this.data);
    };
    MapPolyfill.prototype.forEach = function(callback) {
        var data = this.data;
        for(var key in data)if (data.hasOwnProperty(key)) callback(data[key], key);
    };
    return MapPolyfill;
}();
var $43e0a445ed6711da$var$isNativeMapSupported = typeof Map === "function";
function $43e0a445ed6711da$var$maybeNativeMap() {
    return $43e0a445ed6711da$var$isNativeMapSupported ? new Map() : new $43e0a445ed6711da$var$MapPolyfill();
}
var $43e0a445ed6711da$export$60ef0b43d585640a = function() {
    function HashMap(obj) {
        var isArr = $43e0a445ed6711da$export$43bee75e5e14138e(obj);
        this.data = $43e0a445ed6711da$var$maybeNativeMap();
        var thisMap = this;
        obj instanceof HashMap ? obj.each(visit) : obj && $43e0a445ed6711da$export$79b2f7037acddd43(obj, visit);
        function visit(value, key) {
            isArr ? thisMap.set(value, key) : thisMap.set(key, value);
        }
    }
    HashMap.prototype.hasKey = function(key) {
        return this.data.has(key);
    };
    HashMap.prototype.get = function(key) {
        return this.data.get(key);
    };
    HashMap.prototype.set = function(key, value) {
        this.data.set(key, value);
        return value;
    };
    HashMap.prototype.each = function(cb, context) {
        this.data.forEach(function(value, key) {
            cb.call(context, value, key);
        });
    };
    HashMap.prototype.keys = function() {
        var keys = this.data.keys();
        return $43e0a445ed6711da$var$isNativeMapSupported ? Array.from(keys) : keys;
    };
    HashMap.prototype.removeKey = function(key) {
        this.data["delete"](key);
    };
    return HashMap;
}();
function $43e0a445ed6711da$export$55f8aa7ef875b0a4(obj) {
    return new $43e0a445ed6711da$export$60ef0b43d585640a(obj);
}
function $43e0a445ed6711da$export$4fd8af2c48c43416(a, b) {
    var newArray = new a.constructor(a.length + b.length);
    for(var i = 0; i < a.length; i++)newArray[i] = a[i];
    var offset = a.length;
    for(var i = 0; i < b.length; i++)newArray[i + offset] = b[i];
    return newArray;
}
function $43e0a445ed6711da$export$79c7e160a7743efd(proto, properties) {
    var obj;
    if (Object.create) obj = Object.create(proto);
    else {
        var StyleCtor = function() {};
        StyleCtor.prototype = proto;
        obj = new StyleCtor();
    }
    if (properties) $43e0a445ed6711da$export$8b58be045bf06082(obj, properties);
    return obj;
}
function $43e0a445ed6711da$export$23a5d775868fdd2c(dom) {
    var domStyle = dom.style;
    domStyle.webkitUserSelect = "none";
    domStyle.userSelect = "none";
    domStyle.webkitTapHighlightColor = "rgba(0,0,0,0)";
    domStyle["-webkit-touch-callout"] = "none";
}
function $43e0a445ed6711da$export$b5a638e9b3fff9f3(own, prop) {
    return own.hasOwnProperty(prop);
}
function $43e0a445ed6711da$export$8793edee2d425525() {}
var $43e0a445ed6711da$export$bce8e055322a0ce6 = 180 / Math.PI;
var $43e0a445ed6711da$export$fd293b15f47e270 = Number.EPSILON || Math.pow(2, -52);




var $ee491d8f32bd01ff$exports = {};

$parcel$export($ee491d8f32bd01ff$exports, "create", function () { return $ee491d8f32bd01ff$export$185802fd694ee1f5; });
$parcel$export($ee491d8f32bd01ff$exports, "copy", function () { return $ee491d8f32bd01ff$export$784d13d8ee351f07; });
$parcel$export($ee491d8f32bd01ff$exports, "clone", function () { return $ee491d8f32bd01ff$export$9cd59f9826255e47; });
$parcel$export($ee491d8f32bd01ff$exports, "set", function () { return $ee491d8f32bd01ff$export$adaa4cf7ef1b65be; });
$parcel$export($ee491d8f32bd01ff$exports, "add", function () { return $ee491d8f32bd01ff$export$e16d8520af44a096; });
$parcel$export($ee491d8f32bd01ff$exports, "scaleAndAdd", function () { return $ee491d8f32bd01ff$export$19cedf1da84ba854; });
$parcel$export($ee491d8f32bd01ff$exports, "sub", function () { return $ee491d8f32bd01ff$export$f93b5905241a7cca; });
$parcel$export($ee491d8f32bd01ff$exports, "len", function () { return $ee491d8f32bd01ff$export$fc1400facf92c78; });
$parcel$export($ee491d8f32bd01ff$exports, "lenSquare", function () { return $ee491d8f32bd01ff$export$48e33bc611e4c25a; });
$parcel$export($ee491d8f32bd01ff$exports, "length", function () { return $ee491d8f32bd01ff$export$f24224f1c91d8156; });
$parcel$export($ee491d8f32bd01ff$exports, "lengthSquare", function () { return $ee491d8f32bd01ff$export$2f106540dd9a5136; });
$parcel$export($ee491d8f32bd01ff$exports, "mul", function () { return $ee491d8f32bd01ff$export$6e3a27864ab166fe; });
$parcel$export($ee491d8f32bd01ff$exports, "div", function () { return $ee491d8f32bd01ff$export$159d9494db57879b; });
$parcel$export($ee491d8f32bd01ff$exports, "dot", function () { return $ee491d8f32bd01ff$export$94132a0e348806d4; });
$parcel$export($ee491d8f32bd01ff$exports, "scale", function () { return $ee491d8f32bd01ff$export$dcdf75081b88279d; });
$parcel$export($ee491d8f32bd01ff$exports, "normalize", function () { return $ee491d8f32bd01ff$export$a3295358bff77e; });
$parcel$export($ee491d8f32bd01ff$exports, "distance", function () { return $ee491d8f32bd01ff$export$9f17032d917177de; });
$parcel$export($ee491d8f32bd01ff$exports, "dist", function () { return $ee491d8f32bd01ff$export$6c4a311cc157c764; });
$parcel$export($ee491d8f32bd01ff$exports, "distanceSquare", function () { return $ee491d8f32bd01ff$export$137c0a69d1ff4a79; });
$parcel$export($ee491d8f32bd01ff$exports, "distSquare", function () { return $ee491d8f32bd01ff$export$c68db45a034c13b0; });
$parcel$export($ee491d8f32bd01ff$exports, "negate", function () { return $ee491d8f32bd01ff$export$aef51622e549b8b0; });
$parcel$export($ee491d8f32bd01ff$exports, "lerp", function () { return $ee491d8f32bd01ff$export$3a89f8d6f6bf6c9f; });
$parcel$export($ee491d8f32bd01ff$exports, "applyTransform", function () { return $ee491d8f32bd01ff$export$9f9dcb98c894b623; });
$parcel$export($ee491d8f32bd01ff$exports, "min", function () { return $ee491d8f32bd01ff$export$96ec731ed4dcb222; });
$parcel$export($ee491d8f32bd01ff$exports, "max", function () { return $ee491d8f32bd01ff$export$8960430cfd85939f; });
function $ee491d8f32bd01ff$export$185802fd694ee1f5(x, y) {
    if (x == null) x = 0;
    if (y == null) y = 0;
    return [
        x,
        y
    ];
}
function $ee491d8f32bd01ff$export$784d13d8ee351f07(out, v) {
    out[0] = v[0];
    out[1] = v[1];
    return out;
}
function $ee491d8f32bd01ff$export$9cd59f9826255e47(v) {
    return [
        v[0],
        v[1]
    ];
}
function $ee491d8f32bd01ff$export$adaa4cf7ef1b65be(out, a, b) {
    out[0] = a;
    out[1] = b;
    return out;
}
function $ee491d8f32bd01ff$export$e16d8520af44a096(out, v1, v2) {
    out[0] = v1[0] + v2[0];
    out[1] = v1[1] + v2[1];
    return out;
}
function $ee491d8f32bd01ff$export$19cedf1da84ba854(out, v1, v2, a) {
    out[0] = v1[0] + v2[0] * a;
    out[1] = v1[1] + v2[1] * a;
    return out;
}
function $ee491d8f32bd01ff$export$f93b5905241a7cca(out, v1, v2) {
    out[0] = v1[0] - v2[0];
    out[1] = v1[1] - v2[1];
    return out;
}
function $ee491d8f32bd01ff$export$fc1400facf92c78(v) {
    return Math.sqrt($ee491d8f32bd01ff$export$48e33bc611e4c25a(v));
}
var $ee491d8f32bd01ff$export$f24224f1c91d8156 = $ee491d8f32bd01ff$export$fc1400facf92c78;
function $ee491d8f32bd01ff$export$48e33bc611e4c25a(v) {
    return v[0] * v[0] + v[1] * v[1];
}
var $ee491d8f32bd01ff$export$2f106540dd9a5136 = $ee491d8f32bd01ff$export$48e33bc611e4c25a;
function $ee491d8f32bd01ff$export$6e3a27864ab166fe(out, v1, v2) {
    out[0] = v1[0] * v2[0];
    out[1] = v1[1] * v2[1];
    return out;
}
function $ee491d8f32bd01ff$export$159d9494db57879b(out, v1, v2) {
    out[0] = v1[0] / v2[0];
    out[1] = v1[1] / v2[1];
    return out;
}
function $ee491d8f32bd01ff$export$94132a0e348806d4(v1, v2) {
    return v1[0] * v2[0] + v1[1] * v2[1];
}
function $ee491d8f32bd01ff$export$dcdf75081b88279d(out, v, s) {
    out[0] = v[0] * s;
    out[1] = v[1] * s;
    return out;
}
function $ee491d8f32bd01ff$export$a3295358bff77e(out, v) {
    var d = $ee491d8f32bd01ff$export$fc1400facf92c78(v);
    if (d === 0) {
        out[0] = 0;
        out[1] = 0;
    } else {
        out[0] = v[0] / d;
        out[1] = v[1] / d;
    }
    return out;
}
function $ee491d8f32bd01ff$export$9f17032d917177de(v1, v2) {
    return Math.sqrt((v1[0] - v2[0]) * (v1[0] - v2[0]) + (v1[1] - v2[1]) * (v1[1] - v2[1]));
}
var $ee491d8f32bd01ff$export$6c4a311cc157c764 = $ee491d8f32bd01ff$export$9f17032d917177de;
function $ee491d8f32bd01ff$export$137c0a69d1ff4a79(v1, v2) {
    return (v1[0] - v2[0]) * (v1[0] - v2[0]) + (v1[1] - v2[1]) * (v1[1] - v2[1]);
}
var $ee491d8f32bd01ff$export$c68db45a034c13b0 = $ee491d8f32bd01ff$export$137c0a69d1ff4a79;
function $ee491d8f32bd01ff$export$aef51622e549b8b0(out, v) {
    out[0] = -v[0];
    out[1] = -v[1];
    return out;
}
function $ee491d8f32bd01ff$export$3a89f8d6f6bf6c9f(out, v1, v2, t) {
    out[0] = v1[0] + t * (v2[0] - v1[0]);
    out[1] = v1[1] + t * (v2[1] - v1[1]);
    return out;
}
function $ee491d8f32bd01ff$export$9f9dcb98c894b623(out, v, m) {
    var x = v[0];
    var y = v[1];
    out[0] = m[0] * x + m[2] * y + m[4];
    out[1] = m[1] * x + m[3] * y + m[5];
    return out;
}
function $ee491d8f32bd01ff$export$96ec731ed4dcb222(out, v1, v2) {
    out[0] = Math.min(v1[0], v2[0]);
    out[1] = Math.min(v1[1], v2[1]);
    return out;
}
function $ee491d8f32bd01ff$export$8960430cfd85939f(out, v1, v2) {
    out[0] = Math.max(v1[0], v2[0]);
    out[1] = Math.max(v1[1], v2[1]);
    return out;
}


var $a5222817c3685715$var$Param = function() {
    function Param(target, e) {
        this.target = target;
        this.topTarget = e && e.topTarget;
    }
    return Param;
}();
var $a5222817c3685715$var$Draggable = function() {
    function Draggable(handler) {
        this.handler = handler;
        handler.on("mousedown", this._dragStart, this);
        handler.on("mousemove", this._drag, this);
        handler.on("mouseup", this._dragEnd, this);
    }
    Draggable.prototype._dragStart = function(e) {
        var draggingTarget = e.target;
        while(draggingTarget && !draggingTarget.draggable)draggingTarget = draggingTarget.parent || draggingTarget.__hostTarget;
        if (draggingTarget) {
            this._draggingTarget = draggingTarget;
            draggingTarget.dragging = true;
            this._x = e.offsetX;
            this._y = e.offsetY;
            this.handler.dispatchToElement(new $a5222817c3685715$var$Param(draggingTarget, e), "dragstart", e.event);
        }
    };
    Draggable.prototype._drag = function(e) {
        var draggingTarget = this._draggingTarget;
        if (draggingTarget) {
            var x = e.offsetX;
            var y = e.offsetY;
            var dx = x - this._x;
            var dy = y - this._y;
            this._x = x;
            this._y = y;
            draggingTarget.drift(dx, dy, e);
            this.handler.dispatchToElement(new $a5222817c3685715$var$Param(draggingTarget, e), "drag", e.event);
            var dropTarget = this.handler.findHover(x, y, draggingTarget).target;
            var lastDropTarget = this._dropTarget;
            this._dropTarget = dropTarget;
            if (draggingTarget !== dropTarget) {
                if (lastDropTarget && dropTarget !== lastDropTarget) this.handler.dispatchToElement(new $a5222817c3685715$var$Param(lastDropTarget, e), "dragleave", e.event);
                if (dropTarget && dropTarget !== lastDropTarget) this.handler.dispatchToElement(new $a5222817c3685715$var$Param(dropTarget, e), "dragenter", e.event);
            }
        }
    };
    Draggable.prototype._dragEnd = function(e) {
        var draggingTarget = this._draggingTarget;
        if (draggingTarget) draggingTarget.dragging = false;
        this.handler.dispatchToElement(new $a5222817c3685715$var$Param(draggingTarget, e), "dragend", e.event);
        if (this._dropTarget) this.handler.dispatchToElement(new $a5222817c3685715$var$Param(this._dropTarget, e), "drop", e.event);
        this._draggingTarget = null;
        this._dropTarget = null;
    };
    return Draggable;
}();
var $a5222817c3685715$export$2e2bcd8739ae039 = $a5222817c3685715$var$Draggable;


var $131b7833cdf735df$var$Eventful = function() {
    function Eventful(eventProcessors) {
        if (eventProcessors) this._$eventProcessor = eventProcessors;
    }
    Eventful.prototype.on = function(event, query, handler, context) {
        if (!this._$handlers) this._$handlers = {};
        var _h = this._$handlers;
        if (typeof query === "function") {
            context = handler;
            handler = query;
            query = null;
        }
        if (!handler || !event) return this;
        var eventProcessor = this._$eventProcessor;
        if (query != null && eventProcessor && eventProcessor.normalizeQuery) query = eventProcessor.normalizeQuery(query);
        if (!_h[event]) _h[event] = [];
        for(var i = 0; i < _h[event].length; i++){
            if (_h[event][i].h === handler) return this;
        }
        var wrap = {
            h: handler,
            query: query,
            ctx: context || this,
            callAtLast: handler.zrEventfulCallAtLast
        };
        var lastIndex = _h[event].length - 1;
        var lastWrap = _h[event][lastIndex];
        lastWrap && lastWrap.callAtLast ? _h[event].splice(lastIndex, 0, wrap) : _h[event].push(wrap);
        return this;
    };
    Eventful.prototype.isSilent = function(eventName) {
        var _h = this._$handlers;
        return !_h || !_h[eventName] || !_h[eventName].length;
    };
    Eventful.prototype.off = function(eventType, handler) {
        var _h = this._$handlers;
        if (!_h) return this;
        if (!eventType) {
            this._$handlers = {};
            return this;
        }
        if (handler) {
            if (_h[eventType]) {
                var newList = [];
                for(var i = 0, l = _h[eventType].length; i < l; i++)if (_h[eventType][i].h !== handler) newList.push(_h[eventType][i]);
                _h[eventType] = newList;
            }
            if (_h[eventType] && _h[eventType].length === 0) delete _h[eventType];
        } else delete _h[eventType];
        return this;
    };
    Eventful.prototype.trigger = function(eventType) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        if (!this._$handlers) return this;
        var _h = this._$handlers[eventType];
        var eventProcessor = this._$eventProcessor;
        if (_h) {
            var argLen = args.length;
            var len = _h.length;
            for(var i = 0; i < len; i++){
                var hItem = _h[i];
                if (eventProcessor && eventProcessor.filter && hItem.query != null && !eventProcessor.filter(eventType, hItem.query)) continue;
                switch(argLen){
                    case 0:
                        hItem.h.call(hItem.ctx);
                        break;
                    case 1:
                        hItem.h.call(hItem.ctx, args[0]);
                        break;
                    case 2:
                        hItem.h.call(hItem.ctx, args[0], args[1]);
                        break;
                    default:
                        hItem.h.apply(hItem.ctx, args);
                        break;
                }
            }
        }
        eventProcessor && eventProcessor.afterTrigger && eventProcessor.afterTrigger(eventType);
        return this;
    };
    Eventful.prototype.triggerWithContext = function(type) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        if (!this._$handlers) return this;
        var _h = this._$handlers[type];
        var eventProcessor = this._$eventProcessor;
        if (_h) {
            var argLen = args.length;
            var ctx = args[argLen - 1];
            var len = _h.length;
            for(var i = 0; i < len; i++){
                var hItem = _h[i];
                if (eventProcessor && eventProcessor.filter && hItem.query != null && !eventProcessor.filter(type, hItem.query)) continue;
                switch(argLen){
                    case 0:
                        hItem.h.call(ctx);
                        break;
                    case 1:
                        hItem.h.call(ctx, args[0]);
                        break;
                    case 2:
                        hItem.h.call(ctx, args[0], args[1]);
                        break;
                    default:
                        hItem.h.apply(ctx, args.slice(1, argLen - 1));
                        break;
                }
            }
        }
        eventProcessor && eventProcessor.afterTrigger && eventProcessor.afterTrigger(type);
        return this;
    };
    return Eventful;
}();
var $131b7833cdf735df$export$2e2bcd8739ae039 = $131b7833cdf735df$var$Eventful;





var $3d2079d81058abb5$var$LN2 = Math.log(2);
function $3d2079d81058abb5$var$determinant(rows, rank, rowStart, rowMask, colMask, detCache) {
    var cacheKey = rowMask + "-" + colMask;
    var fullRank = rows.length;
    if (detCache.hasOwnProperty(cacheKey)) return detCache[cacheKey];
    if (rank === 1) {
        var colStart = Math.round(Math.log((1 << fullRank) - 1 & ~colMask) / $3d2079d81058abb5$var$LN2);
        return rows[rowStart][colStart];
    }
    var subRowMask = rowMask | 1 << rowStart;
    var subRowStart = rowStart + 1;
    while(rowMask & 1 << subRowStart)subRowStart++;
    var sum = 0;
    for(var j = 0, colLocalIdx = 0; j < fullRank; j++){
        var colTag = 1 << j;
        if (!(colTag & colMask)) {
            sum += (colLocalIdx % 2 ? -1 : 1) * rows[rowStart][j] * $3d2079d81058abb5$var$determinant(rows, rank - 1, subRowStart, subRowMask, colMask | colTag, detCache);
            colLocalIdx++;
        }
    }
    detCache[cacheKey] = sum;
    return sum;
}
function $3d2079d81058abb5$export$fbdb2748a8171a7e(src, dest) {
    var mA = [
        [
            src[0],
            src[1],
            1,
            0,
            0,
            0,
            -dest[0] * src[0],
            -dest[0] * src[1]
        ],
        [
            0,
            0,
            0,
            src[0],
            src[1],
            1,
            -dest[1] * src[0],
            -dest[1] * src[1]
        ],
        [
            src[2],
            src[3],
            1,
            0,
            0,
            0,
            -dest[2] * src[2],
            -dest[2] * src[3]
        ],
        [
            0,
            0,
            0,
            src[2],
            src[3],
            1,
            -dest[3] * src[2],
            -dest[3] * src[3]
        ],
        [
            src[4],
            src[5],
            1,
            0,
            0,
            0,
            -dest[4] * src[4],
            -dest[4] * src[5]
        ],
        [
            0,
            0,
            0,
            src[4],
            src[5],
            1,
            -dest[5] * src[4],
            -dest[5] * src[5]
        ],
        [
            src[6],
            src[7],
            1,
            0,
            0,
            0,
            -dest[6] * src[6],
            -dest[6] * src[7]
        ],
        [
            0,
            0,
            0,
            src[6],
            src[7],
            1,
            -dest[7] * src[6],
            -dest[7] * src[7]
        ]
    ];
    var detCache = {};
    var det = $3d2079d81058abb5$var$determinant(mA, 8, 0, 0, 0, detCache);
    if (det === 0) return;
    var vh = [];
    for(var i = 0; i < 8; i++)for(var j = 0; j < 8; j++){
        vh[j] == null && (vh[j] = 0);
        vh[j] += ((i + j) % 2 ? -1 : 1) * $3d2079d81058abb5$var$determinant(mA, 7, i === 0 ? 1 : 0, 1 << i, 1 << j, detCache) / det * dest[i];
    }
    return function(out, srcPointX, srcPointY) {
        var pk = srcPointX * vh[6] + srcPointY * vh[7] + 1;
        out[0] = (srcPointX * vh[0] + srcPointY * vh[1] + vh[2]) / pk;
        out[1] = (srcPointX * vh[3] + srcPointY * vh[4] + vh[5]) / pk;
    };
}



var $e2318d49eb46f886$var$EVENT_SAVED_PROP = "___zrEVENTSAVED";
var $e2318d49eb46f886$var$_calcOut = [];
function $e2318d49eb46f886$export$8c5c02e118307e20(out, elFrom, elTarget, inX, inY) {
    return $e2318d49eb46f886$export$1219648acc517df4($e2318d49eb46f886$var$_calcOut, elFrom, inX, inY, true) && $e2318d49eb46f886$export$1219648acc517df4(out, elTarget, $e2318d49eb46f886$var$_calcOut[0], $e2318d49eb46f886$var$_calcOut[1]);
}
function $e2318d49eb46f886$export$a29dbe4b7d3cd586(elFrom, elTarget) {
    elFrom && dealClear(elFrom);
    elTarget && dealClear(elTarget);
    function dealClear(el) {
        var saved = el[$e2318d49eb46f886$var$EVENT_SAVED_PROP];
        if (saved) {
            saved.clearMarkers && saved.clearMarkers();
            delete el[$e2318d49eb46f886$var$EVENT_SAVED_PROP];
        }
    }
}
function $e2318d49eb46f886$export$1219648acc517df4(out, el, inX, inY, inverse) {
    if (el.getBoundingClientRect && (0, $a84633bb9c74d89c$export$2e2bcd8739ae039).domSupported && !$e2318d49eb46f886$export$1b92e4fe606eff6d(el)) {
        var saved = el[$e2318d49eb46f886$var$EVENT_SAVED_PROP] || (el[$e2318d49eb46f886$var$EVENT_SAVED_PROP] = {});
        var markers = $e2318d49eb46f886$var$prepareCoordMarkers(el, saved);
        var transformer = $e2318d49eb46f886$var$preparePointerTransformer(markers, saved, inverse);
        if (transformer) {
            transformer(out, inX, inY);
            return true;
        }
    }
    return false;
}
function $e2318d49eb46f886$var$prepareCoordMarkers(el, saved) {
    var markers = saved.markers;
    if (markers) return markers;
    markers = saved.markers = [];
    var propLR = [
        "left",
        "right"
    ];
    var propTB = [
        "top",
        "bottom"
    ];
    for(var i = 0; i < 4; i++){
        var marker = document.createElement("div");
        var stl = marker.style;
        var idxLR = i % 2;
        var idxTB = (i >> 1) % 2;
        stl.cssText = [
            "position: absolute",
            "visibility: hidden",
            "padding: 0",
            "margin: 0",
            "border-width: 0",
            "user-select: none",
            "width:0",
            "height:0",
            propLR[idxLR] + ":0",
            propTB[idxTB] + ":0",
            propLR[1 - idxLR] + ":auto",
            propTB[1 - idxTB] + ":auto",
            ""
        ].join("!important;");
        el.appendChild(marker);
        markers.push(marker);
    }
    saved.clearMarkers = function() {
        (0, $43e0a445ed6711da$export$79b2f7037acddd43)(markers, function(marker) {
            marker.parentNode && marker.parentNode.removeChild(marker);
        });
    };
    return markers;
}
function $e2318d49eb46f886$var$preparePointerTransformer(markers, saved, inverse) {
    var transformerName = inverse ? "invTrans" : "trans";
    var transformer = saved[transformerName];
    var oldSrcCoords = saved.srcCoords;
    var srcCoords = [];
    var destCoords = [];
    var oldCoordTheSame = true;
    for(var i = 0; i < 4; i++){
        var rect = markers[i].getBoundingClientRect();
        var ii = 2 * i;
        var x = rect.left;
        var y = rect.top;
        srcCoords.push(x, y);
        oldCoordTheSame = oldCoordTheSame && oldSrcCoords && x === oldSrcCoords[ii] && y === oldSrcCoords[ii + 1];
        destCoords.push(markers[i].offsetLeft, markers[i].offsetTop);
    }
    return oldCoordTheSame && transformer ? transformer : (saved.srcCoords = srcCoords, saved[transformerName] = inverse ? (0, $3d2079d81058abb5$export$fbdb2748a8171a7e)(destCoords, srcCoords) : (0, $3d2079d81058abb5$export$fbdb2748a8171a7e)(srcCoords, destCoords));
}
function $e2318d49eb46f886$export$1b92e4fe606eff6d(el) {
    return el.nodeName.toUpperCase() === "CANVAS";
}
var $e2318d49eb46f886$var$replaceReg = /([&<>"'])/g;
var $e2318d49eb46f886$var$replaceMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
};
function $e2318d49eb46f886$export$f9d6449b9af28dc1(source) {
    return source == null ? "" : (source + "").replace($e2318d49eb46f886$var$replaceReg, function(str, c) {
        return $e2318d49eb46f886$var$replaceMap[c];
    });
}


var $e48a660b5a6fd3cb$var$MOUSE_EVENT_REG = /^(?:mouse|pointer|contextmenu|drag|drop)|click/;
var $e48a660b5a6fd3cb$var$_calcOut = [];
var $e48a660b5a6fd3cb$var$firefoxNotSupportOffsetXY = (0, $a84633bb9c74d89c$export$2e2bcd8739ae039).browser.firefox && +(0, $a84633bb9c74d89c$export$2e2bcd8739ae039).browser.version.split(".")[0] < 39;
function $e48a660b5a6fd3cb$export$7d5fecde839eee88(el, e, out, calculate) {
    out = out || {};
    if (calculate) $e48a660b5a6fd3cb$var$calculateZrXY(el, e, out);
    else if ($e48a660b5a6fd3cb$var$firefoxNotSupportOffsetXY && e.layerX != null && e.layerX !== e.offsetX) {
        out.zrX = e.layerX;
        out.zrY = e.layerY;
    } else if (e.offsetX != null) {
        out.zrX = e.offsetX;
        out.zrY = e.offsetY;
    } else $e48a660b5a6fd3cb$var$calculateZrXY(el, e, out);
    return out;
}
function $e48a660b5a6fd3cb$var$calculateZrXY(el, e, out) {
    if ((0, $a84633bb9c74d89c$export$2e2bcd8739ae039).domSupported && el.getBoundingClientRect) {
        var ex = e.clientX;
        var ey = e.clientY;
        if ((0, $e2318d49eb46f886$export$1b92e4fe606eff6d)(el)) {
            var box = el.getBoundingClientRect();
            out.zrX = ex - box.left;
            out.zrY = ey - box.top;
            return;
        } else if ((0, $e2318d49eb46f886$export$1219648acc517df4)($e48a660b5a6fd3cb$var$_calcOut, el, ex, ey)) {
            out.zrX = $e48a660b5a6fd3cb$var$_calcOut[0];
            out.zrY = $e48a660b5a6fd3cb$var$_calcOut[1];
            return;
        }
    }
    out.zrX = out.zrY = 0;
}
function $e48a660b5a6fd3cb$export$4abe0e945399ac1d(e) {
    return e || window.event;
}
function $e48a660b5a6fd3cb$export$40fadb093aebad71(el, e, calculate) {
    e = $e48a660b5a6fd3cb$export$4abe0e945399ac1d(e);
    if (e.zrX != null) return e;
    var eventType = e.type;
    var isTouch = eventType && eventType.indexOf("touch") >= 0;
    if (!isTouch) {
        $e48a660b5a6fd3cb$export$7d5fecde839eee88(el, e, e, calculate);
        var wheelDelta = $e48a660b5a6fd3cb$var$getWheelDeltaMayPolyfill(e);
        e.zrDelta = wheelDelta ? wheelDelta / 120 : -(e.detail || 0) / 3;
    } else {
        var touch = eventType !== "touchend" ? e.targetTouches[0] : e.changedTouches[0];
        touch && $e48a660b5a6fd3cb$export$7d5fecde839eee88(el, touch, e, calculate);
    }
    var button = e.button;
    if (e.which == null && button !== undefined && $e48a660b5a6fd3cb$var$MOUSE_EVENT_REG.test(e.type)) e.which = button & 1 ? 1 : button & 2 ? 3 : button & 4 ? 2 : 0;
    return e;
}
function $e48a660b5a6fd3cb$var$getWheelDeltaMayPolyfill(e) {
    var rawWheelDelta = e.wheelDelta;
    if (rawWheelDelta) return rawWheelDelta;
    var deltaX = e.deltaX;
    var deltaY = e.deltaY;
    if (deltaX == null || deltaY == null) return rawWheelDelta;
    var delta = deltaY !== 0 ? Math.abs(deltaY) : Math.abs(deltaX);
    var sign = deltaY > 0 ? -1 : deltaY < 0 ? 1 : deltaX > 0 ? -1 : 1;
    return 3 * delta * sign;
}
function $e48a660b5a6fd3cb$export$3f65cefe8380dbea(el, name, handler, opt) {
    el.addEventListener(name, handler, opt);
}
function $e48a660b5a6fd3cb$export$8ff9f68337b520c0(el, name, handler, opt) {
    el.removeEventListener(name, handler, opt);
}
var $e48a660b5a6fd3cb$export$fa6813432f753b0d = function(e) {
    e.preventDefault();
    e.stopPropagation();
    e.cancelBubble = true;
};
function $e48a660b5a6fd3cb$export$b7ae4cded3e71bd2(e) {
    return e.which === 2 || e.which === 3;
}



var $f827c357e1ee5b29$export$f7557d6f27e9503 = function() {
    function GestureMgr() {
        this._track = [];
    }
    GestureMgr.prototype.recognize = function(event, target, root) {
        this._doTrack(event, target, root);
        return this._recognize(event);
    };
    GestureMgr.prototype.clear = function() {
        this._track.length = 0;
        return this;
    };
    GestureMgr.prototype._doTrack = function(event, target, root) {
        var touches = event.touches;
        if (!touches) return;
        var trackItem = {
            points: [],
            touches: [],
            target: target,
            event: event
        };
        for(var i = 0, len = touches.length; i < len; i++){
            var touch = touches[i];
            var pos = $e48a660b5a6fd3cb$export$7d5fecde839eee88(root, touch, {});
            trackItem.points.push([
                pos.zrX,
                pos.zrY
            ]);
            trackItem.touches.push(touch);
        }
        this._track.push(trackItem);
    };
    GestureMgr.prototype._recognize = function(event) {
        for(var eventName in $f827c357e1ee5b29$var$recognizers)if ($f827c357e1ee5b29$var$recognizers.hasOwnProperty(eventName)) {
            var gestureInfo = $f827c357e1ee5b29$var$recognizers[eventName](this._track, event);
            if (gestureInfo) return gestureInfo;
        }
    };
    return GestureMgr;
}();
function $f827c357e1ee5b29$var$dist(pointPair) {
    var dx = pointPair[1][0] - pointPair[0][0];
    var dy = pointPair[1][1] - pointPair[0][1];
    return Math.sqrt(dx * dx + dy * dy);
}
function $f827c357e1ee5b29$var$center(pointPair) {
    return [
        (pointPair[0][0] + pointPair[1][0]) / 2,
        (pointPair[0][1] + pointPair[1][1]) / 2
    ];
}
var $f827c357e1ee5b29$var$recognizers = {
    pinch: function(tracks, event) {
        var trackLen = tracks.length;
        if (!trackLen) return;
        var pinchEnd = (tracks[trackLen - 1] || {}).points;
        var pinchPre = (tracks[trackLen - 2] || {}).points || pinchEnd;
        if (pinchPre && pinchPre.length > 1 && pinchEnd && pinchEnd.length > 1) {
            var pinchScale = $f827c357e1ee5b29$var$dist(pinchEnd) / $f827c357e1ee5b29$var$dist(pinchPre);
            !isFinite(pinchScale) && (pinchScale = 1);
            event.pinchScale = pinchScale;
            var pinchCenter = $f827c357e1ee5b29$var$center(pinchEnd);
            event.pinchX = pinchCenter[0];
            event.pinchY = pinchCenter[1];
            return {
                type: "pinch",
                target: tracks[0].target,
                event: event
            };
        }
    }
};


var $87ac8de5537d9a34$exports = {};

$parcel$export($87ac8de5537d9a34$exports, "create", function () { return $87ac8de5537d9a34$export$185802fd694ee1f5; });
$parcel$export($87ac8de5537d9a34$exports, "identity", function () { return $87ac8de5537d9a34$export$f0954fd7d5368655; });
$parcel$export($87ac8de5537d9a34$exports, "copy", function () { return $87ac8de5537d9a34$export$784d13d8ee351f07; });
$parcel$export($87ac8de5537d9a34$exports, "mul", function () { return $87ac8de5537d9a34$export$6e3a27864ab166fe; });
$parcel$export($87ac8de5537d9a34$exports, "translate", function () { return $87ac8de5537d9a34$export$d73ee8ef04f5226a; });
$parcel$export($87ac8de5537d9a34$exports, "rotate", function () { return $87ac8de5537d9a34$export$bb628a54ab399bc9; });
$parcel$export($87ac8de5537d9a34$exports, "scale", function () { return $87ac8de5537d9a34$export$dcdf75081b88279d; });
$parcel$export($87ac8de5537d9a34$exports, "invert", function () { return $87ac8de5537d9a34$export$6897c284b6f9f4dc; });
$parcel$export($87ac8de5537d9a34$exports, "clone", function () { return $87ac8de5537d9a34$export$9cd59f9826255e47; });
function $87ac8de5537d9a34$export$185802fd694ee1f5() {
    return [
        1,
        0,
        0,
        1,
        0,
        0
    ];
}
function $87ac8de5537d9a34$export$f0954fd7d5368655(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 1;
    out[4] = 0;
    out[5] = 0;
    return out;
}
function $87ac8de5537d9a34$export$784d13d8ee351f07(out, m) {
    out[0] = m[0];
    out[1] = m[1];
    out[2] = m[2];
    out[3] = m[3];
    out[4] = m[4];
    out[5] = m[5];
    return out;
}
function $87ac8de5537d9a34$export$6e3a27864ab166fe(out, m1, m2) {
    var out0 = m1[0] * m2[0] + m1[2] * m2[1];
    var out1 = m1[1] * m2[0] + m1[3] * m2[1];
    var out2 = m1[0] * m2[2] + m1[2] * m2[3];
    var out3 = m1[1] * m2[2] + m1[3] * m2[3];
    var out4 = m1[0] * m2[4] + m1[2] * m2[5] + m1[4];
    var out5 = m1[1] * m2[4] + m1[3] * m2[5] + m1[5];
    out[0] = out0;
    out[1] = out1;
    out[2] = out2;
    out[3] = out3;
    out[4] = out4;
    out[5] = out5;
    return out;
}
function $87ac8de5537d9a34$export$d73ee8ef04f5226a(out, a, v) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4] + v[0];
    out[5] = a[5] + v[1];
    return out;
}
function $87ac8de5537d9a34$export$bb628a54ab399bc9(out, a, rad, pivot) {
    if (pivot === void 0) pivot = [
        0,
        0
    ];
    var aa = a[0];
    var ac = a[2];
    var atx = a[4];
    var ab = a[1];
    var ad = a[3];
    var aty = a[5];
    var st = Math.sin(rad);
    var ct = Math.cos(rad);
    out[0] = aa * ct + ab * st;
    out[1] = -aa * st + ab * ct;
    out[2] = ac * ct + ad * st;
    out[3] = -ac * st + ct * ad;
    out[4] = ct * (atx - pivot[0]) + st * (aty - pivot[1]) + pivot[0];
    out[5] = ct * (aty - pivot[1]) - st * (atx - pivot[0]) + pivot[1];
    return out;
}
function $87ac8de5537d9a34$export$dcdf75081b88279d(out, a, v) {
    var vx = v[0];
    var vy = v[1];
    out[0] = a[0] * vx;
    out[1] = a[1] * vy;
    out[2] = a[2] * vx;
    out[3] = a[3] * vy;
    out[4] = a[4] * vx;
    out[5] = a[5] * vy;
    return out;
}
function $87ac8de5537d9a34$export$6897c284b6f9f4dc(out, a) {
    var aa = a[0];
    var ac = a[2];
    var atx = a[4];
    var ab = a[1];
    var ad = a[3];
    var aty = a[5];
    var det = aa * ad - ab * ac;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = ad * det;
    out[1] = -ab * det;
    out[2] = -ac * det;
    out[3] = aa * det;
    out[4] = (ac * aty - ad * atx) * det;
    out[5] = (ab * atx - aa * aty) * det;
    return out;
}
function $87ac8de5537d9a34$export$9cd59f9826255e47(a) {
    var b = $87ac8de5537d9a34$export$185802fd694ee1f5();
    $87ac8de5537d9a34$export$784d13d8ee351f07(b, a);
    return b;
}



var $1de2ad08c108b7c2$var$Point = function() {
    function Point(x, y) {
        this.x = x || 0;
        this.y = y || 0;
    }
    Point.prototype.copy = function(other) {
        this.x = other.x;
        this.y = other.y;
        return this;
    };
    Point.prototype.clone = function() {
        return new Point(this.x, this.y);
    };
    Point.prototype.set = function(x, y) {
        this.x = x;
        this.y = y;
        return this;
    };
    Point.prototype.equal = function(other) {
        return other.x === this.x && other.y === this.y;
    };
    Point.prototype.add = function(other) {
        this.x += other.x;
        this.y += other.y;
        return this;
    };
    Point.prototype.scale = function(scalar) {
        this.x *= scalar;
        this.y *= scalar;
    };
    Point.prototype.scaleAndAdd = function(other, scalar) {
        this.x += other.x * scalar;
        this.y += other.y * scalar;
    };
    Point.prototype.sub = function(other) {
        this.x -= other.x;
        this.y -= other.y;
        return this;
    };
    Point.prototype.dot = function(other) {
        return this.x * other.x + this.y * other.y;
    };
    Point.prototype.len = function() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    };
    Point.prototype.lenSquare = function() {
        return this.x * this.x + this.y * this.y;
    };
    Point.prototype.normalize = function() {
        var len = this.len();
        this.x /= len;
        this.y /= len;
        return this;
    };
    Point.prototype.distance = function(other) {
        var dx = this.x - other.x;
        var dy = this.y - other.y;
        return Math.sqrt(dx * dx + dy * dy);
    };
    Point.prototype.distanceSquare = function(other) {
        var dx = this.x - other.x;
        var dy = this.y - other.y;
        return dx * dx + dy * dy;
    };
    Point.prototype.negate = function() {
        this.x = -this.x;
        this.y = -this.y;
        return this;
    };
    Point.prototype.transform = function(m) {
        if (!m) return;
        var x = this.x;
        var y = this.y;
        this.x = m[0] * x + m[2] * y + m[4];
        this.y = m[1] * x + m[3] * y + m[5];
        return this;
    };
    Point.prototype.toArray = function(out) {
        out[0] = this.x;
        out[1] = this.y;
        return out;
    };
    Point.prototype.fromArray = function(input) {
        this.x = input[0];
        this.y = input[1];
    };
    Point.set = function(p, x, y) {
        p.x = x;
        p.y = y;
    };
    Point.copy = function(p, p2) {
        p.x = p2.x;
        p.y = p2.y;
    };
    Point.len = function(p) {
        return Math.sqrt(p.x * p.x + p.y * p.y);
    };
    Point.lenSquare = function(p) {
        return p.x * p.x + p.y * p.y;
    };
    Point.dot = function(p0, p1) {
        return p0.x * p1.x + p0.y * p1.y;
    };
    Point.add = function(out, p0, p1) {
        out.x = p0.x + p1.x;
        out.y = p0.y + p1.y;
    };
    Point.sub = function(out, p0, p1) {
        out.x = p0.x - p1.x;
        out.y = p0.y - p1.y;
    };
    Point.scale = function(out, p0, scalar) {
        out.x = p0.x * scalar;
        out.y = p0.y * scalar;
    };
    Point.scaleAndAdd = function(out, p0, p1, scalar) {
        out.x = p0.x + p1.x * scalar;
        out.y = p0.y + p1.y * scalar;
    };
    Point.lerp = function(out, p0, p1, t) {
        var onet = 1 - t;
        out.x = onet * p0.x + t * p1.x;
        out.y = onet * p0.y + t * p1.y;
    };
    return Point;
}();
var $1de2ad08c108b7c2$export$2e2bcd8739ae039 = $1de2ad08c108b7c2$var$Point;


var $c437f598d9c9ee16$var$mathMin = Math.min;
var $c437f598d9c9ee16$var$mathMax = Math.max;
var $c437f598d9c9ee16$var$mathAbs = Math.abs;
var $c437f598d9c9ee16$var$XY = [
    "x",
    "y"
];
var $c437f598d9c9ee16$var$WH = [
    "width",
    "height"
];
var $c437f598d9c9ee16$var$lt = new (0, $1de2ad08c108b7c2$export$2e2bcd8739ae039)();
var $c437f598d9c9ee16$var$rb = new (0, $1de2ad08c108b7c2$export$2e2bcd8739ae039)();
var $c437f598d9c9ee16$var$lb = new (0, $1de2ad08c108b7c2$export$2e2bcd8739ae039)();
var $c437f598d9c9ee16$var$rt = new (0, $1de2ad08c108b7c2$export$2e2bcd8739ae039)();
var $c437f598d9c9ee16$var$_intersectCtx = $c437f598d9c9ee16$export$a0be2bdbd2369e0e();
var $c437f598d9c9ee16$var$_minTv = $c437f598d9c9ee16$var$_intersectCtx.minTv;
var $c437f598d9c9ee16$var$_maxTv = $c437f598d9c9ee16$var$_intersectCtx.maxTv;
var $c437f598d9c9ee16$var$_lenMinMax = [
    0,
    0
];
var $c437f598d9c9ee16$var$BoundingRect = function() {
    function BoundingRect(x, y, width, height) {
        $c437f598d9c9ee16$export$6bf07b1ffc18797f(this, x, y, width, height);
    }
    BoundingRect.set = function(target, x, y, width, height) {
        if (width < 0) {
            x = x + width;
            width = -width;
        }
        if (height < 0) {
            y = y + height;
            height = -height;
        }
        target.x = x;
        target.y = y;
        target.width = width;
        target.height = height;
        return target;
    };
    BoundingRect.prototype.union = function(other) {
        var x = $c437f598d9c9ee16$var$mathMin(other.x, this.x);
        var y = $c437f598d9c9ee16$var$mathMin(other.y, this.y);
        if (isFinite(this.x) && isFinite(this.width)) this.width = $c437f598d9c9ee16$var$mathMax(other.x + other.width, this.x + this.width) - x;
        else this.width = other.width;
        if (isFinite(this.y) && isFinite(this.height)) this.height = $c437f598d9c9ee16$var$mathMax(other.y + other.height, this.y + this.height) - y;
        else this.height = other.height;
        this.x = x;
        this.y = y;
    };
    BoundingRect.prototype.applyTransform = function(m) {
        BoundingRect.applyTransform(this, this, m);
    };
    BoundingRect.prototype.calculateTransform = function(b) {
        return $c437f598d9c9ee16$export$92d3eaad4f1a1f35($87ac8de5537d9a34$export$185802fd694ee1f5(), this, b);
    };
    BoundingRect.prototype.intersect = function(b, mtv, opt) {
        return BoundingRect.intersect(this, b, mtv, opt);
    };
    BoundingRect.intersect = function(a, b, mtv, opt) {
        if (mtv) (0, $1de2ad08c108b7c2$export$2e2bcd8739ae039).set(mtv, 0, 0);
        var outIntersectRect = opt && opt.outIntersectRect || null;
        var clamp = opt && opt.clamp;
        if (outIntersectRect) outIntersectRect.x = outIntersectRect.y = outIntersectRect.width = outIntersectRect.height = NaN;
        if (!a || !b) return false;
        if (!(a instanceof BoundingRect)) a = $c437f598d9c9ee16$export$6bf07b1ffc18797f($c437f598d9c9ee16$var$_tmpIntersectA, a.x, a.y, a.width, a.height);
        if (!(b instanceof BoundingRect)) b = $c437f598d9c9ee16$export$6bf07b1ffc18797f($c437f598d9c9ee16$var$_tmpIntersectB, b.x, b.y, b.width, b.height);
        var useMTV = !!mtv;
        $c437f598d9c9ee16$var$_intersectCtx.reset(opt, useMTV);
        var touchThreshold = $c437f598d9c9ee16$var$_intersectCtx.touchThreshold;
        var ax0 = a.x + touchThreshold;
        var ax1 = a.x + a.width - touchThreshold;
        var ay0 = a.y + touchThreshold;
        var ay1 = a.y + a.height - touchThreshold;
        var bx0 = b.x + touchThreshold;
        var bx1 = b.x + b.width - touchThreshold;
        var by0 = b.y + touchThreshold;
        var by1 = b.y + b.height - touchThreshold;
        if (ax0 > ax1 || ay0 > ay1 || bx0 > bx1 || by0 > by1) return false;
        var overlap = !(ax1 < bx0 || bx1 < ax0 || ay1 < by0 || by1 < ay0);
        if (useMTV || outIntersectRect) {
            $c437f598d9c9ee16$var$_lenMinMax[0] = Infinity;
            $c437f598d9c9ee16$var$_lenMinMax[1] = 0;
            $c437f598d9c9ee16$var$intersectOneDim(ax0, ax1, bx0, bx1, 0, useMTV, outIntersectRect, clamp);
            $c437f598d9c9ee16$var$intersectOneDim(ay0, ay1, by0, by1, 1, useMTV, outIntersectRect, clamp);
            if (useMTV) (0, $1de2ad08c108b7c2$export$2e2bcd8739ae039).copy(mtv, overlap ? $c437f598d9c9ee16$var$_intersectCtx.useDir ? $c437f598d9c9ee16$var$_intersectCtx.dirMinTv : $c437f598d9c9ee16$var$_minTv : $c437f598d9c9ee16$var$_maxTv);
        }
        return overlap;
    };
    BoundingRect.contain = function(rect, x, y) {
        return x >= rect.x && x <= rect.x + rect.width && y >= rect.y && y <= rect.y + rect.height;
    };
    BoundingRect.prototype.contain = function(x, y) {
        return BoundingRect.contain(this, x, y);
    };
    BoundingRect.prototype.clone = function() {
        return new BoundingRect(this.x, this.y, this.width, this.height);
    };
    BoundingRect.prototype.copy = function(other) {
        $c437f598d9c9ee16$export$241114a7b05054e(this, other);
    };
    BoundingRect.prototype.plain = function() {
        return {
            x: this.x,
            y: this.y,
            width: this.width,
            height: this.height
        };
    };
    BoundingRect.prototype.isFinite = function() {
        return isFinite(this.x) && isFinite(this.y) && isFinite(this.width) && isFinite(this.height);
    };
    BoundingRect.prototype.isZero = function() {
        return this.width === 0 || this.height === 0;
    };
    BoundingRect.create = function(rect) {
        return new BoundingRect(rect ? rect.x : 0, rect ? rect.y : 0, rect ? rect.width : 0, rect ? rect.height : 0);
    };
    BoundingRect.copy = function(target, source) {
        target.x = source.x;
        target.y = source.y;
        target.width = source.width;
        target.height = source.height;
        return target;
    };
    BoundingRect.applyTransform = function(target, source, m) {
        if (!m) {
            if (target !== source) $c437f598d9c9ee16$export$241114a7b05054e(target, source);
            return;
        }
        if (m[1] < 1e-5 && m[1] > -0.00001 && m[2] < 1e-5 && m[2] > -0.00001) {
            var sx = m[0];
            var sy = m[3];
            var tx = m[4];
            var ty = m[5];
            target.x = source.x * sx + tx;
            target.y = source.y * sy + ty;
            target.width = source.width * sx;
            target.height = source.height * sy;
            if (target.width < 0) {
                target.x += target.width;
                target.width = -target.width;
            }
            if (target.height < 0) {
                target.y += target.height;
                target.height = -target.height;
            }
            return;
        }
        $c437f598d9c9ee16$var$lt.x = $c437f598d9c9ee16$var$lb.x = source.x;
        $c437f598d9c9ee16$var$lt.y = $c437f598d9c9ee16$var$rt.y = source.y;
        $c437f598d9c9ee16$var$rb.x = $c437f598d9c9ee16$var$rt.x = source.x + source.width;
        $c437f598d9c9ee16$var$rb.y = $c437f598d9c9ee16$var$lb.y = source.y + source.height;
        $c437f598d9c9ee16$var$lt.transform(m);
        $c437f598d9c9ee16$var$rt.transform(m);
        $c437f598d9c9ee16$var$rb.transform(m);
        $c437f598d9c9ee16$var$lb.transform(m);
        target.x = $c437f598d9c9ee16$var$mathMin($c437f598d9c9ee16$var$lt.x, $c437f598d9c9ee16$var$rb.x, $c437f598d9c9ee16$var$lb.x, $c437f598d9c9ee16$var$rt.x);
        target.y = $c437f598d9c9ee16$var$mathMin($c437f598d9c9ee16$var$lt.y, $c437f598d9c9ee16$var$rb.y, $c437f598d9c9ee16$var$lb.y, $c437f598d9c9ee16$var$rt.y);
        var maxX = $c437f598d9c9ee16$var$mathMax($c437f598d9c9ee16$var$lt.x, $c437f598d9c9ee16$var$rb.x, $c437f598d9c9ee16$var$lb.x, $c437f598d9c9ee16$var$rt.x);
        var maxY = $c437f598d9c9ee16$var$mathMax($c437f598d9c9ee16$var$lt.y, $c437f598d9c9ee16$var$rb.y, $c437f598d9c9ee16$var$lb.y, $c437f598d9c9ee16$var$rt.y);
        target.width = maxX - target.x;
        target.height = maxY - target.y;
    };
    BoundingRect.calculateTransform = function(out, a, b) {
        var sx = b.width / a.width;
        var sy = b.height / a.height;
        out = $87ac8de5537d9a34$export$f0954fd7d5368655(out || []);
        $87ac8de5537d9a34$export$d73ee8ef04f5226a(out, out, $ee491d8f32bd01ff$export$adaa4cf7ef1b65be($c437f598d9c9ee16$var$_tmpCalcTrans, -a.x, -a.y));
        $87ac8de5537d9a34$export$dcdf75081b88279d(out, out, $ee491d8f32bd01ff$export$adaa4cf7ef1b65be($c437f598d9c9ee16$var$_tmpCalcTrans, sx, sy));
        $87ac8de5537d9a34$export$d73ee8ef04f5226a(out, out, $ee491d8f32bd01ff$export$adaa4cf7ef1b65be($c437f598d9c9ee16$var$_tmpCalcTrans, b.x, b.y));
        return out;
    };
    return BoundingRect;
}();
var $c437f598d9c9ee16$export$cd9abb76972ddc89 = $c437f598d9c9ee16$var$BoundingRect.create;
var $c437f598d9c9ee16$export$6bf07b1ffc18797f = $c437f598d9c9ee16$var$BoundingRect.set;
var $c437f598d9c9ee16$export$241114a7b05054e = $c437f598d9c9ee16$var$BoundingRect.copy;
var $c437f598d9c9ee16$export$92d3eaad4f1a1f35 = $c437f598d9c9ee16$var$BoundingRect.calculateTransform;
var $c437f598d9c9ee16$export$738b31304fd07ad0 = $c437f598d9c9ee16$var$BoundingRect.applyTransform;
var $c437f598d9c9ee16$export$39177876d76f05b = $c437f598d9c9ee16$var$BoundingRect.contain;
var $c437f598d9c9ee16$var$_tmpIntersectA = new $c437f598d9c9ee16$var$BoundingRect(0, 0, 0, 0);
var $c437f598d9c9ee16$var$_tmpIntersectB = new $c437f598d9c9ee16$var$BoundingRect(0, 0, 0, 0);
var $c437f598d9c9ee16$var$_tmpCalcTrans = [];
function $c437f598d9c9ee16$var$intersectOneDim(a0, a1, b0, b1, updateDimIdx, useMTV, outIntersectRect, clamp) {
    var d0 = $c437f598d9c9ee16$var$mathAbs(a1 - b0);
    var d1 = $c437f598d9c9ee16$var$mathAbs(b1 - a0);
    var d01min = $c437f598d9c9ee16$var$mathMin(d0, d1);
    var updateDim = $c437f598d9c9ee16$var$XY[updateDimIdx];
    var zeroDim = $c437f598d9c9ee16$var$XY[1 - updateDimIdx];
    var wh = $c437f598d9c9ee16$var$WH[updateDimIdx];
    if (a1 < b0 || b1 < a0) {
        if (d0 < d1) {
            if (useMTV) $c437f598d9c9ee16$var$_maxTv[updateDim] = -d0;
            if (clamp) {
                outIntersectRect[updateDim] = a1;
                outIntersectRect[wh] = 0;
            }
        } else {
            if (useMTV) $c437f598d9c9ee16$var$_maxTv[updateDim] = d1;
            if (clamp) {
                outIntersectRect[updateDim] = a0;
                outIntersectRect[wh] = 0;
            }
        }
    } else {
        if (outIntersectRect) {
            outIntersectRect[updateDim] = $c437f598d9c9ee16$var$mathMax(a0, b0);
            outIntersectRect[wh] = $c437f598d9c9ee16$var$mathMin(a1, b1) - outIntersectRect[updateDim];
        }
        if (useMTV) {
            if (d01min < $c437f598d9c9ee16$var$_lenMinMax[0] || $c437f598d9c9ee16$var$_intersectCtx.useDir) {
                $c437f598d9c9ee16$var$_lenMinMax[0] = $c437f598d9c9ee16$var$mathMin(d01min, $c437f598d9c9ee16$var$_lenMinMax[0]);
                if (d0 < d1 || !$c437f598d9c9ee16$var$_intersectCtx.bidirectional) {
                    $c437f598d9c9ee16$var$_minTv[updateDim] = d0;
                    $c437f598d9c9ee16$var$_minTv[zeroDim] = 0;
                    if ($c437f598d9c9ee16$var$_intersectCtx.useDir) $c437f598d9c9ee16$var$_intersectCtx.calcDirMTV();
                }
                if (d0 >= d1 || !$c437f598d9c9ee16$var$_intersectCtx.bidirectional) {
                    $c437f598d9c9ee16$var$_minTv[updateDim] = -d1;
                    $c437f598d9c9ee16$var$_minTv[zeroDim] = 0;
                    if ($c437f598d9c9ee16$var$_intersectCtx.useDir) $c437f598d9c9ee16$var$_intersectCtx.calcDirMTV();
                }
            }
        }
    }
}
function $c437f598d9c9ee16$export$a0be2bdbd2369e0e() {
    var _direction = 0;
    var _dirCheckVec = new (0, $1de2ad08c108b7c2$export$2e2bcd8739ae039)();
    var _dirTmp = new (0, $1de2ad08c108b7c2$export$2e2bcd8739ae039)();
    var _ctx = {
        minTv: new (0, $1de2ad08c108b7c2$export$2e2bcd8739ae039)(),
        maxTv: new (0, $1de2ad08c108b7c2$export$2e2bcd8739ae039)(),
        useDir: false,
        dirMinTv: new (0, $1de2ad08c108b7c2$export$2e2bcd8739ae039)(),
        touchThreshold: 0,
        bidirectional: true,
        negativeSize: false,
        reset: function(opt, useMTV) {
            _ctx.touchThreshold = 0;
            if (opt && opt.touchThreshold != null) _ctx.touchThreshold = $c437f598d9c9ee16$var$mathMax(0, opt.touchThreshold);
            _ctx.negativeSize = false;
            if (!useMTV) return;
            _ctx.minTv.set(Infinity, Infinity);
            _ctx.maxTv.set(0, 0);
            _ctx.useDir = false;
            if (opt && opt.direction != null) {
                _ctx.useDir = true;
                _ctx.dirMinTv.copy(_ctx.minTv);
                _dirTmp.copy(_ctx.minTv);
                _direction = opt.direction;
                _ctx.bidirectional = opt.bidirectional == null || !!opt.bidirectional;
                if (!_ctx.bidirectional) _dirCheckVec.set(Math.cos(_direction), Math.sin(_direction));
            }
        },
        calcDirMTV: function() {
            var minTv = _ctx.minTv;
            var dirMinTv = _ctx.dirMinTv;
            var squareMag = minTv.y * minTv.y + minTv.x * minTv.x;
            var dirSin = Math.sin(_direction);
            var dirCos = Math.cos(_direction);
            var dotProd = dirSin * minTv.y + dirCos * minTv.x;
            if (nearZero(dotProd)) {
                if (nearZero(minTv.x) && nearZero(minTv.y)) dirMinTv.set(0, 0);
                return;
            }
            _dirTmp.x = squareMag * dirCos / dotProd;
            _dirTmp.y = squareMag * dirSin / dotProd;
            if (nearZero(_dirTmp.x) && nearZero(_dirTmp.y)) {
                dirMinTv.set(0, 0);
                return;
            }
            if ((_ctx.bidirectional || _dirCheckVec.dot(_dirTmp) > 0) && _dirTmp.len() < dirMinTv.len()) dirMinTv.copy(_dirTmp);
        }
    };
    function nearZero(val) {
        return $c437f598d9c9ee16$var$mathAbs(val) < 1e-10;
    }
    return _ctx;
}
var $c437f598d9c9ee16$export$2e2bcd8739ae039 = $c437f598d9c9ee16$var$BoundingRect;


var $93fcb791e74b72e6$var$SILENT = "silent";
function $93fcb791e74b72e6$var$makeEventPacket(eveType, targetInfo, event) {
    return {
        type: eveType,
        event: event,
        target: targetInfo.target,
        topTarget: targetInfo.topTarget,
        cancelBubble: false,
        offsetX: event.zrX,
        offsetY: event.zrY,
        gestureEvent: event.gestureEvent,
        pinchX: event.pinchX,
        pinchY: event.pinchY,
        pinchScale: event.pinchScale,
        wheelDelta: event.zrDelta,
        zrByTouch: event.zrByTouch,
        which: event.which,
        stop: $93fcb791e74b72e6$var$stopEvent
    };
}
function $93fcb791e74b72e6$var$stopEvent() {
    $e48a660b5a6fd3cb$export$fa6813432f753b0d(this.event);
}
var $93fcb791e74b72e6$var$EmptyProxy = function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(EmptyProxy, _super);
    function EmptyProxy() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handler = null;
        return _this;
    }
    EmptyProxy.prototype.dispose = function() {};
    EmptyProxy.prototype.setCursor = function() {};
    return EmptyProxy;
}((0, $131b7833cdf735df$export$2e2bcd8739ae039));
var $93fcb791e74b72e6$var$HoveredResult = function() {
    function HoveredResult(x, y) {
        this.x = x;
        this.y = y;
    }
    return HoveredResult;
}();
var $93fcb791e74b72e6$var$handlerNames = [
    "click",
    "dblclick",
    "mousewheel",
    "mouseout",
    "mouseup",
    "mousedown",
    "mousemove",
    "contextmenu"
];
var $93fcb791e74b72e6$var$tmpRect = new (0, $c437f598d9c9ee16$export$2e2bcd8739ae039)(0, 0, 0, 0);
var $93fcb791e74b72e6$var$Handler = function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(Handler, _super);
    function Handler(storage, painter, proxy, painterRoot, pointerSize) {
        var _this = _super.call(this) || this;
        _this._hovered = new $93fcb791e74b72e6$var$HoveredResult(0, 0);
        _this.storage = storage;
        _this.painter = painter;
        _this.painterRoot = painterRoot;
        _this._pointerSize = pointerSize;
        proxy = proxy || new $93fcb791e74b72e6$var$EmptyProxy();
        _this.proxy = null;
        _this.setHandlerProxy(proxy);
        _this._draggingMgr = new (0, $a5222817c3685715$export$2e2bcd8739ae039)(_this);
        return _this;
    }
    Handler.prototype.setHandlerProxy = function(proxy) {
        if (this.proxy) this.proxy.dispose();
        if (proxy) {
            $43e0a445ed6711da$export$79b2f7037acddd43($93fcb791e74b72e6$var$handlerNames, function(name) {
                proxy.on && proxy.on(name, this[name], this);
            }, this);
            proxy.handler = this;
        }
        this.proxy = proxy;
    };
    Handler.prototype.mousemove = function(event) {
        var x = event.zrX;
        var y = event.zrY;
        var isOutside = $93fcb791e74b72e6$var$isOutsideBoundary(this, x, y);
        var lastHovered = this._hovered;
        var lastHoveredTarget = lastHovered.target;
        if (lastHoveredTarget && !lastHoveredTarget.__zr) {
            lastHovered = this.findHover(lastHovered.x, lastHovered.y);
            lastHoveredTarget = lastHovered.target;
        }
        var hovered = this._hovered = isOutside ? new $93fcb791e74b72e6$var$HoveredResult(x, y) : this.findHover(x, y);
        var hoveredTarget = hovered.target;
        var proxy = this.proxy;
        proxy.setCursor && proxy.setCursor(hoveredTarget ? hoveredTarget.cursor : "default");
        if (lastHoveredTarget && hoveredTarget !== lastHoveredTarget) this.dispatchToElement(lastHovered, "mouseout", event);
        this.dispatchToElement(hovered, "mousemove", event);
        if (hoveredTarget && hoveredTarget !== lastHoveredTarget) this.dispatchToElement(hovered, "mouseover", event);
    };
    Handler.prototype.mouseout = function(event) {
        var eventControl = event.zrEventControl;
        if (eventControl !== "only_globalout") this.dispatchToElement(this._hovered, "mouseout", event);
        if (eventControl !== "no_globalout") this.trigger("globalout", {
            type: "globalout",
            event: event
        });
    };
    Handler.prototype.resize = function() {
        this._hovered = new $93fcb791e74b72e6$var$HoveredResult(0, 0);
    };
    Handler.prototype.dispatch = function(eventName, eventArgs) {
        var handler = this[eventName];
        handler && handler.call(this, eventArgs);
    };
    Handler.prototype.dispose = function() {
        this.proxy.dispose();
        this.storage = null;
        this.proxy = null;
        this.painter = null;
    };
    Handler.prototype.setCursorStyle = function(cursorStyle) {
        var proxy = this.proxy;
        proxy.setCursor && proxy.setCursor(cursorStyle);
    };
    Handler.prototype.dispatchToElement = function(targetInfo, eventName, event) {
        targetInfo = targetInfo || {};
        var el = targetInfo.target;
        if (el && el.silent) return;
        var eventKey = "on" + eventName;
        var eventPacket = $93fcb791e74b72e6$var$makeEventPacket(eventName, targetInfo, event);
        while(el){
            el[eventKey] && (eventPacket.cancelBubble = !!el[eventKey].call(el, eventPacket));
            el.trigger(eventName, eventPacket);
            el = el.__hostTarget ? el.__hostTarget : el.parent;
            if (eventPacket.cancelBubble) break;
        }
        if (!eventPacket.cancelBubble) {
            this.trigger(eventName, eventPacket);
            if (this.painter && this.painter.eachOtherLayer) this.painter.eachOtherLayer(function(layer) {
                if (typeof layer[eventKey] === "function") layer[eventKey].call(layer, eventPacket);
                if (layer.trigger) layer.trigger(eventName, eventPacket);
            });
        }
    };
    Handler.prototype.findHover = function(x, y, exclude) {
        var list = this.storage.getDisplayList();
        var out = new $93fcb791e74b72e6$var$HoveredResult(x, y);
        $93fcb791e74b72e6$var$setHoverTarget(list, out, x, y, exclude);
        if (this._pointerSize && !out.target) {
            var candidates = [];
            var pointerSize = this._pointerSize;
            var targetSizeHalf = pointerSize / 2;
            var pointerRect = new (0, $c437f598d9c9ee16$export$2e2bcd8739ae039)(x - targetSizeHalf, y - targetSizeHalf, pointerSize, pointerSize);
            for(var i = list.length - 1; i >= 0; i--){
                var el = list[i];
                if (el !== exclude && !el.ignore && !el.ignoreCoarsePointer && (!el.parent || !el.parent.ignoreCoarsePointer)) {
                    $93fcb791e74b72e6$var$tmpRect.copy(el.getBoundingRect());
                    if (el.transform) $93fcb791e74b72e6$var$tmpRect.applyTransform(el.transform);
                    if ($93fcb791e74b72e6$var$tmpRect.intersect(pointerRect)) candidates.push(el);
                }
            }
            if (candidates.length) {
                var rStep = 4;
                var thetaStep = Math.PI / 12;
                var PI2 = Math.PI * 2;
                for(var r = 0; r < targetSizeHalf; r += rStep)for(var theta = 0; theta < PI2; theta += thetaStep){
                    var x1 = x + r * Math.cos(theta);
                    var y1 = y + r * Math.sin(theta);
                    $93fcb791e74b72e6$var$setHoverTarget(candidates, out, x1, y1, exclude);
                    if (out.target) return out;
                }
            }
        }
        return out;
    };
    Handler.prototype.processGesture = function(event, stage) {
        if (!this._gestureMgr) this._gestureMgr = new (0, $f827c357e1ee5b29$export$f7557d6f27e9503)();
        var gestureMgr = this._gestureMgr;
        stage === "start" && gestureMgr.clear();
        var gestureInfo = gestureMgr.recognize(event, this.findHover(event.zrX, event.zrY, null).target, this.proxy.dom);
        stage === "end" && gestureMgr.clear();
        if (gestureInfo) {
            var type = gestureInfo.type;
            event.gestureEvent = type;
            var res = new $93fcb791e74b72e6$var$HoveredResult();
            res.target = gestureInfo.target;
            this.dispatchToElement(res, type, gestureInfo.event);
        }
    };
    return Handler;
}((0, $131b7833cdf735df$export$2e2bcd8739ae039));
$43e0a445ed6711da$export$79b2f7037acddd43([
    "click",
    "mousedown",
    "mouseup",
    "mousewheel",
    "dblclick",
    "contextmenu"
], function(name) {
    $93fcb791e74b72e6$var$Handler.prototype[name] = function(event) {
        var x = event.zrX;
        var y = event.zrY;
        var isOutside = $93fcb791e74b72e6$var$isOutsideBoundary(this, x, y);
        var hovered;
        var hoveredTarget;
        if (name !== "mouseup" || !isOutside) {
            hovered = this.findHover(x, y);
            hoveredTarget = hovered.target;
        }
        if (name === "mousedown") {
            this._downEl = hoveredTarget;
            this._downPoint = [
                event.zrX,
                event.zrY
            ];
            this._upEl = hoveredTarget;
        } else if (name === "mouseup") this._upEl = hoveredTarget;
        else if (name === "click") {
            if (this._downEl !== this._upEl || !this._downPoint || $ee491d8f32bd01ff$export$6c4a311cc157c764(this._downPoint, [
                event.zrX,
                event.zrY
            ]) > 4) return;
            this._downPoint = null;
        }
        this.dispatchToElement(hovered, name, event);
    };
});
function $93fcb791e74b72e6$var$isHover(displayable, x, y) {
    if (displayable[displayable.rectHover ? "rectContain" : "contain"](x, y)) {
        var el = displayable;
        var isSilent = void 0;
        var ignoreClip = false;
        while(el){
            if (el.ignoreClip) ignoreClip = true;
            if (!ignoreClip) {
                var clipPath = el.getClipPath();
                if (clipPath && !clipPath.contain(x, y)) return false;
            }
            if (el.silent) isSilent = true;
            var hostEl = el.__hostTarget;
            el = hostEl ? el.ignoreHostSilent ? null : hostEl : el.parent;
        }
        return isSilent ? $93fcb791e74b72e6$var$SILENT : true;
    }
    return false;
}
function $93fcb791e74b72e6$var$setHoverTarget(list, out, x, y, exclude) {
    for(var i = list.length - 1; i >= 0; i--){
        var el = list[i];
        var hoverCheckResult = void 0;
        if (el !== exclude && !el.ignore && (hoverCheckResult = $93fcb791e74b72e6$var$isHover(el, x, y))) {
            !out.topTarget && (out.topTarget = el);
            if (hoverCheckResult !== $93fcb791e74b72e6$var$SILENT) {
                out.target = el;
                break;
            }
        }
    }
}
function $93fcb791e74b72e6$var$isOutsideBoundary(handlerInstance, x, y) {
    var painter = handlerInstance.painter;
    return x < 0 || x > painter.getWidth() || y < 0 || y > painter.getHeight();
}
var $93fcb791e74b72e6$export$2e2bcd8739ae039 = $93fcb791e74b72e6$var$Handler;



var $48c141f615e02ecf$var$DEFAULT_MIN_MERGE = 32;
var $48c141f615e02ecf$var$DEFAULT_MIN_GALLOPING = 7;
function $48c141f615e02ecf$var$minRunLength(n) {
    var r = 0;
    while(n >= $48c141f615e02ecf$var$DEFAULT_MIN_MERGE){
        r |= n & 1;
        n >>= 1;
    }
    return n + r;
}
function $48c141f615e02ecf$var$makeAscendingRun(array, lo, hi, compare) {
    var runHi = lo + 1;
    if (runHi === hi) return 1;
    if (compare(array[runHi++], array[lo]) < 0) {
        while(runHi < hi && compare(array[runHi], array[runHi - 1]) < 0)runHi++;
        $48c141f615e02ecf$var$reverseRun(array, lo, runHi);
    } else while(runHi < hi && compare(array[runHi], array[runHi - 1]) >= 0)runHi++;
    return runHi - lo;
}
function $48c141f615e02ecf$var$reverseRun(array, lo, hi) {
    hi--;
    while(lo < hi){
        var t = array[lo];
        array[lo++] = array[hi];
        array[hi--] = t;
    }
}
function $48c141f615e02ecf$var$binaryInsertionSort(array, lo, hi, start, compare) {
    if (start === lo) start++;
    for(; start < hi; start++){
        var pivot = array[start];
        var left = lo;
        var right = start;
        var mid;
        while(left < right){
            mid = left + right >>> 1;
            if (compare(pivot, array[mid]) < 0) right = mid;
            else left = mid + 1;
        }
        var n = start - left;
        switch(n){
            case 3:
                array[left + 3] = array[left + 2];
            case 2:
                array[left + 2] = array[left + 1];
            case 1:
                array[left + 1] = array[left];
                break;
            default:
                while(n > 0){
                    array[left + n] = array[left + n - 1];
                    n--;
                }
        }
        array[left] = pivot;
    }
}
function $48c141f615e02ecf$var$gallopLeft(value, array, start, length, hint, compare) {
    var lastOffset = 0;
    var maxOffset = 0;
    var offset = 1;
    if (compare(value, array[start + hint]) > 0) {
        maxOffset = length - hint;
        while(offset < maxOffset && compare(value, array[start + hint + offset]) > 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        lastOffset += hint;
        offset += hint;
    } else {
        maxOffset = hint + 1;
        while(offset < maxOffset && compare(value, array[start + hint - offset]) <= 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        var tmp = lastOffset;
        lastOffset = hint - offset;
        offset = hint - tmp;
    }
    lastOffset++;
    while(lastOffset < offset){
        var m = lastOffset + (offset - lastOffset >>> 1);
        if (compare(value, array[start + m]) > 0) lastOffset = m + 1;
        else offset = m;
    }
    return offset;
}
function $48c141f615e02ecf$var$gallopRight(value, array, start, length, hint, compare) {
    var lastOffset = 0;
    var maxOffset = 0;
    var offset = 1;
    if (compare(value, array[start + hint]) < 0) {
        maxOffset = hint + 1;
        while(offset < maxOffset && compare(value, array[start + hint - offset]) < 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        var tmp = lastOffset;
        lastOffset = hint - offset;
        offset = hint - tmp;
    } else {
        maxOffset = length - hint;
        while(offset < maxOffset && compare(value, array[start + hint + offset]) >= 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        lastOffset += hint;
        offset += hint;
    }
    lastOffset++;
    while(lastOffset < offset){
        var m = lastOffset + (offset - lastOffset >>> 1);
        if (compare(value, array[start + m]) < 0) offset = m;
        else lastOffset = m + 1;
    }
    return offset;
}
function $48c141f615e02ecf$var$TimSort(array, compare) {
    var minGallop = $48c141f615e02ecf$var$DEFAULT_MIN_GALLOPING;
    var runStart;
    var runLength;
    var stackSize = 0;
    var tmp = [];
    runStart = [];
    runLength = [];
    function pushRun(_runStart, _runLength) {
        runStart[stackSize] = _runStart;
        runLength[stackSize] = _runLength;
        stackSize += 1;
    }
    function mergeRuns() {
        while(stackSize > 1){
            var n = stackSize - 2;
            if (n >= 1 && runLength[n - 1] <= runLength[n] + runLength[n + 1] || n >= 2 && runLength[n - 2] <= runLength[n] + runLength[n - 1]) {
                if (runLength[n - 1] < runLength[n + 1]) n--;
            } else if (runLength[n] > runLength[n + 1]) break;
            mergeAt(n);
        }
    }
    function forceMergeRuns() {
        while(stackSize > 1){
            var n = stackSize - 2;
            if (n > 0 && runLength[n - 1] < runLength[n + 1]) n--;
            mergeAt(n);
        }
    }
    function mergeAt(i) {
        var start1 = runStart[i];
        var length1 = runLength[i];
        var start2 = runStart[i + 1];
        var length2 = runLength[i + 1];
        runLength[i] = length1 + length2;
        if (i === stackSize - 3) {
            runStart[i + 1] = runStart[i + 2];
            runLength[i + 1] = runLength[i + 2];
        }
        stackSize--;
        var k = $48c141f615e02ecf$var$gallopRight(array[start2], array, start1, length1, 0, compare);
        start1 += k;
        length1 -= k;
        if (length1 === 0) return;
        length2 = $48c141f615e02ecf$var$gallopLeft(array[start1 + length1 - 1], array, start2, length2, length2 - 1, compare);
        if (length2 === 0) return;
        if (length1 <= length2) mergeLow(start1, length1, start2, length2);
        else mergeHigh(start1, length1, start2, length2);
    }
    function mergeLow(start1, length1, start2, length2) {
        var i = 0;
        for(i = 0; i < length1; i++)tmp[i] = array[start1 + i];
        var cursor1 = 0;
        var cursor2 = start2;
        var dest = start1;
        array[dest++] = array[cursor2++];
        if (--length2 === 0) {
            for(i = 0; i < length1; i++)array[dest + i] = tmp[cursor1 + i];
            return;
        }
        if (length1 === 1) {
            for(i = 0; i < length2; i++)array[dest + i] = array[cursor2 + i];
            array[dest + length2] = tmp[cursor1];
            return;
        }
        var _minGallop = minGallop;
        var count1;
        var count2;
        var exit;
        while(true){
            count1 = 0;
            count2 = 0;
            exit = false;
            do if (compare(array[cursor2], tmp[cursor1]) < 0) {
                array[dest++] = array[cursor2++];
                count2++;
                count1 = 0;
                if (--length2 === 0) {
                    exit = true;
                    break;
                }
            } else {
                array[dest++] = tmp[cursor1++];
                count1++;
                count2 = 0;
                if (--length1 === 1) {
                    exit = true;
                    break;
                }
            }
            while ((count1 | count2) < _minGallop);
            if (exit) break;
            do {
                count1 = $48c141f615e02ecf$var$gallopRight(array[cursor2], tmp, cursor1, length1, 0, compare);
                if (count1 !== 0) {
                    for(i = 0; i < count1; i++)array[dest + i] = tmp[cursor1 + i];
                    dest += count1;
                    cursor1 += count1;
                    length1 -= count1;
                    if (length1 <= 1) {
                        exit = true;
                        break;
                    }
                }
                array[dest++] = array[cursor2++];
                if (--length2 === 0) {
                    exit = true;
                    break;
                }
                count2 = $48c141f615e02ecf$var$gallopLeft(tmp[cursor1], array, cursor2, length2, 0, compare);
                if (count2 !== 0) {
                    for(i = 0; i < count2; i++)array[dest + i] = array[cursor2 + i];
                    dest += count2;
                    cursor2 += count2;
                    length2 -= count2;
                    if (length2 === 0) {
                        exit = true;
                        break;
                    }
                }
                array[dest++] = tmp[cursor1++];
                if (--length1 === 1) {
                    exit = true;
                    break;
                }
                _minGallop--;
            }while (count1 >= $48c141f615e02ecf$var$DEFAULT_MIN_GALLOPING || count2 >= $48c141f615e02ecf$var$DEFAULT_MIN_GALLOPING);
            if (exit) break;
            if (_minGallop < 0) _minGallop = 0;
            _minGallop += 2;
        }
        minGallop = _minGallop;
        minGallop < 1 && (minGallop = 1);
        if (length1 === 1) {
            for(i = 0; i < length2; i++)array[dest + i] = array[cursor2 + i];
            array[dest + length2] = tmp[cursor1];
        } else if (length1 === 0) throw new Error();
        else for(i = 0; i < length1; i++)array[dest + i] = tmp[cursor1 + i];
    }
    function mergeHigh(start1, length1, start2, length2) {
        var i = 0;
        for(i = 0; i < length2; i++)tmp[i] = array[start2 + i];
        var cursor1 = start1 + length1 - 1;
        var cursor2 = length2 - 1;
        var dest = start2 + length2 - 1;
        var customCursor = 0;
        var customDest = 0;
        array[dest--] = array[cursor1--];
        if (--length1 === 0) {
            customCursor = dest - (length2 - 1);
            for(i = 0; i < length2; i++)array[customCursor + i] = tmp[i];
            return;
        }
        if (length2 === 1) {
            dest -= length1;
            cursor1 -= length1;
            customDest = dest + 1;
            customCursor = cursor1 + 1;
            for(i = length1 - 1; i >= 0; i--)array[customDest + i] = array[customCursor + i];
            array[dest] = tmp[cursor2];
            return;
        }
        var _minGallop = minGallop;
        while(true){
            var count1 = 0;
            var count2 = 0;
            var exit = false;
            do if (compare(tmp[cursor2], array[cursor1]) < 0) {
                array[dest--] = array[cursor1--];
                count1++;
                count2 = 0;
                if (--length1 === 0) {
                    exit = true;
                    break;
                }
            } else {
                array[dest--] = tmp[cursor2--];
                count2++;
                count1 = 0;
                if (--length2 === 1) {
                    exit = true;
                    break;
                }
            }
            while ((count1 | count2) < _minGallop);
            if (exit) break;
            do {
                count1 = length1 - $48c141f615e02ecf$var$gallopRight(tmp[cursor2], array, start1, length1, length1 - 1, compare);
                if (count1 !== 0) {
                    dest -= count1;
                    cursor1 -= count1;
                    length1 -= count1;
                    customDest = dest + 1;
                    customCursor = cursor1 + 1;
                    for(i = count1 - 1; i >= 0; i--)array[customDest + i] = array[customCursor + i];
                    if (length1 === 0) {
                        exit = true;
                        break;
                    }
                }
                array[dest--] = tmp[cursor2--];
                if (--length2 === 1) {
                    exit = true;
                    break;
                }
                count2 = length2 - $48c141f615e02ecf$var$gallopLeft(array[cursor1], tmp, 0, length2, length2 - 1, compare);
                if (count2 !== 0) {
                    dest -= count2;
                    cursor2 -= count2;
                    length2 -= count2;
                    customDest = dest + 1;
                    customCursor = cursor2 + 1;
                    for(i = 0; i < count2; i++)array[customDest + i] = tmp[customCursor + i];
                    if (length2 <= 1) {
                        exit = true;
                        break;
                    }
                }
                array[dest--] = array[cursor1--];
                if (--length1 === 0) {
                    exit = true;
                    break;
                }
                _minGallop--;
            }while (count1 >= $48c141f615e02ecf$var$DEFAULT_MIN_GALLOPING || count2 >= $48c141f615e02ecf$var$DEFAULT_MIN_GALLOPING);
            if (exit) break;
            if (_minGallop < 0) _minGallop = 0;
            _minGallop += 2;
        }
        minGallop = _minGallop;
        if (minGallop < 1) minGallop = 1;
        if (length2 === 1) {
            dest -= length1;
            cursor1 -= length1;
            customDest = dest + 1;
            customCursor = cursor1 + 1;
            for(i = length1 - 1; i >= 0; i--)array[customDest + i] = array[customCursor + i];
            array[dest] = tmp[cursor2];
        } else if (length2 === 0) throw new Error();
        else {
            customCursor = dest - (length2 - 1);
            for(i = 0; i < length2; i++)array[customCursor + i] = tmp[i];
        }
    }
    return {
        mergeRuns: mergeRuns,
        forceMergeRuns: forceMergeRuns,
        pushRun: pushRun
    };
}
function $48c141f615e02ecf$export$2e2bcd8739ae039(array, compare, lo, hi) {
    if (!lo) lo = 0;
    if (!hi) hi = array.length;
    var remaining = hi - lo;
    if (remaining < 2) return;
    var runLength = 0;
    if (remaining < $48c141f615e02ecf$var$DEFAULT_MIN_MERGE) {
        runLength = $48c141f615e02ecf$var$makeAscendingRun(array, lo, hi, compare);
        $48c141f615e02ecf$var$binaryInsertionSort(array, lo, hi, lo + runLength, compare);
        return;
    }
    var ts = $48c141f615e02ecf$var$TimSort(array, compare);
    var minRun = $48c141f615e02ecf$var$minRunLength(remaining);
    do {
        runLength = $48c141f615e02ecf$var$makeAscendingRun(array, lo, hi, compare);
        if (runLength < minRun) {
            var force = remaining;
            if (force > minRun) force = minRun;
            $48c141f615e02ecf$var$binaryInsertionSort(array, lo, lo + force, lo + runLength, compare);
            runLength = force;
        }
        ts.pushRun(lo, runLength);
        ts.mergeRuns();
        remaining -= runLength;
        lo += runLength;
    }while (remaining !== 0);
    ts.forceMergeRuns();
}


var $24fa4a8d26d34a24$export$a7b6db622c6c7dbd = 1;
var $24fa4a8d26d34a24$export$ada8b2beb3d76671 = 2;
var $24fa4a8d26d34a24$export$f75fe89a33ebe115 = 4;


var $bebee66775a2c8f3$var$invalidZErrorLogged = false;
function $bebee66775a2c8f3$var$logInvalidZError() {
    if ($bebee66775a2c8f3$var$invalidZErrorLogged) return;
    $bebee66775a2c8f3$var$invalidZErrorLogged = true;
    console.warn("z / z2 / zlevel of displayable is invalid, which may cause unexpected errors");
}
function $bebee66775a2c8f3$var$shapeCompareFunc(a, b) {
    if (a.zlevel === b.zlevel) {
        if (a.z === b.z) return a.z2 - b.z2;
        return a.z - b.z;
    }
    return a.zlevel - b.zlevel;
}
var $bebee66775a2c8f3$var$Storage = function() {
    function Storage() {
        this._roots = [];
        this._displayList = [];
        this._displayListLen = 0;
        this.displayableSortFunc = $bebee66775a2c8f3$var$shapeCompareFunc;
    }
    Storage.prototype.traverse = function(cb, context) {
        for(var i = 0; i < this._roots.length; i++)this._roots[i].traverse(cb, context);
    };
    Storage.prototype.getDisplayList = function(update, includeIgnore) {
        includeIgnore = includeIgnore || false;
        var displayList = this._displayList;
        if (update || !displayList.length) this.updateDisplayList(includeIgnore);
        return displayList;
    };
    Storage.prototype.updateDisplayList = function(includeIgnore) {
        this._displayListLen = 0;
        var roots = this._roots;
        var displayList = this._displayList;
        for(var i = 0, len = roots.length; i < len; i++)this._updateAndAddDisplayable(roots[i], null, includeIgnore);
        displayList.length = this._displayListLen;
        (0, $48c141f615e02ecf$export$2e2bcd8739ae039)(displayList, $bebee66775a2c8f3$var$shapeCompareFunc);
    };
    Storage.prototype._updateAndAddDisplayable = function(el, parentClipPaths, includeIgnore) {
        if (el.ignore && !includeIgnore) return;
        el.beforeUpdate();
        el.update();
        el.afterUpdate();
        var userSetClipPath = el.getClipPath();
        var parentHasClipPaths = parentClipPaths && parentClipPaths.length;
        var clipPathIdx = 0;
        var thisClipPaths = el.__clipPaths;
        if (!el.ignoreClip && (parentHasClipPaths || userSetClipPath)) {
            if (!thisClipPaths) thisClipPaths = el.__clipPaths = [];
            if (parentHasClipPaths) for(var idx = 0; idx < parentClipPaths.length; idx++)thisClipPaths[clipPathIdx++] = parentClipPaths[idx];
            var currentClipPath = userSetClipPath;
            var parentClipPath = el;
            while(currentClipPath){
                currentClipPath.parent = parentClipPath;
                currentClipPath.updateTransform();
                thisClipPaths[clipPathIdx++] = currentClipPath;
                parentClipPath = currentClipPath;
                currentClipPath = currentClipPath.getClipPath();
            }
        }
        if (thisClipPaths) thisClipPaths.length = clipPathIdx;
        if (el.childrenRef) {
            var children = el.childrenRef();
            for(var i = 0; i < children.length; i++){
                var child = children[i];
                if (el.__dirty) child.__dirty |= (0, $24fa4a8d26d34a24$export$a7b6db622c6c7dbd);
                this._updateAndAddDisplayable(child, thisClipPaths, includeIgnore);
            }
            el.__dirty = 0;
        } else {
            var disp = el;
            if (isNaN(disp.z)) {
                $bebee66775a2c8f3$var$logInvalidZError();
                disp.z = 0;
            }
            if (isNaN(disp.z2)) {
                $bebee66775a2c8f3$var$logInvalidZError();
                disp.z2 = 0;
            }
            if (isNaN(disp.zlevel)) {
                $bebee66775a2c8f3$var$logInvalidZError();
                disp.zlevel = 0;
            }
            this._displayList[this._displayListLen++] = disp;
        }
        var decalEl = el.getDecalElement && el.getDecalElement();
        if (decalEl) this._updateAndAddDisplayable(decalEl, thisClipPaths, includeIgnore);
        var textGuide = el.getTextGuideLine();
        if (textGuide) this._updateAndAddDisplayable(textGuide, thisClipPaths, includeIgnore);
        var textEl = el.getTextContent();
        if (textEl) this._updateAndAddDisplayable(textEl, thisClipPaths, includeIgnore);
    };
    Storage.prototype.addRoot = function(el) {
        if (el.__zr && el.__zr.storage === this) return;
        this._roots.push(el);
    };
    Storage.prototype.delRoot = function(el) {
        if (el instanceof Array) {
            for(var i = 0, l = el.length; i < l; i++)this.delRoot(el[i]);
            return;
        }
        var idx = $43e0a445ed6711da$export$305f7d4e9d4624f2(this._roots, el);
        if (idx >= 0) this._roots.splice(idx, 1);
    };
    Storage.prototype.delAllRoots = function() {
        this._roots = [];
        this._displayList = [];
        this._displayListLen = 0;
        return;
    };
    Storage.prototype.getRoots = function() {
        return this._roots;
    };
    Storage.prototype.dispose = function() {
        this._displayList = null;
        this._roots = null;
    };
    return Storage;
}();
var $bebee66775a2c8f3$export$2e2bcd8739ae039 = $bebee66775a2c8f3$var$Storage;





var $261197b637bbe3ef$var$requestAnimationFrame;
$261197b637bbe3ef$var$requestAnimationFrame = (0, $a84633bb9c74d89c$export$2e2bcd8739ae039).hasGlobalWindow && (window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.msRequestAnimationFrame && window.msRequestAnimationFrame.bind(window) || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame) || function(func) {
    return setTimeout(func, 16);
};
var $261197b637bbe3ef$export$2e2bcd8739ae039 = $261197b637bbe3ef$var$requestAnimationFrame;


var $5c8efb9bac6f133e$var$easingFuncs = {
    linear: function(k) {
        return k;
    },
    quadraticIn: function(k) {
        return k * k;
    },
    quadraticOut: function(k) {
        return k * (2 - k);
    },
    quadraticInOut: function(k) {
        if ((k *= 2) < 1) return 0.5 * k * k;
        return -0.5 * (--k * (k - 2) - 1);
    },
    cubicIn: function(k) {
        return k * k * k;
    },
    cubicOut: function(k) {
        return --k * k * k + 1;
    },
    cubicInOut: function(k) {
        if ((k *= 2) < 1) return 0.5 * k * k * k;
        return 0.5 * ((k -= 2) * k * k + 2);
    },
    quarticIn: function(k) {
        return k * k * k * k;
    },
    quarticOut: function(k) {
        return 1 - --k * k * k * k;
    },
    quarticInOut: function(k) {
        if ((k *= 2) < 1) return 0.5 * k * k * k * k;
        return -0.5 * ((k -= 2) * k * k * k - 2);
    },
    quinticIn: function(k) {
        return k * k * k * k * k;
    },
    quinticOut: function(k) {
        return --k * k * k * k * k + 1;
    },
    quinticInOut: function(k) {
        if ((k *= 2) < 1) return 0.5 * k * k * k * k * k;
        return 0.5 * ((k -= 2) * k * k * k * k + 2);
    },
    sinusoidalIn: function(k) {
        return 1 - Math.cos(k * Math.PI / 2);
    },
    sinusoidalOut: function(k) {
        return Math.sin(k * Math.PI / 2);
    },
    sinusoidalInOut: function(k) {
        return 0.5 * (1 - Math.cos(Math.PI * k));
    },
    exponentialIn: function(k) {
        return k === 0 ? 0 : Math.pow(1024, k - 1);
    },
    exponentialOut: function(k) {
        return k === 1 ? 1 : 1 - Math.pow(2, -10 * k);
    },
    exponentialInOut: function(k) {
        if (k === 0) return 0;
        if (k === 1) return 1;
        if ((k *= 2) < 1) return 0.5 * Math.pow(1024, k - 1);
        return 0.5 * (-Math.pow(2, -10 * (k - 1)) + 2);
    },
    circularIn: function(k) {
        return 1 - Math.sqrt(1 - k * k);
    },
    circularOut: function(k) {
        return Math.sqrt(1 - --k * k);
    },
    circularInOut: function(k) {
        if ((k *= 2) < 1) return -0.5 * (Math.sqrt(1 - k * k) - 1);
        return 0.5 * (Math.sqrt(1 - (k -= 2) * k) + 1);
    },
    elasticIn: function(k) {
        var s;
        var a = 0.1;
        var p = 0.4;
        if (k === 0) return 0;
        if (k === 1) return 1;
        if (!a || a < 1) {
            a = 1;
            s = p / 4;
        } else s = p * Math.asin(1 / a) / (2 * Math.PI);
        return -(a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
    },
    elasticOut: function(k) {
        var s;
        var a = 0.1;
        var p = 0.4;
        if (k === 0) return 0;
        if (k === 1) return 1;
        if (!a || a < 1) {
            a = 1;
            s = p / 4;
        } else s = p * Math.asin(1 / a) / (2 * Math.PI);
        return a * Math.pow(2, -10 * k) * Math.sin((k - s) * (2 * Math.PI) / p) + 1;
    },
    elasticInOut: function(k) {
        var s;
        var a = 0.1;
        var p = 0.4;
        if (k === 0) return 0;
        if (k === 1) return 1;
        if (!a || a < 1) {
            a = 1;
            s = p / 4;
        } else s = p * Math.asin(1 / a) / (2 * Math.PI);
        if ((k *= 2) < 1) return -0.5 * (a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
        return a * Math.pow(2, -10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p) * 0.5 + 1;
    },
    backIn: function(k) {
        var s = 1.70158;
        return k * k * ((s + 1) * k - s);
    },
    backOut: function(k) {
        var s = 1.70158;
        return --k * k * ((s + 1) * k + s) + 1;
    },
    backInOut: function(k) {
        var s = 2.5949095;
        if ((k *= 2) < 1) return 0.5 * (k * k * ((s + 1) * k - s));
        return 0.5 * ((k -= 2) * k * ((s + 1) * k + s) + 2);
    },
    bounceIn: function(k) {
        return 1 - $5c8efb9bac6f133e$var$easingFuncs.bounceOut(1 - k);
    },
    bounceOut: function(k) {
        if (k < 1 / 2.75) return 7.5625 * k * k;
        else if (k < 2 / 2.75) return 7.5625 * (k -= 1.5 / 2.75) * k + 0.75;
        else if (k < 2.5 / 2.75) return 7.5625 * (k -= 2.25 / 2.75) * k + 0.9375;
        else return 7.5625 * (k -= 2.625 / 2.75) * k + 0.984375;
    },
    bounceInOut: function(k) {
        if (k < 0.5) return $5c8efb9bac6f133e$var$easingFuncs.bounceIn(k * 2) * 0.5;
        return $5c8efb9bac6f133e$var$easingFuncs.bounceOut(k * 2 - 1) * 0.5 + 0.5;
    }
};
var $5c8efb9bac6f133e$export$2e2bcd8739ae039 = $5c8efb9bac6f133e$var$easingFuncs;




var $3dec70ca5f6b6e8f$var$mathPow = Math.pow;
var $3dec70ca5f6b6e8f$var$mathSqrt = Math.sqrt;
var $3dec70ca5f6b6e8f$var$EPSILON = 1e-8;
var $3dec70ca5f6b6e8f$var$EPSILON_NUMERIC = 1e-4;
var $3dec70ca5f6b6e8f$var$THREE_SQRT = $3dec70ca5f6b6e8f$var$mathSqrt(3);
var $3dec70ca5f6b6e8f$var$ONE_THIRD = 1 / 3;
var $3dec70ca5f6b6e8f$var$_v0 = (0, $ee491d8f32bd01ff$export$185802fd694ee1f5)();
var $3dec70ca5f6b6e8f$var$_v1 = (0, $ee491d8f32bd01ff$export$185802fd694ee1f5)();
var $3dec70ca5f6b6e8f$var$_v2 = (0, $ee491d8f32bd01ff$export$185802fd694ee1f5)();
function $3dec70ca5f6b6e8f$var$isAroundZero(val) {
    return val > -$3dec70ca5f6b6e8f$var$EPSILON && val < $3dec70ca5f6b6e8f$var$EPSILON;
}
function $3dec70ca5f6b6e8f$var$isNotAroundZero(val) {
    return val > $3dec70ca5f6b6e8f$var$EPSILON || val < -$3dec70ca5f6b6e8f$var$EPSILON;
}
function $3dec70ca5f6b6e8f$export$547c21de482bbcb2(p0, p1, p2, p3, t) {
    var onet = 1 - t;
    return onet * onet * (onet * p0 + 3 * t * p1) + t * t * (t * p3 + 3 * onet * p2);
}
function $3dec70ca5f6b6e8f$export$55fce925c60b6271(p0, p1, p2, p3, t) {
    var onet = 1 - t;
    return 3 * (((p1 - p0) * onet + 2 * (p2 - p1) * t) * onet + (p3 - p2) * t * t);
}
function $3dec70ca5f6b6e8f$export$ca5d13faa10b167e(p0, p1, p2, p3, val, roots) {
    var a = p3 + 3 * (p1 - p2) - p0;
    var b = 3 * (p2 - p1 * 2 + p0);
    var c = 3 * (p1 - p0);
    var d = p0 - val;
    var A = b * b - 3 * a * c;
    var B = b * c - 9 * a * d;
    var C = c * c - 3 * b * d;
    var n = 0;
    if ($3dec70ca5f6b6e8f$var$isAroundZero(A) && $3dec70ca5f6b6e8f$var$isAroundZero(B)) {
        if ($3dec70ca5f6b6e8f$var$isAroundZero(b)) roots[0] = 0;
        else {
            var t1 = -c / b;
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        }
    } else {
        var disc = B * B - 4 * A * C;
        if ($3dec70ca5f6b6e8f$var$isAroundZero(disc)) {
            var K = B / A;
            var t1 = -b / a + K;
            var t2 = -K / 2;
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
            if (t2 >= 0 && t2 <= 1) roots[n++] = t2;
        } else if (disc > 0) {
            var discSqrt = $3dec70ca5f6b6e8f$var$mathSqrt(disc);
            var Y1 = A * b + 1.5 * a * (-B + discSqrt);
            var Y2 = A * b + 1.5 * a * (-B - discSqrt);
            if (Y1 < 0) Y1 = -$3dec70ca5f6b6e8f$var$mathPow(-Y1, $3dec70ca5f6b6e8f$var$ONE_THIRD);
            else Y1 = $3dec70ca5f6b6e8f$var$mathPow(Y1, $3dec70ca5f6b6e8f$var$ONE_THIRD);
            if (Y2 < 0) Y2 = -$3dec70ca5f6b6e8f$var$mathPow(-Y2, $3dec70ca5f6b6e8f$var$ONE_THIRD);
            else Y2 = $3dec70ca5f6b6e8f$var$mathPow(Y2, $3dec70ca5f6b6e8f$var$ONE_THIRD);
            var t1 = (-b - (Y1 + Y2)) / (3 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        } else {
            var T = (2 * A * b - 3 * a * B) / (2 * $3dec70ca5f6b6e8f$var$mathSqrt(A * A * A));
            var theta = Math.acos(T) / 3;
            var ASqrt = $3dec70ca5f6b6e8f$var$mathSqrt(A);
            var tmp = Math.cos(theta);
            var t1 = (-b - 2 * ASqrt * tmp) / (3 * a);
            var t2 = (-b + ASqrt * (tmp + $3dec70ca5f6b6e8f$var$THREE_SQRT * Math.sin(theta))) / (3 * a);
            var t3 = (-b + ASqrt * (tmp - $3dec70ca5f6b6e8f$var$THREE_SQRT * Math.sin(theta))) / (3 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
            if (t2 >= 0 && t2 <= 1) roots[n++] = t2;
            if (t3 >= 0 && t3 <= 1) roots[n++] = t3;
        }
    }
    return n;
}
function $3dec70ca5f6b6e8f$export$df1a172f100d0457(p0, p1, p2, p3, extrema) {
    var b = 6 * p2 - 12 * p1 + 6 * p0;
    var a = 9 * p1 + 3 * p3 - 3 * p0 - 9 * p2;
    var c = 3 * p1 - 3 * p0;
    var n = 0;
    if ($3dec70ca5f6b6e8f$var$isAroundZero(a)) {
        if ($3dec70ca5f6b6e8f$var$isNotAroundZero(b)) {
            var t1 = -c / b;
            if (t1 >= 0 && t1 <= 1) extrema[n++] = t1;
        }
    } else {
        var disc = b * b - 4 * a * c;
        if ($3dec70ca5f6b6e8f$var$isAroundZero(disc)) extrema[0] = -b / (2 * a);
        else if (disc > 0) {
            var discSqrt = $3dec70ca5f6b6e8f$var$mathSqrt(disc);
            var t1 = (-b + discSqrt) / (2 * a);
            var t2 = (-b - discSqrt) / (2 * a);
            if (t1 >= 0 && t1 <= 1) extrema[n++] = t1;
            if (t2 >= 0 && t2 <= 1) extrema[n++] = t2;
        }
    }
    return n;
}
function $3dec70ca5f6b6e8f$export$a2ee23a0567039da(p0, p1, p2, p3, t, out) {
    var p01 = (p1 - p0) * t + p0;
    var p12 = (p2 - p1) * t + p1;
    var p23 = (p3 - p2) * t + p2;
    var p012 = (p12 - p01) * t + p01;
    var p123 = (p23 - p12) * t + p12;
    var p0123 = (p123 - p012) * t + p012;
    out[0] = p0;
    out[1] = p01;
    out[2] = p012;
    out[3] = p0123;
    out[4] = p0123;
    out[5] = p123;
    out[6] = p23;
    out[7] = p3;
}
function $3dec70ca5f6b6e8f$export$dbaa3801d1284367(x0, y0, x1, y1, x2, y2, x3, y3, x, y, out) {
    var t;
    var interval = 0.005;
    var d = Infinity;
    var prev;
    var next;
    var d1;
    var d2;
    $3dec70ca5f6b6e8f$var$_v0[0] = x;
    $3dec70ca5f6b6e8f$var$_v0[1] = y;
    for(var _t = 0; _t < 1; _t += 0.05){
        $3dec70ca5f6b6e8f$var$_v1[0] = $3dec70ca5f6b6e8f$export$547c21de482bbcb2(x0, x1, x2, x3, _t);
        $3dec70ca5f6b6e8f$var$_v1[1] = $3dec70ca5f6b6e8f$export$547c21de482bbcb2(y0, y1, y2, y3, _t);
        d1 = (0, $ee491d8f32bd01ff$export$c68db45a034c13b0)($3dec70ca5f6b6e8f$var$_v0, $3dec70ca5f6b6e8f$var$_v1);
        if (d1 < d) {
            t = _t;
            d = d1;
        }
    }
    d = Infinity;
    for(var i = 0; i < 32; i++){
        if (interval < $3dec70ca5f6b6e8f$var$EPSILON_NUMERIC) break;
        prev = t - interval;
        next = t + interval;
        $3dec70ca5f6b6e8f$var$_v1[0] = $3dec70ca5f6b6e8f$export$547c21de482bbcb2(x0, x1, x2, x3, prev);
        $3dec70ca5f6b6e8f$var$_v1[1] = $3dec70ca5f6b6e8f$export$547c21de482bbcb2(y0, y1, y2, y3, prev);
        d1 = (0, $ee491d8f32bd01ff$export$c68db45a034c13b0)($3dec70ca5f6b6e8f$var$_v1, $3dec70ca5f6b6e8f$var$_v0);
        if (prev >= 0 && d1 < d) {
            t = prev;
            d = d1;
        } else {
            $3dec70ca5f6b6e8f$var$_v2[0] = $3dec70ca5f6b6e8f$export$547c21de482bbcb2(x0, x1, x2, x3, next);
            $3dec70ca5f6b6e8f$var$_v2[1] = $3dec70ca5f6b6e8f$export$547c21de482bbcb2(y0, y1, y2, y3, next);
            d2 = (0, $ee491d8f32bd01ff$export$c68db45a034c13b0)($3dec70ca5f6b6e8f$var$_v2, $3dec70ca5f6b6e8f$var$_v0);
            if (next <= 1 && d2 < d) {
                t = next;
                d = d2;
            } else interval *= 0.5;
        }
    }
    if (out) {
        out[0] = $3dec70ca5f6b6e8f$export$547c21de482bbcb2(x0, x1, x2, x3, t);
        out[1] = $3dec70ca5f6b6e8f$export$547c21de482bbcb2(y0, y1, y2, y3, t);
    }
    return $3dec70ca5f6b6e8f$var$mathSqrt(d);
}
function $3dec70ca5f6b6e8f$export$af1875d576f60d7c(x0, y0, x1, y1, x2, y2, x3, y3, iteration) {
    var px = x0;
    var py = y0;
    var d = 0;
    var step = 1 / iteration;
    for(var i = 1; i <= iteration; i++){
        var t = i * step;
        var x = $3dec70ca5f6b6e8f$export$547c21de482bbcb2(x0, x1, x2, x3, t);
        var y = $3dec70ca5f6b6e8f$export$547c21de482bbcb2(y0, y1, y2, y3, t);
        var dx = x - px;
        var dy = y - py;
        d += Math.sqrt(dx * dx + dy * dy);
        px = x;
        py = y;
    }
    return d;
}
function $3dec70ca5f6b6e8f$export$af17094a950f5073(p0, p1, p2, t) {
    var onet = 1 - t;
    return onet * (onet * p0 + 2 * t * p1) + t * t * p2;
}
function $3dec70ca5f6b6e8f$export$7e161e77e6fff8cb(p0, p1, p2, t) {
    return 2 * ((1 - t) * (p1 - p0) + t * (p2 - p1));
}
function $3dec70ca5f6b6e8f$export$fd895ac7ee764967(p0, p1, p2, val, roots) {
    var a = p0 - 2 * p1 + p2;
    var b = 2 * (p1 - p0);
    var c = p0 - val;
    var n = 0;
    if ($3dec70ca5f6b6e8f$var$isAroundZero(a)) {
        if ($3dec70ca5f6b6e8f$var$isNotAroundZero(b)) {
            var t1 = -c / b;
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        }
    } else {
        var disc = b * b - 4 * a * c;
        if ($3dec70ca5f6b6e8f$var$isAroundZero(disc)) {
            var t1 = -b / (2 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        } else if (disc > 0) {
            var discSqrt = $3dec70ca5f6b6e8f$var$mathSqrt(disc);
            var t1 = (-b + discSqrt) / (2 * a);
            var t2 = (-b - discSqrt) / (2 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
            if (t2 >= 0 && t2 <= 1) roots[n++] = t2;
        }
    }
    return n;
}
function $3dec70ca5f6b6e8f$export$752e1f8c6e7f7e11(p0, p1, p2) {
    var divider = p0 + p2 - 2 * p1;
    if (divider === 0) return 0.5;
    else return (p0 - p1) / divider;
}
function $3dec70ca5f6b6e8f$export$117c659e21a7a060(p0, p1, p2, t, out) {
    var p01 = (p1 - p0) * t + p0;
    var p12 = (p2 - p1) * t + p1;
    var p012 = (p12 - p01) * t + p01;
    out[0] = p0;
    out[1] = p01;
    out[2] = p012;
    out[3] = p012;
    out[4] = p12;
    out[5] = p2;
}
function $3dec70ca5f6b6e8f$export$81915a594fe10dee(x0, y0, x1, y1, x2, y2, x, y, out) {
    var t;
    var interval = 0.005;
    var d = Infinity;
    $3dec70ca5f6b6e8f$var$_v0[0] = x;
    $3dec70ca5f6b6e8f$var$_v0[1] = y;
    for(var _t = 0; _t < 1; _t += 0.05){
        $3dec70ca5f6b6e8f$var$_v1[0] = $3dec70ca5f6b6e8f$export$af17094a950f5073(x0, x1, x2, _t);
        $3dec70ca5f6b6e8f$var$_v1[1] = $3dec70ca5f6b6e8f$export$af17094a950f5073(y0, y1, y2, _t);
        var d1 = (0, $ee491d8f32bd01ff$export$c68db45a034c13b0)($3dec70ca5f6b6e8f$var$_v0, $3dec70ca5f6b6e8f$var$_v1);
        if (d1 < d) {
            t = _t;
            d = d1;
        }
    }
    d = Infinity;
    for(var i = 0; i < 32; i++){
        if (interval < $3dec70ca5f6b6e8f$var$EPSILON_NUMERIC) break;
        var prev = t - interval;
        var next = t + interval;
        $3dec70ca5f6b6e8f$var$_v1[0] = $3dec70ca5f6b6e8f$export$af17094a950f5073(x0, x1, x2, prev);
        $3dec70ca5f6b6e8f$var$_v1[1] = $3dec70ca5f6b6e8f$export$af17094a950f5073(y0, y1, y2, prev);
        var d1 = (0, $ee491d8f32bd01ff$export$c68db45a034c13b0)($3dec70ca5f6b6e8f$var$_v1, $3dec70ca5f6b6e8f$var$_v0);
        if (prev >= 0 && d1 < d) {
            t = prev;
            d = d1;
        } else {
            $3dec70ca5f6b6e8f$var$_v2[0] = $3dec70ca5f6b6e8f$export$af17094a950f5073(x0, x1, x2, next);
            $3dec70ca5f6b6e8f$var$_v2[1] = $3dec70ca5f6b6e8f$export$af17094a950f5073(y0, y1, y2, next);
            var d2 = (0, $ee491d8f32bd01ff$export$c68db45a034c13b0)($3dec70ca5f6b6e8f$var$_v2, $3dec70ca5f6b6e8f$var$_v0);
            if (next <= 1 && d2 < d) {
                t = next;
                d = d2;
            } else interval *= 0.5;
        }
    }
    if (out) {
        out[0] = $3dec70ca5f6b6e8f$export$af17094a950f5073(x0, x1, x2, t);
        out[1] = $3dec70ca5f6b6e8f$export$af17094a950f5073(y0, y1, y2, t);
    }
    return $3dec70ca5f6b6e8f$var$mathSqrt(d);
}
function $3dec70ca5f6b6e8f$export$8a68adee46f3cf55(x0, y0, x1, y1, x2, y2, iteration) {
    var px = x0;
    var py = y0;
    var d = 0;
    var step = 1 / iteration;
    for(var i = 1; i <= iteration; i++){
        var t = i * step;
        var x = $3dec70ca5f6b6e8f$export$af17094a950f5073(x0, x1, x2, t);
        var y = $3dec70ca5f6b6e8f$export$af17094a950f5073(y0, y1, y2, t);
        var dx = x - px;
        var dy = y - py;
        d += Math.sqrt(dx * dx + dy * dy);
        px = x;
        py = y;
    }
    return d;
}



var $739b4fcf1779451b$var$regexp = /cubic-bezier\(([0-9,\.e ]+)\)/;
function $739b4fcf1779451b$export$ec0863d806fd857e(cubicEasingStr) {
    var cubic = cubicEasingStr && $739b4fcf1779451b$var$regexp.exec(cubicEasingStr);
    if (cubic) {
        var points = cubic[1].split(",");
        var a_1 = +(0, $43e0a445ed6711da$export$87c2784dc9fc4ab)(points[0]);
        var b_1 = +(0, $43e0a445ed6711da$export$87c2784dc9fc4ab)(points[1]);
        var c_1 = +(0, $43e0a445ed6711da$export$87c2784dc9fc4ab)(points[2]);
        var d_1 = +(0, $43e0a445ed6711da$export$87c2784dc9fc4ab)(points[3]);
        if (isNaN(a_1 + b_1 + c_1 + d_1)) return;
        var roots_1 = [];
        return function(p) {
            return p <= 0 ? 0 : p >= 1 ? 1 : (0, $3dec70ca5f6b6e8f$export$ca5d13faa10b167e)(0, a_1, c_1, 1, p, roots_1) && (0, $3dec70ca5f6b6e8f$export$547c21de482bbcb2)(0, b_1, d_1, 1, roots_1[0]);
        };
    }
}


var $8b6f1ad92f8c8456$var$Clip = function() {
    function Clip(opts) {
        this._inited = false;
        this._startTime = 0;
        this._pausedTime = 0;
        this._paused = false;
        this._life = opts.life || 1000;
        this._delay = opts.delay || 0;
        this.loop = opts.loop || false;
        this.onframe = opts.onframe || (0, $43e0a445ed6711da$export$8793edee2d425525);
        this.ondestroy = opts.ondestroy || (0, $43e0a445ed6711da$export$8793edee2d425525);
        this.onrestart = opts.onrestart || (0, $43e0a445ed6711da$export$8793edee2d425525);
        opts.easing && this.setEasing(opts.easing);
    }
    Clip.prototype.step = function(globalTime, deltaTime) {
        if (!this._inited) {
            this._startTime = globalTime + this._delay;
            this._inited = true;
        }
        if (this._paused) {
            this._pausedTime += deltaTime;
            return;
        }
        var life = this._life;
        var elapsedTime = globalTime - this._startTime - this._pausedTime;
        var percent = elapsedTime / life;
        if (percent < 0) percent = 0;
        percent = Math.min(percent, 1);
        var easingFunc = this.easingFunc;
        var schedule = easingFunc ? easingFunc(percent) : percent;
        this.onframe(schedule);
        if (percent === 1) {
            if (this.loop) {
                var remainder = elapsedTime % life;
                this._startTime = globalTime - remainder;
                this._pausedTime = 0;
                this.onrestart();
            } else return true;
        }
        return false;
    };
    Clip.prototype.pause = function() {
        this._paused = true;
    };
    Clip.prototype.resume = function() {
        this._paused = false;
    };
    Clip.prototype.setEasing = function(easing) {
        this.easing = easing;
        this.easingFunc = (0, $43e0a445ed6711da$export$f6e2535fb5126e54)(easing) ? easing : (0, $5c8efb9bac6f133e$export$2e2bcd8739ae039)[easing] || (0, $739b4fcf1779451b$export$ec0863d806fd857e)(easing);
    };
    return Clip;
}();
var $8b6f1ad92f8c8456$export$2e2bcd8739ae039 = $8b6f1ad92f8c8456$var$Clip;


var $b0979f18b0a232f9$exports = {};

$parcel$export($b0979f18b0a232f9$exports, "parseCssInt", function () { return $b0979f18b0a232f9$export$e6be818e738239a; });
$parcel$export($b0979f18b0a232f9$exports, "parseCssFloat", function () { return $b0979f18b0a232f9$export$7638a67891c3b497; });
$parcel$export($b0979f18b0a232f9$exports, "parse", function () { return $b0979f18b0a232f9$export$98e6a39c04603d36; });
$parcel$export($b0979f18b0a232f9$exports, "lift", function () { return $b0979f18b0a232f9$export$590e8b2c435046d9; });
$parcel$export($b0979f18b0a232f9$exports, "stringify", function () { return $b0979f18b0a232f9$export$fac44ee5b035f737; });
$parcel$export($b0979f18b0a232f9$exports, "toHex", function () { return $b0979f18b0a232f9$export$7ea66e3774a60b67; });
$parcel$export($b0979f18b0a232f9$exports, "fastLerp", function () { return $b0979f18b0a232f9$export$66cb3c0e9efc61c8; });
$parcel$export($b0979f18b0a232f9$exports, "fastMapToColor", function () { return $b0979f18b0a232f9$export$daa5a65daad5df58; });
$parcel$export($b0979f18b0a232f9$exports, "lerp", function () { return $b0979f18b0a232f9$export$3a89f8d6f6bf6c9f; });
$parcel$export($b0979f18b0a232f9$exports, "mapToColor", function () { return $b0979f18b0a232f9$export$296e08242b78a3ec; });
$parcel$export($b0979f18b0a232f9$exports, "modifyHSL", function () { return $b0979f18b0a232f9$export$d898ae866e27bf18; });
$parcel$export($b0979f18b0a232f9$exports, "modifyAlpha", function () { return $b0979f18b0a232f9$export$ab4754bf42583a26; });
$parcel$export($b0979f18b0a232f9$exports, "lum", function () { return $b0979f18b0a232f9$export$16c0ec21a6f9ef95; });
$parcel$export($b0979f18b0a232f9$exports, "random", function () { return $b0979f18b0a232f9$export$4385e60b38654f68; });
$parcel$export($b0979f18b0a232f9$exports, "liftColor", function () { return $b0979f18b0a232f9$export$2b47e247dfb87a73; });
var $0a70a3b1dc4cb6e5$export$3bb977b3ba9d3b59 = function() {
    function Entry(val) {
        this.value = val;
    }
    return Entry;
}();
var $0a70a3b1dc4cb6e5$export$f0ef28713f767754 = function() {
    function LinkedList() {
        this._len = 0;
    }
    LinkedList.prototype.insert = function(val) {
        var entry = new $0a70a3b1dc4cb6e5$export$3bb977b3ba9d3b59(val);
        this.insertEntry(entry);
        return entry;
    };
    LinkedList.prototype.insertEntry = function(entry) {
        if (!this.head) this.head = this.tail = entry;
        else {
            this.tail.next = entry;
            entry.prev = this.tail;
            entry.next = null;
            this.tail = entry;
        }
        this._len++;
    };
    LinkedList.prototype.remove = function(entry) {
        var prev = entry.prev;
        var next = entry.next;
        if (prev) prev.next = next;
        else this.head = next;
        if (next) next.prev = prev;
        else this.tail = prev;
        entry.next = entry.prev = null;
        this._len--;
    };
    LinkedList.prototype.len = function() {
        return this._len;
    };
    LinkedList.prototype.clear = function() {
        this.head = this.tail = null;
        this._len = 0;
    };
    return LinkedList;
}();
var $0a70a3b1dc4cb6e5$var$LRU = function() {
    function LRU(maxSize) {
        this._list = new $0a70a3b1dc4cb6e5$export$f0ef28713f767754();
        this._maxSize = 10;
        this._map = {};
        this._maxSize = maxSize;
    }
    LRU.prototype.put = function(key, value) {
        var list = this._list;
        var map = this._map;
        var removed = null;
        if (map[key] == null) {
            var len = list.len();
            var entry = this._lastRemovedEntry;
            if (len >= this._maxSize && len > 0) {
                var leastUsedEntry = list.head;
                list.remove(leastUsedEntry);
                delete map[leastUsedEntry.key];
                removed = leastUsedEntry.value;
                this._lastRemovedEntry = leastUsedEntry;
            }
            if (entry) entry.value = value;
            else entry = new $0a70a3b1dc4cb6e5$export$3bb977b3ba9d3b59(value);
            entry.key = key;
            list.insertEntry(entry);
            map[key] = entry;
        }
        return removed;
    };
    LRU.prototype.get = function(key) {
        var entry = this._map[key];
        var list = this._list;
        if (entry != null) {
            if (entry !== list.tail) {
                list.remove(entry);
                list.insertEntry(entry);
            }
            return entry.value;
        }
    };
    LRU.prototype.clear = function() {
        this._list.clear();
        this._map = {};
    };
    LRU.prototype.len = function() {
        return this._list.len();
    };
    return LRU;
}();
var $0a70a3b1dc4cb6e5$export$2e2bcd8739ae039 = $0a70a3b1dc4cb6e5$var$LRU;



var $b0979f18b0a232f9$var$kCSSColorTable = {
    "transparent": [
        0,
        0,
        0,
        0
    ],
    "aliceblue": [
        240,
        248,
        255,
        1
    ],
    "antiquewhite": [
        250,
        235,
        215,
        1
    ],
    "aqua": [
        0,
        255,
        255,
        1
    ],
    "aquamarine": [
        127,
        255,
        212,
        1
    ],
    "azure": [
        240,
        255,
        255,
        1
    ],
    "beige": [
        245,
        245,
        220,
        1
    ],
    "bisque": [
        255,
        228,
        196,
        1
    ],
    "black": [
        0,
        0,
        0,
        1
    ],
    "blanchedalmond": [
        255,
        235,
        205,
        1
    ],
    "blue": [
        0,
        0,
        255,
        1
    ],
    "blueviolet": [
        138,
        43,
        226,
        1
    ],
    "brown": [
        165,
        42,
        42,
        1
    ],
    "burlywood": [
        222,
        184,
        135,
        1
    ],
    "cadetblue": [
        95,
        158,
        160,
        1
    ],
    "chartreuse": [
        127,
        255,
        0,
        1
    ],
    "chocolate": [
        210,
        105,
        30,
        1
    ],
    "coral": [
        255,
        127,
        80,
        1
    ],
    "cornflowerblue": [
        100,
        149,
        237,
        1
    ],
    "cornsilk": [
        255,
        248,
        220,
        1
    ],
    "crimson": [
        220,
        20,
        60,
        1
    ],
    "cyan": [
        0,
        255,
        255,
        1
    ],
    "darkblue": [
        0,
        0,
        139,
        1
    ],
    "darkcyan": [
        0,
        139,
        139,
        1
    ],
    "darkgoldenrod": [
        184,
        134,
        11,
        1
    ],
    "darkgray": [
        169,
        169,
        169,
        1
    ],
    "darkgreen": [
        0,
        100,
        0,
        1
    ],
    "darkgrey": [
        169,
        169,
        169,
        1
    ],
    "darkkhaki": [
        189,
        183,
        107,
        1
    ],
    "darkmagenta": [
        139,
        0,
        139,
        1
    ],
    "darkolivegreen": [
        85,
        107,
        47,
        1
    ],
    "darkorange": [
        255,
        140,
        0,
        1
    ],
    "darkorchid": [
        153,
        50,
        204,
        1
    ],
    "darkred": [
        139,
        0,
        0,
        1
    ],
    "darksalmon": [
        233,
        150,
        122,
        1
    ],
    "darkseagreen": [
        143,
        188,
        143,
        1
    ],
    "darkslateblue": [
        72,
        61,
        139,
        1
    ],
    "darkslategray": [
        47,
        79,
        79,
        1
    ],
    "darkslategrey": [
        47,
        79,
        79,
        1
    ],
    "darkturquoise": [
        0,
        206,
        209,
        1
    ],
    "darkviolet": [
        148,
        0,
        211,
        1
    ],
    "deeppink": [
        255,
        20,
        147,
        1
    ],
    "deepskyblue": [
        0,
        191,
        255,
        1
    ],
    "dimgray": [
        105,
        105,
        105,
        1
    ],
    "dimgrey": [
        105,
        105,
        105,
        1
    ],
    "dodgerblue": [
        30,
        144,
        255,
        1
    ],
    "firebrick": [
        178,
        34,
        34,
        1
    ],
    "floralwhite": [
        255,
        250,
        240,
        1
    ],
    "forestgreen": [
        34,
        139,
        34,
        1
    ],
    "fuchsia": [
        255,
        0,
        255,
        1
    ],
    "gainsboro": [
        220,
        220,
        220,
        1
    ],
    "ghostwhite": [
        248,
        248,
        255,
        1
    ],
    "gold": [
        255,
        215,
        0,
        1
    ],
    "goldenrod": [
        218,
        165,
        32,
        1
    ],
    "gray": [
        128,
        128,
        128,
        1
    ],
    "green": [
        0,
        128,
        0,
        1
    ],
    "greenyellow": [
        173,
        255,
        47,
        1
    ],
    "grey": [
        128,
        128,
        128,
        1
    ],
    "honeydew": [
        240,
        255,
        240,
        1
    ],
    "hotpink": [
        255,
        105,
        180,
        1
    ],
    "indianred": [
        205,
        92,
        92,
        1
    ],
    "indigo": [
        75,
        0,
        130,
        1
    ],
    "ivory": [
        255,
        255,
        240,
        1
    ],
    "khaki": [
        240,
        230,
        140,
        1
    ],
    "lavender": [
        230,
        230,
        250,
        1
    ],
    "lavenderblush": [
        255,
        240,
        245,
        1
    ],
    "lawngreen": [
        124,
        252,
        0,
        1
    ],
    "lemonchiffon": [
        255,
        250,
        205,
        1
    ],
    "lightblue": [
        173,
        216,
        230,
        1
    ],
    "lightcoral": [
        240,
        128,
        128,
        1
    ],
    "lightcyan": [
        224,
        255,
        255,
        1
    ],
    "lightgoldenrodyellow": [
        250,
        250,
        210,
        1
    ],
    "lightgray": [
        211,
        211,
        211,
        1
    ],
    "lightgreen": [
        144,
        238,
        144,
        1
    ],
    "lightgrey": [
        211,
        211,
        211,
        1
    ],
    "lightpink": [
        255,
        182,
        193,
        1
    ],
    "lightsalmon": [
        255,
        160,
        122,
        1
    ],
    "lightseagreen": [
        32,
        178,
        170,
        1
    ],
    "lightskyblue": [
        135,
        206,
        250,
        1
    ],
    "lightslategray": [
        119,
        136,
        153,
        1
    ],
    "lightslategrey": [
        119,
        136,
        153,
        1
    ],
    "lightsteelblue": [
        176,
        196,
        222,
        1
    ],
    "lightyellow": [
        255,
        255,
        224,
        1
    ],
    "lime": [
        0,
        255,
        0,
        1
    ],
    "limegreen": [
        50,
        205,
        50,
        1
    ],
    "linen": [
        250,
        240,
        230,
        1
    ],
    "magenta": [
        255,
        0,
        255,
        1
    ],
    "maroon": [
        128,
        0,
        0,
        1
    ],
    "mediumaquamarine": [
        102,
        205,
        170,
        1
    ],
    "mediumblue": [
        0,
        0,
        205,
        1
    ],
    "mediumorchid": [
        186,
        85,
        211,
        1
    ],
    "mediumpurple": [
        147,
        112,
        219,
        1
    ],
    "mediumseagreen": [
        60,
        179,
        113,
        1
    ],
    "mediumslateblue": [
        123,
        104,
        238,
        1
    ],
    "mediumspringgreen": [
        0,
        250,
        154,
        1
    ],
    "mediumturquoise": [
        72,
        209,
        204,
        1
    ],
    "mediumvioletred": [
        199,
        21,
        133,
        1
    ],
    "midnightblue": [
        25,
        25,
        112,
        1
    ],
    "mintcream": [
        245,
        255,
        250,
        1
    ],
    "mistyrose": [
        255,
        228,
        225,
        1
    ],
    "moccasin": [
        255,
        228,
        181,
        1
    ],
    "navajowhite": [
        255,
        222,
        173,
        1
    ],
    "navy": [
        0,
        0,
        128,
        1
    ],
    "oldlace": [
        253,
        245,
        230,
        1
    ],
    "olive": [
        128,
        128,
        0,
        1
    ],
    "olivedrab": [
        107,
        142,
        35,
        1
    ],
    "orange": [
        255,
        165,
        0,
        1
    ],
    "orangered": [
        255,
        69,
        0,
        1
    ],
    "orchid": [
        218,
        112,
        214,
        1
    ],
    "palegoldenrod": [
        238,
        232,
        170,
        1
    ],
    "palegreen": [
        152,
        251,
        152,
        1
    ],
    "paleturquoise": [
        175,
        238,
        238,
        1
    ],
    "palevioletred": [
        219,
        112,
        147,
        1
    ],
    "papayawhip": [
        255,
        239,
        213,
        1
    ],
    "peachpuff": [
        255,
        218,
        185,
        1
    ],
    "peru": [
        205,
        133,
        63,
        1
    ],
    "pink": [
        255,
        192,
        203,
        1
    ],
    "plum": [
        221,
        160,
        221,
        1
    ],
    "powderblue": [
        176,
        224,
        230,
        1
    ],
    "purple": [
        128,
        0,
        128,
        1
    ],
    "red": [
        255,
        0,
        0,
        1
    ],
    "rosybrown": [
        188,
        143,
        143,
        1
    ],
    "royalblue": [
        65,
        105,
        225,
        1
    ],
    "saddlebrown": [
        139,
        69,
        19,
        1
    ],
    "salmon": [
        250,
        128,
        114,
        1
    ],
    "sandybrown": [
        244,
        164,
        96,
        1
    ],
    "seagreen": [
        46,
        139,
        87,
        1
    ],
    "seashell": [
        255,
        245,
        238,
        1
    ],
    "sienna": [
        160,
        82,
        45,
        1
    ],
    "silver": [
        192,
        192,
        192,
        1
    ],
    "skyblue": [
        135,
        206,
        235,
        1
    ],
    "slateblue": [
        106,
        90,
        205,
        1
    ],
    "slategray": [
        112,
        128,
        144,
        1
    ],
    "slategrey": [
        112,
        128,
        144,
        1
    ],
    "snow": [
        255,
        250,
        250,
        1
    ],
    "springgreen": [
        0,
        255,
        127,
        1
    ],
    "steelblue": [
        70,
        130,
        180,
        1
    ],
    "tan": [
        210,
        180,
        140,
        1
    ],
    "teal": [
        0,
        128,
        128,
        1
    ],
    "thistle": [
        216,
        191,
        216,
        1
    ],
    "tomato": [
        255,
        99,
        71,
        1
    ],
    "turquoise": [
        64,
        224,
        208,
        1
    ],
    "violet": [
        238,
        130,
        238,
        1
    ],
    "wheat": [
        245,
        222,
        179,
        1
    ],
    "white": [
        255,
        255,
        255,
        1
    ],
    "whitesmoke": [
        245,
        245,
        245,
        1
    ],
    "yellow": [
        255,
        255,
        0,
        1
    ],
    "yellowgreen": [
        154,
        205,
        50,
        1
    ]
};
function $b0979f18b0a232f9$var$clampCssByte(i) {
    i = Math.round(i);
    return i < 0 ? 0 : i > 255 ? 255 : i;
}
function $b0979f18b0a232f9$var$clampCssAngle(i) {
    i = Math.round(i);
    return i < 0 ? 0 : i > 360 ? 360 : i;
}
function $b0979f18b0a232f9$var$clampCssFloat(f) {
    return f < 0 ? 0 : f > 1 ? 1 : f;
}
function $b0979f18b0a232f9$export$e6be818e738239a(val) {
    var str = val;
    if (str.length && str.charAt(str.length - 1) === "%") return $b0979f18b0a232f9$var$clampCssByte(parseFloat(str) / 100 * 255);
    return $b0979f18b0a232f9$var$clampCssByte(parseInt(str, 10));
}
function $b0979f18b0a232f9$export$7638a67891c3b497(val) {
    var str = val;
    if (str.length && str.charAt(str.length - 1) === "%") return $b0979f18b0a232f9$var$clampCssFloat(parseFloat(str) / 100);
    return $b0979f18b0a232f9$var$clampCssFloat(parseFloat(str));
}
function $b0979f18b0a232f9$var$cssHueToRgb(m1, m2, h) {
    if (h < 0) h += 1;
    else if (h > 1) h -= 1;
    if (h * 6 < 1) return m1 + (m2 - m1) * h * 6;
    if (h * 2 < 1) return m2;
    if (h * 3 < 2) return m1 + (m2 - m1) * (2 / 3 - h) * 6;
    return m1;
}
function $b0979f18b0a232f9$var$lerpNumber(a, b, p) {
    return a + (b - a) * p;
}
function $b0979f18b0a232f9$var$setRgba(out, r, g, b, a) {
    out[0] = r;
    out[1] = g;
    out[2] = b;
    out[3] = a;
    return out;
}
function $b0979f18b0a232f9$var$copyRgba(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
}
var $b0979f18b0a232f9$var$colorCache = new (0, $0a70a3b1dc4cb6e5$export$2e2bcd8739ae039)(20);
var $b0979f18b0a232f9$var$lastRemovedArr = null;
function $b0979f18b0a232f9$var$putToCache(colorStr, rgbaArr) {
    if ($b0979f18b0a232f9$var$lastRemovedArr) $b0979f18b0a232f9$var$copyRgba($b0979f18b0a232f9$var$lastRemovedArr, rgbaArr);
    $b0979f18b0a232f9$var$lastRemovedArr = $b0979f18b0a232f9$var$colorCache.put(colorStr, $b0979f18b0a232f9$var$lastRemovedArr || rgbaArr.slice());
}
function $b0979f18b0a232f9$export$98e6a39c04603d36(colorStr, rgbaArr) {
    if (!colorStr) return;
    rgbaArr = rgbaArr || [];
    var cached = $b0979f18b0a232f9$var$colorCache.get(colorStr);
    if (cached) return $b0979f18b0a232f9$var$copyRgba(rgbaArr, cached);
    colorStr = colorStr + "";
    var str = colorStr.replace(/ /g, "").toLowerCase();
    if (str in $b0979f18b0a232f9$var$kCSSColorTable) {
        $b0979f18b0a232f9$var$copyRgba(rgbaArr, $b0979f18b0a232f9$var$kCSSColorTable[str]);
        $b0979f18b0a232f9$var$putToCache(colorStr, rgbaArr);
        return rgbaArr;
    }
    var strLen = str.length;
    if (str.charAt(0) === "#") {
        if (strLen === 4 || strLen === 5) {
            var iv = parseInt(str.slice(1, 4), 16);
            if (!(iv >= 0 && iv <= 0xfff)) {
                $b0979f18b0a232f9$var$setRgba(rgbaArr, 0, 0, 0, 1);
                return;
            }
            $b0979f18b0a232f9$var$setRgba(rgbaArr, (iv & 0xf00) >> 4 | (iv & 0xf00) >> 8, iv & 0xf0 | (iv & 0xf0) >> 4, iv & 0xf | (iv & 0xf) << 4, strLen === 5 ? parseInt(str.slice(4), 16) / 0xf : 1);
            $b0979f18b0a232f9$var$putToCache(colorStr, rgbaArr);
            return rgbaArr;
        } else if (strLen === 7 || strLen === 9) {
            var iv = parseInt(str.slice(1, 7), 16);
            if (!(iv >= 0 && iv <= 0xffffff)) {
                $b0979f18b0a232f9$var$setRgba(rgbaArr, 0, 0, 0, 1);
                return;
            }
            $b0979f18b0a232f9$var$setRgba(rgbaArr, (iv & 0xff0000) >> 16, (iv & 0xff00) >> 8, iv & 0xff, strLen === 9 ? parseInt(str.slice(7), 16) / 0xff : 1);
            $b0979f18b0a232f9$var$putToCache(colorStr, rgbaArr);
            return rgbaArr;
        }
        return;
    }
    var op = str.indexOf("(");
    var ep = str.indexOf(")");
    if (op !== -1 && ep + 1 === strLen) {
        var fname = str.substr(0, op);
        var params = str.substr(op + 1, ep - (op + 1)).split(",");
        var alpha = 1;
        switch(fname){
            case "rgba":
                if (params.length !== 4) return params.length === 3 ? $b0979f18b0a232f9$var$setRgba(rgbaArr, +params[0], +params[1], +params[2], 1) : $b0979f18b0a232f9$var$setRgba(rgbaArr, 0, 0, 0, 1);
                alpha = $b0979f18b0a232f9$export$7638a67891c3b497(params.pop());
            case "rgb":
                if (params.length >= 3) {
                    $b0979f18b0a232f9$var$setRgba(rgbaArr, $b0979f18b0a232f9$export$e6be818e738239a(params[0]), $b0979f18b0a232f9$export$e6be818e738239a(params[1]), $b0979f18b0a232f9$export$e6be818e738239a(params[2]), params.length === 3 ? alpha : $b0979f18b0a232f9$export$7638a67891c3b497(params[3]));
                    $b0979f18b0a232f9$var$putToCache(colorStr, rgbaArr);
                    return rgbaArr;
                } else {
                    $b0979f18b0a232f9$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
            case "hsla":
                if (params.length !== 4) {
                    $b0979f18b0a232f9$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
                params[3] = $b0979f18b0a232f9$export$7638a67891c3b497(params[3]);
                $b0979f18b0a232f9$var$hsla2rgba(params, rgbaArr);
                $b0979f18b0a232f9$var$putToCache(colorStr, rgbaArr);
                return rgbaArr;
            case "hsl":
                if (params.length !== 3) {
                    $b0979f18b0a232f9$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
                $b0979f18b0a232f9$var$hsla2rgba(params, rgbaArr);
                $b0979f18b0a232f9$var$putToCache(colorStr, rgbaArr);
                return rgbaArr;
            default:
                return;
        }
    }
    $b0979f18b0a232f9$var$setRgba(rgbaArr, 0, 0, 0, 1);
    return;
}
function $b0979f18b0a232f9$var$hsla2rgba(hsla, rgba) {
    var h = (parseFloat(hsla[0]) % 360 + 360) % 360 / 360;
    var s = $b0979f18b0a232f9$export$7638a67891c3b497(hsla[1]);
    var l = $b0979f18b0a232f9$export$7638a67891c3b497(hsla[2]);
    var m2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
    var m1 = l * 2 - m2;
    rgba = rgba || [];
    $b0979f18b0a232f9$var$setRgba(rgba, $b0979f18b0a232f9$var$clampCssByte($b0979f18b0a232f9$var$cssHueToRgb(m1, m2, h + 1 / 3) * 255), $b0979f18b0a232f9$var$clampCssByte($b0979f18b0a232f9$var$cssHueToRgb(m1, m2, h) * 255), $b0979f18b0a232f9$var$clampCssByte($b0979f18b0a232f9$var$cssHueToRgb(m1, m2, h - 1 / 3) * 255), 1);
    if (hsla.length === 4) rgba[3] = hsla[3];
    return rgba;
}
function $b0979f18b0a232f9$var$rgba2hsla(rgba) {
    if (!rgba) return;
    var R = rgba[0] / 255;
    var G = rgba[1] / 255;
    var B = rgba[2] / 255;
    var vMin = Math.min(R, G, B);
    var vMax = Math.max(R, G, B);
    var delta = vMax - vMin;
    var L = (vMax + vMin) / 2;
    var H;
    var S;
    if (delta === 0) {
        H = 0;
        S = 0;
    } else {
        if (L < 0.5) S = delta / (vMax + vMin);
        else S = delta / (2 - vMax - vMin);
        var deltaR = ((vMax - R) / 6 + delta / 2) / delta;
        var deltaG = ((vMax - G) / 6 + delta / 2) / delta;
        var deltaB = ((vMax - B) / 6 + delta / 2) / delta;
        if (R === vMax) H = deltaB - deltaG;
        else if (G === vMax) H = 1 / 3 + deltaR - deltaB;
        else if (B === vMax) H = 2 / 3 + deltaG - deltaR;
        if (H < 0) H += 1;
        if (H > 1) H -= 1;
    }
    var hsla = [
        H * 360,
        S,
        L
    ];
    if (rgba[3] != null) hsla.push(rgba[3]);
    return hsla;
}
function $b0979f18b0a232f9$export$590e8b2c435046d9(color, level) {
    var colorArr = $b0979f18b0a232f9$export$98e6a39c04603d36(color);
    if (colorArr) {
        for(var i = 0; i < 3; i++){
            if (level < 0) colorArr[i] = colorArr[i] * (1 - level) | 0;
            else colorArr[i] = (255 - colorArr[i]) * level + colorArr[i] | 0;
            if (colorArr[i] > 255) colorArr[i] = 255;
            else if (colorArr[i] < 0) colorArr[i] = 0;
        }
        return $b0979f18b0a232f9$export$fac44ee5b035f737(colorArr, colorArr.length === 4 ? "rgba" : "rgb");
    }
}
function $b0979f18b0a232f9$export$7ea66e3774a60b67(color) {
    var colorArr = $b0979f18b0a232f9$export$98e6a39c04603d36(color);
    if (colorArr) return (16777216 + (colorArr[0] << 16) + (colorArr[1] << 8) + +colorArr[2]).toString(16).slice(1);
}
function $b0979f18b0a232f9$export$66cb3c0e9efc61c8(normalizedValue, colors, out) {
    if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) return;
    out = out || [];
    var value = normalizedValue * (colors.length - 1);
    var leftIndex = Math.floor(value);
    var rightIndex = Math.ceil(value);
    var leftColor = colors[leftIndex];
    var rightColor = colors[rightIndex];
    var dv = value - leftIndex;
    out[0] = $b0979f18b0a232f9$var$clampCssByte($b0979f18b0a232f9$var$lerpNumber(leftColor[0], rightColor[0], dv));
    out[1] = $b0979f18b0a232f9$var$clampCssByte($b0979f18b0a232f9$var$lerpNumber(leftColor[1], rightColor[1], dv));
    out[2] = $b0979f18b0a232f9$var$clampCssByte($b0979f18b0a232f9$var$lerpNumber(leftColor[2], rightColor[2], dv));
    out[3] = $b0979f18b0a232f9$var$clampCssFloat($b0979f18b0a232f9$var$lerpNumber(leftColor[3], rightColor[3], dv));
    return out;
}
var $b0979f18b0a232f9$export$daa5a65daad5df58 = $b0979f18b0a232f9$export$66cb3c0e9efc61c8;
function $b0979f18b0a232f9$export$3a89f8d6f6bf6c9f(normalizedValue, colors, fullOutput) {
    if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) return;
    var value = normalizedValue * (colors.length - 1);
    var leftIndex = Math.floor(value);
    var rightIndex = Math.ceil(value);
    var leftColor = $b0979f18b0a232f9$export$98e6a39c04603d36(colors[leftIndex]);
    var rightColor = $b0979f18b0a232f9$export$98e6a39c04603d36(colors[rightIndex]);
    var dv = value - leftIndex;
    var color = $b0979f18b0a232f9$export$fac44ee5b035f737([
        $b0979f18b0a232f9$var$clampCssByte($b0979f18b0a232f9$var$lerpNumber(leftColor[0], rightColor[0], dv)),
        $b0979f18b0a232f9$var$clampCssByte($b0979f18b0a232f9$var$lerpNumber(leftColor[1], rightColor[1], dv)),
        $b0979f18b0a232f9$var$clampCssByte($b0979f18b0a232f9$var$lerpNumber(leftColor[2], rightColor[2], dv)),
        $b0979f18b0a232f9$var$clampCssFloat($b0979f18b0a232f9$var$lerpNumber(leftColor[3], rightColor[3], dv))
    ], "rgba");
    return fullOutput ? {
        color: color,
        leftIndex: leftIndex,
        rightIndex: rightIndex,
        value: value
    } : color;
}
var $b0979f18b0a232f9$export$296e08242b78a3ec = $b0979f18b0a232f9$export$3a89f8d6f6bf6c9f;
function $b0979f18b0a232f9$export$d898ae866e27bf18(color, h, s, l) {
    var colorArr = $b0979f18b0a232f9$export$98e6a39c04603d36(color);
    if (color) {
        colorArr = $b0979f18b0a232f9$var$rgba2hsla(colorArr);
        h != null && (colorArr[0] = $b0979f18b0a232f9$var$clampCssAngle((0, $43e0a445ed6711da$export$f6e2535fb5126e54)(h) ? h(colorArr[0]) : h));
        s != null && (colorArr[1] = $b0979f18b0a232f9$export$7638a67891c3b497((0, $43e0a445ed6711da$export$f6e2535fb5126e54)(s) ? s(colorArr[1]) : s));
        l != null && (colorArr[2] = $b0979f18b0a232f9$export$7638a67891c3b497((0, $43e0a445ed6711da$export$f6e2535fb5126e54)(l) ? l(colorArr[2]) : l));
        return $b0979f18b0a232f9$export$fac44ee5b035f737($b0979f18b0a232f9$var$hsla2rgba(colorArr), "rgba");
    }
}
function $b0979f18b0a232f9$export$ab4754bf42583a26(color, alpha) {
    var colorArr = $b0979f18b0a232f9$export$98e6a39c04603d36(color);
    if (colorArr && alpha != null) {
        colorArr[3] = $b0979f18b0a232f9$var$clampCssFloat(alpha);
        return $b0979f18b0a232f9$export$fac44ee5b035f737(colorArr, "rgba");
    }
}
function $b0979f18b0a232f9$export$fac44ee5b035f737(arrColor, type) {
    if (!arrColor || !arrColor.length) return;
    var colorStr = arrColor[0] + "," + arrColor[1] + "," + arrColor[2];
    if (type === "rgba" || type === "hsva" || type === "hsla") colorStr += "," + arrColor[3];
    return type + "(" + colorStr + ")";
}
function $b0979f18b0a232f9$export$16c0ec21a6f9ef95(color, backgroundLum) {
    var arr = $b0979f18b0a232f9$export$98e6a39c04603d36(color);
    return arr ? (0.299 * arr[0] + 0.587 * arr[1] + 0.114 * arr[2]) * arr[3] / 255 + (1 - arr[3]) * backgroundLum : 0;
}
function $b0979f18b0a232f9$export$4385e60b38654f68() {
    return $b0979f18b0a232f9$export$fac44ee5b035f737([
        Math.round(Math.random() * 255),
        Math.round(Math.random() * 255),
        Math.round(Math.random() * 255)
    ], "rgb");
}
var $b0979f18b0a232f9$var$liftedColorCache = new (0, $0a70a3b1dc4cb6e5$export$2e2bcd8739ae039)(100);
function $b0979f18b0a232f9$export$2b47e247dfb87a73(color) {
    if ((0, $43e0a445ed6711da$export$844ec244b1367d54)(color)) {
        var liftedColor = $b0979f18b0a232f9$var$liftedColorCache.get(color);
        if (!liftedColor) {
            liftedColor = $b0979f18b0a232f9$export$590e8b2c435046d9(color, -0.1);
            $b0979f18b0a232f9$var$liftedColorCache.put(color, liftedColor);
        }
        return liftedColor;
    } else if ((0, $43e0a445ed6711da$export$fa2c283003ed971c)(color)) {
        var ret = (0, $43e0a445ed6711da$export$8b58be045bf06082)({}, color);
        ret.colorStops = (0, $43e0a445ed6711da$export$871de8747c9eaa88)(color.colorStops, function(stop) {
            return {
                offset: stop.offset,
                color: $b0979f18b0a232f9$export$590e8b2c435046d9(stop.color, -0.1)
            };
        });
        return ret;
    }
    return color;
}








var $93054fe26f21d475$require$Buffer = $46b8ab9ed5acde5f$export$a143d493d941bafc;
var $93054fe26f21d475$var$mathRound = Math.round;
function $93054fe26f21d475$export$4cde5df63f53f473(color) {
    var opacity;
    if (!color || color === "transparent") color = "none";
    else if (typeof color === "string" && color.indexOf("rgba") > -1) {
        var arr = (0, $b0979f18b0a232f9$export$98e6a39c04603d36)(color);
        if (arr) {
            color = "rgb(" + arr[0] + "," + arr[1] + "," + arr[2] + ")";
            opacity = arr[3];
        }
    }
    return {
        color: color,
        opacity: opacity == null ? 1 : opacity
    };
}
var $93054fe26f21d475$var$EPSILON = 1e-4;
function $93054fe26f21d475$export$4701367f5b4de464(transform) {
    return transform < $93054fe26f21d475$var$EPSILON && transform > -$93054fe26f21d475$var$EPSILON;
}
function $93054fe26f21d475$export$4b9074ac37ee5a23(transform) {
    return $93054fe26f21d475$var$mathRound(transform * 1e3) / 1e3;
}
function $93054fe26f21d475$export$52bfc6d3e2ff0fc2(transform) {
    return $93054fe26f21d475$var$mathRound(transform * 1e4) / 1e4;
}
function $93054fe26f21d475$export$19676ab5cb1de150(transform) {
    return $93054fe26f21d475$var$mathRound(transform * 10) / 10;
}
function $93054fe26f21d475$export$f29a4456cf56ff21(m) {
    return "matrix(" + $93054fe26f21d475$export$4b9074ac37ee5a23(m[0]) + "," + $93054fe26f21d475$export$4b9074ac37ee5a23(m[1]) + "," + $93054fe26f21d475$export$4b9074ac37ee5a23(m[2]) + "," + $93054fe26f21d475$export$4b9074ac37ee5a23(m[3]) + "," + $93054fe26f21d475$export$52bfc6d3e2ff0fc2(m[4]) + "," + $93054fe26f21d475$export$52bfc6d3e2ff0fc2(m[5]) + ")";
}
var $93054fe26f21d475$export$4062150f0600d971 = {
    left: "start",
    right: "end",
    center: "middle",
    middle: "middle"
};
function $93054fe26f21d475$export$bf7d6802d2badd9(y, lineHeight, textBaseline) {
    if (textBaseline === "top") y += lineHeight / 2;
    else if (textBaseline === "bottom") y -= lineHeight / 2;
    return y;
}
function $93054fe26f21d475$export$c62076b3a966c94b(style) {
    return style && (style.shadowBlur || style.shadowOffsetX || style.shadowOffsetY);
}
function $93054fe26f21d475$export$9e4c657be710688a(displayable) {
    var style = displayable.style;
    var globalScale = displayable.getGlobalScale();
    return [
        style.shadowColor,
        (style.shadowBlur || 0).toFixed(2),
        (style.shadowOffsetX || 0).toFixed(2),
        (style.shadowOffsetY || 0).toFixed(2),
        globalScale[0],
        globalScale[1]
    ].join(",");
}
function $93054fe26f21d475$export$8abc07640cab0527(clipPaths) {
    var key = [];
    if (clipPaths) for(var i = 0; i < clipPaths.length; i++){
        var clipPath = clipPaths[i];
        key.push(clipPath.id);
    }
    return key.join(",");
}
function $93054fe26f21d475$export$2ade673ac4f85dfe(val) {
    return val && !!val.image;
}
function $93054fe26f21d475$export$30352f47600a13cd(val) {
    return val && !!val.svgElement;
}
function $93054fe26f21d475$export$41a28f5a000a9d0f(val) {
    return $93054fe26f21d475$export$2ade673ac4f85dfe(val) || $93054fe26f21d475$export$30352f47600a13cd(val);
}
function $93054fe26f21d475$export$7d961bca9d3b47d0(val) {
    return val.type === "linear";
}
function $93054fe26f21d475$export$2a9cca6692a0ce3a(val) {
    return val.type === "radial";
}
function $93054fe26f21d475$export$545e02bbd5f8fe95(val) {
    return val && (val.type === "linear" || val.type === "radial");
}
function $93054fe26f21d475$export$bb094196179998a5(id) {
    return "url(#" + id + ")";
}
function $93054fe26f21d475$export$93fa1ae8a509371c(el) {
    var scale = el.getGlobalScale();
    var size = Math.max(scale[0], scale[1]);
    return Math.max(Math.ceil(Math.log(size) / Math.log(10)), 1);
}
function $93054fe26f21d475$export$3fe07c0888ff6164(transform) {
    var x = transform.x || 0;
    var y = transform.y || 0;
    var rotation = (transform.rotation || 0) * (0, $43e0a445ed6711da$export$bce8e055322a0ce6);
    var scaleX = (0, $43e0a445ed6711da$export$995e01f2f5c9d030)(transform.scaleX, 1);
    var scaleY = (0, $43e0a445ed6711da$export$995e01f2f5c9d030)(transform.scaleY, 1);
    var skewX = transform.skewX || 0;
    var skewY = transform.skewY || 0;
    var res = [];
    if (x || y) res.push("translate(" + x + "px," + y + "px)");
    if (rotation) res.push("rotate(" + rotation + ")");
    if (scaleX !== 1 || scaleY !== 1) res.push("scale(" + scaleX + "," + scaleY + ")");
    if (skewX || skewY) res.push("skew(" + $93054fe26f21d475$var$mathRound(skewX * (0, $43e0a445ed6711da$export$bce8e055322a0ce6)) + "deg, " + $93054fe26f21d475$var$mathRound(skewY * (0, $43e0a445ed6711da$export$bce8e055322a0ce6)) + "deg)");
    return res.join(" ");
}
var $93054fe26f21d475$export$8fb536984ec8b4d7 = function() {
    if (typeof $93054fe26f21d475$require$Buffer !== "undefined" && typeof $93054fe26f21d475$require$Buffer.from === "function") return function(str) {
        return $93054fe26f21d475$require$Buffer.from(str).toString("base64");
    };
    if (typeof btoa === "function" && typeof unescape === "function" && typeof encodeURIComponent === "function") return function(str) {
        return btoa(unescape(encodeURIComponent(str)));
    };
    return function(str) {
        return null;
    };
}();


var $b0a396476612fe2c$var$arraySlice = Array.prototype.slice;
function $b0a396476612fe2c$var$interpolateNumber(p0, p1, percent) {
    return (p1 - p0) * percent + p0;
}
function $b0a396476612fe2c$var$interpolate1DArray(out, p0, p1, percent) {
    var len = p0.length;
    for(var i = 0; i < len; i++)out[i] = $b0a396476612fe2c$var$interpolateNumber(p0[i], p1[i], percent);
    return out;
}
function $b0a396476612fe2c$var$interpolate2DArray(out, p0, p1, percent) {
    var len = p0.length;
    var len2 = len && p0[0].length;
    for(var i = 0; i < len; i++){
        if (!out[i]) out[i] = [];
        for(var j = 0; j < len2; j++)out[i][j] = $b0a396476612fe2c$var$interpolateNumber(p0[i][j], p1[i][j], percent);
    }
    return out;
}
function $b0a396476612fe2c$var$add1DArray(out, p0, p1, sign) {
    var len = p0.length;
    for(var i = 0; i < len; i++)out[i] = p0[i] + p1[i] * sign;
    return out;
}
function $b0a396476612fe2c$var$add2DArray(out, p0, p1, sign) {
    var len = p0.length;
    var len2 = len && p0[0].length;
    for(var i = 0; i < len; i++){
        if (!out[i]) out[i] = [];
        for(var j = 0; j < len2; j++)out[i][j] = p0[i][j] + p1[i][j] * sign;
    }
    return out;
}
function $b0a396476612fe2c$var$fillColorStops(val0, val1) {
    var len0 = val0.length;
    var len1 = val1.length;
    var shorterArr = len0 > len1 ? val1 : val0;
    var shorterLen = Math.min(len0, len1);
    var last = shorterArr[shorterLen - 1] || {
        color: [
            0,
            0,
            0,
            0
        ],
        offset: 0
    };
    for(var i = shorterLen; i < Math.max(len0, len1); i++)shorterArr.push({
        offset: last.offset,
        color: last.color.slice()
    });
}
function $b0a396476612fe2c$var$fillArray(val0, val1, arrDim) {
    var arr0 = val0;
    var arr1 = val1;
    if (!arr0.push || !arr1.push) return;
    var arr0Len = arr0.length;
    var arr1Len = arr1.length;
    if (arr0Len !== arr1Len) {
        var isPreviousLarger = arr0Len > arr1Len;
        if (isPreviousLarger) arr0.length = arr1Len;
        else for(var i = arr0Len; i < arr1Len; i++)arr0.push(arrDim === 1 ? arr1[i] : $b0a396476612fe2c$var$arraySlice.call(arr1[i]));
    }
    var len2 = arr0[0] && arr0[0].length;
    for(var i = 0; i < arr0.length; i++){
        if (arrDim === 1) {
            if (isNaN(arr0[i])) arr0[i] = arr1[i];
        } else {
            for(var j = 0; j < len2; j++)if (isNaN(arr0[i][j])) arr0[i][j] = arr1[i][j];
        }
    }
}
function $b0a396476612fe2c$export$c5e92b7f105af84e(value) {
    if ((0, $43e0a445ed6711da$export$1e2f57719e155213)(value)) {
        var len = value.length;
        if ((0, $43e0a445ed6711da$export$1e2f57719e155213)(value[0])) {
            var ret = [];
            for(var i = 0; i < len; i++)ret.push($b0a396476612fe2c$var$arraySlice.call(value[i]));
            return ret;
        }
        return $b0a396476612fe2c$var$arraySlice.call(value);
    }
    return value;
}
function $b0a396476612fe2c$var$rgba2String(rgba) {
    rgba[0] = Math.floor(rgba[0]) || 0;
    rgba[1] = Math.floor(rgba[1]) || 0;
    rgba[2] = Math.floor(rgba[2]) || 0;
    rgba[3] = rgba[3] == null ? 1 : rgba[3];
    return "rgba(" + rgba.join(",") + ")";
}
function $b0a396476612fe2c$var$guessArrayDim(value) {
    return (0, $43e0a445ed6711da$export$1e2f57719e155213)(value && value[0]) ? 2 : 1;
}
var $b0a396476612fe2c$var$VALUE_TYPE_NUMBER = 0;
var $b0a396476612fe2c$var$VALUE_TYPE_1D_ARRAY = 1;
var $b0a396476612fe2c$var$VALUE_TYPE_2D_ARRAY = 2;
var $b0a396476612fe2c$var$VALUE_TYPE_COLOR = 3;
var $b0a396476612fe2c$var$VALUE_TYPE_LINEAR_GRADIENT = 4;
var $b0a396476612fe2c$var$VALUE_TYPE_RADIAL_GRADIENT = 5;
var $b0a396476612fe2c$var$VALUE_TYPE_UNKOWN = 6;
function $b0a396476612fe2c$var$isGradientValueType(valType) {
    return valType === $b0a396476612fe2c$var$VALUE_TYPE_LINEAR_GRADIENT || valType === $b0a396476612fe2c$var$VALUE_TYPE_RADIAL_GRADIENT;
}
function $b0a396476612fe2c$var$isArrayValueType(valType) {
    return valType === $b0a396476612fe2c$var$VALUE_TYPE_1D_ARRAY || valType === $b0a396476612fe2c$var$VALUE_TYPE_2D_ARRAY;
}
var $b0a396476612fe2c$var$tmpRgba = [
    0,
    0,
    0,
    0
];
var $b0a396476612fe2c$var$Track = function() {
    function Track(propName) {
        this.keyframes = [];
        this.discrete = false;
        this._invalid = false;
        this._needsSort = false;
        this._lastFr = 0;
        this._lastFrP = 0;
        this.propName = propName;
    }
    Track.prototype.isFinished = function() {
        return this._finished;
    };
    Track.prototype.setFinished = function() {
        this._finished = true;
        if (this._additiveTrack) this._additiveTrack.setFinished();
    };
    Track.prototype.needsAnimate = function() {
        return this.keyframes.length >= 1;
    };
    Track.prototype.getAdditiveTrack = function() {
        return this._additiveTrack;
    };
    Track.prototype.addKeyframe = function(time, rawValue, easing) {
        this._needsSort = true;
        var keyframes = this.keyframes;
        var len = keyframes.length;
        var discrete = false;
        var valType = $b0a396476612fe2c$var$VALUE_TYPE_UNKOWN;
        var value = rawValue;
        if ((0, $43e0a445ed6711da$export$1e2f57719e155213)(rawValue)) {
            var arrayDim = $b0a396476612fe2c$var$guessArrayDim(rawValue);
            valType = arrayDim;
            if (arrayDim === 1 && !(0, $43e0a445ed6711da$export$7e4aa119212bc614)(rawValue[0]) || arrayDim === 2 && !(0, $43e0a445ed6711da$export$7e4aa119212bc614)(rawValue[0][0])) discrete = true;
        } else {
            if ((0, $43e0a445ed6711da$export$7e4aa119212bc614)(rawValue) && !(0, $43e0a445ed6711da$export$7d667b9a0c48c975)(rawValue)) valType = $b0a396476612fe2c$var$VALUE_TYPE_NUMBER;
            else if ((0, $43e0a445ed6711da$export$844ec244b1367d54)(rawValue)) {
                if (!isNaN(+rawValue)) valType = $b0a396476612fe2c$var$VALUE_TYPE_NUMBER;
                else {
                    var colorArray = $b0979f18b0a232f9$export$98e6a39c04603d36(rawValue);
                    if (colorArray) {
                        value = colorArray;
                        valType = $b0a396476612fe2c$var$VALUE_TYPE_COLOR;
                    }
                }
            } else if ((0, $43e0a445ed6711da$export$fa2c283003ed971c)(rawValue)) {
                var parsedGradient = (0, $43e0a445ed6711da$export$8b58be045bf06082)({}, value);
                parsedGradient.colorStops = (0, $43e0a445ed6711da$export$871de8747c9eaa88)(rawValue.colorStops, function(colorStop) {
                    return {
                        offset: colorStop.offset,
                        color: $b0979f18b0a232f9$export$98e6a39c04603d36(colorStop.color)
                    };
                });
                if ((0, $93054fe26f21d475$export$7d961bca9d3b47d0)(rawValue)) valType = $b0a396476612fe2c$var$VALUE_TYPE_LINEAR_GRADIENT;
                else if ((0, $93054fe26f21d475$export$2a9cca6692a0ce3a)(rawValue)) valType = $b0a396476612fe2c$var$VALUE_TYPE_RADIAL_GRADIENT;
                value = parsedGradient;
            }
        }
        if (len === 0) this.valType = valType;
        else if (valType !== this.valType || valType === $b0a396476612fe2c$var$VALUE_TYPE_UNKOWN) discrete = true;
        this.discrete = this.discrete || discrete;
        var kf = {
            time: time,
            value: value,
            rawValue: rawValue,
            percent: 0
        };
        if (easing) {
            kf.easing = easing;
            kf.easingFunc = (0, $43e0a445ed6711da$export$f6e2535fb5126e54)(easing) ? easing : (0, $5c8efb9bac6f133e$export$2e2bcd8739ae039)[easing] || (0, $739b4fcf1779451b$export$ec0863d806fd857e)(easing);
        }
        keyframes.push(kf);
        return kf;
    };
    Track.prototype.prepare = function(maxTime, additiveTrack) {
        var kfs = this.keyframes;
        if (this._needsSort) kfs.sort(function(a, b) {
            return a.time - b.time;
        });
        var valType = this.valType;
        var kfsLen = kfs.length;
        var lastKf = kfs[kfsLen - 1];
        var isDiscrete = this.discrete;
        var isArr = $b0a396476612fe2c$var$isArrayValueType(valType);
        var isGradient = $b0a396476612fe2c$var$isGradientValueType(valType);
        for(var i = 0; i < kfsLen; i++){
            var kf = kfs[i];
            var value = kf.value;
            var lastValue = lastKf.value;
            kf.percent = kf.time / maxTime;
            if (!isDiscrete) {
                if (isArr && i !== kfsLen - 1) $b0a396476612fe2c$var$fillArray(value, lastValue, valType);
                else if (isGradient) $b0a396476612fe2c$var$fillColorStops(value.colorStops, lastValue.colorStops);
            }
        }
        if (!isDiscrete && valType !== $b0a396476612fe2c$var$VALUE_TYPE_RADIAL_GRADIENT && additiveTrack && this.needsAnimate() && additiveTrack.needsAnimate() && valType === additiveTrack.valType && !additiveTrack._finished) {
            this._additiveTrack = additiveTrack;
            var startValue = kfs[0].value;
            for(var i = 0; i < kfsLen; i++){
                if (valType === $b0a396476612fe2c$var$VALUE_TYPE_NUMBER) kfs[i].additiveValue = kfs[i].value - startValue;
                else if (valType === $b0a396476612fe2c$var$VALUE_TYPE_COLOR) kfs[i].additiveValue = $b0a396476612fe2c$var$add1DArray([], kfs[i].value, startValue, -1);
                else if ($b0a396476612fe2c$var$isArrayValueType(valType)) kfs[i].additiveValue = valType === $b0a396476612fe2c$var$VALUE_TYPE_1D_ARRAY ? $b0a396476612fe2c$var$add1DArray([], kfs[i].value, startValue, -1) : $b0a396476612fe2c$var$add2DArray([], kfs[i].value, startValue, -1);
            }
        }
    };
    Track.prototype.step = function(target, percent) {
        if (this._finished) return;
        if (this._additiveTrack && this._additiveTrack._finished) this._additiveTrack = null;
        var isAdditive = this._additiveTrack != null;
        var valueKey = isAdditive ? "additiveValue" : "value";
        var valType = this.valType;
        var keyframes = this.keyframes;
        var kfsNum = keyframes.length;
        var propName = this.propName;
        var isValueColor = valType === $b0a396476612fe2c$var$VALUE_TYPE_COLOR;
        var frameIdx;
        var lastFrame = this._lastFr;
        var mathMin = Math.min;
        var frame;
        var nextFrame;
        if (kfsNum === 1) frame = nextFrame = keyframes[0];
        else {
            if (percent < 0) frameIdx = 0;
            else if (percent < this._lastFrP) {
                var start = mathMin(lastFrame + 1, kfsNum - 1);
                for(frameIdx = start; frameIdx >= 0; frameIdx--){
                    if (keyframes[frameIdx].percent <= percent) break;
                }
                frameIdx = mathMin(frameIdx, kfsNum - 2);
            } else {
                for(frameIdx = lastFrame; frameIdx < kfsNum; frameIdx++){
                    if (keyframes[frameIdx].percent > percent) break;
                }
                frameIdx = mathMin(frameIdx - 1, kfsNum - 2);
            }
            nextFrame = keyframes[frameIdx + 1];
            frame = keyframes[frameIdx];
        }
        if (!(frame && nextFrame)) return;
        this._lastFr = frameIdx;
        this._lastFrP = percent;
        var interval = nextFrame.percent - frame.percent;
        var w = interval === 0 ? 1 : mathMin((percent - frame.percent) / interval, 1);
        if (nextFrame.easingFunc) w = nextFrame.easingFunc(w);
        var targetArr = isAdditive ? this._additiveValue : isValueColor ? $b0a396476612fe2c$var$tmpRgba : target[propName];
        if (($b0a396476612fe2c$var$isArrayValueType(valType) || isValueColor) && !targetArr) targetArr = this._additiveValue = [];
        if (this.discrete) target[propName] = w < 1 ? frame.rawValue : nextFrame.rawValue;
        else if ($b0a396476612fe2c$var$isArrayValueType(valType)) valType === $b0a396476612fe2c$var$VALUE_TYPE_1D_ARRAY ? $b0a396476612fe2c$var$interpolate1DArray(targetArr, frame[valueKey], nextFrame[valueKey], w) : $b0a396476612fe2c$var$interpolate2DArray(targetArr, frame[valueKey], nextFrame[valueKey], w);
        else if ($b0a396476612fe2c$var$isGradientValueType(valType)) {
            var val = frame[valueKey];
            var nextVal_1 = nextFrame[valueKey];
            var isLinearGradient_1 = valType === $b0a396476612fe2c$var$VALUE_TYPE_LINEAR_GRADIENT;
            target[propName] = {
                type: isLinearGradient_1 ? "linear" : "radial",
                x: $b0a396476612fe2c$var$interpolateNumber(val.x, nextVal_1.x, w),
                y: $b0a396476612fe2c$var$interpolateNumber(val.y, nextVal_1.y, w),
                colorStops: (0, $43e0a445ed6711da$export$871de8747c9eaa88)(val.colorStops, function(colorStop, idx) {
                    var nextColorStop = nextVal_1.colorStops[idx];
                    return {
                        offset: $b0a396476612fe2c$var$interpolateNumber(colorStop.offset, nextColorStop.offset, w),
                        color: $b0a396476612fe2c$var$rgba2String($b0a396476612fe2c$var$interpolate1DArray([], colorStop.color, nextColorStop.color, w))
                    };
                }),
                global: nextVal_1.global
            };
            if (isLinearGradient_1) {
                target[propName].x2 = $b0a396476612fe2c$var$interpolateNumber(val.x2, nextVal_1.x2, w);
                target[propName].y2 = $b0a396476612fe2c$var$interpolateNumber(val.y2, nextVal_1.y2, w);
            } else target[propName].r = $b0a396476612fe2c$var$interpolateNumber(val.r, nextVal_1.r, w);
        } else if (isValueColor) {
            $b0a396476612fe2c$var$interpolate1DArray(targetArr, frame[valueKey], nextFrame[valueKey], w);
            if (!isAdditive) target[propName] = $b0a396476612fe2c$var$rgba2String(targetArr);
        } else {
            var value = $b0a396476612fe2c$var$interpolateNumber(frame[valueKey], nextFrame[valueKey], w);
            if (isAdditive) this._additiveValue = value;
            else target[propName] = value;
        }
        if (isAdditive) this._addToTarget(target);
    };
    Track.prototype._addToTarget = function(target) {
        var valType = this.valType;
        var propName = this.propName;
        var additiveValue = this._additiveValue;
        if (valType === $b0a396476612fe2c$var$VALUE_TYPE_NUMBER) target[propName] = target[propName] + additiveValue;
        else if (valType === $b0a396476612fe2c$var$VALUE_TYPE_COLOR) {
            $b0979f18b0a232f9$export$98e6a39c04603d36(target[propName], $b0a396476612fe2c$var$tmpRgba);
            $b0a396476612fe2c$var$add1DArray($b0a396476612fe2c$var$tmpRgba, $b0a396476612fe2c$var$tmpRgba, additiveValue, 1);
            target[propName] = $b0a396476612fe2c$var$rgba2String($b0a396476612fe2c$var$tmpRgba);
        } else if (valType === $b0a396476612fe2c$var$VALUE_TYPE_1D_ARRAY) $b0a396476612fe2c$var$add1DArray(target[propName], target[propName], additiveValue, 1);
        else if (valType === $b0a396476612fe2c$var$VALUE_TYPE_2D_ARRAY) $b0a396476612fe2c$var$add2DArray(target[propName], target[propName], additiveValue, 1);
    };
    return Track;
}();
var $b0a396476612fe2c$var$Animator = function() {
    function Animator(target, loop, allowDiscreteAnimation, additiveTo) {
        this._tracks = {};
        this._trackKeys = [];
        this._maxTime = 0;
        this._started = 0;
        this._clip = null;
        this._target = target;
        this._loop = loop;
        if (loop && additiveTo) {
            (0, $43e0a445ed6711da$export$58da9968c3170cb1)("Can' use additive animation on looped animation.");
            return;
        }
        this._additiveAnimators = additiveTo;
        this._allowDiscrete = allowDiscreteAnimation;
    }
    Animator.prototype.getMaxTime = function() {
        return this._maxTime;
    };
    Animator.prototype.getDelay = function() {
        return this._delay;
    };
    Animator.prototype.getLoop = function() {
        return this._loop;
    };
    Animator.prototype.getTarget = function() {
        return this._target;
    };
    Animator.prototype.changeTarget = function(target) {
        this._target = target;
    };
    Animator.prototype.when = function(time, props, easing) {
        return this.whenWithKeys(time, props, (0, $43e0a445ed6711da$export$ed97f33186d4b816)(props), easing);
    };
    Animator.prototype.whenWithKeys = function(time, props, propNames, easing) {
        var tracks = this._tracks;
        for(var i = 0; i < propNames.length; i++){
            var propName = propNames[i];
            var track = tracks[propName];
            if (!track) {
                track = tracks[propName] = new $b0a396476612fe2c$var$Track(propName);
                var initialValue = void 0;
                var additiveTrack = this._getAdditiveTrack(propName);
                if (additiveTrack) {
                    var addtiveTrackKfs = additiveTrack.keyframes;
                    var lastFinalKf = addtiveTrackKfs[addtiveTrackKfs.length - 1];
                    initialValue = lastFinalKf && lastFinalKf.value;
                    if (additiveTrack.valType === $b0a396476612fe2c$var$VALUE_TYPE_COLOR && initialValue) initialValue = $b0a396476612fe2c$var$rgba2String(initialValue);
                } else initialValue = this._target[propName];
                if (initialValue == null) continue;
                if (time > 0) track.addKeyframe(0, $b0a396476612fe2c$export$c5e92b7f105af84e(initialValue), easing);
                this._trackKeys.push(propName);
            }
            track.addKeyframe(time, $b0a396476612fe2c$export$c5e92b7f105af84e(props[propName]), easing);
        }
        this._maxTime = Math.max(this._maxTime, time);
        return this;
    };
    Animator.prototype.pause = function() {
        this._clip.pause();
        this._paused = true;
    };
    Animator.prototype.resume = function() {
        this._clip.resume();
        this._paused = false;
    };
    Animator.prototype.isPaused = function() {
        return !!this._paused;
    };
    Animator.prototype.duration = function(duration) {
        this._maxTime = duration;
        this._force = true;
        return this;
    };
    Animator.prototype._doneCallback = function() {
        this._setTracksFinished();
        this._clip = null;
        var doneList = this._doneCbs;
        if (doneList) {
            var len = doneList.length;
            for(var i = 0; i < len; i++)doneList[i].call(this);
        }
    };
    Animator.prototype._abortedCallback = function() {
        this._setTracksFinished();
        var animation = this.animation;
        var abortedList = this._abortedCbs;
        if (animation) animation.removeClip(this._clip);
        this._clip = null;
        if (abortedList) for(var i = 0; i < abortedList.length; i++)abortedList[i].call(this);
    };
    Animator.prototype._setTracksFinished = function() {
        var tracks = this._tracks;
        var tracksKeys = this._trackKeys;
        for(var i = 0; i < tracksKeys.length; i++)tracks[tracksKeys[i]].setFinished();
    };
    Animator.prototype._getAdditiveTrack = function(trackName) {
        var additiveTrack;
        var additiveAnimators = this._additiveAnimators;
        if (additiveAnimators) for(var i = 0; i < additiveAnimators.length; i++){
            var track = additiveAnimators[i].getTrack(trackName);
            if (track) additiveTrack = track;
        }
        return additiveTrack;
    };
    Animator.prototype.start = function(easing) {
        if (this._started > 0) return;
        this._started = 1;
        var self = this;
        var tracks = [];
        var maxTime = this._maxTime || 0;
        for(var i = 0; i < this._trackKeys.length; i++){
            var propName = this._trackKeys[i];
            var track = this._tracks[propName];
            var additiveTrack = this._getAdditiveTrack(propName);
            var kfs = track.keyframes;
            var kfsNum = kfs.length;
            track.prepare(maxTime, additiveTrack);
            if (track.needsAnimate()) {
                if (!this._allowDiscrete && track.discrete) {
                    var lastKf = kfs[kfsNum - 1];
                    if (lastKf) self._target[track.propName] = lastKf.rawValue;
                    track.setFinished();
                } else tracks.push(track);
            }
        }
        if (tracks.length || this._force) {
            var clip = new (0, $8b6f1ad92f8c8456$export$2e2bcd8739ae039)({
                life: maxTime,
                loop: this._loop,
                delay: this._delay || 0,
                onframe: function(percent) {
                    self._started = 2;
                    var additiveAnimators = self._additiveAnimators;
                    if (additiveAnimators) {
                        var stillHasAdditiveAnimator = false;
                        for(var i = 0; i < additiveAnimators.length; i++)if (additiveAnimators[i]._clip) {
                            stillHasAdditiveAnimator = true;
                            break;
                        }
                        if (!stillHasAdditiveAnimator) self._additiveAnimators = null;
                    }
                    for(var i = 0; i < tracks.length; i++)tracks[i].step(self._target, percent);
                    var onframeList = self._onframeCbs;
                    if (onframeList) for(var i = 0; i < onframeList.length; i++)onframeList[i](self._target, percent);
                },
                ondestroy: function() {
                    self._doneCallback();
                }
            });
            this._clip = clip;
            if (this.animation) this.animation.addClip(clip);
            if (easing) clip.setEasing(easing);
        } else this._doneCallback();
        return this;
    };
    Animator.prototype.stop = function(forwardToLast) {
        if (!this._clip) return;
        var clip = this._clip;
        if (forwardToLast) clip.onframe(1);
        this._abortedCallback();
    };
    Animator.prototype.delay = function(time) {
        this._delay = time;
        return this;
    };
    Animator.prototype.during = function(cb) {
        if (cb) {
            if (!this._onframeCbs) this._onframeCbs = [];
            this._onframeCbs.push(cb);
        }
        return this;
    };
    Animator.prototype.done = function(cb) {
        if (cb) {
            if (!this._doneCbs) this._doneCbs = [];
            this._doneCbs.push(cb);
        }
        return this;
    };
    Animator.prototype.aborted = function(cb) {
        if (cb) {
            if (!this._abortedCbs) this._abortedCbs = [];
            this._abortedCbs.push(cb);
        }
        return this;
    };
    Animator.prototype.getClip = function() {
        return this._clip;
    };
    Animator.prototype.getTrack = function(propName) {
        return this._tracks[propName];
    };
    Animator.prototype.getTracks = function() {
        var _this = this;
        return (0, $43e0a445ed6711da$export$871de8747c9eaa88)(this._trackKeys, function(key) {
            return _this._tracks[key];
        });
    };
    Animator.prototype.stopTracks = function(propNames, forwardToLast) {
        if (!propNames.length || !this._clip) return true;
        var tracks = this._tracks;
        var tracksKeys = this._trackKeys;
        for(var i = 0; i < propNames.length; i++){
            var track = tracks[propNames[i]];
            if (track && !track.isFinished()) {
                if (forwardToLast) track.step(this._target, 1);
                else if (this._started === 1) track.step(this._target, 0);
                track.setFinished();
            }
        }
        var allAborted = true;
        for(var i = 0; i < tracksKeys.length; i++)if (!tracks[tracksKeys[i]].isFinished()) {
            allAborted = false;
            break;
        }
        if (allAborted) this._abortedCallback();
        return allAborted;
    };
    Animator.prototype.saveTo = function(target, trackKeys, firstOrLast) {
        if (!target) return;
        trackKeys = trackKeys || this._trackKeys;
        for(var i = 0; i < trackKeys.length; i++){
            var propName = trackKeys[i];
            var track = this._tracks[propName];
            if (!track || track.isFinished()) continue;
            var kfs = track.keyframes;
            var kf = kfs[firstOrLast ? 0 : kfs.length - 1];
            if (kf) target[propName] = $b0a396476612fe2c$export$c5e92b7f105af84e(kf.rawValue);
        }
    };
    Animator.prototype.__changeFinalValue = function(finalProps, trackKeys) {
        trackKeys = trackKeys || (0, $43e0a445ed6711da$export$ed97f33186d4b816)(finalProps);
        for(var i = 0; i < trackKeys.length; i++){
            var propName = trackKeys[i];
            var track = this._tracks[propName];
            if (!track) continue;
            var kfs = track.keyframes;
            if (kfs.length > 1) {
                var lastKf = kfs.pop();
                track.addKeyframe(lastKf.time, finalProps[propName]);
                track.prepare(this._maxTime, track.getAdditiveTrack());
            }
        }
    };
    return Animator;
}();
var $b0a396476612fe2c$export$2e2bcd8739ae039 = $b0a396476612fe2c$var$Animator;


function $2b16e6dd85ff7184$export$1428f42a7de81803() {
    return new Date().getTime();
}
var $2b16e6dd85ff7184$var$Animation = function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(Animation, _super);
    function Animation(opts) {
        var _this = _super.call(this) || this;
        _this._running = false;
        _this._time = 0;
        _this._pausedTime = 0;
        _this._pauseStart = 0;
        _this._paused = false;
        opts = opts || {};
        _this.stage = opts.stage || {};
        return _this;
    }
    Animation.prototype.addClip = function(clip) {
        if (clip.animation) this.removeClip(clip);
        if (!this._head) this._head = this._tail = clip;
        else {
            this._tail.next = clip;
            clip.prev = this._tail;
            clip.next = null;
            this._tail = clip;
        }
        clip.animation = this;
    };
    Animation.prototype.addAnimator = function(animator) {
        animator.animation = this;
        var clip = animator.getClip();
        if (clip) this.addClip(clip);
    };
    Animation.prototype.removeClip = function(clip) {
        if (!clip.animation) return;
        var prev = clip.prev;
        var next = clip.next;
        if (prev) prev.next = next;
        else this._head = next;
        if (next) next.prev = prev;
        else this._tail = prev;
        clip.next = clip.prev = clip.animation = null;
    };
    Animation.prototype.removeAnimator = function(animator) {
        var clip = animator.getClip();
        if (clip) this.removeClip(clip);
        animator.animation = null;
    };
    Animation.prototype.update = function(notTriggerFrameAndStageUpdate) {
        var time = $2b16e6dd85ff7184$export$1428f42a7de81803() - this._pausedTime;
        var delta = time - this._time;
        var clip = this._head;
        while(clip){
            var nextClip = clip.next;
            var finished = clip.step(time, delta);
            if (finished) {
                clip.ondestroy();
                this.removeClip(clip);
                clip = nextClip;
            } else clip = nextClip;
        }
        this._time = time;
        if (!notTriggerFrameAndStageUpdate) {
            this.trigger("frame", delta);
            this.stage.update && this.stage.update();
        }
    };
    Animation.prototype._startLoop = function() {
        var self = this;
        this._running = true;
        function step() {
            if (self._running) {
                (0, $261197b637bbe3ef$export$2e2bcd8739ae039)(step);
                !self._paused && self.update();
            }
        }
        (0, $261197b637bbe3ef$export$2e2bcd8739ae039)(step);
    };
    Animation.prototype.start = function() {
        if (this._running) return;
        this._time = $2b16e6dd85ff7184$export$1428f42a7de81803();
        this._pausedTime = 0;
        this._startLoop();
    };
    Animation.prototype.stop = function() {
        this._running = false;
    };
    Animation.prototype.pause = function() {
        if (!this._paused) {
            this._pauseStart = $2b16e6dd85ff7184$export$1428f42a7de81803();
            this._paused = true;
        }
    };
    Animation.prototype.resume = function() {
        if (this._paused) {
            this._pausedTime += $2b16e6dd85ff7184$export$1428f42a7de81803() - this._pauseStart;
            this._paused = false;
        }
    };
    Animation.prototype.clear = function() {
        var clip = this._head;
        while(clip){
            var nextClip = clip.next;
            clip.prev = clip.next = clip.animation = null;
            clip = nextClip;
        }
        this._head = this._tail = null;
    };
    Animation.prototype.isFinished = function() {
        return this._head == null;
    };
    Animation.prototype.animate = function(target, options) {
        options = options || {};
        this.start();
        var animator = new (0, $b0a396476612fe2c$export$2e2bcd8739ae039)(target, options.loop);
        this.addAnimator(animator);
        return animator;
    };
    return Animation;
}((0, $131b7833cdf735df$export$2e2bcd8739ae039));
var $2b16e6dd85ff7184$export$2e2bcd8739ae039 = $2b16e6dd85ff7184$var$Animation;







var $2011c487b8e23053$var$TOUCH_CLICK_DELAY = 300;
var $2011c487b8e23053$var$globalEventSupported = (0, $a84633bb9c74d89c$export$2e2bcd8739ae039).domSupported;
var $2011c487b8e23053$var$localNativeListenerNames = function() {
    var mouseHandlerNames = [
        "click",
        "dblclick",
        "mousewheel",
        "wheel",
        "mouseout",
        "mouseup",
        "mousedown",
        "mousemove",
        "contextmenu"
    ];
    var touchHandlerNames = [
        "touchstart",
        "touchend",
        "touchmove"
    ];
    var pointerEventNameMap = {
        pointerdown: 1,
        pointerup: 1,
        pointermove: 1,
        pointerout: 1
    };
    var pointerHandlerNames = $43e0a445ed6711da$export$871de8747c9eaa88(mouseHandlerNames, function(name) {
        var nm = name.replace("mouse", "pointer");
        return pointerEventNameMap.hasOwnProperty(nm) ? nm : name;
    });
    return {
        mouse: mouseHandlerNames,
        touch: touchHandlerNames,
        pointer: pointerHandlerNames
    };
}();
var $2011c487b8e23053$var$globalNativeListenerNames = {
    mouse: [
        "mousemove",
        "mouseup"
    ],
    pointer: [
        "pointermove",
        "pointerup"
    ]
};
var $2011c487b8e23053$var$wheelEventSupported = false;
function $2011c487b8e23053$var$isPointerFromTouch(event) {
    var pointerType = event.pointerType;
    return pointerType === "pen" || pointerType === "touch";
}
function $2011c487b8e23053$var$setTouchTimer(scope) {
    scope.touching = true;
    if (scope.touchTimer != null) {
        clearTimeout(scope.touchTimer);
        scope.touchTimer = null;
    }
    scope.touchTimer = setTimeout(function() {
        scope.touching = false;
        scope.touchTimer = null;
    }, 700);
}
function $2011c487b8e23053$var$markTouch(event) {
    event && (event.zrByTouch = true);
}
function $2011c487b8e23053$var$normalizeGlobalEvent(instance, event) {
    return (0, $e48a660b5a6fd3cb$export$40fadb093aebad71)(instance.dom, new $2011c487b8e23053$var$FakeGlobalEvent(instance, event), true);
}
function $2011c487b8e23053$var$isLocalEl(instance, el) {
    var elTmp = el;
    var isLocal = false;
    while(elTmp && elTmp.nodeType !== 9 && !(isLocal = elTmp.domBelongToZr || elTmp !== el && elTmp === instance.painterRoot))elTmp = elTmp.parentNode;
    return isLocal;
}
var $2011c487b8e23053$var$FakeGlobalEvent = function() {
    function FakeGlobalEvent(instance, event) {
        this.stopPropagation = $43e0a445ed6711da$export$8793edee2d425525;
        this.stopImmediatePropagation = $43e0a445ed6711da$export$8793edee2d425525;
        this.preventDefault = $43e0a445ed6711da$export$8793edee2d425525;
        this.type = event.type;
        this.target = this.currentTarget = instance.dom;
        this.pointerType = event.pointerType;
        this.clientX = event.clientX;
        this.clientY = event.clientY;
    }
    return FakeGlobalEvent;
}();
var $2011c487b8e23053$var$localDOMHandlers = {
    mousedown: function(event) {
        event = (0, $e48a660b5a6fd3cb$export$40fadb093aebad71)(this.dom, event);
        this.__mayPointerCapture = [
            event.zrX,
            event.zrY
        ];
        this.trigger("mousedown", event);
    },
    mousemove: function(event) {
        event = (0, $e48a660b5a6fd3cb$export$40fadb093aebad71)(this.dom, event);
        var downPoint = this.__mayPointerCapture;
        if (downPoint && (event.zrX !== downPoint[0] || event.zrY !== downPoint[1])) this.__togglePointerCapture(true);
        this.trigger("mousemove", event);
    },
    mouseup: function(event) {
        event = (0, $e48a660b5a6fd3cb$export$40fadb093aebad71)(this.dom, event);
        this.__togglePointerCapture(false);
        this.trigger("mouseup", event);
    },
    mouseout: function(event) {
        event = (0, $e48a660b5a6fd3cb$export$40fadb093aebad71)(this.dom, event);
        var element = event.toElement || event.relatedTarget;
        if (!$2011c487b8e23053$var$isLocalEl(this, element)) {
            if (this.__pointerCapturing) event.zrEventControl = "no_globalout";
            this.trigger("mouseout", event);
        }
    },
    wheel: function(event) {
        $2011c487b8e23053$var$wheelEventSupported = true;
        event = (0, $e48a660b5a6fd3cb$export$40fadb093aebad71)(this.dom, event);
        this.trigger("mousewheel", event);
    },
    mousewheel: function(event) {
        if ($2011c487b8e23053$var$wheelEventSupported) return;
        event = (0, $e48a660b5a6fd3cb$export$40fadb093aebad71)(this.dom, event);
        this.trigger("mousewheel", event);
    },
    touchstart: function(event) {
        event = (0, $e48a660b5a6fd3cb$export$40fadb093aebad71)(this.dom, event);
        $2011c487b8e23053$var$markTouch(event);
        this.__lastTouchMoment = new Date();
        this.handler.processGesture(event, "start");
        $2011c487b8e23053$var$localDOMHandlers.mousemove.call(this, event);
        $2011c487b8e23053$var$localDOMHandlers.mousedown.call(this, event);
    },
    touchmove: function(event) {
        event = (0, $e48a660b5a6fd3cb$export$40fadb093aebad71)(this.dom, event);
        $2011c487b8e23053$var$markTouch(event);
        this.handler.processGesture(event, "change");
        $2011c487b8e23053$var$localDOMHandlers.mousemove.call(this, event);
    },
    touchend: function(event) {
        event = (0, $e48a660b5a6fd3cb$export$40fadb093aebad71)(this.dom, event);
        $2011c487b8e23053$var$markTouch(event);
        this.handler.processGesture(event, "end");
        $2011c487b8e23053$var$localDOMHandlers.mouseup.call(this, event);
        if (+new Date() - +this.__lastTouchMoment < $2011c487b8e23053$var$TOUCH_CLICK_DELAY) $2011c487b8e23053$var$localDOMHandlers.click.call(this, event);
    },
    pointerdown: function(event) {
        $2011c487b8e23053$var$localDOMHandlers.mousedown.call(this, event);
    },
    pointermove: function(event) {
        if (!$2011c487b8e23053$var$isPointerFromTouch(event)) $2011c487b8e23053$var$localDOMHandlers.mousemove.call(this, event);
    },
    pointerup: function(event) {
        $2011c487b8e23053$var$localDOMHandlers.mouseup.call(this, event);
    },
    pointerout: function(event) {
        if (!$2011c487b8e23053$var$isPointerFromTouch(event)) $2011c487b8e23053$var$localDOMHandlers.mouseout.call(this, event);
    }
};
$43e0a445ed6711da$export$79b2f7037acddd43([
    "click",
    "dblclick",
    "contextmenu"
], function(name) {
    $2011c487b8e23053$var$localDOMHandlers[name] = function(event) {
        event = (0, $e48a660b5a6fd3cb$export$40fadb093aebad71)(this.dom, event);
        this.trigger(name, event);
    };
});
var $2011c487b8e23053$var$globalDOMHandlers = {
    pointermove: function(event) {
        if (!$2011c487b8e23053$var$isPointerFromTouch(event)) $2011c487b8e23053$var$globalDOMHandlers.mousemove.call(this, event);
    },
    pointerup: function(event) {
        $2011c487b8e23053$var$globalDOMHandlers.mouseup.call(this, event);
    },
    mousemove: function(event) {
        this.trigger("mousemove", event);
    },
    mouseup: function(event) {
        var pointerCaptureReleasing = this.__pointerCapturing;
        this.__togglePointerCapture(false);
        this.trigger("mouseup", event);
        if (pointerCaptureReleasing) {
            event.zrEventControl = "only_globalout";
            this.trigger("mouseout", event);
        }
    }
};
function $2011c487b8e23053$var$mountLocalDOMEventListeners(instance, scope) {
    var domHandlers = scope.domHandlers;
    if ((0, $a84633bb9c74d89c$export$2e2bcd8739ae039).pointerEventsSupported) $43e0a445ed6711da$export$79b2f7037acddd43($2011c487b8e23053$var$localNativeListenerNames.pointer, function(nativeEventName) {
        $2011c487b8e23053$var$mountSingleDOMEventListener(scope, nativeEventName, function(event) {
            domHandlers[nativeEventName].call(instance, event);
        });
    });
    else {
        if ((0, $a84633bb9c74d89c$export$2e2bcd8739ae039).touchEventsSupported) $43e0a445ed6711da$export$79b2f7037acddd43($2011c487b8e23053$var$localNativeListenerNames.touch, function(nativeEventName) {
            $2011c487b8e23053$var$mountSingleDOMEventListener(scope, nativeEventName, function(event) {
                domHandlers[nativeEventName].call(instance, event);
                $2011c487b8e23053$var$setTouchTimer(scope);
            });
        });
        $43e0a445ed6711da$export$79b2f7037acddd43($2011c487b8e23053$var$localNativeListenerNames.mouse, function(nativeEventName) {
            $2011c487b8e23053$var$mountSingleDOMEventListener(scope, nativeEventName, function(event) {
                event = (0, $e48a660b5a6fd3cb$export$4abe0e945399ac1d)(event);
                if (!scope.touching) domHandlers[nativeEventName].call(instance, event);
            });
        });
    }
}
function $2011c487b8e23053$var$mountGlobalDOMEventListeners(instance, scope) {
    if ((0, $a84633bb9c74d89c$export$2e2bcd8739ae039).pointerEventsSupported) $43e0a445ed6711da$export$79b2f7037acddd43($2011c487b8e23053$var$globalNativeListenerNames.pointer, mount);
    else if (!(0, $a84633bb9c74d89c$export$2e2bcd8739ae039).touchEventsSupported) $43e0a445ed6711da$export$79b2f7037acddd43($2011c487b8e23053$var$globalNativeListenerNames.mouse, mount);
    function mount(nativeEventName) {
        function nativeEventListener(event) {
            event = (0, $e48a660b5a6fd3cb$export$4abe0e945399ac1d)(event);
            if (!$2011c487b8e23053$var$isLocalEl(instance, event.target)) {
                event = $2011c487b8e23053$var$normalizeGlobalEvent(instance, event);
                scope.domHandlers[nativeEventName].call(instance, event);
            }
        }
        $2011c487b8e23053$var$mountSingleDOMEventListener(scope, nativeEventName, nativeEventListener, {
            capture: true
        });
    }
}
function $2011c487b8e23053$var$mountSingleDOMEventListener(scope, nativeEventName, listener, opt) {
    scope.mounted[nativeEventName] = listener;
    scope.listenerOpts[nativeEventName] = opt;
    (0, $e48a660b5a6fd3cb$export$3f65cefe8380dbea)(scope.domTarget, nativeEventName, listener, opt);
}
function $2011c487b8e23053$var$unmountDOMEventListeners(scope) {
    var mounted = scope.mounted;
    for(var nativeEventName in mounted)if (mounted.hasOwnProperty(nativeEventName)) (0, $e48a660b5a6fd3cb$export$8ff9f68337b520c0)(scope.domTarget, nativeEventName, mounted[nativeEventName], scope.listenerOpts[nativeEventName]);
    scope.mounted = {};
}
var $2011c487b8e23053$var$DOMHandlerScope = function() {
    function DOMHandlerScope(domTarget, domHandlers) {
        this.mounted = {};
        this.listenerOpts = {};
        this.touching = false;
        this.domTarget = domTarget;
        this.domHandlers = domHandlers;
    }
    return DOMHandlerScope;
}();
var $2011c487b8e23053$var$HandlerDomProxy = function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(HandlerDomProxy, _super);
    function HandlerDomProxy(dom, painterRoot) {
        var _this = _super.call(this) || this;
        _this.__pointerCapturing = false;
        _this.dom = dom;
        _this.painterRoot = painterRoot;
        _this._localHandlerScope = new $2011c487b8e23053$var$DOMHandlerScope(dom, $2011c487b8e23053$var$localDOMHandlers);
        if ($2011c487b8e23053$var$globalEventSupported) _this._globalHandlerScope = new $2011c487b8e23053$var$DOMHandlerScope(document, $2011c487b8e23053$var$globalDOMHandlers);
        $2011c487b8e23053$var$mountLocalDOMEventListeners(_this, _this._localHandlerScope);
        return _this;
    }
    HandlerDomProxy.prototype.dispose = function() {
        $2011c487b8e23053$var$unmountDOMEventListeners(this._localHandlerScope);
        if ($2011c487b8e23053$var$globalEventSupported) $2011c487b8e23053$var$unmountDOMEventListeners(this._globalHandlerScope);
    };
    HandlerDomProxy.prototype.setCursor = function(cursorStyle) {
        this.dom.style && (this.dom.style.cursor = cursorStyle || "default");
    };
    HandlerDomProxy.prototype.__togglePointerCapture = function(isPointerCapturing) {
        this.__mayPointerCapture = null;
        if ($2011c487b8e23053$var$globalEventSupported && +this.__pointerCapturing ^ +isPointerCapturing) {
            this.__pointerCapturing = isPointerCapturing;
            var globalHandlerScope = this._globalHandlerScope;
            isPointerCapturing ? $2011c487b8e23053$var$mountGlobalDOMEventListeners(this, globalHandlerScope) : $2011c487b8e23053$var$unmountDOMEventListeners(globalHandlerScope);
        }
    };
    return HandlerDomProxy;
}((0, $131b7833cdf735df$export$2e2bcd8739ae039));
var $2011c487b8e23053$export$2e2bcd8739ae039 = $2011c487b8e23053$var$HandlerDomProxy;




var $b4769615a730dcfc$var$dpr = 1;
if ((0, $a84633bb9c74d89c$export$2e2bcd8739ae039).hasGlobalWindow) $b4769615a730dcfc$var$dpr = Math.max(window.devicePixelRatio || window.screen && window.screen.deviceXDPI / window.screen.logicalXDPI || 1, 1);
var $b4769615a730dcfc$export$7cdcde344c85339c = 0;
var $b4769615a730dcfc$export$508f096bfcdaac40 = $b4769615a730dcfc$var$dpr;
var $b4769615a730dcfc$export$fd81e7ebc7dae256 = 0.4;
var $b4769615a730dcfc$export$f8ce94761f39398d = "#333";
var $b4769615a730dcfc$export$3c6e95f318c8369b = "#ccc";
var $b4769615a730dcfc$export$27682248795c3c6b = "#eee";







var $cca2e8cc539372e0$var$mIdentity = $87ac8de5537d9a34$export$f0954fd7d5368655;
var $cca2e8cc539372e0$var$EPSILON = 5e-5;
function $cca2e8cc539372e0$var$isNotAroundZero(val) {
    return val > $cca2e8cc539372e0$var$EPSILON || val < -$cca2e8cc539372e0$var$EPSILON;
}
var $cca2e8cc539372e0$var$scaleTmp = [];
var $cca2e8cc539372e0$var$tmpTransform = [];
var $cca2e8cc539372e0$var$originTransform = $87ac8de5537d9a34$export$185802fd694ee1f5();
var $cca2e8cc539372e0$var$abs = Math.abs;
var $cca2e8cc539372e0$var$Transformable = function() {
    function Transformable() {}
    Transformable.prototype.getLocalTransform = function(m) {
        return $cca2e8cc539372e0$export$1157cd5386cdcc1b(this, m);
    };
    Transformable.prototype.setPosition = function(arr) {
        this.x = arr[0];
        this.y = arr[1];
    };
    Transformable.prototype.setScale = function(arr) {
        this.scaleX = arr[0];
        this.scaleY = arr[1];
    };
    Transformable.prototype.setSkew = function(arr) {
        this.skewX = arr[0];
        this.skewY = arr[1];
    };
    Transformable.prototype.setOrigin = function(arr) {
        this.originX = arr[0];
        this.originY = arr[1];
    };
    Transformable.prototype.needLocalTransform = function() {
        return $cca2e8cc539372e0$var$isNotAroundZero(this.rotation) || $cca2e8cc539372e0$var$isNotAroundZero(this.x) || $cca2e8cc539372e0$var$isNotAroundZero(this.y) || $cca2e8cc539372e0$var$isNotAroundZero(this.scaleX - 1) || $cca2e8cc539372e0$var$isNotAroundZero(this.scaleY - 1) || $cca2e8cc539372e0$var$isNotAroundZero(this.skewX) || $cca2e8cc539372e0$var$isNotAroundZero(this.skewY);
    };
    Transformable.prototype.updateTransform = function() {
        var parentTransform = this.parent && this.parent.transform;
        var needLocalTransform = this.needLocalTransform();
        var m = this.transform;
        if (!(needLocalTransform || parentTransform)) {
            if (m) {
                $cca2e8cc539372e0$var$mIdentity(m);
                this.invTransform = null;
            }
            return;
        }
        m = m || $87ac8de5537d9a34$export$185802fd694ee1f5();
        if (needLocalTransform) this.getLocalTransform(m);
        else $cca2e8cc539372e0$var$mIdentity(m);
        if (parentTransform) {
            if (needLocalTransform) $87ac8de5537d9a34$export$6e3a27864ab166fe(m, parentTransform, m);
            else $87ac8de5537d9a34$export$784d13d8ee351f07(m, parentTransform);
        }
        this.transform = m;
        this._resolveGlobalScaleRatio(m);
        this.invTransform = this.invTransform || $87ac8de5537d9a34$export$185802fd694ee1f5();
        $87ac8de5537d9a34$export$6897c284b6f9f4dc(this.invTransform, m);
    };
    Transformable.prototype._resolveGlobalScaleRatio = function(m) {
        var globalScaleRatio = this.globalScaleRatio;
        if (globalScaleRatio != null && globalScaleRatio !== 1) {
            this.getGlobalScale($cca2e8cc539372e0$var$scaleTmp);
            var relX = $cca2e8cc539372e0$var$scaleTmp[0] < 0 ? -1 : 1;
            var relY = $cca2e8cc539372e0$var$scaleTmp[1] < 0 ? -1 : 1;
            var sx = (($cca2e8cc539372e0$var$scaleTmp[0] - relX) * globalScaleRatio + relX) / $cca2e8cc539372e0$var$scaleTmp[0] || 0;
            var sy = (($cca2e8cc539372e0$var$scaleTmp[1] - relY) * globalScaleRatio + relY) / $cca2e8cc539372e0$var$scaleTmp[1] || 0;
            m[0] *= sx;
            m[1] *= sx;
            m[2] *= sy;
            m[3] *= sy;
        }
    };
    Transformable.prototype.getComputedTransform = function() {
        var transformNode = this;
        var ancestors = [];
        while(transformNode){
            ancestors.push(transformNode);
            transformNode = transformNode.parent;
        }
        while(transformNode = ancestors.pop())transformNode.updateTransform();
        return this.transform;
    };
    Transformable.prototype.setLocalTransform = function(m) {
        if (!m) return;
        var sx = m[0] * m[0] + m[1] * m[1];
        var sy = m[2] * m[2] + m[3] * m[3];
        var rotation = Math.atan2(m[1], m[0]);
        var shearX = Math.PI / 2 + rotation - Math.atan2(m[3], m[2]);
        sy = Math.sqrt(sy) * Math.cos(shearX);
        sx = Math.sqrt(sx);
        this.skewX = shearX;
        this.skewY = 0;
        this.rotation = -rotation;
        this.x = +m[4];
        this.y = +m[5];
        this.scaleX = sx;
        this.scaleY = sy;
        this.originX = 0;
        this.originY = 0;
    };
    Transformable.prototype.decomposeTransform = function() {
        if (!this.transform) return;
        var parent = this.parent;
        var m = this.transform;
        if (parent && parent.transform) {
            parent.invTransform = parent.invTransform || $87ac8de5537d9a34$export$185802fd694ee1f5();
            $87ac8de5537d9a34$export$6e3a27864ab166fe($cca2e8cc539372e0$var$tmpTransform, parent.invTransform, m);
            m = $cca2e8cc539372e0$var$tmpTransform;
        }
        var ox = this.originX;
        var oy = this.originY;
        if (ox || oy) {
            $cca2e8cc539372e0$var$originTransform[4] = ox;
            $cca2e8cc539372e0$var$originTransform[5] = oy;
            $87ac8de5537d9a34$export$6e3a27864ab166fe($cca2e8cc539372e0$var$tmpTransform, m, $cca2e8cc539372e0$var$originTransform);
            $cca2e8cc539372e0$var$tmpTransform[4] -= ox;
            $cca2e8cc539372e0$var$tmpTransform[5] -= oy;
            m = $cca2e8cc539372e0$var$tmpTransform;
        }
        this.setLocalTransform(m);
    };
    Transformable.prototype.getGlobalScale = function(out) {
        var m = this.transform;
        out = out || [];
        if (!m) {
            out[0] = 1;
            out[1] = 1;
            return out;
        }
        out[0] = Math.sqrt(m[0] * m[0] + m[1] * m[1]);
        out[1] = Math.sqrt(m[2] * m[2] + m[3] * m[3]);
        if (m[0] < 0) out[0] = -out[0];
        if (m[3] < 0) out[1] = -out[1];
        return out;
    };
    Transformable.prototype.transformCoordToLocal = function(x, y) {
        var v2 = [
            x,
            y
        ];
        var invTransform = this.invTransform;
        if (invTransform) $ee491d8f32bd01ff$export$9f9dcb98c894b623(v2, v2, invTransform);
        return v2;
    };
    Transformable.prototype.transformCoordToGlobal = function(x, y) {
        var v2 = [
            x,
            y
        ];
        var transform = this.transform;
        if (transform) $ee491d8f32bd01ff$export$9f9dcb98c894b623(v2, v2, transform);
        return v2;
    };
    Transformable.prototype.getLineScale = function() {
        var m = this.transform;
        return m && $cca2e8cc539372e0$var$abs(m[0] - 1) > 1e-10 && $cca2e8cc539372e0$var$abs(m[3] - 1) > 1e-10 ? Math.sqrt($cca2e8cc539372e0$var$abs(m[0] * m[3] - m[2] * m[1])) : 1;
    };
    Transformable.prototype.copyTransform = function(source) {
        $cca2e8cc539372e0$export$234b1c16dfa57d6a(this, source);
    };
    Transformable.getLocalTransform = function(target, m) {
        m = m || [];
        var ox = target.originX || 0;
        var oy = target.originY || 0;
        var sx = target.scaleX;
        var sy = target.scaleY;
        var ax = target.anchorX;
        var ay = target.anchorY;
        var rotation = target.rotation || 0;
        var x = target.x;
        var y = target.y;
        var skewX = target.skewX ? Math.tan(target.skewX) : 0;
        var skewY = target.skewY ? Math.tan(-target.skewY) : 0;
        if (ox || oy || ax || ay) {
            var dx = ox + ax;
            var dy = oy + ay;
            m[4] = -dx * sx - skewX * dy * sy;
            m[5] = -dy * sy - skewY * dx * sx;
        } else m[4] = m[5] = 0;
        m[0] = sx;
        m[3] = sy;
        m[1] = skewY * sx;
        m[2] = skewX * sy;
        rotation && $87ac8de5537d9a34$export$bb628a54ab399bc9(m, m, rotation);
        m[4] += ox + x;
        m[5] += oy + y;
        return m;
    };
    Transformable.initDefaultProps = function() {
        var proto = Transformable.prototype;
        proto.scaleX = proto.scaleY = proto.globalScaleRatio = 1;
        proto.x = proto.y = proto.originX = proto.originY = proto.skewX = proto.skewY = proto.rotation = proto.anchorX = proto.anchorY = 0;
    }();
    return Transformable;
}();
var $cca2e8cc539372e0$export$1157cd5386cdcc1b = $cca2e8cc539372e0$var$Transformable.getLocalTransform;
function $cca2e8cc539372e0$export$b78f9cf796c6d361() {
    return new $cca2e8cc539372e0$var$Transformable();
}
var $cca2e8cc539372e0$export$98ab6203ec3396e2 = [
    "x",
    "y",
    "originX",
    "originY",
    "anchorX",
    "anchorY",
    "rotation",
    "scaleX",
    "scaleY",
    "skewX",
    "skewY"
];
function $cca2e8cc539372e0$export$234b1c16dfa57d6a(target, source) {
    return (0, $43e0a445ed6711da$export$2b3af8009eff404f)(target, source, $cca2e8cc539372e0$export$98ab6203ec3396e2);
}
var $cca2e8cc539372e0$export$2e2bcd8739ae039 = $cca2e8cc539372e0$var$Transformable;








function $67e15a06bdb46d49$export$3c49c185de0c2bfc(text, font) {
    return $67e15a06bdb46d49$export$e6849d91c2a0b61f($67e15a06bdb46d49$export$23ef3ef10b010856(font), text);
}
function $67e15a06bdb46d49$export$23ef3ef10b010856(font) {
    if (!$67e15a06bdb46d49$var$_fontMeasureInfoCache) $67e15a06bdb46d49$var$_fontMeasureInfoCache = new (0, $0a70a3b1dc4cb6e5$export$2e2bcd8739ae039)(100);
    font = font || (0, $08c3209e6efc839a$export$7d7a232b6d2cc80c);
    var measureInfo = $67e15a06bdb46d49$var$_fontMeasureInfoCache.get(font);
    if (!measureInfo) {
        measureInfo = {
            font: font,
            strWidthCache: new (0, $0a70a3b1dc4cb6e5$export$2e2bcd8739ae039)(500),
            asciiWidthMap: null,
            asciiWidthMapTried: false,
            stWideCharWidth: (0, $08c3209e6efc839a$export$ef5e599365494451).measureText("\u56FD", font).width,
            asciiCharWidth: (0, $08c3209e6efc839a$export$ef5e599365494451).measureText("a", font).width
        };
        $67e15a06bdb46d49$var$_fontMeasureInfoCache.put(font, measureInfo);
    }
    return measureInfo;
}
var $67e15a06bdb46d49$var$_fontMeasureInfoCache;
function $67e15a06bdb46d49$var$tryCreateASCIIWidthMap(font) {
    if ($67e15a06bdb46d49$var$_getASCIIWidthMapLongCount >= $67e15a06bdb46d49$var$GET_ASCII_WIDTH_LONG_COUNT_MAX) return;
    font = font || (0, $08c3209e6efc839a$export$7d7a232b6d2cc80c);
    var asciiWidthMap = [];
    var start = +new Date();
    for(var code = 0; code <= 127; code++)asciiWidthMap[code] = (0, $08c3209e6efc839a$export$ef5e599365494451).measureText(String.fromCharCode(code), font).width;
    var cost = +new Date() - start;
    if (cost > 16) $67e15a06bdb46d49$var$_getASCIIWidthMapLongCount = $67e15a06bdb46d49$var$GET_ASCII_WIDTH_LONG_COUNT_MAX;
    else if (cost > 2) $67e15a06bdb46d49$var$_getASCIIWidthMapLongCount++;
    return asciiWidthMap;
}
var $67e15a06bdb46d49$var$_getASCIIWidthMapLongCount = 0;
var $67e15a06bdb46d49$var$GET_ASCII_WIDTH_LONG_COUNT_MAX = 5;
function $67e15a06bdb46d49$export$4e92f5603b5c7bb3(fontMeasureInfo, charCode) {
    if (!fontMeasureInfo.asciiWidthMapTried) {
        fontMeasureInfo.asciiWidthMap = $67e15a06bdb46d49$var$tryCreateASCIIWidthMap(fontMeasureInfo.font);
        fontMeasureInfo.asciiWidthMapTried = true;
    }
    return 0 <= charCode && charCode <= 127 ? fontMeasureInfo.asciiWidthMap != null ? fontMeasureInfo.asciiWidthMap[charCode] : fontMeasureInfo.asciiCharWidth : fontMeasureInfo.stWideCharWidth;
}
function $67e15a06bdb46d49$export$e6849d91c2a0b61f(fontMeasureInfo, text) {
    var strWidthCache = fontMeasureInfo.strWidthCache;
    var width = strWidthCache.get(text);
    if (width == null) {
        width = (0, $08c3209e6efc839a$export$ef5e599365494451).measureText(text, fontMeasureInfo.font).width;
        strWidthCache.put(text, width);
    }
    return width;
}
function $67e15a06bdb46d49$export$85aabf24202fbe9b(text, font, textAlign, textBaseline) {
    var width = $67e15a06bdb46d49$export$e6849d91c2a0b61f($67e15a06bdb46d49$export$23ef3ef10b010856(font), text);
    var height = $67e15a06bdb46d49$export$56204a27a2958a55(font);
    var x = $67e15a06bdb46d49$export$eb5a525ef00ef9a4(0, width, textAlign);
    var y = $67e15a06bdb46d49$export$bf7d6802d2badd9(0, height, textBaseline);
    var rect = new (0, $c437f598d9c9ee16$export$2e2bcd8739ae039)(x, y, width, height);
    return rect;
}
function $67e15a06bdb46d49$export$c381147bfed79d9f(text, font, textAlign, textBaseline) {
    var textLines = ((text || "") + "").split("\n");
    var len = textLines.length;
    if (len === 1) return $67e15a06bdb46d49$export$85aabf24202fbe9b(textLines[0], font, textAlign, textBaseline);
    else {
        var uniondRect = new (0, $c437f598d9c9ee16$export$2e2bcd8739ae039)(0, 0, 0, 0);
        for(var i = 0; i < textLines.length; i++){
            var rect = $67e15a06bdb46d49$export$85aabf24202fbe9b(textLines[i], font, textAlign, textBaseline);
            i === 0 ? uniondRect.copy(rect) : uniondRect.union(rect);
        }
        return uniondRect;
    }
}
function $67e15a06bdb46d49$export$eb5a525ef00ef9a4(x, width, textAlign, inverse) {
    if (textAlign === "right") !inverse ? x -= width : x += width;
    else if (textAlign === "center") !inverse ? x -= width / 2 : x += width / 2;
    return x;
}
function $67e15a06bdb46d49$export$bf7d6802d2badd9(y, height, verticalAlign, inverse) {
    if (verticalAlign === "middle") !inverse ? y -= height / 2 : y += height / 2;
    else if (verticalAlign === "bottom") !inverse ? y -= height : y += height;
    return y;
}
function $67e15a06bdb46d49$export$56204a27a2958a55(font) {
    return $67e15a06bdb46d49$export$23ef3ef10b010856(font).stWideCharWidth;
}
function $67e15a06bdb46d49$export$866cc30a33805630(text, font) {
    return (0, $08c3209e6efc839a$export$ef5e599365494451).measureText(text, font);
}
function $67e15a06bdb46d49$export$e8514cb5a5e2b40f(value, maxValue) {
    if (typeof value === "string") {
        if (value.lastIndexOf("%") >= 0) return parseFloat(value) / 100 * maxValue;
        return parseFloat(value);
    }
    return value;
}
function $67e15a06bdb46d49$export$eee3603b512feab7(out, opts, rect) {
    var textPosition = opts.position || "inside";
    var distance = opts.distance != null ? opts.distance : 5;
    var height = rect.height;
    var width = rect.width;
    var halfHeight = height / 2;
    var x = rect.x;
    var y = rect.y;
    var textAlign = "left";
    var textVerticalAlign = "top";
    if (textPosition instanceof Array) {
        x += $67e15a06bdb46d49$export$e8514cb5a5e2b40f(textPosition[0], rect.width);
        y += $67e15a06bdb46d49$export$e8514cb5a5e2b40f(textPosition[1], rect.height);
        textAlign = null;
        textVerticalAlign = null;
    } else switch(textPosition){
        case "left":
            x -= distance;
            y += halfHeight;
            textAlign = "right";
            textVerticalAlign = "middle";
            break;
        case "right":
            x += distance + width;
            y += halfHeight;
            textVerticalAlign = "middle";
            break;
        case "top":
            x += width / 2;
            y -= distance;
            textAlign = "center";
            textVerticalAlign = "bottom";
            break;
        case "bottom":
            x += width / 2;
            y += height + distance;
            textAlign = "center";
            break;
        case "inside":
            x += width / 2;
            y += halfHeight;
            textAlign = "center";
            textVerticalAlign = "middle";
            break;
        case "insideLeft":
            x += distance;
            y += halfHeight;
            textVerticalAlign = "middle";
            break;
        case "insideRight":
            x += width - distance;
            y += halfHeight;
            textAlign = "right";
            textVerticalAlign = "middle";
            break;
        case "insideTop":
            x += width / 2;
            y += distance;
            textAlign = "center";
            break;
        case "insideBottom":
            x += width / 2;
            y += height - distance;
            textAlign = "center";
            textVerticalAlign = "bottom";
            break;
        case "insideTopLeft":
            x += distance;
            y += distance;
            break;
        case "insideTopRight":
            x += width - distance;
            y += distance;
            textAlign = "right";
            break;
        case "insideBottomLeft":
            x += distance;
            y += height - distance;
            textVerticalAlign = "bottom";
            break;
        case "insideBottomRight":
            x += width - distance;
            y += height - distance;
            textAlign = "right";
            textVerticalAlign = "bottom";
            break;
    }
    out = out || {};
    out.x = x;
    out.y = y;
    out.align = textAlign;
    out.verticalAlign = textVerticalAlign;
    return out;
}







var $0b8373c26fe287ed$export$97b5e845c7286801 = "__zr_normal__";
var $0b8373c26fe287ed$var$PRIMARY_STATES_KEYS = (0, $cca2e8cc539372e0$export$98ab6203ec3396e2).concat([
    "ignore"
]);
var $0b8373c26fe287ed$var$DEFAULT_ANIMATABLE_MAP = (0, $43e0a445ed6711da$export$533b26079ad0b4b)((0, $cca2e8cc539372e0$export$98ab6203ec3396e2), function(obj, key) {
    obj[key] = true;
    return obj;
}, {
    ignore: false
});
var $0b8373c26fe287ed$var$tmpTextPosCalcRes = {};
var $0b8373c26fe287ed$var$tmpBoundingRect = new (0, $c437f598d9c9ee16$export$2e2bcd8739ae039)(0, 0, 0, 0);
var $0b8373c26fe287ed$var$tmpInnerTextTrans = [];
var $0b8373c26fe287ed$export$afb92d844f688c8d = 0;
var $0b8373c26fe287ed$export$f5347ae640a7f0d0 = 1;
var $0b8373c26fe287ed$var$Element = function() {
    function Element(props) {
        this.id = (0, $43e0a445ed6711da$export$46e8f25c7328f77e)();
        this.animators = [];
        this.currentStates = [];
        this.states = {};
        this._init(props);
    }
    Element.prototype._init = function(props) {
        this.attr(props);
    };
    Element.prototype.drift = function(dx, dy, e) {
        switch(this.draggable){
            case "horizontal":
                dy = 0;
                break;
            case "vertical":
                dx = 0;
                break;
        }
        var m = this.transform;
        if (!m) m = this.transform = [
            1,
            0,
            0,
            1,
            0,
            0
        ];
        m[4] += dx;
        m[5] += dy;
        this.decomposeTransform();
        this.markRedraw();
    };
    Element.prototype.beforeUpdate = function() {};
    Element.prototype.afterUpdate = function() {};
    Element.prototype.update = function() {
        this.updateTransform();
        if (this.__dirty) this.updateInnerText();
    };
    Element.prototype.updateInnerText = function(forceUpdate) {
        var textEl = this._textContent;
        if (textEl && (!textEl.ignore || forceUpdate)) {
            if (!this.textConfig) this.textConfig = {};
            var textConfig = this.textConfig;
            var isLocal = textConfig.local;
            var innerTransformable = textEl.innerTransformable;
            var textAlign = void 0;
            var textVerticalAlign = void 0;
            var textStyleChanged = false;
            innerTransformable.parent = isLocal ? this : null;
            var innerOrigin = false;
            innerTransformable.copyTransform(textEl);
            var hasPosition = textConfig.position != null;
            var autoOverflowArea = textConfig.autoOverflowArea;
            var layoutRect = void 0;
            if (autoOverflowArea || hasPosition) {
                layoutRect = $0b8373c26fe287ed$var$tmpBoundingRect;
                if (textConfig.layoutRect) layoutRect.copy(textConfig.layoutRect);
                else layoutRect.copy(this.getBoundingRect());
                if (!isLocal) layoutRect.applyTransform(this.transform);
            }
            if (hasPosition) {
                if (this.calculateTextPosition) this.calculateTextPosition($0b8373c26fe287ed$var$tmpTextPosCalcRes, textConfig, layoutRect);
                else (0, $67e15a06bdb46d49$export$eee3603b512feab7)($0b8373c26fe287ed$var$tmpTextPosCalcRes, textConfig, layoutRect);
                innerTransformable.x = $0b8373c26fe287ed$var$tmpTextPosCalcRes.x;
                innerTransformable.y = $0b8373c26fe287ed$var$tmpTextPosCalcRes.y;
                textAlign = $0b8373c26fe287ed$var$tmpTextPosCalcRes.align;
                textVerticalAlign = $0b8373c26fe287ed$var$tmpTextPosCalcRes.verticalAlign;
                var textOrigin = textConfig.origin;
                if (textOrigin && textConfig.rotation != null) {
                    var relOriginX = void 0;
                    var relOriginY = void 0;
                    if (textOrigin === "center") {
                        relOriginX = layoutRect.width * 0.5;
                        relOriginY = layoutRect.height * 0.5;
                    } else {
                        relOriginX = (0, $67e15a06bdb46d49$export$e8514cb5a5e2b40f)(textOrigin[0], layoutRect.width);
                        relOriginY = (0, $67e15a06bdb46d49$export$e8514cb5a5e2b40f)(textOrigin[1], layoutRect.height);
                    }
                    innerOrigin = true;
                    innerTransformable.originX = -innerTransformable.x + relOriginX + (isLocal ? 0 : layoutRect.x);
                    innerTransformable.originY = -innerTransformable.y + relOriginY + (isLocal ? 0 : layoutRect.y);
                }
            }
            if (textConfig.rotation != null) innerTransformable.rotation = textConfig.rotation;
            var textOffset = textConfig.offset;
            if (textOffset) {
                innerTransformable.x += textOffset[0];
                innerTransformable.y += textOffset[1];
                if (!innerOrigin) {
                    innerTransformable.originX = -textOffset[0];
                    innerTransformable.originY = -textOffset[1];
                }
            }
            var innerTextDefaultStyle = this._innerTextDefaultStyle || (this._innerTextDefaultStyle = {});
            if (autoOverflowArea) {
                var overflowRect = innerTextDefaultStyle.overflowRect = innerTextDefaultStyle.overflowRect || new (0, $c437f598d9c9ee16$export$2e2bcd8739ae039)(0, 0, 0, 0);
                innerTransformable.getLocalTransform($0b8373c26fe287ed$var$tmpInnerTextTrans);
                (0, $87ac8de5537d9a34$export$6897c284b6f9f4dc)($0b8373c26fe287ed$var$tmpInnerTextTrans, $0b8373c26fe287ed$var$tmpInnerTextTrans);
                (0, $c437f598d9c9ee16$export$2e2bcd8739ae039).copy(overflowRect, layoutRect);
                overflowRect.applyTransform($0b8373c26fe287ed$var$tmpInnerTextTrans);
            } else innerTextDefaultStyle.overflowRect = null;
            var isInside = textConfig.inside == null ? typeof textConfig.position === "string" && textConfig.position.indexOf("inside") >= 0 : textConfig.inside;
            var textFill = void 0;
            var textStroke = void 0;
            var autoStroke = void 0;
            if (isInside && this.canBeInsideText()) {
                textFill = textConfig.insideFill;
                textStroke = textConfig.insideStroke;
                if (textFill == null || textFill === "auto") textFill = this.getInsideTextFill();
                if (textStroke == null || textStroke === "auto") {
                    textStroke = this.getInsideTextStroke(textFill);
                    autoStroke = true;
                }
            } else {
                textFill = textConfig.outsideFill;
                textStroke = textConfig.outsideStroke;
                if (textFill == null || textFill === "auto") textFill = this.getOutsideFill();
                if (textStroke == null || textStroke === "auto") {
                    textStroke = this.getOutsideStroke(textFill);
                    autoStroke = true;
                }
            }
            textFill = textFill || "#000";
            if (textFill !== innerTextDefaultStyle.fill || textStroke !== innerTextDefaultStyle.stroke || autoStroke !== innerTextDefaultStyle.autoStroke || textAlign !== innerTextDefaultStyle.align || textVerticalAlign !== innerTextDefaultStyle.verticalAlign) {
                textStyleChanged = true;
                innerTextDefaultStyle.fill = textFill;
                innerTextDefaultStyle.stroke = textStroke;
                innerTextDefaultStyle.autoStroke = autoStroke;
                innerTextDefaultStyle.align = textAlign;
                innerTextDefaultStyle.verticalAlign = textVerticalAlign;
                textEl.setDefaultTextStyle(innerTextDefaultStyle);
            }
            textEl.__dirty |= (0, $24fa4a8d26d34a24$export$a7b6db622c6c7dbd);
            if (textStyleChanged) textEl.dirtyStyle(true);
        }
    };
    Element.prototype.canBeInsideText = function() {
        return true;
    };
    Element.prototype.getInsideTextFill = function() {
        return "#fff";
    };
    Element.prototype.getInsideTextStroke = function(textFill) {
        return "#000";
    };
    Element.prototype.getOutsideFill = function() {
        return this.__zr && this.__zr.isDarkMode() ? (0, $b4769615a730dcfc$export$3c6e95f318c8369b) : (0, $b4769615a730dcfc$export$f8ce94761f39398d);
    };
    Element.prototype.getOutsideStroke = function(textFill) {
        var backgroundColor = this.__zr && this.__zr.getBackgroundColor();
        var colorArr = typeof backgroundColor === "string" && (0, $b0979f18b0a232f9$export$98e6a39c04603d36)(backgroundColor);
        if (!colorArr) colorArr = [
            255,
            255,
            255,
            1
        ];
        var alpha = colorArr[3];
        var isDark = this.__zr.isDarkMode();
        for(var i = 0; i < 3; i++)colorArr[i] = colorArr[i] * alpha + (isDark ? 0 : 255) * (1 - alpha);
        colorArr[3] = 1;
        return (0, $b0979f18b0a232f9$export$fac44ee5b035f737)(colorArr, "rgba");
    };
    Element.prototype.traverse = function(cb, context) {};
    Element.prototype.attrKV = function(key, value) {
        if (key === "textConfig") this.setTextConfig(value);
        else if (key === "textContent") this.setTextContent(value);
        else if (key === "clipPath") this.setClipPath(value);
        else if (key === "extra") {
            this.extra = this.extra || {};
            (0, $43e0a445ed6711da$export$8b58be045bf06082)(this.extra, value);
        } else this[key] = value;
    };
    Element.prototype.hide = function() {
        this.ignore = true;
        this.markRedraw();
    };
    Element.prototype.show = function() {
        this.ignore = false;
        this.markRedraw();
    };
    Element.prototype.attr = function(keyOrObj, value) {
        if (typeof keyOrObj === "string") this.attrKV(keyOrObj, value);
        else if ((0, $43e0a445ed6711da$export$a6cdc56e425d0d0a)(keyOrObj)) {
            var obj = keyOrObj;
            var keysArr = (0, $43e0a445ed6711da$export$ed97f33186d4b816)(obj);
            for(var i = 0; i < keysArr.length; i++){
                var key = keysArr[i];
                this.attrKV(key, keyOrObj[key]);
            }
        }
        this.markRedraw();
        return this;
    };
    Element.prototype.saveCurrentToNormalState = function(toState) {
        this._innerSaveToNormal(toState);
        var normalState = this._normalState;
        for(var i = 0; i < this.animators.length; i++){
            var animator = this.animators[i];
            var fromStateTransition = animator.__fromStateTransition;
            if (animator.getLoop() || fromStateTransition && fromStateTransition !== $0b8373c26fe287ed$export$97b5e845c7286801) continue;
            var targetName = animator.targetName;
            var target = targetName ? normalState[targetName] : normalState;
            animator.saveTo(target);
        }
    };
    Element.prototype._innerSaveToNormal = function(toState) {
        var normalState = this._normalState;
        if (!normalState) normalState = this._normalState = {};
        if (toState.textConfig && !normalState.textConfig) normalState.textConfig = this.textConfig;
        this._savePrimaryToNormal(toState, normalState, $0b8373c26fe287ed$var$PRIMARY_STATES_KEYS);
    };
    Element.prototype._savePrimaryToNormal = function(toState, normalState, primaryKeys) {
        for(var i = 0; i < primaryKeys.length; i++){
            var key = primaryKeys[i];
            if (toState[key] != null && !(key in normalState)) normalState[key] = this[key];
        }
    };
    Element.prototype.hasState = function() {
        return this.currentStates.length > 0;
    };
    Element.prototype.getState = function(name) {
        return this.states[name];
    };
    Element.prototype.ensureState = function(name) {
        var states = this.states;
        if (!states[name]) states[name] = {};
        return states[name];
    };
    Element.prototype.clearStates = function(noAnimation) {
        this.useState($0b8373c26fe287ed$export$97b5e845c7286801, false, noAnimation);
    };
    Element.prototype.useState = function(stateName, keepCurrentStates, noAnimation, forceUseHoverLayer) {
        var toNormalState = stateName === $0b8373c26fe287ed$export$97b5e845c7286801;
        var hasStates = this.hasState();
        if (!hasStates && toNormalState) return;
        var currentStates = this.currentStates;
        var animationCfg = this.stateTransition;
        if ((0, $43e0a445ed6711da$export$305f7d4e9d4624f2)(currentStates, stateName) >= 0 && (keepCurrentStates || currentStates.length === 1)) return;
        var state;
        if (this.stateProxy && !toNormalState) state = this.stateProxy(stateName);
        if (!state) state = this.states && this.states[stateName];
        if (!state && !toNormalState) {
            (0, $43e0a445ed6711da$export$58da9968c3170cb1)("State " + stateName + " not exists.");
            return;
        }
        if (!toNormalState) this.saveCurrentToNormalState(state);
        var textContent = this._textContent;
        var useHoverLayer = $0b8373c26fe287ed$var$shouldUseHoverLayer(this, textContent, state, forceUseHoverLayer);
        if (useHoverLayer && !this.__inHover) this.__inHover = useHoverLayer;
        this._applyStateObj(stateName, state, this._normalState, keepCurrentStates, $0b8373c26fe287ed$var$canTransition(this, noAnimation, animationCfg), animationCfg);
        var textGuide = this._textGuide;
        if (textContent) textContent.useState(stateName, keepCurrentStates, noAnimation, !!useHoverLayer);
        if (textGuide) textGuide.useState(stateName, keepCurrentStates, noAnimation, !!useHoverLayer);
        if (toNormalState) {
            this.currentStates = [];
            this._normalState = {};
        } else if (!keepCurrentStates) this.currentStates = [
            stateName
        ];
        else this.currentStates.push(stateName);
        this._updateAnimationTargets();
        this.markRedraw();
        if (!useHoverLayer && this.__inHover) {
            this.__inHover = $0b8373c26fe287ed$export$afb92d844f688c8d;
            this.__dirty &= ~(0, $24fa4a8d26d34a24$export$a7b6db622c6c7dbd);
        }
        return state;
    };
    Element.prototype.useStates = function(states, noAnimation, forceUseHoverLayer) {
        if (!states.length) this.clearStates();
        else {
            var stateObjects = [];
            var currentStates = this.currentStates;
            var len = states.length;
            var notChange = len === currentStates.length;
            if (notChange) {
                for(var i = 0; i < len; i++)if (states[i] !== currentStates[i]) {
                    notChange = false;
                    break;
                }
            }
            if (notChange) return;
            for(var i = 0; i < len; i++){
                var stateName = states[i];
                var stateObj = void 0;
                if (this.stateProxy) stateObj = this.stateProxy(stateName, states);
                if (!stateObj) stateObj = this.states[stateName];
                if (stateObj) stateObjects.push(stateObj);
            }
            var lastStateObj = stateObjects[len - 1];
            var textContent = this._textContent;
            var useHoverLayer = $0b8373c26fe287ed$var$shouldUseHoverLayer(this, textContent, lastStateObj, forceUseHoverLayer);
            if (useHoverLayer && !this.__inHover) this.__inHover = useHoverLayer;
            var mergedState = this._mergeStates(stateObjects);
            var animationCfg = this.stateTransition;
            this.saveCurrentToNormalState(mergedState);
            this._applyStateObj(states.join(","), mergedState, this._normalState, false, $0b8373c26fe287ed$var$canTransition(this, noAnimation, animationCfg), animationCfg);
            var textGuide = this._textGuide;
            if (textContent) textContent.useStates(states, noAnimation, !!useHoverLayer);
            if (textGuide) textGuide.useStates(states, noAnimation, !!useHoverLayer);
            this._updateAnimationTargets();
            this.currentStates = states.slice();
            this.markRedraw();
            if (!useHoverLayer && this.__inHover) {
                this.__inHover = $0b8373c26fe287ed$export$afb92d844f688c8d;
                this.__dirty &= ~(0, $24fa4a8d26d34a24$export$a7b6db622c6c7dbd);
            }
        }
    };
    Element.prototype.isSilent = function() {
        var el = this;
        while(el){
            if (el.silent) return true;
            var hostEl = el.__hostTarget;
            el = hostEl ? el.ignoreHostSilent ? null : hostEl : el.parent;
        }
        return false;
    };
    Element.prototype._updateAnimationTargets = function() {
        for(var i = 0; i < this.animators.length; i++){
            var animator = this.animators[i];
            if (animator.targetName) animator.changeTarget(this[animator.targetName]);
        }
    };
    Element.prototype.removeState = function(state) {
        var idx = (0, $43e0a445ed6711da$export$305f7d4e9d4624f2)(this.currentStates, state);
        if (idx >= 0) {
            var currentStates = this.currentStates.slice();
            currentStates.splice(idx, 1);
            this.useStates(currentStates);
        }
    };
    Element.prototype.replaceState = function(oldState, newState, forceAdd) {
        var currentStates = this.currentStates.slice();
        var idx = (0, $43e0a445ed6711da$export$305f7d4e9d4624f2)(currentStates, oldState);
        var newStateExists = (0, $43e0a445ed6711da$export$305f7d4e9d4624f2)(currentStates, newState) >= 0;
        if (idx >= 0) {
            if (!newStateExists) currentStates[idx] = newState;
            else currentStates.splice(idx, 1);
        } else if (forceAdd && !newStateExists) currentStates.push(newState);
        this.useStates(currentStates);
    };
    Element.prototype.toggleState = function(state, enable) {
        if (enable) this.useState(state, true);
        else this.removeState(state);
    };
    Element.prototype._mergeStates = function(states) {
        var mergedState = {};
        var mergedTextConfig;
        for(var i = 0; i < states.length; i++){
            var state = states[i];
            (0, $43e0a445ed6711da$export$8b58be045bf06082)(mergedState, state);
            if (state.textConfig) {
                mergedTextConfig = mergedTextConfig || {};
                (0, $43e0a445ed6711da$export$8b58be045bf06082)(mergedTextConfig, state.textConfig);
            }
        }
        if (mergedTextConfig) mergedState.textConfig = mergedTextConfig;
        return mergedState;
    };
    Element.prototype._applyStateObj = function(stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
        if (this.__inHover === $0b8373c26fe287ed$export$f5347ae640a7f0d0) return;
        var needsRestoreToNormal = !(state && keepCurrentStates);
        if (state && state.textConfig) {
            this.textConfig = (0, $43e0a445ed6711da$export$8b58be045bf06082)({}, keepCurrentStates ? this.textConfig : normalState.textConfig);
            (0, $43e0a445ed6711da$export$8b58be045bf06082)(this.textConfig, state.textConfig);
        } else if (needsRestoreToNormal) {
            if (normalState.textConfig) this.textConfig = normalState.textConfig;
        }
        var transitionTarget = {};
        var hasTransition = false;
        for(var i = 0; i < $0b8373c26fe287ed$var$PRIMARY_STATES_KEYS.length; i++){
            var key = $0b8373c26fe287ed$var$PRIMARY_STATES_KEYS[i];
            var propNeedsTransition = transition && $0b8373c26fe287ed$var$DEFAULT_ANIMATABLE_MAP[key];
            if (state && state[key] != null) {
                if (propNeedsTransition) {
                    hasTransition = true;
                    transitionTarget[key] = state[key];
                } else this[key] = state[key];
            } else if (needsRestoreToNormal) {
                if (normalState[key] != null) {
                    if (propNeedsTransition) {
                        hasTransition = true;
                        transitionTarget[key] = normalState[key];
                    } else this[key] = normalState[key];
                }
            }
        }
        if (!transition) for(var i = 0; i < this.animators.length; i++){
            var animator = this.animators[i];
            var targetName = animator.targetName;
            if (!animator.getLoop()) animator.__changeFinalValue(targetName ? (state || normalState)[targetName] : state || normalState);
        }
        if (hasTransition) this._transitionState(stateName, transitionTarget, animationCfg);
    };
    Element.prototype._attachComponent = function(componentEl) {
        if (componentEl.__zr && !componentEl.__hostTarget) return;
        if (componentEl === this) return;
        var zr = this.__zr;
        if (zr) componentEl.addSelfToZr(zr);
        componentEl.__zr = zr;
        componentEl.__hostTarget = this;
    };
    Element.prototype._detachComponent = function(componentEl) {
        if (componentEl.__zr) componentEl.removeSelfFromZr(componentEl.__zr);
        componentEl.__zr = null;
        componentEl.__hostTarget = null;
    };
    Element.prototype.getClipPath = function() {
        return this._clipPath;
    };
    Element.prototype.setClipPath = function(clipPath) {
        if (this._clipPath && this._clipPath !== clipPath) this.removeClipPath();
        this._attachComponent(clipPath);
        this._clipPath = clipPath;
        this.markRedraw();
    };
    Element.prototype.removeClipPath = function() {
        var clipPath = this._clipPath;
        if (clipPath) {
            this._detachComponent(clipPath);
            this._clipPath = null;
            this.markRedraw();
        }
    };
    Element.prototype.getTextContent = function() {
        return this._textContent;
    };
    Element.prototype.setTextContent = function(textEl) {
        var previousTextContent = this._textContent;
        if (previousTextContent === textEl) return;
        if (previousTextContent && previousTextContent !== textEl) this.removeTextContent();
        textEl.innerTransformable = new (0, $cca2e8cc539372e0$export$2e2bcd8739ae039)();
        this._attachComponent(textEl);
        this._textContent = textEl;
        this.markRedraw();
    };
    Element.prototype.setTextConfig = function(cfg) {
        if (!this.textConfig) this.textConfig = {};
        (0, $43e0a445ed6711da$export$8b58be045bf06082)(this.textConfig, cfg);
        this.markRedraw();
    };
    Element.prototype.removeTextConfig = function() {
        this.textConfig = null;
        this.markRedraw();
    };
    Element.prototype.removeTextContent = function() {
        var textEl = this._textContent;
        if (textEl) {
            textEl.innerTransformable = null;
            this._detachComponent(textEl);
            this._textContent = null;
            this._innerTextDefaultStyle = null;
            this.markRedraw();
        }
    };
    Element.prototype.getTextGuideLine = function() {
        return this._textGuide;
    };
    Element.prototype.setTextGuideLine = function(guideLine) {
        if (this._textGuide && this._textGuide !== guideLine) this.removeTextGuideLine();
        this._attachComponent(guideLine);
        this._textGuide = guideLine;
        this.markRedraw();
    };
    Element.prototype.removeTextGuideLine = function() {
        var textGuide = this._textGuide;
        if (textGuide) {
            this._detachComponent(textGuide);
            this._textGuide = null;
            this.markRedraw();
        }
    };
    Element.prototype.markRedraw = function() {
        this.__dirty |= (0, $24fa4a8d26d34a24$export$a7b6db622c6c7dbd);
        var zr = this.__zr;
        if (zr) {
            if (this.__inHover) zr.refreshHover();
            else zr.refresh();
        }
        if (this.__hostTarget) this.__hostTarget.markRedraw();
    };
    Element.prototype.dirty = function() {
        this.markRedraw();
    };
    Element.prototype.addSelfToZr = function(zr) {
        if (this.__zr === zr) return;
        this.__zr = zr;
        var animators = this.animators;
        if (animators) for(var i = 0; i < animators.length; i++)zr.animation.addAnimator(animators[i]);
        if (this._clipPath) this._clipPath.addSelfToZr(zr);
        if (this._textContent) this._textContent.addSelfToZr(zr);
        if (this._textGuide) this._textGuide.addSelfToZr(zr);
    };
    Element.prototype.removeSelfFromZr = function(zr) {
        if (!this.__zr) return;
        this.__zr = null;
        var animators = this.animators;
        if (animators) for(var i = 0; i < animators.length; i++)zr.animation.removeAnimator(animators[i]);
        if (this._clipPath) this._clipPath.removeSelfFromZr(zr);
        if (this._textContent) this._textContent.removeSelfFromZr(zr);
        if (this._textGuide) this._textGuide.removeSelfFromZr(zr);
    };
    Element.prototype.animate = function(key, loop, allowDiscreteAnimation) {
        var target = key ? this[key] : this;
        var animator = new (0, $b0a396476612fe2c$export$2e2bcd8739ae039)(target, loop, allowDiscreteAnimation);
        key && (animator.targetName = key);
        this.addAnimator(animator, key);
        return animator;
    };
    Element.prototype.addAnimator = function(animator, key) {
        var zr = this.__zr;
        var el = this;
        animator.during(function() {
            el.updateDuringAnimation(key);
        }).done(function() {
            var animators = el.animators;
            var idx = (0, $43e0a445ed6711da$export$305f7d4e9d4624f2)(animators, animator);
            if (idx >= 0) animators.splice(idx, 1);
        });
        this.animators.push(animator);
        if (zr) zr.animation.addAnimator(animator);
        zr && zr.wakeUp();
    };
    Element.prototype.updateDuringAnimation = function(key) {
        this.markRedraw();
    };
    Element.prototype.stopAnimation = function(scope, forwardToLast) {
        var animators = this.animators;
        var len = animators.length;
        var leftAnimators = [];
        for(var i = 0; i < len; i++){
            var animator = animators[i];
            if (!scope || scope === animator.scope) animator.stop(forwardToLast);
            else leftAnimators.push(animator);
        }
        this.animators = leftAnimators;
        return this;
    };
    Element.prototype.animateTo = function(target, cfg, animationProps) {
        $0b8373c26fe287ed$var$animateTo(this, target, cfg, animationProps);
    };
    Element.prototype.animateFrom = function(target, cfg, animationProps) {
        $0b8373c26fe287ed$var$animateTo(this, target, cfg, animationProps, true);
    };
    Element.prototype._transitionState = function(stateName, target, cfg, animationProps) {
        var animators = $0b8373c26fe287ed$var$animateTo(this, target, cfg, animationProps);
        for(var i = 0; i < animators.length; i++)animators[i].__fromStateTransition = stateName;
    };
    Element.prototype.getBoundingRect = function() {
        return null;
    };
    Element.prototype.getPaintRect = function() {
        return null;
    };
    Element.initDefaultProps = function() {
        var elProto = Element.prototype;
        elProto.type = "element";
        elProto.name = "";
        elProto.ignore = elProto.silent = elProto.ignoreHostSilent = elProto.isGroup = elProto.draggable = elProto.dragging = elProto.ignoreClip = false;
        elProto.__inHover = $0b8373c26fe287ed$export$afb92d844f688c8d;
        elProto.__dirty = (0, $24fa4a8d26d34a24$export$a7b6db622c6c7dbd);
        var logs = {};
        function logDeprecatedError(key, xKey, yKey) {
            if (!logs[key + xKey + yKey]) {
                console.warn("DEPRECATED: '" + key + "' has been deprecated. use '" + xKey + "', '" + yKey + "' instead");
                logs[key + xKey + yKey] = true;
            }
        }
        function createLegacyProperty(key, privateKey, xKey, yKey) {
            Object.defineProperty(elProto, key, {
                get: function() {
                    if (!this[privateKey]) {
                        var pos = this[privateKey] = [];
                        enhanceArray(this, pos);
                    }
                    return this[privateKey];
                },
                set: function(pos) {
                    this[xKey] = pos[0];
                    this[yKey] = pos[1];
                    this[privateKey] = pos;
                    enhanceArray(this, pos);
                }
            });
            function enhanceArray(self, pos) {
                Object.defineProperty(pos, 0, {
                    get: function() {
                        return self[xKey];
                    },
                    set: function(val) {
                        self[xKey] = val;
                    }
                });
                Object.defineProperty(pos, 1, {
                    get: function() {
                        return self[yKey];
                    },
                    set: function(val) {
                        self[yKey] = val;
                    }
                });
            }
        }
        if (Object.defineProperty) {
            createLegacyProperty("position", "_legacyPos", "x", "y");
            createLegacyProperty("scale", "_legacyScale", "scaleX", "scaleY");
            createLegacyProperty("origin", "_legacyOrigin", "originX", "originY");
        }
    }();
    return Element;
}();
(0, $43e0a445ed6711da$export$e36fc9d62a853069)($0b8373c26fe287ed$var$Element, (0, $131b7833cdf735df$export$2e2bcd8739ae039));
(0, $43e0a445ed6711da$export$e36fc9d62a853069)($0b8373c26fe287ed$var$Element, (0, $cca2e8cc539372e0$export$2e2bcd8739ae039));
function $0b8373c26fe287ed$var$animateTo(animatable, target, cfg, animationProps, reverse) {
    cfg = cfg || {};
    var animators = [];
    $0b8373c26fe287ed$var$animateToShallow(animatable, "", animatable, target, cfg, animationProps, animators, reverse);
    var finishCount = animators.length;
    var doneHappened = false;
    var cfgDone = cfg.done;
    var cfgAborted = cfg.aborted;
    var doneCb = function() {
        doneHappened = true;
        finishCount--;
        if (finishCount <= 0) doneHappened ? cfgDone && cfgDone() : cfgAborted && cfgAborted();
    };
    var abortedCb = function() {
        finishCount--;
        if (finishCount <= 0) doneHappened ? cfgDone && cfgDone() : cfgAborted && cfgAborted();
    };
    if (!finishCount) cfgDone && cfgDone();
    if (animators.length > 0 && cfg.during) animators[0].during(function(target, percent) {
        cfg.during(percent);
    });
    for(var i = 0; i < animators.length; i++){
        var animator = animators[i];
        if (doneCb) animator.done(doneCb);
        if (abortedCb) animator.aborted(abortedCb);
        if (cfg.force) animator.duration(cfg.duration);
        animator.start(cfg.easing);
    }
    return animators;
}
function $0b8373c26fe287ed$var$copyArrShallow(source, target, len) {
    for(var i = 0; i < len; i++)source[i] = target[i];
}
function $0b8373c26fe287ed$var$is2DArray(value) {
    return (0, $43e0a445ed6711da$export$1e2f57719e155213)(value[0]);
}
function $0b8373c26fe287ed$var$copyValue(target, source, key) {
    if ((0, $43e0a445ed6711da$export$1e2f57719e155213)(source[key])) {
        if (!(0, $43e0a445ed6711da$export$1e2f57719e155213)(target[key])) target[key] = [];
        if ((0, $43e0a445ed6711da$export$b119cc7e1840e59c)(source[key])) {
            var len = source[key].length;
            if (target[key].length !== len) {
                target[key] = new source[key].constructor(len);
                $0b8373c26fe287ed$var$copyArrShallow(target[key], source[key], len);
            }
        } else {
            var sourceArr = source[key];
            var targetArr = target[key];
            var len0 = sourceArr.length;
            if ($0b8373c26fe287ed$var$is2DArray(sourceArr)) {
                var len1 = sourceArr[0].length;
                for(var i = 0; i < len0; i++)if (!targetArr[i]) targetArr[i] = Array.prototype.slice.call(sourceArr[i]);
                else $0b8373c26fe287ed$var$copyArrShallow(targetArr[i], sourceArr[i], len1);
            } else $0b8373c26fe287ed$var$copyArrShallow(targetArr, sourceArr, len0);
            targetArr.length = sourceArr.length;
        }
    } else target[key] = source[key];
}
function $0b8373c26fe287ed$var$isValueSame(val1, val2) {
    return val1 === val2 || (0, $43e0a445ed6711da$export$1e2f57719e155213)(val1) && (0, $43e0a445ed6711da$export$1e2f57719e155213)(val2) && $0b8373c26fe287ed$var$is1DArraySame(val1, val2);
}
function $0b8373c26fe287ed$var$is1DArraySame(arr0, arr1) {
    var len = arr0.length;
    if (len !== arr1.length) return false;
    for(var i = 0; i < len; i++){
        if (arr0[i] !== arr1[i]) return false;
    }
    return true;
}
function $0b8373c26fe287ed$var$animateToShallow(animatable, topKey, animateObj, target, cfg, animationProps, animators, reverse) {
    var targetKeys = (0, $43e0a445ed6711da$export$ed97f33186d4b816)(target);
    var duration = cfg.duration;
    var delay = cfg.delay;
    var additive = cfg.additive;
    var setToFinal = cfg.setToFinal;
    var animateAll = !(0, $43e0a445ed6711da$export$a6cdc56e425d0d0a)(animationProps);
    var existsAnimators = animatable.animators;
    var animationKeys = [];
    for(var k = 0; k < targetKeys.length; k++){
        var innerKey = targetKeys[k];
        var targetVal = target[innerKey];
        if (targetVal != null && animateObj[innerKey] != null && (animateAll || animationProps[innerKey])) {
            if ((0, $43e0a445ed6711da$export$a6cdc56e425d0d0a)(targetVal) && !(0, $43e0a445ed6711da$export$1e2f57719e155213)(targetVal) && !(0, $43e0a445ed6711da$export$fa2c283003ed971c)(targetVal)) {
                if (topKey) {
                    if (!reverse) {
                        animateObj[innerKey] = targetVal;
                        animatable.updateDuringAnimation(topKey);
                    }
                    continue;
                }
                $0b8373c26fe287ed$var$animateToShallow(animatable, innerKey, animateObj[innerKey], targetVal, cfg, animationProps && animationProps[innerKey], animators, reverse);
            } else animationKeys.push(innerKey);
        } else if (!reverse) {
            animateObj[innerKey] = targetVal;
            animatable.updateDuringAnimation(topKey);
            animationKeys.push(innerKey);
        }
    }
    var keyLen = animationKeys.length;
    if (!additive && keyLen) for(var i = 0; i < existsAnimators.length; i++){
        var animator = existsAnimators[i];
        if (animator.targetName === topKey) {
            var allAborted = animator.stopTracks(animationKeys);
            if (allAborted) {
                var idx = (0, $43e0a445ed6711da$export$305f7d4e9d4624f2)(existsAnimators, animator);
                existsAnimators.splice(idx, 1);
            }
        }
    }
    if (!cfg.force) {
        animationKeys = (0, $43e0a445ed6711da$export$3dea766d36a8935f)(animationKeys, function(key) {
            return !$0b8373c26fe287ed$var$isValueSame(target[key], animateObj[key]);
        });
        keyLen = animationKeys.length;
    }
    if (keyLen > 0 || cfg.force && !animators.length) {
        var revertedSource = void 0;
        var reversedTarget = void 0;
        var sourceClone = void 0;
        if (reverse) {
            reversedTarget = {};
            if (setToFinal) revertedSource = {};
            for(var i = 0; i < keyLen; i++){
                var innerKey = animationKeys[i];
                reversedTarget[innerKey] = animateObj[innerKey];
                if (setToFinal) revertedSource[innerKey] = target[innerKey];
                else animateObj[innerKey] = target[innerKey];
            }
        } else if (setToFinal) {
            sourceClone = {};
            for(var i = 0; i < keyLen; i++){
                var innerKey = animationKeys[i];
                sourceClone[innerKey] = (0, $b0a396476612fe2c$export$c5e92b7f105af84e)(animateObj[innerKey]);
                $0b8373c26fe287ed$var$copyValue(animateObj, target, innerKey);
            }
        }
        var animator = new (0, $b0a396476612fe2c$export$2e2bcd8739ae039)(animateObj, false, false, additive ? (0, $43e0a445ed6711da$export$3dea766d36a8935f)(existsAnimators, function(animator) {
            return animator.targetName === topKey;
        }) : null);
        animator.targetName = topKey;
        if (cfg.scope) animator.scope = cfg.scope;
        if (setToFinal && revertedSource) animator.whenWithKeys(0, revertedSource, animationKeys);
        if (sourceClone) animator.whenWithKeys(0, sourceClone, animationKeys);
        animator.whenWithKeys(duration == null ? 500 : duration, reverse ? reversedTarget : target, animationKeys).delay(delay || 0);
        animatable.addAnimator(animator, topKey);
        animators.push(animator);
    }
}
function $0b8373c26fe287ed$var$shouldUseHoverLayer(el, textContent, nextState, forceUseHoverLayer) {
    return !(nextState && nextState.hoverLayer || forceUseHoverLayer) || $0b8373c26fe287ed$var$isTextRelatedEl(el) || textContent && $0b8373c26fe287ed$var$isTextRelatedEl(textContent) ? $0b8373c26fe287ed$export$afb92d844f688c8d : $0b8373c26fe287ed$export$f5347ae640a7f0d0;
}
function $0b8373c26fe287ed$var$isTextRelatedEl(el) {
    return el.type === "text" || el.type === "tspan";
}
function $0b8373c26fe287ed$var$canTransition(el, noAnimation, animationCfg) {
    return !noAnimation && !el.__inHover && animationCfg && animationCfg.duration > 0;
}
var $0b8373c26fe287ed$export$2e2bcd8739ae039 = $0b8373c26fe287ed$var$Element;



var $a8978f7a0e842e3d$var$Group = function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(Group, _super);
    function Group(opts) {
        var _this = _super.call(this) || this;
        _this.isGroup = true;
        _this._children = [];
        _this.attr(opts);
        return _this;
    }
    Group.prototype.childrenRef = function() {
        return this._children;
    };
    Group.prototype.children = function() {
        return this._children.slice();
    };
    Group.prototype.childAt = function(idx) {
        return this._children[idx];
    };
    Group.prototype.childOfName = function(name) {
        var children = this._children;
        for(var i = 0; i < children.length; i++){
            if (children[i].name === name) return children[i];
        }
    };
    Group.prototype.childCount = function() {
        return this._children.length;
    };
    Group.prototype.add = function(child) {
        if (child) {
            if (child !== this && child.parent !== this) {
                this._children.push(child);
                this._doAdd(child);
            }
        }
        return this;
    };
    Group.prototype.addBefore = function(child, nextSibling) {
        if (child && child !== this && child.parent !== this && nextSibling && nextSibling.parent === this) {
            var children = this._children;
            var idx = children.indexOf(nextSibling);
            if (idx >= 0) {
                children.splice(idx, 0, child);
                this._doAdd(child);
            }
        }
        return this;
    };
    Group.prototype.replace = function(oldChild, newChild) {
        var idx = $43e0a445ed6711da$export$305f7d4e9d4624f2(this._children, oldChild);
        if (idx >= 0) this.replaceAt(newChild, idx);
        return this;
    };
    Group.prototype.replaceAt = function(child, index) {
        var children = this._children;
        var old = children[index];
        if (child && child !== this && child.parent !== this && child !== old) {
            children[index] = child;
            old.parent = null;
            var zr = this.__zr;
            if (zr) old.removeSelfFromZr(zr);
            this._doAdd(child);
        }
        return this;
    };
    Group.prototype._doAdd = function(child) {
        if (child.parent) child.parent.remove(child);
        child.parent = this;
        var zr = this.__zr;
        if (zr && zr !== child.__zr) child.addSelfToZr(zr);
        zr && zr.refresh();
    };
    Group.prototype.remove = function(child) {
        var zr = this.__zr;
        var children = this._children;
        var idx = $43e0a445ed6711da$export$305f7d4e9d4624f2(children, child);
        if (idx < 0) return this;
        children.splice(idx, 1);
        child.parent = null;
        if (zr) child.removeSelfFromZr(zr);
        zr && zr.refresh();
        return this;
    };
    Group.prototype.removeAll = function() {
        var children = this._children;
        var zr = this.__zr;
        for(var i = 0; i < children.length; i++){
            var child = children[i];
            if (zr) child.removeSelfFromZr(zr);
            child.parent = null;
        }
        children.length = 0;
        return this;
    };
    Group.prototype.eachChild = function(cb, context) {
        var children = this._children;
        for(var i = 0; i < children.length; i++){
            var child = children[i];
            cb.call(context, child, i);
        }
        return this;
    };
    Group.prototype.traverse = function(cb, context) {
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            var stopped = cb.call(context, child);
            if (child.isGroup && !stopped) child.traverse(cb, context);
        }
        return this;
    };
    Group.prototype.addSelfToZr = function(zr) {
        _super.prototype.addSelfToZr.call(this, zr);
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            child.addSelfToZr(zr);
        }
    };
    Group.prototype.removeSelfFromZr = function(zr) {
        _super.prototype.removeSelfFromZr.call(this, zr);
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            child.removeSelfFromZr(zr);
        }
    };
    Group.prototype.getBoundingRect = function(includeChildren) {
        var tmpRect = new (0, $c437f598d9c9ee16$export$2e2bcd8739ae039)(0, 0, 0, 0);
        var children = includeChildren || this._children;
        var tmpMat = [];
        var rect = null;
        for(var i = 0; i < children.length; i++){
            var child = children[i];
            if (child.ignore || child.invisible) continue;
            var childRect = child.getBoundingRect();
            var transform = child.getLocalTransform(tmpMat);
            if (transform) {
                (0, $c437f598d9c9ee16$export$2e2bcd8739ae039).applyTransform(tmpRect, childRect, transform);
                rect = rect || tmpRect.clone();
                rect.union(tmpRect);
            } else {
                rect = rect || childRect.clone();
                rect.union(childRect);
            }
        }
        return rect || tmpRect;
    };
    return Group;
}((0, $0b8373c26fe287ed$export$2e2bcd8739ae039));
$a8978f7a0e842e3d$var$Group.prototype.type = "group";
var $a8978f7a0e842e3d$export$2e2bcd8739ae039 = $a8978f7a0e842e3d$var$Group;


var $08a7e718789e144c$var$painterCtors = {};
var $08a7e718789e144c$var$instances = {};
function $08a7e718789e144c$var$delInstance(id) {
    delete $08a7e718789e144c$var$instances[id];
}
function $08a7e718789e144c$var$isDarkMode(backgroundColor) {
    if (!backgroundColor) return false;
    if (typeof backgroundColor === "string") return (0, $b0979f18b0a232f9$export$16c0ec21a6f9ef95)(backgroundColor, 1) < (0, $b4769615a730dcfc$export$fd81e7ebc7dae256);
    else if (backgroundColor.colorStops) {
        var colorStops = backgroundColor.colorStops;
        var totalLum = 0;
        var len = colorStops.length;
        for(var i = 0; i < len; i++)totalLum += (0, $b0979f18b0a232f9$export$16c0ec21a6f9ef95)(colorStops[i].color, 1);
        totalLum /= len;
        return totalLum < (0, $b4769615a730dcfc$export$fd81e7ebc7dae256);
    }
    return false;
}
var $08a7e718789e144c$var$ZRender = function() {
    function ZRender(id, dom, opts) {
        var _this = this;
        this._sleepAfterStill = 10;
        this._stillFrameAccum = 0;
        this._needsRefresh = true;
        this._needsRefreshHover = false;
        this._darkMode = false;
        opts = opts || {};
        this.dom = dom;
        this.id = id;
        var storage = new (0, $bebee66775a2c8f3$export$2e2bcd8739ae039)();
        var rendererType = opts.renderer || "canvas";
        if (!$08a7e718789e144c$var$painterCtors[rendererType]) rendererType = $43e0a445ed6711da$export$ed97f33186d4b816($08a7e718789e144c$var$painterCtors)[0];
        opts.useDirtyRect = opts.useDirtyRect == null ? false : opts.useDirtyRect;
        var painter = new $08a7e718789e144c$var$painterCtors[rendererType](dom, storage, opts, id);
        var ssrMode = opts.ssr || painter.ssrOnly;
        this.storage = storage;
        this.painter = painter;
        var handlerProxy = !(0, $a84633bb9c74d89c$export$2e2bcd8739ae039).node && !(0, $a84633bb9c74d89c$export$2e2bcd8739ae039).worker && !ssrMode ? new (0, $2011c487b8e23053$export$2e2bcd8739ae039)(painter.getViewportRoot(), painter.root) : null;
        var useCoarsePointer = opts.useCoarsePointer;
        var usePointerSize = useCoarsePointer == null || useCoarsePointer === "auto" ? (0, $a84633bb9c74d89c$export$2e2bcd8739ae039).touchEventsSupported : !!useCoarsePointer;
        var defaultPointerSize = 44;
        var pointerSize;
        if (usePointerSize) pointerSize = $43e0a445ed6711da$export$995e01f2f5c9d030(opts.pointerSize, defaultPointerSize);
        this.handler = new (0, $93fcb791e74b72e6$export$2e2bcd8739ae039)(storage, painter, handlerProxy, painter.root, pointerSize);
        this.animation = new (0, $2b16e6dd85ff7184$export$2e2bcd8739ae039)({
            stage: {
                update: ssrMode ? null : function() {
                    return _this._flush(false);
                }
            }
        });
        if (!ssrMode) this.animation.start();
    }
    ZRender.prototype.add = function(el) {
        if (this._disposed || !el) return;
        this.storage.addRoot(el);
        el.addSelfToZr(this);
        this.refresh();
    };
    ZRender.prototype.remove = function(el) {
        if (this._disposed || !el) return;
        this.storage.delRoot(el);
        el.removeSelfFromZr(this);
        this.refresh();
    };
    ZRender.prototype.configLayer = function(zLevel, config) {
        if (this._disposed) return;
        if (this.painter.configLayer) this.painter.configLayer(zLevel, config);
        this.refresh();
    };
    ZRender.prototype.setBackgroundColor = function(backgroundColor) {
        if (this._disposed) return;
        if (this.painter.setBackgroundColor) this.painter.setBackgroundColor(backgroundColor);
        this.refresh();
        this._backgroundColor = backgroundColor;
        this._darkMode = $08a7e718789e144c$var$isDarkMode(backgroundColor);
    };
    ZRender.prototype.getBackgroundColor = function() {
        return this._backgroundColor;
    };
    ZRender.prototype.setDarkMode = function(darkMode) {
        this._darkMode = darkMode;
    };
    ZRender.prototype.isDarkMode = function() {
        return this._darkMode;
    };
    ZRender.prototype.refreshImmediately = function(noAnimationUpdate) {
        if (this._disposed) return;
        this._refresh({
            animUpdate: !noAnimationUpdate,
            refresh: true,
            refreshHover: false
        });
    };
    ZRender.prototype._refresh = function(opt) {
        if (opt.animUpdate) this.animation.update(true);
        this._needsRefresh = this._needsRefreshHover = false;
        this.painter.refresh({
            refresh: opt.refresh,
            refreshHover: opt.refreshHover
        });
        this._needsRefresh = this._needsRefreshHover = false;
    };
    ZRender.prototype.refresh = function() {
        if (this._disposed) return;
        this._needsRefresh = true;
        this.animation.start();
    };
    ZRender.prototype.flush = function() {
        if (this._disposed) return;
        this._flush(true);
    };
    ZRender.prototype._flush = function(animationUpdate) {
        var triggerRendered;
        var start = (0, $2b16e6dd85ff7184$export$1428f42a7de81803)();
        var needsRefresh = this._needsRefresh;
        var needsRefreshHover = this._needsRefreshHover;
        if (needsRefresh || needsRefreshHover) {
            triggerRendered = true;
            this._refresh({
                animUpdate: animationUpdate,
                refresh: needsRefresh,
                refreshHover: needsRefreshHover
            });
        }
        var end = (0, $2b16e6dd85ff7184$export$1428f42a7de81803)();
        if (triggerRendered) {
            this._stillFrameAccum = 0;
            this.trigger("rendered", {
                elapsedTime: end - start
            });
        } else if (this._sleepAfterStill > 0) {
            this._stillFrameAccum++;
            if (this._stillFrameAccum > this._sleepAfterStill) this.animation.stop();
        }
    };
    ZRender.prototype.setSleepAfterStill = function(stillFramesCount) {
        this._sleepAfterStill = stillFramesCount;
    };
    ZRender.prototype.wakeUp = function() {
        if (this._disposed) return;
        this.animation.start();
        this._stillFrameAccum = 0;
    };
    ZRender.prototype.refreshHover = function() {
        this._needsRefreshHover = true;
    };
    ZRender.prototype.refreshHoverImmediately = function() {
        if (this._disposed) return;
        this._refresh({
            animUpdate: false,
            refresh: false,
            refreshHover: true
        });
    };
    ZRender.prototype.resize = function(opts) {
        if (this._disposed) return;
        opts = opts || {};
        this.painter.resize(opts.width, opts.height);
        this.handler.resize();
    };
    ZRender.prototype.clearAnimation = function() {
        if (this._disposed) return;
        this.animation.clear();
    };
    ZRender.prototype.getWidth = function() {
        if (this._disposed) return;
        return this.painter.getWidth();
    };
    ZRender.prototype.getHeight = function() {
        if (this._disposed) return;
        return this.painter.getHeight();
    };
    ZRender.prototype.setCursorStyle = function(cursorStyle) {
        if (this._disposed) return;
        this.handler.setCursorStyle(cursorStyle);
    };
    ZRender.prototype.findHover = function(x, y) {
        if (this._disposed) return;
        return this.handler.findHover(x, y);
    };
    ZRender.prototype.on = function(eventName, eventHandler, context) {
        if (!this._disposed) this.handler.on(eventName, eventHandler, context);
        return this;
    };
    ZRender.prototype.off = function(eventName, eventHandler) {
        if (this._disposed) return;
        this.handler.off(eventName, eventHandler);
    };
    ZRender.prototype.trigger = function(eventName, event) {
        if (this._disposed) return;
        this.handler.trigger(eventName, event);
    };
    ZRender.prototype.clear = function() {
        if (this._disposed) return;
        var roots = this.storage.getRoots();
        for(var i = 0; i < roots.length; i++)if (roots[i] instanceof (0, $a8978f7a0e842e3d$export$2e2bcd8739ae039)) roots[i].removeSelfFromZr(this);
        this.storage.delAllRoots();
        this.painter.clear();
    };
    ZRender.prototype.dispose = function() {
        if (this._disposed) return;
        this.animation.stop();
        this.clear();
        this.storage.dispose();
        this.painter.dispose();
        this.handler.dispose();
        this.animation = this.storage = this.painter = this.handler = null;
        this._disposed = true;
        $08a7e718789e144c$var$delInstance(this.id);
    };
    return ZRender;
}();
function $08a7e718789e144c$export$2cd8252107eb640b(dom, opts) {
    var zr = new $08a7e718789e144c$var$ZRender($43e0a445ed6711da$export$46e8f25c7328f77e(), dom, opts);
    $08a7e718789e144c$var$instances[zr.id] = zr;
    return zr;
}
function $08a7e718789e144c$export$fcfbbcec2cb820d5(zr) {
    zr.dispose();
}
function $08a7e718789e144c$export$825f692fb04800ef() {
    for(var key in $08a7e718789e144c$var$instances)if ($08a7e718789e144c$var$instances.hasOwnProperty(key)) $08a7e718789e144c$var$instances[key].dispose();
    $08a7e718789e144c$var$instances = {};
}
function $08a7e718789e144c$export$8bedcca5bbd73999(id) {
    return $08a7e718789e144c$var$instances[id];
}
function $08a7e718789e144c$export$a3e793ccb11823a5(name, Ctor) {
    $08a7e718789e144c$var$painterCtors[name] = Ctor;
}
var $08a7e718789e144c$var$ssrDataGetter;
function $08a7e718789e144c$export$dd7015a5412ca583(el) {
    if (typeof $08a7e718789e144c$var$ssrDataGetter === "function") return $08a7e718789e144c$var$ssrDataGetter(el);
}
function $08a7e718789e144c$export$e7a09d7fe68a4f7(getter) {
    $08a7e718789e144c$var$ssrDataGetter = getter;
}
var $08a7e718789e144c$export$83d89fbfd8236492 = "6.1.0";






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* A third-party license is embedded for some of the code in this file:
* The method "quantile" was copied from "d3.js".
* (See more details in the comment of the method below.)
* The use of the source code of this file is also subject to the terms
* and consitions of the license of "d3.js" (BSD-3Clause, see
* </licenses/LICENSE-d3>).
*/ 
var $b49750109e236fd8$var$RADIAN_EPSILON = 1e-4;
// A `RangeError` may be thrown if `n` is out of this range when calling `toFixed(n)`.
// Although Chrome and ES2017+ have enlarged this number to 100, but we sill follow
// the ES3~ES6 spec (0 <= n <= 20) for backward and cross-platform compatibility.
var $b49750109e236fd8$var$TO_FIXED_SUPPORTED_PRECISION_MAX = 20;
var $b49750109e236fd8$export$8ba97c21efb02ba7 = 14;
function $b49750109e236fd8$var$_trim(str) {
    return str.replace(/^\s+|\s+$/g, "");
}
var $b49750109e236fd8$export$e411eeaf23dccbe8 = Math.min;
var $b49750109e236fd8$export$2ca8010d037f830f = Math.max;
var $b49750109e236fd8$export$5860c226b237d9a6 = Math.abs;
var $b49750109e236fd8$export$42cacde8c45786ff = Math.round;
var $b49750109e236fd8$export$c6301bc99a7f80a7 = Math.floor;
var $b49750109e236fd8$export$cf129980c996e186 = Math.ceil;
var $b49750109e236fd8$export$858b42c97efc7084 = Math.pow;
var $b49750109e236fd8$export$f0e980411e05f912 = Math.log;
var $b49750109e236fd8$export$37fe35d0539e4a76 = Math.LN10;
var $b49750109e236fd8$export$14727c6ff83b55d = Math.PI;
var $b49750109e236fd8$export$9b2865e267c5db1d = Math.random;
function $b49750109e236fd8$export$d3f68fbaa670562(val, domain, range, clamp) {
    var d0 = domain[0];
    var d1 = domain[1];
    var r0 = range[0];
    var r1 = range[1];
    var subDomain = d1 - d0;
    var subRange = r1 - r0;
    if (subDomain === 0) return subRange === 0 ? r0 : (r0 + r1) / 2;
    // Avoid accuracy problem in edge, such as
    // 146.39 - 62.83 === 83.55999999999999.
    // See echarts/test/ut/spec/util/number.js#linearMap#accuracyError
    // It is a little verbose for efficiency considering this method
    // is a hotspot.
    if (clamp) {
        if (subDomain > 0) {
            if (val <= d0) return r0;
            else if (val >= d1) return r1;
        } else {
            if (val >= d0) return r0;
            else if (val <= d1) return r1;
        }
    } else {
        if (val === d0) return r0;
        if (val === d1) return r1;
    }
    return (val - d0) / subDomain * subRange + r0;
}
var $b49750109e236fd8$export$e8514cb5a5e2b40f = $b49750109e236fd8$export$249e1c100b47bcef;
function $b49750109e236fd8$export$249e1c100b47bcef(option, percentBase, percentOffset) {
    switch(option){
        case "center":
        case "middle":
            option = "50%";
            break;
        case "left":
        case "top":
            option = "0%";
            break;
        case "right":
        case "bottom":
            option = "100%";
            break;
    }
    return $b49750109e236fd8$export$6b392db7c2374a1a(option, percentBase, percentOffset);
}
function $b49750109e236fd8$export$6b392db7c2374a1a(option, percentBase, // Typical usage of `percentOffset`: percent value is based on an specific rect rather than canvas viewport:
//  `parsePercent(percentOrAbsoluteLeft, rect.width, rect.x)`
percentOffset) {
    if ($43e0a445ed6711da$export$844ec244b1367d54(option)) {
        if ($b49750109e236fd8$var$isOptionStringPercent(option)) return parseFloat(option) / 100 * percentBase + (percentOffset || 0);
        return parseFloat(option);
    }
    // Allow flexible input due to backward compatibility.
    return option == null ? NaN : +option;
}
function $b49750109e236fd8$export$44c0eb10d342c176(option) {
    return $43e0a445ed6711da$export$844ec244b1367d54(option) && $b49750109e236fd8$var$isOptionStringPercent(option);
}
function $b49750109e236fd8$var$isOptionStringPercent(option) {
    return !!$b49750109e236fd8$var$_trim(option).match(/%$/);
}
function $b49750109e236fd8$export$2077e0241d6afd3c(x, precision, returnStr) {
    if (isNaN(precision)) // precision utils (such as getAcceptableTickPrecision) may return NaN.
    return returnStr ? "" + x : +x;
    // Avoid range error
    precision = $b49750109e236fd8$export$e411eeaf23dccbe8($b49750109e236fd8$export$2ca8010d037f830f(0, precision), $b49750109e236fd8$var$TO_FIXED_SUPPORTED_PRECISION_MAX);
    // PENDING: 1.005.toFixed(2) is '1.00' rather than '1.01'
    x = (+x).toFixed(precision);
    return returnStr ? x : +x;
}
function $b49750109e236fd8$export$d6af03b9b5dd06d7(x, precision, returnStr) {
    if (precision == null) precision = 10;
    return $b49750109e236fd8$export$2077e0241d6afd3c(x, precision, returnStr);
}
function $b49750109e236fd8$export$debe6e778e0a6d32(arr) {
    arr.sort(function(a, b) {
        return a - b;
    });
    return arr;
}
function $b49750109e236fd8$export$e0c74b50bbd10f68(val) {
    val = +val;
    if (isNaN(val)) return 0;
    // It is much faster than methods converting number to string as follows
    //      let tmp = val.toString();
    //      return tmp.length - 1 - tmp.indexOf('.');
    // especially when precision is low
    // Notice:
    // (1) If the loop count is over about 20, it is slower than `getPrecisionSafe`.
    //     (see https://jsbench.me/2vkpcekkvw/1)
    // (2) If the val is less than for example 1e-15, the result may be incorrect.
    //     (see test/ut/spec/util/number.test.ts `getPrecision_equal_random`)
    if (val > 1e-14) {
        var e = 1;
        for(var i = 0; i < 15; i++, e *= 10){
            if ($b49750109e236fd8$export$42cacde8c45786ff(val * e) / e === val) return i;
        }
    }
    return $b49750109e236fd8$export$6d86ba4ca4984d31(val);
}
function $b49750109e236fd8$export$6d86ba4ca4984d31(val) {
    // toLowerCase for: '3.4E-12'
    var str = val.toString().toLowerCase();
    // Consider scientific notation: '3.4e-12' '3.4e+12'
    var eIndex = str.indexOf("e");
    var exp = eIndex > 0 ? +str.slice(eIndex + 1) : 0;
    var significandPartLen = eIndex > 0 ? eIndex : str.length;
    var dotIndex = str.indexOf(".");
    var decimalPartLen = dotIndex < 0 ? 0 : significandPartLen - 1 - dotIndex;
    return $b49750109e236fd8$export$2ca8010d037f830f(0, decimalPartLen - exp);
}
function $b49750109e236fd8$export$666260d9a2dda8a7(dataExtent, pixelExtent) {
    var dataQuantity = $b49750109e236fd8$export$c6301bc99a7f80a7($b49750109e236fd8$export$f0e980411e05f912(dataExtent[1] - dataExtent[0]) / $b49750109e236fd8$export$37fe35d0539e4a76);
    var sizeQuantity = $b49750109e236fd8$export$42cacde8c45786ff($b49750109e236fd8$export$f0e980411e05f912($b49750109e236fd8$export$5860c226b237d9a6(pixelExtent[1] - pixelExtent[0])) / $b49750109e236fd8$export$37fe35d0539e4a76);
    // toFixed() digits argument must be between 0 and 20.
    var precision = $b49750109e236fd8$export$e411eeaf23dccbe8($b49750109e236fd8$export$2ca8010d037f830f(-dataQuantity + sizeQuantity, 0), $b49750109e236fd8$var$TO_FIXED_SUPPORTED_PRECISION_MAX);
    return !isFinite(precision) ? $b49750109e236fd8$var$TO_FIXED_SUPPORTED_PRECISION_MAX : precision;
}
function $b49750109e236fd8$export$de3fddfc2aec84e4(dataExtent, // Typically, `Math.abs(pixelExtent[1] - pixelExtent[0])`.
pxSpan, // By default, `1`.
pxDiffAcceptable) {
    var dataSpan = $b49750109e236fd8$export$5860c226b237d9a6(dataExtent[1] - dataExtent[0]);
    if (!isFinite(dataSpan) || dataSpan === 0) return NaN;
    // Formula for choosing an acceptable precision:
    //  Let `pxDiff = abs(dataSpan - round(dataSpan, precision))`.
    //  We require `pxDiff <= dataSpan * pxDiffAcceptable / pxSpan`.
    //  Consider the nature of "round", the max `pxDiff` is: `pow(10, -precision) / 2`,
    //  Hence: `pow(10, -precision) / 2 <= dataSpan * pxDiffAcceptable / pxSpan`
    //  Hence: `precision >= -log10(2 * dataSpan * pxDiffAcceptable / pxSpan)`
    var dataExp2 = $b49750109e236fd8$export$f0e980411e05f912(2 * $b49750109e236fd8$export$5860c226b237d9a6(pxDiffAcceptable || 1) * $b49750109e236fd8$export$5860c226b237d9a6(dataSpan)) / $b49750109e236fd8$export$37fe35d0539e4a76;
    var pxExp = $b49750109e236fd8$export$f0e980411e05f912($b49750109e236fd8$export$5860c226b237d9a6(pxSpan)) / $b49750109e236fd8$export$37fe35d0539e4a76;
    // PENDING: Rounding error generally does not matter; do not fix it before `Math.ceil`
    // until bad case occur.
    var precision = $b49750109e236fd8$export$2ca8010d037f830f(0, $b49750109e236fd8$export$cf129980c996e186(-dataExp2 + pxExp));
    if (!isFinite(precision)) // If dataSpan is near `0`, the result should not be too big or even `Infinity`.
    precision = NaN;
    return precision;
}
function $b49750109e236fd8$export$70cc11b075afeb90(valueList, idx, precision) {
    if (!valueList[idx]) return 0;
    var seats = $b49750109e236fd8$export$222dabb13d5320df(valueList, precision);
    return seats[idx] || 0;
}
function $b49750109e236fd8$export$222dabb13d5320df(valueList, precision) {
    var sum = $43e0a445ed6711da$export$533b26079ad0b4b(valueList, function(acc, val) {
        return acc + (isNaN(val) ? 0 : val);
    }, 0);
    if (sum === 0) return [];
    var digits = $b49750109e236fd8$export$858b42c97efc7084(10, precision);
    var votesPerQuota = $43e0a445ed6711da$export$871de8747c9eaa88(valueList, function(val) {
        return (isNaN(val) ? 0 : val) / sum * digits * 100;
    });
    var targetSeats = digits * 100;
    var seats = $43e0a445ed6711da$export$871de8747c9eaa88(votesPerQuota, function(votes) {
        // Assign automatic seats.
        return $b49750109e236fd8$export$c6301bc99a7f80a7(votes);
    });
    var currentSum = $43e0a445ed6711da$export$533b26079ad0b4b(seats, function(acc, val) {
        return acc + val;
    }, 0);
    var remainder = $43e0a445ed6711da$export$871de8747c9eaa88(votesPerQuota, function(votes, idx) {
        return votes - seats[idx];
    });
    // Has remainding votes.
    while(currentSum < targetSeats){
        // Find next largest remainder.
        var max = Number.NEGATIVE_INFINITY;
        var maxId = null;
        for(var i = 0, len = remainder.length; i < len; ++i)if (remainder[i] > max) {
            max = remainder[i];
            maxId = i;
        }
        // Add a vote to max remainder.
        ++seats[maxId];
        remainder[maxId] = 0;
        ++currentSum;
    }
    return $43e0a445ed6711da$export$871de8747c9eaa88(seats, function(seat) {
        return seat / digits;
    });
}
function $b49750109e236fd8$export$d3389a301c3a5706(val0, val1) {
    var maxPrecision = $b49750109e236fd8$export$2ca8010d037f830f($b49750109e236fd8$export$e0c74b50bbd10f68(val0), $b49750109e236fd8$export$e0c74b50bbd10f68(val1));
    // const multiplier = Math.pow(10, maxPrecision);
    // return (mathRound(val0 * multiplier) + mathRound(val1 * multiplier)) / multiplier;
    var sum = val0 + val1;
    // // PENDING: support more?
    return maxPrecision > $b49750109e236fd8$var$TO_FIXED_SUPPORTED_PRECISION_MAX ? sum : $b49750109e236fd8$export$2077e0241d6afd3c(sum, maxPrecision);
}
var $b49750109e236fd8$export$18510406f204a1b9 = $b49750109e236fd8$export$858b42c97efc7084(2, 53) - 1;
function $b49750109e236fd8$export$2ca6dd70a288b1c3(radian) {
    var pi2 = $b49750109e236fd8$export$14727c6ff83b55d * 2;
    return (radian % pi2 + pi2) % pi2;
}
function $b49750109e236fd8$export$d1df570aea2868f(val) {
    return val > -$b49750109e236fd8$var$RADIAN_EPSILON && val < $b49750109e236fd8$var$RADIAN_EPSILON;
}
// eslint-disable-next-line
var $b49750109e236fd8$var$TIME_REG = /^(?:(\d{4})(?:[-\/](\d{1,2})(?:[-\/](\d{1,2})(?:[T ](\d{1,2})(?::(\d{1,2})(?::(\d{1,2})(?:[.,](\d+))?)?)?(Z|[\+\-]\d\d:?\d\d)?)?)?)?)?$/; // jshint ignore:line
function $b49750109e236fd8$export$6b862160d295c8e(value) {
    if (value instanceof Date) return value;
    else if ($43e0a445ed6711da$export$844ec244b1367d54(value)) {
        // Different browsers parse date in different way, so we parse it manually.
        // Some other issues:
        // new Date('1970-01-01') is UTC,
        // new Date('1970/01/01') and new Date('1970-1-01') is local.
        // See issue #3623
        var match = $b49750109e236fd8$var$TIME_REG.exec(value);
        if (!match) // return Invalid Date.
        return new Date(NaN);
        // Use local time when no timezone offset is specified.
        if (!match[8]) // match[n] can only be string or undefined.
        // But take care of '12' + 1 => '121'.
        return new Date(+match[1], +(match[2] || 1) - 1, +match[3] || 1, +match[4] || 0, +(match[5] || 0), +match[6] || 0, match[7] ? +match[7].substring(0, 3) : 0);
        else {
            var hour = +match[4] || 0;
            if (match[8].toUpperCase() !== "Z") hour -= +match[8].slice(0, 3);
            return new Date(Date.UTC(+match[1], +(match[2] || 1) - 1, +match[3] || 1, hour, +(match[5] || 0), +match[6] || 0, match[7] ? +match[7].substring(0, 3) : 0));
        }
    } else if (value == null) return new Date(NaN);
    return new Date($b49750109e236fd8$export$42cacde8c45786ff(value));
}
function $b49750109e236fd8$export$82dd68b83a44b253(val) {
    return $b49750109e236fd8$export$858b42c97efc7084(10, $b49750109e236fd8$export$97256a17b20a0c24(val));
}
function $b49750109e236fd8$export$97256a17b20a0c24(val) {
    if (val === 0) // PENDING: like IEEE754 use exponent `0` in this case.
    // but methematically, exponent of zero is `-Infinity`.
    return 0;
    var exp = $b49750109e236fd8$export$c6301bc99a7f80a7($b49750109e236fd8$export$f0e980411e05f912(val) / $b49750109e236fd8$export$37fe35d0539e4a76);
    /**
   * exp is expected to be the rounded-down result of the base-10 log of val.
   * But due to the precision loss with Math.log(val), we need to restore it
   * using 10^exp to make sure we can get val back from exp. #11249
   */ if (val / $b49750109e236fd8$export$858b42c97efc7084(10, exp) >= 10) exp++;
    return exp;
}
var $b49750109e236fd8$export$50cf7838cdf68969 = 1;
var $b49750109e236fd8$export$492adb595f875f4e = 2;
function $b49750109e236fd8$export$7a695fe44258210b(val, // All non-`NICE_MODE_MIN`-truthy values means `NICE_MODE_ROUND`, for backward compatibility.
mode) {
    // Consider the scientific notation of `val`:
    //  - `exponent` is its exponent.
    //  - `f` is its coefficient. `1 <= f < 10`.
    //  e.g., if `val` is `0.0054321`, `exponent` is `-3`, `f` is `5.4321`,
    //      The result is `0.005` on NICE_MODE_ROUND.
    //  e.g., if `val` is `987.12345`, `exponent` is `2`, `f` is `9.8712345`,
    //      The result is `1000` on NICE_MODE_ROUND.
    //  e.g., if `val` is `0`,
    //      The result is `1`.
    var exponent = $b49750109e236fd8$export$97256a17b20a0c24(val);
    // No rounding error in Math.pow(10, integer).
    var exp10 = $b49750109e236fd8$export$858b42c97efc7084(10, exponent);
    var f = val / exp10;
    var nf;
    if (mode === $b49750109e236fd8$export$492adb595f875f4e) nf = 1;
    else if (mode) {
        if (f < 1.5) nf = 1;
        else if (f < 2.5) nf = 2;
        else if (f < 4) nf = 3;
        else if (f < 7) nf = 5;
        else nf = 10;
    } else {
        if (f < 1) nf = 1;
        else if (f < 2) nf = 2;
        else if (f < 3) nf = 3;
        else if (f < 5) nf = 5;
        else nf = 10;
    }
    val = nf * exp10;
    // Fix IEEE 754 float rounding error
    return $b49750109e236fd8$export$2077e0241d6afd3c(val, -exponent);
}
function $b49750109e236fd8$export$651fb4afdb6caa4b(ascArr, p) {
    var H = (ascArr.length - 1) * p + 1;
    var h = $b49750109e236fd8$export$c6301bc99a7f80a7(H);
    var v = +ascArr[h - 1];
    var e = H - h;
    return e ? v + e * (ascArr[h] - v) : v;
}
function $b49750109e236fd8$export$12f7386070bc380a(list) {
    list.sort(function(a, b) {
        return littleThan(a, b, 0) ? -1 : 1;
    });
    var curr = -Infinity;
    var currClose = 1;
    for(var i = 0; i < list.length;){
        var interval = list[i].interval;
        var close_1 = list[i].close;
        for(var lg = 0; lg < 2; lg++){
            if (interval[lg] <= curr) {
                interval[lg] = curr;
                close_1[lg] = !lg ? 1 - currClose : 1;
            }
            curr = interval[lg];
            currClose = close_1[lg];
        }
        if (interval[0] === interval[1] && close_1[0] * close_1[1] !== 1) list.splice(i, 1);
        else i++;
    }
    return list;
    function littleThan(a, b, lg) {
        return a.interval[lg] < b.interval[lg] || a.interval[lg] === b.interval[lg] && (a.close[lg] - b.close[lg] === (!lg ? 1 : -1) || !lg && littleThan(a, b, 1));
    }
}
function $b49750109e236fd8$export$8b4007b942b45a96(val) {
    var valFloat = parseFloat(val);
    return valFloat == val // eslint-disable-line eqeqeq
     && (valFloat !== 0 || !$43e0a445ed6711da$export$844ec244b1367d54(val) || val.indexOf("x") <= 0 // For case ' 0x0 '.
    ) ? valFloat : NaN;
}
function $b49750109e236fd8$export$e90fb89750dba83f(val) {
    return !isNaN($b49750109e236fd8$export$8b4007b942b45a96(val));
}
function $b49750109e236fd8$export$474d2ec9aa44a22() {
    return $b49750109e236fd8$export$42cacde8c45786ff($b49750109e236fd8$export$9b2865e267c5db1d() * 9);
}
function $b49750109e236fd8$export$a368fd580c0d0fe4(a, b) {
    if (b === 0) return a;
    return $b49750109e236fd8$export$a368fd580c0d0fe4(b, a % b);
}
function $b49750109e236fd8$export$680a45b749323f49(a, b) {
    if (a == null) return b;
    if (b == null) return a;
    return a * b / $b49750109e236fd8$export$a368fd580c0d0fe4(a, b);
}
function $b49750109e236fd8$export$b5c30d4208814a65(val) {
    return val != null && isFinite(val);
}



function $87f4a59ac66e0ee6$var$interpolateNumber(p0, p1, percent) {
    return (p1 - p0) * percent + p0;
}
/**
 * Make the name displayable. But we should
 * make sure it is not duplicated with user
 * specified name, so use '\0';
 */ var $87f4a59ac66e0ee6$var$DUMMY_COMPONENT_NAME_PREFIX = "series\0";
var $87f4a59ac66e0ee6$var$INTERNAL_COMPONENT_ID_PREFIX = "\0_ec_\0";
function $87f4a59ac66e0ee6$export$4f07b212a02c8051(value) {
    return value instanceof Array ? value : value == null ? [] : [
        value
    ];
}
function $87f4a59ac66e0ee6$export$abdcc6a26372f94b(opt, key, subOpts) {
    // Caution: performance sensitive.
    if (opt) {
        opt[key] = opt[key] || {};
        opt.emphasis = opt.emphasis || {};
        opt.emphasis[key] = opt.emphasis[key] || {};
        // Default emphasis option from normal
        for(var i = 0, len = subOpts.length; i < len; i++){
            var subOptName = subOpts[i];
            if (!opt.emphasis[key].hasOwnProperty(subOptName) && opt[key].hasOwnProperty(subOptName)) opt.emphasis[key][subOptName] = opt[key][subOptName];
        }
    }
}
var $87f4a59ac66e0ee6$export$df45610347a602ad = [
    "fontStyle",
    "fontWeight",
    "fontSize",
    "fontFamily",
    "rich",
    "tag",
    "color",
    "textBorderColor",
    "textBorderWidth",
    "width",
    "height",
    "lineHeight",
    "align",
    "verticalAlign",
    "baseline",
    "shadowColor",
    "shadowBlur",
    "shadowOffsetX",
    "shadowOffsetY",
    "textShadowColor",
    "textShadowBlur",
    "textShadowOffsetX",
    "textShadowOffsetY",
    "backgroundColor",
    "borderColor",
    "borderWidth",
    "borderRadius",
    "padding"
];
function $87f4a59ac66e0ee6$export$2c944e12edb48d4b(dataItem) {
    return (0, $43e0a445ed6711da$export$a6cdc56e425d0d0a)(dataItem) && !(0, $43e0a445ed6711da$export$43bee75e5e14138e)(dataItem) && !(dataItem instanceof Date) ? dataItem.value : dataItem;
}
function $87f4a59ac66e0ee6$export$3e1a543f33ef6883(dataItem) {
    return (0, $43e0a445ed6711da$export$a6cdc56e425d0d0a)(dataItem) && !(dataItem instanceof Array);
// // markLine data can be array
// && !(dataItem[0] && isObject(dataItem[0]) && !(dataItem[0] instanceof Array));
}
function $87f4a59ac66e0ee6$export$574f818966e4da87(existings, newCmptOptions, mode) {
    var isNormalMergeMode = mode === "normalMerge";
    var isReplaceMergeMode = mode === "replaceMerge";
    var isReplaceAllMode = mode === "replaceAll";
    existings = existings || [];
    newCmptOptions = (newCmptOptions || []).slice();
    var existingIdIdxMap = (0, $43e0a445ed6711da$export$55f8aa7ef875b0a4)();
    // Validate id and name on user input option.
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)(newCmptOptions, function(cmptOption, index) {
        if (!(0, $43e0a445ed6711da$export$a6cdc56e425d0d0a)(cmptOption)) {
            newCmptOptions[index] = null;
            return;
        }
    });
    var result = $87f4a59ac66e0ee6$var$prepareResult(existings, existingIdIdxMap, mode);
    if (isNormalMergeMode || isReplaceMergeMode) $87f4a59ac66e0ee6$var$mappingById(result, existings, existingIdIdxMap, newCmptOptions);
    if (isNormalMergeMode) $87f4a59ac66e0ee6$var$mappingByName(result, newCmptOptions);
    if (isNormalMergeMode || isReplaceMergeMode) $87f4a59ac66e0ee6$var$mappingByIndex(result, newCmptOptions, isReplaceMergeMode);
    else if (isReplaceAllMode) $87f4a59ac66e0ee6$var$mappingInReplaceAllMode(result, newCmptOptions);
    $87f4a59ac66e0ee6$var$makeIdAndName(result);
    // The array `result` MUST NOT contain elided items, otherwise the
    // forEach will omit those items and result in incorrect result.
    return result;
}
function $87f4a59ac66e0ee6$var$prepareResult(existings, existingIdIdxMap, mode) {
    var result = [];
    if (mode === "replaceAll") return result;
    // Do not use native `map` to in case that the array `existings`
    // contains elided items, which will be omitted.
    for(var index = 0; index < existings.length; index++){
        var existing = existings[index];
        // Because of replaceMerge, `existing` may be null/undefined.
        if (existing && existing.id != null) existingIdIdxMap.set(existing.id, index);
        // For non-internal-componnets:
        //     Mode "normalMerge": all existings kept.
        //     Mode "replaceMerge": all existing removed unless mapped by id.
        // For internal-components:
        //     go with "replaceMerge" approach in both mode.
        result.push({
            existing: mode === "replaceMerge" || $87f4a59ac66e0ee6$export$feece3e7d52a102b(existing) ? null : existing,
            newOption: null,
            keyInfo: null,
            brandNew: null
        });
    }
    return result;
}
function $87f4a59ac66e0ee6$var$mappingById(result, existings, existingIdIdxMap, newCmptOptions) {
    // Mapping by id if specified.
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)(newCmptOptions, function(cmptOption, index) {
        if (!cmptOption || cmptOption.id == null) return;
        var optionId = $87f4a59ac66e0ee6$var$makeComparableKey(cmptOption.id);
        var existingIdx = existingIdIdxMap.get(optionId);
        if (existingIdx != null) {
            var resultItem = result[existingIdx];
            (0, $43e0a445ed6711da$export$a7a9523472993e97)(!resultItem.newOption, 'Duplicated option on id "' + optionId + '".');
            resultItem.newOption = cmptOption;
            // In both mode, if id matched, new option will be merged to
            // the existings rather than creating new component model.
            resultItem.existing = existings[existingIdx];
            newCmptOptions[index] = null;
        }
    });
}
function $87f4a59ac66e0ee6$var$mappingByName(result, newCmptOptions) {
    // Mapping by name if specified.
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)(newCmptOptions, function(cmptOption, index) {
        if (!cmptOption || cmptOption.name == null) return;
        for(var i = 0; i < result.length; i++){
            var existing = result[i].existing;
            if (!result[i].newOption // Consider name: two map to one.
             && existing && (existing.id == null || cmptOption.id == null) && !$87f4a59ac66e0ee6$export$feece3e7d52a102b(cmptOption) && !$87f4a59ac66e0ee6$export$feece3e7d52a102b(existing) && $87f4a59ac66e0ee6$var$keyExistAndEqual("name", existing, cmptOption)) {
                result[i].newOption = cmptOption;
                newCmptOptions[index] = null;
                return;
            }
        }
    });
}
function $87f4a59ac66e0ee6$var$mappingByIndex(result, newCmptOptions, brandNew) {
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)(newCmptOptions, function(cmptOption) {
        if (!cmptOption) return;
        // Find the first place that not mapped by id and not internal component (consider the "hole").
        var resultItem;
        var nextIdx = 0;
        while(// Be `!resultItem` only when `nextIdx >= result.length`.
        (resultItem = result[nextIdx]) && (resultItem.newOption || $87f4a59ac66e0ee6$export$feece3e7d52a102b(resultItem.existing) || // In mode "replaceMerge", here no not-mapped-non-internal-existing.
        resultItem.existing && cmptOption.id != null && !$87f4a59ac66e0ee6$var$keyExistAndEqual("id", cmptOption, resultItem.existing)))nextIdx++;
        if (resultItem) {
            resultItem.newOption = cmptOption;
            resultItem.brandNew = brandNew;
        } else result.push({
            newOption: cmptOption,
            brandNew: brandNew,
            existing: null,
            keyInfo: null
        });
        nextIdx++;
    });
}
function $87f4a59ac66e0ee6$var$mappingInReplaceAllMode(result, newCmptOptions) {
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)(newCmptOptions, function(cmptOption) {
        // The feature "reproduce" requires "hole" will also reproduced
        // in case that component index referring are broken.
        result.push({
            newOption: cmptOption,
            brandNew: true,
            existing: null,
            keyInfo: null
        });
    });
}
/**
 * Make id and name for mapping result (result of mappingToExists)
 * into `keyInfo` field.
 */ function $87f4a59ac66e0ee6$var$makeIdAndName(mapResult) {
    // We use this id to hash component models and view instances
    // in echarts. id can be specified by user, or auto generated.
    // The id generation rule ensures new view instance are able
    // to mapped to old instance when setOption are called in
    // no-merge mode. So we generate model id by name and plus
    // type in view id.
    // name can be duplicated among components, which is convenient
    // to specify multi components (like series) by one name.
    // Ensure that each id is distinct.
    var idMap = (0, $43e0a445ed6711da$export$55f8aa7ef875b0a4)();
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)(mapResult, function(item) {
        var existing = item.existing;
        existing && idMap.set(existing.id, item);
    });
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)(mapResult, function(item) {
        var opt = item.newOption;
        // Force ensure id not duplicated.
        (0, $43e0a445ed6711da$export$a7a9523472993e97)(!opt || opt.id == null || !idMap.get(opt.id) || idMap.get(opt.id) === item, "id duplicates: " + (opt && opt.id));
        opt && opt.id != null && idMap.set(opt.id, item);
        !item.keyInfo && (item.keyInfo = {});
    });
    // Make name and id.
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)(mapResult, function(item, index) {
        var existing = item.existing;
        var opt = item.newOption;
        var keyInfo = item.keyInfo;
        if (!(0, $43e0a445ed6711da$export$a6cdc56e425d0d0a)(opt)) return;
        // Name can be overwritten. Consider case: axis.name = '20km'.
        // But id generated by name will not be changed, which affect
        // only in that case: setOption with 'not merge mode' and view
        // instance will be recreated, which can be accepted.
        keyInfo.name = opt.name != null ? $87f4a59ac66e0ee6$var$makeComparableKey(opt.name) : existing ? existing.name : $87f4a59ac66e0ee6$var$DUMMY_COMPONENT_NAME_PREFIX + index;
        if (existing) keyInfo.id = $87f4a59ac66e0ee6$var$makeComparableKey(existing.id);
        else if (opt.id != null) keyInfo.id = $87f4a59ac66e0ee6$var$makeComparableKey(opt.id);
        else {
            // Consider this situatoin:
            //  optionA: [{name: 'a'}, {name: 'a'}, {..}]
            //  optionB [{..}, {name: 'a'}, {name: 'a'}]
            // Series with the same name between optionA and optionB
            // should be mapped.
            var idNum = 0;
            do keyInfo.id = "\0" + keyInfo.name + "\0" + idNum++;
            while (idMap.get(keyInfo.id));
        }
        idMap.set(keyInfo.id, item);
    });
}
function $87f4a59ac66e0ee6$var$keyExistAndEqual(attr, obj1, obj2) {
    var key1 = $87f4a59ac66e0ee6$export$fb1a222ba5dd6e51(obj1[attr], null);
    var key2 = $87f4a59ac66e0ee6$export$fb1a222ba5dd6e51(obj2[attr], null);
    // See `MappingExistingItem`. `id` and `name` trade string equals to number.
    return key1 != null && key2 != null && key1 === key2;
}
/**
 * @return return null if not exist.
 */ function $87f4a59ac66e0ee6$var$makeComparableKey(val) {
    return $87f4a59ac66e0ee6$export$fb1a222ba5dd6e51(val, "");
}
function $87f4a59ac66e0ee6$export$fb1a222ba5dd6e51(idOrName, defaultValue) {
    if (idOrName == null) return defaultValue;
    return (0, $43e0a445ed6711da$export$844ec244b1367d54)(idOrName) ? idOrName : (0, $43e0a445ed6711da$export$7e4aa119212bc614)(idOrName) || (0, $43e0a445ed6711da$export$29d0bb2a4e07b252)(idOrName) ? idOrName + "" : defaultValue;
}
function $87f4a59ac66e0ee6$var$warnInvalidateIdOrName(idOrName) {}
function $87f4a59ac66e0ee6$var$isValidIdOrName(idOrName) {
    return (0, $43e0a445ed6711da$export$29d0bb2a4e07b252)(idOrName) || (0, $b49750109e236fd8$export$e90fb89750dba83f)(idOrName);
}
function $87f4a59ac66e0ee6$export$beae19a2652b3368(componentModel) {
    var name = componentModel.name;
    // Is specified when `indexOf` get -1 or > 0.
    return !!(name && name.indexOf($87f4a59ac66e0ee6$var$DUMMY_COMPONENT_NAME_PREFIX));
}
function $87f4a59ac66e0ee6$export$feece3e7d52a102b(cmptOption) {
    return cmptOption && cmptOption.id != null && $87f4a59ac66e0ee6$var$makeComparableKey(cmptOption.id).indexOf($87f4a59ac66e0ee6$var$INTERNAL_COMPONENT_ID_PREFIX) === 0;
}
function $87f4a59ac66e0ee6$export$1753133c42e665e8(idSuffix) {
    return $87f4a59ac66e0ee6$var$INTERNAL_COMPONENT_ID_PREFIX + idSuffix;
}
function $87f4a59ac66e0ee6$export$5ac61aca2ba0282d(mappingResult, mainType, componentModelCtor) {
    // Set mainType and complete subType.
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)(mappingResult, function(item) {
        var newOption = item.newOption;
        if ((0, $43e0a445ed6711da$export$a6cdc56e425d0d0a)(newOption)) {
            item.keyInfo.mainType = mainType;
            item.keyInfo.subType = $87f4a59ac66e0ee6$var$determineSubType(mainType, newOption, item.existing, componentModelCtor);
        }
    });
}
function $87f4a59ac66e0ee6$var$determineSubType(mainType, newCmptOption, existComponent, componentModelCtor) {
    var subType = newCmptOption.type ? newCmptOption.type : existComponent ? existComponent.subType : componentModelCtor.determineSubType(mainType, newCmptOption);
    // tooltip, markline, markpoint may always has no subType
    return subType;
}
function $87f4a59ac66e0ee6$export$6d12cabb0c9bf8e3(batchA, batchB) {
    var mapA = {};
    var mapB = {};
    makeMap(batchA || [], mapA);
    makeMap(batchB || [], mapB, mapA);
    return [
        mapToArray(mapA),
        mapToArray(mapB)
    ];
    function makeMap(sourceBatch, map, otherMap) {
        for(var i = 0, len = sourceBatch.length; i < len; i++){
            var seriesId = $87f4a59ac66e0ee6$export$fb1a222ba5dd6e51(sourceBatch[i].seriesId, null);
            if (seriesId == null) return;
            var dataIndices = $87f4a59ac66e0ee6$export$4f07b212a02c8051(sourceBatch[i].dataIndex);
            var otherDataIndices = otherMap && otherMap[seriesId];
            for(var j = 0, lenj = dataIndices.length; j < lenj; j++){
                var dataIndex = dataIndices[j];
                if (otherDataIndices && otherDataIndices[dataIndex]) otherDataIndices[dataIndex] = null;
                else (map[seriesId] || (map[seriesId] = {}))[dataIndex] = 1;
            }
        }
    }
    function mapToArray(map, isData) {
        var result = [];
        for(var i in map)if (map.hasOwnProperty(i) && map[i] != null) {
            if (isData) result.push(+i);
            else {
                var dataIndices = mapToArray(map[i], true);
                dataIndices.length && result.push({
                    seriesId: i,
                    dataIndex: dataIndices
                });
            }
        }
        return result;
    }
}
function $87f4a59ac66e0ee6$export$42b26cae8b8d10(data, payload) {
    if (payload.dataIndexInside != null) return payload.dataIndexInside;
    else if (payload.dataIndex != null) return (0, $43e0a445ed6711da$export$43bee75e5e14138e)(payload.dataIndex) ? (0, $43e0a445ed6711da$export$871de8747c9eaa88)(payload.dataIndex, function(value) {
        return data.indexOfRawIndex(value);
    }) : data.indexOfRawIndex(payload.dataIndex);
    else if (payload.name != null) return (0, $43e0a445ed6711da$export$43bee75e5e14138e)(payload.name) ? (0, $43e0a445ed6711da$export$871de8747c9eaa88)(payload.name, function(value) {
        return data.indexOfName(value);
    }) : data.indexOfName(payload.name);
}
function $87f4a59ac66e0ee6$export$64df9f8d92ae083f() {
    var key = "__ec_inner_" + $87f4a59ac66e0ee6$var$innerUniqueIndex++;
    return function(hostObj) {
        return hostObj[key] || (hostObj[key] = {});
    };
}
var $87f4a59ac66e0ee6$var$innerUniqueIndex = (0, $b49750109e236fd8$export$474d2ec9aa44a22)();
function $87f4a59ac66e0ee6$export$95de80076abac814(ecModel, finderInput, opt) {
    var _a = $87f4a59ac66e0ee6$export$fe600815775d9400(finderInput, opt), mainTypeSpecified = _a.mainTypeSpecified, queryOptionMap = _a.queryOptionMap, others = _a.others;
    var result = others;
    var defaultMainType = opt ? opt.defaultMainType : null;
    if (!mainTypeSpecified && defaultMainType) queryOptionMap.set(defaultMainType, {});
    queryOptionMap.each(function(queryOption, mainType) {
        var queryResult = $87f4a59ac66e0ee6$export$dc741340f7e5f186(ecModel, mainType, queryOption, {
            useDefault: defaultMainType === mainType,
            enableAll: opt && opt.enableAll != null ? opt.enableAll : true,
            enableNone: opt && opt.enableNone != null ? opt.enableNone : true
        });
        result[mainType + "Models"] = queryResult.models;
        result[mainType + "Model"] = queryResult.models[0];
    });
    return result;
}
function $87f4a59ac66e0ee6$export$fe600815775d9400(finderInput, opt) {
    var finder;
    if ((0, $43e0a445ed6711da$export$844ec244b1367d54)(finderInput)) {
        var obj = {};
        obj[finderInput + "Index"] = 0;
        finder = obj;
    } else finder = finderInput;
    var queryOptionMap = (0, $43e0a445ed6711da$export$55f8aa7ef875b0a4)();
    var others = {};
    var mainTypeSpecified = false;
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)(finder, function(value, key) {
        // Exclude 'dataIndex' and other illegal keys.
        if (key === "dataIndex" || key === "dataIndexInside") {
            others[key] = value;
            return;
        }
        var parsedKey = key.match(/^(\w+)(Index|Id|Name)$/) || [];
        var mainType = parsedKey[1];
        var queryType = (parsedKey[2] || "").toLowerCase();
        if (!mainType || !queryType || opt && opt.includeMainTypes && (0, $43e0a445ed6711da$export$305f7d4e9d4624f2)(opt.includeMainTypes, mainType) < 0) return;
        mainTypeSpecified = mainTypeSpecified || !!mainType;
        var queryOption = queryOptionMap.get(mainType) || queryOptionMap.set(mainType, {});
        queryOption[queryType] = value;
    });
    return {
        mainTypeSpecified: mainTypeSpecified,
        queryOptionMap: queryOptionMap,
        others: others
    };
}
var $87f4a59ac66e0ee6$export$f076738ec84e693c = {
    useDefault: true,
    enableAll: false,
    enableNone: false
};
var $87f4a59ac66e0ee6$export$48d598924ce4892c = {
    useDefault: false,
    enableAll: true,
    enableNone: true
};
function $87f4a59ac66e0ee6$export$dc741340f7e5f186(ecModel, mainType, userOption, opt) {
    opt = opt || $87f4a59ac66e0ee6$export$f076738ec84e693c;
    var indexOption = userOption.index;
    var idOption = userOption.id;
    var nameOption = userOption.name;
    var result = {
        models: null,
        specified: indexOption != null || idOption != null || nameOption != null
    };
    if (!result.specified) {
        // Use the first as default if `useDefault`.
        var firstCmpt = void 0;
        result.models = opt.useDefault && (firstCmpt = ecModel.getComponent(mainType)) ? [
            firstCmpt
        ] : [];
        return result;
    }
    if (indexOption === "none" || indexOption === false) {
        if (opt.enableNone) {
            result.models = [];
            return result;
        } else indexOption = -1; // Can not query by index but may still query by id/name if specified.
    }
    // `queryComponents` will return all components if
    // both all of index/id/name are null/undefined.
    if (indexOption === "all") {
        if (opt.enableAll) indexOption = idOption = nameOption = null;
        else indexOption = -1;
    }
    result.models = ecModel.queryComponents({
        mainType: mainType,
        index: indexOption,
        id: idOption,
        name: nameOption
    });
    return result;
}
function $87f4a59ac66e0ee6$export$c064a542e5272c93(payload, // `mainType` is mandatory to restrict the range of query,
// since `payload` in an user input.
mainType, // subType may be '' by `parseClassType`
subType) {
    var query = {};
    query[mainType + "Id"] = payload[mainType + "Id"];
    query[mainType + "Index"] = payload[mainType + "Index"];
    query[mainType + "Name"] = payload[mainType + "Name"];
    var condition = {
        mainType: mainType,
        query: query
    };
    subType && (condition.subType = subType); // subType is determined by `hasOwnProperty`.
    return condition;
}
function $87f4a59ac66e0ee6$export$9fec4d97f1922e0b(dom, key, value) {
    dom.setAttribute ? dom.setAttribute(key, value) : dom[key] = value;
}
function $87f4a59ac66e0ee6$export$735ee1799fd02602(dom, key) {
    return dom.getAttribute ? dom.getAttribute(key) : dom[key];
}
function $87f4a59ac66e0ee6$export$cc0a17a5d27b4e17(renderModeOption) {
    if (renderModeOption === "auto") // Using html when `document` exists, use richText otherwise
    return (0, $a84633bb9c74d89c$export$2e2bcd8739ae039).domSupported ? "html" : "richText";
    else return renderModeOption || "html";
}
function $87f4a59ac66e0ee6$export$7ab5bda43e13168f(array, getKey // return key
) {
    var buckets = (0, $43e0a445ed6711da$export$55f8aa7ef875b0a4)();
    var keys = [];
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)(array, function(item) {
        var key = getKey(item);
        (buckets.get(key) || (keys.push(key), buckets.set(key, []))).push(item);
    });
    return {
        keys: keys,
        buckets: buckets
    };
}
function $87f4a59ac66e0ee6$export$bd0439821a1869f3(data, precision, sourceValue, targetValue, percent) {
    var isAutoPrecision = precision == null || precision === "auto";
    if (targetValue == null) return targetValue;
    if ((0, $43e0a445ed6711da$export$7e4aa119212bc614)(targetValue)) {
        var value = $87f4a59ac66e0ee6$var$interpolateNumber(sourceValue || 0, targetValue, percent);
        return (0, $b49750109e236fd8$export$2077e0241d6afd3c)(value, isAutoPrecision ? Math.max((0, $b49750109e236fd8$export$e0c74b50bbd10f68)(sourceValue || 0), (0, $b49750109e236fd8$export$e0c74b50bbd10f68)(targetValue)) : precision);
    } else if ((0, $43e0a445ed6711da$export$844ec244b1367d54)(targetValue)) return percent < 1 ? sourceValue : targetValue;
    else {
        var interpolated = [];
        var leftArr = sourceValue;
        var rightArr = targetValue;
        var length_1 = Math.max(leftArr ? leftArr.length : 0, rightArr.length);
        for(var i = 0; i < length_1; ++i){
            var info = data.getDimensionInfo(i);
            // Don't interpolate ordinal dims
            if (info && info.type === "ordinal") // In init, there is no `sourceValue`, but should better not to get undefined result.
            interpolated[i] = (percent < 1 && leftArr ? leftArr : rightArr)[i];
            else {
                var leftVal = leftArr && leftArr[i] ? leftArr[i] : 0;
                var rightVal = rightArr[i];
                var value = $87f4a59ac66e0ee6$var$interpolateNumber(leftVal, rightVal, percent);
                interpolated[i] = (0, $b49750109e236fd8$export$2077e0241d6afd3c)(value, isAutoPrecision ? Math.max((0, $b49750109e236fd8$export$e0c74b50bbd10f68)(leftVal), (0, $b49750109e236fd8$export$e0c74b50bbd10f68)(rightVal)) : precision);
            }
        }
        return interpolated;
    }
}
/**
 * Use an iterator to avoid exposing the internal list or duplicating it
 * for the outside traveller, and no extra heap allocation.
 * @usage
 *  for (const it = resetIterator(); it.next();) {
 *      const item = it.item;
 *      const key = it.key;
 *      const itIdx = it.itIdx;
 *      // ...
 *  }
 * @usage
 *  const it = resetIterator();
 *  while (it.next()) { ... }
 * @usage
 *  for (resetIterator(it); it.next();) { ... }
 */ var $87f4a59ac66e0ee6$export$4e38036c4470d56c = /** @class */ function() {
    function ListIterator() {}
    /**
   * The loop condition is `idx < end` if `step > 0`;
   * The loop condition is `idx >= end` if `step < 0`.
   *
   * @param end By default `list.length` if `step > 0`; `0` if `step < 0`.
   * @param step By default `1`.
   */ ListIterator.prototype.reset = function(list, start, end, step) {
        this._list = list;
        this._step = step = step || 1;
        this._idx = start;
        this._end = end != null ? end : step > 0 ? list.length : 0;
        this.item = null;
        this.key = NaN;
        return this;
    };
    ListIterator.prototype.next = function() {
        if (this._step > 0 ? this._idx < this._end : this._idx >= this._end) {
            this.item = this._list[this._idx];
            this.key = this._idx = this._idx + this._step;
            return true;
        }
        return false;
    };
    return ListIterator;
}();
function $87f4a59ac66e0ee6$export$be44d6593b016f3e(model) {
    // Clear to avoid memory leak.
    model.option = model.parentModel = model.ecModel = null;
}
function $87f4a59ac66e0ee6$export$62e5f07ab009f3b() {
    return [
        Infinity,
        -Infinity
    ];
}
function $87f4a59ac66e0ee6$export$c28a8a63acb35a19(extent, val) {
    if ($87f4a59ac66e0ee6$export$5af06089290883e2(val)) {
        val < extent[0] && (extent[0] = val);
        val > extent[1] && (extent[1] = val);
    }
}
function $87f4a59ac66e0ee6$export$a7951d5427fae7a0(extent, val) {
    if ($87f4a59ac66e0ee6$export$5af06089290883e2(val) && val < extent[0]) extent[0] = val;
}
function $87f4a59ac66e0ee6$export$707ef09fb8bbaa0e(extent, val) {
    if ($87f4a59ac66e0ee6$export$5af06089290883e2(val) && val > extent[1]) extent[1] = val;
}
function $87f4a59ac66e0ee6$export$380d5a0634ac86f8(tarExtent, srcExtent) {
    // Accept both or neither.
    if ($87f4a59ac66e0ee6$export$d386653f29930adb(srcExtent[0], srcExtent[1])) {
        srcExtent[0] < tarExtent[0] && (tarExtent[0] = srcExtent[0]);
        srcExtent[1] > tarExtent[1] && (tarExtent[1] = srcExtent[1]);
    }
}
function $87f4a59ac66e0ee6$export$5af06089290883e2(val) {
    // Considered that number could be `NaN` and `Infinity` and should not write into the extent.
    // Note that `Infinity` is the initialized value from `initExtentForUnion` and may be inputted.
    return val != null && isFinite(val);
}
function $87f4a59ac66e0ee6$export$d386653f29930adb(start, end) {
    return $87f4a59ac66e0ee6$export$5af06089290883e2(start) && $87f4a59ac66e0ee6$export$5af06089290883e2(end) && start <= end;
}
function $87f4a59ac66e0ee6$export$622ca7efe3351d22(extent) {
    // Also considered extent may have `NaN` and `Infinity`.
    var span = extent[1] - extent[0];
    return isFinite(span) && span >= 0;
}
function $87f4a59ac66e0ee6$export$fca8d858e99f6a42(extent) {
    if ($87f4a59ac66e0ee6$export$d386653f29930adb(extent[0], extent[1]) && extent[0] > extent[1]) extent[0] = extent[1];
}
function $87f4a59ac66e0ee6$export$a305e9b27fd23ae3() {
    var hiddenKey = "__ec_once_" + $87f4a59ac66e0ee6$var$onceUniqueIndex++;
    return function(hostObj, cb) {
        if (!(0, $43e0a445ed6711da$export$b5a638e9b3fff9f3)(hostObj, hiddenKey)) {
            hostObj[hiddenKey] = 1;
            cb();
        }
    };
}
var $87f4a59ac66e0ee6$var$onceUniqueIndex = (0, $b49750109e236fd8$export$474d2ec9aa44a22)();
function $87f4a59ac66e0ee6$export$2e2262a44ac61957(arr, getKey, // `existingCount`: the count before this item is added.
resolve) {
    var dupMap = (0, $43e0a445ed6711da$export$55f8aa7ef875b0a4)();
    var writeIdx = 0;
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)(arr, function(item) {
        var key = getKey(item);
        var count = dupMap.get(key) || 0;
        if (resolve) resolve(item, count);
        if (!count && !resolve) arr[writeIdx++] = item;
        dupMap.set(key, count + 1);
    });
    if (!resolve) arr.length = writeIdx;
}
function $87f4a59ac66e0ee6$export$605c429b4975bbd7(item) {
    return item.value + "";
}
function $87f4a59ac66e0ee6$export$fec5e8fdd97d769b(item) {
    return item + "";
}
function $87f4a59ac66e0ee6$export$4496820b7f3d3e98(seriesModel, useIncremental) {
    // 0 means disable incremental.
    // 1 is preserved for backward compatibility.
    return (0, $43e0a445ed6711da$export$995e01f2f5c9d030)(useIncremental, true) ? seriesModel.seriesIndex + 2 : 0;
}
function $87f4a59ac66e0ee6$export$3b33f7e0868ca070(seriesModel, view, pipeline) {
    var dataLen = seriesModel.getData().count();
    return {
        progressiveRender: pipeline.progressiveEnabled && view.incrementalPrepareRender && dataLen >= pipeline.threshold,
        large: seriesModel.get("large") && dataLen >= seriesModel.get("largeThreshold"),
        // TODO: modDataCount should not updated if `appendData`, otherwise cause whole repaint.
        // see `test/candlestick-large3.html`
        modDataCount: seriesModel.get("progressiveChunkMode") === "mod" ? seriesModel.getData().count() : null
    };
}
function $87f4a59ac66e0ee6$export$e9d2910fc7a89b3c(// null/undefined is not allowed, otherwise bug-prone.
upstreamOutputRange, thisTaskPlannedRange) {
    (0, $43e0a445ed6711da$export$a7a9523472993e97)(upstreamOutputRange.start === thisTaskPlannedRange.start && upstreamOutputRange.end === thisTaskPlannedRange.end);
}
function $87f4a59ac66e0ee6$export$c635911e41d20ada(seriesType, overallReset) {
    return {
        seriesType: seriesType,
        overallReset: overallReset
    };
}
function $87f4a59ac66e0ee6$export$d62c61cad9d1ab83(overallReset) {
    return {
        overallReset: overallReset
    };
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $10ce7a4361c3910c$var$TYPE_DELIMITER = ".";
var $10ce7a4361c3910c$var$IS_CONTAINER = "___EC__COMPONENT__CONTAINER___";
var $10ce7a4361c3910c$var$IS_EXTENDED_CLASS = "___EC__EXTENDED_CLASS___";
function $10ce7a4361c3910c$export$fbe18865d303bf01(componentType) {
    var ret = {
        main: "",
        sub: ""
    };
    if (componentType) {
        var typeArr = componentType.split($10ce7a4361c3910c$var$TYPE_DELIMITER);
        ret.main = typeArr[0] || "";
        ret.sub = typeArr[1] || "";
    }
    return ret;
}
/**
 * @public
 */ function $10ce7a4361c3910c$var$checkClassType(componentType) {
    $43e0a445ed6711da$export$a7a9523472993e97(/^[a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)?$/.test(componentType), 'componentType "' + componentType + '" illegal');
}
function $10ce7a4361c3910c$export$4f3b818f3dd2d182(clz) {
    return !!(clz && clz[$10ce7a4361c3910c$var$IS_EXTENDED_CLASS]);
}
function $10ce7a4361c3910c$export$cd4c3a4dca301c70(rootClz, mandatoryMethods) {
    rootClz.$constructor = rootClz; // FIXME: not necessary?
    rootClz.extend = function(proto) {
        var superClass = this;
        var ExtendedClass;
        if ($10ce7a4361c3910c$var$isESClass(superClass)) ExtendedClass = /** @class */ function(_super) {
            (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(class_1, _super);
            function class_1() {
                return _super.apply(this, arguments) || this;
            }
            return class_1;
        }(superClass);
        else {
            // For backward compat, we both support ts class inheritance and this
            // "extend" approach.
            // The constructor should keep the same behavior as ts class inheritance:
            // If this constructor/$constructor is not declared, auto invoke the super
            // constructor.
            // If this constructor/$constructor is declared, it is responsible for
            // calling the super constructor.
            ExtendedClass = function() {
                (proto.$constructor || superClass).apply(this, arguments);
            };
            $43e0a445ed6711da$export$69f1b2dcda23c5f8(ExtendedClass, this);
        }
        $43e0a445ed6711da$export$8b58be045bf06082(ExtendedClass.prototype, proto);
        ExtendedClass[$10ce7a4361c3910c$var$IS_EXTENDED_CLASS] = true;
        ExtendedClass.extend = this.extend;
        ExtendedClass.superCall = $10ce7a4361c3910c$var$superCall;
        ExtendedClass.superApply = $10ce7a4361c3910c$var$superApply;
        ExtendedClass.superClass = superClass;
        return ExtendedClass;
    };
}
function $10ce7a4361c3910c$var$isESClass(fn) {
    return $43e0a445ed6711da$export$f6e2535fb5126e54(fn) && /^class\s/.test(Function.prototype.toString.call(fn));
}
function $10ce7a4361c3910c$export$c9c2d87774f1275d(SubClz, SupperClz) {
    SubClz.extend = SupperClz.extend;
}
// A random offset.
var $10ce7a4361c3910c$var$classBase = Math.round(Math.random() * 10);
function $10ce7a4361c3910c$export$e1aac4552ae82081(target) {
    var classAttr = [
        "__\0is_clz",
        $10ce7a4361c3910c$var$classBase++
    ].join("_");
    target.prototype[classAttr] = true;
    target.isInstance = function(obj) {
        return !!(obj && obj[classAttr]);
    };
}
// superCall should have class info, which can not be fetched from 'this'.
// Consider this case:
// class A has method f,
// class B inherits class A, overrides method f, f call superApply('f'),
// class C inherits class B, does not override method f,
// then when method of class C is called, dead loop occurred.
function $10ce7a4361c3910c$var$superCall(context, methodName) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    return this.superClass.prototype[methodName].apply(context, args);
}
function $10ce7a4361c3910c$var$superApply(context, methodName, args) {
    return this.superClass.prototype[methodName].apply(context, args);
}
function $10ce7a4361c3910c$export$241315e45585454d(target) {
    /**
   * Component model classes
   * key: componentType,
   * value:
   *     componentClass, when componentType is 'a'
   *     or Object.<subKey, componentClass>, when componentType is 'a.b'
   */ var storage = {};
    target.registerClass = function(clz) {
        // `type` should not be a "instance member".
        // If using TS class, should better declared as `static type = 'series.pie'`.
        // otherwise users have to mount `type` on prototype manually.
        // For backward compat and enable instance visit type via `this.type`,
        // we still support fetch `type` from prototype.
        var componentFullType = clz.type || clz.prototype.type;
        if (componentFullType) {
            $10ce7a4361c3910c$var$checkClassType(componentFullType);
            // If only static type declared, we assign it to prototype mandatorily.
            clz.prototype.type = componentFullType;
            var componentTypeInfo = $10ce7a4361c3910c$export$fbe18865d303bf01(componentFullType);
            if (!componentTypeInfo.sub) storage[componentTypeInfo.main] = clz;
            else if (componentTypeInfo.sub !== $10ce7a4361c3910c$var$IS_CONTAINER) {
                var container = makeContainer(componentTypeInfo);
                container[componentTypeInfo.sub] = clz;
            }
        }
        return clz;
    };
    target.getClass = function(mainType, subType, throwWhenNotFound) {
        var clz = storage[mainType];
        if (clz && clz[$10ce7a4361c3910c$var$IS_CONTAINER]) clz = subType ? clz[subType] : null;
        if (throwWhenNotFound && !clz) throw new Error(!subType ? mainType + "." + "type should be specified." : "Component " + mainType + "." + (subType || "") + " is used but not imported.");
        return clz;
    };
    target.getClassesByMainType = function(componentType) {
        var componentTypeInfo = $10ce7a4361c3910c$export$fbe18865d303bf01(componentType);
        var result = [];
        var obj = storage[componentTypeInfo.main];
        if (obj && obj[$10ce7a4361c3910c$var$IS_CONTAINER]) $43e0a445ed6711da$export$79b2f7037acddd43(obj, function(o, type) {
            type !== $10ce7a4361c3910c$var$IS_CONTAINER && result.push(o);
        });
        else result.push(obj);
        return result;
    };
    target.hasClass = function(componentType) {
        // Just consider componentType.main.
        var componentTypeInfo = $10ce7a4361c3910c$export$fbe18865d303bf01(componentType);
        return !!storage[componentTypeInfo.main];
    };
    /**
   * @return Like ['aa', 'bb'], but can not be ['aa.xx']
   */ target.getAllClassMainTypes = function() {
        var types = [];
        $43e0a445ed6711da$export$79b2f7037acddd43(storage, function(obj, type) {
            types.push(type);
        });
        return types;
    };
    /**
   * If a main type is container and has sub types
   */ target.hasSubTypes = function(componentType) {
        var componentTypeInfo = $10ce7a4361c3910c$export$fbe18865d303bf01(componentType);
        var obj = storage[componentTypeInfo.main];
        return obj && obj[$10ce7a4361c3910c$var$IS_CONTAINER];
    };
    function makeContainer(componentTypeInfo) {
        var container = storage[componentTypeInfo.main];
        if (!container || !container[$10ce7a4361c3910c$var$IS_CONTAINER]) {
            container = storage[componentTypeInfo.main] = {};
            container[$10ce7a4361c3910c$var$IS_CONTAINER] = true;
        }
        return container;
    }
} // /**
 //  * @param {string|Array.<string>} properties
 //  */
 // export function setReadOnly(obj, properties) {
 // FIXME It seems broken in IE8 simulation of IE11
 // if (!zrUtil.isArray(properties)) {
 //     properties = properties != null ? [properties] : [];
 // }
 // zrUtil.each(properties, function (prop) {
 //     let value = obj[prop];
 //     Object.defineProperty
 //         && Object.defineProperty(obj, prop, {
 //             value: value, writable: false
 //         });
 //     zrUtil.isArray(obj[prop])
 //         && Object.freeze
 //         && Object.freeze(obj[prop]);
 // });
 // }


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // TODO Parse shadow style
// TODO Only shallow path support

function $0b19196a0800a1eb$export$2e2bcd8739ae039(properties, ignoreParent) {
    // Normalize
    for(var i = 0; i < properties.length; i++)if (!properties[i][1]) properties[i][1] = properties[i][0];
    ignoreParent = ignoreParent || false;
    return function(model, excludes, includes) {
        var style = {};
        for(var i = 0; i < properties.length; i++){
            var propName = properties[i][1];
            if (excludes && $43e0a445ed6711da$export$305f7d4e9d4624f2(excludes, propName) >= 0 || includes && $43e0a445ed6711da$export$305f7d4e9d4624f2(includes, propName) < 0) continue;
            var val = model.getShallow(propName, ignoreParent);
            if (val != null) style[properties[i][0]] = val;
        }
        // TODO Text or image?
        return style;
    };
}


var $cb0bc0f271fe90a7$export$52de6e304d934d85 = [
    [
        "fill",
        "color"
    ],
    [
        "shadowBlur"
    ],
    [
        "shadowOffsetX"
    ],
    [
        "shadowOffsetY"
    ],
    [
        "opacity"
    ],
    [
        "shadowColor"
    ]
];
var $cb0bc0f271fe90a7$var$getAreaStyle = (0, $0b19196a0800a1eb$export$2e2bcd8739ae039)($cb0bc0f271fe90a7$export$52de6e304d934d85);
var $cb0bc0f271fe90a7$export$a3a0ed7e2dd84c9e = /** @class */ function() {
    function AreaStyleMixin() {}
    AreaStyleMixin.prototype.getAreaStyle = function(excludes, includes) {
        return $cb0bc0f271fe90a7$var$getAreaStyle(this, excludes, includes);
    };
    return AreaStyleMixin;
}();


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $b3b93921504aa1e2$var$globalImageCache = new (0, $0a70a3b1dc4cb6e5$export$2e2bcd8739ae039)(50);
function $b3b93921504aa1e2$export$1b614f30ac2c8867(newImageOrSrc) {
    if (typeof newImageOrSrc === "string") {
        var cachedImgObj = $b3b93921504aa1e2$var$globalImageCache.get(newImageOrSrc);
        return cachedImgObj && cachedImgObj.image;
    } else return newImageOrSrc;
}
function $b3b93921504aa1e2$export$46c791b69ff9a0f(newImageOrSrc, image, hostEl, onload, cbPayload) {
    if (!newImageOrSrc) return image;
    else if (typeof newImageOrSrc === "string") {
        if (image && image.__zrImageSrc === newImageOrSrc || !hostEl) return image;
        var cachedImgObj = $b3b93921504aa1e2$var$globalImageCache.get(newImageOrSrc);
        var pendingWrap = {
            hostEl: hostEl,
            cb: onload,
            cbPayload: cbPayload
        };
        if (cachedImgObj) {
            image = cachedImgObj.image;
            !$b3b93921504aa1e2$export$37ca7dd901d0236d(image) && cachedImgObj.pending.push(pendingWrap);
        } else {
            image = (0, $08c3209e6efc839a$export$ef5e599365494451).loadImage(newImageOrSrc, $b3b93921504aa1e2$var$imageOnLoad, $b3b93921504aa1e2$var$imageOnLoad);
            image.__zrImageSrc = newImageOrSrc;
            $b3b93921504aa1e2$var$globalImageCache.put(newImageOrSrc, image.__cachedImgObj = {
                image: image,
                pending: [
                    pendingWrap
                ]
            });
        }
        return image;
    } else return newImageOrSrc;
}
function $b3b93921504aa1e2$var$imageOnLoad() {
    var cachedImgObj = this.__cachedImgObj;
    this.onload = this.onerror = this.__cachedImgObj = null;
    for(var i = 0; i < cachedImgObj.pending.length; i++){
        var pendingWrap = cachedImgObj.pending[i];
        var cb = pendingWrap.cb;
        cb && cb(this, pendingWrap.cbPayload);
        pendingWrap.hostEl.dirty();
    }
    cachedImgObj.pending.length = 0;
}
function $b3b93921504aa1e2$export$37ca7dd901d0236d(image) {
    return image && image.width && image.height;
}





var $92d383513c7738d1$var$STYLE_REG = /\{([a-zA-Z0-9_]+)\|([^}]*)\}/g;
function $92d383513c7738d1$export$59a943b34a82e690(text, containerWidth, font, ellipsis, options) {
    var out = {};
    $92d383513c7738d1$var$truncateText2(out, text, containerWidth, font, ellipsis, options);
    return out.text;
}
function $92d383513c7738d1$var$truncateText2(out, text, containerWidth, font, ellipsis, options) {
    if (!containerWidth) {
        out.text = "";
        out.isTruncated = false;
        return;
    }
    var textLines = (text + "").split("\n");
    options = $92d383513c7738d1$var$prepareTruncateOptions(containerWidth, font, ellipsis, options);
    var isTruncated = false;
    var truncateOut = {};
    for(var i = 0, len = textLines.length; i < len; i++){
        $92d383513c7738d1$var$truncateSingleLine(truncateOut, textLines[i], options);
        textLines[i] = truncateOut.textLine;
        isTruncated = isTruncated || truncateOut.isTruncated;
    }
    out.text = textLines.join("\n");
    out.isTruncated = isTruncated;
}
function $92d383513c7738d1$var$prepareTruncateOptions(containerWidth, font, ellipsis, options) {
    options = options || {};
    var preparedOpts = (0, $43e0a445ed6711da$export$8b58be045bf06082)({}, options);
    ellipsis = (0, $43e0a445ed6711da$export$995e01f2f5c9d030)(ellipsis, "...");
    preparedOpts.maxIterations = (0, $43e0a445ed6711da$export$995e01f2f5c9d030)(options.maxIterations, 2);
    var minChar = preparedOpts.minChar = (0, $43e0a445ed6711da$export$995e01f2f5c9d030)(options.minChar, 0);
    var fontMeasureInfo = preparedOpts.fontMeasureInfo = (0, $67e15a06bdb46d49$export$23ef3ef10b010856)(font);
    var ascCharWidth = fontMeasureInfo.asciiCharWidth;
    preparedOpts.placeholder = (0, $43e0a445ed6711da$export$995e01f2f5c9d030)(options.placeholder, "");
    var contentWidth = containerWidth = Math.max(0, containerWidth - 1);
    for(var i = 0; i < minChar && contentWidth >= ascCharWidth; i++)contentWidth -= ascCharWidth;
    var ellipsisWidth = (0, $67e15a06bdb46d49$export$e6849d91c2a0b61f)(fontMeasureInfo, ellipsis);
    if (ellipsisWidth > contentWidth) {
        ellipsis = "";
        ellipsisWidth = 0;
    }
    contentWidth = containerWidth - ellipsisWidth;
    preparedOpts.ellipsis = ellipsis;
    preparedOpts.ellipsisWidth = ellipsisWidth;
    preparedOpts.contentWidth = contentWidth;
    preparedOpts.containerWidth = containerWidth;
    return preparedOpts;
}
function $92d383513c7738d1$var$truncateSingleLine(out, textLine, options) {
    var containerWidth = options.containerWidth;
    var contentWidth = options.contentWidth;
    var fontMeasureInfo = options.fontMeasureInfo;
    if (!containerWidth) {
        out.textLine = "";
        out.isTruncated = false;
        return;
    }
    var lineWidth = (0, $67e15a06bdb46d49$export$e6849d91c2a0b61f)(fontMeasureInfo, textLine);
    if (lineWidth <= containerWidth) {
        out.textLine = textLine;
        out.isTruncated = false;
        return;
    }
    for(var j = 0;; j++){
        if (lineWidth <= contentWidth || j >= options.maxIterations) {
            textLine += options.ellipsis;
            break;
        }
        var subLength = j === 0 ? $92d383513c7738d1$var$estimateLength(textLine, contentWidth, fontMeasureInfo) : lineWidth > 0 ? Math.floor(textLine.length * contentWidth / lineWidth) : 0;
        textLine = textLine.substr(0, subLength);
        lineWidth = (0, $67e15a06bdb46d49$export$e6849d91c2a0b61f)(fontMeasureInfo, textLine);
    }
    if (textLine === "") textLine = options.placeholder;
    out.textLine = textLine;
    out.isTruncated = true;
}
function $92d383513c7738d1$var$estimateLength(text, contentWidth, fontMeasureInfo) {
    var width = 0;
    var i = 0;
    for(var len = text.length; i < len && width < contentWidth; i++)width += (0, $67e15a06bdb46d49$export$4e92f5603b5c7bb3)(fontMeasureInfo, text.charCodeAt(i));
    return i;
}
function $92d383513c7738d1$export$5772575e34ef80f9(rawText, style, defaultOuterWidth, defaultOuterHeight) {
    var text = $92d383513c7738d1$var$formatText(rawText);
    var overflow = style.overflow;
    var padding = style.padding;
    var paddingH = padding ? padding[1] + padding[3] : 0;
    var paddingV = padding ? padding[0] + padding[2] : 0;
    var font = style.font;
    var truncate = overflow === "truncate";
    var calculatedLineHeight = (0, $67e15a06bdb46d49$export$56204a27a2958a55)(font);
    var lineHeight = (0, $43e0a445ed6711da$export$995e01f2f5c9d030)(style.lineHeight, calculatedLineHeight);
    var truncateLineOverflow = style.lineOverflow === "truncate";
    var isTruncated = false;
    var width = style.width;
    if (width == null && defaultOuterWidth != null) width = defaultOuterWidth - paddingH;
    var height = style.height;
    if (height == null && defaultOuterHeight != null) height = defaultOuterHeight - paddingV;
    var lines;
    if (width != null && (overflow === "break" || overflow === "breakAll")) lines = text ? $92d383513c7738d1$var$wrapText(text, style.font, width, overflow === "breakAll", 0).lines : [];
    else lines = text ? text.split("\n") : [];
    var contentHeight = lines.length * lineHeight;
    if (height == null) height = contentHeight;
    if (contentHeight > height && truncateLineOverflow) {
        var lineCount = Math.floor(height / lineHeight);
        isTruncated = isTruncated || lines.length > lineCount;
        lines = lines.slice(0, lineCount);
        contentHeight = lines.length * lineHeight;
    }
    if (text && truncate && width != null) {
        var options = $92d383513c7738d1$var$prepareTruncateOptions(width, font, style.ellipsis, {
            minChar: style.truncateMinChar,
            placeholder: style.placeholder
        });
        var singleOut = {};
        for(var i = 0; i < lines.length; i++){
            $92d383513c7738d1$var$truncateSingleLine(singleOut, lines[i], options);
            lines[i] = singleOut.textLine;
            isTruncated = isTruncated || singleOut.isTruncated;
        }
    }
    var outerHeight = height;
    var contentWidth = 0;
    var fontMeasureInfo = (0, $67e15a06bdb46d49$export$23ef3ef10b010856)(font);
    for(var i = 0; i < lines.length; i++)contentWidth = Math.max((0, $67e15a06bdb46d49$export$e6849d91c2a0b61f)(fontMeasureInfo, lines[i]), contentWidth);
    if (width == null) width = contentWidth;
    var outerWidth = width;
    outerHeight += paddingV;
    outerWidth += paddingH;
    return {
        lines: lines,
        height: height,
        outerWidth: outerWidth,
        outerHeight: outerHeight,
        lineHeight: lineHeight,
        calculatedLineHeight: calculatedLineHeight,
        contentWidth: contentWidth,
        contentHeight: contentHeight,
        width: width,
        isTruncated: isTruncated
    };
}
var $92d383513c7738d1$var$RichTextToken = function() {
    function RichTextToken() {}
    return RichTextToken;
}();
var $92d383513c7738d1$var$RichTextLine = function() {
    function RichTextLine(tokens) {
        this.tokens = [];
        if (tokens) this.tokens = tokens;
    }
    return RichTextLine;
}();
var $92d383513c7738d1$export$ca607d3c98caaf7e = function() {
    function RichTextContentBlock() {
        this.width = 0;
        this.height = 0;
        this.contentWidth = 0;
        this.contentHeight = 0;
        this.outerWidth = 0;
        this.outerHeight = 0;
        this.lines = [];
        this.isTruncated = false;
    }
    return RichTextContentBlock;
}();
function $92d383513c7738d1$export$15ec9472ff2d721(rawText, style, defaultOuterWidth, defaultOuterHeight, topTextAlign) {
    var contentBlock = new $92d383513c7738d1$export$ca607d3c98caaf7e();
    var text = $92d383513c7738d1$var$formatText(rawText);
    if (!text) return contentBlock;
    var stlPadding = style.padding;
    var stlPaddingH = stlPadding ? stlPadding[1] + stlPadding[3] : 0;
    var stlPaddingV = stlPadding ? stlPadding[0] + stlPadding[2] : 0;
    var topWidth = style.width;
    if (topWidth == null && defaultOuterWidth != null) topWidth = defaultOuterWidth - stlPaddingH;
    var topHeight = style.height;
    if (topHeight == null && defaultOuterHeight != null) topHeight = defaultOuterHeight - stlPaddingV;
    var overflow = style.overflow;
    var wrapInfo = (overflow === "break" || overflow === "breakAll") && topWidth != null ? {
        width: topWidth,
        accumWidth: 0,
        breakAll: overflow === "breakAll"
    } : null;
    var lastIndex = $92d383513c7738d1$var$STYLE_REG.lastIndex = 0;
    var result;
    while((result = $92d383513c7738d1$var$STYLE_REG.exec(text)) != null){
        var matchedIndex = result.index;
        if (matchedIndex > lastIndex) $92d383513c7738d1$var$pushTokens(contentBlock, text.substring(lastIndex, matchedIndex), style, wrapInfo);
        $92d383513c7738d1$var$pushTokens(contentBlock, result[2], style, wrapInfo, result[1]);
        lastIndex = $92d383513c7738d1$var$STYLE_REG.lastIndex;
    }
    if (lastIndex < text.length) $92d383513c7738d1$var$pushTokens(contentBlock, text.substring(lastIndex, text.length), style, wrapInfo);
    var pendingList = [];
    var calculatedHeight = 0;
    var calculatedWidth = 0;
    var truncate = overflow === "truncate";
    var truncateLine = style.lineOverflow === "truncate";
    var tmpTruncateOut = {};
    function finishLine(line, lineWidth, lineHeight) {
        line.width = lineWidth;
        line.lineHeight = lineHeight;
        calculatedHeight += lineHeight;
        calculatedWidth = Math.max(calculatedWidth, lineWidth);
    }
    outer: for(var i = 0; i < contentBlock.lines.length; i++){
        var line = contentBlock.lines[i];
        var lineHeight = 0;
        var lineWidth = 0;
        for(var j = 0; j < line.tokens.length; j++){
            var token = line.tokens[j];
            var tokenStyle = token.styleName && style.rich[token.styleName] || {};
            var textPadding = token.textPadding = tokenStyle.padding;
            var paddingH = textPadding ? textPadding[1] + textPadding[3] : 0;
            var font = token.font = tokenStyle.font || style.font;
            token.contentHeight = (0, $67e15a06bdb46d49$export$56204a27a2958a55)(font);
            var tokenHeight = (0, $43e0a445ed6711da$export$995e01f2f5c9d030)(tokenStyle.height, token.contentHeight);
            token.innerHeight = tokenHeight;
            textPadding && (tokenHeight += textPadding[0] + textPadding[2]);
            token.height = tokenHeight;
            token.lineHeight = (0, $43e0a445ed6711da$export$2e94551289abb95b)(tokenStyle.lineHeight, style.lineHeight, tokenHeight);
            token.align = tokenStyle && tokenStyle.align || topTextAlign;
            token.verticalAlign = tokenStyle && tokenStyle.verticalAlign || "middle";
            if (truncateLine && topHeight != null && calculatedHeight + token.lineHeight > topHeight) {
                var originalLength = contentBlock.lines.length;
                if (j > 0) {
                    line.tokens = line.tokens.slice(0, j);
                    finishLine(line, lineWidth, lineHeight);
                    contentBlock.lines = contentBlock.lines.slice(0, i + 1);
                } else contentBlock.lines = contentBlock.lines.slice(0, i);
                contentBlock.isTruncated = contentBlock.isTruncated || contentBlock.lines.length < originalLength;
                break outer;
            }
            var styleTokenWidth = tokenStyle.width;
            var tokenWidthNotSpecified = styleTokenWidth == null || styleTokenWidth === "auto";
            if (typeof styleTokenWidth === "string" && styleTokenWidth.charAt(styleTokenWidth.length - 1) === "%") {
                token.percentWidth = styleTokenWidth;
                pendingList.push(token);
                token.contentWidth = (0, $67e15a06bdb46d49$export$e6849d91c2a0b61f)((0, $67e15a06bdb46d49$export$23ef3ef10b010856)(font), token.text);
            } else {
                if (tokenWidthNotSpecified) {
                    var textBackgroundColor = tokenStyle.backgroundColor;
                    var bgImg = textBackgroundColor && textBackgroundColor.image;
                    if (bgImg) {
                        bgImg = $b3b93921504aa1e2$export$1b614f30ac2c8867(bgImg);
                        if ($b3b93921504aa1e2$export$37ca7dd901d0236d(bgImg)) token.width = Math.max(token.width, bgImg.width * tokenHeight / bgImg.height);
                    }
                }
                var remainTruncWidth = truncate && topWidth != null ? topWidth - lineWidth : null;
                if (remainTruncWidth != null && remainTruncWidth < token.width) {
                    if (!tokenWidthNotSpecified || remainTruncWidth < paddingH) {
                        token.text = "";
                        token.width = token.contentWidth = 0;
                    } else {
                        $92d383513c7738d1$var$truncateText2(tmpTruncateOut, token.text, remainTruncWidth - paddingH, font, style.ellipsis, {
                            minChar: style.truncateMinChar
                        });
                        token.text = tmpTruncateOut.text;
                        contentBlock.isTruncated = contentBlock.isTruncated || tmpTruncateOut.isTruncated;
                        token.width = token.contentWidth = (0, $67e15a06bdb46d49$export$e6849d91c2a0b61f)((0, $67e15a06bdb46d49$export$23ef3ef10b010856)(font), token.text);
                    }
                } else token.contentWidth = (0, $67e15a06bdb46d49$export$e6849d91c2a0b61f)((0, $67e15a06bdb46d49$export$23ef3ef10b010856)(font), token.text);
            }
            token.width += paddingH;
            lineWidth += token.width;
            tokenStyle && (lineHeight = Math.max(lineHeight, token.lineHeight));
        }
        finishLine(line, lineWidth, lineHeight);
    }
    contentBlock.outerWidth = contentBlock.width = (0, $43e0a445ed6711da$export$995e01f2f5c9d030)(topWidth, calculatedWidth);
    contentBlock.outerHeight = contentBlock.height = (0, $43e0a445ed6711da$export$995e01f2f5c9d030)(topHeight, calculatedHeight);
    contentBlock.contentHeight = calculatedHeight;
    contentBlock.contentWidth = calculatedWidth;
    contentBlock.outerWidth += stlPaddingH;
    contentBlock.outerHeight += stlPaddingV;
    for(var i = 0; i < pendingList.length; i++){
        var token = pendingList[i];
        var percentWidth = token.percentWidth;
        token.width = parseInt(percentWidth, 10) / 100 * contentBlock.width;
    }
    return contentBlock;
}
function $92d383513c7738d1$var$pushTokens(block, str, style, wrapInfo, styleName) {
    var isEmptyStr = str === "";
    var tokenStyle = styleName && style.rich[styleName] || {};
    var lines = block.lines;
    var font = tokenStyle.font || style.font;
    var newLine = false;
    var strLines;
    var linesWidths;
    if (wrapInfo) {
        var tokenPadding = tokenStyle.padding;
        var tokenPaddingH = tokenPadding ? tokenPadding[1] + tokenPadding[3] : 0;
        if (tokenStyle.width != null && tokenStyle.width !== "auto") {
            var outerWidth_1 = (0, $67e15a06bdb46d49$export$e8514cb5a5e2b40f)(tokenStyle.width, wrapInfo.width) + tokenPaddingH;
            if (lines.length > 0) {
                if (outerWidth_1 + wrapInfo.accumWidth > wrapInfo.width) {
                    strLines = str.split("\n");
                    newLine = true;
                }
            }
            wrapInfo.accumWidth = outerWidth_1;
        } else {
            var res = $92d383513c7738d1$var$wrapText(str, font, wrapInfo.width, wrapInfo.breakAll, wrapInfo.accumWidth);
            wrapInfo.accumWidth = res.accumWidth + tokenPaddingH;
            linesWidths = res.linesWidths;
            strLines = res.lines;
        }
    }
    if (!strLines) strLines = str.split("\n");
    var fontMeasureInfo = (0, $67e15a06bdb46d49$export$23ef3ef10b010856)(font);
    for(var i = 0; i < strLines.length; i++){
        var text = strLines[i];
        var token = new $92d383513c7738d1$var$RichTextToken();
        token.styleName = styleName;
        token.text = text;
        token.isLineHolder = !text && !isEmptyStr;
        if (typeof tokenStyle.width === "number") token.width = tokenStyle.width;
        else token.width = linesWidths ? linesWidths[i] : (0, $67e15a06bdb46d49$export$e6849d91c2a0b61f)(fontMeasureInfo, text);
        if (!i && !newLine) {
            var tokens = (lines[lines.length - 1] || (lines[0] = new $92d383513c7738d1$var$RichTextLine())).tokens;
            var tokensLen = tokens.length;
            tokensLen === 1 && tokens[0].isLineHolder ? tokens[0] = token : (text || !tokensLen || isEmptyStr) && tokens.push(token);
        } else lines.push(new $92d383513c7738d1$var$RichTextLine([
            token
        ]));
    }
}
function $92d383513c7738d1$var$isAlphabeticLetter(ch) {
    var code = ch.charCodeAt(0);
    return code >= 0x20 && code <= 0x24F || code >= 0x370 && code <= 0x10FF || code >= 0x1200 && code <= 0x13FF || code >= 0x1E00 && code <= 0x206F;
}
var $92d383513c7738d1$var$breakCharMap = (0, $43e0a445ed6711da$export$533b26079ad0b4b)(",&?/;] ".split(""), function(obj, ch) {
    obj[ch] = true;
    return obj;
}, {});
function $92d383513c7738d1$var$isWordBreakChar(ch) {
    if ($92d383513c7738d1$var$isAlphabeticLetter(ch)) {
        if ($92d383513c7738d1$var$breakCharMap[ch]) return true;
        return false;
    }
    return true;
}
function $92d383513c7738d1$var$wrapText(text, font, lineWidth, isBreakAll, lastAccumWidth) {
    var lines = [];
    var linesWidths = [];
    var line = "";
    var currentWord = "";
    var currentWordWidth = 0;
    var accumWidth = 0;
    var fontMeasureInfo = (0, $67e15a06bdb46d49$export$23ef3ef10b010856)(font);
    for(var i = 0; i < text.length; i++){
        var ch = text.charAt(i);
        if (ch === "\n") {
            if (currentWord) {
                line += currentWord;
                accumWidth += currentWordWidth;
            }
            lines.push(line);
            linesWidths.push(accumWidth);
            line = "";
            currentWord = "";
            currentWordWidth = 0;
            accumWidth = 0;
            continue;
        }
        var chWidth = (0, $67e15a06bdb46d49$export$4e92f5603b5c7bb3)(fontMeasureInfo, ch.charCodeAt(0));
        var inWord = isBreakAll ? false : !$92d383513c7738d1$var$isWordBreakChar(ch);
        if (!lines.length ? lastAccumWidth + accumWidth + chWidth > lineWidth : accumWidth + chWidth > lineWidth) {
            if (!accumWidth) {
                if (inWord) {
                    lines.push(currentWord);
                    linesWidths.push(currentWordWidth);
                    currentWord = ch;
                    currentWordWidth = chWidth;
                } else {
                    lines.push(ch);
                    linesWidths.push(chWidth);
                }
            } else if (line || currentWord) {
                if (inWord) {
                    if (!line) {
                        line = currentWord;
                        currentWord = "";
                        currentWordWidth = 0;
                        accumWidth = currentWordWidth;
                    }
                    lines.push(line);
                    linesWidths.push(accumWidth - currentWordWidth);
                    currentWord += ch;
                    currentWordWidth += chWidth;
                    line = "";
                    accumWidth = currentWordWidth;
                } else {
                    if (currentWord) {
                        line += currentWord;
                        currentWord = "";
                        currentWordWidth = 0;
                    }
                    lines.push(line);
                    linesWidths.push(accumWidth);
                    line = ch;
                    accumWidth = chWidth;
                }
            }
            continue;
        }
        accumWidth += chWidth;
        if (inWord) {
            currentWord += ch;
            currentWordWidth += chWidth;
        } else {
            if (currentWord) {
                line += currentWord;
                currentWord = "";
                currentWordWidth = 0;
            }
            line += ch;
        }
    }
    if (currentWord) line += currentWord;
    if (line) {
        lines.push(line);
        linesWidths.push(accumWidth);
    }
    if (lines.length === 1) accumWidth += lastAccumWidth;
    return {
        accumWidth: accumWidth,
        lines: lines,
        linesWidths: linesWidths
    };
}
function $92d383513c7738d1$export$9a4428591d825b14(out, overflowRect, baseX, baseY, textAlign, textVerticalAlign) {
    out.baseX = baseX;
    out.baseY = baseY;
    out.outerWidth = out.outerHeight = null;
    if (!overflowRect) return;
    var textWidth = overflowRect.width * 2;
    var textHeight = overflowRect.height * 2;
    (0, $c437f598d9c9ee16$export$2e2bcd8739ae039).set($92d383513c7738d1$var$tmpCITCTextRect, (0, $67e15a06bdb46d49$export$eb5a525ef00ef9a4)(baseX, textWidth, textAlign), (0, $67e15a06bdb46d49$export$bf7d6802d2badd9)(baseY, textHeight, textVerticalAlign), textWidth, textHeight);
    (0, $c437f598d9c9ee16$export$2e2bcd8739ae039).intersect(overflowRect, $92d383513c7738d1$var$tmpCITCTextRect, null, $92d383513c7738d1$var$tmpCITCIntersectRectOpt);
    var outIntersectRect = $92d383513c7738d1$var$tmpCITCIntersectRectOpt.outIntersectRect;
    out.outerWidth = outIntersectRect.width;
    out.outerHeight = outIntersectRect.height;
    out.baseX = (0, $67e15a06bdb46d49$export$eb5a525ef00ef9a4)(outIntersectRect.x, outIntersectRect.width, textAlign, true);
    out.baseY = (0, $67e15a06bdb46d49$export$bf7d6802d2badd9)(outIntersectRect.y, outIntersectRect.height, textVerticalAlign, true);
}
var $92d383513c7738d1$var$tmpCITCTextRect = new (0, $c437f598d9c9ee16$export$2e2bcd8739ae039)(0, 0, 0, 0);
var $92d383513c7738d1$var$tmpCITCIntersectRectOpt = {
    outIntersectRect: {},
    clamp: true
};
function $92d383513c7738d1$var$formatText(text) {
    return text != null ? text += "" : text = "";
}
function $92d383513c7738d1$export$d79289ac0f53b974(style) {
    var text = $92d383513c7738d1$var$formatText(style.text);
    var font = style.font;
    var contentWidth = (0, $67e15a06bdb46d49$export$e6849d91c2a0b61f)((0, $67e15a06bdb46d49$export$23ef3ef10b010856)(font), text);
    var contentHeight = (0, $67e15a06bdb46d49$export$56204a27a2958a55)(font);
    return $92d383513c7738d1$export$bd5d12d7bf7c9027(style, contentWidth, contentHeight, null);
}
function $92d383513c7738d1$export$bd5d12d7bf7c9027(style, contentWidth, contentHeight, forceLineWidth) {
    var rect = new (0, $c437f598d9c9ee16$export$2e2bcd8739ae039)((0, $67e15a06bdb46d49$export$eb5a525ef00ef9a4)(style.x || 0, contentWidth, style.textAlign), (0, $67e15a06bdb46d49$export$bf7d6802d2badd9)(style.y || 0, contentHeight, style.textBaseline), contentWidth, contentHeight);
    var lineWidth = forceLineWidth != null ? forceLineWidth : $92d383513c7738d1$export$c7aae0ffd99a8643(style) ? style.lineWidth : 0;
    if (lineWidth > 0) {
        rect.x -= lineWidth / 2;
        rect.y -= lineWidth / 2;
        rect.width += lineWidth;
        rect.height += lineWidth;
    }
    return rect;
}
function $92d383513c7738d1$export$c7aae0ffd99a8643(style) {
    var stroke = style.stroke;
    return stroke != null && stroke !== "none" && style.lineWidth > 0;
}








var $4773d393c538283c$var$STYLE_MAGIC_KEY = "__zr_style_" + Math.round(Math.random() * 10);
var $4773d393c538283c$export$737672163db00fe3 = {
    shadowBlur: 0,
    shadowOffsetX: 0,
    shadowOffsetY: 0,
    shadowColor: "#000",
    opacity: 1,
    blend: "source-over"
};
var $4773d393c538283c$export$9908943fb57fbe51 = {
    style: {
        shadowBlur: true,
        shadowOffsetX: true,
        shadowOffsetY: true,
        shadowColor: true,
        opacity: true
    }
};
$4773d393c538283c$export$737672163db00fe3[$4773d393c538283c$var$STYLE_MAGIC_KEY] = true;
var $4773d393c538283c$var$PRIMARY_STATES_KEYS = [
    "z",
    "z2",
    "invisible"
];
var $4773d393c538283c$var$PRIMARY_STATES_KEYS_IN_HOVER_LAYER = [
    "invisible"
];
var $4773d393c538283c$var$Displayable = function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(Displayable, _super);
    function Displayable(props) {
        return _super.call(this, props) || this;
    }
    Displayable.prototype._init = function(props) {
        var keysArr = (0, $43e0a445ed6711da$export$ed97f33186d4b816)(props);
        for(var i = 0; i < keysArr.length; i++){
            var key = keysArr[i];
            if (key === "style") this.useStyle(props[key]);
            else _super.prototype.attrKV.call(this, key, props[key]);
        }
        if (!this.style) this.useStyle({});
    };
    Displayable.prototype.beforeBrush = function(param) {};
    Displayable.prototype.afterBrush = function() {};
    Displayable.prototype.innerBeforeBrush = function() {};
    Displayable.prototype.innerAfterBrush = function() {};
    Displayable.prototype.shouldBePainted = function(viewWidth, viewHeight, considerClipPath, considerAncestors) {
        var m = this.transform;
        if (this.ignore || this.invisible || this.style.opacity === 0 || this.culling && $4773d393c538283c$var$isDisplayableCulled(this, viewWidth, viewHeight) || m && !m[0] && !m[3]) return false;
        if (considerClipPath && this.__clipPaths && this.__clipPaths.length) for(var i = 0; i < this.__clipPaths.length; ++i){
            if (this.__clipPaths[i].isZeroArea()) return false;
        }
        if (considerAncestors && this.parent) {
            var parent_1 = this.parent;
            while(parent_1){
                if (parent_1.ignore) return false;
                parent_1 = parent_1.parent;
            }
        }
        return true;
    };
    Displayable.prototype.contain = function(x, y) {
        return this.rectContain(x, y);
    };
    Displayable.prototype.traverse = function(cb, context) {
        cb.call(context, this);
    };
    Displayable.prototype.rectContain = function(x, y) {
        var coord = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        return rect.contain(coord[0], coord[1]);
    };
    Displayable.prototype.getPaintRect = function() {
        var rect = this._paintRect;
        if (!this._paintRect || this.__dirty) {
            var transform = this.transform;
            var elRect = this.getBoundingRect();
            var style = this.style;
            var shadowSize = style.shadowBlur || 0;
            var shadowOffsetX = style.shadowOffsetX || 0;
            var shadowOffsetY = style.shadowOffsetY || 0;
            rect = this._paintRect || (this._paintRect = new (0, $c437f598d9c9ee16$export$2e2bcd8739ae039)(0, 0, 0, 0));
            if (transform) (0, $c437f598d9c9ee16$export$2e2bcd8739ae039).applyTransform(rect, elRect, transform);
            else rect.copy(elRect);
            if (shadowSize || shadowOffsetX || shadowOffsetY) {
                rect.width += shadowSize * 2 + Math.abs(shadowOffsetX);
                rect.height += shadowSize * 2 + Math.abs(shadowOffsetY);
                rect.x = Math.min(rect.x, rect.x + shadowOffsetX - shadowSize);
                rect.y = Math.min(rect.y, rect.y + shadowOffsetY - shadowSize);
            }
            var tolerance = this.dirtyRectTolerance;
            if (!rect.isZero()) {
                rect.x = Math.floor(rect.x - tolerance);
                rect.y = Math.floor(rect.y - tolerance);
                rect.width = Math.ceil(rect.width + 1 + tolerance * 2);
                rect.height = Math.ceil(rect.height + 1 + tolerance * 2);
            }
        }
        return rect;
    };
    Displayable.prototype.setPrevPaintRect = function(paintRect) {
        if (paintRect) {
            this._prevPaintRect = this._prevPaintRect || new (0, $c437f598d9c9ee16$export$2e2bcd8739ae039)(0, 0, 0, 0);
            this._prevPaintRect.copy(paintRect);
        } else this._prevPaintRect = null;
    };
    Displayable.prototype.getPrevPaintRect = function() {
        return this._prevPaintRect;
    };
    Displayable.prototype.animateStyle = function(loop) {
        return this.animate("style", loop);
    };
    Displayable.prototype.updateDuringAnimation = function(targetKey) {
        if (targetKey === "style") this.dirtyStyle();
        else this.markRedraw();
    };
    Displayable.prototype.attrKV = function(key, value) {
        if (key !== "style") _super.prototype.attrKV.call(this, key, value);
        else if (!this.style) this.useStyle(value);
        else this.setStyle(value);
    };
    Displayable.prototype.setStyle = function(keyOrObj, value) {
        if (typeof keyOrObj === "string") this.style[keyOrObj] = value;
        else (0, $43e0a445ed6711da$export$8b58be045bf06082)(this.style, keyOrObj);
        this.dirtyStyle();
        return this;
    };
    Displayable.prototype.dirtyStyle = function(notRedraw) {
        if (!notRedraw) this.markRedraw();
        this.__dirty |= (0, $24fa4a8d26d34a24$export$ada8b2beb3d76671);
        if (this._rect) this._rect = null;
    };
    Displayable.prototype.dirty = function() {
        this.dirtyStyle();
    };
    Displayable.prototype.styleChanged = function() {
        return !!(this.__dirty & (0, $24fa4a8d26d34a24$export$ada8b2beb3d76671));
    };
    Displayable.prototype.styleUpdated = function() {
        this.__dirty &= ~(0, $24fa4a8d26d34a24$export$ada8b2beb3d76671);
    };
    Displayable.prototype.createStyle = function(obj) {
        return (0, $43e0a445ed6711da$export$79c7e160a7743efd)($4773d393c538283c$export$737672163db00fe3, obj);
    };
    Displayable.prototype.useStyle = function(obj) {
        if (!obj[$4773d393c538283c$var$STYLE_MAGIC_KEY]) obj = this.createStyle(obj);
        this.style = obj;
        this.dirtyStyle();
    };
    Displayable.prototype._useHoverStyle = function(obj) {
        this.__hoverStyle = obj;
    };
    Displayable.prototype.isStyleObject = function(obj) {
        return obj[$4773d393c538283c$var$STYLE_MAGIC_KEY];
    };
    Displayable.prototype._innerSaveToNormal = function(toState) {
        _super.prototype._innerSaveToNormal.call(this, toState);
        var normalState = this._normalState;
        if (toState.style && !normalState.style) normalState.style = this._mergeStyle(this.createStyle(), this.style);
        this._savePrimaryToNormal(toState, normalState, $4773d393c538283c$var$PRIMARY_STATES_KEYS);
    };
    Displayable.prototype._applyStateObj = function(stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
        _super.prototype._applyStateObj.call(this, stateName, state, normalState, keepCurrentStates, transition, animationCfg);
        var needsRestoreToNormal = !(state && keepCurrentStates);
        var inHoverOnlyStyleChange = this.__inHover === (0, $0b8373c26fe287ed$export$f5347ae640a7f0d0);
        var targetStyle;
        if (state && state.style) {
            if (transition) {
                if (keepCurrentStates) targetStyle = state.style;
                else {
                    targetStyle = this._mergeStyle(this.createStyle(), normalState.style);
                    this._mergeStyle(targetStyle, state.style);
                }
            } else {
                targetStyle = this._mergeStyle(this.createStyle(), keepCurrentStates ? this.style : normalState.style);
                this._mergeStyle(targetStyle, state.style);
            }
        } else if (needsRestoreToNormal) targetStyle = normalState.style;
        if (targetStyle) {
            if (transition) {
                var sourceStyle = this.style;
                this.style = this.createStyle(needsRestoreToNormal ? {} : sourceStyle);
                if (needsRestoreToNormal) {
                    var changedKeys = (0, $43e0a445ed6711da$export$ed97f33186d4b816)(sourceStyle);
                    for(var i = 0; i < changedKeys.length; i++){
                        var key = changedKeys[i];
                        if (key in targetStyle) {
                            targetStyle[key] = targetStyle[key];
                            this.style[key] = sourceStyle[key];
                        }
                    }
                }
                var targetKeys = (0, $43e0a445ed6711da$export$ed97f33186d4b816)(targetStyle);
                for(var i = 0; i < targetKeys.length; i++){
                    var key = targetKeys[i];
                    this.style[key] = this.style[key];
                }
                this._transitionState(stateName, {
                    style: targetStyle
                }, animationCfg, this.getAnimationStyleProps());
            } else if (inHoverOnlyStyleChange) this._useHoverStyle(targetStyle);
            else this.useStyle(targetStyle);
        }
        if (!inHoverOnlyStyleChange) {
            var statesKeys = this.__inHover ? $4773d393c538283c$var$PRIMARY_STATES_KEYS_IN_HOVER_LAYER : $4773d393c538283c$var$PRIMARY_STATES_KEYS;
            for(var i = 0; i < statesKeys.length; i++){
                var key = statesKeys[i];
                if (state && state[key] != null) this[key] = state[key];
                else if (needsRestoreToNormal) {
                    if (normalState[key] != null) this[key] = normalState[key];
                }
            }
        }
    };
    Displayable.prototype._mergeStates = function(states) {
        var mergedState = _super.prototype._mergeStates.call(this, states);
        var mergedStyle;
        for(var i = 0; i < states.length; i++){
            var state = states[i];
            if (state.style) {
                mergedStyle = mergedStyle || {};
                this._mergeStyle(mergedStyle, state.style);
            }
        }
        if (mergedStyle) mergedState.style = mergedStyle;
        return mergedState;
    };
    Displayable.prototype._mergeStyle = function(targetStyle, sourceStyle) {
        (0, $43e0a445ed6711da$export$8b58be045bf06082)(targetStyle, sourceStyle);
        return targetStyle;
    };
    Displayable.prototype.getAnimationStyleProps = function() {
        return $4773d393c538283c$export$9908943fb57fbe51;
    };
    Displayable.initDefaultProps = function() {
        var dispProto = Displayable.prototype;
        dispProto.type = "displayable";
        dispProto.invisible = false;
        dispProto.z = 0;
        dispProto.z2 = 0;
        dispProto.zlevel = 0;
        dispProto.culling = false;
        dispProto.cursor = "pointer";
        dispProto.rectHover = false;
        dispProto.incremental = 0;
        dispProto._rect = null;
        dispProto.dirtyRectTolerance = 0;
        dispProto.__dirty = (0, $24fa4a8d26d34a24$export$a7b6db622c6c7dbd) | (0, $24fa4a8d26d34a24$export$ada8b2beb3d76671);
    }();
    return Displayable;
}((0, $0b8373c26fe287ed$export$2e2bcd8739ae039));
var $4773d393c538283c$var$tmpRect = new (0, $c437f598d9c9ee16$export$2e2bcd8739ae039)(0, 0, 0, 0);
var $4773d393c538283c$var$viewRect = new (0, $c437f598d9c9ee16$export$2e2bcd8739ae039)(0, 0, 0, 0);
function $4773d393c538283c$var$isDisplayableCulled(el, width, height) {
    $4773d393c538283c$var$tmpRect.copy(el.getBoundingRect());
    if (el.transform) $4773d393c538283c$var$tmpRect.applyTransform(el.transform);
    $4773d393c538283c$var$viewRect.width = width;
    $4773d393c538283c$var$viewRect.height = height;
    return !$4773d393c538283c$var$tmpRect.intersect($4773d393c538283c$var$viewRect);
}
var $4773d393c538283c$export$2e2bcd8739ae039 = $4773d393c538283c$var$Displayable;










var $183212b76d2e2f21$var$mathMin = Math.min;
var $183212b76d2e2f21$var$mathMax = Math.max;
var $183212b76d2e2f21$var$mathSin = Math.sin;
var $183212b76d2e2f21$var$mathCos = Math.cos;
var $183212b76d2e2f21$var$PI2 = Math.PI * 2;
var $183212b76d2e2f21$var$start = $ee491d8f32bd01ff$export$185802fd694ee1f5();
var $183212b76d2e2f21$var$end = $ee491d8f32bd01ff$export$185802fd694ee1f5();
var $183212b76d2e2f21$var$extremity = $ee491d8f32bd01ff$export$185802fd694ee1f5();
function $183212b76d2e2f21$export$188c3cd07b4129dd(points, min, max) {
    if (points.length === 0) return;
    var p = points[0];
    var left = p[0];
    var right = p[0];
    var top = p[1];
    var bottom = p[1];
    for(var i = 1; i < points.length; i++){
        p = points[i];
        left = $183212b76d2e2f21$var$mathMin(left, p[0]);
        right = $183212b76d2e2f21$var$mathMax(right, p[0]);
        top = $183212b76d2e2f21$var$mathMin(top, p[1]);
        bottom = $183212b76d2e2f21$var$mathMax(bottom, p[1]);
    }
    min[0] = left;
    min[1] = top;
    max[0] = right;
    max[1] = bottom;
}
function $183212b76d2e2f21$export$d2b1491e4450bf2c(x0, y0, x1, y1, min, max) {
    min[0] = $183212b76d2e2f21$var$mathMin(x0, x1);
    min[1] = $183212b76d2e2f21$var$mathMin(y0, y1);
    max[0] = $183212b76d2e2f21$var$mathMax(x0, x1);
    max[1] = $183212b76d2e2f21$var$mathMax(y0, y1);
}
var $183212b76d2e2f21$var$xDim = [];
var $183212b76d2e2f21$var$yDim = [];
function $183212b76d2e2f21$export$c1bc6be456bb6609(x0, y0, x1, y1, x2, y2, x3, y3, min, max) {
    var cubicExtrema = $3dec70ca5f6b6e8f$export$df1a172f100d0457;
    var cubicAt = $3dec70ca5f6b6e8f$export$547c21de482bbcb2;
    var n = cubicExtrema(x0, x1, x2, x3, $183212b76d2e2f21$var$xDim);
    min[0] = Infinity;
    min[1] = Infinity;
    max[0] = -Infinity;
    max[1] = -Infinity;
    for(var i = 0; i < n; i++){
        var x = cubicAt(x0, x1, x2, x3, $183212b76d2e2f21$var$xDim[i]);
        min[0] = $183212b76d2e2f21$var$mathMin(x, min[0]);
        max[0] = $183212b76d2e2f21$var$mathMax(x, max[0]);
    }
    n = cubicExtrema(y0, y1, y2, y3, $183212b76d2e2f21$var$yDim);
    for(var i = 0; i < n; i++){
        var y = cubicAt(y0, y1, y2, y3, $183212b76d2e2f21$var$yDim[i]);
        min[1] = $183212b76d2e2f21$var$mathMin(y, min[1]);
        max[1] = $183212b76d2e2f21$var$mathMax(y, max[1]);
    }
    min[0] = $183212b76d2e2f21$var$mathMin(x0, min[0]);
    max[0] = $183212b76d2e2f21$var$mathMax(x0, max[0]);
    min[0] = $183212b76d2e2f21$var$mathMin(x3, min[0]);
    max[0] = $183212b76d2e2f21$var$mathMax(x3, max[0]);
    min[1] = $183212b76d2e2f21$var$mathMin(y0, min[1]);
    max[1] = $183212b76d2e2f21$var$mathMax(y0, max[1]);
    min[1] = $183212b76d2e2f21$var$mathMin(y3, min[1]);
    max[1] = $183212b76d2e2f21$var$mathMax(y3, max[1]);
}
function $183212b76d2e2f21$export$16fbe795323a1f4c(x0, y0, x1, y1, x2, y2, min, max) {
    var quadraticExtremum = $3dec70ca5f6b6e8f$export$752e1f8c6e7f7e11;
    var quadraticAt = $3dec70ca5f6b6e8f$export$af17094a950f5073;
    var tx = $183212b76d2e2f21$var$mathMax($183212b76d2e2f21$var$mathMin(quadraticExtremum(x0, x1, x2), 1), 0);
    var ty = $183212b76d2e2f21$var$mathMax($183212b76d2e2f21$var$mathMin(quadraticExtremum(y0, y1, y2), 1), 0);
    var x = quadraticAt(x0, x1, x2, tx);
    var y = quadraticAt(y0, y1, y2, ty);
    min[0] = $183212b76d2e2f21$var$mathMin(x0, x2, x);
    min[1] = $183212b76d2e2f21$var$mathMin(y0, y2, y);
    max[0] = $183212b76d2e2f21$var$mathMax(x0, x2, x);
    max[1] = $183212b76d2e2f21$var$mathMax(y0, y2, y);
}
function $183212b76d2e2f21$export$161c8bb0e1d9ef49(x, y, rx, ry, startAngle, endAngle, anticlockwise, min, max) {
    var vec2Min = $ee491d8f32bd01ff$export$96ec731ed4dcb222;
    var vec2Max = $ee491d8f32bd01ff$export$8960430cfd85939f;
    var diff = Math.abs(startAngle - endAngle);
    if (diff % $183212b76d2e2f21$var$PI2 < 1e-4 && diff > 1e-4) {
        min[0] = x - rx;
        min[1] = y - ry;
        max[0] = x + rx;
        max[1] = y + ry;
        return;
    }
    $183212b76d2e2f21$var$start[0] = $183212b76d2e2f21$var$mathCos(startAngle) * rx + x;
    $183212b76d2e2f21$var$start[1] = $183212b76d2e2f21$var$mathSin(startAngle) * ry + y;
    $183212b76d2e2f21$var$end[0] = $183212b76d2e2f21$var$mathCos(endAngle) * rx + x;
    $183212b76d2e2f21$var$end[1] = $183212b76d2e2f21$var$mathSin(endAngle) * ry + y;
    vec2Min(min, $183212b76d2e2f21$var$start, $183212b76d2e2f21$var$end);
    vec2Max(max, $183212b76d2e2f21$var$start, $183212b76d2e2f21$var$end);
    startAngle = startAngle % $183212b76d2e2f21$var$PI2;
    if (startAngle < 0) startAngle = startAngle + $183212b76d2e2f21$var$PI2;
    endAngle = endAngle % $183212b76d2e2f21$var$PI2;
    if (endAngle < 0) endAngle = endAngle + $183212b76d2e2f21$var$PI2;
    if (startAngle > endAngle && !anticlockwise) endAngle += $183212b76d2e2f21$var$PI2;
    else if (startAngle < endAngle && anticlockwise) startAngle += $183212b76d2e2f21$var$PI2;
    if (anticlockwise) {
        var tmp = endAngle;
        endAngle = startAngle;
        startAngle = tmp;
    }
    for(var angle = 0; angle < endAngle; angle += Math.PI / 2)if (angle > startAngle) {
        $183212b76d2e2f21$var$extremity[0] = $183212b76d2e2f21$var$mathCos(angle) * rx + x;
        $183212b76d2e2f21$var$extremity[1] = $183212b76d2e2f21$var$mathSin(angle) * ry + y;
        vec2Min(min, $183212b76d2e2f21$var$extremity, min);
        vec2Max(max, $183212b76d2e2f21$var$extremity, max);
    }
}



var $e2a16933ef78a053$var$CMD = {
    M: 1,
    L: 2,
    C: 3,
    Q: 4,
    A: 5,
    Z: 6,
    R: 7
};
var $e2a16933ef78a053$var$tmpOutX = [];
var $e2a16933ef78a053$var$tmpOutY = [];
var $e2a16933ef78a053$var$min = [];
var $e2a16933ef78a053$var$max = [];
var $e2a16933ef78a053$var$min2 = [];
var $e2a16933ef78a053$var$max2 = [];
var $e2a16933ef78a053$var$mathMin = Math.min;
var $e2a16933ef78a053$var$mathMax = Math.max;
var $e2a16933ef78a053$var$mathCos = Math.cos;
var $e2a16933ef78a053$var$mathSin = Math.sin;
var $e2a16933ef78a053$var$mathAbs = Math.abs;
var $e2a16933ef78a053$var$PI = Math.PI;
var $e2a16933ef78a053$var$PI2 = $e2a16933ef78a053$var$PI * 2;
var $e2a16933ef78a053$var$hasTypedArray = typeof Float32Array !== "undefined";
var $e2a16933ef78a053$var$tmpAngles = [];
function $e2a16933ef78a053$var$modPI2(radian) {
    var n = Math.round(radian / $e2a16933ef78a053$var$PI * 1e8) / 1e8;
    return n % 2 * $e2a16933ef78a053$var$PI;
}
function $e2a16933ef78a053$export$bc668021e937022a(angles, anticlockwise) {
    var newStartAngle = $e2a16933ef78a053$var$modPI2(angles[0]);
    if (newStartAngle < 0) newStartAngle += $e2a16933ef78a053$var$PI2;
    var delta = newStartAngle - angles[0];
    var newEndAngle = angles[1];
    newEndAngle += delta;
    if (!anticlockwise && newEndAngle - newStartAngle >= $e2a16933ef78a053$var$PI2) newEndAngle = newStartAngle + $e2a16933ef78a053$var$PI2;
    else if (anticlockwise && newStartAngle - newEndAngle >= $e2a16933ef78a053$var$PI2) newEndAngle = newStartAngle - $e2a16933ef78a053$var$PI2;
    else if (!anticlockwise && newStartAngle > newEndAngle) newEndAngle = newStartAngle + ($e2a16933ef78a053$var$PI2 - $e2a16933ef78a053$var$modPI2(newStartAngle - newEndAngle));
    else if (anticlockwise && newStartAngle < newEndAngle) newEndAngle = newStartAngle - ($e2a16933ef78a053$var$PI2 - $e2a16933ef78a053$var$modPI2(newEndAngle - newStartAngle));
    angles[0] = newStartAngle;
    angles[1] = newEndAngle;
}
var $e2a16933ef78a053$var$PathProxy = function() {
    function PathProxy(notSaveData) {
        this.dpr = 1;
        this._xi = 0;
        this._yi = 0;
        this._x0 = 0;
        this._y0 = 0;
        this._len = 0;
        if (notSaveData) this._saveData = false;
        if (this._saveData) this.data = [];
    }
    PathProxy.prototype.increaseVersion = function() {
        this._version++;
    };
    PathProxy.prototype.getVersion = function() {
        return this._version;
    };
    PathProxy.prototype.setScale = function(sx, sy, segmentIgnoreThreshold) {
        segmentIgnoreThreshold = segmentIgnoreThreshold || 0;
        if (segmentIgnoreThreshold > 0) {
            this._ux = $e2a16933ef78a053$var$mathAbs(segmentIgnoreThreshold / (0, $b4769615a730dcfc$export$508f096bfcdaac40) / sx) || 0;
            this._uy = $e2a16933ef78a053$var$mathAbs(segmentIgnoreThreshold / (0, $b4769615a730dcfc$export$508f096bfcdaac40) / sy) || 0;
        }
    };
    PathProxy.prototype.setDPR = function(dpr) {
        this.dpr = dpr;
    };
    PathProxy.prototype.setContext = function(ctx) {
        this._ctx = ctx;
    };
    PathProxy.prototype.getContext = function() {
        return this._ctx;
    };
    PathProxy.prototype.beginPath = function() {
        this._ctx && this._ctx.beginPath();
        this.reset();
        return this;
    };
    PathProxy.prototype.reset = function() {
        if (this._saveData) this._len = 0;
        if (this._pathSegLen) {
            this._pathSegLen = null;
            this._pathLen = 0;
        }
        this._version++;
    };
    PathProxy.prototype.moveTo = function(x, y) {
        this._drawPendingPt();
        this.addData($e2a16933ef78a053$var$CMD.M, x, y);
        this._ctx && this._ctx.moveTo(x, y);
        this._x0 = x;
        this._y0 = y;
        this._xi = x;
        this._yi = y;
        return this;
    };
    PathProxy.prototype.lineTo = function(x, y) {
        var dx = $e2a16933ef78a053$var$mathAbs(x - this._xi);
        var dy = $e2a16933ef78a053$var$mathAbs(y - this._yi);
        var exceedUnit = dx > this._ux || dy > this._uy;
        this.addData($e2a16933ef78a053$var$CMD.L, x, y);
        if (this._ctx && exceedUnit) this._ctx.lineTo(x, y);
        if (exceedUnit) {
            this._xi = x;
            this._yi = y;
            this._pendingPtDist = 0;
        } else {
            var d2 = dx * dx + dy * dy;
            if (d2 > this._pendingPtDist) {
                this._pendingPtX = x;
                this._pendingPtY = y;
                this._pendingPtDist = d2;
            }
        }
        return this;
    };
    PathProxy.prototype.bezierCurveTo = function(x1, y1, x2, y2, x3, y3) {
        this._drawPendingPt();
        this.addData($e2a16933ef78a053$var$CMD.C, x1, y1, x2, y2, x3, y3);
        if (this._ctx) this._ctx.bezierCurveTo(x1, y1, x2, y2, x3, y3);
        this._xi = x3;
        this._yi = y3;
        return this;
    };
    PathProxy.prototype.quadraticCurveTo = function(x1, y1, x2, y2) {
        this._drawPendingPt();
        this.addData($e2a16933ef78a053$var$CMD.Q, x1, y1, x2, y2);
        if (this._ctx) this._ctx.quadraticCurveTo(x1, y1, x2, y2);
        this._xi = x2;
        this._yi = y2;
        return this;
    };
    PathProxy.prototype.arc = function(cx, cy, r, startAngle, endAngle, anticlockwise) {
        this._drawPendingPt();
        $e2a16933ef78a053$var$tmpAngles[0] = startAngle;
        $e2a16933ef78a053$var$tmpAngles[1] = endAngle;
        $e2a16933ef78a053$export$bc668021e937022a($e2a16933ef78a053$var$tmpAngles, anticlockwise);
        startAngle = $e2a16933ef78a053$var$tmpAngles[0];
        endAngle = $e2a16933ef78a053$var$tmpAngles[1];
        var delta = endAngle - startAngle;
        this.addData($e2a16933ef78a053$var$CMD.A, cx, cy, r, r, startAngle, delta, 0, anticlockwise ? 0 : 1);
        this._ctx && this._ctx.arc(cx, cy, r, startAngle, endAngle, anticlockwise);
        this._xi = $e2a16933ef78a053$var$mathCos(endAngle) * r + cx;
        this._yi = $e2a16933ef78a053$var$mathSin(endAngle) * r + cy;
        return this;
    };
    PathProxy.prototype.arcTo = function(x1, y1, x2, y2, radius) {
        this._drawPendingPt();
        if (this._ctx) this._ctx.arcTo(x1, y1, x2, y2, radius);
        return this;
    };
    PathProxy.prototype.rect = function(x, y, w, h) {
        this._drawPendingPt();
        this._ctx && this._ctx.rect(x, y, w, h);
        this.addData($e2a16933ef78a053$var$CMD.R, x, y, w, h);
        return this;
    };
    PathProxy.prototype.closePath = function() {
        this._drawPendingPt();
        this.addData($e2a16933ef78a053$var$CMD.Z);
        var ctx = this._ctx;
        var x0 = this._x0;
        var y0 = this._y0;
        if (ctx) ctx.closePath();
        this._xi = x0;
        this._yi = y0;
        return this;
    };
    PathProxy.prototype.fill = function(ctx) {
        ctx && ctx.fill();
        this.toStatic();
    };
    PathProxy.prototype.stroke = function(ctx) {
        ctx && ctx.stroke();
        this.toStatic();
    };
    PathProxy.prototype.len = function() {
        return this._len;
    };
    PathProxy.prototype.setData = function(data) {
        if (!this._saveData) return;
        var len = data.length;
        if (!(this.data && this.data.length === len) && $e2a16933ef78a053$var$hasTypedArray) this.data = new Float32Array(len);
        for(var i = 0; i < len; i++)this.data[i] = data[i];
        this._len = len;
    };
    PathProxy.prototype.appendPath = function(path) {
        if (!this._saveData) return;
        if (!(path instanceof Array)) path = [
            path
        ];
        var len = path.length;
        var appendSize = 0;
        var offset = this._len;
        for(var i = 0; i < len; i++)appendSize += path[i].len();
        var oldData = this.data;
        if ($e2a16933ef78a053$var$hasTypedArray && (oldData instanceof Float32Array || !oldData)) {
            this.data = new Float32Array(offset + appendSize);
            if (offset > 0 && oldData) for(var k = 0; k < offset; k++)this.data[k] = oldData[k];
        }
        for(var i = 0; i < len; i++){
            var appendPathData = path[i].data;
            for(var k = 0; k < appendPathData.length; k++)this.data[offset++] = appendPathData[k];
        }
        this._len = offset;
    };
    PathProxy.prototype.addData = function(cmd, a, b, c, d, e, f, g, h) {
        if (!this._saveData) return;
        var data = this.data;
        if (this._len + arguments.length > data.length) {
            this._expandData();
            data = this.data;
        }
        for(var i = 0; i < arguments.length; i++)data[this._len++] = arguments[i];
    };
    PathProxy.prototype._drawPendingPt = function() {
        if (this._pendingPtDist > 0) {
            this._ctx && this._ctx.lineTo(this._pendingPtX, this._pendingPtY);
            this._pendingPtDist = 0;
        }
    };
    PathProxy.prototype._expandData = function() {
        if (!(this.data instanceof Array)) {
            var newData = [];
            for(var i = 0; i < this._len; i++)newData[i] = this.data[i];
            this.data = newData;
        }
    };
    PathProxy.prototype.toStatic = function() {
        if (!this._saveData) return;
        this._drawPendingPt();
        var data = this.data;
        if (data instanceof Array) {
            data.length = this._len;
            if ($e2a16933ef78a053$var$hasTypedArray && this._len > 11) this.data = new Float32Array(data);
        }
    };
    PathProxy.prototype.getBoundingRect = function() {
        $e2a16933ef78a053$var$min[0] = $e2a16933ef78a053$var$min[1] = $e2a16933ef78a053$var$min2[0] = $e2a16933ef78a053$var$min2[1] = Number.MAX_VALUE;
        $e2a16933ef78a053$var$max[0] = $e2a16933ef78a053$var$max[1] = $e2a16933ef78a053$var$max2[0] = $e2a16933ef78a053$var$max2[1] = -Number.MAX_VALUE;
        var data = this.data;
        var xi = 0;
        var yi = 0;
        var x0 = 0;
        var y0 = 0;
        var i;
        for(i = 0; i < this._len;){
            var cmd = data[i++];
            var isFirst = i === 1;
            if (isFirst) {
                xi = data[i];
                yi = data[i + 1];
                x0 = xi;
                y0 = yi;
            }
            switch(cmd){
                case $e2a16933ef78a053$var$CMD.M:
                    xi = x0 = data[i++];
                    yi = y0 = data[i++];
                    $e2a16933ef78a053$var$min2[0] = x0;
                    $e2a16933ef78a053$var$min2[1] = y0;
                    $e2a16933ef78a053$var$max2[0] = x0;
                    $e2a16933ef78a053$var$max2[1] = y0;
                    break;
                case $e2a16933ef78a053$var$CMD.L:
                    (0, $183212b76d2e2f21$export$d2b1491e4450bf2c)(xi, yi, data[i], data[i + 1], $e2a16933ef78a053$var$min2, $e2a16933ef78a053$var$max2);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $e2a16933ef78a053$var$CMD.C:
                    (0, $183212b76d2e2f21$export$c1bc6be456bb6609)(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], $e2a16933ef78a053$var$min2, $e2a16933ef78a053$var$max2);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $e2a16933ef78a053$var$CMD.Q:
                    (0, $183212b76d2e2f21$export$16fbe795323a1f4c)(xi, yi, data[i++], data[i++], data[i], data[i + 1], $e2a16933ef78a053$var$min2, $e2a16933ef78a053$var$max2);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $e2a16933ef78a053$var$CMD.A:
                    var cx = data[i++];
                    var cy = data[i++];
                    var rx = data[i++];
                    var ry = data[i++];
                    var startAngle = data[i++];
                    var endAngle = data[i++] + startAngle;
                    i += 1;
                    var anticlockwise = !data[i++];
                    if (isFirst) {
                        x0 = $e2a16933ef78a053$var$mathCos(startAngle) * rx + cx;
                        y0 = $e2a16933ef78a053$var$mathSin(startAngle) * ry + cy;
                    }
                    (0, $183212b76d2e2f21$export$161c8bb0e1d9ef49)(cx, cy, rx, ry, startAngle, endAngle, anticlockwise, $e2a16933ef78a053$var$min2, $e2a16933ef78a053$var$max2);
                    xi = $e2a16933ef78a053$var$mathCos(endAngle) * rx + cx;
                    yi = $e2a16933ef78a053$var$mathSin(endAngle) * ry + cy;
                    break;
                case $e2a16933ef78a053$var$CMD.R:
                    x0 = xi = data[i++];
                    y0 = yi = data[i++];
                    var width = data[i++];
                    var height = data[i++];
                    (0, $183212b76d2e2f21$export$d2b1491e4450bf2c)(x0, y0, x0 + width, y0 + height, $e2a16933ef78a053$var$min2, $e2a16933ef78a053$var$max2);
                    break;
                case $e2a16933ef78a053$var$CMD.Z:
                    xi = x0;
                    yi = y0;
                    break;
            }
            $ee491d8f32bd01ff$export$96ec731ed4dcb222($e2a16933ef78a053$var$min, $e2a16933ef78a053$var$min, $e2a16933ef78a053$var$min2);
            $ee491d8f32bd01ff$export$8960430cfd85939f($e2a16933ef78a053$var$max, $e2a16933ef78a053$var$max, $e2a16933ef78a053$var$max2);
        }
        if (i === 0) $e2a16933ef78a053$var$min[0] = $e2a16933ef78a053$var$min[1] = $e2a16933ef78a053$var$max[0] = $e2a16933ef78a053$var$max[1] = 0;
        return new (0, $c437f598d9c9ee16$export$2e2bcd8739ae039)($e2a16933ef78a053$var$min[0], $e2a16933ef78a053$var$min[1], $e2a16933ef78a053$var$max[0] - $e2a16933ef78a053$var$min[0], $e2a16933ef78a053$var$max[1] - $e2a16933ef78a053$var$min[1]);
    };
    PathProxy.prototype._calculateLength = function() {
        var data = this.data;
        var len = this._len;
        var ux = this._ux;
        var uy = this._uy;
        var xi = 0;
        var yi = 0;
        var x0 = 0;
        var y0 = 0;
        if (!this._pathSegLen) this._pathSegLen = [];
        var pathSegLen = this._pathSegLen;
        var pathTotalLen = 0;
        var segCount = 0;
        for(var i = 0; i < len;){
            var cmd = data[i++];
            var isFirst = i === 1;
            if (isFirst) {
                xi = data[i];
                yi = data[i + 1];
                x0 = xi;
                y0 = yi;
            }
            var l = -1;
            switch(cmd){
                case $e2a16933ef78a053$var$CMD.M:
                    xi = x0 = data[i++];
                    yi = y0 = data[i++];
                    break;
                case $e2a16933ef78a053$var$CMD.L:
                    var x2 = data[i++];
                    var y2 = data[i++];
                    var dx = x2 - xi;
                    var dy = y2 - yi;
                    if ($e2a16933ef78a053$var$mathAbs(dx) > ux || $e2a16933ef78a053$var$mathAbs(dy) > uy || i === len - 1) {
                        l = Math.sqrt(dx * dx + dy * dy);
                        xi = x2;
                        yi = y2;
                    }
                    break;
                case $e2a16933ef78a053$var$CMD.C:
                    var x1 = data[i++];
                    var y1 = data[i++];
                    var x2 = data[i++];
                    var y2 = data[i++];
                    var x3 = data[i++];
                    var y3 = data[i++];
                    l = (0, $3dec70ca5f6b6e8f$export$af1875d576f60d7c)(xi, yi, x1, y1, x2, y2, x3, y3, 10);
                    xi = x3;
                    yi = y3;
                    break;
                case $e2a16933ef78a053$var$CMD.Q:
                    var x1 = data[i++];
                    var y1 = data[i++];
                    var x2 = data[i++];
                    var y2 = data[i++];
                    l = (0, $3dec70ca5f6b6e8f$export$8a68adee46f3cf55)(xi, yi, x1, y1, x2, y2, 10);
                    xi = x2;
                    yi = y2;
                    break;
                case $e2a16933ef78a053$var$CMD.A:
                    var cx = data[i++];
                    var cy = data[i++];
                    var rx = data[i++];
                    var ry = data[i++];
                    var startAngle = data[i++];
                    var delta = data[i++];
                    var endAngle = delta + startAngle;
                    i += 1;
                    if (isFirst) {
                        x0 = $e2a16933ef78a053$var$mathCos(startAngle) * rx + cx;
                        y0 = $e2a16933ef78a053$var$mathSin(startAngle) * ry + cy;
                    }
                    l = $e2a16933ef78a053$var$mathMax(rx, ry) * $e2a16933ef78a053$var$mathMin($e2a16933ef78a053$var$PI2, Math.abs(delta));
                    xi = $e2a16933ef78a053$var$mathCos(endAngle) * rx + cx;
                    yi = $e2a16933ef78a053$var$mathSin(endAngle) * ry + cy;
                    break;
                case $e2a16933ef78a053$var$CMD.R:
                    x0 = xi = data[i++];
                    y0 = yi = data[i++];
                    var width = data[i++];
                    var height = data[i++];
                    l = width * 2 + height * 2;
                    break;
                case $e2a16933ef78a053$var$CMD.Z:
                    var dx = x0 - xi;
                    var dy = y0 - yi;
                    l = Math.sqrt(dx * dx + dy * dy);
                    xi = x0;
                    yi = y0;
                    break;
            }
            if (l >= 0) {
                pathSegLen[segCount++] = l;
                pathTotalLen += l;
            }
        }
        this._pathLen = pathTotalLen;
        return pathTotalLen;
    };
    PathProxy.prototype.rebuildPath = function(ctx, percent) {
        var d = this.data;
        var ux = this._ux;
        var uy = this._uy;
        var len = this._len;
        var x0;
        var y0;
        var xi;
        var yi;
        var x;
        var y;
        var drawPart = percent < 1;
        var pathSegLen;
        var pathTotalLen;
        var accumLength = 0;
        var segCount = 0;
        var displayedLength;
        var pendingPtDist = 0;
        var pendingPtX;
        var pendingPtY;
        if (drawPart) {
            if (!this._pathSegLen) this._calculateLength();
            pathSegLen = this._pathSegLen;
            pathTotalLen = this._pathLen;
            displayedLength = percent * pathTotalLen;
            if (!displayedLength) return;
        }
        lo: for(var i = 0; i < len;){
            var cmd = d[i++];
            var isFirst = i === 1;
            if (isFirst) {
                xi = d[i];
                yi = d[i + 1];
                x0 = xi;
                y0 = yi;
            }
            if (cmd !== $e2a16933ef78a053$var$CMD.L && pendingPtDist > 0) {
                ctx.lineTo(pendingPtX, pendingPtY);
                pendingPtDist = 0;
            }
            switch(cmd){
                case $e2a16933ef78a053$var$CMD.M:
                    x0 = xi = d[i++];
                    y0 = yi = d[i++];
                    ctx.moveTo(xi, yi);
                    break;
                case $e2a16933ef78a053$var$CMD.L:
                    x = d[i++];
                    y = d[i++];
                    var dx = $e2a16933ef78a053$var$mathAbs(x - xi);
                    var dy = $e2a16933ef78a053$var$mathAbs(y - yi);
                    if (dx > ux || dy > uy) {
                        if (drawPart) {
                            var l = pathSegLen[segCount++];
                            if (accumLength + l > displayedLength) {
                                var t = (displayedLength - accumLength) / l;
                                ctx.lineTo(xi * (1 - t) + x * t, yi * (1 - t) + y * t);
                                break lo;
                            }
                            accumLength += l;
                        }
                        ctx.lineTo(x, y);
                        xi = x;
                        yi = y;
                        pendingPtDist = 0;
                    } else {
                        var d2 = dx * dx + dy * dy;
                        if (d2 > pendingPtDist) {
                            pendingPtX = x;
                            pendingPtY = y;
                            pendingPtDist = d2;
                        }
                    }
                    break;
                case $e2a16933ef78a053$var$CMD.C:
                    var x1 = d[i++];
                    var y1 = d[i++];
                    var x2 = d[i++];
                    var y2 = d[i++];
                    var x3 = d[i++];
                    var y3 = d[i++];
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var t = (displayedLength - accumLength) / l;
                            (0, $3dec70ca5f6b6e8f$export$a2ee23a0567039da)(xi, x1, x2, x3, t, $e2a16933ef78a053$var$tmpOutX);
                            (0, $3dec70ca5f6b6e8f$export$a2ee23a0567039da)(yi, y1, y2, y3, t, $e2a16933ef78a053$var$tmpOutY);
                            ctx.bezierCurveTo($e2a16933ef78a053$var$tmpOutX[1], $e2a16933ef78a053$var$tmpOutY[1], $e2a16933ef78a053$var$tmpOutX[2], $e2a16933ef78a053$var$tmpOutY[2], $e2a16933ef78a053$var$tmpOutX[3], $e2a16933ef78a053$var$tmpOutY[3]);
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.bezierCurveTo(x1, y1, x2, y2, x3, y3);
                    xi = x3;
                    yi = y3;
                    break;
                case $e2a16933ef78a053$var$CMD.Q:
                    var x1 = d[i++];
                    var y1 = d[i++];
                    var x2 = d[i++];
                    var y2 = d[i++];
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var t = (displayedLength - accumLength) / l;
                            (0, $3dec70ca5f6b6e8f$export$117c659e21a7a060)(xi, x1, x2, t, $e2a16933ef78a053$var$tmpOutX);
                            (0, $3dec70ca5f6b6e8f$export$117c659e21a7a060)(yi, y1, y2, t, $e2a16933ef78a053$var$tmpOutY);
                            ctx.quadraticCurveTo($e2a16933ef78a053$var$tmpOutX[1], $e2a16933ef78a053$var$tmpOutY[1], $e2a16933ef78a053$var$tmpOutX[2], $e2a16933ef78a053$var$tmpOutY[2]);
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.quadraticCurveTo(x1, y1, x2, y2);
                    xi = x2;
                    yi = y2;
                    break;
                case $e2a16933ef78a053$var$CMD.A:
                    var cx = d[i++];
                    var cy = d[i++];
                    var rx = d[i++];
                    var ry = d[i++];
                    var startAngle = d[i++];
                    var delta = d[i++];
                    var psi = d[i++];
                    var anticlockwise = !d[i++];
                    var r = rx > ry ? rx : ry;
                    var isEllipse = $e2a16933ef78a053$var$mathAbs(rx - ry) > 1e-3;
                    var endAngle = startAngle + delta;
                    var breakBuild = false;
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            endAngle = startAngle + delta * (displayedLength - accumLength) / l;
                            breakBuild = true;
                        }
                        accumLength += l;
                    }
                    if (isEllipse && ctx.ellipse) ctx.ellipse(cx, cy, rx, ry, psi, startAngle, endAngle, anticlockwise);
                    else ctx.arc(cx, cy, r, startAngle, endAngle, anticlockwise);
                    if (breakBuild) break lo;
                    if (isFirst) {
                        x0 = $e2a16933ef78a053$var$mathCos(startAngle) * rx + cx;
                        y0 = $e2a16933ef78a053$var$mathSin(startAngle) * ry + cy;
                    }
                    xi = $e2a16933ef78a053$var$mathCos(endAngle) * rx + cx;
                    yi = $e2a16933ef78a053$var$mathSin(endAngle) * ry + cy;
                    break;
                case $e2a16933ef78a053$var$CMD.R:
                    x0 = xi = d[i];
                    y0 = yi = d[i + 1];
                    x = d[i++];
                    y = d[i++];
                    var width = d[i++];
                    var height = d[i++];
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var d_1 = displayedLength - accumLength;
                            ctx.moveTo(x, y);
                            ctx.lineTo(x + $e2a16933ef78a053$var$mathMin(d_1, width), y);
                            d_1 -= width;
                            if (d_1 > 0) ctx.lineTo(x + width, y + $e2a16933ef78a053$var$mathMin(d_1, height));
                            d_1 -= height;
                            if (d_1 > 0) ctx.lineTo(x + $e2a16933ef78a053$var$mathMax(width - d_1, 0), y + height);
                            d_1 -= width;
                            if (d_1 > 0) ctx.lineTo(x, y + $e2a16933ef78a053$var$mathMax(height - d_1, 0));
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.rect(x, y, width, height);
                    break;
                case $e2a16933ef78a053$var$CMD.Z:
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var t = (displayedLength - accumLength) / l;
                            ctx.lineTo(xi * (1 - t) + x0 * t, yi * (1 - t) + y0 * t);
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.closePath();
                    xi = x0;
                    yi = y0;
            }
        }
    };
    PathProxy.prototype.clone = function() {
        var newProxy = new PathProxy();
        var data = this.data;
        newProxy.data = data.slice ? data.slice() : Array.prototype.slice.call(data);
        newProxy._len = this._len;
        return newProxy;
    };
    PathProxy.prototype.canSave = function() {
        return !!this._saveData;
    };
    PathProxy.CMD = $e2a16933ef78a053$var$CMD;
    PathProxy.initDefaultProps = function() {
        var proto = PathProxy.prototype;
        proto._saveData = true;
        proto._ux = 0;
        proto._uy = 0;
        proto._pendingPtDist = 0;
        proto._version = 0;
    }();
    return PathProxy;
}();
var $e2a16933ef78a053$export$2e2bcd8739ae039 = $e2a16933ef78a053$var$PathProxy;



function $5f7c4dc2b1f6f789$export$8d36b1b5d19157c5(x0, y0, x1, y1, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    var _a = 0;
    var _b = x0;
    if (y > y0 + _l && y > y1 + _l || y < y0 - _l && y < y1 - _l || x > x0 + _l && x > x1 + _l || x < x0 - _l && x < x1 - _l) return false;
    if (x0 !== x1) {
        _a = (y0 - y1) / (x0 - x1);
        _b = (x0 * y1 - x1 * y0) / (x0 - x1);
    } else return Math.abs(x - x0) <= _l / 2;
    var tmp = _a * x - y + _b;
    var _s = tmp * tmp / (_a * _a + 1);
    return _s <= _l / 2 * _l / 2;
}



function $447c3b2f7f3e5569$export$8d36b1b5d19157c5(x0, y0, x1, y1, x2, y2, x3, y3, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    if (y > y0 + _l && y > y1 + _l && y > y2 + _l && y > y3 + _l || y < y0 - _l && y < y1 - _l && y < y2 - _l && y < y3 - _l || x > x0 + _l && x > x1 + _l && x > x2 + _l && x > x3 + _l || x < x0 - _l && x < x1 - _l && x < x2 - _l && x < x3 - _l) return false;
    var d = $3dec70ca5f6b6e8f$export$dbaa3801d1284367(x0, y0, x1, y1, x2, y2, x3, y3, x, y, null);
    return d <= _l / 2;
}



function $94f3552556f0a4f2$export$8d36b1b5d19157c5(x0, y0, x1, y1, x2, y2, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    if (y > y0 + _l && y > y1 + _l && y > y2 + _l || y < y0 - _l && y < y1 - _l && y < y2 - _l || x > x0 + _l && x > x1 + _l && x > x2 + _l || x < x0 - _l && x < x1 - _l && x < x2 - _l) return false;
    var d = (0, $3dec70ca5f6b6e8f$export$81915a594fe10dee)(x0, y0, x1, y1, x2, y2, x, y, null);
    return d <= _l / 2;
}


var $865d7df327ec107b$var$PI2 = Math.PI * 2;
function $865d7df327ec107b$export$d44861331f213635(angle) {
    angle %= $865d7df327ec107b$var$PI2;
    if (angle < 0) angle += $865d7df327ec107b$var$PI2;
    return angle;
}


var $a1064b55bdfd82e5$var$PI2 = Math.PI * 2;
function $a1064b55bdfd82e5$export$8d36b1b5d19157c5(cx, cy, r, startAngle, endAngle, anticlockwise, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    x -= cx;
    y -= cy;
    var d = Math.sqrt(x * x + y * y);
    if (d - _l > r || d + _l < r) return false;
    if (Math.abs(startAngle - endAngle) % $a1064b55bdfd82e5$var$PI2 < 1e-4) return true;
    if (anticlockwise) {
        var tmp = startAngle;
        startAngle = (0, $865d7df327ec107b$export$d44861331f213635)(endAngle);
        endAngle = (0, $865d7df327ec107b$export$d44861331f213635)(tmp);
    } else {
        startAngle = (0, $865d7df327ec107b$export$d44861331f213635)(startAngle);
        endAngle = (0, $865d7df327ec107b$export$d44861331f213635)(endAngle);
    }
    if (startAngle > endAngle) endAngle += $a1064b55bdfd82e5$var$PI2;
    var angle = Math.atan2(y, x);
    if (angle < 0) angle += $a1064b55bdfd82e5$var$PI2;
    return angle >= startAngle && angle <= endAngle || angle + $a1064b55bdfd82e5$var$PI2 >= startAngle && angle + $a1064b55bdfd82e5$var$PI2 <= endAngle;
}



function $36ba9cdf2f52eec1$export$2e2bcd8739ae039(x0, y0, x1, y1, x, y) {
    if (y > y0 && y > y1 || y < y0 && y < y1) return 0;
    if (y1 === y0) return 0;
    var t = (y - y0) / (y1 - y0);
    var dir = y1 < y0 ? 1 : -1;
    if (t === 1 || t === 0) dir = y1 < y0 ? 0.5 : -0.5;
    var x_ = t * (x1 - x0) + x0;
    return x_ === x ? Infinity : x_ > x ? dir : 0;
}


var $e628138483af114c$var$CMD = (0, $e2a16933ef78a053$export$2e2bcd8739ae039).CMD;
var $e628138483af114c$var$PI2 = Math.PI * 2;
var $e628138483af114c$var$EPSILON = 1e-4;
function $e628138483af114c$var$isAroundEqual(a, b) {
    return Math.abs(a - b) < $e628138483af114c$var$EPSILON;
}
var $e628138483af114c$var$roots = [
    -1,
    -1,
    -1
];
var $e628138483af114c$var$extrema = [
    -1,
    -1
];
function $e628138483af114c$var$swapExtrema() {
    var tmp = $e628138483af114c$var$extrema[0];
    $e628138483af114c$var$extrema[0] = $e628138483af114c$var$extrema[1];
    $e628138483af114c$var$extrema[1] = tmp;
}
function $e628138483af114c$var$windingCubic(x0, y0, x1, y1, x2, y2, x3, y3, x, y) {
    if (y > y0 && y > y1 && y > y2 && y > y3 || y < y0 && y < y1 && y < y2 && y < y3) return 0;
    var nRoots = $3dec70ca5f6b6e8f$export$ca5d13faa10b167e(y0, y1, y2, y3, y, $e628138483af114c$var$roots);
    if (nRoots === 0) return 0;
    else {
        var w = 0;
        var nExtrema = -1;
        var y0_ = void 0;
        var y1_ = void 0;
        for(var i = 0; i < nRoots; i++){
            var t = $e628138483af114c$var$roots[i];
            var unit = t === 0 || t === 1 ? 0.5 : 1;
            var x_ = $3dec70ca5f6b6e8f$export$547c21de482bbcb2(x0, x1, x2, x3, t);
            if (x_ < x) continue;
            if (nExtrema < 0) {
                nExtrema = $3dec70ca5f6b6e8f$export$df1a172f100d0457(y0, y1, y2, y3, $e628138483af114c$var$extrema);
                if ($e628138483af114c$var$extrema[1] < $e628138483af114c$var$extrema[0] && nExtrema > 1) $e628138483af114c$var$swapExtrema();
                y0_ = $3dec70ca5f6b6e8f$export$547c21de482bbcb2(y0, y1, y2, y3, $e628138483af114c$var$extrema[0]);
                if (nExtrema > 1) y1_ = $3dec70ca5f6b6e8f$export$547c21de482bbcb2(y0, y1, y2, y3, $e628138483af114c$var$extrema[1]);
            }
            if (nExtrema === 2) {
                if (t < $e628138483af114c$var$extrema[0]) w += y0_ < y0 ? unit : -unit;
                else if (t < $e628138483af114c$var$extrema[1]) w += y1_ < y0_ ? unit : -unit;
                else w += y3 < y1_ ? unit : -unit;
            } else if (t < $e628138483af114c$var$extrema[0]) w += y0_ < y0 ? unit : -unit;
            else w += y3 < y0_ ? unit : -unit;
        }
        return w;
    }
}
function $e628138483af114c$var$windingQuadratic(x0, y0, x1, y1, x2, y2, x, y) {
    if (y > y0 && y > y1 && y > y2 || y < y0 && y < y1 && y < y2) return 0;
    var nRoots = $3dec70ca5f6b6e8f$export$fd895ac7ee764967(y0, y1, y2, y, $e628138483af114c$var$roots);
    if (nRoots === 0) return 0;
    else {
        var t = $3dec70ca5f6b6e8f$export$752e1f8c6e7f7e11(y0, y1, y2);
        if (t >= 0 && t <= 1) {
            var w = 0;
            var y_ = $3dec70ca5f6b6e8f$export$af17094a950f5073(y0, y1, y2, t);
            for(var i = 0; i < nRoots; i++){
                var unit = $e628138483af114c$var$roots[i] === 0 || $e628138483af114c$var$roots[i] === 1 ? 0.5 : 1;
                var x_ = $3dec70ca5f6b6e8f$export$af17094a950f5073(x0, x1, x2, $e628138483af114c$var$roots[i]);
                if (x_ < x) continue;
                if ($e628138483af114c$var$roots[i] < t) w += y_ < y0 ? unit : -unit;
                else w += y2 < y_ ? unit : -unit;
            }
            return w;
        } else {
            var unit = $e628138483af114c$var$roots[0] === 0 || $e628138483af114c$var$roots[0] === 1 ? 0.5 : 1;
            var x_ = $3dec70ca5f6b6e8f$export$af17094a950f5073(x0, x1, x2, $e628138483af114c$var$roots[0]);
            if (x_ < x) return 0;
            return y2 < y0 ? unit : -unit;
        }
    }
}
function $e628138483af114c$var$windingArc(cx, cy, r, startAngle, endAngle, anticlockwise, x, y) {
    y -= cy;
    if (y > r || y < -r) return 0;
    var tmp = Math.sqrt(r * r - y * y);
    $e628138483af114c$var$roots[0] = -tmp;
    $e628138483af114c$var$roots[1] = tmp;
    var dTheta = Math.abs(startAngle - endAngle);
    if (dTheta < 1e-4) return 0;
    if (dTheta >= $e628138483af114c$var$PI2 - 1e-4) {
        startAngle = 0;
        endAngle = $e628138483af114c$var$PI2;
        var dir = anticlockwise ? 1 : -1;
        if (x >= $e628138483af114c$var$roots[0] + cx && x <= $e628138483af114c$var$roots[1] + cx) return dir;
        else return 0;
    }
    if (startAngle > endAngle) {
        var tmp_1 = startAngle;
        startAngle = endAngle;
        endAngle = tmp_1;
    }
    if (startAngle < 0) {
        startAngle += $e628138483af114c$var$PI2;
        endAngle += $e628138483af114c$var$PI2;
    }
    var w = 0;
    for(var i = 0; i < 2; i++){
        var x_ = $e628138483af114c$var$roots[i];
        if (x_ + cx > x) {
            var angle = Math.atan2(y, x_);
            var dir = anticlockwise ? 1 : -1;
            if (angle < 0) angle = $e628138483af114c$var$PI2 + angle;
            if (angle >= startAngle && angle <= endAngle || angle + $e628138483af114c$var$PI2 >= startAngle && angle + $e628138483af114c$var$PI2 <= endAngle) {
                if (angle > Math.PI / 2 && angle < Math.PI * 1.5) dir = -dir;
                w += dir;
            }
        }
    }
    return w;
}
function $e628138483af114c$var$containPath(path, lineWidth, isStroke, x, y) {
    var data = path.data;
    var len = path.len();
    var w = 0;
    var xi = 0;
    var yi = 0;
    var x0 = 0;
    var y0 = 0;
    var x1;
    var y1;
    for(var i = 0; i < len;){
        var cmd = data[i++];
        var isFirst = i === 1;
        if (cmd === $e628138483af114c$var$CMD.M && i > 1) {
            if (!isStroke) w += (0, $36ba9cdf2f52eec1$export$2e2bcd8739ae039)(xi, yi, x0, y0, x, y);
        }
        if (isFirst) {
            xi = data[i];
            yi = data[i + 1];
            x0 = xi;
            y0 = yi;
        }
        switch(cmd){
            case $e628138483af114c$var$CMD.M:
                x0 = data[i++];
                y0 = data[i++];
                xi = x0;
                yi = y0;
                break;
            case $e628138483af114c$var$CMD.L:
                if (isStroke) {
                    if ($5f7c4dc2b1f6f789$export$8d36b1b5d19157c5(xi, yi, data[i], data[i + 1], lineWidth, x, y)) return true;
                } else w += (0, $36ba9cdf2f52eec1$export$2e2bcd8739ae039)(xi, yi, data[i], data[i + 1], x, y) || 0;
                xi = data[i++];
                yi = data[i++];
                break;
            case $e628138483af114c$var$CMD.C:
                if (isStroke) {
                    if ($447c3b2f7f3e5569$export$8d36b1b5d19157c5(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) return true;
                } else w += $e628138483af114c$var$windingCubic(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
                xi = data[i++];
                yi = data[i++];
                break;
            case $e628138483af114c$var$CMD.Q:
                if (isStroke) {
                    if ($94f3552556f0a4f2$export$8d36b1b5d19157c5(xi, yi, data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) return true;
                } else w += $e628138483af114c$var$windingQuadratic(xi, yi, data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
                xi = data[i++];
                yi = data[i++];
                break;
            case $e628138483af114c$var$CMD.A:
                var cx = data[i++];
                var cy = data[i++];
                var rx = data[i++];
                var ry = data[i++];
                var theta = data[i++];
                var dTheta = data[i++];
                i += 1;
                var anticlockwise = !!(1 - data[i++]);
                x1 = Math.cos(theta) * rx + cx;
                y1 = Math.sin(theta) * ry + cy;
                if (!isFirst) w += (0, $36ba9cdf2f52eec1$export$2e2bcd8739ae039)(xi, yi, x1, y1, x, y);
                else {
                    x0 = x1;
                    y0 = y1;
                }
                var _x = (x - cx) * ry / rx + cx;
                if (isStroke) {
                    if ($a1064b55bdfd82e5$export$8d36b1b5d19157c5(cx, cy, ry, theta, theta + dTheta, anticlockwise, lineWidth, _x, y)) return true;
                } else w += $e628138483af114c$var$windingArc(cx, cy, ry, theta, theta + dTheta, anticlockwise, _x, y);
                xi = Math.cos(theta + dTheta) * rx + cx;
                yi = Math.sin(theta + dTheta) * ry + cy;
                break;
            case $e628138483af114c$var$CMD.R:
                x0 = xi = data[i++];
                y0 = yi = data[i++];
                var width = data[i++];
                var height = data[i++];
                x1 = x0 + width;
                y1 = y0 + height;
                if (isStroke) {
                    if ($5f7c4dc2b1f6f789$export$8d36b1b5d19157c5(x0, y0, x1, y0, lineWidth, x, y) || $5f7c4dc2b1f6f789$export$8d36b1b5d19157c5(x1, y0, x1, y1, lineWidth, x, y) || $5f7c4dc2b1f6f789$export$8d36b1b5d19157c5(x1, y1, x0, y1, lineWidth, x, y) || $5f7c4dc2b1f6f789$export$8d36b1b5d19157c5(x0, y1, x0, y0, lineWidth, x, y)) return true;
                } else {
                    w += (0, $36ba9cdf2f52eec1$export$2e2bcd8739ae039)(x1, y0, x1, y1, x, y);
                    w += (0, $36ba9cdf2f52eec1$export$2e2bcd8739ae039)(x0, y1, x0, y0, x, y);
                }
                break;
            case $e628138483af114c$var$CMD.Z:
                if (isStroke) {
                    if ($5f7c4dc2b1f6f789$export$8d36b1b5d19157c5(xi, yi, x0, y0, lineWidth, x, y)) return true;
                } else w += (0, $36ba9cdf2f52eec1$export$2e2bcd8739ae039)(xi, yi, x0, y0, x, y);
                xi = x0;
                yi = y0;
                break;
        }
    }
    if (!isStroke && !$e628138483af114c$var$isAroundEqual(yi, y0)) w += (0, $36ba9cdf2f52eec1$export$2e2bcd8739ae039)(xi, yi, x0, y0, x, y) || 0;
    return w !== 0;
}
function $e628138483af114c$export$8893e2b90ba10d92(pathProxy, x, y) {
    return $e628138483af114c$var$containPath(pathProxy, 0, false, x, y);
}
function $e628138483af114c$export$8d36b1b5d19157c5(pathProxy, lineWidth, x, y) {
    return $e628138483af114c$var$containPath(pathProxy, lineWidth, true, x, y);
}







var $227e31075465dcd4$export$deade517576e293a = (0, $43e0a445ed6711da$export$ebe90cb607ad99e)({
    fill: "#000",
    stroke: null,
    strokePercent: 1,
    fillOpacity: 1,
    strokeOpacity: 1,
    lineDashOffset: 0,
    lineWidth: 1,
    lineCap: "butt",
    miterLimit: 10,
    strokeNoScale: false,
    strokeFirst: false
}, (0, $4773d393c538283c$export$737672163db00fe3));
var $227e31075465dcd4$export$71bb6c3c6862c6a5 = {
    style: (0, $43e0a445ed6711da$export$ebe90cb607ad99e)({
        fill: true,
        stroke: true,
        strokePercent: true,
        fillOpacity: true,
        strokeOpacity: true,
        lineDashOffset: true,
        lineWidth: true,
        miterLimit: true
    }, (0, $4773d393c538283c$export$9908943fb57fbe51).style)
};
var $227e31075465dcd4$var$pathCopyParams = (0, $cca2e8cc539372e0$export$98ab6203ec3396e2).concat([
    "invisible",
    "culling",
    "z",
    "z2",
    "zlevel",
    "parent"
]);
var $227e31075465dcd4$var$Path = function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(Path, _super);
    function Path(opts) {
        return _super.call(this, opts) || this;
    }
    Path.prototype.update = function() {
        var _this = this;
        _super.prototype.update.call(this);
        var style = this.style;
        if (style.decal) {
            var decalEl = this._decalEl = this._decalEl || new Path();
            if (decalEl.buildPath === Path.prototype.buildPath) decalEl.buildPath = function(ctx) {
                _this.buildPath(ctx, _this.shape);
            };
            decalEl.silent = true;
            var decalElStyle = decalEl.style;
            for(var key in style)if (decalElStyle[key] !== style[key]) decalElStyle[key] = style[key];
            decalElStyle.fill = style.fill ? style.decal : null;
            decalElStyle.decal = null;
            decalElStyle.shadowColor = null;
            style.strokeFirst && (decalElStyle.stroke = null);
            for(var i = 0; i < $227e31075465dcd4$var$pathCopyParams.length; ++i)decalEl[$227e31075465dcd4$var$pathCopyParams[i]] = this[$227e31075465dcd4$var$pathCopyParams[i]];
            decalEl.__dirty |= (0, $24fa4a8d26d34a24$export$a7b6db622c6c7dbd);
        } else if (this._decalEl) this._decalEl = null;
    };
    Path.prototype.getDecalElement = function() {
        return this._decalEl;
    };
    Path.prototype._init = function(props) {
        var keysArr = (0, $43e0a445ed6711da$export$ed97f33186d4b816)(props);
        this.shape = this.getDefaultShape();
        var defaultStyle = this.getDefaultStyle();
        if (defaultStyle) this.useStyle(defaultStyle);
        for(var i = 0; i < keysArr.length; i++){
            var key = keysArr[i];
            var value = props[key];
            if (key === "style") {
                if (!this.style) this.useStyle(value);
                else (0, $43e0a445ed6711da$export$8b58be045bf06082)(this.style, value);
            } else if (key === "shape") (0, $43e0a445ed6711da$export$8b58be045bf06082)(this.shape, value);
            else _super.prototype.attrKV.call(this, key, value);
        }
        if (!this.style) this.useStyle({});
    };
    Path.prototype.getDefaultStyle = function() {
        return null;
    };
    Path.prototype.getDefaultShape = function() {
        return {};
    };
    Path.prototype.canBeInsideText = function() {
        return this.hasFill();
    };
    Path.prototype.getInsideTextFill = function() {
        var pathFill = this.style.fill;
        if (pathFill !== "none") {
            if ((0, $43e0a445ed6711da$export$844ec244b1367d54)(pathFill)) {
                var fillLum = (0, $b0979f18b0a232f9$export$16c0ec21a6f9ef95)(pathFill, 0);
                if (fillLum > 0.5) return 0, $b4769615a730dcfc$export$f8ce94761f39398d;
                else if (fillLum > 0.2) return 0, $b4769615a730dcfc$export$27682248795c3c6b;
                return 0, $b4769615a730dcfc$export$3c6e95f318c8369b;
            } else if (pathFill) return 0, $b4769615a730dcfc$export$3c6e95f318c8369b;
        }
        return 0, $b4769615a730dcfc$export$f8ce94761f39398d;
    };
    Path.prototype.getInsideTextStroke = function(textFill) {
        var pathFill = this.style.fill;
        if ((0, $43e0a445ed6711da$export$844ec244b1367d54)(pathFill)) {
            var zr = this.__zr;
            var isDarkMode = !!(zr && zr.isDarkMode());
            var isDarkLabel = (0, $b0979f18b0a232f9$export$16c0ec21a6f9ef95)(textFill, 0) < (0, $b4769615a730dcfc$export$fd81e7ebc7dae256);
            if (isDarkMode === isDarkLabel) return pathFill;
        }
    };
    Path.prototype.buildPath = function(ctx, shapeCfg, inBatch) {};
    Path.prototype.pathUpdated = function() {
        this.__dirty &= ~(0, $24fa4a8d26d34a24$export$f75fe89a33ebe115);
    };
    Path.prototype.getUpdatedPathProxy = function(inBatch) {
        !this.path && this.createPathProxy();
        this.path.beginPath();
        this.buildPath(this.path, this.shape, inBatch);
        return this.path;
    };
    Path.prototype.createPathProxy = function() {
        this.path = new (0, $e2a16933ef78a053$export$2e2bcd8739ae039)(false);
    };
    Path.prototype.hasStroke = function() {
        var style = this.style;
        var stroke = style.stroke;
        return !(stroke == null || stroke === "none" || !(style.lineWidth > 0));
    };
    Path.prototype.hasFill = function() {
        var style = this.style;
        var fill = style.fill;
        return fill != null && fill !== "none";
    };
    Path.prototype.getBoundingRect = function() {
        var rect = this._rect;
        var style = this.style;
        var needsUpdateRect = !rect;
        if (needsUpdateRect) {
            var firstInvoke = false;
            if (!this.path) {
                firstInvoke = true;
                this.createPathProxy();
            }
            var path = this.path;
            if (firstInvoke || this.__dirty & (0, $24fa4a8d26d34a24$export$f75fe89a33ebe115)) {
                path.beginPath();
                this.buildPath(path, this.shape, false);
                this.pathUpdated();
            }
            rect = path.getBoundingRect();
        }
        this._rect = rect;
        if (this.hasStroke() && this.path && this.path.len() > 0) {
            var rectStroke = this._rectStroke || (this._rectStroke = rect.clone());
            if (this.__dirty || needsUpdateRect) {
                rectStroke.copy(rect);
                var lineScale = style.strokeNoScale ? this.getLineScale() : 1;
                var w = style.lineWidth;
                if (!this.hasFill()) {
                    var strokeContainThreshold = this.strokeContainThreshold;
                    w = Math.max(w, strokeContainThreshold == null ? 4 : strokeContainThreshold);
                }
                if (lineScale > 1e-10) {
                    rectStroke.width += w / lineScale;
                    rectStroke.height += w / lineScale;
                    rectStroke.x -= w / lineScale / 2;
                    rectStroke.y -= w / lineScale / 2;
                }
            }
            return rectStroke;
        }
        return rect;
    };
    Path.prototype.contain = function(x, y) {
        var localPos = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        var style = this.style;
        x = localPos[0];
        y = localPos[1];
        if (rect.contain(x, y)) {
            var pathProxy = this.path;
            if (this.hasStroke()) {
                var lineWidth = style.lineWidth;
                var lineScale = style.strokeNoScale ? this.getLineScale() : 1;
                if (lineScale > 1e-10) {
                    if (!this.hasFill()) lineWidth = Math.max(lineWidth, this.strokeContainThreshold);
                    if ($e628138483af114c$export$8d36b1b5d19157c5(pathProxy, lineWidth / lineScale, x, y)) return true;
                }
            }
            if (this.hasFill()) return $e628138483af114c$export$8893e2b90ba10d92(pathProxy, x, y);
        }
        return false;
    };
    Path.prototype.dirtyShape = function() {
        this.__dirty |= (0, $24fa4a8d26d34a24$export$f75fe89a33ebe115);
        if (this._rect) this._rect = null;
        if (this._decalEl) this._decalEl.dirtyShape();
        this.markRedraw();
    };
    Path.prototype.dirty = function() {
        this.dirtyStyle();
        this.dirtyShape();
    };
    Path.prototype.animateShape = function(loop) {
        return this.animate("shape", loop);
    };
    Path.prototype.updateDuringAnimation = function(targetKey) {
        if (targetKey === "style") this.dirtyStyle();
        else if (targetKey === "shape") this.dirtyShape();
        else this.markRedraw();
    };
    Path.prototype.attrKV = function(key, value) {
        if (key === "shape") this.setShape(value);
        else _super.prototype.attrKV.call(this, key, value);
    };
    Path.prototype.setShape = function(keyOrObj, value) {
        var shape = this.shape;
        if (!shape) shape = this.shape = {};
        if (typeof keyOrObj === "string") shape[keyOrObj] = value;
        else (0, $43e0a445ed6711da$export$8b58be045bf06082)(shape, keyOrObj);
        this.dirtyShape();
        return this;
    };
    Path.prototype.shapeChanged = function() {
        return !!(this.__dirty & (0, $24fa4a8d26d34a24$export$f75fe89a33ebe115));
    };
    Path.prototype.createStyle = function(obj) {
        return (0, $43e0a445ed6711da$export$79c7e160a7743efd)($227e31075465dcd4$export$deade517576e293a, obj);
    };
    Path.prototype._innerSaveToNormal = function(toState) {
        _super.prototype._innerSaveToNormal.call(this, toState);
        var normalState = this._normalState;
        if (toState.shape && !normalState.shape) normalState.shape = (0, $43e0a445ed6711da$export$8b58be045bf06082)({}, this.shape);
    };
    Path.prototype._applyStateObj = function(stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
        _super.prototype._applyStateObj.call(this, stateName, state, normalState, keepCurrentStates, transition, animationCfg);
        if (this.__inHover === (0, $0b8373c26fe287ed$export$f5347ae640a7f0d0)) return;
        var needsRestoreToNormal = !(state && keepCurrentStates);
        var targetShape;
        if (state && state.shape) {
            if (transition) {
                if (keepCurrentStates) targetShape = state.shape;
                else {
                    targetShape = (0, $43e0a445ed6711da$export$8b58be045bf06082)({}, normalState.shape);
                    (0, $43e0a445ed6711da$export$8b58be045bf06082)(targetShape, state.shape);
                }
            } else {
                targetShape = (0, $43e0a445ed6711da$export$8b58be045bf06082)({}, keepCurrentStates ? this.shape : normalState.shape);
                (0, $43e0a445ed6711da$export$8b58be045bf06082)(targetShape, state.shape);
            }
        } else if (needsRestoreToNormal) targetShape = normalState.shape;
        if (targetShape) {
            if (transition) {
                this.shape = (0, $43e0a445ed6711da$export$8b58be045bf06082)({}, this.shape);
                var targetShapePrimaryProps = {};
                var shapeKeys = (0, $43e0a445ed6711da$export$ed97f33186d4b816)(targetShape);
                for(var i = 0; i < shapeKeys.length; i++){
                    var key = shapeKeys[i];
                    if (typeof targetShape[key] === "object") this.shape[key] = targetShape[key];
                    else targetShapePrimaryProps[key] = targetShape[key];
                }
                this._transitionState(stateName, {
                    shape: targetShapePrimaryProps
                }, animationCfg);
            } else {
                this.shape = targetShape;
                this.dirtyShape();
            }
        }
    };
    Path.prototype._mergeStates = function(states) {
        var mergedState = _super.prototype._mergeStates.call(this, states);
        var mergedShape;
        for(var i = 0; i < states.length; i++){
            var state = states[i];
            if (state.shape) {
                mergedShape = mergedShape || {};
                this._mergeStyle(mergedShape, state.shape);
            }
        }
        if (mergedShape) mergedState.shape = mergedShape;
        return mergedState;
    };
    Path.prototype.getAnimationStyleProps = function() {
        return $227e31075465dcd4$export$71bb6c3c6862c6a5;
    };
    Path.prototype.isZeroArea = function() {
        return false;
    };
    Path.extend = function(defaultProps) {
        var Sub = function(_super) {
            (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(Sub, _super);
            function Sub(opts) {
                var _this = _super.call(this, opts) || this;
                defaultProps.init && defaultProps.init.call(_this, opts);
                return _this;
            }
            Sub.prototype.getDefaultStyle = function() {
                return (0, $43e0a445ed6711da$export$9cd59f9826255e47)(defaultProps.style);
            };
            Sub.prototype.getDefaultShape = function() {
                return (0, $43e0a445ed6711da$export$9cd59f9826255e47)(defaultProps.shape);
            };
            return Sub;
        }(Path);
        for(var key in defaultProps)if (typeof defaultProps[key] === "function") Sub.prototype[key] = defaultProps[key];
        return Sub;
    };
    Path.initDefaultProps = function() {
        var pathProto = Path.prototype;
        pathProto.type = "path";
        pathProto.strokeContainThreshold = 5;
        pathProto.segmentIgnoreThreshold = 0;
        pathProto.subPixelOptimize = false;
        pathProto.autoBatch = false;
        pathProto.__dirty = (0, $24fa4a8d26d34a24$export$a7b6db622c6c7dbd) | (0, $24fa4a8d26d34a24$export$ada8b2beb3d76671) | (0, $24fa4a8d26d34a24$export$f75fe89a33ebe115);
    }();
    return Path;
}((0, $4773d393c538283c$export$2e2bcd8739ae039));
var $227e31075465dcd4$export$2e2bcd8739ae039 = $227e31075465dcd4$var$Path;





var $f2b3c07e83bf5376$export$5fbb6d98091bcb56 = (0, $43e0a445ed6711da$export$ebe90cb607ad99e)({
    strokeFirst: true,
    font: (0, $08c3209e6efc839a$export$7d7a232b6d2cc80c),
    x: 0,
    y: 0,
    textAlign: "left",
    textBaseline: "top",
    miterLimit: 2
}, (0, $227e31075465dcd4$export$deade517576e293a));
var $f2b3c07e83bf5376$var$TSpan = function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(TSpan, _super);
    function TSpan() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TSpan.prototype.hasStroke = function() {
        return (0, $92d383513c7738d1$export$c7aae0ffd99a8643)(this.style);
    };
    TSpan.prototype.hasFill = function() {
        var style = this.style;
        var fill = style.fill;
        return fill != null && fill !== "none";
    };
    TSpan.prototype.createStyle = function(obj) {
        return (0, $43e0a445ed6711da$export$79c7e160a7743efd)($f2b3c07e83bf5376$export$5fbb6d98091bcb56, obj);
    };
    TSpan.prototype.setBoundingRect = function(rect) {
        this._rect = rect;
    };
    TSpan.prototype.getBoundingRect = function() {
        if (!this._rect) this._rect = (0, $92d383513c7738d1$export$d79289ac0f53b974)(this.style);
        return this._rect;
    };
    TSpan.initDefaultProps = function() {
        var tspanProto = TSpan.prototype;
        tspanProto.dirtyRectTolerance = 10;
    }();
    return TSpan;
}((0, $4773d393c538283c$export$2e2bcd8739ae039));
$f2b3c07e83bf5376$var$TSpan.prototype.type = "tspan";
var $f2b3c07e83bf5376$export$2e2bcd8739ae039 = $f2b3c07e83bf5376$var$TSpan;








var $d3b0315ae8e8e298$export$8993f922aeeac642 = (0, $43e0a445ed6711da$export$ebe90cb607ad99e)({
    x: 0,
    y: 0
}, (0, $4773d393c538283c$export$737672163db00fe3));
var $d3b0315ae8e8e298$export$4aba8ad70847a488 = {
    style: (0, $43e0a445ed6711da$export$ebe90cb607ad99e)({
        x: true,
        y: true,
        width: true,
        height: true,
        sx: true,
        sy: true,
        sWidth: true,
        sHeight: true
    }, (0, $4773d393c538283c$export$9908943fb57fbe51).style)
};
function $d3b0315ae8e8e298$var$isImageLike(source) {
    return !!(source && typeof source !== "string" && source.width && source.height);
}
var $d3b0315ae8e8e298$var$ZRImage = function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(ZRImage, _super);
    function ZRImage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ZRImage.prototype.createStyle = function(obj) {
        return (0, $43e0a445ed6711da$export$79c7e160a7743efd)($d3b0315ae8e8e298$export$8993f922aeeac642, obj);
    };
    ZRImage.prototype._getSize = function(dim) {
        var style = this.style;
        var size = style[dim];
        if (size != null) return size;
        var imageSource = $d3b0315ae8e8e298$var$isImageLike(style.image) ? style.image : this.__image;
        if (!imageSource) return 0;
        var otherDim = dim === "width" ? "height" : "width";
        var otherDimSize = style[otherDim];
        if (otherDimSize == null) return imageSource[dim];
        else return imageSource[dim] / imageSource[otherDim] * otherDimSize;
    };
    ZRImage.prototype.getWidth = function() {
        return this._getSize("width");
    };
    ZRImage.prototype.getHeight = function() {
        return this._getSize("height");
    };
    ZRImage.prototype.getAnimationStyleProps = function() {
        return $d3b0315ae8e8e298$export$4aba8ad70847a488;
    };
    ZRImage.prototype.getBoundingRect = function() {
        var style = this.style;
        if (!this._rect) this._rect = new (0, $c437f598d9c9ee16$export$2e2bcd8739ae039)(style.x || 0, style.y || 0, this.getWidth(), this.getHeight());
        return this._rect;
    };
    return ZRImage;
}((0, $4773d393c538283c$export$2e2bcd8739ae039));
$d3b0315ae8e8e298$var$ZRImage.prototype.type = "image";
var $d3b0315ae8e8e298$export$2e2bcd8739ae039 = $d3b0315ae8e8e298$var$ZRImage;




function $89fc20bca27be9e4$export$5cc7f731b5937e99(ctx, shape) {
    var x = shape.x;
    var y = shape.y;
    var width = shape.width;
    var height = shape.height;
    var r = shape.r;
    var r1;
    var r2;
    var r3;
    var r4;
    if (width < 0) {
        x = x + width;
        width = -width;
    }
    if (height < 0) {
        y = y + height;
        height = -height;
    }
    if (typeof r === "number") r1 = r2 = r3 = r4 = r;
    else if (r instanceof Array) {
        if (r.length === 1) r1 = r2 = r3 = r4 = r[0];
        else if (r.length === 2) {
            r1 = r3 = r[0];
            r2 = r4 = r[1];
        } else if (r.length === 3) {
            r1 = r[0];
            r2 = r4 = r[1];
            r3 = r[2];
        } else {
            r1 = r[0];
            r2 = r[1];
            r3 = r[2];
            r4 = r[3];
        }
    } else r1 = r2 = r3 = r4 = 0;
    var total;
    if (r1 + r2 > width) {
        total = r1 + r2;
        r1 *= width / total;
        r2 *= width / total;
    }
    if (r3 + r4 > width) {
        total = r3 + r4;
        r3 *= width / total;
        r4 *= width / total;
    }
    if (r2 + r3 > height) {
        total = r2 + r3;
        r2 *= height / total;
        r3 *= height / total;
    }
    if (r1 + r4 > height) {
        total = r1 + r4;
        r1 *= height / total;
        r4 *= height / total;
    }
    ctx.moveTo(x + r1, y);
    ctx.lineTo(x + width - r2, y);
    r2 !== 0 && ctx.arc(x + width - r2, y + r2, r2, -Math.PI / 2, 0);
    ctx.lineTo(x + width, y + height - r3);
    r3 !== 0 && ctx.arc(x + width - r3, y + height - r3, r3, 0, Math.PI / 2);
    ctx.lineTo(x + r4, y + height);
    r4 !== 0 && ctx.arc(x + r4, y + height - r4, r4, Math.PI / 2, Math.PI);
    ctx.lineTo(x, y + r1);
    r1 !== 0 && ctx.arc(x + r1, y + r1, r1, Math.PI, Math.PI * 1.5);
    ctx.closePath();
}


var $4e772fb15506b6bd$var$round = Math.round;
function $4e772fb15506b6bd$export$8b4b620d7f4aad1b(outputShape, inputShape, style) {
    if (!inputShape) return;
    var x1 = inputShape.x1;
    var x2 = inputShape.x2;
    var y1 = inputShape.y1;
    var y2 = inputShape.y2;
    outputShape.x1 = x1;
    outputShape.x2 = x2;
    outputShape.y1 = y1;
    outputShape.y2 = y2;
    var lineWidth = style && style.lineWidth;
    if (!lineWidth) return outputShape;
    if ($4e772fb15506b6bd$var$round(x1 * 2) === $4e772fb15506b6bd$var$round(x2 * 2)) outputShape.x1 = outputShape.x2 = $4e772fb15506b6bd$export$72c4fd4c1b8fcb10(x1, lineWidth, true);
    if ($4e772fb15506b6bd$var$round(y1 * 2) === $4e772fb15506b6bd$var$round(y2 * 2)) outputShape.y1 = outputShape.y2 = $4e772fb15506b6bd$export$72c4fd4c1b8fcb10(y1, lineWidth, true);
    return outputShape;
}
function $4e772fb15506b6bd$export$60e2aa74957d0b9d(outputShape, inputShape, style) {
    if (!inputShape) return;
    var originX = inputShape.x;
    var originY = inputShape.y;
    var originWidth = inputShape.width;
    var originHeight = inputShape.height;
    outputShape.x = originX;
    outputShape.y = originY;
    outputShape.width = originWidth;
    outputShape.height = originHeight;
    var lineWidth = style && style.lineWidth;
    if (!lineWidth) return outputShape;
    outputShape.x = $4e772fb15506b6bd$export$72c4fd4c1b8fcb10(originX, lineWidth, true);
    outputShape.y = $4e772fb15506b6bd$export$72c4fd4c1b8fcb10(originY, lineWidth, true);
    outputShape.width = Math.max($4e772fb15506b6bd$export$72c4fd4c1b8fcb10(originX + originWidth, lineWidth, false) - outputShape.x, originWidth === 0 ? 0 : 1);
    outputShape.height = Math.max($4e772fb15506b6bd$export$72c4fd4c1b8fcb10(originY + originHeight, lineWidth, false) - outputShape.y, originHeight === 0 ? 0 : 1);
    return outputShape;
}
function $4e772fb15506b6bd$export$72c4fd4c1b8fcb10(position, lineWidth, positiveOrNegative) {
    if (!lineWidth) return position;
    var doubledPosition = $4e772fb15506b6bd$var$round(position * 2);
    return (doubledPosition + $4e772fb15506b6bd$var$round(lineWidth)) % 2 === 0 ? doubledPosition / 2 : (doubledPosition + (positiveOrNegative ? 1 : -1)) / 2;
}


var $42ed508a93973e78$export$51140d6b71bb4ed5 = function() {
    function RectShape() {
        this.x = 0;
        this.y = 0;
        this.width = 0;
        this.height = 0;
    }
    return RectShape;
}();
var $42ed508a93973e78$var$subPixelOptimizeOutputShape = {};
var $42ed508a93973e78$var$Rect = function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(Rect, _super);
    function Rect(opts) {
        return _super.call(this, opts) || this;
    }
    Rect.prototype.getDefaultShape = function() {
        return new $42ed508a93973e78$export$51140d6b71bb4ed5();
    };
    Rect.prototype.buildPath = function(ctx, shape) {
        var x;
        var y;
        var width;
        var height;
        if (this.subPixelOptimize) {
            var optimizedShape = (0, $4e772fb15506b6bd$export$60e2aa74957d0b9d)($42ed508a93973e78$var$subPixelOptimizeOutputShape, shape, this.style);
            x = optimizedShape.x;
            y = optimizedShape.y;
            width = optimizedShape.width;
            height = optimizedShape.height;
            optimizedShape.r = shape.r;
            shape = optimizedShape;
        } else {
            x = shape.x;
            y = shape.y;
            width = shape.width;
            height = shape.height;
        }
        if (!shape.r) ctx.rect(x, y, width, height);
        else $89fc20bca27be9e4$export$5cc7f731b5937e99(ctx, shape);
    };
    Rect.prototype.isZeroArea = function() {
        return !this.shape.width || !this.shape.height;
    };
    return Rect;
}((0, $227e31075465dcd4$export$2e2bcd8739ae039));
$42ed508a93973e78$var$Rect.prototype.type = "rect";
var $42ed508a93973e78$export$2e2bcd8739ae039 = $42ed508a93973e78$var$Rect;





var $7db7960d25b39b7c$var$DEFAULT_RICH_TEXT_COLOR = {
    fill: "#000"
};
var $7db7960d25b39b7c$var$DEFAULT_STROKE_LINE_WIDTH = 2;
var $7db7960d25b39b7c$var$tmpCITOverflowAreaOut = {};
var $7db7960d25b39b7c$export$21aaaa0607ee0e2b = {
    style: (0, $43e0a445ed6711da$export$ebe90cb607ad99e)({
        fill: true,
        stroke: true,
        fillOpacity: true,
        strokeOpacity: true,
        lineWidth: true,
        fontSize: true,
        lineHeight: true,
        width: true,
        height: true,
        textShadowColor: true,
        textShadowBlur: true,
        textShadowOffsetX: true,
        textShadowOffsetY: true,
        backgroundColor: true,
        padding: true,
        borderColor: true,
        borderWidth: true,
        borderRadius: true
    }, (0, $4773d393c538283c$export$9908943fb57fbe51).style)
};
var $7db7960d25b39b7c$var$ZRText = function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(ZRText, _super);
    function ZRText(opts) {
        var _this = _super.call(this) || this;
        _this.type = "text";
        _this._children = [];
        _this._defaultStyle = $7db7960d25b39b7c$var$DEFAULT_RICH_TEXT_COLOR;
        _this.attr(opts);
        return _this;
    }
    ZRText.prototype.childrenRef = function() {
        return this._children;
    };
    ZRText.prototype.update = function() {
        _super.prototype.update.call(this);
        if (this.styleChanged()) this._updateSubTexts();
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            child.zlevel = this.zlevel;
            child.z = this.z;
            child.z2 = this.z2;
            child.culling = this.culling;
            child.cursor = this.cursor;
            child.invisible = this.invisible;
        }
    };
    ZRText.prototype.updateTransform = function() {
        var innerTransformable = this.innerTransformable;
        if (innerTransformable) {
            innerTransformable.updateTransform();
            if (innerTransformable.transform) this.transform = innerTransformable.transform;
        } else _super.prototype.updateTransform.call(this);
    };
    ZRText.prototype.getLocalTransform = function(m) {
        var innerTransformable = this.innerTransformable;
        return innerTransformable ? innerTransformable.getLocalTransform(m) : _super.prototype.getLocalTransform.call(this, m);
    };
    ZRText.prototype.getComputedTransform = function() {
        if (this.__hostTarget) {
            this.__hostTarget.getComputedTransform();
            this.__hostTarget.updateInnerText(true);
        }
        return _super.prototype.getComputedTransform.call(this);
    };
    ZRText.prototype._updateSubTexts = function() {
        this._childCursor = 0;
        $7db7960d25b39b7c$export$176336068cc5371f(this.style);
        this.style.rich ? this._updateRichTexts() : this._updatePlainTexts();
        this._children.length = this._childCursor;
        this.styleUpdated();
    };
    ZRText.prototype.addSelfToZr = function(zr) {
        _super.prototype.addSelfToZr.call(this, zr);
        for(var i = 0; i < this._children.length; i++)this._children[i].__zr = zr;
    };
    ZRText.prototype.removeSelfFromZr = function(zr) {
        _super.prototype.removeSelfFromZr.call(this, zr);
        for(var i = 0; i < this._children.length; i++)this._children[i].__zr = null;
    };
    ZRText.prototype.getBoundingRect = function() {
        if (this.styleChanged()) this._updateSubTexts();
        if (!this._rect) {
            var tmpRect = new (0, $c437f598d9c9ee16$export$2e2bcd8739ae039)(0, 0, 0, 0);
            var children = this._children;
            var tmpMat = [];
            var rect = null;
            for(var i = 0; i < children.length; i++){
                var child = children[i];
                var childRect = child.getBoundingRect();
                var transform = child.getLocalTransform(tmpMat);
                if (transform) {
                    tmpRect.copy(childRect);
                    tmpRect.applyTransform(transform);
                    rect = rect || tmpRect.clone();
                    rect.union(tmpRect);
                } else {
                    rect = rect || childRect.clone();
                    rect.union(childRect);
                }
            }
            this._rect = rect || tmpRect;
        }
        return this._rect;
    };
    ZRText.prototype.setDefaultTextStyle = function(defaultTextStyle) {
        this._defaultStyle = defaultTextStyle || $7db7960d25b39b7c$var$DEFAULT_RICH_TEXT_COLOR;
    };
    ZRText.prototype.setTextContent = function(textContent) {};
    ZRText.prototype._mergeStyle = function(targetStyle, sourceStyle) {
        if (!sourceStyle) return targetStyle;
        var sourceRich = sourceStyle.rich;
        var targetRich = targetStyle.rich || sourceRich && {};
        (0, $43e0a445ed6711da$export$8b58be045bf06082)(targetStyle, sourceStyle);
        if (sourceRich && targetRich) {
            this._mergeRich(targetRich, sourceRich);
            targetStyle.rich = targetRich;
        } else if (targetRich) targetStyle.rich = targetRich;
        return targetStyle;
    };
    ZRText.prototype._mergeRich = function(targetRich, sourceRich) {
        var richNames = (0, $43e0a445ed6711da$export$ed97f33186d4b816)(sourceRich);
        for(var i = 0; i < richNames.length; i++){
            var richName = richNames[i];
            targetRich[richName] = targetRich[richName] || {};
            (0, $43e0a445ed6711da$export$8b58be045bf06082)(targetRich[richName], sourceRich[richName]);
        }
    };
    ZRText.prototype.getAnimationStyleProps = function() {
        return $7db7960d25b39b7c$export$21aaaa0607ee0e2b;
    };
    ZRText.prototype._getOrCreateChild = function(Ctor) {
        var child = this._children[this._childCursor];
        if (!child || !(child instanceof Ctor)) child = new Ctor();
        this._children[this._childCursor++] = child;
        child.__zr = this.__zr;
        child.parent = this;
        return child;
    };
    ZRText.prototype._updatePlainTexts = function() {
        var style = this.style;
        var textFont = style.font || (0, $08c3209e6efc839a$export$7d7a232b6d2cc80c);
        var textPadding = style.padding;
        var defaultStyle = this._defaultStyle;
        var baseX = style.x || 0;
        var baseY = style.y || 0;
        var textAlign = style.align || defaultStyle.align || "left";
        var verticalAlign = style.verticalAlign || defaultStyle.verticalAlign || "top";
        (0, $92d383513c7738d1$export$9a4428591d825b14)($7db7960d25b39b7c$var$tmpCITOverflowAreaOut, defaultStyle.overflowRect, baseX, baseY, textAlign, verticalAlign);
        baseX = $7db7960d25b39b7c$var$tmpCITOverflowAreaOut.baseX;
        baseY = $7db7960d25b39b7c$var$tmpCITOverflowAreaOut.baseY;
        var text = $7db7960d25b39b7c$var$getStyleText(style);
        var contentBlock = (0, $92d383513c7738d1$export$5772575e34ef80f9)(text, style, $7db7960d25b39b7c$var$tmpCITOverflowAreaOut.outerWidth, $7db7960d25b39b7c$var$tmpCITOverflowAreaOut.outerHeight);
        var needDrawBg = $7db7960d25b39b7c$var$needDrawBackground(style);
        var bgColorDrawn = !!style.backgroundColor;
        var outerHeight = contentBlock.outerHeight;
        var outerWidth = contentBlock.outerWidth;
        var textLines = contentBlock.lines;
        var lineHeight = contentBlock.lineHeight;
        this.isTruncated = !!contentBlock.isTruncated;
        var textX = baseX;
        var textY = (0, $67e15a06bdb46d49$export$bf7d6802d2badd9)(baseY, contentBlock.contentHeight, verticalAlign);
        if (needDrawBg || textPadding) {
            var boxX = (0, $67e15a06bdb46d49$export$eb5a525ef00ef9a4)(baseX, outerWidth, textAlign);
            var boxY = (0, $67e15a06bdb46d49$export$bf7d6802d2badd9)(baseY, outerHeight, verticalAlign);
            needDrawBg && this._renderBackground(style, style, boxX, boxY, outerWidth, outerHeight);
        }
        textY += lineHeight / 2;
        if (textPadding) {
            textX = $7db7960d25b39b7c$var$getTextXForPadding(baseX, textAlign, textPadding);
            if (verticalAlign === "top") textY += textPadding[0];
            else if (verticalAlign === "bottom") textY -= textPadding[2];
        }
        var defaultLineWidth = 0;
        var usingDefaultStroke = false;
        var useDefaultFill = false;
        var textFill = $7db7960d25b39b7c$var$getFill("fill" in style ? style.fill : (useDefaultFill = true, defaultStyle.fill));
        var textStroke = $7db7960d25b39b7c$var$getStroke("stroke" in style ? style.stroke : !bgColorDrawn && (!defaultStyle.autoStroke || useDefaultFill) ? (defaultLineWidth = $7db7960d25b39b7c$var$DEFAULT_STROKE_LINE_WIDTH, usingDefaultStroke = true, defaultStyle.stroke) : null);
        var hasShadow = style.textShadowBlur > 0;
        for(var i = 0; i < textLines.length; i++){
            var el = this._getOrCreateChild((0, $f2b3c07e83bf5376$export$2e2bcd8739ae039));
            var subElStyle = el.createStyle();
            el.useStyle(subElStyle);
            subElStyle.text = textLines[i];
            subElStyle.x = textX;
            subElStyle.y = textY;
            if (textAlign) subElStyle.textAlign = textAlign;
            subElStyle.textBaseline = "middle";
            subElStyle.opacity = style.opacity;
            subElStyle.strokeFirst = true;
            if (hasShadow) {
                subElStyle.shadowBlur = style.textShadowBlur || 0;
                subElStyle.shadowColor = style.textShadowColor || "transparent";
                subElStyle.shadowOffsetX = style.textShadowOffsetX || 0;
                subElStyle.shadowOffsetY = style.textShadowOffsetY || 0;
            }
            subElStyle.stroke = textStroke;
            subElStyle.fill = textFill;
            if (textStroke) {
                subElStyle.lineWidth = style.lineWidth || defaultLineWidth;
                subElStyle.lineDash = style.lineDash;
                subElStyle.lineDashOffset = style.lineDashOffset || 0;
            }
            subElStyle.font = textFont;
            $7db7960d25b39b7c$var$setSeparateFont(subElStyle, style);
            textY += lineHeight;
            el.setBoundingRect((0, $92d383513c7738d1$export$bd5d12d7bf7c9027)(subElStyle, contentBlock.contentWidth, contentBlock.calculatedLineHeight, usingDefaultStroke ? 0 : null));
        }
    };
    ZRText.prototype._updateRichTexts = function() {
        var style = this.style;
        var defaultStyle = this._defaultStyle;
        var textAlign = style.align || defaultStyle.align;
        var verticalAlign = style.verticalAlign || defaultStyle.verticalAlign;
        var baseX = style.x || 0;
        var baseY = style.y || 0;
        (0, $92d383513c7738d1$export$9a4428591d825b14)($7db7960d25b39b7c$var$tmpCITOverflowAreaOut, defaultStyle.overflowRect, baseX, baseY, textAlign, verticalAlign);
        baseX = $7db7960d25b39b7c$var$tmpCITOverflowAreaOut.baseX;
        baseY = $7db7960d25b39b7c$var$tmpCITOverflowAreaOut.baseY;
        var text = $7db7960d25b39b7c$var$getStyleText(style);
        var contentBlock = (0, $92d383513c7738d1$export$15ec9472ff2d721)(text, style, $7db7960d25b39b7c$var$tmpCITOverflowAreaOut.outerWidth, $7db7960d25b39b7c$var$tmpCITOverflowAreaOut.outerHeight, textAlign);
        var contentWidth = contentBlock.width;
        var outerWidth = contentBlock.outerWidth;
        var outerHeight = contentBlock.outerHeight;
        var textPadding = style.padding;
        this.isTruncated = !!contentBlock.isTruncated;
        var boxX = (0, $67e15a06bdb46d49$export$eb5a525ef00ef9a4)(baseX, outerWidth, textAlign);
        var boxY = (0, $67e15a06bdb46d49$export$bf7d6802d2badd9)(baseY, outerHeight, verticalAlign);
        var xLeft = boxX;
        var lineTop = boxY;
        if (textPadding) {
            xLeft += textPadding[3];
            lineTop += textPadding[0];
        }
        var xRight = xLeft + contentWidth;
        if ($7db7960d25b39b7c$var$needDrawBackground(style)) this._renderBackground(style, style, boxX, boxY, outerWidth, outerHeight);
        var bgColorDrawn = !!style.backgroundColor;
        for(var i = 0; i < contentBlock.lines.length; i++){
            var line = contentBlock.lines[i];
            var tokens = line.tokens;
            var tokenCount = tokens.length;
            var lineHeight = line.lineHeight;
            var remainedWidth = line.width;
            var leftIndex = 0;
            var lineXLeft = xLeft;
            var lineXRight = xRight;
            var rightIndex = tokenCount - 1;
            var token = void 0;
            while(leftIndex < tokenCount && (token = tokens[leftIndex], !token.align || token.align === "left")){
                this._placeToken(token, style, lineHeight, lineTop, lineXLeft, "left", bgColorDrawn);
                remainedWidth -= token.width;
                lineXLeft += token.width;
                leftIndex++;
            }
            while(rightIndex >= 0 && (token = tokens[rightIndex], token.align === "right")){
                this._placeToken(token, style, lineHeight, lineTop, lineXRight, "right", bgColorDrawn);
                remainedWidth -= token.width;
                lineXRight -= token.width;
                rightIndex--;
            }
            lineXLeft += (contentWidth - (lineXLeft - xLeft) - (xRight - lineXRight) - remainedWidth) / 2;
            while(leftIndex <= rightIndex){
                token = tokens[leftIndex];
                this._placeToken(token, style, lineHeight, lineTop, lineXLeft + token.width / 2, "center", bgColorDrawn);
                lineXLeft += token.width;
                leftIndex++;
            }
            lineTop += lineHeight;
        }
    };
    ZRText.prototype._placeToken = function(token, style, lineHeight, lineTop, x, textAlign, parentBgColorDrawn) {
        var tokenStyle = style.rich[token.styleName] || {};
        tokenStyle.text = token.text;
        var verticalAlign = token.verticalAlign;
        var y = lineTop + lineHeight / 2;
        if (verticalAlign === "top") y = lineTop + token.height / 2;
        else if (verticalAlign === "bottom") y = lineTop + lineHeight - token.height / 2;
        var needDrawBg = !token.isLineHolder && $7db7960d25b39b7c$var$needDrawBackground(tokenStyle);
        needDrawBg && this._renderBackground(tokenStyle, style, textAlign === "right" ? x - token.width : textAlign === "center" ? x - token.width / 2 : x, y - token.height / 2, token.width, token.height);
        var bgColorDrawn = !!tokenStyle.backgroundColor;
        var textPadding = token.textPadding;
        if (textPadding) {
            x = $7db7960d25b39b7c$var$getTextXForPadding(x, textAlign, textPadding);
            y -= token.height / 2 - textPadding[0] - token.innerHeight / 2;
        }
        var el = this._getOrCreateChild((0, $f2b3c07e83bf5376$export$2e2bcd8739ae039));
        var subElStyle = el.createStyle();
        el.useStyle(subElStyle);
        var defaultStyle = this._defaultStyle;
        var useDefaultFill = false;
        var defaultLineWidth = 0;
        var usingDefaultStroke = false;
        var textFill = $7db7960d25b39b7c$var$getFill("fill" in tokenStyle ? tokenStyle.fill : "fill" in style ? style.fill : (useDefaultFill = true, defaultStyle.fill));
        var textStroke = $7db7960d25b39b7c$var$getStroke("stroke" in tokenStyle ? tokenStyle.stroke : "stroke" in style ? style.stroke : !bgColorDrawn && !parentBgColorDrawn && (!defaultStyle.autoStroke || useDefaultFill) ? (defaultLineWidth = $7db7960d25b39b7c$var$DEFAULT_STROKE_LINE_WIDTH, usingDefaultStroke = true, defaultStyle.stroke) : null);
        var hasShadow = tokenStyle.textShadowBlur > 0 || style.textShadowBlur > 0;
        subElStyle.text = token.text;
        subElStyle.x = x;
        subElStyle.y = y;
        if (hasShadow) {
            subElStyle.shadowBlur = tokenStyle.textShadowBlur || style.textShadowBlur || 0;
            subElStyle.shadowColor = tokenStyle.textShadowColor || style.textShadowColor || "transparent";
            subElStyle.shadowOffsetX = tokenStyle.textShadowOffsetX || style.textShadowOffsetX || 0;
            subElStyle.shadowOffsetY = tokenStyle.textShadowOffsetY || style.textShadowOffsetY || 0;
        }
        subElStyle.textAlign = textAlign;
        subElStyle.textBaseline = "middle";
        subElStyle.font = token.font || (0, $08c3209e6efc839a$export$7d7a232b6d2cc80c);
        subElStyle.opacity = (0, $43e0a445ed6711da$export$2e94551289abb95b)(tokenStyle.opacity, style.opacity, 1);
        $7db7960d25b39b7c$var$setSeparateFont(subElStyle, tokenStyle);
        if (textStroke) {
            subElStyle.lineWidth = (0, $43e0a445ed6711da$export$2e94551289abb95b)(tokenStyle.lineWidth, style.lineWidth, defaultLineWidth);
            subElStyle.lineDash = (0, $43e0a445ed6711da$export$995e01f2f5c9d030)(tokenStyle.lineDash, style.lineDash);
            subElStyle.lineDashOffset = style.lineDashOffset || 0;
            subElStyle.stroke = textStroke;
        }
        if (textFill) subElStyle.fill = textFill;
        el.setBoundingRect((0, $92d383513c7738d1$export$bd5d12d7bf7c9027)(subElStyle, token.contentWidth, token.contentHeight, usingDefaultStroke ? 0 : null));
    };
    ZRText.prototype._renderBackground = function(style, topStyle, x, y, width, height) {
        var textBackgroundColor = style.backgroundColor;
        var textBorderWidth = style.borderWidth;
        var textBorderColor = style.borderColor;
        var isImageBg = textBackgroundColor && textBackgroundColor.image;
        var isPlainOrGradientBg = textBackgroundColor && !isImageBg;
        var textBorderRadius = style.borderRadius;
        var self = this;
        var rectEl;
        var imgEl;
        if (isPlainOrGradientBg || style.lineHeight || textBorderWidth && textBorderColor) {
            rectEl = this._getOrCreateChild((0, $42ed508a93973e78$export$2e2bcd8739ae039));
            rectEl.useStyle(rectEl.createStyle());
            rectEl.style.fill = null;
            var rectShape = rectEl.shape;
            rectShape.x = x;
            rectShape.y = y;
            rectShape.width = width;
            rectShape.height = height;
            rectShape.r = textBorderRadius;
            rectEl.dirtyShape();
        }
        if (isPlainOrGradientBg) {
            var rectStyle = rectEl.style;
            rectStyle.fill = textBackgroundColor || null;
            rectStyle.fillOpacity = (0, $43e0a445ed6711da$export$995e01f2f5c9d030)(style.fillOpacity, 1);
        } else if (isImageBg) {
            imgEl = this._getOrCreateChild((0, $d3b0315ae8e8e298$export$2e2bcd8739ae039));
            imgEl.onload = function() {
                self.dirtyStyle();
            };
            var imgStyle = imgEl.style;
            imgStyle.image = textBackgroundColor.image;
            imgStyle.x = x;
            imgStyle.y = y;
            imgStyle.width = width;
            imgStyle.height = height;
        }
        if (textBorderWidth && textBorderColor) {
            var rectStyle = rectEl.style;
            rectStyle.lineWidth = textBorderWidth;
            rectStyle.stroke = textBorderColor;
            rectStyle.strokeOpacity = (0, $43e0a445ed6711da$export$995e01f2f5c9d030)(style.strokeOpacity, 1);
            rectStyle.lineDash = style.borderDash;
            rectStyle.lineDashOffset = style.borderDashOffset || 0;
            rectEl.strokeContainThreshold = 0;
            if (rectEl.hasFill() && rectEl.hasStroke()) {
                rectStyle.strokeFirst = true;
                rectStyle.lineWidth *= 2;
            }
        }
        var commonStyle = (rectEl || imgEl).style;
        commonStyle.shadowBlur = style.shadowBlur || 0;
        commonStyle.shadowColor = style.shadowColor || "transparent";
        commonStyle.shadowOffsetX = style.shadowOffsetX || 0;
        commonStyle.shadowOffsetY = style.shadowOffsetY || 0;
        commonStyle.opacity = (0, $43e0a445ed6711da$export$2e94551289abb95b)(style.opacity, topStyle.opacity, 1);
    };
    ZRText.makeFont = function(style) {
        var font = "";
        if ($7db7960d25b39b7c$export$4685c95d5118e76a(style)) font = [
            style.fontStyle,
            style.fontWeight,
            $7db7960d25b39b7c$export$51b066d9cfc2578e(style.fontSize),
            style.fontFamily || "sans-serif"
        ].join(" ");
        return font && (0, $43e0a445ed6711da$export$87c2784dc9fc4ab)(font) || style.textFont || style.font;
    };
    return ZRText;
}((0, $4773d393c538283c$export$2e2bcd8739ae039));
var $7db7960d25b39b7c$var$VALID_TEXT_ALIGN = {
    left: true,
    right: 1,
    center: 1
};
var $7db7960d25b39b7c$var$VALID_TEXT_VERTICAL_ALIGN = {
    top: 1,
    bottom: 1,
    middle: 1
};
var $7db7960d25b39b7c$var$FONT_PARTS = [
    "fontStyle",
    "fontWeight",
    "fontSize",
    "fontFamily"
];
function $7db7960d25b39b7c$export$51b066d9cfc2578e(fontSize) {
    if (typeof fontSize === "string" && (fontSize.indexOf("px") !== -1 || fontSize.indexOf("rem") !== -1 || fontSize.indexOf("em") !== -1)) return fontSize;
    else if (!isNaN(+fontSize)) return fontSize + "px";
    else return (0, $08c3209e6efc839a$export$b1461457ea2c1179) + "px";
}
function $7db7960d25b39b7c$var$setSeparateFont(targetStyle, sourceStyle) {
    for(var i = 0; i < $7db7960d25b39b7c$var$FONT_PARTS.length; i++){
        var fontProp = $7db7960d25b39b7c$var$FONT_PARTS[i];
        var val = sourceStyle[fontProp];
        if (val != null) targetStyle[fontProp] = val;
    }
}
function $7db7960d25b39b7c$export$4685c95d5118e76a(style) {
    return style.fontSize != null || style.fontFamily || style.fontWeight;
}
function $7db7960d25b39b7c$export$176336068cc5371f(style) {
    $7db7960d25b39b7c$var$normalizeStyle(style);
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)(style.rich, $7db7960d25b39b7c$var$normalizeStyle);
    return style;
}
function $7db7960d25b39b7c$var$normalizeStyle(style) {
    if (style) {
        style.font = $7db7960d25b39b7c$var$ZRText.makeFont(style);
        var textAlign = style.align;
        textAlign === "middle" && (textAlign = "center");
        style.align = textAlign == null || $7db7960d25b39b7c$var$VALID_TEXT_ALIGN[textAlign] ? textAlign : "left";
        var verticalAlign = style.verticalAlign;
        verticalAlign === "center" && (verticalAlign = "middle");
        style.verticalAlign = verticalAlign == null || $7db7960d25b39b7c$var$VALID_TEXT_VERTICAL_ALIGN[verticalAlign] ? verticalAlign : "top";
        var textPadding = style.padding;
        if (textPadding) style.padding = (0, $43e0a445ed6711da$export$f3a38102c49f4268)(style.padding);
    }
}
function $7db7960d25b39b7c$var$getStroke(stroke, lineWidth) {
    return stroke == null || lineWidth <= 0 || stroke === "transparent" || stroke === "none" ? null : stroke.image || stroke.colorStops ? "#000" : stroke;
}
function $7db7960d25b39b7c$var$getFill(fill) {
    return fill == null || fill === "none" ? null : fill.image || fill.colorStops ? "#000" : fill;
}
function $7db7960d25b39b7c$var$getTextXForPadding(x, textAlign, textPadding) {
    return textAlign === "right" ? x - textPadding[1] : textAlign === "center" ? x + textPadding[3] / 2 - textPadding[1] / 2 : x + textPadding[3];
}
function $7db7960d25b39b7c$var$getStyleText(style) {
    var text = style.text;
    text != null && (text += "");
    return text;
}
function $7db7960d25b39b7c$var$needDrawBackground(style) {
    return !!(style.backgroundColor || style.lineHeight || style.borderWidth && style.borderColor);
}
var $7db7960d25b39b7c$export$2e2bcd8739ae039 = $7db7960d25b39b7c$var$ZRText;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $7e4afcfca8f5121f$export$b1c39b2bacd1ddc2 = (0, $87f4a59ac66e0ee6$export$64df9f8d92ae083f)();
var $7e4afcfca8f5121f$export$30d6736ebb8e18d5 = function(seriesIndex, dataType, dataIdx, el) {
    if (el) {
        var ecData = $7e4afcfca8f5121f$export$b1c39b2bacd1ddc2(el);
        // Add data index and series index for indexing the data by element
        // Useful in tooltip
        ecData.dataIndex = dataIdx;
        ecData.dataType = dataType;
        ecData.seriesIndex = seriesIndex;
        ecData.ssrType = "chart";
        // TODO: not store dataIndex on children.
        if (el.type === "group") el.traverse(function(child) {
            var childECData = $7e4afcfca8f5121f$export$b1c39b2bacd1ddc2(child);
            childECData.seriesIndex = seriesIndex;
            childECData.dataIndex = dataIdx;
            childECData.dataType = dataType;
            childECData.ssrType = "chart";
        });
    }
};





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bde9c82f7837f767$export$5ba2cba1cb566d7a = "undefined";
var $bde9c82f7837f767$export$68ebcbce21494007 = "series";
var $bde9c82f7837f767$export$cd51b5ca77f6f0e4 = (0, $43e0a445ed6711da$export$55f8aa7ef875b0a4)([
    "tooltip",
    "label",
    "itemName",
    "itemId",
    "itemGroupId",
    "itemChildGroupId",
    "seriesName"
]);
var $bde9c82f7837f767$export$2823037fb9d8f0c6 = "original";
var $bde9c82f7837f767$export$fcd62ebf51387903 = "arrayRows";
var $bde9c82f7837f767$export$703ae8a2d83f441 = "objectRows";
var $bde9c82f7837f767$export$6a32b42c754a3cb8 = "keyedColumns";
var $bde9c82f7837f767$export$a918cb016a382d45 = "typedArray";
var $bde9c82f7837f767$export$c78f1330778d30d = "unknown";
var $bde9c82f7837f767$export$7b3f3c6551b4949b = "column";
var $bde9c82f7837f767$export$d55da1467cdf7804 = "row";
var $bde9c82f7837f767$export$4ca176c09704a32 = "Roam";


var $00f59fca90c489d2$var$availableMethods = [
    "getDom",
    "getZr",
    "getWidth",
    "getHeight",
    "getDevicePixelRatio",
    "dispatchAction",
    "isSSR",
    "isDisposed",
    "on",
    "off",
    "getDataURL",
    "getConnectedDataURL",
    // 'getModel',
    "getOption",
    // 'getViewOfComponentModel',
    // 'getViewOfSeriesModel',
    "getId",
    "updateLabelLayout"
];
var $00f59fca90c489d2$var$ExtensionAPI = /** @class */ function() {
    function ExtensionAPI(ecInstance) {
        $43e0a445ed6711da$export$79b2f7037acddd43($00f59fca90c489d2$var$availableMethods, function(methodName) {
            this[methodName] = $43e0a445ed6711da$export$2385a24977818dd0(ecInstance[methodName], ecInstance);
        }, this);
    }
    return ExtensionAPI;
}();
function $00f59fca90c489d2$export$2b32bcfeffd624a6(api, componentOrSeries) {
    return componentOrSeries.mainType === (0, $bde9c82f7837f767$export$68ebcbce21494007) ? api.getViewOfSeriesModel(componentOrSeries) : api.getViewOfComponentModel(componentOrSeries);
}
var $00f59fca90c489d2$export$2e2bcd8739ae039 = $00f59fca90c489d2$var$ExtensionAPI;



// Reserve 0 as default.
var $fffc76734a157b4c$var$_highlightNextDigit = 1;
var $fffc76734a157b4c$var$_highlightKeyMap = {};
var $fffc76734a157b4c$var$getSavedStates = (0, $87f4a59ac66e0ee6$export$64df9f8d92ae083f)();
var $fffc76734a157b4c$var$getComponentStates = (0, $87f4a59ac66e0ee6$export$64df9f8d92ae083f)();
var $fffc76734a157b4c$export$5542daa30722333e = 0;
var $fffc76734a157b4c$export$1307d6a87d56baa = 1;
var $fffc76734a157b4c$export$f0f2bee145debb31 = 2;
var $fffc76734a157b4c$export$151308dceb52d5b = [
    "emphasis",
    "blur",
    "select"
];
var $fffc76734a157b4c$export$57ee5306b85ad7d5 = [
    "normal",
    "emphasis",
    "blur",
    "select"
];
var $fffc76734a157b4c$export$1cb9fc6ed5b9836c = 10;
var $fffc76734a157b4c$export$3a2f97d39514bbc = 9;
var $fffc76734a157b4c$export$df035d873a9de64f = "highlight";
var $fffc76734a157b4c$export$f8a2f7807cc185ea = "downplay";
var $fffc76734a157b4c$export$89616263e7d38fe9 = "select";
var $fffc76734a157b4c$export$7636ad95c0f68a79 = "unselect";
var $fffc76734a157b4c$export$1e90ed8a25542516 = "toggleSelect";
var $fffc76734a157b4c$export$67f8c62bcdfbd39f = "selectchanged";
function $fffc76734a157b4c$var$hasFillOrStroke(fillOrStroke) {
    return fillOrStroke != null && fillOrStroke !== "none";
}
function $fffc76734a157b4c$var$doChangeHoverState(el, stateName, hoverStateEnum) {
    if (el.onHoverStateChange && (el.hoverState || 0) !== hoverStateEnum) el.onHoverStateChange(stateName);
    el.hoverState = hoverStateEnum;
}
function $fffc76734a157b4c$var$singleEnterEmphasis(el) {
    // Only mark the flag.
    // States will be applied in the echarts.ts in next frame.
    $fffc76734a157b4c$var$doChangeHoverState(el, "emphasis", $fffc76734a157b4c$export$f0f2bee145debb31);
}
function $fffc76734a157b4c$var$singleLeaveEmphasis(el) {
    // Only mark the flag.
    // States will be applied in the echarts.ts in next frame.
    if (el.hoverState === $fffc76734a157b4c$export$f0f2bee145debb31) $fffc76734a157b4c$var$doChangeHoverState(el, "normal", $fffc76734a157b4c$export$5542daa30722333e);
}
function $fffc76734a157b4c$var$singleEnterBlur(el) {
    $fffc76734a157b4c$var$doChangeHoverState(el, "blur", $fffc76734a157b4c$export$1307d6a87d56baa);
}
function $fffc76734a157b4c$var$singleLeaveBlur(el) {
    if (el.hoverState === $fffc76734a157b4c$export$1307d6a87d56baa) $fffc76734a157b4c$var$doChangeHoverState(el, "normal", $fffc76734a157b4c$export$5542daa30722333e);
}
function $fffc76734a157b4c$var$singleEnterSelect(el) {
    el.selected = true;
}
function $fffc76734a157b4c$var$singleLeaveSelect(el) {
    el.selected = false;
}
function $fffc76734a157b4c$var$updateElementState(el, updater, commonParam) {
    updater(el, commonParam);
}
function $fffc76734a157b4c$var$traverseUpdateState(el, updater, commonParam) {
    $fffc76734a157b4c$var$updateElementState(el, updater, commonParam);
    el.isGroup && el.traverse(function(child) {
        $fffc76734a157b4c$var$updateElementState(child, updater, commonParam);
    });
}
function $fffc76734a157b4c$export$868ba38adffa9e39(el, stateName) {
    switch(stateName){
        case "emphasis":
            el.hoverState = $fffc76734a157b4c$export$f0f2bee145debb31;
            break;
        case "normal":
            el.hoverState = $fffc76734a157b4c$export$5542daa30722333e;
            break;
        case "blur":
            el.hoverState = $fffc76734a157b4c$export$1307d6a87d56baa;
            break;
        case "select":
            el.selected = true;
    }
}
function $fffc76734a157b4c$export$35330f949342a669(el) {
    if (el.isGroup) el.traverse(function(child) {
        child.clearStates();
    });
    else el.clearStates();
}
function $fffc76734a157b4c$var$getFromStateStyle(el, props, toStateName, defaultValue) {
    var style = el.style;
    var fromState = {};
    for(var i = 0; i < props.length; i++){
        var propName = props[i];
        var val = style[propName];
        fromState[propName] = val == null ? defaultValue && defaultValue[propName] : val;
    }
    for(var i = 0; i < el.animators.length; i++){
        var animator = el.animators[i];
        if (animator.__fromStateTransition && animator.__fromStateTransition.indexOf(toStateName) < 0 && animator.targetName === "style") animator.saveTo(fromState, props);
    }
    return fromState;
}
function $fffc76734a157b4c$var$createEmphasisDefaultState(el, stateName, targetStates, state) {
    var hasSelect = targetStates && (0, $43e0a445ed6711da$export$305f7d4e9d4624f2)(targetStates, "select") >= 0;
    var cloned = false;
    if (el instanceof (0, $227e31075465dcd4$export$2e2bcd8739ae039)) {
        var store = $fffc76734a157b4c$var$getSavedStates(el);
        var fromFill = hasSelect ? store.selectFill || store.normalFill : store.normalFill;
        var fromStroke = hasSelect ? store.selectStroke || store.normalStroke : store.normalStroke;
        if ($fffc76734a157b4c$var$hasFillOrStroke(fromFill) || $fffc76734a157b4c$var$hasFillOrStroke(fromStroke)) {
            state = state || {};
            var emphasisStyle = state.style || {};
            // inherit case
            if (emphasisStyle.fill === "inherit") {
                cloned = true;
                state = (0, $43e0a445ed6711da$export$8b58be045bf06082)({}, state);
                emphasisStyle = (0, $43e0a445ed6711da$export$8b58be045bf06082)({}, emphasisStyle);
                emphasisStyle.fill = fromFill;
            } else if (!$fffc76734a157b4c$var$hasFillOrStroke(emphasisStyle.fill) && $fffc76734a157b4c$var$hasFillOrStroke(fromFill)) {
                cloned = true;
                // Not modify the original value.
                state = (0, $43e0a445ed6711da$export$8b58be045bf06082)({}, state);
                emphasisStyle = (0, $43e0a445ed6711da$export$8b58be045bf06082)({}, emphasisStyle);
                // Already being applied 'emphasis'. DON'T lift color multiple times.
                emphasisStyle.fill = (0, $b0979f18b0a232f9$export$2b47e247dfb87a73)(fromFill);
            } else if (!$fffc76734a157b4c$var$hasFillOrStroke(emphasisStyle.stroke) && $fffc76734a157b4c$var$hasFillOrStroke(fromStroke)) {
                if (!cloned) {
                    state = (0, $43e0a445ed6711da$export$8b58be045bf06082)({}, state);
                    emphasisStyle = (0, $43e0a445ed6711da$export$8b58be045bf06082)({}, emphasisStyle);
                }
                emphasisStyle.stroke = (0, $b0979f18b0a232f9$export$2b47e247dfb87a73)(fromStroke);
            }
            state.style = emphasisStyle;
        }
    }
    if (state) // TODO Share with textContent?
    {
        if (state.z2 == null) {
            if (!cloned) state = (0, $43e0a445ed6711da$export$8b58be045bf06082)({}, state);
            var z2EmphasisLift = el.z2EmphasisLift;
            state.z2 = el.z2 + (z2EmphasisLift != null ? z2EmphasisLift : $fffc76734a157b4c$export$1cb9fc6ed5b9836c);
        }
    }
    return state;
}
function $fffc76734a157b4c$var$createSelectDefaultState(el, stateName, state) {
    // const hasSelect = indexOf(el.currentStates, stateName) >= 0;
    if (state) // TODO Share with textContent?
    {
        if (state.z2 == null) {
            state = (0, $43e0a445ed6711da$export$8b58be045bf06082)({}, state);
            var z2SelectLift = el.z2SelectLift;
            state.z2 = el.z2 + (z2SelectLift != null ? z2SelectLift : $fffc76734a157b4c$export$3a2f97d39514bbc);
        }
    }
    return state;
}
function $fffc76734a157b4c$var$createBlurDefaultState(el, stateName, state) {
    var hasBlur = (0, $43e0a445ed6711da$export$305f7d4e9d4624f2)(el.currentStates, stateName) >= 0;
    var currentOpacity = el.style.opacity;
    var fromState = !hasBlur ? $fffc76734a157b4c$var$getFromStateStyle(el, [
        "opacity"
    ], stateName, {
        opacity: 1
    }) : null;
    state = state || {};
    var blurStyle = state.style || {};
    if (blurStyle.opacity == null) {
        // clone state
        state = (0, $43e0a445ed6711da$export$8b58be045bf06082)({}, state);
        blurStyle = (0, $43e0a445ed6711da$export$8b58be045bf06082)({
            // Already being applied 'emphasis'. DON'T mul opacity multiple times.
            opacity: hasBlur ? currentOpacity : fromState.opacity * 0.1
        }, blurStyle);
        state.style = blurStyle;
    }
    return state;
}
function $fffc76734a157b4c$var$elementStateProxy(stateName, targetStates) {
    var state = this.states[stateName];
    if (this.style) {
        if (stateName === "emphasis") return $fffc76734a157b4c$var$createEmphasisDefaultState(this, stateName, targetStates, state);
        else if (stateName === "blur") return $fffc76734a157b4c$var$createBlurDefaultState(this, stateName, state);
        else if (stateName === "select") return $fffc76734a157b4c$var$createSelectDefaultState(this, stateName, state);
    }
    return state;
}
function $fffc76734a157b4c$export$20f39bbe322fb9ab(el) {
    el.stateProxy = $fffc76734a157b4c$var$elementStateProxy;
    var textContent = el.getTextContent();
    var textGuide = el.getTextGuideLine();
    if (textContent) textContent.stateProxy = $fffc76734a157b4c$var$elementStateProxy;
    if (textGuide) textGuide.stateProxy = $fffc76734a157b4c$var$elementStateProxy;
}
function $fffc76734a157b4c$export$d899507e2598e4ae(el, e) {
    !$fffc76734a157b4c$var$shouldSilent(el, e) && !el.__highByOuter && $fffc76734a157b4c$var$traverseUpdateState(el, $fffc76734a157b4c$var$singleEnterEmphasis);
}
function $fffc76734a157b4c$export$784cba1f7fe58cca(el, e) {
    !$fffc76734a157b4c$var$shouldSilent(el, e) && !el.__highByOuter && $fffc76734a157b4c$var$traverseUpdateState(el, $fffc76734a157b4c$var$singleLeaveEmphasis);
}
function $fffc76734a157b4c$export$b2d02638cc34c042(el, highlightDigit) {
    el.__highByOuter |= 1 << (highlightDigit || 0);
    $fffc76734a157b4c$var$traverseUpdateState(el, $fffc76734a157b4c$var$singleEnterEmphasis);
}
function $fffc76734a157b4c$export$11be6f716239ac55(el, highlightDigit) {
    !(el.__highByOuter &= ~(1 << (highlightDigit || 0))) && $fffc76734a157b4c$var$traverseUpdateState(el, $fffc76734a157b4c$var$singleLeaveEmphasis);
}
function $fffc76734a157b4c$export$207f9cb3e1099375(el) {
    $fffc76734a157b4c$var$traverseUpdateState(el, $fffc76734a157b4c$var$singleEnterBlur);
}
function $fffc76734a157b4c$export$fd4a9ec75456d3c1(el) {
    $fffc76734a157b4c$var$traverseUpdateState(el, $fffc76734a157b4c$var$singleLeaveBlur);
}
function $fffc76734a157b4c$export$252d028dda8ef765(el) {
    $fffc76734a157b4c$var$traverseUpdateState(el, $fffc76734a157b4c$var$singleEnterSelect);
}
function $fffc76734a157b4c$export$ea9a904bd6e32bd3(el) {
    $fffc76734a157b4c$var$traverseUpdateState(el, $fffc76734a157b4c$var$singleLeaveSelect);
}
function $fffc76734a157b4c$var$shouldSilent(el, e) {
    return el.__highDownSilentOnTouch && e.zrByTouch;
}
function $fffc76734a157b4c$export$b2a593c7b5243584(api) {
    var model = api.getModel();
    var leaveBlurredSeries = [];
    var allComponentViews = [];
    model.eachComponent(function(componentType, componentModel) {
        var componentStates = $fffc76734a157b4c$var$getComponentStates(componentModel);
        var view = (0, $00f59fca90c489d2$export$2b32bcfeffd624a6)(api, componentModel);
        var isSeries = componentType === "series";
        !isSeries && allComponentViews.push(view);
        if (componentStates.isBlured) {
            // Leave blur anyway
            view.group.traverse(function(child) {
                $fffc76734a157b4c$var$singleLeaveBlur(child);
            });
            isSeries && leaveBlurredSeries.push(componentModel);
        }
        componentStates.isBlured = false;
    });
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)(allComponentViews, function(view) {
        if (view && view.toggleBlurSeries) view.toggleBlurSeries(leaveBlurredSeries, false, model);
    });
}
function $fffc76734a157b4c$export$7d399e067d6552e3(targetSeriesIndex, focus, blurScope, api) {
    var ecModel = api.getModel();
    blurScope = blurScope || "coordinateSystem";
    function leaveBlurOfIndices(data, dataIndices) {
        for(var i = 0; i < dataIndices.length; i++){
            var itemEl = data.getItemGraphicEl(dataIndices[i]);
            itemEl && $fffc76734a157b4c$export$fd4a9ec75456d3c1(itemEl);
        }
    }
    if (targetSeriesIndex == null) return;
    if (!focus || focus === "none") return;
    var targetSeriesModel = ecModel.getSeriesByIndex(targetSeriesIndex);
    var targetCoordSys = targetSeriesModel.coordinateSystem;
    if (targetCoordSys && targetCoordSys.master) targetCoordSys = targetCoordSys.master;
    var blurredSeries = [];
    ecModel.eachSeries(function(seriesModel) {
        var sameSeries = targetSeriesModel === seriesModel;
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys && coordSys.master) coordSys = coordSys.master;
        var sameCoordSys = coordSys && targetCoordSys ? coordSys === targetCoordSys : sameSeries; // If there is no coordinate system. use sameSeries instead.
        if (!// Not blur other series if blurScope series
        (blurScope === "series" && !sameSeries || blurScope === "coordinateSystem" && !sameCoordSys || focus === "series" && sameSeries)) {
            var view = api.getViewOfSeriesModel(seriesModel);
            view.group.traverse(function(child) {
                // For the elements that have been triggered by other components,
                // and are still required to be highlighted,
                // because the current is directly forced to blur the element,
                // it will cause the focus self to be unable to highlight, so skip the blur of this element.
                if (child.__highByOuter && sameSeries && focus === "self") return;
                $fffc76734a157b4c$var$singleEnterBlur(child);
            });
            if ((0, $43e0a445ed6711da$export$1e2f57719e155213)(focus)) leaveBlurOfIndices(seriesModel.getData(), focus);
            else if ((0, $43e0a445ed6711da$export$a6cdc56e425d0d0a)(focus)) {
                var dataTypes = (0, $43e0a445ed6711da$export$ed97f33186d4b816)(focus);
                for(var d = 0; d < dataTypes.length; d++)leaveBlurOfIndices(seriesModel.getData(dataTypes[d]), focus[dataTypes[d]]);
            }
            blurredSeries.push(seriesModel);
            $fffc76734a157b4c$var$getComponentStates(seriesModel).isBlured = true;
        }
    });
    ecModel.eachComponent(function(componentType, componentModel) {
        if (componentType === "series") return;
        var view = api.getViewOfComponentModel(componentModel);
        if (view && view.toggleBlurSeries) view.toggleBlurSeries(blurredSeries, true, ecModel);
    });
}
function $fffc76734a157b4c$export$569da03256c8a55f(componentMainType, componentIndex, api) {
    if (componentMainType == null || componentIndex == null) return;
    var componentModel = api.getModel().getComponent(componentMainType, componentIndex);
    if (!componentModel) return;
    $fffc76734a157b4c$var$getComponentStates(componentModel).isBlured = true;
    var view = api.getViewOfComponentModel(componentModel);
    if (!view || !view.focusBlurEnabled) return;
    view.group.traverse(function(child) {
        $fffc76734a157b4c$var$singleEnterBlur(child);
    });
}
function $fffc76734a157b4c$export$64f1fd4daefef21b(seriesModel, payload, api) {
    var seriesIndex = seriesModel.seriesIndex;
    var data = seriesModel.getData(payload.dataType);
    if (!data) return;
    var dataIndex = (0, $87f4a59ac66e0ee6$export$42b26cae8b8d10)(data, payload);
    // Pick the first one if there is multiple/none exists.
    dataIndex = ((0, $43e0a445ed6711da$export$43bee75e5e14138e)(dataIndex) ? dataIndex[0] : dataIndex) || 0;
    var el = data.getItemGraphicEl(dataIndex);
    if (!el) {
        var count = data.count();
        var current = 0;
        // If data on dataIndex is NaN.
        while(!el && current < count)el = data.getItemGraphicEl(current++);
    }
    if (el) {
        var ecData = (0, $7e4afcfca8f5121f$export$b1c39b2bacd1ddc2)(el);
        $fffc76734a157b4c$export$7d399e067d6552e3(seriesIndex, ecData.focus, ecData.blurScope, api);
    } else {
        // If there is no element put on the data. Try getting it from raw option
        // TODO Should put it on seriesModel?
        var focus_1 = seriesModel.get([
            "emphasis",
            "focus"
        ]);
        var blurScope = seriesModel.get([
            "emphasis",
            "blurScope"
        ]);
        if (focus_1 != null) $fffc76734a157b4c$export$7d399e067d6552e3(seriesIndex, focus_1, blurScope, api);
    }
}
function $fffc76734a157b4c$export$f31a644ccca0ef23(componentMainType, componentIndex, name, api) {
    var ret = {
        focusSelf: false,
        dispatchers: null
    };
    if (componentMainType == null || componentMainType === "series" || componentIndex == null || name == null) return ret;
    var componentModel = api.getModel().getComponent(componentMainType, componentIndex);
    if (!componentModel) return ret;
    var view = api.getViewOfComponentModel(componentModel);
    if (!view || !view.findHighDownDispatchers) return ret;
    var dispatchers = view.findHighDownDispatchers(name);
    // At presnet, the component (like Geo) only blur inside itself.
    // So we do not use `blurScope` in component.
    var focusSelf;
    for(var i = 0; i < dispatchers.length; i++)if ((0, $7e4afcfca8f5121f$export$b1c39b2bacd1ddc2)(dispatchers[i]).focus === "self") {
        focusSelf = true;
        break;
    }
    return {
        focusSelf: focusSelf,
        dispatchers: dispatchers
    };
}
function $fffc76734a157b4c$export$416765b6198234ff(dispatcher, e, api) {
    var ecData = (0, $7e4afcfca8f5121f$export$b1c39b2bacd1ddc2)(dispatcher);
    var _a = $fffc76734a157b4c$export$f31a644ccca0ef23(ecData.componentMainType, ecData.componentIndex, ecData.componentHighDownName, api), dispatchers = _a.dispatchers, focusSelf = _a.focusSelf;
    // If `findHighDownDispatchers` is supported on the component,
    // highlight/downplay elements with the same name.
    if (dispatchers) {
        if (focusSelf) $fffc76734a157b4c$export$569da03256c8a55f(ecData.componentMainType, ecData.componentIndex, api);
        (0, $43e0a445ed6711da$export$79b2f7037acddd43)(dispatchers, function(dispatcher) {
            return $fffc76734a157b4c$export$d899507e2598e4ae(dispatcher, e);
        });
    } else {
        // Try blur all in the related series. Then emphasis the hoverred.
        // TODO. progressive mode.
        $fffc76734a157b4c$export$7d399e067d6552e3(ecData.seriesIndex, ecData.focus, ecData.blurScope, api);
        if (ecData.focus === "self") $fffc76734a157b4c$export$569da03256c8a55f(ecData.componentMainType, ecData.componentIndex, api);
        // Other than series, component that not support `findHighDownDispatcher` will
        // also use it. But in this case, highlight/downplay are only supported in
        // mouse hover but not in dispatchAction.
        $fffc76734a157b4c$export$d899507e2598e4ae(dispatcher, e);
    }
}
function $fffc76734a157b4c$export$bb1c7b62436282a(dispatcher, e, api) {
    $fffc76734a157b4c$export$b2a593c7b5243584(api);
    var ecData = (0, $7e4afcfca8f5121f$export$b1c39b2bacd1ddc2)(dispatcher);
    var dispatchers = $fffc76734a157b4c$export$f31a644ccca0ef23(ecData.componentMainType, ecData.componentIndex, ecData.componentHighDownName, api).dispatchers;
    if (dispatchers) (0, $43e0a445ed6711da$export$79b2f7037acddd43)(dispatchers, function(dispatcher) {
        return $fffc76734a157b4c$export$784cba1f7fe58cca(dispatcher, e);
    });
    else $fffc76734a157b4c$export$784cba1f7fe58cca(dispatcher, e);
}
function $fffc76734a157b4c$export$1c7d489f62372d73(seriesModel, payload, api) {
    if (!$fffc76734a157b4c$export$72aea10e60e45351(payload)) return;
    var dataType = payload.dataType;
    var data = seriesModel.getData(dataType);
    var dataIndex = (0, $87f4a59ac66e0ee6$export$42b26cae8b8d10)(data, payload);
    if (!(0, $43e0a445ed6711da$export$43bee75e5e14138e)(dataIndex)) dataIndex = [
        dataIndex
    ];
    seriesModel[payload.type === $fffc76734a157b4c$export$1e90ed8a25542516 ? "toggleSelect" : payload.type === $fffc76734a157b4c$export$89616263e7d38fe9 ? "select" : "unselect"](dataIndex, dataType);
}
function $fffc76734a157b4c$export$e4ea08ef52e0a73(seriesModel) {
    var allData = seriesModel.getAllData();
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)(allData, function(_a) {
        var data = _a.data, type = _a.type;
        data.eachItemGraphicEl(function(el, idx) {
            seriesModel.isSelected(idx, type) ? $fffc76734a157b4c$export$252d028dda8ef765(el) : $fffc76734a157b4c$export$ea9a904bd6e32bd3(el);
        });
    });
}
function $fffc76734a157b4c$export$c529643b619af6b3(ecModel) {
    var ret = [];
    ecModel.eachSeries(function(seriesModel) {
        var allData = seriesModel.getAllData();
        (0, $43e0a445ed6711da$export$79b2f7037acddd43)(allData, function(_a) {
            var data = _a.data, type = _a.type;
            var dataIndices = seriesModel.getSelectedDataIndices();
            if (dataIndices.length > 0) {
                var item = {
                    dataIndex: dataIndices,
                    seriesIndex: seriesModel.seriesIndex
                };
                if (type != null) item.dataType = type;
                ret.push(item);
            }
        });
    });
    return ret;
}
function $fffc76734a157b4c$export$5f393df0b5aee2e7(el, focus, blurScope) {
    $fffc76734a157b4c$export$9ba15aea1e048d48(el, true);
    $fffc76734a157b4c$var$traverseUpdateState(el, $fffc76734a157b4c$export$20f39bbe322fb9ab);
    $fffc76734a157b4c$export$24972466b2b62ac2(el, focus, blurScope);
}
function $fffc76734a157b4c$export$912cae7b47c8e437(el) {
    $fffc76734a157b4c$export$9ba15aea1e048d48(el, false);
}
function $fffc76734a157b4c$export$e51187539ff11209(el, focus, blurScope, isDisabled) {
    isDisabled ? $fffc76734a157b4c$export$912cae7b47c8e437(el) : $fffc76734a157b4c$export$5f393df0b5aee2e7(el, focus, blurScope);
}
function $fffc76734a157b4c$export$24972466b2b62ac2(el, focus, blurScope) {
    var ecData = (0, $7e4afcfca8f5121f$export$b1c39b2bacd1ddc2)(el);
    if (focus != null) {
        // TODO dataIndex may be set after this function. This check is not useful.
        // if (ecData.dataIndex == null) {
        //     if (__DEV__) {
        //         console.warn('focus can only been set on element with dataIndex');
        //     }
        // }
        // else {
        ecData.focus = focus;
        ecData.blurScope = blurScope;
    // }
    } else if (ecData.focus) ecData.focus = null;
}
var $fffc76734a157b4c$var$OTHER_STATES = [
    "emphasis",
    "blur",
    "select"
];
var $fffc76734a157b4c$var$defaultStyleGetterMap = {
    itemStyle: "getItemStyle",
    lineStyle: "getLineStyle",
    areaStyle: "getAreaStyle"
};
function $fffc76734a157b4c$export$48b68047d330bbc9(el, itemModel, styleType, // default itemStyle
getter) {
    styleType = styleType || "itemStyle";
    for(var i = 0; i < $fffc76734a157b4c$var$OTHER_STATES.length; i++){
        var stateName = $fffc76734a157b4c$var$OTHER_STATES[i];
        var model = itemModel.getModel([
            stateName,
            styleType
        ]);
        var state = el.ensureState(stateName);
        // Let it throw error if getterType is not found.
        state.style = getter ? getter(model) : model[$fffc76734a157b4c$var$defaultStyleGetterMap[styleType]]();
    }
}
function $fffc76734a157b4c$export$9ba15aea1e048d48(el, asDispatcher) {
    var disable = asDispatcher === false;
    var extendedEl = el;
    // Make `highDownSilentOnTouch` and `onStateChange` only work after
    // `setAsHighDownDispatcher` called. Avoid it is modified by user unexpectedly.
    if (el.highDownSilentOnTouch) extendedEl.__highDownSilentOnTouch = el.highDownSilentOnTouch;
    // Simple optimize, since this method might be
    // called for each elements of a group in some cases.
    if (!disable || extendedEl.__highDownDispatcher) {
        // Emphasis, normal can be triggered manually by API or other components like hover link.
        // el[method]('emphasis', onElementEmphasisEvent)[method]('normal', onElementNormalEvent);
        // Also keep previous record.
        extendedEl.__highByOuter = extendedEl.__highByOuter || 0;
        extendedEl.__highDownDispatcher = !disable;
    }
}
function $fffc76734a157b4c$export$77d1445f699c58b5(el) {
    return !!(el && el.__highDownDispatcher);
}
function $fffc76734a157b4c$export$4da05a9639f01954(el, componentModel, componentHighDownName) {
    var ecData = (0, $7e4afcfca8f5121f$export$b1c39b2bacd1ddc2)(el);
    ecData.componentMainType = componentModel.mainType;
    ecData.componentIndex = componentModel.componentIndex;
    ecData.componentHighDownName = componentHighDownName;
}
function $fffc76734a157b4c$export$824af40eb714530d(highlightKey) {
    var highlightDigit = $fffc76734a157b4c$var$_highlightKeyMap[highlightKey];
    if (highlightDigit == null && $fffc76734a157b4c$var$_highlightNextDigit <= 32) highlightDigit = $fffc76734a157b4c$var$_highlightKeyMap[highlightKey] = $fffc76734a157b4c$var$_highlightNextDigit++;
    return highlightDigit;
}
function $fffc76734a157b4c$export$72aea10e60e45351(payload) {
    var payloadType = payload.type;
    return payloadType === $fffc76734a157b4c$export$89616263e7d38fe9 || payloadType === $fffc76734a157b4c$export$7636ad95c0f68a79 || payloadType === $fffc76734a157b4c$export$1e90ed8a25542516;
}
function $fffc76734a157b4c$export$aebe71265c1b77bf(payload) {
    var payloadType = payload.type;
    return payloadType === $fffc76734a157b4c$export$df035d873a9de64f || payloadType === $fffc76734a157b4c$export$f8a2f7807cc185ea;
}
function $fffc76734a157b4c$export$9fe78019e6f395b6(el) {
    var store = $fffc76734a157b4c$var$getSavedStates(el);
    store.normalFill = el.style.fill;
    store.normalStroke = el.style.stroke;
    var selectState = el.states.select || {};
    store.selectFill = selectState.style && selectState.style.fill || null;
    store.selectStroke = selectState.style && selectState.style.stroke || null;
}




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $4feffdaaa31d998e$export$ae7433df314f6ec3 = (0, $87f4a59ac66e0ee6$export$64df9f8d92ae083f)();
function $4feffdaaa31d998e$export$5cc7add7ab591d0a(animationType, animatableModel, dataIndex, // Extra opts can override the option in animatable model.
extraOpts, // TODO It's only for pictorial bar now.
extraDelayParams) {
    var animationPayload;
    // Check if there is global animation configuration from dataZoom/resize can override the config in option.
    // If animation is enabled. Will use this animation config in payload.
    // If animation is disabled. Just ignore it.
    if (animatableModel && animatableModel.ecModel) {
        var updatePayload = animatableModel.ecModel.getUpdatePayload();
        animationPayload = updatePayload && updatePayload.animation;
    }
    var animationEnabled = animatableModel && animatableModel.isAnimationEnabled();
    var isUpdate = animationType === "update";
    if (animationEnabled) {
        var duration = void 0;
        var easing = void 0;
        var delay = void 0;
        if (extraOpts) {
            duration = (0, $43e0a445ed6711da$export$995e01f2f5c9d030)(extraOpts.duration, 200);
            easing = (0, $43e0a445ed6711da$export$995e01f2f5c9d030)(extraOpts.easing, "cubicOut");
            delay = 0;
        } else {
            duration = animatableModel.getShallow(isUpdate ? "animationDurationUpdate" : "animationDuration");
            easing = animatableModel.getShallow(isUpdate ? "animationEasingUpdate" : "animationEasing");
            delay = animatableModel.getShallow(isUpdate ? "animationDelayUpdate" : "animationDelay");
        }
        // animation from payload has highest priority.
        if (animationPayload) {
            animationPayload.duration != null && (duration = animationPayload.duration);
            animationPayload.easing != null && (easing = animationPayload.easing);
            animationPayload.delay != null && (delay = animationPayload.delay);
        }
        if ((0, $43e0a445ed6711da$export$f6e2535fb5126e54)(delay)) delay = delay(dataIndex, extraDelayParams);
        if ((0, $43e0a445ed6711da$export$f6e2535fb5126e54)(duration)) duration = duration(dataIndex);
        var config = {
            duration: duration || 0,
            delay: delay,
            easing: easing
        };
        return config;
    } else return null;
}
function $4feffdaaa31d998e$var$animateOrSetProps(animationType, el, props, animatableModel, dataIndex, cb, during) {
    var isFrom = false;
    var removeOpt;
    if ((0, $43e0a445ed6711da$export$f6e2535fb5126e54)(dataIndex)) {
        during = cb;
        cb = dataIndex;
        dataIndex = null;
    } else if ((0, $43e0a445ed6711da$export$a6cdc56e425d0d0a)(dataIndex)) {
        cb = dataIndex.cb;
        during = dataIndex.during;
        isFrom = dataIndex.isFrom;
        removeOpt = dataIndex.removeOpt;
        dataIndex = dataIndex.dataIndex;
    }
    var isRemove = animationType === "leave";
    if (!isRemove) // Must stop the remove animation.
    el.stopAnimation("leave");
    var animationConfig = $4feffdaaa31d998e$export$5cc7add7ab591d0a(animationType, animatableModel, dataIndex, isRemove ? removeOpt || {} : null, animatableModel && animatableModel.getAnimationDelayParams ? animatableModel.getAnimationDelayParams(el, dataIndex) : null);
    if (animationConfig && animationConfig.duration > 0) {
        var duration = animationConfig.duration;
        var animationDelay = animationConfig.delay;
        var animationEasing = animationConfig.easing;
        var animateConfig = {
            duration: duration,
            delay: animationDelay || 0,
            easing: animationEasing,
            done: cb,
            force: !!cb || !!during,
            // Set to final state in update/init animation.
            // So the post processing based on the path shape can be done correctly.
            setToFinal: !isRemove,
            scope: animationType,
            during: during
        };
        isFrom ? el.animateFrom(props, animateConfig) : el.animateTo(props, animateConfig);
    } else {
        el.stopAnimation();
        // If `isFrom`, the props is the "from" props.
        !isFrom && el.attr(props);
        // Call during at least once.
        during && during(1);
        cb && cb();
    }
}
/**
 * Update graphic element properties with or without animation according to the
 * configuration in series.
 *
 * Caution: this method will stop previous animation.
 * So do not use this method to one element twice before
 * animation starts, unless you know what you are doing.
 * @example
 *     graphic.updateProps(el, {
 *         position: [100, 100]
 *     }, seriesModel, dataIndex, function () { console.log('Animation done!'); });
 *     // Or
 *     graphic.updateProps(el, {
 *         position: [100, 100]
 *     }, seriesModel, function () { console.log('Animation done!'); });
 */ function $4feffdaaa31d998e$export$c8dce3c08436e91e(el, props, // TODO: TYPE AnimatableModel
animatableModel, dataIndex, cb, during) {
    $4feffdaaa31d998e$var$animateOrSetProps("update", el, props, animatableModel, dataIndex, cb, during);
}
function $4feffdaaa31d998e$export$a121566aadcfe021(el, props, animatableModel, dataIndex, cb, during) {
    $4feffdaaa31d998e$var$animateOrSetProps("enter", el, props, animatableModel, dataIndex, cb, during);
}
function $4feffdaaa31d998e$export$5b89d4b643713034(el) {
    if (!el.__zr) return true;
    for(var i = 0; i < el.animators.length; i++){
        var animator = el.animators[i];
        if (animator.scope === "leave") return true;
    }
    return false;
}
function $4feffdaaa31d998e$export$f883456a56996078(el, props, animatableModel, dataIndex, cb, during) {
    // Don't do remove animation twice.
    if ($4feffdaaa31d998e$export$5b89d4b643713034(el)) return;
    $4feffdaaa31d998e$var$animateOrSetProps("leave", el, props, animatableModel, dataIndex, cb, during);
}
function $4feffdaaa31d998e$var$fadeOutDisplayable(el, animatableModel, dataIndex, done) {
    el.removeTextContent();
    el.removeTextGuideLine();
    $4feffdaaa31d998e$export$f883456a56996078(el, {
        style: {
            opacity: 0
        }
    }, animatableModel, dataIndex, done);
}
function $4feffdaaa31d998e$export$6d0fd725cb4aee8a(el, animatableModel, dataIndex) {
    function doRemove() {
        el.parent && el.parent.remove(el);
    }
    // Hide label and labelLine first
    // TODO Also use fade out animation?
    if (!el.isGroup) $4feffdaaa31d998e$var$fadeOutDisplayable(el, animatableModel, dataIndex, doRemove);
    else el.traverse(function(disp) {
        if (!disp.isGroup) // Can invoke doRemove multiple times.
        $4feffdaaa31d998e$var$fadeOutDisplayable(disp, animatableModel, dataIndex, doRemove);
    });
}
function $4feffdaaa31d998e$export$bca7290a9faf0ec9(el) {
    $4feffdaaa31d998e$export$ae7433df314f6ec3(el).oldStyle = el.style;
}
function $4feffdaaa31d998e$export$ccb1f1e4d2fa86ac(el) {
    return $4feffdaaa31d998e$export$ae7433df314f6ec3(el).oldStyle;
}

var $6552edac5ca572b1$exports = {};

$parcel$export($6552edac5ca572b1$exports, "XY", function () { return $6552edac5ca572b1$export$cb4c12294149dd2d; });
$parcel$export($6552edac5ca572b1$exports, "WH", function () { return $6552edac5ca572b1$export$a3fe6d967173a3ac; });
$parcel$export($6552edac5ca572b1$exports, "HOVER_LAYER_NO", function () { return $6552edac5ca572b1$export$3e67317617241636; });
$parcel$export($6552edac5ca572b1$exports, "HOVER_LAYER_FROM_THRESHOLD", function () { return $6552edac5ca572b1$export$3c339ce201e4ce4d; });
$parcel$export($6552edac5ca572b1$exports, "HOVER_LAYER_FOR_INCREMENTAL", function () { return $6552edac5ca572b1$export$2ed770cec6ef78e8; });
$parcel$export($6552edac5ca572b1$exports, "extendShape", function () { return $6552edac5ca572b1$export$d0d5398c9d612037; });
$parcel$export($6552edac5ca572b1$exports, "extendPath", function () { return $6552edac5ca572b1$export$53b54a3137026af0; });
$parcel$export($6552edac5ca572b1$exports, "registerShape", function () { return $6552edac5ca572b1$export$2b95b62e3aaf6fdd; });
$parcel$export($6552edac5ca572b1$exports, "getShapeClass", function () { return $6552edac5ca572b1$export$51df4b5565a58189; });
$parcel$export($6552edac5ca572b1$exports, "makePath", function () { return $6552edac5ca572b1$export$aa9bab72412f5613; });
$parcel$export($6552edac5ca572b1$exports, "resizePath", function () { return $6552edac5ca572b1$export$566dbf1c62b04fc7; });
$parcel$export($6552edac5ca572b1$exports, "makeImage", function () { return $6552edac5ca572b1$export$7a2bdede98851ac5; });
$parcel$export($6552edac5ca572b1$exports, "mergePath", function () { return $6552edac5ca572b1$export$7b1dd269fbc4e903; });
$parcel$export($6552edac5ca572b1$exports, "subPixelOptimizeLine", function () { return $6552edac5ca572b1$export$8b4b620d7f4aad1b; });
$parcel$export($6552edac5ca572b1$exports, "subPixelOptimizeRect", function () { return $6552edac5ca572b1$export$60e2aa74957d0b9d; });
$parcel$export($6552edac5ca572b1$exports, "subPixelOptimize", function () { return $6552edac5ca572b1$export$72c4fd4c1b8fcb10; });
$parcel$export($6552edac5ca572b1$exports, "getTransform", function () { return $6552edac5ca572b1$export$fce0c6cfca85ed96; });
$parcel$export($6552edac5ca572b1$exports, "applyTransform", function () { return $6552edac5ca572b1$export$9f9dcb98c894b623; });
$parcel$export($6552edac5ca572b1$exports, "transformDirection", function () { return $6552edac5ca572b1$export$fff94e9792354cfa; });
$parcel$export($6552edac5ca572b1$exports, "groupTransition", function () { return $6552edac5ca572b1$export$64fcab7860c216ae; });
$parcel$export($6552edac5ca572b1$exports, "clipPointsByRect", function () { return $6552edac5ca572b1$export$e2f409471bbbc1dc; });
$parcel$export($6552edac5ca572b1$exports, "clipRectByRect", function () { return $6552edac5ca572b1$export$d0d3709202b8b2a; });
$parcel$export($6552edac5ca572b1$exports, "createIcon", function () { return $6552edac5ca572b1$export$274edc73af1ae9c8; });
$parcel$export($6552edac5ca572b1$exports, "linePolygonIntersect", function () { return $6552edac5ca572b1$export$4f47c855a5e9ae9; });
$parcel$export($6552edac5ca572b1$exports, "lineLineIntersect", function () { return $6552edac5ca572b1$export$6c0a70ea1d8d158b; });
$parcel$export($6552edac5ca572b1$exports, "expandOrShrinkRect", function () { return $6552edac5ca572b1$export$81ed941fdeb91c7c; });
$parcel$export($6552edac5ca572b1$exports, "setTooltipConfig", function () { return $6552edac5ca572b1$export$fc6410d97fab306c; });
$parcel$export($6552edac5ca572b1$exports, "traverseElements", function () { return $6552edac5ca572b1$export$3e564442729bf048; });
$parcel$export($6552edac5ca572b1$exports, "isBoundingRectAxisAligned", function () { return $6552edac5ca572b1$export$576610ccf2234b72; });
$parcel$export($6552edac5ca572b1$exports, "ensureCopyRect", function () { return $6552edac5ca572b1$export$38128dfd9a498e1; });
$parcel$export($6552edac5ca572b1$exports, "ensureCopyTransform", function () { return $6552edac5ca572b1$export$4d61283a070e0362; });
$parcel$export($6552edac5ca572b1$exports, "retrieveZInfo", function () { return $6552edac5ca572b1$export$1500a631bea5adda; });
$parcel$export($6552edac5ca572b1$exports, "calcZ2Range", function () { return $6552edac5ca572b1$export$8215ea00957327f2; });
$parcel$export($6552edac5ca572b1$exports, "traverseUpdateZ", function () { return $6552edac5ca572b1$export$d31cf465bf5e8879; });
$parcel$export($6552edac5ca572b1$exports, "payloadDisableAnimation", function () { return $6552edac5ca572b1$export$6f963a8600ad6f65; });
$parcel$export($6552edac5ca572b1$exports, "decomposeTransform", function () { return $6552edac5ca572b1$export$31f224ae9d6cf05; });
$parcel$export($6552edac5ca572b1$exports, "getCurrentCanvasPainter", function () { return $6552edac5ca572b1$export$e8e725f22cc8ef79; });
$parcel$export($6552edac5ca572b1$exports, "updateProps", function () { return $4feffdaaa31d998e$export$c8dce3c08436e91e; });
$parcel$export($6552edac5ca572b1$exports, "initProps", function () { return $4feffdaaa31d998e$export$a121566aadcfe021; });
$parcel$export($6552edac5ca572b1$exports, "removeElement", function () { return $4feffdaaa31d998e$export$f883456a56996078; });
$parcel$export($6552edac5ca572b1$exports, "removeElementWithFadeOut", function () { return $4feffdaaa31d998e$export$6d0fd725cb4aee8a; });
$parcel$export($6552edac5ca572b1$exports, "isElementRemoved", function () { return $4feffdaaa31d998e$export$5b89d4b643713034; });
$parcel$export($6552edac5ca572b1$exports, "Group", function () { return $a8978f7a0e842e3d$export$2e2bcd8739ae039; });
$parcel$export($6552edac5ca572b1$exports, "Image", function () { return $d3b0315ae8e8e298$export$2e2bcd8739ae039; });
$parcel$export($6552edac5ca572b1$exports, "Text", function () { return $7db7960d25b39b7c$export$2e2bcd8739ae039; });
$parcel$export($6552edac5ca572b1$exports, "Circle", function () { return $55c0fda972a24142$export$2e2bcd8739ae039; });
$parcel$export($6552edac5ca572b1$exports, "Ellipse", function () { return $1d371afa26fdd11c$export$2e2bcd8739ae039; });
$parcel$export($6552edac5ca572b1$exports, "Sector", function () { return $7a3d58339c1601e8$export$2e2bcd8739ae039; });
$parcel$export($6552edac5ca572b1$exports, "Ring", function () { return $493646296ab90046$export$2e2bcd8739ae039; });
$parcel$export($6552edac5ca572b1$exports, "Polygon", function () { return $dbc82dce785be05b$export$2e2bcd8739ae039; });
$parcel$export($6552edac5ca572b1$exports, "Polyline", function () { return $363f38bff4966f60$export$2e2bcd8739ae039; });
$parcel$export($6552edac5ca572b1$exports, "Rect", function () { return $42ed508a93973e78$export$2e2bcd8739ae039; });
$parcel$export($6552edac5ca572b1$exports, "Line", function () { return $0e0ee2afac2bc66d$export$2e2bcd8739ae039; });
$parcel$export($6552edac5ca572b1$exports, "BezierCurve", function () { return $57c0d9f749c3a837$export$2e2bcd8739ae039; });
$parcel$export($6552edac5ca572b1$exports, "Arc", function () { return $d0a314b008adf9ab$export$2e2bcd8739ae039; });
$parcel$export($6552edac5ca572b1$exports, "IncrementalDisplayable", function () { return $afb0e0140d20f85a$export$2e2bcd8739ae039; });
$parcel$export($6552edac5ca572b1$exports, "CompoundPath", function () { return $21e4011e695d4132$export$2e2bcd8739ae039; });
$parcel$export($6552edac5ca572b1$exports, "LinearGradient", function () { return $9cb489c6746d60b7$export$2e2bcd8739ae039; });
$parcel$export($6552edac5ca572b1$exports, "RadialGradient", function () { return $675bf9bc44bcf0b5$export$2e2bcd8739ae039; });
$parcel$export($6552edac5ca572b1$exports, "BoundingRect", function () { return $c437f598d9c9ee16$export$2e2bcd8739ae039; });
$parcel$export($6552edac5ca572b1$exports, "OrientedBoundingRect", function () { return $babb2d949c53d85d$export$2e2bcd8739ae039; });
$parcel$export($6552edac5ca572b1$exports, "Point", function () { return $1de2ad08c108b7c2$export$2e2bcd8739ae039; });
$parcel$export($6552edac5ca572b1$exports, "Path", function () { return $227e31075465dcd4$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $4c08f4322bc028a3$var$CMD = (0, $e2a16933ef78a053$export$2e2bcd8739ae039).CMD;
var $4c08f4322bc028a3$var$points = [
    [],
    [],
    []
];
var $4c08f4322bc028a3$var$mathSqrt = Math.sqrt;
var $4c08f4322bc028a3$var$mathAtan2 = Math.atan2;
function $4c08f4322bc028a3$export$2e2bcd8739ae039(path, m) {
    if (!m) return;
    var data = path.data;
    var len = path.len();
    var cmd;
    var nPoint;
    var i;
    var j;
    var k;
    var p;
    var M = $4c08f4322bc028a3$var$CMD.M;
    var C = $4c08f4322bc028a3$var$CMD.C;
    var L = $4c08f4322bc028a3$var$CMD.L;
    var R = $4c08f4322bc028a3$var$CMD.R;
    var A = $4c08f4322bc028a3$var$CMD.A;
    var Q = $4c08f4322bc028a3$var$CMD.Q;
    for(i = 0, j = 0; i < len;){
        cmd = data[i++];
        j = i;
        nPoint = 0;
        switch(cmd){
            case M:
                nPoint = 1;
                break;
            case L:
                nPoint = 1;
                break;
            case C:
                nPoint = 3;
                break;
            case Q:
                nPoint = 2;
                break;
            case A:
                var x = m[4];
                var y = m[5];
                var sx = $4c08f4322bc028a3$var$mathSqrt(m[0] * m[0] + m[1] * m[1]);
                var sy = $4c08f4322bc028a3$var$mathSqrt(m[2] * m[2] + m[3] * m[3]);
                var angle = $4c08f4322bc028a3$var$mathAtan2(-m[1] / sy, m[0] / sx);
                data[i] *= sx;
                data[i++] += x;
                data[i] *= sy;
                data[i++] += y;
                data[i++] *= sx;
                data[i++] *= sy;
                data[i++] += angle;
                data[i++] += angle;
                i += 2;
                j = i;
                break;
            case R:
                p[0] = data[i++];
                p[1] = data[i++];
                (0, $ee491d8f32bd01ff$export$9f9dcb98c894b623)(p, p, m);
                data[j++] = p[0];
                data[j++] = p[1];
                p[0] += data[i++];
                p[1] += data[i++];
                (0, $ee491d8f32bd01ff$export$9f9dcb98c894b623)(p, p, m);
                data[j++] = p[0];
                data[j++] = p[1];
        }
        for(k = 0; k < nPoint; k++){
            var p_1 = $4c08f4322bc028a3$var$points[k];
            p_1[0] = data[i++];
            p_1[1] = data[i++];
            (0, $ee491d8f32bd01ff$export$9f9dcb98c894b623)(p_1, p_1, m);
            data[j++] = p_1[0];
            data[j++] = p_1[1];
        }
    }
    path.increaseVersion();
}



var $4656fa00e972eae8$var$mathSqrt = Math.sqrt;
var $4656fa00e972eae8$var$mathSin = Math.sin;
var $4656fa00e972eae8$var$mathCos = Math.cos;
var $4656fa00e972eae8$var$PI = Math.PI;
function $4656fa00e972eae8$var$vMag(v) {
    return Math.sqrt(v[0] * v[0] + v[1] * v[1]);
}
function $4656fa00e972eae8$var$vRatio(u, v) {
    return (u[0] * v[0] + u[1] * v[1]) / ($4656fa00e972eae8$var$vMag(u) * $4656fa00e972eae8$var$vMag(v));
}
function $4656fa00e972eae8$var$vAngle(u, v) {
    return (u[0] * v[1] < u[1] * v[0] ? -1 : 1) * Math.acos($4656fa00e972eae8$var$vRatio(u, v));
}
function $4656fa00e972eae8$var$processArc(x1, y1, x2, y2, fa, fs, rx, ry, psiDeg, cmd, path) {
    var psi = psiDeg * ($4656fa00e972eae8$var$PI / 180.0);
    var xp = $4656fa00e972eae8$var$mathCos(psi) * (x1 - x2) / 2.0 + $4656fa00e972eae8$var$mathSin(psi) * (y1 - y2) / 2.0;
    var yp = -1 * $4656fa00e972eae8$var$mathSin(psi) * (x1 - x2) / 2.0 + $4656fa00e972eae8$var$mathCos(psi) * (y1 - y2) / 2.0;
    var lambda = xp * xp / (rx * rx) + yp * yp / (ry * ry);
    if (lambda > 1) {
        rx *= $4656fa00e972eae8$var$mathSqrt(lambda);
        ry *= $4656fa00e972eae8$var$mathSqrt(lambda);
    }
    var f = (fa === fs ? -1 : 1) * $4656fa00e972eae8$var$mathSqrt((rx * rx * (ry * ry) - rx * rx * (yp * yp) - ry * ry * (xp * xp)) / (rx * rx * (yp * yp) + ry * ry * (xp * xp))) || 0;
    var cxp = f * rx * yp / ry;
    var cyp = f * -ry * xp / rx;
    var cx = (x1 + x2) / 2.0 + $4656fa00e972eae8$var$mathCos(psi) * cxp - $4656fa00e972eae8$var$mathSin(psi) * cyp;
    var cy = (y1 + y2) / 2.0 + $4656fa00e972eae8$var$mathSin(psi) * cxp + $4656fa00e972eae8$var$mathCos(psi) * cyp;
    var theta = $4656fa00e972eae8$var$vAngle([
        1,
        0
    ], [
        (xp - cxp) / rx,
        (yp - cyp) / ry
    ]);
    var u = [
        (xp - cxp) / rx,
        (yp - cyp) / ry
    ];
    var v = [
        (-1 * xp - cxp) / rx,
        (-1 * yp - cyp) / ry
    ];
    var dTheta = $4656fa00e972eae8$var$vAngle(u, v);
    if ($4656fa00e972eae8$var$vRatio(u, v) <= -1) dTheta = $4656fa00e972eae8$var$PI;
    if ($4656fa00e972eae8$var$vRatio(u, v) >= 1) dTheta = 0;
    if (dTheta < 0) {
        var n = Math.round(dTheta / $4656fa00e972eae8$var$PI * 1e6) / 1e6;
        dTheta = $4656fa00e972eae8$var$PI * 2 + n % 2 * $4656fa00e972eae8$var$PI;
    }
    path.addData(cmd, cx, cy, rx, ry, theta, dTheta, psi, fs);
}
var $4656fa00e972eae8$var$commandReg = /([mlvhzcqtsa])([^mlvhzcqtsa]*)/ig;
var $4656fa00e972eae8$var$numberReg = /-?([0-9]*\.)?[0-9]+([eE]-?[0-9]+)?/g;
function $4656fa00e972eae8$var$createPathProxyFromString(data) {
    var path = new (0, $e2a16933ef78a053$export$2e2bcd8739ae039)();
    if (!data) return path;
    var cpx = 0;
    var cpy = 0;
    var subpathX = cpx;
    var subpathY = cpy;
    var prevCmd;
    var CMD = (0, $e2a16933ef78a053$export$2e2bcd8739ae039).CMD;
    var cmdList = data.match($4656fa00e972eae8$var$commandReg);
    if (!cmdList) return path;
    for(var l = 0; l < cmdList.length; l++){
        var cmdText = cmdList[l];
        var cmdStr = cmdText.charAt(0);
        var cmd = void 0;
        var p = cmdText.match($4656fa00e972eae8$var$numberReg) || [];
        var pLen = p.length;
        for(var i = 0; i < pLen; i++)p[i] = parseFloat(p[i]);
        var off = 0;
        while(off < pLen){
            var ctlPtx = void 0;
            var ctlPty = void 0;
            var rx = void 0;
            var ry = void 0;
            var psi = void 0;
            var fa = void 0;
            var fs = void 0;
            var x1 = cpx;
            var y1 = cpy;
            var len = void 0;
            var pathData = void 0;
            switch(cmdStr){
                case "l":
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case "L":
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case "m":
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.M;
                    path.addData(cmd, cpx, cpy);
                    subpathX = cpx;
                    subpathY = cpy;
                    cmdStr = "l";
                    break;
                case "M":
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.M;
                    path.addData(cmd, cpx, cpy);
                    subpathX = cpx;
                    subpathY = cpy;
                    cmdStr = "L";
                    break;
                case "h":
                    cpx += p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case "H":
                    cpx = p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case "v":
                    cpy += p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case "V":
                    cpy = p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case "C":
                    cmd = CMD.C;
                    path.addData(cmd, p[off++], p[off++], p[off++], p[off++], p[off++], p[off++]);
                    cpx = p[off - 2];
                    cpy = p[off - 1];
                    break;
                case "c":
                    cmd = CMD.C;
                    path.addData(cmd, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy);
                    cpx += p[off - 2];
                    cpy += p[off - 1];
                    break;
                case "S":
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.C) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cmd = CMD.C;
                    x1 = p[off++];
                    y1 = p[off++];
                    cpx = p[off++];
                    cpy = p[off++];
                    path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
                    break;
                case "s":
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.C) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cmd = CMD.C;
                    x1 = cpx + p[off++];
                    y1 = cpy + p[off++];
                    cpx += p[off++];
                    cpy += p[off++];
                    path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
                    break;
                case "Q":
                    x1 = p[off++];
                    y1 = p[off++];
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, x1, y1, cpx, cpy);
                    break;
                case "q":
                    x1 = p[off++] + cpx;
                    y1 = p[off++] + cpy;
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, x1, y1, cpx, cpy);
                    break;
                case "T":
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.Q) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
                    break;
                case "t":
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.Q) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
                    break;
                case "A":
                    rx = p[off++];
                    ry = p[off++];
                    psi = p[off++];
                    fa = p[off++];
                    fs = p[off++];
                    x1 = cpx, y1 = cpy;
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.A;
                    $4656fa00e972eae8$var$processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
                    break;
                case "a":
                    rx = p[off++];
                    ry = p[off++];
                    psi = p[off++];
                    fa = p[off++];
                    fs = p[off++];
                    x1 = cpx, y1 = cpy;
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.A;
                    $4656fa00e972eae8$var$processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
                    break;
            }
        }
        if (cmdStr === "z" || cmdStr === "Z") {
            cmd = CMD.Z;
            path.addData(cmd);
            cpx = subpathX;
            cpy = subpathY;
        }
        prevCmd = cmd;
    }
    path.toStatic();
    return path;
}
var $4656fa00e972eae8$var$SVGPath = function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(SVGPath, _super);
    function SVGPath() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SVGPath.prototype.applyTransform = function(m) {};
    return SVGPath;
}((0, $227e31075465dcd4$export$2e2bcd8739ae039));
function $4656fa00e972eae8$var$isPathProxy(path) {
    return path.setData != null;
}
function $4656fa00e972eae8$var$createPathOptions(str, opts) {
    var pathProxy = $4656fa00e972eae8$var$createPathProxyFromString(str);
    var innerOpts = (0, $43e0a445ed6711da$export$8b58be045bf06082)({}, opts);
    innerOpts.buildPath = function(path) {
        var beProxy = $4656fa00e972eae8$var$isPathProxy(path);
        if (beProxy && path.canSave()) {
            path.appendPath(pathProxy);
            var ctx = path.getContext();
            if (ctx) path.rebuildPath(ctx, 1);
        } else {
            var ctx = beProxy ? path.getContext() : path;
            if (ctx) pathProxy.rebuildPath(ctx, 1);
        }
    };
    innerOpts.applyTransform = function(m) {
        (0, $4c08f4322bc028a3$export$2e2bcd8739ae039)(pathProxy, m);
        this.dirtyShape();
    };
    return innerOpts;
}
function $4656fa00e972eae8$export$ae5b259626f00aeb(str, opts) {
    return new $4656fa00e972eae8$var$SVGPath($4656fa00e972eae8$var$createPathOptions(str, opts));
}
function $4656fa00e972eae8$export$68e3a51ba2ed417c(str, defaultOpts) {
    var innerOpts = $4656fa00e972eae8$var$createPathOptions(str, defaultOpts);
    var Sub = function(_super) {
        (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(Sub, _super);
        function Sub(opts) {
            var _this = _super.call(this, opts) || this;
            _this.applyTransform = innerOpts.applyTransform;
            _this.buildPath = innerOpts.buildPath;
            return _this;
        }
        return Sub;
    }($4656fa00e972eae8$var$SVGPath);
    return Sub;
}
function $4656fa00e972eae8$export$7b1dd269fbc4e903(pathEls, opts) {
    var pathList = [];
    var len = pathEls.length;
    for(var i = 0; i < len; i++){
        var pathEl = pathEls[i];
        pathList.push(pathEl.getUpdatedPathProxy(true));
    }
    var pathBundle = new (0, $227e31075465dcd4$export$2e2bcd8739ae039)(opts);
    pathBundle.createPathProxy();
    pathBundle.buildPath = function(path) {
        if ($4656fa00e972eae8$var$isPathProxy(path)) {
            path.appendPath(pathList);
            var ctx = path.getContext();
            if (ctx) path.rebuildPath(ctx, 1);
        }
    };
    return pathBundle;
}
function $4656fa00e972eae8$export$18711d956bf1c3eb(sourcePath, opts) {
    opts = opts || {};
    var path = new (0, $227e31075465dcd4$export$2e2bcd8739ae039)();
    if (sourcePath.shape) path.setShape(sourcePath.shape);
    path.setStyle(sourcePath.style);
    if (opts.bakeTransform) (0, $4c08f4322bc028a3$export$2e2bcd8739ae039)(path.path, sourcePath.getComputedTransform());
    else if (opts.toLocal) path.setLocalTransform(sourcePath.getComputedTransform());
    else path.copyTransform(sourcePath);
    path.buildPath = sourcePath.buildPath;
    path.applyTransform = path.applyTransform;
    path.z = sourcePath.z;
    path.z2 = sourcePath.z2;
    path.zlevel = sourcePath.zlevel;
    return path;
}











var $55c0fda972a24142$export$2c0b65c9c7b57845 = function() {
    function CircleShape() {
        this.cx = 0;
        this.cy = 0;
        this.r = 0;
    }
    return CircleShape;
}();
var $55c0fda972a24142$var$Circle = function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(Circle, _super);
    function Circle(opts) {
        return _super.call(this, opts) || this;
    }
    Circle.prototype.getDefaultShape = function() {
        return new $55c0fda972a24142$export$2c0b65c9c7b57845();
    };
    Circle.prototype.buildPath = function(ctx, shape) {
        ctx.moveTo(shape.cx + shape.r, shape.cy);
        ctx.arc(shape.cx, shape.cy, shape.r, 0, Math.PI * 2);
    };
    return Circle;
}((0, $227e31075465dcd4$export$2e2bcd8739ae039));
$55c0fda972a24142$var$Circle.prototype.type = "circle";
var $55c0fda972a24142$export$2e2bcd8739ae039 = $55c0fda972a24142$var$Circle;




var $1d371afa26fdd11c$export$817919dfe2806d31 = function() {
    function EllipseShape() {
        this.cx = 0;
        this.cy = 0;
        this.rx = 0;
        this.ry = 0;
    }
    return EllipseShape;
}();
var $1d371afa26fdd11c$var$Ellipse = function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(Ellipse, _super);
    function Ellipse(opts) {
        return _super.call(this, opts) || this;
    }
    Ellipse.prototype.getDefaultShape = function() {
        return new $1d371afa26fdd11c$export$817919dfe2806d31();
    };
    Ellipse.prototype.buildPath = function(ctx, shape) {
        var k = 0.5522848;
        var x = shape.cx;
        var y = shape.cy;
        var a = shape.rx;
        var b = shape.ry;
        var ox = a * k;
        var oy = b * k;
        ctx.moveTo(x - a, y);
        ctx.bezierCurveTo(x - a, y - oy, x - ox, y - b, x, y - b);
        ctx.bezierCurveTo(x + ox, y - b, x + a, y - oy, x + a, y);
        ctx.bezierCurveTo(x + a, y + oy, x + ox, y + b, x, y + b);
        ctx.bezierCurveTo(x - ox, y + b, x - a, y + oy, x - a, y);
        ctx.closePath();
    };
    return Ellipse;
}((0, $227e31075465dcd4$export$2e2bcd8739ae039));
$1d371afa26fdd11c$var$Ellipse.prototype.type = "ellipse";
var $1d371afa26fdd11c$export$2e2bcd8739ae039 = $1d371afa26fdd11c$var$Ellipse;





var $087c336afd913086$var$PI = Math.PI;
var $087c336afd913086$var$PI2 = $087c336afd913086$var$PI * 2;
var $087c336afd913086$var$mathSin = Math.sin;
var $087c336afd913086$var$mathCos = Math.cos;
var $087c336afd913086$var$mathACos = Math.acos;
var $087c336afd913086$var$mathATan2 = Math.atan2;
var $087c336afd913086$var$mathAbs = Math.abs;
var $087c336afd913086$var$mathSqrt = Math.sqrt;
var $087c336afd913086$var$mathMax = Math.max;
var $087c336afd913086$var$mathMin = Math.min;
var $087c336afd913086$var$e = 1e-4;
function $087c336afd913086$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var dx10 = x1 - x0;
    var dy10 = y1 - y0;
    var dx32 = x3 - x2;
    var dy32 = y3 - y2;
    var t = dy32 * dx10 - dx32 * dy10;
    if (t * t < $087c336afd913086$var$e) return;
    t = (dx32 * (y0 - y2) - dy32 * (x0 - x2)) / t;
    return [
        x0 + t * dx10,
        y0 + t * dy10
    ];
}
function $087c336afd913086$var$computeCornerTangents(x0, y0, x1, y1, radius, cr, clockwise) {
    var x01 = x0 - x1;
    var y01 = y0 - y1;
    var lo = (clockwise ? cr : -cr) / $087c336afd913086$var$mathSqrt(x01 * x01 + y01 * y01);
    var ox = lo * y01;
    var oy = -lo * x01;
    var x11 = x0 + ox;
    var y11 = y0 + oy;
    var x10 = x1 + ox;
    var y10 = y1 + oy;
    var x00 = (x11 + x10) / 2;
    var y00 = (y11 + y10) / 2;
    var dx = x10 - x11;
    var dy = y10 - y11;
    var d2 = dx * dx + dy * dy;
    var r = radius - cr;
    var s = x11 * y10 - x10 * y11;
    var d = (dy < 0 ? -1 : 1) * $087c336afd913086$var$mathSqrt($087c336afd913086$var$mathMax(0, r * r * d2 - s * s));
    var cx0 = (s * dy - dx * d) / d2;
    var cy0 = (-s * dx - dy * d) / d2;
    var cx1 = (s * dy + dx * d) / d2;
    var cy1 = (-s * dx + dy * d) / d2;
    var dx0 = cx0 - x00;
    var dy0 = cy0 - y00;
    var dx1 = cx1 - x00;
    var dy1 = cy1 - y00;
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) {
        cx0 = cx1;
        cy0 = cy1;
    }
    return {
        cx: cx0,
        cy: cy0,
        x0: -ox,
        y0: -oy,
        x1: cx0 * (radius / r - 1),
        y1: cy0 * (radius / r - 1)
    };
}
function $087c336afd913086$var$normalizeCornerRadius(cr) {
    var arr;
    if ((0, $43e0a445ed6711da$export$43bee75e5e14138e)(cr)) {
        var len = cr.length;
        if (!len) return cr;
        if (len === 1) arr = [
            cr[0],
            cr[0],
            0,
            0
        ];
        else if (len === 2) arr = [
            cr[0],
            cr[0],
            cr[1],
            cr[1]
        ];
        else if (len === 3) arr = cr.concat(cr[2]);
        else arr = cr;
    } else arr = [
        cr,
        cr,
        cr,
        cr
    ];
    return arr;
}
function $087c336afd913086$export$5cc7f731b5937e99(ctx, shape) {
    var _a;
    var radius = $087c336afd913086$var$mathMax(shape.r, 0);
    var innerRadius = $087c336afd913086$var$mathMax(shape.r0 || 0, 0);
    var hasRadius = radius > 0;
    var hasInnerRadius = innerRadius > 0;
    if (!hasRadius && !hasInnerRadius) return;
    if (!hasRadius) {
        radius = innerRadius;
        innerRadius = 0;
    }
    if (innerRadius > radius) {
        var tmp = radius;
        radius = innerRadius;
        innerRadius = tmp;
    }
    var startAngle = shape.startAngle, endAngle = shape.endAngle;
    if (isNaN(startAngle) || isNaN(endAngle)) return;
    var cx = shape.cx, cy = shape.cy;
    var clockwise = !!shape.clockwise;
    var arc = $087c336afd913086$var$mathAbs(endAngle - startAngle);
    var mod = arc > $087c336afd913086$var$PI2 && arc % $087c336afd913086$var$PI2;
    mod > $087c336afd913086$var$e && (arc = mod);
    if (!(radius > $087c336afd913086$var$e)) ctx.moveTo(cx, cy);
    else if (arc > $087c336afd913086$var$PI2 - $087c336afd913086$var$e) {
        ctx.moveTo(cx + radius * $087c336afd913086$var$mathCos(startAngle), cy + radius * $087c336afd913086$var$mathSin(startAngle));
        ctx.arc(cx, cy, radius, startAngle, endAngle, !clockwise);
        if (innerRadius > $087c336afd913086$var$e) {
            ctx.moveTo(cx + innerRadius * $087c336afd913086$var$mathCos(endAngle), cy + innerRadius * $087c336afd913086$var$mathSin(endAngle));
            ctx.arc(cx, cy, innerRadius, endAngle, startAngle, clockwise);
        }
    } else {
        var icrStart = void 0;
        var icrEnd = void 0;
        var ocrStart = void 0;
        var ocrEnd = void 0;
        var ocrs = void 0;
        var ocre = void 0;
        var icrs = void 0;
        var icre = void 0;
        var ocrMax = void 0;
        var icrMax = void 0;
        var limitedOcrMax = void 0;
        var limitedIcrMax = void 0;
        var xre = void 0;
        var yre = void 0;
        var xirs = void 0;
        var yirs = void 0;
        var xrs = radius * $087c336afd913086$var$mathCos(startAngle);
        var yrs = radius * $087c336afd913086$var$mathSin(startAngle);
        var xire = innerRadius * $087c336afd913086$var$mathCos(endAngle);
        var yire = innerRadius * $087c336afd913086$var$mathSin(endAngle);
        var hasArc = arc > $087c336afd913086$var$e;
        if (hasArc) {
            var cornerRadius = shape.cornerRadius;
            if (cornerRadius) _a = $087c336afd913086$var$normalizeCornerRadius(cornerRadius), icrStart = _a[0], icrEnd = _a[1], ocrStart = _a[2], ocrEnd = _a[3];
            var halfRd = $087c336afd913086$var$mathAbs(radius - innerRadius) / 2;
            ocrs = $087c336afd913086$var$mathMin(halfRd, ocrStart);
            ocre = $087c336afd913086$var$mathMin(halfRd, ocrEnd);
            icrs = $087c336afd913086$var$mathMin(halfRd, icrStart);
            icre = $087c336afd913086$var$mathMin(halfRd, icrEnd);
            limitedOcrMax = ocrMax = $087c336afd913086$var$mathMax(ocrs, ocre);
            limitedIcrMax = icrMax = $087c336afd913086$var$mathMax(icrs, icre);
            if (ocrMax > $087c336afd913086$var$e || icrMax > $087c336afd913086$var$e) {
                xre = radius * $087c336afd913086$var$mathCos(endAngle);
                yre = radius * $087c336afd913086$var$mathSin(endAngle);
                xirs = innerRadius * $087c336afd913086$var$mathCos(startAngle);
                yirs = innerRadius * $087c336afd913086$var$mathSin(startAngle);
                if (arc < $087c336afd913086$var$PI) {
                    var it_1 = $087c336afd913086$var$intersect(xrs, yrs, xirs, yirs, xre, yre, xire, yire);
                    if (it_1) {
                        var x0 = xrs - it_1[0];
                        var y0 = yrs - it_1[1];
                        var x1 = xre - it_1[0];
                        var y1 = yre - it_1[1];
                        var a = 1 / $087c336afd913086$var$mathSin($087c336afd913086$var$mathACos((x0 * x1 + y0 * y1) / ($087c336afd913086$var$mathSqrt(x0 * x0 + y0 * y0) * $087c336afd913086$var$mathSqrt(x1 * x1 + y1 * y1))) / 2);
                        var b = $087c336afd913086$var$mathSqrt(it_1[0] * it_1[0] + it_1[1] * it_1[1]);
                        limitedOcrMax = $087c336afd913086$var$mathMin(ocrMax, (radius - b) / (a + 1));
                        limitedIcrMax = $087c336afd913086$var$mathMin(icrMax, (innerRadius - b) / (a - 1));
                    }
                }
            }
        }
        if (!hasArc) ctx.moveTo(cx + xrs, cy + yrs);
        else if (limitedOcrMax > $087c336afd913086$var$e) {
            var crStart = $087c336afd913086$var$mathMin(ocrStart, limitedOcrMax);
            var crEnd = $087c336afd913086$var$mathMin(ocrEnd, limitedOcrMax);
            var ct0 = $087c336afd913086$var$computeCornerTangents(xirs, yirs, xrs, yrs, radius, crStart, clockwise);
            var ct1 = $087c336afd913086$var$computeCornerTangents(xre, yre, xire, yire, radius, crEnd, clockwise);
            ctx.moveTo(cx + ct0.cx + ct0.x0, cy + ct0.cy + ct0.y0);
            if (limitedOcrMax < ocrMax && crStart === crEnd) ctx.arc(cx + ct0.cx, cy + ct0.cy, limitedOcrMax, $087c336afd913086$var$mathATan2(ct0.y0, ct0.x0), $087c336afd913086$var$mathATan2(ct1.y0, ct1.x0), !clockwise);
            else {
                crStart > 0 && ctx.arc(cx + ct0.cx, cy + ct0.cy, crStart, $087c336afd913086$var$mathATan2(ct0.y0, ct0.x0), $087c336afd913086$var$mathATan2(ct0.y1, ct0.x1), !clockwise);
                ctx.arc(cx, cy, radius, $087c336afd913086$var$mathATan2(ct0.cy + ct0.y1, ct0.cx + ct0.x1), $087c336afd913086$var$mathATan2(ct1.cy + ct1.y1, ct1.cx + ct1.x1), !clockwise);
                crEnd > 0 && ctx.arc(cx + ct1.cx, cy + ct1.cy, crEnd, $087c336afd913086$var$mathATan2(ct1.y1, ct1.x1), $087c336afd913086$var$mathATan2(ct1.y0, ct1.x0), !clockwise);
            }
        } else {
            ctx.moveTo(cx + xrs, cy + yrs);
            ctx.arc(cx, cy, radius, startAngle, endAngle, !clockwise);
        }
        if (!(innerRadius > $087c336afd913086$var$e) || !hasArc) ctx.lineTo(cx + xire, cy + yire);
        else if (limitedIcrMax > $087c336afd913086$var$e) {
            var crStart = $087c336afd913086$var$mathMin(icrStart, limitedIcrMax);
            var crEnd = $087c336afd913086$var$mathMin(icrEnd, limitedIcrMax);
            var ct0 = $087c336afd913086$var$computeCornerTangents(xire, yire, xre, yre, innerRadius, -crEnd, clockwise);
            var ct1 = $087c336afd913086$var$computeCornerTangents(xrs, yrs, xirs, yirs, innerRadius, -crStart, clockwise);
            ctx.lineTo(cx + ct0.cx + ct0.x0, cy + ct0.cy + ct0.y0);
            if (limitedIcrMax < icrMax && crStart === crEnd) ctx.arc(cx + ct0.cx, cy + ct0.cy, limitedIcrMax, $087c336afd913086$var$mathATan2(ct0.y0, ct0.x0), $087c336afd913086$var$mathATan2(ct1.y0, ct1.x0), !clockwise);
            else {
                crEnd > 0 && ctx.arc(cx + ct0.cx, cy + ct0.cy, crEnd, $087c336afd913086$var$mathATan2(ct0.y0, ct0.x0), $087c336afd913086$var$mathATan2(ct0.y1, ct0.x1), !clockwise);
                ctx.arc(cx, cy, innerRadius, $087c336afd913086$var$mathATan2(ct0.cy + ct0.y1, ct0.cx + ct0.x1), $087c336afd913086$var$mathATan2(ct1.cy + ct1.y1, ct1.cx + ct1.x1), clockwise);
                crStart > 0 && ctx.arc(cx + ct1.cx, cy + ct1.cy, crStart, $087c336afd913086$var$mathATan2(ct1.y1, ct1.x1), $087c336afd913086$var$mathATan2(ct1.y0, ct1.x0), !clockwise);
            }
        } else {
            ctx.lineTo(cx + xire, cy + yire);
            ctx.arc(cx, cy, innerRadius, endAngle, startAngle, clockwise);
        }
    }
    ctx.closePath();
}


var $7a3d58339c1601e8$export$98af62de8a972c99 = function() {
    function SectorShape() {
        this.cx = 0;
        this.cy = 0;
        this.r0 = 0;
        this.r = 0;
        this.startAngle = 0;
        this.endAngle = Math.PI * 2;
        this.clockwise = true;
        this.cornerRadius = 0;
    }
    return SectorShape;
}();
var $7a3d58339c1601e8$var$Sector = function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(Sector, _super);
    function Sector(opts) {
        return _super.call(this, opts) || this;
    }
    Sector.prototype.getDefaultShape = function() {
        return new $7a3d58339c1601e8$export$98af62de8a972c99();
    };
    Sector.prototype.buildPath = function(ctx, shape) {
        $087c336afd913086$export$5cc7f731b5937e99(ctx, shape);
    };
    Sector.prototype.isZeroArea = function() {
        return this.shape.startAngle === this.shape.endAngle || this.shape.r === this.shape.r0;
    };
    return Sector;
}((0, $227e31075465dcd4$export$2e2bcd8739ae039));
$7a3d58339c1601e8$var$Sector.prototype.type = "sector";
var $7a3d58339c1601e8$export$2e2bcd8739ae039 = $7a3d58339c1601e8$var$Sector;




var $493646296ab90046$export$4a506b3cd4ea73db = function() {
    function RingShape() {
        this.cx = 0;
        this.cy = 0;
        this.r = 0;
        this.r0 = 0;
    }
    return RingShape;
}();
var $493646296ab90046$var$Ring = function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(Ring, _super);
    function Ring(opts) {
        return _super.call(this, opts) || this;
    }
    Ring.prototype.getDefaultShape = function() {
        return new $493646296ab90046$export$4a506b3cd4ea73db();
    };
    Ring.prototype.buildPath = function(ctx, shape) {
        var x = shape.cx;
        var y = shape.cy;
        var PI2 = Math.PI * 2;
        ctx.moveTo(x + shape.r, y);
        ctx.arc(x, y, shape.r, 0, PI2, false);
        ctx.moveTo(x + shape.r0, y);
        ctx.arc(x, y, shape.r0, 0, PI2, true);
    };
    return Ring;
}((0, $227e31075465dcd4$export$2e2bcd8739ae039));
$493646296ab90046$var$Ring.prototype.type = "ring";
var $493646296ab90046$export$2e2bcd8739ae039 = $493646296ab90046$var$Ring;





function $811b9322b312b37a$export$2e2bcd8739ae039(points, smooth, isLoop, constraint) {
    var cps = [];
    var v = [];
    var v1 = [];
    var v2 = [];
    var prevPoint;
    var nextPoint;
    var min;
    var max;
    if (constraint) {
        min = [
            Infinity,
            Infinity
        ];
        max = [
            -Infinity,
            -Infinity
        ];
        for(var i = 0, len = points.length; i < len; i++){
            (0, $ee491d8f32bd01ff$export$96ec731ed4dcb222)(min, min, points[i]);
            (0, $ee491d8f32bd01ff$export$8960430cfd85939f)(max, max, points[i]);
        }
        (0, $ee491d8f32bd01ff$export$96ec731ed4dcb222)(min, min, constraint[0]);
        (0, $ee491d8f32bd01ff$export$8960430cfd85939f)(max, max, constraint[1]);
    }
    for(var i = 0, len = points.length; i < len; i++){
        var point = points[i];
        if (isLoop) {
            prevPoint = points[i ? i - 1 : len - 1];
            nextPoint = points[(i + 1) % len];
        } else if (i === 0 || i === len - 1) {
            cps.push((0, $ee491d8f32bd01ff$export$9cd59f9826255e47)(points[i]));
            continue;
        } else {
            prevPoint = points[i - 1];
            nextPoint = points[i + 1];
        }
        (0, $ee491d8f32bd01ff$export$f93b5905241a7cca)(v, nextPoint, prevPoint);
        (0, $ee491d8f32bd01ff$export$dcdf75081b88279d)(v, v, smooth);
        var d0 = (0, $ee491d8f32bd01ff$export$9f17032d917177de)(point, prevPoint);
        var d1 = (0, $ee491d8f32bd01ff$export$9f17032d917177de)(point, nextPoint);
        var sum = d0 + d1;
        if (sum !== 0) {
            d0 /= sum;
            d1 /= sum;
        }
        (0, $ee491d8f32bd01ff$export$dcdf75081b88279d)(v1, v, -d0);
        (0, $ee491d8f32bd01ff$export$dcdf75081b88279d)(v2, v, d1);
        var cp0 = (0, $ee491d8f32bd01ff$export$e16d8520af44a096)([], point, v1);
        var cp1 = (0, $ee491d8f32bd01ff$export$e16d8520af44a096)([], point, v2);
        if (constraint) {
            (0, $ee491d8f32bd01ff$export$8960430cfd85939f)(cp0, cp0, min);
            (0, $ee491d8f32bd01ff$export$96ec731ed4dcb222)(cp0, cp0, max);
            (0, $ee491d8f32bd01ff$export$8960430cfd85939f)(cp1, cp1, min);
            (0, $ee491d8f32bd01ff$export$96ec731ed4dcb222)(cp1, cp1, max);
        }
        cps.push(cp0);
        cps.push(cp1);
    }
    if (isLoop) cps.push(cps.shift());
    return cps;
}


function $8413c37f5fa06398$export$5cc7f731b5937e99(ctx, shape, closePath) {
    var smooth = shape.smooth;
    var points = shape.points;
    if (points && points.length >= 2) {
        if (smooth) {
            var controlPoints = (0, $811b9322b312b37a$export$2e2bcd8739ae039)(points, smooth, closePath, shape.smoothConstraint);
            ctx.moveTo(points[0][0], points[0][1]);
            var len = points.length;
            for(var i = 0; i < (closePath ? len : len - 1); i++){
                var cp1 = controlPoints[i * 2];
                var cp2 = controlPoints[i * 2 + 1];
                var p = points[(i + 1) % len];
                ctx.bezierCurveTo(cp1[0], cp1[1], cp2[0], cp2[1], p[0], p[1]);
            }
        } else {
            ctx.moveTo(points[0][0], points[0][1]);
            for(var i = 1, l = points.length; i < l; i++)ctx.lineTo(points[i][0], points[i][1]);
        }
        closePath && ctx.closePath();
    }
}


var $dbc82dce785be05b$export$a34d87b9aaeedd46 = function() {
    function PolygonShape() {
        this.points = null;
        this.smooth = 0;
        this.smoothConstraint = null;
    }
    return PolygonShape;
}();
var $dbc82dce785be05b$var$Polygon = function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(Polygon, _super);
    function Polygon(opts) {
        return _super.call(this, opts) || this;
    }
    Polygon.prototype.getDefaultShape = function() {
        return new $dbc82dce785be05b$export$a34d87b9aaeedd46();
    };
    Polygon.prototype.buildPath = function(ctx, shape) {
        $8413c37f5fa06398$export$5cc7f731b5937e99(ctx, shape, true);
    };
    return Polygon;
}((0, $227e31075465dcd4$export$2e2bcd8739ae039));
$dbc82dce785be05b$var$Polygon.prototype.type = "polygon";
var $dbc82dce785be05b$export$2e2bcd8739ae039 = $dbc82dce785be05b$var$Polygon;





var $363f38bff4966f60$export$e9e5cc3985e19d11 = function() {
    function PolylineShape() {
        this.points = null;
        this.percent = 1;
        this.smooth = 0;
        this.smoothConstraint = null;
    }
    return PolylineShape;
}();
var $363f38bff4966f60$var$Polyline = function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(Polyline, _super);
    function Polyline(opts) {
        return _super.call(this, opts) || this;
    }
    Polyline.prototype.getDefaultStyle = function() {
        return {
            stroke: "#000",
            fill: null
        };
    };
    Polyline.prototype.getDefaultShape = function() {
        return new $363f38bff4966f60$export$e9e5cc3985e19d11();
    };
    Polyline.prototype.buildPath = function(ctx, shape) {
        $8413c37f5fa06398$export$5cc7f731b5937e99(ctx, shape, false);
    };
    return Polyline;
}((0, $227e31075465dcd4$export$2e2bcd8739ae039));
$363f38bff4966f60$var$Polyline.prototype.type = "polyline";
var $363f38bff4966f60$export$2e2bcd8739ae039 = $363f38bff4966f60$var$Polyline;






var $0e0ee2afac2bc66d$var$subPixelOptimizeOutputShape = {};
var $0e0ee2afac2bc66d$export$64b674d0815308 = function() {
    function LineShape() {
        this.x1 = 0;
        this.y1 = 0;
        this.x2 = 0;
        this.y2 = 0;
        this.percent = 1;
    }
    return LineShape;
}();
var $0e0ee2afac2bc66d$var$Line = function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(Line, _super);
    function Line(opts) {
        return _super.call(this, opts) || this;
    }
    Line.prototype.getDefaultStyle = function() {
        return {
            stroke: "#000",
            fill: null
        };
    };
    Line.prototype.getDefaultShape = function() {
        return new $0e0ee2afac2bc66d$export$64b674d0815308();
    };
    Line.prototype.buildPath = function(ctx, shape) {
        var x1;
        var y1;
        var x2;
        var y2;
        if (this.subPixelOptimize) {
            var optimizedShape = (0, $4e772fb15506b6bd$export$8b4b620d7f4aad1b)($0e0ee2afac2bc66d$var$subPixelOptimizeOutputShape, shape, this.style);
            x1 = optimizedShape.x1;
            y1 = optimizedShape.y1;
            x2 = optimizedShape.x2;
            y2 = optimizedShape.y2;
        } else {
            x1 = shape.x1;
            y1 = shape.y1;
            x2 = shape.x2;
            y2 = shape.y2;
        }
        var percent = shape.percent;
        if (percent === 0) return;
        ctx.moveTo(x1, y1);
        if (percent < 1) {
            x2 = x1 * (1 - percent) + x2 * percent;
            y2 = y1 * (1 - percent) + y2 * percent;
        }
        ctx.lineTo(x2, y2);
    };
    Line.prototype.pointAt = function(p) {
        var shape = this.shape;
        return [
            shape.x1 * (1 - p) + shape.x2 * p,
            shape.y1 * (1 - p) + shape.y2 * p
        ];
    };
    return Line;
}((0, $227e31075465dcd4$export$2e2bcd8739ae039));
$0e0ee2afac2bc66d$var$Line.prototype.type = "line";
var $0e0ee2afac2bc66d$export$2e2bcd8739ae039 = $0e0ee2afac2bc66d$var$Line;






var $57c0d9f749c3a837$var$out = [];
var $57c0d9f749c3a837$export$e10089729fef29aa = function() {
    function BezierCurveShape() {
        this.x1 = 0;
        this.y1 = 0;
        this.x2 = 0;
        this.y2 = 0;
        this.cpx1 = 0;
        this.cpy1 = 0;
        this.percent = 1;
    }
    return BezierCurveShape;
}();
function $57c0d9f749c3a837$var$someVectorAt(shape, t, isTangent) {
    var cpx2 = shape.cpx2;
    var cpy2 = shape.cpy2;
    if (cpx2 != null || cpy2 != null) return [
        (isTangent ? (0, $3dec70ca5f6b6e8f$export$55fce925c60b6271) : (0, $3dec70ca5f6b6e8f$export$547c21de482bbcb2))(shape.x1, shape.cpx1, shape.cpx2, shape.x2, t),
        (isTangent ? (0, $3dec70ca5f6b6e8f$export$55fce925c60b6271) : (0, $3dec70ca5f6b6e8f$export$547c21de482bbcb2))(shape.y1, shape.cpy1, shape.cpy2, shape.y2, t)
    ];
    else return [
        (isTangent ? (0, $3dec70ca5f6b6e8f$export$7e161e77e6fff8cb) : (0, $3dec70ca5f6b6e8f$export$af17094a950f5073))(shape.x1, shape.cpx1, shape.x2, t),
        (isTangent ? (0, $3dec70ca5f6b6e8f$export$7e161e77e6fff8cb) : (0, $3dec70ca5f6b6e8f$export$af17094a950f5073))(shape.y1, shape.cpy1, shape.y2, t)
    ];
}
var $57c0d9f749c3a837$var$BezierCurve = function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(BezierCurve, _super);
    function BezierCurve(opts) {
        return _super.call(this, opts) || this;
    }
    BezierCurve.prototype.getDefaultStyle = function() {
        return {
            stroke: "#000",
            fill: null
        };
    };
    BezierCurve.prototype.getDefaultShape = function() {
        return new $57c0d9f749c3a837$export$e10089729fef29aa();
    };
    BezierCurve.prototype.buildPath = function(ctx, shape) {
        var x1 = shape.x1;
        var y1 = shape.y1;
        var x2 = shape.x2;
        var y2 = shape.y2;
        var cpx1 = shape.cpx1;
        var cpy1 = shape.cpy1;
        var cpx2 = shape.cpx2;
        var cpy2 = shape.cpy2;
        var percent = shape.percent;
        if (percent === 0) return;
        ctx.moveTo(x1, y1);
        if (cpx2 == null || cpy2 == null) {
            if (percent < 1) {
                (0, $3dec70ca5f6b6e8f$export$117c659e21a7a060)(x1, cpx1, x2, percent, $57c0d9f749c3a837$var$out);
                cpx1 = $57c0d9f749c3a837$var$out[1];
                x2 = $57c0d9f749c3a837$var$out[2];
                (0, $3dec70ca5f6b6e8f$export$117c659e21a7a060)(y1, cpy1, y2, percent, $57c0d9f749c3a837$var$out);
                cpy1 = $57c0d9f749c3a837$var$out[1];
                y2 = $57c0d9f749c3a837$var$out[2];
            }
            ctx.quadraticCurveTo(cpx1, cpy1, x2, y2);
        } else {
            if (percent < 1) {
                (0, $3dec70ca5f6b6e8f$export$a2ee23a0567039da)(x1, cpx1, cpx2, x2, percent, $57c0d9f749c3a837$var$out);
                cpx1 = $57c0d9f749c3a837$var$out[1];
                cpx2 = $57c0d9f749c3a837$var$out[2];
                x2 = $57c0d9f749c3a837$var$out[3];
                (0, $3dec70ca5f6b6e8f$export$a2ee23a0567039da)(y1, cpy1, cpy2, y2, percent, $57c0d9f749c3a837$var$out);
                cpy1 = $57c0d9f749c3a837$var$out[1];
                cpy2 = $57c0d9f749c3a837$var$out[2];
                y2 = $57c0d9f749c3a837$var$out[3];
            }
            ctx.bezierCurveTo(cpx1, cpy1, cpx2, cpy2, x2, y2);
        }
    };
    BezierCurve.prototype.pointAt = function(t) {
        return $57c0d9f749c3a837$var$someVectorAt(this.shape, t, false);
    };
    BezierCurve.prototype.tangentAt = function(t) {
        var p = $57c0d9f749c3a837$var$someVectorAt(this.shape, t, true);
        return $ee491d8f32bd01ff$export$a3295358bff77e(p, p);
    };
    return BezierCurve;
}((0, $227e31075465dcd4$export$2e2bcd8739ae039));
$57c0d9f749c3a837$var$BezierCurve.prototype.type = "bezier-curve";
var $57c0d9f749c3a837$export$2e2bcd8739ae039 = $57c0d9f749c3a837$var$BezierCurve;




var $d0a314b008adf9ab$export$a259dbdc51948277 = function() {
    function ArcShape() {
        this.cx = 0;
        this.cy = 0;
        this.r = 0;
        this.startAngle = 0;
        this.endAngle = Math.PI * 2;
        this.clockwise = true;
    }
    return ArcShape;
}();
var $d0a314b008adf9ab$var$Arc = function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(Arc, _super);
    function Arc(opts) {
        return _super.call(this, opts) || this;
    }
    Arc.prototype.getDefaultStyle = function() {
        return {
            stroke: "#000",
            fill: null
        };
    };
    Arc.prototype.getDefaultShape = function() {
        return new $d0a314b008adf9ab$export$a259dbdc51948277();
    };
    Arc.prototype.buildPath = function(ctx, shape) {
        var x = shape.cx;
        var y = shape.cy;
        var r = Math.max(shape.r, 0);
        var startAngle = shape.startAngle;
        var endAngle = shape.endAngle;
        var clockwise = shape.clockwise;
        var unitX = Math.cos(startAngle);
        var unitY = Math.sin(startAngle);
        ctx.moveTo(unitX * r + x, unitY * r + y);
        ctx.arc(x, y, r, startAngle, endAngle, !clockwise);
    };
    return Arc;
}((0, $227e31075465dcd4$export$2e2bcd8739ae039));
$d0a314b008adf9ab$var$Arc.prototype.type = "arc";
var $d0a314b008adf9ab$export$2e2bcd8739ae039 = $d0a314b008adf9ab$var$Arc;




var $21e4011e695d4132$var$CompoundPath = function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(CompoundPath, _super);
    function CompoundPath() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = "compound";
        return _this;
    }
    CompoundPath.prototype._updatePathDirty = function() {
        var paths = this.shape.paths;
        var dirtyPath = this.shapeChanged();
        for(var i = 0; i < paths.length; i++)dirtyPath = dirtyPath || paths[i].shapeChanged();
        if (dirtyPath) this.dirtyShape();
    };
    CompoundPath.prototype.beforeBrush = function() {
        this._updatePathDirty();
        var paths = this.shape.paths || [];
        var scale = this.getGlobalScale();
        for(var i = 0; i < paths.length; i++){
            if (!paths[i].path) paths[i].createPathProxy();
            paths[i].path.setScale(scale[0], scale[1], paths[i].segmentIgnoreThreshold);
        }
    };
    CompoundPath.prototype.buildPath = function(ctx, shape) {
        var paths = shape.paths || [];
        for(var i = 0; i < paths.length; i++)paths[i].buildPath(ctx, paths[i].shape, true);
    };
    CompoundPath.prototype.afterBrush = function() {
        var paths = this.shape.paths || [];
        for(var i = 0; i < paths.length; i++)paths[i].pathUpdated();
    };
    CompoundPath.prototype.getBoundingRect = function() {
        this._updatePathDirty.call(this);
        return (0, $227e31075465dcd4$export$2e2bcd8739ae039).prototype.getBoundingRect.call(this);
    };
    return CompoundPath;
}((0, $227e31075465dcd4$export$2e2bcd8739ae039));
var $21e4011e695d4132$export$2e2bcd8739ae039 = $21e4011e695d4132$var$CompoundPath;



var $1950e9a1fc3af1da$var$Gradient = function() {
    function Gradient(colorStops) {
        this.colorStops = colorStops || [];
    }
    Gradient.prototype.addColorStop = function(offset, color) {
        this.colorStops.push({
            offset: offset,
            color: color
        });
    };
    return Gradient;
}();
var $1950e9a1fc3af1da$export$2e2bcd8739ae039 = $1950e9a1fc3af1da$var$Gradient;


var $9cb489c6746d60b7$var$LinearGradient = function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(LinearGradient, _super);
    function LinearGradient(x, y, x2, y2, colorStops, globalCoord) {
        var _this = _super.call(this, colorStops) || this;
        _this.x = x == null ? 0 : x;
        _this.y = y == null ? 0 : y;
        _this.x2 = x2 == null ? 1 : x2;
        _this.y2 = y2 == null ? 0 : y2;
        _this.type = "linear";
        _this.global = globalCoord || false;
        return _this;
    }
    return LinearGradient;
}((0, $1950e9a1fc3af1da$export$2e2bcd8739ae039));
var $9cb489c6746d60b7$export$2e2bcd8739ae039 = $9cb489c6746d60b7$var$LinearGradient;




var $675bf9bc44bcf0b5$var$RadialGradient = function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(RadialGradient, _super);
    function RadialGradient(x, y, r, colorStops, globalCoord) {
        var _this = _super.call(this, colorStops) || this;
        _this.x = x == null ? 0.5 : x;
        _this.y = y == null ? 0.5 : y;
        _this.r = r == null ? 0.5 : r;
        _this.type = "radial";
        _this.global = globalCoord || false;
        return _this;
    }
    return RadialGradient;
}((0, $1950e9a1fc3af1da$export$2e2bcd8739ae039));
var $675bf9bc44bcf0b5$export$2e2bcd8739ae039 = $675bf9bc44bcf0b5$var$RadialGradient;





var $babb2d949c53d85d$var$mathMin = Math.min;
var $babb2d949c53d85d$var$mathMax = Math.max;
var $babb2d949c53d85d$var$mathAbs = Math.abs;
var $babb2d949c53d85d$var$_extent = [
    0,
    0
];
var $babb2d949c53d85d$var$_extent2 = [
    0,
    0
];
var $babb2d949c53d85d$var$_intersectCtx = (0, $c437f598d9c9ee16$export$a0be2bdbd2369e0e)();
var $babb2d949c53d85d$var$_minTv = $babb2d949c53d85d$var$_intersectCtx.minTv;
var $babb2d949c53d85d$var$_maxTv = $babb2d949c53d85d$var$_intersectCtx.maxTv;
var $babb2d949c53d85d$var$OrientedBoundingRect = function() {
    function OrientedBoundingRect(rect, transform) {
        this._corners = [];
        this._axes = [];
        this._origin = [
            0,
            0
        ];
        for(var i = 0; i < 4; i++)this._corners[i] = new (0, $1de2ad08c108b7c2$export$2e2bcd8739ae039)();
        for(var i = 0; i < 2; i++)this._axes[i] = new (0, $1de2ad08c108b7c2$export$2e2bcd8739ae039)();
        if (rect) this.fromBoundingRect(rect, transform);
    }
    OrientedBoundingRect.prototype.fromBoundingRect = function(rect, transform) {
        var corners = this._corners;
        var axes = this._axes;
        var x = rect.x;
        var y = rect.y;
        var x2 = x + rect.width;
        var y2 = y + rect.height;
        corners[0].set(x, y);
        corners[1].set(x2, y);
        corners[2].set(x2, y2);
        corners[3].set(x, y2);
        if (transform) for(var i = 0; i < 4; i++)corners[i].transform(transform);
        (0, $1de2ad08c108b7c2$export$2e2bcd8739ae039).sub(axes[0], corners[1], corners[0]);
        (0, $1de2ad08c108b7c2$export$2e2bcd8739ae039).sub(axes[1], corners[3], corners[0]);
        axes[0].normalize();
        axes[1].normalize();
        for(var i = 0; i < 2; i++)this._origin[i] = axes[i].dot(corners[0]);
    };
    OrientedBoundingRect.prototype.intersect = function(other, mtv, opt) {
        var overlapped = true;
        var noMtv = !mtv;
        if (mtv) (0, $1de2ad08c108b7c2$export$2e2bcd8739ae039).set(mtv, 0, 0);
        $babb2d949c53d85d$var$_intersectCtx.reset(opt, !noMtv);
        if (!this._intersectCheckOneSide(this, other, noMtv, 1)) {
            overlapped = false;
            if (noMtv) return overlapped;
        }
        if (!this._intersectCheckOneSide(other, this, noMtv, -1)) {
            overlapped = false;
            if (noMtv) return overlapped;
        }
        if (!noMtv && !$babb2d949c53d85d$var$_intersectCtx.negativeSize) (0, $1de2ad08c108b7c2$export$2e2bcd8739ae039).copy(mtv, overlapped ? $babb2d949c53d85d$var$_intersectCtx.useDir ? $babb2d949c53d85d$var$_intersectCtx.dirMinTv : $babb2d949c53d85d$var$_minTv : $babb2d949c53d85d$var$_maxTv);
        return overlapped;
    };
    OrientedBoundingRect.prototype._intersectCheckOneSide = function(self, other, noMtv, inverse) {
        var overlapped = true;
        for(var i = 0; i < 2; i++){
            var axis = self._axes[i];
            self._getProjMinMaxOnAxis(i, self._corners, $babb2d949c53d85d$var$_extent);
            self._getProjMinMaxOnAxis(i, other._corners, $babb2d949c53d85d$var$_extent2);
            if ($babb2d949c53d85d$var$_intersectCtx.negativeSize || $babb2d949c53d85d$var$_extent[1] < $babb2d949c53d85d$var$_extent2[0] || $babb2d949c53d85d$var$_extent[0] > $babb2d949c53d85d$var$_extent2[1]) {
                overlapped = false;
                if ($babb2d949c53d85d$var$_intersectCtx.negativeSize || noMtv) return overlapped;
                var dist0 = $babb2d949c53d85d$var$mathAbs($babb2d949c53d85d$var$_extent2[0] - $babb2d949c53d85d$var$_extent[1]);
                var dist1 = $babb2d949c53d85d$var$mathAbs($babb2d949c53d85d$var$_extent[0] - $babb2d949c53d85d$var$_extent2[1]);
                if ($babb2d949c53d85d$var$mathMin(dist0, dist1) > $babb2d949c53d85d$var$_maxTv.len()) {
                    if (dist0 < dist1) (0, $1de2ad08c108b7c2$export$2e2bcd8739ae039).scale($babb2d949c53d85d$var$_maxTv, axis, -dist0 * inverse);
                    else (0, $1de2ad08c108b7c2$export$2e2bcd8739ae039).scale($babb2d949c53d85d$var$_maxTv, axis, dist1 * inverse);
                }
            } else if (!noMtv) {
                var dist0 = $babb2d949c53d85d$var$mathAbs($babb2d949c53d85d$var$_extent2[0] - $babb2d949c53d85d$var$_extent[1]);
                var dist1 = $babb2d949c53d85d$var$mathAbs($babb2d949c53d85d$var$_extent[0] - $babb2d949c53d85d$var$_extent2[1]);
                if ($babb2d949c53d85d$var$_intersectCtx.useDir || $babb2d949c53d85d$var$mathMin(dist0, dist1) < $babb2d949c53d85d$var$_minTv.len()) {
                    if (dist0 < dist1 || !$babb2d949c53d85d$var$_intersectCtx.bidirectional) {
                        (0, $1de2ad08c108b7c2$export$2e2bcd8739ae039).scale($babb2d949c53d85d$var$_minTv, axis, dist0 * inverse);
                        if ($babb2d949c53d85d$var$_intersectCtx.useDir) $babb2d949c53d85d$var$_intersectCtx.calcDirMTV();
                    }
                    if (dist0 >= dist1 || !$babb2d949c53d85d$var$_intersectCtx.bidirectional) {
                        (0, $1de2ad08c108b7c2$export$2e2bcd8739ae039).scale($babb2d949c53d85d$var$_minTv, axis, -dist1 * inverse);
                        if ($babb2d949c53d85d$var$_intersectCtx.useDir) $babb2d949c53d85d$var$_intersectCtx.calcDirMTV();
                    }
                }
            }
        }
        return overlapped;
    };
    OrientedBoundingRect.prototype._getProjMinMaxOnAxis = function(dim, corners, out) {
        var axis = this._axes[dim];
        var origin = this._origin;
        var proj = corners[0].dot(axis) + origin[dim];
        var min = proj;
        var max = proj;
        for(var i = 1; i < corners.length; i++){
            var proj_1 = corners[i].dot(axis) + origin[dim];
            min = $babb2d949c53d85d$var$mathMin(proj_1, min);
            max = $babb2d949c53d85d$var$mathMax(proj_1, max);
        }
        out[0] = min + $babb2d949c53d85d$var$_intersectCtx.touchThreshold;
        out[1] = max - $babb2d949c53d85d$var$_intersectCtx.touchThreshold;
        $babb2d949c53d85d$var$_intersectCtx.negativeSize = out[1] < out[0];
    };
    return OrientedBoundingRect;
}();
var $babb2d949c53d85d$export$2e2bcd8739ae039 = $babb2d949c53d85d$var$OrientedBoundingRect;






var $0f043989b8b0b396$export$2dc95e9f4fd018cd = 0;
var $0f043989b8b0b396$export$a0377e544ceae7da = 1;
var $0f043989b8b0b396$export$f2b95933e1444751 = 2;
var $0f043989b8b0b396$export$5bf503311eda4292 = 1;
var $0f043989b8b0b396$export$63f5564428138c5e = 0;


var $afb0e0140d20f85a$var$m = [];
var $afb0e0140d20f85a$var$IncrementalDisplayable = function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(IncrementalDisplayable, _super);
    function IncrementalDisplayable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.notClear = true;
        _this.incremental = (0, $0f043989b8b0b396$export$a0377e544ceae7da);
        _this._displayables = [];
        _this._temporaryDisplayables = [];
        _this._cursor = 0;
        return _this;
    }
    IncrementalDisplayable.prototype.traverse = function(cb, context) {
        cb.call(context, this);
    };
    IncrementalDisplayable.prototype.useStyle = function() {
        this.style = {};
    };
    IncrementalDisplayable.prototype._useHoverStyle = function() {
        this.__hoverStyle = null;
    };
    IncrementalDisplayable.prototype.getCursor = function() {
        return this._cursor;
    };
    IncrementalDisplayable.prototype.innerAfterBrush = function() {
        this._cursor = this._displayables.length;
    };
    IncrementalDisplayable.prototype.clearDisplaybles = function() {
        this._displayables = [];
        this._temporaryDisplayables = [];
        this._cursor = 0;
        this.markRedraw();
        this.notClear = false;
    };
    IncrementalDisplayable.prototype.clearTemporalDisplayables = function() {
        this._temporaryDisplayables = [];
    };
    IncrementalDisplayable.prototype.addDisplayable = function(displayable, notPersistent) {
        if (notPersistent) this._temporaryDisplayables.push(displayable);
        else this._displayables.push(displayable);
        this.markRedraw();
    };
    IncrementalDisplayable.prototype.addDisplayables = function(displayables, notPersistent) {
        notPersistent = notPersistent || false;
        for(var i = 0; i < displayables.length; i++)this.addDisplayable(displayables[i], notPersistent);
    };
    IncrementalDisplayable.prototype.getDisplayables = function() {
        return this._displayables;
    };
    IncrementalDisplayable.prototype.getTemporalDisplayables = function() {
        return this._temporaryDisplayables;
    };
    IncrementalDisplayable.prototype.eachPendingDisplayable = function(cb) {
        for(var i = this._cursor; i < this._displayables.length; i++)cb && cb(this._displayables[i]);
        for(var i = 0; i < this._temporaryDisplayables.length; i++)cb && cb(this._temporaryDisplayables[i]);
    };
    IncrementalDisplayable.prototype.update = function() {
        this.updateTransform();
        for(var i = this._cursor; i < this._displayables.length; i++){
            var displayable = this._displayables[i];
            displayable.parent = this;
            displayable.update();
            displayable.parent = null;
        }
        for(var i = 0; i < this._temporaryDisplayables.length; i++){
            var displayable = this._temporaryDisplayables[i];
            displayable.parent = this;
            displayable.update();
            displayable.parent = null;
        }
    };
    IncrementalDisplayable.prototype.getBoundingRect = function() {
        if (!this._rect) {
            var rect = new (0, $c437f598d9c9ee16$export$2e2bcd8739ae039)(Infinity, Infinity, -Infinity, -Infinity);
            for(var i = 0; i < this._displayables.length; i++){
                var displayable = this._displayables[i];
                var childRect = displayable.getBoundingRect().clone();
                if (displayable.needLocalTransform()) childRect.applyTransform(displayable.getLocalTransform($afb0e0140d20f85a$var$m));
                rect.union(childRect);
            }
            this._rect = rect;
        }
        return this._rect;
    };
    IncrementalDisplayable.prototype.contain = function(x, y) {
        var localPos = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        if (rect.contain(localPos[0], localPos[1])) for(var i = 0; i < this._displayables.length; i++){
            var displayable = this._displayables[i];
            if (displayable.contain(x, y)) return true;
        }
        return false;
    };
    return IncrementalDisplayable;
}((0, $4773d393c538283c$export$2e2bcd8739ae039));
var $afb0e0140d20f85a$export$2e2bcd8739ae039 = $afb0e0140d20f85a$var$IncrementalDisplayable;







var $6552edac5ca572b1$var$_customShapeMap = {};
var $6552edac5ca572b1$export$cb4c12294149dd2d = [
    "x",
    "y"
];
var $6552edac5ca572b1$export$a3fe6d967173a3ac = [
    "width",
    "height"
];
var $6552edac5ca572b1$export$3e67317617241636 = 0;
var $6552edac5ca572b1$export$3c339ce201e4ce4d = 1;
var $6552edac5ca572b1$export$2ed770cec6ef78e8 = 2;
function $6552edac5ca572b1$export$d0d5398c9d612037(opts) {
    return (0, $227e31075465dcd4$export$2e2bcd8739ae039).extend(opts);
}
var $6552edac5ca572b1$var$extendPathFromString = $4656fa00e972eae8$export$68e3a51ba2ed417c;
function $6552edac5ca572b1$export$53b54a3137026af0(pathData, opts) {
    return $6552edac5ca572b1$var$extendPathFromString(pathData, opts);
}
function $6552edac5ca572b1$export$2b95b62e3aaf6fdd(name, ShapeClass) {
    $6552edac5ca572b1$var$_customShapeMap[name] = ShapeClass;
}
function $6552edac5ca572b1$export$51df4b5565a58189(name) {
    if ($6552edac5ca572b1$var$_customShapeMap.hasOwnProperty(name)) return $6552edac5ca572b1$var$_customShapeMap[name];
}
function $6552edac5ca572b1$export$aa9bab72412f5613(pathData, opts, rect, layout) {
    var path = $4656fa00e972eae8$export$ae5b259626f00aeb(pathData, opts);
    if (rect) {
        if (layout === "center") rect = $6552edac5ca572b1$var$centerGraphic(rect, path.getBoundingRect());
        $6552edac5ca572b1$export$566dbf1c62b04fc7(path, rect);
    }
    return path;
}
function $6552edac5ca572b1$export$7a2bdede98851ac5(imageUrl, rect, layout) {
    var zrImg = new (0, $d3b0315ae8e8e298$export$2e2bcd8739ae039)({
        style: {
            image: imageUrl,
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height
        },
        onload: function(img) {
            if (layout === "center") {
                var boundingRect = {
                    width: img.width,
                    height: img.height
                };
                zrImg.setStyle($6552edac5ca572b1$var$centerGraphic(rect, boundingRect));
            }
        }
    });
    return zrImg;
}
/**
 * Get position of centered element in bounding box.
 *
 * @param  rect         element local bounding box
 * @param  boundingRect constraint bounding box
 * @return element position containing x, y, width, and height
 */ function $6552edac5ca572b1$var$centerGraphic(rect, boundingRect) {
    // Set rect to center, keep width / height ratio.
    var aspect = boundingRect.width / boundingRect.height;
    var width = rect.height * aspect;
    var height;
    if (width <= rect.width) height = rect.height;
    else {
        width = rect.width;
        height = width / aspect;
    }
    var cx = rect.x + rect.width / 2;
    var cy = rect.y + rect.height / 2;
    return {
        x: cx - width / 2,
        y: cy - height / 2,
        width: width,
        height: height
    };
}
var $6552edac5ca572b1$export$7b1dd269fbc4e903 = $4656fa00e972eae8$export$7b1dd269fbc4e903;
function $6552edac5ca572b1$export$566dbf1c62b04fc7(path, rect) {
    if (!path.applyTransform) return;
    var pathRect = path.getBoundingRect();
    var m = pathRect.calculateTransform(rect);
    path.applyTransform(m);
}
function $6552edac5ca572b1$export$8b4b620d7f4aad1b(shape, lineWidth) {
    $4e772fb15506b6bd$export$8b4b620d7f4aad1b(shape, shape, {
        lineWidth: lineWidth
    });
    return shape;
}
function $6552edac5ca572b1$export$60e2aa74957d0b9d(shape, style) {
    $4e772fb15506b6bd$export$60e2aa74957d0b9d(shape, shape, style);
    return shape;
}
var $6552edac5ca572b1$export$72c4fd4c1b8fcb10 = $4e772fb15506b6bd$export$72c4fd4c1b8fcb10;
function $6552edac5ca572b1$export$fce0c6cfca85ed96(target, ancestor) {
    var mat = $87ac8de5537d9a34$export$f0954fd7d5368655([]);
    while(target && target !== ancestor){
        $87ac8de5537d9a34$export$6e3a27864ab166fe(mat, target.getLocalTransform(), mat);
        target = target.parent;
    }
    return mat;
}
function $6552edac5ca572b1$export$9f9dcb98c894b623(target, transform, invert) {
    if (transform && !(0, $43e0a445ed6711da$export$1e2f57719e155213)(transform)) transform = (0, $cca2e8cc539372e0$export$2e2bcd8739ae039).getLocalTransform(transform);
    if (invert) transform = $87ac8de5537d9a34$export$6897c284b6f9f4dc([], transform);
    return $ee491d8f32bd01ff$export$9f9dcb98c894b623([], target, transform);
}
function $6552edac5ca572b1$export$fff94e9792354cfa(direction, transform, invert) {
    // Pick a base, ensure that transform result will not be (0, 0).
    var hBase = transform[4] === 0 || transform[5] === 0 || transform[0] === 0 ? 1 : (0, $b49750109e236fd8$export$5860c226b237d9a6)(2 * transform[4] / transform[0]);
    var vBase = transform[4] === 0 || transform[5] === 0 || transform[2] === 0 ? 1 : (0, $b49750109e236fd8$export$5860c226b237d9a6)(2 * transform[4] / transform[2]);
    var vertex = [
        direction === "left" ? -hBase : direction === "right" ? hBase : 0,
        direction === "top" ? -vBase : direction === "bottom" ? vBase : 0
    ];
    vertex = $6552edac5ca572b1$export$9f9dcb98c894b623(vertex, transform, invert);
    return (0, $b49750109e236fd8$export$5860c226b237d9a6)(vertex[0]) > (0, $b49750109e236fd8$export$5860c226b237d9a6)(vertex[1]) ? vertex[0] > 0 ? "right" : "left" : vertex[1] > 0 ? "bottom" : "top";
}
function $6552edac5ca572b1$var$isNotGroup(el) {
    return !el.isGroup;
}
function $6552edac5ca572b1$var$isPath(el) {
    return el.shape != null;
}
function $6552edac5ca572b1$export$64fcab7860c216ae(g1, g2, animatableModel) {
    if (!g1 || !g2) return;
    function getElMap(g) {
        var elMap = {};
        g.traverse(function(el) {
            if ($6552edac5ca572b1$var$isNotGroup(el) && el.anid) elMap[el.anid] = el;
        });
        return elMap;
    }
    function getAnimatableProps(el) {
        var obj = {
            x: el.x,
            y: el.y,
            rotation: el.rotation
        };
        if ($6552edac5ca572b1$var$isPath(el)) obj.shape = (0, $43e0a445ed6711da$export$9cd59f9826255e47)(el.shape);
        return obj;
    }
    var elMap1 = getElMap(g1);
    g2.traverse(function(el) {
        if ($6552edac5ca572b1$var$isNotGroup(el) && el.anid) {
            var oldEl = elMap1[el.anid];
            if (oldEl) {
                var newProp = getAnimatableProps(el);
                el.attr(getAnimatableProps(oldEl));
                (0, $4feffdaaa31d998e$export$c8dce3c08436e91e)(el, newProp, animatableModel, (0, $7e4afcfca8f5121f$export$b1c39b2bacd1ddc2)(el).dataIndex);
            }
        }
    });
}
function $6552edac5ca572b1$export$e2f409471bbbc1dc(points, rect) {
    // FIXME: This way might be incorrect when graphic clipped by a corner
    // and when element has a border.
    return (0, $43e0a445ed6711da$export$871de8747c9eaa88)(points, function(point) {
        var x = point[0];
        x = (0, $b49750109e236fd8$export$2ca8010d037f830f)(x, rect.x);
        x = (0, $b49750109e236fd8$export$e411eeaf23dccbe8)(x, rect.x + rect.width);
        var y = point[1];
        y = (0, $b49750109e236fd8$export$2ca8010d037f830f)(y, rect.y);
        y = (0, $b49750109e236fd8$export$e411eeaf23dccbe8)(y, rect.y + rect.height);
        return [
            x,
            y
        ];
    });
}
function $6552edac5ca572b1$export$d0d3709202b8b2a(targetRect, rect) {
    var x = (0, $b49750109e236fd8$export$2ca8010d037f830f)(targetRect.x, rect.x);
    var x2 = (0, $b49750109e236fd8$export$e411eeaf23dccbe8)(targetRect.x + targetRect.width, rect.x + rect.width);
    var y = (0, $b49750109e236fd8$export$2ca8010d037f830f)(targetRect.y, rect.y);
    var y2 = (0, $b49750109e236fd8$export$e411eeaf23dccbe8)(targetRect.y + targetRect.height, rect.y + rect.height);
    // If the total rect is cliped, nothing, including the border,
    // should be painted. So return undefined.
    if (x2 >= x && y2 >= y) return {
        x: x,
        y: y,
        width: x2 - x,
        height: y2 - y
    };
}
function $6552edac5ca572b1$export$274edc73af1ae9c8(iconStr, // Support 'image://' or 'path://' or direct svg path.
opt, rect) {
    var innerOpts = (0, $43e0a445ed6711da$export$8b58be045bf06082)({
        rectHover: true
    }, opt);
    var style = innerOpts.style = {
        strokeNoScale: true
    };
    rect = rect || {
        x: -1,
        y: -1,
        width: 2,
        height: 2
    };
    if (iconStr) return iconStr.indexOf("image://") === 0 ? (style.image = iconStr.slice(8), (0, $43e0a445ed6711da$export$ebe90cb607ad99e)(style, rect), new (0, $d3b0315ae8e8e298$export$2e2bcd8739ae039)(innerOpts)) : $6552edac5ca572b1$export$aa9bab72412f5613(iconStr.replace("path://", ""), innerOpts, rect, "center");
}
function $6552edac5ca572b1$export$4f47c855a5e9ae9(a1x, a1y, a2x, a2y, points) {
    for(var i = 0, p2 = points[points.length - 1]; i < points.length; i++){
        var p = points[i];
        if ($6552edac5ca572b1$export$6c0a70ea1d8d158b(a1x, a1y, a2x, a2y, p[0], p[1], p2[0], p2[1])) return true;
        p2 = p;
    }
}
function $6552edac5ca572b1$export$6c0a70ea1d8d158b(a1x, a1y, a2x, a2y, b1x, b1y, b2x, b2y) {
    // let `vec_m` to be `vec_a2 - vec_a1` and `vec_n` to be `vec_b2 - vec_b1`.
    var mx = a2x - a1x;
    var my = a2y - a1y;
    var nx = b2x - b1x;
    var ny = b2y - b1y;
    // `vec_m` and `vec_n` are parallel iff
    //     existing `k` such that `vec_m = k · vec_n`, equivalent to `vec_m X vec_n = 0`.
    var nmCrossProduct = $6552edac5ca572b1$var$crossProduct2d(nx, ny, mx, my);
    if ($6552edac5ca572b1$var$nearZero(nmCrossProduct)) return false;
    // `vec_m` and `vec_n` are intersect iff
    //     existing `p` and `q` in [0, 1] such that `vec_a1 + p * vec_m = vec_b1 + q * vec_n`,
    //     such that `q = ((vec_a1 - vec_b1) X vec_m) / (vec_n X vec_m)`
    //           and `p = ((vec_a1 - vec_b1) X vec_n) / (vec_n X vec_m)`.
    var b1a1x = a1x - b1x;
    var b1a1y = a1y - b1y;
    var q = $6552edac5ca572b1$var$crossProduct2d(b1a1x, b1a1y, mx, my) / nmCrossProduct;
    if (q < 0 || q > 1) return false;
    var p = $6552edac5ca572b1$var$crossProduct2d(b1a1x, b1a1y, nx, ny) / nmCrossProduct;
    if (p < 0 || p > 1) return false;
    return true;
}
/**
 * Cross product of 2-dimension vector.
 */ function $6552edac5ca572b1$var$crossProduct2d(x1, y1, x2, y2) {
    return x1 * y2 - x2 * y1;
}
function $6552edac5ca572b1$var$nearZero(val) {
    return val <= 1e-6 && val >= -0.000001;
}
function $6552edac5ca572b1$export$81ed941fdeb91c7c(rect, delta, shrinkOrExpand, noNegative, minSize // by default [0, 0].
) {
    if (delta == null) return rect;
    else if ((0, $43e0a445ed6711da$export$7e4aa119212bc614)(delta)) $6552edac5ca572b1$var$_tmpExpandRectDelta[0] = $6552edac5ca572b1$var$_tmpExpandRectDelta[1] = $6552edac5ca572b1$var$_tmpExpandRectDelta[2] = $6552edac5ca572b1$var$_tmpExpandRectDelta[3] = delta;
    else {
        $6552edac5ca572b1$var$_tmpExpandRectDelta[0] = delta[0];
        $6552edac5ca572b1$var$_tmpExpandRectDelta[1] = delta[1];
        $6552edac5ca572b1$var$_tmpExpandRectDelta[2] = delta[2];
        $6552edac5ca572b1$var$_tmpExpandRectDelta[3] = delta[3];
    }
    if (noNegative) {
        $6552edac5ca572b1$var$_tmpExpandRectDelta[0] = (0, $b49750109e236fd8$export$2ca8010d037f830f)(0, $6552edac5ca572b1$var$_tmpExpandRectDelta[0]);
        $6552edac5ca572b1$var$_tmpExpandRectDelta[1] = (0, $b49750109e236fd8$export$2ca8010d037f830f)(0, $6552edac5ca572b1$var$_tmpExpandRectDelta[1]);
        $6552edac5ca572b1$var$_tmpExpandRectDelta[2] = (0, $b49750109e236fd8$export$2ca8010d037f830f)(0, $6552edac5ca572b1$var$_tmpExpandRectDelta[2]);
        $6552edac5ca572b1$var$_tmpExpandRectDelta[3] = (0, $b49750109e236fd8$export$2ca8010d037f830f)(0, $6552edac5ca572b1$var$_tmpExpandRectDelta[3]);
    }
    if (shrinkOrExpand) {
        $6552edac5ca572b1$var$_tmpExpandRectDelta[0] = -$6552edac5ca572b1$var$_tmpExpandRectDelta[0];
        $6552edac5ca572b1$var$_tmpExpandRectDelta[1] = -$6552edac5ca572b1$var$_tmpExpandRectDelta[1];
        $6552edac5ca572b1$var$_tmpExpandRectDelta[2] = -$6552edac5ca572b1$var$_tmpExpandRectDelta[2];
        $6552edac5ca572b1$var$_tmpExpandRectDelta[3] = -$6552edac5ca572b1$var$_tmpExpandRectDelta[3];
    }
    $6552edac5ca572b1$var$expandRectOnOneDimension(rect, $6552edac5ca572b1$var$_tmpExpandRectDelta, "x", "width", 3, 1, minSize && minSize[0] || 0);
    $6552edac5ca572b1$var$expandRectOnOneDimension(rect, $6552edac5ca572b1$var$_tmpExpandRectDelta, "y", "height", 0, 2, minSize && minSize[1] || 0);
    return rect;
}
var $6552edac5ca572b1$var$_tmpExpandRectDelta = [
    0,
    0,
    0,
    0
];
function $6552edac5ca572b1$var$expandRectOnOneDimension(rect, delta, xy, wh, ltIdx, rbIdx, minSize) {
    var deltaSum = delta[rbIdx] + delta[ltIdx];
    var oldSize = rect[wh];
    rect[wh] += deltaSum;
    minSize = (0, $b49750109e236fd8$export$2ca8010d037f830f)(0, (0, $b49750109e236fd8$export$e411eeaf23dccbe8)(minSize, oldSize));
    if (rect[wh] < minSize) {
        rect[wh] = minSize;
        // Try to make the position of the zero rect reasonable in most visual cases.
        rect[xy] += delta[ltIdx] >= 0 ? -delta[ltIdx] : delta[rbIdx] >= 0 ? oldSize + delta[rbIdx] : (0, $b49750109e236fd8$export$5860c226b237d9a6)(deltaSum) > 1e-8 ? (oldSize - minSize) * delta[ltIdx] / deltaSum : 0;
    } else rect[xy] -= delta[ltIdx];
}
function $6552edac5ca572b1$export$fc6410d97fab306c(opt) {
    var itemTooltipOption = opt.itemTooltipOption;
    var componentModel = opt.componentModel;
    var itemName = opt.itemName;
    var itemTooltipOptionObj = (0, $43e0a445ed6711da$export$844ec244b1367d54)(itemTooltipOption) ? {
        formatter: itemTooltipOption
    } : itemTooltipOption;
    var mainType = componentModel.mainType;
    var componentIndex = componentModel.componentIndex;
    var formatterParams = {
        componentType: mainType,
        name: itemName,
        $vars: [
            "name"
        ]
    };
    formatterParams[mainType + "Index"] = componentIndex;
    var formatterParamsExtra = opt.formatterParamsExtra;
    if (formatterParamsExtra) (0, $43e0a445ed6711da$export$79b2f7037acddd43)((0, $43e0a445ed6711da$export$ed97f33186d4b816)(formatterParamsExtra), function(key) {
        if (!(0, $43e0a445ed6711da$export$b5a638e9b3fff9f3)(formatterParams, key)) {
            formatterParams[key] = formatterParamsExtra[key];
            formatterParams.$vars.push(key);
        }
    });
    var ecData = (0, $7e4afcfca8f5121f$export$b1c39b2bacd1ddc2)(opt.el);
    ecData.componentMainType = mainType;
    ecData.componentIndex = componentIndex;
    ecData.tooltipConfig = {
        name: itemName,
        option: (0, $43e0a445ed6711da$export$ebe90cb607ad99e)({
            content: itemName,
            encodeHTMLContent: true,
            formatterParams: formatterParams
        }, itemTooltipOptionObj)
    };
}
function $6552edac5ca572b1$var$traverseElement(el, cb) {
    var stopped;
    // TODO
    // Polyfill for fixing zrender group traverse don't visit it's root issue.
    if (el.isGroup) stopped = cb(el);
    if (!stopped) el.traverse(cb);
}
function $6552edac5ca572b1$export$3e564442729bf048(els, cb) {
    if (els) {
        if ((0, $43e0a445ed6711da$export$43bee75e5e14138e)(els)) for(var i = 0; i < els.length; i++)$6552edac5ca572b1$var$traverseElement(els[i], cb);
        else $6552edac5ca572b1$var$traverseElement(els, cb);
    }
}
function $6552edac5ca572b1$export$576610ccf2234b72(transform) {
    return !transform || (0, $b49750109e236fd8$export$5860c226b237d9a6)(transform[1]) < $6552edac5ca572b1$var$AXIS_ALIGN_EPSILON && (0, $b49750109e236fd8$export$5860c226b237d9a6)(transform[2]) < $6552edac5ca572b1$var$AXIS_ALIGN_EPSILON || (0, $b49750109e236fd8$export$5860c226b237d9a6)(transform[0]) < $6552edac5ca572b1$var$AXIS_ALIGN_EPSILON && (0, $b49750109e236fd8$export$5860c226b237d9a6)(transform[3]) < $6552edac5ca572b1$var$AXIS_ALIGN_EPSILON;
}
var $6552edac5ca572b1$var$AXIS_ALIGN_EPSILON = 1e-5;
function $6552edac5ca572b1$export$38128dfd9a498e1(target, source) {
    return target ? (0, $c437f598d9c9ee16$export$2e2bcd8739ae039).copy(target, source) : source.clone();
}
function $6552edac5ca572b1$export$4d61283a070e0362(target, source) {
    return source ? $87ac8de5537d9a34$export$784d13d8ee351f07(target || $87ac8de5537d9a34$export$185802fd694ee1f5(), source) : undefined;
}
function $6552edac5ca572b1$export$1500a631bea5adda(model) {
    return {
        z: model.get("z") || 0,
        zlevel: model.get("zlevel") || 0
    };
}
function $6552edac5ca572b1$export$8215ea00957327f2(el) {
    var max = -Infinity;
    var min = Infinity;
    $6552edac5ca572b1$var$traverseElement(el, function(el) {
        visitEl(el);
        visitEl(el.getTextContent());
        visitEl(el.getTextGuideLine());
    });
    function visitEl(el) {
        if (!el || el.isGroup) return;
        var currentStates = el.currentStates;
        if (currentStates.length) for(var idx = 0; idx < currentStates.length; idx++)calcZ2(el.states[currentStates[idx]]);
        calcZ2(el);
    }
    function calcZ2(entity) {
        if (entity) {
            var z2 = entity.z2;
            // Consider z2 may be NullUndefined
            if (z2 > max) max = z2;
            if (z2 < min) min = z2;
        }
    }
    if (min > max) min = max = 0;
    return {
        min: min,
        max: max
    };
}
function $6552edac5ca572b1$export$d31cf465bf5e8879(el, z, zlevel) {
    $6552edac5ca572b1$var$doUpdateZ(el, z, zlevel, -Infinity);
}
function $6552edac5ca572b1$var$doUpdateZ(el, z, zlevel, // FIXME: Ideally all the labels should be above all the glyphs by default,
//  e.g. in graph, edge labels should be above node elements.
//  Currently impl does not guarantee that.
maxZ2) {
    // `ignoreModelZ` is used to intentionally lift elements to cover other elements,
    // where maxZ2 (for label.z2) should also not be counted for its parents.
    if (el.ignoreModelZ) return maxZ2;
    // Group may also have textContent
    var label = el.getTextContent();
    var labelLine = el.getTextGuideLine();
    var isGroup = el.isGroup;
    if (isGroup) {
        // set z & zlevel of children elements of Group
        var children = el.childrenRef();
        for(var i = 0; i < children.length; i++)maxZ2 = (0, $b49750109e236fd8$export$2ca8010d037f830f)($6552edac5ca572b1$var$doUpdateZ(children[i], z, zlevel, maxZ2), maxZ2);
    } else {
        // not Group
        el.z = z;
        el.zlevel = zlevel;
        maxZ2 = (0, $b49750109e236fd8$export$2ca8010d037f830f)(el.z2 || 0, maxZ2);
    }
    // NOTICE: Do not call any method that can set REDRAW_BIT,
    // otherwise progressive rendering is broken.
    // always set z and zlevel if label/labelLine exists
    if (label) {
        label.z = z;
        label.zlevel = zlevel;
        // lift z2 of text content
        // TODO if el.emphasis.z2 is spcefied, what about textContent.
        isFinite(maxZ2) && (label.z2 = maxZ2 + 2);
    }
    if (labelLine) {
        var textGuideLineConfig = el.textGuideLineConfig;
        labelLine.z = z;
        labelLine.zlevel = zlevel;
        isFinite(maxZ2) && (labelLine.z2 = maxZ2 + (textGuideLineConfig && textGuideLineConfig.showAbove ? 1 : -1));
    }
    return maxZ2;
}
function $6552edac5ca572b1$export$6f963a8600ad6f65(payload) {
    // Disable animation in `updateProps` of `graphic.ts`.
    payload.animation = {
        duration: 0
    };
    return payload;
}
function $6552edac5ca572b1$export$31f224ae9d6cf05(out, mt) {
    mt ? $87ac8de5537d9a34$export$784d13d8ee351f07($6552edac5ca572b1$var$tmpDTR.transform, mt) : $87ac8de5537d9a34$export$f0954fd7d5368655($6552edac5ca572b1$var$tmpDTR.transform);
    // Use a tmp transformable to avoid effects from parent.
    $6552edac5ca572b1$var$tmpDTR.decomposeTransform();
    (0, $cca2e8cc539372e0$export$234b1c16dfa57d6a)(out, $6552edac5ca572b1$var$tmpDTR);
    return out;
}
var $6552edac5ca572b1$var$tmpDTR = new (0, $cca2e8cc539372e0$export$2e2bcd8739ae039)();
$6552edac5ca572b1$var$tmpDTR.transform = $87ac8de5537d9a34$export$185802fd694ee1f5();
function $6552edac5ca572b1$export$e8e725f22cc8ef79(api) {
    var painter = api.getZr().painter;
    return painter.getType() === "canvas" ? painter : null;
}
// Register built-in shapes. These shapes might be overwritten
// by users, although we do not recommend that.
$6552edac5ca572b1$export$2b95b62e3aaf6fdd("circle", (0, $55c0fda972a24142$export$2e2bcd8739ae039));
$6552edac5ca572b1$export$2b95b62e3aaf6fdd("ellipse", (0, $1d371afa26fdd11c$export$2e2bcd8739ae039));
$6552edac5ca572b1$export$2b95b62e3aaf6fdd("sector", (0, $7a3d58339c1601e8$export$2e2bcd8739ae039));
$6552edac5ca572b1$export$2b95b62e3aaf6fdd("ring", (0, $493646296ab90046$export$2e2bcd8739ae039));
$6552edac5ca572b1$export$2b95b62e3aaf6fdd("polygon", (0, $dbc82dce785be05b$export$2e2bcd8739ae039));
$6552edac5ca572b1$export$2b95b62e3aaf6fdd("polyline", (0, $363f38bff4966f60$export$2e2bcd8739ae039));
$6552edac5ca572b1$export$2b95b62e3aaf6fdd("rect", (0, $42ed508a93973e78$export$2e2bcd8739ae039));
$6552edac5ca572b1$export$2b95b62e3aaf6fdd("line", (0, $0e0ee2afac2bc66d$export$2e2bcd8739ae039));
$6552edac5ca572b1$export$2b95b62e3aaf6fdd("bezierCurve", (0, $57c0d9f749c3a837$export$2e2bcd8739ae039));
$6552edac5ca572b1$export$2b95b62e3aaf6fdd("arc", (0, $d0a314b008adf9ab$export$2e2bcd8739ae039));


var $6556fe1ed9fb479d$var$EMPTY_OBJ = {};
function $6556fe1ed9fb479d$export$b533918394a58529(label, labelTexts) {
    for(var i = 0; i < (0, $fffc76734a157b4c$export$151308dceb52d5b).length; i++){
        var stateName = (0, $fffc76734a157b4c$export$151308dceb52d5b)[i];
        var text = labelTexts[stateName];
        var state = label.ensureState(stateName);
        state.style = state.style || {};
        state.style.text = text;
    }
    var oldStates = label.currentStates.slice();
    label.clearStates(true);
    label.setStyle({
        text: labelTexts.normal
    });
    label.useStates(oldStates, true);
}
function $6556fe1ed9fb479d$var$getLabelText(opt, stateModels, interpolatedValue) {
    var labelFetcher = opt.labelFetcher;
    var labelDataIndex = opt.labelDataIndex;
    var labelDimIndex = opt.labelDimIndex;
    var normalModel = stateModels.normal;
    var baseText;
    if (labelFetcher) baseText = labelFetcher.getFormattedLabel(labelDataIndex, "normal", null, labelDimIndex, normalModel && normalModel.get("formatter"), interpolatedValue != null ? {
        interpolatedValue: interpolatedValue
    } : null);
    if (baseText == null) baseText = (0, $43e0a445ed6711da$export$f6e2535fb5126e54)(opt.defaultText) ? opt.defaultText(labelDataIndex, opt, interpolatedValue) : opt.defaultText;
    var statesText = {
        normal: baseText
    };
    for(var i = 0; i < (0, $fffc76734a157b4c$export$151308dceb52d5b).length; i++){
        var stateName = (0, $fffc76734a157b4c$export$151308dceb52d5b)[i];
        var stateModel = stateModels[stateName];
        statesText[stateName] = (0, $43e0a445ed6711da$export$995e01f2f5c9d030)(labelFetcher ? labelFetcher.getFormattedLabel(labelDataIndex, stateName, null, labelDimIndex, stateModel && stateModel.get("formatter")) : null, baseText);
    }
    return statesText;
}
function $6556fe1ed9fb479d$export$9a13992917966657(targetEl, labelStatesModels, opt, stateSpecified) {
    opt = opt || $6556fe1ed9fb479d$var$EMPTY_OBJ;
    var isSetOnText = targetEl instanceof (0, $7db7960d25b39b7c$export$2e2bcd8739ae039);
    var needsCreateText = false;
    for(var i = 0; i < (0, $fffc76734a157b4c$export$57ee5306b85ad7d5).length; i++){
        var stateModel = labelStatesModels[(0, $fffc76734a157b4c$export$57ee5306b85ad7d5)[i]];
        if (stateModel && stateModel.getShallow("show")) {
            needsCreateText = true;
            break;
        }
    }
    var textContent = isSetOnText ? targetEl : targetEl.getTextContent();
    if (needsCreateText) {
        if (!isSetOnText) {
            // Reuse the previous
            if (!textContent) {
                textContent = new (0, $7db7960d25b39b7c$export$2e2bcd8739ae039)();
                targetEl.setTextContent(textContent);
            }
            // Use same state proxy
            if (targetEl.stateProxy) textContent.stateProxy = targetEl.stateProxy;
        }
        var labelStatesTexts = $6556fe1ed9fb479d$var$getLabelText(opt, labelStatesModels);
        var normalModel = labelStatesModels.normal;
        var showNormal = !!normalModel.getShallow("show");
        var normalStyle = $6556fe1ed9fb479d$export$f8998c3d0a13de59(normalModel, stateSpecified && stateSpecified.normal, opt, false, !isSetOnText);
        normalStyle.text = labelStatesTexts.normal;
        if (!isSetOnText) // Always create new
        targetEl.setTextConfig($6556fe1ed9fb479d$export$e149afab8df6e053(normalModel, opt, false));
        for(var i = 0; i < (0, $fffc76734a157b4c$export$151308dceb52d5b).length; i++){
            var stateName = (0, $fffc76734a157b4c$export$151308dceb52d5b)[i];
            var stateModel = labelStatesModels[stateName];
            if (stateModel) {
                var stateObj = textContent.ensureState(stateName);
                var stateShow = !!(0, $43e0a445ed6711da$export$995e01f2f5c9d030)(stateModel.getShallow("show"), showNormal);
                if (stateShow !== showNormal) stateObj.ignore = !stateShow;
                stateObj.style = $6556fe1ed9fb479d$export$f8998c3d0a13de59(stateModel, stateSpecified && stateSpecified[stateName], opt, true, !isSetOnText);
                stateObj.style.text = labelStatesTexts[stateName];
                if (!isSetOnText) {
                    var targetElEmphasisState = targetEl.ensureState(stateName);
                    targetElEmphasisState.textConfig = $6556fe1ed9fb479d$export$e149afab8df6e053(stateModel, opt, true);
                }
            }
        }
        // PENDING: if there is many requirements that emphasis position
        // need to be different from normal position, we might consider
        // auto silent is those cases.
        textContent.silent = !!normalModel.getShallow("silent");
        // Keep x and y
        if (textContent.style.x != null) normalStyle.x = textContent.style.x;
        if (textContent.style.y != null) normalStyle.y = textContent.style.y;
        textContent.ignore = !showNormal;
        // Always create new style.
        textContent.useStyle(normalStyle);
        textContent.dirty();
        if (opt.enableTextSetter) $6556fe1ed9fb479d$export$f62786d3261ab0f4(textContent).setLabelText = function(interpolatedValue) {
            var labelStatesTexts = $6556fe1ed9fb479d$var$getLabelText(opt, labelStatesModels, interpolatedValue);
            $6556fe1ed9fb479d$export$b533918394a58529(textContent, labelStatesTexts);
        };
    } else if (textContent) // Not display rich text.
    textContent.ignore = true;
    targetEl.dirty();
}
function $6556fe1ed9fb479d$export$9739a32674be5893(itemModel, labelName) {
    labelName = labelName || "label";
    var statesModels = {
        normal: itemModel.getModel(labelName)
    };
    for(var i = 0; i < (0, $fffc76734a157b4c$export$151308dceb52d5b).length; i++){
        var stateName = (0, $fffc76734a157b4c$export$151308dceb52d5b)[i];
        statesModels[stateName] = itemModel.getModel([
            stateName,
            labelName
        ]);
    }
    return statesModels;
}
function $6556fe1ed9fb479d$export$f8998c3d0a13de59(textStyleModel, specifiedTextStyle, // Fixed style in the code. Can't be set by model.
opt, isNotNormal, isAttached // If text is attached on an element. If so, auto color will handling in zrender.
) {
    var textStyle = {};
    $6556fe1ed9fb479d$var$setTextStyleCommon(textStyle, textStyleModel, opt, isNotNormal, isAttached);
    specifiedTextStyle && (0, $43e0a445ed6711da$export$8b58be045bf06082)(textStyle, specifiedTextStyle);
    // textStyle.host && textStyle.host.dirty && textStyle.host.dirty(false);
    return textStyle;
}
function $6556fe1ed9fb479d$export$e149afab8df6e053(textStyleModel, opt, isNotNormal) {
    opt = opt || {};
    var textConfig = {};
    var labelPosition;
    var labelRotate = textStyleModel.getShallow("rotate");
    var labelDistance = (0, $43e0a445ed6711da$export$995e01f2f5c9d030)(textStyleModel.getShallow("distance"), isNotNormal ? null : 5);
    var labelOffset = textStyleModel.getShallow("offset");
    labelPosition = textStyleModel.getShallow("position") || (isNotNormal ? null : "inside");
    // 'outside' is not a valid zr textPostion value, but used
    // in bar series, and magic type should be considered.
    labelPosition === "outside" && (labelPosition = opt.defaultOutsidePosition || "top");
    if (labelPosition != null) textConfig.position = labelPosition;
    if (labelOffset != null) textConfig.offset = labelOffset;
    if (labelRotate != null) {
        labelRotate *= Math.PI / 180;
        textConfig.rotation = labelRotate;
    }
    if (labelDistance != null) textConfig.distance = labelDistance;
    // fill and auto is determined by the color of path fill if it's not specified by developers.
    textConfig.outsideFill = textStyleModel.get("color") === "inherit" ? opt.inheritColor || null : "auto";
    if (opt.autoOverflowArea != null) textConfig.autoOverflowArea = opt.autoOverflowArea;
    if (opt.layoutRect != null) textConfig.layoutRect = opt.layoutRect;
    return textConfig;
}
/**
 * The uniform entry of set text style, that is, retrieve style definitions
 * from `model` and set to `textStyle` object.
 *
 * Never in merge mode, but in overwrite mode, that is, all of the text style
 * properties will be set. (Consider the states of normal and emphasis and
 * default value can be adopted, merge would make the logic too complicated
 * to manage.)
 */ function $6556fe1ed9fb479d$var$setTextStyleCommon(textStyle, textStyleModel, opt, isNotNormal, isAttached) {
    // Consider there will be abnormal when merge hover style to normal style if given default value.
    opt = opt || $6556fe1ed9fb479d$var$EMPTY_OBJ;
    var ecModel = textStyleModel.ecModel;
    var globalTextStyle = ecModel && ecModel.option.textStyle;
    // Consider case:
    // {
    //     data: [{
    //         value: 12,
    //         label: {
    //             rich: {
    //                 // no 'a' here but using parent 'a'.
    //             }
    //         }
    //     }],
    //     rich: {
    //         a: { ... }
    //     }
    // }
    var richItemNames = $6556fe1ed9fb479d$var$getRichItemNames(textStyleModel);
    var richResult;
    if (richItemNames) {
        richResult = {};
        var richInheritPlainLabelOptionName = "richInheritPlainLabel";
        var richInheritPlainLabel = (0, $43e0a445ed6711da$export$995e01f2f5c9d030)(textStyleModel.get(richInheritPlainLabelOptionName), ecModel ? ecModel.get(richInheritPlainLabelOptionName) : undefined);
        for(var name_1 in richItemNames)if (richItemNames.hasOwnProperty(name_1)) {
            // Cascade is supported in rich.
            var richTextStyle = textStyleModel.getModel([
                "rich",
                name_1
            ]);
            // In rich, never `disableBox`.
            // consider `label: {formatter: '{a|xx}', color: 'blue', rich: {a: {}}}`,
            // the default color `'blue'` will not be adopted if no color declared in `rich`.
            // That might confuses users. So probably we should put `textStyleModel` as the
            // root ancestor of the `richTextStyle`. But that would be a break change.
            // Since v6, the rich style inherits plain label by default
            // but this behavior can be disabled by setting `richInheritPlainLabel` to `false`.
            $6556fe1ed9fb479d$var$setTokenTextStyle(richResult[name_1] = {}, richTextStyle, globalTextStyle, textStyleModel, richInheritPlainLabel, opt, isNotNormal, isAttached, false, true);
        }
    }
    if (richResult) textStyle.rich = richResult;
    var overflow = textStyleModel.get("overflow");
    if (overflow) textStyle.overflow = overflow;
    var lineOverflow = textStyleModel.get("lineOverflow");
    if (lineOverflow) textStyle.lineOverflow = lineOverflow;
    var labelTextStyle = textStyle;
    // `minMargin` has a higher precedence than `textMargin`, because `textMargin` is allowed
    // to be set in `defaultOption`.
    var minMargin = textStyleModel.get("minMargin");
    if (minMargin != null) {
        // `minMargin` only support number value.
        minMargin = !(0, $43e0a445ed6711da$export$7e4aa119212bc614)(minMargin) ? 0 : minMargin / 2;
        labelTextStyle.margin = [
            minMargin,
            minMargin,
            minMargin,
            minMargin
        ];
        labelTextStyle.__marginType = $6556fe1ed9fb479d$export$2b18df2bc75ae422.minMargin;
    } else {
        var textMargin = textStyleModel.get("textMargin");
        if (textMargin != null) {
            labelTextStyle.margin = (0, $43e0a445ed6711da$export$f3a38102c49f4268)(textMargin);
            labelTextStyle.__marginType = $6556fe1ed9fb479d$export$2b18df2bc75ae422.textMargin;
        }
    }
    $6556fe1ed9fb479d$var$setTokenTextStyle(textStyle, textStyleModel, globalTextStyle, null, null, opt, isNotNormal, isAttached, true, false);
}
// Consider case:
// {
//     data: [{
//         value: 12,
//         label: {
//             rich: {
//                 // no 'a' here but using parent 'a'.
//             }
//         }
//     }],
//     rich: {
//         a: { ... }
//     }
// }
// TODO TextStyleModel
function $6556fe1ed9fb479d$var$getRichItemNames(textStyleModel) {
    // Use object to remove duplicated names.
    var richItemNameMap;
    while(textStyleModel && textStyleModel !== textStyleModel.ecModel){
        var rich = (textStyleModel.option || $6556fe1ed9fb479d$var$EMPTY_OBJ).rich;
        if (rich) {
            richItemNameMap = richItemNameMap || {};
            var richKeys = (0, $43e0a445ed6711da$export$ed97f33186d4b816)(rich);
            for(var i = 0; i < richKeys.length; i++){
                var richKey = richKeys[i];
                richItemNameMap[richKey] = 1;
            }
        }
        textStyleModel = textStyleModel.parentModel;
    }
    return richItemNameMap;
}
var $6556fe1ed9fb479d$var$TEXT_PROPS_WITH_GLOBAL = [
    "fontStyle",
    "fontWeight",
    "fontSize",
    "fontFamily",
    "textShadowColor",
    "textShadowBlur",
    "textShadowOffsetX",
    "textShadowOffsetY"
];
var $6556fe1ed9fb479d$var$TEXT_PROPS_SELF = [
    "align",
    "lineHeight",
    "width",
    "height",
    "tag",
    "verticalAlign",
    "ellipsis"
];
var $6556fe1ed9fb479d$var$TEXT_PROPS_BOX = [
    "padding",
    "borderWidth",
    "borderRadius",
    "borderDashOffset",
    "backgroundColor",
    "borderColor",
    "shadowColor",
    "shadowBlur",
    "shadowOffsetX",
    "shadowOffsetY"
];
function $6556fe1ed9fb479d$var$setTokenTextStyle(textStyle, // FIXME: check/refactor for ellipsis handling of rich text.
textStyleModel, globalTextStyle, plainTextModel, richInheritPlainLabel, opt, isNotNormal, isAttached, isBlock, inRich) {
    // In merge mode, default value should not be given.
    globalTextStyle = !isNotNormal && globalTextStyle || $6556fe1ed9fb479d$var$EMPTY_OBJ;
    var inheritColor = opt && opt.inheritColor;
    var fillColor = textStyleModel.getShallow("color");
    var strokeColor = textStyleModel.getShallow("textBorderColor");
    var opacity = (0, $43e0a445ed6711da$export$995e01f2f5c9d030)(textStyleModel.getShallow("opacity"), globalTextStyle.opacity);
    if (fillColor === "inherit" || fillColor === "auto") {
        if (inheritColor) fillColor = inheritColor;
        else fillColor = null;
    }
    if (strokeColor === "inherit" || strokeColor === "auto") {
        if (inheritColor) strokeColor = inheritColor;
        else strokeColor = null;
    }
    if (!isAttached) {
        // Only use default global textStyle.color if text is individual.
        // Otherwise it will use the strategy of attached text color because text may be on a path.
        fillColor = fillColor || globalTextStyle.color;
        strokeColor = strokeColor || globalTextStyle.textBorderColor;
    }
    if (fillColor != null) // Might not be a string, e.g, it's a function in axisLabel case; but assume that it will
    // be erased by a correct value outside.
    textStyle.fill = fillColor;
    if (strokeColor != null) textStyle.stroke = strokeColor;
    var textBorderWidth = (0, $43e0a445ed6711da$export$995e01f2f5c9d030)(textStyleModel.getShallow("textBorderWidth"), globalTextStyle.textBorderWidth);
    if (textBorderWidth != null) textStyle.lineWidth = textBorderWidth;
    var textBorderType = (0, $43e0a445ed6711da$export$995e01f2f5c9d030)(textStyleModel.getShallow("textBorderType"), globalTextStyle.textBorderType);
    if (textBorderType != null) textStyle.lineDash = textBorderType;
    var textBorderDashOffset = (0, $43e0a445ed6711da$export$995e01f2f5c9d030)(textStyleModel.getShallow("textBorderDashOffset"), globalTextStyle.textBorderDashOffset);
    if (textBorderDashOffset != null) textStyle.lineDashOffset = textBorderDashOffset;
    if (!isNotNormal && opacity == null && !inRich) opacity = opt && opt.defaultOpacity;
    if (opacity != null) textStyle.opacity = opacity;
    // TODO
    if (!isNotNormal && !isAttached) // Set default finally.
    {
        if (textStyle.fill == null && opt.inheritColor) textStyle.fill = opt.inheritColor;
    }
    // Do not use `getFont` here, because merge should be supported, where
    // part of these properties may be changed in emphasis style, and the
    // others should remain their original value got from normal style.
    for(var i = 0; i < $6556fe1ed9fb479d$var$TEXT_PROPS_WITH_GLOBAL.length; i++){
        var key = $6556fe1ed9fb479d$var$TEXT_PROPS_WITH_GLOBAL[i];
        // props width, height, padding, margin, tag, backgroundColor, borderColor,
        // borderWidth, borderRadius, shadowColor, shadowBlur, shadowOffsetX, shadowOffsetY
        // may inappropriate to inherit from plainTextStyle.
        // And if some props is specified in default options, users may have to reset them one by one.
        // Therefore, we only allow these props to inherit from plainTextStyle.
        // `richInheritPlainLabel` is switch for backward compatibility
        var val = richInheritPlainLabel !== false && plainTextModel ? (0, $43e0a445ed6711da$export$2e94551289abb95b)(textStyleModel.getShallow(key), plainTextModel.getShallow(key), globalTextStyle[key]) : (0, $43e0a445ed6711da$export$995e01f2f5c9d030)(textStyleModel.getShallow(key), globalTextStyle[key]);
        if (val != null) textStyle[key] = val;
    }
    for(var i = 0; i < $6556fe1ed9fb479d$var$TEXT_PROPS_SELF.length; i++){
        var key = $6556fe1ed9fb479d$var$TEXT_PROPS_SELF[i];
        var val = textStyleModel.getShallow(key);
        if (val != null) textStyle[key] = val;
    }
    if (textStyle.verticalAlign == null) {
        var baseline = textStyleModel.getShallow("baseline");
        if (baseline != null) textStyle.verticalAlign = baseline;
    }
    if (!isBlock || !opt.disableBox) {
        for(var i = 0; i < $6556fe1ed9fb479d$var$TEXT_PROPS_BOX.length; i++){
            var key = $6556fe1ed9fb479d$var$TEXT_PROPS_BOX[i];
            var val = textStyleModel.getShallow(key);
            if (val != null) textStyle[key] = val;
        }
        var borderType = textStyleModel.getShallow("borderType");
        if (borderType != null) textStyle.borderDash = borderType;
        if ((textStyle.backgroundColor === "auto" || textStyle.backgroundColor === "inherit") && inheritColor) textStyle.backgroundColor = inheritColor;
        if ((textStyle.borderColor === "auto" || textStyle.borderColor === "inherit") && inheritColor) textStyle.borderColor = inheritColor;
    }
}
function $6556fe1ed9fb479d$export$155316a870a9d61e(opt, ecModel) {
    var gTextStyleModel = ecModel && ecModel.getModel("textStyle");
    return (0, $43e0a445ed6711da$export$87c2784dc9fc4ab)([
        // FIXME in node-canvas fontWeight is before fontStyle
        opt.fontStyle || gTextStyleModel && gTextStyleModel.getShallow("fontStyle") || "",
        opt.fontWeight || gTextStyleModel && gTextStyleModel.getShallow("fontWeight") || "",
        (opt.fontSize || gTextStyleModel && gTextStyleModel.getShallow("fontSize") || 12) + "px",
        opt.fontFamily || gTextStyleModel && gTextStyleModel.getShallow("fontFamily") || "sans-serif"
    ].join(" "));
}
var $6556fe1ed9fb479d$export$f62786d3261ab0f4 = (0, $87f4a59ac66e0ee6$export$64df9f8d92ae083f)();
function $6556fe1ed9fb479d$export$7bdbceaf9ab378f2(label, labelStatesModels, value, getDefaultText) {
    if (!label) return;
    var obj = $6556fe1ed9fb479d$export$f62786d3261ab0f4(label);
    obj.prevValue = obj.value;
    obj.value = value;
    var normalLabelModel = labelStatesModels.normal;
    obj.valueAnimation = normalLabelModel.get("valueAnimation");
    if (obj.valueAnimation) {
        obj.precision = normalLabelModel.get("precision");
        obj.defaultInterpolatedText = getDefaultText;
        obj.statesModels = labelStatesModels;
    }
}
function $6556fe1ed9fb479d$export$dd6101605f5c186(textEl, dataIndex, data, animatableModel, labelFetcher) {
    var labelInnerStore = $6556fe1ed9fb479d$export$f62786d3261ab0f4(textEl);
    if (!labelInnerStore.valueAnimation || labelInnerStore.prevValue === labelInnerStore.value) // Value not changed, no new label animation
    return;
    var defaultInterpolatedText = labelInnerStore.defaultInterpolatedText;
    // Consider the case that being animating, do not use the `obj.value`,
    // Otherwise it will jump to the `obj.value` when this new animation started.
    var currValue = (0, $43e0a445ed6711da$export$995e01f2f5c9d030)(labelInnerStore.interpolatedValue, labelInnerStore.prevValue);
    var targetValue = labelInnerStore.value;
    function during(percent) {
        var interpolated = (0, $87f4a59ac66e0ee6$export$bd0439821a1869f3)(data, labelInnerStore.precision, currValue, targetValue, percent);
        labelInnerStore.interpolatedValue = percent === 1 ? null : interpolated;
        var labelText = $6556fe1ed9fb479d$var$getLabelText({
            labelDataIndex: dataIndex,
            labelFetcher: labelFetcher,
            defaultText: defaultInterpolatedText ? defaultInterpolatedText(interpolated) : interpolated + ""
        }, labelInnerStore.statesModels, interpolated);
        $6556fe1ed9fb479d$export$b533918394a58529(textEl, labelText);
    }
    textEl.percent = 0;
    (labelInnerStore.prevValue == null ? (0, $4feffdaaa31d998e$export$a121566aadcfe021) : (0, $4feffdaaa31d998e$export$c8dce3c08436e91e))(textEl, {
        // percent is used to prevent animation from being aborted #15916
        percent: 1
    }, animatableModel, dataIndex, null, during);
}
var $6556fe1ed9fb479d$export$2b18df2bc75ae422 = {
    minMargin: 1,
    textMargin: 2
};



var $0885fbb58d40a5d7$var$PATH_COLOR = [
    "textStyle",
    "color"
];
var $0885fbb58d40a5d7$var$textStyleParams = [
    "fontStyle",
    "fontWeight",
    "fontSize",
    "fontFamily",
    "padding",
    "lineHeight",
    "rich",
    "width",
    "height",
    "overflow"
];
// TODO Performance improvement?
var $0885fbb58d40a5d7$var$tmpText = new (0, $7db7960d25b39b7c$export$2e2bcd8739ae039)();
var $0885fbb58d40a5d7$var$TextStyleMixin = /** @class */ function() {
    function TextStyleMixin() {}
    /**
   * Get color property or get color from option.textStyle.color
   */ // TODO Callback
    TextStyleMixin.prototype.getTextColor = function(isEmphasis) {
        var ecModel = this.ecModel;
        return this.getShallow("color") || (!isEmphasis && ecModel ? ecModel.get($0885fbb58d40a5d7$var$PATH_COLOR) : null);
    };
    /**
   * Create font string from fontStyle, fontWeight, fontSize, fontFamily
   * @return {string}
   */ TextStyleMixin.prototype.getFont = function() {
        return (0, $6556fe1ed9fb479d$export$155316a870a9d61e)({
            fontStyle: this.getShallow("fontStyle"),
            fontWeight: this.getShallow("fontWeight"),
            fontSize: this.getShallow("fontSize"),
            fontFamily: this.getShallow("fontFamily")
        }, this.ecModel);
    };
    TextStyleMixin.prototype.getTextRect = function(text) {
        var style = {
            text: text,
            verticalAlign: this.getShallow("verticalAlign") || this.getShallow("baseline")
        };
        for(var i = 0; i < $0885fbb58d40a5d7$var$textStyleParams.length; i++)style[$0885fbb58d40a5d7$var$textStyleParams[i]] = this.getShallow($0885fbb58d40a5d7$var$textStyleParams[i]);
        $0885fbb58d40a5d7$var$tmpText.useStyle(style);
        $0885fbb58d40a5d7$var$tmpText.update();
        return $0885fbb58d40a5d7$var$tmpText.getBoundingRect();
    };
    return TextStyleMixin;
}();
var $0885fbb58d40a5d7$export$2e2bcd8739ae039 = $0885fbb58d40a5d7$var$TextStyleMixin;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $e0a50a0f4a6edbaa$export$9f34de5b59222949 = [
    [
        "lineWidth",
        "width"
    ],
    [
        "stroke",
        "color"
    ],
    [
        "opacity"
    ],
    [
        "shadowBlur"
    ],
    [
        "shadowOffsetX"
    ],
    [
        "shadowOffsetY"
    ],
    [
        "shadowColor"
    ],
    [
        "lineDash",
        "type"
    ],
    [
        "lineDashOffset",
        "dashOffset"
    ],
    [
        "lineCap",
        "cap"
    ],
    [
        "lineJoin",
        "join"
    ],
    [
        "miterLimit"
    ]
];
var $e0a50a0f4a6edbaa$var$getLineStyle = (0, $0b19196a0800a1eb$export$2e2bcd8739ae039)($e0a50a0f4a6edbaa$export$9f34de5b59222949);
var $e0a50a0f4a6edbaa$export$91eeeeed4a69a7e7 = /** @class */ function() {
    function LineStyleMixin() {}
    LineStyleMixin.prototype.getLineStyle = function(excludes) {
        return $e0a50a0f4a6edbaa$var$getLineStyle(this, excludes);
    };
    return LineStyleMixin;
}();


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $c62e186be3a8172a$export$ffb0bba5dde0130b = [
    [
        "fill",
        "color"
    ],
    [
        "stroke",
        "borderColor"
    ],
    [
        "lineWidth",
        "borderWidth"
    ],
    [
        "opacity"
    ],
    [
        "shadowBlur"
    ],
    [
        "shadowOffsetX"
    ],
    [
        "shadowOffsetY"
    ],
    [
        "shadowColor"
    ],
    [
        "lineDash",
        "borderType"
    ],
    [
        "lineDashOffset",
        "borderDashOffset"
    ],
    [
        "lineCap",
        "borderCap"
    ],
    [
        "lineJoin",
        "borderJoin"
    ],
    [
        "miterLimit",
        "borderMiterLimit"
    ]
];
var $c62e186be3a8172a$var$getItemStyle = (0, $0b19196a0800a1eb$export$2e2bcd8739ae039)($c62e186be3a8172a$export$ffb0bba5dde0130b);
var $c62e186be3a8172a$export$e4f01e48d6fda412 = /** @class */ function() {
    function ItemStyleMixin() {}
    ItemStyleMixin.prototype.getItemStyle = function(excludes, includes) {
        return $c62e186be3a8172a$var$getItemStyle(this, excludes, includes);
    };
    return ItemStyleMixin;
}();



var $279973fc50f77a15$var$Model = /** @class */ function() {
    function Model(option, parentModel, ecModel) {
        this.parentModel = parentModel;
        this.ecModel = ecModel;
        this.option = option;
    // Simple optimization
    // if (this.init) {
    //     if (arguments.length <= 4) {
    //         this.init(option, parentModel, ecModel, extraOpt);
    //     }
    //     else {
    //         this.init.apply(this, arguments);
    //     }
    // }
    }
    Model.prototype.init = function(option, parentModel, ecModel) {
        var rest = [];
        for(var _i = 3; _i < arguments.length; _i++)rest[_i - 3] = arguments[_i];
    };
    /**
   * Merge the input option to me.
   */ Model.prototype.mergeOption = function(option, ecModel) {
        (0, $43e0a445ed6711da$export$4950aa0f605343fb)(this.option, option, true);
    };
    // `path` can be 'a.b.c', so the return value type have to be `ModelOption`
    // TODO: TYPE strict key check?
    // get(path: string | string[], ignoreParent?: boolean): ModelOption;
    Model.prototype.get = function(path, ignoreParent) {
        if (path == null) return this.option;
        return this._doGet(this.parsePath(path), !ignoreParent && this.parentModel);
    };
    Model.prototype.getShallow = function(key, ignoreParent) {
        var option = this.option;
        var val = option == null ? option : option[key];
        if (val == null && !ignoreParent) {
            var parentModel = this.parentModel;
            if (parentModel) // FIXME:TS do not know how to make it works
            val = parentModel.getShallow(key);
        }
        return val;
    };
    // `path` can be 'a.b.c', so the return value type have to be `Model<ModelOption>`
    // getModel(path: string | string[], parentModel?: Model): Model;
    // TODO 'a.b.c' is deprecated
    Model.prototype.getModel = function(path, parentModel) {
        var hasPath = path != null;
        var pathFinal = hasPath ? this.parsePath(path) : null;
        var obj = hasPath ? this._doGet(pathFinal) : this.option;
        parentModel = parentModel || this.parentModel && this.parentModel.getModel(this.resolveParentPath(pathFinal));
        return new Model(obj, parentModel, this.ecModel);
    };
    /**
   * If model has option
   */ Model.prototype.isEmpty = function() {
        return this.option == null;
    };
    Model.prototype.restoreData = function() {};
    // Pending
    Model.prototype.clone = function() {
        var Ctor = this.constructor;
        return new Ctor((0, $43e0a445ed6711da$export$9cd59f9826255e47)(this.option));
    };
    // setReadOnly(properties): void {
    // clazzUtil.setReadOnly(this, properties);
    // }
    // If path is null/undefined, return null/undefined.
    Model.prototype.parsePath = function(path) {
        if (typeof path === "string") return path.split(".");
        return path;
    };
    // Resolve path for parent. Perhaps useful when parent use a different property.
    // Default to be a identity resolver.
    // Can be modified to a different resolver.
    Model.prototype.resolveParentPath = function(path) {
        return path;
    };
    // FIXME:TS check whether put this method here
    Model.prototype.isAnimationEnabled = function() {
        if (!(0, $a84633bb9c74d89c$export$2e2bcd8739ae039).node && this.option) {
            if (this.option.animation != null) return !!this.option.animation;
            else if (this.parentModel) return this.parentModel.isAnimationEnabled();
        }
    };
    Model.prototype._doGet = function(pathArr, parentModel) {
        var obj = this.option;
        if (!pathArr) return obj;
        for(var i = 0; i < pathArr.length; i++){
            // Ignore empty
            if (!pathArr[i]) continue;
            // obj could be number/string/... (like 0)
            obj = obj && typeof obj === "object" ? obj[pathArr[i]] : null;
            if (obj == null) break;
        }
        if (obj == null && parentModel) obj = parentModel._doGet(this.resolveParentPath(pathArr), parentModel.parentModel);
        return obj;
    };
    return Model;
}();
// Enable Model.extend.
(0, $10ce7a4361c3910c$export$cd4c3a4dca301c70)($279973fc50f77a15$var$Model);
(0, $10ce7a4361c3910c$export$e1aac4552ae82081)($279973fc50f77a15$var$Model);
(0, $43e0a445ed6711da$export$e36fc9d62a853069)($279973fc50f77a15$var$Model, (0, $e0a50a0f4a6edbaa$export$91eeeeed4a69a7e7));
(0, $43e0a445ed6711da$export$e36fc9d62a853069)($279973fc50f77a15$var$Model, (0, $c62e186be3a8172a$export$e4f01e48d6fda412));
(0, $43e0a445ed6711da$export$e36fc9d62a853069)($279973fc50f77a15$var$Model, (0, $cb0bc0f271fe90a7$export$a3a0ed7e2dd84c9e));
(0, $43e0a445ed6711da$export$e36fc9d62a853069)($279973fc50f77a15$var$Model, (0, $0885fbb58d40a5d7$export$2e2bcd8739ae039));
var $279973fc50f77a15$export$2e2bcd8739ae039 = $279973fc50f77a15$var$Model;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


// A random offset
var $f7a89889802a4565$var$base = Math.round(Math.random() * 10);
function $f7a89889802a4565$export$6d2b3473b0986646(type) {
    // Considering the case of crossing js context,
    // use Math.random to make id as unique as possible.
    return [
        type || "",
        $f7a89889802a4565$var$base++
    ].join("_");
}
function $f7a89889802a4565$export$b9faf30b7d655a6f(target) {
    var subTypeDefaulters = {};
    target.registerSubTypeDefaulter = function(componentType, defaulter) {
        var componentTypeInfo = (0, $10ce7a4361c3910c$export$fbe18865d303bf01)(componentType);
        subTypeDefaulters[componentTypeInfo.main] = defaulter;
    };
    target.determineSubType = function(componentType, option) {
        var type = option.type;
        if (!type) {
            var componentTypeMain = (0, $10ce7a4361c3910c$export$fbe18865d303bf01)(componentType).main;
            if (target.hasSubTypes(componentType) && subTypeDefaulters[componentTypeMain]) type = subTypeDefaulters[componentTypeMain](option);
        }
        return type;
    };
}
function $f7a89889802a4565$export$ce592d345a3ec040(entity, dependencyGetter) {
    /**
   * @param targetNameList Target Component type list.
   *                       Can be ['aa', 'bb', 'aa.xx']
   * @param fullNameList By which we can build dependency graph.
   * @param callback Params: componentType, dependencies.
   * @param context Scope of callback.
   */ entity.topologicalTravel = function(targetNameList, fullNameList, callback, context) {
        if (!targetNameList.length) return;
        var result = makeDepndencyGraph(fullNameList);
        var graph = result.graph;
        var noEntryList = result.noEntryList;
        var targetNameSet = {};
        $43e0a445ed6711da$export$79b2f7037acddd43(targetNameList, function(name) {
            targetNameSet[name] = true;
        });
        while(noEntryList.length){
            var currComponentType = noEntryList.pop();
            var currVertex = graph[currComponentType];
            var isInTargetNameSet = !!targetNameSet[currComponentType];
            if (isInTargetNameSet) {
                callback.call(context, currComponentType, currVertex.originalDeps.slice());
                delete targetNameSet[currComponentType];
            }
            $43e0a445ed6711da$export$79b2f7037acddd43(currVertex.successor, isInTargetNameSet ? removeEdgeAndAdd : removeEdge);
        }
        $43e0a445ed6711da$export$79b2f7037acddd43(targetNameSet, function() {
            var errMsg = "";
            throw new Error(errMsg);
        });
        function removeEdge(succComponentType) {
            graph[succComponentType].entryCount--;
            if (graph[succComponentType].entryCount === 0) noEntryList.push(succComponentType);
        }
        // Consider this case: legend depends on series, and we call
        // chart.setOption({series: [...]}), where only series is in option.
        // If we do not have 'removeEdgeAndAdd', legendModel.mergeOption will
        // not be called, but only sereis.mergeOption is called. Thus legend
        // have no chance to update its local record about series (like which
        // name of series is available in legend).
        function removeEdgeAndAdd(succComponentType) {
            targetNameSet[succComponentType] = true;
            removeEdge(succComponentType);
        }
    };
    function makeDepndencyGraph(fullNameList) {
        var graph = {};
        var noEntryList = [];
        $43e0a445ed6711da$export$79b2f7037acddd43(fullNameList, function(name) {
            var thisItem = createDependencyGraphItem(graph, name);
            var originalDeps = thisItem.originalDeps = dependencyGetter(name);
            var availableDeps = getAvailableDependencies(originalDeps, fullNameList);
            thisItem.entryCount = availableDeps.length;
            if (thisItem.entryCount === 0) noEntryList.push(name);
            $43e0a445ed6711da$export$79b2f7037acddd43(availableDeps, function(dependentName) {
                if ($43e0a445ed6711da$export$305f7d4e9d4624f2(thisItem.predecessor, dependentName) < 0) thisItem.predecessor.push(dependentName);
                var thatItem = createDependencyGraphItem(graph, dependentName);
                if ($43e0a445ed6711da$export$305f7d4e9d4624f2(thatItem.successor, dependentName) < 0) thatItem.successor.push(name);
            });
        });
        return {
            graph: graph,
            noEntryList: noEntryList
        };
    }
    function createDependencyGraphItem(graph, name) {
        if (!graph[name]) graph[name] = {
            predecessor: [],
            successor: []
        };
        return graph[name];
    }
    function getAvailableDependencies(originalDeps, fullNameList) {
        var availableDeps = [];
        $43e0a445ed6711da$export$79b2f7037acddd43(originalDeps, function(dep) {
            $43e0a445ed6711da$export$305f7d4e9d4624f2(fullNameList, dep) >= 0 && availableDeps.push(dep);
        });
        return availableDeps;
    }
}
function $f7a89889802a4565$export$68acc510e46fef2(superOption, subOption) {
    // See also `model/Component.ts#getDefaultOption`
    return $43e0a445ed6711da$export$4950aa0f605343fb($43e0a445ed6711da$export$4950aa0f605343fb({}, superOption, true), subOption, true);
}




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Layout helpers for each component positioning



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */ /**
 * Language: English.
 */ var $8ebf26fd27a0635d$export$2e2bcd8739ae039 = {
    time: {
        month: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ],
        monthAbbr: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ],
        dayOfWeek: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ],
        dayOfWeekAbbr: [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat"
        ]
    },
    legend: {
        selector: {
            all: "All",
            inverse: "Inv"
        }
    },
    toolbox: {
        brush: {
            title: {
                rect: "Box Select",
                polygon: "Lasso Select",
                lineX: "Horizontally Select",
                lineY: "Vertically Select",
                keep: "Keep Selections",
                clear: "Clear Selections"
            }
        },
        dataView: {
            title: "Data View",
            lang: [
                "Data View",
                "Close",
                "Refresh"
            ]
        },
        dataZoom: {
            title: {
                zoom: "Zoom",
                back: "Zoom Reset"
            }
        },
        magicType: {
            title: {
                line: "Switch to Line Chart",
                bar: "Switch to Bar Chart",
                stack: "Stack",
                tiled: "Tile"
            }
        },
        restore: {
            title: "Restore"
        },
        saveAsImage: {
            title: "Save as Image",
            lang: [
                "Right Click to Save Image"
            ]
        }
    },
    series: {
        typeNames: {
            pie: "Pie chart",
            bar: "Bar chart",
            line: "Line chart",
            scatter: "Scatter plot",
            effectScatter: "Ripple scatter plot",
            radar: "Radar chart",
            tree: "Tree",
            treemap: "Treemap",
            boxplot: "Boxplot",
            candlestick: "Candlestick",
            k: "K line chart",
            heatmap: "Heat map",
            map: "Map",
            parallel: "Parallel coordinate map",
            lines: "Line graph",
            graph: "Relationship graph",
            sankey: "Sankey diagram",
            funnel: "Funnel chart",
            gauge: "Gauge",
            pictorialBar: "Pictorial bar",
            themeRiver: "Theme River Map",
            sunburst: "Sunburst",
            custom: "Custom chart",
            chart: "Chart"
        }
    },
    aria: {
        general: {
            withTitle: 'This is a chart about "{title}"',
            withoutTitle: "This is a chart"
        },
        series: {
            single: {
                prefix: "",
                withName: " with type {seriesType} named {seriesName}.",
                withoutName: " with type {seriesType}."
            },
            multiple: {
                prefix: ". It consists of {seriesCount} series count.",
                withName: " The {seriesId} series is a {seriesType} representing {seriesName}.",
                withoutName: " The {seriesId} series is a {seriesType}.",
                separator: {
                    middle: "",
                    end: ""
                }
            }
        },
        data: {
            allData: "The data is as follows: ",
            partialData: "The first {displayCnt} items are: ",
            withName: "the data for {name} is {value}",
            withoutName: "{value}",
            separator: {
                middle: ", ",
                end: ". "
            }
        }
    }
};


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */ var $70a219798c15fc52$export$2e2bcd8739ae039 = {
    time: {
        month: [
            "\u4E00\u6708",
            "\u4E8C\u6708",
            "\u4E09\u6708",
            "\u56DB\u6708",
            "\u4E94\u6708",
            "\u516D\u6708",
            "\u4E03\u6708",
            "\u516B\u6708",
            "\u4E5D\u6708",
            "\u5341\u6708",
            "\u5341\u4E00\u6708",
            "\u5341\u4E8C\u6708"
        ],
        monthAbbr: [
            "1\u6708",
            "2\u6708",
            "3\u6708",
            "4\u6708",
            "5\u6708",
            "6\u6708",
            "7\u6708",
            "8\u6708",
            "9\u6708",
            "10\u6708",
            "11\u6708",
            "12\u6708"
        ],
        dayOfWeek: [
            "\u661F\u671F\u65E5",
            "\u661F\u671F\u4E00",
            "\u661F\u671F\u4E8C",
            "\u661F\u671F\u4E09",
            "\u661F\u671F\u56DB",
            "\u661F\u671F\u4E94",
            "\u661F\u671F\u516D"
        ],
        dayOfWeekAbbr: [
            "\u65E5",
            "\u4E00",
            "\u4E8C",
            "\u4E09",
            "\u56DB",
            "\u4E94",
            "\u516D"
        ]
    },
    legend: {
        selector: {
            all: "\u5168\u9009",
            inverse: "\u53CD\u9009"
        }
    },
    toolbox: {
        brush: {
            title: {
                rect: "\u77E9\u5F62\u9009\u62E9",
                polygon: "\u5708\u9009",
                lineX: "\u6A2A\u5411\u9009\u62E9",
                lineY: "\u7EB5\u5411\u9009\u62E9",
                keep: "\u4FDD\u6301\u9009\u62E9",
                clear: "\u6E05\u9664\u9009\u62E9"
            }
        },
        dataView: {
            title: "\u6570\u636E\u89C6\u56FE",
            lang: [
                "\u6570\u636E\u89C6\u56FE",
                "\u5173\u95ED",
                "\u5237\u65B0"
            ]
        },
        dataZoom: {
            title: {
                zoom: "\u533A\u57DF\u7F29\u653E",
                back: "\u533A\u57DF\u7F29\u653E\u8FD8\u539F"
            }
        },
        magicType: {
            title: {
                line: "\u5207\u6362\u4E3A\u6298\u7EBF\u56FE",
                bar: "\u5207\u6362\u4E3A\u67F1\u72B6\u56FE",
                stack: "\u5207\u6362\u4E3A\u5806\u53E0",
                tiled: "\u5207\u6362\u4E3A\u5E73\u94FA"
            }
        },
        restore: {
            title: "\u8FD8\u539F"
        },
        saveAsImage: {
            title: "\u4FDD\u5B58\u4E3A\u56FE\u7247",
            lang: [
                "\u53F3\u952E\u53E6\u5B58\u4E3A\u56FE\u7247"
            ]
        }
    },
    series: {
        typeNames: {
            pie: "\u997C\u56FE",
            bar: "\u67F1\u72B6\u56FE",
            line: "\u6298\u7EBF\u56FE",
            scatter: "\u6563\u70B9\u56FE",
            effectScatter: "\u6D9F\u6F2A\u6563\u70B9\u56FE",
            radar: "\u96F7\u8FBE\u56FE",
            tree: "\u6811\u56FE",
            treemap: "\u77E9\u5F62\u6811\u56FE",
            boxplot: "\u7BB1\u578B\u56FE",
            candlestick: "K\u7EBF\u56FE",
            k: "K\u7EBF\u56FE",
            heatmap: "\u70ED\u529B\u56FE",
            map: "\u5730\u56FE",
            parallel: "\u5E73\u884C\u5750\u6807\u56FE",
            lines: "\u7EBF\u56FE",
            graph: "\u5173\u7CFB\u56FE",
            sankey: "\u6851\u57FA\u56FE",
            funnel: "\u6F0F\u6597\u56FE",
            gauge: "\u4EEA\u8868\u76D8\u56FE",
            pictorialBar: "\u8C61\u5F62\u67F1\u56FE",
            themeRiver: "\u4E3B\u9898\u6CB3\u6D41\u56FE",
            sunburst: "\u65ED\u65E5\u56FE",
            custom: "\u81EA\u5B9A\u4E49\u56FE\u8868",
            chart: "\u56FE\u8868"
        }
    },
    aria: {
        general: {
            withTitle: "\u8FD9\u662F\u4E00\u4E2A\u5173\u4E8E\u201C{title}\u201D\u7684\u56FE\u8868\u3002",
            withoutTitle: "\u8FD9\u662F\u4E00\u4E2A\u56FE\u8868\uFF0C"
        },
        series: {
            single: {
                prefix: "",
                withName: "\u56FE\u8868\u7C7B\u578B\u662F{seriesType}\uFF0C\u8868\u793A{seriesName}\u3002",
                withoutName: "\u56FE\u8868\u7C7B\u578B\u662F{seriesType}\u3002"
            },
            multiple: {
                prefix: "\u5B83\u7531{seriesCount}\u4E2A\u56FE\u8868\u7CFB\u5217\u7EC4\u6210\u3002",
                withName: "\u7B2C{seriesId}\u4E2A\u7CFB\u5217\u662F\u4E00\u4E2A\u8868\u793A{seriesName}\u7684{seriesType}\uFF0C",
                withoutName: "\u7B2C{seriesId}\u4E2A\u7CFB\u5217\u662F\u4E00\u4E2A{seriesType}\uFF0C",
                separator: {
                    middle: "\uFF1B",
                    end: "\u3002"
                }
            }
        },
        data: {
            allData: "\u5176\u6570\u636E\u662F\u2014\u2014",
            partialData: "\u5176\u4E2D\uFF0C\u524D{displayCnt}\u9879\u662F\u2014\u2014",
            withName: "{name}\u7684\u6570\u636E\u662F{value}",
            withoutName: "{value}",
            separator: {
                middle: "\uFF0C",
                end: ""
            }
        }
    }
};



var $89683316752ed4c5$var$LOCALE_ZH = "ZH";
var $89683316752ed4c5$var$LOCALE_EN = "EN";
var $89683316752ed4c5$var$DEFAULT_LOCALE = $89683316752ed4c5$var$LOCALE_EN;
var $89683316752ed4c5$var$localeStorage = {};
var $89683316752ed4c5$var$localeModels = {};
var $89683316752ed4c5$export$9a2147b3808d4c6b = !(0, $a84633bb9c74d89c$export$2e2bcd8739ae039).domSupported ? $89683316752ed4c5$var$DEFAULT_LOCALE : function() {
    var langStr = (document.documentElement.lang || navigator.language || navigator.browserLanguage || $89683316752ed4c5$var$DEFAULT_LOCALE).toUpperCase();
    return langStr.indexOf($89683316752ed4c5$var$LOCALE_ZH) > -1 ? $89683316752ed4c5$var$LOCALE_ZH : $89683316752ed4c5$var$DEFAULT_LOCALE;
}();
function $89683316752ed4c5$export$bab6a7822cc1e2cd(locale, localeObj) {
    locale = locale.toUpperCase();
    $89683316752ed4c5$var$localeModels[locale] = new (0, $279973fc50f77a15$export$2e2bcd8739ae039)(localeObj);
    $89683316752ed4c5$var$localeStorage[locale] = localeObj;
}
function $89683316752ed4c5$export$ddc371781a6af754(locale) {
    if ((0, $43e0a445ed6711da$export$844ec244b1367d54)(locale)) {
        var localeObj = $89683316752ed4c5$var$localeStorage[locale.toUpperCase()] || {};
        if (locale === $89683316752ed4c5$var$LOCALE_ZH || locale === $89683316752ed4c5$var$LOCALE_EN) return (0, $43e0a445ed6711da$export$9cd59f9826255e47)(localeObj);
        else return (0, $43e0a445ed6711da$export$4950aa0f605343fb)((0, $43e0a445ed6711da$export$9cd59f9826255e47)(localeObj), (0, $43e0a445ed6711da$export$9cd59f9826255e47)($89683316752ed4c5$var$localeStorage[$89683316752ed4c5$var$DEFAULT_LOCALE]), false);
    } else return (0, $43e0a445ed6711da$export$4950aa0f605343fb)((0, $43e0a445ed6711da$export$9cd59f9826255e47)(locale), (0, $43e0a445ed6711da$export$9cd59f9826255e47)($89683316752ed4c5$var$localeStorage[$89683316752ed4c5$var$DEFAULT_LOCALE]), false);
}
function $89683316752ed4c5$export$37cc638e0e11865f(lang) {
    return $89683316752ed4c5$var$localeModels[lang];
}
function $89683316752ed4c5$export$1188f179b2597821() {
    return $89683316752ed4c5$var$localeModels[$89683316752ed4c5$var$DEFAULT_LOCALE];
}
// Default locale
$89683316752ed4c5$export$bab6a7822cc1e2cd($89683316752ed4c5$var$LOCALE_EN, (0, $8ebf26fd27a0635d$export$2e2bcd8739ae039));
$89683316752ed4c5$export$bab6a7822cc1e2cd($89683316752ed4c5$var$LOCALE_ZH, (0, $70a219798c15fc52$export$2e2bcd8739ae039));



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ var $d760dd937396b887$var$_impl = null;
function $d760dd937396b887$export$11977f1e90ef55cf(impl) {
    if (!$d760dd937396b887$var$_impl) $d760dd937396b887$var$_impl = impl;
}
function $d760dd937396b887$export$e79b20ac82c2d660() {
    return $d760dd937396b887$var$_impl;
}
function $d760dd937396b887$export$770ec3eb53b5689b(scale, opt) {
    var scaleBreakHelper = $d760dd937396b887$export$e79b20ac82c2d660();
    var breakOption = opt.breakOption;
    var breakParsed = opt.breakParsed;
    if (!breakParsed && scaleBreakHelper) breakParsed = scaleBreakHelper.parseAxisBreakOption(breakOption, scale);
    return breakParsed;
}
function $d760dd937396b887$export$20734ee5f1d5720f(scale) {
    var brk = scale.brk;
    return brk ? brk.breaks : [];
}
function $d760dd937396b887$export$fec008222a1db2dc(scale) {
    var brk = scale.brk;
    return brk ? brk.hasBreaks() : false;
}


var $d28d71d6b904c104$export$32c0454ceff7f92d = 1000;
var $d28d71d6b904c104$export$35acaebf644db34e = $d28d71d6b904c104$export$32c0454ceff7f92d * 60;
var $d28d71d6b904c104$export$82541edf19e5e3b0 = $d28d71d6b904c104$export$35acaebf644db34e * 60;
var $d28d71d6b904c104$export$a97a1358cbb650ab = $d28d71d6b904c104$export$82541edf19e5e3b0 * 24;
var $d28d71d6b904c104$export$99cafda57477293d = $d28d71d6b904c104$export$a97a1358cbb650ab * 365;
var $d28d71d6b904c104$var$primaryTimeUnitFormatterMatchers = {
    year: /({yyyy}|{yy})/,
    month: /({MMMM}|{MMM}|{MM}|{M})/,
    day: /({dd}|{d})/,
    hour: /({HH}|{H}|{hh}|{h})/,
    minute: /({mm}|{m})/,
    second: /({ss}|{s})/,
    millisecond: /({SSS}|{S})/
};
var $d28d71d6b904c104$var$defaultFormatterSeed = {
    year: "{yyyy}",
    month: "{MMM}",
    day: "{d}",
    hour: "{HH}:{mm}",
    minute: "{HH}:{mm}",
    second: "{HH}:{mm}:{ss}",
    millisecond: "{HH}:{mm}:{ss} {SSS}"
};
var $d28d71d6b904c104$var$defaultFullFormatter = "{yyyy}-{MM}-{dd} {HH}:{mm}:{ss} {SSS}";
var $d28d71d6b904c104$var$fullDayFormatter = "{yyyy}-{MM}-{dd}";
var $d28d71d6b904c104$export$445bdbd8d2334e40 = {
    year: "{yyyy}",
    month: "{yyyy}-{MM}",
    day: $d28d71d6b904c104$var$fullDayFormatter,
    hour: $d28d71d6b904c104$var$fullDayFormatter + " " + $d28d71d6b904c104$var$defaultFormatterSeed.hour,
    minute: $d28d71d6b904c104$var$fullDayFormatter + " " + $d28d71d6b904c104$var$defaultFormatterSeed.minute,
    second: $d28d71d6b904c104$var$fullDayFormatter + " " + $d28d71d6b904c104$var$defaultFormatterSeed.second,
    millisecond: $d28d71d6b904c104$var$defaultFullFormatter
};
var $d28d71d6b904c104$export$87100da04d711986 = [
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "millisecond"
];
var $d28d71d6b904c104$export$833c398a55654bb7 = [
    "year",
    "half-year",
    "quarter",
    "month",
    "week",
    "half-week",
    "day",
    "half-day",
    "quarter-day",
    "hour",
    "minute",
    "second",
    "millisecond"
];
function $d28d71d6b904c104$export$f16a827770bdffb5(formatter) {
    // Keep the logic the same with function `leveledFormat`.
    return !$43e0a445ed6711da$export$844ec244b1367d54(formatter) && !$43e0a445ed6711da$export$f6e2535fb5126e54(formatter) ? $d28d71d6b904c104$var$parseTimeAxisLabelFormatterDictionary(formatter) : formatter;
}
/**
 * The final generated dictionary is like:
 *  generated_dict = {
 *      year: {
 *          year: ['{yyyy}', ...<higher_levels_if_any>]
 *      },
 *      month: {
 *          year: ['{yyyy} {MMM}', ...<higher_levels_if_any>],
 *          month: ['{MMM}', ...<higher_levels_if_any>]
 *      },
 *      day: {
 *          year: ['{yyyy} {MMM} {d}', ...<higher_levels_if_any>],
 *          month: ['{MMM} {d}', ...<higher_levels_if_any>],
 *          day: ['{d}', ...<higher_levels_if_any>]
 *      },
 *      ...
 *  }
 *
 * In echarts option, users can specify the entire dictionary or typically just:
 *  {formatter: {
 *      year: '{yyyy}', // Or an array of leveled templates: `['{yyyy}', '{bold1|{yyyy}}', ...]`,
 *                      // corresponding to `[level0, level1, level2, ...]`.
 *      month: '{MMM}',
 *      day: '{d}',
 *      hour: '{HH}:{mm}',
 *      second: '{HH}:{mm}',
 *      ...
 *  }}
 *  If any time unit is not specified in echarts option, the default template is used,
 *  such as `['{yyyy}', {primary|{yyyy}']`.
 *
 * The `tick.level` is only used to read string from each array, meaning the style type.
 *
 * Let `lowerUnit = getUnitFromValue(tick.value)`.
 * The non-break axis ticks only use `generated_dict[lowerUnit][lowerUnit][level]`.
 * The break axis ticks may use `generated_dict[lowerUnit][upperUnit][level]`, because:
 *  Consider the case: the non-break ticks are `16th, 23th, Feb, 7th, ...`, where `Feb` is in the break
 *  range and pruned by breaks, and the break ends might be in lower time unit than day. e.g., break start
 *  is `Jan 25th 18:00`(in unit `hour`) and break end is `Feb 6th 18:30` (in unit `minute`). Thus the break
 *  label prefers `Jan 25th 18:00` and `Feb 6th 18:30` rather than only `18:00` and `18:30`, otherwise it
 *  causes misleading.
 *  In this case, the tick of the break start and end will both be:
 *      `{level: 1, lowerTimeUnit: 'minute', upperTimeUnit: 'month'}`
 *  And get the final template by `generated_dict[lowerTimeUnit][upperTimeUnit][level]`.
 *  Note that the time unit can not be calculated directly by a single tick value, since the two breaks have
 *  to be at the same time unit to avoid awkward appearance. i.e., `Jan 25th 18:00` is in the time unit "hour"
 *  but we need it to be "minute", following `Feb 6th 18:30`.
 */ function $d28d71d6b904c104$var$parseTimeAxisLabelFormatterDictionary(dictOption) {
    dictOption = dictOption || {};
    var dict = {};
    // Currently if any template is specified by user, it may contain rich text tag,
    // such as `'{my_bold|{YYYY}}'`, thus we do add highlight style to it.
    // (Note that nested tag (`'{some|{some2|xxx}}'`) in rich text is not supported yet.)
    var canAddHighlight = true;
    $43e0a445ed6711da$export$79b2f7037acddd43($d28d71d6b904c104$export$87100da04d711986, function(lowestUnit) {
        canAddHighlight && (canAddHighlight = dictOption[lowestUnit] == null);
    });
    $43e0a445ed6711da$export$79b2f7037acddd43($d28d71d6b904c104$export$87100da04d711986, function(lowestUnit, lowestUnitIdx) {
        var upperDictOption = dictOption[lowestUnit];
        dict[lowestUnit] = {};
        var lowerTpl = null;
        for(var upperUnitIdx = lowestUnitIdx; upperUnitIdx >= 0; upperUnitIdx--){
            var upperUnit = $d28d71d6b904c104$export$87100da04d711986[upperUnitIdx];
            var upperDictItemOption = $43e0a445ed6711da$export$a6cdc56e425d0d0a(upperDictOption) && !$43e0a445ed6711da$export$43bee75e5e14138e(upperDictOption) ? upperDictOption[upperUnit] : upperDictOption;
            var tplArr = void 0;
            if ($43e0a445ed6711da$export$43bee75e5e14138e(upperDictItemOption)) {
                tplArr = upperDictItemOption.slice();
                lowerTpl = tplArr[0] || "";
            } else if ($43e0a445ed6711da$export$844ec244b1367d54(upperDictItemOption)) {
                lowerTpl = upperDictItemOption;
                tplArr = [
                    lowerTpl
                ];
            } else {
                if (lowerTpl == null) lowerTpl = $d28d71d6b904c104$var$defaultFormatterSeed[lowestUnit];
                else if (!$d28d71d6b904c104$var$primaryTimeUnitFormatterMatchers[upperUnit].test(lowerTpl)) lowerTpl = dict[upperUnit][upperUnit][0] + " " + lowerTpl;
                tplArr = [
                    lowerTpl
                ];
                if (canAddHighlight) tplArr[1] = "{primary|" + lowerTpl + "}";
            }
            dict[lowestUnit][upperUnit] = tplArr;
        }
    });
    return dict;
}
function $d28d71d6b904c104$export$5d04458e2a6c373e(str, len) {
    str += "";
    return "0000".substr(0, len - str.length) + str;
}
function $d28d71d6b904c104$export$1da4b91a25d7e1c8(timeUnit) {
    switch(timeUnit){
        case "half-year":
        case "quarter":
            return "month";
        case "week":
        case "half-week":
            return "day";
        case "half-day":
        case "quarter-day":
            return "hour";
        default:
            // year, minutes, second, milliseconds
            return timeUnit;
    }
}
function $d28d71d6b904c104$export$beb5920b69c13da(timeUnit) {
    return timeUnit === $d28d71d6b904c104$export$1da4b91a25d7e1c8(timeUnit);
}
function $d28d71d6b904c104$export$124c820721c4f66b(timeUnit) {
    switch(timeUnit){
        case "year":
        case "month":
            return "day";
        case "millisecond":
            return "millisecond";
        default:
            // Also for day, hour, minute, second
            return "second";
    }
}
function $d28d71d6b904c104$export$d9468344d3651243(// Note: The result based on `isUTC` are totally different, which can not be just simply
// substituted by the result without `isUTC`. So we make the param `isUTC` mandatory.
time, template, isUTC, lang) {
    var date = $b49750109e236fd8$export$6b862160d295c8e(time);
    var y = date[$d28d71d6b904c104$export$8d046fefed9a548e(isUTC)]();
    var M = date[$d28d71d6b904c104$export$5c242a801a23eec7(isUTC)]() + 1;
    var q = Math.floor((M - 1) / 3) + 1;
    var d = date[$d28d71d6b904c104$export$4189e6cbc9753260(isUTC)]();
    var e = date["get" + (isUTC ? "UTC" : "") + "Day"]();
    var H = date[$d28d71d6b904c104$export$8b40b55b3c06cbe2(isUTC)]();
    var h = (H - 1) % 12 + 1;
    var m = date[$d28d71d6b904c104$export$8807847c5c71eded(isUTC)]();
    var s = date[$d28d71d6b904c104$export$8f49e73e2eebd168(isUTC)]();
    var S = date[$d28d71d6b904c104$export$312207a92d041116(isUTC)]();
    var a = H >= 12 ? "pm" : "am";
    var A = a.toUpperCase();
    var localeModel = lang instanceof (0, $279973fc50f77a15$export$2e2bcd8739ae039) ? lang : (0, $89683316752ed4c5$export$37cc638e0e11865f)(lang || (0, $89683316752ed4c5$export$9a2147b3808d4c6b)) || (0, $89683316752ed4c5$export$1188f179b2597821)();
    var timeModel = localeModel.getModel("time");
    var month = timeModel.get("month");
    var monthAbbr = timeModel.get("monthAbbr");
    var dayOfWeek = timeModel.get("dayOfWeek");
    var dayOfWeekAbbr = timeModel.get("dayOfWeekAbbr");
    return (template || "").replace(/{a}/g, a + "").replace(/{A}/g, A + "").replace(/{yyyy}/g, y + "").replace(/{yy}/g, $d28d71d6b904c104$export$5d04458e2a6c373e(y % 100 + "", 2)).replace(/{Q}/g, q + "").replace(/{MMMM}/g, month[M - 1]).replace(/{MMM}/g, monthAbbr[M - 1]).replace(/{MM}/g, $d28d71d6b904c104$export$5d04458e2a6c373e(M, 2)).replace(/{M}/g, M + "").replace(/{dd}/g, $d28d71d6b904c104$export$5d04458e2a6c373e(d, 2)).replace(/{d}/g, d + "").replace(/{eeee}/g, dayOfWeek[e]).replace(/{ee}/g, dayOfWeekAbbr[e]).replace(/{e}/g, e + "").replace(/{HH}/g, $d28d71d6b904c104$export$5d04458e2a6c373e(H, 2)).replace(/{H}/g, H + "").replace(/{hh}/g, $d28d71d6b904c104$export$5d04458e2a6c373e(h + "", 2)).replace(/{h}/g, h + "").replace(/{mm}/g, $d28d71d6b904c104$export$5d04458e2a6c373e(m, 2)).replace(/{m}/g, m + "").replace(/{ss}/g, $d28d71d6b904c104$export$5d04458e2a6c373e(s, 2)).replace(/{s}/g, s + "").replace(/{SSS}/g, $d28d71d6b904c104$export$5d04458e2a6c373e(S, 3)).replace(/{S}/g, S + "");
}
function $d28d71d6b904c104$export$fe777b6293828b5d(tick, idx, formatter, lang, isUTC) {
    var template = null;
    if ($43e0a445ed6711da$export$844ec244b1367d54(formatter)) // Single formatter for all units at all levels
    template = formatter;
    else if ($43e0a445ed6711da$export$f6e2535fb5126e54(formatter)) {
        var extra = {
            time: tick.time,
            level: tick.time ? tick.time.level : 0
        };
        var scaleBreakHelper = (0, $d760dd937396b887$export$e79b20ac82c2d660)();
        if (scaleBreakHelper) scaleBreakHelper.makeAxisLabelFormatterParamBreak(extra, tick["break"]);
        template = formatter(tick.value, idx, extra);
    } else {
        var tickTime = tick.time;
        if (tickTime) {
            var leveledTplArr = formatter[tickTime.lowerTimeUnit][tickTime.upperTimeUnit];
            template = leveledTplArr[Math.min(tickTime.level, leveledTplArr.length - 1)] || "";
        } else {
            // tick may be from customTicks or timeline therefore no tick.time.
            var unit = $d28d71d6b904c104$export$4dfb0417ad6555b7(tick.value, isUTC);
            template = formatter[unit][unit][0];
        }
    }
    return $d28d71d6b904c104$export$d9468344d3651243(new Date(tick.value), template, isUTC, lang);
}
function $d28d71d6b904c104$export$4dfb0417ad6555b7(value, isUTC) {
    var date = $b49750109e236fd8$export$6b862160d295c8e(value);
    var M = date[$d28d71d6b904c104$export$5c242a801a23eec7(isUTC)]() + 1;
    var d = date[$d28d71d6b904c104$export$4189e6cbc9753260(isUTC)]();
    var h = date[$d28d71d6b904c104$export$8b40b55b3c06cbe2(isUTC)]();
    var m = date[$d28d71d6b904c104$export$8807847c5c71eded(isUTC)]();
    var s = date[$d28d71d6b904c104$export$8f49e73e2eebd168(isUTC)]();
    var S = date[$d28d71d6b904c104$export$312207a92d041116(isUTC)]();
    var isSecond = S === 0;
    var isMinute = isSecond && s === 0;
    var isHour = isMinute && m === 0;
    var isDay = isHour && h === 0;
    var isMonth = isDay && d === 1;
    var isYear = isMonth && M === 1;
    if (isYear) return "year";
    else if (isMonth) return "month";
    else if (isDay) return "day";
    else if (isHour) return "hour";
    else if (isMinute) return "minute";
    else if (isSecond) return "second";
    else return "millisecond";
}
function $d28d71d6b904c104$export$2ed3384313b02c28(date, timeUnit, isUTC) {
    switch(timeUnit){
        case "year":
            date[$d28d71d6b904c104$export$233f59998ed71c09(isUTC)](0);
        case "month":
            date[$d28d71d6b904c104$export$82fd379a67f37fa0(isUTC)](1);
        case "day":
            date[$d28d71d6b904c104$export$b6f943e8d23c15bb(isUTC)](0);
        case "hour":
            date[$d28d71d6b904c104$export$50303078793fc7d(isUTC)](0);
        case "minute":
            date[$d28d71d6b904c104$export$a4a908acda9c3118(isUTC)](0);
        case "second":
            date[$d28d71d6b904c104$export$c047afab75f6d84(isUTC)](0);
    }
    return date;
}
function $d28d71d6b904c104$export$8d046fefed9a548e(isUTC) {
    return isUTC ? "getUTCFullYear" : "getFullYear";
}
function $d28d71d6b904c104$export$5c242a801a23eec7(isUTC) {
    return isUTC ? "getUTCMonth" : "getMonth";
}
function $d28d71d6b904c104$export$4189e6cbc9753260(isUTC) {
    return isUTC ? "getUTCDate" : "getDate";
}
function $d28d71d6b904c104$export$8b40b55b3c06cbe2(isUTC) {
    return isUTC ? "getUTCHours" : "getHours";
}
function $d28d71d6b904c104$export$8807847c5c71eded(isUTC) {
    return isUTC ? "getUTCMinutes" : "getMinutes";
}
function $d28d71d6b904c104$export$8f49e73e2eebd168(isUTC) {
    return isUTC ? "getUTCSeconds" : "getSeconds";
}
function $d28d71d6b904c104$export$312207a92d041116(isUTC) {
    return isUTC ? "getUTCMilliseconds" : "getMilliseconds";
}
function $d28d71d6b904c104$export$43fbeac90913b151(isUTC) {
    return isUTC ? "setUTCFullYear" : "setFullYear";
}
function $d28d71d6b904c104$export$233f59998ed71c09(isUTC) {
    return isUTC ? "setUTCMonth" : "setMonth";
}
function $d28d71d6b904c104$export$82fd379a67f37fa0(isUTC) {
    return isUTC ? "setUTCDate" : "setDate";
}
function $d28d71d6b904c104$export$b6f943e8d23c15bb(isUTC) {
    return isUTC ? "setUTCHours" : "setHours";
}
function $d28d71d6b904c104$export$50303078793fc7d(isUTC) {
    return isUTC ? "setUTCMinutes" : "setMinutes";
}
function $d28d71d6b904c104$export$a4a908acda9c3118(isUTC) {
    return isUTC ? "setUTCSeconds" : "setSeconds";
}
function $d28d71d6b904c104$export$c047afab75f6d84(isUTC) {
    return isUTC ? "setUTCMilliseconds" : "setMilliseconds";
}




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $211347b2c684c0f2$export$372ffda650a6e70d(text, font, align, verticalAlign, padding, rich, truncate, lineHeight) {
    var textEl = new (0, $7db7960d25b39b7c$export$2e2bcd8739ae039)({
        style: {
            text: text,
            font: font,
            align: align,
            verticalAlign: verticalAlign,
            padding: padding,
            rich: rich,
            overflow: truncate ? "truncate" : null,
            lineHeight: lineHeight
        }
    });
    return textEl.getBoundingRect();
}


function $78c2ece6dfa6bb7a$export$b6fe44657ce35c42(x) {
    if (!(0, $b49750109e236fd8$export$e90fb89750dba83f)(x)) return $43e0a445ed6711da$export$844ec244b1367d54(x) ? x : "-";
    var parts = (x + "").split(".");
    return parts[0].replace(/(\d{1,3})(?=(?:\d{3})+(?!\d))/g, "$1,") + (parts.length > 1 ? "." + parts[1] : "");
}
function $78c2ece6dfa6bb7a$export$86f54f62aa7a7514(str, upperCaseFirst) {
    str = (str || "").toLowerCase().replace(/-(.)/g, function(match, group1) {
        return group1.toUpperCase();
    });
    if (upperCaseFirst && str) str = str.charAt(0).toUpperCase() + str.slice(1);
    return str;
}
var $78c2ece6dfa6bb7a$export$f3a38102c49f4268 = $43e0a445ed6711da$export$f3a38102c49f4268;
function $78c2ece6dfa6bb7a$export$3cd8db88714decfc(value, valueType, useUTC) {
    var USER_READABLE_DEFUALT_TIME_PATTERN = "{yyyy}-{MM}-{dd} {HH}:{mm}:{ss}";
    function stringToUserReadable(str) {
        return str && $43e0a445ed6711da$export$87c2784dc9fc4ab(str) ? str : "-";
    }
    function isNumberUserReadable(num) {
        return (0, $b49750109e236fd8$export$b5c30d4208814a65)(num);
    }
    var isTypeTime = valueType === "time";
    var isValueDate = value instanceof Date;
    if (isTypeTime || isValueDate) {
        var date = isTypeTime ? (0, $b49750109e236fd8$export$6b862160d295c8e)(value) : value;
        if (!isNaN(+date)) return (0, $d28d71d6b904c104$export$d9468344d3651243)(date, USER_READABLE_DEFUALT_TIME_PATTERN, useUTC);
        else if (isValueDate) return "-";
    // In other cases, continue to try to display the value in the following code.
    }
    if (valueType === "ordinal") return $43e0a445ed6711da$export$29d0bb2a4e07b252(value) ? stringToUserReadable(value) : $43e0a445ed6711da$export$7e4aa119212bc614(value) ? isNumberUserReadable(value) ? value + "" : "-" : "-";
    // By default.
    var numericResult = (0, $b49750109e236fd8$export$8b4007b942b45a96)(value);
    return isNumberUserReadable(numericResult) ? $78c2ece6dfa6bb7a$export$b6fe44657ce35c42(numericResult) : $43e0a445ed6711da$export$29d0bb2a4e07b252(value) ? stringToUserReadable(value) : typeof value === "boolean" ? value + "" : "-";
}
var $78c2ece6dfa6bb7a$var$TPL_VAR_ALIAS = [
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g"
];
var $78c2ece6dfa6bb7a$var$wrapVar = function(varName, seriesIdx) {
    return "{" + varName + (seriesIdx == null ? "" : seriesIdx) + "}";
};
function $78c2ece6dfa6bb7a$export$2028496a35766e41(tpl, paramsList, encode) {
    if (!$43e0a445ed6711da$export$43bee75e5e14138e(paramsList)) paramsList = [
        paramsList
    ];
    var seriesLen = paramsList.length;
    if (!seriesLen) return "";
    var $vars = paramsList[0].$vars || [];
    for(var i = 0; i < $vars.length; i++){
        var alias = $78c2ece6dfa6bb7a$var$TPL_VAR_ALIAS[i];
        tpl = tpl.replace($78c2ece6dfa6bb7a$var$wrapVar(alias), $78c2ece6dfa6bb7a$var$wrapVar(alias, 0));
    }
    for(var seriesIdx = 0; seriesIdx < seriesLen; seriesIdx++)for(var k = 0; k < $vars.length; k++){
        var val = paramsList[seriesIdx][$vars[k]];
        tpl = tpl.replace($78c2ece6dfa6bb7a$var$wrapVar($78c2ece6dfa6bb7a$var$TPL_VAR_ALIAS[k], seriesIdx), encode ? (0, $e2318d49eb46f886$export$f9d6449b9af28dc1)(val) : val);
    }
    return tpl;
}
function $78c2ece6dfa6bb7a$export$2fa08233ee42f8e1(tpl, param, encode) {
    $43e0a445ed6711da$export$79b2f7037acddd43(param, function(value, key) {
        tpl = tpl.replace("{" + key + "}", encode ? (0, $e2318d49eb46f886$export$f9d6449b9af28dc1)(value) : value);
    });
    return tpl;
}
function $78c2ece6dfa6bb7a$export$1987a3dbdf3c45ca(inOpt, extraCssText) {
    var opt = $43e0a445ed6711da$export$844ec244b1367d54(inOpt) ? {
        color: inOpt,
        extraCssText: extraCssText
    } : inOpt || {};
    var color = opt.color;
    var type = opt.type;
    extraCssText = opt.extraCssText;
    var renderMode = opt.renderMode || "html";
    if (!color) return "";
    if (renderMode === "html") return type === "subItem" ? '<span style="display:inline-block;vertical-align:middle;margin-right:8px;margin-left:3px;border-radius:4px;width:4px;height:4px;background-color:' + (0, $e2318d49eb46f886$export$f9d6449b9af28dc1)(color) + ";" + (extraCssText || "") + '"></span>' : '<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:' + (0, $e2318d49eb46f886$export$f9d6449b9af28dc1)(color) + ";" + (extraCssText || "") + '"></span>';
    else {
        // Should better not to auto generate style name by auto-increment number here.
        // Because this util is usually called in tooltip formatter, which is probably
        // called repeatedly when mouse move and the auto-increment number increases fast.
        // Users can make their own style name by theirselves, make it unique and readable.
        var markerId = opt.markerId || "markerX";
        return {
            renderMode: renderMode,
            content: "{" + markerId + "|}  ",
            style: type === "subItem" ? {
                width: 4,
                height: 4,
                borderRadius: 2,
                backgroundColor: color
            } : {
                width: 10,
                height: 10,
                borderRadius: 5,
                backgroundColor: color
            }
        };
    }
}
function $78c2ece6dfa6bb7a$export$3203edd9e5edd663(tpl, value, isUTC) {
    if (tpl === "week" || tpl === "month" || tpl === "quarter" || tpl === "half-year" || tpl === "year") tpl = "MM-dd\nyyyy";
    var date = (0, $b49750109e236fd8$export$6b862160d295c8e)(value);
    var getUTC = isUTC ? "getUTC" : "get";
    var y = date[getUTC + "FullYear"]();
    var M = date[getUTC + "Month"]() + 1;
    var d = date[getUTC + "Date"]();
    var h = date[getUTC + "Hours"]();
    var m = date[getUTC + "Minutes"]();
    var s = date[getUTC + "Seconds"]();
    var S = date[getUTC + "Milliseconds"]();
    tpl = tpl.replace("MM", (0, $d28d71d6b904c104$export$5d04458e2a6c373e)(M, 2)).replace("M", M).replace("yyyy", y).replace("yy", (0, $d28d71d6b904c104$export$5d04458e2a6c373e)(y % 100 + "", 2)).replace("dd", (0, $d28d71d6b904c104$export$5d04458e2a6c373e)(d, 2)).replace("d", d).replace("hh", (0, $d28d71d6b904c104$export$5d04458e2a6c373e)(h, 2)).replace("h", h).replace("mm", (0, $d28d71d6b904c104$export$5d04458e2a6c373e)(m, 2)).replace("m", m).replace("ss", (0, $d28d71d6b904c104$export$5d04458e2a6c373e)(s, 2)).replace("s", s).replace("SSS", (0, $d28d71d6b904c104$export$5d04458e2a6c373e)(S, 3));
    return tpl;
}
function $78c2ece6dfa6bb7a$export$38a1e7552f497c0e(str) {
    return str ? str.charAt(0).toUpperCase() + str.substr(1) : str;
}
function $78c2ece6dfa6bb7a$export$cda04d03233e5555(color, defaultColor) {
    defaultColor = defaultColor || "transparent";
    return $43e0a445ed6711da$export$844ec244b1367d54(color) ? color : $43e0a445ed6711da$export$a6cdc56e425d0d0a(color) ? color.colorStops && (color.colorStops[0] || {}).color || defaultColor : defaultColor;
}
function $78c2ece6dfa6bb7a$export$13e13f9b96dbe8fa(link, target) {
    /* global window */ if (target === "_blank" || target === "blank") {
        var blank = window.open();
        blank.opener = null;
        blank.location.href = link;
    } else window.open(link, target);
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/**
 * FIXME:
 * `nonSeriesBoxCoordSysCreators` and `_nonSeriesBoxMasterList` are hardcoded implementations.
 * Regarding "coord sys layout based on another coord sys", currently we only experimentally support one level
 * dependency, such as, "grid(cartesian)s can be laid out based on matrix/calendar coord sys."
 * But a comprehensive implementation may need to support:
 *  - Recursive dependencies. e.g., a matrix coord sys lays out based on another matrix coord sys.
 *    That requires in the implementation `create` and `update` of coord sys are called by a dependency graph.
 *    (@see enableTopologicalTravel in `util/component.ts`)
 */ var $a30c5e122eaab0a1$var$nonSeriesBoxCoordSysCreators = {};
var $a30c5e122eaab0a1$var$normalCoordSysCreators = {};
var $a30c5e122eaab0a1$var$CoordinateSystemManager = /** @class */ function() {
    function CoordinateSystemManager() {
        this._normalMasterList = [];
        this._nonSeriesBoxMasterList = [];
    }
    /**
   * Typically,
   *  - in `create`, a coord sys lays out based on a given rect;
   *  - in `update`, update the pixel and data extent of there axes (if any) based on processed `series.data`.
   * After that, a coord sys can serve (typically by `dataToPoint`/`dataToLayout`/`pointToData`).
   * If the coordinate system do not lay out based on `series.data`, `update` is not needed.
   */ CoordinateSystemManager.prototype.create = function(ecModel, api) {
        this._nonSeriesBoxMasterList = dealCreate($a30c5e122eaab0a1$var$nonSeriesBoxCoordSysCreators, true);
        this._normalMasterList = dealCreate($a30c5e122eaab0a1$var$normalCoordSysCreators, false);
        function dealCreate(creatorMap, canBeNonSeriesBox) {
            var coordinateSystems = [];
            $43e0a445ed6711da$export$79b2f7037acddd43(creatorMap, function(creator, type) {
                var list = creator.create(ecModel, api);
                coordinateSystems = coordinateSystems.concat(list || []);
            });
            return coordinateSystems;
        }
    };
    /**
   * @see CoordinateSystem['create']
   */ CoordinateSystemManager.prototype.update = function(ecModel, api) {
        $43e0a445ed6711da$export$79b2f7037acddd43(this._normalMasterList, function(coordSys) {
            coordSys.update && coordSys.update(ecModel, api);
        });
    };
    CoordinateSystemManager.prototype.getCoordinateSystems = function() {
        return this._normalMasterList.concat(this._nonSeriesBoxMasterList);
    };
    CoordinateSystemManager.register = function(type, creator) {
        if (type === "matrix" || type === "calendar") {
            // FIXME: hardcode, @see nonSeriesBoxCoordSysCreators
            $a30c5e122eaab0a1$var$nonSeriesBoxCoordSysCreators[type] = creator;
            return;
        }
        $a30c5e122eaab0a1$var$normalCoordSysCreators[type] = creator;
    };
    CoordinateSystemManager.get = function(type) {
        return $a30c5e122eaab0a1$var$normalCoordSysCreators[type] || $a30c5e122eaab0a1$var$nonSeriesBoxCoordSysCreators[type];
    };
    return CoordinateSystemManager;
}();
function $a30c5e122eaab0a1$var$canBeNonSeriesBoxCoordSys(coordSysType) {
    return !!$a30c5e122eaab0a1$var$nonSeriesBoxCoordSysCreators[coordSysType];
}
var $a30c5e122eaab0a1$export$6755bb1cf0b796be = 1;
var $a30c5e122eaab0a1$export$d88bf84633e72240 = 2;
function $a30c5e122eaab0a1$export$b8fb890203e861d5(opt) {
    $a30c5e122eaab0a1$var$coordSysUseMap.set(opt.fullType, {
        getCoord2: undefined
    }).getCoord2 = opt.getCoord2;
}
var $a30c5e122eaab0a1$var$coordSysUseMap = $43e0a445ed6711da$export$55f8aa7ef875b0a4();
function $a30c5e122eaab0a1$export$4818264084d885e(model) {
    var coord = model.getShallow("coord", true);
    var from = $a30c5e122eaab0a1$export$6755bb1cf0b796be;
    if (coord == null) {
        var store = $a30c5e122eaab0a1$var$coordSysUseMap.get(model.type);
        if (store && store.getCoord2) {
            from = $a30c5e122eaab0a1$export$d88bf84633e72240;
            coord = store.getCoord2(model);
        }
    }
    return {
        coord: coord,
        from: from
    };
}
var $a30c5e122eaab0a1$export$bd9a7aa65874feb1 = 0;
var $a30c5e122eaab0a1$export$87a00611f63b7e87 = 1;
var $a30c5e122eaab0a1$export$e670080ba75bc9e9 = 2;
function $a30c5e122eaab0a1$export$29cb72d70b6b3a71(// Component or series
model, printError) {
    // For backward compat, still not use `true` in model.get.
    var coordSysType = model.getShallow("coordinateSystem");
    var coordSysUsageOption = model.getShallow("coordinateSystemUsage", true);
    var isDeclaredExplicitly = coordSysUsageOption != null;
    var kind = $a30c5e122eaab0a1$export$bd9a7aa65874feb1;
    if (coordSysType) {
        var isSeries = model.mainType === "series";
        if (coordSysUsageOption == null) coordSysUsageOption = isSeries ? "data" : "box";
        if (coordSysUsageOption === "data") {
            kind = $a30c5e122eaab0a1$export$87a00611f63b7e87;
            if (!isSeries) kind = $a30c5e122eaab0a1$export$bd9a7aa65874feb1;
        } else if (coordSysUsageOption === "box") {
            kind = $a30c5e122eaab0a1$export$e670080ba75bc9e9;
            if (!isSeries && !$a30c5e122eaab0a1$var$canBeNonSeriesBoxCoordSys(coordSysType)) kind = $a30c5e122eaab0a1$export$bd9a7aa65874feb1;
        }
    }
    return {
        coordSysType: coordSysType,
        kind: kind
    };
}
function $a30c5e122eaab0a1$export$7ed0c09d4f5c932e(opt) {
    var targetModel = opt.targetModel, coordSysType = opt.coordSysType, coordSysProvider = opt.coordSysProvider, isDefaultDataCoordSys = opt.isDefaultDataCoordSys, allowNotFound = opt.allowNotFound;
    var _a = $a30c5e122eaab0a1$export$29cb72d70b6b3a71(targetModel, true), kind = _a.kind, declaredType = _a.coordSysType;
    if (isDefaultDataCoordSys && kind !== $a30c5e122eaab0a1$export$87a00611f63b7e87) {
        // If both `COORD_SYS_USAGE_KIND_DATA` and `COORD_SYS_USAGE_KIND_BOX` declared in one model.
        // There is the only case in series-graph, and no other cases yet.
        kind = $a30c5e122eaab0a1$export$87a00611f63b7e87;
        declaredType = coordSysType;
    }
    if (kind === $a30c5e122eaab0a1$export$bd9a7aa65874feb1 || declaredType !== coordSysType) return $a30c5e122eaab0a1$export$bd9a7aa65874feb1;
    var coordSys = coordSysProvider(coordSysType, targetModel);
    if (!coordSys) return $a30c5e122eaab0a1$export$bd9a7aa65874feb1;
    if (kind === $a30c5e122eaab0a1$export$87a00611f63b7e87) targetModel.coordinateSystem = coordSys;
    else // kind === COORD_SYS_USAGE_KIND_BOX
    targetModel.boxCoordinateSystem = coordSys;
    return kind;
}
var $a30c5e122eaab0a1$export$33b06c851894cd19 = function(coordSysType, injectTargetModel) {
    var coordSysModel = injectTargetModel.getReferringComponents(coordSysType, (0, $87f4a59ac66e0ee6$export$f076738ec84e693c)).models[0];
    return coordSysModel && coordSysModel.coordinateSystem;
};
var $a30c5e122eaab0a1$export$2e2bcd8739ae039 = $a30c5e122eaab0a1$var$CoordinateSystemManager;


var $826bc4094efae72b$var$each = $43e0a445ed6711da$export$79b2f7037acddd43;
var $826bc4094efae72b$export$a9aa2cc018afbed = [
    "left",
    "right",
    "top",
    "bottom",
    "width",
    "height"
];
var $826bc4094efae72b$export$d7fd4338c7b20804 = [
    [
        "width",
        "left",
        "right"
    ],
    [
        "height",
        "top",
        "bottom"
    ]
];
function $826bc4094efae72b$var$boxLayout(orient, group, gap, maxWidth, maxHeight) {
    var x = 0;
    var y = 0;
    if (maxWidth == null) maxWidth = Infinity;
    if (maxHeight == null) maxHeight = Infinity;
    var currentLineMaxSize = 0;
    group.eachChild(function(child, idx) {
        var rect = child.getBoundingRect();
        var nextChild = group.childAt(idx + 1);
        var nextChildRect = nextChild && nextChild.getBoundingRect();
        var nextX;
        var nextY;
        if (orient === "horizontal") {
            var moveX = rect.width + (nextChildRect ? -nextChildRect.x + rect.x : 0);
            nextX = x + moveX;
            // Wrap when width exceeds maxWidth or meet a `newline` group
            // FIXME compare before adding gap?
            if (nextX > maxWidth || child.newline) {
                x = 0;
                nextX = moveX;
                y += currentLineMaxSize + gap;
                currentLineMaxSize = rect.height;
            } else // FIXME: consider rect.y is not `0`?
            currentLineMaxSize = Math.max(currentLineMaxSize, rect.height);
        } else {
            var moveY = rect.height + (nextChildRect ? -nextChildRect.y + rect.y : 0);
            nextY = y + moveY;
            // Wrap when width exceeds maxHeight or meet a `newline` group
            if (nextY > maxHeight || child.newline) {
                x += currentLineMaxSize + gap;
                y = 0;
                nextY = moveY;
                currentLineMaxSize = rect.width;
            } else currentLineMaxSize = Math.max(currentLineMaxSize, rect.width);
        }
        if (child.newline) return;
        child.x = x;
        child.y = y;
        child.markRedraw();
        orient === "horizontal" ? x = nextX + gap : y = nextY + gap;
    });
}
var $826bc4094efae72b$export$827f4ee28efc37 = $826bc4094efae72b$var$boxLayout;
var $826bc4094efae72b$export$be20d9158c17374c = $43e0a445ed6711da$export$c3095a23b368d1f2($826bc4094efae72b$var$boxLayout, "vertical");
var $826bc4094efae72b$export$ae65a483d943e7a7 = $43e0a445ed6711da$export$c3095a23b368d1f2($826bc4094efae72b$var$boxLayout, "horizontal");
function $826bc4094efae72b$export$22344244a123da8(boxLayoutModel, ignoreParent) {
    return {
        left: boxLayoutModel.getShallow("left", ignoreParent),
        top: boxLayoutModel.getShallow("top", ignoreParent),
        right: boxLayoutModel.getShallow("right", ignoreParent),
        bottom: boxLayoutModel.getShallow("bottom", ignoreParent),
        width: boxLayoutModel.getShallow("width", ignoreParent),
        height: boxLayoutModel.getShallow("height", ignoreParent)
    };
}
function $826bc4094efae72b$var$getViewRectAndCenterForCircleLayout(seriesModel, api) {
    var layoutRef = $826bc4094efae72b$export$5aec1e94f566e59f(seriesModel, api, {
        enableLayoutOnlyByCenter: true
    });
    var boxLayoutParams = seriesModel.getBoxLayoutParams();
    var viewRect;
    var center;
    if (layoutRef.type === $826bc4094efae72b$export$953b11ffc6912560.point) {
        center = layoutRef.refPoint;
        // `viewRect` is required in `pie/labelLayout.ts`.
        viewRect = $826bc4094efae72b$export$4517a5ca639a7293(boxLayoutParams, {
            width: api.getWidth(),
            height: api.getHeight()
        });
    } else {
        // layoutRef.type === layout.BoxLayoutReferenceType.rect
        var centerOption = seriesModel.get("center");
        var centerOptionArr = $43e0a445ed6711da$export$43bee75e5e14138e(centerOption) ? centerOption : [
            centerOption,
            centerOption
        ];
        viewRect = $826bc4094efae72b$export$4517a5ca639a7293(boxLayoutParams, layoutRef.refContainer);
        center = layoutRef.boxCoordFrom === (0, $a30c5e122eaab0a1$export$d88bf84633e72240) ? layoutRef.refPoint // option `series.center` has been used as coord.
         : [
            (0, $b49750109e236fd8$export$e8514cb5a5e2b40f)(centerOptionArr[0], viewRect.width) + viewRect.x,
            (0, $b49750109e236fd8$export$e8514cb5a5e2b40f)(centerOptionArr[1], viewRect.height) + viewRect.y
        ];
    }
    return {
        viewRect: viewRect,
        center: center
    };
}
function $826bc4094efae72b$export$3101c00baac0ee1f(seriesModel, api) {
    // center can be string or number when coordinateSystem is specified
    var _a = $826bc4094efae72b$var$getViewRectAndCenterForCircleLayout(seriesModel, api), viewRect = _a.viewRect, center = _a.center;
    var radius = seriesModel.get("radius");
    if (!$43e0a445ed6711da$export$43bee75e5e14138e(radius)) radius = [
        0,
        radius
    ];
    var width = (0, $b49750109e236fd8$export$e8514cb5a5e2b40f)(viewRect.width, api.getWidth());
    var height = (0, $b49750109e236fd8$export$e8514cb5a5e2b40f)(viewRect.height, api.getHeight());
    var size = Math.min(width, height);
    var r0 = (0, $b49750109e236fd8$export$e8514cb5a5e2b40f)(radius[0], size / 2);
    var r = (0, $b49750109e236fd8$export$e8514cb5a5e2b40f)(radius[1], size / 2);
    return {
        cx: center[0],
        cy: center[1],
        r0: r0,
        r: r,
        viewRect: viewRect
    };
}
function $826bc4094efae72b$export$4517a5ca639a7293(positionInfo, containerRect, // This is the space from the `containerRect` to the returned bounding rect.
// Commonly used in option `legend.padding`, `timeline.padding`, `title.padding`,
//  `visualMap.padding`, ...
// [NOTICE]:
//  It's named `margin`, because it's the space that outside the bounding rect. But from
//  the perspective of the the caller, it's commonly used as the `padding` of a component,
//  because conventionally background color covers this space.
// [BEHAVIOR]:
//  - If width/height is specified, `margin` does not effect them.
//  - Otherwise, they are calculated based on the rect that `containerRect` shrinked by `margin`.
//  - left/right/top/bottom are based on the rect that `containerRect` shrinked by `margin`.
margin) {
    margin = $78c2ece6dfa6bb7a$export$f3a38102c49f4268(margin || 0);
    var containerWidth = containerRect.width;
    var containerHeight = containerRect.height;
    var left = (0, $b49750109e236fd8$export$e8514cb5a5e2b40f)(positionInfo.left, containerWidth);
    var top = (0, $b49750109e236fd8$export$e8514cb5a5e2b40f)(positionInfo.top, containerHeight);
    var right = (0, $b49750109e236fd8$export$e8514cb5a5e2b40f)(positionInfo.right, containerWidth);
    var bottom = (0, $b49750109e236fd8$export$e8514cb5a5e2b40f)(positionInfo.bottom, containerHeight);
    var width = (0, $b49750109e236fd8$export$e8514cb5a5e2b40f)(positionInfo.width, containerWidth);
    var height = (0, $b49750109e236fd8$export$e8514cb5a5e2b40f)(positionInfo.height, containerHeight);
    var verticalMargin = margin[2] + margin[0];
    var horizontalMargin = margin[1] + margin[3];
    var aspect = positionInfo.aspect;
    // If width is not specified, calculate width from left and right
    if (isNaN(width)) width = containerWidth - right - horizontalMargin - left;
    if (isNaN(height)) height = containerHeight - bottom - verticalMargin - top;
    if (aspect != null) {
        // If width and height are not given
        // 1. Graph should not exceeds the container
        // 2. Aspect must be keeped
        // 3. Graph should take the space as more as possible
        // FIXME
        // Margin is not considered, because there is no case that both
        // using margin and aspect so far.
        if (isNaN(width) && isNaN(height)) {
            // PENDING: if only `left` or `right` is defined, perhaps it's more preferable to
            // calculate size based on `containerWidth - left` or `containerWidth - left` here,
            // but for backward compatibility we do not change it.
            if (aspect > containerWidth / containerHeight) width = containerWidth * 0.8;
            else height = containerHeight * 0.8;
        }
        // Calculate width or height with given aspect
        if (isNaN(width)) width = aspect * height;
        if (isNaN(height)) height = width / aspect;
    }
    // If left is not specified, calculate left from right and width
    if (isNaN(left)) left = containerWidth - right - width - horizontalMargin;
    if (isNaN(top)) top = containerHeight - bottom - height - verticalMargin;
    // Align left and top
    switch(positionInfo.left || positionInfo.right){
        case "center":
            left = containerWidth / 2 - width / 2 - margin[3];
            break;
        case "right":
            left = containerWidth - width - horizontalMargin;
            break;
    }
    switch(positionInfo.top || positionInfo.bottom){
        case "middle":
        case "center":
            top = containerHeight / 2 - height / 2 - margin[0];
            break;
        case "bottom":
            top = containerHeight - height - verticalMargin;
            break;
    }
    // If something is wrong and left, top, width, height are calculated as NaN
    left = left || 0;
    top = top || 0;
    if (isNaN(width)) // Width may be NaN if only one value is given except width
    width = containerWidth - horizontalMargin - left - (right || 0);
    if (isNaN(height)) // Height may be NaN if only one value is given except height
    height = containerHeight - verticalMargin - top - (bottom || 0);
    var rect = new (0, $c437f598d9c9ee16$export$2e2bcd8739ae039)((containerRect.x || 0) + left + margin[3], (containerRect.y || 0) + top + margin[0], width, height);
    rect.margin = margin;
    return rect;
}
function $826bc4094efae72b$export$9fec79e40d579ea7(component, layoutRect, // That is, `width / height`.
// Assume `aspect` is positive.
aspect) {
    var preserveAspect = component.getShallow("preserveAspect", true);
    if (!preserveAspect) return layoutRect;
    var actualAspect = layoutRect.width / layoutRect.height;
    if (Math.abs(Math.atan(aspect) - Math.atan(actualAspect)) < 1e-9) return layoutRect;
    var preserveAspectAlign = component.getShallow("preserveAspectAlign", true);
    var preserveAspectVerticalAlign = component.getShallow("preserveAspectVerticalAlign", true);
    var layoutOptInner = {
        width: layoutRect.width,
        height: layoutRect.height
    };
    var isCover = preserveAspect === "cover";
    if (actualAspect > aspect && !isCover || actualAspect < aspect && isCover) {
        layoutOptInner.width = layoutRect.height * aspect;
        preserveAspectAlign === "left" ? layoutOptInner.left = 0 : preserveAspectAlign === "right" ? layoutOptInner.right = 0 : layoutOptInner.left = "center";
    } else {
        layoutOptInner.height = layoutRect.width / aspect;
        preserveAspectVerticalAlign === "top" ? layoutOptInner.top = 0 : preserveAspectVerticalAlign === "bottom" ? layoutOptInner.bottom = 0 : layoutOptInner.top = "middle";
    }
    return $826bc4094efae72b$export$4517a5ca639a7293(layoutOptInner, layoutRect);
}
var $826bc4094efae72b$export$953b11ffc6912560 = {
    rect: 1,
    point: 2
};
function $826bc4094efae72b$export$5aec1e94f566e59f(model, api, opt) {
    var refContainer;
    var refPoint;
    var layoutRefType;
    var boxCoordSys = model.boxCoordinateSystem;
    var boxCoordFrom;
    if (boxCoordSys) {
        var _a = (0, $a30c5e122eaab0a1$export$4818264084d885e)(model), coord = _a.coord, from = _a.from;
        // Do not use `clamp` in `dataToLayout` and `dataToPoint`, because:
        //  1. Should support overflow (such as, by dataZoom), where NaN should be in the result.
        //  2. Be consistent with the way used in `series.data`
        if (boxCoordSys.dataToLayout) {
            layoutRefType = $826bc4094efae72b$export$953b11ffc6912560.rect;
            boxCoordFrom = from;
            var result = boxCoordSys.dataToLayout(coord);
            refContainer = result.contentRect || result.rect;
        } else if (opt && opt.enableLayoutOnlyByCenter && boxCoordSys.dataToPoint) {
            layoutRefType = $826bc4094efae72b$export$953b11ffc6912560.point;
            boxCoordFrom = from;
            refPoint = boxCoordSys.dataToPoint(coord);
        }
    }
    if (layoutRefType == null) layoutRefType = $826bc4094efae72b$export$953b11ffc6912560.rect;
    if (layoutRefType === $826bc4094efae72b$export$953b11ffc6912560.rect) {
        if (!refContainer) refContainer = {
            x: 0,
            y: 0,
            width: api.getWidth(),
            height: api.getHeight()
        };
        refPoint = [
            refContainer.x + refContainer.width / 2,
            refContainer.y + refContainer.height / 2
        ];
    }
    return {
        type: layoutRefType,
        refContainer: refContainer,
        refPoint: refPoint,
        boxCoordFrom: boxCoordFrom
    };
}
function $826bc4094efae72b$export$74054bd96b5eeef1(el, positionInfo, containerRect, margin, opt, out) {
    var h = !opt || !opt.hv || opt.hv[0];
    var v = !opt || !opt.hv || opt.hv[1];
    var boundingMode = opt && opt.boundingMode || "all";
    out = out || el;
    out.x = el.x;
    out.y = el.y;
    if (!h && !v) return false;
    var rect;
    if (boundingMode === "raw") rect = el.type === "group" ? new (0, $c437f598d9c9ee16$export$2e2bcd8739ae039)(0, 0, +positionInfo.width || 0, +positionInfo.height || 0) : el.getBoundingRect();
    else {
        rect = el.getBoundingRect();
        if (el.needLocalTransform()) {
            var transform = el.getLocalTransform();
            // Notice: raw rect may be inner object of el,
            // which should not be modified.
            rect = rect.clone();
            rect.applyTransform(transform);
        }
    }
    // The real width and height can not be specified but calculated by the given el.
    var layoutRect = $826bc4094efae72b$export$4517a5ca639a7293($43e0a445ed6711da$export$ebe90cb607ad99e({
        width: rect.width,
        height: rect.height
    }, positionInfo), containerRect, margin);
    // Because 'tranlate' is the last step in transform
    // (see zrender/core/Transformable#getLocalTransform),
    // we can just only modify el.position to get final result.
    var dx = h ? layoutRect.x - rect.x : 0;
    var dy = v ? layoutRect.y - rect.y : 0;
    if (boundingMode === "raw") {
        out.x = dx;
        out.y = dy;
    } else {
        out.x += dx;
        out.y += dy;
    }
    if (out === el) el.markRedraw();
    return true;
}
function $826bc4094efae72b$export$7ede609e8ebc9650(option, hvIdx) {
    return option[$826bc4094efae72b$export$d7fd4338c7b20804[hvIdx][0]] != null || option[$826bc4094efae72b$export$d7fd4338c7b20804[hvIdx][1]] != null && option[$826bc4094efae72b$export$d7fd4338c7b20804[hvIdx][2]] != null;
}
function $826bc4094efae72b$export$3968a28a7cbd6063(ins) {
    var layoutMode = ins.layoutMode || ins.constructor.layoutMode;
    return $43e0a445ed6711da$export$a6cdc56e425d0d0a(layoutMode) ? layoutMode : layoutMode ? {
        type: layoutMode
    } : null;
}
function $826bc4094efae72b$export$1754cb91f16ca028(targetOption, newOption, opt) {
    var ignoreSize = opt && opt.ignoreSize;
    !$43e0a445ed6711da$export$43bee75e5e14138e(ignoreSize) && (ignoreSize = [
        ignoreSize,
        ignoreSize
    ]);
    var hResult = merge($826bc4094efae72b$export$d7fd4338c7b20804[0], 0);
    var vResult = merge($826bc4094efae72b$export$d7fd4338c7b20804[1], 1);
    copy($826bc4094efae72b$export$d7fd4338c7b20804[0], targetOption, hResult);
    copy($826bc4094efae72b$export$d7fd4338c7b20804[1], targetOption, vResult);
    function merge(names, hvIdx) {
        var newParams = {};
        var newValueCount = 0;
        var merged = {};
        var mergedValueCount = 0;
        var enoughParamNumber = 2;
        $826bc4094efae72b$var$each(names, function(name) {
            merged[name] = targetOption[name];
        });
        $826bc4094efae72b$var$each(names, function(name) {
            // Consider case: newOption.width is null, which is
            // set by user for removing width setting.
            $43e0a445ed6711da$export$b5a638e9b3fff9f3(newOption, name) && (newParams[name] = merged[name] = newOption[name]);
            hasValue(newParams, name) && newValueCount++;
            hasValue(merged, name) && mergedValueCount++;
        });
        if (ignoreSize[hvIdx]) {
            // Only one of left/right is premitted to exist.
            if (hasValue(newOption, names[1])) merged[names[2]] = null;
            else if (hasValue(newOption, names[2])) merged[names[1]] = null;
            return merged;
        }
        // Case: newOption: {width: ..., right: ...},
        // or targetOption: {right: ...} and newOption: {width: ...},
        // There is no conflict when merged only has params count
        // little than enoughParamNumber.
        if (mergedValueCount === enoughParamNumber || !newValueCount) return merged;
        else if (newValueCount >= enoughParamNumber) return newParams;
        else {
            // Chose another param from targetOption by priority.
            for(var i = 0; i < names.length; i++){
                var name_1 = names[i];
                if (!$43e0a445ed6711da$export$b5a638e9b3fff9f3(newParams, name_1) && $43e0a445ed6711da$export$b5a638e9b3fff9f3(targetOption, name_1)) {
                    newParams[name_1] = targetOption[name_1];
                    break;
                }
            }
            return newParams;
        }
    }
    function hasValue(obj, name) {
        return obj[name] != null && obj[name] !== "auto";
    }
    function copy(names, target, source) {
        $826bc4094efae72b$var$each(names, function(name) {
            target[name] = source[name];
        });
    }
}
function $826bc4094efae72b$export$4b0d20af19c9875e(source) {
    return $826bc4094efae72b$export$7438999faea9b6cc({}, source);
}
function $826bc4094efae72b$export$7438999faea9b6cc(target, source) {
    source && target && $826bc4094efae72b$var$each($826bc4094efae72b$export$a9aa2cc018afbed, function(name) {
        $43e0a445ed6711da$export$b5a638e9b3fff9f3(source, name) && (target[name] = source[name]);
    });
    return target;
}


var $4a9041b12b787d1b$var$inner = (0, $87f4a59ac66e0ee6$export$64df9f8d92ae083f)();
var $4a9041b12b787d1b$var$ComponentModel = /** @class */ function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(ComponentModel, _super);
    function ComponentModel(option, parentModel, ecModel) {
        var _this = _super.call(this, option, parentModel, ecModel) || this;
        _this.uid = $f7a89889802a4565$export$6d2b3473b0986646("ec_cpt_model");
        return _this;
    }
    ComponentModel.prototype.init = function(option, parentModel, ecModel) {
        this.mergeDefaultAndTheme(option, ecModel);
    };
    ComponentModel.prototype.mergeDefaultAndTheme = function(option, ecModel) {
        var layoutMode = $826bc4094efae72b$export$3968a28a7cbd6063(this);
        var inputPositionParams = layoutMode ? $826bc4094efae72b$export$4b0d20af19c9875e(option) : {};
        var themeModel = ecModel.getTheme();
        $43e0a445ed6711da$export$4950aa0f605343fb(option, themeModel.get(this.mainType));
        $43e0a445ed6711da$export$4950aa0f605343fb(option, this.getDefaultOption());
        if (layoutMode) $826bc4094efae72b$export$1754cb91f16ca028(option, inputPositionParams, layoutMode);
    };
    ComponentModel.prototype.mergeOption = function(option, ecModel) {
        $43e0a445ed6711da$export$4950aa0f605343fb(this.option, option, true);
        var layoutMode = $826bc4094efae72b$export$3968a28a7cbd6063(this);
        if (layoutMode) $826bc4094efae72b$export$1754cb91f16ca028(this.option, option, layoutMode);
    };
    /**
   * Called immediately after `init` or `mergeOption` of this instance called.
   */ ComponentModel.prototype.optionUpdated = function(newCptOption, isInit) {
    // MUST NOT do anything here.
    };
    /**
   * [How to declare defaultOption]:
   *
   * (A) If using class declaration in typescript (since echarts 5):
   * ```ts
   * import {ComponentOption} from '../model/option.js';
   * export interface XxxOption extends ComponentOption {
   *     aaa: number
   * }
   * export class XxxModel extends Component {
   *     static type = 'xxx';
   *     static defaultOption: XxxOption = {
   *         aaa: 123
   *     }
   * }
   * Component.registerClass(XxxModel);
   * ```
   * ```ts
   * import {inheritDefaultOption} from '../util/component.js';
   * import {XxxModel, XxxOption} from './XxxModel.js';
   * export interface XxxSubOption extends XxxOption {
   *     bbb: number
   * }
   * class XxxSubModel extends XxxModel {
   *     static defaultOption: XxxSubOption = inheritDefaultOption(XxxModel.defaultOption, {
   *         bbb: 456
   *     })
   *     fn() {
   *         let opt = this.getDefaultOption();
   *         // opt is {aaa: 123, bbb: 456}
   *     }
   * }
   * ```
   *
   * (B) If using class extend (previous approach in echarts 3 & 4):
   * ```js
   * let XxxComponent = Component.extend({
   *     defaultOption: {
   *         xx: 123
   *     }
   * })
   * ```
   * ```js
   * let XxxSubComponent = XxxComponent.extend({
   *     defaultOption: {
   *         yy: 456
   *     },
   *     fn: function () {
   *         let opt = this.getDefaultOption();
   *         // opt is {xx: 123, yy: 456}
   *     }
   * })
   * ```
   */ ComponentModel.prototype.getDefaultOption = function() {
        var ctor = this.constructor;
        if (!(0, $10ce7a4361c3910c$export$4f3b818f3dd2d182)(ctor)) // When using ES class declaration, defaultOption must be declared as static.
        // And manually inherit the defaultOption from its parent class if needed, such as,
        //  ```ts
        //  static defaultOption = inheritDefaultOption(ParentModel.defaultOption, {...});
        //  ```
        return ctor.defaultOption;
        // FIXME: remove this approach?
        // Legacy: auto merge defaultOption from ancestor classes if using ParentClass.extend(subProto)
        var fields = $4a9041b12b787d1b$var$inner(this);
        if (!fields.defaultOption) {
            var optList = [];
            var clz = ctor;
            while(clz){
                var opt = clz.prototype.defaultOption;
                opt && optList.push(opt);
                clz = clz.superClass;
            }
            var defaultOption = {};
            for(var i = optList.length - 1; i >= 0; i--)defaultOption = $43e0a445ed6711da$export$4950aa0f605343fb(defaultOption, optList[i], true);
            fields.defaultOption = defaultOption;
        }
        return fields.defaultOption;
    };
    /**
   * Notice: always force to input param `useDefault` in case that forget to consider it.
   * The same behavior as `modelUtil.parseFinder`.
   *
   * @param useDefault In many cases like series refer axis and axis refer grid,
   *        If axis index / axis id not specified, use the first target as default.
   *        In other cases like dataZoom refer axis, if not specified, measn no refer.
   */ ComponentModel.prototype.getReferringComponents = function(mainType, opt) {
        var indexKey = mainType + "Index";
        var idKey = mainType + "Id";
        return (0, $87f4a59ac66e0ee6$export$dc741340f7e5f186)(this.ecModel, mainType, {
            index: this.get(indexKey, true),
            id: this.get(idKey, true)
        }, opt);
    };
    ComponentModel.prototype.getBoxLayoutParams = function() {
        // Consider itself having box layout configs.
        // For backward compatibility, by default do not `ignoreParent`.
        return $826bc4094efae72b$export$22344244a123da8(this, false);
    };
    /**
   * If developers don't configure zlevel. We will assign zlevel to series based on the key, if provided.
   * For example, lines with trail effect is expected to be in an individual zlevel.
   *
   * @tutorial [GET_ZLEVEL_KEY_FOR_PROGRESSIVE]
   * Regarding "progressive rendering", zrender can automatically assign a dedicated "incremental layer"
   * for `el.incremental` per zlevel. But there is a trade-off:
   *  - If we do not provide different zlevelKey for different series here, all incremental elements from
   *    different series will be assigned to one incremental layer, which causes them to cover each other
   *    in an order depending on progressive steps.
   *      i.e., seriesA_el1 -covered_by-> seriesB_el1 -covered_by-> seriesC_el1 -> seriesA_el2 -> seriesB_el2 ...
   *    This order may causes an unexpected visual result: series with small data are likely to be completely
   *    covered by series with large data. (like in test/scatter-weibo.html)
   *  - If we assign a different zlevelKey to each series, the "covering issue" above can be resolved,
   *    but having one HTML Canvas per series may be excessively memory-consuming.
   *  Therefore, we only automatically assign zlevelKey on `ScatterSeries` and `LinesSeries` for backward
   *  compatibility, and not to other series. Users can explicitly assign zlevel if they encouter above
   *  "covering issue".
   */ ComponentModel.prototype.getZLevelKey = function() {
        return "";
    };
    ComponentModel.prototype.setZLevel = function(zlevel) {
        this.option.zlevel = zlevel;
    };
    ComponentModel.protoInitialize = function() {
        var proto = ComponentModel.prototype;
        proto.type = "component";
        proto.id = "";
        proto.name = "";
        proto.mainType = "";
        proto.subType = "";
        proto.componentIndex = 0;
    }();
    return ComponentModel;
}((0, $279973fc50f77a15$export$2e2bcd8739ae039));
(0, $10ce7a4361c3910c$export$c9c2d87774f1275d)($4a9041b12b787d1b$var$ComponentModel, (0, $279973fc50f77a15$export$2e2bcd8739ae039));
(0, $10ce7a4361c3910c$export$241315e45585454d)($4a9041b12b787d1b$var$ComponentModel);
$f7a89889802a4565$export$b9faf30b7d655a6f($4a9041b12b787d1b$var$ComponentModel);
$f7a89889802a4565$export$ce592d345a3ec040($4a9041b12b787d1b$var$ComponentModel, $4a9041b12b787d1b$var$getDependencies);
function $4a9041b12b787d1b$var$getDependencies(componentType) {
    var deps = [];
    $43e0a445ed6711da$export$79b2f7037acddd43($4a9041b12b787d1b$var$ComponentModel.getClassesByMainType(componentType), function(clz) {
        deps = deps.concat(clz.dependencies || clz.prototype.dependencies || []);
    });
    // Ensure main type.
    deps = $43e0a445ed6711da$export$871de8747c9eaa88(deps, function(type) {
        return (0, $10ce7a4361c3910c$export$fbe18865d303bf01)(type).main;
    });
    // Hack dataset for convenience.
    if (componentType !== "dataset" && $43e0a445ed6711da$export$305f7d4e9d4624f2(deps, "dataset") <= 0) deps.unshift("dataset");
    return deps;
}
var $4a9041b12b787d1b$export$2e2bcd8739ae039 = $4a9041b12b787d1b$var$ComponentModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $8327d823e00b772c$var$tokens = {
    color: {},
    darkColor: {},
    size: {}
};
var $8327d823e00b772c$var$color = $8327d823e00b772c$var$tokens.color = {
    theme: [
        "#5070dd",
        "#b6d634",
        "#505372",
        "#ff994d",
        "#0ca8df",
        "#ffd10a",
        "#fb628b",
        "#785db0",
        "#3fbe95"
    ],
    neutral00: "#fff",
    neutral05: "#f4f7fd",
    neutral10: "#e8ebf0",
    neutral15: "#dbdee4",
    neutral20: "#cfd2d7",
    neutral25: "#c3c5cb",
    neutral30: "#b7b9be",
    neutral35: "#aaacb2",
    neutral40: "#9ea0a5",
    neutral45: "#929399",
    neutral50: "#86878c",
    neutral55: "#797b7f",
    neutral60: "#6d6e73",
    neutral65: "#616266",
    neutral70: "#54555a",
    neutral75: "#48494d",
    neutral80: "#3c3c41",
    neutral85: "#303034",
    neutral90: "#232328",
    neutral95: "#17171b",
    neutral99: "#000",
    accent05: "#eff1f9",
    accent10: "#e0e4f2",
    accent15: "#d0d6ec",
    accent20: "#c0c9e6",
    accent25: "#b1bbdf",
    accent30: "#a1aed9",
    accent35: "#91a0d3",
    accent40: "#8292cc",
    accent45: "#7285c6",
    accent50: "#6578ba",
    accent55: "#5c6da9",
    accent60: "#536298",
    accent65: "#4a5787",
    accent70: "#404c76",
    accent75: "#374165",
    accent80: "#2e3654",
    accent85: "#252b43",
    accent90: "#1b2032",
    accent95: "#121521",
    transparent: "rgba(0,0,0,0)",
    highlight: "rgba(255,231,130,0.8)"
};
(0, $43e0a445ed6711da$export$8b58be045bf06082)($8327d823e00b772c$var$color, {
    primary: $8327d823e00b772c$var$color.neutral80,
    secondary: $8327d823e00b772c$var$color.neutral70,
    tertiary: $8327d823e00b772c$var$color.neutral60,
    quaternary: $8327d823e00b772c$var$color.neutral50,
    disabled: $8327d823e00b772c$var$color.neutral20,
    border: $8327d823e00b772c$var$color.neutral30,
    borderTint: $8327d823e00b772c$var$color.neutral20,
    borderShade: $8327d823e00b772c$var$color.neutral40,
    background: $8327d823e00b772c$var$color.neutral05,
    backgroundTint: "rgba(234,237,245,0.5)",
    backgroundTransparent: "rgba(255,255,255,0)",
    backgroundShade: $8327d823e00b772c$var$color.neutral10,
    shadow: "rgba(0,0,0,0.2)",
    shadowTint: "rgba(129,130,136,0.2)",
    axisLine: $8327d823e00b772c$var$color.neutral70,
    axisLineTint: $8327d823e00b772c$var$color.neutral40,
    axisTick: $8327d823e00b772c$var$color.neutral70,
    axisTickMinor: $8327d823e00b772c$var$color.neutral60,
    axisLabel: $8327d823e00b772c$var$color.neutral70,
    axisSplitLine: $8327d823e00b772c$var$color.neutral15,
    axisMinorSplitLine: $8327d823e00b772c$var$color.neutral05
});
for(var $8327d823e00b772c$var$key in $8327d823e00b772c$var$color)if ($8327d823e00b772c$var$color.hasOwnProperty($8327d823e00b772c$var$key)) {
    var $8327d823e00b772c$var$hex = $8327d823e00b772c$var$color[$8327d823e00b772c$var$key];
    if ($8327d823e00b772c$var$key === "theme") // Don't modify theme colors.
    $8327d823e00b772c$var$tokens.darkColor.theme = $8327d823e00b772c$var$color.theme.slice();
    else if ($8327d823e00b772c$var$key === "highlight") $8327d823e00b772c$var$tokens.darkColor.highlight = "rgba(255,231,130,0.4)";
    else if ($8327d823e00b772c$var$key.indexOf("accent") === 0) // Desaturate and lighten accent colors.
    $8327d823e00b772c$var$tokens.darkColor[$8327d823e00b772c$var$key] = (0, $b0979f18b0a232f9$export$d898ae866e27bf18)($8327d823e00b772c$var$hex, null, function(s) {
        return s * 0.5;
    }, function(l) {
        return Math.min(1, 1.3 - l);
    });
    else $8327d823e00b772c$var$tokens.darkColor[$8327d823e00b772c$var$key] = (0, $b0979f18b0a232f9$export$d898ae866e27bf18)($8327d823e00b772c$var$hex, null, function(s) {
        return s * 0.9;
    }, function(l) {
        return 1 - Math.pow(l, 1.5);
    });
}
$8327d823e00b772c$var$tokens.size = {
    xxs: 2,
    xs: 5,
    s: 10,
    m: 15,
    l: 20,
    xl: 30,
    xxl: 40,
    xxxl: 50
};
var $8327d823e00b772c$export$2e2bcd8739ae039 = $8327d823e00b772c$var$tokens;


var $bafd6197f944c639$var$platform = "";
// Navigator not exists in node
if (typeof navigator !== "undefined") $bafd6197f944c639$var$platform = navigator.platform || "";
var $bafd6197f944c639$var$decalColor = "rgba(0, 0, 0, 0.2)";
var $bafd6197f944c639$var$themeColor = (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.theme[0];
var $bafd6197f944c639$var$lightThemeColor = (0, $b0979f18b0a232f9$export$d898ae866e27bf18)($bafd6197f944c639$var$themeColor, null, null, 0.9);
var $bafd6197f944c639$export$2e2bcd8739ae039 = {
    darkMode: "auto",
    // backgroundColor: 'rgba(0,0,0,0)',
    colorBy: "series",
    color: (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.theme,
    gradientColor: [
        $bafd6197f944c639$var$lightThemeColor,
        $bafd6197f944c639$var$themeColor
    ],
    aria: {
        decal: {
            decals: [
                {
                    color: $bafd6197f944c639$var$decalColor,
                    dashArrayX: [
                        1,
                        0
                    ],
                    dashArrayY: [
                        2,
                        5
                    ],
                    symbolSize: 1,
                    rotation: Math.PI / 6
                },
                {
                    color: $bafd6197f944c639$var$decalColor,
                    symbol: "circle",
                    dashArrayX: [
                        [
                            8,
                            8
                        ],
                        [
                            0,
                            8,
                            8,
                            0
                        ]
                    ],
                    dashArrayY: [
                        6,
                        0
                    ],
                    symbolSize: 0.8
                },
                {
                    color: $bafd6197f944c639$var$decalColor,
                    dashArrayX: [
                        1,
                        0
                    ],
                    dashArrayY: [
                        4,
                        3
                    ],
                    rotation: -Math.PI / 4
                },
                {
                    color: $bafd6197f944c639$var$decalColor,
                    dashArrayX: [
                        [
                            6,
                            6
                        ],
                        [
                            0,
                            6,
                            6,
                            0
                        ]
                    ],
                    dashArrayY: [
                        6,
                        0
                    ]
                },
                {
                    color: $bafd6197f944c639$var$decalColor,
                    dashArrayX: [
                        [
                            1,
                            0
                        ],
                        [
                            1,
                            6
                        ]
                    ],
                    dashArrayY: [
                        1,
                        0,
                        6,
                        0
                    ],
                    rotation: Math.PI / 4
                },
                {
                    color: $bafd6197f944c639$var$decalColor,
                    symbol: "triangle",
                    dashArrayX: [
                        [
                            9,
                            9
                        ],
                        [
                            0,
                            9,
                            9,
                            0
                        ]
                    ],
                    dashArrayY: [
                        7,
                        2
                    ],
                    symbolSize: 0.75
                }
            ]
        }
    },
    // If xAxis and yAxis declared, grid is created by default.
    // grid: {},
    textStyle: {
        // color: '#000',
        // decoration: 'none',
        // PENDING
        fontFamily: $bafd6197f944c639$var$platform.match(/^Win/) ? "Microsoft YaHei" : "sans-serif",
        // fontFamily: 'Arial, Verdana, sans-serif',
        fontSize: 12,
        fontStyle: "normal",
        fontWeight: "normal"
    },
    // http://blogs.adobe.com/webplatform/2014/02/24/using-blend-modes-in-html-canvas/
    // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/globalCompositeOperation
    // Default is source-over
    blendMode: null,
    stateAnimation: {
        duration: 300,
        easing: "cubicOut"
    },
    animation: "auto",
    animationDuration: 1000,
    animationDurationUpdate: 500,
    animationEasing: "cubicInOut",
    animationEasingUpdate: "cubicInOut",
    animationThreshold: 2000,
    // Configuration for progressive/incremental rendering
    progressiveThreshold: 3000,
    progressive: 400,
    // Threshold of if use single hover layer to optimize.
    // It is recommended that `hoverLayerThreshold` is equivalent to or less than
    // `progressiveThreshold`, otherwise hover will cause restart of progressive,
    // which is unexpected.
    // see example <echarts/test/heatmap-large.html>.
    hoverLayerThreshold: 3000,
    // See: module:echarts/scale/Time
    useUTC: false
};


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $a55589c1e81db35a$export$328749e9c5b40760 = {
    Must: 1,
    Might: 2,
    Not: 3 // Other cases
};
var $a55589c1e81db35a$var$innerGlobalModel = (0, $87f4a59ac66e0ee6$export$64df9f8d92ae083f)();
function $a55589c1e81db35a$export$b30cdea50aa00e6(ecModel) {
    // `datasetMap` is used to make default encode.
    $a55589c1e81db35a$var$innerGlobalModel(ecModel).datasetMap = (0, $43e0a445ed6711da$export$55f8aa7ef875b0a4)();
}
function $a55589c1e81db35a$export$37682b8fdd2e83d(coordDimensions, seriesModel, source) {
    var encode = {};
    var datasetModel = $a55589c1e81db35a$export$8da66f73a1eda454(seriesModel);
    // Currently only make default when using dataset, util more reqirements occur.
    if (!datasetModel || !coordDimensions) return encode;
    var encodeItemName = [];
    var encodeSeriesName = [];
    var ecModel = seriesModel.ecModel;
    var datasetMap = $a55589c1e81db35a$var$innerGlobalModel(ecModel).datasetMap;
    var key = datasetModel.uid + "_" + source.seriesLayoutBy;
    var baseCategoryDimIndex;
    var categoryWayValueDimStart;
    coordDimensions = coordDimensions.slice();
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)(coordDimensions, function(coordDimInfoLoose, coordDimIdx) {
        var coordDimInfo = (0, $43e0a445ed6711da$export$a6cdc56e425d0d0a)(coordDimInfoLoose) ? coordDimInfoLoose : coordDimensions[coordDimIdx] = {
            name: coordDimInfoLoose
        };
        if (coordDimInfo.type === "ordinal" && baseCategoryDimIndex == null) {
            baseCategoryDimIndex = coordDimIdx;
            categoryWayValueDimStart = getDataDimCountOnCoordDim(coordDimInfo);
        }
        encode[coordDimInfo.name] = [];
    });
    var datasetRecord = datasetMap.get(key) || datasetMap.set(key, {
        categoryWayDim: categoryWayValueDimStart,
        valueWayDim: 0
    });
    // TODO
    // Auto detect first time axis and do arrangement.
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)(coordDimensions, function(coordDimInfo, coordDimIdx) {
        var coordDimName = coordDimInfo.name;
        var count = getDataDimCountOnCoordDim(coordDimInfo);
        // In value way.
        if (baseCategoryDimIndex == null) {
            var start = datasetRecord.valueWayDim;
            pushDim(encode[coordDimName], start, count);
            pushDim(encodeSeriesName, start, count);
            datasetRecord.valueWayDim += count;
        // ??? TODO give a better default series name rule?
        // especially when encode x y specified.
        // consider: when multiple series share one dimension
        // category axis, series name should better use
        // the other dimension name. On the other hand, use
        // both dimensions name.
        } else if (baseCategoryDimIndex === coordDimIdx) {
            pushDim(encode[coordDimName], 0, count);
            pushDim(encodeItemName, 0, count);
        } else {
            var start = datasetRecord.categoryWayDim;
            pushDim(encode[coordDimName], start, count);
            pushDim(encodeSeriesName, start, count);
            datasetRecord.categoryWayDim += count;
        }
    });
    function pushDim(dimIdxArr, idxFrom, idxCount) {
        for(var i = 0; i < idxCount; i++)dimIdxArr.push(idxFrom + i);
    }
    function getDataDimCountOnCoordDim(coordDimInfo) {
        var dimsDef = coordDimInfo.dimsDef;
        return dimsDef ? dimsDef.length : 1;
    }
    encodeItemName.length && (encode.itemName = encodeItemName);
    encodeSeriesName.length && (encode.seriesName = encodeSeriesName);
    return encode;
}
function $a55589c1e81db35a$export$60b8a57d1f2fed26(seriesModel, source, dimCount) {
    var encode = {};
    var datasetModel = $a55589c1e81db35a$export$8da66f73a1eda454(seriesModel);
    // Currently only make default when using dataset, util more reqirements occur.
    if (!datasetModel) return encode;
    var sourceFormat = source.sourceFormat;
    var dimensionsDefine = source.dimensionsDefine;
    var potentialNameDimIndex;
    if (sourceFormat === (0, $bde9c82f7837f767$export$703ae8a2d83f441) || sourceFormat === (0, $bde9c82f7837f767$export$6a32b42c754a3cb8)) (0, $43e0a445ed6711da$export$79b2f7037acddd43)(dimensionsDefine, function(dim, idx) {
        if (((0, $43e0a445ed6711da$export$a6cdc56e425d0d0a)(dim) ? dim.name : dim) === "name") potentialNameDimIndex = idx;
    });
    var idxResult = function() {
        var idxRes0 = {};
        var idxRes1 = {};
        var guessRecords = [];
        // 5 is an experience value.
        for(var i = 0, len = Math.min(5, dimCount); i < len; i++){
            var guessResult = $a55589c1e81db35a$var$doGuessOrdinal(source.data, sourceFormat, source.seriesLayoutBy, dimensionsDefine, source.startIndex, i);
            guessRecords.push(guessResult);
            var isPureNumber = guessResult === $a55589c1e81db35a$export$328749e9c5b40760.Not;
            // [Strategy of idxRes0]: find the first BE_ORDINAL.Not as the value dim,
            // and then find a name dim with the priority:
            // "BE_ORDINAL.Might|BE_ORDINAL.Must" > "other dim" > "the value dim itself".
            if (isPureNumber && idxRes0.v == null && i !== potentialNameDimIndex) idxRes0.v = i;
            if (idxRes0.n == null || idxRes0.n === idxRes0.v || !isPureNumber && guessRecords[idxRes0.n] === $a55589c1e81db35a$export$328749e9c5b40760.Not) idxRes0.n = i;
            if (fulfilled(idxRes0) && guessRecords[idxRes0.n] !== $a55589c1e81db35a$export$328749e9c5b40760.Not) return idxRes0;
            // [Strategy of idxRes1]: if idxRes0 not satisfied (that is, no BE_ORDINAL.Not),
            // find the first BE_ORDINAL.Might as the value dim,
            // and then find a name dim with the priority:
            // "other dim" > "the value dim itself".
            // That is for backward compat: number-like (e.g., `'3'`, `'55'`) can be
            // treated as number.
            if (!isPureNumber) {
                if (guessResult === $a55589c1e81db35a$export$328749e9c5b40760.Might && idxRes1.v == null && i !== potentialNameDimIndex) idxRes1.v = i;
                if (idxRes1.n == null || idxRes1.n === idxRes1.v) idxRes1.n = i;
            }
        }
        function fulfilled(idxResult) {
            return idxResult.v != null && idxResult.n != null;
        }
        return fulfilled(idxRes0) ? idxRes0 : fulfilled(idxRes1) ? idxRes1 : null;
    }();
    if (idxResult) {
        encode.value = [
            idxResult.v
        ];
        // `potentialNameDimIndex` has highest priority.
        var nameDimIndex = potentialNameDimIndex != null ? potentialNameDimIndex : idxResult.n;
        // By default, label uses itemName in charts.
        // So we don't set encodeLabel here.
        encode.itemName = [
            nameDimIndex
        ];
        encode.seriesName = [
            nameDimIndex
        ];
    }
    return encode;
}
function $a55589c1e81db35a$export$8da66f73a1eda454(seriesModel) {
    // Caution: consider the scenario:
    // A dataset is declared and a series is not expected to use the dataset,
    // and at the beginning `setOption({series: { noData })` (just prepare other
    // option but no data), then `setOption({series: {data: [...]}); In this case,
    // the user should set an empty array to avoid that dataset is used by default.
    var thisData = seriesModel.get("data", true);
    if (!thisData) return (0, $87f4a59ac66e0ee6$export$dc741340f7e5f186)(seriesModel.ecModel, "dataset", {
        index: seriesModel.get("datasetIndex", true),
        id: seriesModel.get("datasetId", true)
    }, (0, $87f4a59ac66e0ee6$export$f076738ec84e693c)).models[0];
}
function $a55589c1e81db35a$export$397ba553479711e7(datasetModel) {
    // Only these attributes declared, we by default reference to `datasetIndex: 0`.
    // Otherwise, no reference.
    if (!datasetModel.get("transform", true) && !datasetModel.get("fromTransformResult", true)) return [];
    return (0, $87f4a59ac66e0ee6$export$dc741340f7e5f186)(datasetModel.ecModel, "dataset", {
        index: datasetModel.get("fromDatasetIndex", true),
        id: datasetModel.get("fromDatasetId", true)
    }, (0, $87f4a59ac66e0ee6$export$f076738ec84e693c)).models;
}
function $a55589c1e81db35a$export$c51adf1a2be01b9c(source, dimIndex) {
    return $a55589c1e81db35a$var$doGuessOrdinal(source.data, source.sourceFormat, source.seriesLayoutBy, source.dimensionsDefine, source.startIndex, dimIndex);
}
// dimIndex may be overflow source data.
// return {BE_ORDINAL}
function $a55589c1e81db35a$var$doGuessOrdinal(data, sourceFormat, seriesLayoutBy, dimensionsDefine, startIndex, dimIndex) {
    var result;
    // Experience value.
    var maxLoop = 5;
    if ((0, $43e0a445ed6711da$export$b119cc7e1840e59c)(data)) return $a55589c1e81db35a$export$328749e9c5b40760.Not;
    // When sourceType is 'objectRows' or 'keyedColumns', dimensionsDefine
    // always exists in source.
    var dimName;
    var dimType;
    if (dimensionsDefine) {
        var dimDefItem = dimensionsDefine[dimIndex];
        if ((0, $43e0a445ed6711da$export$a6cdc56e425d0d0a)(dimDefItem)) {
            dimName = dimDefItem.name;
            dimType = dimDefItem.type;
        } else if ((0, $43e0a445ed6711da$export$844ec244b1367d54)(dimDefItem)) dimName = dimDefItem;
    }
    if (dimType != null) return dimType === "ordinal" ? $a55589c1e81db35a$export$328749e9c5b40760.Must : $a55589c1e81db35a$export$328749e9c5b40760.Not;
    if (sourceFormat === (0, $bde9c82f7837f767$export$fcd62ebf51387903)) {
        var dataArrayRows = data;
        if (seriesLayoutBy === (0, $bde9c82f7837f767$export$d55da1467cdf7804)) {
            var sample = dataArrayRows[dimIndex];
            for(var i = 0; i < (sample || []).length && i < maxLoop; i++){
                if ((result = detectValue(sample[startIndex + i])) != null) return result;
            }
        } else for(var i = 0; i < dataArrayRows.length && i < maxLoop; i++){
            var row = dataArrayRows[startIndex + i];
            if (row && (result = detectValue(row[dimIndex])) != null) return result;
        }
    } else if (sourceFormat === (0, $bde9c82f7837f767$export$703ae8a2d83f441)) {
        var dataObjectRows = data;
        if (!dimName) return $a55589c1e81db35a$export$328749e9c5b40760.Not;
        for(var i = 0; i < dataObjectRows.length && i < maxLoop; i++){
            var item = dataObjectRows[i];
            if (item && (result = detectValue(item[dimName])) != null) return result;
        }
    } else if (sourceFormat === (0, $bde9c82f7837f767$export$6a32b42c754a3cb8)) {
        var dataKeyedColumns = data;
        if (!dimName) return $a55589c1e81db35a$export$328749e9c5b40760.Not;
        var sample = dataKeyedColumns[dimName];
        if (!sample || (0, $43e0a445ed6711da$export$b119cc7e1840e59c)(sample)) return $a55589c1e81db35a$export$328749e9c5b40760.Not;
        for(var i = 0; i < sample.length && i < maxLoop; i++){
            if ((result = detectValue(sample[i])) != null) return result;
        }
    } else if (sourceFormat === (0, $bde9c82f7837f767$export$2823037fb9d8f0c6)) {
        var dataOriginal = data;
        for(var i = 0; i < dataOriginal.length && i < maxLoop; i++){
            var item = dataOriginal[i];
            var val = (0, $87f4a59ac66e0ee6$export$2c944e12edb48d4b)(item);
            if (!(0, $43e0a445ed6711da$export$43bee75e5e14138e)(val)) return $a55589c1e81db35a$export$328749e9c5b40760.Not;
            if ((result = detectValue(val[dimIndex])) != null) return result;
        }
    }
    function detectValue(val) {
        var beStr = (0, $43e0a445ed6711da$export$844ec244b1367d54)(val);
        // Consider usage convenience, '1', '2' will be treated as "number".
        // `Number('')` (or any whitespace) is `0`.
        // `Number(val)` prevents error for BigInt.
        if (val != null && isFinite(Number(val)) && val !== "") return beStr ? $a55589c1e81db35a$export$328749e9c5b40760.Might : $a55589c1e81db35a$export$328749e9c5b40760.Not;
        else if (beStr && val !== "-") return $a55589c1e81db35a$export$328749e9c5b40760.Must;
    }
    return $a55589c1e81db35a$export$328749e9c5b40760.Not;
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $fdcf30e2fcadb4a5$var$internalOptionCreatorMap = (0, $43e0a445ed6711da$export$55f8aa7ef875b0a4)();
function $fdcf30e2fcadb4a5$export$5a90be4668898d38(mainType, creator) {
    (0, $43e0a445ed6711da$export$a7a9523472993e97)($fdcf30e2fcadb4a5$var$internalOptionCreatorMap.get(mainType) == null && creator);
    $fdcf30e2fcadb4a5$var$internalOptionCreatorMap.set(mainType, creator);
}
function $fdcf30e2fcadb4a5$export$c713a6a3b43f401d(ecModel, mainType, newCmptOptionList) {
    var internalOptionCreator = $fdcf30e2fcadb4a5$var$internalOptionCreatorMap.get(mainType);
    if (!internalOptionCreator) return newCmptOptionList;
    var internalOptions = internalOptionCreator(ecModel);
    if (!internalOptions) return newCmptOptionList;
    var i;
    return newCmptOptionList.concat(internalOptions);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $98b3e46db1e9df2f$var$innerColor = (0, $87f4a59ac66e0ee6$export$64df9f8d92ae083f)();
var $98b3e46db1e9df2f$var$innerDecal = (0, $87f4a59ac66e0ee6$export$64df9f8d92ae083f)();
var $98b3e46db1e9df2f$export$55a3c39e852b90f4 = /** @class */ function() {
    function PaletteMixin() {}
    PaletteMixin.prototype.getColorFromPalette = function(name, scope, requestNum) {
        var defaultPalette = (0, $87f4a59ac66e0ee6$export$4f07b212a02c8051)(this.get("color", true));
        var layeredPalette = this.get("colorLayer", true);
        return $98b3e46db1e9df2f$var$getFromPalette(this, $98b3e46db1e9df2f$var$innerColor, defaultPalette, layeredPalette, name, scope, requestNum);
    };
    PaletteMixin.prototype.clearColorPalette = function() {
        $98b3e46db1e9df2f$var$clearPalette(this, $98b3e46db1e9df2f$var$innerColor);
    };
    return PaletteMixin;
}();
function $98b3e46db1e9df2f$export$e4d892222945a227(ecModel, name, scope, requestNum) {
    var defaultDecals = (0, $87f4a59ac66e0ee6$export$4f07b212a02c8051)(ecModel.get([
        "aria",
        "decal",
        "decals"
    ]));
    return $98b3e46db1e9df2f$var$getFromPalette(ecModel, $98b3e46db1e9df2f$var$innerDecal, defaultDecals, null, name, scope, requestNum);
}
function $98b3e46db1e9df2f$var$getNearestPalette(palettes, requestColorNum) {
    var paletteNum = palettes.length;
    // TODO palettes must be in order
    for(var i = 0; i < paletteNum; i++){
        if (palettes[i].length > requestColorNum) return palettes[i];
    }
    return palettes[paletteNum - 1];
}
/**
 * @param name MUST NOT be null/undefined. Otherwise call this function
 *             twise with the same parameters will get different result.
 * @param scope default this.
 * @return Can be null/undefined
 */ function $98b3e46db1e9df2f$var$getFromPalette(that, inner, defaultPalette, layeredPalette, name, scope, requestNum) {
    scope = scope || that;
    var scopeFields = inner(scope);
    var paletteIdx = scopeFields.paletteIdx || 0;
    var paletteNameMap = scopeFields.paletteNameMap = scopeFields.paletteNameMap || {};
    // Use `hasOwnProperty` to avoid conflict with Object.prototype.
    if (paletteNameMap.hasOwnProperty(name)) return paletteNameMap[name];
    var palette = requestNum == null || !layeredPalette ? defaultPalette : $98b3e46db1e9df2f$var$getNearestPalette(layeredPalette, requestNum);
    // In case can't find in layered color palette.
    palette = palette || defaultPalette;
    if (!palette || !palette.length) return;
    var pickedPaletteItem = palette[paletteIdx];
    if (name) paletteNameMap[name] = pickedPaletteItem;
    scopeFields.paletteIdx = (paletteIdx + 1) % palette.length;
    return pickedPaletteItem;
}
function $98b3e46db1e9df2f$var$clearPalette(that, inner) {
    inner(that).paletteIdx = 0;
    inner(that).paletteNameMap = {};
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $51c99d7efb19f4a2$var$ECHARTS_PREFIX = "[ECharts] ";
var $51c99d7efb19f4a2$var$storedLogs = {};
var $51c99d7efb19f4a2$var$hasConsole = typeof console !== "undefined" && console.warn && console.log;
function $51c99d7efb19f4a2$var$outputLog(type, str, onlyOnce) {
    if ($51c99d7efb19f4a2$var$hasConsole) {
        if (onlyOnce) {
            if ($51c99d7efb19f4a2$var$storedLogs[str]) return;
            $51c99d7efb19f4a2$var$storedLogs[str] = true;
        }
        // eslint-disable-next-line
        console[type]($51c99d7efb19f4a2$var$ECHARTS_PREFIX + str);
    }
}
function $51c99d7efb19f4a2$export$bef1f36f5486a6a3(str, onlyOnce) {
    $51c99d7efb19f4a2$var$outputLog("log", str, onlyOnce);
}
function $51c99d7efb19f4a2$export$c106dd0671a0fc2d(str, onlyOnce) {
    $51c99d7efb19f4a2$var$outputLog("warn", str, onlyOnce);
}
function $51c99d7efb19f4a2$export$a3bc9b8ed74fc(str, onlyOnce) {
    $51c99d7efb19f4a2$var$outputLog("error", str, onlyOnce);
}
function $51c99d7efb19f4a2$export$4a9c0b74eb885aa1(str) {}
function $51c99d7efb19f4a2$export$bbd91d66002c4ea6(oldOpt, newOpt, scope) {}
function $51c99d7efb19f4a2$export$a68bb8b222a6bd43() {
    var hintInfo = [];
    for(var _i = 0; _i < arguments.length; _i++)hintInfo[_i] = arguments[_i];
    var msg = "";
    var makePrintableStringIfPossible_1;
    return msg;
}
function $51c99d7efb19f4a2$export$8bf7aba4a9e09055(msg) {
    throw new Error(msg);
}


// -----------------------
// Internal method names:
// -----------------------
var $788e99a37a3fbb71$var$reCreateSeriesIndices;
var $788e99a37a3fbb71$var$assertSeriesInitialized;
var $788e99a37a3fbb71$var$initBase;
var $788e99a37a3fbb71$var$OPTION_INNER_KEY = "\0_ec_inner";
var $788e99a37a3fbb71$var$OPTION_INNER_VALUE = 1;
var $788e99a37a3fbb71$var$BUITIN_COMPONENTS_MAP = {
    grid: "GridComponent",
    polar: "PolarComponent",
    geo: "GeoComponent",
    singleAxis: "SingleAxisComponent",
    parallel: "ParallelComponent",
    calendar: "CalendarComponent",
    matrix: "MatrixComponent",
    graphic: "GraphicComponent",
    toolbox: "ToolboxComponent",
    tooltip: "TooltipComponent",
    axisPointer: "AxisPointerComponent",
    brush: "BrushComponent",
    title: "TitleComponent",
    timeline: "TimelineComponent",
    markPoint: "MarkPointComponent",
    markLine: "MarkLineComponent",
    markArea: "MarkAreaComponent",
    legend: "LegendComponent",
    dataZoom: "DataZoomComponent",
    visualMap: "VisualMapComponent",
    // aria: 'AriaComponent',
    // dataset: 'DatasetComponent',
    // Dependencies
    xAxis: "GridComponent",
    yAxis: "GridComponent",
    angleAxis: "PolarComponent",
    radiusAxis: "PolarComponent"
};
var $788e99a37a3fbb71$var$BUILTIN_CHARTS_MAP = {
    line: "LineChart",
    bar: "BarChart",
    pie: "PieChart",
    scatter: "ScatterChart",
    radar: "RadarChart",
    map: "MapChart",
    tree: "TreeChart",
    treemap: "TreemapChart",
    graph: "GraphChart",
    chord: "ChordChart",
    gauge: "GaugeChart",
    funnel: "FunnelChart",
    parallel: "ParallelChart",
    sankey: "SankeyChart",
    boxplot: "BoxplotChart",
    candlestick: "CandlestickChart",
    effectScatter: "EffectScatterChart",
    lines: "LinesChart",
    heatmap: "HeatmapChart",
    pictorialBar: "PictorialBarChart",
    themeRiver: "ThemeRiverChart",
    sunburst: "SunburstChart",
    custom: "CustomChart"
};
var $788e99a37a3fbb71$var$componetsMissingLogPrinted = {};
function $788e99a37a3fbb71$var$checkMissingComponents(option) {
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)(option, function(componentOption, mainType) {
        if (!(0, $4a9041b12b787d1b$export$2e2bcd8739ae039).hasClass(mainType)) {
            var componentImportName = $788e99a37a3fbb71$var$BUITIN_COMPONENTS_MAP[mainType];
            if (componentImportName && !$788e99a37a3fbb71$var$componetsMissingLogPrinted[componentImportName]) {
                (0, $51c99d7efb19f4a2$export$a3bc9b8ed74fc)("Component " + mainType + " is used but not imported.\nimport { " + componentImportName + " } from 'echarts/components';\necharts.use([" + componentImportName + "]);");
                $788e99a37a3fbb71$var$componetsMissingLogPrinted[componentImportName] = true;
            }
        }
    });
}
var $788e99a37a3fbb71$var$GlobalModel = /** @class */ function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(GlobalModel, _super);
    function GlobalModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GlobalModel.prototype.init = function(option, parentModel, ecModel, theme, locale, optionManager) {
        theme = theme || {};
        this.option = null; // Mark as not initialized.
        this._theme = new (0, $279973fc50f77a15$export$2e2bcd8739ae039)(theme);
        this._locale = new (0, $279973fc50f77a15$export$2e2bcd8739ae039)(locale);
        this._optionManager = optionManager;
    };
    GlobalModel.prototype.setOption = function(option, opts, optionPreprocessorFuncs) {
        var innerOpt = $788e99a37a3fbb71$var$normalizeSetOptionInput(opts);
        this._optionManager.setOption(option, optionPreprocessorFuncs, innerOpt);
        this._resetOption(null, innerOpt);
    };
    /**
   * @param type null/undefined: reset all.
   *        'recreate': force recreate all.
   *        'timeline': only reset timeline option
   *        'media': only reset media query option
   * @return Whether option changed.
   */ GlobalModel.prototype.resetOption = function(type, opt) {
        return this._resetOption(type, $788e99a37a3fbb71$var$normalizeSetOptionInput(opt));
    };
    GlobalModel.prototype._resetOption = function(type, opt) {
        var optionChanged = false;
        var optionManager = this._optionManager;
        if (!type || type === "recreate") {
            var baseOption = optionManager.mountOption(type === "recreate");
            if (!this.option || type === "recreate") $788e99a37a3fbb71$var$initBase(this, baseOption);
            else {
                this.restoreData();
                this._mergeOption(baseOption, opt);
            }
            optionChanged = true;
        }
        if (type === "timeline" || type === "media") this.restoreData();
        // By design, if `setOption(option2)` at the second time, and `option2` is a `ECUnitOption`,
        // it should better not have the same props with `MediaUnit['option']`.
        // Because either `option2` or `MediaUnit['option']` will be always merged to "current option"
        // rather than original "baseOption". If they both override a prop, the result might be
        // unexpected when media state changed after `setOption` called.
        // If we really need to modify a props in each `MediaUnit['option']`, use the full version
        // (`{baseOption, media}`) in `setOption`.
        // For `timeline`, the case is the same.
        if (!type || type === "recreate" || type === "timeline") {
            var timelineOption = optionManager.getTimelineOption(this);
            if (timelineOption) {
                optionChanged = true;
                this._mergeOption(timelineOption, opt);
            }
        }
        if (!type || type === "recreate" || type === "media") {
            var mediaOptions = optionManager.getMediaOption(this);
            if (mediaOptions.length) (0, $43e0a445ed6711da$export$79b2f7037acddd43)(mediaOptions, function(mediaOption) {
                optionChanged = true;
                this._mergeOption(mediaOption, opt);
            }, this);
        }
        return optionChanged;
    };
    GlobalModel.prototype.mergeOption = function(option) {
        this._mergeOption(option, null);
    };
    GlobalModel.prototype._mergeOption = function(newOption, opt) {
        var option = this.option;
        var componentsMap = this._componentsMap;
        var componentsCount = this._componentsCount;
        var newCmptTypes = [];
        var newCmptTypeMap = (0, $43e0a445ed6711da$export$55f8aa7ef875b0a4)();
        var replaceMergeMainTypeMap = opt && opt.replaceMergeMainTypeMap;
        (0, $a55589c1e81db35a$export$b30cdea50aa00e6)(this);
        // If no component class, merge directly.
        // For example: color, animaiton options, etc.
        (0, $43e0a445ed6711da$export$79b2f7037acddd43)(newOption, function(componentOption, mainType) {
            if (componentOption == null) return;
            if (!(0, $4a9041b12b787d1b$export$2e2bcd8739ae039).hasClass(mainType)) // globalSettingTask.dirty();
            option[mainType] = option[mainType] == null ? (0, $43e0a445ed6711da$export$9cd59f9826255e47)(componentOption) : (0, $43e0a445ed6711da$export$4950aa0f605343fb)(option[mainType], componentOption, true);
            else if (mainType) {
                newCmptTypes.push(mainType);
                newCmptTypeMap.set(mainType, true);
            }
        });
        if (replaceMergeMainTypeMap) // If there is a mainType `xxx` in `replaceMerge` but not declared in option,
        // we trade it as it is declared in option as `{xxx: []}`. Because:
        // (1) for normal merge, `{xxx: null/undefined}` are the same meaning as `{xxx: []}`.
        // (2) some preprocessor may convert some of `{xxx: null/undefined}` to `{xxx: []}`.
        replaceMergeMainTypeMap.each(function(val, mainTypeInReplaceMerge) {
            if ((0, $4a9041b12b787d1b$export$2e2bcd8739ae039).hasClass(mainTypeInReplaceMerge) && !newCmptTypeMap.get(mainTypeInReplaceMerge)) {
                newCmptTypes.push(mainTypeInReplaceMerge);
                newCmptTypeMap.set(mainTypeInReplaceMerge, true);
            }
        });
        (0, $4a9041b12b787d1b$export$2e2bcd8739ae039).topologicalTravel(newCmptTypes, (0, $4a9041b12b787d1b$export$2e2bcd8739ae039).getAllClassMainTypes(), visitComponent, this);
        function visitComponent(mainType) {
            var newCmptOptionList = (0, $fdcf30e2fcadb4a5$export$c713a6a3b43f401d)(this, mainType, $87f4a59ac66e0ee6$export$4f07b212a02c8051(newOption[mainType]));
            var oldCmptList = componentsMap.get(mainType);
            var mergeMode = // `!oldCmptList` means init. See the comment in `mappingToExists`
            !oldCmptList ? "replaceAll" : replaceMergeMainTypeMap && replaceMergeMainTypeMap.get(mainType) ? "replaceMerge" : "normalMerge";
            var mappingResult = $87f4a59ac66e0ee6$export$574f818966e4da87(oldCmptList, newCmptOptionList, mergeMode);
            // Set mainType and complete subType.
            $87f4a59ac66e0ee6$export$5ac61aca2ba0282d(mappingResult, mainType, (0, $4a9041b12b787d1b$export$2e2bcd8739ae039));
            // Empty it before the travel, in order to prevent `this._componentsMap`
            // from being used in the `init`/`mergeOption`/`optionUpdated` of some
            // components, which is probably incorrect logic.
            option[mainType] = null;
            componentsMap.set(mainType, null);
            componentsCount.set(mainType, 0);
            var optionsByMainType = [];
            var cmptsByMainType = [];
            var cmptsCountByMainType = 0;
            var tooltipExists;
            var tooltipWarningLogged;
            (0, $43e0a445ed6711da$export$79b2f7037acddd43)(mappingResult, function(resultItem, index) {
                var componentModel = resultItem.existing;
                var newCmptOption = resultItem.newOption;
                if (!newCmptOption) {
                    if (componentModel) {
                        // Consider where is no new option and should be merged using {},
                        // see removeEdgeAndAdd in topologicalTravel and
                        // ComponentModel.getAllClassMainTypes.
                        componentModel.mergeOption({}, this);
                        componentModel.optionUpdated({}, false);
                    }
                } else {
                    var isSeriesType = mainType === "series";
                    var ComponentModelClass = (0, $4a9041b12b787d1b$export$2e2bcd8739ae039).getClass(mainType, resultItem.keyInfo.subType, !isSeriesType // Give a more detailed warn later if series don't exists
                    );
                    if (!ComponentModelClass) {
                        var subType, seriesImportName;
                        return;
                    }
                    // TODO Before multiple tooltips get supported, we do this check to avoid unexpected exception.
                    if (mainType === "tooltip") {
                        if (tooltipExists) return;
                        tooltipExists = true;
                    }
                    if (componentModel && componentModel.constructor === ComponentModelClass) {
                        componentModel.name = resultItem.keyInfo.name;
                        // componentModel.settingTask && componentModel.settingTask.dirty();
                        componentModel.mergeOption(newCmptOption, this);
                        componentModel.optionUpdated(newCmptOption, false);
                    } else {
                        // PENDING Global as parent ?
                        var extraOpt = (0, $43e0a445ed6711da$export$8b58be045bf06082)({
                            componentIndex: index
                        }, resultItem.keyInfo);
                        componentModel = new ComponentModelClass(newCmptOption, this, this, extraOpt);
                        // Assign `keyInfo`
                        (0, $43e0a445ed6711da$export$8b58be045bf06082)(componentModel, extraOpt);
                        if (resultItem.brandNew) componentModel.__requireNewView = true;
                        componentModel.init(newCmptOption, this, this);
                        // Call optionUpdated after init.
                        // newCmptOption has been used as componentModel.option
                        // and may be merged with theme and default, so pass null
                        // to avoid confusion.
                        componentModel.optionUpdated(null, true);
                    }
                }
                if (componentModel) {
                    optionsByMainType.push(componentModel.option);
                    cmptsByMainType.push(componentModel);
                    cmptsCountByMainType++;
                } else {
                    // Always do assign to avoid elided item in array.
                    optionsByMainType.push(void 0);
                    cmptsByMainType.push(void 0);
                }
            }, this);
            option[mainType] = optionsByMainType;
            componentsMap.set(mainType, cmptsByMainType);
            componentsCount.set(mainType, cmptsCountByMainType);
            // Backup series for filtering.
            if (mainType === "series") $788e99a37a3fbb71$var$reCreateSeriesIndices(this);
        }
        // If no series declared, ensure `_seriesIndices` initialized.
        if (!this._seriesIndices) $788e99a37a3fbb71$var$reCreateSeriesIndices(this);
    };
    /**
   * Get option for output (cloned option and inner info removed)
   */ GlobalModel.prototype.getOption = function() {
        var option = (0, $43e0a445ed6711da$export$9cd59f9826255e47)(this.option);
        (0, $43e0a445ed6711da$export$79b2f7037acddd43)(option, function(optInMainType, mainType) {
            if ((0, $4a9041b12b787d1b$export$2e2bcd8739ae039).hasClass(mainType)) {
                var opts = $87f4a59ac66e0ee6$export$4f07b212a02c8051(optInMainType);
                // Inner cmpts need to be removed.
                // Inner cmpts might not be at last since ec5.0, but still
                // compatible for users: if inner cmpt at last, splice the returned array.
                var realLen = opts.length;
                var metNonInner = false;
                for(var i = realLen - 1; i >= 0; i--)// Remove options with inner id.
                if (opts[i] && !$87f4a59ac66e0ee6$export$feece3e7d52a102b(opts[i])) metNonInner = true;
                else {
                    opts[i] = null;
                    !metNonInner && realLen--;
                }
                opts.length = realLen;
                option[mainType] = opts;
            }
        });
        delete option[$788e99a37a3fbb71$var$OPTION_INNER_KEY];
        return option;
    };
    GlobalModel.prototype.setTheme = function(theme) {
        this._theme = new (0, $279973fc50f77a15$export$2e2bcd8739ae039)(theme);
        this._resetOption("recreate", null);
    };
    GlobalModel.prototype.getTheme = function() {
        return this._theme;
    };
    GlobalModel.prototype.getLocaleModel = function() {
        return this._locale;
    };
    GlobalModel.prototype.setUpdatePayload = function(payload) {
        this._payload = payload;
    };
    GlobalModel.prototype.getUpdatePayload = function() {
        return this._payload;
    };
    /**
   * @param idx If not specified, return the first one.
   */ GlobalModel.prototype.getComponent = function(mainType, idx) {
        var list = this._componentsMap.get(mainType);
        if (list) {
            var cmpt = list[idx || 0];
            if (cmpt) return cmpt;
            else if (idx == null) for(var i = 0; i < list.length; i++){
                if (list[i]) return list[i];
            }
        }
    };
    /**
   * @return Never be null/undefined.
   */ GlobalModel.prototype.queryComponents = function(condition) {
        var mainType = condition.mainType;
        if (!mainType) return [];
        var index = condition.index;
        var id = condition.id;
        var name = condition.name;
        var cmpts = this._componentsMap.get(mainType);
        if (!cmpts || !cmpts.length) return [];
        var result;
        if (index != null) {
            result = [];
            (0, $43e0a445ed6711da$export$79b2f7037acddd43)($87f4a59ac66e0ee6$export$4f07b212a02c8051(index), function(idx) {
                cmpts[idx] && result.push(cmpts[idx]);
            });
        } else if (id != null) result = $788e99a37a3fbb71$var$queryByIdOrName("id", id, cmpts);
        else if (name != null) result = $788e99a37a3fbb71$var$queryByIdOrName("name", name, cmpts);
        else // Return all non-empty components in that mainType
        result = (0, $43e0a445ed6711da$export$3dea766d36a8935f)(cmpts, function(cmpt) {
            return !!cmpt;
        });
        return $788e99a37a3fbb71$var$filterBySubType(result, condition);
    };
    /**
   * The interface is different from queryComponents,
   * which is convenient for inner usage.
   *
   * @usage
   * let result = findComponents(
   *     {mainType: 'dataZoom', query: {dataZoomId: 'abc'}}
   * );
   * let result = findComponents(
   *     {mainType: 'series', subType: 'pie', query: {seriesName: 'uio'}}
   * );
   * let result = findComponents(
   *     {mainType: 'series',
   *     filter: function (model, index) {...}}
   * );
   * // result like [component0, component1, ...]
   */ GlobalModel.prototype.findComponents = function(condition) {
        var query = condition.query;
        var mainType = condition.mainType;
        var queryCond = getQueryCond(query);
        var result = queryCond ? this.queryComponents(queryCond) : (0, $43e0a445ed6711da$export$3dea766d36a8935f)(this._componentsMap.get(mainType), function(cmpt) {
            return !!cmpt;
        });
        return doFilter($788e99a37a3fbb71$var$filterBySubType(result, condition));
        function getQueryCond(q) {
            var indexAttr = mainType + "Index";
            var idAttr = mainType + "Id";
            var nameAttr = mainType + "Name";
            return q && (q[indexAttr] != null || q[idAttr] != null || q[nameAttr] != null) ? {
                mainType: mainType,
                // subType will be filtered finally.
                index: q[indexAttr],
                id: q[idAttr],
                name: q[nameAttr]
            } : null;
        }
        function doFilter(res) {
            return condition.filter ? (0, $43e0a445ed6711da$export$3dea766d36a8935f)(res, condition.filter) : res;
        }
    };
    GlobalModel.prototype.eachComponent = function(mainType, cb, context) {
        var componentsMap = this._componentsMap;
        if ((0, $43e0a445ed6711da$export$f6e2535fb5126e54)(mainType)) {
            var ctxForAll_1 = cb;
            var cbForAll_1 = mainType;
            componentsMap.each(function(cmpts, componentType) {
                for(var i = 0; cmpts && i < cmpts.length; i++){
                    var cmpt = cmpts[i];
                    cmpt && cbForAll_1.call(ctxForAll_1, componentType, cmpt, cmpt.componentIndex);
                }
            });
        } else {
            var cmpts = (0, $43e0a445ed6711da$export$844ec244b1367d54)(mainType) ? componentsMap.get(mainType) : (0, $43e0a445ed6711da$export$a6cdc56e425d0d0a)(mainType) ? this.findComponents(mainType) : null;
            for(var i = 0; cmpts && i < cmpts.length; i++){
                var cmpt = cmpts[i];
                cmpt && cb.call(context, cmpt, cmpt.componentIndex);
            }
        }
    };
    /**
   * Get series list before filtered by name.
   */ GlobalModel.prototype.getSeriesByName = function(name) {
        var nameStr = $87f4a59ac66e0ee6$export$fb1a222ba5dd6e51(name, null);
        return (0, $43e0a445ed6711da$export$3dea766d36a8935f)(this._componentsMap.get("series"), function(oneSeries) {
            return !!oneSeries && nameStr != null && oneSeries.name === nameStr;
        });
    };
    /**
   * Get series list before filtered by index.
   */ GlobalModel.prototype.getSeriesByIndex = function(seriesIndex) {
        return this._componentsMap.get("series")[seriesIndex];
    };
    /**
   * Get series list before filtered by type.
   * FIXME: rename to getRawSeriesByType?
   */ GlobalModel.prototype.getSeriesByType = function(subType) {
        return (0, $43e0a445ed6711da$export$3dea766d36a8935f)(this._componentsMap.get("series"), function(oneSeries) {
            return !!oneSeries && oneSeries.subType === subType;
        });
    };
    /**
   * Get all series before filtered.
   */ GlobalModel.prototype.getSeries = function() {
        return (0, $43e0a445ed6711da$export$3dea766d36a8935f)(this._componentsMap.get("series"), function(oneSeries) {
            return !!oneSeries;
        });
    };
    /**
   * Count series before filtered.
   */ GlobalModel.prototype.getSeriesCount = function() {
        return this._componentsCount.get("series");
    };
    /**
   * After filtering, series may be different
   * from raw series.
   */ GlobalModel.prototype.eachSeries = function(cb, context) {
        $788e99a37a3fbb71$var$assertSeriesInitialized(this);
        (0, $43e0a445ed6711da$export$79b2f7037acddd43)(this._seriesIndices, function(rawSeriesIndex) {
            var series = this._componentsMap.get("series")[rawSeriesIndex];
            cb.call(context, series, rawSeriesIndex);
        }, this);
    };
    /**
   * Iterate raw series before filtered.
   */ GlobalModel.prototype.eachRawSeries = function(cb, context) {
        (0, $43e0a445ed6711da$export$79b2f7037acddd43)(this._componentsMap.get("series"), function(series) {
            series && cb.call(context, series, series.componentIndex);
        });
    };
    /**
   * After filtering, series may be different.
   * from raw series.
   */ GlobalModel.prototype.eachSeriesByType = function(subType, cb, context) {
        $788e99a37a3fbb71$var$assertSeriesInitialized(this);
        (0, $43e0a445ed6711da$export$79b2f7037acddd43)(this._seriesIndices, function(rawSeriesIndex) {
            var series = this._componentsMap.get("series")[rawSeriesIndex];
            if (series.subType === subType) cb.call(context, series, rawSeriesIndex);
        }, this);
    };
    /**
   * Iterate raw series before filtered of given type.
   */ GlobalModel.prototype.eachRawSeriesByType = function(subType, cb, context) {
        return (0, $43e0a445ed6711da$export$79b2f7037acddd43)(this.getSeriesByType(subType), cb, context);
    };
    /**
   * It means "filtered out".
   */ GlobalModel.prototype.isSeriesFiltered = function(seriesModel) {
        $788e99a37a3fbb71$var$assertSeriesInitialized(this);
        return this._seriesIndicesMap.get(seriesModel.componentIndex) == null;
    };
    GlobalModel.prototype.getCurrentSeriesIndices = function() {
        return (this._seriesIndices || []).slice();
    };
    GlobalModel.prototype.filterSeries = function(cb, context) {
        $788e99a37a3fbb71$var$assertSeriesInitialized(this);
        var newSeriesIndices = [];
        (0, $43e0a445ed6711da$export$79b2f7037acddd43)(this._seriesIndices, function(seriesRawIdx) {
            var series = this._componentsMap.get("series")[seriesRawIdx];
            cb.call(context, series, seriesRawIdx) && newSeriesIndices.push(seriesRawIdx);
        }, this);
        this._seriesIndices = newSeriesIndices;
        this._seriesIndicesMap = (0, $43e0a445ed6711da$export$55f8aa7ef875b0a4)(newSeriesIndices);
    };
    GlobalModel.prototype.restoreData = function(payload) {
        $788e99a37a3fbb71$var$reCreateSeriesIndices(this);
        var componentsMap = this._componentsMap;
        var componentTypes = [];
        componentsMap.each(function(components, componentType) {
            if ((0, $4a9041b12b787d1b$export$2e2bcd8739ae039).hasClass(componentType)) componentTypes.push(componentType);
        });
        (0, $4a9041b12b787d1b$export$2e2bcd8739ae039).topologicalTravel(componentTypes, (0, $4a9041b12b787d1b$export$2e2bcd8739ae039).getAllClassMainTypes(), function(componentType) {
            (0, $43e0a445ed6711da$export$79b2f7037acddd43)(componentsMap.get(componentType), function(component) {
                if (component && (componentType !== "series" || !$788e99a37a3fbb71$var$isNotTargetSeries(component, payload))) component.restoreData();
            });
        });
    };
    GlobalModel.internalField = function() {
        $788e99a37a3fbb71$var$reCreateSeriesIndices = function(ecModel) {
            var seriesIndices = ecModel._seriesIndices = [];
            (0, $43e0a445ed6711da$export$79b2f7037acddd43)(ecModel._componentsMap.get("series"), function(series) {
                // series may have been removed by `replaceMerge`.
                series && seriesIndices.push(series.componentIndex);
            });
            ecModel._seriesIndicesMap = (0, $43e0a445ed6711da$export$55f8aa7ef875b0a4)(seriesIndices);
        };
        $788e99a37a3fbb71$var$assertSeriesInitialized = function(ecModel) {};
        $788e99a37a3fbb71$var$initBase = function(ecModel, baseOption) {
            // Using OPTION_INNER_KEY to mark that this option cannot be used outside,
            // i.e. `chart.setOption(chart.getModel().option);` is forbidden.
            ecModel.option = {};
            ecModel.option[$788e99a37a3fbb71$var$OPTION_INNER_KEY] = $788e99a37a3fbb71$var$OPTION_INNER_VALUE;
            // Init with series: [], in case of calling findSeries method
            // before series initialized.
            ecModel._componentsMap = (0, $43e0a445ed6711da$export$55f8aa7ef875b0a4)({
                series: []
            });
            ecModel._componentsCount = (0, $43e0a445ed6711da$export$55f8aa7ef875b0a4)();
            // If user spefied `option.aria`, aria will be enable. This detection should be
            // performed before theme and globalDefault merge.
            var airaOption = baseOption.aria;
            if ((0, $43e0a445ed6711da$export$a6cdc56e425d0d0a)(airaOption) && airaOption.enabled == null) airaOption.enabled = true;
            $788e99a37a3fbb71$var$mergeTheme(baseOption, ecModel._theme.option);
            // TODO Needs clone when merging to the unexisted property
            (0, $43e0a445ed6711da$export$4950aa0f605343fb)(baseOption, (0, $bafd6197f944c639$export$2e2bcd8739ae039), false);
            ecModel._mergeOption(baseOption, null);
        };
    }();
    return GlobalModel;
}((0, $279973fc50f77a15$export$2e2bcd8739ae039));
function $788e99a37a3fbb71$var$isNotTargetSeries(seriesModel, payload) {
    if (payload) {
        var index = payload.seriesIndex;
        var id = payload.seriesId;
        var name_1 = payload.seriesName;
        return index != null && seriesModel.componentIndex !== index || id != null && seriesModel.id !== id || name_1 != null && seriesModel.name !== name_1;
    }
}
function $788e99a37a3fbb71$var$mergeTheme(option, theme) {
    // PENDING
    // NOT use `colorLayer` in theme if option has `color`
    var notMergeColorLayer = option.color && !option.colorLayer;
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)(theme, function(themeItem, name) {
        if (name === "colorLayer" && notMergeColorLayer || name === "color" && option.color) return;
        // If it is component model mainType, the model handles that merge later.
        // otherwise, merge them here.
        if (!(0, $4a9041b12b787d1b$export$2e2bcd8739ae039).hasClass(name)) {
            if (typeof themeItem === "object") option[name] = !option[name] ? (0, $43e0a445ed6711da$export$9cd59f9826255e47)(themeItem) : (0, $43e0a445ed6711da$export$4950aa0f605343fb)(option[name], themeItem, false);
            else if (option[name] == null) option[name] = themeItem;
        }
    });
}
function $788e99a37a3fbb71$var$queryByIdOrName(attr, idOrName, cmpts) {
    // Here is a break from echarts4: string and number are
    // treated as equal.
    if ((0, $43e0a445ed6711da$export$43bee75e5e14138e)(idOrName)) {
        var keyMap_1 = (0, $43e0a445ed6711da$export$55f8aa7ef875b0a4)();
        (0, $43e0a445ed6711da$export$79b2f7037acddd43)(idOrName, function(idOrNameItem) {
            if (idOrNameItem != null) {
                var idName = $87f4a59ac66e0ee6$export$fb1a222ba5dd6e51(idOrNameItem, null);
                idName != null && keyMap_1.set(idOrNameItem, true);
            }
        });
        return (0, $43e0a445ed6711da$export$3dea766d36a8935f)(cmpts, function(cmpt) {
            return cmpt && keyMap_1.get(cmpt[attr]);
        });
    } else {
        var idName_1 = $87f4a59ac66e0ee6$export$fb1a222ba5dd6e51(idOrName, null);
        return (0, $43e0a445ed6711da$export$3dea766d36a8935f)(cmpts, function(cmpt) {
            return cmpt && idName_1 != null && cmpt[attr] === idName_1;
        });
    }
}
function $788e99a37a3fbb71$var$filterBySubType(components, condition) {
    // Using hasOwnProperty for restrict. Consider
    // subType is undefined in user payload.
    return condition.hasOwnProperty("subType") ? (0, $43e0a445ed6711da$export$3dea766d36a8935f)(components, function(cmpt) {
        return cmpt && cmpt.subType === condition.subType;
    }) : components;
}
function $788e99a37a3fbb71$var$normalizeSetOptionInput(opts) {
    var replaceMergeMainTypeMap = (0, $43e0a445ed6711da$export$55f8aa7ef875b0a4)();
    opts && (0, $43e0a445ed6711da$export$79b2f7037acddd43)($87f4a59ac66e0ee6$export$4f07b212a02c8051(opts.replaceMerge), function(mainType) {
        replaceMergeMainTypeMap.set(mainType, true);
    });
    return {
        replaceMergeMainTypeMap: replaceMergeMainTypeMap
    };
}
(0, $43e0a445ed6711da$export$e36fc9d62a853069)($788e99a37a3fbb71$var$GlobalModel, (0, $98b3e46db1e9df2f$export$55a3c39e852b90f4));
var $788e99a37a3fbb71$export$2e2bcd8739ae039 = $788e99a37a3fbb71$var$GlobalModel;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $a22ea7e62969c051$var$QUERY_REG = /^(min|max)?(.+)$/;
// Key: mainType
// type FakeComponentsMap = HashMap<(MappingExistingItem & { subType: string })[]>;
/**
 * TERM EXPLANATIONS:
 * See `ECOption` and `ECUnitOption` in `src/util/types.ts`.
 */ var $a22ea7e62969c051$var$OptionManager = /** @class */ function() {
    // timeline.notMerge is not supported in ec3. Firstly there is rearly
    // case that notMerge is needed. Secondly supporting 'notMerge' requires
    // rawOption cloned and backuped when timeline changed, which does no
    // good to performance. What's more, that both timeline and setOption
    // method supply 'notMerge' brings complex and some problems.
    // Consider this case:
    // (step1) chart.setOption({timeline: {notMerge: false}, ...}, false);
    // (step2) chart.setOption({timeline: {notMerge: true}, ...}, false);
    function OptionManager(api) {
        this._timelineOptions = [];
        this._mediaList = [];
        /**
     * -1, means default.
     * empty means no media.
     */ this._currentMediaIndices = [];
        this._api = api;
    }
    OptionManager.prototype.setOption = function(rawOption, optionPreprocessorFuncs, opt) {
        if (rawOption) {
            // That set dat primitive is dangerous if user reuse the data when setOption again.
            (0, $43e0a445ed6711da$export$79b2f7037acddd43)((0, $87f4a59ac66e0ee6$export$4f07b212a02c8051)(rawOption.series), function(series) {
                series && series.data && (0, $43e0a445ed6711da$export$b119cc7e1840e59c)(series.data) && (0, $43e0a445ed6711da$export$112e66431016387b)(series.data);
            });
            (0, $43e0a445ed6711da$export$79b2f7037acddd43)((0, $87f4a59ac66e0ee6$export$4f07b212a02c8051)(rawOption.dataset), function(dataset) {
                dataset && dataset.source && (0, $43e0a445ed6711da$export$b119cc7e1840e59c)(dataset.source) && (0, $43e0a445ed6711da$export$112e66431016387b)(dataset.source);
            });
        }
        // Caution: some series modify option data, if do not clone,
        // it should ensure that the repeat modify correctly
        // (create a new object when modify itself).
        rawOption = (0, $43e0a445ed6711da$export$9cd59f9826255e47)(rawOption);
        // FIXME
        // If some property is set in timeline options or media option but
        // not set in baseOption, a warning should be given.
        var optionBackup = this._optionBackup;
        var newParsedOption = $a22ea7e62969c051$var$parseRawOption(rawOption, optionPreprocessorFuncs, !optionBackup);
        this._newBaseOption = newParsedOption.baseOption;
        // For setOption at second time (using merge mode);
        if (optionBackup) {
            // FIXME
            // the restore merge solution is essentially incorrect.
            // the mapping can not be 100% consistent with ecModel, which probably brings
            // potential bug!
            // The first merge is delayed, because in most cases, users do not call `setOption` twice.
            // let fakeCmptsMap = this._fakeCmptsMap;
            // if (!fakeCmptsMap) {
            //     fakeCmptsMap = this._fakeCmptsMap = createHashMap();
            //     mergeToBackupOption(fakeCmptsMap, null, optionBackup.baseOption, null);
            // }
            // mergeToBackupOption(
            //     fakeCmptsMap, optionBackup.baseOption, newParsedOption.baseOption, opt
            // );
            // For simplicity, timeline options and media options do not support merge,
            // that is, if you `setOption` twice and both has timeline options, the latter
            // timeline options will not be merged to the former, but just substitute them.
            if (newParsedOption.timelineOptions.length) optionBackup.timelineOptions = newParsedOption.timelineOptions;
            if (newParsedOption.mediaList.length) optionBackup.mediaList = newParsedOption.mediaList;
            if (newParsedOption.mediaDefault) optionBackup.mediaDefault = newParsedOption.mediaDefault;
        } else this._optionBackup = newParsedOption;
    };
    OptionManager.prototype.mountOption = function(isRecreate) {
        var optionBackup = this._optionBackup;
        this._timelineOptions = optionBackup.timelineOptions;
        this._mediaList = optionBackup.mediaList;
        this._mediaDefault = optionBackup.mediaDefault;
        this._currentMediaIndices = [];
        return (0, $43e0a445ed6711da$export$9cd59f9826255e47)(isRecreate ? optionBackup.baseOption : this._newBaseOption);
    };
    OptionManager.prototype.getTimelineOption = function(ecModel) {
        var option;
        var timelineOptions = this._timelineOptions;
        if (timelineOptions.length) {
            // getTimelineOption can only be called after ecModel inited,
            // so we can get currentIndex from timelineModel.
            var timelineModel = ecModel.getComponent("timeline");
            if (timelineModel) option = (0, $43e0a445ed6711da$export$9cd59f9826255e47)(// FIXME:TS as TimelineModel or quivlant interface
            timelineOptions[timelineModel.getCurrentIndex()]);
        }
        return option;
    };
    OptionManager.prototype.getMediaOption = function(ecModel) {
        var ecWidth = this._api.getWidth();
        var ecHeight = this._api.getHeight();
        var mediaList = this._mediaList;
        var mediaDefault = this._mediaDefault;
        var indices = [];
        var result = [];
        // No media defined.
        if (!mediaList.length && !mediaDefault) return result;
        // Multi media may be applied, the latter defined media has higher priority.
        for(var i = 0, len = mediaList.length; i < len; i++)if ($a22ea7e62969c051$var$applyMediaQuery(mediaList[i].query, ecWidth, ecHeight)) indices.push(i);
        // FIXME
        // Whether mediaDefault should force users to provide? Otherwise
        // the change by media query can not be recorvered.
        if (!indices.length && mediaDefault) indices = [
            -1
        ];
        if (indices.length && !$a22ea7e62969c051$var$indicesEquals(indices, this._currentMediaIndices)) result = (0, $43e0a445ed6711da$export$871de8747c9eaa88)(indices, function(index) {
            return (0, $43e0a445ed6711da$export$9cd59f9826255e47)(index === -1 ? mediaDefault.option : mediaList[index].option);
        });
        // Otherwise return nothing.
        this._currentMediaIndices = indices;
        return result;
    };
    return OptionManager;
}();
/**
 * [RAW_OPTION_PATTERNS]
 * (Note: "series: []" represents all other props in `ECUnitOption`)
 *
 * (1) No prop "baseOption" declared:
 * Root option is used as "baseOption" (except prop "options" and "media").
 * ```js
 * option = {
 *     series: [],
 *     timeline: {},
 *     options: [],
 * };
 * option = {
 *     series: [],
 *     media: {},
 * };
 * option = {
 *     series: [],
 *     timeline: {},
 *     options: [],
 *     media: {},
 * }
 * ```
 *
 * (2) Prop "baseOption" declared:
 * If "baseOption" declared, `ECUnitOption` props can only be declared
 * inside "baseOption" except prop "timeline" (compat ec2).
 * ```js
 * option = {
 *     baseOption: {
 *         timeline: {},
 *         series: [],
 *     },
 *     options: []
 * };
 * option = {
 *     baseOption: {
 *         series: [],
 *     },
 *     media: []
 * };
 * option = {
 *     baseOption: {
 *         timeline: {},
 *         series: [],
 *     },
 *     options: []
 *     media: []
 * };
 * option = {
 *     // ec3 compat ec2: allow (only) `timeline` declared
 *     // outside baseOption. Keep this setting for compat.
 *     timeline: {},
 *     baseOption: {
 *         series: [],
 *     },
 *     options: [],
 *     media: []
 * };
 * ```
 */ function $a22ea7e62969c051$var$parseRawOption(// `rawOption` May be modified
rawOption, optionPreprocessorFuncs, isNew) {
    var mediaList = [];
    var mediaDefault;
    var baseOption;
    var declaredBaseOption = rawOption.baseOption;
    // Compatible with ec2, [RAW_OPTION_PATTERNS] above.
    var timelineOnRoot = rawOption.timeline;
    var timelineOptionsOnRoot = rawOption.options;
    var mediaOnRoot = rawOption.media;
    var hasMedia = !!rawOption.media;
    var hasTimeline = !!(timelineOptionsOnRoot || timelineOnRoot || declaredBaseOption && declaredBaseOption.timeline);
    if (declaredBaseOption) {
        baseOption = declaredBaseOption;
        // For merge option.
        if (!baseOption.timeline) baseOption.timeline = timelineOnRoot;
    } else {
        if (hasTimeline || hasMedia) rawOption.options = rawOption.media = null;
        baseOption = rawOption;
    }
    if (hasMedia) {
        if ((0, $43e0a445ed6711da$export$43bee75e5e14138e)(mediaOnRoot)) (0, $43e0a445ed6711da$export$79b2f7037acddd43)(mediaOnRoot, function(singleMedia) {
            if (singleMedia && singleMedia.option) {
                if (singleMedia.query) mediaList.push(singleMedia);
                else if (!mediaDefault) // Use the first media default.
                mediaDefault = singleMedia;
            }
        });
    }
    doPreprocess(baseOption);
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)(timelineOptionsOnRoot, function(option) {
        return doPreprocess(option);
    });
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)(mediaList, function(media) {
        return doPreprocess(media.option);
    });
    function doPreprocess(option) {
        (0, $43e0a445ed6711da$export$79b2f7037acddd43)(optionPreprocessorFuncs, function(preProcess) {
            preProcess(option, isNew);
        });
    }
    return {
        baseOption: baseOption,
        timelineOptions: timelineOptionsOnRoot || [],
        mediaDefault: mediaDefault,
        mediaList: mediaList
    };
}
/**
 * @see <http://www.w3.org/TR/css3-mediaqueries/#media1>
 * Support: width, height, aspectRatio
 * Can use max or min as prefix.
 */ function $a22ea7e62969c051$var$applyMediaQuery(query, ecWidth, ecHeight) {
    var realMap = {
        width: ecWidth,
        height: ecHeight,
        aspectratio: ecWidth / ecHeight // lower case for convenience.
    };
    var applicable = true;
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)(query, function(value, attr) {
        var matched = attr.match($a22ea7e62969c051$var$QUERY_REG);
        if (!matched || !matched[1] || !matched[2]) return;
        var operator = matched[1];
        var realAttr = matched[2].toLowerCase();
        if (!$a22ea7e62969c051$var$compare(realMap[realAttr], value, operator)) applicable = false;
    });
    return applicable;
}
function $a22ea7e62969c051$var$compare(real, expect, operator) {
    if (operator === "min") return real >= expect;
    else if (operator === "max") return real <= expect;
    else // Equals
    return real === expect;
}
function $a22ea7e62969c051$var$indicesEquals(indices1, indices2) {
    // indices is always order by asc and has only finite number.
    return indices1.join(",") === indices2.join(",");
}
var /**
 * Consider case:
 * `chart.setOption(opt1);`
 * Then user do some interaction like dataZoom, dataView changing.
 * `chart.setOption(opt2);`
 * Then user press 'reset button' in toolbox.
 *
 * After doing that all of the interaction effects should be reset, the
 * chart should be the same as the result of invoke
 * `chart.setOption(opt1); chart.setOption(opt2);`.
 *
 * Although it is not able ensure that
 * `chart.setOption(opt1); chart.setOption(opt2);` is equivalents to
 * `chart.setOption(merge(opt1, opt2));` exactly,
 * this might be the only simple way to implement that feature.
 *
 * MEMO: We've considered some other approaches:
 * 1. Each model handles its self restoration but not uniform treatment.
 *     (Too complex in logic and error-prone)
 * 2. Use a shadow ecModel. (Performance expensive)
 *
 * FIXME: A possible solution:
 * Add a extra level of model for each component model. The inheritance chain would be:
 * ecModel <- componentModel <- componentActionModel <- dataItemModel
 * And all of the actions can only modify the `componentActionModel` rather than
 * `componentModel`. `setOption` will only modify the `ecModel` and `componentModel`.
 * When "resotre" action triggered, model from `componentActionModel` will be discarded
 * instead of recreating the "ecModel" from the "_optionBackup".
 */ // function mergeToBackupOption(
//     fakeCmptsMap: FakeComponentsMap,
//     // `tarOption` Can be null/undefined, means init
//     tarOption: ECUnitOption,
//     newOption: ECUnitOption,
//     // Can be null/undefined
//     opt: InnerSetOptionOpts
// ): void {
//     newOption = newOption || {} as ECUnitOption;
//     const notInit = !!tarOption;
//     each(newOption, function (newOptsInMainType, mainType) {
//         if (newOptsInMainType == null) {
//             return;
//         }
//         if (!ComponentModel.hasClass(mainType)) {
//             if (tarOption) {
//                 tarOption[mainType] = merge(tarOption[mainType], newOptsInMainType, true);
//             }
//         }
//         else {
//             const oldTarOptsInMainType = notInit ? normalizeToArray(tarOption[mainType]) : null;
//             const oldFakeCmptsInMainType = fakeCmptsMap.get(mainType) || [];
//             const resultTarOptsInMainType = notInit ? (tarOption[mainType] = [] as ComponentOption[]) : null;
//             const resultFakeCmptsInMainType = fakeCmptsMap.set(mainType, []);
//             const mappingResult = mappingToExists(
//                 oldFakeCmptsInMainType,
//                 normalizeToArray(newOptsInMainType),
//                 (opt && opt.replaceMergeMainTypeMap.get(mainType)) ? 'replaceMerge' : 'normalMerge'
//             );
//             setComponentTypeToKeyInfo(mappingResult, mainType, ComponentModel as ComponentModelConstructor);
//             each(mappingResult, function (resultItem, index) {
//                 // The same logic as `Global.ts#_mergeOption`.
//                 let fakeCmpt = resultItem.existing;
//                 const newOption = resultItem.newOption;
//                 const keyInfo = resultItem.keyInfo;
//                 let fakeCmptOpt;
//                 if (!newOption) {
//                     fakeCmptOpt = oldTarOptsInMainType[index];
//                 }
//                 else {
//                     if (fakeCmpt && fakeCmpt.subType === keyInfo.subType) {
//                         fakeCmpt.name = keyInfo.name;
//                         if (notInit) {
//                             fakeCmptOpt = merge(oldTarOptsInMainType[index], newOption, true);
//                         }
//                     }
//                     else {
//                         fakeCmpt = extend({}, keyInfo);
//                         if (notInit) {
//                             fakeCmptOpt = clone(newOption);
//                         }
//                     }
//                 }
//                 if (fakeCmpt) {
//                     notInit && resultTarOptsInMainType.push(fakeCmptOpt);
//                     resultFakeCmptsInMainType.push(fakeCmpt);
//                 }
//                 else {
//                     notInit && resultTarOptsInMainType.push(void 0);
//                     resultFakeCmptsInMainType.push(void 0);
//                 }
//             });
//         }
//     });
// }
$a22ea7e62969c051$export$2e2bcd8739ae039 = $a22ea7e62969c051$var$OptionManager;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $a8365c2c37931914$var$each = $43e0a445ed6711da$export$79b2f7037acddd43;
var $a8365c2c37931914$var$isObject = $43e0a445ed6711da$export$a6cdc56e425d0d0a;
var $a8365c2c37931914$var$POSSIBLE_STYLES = [
    "areaStyle",
    "lineStyle",
    "nodeStyle",
    "linkStyle",
    "chordStyle",
    "label",
    "labelLine"
];
function $a8365c2c37931914$var$compatEC2ItemStyle(opt) {
    var itemStyleOpt = opt && opt.itemStyle;
    if (!itemStyleOpt) return;
    for(var i = 0, len = $a8365c2c37931914$var$POSSIBLE_STYLES.length; i < len; i++){
        var styleName = $a8365c2c37931914$var$POSSIBLE_STYLES[i];
        var normalItemStyleOpt = itemStyleOpt.normal;
        var emphasisItemStyleOpt = itemStyleOpt.emphasis;
        if (normalItemStyleOpt && normalItemStyleOpt[styleName]) {
            opt[styleName] = opt[styleName] || {};
            if (!opt[styleName].normal) opt[styleName].normal = normalItemStyleOpt[styleName];
            else $43e0a445ed6711da$export$4950aa0f605343fb(opt[styleName].normal, normalItemStyleOpt[styleName]);
            normalItemStyleOpt[styleName] = null;
        }
        if (emphasisItemStyleOpt && emphasisItemStyleOpt[styleName]) {
            opt[styleName] = opt[styleName] || {};
            if (!opt[styleName].emphasis) opt[styleName].emphasis = emphasisItemStyleOpt[styleName];
            else $43e0a445ed6711da$export$4950aa0f605343fb(opt[styleName].emphasis, emphasisItemStyleOpt[styleName]);
            emphasisItemStyleOpt[styleName] = null;
        }
    }
}
function $a8365c2c37931914$var$convertNormalEmphasis(opt, optType, useExtend) {
    if (opt && opt[optType] && (opt[optType].normal || opt[optType].emphasis)) {
        var normalOpt = opt[optType].normal;
        var emphasisOpt = opt[optType].emphasis;
        if (normalOpt) {
            // Timeline controlStyle has other properties besides normal and emphasis
            if (useExtend) {
                opt[optType].normal = opt[optType].emphasis = null;
                $43e0a445ed6711da$export$ebe90cb607ad99e(opt[optType], normalOpt);
            } else opt[optType] = normalOpt;
        }
        if (emphasisOpt) {
            opt.emphasis = opt.emphasis || {};
            opt.emphasis[optType] = emphasisOpt;
            // Also compat the case user mix the style and focus together in ec3 style
            // for example: { itemStyle: { normal: {}, emphasis: {focus, shadowBlur} } }
            if (emphasisOpt.focus) opt.emphasis.focus = emphasisOpt.focus;
            if (emphasisOpt.blurScope) opt.emphasis.blurScope = emphasisOpt.blurScope;
        }
    }
}
function $a8365c2c37931914$var$removeEC3NormalStatus(opt) {
    $a8365c2c37931914$var$convertNormalEmphasis(opt, "itemStyle");
    $a8365c2c37931914$var$convertNormalEmphasis(opt, "lineStyle");
    $a8365c2c37931914$var$convertNormalEmphasis(opt, "areaStyle");
    $a8365c2c37931914$var$convertNormalEmphasis(opt, "label");
    $a8365c2c37931914$var$convertNormalEmphasis(opt, "labelLine");
    // treemap
    $a8365c2c37931914$var$convertNormalEmphasis(opt, "upperLabel");
    // graph
    $a8365c2c37931914$var$convertNormalEmphasis(opt, "edgeLabel");
}
function $a8365c2c37931914$var$compatTextStyle(opt, propName) {
    // Check whether is not object (string\null\undefined ...)
    var labelOptSingle = $a8365c2c37931914$var$isObject(opt) && opt[propName];
    var textStyle = $a8365c2c37931914$var$isObject(labelOptSingle) && labelOptSingle.textStyle;
    if (textStyle) for(var i = 0, len = $87f4a59ac66e0ee6$export$df45610347a602ad.length; i < len; i++){
        var textPropName = $87f4a59ac66e0ee6$export$df45610347a602ad[i];
        if (textStyle.hasOwnProperty(textPropName)) labelOptSingle[textPropName] = textStyle[textPropName];
    }
}
function $a8365c2c37931914$var$compatEC3CommonStyles(opt) {
    if (opt) {
        $a8365c2c37931914$var$removeEC3NormalStatus(opt);
        $a8365c2c37931914$var$compatTextStyle(opt, "label");
        opt.emphasis && $a8365c2c37931914$var$compatTextStyle(opt.emphasis, "label");
    }
}
function $a8365c2c37931914$var$processSeries(seriesOpt) {
    if (!$a8365c2c37931914$var$isObject(seriesOpt)) return;
    $a8365c2c37931914$var$compatEC2ItemStyle(seriesOpt);
    $a8365c2c37931914$var$removeEC3NormalStatus(seriesOpt);
    $a8365c2c37931914$var$compatTextStyle(seriesOpt, "label");
    // treemap
    $a8365c2c37931914$var$compatTextStyle(seriesOpt, "upperLabel");
    // graph
    $a8365c2c37931914$var$compatTextStyle(seriesOpt, "edgeLabel");
    if (seriesOpt.emphasis) {
        $a8365c2c37931914$var$compatTextStyle(seriesOpt.emphasis, "label");
        // treemap
        $a8365c2c37931914$var$compatTextStyle(seriesOpt.emphasis, "upperLabel");
        // graph
        $a8365c2c37931914$var$compatTextStyle(seriesOpt.emphasis, "edgeLabel");
    }
    var markPoint = seriesOpt.markPoint;
    if (markPoint) {
        $a8365c2c37931914$var$compatEC2ItemStyle(markPoint);
        $a8365c2c37931914$var$compatEC3CommonStyles(markPoint);
    }
    var markLine = seriesOpt.markLine;
    if (markLine) {
        $a8365c2c37931914$var$compatEC2ItemStyle(markLine);
        $a8365c2c37931914$var$compatEC3CommonStyles(markLine);
    }
    var markArea = seriesOpt.markArea;
    if (markArea) $a8365c2c37931914$var$compatEC3CommonStyles(markArea);
    var data = seriesOpt.data;
    // Break with ec3: if `setOption` again, there may be no `type` in option,
    // then the backward compat based on option type will not be performed.
    if (seriesOpt.type === "graph") {
        data = data || seriesOpt.nodes;
        var edgeData = seriesOpt.links || seriesOpt.edges;
        if (edgeData && !$43e0a445ed6711da$export$b119cc7e1840e59c(edgeData)) for(var i = 0; i < edgeData.length; i++)$a8365c2c37931914$var$compatEC3CommonStyles(edgeData[i]);
        $43e0a445ed6711da$export$79b2f7037acddd43(seriesOpt.categories, function(opt) {
            $a8365c2c37931914$var$removeEC3NormalStatus(opt);
        });
    }
    if (data && !$43e0a445ed6711da$export$b119cc7e1840e59c(data)) for(var i = 0; i < data.length; i++)$a8365c2c37931914$var$compatEC3CommonStyles(data[i]);
    // mark point data
    markPoint = seriesOpt.markPoint;
    if (markPoint && markPoint.data) {
        var mpData = markPoint.data;
        for(var i = 0; i < mpData.length; i++)$a8365c2c37931914$var$compatEC3CommonStyles(mpData[i]);
    }
    // mark line data
    markLine = seriesOpt.markLine;
    if (markLine && markLine.data) {
        var mlData = markLine.data;
        for(var i = 0; i < mlData.length; i++)if ($43e0a445ed6711da$export$43bee75e5e14138e(mlData[i])) {
            $a8365c2c37931914$var$compatEC3CommonStyles(mlData[i][0]);
            $a8365c2c37931914$var$compatEC3CommonStyles(mlData[i][1]);
        } else $a8365c2c37931914$var$compatEC3CommonStyles(mlData[i]);
    }
    // Series
    if (seriesOpt.type === "gauge") {
        $a8365c2c37931914$var$compatTextStyle(seriesOpt, "axisLabel");
        $a8365c2c37931914$var$compatTextStyle(seriesOpt, "title");
        $a8365c2c37931914$var$compatTextStyle(seriesOpt, "detail");
    } else if (seriesOpt.type === "treemap") {
        $a8365c2c37931914$var$convertNormalEmphasis(seriesOpt.breadcrumb, "itemStyle");
        $43e0a445ed6711da$export$79b2f7037acddd43(seriesOpt.levels, function(opt) {
            $a8365c2c37931914$var$removeEC3NormalStatus(opt);
        });
    } else if (seriesOpt.type === "tree") $a8365c2c37931914$var$removeEC3NormalStatus(seriesOpt.leaves);
// sunburst starts from ec4, so it does not need to compat levels.
}
function $a8365c2c37931914$var$toArr(o) {
    return $43e0a445ed6711da$export$43bee75e5e14138e(o) ? o : o ? [
        o
    ] : [];
}
function $a8365c2c37931914$var$toObj(o) {
    return ($43e0a445ed6711da$export$43bee75e5e14138e(o) ? o[0] : o) || {};
}
function $a8365c2c37931914$export$2e2bcd8739ae039(option, isTheme) {
    $a8365c2c37931914$var$each($a8365c2c37931914$var$toArr(option.series), function(seriesOpt) {
        $a8365c2c37931914$var$isObject(seriesOpt) && $a8365c2c37931914$var$processSeries(seriesOpt);
    });
    var axes = [
        "xAxis",
        "yAxis",
        "radiusAxis",
        "angleAxis",
        "singleAxis",
        "parallelAxis",
        "radar"
    ];
    isTheme && axes.push("valueAxis", "categoryAxis", "logAxis", "timeAxis");
    $a8365c2c37931914$var$each(axes, function(axisName) {
        $a8365c2c37931914$var$each($a8365c2c37931914$var$toArr(option[axisName]), function(axisOpt) {
            if (axisOpt) {
                $a8365c2c37931914$var$compatTextStyle(axisOpt, "axisLabel");
                $a8365c2c37931914$var$compatTextStyle(axisOpt.axisPointer, "label");
            }
        });
    });
    $a8365c2c37931914$var$each($a8365c2c37931914$var$toArr(option.parallel), function(parallelOpt) {
        var parallelAxisDefault = parallelOpt && parallelOpt.parallelAxisDefault;
        $a8365c2c37931914$var$compatTextStyle(parallelAxisDefault, "axisLabel");
        $a8365c2c37931914$var$compatTextStyle(parallelAxisDefault && parallelAxisDefault.axisPointer, "label");
    });
    $a8365c2c37931914$var$each($a8365c2c37931914$var$toArr(option.calendar), function(calendarOpt) {
        $a8365c2c37931914$var$convertNormalEmphasis(calendarOpt, "itemStyle");
        $a8365c2c37931914$var$compatTextStyle(calendarOpt, "dayLabel");
        $a8365c2c37931914$var$compatTextStyle(calendarOpt, "monthLabel");
        $a8365c2c37931914$var$compatTextStyle(calendarOpt, "yearLabel");
    });
    // radar.name.textStyle
    $a8365c2c37931914$var$each($a8365c2c37931914$var$toArr(option.radar), function(radarOpt) {
        $a8365c2c37931914$var$compatTextStyle(radarOpt, "name");
        // Use axisName instead of name because component has name property
        if (radarOpt.name && radarOpt.axisName == null) {
            radarOpt.axisName = radarOpt.name;
            delete radarOpt.name;
        }
        if (radarOpt.nameGap != null && radarOpt.axisNameGap == null) {
            radarOpt.axisNameGap = radarOpt.nameGap;
            delete radarOpt.nameGap;
        }
    });
    $a8365c2c37931914$var$each($a8365c2c37931914$var$toArr(option.geo), function(geoOpt) {
        if ($a8365c2c37931914$var$isObject(geoOpt)) {
            $a8365c2c37931914$var$compatEC3CommonStyles(geoOpt);
            $a8365c2c37931914$var$each($a8365c2c37931914$var$toArr(geoOpt.regions), function(regionObj) {
                $a8365c2c37931914$var$compatEC3CommonStyles(regionObj);
            });
        }
    });
    $a8365c2c37931914$var$each($a8365c2c37931914$var$toArr(option.timeline), function(timelineOpt) {
        $a8365c2c37931914$var$compatEC3CommonStyles(timelineOpt);
        $a8365c2c37931914$var$convertNormalEmphasis(timelineOpt, "label");
        $a8365c2c37931914$var$convertNormalEmphasis(timelineOpt, "itemStyle");
        $a8365c2c37931914$var$convertNormalEmphasis(timelineOpt, "controlStyle", true);
        var data = timelineOpt.data;
        $43e0a445ed6711da$export$43bee75e5e14138e(data) && $43e0a445ed6711da$export$79b2f7037acddd43(data, function(item) {
            if ($43e0a445ed6711da$export$a6cdc56e425d0d0a(item)) {
                $a8365c2c37931914$var$convertNormalEmphasis(item, "label");
                $a8365c2c37931914$var$convertNormalEmphasis(item, "itemStyle");
            }
        });
    });
    $a8365c2c37931914$var$each($a8365c2c37931914$var$toArr(option.toolbox), function(toolboxOpt) {
        $a8365c2c37931914$var$convertNormalEmphasis(toolboxOpt, "iconStyle");
        $a8365c2c37931914$var$each(toolboxOpt.feature, function(featureOpt) {
            $a8365c2c37931914$var$convertNormalEmphasis(featureOpt, "iconStyle");
        });
    });
    $a8365c2c37931914$var$compatTextStyle($a8365c2c37931914$var$toObj(option.axisPointer), "label");
    $a8365c2c37931914$var$compatTextStyle($a8365c2c37931914$var$toObj(option.tooltip).axisPointer, "label");
// Clean logs
// storedLogs = {};
}




function $8dc883428bb9533d$var$get(opt, path) {
    var pathArr = path.split(",");
    var obj = opt;
    for(var i = 0; i < pathArr.length; i++){
        obj = obj && obj[pathArr[i]];
        if (obj == null) break;
    }
    return obj;
}
function $8dc883428bb9533d$var$set(opt, path, val, overwrite) {
    var pathArr = path.split(",");
    var obj = opt;
    var key;
    var i = 0;
    for(; i < pathArr.length - 1; i++){
        key = pathArr[i];
        if (obj[key] == null) obj[key] = {};
        obj = obj[key];
    }
    if (overwrite || obj[pathArr[i]] == null) obj[pathArr[i]] = val;
}
function $8dc883428bb9533d$var$compatLayoutProperties(option) {
    option && (0, $43e0a445ed6711da$export$79b2f7037acddd43)($8dc883428bb9533d$var$LAYOUT_PROPERTIES, function(prop) {
        if (prop[0] in option && !(prop[1] in option)) option[prop[1]] = option[prop[0]];
    });
}
var $8dc883428bb9533d$var$LAYOUT_PROPERTIES = [
    [
        "x",
        "left"
    ],
    [
        "y",
        "top"
    ],
    [
        "x2",
        "right"
    ],
    [
        "y2",
        "bottom"
    ]
];
var $8dc883428bb9533d$var$COMPATITABLE_COMPONENTS = [
    "grid",
    "geo",
    "parallel",
    "legend",
    "toolbox",
    "title",
    "visualMap",
    "dataZoom",
    "timeline"
];
var $8dc883428bb9533d$var$BAR_ITEM_STYLE_MAP = [
    [
        "borderRadius",
        "barBorderRadius"
    ],
    [
        "borderColor",
        "barBorderColor"
    ],
    [
        "borderWidth",
        "barBorderWidth"
    ]
];
function $8dc883428bb9533d$var$compatBarItemStyle(option) {
    var itemStyle = option && option.itemStyle;
    if (itemStyle) for(var i = 0; i < $8dc883428bb9533d$var$BAR_ITEM_STYLE_MAP.length; i++){
        var oldName = $8dc883428bb9533d$var$BAR_ITEM_STYLE_MAP[i][1];
        var newName = $8dc883428bb9533d$var$BAR_ITEM_STYLE_MAP[i][0];
        if (itemStyle[oldName] != null) itemStyle[newName] = itemStyle[oldName];
    }
}
function $8dc883428bb9533d$var$compatPieLabel(option) {
    if (!option) return;
    if (option.alignTo === "edge" && option.margin != null && option.edgeDistance == null) option.edgeDistance = option.margin;
}
function $8dc883428bb9533d$var$compatSunburstState(option) {
    if (!option) return;
    if (option.downplay && !option.blur) option.blur = option.downplay;
}
function $8dc883428bb9533d$var$compatGraphFocus(option) {
    if (!option) return;
    if (option.focusNodeAdjacency != null) {
        option.emphasis = option.emphasis || {};
        if (option.emphasis.focus == null) option.emphasis.focus = "adjacency";
    }
}
function $8dc883428bb9533d$var$traverseTree(data, cb) {
    if (data) for(var i = 0; i < data.length; i++){
        cb(data[i]);
        data[i] && $8dc883428bb9533d$var$traverseTree(data[i].children, cb);
    }
}
function $8dc883428bb9533d$export$2e2bcd8739ae039(option, isTheme) {
    (0, $a8365c2c37931914$export$2e2bcd8739ae039)(option, isTheme);
    // Make sure series array for model initialization.
    option.series = (0, $87f4a59ac66e0ee6$export$4f07b212a02c8051)(option.series);
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)(option.series, function(seriesOpt) {
        if (!(0, $43e0a445ed6711da$export$a6cdc56e425d0d0a)(seriesOpt)) return;
        var seriesType = seriesOpt.type;
        if (seriesType === "line") {
            if (seriesOpt.clipOverflow != null) seriesOpt.clip = seriesOpt.clipOverflow;
        } else if (seriesType === "pie" || seriesType === "gauge") {
            if (seriesOpt.clockWise != null) seriesOpt.clockwise = seriesOpt.clockWise;
            $8dc883428bb9533d$var$compatPieLabel(seriesOpt.label);
            var data = seriesOpt.data;
            if (data && !(0, $43e0a445ed6711da$export$b119cc7e1840e59c)(data)) for(var i = 0; i < data.length; i++)$8dc883428bb9533d$var$compatPieLabel(data[i]);
            if (seriesOpt.hoverOffset != null) {
                seriesOpt.emphasis = seriesOpt.emphasis || {};
                seriesOpt.emphasis.scaleSize = null;
            }
        } else if (seriesType === "gauge") {
            var pointerColor = $8dc883428bb9533d$var$get(seriesOpt, "pointer.color");
            pointerColor != null && $8dc883428bb9533d$var$set(seriesOpt, "itemStyle.color", pointerColor);
        } else if (seriesType === "bar") {
            $8dc883428bb9533d$var$compatBarItemStyle(seriesOpt);
            $8dc883428bb9533d$var$compatBarItemStyle(seriesOpt.backgroundStyle);
            $8dc883428bb9533d$var$compatBarItemStyle(seriesOpt.emphasis);
            var data = seriesOpt.data;
            if (data && !(0, $43e0a445ed6711da$export$b119cc7e1840e59c)(data)) {
                for(var i = 0; i < data.length; i++)if (typeof data[i] === "object") {
                    $8dc883428bb9533d$var$compatBarItemStyle(data[i]);
                    $8dc883428bb9533d$var$compatBarItemStyle(data[i] && data[i].emphasis);
                }
            }
        } else if (seriesType === "sunburst") {
            var highlightPolicy = seriesOpt.highlightPolicy;
            if (highlightPolicy) {
                seriesOpt.emphasis = seriesOpt.emphasis || {};
                if (!seriesOpt.emphasis.focus) seriesOpt.emphasis.focus = highlightPolicy;
            }
            $8dc883428bb9533d$var$compatSunburstState(seriesOpt);
            $8dc883428bb9533d$var$traverseTree(seriesOpt.data, $8dc883428bb9533d$var$compatSunburstState);
        } else if (seriesType === "graph" || seriesType === "sankey") $8dc883428bb9533d$var$compatGraphFocus(seriesOpt);
        else if (seriesType === "map") {
            if (seriesOpt.mapType && !seriesOpt.map) seriesOpt.map = seriesOpt.mapType;
            if (seriesOpt.mapLocation) (0, $43e0a445ed6711da$export$ebe90cb607ad99e)(seriesOpt, seriesOpt.mapLocation);
        }
        if (seriesOpt.hoverAnimation != null) {
            seriesOpt.emphasis = seriesOpt.emphasis || {};
            if (seriesOpt.emphasis && seriesOpt.emphasis.scale == null) seriesOpt.emphasis.scale = seriesOpt.hoverAnimation;
        }
        $8dc883428bb9533d$var$compatLayoutProperties(seriesOpt);
    });
    // dataRange has changed to visualMap
    if (option.dataRange) option.visualMap = option.dataRange;
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)($8dc883428bb9533d$var$COMPATITABLE_COMPONENTS, function(componentName) {
        var options = option[componentName];
        if (options) {
            if (!(0, $43e0a445ed6711da$export$43bee75e5e14138e)(options)) options = [
                options
            ];
            (0, $43e0a445ed6711da$export$79b2f7037acddd43)(options, function(option) {
                $8dc883428bb9533d$var$compatLayoutProperties(option);
            });
        }
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $5333fd4aae6dad6f$export$dc018729d9e78c17 = (0, $87f4a59ac66e0ee6$export$d62c61cad9d1ab83)($5333fd4aae6dad6f$var$dataStack);
// (1) [Caution]: the logic is correct based on the premises:
//     data processing stage is blocked in stream.
//     See <module:echarts/stream/Scheduler#performDataProcessorTasks>
// (2) Only register once when import repeatedly.
//     Should be executed after series is filtered and before stack calculation.
function $5333fd4aae6dad6f$var$dataStack(ecModel) {
    var stackInfoMap = (0, $43e0a445ed6711da$export$55f8aa7ef875b0a4)();
    ecModel.eachSeries(function(seriesModel) {
        var stack = seriesModel.get("stack");
        // Compatible: when `stack` is set as '', do not stack.
        if (stack) {
            var stackInfoList = stackInfoMap.get(stack) || stackInfoMap.set(stack, []);
            var data = seriesModel.getData();
            var stackInfo = {
                // Used for calculate axis extent automatically.
                // TODO: Type getCalculationInfo return more specific type?
                stackResultDimension: data.getCalculationInfo("stackResultDimension"),
                stackedOverDimension: data.getCalculationInfo("stackedOverDimension"),
                stackedDimension: data.getCalculationInfo("stackedDimension"),
                stackedByDimension: data.getCalculationInfo("stackedByDimension"),
                isStackedByIndex: data.getCalculationInfo("isStackedByIndex"),
                data: data,
                seriesModel: seriesModel
            };
            // If stacked on axis that do not support data stack.
            if (!stackInfo.stackedDimension || !(stackInfo.isStackedByIndex || stackInfo.stackedByDimension)) return;
            stackInfoList.push(stackInfo);
        }
    });
    // Process each stack group
    stackInfoMap.each(function(stackInfoList) {
        if (stackInfoList.length === 0) return;
        // Check if stack order needs to be reversed
        var firstSeries = stackInfoList[0].seriesModel;
        var stackOrder = firstSeries.get("stackOrder") || "seriesAsc";
        if (stackOrder === "seriesDesc") stackInfoList.reverse();
        // Set stackedOnSeries for each series in the final order
        (0, $43e0a445ed6711da$export$79b2f7037acddd43)(stackInfoList, function(stackInfo, index) {
            stackInfo.data.setCalculationInfo("stackedOnSeries", index > 0 ? stackInfoList[index - 1].seriesModel : null);
        });
        // Calculate stack values
        $5333fd4aae6dad6f$var$calculateStack(stackInfoList);
    });
}
function $5333fd4aae6dad6f$var$calculateStack(stackInfoList) {
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)(stackInfoList, function(targetStackInfo, idxInStack) {
        var resultVal = [];
        var resultNaN = [
            NaN,
            NaN
        ];
        var dims = [
            targetStackInfo.stackResultDimension,
            targetStackInfo.stackedOverDimension
        ];
        var targetData = targetStackInfo.data;
        var isStackedByIndex = targetStackInfo.isStackedByIndex;
        var stackStrategy = targetStackInfo.seriesModel.get("stackStrategy") || "samesign";
        // Should not write on raw data, because stack series model list changes
        // depending on legend selection.
        targetData.modify(dims, function(v0, v1, dataIndex) {
            var sum = targetData.get(targetStackInfo.stackedDimension, dataIndex);
            // Consider `connectNulls` of line area, if value is NaN, stackedOver
            // should also be NaN, to draw a appropriate belt area.
            if (isNaN(sum)) return resultNaN;
            var byValue;
            var stackedDataRawIndex;
            if (isStackedByIndex) stackedDataRawIndex = targetData.getRawIndex(dataIndex);
            else byValue = targetData.get(targetStackInfo.stackedByDimension, dataIndex);
            // If stackOver is NaN, chart view will render point on value start.
            var stackedOver = NaN;
            for(var j = idxInStack - 1; j >= 0; j--){
                var stackInfo = stackInfoList[j];
                // Has been optimized by inverted indices on `stackedByDimension`.
                if (!isStackedByIndex) stackedDataRawIndex = stackInfo.data.rawIndexOf(stackInfo.stackedByDimension, byValue);
                if (stackedDataRawIndex >= 0) {
                    var val = stackInfo.data.getByRawIndex(stackInfo.stackResultDimension, stackedDataRawIndex);
                    // Considering positive stack, negative stack and empty data
                    if (stackStrategy === "all" // single stack group
                     || stackStrategy === "positive" && val > 0 || stackStrategy === "negative" && val < 0 || stackStrategy === "samesign" && sum >= 0 && val > 0 // All positive stack
                     || stackStrategy === "samesign" && sum <= 0 && val < 0 // All negative stack
                    ) {
                        // The sum has to be very small to be affected by the
                        // floating arithmetic problem. An incorrect result will probably
                        // cause axis min/max to be filtered incorrectly.
                        sum = (0, $b49750109e236fd8$export$d3389a301c3a5706)(sum, val);
                        stackedOver = val;
                        break;
                    }
                }
            }
            resultVal[0] = sum;
            resultVal[1] = stackedOver;
            return resultVal;
        });
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



// @inner
var $8bdec9fd4ba68d58$var$SourceImpl = /** @class */ function() {
    function SourceImpl(fields) {
        this.data = fields.data || (fields.sourceFormat === (0, $bde9c82f7837f767$export$6a32b42c754a3cb8) ? {} : []);
        this.sourceFormat = fields.sourceFormat || (0, $bde9c82f7837f767$export$c78f1330778d30d);
        // Visit config
        this.seriesLayoutBy = fields.seriesLayoutBy || (0, $bde9c82f7837f767$export$7b3f3c6551b4949b);
        this.startIndex = fields.startIndex || 0;
        this.dimensionsDetectedCount = fields.dimensionsDetectedCount;
        this.metaRawOption = fields.metaRawOption;
        var dimensionsDefine = this.dimensionsDefine = fields.dimensionsDefine;
        if (dimensionsDefine) for(var i = 0; i < dimensionsDefine.length; i++){
            var dim = dimensionsDefine[i];
            if (dim.type == null) {
                if ((0, $a55589c1e81db35a$export$c51adf1a2be01b9c)(this, i) === (0, $a55589c1e81db35a$export$328749e9c5b40760).Must) dim.type = "ordinal";
            }
        }
    }
    return SourceImpl;
}();
function $8bdec9fd4ba68d58$export$22b808bc02a60488(val) {
    return val instanceof $8bdec9fd4ba68d58$var$SourceImpl;
}
function $8bdec9fd4ba68d58$export$1921362e86c73c88(sourceData, thisMetaRawOption, // can be null. If not provided, auto detect it from `sourceData`.
sourceFormat) {
    sourceFormat = sourceFormat || $8bdec9fd4ba68d58$export$52a469afa4653e57(sourceData);
    var seriesLayoutBy = thisMetaRawOption.seriesLayoutBy;
    var determined = $8bdec9fd4ba68d58$var$determineSourceDimensions(sourceData, sourceFormat, seriesLayoutBy, thisMetaRawOption.sourceHeader, thisMetaRawOption.dimensions);
    var source = new $8bdec9fd4ba68d58$var$SourceImpl({
        data: sourceData,
        sourceFormat: sourceFormat,
        seriesLayoutBy: seriesLayoutBy,
        dimensionsDefine: determined.dimensionsDefine,
        startIndex: determined.startIndex,
        dimensionsDetectedCount: determined.dimensionsDetectedCount,
        metaRawOption: (0, $43e0a445ed6711da$export$9cd59f9826255e47)(thisMetaRawOption)
    });
    return source;
}
function $8bdec9fd4ba68d58$export$75aef3f97c0a5edf(data) {
    return new $8bdec9fd4ba68d58$var$SourceImpl({
        data: data,
        sourceFormat: (0, $43e0a445ed6711da$export$b119cc7e1840e59c)(data) ? (0, $bde9c82f7837f767$export$a918cb016a382d45) : (0, $bde9c82f7837f767$export$2823037fb9d8f0c6)
    });
}
function $8bdec9fd4ba68d58$export$e0365e7e3555ddd4(source) {
    return new $8bdec9fd4ba68d58$var$SourceImpl({
        data: source.data,
        sourceFormat: source.sourceFormat,
        seriesLayoutBy: source.seriesLayoutBy,
        dimensionsDefine: (0, $43e0a445ed6711da$export$9cd59f9826255e47)(source.dimensionsDefine),
        startIndex: source.startIndex,
        dimensionsDetectedCount: source.dimensionsDetectedCount
    });
}
function $8bdec9fd4ba68d58$export$52a469afa4653e57(data) {
    var sourceFormat = (0, $bde9c82f7837f767$export$c78f1330778d30d);
    if ((0, $43e0a445ed6711da$export$b119cc7e1840e59c)(data)) sourceFormat = (0, $bde9c82f7837f767$export$a918cb016a382d45);
    else if ((0, $43e0a445ed6711da$export$43bee75e5e14138e)(data)) {
        // FIXME Whether tolerate null in top level array?
        if (data.length === 0) sourceFormat = (0, $bde9c82f7837f767$export$fcd62ebf51387903);
        for(var i = 0, len = data.length; i < len; i++){
            var item = data[i];
            if (item == null) continue;
            else if ((0, $43e0a445ed6711da$export$43bee75e5e14138e)(item) || (0, $43e0a445ed6711da$export$b119cc7e1840e59c)(item)) {
                sourceFormat = (0, $bde9c82f7837f767$export$fcd62ebf51387903);
                break;
            } else if ((0, $43e0a445ed6711da$export$a6cdc56e425d0d0a)(item)) {
                sourceFormat = (0, $bde9c82f7837f767$export$703ae8a2d83f441);
                break;
            }
        }
    } else if ((0, $43e0a445ed6711da$export$a6cdc56e425d0d0a)(data)) {
        for(var key in data)if ((0, $43e0a445ed6711da$export$b5a638e9b3fff9f3)(data, key) && (0, $43e0a445ed6711da$export$1e2f57719e155213)(data[key])) {
            sourceFormat = (0, $bde9c82f7837f767$export$6a32b42c754a3cb8);
            break;
        }
    }
    return sourceFormat;
}
/**
 * Determine the source definitions from data standalone dimensions definitions
 * are not specified.
 */ function $8bdec9fd4ba68d58$var$determineSourceDimensions(data, sourceFormat, seriesLayoutBy, sourceHeader, // standalone raw dimensions definition, like:
// {
//     dimensions: ['aa', 'bb', { name: 'cc', type: 'time' }]
// }
// in `dataset` or `series`
dimensionsDefine) {
    var dimensionsDetectedCount;
    var startIndex;
    // PENDING: Could data be null/undefined here?
    // currently, if `dataset.source` not specified, error thrown.
    // if `series.data` not specified, nothing rendered without error thrown.
    // Should test these cases.
    if (!data) return {
        dimensionsDefine: $8bdec9fd4ba68d58$var$normalizeDimensionsOption(dimensionsDefine),
        startIndex: startIndex,
        dimensionsDetectedCount: dimensionsDetectedCount
    };
    if (sourceFormat === (0, $bde9c82f7837f767$export$fcd62ebf51387903)) {
        var dataArrayRows = data;
        // Rule: Most of the first line are string: it is header.
        // Caution: consider a line with 5 string and 1 number,
        // it still can not be sure it is a head, because the
        // 5 string may be 5 values of category columns.
        if (sourceHeader === "auto" || sourceHeader == null) $8bdec9fd4ba68d58$var$arrayRowsTravelFirst(function(val) {
            // '-' is regarded as null/undefined.
            if (val != null && val !== "-") {
                if ((0, $43e0a445ed6711da$export$844ec244b1367d54)(val)) startIndex == null && (startIndex = 1);
                else startIndex = 0;
            }
        // 10 is an experience number, avoid long loop.
        }, seriesLayoutBy, dataArrayRows, 10);
        else startIndex = (0, $43e0a445ed6711da$export$7e4aa119212bc614)(sourceHeader) ? sourceHeader : sourceHeader ? 1 : 0;
        if (!dimensionsDefine && startIndex === 1) {
            dimensionsDefine = [];
            $8bdec9fd4ba68d58$var$arrayRowsTravelFirst(function(val, index) {
                dimensionsDefine[index] = val != null ? val + "" : "";
            }, seriesLayoutBy, dataArrayRows, Infinity);
        }
        dimensionsDetectedCount = dimensionsDefine ? dimensionsDefine.length : seriesLayoutBy === (0, $bde9c82f7837f767$export$d55da1467cdf7804) ? dataArrayRows.length : dataArrayRows[0] ? dataArrayRows[0].length : null;
    } else if (sourceFormat === (0, $bde9c82f7837f767$export$703ae8a2d83f441)) {
        if (!dimensionsDefine) dimensionsDefine = $8bdec9fd4ba68d58$var$objectRowsCollectDimensions(data);
    } else if (sourceFormat === (0, $bde9c82f7837f767$export$6a32b42c754a3cb8)) {
        if (!dimensionsDefine) {
            dimensionsDefine = [];
            (0, $43e0a445ed6711da$export$79b2f7037acddd43)(data, function(colArr, key) {
                dimensionsDefine.push(key);
            });
        }
    } else if (sourceFormat === (0, $bde9c82f7837f767$export$2823037fb9d8f0c6)) {
        var value0 = (0, $87f4a59ac66e0ee6$export$2c944e12edb48d4b)(data[0]);
        dimensionsDetectedCount = (0, $43e0a445ed6711da$export$43bee75e5e14138e)(value0) && value0.length || 1;
    }
    return {
        startIndex: startIndex,
        dimensionsDefine: $8bdec9fd4ba68d58$var$normalizeDimensionsOption(dimensionsDefine),
        dimensionsDetectedCount: dimensionsDetectedCount
    };
}
function $8bdec9fd4ba68d58$var$objectRowsCollectDimensions(data) {
    var firstIndex = 0;
    var obj;
    while(firstIndex < data.length && !(obj = data[firstIndex++])); // jshint ignore: line
    if (obj) return (0, $43e0a445ed6711da$export$ed97f33186d4b816)(obj);
}
// Consider dimensions defined like ['A', 'price', 'B', 'price', 'C', 'price'],
// which is reasonable. But dimension name is duplicated.
// Returns undefined or an array contains only object without null/undefined or string.
function $8bdec9fd4ba68d58$var$normalizeDimensionsOption(dimensionsDefine) {
    if (!dimensionsDefine) // The meaning of null/undefined is different from empty array.
    return;
    var nameMap = (0, $43e0a445ed6711da$export$55f8aa7ef875b0a4)();
    return (0, $43e0a445ed6711da$export$871de8747c9eaa88)(dimensionsDefine, function(rawItem, index) {
        rawItem = (0, $43e0a445ed6711da$export$a6cdc56e425d0d0a)(rawItem) ? rawItem : {
            name: rawItem
        };
        // Other fields will be discarded.
        var item = {
            name: rawItem.name,
            displayName: rawItem.displayName,
            type: rawItem.type
        };
        // User can set null in dimensions.
        // We don't auto specify name, otherwise a given name may
        // cause it to be referred unexpectedly.
        if (item.name == null) return item;
        // Also consider number form like 2012.
        item.name += "";
        // User may also specify displayName.
        // displayName will always exists except user not
        // specified or dim name is not specified or detected.
        // (A auto generated dim name will not be used as
        // displayName).
        if (item.displayName == null) item.displayName = item.name;
        var exist = nameMap.get(item.name);
        if (!exist) nameMap.set(item.name, {
            count: 1
        });
        else item.name += "-" + exist.count++;
        return item;
    });
}
function $8bdec9fd4ba68d58$var$arrayRowsTravelFirst(cb, seriesLayoutBy, data, maxLoop) {
    if (seriesLayoutBy === (0, $bde9c82f7837f767$export$d55da1467cdf7804)) for(var i = 0; i < data.length && i < maxLoop; i++)cb(data[i] ? data[i][0] : null, i);
    else {
        var value0 = data[0] || [];
        for(var i = 0; i < value0.length && i < maxLoop; i++)cb(value0[i], i);
    }
}
function $8bdec9fd4ba68d58$export$8911336b527f8517(source) {
    var sourceFormat = source.sourceFormat;
    return sourceFormat === (0, $bde9c82f7837f767$export$703ae8a2d83f441) || sourceFormat === (0, $bde9c82f7837f767$export$6a32b42c754a3cb8);
}




var $2e0ca4b2bac7e54a$var$_a, $2e0ca4b2bac7e54a$var$_b, $2e0ca4b2bac7e54a$var$_c, $2e0ca4b2bac7e54a$var$_d;
var $2e0ca4b2bac7e54a$var$providerMethods;
var $2e0ca4b2bac7e54a$var$mountMethods;
/**
 * If normal array used, mutable chunk size is supported.
 * If typed array used, chunk size must be fixed.
 */ var $2e0ca4b2bac7e54a$export$b900d7c4c3952a40 = /** @class */ function() {
    function DefaultDataProvider(sourceParam, dimSize) {
        // let source: Source;
        var source = !(0, $8bdec9fd4ba68d58$export$22b808bc02a60488)(sourceParam) ? (0, $8bdec9fd4ba68d58$export$75aef3f97c0a5edf)(sourceParam) : sourceParam;
        // declare source is Source;
        this._source = source;
        var data = this._data = source.data;
        var sourceFormat = source.sourceFormat;
        var seriesLayoutBy = source.seriesLayoutBy;
        // Typed array. TODO IE10+?
        if (sourceFormat === (0, $bde9c82f7837f767$export$a918cb016a382d45)) {
            this._offset = 0;
            this._dimSize = dimSize;
            this._data = data;
        }
        var validator;
        $2e0ca4b2bac7e54a$var$mountMethods(this, data, source);
    }
    DefaultDataProvider.prototype.getSource = function() {
        return this._source;
    };
    DefaultDataProvider.prototype.count = function() {
        return 0;
    };
    DefaultDataProvider.prototype.getItem = function(idx, out) {
        return;
    };
    DefaultDataProvider.prototype.appendData = function(newData) {};
    DefaultDataProvider.prototype.clean = function() {};
    DefaultDataProvider.protoInitialize = function() {
        // PENDING: To avoid potential incompat (e.g., prototype
        // is visited somewhere), still init them on prototype.
        var proto = DefaultDataProvider.prototype;
        proto.pure = false;
        proto.persistent = true;
    }();
    DefaultDataProvider.internalField = function() {
        var _a;
        $2e0ca4b2bac7e54a$var$mountMethods = function(provider, data, source) {
            var sourceFormat = source.sourceFormat;
            var seriesLayoutBy = source.seriesLayoutBy;
            var startIndex = source.startIndex;
            var dimsDef = source.dimensionsDefine;
            var methods = $2e0ca4b2bac7e54a$var$providerMethods[$2e0ca4b2bac7e54a$var$getMethodMapKey(sourceFormat, seriesLayoutBy)];
            (0, $43e0a445ed6711da$export$8b58be045bf06082)(provider, methods);
            if (sourceFormat === (0, $bde9c82f7837f767$export$a918cb016a382d45)) {
                provider.getItem = getItemForTypedArray;
                provider.count = countForTypedArray;
                provider.fillStorage = fillStorageForTypedArray;
            } else {
                var rawItemGetter = $2e0ca4b2bac7e54a$export$92c8ea8642b3957d(sourceFormat, seriesLayoutBy);
                provider.getItem = (0, $43e0a445ed6711da$export$2385a24977818dd0)(rawItemGetter, null, data, startIndex, dimsDef);
                var rawCounter = $2e0ca4b2bac7e54a$export$803742e832f4b52c(sourceFormat, seriesLayoutBy);
                provider.count = (0, $43e0a445ed6711da$export$2385a24977818dd0)(rawCounter, null, data, startIndex, dimsDef);
            }
        };
        var getItemForTypedArray = function(idx, out) {
            idx = idx - this._offset;
            out = out || [];
            var data = this._data;
            var dimSize = this._dimSize;
            var offset = dimSize * idx;
            for(var i = 0; i < dimSize; i++)out[i] = data[offset + i];
            return out;
        };
        var fillStorageForTypedArray = function(start, end, storage, extent) {
            var data = this._data;
            var dimSize = this._dimSize;
            for(var dim = 0; dim < dimSize; dim++){
                var dimExtent = extent[dim];
                var min = dimExtent[0] == null ? Infinity : dimExtent[0];
                var max = dimExtent[1] == null ? -Infinity : dimExtent[1];
                var count = end - start;
                var arr = storage[dim];
                for(var i = 0; i < count; i++){
                    // appendData with TypedArray will always do replace in provider.
                    var val = data[i * dimSize + dim];
                    arr[start + i] = val;
                    val < min && (min = val);
                    val > max && (max = val);
                }
                dimExtent[0] = min;
                dimExtent[1] = max;
            }
        };
        var countForTypedArray = function() {
            return this._data ? this._data.length / this._dimSize : 0;
        };
        $2e0ca4b2bac7e54a$var$providerMethods = (_a = {}, _a[(0, $bde9c82f7837f767$export$fcd62ebf51387903) + "_" + (0, $bde9c82f7837f767$export$7b3f3c6551b4949b)] = {
            pure: true,
            appendData: appendDataSimply
        }, _a[(0, $bde9c82f7837f767$export$fcd62ebf51387903) + "_" + (0, $bde9c82f7837f767$export$d55da1467cdf7804)] = {
            pure: true,
            appendData: function() {
                throw new Error('Do not support appendData when set seriesLayoutBy: "row".');
            }
        }, _a[0, $bde9c82f7837f767$export$703ae8a2d83f441] = {
            pure: true,
            appendData: appendDataSimply
        }, _a[0, $bde9c82f7837f767$export$6a32b42c754a3cb8] = {
            pure: true,
            appendData: function(newData) {
                var data = this._data;
                (0, $43e0a445ed6711da$export$79b2f7037acddd43)(newData, function(newCol, key) {
                    var oldCol = data[key] || (data[key] = []);
                    for(var i = 0; i < (newCol || []).length; i++)oldCol.push(newCol[i]);
                });
            }
        }, _a[0, $bde9c82f7837f767$export$2823037fb9d8f0c6] = {
            appendData: appendDataSimply
        }, _a[0, $bde9c82f7837f767$export$a918cb016a382d45] = {
            persistent: false,
            pure: true,
            appendData: function(newData) {
                this._data = newData;
            },
            // Clean self if data is already used.
            clean: function() {
                // PENDING
                this._offset += this.count();
                this._data = null;
            }
        }, _a);
        function appendDataSimply(newData) {
            for(var i = 0; i < newData.length; i++)this._data.push(newData[i]);
        }
    }();
    return DefaultDataProvider;
}();
var $2e0ca4b2bac7e54a$var$validateSimply = function(rawData) {
    if (!(0, $43e0a445ed6711da$export$43bee75e5e14138e)(rawData)) (0, $51c99d7efb19f4a2$export$a3bc9b8ed74fc)("series.data or dataset.source must be an array.");
};
/**
 * Only run in dev mode - hint users for debug.
 */ var $2e0ca4b2bac7e54a$var$rawSourceDataValidatorMap = ($2e0ca4b2bac7e54a$var$_a = {}, $2e0ca4b2bac7e54a$var$_a[(0, $bde9c82f7837f767$export$fcd62ebf51387903) + "_" + (0, $bde9c82f7837f767$export$7b3f3c6551b4949b)] = $2e0ca4b2bac7e54a$var$validateSimply, $2e0ca4b2bac7e54a$var$_a[(0, $bde9c82f7837f767$export$fcd62ebf51387903) + "_" + (0, $bde9c82f7837f767$export$d55da1467cdf7804)] = $2e0ca4b2bac7e54a$var$validateSimply, $2e0ca4b2bac7e54a$var$_a[0, $bde9c82f7837f767$export$703ae8a2d83f441] = $2e0ca4b2bac7e54a$var$validateSimply, $2e0ca4b2bac7e54a$var$_a[0, $bde9c82f7837f767$export$6a32b42c754a3cb8] = function(rawData, dimsDef) {
    for(var i = 0; i < dimsDef.length; i++){
        var dimName = dimsDef[i].name;
        if (dimName == null) (0, $51c99d7efb19f4a2$export$a3bc9b8ed74fc)("dimension name must not be null/undefined.");
    }
}, $2e0ca4b2bac7e54a$var$_a[0, $bde9c82f7837f767$export$2823037fb9d8f0c6] = $2e0ca4b2bac7e54a$var$validateSimply, $2e0ca4b2bac7e54a$var$_a);
var $2e0ca4b2bac7e54a$var$getItemSimply = function(rawData, startIndex, dimsDef, idx) {
    return rawData[idx];
};
var $2e0ca4b2bac7e54a$var$rawSourceItemGetterMap = ($2e0ca4b2bac7e54a$var$_b = {}, $2e0ca4b2bac7e54a$var$_b[(0, $bde9c82f7837f767$export$fcd62ebf51387903) + "_" + (0, $bde9c82f7837f767$export$7b3f3c6551b4949b)] = function(rawData, startIndex, dimsDef, idx) {
    return rawData[idx + startIndex];
}, $2e0ca4b2bac7e54a$var$_b[(0, $bde9c82f7837f767$export$fcd62ebf51387903) + "_" + (0, $bde9c82f7837f767$export$d55da1467cdf7804)] = function(rawData, startIndex, dimsDef, idx, out) {
    idx += startIndex;
    var item = out || [];
    var data = rawData;
    for(var i = 0; i < data.length; i++){
        var row = data[i];
        item[i] = row ? row[idx] : null;
    }
    return item;
}, $2e0ca4b2bac7e54a$var$_b[0, $bde9c82f7837f767$export$703ae8a2d83f441] = $2e0ca4b2bac7e54a$var$getItemSimply, $2e0ca4b2bac7e54a$var$_b[0, $bde9c82f7837f767$export$6a32b42c754a3cb8] = function(rawData, startIndex, dimsDef, idx, out) {
    var item = out || [];
    for(var i = 0; i < dimsDef.length; i++){
        var dimName = dimsDef[i].name;
        var col = dimName != null ? rawData[dimName] : null;
        item[i] = col ? col[idx] : null;
    }
    return item;
}, $2e0ca4b2bac7e54a$var$_b[0, $bde9c82f7837f767$export$2823037fb9d8f0c6] = $2e0ca4b2bac7e54a$var$getItemSimply, $2e0ca4b2bac7e54a$var$_b);
function $2e0ca4b2bac7e54a$export$92c8ea8642b3957d(sourceFormat, seriesLayoutBy) {
    var method = $2e0ca4b2bac7e54a$var$rawSourceItemGetterMap[$2e0ca4b2bac7e54a$var$getMethodMapKey(sourceFormat, seriesLayoutBy)];
    return method;
}
var $2e0ca4b2bac7e54a$var$countSimply = function(rawData, startIndex, dimsDef) {
    return rawData.length;
};
var $2e0ca4b2bac7e54a$var$rawSourceDataCounterMap = ($2e0ca4b2bac7e54a$var$_c = {}, $2e0ca4b2bac7e54a$var$_c[(0, $bde9c82f7837f767$export$fcd62ebf51387903) + "_" + (0, $bde9c82f7837f767$export$7b3f3c6551b4949b)] = function(rawData, startIndex, dimsDef) {
    return Math.max(0, rawData.length - startIndex);
}, $2e0ca4b2bac7e54a$var$_c[(0, $bde9c82f7837f767$export$fcd62ebf51387903) + "_" + (0, $bde9c82f7837f767$export$d55da1467cdf7804)] = function(rawData, startIndex, dimsDef) {
    var row = rawData[0];
    return row ? Math.max(0, row.length - startIndex) : 0;
}, $2e0ca4b2bac7e54a$var$_c[0, $bde9c82f7837f767$export$703ae8a2d83f441] = $2e0ca4b2bac7e54a$var$countSimply, $2e0ca4b2bac7e54a$var$_c[0, $bde9c82f7837f767$export$6a32b42c754a3cb8] = function(rawData, startIndex, dimsDef) {
    var dimName = dimsDef[0].name;
    var col = dimName != null ? rawData[dimName] : null;
    return col ? col.length : 0;
}, $2e0ca4b2bac7e54a$var$_c[0, $bde9c82f7837f767$export$2823037fb9d8f0c6] = $2e0ca4b2bac7e54a$var$countSimply, $2e0ca4b2bac7e54a$var$_c);
function $2e0ca4b2bac7e54a$export$803742e832f4b52c(sourceFormat, seriesLayoutBy) {
    var method = $2e0ca4b2bac7e54a$var$rawSourceDataCounterMap[$2e0ca4b2bac7e54a$var$getMethodMapKey(sourceFormat, seriesLayoutBy)];
    return method;
}
var $2e0ca4b2bac7e54a$var$getRawValueSimply = function(dataItem, dimIndex, property) {
    return dataItem[dimIndex];
};
var $2e0ca4b2bac7e54a$var$rawSourceValueGetterMap = ($2e0ca4b2bac7e54a$var$_d = {}, $2e0ca4b2bac7e54a$var$_d[0, $bde9c82f7837f767$export$fcd62ebf51387903] = $2e0ca4b2bac7e54a$var$getRawValueSimply, $2e0ca4b2bac7e54a$var$_d[0, $bde9c82f7837f767$export$703ae8a2d83f441] = function(dataItem, dimIndex, property) {
    return dataItem[property];
}, $2e0ca4b2bac7e54a$var$_d[0, $bde9c82f7837f767$export$6a32b42c754a3cb8] = $2e0ca4b2bac7e54a$var$getRawValueSimply, $2e0ca4b2bac7e54a$var$_d[0, $bde9c82f7837f767$export$2823037fb9d8f0c6] = function(dataItem, dimIndex, property) {
    // FIXME: In some case (markpoint in geo (geo-map.html)),
    // dataItem is {coord: [...]}
    var value = (0, $87f4a59ac66e0ee6$export$2c944e12edb48d4b)(dataItem);
    return !(value instanceof Array) ? value : value[dimIndex];
}, $2e0ca4b2bac7e54a$var$_d[0, $bde9c82f7837f767$export$a918cb016a382d45] = $2e0ca4b2bac7e54a$var$getRawValueSimply, $2e0ca4b2bac7e54a$var$_d);
function $2e0ca4b2bac7e54a$export$1752de8084789a14(sourceFormat) {
    var method = $2e0ca4b2bac7e54a$var$rawSourceValueGetterMap[sourceFormat];
    return method;
}
function $2e0ca4b2bac7e54a$var$getMethodMapKey(sourceFormat, seriesLayoutBy) {
    return sourceFormat === (0, $bde9c82f7837f767$export$fcd62ebf51387903) ? sourceFormat + "_" + seriesLayoutBy : sourceFormat;
}
function $2e0ca4b2bac7e54a$export$cde9373da9aad801(data, dataIndex, // If dimIndex is null/undefined, return OptionDataItem.
// Otherwise, return OptionDataValue.
dim) {
    if (!data) return;
    // Consider data may be not persistent.
    var dataItem = data.getRawDataItem(dataIndex);
    if (dataItem == null) return;
    var store = data.getStore();
    var sourceFormat = store.getSource().sourceFormat;
    if (dim != null) {
        var dimIndex = data.getDimensionIndex(dim);
        var property = store.getDimensionProperty(dimIndex);
        return $2e0ca4b2bac7e54a$export$1752de8084789a14(sourceFormat)(dataItem, dimIndex, property);
    } else {
        var result = dataItem;
        if (sourceFormat === (0, $bde9c82f7837f767$export$2823037fb9d8f0c6)) result = (0, $87f4a59ac66e0ee6$export$2c944e12edb48d4b)(dataItem);
        return result;
    }
}
function $2e0ca4b2bac7e54a$export$c8ae9e77e0ddc42a(data, dataIndex, attr) {
    if (!data) return;
    var sourceFormat = data.getStore().getSource().sourceFormat;
    if (sourceFormat !== (0, $bde9c82f7837f767$export$2823037fb9d8f0c6) && sourceFormat !== (0, $bde9c82f7837f767$export$703ae8a2d83f441)) return;
    var dataItem = data.getRawDataItem(dataIndex);
    if (sourceFormat === (0, $bde9c82f7837f767$export$2823037fb9d8f0c6) && !(0, $43e0a445ed6711da$export$a6cdc56e425d0d0a)(dataItem)) dataItem = null;
    if (dataItem) return dataItem[attr];
}




var $f48a6be4420f5faf$var$DIMENSION_LABEL_REG = /\{@(.+?)\}/g;
var $f48a6be4420f5faf$export$f23396ae04ea95a7 = /** @class */ function() {
    function DataFormatMixin() {}
    /**
   * Get params for formatter
   */ DataFormatMixin.prototype.getDataParams = function(dataIndex, dataType) {
        var data = this.getData(dataType);
        var rawValue = this.getRawValue(dataIndex, dataType);
        var rawDataIndex = data.getRawIndex(dataIndex);
        var name = data.getName(dataIndex);
        var itemOpt = data.getRawDataItem(dataIndex);
        var style = data.getItemVisual(dataIndex, "style");
        var color = style && style[data.getItemVisual(dataIndex, "drawType") || "fill"];
        var borderColor = style && style.stroke;
        var mainType = this.mainType;
        var isSeries = mainType === "series";
        var userOutput = data.userOutput && data.userOutput.get();
        return {
            componentType: mainType,
            componentSubType: this.subType,
            componentIndex: this.componentIndex,
            seriesType: isSeries ? this.subType : null,
            seriesIndex: this.seriesIndex,
            seriesId: isSeries ? this.id : null,
            seriesName: isSeries ? this.name : null,
            name: name,
            dataIndex: rawDataIndex,
            data: itemOpt,
            dataType: dataType,
            value: rawValue,
            color: color,
            borderColor: borderColor,
            dimensionNames: userOutput ? userOutput.fullDimensions : null,
            encode: userOutput ? userOutput.encode : null,
            // Param name list for mapping `a`, `b`, `c`, `d`, `e`
            $vars: [
                "seriesName",
                "name",
                "value"
            ]
        };
    };
    /**
   * Format label
   * @param dataIndex
   * @param status 'normal' by default
   * @param dataType
   * @param labelDimIndex Only used in some chart that
   *        use formatter in different dimensions, like radar.
   * @param formatter Formatter given outside.
   * @return return null/undefined if no formatter
   */ DataFormatMixin.prototype.getFormattedLabel = function(dataIndex, status, dataType, labelDimIndex, formatter, extendParams) {
        status = status || "normal";
        var data = this.getData(dataType);
        var params = this.getDataParams(dataIndex, dataType);
        if (extendParams) params.value = extendParams.interpolatedValue;
        if (labelDimIndex != null && $43e0a445ed6711da$export$43bee75e5e14138e(params.value)) params.value = params.value[labelDimIndex];
        if (!formatter) {
            var itemModel = data.getItemModel(dataIndex);
            // @ts-ignore
            formatter = itemModel.get(status === "normal" ? [
                "label",
                "formatter"
            ] : [
                status,
                "label",
                "formatter"
            ]);
        }
        if ($43e0a445ed6711da$export$f6e2535fb5126e54(formatter)) {
            params.status = status;
            params.dimensionIndex = labelDimIndex;
            return formatter(params);
        } else if ($43e0a445ed6711da$export$844ec244b1367d54(formatter)) {
            var str = (0, $78c2ece6dfa6bb7a$export$2028496a35766e41)(formatter, params);
            // Support 'aaa{@[3]}bbb{@product}ccc'.
            // Do not support '}' in dim name util have to.
            return str.replace($f48a6be4420f5faf$var$DIMENSION_LABEL_REG, function(origin, dimStr) {
                var len = dimStr.length;
                var dimLoose = dimStr;
                if (dimLoose.charAt(0) === "[" && dimLoose.charAt(len - 1) === "]") dimLoose = +dimLoose.slice(1, len - 1); // Also support: '[]' => 0
                var val = (0, $2e0ca4b2bac7e54a$export$cde9373da9aad801)(data, dataIndex, dimLoose);
                if (extendParams && $43e0a445ed6711da$export$43bee75e5e14138e(extendParams.interpolatedValue)) {
                    var dimIndex = data.getDimensionIndex(dimLoose);
                    if (dimIndex >= 0) val = extendParams.interpolatedValue[dimIndex];
                }
                return val != null ? val + "" : "";
            });
        }
    };
    /**
   * Get raw value in option
   */ DataFormatMixin.prototype.getRawValue = function(idx, dataType) {
        return (0, $2e0ca4b2bac7e54a$export$cde9373da9aad801)(this.getData(dataType), idx);
    };
    /**
   * Should be implemented.
   * @param {number} dataIndex
   * @param {boolean} [multipleSeries=false]
   * @param {string} [dataType]
   */ DataFormatMixin.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        // Empty function
        return;
    };
    return DataFormatMixin;
}();
function $f48a6be4420f5faf$export$2d16fa82a50c4741(result) {
    var markupText;
    // let markers: Dictionary<ColorString>;
    var markupFragment;
    if ($43e0a445ed6711da$export$a6cdc56e425d0d0a(result)) {
        if (result.type) markupFragment = result;
    } else markupText = result;
    return {
        text: markupText,
        // markers: markers || markersExisting,
        frag: markupFragment
    };
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $eb04eaa34fbabb0a$export$f7292ab7796be73c(define) {
    return new $eb04eaa34fbabb0a$export$2dea7024bcdd7731(define);
}
var $eb04eaa34fbabb0a$export$2dea7024bcdd7731 = /** @class */ function() {
    function Task(define) {
        define = define || {};
        this._reset = define.reset;
        this._plan = define.plan;
        this._count = define.count;
        this._onDirty = define.onDirty;
        this._dirty = true;
    }
    /**
   * @param step Specified step.
   * @param skip Skip customer perform call.
   * @param modBy Sampling window size.
   * @param modDataCount Sampling count.
   * @return whether unfinished.
   */ Task.prototype.perform = function(performArgs) {
        var upTask = this._upstream;
        var skip = performArgs && performArgs.skip;
        // TODO some refactor.
        // Pull data. Must pull data each time, because context.data
        // may be updated by Series.setData.
        if (this._dirty && upTask) {
            var context = this.context;
            context.data = context.outputData = upTask.context.outputData;
        }
        if (this.__pipeline) this.__pipeline.currentTask = this;
        var planResult;
        if (this._plan && !skip) planResult = this._plan(this.context);
        // Support sharding by mod, which changes the render sequence and makes the rendered graphic
        // elements uniformed distributed when progress, especially when moving or zooming.
        var lastModBy = normalizeModBy(this._modBy);
        var lastModDataCount = this._modDataCount || 0;
        var modBy = normalizeModBy(performArgs && performArgs.modBy);
        var modDataCount = performArgs && performArgs.modDataCount || 0;
        if (lastModBy !== modBy || lastModDataCount !== modDataCount) planResult = "reset";
        function normalizeModBy(val) {
            !(val >= 1) && (val = 1); // jshint ignore:line
            return val;
        }
        var forceFirstProgress;
        if (this._dirty || planResult === "reset") {
            this._dirty = false;
            forceFirstProgress = this._doReset(skip);
        }
        this._modBy = modBy;
        this._modDataCount = modDataCount;
        var step = performArgs && performArgs.step;
        if (upTask) this._dueEnd = upTask._outputDueEnd;
        else this._dueEnd = this._count ? this._count(this.context) : Infinity;
        // Note: Stubs, that its host overall task let it has progress, has progress.
        // If no progress, pass index from upstream to downstream each time plan called.
        if (this._progress) {
            var start = this._dueIndex;
            var end = Math.min(step != null ? this._dueIndex + step : Infinity, this._dueEnd);
            if (!skip && (forceFirstProgress || start < end)) {
                var progress = this._progress;
                if ((0, $43e0a445ed6711da$export$43bee75e5e14138e)(progress)) for(var i = 0; i < progress.length; i++)this._doProgress(progress[i], start, end, modBy, modDataCount);
                else this._doProgress(progress, start, end, modBy, modDataCount);
            }
            this._dueIndex = end;
            // If no `outputDueEnd`, assume that output data and
            // input data is the same, so use `dueIndex` as `outputDueEnd`.
            var outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : end;
            this._outputDueEnd = outputDueEnd;
        } else // (1) Some overall task has no progress.
        // (2) Stubs, that its host overall task do not let it has progress, has no progress.
        // This should always be performed so it can be passed to downstream.
        this._dueIndex = this._outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : this._dueEnd;
        return this.unfinished();
    };
    /**
   * @tutorial [EC_TASK_DIRTY]
   *  Task `dirty()` calls typically originate from a trigger of EC_FULL_UPDATE_CYCLE and
   *  EC_PARTIAL_UPDATE_CYCLE) (See comments in EC_CYCLE. Generally, task dirty propagates
   *  to downstream tasks.
   *  Task dirty leads to the `StageHandler['reset']` or `StageHandler['overallReset']` call,
   *  which discards the previous result and starts over the processing.
   */ Task.prototype.dirty = function() {
        this._dirty = true;
        this._onDirty && this._onDirty(this.context);
    };
    Task.prototype._doProgress = function(progress, start, end, modBy, modDataCount) {
        $eb04eaa34fbabb0a$var$iterator.reset(start, end, modBy, modDataCount);
        this._callingProgress = progress;
        this._callingProgress({
            start: start,
            end: end,
            count: end - start,
            next: $eb04eaa34fbabb0a$var$iterator.next
        }, this.context);
    };
    Task.prototype._doReset = function(skip) {
        this._dueIndex = this._outputDueEnd = this._dueEnd = 0;
        this._settedOutputEnd = null;
        var progress;
        var forceFirstProgress;
        if (!skip && this._reset) {
            progress = this._reset(this.context);
            if (progress && progress.progress) {
                forceFirstProgress = progress.forceFirstProgress;
                progress = progress.progress;
            }
            // To simplify no progress checking, array must has item.
            if ((0, $43e0a445ed6711da$export$43bee75e5e14138e)(progress) && !progress.length) progress = null;
        }
        this._progress = progress;
        this._modBy = this._modDataCount = null;
        var downstream = this._downstream;
        downstream && downstream.dirty();
        return forceFirstProgress;
    };
    Task.prototype.unfinished = function() {
        return this._progress && this._dueIndex < this._dueEnd;
    };
    /**
   * @param downTask The downstream task.
   * @return The downstream task.
   */ Task.prototype.pipe = function(downTask) {
        // If already downstream, do not dirty downTask.
        if (this._downstream !== downTask || this._dirty) {
            this._downstream = downTask;
            downTask._upstream = this;
            downTask.dirty();
        }
    };
    Task.prototype.dispose = function() {
        if (this._disposed) return;
        this._upstream && (this._upstream._downstream = null);
        this._downstream && (this._downstream._upstream = null);
        this._dirty = false;
        this._disposed = true;
    };
    Task.prototype.getUpstream = function() {
        return this._upstream;
    };
    Task.prototype.getDownstream = function() {
        return this._downstream;
    };
    Task.prototype.setOutputEnd = function(end) {
        // This only happens in dataTask, dataZoom, map, currently.
        // where dataZoom do not set end each time, but only set
        // when reset. So we should record the set end, in case
        // that the stub of dataZoom perform again and earse the
        // set end by upstream.
        this._outputDueEnd = this._settedOutputEnd = end;
    };
    return Task;
}();
var $eb04eaa34fbabb0a$var$iterator = function() {
    var end;
    var current;
    var modBy;
    var modDataCount;
    var winCount;
    var it = {
        reset: function(s, e, sStep, sCount) {
            current = s;
            end = e;
            modBy = sStep;
            modDataCount = sCount;
            winCount = Math.ceil(modDataCount / modBy);
            it.next = modBy > 1 && modDataCount > 0 ? modNext : sequentialNext;
        }
    };
    return it;
    function sequentialNext() {
        return current < end ? current++ : null;
    }
    function modNext() {
        var dataIndex = current % winCount * modBy + Math.ceil(current / winCount);
        var result = current >= end ? null : dataIndex < modDataCount ? dataIndex : current;
        current++;
        return result;
    }
}(); // -----------------------------------------------------------------------------
 // For stream debug (Should be commented out after used!)
 // @usage: printTask(this, 'begin');
 // @usage: printTask(this, null, {someExtraProp});
 // @usage: Use `__idxInPipeline` as conditional breakpiont.
 //
 // window.printTask = function (task: any, prefix: string, extra: { [key: string]: unknown }): void {
 //     window.ecTaskUID == null && (window.ecTaskUID = 0);
 //     task.uidDebug == null && (task.uidDebug = `task_${window.ecTaskUID++}`);
 //     task.agent && task.agent.uidDebug == null && (task.agent.uidDebug = `task_${window.ecTaskUID++}`);
 //     let props = [];
 //     if (task.__pipeline) {
 //         let val = `${task.__idxInPipeline}/${task.__pipeline.tail.__idxInPipeline} ${task.agent ? '(stub)' : ''}`;
 //         props.push({text: '__idxInPipeline/total', value: val});
 //     } else {
 //         let stubCount = 0;
 //         task.agentStubMap.each(() => stubCount++);
 //         props.push({text: 'idx', value: `overall (stubs: ${stubCount})`});
 //     }
 //     props.push({text: 'uid', value: task.uidDebug});
 //     if (task.__pipeline) {
 //         props.push({text: 'pipelineId', value: task.__pipeline.id});
 //         task.agent && props.push(
 //             {text: 'stubFor', value: task.agent.uidDebug}
 //         );
 //     }
 //     props.push(
 //         {text: 'dirty', value: task._dirty},
 //         {text: 'dueIndex', value: task._dueIndex},
 //         {text: 'dueEnd', value: task._dueEnd},
 //         {text: 'outputDueEnd', value: task._outputDueEnd}
 //     );
 //     if (extra) {
 //         Object.keys(extra).forEach(key => {
 //             props.push({text: key, value: extra[key]});
 //         });
 //     }
 //     let args = ['color: blue'];
 //     let msg = `%c[${prefix || 'T'}] %c` + props.map(item => (
 //         args.push('color: green', 'color: red'),
 //         `${item.text}: %c${item.value}`
 //     )).join('%c, ');
 //     console.log.apply(console, [msg].concat(args));
 //     // console.log(this);
 // };
 // window.printPipeline = function (task: any, prefix: string) {
 //     const pipeline = task.__pipeline;
 //     let currTask = pipeline.head;
 //     while (currTask) {
 //         window.printTask(currTask, prefix);
 //         currTask = currTask._downstream;
 //     }
 // };
 // window.showChain = function (chainHeadTask) {
 //     var chain = [];
 //     var task = chainHeadTask;
 //     while (task) {
 //         chain.push({
 //             task: task,
 //             up: task._upstream,
 //             down: task._downstream,
 //             idxInPipeline: task.__idxInPipeline
 //         });
 //         task = task._downstream;
 //     }
 //     return chain;
 // };
 // window.findTaskInChain = function (task, chainHeadTask) {
 //     let chain = window.showChain(chainHeadTask);
 //     let result = [];
 //     for (let i = 0; i < chain.length; i++) {
 //         let chainItem = chain[i];
 //         if (chainItem.task === task) {
 //             result.push(i);
 //         }
 //     }
 //     return result;
 // };
 // window.printChainAEachInChainB = function (chainHeadTaskA, chainHeadTaskB) {
 //     let chainA = window.showChain(chainHeadTaskA);
 //     for (let i = 0; i < chainA.length; i++) {
 //         console.log('chainAIdx:', i, 'inChainB:', window.findTaskInChain(chainA[i].task, chainHeadTaskB));
 //     }
 // };



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $33d0d4ceafa5e518$export$cc7175145baad076(value, // For high performance, do not omit the second param.
opt) {
    // Performance sensitive.
    var dimType = opt && opt.type;
    if (dimType === "ordinal") // If given value is a category string
    return value;
    if (dimType === "time" && !(0, $43e0a445ed6711da$export$7e4aa119212bc614)(value) && value != null && value !== "-") value = +(0, $b49750109e236fd8$export$6b862160d295c8e)(value);
    // dimType defaults 'number'.
    // If dimType is not ordinal and value is null or undefined or NaN or '-',
    // parse to NaN.
    // number-like string (like ' 123 ') can be converted to a number.
    // where null/undefined or other string will be converted to NaN.
    return value == null || value === "" ? NaN : Number(value);
}
var $33d0d4ceafa5e518$var$valueParserMap = (0, $43e0a445ed6711da$export$55f8aa7ef875b0a4)({
    "number": function(val) {
        // Do not use `numericToNumber` here. We have `numericToNumber` by default.
        // Here the number parser can have loose rule:
        // enable to cut suffix: "120px" => 120, "14%" => 14.
        return parseFloat(val);
    },
    "time": function(val) {
        // return timestamp.
        return +(0, $b49750109e236fd8$export$6b862160d295c8e)(val);
    },
    "trim": function(val) {
        return (0, $43e0a445ed6711da$export$844ec244b1367d54)(val) ? (0, $43e0a445ed6711da$export$87c2784dc9fc4ab)(val) : val;
    }
});
function $33d0d4ceafa5e518$export$c88237b7c265b36b(type) {
    return $33d0d4ceafa5e518$var$valueParserMap.get(type);
}
var $33d0d4ceafa5e518$var$ORDER_COMPARISON_OP_MAP = {
    lt: function(lval, rval) {
        return lval < rval;
    },
    lte: function(lval, rval) {
        return lval <= rval;
    },
    gt: function(lval, rval) {
        return lval > rval;
    },
    gte: function(lval, rval) {
        return lval >= rval;
    }
};
var $33d0d4ceafa5e518$var$FilterOrderComparator = /** @class */ function() {
    function FilterOrderComparator(op, rval) {
        if (!(0, $43e0a445ed6711da$export$7e4aa119212bc614)(rval)) {
            var errMsg = "";
            (0, $51c99d7efb19f4a2$export$8bf7aba4a9e09055)(errMsg);
        }
        this._opFn = $33d0d4ceafa5e518$var$ORDER_COMPARISON_OP_MAP[op];
        this._rvalFloat = (0, $b49750109e236fd8$export$8b4007b942b45a96)(rval);
    }
    // Performance sensitive.
    FilterOrderComparator.prototype.evaluate = function(lval) {
        // Most cases is 'number', and typeof maybe 10 times faseter than parseFloat.
        return (0, $43e0a445ed6711da$export$7e4aa119212bc614)(lval) ? this._opFn(lval, this._rvalFloat) : this._opFn((0, $b49750109e236fd8$export$8b4007b942b45a96)(lval), this._rvalFloat);
    };
    return FilterOrderComparator;
}();
var $33d0d4ceafa5e518$export$ed75a5d7b0144167 = /** @class */ function() {
    /**
   * @param order by default: 'asc'
   * @param incomparable by default: Always on the tail.
   *        That is, if 'asc' => 'max', if 'desc' => 'min'
   *        See the definition of "incomparable" in [SORT_COMPARISON_RULE].
   */ function SortOrderComparator(order, incomparable) {
        var isDesc = order === "desc";
        this._resultLT = isDesc ? 1 : -1;
        if (incomparable == null) incomparable = isDesc ? "min" : "max";
        this._incomparable = incomparable === "min" ? -Infinity : Infinity;
    }
    // See [SORT_COMPARISON_RULE].
    // Performance sensitive.
    SortOrderComparator.prototype.evaluate = function(lval, rval) {
        // Most cases is 'number', and typeof maybe 10 times faseter than parseFloat.
        var lvalFloat = (0, $43e0a445ed6711da$export$7e4aa119212bc614)(lval) ? lval : (0, $b49750109e236fd8$export$8b4007b942b45a96)(lval);
        var rvalFloat = (0, $43e0a445ed6711da$export$7e4aa119212bc614)(rval) ? rval : (0, $b49750109e236fd8$export$8b4007b942b45a96)(rval);
        var lvalNotNumeric = isNaN(lvalFloat);
        var rvalNotNumeric = isNaN(rvalFloat);
        if (lvalNotNumeric) lvalFloat = this._incomparable;
        if (rvalNotNumeric) rvalFloat = this._incomparable;
        if (lvalNotNumeric && rvalNotNumeric) {
            var lvalIsStr = (0, $43e0a445ed6711da$export$844ec244b1367d54)(lval);
            var rvalIsStr = (0, $43e0a445ed6711da$export$844ec244b1367d54)(rval);
            if (lvalIsStr) lvalFloat = rvalIsStr ? lval : 0;
            if (rvalIsStr) rvalFloat = lvalIsStr ? rval : 0;
        }
        return lvalFloat < rvalFloat ? this._resultLT : lvalFloat > rvalFloat ? -this._resultLT : 0;
    };
    return SortOrderComparator;
}();
var $33d0d4ceafa5e518$var$FilterEqualityComparator = /** @class */ function() {
    function FilterEqualityComparator(isEq, rval) {
        this._rval = rval;
        this._isEQ = isEq;
        this._rvalTypeof = typeof rval;
        this._rvalFloat = (0, $b49750109e236fd8$export$8b4007b942b45a96)(rval);
    }
    // Performance sensitive.
    FilterEqualityComparator.prototype.evaluate = function(lval) {
        var eqResult = lval === this._rval;
        if (!eqResult) {
            var lvalTypeof = typeof lval;
            if (lvalTypeof !== this._rvalTypeof && (lvalTypeof === "number" || this._rvalTypeof === "number")) eqResult = (0, $b49750109e236fd8$export$8b4007b942b45a96)(lval) === this._rvalFloat;
        }
        return this._isEQ ? eqResult : !eqResult;
    };
    return FilterEqualityComparator;
}();
function $33d0d4ceafa5e518$export$f2644c3485f94c4e(op, rval) {
    return op === "eq" || op === "ne" ? new $33d0d4ceafa5e518$var$FilterEqualityComparator(op === "eq", rval) : (0, $43e0a445ed6711da$export$b5a638e9b3fff9f3)($33d0d4ceafa5e518$var$ORDER_COMPARISON_OP_MAP, op) ? new $33d0d4ceafa5e518$var$FilterOrderComparator(op, rval) : null;
}
function $33d0d4ceafa5e518$export$1b2aa782dfdf5700(filter) {
    var filterKey = "";
    var filterG = -Infinity;
    var filterGE = -Infinity;
    var filterL = Infinity;
    var filterLE = Infinity;
    if (filter) {
        if (filter.g != null) {
            filterKey += "G" + filter.g;
            filterG = filter.g;
        }
        if (filter.ge != null) {
            filterKey += "GE" + filter.ge;
            filterGE = filter.ge;
        }
        if (filter.l != null) {
            filterKey += "L" + filter.l;
            filterL = filter.l;
        }
        if (filter.le != null) {
            filterKey += "LE" + filter.le;
            filterLE = filter.le;
        }
    }
    return {
        key: filterKey,
        g: filterG,
        ge: filterGE,
        l: filterL,
        le: filterLE
    };
}
function $33d0d4ceafa5e518$export$49bf74cb3f1b6c80(filterParsed, value) {
    return value > filterParsed.g && value >= filterParsed.ge && value < filterParsed.l && value <= filterParsed.le;
} // --------- END: Data store sanitization filters ---------




/**
 * TODO: disable writable.
 * This structure will be exposed to users.
 */ var $b3d05d3fca143040$export$ffc19e40a21f08eb = /** @class */ function() {
    function ExternalSource() {}
    ExternalSource.prototype.getRawData = function() {
        // Only built-in transform available.
        throw new Error("not supported");
    };
    ExternalSource.prototype.getRawDataItem = function(dataIndex) {
        // Only built-in transform available.
        throw new Error("not supported");
    };
    ExternalSource.prototype.cloneRawData = function() {
        return;
    };
    /**
   * @return If dimension not found, return null/undefined.
   */ ExternalSource.prototype.getDimensionInfo = function(dim) {
        return;
    };
    /**
   * dimensions defined if and only if either:
   * (a) dataset.dimensions are declared.
   * (b) dataset data include dimensions definitions in data (detected or via specified `sourceHeader`).
   * If dimensions are defined, `dimensionInfoAll` is corresponding to
   * the defined dimensions.
   * Otherwise, `dimensionInfoAll` is determined by data columns.
   * @return Always return an array (even empty array).
   */ ExternalSource.prototype.cloneAllDimensionInfo = function() {
        return;
    };
    ExternalSource.prototype.count = function() {
        return;
    };
    /**
   * Only support by dimension index.
   * No need to support by dimension name in transform function,
   * because transform function is not case-specific, no need to use name literally.
   */ ExternalSource.prototype.retrieveValue = function(dataIndex, dimIndex) {
        return;
    };
    ExternalSource.prototype.retrieveValueFromItem = function(dataItem, dimIndex) {
        return;
    };
    ExternalSource.prototype.convertValue = function(rawVal, dimInfo) {
        return (0, $33d0d4ceafa5e518$export$cc7175145baad076)(rawVal, dimInfo);
    };
    return ExternalSource;
}();
function $b3d05d3fca143040$var$createExternalSource(internalSource, externalTransform) {
    var extSource = new $b3d05d3fca143040$export$ffc19e40a21f08eb();
    var data = internalSource.data;
    var sourceFormat = extSource.sourceFormat = internalSource.sourceFormat;
    var sourceHeaderCount = internalSource.startIndex;
    var errMsg = "";
    if (internalSource.seriesLayoutBy !== (0, $bde9c82f7837f767$export$7b3f3c6551b4949b)) (0, $51c99d7efb19f4a2$export$8bf7aba4a9e09055)(errMsg);
    // [MEMO]
    // Create a new dimensions structure for exposing.
    // Do not expose all dimension info to users directly.
    // Because the dimension is probably auto detected from data and not might reliable.
    // Should not lead the transformers to think that is reliable and return it.
    // See [DIMENSION_INHERIT_RULE] in `sourceManager.ts`.
    var dimensions = [];
    var dimsByName = {};
    var dimsDef = internalSource.dimensionsDefine;
    if (dimsDef) (0, $43e0a445ed6711da$export$79b2f7037acddd43)(dimsDef, function(dimDef, idx) {
        var name = dimDef.name;
        var dimDefExt = {
            index: idx,
            name: name,
            displayName: dimDef.displayName
        };
        dimensions.push(dimDefExt);
        // Users probably do not specify dimension name. For simplicity, data transform
        // does not generate dimension name.
        if (name != null) {
            // Dimension name should not be duplicated.
            // For simplicity, data transform forbids name duplication, do not generate
            // new name like module `completeDimensions.ts` did, but just tell users.
            var errMsg_1 = "";
            if ((0, $43e0a445ed6711da$export$b5a638e9b3fff9f3)(dimsByName, name)) (0, $51c99d7efb19f4a2$export$8bf7aba4a9e09055)(errMsg_1);
            dimsByName[name] = dimDefExt;
        }
    });
    else for(var i = 0; i < internalSource.dimensionsDetectedCount || 0; i++)// Do not generete name or anything others. The consequence process in
    // `transform` or `series` probably have there own name generation strategry.
    dimensions.push({
        index: i
    });
    // Implement public methods:
    var rawItemGetter = (0, $2e0ca4b2bac7e54a$export$92c8ea8642b3957d)(sourceFormat, (0, $bde9c82f7837f767$export$7b3f3c6551b4949b));
    if (externalTransform.__isBuiltIn) {
        extSource.getRawDataItem = function(dataIndex) {
            return rawItemGetter(data, sourceHeaderCount, dimensions, dataIndex);
        };
        extSource.getRawData = (0, $43e0a445ed6711da$export$2385a24977818dd0)($b3d05d3fca143040$var$getRawData, null, internalSource);
    }
    extSource.cloneRawData = (0, $43e0a445ed6711da$export$2385a24977818dd0)($b3d05d3fca143040$var$cloneRawData, null, internalSource);
    var rawCounter = (0, $2e0ca4b2bac7e54a$export$803742e832f4b52c)(sourceFormat, (0, $bde9c82f7837f767$export$7b3f3c6551b4949b));
    extSource.count = (0, $43e0a445ed6711da$export$2385a24977818dd0)(rawCounter, null, data, sourceHeaderCount, dimensions);
    var rawValueGetter = (0, $2e0ca4b2bac7e54a$export$1752de8084789a14)(sourceFormat);
    extSource.retrieveValue = function(dataIndex, dimIndex) {
        var rawItem = rawItemGetter(data, sourceHeaderCount, dimensions, dataIndex);
        return retrieveValueFromItem(rawItem, dimIndex);
    };
    var retrieveValueFromItem = extSource.retrieveValueFromItem = function(dataItem, dimIndex) {
        if (dataItem == null) return;
        var dimDef = dimensions[dimIndex];
        // When `dimIndex` is `null`, `rawValueGetter` return the whole item.
        if (dimDef) return rawValueGetter(dataItem, dimIndex, dimDef.name);
    };
    extSource.getDimensionInfo = (0, $43e0a445ed6711da$export$2385a24977818dd0)($b3d05d3fca143040$var$getDimensionInfo, null, dimensions, dimsByName);
    extSource.cloneAllDimensionInfo = (0, $43e0a445ed6711da$export$2385a24977818dd0)($b3d05d3fca143040$var$cloneAllDimensionInfo, null, dimensions);
    return extSource;
}
function $b3d05d3fca143040$var$getRawData(upstream) {
    var sourceFormat = upstream.sourceFormat;
    if (!$b3d05d3fca143040$var$isSupportedSourceFormat(sourceFormat)) {
        var errMsg = "";
        (0, $51c99d7efb19f4a2$export$8bf7aba4a9e09055)(errMsg);
    }
    return upstream.data;
}
function $b3d05d3fca143040$var$cloneRawData(upstream) {
    var sourceFormat = upstream.sourceFormat;
    var data = upstream.data;
    if (!$b3d05d3fca143040$var$isSupportedSourceFormat(sourceFormat)) {
        var errMsg = "";
        (0, $51c99d7efb19f4a2$export$8bf7aba4a9e09055)(errMsg);
    }
    if (sourceFormat === (0, $bde9c82f7837f767$export$fcd62ebf51387903)) {
        var result = [];
        for(var i = 0, len = data.length; i < len; i++)// Not strictly clone for performance
        result.push(data[i].slice());
        return result;
    } else if (sourceFormat === (0, $bde9c82f7837f767$export$703ae8a2d83f441)) {
        var result = [];
        for(var i = 0, len = data.length; i < len; i++)// Not strictly clone for performance
        result.push((0, $43e0a445ed6711da$export$8b58be045bf06082)({}, data[i]));
        return result;
    }
}
function $b3d05d3fca143040$var$getDimensionInfo(dimensions, dimsByName, dim) {
    if (dim == null) return;
    // Keep the same logic as `List::getDimension` did.
    if ((0, $43e0a445ed6711da$export$7e4aa119212bc614)(dim) || !isNaN(dim) && !(0, $43e0a445ed6711da$export$b5a638e9b3fff9f3)(dimsByName, dim)) return dimensions[dim];
    else if ((0, $43e0a445ed6711da$export$b5a638e9b3fff9f3)(dimsByName, dim)) return dimsByName[dim];
}
function $b3d05d3fca143040$var$cloneAllDimensionInfo(dimensions) {
    return (0, $43e0a445ed6711da$export$9cd59f9826255e47)(dimensions);
}
var $b3d05d3fca143040$var$externalTransformMap = (0, $43e0a445ed6711da$export$55f8aa7ef875b0a4)();
function $b3d05d3fca143040$export$92c96c6d8b255b7d(externalTransform) {
    externalTransform = (0, $43e0a445ed6711da$export$9cd59f9826255e47)(externalTransform);
    var type = externalTransform.type;
    var errMsg = "";
    if (!type) (0, $51c99d7efb19f4a2$export$8bf7aba4a9e09055)(errMsg);
    var typeParsed = type.split(":");
    if (typeParsed.length !== 2) (0, $51c99d7efb19f4a2$export$8bf7aba4a9e09055)(errMsg);
    // Namespace 'echarts:xxx' is official namespace, where the transforms should
    // be called directly via 'xxx' rather than 'echarts:xxx'.
    var isBuiltIn = false;
    if (typeParsed[0] === "echarts") {
        type = typeParsed[1];
        isBuiltIn = true;
    }
    externalTransform.__isBuiltIn = isBuiltIn;
    $b3d05d3fca143040$var$externalTransformMap.set(type, externalTransform);
}
function $b3d05d3fca143040$export$42a68f09db16803f(rawTransOption, sourceList, infoForPrint) {
    var pipedTransOption = (0, $87f4a59ac66e0ee6$export$4f07b212a02c8051)(rawTransOption);
    var pipeLen = pipedTransOption.length;
    var errMsg = "";
    if (!pipeLen) (0, $51c99d7efb19f4a2$export$8bf7aba4a9e09055)(errMsg);
    for(var i = 0, len = pipeLen; i < len; i++){
        var transOption = pipedTransOption[i];
        sourceList = $b3d05d3fca143040$var$applySingleDataTransform(transOption, sourceList, infoForPrint, pipeLen === 1 ? null : i);
        // piped transform only support single input, except the fist one.
        // piped transform only support single output, except the last one.
        if (i !== len - 1) sourceList.length = Math.max(sourceList.length, 1);
    }
    return sourceList;
}
function $b3d05d3fca143040$var$applySingleDataTransform(transOption, upSourceList, infoForPrint, // If `pipeIndex` is null/undefined, no piped transform.
pipeIndex) {
    var errMsg = "";
    if (!upSourceList.length) (0, $51c99d7efb19f4a2$export$8bf7aba4a9e09055)(errMsg);
    if (!(0, $43e0a445ed6711da$export$a6cdc56e425d0d0a)(transOption)) (0, $51c99d7efb19f4a2$export$8bf7aba4a9e09055)(errMsg);
    var transType = transOption.type;
    var externalTransform = $b3d05d3fca143040$var$externalTransformMap.get(transType);
    if (!externalTransform) (0, $51c99d7efb19f4a2$export$8bf7aba4a9e09055)(errMsg);
    // Prepare source
    var extUpSourceList = (0, $43e0a445ed6711da$export$871de8747c9eaa88)(upSourceList, function(upSource) {
        return $b3d05d3fca143040$var$createExternalSource(upSource, externalTransform);
    });
    var resultList = (0, $87f4a59ac66e0ee6$export$4f07b212a02c8051)(externalTransform.transform({
        upstream: extUpSourceList[0],
        upstreamList: extUpSourceList,
        config: (0, $43e0a445ed6711da$export$9cd59f9826255e47)(transOption.config)
    }));
    var printStrArr;
    return (0, $43e0a445ed6711da$export$871de8747c9eaa88)(resultList, function(result, resultIndex) {
        var errMsg = "";
        if (!(0, $43e0a445ed6711da$export$a6cdc56e425d0d0a)(result)) (0, $51c99d7efb19f4a2$export$8bf7aba4a9e09055)(errMsg);
        if (!result.data) (0, $51c99d7efb19f4a2$export$8bf7aba4a9e09055)(errMsg);
        var sourceFormat = (0, $8bdec9fd4ba68d58$export$52a469afa4653e57)(result.data);
        if (!$b3d05d3fca143040$var$isSupportedSourceFormat(sourceFormat)) (0, $51c99d7efb19f4a2$export$8bf7aba4a9e09055)(errMsg);
        var resultMetaRawOption;
        var firstUpSource = upSourceList[0];
        /**
     * Intuitively, the end users known the content of the original `dataset.source`,
     * calucating the transform result in mind.
     * Suppose the original `dataset.source` is:
     * ```js
     * [
     *     ['product', '2012', '2013', '2014', '2015'],
     *     ['AAA', 41.1, 30.4, 65.1, 53.3],
     *     ['BBB', 86.5, 92.1, 85.7, 83.1],
     *     ['CCC', 24.1, 67.2, 79.5, 86.4]
     * ]
     * ```
     * The dimension info have to be detected from the source data.
     * Some of the transformers (like filter, sort) will follow the dimension info
     * of upstream, while others use new dimensions (like aggregate).
     * Transformer can output a field `dimensions` to define the its own output dimensions.
     * We also allow transformers to ignore the output `dimensions` field, and
     * inherit the upstream dimensions definition. It can reduce the burden of handling
     * dimensions in transformers.
     *
     * See also [DIMENSION_INHERIT_RULE] in `sourceManager.ts`.
     */ if (firstUpSource && resultIndex === 0 && !result.dimensions) {
            var startIndex = firstUpSource.startIndex;
            // We copy the header of upstream to the result, because:
            // (1) The returned data always does not contain header line and can not be used
            // as dimension-detection. In this case we can not use "detected dimensions" of
            // upstream directly, because it might be detected based on different `seriesLayoutBy`.
            // (2) We should support that the series read the upstream source in `seriesLayoutBy: 'row'`.
            // So the original detected header should be add to the result, otherwise they can not be read.
            if (startIndex) result.data = firstUpSource.data.slice(0, startIndex).concat(result.data);
            resultMetaRawOption = {
                seriesLayoutBy: (0, $bde9c82f7837f767$export$7b3f3c6551b4949b),
                sourceHeader: startIndex,
                dimensions: firstUpSource.metaRawOption.dimensions
            };
        } else resultMetaRawOption = {
            seriesLayoutBy: (0, $bde9c82f7837f767$export$7b3f3c6551b4949b),
            sourceHeader: 0,
            dimensions: result.dimensions
        };
        return (0, $8bdec9fd4ba68d58$export$1921362e86c73c88)(result.data, resultMetaRawOption, null);
    });
}
function $b3d05d3fca143040$var$isSupportedSourceFormat(sourceFormat) {
    return sourceFormat === (0, $bde9c82f7837f767$export$fcd62ebf51387903) || sourceFormat === (0, $bde9c82f7837f767$export$703ae8a2d83f441);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $b8b029dec8573db8$export$859a1fa4f1106aa0 = typeof Uint32Array === (0, $bde9c82f7837f767$export$5ba2cba1cb566d7a) ? Array : Uint32Array;
var $b8b029dec8573db8$export$78cf73566f32c185 = typeof Uint16Array === (0, $bde9c82f7837f767$export$5ba2cba1cb566d7a) ? Array : Uint16Array;
var $b8b029dec8573db8$export$b60d945128546f53 = typeof Int32Array === (0, $bde9c82f7837f767$export$5ba2cba1cb566d7a) ? Array : Int32Array;
var $b8b029dec8573db8$export$365b104db51a490a = typeof Float64Array === (0, $bde9c82f7837f767$export$5ba2cba1cb566d7a) ? Array : Float64Array;
/**
 * Multi dimensional data store
 */ var $b8b029dec8573db8$var$dataCtors = {
    "float": $b8b029dec8573db8$export$365b104db51a490a,
    "int": $b8b029dec8573db8$export$b60d945128546f53,
    // Ordinal data type can be string or int
    "ordinal": Array,
    "number": Array,
    "time": $b8b029dec8573db8$export$365b104db51a490a
};
var $b8b029dec8573db8$var$defaultDimValueGetters;
function $b8b029dec8573db8$var$getIndicesCtor(rawCount) {
    // The possible max value in this._indicies is always this._rawCount despite of filtering.
    return rawCount > 65535 ? $b8b029dec8573db8$export$859a1fa4f1106aa0 : $b8b029dec8573db8$export$78cf73566f32c185;
}
function $b8b029dec8573db8$var$cloneChunk(originalChunk) {
    var Ctor = originalChunk.constructor;
    // Only shallow clone is enough when Array.
    return Ctor === Array ? originalChunk.slice() : new Ctor(originalChunk);
}
function $b8b029dec8573db8$var$prepareStore(store, dimIdx, dimType, end, append) {
    var DataCtor = $b8b029dec8573db8$var$dataCtors[dimType || "float"];
    if (append) {
        var oldStore = store[dimIdx];
        var oldLen = oldStore && oldStore.length;
        if (!(oldLen === end)) {
            var newStore = new DataCtor(end);
            // The cost of the copy is probably inconsiderable
            // within the initial chunkSize.
            for(var j = 0; j < oldLen; j++)newStore[j] = oldStore[j];
            store[dimIdx] = newStore;
        }
    } else store[dimIdx] = new DataCtor(end);
}
/**
 * Basically, DataStore API keep immutable.
 */ var $b8b029dec8573db8$var$DataStore = /** @class */ function() {
    function DataStore() {
        this._chunks = [];
        // It will not be calculated until needed.
        this._rawExtent = [];
        // structure:
        //  `const extentOnFilterOnDimension = this._extent[dim][extentFilterKey]`
        this._extent = [];
        // Count after filtered.
        this._count = 0;
        this._rawCount = 0;
        this._calcDimNameToIdx = (0, $43e0a445ed6711da$export$55f8aa7ef875b0a4)();
    }
    /**
   * Initialize from data
   */ DataStore.prototype.initData = function(provider, inputDimensions, dimValueGetter) {
        this._provider = provider;
        // Clear
        this._chunks = [];
        this._indices = null;
        this.getRawIndex = this._getRawIdxIdentity;
        var source = provider.getSource();
        var defaultGetter = this.defaultDimValueGetter = $b8b029dec8573db8$var$defaultDimValueGetters[source.sourceFormat];
        // Default dim value getter
        this._dimValueGetter = dimValueGetter || defaultGetter;
        // Reset raw extent.
        this._rawExtent = [];
        var willRetrieveDataByName = (0, $8bdec9fd4ba68d58$export$8911336b527f8517)(source);
        this._dimensions = (0, $43e0a445ed6711da$export$871de8747c9eaa88)(inputDimensions, function(dim) {
            return {
                // Only pick these two props. Not leak other properties like orderMeta.
                type: dim.type,
                property: dim.property
            };
        });
        this._initDataFromProvider(0, provider.count());
    };
    DataStore.prototype.getProvider = function() {
        return this._provider;
    };
    /**
   * Caution: even when a `source` instance owned by a series, the created data store
   * may still be shared by different sereis (the source hash does not use all `source`
   * props, see `sourceManager`). In this case, the `source` props that are not used in
   * hash (like `source.dimensionDefine`) probably only belongs to a certain series and
   * thus should not be fetch here.
   */ DataStore.prototype.getSource = function() {
        return this._provider.getSource();
    };
    /**
   * @caution Only used in dataStack.
   */ DataStore.prototype.ensureCalculationDimension = function(dimName, type) {
        var calcDimNameToIdx = this._calcDimNameToIdx;
        var dimensions = this._dimensions;
        var calcDimIdx = calcDimNameToIdx.get(dimName);
        if (calcDimIdx != null) {
            if (dimensions[calcDimIdx].type === type) return calcDimIdx;
        } else calcDimIdx = dimensions.length;
        dimensions[calcDimIdx] = {
            type: type
        };
        calcDimNameToIdx.set(dimName, calcDimIdx);
        this._chunks[calcDimIdx] = new $b8b029dec8573db8$var$dataCtors[type || "float"](this._rawCount);
        this._rawExtent[calcDimIdx] = (0, $87f4a59ac66e0ee6$export$62e5f07ab009f3b)();
        return calcDimIdx;
    };
    DataStore.prototype.collectOrdinalMeta = function(dimIdx, ordinalMeta) {
        var chunk = this._chunks[dimIdx];
        var dim = this._dimensions[dimIdx];
        var rawExtents = this._rawExtent;
        var offset = dim.ordinalOffset || 0;
        var len = chunk.length;
        if (offset === 0) // We need to reset the rawExtent if collect is from start.
        // Because this dimension may be guessed as number and calcuating a wrong extent.
        rawExtents[dimIdx] = (0, $87f4a59ac66e0ee6$export$62e5f07ab009f3b)();
        var dimRawExtent = rawExtents[dimIdx];
        // Parse from previous data offset. len may be changed after appendData
        for(var i = offset; i < len; i++){
            // See also CATEGORY_AXIS_MODEL_DATA_IS_EMPTY_ARRAY.
            var val = chunk[i] = ordinalMeta.parseAndCollect(chunk[i]);
            if (!isNaN(val)) {
                dimRawExtent[0] = Math.min(val, dimRawExtent[0]);
                dimRawExtent[1] = Math.max(val, dimRawExtent[1]);
            }
        }
        dim.ordinalMeta = ordinalMeta;
        dim.ordinalOffset = len;
        dim.type = "ordinal"; // Force to be ordinal
    };
    DataStore.prototype.getOrdinalMeta = function(dimIdx) {
        var dimInfo = this._dimensions[dimIdx];
        var ordinalMeta = dimInfo.ordinalMeta;
        return ordinalMeta;
    };
    DataStore.prototype.getDimensionProperty = function(dimIndex) {
        var item = this._dimensions[dimIndex];
        return item && item.property;
    };
    /**
   * Caution: Can be only called on raw data (before `this._indices` created).
   */ DataStore.prototype.appendData = function(data) {
        var provider = this._provider;
        var start = this.count();
        provider.appendData(data);
        var end = provider.count();
        if (!provider.persistent) end += start;
        if (start < end) this._initDataFromProvider(start, end, true);
        return [
            start,
            end
        ];
    };
    DataStore.prototype.appendValues = function(values, minFillLen) {
        var chunks = this._chunks;
        var dimensions = this._dimensions;
        var dimLen = dimensions.length;
        var rawExtent = this._rawExtent;
        var start = this.count();
        var end = start + Math.max(values.length, minFillLen || 0);
        for(var i = 0; i < dimLen; i++){
            var dim = dimensions[i];
            $b8b029dec8573db8$var$prepareStore(chunks, i, dim.type, end, true);
        }
        var emptyDataItem = [];
        for(var idx = start; idx < end; idx++){
            var sourceIdx = idx - start;
            // Store the data by dimensions
            for(var dimIdx = 0; dimIdx < dimLen; dimIdx++){
                var dim = dimensions[dimIdx];
                var val = $b8b029dec8573db8$var$defaultDimValueGetters.arrayRows.call(this, values[sourceIdx] || emptyDataItem, dim.property, sourceIdx, dimIdx);
                chunks[dimIdx][idx] = val;
                var dimRawExtent = rawExtent[dimIdx];
                val < dimRawExtent[0] && (dimRawExtent[0] = val);
                val > dimRawExtent[1] && (dimRawExtent[1] = val);
            }
        }
        this._rawCount = this._count = end;
        return {
            start: start,
            end: end
        };
    };
    DataStore.prototype._initDataFromProvider = function(start, end, append) {
        var provider = this._provider;
        var chunks = this._chunks;
        var dimensions = this._dimensions;
        var dimLen = dimensions.length;
        var rawExtent = this._rawExtent;
        var dimNames = (0, $43e0a445ed6711da$export$871de8747c9eaa88)(dimensions, function(dim) {
            return dim.property;
        });
        for(var i = 0; i < dimLen; i++){
            var dim = dimensions[i];
            if (!rawExtent[i]) rawExtent[i] = (0, $87f4a59ac66e0ee6$export$62e5f07ab009f3b)();
            $b8b029dec8573db8$var$prepareStore(chunks, i, dim.type, end, append);
        }
        if (provider.fillStorage) provider.fillStorage(start, end, chunks, rawExtent);
        else {
            var dataItem = [];
            for(var idx = start; idx < end; idx++){
                // NOTICE: Try not to write things into dataItem
                dataItem = provider.getItem(idx, dataItem);
                // Each data item is value
                // [1, 2]
                // 2
                // Bar chart, line chart which uses category axis
                // only gives the 'y' value. 'x' value is the indices of category
                // Use a tempValue to normalize the value to be a (x, y) value
                // Store the data by dimensions
                for(var dimIdx = 0; dimIdx < dimLen; dimIdx++){
                    var dimStorage = chunks[dimIdx];
                    // PENDING NULL is empty or zero
                    var val = this._dimValueGetter(dataItem, dimNames[dimIdx], idx, dimIdx);
                    dimStorage[idx] = val;
                    var dimRawExtent = rawExtent[dimIdx];
                    val < dimRawExtent[0] && (dimRawExtent[0] = val);
                    val > dimRawExtent[1] && (dimRawExtent[1] = val);
                }
            }
        }
        if (!provider.persistent && provider.clean) // Clean unused data if data source is typed array.
        provider.clean();
        this._rawCount = this._count = end;
        // Reset data extent
        this._extent = [];
    };
    DataStore.prototype.count = function() {
        return this._count;
    };
    /**
   * Get value. Return NaN if idx is out of range.
   */ DataStore.prototype.get = function(dim, idx) {
        if (!(idx >= 0 && idx < this._count)) return NaN;
        var dimStore = this._chunks[dim];
        return dimStore ? dimStore[this.getRawIndex(idx)] : NaN;
    };
    DataStore.prototype.getValues = function(dimensions, idx) {
        var values = [];
        var dimArr = [];
        if (idx == null) {
            idx = dimensions;
            // TODO get all from store?
            dimensions = [];
            // All dimensions
            for(var i = 0; i < this._dimensions.length; i++)dimArr.push(i);
        } else dimArr = dimensions;
        for(var i = 0, len = dimArr.length; i < len; i++)values.push(this.get(dimArr[i], idx));
        return values;
    };
    /**
   * @param dim concrete dim
   */ DataStore.prototype.getByRawIndex = function(dim, rawIdx) {
        if (!(rawIdx >= 0 && rawIdx < this._rawCount)) return NaN;
        var dimStore = this._chunks[dim];
        return dimStore ? dimStore[rawIdx] : NaN;
    };
    /**
   * Get sum of data in one dimension
   */ DataStore.prototype.getSum = function(dim) {
        var dimData = this._chunks[dim];
        var sum = 0;
        if (dimData) for(var i = 0, len = this.count(); i < len; i++){
            var value = this.get(dim, i);
            if (!isNaN(value)) sum += value;
        }
        return sum;
    };
    /**
   * Get median of data in one dimension
   */ DataStore.prototype.getMedian = function(dim) {
        var dimDataArray = [];
        // map all data of one dimension
        this.each([
            dim
        ], function(val) {
            if (!isNaN(val)) dimDataArray.push(val);
        });
        // TODO
        // Use quick select?
        (0, $b49750109e236fd8$export$debe6e778e0a6d32)(dimDataArray);
        var len = this.count();
        // calculate median
        return len === 0 ? 0 : len % 2 === 1 ? dimDataArray[(len - 1) / 2] : (dimDataArray[len / 2] + dimDataArray[len / 2 - 1]) / 2;
    };
    /**
   * Retrieve the index with given raw data index.
   */ DataStore.prototype.indexOfRawIndex = function(rawIndex) {
        if (rawIndex >= this._rawCount || rawIndex < 0) return -1;
        if (!this._indices) return rawIndex;
        // Indices are ascending
        var indices = this._indices;
        // If rawIndex === dataIndex
        var rawDataIndex = indices[rawIndex];
        if (rawDataIndex != null && rawDataIndex < this._count && rawDataIndex === rawIndex) return rawIndex;
        var left = 0;
        var right = this._count - 1;
        while(left <= right){
            var mid = (left + right) / 2 | 0;
            if (indices[mid] < rawIndex) left = mid + 1;
            else if (indices[mid] > rawIndex) right = mid - 1;
            else return mid;
        }
        return -1;
    };
    DataStore.prototype.getIndices = function() {
        var newIndices;
        var indices = this._indices;
        if (indices) {
            var Ctor = indices.constructor;
            var thisCount = this._count;
            // `new Array(a, b, c)` is different from `new Uint32Array(a, b, c)`.
            if (Ctor === Array) {
                newIndices = new Ctor(thisCount);
                for(var i = 0; i < thisCount; i++)newIndices[i] = indices[i];
            } else newIndices = new Ctor(indices.buffer, 0, thisCount);
        } else {
            var Ctor = $b8b029dec8573db8$var$getIndicesCtor(this._rawCount);
            newIndices = new Ctor(this.count());
            for(var i = 0; i < newIndices.length; i++)newIndices[i] = i;
        }
        return newIndices;
    };
    /**
   * [NOTICE]: Performance-sensitive for large data.
   */ DataStore.prototype.filter = function(dims, cb) {
        if (!this._count) return this;
        var newStore = this.clone();
        var count = newStore.count();
        var Ctor = $b8b029dec8573db8$var$getIndicesCtor(newStore._rawCount);
        var newIndices = new Ctor(count);
        var value = [];
        var dimSize = dims.length;
        var offset = 0;
        var dim0 = dims[0];
        var chunks = newStore._chunks;
        for(var i = 0; i < count; i++){
            var keep = void 0;
            var rawIdx = newStore.getRawIndex(i);
            // Simple optimization
            if (dimSize === 0) keep = cb(i);
            else if (dimSize === 1) {
                var val = chunks[dim0][rawIdx];
                keep = cb(val, i);
            } else {
                var k = 0;
                for(; k < dimSize; k++)value[k] = chunks[dims[k]][rawIdx];
                value[k] = i;
                keep = cb.apply(null, value);
            }
            if (keep) newIndices[offset++] = rawIdx;
        }
        // Set indices after filtered.
        if (offset < count) newStore._indices = newIndices;
        newStore._count = offset;
        // Reset data extent
        newStore._extent = [];
        newStore._updateGetRawIdx();
        return newStore;
    };
    /**
   * Select data in range. (For optimization of filter)
   * (Manually inline code, support 5 million data filtering in data zoom.)
   */ DataStore.prototype.selectRange = function(range) {
        var newStore = this.clone();
        var len = newStore._count;
        if (!len) return this;
        var dims = (0, $43e0a445ed6711da$export$ed97f33186d4b816)(range);
        var dimSize = dims.length;
        if (!dimSize) return this;
        var originalCount = newStore.count();
        var Ctor = $b8b029dec8573db8$var$getIndicesCtor(newStore._rawCount);
        var newIndices = new Ctor(originalCount);
        var offset = 0;
        var dim0 = dims[0];
        var min = range[dim0][0];
        var max = range[dim0][1];
        var storeArr = newStore._chunks;
        var quickFinished = false;
        if (!newStore._indices) {
            // Extreme optimization for common case. About 2x faster in chrome.
            var idx = 0;
            if (dimSize === 1) {
                var dimStorage = storeArr[dims[0]];
                for(var i = 0; i < len; i++){
                    var val = dimStorage[i];
                    // NaN will not be filtered. Consider the case, in line chart, empty
                    // value indicates the line should be broken. But for the case like
                    // scatter plot, a data item with empty value will not be rendered,
                    // but the axis extent may be effected if some other dim of the data
                    // item has value. Fortunately it is not a significant negative effect.
                    if (val >= min && val <= max || isNaN(val)) newIndices[offset++] = idx;
                    idx++;
                }
                quickFinished = true;
            } else if (dimSize === 2) {
                var dimStorage = storeArr[dims[0]];
                var dimStorage2 = storeArr[dims[1]];
                var min2 = range[dims[1]][0];
                var max2 = range[dims[1]][1];
                for(var i = 0; i < len; i++){
                    var val = dimStorage[i];
                    var val2 = dimStorage2[i];
                    // Do not filter NaN, see comment above.
                    if ((val >= min && val <= max || isNaN(val)) && (val2 >= min2 && val2 <= max2 || isNaN(val2))) newIndices[offset++] = idx;
                    idx++;
                }
                quickFinished = true;
            }
        }
        if (!quickFinished) {
            if (dimSize === 1) for(var i = 0; i < originalCount; i++){
                var rawIndex = newStore.getRawIndex(i);
                var val = storeArr[dims[0]][rawIndex];
                // Do not filter NaN, see comment above.
                if (val >= min && val <= max || isNaN(val)) newIndices[offset++] = rawIndex;
            }
            else for(var i = 0; i < originalCount; i++){
                var keep = true;
                var rawIndex = newStore.getRawIndex(i);
                for(var k = 0; k < dimSize; k++){
                    var dimk = dims[k];
                    var val = storeArr[dimk][rawIndex];
                    // Do not filter NaN, see comment above.
                    if (val < range[dimk][0] || val > range[dimk][1]) keep = false;
                }
                if (keep) newIndices[offset++] = newStore.getRawIndex(i);
            }
        }
        // Set indices after filtered.
        if (offset < originalCount) newStore._indices = newIndices;
        newStore._count = offset;
        // Reset data extent
        newStore._extent = [];
        newStore._updateGetRawIdx();
        return newStore;
    };
    // /**
    //  * Data mapping to a plain array
    //  */
    // mapArray(dims: DimensionIndex[], cb: MapArrayCb): any[] {
    //     const result: any[] = [];
    //     this.each(dims, function () {
    //         result.push(cb && (cb as MapArrayCb).apply(null, arguments));
    //     });
    //     return result;
    // }
    /**
   * Data mapping to a new List with given dimensions
   */ DataStore.prototype.map = function(dims, cb) {
        // TODO only clone picked chunks.
        var target = this.clone(dims);
        this._updateDims(target, dims, cb);
        return target;
    };
    /**
   * @caution Danger!! Only used in dataStack.
   */ DataStore.prototype.modify = function(dims, cb) {
        this._updateDims(this, dims, cb);
    };
    DataStore.prototype._updateDims = function(target, dims, cb) {
        var targetChunks = target._chunks;
        var tmpRetValue = [];
        var dimSize = dims.length;
        var dataCount = target.count();
        var values = [];
        var rawExtent = target._rawExtent;
        for(var i = 0; i < dims.length; i++)rawExtent[dims[i]] = (0, $87f4a59ac66e0ee6$export$62e5f07ab009f3b)();
        for(var dataIndex = 0; dataIndex < dataCount; dataIndex++){
            var rawIndex = target.getRawIndex(dataIndex);
            for(var k = 0; k < dimSize; k++)values[k] = targetChunks[dims[k]][rawIndex];
            values[dimSize] = dataIndex;
            var retValue = cb && cb.apply(null, values);
            if (retValue != null) {
                // a number or string (in ordinal dimension)?
                if (typeof retValue !== "object") {
                    tmpRetValue[0] = retValue;
                    retValue = tmpRetValue;
                }
                for(var i = 0; i < retValue.length; i++){
                    var dim = dims[i];
                    var val = retValue[i];
                    var rawExtentOnDim = rawExtent[dim];
                    var dimStore = targetChunks[dim];
                    if (dimStore) dimStore[rawIndex] = val;
                    if (val < rawExtentOnDim[0]) rawExtentOnDim[0] = val;
                    if (val > rawExtentOnDim[1]) rawExtentOnDim[1] = val;
                }
            }
        }
    };
    /**
   * Large data down sampling using largest-triangle-three-buckets
   * @param {string} valueDimension
   * @param {number} targetCount
   */ DataStore.prototype.lttbDownSample = function(valueDimension, rate) {
        var target = this.clone([
            valueDimension
        ], true);
        var targetStorage = target._chunks;
        var dimStore = targetStorage[valueDimension];
        var len = this.count();
        var sampledIndex = 0;
        var frameSize = Math.floor(1 / rate);
        var currentRawIndex = this.getRawIndex(0);
        var maxArea;
        var area;
        var nextRawIndex;
        var newIndices = new ($b8b029dec8573db8$var$getIndicesCtor(this._rawCount))(Math.min((Math.ceil(len / frameSize) + 2) * 2, len));
        // First frame use the first data.
        newIndices[sampledIndex++] = currentRawIndex;
        for(var i = 1; i < len - 1; i += frameSize){
            var nextFrameStart = Math.min(i + frameSize, len - 1);
            var nextFrameEnd = Math.min(i + frameSize * 2, len);
            var avgX = (nextFrameEnd + nextFrameStart) / 2;
            var avgY = 0;
            for(var idx = nextFrameStart; idx < nextFrameEnd; idx++){
                var rawIndex = this.getRawIndex(idx);
                var y = dimStore[rawIndex];
                if (isNaN(y)) continue;
                avgY += y;
            }
            avgY /= nextFrameEnd - nextFrameStart;
            var frameStart = i;
            var frameEnd = Math.min(i + frameSize, len);
            var pointAX = i - 1;
            var pointAY = dimStore[currentRawIndex];
            maxArea = -1;
            nextRawIndex = frameStart;
            var firstNaNIndex = -1;
            var countNaN = 0;
            // Find a point from current frame that construct a triangle with largest area with previous selected point
            // And the average of next frame.
            for(var idx = frameStart; idx < frameEnd; idx++){
                var rawIndex = this.getRawIndex(idx);
                var y = dimStore[rawIndex];
                if (isNaN(y)) {
                    countNaN++;
                    if (firstNaNIndex < 0) firstNaNIndex = rawIndex;
                    continue;
                }
                // Calculate triangle area over three buckets
                area = Math.abs((pointAX - avgX) * (y - pointAY) - (pointAX - idx) * (avgY - pointAY));
                if (area > maxArea) {
                    maxArea = area;
                    nextRawIndex = rawIndex; // Next a is this b
                }
            }
            if (countNaN > 0 && countNaN < frameEnd - frameStart) {
                // Append first NaN point in every bucket.
                // It is necessary to ensure the correct order of indices.
                newIndices[sampledIndex++] = Math.min(firstNaNIndex, nextRawIndex);
                nextRawIndex = Math.max(firstNaNIndex, nextRawIndex);
            }
            newIndices[sampledIndex++] = nextRawIndex;
            currentRawIndex = nextRawIndex; // This a is the next a (chosen b)
        }
        // First frame use the last data.
        newIndices[sampledIndex++] = this.getRawIndex(len - 1);
        target._count = sampledIndex;
        target._indices = newIndices;
        target.getRawIndex = this._getRawIdx;
        return target;
    };
    /**
   * Large data down sampling using min-max
   * @param {string} valueDimension
   * @param {number} rate
   */ DataStore.prototype.minmaxDownSample = function(valueDimension, rate) {
        var target = this.clone([
            valueDimension
        ], true);
        var targetStorage = target._chunks;
        var frameSize = Math.floor(1 / rate);
        var dimStore = targetStorage[valueDimension];
        var len = this.count();
        // Each frame results in 2 data points, one for min and one for max
        var newIndices = new ($b8b029dec8573db8$var$getIndicesCtor(this._rawCount))(Math.ceil(len / frameSize) * 2);
        var offset = 0;
        for(var i = 0; i < len; i += frameSize){
            var minIndex = i;
            var minValue = dimStore[this.getRawIndex(minIndex)];
            var maxIndex = i;
            var maxValue = dimStore[this.getRawIndex(maxIndex)];
            var thisFrameSize = frameSize;
            // Handle final smaller frame
            if (i + frameSize > len) thisFrameSize = len - i;
            // Determine min and max within the current frame
            for(var k = 0; k < thisFrameSize; k++){
                var rawIndex = this.getRawIndex(i + k);
                var value = dimStore[rawIndex];
                if (value < minValue) {
                    minValue = value;
                    minIndex = i + k;
                }
                if (value > maxValue) {
                    maxValue = value;
                    maxIndex = i + k;
                }
            }
            var rawMinIndex = this.getRawIndex(minIndex);
            var rawMaxIndex = this.getRawIndex(maxIndex);
            // Set the order of the min and max values, based on their ordering in the frame
            if (minIndex < maxIndex) {
                newIndices[offset++] = rawMinIndex;
                newIndices[offset++] = rawMaxIndex;
            } else {
                newIndices[offset++] = rawMaxIndex;
                newIndices[offset++] = rawMinIndex;
            }
        }
        target._count = offset;
        target._indices = newIndices;
        target._updateGetRawIdx();
        return target;
    };
    /**
   * Large data down sampling on given dimension
   * @param sampleIndex Sample index for name and id
   */ DataStore.prototype.downSample = function(dimension, rate, sampleValue, sampleIndex) {
        var target = this.clone([
            dimension
        ], true);
        var targetStorage = target._chunks;
        var frameValues = [];
        var frameSize = Math.floor(1 / rate);
        var dimStore = targetStorage[dimension];
        var len = this.count();
        var rawExtentOnDim = target._rawExtent[dimension] = (0, $87f4a59ac66e0ee6$export$62e5f07ab009f3b)();
        var newIndices = new ($b8b029dec8573db8$var$getIndicesCtor(this._rawCount))(Math.ceil(len / frameSize));
        var offset = 0;
        for(var i = 0; i < len; i += frameSize){
            // Last frame
            if (frameSize > len - i) {
                frameSize = len - i;
                frameValues.length = frameSize;
            }
            for(var k = 0; k < frameSize; k++){
                var dataIdx = this.getRawIndex(i + k);
                frameValues[k] = dimStore[dataIdx];
            }
            var value = sampleValue(frameValues);
            var sampleFrameIdx = this.getRawIndex(Math.min(i + sampleIndex(frameValues, value) || 0, len - 1));
            // Only write value on the filtered data
            dimStore[sampleFrameIdx] = value;
            if (value < rawExtentOnDim[0]) rawExtentOnDim[0] = value;
            if (value > rawExtentOnDim[1]) rawExtentOnDim[1] = value;
            newIndices[offset++] = sampleFrameIdx;
        }
        target._count = offset;
        target._indices = newIndices;
        target._updateGetRawIdx();
        return target;
    };
    /**
   * Data iteration
   * @param ctx default this
   * @example
   *  list.each(0, function (x, idx) {});
   *  list.each([0, 1], function (x, y, idx) {});
   *  list.each(function (idx) {})
   */ DataStore.prototype.each = function(dims, cb) {
        if (!this._count) return;
        var dimSize = dims.length;
        var chunks = this._chunks;
        for(var i = 0, len = this.count(); i < len; i++){
            var rawIdx = this.getRawIndex(i);
            // Simple optimization
            switch(dimSize){
                case 0:
                    cb(i);
                    break;
                case 1:
                    cb(chunks[dims[0]][rawIdx], i);
                    break;
                case 2:
                    cb(chunks[dims[0]][rawIdx], chunks[dims[1]][rawIdx], i);
                    break;
                default:
                    var k = 0;
                    var value = [];
                    for(; k < dimSize; k++)value[k] = chunks[dims[k]][rawIdx];
                    // Index
                    value[k] = i;
                    cb.apply(null, value);
            }
        }
    };
    DataStore.prototype.getDataExtent = function(dim, filter) {
        // Make sure use concrete dim as cache name.
        var dimData = this._chunks[dim];
        var initialExtent = (0, $87f4a59ac66e0ee6$export$62e5f07ab009f3b)();
        if (!dimData) return initialExtent;
        // Make more strict checkings to ensure hitting cache.
        var currEnd = this.count();
        // Consider the most cases when using data zoom, `getDataExtent`
        // happened before filtering. We cache raw extent, which is not
        // necessary to be cleared and recalculated when restore data.
        var useRaw = !this._indices && !filter;
        if (useRaw) return this._rawExtent[dim].slice();
        // NOTE:
        //  - In logarithm axis, zero should be excluded, therefore the `extent[0]` should be less or equal
        //    than the min positive data item, which requires the special handling here.
        //  - "Filter non-positive values for logarithm axis" can also be implemented in a data processor
        //    but that requires more complicated code to not break all streams under the current architecture,
        //    therefore we simply implement it here.
        //  - Performance is sensitive for large data, therefore inline filters rather than cb is used here.
        var thisExtent = this._extent;
        var dimExtentRecord = thisExtent[dim] || (thisExtent[dim] = {});
        var filterParsed = (0, $33d0d4ceafa5e518$export$1b2aa782dfdf5700)(filter);
        var filterKey = filterParsed.key;
        var dimExtent = dimExtentRecord[filterKey];
        if (dimExtent) return dimExtent.slice();
        var min = initialExtent[0];
        var max = initialExtent[1];
        for(var i = 0; i < currEnd; i++){
            // NOTICE: Manually inline some code for performance of large data.
            var rawIdx = this.getRawIndex(i);
            var value = dimData[rawIdx];
            // NOTE: in most cases, filter does not exist.
            if (!filter || (0, $33d0d4ceafa5e518$export$49bf74cb3f1b6c80)(filterParsed, value)) {
                if (value < min) min = value;
                if (value > max) max = value;
            }
        }
        return dimExtentRecord[filterKey] = [
            min,
            max
        ];
    };
    /**
   * Get raw data item
   */ DataStore.prototype.getRawDataItem = function(idx) {
        var rawIdx = this.getRawIndex(idx);
        if (!this._provider.persistent) {
            var val = [];
            var chunks = this._chunks;
            for(var i = 0; i < chunks.length; i++)val.push(chunks[i][rawIdx]);
            return val;
        } else return this._provider.getItem(rawIdx);
    };
    /**
   * Clone shallow.
   *
   * @param clonedDims Determine which dims to clone. Will share the data if not specified.
   */ DataStore.prototype.clone = function(clonedDims, ignoreIndices) {
        var target = new DataStore();
        var chunks = this._chunks;
        var clonedDimsMap = clonedDims && (0, $43e0a445ed6711da$export$533b26079ad0b4b)(clonedDims, function(obj, dimIdx) {
            obj[dimIdx] = true;
            return obj;
        }, {});
        if (clonedDimsMap) for(var i = 0; i < chunks.length; i++)// Not clone if dim is not picked.
        target._chunks[i] = !clonedDimsMap[i] ? chunks[i] : $b8b029dec8573db8$var$cloneChunk(chunks[i]);
        else target._chunks = chunks;
        this._copyCommonProps(target);
        if (!ignoreIndices) target._indices = this._cloneIndices();
        target._updateGetRawIdx();
        return target;
    };
    DataStore.prototype._copyCommonProps = function(target) {
        target._count = this._count;
        target._rawCount = this._rawCount;
        target._provider = this._provider;
        target._dimensions = this._dimensions;
        target._extent = (0, $43e0a445ed6711da$export$9cd59f9826255e47)(this._extent);
        target._rawExtent = (0, $43e0a445ed6711da$export$9cd59f9826255e47)(this._rawExtent);
    };
    DataStore.prototype._cloneIndices = function() {
        if (this._indices) {
            var Ctor = this._indices.constructor;
            var indices = void 0;
            if (Ctor === Array) {
                var thisCount = this._indices.length;
                indices = new Ctor(thisCount);
                for(var i = 0; i < thisCount; i++)indices[i] = this._indices[i];
            } else indices = new Ctor(this._indices);
            return indices;
        }
        return null;
    };
    DataStore.prototype._getRawIdxIdentity = function(idx) {
        return idx;
    };
    DataStore.prototype._getRawIdx = function(idx) {
        if (idx < this._count && idx >= 0) return this._indices[idx];
        return -1;
    };
    DataStore.prototype._updateGetRawIdx = function() {
        this.getRawIndex = this._indices ? this._getRawIdx : this._getRawIdxIdentity;
    };
    DataStore.internalField = function() {
        function getDimValueSimply(dataItem, property, dataIndex, dimIndex) {
            return (0, $33d0d4ceafa5e518$export$cc7175145baad076)(dataItem[dimIndex], this._dimensions[dimIndex]);
        }
        $b8b029dec8573db8$var$defaultDimValueGetters = {
            arrayRows: getDimValueSimply,
            objectRows: function(dataItem, property, dataIndex, dimIndex) {
                return (0, $33d0d4ceafa5e518$export$cc7175145baad076)(dataItem[property], this._dimensions[dimIndex]);
            },
            keyedColumns: getDimValueSimply,
            original: function(dataItem, property, dataIndex, dimIndex) {
                // Performance sensitive, do not use modelUtil.getDataItemValue.
                // If dataItem is an plain object with no value field, the let `value`
                // will be assigned with the object, but it will be tread correctly
                // in the `convertValue`.
                var value = dataItem && (dataItem.value == null ? dataItem : dataItem.value);
                return (0, $33d0d4ceafa5e518$export$cc7175145baad076)(value instanceof Array ? value[dimIndex] : value, this._dimensions[dimIndex]);
            },
            typedArray: function(dataItem, property, dataIndex, dimIndex) {
                return dataItem[dimIndex];
            }
        };
    }();
    return DataStore;
}();
var $b8b029dec8573db8$export$2e2bcd8739ae039 = $b8b029dec8573db8$var$DataStore;



/**
 * [REQUIREMENT_MEMO]:
 * (0) `metaRawOption` means `dimensions`/`sourceHeader`/`seriesLayoutBy` in raw option.
 * (1) Keep support the feature: `metaRawOption` can be specified both on `series` and
 * `root-dataset`. Them on `series` has higher priority.
 * (2) Do not support to set `metaRawOption` on a `non-root-dataset`, because it might
 * confuse users: whether those props indicate how to visit the upstream source or visit
 * the transform result source, and some transforms has nothing to do with these props,
 * and some transforms might have multiple upstream.
 * (3) Transforms should specify `metaRawOption` in each output, just like they can be
 * declared in `root-dataset`.
 * (4) At present only support visit source in `SERIES_LAYOUT_BY_COLUMN` in transforms.
 * That is for reducing complexity in transforms.
 * PENDING: Whether to provide transposition transform?
 *
 * [IMPLEMENTAION_MEMO]:
 * "sourceVisitConfig" are calculated from `metaRawOption` and `data`.
 * They will not be calculated until `source` is about to be visited (to prevent from
 * duplicate calcuation). `source` is visited only in series and input to transforms.
 *
 * [DIMENSION_INHERIT_RULE]:
 * By default the dimensions are inherited from ancestors, unless a transform return
 * a new dimensions definition.
 * Consider the case:
 * ```js
 * dataset: [{
 *     source: [ ['Product', 'Sales', 'Prise'], ['Cookies', 321, 44.21], ...]
 * }, {
 *     transform: { type: 'filter', ... }
 * }]
 * dataset: [{
 *     dimension: ['Product', 'Sales', 'Prise'],
 *     source: [ ['Cookies', 321, 44.21], ...]
 * }, {
 *     transform: { type: 'filter', ... }
 * }]
 * ```
 * The two types of option should have the same behavior after transform.
 *
 *
 * [SCENARIO]:
 * (1) Provide source data directly:
 * ```js
 * series: {
 *     encode: {...},
 *     dimensions: [...]
 *     seriesLayoutBy: 'row',
 *     data: [[...]]
 * }
 * ```
 * (2) Series refer to dataset.
 * ```js
 * series: [{
 *     encode: {...}
 *     // Ignore datasetIndex means `datasetIndex: 0`
 *     // and the dimensions defination in dataset is used
 * }, {
 *     encode: {...},
 *     seriesLayoutBy: 'column',
 *     datasetIndex: 1
 * }]
 * ```
 * (3) dataset transform
 * ```js
 * dataset: [{
 *     source: [...]
 * }, {
 *     source: [...]
 * }, {
 *     // By default from 0.
 *     transform: { type: 'filter', config: {...} }
 * }, {
 *     // Piped.
 *     transform: [
 *         { type: 'filter', config: {...} },
 *         { type: 'sort', config: {...} }
 *     ]
 * }, {
 *     id: 'regressionData',
 *     fromDatasetIndex: 1,
 *     // Third-party transform
 *     transform: { type: 'ecStat:regression', config: {...} }
 * }, {
 *     // retrieve the extra result.
 *     id: 'regressionFormula',
 *     fromDatasetId: 'regressionData',
 *     fromTransformResult: 1
 * }]
 * ```
 */ var $432251f0b9a88ba7$export$af4db9ec7e200ea2 = /** @class */ function() {
    function SourceManager(sourceHost) {
        // Cached source. Do not repeat calculating if not dirty.
        this._sourceList = [];
        this._storeList = [];
        // version sign of each upstream source manager.
        this._upstreamSignList = [];
        this._versionSignBase = 0;
        this._dirty = true;
        this._sourceHost = sourceHost;
    }
    /**
   * Mark dirty.
   */ SourceManager.prototype.dirty = function() {
        this._setLocalSource([], []);
        this._storeList = [];
        this._dirty = true;
    };
    SourceManager.prototype._setLocalSource = function(sourceList, upstreamSignList) {
        this._sourceList = sourceList;
        this._upstreamSignList = upstreamSignList;
        this._versionSignBase++;
        if (this._versionSignBase > 9e10) this._versionSignBase = 0;
    };
    /**
   * For detecting whether the upstream source is dirty, so that
   * the local cached source (in `_sourceList`) should be discarded.
   */ SourceManager.prototype._getVersionSign = function() {
        return this._sourceHost.uid + "_" + this._versionSignBase;
    };
    /**
   * Always return a source instance. Otherwise throw error.
   */ SourceManager.prototype.prepareSource = function() {
        // For the case that call `setOption` multiple time but no data changed,
        // cache the result source to prevent from repeating transform.
        if (this._isDirty()) {
            this._createSource();
            this._dirty = false;
        }
    };
    SourceManager.prototype._createSource = function() {
        this._setLocalSource([], []);
        var sourceHost = this._sourceHost;
        var upSourceMgrList = this._getUpstreamSourceManagers();
        var hasUpstream = !!upSourceMgrList.length;
        var resultSourceList;
        var upstreamSignList;
        if ($432251f0b9a88ba7$var$isSeries(sourceHost)) {
            var seriesModel = sourceHost;
            var data = void 0;
            var sourceFormat = void 0;
            var upSource = void 0;
            // Has upstream dataset
            if (hasUpstream) {
                var upSourceMgr = upSourceMgrList[0];
                upSourceMgr.prepareSource();
                upSource = upSourceMgr.getSource();
                data = upSource.data;
                sourceFormat = upSource.sourceFormat;
                upstreamSignList = [
                    upSourceMgr._getVersionSign()
                ];
            } else {
                data = seriesModel.get("data", true);
                sourceFormat = (0, $43e0a445ed6711da$export$b119cc7e1840e59c)(data) ? (0, $bde9c82f7837f767$export$a918cb016a382d45) : (0, $bde9c82f7837f767$export$2823037fb9d8f0c6);
                upstreamSignList = [];
            }
            // See [REQUIREMENT_MEMO], merge settings on series and parent dataset if it is root.
            var newMetaRawOption = this._getSourceMetaRawOption() || {};
            var upMetaRawOption = upSource && upSource.metaRawOption || {};
            var seriesLayoutBy = (0, $43e0a445ed6711da$export$995e01f2f5c9d030)(newMetaRawOption.seriesLayoutBy, upMetaRawOption.seriesLayoutBy) || null;
            var sourceHeader = (0, $43e0a445ed6711da$export$995e01f2f5c9d030)(newMetaRawOption.sourceHeader, upMetaRawOption.sourceHeader);
            // Note here we should not use `upSource.dimensionsDefine`. Consider the case:
            // `upSource.dimensionsDefine` is detected by `seriesLayoutBy: 'column'`,
            // but series need `seriesLayoutBy: 'row'`.
            var dimensions = (0, $43e0a445ed6711da$export$995e01f2f5c9d030)(newMetaRawOption.dimensions, upMetaRawOption.dimensions);
            // We share source with dataset as much as possible
            // to avoid extra memory cost of high dimensional data.
            var needsCreateSource = seriesLayoutBy !== upMetaRawOption.seriesLayoutBy || !!sourceHeader !== !!upMetaRawOption.sourceHeader || dimensions;
            resultSourceList = needsCreateSource ? [
                (0, $8bdec9fd4ba68d58$export$1921362e86c73c88)(data, {
                    seriesLayoutBy: seriesLayoutBy,
                    sourceHeader: sourceHeader,
                    dimensions: dimensions
                }, sourceFormat)
            ] : [];
        } else {
            var datasetModel = sourceHost;
            // Has upstream dataset.
            if (hasUpstream) {
                var result = this._applyTransform(upSourceMgrList);
                resultSourceList = result.sourceList;
                upstreamSignList = result.upstreamSignList;
            } else {
                var sourceData = datasetModel.get("source", true);
                resultSourceList = [
                    (0, $8bdec9fd4ba68d58$export$1921362e86c73c88)(sourceData, this._getSourceMetaRawOption(), null)
                ];
                upstreamSignList = [];
            }
        }
        this._setLocalSource(resultSourceList, upstreamSignList);
    };
    SourceManager.prototype._applyTransform = function(upMgrList) {
        var datasetModel = this._sourceHost;
        var transformOption = datasetModel.get("transform", true);
        var fromTransformResult = datasetModel.get("fromTransformResult", true);
        if (fromTransformResult != null) {
            var errMsg = "";
            if (upMgrList.length !== 1) $432251f0b9a88ba7$var$doThrow(errMsg);
        }
        var sourceList;
        var upSourceList = [];
        var upstreamSignList = [];
        (0, $43e0a445ed6711da$export$79b2f7037acddd43)(upMgrList, function(upMgr) {
            upMgr.prepareSource();
            var upSource = upMgr.getSource(fromTransformResult || 0);
            var errMsg = "";
            if (fromTransformResult != null && !upSource) $432251f0b9a88ba7$var$doThrow(errMsg);
            upSourceList.push(upSource);
            upstreamSignList.push(upMgr._getVersionSign());
        });
        if (transformOption) sourceList = (0, $b3d05d3fca143040$export$42a68f09db16803f)(transformOption, upSourceList, {
            datasetIndex: datasetModel.componentIndex
        });
        else if (fromTransformResult != null) sourceList = [
            (0, $8bdec9fd4ba68d58$export$e0365e7e3555ddd4)(upSourceList[0])
        ];
        return {
            sourceList: sourceList,
            upstreamSignList: upstreamSignList
        };
    };
    SourceManager.prototype._isDirty = function() {
        if (this._dirty) return true;
        // All sourceList is from the some upstream.
        var upSourceMgrList = this._getUpstreamSourceManagers();
        for(var i = 0; i < upSourceMgrList.length; i++){
            var upSrcMgr = upSourceMgrList[i];
            if (// Consider the case that there is ancestor diry, call it recursively.
            // The performance is probably not an issue because usually the chain is not long.
            upSrcMgr._isDirty() || this._upstreamSignList[i] !== upSrcMgr._getVersionSign()) return true;
        }
    };
    /**
   * @param sourceIndex By default 0, means "main source".
   *                    In most cases there is only one source.
   */ SourceManager.prototype.getSource = function(sourceIndex) {
        sourceIndex = sourceIndex || 0;
        var source = this._sourceList[sourceIndex];
        if (!source) {
            // Series may share source instance with dataset.
            var upSourceMgrList = this._getUpstreamSourceManagers();
            return upSourceMgrList[0] && upSourceMgrList[0].getSource(sourceIndex);
        }
        return source;
    };
    /**
   *
   * Get a data store which can be shared across series.
   * Only available for series.
   *
   * @param seriesDimRequest Dimensions that are generated in series.
   *        Should have been sorted by `storeDimIndex` asc.
   */ SourceManager.prototype.getSharedDataStore = function(seriesDimRequest) {
        var schema = seriesDimRequest.makeStoreSchema();
        return this._innerGetDataStore(schema.dimensions, seriesDimRequest.source, schema.hash);
    };
    SourceManager.prototype._innerGetDataStore = function(storeDims, seriesSource, sourceReadKey) {
        // TODO Can use other sourceIndex?
        var sourceIndex = 0;
        var storeList = this._storeList;
        var cachedStoreMap = storeList[sourceIndex];
        if (!cachedStoreMap) cachedStoreMap = storeList[sourceIndex] = {};
        var cachedStore = cachedStoreMap[sourceReadKey];
        if (!cachedStore) {
            var upSourceMgr = this._getUpstreamSourceManagers()[0];
            if ($432251f0b9a88ba7$var$isSeries(this._sourceHost) && upSourceMgr) cachedStore = upSourceMgr._innerGetDataStore(storeDims, seriesSource, sourceReadKey);
            else {
                cachedStore = new (0, $b8b029dec8573db8$export$2e2bcd8739ae039)();
                // Always create store from source of series.
                cachedStore.initData(new (0, $2e0ca4b2bac7e54a$export$b900d7c4c3952a40)(seriesSource, storeDims.length), storeDims);
            }
            cachedStoreMap[sourceReadKey] = cachedStore;
        }
        return cachedStore;
    };
    /**
   * PENDING: Is it fast enough?
   * If no upstream, return empty array.
   */ SourceManager.prototype._getUpstreamSourceManagers = function() {
        // Always get the relationship from the raw option.
        // Do not cache the link of the dependency graph, so that
        // there is no need to update them when change happens.
        var sourceHost = this._sourceHost;
        if ($432251f0b9a88ba7$var$isSeries(sourceHost)) {
            var datasetModel = (0, $a55589c1e81db35a$export$8da66f73a1eda454)(sourceHost);
            return !datasetModel ? [] : [
                datasetModel.getSourceManager()
            ];
        } else return (0, $43e0a445ed6711da$export$871de8747c9eaa88)((0, $a55589c1e81db35a$export$397ba553479711e7)(sourceHost), function(datasetModel) {
            return datasetModel.getSourceManager();
        });
    };
    SourceManager.prototype._getSourceMetaRawOption = function() {
        var sourceHost = this._sourceHost;
        var seriesLayoutBy;
        var sourceHeader;
        var dimensions;
        if ($432251f0b9a88ba7$var$isSeries(sourceHost)) {
            seriesLayoutBy = sourceHost.get("seriesLayoutBy", true);
            sourceHeader = sourceHost.get("sourceHeader", true);
            dimensions = sourceHost.get("dimensions", true);
        } else if (!this._getUpstreamSourceManagers().length) {
            var model = sourceHost;
            seriesLayoutBy = model.get("seriesLayoutBy", true);
            sourceHeader = model.get("sourceHeader", true);
            dimensions = model.get("dimensions", true);
        }
        return {
            seriesLayoutBy: seriesLayoutBy,
            sourceHeader: sourceHeader,
            dimensions: dimensions
        };
    };
    return SourceManager;
}();
function $432251f0b9a88ba7$export$9451f4e9047441ec(datasetModel) {
    var transformOption = datasetModel.option.transform;
    transformOption && (0, $43e0a445ed6711da$export$112e66431016387b)(datasetModel.option.transform);
}
function $432251f0b9a88ba7$var$isSeries(sourceHost) {
    // Avoid circular dependency with Series.ts
    return sourceHost.mainType === "series";
}
function $432251f0b9a88ba7$var$doThrow(errMsg) {
    throw new Error(errMsg);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $805c7be1c699f811$var$TOOLTIP_LINE_HEIGHT_CSS = "line-height:1";
function $805c7be1c699f811$var$getTooltipLineHeight(textStyle) {
    var lineHeight = textStyle.lineHeight;
    if (lineHeight == null) return $805c7be1c699f811$var$TOOLTIP_LINE_HEIGHT_CSS;
    else return "line-height:" + (0, $e2318d49eb46f886$export$f9d6449b9af28dc1)(lineHeight + "") + "px";
}
// TODO: more textStyle option
function $805c7be1c699f811$var$getTooltipTextStyle(textStyle, renderMode) {
    var nameFontColor = textStyle.color || (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.tertiary;
    var nameFontSize = textStyle.fontSize || 12;
    var nameFontWeight = textStyle.fontWeight || "400";
    var valueFontColor = textStyle.color || (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.secondary;
    var valueFontSize = textStyle.fontSize || 14;
    var valueFontWeight = textStyle.fontWeight || "900";
    if (renderMode === "html") // `textStyle` is probably from user input, should be encoded to reduce security risk.
    return {
        // eslint-disable-next-line max-len
        nameStyle: "font-size:" + (0, $e2318d49eb46f886$export$f9d6449b9af28dc1)(nameFontSize + "") + "px;color:" + (0, $e2318d49eb46f886$export$f9d6449b9af28dc1)(nameFontColor) + ";font-weight:" + (0, $e2318d49eb46f886$export$f9d6449b9af28dc1)(nameFontWeight + ""),
        // eslint-disable-next-line max-len
        valueStyle: "font-size:" + (0, $e2318d49eb46f886$export$f9d6449b9af28dc1)(valueFontSize + "") + "px;color:" + (0, $e2318d49eb46f886$export$f9d6449b9af28dc1)(valueFontColor) + ";font-weight:" + (0, $e2318d49eb46f886$export$f9d6449b9af28dc1)(valueFontWeight + "")
    };
    else return {
        nameStyle: {
            fontSize: nameFontSize,
            fill: nameFontColor,
            fontWeight: nameFontWeight
        },
        valueStyle: {
            fontSize: valueFontSize,
            fill: valueFontColor,
            fontWeight: valueFontWeight
        }
    };
}
// See `TooltipMarkupLayoutIntent['innerGapLevel']`.
// (value from UI design)
var $805c7be1c699f811$var$HTML_GAPS = [
    0,
    10,
    20,
    30
];
var $805c7be1c699f811$var$RICH_TEXT_GAPS = [
    "",
    "\n",
    "\n\n",
    "\n\n\n"
];
function $805c7be1c699f811$export$cf63b23ce77d1921(type, option) {
    option.type = type;
    return option;
}
function $805c7be1c699f811$var$isSectionFragment(frag) {
    return frag.type === "section";
}
function $805c7be1c699f811$var$getBuilder(frag) {
    return $805c7be1c699f811$var$isSectionFragment(frag) ? $805c7be1c699f811$var$buildSection : $805c7be1c699f811$var$buildNameValue;
}
function $805c7be1c699f811$var$getBlockGapLevel(frag) {
    if ($805c7be1c699f811$var$isSectionFragment(frag)) {
        var gapLevel_1 = 0;
        var subBlockLen = frag.blocks.length;
        var hasInnerGap_1 = subBlockLen > 1 || subBlockLen > 0 && !frag.noHeader;
        (0, $43e0a445ed6711da$export$79b2f7037acddd43)(frag.blocks, function(subBlock) {
            var subGapLevel = $805c7be1c699f811$var$getBlockGapLevel(subBlock);
            // If the some of the sub-blocks have some gaps (like 10px) inside, this block
            // should use a larger gap (like 20px) to distinguish those sub-blocks.
            if (subGapLevel >= gapLevel_1) gapLevel_1 = subGapLevel + +(hasInnerGap_1 && // 0 always can not be readable gap level.
            (!subGapLevel || $805c7be1c699f811$var$isSectionFragment(subBlock) && !subBlock.noHeader));
        });
        return gapLevel_1;
    }
    return 0;
}
function $805c7be1c699f811$var$buildSection(ctx, fragment, topMarginForOuterGap, toolTipTextStyle) {
    var noHeader = fragment.noHeader;
    var gaps = $805c7be1c699f811$var$getGap($805c7be1c699f811$var$getBlockGapLevel(fragment));
    var subMarkupTextList = [];
    var subBlocks = fragment.blocks || [];
    (0, $43e0a445ed6711da$export$a7a9523472993e97)(!subBlocks || (0, $43e0a445ed6711da$export$43bee75e5e14138e)(subBlocks));
    subBlocks = subBlocks || [];
    var orderMode = ctx.orderMode;
    if (fragment.sortBlocks && orderMode) {
        subBlocks = subBlocks.slice();
        var orderMap = {
            valueAsc: "asc",
            valueDesc: "desc"
        };
        if ((0, $43e0a445ed6711da$export$b5a638e9b3fff9f3)(orderMap, orderMode)) {
            var comparator_1 = new (0, $33d0d4ceafa5e518$export$ed75a5d7b0144167)(orderMap[orderMode], null);
            subBlocks.sort(function(a, b) {
                return comparator_1.evaluate(a.sortParam, b.sortParam);
            });
        } else if (orderMode === "seriesDesc") subBlocks.reverse();
    }
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)(subBlocks, function(subBlock, idx) {
        var valueFormatter = fragment.valueFormatter;
        var subMarkupText = $805c7be1c699f811$var$getBuilder(subBlock)(// Inherit valueFormatter
        valueFormatter ? (0, $43e0a445ed6711da$export$8b58be045bf06082)((0, $43e0a445ed6711da$export$8b58be045bf06082)({}, ctx), {
            valueFormatter: valueFormatter
        }) : ctx, subBlock, idx > 0 ? gaps.html : 0, toolTipTextStyle);
        subMarkupText != null && subMarkupTextList.push(subMarkupText);
    });
    var subMarkupText = ctx.renderMode === "richText" ? subMarkupTextList.join(gaps.richText) : $805c7be1c699f811$var$wrapBlockHTML(toolTipTextStyle, subMarkupTextList.join(""), noHeader ? topMarginForOuterGap : gaps.html);
    if (noHeader) return subMarkupText;
    var displayableHeader = (0, $78c2ece6dfa6bb7a$export$3cd8db88714decfc)(fragment.header, "ordinal", ctx.useUTC);
    var nameStyle = $805c7be1c699f811$var$getTooltipTextStyle(toolTipTextStyle, ctx.renderMode).nameStyle;
    var tooltipLineHeight = $805c7be1c699f811$var$getTooltipLineHeight(toolTipTextStyle);
    if (ctx.renderMode === "richText") return $805c7be1c699f811$var$wrapInlineNameRichText(ctx, displayableHeader, nameStyle) + gaps.richText + subMarkupText;
    else return $805c7be1c699f811$var$wrapBlockHTML(toolTipTextStyle, '<div style="' + nameStyle + ";" + tooltipLineHeight + ';">' + (0, $e2318d49eb46f886$export$f9d6449b9af28dc1)(displayableHeader) + "</div>" + subMarkupText, topMarginForOuterGap);
}
function $805c7be1c699f811$var$buildNameValue(ctx, fragment, topMarginForOuterGap, toolTipTextStyle) {
    var renderMode = ctx.renderMode;
    var noName = fragment.noName;
    var noValue = fragment.noValue;
    var noMarker = !fragment.markerType;
    var name = fragment.name;
    var useUTC = ctx.useUTC;
    var valueFormatter = fragment.valueFormatter || ctx.valueFormatter || function(value) {
        value = (0, $43e0a445ed6711da$export$43bee75e5e14138e)(value) ? value : [
            value
        ];
        return (0, $43e0a445ed6711da$export$871de8747c9eaa88)(value, function(val, idx) {
            return (0, $78c2ece6dfa6bb7a$export$3cd8db88714decfc)(val, (0, $43e0a445ed6711da$export$43bee75e5e14138e)(valueTypeOption) ? valueTypeOption[idx] : valueTypeOption, useUTC);
        });
    };
    if (noName && noValue) return;
    var markerStr = noMarker ? "" : ctx.markupStyleCreator.makeTooltipMarker(fragment.markerType, fragment.markerColor || (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.secondary, renderMode);
    var readableName = noName ? "" : (0, $78c2ece6dfa6bb7a$export$3cd8db88714decfc)(name, "ordinal", useUTC);
    var valueTypeOption = fragment.valueType;
    var readableValueList = noValue ? [] : valueFormatter(fragment.value, fragment.rawDataIndex);
    var valueAlignRight = !noMarker || !noName;
    // It little weird if only value next to marker but far from marker.
    var valueCloseToMarker = !noMarker && noName;
    var _a = $805c7be1c699f811$var$getTooltipTextStyle(toolTipTextStyle, renderMode), nameStyle = _a.nameStyle, valueStyle = _a.valueStyle;
    return renderMode === "richText" ? (noMarker ? "" : markerStr) + (noName ? "" : $805c7be1c699f811$var$wrapInlineNameRichText(ctx, readableName, nameStyle)) + (noValue ? "" : $805c7be1c699f811$var$wrapInlineValueRichText(ctx, readableValueList, valueAlignRight, valueCloseToMarker, valueStyle)) : $805c7be1c699f811$var$wrapBlockHTML(toolTipTextStyle, (noMarker ? "" : markerStr) + (noName ? "" : $805c7be1c699f811$var$wrapInlineNameHTML(readableName, !noMarker, nameStyle)) + (noValue ? "" : $805c7be1c699f811$var$wrapInlineValueHTML(readableValueList, valueAlignRight, valueCloseToMarker, valueStyle)), topMarginForOuterGap);
}
function $805c7be1c699f811$export$6969ffb02c1cb49a(fragment, markupStyleCreator, renderMode, orderMode, useUTC, toolTipTextStyle) {
    if (!fragment) return;
    var builder = $805c7be1c699f811$var$getBuilder(fragment);
    var ctx = {
        useUTC: useUTC,
        renderMode: renderMode,
        orderMode: orderMode,
        markupStyleCreator: markupStyleCreator,
        valueFormatter: fragment.valueFormatter
    };
    return builder(ctx, fragment, 0, toolTipTextStyle);
}
function $805c7be1c699f811$var$getGap(gapLevel) {
    return {
        html: $805c7be1c699f811$var$HTML_GAPS[gapLevel],
        richText: $805c7be1c699f811$var$RICH_TEXT_GAPS[gapLevel]
    };
}
function $805c7be1c699f811$var$wrapBlockHTML(textStyle, encodedContent, topGap) {
    var clearfix = '<div style="clear:both"></div>';
    var marginCSS = "margin: " + topGap + "px 0 0";
    var tooltipLineHeight = $805c7be1c699f811$var$getTooltipLineHeight(textStyle);
    return '<div style="' + marginCSS + ";" + tooltipLineHeight + ';">' + encodedContent + clearfix + "</div>";
}
function $805c7be1c699f811$var$wrapInlineNameHTML(name, leftHasMarker, style) {
    var marginCss = leftHasMarker ? "margin-left:2px" : "";
    return '<span style="' + style + ";" + marginCss + '">' + (0, $e2318d49eb46f886$export$f9d6449b9af28dc1)(name) + "</span>";
}
function $805c7be1c699f811$var$wrapInlineValueHTML(valueList, alignRight, valueCloseToMarker, style) {
    // Do not too close to marker, considering there are multiple values separated by spaces.
    var paddingStr = valueCloseToMarker ? "10px" : "20px";
    var alignCSS = alignRight ? "float:right;margin-left:" + paddingStr : "";
    valueList = (0, $43e0a445ed6711da$export$43bee75e5e14138e)(valueList) ? valueList : [
        valueList
    ];
    return '<span style="' + alignCSS + ";" + style + '">' + (0, $43e0a445ed6711da$export$871de8747c9eaa88)(valueList, function(value) {
        return (0, $e2318d49eb46f886$export$f9d6449b9af28dc1)(value);
    }).join("&nbsp;&nbsp;") + "</span>";
}
function $805c7be1c699f811$var$wrapInlineNameRichText(ctx, name, style) {
    return ctx.markupStyleCreator.wrapRichTextStyle(name, style);
}
function $805c7be1c699f811$var$wrapInlineValueRichText(ctx, values, alignRight, valueCloseToMarker, style) {
    var styles = [
        style
    ];
    var paddingLeft = valueCloseToMarker ? 10 : 20;
    alignRight && styles.push({
        padding: [
            0,
            0,
            0,
            paddingLeft
        ],
        align: "right"
    });
    // Value has commas inside, so use '  ' as delimiter for multiple values.
    return ctx.markupStyleCreator.wrapRichTextStyle((0, $43e0a445ed6711da$export$43bee75e5e14138e)(values) ? values.join("  ") : values, styles);
}
function $805c7be1c699f811$export$ea15628039c0fa93(series, dataIndex) {
    var style = series.getData().getItemVisual(dataIndex, "style");
    var color = style[series.visualDrawType];
    return (0, $78c2ece6dfa6bb7a$export$cda04d03233e5555)(color);
}
function $805c7be1c699f811$export$3048212c802df496(model, renderMode) {
    var padding = model.get("padding");
    return padding != null ? padding : renderMode === "richText" ? [
        8,
        10
    ] : 10;
}
/**
 * The major feature is generate styles for `renderMode: 'richText'`.
 * But it also serves `renderMode: 'html'` to provide
 * "renderMode-independent" API.
 */ var $805c7be1c699f811$export$2fba3afbcdcf3e18 = /** @class */ function() {
    function TooltipMarkupStyleCreator() {
        this.richTextStyles = {};
        // Notice that "generate a style name" usually happens repeatedly when mouse is moving and
        // a tooltip is displayed. So we put the `_nextStyleNameId` as a member of each creator
        // rather than static shared by all creators (which will cause it increase to fast).
        this._nextStyleNameId = (0, $b49750109e236fd8$export$474d2ec9aa44a22)();
    }
    TooltipMarkupStyleCreator.prototype._generateStyleName = function() {
        return "__EC_aUTo_" + this._nextStyleNameId++;
    };
    TooltipMarkupStyleCreator.prototype.makeTooltipMarker = function(markerType, colorStr, renderMode) {
        var markerId = renderMode === "richText" ? this._generateStyleName() : null;
        var marker = (0, $78c2ece6dfa6bb7a$export$1987a3dbdf3c45ca)({
            color: colorStr,
            type: markerType,
            renderMode: renderMode,
            markerId: markerId
        });
        if ((0, $43e0a445ed6711da$export$844ec244b1367d54)(marker)) return marker;
        else {
            this.richTextStyles[markerId] = marker.style;
            return marker.content;
        }
    };
    /**
   * @usage
   * ```ts
   * const styledText = markupStyleCreator.wrapRichTextStyle([
   *     // The styles will be auto merged.
   *     {
   *         fontSize: 12,
   *         color: 'blue'
   *     },
   *     {
   *         padding: 20
   *     }
   * ]);
   * ```
   */ TooltipMarkupStyleCreator.prototype.wrapRichTextStyle = function(text, styles) {
        var finalStl = {};
        if ((0, $43e0a445ed6711da$export$43bee75e5e14138e)(styles)) (0, $43e0a445ed6711da$export$79b2f7037acddd43)(styles, function(stl) {
            return (0, $43e0a445ed6711da$export$8b58be045bf06082)(finalStl, stl);
        });
        else (0, $43e0a445ed6711da$export$8b58be045bf06082)(finalStl, styles);
        var styleName = this._generateStyleName();
        this.richTextStyles[styleName] = finalStl;
        return "{" + styleName + "|" + text + "}";
    };
    return TooltipMarkupStyleCreator;
}();




function $4ca7aa25c8bbd5d4$export$3a110b9fb5c88b34(opt) {
    var series = opt.series;
    var dataIndex = opt.dataIndex;
    var multipleSeries = opt.multipleSeries;
    var data = series.getData();
    var tooltipDims = data.mapDimensionsAll("defaultedTooltip");
    var tooltipDimLen = tooltipDims.length;
    var value = series.getRawValue(dataIndex);
    var isValueArr = (0, $43e0a445ed6711da$export$43bee75e5e14138e)(value);
    var markerColor = (0, $805c7be1c699f811$export$ea15628039c0fa93)(series, dataIndex);
    // Complicated rule for pretty tooltip.
    var inlineValue;
    var inlineValueType;
    var subBlocks;
    var sortParam;
    if (tooltipDimLen > 1 || isValueArr && !tooltipDimLen) {
        var formatArrResult = $4ca7aa25c8bbd5d4$var$formatTooltipArrayValue(value, series, dataIndex, tooltipDims, markerColor);
        inlineValue = formatArrResult.inlineValues;
        inlineValueType = formatArrResult.inlineValueTypes;
        subBlocks = formatArrResult.blocks;
        // Only support tooltip sort by the first inline value. It's enough in most cases.
        sortParam = formatArrResult.inlineValues[0];
    } else if (tooltipDimLen) {
        var dimInfo = data.getDimensionInfo(tooltipDims[0]);
        sortParam = inlineValue = (0, $2e0ca4b2bac7e54a$export$cde9373da9aad801)(data, dataIndex, tooltipDims[0]);
        inlineValueType = dimInfo.type;
    } else sortParam = inlineValue = isValueArr ? value[0] : value;
    // Do not show generated series name. It might not be readable.
    var seriesNameSpecified = (0, $87f4a59ac66e0ee6$export$beae19a2652b3368)(series);
    var seriesName = seriesNameSpecified && series.name || "";
    var itemName = data.getName(dataIndex);
    var inlineName = multipleSeries ? seriesName : itemName;
    return (0, $805c7be1c699f811$export$cf63b23ce77d1921)("section", {
        header: seriesName,
        // When series name is not specified, do not show a header line with only '-'.
        // This case always happens in tooltip.trigger: 'item'.
        noHeader: multipleSeries || !seriesNameSpecified,
        sortParam: sortParam,
        blocks: [
            (0, $805c7be1c699f811$export$cf63b23ce77d1921)("nameValue", {
                markerType: "item",
                markerColor: markerColor,
                // Do not mix display seriesName and itemName in one tooltip,
                // which might confuses users.
                name: inlineName,
                // name dimension might be auto assigned, where the name might
                // be not readable. So we check trim here.
                noName: !(0, $43e0a445ed6711da$export$87c2784dc9fc4ab)(inlineName),
                value: inlineValue,
                valueType: inlineValueType,
                rawDataIndex: data.getRawIndex(dataIndex)
            })
        ].concat(subBlocks || [])
    });
}
function $4ca7aa25c8bbd5d4$var$formatTooltipArrayValue(value, series, dataIndex, tooltipDims, colorStr) {
    // check: category-no-encode-has-axis-data in dataset.html
    var data = series.getData();
    var isValueMultipleLine = (0, $43e0a445ed6711da$export$533b26079ad0b4b)(value, function(isValueMultipleLine, val, idx) {
        var dimItem = data.getDimensionInfo(idx);
        return isValueMultipleLine = isValueMultipleLine || dimItem && dimItem.tooltip !== false && dimItem.displayName != null;
    }, false);
    var inlineValues = [];
    var inlineValueTypes = [];
    var blocks = [];
    tooltipDims.length ? (0, $43e0a445ed6711da$export$79b2f7037acddd43)(tooltipDims, function(dim) {
        setEachItem((0, $2e0ca4b2bac7e54a$export$cde9373da9aad801)(data, dataIndex, dim), dim);
    }) : (0, $43e0a445ed6711da$export$79b2f7037acddd43)(value, setEachItem);
    function setEachItem(val, dim) {
        var dimInfo = data.getDimensionInfo(dim);
        // If `dimInfo.tooltip` is not set, show tooltip.
        if (!dimInfo || dimInfo.otherDims.tooltip === false) return;
        if (isValueMultipleLine) blocks.push((0, $805c7be1c699f811$export$cf63b23ce77d1921)("nameValue", {
            markerType: "subItem",
            markerColor: colorStr,
            name: dimInfo.displayName,
            value: val,
            valueType: dimInfo.type
        }));
        else {
            inlineValues.push(val);
            inlineValueTypes.push(dimInfo.type);
        }
    }
    return {
        inlineValues: inlineValues,
        inlineValueTypes: inlineValueTypes,
        blocks: blocks
    };
}


var $39002e2f499d7a2f$var$inner = $87f4a59ac66e0ee6$export$64df9f8d92ae083f();
function $39002e2f499d7a2f$var$getSelectionKey(data, dataIndex) {
    return data.getName(dataIndex) || data.getId(dataIndex);
}
var $39002e2f499d7a2f$export$e960441116ae2799 = "__universalTransitionEnabled";
var $39002e2f499d7a2f$var$SeriesModel = /** @class */ function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(SeriesModel, _super);
    function SeriesModel() {
        // [Caution]: Because this class or desecendants can be used as `XXX.extend(subProto)`,
        // the class members must not be initialized in constructor or declaration place.
        // Otherwise there is bad case:
        //   class A {xxx = 1;}
        //   enableClassExtend(A);
        //   class B extends A {}
        //   var C = B.extend({xxx: 5});
        //   var c = new C();
        //   console.log(c.xxx); // expect 5 but always 1.
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // ---------------------------------------
        // Props about data selection
        // ---------------------------------------
        _this._selectedDataIndicesMap = {};
        return _this;
    }
    SeriesModel.prototype.init = function(option, parentModel, ecModel) {
        this.seriesIndex = this.componentIndex;
        this.dataTask = (0, $eb04eaa34fbabb0a$export$f7292ab7796be73c)({
            count: $39002e2f499d7a2f$var$dataTaskCount,
            reset: $39002e2f499d7a2f$var$dataTaskReset
        });
        this.dataTask.context = {
            model: this
        };
        this.mergeDefaultAndTheme(option, ecModel);
        var sourceManager = $39002e2f499d7a2f$var$inner(this).sourceManager = new (0, $432251f0b9a88ba7$export$af4db9ec7e200ea2)(this);
        sourceManager.prepareSource();
        var data = this.getInitialData(option, ecModel);
        $39002e2f499d7a2f$var$wrapData(data, this);
        this.dataTask.context.data = data;
        $39002e2f499d7a2f$var$inner(this).dataBeforeProcessed = data;
        // If we reverse the order (make data firstly, and then make
        // dataBeforeProcessed by cloneShallow), cloneShallow will
        // cause data.graph.data !== data when using
        // module:echarts/data/Graph or module:echarts/data/Tree.
        // See module:echarts/data/helper/linkSeriesData
        // Theoretically, it is unreasonable to call `seriesModel.getData()` in the model
        // init or merge stage, because the data can be restored. So we do not `restoreData`
        // and `setData` here, which forbids calling `seriesModel.getData()` in this stage.
        // Call `seriesModel.getRawData()` instead.
        // this.restoreData();
        $39002e2f499d7a2f$var$autoSeriesName(this);
        this._initSelectedMapFromData(data);
    };
    /**
   * Util for merge default and theme to option
   */ SeriesModel.prototype.mergeDefaultAndTheme = function(option, ecModel) {
        var layoutMode = (0, $826bc4094efae72b$export$3968a28a7cbd6063)(this);
        var inputPositionParams = layoutMode ? (0, $826bc4094efae72b$export$4b0d20af19c9875e)(option) : {};
        // Backward compat: using subType on theme.
        // But if name duplicate between series subType
        // (for example: parallel) add component mainType,
        // add suffix 'Series'.
        var themeSubType = this.subType;
        if ((0, $4a9041b12b787d1b$export$2e2bcd8739ae039).hasClass(themeSubType)) themeSubType += "Series";
        $43e0a445ed6711da$export$4950aa0f605343fb(option, ecModel.getTheme().get(this.subType));
        $43e0a445ed6711da$export$4950aa0f605343fb(option, this.getDefaultOption());
        // Default label emphasis `show`
        $87f4a59ac66e0ee6$export$abdcc6a26372f94b(option, "label", [
            "show"
        ]);
        this.fillDataTextStyle(option.data);
        if (layoutMode) (0, $826bc4094efae72b$export$1754cb91f16ca028)(option, inputPositionParams, layoutMode);
    };
    SeriesModel.prototype.mergeOption = function(newSeriesOption, ecModel) {
        // this.settingTask.dirty();
        newSeriesOption = $43e0a445ed6711da$export$4950aa0f605343fb(this.option, newSeriesOption, true);
        this.fillDataTextStyle(newSeriesOption.data);
        var layoutMode = (0, $826bc4094efae72b$export$3968a28a7cbd6063)(this);
        if (layoutMode) (0, $826bc4094efae72b$export$1754cb91f16ca028)(this.option, newSeriesOption, layoutMode);
        var sourceManager = $39002e2f499d7a2f$var$inner(this).sourceManager;
        sourceManager.dirty();
        sourceManager.prepareSource();
        var data = this.getInitialData(newSeriesOption, ecModel);
        $39002e2f499d7a2f$var$wrapData(data, this);
        this.dataTask.dirty();
        this.dataTask.context.data = data;
        $39002e2f499d7a2f$var$inner(this).dataBeforeProcessed = data;
        $39002e2f499d7a2f$var$autoSeriesName(this);
        this._initSelectedMapFromData(data);
    };
    SeriesModel.prototype.fillDataTextStyle = function(data) {
        // Default data label emphasis `show`
        // FIXME Tree structure data ?
        // FIXME Performance ?
        if (data && !$43e0a445ed6711da$export$b119cc7e1840e59c(data)) {
            var props = [
                "show"
            ];
            for(var i = 0; i < data.length; i++)if (data[i] && data[i].label) $87f4a59ac66e0ee6$export$abdcc6a26372f94b(data[i], "label", props);
        }
    };
    /**
   * Init a data structure from data related option in series
   * Must be overridden.
   */ SeriesModel.prototype.getInitialData = function(option, ecModel) {
        return;
    };
    /**
   * Append data to list
   */ SeriesModel.prototype.appendData = function(params) {
        // FIXME ???
        // (1) If data from dataset, forbidden append.
        // (2) support append data of dataset.
        var data = this.getRawData();
        data.appendData(params.data);
    };
    /**
   * Consider some method like `filter`, `map` need make new data,
   * We should make sure that `seriesModel.getData()` get correct
   * data in the stream procedure. So we fetch data from upstream
   * each time `task.perform` called.
   */ SeriesModel.prototype.getData = function(dataType) {
        var task = $39002e2f499d7a2f$var$getCurrentTask(this);
        if (task) {
            var data = task.context.data;
            return dataType == null || !data.getLinkedData ? data : data.getLinkedData(dataType);
        } else // When series is not alive (that may happen when click toolbox
        // restore or setOption with not merge mode), series data may
        // be still need to judge animation or something when graphic
        // elements want to know whether fade out.
        return $39002e2f499d7a2f$var$inner(this).data;
    };
    SeriesModel.prototype.getAllData = function() {
        var mainData = this.getData();
        return mainData && mainData.getLinkedDataAll ? mainData.getLinkedDataAll() : [
            {
                data: mainData
            }
        ];
    };
    SeriesModel.prototype.setData = function(data) {
        var task = $39002e2f499d7a2f$var$getCurrentTask(this);
        if (task) {
            var context = task.context;
            // Consider case: filter, data sample.
            // FIXME:TS never used, so comment it
            // if (context.data !== data && task.modifyOutputEnd) {
            //     task.setOutputEnd(data.count());
            // }
            context.outputData = data;
            // Caution: setData should update context.data,
            // Because getData may be called multiply in a
            // single stage and expect to get the data just
            // set. (For example, AxisProxy, x y both call
            // getData and setDate sequentially).
            // So the context.data should be fetched from
            // upstream each time when a stage starts to be
            // performed.
            if (task !== this.dataTask) context.data = data;
        }
        $39002e2f499d7a2f$var$inner(this).data = data;
    };
    SeriesModel.prototype.getEncode = function() {
        var encode = this.get("encode", true);
        if (encode) return $43e0a445ed6711da$export$55f8aa7ef875b0a4(encode);
    };
    SeriesModel.prototype.getSourceManager = function() {
        return $39002e2f499d7a2f$var$inner(this).sourceManager;
    };
    SeriesModel.prototype.getSource = function() {
        return this.getSourceManager().getSource();
    };
    /**
   * Get data before processed
   */ SeriesModel.prototype.getRawData = function() {
        return $39002e2f499d7a2f$var$inner(this).dataBeforeProcessed;
    };
    SeriesModel.prototype.getColorBy = function() {
        var colorBy = this.get("colorBy");
        return colorBy || "series";
    };
    SeriesModel.prototype.isColorBySeries = function() {
        return this.getColorBy() === "series";
    };
    /**
   * Get base axis if has coordinate system and has axis.
   * By default use coordSys.getBaseAxis();
   * Can be overridden for some chart.
   * @return {type} description
   */ SeriesModel.prototype.getBaseAxis = function() {
        var coordSys = this.coordinateSystem;
        return coordSys && coordSys.getBaseAxis && coordSys.getBaseAxis();
    };
    /**
   * Retrieve the index of nearest value in the view coordinate.
   * Data position is compared with each axis's dataToCoord.
   *
   * @param axisDim axis dimension
   * @param dim data dimension
   * @param value
   * @param [maxDistance=Infinity] The maximum distance in view coordinate space
   * @return If and only if multiple indices has
   *         the same value, they are put to the result.
   */ SeriesModel.prototype.indicesOfNearest = function(axisDim, dim, value, maxDistance) {
        var data = this.getData();
        var coordSys = this.coordinateSystem;
        var axis = coordSys && coordSys.getAxis(axisDim);
        if (!coordSys || !axis) return [];
        var targetCoord = axis.dataToCoord(value);
        if (maxDistance == null) maxDistance = Infinity;
        var nearestIndices = [];
        var minDist = Infinity;
        var minDiff = -1;
        var nearestIndicesLen = 0;
        // Performance-sensitive on large data (triggered by `tooltip`/`axisPointer` frequently).
        var dimIdx = data.getDimensionIndex(dim);
        var store = data.getStore();
        for(var idx = 0, len = store.count(); idx < len; idx++){
            var dimValue = store.get(dimIdx, idx);
            var dataCoord = axis.dataToCoord(dimValue);
            var diff = targetCoord - dataCoord;
            var dist = Math.abs(diff);
            if (dist <= maxDistance) {
                // When the `value` is at the middle of `this.get(dim, i)` and `this.get(dim, i+1)`,
                // we'd better not push both of them to `nearestIndices`, otherwise it is easy to
                // get more than one item in `nearestIndices` (more specifically, in `tooltip`).
                // So we choose the one that `diff >= 0` in this case.
                // But if `this.get(dim, i)` and `this.get(dim, j)` get the same value, both of them
                // should be push to `nearestIndices`.
                if (dist < minDist || dist === minDist && diff >= 0 && minDiff < 0) {
                    minDist = dist;
                    minDiff = diff;
                    nearestIndicesLen = 0;
                }
                if (diff === minDiff) nearestIndices[nearestIndicesLen++] = idx;
            }
        }
        nearestIndices.length = nearestIndicesLen;
        return nearestIndices;
    };
    /**
   * Default tooltip formatter
   *
   * @param dataIndex
   * @param multipleSeries
   * @param dataType
   * @param renderMode valid values: 'html'(by default) and 'richText'.
   *        'html' is used for rendering tooltip in extra DOM form, and the result
   *        string is used as DOM HTML content.
   *        'richText' is used for rendering tooltip in rich text form, for those where
   *        DOM operation is not supported.
   * @return formatted tooltip with `html` and `markers`
   *        Notice: The override method can also return string
   */ SeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        return (0, $4ca7aa25c8bbd5d4$export$3a110b9fb5c88b34)({
            series: this,
            dataIndex: dataIndex,
            multipleSeries: multipleSeries
        });
    };
    SeriesModel.prototype.isAnimationEnabled = function() {
        var ecModel = this.ecModel;
        // Disable animation if using echarts in node but not give ssr flag.
        // In ssr mode, renderToString will generate svg with css animation.
        if ((0, $a84633bb9c74d89c$export$2e2bcd8739ae039).node && !(ecModel && ecModel.ssr)) return false;
        var animationEnabled = this.getShallow("animation");
        if (animationEnabled) {
            if (this.getData().count() > this.getShallow("animationThreshold")) animationEnabled = false;
        }
        return !!animationEnabled;
    };
    SeriesModel.prototype.restoreData = function() {
        // See `dataTaskReset`.
        this.dataTask.dirty();
    };
    SeriesModel.prototype.getColorFromPalette = function(name, scope, requestColorNum) {
        var ecModel = this.ecModel;
        // PENDING
        var color = (0, $98b3e46db1e9df2f$export$55a3c39e852b90f4).prototype.getColorFromPalette.call(this, name, scope, requestColorNum);
        if (!color) color = ecModel.getColorFromPalette(name, scope, requestColorNum);
        return color;
    };
    /**
   * Use `data.mapDimensionsAll(coordDim)` instead.
   * @deprecated
   */ SeriesModel.prototype.coordDimToDataDim = function(coordDim) {
        return this.getRawData().mapDimensionsAll(coordDim);
    };
    /**
   * Get progressive rendering count each step
   */ SeriesModel.prototype.getProgressive = function() {
        return this.get("progressive");
    };
    /**
   * Get progressive rendering count each step
   */ SeriesModel.prototype.getProgressiveThreshold = function() {
        return this.get("progressiveThreshold");
    };
    // PENGING If selectedMode is null ?
    SeriesModel.prototype.select = function(innerDataIndices, dataType) {
        this._innerSelect(this.getData(dataType), innerDataIndices);
    };
    SeriesModel.prototype.unselect = function(innerDataIndices, dataType) {
        var selectedMap = this.option.selectedMap;
        if (!selectedMap) return;
        var selectedMode = this.option.selectedMode;
        var data = this.getData(dataType);
        if (selectedMode === "series" || selectedMap === "all") {
            this.option.selectedMap = {};
            this._selectedDataIndicesMap = {};
            return;
        }
        for(var i = 0; i < innerDataIndices.length; i++){
            var dataIndex = innerDataIndices[i];
            var nameOrId = $39002e2f499d7a2f$var$getSelectionKey(data, dataIndex);
            selectedMap[nameOrId] = false;
            this._selectedDataIndicesMap[nameOrId] = -1;
        }
    };
    SeriesModel.prototype.toggleSelect = function(innerDataIndices, dataType) {
        var tmpArr = [];
        for(var i = 0; i < innerDataIndices.length; i++){
            tmpArr[0] = innerDataIndices[i];
            this.isSelected(innerDataIndices[i], dataType) ? this.unselect(tmpArr, dataType) : this.select(tmpArr, dataType);
        }
    };
    SeriesModel.prototype.getSelectedDataIndices = function() {
        if (this.option.selectedMap === "all") return [].slice.call(this.getData().getIndices());
        var selectedDataIndicesMap = this._selectedDataIndicesMap;
        var nameOrIds = $43e0a445ed6711da$export$ed97f33186d4b816(selectedDataIndicesMap);
        var dataIndices = [];
        for(var i = 0; i < nameOrIds.length; i++){
            var dataIndex = selectedDataIndicesMap[nameOrIds[i]];
            if (dataIndex >= 0) dataIndices.push(dataIndex);
        }
        return dataIndices;
    };
    SeriesModel.prototype.isSelected = function(dataIndex, dataType) {
        var selectedMap = this.option.selectedMap;
        if (!selectedMap) return false;
        var data = this.getData(dataType);
        return (selectedMap === "all" || selectedMap[$39002e2f499d7a2f$var$getSelectionKey(data, dataIndex)]) && !data.getItemModel(dataIndex).get([
            "select",
            "disabled"
        ]);
    };
    SeriesModel.prototype.isUniversalTransitionEnabled = function() {
        if (this[$39002e2f499d7a2f$export$e960441116ae2799]) return true;
        var universalTransitionOpt = this.option.universalTransition;
        // Quick reject
        if (!universalTransitionOpt) return false;
        if (universalTransitionOpt === true) return true;
        // Can be simply 'universalTransition: true'
        return universalTransitionOpt && universalTransitionOpt.enabled;
    };
    SeriesModel.prototype._innerSelect = function(data, innerDataIndices) {
        var _a, _b;
        var option = this.option;
        var selectedMode = option.selectedMode;
        var len = innerDataIndices.length;
        if (!selectedMode || !len) return;
        if (selectedMode === "series") option.selectedMap = "all";
        else if (selectedMode === "multiple") {
            if (!$43e0a445ed6711da$export$a6cdc56e425d0d0a(option.selectedMap)) option.selectedMap = {};
            var selectedMap = option.selectedMap;
            for(var i = 0; i < len; i++){
                var dataIndex = innerDataIndices[i];
                // TODO different types of data share same object.
                var nameOrId = $39002e2f499d7a2f$var$getSelectionKey(data, dataIndex);
                selectedMap[nameOrId] = true;
                this._selectedDataIndicesMap[nameOrId] = data.getRawIndex(dataIndex);
            }
        } else if (selectedMode === "single" || selectedMode === true) {
            var lastDataIndex = innerDataIndices[len - 1];
            var nameOrId = $39002e2f499d7a2f$var$getSelectionKey(data, lastDataIndex);
            option.selectedMap = (_a = {}, _a[nameOrId] = true, _a);
            this._selectedDataIndicesMap = (_b = {}, _b[nameOrId] = data.getRawIndex(lastDataIndex), _b);
        }
    };
    SeriesModel.prototype._initSelectedMapFromData = function(data) {
        // Ignore select info in data if selectedMap exists.
        // NOTE It's only for legacy usage. edge data is not supported.
        if (this.option.selectedMap) return;
        var dataIndices = [];
        if (data.hasItemOption) data.each(function(idx) {
            var rawItem = data.getRawDataItem(idx);
            if (rawItem && rawItem.selected) dataIndices.push(idx);
        });
        if (dataIndices.length > 0) this._innerSelect(data, dataIndices);
    };
    // /**
    //  * @see {module:echarts/stream/Scheduler}
    //  */
    // abstract pipeTask: null
    SeriesModel.registerClass = function(clz) {
        return (0, $4a9041b12b787d1b$export$2e2bcd8739ae039).registerClass(clz);
    };
    SeriesModel.protoInitialize = function() {
        var proto = SeriesModel.prototype;
        proto.type = "series.__base__";
        proto.seriesIndex = 0;
        proto.ignoreStyleOnData = false;
        proto.hasSymbolVisual = false;
        proto.defaultSymbol = "circle";
        // Make sure the values can be accessed!
        proto.visualStyleAccessPath = "itemStyle";
        proto.visualDrawType = "fill";
    }();
    return SeriesModel;
}((0, $4a9041b12b787d1b$export$2e2bcd8739ae039));
$43e0a445ed6711da$export$e36fc9d62a853069($39002e2f499d7a2f$var$SeriesModel, (0, $f48a6be4420f5faf$export$f23396ae04ea95a7));
$43e0a445ed6711da$export$e36fc9d62a853069($39002e2f499d7a2f$var$SeriesModel, (0, $98b3e46db1e9df2f$export$55a3c39e852b90f4));
(0, $10ce7a4361c3910c$export$c9c2d87774f1275d)($39002e2f499d7a2f$var$SeriesModel, (0, $4a9041b12b787d1b$export$2e2bcd8739ae039));
/**
 * MUST be called after `prepareSource` called
 * Here we need to make auto series, especially for auto legend. But we
 * do not modify series.name in option to avoid side effects.
 */ function $39002e2f499d7a2f$var$autoSeriesName(seriesModel) {
    // User specified name has higher priority, otherwise it may cause
    // series can not be queried unexpectedly.
    var name = seriesModel.name;
    if (!$87f4a59ac66e0ee6$export$beae19a2652b3368(seriesModel)) seriesModel.name = $39002e2f499d7a2f$var$getSeriesAutoName(seriesModel) || name;
}
function $39002e2f499d7a2f$var$getSeriesAutoName(seriesModel) {
    var data = seriesModel.getRawData();
    var dataDims = data.mapDimensionsAll("seriesName");
    var nameArr = [];
    $43e0a445ed6711da$export$79b2f7037acddd43(dataDims, function(dataDim) {
        var dimInfo = data.getDimensionInfo(dataDim);
        dimInfo.displayName && nameArr.push(dimInfo.displayName);
    });
    return nameArr.join(" ");
}
function $39002e2f499d7a2f$var$dataTaskCount(context) {
    return context.model.getRawData().count();
}
function $39002e2f499d7a2f$var$dataTaskReset(context) {
    var seriesModel = context.model;
    seriesModel.setData(seriesModel.getRawData().cloneShallow());
    return $39002e2f499d7a2f$var$dataTaskProgress;
}
function $39002e2f499d7a2f$var$dataTaskProgress(param, context) {
    // Avoid repeat cloneShallow when data just created in reset.
    if (context.outputData && param.end > context.outputData.count()) context.model.getRawData().cloneShallow(context.outputData);
}
// TODO refactor
function $39002e2f499d7a2f$var$wrapData(data, seriesModel) {
    $43e0a445ed6711da$export$79b2f7037acddd43($43e0a445ed6711da$export$4fd8af2c48c43416(data.CHANGABLE_METHODS, data.DOWNSAMPLE_METHODS), function(methodName) {
        data.wrapMethod(methodName, $43e0a445ed6711da$export$c3095a23b368d1f2($39002e2f499d7a2f$var$onDataChange, seriesModel));
    });
}
function $39002e2f499d7a2f$var$onDataChange(seriesModel, newList) {
    var task = $39002e2f499d7a2f$var$getCurrentTask(seriesModel);
    if (task) // Consider case: filter, selectRange
    task.setOutputEnd((newList || this).count());
    return newList;
}
function $39002e2f499d7a2f$var$getCurrentTask(seriesModel) {
    var scheduler = (seriesModel.ecModel || {}).scheduler;
    var pipeline = scheduler && scheduler.getPipeline(seriesModel.uid);
    if (pipeline) {
        // When pipline finished, the currrentTask keep the last
        // task (renderTask).
        var task = pipeline.currentTask;
        if (task) {
            var agentStubMap = task.agentStubMap;
            if (agentStubMap) task = agentStubMap.get(seriesModel.uid);
        }
        return task;
    }
}
var $39002e2f499d7a2f$export$2e2bcd8739ae039 = $39002e2f499d7a2f$var$SeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $c81700f6bd52c5a7$var$ComponentView = /** @class */ function() {
    function ComponentView() {
        this.group = new (0, $a8978f7a0e842e3d$export$2e2bcd8739ae039)();
        this.uid = $f7a89889802a4565$export$6d2b3473b0986646("viewComponent");
    }
    ComponentView.prototype.init = function(ecModel, api) {};
    ComponentView.prototype.render = function(model, ecModel, api, payload) {};
    ComponentView.prototype.dispose = function(ecModel, api) {};
    ComponentView.prototype.updateView = function(model, ecModel, api, payload) {
    // Do nothing;
    };
    ComponentView.prototype.updateLayout = function(model, ecModel, api, payload) {
    // Do nothing;
    };
    ComponentView.prototype.updateVisual = function(model, ecModel, api, payload) {
    // Do nothing;
    };
    /**
   * Hook for toggle blur target series.
   * Can be used in marker for blur or leave blur the markers
   */ ComponentView.prototype.toggleBlurSeries = function(seriesModels, isBlur, ecModel) {
    // Do nothing;
    };
    /**
   * Traverse the new rendered elements.
   *
   * It will traverse the new added element in progressive rendering.
   * And traverse all in normal rendering.
   */ ComponentView.prototype.eachRendered = function(cb) {
        var group = this.group;
        if (group) group.traverse(cb);
    };
    return ComponentView;
}();
$10ce7a4361c3910c$export$cd4c3a4dca301c70($c81700f6bd52c5a7$var$ComponentView);
$10ce7a4361c3910c$export$241315e45585454d($c81700f6bd52c5a7$var$ComponentView);
var $c81700f6bd52c5a7$export$2e2bcd8739ae039 = $c81700f6bd52c5a7$var$ComponentView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $cf4d5552a72b5b73$export$2e2bcd8739ae039() {
    var inner = (0, $87f4a59ac66e0ee6$export$64df9f8d92ae083f)();
    return function(seriesModel) {
        var fields = inner(seriesModel);
        var pipelineContext = seriesModel.pipelineContext;
        var originalLarge = !!fields.large;
        var originalProgressive = !!fields.progressiveRender;
        // FIXME: if the planner works on a filtered series, `pipelineContext` does not
        // exists. See #11611 . Probably we need to modify this structure, see the comment
        // on `performRawSeries` in `Schedular.js`.
        var large = fields.large = !!(pipelineContext && pipelineContext.large);
        var progressive = fields.progressiveRender = !!(pipelineContext && pipelineContext.progressiveRender);
        return !!(originalLarge !== large || originalProgressive !== progressive) && "reset";
    };
}




var $9bc1fbefe72d5b26$var$inner = $87f4a59ac66e0ee6$export$64df9f8d92ae083f();
var $9bc1fbefe72d5b26$var$renderPlanner = (0, $cf4d5552a72b5b73$export$2e2bcd8739ae039)();
var $9bc1fbefe72d5b26$var$ChartView = /** @class */ function() {
    function ChartView() {
        this.group = new (0, $a8978f7a0e842e3d$export$2e2bcd8739ae039)();
        this.uid = $f7a89889802a4565$export$6d2b3473b0986646("viewChart");
        this.renderTask = (0, $eb04eaa34fbabb0a$export$f7292ab7796be73c)({
            plan: $9bc1fbefe72d5b26$var$renderTaskPlan,
            reset: $9bc1fbefe72d5b26$var$renderTaskReset
        });
        this.renderTask.context = {
            view: this
        };
    }
    ChartView.prototype.init = function(ecModel, api) {};
    ChartView.prototype.render = function(seriesModel, ecModel, api, payload) {};
    /**
   * Highlight series or specified data item.
   */ ChartView.prototype.highlight = function(seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData(payload && payload.dataType);
        if (!data) return;
        $9bc1fbefe72d5b26$var$toggleHighlight(data, payload, "emphasis");
    };
    /**
   * Downplay series or specified data item.
   */ ChartView.prototype.downplay = function(seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData(payload && payload.dataType);
        if (!data) return;
        $9bc1fbefe72d5b26$var$toggleHighlight(data, payload, "normal");
    };
    /**
   * `remove` only occurs when series is filtered out, typically by legend.
   * And theirafter the view can only be rendered again via
   * `ChartView['render']` or `ChartView['incrementalPrepareRender']`.
   */ ChartView.prototype.remove = function(ecModel, api) {
        this.group.removeAll();
    };
    /**
   * Dispose self.
   */ ChartView.prototype.dispose = function(ecModel, api) {};
    ChartView.prototype.updateView = function(seriesModel, ecModel, api, payload) {
        this.render(seriesModel, ecModel, api, payload);
    };
    // FIXME never used?
    // updateLayout(seriesModel: SeriesModel, ecModel: GlobalModel, api: ExtensionAPI, payload: Payload): void {
    //     this.render(seriesModel, ecModel, api, payload);
    // }
    // FIXME never used?
    ChartView.prototype.updateVisual = function(seriesModel, ecModel, api, payload) {
        this.render(seriesModel, ecModel, api, payload);
    };
    /**
   * Traverse the new rendered elements.
   *
   * It will traverse the new added element in progressive rendering.
   * And traverse all in normal rendering.
   */ ChartView.prototype.eachRendered = function(cb) {
        (0, $6552edac5ca572b1$export$3e564442729bf048)(this.group, cb);
    };
    ChartView.markUpdateMethod = function(payload, methodName) {
        $9bc1fbefe72d5b26$var$inner(payload).updateMethod = methodName;
    };
    ChartView.protoInitialize = function() {
        var proto = ChartView.prototype;
        proto.type = "chart";
    }();
    return ChartView;
}();
/**
 * Set state of single element
 */ function $9bc1fbefe72d5b26$var$elSetState(el, state, highlightDigit) {
    if (el && (0, $fffc76734a157b4c$export$77d1445f699c58b5)(el)) (state === "emphasis" ? (0, $fffc76734a157b4c$export$b2d02638cc34c042) : (0, $fffc76734a157b4c$export$11be6f716239ac55))(el, highlightDigit);
}
function $9bc1fbefe72d5b26$var$toggleHighlight(data, payload, state) {
    var dataIndex = $87f4a59ac66e0ee6$export$42b26cae8b8d10(data, payload);
    var highlightDigit = payload && payload.highlightKey != null ? (0, $fffc76734a157b4c$export$824af40eb714530d)(payload.highlightKey) : null;
    if (dataIndex != null) (0, $43e0a445ed6711da$export$79b2f7037acddd43)($87f4a59ac66e0ee6$export$4f07b212a02c8051(dataIndex), function(dataIdx) {
        $9bc1fbefe72d5b26$var$elSetState(data.getItemGraphicEl(dataIdx), state, highlightDigit);
    });
    else // In progressive mode, `data._graphicEls` has typically no items,
    // thereby skipping this hover style changing.
    // PENDING: more robust approaches?
    data.eachItemGraphicEl(function(el) {
        $9bc1fbefe72d5b26$var$elSetState(el, state, highlightDigit);
    });
}
$10ce7a4361c3910c$export$cd4c3a4dca301c70($9bc1fbefe72d5b26$var$ChartView, [
    "dispose"
]);
$10ce7a4361c3910c$export$241315e45585454d($9bc1fbefe72d5b26$var$ChartView);
function $9bc1fbefe72d5b26$var$renderTaskPlan(context) {
    return $9bc1fbefe72d5b26$var$renderPlanner(context.model);
}
function $9bc1fbefe72d5b26$var$renderTaskReset(context) {
    var seriesModel = context.model;
    var ecModel = context.ecModel;
    var api = context.api;
    var payload = context.payload;
    // FIXME: remove updateView updateVisual
    var progressiveRender = seriesModel.pipelineContext.progressiveRender;
    var view = context.view;
    var updateMethod = payload && $9bc1fbefe72d5b26$var$inner(payload).updateMethod;
    var methodName = progressiveRender ? "incrementalPrepareRender" : updateMethod && view[updateMethod] ? updateMethod : "render";
    if (methodName !== "render") view[methodName](seriesModel, ecModel, api, payload);
    return $9bc1fbefe72d5b26$var$progressMethodMap[methodName];
}
var $9bc1fbefe72d5b26$var$progressMethodMap = {
    incrementalPrepareRender: {
        progress: function(params, context) {
            context.view.incrementalRender(params, context.model, context.ecModel, context.api, context.payload);
        }
    },
    render: {
        // Put view.render in `progress` to support appendData. But in this case
        // view.render should not be called in reset, otherwise it will be called
        // twise. Use `forceFirstProgress` to make sure that view.render is called
        // in any cases.
        forceFirstProgress: true,
        progress: function(params, context) {
            context.view.render(context.model, context.ecModel, context.api, context.payload);
        }
    }
};
var $9bc1fbefe72d5b26$export$2e2bcd8739ae039 = $9bc1fbefe72d5b26$var$ChartView;






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $3a03c388017fa83a$var$ORIGIN_METHOD = "\0__throttleOriginMethod";
var $3a03c388017fa83a$var$RATE = "\0__throttleRate";
var $3a03c388017fa83a$var$THROTTLE_TYPE = "\0__throttleType";
function $3a03c388017fa83a$export$de363e709c412c8a(fn, delay, debounce) {
    var currCall;
    var lastCall = 0;
    var lastExec = 0;
    var timer = null;
    var diff;
    var scope;
    var args;
    var debounceNextCall;
    delay = delay || 0;
    function exec() {
        lastExec = new Date().getTime();
        timer = null;
        fn.apply(scope, args || []);
    }
    var cb = function() {
        var cbArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)cbArgs[_i] = arguments[_i];
        currCall = new Date().getTime();
        scope = this;
        args = cbArgs;
        var thisDelay = debounceNextCall || delay;
        var thisDebounce = debounceNextCall || debounce;
        debounceNextCall = null;
        diff = currCall - (thisDebounce ? lastCall : lastExec) - thisDelay;
        clearTimeout(timer);
        // Here we should make sure that: the `exec` SHOULD NOT be called later
        // than a new call of `cb`, that is, preserving the command order. Consider
        // calculating "scale rate" when roaming as an example. When a call of `cb`
        // happens, either the `exec` is called dierectly, or the call is delayed.
        // But the delayed call should never be later than next call of `cb`. Under
        // this assurance, we can simply update view state each time `dispatchAction`
        // triggered by user roaming, but not need to add extra code to avoid the
        // state being "rolled-back".
        if (thisDebounce) timer = setTimeout(exec, thisDelay);
        else if (diff >= 0) exec();
        else timer = setTimeout(exec, -diff);
        lastCall = currCall;
    };
    /**
   * Clear throttle.
   * @public
   */ cb.clear = function() {
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
    };
    /**
   * Enable debounce once.
   */ cb.debounceNextCall = function(debounceDelay) {
        debounceNextCall = debounceDelay;
    };
    return cb;
}
function $3a03c388017fa83a$export$958e3e1a02eac4b6(obj, fnAttr, rate, throttleType) {
    var fn = obj[fnAttr];
    if (!fn) return;
    var originFn = fn[$3a03c388017fa83a$var$ORIGIN_METHOD] || fn;
    var lastThrottleType = fn[$3a03c388017fa83a$var$THROTTLE_TYPE];
    var lastRate = fn[$3a03c388017fa83a$var$RATE];
    if (lastRate !== rate || lastThrottleType !== throttleType) {
        if (rate == null || !throttleType) return obj[fnAttr] = originFn;
        fn = obj[fnAttr] = $3a03c388017fa83a$export$de363e709c412c8a(originFn, rate, throttleType === "debounce");
        fn[$3a03c388017fa83a$var$ORIGIN_METHOD] = originFn;
        fn[$3a03c388017fa83a$var$THROTTLE_TYPE] = throttleType;
        fn[$3a03c388017fa83a$var$RATE] = rate;
    }
    return fn;
}
function $3a03c388017fa83a$export$42ffd38884aecdac(obj, fnAttr) {
    var fn = obj[fnAttr];
    if (fn && fn[$3a03c388017fa83a$var$ORIGIN_METHOD]) {
        // Clear throttle
        fn.clear && fn.clear();
        obj[fnAttr] = fn[$3a03c388017fa83a$var$ORIGIN_METHOD];
    }
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $c85eb56081b6d5d9$var$inner = (0, $87f4a59ac66e0ee6$export$64df9f8d92ae083f)();
var $c85eb56081b6d5d9$var$defaultStyleMappers = {
    itemStyle: (0, $0b19196a0800a1eb$export$2e2bcd8739ae039)((0, $c62e186be3a8172a$export$ffb0bba5dde0130b), true),
    lineStyle: (0, $0b19196a0800a1eb$export$2e2bcd8739ae039)((0, $e0a50a0f4a6edbaa$export$9f34de5b59222949), true)
};
var $c85eb56081b6d5d9$var$defaultColorKey = {
    lineStyle: "stroke",
    itemStyle: "fill"
};
function $c85eb56081b6d5d9$var$getStyleMapper(seriesModel, stylePath) {
    var styleMapper = seriesModel.visualStyleMapper || $c85eb56081b6d5d9$var$defaultStyleMappers[stylePath];
    if (!styleMapper) {
        console.warn("Unknown style type '" + stylePath + "'.");
        return $c85eb56081b6d5d9$var$defaultStyleMappers.itemStyle;
    }
    return styleMapper;
}
function $c85eb56081b6d5d9$var$getDefaultColorKey(seriesModel, stylePath) {
    // return defaultColorKey[stylePath] ||
    var colorKey = seriesModel.visualDrawType || $c85eb56081b6d5d9$var$defaultColorKey[stylePath];
    if (!colorKey) {
        console.warn("Unknown style type '" + stylePath + "'.");
        return "fill";
    }
    return colorKey;
}
var $c85eb56081b6d5d9$export$7ce4d65f9b69240 = {
    createOnAllSeries: true,
    performRawSeries: true,
    reset: function(seriesModel, ecModel) {
        var data = seriesModel.getData();
        var stylePath = seriesModel.visualStyleAccessPath || "itemStyle";
        // Set in itemStyle
        var styleModel = seriesModel.getModel(stylePath);
        var getStyle = $c85eb56081b6d5d9$var$getStyleMapper(seriesModel, stylePath);
        var globalStyle = getStyle(styleModel);
        var decalOption = styleModel.getShallow("decal");
        if (decalOption) {
            data.setVisual("decal", decalOption);
            decalOption.dirty = true;
        }
        // TODO
        var colorKey = $c85eb56081b6d5d9$var$getDefaultColorKey(seriesModel, stylePath);
        var color = globalStyle[colorKey];
        // TODO style callback
        var colorCallback = (0, $43e0a445ed6711da$export$f6e2535fb5126e54)(color) ? color : null;
        var hasAutoColor = globalStyle.fill === "auto" || globalStyle.stroke === "auto";
        // Get from color palette by default.
        if (!globalStyle[colorKey] || colorCallback || hasAutoColor) {
            // Note: If some series has color specified (e.g., by itemStyle.color), we DO NOT
            // make it effect palette. Because some scenarios users need to make some series
            // transparent or as background, which should better not effect the palette.
            var colorPalette = seriesModel.getColorFromPalette(// TODO series count changed.
            seriesModel.name, null, ecModel.getSeriesCount());
            if (!globalStyle[colorKey]) {
                globalStyle[colorKey] = colorPalette;
                data.setVisual("colorFromPalette", true);
            }
            globalStyle.fill = globalStyle.fill === "auto" || (0, $43e0a445ed6711da$export$f6e2535fb5126e54)(globalStyle.fill) ? colorPalette : globalStyle.fill;
            globalStyle.stroke = globalStyle.stroke === "auto" || (0, $43e0a445ed6711da$export$f6e2535fb5126e54)(globalStyle.stroke) ? colorPalette : globalStyle.stroke;
        }
        data.setVisual("style", globalStyle);
        data.setVisual("drawType", colorKey);
        // Only visible series has each data be visual encoded
        if (!ecModel.isSeriesFiltered(seriesModel) && colorCallback) {
            data.setVisual("colorFromPalette", false);
            return {
                dataEach: function(data, idx) {
                    var dataParams = seriesModel.getDataParams(idx);
                    var itemStyle = (0, $43e0a445ed6711da$export$8b58be045bf06082)({}, globalStyle);
                    itemStyle[colorKey] = colorCallback(dataParams);
                    data.setItemVisual(idx, "style", itemStyle);
                }
            };
        }
    }
};
var $c85eb56081b6d5d9$var$sharedModel = new (0, $279973fc50f77a15$export$2e2bcd8739ae039)();
var $c85eb56081b6d5d9$export$f7dcb66a065003d1 = {
    createOnAllSeries: true,
    reset: function(seriesModel, ecModel) {
        if (seriesModel.ignoreStyleOnData) return;
        var data = seriesModel.getData();
        var stylePath = seriesModel.visualStyleAccessPath || "itemStyle";
        // Set in itemStyle
        var getStyle = $c85eb56081b6d5d9$var$getStyleMapper(seriesModel, stylePath);
        var colorKey = data.getVisual("drawType");
        return {
            dataEach: data.hasItemOption ? function(data, idx) {
                // Not use getItemModel for performance considuration
                var rawItem = data.getRawDataItem(idx);
                if (rawItem && rawItem[stylePath]) {
                    $c85eb56081b6d5d9$var$sharedModel.option = rawItem[stylePath];
                    var style = getStyle($c85eb56081b6d5d9$var$sharedModel);
                    var existsStyle = data.ensureUniqueItemVisual(idx, "style");
                    (0, $43e0a445ed6711da$export$8b58be045bf06082)(existsStyle, style);
                    if ($c85eb56081b6d5d9$var$sharedModel.option.decal) {
                        data.setItemVisual(idx, "decal", $c85eb56081b6d5d9$var$sharedModel.option.decal);
                        $c85eb56081b6d5d9$var$sharedModel.option.decal.dirty = true;
                    }
                    if (colorKey in style) data.setItemVisual(idx, "colorFromPalette", false);
                }
            } : null
        };
    }
};
// Pick color from palette for the data which has not been set with color yet.
// Note: do not support stream rendering. No such cases yet.
var $c85eb56081b6d5d9$export$cf9758b0d6dc0aa9 = {
    performRawSeries: true,
    overallReset: function(ecModel) {
        // Each type of series uses one scope.
        // Pie and funnel are using different scopes.
        var paletteScopeGroupByType = (0, $43e0a445ed6711da$export$55f8aa7ef875b0a4)();
        ecModel.eachSeries(function(seriesModel) {
            if (!seriesModel.isColorBySeries()) {
                var key = seriesModel.type + "-" + seriesModel.getColorBy();
                $c85eb56081b6d5d9$var$inner(seriesModel).scope = paletteScopeGroupByType.get(key) || paletteScopeGroupByType.set(key, {});
            }
        });
        ecModel.eachSeries(function(seriesModel) {
            if (seriesModel.isColorBySeries()) return;
            var dataAll = seriesModel.getRawData();
            var idxMap = {};
            var data = seriesModel.getData();
            var colorScope = $c85eb56081b6d5d9$var$inner(seriesModel).scope;
            var stylePath = seriesModel.visualStyleAccessPath || "itemStyle";
            var colorKey = $c85eb56081b6d5d9$var$getDefaultColorKey(seriesModel, stylePath);
            data.each(function(idx) {
                var rawIdx = data.getRawIndex(idx);
                idxMap[rawIdx] = idx;
            });
            // Iterate on data before filtered. To make sure color from palette can be
            // Consistent when toggling legend.
            dataAll.each(function(rawIdx) {
                var idx = idxMap[rawIdx];
                var fromPalette = data.getItemVisual(idx, "colorFromPalette");
                // Get color from palette for each data only when the color is inherited from series color, which is
                // also picked from color palette. So following situation is not in the case:
                // 1. series.itemStyle.color is set
                // 2. color is encoded by visualMap
                if (fromPalette) {
                    var itemStyle = data.ensureUniqueItemVisual(idx, "style");
                    var name_1 = dataAll.getName(rawIdx) || rawIdx + "";
                    var dataCount = dataAll.count();
                    itemStyle[colorKey] = seriesModel.getColorFromPalette(name_1, colorScope, dataCount);
                }
            });
        });
    }
};


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $96ef4a55d6ec4384$var$PI = Math.PI;
function $96ef4a55d6ec4384$export$2e2bcd8739ae039(api, opts) {
    opts = opts || {};
    $43e0a445ed6711da$export$ebe90cb607ad99e(opts, {
        text: "loading",
        textColor: (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.primary,
        fontSize: 12,
        fontWeight: "normal",
        fontStyle: "normal",
        fontFamily: "sans-serif",
        maskColor: "rgba(255,255,255,0.8)",
        showSpinner: true,
        color: (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.theme[0],
        spinnerRadius: 10,
        lineWidth: 5,
        zlevel: 0
    });
    var group = new $a8978f7a0e842e3d$export$2e2bcd8739ae039();
    var mask = new $42ed508a93973e78$export$2e2bcd8739ae039({
        style: {
            fill: opts.maskColor
        },
        zlevel: opts.zlevel,
        z: 10000
    });
    group.add(mask);
    var textContent = new $7db7960d25b39b7c$export$2e2bcd8739ae039({
        style: {
            text: opts.text,
            fill: opts.textColor,
            fontSize: opts.fontSize,
            fontWeight: opts.fontWeight,
            fontStyle: opts.fontStyle,
            fontFamily: opts.fontFamily
        },
        zlevel: opts.zlevel,
        z: 10001
    });
    var labelRect = new $42ed508a93973e78$export$2e2bcd8739ae039({
        style: {
            fill: "none"
        },
        textContent: textContent,
        textConfig: {
            position: "right",
            distance: 10
        },
        zlevel: opts.zlevel,
        z: 10001
    });
    group.add(labelRect);
    var arc;
    if (opts.showSpinner) {
        arc = new $d0a314b008adf9ab$export$2e2bcd8739ae039({
            shape: {
                startAngle: -$96ef4a55d6ec4384$var$PI / 2,
                endAngle: -$96ef4a55d6ec4384$var$PI / 2 + 0.1,
                r: opts.spinnerRadius
            },
            style: {
                stroke: opts.color,
                lineCap: "round",
                lineWidth: opts.lineWidth
            },
            zlevel: opts.zlevel,
            z: 10001
        });
        arc.animateShape(true).when(1000, {
            endAngle: $96ef4a55d6ec4384$var$PI * 3 / 2
        }).start("circularInOut");
        arc.animateShape(true).when(1000, {
            startAngle: $96ef4a55d6ec4384$var$PI * 3 / 2
        }).delay(300).start("circularInOut");
        group.add(arc);
    }
    // Inject resize
    group.resize = function() {
        var textWidth = textContent.getBoundingRect().width;
        var r = opts.showSpinner ? opts.spinnerRadius : 0;
        // cx = (containerWidth - arcDiameter - textDistance - textWidth) / 2
        // textDistance needs to be calculated when both animation and text exist
        var cx = (api.getWidth() - r * 2 - (opts.showSpinner && textWidth ? 10 : 0) - textWidth) / 2 - (opts.showSpinner && textWidth ? 0 : 5 + textWidth / 2) + (opts.showSpinner ? 0 : textWidth / 2) + (textWidth ? 0 : r);
        var cy = api.getHeight() / 2;
        opts.showSpinner && arc.setShape({
            cx: cx,
            cy: cy
        });
        labelRect.setShape({
            x: cx - r,
            y: cy - r,
            width: r * 2,
            height: r * 2
        });
        mask.setShape({
            x: 0,
            y: 0,
            width: api.getWidth(),
            height: api.getHeight()
        });
    };
    group.resize();
    return group;
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $7982fe5ed36bab1b$var$Scheduler = /** @class */ function() {
    function Scheduler(ecInstance, api, dataProcessorHandlers, visualHandlers) {
        // key: handlerUID
        this._stageTaskMap = (0, $43e0a445ed6711da$export$55f8aa7ef875b0a4)();
        this.ecInstance = ecInstance;
        this.api = api;
        // Fix current processors in case that in some rear cases that
        // processors might be registered after echarts instance created.
        // Register processors incrementally for a echarts instance is
        // not supported by this stream architecture.
        dataProcessorHandlers = this._dataProcessorHandlers = dataProcessorHandlers.slice();
        visualHandlers = this._visualHandlers = visualHandlers.slice();
        this._allHandlers = dataProcessorHandlers.concat(visualHandlers);
    }
    Scheduler.prototype.restoreData = function(ecModel, payload) {
        // TODO: Only restore needed series and components, but not all components.
        // Currently `restoreData` of all of the series and component will be called.
        // But some independent components like `title`, `legend`, `graphic`, `toolbox`,
        // `tooltip`, `axisPointer`, etc, do not need series refresh when `setOption`,
        // and some components like coordinate system, axes, dataZoom, visualMap only
        // need their target series refresh.
        // (1) If we are implementing this feature some day, we should consider these cases:
        // if a data processor depends on a component (e.g., dataZoomProcessor depends
        // on the settings of `dataZoom`), it should be re-performed if the component
        // is modified by `setOption`.
        // (2) If a processor depends on several series, specified by its `getTargetSeries`,
        // it should be re-performed when the result array of `getTargetSeries` changed.
        // We use `dependencies` to cover these issues.
        // (3) How to update target series when coordinate system related components modified.
        // TODO: simply the dirty mechanism? Check whether only the case here can set tasks dirty,
        // and this case all of the tasks will be set as dirty.
        ecModel.restoreData(payload);
        // Theoretically an overall task not only depends on each of its target series, but also
        // depends on all of the series.
        // The overall task is not in pipeline, and `ecModel.restoreData` only set pipeline tasks
        // dirty. If `getTargetSeries` of an overall task returns nothing, we should also ensure
        // that the overall task is set as dirty and to be performed, otherwise it probably cause
        // state chaos. So we have to set dirty of all of the overall tasks manually, otherwise it
        // probably cause state chaos (consider `dataZoomProcessor`).
        this._stageTaskMap.each(function(taskRecord) {
            var overallTask = taskRecord.overallTask;
            overallTask && overallTask.dirty();
        });
    };
    // If seriesModel provided, incremental threshold is check by series data.
    Scheduler.prototype.getPerformArgs = function(task, isBlock) {
        // For overall task
        if (!task.__pipeline) return;
        var pipeline = this._pipelineMap.get(task.__pipeline.id);
        var pCtx = pipeline.context;
        var incremental = !isBlock && pipeline.progressiveEnabled && (!pCtx || pCtx.progressiveRender) && task.__idxInPipeline > pipeline.blockIndex;
        var step = incremental ? pipeline.step : null;
        var modDataCount = pCtx && pCtx.modDataCount;
        var modBy = modDataCount != null ? Math.ceil(modDataCount / step) : null;
        return {
            step: step,
            modBy: modBy,
            modDataCount: modDataCount
        };
    };
    Scheduler.prototype.getPipeline = function(pipelineId) {
        return this._pipelineMap.get(pipelineId);
    };
    /**
   * Current, progressive rendering starts from visual and layout.
   * Always detect render mode in the same stage, avoiding that incorrect
   * detection caused by data filtering.
   * Caution:
   * `updateStreamModes` use `seriesModel.getData()`.
   */ Scheduler.prototype.updateStreamModes = function(seriesModel, view) {
        var pipeline = this._pipelineMap.get(seriesModel.uid);
        // `progressiveRender` means that can render progressively in each
        // animation frame. Note that some types of series do not provide
        // `view.incrementalPrepareRender` but support `chart.appendData`. We
        // use the term `incremental` but not `progressive` to describe the
        // case `chart.appendData`.
        // Regarding zrender, both echarts "progressive" and "incremental" use `el.incremental: true`.
        var context = seriesModel.__preparePipelineContext ? seriesModel.__preparePipelineContext(view, pipeline) : (0, $87f4a59ac66e0ee6$export$3b33f7e0868ca070)(seriesModel, view, pipeline);
        seriesModel.pipelineContext = pipeline.context = context;
    };
    Scheduler.prototype.restorePipelines = function(zr, ecModel) {
        var scheduler = this;
        var pipelineMap = scheduler._pipelineMap = (0, $43e0a445ed6711da$export$55f8aa7ef875b0a4)();
        ecModel.eachSeries(function(seriesModel) {
            var progressive = zr.painter.type === "canvas" && seriesModel.getProgressive();
            var pipelineId = seriesModel.uid;
            pipelineMap.set(pipelineId, {
                id: pipelineId,
                head: null,
                tail: null,
                threshold: seriesModel.getProgressiveThreshold(),
                progressiveEnabled: progressive && !(seriesModel.preventIncremental && seriesModel.preventIncremental()),
                blockIndex: -1,
                step: Math.round(progressive || 700),
                count: 0
            });
            scheduler._pipe(seriesModel, seriesModel.dataTask);
        });
    };
    Scheduler.prototype.prepareStageTasks = function() {
        var stageTaskMap = this._stageTaskMap;
        var ecModel = this.api.getModel();
        var api = this.api;
        (0, $43e0a445ed6711da$export$79b2f7037acddd43)(this._allHandlers, function(handler) {
            var record = stageTaskMap.get(handler.uid) || stageTaskMap.set(handler.uid, {});
            var errMsg = "";
            (0, $43e0a445ed6711da$export$a7a9523472993e97)(!(handler.reset && handler.overallReset), errMsg);
            handler.reset && this._createSeriesStageTask(handler, record, ecModel, api);
            handler.overallReset && this._createOverallStageTask(handler, record, ecModel, api);
        }, this);
    };
    Scheduler.prototype.prepareView = function(view, model, ecModel, api) {
        var renderTask = view.renderTask;
        var context = renderTask.context;
        context.model = model;
        context.ecModel = ecModel;
        context.api = api;
        renderTask.__block = !view.incrementalPrepareRender;
        this._pipe(model, renderTask);
    };
    Scheduler.prototype.performDataProcessorTasks = function(ecModel, payload) {
        // If we do not use `block` here, it should be considered when to update modes.
        this._performStageTasks(this._dataProcessorHandlers, ecModel, payload, {
            block: true
        });
    };
    Scheduler.prototype.performVisualTasks = function(ecModel, payload, opt) {
        this._performStageTasks(this._visualHandlers, ecModel, payload, opt);
    };
    Scheduler.prototype._performStageTasks = function(stageHandlers, ecModel, payload, opt) {
        opt = opt || {};
        var unfinished = false;
        var scheduler = this;
        (0, $43e0a445ed6711da$export$79b2f7037acddd43)(stageHandlers, function(stageHandler, idx) {
            if (opt.visualType && opt.visualType !== stageHandler.visualType) return;
            var stageHandlerRecord = scheduler._stageTaskMap.get(stageHandler.uid);
            var seriesTaskMap = stageHandlerRecord.seriesTaskMap;
            var overallTask = stageHandlerRecord.overallTask;
            if (overallTask) {
                var overallNeedDirty_1;
                var agentStubMap = overallTask.agentStubMap;
                agentStubMap.each(function(stub) {
                    if (needSetDirty(opt, stub)) {
                        stub.dirty();
                        overallNeedDirty_1 = true;
                    }
                });
                overallNeedDirty_1 && overallTask.dirty();
                scheduler.updatePayload(overallTask, payload);
                var performArgs_1 = scheduler.getPerformArgs(overallTask, opt.block);
                // Execute stubs firstly, which may set the overall task dirty,
                // then execute the overall task. And stub will call seriesModel.setData,
                // which ensures that in the overallTask seriesModel.getData() will not
                // return incorrect data.
                agentStubMap.each(function(stub) {
                    stub.perform(performArgs_1);
                });
                if (overallTask.perform(performArgs_1)) unfinished = true;
            } else if (seriesTaskMap) seriesTaskMap.each(function(task, pipelineId) {
                if (needSetDirty(opt, task)) task.dirty();
                var performArgs = scheduler.getPerformArgs(task, opt.block);
                // FIXME
                // if intending to declare `performRawSeries` in handlers, only
                // stream-independent (specifically, data item independent) operations can be
                // performed. Because if a series is filtered, most of the tasks will not
                // be performed. A stream-dependent operation probably cause wrong biz logic.
                // Perhaps we should not provide a separate callback for this case instead
                // of providing the config `performRawSeries`. The stream-dependent operations
                // and stream-independent operations should better not be mixed.
                performArgs.skip = !stageHandler.performRawSeries && ecModel.isSeriesFiltered(task.context.model);
                scheduler.updatePayload(task, payload);
                if (task.perform(performArgs)) unfinished = true;
            });
        });
        function needSetDirty(opt, task) {
            return opt.setDirty && (!opt.dirtyMap || opt.dirtyMap.get(task.__pipeline.id));
        }
        this.unfinished = unfinished || this.unfinished;
    };
    Scheduler.prototype.performSeriesTasks = function(ecModel) {
        var unfinished;
        ecModel.eachSeries(function(seriesModel) {
            // Progress to the end for dataInit and dataRestore.
            unfinished = seriesModel.dataTask.perform() || unfinished;
        });
        this.unfinished = unfinished || this.unfinished;
    };
    Scheduler.prototype.plan = function() {
        // Travel pipelines, check block.
        this._pipelineMap.each(function(pipeline) {
            var task = pipeline.tail;
            do {
                if (task.__block) {
                    pipeline.blockIndex = task.__idxInPipeline;
                    break;
                }
                task = task.getUpstream();
            }while (task);
        });
    };
    Scheduler.prototype.updatePayload = function(task, payload) {
        payload !== "remain" && (task.context.payload = payload);
    };
    Scheduler.prototype._createSeriesStageTask = function(stageHandler, stageHandlerRecord, ecModel, api) {
        var scheduler = this;
        var oldSeriesTaskMap = stageHandlerRecord.seriesTaskMap;
        // The count of stages are totally about only several dozen, so
        // do not need to reuse the map.
        var newSeriesTaskMap = stageHandlerRecord.seriesTaskMap = (0, $43e0a445ed6711da$export$55f8aa7ef875b0a4)();
        var seriesType = stageHandler.seriesType;
        var getTargetSeries = stageHandler.getTargetSeries;
        // If a stageHandler should cover all series, `createOnAllSeries` should be declared mandatorily,
        // to avoid some typo or abuse. Otherwise if an extension do not specify a `seriesType`,
        // it works but it may cause other irrelevant charts blocked.
        if (stageHandler.createOnAllSeries) ecModel.eachRawSeries(create);
        else if (seriesType) ecModel.eachRawSeriesByType(seriesType, create);
        else if (getTargetSeries) getTargetSeries(ecModel, api).each(create);
        function create(seriesModel) {
            var pipelineId = seriesModel.uid;
            // Init tasks for each seriesModel only once.
            // Reuse original task instance.
            var task = newSeriesTaskMap.set(pipelineId, oldSeriesTaskMap && oldSeriesTaskMap.get(pipelineId) || (0, $eb04eaa34fbabb0a$export$f7292ab7796be73c)({
                plan: $7982fe5ed36bab1b$var$seriesTaskPlan,
                reset: $7982fe5ed36bab1b$var$seriesTaskReset,
                count: $7982fe5ed36bab1b$var$seriesTaskCount
            }));
            task.context = {
                model: seriesModel,
                ecModel: ecModel,
                api: api,
                // PENDING: `useClearVisual` not used?
                useClearVisual: stageHandler.isVisual && !stageHandler.isLayout,
                plan: stageHandler.plan,
                reset: stageHandler.reset,
                scheduler: scheduler
            };
            scheduler._pipe(seriesModel, task);
        }
    };
    Scheduler.prototype._createOverallStageTask = function(stageHandler, stageHandlerRecord, ecModel, api) {
        var scheduler = this;
        var overallTask = stageHandlerRecord.overallTask = stageHandlerRecord.overallTask || (0, $eb04eaa34fbabb0a$export$f7292ab7796be73c)({
            reset: $7982fe5ed36bab1b$var$overallTaskReset
        });
        overallTask.context = {
            ecModel: ecModel,
            api: api,
            overallReset: stageHandler.overallReset,
            scheduler: scheduler
        };
        var oldAgentStubMap = overallTask.agentStubMap;
        // The count of stages are totally about only several dozen, so
        // do not need to reuse the map.
        var newAgentStubMap = overallTask.agentStubMap = (0, $43e0a445ed6711da$export$55f8aa7ef875b0a4)();
        var seriesType = stageHandler.seriesType;
        var getTargetSeries = stageHandler.getTargetSeries;
        var dirtyOnOverallProgress = stageHandler.dirtyOnOverallProgress;
        var shouldOverallTaskDirty = false;
        // FIXME:TS never used, so comment it
        // let modifyOutputEnd = stageHandler.modifyOutputEnd;
        // An overall task with seriesType detected or has `getTargetSeries`, we add
        // stub in each pipelines to receive dirty info from upstream.
        var errMsg = "";
        (0, $43e0a445ed6711da$export$a7a9523472993e97)(!stageHandler.createOnAllSeries, errMsg);
        if (seriesType) ecModel.eachRawSeriesByType(seriesType, createStub);
        else if (getTargetSeries) getTargetSeries(ecModel, api).each(createStub);
        else (0, $43e0a445ed6711da$export$79b2f7037acddd43)(ecModel.getSeries(), createStub);
        function createStub(seriesModel) {
            var pipelineId = seriesModel.uid;
            var stub = newAgentStubMap.set(pipelineId, oldAgentStubMap && oldAgentStubMap.get(pipelineId) || // When the result of `getTargetSeries` changed, the overallTask
            // should be set as dirty and re-performed.
            (shouldOverallTaskDirty = true, (0, $eb04eaa34fbabb0a$export$f7292ab7796be73c)({
                reset: $7982fe5ed36bab1b$var$stubReset,
                onDirty: $7982fe5ed36bab1b$var$stubOnDirty
            })));
            stub.context = {
                model: seriesModel,
                dirtyOnOverallProgress: dirtyOnOverallProgress
            };
            stub.agent = overallTask;
            stub.__block = dirtyOnOverallProgress;
            scheduler._pipe(seriesModel, stub);
        }
        if (shouldOverallTaskDirty) overallTask.dirty();
    };
    Scheduler.prototype._pipe = function(seriesModel, task) {
        var pipelineId = seriesModel.uid;
        var pipeline = this._pipelineMap.get(pipelineId);
        !pipeline.head && (pipeline.head = task);
        pipeline.tail && pipeline.tail.pipe(task);
        pipeline.tail = task;
        task.__idxInPipeline = pipeline.count++;
        task.__pipeline = pipeline;
    };
    Scheduler.wrapStageHandler = function(stageHandler, visualType) {
        if ((0, $43e0a445ed6711da$export$f6e2535fb5126e54)(stageHandler)) stageHandler = {
            overallReset: stageHandler,
            seriesType: $7982fe5ed36bab1b$var$detectSeriseType(stageHandler)
        };
        stageHandler.uid = (0, $f7a89889802a4565$export$6d2b3473b0986646)("stageHandler");
        visualType && (stageHandler.visualType = visualType);
        return stageHandler;
    };
    return Scheduler;
}();
function $7982fe5ed36bab1b$var$overallTaskReset(context) {
    context.overallReset(context.ecModel, context.api, context.payload);
}
function $7982fe5ed36bab1b$var$stubReset(context) {
    return context.dirtyOnOverallProgress && $7982fe5ed36bab1b$var$stubProgress;
}
function $7982fe5ed36bab1b$var$stubProgress() {
    this.agent.dirty();
    this.getDownstream().dirty();
}
function $7982fe5ed36bab1b$var$stubOnDirty() {
    this.agent && this.agent.dirty();
}
function $7982fe5ed36bab1b$var$seriesTaskPlan(context) {
    return context.plan ? context.plan(context.model, context.ecModel, context.api, context.payload) : null;
}
function $7982fe5ed36bab1b$var$seriesTaskReset(context) {
    if (context.useClearVisual) context.data.clearAllVisual();
    var resetDefines = context.resetDefines = (0, $87f4a59ac66e0ee6$export$4f07b212a02c8051)(context.reset(context.model, context.ecModel, context.api, context.payload));
    return resetDefines.length > 1 ? (0, $43e0a445ed6711da$export$871de8747c9eaa88)(resetDefines, function(v, idx) {
        return $7982fe5ed36bab1b$var$makeSeriesTaskProgress(idx);
    }) : $7982fe5ed36bab1b$var$singleSeriesTaskProgress;
}
var $7982fe5ed36bab1b$var$singleSeriesTaskProgress = $7982fe5ed36bab1b$var$makeSeriesTaskProgress(0);
function $7982fe5ed36bab1b$var$makeSeriesTaskProgress(resetDefineIdx) {
    return function(params, context) {
        var data = context.data;
        var resetDefine = context.resetDefines[resetDefineIdx];
        if (resetDefine && resetDefine.dataEach) for(var i = params.start; i < params.end; i++)resetDefine.dataEach(data, i);
        else if (resetDefine && resetDefine.progress) resetDefine.progress(params, data);
    };
}
function $7982fe5ed36bab1b$var$seriesTaskCount(context) {
    return context.data.count();
}
/**
 * Only some legacy stage handlers (usually in echarts extensions) are pure function.
 * To ensure that they can work normally, they should work in block mode, that is,
 * they should not be started util the previous tasks finished. So they cause the
 * progressive rendering disabled. We try to detect the series type, to narrow down
 * the block range to only the series type they concern, but not all series.
 */ function $7982fe5ed36bab1b$var$detectSeriseType(legacyFunc) {
    $7982fe5ed36bab1b$var$seriesType = null;
    try {
        // Assume there is no async when calling `eachSeriesByType`.
        legacyFunc($7982fe5ed36bab1b$var$ecModelMock, $7982fe5ed36bab1b$var$apiMock);
    } catch (e) {}
    return $7982fe5ed36bab1b$var$seriesType;
}
var $7982fe5ed36bab1b$var$ecModelMock = {};
var $7982fe5ed36bab1b$var$apiMock = {};
var $7982fe5ed36bab1b$var$seriesType;
$7982fe5ed36bab1b$var$mockMethods($7982fe5ed36bab1b$var$ecModelMock, (0, $788e99a37a3fbb71$export$2e2bcd8739ae039));
$7982fe5ed36bab1b$var$mockMethods($7982fe5ed36bab1b$var$apiMock, (0, $00f59fca90c489d2$export$2e2bcd8739ae039));
$7982fe5ed36bab1b$var$ecModelMock.eachSeriesByType = $7982fe5ed36bab1b$var$ecModelMock.eachRawSeriesByType = function(type) {
    $7982fe5ed36bab1b$var$seriesType = type;
};
$7982fe5ed36bab1b$var$ecModelMock.eachComponent = function(cond) {
    if (cond.mainType === "series" && cond.subType) $7982fe5ed36bab1b$var$seriesType = cond.subType;
};
function $7982fe5ed36bab1b$var$mockMethods(target, Clz) {
    /* eslint-disable */ for(var name_1 in Clz.prototype)// Do not use hasOwnProperty
    target[name_1] = (0, $43e0a445ed6711da$export$8793edee2d425525);
/* eslint-enable */ }
var $7982fe5ed36bab1b$export$2e2bcd8739ae039 = $7982fe5ed36bab1b$var$Scheduler;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $c73c267370237d01$var$color = (0, $8327d823e00b772c$export$2e2bcd8739ae039).darkColor;
var $c73c267370237d01$var$backgroundColor = $c73c267370237d01$var$color.background;
var $c73c267370237d01$var$axisCommon = function() {
    return {
        axisLine: {
            lineStyle: {
                color: $c73c267370237d01$var$color.axisLine
            }
        },
        splitLine: {
            lineStyle: {
                color: $c73c267370237d01$var$color.axisSplitLine
            }
        },
        splitArea: {
            areaStyle: {
                color: [
                    $c73c267370237d01$var$color.backgroundTint,
                    $c73c267370237d01$var$color.backgroundTransparent
                ]
            }
        },
        minorSplitLine: {
            lineStyle: {
                color: $c73c267370237d01$var$color.axisMinorSplitLine
            }
        },
        axisLabel: {
            color: $c73c267370237d01$var$color.axisLabel
        },
        axisName: {}
    };
};
var $c73c267370237d01$var$matrixAxis = {
    label: {
        color: $c73c267370237d01$var$color.secondary
    },
    itemStyle: {
        borderColor: $c73c267370237d01$var$color.borderTint
    },
    dividerLineStyle: {
        color: $c73c267370237d01$var$color.border
    }
};
var $c73c267370237d01$var$theme = {
    darkMode: true,
    color: $c73c267370237d01$var$color.theme,
    backgroundColor: $c73c267370237d01$var$backgroundColor,
    axisPointer: {
        lineStyle: {
            color: $c73c267370237d01$var$color.border
        },
        crossStyle: {
            color: $c73c267370237d01$var$color.borderShade
        },
        label: {
            color: $c73c267370237d01$var$color.tertiary
        }
    },
    legend: {
        textStyle: {
            color: $c73c267370237d01$var$color.secondary
        },
        pageTextStyle: {
            color: $c73c267370237d01$var$color.tertiary
        }
    },
    textStyle: {
        color: $c73c267370237d01$var$color.secondary
    },
    title: {
        textStyle: {
            color: $c73c267370237d01$var$color.primary
        },
        subtextStyle: {
            color: $c73c267370237d01$var$color.quaternary
        }
    },
    toolbox: {
        iconStyle: {
            borderColor: $c73c267370237d01$var$color.accent50
        },
        feature: {
            dataView: {
                backgroundColor: $c73c267370237d01$var$backgroundColor,
                textColor: $c73c267370237d01$var$color.primary,
                textareaColor: $c73c267370237d01$var$color.background,
                textareaBorderColor: $c73c267370237d01$var$color.border,
                buttonColor: $c73c267370237d01$var$color.accent50,
                buttonTextColor: $c73c267370237d01$var$color.neutral00
            }
        }
    },
    tooltip: {
        backgroundColor: $c73c267370237d01$var$color.neutral20,
        defaultBorderColor: $c73c267370237d01$var$color.border,
        textStyle: {
            color: $c73c267370237d01$var$color.tertiary
        }
    },
    dataZoom: {
        borderColor: $c73c267370237d01$var$color.accent10,
        textStyle: {
            color: $c73c267370237d01$var$color.tertiary
        },
        brushStyle: {
            color: $c73c267370237d01$var$color.backgroundTint
        },
        handleStyle: {
            color: $c73c267370237d01$var$color.neutral00,
            borderColor: $c73c267370237d01$var$color.accent20
        },
        moveHandleStyle: {
            color: $c73c267370237d01$var$color.accent40
        },
        emphasis: {
            handleStyle: {
                borderColor: $c73c267370237d01$var$color.accent50
            }
        },
        dataBackground: {
            lineStyle: {
                color: $c73c267370237d01$var$color.accent30
            },
            areaStyle: {
                color: $c73c267370237d01$var$color.accent20
            }
        },
        selectedDataBackground: {
            lineStyle: {
                color: $c73c267370237d01$var$color.accent50
            },
            areaStyle: {
                color: $c73c267370237d01$var$color.accent30
            }
        }
    },
    visualMap: {
        textStyle: {
            color: $c73c267370237d01$var$color.secondary
        },
        handleStyle: {
            borderColor: $c73c267370237d01$var$color.neutral30
        }
    },
    timeline: {
        lineStyle: {
            color: $c73c267370237d01$var$color.accent10
        },
        label: {
            color: $c73c267370237d01$var$color.tertiary
        },
        controlStyle: {
            color: $c73c267370237d01$var$color.accent30,
            borderColor: $c73c267370237d01$var$color.accent30
        }
    },
    calendar: {
        itemStyle: {
            color: $c73c267370237d01$var$color.neutral00,
            borderColor: $c73c267370237d01$var$color.neutral20
        },
        dayLabel: {
            color: $c73c267370237d01$var$color.tertiary
        },
        monthLabel: {
            color: $c73c267370237d01$var$color.secondary
        },
        yearLabel: {
            color: $c73c267370237d01$var$color.secondary
        }
    },
    matrix: {
        x: $c73c267370237d01$var$matrixAxis,
        y: $c73c267370237d01$var$matrixAxis,
        backgroundColor: {
            borderColor: $c73c267370237d01$var$color.axisLine
        },
        body: {
            itemStyle: {
                borderColor: $c73c267370237d01$var$color.borderTint
            }
        }
    },
    timeAxis: $c73c267370237d01$var$axisCommon(),
    logAxis: $c73c267370237d01$var$axisCommon(),
    valueAxis: $c73c267370237d01$var$axisCommon(),
    categoryAxis: $c73c267370237d01$var$axisCommon(),
    line: {
        symbol: "circle"
    },
    graph: {
        color: $c73c267370237d01$var$color.theme
    },
    gauge: {
        title: {
            color: $c73c267370237d01$var$color.secondary
        },
        axisLine: {
            lineStyle: {
                color: [
                    [
                        1,
                        $c73c267370237d01$var$color.neutral05
                    ]
                ]
            }
        },
        axisLabel: {
            color: $c73c267370237d01$var$color.axisLabel
        },
        detail: {
            color: $c73c267370237d01$var$color.primary
        }
    },
    candlestick: {
        itemStyle: {
            color: "#f64e56",
            color0: "#54ea92",
            borderColor: "#f64e56",
            borderColor0: "#54ea92"
        }
    },
    funnel: {
        itemStyle: {
            borderColor: $c73c267370237d01$var$color.background
        }
    },
    radar: function() {
        var radar = $c73c267370237d01$var$axisCommon();
        radar.axisName = {
            color: $c73c267370237d01$var$color.axisLabel
        };
        radar.axisLine.lineStyle.color = $c73c267370237d01$var$color.neutral20;
        return radar;
    }(),
    treemap: {
        breadcrumb: {
            itemStyle: {
                color: $c73c267370237d01$var$color.neutral20,
                textStyle: {
                    color: $c73c267370237d01$var$color.secondary
                }
            },
            emphasis: {
                itemStyle: {
                    color: $c73c267370237d01$var$color.neutral30
                }
            }
        }
    },
    sunburst: {
        itemStyle: {
            borderColor: $c73c267370237d01$var$color.background
        }
    },
    map: {
        itemStyle: {
            borderColor: $c73c267370237d01$var$color.border,
            areaColor: $c73c267370237d01$var$color.neutral10
        },
        label: {
            color: $c73c267370237d01$var$color.tertiary
        },
        emphasis: {
            label: {
                color: $c73c267370237d01$var$color.primary
            },
            itemStyle: {
                areaColor: $c73c267370237d01$var$color.highlight
            }
        },
        select: {
            label: {
                color: $c73c267370237d01$var$color.primary
            },
            itemStyle: {
                areaColor: $c73c267370237d01$var$color.highlight
            }
        }
    },
    geo: {
        itemStyle: {
            borderColor: $c73c267370237d01$var$color.border,
            areaColor: $c73c267370237d01$var$color.neutral10
        },
        emphasis: {
            label: {
                color: $c73c267370237d01$var$color.primary
            },
            itemStyle: {
                areaColor: $c73c267370237d01$var$color.highlight
            }
        },
        select: {
            label: {
                color: $c73c267370237d01$var$color.primary
            },
            itemStyle: {
                color: $c73c267370237d01$var$color.highlight
            }
        }
    }
};
$c73c267370237d01$var$theme.categoryAxis.splitLine.show = false;
var $c73c267370237d01$export$2e2bcd8739ae039 = $c73c267370237d01$var$theme;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/**
 * Usage of query:
 * `chart.on('click', query, handler);`
 * The `query` can be:
 * + The component type query string, only `mainType` or `mainType.subType`,
 *   like: 'xAxis', 'series', 'xAxis.category' or 'series.line'.
 * + The component query object, like:
 *   `{seriesIndex: 2}`, `{seriesName: 'xx'}`, `{seriesId: 'some'}`,
 *   `{xAxisIndex: 2}`, `{xAxisName: 'xx'}`, `{xAxisId: 'some'}`.
 * + The data query object, like:
 *   `{dataIndex: 123}`, `{dataType: 'link'}`, `{name: 'some'}`.
 * + The other query object (cmponent customized query), like:
 *   `{element: 'some'}` (only available in custom series).
 *
 * Caveat: If a prop in the `query` object is `null/undefined`, it is the
 * same as there is no such prop in the `query` object.
 */ var $a274655c8c7e1675$export$d0fd09f950257b52 = /** @class */ function() {
    function ECEventProcessor() {}
    ECEventProcessor.prototype.normalizeQuery = function(query) {
        var cptQuery = {};
        var dataQuery = {};
        var otherQuery = {};
        // `query` is `mainType` or `mainType.subType` of component.
        if ($43e0a445ed6711da$export$844ec244b1367d54(query)) {
            var condCptType = (0, $10ce7a4361c3910c$export$fbe18865d303bf01)(query);
            // `.main` and `.sub` may be ''.
            cptQuery.mainType = condCptType.main || null;
            cptQuery.subType = condCptType.sub || null;
        } else {
            // `xxxIndex`, `xxxName`, `xxxId`, `name`, `dataIndex`, `dataType` is reserved,
            // can not be used in `compomentModel.filterForExposedEvent`.
            var suffixes_1 = [
                "Index",
                "Name",
                "Id"
            ];
            var dataKeys_1 = {
                name: 1,
                dataIndex: 1,
                dataType: 1
            };
            $43e0a445ed6711da$export$79b2f7037acddd43(query, function(val, key) {
                var reserved = false;
                for(var i = 0; i < suffixes_1.length; i++){
                    var propSuffix = suffixes_1[i];
                    var suffixPos = key.lastIndexOf(propSuffix);
                    if (suffixPos > 0 && suffixPos === key.length - propSuffix.length) {
                        var mainType = key.slice(0, suffixPos);
                        // Consider `dataIndex`.
                        if (mainType !== "data") {
                            cptQuery.mainType = mainType;
                            cptQuery[propSuffix.toLowerCase()] = val;
                            reserved = true;
                        }
                    }
                }
                if (dataKeys_1.hasOwnProperty(key)) {
                    dataQuery[key] = val;
                    reserved = true;
                }
                if (!reserved) otherQuery[key] = val;
            });
        }
        return {
            cptQuery: cptQuery,
            dataQuery: dataQuery,
            otherQuery: otherQuery
        };
    };
    ECEventProcessor.prototype.filter = function(eventType, query) {
        // They should be assigned before each trigger call.
        var eventInfo = this.eventInfo;
        if (!eventInfo) return true;
        var targetEl = eventInfo.targetEl;
        var packedEvent = eventInfo.packedEvent;
        var model = eventInfo.model;
        var view = eventInfo.view;
        // For event like 'globalout'.
        if (!model || !view) return true;
        var cptQuery = query.cptQuery;
        var dataQuery = query.dataQuery;
        return check(cptQuery, model, "mainType") && check(cptQuery, model, "subType") && check(cptQuery, model, "index", "componentIndex") && check(cptQuery, model, "name") && check(cptQuery, model, "id") && check(dataQuery, packedEvent, "name") && check(dataQuery, packedEvent, "dataIndex") && check(dataQuery, packedEvent, "dataType") && (!view.filterForExposedEvent || view.filterForExposedEvent(eventType, query.otherQuery, targetEl, packedEvent));
        function check(query, host, prop, propOnHost) {
            return query[prop] == null || host[propOnHost || prop] === query[prop];
        }
    };
    ECEventProcessor.prototype.afterTrigger = function() {
        // Make sure the eventInfo won't be used in next trigger.
        this.eventInfo = null;
    };
    return ECEventProcessor;
}();



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $682692c8c595d5c5$var$SYMBOL_PROPS_WITH_CB = [
    "symbol",
    "symbolSize",
    "symbolRotate",
    "symbolOffset"
];
var $682692c8c595d5c5$var$SYMBOL_PROPS = $682692c8c595d5c5$var$SYMBOL_PROPS_WITH_CB.concat([
    "symbolKeepAspect"
]);
// Encoding visual for all series include which is filtered for legend drawing
var $682692c8c595d5c5$export$144ac3beded415d9 = {
    createOnAllSeries: true,
    // For legend.
    performRawSeries: true,
    reset: function(seriesModel, ecModel) {
        var data = seriesModel.getData();
        if (seriesModel.legendIcon) data.setVisual("legendIcon", seriesModel.legendIcon);
        if (!seriesModel.hasSymbolVisual) return;
        var symbolOptions = {};
        var symbolOptionsCb = {};
        var hasCallback = false;
        for(var i = 0; i < $682692c8c595d5c5$var$SYMBOL_PROPS_WITH_CB.length; i++){
            var symbolPropName = $682692c8c595d5c5$var$SYMBOL_PROPS_WITH_CB[i];
            var val = seriesModel.get(symbolPropName);
            if ((0, $43e0a445ed6711da$export$f6e2535fb5126e54)(val)) {
                hasCallback = true;
                symbolOptionsCb[symbolPropName] = val;
            } else symbolOptions[symbolPropName] = val;
        }
        symbolOptions.symbol = symbolOptions.symbol || seriesModel.defaultSymbol;
        data.setVisual((0, $43e0a445ed6711da$export$8b58be045bf06082)({
            legendIcon: seriesModel.legendIcon || symbolOptions.symbol,
            symbolKeepAspect: seriesModel.get("symbolKeepAspect")
        }, symbolOptions));
        // Only visible series has each data be visual encoded
        if (ecModel.isSeriesFiltered(seriesModel)) return;
        var symbolPropsCb = (0, $43e0a445ed6711da$export$ed97f33186d4b816)(symbolOptionsCb);
        function dataEach(data, idx) {
            var rawValue = seriesModel.getRawValue(idx);
            var params = seriesModel.getDataParams(idx);
            for(var i = 0; i < symbolPropsCb.length; i++){
                var symbolPropName = symbolPropsCb[i];
                data.setItemVisual(idx, symbolPropName, symbolOptionsCb[symbolPropName](rawValue, params));
            }
        }
        return {
            dataEach: hasCallback ? dataEach : null
        };
    }
};
var $682692c8c595d5c5$export$435b956f7f1071fb = {
    createOnAllSeries: true,
    // For legend.
    performRawSeries: true,
    reset: function(seriesModel, ecModel) {
        if (!seriesModel.hasSymbolVisual) return;
        // Only visible series has each data be visual encoded
        if (ecModel.isSeriesFiltered(seriesModel)) return;
        var data = seriesModel.getData();
        function dataEach(data, idx) {
            var itemModel = data.getItemModel(idx);
            for(var i = 0; i < $682692c8c595d5c5$var$SYMBOL_PROPS.length; i++){
                var symbolPropName = $682692c8c595d5c5$var$SYMBOL_PROPS[i];
                var val = itemModel.getShallow(symbolPropName, true);
                if (val != null) data.setItemVisual(idx, symbolPropName, val);
            }
        }
        return {
            dataEach: data.hasItemOption ? dataEach : null
        };
    }
};


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $76af5bb296a0e67b$export$91d919a86b2df624(data, dataIndex, key) {
    switch(key){
        case "color":
            var style = data.getItemVisual(dataIndex, "style");
            return style[data.getVisual("drawType")];
        case "opacity":
            return data.getItemVisual(dataIndex, "style").opacity;
        case "symbol":
        case "symbolSize":
        case "liftZ":
            return data.getItemVisual(dataIndex, key);
        default:
    }
}
function $76af5bb296a0e67b$export$d76e333a86ea1a2(data, key) {
    switch(key){
        case "color":
            var style = data.getVisual("style");
            return style[data.getVisual("drawType")];
        case "opacity":
            return data.getVisual("style").opacity;
        case "symbol":
        case "symbolSize":
        case "liftZ":
            return data.getVisual(key);
        default:
    }
}
function $76af5bb296a0e67b$export$3aab879e9d0e7c75(data, dataIndex, key, value) {
    switch(key){
        case "color":
            // Make sure not sharing style object.
            var style = data.ensureUniqueItemVisual(dataIndex, "style");
            style[data.getVisual("drawType")] = value;
            // Mark the color has been changed, not from palette anymore
            data.setItemVisual(dataIndex, "colorFromPalette", false);
            break;
        case "opacity":
            data.ensureUniqueItemVisual(dataIndex, "style").opacity = value;
            break;
        case "symbol":
        case "symbolSize":
        case "liftZ":
            data.setItemVisual(dataIndex, key, value);
            break;
        default:
    }
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $5779b3a999a9cae1$export$62942ba95693dbfc(seriesType, ecRegisterAction) {
    function getSeriesIndices(ecModel, payload) {
        var seriesIndices = [];
        ecModel.eachComponent({
            mainType: "series",
            subType: seriesType,
            query: payload
        }, function(seriesModel) {
            seriesIndices.push(seriesModel.seriesIndex);
        });
        return seriesIndices;
    }
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)([
        [
            seriesType + "ToggleSelect",
            "toggleSelect"
        ],
        [
            seriesType + "Select",
            "select"
        ],
        [
            seriesType + "UnSelect",
            "unselect"
        ]
    ], function(eventsMap) {
        ecRegisterAction(eventsMap[0], function(payload, ecModel, api) {
            payload = (0, $43e0a445ed6711da$export$8b58be045bf06082)({}, payload);
            api.dispatchAction((0, $43e0a445ed6711da$export$8b58be045bf06082)(payload, {
                type: eventsMap[1],
                seriesIndex: getSeriesIndices(ecModel, payload)
            }));
        });
    });
}
function $5779b3a999a9cae1$var$handleSeriesLegacySelectEvents(type, eventPostfix, ecIns, ecModel, payload) {
    var legacyEventName = type + eventPostfix;
    if (!ecIns.isSilent(legacyEventName)) ecModel.eachComponent({
        mainType: "series",
        subType: "pie"
    }, function(seriesModel) {
        var seriesIndex = seriesModel.seriesIndex;
        var selectedMap = seriesModel.option.selectedMap;
        var selected = payload.selected;
        for(var i = 0; i < selected.length; i++)if (selected[i].seriesIndex === seriesIndex) {
            var data = seriesModel.getData();
            var dataIndex = (0, $87f4a59ac66e0ee6$export$42b26cae8b8d10)(data, payload.fromActionPayload);
            ecIns.trigger(legacyEventName, {
                type: legacyEventName,
                seriesId: seriesModel.id,
                name: (0, $43e0a445ed6711da$export$43bee75e5e14138e)(dataIndex) ? data.getName(dataIndex[0]) : data.getName(dataIndex),
                selected: (0, $43e0a445ed6711da$export$844ec244b1367d54)(selectedMap) ? selectedMap : (0, $43e0a445ed6711da$export$8b58be045bf06082)({}, selectedMap)
            });
        }
    });
}
function $5779b3a999a9cae1$export$2575c83262e49d0c(messageCenter, ecIns, api) {
    messageCenter.on("selectchanged", function(params) {
        var ecModel = api.getModel();
        if (params.isFromClick) {
            $5779b3a999a9cae1$var$handleSeriesLegacySelectEvents("map", "selectchanged", ecIns, ecModel, params);
            $5779b3a999a9cae1$var$handleSeriesLegacySelectEvents("pie", "selectchanged", ecIns, ecModel, params);
        } else if (params.fromAction === "select") {
            $5779b3a999a9cae1$var$handleSeriesLegacySelectEvents("map", "selected", ecIns, ecModel, params);
            $5779b3a999a9cae1$var$handleSeriesLegacySelectEvents("pie", "selected", ecIns, ecModel, params);
        } else if (params.fromAction === "unselect") {
            $5779b3a999a9cae1$var$handleSeriesLegacySelectEvents("map", "unselected", ecIns, ecModel, params);
            $5779b3a999a9cae1$var$handleSeriesLegacySelectEvents("pie", "unselected", ecIns, ecModel, params);
        }
    });
}




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $10e23f9ea92ef04e$export$8a4fca9e04eb4df6(target, det, returnFirstMatch) {
    var found;
    while(target){
        if (det(target)) {
            found = target;
            if (returnFirstMatch) break;
        }
        target = target.__hostTarget || target.parent;
    }
    return found;
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $567b7069bdf5f856$var$lifecycle = new (0, $131b7833cdf735df$export$2e2bcd8739ae039)();
var $567b7069bdf5f856$export$2e2bcd8739ae039 = $567b7069bdf5f856$var$lifecycle;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
// Implementation of exported APIs. For example registerMap, getMap.
// The implementations will be registered when installing the component.
// Avoid these code being bundled to the core module.
var $8a21e81d789730a0$var$implsStore = {};
function $8a21e81d789730a0$export$9b808fd12256ddd3(name, impl) {
    $8a21e81d789730a0$var$implsStore[name] = impl;
}
function $8a21e81d789730a0$export$73333eb8a09d5f61(name) {
    return $8a21e81d789730a0$var$implsStore[name];
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $fbd66d714849991d$var$customRenderers = {};
function $fbd66d714849991d$export$c3e61191887968da(type, renderItem) {
    $fbd66d714849991d$var$customRenderers[type] = renderItem;
}
function $fbd66d714849991d$export$2b5db8e5650e8d15(type) {
    return $fbd66d714849991d$var$customRenderers[type];
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $b6f52a1ffb51de17$var$ecModelCacheInner = (0, $87f4a59ac66e0ee6$export$64df9f8d92ae083f)();
function $b6f52a1ffb51de17$export$54b70eb74482271e(ecModel) {
    $b6f52a1ffb51de17$var$ecModelCacheInner(ecModel).prepare = {};
}
function $b6f52a1ffb51de17$export$7a0372e5df3ca6f4(ecModel) {
    $b6f52a1ffb51de17$var$ecModelCacheInner(ecModel).fullUpdate = {};
}
function $b6f52a1ffb51de17$export$67fb26d0f4e31b9e(ecModel) {
    return $b6f52a1ffb51de17$var$ecModelCacheInner(ecModel).prepare;
}
function $b6f52a1ffb51de17$export$14434b56aab40385(ecModel) {
    return $b6f52a1ffb51de17$var$ecModelCacheInner(ecModel).fullUpdate;
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $c4818bfd4f0c62e6$var$wmUniqueIndex = Math.round(Math.random() * 9);
var $c4818bfd4f0c62e6$var$supportDefineProperty = typeof Object.defineProperty === "function";
var $c4818bfd4f0c62e6$var$WeakMap = function() {
    function WeakMap() {
        this._id = "__ec_inner_" + $c4818bfd4f0c62e6$var$wmUniqueIndex++;
    }
    WeakMap.prototype.get = function(key) {
        return this._guard(key)[this._id];
    };
    WeakMap.prototype.set = function(key, value) {
        var target = this._guard(key);
        if ($c4818bfd4f0c62e6$var$supportDefineProperty) Object.defineProperty(target, this._id, {
            value: value,
            enumerable: false,
            configurable: true
        });
        else target[this._id] = value;
        return this;
    };
    WeakMap.prototype["delete"] = function(key) {
        if (this.has(key)) {
            delete this._guard(key)[this._id];
            return true;
        }
        return false;
    };
    WeakMap.prototype.has = function(key) {
        return !!this._guard(key)[this._id];
    };
    WeakMap.prototype._guard = function(key) {
        if (key !== Object(key)) throw TypeError("Value of WeakMap is not a non-null object.");
        return key;
    };
    return WeakMap;
}();
var $c4818bfd4f0c62e6$export$2e2bcd8739ae039 = $c4818bfd4f0c62e6$var$WeakMap;





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Symbol factory






/**
 * Triangle shape
 * @inner
 */ var $4ff41a845d4679a6$var$Triangle = $227e31075465dcd4$export$2e2bcd8739ae039.extend({
    type: "triangle",
    shape: {
        cx: 0,
        cy: 0,
        width: 0,
        height: 0
    },
    buildPath: function(path, shape) {
        var cx = shape.cx;
        var cy = shape.cy;
        var width = shape.width / 2;
        var height = shape.height / 2;
        path.moveTo(cx, cy - height);
        path.lineTo(cx + width, cy + height);
        path.lineTo(cx - width, cy + height);
        path.closePath();
    }
});
/**
 * Diamond shape
 * @inner
 */ var $4ff41a845d4679a6$var$Diamond = $227e31075465dcd4$export$2e2bcd8739ae039.extend({
    type: "diamond",
    shape: {
        cx: 0,
        cy: 0,
        width: 0,
        height: 0
    },
    buildPath: function(path, shape) {
        var cx = shape.cx;
        var cy = shape.cy;
        var width = shape.width / 2;
        var height = shape.height / 2;
        path.moveTo(cx, cy - height);
        path.lineTo(cx + width, cy);
        path.lineTo(cx, cy + height);
        path.lineTo(cx - width, cy);
        path.closePath();
    }
});
/**
 * Pin shape
 * @inner
 */ var $4ff41a845d4679a6$var$Pin = $227e31075465dcd4$export$2e2bcd8739ae039.extend({
    type: "pin",
    shape: {
        // x, y on the cusp
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    buildPath: function(path, shape) {
        var x = shape.x;
        var y = shape.y;
        var w = shape.width / 5 * 3;
        // Height must be larger than width
        var h = Math.max(w, shape.height);
        var r = w / 2;
        // Dist on y with tangent point and circle center
        var dy = r * r / (h - r);
        var cy = y - h + r + dy;
        var angle = Math.asin(dy / r);
        // Dist on x with tangent point and circle center
        var dx = Math.cos(angle) * r;
        var tanX = Math.sin(angle);
        var tanY = Math.cos(angle);
        var cpLen = r * 0.6;
        var cpLen2 = r * 0.7;
        path.moveTo(x - dx, cy + dy);
        path.arc(x, cy, r, Math.PI - angle, Math.PI * 2 + angle);
        path.bezierCurveTo(x + dx - tanX * cpLen, cy + dy + tanY * cpLen, x, y - cpLen2, x, y);
        path.bezierCurveTo(x, y - cpLen2, x - dx + tanX * cpLen, cy + dy + tanY * cpLen, x - dx, cy + dy);
        path.closePath();
    }
});
/**
 * Arrow shape
 * @inner
 */ var $4ff41a845d4679a6$var$Arrow = $227e31075465dcd4$export$2e2bcd8739ae039.extend({
    type: "arrow",
    shape: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    buildPath: function(ctx, shape) {
        var height = shape.height;
        var width = shape.width;
        var x = shape.x;
        var y = shape.y;
        var dx = width / 3 * 2;
        ctx.moveTo(x, y);
        ctx.lineTo(x + dx, y + height);
        ctx.lineTo(x, y + height / 4 * 3);
        ctx.lineTo(x - dx, y + height);
        ctx.lineTo(x, y);
        ctx.closePath();
    }
});
/**
 * Map of path constructors
 */ // TODO Use function to build symbol path.
var $4ff41a845d4679a6$var$symbolCtors = {
    line: $0e0ee2afac2bc66d$export$2e2bcd8739ae039,
    rect: $42ed508a93973e78$export$2e2bcd8739ae039,
    roundRect: $42ed508a93973e78$export$2e2bcd8739ae039,
    square: $42ed508a93973e78$export$2e2bcd8739ae039,
    circle: $55c0fda972a24142$export$2e2bcd8739ae039,
    diamond: $4ff41a845d4679a6$var$Diamond,
    pin: $4ff41a845d4679a6$var$Pin,
    arrow: $4ff41a845d4679a6$var$Arrow,
    triangle: $4ff41a845d4679a6$var$Triangle
};
var $4ff41a845d4679a6$var$symbolShapeMakers = {
    line: function(x, y, w, h, shape) {
        shape.x1 = x;
        shape.y1 = y + h / 2;
        shape.x2 = x + w;
        shape.y2 = y + h / 2;
    },
    rect: function(x, y, w, h, shape) {
        shape.x = x;
        shape.y = y;
        shape.width = w;
        shape.height = h;
    },
    roundRect: function(x, y, w, h, shape) {
        shape.x = x;
        shape.y = y;
        shape.width = w;
        shape.height = h;
        shape.r = Math.min(w, h) / 4;
    },
    square: function(x, y, w, h, shape) {
        var size = Math.min(w, h);
        shape.x = x;
        shape.y = y;
        shape.width = size;
        shape.height = size;
    },
    circle: function(x, y, w, h, shape) {
        // Put circle in the center of square
        shape.cx = x + w / 2;
        shape.cy = y + h / 2;
        shape.r = Math.min(w, h) / 2;
    },
    diamond: function(x, y, w, h, shape) {
        shape.cx = x + w / 2;
        shape.cy = y + h / 2;
        shape.width = w;
        shape.height = h;
    },
    pin: function(x, y, w, h, shape) {
        shape.x = x + w / 2;
        shape.y = y + h / 2;
        shape.width = w;
        shape.height = h;
    },
    arrow: function(x, y, w, h, shape) {
        shape.x = x + w / 2;
        shape.y = y + h / 2;
        shape.width = w;
        shape.height = h;
    },
    triangle: function(x, y, w, h, shape) {
        shape.cx = x + w / 2;
        shape.cy = y + h / 2;
        shape.width = w;
        shape.height = h;
    }
};
var $4ff41a845d4679a6$export$33fc3b478d332725 = {};
(0, $43e0a445ed6711da$export$79b2f7037acddd43)($4ff41a845d4679a6$var$symbolCtors, function(Ctor, name) {
    $4ff41a845d4679a6$export$33fc3b478d332725[name] = new Ctor();
});
var $4ff41a845d4679a6$var$SymbolClz = $227e31075465dcd4$export$2e2bcd8739ae039.extend({
    type: "symbol",
    shape: {
        symbolType: "",
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    calculateTextPosition: function(out, config, rect) {
        var res = (0, $67e15a06bdb46d49$export$eee3603b512feab7)(out, config, rect);
        var shape = this.shape;
        if (shape && shape.symbolType === "pin" && config.position === "inside") res.y = rect.y + rect.height * 0.4;
        return res;
    },
    buildPath: function(ctx, shape, inBundle) {
        var symbolType = shape.symbolType;
        if (symbolType !== "none") {
            var proxySymbol = $4ff41a845d4679a6$export$33fc3b478d332725[symbolType];
            if (!proxySymbol) {
                // Default rect
                symbolType = "rect";
                proxySymbol = $4ff41a845d4679a6$export$33fc3b478d332725[symbolType];
            }
            $4ff41a845d4679a6$var$symbolShapeMakers[symbolType](shape.x, shape.y, shape.width, shape.height, proxySymbol.shape);
            proxySymbol.buildPath(ctx, proxySymbol.shape, inBundle);
        }
    }
});
// Provide setColor helper method to avoid determine if set the fill or stroke outside
function $4ff41a845d4679a6$var$symbolPathSetColor(color, innerColor) {
    if (this.type !== "image") {
        var symbolStyle = this.style;
        if (this.__isEmptyBrush) {
            symbolStyle.stroke = color;
            symbolStyle.fill = innerColor || (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.neutral00;
            // TODO Same width with lineStyle in LineView
            symbolStyle.lineWidth = 2;
        } else if (this.shape.symbolType === "line") symbolStyle.stroke = color;
        else symbolStyle.fill = color;
        this.markRedraw();
    }
}
function $4ff41a845d4679a6$export$af050e04da3a02e8(symbolType, x, y, w, h, color, // whether to keep the ratio of w/h,
keepAspect) {
    // TODO Support image object, DynamicImage.
    var isEmpty = symbolType.indexOf("empty") === 0;
    if (isEmpty) symbolType = symbolType.substr(5, 1).toLowerCase() + symbolType.substr(6);
    var symbolPath;
    if (symbolType.indexOf("image://") === 0) symbolPath = $6552edac5ca572b1$export$7a2bdede98851ac5(symbolType.slice(8), new (0, $c437f598d9c9ee16$export$2e2bcd8739ae039)(x, y, w, h), keepAspect ? "center" : "cover");
    else if (symbolType.indexOf("path://") === 0) symbolPath = $6552edac5ca572b1$export$aa9bab72412f5613(symbolType.slice(7), {}, new (0, $c437f598d9c9ee16$export$2e2bcd8739ae039)(x, y, w, h), keepAspect ? "center" : "cover");
    else symbolPath = new $4ff41a845d4679a6$var$SymbolClz({
        shape: {
            symbolType: symbolType,
            x: x,
            y: y,
            width: w,
            height: h
        }
    });
    symbolPath.__isEmptyBrush = isEmpty;
    // TODO Should deprecate setColor
    symbolPath.setColor = $4ff41a845d4679a6$var$symbolPathSetColor;
    if (color) symbolPath.setColor(color);
    return symbolPath;
}
function $4ff41a845d4679a6$export$a84524f03e8e8dfb(symbolSize) {
    if (!(0, $43e0a445ed6711da$export$43bee75e5e14138e)(symbolSize)) symbolSize = [
        +symbolSize,
        +symbolSize
    ];
    return [
        symbolSize[0] || 0,
        symbolSize[1] || 0
    ];
}
function $4ff41a845d4679a6$export$e3e292895c033f6d(symbolOffset, symbolSize) {
    if (symbolOffset == null) return;
    if (!(0, $43e0a445ed6711da$export$43bee75e5e14138e)(symbolOffset)) symbolOffset = [
        symbolOffset,
        symbolOffset
    ];
    return [
        (0, $b49750109e236fd8$export$e8514cb5a5e2b40f)(symbolOffset[0], symbolSize[0]) || 0,
        (0, $b49750109e236fd8$export$e8514cb5a5e2b40f)((0, $43e0a445ed6711da$export$995e01f2f5c9d030)(symbolOffset[1], symbolOffset[0]), symbolSize[1]) || 0
    ];
}





function $0aca998062cac624$var$isSafeNum(num) {
    return isFinite(num);
}
function $0aca998062cac624$export$235c7ac50fe1db0a(ctx, obj, rect) {
    var x = obj.x == null ? 0 : obj.x;
    var x2 = obj.x2 == null ? 1 : obj.x2;
    var y = obj.y == null ? 0 : obj.y;
    var y2 = obj.y2 == null ? 0 : obj.y2;
    if (!obj.global) {
        x = x * rect.width + rect.x;
        x2 = x2 * rect.width + rect.x;
        y = y * rect.height + rect.y;
        y2 = y2 * rect.height + rect.y;
    }
    x = $0aca998062cac624$var$isSafeNum(x) ? x : 0;
    x2 = $0aca998062cac624$var$isSafeNum(x2) ? x2 : 1;
    y = $0aca998062cac624$var$isSafeNum(y) ? y : 0;
    y2 = $0aca998062cac624$var$isSafeNum(y2) ? y2 : 0;
    var canvasGradient = ctx.createLinearGradient(x, y, x2, y2);
    return canvasGradient;
}
function $0aca998062cac624$export$57f098206d57a443(ctx, obj, rect) {
    var width = rect.width;
    var height = rect.height;
    var min = Math.min(width, height);
    var x = obj.x == null ? 0.5 : obj.x;
    var y = obj.y == null ? 0.5 : obj.y;
    var r = obj.r == null ? 0.5 : obj.r;
    if (!obj.global) {
        x = x * width + rect.x;
        y = y * height + rect.y;
        r = r * min;
    }
    x = $0aca998062cac624$var$isSafeNum(x) ? x : 0.5;
    y = $0aca998062cac624$var$isSafeNum(y) ? y : 0.5;
    r = r >= 0 && $0aca998062cac624$var$isSafeNum(r) ? r : 0.5;
    var canvasGradient = ctx.createRadialGradient(x, y, 0, x, y, r);
    return canvasGradient;
}
function $0aca998062cac624$export$3dab6afd018d48c7(ctx, obj, rect) {
    var canvasGradient = obj.type === "radial" ? $0aca998062cac624$export$57f098206d57a443(ctx, obj, rect) : $0aca998062cac624$export$235c7ac50fe1db0a(ctx, obj, rect);
    var colorStops = obj.colorStops;
    for(var i = 0; i < colorStops.length; i++)canvasGradient.addColorStop(colorStops[i].offset, colorStops[i].color);
    return canvasGradient;
}
function $0aca998062cac624$export$beeddc5150cb2e83(clipPaths, prevClipPaths) {
    if (clipPaths === prevClipPaths || !clipPaths && !prevClipPaths) return false;
    if (!clipPaths || !prevClipPaths || clipPaths.length !== prevClipPaths.length) return true;
    for(var i = 0; i < clipPaths.length; i++){
        if (clipPaths[i] !== prevClipPaths[i]) return true;
    }
    return false;
}
function $0aca998062cac624$var$parseInt10(val) {
    return parseInt(val, 10);
}
function $0aca998062cac624$export$31b21d0167753bb4(root, whIdx, opts) {
    var wh = [
        "width",
        "height"
    ][whIdx];
    var cwh = [
        "clientWidth",
        "clientHeight"
    ][whIdx];
    var plt = [
        "paddingLeft",
        "paddingTop"
    ][whIdx];
    var prb = [
        "paddingRight",
        "paddingBottom"
    ][whIdx];
    if (opts[wh] != null && opts[wh] !== "auto") return parseFloat(opts[wh]);
    var stl = document.defaultView.getComputedStyle(root);
    return (root[cwh] || $0aca998062cac624$var$parseInt10(stl[wh]) || $0aca998062cac624$var$parseInt10(root.style[wh])) - ($0aca998062cac624$var$parseInt10(stl[plt]) || 0) - ($0aca998062cac624$var$parseInt10(stl[prb]) || 0) || 0;
}







function $cf1c665c8b2c91a8$export$9efb2ae8a603855d(lineType, lineWidth) {
    if (!lineType || lineType === "solid" || !(lineWidth > 0)) return null;
    return lineType === "dashed" ? [
        4 * lineWidth,
        2 * lineWidth
    ] : lineType === "dotted" ? [
        lineWidth
    ] : (0, $43e0a445ed6711da$export$7e4aa119212bc614)(lineType) ? [
        lineType
    ] : (0, $43e0a445ed6711da$export$43bee75e5e14138e)(lineType) ? lineType : null;
}
function $cf1c665c8b2c91a8$export$9d315911f153b3b2(el) {
    var style = el.style;
    var lineDash = style.lineDash && style.lineWidth > 0 && $cf1c665c8b2c91a8$export$9efb2ae8a603855d(style.lineDash, style.lineWidth);
    var lineDashOffset = style.lineDashOffset;
    if (lineDash) {
        var lineScale_1 = style.strokeNoScale && el.getLineScale ? el.getLineScale() : 1;
        if (lineScale_1 && lineScale_1 !== 1) {
            lineDash = (0, $43e0a445ed6711da$export$871de8747c9eaa88)(lineDash, function(rawVal) {
                return rawVal / lineScale_1;
            });
            lineDashOffset /= lineScale_1;
        }
    }
    return [
        lineDash,
        lineDashOffset
    ];
}




var $6bc3d3dcea2beb63$var$pathProxyForDraw = new (0, $e2a16933ef78a053$export$2e2bcd8739ae039)(true);
function $6bc3d3dcea2beb63$var$styleHasStroke(style) {
    var stroke = style.stroke;
    return !(stroke == null || stroke === "none" || !(style.lineWidth > 0));
}
function $6bc3d3dcea2beb63$var$isValidStrokeFillStyle(strokeOrFill) {
    return typeof strokeOrFill === "string" && strokeOrFill !== "none";
}
function $6bc3d3dcea2beb63$var$styleHasFill(style) {
    var fill = style.fill;
    return fill != null && fill !== "none";
}
function $6bc3d3dcea2beb63$var$doFillPath(ctx, style) {
    if (style.fillOpacity != null && style.fillOpacity !== 1) {
        var originalGlobalAlpha = ctx.globalAlpha;
        ctx.globalAlpha = style.fillOpacity * style.opacity;
        ctx.fill();
        ctx.globalAlpha = originalGlobalAlpha;
    } else ctx.fill();
}
function $6bc3d3dcea2beb63$var$doStrokePath(ctx, style) {
    if (style.strokeOpacity != null && style.strokeOpacity !== 1) {
        var originalGlobalAlpha = ctx.globalAlpha;
        ctx.globalAlpha = style.strokeOpacity * style.opacity;
        ctx.stroke();
        ctx.globalAlpha = originalGlobalAlpha;
    } else ctx.stroke();
}
function $6bc3d3dcea2beb63$export$8eb5db6b7bc27903(ctx, pattern, el) {
    var image = (0, $b3b93921504aa1e2$export$46c791b69ff9a0f)(pattern.image, pattern.__image, el);
    if ((0, $b3b93921504aa1e2$export$37ca7dd901d0236d)(image)) {
        var canvasPattern = ctx.createPattern(image, pattern.repeat || "repeat");
        if (typeof DOMMatrix === "function" && canvasPattern && canvasPattern.setTransform) {
            var matrix = new DOMMatrix();
            matrix.translateSelf(pattern.x || 0, pattern.y || 0);
            matrix.rotateSelf(0, 0, (pattern.rotation || 0) * (0, $43e0a445ed6711da$export$bce8e055322a0ce6));
            matrix.scaleSelf(pattern.scaleX || 1, pattern.scaleY || 1);
            canvasPattern.setTransform(matrix);
        }
        return canvasPattern;
    }
}
function $6bc3d3dcea2beb63$var$brushPath(ctx, el, style, canBatch, scope) {
    var _a;
    var hasStroke = $6bc3d3dcea2beb63$var$styleHasStroke(style);
    var hasFill = $6bc3d3dcea2beb63$var$styleHasFill(style);
    var strokePercent = style.strokePercent;
    var strokePart = strokePercent < 1;
    var firstDraw = !el.path;
    if ((!el.silent || strokePart) && firstDraw) el.createPathProxy();
    var path = el.path || $6bc3d3dcea2beb63$var$pathProxyForDraw;
    var dirtyFlag = el.__dirty;
    if (!canBatch) {
        var fill = style.fill;
        var stroke = style.stroke;
        var hasFillGradient = hasFill && !!fill.colorStops;
        var hasStrokeGradient = hasStroke && !!stroke.colorStops;
        var hasFillPattern = hasFill && !!fill.image;
        var hasStrokePattern = hasStroke && !!stroke.image;
        var fillGradient = void 0;
        var strokeGradient = void 0;
        var fillPattern = void 0;
        var strokePattern = void 0;
        var rect = void 0;
        if (hasFillGradient || hasStrokeGradient) rect = el.getBoundingRect();
        if (hasFillGradient) {
            fillGradient = dirtyFlag ? (0, $0aca998062cac624$export$3dab6afd018d48c7)(ctx, fill, rect) : el.__canvasFillGradient;
            el.__canvasFillGradient = fillGradient;
        }
        if (hasStrokeGradient) {
            strokeGradient = dirtyFlag ? (0, $0aca998062cac624$export$3dab6afd018d48c7)(ctx, stroke, rect) : el.__canvasStrokeGradient;
            el.__canvasStrokeGradient = strokeGradient;
        }
        if (hasFillPattern) {
            fillPattern = dirtyFlag || !el.__canvasFillPattern ? $6bc3d3dcea2beb63$export$8eb5db6b7bc27903(ctx, fill, el) : el.__canvasFillPattern;
            el.__canvasFillPattern = fillPattern;
        }
        if (hasStrokePattern) {
            strokePattern = dirtyFlag || !el.__canvasStrokePattern ? $6bc3d3dcea2beb63$export$8eb5db6b7bc27903(ctx, stroke, el) : el.__canvasStrokePattern;
            el.__canvasStrokePattern = strokePattern;
        }
        if (hasFillGradient) ctx.fillStyle = fillGradient;
        else if (hasFillPattern) {
            if (fillPattern) ctx.fillStyle = fillPattern;
            else hasFill = false;
        }
        if (hasStrokeGradient) ctx.strokeStyle = strokeGradient;
        else if (hasStrokePattern) {
            if (strokePattern) ctx.strokeStyle = strokePattern;
            else hasStroke = false;
        }
    }
    var scale = el.getGlobalScale();
    path.setScale(scale[0], scale[1], el.segmentIgnoreThreshold);
    var lineDash;
    var lineDashOffset;
    if (ctx.setLineDash && style.lineDash) _a = (0, $cf1c665c8b2c91a8$export$9d315911f153b3b2)(el), lineDash = _a[0], lineDashOffset = _a[1];
    var needsRebuild = true;
    if (firstDraw || dirtyFlag & (0, $24fa4a8d26d34a24$export$f75fe89a33ebe115)) {
        path.setDPR(ctx.dpr);
        if (strokePart) path.setContext(null);
        else {
            path.setContext(ctx);
            needsRebuild = false;
        }
        path.reset();
        el.buildPath(path, el.shape, canBatch);
        path.toStatic();
        el.pathUpdated();
    }
    if (needsRebuild) path.rebuildPath(ctx, strokePart ? strokePercent : 1);
    if (lineDash) {
        ctx.setLineDash(lineDash);
        ctx.lineDashOffset = lineDashOffset;
    }
    if (!canBatch) {
        if (style.strokeFirst) {
            if (hasStroke) $6bc3d3dcea2beb63$var$doStrokePath(ctx, style);
            if (hasFill) $6bc3d3dcea2beb63$var$doFillPath(ctx, style);
        } else {
            if (hasFill) $6bc3d3dcea2beb63$var$doFillPath(ctx, style);
            if (hasStroke) $6bc3d3dcea2beb63$var$doStrokePath(ctx, style);
        }
    } else {
        scope.batchFill = hasFill;
        scope.batchStroke = hasStroke;
    }
    if (lineDash) ctx.setLineDash([]);
}
function $6bc3d3dcea2beb63$var$brushImage(ctx, el, style) {
    var image = el.__image = (0, $b3b93921504aa1e2$export$46c791b69ff9a0f)(style.image, el.__image, el, el.onload);
    if (!image || !(0, $b3b93921504aa1e2$export$37ca7dd901d0236d)(image)) return;
    var x = style.x || 0;
    var y = style.y || 0;
    var width = el.getWidth();
    var height = el.getHeight();
    var aspect = image.width / image.height;
    if (width == null && height != null) width = height * aspect;
    else if (height == null && width != null) height = width / aspect;
    else if (width == null && height == null) {
        width = image.width;
        height = image.height;
    }
    if (style.sWidth && style.sHeight) {
        var sx = style.sx || 0;
        var sy = style.sy || 0;
        ctx.drawImage(image, sx, sy, style.sWidth, style.sHeight, x, y, width, height);
    } else if (style.sx && style.sy) {
        var sx = style.sx;
        var sy = style.sy;
        var sWidth = width - sx;
        var sHeight = height - sy;
        ctx.drawImage(image, sx, sy, sWidth, sHeight, x, y, width, height);
    } else ctx.drawImage(image, x, y, width, height);
}
function $6bc3d3dcea2beb63$var$brushText(ctx, el, style) {
    var _a;
    var text = style.text;
    text != null && (text += "");
    if (text) {
        ctx.font = style.font || (0, $08c3209e6efc839a$export$7d7a232b6d2cc80c);
        ctx.textAlign = style.textAlign;
        ctx.textBaseline = style.textBaseline;
        var lineDash = void 0;
        var lineDashOffset = void 0;
        if (ctx.setLineDash && style.lineDash) _a = (0, $cf1c665c8b2c91a8$export$9d315911f153b3b2)(el), lineDash = _a[0], lineDashOffset = _a[1];
        if (lineDash) {
            ctx.setLineDash(lineDash);
            ctx.lineDashOffset = lineDashOffset;
        }
        if (style.strokeFirst) {
            if ($6bc3d3dcea2beb63$var$styleHasStroke(style)) ctx.strokeText(text, style.x, style.y);
            if ($6bc3d3dcea2beb63$var$styleHasFill(style)) ctx.fillText(text, style.x, style.y);
        } else {
            if ($6bc3d3dcea2beb63$var$styleHasFill(style)) ctx.fillText(text, style.x, style.y);
            if ($6bc3d3dcea2beb63$var$styleHasStroke(style)) ctx.strokeText(text, style.x, style.y);
        }
        if (lineDash) ctx.setLineDash([]);
    }
}
var $6bc3d3dcea2beb63$var$SHADOW_NUMBER_PROPS = [
    "shadowBlur",
    "shadowOffsetX",
    "shadowOffsetY"
];
var $6bc3d3dcea2beb63$var$STROKE_PROPS = [
    [
        "lineCap",
        "butt"
    ],
    [
        "lineJoin",
        "miter"
    ],
    [
        "miterLimit",
        10
    ]
];
function $6bc3d3dcea2beb63$var$bindCommonProps(ctx, style, prevStyle, forceSetAll, scope) {
    var styleChanged = false;
    if (!forceSetAll) {
        prevStyle = prevStyle || {};
        if (style === prevStyle) return false;
    }
    if (forceSetAll || style.opacity !== prevStyle.opacity) {
        $6bc3d3dcea2beb63$var$flushPathDrawn(ctx, scope);
        styleChanged = true;
        var opacity = Math.max(Math.min(style.opacity, 1), 0);
        ctx.globalAlpha = isNaN(opacity) ? (0, $4773d393c538283c$export$737672163db00fe3).opacity : opacity;
    }
    if (forceSetAll || style.blend !== prevStyle.blend) {
        if (!styleChanged) {
            $6bc3d3dcea2beb63$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        ctx.globalCompositeOperation = style.blend || (0, $4773d393c538283c$export$737672163db00fe3).blend;
    }
    for(var i = 0; i < $6bc3d3dcea2beb63$var$SHADOW_NUMBER_PROPS.length; i++){
        var propName = $6bc3d3dcea2beb63$var$SHADOW_NUMBER_PROPS[i];
        if (forceSetAll || style[propName] !== prevStyle[propName]) {
            if (!styleChanged) {
                $6bc3d3dcea2beb63$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            ctx[propName] = ctx.dpr * (style[propName] || 0);
        }
    }
    if (forceSetAll || style.shadowColor !== prevStyle.shadowColor) {
        if (!styleChanged) {
            $6bc3d3dcea2beb63$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        ctx.shadowColor = style.shadowColor || (0, $4773d393c538283c$export$737672163db00fe3).shadowColor;
    }
    return styleChanged;
}
function $6bc3d3dcea2beb63$var$bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetAll, scope) {
    var style = el.style;
    var prevStyle = forceSetAll ? null : prevEl && prevEl.style || {};
    if (style === prevStyle) return false;
    var styleChanged = $6bc3d3dcea2beb63$var$bindCommonProps(ctx, style, prevStyle, forceSetAll, scope);
    if (forceSetAll || style.fill !== prevStyle.fill) {
        if (!styleChanged) {
            $6bc3d3dcea2beb63$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        $6bc3d3dcea2beb63$var$isValidStrokeFillStyle(style.fill) && (ctx.fillStyle = style.fill);
    }
    if (forceSetAll || style.stroke !== prevStyle.stroke) {
        if (!styleChanged) {
            $6bc3d3dcea2beb63$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        $6bc3d3dcea2beb63$var$isValidStrokeFillStyle(style.stroke) && (ctx.strokeStyle = style.stroke);
    }
    if (forceSetAll || style.opacity !== prevStyle.opacity) {
        if (!styleChanged) {
            $6bc3d3dcea2beb63$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        ctx.globalAlpha = style.opacity == null ? 1 : style.opacity;
    }
    if (el.hasStroke()) {
        var lineWidth = style.lineWidth;
        var newLineWidth = lineWidth / (style.strokeNoScale && el.getLineScale ? el.getLineScale() : 1);
        if (ctx.lineWidth !== newLineWidth) {
            if (!styleChanged) {
                $6bc3d3dcea2beb63$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            ctx.lineWidth = newLineWidth;
        }
    }
    for(var i = 0; i < $6bc3d3dcea2beb63$var$STROKE_PROPS.length; i++){
        var prop = $6bc3d3dcea2beb63$var$STROKE_PROPS[i];
        var propName = prop[0];
        if (forceSetAll || style[propName] !== prevStyle[propName]) {
            if (!styleChanged) {
                $6bc3d3dcea2beb63$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            ctx[propName] = style[propName] || prop[1];
        }
    }
    return styleChanged;
}
function $6bc3d3dcea2beb63$var$bindImageStyle(ctx, el, prevEl, forceSetAll, scope) {
    return $6bc3d3dcea2beb63$var$bindCommonProps(ctx, el.style, prevEl && prevEl.style, forceSetAll, scope);
}
function $6bc3d3dcea2beb63$var$setContextTransform(ctx, el) {
    var m = el.transform;
    var dpr = ctx.dpr || 1;
    if (m) ctx.setTransform(dpr * m[0], dpr * m[1], dpr * m[2], dpr * m[3], dpr * m[4], dpr * m[5]);
    else ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
}
function $6bc3d3dcea2beb63$var$updateClipStatus(clipPaths, ctx, scope) {
    var allClipped = false;
    for(var i = 0; i < clipPaths.length; i++){
        var clipPath = clipPaths[i];
        allClipped = allClipped || clipPath.isZeroArea();
        $6bc3d3dcea2beb63$var$setContextTransform(ctx, clipPath);
        ctx.beginPath();
        clipPath.buildPath(ctx, clipPath.shape);
        ctx.clip();
    }
    scope.allClipped = allClipped;
}
function $6bc3d3dcea2beb63$var$isTransformChanged(m0, m1) {
    if (m0 && m1) return m0[0] !== m1[0] || m0[1] !== m1[1] || m0[2] !== m1[2] || m0[3] !== m1[3] || m0[4] !== m1[4] || m0[5] !== m1[5];
    else if (!m0 && !m1) return false;
    return true;
}
var $6bc3d3dcea2beb63$var$DRAW_TYPE_PATH = 1;
var $6bc3d3dcea2beb63$var$DRAW_TYPE_IMAGE = 2;
var $6bc3d3dcea2beb63$var$DRAW_TYPE_TEXT = 3;
var $6bc3d3dcea2beb63$var$DRAW_TYPE_INCREMENTAL = 4;
function $6bc3d3dcea2beb63$var$canPathBatch(style) {
    var hasFill = $6bc3d3dcea2beb63$var$styleHasFill(style);
    var hasStroke = $6bc3d3dcea2beb63$var$styleHasStroke(style);
    return !(style.lineDash || !(+hasFill ^ +hasStroke) || hasFill && typeof style.fill !== "string" || hasStroke && typeof style.stroke !== "string" || style.strokePercent < 1 || style.strokeOpacity < 1 || style.fillOpacity < 1);
}
function $6bc3d3dcea2beb63$var$flushPathDrawn(ctx, scope) {
    if (scope.batchFill) {
        scope.batchFill = false;
        ctx.fill();
    }
    if (scope.batchStroke) {
        scope.batchStroke = false;
        ctx.stroke();
    }
}
function $6bc3d3dcea2beb63$export$567881adfc3eb7f3(ctx, el) {
    var scope = {
        inHover: false,
        viewWidth: 0,
        viewHeight: 0,
        beforeBrushParam: {}
    };
    $6bc3d3dcea2beb63$export$da5d6544e8c27bc1(ctx, el, scope);
    $6bc3d3dcea2beb63$export$aa9c98b43779289a(ctx, scope);
}
function $6bc3d3dcea2beb63$export$da5d6544e8c27bc1(ctx, el, scope) {
    var m = el.transform;
    if (!el.shouldBePainted(scope.viewWidth, scope.viewHeight, false, false)) {
        el.__dirty &= ~(0, $24fa4a8d26d34a24$export$a7b6db622c6c7dbd);
        el.__isRendered = false;
        return;
    }
    var clipPaths = el.__clipPaths;
    var prevElClipPaths = scope.prevElClipPaths;
    var style = el.style;
    var forceSetTransform = false;
    var forceSetStyle = false;
    if (!prevElClipPaths || (0, $0aca998062cac624$export$beeddc5150cb2e83)(clipPaths, prevElClipPaths)) {
        if (prevElClipPaths) {
            $6bc3d3dcea2beb63$var$flushPathDrawn(ctx, scope);
            ctx.restore();
            forceSetStyle = forceSetTransform = true;
            scope.prevElClipPaths = null;
            scope.allClipped = false;
            scope.prevEl = null;
        }
        if (clipPaths && clipPaths.length) {
            $6bc3d3dcea2beb63$var$flushPathDrawn(ctx, scope);
            ctx.save();
            $6bc3d3dcea2beb63$var$updateClipStatus(clipPaths, ctx, scope);
            forceSetTransform = true;
            scope.prevElClipPaths = clipPaths;
        }
    }
    if (scope.allClipped) {
        el.__dirty &= ~(0, $24fa4a8d26d34a24$export$a7b6db622c6c7dbd);
        el.__isRendered = false;
        return;
    }
    el.beforeBrush && el.beforeBrush(scope.beforeBrushParam);
    el.innerBeforeBrush();
    var prevEl = scope.prevEl;
    if (!prevEl) forceSetStyle = forceSetTransform = true;
    var canBatchPath = el instanceof (0, $227e31075465dcd4$export$2e2bcd8739ae039) && el.autoBatch && $6bc3d3dcea2beb63$var$canPathBatch(style);
    if (forceSetTransform || $6bc3d3dcea2beb63$var$isTransformChanged(m, prevEl.transform)) {
        $6bc3d3dcea2beb63$var$flushPathDrawn(ctx, scope);
        $6bc3d3dcea2beb63$var$setContextTransform(ctx, el);
    } else if (!canBatchPath) $6bc3d3dcea2beb63$var$flushPathDrawn(ctx, scope);
    if (el instanceof (0, $227e31075465dcd4$export$2e2bcd8739ae039)) {
        if (scope.lastDrawType !== $6bc3d3dcea2beb63$var$DRAW_TYPE_PATH) {
            forceSetStyle = true;
            scope.lastDrawType = $6bc3d3dcea2beb63$var$DRAW_TYPE_PATH;
        }
        $6bc3d3dcea2beb63$var$bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetStyle, scope);
        if (!canBatchPath || !scope.batchFill && !scope.batchStroke) ctx.beginPath();
        $6bc3d3dcea2beb63$var$brushPath(ctx, el, style, canBatchPath, scope);
    } else {
        if (el instanceof (0, $f2b3c07e83bf5376$export$2e2bcd8739ae039)) {
            if (scope.lastDrawType !== $6bc3d3dcea2beb63$var$DRAW_TYPE_TEXT) {
                forceSetStyle = true;
                scope.lastDrawType = $6bc3d3dcea2beb63$var$DRAW_TYPE_TEXT;
            }
            $6bc3d3dcea2beb63$var$bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetStyle, scope);
            $6bc3d3dcea2beb63$var$brushText(ctx, el, style);
        } else if (el instanceof (0, $d3b0315ae8e8e298$export$2e2bcd8739ae039)) {
            if (scope.lastDrawType !== $6bc3d3dcea2beb63$var$DRAW_TYPE_IMAGE) {
                forceSetStyle = true;
                scope.lastDrawType = $6bc3d3dcea2beb63$var$DRAW_TYPE_IMAGE;
            }
            $6bc3d3dcea2beb63$var$bindImageStyle(ctx, el, prevEl, forceSetStyle, scope);
            $6bc3d3dcea2beb63$var$brushImage(ctx, el, style);
        } else if (el.getTemporalDisplayables) {
            if (scope.lastDrawType !== $6bc3d3dcea2beb63$var$DRAW_TYPE_INCREMENTAL) {
                forceSetStyle = true;
                scope.lastDrawType = $6bc3d3dcea2beb63$var$DRAW_TYPE_INCREMENTAL;
            }
            $6bc3d3dcea2beb63$var$brushIncremental(ctx, el, scope);
        }
    }
    el.innerAfterBrush();
    if (el.afterBrush) {
        if (canBatchPath) $6bc3d3dcea2beb63$var$flushPathDrawn(ctx, scope);
        el.afterBrush();
    }
    scope.prevEl = el;
    el.__dirty = 0;
    el.__isRendered = true;
}
function $6bc3d3dcea2beb63$export$aa9c98b43779289a(ctx, scope) {
    $6bc3d3dcea2beb63$var$flushPathDrawn(ctx, scope);
    if (scope.prevElClipPaths) ctx.restore();
}
function $6bc3d3dcea2beb63$var$brushIncremental(ctx, el, scope) {
    var displayables = el.getDisplayables();
    var temporalDisplayables = el.getTemporalDisplayables();
    ctx.save();
    var innerScope = {
        prevElClipPaths: null,
        prevEl: null,
        allClipped: false,
        viewWidth: scope.viewWidth,
        viewHeight: scope.viewHeight,
        inHover: scope.inHover,
        beforeBrushParam: {}
    };
    var i;
    var len;
    for(i = el.getCursor(), len = displayables.length; i < len; i++){
        var displayable = displayables[i];
        displayable.beforeBrush && displayable.beforeBrush(scope.beforeBrushParam);
        displayable.innerBeforeBrush();
        $6bc3d3dcea2beb63$export$da5d6544e8c27bc1(ctx, displayable, innerScope);
        displayable.innerAfterBrush();
        displayable.afterBrush && displayable.afterBrush();
        innerScope.prevEl = displayable;
    }
    $6bc3d3dcea2beb63$export$aa9c98b43779289a(ctx, innerScope);
    for(var i_1 = 0, len_1 = temporalDisplayables.length; i_1 < len_1; i_1++){
        var displayable = temporalDisplayables[i_1];
        displayable.beforeBrush && displayable.beforeBrush(scope.beforeBrushParam);
        displayable.innerBeforeBrush();
        $6bc3d3dcea2beb63$export$da5d6544e8c27bc1(ctx, displayable, innerScope);
        displayable.innerAfterBrush();
        displayable.afterBrush && displayable.afterBrush();
        innerScope.prevEl = displayable;
    }
    $6bc3d3dcea2beb63$export$aa9c98b43779289a(ctx, innerScope);
    el.clearTemporalDisplayables();
    el.notClear = true;
    ctx.restore();
}



var $3850641d805af85d$var$decalMap = new (0, $c4818bfd4f0c62e6$export$2e2bcd8739ae039)();
var $3850641d805af85d$var$decalCache = new (0, $0a70a3b1dc4cb6e5$export$2e2bcd8739ae039)(100);
var $3850641d805af85d$var$decalKeys = [
    "symbol",
    "symbolSize",
    "symbolKeepAspect",
    "color",
    "backgroundColor",
    "dashArrayX",
    "dashArrayY",
    "maxTileWidth",
    "maxTileHeight"
];
function $3850641d805af85d$export$a3ba048e1a648972(decalObject, api) {
    if (decalObject === "none") return null;
    var dpr = api.getDevicePixelRatio();
    var zr = api.getZr();
    var isSVG = zr.painter.type === "svg";
    if (decalObject.dirty) $3850641d805af85d$var$decalMap["delete"](decalObject);
    var oldPattern = $3850641d805af85d$var$decalMap.get(decalObject);
    if (oldPattern) return oldPattern;
    var decalOpt = (0, $43e0a445ed6711da$export$ebe90cb607ad99e)(decalObject, {
        symbol: "rect",
        symbolSize: 1,
        symbolKeepAspect: true,
        color: "rgba(0, 0, 0, 0.2)",
        backgroundColor: null,
        dashArrayX: 5,
        dashArrayY: 5,
        rotation: 0,
        maxTileWidth: 512,
        maxTileHeight: 512
    });
    if (decalOpt.backgroundColor === "none") decalOpt.backgroundColor = null;
    var pattern = {
        repeat: "repeat"
    };
    setPatternnSource(pattern);
    pattern.rotation = decalOpt.rotation;
    pattern.scaleX = pattern.scaleY = isSVG ? 1 : 1 / dpr;
    $3850641d805af85d$var$decalMap.set(decalObject, pattern);
    decalObject.dirty = false;
    return pattern;
    function setPatternnSource(pattern) {
        var keys = [
            dpr
        ];
        var isValidKey = true;
        for(var i = 0; i < $3850641d805af85d$var$decalKeys.length; ++i){
            var value = decalOpt[$3850641d805af85d$var$decalKeys[i]];
            if (value != null && !(0, $43e0a445ed6711da$export$43bee75e5e14138e)(value) && !(0, $43e0a445ed6711da$export$844ec244b1367d54)(value) && !(0, $43e0a445ed6711da$export$7e4aa119212bc614)(value) && typeof value !== "boolean") {
                isValidKey = false;
                break;
            }
            keys.push(value);
        }
        var cacheKey;
        if (isValidKey) {
            cacheKey = keys.join(",") + (isSVG ? "-svg" : "");
            var cache = $3850641d805af85d$var$decalCache.get(cacheKey);
            if (cache) isSVG ? pattern.svgElement = cache : pattern.image = cache;
        }
        var dashArrayX = $3850641d805af85d$var$normalizeDashArrayX(decalOpt.dashArrayX);
        var dashArrayY = $3850641d805af85d$var$normalizeDashArrayY(decalOpt.dashArrayY);
        var symbolArray = $3850641d805af85d$var$normalizeSymbolArray(decalOpt.symbol);
        var lineBlockLengthsX = $3850641d805af85d$var$getLineBlockLengthX(dashArrayX);
        var lineBlockLengthY = $3850641d805af85d$var$getLineBlockLengthY(dashArrayY);
        var canvas = !isSVG && (0, $08c3209e6efc839a$export$ef5e599365494451).createCanvas();
        var svgRoot = isSVG && {
            tag: "g",
            attrs: {},
            key: "dcl",
            children: []
        };
        var pSize = getPatternSize();
        var ctx;
        if (canvas) {
            canvas.width = pSize.width * dpr;
            canvas.height = pSize.height * dpr;
            ctx = canvas.getContext("2d");
        }
        brushDecal();
        if (isValidKey) $3850641d805af85d$var$decalCache.put(cacheKey, canvas || svgRoot);
        pattern.image = canvas;
        pattern.svgElement = svgRoot;
        pattern.svgWidth = pSize.width;
        pattern.svgHeight = pSize.height;
        /**
     * Get minimum length that can make a repeatable pattern.
     *
     * @return {Object} pattern width and height
     */ function getPatternSize() {
            /**
       * For example, if dash is [[3, 2], [2, 1]] for X, it looks like
       * |---  ---  ---  ---  --- ...
       * |-- -- -- -- -- -- -- -- ...
       * |---  ---  ---  ---  --- ...
       * |-- -- -- -- -- -- -- -- ...
       * So the minimum length of X is 15,
       * which is the least common multiple of `3 + 2` and `2 + 1`
       * |---  ---  ---  |---  --- ...
       * |-- -- -- -- -- |-- -- -- ...
       */ var width = 1;
            for(var i = 0, xlen = lineBlockLengthsX.length; i < xlen; ++i)width = (0, $b49750109e236fd8$export$680a45b749323f49)(width, lineBlockLengthsX[i]);
            var symbolRepeats = 1;
            for(var i = 0, xlen = symbolArray.length; i < xlen; ++i)symbolRepeats = (0, $b49750109e236fd8$export$680a45b749323f49)(symbolRepeats, symbolArray[i].length);
            width *= symbolRepeats;
            var height = lineBlockLengthY * lineBlockLengthsX.length * symbolArray.length;
            var warn;
            return {
                width: Math.max(1, Math.min(width, decalOpt.maxTileWidth)),
                height: Math.max(1, Math.min(height, decalOpt.maxTileHeight))
            };
        }
        function brushDecal() {
            if (ctx) {
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                if (decalOpt.backgroundColor) {
                    ctx.fillStyle = decalOpt.backgroundColor;
                    ctx.fillRect(0, 0, canvas.width, canvas.height);
                }
            }
            var ySum = 0;
            for(var i = 0; i < dashArrayY.length; ++i)ySum += dashArrayY[i];
            if (ySum <= 0) // dashArrayY is 0, draw nothing
            return;
            var y = -lineBlockLengthY;
            var yId = 0;
            var yIdTotal = 0;
            var xId0 = 0;
            while(y < pSize.height){
                if (yId % 2 === 0) {
                    var symbolYId = yIdTotal / 2 % symbolArray.length;
                    var x = 0;
                    var xId1 = 0;
                    var xId1Total = 0;
                    while(x < pSize.width * 2){
                        var xSum = 0;
                        for(var i = 0; i < dashArrayX[xId0].length; ++i)xSum += dashArrayX[xId0][i];
                        if (xSum <= 0) break;
                        // E.g., [15, 5, 20, 5] draws only for 15 and 20
                        if (xId1 % 2 === 0) {
                            var size = (1 - decalOpt.symbolSize) * 0.5;
                            var left = x + dashArrayX[xId0][xId1] * size;
                            var top_1 = y + dashArrayY[yId] * size;
                            var width = dashArrayX[xId0][xId1] * decalOpt.symbolSize;
                            var height = dashArrayY[yId] * decalOpt.symbolSize;
                            var symbolXId = xId1Total / 2 % symbolArray[symbolYId].length;
                            brushSymbol(left, top_1, width, height, symbolArray[symbolYId][symbolXId]);
                        }
                        x += dashArrayX[xId0][xId1];
                        ++xId1Total;
                        ++xId1;
                        if (xId1 === dashArrayX[xId0].length) xId1 = 0;
                    }
                    ++xId0;
                    if (xId0 === dashArrayX.length) xId0 = 0;
                }
                y += dashArrayY[yId];
                ++yIdTotal;
                ++yId;
                if (yId === dashArrayY.length) yId = 0;
            }
            function brushSymbol(x, y, width, height, symbolType) {
                var scale = isSVG ? 1 : dpr;
                var symbol = (0, $4ff41a845d4679a6$export$af050e04da3a02e8)(symbolType, x * scale, y * scale, width * scale, height * scale, decalOpt.color, decalOpt.symbolKeepAspect);
                if (isSVG) {
                    var symbolVNode = zr.painter.renderOneToVNode(symbol);
                    if (symbolVNode) svgRoot.children.push(symbolVNode);
                } else // Paint to canvas for all other renderers.
                (0, $6bc3d3dcea2beb63$export$567881adfc3eb7f3)(ctx, symbol);
            }
        }
    }
}
/**
 * Convert symbol array into normalized array
 *
 * @param {string | (string | string[])[]} symbol symbol input
 * @return {string[][]} normolized symbol array
 */ function $3850641d805af85d$var$normalizeSymbolArray(symbol) {
    if (!symbol || symbol.length === 0) return [
        [
            "rect"
        ]
    ];
    if ((0, $43e0a445ed6711da$export$844ec244b1367d54)(symbol)) return [
        [
            symbol
        ]
    ];
    var isAllString = true;
    for(var i = 0; i < symbol.length; ++i)if (!(0, $43e0a445ed6711da$export$844ec244b1367d54)(symbol[i])) {
        isAllString = false;
        break;
    }
    if (isAllString) return $3850641d805af85d$var$normalizeSymbolArray([
        symbol
    ]);
    var result = [];
    for(var i = 0; i < symbol.length; ++i)if ((0, $43e0a445ed6711da$export$844ec244b1367d54)(symbol[i])) result.push([
        symbol[i]
    ]);
    else result.push(symbol[i]);
    return result;
}
/**
 * Convert dash input into dashArray
 *
 * @param {DecalDashArrayX} dash dash input
 * @return {number[][]} normolized dash array
 */ function $3850641d805af85d$var$normalizeDashArrayX(dash) {
    if (!dash || dash.length === 0) return [
        [
            0,
            0
        ]
    ];
    if ((0, $43e0a445ed6711da$export$7e4aa119212bc614)(dash)) {
        var dashValue = Math.ceil(dash);
        return [
            [
                dashValue,
                dashValue
            ]
        ];
    }
    /**
   * [20, 5] should be normalized into [[20, 5]],
   * while [20, [5, 10]] should be normalized into [[20, 20], [5, 10]]
   */ var isAllNumber = true;
    for(var i = 0; i < dash.length; ++i)if (!(0, $43e0a445ed6711da$export$7e4aa119212bc614)(dash[i])) {
        isAllNumber = false;
        break;
    }
    if (isAllNumber) return $3850641d805af85d$var$normalizeDashArrayX([
        dash
    ]);
    var result = [];
    for(var i = 0; i < dash.length; ++i)if ((0, $43e0a445ed6711da$export$7e4aa119212bc614)(dash[i])) {
        var dashValue = Math.ceil(dash[i]);
        result.push([
            dashValue,
            dashValue
        ]);
    } else {
        var dashValue = (0, $43e0a445ed6711da$export$871de8747c9eaa88)(dash[i], function(n) {
            return Math.ceil(n);
        });
        if (dashValue.length % 2 === 1) // [4, 2, 1] means |----  -    -- |----  -    -- |
        // so normalize it to be [4, 2, 1, 4, 2, 1]
        result.push(dashValue.concat(dashValue));
        else result.push(dashValue);
    }
    return result;
}
/**
 * Convert dash input into dashArray
 *
 * @param {DecalDashArrayY} dash dash input
 * @return {number[]} normolized dash array
 */ function $3850641d805af85d$var$normalizeDashArrayY(dash) {
    if (!dash || typeof dash === "object" && dash.length === 0) return [
        0,
        0
    ];
    if ((0, $43e0a445ed6711da$export$7e4aa119212bc614)(dash)) {
        var dashValue_1 = Math.ceil(dash);
        return [
            dashValue_1,
            dashValue_1
        ];
    }
    var dashValue = (0, $43e0a445ed6711da$export$871de8747c9eaa88)(dash, function(n) {
        return Math.ceil(n);
    });
    return dash.length % 2 ? dashValue.concat(dashValue) : dashValue;
}
/**
 * Get block length of each line. A block is the length of dash line and space.
 * For example, a line with [4, 1] has a dash line of 4 and a space of 1 after
 * that, so the block length of this line is 5.
 *
 * @param {number[][]} dash dash array of X or Y
 * @return {number[]} block length of each line
 */ function $3850641d805af85d$var$getLineBlockLengthX(dash) {
    return (0, $43e0a445ed6711da$export$871de8747c9eaa88)(dash, function(line) {
        return $3850641d805af85d$var$getLineBlockLengthY(line);
    });
}
function $3850641d805af85d$var$getLineBlockLengthY(dash) {
    var blockLength = 0;
    for(var i = 0; i < dash.length; ++i)blockLength += dash[i];
    if (dash.length % 2 === 1) // [4, 2, 1] means |----  -    -- |----  -    -- |
    // So total length is (4 + 2 + 1) * 2
    return blockLength * 2;
    return blockLength;
}



var $d10acd6e8d584437$export$218eea02a2a96fb4 = (0, $87f4a59ac66e0ee6$export$d62c61cad9d1ab83)($d10acd6e8d584437$var$decalVisual);
function $d10acd6e8d584437$var$decalVisual(ecModel, api) {
    ecModel.eachRawSeries(function(seriesModel) {
        if (ecModel.isSeriesFiltered(seriesModel)) return;
        var data = seriesModel.getData();
        if (data.hasItemVisual()) data.each(function(idx) {
            var decal = data.getItemVisual(idx, "decal");
            if (decal) {
                var itemStyle = data.ensureUniqueItemVisual(idx, "style");
                itemStyle.decal = (0, $3850641d805af85d$export$a3ba048e1a648972)(decal, api);
            }
        });
        var decal = data.getVisual("decal");
        if (decal) {
            var style = data.getVisual("style");
            style.decal = (0, $3850641d805af85d$export$a3ba048e1a648972)(decal, api);
        }
    });
}


var $8d957d74809727b8$export$83d89fbfd8236492 = "6.1.0";
var $8d957d74809727b8$export$b74ff737e0e298b5 = {
    zrender: "6.1.0"
};
var $8d957d74809727b8$var$TEST_FRAME_REMAIN_TIME = 1;
var $8d957d74809727b8$var$PRIORITY_PROCESSOR_SERIES_FILTER = 800;
// In the current impl, "data stack" will modifies the original "series data extent". Some data
// processors rely on the stack result dimension to calculate extents. So data stack
// should be in front of other data processors.
var $8d957d74809727b8$var$PRIORITY_PROCESSOR_DATASTACK = 900;
// AXIS_STATISTICS should be after SERIES_FILTER, as it may change the statistics result (like min gap).
// AXIS_STATISTICS should be before filter (dataZoom), as dataZoom require the result in "containShape" calculation.
var $8d957d74809727b8$var$PRIORITY_PROCESSOR_AXIS_STATISTICS = 920;
// `PRIORITY_PROCESSOR_FILTER` is typically used by `dataZoom` (see `AxisProxy`), which relies
// on the initialized "axis extent".
var $8d957d74809727b8$var$PRIORITY_PROCESSOR_FILTER = 1000;
var $8d957d74809727b8$var$PRIORITY_PROCESSOR_DEFAULT = 2000;
var $8d957d74809727b8$var$PRIORITY_PROCESSOR_STATISTICS = 5000;
// NOTICE: Data processors above block the stream (especially time-consuming processors like data filters).
var $8d957d74809727b8$var$PRIORITY_VISUAL_LAYOUT = 1000;
var $8d957d74809727b8$var$PRIORITY_VISUAL_PROGRESSIVE_LAYOUT = 1100;
var $8d957d74809727b8$var$PRIORITY_VISUAL_GLOBAL = 2000;
var $8d957d74809727b8$var$PRIORITY_VISUAL_CHART = 3000;
var $8d957d74809727b8$var$PRIORITY_VISUAL_COMPONENT = 4000;
// Visual property in data. Greater than `PRIORITY_VISUAL_COMPONENT` to enable to
// overwrite the visual result of component (like `visualMap`)
// using data item specific setting (like itemStyle.xxx on data item)
var $8d957d74809727b8$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM = 4500;
// Greater than `PRIORITY_VISUAL_CHART_DATA_CUSTOM` to enable to layout based on
// visual result like `symbolSize`.
var $8d957d74809727b8$var$PRIORITY_VISUAL_POST_CHART_LAYOUT = 4600;
var $8d957d74809727b8$var$PRIORITY_VISUAL_BRUSH = 5000;
var $8d957d74809727b8$var$PRIORITY_VISUAL_ARIA = 6000;
var $8d957d74809727b8$var$PRIORITY_VISUAL_DECAL = 7000;
var $8d957d74809727b8$export$bb34f3538ba26c7e = {
    PROCESSOR: {
        SERIES_FILTER: $8d957d74809727b8$var$PRIORITY_PROCESSOR_SERIES_FILTER,
        AXIS_STATISTICS: $8d957d74809727b8$var$PRIORITY_PROCESSOR_AXIS_STATISTICS,
        FILTER: $8d957d74809727b8$var$PRIORITY_PROCESSOR_FILTER,
        STATISTIC: $8d957d74809727b8$var$PRIORITY_PROCESSOR_STATISTICS,
        STATISTICS: $8d957d74809727b8$var$PRIORITY_PROCESSOR_STATISTICS
    },
    VISUAL: {
        LAYOUT: $8d957d74809727b8$var$PRIORITY_VISUAL_LAYOUT,
        PROGRESSIVE_LAYOUT: $8d957d74809727b8$var$PRIORITY_VISUAL_PROGRESSIVE_LAYOUT,
        GLOBAL: $8d957d74809727b8$var$PRIORITY_VISUAL_GLOBAL,
        CHART: $8d957d74809727b8$var$PRIORITY_VISUAL_CHART,
        POST_CHART_LAYOUT: $8d957d74809727b8$var$PRIORITY_VISUAL_POST_CHART_LAYOUT,
        COMPONENT: $8d957d74809727b8$var$PRIORITY_VISUAL_COMPONENT,
        BRUSH: $8d957d74809727b8$var$PRIORITY_VISUAL_BRUSH,
        CHART_ITEM: $8d957d74809727b8$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM,
        ARIA: $8d957d74809727b8$var$PRIORITY_VISUAL_ARIA,
        DECAL: $8d957d74809727b8$var$PRIORITY_VISUAL_DECAL
    }
};
/**
 * @tutorial [EC_CYCLE] (ec updating/rendering cycles):
 *
 *  - Common Rules:
 *    - Nested entry is not allowed. If triggering a new run of EC_CYCLE during a
 *      unfinished run, the new run will be delayed until the current run finishes
 *      (if triggered by `dispatchAction`), or throw error (if triggered by other API calls).
 *    - All user-visible ec events are triggered outside EC_CYCLE.
 *      (i.e. be triggered after `this[IN_EC_CYCLE_KEY]` becoming `false`).
 *
 *  - [EC_FULL_UPDATE_CYCLE]:
 *    - It designates a run of a series of processing/updating/rendering.
 *    - It is triggered by:
 *      - `setOption`
 *      - `dispatchAction`
 *        (It is typically internally triggered by user inputs; but can also an explicit API call.)
 *      - `resize`
 *      - The next "animation frame" if in `lazyMode: true`.
 *    - A run of EC_FULL_UPDATE_CYCLE comprises:
 *      - EC_PREPARE (may be absent)
 *      - EC_FULL_UPDATE:
 *        - CoordinateSystem['create']
 *        - Data processing (may be absent) (see `registerProcessor`)
 *        - CoordinateSystem['update'] (may be absent)
 *        - Visual encoding (may be absent) (see `registerVisual`)
 *        - Layout (may be absent) (see `registerLayout`)
 *        - Rendering (`ComponentView` or `SeriesView`)
 *
 *  - [EC_PARTIAL_UPDATE_CYCLE]s:
 *      - They are shortcuts for performance.
 *      - They are triggered by:
 *        - `dispatchAction`
 *      - These steps are typically omitted:
 *        - No EC_PREPARE
 *        - No CoordinateSystem['create'] and CoordinateSystem['update']
 *      - They require careful implementation, otherwise inconsistency may be introduced.
 *
 *  - [EC_PROGRESSIVE_CYCLE]:
 *    - It also carries out a series of processing/updating/rendering.
 *    - It is performed in each subsequent "animation frame" until finished.
 *    - It can be triggered by EC_FULL_UPDATE_CYCLE, EC_PARTIAL_UPDATE_CYCLE or EC_APPEND_DATA_CYCLE.
 *    - A run of EC_PROGRESSIVE_CYCLE comprises:
 *      - Data processing (may be absent) (see `registerProcessor`)
 *      - Visual encoding (may be absent) (see `registerVisual`)
 *      - Layout (may be absent) (see `registerLayout`)
 *      - Rendering (`ComponentView` or `SeriesView`)
 *    - PENDING: currently all data processing tasks (via `registerProcessor`) run in "block" mode.
 *      (see `performDataProcessorTasks`).
 *
 *  - [EC_APPEND_DATA_CYCLE]:
 *    - See `appendData`. It is only supported for some special cases.
 *
 *  - [SERIES_SPECIFIC_CYCLE]s:
 *    - Series may have specific update/render cycles. For example, graph force layout performs
 *      layout and rendering in each "animation frame".
 *
 *  - Model updating:
 *    - Model can only be modified at the beginning of ec cycles, including only:
 *      - EC_PREPARE (see method `prepare()`) in `setOption` call.
 *      - EC action handlers in `dispatchAction` call.
 *      - `appendData` (a special case, where only data can be modified).
 *
 *  - The lifetime of CoordinateSystem/Axis/Scale instances:
 *    - They are only re-created per run of EC_FULL_UPDATE_CYCLE.
 *
 *  - Global caches: see `cycleCache.ts`
 */ // See comments in EC_CYCLE.
var $8d957d74809727b8$var$IN_EC_CYCLE_KEY = "__flagInMainProcess";
// Useful for detecting outdated rendering results for the following scenarios:
//  - In EC_PARTIAL_UPDATE_CYCLE, some rendering may be skipped.
//  - Asynchronously update rendered view (e.g., graph force layout).
//  - Multiple ChartView/ComponentView render to one group cooperatively.
var $8d957d74809727b8$var$EC_UPDATE_CYCLE_VERSION_KEY = "__mainProcessVersion";
var $8d957d74809727b8$var$PENDING_UPDATE = "__pendingUpdate";
var $8d957d74809727b8$var$STATUS_NEEDS_UPDATE_KEY = "__needsUpdateStatus";
var $8d957d74809727b8$var$ACTION_REG = /^[a-zA-Z0-9_]+$/;
var $8d957d74809727b8$var$CONNECT_STATUS_KEY = "__connectUpdateStatus";
var $8d957d74809727b8$var$CONNECT_STATUS_PENDING = 0;
var $8d957d74809727b8$var$CONNECT_STATUS_UPDATING = 1;
var $8d957d74809727b8$var$CONNECT_STATUS_UPDATED = 2;
function $8d957d74809727b8$var$createRegisterEventWithLowercaseECharts(method) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (this.isDisposed()) {
            $8d957d74809727b8$var$disposedWarning(this.id);
            return;
        }
        return $8d957d74809727b8$var$toLowercaseNameAndCallEventful(this, method, args);
    };
}
function $8d957d74809727b8$var$createRegisterEventWithLowercaseMessageCenter(method) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $8d957d74809727b8$var$toLowercaseNameAndCallEventful(this, method, args);
    };
}
function $8d957d74809727b8$var$toLowercaseNameAndCallEventful(host, method, args) {
    // `args[0]` is event name. Event name is all lowercase.
    args[0] = args[0] && args[0].toLowerCase();
    return (0, $131b7833cdf735df$export$2e2bcd8739ae039).prototype[method].apply(host, args);
}
var $8d957d74809727b8$var$MessageCenter = /** @class */ function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(MessageCenter, _super);
    function MessageCenter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return MessageCenter;
}((0, $131b7833cdf735df$export$2e2bcd8739ae039));
var $8d957d74809727b8$var$messageCenterProto = $8d957d74809727b8$var$MessageCenter.prototype;
$8d957d74809727b8$var$messageCenterProto.on = $8d957d74809727b8$var$createRegisterEventWithLowercaseMessageCenter("on");
$8d957d74809727b8$var$messageCenterProto.off = $8d957d74809727b8$var$createRegisterEventWithLowercaseMessageCenter("off");
// ---------------------------------------
// Internal method names for class ECharts
// ---------------------------------------
// This is [EC_PREPARE].
var $8d957d74809727b8$var$prepare;
var $8d957d74809727b8$var$prepareView;
var $8d957d74809727b8$var$updateDirectly;
var $8d957d74809727b8$var$updateMethods;
var $8d957d74809727b8$var$doConvertPixel;
var $8d957d74809727b8$var$updateStreamModes;
var $8d957d74809727b8$var$doDispatchAction;
var $8d957d74809727b8$var$flushPendingActions;
var $8d957d74809727b8$var$triggerUpdatedEvent;
var $8d957d74809727b8$var$bindRenderedEvent;
var $8d957d74809727b8$var$bindMouseEvent;
var $8d957d74809727b8$var$render;
var $8d957d74809727b8$var$renderComponents;
var $8d957d74809727b8$var$renderSeries;
var $8d957d74809727b8$var$createExtensionAPI;
var $8d957d74809727b8$var$enableConnect;
var $8d957d74809727b8$var$markStatusToUpdate;
var $8d957d74809727b8$var$applyChangedStates;
var $8d957d74809727b8$var$updateECUpdateCycleVersion;
var $8d957d74809727b8$var$ECharts = /** @class */ function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(ECharts, _super);
    function ECharts(dom, // Theme name or themeOption.
    theme, opts) {
        var _this = _super.call(this, new (0, $a274655c8c7e1675$export$d0fd09f950257b52)()) || this;
        _this._chartsViews = [];
        _this._chartsMap = {};
        _this._componentsViews = [];
        _this._componentsMap = {};
        // Can't dispatch action during rendering procedure
        _this._pendingActions = [];
        opts = opts || {};
        // mark the echarts instance as raw in Vue 3 to prevent the object being converted to be a proxy.
        _this.__v_skip = true;
        _this._dom = dom;
        var defaultRenderer = "canvas";
        var defaultCoarsePointer = "auto";
        var defaultUseDirtyRect = false;
        _this[$8d957d74809727b8$var$EC_UPDATE_CYCLE_VERSION_KEY] = 1;
        var root;
        if (opts.ssr) $08a7e718789e144c$export$e7a09d7fe68a4f7(function(el) {
            var ecData = (0, $7e4afcfca8f5121f$export$b1c39b2bacd1ddc2)(el);
            var dataIndex = ecData.dataIndex;
            if (dataIndex == null) return;
            var hashMap = (0, $43e0a445ed6711da$export$55f8aa7ef875b0a4)();
            hashMap.set("series_index", ecData.seriesIndex);
            hashMap.set("data_index", dataIndex);
            ecData.ssrType && hashMap.set("ssr_type", ecData.ssrType);
            return hashMap;
        });
        var zr = _this._zr = $08a7e718789e144c$export$2cd8252107eb640b(dom, {
            renderer: opts.renderer || defaultRenderer,
            devicePixelRatio: opts.devicePixelRatio,
            width: opts.width,
            height: opts.height,
            ssr: opts.ssr,
            useDirtyRect: (0, $43e0a445ed6711da$export$995e01f2f5c9d030)(opts.useDirtyRect, defaultUseDirtyRect),
            useCoarsePointer: (0, $43e0a445ed6711da$export$995e01f2f5c9d030)(opts.useCoarsePointer, defaultCoarsePointer),
            pointerSize: opts.pointerSize
        });
        _this._ssr = opts.ssr;
        // Expect 60 fps.
        _this._throttledZrFlush = (0, $3a03c388017fa83a$export$de363e709c412c8a)((0, $43e0a445ed6711da$export$2385a24977818dd0)(zr.flush, zr), 17);
        _this._updateTheme(theme);
        _this._locale = (0, $89683316752ed4c5$export$ddc371781a6af754)(opts.locale || (0, $89683316752ed4c5$export$9a2147b3808d4c6b));
        _this._coordSysMgr = new (0, $a30c5e122eaab0a1$export$2e2bcd8739ae039)();
        var api = _this._api = $8d957d74809727b8$var$createExtensionAPI(_this);
        // Sort on demand
        function prioritySortFunc(a, b) {
            return a.__prio - b.__prio;
        }
        (0, $48c141f615e02ecf$export$2e2bcd8739ae039)($8d957d74809727b8$var$visualFuncs, prioritySortFunc);
        (0, $48c141f615e02ecf$export$2e2bcd8739ae039)($8d957d74809727b8$var$dataProcessorFuncs, prioritySortFunc);
        _this._scheduler = new (0, $7982fe5ed36bab1b$export$2e2bcd8739ae039)(_this, api, $8d957d74809727b8$var$dataProcessorFuncs, $8d957d74809727b8$var$visualFuncs);
        _this._messageCenter = new $8d957d74809727b8$var$MessageCenter();
        // Init mouse events
        _this._initEvents();
        // In case some people write `window.onresize = chart.resize`
        _this.resize = (0, $43e0a445ed6711da$export$2385a24977818dd0)(_this.resize, _this);
        zr.animation.on("frame", _this._onframe, _this);
        $8d957d74809727b8$var$bindRenderedEvent(zr, _this);
        $8d957d74809727b8$var$bindMouseEvent(zr, _this);
        // ECharts instance can be used as value.
        (0, $43e0a445ed6711da$export$112e66431016387b)(_this);
        return _this;
    }
    ECharts.prototype._onframe = function() {
        if (this._disposed) return;
        var scheduler = this._scheduler;
        var ecModel = this._model;
        var api = this._api;
        $8d957d74809727b8$var$applyChangedStates(this);
        // Lazy update
        if (this[$8d957d74809727b8$var$PENDING_UPDATE]) {
            var silent = this[$8d957d74809727b8$var$PENDING_UPDATE].silent;
            this[$8d957d74809727b8$var$IN_EC_CYCLE_KEY] = true;
            $8d957d74809727b8$var$updateECUpdateCycleVersion(this);
            try {
                $8d957d74809727b8$var$prepare(this);
                $8d957d74809727b8$var$updateMethods.update.call(this, null, this[$8d957d74809727b8$var$PENDING_UPDATE].updateParams);
            } catch (e) {
                this[$8d957d74809727b8$var$IN_EC_CYCLE_KEY] = false;
                this[$8d957d74809727b8$var$PENDING_UPDATE] = null;
                throw e;
            }
            // At present, in each frame, zrender performs:
            //   (1) animation step forward.
            //   (2) trigger('frame') (where this `_onframe` is called)
            //   (3) zrender flush (render).
            // If we do nothing here, since we use `setToFinal: true`, the step (3) above
            // will render the final state of the elements before the real animation started.
            this._zr.flush();
            this[$8d957d74809727b8$var$IN_EC_CYCLE_KEY] = false;
            this[$8d957d74809727b8$var$PENDING_UPDATE] = null;
            $8d957d74809727b8$var$flushPendingActions.call(this, silent);
            $8d957d74809727b8$var$triggerUpdatedEvent.call(this, silent);
        } else if (scheduler.unfinished) {
            // Stream progress.
            var remainTime = $8d957d74809727b8$var$TEST_FRAME_REMAIN_TIME;
            // PENDING: guard the following by `this[IN_EC_CYCLE_KEY] = true`?
            do {
                // Reset to false per iteration. Otherwise the last zr.flush
                // can not be triggered and 'finish' event can not be triggered.
                scheduler.unfinished = false;
                var startTime = (0, $08c3209e6efc839a$export$ef5e599365494451).getTime();
                scheduler.performSeriesTasks(ecModel);
                // Currently dataProcessorFuncs do not check threshold.
                scheduler.performDataProcessorTasks(ecModel);
                $8d957d74809727b8$var$updateStreamModes(this, ecModel);
                // Do not update coordinate system here. Because that coord system update in
                // each frame is not a good user experience. So we follow the rule that
                // the extent of the coordinate system is determined in the first frame (the
                // frame is executed immediately after task reset.
                // this._coordSysMgr.update(ecModel, api);
                // console.log('--- ec frame visual ---', remainTime);
                scheduler.performVisualTasks(ecModel);
                $8d957d74809727b8$var$renderSeries(this, this._model, api, "remain", {});
                remainTime -= (0, $08c3209e6efc839a$export$ef5e599365494451).getTime() - startTime;
            }while (remainTime > 0 && scheduler.unfinished);
            // Call flush explicitly for trigger finished event.
            if (!scheduler.unfinished) this._zr.flush();
        // Else, zr flushing be ensue within the same frame,
        // because zr flushing is after onframe event.
        }
    };
    ECharts.prototype.getDom = function() {
        return this._dom;
    };
    ECharts.prototype.getId = function() {
        return this.id;
    };
    ECharts.prototype.getZr = function() {
        return this._zr;
    };
    ECharts.prototype.isSSR = function() {
        return this._ssr;
    };
    /* eslint-disable-next-line */ ECharts.prototype.setOption = function(option, notMerge, lazyUpdate) {
        if (this[$8d957d74809727b8$var$IN_EC_CYCLE_KEY]) return;
        if (this._disposed) {
            $8d957d74809727b8$var$disposedWarning(this.id);
            return;
        }
        var silent;
        var replaceMerge;
        var transitionOpt;
        if ((0, $43e0a445ed6711da$export$a6cdc56e425d0d0a)(notMerge)) {
            lazyUpdate = notMerge.lazyUpdate;
            silent = notMerge.silent;
            replaceMerge = notMerge.replaceMerge;
            transitionOpt = notMerge.transition;
            notMerge = notMerge.notMerge;
        }
        this[$8d957d74809727b8$var$IN_EC_CYCLE_KEY] = true;
        $8d957d74809727b8$var$updateECUpdateCycleVersion(this);
        if (!this._model || notMerge) {
            var optionManager = new (0, $a22ea7e62969c051$export$2e2bcd8739ae039)(this._api);
            var theme = this._theme;
            var ecModel = this._model = new (0, $788e99a37a3fbb71$export$2e2bcd8739ae039)();
            ecModel.scheduler = this._scheduler;
            ecModel.ssr = this._ssr;
            ecModel.init(null, null, null, theme, this._locale, optionManager);
        }
        this._model.setOption(option, {
            replaceMerge: replaceMerge
        }, $8d957d74809727b8$var$optionPreprocessorFuncs);
        var updateParams = {
            seriesTransition: transitionOpt,
            optionChanged: true
        };
        if (lazyUpdate) {
            this[$8d957d74809727b8$var$PENDING_UPDATE] = {
                silent: silent,
                updateParams: updateParams
            };
            this[$8d957d74809727b8$var$IN_EC_CYCLE_KEY] = false;
            // `setOption(option, {lazyMode: true})` may be called when zrender has been slept.
            // It should wake it up to make sure zrender start to render at the next frame.
            this.getZr().wakeUp();
        } else {
            try {
                $8d957d74809727b8$var$prepare(this);
                $8d957d74809727b8$var$updateMethods.update.call(this, null, updateParams);
            } catch (e) {
                this[$8d957d74809727b8$var$PENDING_UPDATE] = null;
                this[$8d957d74809727b8$var$IN_EC_CYCLE_KEY] = false;
                throw e;
            }
            // Ensure zr refresh sychronously, and then pixel in canvas can be
            // fetched after `setOption`.
            if (!this._ssr) // not use flush when using ssr mode.
            this._zr.flush();
            this[$8d957d74809727b8$var$PENDING_UPDATE] = null;
            this[$8d957d74809727b8$var$IN_EC_CYCLE_KEY] = false;
            $8d957d74809727b8$var$flushPendingActions.call(this, silent);
            $8d957d74809727b8$var$triggerUpdatedEvent.call(this, silent);
        }
    };
    /**
   * Update theme with name or theme option and repaint the chart.
   * @param theme Theme name or theme option.
   * @param opts Optional settings
   */ ECharts.prototype.setTheme = function(theme, opts) {
        if (this[$8d957d74809727b8$var$IN_EC_CYCLE_KEY]) return;
        if (this._disposed) {
            $8d957d74809727b8$var$disposedWarning(this.id);
            return;
        }
        var ecModel = this._model;
        if (!ecModel) return;
        var silent = opts && opts.silent;
        var updateParams = null;
        if (this[$8d957d74809727b8$var$PENDING_UPDATE]) {
            if (silent == null) silent = this[$8d957d74809727b8$var$PENDING_UPDATE].silent;
            updateParams = this[$8d957d74809727b8$var$PENDING_UPDATE].updateParams;
            this[$8d957d74809727b8$var$PENDING_UPDATE] = null;
        }
        this[$8d957d74809727b8$var$IN_EC_CYCLE_KEY] = true;
        $8d957d74809727b8$var$updateECUpdateCycleVersion(this);
        try {
            this._updateTheme(theme);
            ecModel.setTheme(this._theme);
            $8d957d74809727b8$var$prepare(this);
            $8d957d74809727b8$var$updateMethods.update.call(this, {
                type: "setTheme"
            }, updateParams);
        } catch (e) {
            this[$8d957d74809727b8$var$IN_EC_CYCLE_KEY] = false;
            throw e;
        }
        this[$8d957d74809727b8$var$IN_EC_CYCLE_KEY] = false;
        $8d957d74809727b8$var$flushPendingActions.call(this, silent);
        $8d957d74809727b8$var$triggerUpdatedEvent.call(this, silent);
    };
    ECharts.prototype._updateTheme = function(theme) {
        if ((0, $43e0a445ed6711da$export$844ec244b1367d54)(theme)) theme = $8d957d74809727b8$var$themeStorage[theme];
        if (theme) {
            theme = (0, $43e0a445ed6711da$export$9cd59f9826255e47)(theme);
            theme && (0, $8dc883428bb9533d$export$2e2bcd8739ae039)(theme, true);
            this._theme = theme;
        }
    };
    // We don't want developers to use getModel directly.
    ECharts.prototype.getModel = function() {
        return this._model;
    };
    ECharts.prototype.getOption = function() {
        return this._model && this._model.getOption();
    };
    ECharts.prototype.getWidth = function() {
        return this._zr.getWidth();
    };
    ECharts.prototype.getHeight = function() {
        return this._zr.getHeight();
    };
    ECharts.prototype.getDevicePixelRatio = function() {
        return this._zr.painter.dpr || (0, $a84633bb9c74d89c$export$2e2bcd8739ae039).hasGlobalWindow && window.devicePixelRatio || 1;
    };
    /**
   * Get canvas which has all thing rendered
   * @deprecated Use renderToCanvas instead.
   */ ECharts.prototype.getRenderedCanvas = function(opts) {
        return this.renderToCanvas(opts);
    };
    ECharts.prototype.renderToCanvas = function(opts) {
        opts = opts || {};
        var painter = this._zr.painter;
        return painter.getRenderedCanvas({
            backgroundColor: opts.backgroundColor || this._model.get("backgroundColor"),
            pixelRatio: opts.pixelRatio || this.getDevicePixelRatio()
        });
    };
    ECharts.prototype.renderToSVGString = function(opts) {
        opts = opts || {};
        var painter = this._zr.painter;
        return painter.renderToString({
            useViewBox: opts.useViewBox
        });
    };
    /**
   * Get svg data url
   */ ECharts.prototype.getSvgDataURL = function() {
        var zr = this._zr;
        var list = zr.storage.getDisplayList();
        // Stop animations
        (0, $43e0a445ed6711da$export$79b2f7037acddd43)(list, function(el) {
            el.stopAnimation(null, true);
        });
        return zr.painter.toDataURL();
    };
    ECharts.prototype.getDataURL = function(opts) {
        if (this._disposed) {
            $8d957d74809727b8$var$disposedWarning(this.id);
            return;
        }
        opts = opts || {};
        var excludeComponents = opts.excludeComponents;
        var ecModel = this._model;
        var excludesComponentViews = [];
        var self = this;
        (0, $43e0a445ed6711da$export$79b2f7037acddd43)(excludeComponents, function(componentType) {
            ecModel.eachComponent({
                mainType: componentType
            }, function(component) {
                var view = self._componentsMap[component.__viewId];
                if (!view.group.ignore) {
                    excludesComponentViews.push(view);
                    view.group.ignore = true;
                }
            });
        });
        var url = this._zr.painter.getType() === "svg" ? this.getSvgDataURL() : this.renderToCanvas(opts).toDataURL("image/" + (opts && opts.type || "png"));
        (0, $43e0a445ed6711da$export$79b2f7037acddd43)(excludesComponentViews, function(view) {
            view.group.ignore = false;
        });
        return url;
    };
    ECharts.prototype.getConnectedDataURL = function(opts) {
        if (this._disposed) {
            $8d957d74809727b8$var$disposedWarning(this.id);
            return;
        }
        var isSvg = opts.type === "svg";
        var groupId = this.group;
        var mathMin = Math.min;
        var mathMax = Math.max;
        var MAX_NUMBER = Infinity;
        if ($8d957d74809727b8$var$connectedGroups[groupId]) {
            var left_1 = MAX_NUMBER;
            var top_1 = MAX_NUMBER;
            var right_1 = -MAX_NUMBER;
            var bottom_1 = -MAX_NUMBER;
            var canvasList_1 = [];
            var dpr_1 = opts && opts.pixelRatio || this.getDevicePixelRatio();
            (0, $43e0a445ed6711da$export$79b2f7037acddd43)($8d957d74809727b8$var$instances, function(chart, id) {
                if (chart.group === groupId) {
                    var canvas = isSvg ? chart.getZr().painter.getSvgDom().innerHTML : chart.renderToCanvas((0, $43e0a445ed6711da$export$9cd59f9826255e47)(opts));
                    var boundingRect = chart.getDom().getBoundingClientRect();
                    left_1 = mathMin(boundingRect.left, left_1);
                    top_1 = mathMin(boundingRect.top, top_1);
                    right_1 = mathMax(boundingRect.right, right_1);
                    bottom_1 = mathMax(boundingRect.bottom, bottom_1);
                    canvasList_1.push({
                        dom: canvas,
                        left: boundingRect.left,
                        top: boundingRect.top
                    });
                }
            });
            left_1 *= dpr_1;
            top_1 *= dpr_1;
            right_1 *= dpr_1;
            bottom_1 *= dpr_1;
            var width = right_1 - left_1;
            var height = bottom_1 - top_1;
            var targetCanvas = (0, $08c3209e6efc839a$export$ef5e599365494451).createCanvas();
            var zr_1 = $08a7e718789e144c$export$2cd8252107eb640b(targetCanvas, {
                renderer: isSvg ? "svg" : "canvas"
            });
            zr_1.resize({
                width: width,
                height: height
            });
            if (isSvg) {
                var content_1 = "";
                (0, $43e0a445ed6711da$export$79b2f7037acddd43)(canvasList_1, function(item) {
                    var x = item.left - left_1;
                    var y = item.top - top_1;
                    content_1 += '<g transform="translate(' + x + "," + y + ')">' + item.dom + "</g>";
                });
                zr_1.painter.getSvgRoot().innerHTML = content_1;
                if (opts.connectedBackgroundColor) zr_1.painter.setBackgroundColor(opts.connectedBackgroundColor);
                zr_1.refreshImmediately();
                return zr_1.painter.toDataURL();
            } else {
                // Background between the charts
                if (opts.connectedBackgroundColor) zr_1.add(new $42ed508a93973e78$export$2e2bcd8739ae039({
                    shape: {
                        x: 0,
                        y: 0,
                        width: width,
                        height: height
                    },
                    style: {
                        fill: opts.connectedBackgroundColor
                    }
                }));
                (0, $43e0a445ed6711da$export$79b2f7037acddd43)(canvasList_1, function(item) {
                    var img = new $d3b0315ae8e8e298$export$2e2bcd8739ae039({
                        style: {
                            x: item.left * dpr_1 - left_1,
                            y: item.top * dpr_1 - top_1,
                            image: item.dom
                        }
                    });
                    zr_1.add(img);
                });
                zr_1.refreshImmediately();
                return targetCanvas.toDataURL("image/" + (opts && opts.type || "png"));
            }
        } else return this.getDataURL(opts);
    };
    ECharts.prototype.convertToPixel = function(finder, value, opt) {
        return $8d957d74809727b8$var$doConvertPixel(this, "convertToPixel", finder, value, opt);
    };
    /**
   * Convert from logical coordinate system to pixel coordinate system.
   * See CoordinateSystem#convertToPixel.
   *
   * @see CoordinateSystem['dataToLayout'] for parameters and return.
   * @see CoordinateSystemDataCoord
   */ ECharts.prototype.convertToLayout = function(finder, value, opt) {
        return $8d957d74809727b8$var$doConvertPixel(this, "convertToLayout", finder, value, opt);
    };
    // The above are signatures from before v6, thus they should be preserved for backward compat.
    ECharts.prototype.convertFromPixel = function(finder, value, opt) {
        return $8d957d74809727b8$var$doConvertPixel(this, "convertFromPixel", finder, value, opt);
    };
    /**
   * Is the specified coordinate systems or components contain the given pixel point.
   * @param {Array|number} value
   * @return {boolean} result
   */ ECharts.prototype.containPixel = function(finder, value) {
        if (this._disposed) {
            $8d957d74809727b8$var$disposedWarning(this.id);
            return;
        }
        var ecModel = this._model;
        var result;
        var findResult = $87f4a59ac66e0ee6$export$95de80076abac814(ecModel, finder);
        (0, $43e0a445ed6711da$export$79b2f7037acddd43)(findResult, function(models, key) {
            key.indexOf("Models") >= 0 && (0, $43e0a445ed6711da$export$79b2f7037acddd43)(models, function(model) {
                var coordSys = model.coordinateSystem;
                if (coordSys && coordSys.containPoint) result = result || !!coordSys.containPoint(value);
                else if (key === "seriesModels") {
                    var view = this._chartsMap[model.__viewId];
                    if (view && view.containPoint) result = result || view.containPoint(value, model);
                }
            }, this);
        }, this);
        return !!result;
    };
    /**
   * Get visual from series or data.
   * @param finder
   *        If string, e.g., 'series', means {seriesIndex: 0}.
   *        If Object, could contain some of these properties below:
   *        {
   *            seriesIndex / seriesId / seriesName,
   *            dataIndex / dataIndexInside
   *        }
   *        If dataIndex is not specified, series visual will be fetched,
   *        but not data item visual.
   *        If all of seriesIndex, seriesId, seriesName are not specified,
   *        visual will be fetched from first series.
   * @param visualType 'color', 'symbol', 'symbolSize'
   */ ECharts.prototype.getVisual = function(finder, visualType) {
        var ecModel = this._model;
        var parsedFinder = $87f4a59ac66e0ee6$export$95de80076abac814(ecModel, finder, {
            defaultMainType: "series"
        });
        var seriesModel = parsedFinder.seriesModel;
        var data = seriesModel.getData();
        var dataIndexInside = parsedFinder.hasOwnProperty("dataIndexInside") ? parsedFinder.dataIndexInside : parsedFinder.hasOwnProperty("dataIndex") ? data.indexOfRawIndex(parsedFinder.dataIndex) : null;
        return dataIndexInside != null ? (0, $76af5bb296a0e67b$export$91d919a86b2df624)(data, dataIndexInside, visualType) : (0, $76af5bb296a0e67b$export$d76e333a86ea1a2)(data, visualType);
    };
    /**
   * Get view of corresponding component model
   */ ECharts.prototype.getViewOfComponentModel = function(componentModel) {
        return this._componentsMap[componentModel.__viewId];
    };
    /**
   * Get view of corresponding series model
   */ ECharts.prototype.getViewOfSeriesModel = function(seriesModel) {
        return this._chartsMap[seriesModel.__viewId];
    };
    ECharts.prototype._initEvents = function() {
        var _this = this;
        (0, $43e0a445ed6711da$export$79b2f7037acddd43)($8d957d74809727b8$var$MOUSE_EVENT_NAMES, function(eveName) {
            var handler = function(e) {
                var ecModel = _this.getModel();
                var el = e.target;
                var params;
                var isGlobalOut = eveName === "globalout";
                // no e.target when 'globalout'.
                if (isGlobalOut) params = {};
                else el && (0, $10e23f9ea92ef04e$export$8a4fca9e04eb4df6)(el, function(parent) {
                    var ecData = (0, $7e4afcfca8f5121f$export$b1c39b2bacd1ddc2)(parent);
                    if (ecData && ecData.dataIndex != null) {
                        var dataModel = ecData.dataModel || ecModel.getSeriesByIndex(ecData.seriesIndex);
                        params = dataModel && dataModel.getDataParams(ecData.dataIndex, ecData.dataType, el) || {};
                        return true;
                    } else if (ecData.eventData) {
                        params = (0, $43e0a445ed6711da$export$8b58be045bf06082)({}, ecData.eventData);
                        return true;
                    }
                }, true);
                // Contract: if params prepared in mouse event,
                // these properties must be specified:
                // {
                //    componentType: string (component main type)
                //    componentIndex: number
                // }
                // Otherwise event query can not work.
                if (params) {
                    var componentType = params.componentType;
                    var componentIndex = params.componentIndex;
                    // Special handling for historic reason: when trigger by
                    // markLine/markPoint/markArea, the componentType is
                    // 'markLine'/'markPoint'/'markArea', but we should better
                    // enable them to be queried by seriesIndex, since their
                    // option is set in each series.
                    if (componentType === "markLine" || componentType === "markPoint" || componentType === "markArea") {
                        componentType = "series";
                        componentIndex = params.seriesIndex;
                    }
                    var model = componentType && componentIndex != null && ecModel.getComponent(componentType, componentIndex);
                    var view = model && _this[model.mainType === "series" ? "_chartsMap" : "_componentsMap"][model.__viewId];
                    params.event = e;
                    params.type = eveName;
                    _this._$eventProcessor.eventInfo = {
                        targetEl: el,
                        packedEvent: params,
                        model: model,
                        view: view
                    };
                    _this.trigger(eveName, params);
                }
            };
            // Consider that some component (like tooltip, brush, ...)
            // register zr event handler, but user event handler might
            // do anything, such as call `setOption` or `dispatchAction`,
            // which probably update any of the content and probably
            // cause problem if it is called previous other inner handlers.
            handler.zrEventfulCallAtLast = true;
            _this._zr.on(eveName, handler, _this);
        });
        var messageCenter = this._messageCenter;
        (0, $43e0a445ed6711da$export$79b2f7037acddd43)($8d957d74809727b8$var$publicEventTypeMap, function(_, eventType) {
            messageCenter.on(eventType, function(event) {
                _this.trigger(eventType, event);
            });
        });
        (0, $5779b3a999a9cae1$export$2575c83262e49d0c)(messageCenter, this, this._api);
    };
    ECharts.prototype.isDisposed = function() {
        return this._disposed;
    };
    ECharts.prototype.clear = function() {
        if (this._disposed) {
            $8d957d74809727b8$var$disposedWarning(this.id);
            return;
        }
        this.setOption({
            series: []
        }, true);
    };
    ECharts.prototype.dispose = function() {
        if (this._disposed) {
            $8d957d74809727b8$var$disposedWarning(this.id);
            return;
        }
        this._disposed = true;
        var dom = this.getDom();
        if (dom) $87f4a59ac66e0ee6$export$9fec4d97f1922e0b(this.getDom(), $8d957d74809727b8$var$DOM_ATTRIBUTE_KEY, "");
        var chart = this;
        var api = chart._api;
        var ecModel = chart._model;
        (0, $43e0a445ed6711da$export$79b2f7037acddd43)(chart._componentsViews, function(component) {
            component.dispose(ecModel, api);
        });
        (0, $43e0a445ed6711da$export$79b2f7037acddd43)(chart._chartsViews, function(chart) {
            chart.dispose(ecModel, api);
        });
        // Dispose after all views disposed
        chart._zr.dispose();
        // Set properties to null.
        // To reduce the memory cost in case the top code still holds this instance unexpectedly.
        chart._dom = chart._model = chart._chartsMap = chart._componentsMap = chart._chartsViews = chart._componentsViews = chart._scheduler = chart._api = chart._zr = chart._throttledZrFlush = chart._theme = chart._coordSysMgr = chart._messageCenter = null;
        delete $8d957d74809727b8$var$instances[chart.id];
    };
    /**
   * Resize the chart
   */ ECharts.prototype.resize = function(opts) {
        if (this[$8d957d74809727b8$var$IN_EC_CYCLE_KEY]) return;
        if (this._disposed) {
            $8d957d74809727b8$var$disposedWarning(this.id);
            return;
        }
        this._zr.resize(opts);
        var ecModel = this._model;
        // Resize loading effect
        this._loadingFX && this._loadingFX.resize();
        if (!ecModel) return;
        var needPrepare = ecModel.resetOption("media");
        var silent = opts && opts.silent;
        // There is some real cases that:
        // chart.setOption(option, { lazyUpdate: true });
        // chart.resize();
        if (this[$8d957d74809727b8$var$PENDING_UPDATE]) {
            if (silent == null) silent = this[$8d957d74809727b8$var$PENDING_UPDATE].silent;
            needPrepare = true;
            this[$8d957d74809727b8$var$PENDING_UPDATE] = null;
        }
        this[$8d957d74809727b8$var$IN_EC_CYCLE_KEY] = true;
        $8d957d74809727b8$var$updateECUpdateCycleVersion(this);
        try {
            needPrepare && $8d957d74809727b8$var$prepare(this);
            $8d957d74809727b8$var$updateMethods.update.call(this, {
                type: "resize",
                animation: (0, $43e0a445ed6711da$export$8b58be045bf06082)({
                    // Disable animation
                    duration: 0
                }, opts && opts.animation)
            });
        } catch (e) {
            this[$8d957d74809727b8$var$IN_EC_CYCLE_KEY] = false;
            throw e;
        }
        this[$8d957d74809727b8$var$IN_EC_CYCLE_KEY] = false;
        $8d957d74809727b8$var$flushPendingActions.call(this, silent);
        $8d957d74809727b8$var$triggerUpdatedEvent.call(this, silent);
    };
    ECharts.prototype.showLoading = function(name, cfg) {
        if (this._disposed) {
            $8d957d74809727b8$var$disposedWarning(this.id);
            return;
        }
        if ((0, $43e0a445ed6711da$export$a6cdc56e425d0d0a)(name)) {
            cfg = name;
            name = "";
        }
        name = name || "default";
        this.hideLoading();
        if (!$8d957d74809727b8$var$loadingEffects[name]) return;
        var el = $8d957d74809727b8$var$loadingEffects[name](this._api, cfg);
        var zr = this._zr;
        this._loadingFX = el;
        zr.add(el);
    };
    /**
   * Hide loading effect
   */ ECharts.prototype.hideLoading = function() {
        if (this._disposed) {
            $8d957d74809727b8$var$disposedWarning(this.id);
            return;
        }
        this._loadingFX && this._zr.remove(this._loadingFX);
        this._loadingFX = null;
    };
    ECharts.prototype.makeActionFromEvent = function(eventObj) {
        var payload = (0, $43e0a445ed6711da$export$8b58be045bf06082)({}, eventObj);
        payload.type = $8d957d74809727b8$var$connectionEventRevertMap[eventObj.type];
        return payload;
    };
    /**
   * @param opt If pass boolean, means opt.silent
   * @param opt.silent Default `false`. Whether trigger events.
   * @param opt.flush Default `undefined`.
   *        true: Flush immediately, and then pixel in canvas can be fetched
   *            immediately. Caution: it might affect performance.
   *        false: Not flush.
   *        undefined: Auto decide whether perform flush.
   */ ECharts.prototype.dispatchAction = function(payload, opt) {
        if (this._disposed) {
            $8d957d74809727b8$var$disposedWarning(this.id);
            return;
        }
        if (!(0, $43e0a445ed6711da$export$a6cdc56e425d0d0a)(opt)) opt = {
            silent: !!opt
        };
        if (!$8d957d74809727b8$var$actions[payload.type]) return;
        // Avoid dispatch action before setOption. Especially in `connect`.
        if (!this._model) return;
        // May dispatchAction in rendering procedure
        if (this[$8d957d74809727b8$var$IN_EC_CYCLE_KEY]) {
            this._pendingActions.push(payload);
            return;
        }
        var silent = opt.silent;
        $8d957d74809727b8$var$doDispatchAction.call(this, payload, silent);
        var flush = opt.flush;
        if (flush) this._zr.flush();
        else if (flush !== false && (0, $a84633bb9c74d89c$export$2e2bcd8739ae039).browser.weChat) // In WeChat embedded browser, `requestAnimationFrame` and `setInterval`
        // hang when sliding page (on touch event), which cause that zr does not
        // refresh until user interaction finished, which is not expected.
        // But `dispatchAction` may be called too frequently when pan on touch
        // screen, which impacts performance if do not throttle them.
        this._throttledZrFlush();
        $8d957d74809727b8$var$flushPendingActions.call(this, silent);
        $8d957d74809727b8$var$triggerUpdatedEvent.call(this, silent);
    };
    ECharts.prototype.updateLabelLayout = function() {
        (0, $567b7069bdf5f856$export$2e2bcd8739ae039).trigger("series:layoutlabels", this._model, this._api, {
            // Not adding series labels.
            // TODO
            updatedSeries: []
        });
    };
    ECharts.prototype.appendData = function(params) {
        if (this._disposed) {
            $8d957d74809727b8$var$disposedWarning(this.id);
            return;
        }
        var seriesIndex = params.seriesIndex;
        var ecModel = this.getModel();
        var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
        seriesModel.appendData(params);
        // NOTICE:
        // `appendData` does not support to update axis scale extent of coordinate
        // systems. In the expected usage of `appendData`, the initial extent of
        // coordinate system should be explicitly specified (by `xxxAxis.data` for
        // 'category' axis or by `xxxAxis.min/max` for other axes). Otherwise, if
        // the extent keep changing while `appendData`, the location of the painted
        // graphic elements have to be changed frequently.
        this._scheduler.unfinished = true;
        this.getZr().wakeUp();
    };
    // A work around for no `internal` modifier in ts yet but
    // need to strictly hide private methods to JS users.
    ECharts.internalField = function() {
        $8d957d74809727b8$var$prepare = function(ecIns) {
            (0, $b6f52a1ffb51de17$export$54b70eb74482271e)(ecIns._model);
            var scheduler = ecIns._scheduler;
            scheduler.restorePipelines(ecIns._zr, ecIns._model);
            scheduler.prepareStageTasks();
            $8d957d74809727b8$var$prepareView(ecIns, true);
            $8d957d74809727b8$var$prepareView(ecIns, false);
            scheduler.plan();
        };
        /**
     * Prepare view instances of charts and components
     */ $8d957d74809727b8$var$prepareView = function(ecIns, isComponent) {
            var ecModel = ecIns._model;
            var scheduler = ecIns._scheduler;
            var viewList = isComponent ? ecIns._componentsViews : ecIns._chartsViews;
            var viewMap = isComponent ? ecIns._componentsMap : ecIns._chartsMap;
            var zr = ecIns._zr;
            var api = ecIns._api;
            for(var i = 0; i < viewList.length; i++)viewList[i].__alive = false;
            isComponent ? ecModel.eachComponent(function(componentType, model) {
                componentType !== "series" && doPrepare(model);
            }) : ecModel.eachSeries(doPrepare);
            function doPrepare(model) {
                // By default view will be reused if possible for the case that `setOption` with "notMerge"
                // mode and need to enable transition animation. (Usually, when they have the same id, or
                // especially no id but have the same type & name & index. See the `model.id` generation
                // rule in `makeIdAndName` and `viewId` generation rule here).
                // But in `replaceMerge` mode, this feature should be able to disabled when it is clear that
                // the new model has nothing to do with the old model.
                var requireNewView = model.__requireNewView;
                // This command should not work twice.
                model.__requireNewView = false;
                // Consider: id same and type changed.
                var viewId = "_ec_" + model.id + "_" + model.type;
                var view = !requireNewView && viewMap[viewId];
                if (!view) {
                    var classType = (0, $10ce7a4361c3910c$export$fbe18865d303bf01)(model.type);
                    var Clazz = isComponent ? (0, $c81700f6bd52c5a7$export$2e2bcd8739ae039).getClass(classType.main, classType.sub) : // FIXME:TS
                    // (ChartView as ChartViewConstructor).getClass('series', classType.sub)
                    // For backward compat, still support a chart type declared as only subType
                    // like "liquidfill", but recommend "series.liquidfill"
                    // But need a base class to make a type series.
                    (0, $9bc1fbefe72d5b26$export$2e2bcd8739ae039).getClass(classType.sub);
                    view = new Clazz();
                    view.init(ecModel, api);
                    viewMap[viewId] = view;
                    viewList.push(view);
                    zr.add(view.group);
                }
                model.__viewId = view.__id = viewId;
                view.__alive = true;
                view.__model = model;
                view.group.__ecComponentInfo = {
                    mainType: model.mainType,
                    index: model.componentIndex
                };
                !isComponent && scheduler.prepareView(view, model, ecModel, api);
            }
            for(var i = 0; i < viewList.length;){
                var view = viewList[i];
                if (!view.__alive) {
                    !isComponent && view.renderTask.dispose();
                    zr.remove(view.group);
                    view.dispose(ecModel, api);
                    viewList.splice(i, 1);
                    if (viewMap[view.__id] === view) delete viewMap[view.__id];
                    view.__id = view.group.__ecComponentInfo = null;
                } else i++;
            }
        };
        $8d957d74809727b8$var$updateDirectly = function(ecIns, method, payload, mainType, subType) {
            var ecModel = ecIns._model;
            ecModel.setUpdatePayload(payload);
            // broadcast (e.g., for ':updateAxisPointer')
            if (!mainType) {
                // FIXME
                // Chart will not be update directly here, except set dirty.
                // But there is no such scenario now.
                (0, $43e0a445ed6711da$export$79b2f7037acddd43)([].concat(ecIns._componentsViews).concat(ecIns._chartsViews), callView);
                return;
            }
            var condition = $87f4a59ac66e0ee6$export$c064a542e5272c93(payload, mainType, subType);
            var excludeSeriesId = payload.excludeSeriesId;
            var excludeSeriesIdMap;
            if (excludeSeriesId != null) {
                excludeSeriesIdMap = (0, $43e0a445ed6711da$export$55f8aa7ef875b0a4)();
                (0, $43e0a445ed6711da$export$79b2f7037acddd43)($87f4a59ac66e0ee6$export$4f07b212a02c8051(excludeSeriesId), function(id) {
                    var modelId = $87f4a59ac66e0ee6$export$fb1a222ba5dd6e51(id, null);
                    if (modelId != null) excludeSeriesIdMap.set(modelId, true);
                });
            }
            // If dispatchAction before setOption, do nothing.
            ecModel && ecModel.eachComponent(condition, function(model) {
                var isExcluded = excludeSeriesIdMap && excludeSeriesIdMap.get(model.id) != null;
                if (isExcluded) return;
                if ((0, $fffc76734a157b4c$export$aebe71265c1b77bf)(payload)) {
                    if (model instanceof (0, $39002e2f499d7a2f$export$2e2bcd8739ae039)) {
                        if (payload.type === (0, $fffc76734a157b4c$export$df035d873a9de64f) && !payload.notBlur && !model.get([
                            "emphasis",
                            "disabled"
                        ])) (0, $fffc76734a157b4c$export$64f1fd4daefef21b)(model, payload, ecIns._api);
                    } else {
                        var _a = (0, $fffc76734a157b4c$export$f31a644ccca0ef23)(model.mainType, model.componentIndex, payload.name, ecIns._api), focusSelf = _a.focusSelf, dispatchers = _a.dispatchers;
                        if (payload.type === (0, $fffc76734a157b4c$export$df035d873a9de64f) && focusSelf && !payload.notBlur) (0, $fffc76734a157b4c$export$569da03256c8a55f)(model.mainType, model.componentIndex, ecIns._api);
                        // PENDING:
                        // Whether to put this "enter emphasis" code in `ComponentView`,
                        // which will be the same as `ChartView` but might be not necessary
                        // and will be far from this logic.
                        if (dispatchers) (0, $43e0a445ed6711da$export$79b2f7037acddd43)(dispatchers, function(dispatcher) {
                            payload.type === (0, $fffc76734a157b4c$export$df035d873a9de64f) ? (0, $fffc76734a157b4c$export$b2d02638cc34c042)(dispatcher) : (0, $fffc76734a157b4c$export$11be6f716239ac55)(dispatcher);
                        });
                    }
                } else if ((0, $fffc76734a157b4c$export$72aea10e60e45351)(payload)) // TODO geo
                {
                    if (model instanceof (0, $39002e2f499d7a2f$export$2e2bcd8739ae039)) {
                        (0, $fffc76734a157b4c$export$1c7d489f62372d73)(model, payload, ecIns._api);
                        (0, $fffc76734a157b4c$export$e4ea08ef52e0a73)(model);
                        $8d957d74809727b8$var$markStatusToUpdate(ecIns);
                    }
                }
            }, ecIns);
            ecModel && ecModel.eachComponent(condition, function(model) {
                var isExcluded = excludeSeriesIdMap && excludeSeriesIdMap.get(model.id) != null;
                if (isExcluded) return;
                callView(ecIns[mainType === "series" ? "_chartsMap" : "_componentsMap"][model.__viewId]);
            }, ecIns);
            function callView(view) {
                view && view.__alive && view[method] && view[method](view.__model, ecModel, ecIns._api, payload);
            }
        };
        $8d957d74809727b8$var$updateMethods = {
            prepareAndUpdate: function(payload) {
                $8d957d74809727b8$var$prepare(this);
                $8d957d74809727b8$var$updateMethods.update.call(this, payload, payload && {
                    // Needs to mark option changed if newOption is given.
                    // It's from MagicType.
                    // TODO If use a separate flag optionChanged in payload?
                    optionChanged: payload.newOption != null
                });
            },
            update: function(payload, updateParams) {
                var ecModel = this._model;
                var api = this._api;
                var zr = this._zr;
                var coordSysMgr = this._coordSysMgr;
                var scheduler = this._scheduler;
                // update before setOption
                if (!ecModel) return;
                (0, $b6f52a1ffb51de17$export$7a0372e5df3ca6f4)(ecModel);
                ecModel.setUpdatePayload(payload);
                scheduler.restoreData(ecModel, payload);
                scheduler.performSeriesTasks(ecModel);
                // TODO
                // Save total ecModel here for undo/redo (after restoring data and before processing data).
                // Undo (restoration of total ecModel) can be carried out in 'action' or outside API call.
                // Create new coordinate system each update
                // In LineView may save the old coordinate system and use it to get the original point.
                coordSysMgr.create(ecModel, api);
                (0, $567b7069bdf5f856$export$2e2bcd8739ae039).trigger("coordsys:aftercreate", ecModel, api);
                scheduler.performDataProcessorTasks(ecModel, payload);
                // Current stream render is not supported in data process. So we can update
                // stream modes after data processing, where the filtered data is used to
                // determine whether to use progressive rendering.
                $8d957d74809727b8$var$updateStreamModes(this, ecModel);
                // We update stream modes before coordinate system updated, then the modes info
                // can be fetched when coord sys updating (consider the barGrid extent fix). But
                // the drawback is the full coord info can not be fetched. Fortunately this full
                // coord is not required in stream mode updater currently.
                coordSysMgr.update(ecModel, api);
                clearColorPalette(ecModel);
                scheduler.performVisualTasks(ecModel, payload);
                // Set background and dark mode before rendering, because they affect auto-color-determination
                // in zrender Text, and consequently affect the bounding rect if stroke is added.
                var backgroundColor = ecModel.get("backgroundColor") || "transparent";
                zr.setBackgroundColor(backgroundColor);
                // Force set dark mode.
                var darkMode = ecModel.get("darkMode");
                if (darkMode != null && darkMode !== "auto") zr.setDarkMode(darkMode);
                $8d957d74809727b8$var$render(this, ecModel, api, payload, updateParams);
                (0, $567b7069bdf5f856$export$2e2bcd8739ae039).trigger("afterupdate", ecModel, api);
            },
            /**
       * PENDING: See INCONSISTENCY_OF_BRUSH_SELECTED_EVENT_IN_UPDATE_TRANSFORM
       */ updateTransform: function(payload) {
                var ecIns = this;
                var ecModel = ecIns._model;
                var api = ecIns._api;
                // update before setOption
                if (!ecModel) return;
                ecModel.setUpdatePayload(payload);
                // ChartView.markUpdateMethod(payload, 'updateTransform');
                var componentDirtyList = [];
                ecModel.eachComponent(function(mainType, componentModel) {
                    if (mainType === (0, $bde9c82f7837f767$export$68ebcbce21494007)) return;
                    var componentView = ecIns.getViewOfComponentModel(componentModel);
                    if (componentView && componentView.__alive) {
                        if (componentView.updateTransform) {
                            var result = componentView.updateTransform(componentModel, ecModel, api, payload);
                            result && result.update && componentDirtyList.push(componentView);
                        } else componentDirtyList.push(componentView);
                    }
                });
                var seriesDirtyMap = (0, $43e0a445ed6711da$export$55f8aa7ef875b0a4)();
                ecModel.eachSeries(function(seriesModel) {
                    var chartView = ecIns._chartsMap[seriesModel.__viewId];
                    var pipelineContext = seriesModel.pipelineContext;
                    if (chartView.updateTransform && !pipelineContext.progressiveRender) {
                        var result = chartView.updateTransform(seriesModel, ecModel, api, payload);
                        result && result.update && seriesDirtyMap.set(seriesModel.uid, 1);
                    } else seriesDirtyMap.set(seriesModel.uid, 1);
                });
                // Palette should not be cleared, otherwise the variation of dirty series
                // can cause color change unexpectedly.
                // clearColorPalette(ecModel);
                // NOTICE: series data tasks must NOT be dirty, otherwise series data will be recreated.
                // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
                // this._scheduler.performVisualTasks(ecModel, payload, 'layout', true);
                ecIns._scheduler.performVisualTasks(ecModel, payload, {
                    setDirty: true,
                    dirtyMap: seriesDirtyMap
                });
                // Currently, not call render of components. Geo render cost a lot.
                // renderComponents(ecIns, ecModel, api, payload, componentDirtyList);
                $8d957d74809727b8$var$renderSeries(ecIns, ecModel, api, payload, {}, seriesDirtyMap);
                (0, $567b7069bdf5f856$export$2e2bcd8739ae039).trigger("afterupdate", ecModel, api);
            },
            updateView: function(payload) {
                var ecModel = this._model;
                // update before setOption
                if (!ecModel) return;
                ecModel.setUpdatePayload(payload);
                (0, $9bc1fbefe72d5b26$export$2e2bcd8739ae039).markUpdateMethod(payload, "updateView");
                clearColorPalette(ecModel);
                // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
                this._scheduler.performVisualTasks(ecModel, payload, {
                    setDirty: true
                });
                $8d957d74809727b8$var$render(this, ecModel, this._api, payload, {});
                (0, $567b7069bdf5f856$export$2e2bcd8739ae039).trigger("afterupdate", ecModel, this._api);
            },
            updateVisual: function(payload) {
                var _this = this;
                var ecModel = this._model;
                // update before setOption
                if (!ecModel) return;
                ecModel.setUpdatePayload(payload);
                // clear all visual
                ecModel.eachSeries(function(seriesModel) {
                    seriesModel.getData().clearAllVisual();
                });
                // Perform visual
                (0, $9bc1fbefe72d5b26$export$2e2bcd8739ae039).markUpdateMethod(payload, "updateVisual");
                clearColorPalette(ecModel);
                // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
                this._scheduler.performVisualTasks(ecModel, payload, {
                    visualType: "visual",
                    setDirty: true
                });
                // FIXME: `visualType` may be removed, since it conflicts with `priority` of task. `updateVisual`
                // can be altered to start the pipeline with a certain priority, rather than only execute tasks
                // with `visualType: 'visual'`, otherwise, PRIORITY_VISUAL_POST_CHART_LAYOUT is omitted in this
                // case. Currently, only "brush" uses `updateVisual`, and it works by coincidence.
                ecModel.eachComponent(function(componentType, componentModel) {
                    if (componentType !== "series") {
                        var componentView = _this.getViewOfComponentModel(componentModel);
                        componentView && componentView.__alive && componentView.updateVisual(componentModel, ecModel, _this._api, payload);
                    }
                });
                ecModel.eachSeries(function(seriesModel) {
                    var chartView = _this._chartsMap[seriesModel.__viewId];
                    chartView.updateVisual(seriesModel, ecModel, _this._api, payload);
                });
                (0, $567b7069bdf5f856$export$2e2bcd8739ae039).trigger("afterupdate", ecModel, this._api);
            },
            /**
       * @deprecated
       */ updateLayout: function(payload) {
                $8d957d74809727b8$var$updateMethods.update.call(this, payload);
            }
        };
        function doConvertPixelImpl(ecIns, methodName, finder, value, opt) {
            if (ecIns._disposed) {
                $8d957d74809727b8$var$disposedWarning(ecIns.id);
                return;
            }
            var ecModel = ecIns._model;
            var coordSysList = ecIns._coordSysMgr.getCoordinateSystems();
            var result;
            var parsedFinder = $87f4a59ac66e0ee6$export$95de80076abac814(ecModel, finder);
            for(var i = 0; i < coordSysList.length; i++){
                var coordSys = coordSysList[i];
                if (coordSys[methodName] && (result = coordSys[methodName](ecModel, parsedFinder, value, opt)) != null) return result;
            }
        }
        $8d957d74809727b8$var$doConvertPixel = doConvertPixelImpl;
        $8d957d74809727b8$var$updateStreamModes = function(ecIns, ecModel) {
            var chartsMap = ecIns._chartsMap;
            var scheduler = ecIns._scheduler;
            ecModel.eachSeries(function(seriesModel) {
                scheduler.updateStreamModes(seriesModel, chartsMap[seriesModel.__viewId]);
            });
        };
        $8d957d74809727b8$var$doDispatchAction = function(payload, silent) {
            var _this = this;
            var ecModel = this.getModel();
            var payloadType = payload.type;
            var escapeConnect = payload.escapeConnect;
            var actionInfo = $8d957d74809727b8$var$actions[payloadType];
            var cptTypeTmp = (actionInfo.update || "update").split(":");
            var updateMethod = cptTypeTmp.pop();
            var cptType = cptTypeTmp[0] != null && (0, $10ce7a4361c3910c$export$fbe18865d303bf01)(cptTypeTmp[0]);
            this[$8d957d74809727b8$var$IN_EC_CYCLE_KEY] = true;
            $8d957d74809727b8$var$updateECUpdateCycleVersion(this);
            var payloads = [
                payload
            ];
            var batched = false;
            // Batch action
            if (payload.batch) {
                batched = true;
                payloads = (0, $43e0a445ed6711da$export$871de8747c9eaa88)(payload.batch, function(item) {
                    item = (0, $43e0a445ed6711da$export$ebe90cb607ad99e)((0, $43e0a445ed6711da$export$8b58be045bf06082)({}, item), payload);
                    item.batch = null;
                    return item;
                });
            }
            var eventObjBatch = [];
            var eventObj;
            var actionResultBatch = [];
            var nonRefinedEventType = actionInfo.nonRefinedEventType;
            var isSelectChange = (0, $fffc76734a157b4c$export$72aea10e60e45351)(payload);
            var isHighDown = (0, $fffc76734a157b4c$export$aebe71265c1b77bf)(payload);
            // Only leave blur once if there are multiple batches.
            if (isHighDown) (0, $fffc76734a157b4c$export$b2a593c7b5243584)(this._api);
            (0, $43e0a445ed6711da$export$79b2f7037acddd43)(payloads, function(batchItem) {
                // Action can specify the event by return it.
                var actionResult = actionInfo.action(batchItem, ecModel, _this._api);
                if (actionInfo.refineEvent) actionResultBatch.push(actionResult);
                else eventObj = actionResult;
                eventObj = eventObj || (0, $43e0a445ed6711da$export$8b58be045bf06082)({}, batchItem);
                eventObj.type = nonRefinedEventType;
                eventObjBatch.push(eventObj);
                // light update does not perform data process, layout and visual.
                if (isHighDown) {
                    var _a = $87f4a59ac66e0ee6$export$fe600815775d9400(payload), queryOptionMap = _a.queryOptionMap, mainTypeSpecified = _a.mainTypeSpecified;
                    var componentMainType = mainTypeSpecified ? queryOptionMap.keys()[0] : "series";
                    $8d957d74809727b8$var$updateDirectly(_this, updateMethod, batchItem, componentMainType);
                    $8d957d74809727b8$var$markStatusToUpdate(_this);
                } else if (isSelectChange) {
                    // At present `dispatchAction({ type: 'select', ... })` is not supported on components.
                    // geo still use 'geoselect'.
                    $8d957d74809727b8$var$updateDirectly(_this, updateMethod, batchItem, "series");
                    $8d957d74809727b8$var$markStatusToUpdate(_this);
                } else if (cptType) $8d957d74809727b8$var$updateDirectly(_this, updateMethod, batchItem, cptType.main, cptType.sub);
            });
            if (updateMethod !== "none" && !isHighDown && !isSelectChange && !cptType) try {
                // Still dirty
                if (this[$8d957d74809727b8$var$PENDING_UPDATE]) {
                    $8d957d74809727b8$var$prepare(this);
                    $8d957d74809727b8$var$updateMethods.update.call(this, payload);
                    this[$8d957d74809727b8$var$PENDING_UPDATE] = null;
                } else $8d957d74809727b8$var$updateMethods[updateMethod].call(this, payload);
            } catch (e) {
                this[$8d957d74809727b8$var$IN_EC_CYCLE_KEY] = false;
                throw e;
            }
            // Follow the rule of action batch
            if (batched) eventObj = {
                type: nonRefinedEventType,
                escapeConnect: escapeConnect,
                batch: eventObjBatch
            };
            else eventObj = eventObjBatch[0];
            this[$8d957d74809727b8$var$IN_EC_CYCLE_KEY] = false;
            if (!silent) {
                var refinedEvent = void 0;
                if (actionInfo.refineEvent) {
                    var eventContent = actionInfo.refineEvent(actionResultBatch, payload, ecModel, this._api).eventContent;
                    (0, $43e0a445ed6711da$export$a7a9523472993e97)((0, $43e0a445ed6711da$export$a6cdc56e425d0d0a)(eventContent));
                    refinedEvent = (0, $43e0a445ed6711da$export$ebe90cb607ad99e)({
                        type: actionInfo.refinedEventType
                    }, eventContent);
                    refinedEvent.fromAction = payload.type;
                    refinedEvent.fromActionPayload = payload;
                    refinedEvent.escapeConnect = true;
                }
                var messageCenter = this._messageCenter;
                // - If `refineEvent` created a `refinedEvent`, `eventObj` (replicated from the original payload)
                //  is still needed to be triggered for the feature `connect`. But it will not be triggered to
                //  users in this case.
                // - If no `refineEvent` used, `eventObj` will be triggered for both `connect` and users.
                messageCenter.trigger(eventObj.type, eventObj);
                if (refinedEvent) messageCenter.trigger(refinedEvent.type, refinedEvent);
            }
        };
        $8d957d74809727b8$var$flushPendingActions = function(silent) {
            var pendingActions = this._pendingActions;
            while(pendingActions.length){
                var payload = pendingActions.shift();
                $8d957d74809727b8$var$doDispatchAction.call(this, payload, silent);
            }
        };
        $8d957d74809727b8$var$triggerUpdatedEvent = function(silent) {
            !silent && this.trigger("updated");
        };
        /**
     * Event `rendered` is triggered when zr
     * rendered. It is useful for realtime
     * snapshot (reflect animation).
     *
     * Event `finished` is triggered when:
     * (1) zrender rendering finished.
     * (2) initial animation finished.
     * (3) progressive rendering finished.
     * (4) no pending action.
     * (5) no delayed setOption needs to be processed.
     */ $8d957d74809727b8$var$bindRenderedEvent = function(zr, ecIns) {
            zr.on("rendered", function(params) {
                ecIns.trigger("rendered", params);
                // The `finished` event should not be triggered repeatedly,
                // so it should only be triggered when rendering indeed happens
                // in zrender. (Consider the case that dispatchAction is keep
                // triggering when mouse move).
                if (// Although zr is dirty if initial animation is not finished
                // and this checking is called on frame, we also check
                // animation finished for robustness.
                zr.animation.isFinished() && !ecIns[$8d957d74809727b8$var$PENDING_UPDATE] && !ecIns._scheduler.unfinished && !ecIns._pendingActions.length) ecIns.trigger("finished");
                else // Make sure this method can be entered again in next frames.
                zr.refresh();
            });
        };
        $8d957d74809727b8$var$bindMouseEvent = function(zr, ecIns) {
            zr.on("mouseover", function(e) {
                var el = e.target;
                var dispatcher = (0, $10e23f9ea92ef04e$export$8a4fca9e04eb4df6)(el, (0, $fffc76734a157b4c$export$77d1445f699c58b5));
                if (dispatcher) {
                    (0, $fffc76734a157b4c$export$416765b6198234ff)(dispatcher, e, ecIns._api);
                    $8d957d74809727b8$var$markStatusToUpdate(ecIns);
                }
            }).on("mouseout", function(e) {
                var el = e.target;
                var dispatcher = (0, $10e23f9ea92ef04e$export$8a4fca9e04eb4df6)(el, (0, $fffc76734a157b4c$export$77d1445f699c58b5));
                if (dispatcher) {
                    (0, $fffc76734a157b4c$export$bb1c7b62436282a)(dispatcher, e, ecIns._api);
                    $8d957d74809727b8$var$markStatusToUpdate(ecIns);
                }
            }).on("click", function(e) {
                var el = e.target;
                var dispatcher = (0, $10e23f9ea92ef04e$export$8a4fca9e04eb4df6)(el, function(target) {
                    return (0, $7e4afcfca8f5121f$export$b1c39b2bacd1ddc2)(target).dataIndex != null;
                }, true);
                if (dispatcher) {
                    var actionType = dispatcher.selected ? "unselect" : "select";
                    var ecData = (0, $7e4afcfca8f5121f$export$b1c39b2bacd1ddc2)(dispatcher);
                    ecIns._api.dispatchAction({
                        type: actionType,
                        dataType: ecData.dataType,
                        dataIndexInside: ecData.dataIndex,
                        seriesIndex: ecData.seriesIndex,
                        isFromClick: true
                    });
                }
            });
        };
        function clearColorPalette(ecModel) {
            ecModel.clearColorPalette();
            ecModel.eachSeries(function(seriesModel) {
                seriesModel.clearColorPalette();
            });
        }
        // Allocate zlevels for series and components
        function allocateZlevels(ecModel) {
            var componentZLevels = [];
            var seriesZLevels = [];
            var hasSeparateZLevel = false;
            ecModel.eachComponent(function(componentType, componentModel) {
                var zlevel = componentModel.get("zlevel") || 0;
                var z = componentModel.get("z") || 0;
                var zlevelKey = componentModel.getZLevelKey();
                hasSeparateZLevel = hasSeparateZLevel || !!zlevelKey;
                (componentType === "series" ? seriesZLevels : componentZLevels).push({
                    zlevel: zlevel,
                    z: z,
                    idx: componentModel.componentIndex,
                    type: componentType,
                    key: zlevelKey
                });
            });
            if (hasSeparateZLevel) {
                // Series after component
                var zLevels = componentZLevels.concat(seriesZLevels);
                var lastSeriesZLevel_1;
                var lastSeriesKey_1;
                (0, $48c141f615e02ecf$export$2e2bcd8739ae039)(zLevels, function(a, b) {
                    if (a.zlevel === b.zlevel) return a.z - b.z;
                    return a.zlevel - b.zlevel;
                });
                (0, $43e0a445ed6711da$export$79b2f7037acddd43)(zLevels, function(item) {
                    var componentModel = ecModel.getComponent(item.type, item.idx);
                    var zlevel = item.zlevel;
                    var key = item.key;
                    if (lastSeriesZLevel_1 != null) zlevel = Math.max(lastSeriesZLevel_1, zlevel);
                    if (key) {
                        if (zlevel === lastSeriesZLevel_1 && key !== lastSeriesKey_1) zlevel++;
                        lastSeriesKey_1 = key;
                    } else if (lastSeriesKey_1) {
                        if (zlevel === lastSeriesZLevel_1) zlevel++;
                        lastSeriesKey_1 = "";
                    }
                    lastSeriesZLevel_1 = zlevel;
                    componentModel.setZLevel(zlevel);
                });
            }
        }
        $8d957d74809727b8$var$render = function(ecIns, ecModel, api, payload, updateParams) {
            allocateZlevels(ecModel);
            $8d957d74809727b8$var$renderComponents(ecIns, ecModel, api, payload, updateParams);
            (0, $43e0a445ed6711da$export$79b2f7037acddd43)(ecIns._chartsViews, function(chart) {
                chart.__alive = false;
            });
            $8d957d74809727b8$var$renderSeries(ecIns, ecModel, api, payload, updateParams);
            // Remove groups of unrendered charts
            (0, $43e0a445ed6711da$export$79b2f7037acddd43)(ecIns._chartsViews, function(chart) {
                if (!chart.__alive) chart.remove(ecModel, api);
            });
        };
        $8d957d74809727b8$var$renderComponents = function(ecIns, ecModel, api, payload, updateParams, dirtyList) {
            (0, $43e0a445ed6711da$export$79b2f7037acddd43)(dirtyList || ecIns._componentsViews, function(componentView) {
                var componentModel = componentView.__model;
                clearStates(componentModel, componentView);
                componentView.render(componentModel, ecModel, api, payload);
                updateZ(componentModel, componentView);
                updateStates(componentModel, componentView);
            });
        };
        /**
     * Render each chart and component
     */ $8d957d74809727b8$var$renderSeries = function(ecIns, ecModel, api, payload, updateParams, dirtyMap) {
            // Render all charts
            var scheduler = ecIns._scheduler;
            updateParams = (0, $43e0a445ed6711da$export$8b58be045bf06082)(updateParams || {}, {
                updatedSeries: ecModel.getSeries()
            });
            // TODO progressive?
            (0, $567b7069bdf5f856$export$2e2bcd8739ae039).trigger("series:beforeupdate", ecModel, api, updateParams);
            var unfinished = false;
            ecModel.eachSeries(function(seriesModel) {
                var chartView = ecIns._chartsMap[seriesModel.__viewId];
                chartView.__alive = true;
                var renderTask = chartView.renderTask;
                scheduler.updatePayload(renderTask, payload);
                // TODO states on marker.
                clearStates(seriesModel, chartView);
                if (dirtyMap && dirtyMap.get(seriesModel.uid)) renderTask.dirty();
                if (renderTask.perform(scheduler.getPerformArgs(renderTask))) unfinished = true;
                chartView.group.silent = !!seriesModel.get("silent");
                // Should not call markRedraw on group, because it will disable zrender
                // incremental render (always render from the __startIndex each frame)
                // chartView.group.markRedraw();
                updateBlend(seriesModel, chartView);
                (0, $fffc76734a157b4c$export$e4ea08ef52e0a73)(seriesModel);
            });
            scheduler.unfinished = unfinished || scheduler.unfinished;
            (0, $567b7069bdf5f856$export$2e2bcd8739ae039).trigger("series:layoutlabels", ecModel, api, updateParams);
            // transition after label is layouted.
            (0, $567b7069bdf5f856$export$2e2bcd8739ae039).trigger("series:transition", ecModel, api, updateParams);
            ecModel.eachSeries(function(seriesModel) {
                var chartView = ecIns._chartsMap[seriesModel.__viewId];
                // Update Z after labels updated. Before applying states.
                updateZ(seriesModel, chartView);
                // NOTE: Update states after label is updated.
                // label should be in normal status when layouting.
                updateStates(seriesModel, chartView);
            });
            // If use hover layer
            updateHoverLayerStatus(ecIns, ecModel);
            (0, $567b7069bdf5f856$export$2e2bcd8739ae039).trigger("series:afterupdate", ecModel, api, updateParams);
        };
        $8d957d74809727b8$var$markStatusToUpdate = function(ecIns) {
            ecIns[$8d957d74809727b8$var$STATUS_NEEDS_UPDATE_KEY] = true;
            // Wake up zrender if it's sleep. Let it update states in the next frame.
            ecIns.getZr().wakeUp();
        };
        $8d957d74809727b8$var$updateECUpdateCycleVersion = function(ecIns) {
            ecIns[$8d957d74809727b8$var$EC_UPDATE_CYCLE_VERSION_KEY] = (ecIns[$8d957d74809727b8$var$EC_UPDATE_CYCLE_VERSION_KEY] + 1) % 1e6;
        };
        $8d957d74809727b8$var$applyChangedStates = function(ecIns) {
            if (!ecIns[$8d957d74809727b8$var$STATUS_NEEDS_UPDATE_KEY]) return;
            ecIns.getZr().storage.traverse(function(el) {
                // Not applied on removed elements, it may still in fading.
                if ($4feffdaaa31d998e$export$5b89d4b643713034(el)) return;
                applyElementStates(el);
            });
            ecIns[$8d957d74809727b8$var$STATUS_NEEDS_UPDATE_KEY] = false;
        };
        function applyElementStates(el) {
            var newStates = [];
            var oldStates = el.currentStates;
            // Keep other states.
            for(var i = 0; i < oldStates.length; i++){
                var stateName = oldStates[i];
                if (!(stateName === "emphasis" || stateName === "blur" || stateName === "select")) newStates.push(stateName);
            }
            // Only use states when it's exists.
            if (el.selected && el.states.select) newStates.push("select");
            if (el.hoverState === (0, $fffc76734a157b4c$export$f0f2bee145debb31) && el.states.emphasis) newStates.push("emphasis");
            else if (el.hoverState === (0, $fffc76734a157b4c$export$1307d6a87d56baa) && el.states.blur) newStates.push("blur");
            el.useStates(newStates);
        }
        function updateHoverLayerStatus(ecIns, ecModel) {
            var zr = ecIns._zr;
            if (zr.painter.type !== "canvas") return;
            var storage = zr.storage;
            var elCount = 0;
            storage.traverse(function(el) {
                if (!el.isGroup) elCount++;
            });
            var shouldUseHoverLayer = elCount > (0, $43e0a445ed6711da$export$995e01f2f5c9d030)(ecModel.get("hoverLayerThreshold"), (0, $bafd6197f944c639$export$2e2bcd8739ae039).hoverLayerThreshold) && !(0, $a84633bb9c74d89c$export$2e2bcd8739ae039).node && !(0, $a84633bb9c74d89c$export$2e2bcd8739ae039).worker;
            if (ecIns._usingTHL || shouldUseHoverLayer) {
                ecModel.eachSeries(function(seriesModel) {
                    if (seriesModel.preventUsingHoverLayer) return;
                    var chartView = ecIns._chartsMap[seriesModel.__viewId];
                    if (chartView.__alive) chartView.eachRendered(function(el) {
                        // NOTICE: Do not call any method that can set REDRAW_BIT,
                        // otherwise progressive rendering is broken.
                        var emphasis = el.states.emphasis;
                        if (emphasis && emphasis.hoverLayer !== $6552edac5ca572b1$export$2ed770cec6ef78e8) emphasis.hoverLayer = shouldUseHoverLayer ? $6552edac5ca572b1$export$3c339ce201e4ce4d : $6552edac5ca572b1$export$3e67317617241636;
                    });
                });
                ecIns._usingTHL = shouldUseHoverLayer;
            }
        }
        /**
     * Update chart and blend.
     */ function updateBlend(seriesModel, chartView) {
            var blendMode = seriesModel.get("blendMode") || null;
            chartView.eachRendered(function(el) {
                // NOTICE: Do not call any method that can set REDRAW_BIT,
                // otherwise progressive rendering is broken.
                // FIXME marker and other components
                if (!el.isGroup) // DON'T mark the element dirty. In case element is incremental and don't want to rerender.
                el.style.blend = blendMode;
            });
        }
        function updateZ(model, view) {
            if (model.preventAutoZ) return;
            var zInfo = $6552edac5ca572b1$export$1500a631bea5adda(model);
            // Set z and zlevel
            view.eachRendered(function(el) {
                $6552edac5ca572b1$export$d31cf465bf5e8879(el, zInfo.z, zInfo.zlevel);
                // Don't traverse the children because it has been traversed in _updateZ.
                return true;
            });
        }
        // Clear states without animation.
        // TODO States on component.
        function clearStates(model, view) {
            view.eachRendered(function(el) {
                // Not applied on removed elements, it may still in fading.
                if ($4feffdaaa31d998e$export$5b89d4b643713034(el)) return;
                var textContent = el.getTextContent();
                var textGuide = el.getTextGuideLine();
                if (el.stateTransition) el.stateTransition = null;
                if (textContent && textContent.stateTransition) textContent.stateTransition = null;
                if (textGuide && textGuide.stateTransition) textGuide.stateTransition = null;
                // TODO If el is incremental.
                if (el.hasState()) {
                    el.prevStates = el.currentStates;
                    el.clearStates();
                } else if (el.prevStates) el.prevStates = null;
            });
        }
        function updateStates(model, view) {
            var stateAnimationModel = model.getModel("stateAnimation");
            var enableAnimation = model.isAnimationEnabled();
            var duration = stateAnimationModel.get("duration");
            var stateTransition = duration > 0 ? {
                duration: duration,
                delay: stateAnimationModel.get("delay"),
                easing: stateAnimationModel.get("easing")
            } : null;
            view.eachRendered(function(el) {
                if (el.states && el.states.emphasis) {
                    // Not applied on removed elements, it may still in fading.
                    if ($4feffdaaa31d998e$export$5b89d4b643713034(el)) return;
                    if (el instanceof $227e31075465dcd4$export$2e2bcd8739ae039) (0, $fffc76734a157b4c$export$9fe78019e6f395b6)(el);
                    // Only updated on changed element. In case element is incremental and don't want to rerender.
                    // TODO, a more proper way?
                    if (el.__dirty) {
                        var prevStates = el.prevStates;
                        // Restore states without animation
                        if (prevStates) el.useStates(prevStates);
                    }
                    // Update state transition and enable animation again.
                    if (enableAnimation) {
                        el.stateTransition = stateTransition;
                        var textContent = el.getTextContent();
                        var textGuide = el.getTextGuideLine();
                        // TODO Is it necessary to animate label?
                        if (textContent) textContent.stateTransition = stateTransition;
                        if (textGuide) textGuide.stateTransition = stateTransition;
                    }
                    // Use highlighted and selected flag to toggle states.
                    if (el.__dirty) applyElementStates(el);
                }
            });
        }
        $8d957d74809727b8$var$createExtensionAPI = function(ecIns) {
            return new /** @class */ (function(_super) {
                (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(class_1, _super);
                function class_1() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                class_1.prototype.getCoordinateSystems = function() {
                    return ecIns._coordSysMgr.getCoordinateSystems();
                };
                class_1.prototype.getComponentByElement = function(el) {
                    while(el){
                        var modelInfo = el.__ecComponentInfo;
                        if (modelInfo != null) return ecIns._model.getComponent(modelInfo.mainType, modelInfo.index);
                        el = el.parent;
                    }
                };
                class_1.prototype.enterEmphasis = function(el, highlightDigit) {
                    (0, $fffc76734a157b4c$export$b2d02638cc34c042)(el, highlightDigit);
                    $8d957d74809727b8$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.leaveEmphasis = function(el, highlightDigit) {
                    (0, $fffc76734a157b4c$export$11be6f716239ac55)(el, highlightDigit);
                    $8d957d74809727b8$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.enterBlur = function(el) {
                    (0, $fffc76734a157b4c$export$207f9cb3e1099375)(el);
                    $8d957d74809727b8$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.leaveBlur = function(el) {
                    (0, $fffc76734a157b4c$export$fd4a9ec75456d3c1)(el);
                    $8d957d74809727b8$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.enterSelect = function(el) {
                    (0, $fffc76734a157b4c$export$252d028dda8ef765)(el);
                    $8d957d74809727b8$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.leaveSelect = function(el) {
                    (0, $fffc76734a157b4c$export$ea9a904bd6e32bd3)(el);
                    $8d957d74809727b8$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.getModel = function() {
                    return ecIns.getModel();
                };
                class_1.prototype.getViewOfComponentModel = function(componentModel) {
                    return ecIns.getViewOfComponentModel(componentModel);
                };
                class_1.prototype.getViewOfSeriesModel = function(seriesModel) {
                    return ecIns.getViewOfSeriesModel(seriesModel);
                };
                class_1.prototype.getECUpdateCycleVersion = function() {
                    return ecIns[$8d957d74809727b8$var$EC_UPDATE_CYCLE_VERSION_KEY];
                };
                class_1.prototype.usingTHL = function() {
                    return ecIns._usingTHL;
                };
                return class_1;
            }((0, $00f59fca90c489d2$export$2e2bcd8739ae039)))(ecIns);
        };
        $8d957d74809727b8$var$enableConnect = function(chart) {
            function updateConnectedChartsStatus(charts, status) {
                for(var i = 0; i < charts.length; i++){
                    var otherChart = charts[i];
                    otherChart[$8d957d74809727b8$var$CONNECT_STATUS_KEY] = status;
                }
            }
            (0, $43e0a445ed6711da$export$79b2f7037acddd43)($8d957d74809727b8$var$connectionEventRevertMap, function(_, eventType) {
                chart._messageCenter.on(eventType, function(event) {
                    if ($8d957d74809727b8$var$connectedGroups[chart.group] && chart[$8d957d74809727b8$var$CONNECT_STATUS_KEY] !== $8d957d74809727b8$var$CONNECT_STATUS_PENDING) {
                        if (event && event.escapeConnect) return;
                        var action_1 = chart.makeActionFromEvent(event);
                        var otherCharts_1 = [];
                        (0, $43e0a445ed6711da$export$79b2f7037acddd43)($8d957d74809727b8$var$instances, function(otherChart) {
                            if (otherChart !== chart && otherChart.group === chart.group) otherCharts_1.push(otherChart);
                        });
                        updateConnectedChartsStatus(otherCharts_1, $8d957d74809727b8$var$CONNECT_STATUS_PENDING);
                        (0, $43e0a445ed6711da$export$79b2f7037acddd43)(otherCharts_1, function(otherChart) {
                            if (otherChart[$8d957d74809727b8$var$CONNECT_STATUS_KEY] !== $8d957d74809727b8$var$CONNECT_STATUS_UPDATING) otherChart.dispatchAction(action_1);
                        });
                        updateConnectedChartsStatus(otherCharts_1, $8d957d74809727b8$var$CONNECT_STATUS_UPDATED);
                    }
                });
            });
        };
    }();
    return ECharts;
}((0, $131b7833cdf735df$export$2e2bcd8739ae039));
var $8d957d74809727b8$var$echartsProto = $8d957d74809727b8$var$ECharts.prototype;
$8d957d74809727b8$var$echartsProto.on = $8d957d74809727b8$var$createRegisterEventWithLowercaseECharts("on");
$8d957d74809727b8$var$echartsProto.off = $8d957d74809727b8$var$createRegisterEventWithLowercaseECharts("off");
/**
 * @deprecated
 */ // @ts-ignore
$8d957d74809727b8$var$echartsProto.one = function(eventName, cb, ctx) {
    var self = this;
    (0, $51c99d7efb19f4a2$export$4a9c0b74eb885aa1)("ECharts#one is deprecated.");
    function wrapped() {
        var args2 = [];
        for(var _i = 0; _i < arguments.length; _i++)args2[_i] = arguments[_i];
        cb && cb.apply && cb.apply(this, args2);
        // @ts-ignore
        self.off(eventName, wrapped);
    }
    // @ts-ignore
    this.on.call(this, eventName, wrapped, ctx);
};
var $8d957d74809727b8$var$MOUSE_EVENT_NAMES = [
    "click",
    "dblclick",
    "mouseover",
    "mouseout",
    "mousemove",
    "mousedown",
    "mouseup",
    "globalout",
    "contextmenu"
];
function $8d957d74809727b8$var$disposedWarning(id) {}
var $8d957d74809727b8$var$actions = {};
/**
 * Map event type to action type for reproducing action from event for `connect`.
 */ var $8d957d74809727b8$var$connectionEventRevertMap = {};
/**
 * To remove duplication.
 */ var $8d957d74809727b8$var$publicEventTypeMap = {};
var $8d957d74809727b8$var$dataProcessorFuncs = [];
var $8d957d74809727b8$var$optionPreprocessorFuncs = [];
var $8d957d74809727b8$var$visualFuncs = [];
var $8d957d74809727b8$var$themeStorage = {};
var $8d957d74809727b8$var$loadingEffects = {};
var $8d957d74809727b8$var$instances = {};
var $8d957d74809727b8$var$connectedGroups = {};
var $8d957d74809727b8$var$idBase = +new Date() - 0;
var $8d957d74809727b8$var$groupIdBase = +new Date() - 0;
var $8d957d74809727b8$var$DOM_ATTRIBUTE_KEY = "_echarts_instance_";
function $8d957d74809727b8$export$2cd8252107eb640b(dom, theme, opts) {
    var isClient = !(opts && opts.ssr);
    if (isClient) {
        var existInstance = $8d957d74809727b8$export$33b6fbccd4f643f8(dom);
        if (existInstance) return existInstance;
    }
    var chart = new $8d957d74809727b8$var$ECharts(dom, theme, opts);
    chart.id = "ec_" + $8d957d74809727b8$var$idBase++;
    $8d957d74809727b8$var$instances[chart.id] = chart;
    isClient && $87f4a59ac66e0ee6$export$9fec4d97f1922e0b(dom, $8d957d74809727b8$var$DOM_ATTRIBUTE_KEY, chart.id);
    $8d957d74809727b8$var$enableConnect(chart);
    (0, $567b7069bdf5f856$export$2e2bcd8739ae039).trigger("afterinit", chart);
    return chart;
}
function $8d957d74809727b8$export$64605811ab45167f(groupId) {
    // Is array of charts
    if ((0, $43e0a445ed6711da$export$43bee75e5e14138e)(groupId)) {
        var charts = groupId;
        groupId = null;
        // If any chart has group
        (0, $43e0a445ed6711da$export$79b2f7037acddd43)(charts, function(chart) {
            if (chart.group != null) groupId = chart.group;
        });
        groupId = groupId || "g_" + $8d957d74809727b8$var$groupIdBase++;
        (0, $43e0a445ed6711da$export$79b2f7037acddd43)(charts, function(chart) {
            chart.group = groupId;
        });
    }
    $8d957d74809727b8$var$connectedGroups[groupId] = true;
    return groupId;
}
function $8d957d74809727b8$export$37dfea93db2e14ed(groupId) {
    $8d957d74809727b8$var$connectedGroups[groupId] = false;
}
var $8d957d74809727b8$export$87cd6834112ecb52 = $8d957d74809727b8$export$37dfea93db2e14ed;
function $8d957d74809727b8$export$fcfbbcec2cb820d5(chart) {
    if ((0, $43e0a445ed6711da$export$844ec244b1367d54)(chart)) chart = $8d957d74809727b8$var$instances[chart];
    else if (!(chart instanceof $8d957d74809727b8$var$ECharts)) // Try to treat as dom
    chart = $8d957d74809727b8$export$33b6fbccd4f643f8(chart);
    if (chart instanceof $8d957d74809727b8$var$ECharts && !chart.isDisposed()) chart.dispose();
}
function $8d957d74809727b8$export$33b6fbccd4f643f8(dom) {
    return $8d957d74809727b8$var$instances[$87f4a59ac66e0ee6$export$735ee1799fd02602(dom, $8d957d74809727b8$var$DOM_ATTRIBUTE_KEY)];
}
function $8d957d74809727b8$export$89b4be35062c4a3f(key) {
    return $8d957d74809727b8$var$instances[key];
}
function $8d957d74809727b8$export$f9c59eed5de5ff80(name, theme) {
    $8d957d74809727b8$var$themeStorage[name] = theme;
}
function $8d957d74809727b8$export$77095792a057b768(preprocessorFunc) {
    if ((0, $43e0a445ed6711da$export$305f7d4e9d4624f2)($8d957d74809727b8$var$optionPreprocessorFuncs, preprocessorFunc) < 0) $8d957d74809727b8$var$optionPreprocessorFuncs.push(preprocessorFunc);
}
function $8d957d74809727b8$export$d575e6557ac1729f(priority, processor) {
    $8d957d74809727b8$var$normalizeRegister($8d957d74809727b8$var$dataProcessorFuncs, priority, processor, $8d957d74809727b8$var$PRIORITY_PROCESSOR_DEFAULT);
}
function $8d957d74809727b8$export$c8c249911ee8c1ed(postInitFunc) {
    $8d957d74809727b8$export$c9ec4b5faef04865("afterinit", postInitFunc);
}
function $8d957d74809727b8$export$99560909c18c76bb(postUpdateFunc) {
    $8d957d74809727b8$export$c9ec4b5faef04865("afterupdate", postUpdateFunc);
}
function $8d957d74809727b8$export$c9ec4b5faef04865(name, cb) {
    (0, $567b7069bdf5f856$export$2e2bcd8739ae039).on(name, cb);
}
function $8d957d74809727b8$export$408c24786cd729c6(arg0, arg1, action) {
    var actionType;
    var publicEventType;
    var refineEvent;
    var update;
    var publishNonRefinedEvent;
    if ((0, $43e0a445ed6711da$export$f6e2535fb5126e54)(arg1)) {
        action = arg1;
        arg1 = "";
    }
    if ((0, $43e0a445ed6711da$export$a6cdc56e425d0d0a)(arg0)) {
        actionType = arg0.type;
        publicEventType = arg0.event;
        update = arg0.update;
        publishNonRefinedEvent = arg0.publishNonRefinedEvent;
        if (!action) action = arg0.action;
        refineEvent = arg0.refineEvent;
    } else {
        actionType = arg0;
        publicEventType = arg1;
    }
    function createEventType(actionOrEventType) {
        // Event type should be all lowercase
        return actionOrEventType.toLowerCase();
    }
    publicEventType = createEventType(publicEventType || actionType);
    // See comments on {ActionInfo} for the reason.
    var nonRefinedEventType = refineEvent ? createEventType(actionType) : publicEventType;
    // Support calling `registerAction` multiple times with the same action
    // type; subsequent calls have no effect.
    if ($8d957d74809727b8$var$actions[actionType]) return;
    // Validate action type and event name.
    (0, $43e0a445ed6711da$export$a7a9523472993e97)($8d957d74809727b8$var$ACTION_REG.test(actionType) && $8d957d74809727b8$var$ACTION_REG.test(publicEventType));
    if (refineEvent) // An event replicated from the action will be triggered internally for `connect` in this case.
    (0, $43e0a445ed6711da$export$a7a9523472993e97)(publicEventType !== actionType);
    $8d957d74809727b8$var$actions[actionType] = {
        actionType: actionType,
        refinedEventType: publicEventType,
        nonRefinedEventType: nonRefinedEventType,
        update: update,
        action: action,
        refineEvent: refineEvent
    };
    $8d957d74809727b8$var$publicEventTypeMap[publicEventType] = 1;
    if (refineEvent && publishNonRefinedEvent) $8d957d74809727b8$var$publicEventTypeMap[nonRefinedEventType] = 1;
    $8d957d74809727b8$var$connectionEventRevertMap[nonRefinedEventType] = actionType;
}
function $8d957d74809727b8$export$1dd5e025a8a37dd(type, coordSysCreator) {
    (0, $a30c5e122eaab0a1$export$2e2bcd8739ae039).register(type, coordSysCreator);
}
function $8d957d74809727b8$export$fc2638719e4159b9(type) {
    var coordSysCreator = (0, $a30c5e122eaab0a1$export$2e2bcd8739ae039).get(type);
    if (coordSysCreator) return coordSysCreator.getDimensionsInfo ? coordSysCreator.getDimensionsInfo() : coordSysCreator.dimensions.slice();
}
function $8d957d74809727b8$export$c3e61191887968da(seriesType, renderItem) {
    (0, $fbd66d714849991d$export$c3e61191887968da)(seriesType, renderItem);
}
function $8d957d74809727b8$export$d768f97700ca6bea(priority, layoutTask) {
    $8d957d74809727b8$var$normalizeRegister($8d957d74809727b8$var$visualFuncs, priority, layoutTask, $8d957d74809727b8$var$PRIORITY_VISUAL_LAYOUT, "layout", true);
}
function $8d957d74809727b8$export$5f32c1eb94c381bb(priority, visualTask) {
    $8d957d74809727b8$var$normalizeRegister($8d957d74809727b8$var$visualFuncs, priority, visualTask, $8d957d74809727b8$var$PRIORITY_VISUAL_CHART, "visual", true);
}
var $8d957d74809727b8$var$registeredTasks = [];
function $8d957d74809727b8$var$normalizeRegister(targetList, priority, fn, defaultPriority, visualType, checkBlock) {
    if ((0, $43e0a445ed6711da$export$f6e2535fb5126e54)(priority) || (0, $43e0a445ed6711da$export$a6cdc56e425d0d0a)(priority)) {
        fn = priority;
        priority = defaultPriority;
    }
    // Already registered
    if ((0, $43e0a445ed6711da$export$305f7d4e9d4624f2)($8d957d74809727b8$var$registeredTasks, fn) >= 0) return;
    $8d957d74809727b8$var$registeredTasks.push(fn);
    var stageHandler = (0, $7982fe5ed36bab1b$export$2e2bcd8739ae039).wrapStageHandler(fn, visualType);
    stageHandler.__prio = priority;
    stageHandler.__raw = fn;
    targetList.push(stageHandler);
}
function $8d957d74809727b8$export$e06b68a82007c015(name, loadingFx) {
    $8d957d74809727b8$var$loadingEffects[name] = loadingFx;
}
function $8d957d74809727b8$export$10425ea7a243b114(creator) {
    (0, $08c3209e6efc839a$export$61bcfd79465c1b7c)({
        createCanvas: creator
    });
}
function $8d957d74809727b8$export$d456de060be2dba1(mapName, geoJson, specialAreas) {
    var registerMap = (0, $8a21e81d789730a0$export$73333eb8a09d5f61)("registerMap");
    registerMap && registerMap(mapName, geoJson, specialAreas);
}
function $8d957d74809727b8$export$b8586192aead8a7e(mapName) {
    var getMap = (0, $8a21e81d789730a0$export$73333eb8a09d5f61)("getMap");
    return getMap && getMap(mapName);
}
var $8d957d74809727b8$export$f01d71dd0389d7e4 = (0, $b3d05d3fca143040$export$92c96c6d8b255b7d);
/**
 * Global dispatchAction to a specified chart instance.
 */ // export function dispatchAction(payload: { chartId: string } & Payload, opt?: Parameters<ECharts['dispatchAction']>[1]) {
//     if (!payload || !payload.chartId) {
//         // Must have chartId to find chart
//         return;
//     }
//     const chart = instances[payload.chartId];
//     if (chart) {
//         chart.dispatchAction(payload, opt);
//     }
// }
// Builtin global visual
$8d957d74809727b8$export$5f32c1eb94c381bb($8d957d74809727b8$var$PRIORITY_VISUAL_GLOBAL, (0, $c85eb56081b6d5d9$export$7ce4d65f9b69240));
$8d957d74809727b8$export$5f32c1eb94c381bb($8d957d74809727b8$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM, (0, $c85eb56081b6d5d9$export$f7dcb66a065003d1));
$8d957d74809727b8$export$5f32c1eb94c381bb($8d957d74809727b8$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM, (0, $c85eb56081b6d5d9$export$cf9758b0d6dc0aa9));
$8d957d74809727b8$export$5f32c1eb94c381bb($8d957d74809727b8$var$PRIORITY_VISUAL_GLOBAL, (0, $682692c8c595d5c5$export$144ac3beded415d9));
$8d957d74809727b8$export$5f32c1eb94c381bb($8d957d74809727b8$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM, (0, $682692c8c595d5c5$export$435b956f7f1071fb));
$8d957d74809727b8$export$5f32c1eb94c381bb($8d957d74809727b8$var$PRIORITY_VISUAL_DECAL, (0, $d10acd6e8d584437$export$218eea02a2a96fb4));
$8d957d74809727b8$export$77095792a057b768((0, $8dc883428bb9533d$export$2e2bcd8739ae039));
$8d957d74809727b8$export$d575e6557ac1729f($8d957d74809727b8$var$PRIORITY_PROCESSOR_DATASTACK, (0, $5333fd4aae6dad6f$export$dc018729d9e78c17));
$8d957d74809727b8$export$e06b68a82007c015("default", (0, $96ef4a55d6ec4384$export$2e2bcd8739ae039));
// Default actions
$8d957d74809727b8$export$408c24786cd729c6({
    type: (0, $fffc76734a157b4c$export$df035d873a9de64f),
    event: (0, $fffc76734a157b4c$export$df035d873a9de64f),
    update: (0, $fffc76734a157b4c$export$df035d873a9de64f)
}, (0, $43e0a445ed6711da$export$8793edee2d425525));
$8d957d74809727b8$export$408c24786cd729c6({
    type: (0, $fffc76734a157b4c$export$f8a2f7807cc185ea),
    event: (0, $fffc76734a157b4c$export$f8a2f7807cc185ea),
    update: (0, $fffc76734a157b4c$export$f8a2f7807cc185ea)
}, (0, $43e0a445ed6711da$export$8793edee2d425525));
$8d957d74809727b8$export$408c24786cd729c6({
    type: (0, $fffc76734a157b4c$export$89616263e7d38fe9),
    event: (0, $fffc76734a157b4c$export$67f8c62bcdfbd39f),
    update: (0, $fffc76734a157b4c$export$89616263e7d38fe9),
    action: (0, $43e0a445ed6711da$export$8793edee2d425525),
    refineEvent: $8d957d74809727b8$var$makeSelectChangedEvent,
    publishNonRefinedEvent: true
});
$8d957d74809727b8$export$408c24786cd729c6({
    type: (0, $fffc76734a157b4c$export$7636ad95c0f68a79),
    event: (0, $fffc76734a157b4c$export$67f8c62bcdfbd39f),
    update: (0, $fffc76734a157b4c$export$7636ad95c0f68a79),
    action: (0, $43e0a445ed6711da$export$8793edee2d425525),
    refineEvent: $8d957d74809727b8$var$makeSelectChangedEvent,
    publishNonRefinedEvent: true
});
$8d957d74809727b8$export$408c24786cd729c6({
    type: (0, $fffc76734a157b4c$export$1e90ed8a25542516),
    event: (0, $fffc76734a157b4c$export$67f8c62bcdfbd39f),
    update: (0, $fffc76734a157b4c$export$1e90ed8a25542516),
    action: (0, $43e0a445ed6711da$export$8793edee2d425525),
    refineEvent: $8d957d74809727b8$var$makeSelectChangedEvent,
    publishNonRefinedEvent: true
});
function $8d957d74809727b8$var$makeSelectChangedEvent(actionResultBatch, payload, ecModel, api) {
    return {
        eventContent: {
            selected: (0, $fffc76734a157b4c$export$c529643b619af6b3)(ecModel),
            isFromClick: payload.isFromClick || false
        }
    };
}
// Default theme, so that we can use `chart.setTheme('default')` to revert to
// the default theme after changing to other themes.
$8d957d74809727b8$export$f9c59eed5de5ff80("default", {});
$8d957d74809727b8$export$f9c59eed5de5ff80("dark", (0, $c73c267370237d01$export$2e2bcd8739ae039));
var $8d957d74809727b8$export$73cae5e090579589 = {};


var $e57dbd7cfd9aef2e$exports = {};

$parcel$export($e57dbd7cfd9aef2e$exports, "extendComponentModel", function () { return $e57dbd7cfd9aef2e$export$4dd01020bb736662; });
$parcel$export($e57dbd7cfd9aef2e$exports, "extendComponentView", function () { return $e57dbd7cfd9aef2e$export$a4336148da8ef02; });
$parcel$export($e57dbd7cfd9aef2e$exports, "extendSeriesModel", function () { return $e57dbd7cfd9aef2e$export$fe6d3114e3fc260c; });
$parcel$export($e57dbd7cfd9aef2e$exports, "extendChartView", function () { return $e57dbd7cfd9aef2e$export$c750883d1b603e83; });
$parcel$export($e57dbd7cfd9aef2e$exports, "zrender", function () { return $08a7e718789e144c$exports; });
$parcel$export($e57dbd7cfd9aef2e$exports, "matrix", function () { return $87ac8de5537d9a34$exports; });
$parcel$export($e57dbd7cfd9aef2e$exports, "vector", function () { return $ee491d8f32bd01ff$exports; });
$parcel$export($e57dbd7cfd9aef2e$exports, "zrUtil", function () { return $43e0a445ed6711da$exports; });
$parcel$export($e57dbd7cfd9aef2e$exports, "color", function () { return $b0979f18b0a232f9$exports; });
$parcel$export($e57dbd7cfd9aef2e$exports, "throttle", function () { return $3a03c388017fa83a$export$de363e709c412c8a; });
$parcel$export($e57dbd7cfd9aef2e$exports, "helper", function () { return $c3732722dc240783$exports; });
$parcel$export($e57dbd7cfd9aef2e$exports, "use", function () { return $8f6e8e1f1e941d98$export$1f96ae73734a86cc; });
$parcel$export($e57dbd7cfd9aef2e$exports, "setPlatformAPI", function () { return $08c3209e6efc839a$export$61bcfd79465c1b7c; });
$parcel$export($e57dbd7cfd9aef2e$exports, "parseGeoJSON", function () { return $3b4146e40988ca14$export$2e2bcd8739ae039; });
$parcel$export($e57dbd7cfd9aef2e$exports, "parseGeoJson", function () { return $3b4146e40988ca14$export$2e2bcd8739ae039; });
$parcel$export($e57dbd7cfd9aef2e$exports, "number", function () { return $d6699ee8efc6dae5$exports; });
$parcel$export($e57dbd7cfd9aef2e$exports, "time", function () { return $efcfb25d726b7d93$exports; });
$parcel$export($e57dbd7cfd9aef2e$exports, "graphic", function () { return $3b38bcf86d23f285$exports; });
$parcel$export($e57dbd7cfd9aef2e$exports, "format", function () { return $6c9f8059fa5b1aae$exports; });
$parcel$export($e57dbd7cfd9aef2e$exports, "util", function () { return $89827b2c1fddca99$exports; });
$parcel$export($e57dbd7cfd9aef2e$exports, "env", function () { return $a84633bb9c74d89c$export$2e2bcd8739ae039; });
$parcel$export($e57dbd7cfd9aef2e$exports, "List", function () { return $1be6b212af73174f$export$2e2bcd8739ae039; });
$parcel$export($e57dbd7cfd9aef2e$exports, "Model", function () { return $279973fc50f77a15$export$2e2bcd8739ae039; });
$parcel$export($e57dbd7cfd9aef2e$exports, "Axis", function () { return $17d11437fadc71c2$export$2e2bcd8739ae039; });
$parcel$export($e57dbd7cfd9aef2e$exports, "ComponentModel", function () { return $4a9041b12b787d1b$export$2e2bcd8739ae039; });
$parcel$export($e57dbd7cfd9aef2e$exports, "ComponentView", function () { return $c81700f6bd52c5a7$export$2e2bcd8739ae039; });
$parcel$export($e57dbd7cfd9aef2e$exports, "SeriesModel", function () { return $39002e2f499d7a2f$export$2e2bcd8739ae039; });
$parcel$export($e57dbd7cfd9aef2e$exports, "ChartView", function () { return $9bc1fbefe72d5b26$export$2e2bcd8739ae039; });
$parcel$export($e57dbd7cfd9aef2e$exports, "innerDrawElementOnCanvas", function () { return $6bc3d3dcea2beb63$export$567881adfc3eb7f3; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // These APIs are for more advanced usages
// For example extend charts and components, creating graphic elements, formatting.




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /* global Int32Array */ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $4d1a09ac340ee97e$var$dataIndexMapValueLength(valNumOrArrLengthMoreThan2) {
    return valNumOrArrLengthMoreThan2 == null ? 0 : valNumOrArrLengthMoreThan2.length || 1;
}
function $4d1a09ac340ee97e$var$defaultKeyGetter(item) {
    return item;
}
var $4d1a09ac340ee97e$var$DataDiffer = /** @class */ function() {
    /**
   * @param context Can be visited by this.context in callback.
   */ function DataDiffer(oldArr, newArr, oldKeyGetter, newKeyGetter, context, // By default: 'oneToOne'.
    diffMode) {
        this._old = oldArr;
        this._new = newArr;
        this._oldKeyGetter = oldKeyGetter || $4d1a09ac340ee97e$var$defaultKeyGetter;
        this._newKeyGetter = newKeyGetter || $4d1a09ac340ee97e$var$defaultKeyGetter;
        // Visible in callback via `this.context`;
        this.context = context;
        this._diffModeMultiple = diffMode === "multiple";
    }
    /**
   * Callback function when add a data
   */ DataDiffer.prototype.add = function(func) {
        this._add = func;
        return this;
    };
    /**
   * Callback function when update a data
   */ DataDiffer.prototype.update = function(func) {
        this._update = func;
        return this;
    };
    /**
   * Callback function when update a data and only work in `cbMode: 'byKey'`.
   */ DataDiffer.prototype.updateManyToOne = function(func) {
        this._updateManyToOne = func;
        return this;
    };
    /**
   * Callback function when update a data and only work in `cbMode: 'byKey'`.
   */ DataDiffer.prototype.updateOneToMany = function(func) {
        this._updateOneToMany = func;
        return this;
    };
    /**
   * Callback function when update a data and only work in `cbMode: 'byKey'`.
   */ DataDiffer.prototype.updateManyToMany = function(func) {
        this._updateManyToMany = func;
        return this;
    };
    /**
   * Callback function when remove a data
   */ DataDiffer.prototype.remove = function(func) {
        this._remove = func;
        return this;
    };
    DataDiffer.prototype.execute = function() {
        this[this._diffModeMultiple ? "_executeMultiple" : "_executeOneToOne"]();
    };
    DataDiffer.prototype._executeOneToOne = function() {
        var oldArr = this._old;
        var newArr = this._new;
        var newDataIndexMap = {};
        var oldDataKeyArr = new Array(oldArr.length);
        var newDataKeyArr = new Array(newArr.length);
        this._initIndexMap(oldArr, null, oldDataKeyArr, "_oldKeyGetter");
        this._initIndexMap(newArr, newDataIndexMap, newDataKeyArr, "_newKeyGetter");
        for(var i = 0; i < oldArr.length; i++){
            var oldKey = oldDataKeyArr[i];
            var newIdxMapVal = newDataIndexMap[oldKey];
            var newIdxMapValLen = $4d1a09ac340ee97e$var$dataIndexMapValueLength(newIdxMapVal);
            // idx can never be empty array here. see 'set null' logic below.
            if (newIdxMapValLen > 1) {
                // Consider there is duplicate key (for example, use dataItem.name as key).
                // We should make sure every item in newArr and oldArr can be visited.
                var newIdx = newIdxMapVal.shift();
                if (newIdxMapVal.length === 1) newDataIndexMap[oldKey] = newIdxMapVal[0];
                this._update && this._update(newIdx, i);
            } else if (newIdxMapValLen === 1) {
                newDataIndexMap[oldKey] = null;
                this._update && this._update(newIdxMapVal, i);
            } else this._remove && this._remove(i);
        }
        this._performRestAdd(newDataKeyArr, newDataIndexMap);
    };
    /**
   * For example, consider the case:
   * oldData: [o0, o1, o2, o3, o4, o5, o6, o7],
   * newData: [n0, n1, n2, n3, n4, n5, n6, n7, n8],
   * Where:
   *     o0, o1, n0 has key 'a' (many to one)
   *     o5, n4, n5, n6 has key 'b' (one to many)
   *     o2, n1 has key 'c' (one to one)
   *     n2, n3 has key 'd' (add)
   *     o3, o4 has key 'e' (remove)
   *     o6, o7, n7, n8 has key 'f' (many to many, treated as add and remove)
   * Then:
   *     (The order of the following directives are not ensured.)
   *     this._updateManyToOne(n0, [o0, o1]);
   *     this._updateOneToMany([n4, n5, n6], o5);
   *     this._update(n1, o2);
   *     this._remove(o3);
   *     this._remove(o4);
   *     this._remove(o6);
   *     this._remove(o7);
   *     this._add(n2);
   *     this._add(n3);
   *     this._add(n7);
   *     this._add(n8);
   */ DataDiffer.prototype._executeMultiple = function() {
        var oldArr = this._old;
        var newArr = this._new;
        var oldDataIndexMap = {};
        var newDataIndexMap = {};
        var oldDataKeyArr = [];
        var newDataKeyArr = [];
        this._initIndexMap(oldArr, oldDataIndexMap, oldDataKeyArr, "_oldKeyGetter");
        this._initIndexMap(newArr, newDataIndexMap, newDataKeyArr, "_newKeyGetter");
        for(var i = 0; i < oldDataKeyArr.length; i++){
            var oldKey = oldDataKeyArr[i];
            var oldIdxMapVal = oldDataIndexMap[oldKey];
            var newIdxMapVal = newDataIndexMap[oldKey];
            var oldIdxMapValLen = $4d1a09ac340ee97e$var$dataIndexMapValueLength(oldIdxMapVal);
            var newIdxMapValLen = $4d1a09ac340ee97e$var$dataIndexMapValueLength(newIdxMapVal);
            if (oldIdxMapValLen > 1 && newIdxMapValLen === 1) {
                this._updateManyToOne && this._updateManyToOne(newIdxMapVal, oldIdxMapVal);
                newDataIndexMap[oldKey] = null;
            } else if (oldIdxMapValLen === 1 && newIdxMapValLen > 1) {
                this._updateOneToMany && this._updateOneToMany(newIdxMapVal, oldIdxMapVal);
                newDataIndexMap[oldKey] = null;
            } else if (oldIdxMapValLen === 1 && newIdxMapValLen === 1) {
                this._update && this._update(newIdxMapVal, oldIdxMapVal);
                newDataIndexMap[oldKey] = null;
            } else if (oldIdxMapValLen > 1 && newIdxMapValLen > 1) {
                this._updateManyToMany && this._updateManyToMany(newIdxMapVal, oldIdxMapVal);
                newDataIndexMap[oldKey] = null;
            } else if (oldIdxMapValLen > 1) for(var i_1 = 0; i_1 < oldIdxMapValLen; i_1++)this._remove && this._remove(oldIdxMapVal[i_1]);
            else this._remove && this._remove(oldIdxMapVal);
        }
        this._performRestAdd(newDataKeyArr, newDataIndexMap);
    };
    DataDiffer.prototype._performRestAdd = function(newDataKeyArr, newDataIndexMap) {
        for(var i = 0; i < newDataKeyArr.length; i++){
            var newKey = newDataKeyArr[i];
            var newIdxMapVal = newDataIndexMap[newKey];
            var idxMapValLen = $4d1a09ac340ee97e$var$dataIndexMapValueLength(newIdxMapVal);
            if (idxMapValLen > 1) for(var j = 0; j < idxMapValLen; j++)this._add && this._add(newIdxMapVal[j]);
            else if (idxMapValLen === 1) this._add && this._add(newIdxMapVal);
            // Support both `newDataKeyArr` are duplication removed or not removed.
            newDataIndexMap[newKey] = null;
        }
    };
    DataDiffer.prototype._initIndexMap = function(arr, // Can be null.
    map, // In 'byKey', the output `keyArr` is duplication removed.
    // In 'byIndex', the output `keyArr` is not duplication removed and
    //     its indices are accurately corresponding to `arr`.
    keyArr, keyGetterName) {
        var cbModeMultiple = this._diffModeMultiple;
        for(var i = 0; i < arr.length; i++){
            // Add prefix to avoid conflict with Object.prototype.
            var key = "_ec_" + this[keyGetterName](arr[i], i);
            if (!cbModeMultiple) keyArr[i] = key;
            if (!map) continue;
            var idxMapVal = map[key];
            var idxMapValLen = $4d1a09ac340ee97e$var$dataIndexMapValueLength(idxMapVal);
            if (idxMapValLen === 0) {
                // Simple optimize: in most cases, one index has one key,
                // do not need array.
                map[key] = i;
                if (cbModeMultiple) keyArr.push(key);
            } else if (idxMapValLen === 1) map[key] = [
                idxMapVal,
                i
            ];
            else idxMapVal.push(i);
        }
    };
    return DataDiffer;
}();
var $4d1a09ac340ee97e$export$2e2bcd8739ae039 = $4d1a09ac340ee97e$var$DataDiffer;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $3f2389d83f9401b4$var$DimensionUserOuput = /** @class */ function() {
    function DimensionUserOuput(encode, dimRequest) {
        this._encode = encode;
        this._schema = dimRequest;
    }
    DimensionUserOuput.prototype.get = function() {
        return {
            // Do not generate full dimension name until fist used.
            fullDimensions: this._getFullDimensionNames(),
            encode: this._encode
        };
    };
    /**
   * Get all data store dimension names.
   * Theoretically a series data store is defined both by series and used dataset (if any).
   * If some dimensions are omitted for performance reason in `this.dimensions`,
   * the dimension name may not be auto-generated if user does not specify a dimension name.
   * In this case, the dimension name is `null`/`undefined`.
   */ DimensionUserOuput.prototype._getFullDimensionNames = function() {
        if (!this._cachedDimNames) this._cachedDimNames = this._schema ? this._schema.makeOutputDimensionNames() : [];
        return this._cachedDimNames;
    };
    return DimensionUserOuput;
}();
function $3f2389d83f9401b4$export$505a22c3734846f1(data, schema) {
    var summary = {};
    var encode = summary.encode = {};
    var notExtraCoordDimMap = (0, $43e0a445ed6711da$export$55f8aa7ef875b0a4)();
    var defaultedLabel = [];
    var defaultedTooltip = [];
    var userOutputEncode = {};
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)(data.dimensions, function(dimName) {
        var dimItem = data.getDimensionInfo(dimName);
        var coordDim = dimItem.coordDim;
        if (coordDim) {
            var coordDimIndex = dimItem.coordDimIndex;
            $3f2389d83f9401b4$var$getOrCreateEncodeArr(encode, coordDim)[coordDimIndex] = dimName;
            if (!dimItem.isExtraCoord) {
                notExtraCoordDimMap.set(coordDim, 1);
                // Use the last coord dim (and label friendly) as default label,
                // because when dataset is used, it is hard to guess which dimension
                // can be value dimension. If both show x, y on label is not look good,
                // and conventionally y axis is focused more.
                if ($3f2389d83f9401b4$var$mayLabelDimType(dimItem.type)) defaultedLabel[0] = dimName;
                // User output encode do not contain generated coords.
                // And it only has index. User can use index to retrieve value from the raw item array.
                $3f2389d83f9401b4$var$getOrCreateEncodeArr(userOutputEncode, coordDim)[coordDimIndex] = data.getDimensionIndex(dimItem.name);
            }
            if (dimItem.defaultTooltip) defaultedTooltip.push(dimName);
        }
        (0, $bde9c82f7837f767$export$cd51b5ca77f6f0e4).each(function(v, otherDim) {
            var encodeArr = $3f2389d83f9401b4$var$getOrCreateEncodeArr(encode, otherDim);
            var dimIndex = dimItem.otherDims[otherDim];
            if (dimIndex != null && dimIndex !== false) encodeArr[dimIndex] = dimItem.name;
        });
    });
    var dataDimsOnCoord = [];
    var encodeFirstDimNotExtra = {};
    notExtraCoordDimMap.each(function(v, coordDim) {
        var dimArr = encode[coordDim];
        encodeFirstDimNotExtra[coordDim] = dimArr[0];
        // Not necessary to remove duplicate, because a data
        // dim canot on more than one coordDim.
        dataDimsOnCoord = dataDimsOnCoord.concat(dimArr);
    });
    summary.dataDimsOnCoord = dataDimsOnCoord;
    summary.dataDimIndicesOnCoord = (0, $43e0a445ed6711da$export$871de8747c9eaa88)(dataDimsOnCoord, function(dimName) {
        return data.getDimensionInfo(dimName).storeDimIndex;
    });
    summary.encodeFirstDimNotExtra = encodeFirstDimNotExtra;
    var encodeLabel = encode.label;
    // FIXME `encode.label` is not recommended, because formatter cannot be set
    // in this way. Use label.formatter instead. Maybe remove this approach someday.
    if (encodeLabel && encodeLabel.length) defaultedLabel = encodeLabel.slice();
    var encodeTooltip = encode.tooltip;
    if (encodeTooltip && encodeTooltip.length) defaultedTooltip = encodeTooltip.slice();
    else if (!defaultedTooltip.length) defaultedTooltip = defaultedLabel.slice();
    encode.defaultedLabel = defaultedLabel;
    encode.defaultedTooltip = defaultedTooltip;
    summary.userOutput = new $3f2389d83f9401b4$var$DimensionUserOuput(userOutputEncode, schema);
    return summary;
}
function $3f2389d83f9401b4$var$getOrCreateEncodeArr(encode, dim) {
    if (!encode.hasOwnProperty(dim)) encode[dim] = [];
    return encode[dim];
}
function $3f2389d83f9401b4$export$af1622903e71278e(axisType) {
    return axisType === "category" ? "ordinal" : axisType === "time" ? "time" : "float";
}
function $3f2389d83f9401b4$var$mayLabelDimType(dimType) {
    // In most cases, ordinal and time do not suitable for label.
    // Ordinal info can be displayed on axis. Time is too long.
    return !(dimType === "ordinal" || dimType === "time");
} // function findTheLastDimMayLabel(data) {
 //     // Get last value dim
 //     let dimensions = data.dimensions.slice();
 //     let valueType;
 //     let valueDim;
 //     while (dimensions.length && (
 //         valueDim = dimensions.pop(),
 //         valueType = data.getDimensionInfo(valueDim).type,
 //         valueType === 'ordinal' || valueType === 'time'
 //     )) {} // jshint ignore:line
 //     return valueDim;
 // }


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $811c3f545844d4e7$var$SeriesDimensionDefine = /** @class */ function() {
    /**
   * @param opt All of the fields will be shallow copied.
   */ function SeriesDimensionDefine(opt) {
        /**
     * The term "other" means "other than coord".
     * The format of `otherDims` is:
     * ```js
     * {
     *     tooltip?: number
     *     label?: number
     *     itemName?: number
     *     seriesName?: number
     * }
     * ```
     *
     * A `series.encode` can specified these fields:
     * ```js
     * encode: {
     *     // "3, 1, 5" is the index of data dimension.
     *     tooltip: [3, 1, 5],
     *     label: [0, 3],
     *     ...
     * }
     * ```
     * `otherDims` is the parse result of the `series.encode` above, like:
     * ```js
     * // Suppose the index of this data dimension is `3`.
     * this.otherDims = {
     *     // `3` is at the index `0` of the `encode.tooltip`
     *     tooltip: 0,
     *     // `3` is at the index `1` of the `encode.label`
     *     label: 1
     * };
     * ```
     *
     * This prop should never be `null`/`undefined` after initialized.
     */ this.otherDims = {};
        if (opt != null) $43e0a445ed6711da$export$8b58be045bf06082(this, opt);
    }
    return SeriesDimensionDefine;
}();
var $811c3f545844d4e7$export$2e2bcd8739ae039 = $811c3f545844d4e7$var$SeriesDimensionDefine;







/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $b25eb3e4e0d2f900$var$inner = (0, $87f4a59ac66e0ee6$export$64df9f8d92ae083f)();
var $b25eb3e4e0d2f900$var$dimTypeShort = {
    float: "f",
    int: "i",
    ordinal: "o",
    number: "n",
    time: "t"
};
/**
 * Represents the dimension requirement of a series.
 *
 * NOTICE:
 * When there are too many dimensions in dataset and many series, only the used dimensions
 * (i.e., used by coord sys and declared in `series.encode`) are add to `dimensionDefineList`.
 * But users may query data by other unused dimension names.
 * In this case, users can only query data if and only if they have defined dimension names
 * via ec option, so we provide `getDimensionIndexFromSource`, which only query them from
 * `source` dimensions.
 */ var $b25eb3e4e0d2f900$export$a1ef064685775f3e = /** @class */ function() {
    function SeriesDataSchema(opt) {
        this.dimensions = opt.dimensions;
        this._dimOmitted = opt.dimensionOmitted;
        this.source = opt.source;
        this._fullDimCount = opt.fullDimensionCount;
        this._updateDimOmitted(opt.dimensionOmitted);
    }
    SeriesDataSchema.prototype.isDimensionOmitted = function() {
        return this._dimOmitted;
    };
    SeriesDataSchema.prototype._updateDimOmitted = function(dimensionOmitted) {
        this._dimOmitted = dimensionOmitted;
        if (!dimensionOmitted) return;
        if (!this._dimNameMap) this._dimNameMap = $b25eb3e4e0d2f900$export$be39ae17310c33f7(this.source);
    };
    /**
   * @caution Can only be used when `dimensionOmitted: true`.
   *
   * Get index by user defined dimension name (i.e., not internal generate name).
   * That is, get index from `dimensionsDefine`.
   * If no `dimensionsDefine`, or no name get, return -1.
   */ SeriesDataSchema.prototype.getSourceDimensionIndex = function(dimName) {
        return (0, $43e0a445ed6711da$export$995e01f2f5c9d030)(this._dimNameMap.get(dimName), -1);
    };
    /**
   * @caution Can only be used when `dimensionOmitted: true`.
   *
   * Notice: may return `null`/`undefined` if user not specify dimension names.
   */ SeriesDataSchema.prototype.getSourceDimension = function(dimIndex) {
        var dimensionsDefine = this.source.dimensionsDefine;
        if (dimensionsDefine) return dimensionsDefine[dimIndex];
    };
    SeriesDataSchema.prototype.makeStoreSchema = function() {
        var dimCount = this._fullDimCount;
        var willRetrieveDataByName = (0, $8bdec9fd4ba68d58$export$8911336b527f8517)(this.source);
        var makeHashStrict = !$b25eb3e4e0d2f900$export$238b87930d825d87(dimCount);
        // If source don't have dimensions or series don't omit unsed dimensions.
        // Generate from seriesDimList directly
        var dimHash = "";
        var dims = [];
        for(var fullDimIdx = 0, seriesDimIdx = 0; fullDimIdx < dimCount; fullDimIdx++){
            var property = void 0;
            var type = void 0;
            var ordinalMeta = void 0;
            var seriesDimDef = this.dimensions[seriesDimIdx];
            // The list has been sorted by `storeDimIndex` asc.
            if (seriesDimDef && seriesDimDef.storeDimIndex === fullDimIdx) {
                property = willRetrieveDataByName ? seriesDimDef.name : null;
                type = seriesDimDef.type;
                ordinalMeta = seriesDimDef.ordinalMeta;
                seriesDimIdx++;
            } else {
                var sourceDimDef = this.getSourceDimension(fullDimIdx);
                if (sourceDimDef) {
                    property = willRetrieveDataByName ? sourceDimDef.name : null;
                    type = sourceDimDef.type;
                }
            }
            dims.push({
                property: property,
                type: type,
                ordinalMeta: ordinalMeta
            });
            // If retrieving data by index,
            //   use <index, type, ordinalMeta> to determine whether data can be shared.
            //   (Because in this case there might be no dimension name defined in dataset, but indices always exists).
            //   (Indices are always 0, 1, 2, ..., so we can ignore them to shorten the hash).
            // Otherwise if retrieving data by property name (like `data: [{aa: 123, bb: 765}, ...]`),
            //   use <property, type, ordinalMeta> in hash.
            if (willRetrieveDataByName && property != null && (!seriesDimDef || !seriesDimDef.isCalculationCoord)) dimHash += makeHashStrict ? property.replace(/\`/g, "`1").replace(/\$/g, "`2") : property;
            dimHash += "$";
            dimHash += $b25eb3e4e0d2f900$var$dimTypeShort[type] || "f";
            if (ordinalMeta) dimHash += ordinalMeta.uid;
            dimHash += "$";
        }
        // Source from endpoint(usually series) will be read differently
        // when seriesLayoutBy or startIndex(which is affected by sourceHeader) are different.
        // So we use this three props as key.
        var source = this.source;
        var hash = [
            source.seriesLayoutBy,
            source.startIndex,
            dimHash
        ].join("$$");
        return {
            dimensions: dims,
            hash: hash
        };
    };
    SeriesDataSchema.prototype.makeOutputDimensionNames = function() {
        var result = [];
        for(var fullDimIdx = 0, seriesDimIdx = 0; fullDimIdx < this._fullDimCount; fullDimIdx++){
            var name_1 = void 0;
            var seriesDimDef = this.dimensions[seriesDimIdx];
            // The list has been sorted by `storeDimIndex` asc.
            if (seriesDimDef && seriesDimDef.storeDimIndex === fullDimIdx) {
                if (!seriesDimDef.isCalculationCoord) name_1 = seriesDimDef.name;
                seriesDimIdx++;
            } else {
                var sourceDimDef = this.getSourceDimension(fullDimIdx);
                if (sourceDimDef) name_1 = sourceDimDef.name;
            }
            result.push(name_1);
        }
        return result;
    };
    SeriesDataSchema.prototype.appendCalculationDimension = function(dimDef) {
        this.dimensions.push(dimDef);
        dimDef.isCalculationCoord = true;
        this._fullDimCount++;
        // If append dimension on a data store, consider the store
        // might be shared by different series, series dimensions not
        // really map to store dimensions.
        this._updateDimOmitted(true);
    };
    return SeriesDataSchema;
}();
function $b25eb3e4e0d2f900$export$fafbc856132a3a0e(schema) {
    return schema instanceof $b25eb3e4e0d2f900$export$a1ef064685775f3e;
}
function $b25eb3e4e0d2f900$export$a477f5bebfd07944(dimsDef) {
    var dataDimNameMap = (0, $43e0a445ed6711da$export$55f8aa7ef875b0a4)();
    for(var i = 0; i < (dimsDef || []).length; i++){
        var dimDefItemRaw = dimsDef[i];
        var userDimName = (0, $43e0a445ed6711da$export$a6cdc56e425d0d0a)(dimDefItemRaw) ? dimDefItemRaw.name : dimDefItemRaw;
        if (userDimName != null && dataDimNameMap.get(userDimName) == null) dataDimNameMap.set(userDimName, i);
    }
    return dataDimNameMap;
}
function $b25eb3e4e0d2f900$export$be39ae17310c33f7(source) {
    var innerSource = $b25eb3e4e0d2f900$var$inner(source);
    return innerSource.dimNameMap || (innerSource.dimNameMap = $b25eb3e4e0d2f900$export$a477f5bebfd07944(source.dimensionsDefine));
}
function $b25eb3e4e0d2f900$export$238b87930d825d87(dimCount) {
    return dimCount > 30;
}


var $1be6b212af73174f$var$isObject = $43e0a445ed6711da$export$a6cdc56e425d0d0a;
var $1be6b212af73174f$var$map = $43e0a445ed6711da$export$871de8747c9eaa88;
var $1be6b212af73174f$var$CtorInt32Array = typeof Int32Array === "undefined" ? Array : Int32Array;
// Use prefix to avoid index to be the same as otherIdList[idx],
// which will cause weird update animation.
var $1be6b212af73174f$var$ID_PREFIX = "e\0\0";
var $1be6b212af73174f$var$INDEX_NOT_FOUND = -1;
// type SeriesDimensionIndex = DimensionIndex;
var $1be6b212af73174f$var$TRANSFERABLE_PROPERTIES = [
    "hasItemOption",
    "_nameList",
    "_idList",
    "_invertedIndicesMap",
    "_dimSummary",
    "userOutput",
    "_rawData",
    "_dimValueGetter",
    "_nameDimIdx",
    "_idDimIdx",
    "_nameRepeatCount"
];
var $1be6b212af73174f$var$CLONE_PROPERTIES = [
    "_approximateExtent"
];
// -----------------------------
// Internal method declarations:
// -----------------------------
var $1be6b212af73174f$var$prepareInvertedIndex;
var $1be6b212af73174f$var$getId;
var $1be6b212af73174f$var$getIdNameFromStore;
var $1be6b212af73174f$var$normalizeDimensions;
var $1be6b212af73174f$var$transferProperties;
var $1be6b212af73174f$var$cloneListForMapAndSample;
var $1be6b212af73174f$var$makeIdFromName;
var $1be6b212af73174f$var$SeriesData = /** @class */ function() {
    /**
   * @param dimensionsInput.dimensions
   *        For example, ['someDimName', {name: 'someDimName', type: 'someDimType'}, ...].
   *        Dimensions should be concrete names like x, y, z, lng, lat, angle, radius
   */ function SeriesData(dimensionsInput, hostModel) {
        this.type = "list";
        this._dimOmitted = false;
        this._nameList = [];
        this._idList = [];
        // Models of data option is stored sparse for optimizing memory cost
        // Never used yet (not used yet).
        // private _optionModels: Model[] = [];
        // Global visual properties after visual coding
        this._visual = {};
        // Global layout properties.
        this._layout = {};
        // Item visual properties after visual coding
        this._itemVisuals = [];
        // Item layout properties after layout
        this._itemLayouts = [];
        // Graphic elements
        this._graphicEls = [];
        // key: dim, value: extent
        this._approximateExtent = {};
        this._calculationInfo = {};
        // Having detected that there is data item is non primitive type
        // (in type `OptionDataItemObject`).
        // Like `data: [ { value: xx, itemStyle: {...} }, ...]`
        // At present it only happen in `SOURCE_FORMAT_ORIGINAL`.
        this.hasItemOption = false;
        // Methods that create a new list based on this list should be listed here.
        // Notice that those method should `RETURN` the new list.
        this.TRANSFERABLE_METHODS = [
            "cloneShallow",
            "downSample",
            "minmaxDownSample",
            "lttbDownSample",
            "map"
        ];
        // Methods that change indices of this list should be listed here.
        this.CHANGABLE_METHODS = [
            "filterSelf",
            "selectRange"
        ];
        this.DOWNSAMPLE_METHODS = [
            "downSample",
            "minmaxDownSample",
            "lttbDownSample"
        ];
        var dimensions;
        var assignStoreDimIdx = false;
        if ((0, $b25eb3e4e0d2f900$export$fafbc856132a3a0e)(dimensionsInput)) {
            dimensions = dimensionsInput.dimensions;
            this._dimOmitted = dimensionsInput.isDimensionOmitted();
            this._schema = dimensionsInput;
        } else {
            assignStoreDimIdx = true;
            dimensions = dimensionsInput;
        }
        dimensions = dimensions || [
            "x",
            "y"
        ];
        var dimensionInfos = {};
        var dimensionNames = [];
        var invertedIndicesMap = {};
        var needsHasOwn = false;
        var emptyObj = {};
        for(var i = 0; i < dimensions.length; i++){
            // Use the original dimensions[i], where other flag props may exists.
            var dimInfoInput = dimensions[i];
            var dimensionInfo = $43e0a445ed6711da$export$844ec244b1367d54(dimInfoInput) ? new (0, $811c3f545844d4e7$export$2e2bcd8739ae039)({
                name: dimInfoInput
            }) : !(dimInfoInput instanceof (0, $811c3f545844d4e7$export$2e2bcd8739ae039)) ? new (0, $811c3f545844d4e7$export$2e2bcd8739ae039)(dimInfoInput) : dimInfoInput;
            var dimensionName = dimensionInfo.name;
            dimensionInfo.type = dimensionInfo.type || "float";
            if (!dimensionInfo.coordDim) {
                dimensionInfo.coordDim = dimensionName;
                dimensionInfo.coordDimIndex = 0;
            }
            var otherDims = dimensionInfo.otherDims = dimensionInfo.otherDims || {};
            dimensionNames.push(dimensionName);
            dimensionInfos[dimensionName] = dimensionInfo;
            if (emptyObj[dimensionName] != null) needsHasOwn = true;
            if (dimensionInfo.createInvertedIndices) invertedIndicesMap[dimensionName] = [];
            if (assignStoreDimIdx) dimensionInfo.storeDimIndex = i;
            if (otherDims.itemName === 0) this._nameDimIdx = dimensionInfo.storeDimIndex;
            if (otherDims.itemId === 0) this._idDimIdx = dimensionInfo.storeDimIndex;
        }
        this.dimensions = dimensionNames;
        this._dimInfos = dimensionInfos;
        this._initGetDimensionInfo(needsHasOwn);
        this.hostModel = hostModel;
        this._invertedIndicesMap = invertedIndicesMap;
        if (this._dimOmitted) {
            var dimIdxToName_1 = this._dimIdxToName = $43e0a445ed6711da$export$55f8aa7ef875b0a4();
            $43e0a445ed6711da$export$79b2f7037acddd43(dimensionNames, function(dimName) {
                dimIdxToName_1.set(dimensionInfos[dimName].storeDimIndex, dimName);
            });
        }
    }
    /**
   *
   * Get concrete dimension name by dimension name or dimension index.
   * If input a dimension name, do not validate whether the dimension name exits.
   *
   * @caution
   * @param dim Must make sure the dimension is `SeriesDimensionLoose`.
   * Because only those dimensions will have auto-generated dimension names if not
   * have a user-specified name, and other dimensions will get a return of null/undefined.
   *
   * @notice Because of this reason, should better use `getDimensionIndex` instead, for examples:
   * ```js
   * const val = data.getStore().get(data.getDimensionIndex(dim), dataIdx);
   * ```
   *
   * @return Concrete dim name.
   */ SeriesData.prototype.getDimension = function(dim) {
        var dimIdx = this._recognizeDimIndex(dim);
        if (dimIdx == null) return dim;
        dimIdx = dim;
        if (!this._dimOmitted) return this.dimensions[dimIdx];
        // Retrieve from series dimension definition because it probably contains
        // generated dimension name (like 'x', 'y').
        var dimName = this._dimIdxToName.get(dimIdx);
        if (dimName != null) return dimName;
        var sourceDimDef = this._schema.getSourceDimension(dimIdx);
        if (sourceDimDef) return sourceDimDef.name;
    };
    /**
   * Get dimension index in data store. Return -1 if not found.
   * Can be used to index value from getRawValue.
   */ SeriesData.prototype.getDimensionIndex = function(dim) {
        var dimIdx = this._recognizeDimIndex(dim);
        if (dimIdx != null) return dimIdx;
        if (dim == null) return -1;
        var dimInfo = this._getDimInfo(dim);
        return dimInfo ? dimInfo.storeDimIndex : this._dimOmitted ? this._schema.getSourceDimensionIndex(dim) : -1;
    };
    /**
   * The meanings of the input parameter `dim`:
   *
   * + If dim is a number (e.g., `1`), it means the index of the dimension.
   *   For example, `getDimension(0)` will return 'x' or 'lng' or 'radius'.
   * + If dim is a number-like string (e.g., `"1"`):
   *     + If there is the same concrete dim name defined in `series.dimensions` or `dataset.dimensions`,
   *        it means that concrete name.
   *     + If not, it will be converted to a number, which means the index of the dimension.
   *        (why? because of the backward compatibility. We have been tolerating number-like string in
   *        dimension setting, although now it seems that it is not a good idea.)
   *     For example, `visualMap[i].dimension: "1"` is the same meaning as `visualMap[i].dimension: 1`,
   *     if no dimension name is defined as `"1"`.
   * + If dim is a not-number-like string, it means the concrete dim name.
   *   For example, it can be be default name `"x"`, `"y"`, `"z"`, `"lng"`, `"lat"`, `"angle"`, `"radius"`,
   *   or customized in `dimensions` property of option like `"age"`.
   *
   * @return recognized `DimensionIndex`. Otherwise return null/undefined (means that dim is `DimensionName`).
   */ SeriesData.prototype._recognizeDimIndex = function(dim) {
        if ($43e0a445ed6711da$export$7e4aa119212bc614(dim) || dim != null && !isNaN(dim) && !this._getDimInfo(dim) && (!this._dimOmitted || this._schema.getSourceDimensionIndex(dim) < 0)) return +dim;
    };
    SeriesData.prototype._getStoreDimIndex = function(dim) {
        var dimIdx = this.getDimensionIndex(dim);
        return dimIdx;
    };
    /**
   * Get type and calculation info of particular dimension
   * @param dim
   *        Dimension can be concrete names like x, y, z, lng, lat, angle, radius
   *        Or a ordinal number. For example getDimensionInfo(0) will return 'x' or 'lng' or 'radius'
   */ SeriesData.prototype.getDimensionInfo = function(dim) {
        // Do not clone, because there may be categories in dimInfo.
        return this._getDimInfo(this.getDimension(dim));
    };
    SeriesData.prototype._initGetDimensionInfo = function(needsHasOwn) {
        var dimensionInfos = this._dimInfos;
        this._getDimInfo = needsHasOwn ? function(dimName) {
            return dimensionInfos.hasOwnProperty(dimName) ? dimensionInfos[dimName] : undefined;
        } : function(dimName) {
            return dimensionInfos[dimName];
        };
    };
    /**
   * concrete dimension name list on coord.
   */ SeriesData.prototype.getDimensionsOnCoord = function() {
        return this._dimSummary.dataDimsOnCoord.slice();
    };
    SeriesData.prototype.mapDimension = function(coordDim, idx) {
        var dimensionsSummary = this._dimSummary;
        if (idx == null) return dimensionsSummary.encodeFirstDimNotExtra[coordDim];
        var dims = dimensionsSummary.encode[coordDim];
        return dims ? dims[idx] : null;
    };
    SeriesData.prototype.mapDimensionsAll = function(coordDim) {
        var dimensionsSummary = this._dimSummary;
        var dims = dimensionsSummary.encode[coordDim];
        return (dims || []).slice();
    };
    SeriesData.prototype.getStore = function() {
        return this._store;
    };
    /**
   * Initialize from data
   * @param data source or data or data store.
   * @param nameList The name of a datum is used on data diff and
   *        default label/tooltip.
   *        A name can be specified in encode.itemName,
   *        or dataItem.name (only for series option data),
   *        or provided in nameList from outside.
   */ SeriesData.prototype.initData = function(data, nameList, dimValueGetter) {
        var _this = this;
        var store;
        if (data instanceof (0, $b8b029dec8573db8$export$2e2bcd8739ae039)) store = data;
        if (!store) {
            var dimensions = this.dimensions;
            var provider = (0, $8bdec9fd4ba68d58$export$22b808bc02a60488)(data) || $43e0a445ed6711da$export$1e2f57719e155213(data) ? new (0, $2e0ca4b2bac7e54a$export$b900d7c4c3952a40)(data, dimensions.length) : data;
            store = new (0, $b8b029dec8573db8$export$2e2bcd8739ae039)();
            var dimensionInfos = $1be6b212af73174f$var$map(dimensions, function(dimName) {
                return {
                    type: _this._dimInfos[dimName].type,
                    property: dimName
                };
            });
            store.initData(provider, dimensionInfos, dimValueGetter);
        }
        this._store = store;
        // Reset
        this._nameList = (nameList || []).slice();
        this._idList = [];
        this._nameRepeatCount = {};
        this._doInit(0, store.count());
        // Cache summary info for fast visit. See "dimensionHelper".
        // Needs to be initialized after store is prepared.
        this._dimSummary = (0, $3f2389d83f9401b4$export$505a22c3734846f1)(this, this._schema);
        this.userOutput = this._dimSummary.userOutput;
    };
    /**
   * Caution: Can be only called on raw data (before `this._indices` created).
   */ SeriesData.prototype.appendData = function(data) {
        var range = this._store.appendData(data);
        this._doInit(range[0], range[1]);
    };
    /**
   * Caution: Can be only called on raw data (before `this._indices` created).
   * This method does not modify `rawData` (`dataProvider`), but only
   * add values to store.
   *
   * The final count will be increased by `Math.max(values.length, names.length)`.
   *
   * @param values That is the SourceType: 'arrayRows', like
   *        [
   *            [12, 33, 44],
   *            [NaN, 43, 1],
   *            ['-', 'asdf', 0]
   *        ]
   *        Each item is exactly corresponding to a dimension.
   */ SeriesData.prototype.appendValues = function(values, names) {
        var _a = this._store.appendValues(values, names && names.length), start = _a.start, end = _a.end;
        var shouldMakeIdFromName = this._shouldMakeIdFromName();
        this._updateOrdinalMeta();
        if (names) for(var idx = start; idx < end; idx++){
            var sourceIdx = idx - start;
            this._nameList[idx] = names[sourceIdx];
            if (shouldMakeIdFromName) $1be6b212af73174f$var$makeIdFromName(this, idx);
        }
    };
    SeriesData.prototype._updateOrdinalMeta = function() {
        var store = this._store;
        var dimensions = this.dimensions;
        for(var i = 0; i < dimensions.length; i++){
            var dimInfo = this._dimInfos[dimensions[i]];
            if (dimInfo.ordinalMeta) store.collectOrdinalMeta(dimInfo.storeDimIndex, dimInfo.ordinalMeta);
        }
    };
    SeriesData.prototype._shouldMakeIdFromName = function() {
        var provider = this._store.getProvider();
        return this._idDimIdx == null && provider.getSource().sourceFormat !== (0, $bde9c82f7837f767$export$a918cb016a382d45) && !provider.fillStorage;
    };
    SeriesData.prototype._doInit = function(start, end) {
        if (start >= end) return;
        var store = this._store;
        var provider = store.getProvider();
        this._updateOrdinalMeta();
        var nameList = this._nameList;
        var idList = this._idList;
        var sourceFormat = provider.getSource().sourceFormat;
        var isFormatOriginal = sourceFormat === (0, $bde9c82f7837f767$export$2823037fb9d8f0c6);
        // Each data item is value
        // [1, 2]
        // 2
        // Bar chart, line chart which uses category axis
        // only gives the 'y' value. 'x' value is the indices of category
        // Use a tempValue to normalize the value to be a (x, y) value
        // If dataItem is {name: ...} or {id: ...}, it has highest priority.
        // This kind of ids and names are always stored `_nameList` and `_idList`.
        if (isFormatOriginal && !provider.pure) {
            var sharedDataItem = [];
            for(var idx = start; idx < end; idx++){
                // NOTICE: Try not to write things into dataItem
                var dataItem = provider.getItem(idx, sharedDataItem);
                if (!this.hasItemOption && (0, $87f4a59ac66e0ee6$export$3e1a543f33ef6883)(dataItem)) this.hasItemOption = true;
                if (dataItem) {
                    var itemName = dataItem.name;
                    if (nameList[idx] == null && itemName != null) nameList[idx] = (0, $87f4a59ac66e0ee6$export$fb1a222ba5dd6e51)(itemName, null);
                    var itemId = dataItem.id;
                    if (idList[idx] == null && itemId != null) idList[idx] = (0, $87f4a59ac66e0ee6$export$fb1a222ba5dd6e51)(itemId, null);
                }
            }
        }
        if (this._shouldMakeIdFromName()) for(var idx = start; idx < end; idx++)$1be6b212af73174f$var$makeIdFromName(this, idx);
        $1be6b212af73174f$var$prepareInvertedIndex(this);
    };
    /**
   * Optimize for the scenario that data is filtered by a given extent.
   * Consider that if data amount is more than hundreds of thousand,
   * extent calculation will cost more than 10ms and the cache will
   * be erased because of the filtering.
   */ SeriesData.prototype.getApproximateExtent = function(dim, filter) {
        return this._approximateExtent[dim] || this._store.getDataExtent(this._getStoreDimIndex(dim), filter);
    };
    /**
   * NOTICE: `_approximateExtent` does not support filter. Callers must ensure the input extent
   * to be handled by `scale.sanitizeExtent`.
   *
   * Calculate extent on a filtered data might be time consuming.
   * Approximate extent is only used for: calculate extent of filtered data outside.
   */ SeriesData.prototype.setApproximateExtent = function(extent, dim) {
        dim = this.getDimension(dim);
        this._approximateExtent[dim] = extent.slice();
    };
    SeriesData.prototype.getCalculationInfo = function(key) {
        return this._calculationInfo[key];
    };
    SeriesData.prototype.setCalculationInfo = function(key, value) {
        $1be6b212af73174f$var$isObject(key) ? $43e0a445ed6711da$export$8b58be045bf06082(this._calculationInfo, key) : this._calculationInfo[key] = value;
    };
    /**
   * @return Never be null/undefined. `number` will be converted to string. Because:
   * In most cases, name is used in display, where returning a string is more convenient.
   * In other cases, name is used in query (see `indexOfName`), where we can keep the
   * rule that name `2` equals to name `'2'`.
   */ SeriesData.prototype.getName = function(idx) {
        var rawIndex = this.getRawIndex(idx);
        var name = this._nameList[rawIndex];
        if (name == null && this._nameDimIdx != null) name = $1be6b212af73174f$var$getIdNameFromStore(this, this._nameDimIdx, rawIndex);
        if (name == null) name = "";
        return name;
    };
    SeriesData.prototype._getCategory = function(dimIdx, idx) {
        var ordinal = this._store.get(dimIdx, idx);
        var ordinalMeta = this._store.getOrdinalMeta(dimIdx);
        if (ordinalMeta) return ordinalMeta.categories[ordinal];
        return ordinal;
    };
    /**
   * @return Never null/undefined. `number` will be converted to string. Because:
   * In all cases having encountered at present, id is used in making diff comparison, which
   * are usually based on hash map. We can keep the rule that the internal id are always string
   * (treat `2` is the same as `'2'`) to make the related logic simple.
   */ SeriesData.prototype.getId = function(idx) {
        return $1be6b212af73174f$var$getId(this, this.getRawIndex(idx));
    };
    SeriesData.prototype.count = function() {
        return this._store.count();
    };
    /**
   * Get value. Return NaN if idx is out of range.
   *
   * @notice Should better to use `data.getStore().get(dimIndex, dataIdx)` instead.
   */ SeriesData.prototype.get = function(dim, idx) {
        var store = this._store;
        var dimInfo = this._dimInfos[dim];
        if (dimInfo) return store.get(dimInfo.storeDimIndex, idx);
    };
    /**
   * @notice Should better to use `data.getStore().getByRawIndex(dimIndex, dataIdx)` instead.
   */ SeriesData.prototype.getByRawIndex = function(dim, rawIdx) {
        var store = this._store;
        var dimInfo = this._dimInfos[dim];
        if (dimInfo) return store.getByRawIndex(dimInfo.storeDimIndex, rawIdx);
    };
    SeriesData.prototype.getIndices = function() {
        return this._store.getIndices();
    };
    SeriesData.prototype.getDataExtent = function(dim) {
        return this._store.getDataExtent(this._getStoreDimIndex(dim), null);
    };
    SeriesData.prototype.getSum = function(dim) {
        return this._store.getSum(this._getStoreDimIndex(dim));
    };
    SeriesData.prototype.getMedian = function(dim) {
        return this._store.getMedian(this._getStoreDimIndex(dim));
    };
    SeriesData.prototype.getValues = function(dimensions, idx) {
        var _this = this;
        var store = this._store;
        return $43e0a445ed6711da$export$43bee75e5e14138e(dimensions) ? store.getValues($1be6b212af73174f$var$map(dimensions, function(dim) {
            return _this._getStoreDimIndex(dim);
        }), idx) : store.getValues(dimensions);
    };
    /**
   * If value is NaN. Including '-'
   * Only check the coord dimensions.
   */ SeriesData.prototype.hasValue = function(idx) {
        var dataDimIndicesOnCoord = this._dimSummary.dataDimIndicesOnCoord;
        for(var i = 0, len = dataDimIndicesOnCoord.length; i < len; i++){
            // Ordinal type originally can be string or number.
            // But when an ordinal type is used on coord, it can
            // not be string but only number. So we can also use isNaN.
            if (isNaN(this._store.get(dataDimIndicesOnCoord[i], idx))) return false;
        }
        return true;
    };
    /**
   * Retrieve the index with given name
   */ SeriesData.prototype.indexOfName = function(name) {
        for(var i = 0, len = this._store.count(); i < len; i++){
            if (this.getName(i) === name) return i;
        }
        return -1;
    };
    SeriesData.prototype.getRawIndex = function(idx) {
        return this._store.getRawIndex(idx);
    };
    SeriesData.prototype.indexOfRawIndex = function(rawIndex) {
        return this._store.indexOfRawIndex(rawIndex);
    };
    /**
   * Only support the dimension which inverted index created.
   * Do not support other cases until required.
   * @param dim concrete dim
   * @param value ordinal index
   * @return rawIndex
   */ SeriesData.prototype.rawIndexOf = function(dim, value) {
        var invertedIndices = dim && this._invertedIndicesMap[dim];
        var rawIndex = invertedIndices && invertedIndices[value];
        if (rawIndex == null || isNaN(rawIndex)) return $1be6b212af73174f$var$INDEX_NOT_FOUND;
        return rawIndex;
    };
    SeriesData.prototype.each = function(dims, cb, ctx) {
        "use strict";
        if ($43e0a445ed6711da$export$f6e2535fb5126e54(dims)) {
            ctx = cb;
            cb = dims;
            dims = [];
        }
        // ctxCompat just for compat echarts3
        var fCtx = ctx || this;
        var dimIndices = $1be6b212af73174f$var$map($1be6b212af73174f$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
        this._store.each(dimIndices, fCtx ? $43e0a445ed6711da$export$2385a24977818dd0(cb, fCtx) : cb);
    };
    SeriesData.prototype.filterSelf = function(dims, cb, ctx) {
        "use strict";
        if ($43e0a445ed6711da$export$f6e2535fb5126e54(dims)) {
            ctx = cb;
            cb = dims;
            dims = [];
        }
        // ctxCompat just for compat echarts3
        var fCtx = ctx || this;
        var dimIndices = $1be6b212af73174f$var$map($1be6b212af73174f$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
        this._store = this._store.filter(dimIndices, fCtx ? $43e0a445ed6711da$export$2385a24977818dd0(cb, fCtx) : cb);
        return this;
    };
    /**
   * Select data in range. (For optimization of filter)
   * (Manually inline code, support 5 million data filtering in data zoom.)
   */ SeriesData.prototype.selectRange = function(range) {
        "use strict";
        var _this = this;
        var innerRange = {};
        var dims = $43e0a445ed6711da$export$ed97f33186d4b816(range);
        var dimIndices = [];
        $43e0a445ed6711da$export$79b2f7037acddd43(dims, function(dim) {
            var dimIdx = _this._getStoreDimIndex(dim);
            innerRange[dimIdx] = range[dim];
            dimIndices.push(dimIdx);
        });
        this._store = this._store.selectRange(innerRange);
        return this;
    };
    /* eslint-enable max-len */ SeriesData.prototype.mapArray = function(dims, cb, ctx) {
        "use strict";
        if ($43e0a445ed6711da$export$f6e2535fb5126e54(dims)) {
            ctx = cb;
            cb = dims;
            dims = [];
        }
        // ctxCompat just for compat echarts3
        ctx = ctx || this;
        var result = [];
        this.each(dims, function() {
            result.push(cb && cb.apply(this, arguments));
        }, ctx);
        return result;
    };
    SeriesData.prototype.map = function(dims, cb, ctx, ctxCompat) {
        "use strict";
        // ctxCompat just for compat echarts3
        var fCtx = ctx || ctxCompat || this;
        var dimIndices = $1be6b212af73174f$var$map($1be6b212af73174f$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
        var list = $1be6b212af73174f$var$cloneListForMapAndSample(this);
        list._store = this._store.map(dimIndices, fCtx ? $43e0a445ed6711da$export$2385a24977818dd0(cb, fCtx) : cb);
        return list;
    };
    SeriesData.prototype.modify = function(dims, cb, ctx, ctxCompat) {
        var _this = this;
        // ctxCompat just for compat echarts3
        var fCtx = ctx || ctxCompat || this;
        var dimIndices = $1be6b212af73174f$var$map($1be6b212af73174f$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
        // If do shallow clone here, if there are too many stacked series,
        // it still cost lots of memory, because `_store.dimensions` are not shared.
        // We should consider there probably be shallow clone happen in each series
        // in consequent filter/map.
        this._store.modify(dimIndices, fCtx ? $43e0a445ed6711da$export$2385a24977818dd0(cb, fCtx) : cb);
    };
    /**
   * Large data down sampling on given dimension
   * @param sampleIndex Sample index for name and id
   */ SeriesData.prototype.downSample = function(dimension, rate, sampleValue, sampleIndex) {
        var list = $1be6b212af73174f$var$cloneListForMapAndSample(this);
        list._store = this._store.downSample(this._getStoreDimIndex(dimension), rate, sampleValue, sampleIndex);
        return list;
    };
    /**
   * Large data down sampling using min-max
   * @param {string} valueDimension
   * @param {number} rate
   */ SeriesData.prototype.minmaxDownSample = function(valueDimension, rate) {
        var list = $1be6b212af73174f$var$cloneListForMapAndSample(this);
        list._store = this._store.minmaxDownSample(this._getStoreDimIndex(valueDimension), rate);
        return list;
    };
    /**
   * Large data down sampling using largest-triangle-three-buckets
   * @param {string} valueDimension
   * @param {number} targetCount
   */ SeriesData.prototype.lttbDownSample = function(valueDimension, rate) {
        var list = $1be6b212af73174f$var$cloneListForMapAndSample(this);
        list._store = this._store.lttbDownSample(this._getStoreDimIndex(valueDimension), rate);
        return list;
    };
    SeriesData.prototype.getRawDataItem = function(idx) {
        return this._store.getRawDataItem(idx);
    };
    /**
   * Get model of one data item.
   */ // TODO: Type of data item
    SeriesData.prototype.getItemModel = function(idx) {
        var hostModel = this.hostModel;
        var dataItem = this.getRawDataItem(idx);
        return new (0, $279973fc50f77a15$export$2e2bcd8739ae039)(dataItem, hostModel, hostModel && hostModel.ecModel);
    };
    /**
   * Create a data differ
   */ SeriesData.prototype.diff = function(otherList) {
        var thisList = this;
        return new (0, $4d1a09ac340ee97e$export$2e2bcd8739ae039)(otherList ? otherList.getStore().getIndices() : [], this.getStore().getIndices(), function(idx) {
            return $1be6b212af73174f$var$getId(otherList, idx);
        }, function(idx) {
            return $1be6b212af73174f$var$getId(thisList, idx);
        });
    };
    /**
   * Get visual property.
   */ SeriesData.prototype.getVisual = function(key) {
        var visual = this._visual;
        return visual && visual[key];
    };
    SeriesData.prototype.setVisual = function(kvObj, val) {
        this._visual = this._visual || {};
        if ($1be6b212af73174f$var$isObject(kvObj)) $43e0a445ed6711da$export$8b58be045bf06082(this._visual, kvObj);
        else this._visual[kvObj] = val;
    };
    /**
   * Get visual property of single data item
   */ // eslint-disable-next-line
    SeriesData.prototype.getItemVisual = function(idx, key) {
        var itemVisual = this._itemVisuals[idx];
        var val = itemVisual && itemVisual[key];
        if (val == null) // Use global visual property
        return this.getVisual(key);
        return val;
    };
    /**
   * If exists visual property of single data item
   */ SeriesData.prototype.hasItemVisual = function() {
        return this._itemVisuals.length > 0;
    };
    /**
   * Make sure itemVisual property is unique
   */ // TODO: use key to save visual to reduce memory.
    SeriesData.prototype.ensureUniqueItemVisual = function(idx, key) {
        var itemVisuals = this._itemVisuals;
        var itemVisual = itemVisuals[idx];
        if (!itemVisual) itemVisual = itemVisuals[idx] = {};
        var val = itemVisual[key];
        if (val == null) {
            val = this.getVisual(key);
            // TODO Performance?
            if ($43e0a445ed6711da$export$43bee75e5e14138e(val)) val = val.slice();
            else if ($1be6b212af73174f$var$isObject(val)) val = $43e0a445ed6711da$export$8b58be045bf06082({}, val);
            itemVisual[key] = val;
        }
        return val;
    };
    // eslint-disable-next-line
    SeriesData.prototype.setItemVisual = function(idx, key, value) {
        var itemVisual = this._itemVisuals[idx] || {};
        this._itemVisuals[idx] = itemVisual;
        if ($1be6b212af73174f$var$isObject(key)) $43e0a445ed6711da$export$8b58be045bf06082(itemVisual, key);
        else itemVisual[key] = value;
    };
    /**
   * Clear itemVisuals and list visual.
   */ SeriesData.prototype.clearAllVisual = function() {
        this._visual = {};
        this._itemVisuals = [];
    };
    SeriesData.prototype.setLayout = function(key, val) {
        $1be6b212af73174f$var$isObject(key) ? $43e0a445ed6711da$export$8b58be045bf06082(this._layout, key) : this._layout[key] = val;
    };
    /**
   * Get layout property.
   */ SeriesData.prototype.getLayout = function(key) {
        return this._layout[key];
    };
    /**
   * Get layout of single data item
   */ SeriesData.prototype.getItemLayout = function(idx) {
        return this._itemLayouts[idx];
    };
    /**
   * Set layout of single data item
   */ SeriesData.prototype.setItemLayout = function(idx, layout, merge) {
        this._itemLayouts[idx] = merge ? $43e0a445ed6711da$export$8b58be045bf06082(this._itemLayouts[idx] || {}, layout) : layout;
    };
    /**
   * Clear all layout of single data item
   */ SeriesData.prototype.clearItemLayouts = function() {
        this._itemLayouts.length = 0;
    };
    /**
   * Set graphic element relative to data. It can be set as null
   */ SeriesData.prototype.setItemGraphicEl = function(idx, el) {
        var seriesIndex = this.hostModel && this.hostModel.seriesIndex;
        (0, $7e4afcfca8f5121f$export$30d6736ebb8e18d5)(seriesIndex, this.dataType, idx, el);
        this._graphicEls[idx] = el;
    };
    SeriesData.prototype.getItemGraphicEl = function(idx) {
        return this._graphicEls[idx];
    };
    SeriesData.prototype.eachItemGraphicEl = function(cb, context) {
        $43e0a445ed6711da$export$79b2f7037acddd43(this._graphicEls, function(el, idx) {
            if (el) cb && cb.call(context, el, idx);
        });
    };
    /**
   * Shallow clone a new list except visual and layout properties, and graph elements.
   * New list only change the indices.
   */ SeriesData.prototype.cloneShallow = function(list) {
        if (!list) list = new SeriesData(this._schema ? this._schema : $1be6b212af73174f$var$map(this.dimensions, this._getDimInfo, this), this.hostModel);
        $1be6b212af73174f$var$transferProperties(list, this);
        list._store = this._store;
        return list;
    };
    /**
   * Wrap some method to add more feature
   */ SeriesData.prototype.wrapMethod = function(methodName, injectFunction) {
        var originalMethod = this[methodName];
        if (!$43e0a445ed6711da$export$f6e2535fb5126e54(originalMethod)) return;
        this.__wrappedMethods = this.__wrappedMethods || [];
        this.__wrappedMethods.push(methodName);
        this[methodName] = function() {
            var res = originalMethod.apply(this, arguments);
            return injectFunction.apply(this, [
                res
            ].concat($43e0a445ed6711da$export$58adb3bec8346d0f(arguments)));
        };
    };
    // ----------------------------------------------------------
    // A work around for internal method visiting private member.
    // ----------------------------------------------------------
    SeriesData.internalField = function() {
        $1be6b212af73174f$var$prepareInvertedIndex = function(data) {
            var invertedIndicesMap = data._invertedIndicesMap;
            $43e0a445ed6711da$export$79b2f7037acddd43(invertedIndicesMap, function(invertedIndices, dim) {
                var dimInfo = data._dimInfos[dim];
                // Currently, only dimensions that has ordinalMeta can create inverted indices.
                var ordinalMeta = dimInfo.ordinalMeta;
                var store = data._store;
                if (ordinalMeta) {
                    invertedIndices = invertedIndicesMap[dim] = new $1be6b212af73174f$var$CtorInt32Array(ordinalMeta.categories.length);
                    // The default value of TypedArray is 0. To avoid miss
                    // mapping to 0, we should set it as INDEX_NOT_FOUND.
                    for(var i = 0; i < invertedIndices.length; i++)invertedIndices[i] = $1be6b212af73174f$var$INDEX_NOT_FOUND;
                    for(var i = 0; i < store.count(); i++)// Only support the case that all values are distinct.
                    invertedIndices[store.get(dimInfo.storeDimIndex, i)] = i;
                }
            });
        };
        $1be6b212af73174f$var$getIdNameFromStore = function(data, dimIdx, idx) {
            return (0, $87f4a59ac66e0ee6$export$fb1a222ba5dd6e51)(data._getCategory(dimIdx, idx), null);
        };
        /**
     * @see the comment of `List['getId']`.
     */ $1be6b212af73174f$var$getId = function(data, rawIndex) {
            var id = data._idList[rawIndex];
            if (id == null && data._idDimIdx != null) id = $1be6b212af73174f$var$getIdNameFromStore(data, data._idDimIdx, rawIndex);
            if (id == null) id = $1be6b212af73174f$var$ID_PREFIX + rawIndex;
            return id;
        };
        $1be6b212af73174f$var$normalizeDimensions = function(dimensions) {
            if (!$43e0a445ed6711da$export$43bee75e5e14138e(dimensions)) dimensions = dimensions != null ? [
                dimensions
            ] : [];
            return dimensions;
        };
        /**
     * Data in excludeDimensions is copied, otherwise transferred.
     */ $1be6b212af73174f$var$cloneListForMapAndSample = function(original) {
            var list = new SeriesData(original._schema ? original._schema : $1be6b212af73174f$var$map(original.dimensions, original._getDimInfo, original), original.hostModel);
            // FIXME If needs stackedOn, value may already been stacked
            $1be6b212af73174f$var$transferProperties(list, original);
            return list;
        };
        $1be6b212af73174f$var$transferProperties = function(target, source) {
            $43e0a445ed6711da$export$79b2f7037acddd43($1be6b212af73174f$var$TRANSFERABLE_PROPERTIES.concat(source.__wrappedMethods || []), function(propName) {
                if (source.hasOwnProperty(propName)) target[propName] = source[propName];
            });
            target.__wrappedMethods = source.__wrappedMethods;
            $43e0a445ed6711da$export$79b2f7037acddd43($1be6b212af73174f$var$CLONE_PROPERTIES, function(propName) {
                target[propName] = $43e0a445ed6711da$export$9cd59f9826255e47(source[propName]);
            });
            target._calculationInfo = $43e0a445ed6711da$export$8b58be045bf06082({}, source._calculationInfo);
        };
        $1be6b212af73174f$var$makeIdFromName = function(data, idx) {
            var nameList = data._nameList;
            var idList = data._idList;
            var nameDimIdx = data._nameDimIdx;
            var idDimIdx = data._idDimIdx;
            var name = nameList[idx];
            var id = idList[idx];
            if (name == null && nameDimIdx != null) nameList[idx] = name = $1be6b212af73174f$var$getIdNameFromStore(data, nameDimIdx, idx);
            if (id == null && idDimIdx != null) idList[idx] = id = $1be6b212af73174f$var$getIdNameFromStore(data, idDimIdx, idx);
            if (id == null && name != null) {
                var nameRepeatCount = data._nameRepeatCount;
                var nmCnt = nameRepeatCount[name] = (nameRepeatCount[name] || 0) + 1;
                id = name;
                if (nmCnt > 1) id += "__ec__" + nmCnt;
                idList[idx] = id;
            }
        };
    }();
    return SeriesData;
}();
var $1be6b212af73174f$export$2e2bcd8739ae039 = $1be6b212af73174f$var$SeriesData;








var $c3732722dc240783$exports = {};

$parcel$export($c3732722dc240783$exports, "createList", function () { return $c3732722dc240783$export$5897d8d7c7a3d871; });
$parcel$export($c3732722dc240783$exports, "dataStack", function () { return $c3732722dc240783$export$d6100971d5a3a0a7; });
$parcel$export($c3732722dc240783$exports, "createScale", function () { return $c3732722dc240783$export$587d9c3c553380c6; });
$parcel$export($c3732722dc240783$exports, "mixinAxisModelCommonMethods", function () { return $c3732722dc240783$export$4665cbe3470e4d57; });
$parcel$export($c3732722dc240783$exports, "createTextStyle", function () { return $c3732722dc240783$export$f8998c3d0a13de59; });
$parcel$export($c3732722dc240783$exports, "getLayoutRect", function () { return $826bc4094efae72b$export$4517a5ca639a7293; });
$parcel$export($c3732722dc240783$exports, "createDimensions", function () { return $9e241c3038e358e2$export$8066c1b52b2e9504; });
$parcel$export($c3732722dc240783$exports, "createSymbol", function () { return $4ff41a845d4679a6$export$af050e04da3a02e8; });
$parcel$export($c3732722dc240783$exports, "getECData", function () { return $7e4afcfca8f5121f$export$b1c39b2bacd1ddc2; });
$parcel$export($c3732722dc240783$exports, "enableHoverEmphasis", function () { return $fffc76734a157b4c$export$5f393df0b5aee2e7; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * This module exposes helper functions for developing extensions.
 */ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







function $9e241c3038e358e2$export$8066c1b52b2e9504(source, opt) {
    return $9e241c3038e358e2$export$2e2bcd8739ae039(source, opt).dimensions;
}
function $9e241c3038e358e2$export$2e2bcd8739ae039(// TODO: TYPE completeDimensions type
source, opt) {
    if (!(0, $8bdec9fd4ba68d58$export$22b808bc02a60488)(source)) source = (0, $8bdec9fd4ba68d58$export$75aef3f97c0a5edf)(source);
    opt = opt || {};
    var sysDims = opt.coordDimensions || [];
    var dimsDef = opt.dimensionsDefine || source.dimensionsDefine || [];
    var coordDimNameMap = (0, $43e0a445ed6711da$export$55f8aa7ef875b0a4)();
    var resultList = [];
    var dimCount = $9e241c3038e358e2$var$getDimCount(source, sysDims, dimsDef, opt.dimensionsCount);
    // Try to ignore unused dimensions if sharing a high dimension datastore
    // 30 is an experience value.
    var omitUnusedDimensions = opt.canOmitUnusedDimensions && (0, $b25eb3e4e0d2f900$export$238b87930d825d87)(dimCount);
    var isUsingSourceDimensionsDef = dimsDef === source.dimensionsDefine;
    var dataDimNameMap = isUsingSourceDimensionsDef ? (0, $b25eb3e4e0d2f900$export$be39ae17310c33f7)(source) : (0, $b25eb3e4e0d2f900$export$a477f5bebfd07944)(dimsDef);
    var encodeDef = opt.encodeDefine;
    if (!encodeDef && opt.encodeDefaulter) encodeDef = opt.encodeDefaulter(source, dimCount);
    var encodeDefMap = (0, $43e0a445ed6711da$export$55f8aa7ef875b0a4)(encodeDef);
    var indicesMap = new (0, $b8b029dec8573db8$export$b60d945128546f53)(dimCount);
    for(var i = 0; i < indicesMap.length; i++)indicesMap[i] = -1;
    function getResultItem(dimIdx) {
        var idx = indicesMap[dimIdx];
        if (idx < 0) {
            var dimDefItemRaw = dimsDef[dimIdx];
            var dimDefItem = (0, $43e0a445ed6711da$export$a6cdc56e425d0d0a)(dimDefItemRaw) ? dimDefItemRaw : {
                name: dimDefItemRaw
            };
            var resultItem = new (0, $811c3f545844d4e7$export$2e2bcd8739ae039)();
            var userDimName = dimDefItem.name;
            if (userDimName != null && dataDimNameMap.get(userDimName) != null) // Only if `series.dimensions` is defined in option
            // displayName, will be set, and dimension will be displayed vertically in
            // tooltip by default.
            resultItem.name = resultItem.displayName = userDimName;
            dimDefItem.type != null && (resultItem.type = dimDefItem.type);
            dimDefItem.displayName != null && (resultItem.displayName = dimDefItem.displayName);
            var newIdx = resultList.length;
            indicesMap[dimIdx] = newIdx;
            resultItem.storeDimIndex = dimIdx;
            resultList.push(resultItem);
            return resultItem;
        }
        return resultList[idx];
    }
    if (!omitUnusedDimensions) for(var i = 0; i < dimCount; i++)getResultItem(i);
    // Set `coordDim` and `coordDimIndex` by `encodeDefMap` and normalize `encodeDefMap`.
    encodeDefMap.each(function(dataDimsRaw, coordDim) {
        var dataDims = (0, $87f4a59ac66e0ee6$export$4f07b212a02c8051)(dataDimsRaw).slice();
        // Note: It is allowed that `dataDims.length` is `0`, e.g., options is
        // `{encode: {x: -1, y: 1}}`. Should not filter anything in
        // this case.
        if (dataDims.length === 1 && !(0, $43e0a445ed6711da$export$844ec244b1367d54)(dataDims[0]) && dataDims[0] < 0) {
            encodeDefMap.set(coordDim, false);
            return;
        }
        var validDataDims = encodeDefMap.set(coordDim, []);
        (0, $43e0a445ed6711da$export$79b2f7037acddd43)(dataDims, function(resultDimIdxOrName, idx) {
            // The input resultDimIdx can be dim name or index.
            var resultDimIdx = (0, $43e0a445ed6711da$export$844ec244b1367d54)(resultDimIdxOrName) ? dataDimNameMap.get(resultDimIdxOrName) : resultDimIdxOrName;
            if (resultDimIdx != null && resultDimIdx < dimCount) {
                validDataDims[idx] = resultDimIdx;
                applyDim(getResultItem(resultDimIdx), coordDim, idx);
            }
        });
    });
    // Apply templates and default order from `sysDims`.
    var availDimIdx = 0;
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)(sysDims, function(sysDimItemRaw) {
        var coordDim;
        var sysDimItemDimsDef;
        var sysDimItemOtherDims;
        var sysDimItem;
        if ((0, $43e0a445ed6711da$export$844ec244b1367d54)(sysDimItemRaw)) {
            coordDim = sysDimItemRaw;
            sysDimItem = {};
        } else {
            sysDimItem = sysDimItemRaw;
            coordDim = sysDimItem.name;
            var ordinalMeta = sysDimItem.ordinalMeta;
            sysDimItem.ordinalMeta = null;
            sysDimItem = (0, $43e0a445ed6711da$export$8b58be045bf06082)({}, sysDimItem);
            sysDimItem.ordinalMeta = ordinalMeta;
            // `coordDimIndex` should not be set directly.
            sysDimItemDimsDef = sysDimItem.dimsDef;
            sysDimItemOtherDims = sysDimItem.otherDims;
            sysDimItem.name = sysDimItem.coordDim = sysDimItem.coordDimIndex = sysDimItem.dimsDef = sysDimItem.otherDims = null;
        }
        var dataDims = encodeDefMap.get(coordDim);
        // negative resultDimIdx means no need to mapping.
        if (dataDims === false) return;
        dataDims = (0, $87f4a59ac66e0ee6$export$4f07b212a02c8051)(dataDims);
        // dimensions provides default dim sequences.
        if (!dataDims.length) for(var i = 0; i < (sysDimItemDimsDef && sysDimItemDimsDef.length || 1); i++){
            while(availDimIdx < dimCount && getResultItem(availDimIdx).coordDim != null)availDimIdx++;
            availDimIdx < dimCount && dataDims.push(availDimIdx++);
        }
        // Apply templates.
        (0, $43e0a445ed6711da$export$79b2f7037acddd43)(dataDims, function(resultDimIdx, coordDimIndex) {
            var resultItem = getResultItem(resultDimIdx);
            // Coordinate system has a higher priority on dim type than source.
            if (isUsingSourceDimensionsDef && sysDimItem.type != null) resultItem.type = sysDimItem.type;
            applyDim((0, $43e0a445ed6711da$export$ebe90cb607ad99e)(resultItem, sysDimItem), coordDim, coordDimIndex);
            if (resultItem.name == null && sysDimItemDimsDef) {
                var sysDimItemDimsDefItem = sysDimItemDimsDef[coordDimIndex];
                !(0, $43e0a445ed6711da$export$a6cdc56e425d0d0a)(sysDimItemDimsDefItem) && (sysDimItemDimsDefItem = {
                    name: sysDimItemDimsDefItem
                });
                resultItem.name = resultItem.displayName = sysDimItemDimsDefItem.name;
                resultItem.defaultTooltip = sysDimItemDimsDefItem.defaultTooltip;
            }
            // FIXME refactor, currently only used in case: {otherDims: {tooltip: false}}
            sysDimItemOtherDims && (0, $43e0a445ed6711da$export$ebe90cb607ad99e)(resultItem.otherDims, sysDimItemOtherDims);
        });
    });
    function applyDim(resultItem, coordDim, coordDimIndex) {
        if ((0, $bde9c82f7837f767$export$cd51b5ca77f6f0e4).get(coordDim) != null) resultItem.otherDims[coordDim] = coordDimIndex;
        else {
            resultItem.coordDim = coordDim;
            resultItem.coordDimIndex = coordDimIndex;
            coordDimNameMap.set(coordDim, true);
        }
    }
    // Make sure the first extra dim is 'value'.
    var generateCoord = opt.generateCoord;
    var generateCoordCount = opt.generateCoordCount;
    var fromZero = generateCoordCount != null;
    generateCoordCount = generateCoord ? generateCoordCount || 1 : 0;
    var extra = generateCoord || "value";
    function ifNoNameFillWithCoordName(resultItem) {
        if (resultItem.name == null) // Duplication will be removed in the next step.
        resultItem.name = resultItem.coordDim;
    }
    // Set dim `name` and other `coordDim` and other props.
    if (!omitUnusedDimensions) for(var resultDimIdx = 0; resultDimIdx < dimCount; resultDimIdx++){
        var resultItem = getResultItem(resultDimIdx);
        var coordDim = resultItem.coordDim;
        if (coordDim == null) {
            // TODO no need to generate coordDim for isExtraCoord?
            resultItem.coordDim = $9e241c3038e358e2$var$genCoordDimName(extra, coordDimNameMap, fromZero);
            resultItem.coordDimIndex = 0;
            // Series specified generateCoord is using out.
            if (!generateCoord || generateCoordCount <= 0) resultItem.isExtraCoord = true;
            generateCoordCount--;
        }
        ifNoNameFillWithCoordName(resultItem);
        if (resultItem.type == null && ((0, $a55589c1e81db35a$export$c51adf1a2be01b9c)(source, resultDimIdx) === (0, $a55589c1e81db35a$export$328749e9c5b40760).Must || resultItem.isExtraCoord && (resultItem.otherDims.itemName != null || resultItem.otherDims.seriesName != null))) resultItem.type = "ordinal";
    }
    else {
        (0, $43e0a445ed6711da$export$79b2f7037acddd43)(resultList, function(resultItem) {
            // PENDING: guessOrdinal or let user specify type: 'ordinal' manually?
            ifNoNameFillWithCoordName(resultItem);
        });
        // Sort dimensions: there are some rule that use the last dim as label,
        // and for some latter travel process easier.
        resultList.sort(function(item0, item1) {
            return item0.storeDimIndex - item1.storeDimIndex;
        });
    }
    (0, $87f4a59ac66e0ee6$export$2e2262a44ac61957)(resultList, function(item) {
        return item.name;
    }, function(item, existingCount) {
        if (existingCount > 0) // Starts from 0.
        item.name = item.name + (existingCount - 1);
    });
    return new (0, $b25eb3e4e0d2f900$export$a1ef064685775f3e)({
        source: source,
        dimensions: resultList,
        fullDimensionCount: dimCount,
        dimensionOmitted: omitUnusedDimensions
    });
}
// ??? TODO
// Originally detect dimCount by data[0]. Should we
// optimize it to only by sysDims and dimensions and encode.
// So only necessary dims will be initialized.
// But
// (1) custom series should be considered. where other dims
// may be visited.
// (2) sometimes user need to calculate bubble size or use visualMap
// on other dimensions besides coordSys needed.
// So, dims that is not used by system, should be shared in data store?
function $9e241c3038e358e2$var$getDimCount(source, sysDims, dimsDef, optDimCount) {
    // Note that the result dimCount should not small than columns count
    // of data, otherwise `dataDimNameMap` checking will be incorrect.
    var dimCount = Math.max(source.dimensionsDetectedCount || 1, sysDims.length, dimsDef.length, optDimCount || 0);
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)(sysDims, function(sysDimItem) {
        var sysDimItemDimsDef;
        if ((0, $43e0a445ed6711da$export$a6cdc56e425d0d0a)(sysDimItem) && (sysDimItemDimsDef = sysDimItem.dimsDef)) dimCount = Math.max(dimCount, sysDimItemDimsDef.length);
    });
    return dimCount;
}
function $9e241c3038e358e2$var$genCoordDimName(name, map, fromZero) {
    if (fromZero || map.hasKey(name)) {
        var i = 0;
        while(map.hasKey(name + i))i++;
        name += i;
    }
    map.set(name, true);
    return name;
}





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Helper for model references.
 * There are many manners to refer axis/coordSys.
 */ // TODO
// merge relevant logic to this file?
// check: "modelHelper" of tooltip and "BrushTargetManager".


/**
 * @class
 * For example:
 * {
 *     coordSysName: 'cartesian2d',
 *     coordSysDims: ['x', 'y', ...],
 *     axisMap: HashMap({
 *         x: xAxisModel,
 *         y: yAxisModel
 *     }),
 *     categoryAxisMap: HashMap({
 *         x: xAxisModel,
 *         y: undefined
 *     }),
 *     // The index of the first category axis in `coordSysDims`.
 *     // `null/undefined` means no category axis exists.
 *     firstCategoryDimIndex: 1,
 *     // To replace user specified encode.
 * }
 */ var $2a14ae0f249cd85f$export$7c29393272d112a1 = /** @class */ function() {
    function SeriesModelCoordSysInfo(coordSysName) {
        this.coordSysDims = [];
        this.axisMap = (0, $43e0a445ed6711da$export$55f8aa7ef875b0a4)();
        this.categoryAxisMap = (0, $43e0a445ed6711da$export$55f8aa7ef875b0a4)();
        this.coordSysName = coordSysName;
    }
    return SeriesModelCoordSysInfo;
}();
function $2a14ae0f249cd85f$export$f2befeb2f4933656(seriesModel) {
    var coordSysName = seriesModel.get("coordinateSystem");
    var result = new $2a14ae0f249cd85f$export$7c29393272d112a1(coordSysName);
    var fetch = $2a14ae0f249cd85f$var$fetchers[coordSysName];
    if (fetch) {
        fetch(seriesModel, result, result.axisMap, result.categoryAxisMap);
        return result;
    }
}
// TODO: refactor them to static member of each coord sys, rather than hard code here.
var $2a14ae0f249cd85f$var$fetchers = {
    cartesian2d: function(seriesModel, result, axisMap, categoryAxisMap) {
        var xAxisModel = seriesModel.getReferringComponents("xAxis", (0, $87f4a59ac66e0ee6$export$f076738ec84e693c)).models[0];
        var yAxisModel = seriesModel.getReferringComponents("yAxis", (0, $87f4a59ac66e0ee6$export$f076738ec84e693c)).models[0];
        result.coordSysDims = [
            "x",
            "y"
        ];
        axisMap.set("x", xAxisModel);
        axisMap.set("y", yAxisModel);
        if ($2a14ae0f249cd85f$var$isCategory(xAxisModel)) {
            categoryAxisMap.set("x", xAxisModel);
            result.firstCategoryDimIndex = 0;
        }
        if ($2a14ae0f249cd85f$var$isCategory(yAxisModel)) {
            categoryAxisMap.set("y", yAxisModel);
            result.firstCategoryDimIndex == null && (result.firstCategoryDimIndex = 1);
        }
    },
    singleAxis: function(seriesModel, result, axisMap, categoryAxisMap) {
        var singleAxisModel = seriesModel.getReferringComponents("singleAxis", (0, $87f4a59ac66e0ee6$export$f076738ec84e693c)).models[0];
        result.coordSysDims = [
            "single"
        ];
        axisMap.set("single", singleAxisModel);
        if ($2a14ae0f249cd85f$var$isCategory(singleAxisModel)) {
            categoryAxisMap.set("single", singleAxisModel);
            result.firstCategoryDimIndex = 0;
        }
    },
    polar: function(seriesModel, result, axisMap, categoryAxisMap) {
        var polarModel = seriesModel.getReferringComponents("polar", (0, $87f4a59ac66e0ee6$export$f076738ec84e693c)).models[0];
        var radiusAxisModel = polarModel.findAxisModel("radiusAxis");
        var angleAxisModel = polarModel.findAxisModel("angleAxis");
        result.coordSysDims = [
            "radius",
            "angle"
        ];
        axisMap.set("radius", radiusAxisModel);
        axisMap.set("angle", angleAxisModel);
        if ($2a14ae0f249cd85f$var$isCategory(radiusAxisModel)) {
            categoryAxisMap.set("radius", radiusAxisModel);
            result.firstCategoryDimIndex = 0;
        }
        if ($2a14ae0f249cd85f$var$isCategory(angleAxisModel)) {
            categoryAxisMap.set("angle", angleAxisModel);
            result.firstCategoryDimIndex == null && (result.firstCategoryDimIndex = 1);
        }
    },
    geo: function(seriesModel, result, axisMap, categoryAxisMap) {
        result.coordSysDims = [
            "lng",
            "lat"
        ];
    },
    parallel: function(seriesModel, result, axisMap, categoryAxisMap) {
        var ecModel = seriesModel.ecModel;
        var parallelModel = ecModel.getComponent("parallel", seriesModel.get("parallelIndex"));
        var coordSysDims = result.coordSysDims = parallelModel.dimensions.slice();
        (0, $43e0a445ed6711da$export$79b2f7037acddd43)(parallelModel.parallelAxisIndex, function(axisIndex, index) {
            var axisModel = ecModel.getComponent("parallelAxis", axisIndex);
            var axisDim = coordSysDims[index];
            axisMap.set(axisDim, axisModel);
            if ($2a14ae0f249cd85f$var$isCategory(axisModel)) {
                categoryAxisMap.set(axisDim, axisModel);
                if (result.firstCategoryDimIndex == null) result.firstCategoryDimIndex = index;
            }
        });
    },
    matrix: function(seriesModel, result, axisMap, categoryAxisMap) {
        var matrixModel = seriesModel.getReferringComponents("matrix", (0, $87f4a59ac66e0ee6$export$f076738ec84e693c)).models[0];
        result.coordSysDims = [
            "x",
            "y"
        ];
        var xModel = matrixModel.getDimensionModel("x");
        var yModel = matrixModel.getDimensionModel("y");
        axisMap.set("x", xModel);
        axisMap.set("y", yModel);
        categoryAxisMap.set("x", xModel);
        categoryAxisMap.set("y", yModel);
    }
};
function $2a14ae0f249cd85f$var$isCategory(axisModel) {
    return axisModel.get("type") === "category";
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $bbbaa8c322403e71$export$f2165f9e8499b278(seriesModel, dimensionsInput, opt) {
    opt = opt || {};
    var byIndex = opt.byIndex;
    var stackedCoordDimension = opt.stackedCoordDimension;
    var dimensionDefineList;
    var schema;
    var store;
    if ($bbbaa8c322403e71$var$isLegacyDimensionsInput(dimensionsInput)) dimensionDefineList = dimensionsInput;
    else {
        schema = dimensionsInput.schema;
        dimensionDefineList = schema.dimensions;
        store = dimensionsInput.store;
    }
    // compatible: when `stack` is set as '', do not stack.
    var mayStack = !!(seriesModel && seriesModel.get("stack"));
    var stackedByDimInfo;
    var stackedDimInfo;
    var stackResultDimension;
    var stackedOverDimension;
    var allDimTypesAreNotOrdinalAndTime = true;
    function dimTypeIsNotOrdinalAndTime(dimensionInfo) {
        return dimensionInfo.type !== "ordinal" && dimensionInfo.type !== "time";
    }
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)(dimensionDefineList, function(dimensionInfo, index) {
        if ((0, $43e0a445ed6711da$export$844ec244b1367d54)(dimensionInfo)) dimensionDefineList[index] = dimensionInfo = {
            name: dimensionInfo
        };
        if (!dimTypeIsNotOrdinalAndTime(dimensionInfo)) allDimTypesAreNotOrdinalAndTime = false;
    });
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)(dimensionDefineList, function(dimensionInfo, index) {
        if (mayStack && !dimensionInfo.isExtraCoord) {
            // Find the first ordinal dimension as the stackedByDimInfo.
            if (!byIndex && !stackedByDimInfo && dimensionInfo.ordinalMeta) stackedByDimInfo = dimensionInfo;
            // Find the first stackable dimension as the stackedDimInfo.
            if (!stackedDimInfo && dimTypeIsNotOrdinalAndTime(dimensionInfo) && (!allDimTypesAreNotOrdinalAndTime || dimensionInfo.coordDim !== "x" && dimensionInfo.coordDim !== "angle") && (!stackedCoordDimension || stackedCoordDimension === dimensionInfo.coordDim)) stackedDimInfo = dimensionInfo;
        }
    });
    if (stackedDimInfo && !byIndex && !stackedByDimInfo) // "Stack by data index" makes sense only if users provide carefully constructed data - any
    // mismatch or absence of data items can cause incorrect results. By "Stack by data index"
    // is more performant - no hashmap is required.
    // PENDING:
    //  Compatible with previous design, non-category axis ("value"/"log"/"time" axis) can only
    //  stack by index. "Stack by value" will not be supported until concrete requirements arise.
    byIndex = true;
    if (stackedDimInfo) {
        // Use a weird name that not duplicated with other names.
        // Also need to use seriesModel.id as postfix because different
        // series may share same data store. The stack dimension needs to be distinguished.
        stackResultDimension = "__\0ecstackresult_" + seriesModel.id;
        stackedOverDimension = "__\0ecstackedover_" + seriesModel.id;
        // Create inverted index to fast query index by value.
        if (stackedByDimInfo) stackedByDimInfo.createInvertedIndices = true;
        var stackedDimCoordDim_1 = stackedDimInfo.coordDim;
        var stackedDimType = stackedDimInfo.type;
        var stackedDimCoordIndex_1 = 0;
        (0, $43e0a445ed6711da$export$79b2f7037acddd43)(dimensionDefineList, function(dimensionInfo) {
            if (dimensionInfo.coordDim === stackedDimCoordDim_1) stackedDimCoordIndex_1++;
        });
        var stackedOverDimensionDefine = {
            name: stackResultDimension,
            coordDim: stackedDimCoordDim_1,
            coordDimIndex: stackedDimCoordIndex_1,
            type: stackedDimType,
            isExtraCoord: true,
            isCalculationCoord: true,
            storeDimIndex: dimensionDefineList.length
        };
        var stackResultDimensionDefine = {
            name: stackedOverDimension,
            // This dimension contains stack base (generally, 0), so do not set it as
            // `stackedDimCoordDim` to avoid extent calculation, consider log scale.
            coordDim: stackedOverDimension,
            coordDimIndex: stackedDimCoordIndex_1 + 1,
            type: stackedDimType,
            isExtraCoord: true,
            isCalculationCoord: true,
            storeDimIndex: dimensionDefineList.length + 1
        };
        if (schema) {
            if (store) {
                stackedOverDimensionDefine.storeDimIndex = store.ensureCalculationDimension(stackedOverDimension, stackedDimType);
                stackResultDimensionDefine.storeDimIndex = store.ensureCalculationDimension(stackResultDimension, stackedDimType);
            }
            schema.appendCalculationDimension(stackedOverDimensionDefine);
            schema.appendCalculationDimension(stackResultDimensionDefine);
        } else {
            dimensionDefineList.push(stackedOverDimensionDefine);
            dimensionDefineList.push(stackResultDimensionDefine);
        }
    }
    return {
        stackedDimension: stackedDimInfo && stackedDimInfo.name,
        stackedByDimension: stackedByDimInfo && stackedByDimInfo.name,
        isStackedByIndex: byIndex,
        stackedOverDimension: stackedOverDimension,
        stackResultDimension: stackResultDimension
    };
}
function $bbbaa8c322403e71$var$isLegacyDimensionsInput(dimensionsInput) {
    return !(0, $b25eb3e4e0d2f900$export$fafbc856132a3a0e)(dimensionsInput.schema);
}
function $bbbaa8c322403e71$export$1dedc39359ae35c(data, stackedDim) {
    // Each single series only maps to one pair of axis. So we do not need to
    // check stackByDim, whatever stacked by a dimension or stacked by index.
    return !!stackedDim && stackedDim === data.getCalculationInfo("stackedDimension");
}
function $bbbaa8c322403e71$export$909db2be4938fbdf(data, targetDim) {
    return $bbbaa8c322403e71$export$1dedc39359ae35c(data, targetDim) ? data.getCalculationInfo("stackResultDimension") : targetDim;
}




function $5d58e30ee7cf15bf$var$getCoordSysDimDefs(seriesModel, coordSysInfo) {
    var coordSysName = seriesModel.get("coordinateSystem");
    var registeredCoordSys = (0, $a30c5e122eaab0a1$export$2e2bcd8739ae039).get(coordSysName);
    var coordSysDimDefs;
    if (coordSysInfo && coordSysInfo.coordSysDims) coordSysDimDefs = $43e0a445ed6711da$export$871de8747c9eaa88(coordSysInfo.coordSysDims, function(dim) {
        var dimInfo = {
            name: dim
        };
        var axisModel = coordSysInfo.axisMap.get(dim);
        if (axisModel) {
            var axisType = axisModel.get("type");
            dimInfo.type = (0, $3f2389d83f9401b4$export$af1622903e71278e)(axisType);
        }
        return dimInfo;
    });
    if (!coordSysDimDefs) // Get dimensions from registered coordinate system
    coordSysDimDefs = registeredCoordSys && (registeredCoordSys.getDimensionsInfo ? registeredCoordSys.getDimensionsInfo() : registeredCoordSys.dimensions.slice()) || [
        "x",
        "y"
    ];
    return coordSysDimDefs;
}
function $5d58e30ee7cf15bf$var$injectOrdinalMeta(dimInfoList, createInvertedIndices, coordSysInfo) {
    var firstCategoryDimIndex;
    var hasNameEncode;
    coordSysInfo && $43e0a445ed6711da$export$79b2f7037acddd43(dimInfoList, function(dimInfo, dimIndex) {
        var coordDim = dimInfo.coordDim;
        var categoryAxisModel = coordSysInfo.categoryAxisMap.get(coordDim);
        if (categoryAxisModel) {
            if (firstCategoryDimIndex == null) firstCategoryDimIndex = dimIndex;
            dimInfo.ordinalMeta = categoryAxisModel.getOrdinalMeta();
            if (createInvertedIndices) dimInfo.createInvertedIndices = true;
        }
        if (dimInfo.otherDims.itemName != null) hasNameEncode = true;
    });
    if (!hasNameEncode && firstCategoryDimIndex != null) dimInfoList[firstCategoryDimIndex].otherDims.itemName = 0;
    return firstCategoryDimIndex;
}
/**
 * Caution: there are side effects to `sourceManager` in this method.
 * Should better only be called in `Series['getInitialData']`.
 */ function $5d58e30ee7cf15bf$var$createSeriesData(sourceRaw, seriesModel, opt) {
    opt = opt || {};
    var sourceManager = seriesModel.getSourceManager();
    var source;
    var isOriginalSource = false;
    if (sourceRaw) {
        isOriginalSource = true;
        source = (0, $8bdec9fd4ba68d58$export$75aef3f97c0a5edf)(sourceRaw);
    } else {
        source = sourceManager.getSource();
        // Is series.data. not dataset.
        isOriginalSource = source.sourceFormat === (0, $bde9c82f7837f767$export$2823037fb9d8f0c6);
    }
    var coordSysInfo = (0, $2a14ae0f249cd85f$export$f2befeb2f4933656)(seriesModel);
    var coordSysDimDefs = $5d58e30ee7cf15bf$var$getCoordSysDimDefs(seriesModel, coordSysInfo);
    var useEncodeDefaulter = opt.useEncodeDefaulter;
    var encodeDefaulter = $43e0a445ed6711da$export$f6e2535fb5126e54(useEncodeDefaulter) ? useEncodeDefaulter : useEncodeDefaulter ? $43e0a445ed6711da$export$c3095a23b368d1f2((0, $a55589c1e81db35a$export$37682b8fdd2e83d), coordSysDimDefs, seriesModel) : null;
    var createDimensionOptions = {
        coordDimensions: coordSysDimDefs,
        generateCoord: opt.generateCoord,
        encodeDefine: seriesModel.getEncode(),
        encodeDefaulter: encodeDefaulter,
        canOmitUnusedDimensions: !isOriginalSource
    };
    var schema = (0, $9e241c3038e358e2$export$2e2bcd8739ae039)(source, createDimensionOptions);
    var firstCategoryDimIndex = $5d58e30ee7cf15bf$var$injectOrdinalMeta(schema.dimensions, opt.createInvertedIndices, coordSysInfo);
    var store = !isOriginalSource ? sourceManager.getSharedDataStore(schema) : null;
    var stackCalculationInfo = (0, $bbbaa8c322403e71$export$f2165f9e8499b278)(seriesModel, {
        schema: schema,
        store: store
    });
    var data = new (0, $1be6b212af73174f$export$2e2bcd8739ae039)(schema, seriesModel);
    data.setCalculationInfo(stackCalculationInfo);
    var dimValueGetter = firstCategoryDimIndex != null && $5d58e30ee7cf15bf$var$isNeedCompleteOrdinalData(source) ? function(itemOpt, dimName, dataIndex, dimIndex) {
        // Use dataIndex as ordinal value in categoryAxis
        return dimIndex === firstCategoryDimIndex ? dataIndex : this.defaultDimValueGetter(itemOpt, dimName, dataIndex, dimIndex);
    } : null;
    data.hasItemOption = false;
    data.initData(// Try to reuse the data store in sourceManager if using dataset.
    isOriginalSource ? source : store, null, dimValueGetter);
    return data;
}
function $5d58e30ee7cf15bf$var$isNeedCompleteOrdinalData(source) {
    if (source.sourceFormat === (0, $bde9c82f7837f767$export$2823037fb9d8f0c6)) {
        var sampleItem = $5d58e30ee7cf15bf$var$firstDataNotNull(source.data || []);
        return !$43e0a445ed6711da$export$43bee75e5e14138e((0, $87f4a59ac66e0ee6$export$2c944e12edb48d4b)(sampleItem));
    }
}
function $5d58e30ee7cf15bf$var$firstDataNotNull(arr) {
    var i = 0;
    while(i < arr.length && arr[i] == null)i++;
    return arr[i];
}
var $5d58e30ee7cf15bf$export$2e2bcd8739ae039 = $5d58e30ee7cf15bf$var$createSeriesData;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $852c4e3dd3bbc3b5$var$Scale = /** @class */ function() {
    function Scale() {}
    /**
   * When axis extent depends on data and no data exists,
   * axis ticks should not be drawn, which is named 'blank'.
   *
   * @final NEVER override!
   */ Scale.prototype.isBlank = function() {
        return this._isBlank;
    };
    /**
   * When axis extent depends on data and no data exists,
   * axis ticks should not be drawn, which is named 'blank'.
   *
   * @final NEVER override!
   */ Scale.prototype.setBlank = function(isBlank) {
        this._isBlank = isBlank;
    };
    return Scale;
}();
$10ce7a4361c3910c$export$241315e45585454d($852c4e3dd3bbc3b5$var$Scale);
var $852c4e3dd3bbc3b5$export$2e2bcd8739ae039 = $852c4e3dd3bbc3b5$var$Scale;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $4f43f0f1fd3f127f$var$uidBase = 0;
var $4f43f0f1fd3f127f$var$OrdinalMeta = /** @class */ function() {
    /**
   * PENDING - Regarding forcibly converting to string:
   *  In the early days, the underlying hash map impl used JS plain object and converted the key to
   *  string; later in https://github.com/ecomfe/zrender/pull/966 it was changed to a JS Map (in supported
   *  platforms), which does not require string keys. But consider any input that `scale/Ordinal['parse']`
   *  is involved, a number input represents an `OrdinalNumber` (i.e., an index), and affect the query
   *  behavior:
   *    - If forcbily converting to string:
   *      pros: users can use numeric string (such as, '123') to query the raw data (123), tho it's probably
   *      still confusing.
   *      cons: NaN/null/undefined in data will be equals to 'NaN'/'null'/'undefined', if simply using
   *      `val + ''` to convert them, like currently `getName` does.
   *    - Otherwise:
   *      pros: see NaN/null/undefined case above.
   *      cons: users cannot query the raw data (123) any more.
   *  There are two inconsistent behaviors in the current impl:
   *    - Force conversion is applied on the case `xAxis{data: ['aaa', 'bbb', ...]}`,
   *      but no conversion applied to the case `xAxis{data: [{value: 'aaa'}, ...]}` and
   *      the case `dataset: {source: [['aaa', 123], ['bbb', 234], ...]}`.
   *    - behaves differently according to whether JS Map is supported (the polyfill is simply using JS
   *      plain object) (tho it seems rare platform that do not support it).
   *  Since there's no sufficient good solution to offset cost of the breaking change, we preserve the
   *  current behavior, until real issues is reported.
   */ function OrdinalMeta(opt) {
        this.categories = opt.categories || [];
        this._needCollect = opt.needCollect;
        this._deduplication = opt.deduplication;
        this.uid = ++$4f43f0f1fd3f127f$var$uidBase;
        this._onCollect = opt.onCollect;
    }
    OrdinalMeta.createByAxisModel = function(axisModel) {
        var option = axisModel.option;
        var data = option.data;
        var categories = data && (0, $43e0a445ed6711da$export$871de8747c9eaa88)(data, $4f43f0f1fd3f127f$var$getName);
        return new OrdinalMeta({
            categories: categories,
            needCollect: !categories,
            // deduplication is default in axis.
            deduplication: option.dedplication !== false
        });
    };
    OrdinalMeta.prototype.getOrdinal = function(category) {
        return this._getOrCreateMap().get(category);
    };
    /**
   * @return The ordinal. If not found, return NaN.
   */ OrdinalMeta.prototype.parseAndCollect = function(category) {
        var index;
        var needCollect = this._needCollect;
        // The value of category dim can be the index of the given category set.
        // This feature is only supported when !needCollect, because we should
        // consider a common case: a value is 2017, which is a number but is
        // expected to be tread as a category. This case usually happen in dataset,
        // where it happent to be no need of the index feature.
        if (!(0, $43e0a445ed6711da$export$844ec244b1367d54)(category) && !needCollect) return category;
        // Optimize for the scenario:
        // category is ['2012-01-01', '2012-01-02', ...], where the input
        // data has been ensured not duplicate and is large data.
        // Notice, if a dataset dimension provide categroies, usually echarts
        // should remove duplication except user tell echarts dont do that
        // (set axis.deduplication = false), because echarts do not know whether
        // the values in the category dimension has duplication (consider the
        // parallel-aqi example)
        if (needCollect && !this._deduplication) {
            index = this.categories.length;
            this.categories[index] = category;
            this._onCollect && this._onCollect(category, index);
            return index;
        }
        var map = this._getOrCreateMap();
        index = map.get(category);
        if (index == null) {
            if (needCollect) {
                index = this.categories.length;
                this.categories[index] = category;
                map.set(category, index);
                this._onCollect && this._onCollect(category, index);
            } else index = NaN;
        }
        return index;
    };
    // Consider big data, do not create map until needed.
    OrdinalMeta.prototype._getOrCreateMap = function() {
        return this._map || (this._map = (0, $43e0a445ed6711da$export$55f8aa7ef875b0a4)(this.categories));
    };
    return OrdinalMeta;
}();
function $4f43f0f1fd3f127f$var$getName(obj) {
    if ((0, $43e0a445ed6711da$export$a6cdc56e425d0d0a)(obj) && obj.value != null) return obj.value;
    else return obj + "";
}
var $4f43f0f1fd3f127f$export$2e2bcd8739ae039 = $4f43f0f1fd3f127f$var$OrdinalMeta;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $3123530578a35744$export$c884056e529a2c7a = 0;
var $3123530578a35744$export$a9efb7aa6faff3f6 = 1;
var $3123530578a35744$var$SCALE_MAPPER_METHOD_NAMES_MAP = {
    needTransform: 1,
    normalize: 1,
    scale: 1,
    transformIn: 1,
    transformOut: 1,
    contain: 1,
    getExtent: 1,
    getExtentUnsafe: 1,
    setExtent: 1,
    setExtent2: 1,
    getFilter: 1,
    sanitize: 1,
    getDefaultStartValue: 1,
    freeze: 1
};
var $3123530578a35744$var$SCALE_MAPPER_METHOD_NAMES = (0, $43e0a445ed6711da$export$ed97f33186d4b816)($3123530578a35744$var$SCALE_MAPPER_METHOD_NAMES_MAP);
var $3123530578a35744$export$2734d952320c7be9 = 2;
var $3123530578a35744$export$64ac424f47d39348 = 3;
function $3123530578a35744$export$acfc4e2d986326b7(// If input `null/undefined`, a mapper will be created.
mapper, breakParsed, initialExtent) {
    var brk;
    mapper = mapper || {};
    var scaleBreakHelper = (0, $d760dd937396b887$export$e79b20ac82c2d660)();
    if (scaleBreakHelper) {
        var brkMapper_1 = scaleBreakHelper.createBreakScaleMapper(breakParsed, initialExtent);
        if (brkMapper_1.hasBreaks()) {
            // Some `ScaleMapper` methods (such as `normalize`) needs to be fast for large data
            // when no breaks, so mount break methods only when breaks really exist.
            (0, $43e0a445ed6711da$export$79b2f7037acddd43)($3123530578a35744$var$SCALE_MAPPER_METHOD_NAMES, function(methodName) {
                if (brkMapper_1[methodName]) mapper[methodName] = (0, $43e0a445ed6711da$export$2385a24977818dd0)(brkMapper_1[methodName], brkMapper_1);
            });
            brk = brkMapper_1;
        }
    }
    if (brk == null) $3123530578a35744$export$e394430c37f37688(mapper, initialExtent);
    return {
        brk: brk,
        mapper: mapper
    };
}
function $3123530578a35744$export$994b6d163a064f23(host, decoratedMapperMethods) {
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)($3123530578a35744$var$SCALE_MAPPER_METHOD_NAMES, function(methodName) {
        host[methodName] = decoratedMapperMethods[methodName];
    });
}
function $3123530578a35744$export$85c5c680f14cd13c(host, subMapper) {
    host.freeze = (0, $43e0a445ed6711da$export$8793edee2d425525);
}
function $3123530578a35744$export$87f6c9bc988c4378(mapper) {
    return mapper.getExtentUnsafe($3123530578a35744$export$c884056e529a2c7a, $3123530578a35744$export$2734d952320c7be9);
}
function $3123530578a35744$export$e182c528b7826102(mapper, // NullUndefined means the outermost space.
depth) {
    return mapper.getExtentUnsafe($3123530578a35744$export$a9efb7aa6faff3f6, depth) || mapper.getExtentUnsafe($3123530578a35744$export$c884056e529a2c7a, depth);
}
function $3123530578a35744$export$285c6793ade939bf(mapper) {
    var extent = $3123530578a35744$export$e182c528b7826102(mapper, $3123530578a35744$export$64ac424f47d39348);
    return extent[1] - extent[0];
}
function $3123530578a35744$export$9a49fe71267af794(mapper) {
    var extent = mapper.getExtentUnsafe($3123530578a35744$export$c884056e529a2c7a, $3123530578a35744$export$64ac424f47d39348);
    return extent[1] - extent[0];
}
function $3123530578a35744$export$e394430c37f37688(// If input `null/undefined`, a mapper will be created.
mapper, initialExtent) {
    var linearMapper = mapper || {};
    var extendList = [];
    // @ts-ignore
    linearMapper._extents = extendList;
    extendList[$3123530578a35744$export$c884056e529a2c7a] = initialExtent ? initialExtent.slice() : (0, $87f4a59ac66e0ee6$export$62e5f07ab009f3b)();
    (0, $43e0a445ed6711da$export$8b58be045bf06082)(linearMapper, $3123530578a35744$var$linearScaleMapperMethods);
    return linearMapper;
}
var $3123530578a35744$var$linearScaleMapperMethods = {
    needTransform: function() {
        return false;
    },
    normalize: function(val) {
        var extent = this._extents[$3123530578a35744$export$a9efb7aa6faff3f6] || this._extents[$3123530578a35744$export$c884056e529a2c7a];
        if (extent[1] === extent[0]) return 0.5;
        return (val - extent[0]) / (extent[1] - extent[0]);
    },
    scale: function(val) {
        var extent = this._extents[$3123530578a35744$export$a9efb7aa6faff3f6] || this._extents[$3123530578a35744$export$c884056e529a2c7a];
        return val * (extent[1] - extent[0]) + extent[0];
    },
    transformIn: function(val) {
        return val;
    },
    transformOut: function(val) {
        return val;
    },
    contain: function(val) {
        // This method is typically used in axis trigger and markers.
        // Users may be confused if the extent is restricted to `SCALE_EXTENT_KIND_EFFECTIVE`.
        var extent = $3123530578a35744$export$e182c528b7826102(this, null);
        return val >= extent[0] && val <= extent[1];
    },
    getExtent: function() {
        return this._extents[$3123530578a35744$export$c884056e529a2c7a].slice();
    },
    getExtentUnsafe: function(kind) {
        return this._extents[kind];
    },
    setExtent: function(start, end) {
        $3123530578a35744$var$writeExtent(this._extents, $3123530578a35744$export$c884056e529a2c7a, start, end);
    },
    setExtent2: function(kind, start, end) {
        var extentList = this._extents;
        if (!extentList[kind]) extentList[kind] = extentList[$3123530578a35744$export$c884056e529a2c7a].slice();
        $3123530578a35744$var$writeExtent(extentList, kind, start, end);
    },
    freeze: function() {}
};
function $3123530578a35744$var$writeExtent(extentList, kind, start, end) {
    // NOTE: `NaN` should be excluded. e.g., `scaleRawExtentInfo.resultMinMax` may be `[NaN, NaN]`.
    if ((0, $87f4a59ac66e0ee6$export$d386653f29930adb)(start, end)) {
        extentList[kind][0] = start;
        extentList[kind][1] = end;
    }
} // ------ END: Linear Scale Mapper ------


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $eb97010bfdf4c825$export$dfc8cd28ed7b22a0(scale) {
    return $eb97010bfdf4c825$export$ba0fcad386c5c7e6(scale) || $eb97010bfdf4c825$export$8b1d8a59aa13c502(scale);
}
function $eb97010bfdf4c825$export$cd3b833884a8d62c(scale) {
    return $eb97010bfdf4c825$export$ba0fcad386c5c7e6(scale) || $eb97010bfdf4c825$export$c9b71a3750db342f(scale);
}
function $eb97010bfdf4c825$export$ba0fcad386c5c7e6(scale) {
    return scale.type === "interval";
}
function $eb97010bfdf4c825$export$c9b71a3750db342f(scale) {
    return scale.type === "time";
}
function $eb97010bfdf4c825$export$8b1d8a59aa13c502(scale) {
    return scale.type === "log";
}
function $eb97010bfdf4c825$export$61579433626afe87(scale) {
    return scale.type === "ordinal";
}
function $eb97010bfdf4c825$export$eeea879a611eb991(extent, spanWithBreaks, splitNumber, minInterval, maxInterval) {
    var result = {};
    var interval = result.interval = (0, $b49750109e236fd8$export$7a695fe44258210b)(spanWithBreaks / splitNumber, true);
    if (minInterval != null && interval < minInterval) interval = result.interval = minInterval;
    if (maxInterval != null && interval > maxInterval) interval = result.interval = maxInterval;
    var precision = result.intervalPrecision = $eb97010bfdf4c825$export$86a060b060d3d31a(interval);
    // Niced extent inside original extent
    result.niceTickExtent = [
        (0, $b49750109e236fd8$export$2077e0241d6afd3c)((0, $b49750109e236fd8$export$cf129980c996e186)(extent[0] / interval) * interval, precision),
        (0, $b49750109e236fd8$export$2077e0241d6afd3c)((0, $b49750109e236fd8$export$c6301bc99a7f80a7)(extent[1] / interval) * interval, precision)
    ];
    return result;
}
function $eb97010bfdf4c825$export$f39031e8422f329d(niceInterval) {
    var exponent = (0, $b49750109e236fd8$export$97256a17b20a0c24)(niceInterval);
    // No rounding error in Math.pow(10, integer).
    var exp10 = (0, $b49750109e236fd8$export$858b42c97efc7084)(10, exponent);
    // Fix IEEE 754 float rounding error
    var f = (0, $b49750109e236fd8$export$42cacde8c45786ff)(niceInterval / exp10);
    if (!f) f = 1;
    else if (f === 2) f = 3;
    else if (f === 3) f = 5;
    else // f is 1 or 5
    f *= 2;
    // Fix IEEE 754 float rounding error
    return (0, $b49750109e236fd8$export$2077e0241d6afd3c)(f * exp10, -exponent);
}
function $eb97010bfdf4c825$export$86a060b060d3d31a(niceInterval) {
    // Tow more digital for tick.
    // NOTE: `2` was introduced in commit `af2a2a9f6303081d7c3b52f0a38add07b4c6e0c7`;
    // it works on "nice" interval, but seems not necessarily mathematically required.
    return (0, $b49750109e236fd8$export$e0c74b50bbd10f68)(niceInterval) + 2;
}
function $eb97010bfdf4c825$export$7854dd225b5d5704(val, base) {
    // NOTE:
    //  - rounding error may happen above, typically expecting `log10(1000)` but actually
    //    getting `2.9999999999999996`, but generally it does not matter since they are not
    //    used to display.
    //  - Consider backward compatibility and other log bases, do not use `Math.log10`.
    return (0, $b49750109e236fd8$export$f0e980411e05f912)(val) / (0, $b49750109e236fd8$export$f0e980411e05f912)(base);
}
function $eb97010bfdf4c825$export$73e21863d9c0dcd3(// `tickVal` should be in the linear space.
linearTickVal, base, opt) {
    var lookup = opt && opt.lookup;
    if (lookup) for(var i = 0; i < lookup.from.length; i++){
        if (linearTickVal === lookup.from[i]) return lookup.to[i];
    }
    return (0, $b49750109e236fd8$export$858b42c97efc7084)(base, linearTickVal);
}
function $eb97010bfdf4c825$export$e279d7ed1695209d(rawExtent, fixMinMax, rawExtentResult) {
    var extent = rawExtent.slice();
    // PENDING:
    //  This implementation is not rigorous, but has long been in use.
    // If extent start and end are same, expand them
    if (extent[0] === extent[1]) {
        // If `containShape`, the extent must be evenly distributed to both sides;
        // otherwise, shape (e.g., bars) may be overflow and clipped.
        var containShapeRequired = rawExtentResult && rawExtentResult.ctnShp;
        if (extent[0] !== 0) {
            // Expand extent
            // Note that extents can be both negative. See #13154
            var expandSize = (0, $b49750109e236fd8$export$5860c226b237d9a6)(extent[0]);
            // In the fowllowing case
            //      Axis has been fixed max 100
            //      Plus data are all 100 and axis extent are [100, 100].
            // Extend to the both side will cause expanded max is larger than fixed max.
            // So only expand to the smaller side.
            if (!fixMinMax[1]) {
                extent[1] += expandSize / 2;
                extent[0] -= expandSize / 2;
            } else extent[0] -= expandSize / 2;
        } else if (containShapeRequired) {
            extent[0] = -1;
            extent[1] = 1;
        } else extent[1] = 1;
    }
    // For example, if there are no series data, extent may be `[Infinity, -Infinity]` here.
    if (!(0, $87f4a59ac66e0ee6$export$5af06089290883e2)(extent[0]) || !(0, $87f4a59ac66e0ee6$export$5af06089290883e2)(extent[1])) {
        extent[0] = 0;
        extent[1] = 1;
    }
    if (extent[1] < extent[0]) extent.reverse();
    return extent;
}
function $eb97010bfdf4c825$export$2b240c817ac5c4f(extent1, extent2) {
    return [
        extent1[0] !== extent2[0],
        extent1[1] !== extent2[1]
    ];
}
function $eb97010bfdf4c825$export$b801ba4e5ad70a4a(rawSplitNumber, defaultSplitNumber) {
    rawSplitNumber = rawSplitNumber || defaultSplitNumber;
    return (0, $b49750109e236fd8$export$42cacde8c45786ff)((0, $b49750109e236fd8$export$2ca8010d037f830f)(rawSplitNumber, 1));
}
function $eb97010bfdf4c825$export$1039c7e66c46a7fd(ordinalScale, // `categoryInterval` is the number part of `CategoryTickLabelSplitIntervalOption`.
categoryInterval, addItem) {
    var extent = (0, $3123530578a35744$export$87f6c9bc988c4378)(ordinalScale);
    var startTick = extent[0];
    var tickCount = ordinalScale.count();
    var step = Math.max((categoryInterval || 0) + 1, 1);
    // Calculate start tick based on zero if possible to keep label consistent
    // while zooming and moving while interval > 0. Otherwise the selection
    // of displayable ticks and symbols probably keep changing.
    if (startTick !== 0 && step > 1 && tickCount / step > 2) startTick = Math.round(Math.ceil(startTick / step) * step);
    // min max labels may be excluded if `startTick > 0`, but they should be always
    // included and the label display strategy is adopted uniformly later in `AxisBuilder`.
    if (startTick !== extent[0]) addItemInternally(extent[0], true, true);
    var tickValue = startTick;
    for(; tickValue <= extent[1]; tickValue += step)addItemInternally(tickValue, false, tickValue === extent[0] || tickValue === extent[1]);
    if (tickValue - step !== extent[1]) addItemInternally(extent[1], true, true);
    function addItemInternally(tickValue, offInterval, isExtentBoundary) {
        addItem({
            value: tickValue,
            offInterval: offInterval
        }, isExtentBoundary);
    }
}


var $766cffcc080fa7a9$var$OrdinalScale = /** @class */ function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(OrdinalScale, _super);
    function OrdinalScale(setting) {
        var _this = _super.call(this) || this;
        _this.type = "ordinal";
        _this.parse = OrdinalScale.parse;
        (0, $3123530578a35744$export$994b6d163a064f23)(_this, OrdinalScale.decoratedMethods);
        var ordinalMeta = setting.ordinalMeta;
        // Caution: Should not use instanceof, consider ec-extensions using
        // import approach to get OrdinalMeta class.
        if (!ordinalMeta) ordinalMeta = new (0, $4f43f0f1fd3f127f$export$2e2bcd8739ae039)({});
        if ((0, $43e0a445ed6711da$export$43bee75e5e14138e)(ordinalMeta)) ordinalMeta = new (0, $4f43f0f1fd3f127f$export$2e2bcd8739ae039)({
            categories: (0, $43e0a445ed6711da$export$871de8747c9eaa88)(ordinalMeta, function(item) {
                return (0, $43e0a445ed6711da$export$a6cdc56e425d0d0a)(item) ? item.value : item;
            })
        });
        _this._ordinalMeta = ordinalMeta;
        // Create an interval LinearScaleMapper, and decorate it.
        var res = (0, $3123530578a35744$export$acfc4e2d986326b7)(null, null, // Do not support break in OrdinalScale yet.
        setting.extent || [
            0,
            ordinalMeta.categories.length - 1
        ]);
        _this._mapper = res.mapper;
        (0, $3123530578a35744$export$85c5c680f14cd13c)(_this, res.mapper);
        return _this;
    }
    OrdinalScale.parse = function(val) {
        // Caution: Math.round(null) will return `0` rather than `NaN`
        if (val == null) val = NaN;
        else if ((0, $43e0a445ed6711da$export$844ec244b1367d54)(val)) {
            val = this._ordinalMeta.getOrdinal(val);
            if (val == null) val = NaN;
        } else // The val from user input might be float.
        val = (0, $b49750109e236fd8$export$42cacde8c45786ff)(val);
        return val;
    };
    /**
   * PENDING: currently this method is not used.
   * `makeCategoryTicks` is effectively used.
   */ OrdinalScale.prototype.getTicks = function() {
        var ticks = [];
        (0, $eb97010bfdf4c825$export$1039c7e66c46a7fd)(this, 0, function(tick) {
            ticks.push(tick);
        });
        return ticks;
    };
    OrdinalScale.prototype.getMinorTicks = function(splitNumber) {
        // Not support.
        return;
    };
    /**
   * @see `Ordinal['_ordinalNumbersByTick']`
   */ OrdinalScale.prototype.setSortInfo = function(info) {
        if (info == null) {
            this._ordinalNumbersByTick = this._ticksByOrdinalNumber = null;
            return;
        }
        var infoOrdinalNumbers = info.ordinalNumbers;
        var ordinalsByTick = this._ordinalNumbersByTick = [];
        var ticksByOrdinal = this._ticksByOrdinalNumber = [];
        // Unnecessary support negative tick in `realtimeSort`.
        var tickNum = 0;
        var allCategoryLen = this._ordinalMeta.categories.length;
        for(var len = (0, $b49750109e236fd8$export$e411eeaf23dccbe8)(allCategoryLen, infoOrdinalNumbers.length); tickNum < len; ++tickNum){
            var ordinalNumber = ordinalsByTick[tickNum] = infoOrdinalNumbers[tickNum];
            ticksByOrdinal[ordinalNumber] = tickNum;
        }
        // Handle that `series.data` only covers part of the `axis.category.data`.
        var unusedOrdinal = 0;
        for(; tickNum < allCategoryLen; ++tickNum){
            while(ticksByOrdinal[unusedOrdinal] != null)unusedOrdinal++;
            ordinalsByTick[tickNum] = unusedOrdinal;
            ticksByOrdinal[unusedOrdinal] = tickNum;
        }
    };
    OrdinalScale.prototype._getTickNumber = function(ordinal) {
        var ticksByOrdinalNumber = this._ticksByOrdinalNumber;
        // also support ordinal out of range of `ordinalMeta.categories.length`,
        // where ordinal numbers are used as tick value directly.
        return ticksByOrdinalNumber && ordinal >= 0 && ordinal < ticksByOrdinalNumber.length ? ticksByOrdinalNumber[ordinal] : ordinal;
    };
    /**
   * @usage
   * ```js
   * const ordinalNumber = ordinalScale.getRawOrdinalNumber(tick.value);
   * // case0
   * const rawOrdinalValue = axisModel.getCategories()[ordinalNumber];
   * // case1
   * const rawOrdinalValue = this._ordinalMeta.categories[ordinalNumber];
   * // case2
   * const coord = axis.dataToCoord(ordinalNumber);
   * ```
   *
   * value may be out of range, e.g., when axis max is larger than `ordinalMeta.categories.length`,
   * where ordinal numbers are used as tick value directly.
   */ OrdinalScale.prototype.getRawOrdinalNumber = function(tickValue) {
        var ordinalNumbersByTick = this._ordinalNumbersByTick;
        return ordinalNumbersByTick && tickValue >= 0 && tickValue < ordinalNumbersByTick.length ? ordinalNumbersByTick[tickValue] : tickValue;
    };
    /**
   * Get item on tick
   */ OrdinalScale.prototype.getLabel = function(tick) {
        if (!this.isBlank()) {
            var ordinalNumber = this.getRawOrdinalNumber(tick.value);
            var category = this._ordinalMeta.categories[ordinalNumber];
            // Note that if no data, ordinalMeta.categories is an empty array.
            // Return empty if it's not exist.
            return category == null ? "" : category + "";
        }
    };
    /**
   * NOTICE: This is different from `.getOrdinalMeta().length` when extent
   * is specified by `xxxAxis.min/max` or by `dataZoom`.
   */ OrdinalScale.prototype.count = function() {
        var extent = (0, $3123530578a35744$export$87f6c9bc988c4378)(this._mapper);
        return extent[1] - extent[0] + 1;
    };
    OrdinalScale.prototype.getOrdinalMeta = function() {
        return this._ordinalMeta;
    };
    OrdinalScale.type = "ordinal";
    OrdinalScale.decoratedMethods = {
        needTransform: function() {
            return this._mapper.needTransform();
        },
        contain: function(val) {
            return this._mapper.contain(this._getTickNumber(val)) && val >= 0 && val < this._ordinalMeta.categories.length;
        },
        normalize: function(val) {
            return this._mapper.normalize(this._getTickNumber(val));
        },
        scale: function(val) {
            return this.getRawOrdinalNumber((0, $b49750109e236fd8$export$42cacde8c45786ff)(this._mapper.scale(val)));
        },
        transformIn: function(val, opt) {
            return this._mapper.transformIn(this._getTickNumber(val), opt);
        },
        transformOut: function(val, opt) {
            return this.getRawOrdinalNumber(this._mapper.transformOut(val, opt));
        },
        getExtent: function() {
            return this._mapper.getExtent();
        },
        getExtentUnsafe: function(kind, depth) {
            return this._mapper.getExtentUnsafe(kind, depth);
        },
        /**
     * NOTICE: OrdinalScale extent should always originates from
     * `[0, ordinalMeta.categories.length - 1]`, regardless of min/max of `series.data`.
     * But settings like `xxxAxis.min/max` can still modify the extent.
     * It is handled by constructor of `ScaleRawExtentInfo`.
     */ setExtent: function(start, end) {
            return this._mapper.setExtent(start, end);
        },
        setExtent2: function(kind, start, end) {
            return this._mapper.setExtent2(kind, start, end);
        }
    };
    return OrdinalScale;
}((0, $852c4e3dd3bbc3b5$export$2e2bcd8739ae039));
(0, $852c4e3dd3bbc3b5$export$2e2bcd8739ae039).registerClass($766cffcc080fa7a9$var$OrdinalScale);
var $766cffcc080fa7a9$export$2e2bcd8739ae039 = $766cffcc080fa7a9$var$OrdinalScale;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $2911692621c6e6e0$export$e2d43952c5db22bb(scale, splitNumber, breaks, scaleInterval) {
    var ticks = scale.getTicks({
        expandToNicedExtent: true
    });
    // NOTE: In log-scale, do not support minor ticks when breaks exist.
    //  because currently log-scale minor ticks is calculated based on raw values
    //  rather than log-transformed value, due to an odd effect when breaks exist.
    var minorTicks = [];
    var extent = scale.getExtent();
    for(var i = 1; i < ticks.length; i++){
        var nextTick = ticks[i];
        var prevTick = ticks[i - 1];
        if (prevTick["break"] || nextTick["break"]) continue;
        var count = 0;
        var minorTicksGroup = [];
        var interval = nextTick.value - prevTick.value;
        var minorInterval = interval / splitNumber;
        var minorIntervalPrecision = (0, $eb97010bfdf4c825$export$86a060b060d3d31a)(minorInterval);
        while(count < splitNumber - 1){
            var minorTick = (0, $b49750109e236fd8$export$2077e0241d6afd3c)(prevTick.value + (count + 1) * minorInterval, minorIntervalPrecision);
            // For the first and last interval. The count may be less than splitNumber.
            if (minorTick > extent[0] && minorTick < extent[1]) minorTicksGroup.push(minorTick);
            count++;
        }
        var scaleBreakHelper = (0, $d760dd937396b887$export$e79b20ac82c2d660)();
        scaleBreakHelper && scaleBreakHelper.pruneTicksByBreak("auto", minorTicksGroup, breaks, function(value) {
            return value;
        }, scaleInterval, extent);
        minorTicks.push(minorTicksGroup);
    }
    return minorTicks;
}




var $ae03431da7737467$var$IntervalScale = /** @class */ function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(IntervalScale, _super);
    function IntervalScale(setting) {
        var _this = _super.call(this) || this;
        _this.type = "interval";
        _this.parse = IntervalScale.parse;
        setting = setting || {};
        var breakParsed = (0, $d760dd937396b887$export$770ec3eb53b5689b)(_this, setting);
        var res = (0, $3123530578a35744$export$acfc4e2d986326b7)(_this, breakParsed, null);
        // @ts-ignore
        _this.brk = res.brk;
        _this._cfg = {
            interval: 0,
            intervalPrecision: 2,
            intervalCount: undefined,
            niceExtent: undefined
        };
        return _this;
    }
    IntervalScale.parse = function(val) {
        // `Scale#parse` (and its overrids) are typically applied at the axis values input
        // in echarts option. e.g., `axis.min/max`, `dataZoom.min/max`, etc.
        // but `series.data` is not included, which uses `dataValueHelper.ts`#`parseDataValue`.
        // `Scale#parse` originally introduced in fb8c813215098b9d2458966229bb95c510883d5e
        // at 2016 for dataZoom start/end settings (See `parseAxisModelMinMax`).
        //
        // Historically `scale/Interval.ts` returns the input value directly. But numeric
        // values (such as a number-like string '123') effectively passed through here and
        // were involved in calculations, which was error-prone and inconsistent with the
        // declared TS return type. Previously such issues are fixed separately in different
        // places case by case (such as #2475).
        //
        // Now, we perform actual parse to ensure its `number` type here. The parsing rule
        // follows the series data parsing rule (`dataValueHelper.ts`#`parseDataValue`)
        // and maintains compatibility as much as possible (thus a more strict parsing
        // `number.ts`#`numericToNumber` is not used here.)
        //
        // FIXME: `ScaleDataValue` also need to be modified to include numeric string type,
        //  since it effectively does.
        return val == null || val === "" ? NaN : Number(val);
    };
    IntervalScale.prototype.getConfig = function() {
        return (0, $43e0a445ed6711da$export$9cd59f9826255e47)(this._cfg);
    };
    IntervalScale.prototype.setConfig = function(cfg) {
        var extent = (0, $3123530578a35744$export$87f6c9bc988c4378)(this);
        // Reset all.
        this._cfg = cfg = (0, $43e0a445ed6711da$export$9cd59f9826255e47)(cfg);
        if (cfg.niceExtent == null) // Dropped the auto calculated niceExtent and use user-set extent.
        // We assume users want to set both interval and extent to get a better result.
        cfg.niceExtent = extent.slice();
        if (cfg.intervalPrecision == null) cfg.intervalPrecision = (0, $eb97010bfdf4c825$export$86a060b060d3d31a)(cfg.interval);
    };
    /**
   * In ascending order.
   */ IntervalScale.prototype.getTicks = function(opt) {
        opt = opt || {};
        var cfg = this._cfg;
        var interval = cfg.interval;
        var extent = (0, $3123530578a35744$export$87f6c9bc988c4378)(this);
        var niceExtent = cfg.niceExtent;
        var intervalPrecision = cfg.intervalPrecision;
        var scaleBreakHelper = (0, $d760dd937396b887$export$e79b20ac82c2d660)();
        var brk = this.brk;
        var brkAvailable = scaleBreakHelper && brk;
        var ticks = [];
        // If interval is 0, return [];
        if (!interval) return ticks;
        if (opt.breakTicks === "only_break" && brkAvailable) {
            scaleBreakHelper.addBreaksToTicks(ticks, brk.breaks, extent);
            return ticks;
        }
        // [CAVEAT]: If changing this logic, must sync it to `axisAlignTicks.ts`.
        // A fail-safe is required since `interval` can be user specified, or for the case
        // that using dataZoom toolbox and zoom repeatedly.
        var safeLimit = 3000;
        if (extent[0] < niceExtent[0]) ticks.push({
            value: opt.expandToNicedExtent ? (0, $b49750109e236fd8$export$2077e0241d6afd3c)(niceExtent[0] - interval, intervalPrecision) : extent[0]
        });
        var estimateNiceMultiple = function(tickVal, targetTick) {
            return (0, $b49750109e236fd8$export$42cacde8c45786ff)((targetTick - tickVal) / interval);
        };
        var intervalCount = cfg.intervalCount;
        for(var tick = niceExtent[0], niceTickIdx = 0;; niceTickIdx++){
            // Consider case `_extent: [5.2, 5.8], _niceExtent: [6, 5], interval: 1`,
            //  `_intervalCount` makes sense iff `-1`.
            // Consider case `_extent: [5, 5.8], _niceExtent: [5, 5], interval: 1`,
            //  `_intervalCount` makes sense iff `0`.
            if (intervalCount == null) {
                if (tick > niceExtent[1] || !isFinite(tick) || !isFinite(niceExtent[1])) break;
            } else {
                if (niceTickIdx > intervalCount) break;
                // Consider cumulative error, especially caused by rounding, the last nice
                // `tick` may be less than or greater than `niceExtent[1]` slightly.
                tick = (0, $b49750109e236fd8$export$e411eeaf23dccbe8)(tick, niceExtent[1]);
                if (niceTickIdx === intervalCount) tick = niceExtent[1];
            }
            ticks.push({
                value: tick
            });
            // Avoid rounding error
            tick = (0, $b49750109e236fd8$export$2077e0241d6afd3c)(tick + interval, intervalPrecision);
            if (brk) {
                var moreMultiple = brk.calcNiceTickMultiple(tick, estimateNiceMultiple);
                if (moreMultiple >= 0) tick = (0, $b49750109e236fd8$export$2077e0241d6afd3c)(tick + moreMultiple * interval, intervalPrecision);
            }
            if (ticks.length > 0 && tick === ticks[ticks.length - 1].value) break;
            if (ticks.length > safeLimit) return [];
        }
        // Consider this case: the last item of ticks is smaller
        // than niceExtent[1] and niceExtent[1] === extent[1].
        var lastNiceTick = ticks.length ? ticks[ticks.length - 1].value : niceExtent[1];
        if (extent[1] > lastNiceTick) ticks.push({
            value: opt.expandToNicedExtent ? (0, $b49750109e236fd8$export$2077e0241d6afd3c)(lastNiceTick + interval, intervalPrecision) : extent[1]
        });
        if (brkAvailable) scaleBreakHelper.pruneTicksByBreak(opt.pruneByBreak, ticks, brk.breaks, function(item) {
            return item.value;
        }, cfg.interval, extent);
        if (brkAvailable && opt.breakTicks !== "none") scaleBreakHelper.addBreaksToTicks(ticks, brk.breaks, extent);
        return ticks;
    };
    IntervalScale.prototype.getMinorTicks = function(splitNumber) {
        return (0, $2911692621c6e6e0$export$e2d43952c5db22bb)(this, splitNumber, (0, $d760dd937396b887$export$20734ee5f1d5720f)(this), this._cfg.interval);
    };
    IntervalScale.prototype.getLabel = function(tick, opt) {
        if (tick == null) return "";
        var precision = opt && opt.precision;
        if (precision == null) precision = (0, $b49750109e236fd8$export$e0c74b50bbd10f68)(tick.value) || 0;
        else if (precision === "auto") // Should be more precise then tick.
        precision = this._cfg.intervalPrecision;
        // (1) If `precision` is set, 12.005 should be display as '12.00500'.
        // (2) Use `round` (toFixed) to avoid scientific notation like '3.5e-7'.
        var dataNum = (0, $b49750109e236fd8$export$2077e0241d6afd3c)(tick.value, precision, true);
        return (0, $78c2ece6dfa6bb7a$export$b6fe44657ce35c42)(dataNum);
    };
    IntervalScale.type = "interval";
    return IntervalScale;
}((0, $852c4e3dd3bbc3b5$export$2e2bcd8739ae039));
(0, $852c4e3dd3bbc3b5$export$2e2bcd8739ae039).registerClass($ae03431da7737467$var$IntervalScale);
var $ae03431da7737467$export$2e2bcd8739ae039 = $ae03431da7737467$var$IntervalScale;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 










// FIXME 公用？
var $ed3599ac91c48f4a$var$bisect = function(a, x, lo, hi) {
    while(lo < hi){
        var mid = lo + hi >>> 1;
        if (a[mid][1] < x) lo = mid + 1;
        else hi = mid;
    }
    return lo;
};
var $ed3599ac91c48f4a$var$TimeScale = /** @class */ function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(TimeScale, _super);
    function TimeScale(setting) {
        var _this = _super.call(this) || this;
        _this.type = "time";
        _this.parse = TimeScale.parse;
        _this._locale = setting.locale;
        _this._useUTC = setting.useUTC;
        _this._interval = 0;
        var breakParsed = (0, $d760dd937396b887$export$770ec3eb53b5689b)(_this, setting);
        var res = (0, $3123530578a35744$export$acfc4e2d986326b7)(_this, breakParsed, null);
        // @ts-ignore
        _this.brk = res.brk;
        return _this;
    }
    /**
   * Get label is mainly for other components like dataZoom, tooltip.
   */ TimeScale.prototype.getLabel = function(tick) {
        return (0, $d28d71d6b904c104$export$d9468344d3651243)(tick.value, (0, $d28d71d6b904c104$export$445bdbd8d2334e40)[(0, $d28d71d6b904c104$export$124c820721c4f66b)((0, $d28d71d6b904c104$export$1da4b91a25d7e1c8)(this._minLevelUnit))] || (0, $d28d71d6b904c104$export$445bdbd8d2334e40).second, this._useUTC, this._locale);
    };
    TimeScale.prototype.getFormattedLabel = function(tick, idx, labelFormatter) {
        return (0, $d28d71d6b904c104$export$fe777b6293828b5d)(tick, idx, labelFormatter, this._locale, this._useUTC);
    };
    TimeScale.prototype.getTicks = function(opt) {
        opt = opt || {};
        var interval = this._interval;
        var extent = (0, $3123530578a35744$export$87f6c9bc988c4378)(this);
        var scaleBreakHelper = (0, $d760dd937396b887$export$e79b20ac82c2d660)();
        var brk = this.brk;
        var brkAvailable = scaleBreakHelper && brk;
        var ticks = [];
        // If interval is 0, return [];
        if (!interval) return ticks;
        var useUTC = this._useUTC;
        if (brkAvailable && opt.breakTicks === "only_break") {
            (0, $d760dd937396b887$export$e79b20ac82c2d660)().addBreaksToTicks(ticks, brk.breaks, extent);
            return ticks;
        }
        ticks = $ed3599ac91c48f4a$var$createIntervalTicks(this._minLevelUnit, this._approxInterval, useUTC, extent, (0, $3123530578a35744$export$9a49fe71267af794)(this), brk);
        var upperUnitIndex = (0, $d28d71d6b904c104$export$87100da04d711986).length - 1;
        var maxLevel = 0;
        (0, $43e0a445ed6711da$export$79b2f7037acddd43)(ticks, function(tick) {
            if (tick.time) {
                upperUnitIndex = Math.min(upperUnitIndex, (0, $43e0a445ed6711da$export$305f7d4e9d4624f2)((0, $d28d71d6b904c104$export$87100da04d711986), tick.time.upperTimeUnit));
                maxLevel = Math.max(maxLevel, tick.time.level);
            }
        });
        if (brkAvailable) (0, $d760dd937396b887$export$e79b20ac82c2d660)().pruneTicksByBreak(opt.pruneByBreak, ticks, brk.breaks, function(item) {
            return item.value;
        }, this._approxInterval, extent);
        if (brkAvailable && opt.breakTicks !== "none") (0, $d760dd937396b887$export$e79b20ac82c2d660)().addBreaksToTicks(ticks, brk.breaks, extent, function(trimmedBrk) {
            // @see `parseTimeAxisLabelFormatterDictionary`.
            var lowerBrkUnitIndex = Math.max((0, $43e0a445ed6711da$export$305f7d4e9d4624f2)((0, $d28d71d6b904c104$export$87100da04d711986), (0, $d28d71d6b904c104$export$4dfb0417ad6555b7)(trimmedBrk.vmin, useUTC)), (0, $43e0a445ed6711da$export$305f7d4e9d4624f2)((0, $d28d71d6b904c104$export$87100da04d711986), (0, $d28d71d6b904c104$export$4dfb0417ad6555b7)(trimmedBrk.vmax, useUTC)));
            var upperBrkUnitIndex = 0;
            for(var unitIdx = 0; unitIdx < (0, $d28d71d6b904c104$export$87100da04d711986).length; unitIdx++)if (!$ed3599ac91c48f4a$var$isPrimaryUnitValueAndGreaterSame((0, $d28d71d6b904c104$export$87100da04d711986)[unitIdx], trimmedBrk.vmin, trimmedBrk.vmax, useUTC)) {
                upperBrkUnitIndex = unitIdx;
                break;
            }
            var upperIdx = Math.min(upperBrkUnitIndex, upperUnitIndex);
            var lowerIdx = Math.max(upperIdx, lowerBrkUnitIndex);
            return {
                level: maxLevel,
                lowerTimeUnit: (0, $d28d71d6b904c104$export$87100da04d711986)[lowerIdx],
                upperTimeUnit: (0, $d28d71d6b904c104$export$87100da04d711986)[upperIdx]
            };
        });
        return ticks;
    };
    TimeScale.prototype.getMinorTicks = function(splitNumber) {
        return (0, $2911692621c6e6e0$export$e2d43952c5db22bb)(this, splitNumber, (0, $d760dd937396b887$export$20734ee5f1d5720f)(this), this._interval);
    };
    TimeScale.prototype.setTimeInterval = function(opt) {
        this._interval = opt.interval;
        this._approxInterval = opt.approxInterval;
        this._minLevelUnit = opt.minLevelUnit;
    };
    TimeScale.parse = function(val) {
        // `val` might be a float (e.g., calculated from percent), so call `round`.
        return (0, $43e0a445ed6711da$export$7e4aa119212bc614)(val) ? Math.round(val) : +$b49750109e236fd8$export$6b862160d295c8e(val);
    };
    TimeScale.type = "time";
    return TimeScale;
}((0, $852c4e3dd3bbc3b5$export$2e2bcd8739ae039));
/**
 * This implementation was originally copied from "d3.js"
 * <https://github.com/d3/d3/blob/b516d77fb8566b576088e73410437494717ada26/src/time/scale.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 */ var $ed3599ac91c48f4a$var$scaleIntervals = [
    // Format                           interval
    [
        "second",
        (0, $d28d71d6b904c104$export$32c0454ceff7f92d)
    ],
    [
        "minute",
        (0, $d28d71d6b904c104$export$35acaebf644db34e)
    ],
    [
        "hour",
        (0, $d28d71d6b904c104$export$82541edf19e5e3b0)
    ],
    [
        "quarter-day",
        (0, $d28d71d6b904c104$export$82541edf19e5e3b0) * 6
    ],
    [
        "half-day",
        (0, $d28d71d6b904c104$export$82541edf19e5e3b0) * 12
    ],
    [
        "day",
        (0, $d28d71d6b904c104$export$a97a1358cbb650ab) * 1.2
    ],
    [
        "half-week",
        (0, $d28d71d6b904c104$export$a97a1358cbb650ab) * 3.5
    ],
    [
        "week",
        (0, $d28d71d6b904c104$export$a97a1358cbb650ab) * 7
    ],
    [
        "month",
        (0, $d28d71d6b904c104$export$a97a1358cbb650ab) * 31
    ],
    [
        "quarter",
        (0, $d28d71d6b904c104$export$a97a1358cbb650ab) * 95
    ],
    [
        "half-year",
        (0, $d28d71d6b904c104$export$99cafda57477293d) / 2
    ],
    [
        "year",
        (0, $d28d71d6b904c104$export$99cafda57477293d)
    ] // 1Y
];
function $ed3599ac91c48f4a$var$isPrimaryUnitValueAndGreaterSame(unit, valueA, valueB, isUTC) {
    return (0, $d28d71d6b904c104$export$2ed3384313b02c28)(new Date(valueA), unit, isUTC).getTime() === (0, $d28d71d6b904c104$export$2ed3384313b02c28)(new Date(valueB), unit, isUTC).getTime();
}
// function isUnitValueSame(
//     unit: PrimaryTimeUnit,
//     valueA: number,
//     valueB: number,
//     isUTC: boolean
// ): boolean {
//     const dateA = numberUtil.parseDate(valueA) as any;
//     const dateB = numberUtil.parseDate(valueB) as any;
//     const isSame = (unit: PrimaryTimeUnit) => {
//         return getUnitValue(dateA, unit, isUTC)
//             === getUnitValue(dateB, unit, isUTC);
//     };
//     const isSameYear = () => isSame('year');
//     // const isSameHalfYear = () => isSameYear() && isSame('half-year');
//     // const isSameQuater = () => isSameYear() && isSame('quarter');
//     const isSameMonth = () => isSameYear() && isSame('month');
//     const isSameDay = () => isSameMonth() && isSame('day');
//     // const isSameHalfDay = () => isSameDay() && isSame('half-day');
//     const isSameHour = () => isSameDay() && isSame('hour');
//     const isSameMinute = () => isSameHour() && isSame('minute');
//     const isSameSecond = () => isSameMinute() && isSame('second');
//     const isSameMilliSecond = () => isSameSecond() && isSame('millisecond');
//     switch (unit) {
//         case 'year':
//             return isSameYear();
//         case 'month':
//             return isSameMonth();
//         case 'day':
//             return isSameDay();
//         case 'hour':
//             return isSameHour();
//         case 'minute':
//             return isSameMinute();
//         case 'second':
//             return isSameSecond();
//         case 'millisecond':
//             return isSameMilliSecond();
//     }
// }
// const primaryUnitGetters = {
//     year: fullYearGetterName(),
//     month: monthGetterName(),
//     day: dateGetterName(),
//     hour: hoursGetterName(),
//     minute: minutesGetterName(),
//     second: secondsGetterName(),
//     millisecond: millisecondsGetterName()
// };
// const primaryUnitUTCGetters = {
//     year: fullYearGetterName(true),
//     month: monthGetterName(true),
//     day: dateGetterName(true),
//     hour: hoursGetterName(true),
//     minute: minutesGetterName(true),
//     second: secondsGetterName(true),
//     millisecond: millisecondsGetterName(true)
// };
// function moveTick(date: Date, unitName: TimeUnit, step: number, isUTC: boolean) {
//     step = step || 1;
//     switch (getPrimaryTimeUnit(unitName)) {
//         case 'year':
//             date[fullYearSetterName(isUTC)](date[fullYearGetterName(isUTC)]() + step);
//             break;
//         case 'month':
//             date[monthSetterName(isUTC)](date[monthGetterName(isUTC)]() + step);
//             break;
//         case 'day':
//             date[dateSetterName(isUTC)](date[dateGetterName(isUTC)]() + step);
//             break;
//         case 'hour':
//             date[hoursSetterName(isUTC)](date[hoursGetterName(isUTC)]() + step);
//             break;
//         case 'minute':
//             date[minutesSetterName(isUTC)](date[minutesGetterName(isUTC)]() + step);
//             break;
//         case 'second':
//             date[secondsSetterName(isUTC)](date[secondsGetterName(isUTC)]() + step);
//             break;
//         case 'millisecond':
//             date[millisecondsSetterName(isUTC)](date[millisecondsGetterName(isUTC)]() + step);
//             break;
//     }
//     return date.getTime();
// }
// const DATE_INTERVALS = [[8, 7.5], [4, 3.5], [2, 1.5]];
// const MONTH_INTERVALS = [[6, 5.5], [3, 2.5], [2, 1.5]];
// const MINUTES_SECONDS_INTERVALS = [[30, 30], [20, 20], [15, 15], [10, 10], [5, 5], [2, 2]];
function $ed3599ac91c48f4a$var$getDateInterval(approxInterval, daysInMonth) {
    approxInterval /= (0, $d28d71d6b904c104$export$a97a1358cbb650ab);
    return approxInterval > 16 ? 16 : approxInterval > 7.5 ? 7 // TODO week 7 or day 8?
     : approxInterval > 3.5 ? 4 : approxInterval > 1.5 ? 2 : 1;
}
function $ed3599ac91c48f4a$var$getMonthInterval(approxInterval) {
    var APPROX_ONE_MONTH = 30 * (0, $d28d71d6b904c104$export$a97a1358cbb650ab);
    approxInterval /= APPROX_ONE_MONTH;
    return approxInterval > 6 ? 6 : approxInterval > 3 ? 3 : approxInterval > 2 ? 2 : 1;
}
function $ed3599ac91c48f4a$var$getHourInterval(approxInterval) {
    approxInterval /= (0, $d28d71d6b904c104$export$82541edf19e5e3b0);
    return approxInterval > 12 ? 12 : approxInterval > 6 ? 6 : approxInterval > 3.5 ? 4 : approxInterval > 2 ? 2 : 1;
}
function $ed3599ac91c48f4a$var$getMinutesAndSecondsInterval(approxInterval, isMinutes) {
    approxInterval /= isMinutes ? (0, $d28d71d6b904c104$export$35acaebf644db34e) : (0, $d28d71d6b904c104$export$32c0454ceff7f92d);
    return approxInterval > 30 ? 30 : approxInterval > 20 ? 20 : approxInterval > 15 ? 15 : approxInterval > 10 ? 10 : approxInterval > 5 ? 5 : approxInterval > 2 ? 2 : 1;
}
function $ed3599ac91c48f4a$var$getMillisecondsInterval(approxInterval) {
    // If less than 1, the getTicks loop will inevitably deed loop and read safeLimit.
    return $b49750109e236fd8$export$2ca8010d037f830f($b49750109e236fd8$export$7a695fe44258210b(approxInterval, true), 1);
}
// e.g., if the input unit is 'day', start calculate ticks from the first day of
// that month to make ticks "nice".
function $ed3599ac91c48f4a$var$getFirstTimestampOfUnit(timestamp, unitName, isUTC) {
    var upperUnitIdx = Math.max(0, (0, $43e0a445ed6711da$export$305f7d4e9d4624f2)((0, $d28d71d6b904c104$export$87100da04d711986), unitName) - 1);
    return (0, $d28d71d6b904c104$export$2ed3384313b02c28)(new Date(timestamp), (0, $d28d71d6b904c104$export$87100da04d711986)[upperUnitIdx], isUTC).getTime();
}
function $ed3599ac91c48f4a$var$createEstimateNiceMultiple(setMethodName, dateMethodInterval) {
    var tmpDate = new Date(0);
    tmpDate[setMethodName](1);
    var tmpTime = tmpDate.getTime();
    tmpDate[setMethodName](1 + dateMethodInterval);
    var approxTimeInterval = tmpDate.getTime() - tmpTime;
    return function(tickVal, targetValue) {
        // Only in month that accurate result can not get by division of
        // timestamp interval, but no need accurate here.
        return Math.max(0, Math.round((targetValue - tickVal) / approxTimeInterval));
    };
}
function $ed3599ac91c48f4a$var$createIntervalTicks(bottomUnitName, approxInterval, isUTC, extent, innermostSpan, brk) {
    // A fail-safe is required since `interval` can be user specified, or for the case
    // that using dataZoom toolbox and zoom repeatedly.
    var safeLimit = 3000;
    var unitNames = (0, $d28d71d6b904c104$export$833c398a55654bb7);
    var iter = 0;
    function addTicksInSpan(interval, minTimestamp, maxTimestamp, getMethodName, setMethodName, isDate, out) {
        var estimateNiceMultiple = $ed3599ac91c48f4a$var$createEstimateNiceMultiple(setMethodName, interval);
        var dateTime = minTimestamp;
        var date = new Date(dateTime);
        // if (isDate) {
        //     d -= 1; // Starts with 0;   PENDING
        // }
        while(dateTime < maxTimestamp && dateTime <= extent[1]){
            out.push({
                value: dateTime
            });
            if (iter++ > safeLimit) break;
            date[setMethodName](date[getMethodName]() + interval);
            dateTime = date.getTime();
            if (brk) {
                var moreMultiple = brk.calcNiceTickMultiple(dateTime, estimateNiceMultiple);
                if (moreMultiple > 0) {
                    date[setMethodName](date[getMethodName]() + moreMultiple * interval);
                    dateTime = date.getTime();
                }
            }
        }
        // This extra tick is for calculating ticks of next level. Will not been added to the final result
        out.push({
            value: dateTime,
            // extent[1] should be added; deduplication will be performed later.
            notAdd: dateTime > extent[1]
        });
    }
    function addLevelTicks(unitName, lastLevelTicks, levelTicks) {
        var newAddedTicks = [];
        var isFirstLevel = !lastLevelTicks.length;
        if ($ed3599ac91c48f4a$var$isPrimaryUnitValueAndGreaterSame((0, $d28d71d6b904c104$export$1da4b91a25d7e1c8)(unitName), extent[0], extent[1], isUTC)) return;
        if (isFirstLevel) lastLevelTicks = [
            {
                value: $ed3599ac91c48f4a$var$getFirstTimestampOfUnit(extent[0], unitName, isUTC)
            },
            {
                value: extent[1]
            }
        ];
        for(var i = 0; i < lastLevelTicks.length - 1; i++){
            var startTick = lastLevelTicks[i].value;
            var endTick = lastLevelTicks[i + 1].value;
            if (startTick === endTick) continue;
            var interval = void 0;
            var getterName = void 0;
            var setterName = void 0;
            var isDate = false;
            switch(unitName){
                case "year":
                    interval = Math.max(1, Math.round(approxInterval / (0, $d28d71d6b904c104$export$a97a1358cbb650ab) / 365));
                    getterName = (0, $d28d71d6b904c104$export$8d046fefed9a548e)(isUTC);
                    setterName = (0, $d28d71d6b904c104$export$43fbeac90913b151)(isUTC);
                    break;
                case "half-year":
                case "quarter":
                case "month":
                    interval = $ed3599ac91c48f4a$var$getMonthInterval(approxInterval);
                    getterName = (0, $d28d71d6b904c104$export$5c242a801a23eec7)(isUTC);
                    setterName = (0, $d28d71d6b904c104$export$233f59998ed71c09)(isUTC);
                    break;
                case "week":
                case "half-week":
                case "day":
                    interval = $ed3599ac91c48f4a$var$getDateInterval(approxInterval, 31); // Use 32 days and let interval been 16
                    getterName = (0, $d28d71d6b904c104$export$4189e6cbc9753260)(isUTC);
                    setterName = (0, $d28d71d6b904c104$export$82fd379a67f37fa0)(isUTC);
                    isDate = true;
                    break;
                case "half-day":
                case "quarter-day":
                case "hour":
                    interval = $ed3599ac91c48f4a$var$getHourInterval(approxInterval);
                    getterName = (0, $d28d71d6b904c104$export$8b40b55b3c06cbe2)(isUTC);
                    setterName = (0, $d28d71d6b904c104$export$b6f943e8d23c15bb)(isUTC);
                    break;
                case "minute":
                    interval = $ed3599ac91c48f4a$var$getMinutesAndSecondsInterval(approxInterval, true);
                    getterName = (0, $d28d71d6b904c104$export$8807847c5c71eded)(isUTC);
                    setterName = (0, $d28d71d6b904c104$export$50303078793fc7d)(isUTC);
                    break;
                case "second":
                    interval = $ed3599ac91c48f4a$var$getMinutesAndSecondsInterval(approxInterval, false);
                    getterName = (0, $d28d71d6b904c104$export$8f49e73e2eebd168)(isUTC);
                    setterName = (0, $d28d71d6b904c104$export$a4a908acda9c3118)(isUTC);
                    break;
                case "millisecond":
                    interval = $ed3599ac91c48f4a$var$getMillisecondsInterval(approxInterval);
                    getterName = (0, $d28d71d6b904c104$export$312207a92d041116)(isUTC);
                    setterName = (0, $d28d71d6b904c104$export$c047afab75f6d84)(isUTC);
                    break;
            }
            // Notice: This expansion by `getFirstTimestampOfUnit` may cause too many ticks and
            // iteration. e.g., when three levels of ticks is displayed, which can be caused by
            // data zoom and axis breaks. Thus trim them here.
            if (endTick >= extent[0] && startTick <= extent[1]) addTicksInSpan(interval, startTick, endTick, getterName, setterName, isDate, newAddedTicks);
            if (unitName === "year" && levelTicks.length > 1 && i === 0) // Add nearest years to the left extent.
            levelTicks.unshift({
                value: levelTicks[0].value - interval
            });
        }
        for(var i = 0; i < newAddedTicks.length; i++)levelTicks.push(newAddedTicks[i]);
    }
    var levelsTicks = [];
    var currentLevelTicks = [];
    var tickCount = 0;
    var lastLevelTickCount = 0;
    for(var i = 0; i < unitNames.length; ++i){
        var primaryTimeUnit = (0, $d28d71d6b904c104$export$1da4b91a25d7e1c8)(unitNames[i]);
        if (!(0, $d28d71d6b904c104$export$beb5920b69c13da)(unitNames[i])) continue;
        addLevelTicks(unitNames[i], levelsTicks[levelsTicks.length - 1] || [], currentLevelTicks);
        var nextPrimaryTimeUnit = unitNames[i + 1] ? (0, $d28d71d6b904c104$export$1da4b91a25d7e1c8)(unitNames[i + 1]) : null;
        if (primaryTimeUnit !== nextPrimaryTimeUnit) {
            if (currentLevelTicks.length) {
                lastLevelTickCount = tickCount;
                // Remove the duplicate so the tick count can be precisely.
                currentLevelTicks.sort(function(a, b) {
                    return a.value - b.value;
                });
                var levelTicksRemoveDuplicated = [];
                for(var i_1 = 0; i_1 < currentLevelTicks.length; ++i_1){
                    var tickValue = currentLevelTicks[i_1].value;
                    if (i_1 === 0 || currentLevelTicks[i_1 - 1].value !== tickValue) {
                        levelTicksRemoveDuplicated.push(currentLevelTicks[i_1]);
                        if (tickValue >= extent[0] && tickValue <= extent[1]) tickCount++;
                    }
                }
                var targetTickNum = innermostSpan / approxInterval;
                // Added too much in this level and not too less in last level
                if (tickCount > targetTickNum * 1.5 && lastLevelTickCount > targetTickNum / 1.5) break;
                // Only treat primary time unit as one level.
                levelsTicks.push(levelTicksRemoveDuplicated);
                if (tickCount > targetTickNum || bottomUnitName === unitNames[i]) break;
            }
            // Reset if next unitName is primary
            currentLevelTicks = [];
        }
    }
    var levelsTicksInExtent = (0, $43e0a445ed6711da$export$3dea766d36a8935f)((0, $43e0a445ed6711da$export$871de8747c9eaa88)(levelsTicks, function(levelTicks) {
        return (0, $43e0a445ed6711da$export$3dea766d36a8935f)(levelTicks, function(tick) {
            return tick.value >= extent[0] && tick.value <= extent[1] && !tick.notAdd;
        });
    }), function(levelTicks) {
        return levelTicks.length > 0;
    });
    var maxLevel = levelsTicksInExtent.length - 1;
    var ticks = [];
    for(var i = 0; i < levelsTicksInExtent.length; ++i){
        var levelTicks = levelsTicksInExtent[i];
        for(var k = 0; k < levelTicks.length; ++k){
            var unit = (0, $d28d71d6b904c104$export$4dfb0417ad6555b7)(levelTicks[k].value, isUTC);
            ticks.push({
                value: levelTicks[k].value,
                time: {
                    level: maxLevel - i,
                    upperTimeUnit: unit,
                    lowerTimeUnit: unit
                }
            });
        }
    }
    // Remove duplicates, which may cause jitter of `splitArea` and other bad cases.
    (0, $87f4a59ac66e0ee6$export$2e2262a44ac61957)(ticks, (0, $87f4a59ac66e0ee6$export$605c429b4975bbd7), null);
    ticks.sort(function(a, b) {
        return a.value - b.value;
    });
    var currMinTick = ticks[0];
    var currMaxTick = ticks[ticks.length - 1];
    var extent0Unit = (0, $d28d71d6b904c104$export$4dfb0417ad6555b7)(extent[0], isUTC);
    var extent1Unit = (0, $d28d71d6b904c104$export$4dfb0417ad6555b7)(extent[1], isUTC);
    if (!currMinTick || currMinTick.value > extent[0]) ticks.unshift({
        value: extent[0],
        time: {
            level: 0,
            upperTimeUnit: extent0Unit,
            lowerTimeUnit: extent0Unit
        },
        notNice: true
    });
    if (!currMaxTick || currMaxTick.value < extent[1]) ticks.push({
        value: extent[1],
        time: {
            level: 0,
            upperTimeUnit: extent1Unit,
            lowerTimeUnit: extent1Unit
        },
        notNice: true
    });
    return ticks;
}
var $ed3599ac91c48f4a$export$b0ab84ebd823da11 = function(scale, opt) {
    var extent = scale.getExtent();
    // If extent start and end are same, expand them
    if (extent[0] === extent[1]) {
        // Expand extent
        extent[0] -= (0, $d28d71d6b904c104$export$a97a1358cbb650ab);
        extent[1] += (0, $d28d71d6b904c104$export$a97a1358cbb650ab);
    }
    // If there are no data and extent are [Infinity, -Infinity]
    if (extent[1] === -Infinity && extent[0] === Infinity) {
        var d = new Date();
        extent[1] = +new Date(d.getFullYear(), d.getMonth(), d.getDate());
        extent[0] = extent[1] - (0, $d28d71d6b904c104$export$a97a1358cbb650ab);
    }
    scale.setExtent(extent[0], extent[1]);
    var splitNumber = (0, $eb97010bfdf4c825$export$b801ba4e5ad70a4a)(opt.splitNumber, 10);
    var approxInterval = (0, $3123530578a35744$export$9a49fe71267af794)(scale) / splitNumber;
    var minInterval = opt.minInterval;
    var maxInterval = opt.maxInterval;
    if (minInterval != null && approxInterval < minInterval) approxInterval = minInterval;
    if (maxInterval != null && approxInterval > maxInterval) approxInterval = maxInterval;
    var scaleIntervalsLen = $ed3599ac91c48f4a$var$scaleIntervals.length;
    var idx = Math.min($ed3599ac91c48f4a$var$bisect($ed3599ac91c48f4a$var$scaleIntervals, approxInterval, 0, scaleIntervalsLen), scaleIntervalsLen - 1);
    // Interval that can be used to calculate ticks
    var interval = $ed3599ac91c48f4a$var$scaleIntervals[idx][1];
    // Min level used when picking ticks from top down.
    // We check one more level to avoid the ticks are to sparse in some case.
    var minLevelUnit = $ed3599ac91c48f4a$var$scaleIntervals[Math.max(idx - 1, 0)][0];
    scale.setTimeInterval({
        approxInterval: approxInterval,
        interval: interval,
        minLevelUnit: minLevelUnit
    });
};
(0, $852c4e3dd3bbc3b5$export$2e2bcd8739ae039).registerClass($ed3599ac91c48f4a$var$TimeScale);
var $ed3599ac91c48f4a$export$2e2bcd8739ae039 = $ed3599ac91c48f4a$var$TimeScale;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 









var $abb26321b997ff61$var$LOOKUP_IDX_EXTENT_START = 0;
var $abb26321b997ff61$var$LOOKUP_IDX_EXTENT_END = 1;
var $abb26321b997ff61$var$LOOKUP_IDX_BREAK_START = 2;
/**
 * @final NEVER inherit me!
 */ var $abb26321b997ff61$var$LogScale = /** @class */ function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(LogScale, _super);
    function LogScale(setting) {
        var _this = _super.call(this) || this;
        _this.type = "log";
        _this.parse = (0, $ae03431da7737467$export$2e2bcd8739ae039).parse;
        _this.base = setting.logBase || 10;
        var lookupFrom = [];
        var lookupTo = [];
        var lookup = _this._lookup = {
            from: lookupFrom,
            to: lookupTo
        };
        lookupFrom[$abb26321b997ff61$var$LOOKUP_IDX_EXTENT_START] = lookupFrom[$abb26321b997ff61$var$LOOKUP_IDX_EXTENT_END] = lookupTo[$abb26321b997ff61$var$LOOKUP_IDX_EXTENT_START] = lookupTo[$abb26321b997ff61$var$LOOKUP_IDX_EXTENT_END] = NaN;
        (0, $3123530578a35744$export$994b6d163a064f23)(_this, LogScale.mapperMethods);
        var scaleBreakHelper = (0, $d760dd937396b887$export$e79b20ac82c2d660)();
        var breakOption = setting.breakOption;
        var out = {
            lookup: lookup
        };
        if (scaleBreakHelper) scaleBreakHelper.parseAxisBreakOptionInwardTransform(breakOption, _this, {
            noNegative: true
        }, $abb26321b997ff61$var$LOOKUP_IDX_BREAK_START, out);
        _this.powStub = new (0, $ae03431da7737467$export$2e2bcd8739ae039)({
            breakParsed: out.original
        });
        _this.intervalStub = new (0, $ae03431da7737467$export$2e2bcd8739ae039)({
            breakParsed: out.transformed
        });
        (0, $3123530578a35744$export$85c5c680f14cd13c)(_this, _this.intervalStub);
        return _this;
    }
    LogScale.prototype.getTicks = function(opt) {
        var base = this.base;
        var powStub = this.powStub;
        var scaleBreakHelper = (0, $d760dd937396b887$export$e79b20ac82c2d660)();
        var intervalStub = this.intervalStub;
        var intervalExtent = intervalStub.getExtent();
        var powExtent = powStub.getExtent();
        var powOpt = {
            lookup: {
                from: intervalExtent,
                to: powExtent
            }
        };
        return (0, $43e0a445ed6711da$export$871de8747c9eaa88)(intervalStub.getTicks(opt || {}), function(tick) {
            var val = tick.value;
            var powVal = (0, $eb97010bfdf4c825$export$73e21863d9c0dcd3)(val, base, powOpt);
            var vBreak;
            if (scaleBreakHelper) {
                var brkPowResult = scaleBreakHelper.getTicksBreakOutwardTransform(this, tick, (0, $d760dd937396b887$export$20734ee5f1d5720f)(powStub), this._lookup);
                if (brkPowResult) {
                    vBreak = brkPowResult.vBreak;
                    powVal = brkPowResult.tickVal;
                }
            }
            return {
                value: powVal,
                "break": vBreak
            };
        }, this);
    };
    LogScale.prototype.getMinorTicks = function(splitNumber) {
        return (0, $2911692621c6e6e0$export$e2d43952c5db22bb)(this, splitNumber, (0, $d760dd937396b887$export$20734ee5f1d5720f)(this.powStub), // NOTE: minor ticks are in the log scale value to visually hint users "logarithm".
        this.intervalStub.getConfig().interval);
    };
    LogScale.prototype.getLabel = function(data, opt) {
        return this.intervalStub.getLabel(data, opt);
    };
    LogScale.type = "log";
    LogScale.mapperMethods = {
        needTransform: function() {
            return true;
        },
        normalize: function(val) {
            return this.intervalStub.normalize((0, $eb97010bfdf4c825$export$7854dd225b5d5704)(val, this.base));
        },
        scale: function(val) {
            // PENDING: Input `intervalStub.getExtent()` and `powStub.getExtent()` may
            // break monotonicity. Do not do it until real problems found.
            return (0, $eb97010bfdf4c825$export$73e21863d9c0dcd3)(this.intervalStub.scale(val), this.base, null);
        },
        transformIn: function(val, opt) {
            val = (0, $eb97010bfdf4c825$export$7854dd225b5d5704)(val, this.base);
            return opt && opt.depth === (0, $3123530578a35744$export$2734d952320c7be9) ? val : this.intervalStub.transformIn(val, opt);
        },
        transformOut: function(val, opt) {
            var depth = opt ? opt.depth : null;
            $abb26321b997ff61$var$tmpTransformOutOpt1.depth = depth;
            $abb26321b997ff61$var$tmpTransformOutOpt2.lookup = this._lookup;
            return (0, $eb97010bfdf4c825$export$73e21863d9c0dcd3)(depth === (0, $3123530578a35744$export$2734d952320c7be9) ? val : this.intervalStub.transformOut(val, $abb26321b997ff61$var$tmpTransformOutOpt1), this.base, $abb26321b997ff61$var$tmpTransformOutOpt2);
        },
        contain: function(val) {
            return this.powStub.contain(val);
        },
        /**
     * NOTICE: The caller should ensure `start` and `end` are both non-negative.
     */ setExtent: function(start, end) {
            this.setExtent2((0, $3123530578a35744$export$c884056e529a2c7a), start, end);
        },
        setExtent2: function(kind, start, end) {
            if (!(0, $87f4a59ac66e0ee6$export$d386653f29930adb)(start, end) || start <= 0 || end <= 0) return;
            var lookupTo = $abb26321b997ff61$var$tmpNotUsedArr;
            var lookupFrom = $abb26321b997ff61$var$tmpNotUsedArr;
            if (kind === (0, $3123530578a35744$export$c884056e529a2c7a)) {
                var lookup = this._lookup;
                lookupTo = lookup.to;
                lookupFrom = lookup.from;
            }
            this.powStub.setExtent2(kind, lookupTo[$abb26321b997ff61$var$LOOKUP_IDX_EXTENT_START] = start, lookupTo[$abb26321b997ff61$var$LOOKUP_IDX_EXTENT_END] = end);
            var base = this.base;
            this.intervalStub.setExtent2(kind, lookupFrom[$abb26321b997ff61$var$LOOKUP_IDX_EXTENT_START] = (0, $eb97010bfdf4c825$export$7854dd225b5d5704)(start, base), lookupFrom[$abb26321b997ff61$var$LOOKUP_IDX_EXTENT_END] = (0, $eb97010bfdf4c825$export$7854dd225b5d5704)(end, base));
        },
        getFilter: function() {
            return {
                g: 0
            };
        },
        sanitize: function(value, dataExtent) {
            // Conservative - if dataExtent is invalid, do not sanitize.
            if ((0, $87f4a59ac66e0ee6$export$d386653f29930adb)(dataExtent[0], dataExtent[1]) && (0, $b49750109e236fd8$export$b5c30d4208814a65)(value) && value <= 0) // `DataStore` has ensured that `dataExtent` is valid for LogScale.
            value = dataExtent[0];
            return value;
        },
        getDefaultStartValue: function() {
            return 1;
        },
        getExtent: function() {
            return this.powStub.getExtent();
        },
        getExtentUnsafe: function(kind, depth) {
            return depth === null ? this.powStub.getExtentUnsafe(kind, null) : this.intervalStub.getExtentUnsafe(kind, depth);
        }
    };
    return LogScale;
}((0, $852c4e3dd3bbc3b5$export$2e2bcd8739ae039));
(0, $852c4e3dd3bbc3b5$export$2e2bcd8739ae039).registerClass($abb26321b997ff61$var$LogScale);
var $abb26321b997ff61$var$tmpTransformOutOpt1 = {};
var $abb26321b997ff61$var$tmpTransformOutOpt2 = {};
var $abb26321b997ff61$var$tmpNotUsedArr = [];
var $abb26321b997ff61$export$2e2bcd8739ae039 = $abb26321b997ff61$var$LogScale;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $ebb9b7ebf9a2ae2e$export$2e0057d176d6f690 = {
    value: 1,
    category: 1,
    time: 1,
    log: 1
};










var $3e6d0d29922ecf90$var$axisInner = (0, $87f4a59ac66e0ee6$export$64df9f8d92ae083f)();
function $3e6d0d29922ecf90$export$a0edf4de19b45ee7(model) {
    var type = model.get("type");
    if (// In ec option, `xxxAxis.type` may be undefined.
    type == null || !$43e0a445ed6711da$export$b5a638e9b3fff9f3((0, $ebb9b7ebf9a2ae2e$export$2e0057d176d6f690), type) && !(0, $852c4e3dd3bbc3b5$export$2e2bcd8739ae039).getClass(type)) type = "value";
    return type;
}
function $3e6d0d29922ecf90$export$8941c4cacdc8f5a5(model, type, coordSysSupportAxisBreaks) {
    var breakHelper = (0, $d760dd937396b887$export$e79b20ac82c2d660)();
    var breakOption;
    if (breakHelper) breakOption = $3e6d0d29922ecf90$export$8094779d9b724f85(model, type, coordSysSupportAxisBreaks);
    switch(type){
        case "category":
            return new (0, $766cffcc080fa7a9$export$2e2bcd8739ae039)({
                ordinalMeta: model.getOrdinalMeta ? model.getOrdinalMeta() : model.getCategories(),
                extent: (0, $87f4a59ac66e0ee6$export$62e5f07ab009f3b)()
            });
        case "time":
            return new (0, $ed3599ac91c48f4a$export$2e2bcd8739ae039)({
                locale: model.ecModel.getLocaleModel(),
                useUTC: model.ecModel.get("useUTC"),
                breakOption: breakOption
            });
        case "log":
            // See also #3749
            return new (0, $abb26321b997ff61$export$2e2bcd8739ae039)({
                logBase: model.get("logBase"),
                breakOption: breakOption
            });
        case "value":
            return new (0, $ae03431da7737467$export$2e2bcd8739ae039)({
                breakOption: breakOption
            });
        default:
            // case others.
            return new ((0, $852c4e3dd3bbc3b5$export$2e2bcd8739ae039).getClass(type) || (0, $ae03431da7737467$export$2e2bcd8739ae039))({});
    }
}
function $3e6d0d29922ecf90$export$99e0963eefdef8b2(scale, value, considerMappingExtent) {
    var dataExtent = considerMappingExtent ? (0, $3123530578a35744$export$e182c528b7826102)(scale, null) : scale.getExtentUnsafe((0, $3123530578a35744$export$c884056e529a2c7a), null);
    var min = dataExtent[0];
    var max = dataExtent[1];
    return !(0, $87f4a59ac66e0ee6$export$d386653f29930adb)(min, max) ? $3e6d0d29922ecf90$export$8b1206c1406788fd : min === value || max === value ? $3e6d0d29922ecf90$export$d0bab53331033bdf : min < value && max > value ? $3e6d0d29922ecf90$export$18028792a61d93c4 : $3e6d0d29922ecf90$export$8b1206c1406788fd;
}
var $3e6d0d29922ecf90$export$18028792a61d93c4 = 1;
var $3e6d0d29922ecf90$export$d0bab53331033bdf = 2;
var $3e6d0d29922ecf90$export$8b1206c1406788fd = 3;
function $3e6d0d29922ecf90$export$3a3942ca9637d423(axis) {
    $3e6d0d29922ecf90$var$axisInner(axis).noOnMyZero = true;
}
function $3e6d0d29922ecf90$export$2204fb02f43463b7(axis) {
    return $3e6d0d29922ecf90$var$axisInner(axis).noOnMyZero;
}
function $3e6d0d29922ecf90$export$742f19a75415b2ae(axis) {
    var labelFormatter = axis.getLabelModel().get("formatter");
    if (axis.type === "time") {
        var parsed_1 = (0, $d28d71d6b904c104$export$f16a827770bdffb5)(labelFormatter);
        return function(tick, idx) {
            return axis.scale.getFormattedLabel(tick, idx, parsed_1);
        };
    } else if ($43e0a445ed6711da$export$844ec244b1367d54(labelFormatter)) return function(tick) {
        // For category axis, get raw value; for numeric axis,
        // get formatted label like '1,333,444'.
        var label = axis.scale.getLabel(tick);
        var text = labelFormatter.replace("{value}", label != null ? label : "");
        return text;
    };
    else if ($43e0a445ed6711da$export$f6e2535fb5126e54(labelFormatter)) {
        if (axis.type === "category") return function(tick, idx) {
            // The original intention of `idx` is "the index of the tick in all ticks".
            // But the previous implementation of category axis do not consider the
            // `axisLabel.interval`, which cause that, for example, the `interval` is
            // `1`, then the ticks "name5", "name7", "name9" are displayed, where the
            // corresponding `idx` are `0`, `2`, `4`, but not `0`, `1`, `2`. So we keep
            // the definition here for back compatibility.
            return labelFormatter($3e6d0d29922ecf90$export$a5a32f324c1fa457(axis, tick), tick.value - axis.scale.getExtent()[0], null // Using `null` just for backward compat.
            );
        };
        var scaleBreakHelper_1 = (0, $d760dd937396b887$export$e79b20ac82c2d660)();
        return function(tick, idx) {
            // Using `null` just for backward compat. It's been found that in the `test/axis-customTicks.html`,
            // there is a formatter `function (value, index, revers = true) { ... }`. Although the third param
            // `revers` is incorrect and always `null`, changing it might introduce a breaking change.
            var extra = null;
            if (scaleBreakHelper_1) extra = scaleBreakHelper_1.makeAxisLabelFormatterParamBreak(extra, tick["break"]);
            return labelFormatter($3e6d0d29922ecf90$export$a5a32f324c1fa457(axis, tick), idx, extra);
        };
    } else return function(tick) {
        return axis.scale.getLabel(tick);
    };
}
function $3e6d0d29922ecf90$export$a5a32f324c1fa457(axis, tick) {
    // In category axis with data zoom, tick is not the original
    // index of axis.data. So tick should not be exposed to user
    // in category axis.
    var scale = axis.scale;
    return (0, $eb97010bfdf4c825$export$61579433626afe87)(scale) ? scale.getLabel(tick) : tick.value;
}
function $3e6d0d29922ecf90$export$6d0bc2429155c088(model) {
    var interval = model.get("interval");
    return interval == null ? "auto" : interval;
}
function $3e6d0d29922ecf90$export$c2911c025243d6a6(axis) {
    return axis.type === "category" && $3e6d0d29922ecf90$export$6d0bc2429155c088(axis.getLabelModel()) === 0;
}
function $3e6d0d29922ecf90$export$e4cf30b1e74cd69d(data, axisDim) {
    // Remove duplicated dat dimensions caused by `getStackedDimension`.
    var dataDimMap = {};
    // Currently `mapDimensionsAll` will contain stack result dimension ('__\0ecstackresult').
    // PENDING: is it reasonable? Do we need to remove the original dim from "coord dim" since
    // there has been stacked result dim?
    $43e0a445ed6711da$export$79b2f7037acddd43(data.mapDimensionsAll(axisDim), function(dataDim) {
        // For example, the extent of the original dimension
        // is [0.1, 0.5], the extent of the `stackResultDimension`
        // is [7, 9], the final extent should NOT include [0.1, 0.5],
        // because there is no graphic corresponding to [0.1, 0.5].
        // See the case in `test/area-stack.html` `main1`, where area line
        // stack needs `yAxis` not start from 0.
        dataDimMap[(0, $bbbaa8c322403e71$export$909db2be4938fbdf)(data, dataDim)] = true;
    });
    return $43e0a445ed6711da$export$ed97f33186d4b816(dataDimMap);
}
function $3e6d0d29922ecf90$export$c06aa22293dea9d2(nameLocation) {
    return nameLocation === "middle" || nameLocation === "center";
}
function $3e6d0d29922ecf90$export$75b737736393e03c(axisModel) {
    return axisModel.getShallow("show");
}
function $3e6d0d29922ecf90$export$8094779d9b724f85(model, axisType, coordSysSupportAxisBreaks) {
    var option = model.get("breaks", true);
    if (option != null) {
        if (!(0, $d760dd937396b887$export$e79b20ac82c2d660)()) return undefined;
        if (!coordSysSupportAxisBreaks || !$3e6d0d29922ecf90$var$isAxisTypeSupportAxisBreak(axisType)) {
            var axisInfo;
            return undefined;
        }
        return option;
    }
}
function $3e6d0d29922ecf90$var$isAxisTypeSupportAxisBreak(axisType) {
    return axisType !== "category";
}
function $3e6d0d29922ecf90$export$8135db7762247d65(scale, fixMinMax, oldIntervalExtent, newIntervalExtent, oldOutermostExtent, cfg) {
    var isTargetLogScale = (0, $eb97010bfdf4c825$export$8b1d8a59aa13c502)(scale);
    var intervalStub = isTargetLogScale ? scale.intervalStub : scale;
    intervalStub.setExtent(newIntervalExtent[0], newIntervalExtent[1]);
    if (isTargetLogScale) {
        // Sync intervalStub extent to the outermost extent (i.e., `powStub` for `LogScale`).
        var powStub = scale.powStub;
        var opt = {
            depth: (0, $3123530578a35744$export$2734d952320c7be9)
        };
        var minPow = scale.transformOut(newIntervalExtent[0], opt);
        var maxPow = scale.transformOut(newIntervalExtent[1], opt);
        // Log transform is probably not inversible by rounding error, which causes min/max tick may be
        // displayed as `5.999999999999999` unexpectedly when min/max are required to be fixed (specified
        // by users or by dataZoom). Therefore we set `powStub` with respect to `oldOutermostExtent` if
        // interval extent is not changed. But `intervalStub` should not be inversely changed by this
        // handling, otherwise its monotonicity between `niceExtent` and `extent` may be broken and cause
        // unexpected ticks generation.
        var extentChanged = (0, $eb97010bfdf4c825$export$2b240c817ac5c4f)(oldIntervalExtent, newIntervalExtent);
        // NOTE: extent may still be changed even when min/max are required to be fixed,
        // e.g., by `intervalScaleEnsureValidExtent`.
        if (fixMinMax[0] && !extentChanged[0]) minPow = oldOutermostExtent[0];
        if (fixMinMax[1] && !extentChanged[1]) maxPow = oldOutermostExtent[1];
        powStub.setExtent(minPow, maxPow);
    }
    intervalStub.setConfig(cfg);
}
function $3e6d0d29922ecf90$export$889d2956111fd257(scale, tick) {
    return (0, $eb97010bfdf4c825$export$61579433626afe87)(scale) ? scale.getRawOrdinalNumber(tick.value) : tick.value;
}
function $3e6d0d29922ecf90$export$43d51f65881fb080(scale, axisModel) {
    return (0, $eb97010bfdf4c825$export$61579433626afe87)(scale) && !!axisModel.get("boundaryGap");
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // eslint-disable-next-line @typescript-eslint/no-unused-vars
var $f8933c96542855fa$export$5c54b224726edb5a = /** @class */ function() {
    function AxisModelCommonMixin() {}
    AxisModelCommonMixin.prototype.needIncludeZero = function() {
        return !this.option.scale;
    };
    /**
   * Should be implemented by each axis model if necessary.
   * @return coordinate system model
   */ AxisModelCommonMixin.prototype.getCoordSysModel = function() {
        return;
    };
    return AxisModelCommonMixin;
}();







/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 








/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $37f4ae2e6793c3da$var$callOnlyOnce = (0, $87f4a59ac66e0ee6$export$a305e9b27fd23ae3)();
var $37f4ae2e6793c3da$export$ba567ca71745149b = "|&";
var $37f4ae2e6793c3da$var$ecModelCacheFullUpdateInner = (0, $87f4a59ac66e0ee6$export$64df9f8d92ae083f)();
var $37f4ae2e6793c3da$export$3faff2d166c13471 = -2;
var $37f4ae2e6793c3da$export$5e218fe556c51ff0 = -1;
var $37f4ae2e6793c3da$var$ecModelCachePrepareInner = (0, $87f4a59ac66e0ee6$export$64df9f8d92ae083f)();
var $37f4ae2e6793c3da$var$validateInputAxis;
function $37f4ae2e6793c3da$var$getAxisStatPerKeyPerAxis(axis, axisStatKey) {
    var axisModel = axis.model;
    var keyed = $37f4ae2e6793c3da$var$ecModelCacheFullUpdateInner((0, $b6f52a1ffb51de17$export$14434b56aab40385)(axisModel.ecModel)).keyed;
    var perKey = keyed && keyed.get(axisStatKey);
    return perKey && perKey.get(axisModel.uid);
}
function $37f4ae2e6793c3da$export$bf9727b05f222b53(axis, axisStatKey) {
    return $37f4ae2e6793c3da$var$wrapStatResult($37f4ae2e6793c3da$var$getAxisStatPerKeyPerAxis(axis, axisStatKey));
}
function $37f4ae2e6793c3da$export$89af6c808d6573fd(axis, seriesList) {
    var result = [];
    $37f4ae2e6793c3da$var$eachKeyEachAxis(axis.model.ecModel, function(perKeyPerAxis) {
        for(var idx = 0; idx < seriesList.length; idx++)if (seriesList[idx] && perKeyPerAxis.serByIdx[seriesList[idx].seriesIndex]) result.push($37f4ae2e6793c3da$var$wrapStatResult(perKeyPerAxis));
    });
    return result;
}
function $37f4ae2e6793c3da$var$eachKeyEachAxis(ecModel, cb) {
    var keyed = $37f4ae2e6793c3da$var$ecModelCacheFullUpdateInner((0, $b6f52a1ffb51de17$export$14434b56aab40385)(ecModel)).keyed;
    keyed && keyed.each(function(perKey, axisStatKey) {
        perKey.each(function(perKeyPerAxis, axisModelUid) {
            cb(perKeyPerAxis, axisStatKey, axisModelUid);
        });
    });
}
function $37f4ae2e6793c3da$var$wrapStatResult(record) {
    return {
        liPosMinGap: record ? record.liPosMinGap : undefined
    };
}
function $37f4ae2e6793c3da$export$cee01bd2e39d754e(axis, cb) {
    var ecModel = axis.model.ecModel;
    var seriesOnAxisMap = $37f4ae2e6793c3da$var$ecModelCacheFullUpdateInner((0, $b6f52a1ffb51de17$export$14434b56aab40385)(ecModel)).axSer;
    seriesOnAxisMap && $37f4ae2e6793c3da$export$bf07bebae360b2fc(ecModel, seriesOnAxisMap.get(axis.model.uid), cb);
}
function $37f4ae2e6793c3da$export$ef6bd388c274421f(axis, axisStatKey, cb) {
    var perKeyPerAxis = $37f4ae2e6793c3da$var$getAxisStatPerKeyPerAxis(axis, axisStatKey);
    perKeyPerAxis && $37f4ae2e6793c3da$export$bf07bebae360b2fc(axis.model.ecModel, perKeyPerAxis.sers, cb);
}
function $37f4ae2e6793c3da$export$bf07bebae360b2fc(ecModel, seriesList, cb) {
    if (!seriesList) return;
    for(var i = 0; i < seriesList.length; i++){
        var seriesModel = seriesList[i];
        // Legend-filtered series need to be ignored since series are registered before `legendFilter`.
        if (!ecModel.isSeriesFiltered(seriesModel)) cb(seriesModel);
    }
}
function $37f4ae2e6793c3da$export$5351a7fee08ae808(axis, axisStatKey) {
    var perKeyPerAxis = $37f4ae2e6793c3da$var$getAxisStatPerKeyPerAxis(axis, axisStatKey);
    if (!perKeyPerAxis || !perKeyPerAxis.sers.length) return 0;
    var count = 0;
    $37f4ae2e6793c3da$export$bf07bebae360b2fc(axis.model.ecModel, perKeyPerAxis.sers, function() {
        count++;
    });
    return count;
}
function $37f4ae2e6793c3da$export$37f432351be0ca61(ecModel, axisStatKey, cb) {
    var keyed = $37f4ae2e6793c3da$var$ecModelCacheFullUpdateInner((0, $b6f52a1ffb51de17$export$14434b56aab40385)(ecModel)).keyed;
    var perKey = keyed && keyed.get(axisStatKey);
    perKey && perKey.each(function(perKeyPerAxis) {
        cb(perKeyPerAxis.axis);
    });
}
function $37f4ae2e6793c3da$export$21f2993d5751eb66(axis, cb) {
    var model = axis.model;
    var keysByAxisModelUid = $37f4ae2e6793c3da$var$ecModelCacheFullUpdateInner((0, $b6f52a1ffb51de17$export$14434b56aab40385)(model.ecModel)).keys;
    keysByAxisModelUid && (0, $43e0a445ed6711da$export$79b2f7037acddd43)(keysByAxisModelUid.get(model.uid), function(axisStatKey) {
        var stat;
        cb(axisStatKey);
    });
}
/**
 * NOTICE: this processor may be omitted - it is registered only if required.
 */ function $37f4ae2e6793c3da$var$performAxisStatisticsOnOverallReset(ecModel) {
    var ecPrepareCache = $37f4ae2e6793c3da$var$ecModelCachePrepareInner((0, $b6f52a1ffb51de17$export$67fb26d0f4e31b9e)(ecModel));
    var ecPrepareCacheKeyed = ecPrepareCache.keyed || (ecPrepareCache.keyed = (0, $43e0a445ed6711da$export$55f8aa7ef875b0a4)());
    $37f4ae2e6793c3da$var$eachKeyEachAxis(ecModel, function(perKeyPerAxis, axisStatKey, axisModelUid) {
        var ecPrepareCachePerKey = ecPrepareCacheKeyed.get(axisStatKey) || ecPrepareCacheKeyed.set(axisStatKey, (0, $43e0a445ed6711da$export$55f8aa7ef875b0a4)());
        var ecPreparePerKeyPerAxis = ecPrepareCachePerKey.get(axisModelUid) || ecPrepareCachePerKey.set(axisModelUid, {});
        if (perKeyPerAxis.metrics.liPosMinGap) // We should assert the impl exists -- fail-fast if missing `registerMetricImpl`.
        $37f4ae2e6793c3da$var$_metricImpl.liPosMinGap(ecModel, perKeyPerAxis, ecPreparePerKeyPerAxis);
    });
}
function $37f4ae2e6793c3da$export$5ce2ad54acb7c055(metricType, impl) {
    $37f4ae2e6793c3da$var$_metricImpl[metricType] = impl;
}
var $37f4ae2e6793c3da$var$_metricImpl = {};
function $37f4ae2e6793c3da$export$48507d392d1d4894(axis, seriesModel, coordSysType) {
    if (!axis) return;
    var ecModel = seriesModel.ecModel;
    var ecFullUpdateCache = $37f4ae2e6793c3da$var$ecModelCacheFullUpdateInner((0, $b6f52a1ffb51de17$export$14434b56aab40385)(ecModel));
    var axisModelUid = axis.model.uid;
    var axSerPairCheck, pairKey;
    var seriesOnAxisMap = ecFullUpdateCache.axSer || (ecFullUpdateCache.axSer = (0, $43e0a445ed6711da$export$55f8aa7ef875b0a4)());
    var seriesListPerAxis = seriesOnAxisMap.get(axisModelUid) || seriesOnAxisMap.set(axisModelUid, []);
    var lastSeries;
    seriesListPerAxis.push(seriesModel);
    var seriesType = seriesModel.subType;
    var isBaseAxis = seriesModel.getBaseAxis() === axis;
    var client = $37f4ae2e6793c3da$var$clientsForLookup.get($37f4ae2e6793c3da$var$makeClientLookupKey(seriesType, isBaseAxis, coordSysType)) || $37f4ae2e6793c3da$var$clientsForLookup.get($37f4ae2e6793c3da$var$makeClientLookupKey(seriesType, isBaseAxis, null));
    if (!client) return;
    var keyed = ecFullUpdateCache.keyed || (ecFullUpdateCache.keyed = (0, $43e0a445ed6711da$export$55f8aa7ef875b0a4)());
    var keys = ecFullUpdateCache.keys || (ecFullUpdateCache.keys = (0, $43e0a445ed6711da$export$55f8aa7ef875b0a4)());
    var axisStatKey = client.key;
    var perKey = keyed.get(axisStatKey) || keyed.set(axisStatKey, (0, $43e0a445ed6711da$export$55f8aa7ef875b0a4)());
    var perKeyPerAxis = perKey.get(axisModelUid);
    if (!perKeyPerAxis) {
        perKeyPerAxis = perKey.set(axisModelUid, {
            axis: axis,
            sers: [],
            serByIdx: []
        });
        // They should only be executed for each <key, axis> pair once:
        perKeyPerAxis.metrics = client.getMetrics(axis);
        (keys.get(axisModelUid) || keys.set(axisModelUid, [])).push(axisStatKey);
    }
    // series order should respect to the input order.
    perKeyPerAxis.sers.push(seriesModel);
    perKeyPerAxis.serByIdx[seriesModel.seriesIndex] = seriesModel;
}
/**
 * NOTE: Currently, the scenario is simple enough to look up clients by hash map.
 * Otherwise, a caller-provided `filter` may be an alternative if more complex requirements arise.
 */ function $37f4ae2e6793c3da$var$makeClientLookupKey(seriesType, isBaseAxis, coordSysType) {
    return seriesType + $37f4ae2e6793c3da$export$ba567ca71745149b + (0, $43e0a445ed6711da$export$995e01f2f5c9d030)(isBaseAxis, true) + $37f4ae2e6793c3da$export$ba567ca71745149b + (coordSysType || "");
}
function $37f4ae2e6793c3da$export$ad2364183e23f875(registers, client) {
    var clientKey = $37f4ae2e6793c3da$var$makeClientLookupKey(client.seriesType, client.baseAxis, client.coordSysType);
    $37f4ae2e6793c3da$var$clientsForLookup.set(clientKey, client);
    $37f4ae2e6793c3da$var$callOnlyOnce(registers, function() {
        registers.registerProcessor(registers.PRIORITY.PROCESSOR.AXIS_STATISTICS, {
            // NOTE: Theoretically, `appendData` requires `dirtyOnOverallProgress: true` here to re-calculate them.
            // But this OVERALL_STAGE_TASK is applied to all series (no `getTargetSeries` specified),
            // `dirtyOnOverallProgress: true` can cause irrelevant series (e.g., series on geo)
            // to be re-rendered when `appendData` is called, which cause `appendData` meaningless,
            // thereby not setting `dirtyOnOverallProgress: true`.
            overallReset: $37f4ae2e6793c3da$var$performAxisStatisticsOnOverallReset
        });
    });
}
var $37f4ae2e6793c3da$var$clientsForCheckingStatKey;
var $37f4ae2e6793c3da$var$clientsForLookup = (0, $43e0a445ed6711da$export$55f8aa7ef875b0a4)();


/**
 * NOTICE: Can be only used in `ensureScaleStore(axisLike)`.
 *
 * In most cases the instances of `Axis` and `Scale` are one-to-one mapping and share the same lifecycle.
 * But in some external usage (such as echarts-gl), axis instance does not necessarily exist, and only
 * scale instance and axisModel are used. Therefore we store the internal info on scale instance directly.
 */ var $0bd809c375c9fffe$var$scaleInner = (0, $87f4a59ac66e0ee6$export$64df9f8d92ae083f)();
var $0bd809c375c9fffe$export$c4999badb722a7d7 = 1;
var $0bd809c375c9fffe$export$f9ee28ea7363d798 = 2;
var $0bd809c375c9fffe$var$AXIS_EXTENT_INFO_BUILD_FROM_EMPTY = 3;
var $0bd809c375c9fffe$export$c35454f678e99c82 = /** @class */ function() {
    function ScaleRawExtentInfo(scale, model, // Typically: data extent from all series on this axis.
    dataExtent, requireStartValue, requireContainShape) {
        var isOrdinal = (0, $eb97010bfdf4c825$export$61579433626afe87)(scale);
        var axisDataLen = isOrdinal ? model.getCategories().length : null;
        // [CATEGORY_AXIS_MODEL_DATA_IS_EMPTY_ARRAY]:
        // This is only for backward compatibility - `xxxAxis: {data: []}` can declare this axis as
        // a "category" axis and use `series.data` to determine its extent but the axis is blank - only
        // axis line is displayed. This is a conincidence, but it is used in some cases.
        var categoryAxisModelDataIsEmptyArray;
        if (isOrdinal) {
            var axisModelDataArray = model.getCategories(true);
            categoryAxisModelDataIsEmptyArray = axisModelDataArray && !axisModelDataArray.length;
        }
        // NOTE: also considered the input dataExtent may be still in the initialized state `[Infinity, -Infinity]`.
        var dataMM = dataExtent.slice();
        // custom dataMin/dataMax.
        // Also considered `modelDataMinMax[0] > modelDataMinMax[1]` may occur.
        if ((0, $eb97010bfdf4c825$export$ba0fcad386c5c7e6)(scale) || (0, $eb97010bfdf4c825$export$8b1d8a59aa13c502)(scale) || (0, $eb97010bfdf4c825$export$c9b71a3750db342f)(scale)) {
            (0, $87f4a59ac66e0ee6$export$a7951d5427fae7a0)(dataMM, $0bd809c375c9fffe$var$parseAxisModelMinMax(scale, model.get("dataMin", true)));
            (0, $87f4a59ac66e0ee6$export$707ef09fb8bbaa0e)(dataMM, $0bd809c375c9fffe$var$parseAxisModelMinMax(scale, model.get("dataMax", true)));
        }
        if (!(0, $87f4a59ac66e0ee6$export$622ca7efe3351d22)(dataMM)) // dataMM may be still `[Infinity, -Infinity]`, we use `NaN` on the subsequent calculations
        // to force the `noZoomEffMM` to be `[NaN, NaN]` if needed.
        dataMM[0] = dataMM[1] = NaN;
        var noZoomEffMM = [];
        var fixMM = [
            false,
            false
        ];
        // Notice: When min/max is not set (that is, when there are null/undefined,
        // which is the most common case), these cases should be ensured:
        // (1) For 'ordinal', show all axis.data.
        // (2) For others:
        //      + `boundaryGap` is applied (if min/max set, boundaryGap is
        //      disabled).
        //      + If `needIncludeZero`, min/max should be zero, otherwise, min/max should
        //      be the result that originalExtent enlarged by boundaryGap.
        // (3) If no data, it should be ensured that `scale.setBlank` is set.
        var modelMinRaw = model.get("min", true);
        if (modelMinRaw === "dataMin") {
            noZoomEffMM[0] = dataMM[0];
            fixMM[0] = true;
        } else {
            noZoomEffMM[0] = $0bd809c375c9fffe$var$parseAxisModelMinMax(scale, (0, $43e0a445ed6711da$export$f6e2535fb5126e54)(modelMinRaw) ? modelMinRaw({
                min: dataMM[0],
                max: dataMM[1]
            }) : modelMinRaw);
            // If `xxxAxis.min: null/undefined`, min should not be fixed.
            fixMM[0] = noZoomEffMM[0] != null;
        }
        var modelMaxRaw = model.get("max", true);
        if (modelMaxRaw === "dataMax") {
            noZoomEffMM[1] = dataMM[1];
            fixMM[1] = true;
        } else {
            noZoomEffMM[1] = $0bd809c375c9fffe$var$parseAxisModelMinMax(scale, (0, $43e0a445ed6711da$export$f6e2535fb5126e54)(modelMaxRaw) ? modelMaxRaw({
                min: dataMM[0],
                max: dataMM[1]
            }) : modelMaxRaw);
            // If `xxxAxis.max: null/undefined`, max should not be fixed.
            fixMM[1] = noZoomEffMM[1] != null;
        }
        var boundaryGap = $0bd809c375c9fffe$var$parseBoundaryGapOption(scale, model);
        var span = !isOrdinal ? dataMM[1] - dataMM[0] || Math.abs(dataMM[0]) : null;
        // NOTE: If a numeric axis min/max is specified as 'dataMin'/'dataMax',
        // `boundaryGap` will not be used.
        if (noZoomEffMM[0] == null) noZoomEffMM[0] = isOrdinal ? categoryAxisModelDataIsEmptyArray ? dataMM[0] : axisDataLen ? 0 : NaN : dataMM[0] - boundaryGap[0] * span;
        if (noZoomEffMM[1] == null) noZoomEffMM[1] = isOrdinal ? categoryAxisModelDataIsEmptyArray ? dataMM[1] : axisDataLen ? axisDataLen - 1 : NaN : dataMM[1] + boundaryGap[1] * span;
        // Normalize to `NaN` if invalid; e.g., this may occur when `dataMM` has Infinity.
        !(0, $87f4a59ac66e0ee6$export$5af06089290883e2)(noZoomEffMM[0]) && (noZoomEffMM[0] = NaN);
        !(0, $87f4a59ac66e0ee6$export$5af06089290883e2)(noZoomEffMM[1]) && (noZoomEffMM[1] = NaN);
        var isBlank = categoryAxisModelDataIsEmptyArray || (0, $43e0a445ed6711da$export$7d667b9a0c48c975)(noZoomEffMM[0]) || (0, $43e0a445ed6711da$export$7d667b9a0c48c975)(noZoomEffMM[1]) || isOrdinal && !axisDataLen;
        // NOTE: `needIncludeZero` is not applicable to LogScale, TimeScale, OrdinalScale.
        var needIncludeZeroApplicable = (0, $eb97010bfdf4c825$export$ba0fcad386c5c7e6)(scale);
        var needIncludeZero = needIncludeZeroApplicable && model.needIncludeZero && model.needIncludeZero();
        if (needIncludeZero) {
            if (noZoomEffMM[0] > 0 && noZoomEffMM[1] > 0 && !fixMM[0]) noZoomEffMM[0] = 0;
            if (noZoomEffMM[0] < 0 && noZoomEffMM[1] < 0 && !fixMM[1]) noZoomEffMM[1] = 0;
        }
        var needToggleAxisInverse = false;
        if (noZoomEffMM[0] > noZoomEffMM[1]) {
            // Historically, if users set `xxxAxis.min > xxxAxis.max`, or `xxxAxis.max < dataExtent[0]`,
            // or `xxxAxis.min > dataExtent[1]` the behavior is sometimes like `xxxAxis.inverse = true`,
            // sometimes abnormal. We remain backward compatible with the former one, though this feature
            // may not be reasonable.
            // And handle it after "needIncludeZero" is also for backward compatibility.
            noZoomEffMM.reverse();
            needToggleAxisInverse = true;
        }
        var startValue = $0bd809c375c9fffe$var$parseAxisModelMinMax(scale, model.get("startValue", true));
        var startValueSpecified = startValue != null;
        if (!(0, $b49750109e236fd8$export$b5c30d4208814a65)(startValue) && requireStartValue) startValue = scale.getDefaultStartValue ? scale.getDefaultStartValue() : 0;
        if ((0, $b49750109e236fd8$export$b5c30d4208814a65)(startValue) && (startValueSpecified || !needIncludeZeroApplicable || needIncludeZero)) {
            if (startValue < noZoomEffMM[0] && !fixMM[0]) {
                noZoomEffMM[0] = startValue;
                fixMM[0] = true;
            } else if (startValue > noZoomEffMM[1] && !fixMM[1]) {
                noZoomEffMM[1] = startValue;
                fixMM[1] = true;
            }
        }
        var internal = this._i = {
            scale: scale,
            dataMM: dataMM,
            noZoomEffMM: noZoomEffMM,
            zoomMM: [],
            fixMM: fixMM,
            zoomFixMM: [
                false,
                false
            ],
            startValue: startValue,
            isBlank: isBlank,
            incl0: needIncludeZero,
            tggAxInv: needToggleAxisInverse,
            ctnShp: requireContainShape
        };
        $0bd809c375c9fffe$var$sanitizeExtent(internal, noZoomEffMM);
    }
    ScaleRawExtentInfo.prototype.makeNoZoom = function() {
        return this._i.noZoomEffMM.slice();
    };
    ScaleRawExtentInfo.prototype.makeFinal = function() {
        var internal = this._i;
        var zoomMM = internal.zoomMM;
        var noZoomEffMM = internal.noZoomEffMM;
        var zoomFixMM = internal.zoomFixMM;
        var fixMM = internal.fixMM;
        var result = {
            fixMM: fixMM,
            zoomFixMM: zoomFixMM,
            isBlank: internal.isBlank,
            incl0: internal.incl0,
            tggAxInv: internal.tggAxInv,
            ctnShp: internal.ctnShp,
            effMM: noZoomEffMM.slice()
        };
        var effMM = result.effMM;
        // NOTE: Switching `fixMM` probably leads to abrupt extent changes when draging a `dataZoom`
        //  handle, since `fixMM` impact the "nice extent" and "nice ticks" calculation.
        //  Consider a case:
        //    dataZoom `start` is 2% but its `end` is 100%, (or vice versa), we currently only set `fixMM[0]`
        //    as `true` but remain `fixMM[1]` as `false` for this case to avoid unnecessary abrupt change.
        //    Incidentally, the effect is not unacceptable if we set both `fixMM[0]/[1]` as `true`.
        if (zoomMM[0] != null) {
            effMM[0] = zoomMM[0];
            fixMM[0] = zoomFixMM[0] = true;
        }
        if (zoomMM[1] != null) {
            effMM[1] = zoomMM[1];
            fixMM[1] = zoomFixMM[1] = true;
        }
        $0bd809c375c9fffe$var$sanitizeExtent(internal, effMM);
        return result;
    };
    ScaleRawExtentInfo.prototype.makeRenderInfo = function() {
        return {
            startValue: this._i.startValue
        };
    };
    /**
   * NOTICE:
   *  - Do not set them if the percent are 0% or 100%. (See `AxisProxy['reset']`.)
   *  - The caller must ensure `start <= end` and the range is equal or less then `noZoomEffMM`.
   *    (See `AxisProxy['calculateDataWindow']`.)
   *  - The outcome `_zoomMM` may have both `NullUndefined` and a finite value, like `[undefined, 123]`.
   */ ScaleRawExtentInfo.prototype.setZoomMM = function(idxMinMax, val) {
        this._i.zoomMM[idxMinMax] = val;
    };
    return ScaleRawExtentInfo;
}();
/**
 * Should be called when a new extent is created or modified.
 */ function $0bd809c375c9fffe$var$sanitizeExtent(internal, mm) {
    var scale = internal.scale;
    var dataMM = internal.dataMM;
    if (scale.sanitize) {
        mm[0] = scale.sanitize(mm[0], dataMM);
        mm[1] = scale.sanitize(mm[1], dataMM);
        (0, $87f4a59ac66e0ee6$export$fca8d858e99f6a42)(mm);
    }
}
function $0bd809c375c9fffe$var$parseAxisModelMinMax(scale, minMax) {
    return minMax == null ? null // null/undefined means not specified and other default values can be applied.
     : (0, $43e0a445ed6711da$export$7d667b9a0c48c975)(minMax) ? NaN // NaN means a deliberate invalid number.
     : scale.parse(minMax);
}
function $0bd809c375c9fffe$var$parseBoundaryGapOption(scale, model) {
    var boundaryGapOptionArr;
    if ((0, $eb97010bfdf4c825$export$61579433626afe87)(scale)) boundaryGapOptionArr = [
        0,
        0
    ];
    else {
        var boundaryGap = model.get("boundaryGap");
        if (typeof boundaryGap === "boolean") boundaryGap = null;
        boundaryGapOptionArr = (0, $43e0a445ed6711da$export$43bee75e5e14138e)(boundaryGap) ? boundaryGap : [
            boundaryGap,
            boundaryGap
        ];
    }
    return [
        $0bd809c375c9fffe$var$parseBoundaryGapOptionItem(boundaryGapOptionArr[0]),
        $0bd809c375c9fffe$var$parseBoundaryGapOptionItem(boundaryGapOptionArr[1])
    ];
}
function $0bd809c375c9fffe$var$parseBoundaryGapOptionItem(opt) {
    return (0, $67e15a06bdb46d49$export$e8514cb5a5e2b40f)(typeof opt === "boolean" ? 0 : opt, 1) || 0;
}
/**
 * NOTE: `associateSeriesWithAxis` is not necessarily called, e.g., when
 * an axis is not used by any series.
 */ function $0bd809c375c9fffe$var$ensureScaleStore(axisLike) {
    var store = $0bd809c375c9fffe$var$scaleInner(axisLike.scale);
    if (!store.extent) store.extent = (0, $87f4a59ac66e0ee6$export$62e5f07ab009f3b)();
    return store;
}
function $0bd809c375c9fffe$export$710d8a038761b881(axisLike, coordSysDimIdxMap) {
    $0bd809c375c9fffe$var$ensureScaleStore(axisLike).dimIdxInCoord = coordSysDimIdxMap.get(axisLike.dim);
}
function $0bd809c375c9fffe$export$113bceb7edf323a4(axis, from) {
    var scale = axis.scale;
    var model = axis.model;
    var axisDim = axis.dim;
    if (scale.rawExtentInfo) return;
    $0bd809c375c9fffe$var$scaleRawExtentInfoCreateDeal(scale, axis, axisDim, model, from);
}
function $0bd809c375c9fffe$var$scaleRawExtentInfoCreateDeal(scale, axis, axisDim, model, from) {
    var scaleStore = $0bd809c375c9fffe$var$ensureScaleStore(axis);
    var extent = scaleStore.extent;
    var requireStartValue = false;
    (0, $37f4ae2e6793c3da$export$cee01bd2e39d754e)(axis, function(seriesModel) {
        if (seriesModel.boxCoordinateSystem) {
            // This supports union extent on case like: pie (or other similar series)
            // lays out on cartesian2d.
            var coord = (0, $a30c5e122eaab0a1$export$4818264084d885e)(seriesModel).coord;
            var dimIdx = scaleStore.dimIdxInCoord;
            if (!(dimIdx >= 0)) ;
            else if ((0, $43e0a445ed6711da$export$43bee75e5e14138e)(coord)) {
                var coordItem = coord[dimIdx];
                if (coordItem != null && !(0, $43e0a445ed6711da$export$43bee75e5e14138e)(coordItem)) (0, $87f4a59ac66e0ee6$export$c28a8a63acb35a19)(extent, scale.parse(coordItem));
            }
        } else if (seriesModel.coordinateSystem) {
            // NOTE: This data may have been filtered by dataZoom on orthogonal axes.
            var data_1 = seriesModel.getData();
            if (data_1) {
                var filter_1 = scale.getFilter ? scale.getFilter() : null;
                (0, $43e0a445ed6711da$export$79b2f7037acddd43)((0, $3e6d0d29922ecf90$export$e4cf30b1e74cd69d)(data_1, axisDim), function(dim) {
                    (0, $87f4a59ac66e0ee6$export$380d5a0634ac86f8)(extent, data_1.getApproximateExtent(dim, filter_1));
                });
            }
            if (seriesModel.__requireStartValue && seriesModel.__requireStartValue(axis)) requireStartValue = true;
        }
    });
    var requireContainShape = $0bd809c375c9fffe$var$determineRequireContainShape(scale, axis, model);
    var rawExtentInfo = new $0bd809c375c9fffe$export$c35454f678e99c82(scale, model, extent, requireStartValue, requireContainShape);
    $0bd809c375c9fffe$var$injectScaleRawExtentInfo(scale, rawExtentInfo, from);
    scaleStore.extent = null; // Clean up
}
/**
 * `rawExtentInfo` may not be created in some cases, such as no series declared or extra useless
 * axes declared in ec option. In this case we still create a default one for that empty axis.
 */ function $0bd809c375c9fffe$var$scaleRawExtentInfoBuildDefault(axisLike, dataExtent) {
    var scale = axisLike.scale;
    $0bd809c375c9fffe$var$injectScaleRawExtentInfo(scale, new $0bd809c375c9fffe$export$c35454f678e99c82(scale, axisLike.model, dataExtent, false, false), $0bd809c375c9fffe$var$AXIS_EXTENT_INFO_BUILD_FROM_EMPTY);
}
function $0bd809c375c9fffe$var$injectScaleRawExtentInfo(scale, scaleRawExtentInfo, from) {
    // @ts-ignore
    scale.rawExtentInfo = scaleRawExtentInfo;
    // @ts-ignore
    scaleRawExtentInfo.from = from;
}
function $0bd809c375c9fffe$export$7b3647d53bcfcf4e(// `axisStatKey` is used to quickly omit irrelevant handlers,
// since handlers need to be iterated per axis.
axisStatKey, handler) {
    $0bd809c375c9fffe$var$axisContainShapeHandlerMap.set(axisStatKey, handler);
}
var $0bd809c375c9fffe$var$axisContainShapeHandlerMap = (0, $43e0a445ed6711da$export$55f8aa7ef875b0a4)();
function $0bd809c375c9fffe$export$b9937565663b5dda(scale, model, ecModel, axis, externalDataExtent) {
    if (!scale.rawExtentInfo) $0bd809c375c9fffe$var$scaleRawExtentInfoBuildDefault({
        scale: scale,
        model: model
    }, externalDataExtent || (0, $87f4a59ac66e0ee6$export$62e5f07ab009f3b)());
    var rawExtentResult = scale.rawExtentInfo.makeFinal();
    // NOTE: This `scale.setExtent()` is required by:
    //  - `axisNiceTicks.ts` and `axisAlignTicks.ts`, where the internal `scaleMapper` may be required.
    var effectiveMinMax = rawExtentResult.effMM;
    scale.setExtent(effectiveMinMax[0], effectiveMinMax[1]);
    scale.setBlank(rawExtentResult.isBlank);
    if (axis && rawExtentResult.tggAxInv && ecModel && !ecModel.get("legacyMinMaxDontInverseAxis")) axis.inverse = !axis.inverse;
    return rawExtentResult;
}
function $0bd809c375c9fffe$var$determineRequireContainShape(scale, axis, model) {
    var onBand = (0, $3e6d0d29922ecf90$export$43d51f65881fb080)(scale, model);
    var modelContainShape = model.get("containShape", true);
    if (modelContainShape == null && !onBand) modelContainShape = true;
    if (!modelContainShape) return false;
    var requireContainShape = false;
    (0, $37f4ae2e6793c3da$export$21f2993d5751eb66)(axis, function(axisStatKey) {
        requireContainShape = !!$0bd809c375c9fffe$var$axisContainShapeHandlerMap.get(axisStatKey) || requireContainShape;
    });
    return requireContainShape;
}
function $0bd809c375c9fffe$export$922e3b0bde7215c8(axis, scale, rawExtentResult, ecModel) {
    if (!rawExtentResult.ctnShp) return;
    var linearSupplement;
    (0, $37f4ae2e6793c3da$export$21f2993d5751eb66)(axis, function(axisStatKey) {
        var handler = $0bd809c375c9fffe$var$axisContainShapeHandlerMap.get(axisStatKey);
        if (handler) {
            // This feature can be implemented by either expanding axis extent or scale extent. The choice depends
            // on whether series shape sizes are defined in pixels or data space. For example, scatter series glyph
            // sizes is mainly defined in pixel, while bar series `bandWidth` is mainly determined by given percents
            // of data scale. Since currently scatter does not require this feature, we implement it only on the
            // data scale.
            var singleLinearSupplement = handler(axis, ecModel);
            if (singleLinearSupplement) {
                linearSupplement = linearSupplement || [
                    0,
                    0
                ];
                (0, $87f4a59ac66e0ee6$export$a7951d5427fae7a0)(linearSupplement, singleLinearSupplement[0]);
                (0, $87f4a59ac66e0ee6$export$707ef09fb8bbaa0e)(linearSupplement, singleLinearSupplement[1]);
                // Consider the consistency of `onZero` behavior (not varying by series data; otherwise error-prone
                // to users), if any `containShape` really performed on this axis, discourage `onZero`.
                (0, $3e6d0d29922ecf90$export$3a3942ca9637d423)(axis);
            }
        }
    });
    if (!linearSupplement) return;
    var scaleExtent = scale.getExtent();
    if ((0, $eb97010bfdf4c825$export$61579433626afe87)(scale)) {
        if (!axis.onBand) // - Zooming on `OrdinalScale` auto "snaps" to integer ticks, which causes edge shapes to
        //   always overlap and be clipped at the boundaries. Therefore we always supplement it with
        //   half bandWith to avoid that overlapping.
        // - `linearSupplement` is typically [-0.5, 0.5] in this case. `linearSupplement` exists only
        //   if any series call `registerAxisContainShapeHandler`.
        // - PENDING: For historical reason, `onBand: true` has another implementation to handle
        //   this case. Merge them to this?
        scale.setExtent2((0, $3123530578a35744$export$a9efb7aa6faff3f6), (0, $b49750109e236fd8$export$e411eeaf23dccbe8)(scaleExtent[0], scaleExtent[0] + linearSupplement[0]), (0, $b49750109e236fd8$export$2ca8010d037f830f)(scaleExtent[1], scaleExtent[1] + linearSupplement[1]));
    } else {
        // For other cases, `SCALE_EXTENT_KIND_MAPPING` is only used on the full window of `dataZoom`,
        // where the visual result is more intuitive when zooming: when dataZoom is applied and its ends
        // (i.e., `zoomMM`) do not reach 0% or 100%, the axis ends should exactly respect to the dataZoom
        // ends, and shapes are clipped if overflowing.
        var scaleExtentExpanded = scaleExtent.slice();
        if (!rawExtentResult.zoomFixMM[0]) scaleExtentExpanded[0] = (0, $b49750109e236fd8$export$e411eeaf23dccbe8)(scaleExtentExpanded[0], scale.transformOut(scale.transformIn(scaleExtentExpanded[0], null) + linearSupplement[0], null));
        if (!rawExtentResult.zoomFixMM[1]) scaleExtentExpanded[1] = (0, $b49750109e236fd8$export$2ca8010d037f830f)(scaleExtentExpanded[1], scale.transformOut(scale.transformIn(scaleExtentExpanded[1], null) + linearSupplement[1], null));
        if (scaleExtentExpanded[0] < scaleExtent[0] || scaleExtentExpanded[1] > scaleExtent[1]) scale.setExtent2((0, $3123530578a35744$export$a9efb7aa6faff3f6), scaleExtentExpanded[0], scaleExtentExpanded[1]);
    }
// NOTE: since currently `SCALE_EXTENT_KIND_MAPPING` is never required to be displayed, we
// do not need to find a proper precision for that. But if it is required in the future, We
// can use `getAcceptableTickPrecision` to find a proper precision.
}



// ------ START: LinearIntervalScaleStub Nice ------
function $8721c77a801a39b2$var$calcNiceForIntervalOrLogScale(scale, opt) {
    // [CAVEAT]: If updating this impl, need to sync it to `axisAlignTicks.ts`.
    var isTargetLogScale = (0, $eb97010bfdf4c825$export$8b1d8a59aa13c502)(scale);
    var intervalStub = isTargetLogScale ? scale.intervalStub : scale;
    var fixMinMax = opt.fixMinMax || [];
    var oldOutermostExtent = isTargetLogScale ? scale.getExtent() : null;
    var oldIntervalExtent = intervalStub.getExtent();
    var newIntervalExtent = (0, $eb97010bfdf4c825$export$e279d7ed1695209d)(oldIntervalExtent, fixMinMax, opt.rawExtentResult);
    intervalStub.setExtent(newIntervalExtent[0], newIntervalExtent[1]);
    newIntervalExtent = intervalStub.getExtent();
    var config = isTargetLogScale ? $8721c77a801a39b2$var$logScaleCalcNiceTicks(intervalStub, opt) : $8721c77a801a39b2$var$intervalScaleCalcNiceTicks(intervalStub, opt);
    var autoIntervalPrecision = config.intervalPrecision;
    var autoInterval = config.interval;
    // When auto calculated interval is not preferable, users are allowed to explicity specify
    // `interval`, `min`, `max` to customize the axis. A typical case is, in angle axis with angle
    // 0 - 360, where the internally calculated interval is not 60-based.
    // NOTICE:
    //  - In `xxxAxis.type: 'log'`, ec option `xxxAxis.interval` requires a logarithm-applied
    //    value rather than a value in the raw scale.
    //  - Follow the historical behavior:
    //    - even `interval` is specified, the scale extent is still expanded based on the auto-calculated
    //      interval.
    //    - No validation to the specified `interval`.
    var userInterval = opt.userInterval;
    if (userInterval != null) {
        config.interval = userInterval;
        config.intervalPrecision = (0, $eb97010bfdf4c825$export$86a060b060d3d31a)(userInterval);
    }
    if (!fixMinMax[0]) newIntervalExtent[0] = (0, $b49750109e236fd8$export$2077e0241d6afd3c)((0, $b49750109e236fd8$export$c6301bc99a7f80a7)(newIntervalExtent[0] / autoInterval) * autoInterval, autoIntervalPrecision);
    if (!fixMinMax[1]) newIntervalExtent[1] = (0, $b49750109e236fd8$export$2077e0241d6afd3c)((0, $b49750109e236fd8$export$cf129980c996e186)(newIntervalExtent[1] / autoInterval) * autoInterval, autoIntervalPrecision);
    if (userInterval != null) // Historical behavior.
    config.niceExtent = newIntervalExtent.slice();
    (0, $3e6d0d29922ecf90$export$8135db7762247d65)(scale, fixMinMax, oldIntervalExtent, newIntervalExtent, oldOutermostExtent, config);
}
// ------ END: LinearIntervalScaleStub Nice ------
// ------ START: IntervalScale Nice ------
function $8721c77a801a39b2$var$intervalScaleCalcNiceTicks(scale, opt) {
    var splitNumber = (0, $eb97010bfdf4c825$export$b801ba4e5ad70a4a)(opt.splitNumber, 5);
    // Use the span in the innermost linear space to calculate nice ticks.
    var span = (0, $3123530578a35744$export$9a49fe71267af794)(scale);
    var minInterval = opt.minInterval;
    var maxInterval = opt.maxInterval;
    var interval = (0, $b49750109e236fd8$export$7a695fe44258210b)(span / splitNumber, true);
    if (minInterval != null && interval < minInterval) interval = minInterval;
    if (maxInterval != null && interval > maxInterval) interval = maxInterval;
    var intervalPrecision = (0, $eb97010bfdf4c825$export$86a060b060d3d31a)(interval);
    var extent = scale.getExtent();
    // By design, the `niceExtent` is inside the original extent
    var niceExtent = [
        (0, $b49750109e236fd8$export$2077e0241d6afd3c)((0, $b49750109e236fd8$export$cf129980c996e186)(extent[0] / interval) * interval, intervalPrecision),
        (0, $b49750109e236fd8$export$2077e0241d6afd3c)((0, $b49750109e236fd8$export$c6301bc99a7f80a7)(extent[1] / interval) * interval, intervalPrecision)
    ];
    return {
        interval: interval,
        intervalPrecision: intervalPrecision,
        niceExtent: niceExtent
    };
}
// ------ END: IntervalScale Nice ------
// ------ START: LogScale Nice ------
function $8721c77a801a39b2$var$logScaleCalcNiceTicks(intervalStub, opt) {
    // [CAVEAT]: If updating this impl, need to sync it to `axisAlignTicks.ts`.
    var splitNumber = (0, $eb97010bfdf4c825$export$b801ba4e5ad70a4a)(opt.splitNumber, 10);
    // Find nice ticks in the "logarithmic space". Notice that "logarithmic space" is a middle space
    // rather than the innermost linear space when axis breaks exist.
    var intervalExtent = intervalStub.getExtent();
    // But use the span in the innermost linear space to calculate nice ticks.
    var span = (0, $3123530578a35744$export$9a49fe71267af794)(intervalStub);
    // Interval should be integer
    var interval = (0, $b49750109e236fd8$export$2ca8010d037f830f)((0, $b49750109e236fd8$export$82dd68b83a44b253)(span), 1);
    var err = splitNumber / span * interval;
    // Filter ticks to get closer to the desired count.
    if (err <= 0.5) // TODO: support other bases other than 10?
    interval *= 10;
    var intervalPrecision = (0, $eb97010bfdf4c825$export$86a060b060d3d31a)(interval);
    // For LogScale, we use a `niceExtent` in the "logarithmic space" rather than
    // the original "pow space", because it is used in `intervalStub.getTicks()` thereafter.
    var niceExtent = [
        (0, $b49750109e236fd8$export$2077e0241d6afd3c)((0, $b49750109e236fd8$export$cf129980c996e186)(intervalExtent[0] / interval) * interval, intervalPrecision),
        (0, $b49750109e236fd8$export$2077e0241d6afd3c)((0, $b49750109e236fd8$export$c6301bc99a7f80a7)(intervalExtent[1] / interval) * interval, intervalPrecision)
    ];
    return {
        intervalPrecision: intervalPrecision,
        interval: interval,
        niceExtent: niceExtent
    };
}
function $8721c77a801a39b2$export$6aaaea8da7d6b895(axisLike) {
    var scale = axisLike.scale;
    var model = axisLike.model;
    var axis = model.axis;
    var ecModel = model.ecModel;
    $8721c77a801a39b2$export$35f94b1dd0b73915(scale, model, axis, ecModel, null);
}
function $8721c77a801a39b2$export$35f94b1dd0b73915(scale, model, // Some call from external source, such as echarts-gl, may have no `axis` and `ecModel`,
// but has `externalDataExtent`.
axis, ecModel, externalDataExtent) {
    var rawExtentResult = (0, $0bd809c375c9fffe$export$b9937565663b5dda)(scale, model, ecModel, axis, externalDataExtent);
    var isIntervalOrTime = (0, $eb97010bfdf4c825$export$ba0fcad386c5c7e6)(scale) || (0, $eb97010bfdf4c825$export$c9b71a3750db342f)(scale);
    $8721c77a801a39b2$export$1b1041112fbfff22(scale, {
        splitNumber: model.get("splitNumber"),
        fixMinMax: rawExtentResult.fixMM,
        userInterval: model.get("interval"),
        minInterval: isIntervalOrTime ? model.get("minInterval") : null,
        maxInterval: isIntervalOrTime ? model.get("maxInterval") : null,
        rawExtentResult: rawExtentResult
    });
    if (axis && ecModel) (0, $0bd809c375c9fffe$export$922e3b0bde7215c8)(axis, scale, rawExtentResult, ecModel);
}
function $8721c77a801a39b2$export$1b1041112fbfff22(scale, opt) {
    $8721c77a801a39b2$var$scaleCalcNiceMethods[scale.type](scale, opt);
}
var $8721c77a801a39b2$var$scaleCalcNiceMethods = {
    interval: $8721c77a801a39b2$var$calcNiceForIntervalOrLogScale,
    log: $8721c77a801a39b2$var$calcNiceForIntervalOrLogScale,
    time: (0, $ed3599ac91c48f4a$export$b0ab84ebd823da11),
    ordinal: (0, $43e0a445ed6711da$export$8793edee2d425525)
}; // ------ END: scaleCalcNice Entry ------





function $c3732722dc240783$export$5897d8d7c7a3d871(seriesModel) {
    return (0, $5d58e30ee7cf15bf$export$2e2bcd8739ae039)(null, seriesModel);
}
var $c3732722dc240783$export$d6100971d5a3a0a7 = {
    isDimensionStacked: (0, $bbbaa8c322403e71$export$1dedc39359ae35c),
    enableDataStack: (0, $bbbaa8c322403e71$export$f2165f9e8499b278),
    getStackedDimension: (0, $bbbaa8c322403e71$export$909db2be4938fbdf)
};
function $c3732722dc240783$export$587d9c3c553380c6(dataExtent, option) {
    var axisModel = option;
    if (!(option instanceof (0, $279973fc50f77a15$export$2e2bcd8739ae039))) axisModel = new (0, $279973fc50f77a15$export$2e2bcd8739ae039)(option);
    var axisType = $3e6d0d29922ecf90$export$a0edf4de19b45ee7(axisModel);
    var scale = $3e6d0d29922ecf90$export$8941c4cacdc8f5a5(axisModel, axisType, false);
    if (dataExtent[1] < dataExtent[0]) dataExtent = dataExtent.slice().reverse();
    (0, $8721c77a801a39b2$export$35f94b1dd0b73915)(scale, axisModel, null, null, dataExtent);
    return scale;
}
function $c3732722dc240783$export$4665cbe3470e4d57(Model) {
    $43e0a445ed6711da$export$e36fc9d62a853069(Model, (0, $f8933c96542855fa$export$5c54b224726edb5a));
}
function $c3732722dc240783$export$f8998c3d0a13de59(textStyleModel, opts) {
    opts = opts || {};
    return (0, $6556fe1ed9fb479d$export$f8998c3d0a13de59)(textStyleModel, null, null, opts.state !== "normal");
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 








var $8f6e8e1f1e941d98$var$extensions = [];
var $8f6e8e1f1e941d98$var$extensionRegisters = {
    registerPreprocessor: (0, $8d957d74809727b8$export$77095792a057b768),
    registerProcessor: (0, $8d957d74809727b8$export$d575e6557ac1729f),
    registerPostInit: (0, $8d957d74809727b8$export$c8c249911ee8c1ed),
    registerPostUpdate: (0, $8d957d74809727b8$export$99560909c18c76bb),
    registerUpdateLifecycle: (0, $8d957d74809727b8$export$c9ec4b5faef04865),
    registerAction: (0, $8d957d74809727b8$export$408c24786cd729c6),
    registerCoordinateSystem: (0, $8d957d74809727b8$export$1dd5e025a8a37dd),
    registerLayout: (0, $8d957d74809727b8$export$d768f97700ca6bea),
    registerVisual: (0, $8d957d74809727b8$export$5f32c1eb94c381bb),
    registerTransform: (0, $8d957d74809727b8$export$f01d71dd0389d7e4),
    registerLoading: (0, $8d957d74809727b8$export$e06b68a82007c015),
    registerMap: (0, $8d957d74809727b8$export$d456de060be2dba1),
    registerImpl: (0, $8a21e81d789730a0$export$9b808fd12256ddd3),
    PRIORITY: (0, $8d957d74809727b8$export$bb34f3538ba26c7e),
    ComponentModel: (0, $4a9041b12b787d1b$export$2e2bcd8739ae039),
    ComponentView: (0, $c81700f6bd52c5a7$export$2e2bcd8739ae039),
    SeriesModel: (0, $39002e2f499d7a2f$export$2e2bcd8739ae039),
    ChartView: (0, $9bc1fbefe72d5b26$export$2e2bcd8739ae039),
    // TODO Use ComponentModel and SeriesModel instead of Constructor
    registerComponentModel: function(ComponentModelClass) {
        (0, $4a9041b12b787d1b$export$2e2bcd8739ae039).registerClass(ComponentModelClass);
    },
    registerComponentView: function(ComponentViewClass) {
        (0, $c81700f6bd52c5a7$export$2e2bcd8739ae039).registerClass(ComponentViewClass);
    },
    registerSeriesModel: function(SeriesModelClass) {
        (0, $39002e2f499d7a2f$export$2e2bcd8739ae039).registerClass(SeriesModelClass);
    },
    registerChartView: function(ChartViewClass) {
        (0, $9bc1fbefe72d5b26$export$2e2bcd8739ae039).registerClass(ChartViewClass);
    },
    registerCustomSeries: function(seriesType, renderItem) {
        (0, $fbd66d714849991d$export$c3e61191887968da)(seriesType, renderItem);
    },
    registerSubTypeDefaulter: function(componentType, defaulter) {
        (0, $4a9041b12b787d1b$export$2e2bcd8739ae039).registerSubTypeDefaulter(componentType, defaulter);
    },
    registerPainter: function(painterType, PainterCtor) {
        (0, $08a7e718789e144c$export$a3e793ccb11823a5)(painterType, PainterCtor);
    }
};
function $8f6e8e1f1e941d98$export$1f96ae73734a86cc(ext) {
    if ((0, $43e0a445ed6711da$export$43bee75e5e14138e)(ext)) {
        // use([ChartLine, ChartBar]);
        (0, $43e0a445ed6711da$export$79b2f7037acddd43)(ext, function(singleExt) {
            $8f6e8e1f1e941d98$export$1f96ae73734a86cc(singleExt);
        });
        return;
    }
    if ((0, $43e0a445ed6711da$export$305f7d4e9d4624f2)($8f6e8e1f1e941d98$var$extensions, ext) >= 0) return;
    $8f6e8e1f1e941d98$var$extensions.push(ext);
    if ((0, $43e0a445ed6711da$export$f6e2535fb5126e54)(ext)) ext = {
        install: ext
    };
    ext.install($8f6e8e1f1e941d98$var$extensionRegisters);
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Parse and decode geo json
 */ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $89769857a6a8b7d8$var$EPSILON = 1e-8;
function $89769857a6a8b7d8$var$isAroundEqual(a, b) {
    return Math.abs(a - b) < $89769857a6a8b7d8$var$EPSILON;
}
function $89769857a6a8b7d8$export$8893e2b90ba10d92(points, x, y) {
    var w = 0;
    var p = points[0];
    if (!p) return false;
    for(var i = 1; i < points.length; i++){
        var p2 = points[i];
        w += (0, $36ba9cdf2f52eec1$export$2e2bcd8739ae039)(p[0], p[1], p2[0], p2[1], x, y);
        p = p2;
    }
    var p0 = points[0];
    if (!$89769857a6a8b7d8$var$isAroundEqual(p[0], p0[0]) || !$89769857a6a8b7d8$var$isAroundEqual(p[1], p0[1])) w += (0, $36ba9cdf2f52eec1$export$2e2bcd8739ae039)(p[0], p[1], p0[0], p0[1], x, y);
    return w !== 0;
}




var $79ee11e824769c68$var$TMP_TRANSFORM = [];
function $79ee11e824769c68$var$transformPoints(points, transform) {
    for(var p = 0; p < points.length; p++)$ee491d8f32bd01ff$export$9f9dcb98c894b623(points[p], points[p], transform);
}
function $79ee11e824769c68$var$updateBBoxFromPoints(points, min, max, projection) {
    for(var i = 0; i < points.length; i++){
        var p = points[i];
        if (projection) // projection may return null point.
        p = projection.project(p);
        if (p && isFinite(p[0]) && isFinite(p[1])) {
            $ee491d8f32bd01ff$export$96ec731ed4dcb222(min, min, p);
            $ee491d8f32bd01ff$export$8960430cfd85939f(max, max, p);
        }
    }
}
function $79ee11e824769c68$var$centroid(points) {
    var signedArea = 0;
    var cx = 0;
    var cy = 0;
    var len = points.length;
    var x0 = points[len - 1][0];
    var y0 = points[len - 1][1];
    // Polygon should been closed.
    for(var i = 0; i < len; i++){
        var x1 = points[i][0];
        var y1 = points[i][1];
        var a = x0 * y1 - x1 * y0;
        signedArea += a;
        cx += (x0 + x1) * a;
        cy += (y0 + y1) * a;
        x0 = x1;
        y0 = y1;
    }
    return signedArea ? [
        cx / signedArea / 3,
        cy / signedArea / 3,
        signedArea
    ] : [
        points[0][0] || 0,
        points[0][1] || 0
    ];
}
var $79ee11e824769c68$export$b1f97c3099fc6872 = /** @class */ function() {
    function Region(name) {
        this.name = name;
    }
    Region.prototype.setCenter = function(center) {
        this._center = center;
    };
    /**
   * Get center point in data unit. That is,
   * for GeoJSONRegion, the unit is lat/lng,
   * for GeoSVGRegion, the unit is SVG local coord.
   */ Region.prototype.getCenter = function() {
        var center = this._center;
        if (!center) // In most cases there are no need to calculate this center.
        // So calculate only when called.
        center = this._center = this.calcCenter();
        return center;
    };
    return Region;
}();
var $79ee11e824769c68$export$91e20b0f72443753 = /** @class */ function() {
    function GeoJSONPolygonGeometry(exterior, interiors) {
        this.type = "polygon";
        this.exterior = exterior;
        this.interiors = interiors;
    }
    return GeoJSONPolygonGeometry;
}();
var $79ee11e824769c68$export$335807c9e785d92c = /** @class */ function() {
    function GeoJSONLineStringGeometry(points) {
        this.type = "linestring";
        this.points = points;
    }
    return GeoJSONLineStringGeometry;
}();
var $79ee11e824769c68$export$ee84fcb463f24b3d = /** @class */ function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(GeoJSONRegion, _super);
    function GeoJSONRegion(name, geometries, cp) {
        var _this = _super.call(this, name) || this;
        _this.type = "geoJSON";
        _this.geometries = geometries;
        _this._center = cp && [
            cp[0],
            cp[1]
        ];
        return _this;
    }
    GeoJSONRegion.prototype.calcCenter = function() {
        var geometries = this.geometries;
        var largestGeo;
        var largestGeoSize = 0;
        for(var i = 0; i < geometries.length; i++){
            var geo = geometries[i];
            var exterior = geo.exterior;
            // Simple trick to use points count instead of polygon area as region size.
            // Ignore linestring
            var size = exterior && exterior.length;
            if (size > largestGeoSize) {
                largestGeo = geo;
                largestGeoSize = size;
            }
        }
        if (largestGeo) return $79ee11e824769c68$var$centroid(largestGeo.exterior);
        // from bounding rect by default.
        var rect = this.getBoundingRect();
        return [
            rect.x + rect.width / 2,
            rect.y + rect.height / 2
        ];
    };
    GeoJSONRegion.prototype.getBoundingRect = function(projection) {
        var rect = this._rect;
        // Always recalculate if using projection.
        if (rect && !projection) return rect;
        var min = [
            Infinity,
            Infinity
        ];
        var max = [
            -Infinity,
            -Infinity
        ];
        var geometries = this.geometries;
        (0, $43e0a445ed6711da$export$79b2f7037acddd43)(geometries, function(geo) {
            if (geo.type === "polygon") // Doesn't consider hole
            $79ee11e824769c68$var$updateBBoxFromPoints(geo.exterior, min, max, projection);
            else (0, $43e0a445ed6711da$export$79b2f7037acddd43)(geo.points, function(points) {
                $79ee11e824769c68$var$updateBBoxFromPoints(points, min, max, projection);
            });
        });
        // Normalie invalid bounding.
        if (!(isFinite(min[0]) && isFinite(min[1]) && isFinite(max[0]) && isFinite(max[1]))) min[0] = min[1] = max[0] = max[1] = 0;
        rect = new (0, $c437f598d9c9ee16$export$2e2bcd8739ae039)(min[0], min[1], max[0] - min[0], max[1] - min[1]);
        if (!projection) this._rect = rect;
        return rect;
    };
    GeoJSONRegion.prototype.contain = function(coord) {
        var rect = this.getBoundingRect();
        var geometries = this.geometries;
        if (!rect.contain(coord[0], coord[1])) return false;
        loopGeo: for(var i = 0, len = geometries.length; i < len; i++){
            var geo = geometries[i];
            // Only support polygon.
            if (geo.type !== "polygon") continue;
            var exterior = geo.exterior;
            var interiors = geo.interiors;
            if ($89769857a6a8b7d8$export$8893e2b90ba10d92(exterior, coord[0], coord[1])) {
                // Not in the region if point is in the hole.
                for(var k = 0; k < (interiors ? interiors.length : 0); k++){
                    if ($89769857a6a8b7d8$export$8893e2b90ba10d92(interiors[k], coord[0], coord[1])) continue loopGeo;
                }
                return true;
            }
        }
        return false;
    };
    /**
   * Transform the raw coords to target bounding.
   * @param x
   * @param y
   * @param width
   * @param height
   */ GeoJSONRegion.prototype.transformTo = function(x, y, width, height) {
        var rect = this.getBoundingRect();
        var aspect = rect.width / rect.height;
        if (!width) width = aspect * height;
        else if (!height) height = width / aspect;
        var target = new (0, $c437f598d9c9ee16$export$2e2bcd8739ae039)(x, y, width, height);
        var transform = rect.calculateTransform(target);
        var geometries = this.geometries;
        for(var i = 0; i < geometries.length; i++){
            var geo = geometries[i];
            if (geo.type === "polygon") {
                $79ee11e824769c68$var$transformPoints(geo.exterior, transform);
                (0, $43e0a445ed6711da$export$79b2f7037acddd43)(geo.interiors, function(interior) {
                    $79ee11e824769c68$var$transformPoints(interior, transform);
                });
            } else (0, $43e0a445ed6711da$export$79b2f7037acddd43)(geo.points, function(points) {
                $79ee11e824769c68$var$transformPoints(points, transform);
            });
        }
        rect = this._rect;
        rect.copy(target);
        // Update center
        this._center = [
            rect.x + rect.width / 2,
            rect.y + rect.height / 2
        ];
    };
    GeoJSONRegion.prototype.cloneShallow = function(name) {
        name == null && (name = this.name);
        var newRegion = new GeoJSONRegion(name, this.geometries, this._center);
        newRegion._rect = this._rect;
        newRegion.transformTo = null; // Simply avoid to be called.
        return newRegion;
    };
    return GeoJSONRegion;
}($79ee11e824769c68$export$b1f97c3099fc6872);
var $79ee11e824769c68$export$5f3d89e7254f3e69 = /** @class */ function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(GeoSVGRegion, _super);
    function GeoSVGRegion(name, elOnlyForCalculate) {
        var _this = _super.call(this, name) || this;
        _this.type = "geoSVG";
        _this._elOnlyForCalculate = elOnlyForCalculate;
        return _this;
    }
    GeoSVGRegion.prototype.calcCenter = function() {
        var el = this._elOnlyForCalculate;
        var rect = el.getBoundingRect();
        var center = [
            rect.x + rect.width / 2,
            rect.y + rect.height / 2
        ];
        var mat = $87ac8de5537d9a34$export$f0954fd7d5368655($79ee11e824769c68$var$TMP_TRANSFORM);
        var target = el;
        while(target && !target.isGeoSVGGraphicRoot){
            $87ac8de5537d9a34$export$6e3a27864ab166fe(mat, target.getLocalTransform(), mat);
            target = target.parent;
        }
        $87ac8de5537d9a34$export$6897c284b6f9f4dc(mat, mat);
        $ee491d8f32bd01ff$export$9f9dcb98c894b623(center, center, mat);
        return center;
    };
    return GeoSVGRegion;
}($79ee11e824769c68$export$b1f97c3099fc6872);


function $3b4146e40988ca14$var$decode(json) {
    if (!json.UTF8Encoding) return json;
    var jsonCompressed = json;
    var encodeScale = jsonCompressed.UTF8Scale;
    if (encodeScale == null) encodeScale = 1024;
    var features = jsonCompressed.features;
    $43e0a445ed6711da$export$79b2f7037acddd43(features, function(feature) {
        var geometry = feature.geometry;
        var encodeOffsets = geometry.encodeOffsets;
        var coordinates = geometry.coordinates;
        // Geometry may be appeded manually in the script after json loaded.
        // In this case this geometry is usually not encoded.
        if (!encodeOffsets) return;
        switch(geometry.type){
            case "LineString":
                geometry.coordinates = $3b4146e40988ca14$var$decodeRing(coordinates, encodeOffsets, encodeScale);
                break;
            case "Polygon":
                $3b4146e40988ca14$var$decodeRings(coordinates, encodeOffsets, encodeScale);
                break;
            case "MultiLineString":
                $3b4146e40988ca14$var$decodeRings(coordinates, encodeOffsets, encodeScale);
                break;
            case "MultiPolygon":
                $43e0a445ed6711da$export$79b2f7037acddd43(coordinates, function(rings, idx) {
                    return $3b4146e40988ca14$var$decodeRings(rings, encodeOffsets[idx], encodeScale);
                });
        }
    });
    // Has been decoded
    jsonCompressed.UTF8Encoding = false;
    return jsonCompressed;
}
function $3b4146e40988ca14$var$decodeRings(rings, encodeOffsets, encodeScale) {
    for(var c = 0; c < rings.length; c++)rings[c] = $3b4146e40988ca14$var$decodeRing(rings[c], encodeOffsets[c], encodeScale);
}
function $3b4146e40988ca14$var$decodeRing(coordinate, encodeOffsets, encodeScale) {
    var result = [];
    var prevX = encodeOffsets[0];
    var prevY = encodeOffsets[1];
    for(var i = 0; i < coordinate.length; i += 2){
        var x = coordinate.charCodeAt(i) - 64;
        var y = coordinate.charCodeAt(i + 1) - 64;
        // ZigZag decoding
        x = x >> 1 ^ -(x & 1);
        y = y >> 1 ^ -(y & 1);
        // Delta deocding
        x += prevX;
        y += prevY;
        prevX = x;
        prevY = y;
        // Dequantize
        result.push([
            x / encodeScale,
            y / encodeScale
        ]);
    }
    return result;
}
function $3b4146e40988ca14$export$2e2bcd8739ae039(geoJson, nameProperty) {
    geoJson = $3b4146e40988ca14$var$decode(geoJson);
    return $43e0a445ed6711da$export$871de8747c9eaa88($43e0a445ed6711da$export$3dea766d36a8935f(geoJson.features, function(featureObj) {
        // Output of mapshaper may have geometry null
        return featureObj.geometry && featureObj.properties && featureObj.geometry.coordinates.length > 0;
    }), function(featureObj) {
        var properties = featureObj.properties;
        var geo = featureObj.geometry;
        var geometries = [];
        switch(geo.type){
            case "Polygon":
                var coordinates = geo.coordinates;
                // According to the GeoJSON specification.
                // First must be exterior, and the rest are all interior(holes).
                geometries.push(new (0, $79ee11e824769c68$export$91e20b0f72443753)(coordinates[0], coordinates.slice(1)));
                break;
            case "MultiPolygon":
                $43e0a445ed6711da$export$79b2f7037acddd43(geo.coordinates, function(item) {
                    if (item[0]) geometries.push(new (0, $79ee11e824769c68$export$91e20b0f72443753)(item[0], item.slice(1)));
                });
                break;
            case "LineString":
                geometries.push(new (0, $79ee11e824769c68$export$335807c9e785d92c)([
                    geo.coordinates
                ]));
                break;
            case "MultiLineString":
                geometries.push(new (0, $79ee11e824769c68$export$335807c9e785d92c)(geo.coordinates));
        }
        var region = new (0, $79ee11e824769c68$export$ee84fcb463f24b3d)(properties[nameProperty || "name"], geometries, properties.cp);
        region.properties = properties;
        return region;
    });
}


var $d6699ee8efc6dae5$exports = {};

$parcel$export($d6699ee8efc6dae5$exports, "linearMap", function () { return $b49750109e236fd8$export$d3f68fbaa670562; });
$parcel$export($d6699ee8efc6dae5$exports, "round", function () { return $b49750109e236fd8$export$d6af03b9b5dd06d7; });
$parcel$export($d6699ee8efc6dae5$exports, "asc", function () { return $b49750109e236fd8$export$debe6e778e0a6d32; });
$parcel$export($d6699ee8efc6dae5$exports, "getPrecision", function () { return $b49750109e236fd8$export$e0c74b50bbd10f68; });
$parcel$export($d6699ee8efc6dae5$exports, "getPrecisionSafe", function () { return $b49750109e236fd8$export$6d86ba4ca4984d31; });
$parcel$export($d6699ee8efc6dae5$exports, "getPixelPrecision", function () { return $b49750109e236fd8$export$666260d9a2dda8a7; });
$parcel$export($d6699ee8efc6dae5$exports, "getPercentWithPrecision", function () { return $b49750109e236fd8$export$70cc11b075afeb90; });
$parcel$export($d6699ee8efc6dae5$exports, "parsePercent", function () { return $b49750109e236fd8$export$e8514cb5a5e2b40f; });
$parcel$export($d6699ee8efc6dae5$exports, "MAX_SAFE_INTEGER", function () { return $b49750109e236fd8$export$18510406f204a1b9; });
$parcel$export($d6699ee8efc6dae5$exports, "remRadian", function () { return $b49750109e236fd8$export$2ca6dd70a288b1c3; });
$parcel$export($d6699ee8efc6dae5$exports, "isRadianAroundZero", function () { return $b49750109e236fd8$export$d1df570aea2868f; });
$parcel$export($d6699ee8efc6dae5$exports, "parseDate", function () { return $b49750109e236fd8$export$6b862160d295c8e; });
$parcel$export($d6699ee8efc6dae5$exports, "quantity", function () { return $b49750109e236fd8$export$82dd68b83a44b253; });
$parcel$export($d6699ee8efc6dae5$exports, "quantityExponent", function () { return $b49750109e236fd8$export$97256a17b20a0c24; });
$parcel$export($d6699ee8efc6dae5$exports, "nice", function () { return $b49750109e236fd8$export$7a695fe44258210b; });
$parcel$export($d6699ee8efc6dae5$exports, "quantile", function () { return $b49750109e236fd8$export$651fb4afdb6caa4b; });
$parcel$export($d6699ee8efc6dae5$exports, "reformIntervals", function () { return $b49750109e236fd8$export$12f7386070bc380a; });
$parcel$export($d6699ee8efc6dae5$exports, "isNumeric", function () { return $b49750109e236fd8$export$e90fb89750dba83f; });
$parcel$export($d6699ee8efc6dae5$exports, "numericToNumber", function () { return $b49750109e236fd8$export$8b4007b942b45a96; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $efcfb25d726b7d93$exports = {};

$parcel$export($efcfb25d726b7d93$exports, "parse", function () { return $b49750109e236fd8$export$6b862160d295c8e; });
$parcel$export($efcfb25d726b7d93$exports, "format", function () { return $d28d71d6b904c104$export$d9468344d3651243; });
$parcel$export($efcfb25d726b7d93$exports, "roundTime", function () { return $d28d71d6b904c104$export$2ed3384313b02c28; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $3b38bcf86d23f285$exports = {};

$parcel$export($3b38bcf86d23f285$exports, "extendShape", function () { return $6552edac5ca572b1$export$d0d5398c9d612037; });
$parcel$export($3b38bcf86d23f285$exports, "extendPath", function () { return $6552edac5ca572b1$export$53b54a3137026af0; });
$parcel$export($3b38bcf86d23f285$exports, "makePath", function () { return $6552edac5ca572b1$export$aa9bab72412f5613; });
$parcel$export($3b38bcf86d23f285$exports, "makeImage", function () { return $6552edac5ca572b1$export$7a2bdede98851ac5; });
$parcel$export($3b38bcf86d23f285$exports, "mergePath", function () { return $6552edac5ca572b1$export$7b1dd269fbc4e903; });
$parcel$export($3b38bcf86d23f285$exports, "resizePath", function () { return $6552edac5ca572b1$export$566dbf1c62b04fc7; });
$parcel$export($3b38bcf86d23f285$exports, "createIcon", function () { return $6552edac5ca572b1$export$274edc73af1ae9c8; });
$parcel$export($3b38bcf86d23f285$exports, "updateProps", function () { return $4feffdaaa31d998e$export$c8dce3c08436e91e; });
$parcel$export($3b38bcf86d23f285$exports, "initProps", function () { return $4feffdaaa31d998e$export$a121566aadcfe021; });
$parcel$export($3b38bcf86d23f285$exports, "getTransform", function () { return $6552edac5ca572b1$export$fce0c6cfca85ed96; });
$parcel$export($3b38bcf86d23f285$exports, "clipPointsByRect", function () { return $6552edac5ca572b1$export$e2f409471bbbc1dc; });
$parcel$export($3b38bcf86d23f285$exports, "clipRectByRect", function () { return $6552edac5ca572b1$export$d0d3709202b8b2a; });
$parcel$export($3b38bcf86d23f285$exports, "registerShape", function () { return $6552edac5ca572b1$export$2b95b62e3aaf6fdd; });
$parcel$export($3b38bcf86d23f285$exports, "getShapeClass", function () { return $6552edac5ca572b1$export$51df4b5565a58189; });
$parcel$export($3b38bcf86d23f285$exports, "Group", function () { return $a8978f7a0e842e3d$export$2e2bcd8739ae039; });
$parcel$export($3b38bcf86d23f285$exports, "Image", function () { return $d3b0315ae8e8e298$export$2e2bcd8739ae039; });
$parcel$export($3b38bcf86d23f285$exports, "Text", function () { return $7db7960d25b39b7c$export$2e2bcd8739ae039; });
$parcel$export($3b38bcf86d23f285$exports, "Circle", function () { return $55c0fda972a24142$export$2e2bcd8739ae039; });
$parcel$export($3b38bcf86d23f285$exports, "Ellipse", function () { return $1d371afa26fdd11c$export$2e2bcd8739ae039; });
$parcel$export($3b38bcf86d23f285$exports, "Sector", function () { return $7a3d58339c1601e8$export$2e2bcd8739ae039; });
$parcel$export($3b38bcf86d23f285$exports, "Ring", function () { return $493646296ab90046$export$2e2bcd8739ae039; });
$parcel$export($3b38bcf86d23f285$exports, "Polygon", function () { return $dbc82dce785be05b$export$2e2bcd8739ae039; });
$parcel$export($3b38bcf86d23f285$exports, "Polyline", function () { return $363f38bff4966f60$export$2e2bcd8739ae039; });
$parcel$export($3b38bcf86d23f285$exports, "Rect", function () { return $42ed508a93973e78$export$2e2bcd8739ae039; });
$parcel$export($3b38bcf86d23f285$exports, "Line", function () { return $0e0ee2afac2bc66d$export$2e2bcd8739ae039; });
$parcel$export($3b38bcf86d23f285$exports, "BezierCurve", function () { return $57c0d9f749c3a837$export$2e2bcd8739ae039; });
$parcel$export($3b38bcf86d23f285$exports, "Arc", function () { return $d0a314b008adf9ab$export$2e2bcd8739ae039; });
$parcel$export($3b38bcf86d23f285$exports, "IncrementalDisplayable", function () { return $afb0e0140d20f85a$export$2e2bcd8739ae039; });
$parcel$export($3b38bcf86d23f285$exports, "CompoundPath", function () { return $21e4011e695d4132$export$2e2bcd8739ae039; });
$parcel$export($3b38bcf86d23f285$exports, "LinearGradient", function () { return $9cb489c6746d60b7$export$2e2bcd8739ae039; });
$parcel$export($3b38bcf86d23f285$exports, "RadialGradient", function () { return $675bf9bc44bcf0b5$export$2e2bcd8739ae039; });
$parcel$export($3b38bcf86d23f285$exports, "BoundingRect", function () { return $c437f598d9c9ee16$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $6c9f8059fa5b1aae$exports = {};

$parcel$export($6c9f8059fa5b1aae$exports, "addCommas", function () { return $78c2ece6dfa6bb7a$export$b6fe44657ce35c42; });
$parcel$export($6c9f8059fa5b1aae$exports, "toCamelCase", function () { return $78c2ece6dfa6bb7a$export$86f54f62aa7a7514; });
$parcel$export($6c9f8059fa5b1aae$exports, "normalizeCssArray", function () { return $78c2ece6dfa6bb7a$export$f3a38102c49f4268; });
$parcel$export($6c9f8059fa5b1aae$exports, "encodeHTML", function () { return $e2318d49eb46f886$export$f9d6449b9af28dc1; });
$parcel$export($6c9f8059fa5b1aae$exports, "formatTpl", function () { return $78c2ece6dfa6bb7a$export$2028496a35766e41; });
$parcel$export($6c9f8059fa5b1aae$exports, "getTooltipMarker", function () { return $78c2ece6dfa6bb7a$export$1987a3dbdf3c45ca; });
$parcel$export($6c9f8059fa5b1aae$exports, "formatTime", function () { return $78c2ece6dfa6bb7a$export$3203edd9e5edd663; });
$parcel$export($6c9f8059fa5b1aae$exports, "capitalFirst", function () { return $78c2ece6dfa6bb7a$export$38a1e7552f497c0e; });
$parcel$export($6c9f8059fa5b1aae$exports, "truncateText", function () { return $92d383513c7738d1$export$59a943b34a82e690; });
$parcel$export($6c9f8059fa5b1aae$exports, "getTextRect", function () { return $211347b2c684c0f2$export$372ffda650a6e70d; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $89827b2c1fddca99$exports = {};

$parcel$export($89827b2c1fddca99$exports, "map", function () { return $43e0a445ed6711da$export$871de8747c9eaa88; });
$parcel$export($89827b2c1fddca99$exports, "each", function () { return $43e0a445ed6711da$export$79b2f7037acddd43; });
$parcel$export($89827b2c1fddca99$exports, "indexOf", function () { return $43e0a445ed6711da$export$305f7d4e9d4624f2; });
$parcel$export($89827b2c1fddca99$exports, "inherits", function () { return $43e0a445ed6711da$export$69f1b2dcda23c5f8; });
$parcel$export($89827b2c1fddca99$exports, "reduce", function () { return $43e0a445ed6711da$export$533b26079ad0b4b; });
$parcel$export($89827b2c1fddca99$exports, "filter", function () { return $43e0a445ed6711da$export$3dea766d36a8935f; });
$parcel$export($89827b2c1fddca99$exports, "bind", function () { return $43e0a445ed6711da$export$2385a24977818dd0; });
$parcel$export($89827b2c1fddca99$exports, "curry", function () { return $43e0a445ed6711da$export$c3095a23b368d1f2; });
$parcel$export($89827b2c1fddca99$exports, "isArray", function () { return $43e0a445ed6711da$export$43bee75e5e14138e; });
$parcel$export($89827b2c1fddca99$exports, "isString", function () { return $43e0a445ed6711da$export$844ec244b1367d54; });
$parcel$export($89827b2c1fddca99$exports, "isObject", function () { return $43e0a445ed6711da$export$a6cdc56e425d0d0a; });
$parcel$export($89827b2c1fddca99$exports, "isFunction", function () { return $43e0a445ed6711da$export$f6e2535fb5126e54; });
$parcel$export($89827b2c1fddca99$exports, "extend", function () { return $43e0a445ed6711da$export$8b58be045bf06082; });
$parcel$export($89827b2c1fddca99$exports, "defaults", function () { return $43e0a445ed6711da$export$ebe90cb607ad99e; });
$parcel$export($89827b2c1fddca99$exports, "clone", function () { return $43e0a445ed6711da$export$9cd59f9826255e47; });
$parcel$export($89827b2c1fddca99$exports, "merge", function () { return $43e0a445ed6711da$export$4950aa0f605343fb; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $c897f028bf966826$var$modelInner = (0, $87f4a59ac66e0ee6$export$64df9f8d92ae083f)();
var $c897f028bf966826$var$axisInner = (0, $87f4a59ac66e0ee6$export$64df9f8d92ae083f)();
var $c897f028bf966826$export$31cba7db0a663292 = {
    estimate: 1,
    determine: 2
};
function $c897f028bf966826$export$12d6ac38274c43e7(kind) {
    return {
        out: {
            noPxChangeTryDetermine: []
        },
        kind: kind
    };
}
function $c897f028bf966826$export$10216ebd3e3e485e(axis, ctx) {
    var custom = axis.getLabelModel().get("customValues");
    if (custom) {
        var scale_1 = axis.scale;
        return {
            labels: $43e0a445ed6711da$export$871de8747c9eaa88($c897f028bf966826$var$parseTickLabelCustomValues(custom, scale_1), function(tick, index) {
                return {
                    formattedLabel: (0, $3e6d0d29922ecf90$export$742f19a75415b2ae)(axis)(tick, index),
                    rawLabel: scale_1.getLabel(tick),
                    tick: tick
                };
            })
        };
    }
    // Only ordinal scale support tick interval
    return axis.type === "category" ? $c897f028bf966826$var$makeCategoryLabels(axis, ctx) : $c897f028bf966826$var$makeRealNumberLabels(axis);
}
function $c897f028bf966826$export$7cccf6836ae8323c(axis, tickModel, opt) {
    var scale = axis.scale;
    var custom = axis.getTickModel().get("customValues");
    if (custom) return {
        ticks: $c897f028bf966826$var$parseTickLabelCustomValues(custom, scale)
    };
    // Only ordinal scale support tick interval
    return axis.type === "category" ? $c897f028bf966826$var$makeCategoryTicks(axis, tickModel) : {
        ticks: scale.getTicks(opt)
    };
}
function $c897f028bf966826$var$parseTickLabelCustomValues(customValues, scale) {
    var extent = scale.getExtent();
    var tickNumbers = [];
    $43e0a445ed6711da$export$79b2f7037acddd43(customValues, function(val) {
        val = scale.parse(val);
        if (val >= extent[0] && val <= extent[1]) tickNumbers.push(val);
    });
    (0, $87f4a59ac66e0ee6$export$2e2262a44ac61957)(tickNumbers, (0, $87f4a59ac66e0ee6$export$fec5e8fdd97d769b), null);
    (0, $b49750109e236fd8$export$debe6e778e0a6d32)(tickNumbers);
    return $43e0a445ed6711da$export$871de8747c9eaa88(tickNumbers, function(tickVal) {
        return {
            value: tickVal
        };
    });
}
function $c897f028bf966826$var$makeCategoryLabels(axis, ctx) {
    var labelModel = axis.getLabelModel();
    var result = $c897f028bf966826$var$makeCategoryLabelsActually(axis, labelModel, ctx);
    return !labelModel.get("show") || axis.scale.isBlank() ? {
        labels: []
    } : result;
}
function $c897f028bf966826$var$makeCategoryLabelsActually(axis, labelModel, ctx) {
    var labelsCache = $c897f028bf966826$var$ensureCategoryLabelCache(axis);
    var optionLabelInterval = (0, $3e6d0d29922ecf90$export$6d0bc2429155c088)(labelModel);
    var isEstimate = ctx.kind === $c897f028bf966826$export$31cba7db0a663292.estimate;
    // In AxisTickLabelComputingKind.estimate, the result likely varies during a single
    // pass of ec main process,due to the change of axisExtent, and will not be shared with
    // splitLine. Therefore no cache is used.
    if (!isEstimate) {
        // PENDING: check necessary?
        var result_1 = $c897f028bf966826$var$axisCacheGet(labelsCache, optionLabelInterval);
        if (result_1) return result_1;
    }
    var labels;
    var numericLabelInterval;
    if ($43e0a445ed6711da$export$f6e2535fb5126e54(optionLabelInterval)) labels = $c897f028bf966826$var$makeTicksLabelsByCategoryIntervalNumOrCb(axis, optionLabelInterval, false);
    else {
        numericLabelInterval = optionLabelInterval === "auto" ? $c897f028bf966826$var$makeAutoCategoryInterval(axis, ctx) : optionLabelInterval;
        labels = $c897f028bf966826$var$makeTicksLabelsByCategoryIntervalNumOrCb(axis, numericLabelInterval, false);
    }
    var result = {
        labels: labels,
        labelCategoryInterval: numericLabelInterval
    };
    if (!isEstimate) $c897f028bf966826$var$axisCacheSet(labelsCache, optionLabelInterval, result);
    else ctx.out.noPxChangeTryDetermine.push(function() {
        $c897f028bf966826$var$axisCacheSet(labelsCache, optionLabelInterval, result);
        return true;
    });
    return result;
}
function $c897f028bf966826$var$makeCategoryTicks(axis, tickModel) {
    var ticksCache = $c897f028bf966826$var$ensureCategoryTickCache(axis);
    var optionTickInterval = (0, $3e6d0d29922ecf90$export$6d0bc2429155c088)(tickModel);
    var result = $c897f028bf966826$var$axisCacheGet(ticksCache, optionTickInterval);
    if (result) return result;
    var ticks;
    var tickCategoryInterval;
    // Optimize for the case that large category data and no label displayed,
    // we should not return all ticks.
    if (!tickModel.get("show") || axis.scale.isBlank()) ticks = [];
    if ($43e0a445ed6711da$export$f6e2535fb5126e54(optionTickInterval)) ticks = $c897f028bf966826$var$makeTicksLabelsByCategoryIntervalNumOrCb(axis, optionTickInterval, true);
    else if (optionTickInterval === "auto") {
        var labelsResult = $c897f028bf966826$var$makeCategoryLabelsActually(axis, axis.getLabelModel(), $c897f028bf966826$export$12d6ac38274c43e7($c897f028bf966826$export$31cba7db0a663292.determine));
        tickCategoryInterval = labelsResult.labelCategoryInterval;
        ticks = $43e0a445ed6711da$export$871de8747c9eaa88(labelsResult.labels, function(labelItem) {
            return labelItem.tick;
        });
    } else {
        tickCategoryInterval = optionTickInterval;
        ticks = $c897f028bf966826$var$makeTicksLabelsByCategoryIntervalNumOrCb(axis, tickCategoryInterval, true);
    }
    // Cache to avoid calling interval function repeatedly.
    return $c897f028bf966826$var$axisCacheSet(ticksCache, optionTickInterval, {
        ticks: ticks,
        tickCategoryInterval: tickCategoryInterval
    });
}
function $c897f028bf966826$var$makeRealNumberLabels(axis) {
    var ticks = axis.scale.getTicks();
    var labelFormatter = (0, $3e6d0d29922ecf90$export$742f19a75415b2ae)(axis);
    return {
        labels: $43e0a445ed6711da$export$871de8747c9eaa88(ticks, function(tick, idx) {
            return {
                formattedLabel: labelFormatter(tick, idx),
                rawLabel: axis.scale.getLabel(tick),
                tick: tick
            };
        })
    };
}
// Large category data calculation is performance sensitive, and ticks and label probably will
// be fetched multiple times (e.g. shared by splitLine and axisTick). So we cache the result.
// axis is created each time during a ec process, so we do not need to clear cache.
var $c897f028bf966826$var$ensureCategoryTickCache = $c897f028bf966826$var$initAxisCacheMethod("axisTick");
var $c897f028bf966826$var$ensureCategoryLabelCache = $c897f028bf966826$var$initAxisCacheMethod("axisLabel");
/**
 * PENDING: refactor to JS Map? Because key can be a function or more complicated object, and
 * cache size always is small, and currently no JS Map object key polyfill, we use a simple
 * array cache instead of plain object hash.
 */ function $c897f028bf966826$var$initAxisCacheMethod(prop) {
    return function ensureCache(axis) {
        return $c897f028bf966826$var$axisInner(axis)[prop] || ($c897f028bf966826$var$axisInner(axis)[prop] = {
            list: []
        });
    };
}
function $c897f028bf966826$var$axisCacheGet(cache, key) {
    for(var i = 0; i < cache.list.length; i++){
        if (cache.list[i].key === key) return cache.list[i].value;
    }
}
function $c897f028bf966826$var$axisCacheSet(cache, key, value) {
    cache.list.push({
        key: key,
        value: value
    });
    return value;
}
function $c897f028bf966826$var$makeAutoCategoryInterval(axis, ctx) {
    if (ctx.kind === $c897f028bf966826$export$31cba7db0a663292.estimate) {
        // Currently axisTick is not involved in estimate kind, and the result likely varies during a
        // single pass of ec main process, due to the change of axisExtent. Therefore no cache is used.
        var result_2 = axis.calculateCategoryInterval(ctx);
        ctx.out.noPxChangeTryDetermine.push(function() {
            $c897f028bf966826$var$axisInner(axis).autoInterval = result_2;
            return true;
        });
        return result_2;
    }
    // Both tick and label uses this result, cacah it to avoid recompute.
    var result = $c897f028bf966826$var$axisInner(axis).autoInterval;
    return result != null ? result : $c897f028bf966826$var$axisInner(axis).autoInterval = axis.calculateCategoryInterval(ctx);
}
function $c897f028bf966826$export$9ea1d3f146a5a65f(axis, ctx) {
    var kind = ctx.kind;
    var params = $c897f028bf966826$var$fetchAutoCategoryIntervalCalculationParams(axis);
    var labelFormatter = (0, $3e6d0d29922ecf90$export$742f19a75415b2ae)(axis);
    var rotation = (params.axisRotate - params.labelRotate) / 180 * Math.PI;
    var ordinalScale = axis.scale;
    var ordinalExtent = ordinalScale.getExtent();
    // Providing this method is for optimization:
    // avoid generating a long array by `getTicks`
    // in large category data case.
    var tickCount = ordinalScale.count();
    if (ordinalExtent[1] - ordinalExtent[0] < 1) return 0;
    var step = 1;
    // Simple optimization. Arbitrary value.
    var maxCount = 40;
    if (tickCount > maxCount) step = Math.max(1, Math.floor(tickCount / maxCount));
    var tickValue = ordinalExtent[0];
    var unitSpan = axis.dataToCoord(tickValue + 1) - axis.dataToCoord(tickValue);
    var unitW = Math.abs(unitSpan * Math.cos(rotation));
    var unitH = Math.abs(unitSpan * Math.sin(rotation));
    var maxW = 0;
    var maxH = 0;
    // Caution: Performance sensitive for large category data.
    // Consider dataZoom, we should make appropriate step to avoid O(n) loop.
    for(; tickValue <= ordinalExtent[1]; tickValue += step){
        var width = 0;
        var height = 0;
        // Not precise, do not consider align and vertical align
        // and each distance from axis line yet.
        var rect = $67e15a06bdb46d49$export$c381147bfed79d9f(labelFormatter({
            value: tickValue
        }), params.font, "center", "top");
        // Magic number
        width = rect.width * 1.3;
        height = rect.height * 1.3;
        // Min size, void long loop.
        maxW = Math.max(maxW, width, 7);
        maxH = Math.max(maxH, height, 7);
    }
    var dw = maxW / unitW;
    var dh = maxH / unitH;
    // 0/0 is NaN, 1/0 is Infinity.
    isNaN(dw) && (dw = Infinity);
    isNaN(dh) && (dh = Infinity);
    var interval = Math.max(0, Math.floor(Math.min(dw, dh)));
    if (kind === $c897f028bf966826$export$31cba7db0a663292.estimate) {
        // In estimate kind, the inteval likely varies, thus do not erase the cache.
        ctx.out.noPxChangeTryDetermine.push($43e0a445ed6711da$export$2385a24977818dd0($c897f028bf966826$var$calculateCategoryIntervalTryDetermine, null, axis, interval, tickCount));
        return interval;
    }
    var lastInterval = $c897f028bf966826$var$calculateCategoryIntervalDealCache(axis, interval, tickCount);
    return lastInterval != null ? lastInterval : interval;
}
function $c897f028bf966826$var$calculateCategoryIntervalTryDetermine(axis, interval, tickCount) {
    return $c897f028bf966826$var$calculateCategoryIntervalDealCache(axis, interval, tickCount) == null;
}
// Return the lastInterval if need to use it, otherwise return NullUndefined and save cache.
function $c897f028bf966826$var$calculateCategoryIntervalDealCache(axis, interval, tickCount) {
    var cache = $c897f028bf966826$var$modelInner(axis.model);
    var axisExtent = axis.getExtent();
    var lastAutoInterval = cache.lastAutoInterval;
    var lastTickCount = cache.lastTickCount;
    // Use cache to keep interval stable while moving zoom window,
    // otherwise the calculated interval might jitter when the zoom
    // window size is close to the interval-changing size.
    // For example, if all of the axis labels are `a, b, c, d, e, f, g`.
    // The jitter will cause that sometimes the displayed labels are
    // `a, d, g` (interval: 2) sometimes `a, c, e`(interval: 1).
    if (lastAutoInterval != null && lastTickCount != null && Math.abs(lastAutoInterval - interval) <= 1 && Math.abs(lastTickCount - tickCount) <= 1 && lastAutoInterval > interval && cache.axisExtent0 === axisExtent[0] && cache.axisExtent1 === axisExtent[1]) return lastAutoInterval;
    else {
        cache.lastTickCount = tickCount;
        cache.lastAutoInterval = interval;
        cache.axisExtent0 = axisExtent[0];
        cache.axisExtent1 = axisExtent[1];
    }
}
function $c897f028bf966826$var$fetchAutoCategoryIntervalCalculationParams(axis) {
    var labelModel = axis.getLabelModel();
    return {
        axisRotate: axis.getRotate ? axis.getRotate() : axis.isHorizontal && !axis.isHorizontal() ? 90 : 0,
        labelRotate: labelModel.get("rotate") || 0,
        font: labelModel.getFont()
    };
}
function $c897f028bf966826$var$makeTicksLabelsByCategoryIntervalNumOrCb(axis, categoryInterval, onlyTick) {
    var labelFormatter = (0, $3e6d0d29922ecf90$export$742f19a75415b2ae)(axis);
    var ordinalScale = axis.scale;
    var result = [];
    var categoryIntervalIsCb = $43e0a445ed6711da$export$f6e2535fb5126e54(categoryInterval);
    (0, $eb97010bfdf4c825$export$1039c7e66c46a7fd)(ordinalScale, categoryIntervalIsCb ? 0 : categoryInterval, function(tickObj, isExtentBoundary) {
        var tickLabel = ordinalScale.getLabel(tickObj);
        if (categoryIntervalIsCb) {
            // When interval is function, a falsy return means ignore the tick.
            // It is time consuming for large category data.
            var isOnInterval = !!categoryInterval(tickObj.value, tickLabel);
            tickObj.offInterval = !isOnInterval;
            // axis extent min max labels should be always included and the display strategy
            // is adopted uniformly later in `AxisBuilder`.
            if (!isOnInterval && !isExtentBoundary) return;
        }
        result.push(onlyTick ? tickObj : {
            formattedLabel: labelFormatter(tickObj),
            rawLabel: tickLabel,
            tick: tickObj
        });
    });
    return result;
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




// Arbitrary, leave some space to avoid overflowing when dataZoom moving.
var $8c5e7e1639db3579$var$FALLBACK_BAND_WIDTH_RATIO = 0.8;
function $8c5e7e1639db3579$export$141021262b29d96e(axis, opt) {
    opt = opt || {};
    var out = {
        w: NaN,
        w2: NaN
    };
    var scale = axis.scale;
    var fromStat = opt.fromStat;
    var min = opt.min;
    // [BAND_WIDTH_USED_SCALE_LINEAR_SPAN]
    //  - Band width should always respect to the currently specified extent, and `SCALE_EXTENT_KIND_MAPPING`
    //    should be used if specified.
    //    Otherwise, the result may incorrect, especially when data count is small.
    //    For example, when "containShape" is calculating, no `SCALE_EXTENT_KIND_MAPPING` is set, so here only
    //    `SCALE_EXTENT_KIND_EFFECTIVE` is returned, say, `[3, 5]`, based on which a `SCALE_EXTENT_KIND_MAPPING`
    //    is calculated, say `[2.5, 5.5]` (expanded by `0.5`). Then when rendering, that `SCALE_EXTENT_KIND_MAPPING`
    //    is returned here.
    //    See AXIS_CONTAIN_SHAPE_COMMON_STRATEGY for more details.
    //  - The span should be in the linear space (typically, the innermost space).
    //  - We use the scale extent after being zoommed and `intervalScaleEnsureValidExtent`-ish applied and
    //    "nice"/"align" applied, because:
    //    - For OrdinalScale, fine;
    //    - For numeric scale, `scaleLinearSpan` is normally not used for a consistent result when `dataZoom`
    //      is applied, but used when none or single data item case.
    var scaleLinearSpan = (0, $3123530578a35744$export$285c6793ade939bf)(scale);
    if (!(0, $b49750109e236fd8$export$b5c30d4208814a65)(scaleLinearSpan)) // scale may be `[Infinity, -Infinity]`.
    scaleLinearSpan = NaN;
    var axisExtent = axis.getExtent();
    // Always use a new pxSpan because it may be changed in `grid` contain label calculation.
    var pxSpan = (0, $b49750109e236fd8$export$5860c226b237d9a6)(axisExtent[1] - axisExtent[0]);
    if ((0, $eb97010bfdf4c825$export$61579433626afe87)(scale)) $8c5e7e1639db3579$var$calcBandWidthForCategoryAxis(out, axis, scaleLinearSpan, pxSpan);
    else if (fromStat) $8c5e7e1639db3579$var$calcBandWidthForNumericAxis(out, axis, scaleLinearSpan, pxSpan, fromStat);
    else min;
    if (min != null) out.w = (0, $b49750109e236fd8$export$b5c30d4208814a65)(out.w) ? (0, $b49750109e236fd8$export$2ca8010d037f830f)(min, out.w) : min;
    return out;
}
function $8c5e7e1639db3579$var$calcBandWidthForCategoryAxis(out, axis, scaleLinearSpan, pxSpan) {
    var onBand = axis.onBand;
    var len = scaleLinearSpan + (onBand ? 1 : 0);
    // Fix #2728, avoid NaN when only one data.
    len === 0 && (len = 1);
    out.w = pxSpan / len;
    // NOTE:
    //  - When `scaleLinearSpan === 0`, no need to expand extent.
    //  - `onBand: true` (`boundaryGap: true`) does not need to support `containShape`,
    //    thereby no `invRatio`.
    if (!onBand && scaleLinearSpan && pxSpan) out.w2 = out.w * scaleLinearSpan / pxSpan;
}
function $8c5e7e1639db3579$var$calcBandWidthForNumericAxis(out, axis, scaleLinearSpan, pxSpan, fromStat) {
    var onlySingular = false;
    var bandWidthInData = -Infinity;
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)(fromStat.key ? [
        (0, $37f4ae2e6793c3da$export$bf9727b05f222b53)(axis, fromStat.key)
    ] : (0, $37f4ae2e6793c3da$export$89af6c808d6573fd)(axis, fromStat.sers || []), function(stat) {
        var liPosMinGap = stat.liPosMinGap;
        // NOTE: `liPosMinGap == null` may indicate that `requireAxisStatistics`
        // is not used by any series on this axis. We should not make `bandWidth`
        // for this case.
        if (liPosMinGap != null) {
            if (liPosMinGap > 0) {
                if (liPosMinGap > bandWidthInData) bandWidthInData = liPosMinGap;
                onlySingular = false;
            } else if (liPosMinGap === (0, $37f4ae2e6793c3da$export$3faff2d166c13471)) onlySingular = true;
        }
    });
    if ((0, $b49750109e236fd8$export$b5c30d4208814a65)(scaleLinearSpan) && scaleLinearSpan > 0 && (0, $b49750109e236fd8$export$b5c30d4208814a65)(bandWidthInData)) {
        out.w = pxSpan / scaleLinearSpan * bandWidthInData;
        out.w2 = bandWidthInData;
    } else if (onlySingular) {
        // This is the special handing for single value case, where min gap can not
        // be calculated, but `w` and `w2` (for "containShape") are still needed.
        out.w = pxSpan * $8c5e7e1639db3579$var$FALLBACK_BAND_WIDTH_RATIO;
        out.w2 = out.w * scaleLinearSpan / pxSpan;
    // Consider an axis has both candlestick and bar series, where candlestick has multiple data
    // but the bar series has no data. In this case, that bar series should be ignored; otherwise,
    // the axis will be significantly expanded by "containShape" but no bar shape displayed.
    }
}



var $17d11437fadc71c2$var$NORMALIZED_EXTENT = [
    0,
    1
];
/**
 * Base class of Axis.
 *
 * Lifetime: recreate for each main process.
 * [NOTICE]: Some caches is stored on the axis instance (e.g., `axisTickLabelBuilder.ts`, `scaleRawExtentInfo.ts`),
 *  which is based on this lifetime.
 */ var $17d11437fadc71c2$var$Axis = /** @class */ function() {
    function Axis(dim, scale, extent) {
        // NOTICE: Must ensure `true` is only available on 'category' axis.
        this.onBand = false;
        // Make sure that `extent[0] > extent[1]` only if `inverse: true`.
        // `inverse` can be inferred by `extent` unless `extent[0] === extent[1]`.
        this.inverse = false;
        this.dim = dim;
        this.scale = scale;
        this._extent = extent || [
            0,
            0
        ];
    }
    /**
   * If axis extent contain given coord
   */ Axis.prototype.contain = function(coord) {
        var extent = this._extent;
        var min = Math.min(extent[0], extent[1]);
        var max = Math.max(extent[0], extent[1]);
        return coord >= min && coord <= max;
    };
    /**
   * If axis extent contain given data
   */ Axis.prototype.containData = function(data) {
        return this.scale.contain(this.scale.parse(data));
    };
    /**
   * Get coord extent.
   */ Axis.prototype.getExtent = function() {
        return this._extent.slice();
    };
    /**
   * Set coord extent
   */ Axis.prototype.setExtent = function(start, end) {
        var extent = this._extent;
        extent[0] = start;
        extent[1] = end;
    };
    /**
   * Convert data to coord. Data is the rank if it has an ordinal scale
   */ Axis.prototype.dataToCoord = function(data, clamp) {
        var scale = this.scale;
        data = scale.normalize(scale.parse(data));
        return (0, $b49750109e236fd8$export$d3f68fbaa670562)(data, $17d11437fadc71c2$var$NORMALIZED_EXTENT, $17d11437fadc71c2$var$makeExtentWithBands(this), clamp);
    };
    /**
   * Convert coord to data. Data is the rank if it has an ordinal scale
   */ Axis.prototype.coordToData = function(coord, clamp) {
        var t = (0, $b49750109e236fd8$export$d3f68fbaa670562)(coord, $17d11437fadc71c2$var$makeExtentWithBands(this), $17d11437fadc71c2$var$NORMALIZED_EXTENT, clamp);
        return this.scale.scale(t);
    };
    /**
   * Convert pixel point to data in axis
   */ Axis.prototype.pointToData = function(point, clamp) {
        // Should be implemented in derived class if necessary.
        return;
    };
    /**
   * Different from `zrUtil.map(axis.getTicks(), axis.dataToCoord, axis)`,
   * `axis.getTicksCoords` considers `onBand`, which is used by
   * `boundaryGap:true` of category axis and splitLine and splitArea.
   * @param opt.tickModel default: axis.model.getModel('axisTick')
   */ Axis.prototype.getTicksCoords = function(opt) {
        opt = opt || {};
        var tickModel = opt.tickModel || this.getTickModel();
        var result = (0, $c897f028bf966826$export$7cccf6836ae8323c)(this, tickModel, {
            breakTicks: opt.breakTicks,
            pruneByBreak: opt.pruneByBreak
        });
        var preTicksCoords = (0, $43e0a445ed6711da$export$871de8747c9eaa88)(result.ticks, function(tick) {
            return {
                coord: this.dataToCoord((0, $3e6d0d29922ecf90$export$889d2956111fd257)(this.scale, tick)),
                tick: tick
            };
        }, this);
        var alignWithLabel = tickModel.get("alignWithLabel");
        var onBandModified = $17d11437fadc71c2$var$fixOnBandTicksCoords(this, preTicksCoords, alignWithLabel);
        return (0, $43e0a445ed6711da$export$871de8747c9eaa88)(preTicksCoords, function(item) {
            return {
                coord: item.coord,
                tickValue: item.tick.value,
                onBand: onBandModified
            };
        });
    };
    Axis.prototype.getMinorTicksCoords = function() {
        if ((0, $eb97010bfdf4c825$export$61579433626afe87)(this.scale)) // Category axis doesn't support minor ticks
        return [];
        var minorTickModel = this.model.getModel("minorTick");
        var splitNumber = minorTickModel.get("splitNumber");
        // Protection.
        if (!(splitNumber > 0 && splitNumber < 100)) splitNumber = 5;
        var minorTicks = this.scale.getMinorTicks(splitNumber);
        var minorTicksCoords = (0, $43e0a445ed6711da$export$871de8747c9eaa88)(minorTicks, function(minorTicksGroup) {
            return (0, $43e0a445ed6711da$export$871de8747c9eaa88)(minorTicksGroup, function(minorTick) {
                return {
                    coord: this.dataToCoord(minorTick),
                    tickValue: minorTick
                };
            }, this);
        }, this);
        return minorTicksCoords;
    };
    Axis.prototype.getViewLabels = function(ctx) {
        ctx = ctx || (0, $c897f028bf966826$export$12d6ac38274c43e7)((0, $c897f028bf966826$export$31cba7db0a663292).determine);
        return (0, $c897f028bf966826$export$10216ebd3e3e485e)(this, ctx).labels;
    };
    Axis.prototype.getLabelModel = function() {
        return this.model.getModel("axisLabel");
    };
    /**
   * Notice here we only get the default tick model. For splitLine
   * or splitArea, we should pass the splitLineModel or splitAreaModel
   * manually when calling `getTicksCoords`.
   * In GL, this method may be overridden to:
   * `axisModel.getModel('axisTick', grid3DModel.getModel('axisTick'));`
   */ Axis.prototype.getTickModel = function() {
        return this.model.getModel("axisTick");
    };
    /**
   * @deprecated Use `calcBandWidth` instead.
   */ Axis.prototype.getBandWidth = function() {
        return (0, $8c5e7e1639db3579$export$141021262b29d96e)(this, {
            min: 1
        }).w;
    // NOTICE: Do not add logic here. Implement everthing in `calcBandWidth`.
    };
    /**
   * Only be called in category axis.
   * Can be overridden, consider other axes like in 3D.
   * @return Auto interval for category axis tick and label
   */ Axis.prototype.calculateCategoryInterval = function(ctx) {
        ctx = ctx || (0, $c897f028bf966826$export$12d6ac38274c43e7)((0, $c897f028bf966826$export$31cba7db0a663292).determine);
        return (0, $c897f028bf966826$export$9ea1d3f146a5a65f)(this, ctx);
    };
    return Axis;
}();
function $17d11437fadc71c2$var$makeExtentWithBands(axis) {
    var extent = axis.getExtent();
    if (axis.onBand) {
        var size = extent[1] - extent[0];
        var margin = size / axis.scale.count() / 2;
        extent[0] += margin;
        extent[1] -= margin;
    }
    return extent;
}
/**
 * `axis.onBand: true` (i.e., `boundaryGap: true` in ec option) and `CategoryTickLabelSplitIntervalOption`
 *  affects `axisTick`/`axisLabel`/`splitLine`/`splitArea`.
 *
 * Currently, the visual result is best only when `axisTick/splitLine/splitArea.interval === 0`.
 * The typical case is:
 *      |---|---|---|     <= This is the input `preTicksCoords`
 *      0   1   2   3        (having been added half band width by `makeExtentWithBands`).
 *    |---|---|---|---|  <= This is the result.
 *      0   1   2   3
 *
 * When `interval > 0`, the visual result may be odd for `axisLabel` and `customValues`, but acceptable
 * for `axisTick` `splitLine` and `splitArea`:
 *      |---~---|---~---~---|---|    <= This is the input `preTicksCoords`; `interval: 2; min: 1; max: 7`.
 *      ₁   ₂   3   ₄   ₅   6   ₇       Subscript numbers (`₀`, `₁`, `₃`) indicate axis labels are hidden
 *                                      (by default settings) due to off-interval.
 *                                      A tilde (`~`) indicates a tick ignored due to off-interval.
 *    |---~---|---~---~---|---~---|  <= This is the result.
 *      ₁   ₂   3   ₄   ₅   6   ₇
 *
 * NOTE:
 *  - A inappropriate result may cause misleading (e.g., split 2 bars of a single data item when there
 *    are two bar series).
 *  - See also #11176 #11186 .
 * PENDING:
 *  - The show/hide of `axisLabel` may be optimized when `interval > 1 and be an even number`,
 *    but that may introduce complex and still not perfect in odd number, and may not necessary if
 *    `axisTick: {show: false}` and `axisLabel` can auto hidden when overlapping.
 */ function $17d11437fadc71c2$var$fixOnBandTicksCoords(axis, preTicksCoords, alignWithLabel) {
    var ticksLen = preTicksCoords.length;
    if (!axis.onBand || alignWithLabel || !ticksLen) return false;
    // Assume:
    //  - If `onBand: true`, `bandWidth` has been calculated by `ticksLen + 1` rather than `ticksLen`.
    //  - If `interval > 0`, some ticks may be ignored, but `ticksCoords` has always included boundary
    //    ticks of axis extent, and be `offInterval: true` if off-interval.
    //  - No need to consider breaks, since axis break is not supported in category axis.
    var bandWidth = (0, $8c5e7e1639db3579$export$141021262b29d96e)(axis).w;
    if (!bandWidth) return false;
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)(preTicksCoords, function(ticksItem) {
        ticksItem.coord -= bandWidth / 2;
    });
    var dataExtent = axis.scale.getExtent();
    var oldLast = preTicksCoords[ticksLen - 1];
    if (oldLast.tick.offInterval) preTicksCoords.pop();
    preTicksCoords.push({
        coord: oldLast.coord + bandWidth,
        tick: {
            value: dataExtent[1] + 1
        }
    });
    return true;
}
var $17d11437fadc71c2$export$2e2bcd8739ae039 = $17d11437fadc71c2$var$Axis;



function $e57dbd7cfd9aef2e$export$4dd01020bb736662(proto) {
    var Model = (0, $4a9041b12b787d1b$export$2e2bcd8739ae039).extend(proto);
    (0, $4a9041b12b787d1b$export$2e2bcd8739ae039).registerClass(Model);
    return Model;
}
function $e57dbd7cfd9aef2e$export$a4336148da8ef02(proto) {
    var View = (0, $c81700f6bd52c5a7$export$2e2bcd8739ae039).extend(proto);
    (0, $c81700f6bd52c5a7$export$2e2bcd8739ae039).registerClass(View);
    return View;
}
function $e57dbd7cfd9aef2e$export$fe6d3114e3fc260c(proto) {
    var Model = (0, $39002e2f499d7a2f$export$2e2bcd8739ae039).extend(proto);
    (0, $39002e2f499d7a2f$export$2e2bcd8739ae039).registerClass(Model);
    return Model;
}
function $e57dbd7cfd9aef2e$export$c750883d1b603e83(proto) {
    var View = (0, $9bc1fbefe72d5b26$export$2e2bcd8739ae039).extend(proto);
    (0, $9bc1fbefe72d5b26$export$2e2bcd8739ae039).registerClass(View);
    return View;
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // TODO: move labels out of viewport.




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







var $7cea174eb56f6e38$var$PI2 = Math.PI * 2;
var $7cea174eb56f6e38$var$CMD = (0, $e2a16933ef78a053$export$2e2bcd8739ae039).CMD;
var $7cea174eb56f6e38$var$DEFAULT_SEARCH_SPACE = [
    "top",
    "right",
    "bottom",
    "left"
];
function $7cea174eb56f6e38$var$getCandidateAnchor(pos, distance, rect, outPt, outDir) {
    var width = rect.width;
    var height = rect.height;
    switch(pos){
        case "top":
            outPt.set(rect.x + width / 2, rect.y - distance);
            outDir.set(0, -1);
            break;
        case "bottom":
            outPt.set(rect.x + width / 2, rect.y + height + distance);
            outDir.set(0, 1);
            break;
        case "left":
            outPt.set(rect.x - distance, rect.y + height / 2);
            outDir.set(-1, 0);
            break;
        case "right":
            outPt.set(rect.x + width + distance, rect.y + height / 2);
            outDir.set(1, 0);
            break;
    }
}
function $7cea174eb56f6e38$var$projectPointToArc(cx, cy, r, startAngle, endAngle, anticlockwise, x, y, out) {
    x -= cx;
    y -= cy;
    var d = Math.sqrt(x * x + y * y);
    x /= d;
    y /= d;
    // Intersect point.
    var ox = x * r + cx;
    var oy = y * r + cy;
    if (Math.abs(startAngle - endAngle) % $7cea174eb56f6e38$var$PI2 < 1e-4) {
        // Is a circle
        out[0] = ox;
        out[1] = oy;
        return d - r;
    }
    if (anticlockwise) {
        var tmp = startAngle;
        startAngle = (0, $865d7df327ec107b$export$d44861331f213635)(endAngle);
        endAngle = (0, $865d7df327ec107b$export$d44861331f213635)(tmp);
    } else {
        startAngle = (0, $865d7df327ec107b$export$d44861331f213635)(startAngle);
        endAngle = (0, $865d7df327ec107b$export$d44861331f213635)(endAngle);
    }
    if (startAngle > endAngle) endAngle += $7cea174eb56f6e38$var$PI2;
    var angle = Math.atan2(y, x);
    if (angle < 0) angle += $7cea174eb56f6e38$var$PI2;
    if (angle >= startAngle && angle <= endAngle || angle + $7cea174eb56f6e38$var$PI2 >= startAngle && angle + $7cea174eb56f6e38$var$PI2 <= endAngle) {
        // Project point is on the arc.
        out[0] = ox;
        out[1] = oy;
        return d - r;
    }
    var x1 = r * Math.cos(startAngle) + cx;
    var y1 = r * Math.sin(startAngle) + cy;
    var x2 = r * Math.cos(endAngle) + cx;
    var y2 = r * Math.sin(endAngle) + cy;
    var d1 = (x1 - x) * (x1 - x) + (y1 - y) * (y1 - y);
    var d2 = (x2 - x) * (x2 - x) + (y2 - y) * (y2 - y);
    if (d1 < d2) {
        out[0] = x1;
        out[1] = y1;
        return Math.sqrt(d1);
    } else {
        out[0] = x2;
        out[1] = y2;
        return Math.sqrt(d2);
    }
}
function $7cea174eb56f6e38$var$projectPointToLine(x1, y1, x2, y2, x, y, out, limitToEnds) {
    var dx = x - x1;
    var dy = y - y1;
    var dx1 = x2 - x1;
    var dy1 = y2 - y1;
    var lineLen = Math.sqrt(dx1 * dx1 + dy1 * dy1);
    dx1 /= lineLen;
    dy1 /= lineLen;
    // dot product
    var projectedLen = dx * dx1 + dy * dy1;
    var t = projectedLen / lineLen;
    if (limitToEnds) t = Math.min(Math.max(t, 0), 1);
    t *= lineLen;
    var ox = out[0] = x1 + t * dx1;
    var oy = out[1] = y1 + t * dy1;
    return Math.sqrt((ox - x) * (ox - x) + (oy - y) * (oy - y));
}
function $7cea174eb56f6e38$var$projectPointToRect(x1, y1, width, height, x, y, out) {
    if (width < 0) {
        x1 = x1 + width;
        width = -width;
    }
    if (height < 0) {
        y1 = y1 + height;
        height = -height;
    }
    var x2 = x1 + width;
    var y2 = y1 + height;
    var ox = out[0] = Math.min(Math.max(x, x1), x2);
    var oy = out[1] = Math.min(Math.max(y, y1), y2);
    return Math.sqrt((ox - x) * (ox - x) + (oy - y) * (oy - y));
}
var $7cea174eb56f6e38$var$tmpPt = [];
function $7cea174eb56f6e38$var$nearestPointOnRect(pt, rect, out) {
    var dist = $7cea174eb56f6e38$var$projectPointToRect(rect.x, rect.y, rect.width, rect.height, pt.x, pt.y, $7cea174eb56f6e38$var$tmpPt);
    out.set($7cea174eb56f6e38$var$tmpPt[0], $7cea174eb56f6e38$var$tmpPt[1]);
    return dist;
}
/**
 * Calculate min distance corresponding point.
 * This method won't evaluate if point is in the path.
 */ function $7cea174eb56f6e38$var$nearestPointOnPath(pt, path, out) {
    var xi = 0;
    var yi = 0;
    var x0 = 0;
    var y0 = 0;
    var x1;
    var y1;
    var minDist = Infinity;
    var data = path.data;
    var x = pt.x;
    var y = pt.y;
    for(var i = 0; i < data.length;){
        var cmd = data[i++];
        if (i === 1) {
            xi = data[i];
            yi = data[i + 1];
            x0 = xi;
            y0 = yi;
        }
        var d = minDist;
        switch(cmd){
            case $7cea174eb56f6e38$var$CMD.M:
                // moveTo 命令重新创建一个新的 subpath, 并且更新新的起点
                // 在 closePath 的时候使用
                x0 = data[i++];
                y0 = data[i++];
                xi = x0;
                yi = y0;
                break;
            case $7cea174eb56f6e38$var$CMD.L:
                d = $7cea174eb56f6e38$var$projectPointToLine(xi, yi, data[i], data[i + 1], x, y, $7cea174eb56f6e38$var$tmpPt, true);
                xi = data[i++];
                yi = data[i++];
                break;
            case $7cea174eb56f6e38$var$CMD.C:
                d = (0, $3dec70ca5f6b6e8f$export$dbaa3801d1284367)(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], x, y, $7cea174eb56f6e38$var$tmpPt);
                xi = data[i++];
                yi = data[i++];
                break;
            case $7cea174eb56f6e38$var$CMD.Q:
                d = (0, $3dec70ca5f6b6e8f$export$81915a594fe10dee)(xi, yi, data[i++], data[i++], data[i], data[i + 1], x, y, $7cea174eb56f6e38$var$tmpPt);
                xi = data[i++];
                yi = data[i++];
                break;
            case $7cea174eb56f6e38$var$CMD.A:
                // TODO Arc 判断的开销比较大
                var cx = data[i++];
                var cy = data[i++];
                var rx = data[i++];
                var ry = data[i++];
                var theta = data[i++];
                var dTheta = data[i++];
                // TODO Arc 旋转
                i += 1;
                var anticlockwise = !!(1 - data[i++]);
                x1 = Math.cos(theta) * rx + cx;
                y1 = Math.sin(theta) * ry + cy;
                // 不是直接使用 arc 命令
                if (i <= 1) {
                    // 第一个命令起点还未定义
                    x0 = x1;
                    y0 = y1;
                }
                // zr 使用scale来模拟椭圆, 这里也对x做一定的缩放
                var _x = (x - cx) * ry / rx + cx;
                d = $7cea174eb56f6e38$var$projectPointToArc(cx, cy, ry, theta, theta + dTheta, anticlockwise, _x, y, $7cea174eb56f6e38$var$tmpPt);
                xi = Math.cos(theta + dTheta) * rx + cx;
                yi = Math.sin(theta + dTheta) * ry + cy;
                break;
            case $7cea174eb56f6e38$var$CMD.R:
                x0 = xi = data[i++];
                y0 = yi = data[i++];
                var width = data[i++];
                var height = data[i++];
                d = $7cea174eb56f6e38$var$projectPointToRect(x0, y0, width, height, x, y, $7cea174eb56f6e38$var$tmpPt);
                break;
            case $7cea174eb56f6e38$var$CMD.Z:
                d = $7cea174eb56f6e38$var$projectPointToLine(xi, yi, x0, y0, x, y, $7cea174eb56f6e38$var$tmpPt, true);
                xi = x0;
                yi = y0;
                break;
        }
        if (d < minDist) {
            minDist = d;
            out.set($7cea174eb56f6e38$var$tmpPt[0], $7cea174eb56f6e38$var$tmpPt[1]);
        }
    }
    return minDist;
}
// Temporal variable for intermediate usage.
var $7cea174eb56f6e38$var$pt0 = new (0, $1de2ad08c108b7c2$export$2e2bcd8739ae039)();
var $7cea174eb56f6e38$var$pt1 = new (0, $1de2ad08c108b7c2$export$2e2bcd8739ae039)();
var $7cea174eb56f6e38$var$pt2 = new (0, $1de2ad08c108b7c2$export$2e2bcd8739ae039)();
var $7cea174eb56f6e38$var$dir = new (0, $1de2ad08c108b7c2$export$2e2bcd8739ae039)();
var $7cea174eb56f6e38$var$dir2 = new (0, $1de2ad08c108b7c2$export$2e2bcd8739ae039)();
function $7cea174eb56f6e38$export$cc93ba643cd97d83(target, labelLineModel) {
    if (!target) return;
    var labelLine = target.getTextGuideLine();
    var label = target.getTextContent();
    // Needs to create text guide in each charts.
    if (!(label && labelLine)) return;
    var labelGuideConfig = target.textGuideLineConfig || {};
    var points = [
        [
            0,
            0
        ],
        [
            0,
            0
        ],
        [
            0,
            0
        ]
    ];
    var searchSpace = labelGuideConfig.candidates || $7cea174eb56f6e38$var$DEFAULT_SEARCH_SPACE;
    var labelRect = label.getBoundingRect().clone();
    labelRect.applyTransform(label.getComputedTransform());
    var minDist = Infinity;
    var anchorPoint = labelGuideConfig.anchor;
    var targetTransform = target.getComputedTransform();
    var targetInversedTransform = targetTransform && (0, $87ac8de5537d9a34$export$6897c284b6f9f4dc)([], targetTransform);
    var len = labelLineModel.get("length2") || 0;
    if (anchorPoint) $7cea174eb56f6e38$var$pt2.copy(anchorPoint);
    for(var i = 0; i < searchSpace.length; i++){
        var candidate = searchSpace[i];
        $7cea174eb56f6e38$var$getCandidateAnchor(candidate, 0, labelRect, $7cea174eb56f6e38$var$pt0, $7cea174eb56f6e38$var$dir);
        (0, $1de2ad08c108b7c2$export$2e2bcd8739ae039).scaleAndAdd($7cea174eb56f6e38$var$pt1, $7cea174eb56f6e38$var$pt0, $7cea174eb56f6e38$var$dir, len);
        // Transform to target coord space.
        $7cea174eb56f6e38$var$pt1.transform(targetInversedTransform);
        // Note: getBoundingRect will ensure the `path` being created.
        var boundingRect = target.getBoundingRect();
        var dist = anchorPoint ? anchorPoint.distance($7cea174eb56f6e38$var$pt1) : target instanceof (0, $227e31075465dcd4$export$2e2bcd8739ae039) ? $7cea174eb56f6e38$var$nearestPointOnPath($7cea174eb56f6e38$var$pt1, target.path, $7cea174eb56f6e38$var$pt2) : $7cea174eb56f6e38$var$nearestPointOnRect($7cea174eb56f6e38$var$pt1, boundingRect, $7cea174eb56f6e38$var$pt2);
        // TODO pt2 is in the path
        if (dist < minDist) {
            minDist = dist;
            // Transform back to global space.
            $7cea174eb56f6e38$var$pt1.transform(targetTransform);
            $7cea174eb56f6e38$var$pt2.transform(targetTransform);
            $7cea174eb56f6e38$var$pt2.toArray(points[0]);
            $7cea174eb56f6e38$var$pt1.toArray(points[1]);
            $7cea174eb56f6e38$var$pt0.toArray(points[2]);
        }
    }
    $7cea174eb56f6e38$export$ac52062003fbe6a(points, labelLineModel.get("minTurnAngle"));
    labelLine.setShape({
        points: points
    });
}
// Temporal variable for the limitTurnAngle function
var $7cea174eb56f6e38$var$tmpArr = [];
var $7cea174eb56f6e38$var$tmpProjPoint = new (0, $1de2ad08c108b7c2$export$2e2bcd8739ae039)();
function $7cea174eb56f6e38$export$ac52062003fbe6a(linePoints, minTurnAngle) {
    if (!(minTurnAngle <= 180 && minTurnAngle > 0)) return;
    minTurnAngle = minTurnAngle / 180 * Math.PI;
    // The line points can be
    //      /pt1----pt2 (label)
    //     /
    // pt0/
    $7cea174eb56f6e38$var$pt0.fromArray(linePoints[0]);
    $7cea174eb56f6e38$var$pt1.fromArray(linePoints[1]);
    $7cea174eb56f6e38$var$pt2.fromArray(linePoints[2]);
    (0, $1de2ad08c108b7c2$export$2e2bcd8739ae039).sub($7cea174eb56f6e38$var$dir, $7cea174eb56f6e38$var$pt0, $7cea174eb56f6e38$var$pt1);
    (0, $1de2ad08c108b7c2$export$2e2bcd8739ae039).sub($7cea174eb56f6e38$var$dir2, $7cea174eb56f6e38$var$pt2, $7cea174eb56f6e38$var$pt1);
    var len1 = $7cea174eb56f6e38$var$dir.len();
    var len2 = $7cea174eb56f6e38$var$dir2.len();
    if (len1 < 1e-3 || len2 < 1e-3) return;
    $7cea174eb56f6e38$var$dir.scale(1 / len1);
    $7cea174eb56f6e38$var$dir2.scale(1 / len2);
    var angleCos = $7cea174eb56f6e38$var$dir.dot($7cea174eb56f6e38$var$dir2);
    var minTurnAngleCos = Math.cos(minTurnAngle);
    if (minTurnAngleCos < angleCos) {
        // Smaller than minTurnAngle
        // Calculate project point of pt0 on pt1-pt2
        var d = $7cea174eb56f6e38$var$projectPointToLine($7cea174eb56f6e38$var$pt1.x, $7cea174eb56f6e38$var$pt1.y, $7cea174eb56f6e38$var$pt2.x, $7cea174eb56f6e38$var$pt2.y, $7cea174eb56f6e38$var$pt0.x, $7cea174eb56f6e38$var$pt0.y, $7cea174eb56f6e38$var$tmpArr, false);
        $7cea174eb56f6e38$var$tmpProjPoint.fromArray($7cea174eb56f6e38$var$tmpArr);
        // Calculate new projected length with limited minTurnAngle and get the new connect point
        $7cea174eb56f6e38$var$tmpProjPoint.scaleAndAdd($7cea174eb56f6e38$var$dir2, d / Math.tan(Math.PI - minTurnAngle));
        // Limit the new calculated connect point between pt1 and pt2.
        var t = $7cea174eb56f6e38$var$pt2.x !== $7cea174eb56f6e38$var$pt1.x ? ($7cea174eb56f6e38$var$tmpProjPoint.x - $7cea174eb56f6e38$var$pt1.x) / ($7cea174eb56f6e38$var$pt2.x - $7cea174eb56f6e38$var$pt1.x) : ($7cea174eb56f6e38$var$tmpProjPoint.y - $7cea174eb56f6e38$var$pt1.y) / ($7cea174eb56f6e38$var$pt2.y - $7cea174eb56f6e38$var$pt1.y);
        if (isNaN(t)) return;
        if (t < 0) (0, $1de2ad08c108b7c2$export$2e2bcd8739ae039).copy($7cea174eb56f6e38$var$tmpProjPoint, $7cea174eb56f6e38$var$pt1);
        else if (t > 1) (0, $1de2ad08c108b7c2$export$2e2bcd8739ae039).copy($7cea174eb56f6e38$var$tmpProjPoint, $7cea174eb56f6e38$var$pt2);
        $7cea174eb56f6e38$var$tmpProjPoint.toArray(linePoints[1]);
    }
}
function $7cea174eb56f6e38$export$973e1fdb2708f71b(linePoints, surfaceNormal, maxSurfaceAngle) {
    if (!(maxSurfaceAngle <= 180 && maxSurfaceAngle > 0)) return;
    maxSurfaceAngle = maxSurfaceAngle / 180 * Math.PI;
    $7cea174eb56f6e38$var$pt0.fromArray(linePoints[0]);
    $7cea174eb56f6e38$var$pt1.fromArray(linePoints[1]);
    $7cea174eb56f6e38$var$pt2.fromArray(linePoints[2]);
    (0, $1de2ad08c108b7c2$export$2e2bcd8739ae039).sub($7cea174eb56f6e38$var$dir, $7cea174eb56f6e38$var$pt1, $7cea174eb56f6e38$var$pt0);
    (0, $1de2ad08c108b7c2$export$2e2bcd8739ae039).sub($7cea174eb56f6e38$var$dir2, $7cea174eb56f6e38$var$pt2, $7cea174eb56f6e38$var$pt1);
    var len1 = $7cea174eb56f6e38$var$dir.len();
    var len2 = $7cea174eb56f6e38$var$dir2.len();
    if (len1 < 1e-3 || len2 < 1e-3) return;
    $7cea174eb56f6e38$var$dir.scale(1 / len1);
    $7cea174eb56f6e38$var$dir2.scale(1 / len2);
    var angleCos = $7cea174eb56f6e38$var$dir.dot(surfaceNormal);
    var maxSurfaceAngleCos = Math.cos(maxSurfaceAngle);
    if (angleCos < maxSurfaceAngleCos) {
        // Calculate project point of pt0 on pt1-pt2
        var d = $7cea174eb56f6e38$var$projectPointToLine($7cea174eb56f6e38$var$pt1.x, $7cea174eb56f6e38$var$pt1.y, $7cea174eb56f6e38$var$pt2.x, $7cea174eb56f6e38$var$pt2.y, $7cea174eb56f6e38$var$pt0.x, $7cea174eb56f6e38$var$pt0.y, $7cea174eb56f6e38$var$tmpArr, false);
        $7cea174eb56f6e38$var$tmpProjPoint.fromArray($7cea174eb56f6e38$var$tmpArr);
        var HALF_PI = Math.PI / 2;
        var angle2 = Math.acos($7cea174eb56f6e38$var$dir2.dot(surfaceNormal));
        var newAngle = HALF_PI + angle2 - maxSurfaceAngle;
        if (newAngle >= HALF_PI) // parallel
        (0, $1de2ad08c108b7c2$export$2e2bcd8739ae039).copy($7cea174eb56f6e38$var$tmpProjPoint, $7cea174eb56f6e38$var$pt2);
        else {
            // Calculate new projected length with limited minTurnAngle and get the new connect point
            $7cea174eb56f6e38$var$tmpProjPoint.scaleAndAdd($7cea174eb56f6e38$var$dir2, d / Math.tan(Math.PI / 2 - newAngle));
            // Limit the new calculated connect point between pt1 and pt2.
            var t = $7cea174eb56f6e38$var$pt2.x !== $7cea174eb56f6e38$var$pt1.x ? ($7cea174eb56f6e38$var$tmpProjPoint.x - $7cea174eb56f6e38$var$pt1.x) / ($7cea174eb56f6e38$var$pt2.x - $7cea174eb56f6e38$var$pt1.x) : ($7cea174eb56f6e38$var$tmpProjPoint.y - $7cea174eb56f6e38$var$pt1.y) / ($7cea174eb56f6e38$var$pt2.y - $7cea174eb56f6e38$var$pt1.y);
            if (isNaN(t)) return;
            if (t < 0) (0, $1de2ad08c108b7c2$export$2e2bcd8739ae039).copy($7cea174eb56f6e38$var$tmpProjPoint, $7cea174eb56f6e38$var$pt1);
            else if (t > 1) (0, $1de2ad08c108b7c2$export$2e2bcd8739ae039).copy($7cea174eb56f6e38$var$tmpProjPoint, $7cea174eb56f6e38$var$pt2);
        }
        $7cea174eb56f6e38$var$tmpProjPoint.toArray(linePoints[1]);
    }
}
function $7cea174eb56f6e38$var$setLabelLineState(labelLine, ignore, stateName, stateModel) {
    var isNormal = stateName === "normal";
    var stateObj = isNormal ? labelLine : labelLine.ensureState(stateName);
    // Make sure display.
    stateObj.ignore = ignore;
    // Set smooth
    var smooth = stateModel.get("smooth");
    smooth = smooth === true ? 0.3 : Math.max(+smooth, 0) || 0;
    stateObj.shape = stateObj.shape || {};
    // always set the `smooth` property
    stateObj.shape.smooth = smooth;
    var styleObj = stateModel.getModel("lineStyle").getLineStyle();
    isNormal ? labelLine.useStyle(styleObj) : stateObj.style = styleObj;
}
function $7cea174eb56f6e38$var$buildLabelLinePath(path, shape) {
    var smooth = shape.smooth;
    var points = shape.points;
    if (!points) return;
    path.moveTo(points[0][0], points[0][1]);
    if (smooth > 0 && points.length >= 3) {
        var len1 = $ee491d8f32bd01ff$export$6c4a311cc157c764(points[0], points[1]);
        var len2 = $ee491d8f32bd01ff$export$6c4a311cc157c764(points[1], points[2]);
        if (!len1 || !len2) {
            path.lineTo(points[1][0], points[1][1]);
            path.lineTo(points[2][0], points[2][1]);
            return;
        }
        var moveLen = Math.min(len1, len2) * smooth;
        var midPoint0 = $ee491d8f32bd01ff$export$3a89f8d6f6bf6c9f([], points[1], points[0], moveLen / len1);
        var midPoint2 = $ee491d8f32bd01ff$export$3a89f8d6f6bf6c9f([], points[1], points[2], moveLen / len2);
        var midPoint1 = $ee491d8f32bd01ff$export$3a89f8d6f6bf6c9f([], midPoint0, midPoint2, 0.5);
        path.bezierCurveTo(midPoint0[0], midPoint0[1], midPoint0[0], midPoint0[1], midPoint1[0], midPoint1[1]);
        path.bezierCurveTo(midPoint2[0], midPoint2[1], midPoint2[0], midPoint2[1], points[2][0], points[2][1]);
    } else for(var i = 1; i < points.length; i++)path.lineTo(points[i][0], points[i][1]);
}
function $7cea174eb56f6e38$export$c09e0b0574bdd2dc(targetEl, statesModels, defaultStyle) {
    var labelLine = targetEl.getTextGuideLine();
    var label = targetEl.getTextContent();
    if (!label) {
        // Not show label line if there is no label.
        if (labelLine) targetEl.removeTextGuideLine();
        return;
    }
    var normalModel = statesModels.normal;
    var showNormal = normalModel.get("show");
    var labelIgnoreNormal = label.ignore;
    for(var i = 0; i < (0, $fffc76734a157b4c$export$57ee5306b85ad7d5).length; i++){
        var stateName = (0, $fffc76734a157b4c$export$57ee5306b85ad7d5)[i];
        var stateModel = statesModels[stateName];
        var isNormal = stateName === "normal";
        if (stateModel) {
            var stateShow = stateModel.get("show");
            var isLabelIgnored = isNormal ? labelIgnoreNormal : (0, $43e0a445ed6711da$export$995e01f2f5c9d030)(label.states[stateName] && label.states[stateName].ignore, labelIgnoreNormal);
            if (isLabelIgnored // Not show when label is not shown in this state.
             || !(0, $43e0a445ed6711da$export$995e01f2f5c9d030)(stateShow, showNormal) // Use normal state by default if not set.
            ) {
                var stateObj = isNormal ? labelLine : labelLine && labelLine.states[stateName];
                if (stateObj) stateObj.ignore = true;
                if (!!labelLine) $7cea174eb56f6e38$var$setLabelLineState(labelLine, true, stateName, stateModel);
                continue;
            }
            // Create labelLine if not exists
            if (!labelLine) {
                labelLine = new (0, $363f38bff4966f60$export$2e2bcd8739ae039)();
                targetEl.setTextGuideLine(labelLine);
                // Reset state of normal because it's new created.
                // NOTE: NORMAL should always been the first!
                if (!isNormal && (labelIgnoreNormal || !showNormal)) $7cea174eb56f6e38$var$setLabelLineState(labelLine, true, "normal", statesModels.normal);
                // Use same state proxy.
                if (targetEl.stateProxy) labelLine.stateProxy = targetEl.stateProxy;
            }
            $7cea174eb56f6e38$var$setLabelLineState(labelLine, false, stateName, stateModel);
        }
    }
    if (labelLine) {
        (0, $43e0a445ed6711da$export$ebe90cb607ad99e)(labelLine.style, defaultStyle);
        // Not fill.
        labelLine.style.fill = null;
        var showAbove = normalModel.get("showAbove");
        var labelLineConfig = targetEl.textGuideLineConfig = targetEl.textGuideLineConfig || {};
        labelLineConfig.showAbove = showAbove || false;
        // Custom the buildPath.
        labelLine.buildPath = $7cea174eb56f6e38$var$buildLabelLinePath;
    }
}
function $7cea174eb56f6e38$export$2979fdbf5ebce521(itemModel, labelLineName) {
    labelLineName = labelLineName || "labelLine";
    var statesModels = {
        normal: itemModel.getModel(labelLineName)
    };
    for(var i = 0; i < (0, $fffc76734a157b4c$export$151308dceb52d5b).length; i++){
        var stateName = (0, $fffc76734a157b4c$export$151308dceb52d5b)[i];
        statesModels[stateName] = itemModel.getModel([
            stateName,
            labelLineName
        ]);
    }
    return statesModels;
}




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $c7004a764badae25$var$LABEL_LAYOUT_BASE_PROPS = [
    "label",
    "labelLine",
    "layoutOption",
    "priority",
    "defaultAttr",
    "marginForce",
    "minMarginForce",
    "marginDefault",
    "suggestIgnore"
];
var $c7004a764badae25$var$LABEL_LAYOUT_DIRTY_BIT_OTHERS = 1;
var $c7004a764badae25$var$LABEL_LAYOUT_DIRTY_BIT_OBB = 2;
var $c7004a764badae25$var$LABEL_LAYOUT_DIRTY_ALL = $c7004a764badae25$var$LABEL_LAYOUT_DIRTY_BIT_OTHERS | $c7004a764badae25$var$LABEL_LAYOUT_DIRTY_BIT_OBB;
function $c7004a764badae25$export$1551ece3f059eafb(labelGeometry, dirtyOrClear, dirtyBits) {
    dirtyBits = dirtyBits || $c7004a764badae25$var$LABEL_LAYOUT_DIRTY_ALL;
    dirtyOrClear ? labelGeometry.dirty |= dirtyBits : labelGeometry.dirty &= ~dirtyBits;
}
function $c7004a764badae25$var$isLabelLayoutDirty(labelGeometry, dirtyBits) {
    dirtyBits = dirtyBits || $c7004a764badae25$var$LABEL_LAYOUT_DIRTY_ALL;
    return labelGeometry.dirty == null || !!(labelGeometry.dirty & dirtyBits);
}
function $c7004a764badae25$export$471916f4e89eb5da(labelLayout) {
    if (!labelLayout) return;
    if ($c7004a764badae25$var$isLabelLayoutDirty(labelLayout)) $c7004a764badae25$export$af9bffc2d00de2cc(labelLayout, labelLayout.label, labelLayout);
    return labelLayout;
}
function $c7004a764badae25$export$af9bffc2d00de2cc(out, label, opt) {
    // [CAUTION] These props may be modified directly for performance consideration,
    //  therefore, do not output the internal data structure of zrender Element.
    var rawTransform = label.getComputedTransform();
    out.transform = (0, $6552edac5ca572b1$export$4d61283a070e0362)(out.transform, rawTransform);
    // NOTE: should call `getBoundingRect` after `getComputedTransform`, or may get an inaccurate bounding rect.
    //  The reason is that `getComputedTransform` calls `__host.updateInnerText()` internally, which updates the label
    //  by `textConfig` mounted on the host.
    // PENDING: add a dirty bit for that in zrender?
    var outLocalRect = out.localRect = (0, $6552edac5ca572b1$export$38128dfd9a498e1)(out.localRect, label.getBoundingRect());
    var labelStyleExt = label.style;
    var margin = labelStyleExt.margin;
    var marginForce = opt && opt.marginForce;
    var minMarginForce = opt && opt.minMarginForce;
    var marginDefault = opt && opt.marginDefault;
    var marginType = labelStyleExt.__marginType;
    if (marginType == null && marginDefault) {
        margin = marginDefault;
        marginType = (0, $6556fe1ed9fb479d$export$2b18df2bc75ae422).textMargin;
    }
    // `textMargin` and `minMargin` can not exist both.
    for(var i = 0; i < 4; i++)$c7004a764badae25$var$_tmpLabelMargin[i] = marginType === (0, $6556fe1ed9fb479d$export$2b18df2bc75ae422).minMargin && minMarginForce && minMarginForce[i] != null ? minMarginForce[i] : marginForce && marginForce[i] != null ? marginForce[i] : margin ? margin[i] : 0;
    if (marginType === (0, $6556fe1ed9fb479d$export$2b18df2bc75ae422).textMargin) (0, $6552edac5ca572b1$export$81ed941fdeb91c7c)(outLocalRect, $c7004a764badae25$var$_tmpLabelMargin, false, false);
    var outGlobalRect = out.rect = (0, $6552edac5ca572b1$export$38128dfd9a498e1)(out.rect, outLocalRect);
    if (rawTransform) outGlobalRect.applyTransform(rawTransform);
    // Notice: label.style.margin is actually `minMargin / 2`, handled by `setTextStyleCommon`.
    if (marginType === (0, $6556fe1ed9fb479d$export$2b18df2bc75ae422).minMargin) (0, $6552edac5ca572b1$export$81ed941fdeb91c7c)(outGlobalRect, $c7004a764badae25$var$_tmpLabelMargin, false, false);
    out.axisAligned = (0, $6552edac5ca572b1$export$576610ccf2234b72)(rawTransform);
    (out.label = out.label || {}).ignore = label.ignore;
    $c7004a764badae25$export$1551ece3f059eafb(out, false);
    $c7004a764badae25$export$1551ece3f059eafb(out, true, $c7004a764badae25$var$LABEL_LAYOUT_DIRTY_BIT_OBB);
    // Do not remove `obb` (if existing) for reuse, just reset the dirty bit.
    return out;
}
var $c7004a764badae25$var$_tmpLabelMargin = [
    0,
    0,
    0,
    0
];
function $c7004a764badae25$export$bc37ae3f8412d105(out, rawLocalRect, rawTransform) {
    out.transform = (0, $6552edac5ca572b1$export$4d61283a070e0362)(out.transform, rawTransform);
    out.localRect = (0, $6552edac5ca572b1$export$38128dfd9a498e1)(out.localRect, rawLocalRect);
    out.rect = (0, $6552edac5ca572b1$export$38128dfd9a498e1)(out.rect, rawLocalRect);
    if (rawTransform) out.rect.applyTransform(rawTransform);
    out.axisAligned = (0, $6552edac5ca572b1$export$576610ccf2234b72)(rawTransform);
    out.obb = undefined; // Reset to undefined, will be created by `ensureOBB` when using.
    (out.label = out.label || {}).ignore = false;
    return out;
}
function $c7004a764badae25$export$91f733c27ab0712f(labelLayout, offset) {
    if (!labelLayout) return;
    labelLayout.label.x += offset.x;
    labelLayout.label.y += offset.y;
    labelLayout.label.markRedraw();
    var transform = labelLayout.transform;
    if (transform) {
        transform[4] += offset.x;
        transform[5] += offset.y;
    }
    var globalRect = labelLayout.rect;
    if (globalRect) {
        globalRect.x += offset.x;
        globalRect.y += offset.y;
    }
    var obb = labelLayout.obb;
    if (obb) obb.fromBoundingRect(labelLayout.localRect, transform);
}
function $c7004a764badae25$export$a1cfd37e9b88106b(newBaseWithDefaults, source) {
    for(var i = 0; i < $c7004a764badae25$var$LABEL_LAYOUT_BASE_PROPS.length; i++){
        var prop = $c7004a764badae25$var$LABEL_LAYOUT_BASE_PROPS[i];
        if (newBaseWithDefaults[prop] == null) newBaseWithDefaults[prop] = source[prop];
    }
    return $c7004a764badae25$export$471916f4e89eb5da(newBaseWithDefaults);
}
/**
 * Create obb if no one, can cache it.
 */ function $c7004a764badae25$var$ensureOBB(labelGeometry) {
    var obb = labelGeometry.obb;
    if (!obb || $c7004a764badae25$var$isLabelLayoutDirty(labelGeometry, $c7004a764badae25$var$LABEL_LAYOUT_DIRTY_BIT_OBB)) {
        labelGeometry.obb = obb = obb || new (0, $babb2d949c53d85d$export$2e2bcd8739ae039)();
        obb.fromBoundingRect(labelGeometry.localRect, labelGeometry.transform);
        $c7004a764badae25$export$1551ece3f059eafb(labelGeometry, false, $c7004a764badae25$var$LABEL_LAYOUT_DIRTY_BIT_OBB);
    }
    return obb;
}
function $c7004a764badae25$export$73ee08bc808f6f3f(list, xyDimIdx, // 0 for x, 1 for y
minBound, // for x, leftBound; for y, topBound
maxBound, // for x, rightBound; for y, bottomBound
// If average the shifts on all labels and add them to 0
// TODO: Not sure if should enable it.
// Pros: The angle of lines will distribute more equally
// Cons: In some layout. It may not what user wanted. like in pie. the label of last sector is usually changed unexpectedly.
balanceShift) {
    var len = list.length;
    var xyDim = (0, $6552edac5ca572b1$export$cb4c12294149dd2d)[xyDimIdx];
    var sizeDim = (0, $6552edac5ca572b1$export$a3fe6d967173a3ac)[xyDimIdx];
    if (len < 2) return false;
    list.sort(function(a, b) {
        return a.rect[xyDim] - b.rect[xyDim];
    });
    var lastPos = 0;
    var delta;
    var adjusted = false;
    // const shifts = [];
    var totalShifts = 0;
    for(var i = 0; i < len; i++){
        var item = list[i];
        var rect = item.rect;
        delta = rect[xyDim] - lastPos;
        if (delta < 0) {
            // shiftForward(i, len, -delta);
            rect[xyDim] -= delta;
            item.label[xyDim] -= delta;
            adjusted = true;
        }
        var shift = Math.max(-delta, 0);
        // shifts.push(shift);
        totalShifts += shift;
        lastPos = rect[xyDim] + rect[sizeDim];
    }
    if (totalShifts > 0 && balanceShift) // Shift back to make the distribution more equally.
    shiftList(-totalShifts / len, 0, len);
    // TODO bleedMargin?
    var first = list[0];
    var last = list[len - 1];
    var minGap;
    var maxGap;
    updateMinMaxGap();
    // If ends exceed two bounds, squeeze at most 80%, then take the gap of two bounds.
    minGap < 0 && squeezeGaps(-minGap, 0.8);
    maxGap < 0 && squeezeGaps(maxGap, 0.8);
    updateMinMaxGap();
    takeBoundsGap(minGap, maxGap, 1);
    takeBoundsGap(maxGap, minGap, -1);
    // Handle bailout when there is not enough space.
    updateMinMaxGap();
    if (minGap < 0) squeezeWhenBailout(-minGap);
    if (maxGap < 0) squeezeWhenBailout(maxGap);
    function updateMinMaxGap() {
        minGap = first.rect[xyDim] - minBound;
        maxGap = maxBound - last.rect[xyDim] - last.rect[sizeDim];
    }
    function takeBoundsGap(gapThisBound, gapOtherBound, moveDir) {
        if (gapThisBound < 0) {
            // Move from other gap if can.
            var moveFromMaxGap = Math.min(gapOtherBound, -gapThisBound);
            if (moveFromMaxGap > 0) {
                shiftList(moveFromMaxGap * moveDir, 0, len);
                var remained = moveFromMaxGap + gapThisBound;
                if (remained < 0) squeezeGaps(-remained * moveDir, 1);
            } else squeezeGaps(-gapThisBound * moveDir, 1);
        }
    }
    function shiftList(delta, start, end) {
        if (delta !== 0) adjusted = true;
        for(var i = start; i < end; i++){
            var item = list[i];
            var rect = item.rect;
            rect[xyDim] += delta;
            item.label[xyDim] += delta;
        }
    }
    // Squeeze gaps if the labels exceed margin.
    function squeezeGaps(delta, maxSqeezePercent) {
        var gaps = [];
        var totalGaps = 0;
        for(var i = 1; i < len; i++){
            var prevItemRect = list[i - 1].rect;
            var gap = Math.max(list[i].rect[xyDim] - prevItemRect[xyDim] - prevItemRect[sizeDim], 0);
            gaps.push(gap);
            totalGaps += gap;
        }
        if (!totalGaps) return;
        var squeezePercent = Math.min(Math.abs(delta) / totalGaps, maxSqeezePercent);
        if (delta > 0) for(var i = 0; i < len - 1; i++){
            // Distribute the shift delta to all gaps.
            var movement = gaps[i] * squeezePercent;
            // Forward
            shiftList(movement, 0, i + 1);
        }
        else // Backward
        for(var i = len - 1; i > 0; i--){
            // Distribute the shift delta to all gaps.
            var movement = gaps[i - 1] * squeezePercent;
            shiftList(-movement, i, len);
        }
    }
    /**
   * Squeeze to allow overlap if there is no more space available.
   * Let other overlapping strategy like hideOverlap do the job instead of keep exceeding the bounds.
   */ function squeezeWhenBailout(delta) {
        var dir = delta < 0 ? -1 : 1;
        delta = Math.abs(delta);
        var moveForEachLabel = Math.ceil(delta / (len - 1));
        for(var i = 0; i < len - 1; i++){
            if (dir > 0) // Forward
            shiftList(moveForEachLabel, 0, i + 1);
            else // Backward
            shiftList(-moveForEachLabel, len - i - 1, len);
            delta -= moveForEachLabel;
            if (delta <= 0) return;
        }
    }
    return adjusted;
}
function $c7004a764badae25$export$ff775ae4fbb23435(labelList) {
    for(var i = 0; i < labelList.length; i++){
        var labelItem = labelList[i];
        var defaultAttr = labelItem.defaultAttr;
        var labelLine = labelItem.labelLine;
        labelItem.label.attr("ignore", defaultAttr.ignore);
        labelLine && labelLine.attr("ignore", defaultAttr.labelGuideIgnore);
    }
}
function $c7004a764badae25$export$8ce774e164a49410(labelList) {
    var displayedLabels = [];
    // TODO, render overflow visible first, put in the displayedLabels.
    labelList.sort(function(a, b) {
        return (b.suggestIgnore ? 1 : 0) - (a.suggestIgnore ? 1 : 0) || b.priority - a.priority;
    });
    function hideEl(el) {
        if (!el.ignore) {
            // Show on emphasis.
            var emphasisState = el.ensureState("emphasis");
            if (emphasisState.ignore == null) emphasisState.ignore = false;
        }
        el.ignore = true;
    }
    for(var i = 0; i < labelList.length; i++){
        var labelItem = $c7004a764badae25$export$471916f4e89eb5da(labelList[i]);
        // The current `el.ignore` is involved, since some previous overlap
        // resolving strategies may have set `el.ignore` to true.
        if (labelItem.label.ignore) continue;
        var label = labelItem.label;
        var labelLine = labelItem.labelLine;
        // NOTICE: even when the with/height of globalRect of a label is 0, the label line should
        // still be displayed, since we should follow the concept of "truncation", meaning that
        // something exists even if it cannot be fully displayed. A visible label line is necessary
        // to allow users to get a tooltip with label info on hover.
        var overlapped = false;
        for(var j = 0; j < displayedLabels.length; j++)if ($c7004a764badae25$export$f28bfabef115ba96(labelItem, displayedLabels[j], null, {
            touchThreshold: 0.05
        })) {
            overlapped = true;
            break;
        }
        // TODO Callback to determine if this overlap should be handled?
        if (overlapped) {
            hideEl(label);
            labelLine && hideEl(labelLine);
        } else displayedLabels.push(labelItem);
    }
}
function $c7004a764badae25$export$f28bfabef115ba96(baseLayoutInfo, targetLayoutInfo, mtv, intersectOpt) {
    if (!baseLayoutInfo || !targetLayoutInfo) return false;
    if (baseLayoutInfo.label && baseLayoutInfo.label.ignore || targetLayoutInfo.label && targetLayoutInfo.label.ignore) return false;
    // Fast rejection.
    if (!baseLayoutInfo.rect.intersect(targetLayoutInfo.rect, mtv, intersectOpt)) return false;
    if (baseLayoutInfo.axisAligned && targetLayoutInfo.axisAligned) return true; // obb is the same as the normal bounding rect.
    return $c7004a764badae25$var$ensureOBB(baseLayoutInfo).intersect($c7004a764badae25$var$ensureOBB(targetLayoutInfo), mtv, intersectOpt);
}




function $1da045816cd7db36$var$cloneArr(points) {
    if (points) {
        var newPoints = [];
        for(var i = 0; i < points.length; i++)newPoints.push(points[i].slice());
        return newPoints;
    }
}
function $1da045816cd7db36$var$prepareLayoutCallbackParams(labelItem, hostEl) {
    var label = labelItem.label;
    var labelLine = hostEl && hostEl.getTextGuideLine();
    return {
        dataIndex: labelItem.dataIndex,
        dataType: labelItem.dataType,
        seriesIndex: labelItem.seriesModel.seriesIndex,
        text: labelItem.label.style.text,
        rect: labelItem.hostRect,
        labelRect: labelItem.rect,
        // x: labelAttr.x,
        // y: labelAttr.y,
        align: label.style.align,
        verticalAlign: label.style.verticalAlign,
        labelLinePoints: $1da045816cd7db36$var$cloneArr(labelLine && labelLine.shape.points)
    };
}
var $1da045816cd7db36$var$LABEL_OPTION_TO_STYLE_KEYS = [
    "align",
    "verticalAlign",
    "width",
    "height",
    "fontSize"
];
var $1da045816cd7db36$var$dummyTransformable = new (0, $cca2e8cc539372e0$export$2e2bcd8739ae039)();
var $1da045816cd7db36$var$labelLayoutInnerStore = (0, $87f4a59ac66e0ee6$export$64df9f8d92ae083f)();
var $1da045816cd7db36$var$labelLineAnimationStore = (0, $87f4a59ac66e0ee6$export$64df9f8d92ae083f)();
function $1da045816cd7db36$var$extendWithKeys(target, source, keys) {
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (source[key] != null) target[key] = source[key];
    }
}
var $1da045816cd7db36$var$LABEL_LAYOUT_PROPS = [
    "x",
    "y",
    "rotation"
];
var $1da045816cd7db36$var$LabelManager = /** @class */ function() {
    function LabelManager() {
        this._labelList = [];
        this._chartViewList = [];
    }
    LabelManager.prototype.clearLabels = function() {
        this._labelList = [];
        this._chartViewList = [];
    };
    /**
   * Add label to manager
   */ LabelManager.prototype._addLabel = function(dataIndex, dataType, seriesModel, label, layoutOptionOrCb) {
        var labelStyle = label.style;
        var hostEl = label.__hostTarget;
        var textConfig = hostEl.textConfig || {};
        // TODO: If label is in other state.
        var labelTransform = label.getComputedTransform();
        var labelRect = label.getBoundingRect().plain();
        (0, $c437f598d9c9ee16$export$2e2bcd8739ae039).applyTransform(labelRect, labelRect, labelTransform);
        if (labelTransform) $1da045816cd7db36$var$dummyTransformable.setLocalTransform(labelTransform);
        else {
            // Identity transform.
            $1da045816cd7db36$var$dummyTransformable.x = $1da045816cd7db36$var$dummyTransformable.y = $1da045816cd7db36$var$dummyTransformable.rotation = $1da045816cd7db36$var$dummyTransformable.originX = $1da045816cd7db36$var$dummyTransformable.originY = 0;
            $1da045816cd7db36$var$dummyTransformable.scaleX = $1da045816cd7db36$var$dummyTransformable.scaleY = 1;
        }
        $1da045816cd7db36$var$dummyTransformable.rotation = (0, $865d7df327ec107b$export$d44861331f213635)($1da045816cd7db36$var$dummyTransformable.rotation);
        var host = label.__hostTarget;
        var hostRect;
        if (host) {
            hostRect = host.getBoundingRect().plain();
            var transform = host.getComputedTransform();
            (0, $c437f598d9c9ee16$export$2e2bcd8739ae039).applyTransform(hostRect, hostRect, transform);
        }
        var labelGuide = hostRect && host.getTextGuideLine();
        this._labelList.push({
            label: label,
            labelLine: labelGuide,
            seriesModel: seriesModel,
            dataIndex: dataIndex,
            dataType: dataType,
            layoutOptionOrCb: layoutOptionOrCb,
            layoutOption: null,
            rect: labelRect,
            hostRect: hostRect,
            // Label with lower priority will be hidden when overlapped
            // Use rect size as default priority
            priority: hostRect ? hostRect.width * hostRect.height : 0,
            // Save default label attributes.
            // For restore if developers want get back to default value in callback.
            defaultAttr: {
                ignore: label.ignore,
                labelGuideIgnore: labelGuide && labelGuide.ignore,
                x: $1da045816cd7db36$var$dummyTransformable.x,
                y: $1da045816cd7db36$var$dummyTransformable.y,
                scaleX: $1da045816cd7db36$var$dummyTransformable.scaleX,
                scaleY: $1da045816cd7db36$var$dummyTransformable.scaleY,
                rotation: $1da045816cd7db36$var$dummyTransformable.rotation,
                style: {
                    x: labelStyle.x,
                    y: labelStyle.y,
                    align: labelStyle.align,
                    verticalAlign: labelStyle.verticalAlign,
                    width: labelStyle.width,
                    height: labelStyle.height,
                    fontSize: labelStyle.fontSize
                },
                cursor: label.cursor,
                attachedPos: textConfig.position,
                attachedRot: textConfig.rotation
            }
        });
    };
    LabelManager.prototype.addLabelsOfSeries = function(chartView) {
        var _this = this;
        this._chartViewList.push(chartView);
        var seriesModel = chartView.__model;
        var layoutOption = seriesModel.get("labelLayout");
        /**
     * Ignore layouting if it's not specified anything.
     */ if (!((0, $43e0a445ed6711da$export$f6e2535fb5126e54)(layoutOption) || (0, $43e0a445ed6711da$export$ed97f33186d4b816)(layoutOption).length)) return;
        chartView.group.traverse(function(child) {
            if (child.ignore) return true; // Stop traverse descendants.
            // Only support label being hosted on graphic elements.
            var textEl = child.getTextContent();
            var ecData = (0, $7e4afcfca8f5121f$export$b1c39b2bacd1ddc2)(child);
            // Can only attach the text on the element with dataIndex
            if (textEl && !textEl.disableLabelLayout) _this._addLabel(ecData.dataIndex, ecData.dataType, seriesModel, textEl, layoutOption);
        });
    };
    LabelManager.prototype.updateLayoutConfig = function(api) {
        var width = api.getWidth();
        var height = api.getHeight();
        function createDragHandler(el, labelLineModel) {
            return function() {
                (0, $7cea174eb56f6e38$export$cc93ba643cd97d83)(el, labelLineModel);
            };
        }
        for(var i = 0; i < this._labelList.length; i++){
            var labelItem = this._labelList[i];
            var label = labelItem.label;
            var hostEl = label.__hostTarget;
            var defaultLabelAttr = labelItem.defaultAttr;
            var layoutOption = void 0;
            // TODO A global layout option?
            if ((0, $43e0a445ed6711da$export$f6e2535fb5126e54)(labelItem.layoutOptionOrCb)) layoutOption = labelItem.layoutOptionOrCb($1da045816cd7db36$var$prepareLayoutCallbackParams(labelItem, hostEl));
            else layoutOption = labelItem.layoutOptionOrCb;
            layoutOption = layoutOption || {};
            labelItem.layoutOption = layoutOption;
            var degreeToRadian = Math.PI / 180;
            // TODO hostEl should always exists.
            // Or label should not have parent because the x, y is all in global space.
            if (hostEl) hostEl.setTextConfig({
                // Force to set local false.
                local: false,
                // Ignore position and rotation config on the host el if x or y is changed.
                position: layoutOption.x != null || layoutOption.y != null ? null : defaultLabelAttr.attachedPos,
                // Ignore rotation config on the host el if rotation is changed.
                rotation: layoutOption.rotate != null ? layoutOption.rotate * degreeToRadian : defaultLabelAttr.attachedRot,
                offset: [
                    layoutOption.dx || 0,
                    layoutOption.dy || 0
                ]
            });
            var needsUpdateLabelLine = false;
            if (layoutOption.x != null) {
                // TODO width of chart view.
                label.x = (0, $b49750109e236fd8$export$e8514cb5a5e2b40f)(layoutOption.x, width);
                label.setStyle("x", 0); // Ignore movement in style. TODO: origin.
                needsUpdateLabelLine = true;
            } else {
                label.x = defaultLabelAttr.x;
                label.setStyle("x", defaultLabelAttr.style.x);
            }
            if (layoutOption.y != null) {
                // TODO height of chart view.
                label.y = (0, $b49750109e236fd8$export$e8514cb5a5e2b40f)(layoutOption.y, height);
                label.setStyle("y", 0); // Ignore movement in style.
                needsUpdateLabelLine = true;
            } else {
                label.y = defaultLabelAttr.y;
                label.setStyle("y", defaultLabelAttr.style.y);
            }
            if (layoutOption.labelLinePoints) {
                var guideLine = hostEl.getTextGuideLine();
                if (guideLine) {
                    guideLine.setShape({
                        points: layoutOption.labelLinePoints
                    });
                    // Not update
                    needsUpdateLabelLine = false;
                }
            }
            var labelLayoutStore = $1da045816cd7db36$var$labelLayoutInnerStore(label);
            labelLayoutStore.needsUpdateLabelLine = needsUpdateLabelLine;
            label.rotation = layoutOption.rotate != null ? layoutOption.rotate * degreeToRadian : defaultLabelAttr.rotation;
            label.scaleX = defaultLabelAttr.scaleX;
            label.scaleY = defaultLabelAttr.scaleY;
            for(var k = 0; k < $1da045816cd7db36$var$LABEL_OPTION_TO_STYLE_KEYS.length; k++){
                var key = $1da045816cd7db36$var$LABEL_OPTION_TO_STYLE_KEYS[k];
                label.setStyle(key, layoutOption[key] != null ? layoutOption[key] : defaultLabelAttr.style[key]);
            }
            if (layoutOption.draggable) {
                label.draggable = true;
                label.cursor = "move";
                if (hostEl) {
                    var hostModel = labelItem.seriesModel;
                    if (labelItem.dataIndex != null) {
                        var data = labelItem.seriesModel.getData(labelItem.dataType);
                        hostModel = data.getItemModel(labelItem.dataIndex);
                    }
                    label.on("drag", createDragHandler(hostEl, hostModel.getModel("labelLine")));
                }
            } else {
                // TODO Other drag functions?
                label.off("drag");
                label.cursor = defaultLabelAttr.cursor;
            }
        }
    };
    LabelManager.prototype.layout = function(api) {
        var width = api.getWidth();
        var height = api.getHeight();
        var labelList = [];
        (0, $43e0a445ed6711da$export$79b2f7037acddd43)(this._labelList, function(inputItem) {
            if (!inputItem.defaultAttr.ignore) labelList.push((0, $c7004a764badae25$export$a1cfd37e9b88106b)({}, inputItem));
        });
        var labelsNeedsAdjustOnX = (0, $43e0a445ed6711da$export$3dea766d36a8935f)(labelList, function(item) {
            return item.layoutOption.moveOverlap === "shiftX";
        });
        var labelsNeedsAdjustOnY = (0, $43e0a445ed6711da$export$3dea766d36a8935f)(labelList, function(item) {
            return item.layoutOption.moveOverlap === "shiftY";
        });
        (0, $c7004a764badae25$export$73ee08bc808f6f3f)(labelsNeedsAdjustOnX, 0, 0, width);
        (0, $c7004a764badae25$export$73ee08bc808f6f3f)(labelsNeedsAdjustOnY, 1, 0, height);
        var labelsNeedsHideOverlap = (0, $43e0a445ed6711da$export$3dea766d36a8935f)(labelList, function(item) {
            return item.layoutOption.hideOverlap;
        });
        (0, $c7004a764badae25$export$ff775ae4fbb23435)(labelsNeedsHideOverlap);
        (0, $c7004a764badae25$export$8ce774e164a49410)(labelsNeedsHideOverlap);
    };
    /**
   * Process all labels. Not only labels with layoutOption.
   */ LabelManager.prototype.processLabelsOverall = function() {
        var _this = this;
        (0, $43e0a445ed6711da$export$79b2f7037acddd43)(this._chartViewList, function(chartView) {
            var seriesModel = chartView.__model;
            var ignoreLabelLineUpdate = chartView.ignoreLabelLineUpdate;
            var animationEnabled = seriesModel.isAnimationEnabled();
            chartView.group.traverse(function(child) {
                if (child.ignore && !child.forceLabelAnimation) return true; // Stop traverse descendants.
                var needsUpdateLabelLine = !ignoreLabelLineUpdate;
                var label = child.getTextContent();
                if (!needsUpdateLabelLine && label) needsUpdateLabelLine = $1da045816cd7db36$var$labelLayoutInnerStore(label).needsUpdateLabelLine;
                if (needsUpdateLabelLine) _this._updateLabelLine(child, seriesModel);
                if (animationEnabled) _this._animateLabels(child, seriesModel);
            });
        });
    };
    LabelManager.prototype._updateLabelLine = function(el, seriesModel) {
        // Only support label being hosted on graphic elements.
        var textEl = el.getTextContent();
        // Update label line style.
        var ecData = (0, $7e4afcfca8f5121f$export$b1c39b2bacd1ddc2)(el);
        var dataIndex = ecData.dataIndex;
        // Only support labelLine on the labels represent data.
        if (textEl && dataIndex != null) {
            var data = seriesModel.getData(ecData.dataType);
            var itemModel = data.getItemModel(dataIndex);
            var defaultStyle = {};
            var visualStyle = data.getItemVisual(dataIndex, "style");
            if (visualStyle) {
                var visualType = data.getVisual("drawType");
                // Default to be same with main color
                defaultStyle.stroke = visualStyle[visualType];
            }
            var labelLineModel = itemModel.getModel("labelLine");
            (0, $7cea174eb56f6e38$export$c09e0b0574bdd2dc)(el, (0, $7cea174eb56f6e38$export$2979fdbf5ebce521)(itemModel), defaultStyle);
            (0, $7cea174eb56f6e38$export$cc93ba643cd97d83)(el, labelLineModel);
        }
    };
    LabelManager.prototype._animateLabels = function(el, seriesModel) {
        var textEl = el.getTextContent();
        var guideLine = el.getTextGuideLine();
        // Animate
        if (textEl && (el.forceLabelAnimation || !textEl.ignore && !textEl.invisible && !el.disableLabelAnimation && !(0, $4feffdaaa31d998e$export$5b89d4b643713034)(el))) {
            var layoutStore = $1da045816cd7db36$var$labelLayoutInnerStore(textEl);
            var oldLayout = layoutStore.oldLayout;
            var ecData = (0, $7e4afcfca8f5121f$export$b1c39b2bacd1ddc2)(el);
            var dataIndex = ecData.dataIndex;
            var newProps = {
                x: textEl.x,
                y: textEl.y,
                rotation: textEl.rotation
            };
            var data = seriesModel.getData(ecData.dataType);
            if (!oldLayout) {
                textEl.attr(newProps);
                // Disable fade in animation if value animation is enabled.
                if (!(0, $6556fe1ed9fb479d$export$f62786d3261ab0f4)(textEl).valueAnimation) {
                    var oldOpacity = (0, $43e0a445ed6711da$export$995e01f2f5c9d030)(textEl.style.opacity, 1);
                    // Fade in animation
                    textEl.style.opacity = 0;
                    (0, $4feffdaaa31d998e$export$a121566aadcfe021)(textEl, {
                        style: {
                            opacity: oldOpacity
                        }
                    }, seriesModel, dataIndex);
                }
            } else {
                textEl.attr(oldLayout);
                // Make sure the animation from is in the right status.
                var prevStates = el.prevStates;
                if (prevStates) {
                    if ((0, $43e0a445ed6711da$export$305f7d4e9d4624f2)(prevStates, "select") >= 0) textEl.attr(layoutStore.oldLayoutSelect);
                    if ((0, $43e0a445ed6711da$export$305f7d4e9d4624f2)(prevStates, "emphasis") >= 0) textEl.attr(layoutStore.oldLayoutEmphasis);
                }
                (0, $4feffdaaa31d998e$export$c8dce3c08436e91e)(textEl, newProps, seriesModel, dataIndex);
            }
            layoutStore.oldLayout = newProps;
            if (textEl.states.select) {
                var layoutSelect = layoutStore.oldLayoutSelect = {};
                $1da045816cd7db36$var$extendWithKeys(layoutSelect, newProps, $1da045816cd7db36$var$LABEL_LAYOUT_PROPS);
                $1da045816cd7db36$var$extendWithKeys(layoutSelect, textEl.states.select, $1da045816cd7db36$var$LABEL_LAYOUT_PROPS);
            }
            if (textEl.states.emphasis) {
                var layoutEmphasis = layoutStore.oldLayoutEmphasis = {};
                $1da045816cd7db36$var$extendWithKeys(layoutEmphasis, newProps, $1da045816cd7db36$var$LABEL_LAYOUT_PROPS);
                $1da045816cd7db36$var$extendWithKeys(layoutEmphasis, textEl.states.emphasis, $1da045816cd7db36$var$LABEL_LAYOUT_PROPS);
            }
            (0, $6556fe1ed9fb479d$export$dd6101605f5c186)(textEl, dataIndex, data, seriesModel, seriesModel);
        }
        if (guideLine && !guideLine.ignore && !guideLine.invisible) {
            var layoutStore = $1da045816cd7db36$var$labelLineAnimationStore(guideLine);
            var oldLayout = layoutStore.oldLayout;
            var newLayout = {
                points: guideLine.shape.points
            };
            if (!oldLayout) {
                guideLine.setShape(newLayout);
                guideLine.style.strokePercent = 0;
                (0, $4feffdaaa31d998e$export$a121566aadcfe021)(guideLine, {
                    style: {
                        strokePercent: 1
                    }
                }, seriesModel);
            } else {
                guideLine.attr({
                    shape: oldLayout
                });
                (0, $4feffdaaa31d998e$export$c8dce3c08436e91e)(guideLine, {
                    shape: newLayout
                }, seriesModel);
            }
            layoutStore.oldLayout = newLayout;
        }
    };
    return LabelManager;
}();
var $1da045816cd7db36$export$2e2bcd8739ae039 = $1da045816cd7db36$var$LabelManager;



var $44497f14292c6788$var$getLabelManager = (0, $87f4a59ac66e0ee6$export$64df9f8d92ae083f)();
function $44497f14292c6788$export$5320d1b3745c02a5(registers) {
    registers.registerUpdateLifecycle("series:beforeupdate", function(ecModel, api, params) {
        // TODO api provide an namespace that can save stuff per instance
        var labelManager = $44497f14292c6788$var$getLabelManager(api).labelManager;
        if (!labelManager) labelManager = $44497f14292c6788$var$getLabelManager(api).labelManager = new (0, $1da045816cd7db36$export$2e2bcd8739ae039)();
        labelManager.clearLabels();
    });
    registers.registerUpdateLifecycle("series:layoutlabels", function(ecModel, api, params) {
        var labelManager = $44497f14292c6788$var$getLabelManager(api).labelManager;
        (0, $43e0a445ed6711da$export$79b2f7037acddd43)(params.updatedSeries, function(series) {
            labelManager.addLabelsOfSeries(api.getViewOfSeriesModel(series));
        });
        labelManager.updateLayoutConfig(api);
        labelManager.layout(api);
        labelManager.processLabelsOverall();
    });
}


(0, $8f6e8e1f1e941d98$export$1f96ae73734a86cc)((0, $44497f14292c6788$export$5320d1b3745c02a5));
$parcel$exportWildcard($c5cdd91bf8145e66$exports, $8d957d74809727b8$exports);
$parcel$exportWildcard($c5cdd91bf8145e66$exports, $e57dbd7cfd9aef2e$exports);


$parcel$exportWildcard($3ffd465796cef3c9$exports, $c5cdd91bf8145e66$exports);


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $378a1ca5cf534fab$var$LineSeriesModel = /** @class */ function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(LineSeriesModel, _super);
    function LineSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = LineSeriesModel.type;
        _this.hasSymbolVisual = true;
        return _this;
    }
    LineSeriesModel.prototype.getInitialData = function(option) {
        var coordSys;
        return (0, $5d58e30ee7cf15bf$export$2e2bcd8739ae039)(null, this, {
            useEncodeDefaulter: true
        });
    };
    LineSeriesModel.prototype.getLegendIcon = function(opt) {
        var group = new (0, $a8978f7a0e842e3d$export$2e2bcd8739ae039)();
        var line = (0, $4ff41a845d4679a6$export$af050e04da3a02e8)("line", 0, opt.itemHeight / 2, opt.itemWidth, 0, opt.lineStyle.stroke, false);
        group.add(line);
        line.setStyle(opt.lineStyle);
        var visualType = this.getData().getVisual("symbol");
        var visualRotate = this.getData().getVisual("symbolRotate");
        var symbolType = visualType === "none" ? "circle" : visualType;
        // Symbol size is 80% when there is a line
        var size = opt.itemHeight * 0.8;
        var symbol = (0, $4ff41a845d4679a6$export$af050e04da3a02e8)(symbolType, (opt.itemWidth - size) / 2, (opt.itemHeight - size) / 2, size, size, opt.itemStyle.fill);
        group.add(symbol);
        symbol.setStyle(opt.itemStyle);
        var symbolRotate = opt.iconRotate === "inherit" ? visualRotate : opt.iconRotate || 0;
        symbol.rotation = symbolRotate * Math.PI / 180;
        symbol.setOrigin([
            opt.itemWidth / 2,
            opt.itemHeight / 2
        ]);
        if (symbolType.indexOf("empty") > -1) {
            symbol.style.stroke = symbol.style.fill;
            symbol.style.fill = (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.neutral00;
            symbol.style.lineWidth = 2;
        }
        return group;
    };
    LineSeriesModel.type = "series.line";
    LineSeriesModel.dependencies = [
        "grid",
        "polar"
    ];
    LineSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 3,
        coordinateSystem: "cartesian2d",
        legendHoverLink: true,
        clip: true,
        label: {
            position: "top"
        },
        // itemStyle: {
        // },
        endLabel: {
            show: false,
            valueAnimation: true,
            distance: 8
        },
        lineStyle: {
            width: 2,
            type: "solid"
        },
        emphasis: {
            scale: true
        },
        // areaStyle: {
        // origin of areaStyle. Valid values:
        // `'auto'/null/undefined`: from axisLine to data
        // `'start'`: from min to data
        // `'end'`: from data to max
        // origin: 'auto'
        // },
        // false, 'start', 'end', 'middle'
        step: false,
        // Disabled if step is true
        smooth: false,
        smoothMonotone: null,
        symbol: "emptyCircle",
        symbolSize: 6,
        symbolRotate: null,
        showSymbol: true,
        // `false`: follow the label interval strategy.
        // `true`: show all symbols.
        // `'auto'`: If possible, show all symbols, otherwise
        //           follow the label interval strategy.
        showAllSymbol: "auto",
        // Whether to connect break point. (non-finite values)
        connectNulls: false,
        // Sampling for large data. Can be: 'average', 'max', 'min', 'sum', 'lttb'.
        sampling: "none",
        animationEasing: "linear",
        // Disable progressive
        progressive: 0,
        hoverLayerThreshold: Infinity,
        universalTransition: {
            divideShape: "clone"
        },
        /**
     * @deprecated
     */ triggerLineEvent: false,
        triggerEvent: false
    };
    return LineSeriesModel;
}((0, $39002e2f499d7a2f$export$2e2bcd8739ae039));
var $378a1ca5cf534fab$export$2e2bcd8739ae039 = $378a1ca5cf534fab$var$LineSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $b07cae9a23d143b9$export$5ff20667590927ed(data, dataIndex) {
    var labelDims = data.mapDimensionsAll("defaultedLabel");
    var len = labelDims.length;
    // Simple optimization (in lots of cases, label dims length is 1)
    if (len === 1) {
        var rawVal = (0, $2e0ca4b2bac7e54a$export$cde9373da9aad801)(data, dataIndex, labelDims[0]);
        return rawVal != null ? rawVal + "" : null;
    } else if (len) {
        var vals = [];
        for(var i = 0; i < labelDims.length; i++)vals.push((0, $2e0ca4b2bac7e54a$export$cde9373da9aad801)(data, dataIndex, labelDims[i]));
        return vals.join(" ");
    }
}
function $b07cae9a23d143b9$export$5f84815e91ca6775(data, interpolatedValue) {
    var labelDims = data.mapDimensionsAll("defaultedLabel");
    if (!(0, $43e0a445ed6711da$export$43bee75e5e14138e)(interpolatedValue)) return interpolatedValue + "";
    var vals = [];
    for(var i = 0; i < labelDims.length; i++){
        var dimIndex = data.getDimensionIndex(labelDims[i]);
        if (dimIndex >= 0) vals.push(interpolatedValue[dimIndex]);
    }
    return vals.join(" ");
}






var $718042fda900fb92$var$Symbol = /** @class */ function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(Symbol, _super);
    function Symbol(data, idx, seriesScope, opts) {
        var _this = _super.call(this) || this;
        _this.updateData(data, idx, seriesScope, opts);
        return _this;
    }
    Symbol.prototype._createSymbol = function(symbolType, data, idx, symbolSize, z2, keepAspect) {
        // Remove paths created before
        this.removeAll();
        // let symbolPath = createSymbol(
        //     symbolType, -0.5, -0.5, 1, 1, color
        // );
        // If width/height are set too small (e.g., set to 1) on ios10
        // and macOS Sierra, a circle stroke become a rect, no matter what
        // the scale is set. So we set width/height as 2. See #4150.
        var symbolPath = (0, $4ff41a845d4679a6$export$af050e04da3a02e8)(symbolType, -1, -1, 2, 2, null, keepAspect);
        symbolPath.attr({
            z2: (0, $43e0a445ed6711da$export$995e01f2f5c9d030)(z2, 100),
            culling: true,
            scaleX: symbolSize[0] / 2,
            scaleY: symbolSize[1] / 2
        });
        // Rewrite drift method
        symbolPath.drift = $718042fda900fb92$var$driftSymbol;
        this._symbolType = symbolType;
        this.add(symbolPath);
    };
    /**
   * Stop animation
   * @param {boolean} toLastFrame
   */ Symbol.prototype.stopSymbolAnimation = function(toLastFrame) {
        this.childAt(0).stopAnimation(null, toLastFrame);
    };
    Symbol.prototype.getSymbolType = function() {
        return this._symbolType;
    };
    /**
   * FIXME:
   * Caution: This method breaks the encapsulation of this module,
   * but it indeed brings convenience. So do not use the method
   * unless you detailedly know all the implements of `Symbol`,
   * especially animation.
   *
   * Get symbol path element.
   */ Symbol.prototype.getSymbolPath = function() {
        return this.childAt(0);
    };
    /**
   * Highlight symbol
   */ Symbol.prototype.highlight = function() {
        (0, $fffc76734a157b4c$export$b2d02638cc34c042)(this.childAt(0));
    };
    /**
   * Downplay symbol
   */ Symbol.prototype.downplay = function() {
        (0, $fffc76734a157b4c$export$11be6f716239ac55)(this.childAt(0));
    };
    /**
   * @param {number} zlevel
   * @param {number} z
   */ Symbol.prototype.setZ = function(zlevel, z) {
        var symbolPath = this.childAt(0);
        symbolPath.zlevel = zlevel;
        symbolPath.z = z;
    };
    Symbol.prototype.setDraggable = function(draggable, hasCursorOption) {
        var symbolPath = this.childAt(0);
        symbolPath.draggable = draggable;
        symbolPath.cursor = !hasCursorOption && draggable ? "move" : symbolPath.cursor;
    };
    /**
   * Update symbol properties
   */ Symbol.prototype.updateData = function(data, idx, seriesScope, opts) {
        this.silent = false;
        var symbolType = data.getItemVisual(idx, "symbol") || "circle";
        var seriesModel = data.hostModel;
        var symbolSize = Symbol.getSymbolSize(data, idx);
        var z2 = Symbol.getSymbolZ2(data, idx);
        var isInit = symbolType !== this._symbolType;
        var disableAnimation = opts && opts.disableAnimation;
        if (isInit) {
            var keepAspect = data.getItemVisual(idx, "symbolKeepAspect");
            this._createSymbol(symbolType, data, idx, symbolSize, z2, keepAspect);
        } else {
            var symbolPath = this.childAt(0);
            symbolPath.silent = false;
            var target = {
                scaleX: symbolSize[0] / 2,
                scaleY: symbolSize[1] / 2
            };
            disableAnimation ? symbolPath.attr(target) : $4feffdaaa31d998e$export$c8dce3c08436e91e(symbolPath, target, seriesModel, idx);
            (0, $4feffdaaa31d998e$export$bca7290a9faf0ec9)(symbolPath);
        }
        this._updateCommon(data, idx, symbolSize, seriesScope, opts);
        if (isInit) {
            var symbolPath = this.childAt(0);
            if (!disableAnimation) {
                var target = {
                    scaleX: this._sizeX,
                    scaleY: this._sizeY,
                    style: {
                        // Always fadeIn. Because it has fadeOut animation when symbol is removed..
                        opacity: symbolPath.style.opacity
                    }
                };
                symbolPath.scaleX = symbolPath.scaleY = 0;
                symbolPath.style.opacity = 0;
                $4feffdaaa31d998e$export$a121566aadcfe021(symbolPath, target, seriesModel, idx);
            }
        }
        if (disableAnimation) // Must stop leave transition manually if don't call initProps or updateProps.
        this.childAt(0).stopAnimation("leave");
    };
    Symbol.prototype._updateCommon = function(data, idx, symbolSize, seriesScope, opts) {
        var symbolPath = this.childAt(0);
        var seriesModel = data.hostModel;
        var emphasisItemStyle;
        var blurItemStyle;
        var selectItemStyle;
        var focus;
        var blurScope;
        var emphasisDisabled;
        var labelStatesModels;
        var hoverScale;
        var cursorStyle;
        if (seriesScope) {
            emphasisItemStyle = seriesScope.emphasisItemStyle;
            blurItemStyle = seriesScope.blurItemStyle;
            selectItemStyle = seriesScope.selectItemStyle;
            focus = seriesScope.focus;
            blurScope = seriesScope.blurScope;
            labelStatesModels = seriesScope.labelStatesModels;
            hoverScale = seriesScope.hoverScale;
            cursorStyle = seriesScope.cursorStyle;
            emphasisDisabled = seriesScope.emphasisDisabled;
        }
        if (!seriesScope || data.hasItemOption) {
            var itemModel = seriesScope && seriesScope.itemModel ? seriesScope.itemModel : data.getItemModel(idx);
            var emphasisModel = itemModel.getModel("emphasis");
            emphasisItemStyle = emphasisModel.getModel("itemStyle").getItemStyle();
            selectItemStyle = itemModel.getModel([
                "select",
                "itemStyle"
            ]).getItemStyle();
            blurItemStyle = itemModel.getModel([
                "blur",
                "itemStyle"
            ]).getItemStyle();
            focus = emphasisModel.get("focus");
            blurScope = emphasisModel.get("blurScope");
            emphasisDisabled = emphasisModel.get("disabled");
            labelStatesModels = (0, $6556fe1ed9fb479d$export$9739a32674be5893)(itemModel);
            hoverScale = emphasisModel.getShallow("scale");
            cursorStyle = itemModel.getShallow("cursor");
        }
        var symbolRotate = data.getItemVisual(idx, "symbolRotate");
        symbolPath.attr("rotation", (symbolRotate || 0) * Math.PI / 180 || 0);
        var symbolOffset = (0, $4ff41a845d4679a6$export$e3e292895c033f6d)(data.getItemVisual(idx, "symbolOffset"), symbolSize);
        if (symbolOffset) {
            symbolPath.x = symbolOffset[0];
            symbolPath.y = symbolOffset[1];
        }
        cursorStyle && symbolPath.attr("cursor", cursorStyle);
        var symbolStyle = data.getItemVisual(idx, "style");
        var visualColor = symbolStyle.fill;
        if (symbolPath instanceof (0, $d3b0315ae8e8e298$export$2e2bcd8739ae039)) {
            var pathStyle = symbolPath.style;
            symbolPath.useStyle((0, $43e0a445ed6711da$export$8b58be045bf06082)({
                // TODO other properties like x, y ?
                image: pathStyle.image,
                x: pathStyle.x,
                y: pathStyle.y,
                width: pathStyle.width,
                height: pathStyle.height
            }, symbolStyle));
        } else {
            if (symbolPath.__isEmptyBrush) // fill and stroke will be swapped if it's empty.
            // So we cloned a new style to avoid it affecting the original style in visual storage.
            // TODO Better implementation. No empty logic!
            symbolPath.useStyle((0, $43e0a445ed6711da$export$8b58be045bf06082)({}, symbolStyle));
            else symbolPath.useStyle(symbolStyle);
            // Disable decal because symbol scale will been applied on the decal.
            symbolPath.style.decal = null;
            symbolPath.setColor(visualColor, opts && opts.symbolInnerColor);
            symbolPath.style.strokeNoScale = true;
        }
        var liftZ = data.getItemVisual(idx, "liftZ");
        var z2Origin = this._z2;
        if (liftZ != null) {
            if (z2Origin == null) {
                this._z2 = symbolPath.z2;
                symbolPath.z2 += liftZ;
            }
        } else if (z2Origin != null) {
            symbolPath.z2 = z2Origin;
            this._z2 = null;
        }
        var useNameLabel = opts && opts.useNameLabel;
        (0, $6556fe1ed9fb479d$export$9a13992917966657)(symbolPath, labelStatesModels, {
            labelFetcher: seriesModel,
            labelDataIndex: idx,
            defaultText: getLabelDefaultText,
            inheritColor: visualColor,
            defaultOpacity: symbolStyle.opacity
        });
        // Do not execute util needed.
        function getLabelDefaultText(idx) {
            return useNameLabel ? data.getName(idx) : (0, $b07cae9a23d143b9$export$5ff20667590927ed)(data, idx);
        }
        this._sizeX = symbolSize[0] / 2;
        this._sizeY = symbolSize[1] / 2;
        var emphasisState = symbolPath.ensureState("emphasis");
        emphasisState.style = emphasisItemStyle;
        symbolPath.ensureState("select").style = selectItemStyle;
        symbolPath.ensureState("blur").style = blurItemStyle;
        // null / undefined / true means to use default strategy.
        // 0 / false / negative number / NaN / Infinity means no scale.
        var scaleRatio = hoverScale == null || hoverScale === true ? Math.max(1.1, 3 / this._sizeY) : isFinite(hoverScale) && hoverScale > 0 ? +hoverScale : 1;
        // always set scale to allow resetting
        emphasisState.scaleX = this._sizeX * scaleRatio;
        emphasisState.scaleY = this._sizeY * scaleRatio;
        this.setSymbolScale(1);
        (0, $fffc76734a157b4c$export$e51187539ff11209)(this, focus, blurScope, emphasisDisabled);
    };
    Symbol.prototype.setSymbolScale = function(scale) {
        this.scaleX = this.scaleY = scale;
    };
    Symbol.prototype.fadeOut = function(cb, seriesModel, opt) {
        var symbolPath = this.childAt(0);
        var dataIndex = (0, $7e4afcfca8f5121f$export$b1c39b2bacd1ddc2)(this).dataIndex;
        var animationOpt = opt && opt.animation;
        // Avoid mistaken hover when fading out
        this.silent = symbolPath.silent = true;
        // Not show text when animating
        if (opt && opt.fadeLabel) {
            var textContent = symbolPath.getTextContent();
            if (textContent) $4feffdaaa31d998e$export$f883456a56996078(textContent, {
                style: {
                    opacity: 0
                }
            }, seriesModel, {
                dataIndex: dataIndex,
                removeOpt: animationOpt,
                cb: function() {
                    symbolPath.removeTextContent();
                }
            });
        } else symbolPath.removeTextContent();
        $4feffdaaa31d998e$export$f883456a56996078(symbolPath, {
            style: {
                opacity: 0
            },
            scaleX: 0,
            scaleY: 0
        }, seriesModel, {
            dataIndex: dataIndex,
            cb: cb,
            removeOpt: animationOpt
        });
    };
    Symbol.getSymbolSize = function(data, idx) {
        return (0, $4ff41a845d4679a6$export$a84524f03e8e8dfb)(data.getItemVisual(idx, "symbolSize"));
    };
    Symbol.getSymbolZ2 = function(data, idx) {
        return data.getItemVisual(idx, "z2");
    };
    return Symbol;
}($a8978f7a0e842e3d$export$2e2bcd8739ae039);
function $718042fda900fb92$var$driftSymbol(dx, dy) {
    this.parent.drift(dx, dy);
}
var $718042fda900fb92$export$2e2bcd8739ae039 = $718042fda900fb92$var$Symbol;




function $5e4ea831c3ae4d50$var$symbolNeedsDraw(data, point, idx, opt) {
    return point && !isNaN(point[0]) && !isNaN(point[1]) && !(opt && opt.isIgnore && opt.isIgnore(idx)) && !(opt && opt.clipShape && !opt.clipShape.contain(point[0], point[1])) && data.getItemVisual(idx, "symbol") !== "none";
}
function $5e4ea831c3ae4d50$var$normalizeUpdateOpt(opt) {
    if (opt != null && !(0, $43e0a445ed6711da$export$a6cdc56e425d0d0a)(opt)) opt = {
        isIgnore: opt
    };
    return opt || {};
}
function $5e4ea831c3ae4d50$var$makeSeriesScope(data) {
    var seriesModel = data.hostModel;
    var emphasisModel = seriesModel.getModel("emphasis");
    return {
        emphasisItemStyle: emphasisModel.getModel("itemStyle").getItemStyle(),
        blurItemStyle: seriesModel.getModel([
            "blur",
            "itemStyle"
        ]).getItemStyle(),
        selectItemStyle: seriesModel.getModel([
            "select",
            "itemStyle"
        ]).getItemStyle(),
        focus: emphasisModel.get("focus"),
        blurScope: emphasisModel.get("blurScope"),
        emphasisDisabled: emphasisModel.get("disabled"),
        hoverScale: emphasisModel.get("scale"),
        labelStatesModels: (0, $6556fe1ed9fb479d$export$9739a32674be5893)(seriesModel),
        cursorStyle: seriesModel.get("cursor")
    };
}
function $5e4ea831c3ae4d50$var$createEl(SymbolCtor, data, newIdx, seriesScope, symbolUpdateOpt, point, group) {
    var symbolEl = new SymbolCtor(data, newIdx, seriesScope, symbolUpdateOpt);
    symbolEl.setPosition(point);
    data.setItemGraphicEl(newIdx, symbolEl);
    group.add(symbolEl);
    return symbolEl;
}
var $5e4ea831c3ae4d50$var$SymbolDraw = /** @class */ function() {
    function SymbolDraw(SymbolCtor) {
        this.group = new $a8978f7a0e842e3d$export$2e2bcd8739ae039();
        this._SymbolCtor = SymbolCtor || (0, $718042fda900fb92$export$2e2bcd8739ae039);
    }
    /**
   * Update symbols draw by new data
   */ SymbolDraw.prototype.updateData = function(data, opt) {
        // Remove progressive els.
        this._progressiveEls = null;
        opt = $5e4ea831c3ae4d50$var$normalizeUpdateOpt(opt);
        var group = this.group;
        var seriesModel = data.hostModel;
        var oldData = this._data;
        var SymbolCtor = this._SymbolCtor;
        var disableAnimation = opt.disableAnimation;
        var seriesScope = this._seriesScope = $5e4ea831c3ae4d50$var$makeSeriesScope(data);
        var symbolUpdateOpt = {
            disableAnimation: disableAnimation
        };
        var getSymbolPoint = opt.getSymbolPoint || function(idx) {
            return data.getItemLayout(idx);
        };
        // There is no oldLineData only when first rendering or switching from
        // stream mode to normal mode, where previous elements should be removed.
        if (!oldData) group.removeAll();
        data.diff(oldData).add(function(newIdx) {
            var point = getSymbolPoint(newIdx);
            if ($5e4ea831c3ae4d50$var$symbolNeedsDraw(data, point, newIdx, opt)) $5e4ea831c3ae4d50$var$createEl(SymbolCtor, data, newIdx, seriesScope, symbolUpdateOpt, point, group);
        }).update(function(newIdx, oldIdx) {
            var symbolEl = oldData.getItemGraphicEl(oldIdx);
            var point = getSymbolPoint(newIdx);
            if (!$5e4ea831c3ae4d50$var$symbolNeedsDraw(data, point, newIdx, opt)) {
                group.remove(symbolEl);
                return;
            }
            var newSymbolType = data.getItemVisual(newIdx, "symbol") || "circle";
            var oldSymbolType = symbolEl && symbolEl.getSymbolType && symbolEl.getSymbolType();
            if (!symbolEl || oldSymbolType && oldSymbolType !== newSymbolType) {
                group.remove(symbolEl);
                symbolEl = new SymbolCtor(data, newIdx, seriesScope, symbolUpdateOpt);
                symbolEl.setPosition(point);
            } else {
                symbolEl.updateData(data, newIdx, seriesScope, symbolUpdateOpt);
                var target = {
                    x: point[0],
                    y: point[1]
                };
                disableAnimation ? symbolEl.attr(target) : $4feffdaaa31d998e$export$c8dce3c08436e91e(symbolEl, target, seriesModel);
            }
            // Add back
            group.add(symbolEl);
            data.setItemGraphicEl(newIdx, symbolEl);
        }).remove(function(oldIdx) {
            var el = oldData.getItemGraphicEl(oldIdx);
            el && el.fadeOut(function() {
                group.remove(el);
            }, seriesModel);
        }).execute();
        this._getSymbolPoint = getSymbolPoint;
        this._data = data;
    };
    SymbolDraw.prototype.updateLayout = function(opt) {
        var data = this._data;
        if (!data) return;
        var symbolDraw = this;
        var store = data.getStore();
        for(var idx = 0, len = store.count(); idx < len; idx++){
            var el = data.getItemGraphicEl(idx);
            var point = symbolDraw._getSymbolPoint(idx);
            // FIXME: [FIXME_SYMBOL_CLIP_CONSIDERING_COORD_SYS_ALIGNMENT_DURING_ANIMATION]
            //  See VIEW_COORD_SYS animation (by center/zoom change) and FIXME_VIEW_COORD_SYS_SYNC_BACK.
            //  If we create symbols when roaming them into the clip area, they can not be laid out
            //  based on the intermediate state but can only based on the final state of VIEW_COORD_SYS,
            //  and introduce visual artifacts.
            // Consider clip, need to handle create or remove.
            if ($5e4ea831c3ae4d50$var$symbolNeedsDraw(data, point, idx, opt)) {
                el = el || $5e4ea831c3ae4d50$var$createEl(symbolDraw._SymbolCtor, data, idx, symbolDraw._seriesScope, {
                    disableAnimation: true
                }, point, symbolDraw.group);
                el.stopAnimation();
                el.setPosition(point);
                el.markRedraw();
            } else if (el) {
                symbolDraw.group.remove(el);
                data.setItemGraphicEl(idx, null);
            }
        }
    };
    SymbolDraw.prototype.incrementalPrepareUpdate = function(data) {
        this._seriesScope = $5e4ea831c3ae4d50$var$makeSeriesScope(data);
        this._data = null;
        this.group.removeAll();
    };
    SymbolDraw.prototype.incrementalUpdate = function(taskParams, data, incrementalId, opt) {
        // Clear
        this._progressiveEls = [];
        opt = $5e4ea831c3ae4d50$var$normalizeUpdateOpt(opt);
        function updateIncrementalAndHover(el) {
            if (!el.isGroup) {
                el.incremental = incrementalId;
                el.ensureState("emphasis").hoverLayer = $6552edac5ca572b1$export$2ed770cec6ef78e8;
            }
        }
        for(var idx = taskParams.start; idx < taskParams.end; idx++){
            var point = data.getItemLayout(idx);
            if ($5e4ea831c3ae4d50$var$symbolNeedsDraw(data, point, idx, opt)) {
                var el = new this._SymbolCtor(data, idx, this._seriesScope);
                el.traverse(updateIncrementalAndHover);
                el.setPosition(point);
                this.group.add(el);
                data.setItemGraphicEl(idx, el);
                this._progressiveEls.push(el);
            }
        }
    };
    SymbolDraw.prototype.eachRendered = function(cb) {
        $6552edac5ca572b1$export$3e564442729bf048(this._progressiveEls || this.group, cb);
    };
    SymbolDraw.prototype.remove = function(enableAnimation) {
        var group = this.group;
        var data = this._data;
        // Incremental model do not have this._data.
        if (data && enableAnimation) data.eachItemGraphicEl(function(el) {
            el.fadeOut(function() {
                group.remove(el);
            }, data.hostModel);
        });
        else group.removeAll();
    };
    return SymbolDraw;
}();
var $5e4ea831c3ae4d50$export$2e2bcd8739ae039 = $5e4ea831c3ae4d50$var$SymbolDraw;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $fa4515035fca9aa0$export$b488a529581b37e(coordSys, data, valueOrigin) {
    var baseAxis = coordSys.getBaseAxis();
    var valueAxis = coordSys.getOtherAxis(baseAxis);
    var valueStart = $fa4515035fca9aa0$var$getValueStart(valueAxis, valueOrigin);
    var baseAxisDim = baseAxis.dim;
    var valueAxisDim = valueAxis.dim;
    var valueDim = data.mapDimension(valueAxisDim);
    var baseDim = data.mapDimension(baseAxisDim);
    var baseDataOffset = valueAxisDim === "x" || valueAxisDim === "radius" ? 1 : 0;
    var dims = (0, $43e0a445ed6711da$export$871de8747c9eaa88)(coordSys.dimensions, function(coordDim) {
        return data.mapDimension(coordDim);
    });
    var stacked = false;
    var stackResultDim = data.getCalculationInfo("stackResultDimension");
    if ((0, $bbbaa8c322403e71$export$1dedc39359ae35c)(data, dims[0])) {
        // jshint ignore:line
        stacked = true;
        dims[0] = stackResultDim;
    }
    if ((0, $bbbaa8c322403e71$export$1dedc39359ae35c)(data, dims[1])) {
        // jshint ignore:line
        stacked = true;
        dims[1] = stackResultDim;
    }
    return {
        dataDimsForPoint: dims,
        valueStart: valueStart,
        valueAxisDim: valueAxisDim,
        baseAxisDim: baseAxisDim,
        stacked: !!stacked,
        valueDim: valueDim,
        baseDim: baseDim,
        baseDataOffset: baseDataOffset,
        stackedOverDimension: data.getCalculationInfo("stackedOverDimension")
    };
}
function $fa4515035fca9aa0$var$getValueStart(valueAxis, valueOrigin) {
    var valueStart = 0;
    var extent = valueAxis.scale.getExtent();
    if (valueOrigin === "start") valueStart = extent[0];
    else if (valueOrigin === "end") valueStart = extent[1];
    else if ((0, $43e0a445ed6711da$export$7e4aa119212bc614)(valueOrigin) && !isNaN(valueOrigin)) valueStart = valueOrigin;
    else {
        // Both positive
        if (extent[0] > 0) valueStart = extent[0];
        else if (extent[1] < 0) valueStart = extent[1];
    // If is one positive, and one negative, onZero shall be true
    }
    return valueStart;
}
function $fa4515035fca9aa0$export$c1601aa630e7b5f8(dataCoordInfo, coordSys, data, idx) {
    var value = NaN;
    if (dataCoordInfo.stacked) value = data.get(data.getCalculationInfo("stackedOverDimension"), idx);
    if (isNaN(value)) value = dataCoordInfo.valueStart;
    var baseDataOffset = dataCoordInfo.baseDataOffset;
    var stackedData = [];
    stackedData[baseDataOffset] = data.get(dataCoordInfo.baseDim, idx);
    stackedData[1 - baseDataOffset] = value;
    return coordSys.dataToPoint(stackedData);
}
function $fa4515035fca9aa0$export$1817f2c796635b83(xOrY, yOrX) {
    // NOTE:
    //  - `NaN` point x/y may be generated by, e.g.,
    //    original series data `NaN`, '-', `null`, `undefined`,
    //    negative values in LogScale.
    //  - `Infinite` point x/y may be generated by, e.g.,
    //    original series data `Infinite`, `0` in LogScale.
    return !isFinite(xOrY) || !isFinite(yOrX);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $b8db9fde926d4d6f$export$4c40490832d9cdb0 = typeof Int8Array !== (0, $bde9c82f7837f767$export$5ba2cba1cb566d7a) ? Int8Array : undefined;
var $b8db9fde926d4d6f$export$111fe31494f58dc3 = typeof Int16Array !== (0, $bde9c82f7837f767$export$5ba2cba1cb566d7a) ? Int16Array : undefined;
var $b8db9fde926d4d6f$export$b18d4ae90391caf = typeof Int32Array !== (0, $bde9c82f7837f767$export$5ba2cba1cb566d7a) ? Int32Array : undefined;
var $b8db9fde926d4d6f$export$14996b0f94ec6069 = typeof Uint8Array !== (0, $bde9c82f7837f767$export$5ba2cba1cb566d7a) ? Uint8Array : undefined;
var $b8db9fde926d4d6f$export$3899859b7677d71 = typeof Uint16Array !== (0, $bde9c82f7837f767$export$5ba2cba1cb566d7a) ? Uint16Array : undefined;
var $b8db9fde926d4d6f$export$f46ab92cd13bdf8 = typeof Uint32Array !== (0, $bde9c82f7837f767$export$5ba2cba1cb566d7a) ? Uint32Array : undefined;
var $b8db9fde926d4d6f$export$9f6b2141b0069558 = typeof Uint8ClampedArray !== (0, $bde9c82f7837f767$export$5ba2cba1cb566d7a) ? Uint8ClampedArray : undefined;
var $b8db9fde926d4d6f$export$e39334316500bbe = typeof Float32Array !== (0, $bde9c82f7837f767$export$5ba2cba1cb566d7a) ? Float32Array : undefined;
var $b8db9fde926d4d6f$export$8b884c4a18b44713 = typeof Float64Array !== (0, $bde9c82f7837f767$export$5ba2cba1cb566d7a) ? Float64Array : undefined;
function $b8db9fde926d4d6f$export$21d2298f3f56bbaf(capacity) {
    return $b8db9fde926d4d6f$export$d47152ac0737a5e9({
        ctor: $b8db9fde926d4d6f$export$e39334316500bbe
    }, capacity).arr;
}
function $b8db9fde926d4d6f$export$d47152ac0737a5e9(tyArr, // Can add more types if needed.
// NOTICE: Callers need to manage data length themselves.
// Do not consider `capacity` as the data length.
capacity) {
    var existingArr = tyArr.arr;
    var ctor = tyArr.ctor;
    if (capacity > (0, $b49750109e236fd8$export$18510406f204a1b9)) capacity = (0, $b49750109e236fd8$export$18510406f204a1b9);
    if (!existingArr || tyArr.typed && existingArr.length < capacity) {
        var nextArr = void 0;
        if (ctor) try {
            // A large contiguous memory allocation may cause OOM.
            nextArr = new ctor(capacity);
            tyArr.typed = true;
            existingArr && nextArr.set(existingArr);
        } catch (e) {}
        if (!nextArr) {
            nextArr = [];
            tyArr.typed = false;
            if (existingArr) for(var i = 0, len = existingArr.length; i < len; i++)nextArr[i] = existingArr[i];
        }
        tyArr.arr = nextArr;
    }
    return tyArr;
}


function $3a141650a67a1cff$var$diffData(oldData, newData) {
    var diffResult = [];
    newData.diff(oldData).add(function(idx) {
        diffResult.push({
            cmd: "+",
            idx: idx
        });
    }).update(function(newIdx, oldIdx) {
        diffResult.push({
            cmd: "=",
            idx: oldIdx,
            idx1: newIdx
        });
    }).remove(function(idx) {
        diffResult.push({
            cmd: "-",
            idx: idx
        });
    }).execute();
    return diffResult;
}
function $3a141650a67a1cff$export$2e2bcd8739ae039(oldData, newData, oldStackedOnPoints, newStackedOnPoints, oldCoordSys, newCoordSys, oldValueOrigin, newValueOrigin) {
    var diff = $3a141650a67a1cff$var$diffData(oldData, newData);
    // let newIdList = newData.mapArray(newData.getId);
    // let oldIdList = oldData.mapArray(oldData.getId);
    // convertToIntId(newIdList, oldIdList);
    // // FIXME One data ?
    // diff = arrayDiff(oldIdList, newIdList);
    var currPoints = [];
    var nextPoints = [];
    // Points for stacking base line
    var currStackedPoints = [];
    var nextStackedPoints = [];
    var status = [];
    var sortedIndices = [];
    var rawIndices = [];
    var newDataOldCoordInfo = (0, $fa4515035fca9aa0$export$b488a529581b37e)(oldCoordSys, newData, oldValueOrigin);
    // const oldDataNewCoordInfo = prepareDataCoordInfo(newCoordSys, oldData, newValueOrigin);
    var oldPoints = oldData.getLayout("points") || [];
    var newPoints = newData.getLayout("points") || [];
    for(var i = 0; i < diff.length; i++){
        var diffItem = diff[i];
        var pointAdded = true;
        var oldIdx2 = void 0;
        var newIdx2 = void 0;
        // FIXME, animation is not so perfect when dataZoom window moves fast
        // Which is in case remvoing or add more than one data in the tail or head
        switch(diffItem.cmd){
            case "=":
                oldIdx2 = diffItem.idx * 2;
                newIdx2 = diffItem.idx1 * 2;
                var currentX = oldPoints[oldIdx2];
                var currentY = oldPoints[oldIdx2 + 1];
                var nextX = newPoints[newIdx2];
                var nextY = newPoints[newIdx2 + 1];
                // If previous data is NaN, use next point directly
                if (isNaN(currentX) || isNaN(currentY)) {
                    currentX = nextX;
                    currentY = nextY;
                }
                currPoints.push(currentX, currentY);
                nextPoints.push(nextX, nextY);
                currStackedPoints.push(oldStackedOnPoints[oldIdx2], oldStackedOnPoints[oldIdx2 + 1]);
                nextStackedPoints.push(newStackedOnPoints[newIdx2], newStackedOnPoints[newIdx2 + 1]);
                rawIndices.push(newData.getRawIndex(diffItem.idx1));
                break;
            case "+":
                var newIdx = diffItem.idx;
                var newDataDimsForPoint = newDataOldCoordInfo.dataDimsForPoint;
                var oldPt = oldCoordSys.dataToPoint([
                    newData.get(newDataDimsForPoint[0], newIdx),
                    newData.get(newDataDimsForPoint[1], newIdx)
                ]);
                newIdx2 = newIdx * 2;
                currPoints.push(oldPt[0], oldPt[1]);
                nextPoints.push(newPoints[newIdx2], newPoints[newIdx2 + 1]);
                var stackedOnPoint = (0, $fa4515035fca9aa0$export$c1601aa630e7b5f8)(newDataOldCoordInfo, oldCoordSys, newData, newIdx);
                currStackedPoints.push(stackedOnPoint[0], stackedOnPoint[1]);
                nextStackedPoints.push(newStackedOnPoints[newIdx2], newStackedOnPoints[newIdx2 + 1]);
                rawIndices.push(newData.getRawIndex(newIdx));
                break;
            case "-":
                pointAdded = false;
        }
        // Original indices
        if (pointAdded) {
            status.push(diffItem);
            sortedIndices.push(sortedIndices.length);
        }
    }
    // Diff result may be crossed if all items are changed
    // Sort by data index
    sortedIndices.sort(function(a, b) {
        return rawIndices[a] - rawIndices[b];
    });
    var len = currPoints.length;
    var sortedCurrPoints = (0, $b8db9fde926d4d6f$export$21d2298f3f56bbaf)(len);
    var sortedNextPoints = (0, $b8db9fde926d4d6f$export$21d2298f3f56bbaf)(len);
    var sortedCurrStackedPoints = (0, $b8db9fde926d4d6f$export$21d2298f3f56bbaf)(len);
    var sortedNextStackedPoints = (0, $b8db9fde926d4d6f$export$21d2298f3f56bbaf)(len);
    var sortedStatus = [];
    for(var i = 0; i < sortedIndices.length; i++){
        var idx = sortedIndices[i];
        var i2 = i * 2;
        var idx2 = idx * 2;
        sortedCurrPoints[i2] = currPoints[idx2];
        sortedCurrPoints[i2 + 1] = currPoints[idx2 + 1];
        sortedNextPoints[i2] = nextPoints[idx2];
        sortedNextPoints[i2 + 1] = nextPoints[idx2 + 1];
        sortedCurrStackedPoints[i2] = currStackedPoints[idx2];
        sortedCurrStackedPoints[i2 + 1] = currStackedPoints[idx2 + 1];
        sortedNextStackedPoints[i2] = nextStackedPoints[idx2];
        sortedNextStackedPoints[i2 + 1] = nextStackedPoints[idx2 + 1];
        sortedStatus[i] = status[idx];
    }
    return {
        current: sortedCurrPoints,
        next: sortedNextPoints,
        stackedOnCurrent: sortedCurrStackedPoints,
        stackedOnNext: sortedNextStackedPoints,
        status: sortedStatus
    };
}




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $fa74553fddb30984$var$mathMin = Math.min;
var $fa74553fddb30984$var$mathMax = Math.max;
/**
 * Draw smoothed line in non-monotone, in may cause undesired curve in extreme
 * situations. This should be used when points are non-monotone neither in x or
 * y dimension.
 */ function $fa74553fddb30984$var$drawSegment(ctx, points, start, segLen, allLen, dir, smooth, smoothMonotone, connectNulls) {
    var prevX;
    var prevY;
    var cpx0;
    var cpy0;
    var cpx1;
    var cpy1;
    var idx = start;
    var k = 0;
    for(; k < segLen; k++){
        var x = points[idx * 2];
        var y = points[idx * 2 + 1];
        if (idx >= allLen || idx < 0) break;
        if ((0, $fa4515035fca9aa0$export$1817f2c796635b83)(x, y)) {
            if (connectNulls) {
                idx += dir;
                continue;
            }
            break;
        }
        if (idx === start) {
            ctx[dir > 0 ? "moveTo" : "lineTo"](x, y);
            cpx0 = x;
            cpy0 = y;
        } else {
            var dx = x - prevX;
            var dy = y - prevY;
            // Ignore tiny segment.
            if (dx * dx + dy * dy < 0.5) {
                idx += dir;
                continue;
            }
            if (smooth > 0) {
                var nextIdx = idx + dir;
                var nextX = points[nextIdx * 2];
                var nextY = points[nextIdx * 2 + 1];
                // Ignore duplicate point
                while(nextX === x && nextY === y && k < segLen){
                    k++;
                    nextIdx += dir;
                    idx += dir;
                    nextX = points[nextIdx * 2];
                    nextY = points[nextIdx * 2 + 1];
                    x = points[idx * 2];
                    y = points[idx * 2 + 1];
                    dx = x - prevX;
                    dy = y - prevY;
                }
                var tmpK = k + 1;
                if (connectNulls) // Find next point not null
                while((0, $fa4515035fca9aa0$export$1817f2c796635b83)(nextX, nextY) && tmpK < segLen){
                    tmpK++;
                    nextIdx += dir;
                    nextX = points[nextIdx * 2];
                    nextY = points[nextIdx * 2 + 1];
                }
                var ratioNextSeg = 0.5;
                var vx = 0;
                var vy = 0;
                var nextCpx0 = void 0;
                var nextCpy0 = void 0;
                // Is last point
                if (tmpK >= segLen || (0, $fa4515035fca9aa0$export$1817f2c796635b83)(nextX, nextY)) {
                    cpx1 = x;
                    cpy1 = y;
                } else {
                    vx = nextX - prevX;
                    vy = nextY - prevY;
                    var dx0 = x - prevX;
                    var dx1 = nextX - x;
                    var dy0 = y - prevY;
                    var dy1 = nextY - y;
                    var lenPrevSeg = void 0;
                    var lenNextSeg = void 0;
                    if (smoothMonotone === "x") {
                        lenPrevSeg = Math.abs(dx0);
                        lenNextSeg = Math.abs(dx1);
                        var dir_1 = vx > 0 ? 1 : -1;
                        cpx1 = x - dir_1 * lenPrevSeg * smooth;
                        cpy1 = y;
                        nextCpx0 = x + dir_1 * lenNextSeg * smooth;
                        nextCpy0 = y;
                    } else if (smoothMonotone === "y") {
                        lenPrevSeg = Math.abs(dy0);
                        lenNextSeg = Math.abs(dy1);
                        var dir_2 = vy > 0 ? 1 : -1;
                        cpx1 = x;
                        cpy1 = y - dir_2 * lenPrevSeg * smooth;
                        nextCpx0 = x;
                        nextCpy0 = y + dir_2 * lenNextSeg * smooth;
                    } else {
                        lenPrevSeg = Math.sqrt(dx0 * dx0 + dy0 * dy0);
                        lenNextSeg = Math.sqrt(dx1 * dx1 + dy1 * dy1);
                        // Use ratio of seg length
                        ratioNextSeg = lenNextSeg / (lenNextSeg + lenPrevSeg);
                        cpx1 = x - vx * smooth * (1 - ratioNextSeg);
                        cpy1 = y - vy * smooth * (1 - ratioNextSeg);
                        // cp0 of next segment
                        nextCpx0 = x + vx * smooth * ratioNextSeg;
                        nextCpy0 = y + vy * smooth * ratioNextSeg;
                        // Smooth constraint between point and next point.
                        // Avoid exceeding extreme after smoothing.
                        nextCpx0 = $fa74553fddb30984$var$mathMin(nextCpx0, $fa74553fddb30984$var$mathMax(nextX, x));
                        nextCpy0 = $fa74553fddb30984$var$mathMin(nextCpy0, $fa74553fddb30984$var$mathMax(nextY, y));
                        nextCpx0 = $fa74553fddb30984$var$mathMax(nextCpx0, $fa74553fddb30984$var$mathMin(nextX, x));
                        nextCpy0 = $fa74553fddb30984$var$mathMax(nextCpy0, $fa74553fddb30984$var$mathMin(nextY, y));
                        // Reclaculate cp1 based on the adjusted cp0 of next seg.
                        vx = nextCpx0 - x;
                        vy = nextCpy0 - y;
                        cpx1 = x - vx * lenPrevSeg / lenNextSeg;
                        cpy1 = y - vy * lenPrevSeg / lenNextSeg;
                        // Smooth constraint between point and prev point.
                        // Avoid exceeding extreme after smoothing.
                        cpx1 = $fa74553fddb30984$var$mathMin(cpx1, $fa74553fddb30984$var$mathMax(prevX, x));
                        cpy1 = $fa74553fddb30984$var$mathMin(cpy1, $fa74553fddb30984$var$mathMax(prevY, y));
                        cpx1 = $fa74553fddb30984$var$mathMax(cpx1, $fa74553fddb30984$var$mathMin(prevX, x));
                        cpy1 = $fa74553fddb30984$var$mathMax(cpy1, $fa74553fddb30984$var$mathMin(prevY, y));
                        // Adjust next cp0 again.
                        vx = x - cpx1;
                        vy = y - cpy1;
                        nextCpx0 = x + vx * lenNextSeg / lenPrevSeg;
                        nextCpy0 = y + vy * lenNextSeg / lenPrevSeg;
                    }
                }
                ctx.bezierCurveTo(cpx0, cpy0, cpx1, cpy1, x, y);
                cpx0 = nextCpx0;
                cpy0 = nextCpy0;
            } else ctx.lineTo(x, y);
        }
        prevX = x;
        prevY = y;
        idx += dir;
    }
    return k;
}
var $fa74553fddb30984$var$ECPolylineShape = /** @class */ function() {
    function ECPolylineShape() {
        this.smooth = 0;
        this.smoothConstraint = true;
    }
    return ECPolylineShape;
}();
var $fa74553fddb30984$export$bf7c0585b8f7d00f = /** @class */ function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(ECPolyline, _super);
    function ECPolyline(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = "ec-polyline";
        return _this;
    }
    ECPolyline.prototype.getDefaultStyle = function() {
        return {
            stroke: (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.neutral99,
            fill: null
        };
    };
    ECPolyline.prototype.getDefaultShape = function() {
        return new $fa74553fddb30984$var$ECPolylineShape();
    };
    ECPolyline.prototype.buildPath = function(ctx, shape) {
        var points = shape.points;
        var i = 0;
        var len = points.length / 2;
        // const result = getBoundingBox(points, shape.smoothConstraint);
        if (shape.connectNulls) {
            // Must remove first and last null values avoid draw error in polygon
            for(; len > 0; len--){
                if (!(0, $fa4515035fca9aa0$export$1817f2c796635b83)(points[len * 2 - 2], points[len * 2 - 1])) break;
            }
            for(; i < len; i++){
                if (!(0, $fa4515035fca9aa0$export$1817f2c796635b83)(points[i * 2], points[i * 2 + 1])) break;
            }
        }
        while(i < len)i += $fa74553fddb30984$var$drawSegment(ctx, points, i, len, len, 1, shape.smooth, shape.smoothMonotone, shape.connectNulls) + 1;
    };
    ECPolyline.prototype.getPointOn = function(xOrY, dim) {
        if (!this.path) {
            this.createPathProxy();
            this.buildPath(this.path, this.shape);
        }
        var path = this.path;
        var data = path.data;
        var CMD = (0, $e2a16933ef78a053$export$2e2bcd8739ae039).CMD;
        var x0;
        var y0;
        var isDimX = dim === "x";
        var roots = [];
        for(var i = 0; i < data.length;){
            var cmd = data[i++];
            var x = void 0;
            var y = void 0;
            var x2 = void 0;
            var y2 = void 0;
            var x3 = void 0;
            var y3 = void 0;
            var t = void 0;
            switch(cmd){
                case CMD.M:
                    x0 = data[i++];
                    y0 = data[i++];
                    break;
                case CMD.L:
                    x = data[i++];
                    y = data[i++];
                    t = isDimX ? (xOrY - x0) / (x - x0) : (xOrY - y0) / (y - y0);
                    if (t <= 1 && t >= 0) {
                        var val = isDimX ? (y - y0) * t + y0 : (x - x0) * t + x0;
                        return isDimX ? [
                            xOrY,
                            val
                        ] : [
                            val,
                            xOrY
                        ];
                    }
                    x0 = x;
                    y0 = y;
                    break;
                case CMD.C:
                    x = data[i++];
                    y = data[i++];
                    x2 = data[i++];
                    y2 = data[i++];
                    x3 = data[i++];
                    y3 = data[i++];
                    var nRoot = isDimX ? (0, $3dec70ca5f6b6e8f$export$ca5d13faa10b167e)(x0, x, x2, x3, xOrY, roots) : (0, $3dec70ca5f6b6e8f$export$ca5d13faa10b167e)(y0, y, y2, y3, xOrY, roots);
                    if (nRoot > 0) for(var i_1 = 0; i_1 < nRoot; i_1++){
                        var t_1 = roots[i_1];
                        if (t_1 <= 1 && t_1 >= 0) {
                            var val = isDimX ? (0, $3dec70ca5f6b6e8f$export$547c21de482bbcb2)(y0, y, y2, y3, t_1) : (0, $3dec70ca5f6b6e8f$export$547c21de482bbcb2)(x0, x, x2, x3, t_1);
                            return isDimX ? [
                                xOrY,
                                val
                            ] : [
                                val,
                                xOrY
                            ];
                        }
                    }
                    x0 = x3;
                    y0 = y3;
                    break;
            }
        }
    };
    return ECPolyline;
}((0, $227e31075465dcd4$export$2e2bcd8739ae039));
var $fa74553fddb30984$var$ECPolygonShape = /** @class */ function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(ECPolygonShape, _super);
    function ECPolygonShape() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ECPolygonShape;
}($fa74553fddb30984$var$ECPolylineShape);
var $fa74553fddb30984$export$6042a400d113f2bd = /** @class */ function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(ECPolygon, _super);
    function ECPolygon(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = "ec-polygon";
        return _this;
    }
    ECPolygon.prototype.getDefaultShape = function() {
        return new $fa74553fddb30984$var$ECPolygonShape();
    };
    ECPolygon.prototype.buildPath = function(ctx, shape) {
        var points = shape.points;
        var stackedOnPoints = shape.stackedOnPoints;
        var i = 0;
        var len = points.length / 2;
        var smoothMonotone = shape.smoothMonotone;
        if (shape.connectNulls) {
            // Must remove first and last null values avoid draw error in polygon
            for(; len > 0; len--){
                if (!(0, $fa4515035fca9aa0$export$1817f2c796635b83)(points[len * 2 - 2], points[len * 2 - 1])) break;
            }
            for(; i < len; i++){
                if (!(0, $fa4515035fca9aa0$export$1817f2c796635b83)(points[i * 2], points[i * 2 + 1])) break;
            }
        }
        while(i < len){
            var k = $fa74553fddb30984$var$drawSegment(ctx, points, i, len, len, 1, shape.smooth, smoothMonotone, shape.connectNulls);
            $fa74553fddb30984$var$drawSegment(ctx, stackedOnPoints, i + k - 1, k, len, -1, shape.stackedOnSmooth, smoothMonotone, shape.connectNulls);
            i += k + 1;
            ctx.closePath();
        }
    };
    return ECPolygon;
}((0, $227e31075465dcd4$export$2e2bcd8739ae039));




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $1839445d0e004f61$export$83958787eb658d14(cartesian, hasAnimation, seriesModel, done, during) {
    var rect = cartesian.getArea();
    var x = rect.x;
    var y = rect.y;
    var width = rect.width;
    var height = rect.height;
    var lineWidth = seriesModel.get([
        "lineStyle",
        "width"
    ]) || 0;
    // Expand the clip path a bit to avoid the border is clipped and looks thinner
    x -= lineWidth / 2;
    y -= lineWidth / 2;
    width += lineWidth;
    height += lineWidth;
    // fix: https://github.com/apache/incubator-echarts/issues/11369
    width = Math.ceil(width);
    if (x !== Math.floor(x)) {
        x = Math.floor(x);
        // if no extra 1px on `width`, it will still be clipped since `x` is floored
        width++;
    }
    var clipPath = new $42ed508a93973e78$export$2e2bcd8739ae039({
        shape: {
            x: x,
            y: y,
            width: width,
            height: height
        }
    });
    if (hasAnimation) {
        var baseAxis = cartesian.getBaseAxis();
        var isHorizontal = baseAxis.isHorizontal();
        var isAxisInversed = baseAxis.inverse;
        if (isHorizontal) {
            if (isAxisInversed) clipPath.shape.x += width;
            clipPath.shape.width = 0;
        } else {
            if (!isAxisInversed) clipPath.shape.y += height;
            clipPath.shape.height = 0;
        }
        var duringCb = (0, $43e0a445ed6711da$export$f6e2535fb5126e54)(during) ? function(percent) {
            during(percent, clipPath);
        } : null;
        $4feffdaaa31d998e$export$a121566aadcfe021(clipPath, {
            shape: {
                width: width,
                height: height,
                x: x,
                y: y
            }
        }, seriesModel, null, done, duringCb);
    }
    return clipPath;
}
function $1839445d0e004f61$export$13dc2b2230df3cb5(polar, hasAnimation, seriesModel) {
    var sectorArea = polar.getArea();
    // Avoid float number rounding error for symbol on the edge of axis extent.
    var r0 = (0, $b49750109e236fd8$export$2077e0241d6afd3c)(sectorArea.r0, 1);
    var r = (0, $b49750109e236fd8$export$2077e0241d6afd3c)(sectorArea.r, 1);
    var clipPath = new $7a3d58339c1601e8$export$2e2bcd8739ae039({
        shape: {
            cx: (0, $b49750109e236fd8$export$2077e0241d6afd3c)(polar.cx, 1),
            cy: (0, $b49750109e236fd8$export$2077e0241d6afd3c)(polar.cy, 1),
            r0: r0,
            r: r,
            startAngle: sectorArea.startAngle,
            endAngle: sectorArea.endAngle,
            clockwise: sectorArea.clockwise
        }
    });
    if (hasAnimation) {
        var isRadial = polar.getBaseAxis().dim === "angle";
        if (isRadial) clipPath.shape.endAngle = sectorArea.startAngle;
        else clipPath.shape.r = r0;
        $4feffdaaa31d998e$export$a121566aadcfe021(clipPath, {
            shape: {
                endAngle: sectorArea.endAngle,
                r: r
            }
        }, seriesModel);
    }
    return clipPath;
}
function $1839445d0e004f61$export$e0fe5081209d01c9(coordSys, hasAnimation, seriesModel, done, during) {
    if (!coordSys) return null;
    else if (coordSys.type === "polar") return $1839445d0e004f61$export$13dc2b2230df3cb5(coordSys, hasAnimation, seriesModel);
    else if (coordSys.type === "cartesian2d") return $1839445d0e004f61$export$83958787eb658d14(coordSys, hasAnimation, seriesModel, done, during);
    return null;
}
var $1839445d0e004f61$export$50eaf45b617b77da = 0;
var $1839445d0e004f61$export$36c0f03caa6071e6 = 1;
var $1839445d0e004f61$export$6b0aed6da8ae4f2e = 2;
function $1839445d0e004f61$export$e01c1b2ba9fe13e9(clip, symbolEl, clipPath) {
    if (clip) symbolEl.setClipPath(clipPath);
    else symbolEl.removeClipPath();
}
function $1839445d0e004f61$export$dd44d434645865fc(seriesModel) {
    var coordSys = seriesModel.coordinateSystem;
    if (seriesModel.get("clip", true) && coordSys && (!coordSys.shouldClip || coordSys.shouldClip())) // PENDING make `0.1` configurable, for example, `clipTolerance`?
    return coordSys.getArea && coordSys.getArea(.1);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $8b0e69611399196e$export$8567506e6336616(coordSys, type) {
    return coordSys.type === type;
}
function $8b0e69611399196e$export$d3269a273c05cc72(coordSys) {
    var dimensions = coordSys.dimensions;
    // Not use coordSys.type === 'geo' because coordSys maybe extended
    return dimensions[0] === "lng" && dimensions[1] === "lat" && !!coordSys.getViewRect;
}











function $4e131664ee8d81e5$var$isPointsSame(points1, points2) {
    if (points1.length !== points2.length) return;
    for(var i = 0; i < points1.length; i++){
        if (points1[i] !== points2[i]) return;
    }
    return true;
}
function $4e131664ee8d81e5$var$xyExtentFromPoints(points) {
    var xExtent = $87f4a59ac66e0ee6$export$62e5f07ab009f3b();
    var yExtent = $87f4a59ac66e0ee6$export$62e5f07ab009f3b();
    for(var i = 0; i < points.length;){
        var x = points[i++];
        var y = points[i++];
        if (!(0, $fa4515035fca9aa0$export$1817f2c796635b83)(x, y)) {
            $87f4a59ac66e0ee6$export$c28a8a63acb35a19(xExtent, x);
            $87f4a59ac66e0ee6$export$c28a8a63acb35a19(yExtent, y);
        }
    }
    return [
        xExtent,
        yExtent
    ];
}
function $4e131664ee8d81e5$var$getBoundingDiff(points1, points2) {
    var _a = $4e131664ee8d81e5$var$xyExtentFromPoints(points1), xExtent1 = _a[0], yExtent1 = _a[1];
    var _b = $4e131664ee8d81e5$var$xyExtentFromPoints(points2), xExtent2 = _b[0], yExtent2 = _b[1];
    // Get a max value from each corner of two boundings.
    return Math.max(Math.abs(xExtent1[0] - xExtent2[0]), Math.abs(yExtent1[0] - yExtent2[0]), Math.abs(xExtent1[1] - xExtent2[1]), Math.abs(yExtent1[1] - yExtent2[1]));
}
function $4e131664ee8d81e5$var$getSmooth(smooth) {
    return $43e0a445ed6711da$export$7e4aa119212bc614(smooth) ? smooth : smooth ? 0.5 : 0;
}
function $4e131664ee8d81e5$var$getStackedOnPoints(coordSys, data, dataCoordInfo) {
    if (dataCoordInfo.valueDim == null) return [];
    var len = data.count();
    var points = (0, $b8db9fde926d4d6f$export$21d2298f3f56bbaf)(len * 2);
    for(var idx = 0; idx < len; idx++){
        var pt = (0, $fa4515035fca9aa0$export$c1601aa630e7b5f8)(dataCoordInfo, coordSys, data, idx);
        points[idx * 2] = pt[0];
        points[idx * 2 + 1] = pt[1];
    }
    return points;
}
/**
 * Filter the null data and extend data for step considering `stepTurnAt`
 *
 * @param points data to convert, that may containing null
 * @param basePoints base data to reference, used only for areaStyle points
 * @param coordSys coordinate system
 * @param stepTurnAt 'start' | 'end' | 'middle' | true
 * @param connectNulls whether to connect nulls
 * @returns converted point positions
 */ function $4e131664ee8d81e5$var$turnPointsIntoStep(points, basePoints, coordSys, stepTurnAt, connectNulls) {
    var baseAxis = coordSys.getBaseAxis();
    var baseIndex = baseAxis.dim === "x" || baseAxis.dim === "radius" ? 0 : 1;
    var stepPoints = [];
    var i = 0;
    var stepPt = [];
    var pt = [];
    var nextPt = [];
    var filteredPoints = [];
    if (connectNulls) {
        for(i = 0; i < points.length; i += 2){
            /**
       * For areaStyle of stepped lines, `stackedOnPoints` should be
       * filtered the same as `points` so that the base axis values
       * should stay the same as the lines above. See #20021
       */ var reference = basePoints || points;
            if (!(0, $fa4515035fca9aa0$export$1817f2c796635b83)(reference[i], reference[i + 1])) filteredPoints.push(points[i], points[i + 1]);
        }
        points = filteredPoints;
    }
    for(i = 0; i < points.length - 2; i += 2){
        nextPt[0] = points[i + 2];
        nextPt[1] = points[i + 3];
        pt[0] = points[i];
        pt[1] = points[i + 1];
        stepPoints.push(pt[0], pt[1]);
        switch(stepTurnAt){
            case "end":
                stepPt[baseIndex] = nextPt[baseIndex];
                stepPt[1 - baseIndex] = pt[1 - baseIndex];
                stepPoints.push(stepPt[0], stepPt[1]);
                break;
            case "middle":
                var middle = (pt[baseIndex] + nextPt[baseIndex]) / 2;
                var stepPt2 = [];
                stepPt[baseIndex] = stepPt2[baseIndex] = middle;
                stepPt[1 - baseIndex] = pt[1 - baseIndex];
                stepPt2[1 - baseIndex] = nextPt[1 - baseIndex];
                stepPoints.push(stepPt[0], stepPt[1]);
                stepPoints.push(stepPt2[0], stepPt2[1]);
                break;
            default:
                // default is start
                stepPt[baseIndex] = pt[baseIndex];
                stepPt[1 - baseIndex] = nextPt[1 - baseIndex];
                stepPoints.push(stepPt[0], stepPt[1]);
        }
    }
    // Last points
    stepPoints.push(points[i++], points[i++]);
    return stepPoints;
}
/**
 * Clip color stops to edge. Avoid creating too large gradients.
 * Which may lead to blurry when GPU acceleration is enabled. See #15680
 *
 * The stops has been sorted from small to large.
 */ function $4e131664ee8d81e5$var$clipColorStops(colorStops, maxSize) {
    var newColorStops = [];
    var len = colorStops.length;
    // coord will always < 0 in prevOutOfRangeColorStop.
    var prevOutOfRangeColorStop;
    var prevInRangeColorStop;
    function lerpStop(stop0, stop1, clippedCoord) {
        var coord0 = stop0.coord;
        var p = (clippedCoord - coord0) / (stop1.coord - coord0);
        var color = (0, $b0979f18b0a232f9$export$3a89f8d6f6bf6c9f)(p, [
            stop0.color,
            stop1.color
        ]);
        return {
            coord: clippedCoord,
            color: color
        };
    }
    for(var i = 0; i < len; i++){
        var stop_1 = colorStops[i];
        var coord = stop_1.coord;
        if (coord < 0) prevOutOfRangeColorStop = stop_1;
        else if (coord > maxSize) {
            if (prevInRangeColorStop) newColorStops.push(lerpStop(prevInRangeColorStop, stop_1, maxSize));
            else if (prevOutOfRangeColorStop) // If there are two stops and coord range is between these two stops
            newColorStops.push(lerpStop(prevOutOfRangeColorStop, stop_1, 0), lerpStop(prevOutOfRangeColorStop, stop_1, maxSize));
            break;
        } else {
            if (prevOutOfRangeColorStop) {
                newColorStops.push(lerpStop(prevOutOfRangeColorStop, stop_1, 0));
                // Reset
                prevOutOfRangeColorStop = null;
            }
            newColorStops.push(stop_1);
            prevInRangeColorStop = stop_1;
        }
    }
    return newColorStops;
}
function $4e131664ee8d81e5$var$getVisualGradient(data, coordSys, api) {
    var visualMetaList = data.getVisual("visualMeta");
    if (!visualMetaList || !visualMetaList.length || !data.count()) // When data.count() is 0, gradient range can not be calculated.
    return;
    if (coordSys.type !== "cartesian2d") return;
    var coordDim;
    var visualMeta;
    for(var i = visualMetaList.length - 1; i >= 0; i--){
        var dimInfo = data.getDimensionInfo(visualMetaList[i].dimension);
        coordDim = dimInfo && dimInfo.coordDim;
        // Can only be x or y
        if (coordDim === "x" || coordDim === "y") {
            visualMeta = visualMetaList[i];
            break;
        }
    }
    if (!visualMeta) return;
    // If the area to be rendered is bigger than area defined by LinearGradient,
    // the canvas spec prescribes that the color of the first stop and the last
    // stop should be used. But if two stops are added at offset 0, in effect
    // browsers use the color of the second stop to render area outside
    // LinearGradient. So we can only infinitesimally extend area defined in
    // LinearGradient to render `outerColors`.
    var axis = coordSys.getAxis(coordDim);
    // dataToCoord mapping may not be linear, but must be monotonic.
    var colorStops = $43e0a445ed6711da$export$871de8747c9eaa88(visualMeta.stops, function(stop) {
        // offset will be calculated later.
        return {
            coord: axis.toGlobalCoord(axis.dataToCoord(stop.value)),
            color: stop.color
        };
    });
    var stopLen = colorStops.length;
    var outerColors = visualMeta.outerColors.slice();
    if (stopLen && colorStops[0].coord > colorStops[stopLen - 1].coord) {
        colorStops.reverse();
        outerColors.reverse();
    }
    var colorStopsInRange = $4e131664ee8d81e5$var$clipColorStops(colorStops, coordDim === "x" ? api.getWidth() : api.getHeight());
    var inRangeStopLen = colorStopsInRange.length;
    if (!inRangeStopLen && stopLen) // All stops are out of range. All will be the same color.
    return colorStops[0].coord < 0 ? outerColors[1] ? outerColors[1] : colorStops[stopLen - 1].color : outerColors[0] ? outerColors[0] : colorStops[0].color;
    var tinyExtent = 10; // Arbitrary value: 10px
    var minCoord = colorStopsInRange[0].coord - tinyExtent;
    var maxCoord = colorStopsInRange[inRangeStopLen - 1].coord + tinyExtent;
    var coordSpan = maxCoord - minCoord;
    if (coordSpan < 1e-3) return "transparent";
    $43e0a445ed6711da$export$79b2f7037acddd43(colorStopsInRange, function(stop) {
        stop.offset = (stop.coord - minCoord) / coordSpan;
    });
    colorStopsInRange.push({
        // NOTE: inRangeStopLen may still be 0 if stoplen is zero.
        offset: inRangeStopLen ? colorStopsInRange[inRangeStopLen - 1].offset : 0.5,
        color: outerColors[1] || "transparent"
    });
    colorStopsInRange.unshift({
        offset: inRangeStopLen ? colorStopsInRange[0].offset : 0.5,
        color: outerColors[0] || "transparent"
    });
    var gradient = new $9cb489c6746d60b7$export$2e2bcd8739ae039(0, 0, 0, 0, colorStopsInRange, true);
    gradient[coordDim] = minCoord;
    gradient[coordDim + "2"] = maxCoord;
    return gradient;
}
function $4e131664ee8d81e5$var$getIsIgnoreFunc(seriesModel, data, coordSys) {
    var showAllSymbol = seriesModel.get("showAllSymbol");
    var isAuto = showAllSymbol === "auto";
    if (showAllSymbol && !isAuto) return;
    var categoryAxis = coordSys.getAxesByScale("ordinal")[0];
    if (!categoryAxis) return;
    // Note that category label interval strategy might bring some weird effect
    // in some scenario: users may wonder why some of the symbols are not
    // displayed. So we show all symbols as possible as we can.
    if (isAuto && $4e131664ee8d81e5$var$canShowAllSymbolForCategory(categoryAxis, data)) return;
    // Otherwise follow the label interval strategy on category axis.
    var categoryDataDim = data.mapDimension(categoryAxis.dim);
    var labelMap = {};
    $43e0a445ed6711da$export$79b2f7037acddd43(categoryAxis.getViewLabels(), function(labelItem) {
        if (!labelItem.tick.offInterval) labelMap[(0, $3e6d0d29922ecf90$export$889d2956111fd257)(categoryAxis.scale, labelItem.tick)] = 1;
    });
    return function(dataIndex) {
        return !labelMap.hasOwnProperty(data.get(categoryDataDim, dataIndex));
    };
}
function $4e131664ee8d81e5$var$canShowAllSymbolForCategory(categoryAxis, data) {
    // In most cases, line is monotonous on category axis, and the label size
    // is close with each other. So we check the symbol size and some of the
    // label size alone with the category axis to estimate whether all symbol
    // can be shown without overlap.
    var axisExtent = categoryAxis.getExtent();
    var availSize = Math.abs(axisExtent[1] - axisExtent[0]) / categoryAxis.scale.count();
    isNaN(availSize) && (availSize = 0); // 0/0 is NaN.
    // Sampling some points, max 5.
    var dataLen = data.count();
    var step = Math.max(1, Math.round(dataLen / 5));
    for(var dataIndex = 0; dataIndex < dataLen; dataIndex += step){
        if ((0, $718042fda900fb92$export$2e2bcd8739ae039).getSymbolSize(data, dataIndex)[categoryAxis.isHorizontal() ? 1 : 0] * 1.5 > availSize) return false;
    }
    return true;
}
function $4e131664ee8d81e5$var$getLastIndexNotNull(points) {
    var len = points.length / 2;
    for(; len > 0; len--){
        if (!(0, $fa4515035fca9aa0$export$1817f2c796635b83)(points[len * 2 - 2], points[len * 2 - 1])) break;
    }
    return len - 1;
}
function $4e131664ee8d81e5$var$getPointAtIndex(points, idx) {
    return [
        points[idx * 2],
        points[idx * 2 + 1]
    ];
}
function $4e131664ee8d81e5$var$getIndexRange(points, xOrY, dim) {
    var len = points.length / 2;
    var dimIdx = dim === "x" ? 0 : 1;
    var a;
    var b;
    var prevIndex = 0;
    var nextIndex = -1;
    for(var i = 0; i < len; i++){
        b = points[i * 2 + dimIdx];
        if ((0, $fa4515035fca9aa0$export$1817f2c796635b83)(b, points[i * 2 + 1 - dimIdx])) continue;
        if (i === 0) {
            a = b;
            continue;
        }
        if (a <= xOrY && b >= xOrY || a >= xOrY && b <= xOrY) {
            nextIndex = i;
            break;
        }
        prevIndex = i;
        a = b;
    }
    return {
        range: [
            prevIndex,
            nextIndex
        ],
        t: (xOrY - a) / (b - a)
    };
}
function $4e131664ee8d81e5$var$anyStateShowEndLabel(seriesModel) {
    if (seriesModel.get([
        "endLabel",
        "show"
    ])) return true;
    for(var i = 0; i < (0, $fffc76734a157b4c$export$151308dceb52d5b).length; i++){
        if (seriesModel.get([
            (0, $fffc76734a157b4c$export$151308dceb52d5b)[i],
            "endLabel",
            "show"
        ])) return true;
    }
    return false;
}
function $4e131664ee8d81e5$var$createLineClipPath(lineView, coordSys, hasAnimation, seriesModel) {
    if ((0, $8b0e69611399196e$export$8567506e6336616)(coordSys, "cartesian2d")) {
        var endLabelModel_1 = seriesModel.getModel("endLabel");
        var valueAnimation_1 = endLabelModel_1.get("valueAnimation");
        var data_1 = seriesModel.getData();
        var labelAnimationRecord_1 = {
            lastFrameIndex: 0
        };
        var during = $4e131664ee8d81e5$var$anyStateShowEndLabel(seriesModel) ? function(percent, clipRect) {
            lineView._endLabelOnDuring(percent, clipRect, data_1, labelAnimationRecord_1, valueAnimation_1, endLabelModel_1, coordSys);
        } : null;
        var isHorizontal = coordSys.getBaseAxis().isHorizontal();
        var clipPath = (0, $1839445d0e004f61$export$83958787eb658d14)(coordSys, hasAnimation, seriesModel, function() {
            var endLabel = lineView._endLabel;
            if (endLabel && hasAnimation) {
                if (labelAnimationRecord_1.originalX != null) endLabel.attr({
                    x: labelAnimationRecord_1.originalX,
                    y: labelAnimationRecord_1.originalY
                });
            }
        }, during);
        // Expand clip shape to avoid clipping when line value exceeds axis
        if (!seriesModel.get("clip", true)) {
            var rectShape = clipPath.shape;
            var expandSize = Math.max(rectShape.width, rectShape.height);
            if (isHorizontal) {
                rectShape.y -= expandSize;
                rectShape.height += expandSize * 2;
            } else {
                rectShape.x -= expandSize;
                rectShape.width += expandSize * 2;
            }
        }
        // Set to the final frame. To make sure label layout is right.
        if (during) during(1, clipPath);
        return clipPath;
    } else return (0, $1839445d0e004f61$export$13dc2b2230df3cb5)(coordSys, hasAnimation, seriesModel);
}
function $4e131664ee8d81e5$var$getEndLabelStateSpecified(endLabelModel, coordSys) {
    var baseAxis = coordSys.getBaseAxis();
    var isHorizontal = baseAxis.isHorizontal();
    var isBaseInversed = baseAxis.inverse;
    var align = isHorizontal ? isBaseInversed ? "right" : "left" : "center";
    var verticalAlign = isHorizontal ? "middle" : isBaseInversed ? "top" : "bottom";
    return {
        normal: {
            align: endLabelModel.get("align") || align,
            verticalAlign: endLabelModel.get("verticalAlign") || verticalAlign
        }
    };
}
var $4e131664ee8d81e5$var$LineView = /** @class */ function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(LineView, _super);
    function LineView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LineView.prototype.init = function() {
        var lineGroup = new $a8978f7a0e842e3d$export$2e2bcd8739ae039();
        var symbolDraw = new (0, $5e4ea831c3ae4d50$export$2e2bcd8739ae039)();
        this.group.add(symbolDraw.group);
        this._symbolDraw = symbolDraw;
        this._lineGroup = lineGroup;
        this._changePolyState = $43e0a445ed6711da$export$2385a24977818dd0(this._changePolyState, this);
    };
    LineView.prototype.render = function(seriesModel, ecModel, api) {
        var coordSys = seriesModel.coordinateSystem;
        var group = this.group;
        var data = seriesModel.getData();
        var lineStyleModel = seriesModel.getModel("lineStyle");
        var areaStyleModel = seriesModel.getModel("areaStyle");
        var points = data.getLayout("points") || [];
        var isCoordSysPolar = coordSys.type === "polar";
        var prevCoordSys = this._coordSys;
        var symbolDraw = this._symbolDraw;
        var polyline = this._polyline;
        var polygon = this._polygon;
        var lineGroup = this._lineGroup;
        var hasAnimation = !ecModel.ssr && seriesModel.get("animation");
        var isAreaChart = !areaStyleModel.isEmpty();
        var valueOrigin = areaStyleModel.get("origin");
        var dataCoordInfo = (0, $fa4515035fca9aa0$export$b488a529581b37e)(coordSys, data, valueOrigin);
        var stackedOnPoints = isAreaChart && $4e131664ee8d81e5$var$getStackedOnPoints(coordSys, data, dataCoordInfo);
        var showSymbol = seriesModel.get("showSymbol");
        var connectNulls = seriesModel.get("connectNulls");
        var isIgnoreFunc = showSymbol && !isCoordSysPolar && $4e131664ee8d81e5$var$getIsIgnoreFunc(seriesModel, data, coordSys);
        // Remove temporary symbols
        var oldData = this._data;
        oldData && oldData.eachItemGraphicEl(function(el, idx) {
            if (el.__temp) {
                group.remove(el);
                oldData.setItemGraphicEl(idx, null);
            }
        });
        // Remove previous created symbols if showSymbol changed to false
        if (!showSymbol) symbolDraw.remove();
        group.add(lineGroup);
        // FIXME step not support polar
        var step = !isCoordSysPolar ? seriesModel.get("step") : false;
        var clipShapeForSymbol;
        if (coordSys && coordSys.getArea && seriesModel.get("clip", true)) {
            clipShapeForSymbol = coordSys.getArea();
            // Avoid float number rounding error for symbol on the edge of axis extent.
            // See #7913 and `test/dataZoom-clip.html`.
            if (clipShapeForSymbol.width != null) {
                clipShapeForSymbol.x -= 0.1;
                clipShapeForSymbol.y -= 0.1;
                clipShapeForSymbol.width += 0.2;
                clipShapeForSymbol.height += 0.2;
            } else if (clipShapeForSymbol.r0) {
                clipShapeForSymbol.r0 -= 0.5;
                clipShapeForSymbol.r += 0.5;
            }
        }
        this._clipShapeForSymbol = clipShapeForSymbol;
        var visualColor = $4e131664ee8d81e5$var$getVisualGradient(data, coordSys, api) || data.getVisual("style")[data.getVisual("drawType")];
        // Initialization animation or coordinate system changed
        if (!(polyline && prevCoordSys.type === coordSys.type && step === this._step)) {
            showSymbol && symbolDraw.updateData(data, {
                isIgnore: isIgnoreFunc,
                clipShape: clipShapeForSymbol,
                disableAnimation: true,
                getSymbolPoint: function(idx) {
                    return [
                        points[idx * 2],
                        points[idx * 2 + 1]
                    ];
                }
            });
            hasAnimation && this._initSymbolLabelAnimation(data, coordSys, clipShapeForSymbol);
            if (step) {
                if (stackedOnPoints) stackedOnPoints = $4e131664ee8d81e5$var$turnPointsIntoStep(stackedOnPoints, points, coordSys, step, connectNulls);
                // TODO If stacked series is not step
                points = $4e131664ee8d81e5$var$turnPointsIntoStep(points, null, coordSys, step, connectNulls);
            }
            polyline = this._newPolyline(points);
            if (isAreaChart) polygon = this._newPolygon(points, stackedOnPoints);
            else if (polygon) {
                lineGroup.remove(polygon);
                polygon = this._polygon = null;
            }
            // NOTE: Must update _endLabel before setClipPath.
            if (!isCoordSysPolar) this._initOrUpdateEndLabel(seriesModel, coordSys, (0, $78c2ece6dfa6bb7a$export$cda04d03233e5555)(visualColor));
            lineGroup.setClipPath($4e131664ee8d81e5$var$createLineClipPath(this, coordSys, true, seriesModel));
        } else {
            if (isAreaChart && !polygon) // If areaStyle is added
            polygon = this._newPolygon(points, stackedOnPoints);
            else if (polygon && !isAreaChart) {
                // If areaStyle is removed
                lineGroup.remove(polygon);
                polygon = this._polygon = null;
            }
            // NOTE: Must update _endLabel before setClipPath.
            if (!isCoordSysPolar) this._initOrUpdateEndLabel(seriesModel, coordSys, (0, $78c2ece6dfa6bb7a$export$cda04d03233e5555)(visualColor));
            // Update clipPath
            var oldClipPath = lineGroup.getClipPath();
            if (oldClipPath) {
                var newClipPath = $4e131664ee8d81e5$var$createLineClipPath(this, coordSys, false, seriesModel);
                $4feffdaaa31d998e$export$a121566aadcfe021(oldClipPath, {
                    shape: newClipPath.shape
                }, seriesModel);
            } else lineGroup.setClipPath($4e131664ee8d81e5$var$createLineClipPath(this, coordSys, true, seriesModel));
            // Always update, or it is wrong in the case turning on legend
            // because points are not changed.
            showSymbol && symbolDraw.updateData(data, {
                isIgnore: isIgnoreFunc,
                clipShape: clipShapeForSymbol,
                disableAnimation: true,
                getSymbolPoint: function(idx) {
                    return [
                        points[idx * 2],
                        points[idx * 2 + 1]
                    ];
                }
            });
            // In the case data zoom triggered refreshing frequently
            // Data may not change if line has a category axis. So it should animate nothing.
            if (!$4e131664ee8d81e5$var$isPointsSame(this._stackedOnPoints, stackedOnPoints) || !$4e131664ee8d81e5$var$isPointsSame(this._points, points)) {
                if (hasAnimation) this._doUpdateAnimation(data, stackedOnPoints, coordSys, api, step, valueOrigin, connectNulls);
                else {
                    // Not do it in update with animation
                    if (step) {
                        if (stackedOnPoints) stackedOnPoints = $4e131664ee8d81e5$var$turnPointsIntoStep(stackedOnPoints, points, coordSys, step, connectNulls);
                        // TODO If stacked series is not step
                        points = $4e131664ee8d81e5$var$turnPointsIntoStep(points, null, coordSys, step, connectNulls);
                    }
                    polyline.setShape({
                        points: points
                    });
                    polygon && polygon.setShape({
                        points: points,
                        stackedOnPoints: stackedOnPoints
                    });
                }
            }
        }
        var emphasisModel = seriesModel.getModel("emphasis");
        var focus = emphasisModel.get("focus");
        var blurScope = emphasisModel.get("blurScope");
        var emphasisDisabled = emphasisModel.get("disabled");
        polyline.useStyle($43e0a445ed6711da$export$ebe90cb607ad99e(// Use color in lineStyle first
        lineStyleModel.getLineStyle(), {
            fill: "none",
            stroke: visualColor,
            lineJoin: "bevel"
        }));
        (0, $fffc76734a157b4c$export$48b68047d330bbc9)(polyline, seriesModel, "lineStyle");
        if (polyline.style.lineWidth > 0 && seriesModel.get([
            "emphasis",
            "lineStyle",
            "width"
        ]) === "bolder") {
            var emphasisLineStyle = polyline.getState("emphasis").style;
            emphasisLineStyle.lineWidth = +polyline.style.lineWidth + 1;
        }
        // Needs seriesIndex for focus
        (0, $7e4afcfca8f5121f$export$b1c39b2bacd1ddc2)(polyline).seriesIndex = seriesModel.seriesIndex;
        (0, $fffc76734a157b4c$export$e51187539ff11209)(polyline, focus, blurScope, emphasisDisabled);
        var smooth = $4e131664ee8d81e5$var$getSmooth(seriesModel.get("smooth"));
        var smoothMonotone = seriesModel.get("smoothMonotone");
        polyline.setShape({
            smooth: smooth,
            smoothMonotone: smoothMonotone,
            connectNulls: connectNulls
        });
        if (polygon) {
            var stackedOnSeries = data.getCalculationInfo("stackedOnSeries");
            var stackedOnSmooth = 0;
            polygon.useStyle($43e0a445ed6711da$export$ebe90cb607ad99e(areaStyleModel.getAreaStyle(), {
                fill: visualColor,
                opacity: 0.7,
                lineJoin: "bevel",
                decal: data.getVisual("style").decal
            }));
            if (stackedOnSeries) stackedOnSmooth = $4e131664ee8d81e5$var$getSmooth(stackedOnSeries.get("smooth"));
            polygon.setShape({
                smooth: smooth,
                stackedOnSmooth: stackedOnSmooth,
                smoothMonotone: smoothMonotone,
                connectNulls: connectNulls
            });
            (0, $fffc76734a157b4c$export$48b68047d330bbc9)(polygon, seriesModel, "areaStyle");
            // Needs seriesIndex for focus
            (0, $7e4afcfca8f5121f$export$b1c39b2bacd1ddc2)(polygon).seriesIndex = seriesModel.seriesIndex;
            (0, $fffc76734a157b4c$export$e51187539ff11209)(polygon, focus, blurScope, emphasisDisabled);
        }
        var changePolyState = this._changePolyState;
        data.eachItemGraphicEl(function(el) {
            // Switch polyline / polygon state if element changed its state.
            el && (el.onHoverStateChange = changePolyState);
        });
        this._polyline.onHoverStateChange = changePolyState;
        this._data = data;
        // Save the coordinate system for transition animation when data changed
        this._coordSys = coordSys;
        this._stackedOnPoints = stackedOnPoints;
        this._points = points;
        this._step = step;
        this._valueOrigin = valueOrigin;
        var triggerEvent = seriesModel.get("triggerEvent");
        var triggerLineEvent = seriesModel.get("triggerLineEvent");
        var shouldTriggerLineEvent = triggerLineEvent === true || triggerEvent === true || triggerEvent === "line";
        var shouldTriggerAreaEvent = triggerLineEvent === true || triggerEvent === true || triggerEvent === "area";
        this.packEventData(seriesModel, polyline, shouldTriggerLineEvent);
        polygon && this.packEventData(seriesModel, polygon, shouldTriggerAreaEvent);
    };
    LineView.prototype.packEventData = function(seriesModel, el, enable) {
        (0, $7e4afcfca8f5121f$export$b1c39b2bacd1ddc2)(el).eventData = enable ? {
            componentType: "series",
            componentSubType: "line",
            componentIndex: seriesModel.componentIndex,
            seriesIndex: seriesModel.seriesIndex,
            seriesName: seriesModel.name,
            seriesType: "line",
            // for determining this event is triggered by area or line
            selfType: el === this._polygon ? "area" : "line"
        } : null;
    };
    LineView.prototype.highlight = function(seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData();
        var dataIndex = $87f4a59ac66e0ee6$export$42b26cae8b8d10(data, payload);
        this._changePolyState("emphasis");
        if (!(dataIndex instanceof Array) && dataIndex != null && dataIndex >= 0) {
            var points = data.getLayout("points");
            var symbol = data.getItemGraphicEl(dataIndex);
            if (!symbol) {
                // Create a temporary symbol if it is not exists
                var x = points[dataIndex * 2];
                var y = points[dataIndex * 2 + 1];
                if ((0, $fa4515035fca9aa0$export$1817f2c796635b83)(x, y)) // Null data
                return;
                // fix #11360: shouldn't draw symbol outside clipShapeForSymbol
                if (this._clipShapeForSymbol && !this._clipShapeForSymbol.contain(x, y)) return;
                var zlevel = seriesModel.get("zlevel") || 0;
                var z = seriesModel.get("z") || 0;
                symbol = new (0, $718042fda900fb92$export$2e2bcd8739ae039)(data, dataIndex);
                symbol.x = x;
                symbol.y = y;
                symbol.setZ(zlevel, z);
                // ensure label text of the temporary symbol is in front of line and area polygon
                var symbolLabel = symbol.getSymbolPath().getTextContent();
                if (symbolLabel) {
                    symbolLabel.zlevel = zlevel;
                    symbolLabel.z = z;
                    symbolLabel.z2 = this._polyline.z2 + 1;
                }
                symbol.__temp = true;
                data.setItemGraphicEl(dataIndex, symbol);
                // Stop scale animation
                symbol.stopSymbolAnimation(true);
                this.group.add(symbol);
            }
            symbol.highlight();
        } else // Highlight whole series
        (0, $9bc1fbefe72d5b26$export$2e2bcd8739ae039).prototype.highlight.call(this, seriesModel, ecModel, api, payload);
    };
    LineView.prototype.downplay = function(seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData();
        var dataIndex = $87f4a59ac66e0ee6$export$42b26cae8b8d10(data, payload);
        this._changePolyState("normal");
        if (dataIndex != null && dataIndex >= 0) {
            var symbol = data.getItemGraphicEl(dataIndex);
            if (symbol) {
                if (symbol.__temp) {
                    data.setItemGraphicEl(dataIndex, null);
                    this.group.remove(symbol);
                } else symbol.downplay();
            }
        } else // FIXME
        // can not downplay completely.
        // Downplay whole series
        (0, $9bc1fbefe72d5b26$export$2e2bcd8739ae039).prototype.downplay.call(this, seriesModel, ecModel, api, payload);
    };
    LineView.prototype._changePolyState = function(toState) {
        var polygon = this._polygon;
        (0, $fffc76734a157b4c$export$868ba38adffa9e39)(this._polyline, toState);
        polygon && (0, $fffc76734a157b4c$export$868ba38adffa9e39)(polygon, toState);
    };
    LineView.prototype._newPolyline = function(points) {
        var polyline = this._polyline;
        // Remove previous created polyline
        if (polyline) this._lineGroup.remove(polyline);
        polyline = new (0, $fa74553fddb30984$export$bf7c0585b8f7d00f)({
            shape: {
                points: points
            },
            segmentIgnoreThreshold: 2,
            z2: 10
        });
        this._lineGroup.add(polyline);
        this._polyline = polyline;
        return polyline;
    };
    LineView.prototype._newPolygon = function(points, stackedOnPoints) {
        var polygon = this._polygon;
        // Remove previous created polygon
        if (polygon) this._lineGroup.remove(polygon);
        polygon = new (0, $fa74553fddb30984$export$6042a400d113f2bd)({
            shape: {
                points: points,
                stackedOnPoints: stackedOnPoints
            },
            segmentIgnoreThreshold: 2
        });
        this._lineGroup.add(polygon);
        this._polygon = polygon;
        return polygon;
    };
    LineView.prototype._initSymbolLabelAnimation = function(data, coordSys, clipShape) {
        var isHorizontalOrRadial;
        var isCoordSysPolar;
        var baseAxis = coordSys.getBaseAxis();
        var isAxisInverse = baseAxis.inverse;
        if (coordSys.type === "cartesian2d") {
            isHorizontalOrRadial = baseAxis.isHorizontal();
            isCoordSysPolar = false;
        } else if (coordSys.type === "polar") {
            isHorizontalOrRadial = baseAxis.dim === "angle";
            isCoordSysPolar = true;
        }
        var seriesModel = data.hostModel;
        var seriesDuration = seriesModel.get("animationDuration");
        if ($43e0a445ed6711da$export$f6e2535fb5126e54(seriesDuration)) seriesDuration = seriesDuration(null);
        var seriesDelay = seriesModel.get("animationDelay") || 0;
        var seriesDelayValue = $43e0a445ed6711da$export$f6e2535fb5126e54(seriesDelay) ? seriesDelay(null) : seriesDelay;
        data.eachItemGraphicEl(function(symbol, idx) {
            var el = symbol;
            if (el) {
                var point = [
                    symbol.x,
                    symbol.y
                ];
                var start = void 0;
                var end = void 0;
                var current = void 0;
                if (clipShape) {
                    if (isCoordSysPolar) {
                        var polarClip = clipShape;
                        var coord = coordSys.pointToCoord(point);
                        if (isHorizontalOrRadial) {
                            start = polarClip.startAngle;
                            end = polarClip.endAngle;
                            current = -coord[1] / 180 * Math.PI;
                        } else {
                            start = polarClip.r0;
                            end = polarClip.r;
                            current = coord[0];
                        }
                    } else {
                        var gridClip = clipShape;
                        if (isHorizontalOrRadial) {
                            start = gridClip.x;
                            end = gridClip.x + gridClip.width;
                            current = symbol.x;
                        } else {
                            start = gridClip.y + gridClip.height;
                            end = gridClip.y;
                            current = symbol.y;
                        }
                    }
                }
                var ratio = end === start ? 0 : (current - start) / (end - start);
                if (isAxisInverse) ratio = 1 - ratio;
                var delay = $43e0a445ed6711da$export$f6e2535fb5126e54(seriesDelay) ? seriesDelay(idx) : seriesDuration * ratio + seriesDelayValue;
                var symbolPath = el.getSymbolPath();
                var text = symbolPath.getTextContent();
                el.attr({
                    scaleX: 0,
                    scaleY: 0
                });
                el.animateTo({
                    scaleX: 1,
                    scaleY: 1
                }, {
                    duration: 200,
                    setToFinal: true,
                    delay: delay
                });
                if (text) text.animateFrom({
                    style: {
                        opacity: 0
                    }
                }, {
                    duration: 300,
                    delay: delay
                });
                symbolPath.disableLabelAnimation = true;
            }
        });
    };
    LineView.prototype._initOrUpdateEndLabel = function(seriesModel, coordSys, inheritColor) {
        var endLabelModel = seriesModel.getModel("endLabel");
        if ($4e131664ee8d81e5$var$anyStateShowEndLabel(seriesModel)) {
            var data_2 = seriesModel.getData();
            var polyline = this._polyline;
            // series may be filtered.
            var points = data_2.getLayout("points");
            if (!points) {
                polyline.removeTextContent();
                this._endLabel = null;
                return;
            }
            var endLabel = this._endLabel;
            if (!endLabel) {
                endLabel = this._endLabel = new $7db7960d25b39b7c$export$2e2bcd8739ae039({
                    z2: 200 // should be higher than item symbol
                });
                endLabel.ignoreClip = true;
                polyline.setTextContent(this._endLabel);
                polyline.disableLabelAnimation = true;
            }
            // Find last non-NaN data to display data
            var dataIndex = $4e131664ee8d81e5$var$getLastIndexNotNull(points);
            if (dataIndex >= 0) {
                (0, $6556fe1ed9fb479d$export$9a13992917966657)(polyline, (0, $6556fe1ed9fb479d$export$9739a32674be5893)(seriesModel, "endLabel"), {
                    inheritColor: inheritColor,
                    labelFetcher: seriesModel,
                    labelDataIndex: dataIndex,
                    defaultText: function(dataIndex, opt, interpolatedValue) {
                        return interpolatedValue != null ? (0, $b07cae9a23d143b9$export$5f84815e91ca6775)(data_2, interpolatedValue) : (0, $b07cae9a23d143b9$export$5ff20667590927ed)(data_2, dataIndex);
                    },
                    enableTextSetter: true
                }, $4e131664ee8d81e5$var$getEndLabelStateSpecified(endLabelModel, coordSys));
                polyline.textConfig.position = null;
            }
        } else if (this._endLabel) {
            this._polyline.removeTextContent();
            this._endLabel = null;
        }
    };
    LineView.prototype._endLabelOnDuring = function(percent, clipRect, data, animationRecord, valueAnimation, endLabelModel, coordSys) {
        var endLabel = this._endLabel;
        var polyline = this._polyline;
        if (endLabel) {
            // NOTE: Don't remove percent < 1. percent === 1 means the first frame during render.
            // The label is not prepared at this time.
            if (percent < 1 && animationRecord.originalX == null) {
                animationRecord.originalX = endLabel.x;
                animationRecord.originalY = endLabel.y;
            }
            var points = data.getLayout("points");
            var seriesModel = data.hostModel;
            var connectNulls = seriesModel.get("connectNulls");
            var precision = endLabelModel.get("precision");
            var distance = endLabelModel.get("distance") || 0;
            var baseAxis = coordSys.getBaseAxis();
            var isHorizontal = baseAxis.isHorizontal();
            var isBaseInversed = baseAxis.inverse;
            var clipShape = clipRect.shape;
            var xOrY = isBaseInversed ? isHorizontal ? clipShape.x : clipShape.y + clipShape.height : isHorizontal ? clipShape.x + clipShape.width : clipShape.y;
            var distanceX = (isHorizontal ? distance : 0) * (isBaseInversed ? -1 : 1);
            var distanceY = (isHorizontal ? 0 : -distance) * (isBaseInversed ? -1 : 1);
            var dim = isHorizontal ? "x" : "y";
            var dataIndexRange = $4e131664ee8d81e5$var$getIndexRange(points, xOrY, dim);
            var indices = dataIndexRange.range;
            var diff = indices[1] - indices[0];
            var value = void 0;
            if (diff >= 1) {
                // diff > 1 && connectNulls, which is on the null data.
                if (diff > 1 && !connectNulls) {
                    var pt = $4e131664ee8d81e5$var$getPointAtIndex(points, indices[0]);
                    endLabel.attr({
                        x: pt[0] + distanceX,
                        y: pt[1] + distanceY
                    });
                    valueAnimation && (value = seriesModel.getRawValue(indices[0]));
                } else {
                    var pt = polyline.getPointOn(xOrY, dim);
                    pt && endLabel.attr({
                        x: pt[0] + distanceX,
                        y: pt[1] + distanceY
                    });
                    var startValue = seriesModel.getRawValue(indices[0]);
                    var endValue = seriesModel.getRawValue(indices[1]);
                    valueAnimation && (value = $87f4a59ac66e0ee6$export$bd0439821a1869f3(data, precision, startValue, endValue, dataIndexRange.t));
                }
                animationRecord.lastFrameIndex = indices[0];
            } else {
                // If diff <= 0, which is the range is not found(Include NaN)
                // Choose the first point or last point.
                var idx = percent === 1 || animationRecord.lastFrameIndex > 0 ? indices[0] : 0;
                var pt = $4e131664ee8d81e5$var$getPointAtIndex(points, idx);
                valueAnimation && (value = seriesModel.getRawValue(idx));
                endLabel.attr({
                    x: pt[0] + distanceX,
                    y: pt[1] + distanceY
                });
            }
            if (valueAnimation) {
                var inner = (0, $6556fe1ed9fb479d$export$f62786d3261ab0f4)(endLabel);
                if (typeof inner.setLabelText === "function") inner.setLabelText(value);
            }
        }
    };
    /**
   * @private
   */ // FIXME Two value axis
    LineView.prototype._doUpdateAnimation = function(data, stackedOnPoints, coordSys, api, step, valueOrigin, connectNulls) {
        var polyline = this._polyline;
        var polygon = this._polygon;
        var seriesModel = data.hostModel;
        var diff = (0, $3a141650a67a1cff$export$2e2bcd8739ae039)(this._data, data, this._stackedOnPoints, stackedOnPoints, this._coordSys, coordSys, this._valueOrigin, valueOrigin);
        var current = diff.current;
        var stackedOnCurrent = diff.stackedOnCurrent;
        var next = diff.next;
        var stackedOnNext = diff.stackedOnNext;
        if (step) {
            // TODO If stacked series is not step
            stackedOnCurrent = $4e131664ee8d81e5$var$turnPointsIntoStep(diff.stackedOnCurrent, diff.current, coordSys, step, connectNulls);
            current = $4e131664ee8d81e5$var$turnPointsIntoStep(diff.current, null, coordSys, step, connectNulls);
            stackedOnNext = $4e131664ee8d81e5$var$turnPointsIntoStep(diff.stackedOnNext, diff.next, coordSys, step, connectNulls);
            next = $4e131664ee8d81e5$var$turnPointsIntoStep(diff.next, null, coordSys, step, connectNulls);
        }
        // Don't apply animation if diff is large.
        // For better result and avoid memory explosion problems like
        // https://github.com/apache/incubator-echarts/issues/12229
        if ($4e131664ee8d81e5$var$getBoundingDiff(current, next) > 3000 || polygon && $4e131664ee8d81e5$var$getBoundingDiff(stackedOnCurrent, stackedOnNext) > 3000) {
            polyline.stopAnimation();
            polyline.setShape({
                points: next
            });
            if (polygon) {
                polygon.stopAnimation();
                polygon.setShape({
                    points: next,
                    stackedOnPoints: stackedOnNext
                });
            }
            return;
        }
        polyline.shape.__points = diff.current;
        polyline.shape.points = current;
        var target = {
            shape: {
                points: next
            }
        };
        // Also animate the original points.
        // If points reference is changed when turning into step line.
        if (diff.current !== current) target.shape.__points = diff.next;
        // Stop previous animation.
        polyline.stopAnimation();
        $4feffdaaa31d998e$export$c8dce3c08436e91e(polyline, target, seriesModel);
        if (polygon) {
            polygon.setShape({
                // Reuse the points with polyline.
                points: current,
                stackedOnPoints: stackedOnCurrent
            });
            polygon.stopAnimation();
            $4feffdaaa31d998e$export$c8dce3c08436e91e(polygon, {
                shape: {
                    stackedOnPoints: stackedOnNext
                }
            }, seriesModel);
            // If use attr directly in updateProps.
            if (polyline.shape.points !== polygon.shape.points) polygon.shape.points = polyline.shape.points;
        }
        var updatedDataInfo = [];
        var diffStatus = diff.status;
        for(var i = 0; i < diffStatus.length; i++){
            var cmd = diffStatus[i].cmd;
            if (cmd === "=") {
                var el = data.getItemGraphicEl(diffStatus[i].idx1);
                if (el) updatedDataInfo.push({
                    el: el,
                    ptIdx: i // Index of points
                });
            }
        }
        if (polyline.animators && polyline.animators.length) polyline.animators[0].during(function() {
            polygon && polygon.dirtyShape();
            var points = polyline.shape.__points;
            for(var i = 0; i < updatedDataInfo.length; i++){
                var el = updatedDataInfo[i].el;
                var offset = updatedDataInfo[i].ptIdx * 2;
                el.x = points[offset];
                el.y = points[offset + 1];
                el.markRedraw();
            }
        });
    };
    LineView.prototype.remove = function(ecModel) {
        var group = this.group;
        var oldData = this._data;
        this._lineGroup.removeAll();
        this._symbolDraw.remove(true);
        // Remove temporary created elements when highlighting
        oldData && oldData.eachItemGraphicEl(function(el, idx) {
            if (el.__temp) {
                group.remove(el);
                oldData.setItemGraphicEl(idx, null);
            }
        });
        this._polyline = this._polygon = this._coordSys = this._points = this._stackedOnPoints = this._endLabel = this._data = null;
    };
    LineView.type = "line";
    return LineView;
}((0, $9bc1fbefe72d5b26$export$2e2bcd8739ae039));
var $4e131664ee8d81e5$export$2e2bcd8739ae039 = $4e131664ee8d81e5$var$LineView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



function $75c6299197835221$export$2e2bcd8739ae039(seriesType, forceStoreInTypedArray) {
    return {
        seriesType: seriesType,
        plan: (0, $cf4d5552a72b5b73$export$2e2bcd8739ae039)(),
        reset: function(seriesModel) {
            var data = seriesModel.getData();
            var coordSys = seriesModel.coordinateSystem;
            var pipelineContext = seriesModel.pipelineContext;
            var useTypedArray = forceStoreInTypedArray || pipelineContext.large;
            if (!coordSys) return;
            var dims = (0, $43e0a445ed6711da$export$871de8747c9eaa88)(coordSys.dimensions, function(dim) {
                return data.mapDimension(dim);
            }).slice(0, 2);
            var dimLen = dims.length;
            var stackResultDim = data.getCalculationInfo("stackResultDimension");
            if ((0, $bbbaa8c322403e71$export$1dedc39359ae35c)(data, dims[0])) dims[0] = stackResultDim;
            if ((0, $bbbaa8c322403e71$export$1dedc39359ae35c)(data, dims[1])) dims[1] = stackResultDim;
            var store = data.getStore();
            var dimIdx0 = data.getDimensionIndex(dims[0]);
            var dimIdx1 = data.getDimensionIndex(dims[1]);
            return dimLen && {
                progress: function(params, data) {
                    var segCount = params.end - params.start;
                    var points = useTypedArray && (0, $b8db9fde926d4d6f$export$21d2298f3f56bbaf)(segCount * dimLen);
                    var tmpIn = [];
                    var tmpOut = [];
                    for(var i = params.start, offset = 0; i < params.end; i++){
                        var point = void 0;
                        if (dimLen === 1) {
                            var x = store.get(dimIdx0, i);
                            // NOTE: Make sure the second parameter is null to use default strategy.
                            point = coordSys.dataToPoint(x, null, tmpOut);
                        } else {
                            tmpIn[0] = store.get(dimIdx0, i);
                            tmpIn[1] = store.get(dimIdx1, i);
                            // Let coordinate system to handle the NaN data.
                            point = coordSys.dataToPoint(tmpIn, null, tmpOut);
                        }
                        if (useTypedArray) {
                            points[offset++] = point[0];
                            points[offset++] = point[1];
                        } else data.setItemLayout(i, point.slice());
                    }
                    if (useTypedArray) {
                        data.setLayout("points", points);
                        data.setLayout("pointsRange", {
                            start: params.start,
                            end: params.end
                        });
                    }
                }
            };
        }
    };
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3ea5fa7884616381$var$samplers = {
    average: function(frame) {
        var sum = 0;
        var count = 0;
        for(var i = 0; i < frame.length; i++)if (!isNaN(frame[i])) {
            sum += frame[i];
            count++;
        }
        // Return NaN if count is 0
        return count === 0 ? NaN : sum / count;
    },
    sum: function(frame) {
        var sum = 0;
        for(var i = 0; i < frame.length; i++)// Ignore NaN
        sum += frame[i] || 0;
        return sum;
    },
    max: function(frame) {
        var max = -Infinity;
        for(var i = 0; i < frame.length; i++)frame[i] > max && (max = frame[i]);
        // NaN will cause illegal axis extent.
        return isFinite(max) ? max : NaN;
    },
    min: function(frame) {
        var min = Infinity;
        for(var i = 0; i < frame.length; i++)frame[i] < min && (min = frame[i]);
        // NaN will cause illegal axis extent.
        return isFinite(min) ? min : NaN;
    },
    // TODO
    // Median
    nearest: function(frame) {
        return frame[0];
    }
};
var $3ea5fa7884616381$var$indexSampler = function(frame) {
    return Math.round(frame.length / 2);
};
function $3ea5fa7884616381$export$2e2bcd8739ae039(seriesType) {
    return {
        seriesType: seriesType,
        // FIXME:TS never used, so comment it
        // modifyOutputEnd: true,
        reset: function(seriesModel, ecModel, api) {
            var data = seriesModel.getData();
            var sampling = seriesModel.get("sampling");
            var coordSys = seriesModel.coordinateSystem;
            var count = data.count();
            // Only cartesian2d support down sampling. Disable it when there is few data.
            if (count > 10 && coordSys.type === "cartesian2d" && sampling) {
                var baseAxis = coordSys.getBaseAxis();
                var valueAxis = coordSys.getOtherAxis(baseAxis);
                var extent = baseAxis.getExtent();
                var dpr = api.getDevicePixelRatio();
                // Coordinste system has been resized
                var size = Math.abs(extent[1] - extent[0]) * (dpr || 1);
                var rate = Math.round(count / size);
                if (isFinite(rate) && rate > 1) {
                    if (sampling === "lttb") seriesModel.setData(data.lttbDownSample(data.mapDimension(valueAxis.dim), 1 / rate));
                    else if (sampling === "minmax") seriesModel.setData(data.minmaxDownSample(data.mapDimension(valueAxis.dim), 1 / rate));
                    var sampler = void 0;
                    if ((0, $43e0a445ed6711da$export$844ec244b1367d54)(sampling)) sampler = $3ea5fa7884616381$var$samplers[sampling];
                    else if ((0, $43e0a445ed6711da$export$f6e2535fb5126e54)(sampling)) sampler = sampling;
                    if (sampler) // Only support sample the first dim mapped from value axis.
                    seriesModel.setData(data.downSample(data.mapDimension(valueAxis.dim), 1 / rate, sampler, $3ea5fa7884616381$var$indexSampler));
                }
            }
        }
    };
}


function $d4e0260b8893a517$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $4e131664ee8d81e5$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $378a1ca5cf534fab$export$2e2bcd8739ae039));
    registers.registerLayout((0, $75c6299197835221$export$2e2bcd8739ae039)("line", true));
    registers.registerVisual({
        seriesType: "line",
        reset: function(seriesModel) {
            var data = seriesModel.getData();
            // Visual coding for legend
            var lineStyle = seriesModel.getModel("lineStyle").getLineStyle();
            if (lineStyle && !lineStyle.stroke) // Fill in visual should be palette color if
            // has color callback
            lineStyle.stroke = data.getVisual("style").fill;
            data.setVisual("legendLineStyle", lineStyle);
        }
    });
    // Down sample after filter
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, (0, $3ea5fa7884616381$export$2e2bcd8739ae039)("line"));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $73c999f4334448ce$export$2e2bcd8739ae039(seriesType) {
    return {
        seriesType: seriesType,
        reset: function(seriesModel, ecModel) {
            var legendModels = ecModel.findComponents({
                mainType: "legend"
            });
            if (!legendModels || !legendModels.length) return;
            var data = seriesModel.getData();
            data.filterSelf(function(idx) {
                var name = data.getName(idx);
                // If in any legend component the status is not selected.
                for(var i = 0; i < legendModels.length; i++){
                    // @ts-ignore FIXME: LegendModel
                    if (!legendModels[i].isSelected(name)) return false;
                }
                return true;
            });
        }
    };
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $d6db2eca93d7b701$export$2e2bcd8739ae039(seriesModel, opt, nameList) {
    opt = (0, $43e0a445ed6711da$export$43bee75e5e14138e)(opt) && {
        coordDimensions: opt
    } || (0, $43e0a445ed6711da$export$8b58be045bf06082)({
        encodeDefine: seriesModel.getEncode()
    }, opt);
    var source = seriesModel.getSource();
    var dimensions = (0, $9e241c3038e358e2$export$2e2bcd8739ae039)(source, opt).dimensions;
    var list = new (0, $1be6b212af73174f$export$2e2bcd8739ae039)(dimensions, seriesModel);
    list.initData(source, nameList);
    return list;
}






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * LegendVisualProvider is an bridge that pick encoded color from data and
 * provide to the legend component.
 */ var $b8191695258ed3b1$var$LegendVisualProvider = /** @class */ function() {
    function LegendVisualProvider(// Function to get data after filtered. It stores all the encoding info
    getDataWithEncodedVisual, // Function to get raw data before filtered.
    getRawData) {
        this._getDataWithEncodedVisual = getDataWithEncodedVisual;
        this._getRawData = getRawData;
    }
    LegendVisualProvider.prototype.getAllNames = function() {
        var rawData = this._getRawData();
        // We find the name from the raw data. In case it's filtered by the legend component.
        // Normally, the name can be found in rawData, but can't be found in filtered data will display as gray.
        return rawData.mapArray(rawData.getName);
    };
    LegendVisualProvider.prototype.containName = function(name) {
        var rawData = this._getRawData();
        return rawData.indexOfName(name) >= 0;
    };
    LegendVisualProvider.prototype.indexOfName = function(name) {
        // Only get data when necessary.
        // Because LegendVisualProvider constructor may be new in the stage that data is not prepared yet.
        // Invoking Series#getData immediately will throw an error.
        var dataWithEncodedVisual = this._getDataWithEncodedVisual();
        return dataWithEncodedVisual.indexOfName(name);
    };
    LegendVisualProvider.prototype.getItemVisual = function(dataIndex, key) {
        // Get encoded visual properties from final filtered data.
        var dataWithEncodedVisual = this._getDataWithEncodedVisual();
        return dataWithEncodedVisual.getItemVisual(dataIndex, key);
    };
    return LegendVisualProvider;
}();
var $b8191695258ed3b1$export$2e2bcd8739ae039 = $b8191695258ed3b1$var$LegendVisualProvider;




var $08db6fe0bb58ae7d$export$dbe059720353b801 = "pie";
var $08db6fe0bb58ae7d$var$innerData = $87f4a59ac66e0ee6$export$64df9f8d92ae083f();
var $08db6fe0bb58ae7d$var$PieSeriesModel = /** @class */ function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(PieSeriesModel, _super);
    function PieSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = PieSeriesModel.type;
        return _this;
    }
    /**
   * @overwrite
   */ PieSeriesModel.prototype.init = function(option) {
        _super.prototype.init.apply(this, arguments);
        // Enable legend selection for each data item
        // Use a function instead of direct access because data reference may changed
        this.legendVisualProvider = new (0, $b8191695258ed3b1$export$2e2bcd8739ae039)($43e0a445ed6711da$export$2385a24977818dd0(this.getData, this), $43e0a445ed6711da$export$2385a24977818dd0(this.getRawData, this));
        this._defaultLabelLine(option);
    };
    /**
   * @overwrite
   */ PieSeriesModel.prototype.mergeOption = function() {
        _super.prototype.mergeOption.apply(this, arguments);
    };
    /**
   * @overwrite
   */ PieSeriesModel.prototype.getInitialData = function() {
        return (0, $d6db2eca93d7b701$export$2e2bcd8739ae039)(this, {
            coordDimensions: [
                "value"
            ],
            encodeDefaulter: $43e0a445ed6711da$export$c3095a23b368d1f2((0, $a55589c1e81db35a$export$60b8a57d1f2fed26), this)
        });
    };
    /**
   * @overwrite
   */ PieSeriesModel.prototype.getDataParams = function(dataIndex) {
        var data = this.getData();
        // update seats when data is changed
        var dataInner = $08db6fe0bb58ae7d$var$innerData(data);
        var seats = dataInner.seats;
        if (!seats) {
            var valueList_1 = [];
            data.each(data.mapDimension("value"), function(value) {
                valueList_1.push(value);
            });
            seats = dataInner.seats = (0, $b49750109e236fd8$export$222dabb13d5320df)(valueList_1, data.hostModel.get("percentPrecision"));
        }
        var params = _super.prototype.getDataParams.call(this, dataIndex);
        // seats may be empty when sum is 0
        params.percent = seats[dataIndex] || 0;
        params.$vars.push("percent");
        return params;
    };
    PieSeriesModel.prototype._defaultLabelLine = function(option) {
        // Extend labelLine emphasis
        $87f4a59ac66e0ee6$export$abdcc6a26372f94b(option, "labelLine", [
            "show"
        ]);
        var labelLineNormalOpt = option.labelLine;
        var labelLineEmphasisOpt = option.emphasis.labelLine;
        // Not show label line if `label.normal.show = false`
        labelLineNormalOpt.show = labelLineNormalOpt.show && option.label.show;
        labelLineEmphasisOpt.show = labelLineEmphasisOpt.show && option.emphasis.label.show;
    };
    PieSeriesModel.type = "series." + $08db6fe0bb58ae7d$export$dbe059720353b801;
    PieSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        legendHoverLink: true,
        colorBy: "data",
        // 默认全局居中
        center: [
            "50%",
            "50%"
        ],
        radius: [
            0,
            "50%"
        ],
        // 默认顺时针
        clockwise: true,
        startAngle: 90,
        endAngle: "auto",
        padAngle: 0,
        // 最小角度改为0
        minAngle: 0,
        // If the angle of a sector less than `minShowLabelAngle`,
        // the label will not be displayed.
        minShowLabelAngle: 0,
        // 选中时扇区偏移量
        selectedOffset: 10,
        // 选择模式，默认关闭，可选single，multiple
        // selectedMode: false,
        // 南丁格尔玫瑰图模式，'radius'（半径） | 'area'（面积）
        // roseType: null,
        percentPrecision: 2,
        // If still show when all data zero.
        stillShowZeroSum: true,
        // cursor: null,
        coordinateSystemUsage: "box",
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        width: null,
        height: null,
        label: {
            // color: 'inherit',
            // If rotate around circle
            rotate: 0,
            show: true,
            overflow: "truncate",
            // 'outer', 'inside', 'center'
            position: "outer",
            // 'none', 'labelLine', 'edge'. Works only when position is 'outer'
            alignTo: "none",
            // Closest distance between label and chart edge.
            // Works only position is 'outer' and alignTo is 'edge'.
            edgeDistance: "25%",
            // Works only position is 'outer' and alignTo is not 'edge'.
            // The default `bleedMargin` is auto determined according to view rect size.
            // bleedMargin: 10,
            // Distance between text and label line.
            distanceToLabelLine: 5
        },
        // Enabled when label.normal.position is 'outer'
        labelLine: {
            show: true,
            // 引导线两段中的第一段长度
            length: 15,
            // 引导线两段中的第二段长度
            length2: 30,
            smooth: false,
            minTurnAngle: 90,
            maxSurfaceAngle: 90,
            lineStyle: {
                // color: 各异,
                width: 1,
                type: "solid"
            }
        },
        itemStyle: {
            borderWidth: 1,
            borderJoin: "round"
        },
        showEmptyCircle: true,
        emptyCircleStyle: {
            color: "lightgray",
            opacity: 1
        },
        labelLayout: {
            // Hide the overlapped label.
            hideOverlap: true
        },
        emphasis: {
            scale: true,
            scaleSize: 5
        },
        // If use strategy to avoid label overlapping
        avoidLabelOverlap: true,
        // Animation type. Valid values: expansion, scale
        animationType: "expansion",
        animationDuration: 1000,
        // Animation type when update. Valid values: transition, expansion
        animationTypeUpdate: "transition",
        animationEasingUpdate: "cubicInOut",
        animationDurationUpdate: 500,
        animationEasing: "cubicInOut"
    };
    return PieSeriesModel;
}((0, $39002e2f499d7a2f$export$2e2bcd8739ae039));
(0, $a30c5e122eaab0a1$export$b8fb890203e861d5)({
    fullType: $08db6fe0bb58ae7d$var$PieSeriesModel.type,
    getCoord2: function(model) {
        // Not able to validate `center` type here.
        // But percentage center, such as '12%', is not allowed in this case.
        return model.getShallow("center");
    }
});
var $08db6fe0bb58ae7d$export$2e2bcd8739ae039 = $08db6fe0bb58ae7d$var$PieSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // FIXME emphasis label position is not same with normal label position






var $317e620942652546$var$RADIAN = Math.PI / 180;
function $317e620942652546$var$adjustSingleSide(list, cx, cy, r, dir, viewWidth, viewHeight, viewLeft, viewTop, farthestX) {
    if (list.length < 2) return;
    function recalculateXOnSemiToAlignOnEllipseCurve(semi) {
        var rB = semi.rB;
        var rB2 = rB * rB;
        for(var i = 0; i < semi.list.length; i++){
            var item = semi.list[i];
            var dy = Math.abs(item.label.y - cy);
            // horizontal r is always same with original r because x is not changed.
            var rA = r + item.len;
            var rA2 = rA * rA;
            // Use ellipse implicit function to calculate x
            var dx = Math.sqrt(Math.abs((1 - dy * dy / rB2) * rA2));
            var newX = cx + (dx + item.len2) * dir;
            var deltaX = newX - item.label.x;
            var newTargetWidth = item.targetTextWidth - deltaX * dir;
            // text x is changed, so need to recalculate width.
            $317e620942652546$var$constrainTextWidth(item, newTargetWidth, true);
            item.label.x = newX;
        }
    }
    // Adjust X based on the shifted y. Make tight labels aligned on an ellipse curve.
    function recalculateX(items) {
        // Extremes of
        var topSemi = {
            list: [],
            maxY: 0
        };
        var bottomSemi = {
            list: [],
            maxY: 0
        };
        for(var i = 0; i < items.length; i++){
            if (items[i].labelAlignTo !== "none") continue;
            var item = items[i];
            var semi = item.label.y > cy ? bottomSemi : topSemi;
            var dy = Math.abs(item.label.y - cy);
            if (dy >= semi.maxY) {
                var dx = item.label.x - cx - item.len2 * dir;
                // horizontal r is always same with original r because x is not changed.
                var rA = r + item.len;
                // Canculate rB based on the topest / bottemest label.
                var rB = Math.abs(dx) < rA ? Math.sqrt(dy * dy / (1 - dx * dx / rA / rA)) : rA;
                semi.rB = rB;
                semi.maxY = dy;
            }
            semi.list.push(item);
        }
        recalculateXOnSemiToAlignOnEllipseCurve(topSemi);
        recalculateXOnSemiToAlignOnEllipseCurve(bottomSemi);
    }
    var len = list.length;
    for(var i = 0; i < len; i++)if (list[i].position === "outer" && list[i].labelAlignTo === "labelLine") {
        var dx = list[i].label.x - farthestX;
        list[i].linePoints[1][0] += dx;
        list[i].label.x = farthestX;
    }
    if ((0, $c7004a764badae25$export$73ee08bc808f6f3f)(list, 1, viewTop, viewTop + viewHeight)) recalculateX(list);
}
function $317e620942652546$var$avoidOverlap(labelLayoutList, cx, cy, r, viewWidth, viewHeight, viewLeft, viewTop) {
    var leftList = [];
    var rightList = [];
    var leftmostX = Number.MAX_VALUE;
    var rightmostX = -Number.MAX_VALUE;
    for(var i = 0; i < labelLayoutList.length; i++){
        var label = labelLayoutList[i].label;
        if ($317e620942652546$var$isPositionCenter(labelLayoutList[i])) continue;
        if (label.x < cx) {
            leftmostX = Math.min(leftmostX, label.x);
            leftList.push(labelLayoutList[i]);
        } else {
            rightmostX = Math.max(rightmostX, label.x);
            rightList.push(labelLayoutList[i]);
        }
    }
    for(var i = 0; i < labelLayoutList.length; i++){
        var layout = labelLayoutList[i];
        if (!$317e620942652546$var$isPositionCenter(layout) && layout.linePoints) {
            if (layout.labelStyleWidth != null) continue;
            var label = layout.label;
            var linePoints = layout.linePoints;
            var targetTextWidth = void 0;
            if (layout.labelAlignTo === "edge") {
                if (label.x < cx) targetTextWidth = linePoints[2][0] - layout.labelDistance - viewLeft - layout.edgeDistance;
                else targetTextWidth = viewLeft + viewWidth - layout.edgeDistance - linePoints[2][0] - layout.labelDistance;
            } else if (layout.labelAlignTo === "labelLine") {
                if (label.x < cx) targetTextWidth = leftmostX - viewLeft - layout.bleedMargin;
                else targetTextWidth = viewLeft + viewWidth - rightmostX - layout.bleedMargin;
            } else if (label.x < cx) targetTextWidth = label.x - viewLeft - layout.bleedMargin;
            else targetTextWidth = viewLeft + viewWidth - label.x - layout.bleedMargin;
            layout.targetTextWidth = targetTextWidth;
            $317e620942652546$var$constrainTextWidth(layout, targetTextWidth, false);
        }
    }
    $317e620942652546$var$adjustSingleSide(rightList, cx, cy, r, 1, viewWidth, viewHeight, viewLeft, viewTop, rightmostX);
    $317e620942652546$var$adjustSingleSide(leftList, cx, cy, r, -1, viewWidth, viewHeight, viewLeft, viewTop, leftmostX);
    for(var i = 0; i < labelLayoutList.length; i++){
        var layout = labelLayoutList[i];
        if (!$317e620942652546$var$isPositionCenter(layout) && layout.linePoints) {
            var label = layout.label;
            var linePoints = layout.linePoints;
            var isAlignToEdge = layout.labelAlignTo === "edge";
            var padding = label.style.padding;
            var paddingH = padding ? padding[1] + padding[3] : 0;
            // textRect.width already contains paddingH if bgColor is set
            var extraPaddingH = label.style.backgroundColor ? 0 : paddingH;
            var realTextWidth = layout.rect.width + extraPaddingH;
            var dist = linePoints[1][0] - linePoints[2][0];
            if (isAlignToEdge) {
                if (label.x < cx) linePoints[2][0] = viewLeft + layout.edgeDistance + realTextWidth + layout.labelDistance;
                else linePoints[2][0] = viewLeft + viewWidth - layout.edgeDistance - realTextWidth - layout.labelDistance;
            } else {
                if (label.x < cx) linePoints[2][0] = label.x + layout.labelDistance;
                else linePoints[2][0] = label.x - layout.labelDistance;
                linePoints[1][0] = linePoints[2][0] + dist;
            }
            linePoints[1][1] = linePoints[2][1] = label.y;
        }
    }
}
/**
 * Set max width of each label, and then wrap each label to the max width.
 *
 * @param layout label layout
 * @param availableWidth max width for the label to display
 * @param forceRecalculate recaculate the text layout even if the current width
 * is smaller than `availableWidth`. This is useful when the text was previously
 * wrapped by calling `constrainTextWidth` but now `availableWidth` changed, in
 * which case, previous wrapping should be redo.
 */ function $317e620942652546$var$constrainTextWidth(layout, availableWidth, forceRecalculate) {
    if (layout.labelStyleWidth != null) // User-defined style.width has the highest priority.
    return;
    var label = layout.label;
    var style = label.style;
    var textRect = layout.rect;
    var bgColor = style.backgroundColor;
    var padding = style.padding;
    var paddingH = padding ? padding[1] + padding[3] : 0;
    var overflow = style.overflow;
    // textRect.width already contains paddingH if bgColor is set
    var oldOuterWidth = textRect.width + (bgColor ? 0 : paddingH);
    if (availableWidth < oldOuterWidth || forceRecalculate) {
        if (overflow && overflow.match("break")) {
            // Temporarily set background to be null to calculate
            // the bounding box without background.
            label.setStyle("backgroundColor", null);
            // Set constraining width
            label.setStyle("width", availableWidth - paddingH);
            // This is the real bounding box of the text without padding.
            var innerRect = label.getBoundingRect();
            label.setStyle("width", Math.ceil(innerRect.width));
            label.setStyle("backgroundColor", bgColor);
        } else {
            var availableInnerWidth = availableWidth - paddingH;
            var newWidth = availableWidth < oldOuterWidth ? availableInnerWidth : // Current available width is enough, but the text may have
            // already been wrapped with a smaller available width.
            forceRecalculate ? availableInnerWidth > layout.unconstrainedWidth ? null : availableInnerWidth : null;
            label.setStyle("width", newWidth);
        }
        $317e620942652546$var$computeLabelGlobalRect(textRect, label);
    }
}
function $317e620942652546$var$computeLabelGlobalRect(out, label) {
    $317e620942652546$var$_tmpLabelGeometry.rect = out;
    (0, $c7004a764badae25$export$af9bffc2d00de2cc)($317e620942652546$var$_tmpLabelGeometry, label, $317e620942652546$var$_computeLabelGeometryOpt);
}
var $317e620942652546$var$_computeLabelGeometryOpt = {
    minMarginForce: [
        null,
        0,
        null,
        0
    ],
    marginDefault: [
        1,
        0,
        1,
        0
    ]
};
var $317e620942652546$var$_tmpLabelGeometry = {};
function $317e620942652546$var$isPositionCenter(sectorShape) {
    // Not change x for center label
    return sectorShape.position === "center";
}
function $317e620942652546$export$2e2bcd8739ae039(seriesModel) {
    var data = seriesModel.getData();
    var labelLayoutList = [];
    var cx;
    var cy;
    var hasLabelRotate = false;
    var minShowLabelRadian = (seriesModel.get("minShowLabelAngle") || 0) * $317e620942652546$var$RADIAN;
    var viewRect = data.getLayout("viewRect");
    var r = data.getLayout("r");
    var viewWidth = viewRect.width;
    var viewLeft = viewRect.x;
    var viewTop = viewRect.y;
    var viewHeight = viewRect.height;
    function setNotShow(el) {
        el.ignore = true;
    }
    function isLabelShown(label) {
        if (!label.ignore) return true;
        for(var key in label.states){
            if (label.states[key].ignore === false) return true;
        }
        return false;
    }
    data.each(function(idx) {
        var sector = data.getItemGraphicEl(idx);
        var sectorShape = sector.shape;
        var label = sector.getTextContent();
        var labelLine = sector.getTextGuideLine();
        var itemModel = data.getItemModel(idx);
        var labelModel = itemModel.getModel("label");
        // Use position in normal or emphasis
        var labelPosition = labelModel.get("position") || itemModel.get([
            "emphasis",
            "label",
            "position"
        ]);
        var labelDistance = labelModel.get("distanceToLabelLine");
        var labelAlignTo = labelModel.get("alignTo");
        var edgeDistance = (0, $b49750109e236fd8$export$e8514cb5a5e2b40f)(labelModel.get("edgeDistance"), viewWidth);
        var bleedMargin = labelModel.get("bleedMargin");
        if (bleedMargin == null) // An arbitrary strategy for small viewRect - especial pie is layout in calendar or matrix coord sys.
        bleedMargin = Math.min(viewWidth, viewHeight) > 200 ? 10 : 2;
        var labelLineModel = itemModel.getModel("labelLine");
        var labelLineLen = labelLineModel.get("length");
        labelLineLen = (0, $b49750109e236fd8$export$e8514cb5a5e2b40f)(labelLineLen, viewWidth);
        var labelLineLen2 = labelLineModel.get("length2");
        labelLineLen2 = (0, $b49750109e236fd8$export$e8514cb5a5e2b40f)(labelLineLen2, viewWidth);
        if (Math.abs(sectorShape.endAngle - sectorShape.startAngle) < minShowLabelRadian) {
            (0, $43e0a445ed6711da$export$79b2f7037acddd43)(label.states, setNotShow);
            label.ignore = true;
            if (labelLine) {
                (0, $43e0a445ed6711da$export$79b2f7037acddd43)(labelLine.states, setNotShow);
                labelLine.ignore = true;
            }
            return;
        }
        if (!isLabelShown(label)) return;
        var midAngle = (sectorShape.startAngle + sectorShape.endAngle) / 2;
        var nx = Math.cos(midAngle);
        var ny = Math.sin(midAngle);
        var textX;
        var textY;
        var linePoints;
        var textAlign;
        cx = sectorShape.cx;
        cy = sectorShape.cy;
        var isLabelInside = labelPosition === "inside" || labelPosition === "inner";
        if (labelPosition === "center") {
            textX = sectorShape.cx;
            textY = sectorShape.cy;
            textAlign = "center";
        } else {
            var x1 = (isLabelInside ? (sectorShape.r + sectorShape.r0) / 2 * nx : sectorShape.r * nx) + cx;
            var y1 = (isLabelInside ? (sectorShape.r + sectorShape.r0) / 2 * ny : sectorShape.r * ny) + cy;
            textX = x1 + nx * 3;
            textY = y1 + ny * 3;
            if (!isLabelInside) {
                // For roseType
                var x2 = x1 + nx * (labelLineLen + r - sectorShape.r);
                var y2 = y1 + ny * (labelLineLen + r - sectorShape.r);
                var x3 = x2 + (nx < 0 ? -1 : 1) * labelLineLen2;
                var y3 = y2;
                if (labelAlignTo === "edge") // Adjust textX because text align of edge is opposite
                textX = nx < 0 ? viewLeft + edgeDistance : viewLeft + viewWidth - edgeDistance;
                else textX = x3 + (nx < 0 ? -labelDistance : labelDistance);
                textY = y3;
                linePoints = [
                    [
                        x1,
                        y1
                    ],
                    [
                        x2,
                        y2
                    ],
                    [
                        x3,
                        y3
                    ]
                ];
            }
            textAlign = isLabelInside ? "center" : labelAlignTo === "edge" ? nx > 0 ? "right" : "left" : nx > 0 ? "left" : "right";
        }
        var PI = Math.PI;
        var labelRotate = 0;
        var rotate = labelModel.get("rotate");
        if ((0, $43e0a445ed6711da$export$7e4aa119212bc614)(rotate)) labelRotate = rotate * (PI / 180);
        else if (labelPosition === "center") labelRotate = 0;
        else if (rotate === "radial" || rotate === true) {
            var radialAngle = nx < 0 ? -midAngle + PI : -midAngle;
            labelRotate = radialAngle;
        } else if (rotate === "tangential" || rotate === "tangential-noflip" && labelPosition !== "outside" && labelPosition !== "outer") {
            var rad = Math.atan2(nx, ny);
            if (rad < 0) rad = PI * 2 + rad;
            var isDown = ny > 0;
            if (isDown && rotate !== "tangential-noflip") rad = PI + rad;
            labelRotate = rad - PI;
        }
        hasLabelRotate = !!labelRotate;
        label.x = textX;
        label.y = textY;
        label.rotation = labelRotate;
        label.setStyle({
            verticalAlign: "middle"
        });
        // Not sectorShape the inside label
        if (!isLabelInside) {
            var textRect = new (0, $c437f598d9c9ee16$export$2e2bcd8739ae039)(0, 0, 0, 0);
            $317e620942652546$var$computeLabelGlobalRect(textRect, label);
            labelLayoutList.push({
                label: label,
                labelLine: labelLine,
                position: labelPosition,
                len: labelLineLen,
                len2: labelLineLen2,
                minTurnAngle: labelLineModel.get("minTurnAngle"),
                maxSurfaceAngle: labelLineModel.get("maxSurfaceAngle"),
                surfaceNormal: new (0, $1de2ad08c108b7c2$export$2e2bcd8739ae039)(nx, ny),
                linePoints: linePoints,
                textAlign: textAlign,
                labelDistance: labelDistance,
                labelAlignTo: labelAlignTo,
                edgeDistance: edgeDistance,
                bleedMargin: bleedMargin,
                rect: textRect,
                unconstrainedWidth: textRect.width,
                labelStyleWidth: label.style.width
            });
        } else {
            label.setStyle({
                align: textAlign
            });
            var selectState = label.states.select;
            if (selectState) {
                selectState.x += label.x;
                selectState.y += label.y;
            }
        }
        sector.setTextConfig({
            inside: isLabelInside
        });
    });
    if (!hasLabelRotate && seriesModel.get("avoidLabelOverlap")) $317e620942652546$var$avoidOverlap(labelLayoutList, cx, cy, r, viewWidth, viewHeight, viewLeft, viewTop);
    for(var i = 0; i < labelLayoutList.length; i++){
        var layout = labelLayoutList[i];
        var label = layout.label;
        var labelLine = layout.labelLine;
        var notShowLabel = isNaN(label.x) || isNaN(label.y);
        if (label) {
            label.setStyle({
                align: layout.textAlign
            });
            if (notShowLabel) {
                (0, $43e0a445ed6711da$export$79b2f7037acddd43)(label.states, setNotShow);
                label.ignore = true;
            }
            var selectState = label.states.select;
            if (selectState) {
                selectState.x += label.x;
                selectState.y += label.y;
            }
        }
        if (labelLine) {
            var linePoints = layout.linePoints;
            if (notShowLabel || !linePoints) {
                (0, $43e0a445ed6711da$export$79b2f7037acddd43)(labelLine.states, setNotShow);
                labelLine.ignore = true;
            } else {
                (0, $7cea174eb56f6e38$export$ac52062003fbe6a)(linePoints, layout.minTurnAngle);
                (0, $7cea174eb56f6e38$export$973e1fdb2708f71b)(linePoints, layout.surfaceNormal, layout.maxSurfaceAngle);
                labelLine.setShape({
                    points: linePoints
                });
                // Set the anchor to the midpoint of sector
                label.__hostTarget.textGuideLineConfig = {
                    anchor: new (0, $1de2ad08c108b7c2$export$2e2bcd8739ae039)(linePoints[0][0], linePoints[0][1])
                };
            }
        }
    }
}




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $33f833f470f0d71d$export$b395eeeb2ad7cce5(model, shape, zeroIfNull) {
    var cornerRadius = model.get("borderRadius");
    if (cornerRadius == null) return zeroIfNull ? {
        cornerRadius: 0
    } : null;
    if (!(0, $43e0a445ed6711da$export$43bee75e5e14138e)(cornerRadius)) cornerRadius = [
        cornerRadius,
        cornerRadius,
        cornerRadius,
        cornerRadius
    ];
    var dr = Math.abs(shape.r || 0 - shape.r0 || 0);
    return {
        cornerRadius: (0, $43e0a445ed6711da$export$871de8747c9eaa88)(cornerRadius, function(cr) {
            return (0, $67e15a06bdb46d49$export$e8514cb5a5e2b40f)(cr, dr);
        })
    };
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $1d4ea3c6172d06dc$var$PI2 = Math.PI * 2;
var $1d4ea3c6172d06dc$var$RADIAN = Math.PI / 180;
var $1d4ea3c6172d06dc$export$76f4818e1603813e = (0, $87f4a59ac66e0ee6$export$c635911e41d20ada)((0, $08db6fe0bb58ae7d$export$dbe059720353b801), $1d4ea3c6172d06dc$var$pieLayout);
function $1d4ea3c6172d06dc$var$pieLayout(ecModel, api) {
    ecModel.eachSeriesByType((0, $08db6fe0bb58ae7d$export$dbe059720353b801), function(seriesModel) {
        var data = seriesModel.getData();
        var valueDim = data.mapDimension("value");
        var _a = (0, $826bc4094efae72b$export$3101c00baac0ee1f)(seriesModel, api), cx = _a.cx, cy = _a.cy, r = _a.r, r0 = _a.r0, viewRect = _a.viewRect;
        var startAngle = -seriesModel.get("startAngle") * $1d4ea3c6172d06dc$var$RADIAN;
        var endAngle = seriesModel.get("endAngle");
        var padAngle = seriesModel.get("padAngle") * $1d4ea3c6172d06dc$var$RADIAN;
        endAngle = endAngle === "auto" ? startAngle - $1d4ea3c6172d06dc$var$PI2 : -endAngle * $1d4ea3c6172d06dc$var$RADIAN;
        var minAngle = seriesModel.get("minAngle") * $1d4ea3c6172d06dc$var$RADIAN;
        var minAndPadAngle = minAngle + padAngle;
        var validDataCount = 0;
        data.each(valueDim, function(value) {
            !isNaN(value) && validDataCount++;
        });
        var sum = data.getSum(valueDim);
        // Sum may be 0
        var unitRadian = Math.PI / (sum || validDataCount) * 2;
        var clockwise = seriesModel.get("clockwise");
        var roseType = seriesModel.get("roseType");
        var stillShowZeroSum = seriesModel.get("stillShowZeroSum");
        // [0...max]
        var extent = data.getDataExtent(valueDim);
        extent[0] = 0;
        var dir = clockwise ? 1 : -1;
        var angles = [
            startAngle,
            endAngle
        ];
        var halfPadAngle = dir * padAngle / 2;
        (0, $e2a16933ef78a053$export$bc668021e937022a)(angles, !clockwise);
        startAngle = angles[0], endAngle = angles[1];
        var layoutData = $1d4ea3c6172d06dc$export$4e43b88a06b9f223(seriesModel);
        layoutData.startAngle = startAngle;
        layoutData.endAngle = endAngle;
        layoutData.clockwise = clockwise;
        layoutData.cx = cx;
        layoutData.cy = cy;
        layoutData.r = r;
        layoutData.r0 = r0;
        var angleRange = Math.abs(endAngle - startAngle);
        // In the case some sector angle is smaller than minAngle
        var restAngle = angleRange;
        var valueSumLargerThanMinAngle = 0;
        var currentAngle = startAngle;
        // Requird by `pieLabelLayout`.
        data.setLayout({
            viewRect: viewRect,
            r: r
        });
        data.each(valueDim, function(value, idx) {
            var angle;
            if (isNaN(value)) {
                data.setItemLayout(idx, {
                    angle: NaN,
                    startAngle: NaN,
                    endAngle: NaN,
                    clockwise: clockwise,
                    cx: cx,
                    cy: cy,
                    r0: r0,
                    r: roseType ? NaN : r
                });
                return;
            }
            // FIXME 兼容 2.0 但是 roseType 是 area 的时候才是这样？
            if (roseType !== "area") angle = sum === 0 && stillShowZeroSum ? unitRadian : value * unitRadian;
            else angle = angleRange / validDataCount;
            if (angle < minAndPadAngle) {
                angle = minAndPadAngle;
                restAngle -= minAndPadAngle;
            } else valueSumLargerThanMinAngle += value;
            var endAngle = currentAngle + dir * angle;
            // calculate display angle
            var actualStartAngle = 0;
            var actualEndAngle = 0;
            if (padAngle > angle) {
                actualStartAngle = currentAngle + dir * angle / 2;
                actualEndAngle = actualStartAngle;
            } else {
                actualStartAngle = currentAngle + halfPadAngle;
                actualEndAngle = endAngle - halfPadAngle;
            }
            data.setItemLayout(idx, {
                angle: angle,
                startAngle: actualStartAngle,
                endAngle: actualEndAngle,
                clockwise: clockwise,
                cx: cx,
                cy: cy,
                r0: r0,
                r: roseType ? (0, $b49750109e236fd8$export$d3f68fbaa670562)(value, extent, [
                    r0,
                    r
                ]) : r
            });
            currentAngle = endAngle;
        });
        // Some sector is constrained by minAngle and padAngle
        // Rest sectors needs recalculate angle
        if (restAngle < $1d4ea3c6172d06dc$var$PI2 && validDataCount) {
            // Average the angle if rest angle is not enough after all angles is
            // Constrained by minAngle and padAngle
            if (restAngle <= 1e-3) {
                var angle_1 = angleRange / validDataCount;
                data.each(valueDim, function(value, idx) {
                    if (!isNaN(value)) {
                        var layout = data.getItemLayout(idx);
                        layout.angle = angle_1;
                        var actualStartAngle = 0;
                        var actualEndAngle = 0;
                        if (angle_1 < padAngle) {
                            actualStartAngle = startAngle + dir * (idx + 0.5) * angle_1;
                            actualEndAngle = actualStartAngle;
                        } else {
                            actualStartAngle = startAngle + dir * idx * angle_1 + halfPadAngle;
                            actualEndAngle = startAngle + dir * (idx + 1) * angle_1 - halfPadAngle;
                        }
                        layout.startAngle = actualStartAngle;
                        layout.endAngle = actualEndAngle;
                    }
                });
            } else {
                unitRadian = restAngle / valueSumLargerThanMinAngle;
                currentAngle = startAngle;
                data.each(valueDim, function(value, idx) {
                    if (!isNaN(value)) {
                        var layout = data.getItemLayout(idx);
                        var angle = layout.angle === minAndPadAngle ? minAndPadAngle : value * unitRadian;
                        var actualStartAngle = 0;
                        var actualEndAngle = 0;
                        if (angle < padAngle) {
                            actualStartAngle = currentAngle + dir * angle / 2;
                            actualEndAngle = actualStartAngle;
                        } else {
                            actualStartAngle = currentAngle + halfPadAngle;
                            actualEndAngle = currentAngle + dir * angle - halfPadAngle;
                        }
                        layout.startAngle = actualStartAngle;
                        layout.endAngle = actualEndAngle;
                        currentAngle += dir * angle;
                    }
                });
            }
        }
    });
}
var $1d4ea3c6172d06dc$export$4e43b88a06b9f223 = (0, $87f4a59ac66e0ee6$export$64df9f8d92ae083f)();


/**
 * Piece of pie including Sector, Label, LabelLine
 */ var $fb3c691c63622d73$var$PiePiece = /** @class */ function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(PiePiece, _super);
    function PiePiece(data, idx, startAngle) {
        var _this = _super.call(this) || this;
        _this.z2 = 2;
        var text = new $7db7960d25b39b7c$export$2e2bcd8739ae039();
        _this.setTextContent(text);
        _this.updateData(data, idx, startAngle, true);
        return _this;
    }
    PiePiece.prototype.updateData = function(data, idx, startAngle, firstCreate) {
        var sector = this;
        var seriesModel = data.hostModel;
        var itemModel = data.getItemModel(idx);
        var emphasisModel = itemModel.getModel("emphasis");
        var layout = data.getItemLayout(idx);
        // cornerRadius & innerCornerRadius doesn't exist in the item layout. Use `0` if null value is specified.
        // see `setItemLayout` in `pieLayout.ts`.
        var sectorShape = (0, $43e0a445ed6711da$export$8b58be045bf06082)((0, $33f833f470f0d71d$export$b395eeeb2ad7cce5)(itemModel.getModel("itemStyle"), layout, true), layout);
        // Ignore NaN data.
        if (isNaN(sectorShape.startAngle)) {
            // Use NaN shape to avoid drawing shape.
            sector.setShape(sectorShape);
            return;
        }
        if (firstCreate) {
            sector.setShape(sectorShape);
            var animationType = seriesModel.getShallow("animationType");
            if (seriesModel.ecModel.ssr) {
                // Use scale animation in SSR mode(opacity?)
                // Because CSS SVG animation doesn't support very customized shape animation.
                $4feffdaaa31d998e$export$a121566aadcfe021(sector, {
                    scaleX: 0,
                    scaleY: 0
                }, seriesModel, {
                    dataIndex: idx,
                    isFrom: true
                });
                sector.originX = sectorShape.cx;
                sector.originY = sectorShape.cy;
            } else if (animationType === "scale") {
                sector.shape.r = layout.r0;
                $4feffdaaa31d998e$export$a121566aadcfe021(sector, {
                    shape: {
                        r: layout.r
                    }
                }, seriesModel, idx);
            } else if (startAngle != null) {
                sector.setShape({
                    startAngle: startAngle,
                    endAngle: startAngle
                });
                $4feffdaaa31d998e$export$a121566aadcfe021(sector, {
                    shape: {
                        startAngle: layout.startAngle,
                        endAngle: layout.endAngle
                    }
                }, seriesModel, idx);
            } else {
                sector.shape.endAngle = layout.startAngle;
                $4feffdaaa31d998e$export$c8dce3c08436e91e(sector, {
                    shape: {
                        endAngle: layout.endAngle
                    }
                }, seriesModel, idx);
            }
        } else {
            (0, $4feffdaaa31d998e$export$bca7290a9faf0ec9)(sector);
            // Transition animation from the old shape
            $4feffdaaa31d998e$export$c8dce3c08436e91e(sector, {
                shape: sectorShape
            }, seriesModel, idx);
        }
        sector.useStyle(data.getItemVisual(idx, "style"));
        (0, $fffc76734a157b4c$export$48b68047d330bbc9)(sector, itemModel);
        var midAngle = (layout.startAngle + layout.endAngle) / 2;
        var offset = seriesModel.get("selectedOffset");
        var dx = Math.cos(midAngle) * offset;
        var dy = Math.sin(midAngle) * offset;
        var cursorStyle = itemModel.getShallow("cursor");
        cursorStyle && sector.attr("cursor", cursorStyle);
        this._updateLabel(seriesModel, data, idx);
        sector.ensureState("emphasis").shape = (0, $43e0a445ed6711da$export$8b58be045bf06082)({
            r: layout.r + (emphasisModel.get("scale") ? emphasisModel.get("scaleSize") || 0 : 0)
        }, (0, $33f833f470f0d71d$export$b395eeeb2ad7cce5)(emphasisModel.getModel("itemStyle"), layout));
        (0, $43e0a445ed6711da$export$8b58be045bf06082)(sector.ensureState("select"), {
            x: dx,
            y: dy,
            shape: (0, $33f833f470f0d71d$export$b395eeeb2ad7cce5)(itemModel.getModel([
                "select",
                "itemStyle"
            ]), layout)
        });
        (0, $43e0a445ed6711da$export$8b58be045bf06082)(sector.ensureState("blur"), {
            shape: (0, $33f833f470f0d71d$export$b395eeeb2ad7cce5)(itemModel.getModel([
                "blur",
                "itemStyle"
            ]), layout)
        });
        var labelLine = sector.getTextGuideLine();
        var labelText = sector.getTextContent();
        labelLine && (0, $43e0a445ed6711da$export$8b58be045bf06082)(labelLine.ensureState("select"), {
            x: dx,
            y: dy
        });
        // TODO: needs dx, dy in zrender?
        (0, $43e0a445ed6711da$export$8b58be045bf06082)(labelText.ensureState("select"), {
            x: dx,
            y: dy
        });
        (0, $fffc76734a157b4c$export$e51187539ff11209)(this, emphasisModel.get("focus"), emphasisModel.get("blurScope"), emphasisModel.get("disabled"));
    };
    PiePiece.prototype._updateLabel = function(seriesModel, data, idx) {
        var sector = this;
        var itemModel = data.getItemModel(idx);
        var labelLineModel = itemModel.getModel("labelLine");
        var style = data.getItemVisual(idx, "style");
        var visualColor = style && style.fill;
        var visualOpacity = style && style.opacity;
        (0, $6556fe1ed9fb479d$export$9a13992917966657)(sector, (0, $6556fe1ed9fb479d$export$9739a32674be5893)(itemModel), {
            labelFetcher: data.hostModel,
            labelDataIndex: idx,
            inheritColor: visualColor,
            defaultOpacity: visualOpacity,
            defaultText: seriesModel.getFormattedLabel(idx, "normal") || data.getName(idx)
        });
        var labelText = sector.getTextContent();
        // Set textConfig on sector.
        sector.setTextConfig({
            // reset position, rotation
            position: null,
            rotation: null
        });
        // Make sure update style on labelText after setLabelStyle.
        // Because setLabelStyle will replace a new style on it.
        labelText.attr({
            z2: 10
        });
        var labelPosition = itemModel.get([
            "label",
            "position"
        ]);
        if (labelPosition !== "outside" && labelPosition !== "outer") sector.removeTextGuideLine();
        else {
            var polyline = this.getTextGuideLine();
            if (!polyline) {
                polyline = new $363f38bff4966f60$export$2e2bcd8739ae039();
                this.setTextGuideLine(polyline);
            }
            // Default use item visual color
            (0, $7cea174eb56f6e38$export$c09e0b0574bdd2dc)(this, (0, $7cea174eb56f6e38$export$2979fdbf5ebce521)(itemModel), {
                stroke: visualColor,
                opacity: (0, $43e0a445ed6711da$export$2e94551289abb95b)(labelLineModel.get([
                    "lineStyle",
                    "opacity"
                ]), visualOpacity, 1)
            });
        }
    };
    return PiePiece;
}($7a3d58339c1601e8$export$2e2bcd8739ae039);
var $fb3c691c63622d73$var$PieView = /** @class */ function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(PieView, _super);
    function PieView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = (0, $08db6fe0bb58ae7d$export$dbe059720353b801);
        _this.ignoreLabelLineUpdate = true;
        return _this;
    }
    PieView.prototype.render = function(seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData();
        var oldData = this._data;
        var group = this.group;
        var startAngle;
        // First render
        if (!oldData && data.count() > 0) {
            var shape = data.getItemLayout(0);
            for(var s = 1; isNaN(shape && shape.startAngle) && s < data.count(); ++s)shape = data.getItemLayout(s);
            if (shape) startAngle = shape.startAngle;
        }
        // remove empty-circle if it exists
        if (this._emptyCircleSector) group.remove(this._emptyCircleSector);
        // when all data are filtered, show lightgray empty circle
        if (data.count() === 0 && seriesModel.get("showEmptyCircle")) {
            var layoutData = (0, $1d4ea3c6172d06dc$export$4e43b88a06b9f223)(seriesModel);
            var sector = new $7a3d58339c1601e8$export$2e2bcd8739ae039({
                shape: (0, $43e0a445ed6711da$export$9cd59f9826255e47)(layoutData)
            });
            sector.useStyle(seriesModel.getModel("emptyCircleStyle").getItemStyle());
            this._emptyCircleSector = sector;
            group.add(sector);
        }
        data.diff(oldData).add(function(idx) {
            var piePiece = new $fb3c691c63622d73$var$PiePiece(data, idx, startAngle);
            data.setItemGraphicEl(idx, piePiece);
            group.add(piePiece);
        }).update(function(newIdx, oldIdx) {
            var piePiece = oldData.getItemGraphicEl(oldIdx);
            piePiece.updateData(data, newIdx, startAngle);
            piePiece.off("click");
            group.add(piePiece);
            data.setItemGraphicEl(newIdx, piePiece);
        }).remove(function(idx) {
            var piePiece = oldData.getItemGraphicEl(idx);
            $4feffdaaa31d998e$export$6d0fd725cb4aee8a(piePiece, seriesModel, idx);
        }).execute();
        (0, $317e620942652546$export$2e2bcd8739ae039)(seriesModel);
        // Always use initial animation.
        if (seriesModel.get("animationTypeUpdate") !== "expansion") this._data = data;
    };
    PieView.prototype.dispose = function() {};
    PieView.prototype.containPoint = function(point, seriesModel) {
        var data = seriesModel.getData();
        var itemLayout = data.getItemLayout(0);
        if (itemLayout) {
            var dx = point[0] - itemLayout.cx;
            var dy = point[1] - itemLayout.cy;
            var radius = Math.sqrt(dx * dx + dy * dy);
            return radius <= itemLayout.r && radius >= itemLayout.r0;
        }
    };
    PieView.type = (0, $08db6fe0bb58ae7d$export$dbe059720353b801);
    return PieView;
}((0, $9bc1fbefe72d5b26$export$2e2bcd8739ae039));
var $fb3c691c63622d73$export$2e2bcd8739ae039 = $fb3c691c63622d73$var$PieView;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $91371df7491c3cd4$export$2e2bcd8739ae039(seriesType) {
    return {
        seriesType: seriesType,
        reset: function(seriesModel, ecModel) {
            var data = seriesModel.getData();
            data.filterSelf(function(idx) {
                // handle negative value condition
                var valueDim = data.mapDimension("value");
                var curValue = data.get(valueDim, idx);
                if ((0, $43e0a445ed6711da$export$7e4aa119212bc614)(curValue) && !isNaN(curValue) && curValue < 0) return false;
                return true;
            });
        }
    };
}



function $bb562bde2a71d0dd$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $fb3c691c63622d73$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $08db6fe0bb58ae7d$export$2e2bcd8739ae039));
    (0, $5779b3a999a9cae1$export$62942ba95693dbfc)((0, $08db6fe0bb58ae7d$export$dbe059720353b801), registers.registerAction);
    registers.registerLayout((0, $1d4ea3c6172d06dc$export$76f4818e1603813e));
    registers.registerProcessor((0, $73c999f4334448ce$export$2e2bcd8739ae039)((0, $08db6fe0bb58ae7d$export$dbe059720353b801)));
    registers.registerProcessor((0, $91371df7491c3cd4$export$2e2bcd8739ae039)((0, $08db6fe0bb58ae7d$export$dbe059720353b801)));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /* global Uint8ClampedArray */ 

var $5b65f5163321be51$var$GRADIENT_LEVELS = 256;
var $5b65f5163321be51$var$HeatmapLayer = /** @class */ function() {
    function HeatmapLayer() {
        this.blurSize = 30;
        this.pointSize = 20;
        this.maxOpacity = 1;
        this.minOpacity = 0;
        this._gradientPixels = {
            inRange: null,
            outOfRange: null
        };
        var canvas = (0, $08c3209e6efc839a$export$ef5e599365494451).createCanvas();
        this.canvas = canvas;
    }
    /**
   * Renders Heatmap and returns the rendered canvas
   * @param data array of data, each has x, y, value
   * @param width canvas width
   * @param height canvas height
   */ HeatmapLayer.prototype.update = function(data, width, height, normalize, colorFunc, isInRange) {
        var brush = this._getBrush();
        var gradientInRange = this._getGradient(colorFunc, "inRange");
        var gradientOutOfRange = this._getGradient(colorFunc, "outOfRange");
        var r = this.pointSize + this.blurSize;
        var canvas = this.canvas;
        var ctx = canvas.getContext("2d");
        var len = data.length;
        canvas.width = width;
        canvas.height = height;
        for(var i = 0; i < len; ++i){
            var p = data[i];
            var x = p[0];
            var y = p[1];
            var value = p[2];
            // calculate alpha using value
            var alpha = normalize(value);
            // draw with the circle brush with alpha
            ctx.globalAlpha = alpha;
            ctx.drawImage(brush, x - r, y - r);
        }
        if (!canvas.width || !canvas.height) // Avoid "Uncaught DOMException: Failed to execute 'getImageData' on
        // 'CanvasRenderingContext2D': The source height is 0."
        return canvas;
        // colorize the canvas using alpha value and set with gradient
        var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        var pixels = imageData.data;
        var offset = 0;
        var pixelLen = pixels.length;
        var minOpacity = this.minOpacity;
        var maxOpacity = this.maxOpacity;
        var diffOpacity = maxOpacity - minOpacity;
        while(offset < pixelLen){
            var alpha = pixels[offset + 3] / 256;
            var gradientOffset = Math.floor(alpha * ($5b65f5163321be51$var$GRADIENT_LEVELS - 1)) * 4;
            // Simple optimize to ignore the empty data
            if (alpha > 0) {
                var gradient = isInRange(alpha) ? gradientInRange : gradientOutOfRange;
                // Any alpha > 0 will be mapped to [minOpacity, maxOpacity]
                alpha > 0 && (alpha = alpha * diffOpacity + minOpacity);
                pixels[offset++] = gradient[gradientOffset];
                pixels[offset++] = gradient[gradientOffset + 1];
                pixels[offset++] = gradient[gradientOffset + 2];
                pixels[offset++] = gradient[gradientOffset + 3] * alpha * 256;
            } else offset += 4;
        }
        ctx.putImageData(imageData, 0, 0);
        return canvas;
    };
    /**
   * get canvas of a black circle brush used for canvas to draw later
   */ HeatmapLayer.prototype._getBrush = function() {
        var brushCanvas = this._brushCanvas || (this._brushCanvas = (0, $08c3209e6efc839a$export$ef5e599365494451).createCanvas());
        // set brush size
        var r = this.pointSize + this.blurSize;
        var d = r * 2;
        brushCanvas.width = d;
        brushCanvas.height = d;
        var ctx = brushCanvas.getContext("2d");
        ctx.clearRect(0, 0, d, d);
        // in order to render shadow without the distinct circle,
        // draw the distinct circle in an invisible place,
        // and use shadowOffset to draw shadow in the center of the canvas
        ctx.shadowOffsetX = d;
        ctx.shadowBlur = this.blurSize;
        // draw the shadow in black, and use alpha and shadow blur to generate
        // color in color map
        ctx.shadowColor = (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.neutral99;
        // draw circle in the left to the canvas
        ctx.beginPath();
        ctx.arc(-r, r, this.pointSize, 0, Math.PI * 2, true);
        ctx.closePath();
        ctx.fill();
        return brushCanvas;
    };
    /**
   * get gradient color map
   * @private
   */ HeatmapLayer.prototype._getGradient = function(colorFunc, state) {
        var gradientPixels = this._gradientPixels;
        var pixelsSingleState = gradientPixels[state] || (gradientPixels[state] = new Uint8ClampedArray(1024));
        var color = [
            0,
            0,
            0,
            0
        ];
        var off = 0;
        for(var i = 0; i < 256; i++){
            colorFunc[state](i / 255, true, color);
            pixelsSingleState[off++] = color[0];
            pixelsSingleState[off++] = color[1];
            pixelsSingleState[off++] = color[2];
            pixelsSingleState[off++] = color[3];
        }
        return pixelsSingleState;
    };
    return HeatmapLayer;
}();
var $5b65f5163321be51$export$2e2bcd8739ae039 = $5b65f5163321be51$var$HeatmapLayer;








function $0c775e96c876c163$var$getIsInPiecewiseRange(dataExtent, pieceList, selected) {
    var dataSpan = dataExtent[1] - dataExtent[0];
    pieceList = $43e0a445ed6711da$export$871de8747c9eaa88(pieceList, function(piece) {
        return {
            interval: [
                (piece.interval[0] - dataExtent[0]) / dataSpan,
                (piece.interval[1] - dataExtent[0]) / dataSpan
            ]
        };
    });
    var len = pieceList.length;
    var lastIndex = 0;
    return function(val) {
        var i;
        // Try to find in the location of the last found
        for(i = lastIndex; i < len; i++){
            var interval = pieceList[i].interval;
            if (interval[0] <= val && val <= interval[1]) {
                lastIndex = i;
                break;
            }
        }
        if (i === len) // Not found, back interation
        for(i = lastIndex - 1; i >= 0; i--){
            var interval = pieceList[i].interval;
            if (interval[0] <= val && val <= interval[1]) {
                lastIndex = i;
                break;
            }
        }
        return i >= 0 && i < len && selected[i];
    };
}
function $0c775e96c876c163$var$getIsInContinuousRange(dataExtent, range) {
    var dataSpan = dataExtent[1] - dataExtent[0];
    range = [
        (range[0] - dataExtent[0]) / dataSpan,
        (range[1] - dataExtent[0]) / dataSpan
    ];
    return function(val) {
        return val >= range[0] && val <= range[1];
    };
}
var $0c775e96c876c163$var$HeatmapView = /** @class */ function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(HeatmapView, _super);
    function HeatmapView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = HeatmapView.type;
        return _this;
    }
    HeatmapView.prototype.render = function(seriesModel, ecModel, api) {
        var visualMapOfThisSeries;
        ecModel.eachComponent("visualMap", function(visualMap) {
            visualMap.eachTargetSeries(function(targetSeries) {
                if (targetSeries === seriesModel) visualMapOfThisSeries = visualMap;
            });
        });
        // Clear previously rendered progressive elements.
        this._progressiveEls = null;
        this.group.removeAll();
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys.type === "cartesian2d" || coordSys.type === "calendar" || coordSys.type === "matrix") this._renderOnGridLike(seriesModel, api, 0, seriesModel.getData().count());
        else if ((0, $8b0e69611399196e$export$d3269a273c05cc72)(coordSys)) this._renderOnGeo(coordSys, seriesModel, visualMapOfThisSeries, api);
    };
    HeatmapView.prototype.incrementalPrepareRender = function(seriesModel, ecModel, api) {
        this.group.removeAll();
    };
    HeatmapView.prototype.incrementalRender = function(params, seriesModel, ecModel, api) {
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys) {
            // geo does not support incremental rendering?
            if ((0, $8b0e69611399196e$export$d3269a273c05cc72)(coordSys)) this.render(seriesModel, ecModel, api);
            else {
                this._progressiveEls = [];
                this._renderOnGridLike(seriesModel, api, params.start, params.end, true);
            }
        }
    };
    HeatmapView.prototype.eachRendered = function(cb) {
        $6552edac5ca572b1$export$3e564442729bf048(this._progressiveEls || this.group, cb);
    };
    HeatmapView.prototype._renderOnGridLike = function(seriesModel, api, start, end, useIncremental) {
        var coordSys = seriesModel.coordinateSystem;
        var isCartesian2d = (0, $8b0e69611399196e$export$8567506e6336616)(coordSys, "cartesian2d");
        var isMatrix = (0, $8b0e69611399196e$export$8567506e6336616)(coordSys, "matrix");
        var width;
        var height;
        var xAxisExtent;
        var yAxisExtent;
        if (isCartesian2d) {
            var xAxis = coordSys.getAxis("x");
            var yAxis = coordSys.getAxis("y");
            // add 0.5px to avoid the gaps
            width = (0, $8c5e7e1639db3579$export$141021262b29d96e)(xAxis).w + .5;
            height = (0, $8c5e7e1639db3579$export$141021262b29d96e)(yAxis).w + .5;
            xAxisExtent = xAxis.scale.getExtent();
            yAxisExtent = yAxis.scale.getExtent();
        }
        var group = this.group;
        var data = seriesModel.getData();
        var emphasisStyle = seriesModel.getModel([
            "emphasis",
            "itemStyle"
        ]).getItemStyle();
        var blurStyle = seriesModel.getModel([
            "blur",
            "itemStyle"
        ]).getItemStyle();
        var selectStyle = seriesModel.getModel([
            "select",
            "itemStyle"
        ]).getItemStyle();
        var borderRadius = seriesModel.get([
            "itemStyle",
            "borderRadius"
        ]);
        var labelStatesModels = (0, $6556fe1ed9fb479d$export$9739a32674be5893)(seriesModel);
        var emphasisModel = seriesModel.getModel("emphasis");
        var focus = emphasisModel.get("focus");
        var blurScope = emphasisModel.get("blurScope");
        var emphasisDisabled = emphasisModel.get("disabled");
        var dataDims = isCartesian2d || isMatrix ? [
            data.mapDimension("x"),
            data.mapDimension("y"),
            data.mapDimension("value")
        ] : [
            data.mapDimension("time"),
            data.mapDimension("value")
        ];
        for(var idx = start; idx < end; idx++){
            var rect = void 0;
            var style = data.getItemVisual(idx, "style");
            if (isCartesian2d) {
                var dataDimX = data.get(dataDims[0], idx);
                var dataDimY = data.get(dataDims[1], idx);
                // Ignore empty data and out of extent data
                if (isNaN(data.get(dataDims[2], idx)) || isNaN(dataDimX) || isNaN(dataDimY) || dataDimX < xAxisExtent[0] || dataDimX > xAxisExtent[1] || dataDimY < yAxisExtent[0] || dataDimY > yAxisExtent[1]) continue;
                var point = coordSys.dataToPoint([
                    dataDimX,
                    dataDimY
                ]);
                rect = new $42ed508a93973e78$export$2e2bcd8739ae039({
                    shape: {
                        x: point[0] - width / 2,
                        y: point[1] - height / 2,
                        width: width,
                        height: height
                    },
                    style: style
                });
            } else if (isMatrix) {
                var shape = coordSys.dataToLayout([
                    data.get(dataDims[0], idx),
                    data.get(dataDims[1], idx)
                ]).rect;
                if ($43e0a445ed6711da$export$7d667b9a0c48c975(shape.x)) continue;
                rect = new $42ed508a93973e78$export$2e2bcd8739ae039({
                    z2: 1,
                    shape: shape,
                    style: style
                });
            } else {
                // Calendar
                // Ignore empty data
                if (isNaN(data.get(dataDims[1], idx))) continue;
                var layout = coordSys.dataToLayout([
                    data.get(dataDims[0], idx)
                ]);
                var shape = layout.contentRect || layout.rect;
                if ($43e0a445ed6711da$export$7d667b9a0c48c975(shape.x) || $43e0a445ed6711da$export$7d667b9a0c48c975(shape.y)) continue;
                rect = new $42ed508a93973e78$export$2e2bcd8739ae039({
                    z2: 1,
                    shape: shape,
                    style: style
                });
            }
            // Optimization for large dataset
            if (data.hasItemOption) {
                var itemModel = data.getItemModel(idx);
                var emphasisModel_1 = itemModel.getModel("emphasis");
                emphasisStyle = emphasisModel_1.getModel("itemStyle").getItemStyle();
                blurStyle = itemModel.getModel([
                    "blur",
                    "itemStyle"
                ]).getItemStyle();
                selectStyle = itemModel.getModel([
                    "select",
                    "itemStyle"
                ]).getItemStyle();
                // Each item value struct in the data would be firstly
                // {
                //     itemStyle: { borderRadius: [30, 30] },
                //     value: [2022, 02, 22]
                // }
                borderRadius = itemModel.get([
                    "itemStyle",
                    "borderRadius"
                ]);
                focus = emphasisModel_1.get("focus");
                blurScope = emphasisModel_1.get("blurScope");
                emphasisDisabled = emphasisModel_1.get("disabled");
                labelStatesModels = (0, $6556fe1ed9fb479d$export$9739a32674be5893)(itemModel);
            }
            rect.shape.r = borderRadius;
            var rawValue = seriesModel.getRawValue(idx);
            var defaultText = "-";
            if (rawValue && rawValue[2] != null) defaultText = rawValue[2] + "";
            (0, $6556fe1ed9fb479d$export$9a13992917966657)(rect, labelStatesModels, {
                labelFetcher: seriesModel,
                labelDataIndex: idx,
                defaultOpacity: style.opacity,
                defaultText: defaultText
            });
            rect.ensureState("emphasis").style = emphasisStyle;
            rect.ensureState("blur").style = blurStyle;
            rect.ensureState("select").style = selectStyle;
            (0, $fffc76734a157b4c$export$e51187539ff11209)(rect, focus, blurScope, emphasisDisabled);
            rect.incremental = (0, $87f4a59ac66e0ee6$export$4496820b7f3d3e98)(seriesModel, useIncremental);
            // PENDING
            if (useIncremental) // Rect must use hover layer if it's incremental.
            rect.states.emphasis.hoverLayer = $6552edac5ca572b1$export$2ed770cec6ef78e8;
            group.add(rect);
            data.setItemGraphicEl(idx, rect);
            if (this._progressiveEls) this._progressiveEls.push(rect);
        }
    };
    HeatmapView.prototype._renderOnGeo = function(geo, seriesModel, visualMapModel, api) {
        var inRangeVisuals = visualMapModel.targetVisuals.inRange;
        var outOfRangeVisuals = visualMapModel.targetVisuals.outOfRange;
        // if (!visualMapping) {
        //     throw new Error('Data range must have color visuals');
        // }
        var data = seriesModel.getData();
        var hmLayer = this._hmLayer || this._hmLayer || new (0, $5b65f5163321be51$export$2e2bcd8739ae039)();
        hmLayer.blurSize = seriesModel.get("blurSize");
        hmLayer.pointSize = seriesModel.get("pointSize");
        hmLayer.minOpacity = seriesModel.get("minOpacity");
        hmLayer.maxOpacity = seriesModel.get("maxOpacity");
        var rect = geo.getViewRect().clone();
        var roamTransform = geo.getRoamTransform();
        rect.applyTransform(roamTransform);
        // Clamp on viewport
        var x = Math.max(rect.x, 0);
        var y = Math.max(rect.y, 0);
        var x2 = Math.min(rect.width + rect.x, api.getWidth());
        var y2 = Math.min(rect.height + rect.y, api.getHeight());
        var width = x2 - x;
        var height = y2 - y;
        var dims = [
            data.mapDimension("lng"),
            data.mapDimension("lat"),
            data.mapDimension("value")
        ];
        var points = data.mapArray(dims, function(lng, lat, value) {
            var pt = geo.dataToPoint([
                lng,
                lat
            ]);
            pt[0] -= x;
            pt[1] -= y;
            pt.push(value);
            return pt;
        });
        var dataExtent = visualMapModel.getExtent();
        var isInRange = visualMapModel.type === "visualMap.continuous" ? $0c775e96c876c163$var$getIsInContinuousRange(dataExtent, visualMapModel.option.range) : $0c775e96c876c163$var$getIsInPiecewiseRange(dataExtent, visualMapModel.getPieceList(), visualMapModel.option.selected);
        hmLayer.update(points, width, height, inRangeVisuals.color.getNormalizer(), {
            inRange: inRangeVisuals.color.getColorMapper(),
            outOfRange: outOfRangeVisuals.color.getColorMapper()
        }, isInRange);
        var img = new $d3b0315ae8e8e298$export$2e2bcd8739ae039({
            style: {
                width: width,
                height: height,
                x: x,
                y: y,
                image: hmLayer.canvas
            },
            silent: true
        });
        this.group.add(img);
    };
    HeatmapView.type = "heatmap";
    return HeatmapView;
}((0, $9bc1fbefe72d5b26$export$2e2bcd8739ae039));
var $0c775e96c876c163$export$2e2bcd8739ae039 = $0c775e96c876c163$var$HeatmapView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $f92541005ccaad00$var$HeatmapSeriesModel = /** @class */ function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(HeatmapSeriesModel, _super);
    function HeatmapSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = HeatmapSeriesModel.type;
        return _this;
    }
    HeatmapSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $5d58e30ee7cf15bf$export$2e2bcd8739ae039)(null, this, {
            generateCoord: "value"
        });
    };
    HeatmapSeriesModel.prototype.preventIncremental = function() {
        var coordSysCreator = (0, $a30c5e122eaab0a1$export$2e2bcd8739ae039).get(this.get("coordinateSystem"));
        if (coordSysCreator && coordSysCreator.dimensions) return coordSysCreator.dimensions[0] === "lng" && coordSysCreator.dimensions[1] === "lat";
    };
    HeatmapSeriesModel.type = "series.heatmap";
    HeatmapSeriesModel.dependencies = [
        "grid",
        "geo",
        "calendar",
        "matrix"
    ];
    HeatmapSeriesModel.defaultOption = {
        coordinateSystem: "cartesian2d",
        // zlevel: 0,
        z: 2,
        // Cartesian coordinate system
        // xAxisIndex: 0,
        // yAxisIndex: 0,
        // Geo coordinate system
        geoIndex: 0,
        blurSize: 30,
        pointSize: 20,
        maxOpacity: 1,
        minOpacity: 0,
        select: {
            itemStyle: {
                borderColor: (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.primary
            }
        }
    };
    return HeatmapSeriesModel;
}((0, $39002e2f499d7a2f$export$2e2bcd8739ae039));
var $f92541005ccaad00$export$2e2bcd8739ae039 = $f92541005ccaad00$var$HeatmapSeriesModel;


function $6d301525e3baeb85$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $0c775e96c876c163$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $f92541005ccaad00$export$2e2bcd8739ae039));
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $01837d90925fb939$export$57b4bb4ff2a0950c = {
    left: 0,
    right: 0,
    top: 0,
    bottom: 0
};
var $01837d90925fb939$export$e78e6bf4dcc3e485 = [
    "25%",
    "25%"
];
var $01837d90925fb939$export$d0b4e8fdb7a13c60 = "cartesian2d";
var $01837d90925fb939$var$GridModel = /** @class */ function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(GridModel, _super);
    function GridModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GridModel.prototype.mergeDefaultAndTheme = function(option, ecModel) {
        var outerBoundsCp = (0, $826bc4094efae72b$export$4b0d20af19c9875e)(option.outerBounds);
        _super.prototype.mergeDefaultAndTheme.apply(this, arguments);
        if (outerBoundsCp && option.outerBounds) (0, $826bc4094efae72b$export$1754cb91f16ca028)(option.outerBounds, outerBoundsCp);
    };
    GridModel.prototype.mergeOption = function(newOption, ecModel) {
        _super.prototype.mergeOption.apply(this, arguments);
        if (this.option.outerBounds && newOption.outerBounds) (0, $826bc4094efae72b$export$1754cb91f16ca028)(this.option.outerBounds, newOption.outerBounds);
    };
    GridModel.type = "grid";
    GridModel.dependencies = [
        "xAxis",
        "yAxis"
    ];
    GridModel.layoutMode = "box";
    GridModel.defaultOption = {
        show: false,
        // zlevel: 0,
        z: 0,
        left: "15%",
        top: 65,
        right: "10%",
        bottom: 80,
        // If grid size contain label
        containLabel: false,
        outerBoundsMode: "auto",
        outerBounds: $01837d90925fb939$export$57b4bb4ff2a0950c,
        outerBoundsContain: "all",
        outerBoundsClampWidth: $01837d90925fb939$export$e78e6bf4dcc3e485[0],
        outerBoundsClampHeight: $01837d90925fb939$export$e78e6bf4dcc3e485[1],
        // width: {totalWidth} - left - right,
        // height: {totalHeight} - top - bottom,
        backgroundColor: (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.transparent,
        borderWidth: 1,
        borderColor: (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.neutral30
    };
    return GridModel;
}((0, $4a9041b12b787d1b$export$2e2bcd8739ae039));
var $01837d90925fb939$export$2e2bcd8739ae039 = $01837d90925fb939$var$GridModel;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $dd4d3cff2e5a37aa$export$483dc37e6ad83a3c = /** @class */ function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(CartesianAxisModel, _super);
    function CartesianAxisModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CartesianAxisModel.prototype.getCoordSysModel = function() {
        return this.getReferringComponents("grid", (0, $87f4a59ac66e0ee6$export$f076738ec84e693c)).models[0];
    };
    CartesianAxisModel.type = "cartesian2dAxis";
    return CartesianAxisModel;
}((0, $4a9041b12b787d1b$export$2e2bcd8739ae039));
$43e0a445ed6711da$export$e36fc9d62a853069($dd4d3cff2e5a37aa$export$483dc37e6ad83a3c, (0, $f8933c96542855fa$export$5c54b224726edb5a));
var $dd4d3cff2e5a37aa$export$2e2bcd8739ae039 = $dd4d3cff2e5a37aa$export$483dc37e6ad83a3c;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $8b492629a1151d51$var$defaultOption = {
    show: true,
    // zlevel: 0,
    z: 0,
    // Inverse the axis.
    inverse: false,
    // Axis name displayed.
    name: "",
    // 'start' | 'middle' | 'end'
    nameLocation: "end",
    // By degree. By default auto rotate by nameLocation.
    nameRotate: null,
    nameTruncate: {
        maxWidth: null,
        ellipsis: "...",
        placeholder: "."
    },
    // Use global text style by default.
    nameTextStyle: {
    },
    // The gap between axisName and axisLine.
    nameGap: 15,
    // Default `false` to support tooltip.
    silent: false,
    // Default `false` to avoid legacy user event listener fail.
    triggerEvent: false,
    tooltip: {
        show: false
    },
    axisPointer: {},
    axisLine: {
        show: true,
        onZero: "auto",
        onZeroAxisIndex: null,
        lineStyle: {
            color: (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.axisLine,
            width: 1,
            type: "solid"
        },
        // The arrow at both ends the the axis.
        symbol: [
            "none",
            "none"
        ],
        symbolSize: [
            10,
            15
        ],
        breakLine: true
    },
    axisTick: {
        show: true,
        // Whether axisTick is inside the grid or outside the grid.
        inside: false,
        // The length of axisTick.
        length: 5,
        lineStyle: {
            width: 1
        }
    },
    axisLabel: {
        show: true,
        // Whether axisLabel is inside the grid or outside the grid.
        inside: false,
        rotate: 0,
        // true | false | null/undefined (auto)
        showMinLabel: null,
        // true | false | null/undefined (auto)
        showMaxLabel: null,
        margin: 8,
        // formatter: null,
        fontSize: 12,
        color: (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.axisLabel,
        // In scenarios like axis labels, when labels text's progression direction matches the label
        // layout direction (e.g., when all letters are in a single line), extra start/end margin is
        // needed to prevent the text from appearing visually joined. In the other case, when lables
        // are stacked (e.g., having rotation or horizontal labels on yAxis), the layout needs to be
        // compact, so NO extra top/bottom margin should be applied.
        textMargin: [
            0,
            3
        ]
    },
    splitLine: {
        show: true,
        showMinLine: true,
        showMaxLine: true,
        lineStyle: {
            color: (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.axisSplitLine,
            width: 1,
            type: "solid"
        }
    },
    splitArea: {
        show: false,
        areaStyle: {
            color: [
                (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.backgroundTint,
                (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.backgroundTransparent
            ]
        }
    },
    breakArea: {
        show: true,
        itemStyle: {
            color: (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.neutral00,
            // Break border color should be darker than the splitLine
            // because it has opacity and should be more prominent
            borderColor: (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.border,
            borderWidth: 1,
            borderType: [
                3,
                3
            ],
            opacity: 0.6
        },
        zigzagAmplitude: 4,
        zigzagMinSpan: 4,
        zigzagMaxSpan: 20,
        zigzagZ: 100,
        expandOnClick: true
    },
    breakLabelLayout: {
        moveOverlap: "auto"
    }
};
var $8b492629a1151d51$var$categoryAxis = $43e0a445ed6711da$export$4950aa0f605343fb({
    // The gap at both ends of the axis. For categoryAxis, boolean.
    boundaryGap: true,
    // Set false to faster category collection.
    deduplication: null,
    jitter: 0,
    jitterOverlap: true,
    jitterMargin: 2,
    // splitArea: {
    // show: false
    // },
    splitLine: {
        show: false
    },
    axisTick: {
        // If tick is align with label when boundaryGap is true
        alignWithLabel: false,
        interval: "auto",
        show: "auto"
    },
    axisLabel: {
        interval: "auto"
    }
}, $8b492629a1151d51$var$defaultOption);
var $8b492629a1151d51$var$valueAxis = $43e0a445ed6711da$export$4950aa0f605343fb({
    boundaryGap: [
        0,
        0
    ],
    axisLine: {
        // Not shown when other axis is categoryAxis in cartesian
        show: "auto"
    },
    axisTick: {
        // Not shown when other axis is categoryAxis in cartesian
        show: "auto"
    },
    // TODO
    // min/max: [30, datamin, 60] or [20, datamin] or [datamin, 60]
    splitNumber: 5,
    minorTick: {
        // Minor tick, not available for cateogry axis.
        show: false,
        // Split number of minor ticks. The value should be in range of (0, 100)
        splitNumber: 5,
        // Length of minor tick
        length: 3,
        // Line style
        lineStyle: {
        }
    },
    minorSplitLine: {
        show: false,
        lineStyle: {
            color: (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.axisMinorSplitLine,
            width: 1
        }
    }
}, $8b492629a1151d51$var$defaultOption);
var $8b492629a1151d51$var$timeAxis = $43e0a445ed6711da$export$4950aa0f605343fb({
    splitNumber: 6,
    axisLabel: {
        // The default value of TimeScale is determined in `AxisBuilder`
        // showMinLabel: false,
        // showMaxLabel: false,
        rich: {
            primary: {
                fontWeight: "bold"
            }
        }
    },
    splitLine: {
        show: false
    }
}, $8b492629a1151d51$var$valueAxis);
var $8b492629a1151d51$var$logAxis = $43e0a445ed6711da$export$ebe90cb607ad99e({
    logBase: 10
}, $8b492629a1151d51$var$valueAxis);
var $8b492629a1151d51$export$2e2bcd8739ae039 = {
    category: $8b492629a1151d51$var$categoryAxis,
    value: $8b492629a1151d51$var$valueAxis,
    time: $8b492629a1151d51$var$timeAxis,
    log: $8b492629a1151d51$var$logAxis
};






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $6ef64eccf67efcc6$var$_impl = null;
function $6ef64eccf67efcc6$export$f5ec8c7ef7a59f4c(impl) {
    if (!$6ef64eccf67efcc6$var$_impl) $6ef64eccf67efcc6$var$_impl = impl;
}
function $6ef64eccf67efcc6$export$c1d9b2cc33e7e5e() {
    return $6ef64eccf67efcc6$var$_impl;
}


function $0aad7c25257f2936$export$2e2bcd8739ae039(registers, axisName, BaseAxisModelClass, extraDefaultOption) {
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)((0, $ebb9b7ebf9a2ae2e$export$2e0057d176d6f690), function(v, axisType) {
        var defaultOption = (0, $43e0a445ed6711da$export$4950aa0f605343fb)((0, $43e0a445ed6711da$export$4950aa0f605343fb)({}, (0, $8b492629a1151d51$export$2e2bcd8739ae039)[axisType], true), extraDefaultOption, true);
        var AxisModel = /** @class */ function(_super) {
            (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(AxisModel, _super);
            function AxisModel() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.type = axisName + "Axis." + axisType;
                return _this;
            }
            AxisModel.prototype.mergeDefaultAndTheme = function(option, ecModel) {
                var layoutMode = (0, $826bc4094efae72b$export$3968a28a7cbd6063)(this);
                var inputPositionParams = layoutMode ? (0, $826bc4094efae72b$export$4b0d20af19c9875e)(option) : {};
                var themeModel = ecModel.getTheme();
                (0, $43e0a445ed6711da$export$4950aa0f605343fb)(option, themeModel.get(axisType + "Axis"));
                (0, $43e0a445ed6711da$export$4950aa0f605343fb)(option, this.getDefaultOption());
                option.type = $0aad7c25257f2936$var$getAxisType(option);
                if (layoutMode) (0, $826bc4094efae72b$export$1754cb91f16ca028)(option, inputPositionParams, layoutMode);
            };
            AxisModel.prototype.optionUpdated = function() {
                var thisOption = this.option;
                if (thisOption.type === "category") this.__ordinalMeta = (0, $4f43f0f1fd3f127f$export$2e2bcd8739ae039).createByAxisModel(this);
            };
            /**
       * Should not be called before all of 'getInitailData' finished.
       * Because categories are collected during initializing data.
       */ AxisModel.prototype.getCategories = function(rawData) {
                var option = this.option;
                // FIXME
                // warning if called before all of 'getInitailData' finished.
                if (option.type === "category") {
                    if (rawData) // NOTICE: return the raw data even if not existing; never use a fallback like `[]`;
                    // Its existence matters in some legacy cases.
                    return option.data;
                    return this.__ordinalMeta.categories;
                }
            };
            AxisModel.prototype.getOrdinalMeta = function() {
                return this.__ordinalMeta;
            };
            AxisModel.prototype.updateAxisBreaks = function(payload) {
                var axisBreakHelper = (0, $6ef64eccf67efcc6$export$c1d9b2cc33e7e5e)();
                return axisBreakHelper ? axisBreakHelper.updateModelAxisBreak(this, payload) : {
                    breaks: []
                };
            };
            AxisModel.type = axisName + "Axis." + axisType;
            AxisModel.defaultOption = defaultOption;
            return AxisModel;
        }(BaseAxisModelClass);
        registers.registerComponentModel(AxisModel);
    });
    registers.registerSubTypeDefaulter(axisName + "Axis", $0aad7c25257f2936$var$getAxisType);
}
function $0aad7c25257f2936$var$getAxisType(option) {
    // Default axis with data is category axis
    return option.type || (option.data ? "category" : "value");
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Grid is a region which contains at most 4 cartesian systems
 *
 * TODO Default cartesian
 */ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $e4699a938d3f32d5$var$Cartesian = /** @class */ function() {
    function Cartesian(name) {
        this.type = "cartesian";
        this._dimList = [];
        this._axes = {};
        this.name = name || "";
    }
    Cartesian.prototype.getAxis = function(dim) {
        return this._axes[dim];
    };
    Cartesian.prototype.getAxes = function() {
        return $43e0a445ed6711da$export$871de8747c9eaa88(this._dimList, function(dim) {
            return this._axes[dim];
        }, this);
    };
    Cartesian.prototype.getAxesByScale = function(scaleType) {
        scaleType = scaleType.toLowerCase();
        return $43e0a445ed6711da$export$3dea766d36a8935f(this.getAxes(), function(axis) {
            return axis.scale.type === scaleType;
        });
    };
    Cartesian.prototype.addAxis = function(axis) {
        var dim = axis.dim;
        this._axes[dim] = axis;
        this._dimList.push(dim);
    };
    return Cartesian;
}();
var $e4699a938d3f32d5$export$2e2bcd8739ae039 = $e4699a938d3f32d5$var$Cartesian;







var $20b308fcf70b98d9$export$988a008d2b9120f4 = [
    "x",
    "y"
];
function $20b308fcf70b98d9$var$canCalculateAffineTransform(scale) {
    // Only supported on linear space.
    return (scale.type === "interval" || scale.type === "time") && !(0, $d760dd937396b887$export$fec008222a1db2dc)(scale);
}
var $20b308fcf70b98d9$var$Cartesian2D = /** @class */ function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(Cartesian2D, _super);
    function Cartesian2D() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = (0, $01837d90925fb939$export$d0b4e8fdb7a13c60);
        _this.dimensions = $20b308fcf70b98d9$export$988a008d2b9120f4;
        return _this;
    }
    /**
   * Calculate an affine transform matrix if two axes are time or value.
   * It's mainly for accelartion on the large time series data.
   */ Cartesian2D.prototype.calcAffineTransform = function() {
        this._transform = this._invTransform = null;
        var xAxisScale = this.getAxis("x").scale;
        var yAxisScale = this.getAxis("y").scale;
        if (!$20b308fcf70b98d9$var$canCalculateAffineTransform(xAxisScale) || !$20b308fcf70b98d9$var$canCalculateAffineTransform(yAxisScale)) return;
        var xScaleExtent = (0, $3123530578a35744$export$e182c528b7826102)(xAxisScale, null);
        var yScaleExtent = (0, $3123530578a35744$export$e182c528b7826102)(yAxisScale, null);
        var start = this.dataToPoint([
            xScaleExtent[0],
            yScaleExtent[0]
        ]);
        var end = this.dataToPoint([
            xScaleExtent[1],
            yScaleExtent[1]
        ]);
        var xScaleSpan = xScaleExtent[1] - xScaleExtent[0];
        var yScaleSpan = yScaleExtent[1] - yScaleExtent[0];
        if (!xScaleSpan || !yScaleSpan) return;
        // Accelerate data to point calculation on the special large time series data.
        var scaleX = (end[0] - start[0]) / xScaleSpan;
        var scaleY = (end[1] - start[1]) / yScaleSpan;
        var translateX = start[0] - xScaleExtent[0] * scaleX;
        var translateY = start[1] - yScaleExtent[0] * scaleY;
        var m = this._transform = [
            scaleX,
            0,
            0,
            scaleY,
            translateX,
            translateY
        ];
        this._invTransform = (0, $87ac8de5537d9a34$export$6897c284b6f9f4dc)([], m);
    };
    /**
   * Base axis will be used on stacking and series such as 'bar', 'pictorialBar', etc.
   */ Cartesian2D.prototype.getBaseAxis = function() {
        // FIXME:
        //  (1) We should allow series (e.g., bar) to specify a base axis when
        //      both axes are type "value", rather than force to xAxis or angleAxis.
        //      NOTE: At present BoxplotSeries has its own overide `getBaseAxis`.
        //      `CoordinateSystem['getBaseAxis']` probably should not exist, since it
        //      may introduce inconsistency with `Series['getBaseAxis']`.
        //  (2) "base axis" info is required in "createSeriesData" stage for "stack",
        //      (see `dataStackHelper.ts` for details). Currently it is hard coded there.
        return this.getAxesByScale("ordinal")[0] || this.getAxesByScale("time")[0] || this.getAxis("x");
    };
    Cartesian2D.prototype.containPoint = function(point) {
        var axisX = this.getAxis("x");
        var axisY = this.getAxis("y");
        return axisX.contain(axisX.toLocalCoord(point[0])) && axisY.contain(axisY.toLocalCoord(point[1]));
    };
    Cartesian2D.prototype.containData = function(data) {
        return this.getAxis("x").containData(data[0]) && this.getAxis("y").containData(data[1]);
    };
    Cartesian2D.prototype.containZone = function(data1, data2) {
        var zoneDiag1 = this.dataToPoint(data1);
        var zoneDiag2 = this.dataToPoint(data2);
        var area = this.getArea();
        var zone = new (0, $c437f598d9c9ee16$export$2e2bcd8739ae039)(zoneDiag1[0], zoneDiag1[1], zoneDiag2[0] - zoneDiag1[0], zoneDiag2[1] - zoneDiag1[1]);
        return area.intersect(zone);
    };
    Cartesian2D.prototype.dataToPoint = function(data, clamp, out) {
        out = out || [];
        var xVal = data[0];
        var yVal = data[1];
        // [CAVEAT]: Do not add time consuming operation within and before fast path.
        // Fast path.
        if (this._transform && xVal != null && isFinite(xVal) && yVal != null && isFinite(yVal)) return (0, $ee491d8f32bd01ff$export$9f9dcb98c894b623)(out, data, this._transform);
        var xAxis = this.getAxis("x");
        var yAxis = this.getAxis("y");
        out[0] = xAxis.toGlobalCoord(xAxis.dataToCoord(xVal, clamp));
        out[1] = yAxis.toGlobalCoord(yAxis.dataToCoord(yVal, clamp));
        return out;
    };
    Cartesian2D.prototype.clampData = function(data, out) {
        var xScale = this.getAxis("x").scale;
        var yScale = this.getAxis("y").scale;
        var xAxisExtent = xScale.getExtent();
        var yAxisExtent = yScale.getExtent();
        var x = xScale.parse(data[0]);
        var y = yScale.parse(data[1]);
        out = out || [];
        out[0] = Math.min(Math.max(Math.min(xAxisExtent[0], xAxisExtent[1]), x), Math.max(xAxisExtent[0], xAxisExtent[1]));
        out[1] = Math.min(Math.max(Math.min(yAxisExtent[0], yAxisExtent[1]), y), Math.max(yAxisExtent[0], yAxisExtent[1]));
        return out;
    };
    Cartesian2D.prototype.pointToData = function(point, clamp, out) {
        out = out || [];
        if (this._invTransform) return (0, $ee491d8f32bd01ff$export$9f9dcb98c894b623)(out, point, this._invTransform);
        var xAxis = this.getAxis("x");
        var yAxis = this.getAxis("y");
        out[0] = xAxis.coordToData(xAxis.toLocalCoord(point[0]), clamp);
        out[1] = yAxis.coordToData(yAxis.toLocalCoord(point[1]), clamp);
        return out;
    };
    Cartesian2D.prototype.getOtherAxis = function(axis) {
        return this.getAxis(axis.dim === "x" ? "y" : "x");
    };
    /**
   * Get rect area of cartesian.
   * Area will have a contain function to determine if a point is in the coordinate system.
   */ Cartesian2D.prototype.getArea = function(tolerance) {
        tolerance = tolerance || 0;
        var xExtent = this.getAxis("x").getGlobalExtent();
        var yExtent = this.getAxis("y").getGlobalExtent();
        var x = Math.min(xExtent[0], xExtent[1]) - tolerance;
        var y = Math.min(yExtent[0], yExtent[1]) - tolerance;
        var width = Math.max(xExtent[0], xExtent[1]) - x + tolerance;
        var height = Math.max(yExtent[0], yExtent[1]) - y + tolerance;
        return new (0, $c437f598d9c9ee16$export$2e2bcd8739ae039)(x, y, width, height);
    };
    return Cartesian2D;
}((0, $e4699a938d3f32d5$export$2e2bcd8739ae039));
var $20b308fcf70b98d9$export$2e2bcd8739ae039 = $20b308fcf70b98d9$var$Cartesian2D;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $78e48a0d5d4f5f3e$var$Axis2D = /** @class */ function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(Axis2D, _super);
    function Axis2D(dim, scale, coordExtent, axisType, position) {
        var _this = _super.call(this, dim, scale, coordExtent) || this;
        /**
     * Index of axis, can be used as key
     * Injected outside.
     */ _this.index = 0;
        _this.type = axisType || "value";
        _this.position = position || "bottom";
        return _this;
    }
    Axis2D.prototype.isHorizontal = function() {
        var position = this.position;
        return position === "top" || position === "bottom";
    };
    /**
   * Each item cooresponds to this.getExtent(), which
   * means globalExtent[0] may greater than globalExtent[1],
   * unless `asc` is input.
   *
   * @param {boolean} [asc]
   * @return {Array.<number>}
   */ Axis2D.prototype.getGlobalExtent = function(asc) {
        var ret = this.getExtent();
        ret[0] = this.toGlobalCoord(ret[0]);
        ret[1] = this.toGlobalCoord(ret[1]);
        asc && ret[0] > ret[1] && ret.reverse();
        return ret;
    };
    Axis2D.prototype.pointToData = function(point, clamp) {
        return this.coordToData(this.toLocalCoord(point[this.dim === "x" ? 0 : 1]), clamp);
    };
    /**
   * Set ordinalSortInfo
   * @param info new OrdinalSortInfo
   */ Axis2D.prototype.setCategorySortInfo = function(info) {
        if (this.type !== "category") return false;
        this.model.option.categorySortInfo = info;
        this.scale.setSortInfo(info);
    };
    return Axis2D;
}((0, $17d11437fadc71c2$export$2e2bcd8739ae039));
var $78e48a0d5d4f5f3e$export$2e2bcd8739ae039 = $78e48a0d5d4f5f3e$var$Axis2D;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 












/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $1ee6234a66398482$export$12319e2083cd71ce = "expandAxisBreak";
var $1ee6234a66398482$export$8ba710d11f5d9b28 = "collapseAxisBreak";
var $1ee6234a66398482$export$cfaa507333440c5e = "toggleAxisBreak";
var $1ee6234a66398482$var$AXIS_BREAK_CHANGED_EVENT_TYPE = "axisbreakchanged";
var $1ee6234a66398482$var$expandAxisBreakActionInfo = {
    type: $1ee6234a66398482$export$12319e2083cd71ce,
    event: $1ee6234a66398482$var$AXIS_BREAK_CHANGED_EVENT_TYPE,
    update: "update",
    refineEvent: $1ee6234a66398482$var$refineAxisBreakChangeEvent
};
var $1ee6234a66398482$var$collapseAxisBreakActionInfo = {
    type: $1ee6234a66398482$export$8ba710d11f5d9b28,
    event: $1ee6234a66398482$var$AXIS_BREAK_CHANGED_EVENT_TYPE,
    update: "update",
    refineEvent: $1ee6234a66398482$var$refineAxisBreakChangeEvent
};
var $1ee6234a66398482$var$toggleAxisBreakActionInfo = {
    type: $1ee6234a66398482$export$cfaa507333440c5e,
    event: $1ee6234a66398482$var$AXIS_BREAK_CHANGED_EVENT_TYPE,
    update: "update",
    refineEvent: $1ee6234a66398482$var$refineAxisBreakChangeEvent
};
function $1ee6234a66398482$var$refineAxisBreakChangeEvent(actionResultBatch, payload, ecModel, api) {
    var breaks = [];
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)(actionResultBatch, function(actionResult) {
        breaks = breaks.concat(actionResult.eventBreaks);
    });
    return {
        eventContent: {
            breaks: breaks
        }
    };
}
function $1ee6234a66398482$export$408c24786cd729c6(registers) {
    registers.registerAction($1ee6234a66398482$var$expandAxisBreakActionInfo, actionHandler);
    registers.registerAction($1ee6234a66398482$var$collapseAxisBreakActionInfo, actionHandler);
    registers.registerAction($1ee6234a66398482$var$toggleAxisBreakActionInfo, actionHandler);
    function actionHandler(payload, ecModel) {
        var eventBreaks = [];
        var finderResult = (0, $87f4a59ac66e0ee6$export$95de80076abac814)(ecModel, payload);
        function dealUpdate(modelProp, indexProp) {
            (0, $43e0a445ed6711da$export$79b2f7037acddd43)(finderResult[modelProp], function(axisModel) {
                var result = axisModel.updateAxisBreaks(payload);
                (0, $43e0a445ed6711da$export$79b2f7037acddd43)(result.breaks, function(item) {
                    var _a;
                    eventBreaks.push((0, $43e0a445ed6711da$export$ebe90cb607ad99e)((_a = {}, _a[indexProp] = axisModel.componentIndex, _a), item));
                });
            });
        }
        dealUpdate("xAxisModels", "xAxisIndex");
        dealUpdate("yAxisModels", "yAxisIndex");
        dealUpdate("singleAxisModels", "singleAxisIndex");
        return {
            eventBreaks: eventBreaks
        };
    }
}








var $377a1d5467eb3e77$var$PI = Math.PI;
var $377a1d5467eb3e77$var$DEFAULT_CENTER_NAME_MARGIN_LEVELS = [
    [
        1,
        2,
        1,
        2
    ],
    [
        5,
        3,
        5,
        3
    ],
    [
        8,
        3,
        8,
        3
    ]
];
var $377a1d5467eb3e77$var$DEFAULT_ENDS_NAME_MARGIN_LEVELS = [
    [
        0,
        1,
        0,
        1
    ],
    [
        0,
        3,
        0,
        3
    ],
    [
        0,
        3,
        0,
        3
    ]
];
var $377a1d5467eb3e77$export$c392b818a26a879e = (0, $87f4a59ac66e0ee6$export$64df9f8d92ae083f)();
var $377a1d5467eb3e77$var$getTickInner = (0, $87f4a59ac66e0ee6$export$64df9f8d92ae083f)();
/**
 * A context shared by difference axisBuilder instances.
 * For cross-axes overlap resolving.
 *
 * Lifecycle constraint: should not over a pass of ec main process.
 *  If model is changed, the context must be disposed.
 *
 * @see AxisBuilderLocalContext
 */ var $377a1d5467eb3e77$export$f2e237206f7393f5 = /** @class */ function() {
    function AxisBuilderSharedContext(resolveAxisNameOverlap) {
        /**
     * [CAUTION] Do not modify this data structure outside this class.
     */ this.recordMap = {};
        this.resolveAxisNameOverlap = resolveAxisNameOverlap;
    }
    AxisBuilderSharedContext.prototype.ensureRecord = function(axisModel) {
        var dim = axisModel.axis.dim;
        var idx = axisModel.componentIndex;
        var recordMap = this.recordMap;
        var records = recordMap[dim] || (recordMap[dim] = []);
        return records[idx] || (records[idx] = {
            ready: {}
        });
    };
    return AxisBuilderSharedContext;
}();
/**
 * [CAUTION]
 *  1. The call of this function must be after axisLabel overlap handlings
 *     (such as `hideOverlap`, `fixMinMaxLabelShow`) and after transform calculating.
 *  2. Can be called multiple times and should be idempotent.
 */ function $377a1d5467eb3e77$var$resetOverlapRecordToShared(cfg, shared, axisModel, labelLayoutList) {
    var axis = axisModel.axis;
    var record = shared.ensureRecord(axisModel);
    var labelInfoList = [];
    var stOccupiedRect;
    var useStOccupiedRect = $377a1d5467eb3e77$var$hasAxisName(cfg.axisName) && (0, $3e6d0d29922ecf90$export$c06aa22293dea9d2)(cfg.nameLocation);
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)(labelLayoutList, function(layout) {
        var layoutInfo = (0, $c7004a764badae25$export$471916f4e89eb5da)(layout);
        if (!layoutInfo || layoutInfo.label.ignore) return;
        labelInfoList.push(layoutInfo);
        var transGroup = record.transGroup;
        if (useStOccupiedRect) {
            // Transform to "standard axis" for creating stOccupiedRect (the label rects union).
            transGroup.transform ? $87ac8de5537d9a34$export$6897c284b6f9f4dc($377a1d5467eb3e77$var$_stTransTmp, transGroup.transform) : $87ac8de5537d9a34$export$f0954fd7d5368655($377a1d5467eb3e77$var$_stTransTmp);
            if (layoutInfo.transform) $87ac8de5537d9a34$export$6e3a27864ab166fe($377a1d5467eb3e77$var$_stTransTmp, $377a1d5467eb3e77$var$_stTransTmp, layoutInfo.transform);
            (0, $c437f598d9c9ee16$export$2e2bcd8739ae039).copy($377a1d5467eb3e77$var$_stLabelRectTmp, layoutInfo.localRect);
            $377a1d5467eb3e77$var$_stLabelRectTmp.applyTransform($377a1d5467eb3e77$var$_stTransTmp);
            stOccupiedRect ? stOccupiedRect.union($377a1d5467eb3e77$var$_stLabelRectTmp) : (0, $c437f598d9c9ee16$export$2e2bcd8739ae039).copy(stOccupiedRect = new (0, $c437f598d9c9ee16$export$2e2bcd8739ae039)(0, 0, 0, 0), $377a1d5467eb3e77$var$_stLabelRectTmp);
        }
    });
    var sortByDim = Math.abs(record.dirVec.x) > 0.1 ? "x" : "y";
    var sortByValue = record.transGroup[sortByDim];
    labelInfoList.sort(function(info1, info2) {
        return Math.abs(info1.label[sortByDim] - sortByValue) - Math.abs(info2.label[sortByDim] - sortByValue);
    });
    if (useStOccupiedRect && stOccupiedRect) {
        var extent = axis.getExtent();
        var axisLineX = Math.min(extent[0], extent[1]);
        var axisLineWidth = Math.max(extent[0], extent[1]) - axisLineX;
        // If `nameLocation` is 'middle', enlarge axis labels boundingRect to axisLine to avoid bad
        //  case like that axis name is placed in the gap between axis labels and axis line.
        // If only one label exists, the entire band should be occupied for
        // visual consistency, so extent it to [0, canvas width].
        stOccupiedRect.union(new (0, $c437f598d9c9ee16$export$2e2bcd8739ae039)(axisLineX, 0, axisLineWidth, 1));
    }
    record.stOccupiedRect = stOccupiedRect;
    record.labelInfoList = labelInfoList;
}
var $377a1d5467eb3e77$var$_stTransTmp = $87ac8de5537d9a34$export$185802fd694ee1f5();
var $377a1d5467eb3e77$var$_stLabelRectTmp = new (0, $c437f598d9c9ee16$export$2e2bcd8739ae039)(0, 0, 0, 0);
var $377a1d5467eb3e77$export$7fcb8742f5816cae = function(cfg, ctx, axisModel, nameLayoutInfo, nameMoveDirVec, thisRecord) {
    if ((0, $3e6d0d29922ecf90$export$c06aa22293dea9d2)(cfg.nameLocation)) {
        var stOccupiedRect = thisRecord.stOccupiedRect;
        if (stOccupiedRect) $377a1d5467eb3e77$var$moveIfOverlap((0, $c7004a764badae25$export$bc37ae3f8412d105)({}, stOccupiedRect, thisRecord.transGroup.transform), nameLayoutInfo, nameMoveDirVec);
    } else $377a1d5467eb3e77$export$e033c6449cc6f6a1(thisRecord.labelInfoList, thisRecord.dirVec, nameLayoutInfo, nameMoveDirVec);
};
// [NOTICE] not consider ignore.
function $377a1d5467eb3e77$var$moveIfOverlap(basedLayoutInfo, movableLayoutInfo, moveDirVec) {
    var mtv = new (0, $1de2ad08c108b7c2$export$2e2bcd8739ae039)();
    if ((0, $c7004a764badae25$export$f28bfabef115ba96)(basedLayoutInfo, movableLayoutInfo, mtv, {
        direction: Math.atan2(moveDirVec.y, moveDirVec.x),
        bidirectional: false,
        touchThreshold: 0.05
    })) (0, $c7004a764badae25$export$91f733c27ab0712f)(movableLayoutInfo, mtv);
}
function $377a1d5467eb3e77$export$e033c6449cc6f6a1(baseLayoutInfoList, baseDirVec, movableLayoutInfo, moveDirVec) {
    // Detect and move from far to close.
    var sameDir = (0, $1de2ad08c108b7c2$export$2e2bcd8739ae039).dot(moveDirVec, baseDirVec) >= 0;
    for(var idx = 0, len = baseLayoutInfoList.length; idx < len; idx++){
        var labelInfo = baseLayoutInfoList[sameDir ? idx : len - 1 - idx];
        if (!labelInfo.label.ignore) $377a1d5467eb3e77$var$moveIfOverlap(labelInfo, movableLayoutInfo, moveDirVec);
    }
}
/**
 * @caution
 * - Ensure it is called after the data processing stage finished.
 * - It might be called before `CahrtView#render`, sush as called at `CoordinateSystem#update`,
 *  thus ensure the result the same whenever it is called.
 *
 * A builder for a straight-line axis.
 *
 * A final axis is translated and rotated from a "standard axis".
 * So opt.position and opt.rotation is required.
 *
 * A "standard axis" is the axis [0,0]-->[abs(axisExtent[1]-axisExtent[0]),0]
 * for example: [0,0]-->[50,0]
 */ var $377a1d5467eb3e77$var$AxisBuilder = /** @class */ function() {
    /**
   * [CAUTION]: axisModel.axis.extent/scale must be ready to use.
   */ function AxisBuilder(axisModel, api, opt, shared) {
        this.group = new $a8978f7a0e842e3d$export$2e2bcd8739ae039();
        this._axisModel = axisModel;
        this._api = api;
        this._local = {};
        this._shared = shared || new $377a1d5467eb3e77$export$f2e237206f7393f5($377a1d5467eb3e77$export$7fcb8742f5816cae);
        this._resetCfgDetermined(opt);
    }
    /**
   * Regarding axis label related configurations, only the change of label.x/y is supported; other
   * changes are not necessary and not performant. To be specific, only `axis.position`
   * (and consequently `labelOffset`) and `axis.extent` can be changed, and assume everything in
   * `axisModel` are not changed.
   * Axis line related configurations can be changed since this method can only be called
   * before they are created.
   */ AxisBuilder.prototype.updateCfg = function(opt) {
        var ready;
        var raw = this._cfg.raw;
        raw.position = opt.position;
        raw.labelOffset = opt.labelOffset;
        this._resetCfgDetermined(raw);
    };
    /**
   * [CAUTION] For debug usage. Never change it outside!
   */ AxisBuilder.prototype.__getRawCfg = function() {
        return this._cfg.raw;
    };
    AxisBuilder.prototype._resetCfgDetermined = function(raw) {
        var axisModel = this._axisModel;
        // FIXME:
        //  Currently there is no uniformed way to set default values if an option
        //  is specified null/undefined by user (intentionally or unintentionally),
        //  e.g. null/undefined is not a illegal value for `nameLocation`.
        //  Try to use `getDefaultOption` to address it. But radar has no `getDefaultOption`.
        var axisModelDefaultOption = axisModel.getDefaultOption ? axisModel.getDefaultOption() : {};
        // Default value
        var axisName = (0, $43e0a445ed6711da$export$995e01f2f5c9d030)(raw.axisName, axisModel.get("name"));
        var nameMoveOverlapOption = axisModel.get("nameMoveOverlap");
        if (nameMoveOverlapOption == null || nameMoveOverlapOption === "auto") nameMoveOverlapOption = (0, $43e0a445ed6711da$export$995e01f2f5c9d030)(raw.defaultNameMoveOverlap, true);
        var cfg = {
            raw: raw,
            position: raw.position,
            rotation: raw.rotation,
            nameDirection: (0, $43e0a445ed6711da$export$995e01f2f5c9d030)(raw.nameDirection, 1),
            tickDirection: (0, $43e0a445ed6711da$export$995e01f2f5c9d030)(raw.tickDirection, 1),
            labelDirection: (0, $43e0a445ed6711da$export$995e01f2f5c9d030)(raw.labelDirection, 1),
            labelOffset: (0, $43e0a445ed6711da$export$995e01f2f5c9d030)(raw.labelOffset, 0),
            silent: (0, $43e0a445ed6711da$export$995e01f2f5c9d030)(raw.silent, true),
            axisName: axisName,
            nameLocation: (0, $43e0a445ed6711da$export$2e94551289abb95b)(axisModel.get("nameLocation"), axisModelDefaultOption.nameLocation, "end"),
            shouldNameMoveOverlap: $377a1d5467eb3e77$var$hasAxisName(axisName) && nameMoveOverlapOption,
            optionHideOverlap: axisModel.get([
                "axisLabel",
                "hideOverlap"
            ]),
            showMinorTicks: axisModel.get([
                "minorTick",
                "show"
            ])
        };
        this._cfg = cfg;
        // FIXME Not use a separate text group?
        var transformGroup = new $a8978f7a0e842e3d$export$2e2bcd8739ae039({
            x: cfg.position[0],
            y: cfg.position[1],
            rotation: cfg.rotation
        });
        transformGroup.updateTransform();
        this._transformGroup = transformGroup;
        var record = this._shared.ensureRecord(axisModel);
        record.transGroup = this._transformGroup;
        record.dirVec = new (0, $1de2ad08c108b7c2$export$2e2bcd8739ae039)(Math.cos(-cfg.rotation), Math.sin(-cfg.rotation));
    };
    AxisBuilder.prototype.build = function(axisPartNameMap, extraParams) {
        var _this = this;
        if (!axisPartNameMap) axisPartNameMap = {
            axisLine: true,
            axisTickLabelEstimate: false,
            axisTickLabelDetermine: true,
            axisName: true
        };
        (0, $43e0a445ed6711da$export$79b2f7037acddd43)($377a1d5467eb3e77$var$AXIS_BUILDER_AXIS_PART_NAMES, function(partName) {
            if (axisPartNameMap[partName]) $377a1d5467eb3e77$var$builders[partName](_this._cfg, _this._local, _this._shared, _this._axisModel, _this.group, _this._transformGroup, _this._api, extraParams || {});
        });
        return this;
    };
    /**
   * Currently only get text align/verticalAlign by rotation.
   * NO `position` is involved, otherwise it have to be performed for each `updateAxisLabelChangableProps`.
   */ AxisBuilder.innerTextLayout = function(axisRotation, textRotation, direction) {
        var rotationDiff = (0, $b49750109e236fd8$export$2ca6dd70a288b1c3)(textRotation - axisRotation);
        var textAlign;
        var textVerticalAlign;
        if ((0, $b49750109e236fd8$export$d1df570aea2868f)(rotationDiff)) {
            // Label is parallel with axis line.
            textVerticalAlign = direction > 0 ? "top" : "bottom";
            textAlign = "center";
        } else if ((0, $b49750109e236fd8$export$d1df570aea2868f)(rotationDiff - $377a1d5467eb3e77$var$PI)) {
            // Label is inverse parallel with axis line.
            textVerticalAlign = direction > 0 ? "bottom" : "top";
            textAlign = "center";
        } else {
            textVerticalAlign = "middle";
            if (rotationDiff > 0 && rotationDiff < $377a1d5467eb3e77$var$PI) textAlign = direction > 0 ? "right" : "left";
            else textAlign = direction > 0 ? "left" : "right";
        }
        return {
            rotation: rotationDiff,
            textAlign: textAlign,
            textVerticalAlign: textVerticalAlign
        };
    };
    AxisBuilder.makeAxisEventDataBase = function(axisModel) {
        var eventData = {
            componentType: axisModel.mainType,
            componentIndex: axisModel.componentIndex
        };
        eventData[axisModel.mainType + "Index"] = axisModel.componentIndex;
        return eventData;
    };
    AxisBuilder.isLabelSilent = function(axisModel) {
        var tooltipOpt = axisModel.get("tooltip");
        return axisModel.get("silent") || !(axisModel.get("triggerEvent") || tooltipOpt && tooltipOpt.show);
    };
    return AxisBuilder;
}();
// Sorted by dependency order.
var $377a1d5467eb3e77$var$AXIS_BUILDER_AXIS_PART_NAMES = [
    "axisLine",
    "axisTickLabelEstimate",
    "axisTickLabelDetermine",
    "axisName"
];
var $377a1d5467eb3e77$var$builders = {
    axisLine: function(cfg, local, shared, axisModel, group, transformGroup, api) {
        var ready;
        var shown = axisModel.get([
            "axisLine",
            "show"
        ]);
        if (shown === "auto") {
            shown = true;
            if (cfg.raw.axisLineAutoShow != null) shown = !!cfg.raw.axisLineAutoShow;
        }
        if (!shown) return;
        var extent = axisModel.axis.getExtent();
        var matrix = transformGroup.transform;
        var pt1 = [
            extent[0],
            0
        ];
        var pt2 = [
            extent[1],
            0
        ];
        var inverse = pt1[0] > pt2[0];
        if (matrix) {
            (0, $ee491d8f32bd01ff$export$9f9dcb98c894b623)(pt1, pt1, matrix);
            (0, $ee491d8f32bd01ff$export$9f9dcb98c894b623)(pt2, pt2, matrix);
        }
        var lineStyle = (0, $43e0a445ed6711da$export$8b58be045bf06082)({
            lineCap: "round"
        }, axisModel.getModel([
            "axisLine",
            "lineStyle"
        ]).getLineStyle());
        var pathBaseProp = {
            strokeContainThreshold: cfg.raw.strokeContainThreshold || 5,
            silent: true,
            z2: 1,
            style: lineStyle
        };
        if (axisModel.get([
            "axisLine",
            "breakLine"
        ]) && (0, $d760dd937396b887$export$fec008222a1db2dc)(axisModel.axis.scale)) (0, $6ef64eccf67efcc6$export$c1d9b2cc33e7e5e)().buildAxisBreakLine(axisModel, group, transformGroup, pathBaseProp);
        else {
            var line = new $0e0ee2afac2bc66d$export$2e2bcd8739ae039((0, $43e0a445ed6711da$export$8b58be045bf06082)({
                shape: {
                    x1: pt1[0],
                    y1: pt1[1],
                    x2: pt2[0],
                    y2: pt2[1]
                }
            }, pathBaseProp));
            $6552edac5ca572b1$export$8b4b620d7f4aad1b(line.shape, line.style.lineWidth);
            line.anid = "line";
            group.add(line);
        }
        var arrows = axisModel.get([
            "axisLine",
            "symbol"
        ]);
        if (arrows != null) {
            var arrowSize = axisModel.get([
                "axisLine",
                "symbolSize"
            ]);
            if ((0, $43e0a445ed6711da$export$844ec244b1367d54)(arrows)) // Use the same arrow for start and end point
            arrows = [
                arrows,
                arrows
            ];
            if ((0, $43e0a445ed6711da$export$844ec244b1367d54)(arrowSize) || (0, $43e0a445ed6711da$export$7e4aa119212bc614)(arrowSize)) // Use the same size for width and height
            arrowSize = [
                arrowSize,
                arrowSize
            ];
            var arrowOffset = (0, $4ff41a845d4679a6$export$e3e292895c033f6d)(axisModel.get([
                "axisLine",
                "symbolOffset"
            ]) || 0, arrowSize);
            var symbolWidth_1 = arrowSize[0];
            var symbolHeight_1 = arrowSize[1];
            (0, $43e0a445ed6711da$export$79b2f7037acddd43)([
                {
                    rotate: cfg.rotation + Math.PI / 2,
                    offset: arrowOffset[0],
                    r: 0
                },
                {
                    rotate: cfg.rotation - Math.PI / 2,
                    offset: arrowOffset[1],
                    r: Math.sqrt((pt1[0] - pt2[0]) * (pt1[0] - pt2[0]) + (pt1[1] - pt2[1]) * (pt1[1] - pt2[1]))
                }
            ], function(point, index) {
                if (arrows[index] !== "none" && arrows[index] != null) {
                    var symbol = (0, $4ff41a845d4679a6$export$af050e04da3a02e8)(arrows[index], -symbolWidth_1 / 2, -symbolHeight_1 / 2, symbolWidth_1, symbolHeight_1, lineStyle.stroke, true);
                    // Calculate arrow position with offset
                    var r = point.r + point.offset;
                    var pt = inverse ? pt2 : pt1;
                    symbol.attr({
                        rotation: point.rotate,
                        x: pt[0] + r * Math.cos(cfg.rotation),
                        y: pt[1] - r * Math.sin(cfg.rotation),
                        silent: true,
                        z2: 11
                    });
                    group.add(symbol);
                }
            });
        }
    },
    /**
   * [CAUTION] This method can be called multiple times, following the change due to `resetCfg` called
   *  in size measurement. Thus this method should be idempotent, and should be performant.
   */ axisTickLabelEstimate: function(cfg, local, shared, axisModel, group, transformGroup, api, extraParams) {
        var ready;
        var needCallLayout = $377a1d5467eb3e77$var$dealLastTickLabelResultReusable(local, group, extraParams);
        if (needCallLayout) $377a1d5467eb3e77$var$layOutAxisTickLabel(cfg, local, shared, axisModel, group, transformGroup, api, (0, $c897f028bf966826$export$31cba7db0a663292).estimate);
    },
    /**
   * Finish axis tick label build.
   * Can be only called once.
   */ axisTickLabelDetermine: function(cfg, local, shared, axisModel, group, transformGroup, api, extraParams) {
        var ready;
        var needCallLayout = $377a1d5467eb3e77$var$dealLastTickLabelResultReusable(local, group, extraParams);
        if (needCallLayout) $377a1d5467eb3e77$var$layOutAxisTickLabel(cfg, local, shared, axisModel, group, transformGroup, api, (0, $c897f028bf966826$export$31cba7db0a663292).determine);
        var ticksEls = $377a1d5467eb3e77$var$buildAxisMajorTicks(cfg, group, transformGroup, axisModel);
        $377a1d5467eb3e77$var$syncLabelIgnoreToMajorTicks(cfg, local.labelLayoutList, ticksEls);
        $377a1d5467eb3e77$var$buildAxisMinorTicks(cfg, group, transformGroup, axisModel, cfg.tickDirection);
    },
    /**
   * [CAUTION] This method can be called multiple times, following the change due to `resetCfg` called
   *  in size measurement. Thus this method should be idempotent, and should be performant.
   */ axisName: function(cfg, local, shared, axisModel, group, transformGroup, api, extraParams) {
        var sharedRecord = shared.ensureRecord(axisModel);
        var ready;
        // Remove the existing name result created in estimation phase.
        if (local.nameEl) {
            group.remove(local.nameEl);
            local.nameEl = sharedRecord.nameLayout = sharedRecord.nameLocation = null;
        }
        var name = cfg.axisName;
        if (!$377a1d5467eb3e77$var$hasAxisName(name)) return;
        var nameLocation = cfg.nameLocation;
        var nameDirection = cfg.nameDirection;
        var textStyleModel = axisModel.getModel("nameTextStyle");
        var gap = axisModel.get("nameGap") || 0;
        var extent = axisModel.axis.getExtent();
        var gapStartEndSignal = axisModel.axis.inverse ? -1 : 1;
        var pos = new (0, $1de2ad08c108b7c2$export$2e2bcd8739ae039)(0, 0);
        var nameMoveDirVec = new (0, $1de2ad08c108b7c2$export$2e2bcd8739ae039)(0, 0);
        if (nameLocation === "start") {
            pos.x = extent[0] - gapStartEndSignal * gap;
            nameMoveDirVec.x = -gapStartEndSignal;
        } else if (nameLocation === "end") {
            pos.x = extent[1] + gapStartEndSignal * gap;
            nameMoveDirVec.x = gapStartEndSignal;
        } else {
            // 'middle' or 'center'
            pos.x = (extent[0] + extent[1]) / 2;
            pos.y = cfg.labelOffset + nameDirection * gap;
            nameMoveDirVec.y = nameDirection;
        }
        var mt = $87ac8de5537d9a34$export$185802fd694ee1f5();
        nameMoveDirVec.transform($87ac8de5537d9a34$export$bb628a54ab399bc9(mt, mt, cfg.rotation));
        var nameRotation = axisModel.get("nameRotate");
        if (nameRotation != null) nameRotation = nameRotation * $377a1d5467eb3e77$var$PI / 180; // To radian.
        var labelLayout;
        var axisNameAvailableWidth;
        if ((0, $3e6d0d29922ecf90$export$c06aa22293dea9d2)(nameLocation)) labelLayout = $377a1d5467eb3e77$var$AxisBuilder.innerTextLayout(cfg.rotation, nameRotation != null ? nameRotation : cfg.rotation, // Adapt to axis.
        nameDirection);
        else {
            labelLayout = $377a1d5467eb3e77$var$endTextLayout(cfg.rotation, nameLocation, nameRotation || 0, extent);
            axisNameAvailableWidth = cfg.raw.axisNameAvailableWidth;
            if (axisNameAvailableWidth != null) {
                axisNameAvailableWidth = Math.abs(axisNameAvailableWidth / Math.sin(labelLayout.rotation));
                !isFinite(axisNameAvailableWidth) && (axisNameAvailableWidth = null);
            }
        }
        var textFont = textStyleModel.getFont();
        var truncateOpt = axisModel.get("nameTruncate", true) || {};
        var ellipsis = truncateOpt.ellipsis;
        var maxWidth = (0, $43e0a445ed6711da$export$8a4d17b6e8486e66)(cfg.raw.nameTruncateMaxWidth, truncateOpt.maxWidth, axisNameAvailableWidth);
        var nameMarginLevel = extraParams.nameMarginLevel || 0;
        var textEl = new $7db7960d25b39b7c$export$2e2bcd8739ae039({
            x: pos.x,
            y: pos.y,
            rotation: labelLayout.rotation,
            silent: $377a1d5467eb3e77$var$AxisBuilder.isLabelSilent(axisModel),
            style: (0, $6556fe1ed9fb479d$export$f8998c3d0a13de59)(textStyleModel, {
                text: name,
                font: textFont,
                overflow: "truncate",
                width: maxWidth,
                ellipsis: ellipsis,
                fill: textStyleModel.getTextColor() || axisModel.get([
                    "axisLine",
                    "lineStyle",
                    "color"
                ]),
                align: textStyleModel.get("align") || labelLayout.textAlign,
                verticalAlign: textStyleModel.get("verticalAlign") || labelLayout.textVerticalAlign
            }),
            z2: 1
        });
        $6552edac5ca572b1$export$fc6410d97fab306c({
            el: textEl,
            componentModel: axisModel,
            itemName: name
        });
        textEl.__fullText = name;
        // Id for animation
        textEl.anid = "name";
        if (axisModel.get("triggerEvent")) {
            var eventData = $377a1d5467eb3e77$var$AxisBuilder.makeAxisEventDataBase(axisModel);
            eventData.targetType = "axisName";
            eventData.name = name;
            (0, $7e4afcfca8f5121f$export$b1c39b2bacd1ddc2)(textEl).eventData = eventData;
        }
        transformGroup.add(textEl);
        textEl.updateTransform();
        local.nameEl = textEl;
        var nameLayout = sharedRecord.nameLayout = (0, $c7004a764badae25$export$471916f4e89eb5da)({
            label: textEl,
            priority: textEl.z2,
            defaultAttr: {
                ignore: textEl.ignore
            },
            marginDefault: (0, $3e6d0d29922ecf90$export$c06aa22293dea9d2)(nameLocation) ? $377a1d5467eb3e77$var$DEFAULT_CENTER_NAME_MARGIN_LEVELS[nameMarginLevel] : $377a1d5467eb3e77$var$DEFAULT_ENDS_NAME_MARGIN_LEVELS[nameMarginLevel]
        });
        sharedRecord.nameLocation = nameLocation;
        group.add(textEl);
        textEl.decomposeTransform();
        if (cfg.shouldNameMoveOverlap && nameLayout) {
            var record = shared.ensureRecord(axisModel);
            shared.resolveAxisNameOverlap(cfg, shared, axisModel, nameLayout, nameMoveDirVec, record);
        }
    }
};
function $377a1d5467eb3e77$var$layOutAxisTickLabel(cfg, local, shared, axisModel, group, transformGroup, api, kind) {
    if (!$377a1d5467eb3e77$var$axisLabelBuildResultExists(local)) $377a1d5467eb3e77$var$buildAxisLabel(cfg, local, group, kind, axisModel, api);
    var labelLayoutList = local.labelLayoutList;
    $377a1d5467eb3e77$var$updateAxisLabelChangableProps(cfg, axisModel, labelLayoutList, transformGroup);
    $377a1d5467eb3e77$var$adjustBreakLabels(axisModel, cfg.rotation, labelLayoutList);
    var optionHideOverlap = cfg.optionHideOverlap;
    $377a1d5467eb3e77$var$fixMinMaxLabelShow(axisModel, labelLayoutList, optionHideOverlap);
    if (optionHideOverlap) // This bit fixes the label overlap issue for the time chart.
    // See https://github.com/apache/echarts/issues/14266 for more.
    (0, $c7004a764badae25$export$8ce774e164a49410)(// Filter the already ignored labels by the previous overlap resolving methods.
    (0, $43e0a445ed6711da$export$3dea766d36a8935f)(labelLayoutList, function(layout) {
        return layout && !layout.label.ignore;
    }));
    // Always call it even this axis has no name, since it serves in overlapping detection
    // and grid outerBounds on other axis.
    $377a1d5467eb3e77$var$resetOverlapRecordToShared(cfg, shared, axisModel, labelLayoutList);
}
function $377a1d5467eb3e77$var$endTextLayout(rotation, textPosition, textRotate, extent) {
    var rotationDiff = (0, $b49750109e236fd8$export$2ca6dd70a288b1c3)(textRotate - rotation);
    var textAlign;
    var textVerticalAlign;
    var inverse = extent[0] > extent[1];
    var onLeft = textPosition === "start" && !inverse || textPosition !== "start" && inverse;
    if ((0, $b49750109e236fd8$export$d1df570aea2868f)(rotationDiff - $377a1d5467eb3e77$var$PI / 2)) {
        textVerticalAlign = onLeft ? "bottom" : "top";
        textAlign = "center";
    } else if ((0, $b49750109e236fd8$export$d1df570aea2868f)(rotationDiff - $377a1d5467eb3e77$var$PI * 1.5)) {
        textVerticalAlign = onLeft ? "top" : "bottom";
        textAlign = "center";
    } else {
        textVerticalAlign = "middle";
        if (rotationDiff < $377a1d5467eb3e77$var$PI * 1.5 && rotationDiff > $377a1d5467eb3e77$var$PI / 2) textAlign = onLeft ? "left" : "right";
        else textAlign = onLeft ? "right" : "left";
    }
    return {
        rotation: rotationDiff,
        textAlign: textAlign,
        textVerticalAlign: textVerticalAlign
    };
}
/**
 * Assume `labelLayoutList` has no `label.ignore: true`.
 * Assume `labelLayoutList` have been sorted by value ascending order.
 */ function $377a1d5467eb3e77$var$fixMinMaxLabelShow(axisModel, labelLayoutList, optionHideOverlap) {
    var axis = axisModel.axis;
    var customValuesOption = axisModel.get([
        "axisLabel",
        "customValues"
    ]);
    if ((0, $3e6d0d29922ecf90$export$c2911c025243d6a6)(axis)) return;
    // FIXME
    // Have not consider onBand yet, where tick els is more than label els.
    // Assert no ignore in labels.
    function deal(showMinMaxLabelOption, outmostLabelIdx, innerLabelIdx) {
        var outmostLabelLayout = (0, $c7004a764badae25$export$471916f4e89eb5da)(labelLayoutList[outmostLabelIdx]);
        var innerLabelLayout = (0, $c7004a764badae25$export$471916f4e89eb5da)(labelLayoutList[innerLabelIdx]);
        var scale = axis.scale;
        if (!outmostLabelLayout || !innerLabelLayout) return;
        if (showMinMaxLabelOption == null) {
            if (!optionHideOverlap && customValuesOption) // In this case, users are unlikely to expect labels to be hidden.
            return;
            var tick = $377a1d5467eb3e77$export$c392b818a26a879e(outmostLabelLayout.label).labelInfo.tick;
            if (// TimeScale does not expand extent to "nice", so eliminate labels that are not nice.
            (0, $eb97010bfdf4c825$export$c9b71a3750db342f)(scale) && tick.notNice || (0, $eb97010bfdf4c825$export$61579433626afe87)(scale) && tick.offInterval) {
                $377a1d5467eb3e77$var$ignoreEl(outmostLabelLayout.label);
                return;
            }
        }
        if (showMinMaxLabelOption === false || outmostLabelLayout.suggestIgnore) {
            $377a1d5467eb3e77$var$ignoreEl(outmostLabelLayout.label);
            return;
        }
        if (innerLabelLayout.suggestIgnore) {
            $377a1d5467eb3e77$var$ignoreEl(innerLabelLayout.label);
            return;
        }
        // PENDING: Originally we thought `optionHideOverlap === false` means do not hide anything,
        //  since currently the bounding rect of text might not accurate enough and might slightly bigger,
        //  which causes false positive. But `optionHideOverlap: null/undfined` is falsy and likely
        //  be treated as false.
        // In most fonts the glyph does not reach the boundary of the bounding rect.
        // This is needed to avoid too aggressive to hide two elements that meet at the edge
        // due to compact layout by the same bounding rect or OBB.
        var touchThreshold = 0.1;
        // This treatment is for backward compatibility. And `!optionHideOverlap` implies that
        // the user accepts the visual touch between adjacent labels, thus "hide min/max label"
        // should be conservative, since the space might be sufficient in this case.
        if (!optionHideOverlap) {
            var marginForce = [
                0,
                0,
                0,
                0
            ];
            // Make a copy to apply `ignoreMargin`.
            outmostLabelLayout = (0, $c7004a764badae25$export$a1cfd37e9b88106b)({
                marginForce: marginForce
            }, outmostLabelLayout);
            innerLabelLayout = (0, $c7004a764badae25$export$a1cfd37e9b88106b)({
                marginForce: marginForce
            }, innerLabelLayout);
        }
        if ((0, $c7004a764badae25$export$f28bfabef115ba96)(outmostLabelLayout, innerLabelLayout, null, {
            touchThreshold: touchThreshold
        })) {
            if (showMinMaxLabelOption) $377a1d5467eb3e77$var$ignoreEl(innerLabelLayout.label);
            else $377a1d5467eb3e77$var$ignoreEl(outmostLabelLayout.label);
        }
    }
    // If min or max are user set, we need to check
    // If the tick on min(max) are overlap on their neighbour tick
    // If they are overlapped, we need to hide the min(max) tick label
    var showMinLabelOption = axisModel.get([
        "axisLabel",
        "showMinLabel"
    ]);
    var showMaxLabelOption = axisModel.get([
        "axisLabel",
        "showMaxLabel"
    ]);
    var labelsLen = labelLayoutList.length;
    deal(showMinLabelOption, 0, 1);
    deal(showMaxLabelOption, labelsLen - 1, labelsLen - 2);
}
// Under default settings, it is visually odd to display a tick without its label,
// since ticks extend from axis line towards labels and serve as visual guide.
// PENDING: Is there opposite cases?
function $377a1d5467eb3e77$var$syncLabelIgnoreToMajorTicks(cfg, labelLayoutList, tickEls) {
    if (cfg.showMinorTicks) // It probably unreasonable to hide major ticks when show minor ticks.
    return;
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)(labelLayoutList, function(labelLayout) {
        if (labelLayout && labelLayout.label.ignore) for(var idx = 0; idx < tickEls.length; idx++){
            var tickEl = tickEls[idx];
            // Assume small array, linear search is fine for performance.
            // PENDING: measure?
            var tickInner = $377a1d5467eb3e77$var$getTickInner(tickEl);
            var labelInner = $377a1d5467eb3e77$export$c392b818a26a879e(labelLayout.label);
            if (tickInner.tickValue != null && !tickInner.onBand && tickInner.tickValue === labelInner.labelInfo.tick.value) {
                $377a1d5467eb3e77$var$ignoreEl(tickEl);
                return;
            }
        }
    });
}
function $377a1d5467eb3e77$var$ignoreEl(el) {
    el && (el.ignore = true);
}
function $377a1d5467eb3e77$var$createTicks(ticksCoords, tickTransform, tickEndCoord, tickLineStyle, anidPrefix) {
    var tickEls = [];
    var pt1 = [];
    var pt2 = [];
    for(var i = 0; i < ticksCoords.length; i++){
        var tickCoord = ticksCoords[i].coord;
        pt1[0] = tickCoord;
        pt1[1] = 0;
        pt2[0] = tickCoord;
        pt2[1] = tickEndCoord;
        if (tickTransform) {
            (0, $ee491d8f32bd01ff$export$9f9dcb98c894b623)(pt1, pt1, tickTransform);
            (0, $ee491d8f32bd01ff$export$9f9dcb98c894b623)(pt2, pt2, tickTransform);
        }
        // Tick line, Not use group transform to have better line draw
        var tickEl = new $0e0ee2afac2bc66d$export$2e2bcd8739ae039({
            shape: {
                x1: pt1[0],
                y1: pt1[1],
                x2: pt2[0],
                y2: pt2[1]
            },
            style: tickLineStyle,
            z2: 2,
            autoBatch: true,
            silent: true
        });
        $6552edac5ca572b1$export$8b4b620d7f4aad1b(tickEl.shape, tickEl.style.lineWidth);
        tickEl.anid = anidPrefix + "_" + ticksCoords[i].tickValue;
        tickEls.push(tickEl);
        var inner = $377a1d5467eb3e77$var$getTickInner(tickEl);
        inner.onBand = !!ticksCoords[i].onBand;
        inner.tickValue = ticksCoords[i].tickValue;
    }
    return tickEls;
}
function $377a1d5467eb3e77$var$buildAxisMajorTicks(cfg, group, transformGroup, axisModel) {
    var axis = axisModel.axis;
    var tickModel = axisModel.getModel("axisTick");
    var shown = tickModel.get("show");
    if (shown === "auto") {
        shown = true;
        if (cfg.raw.axisTickAutoShow != null) shown = !!cfg.raw.axisTickAutoShow;
    }
    if (!shown || axis.scale.isBlank()) return [];
    var lineStyleModel = tickModel.getModel("lineStyle");
    var tickEndCoord = cfg.tickDirection * tickModel.get("length");
    var ticksCoords = axis.getTicksCoords();
    var ticksEls = $377a1d5467eb3e77$var$createTicks(ticksCoords, transformGroup.transform, tickEndCoord, (0, $43e0a445ed6711da$export$ebe90cb607ad99e)(lineStyleModel.getLineStyle(), {
        stroke: axisModel.get([
            "axisLine",
            "lineStyle",
            "color"
        ])
    }), "ticks");
    for(var i = 0; i < ticksEls.length; i++)group.add(ticksEls[i]);
    return ticksEls;
}
function $377a1d5467eb3e77$var$buildAxisMinorTicks(cfg, group, transformGroup, axisModel, tickDirection) {
    var axis = axisModel.axis;
    var minorTickModel = axisModel.getModel("minorTick");
    if (!cfg.showMinorTicks || axis.scale.isBlank()) return;
    var minorTicksCoords = axis.getMinorTicksCoords();
    if (!minorTicksCoords.length) return;
    var lineStyleModel = minorTickModel.getModel("lineStyle");
    var tickEndCoord = tickDirection * minorTickModel.get("length");
    var minorTickLineStyle = (0, $43e0a445ed6711da$export$ebe90cb607ad99e)(lineStyleModel.getLineStyle(), (0, $43e0a445ed6711da$export$ebe90cb607ad99e)(axisModel.getModel("axisTick").getLineStyle(), {
        stroke: axisModel.get([
            "axisLine",
            "lineStyle",
            "color"
        ])
    }));
    for(var i = 0; i < minorTicksCoords.length; i++){
        var minorTicksEls = $377a1d5467eb3e77$var$createTicks(minorTicksCoords[i], transformGroup.transform, tickEndCoord, minorTickLineStyle, "minorticks_" + i);
        for(var k = 0; k < minorTicksEls.length; k++)group.add(minorTicksEls[k]);
    }
}
// Return whether need to call `layOutAxisTickLabel` again.
function $377a1d5467eb3e77$var$dealLastTickLabelResultReusable(local, group, extraParams) {
    if ($377a1d5467eb3e77$var$axisLabelBuildResultExists(local)) {
        var axisLabelsCreationContext = local.axisLabelsCreationContext;
        var noPxChangeTryDetermine = axisLabelsCreationContext.out.noPxChangeTryDetermine;
        if (extraParams.noPxChange) {
            var canDetermine = true;
            for(var idx = 0; idx < noPxChangeTryDetermine.length; idx++)canDetermine = canDetermine && noPxChangeTryDetermine[idx]();
            if (canDetermine) return false;
        }
        if (noPxChangeTryDetermine.length) {
            // Remove the result of `buildAxisLabel`
            group.remove(local.labelGroup);
            $377a1d5467eb3e77$var$axisLabelBuildResultSet(local, null, null, null);
        }
    }
    return true;
}
function $377a1d5467eb3e77$var$buildAxisLabel(cfg, local, group, kind, axisModel, api) {
    var axis = axisModel.axis;
    var show = (0, $43e0a445ed6711da$export$8a4d17b6e8486e66)(cfg.raw.axisLabelShow, axisModel.get([
        "axisLabel",
        "show"
    ]));
    var labelGroup = new $a8978f7a0e842e3d$export$2e2bcd8739ae039();
    group.add(labelGroup);
    var axisLabelCreationCtx = (0, $c897f028bf966826$export$12d6ac38274c43e7)(kind);
    if (!show || axis.scale.isBlank()) {
        $377a1d5467eb3e77$var$axisLabelBuildResultSet(local, [], labelGroup, axisLabelCreationCtx);
        return;
    }
    var labelModel = axisModel.getModel("axisLabel");
    var labels = axis.getViewLabels(axisLabelCreationCtx);
    // Special label rotate.
    var labelRotation = ((0, $43e0a445ed6711da$export$8a4d17b6e8486e66)(cfg.raw.labelRotate, labelModel.get("rotate")) || 0) * $377a1d5467eb3e77$var$PI / 180;
    var labelLayout = $377a1d5467eb3e77$var$AxisBuilder.innerTextLayout(cfg.rotation, labelRotation, cfg.labelDirection);
    var rawCategoryData = axisModel.getCategories && axisModel.getCategories(true);
    var labelEls = [];
    var triggerEvent = axisModel.get("triggerEvent");
    var z2Min = Infinity;
    var z2Max = -Infinity;
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)(labels, function(labelItem, index) {
        var _a;
        var labelItemTick = labelItem.tick;
        var formattedLabel = labelItem.formattedLabel;
        var rawLabel = labelItem.rawLabel;
        var itemLabelModel = labelModel;
        var tickValue = (0, $3e6d0d29922ecf90$export$889d2956111fd257)(axis.scale, labelItemTick);
        if (rawCategoryData && rawCategoryData[tickValue]) {
            var rawCategoryItem = rawCategoryData[tickValue];
            if ((0, $43e0a445ed6711da$export$a6cdc56e425d0d0a)(rawCategoryItem) && rawCategoryItem.textStyle) itemLabelModel = new (0, $279973fc50f77a15$export$2e2bcd8739ae039)(rawCategoryItem.textStyle, labelModel, axisModel.ecModel);
        }
        var textColor = itemLabelModel.getTextColor() || axisModel.get([
            "axisLine",
            "lineStyle",
            "color"
        ]);
        var align = itemLabelModel.getShallow("align", true) || labelLayout.textAlign;
        var alignMin = (0, $43e0a445ed6711da$export$995e01f2f5c9d030)(itemLabelModel.getShallow("alignMinLabel", true), align);
        var alignMax = (0, $43e0a445ed6711da$export$995e01f2f5c9d030)(itemLabelModel.getShallow("alignMaxLabel", true), align);
        var verticalAlign = itemLabelModel.getShallow("verticalAlign", true) || itemLabelModel.getShallow("baseline", true) || labelLayout.textVerticalAlign;
        var verticalAlignMin = (0, $43e0a445ed6711da$export$995e01f2f5c9d030)(itemLabelModel.getShallow("verticalAlignMinLabel", true), verticalAlign);
        var verticalAlignMax = (0, $43e0a445ed6711da$export$995e01f2f5c9d030)(itemLabelModel.getShallow("verticalAlignMaxLabel", true), verticalAlign);
        var z2 = 10 + (((_a = labelItemTick.time) === null || _a === void 0 ? void 0 : _a.level) || 0);
        z2Min = Math.min(z2Min, z2);
        z2Max = Math.max(z2Max, z2);
        var textEl = new $7db7960d25b39b7c$export$2e2bcd8739ae039({
            // --- transform props start ---
            // All of the transform props MUST not be set here, but should be set in
            // `updateAxisLabelChangableProps`, because they may change in estimation,
            // and need to calculate based on global coord sys by `decomposeTransform`.
            x: 0,
            y: 0,
            rotation: 0,
            // --- transform props end ---
            silent: $377a1d5467eb3e77$var$AxisBuilder.isLabelSilent(axisModel),
            z2: z2,
            style: (0, $6556fe1ed9fb479d$export$f8998c3d0a13de59)(itemLabelModel, {
                text: formattedLabel,
                align: index === 0 ? alignMin : index === labels.length - 1 ? alignMax : align,
                verticalAlign: index === 0 ? verticalAlignMin : index === labels.length - 1 ? verticalAlignMax : verticalAlign,
                fill: (0, $43e0a445ed6711da$export$f6e2535fb5126e54)(textColor) ? textColor(// (1) In category axis with data zoom, tick is not the original
                // index of axis.data. So tick should not be exposed to user
                // in category axis.
                // (2) Compatible with previous version, which always use formatted label as
                // input. But in interval scale the formatted label is like '223,445', which
                // maked user replace ','. So we modify it to return original val but remain
                // it as 'string' to avoid error in replacing.
                axis.type === "category" ? rawLabel : axis.type === "value" ? tickValue + "" : tickValue, index) : textColor
            })
        });
        textEl.anid = "label_" + tickValue;
        var inner = $377a1d5467eb3e77$export$c392b818a26a879e(textEl);
        inner.labelInfo = labelItem;
        inner.layoutRotation = labelLayout.rotation;
        $6552edac5ca572b1$export$fc6410d97fab306c({
            el: textEl,
            componentModel: axisModel,
            itemName: formattedLabel,
            formatterParamsExtra: {
                isTruncated: function() {
                    return textEl.isTruncated;
                },
                value: rawLabel,
                tickIndex: index
            }
        });
        // Pack data for mouse event
        if (triggerEvent) {
            var eventData = $377a1d5467eb3e77$var$AxisBuilder.makeAxisEventDataBase(axisModel);
            eventData.targetType = "axisLabel";
            eventData.value = rawLabel;
            eventData.tickIndex = index;
            var labelItemTickBreak = labelItem.tick["break"];
            if (labelItemTickBreak) {
                var labelItemTickBreakParsedBreak = labelItemTickBreak.parsedBreak;
                eventData["break"] = {
                    // type: labelItem.break.type,
                    start: labelItemTickBreakParsedBreak.vmin,
                    end: labelItemTickBreakParsedBreak.vmax
                };
            }
            if (axis.type === "category") eventData.dataIndex = tickValue;
            (0, $7e4afcfca8f5121f$export$b1c39b2bacd1ddc2)(textEl).eventData = eventData;
            if (labelItemTickBreak) $377a1d5467eb3e77$var$addBreakEventHandler(axisModel, api, textEl, labelItemTickBreak);
        }
        labelEls.push(textEl);
        labelGroup.add(textEl);
    });
    var labelLayoutList = (0, $43e0a445ed6711da$export$871de8747c9eaa88)(labelEls, function(label) {
        return {
            label: label,
            priority: $377a1d5467eb3e77$export$c392b818a26a879e(label).labelInfo.tick["break"] ? label.z2 + (z2Max - z2Min + 1 // Make break labels be highest priority.
            ) : label.z2,
            defaultAttr: {
                ignore: label.ignore
            }
        };
    });
    $377a1d5467eb3e77$var$axisLabelBuildResultSet(local, labelLayoutList, labelGroup, axisLabelCreationCtx);
}
// Indicate that `layOutAxisTickLabel` has been called.
function $377a1d5467eb3e77$var$axisLabelBuildResultExists(local) {
    return !!local.labelLayoutList;
}
function $377a1d5467eb3e77$var$axisLabelBuildResultSet(local, labelLayoutList, labelGroup, axisLabelsCreationContext) {
    // Ensure the same lifetime.
    local.labelLayoutList = labelLayoutList;
    local.labelGroup = labelGroup;
    local.axisLabelsCreationContext = axisLabelsCreationContext;
}
function $377a1d5467eb3e77$var$updateAxisLabelChangableProps(cfg, axisModel, labelLayoutList, transformGroup) {
    var labelMargin = axisModel.get([
        "axisLabel",
        "margin"
    ]);
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)(labelLayoutList, function(layout, idx) {
        var geometry = (0, $c7004a764badae25$export$471916f4e89eb5da)(layout);
        if (!geometry) return;
        var labelEl = geometry.label;
        var inner = $377a1d5467eb3e77$export$c392b818a26a879e(labelEl);
        // See the comment in `suggestIgnore`.
        geometry.suggestIgnore = labelEl.ignore;
        // Currently no `ignore:true` is set in `buildAxisLabel`
        // But `ignore:true` may be set subsequently for overlap handling, thus reset it here.
        labelEl.ignore = false;
        (0, $cca2e8cc539372e0$export$234b1c16dfa57d6a)($377a1d5467eb3e77$var$_tmpLayoutEl, $377a1d5467eb3e77$var$_tmpLayoutElReset);
        var axis = axisModel.axis;
        $377a1d5467eb3e77$var$_tmpLayoutEl.x = axis.dataToCoord((0, $3e6d0d29922ecf90$export$889d2956111fd257)(axis.scale, inner.labelInfo.tick));
        $377a1d5467eb3e77$var$_tmpLayoutEl.y = cfg.labelOffset + cfg.labelDirection * labelMargin;
        $377a1d5467eb3e77$var$_tmpLayoutEl.rotation = inner.layoutRotation;
        transformGroup.add($377a1d5467eb3e77$var$_tmpLayoutEl);
        $377a1d5467eb3e77$var$_tmpLayoutEl.updateTransform();
        transformGroup.remove($377a1d5467eb3e77$var$_tmpLayoutEl);
        $377a1d5467eb3e77$var$_tmpLayoutEl.decomposeTransform();
        (0, $cca2e8cc539372e0$export$234b1c16dfa57d6a)(labelEl, $377a1d5467eb3e77$var$_tmpLayoutEl);
        labelEl.markRedraw();
        (0, $c7004a764badae25$export$1551ece3f059eafb)(geometry, true);
        (0, $c7004a764badae25$export$471916f4e89eb5da)(geometry);
    });
}
var $377a1d5467eb3e77$var$_tmpLayoutEl = new $42ed508a93973e78$export$2e2bcd8739ae039();
var $377a1d5467eb3e77$var$_tmpLayoutElReset = new $42ed508a93973e78$export$2e2bcd8739ae039();
function $377a1d5467eb3e77$var$hasAxisName(axisName) {
    return !!axisName;
}
function $377a1d5467eb3e77$var$addBreakEventHandler(axisModel, api, textEl, visualBreak) {
    textEl.on("click", function(params) {
        var payload = {
            type: (0, $1ee6234a66398482$export$12319e2083cd71ce),
            breaks: [
                {
                    start: visualBreak.parsedBreak.breakOption.start,
                    end: visualBreak.parsedBreak.breakOption.end
                }
            ]
        };
        payload[axisModel.axis.dim + "AxisIndex"] = axisModel.componentIndex;
        api.dispatchAction(payload);
    });
}
function $377a1d5467eb3e77$var$adjustBreakLabels(axisModel, axisRotation, labelLayoutList) {
    var scaleBreakHelper = (0, $d760dd937396b887$export$e79b20ac82c2d660)();
    if (!scaleBreakHelper) return;
    var breakLabelIndexPairs = scaleBreakHelper.retrieveAxisBreakPairs(labelLayoutList, function(layoutInfo) {
        return layoutInfo && $377a1d5467eb3e77$export$c392b818a26a879e(layoutInfo.label).labelInfo.tick["break"];
    }, true);
    var moveOverlap = axisModel.get([
        "breakLabelLayout",
        "moveOverlap"
    ], true);
    if (moveOverlap === true || moveOverlap === "auto") (0, $43e0a445ed6711da$export$79b2f7037acddd43)(breakLabelIndexPairs, function(idxPair) {
        (0, $6ef64eccf67efcc6$export$c1d9b2cc33e7e5e)().adjustBreakLabelPair(axisModel.axis.inverse, axisRotation, [
            (0, $c7004a764badae25$export$471916f4e89eb5da)(labelLayoutList[idxPair[0]]),
            (0, $c7004a764badae25$export$471916f4e89eb5da)(labelLayoutList[idxPair[1]])
        ]);
    });
}
var $377a1d5467eb3e77$export$2e2bcd8739ae039 = $377a1d5467eb3e77$var$AxisBuilder;



function $ea10c38ae65d6707$export$b3219800bda33a1f(rect, axisModel, opt) {
    opt = opt || {};
    var axis = axisModel.axis;
    var layout = {};
    var otherAxisOnZeroOf = axis.getAxesOnZeroOf()[0];
    var rawAxisPosition = axis.position;
    var axisPosition = otherAxisOnZeroOf ? "onZero" : rawAxisPosition;
    var axisDim = axis.dim;
    var rectBound = [
        rect.x,
        rect.x + rect.width,
        rect.y,
        rect.y + rect.height
    ];
    var idx = {
        left: 0,
        right: 1,
        top: 0,
        bottom: 1,
        onZero: 2
    };
    var axisOffset = axisModel.get("offset") || 0;
    var posBound = axisDim === "x" ? [
        rectBound[2] - axisOffset,
        rectBound[3] + axisOffset
    ] : [
        rectBound[0] - axisOffset,
        rectBound[1] + axisOffset
    ];
    if (otherAxisOnZeroOf) {
        var onZeroCoord = otherAxisOnZeroOf.toGlobalCoord(otherAxisOnZeroOf.dataToCoord(0));
        posBound[idx.onZero] = Math.max(Math.min(onZeroCoord, posBound[1]), posBound[0]);
    }
    // Axis position
    layout.position = [
        axisDim === "y" ? posBound[idx[axisPosition]] : rectBound[0],
        axisDim === "x" ? posBound[idx[axisPosition]] : rectBound[3]
    ];
    // Axis rotation
    layout.rotation = Math.PI / 2 * (axisDim === "x" ? 0 : 1);
    // Tick and label direction, x y is axisDim
    var dirMap = {
        top: -1,
        bottom: 1,
        left: -1,
        right: 1
    };
    layout.labelDirection = layout.tickDirection = layout.nameDirection = dirMap[rawAxisPosition];
    layout.labelOffset = otherAxisOnZeroOf ? posBound[idx[rawAxisPosition]] - posBound[idx.onZero] : 0;
    if (axisModel.get([
        "axisTick",
        "inside"
    ])) layout.tickDirection = -layout.tickDirection;
    if ($43e0a445ed6711da$export$8a4d17b6e8486e66(opt.labelInside, axisModel.get([
        "axisLabel",
        "inside"
    ]))) layout.labelDirection = -layout.labelDirection;
    // Special label rotation
    var labelRotate = axisModel.get([
        "axisLabel",
        "rotate"
    ]);
    layout.labelRotate = axisPosition === "top" ? -labelRotate : labelRotate;
    // Over splitLine and splitArea
    layout.z2 = 1;
    return layout;
}
function $ea10c38ae65d6707$export$1a2a248dbebc52b5(seriesModel) {
    return seriesModel.get("coordinateSystem") === "cartesian2d";
}
function $ea10c38ae65d6707$export$e447722773749af(seriesModel) {
    return seriesModel.coordinateSystem && seriesModel.coordinateSystem.type === "cartesian2d";
}
function $ea10c38ae65d6707$export$8220131ac1d61d28(seriesModel) {
    var axisModelMap = {
        xAxisModel: null,
        yAxisModel: null
    };
    $43e0a445ed6711da$export$79b2f7037acddd43(axisModelMap, function(v, key) {
        var axisType = key.replace(/Model$/, "");
        var axisModel = seriesModel.getReferringComponents(axisType, (0, $87f4a59ac66e0ee6$export$f076738ec84e693c)).models[0];
        axisModelMap[key] = axisModel;
    });
    return axisModelMap;
}
function $ea10c38ae65d6707$export$2b2ce820c3e1e776(gridRect, cartesians, axisModel, api, ctx, defaultNameMoveOverlap) {
    var layoutResult = $ea10c38ae65d6707$export$b3219800bda33a1f(gridRect, axisModel);
    var axisLineAutoShow = false;
    var axisTickAutoShow = false;
    // Not show axisTick or axisLine if other axis is category / time
    for(var i = 0; i < cartesians.length; i++)if ((0, $eb97010bfdf4c825$export$dfc8cd28ed7b22a0)(cartesians[i].getOtherAxis(axisModel.axis).scale)) {
        // Still show axis tick or axisLine if other axis is value / log
        axisLineAutoShow = axisTickAutoShow = true;
        if (axisModel.axis.type === "category" && axisModel.axis.onBand) axisTickAutoShow = false;
    }
    layoutResult.axisLineAutoShow = axisLineAutoShow;
    layoutResult.axisTickAutoShow = axisTickAutoShow;
    layoutResult.defaultNameMoveOverlap = defaultNameMoveOverlap;
    return new (0, $377a1d5467eb3e77$export$2e2bcd8739ae039)(axisModel, api, layoutResult, ctx);
}
function $ea10c38ae65d6707$export$3e8d41f03e1a6a39(axisBuilder, gridRect, axisModel) {
    var newRaw = $ea10c38ae65d6707$export$b3219800bda33a1f(gridRect, axisModel);
    var oldRaw_1;
    axisBuilder.updateCfg(newRaw);
}
function $ea10c38ae65d6707$export$3fa527f4e8efeff2(axis) {
    return axis.dim + "_" + axis.index;
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 








function $fac92a0c12ec6eda$export$a54aa0aabf394e1b(targetAxis, alignToScale) {
    var targetScale = targetAxis.scale;
    var targetAxisModel = targetAxis.model;
    var targetExtentInfo = (0, $0bd809c375c9fffe$export$b9937565663b5dda)(targetScale, targetAxisModel, targetAxisModel.ecModel, targetAxis, null);
    // FIXME:
    //  (1) Axis inverse is not considered yet.
    //  (2) `SCALE_EXTENT_KIND_MAPPING` is not considered yet.
    var isTargetLogScale = (0, $eb97010bfdf4c825$export$8b1d8a59aa13c502)(targetScale);
    var alignToScaleLinear = (0, $eb97010bfdf4c825$export$8b1d8a59aa13c502)(alignToScale) ? alignToScale.intervalStub : alignToScale;
    var targetIntervalStub = isTargetLogScale ? targetScale.intervalStub : targetScale;
    var targetLogScaleBase = targetScale.base;
    var alignToTicks = alignToScaleLinear.getTicks();
    var alignToExpNiceTicks = alignToScaleLinear.getTicks({
        expandToNicedExtent: true
    });
    var alignToSegCount = alignToTicks.length - 1;
    // The Current strategy: Find a proper interval and an extent for the target scale to derive ticks
    // matching exactly to ticks of `alignTo` scale.
    // Adjust min, max based on the extent of alignTo. When min or max is set in alignTo scale
    var t0; // diff ratio on min not-nice segment. 0 <= t0 < 1
    var t1; // diff ratio on max not-nice segment. 0 <= t1 < 1
    var alignToNiceSegCount; // >= 1
    // Consider ticks of `alignTo`, only these cases below may occur:
    if (alignToSegCount === 1) {
        // `alignToTicks` is like:
        //  |--|
        // In this case, we make the corresponding 2 target ticks "nice".
        t0 = t1 = 0;
        alignToNiceSegCount = 1;
    } else if (alignToSegCount === 2) {
        // `alignToTicks` is like:
        //  |-|-----| or
        //  |-----|-| or
        //  |-----|-----|
        // Notices that nice ticks do not necessarily exist in this case.
        // In this case, we choose the larger segment as the "nice segment" and
        // the corresponding target ticks are made "nice".
        var interval0 = (0, $b49750109e236fd8$export$5860c226b237d9a6)(alignToTicks[0].value - alignToTicks[1].value);
        var interval1 = (0, $b49750109e236fd8$export$5860c226b237d9a6)(alignToTicks[1].value - alignToTicks[2].value);
        t0 = t1 = 0;
        if (interval0 === interval1) alignToNiceSegCount = 2;
        else {
            alignToNiceSegCount = 1;
            if (interval0 < interval1) t0 = interval0 / interval1;
            else t1 = interval1 / interval0;
        }
    } else {
        // alignToSegCount >= 3
        // `alignToTicks` is like:
        //  |-|-----|-----|-| or
        //  |-----|-----|-| or
        //  |-|-----|-----| or ...
        // At least one nice segment is present, and not-nice segments are only present on
        // the start and/or the end.
        // In this case, ticks corresponding to nice segments are made "nice".
        var alignToInterval = alignToScaleLinear.getConfig().interval;
        t0 = (1 - (alignToTicks[0].value - alignToExpNiceTicks[0].value) / alignToInterval) % 1;
        t1 = (1 - (alignToExpNiceTicks[alignToSegCount].value - alignToTicks[alignToSegCount].value) / alignToInterval) % 1;
        alignToNiceSegCount = alignToSegCount - (t0 ? 1 : 0) - (t1 ? 1 : 0);
    }
    // NOTE:
    //  Consider a case:
    //    dataZoom controls all Y axes;
    //    dataZoom end is 90% (maxFixed: true, dataZoomFixMinMax[0]: true);
    //    but dataZoom start is 0% (minFixed: false, dataZoomFixMinMax[1]: false);
    //  In this case,
    //    - `Interval#calcNiceTicks` only uses `targetExtentInfo.max` as the upper bound, but expand the
    //      lower bound to a "nice" tick and can get an acceptable result.
    //    - `scaleCalcAlign` has to use both `targetExtentInfo.min/max` as the bounds without any expansion,
    //      otherwise the lower bound may become negative unexpectedly, especially for all positive series data.
    var dataZoomFixMinMax = targetExtentInfo.zoomFixMM;
    var hasDataZoomFixMinMax = dataZoomFixMinMax[0] || dataZoomFixMinMax[1];
    var targetMinMaxFixed = [
        targetExtentInfo.fixMM[0] || hasDataZoomFixMinMax,
        targetExtentInfo.fixMM[1] || hasDataZoomFixMinMax
    ];
    // MEMO: When only `xxxAxis.min` or `xxxAxis.max` is fixed,
    //  - Even a "nice" interval can be calculated, ticks accumulated based on `min`/`max` can be "nice" only if
    //    `min` or `max` is a "nice" number.
    //  - Generating a "nice" interval may cause the extent have both positive and negative ticks, which may be
    //    not preferable for all positive (very common) or all negative series data. But it can be simply resolved
    //    by specifying `xxxAxis.min: 0`/`xxxAxis.max: 0`, so we do not specially handle this case here.
    //  Therefore, we prioritize generating "nice" interval over preventing from crossing zero.
    //  e.g., if series data are all positive and the max data is `11739`,
    //      If setting `yAxis.max: 'dataMax'`, ticks may be like:
    //          `11739, 8739, 5739, 2739, -1739` (not "nice" enough)
    //      If setting `yAxis.max: 'dataMax', yAxis.min: 0`, ticks may be like:
    //          `11739, 8805, 5870, 2935, 0` (not "nice" enough but may be acceptable)
    //      If setting `yAxis.max: 12000, yAxis.min: 0`, ticks may be like:
    //          `12000, 9000, 6000, 3000, 0` ("nice")
    var targetOldOutermostExtent = targetScale.getExtent();
    var targetOldIntervalExtent = targetIntervalStub.getExtent();
    var targetExtent = (0, $eb97010bfdf4c825$export$e279d7ed1695209d)(targetOldIntervalExtent, targetMinMaxFixed);
    var min;
    var max;
    var interval;
    var intervalPrecision;
    var maxNice;
    var minNice;
    function loopIncreaseInterval(cb) {
        // Typically this loop runs less than 5 times. But we still
        // use a fail-safe for future changes.
        var LOOP_MAX = 50;
        var loopGuard = 0;
        for(; loopGuard < LOOP_MAX; loopGuard++){
            if (cb()) break;
            interval = isTargetLogScale ? interval * (0, $b49750109e236fd8$export$2ca8010d037f830f)(targetLogScaleBase, 2) : (0, $eb97010bfdf4c825$export$f39031e8422f329d)(interval);
            intervalPrecision = (0, $eb97010bfdf4c825$export$86a060b060d3d31a)(interval);
        }
    }
    function updateMinFromMinNice() {
        min = (0, $b49750109e236fd8$export$2077e0241d6afd3c)(minNice - interval * t0, intervalPrecision);
    }
    function updateMaxFromMaxNice() {
        max = (0, $b49750109e236fd8$export$2077e0241d6afd3c)(maxNice + interval * t1, intervalPrecision);
    }
    function updateMinNiceFromMinT0Interval() {
        minNice = t0 ? (0, $b49750109e236fd8$export$2077e0241d6afd3c)(min + interval * t0, intervalPrecision) : min;
    }
    function updateMaxNiceFromMaxT1Interval() {
        maxNice = t1 ? (0, $b49750109e236fd8$export$2077e0241d6afd3c)(max - interval * t1, intervalPrecision) : max;
    }
    // NOTE: The new calculated `min`/`max` must NOT shrink the original extent; otherwise some series
    // data may be outside of the extent. They can expand the original extent slightly to align with
    // ticks of `alignTo`. In this case, more blank space is added but visually fine.
    if (targetMinMaxFixed[0] && targetMinMaxFixed[1]) {
        // Both `min` and `max` are specified (via dataZoom or ec option; consider both Cartesian, radar and
        // other possible axes). In this case, "nice" ticks can hardly be calculated, but reasonable ticks should
        // still be calculated whenever possible, especially `intervalPrecision` should be tuned for better
        // appearance and lower cumulative error.
        min = targetExtent[0];
        max = targetExtent[1];
        interval = (max - min) / (alignToNiceSegCount + t0 + t1);
        // Typically axis pixel extent is ready here. See `create` in `Grid.ts`.
        var axisPxExtent = targetAxis.getExtent();
        // NOTICE: this pxSpan may be not accurate yet due to "outerBounds" logic, but acceptable so far.
        var pxSpan = (0, $b49750109e236fd8$export$5860c226b237d9a6)(axisPxExtent[1] - axisPxExtent[0]);
        // We imperically choose `pxDiffAcceptable` as `0.5 / alignToNiceSegCount` for reduce cumulative
        // error, otherwise a discernible misalign (> 1px) may occur.
        // PENDING: We do not find a acceptable precision for LogScale here.
        //  Theoretically it can be addressed but introduce more complexity. Is it necessary?
        intervalPrecision = (0, $b49750109e236fd8$export$de3fddfc2aec84e4)([
            max,
            min
        ], pxSpan, 0.5 / alignToNiceSegCount);
        updateMinNiceFromMinT0Interval();
        updateMaxNiceFromMaxT1Interval();
        if ((0, $b49750109e236fd8$export$b5c30d4208814a65)(intervalPrecision)) interval = (0, $b49750109e236fd8$export$2077e0241d6afd3c)(interval, intervalPrecision);
    } else {
        // Make a minimal enough `interval`, increase it later.
        // It is a similar logic as `IntervalScale#calcNiceTicks` and `LogScale#calcNiceTicks`.
        // Axis break is not supported, which is guranteed by the caller of this function.
        var targetSpan = targetExtent[1] - targetExtent[0];
        interval = isTargetLogScale ? (0, $b49750109e236fd8$export$2ca8010d037f830f)((0, $b49750109e236fd8$export$82dd68b83a44b253)(targetSpan), 1) : (0, $b49750109e236fd8$export$7a695fe44258210b)(targetSpan / alignToNiceSegCount, (0, $b49750109e236fd8$export$492adb595f875f4e));
        intervalPrecision = (0, $eb97010bfdf4c825$export$86a060b060d3d31a)(interval);
        if (targetMinMaxFixed[0]) {
            min = targetExtent[0];
            loopIncreaseInterval(function() {
                updateMinNiceFromMinT0Interval();
                maxNice = (0, $b49750109e236fd8$export$2077e0241d6afd3c)(minNice + interval * alignToNiceSegCount, intervalPrecision);
                updateMaxFromMaxNice();
                if (max >= targetExtent[1]) return true;
            });
        } else if (targetMinMaxFixed[1]) {
            max = targetExtent[1];
            loopIncreaseInterval(function() {
                updateMaxNiceFromMaxT1Interval();
                minNice = (0, $b49750109e236fd8$export$2077e0241d6afd3c)(maxNice - interval * alignToNiceSegCount, intervalPrecision);
                updateMinFromMinNice();
                if (min <= targetExtent[0]) return true;
            });
        } else loopIncreaseInterval(function() {
            minNice = (0, $b49750109e236fd8$export$2077e0241d6afd3c)((0, $b49750109e236fd8$export$cf129980c996e186)(targetExtent[0] / interval) * interval, intervalPrecision);
            maxNice = (0, $b49750109e236fd8$export$2077e0241d6afd3c)((0, $b49750109e236fd8$export$c6301bc99a7f80a7)(targetExtent[1] / interval) * interval, intervalPrecision);
            // NOTE:
            //  - `maxNice - minNice >= -interval` here.
            //  - While `interval` increases, `currIntervalCount` decreases, minimum `-1`.
            var currIntervalCount = (0, $b49750109e236fd8$export$42cacde8c45786ff)((maxNice - minNice) / interval);
            if (currIntervalCount <= alignToNiceSegCount) {
                var moreCount = alignToNiceSegCount - currIntervalCount;
                // Consider cases that negative tick do not make sense (or vice versa), users can simply
                // specify `xxxAxis.min/max: 0` to avoid negative. But we still automatically handle it
                // for some common cases whenever possible:
                //  - When ec option is `xxxAxis.scale: false` (the default), it is usually unexpected if
                //    negative (or positive) ticks are introduced.
                //  - In LogScale, series data are usually either all > 1 or all < 1, rather than both,
                //    that is, logarithm result is typically either all positive or all negative.
                var moreCountPair = void 0;
                var mayEnhanceZero = targetExtentInfo.incl0 || isTargetLogScale;
                // `bounds < 0` or `bounds > 0` may require more complex handling, so we only auto handle
                // `bounds === 0`.
                if (mayEnhanceZero && targetExtent[0] === 0) // 0 has been included in extent and all positive.
                moreCountPair = [
                    0,
                    moreCount
                ];
                else if (mayEnhanceZero && targetExtent[1] === 0) // 0 has been included in extent and all negative.
                moreCountPair = [
                    moreCount,
                    0
                ];
                else {
                    // Try to center ticks in axis space whenever possible, which is especially preferable
                    // in `LogScale`.
                    var lessHalfCount = (0, $b49750109e236fd8$export$c6301bc99a7f80a7)(moreCount / 2);
                    moreCountPair = moreCount % 2 === 0 ? [
                        lessHalfCount,
                        lessHalfCount
                    ] : min + max < targetExtent[0] + targetExtent[1] ? [
                        lessHalfCount,
                        lessHalfCount + 1
                    ] : [
                        lessHalfCount + 1,
                        lessHalfCount
                    ];
                }
                minNice = (0, $b49750109e236fd8$export$2077e0241d6afd3c)(minNice - interval * moreCountPair[0], intervalPrecision);
                maxNice = (0, $b49750109e236fd8$export$2077e0241d6afd3c)(maxNice + interval * moreCountPair[1], intervalPrecision);
                updateMinFromMinNice();
                updateMaxFromMaxNice();
                if (min <= targetExtent[0] && max >= targetExtent[1]) return true;
            }
        });
    }
    (0, $3e6d0d29922ecf90$export$8135db7762247d65)(targetScale, targetMinMaxFixed, targetOldIntervalExtent, [
        min,
        max
    ], targetOldOutermostExtent, {
        // NOTE: Even in LogScale, `interval` should not be in log space.
        interval: interval,
        // Force ticks count, otherwise cumulative error may cause more unexpected ticks to be generated.
        // Though the overlapping tick labels may be auto-ignored, but probably unexpected, e.g., the min
        // tick label is ignored but the secondary min tick label is shown, which is unexpected when
        // `axis.min` is user-specified or dataZoom-specified.
        intervalCount: alignToNiceSegCount,
        intervalPrecision: intervalPrecision,
        niceExtent: [
            minNice,
            maxNice
        ]
    });
}













// margin is [top, right, bottom, left]
var $aa53a27ee8d5b906$var$XY_TO_MARGIN_IDX = [
    [
        3,
        1
    ],
    [
        0,
        2
    ] // xyIdx 1 => 'y'
];
var $aa53a27ee8d5b906$var$Grid = /** @class */ function() {
    function Grid(gridModel, ecModel, api) {
        // FIXME:TS where used (different from registered type 'cartesian2d')?
        this.type = "grid";
        this._coordsMap = {};
        this._coordsList = [];
        this._axesMap = {};
        this._axesList = [];
        this.axisPointerEnabled = true;
        this.dimensions = (0, $20b308fcf70b98d9$export$988a008d2b9120f4);
        this._initCartesian(gridModel, ecModel, api);
        this.model = gridModel;
    }
    Grid.prototype.getRect = function() {
        return this._rect;
    };
    Grid.prototype.update = function(ecModel, api) {
        var axesMap = this._axesMap;
        (0, $43e0a445ed6711da$export$79b2f7037acddd43)(this._axesList, function(axis) {
            (0, $0bd809c375c9fffe$export$113bceb7edf323a4)(axis, (0, $0bd809c375c9fffe$export$c4999badb722a7d7));
            var scale = axis.scale;
            if ((0, $eb97010bfdf4c825$export$61579433626afe87)(scale)) scale.setSortInfo(axis.model.get("categorySortInfo"));
        });
        function updateAxisTicks(axes) {
            // Axis is added in order of axisIndex.
            var axesIndices = (0, $43e0a445ed6711da$export$ed97f33186d4b816)(axes);
            var axisNeedsAlign = [];
            for(var i = axesIndices.length - 1; i >= 0; i--){
                // Reverse order
                var axis = axes[+axesIndices[i]];
                if (axis.__alignTo) axisNeedsAlign.push(axis);
                else (0, $8721c77a801a39b2$export$6aaaea8da7d6b895)(axis);
            }
            (0, $43e0a445ed6711da$export$79b2f7037acddd43)(axisNeedsAlign, function(axis) {
                if ($aa53a27ee8d5b906$var$incapableOfAlignNeedFallback(axis, axis.__alignTo)) (0, $8721c77a801a39b2$export$6aaaea8da7d6b895)(axis);
                else (0, $fac92a0c12ec6eda$export$a54aa0aabf394e1b)(axis, axis.__alignTo.scale);
            });
        }
        updateAxisTicks(axesMap.x);
        updateAxisTicks(axesMap.y);
        // Key: axisDim_axisIndex, value: boolean, whether onZero target.
        var onZeroRecords = {};
        (0, $43e0a445ed6711da$export$79b2f7037acddd43)(axesMap.x, function(xAxis) {
            $aa53a27ee8d5b906$var$fixAxisOnZero(axesMap, "y", xAxis, onZeroRecords);
        });
        (0, $43e0a445ed6711da$export$79b2f7037acddd43)(axesMap.y, function(yAxis) {
            $aa53a27ee8d5b906$var$fixAxisOnZero(axesMap, "x", yAxis, onZeroRecords);
        });
        // Resize again if containLabel is enabled
        // FIXME It may cause getting wrong grid size in data processing stage
        this.resize(this.model, api);
    };
    /**
   * Resize the grid.
   *
   * [NOTE]
   * If both "grid.containLabel/grid.contain" and pixel-required-data-processing (such as, "dataSampling")
   * exist, circular dependency occurs in logic.
   * The final compromised sequence is:
   *  1. Calculate "axis.extent" (pixel extent) and AffineTransform based on only "grid layout options".
   *      Not accurate if "grid.containLabel/grid.contain" is required, but it is a compromise to avoid
   *      circular dependency.
   *  2. Perform "series data processing" (where "dataSampling" requires "axis.extent").
   *  3. Calculate "scale.extent" (data extent) based on "processed series data".
   *  4. Modify "axis.extent" for "grid.containLabel/grid.contain":
   *      4.1. Calculate "axis labels" based on "scale.extent".
   *      4.2. Modify "axis.extent" by the bounding rects of "axis labels and names".
   */ Grid.prototype.resize = function(gridModel, api, beforeDataProcessing) {
        var layoutRef = (0, $826bc4094efae72b$export$5aec1e94f566e59f)(gridModel, api);
        var gridRect = this._rect = (0, $826bc4094efae72b$export$4517a5ca639a7293)(gridModel.getBoxLayoutParams(), layoutRef.refContainer);
        // PENDING: whether to support that if the input `coord` is out of the base coord sys,
        //  do not render anything. At present, the behavior is undefined.
        var axesMap = this._axesMap;
        var coordsList = this._coordsList;
        var optionContainLabel = gridModel.get("containLabel"); // No `.get(, true)` for backward compat.
        // NOTE: The axis pixel extent is also required by some estimation, e.g., in coord sys update stage,
        // bars on 'time'/'value' axis need it to calculate the supplementary scale extent to avoid edge bars
        // overflowing the axis (see `barGrid.ts`). Therefore, axis pixel extent need to be set early, even
        // may not be accurate.
        $aa53a27ee8d5b906$var$updateAllAxisExtentTransByGridRect(axesMap, gridRect);
        if (!beforeDataProcessing) {
            var axisBuilderSharedCtx = $aa53a27ee8d5b906$var$createAxisBiulders(gridRect, coordsList, axesMap, optionContainLabel, api);
            var noPxChange = void 0;
            if (optionContainLabel) {
                if ($aa53a27ee8d5b906$var$legacyLayOutGridByContainLabel) {
                    // console.time('legacyLayOutGridByContainLabel');
                    $aa53a27ee8d5b906$var$legacyLayOutGridByContainLabel(this._axesList, gridRect);
                    $aa53a27ee8d5b906$var$updateAllAxisExtentTransByGridRect(axesMap, gridRect);
                // console.timeEnd('legacyLayOutGridByContainLabel');
                } else noPxChange = $aa53a27ee8d5b906$var$layOutGridByOuterBounds(gridRect.clone(), "axisLabel", null, gridRect, axesMap, axisBuilderSharedCtx, layoutRef);
            } else {
                var _a = $aa53a27ee8d5b906$var$prepareOuterBounds(gridModel, gridRect, layoutRef), outerBoundsRect = _a.outerBoundsRect, parsedOuterBoundsContain = _a.parsedOuterBoundsContain, outerBoundsClamp = _a.outerBoundsClamp;
                if (outerBoundsRect) // console.time('layOutGridByOuterBounds');
                noPxChange = $aa53a27ee8d5b906$var$layOutGridByOuterBounds(outerBoundsRect, parsedOuterBoundsContain, outerBoundsClamp, gridRect, axesMap, axisBuilderSharedCtx, layoutRef);
            }
            // console.time('buildAxesView_determine');
            $aa53a27ee8d5b906$var$createOrUpdateAxesView(gridRect, axesMap, (0, $c897f028bf966826$export$31cba7db0a663292).determine, null, noPxChange, layoutRef);
            // console.timeEnd('buildAxesView_determine');
            (0, $43e0a445ed6711da$export$79b2f7037acddd43)(this._coordsList, function(coord) {
                // Calculate affine matrix to accelerate the data to point transform.
                // If all the axes scales are time or value.
                coord.calcAffineTransform();
            });
        } // End of beforeDataProcessing
    };
    Grid.prototype.getAxis = function(dim, axisIndex) {
        var axesMapOnDim = this._axesMap[dim];
        if (axesMapOnDim != null) return axesMapOnDim[axisIndex || 0];
    };
    Grid.prototype.getAxes = function() {
        return this._axesList.slice();
    };
    Grid.prototype.getCartesian = function(xAxisIndex, yAxisIndex) {
        if (xAxisIndex != null && yAxisIndex != null) {
            var key = "x" + xAxisIndex + "y" + yAxisIndex;
            return this._coordsMap[key];
        }
        if ((0, $43e0a445ed6711da$export$a6cdc56e425d0d0a)(xAxisIndex)) {
            yAxisIndex = xAxisIndex.yAxisIndex;
            xAxisIndex = xAxisIndex.xAxisIndex;
        }
        for(var i = 0, coordList = this._coordsList; i < coordList.length; i++){
            if (coordList[i].getAxis("x").index === xAxisIndex || coordList[i].getAxis("y").index === yAxisIndex) return coordList[i];
        }
    };
    Grid.prototype.getCartesians = function() {
        return this._coordsList.slice();
    };
    /**
   * @implements
   */ Grid.prototype.convertToPixel = function(ecModel, finder, value) {
        var target = this._findConvertTarget(finder);
        return target.cartesian ? target.cartesian.dataToPoint(value) : target.axis ? target.axis.toGlobalCoord(target.axis.dataToCoord(value)) : null;
    };
    /**
   * @implements
   */ Grid.prototype.convertFromPixel = function(ecModel, finder, value) {
        var target = this._findConvertTarget(finder);
        return target.cartesian ? target.cartesian.pointToData(value) : target.axis ? target.axis.coordToData(target.axis.toLocalCoord(value)) : null;
    };
    Grid.prototype._findConvertTarget = function(finder) {
        var seriesModel = finder.seriesModel;
        var xAxisModel = finder.xAxisModel || seriesModel && seriesModel.getReferringComponents("xAxis", (0, $87f4a59ac66e0ee6$export$f076738ec84e693c)).models[0];
        var yAxisModel = finder.yAxisModel || seriesModel && seriesModel.getReferringComponents("yAxis", (0, $87f4a59ac66e0ee6$export$f076738ec84e693c)).models[0];
        var gridModel = finder.gridModel;
        var coordsList = this._coordsList;
        var cartesian;
        var axis;
        if (seriesModel) {
            cartesian = seriesModel.coordinateSystem;
            (0, $43e0a445ed6711da$export$305f7d4e9d4624f2)(coordsList, cartesian) < 0 && (cartesian = null);
        } else if (xAxisModel && yAxisModel) cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
        else if (xAxisModel) axis = this.getAxis("x", xAxisModel.componentIndex);
        else if (yAxisModel) axis = this.getAxis("y", yAxisModel.componentIndex);
        else if (gridModel) {
            var grid = gridModel.coordinateSystem;
            if (grid === this) cartesian = this._coordsList[0];
        }
        return {
            cartesian: cartesian,
            axis: axis
        };
    };
    /**
   * @implements
   */ Grid.prototype.containPoint = function(point) {
        var coord = this._coordsList[0];
        if (coord) return coord.containPoint(point);
    };
    /**
   * Initialize cartesian coordinate systems
   */ Grid.prototype._initCartesian = function(gridModel, ecModel, api) {
        var _this = this;
        var grid = this;
        var axisPositionUsed = {
            left: false,
            right: false,
            top: false,
            bottom: false
        };
        var axesMap = {
            x: {},
            y: {}
        };
        var axesCount = {
            x: 0,
            y: 0
        };
        // Create axis
        ecModel.eachComponent("xAxis", createAxisCreator("x"), this);
        ecModel.eachComponent("yAxis", createAxisCreator("y"), this);
        if (!axesCount.x || !axesCount.y) {
            // Roll back when there no either x or y axis
            this._axesMap = {};
            this._axesList = [];
            return;
        }
        this._axesMap = axesMap;
        // Create cartesian2d
        (0, $43e0a445ed6711da$export$79b2f7037acddd43)(axesMap.x, function(xAxis, xAxisIndex) {
            (0, $43e0a445ed6711da$export$79b2f7037acddd43)(axesMap.y, function(yAxis, yAxisIndex) {
                var key = "x" + xAxisIndex + "y" + yAxisIndex;
                var cartesian = new (0, $20b308fcf70b98d9$export$2e2bcd8739ae039)(key);
                cartesian.master = _this;
                cartesian.model = gridModel;
                _this._coordsMap[key] = cartesian;
                _this._coordsList.push(cartesian);
                cartesian.addAxis(xAxis);
                cartesian.addAxis(yAxis);
            });
        });
        $aa53a27ee8d5b906$var$prepareAlignToInCoordSysCreate(axesMap.x);
        $aa53a27ee8d5b906$var$prepareAlignToInCoordSysCreate(axesMap.y);
        function createAxisCreator(dimName) {
            return function(axisModel, idx) {
                if (!$aa53a27ee8d5b906$var$isAxisUsedInTheGrid(axisModel, gridModel)) return;
                var axisPosition = axisModel.get("position");
                if (dimName === "x") // Fix position
                {
                    if (axisPosition !== "top" && axisPosition !== "bottom") // Default bottom of X
                    axisPosition = axisPositionUsed.bottom ? "top" : "bottom";
                } else // Fix position
                if (axisPosition !== "left" && axisPosition !== "right") // Default left of Y
                axisPosition = axisPositionUsed.left ? "right" : "left";
                axisPositionUsed[axisPosition] = true;
                var axisType = (0, $3e6d0d29922ecf90$export$a0edf4de19b45ee7)(axisModel);
                var axis = new (0, $78e48a0d5d4f5f3e$export$2e2bcd8739ae039)(dimName, (0, $3e6d0d29922ecf90$export$8941c4cacdc8f5a5)(axisModel, axisType, true), [
                    0,
                    0
                ], axisType, axisPosition);
                axis.onBand = (0, $3e6d0d29922ecf90$export$43d51f65881fb080)(axis.scale, axisModel);
                axis.inverse = axisModel.get("inverse");
                // Inject axis into axisModel
                axisModel.axis = axis;
                // Inject axisModel into axis
                axis.model = axisModel;
                // Inject grid info axis
                axis.grid = grid;
                // Index of axis, can be used as key
                axis.index = idx;
                grid._axesList.push(axis);
                axesMap[dimName][idx] = axis;
                axesCount[dimName]++;
            };
        }
    };
    /**
   * @param dim 'x' or 'y' or 'auto' or null/undefined
   */ Grid.prototype.getTooltipAxes = function(dim) {
        var baseAxes = [];
        var otherAxes = [];
        (0, $43e0a445ed6711da$export$79b2f7037acddd43)(this.getCartesians(), function(cartesian) {
            var baseAxis = dim != null && dim !== "auto" ? cartesian.getAxis(dim) : cartesian.getBaseAxis();
            var otherAxis = cartesian.getOtherAxis(baseAxis);
            (0, $43e0a445ed6711da$export$305f7d4e9d4624f2)(baseAxes, baseAxis) < 0 && baseAxes.push(baseAxis);
            (0, $43e0a445ed6711da$export$305f7d4e9d4624f2)(otherAxes, otherAxis) < 0 && otherAxes.push(otherAxis);
        });
        return {
            baseAxes: baseAxes,
            otherAxes: otherAxes
        };
    };
    Grid.create = function(ecModel, api) {
        var grids = [];
        ecModel.eachComponent("grid", function(gridModel, idx) {
            var grid = new Grid(gridModel, ecModel, api);
            grid.name = "grid_" + idx;
            // dataSampling requires axis extent, so resize
            // should be performed in create stage.
            grid.resize(gridModel, api, true);
            gridModel.coordinateSystem = grid;
            grids.push(grid);
            (0, $43e0a445ed6711da$export$79b2f7037acddd43)(grid._axesList, function(axis) {
                (0, $0bd809c375c9fffe$export$710d8a038761b881)(axis, Grid.dimIdxMap);
            });
        });
        // Inject the coordinateSystems into seriesModel
        ecModel.eachSeries(function(seriesModel) {
            var xAxis;
            var yAxis;
            (0, $a30c5e122eaab0a1$export$7ed0c09d4f5c932e)({
                targetModel: seriesModel,
                coordSysType: (0, $01837d90925fb939$export$d0b4e8fdb7a13c60),
                coordSysProvider: coordSysProvider
            });
            function coordSysProvider() {
                var axesModelMap = (0, $ea10c38ae65d6707$export$8220131ac1d61d28)(seriesModel);
                var xAxisModel = axesModelMap.xAxisModel;
                var yAxisModel = axesModelMap.yAxisModel;
                xAxis = xAxisModel.axis;
                yAxis = yAxisModel.axis;
                var gridModel = xAxisModel.getCoordSysModel();
                var grid = gridModel.coordinateSystem;
                return grid.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
            }
            if (xAxis && yAxis) {
                (0, $37f4ae2e6793c3da$export$48507d392d1d4894)(xAxis, seriesModel, (0, $01837d90925fb939$export$d0b4e8fdb7a13c60));
                (0, $37f4ae2e6793c3da$export$48507d392d1d4894)(yAxis, seriesModel, (0, $01837d90925fb939$export$d0b4e8fdb7a13c60));
            }
        }, this);
        return grids;
    };
    // For deciding which dimensions to use when creating list data
    Grid.dimensions = (0, $20b308fcf70b98d9$export$988a008d2b9120f4);
    Grid.dimIdxMap = (0, $b25eb3e4e0d2f900$export$a477f5bebfd07944)((0, $20b308fcf70b98d9$export$988a008d2b9120f4));
    return Grid;
}();
/**
 * Check if the axis is used in the specified grid.
 */ function $aa53a27ee8d5b906$var$isAxisUsedInTheGrid(axisModel, gridModel) {
    return axisModel.getCoordSysModel() === gridModel;
}
function $aa53a27ee8d5b906$var$fixAxisOnZero(axesMap, otherAxisDim, axis, // Key: see `getOnZeroRecordKey`
onZeroRecords) {
    axis.getAxesOnZeroOf = function() {
        // TODO: onZero of multiple axes.
        return otherAxisOnZeroOf ? [
            otherAxisOnZeroOf
        ] : [];
    };
    // onZero can not be enabled in these two situations:
    // 1. When any other axis is a category axis.
    // 2. When no axis is cross 0 point.
    var otherAxes = axesMap[otherAxisDim];
    var otherAxisOnZeroOf;
    var axisModel = axis.model;
    var onZero = axisModel.get([
        "axisLine",
        "onZero"
    ]);
    var onZeroAxisIndex = axisModel.get([
        "axisLine",
        "onZeroAxisIndex"
    ]);
    // For historical reason, ec option `axisLine.onZero: undefined` leads to "not on zero"
    // while leaving `axisLine.onZero` unspecified causes "on zero". This inconsistency goes
    // against common sense, but is preserved for backward compatibility.
    if (!onZero) return;
    // If target axis is specified.
    if (onZeroAxisIndex != null) {
        if ($aa53a27ee8d5b906$var$canOnZeroToAxis(onZero, otherAxes[onZeroAxisIndex])) otherAxisOnZeroOf = otherAxes[onZeroAxisIndex];
    } else {
        // Find the first available other axis.
        for(var idx in otherAxes)if ((0, $43e0a445ed6711da$export$b5a638e9b3fff9f3)(otherAxes, idx) && $aa53a27ee8d5b906$var$canOnZeroToAxis(onZero, otherAxes[idx]) && !onZeroRecords[getOnZeroRecordKey(otherAxes[idx])]) {
            otherAxisOnZeroOf = otherAxes[idx];
            break;
        }
    }
    if (otherAxisOnZeroOf) onZeroRecords[getOnZeroRecordKey(otherAxisOnZeroOf)] = true;
    function getOnZeroRecordKey(axis) {
        return axis.dim + "_" + axis.index;
    }
}
/**
 * CAVEAT: Must not be called before `CoordinateSystem#update` due to `__dontOnMyZero`.
 */ function $aa53a27ee8d5b906$var$canOnZeroToAxis(onZeroOption, axis) {
    if (!axis) return false;
    var scale = axis.scale;
    var kindEffective = (0, $3e6d0d29922ecf90$export$99e0963eefdef8b2)(scale, 0, false);
    var can = axis && axis.type !== "category" && axis.type !== "time" && kindEffective !== (0, $3e6d0d29922ecf90$export$8b1206c1406788fd);
    if (can && onZeroOption === "auto" && (0, $3e6d0d29922ecf90$export$2204fb02f43463b7)(axis)) can = false;
    // falsy value of `onZeroOption` has been handled in the previous logic.
    return can;
}
/**
 * [CAVEAT] This method is called before data processing stage.
 *  Do not rely on any info that is determined afterward.
 */ function $aa53a27ee8d5b906$var$prepareAlignToInCoordSysCreate(axes) {
    // Axis is added in order of axisIndex.
    var axesIndices = (0, $43e0a445ed6711da$export$ed97f33186d4b816)(axes);
    var alignTo;
    var axisNeedsAlign = [];
    for(var i = axesIndices.length - 1; i >= 0; i--){
        // Reverse order
        var axis = axes[+axesIndices[i]];
        if ((0, $eb97010bfdf4c825$export$dfc8cd28ed7b22a0)(axis.scale) && (0, $3e6d0d29922ecf90$export$8094779d9b724f85)(axis.model, axis.type, true) == null) {
            // Request `alignTicks`.
            if (axis.model.get("alignTicks") && axis.model.get("interval") == null) axisNeedsAlign.push(axis);
            else // `alignTo` the last one that does not request `alignTicks`
            // (This rule is retained for backward compat).
            alignTo = axis;
        }
    }
    // If all axes has set alignTicks, pick the first one as alignTo.
    // PENDING. Should we find the axis that both set interval, min, max and align to this one?
    // PENDING. Should we allow specifying alignTo via ec option?
    if (!alignTo) alignTo = axisNeedsAlign.pop();
    if (alignTo) (0, $43e0a445ed6711da$export$79b2f7037acddd43)(axisNeedsAlign, function(axis) {
        axis.__alignTo = alignTo;
    });
}
/**
 * This is just a defence code. They are unlikely to be actually `true`,
 * since these cases have been addressed in `prepareAlignToInCoordSysCreate`.
 *
 * Can not be called BEFORE "nice" performed.
 */ function $aa53a27ee8d5b906$var$incapableOfAlignNeedFallback(targetAxis, alignTo) {
    return (0, $d760dd937396b887$export$fec008222a1db2dc)(targetAxis.scale) || (0, $d760dd937396b887$export$fec008222a1db2dc)(alignTo.scale) || alignTo.scale.getTicks().length < 2;
}
function $aa53a27ee8d5b906$var$updateAxisTransform(axis, coordBase) {
    var axisExtent = axis.getExtent();
    var axisExtentSum = axisExtent[0] + axisExtent[1];
    // Fast transform
    axis.toGlobalCoord = axis.dim === "x" ? function(coord) {
        return coord + coordBase;
    } : function(coord) {
        return axisExtentSum - coord + coordBase;
    };
    axis.toLocalCoord = axis.dim === "x" ? function(coord) {
        return coord - coordBase;
    } : function(coord) {
        return axisExtentSum - coord + coordBase;
    };
}
function $aa53a27ee8d5b906$var$updateAllAxisExtentTransByGridRect(axesMap, gridRect) {
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)(axesMap.x, function(axis) {
        return $aa53a27ee8d5b906$var$updateAxisExtentTransByGridRect(axis, gridRect.x, gridRect.width);
    });
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)(axesMap.y, function(axis) {
        return $aa53a27ee8d5b906$var$updateAxisExtentTransByGridRect(axis, gridRect.y, gridRect.height);
    });
}
function $aa53a27ee8d5b906$var$updateAxisExtentTransByGridRect(axis, gridXY, gridWH) {
    var extent = [
        0,
        gridWH
    ];
    var idx = axis.inverse ? 1 : 0;
    axis.setExtent(extent[idx], extent[1 - idx]);
    $aa53a27ee8d5b906$var$updateAxisTransform(axis, gridXY);
}
var $aa53a27ee8d5b906$var$legacyLayOutGridByContainLabel;
function $aa53a27ee8d5b906$export$9da5287b2e41f334(impl) {
    $aa53a27ee8d5b906$var$legacyLayOutGridByContainLabel = impl;
}
// Return noPxChange.
function $aa53a27ee8d5b906$var$layOutGridByOuterBounds(outerBoundsRect, outerBoundsContain, outerBoundsClamp, gridRect, axesMap, axisBuilderSharedCtx, layoutRef) {
    // Assume `updateAllAxisExtentTransByGridRect` has been performed once before this call.
    // [NOTE]:
    // - The bounding rect of the axis elements might be sensitve to variations in `axis.extent` due to strategies
    //  like hideOverlap/moveOverlap. @see the comment in `LabelLayoutBase['suggestIgnore']`.
    // - The final `gridRect` might be slightly smaller than the ideally expected result if labels are giant and
    //  get hidden due to overlapping. More iterations could improve precision, but not performant. We consider
    //  the current result acceptable, since no alignment among charts can be guaranteed when using this feature.
    $aa53a27ee8d5b906$var$createOrUpdateAxesView(gridRect, axesMap, (0, $c897f028bf966826$export$31cba7db0a663292).estimate, outerBoundsContain, false, layoutRef);
    var margin = [
        0,
        0,
        0,
        0
    ];
    fillLabelNameOverflowOnOneDimension(0);
    fillLabelNameOverflowOnOneDimension(1);
    // If axis is blank, no label can be used to detect overflow.
    // gridRect itself should not overflow.
    fillMarginOnOneDimension(gridRect, 0, NaN);
    fillMarginOnOneDimension(gridRect, 1, NaN);
    var noPxChange = (0, $43e0a445ed6711da$export$71aa6c912b956294)(margin, function(item) {
        return item > 0;
    }) == null;
    (0, $6552edac5ca572b1$export$81ed941fdeb91c7c)(gridRect, margin, true, true, outerBoundsClamp);
    $aa53a27ee8d5b906$var$updateAllAxisExtentTransByGridRect(axesMap, gridRect);
    return noPxChange;
    function fillLabelNameOverflowOnOneDimension(xyIdx) {
        (0, $43e0a445ed6711da$export$79b2f7037acddd43)(axesMap[(0, $6552edac5ca572b1$export$cb4c12294149dd2d)[xyIdx]], function(axis) {
            if (!(0, $3e6d0d29922ecf90$export$75b737736393e03c)(axis.model)) return;
            // FIXME: zr Group.union may wrongly union (0, 0, 0, 0) and not performant.
            // unionRect.union(axis.axisBuilder.group.getBoundingRect());
            // If ussing Group.getBoundingRect to calculate shrink space, it is not strictly accurate when
            // the outermost label is ignored and the secondary label is very long and contribute to the
            // union extension:
            //      -|---|---|---|
            //         1,000,000,000
            // Therefore we calculate them one by one.
            // Also considered axis may be blank or no labels.
            var sharedRecord = axisBuilderSharedCtx.ensureRecord(axis.model);
            var labelInfoList = sharedRecord.labelInfoList;
            if (labelInfoList) for(var idx = 0; idx < labelInfoList.length; idx++){
                var labelInfo = labelInfoList[idx];
                var proportion = axis.scale.normalize((0, $3e6d0d29922ecf90$export$889d2956111fd257)(axis.scale, (0, $377a1d5467eb3e77$export$c392b818a26a879e)(labelInfo.label).labelInfo.tick));
                proportion = xyIdx === 1 ? 1 - proportion : proportion;
                // xAxis use proportion on x, yAxis use proprotion on y, otherwise not.
                fillMarginOnOneDimension(labelInfo.rect, xyIdx, proportion);
                fillMarginOnOneDimension(labelInfo.rect, 1 - xyIdx, NaN);
            }
            var nameLayout = sharedRecord.nameLayout;
            if (nameLayout) {
                var proportion = (0, $3e6d0d29922ecf90$export$c06aa22293dea9d2)(sharedRecord.nameLocation) ? 0.5 : NaN;
                fillMarginOnOneDimension(nameLayout.rect, xyIdx, proportion);
                fillMarginOnOneDimension(nameLayout.rect, 1 - xyIdx, NaN);
            }
        });
    }
    function fillMarginOnOneDimension(itemRect, xyIdx, proportion // NaN mean no use proportion
    ) {
        var overflow1 = outerBoundsRect[(0, $6552edac5ca572b1$export$cb4c12294149dd2d)[xyIdx]] - itemRect[(0, $6552edac5ca572b1$export$cb4c12294149dd2d)[xyIdx]];
        var overflow2 = itemRect[(0, $6552edac5ca572b1$export$a3fe6d967173a3ac)[xyIdx]] + itemRect[(0, $6552edac5ca572b1$export$cb4c12294149dd2d)[xyIdx]] - (outerBoundsRect[(0, $6552edac5ca572b1$export$a3fe6d967173a3ac)[xyIdx]] + outerBoundsRect[(0, $6552edac5ca572b1$export$cb4c12294149dd2d)[xyIdx]]);
        overflow1 = applyProportion(overflow1, 1 - proportion);
        overflow2 = applyProportion(overflow2, proportion);
        var minIdx = $aa53a27ee8d5b906$var$XY_TO_MARGIN_IDX[xyIdx][0];
        var maxIdx = $aa53a27ee8d5b906$var$XY_TO_MARGIN_IDX[xyIdx][1];
        margin[minIdx] = (0, $b49750109e236fd8$export$2ca8010d037f830f)(margin[minIdx], overflow1);
        margin[maxIdx] = (0, $b49750109e236fd8$export$2ca8010d037f830f)(margin[maxIdx], overflow2);
    }
    function applyProportion(overflow, proportion) {
        // proportion is not likely to near zero. If so, give up shrink
        if (overflow > 0 && !(0, $43e0a445ed6711da$export$7d667b9a0c48c975)(proportion) && proportion > 1e-4) overflow /= proportion;
        return overflow;
    }
}
function $aa53a27ee8d5b906$var$createAxisBiulders(gridRect, cartesians, axesMap, optionContainLabel, api) {
    var axisBuilderSharedCtx = new (0, $377a1d5467eb3e77$export$f2e237206f7393f5)($aa53a27ee8d5b906$var$resolveAxisNameOverlapForGrid);
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)(axesMap, function(axisList) {
        return (0, $43e0a445ed6711da$export$79b2f7037acddd43)(axisList, function(axis) {
            if ((0, $3e6d0d29922ecf90$export$75b737736393e03c)(axis.model)) {
                // See `AxisBaseOptionCommon['nameMoveOverlap']`.
                var defaultNameMoveOverlap = !optionContainLabel;
                axis.axisBuilder = (0, $ea10c38ae65d6707$export$2b2ce820c3e1e776)(gridRect, cartesians, axis.model, api, axisBuilderSharedCtx, defaultNameMoveOverlap);
            }
        });
    });
    return axisBuilderSharedCtx;
}
/**
 * Promote the axis-elements-building from "view render" stage to "coordinate system resize" stage.
 * This is aimed to resovle overlap across multiple axes, since currently it's hard to reconcile
 * multiple axes in "view render" stage.
 *
 * [CAUTION] But this promotion assumes that the subsequent "visual mapping" stage does not affect
 * this axis-elements-building; otherwise we have to refactor it again.
 */ function $aa53a27ee8d5b906$var$createOrUpdateAxesView(gridRect, axesMap, kind, outerBoundsContain, noPxChange, layoutRef) {
    var isDetermine = kind === (0, $c897f028bf966826$export$31cba7db0a663292).determine;
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)(axesMap, function(axisList) {
        return (0, $43e0a445ed6711da$export$79b2f7037acddd43)(axisList, function(axis) {
            if ((0, $3e6d0d29922ecf90$export$75b737736393e03c)(axis.model)) {
                (0, $ea10c38ae65d6707$export$3e8d41f03e1a6a39)(axis.axisBuilder, gridRect, axis.model);
                axis.axisBuilder.build(isDetermine ? {
                    axisTickLabelDetermine: true
                } : {
                    axisTickLabelEstimate: true
                }, {
                    noPxChange: noPxChange
                });
            }
        });
    });
    var nameMarginLevelMap = {
        x: 0,
        y: 0
    };
    calcNameMarginLevel(0);
    calcNameMarginLevel(1);
    function calcNameMarginLevel(xyIdx) {
        nameMarginLevelMap[(0, $6552edac5ca572b1$export$cb4c12294149dd2d)[1 - xyIdx]] = gridRect[(0, $6552edac5ca572b1$export$a3fe6d967173a3ac)[xyIdx]] <= layoutRef.refContainer[(0, $6552edac5ca572b1$export$a3fe6d967173a3ac)[xyIdx]] * 0.5 ? 0 : 1 - xyIdx === 1 ? 2 : 1;
    }
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)(axesMap, function(axisList, xy) {
        return (0, $43e0a445ed6711da$export$79b2f7037acddd43)(axisList, function(axis) {
            if ((0, $3e6d0d29922ecf90$export$75b737736393e03c)(axis.model)) {
                if (outerBoundsContain === "all" || isDetermine) // To resolve overlap, `axisName` layout depends on `axisTickLabel` layout result
                // (all of the axes of the same `grid`; consider multiple x or y axes).
                axis.axisBuilder.build({
                    axisName: true
                }, {
                    nameMarginLevel: nameMarginLevelMap[xy]
                });
                if (isDetermine) axis.axisBuilder.build({
                    axisLine: true
                });
            }
        });
    });
}
function $aa53a27ee8d5b906$var$prepareOuterBounds(gridModel, rawGridRect, layoutRef) {
    var outerBoundsRect;
    var optionOuterBoundsMode = gridModel.get("outerBoundsMode", true);
    if (optionOuterBoundsMode === "same") outerBoundsRect = rawGridRect.clone();
    else if (optionOuterBoundsMode == null || optionOuterBoundsMode === "auto") outerBoundsRect = (0, $826bc4094efae72b$export$4517a5ca639a7293)(gridModel.get("outerBounds", true) || (0, $01837d90925fb939$export$57b4bb4ff2a0950c), layoutRef.refContainer);
    else optionOuterBoundsMode;
    var optionOuterBoundsContain = gridModel.get("outerBoundsContain", true);
    var parsedOuterBoundsContain;
    if (optionOuterBoundsContain == null || optionOuterBoundsContain === "auto") parsedOuterBoundsContain = "all";
    else if ((0, $43e0a445ed6711da$export$305f7d4e9d4624f2)([
        "all",
        "axisLabel"
    ], optionOuterBoundsContain) < 0) parsedOuterBoundsContain = "all";
    else parsedOuterBoundsContain = optionOuterBoundsContain;
    var outerBoundsClamp = [
        (0, $b49750109e236fd8$export$6b392db7c2374a1a)((0, $43e0a445ed6711da$export$995e01f2f5c9d030)(gridModel.get("outerBoundsClampWidth", true), (0, $01837d90925fb939$export$e78e6bf4dcc3e485)[0]), rawGridRect.width),
        (0, $b49750109e236fd8$export$6b392db7c2374a1a)((0, $43e0a445ed6711da$export$995e01f2f5c9d030)(gridModel.get("outerBoundsClampHeight", true), (0, $01837d90925fb939$export$e78e6bf4dcc3e485)[1]), rawGridRect.height)
    ];
    return {
        outerBoundsRect: outerBoundsRect,
        parsedOuterBoundsContain: parsedOuterBoundsContain,
        outerBoundsClamp: outerBoundsClamp
    };
}
var $aa53a27ee8d5b906$var$resolveAxisNameOverlapForGrid = function(cfg, ctx, axisModel, nameLayoutInfo, nameMoveDirVec, thisRecord) {
    var perpendicularDim = axisModel.axis.dim === "x" ? "y" : "x";
    (0, $377a1d5467eb3e77$export$7fcb8742f5816cae)(cfg, ctx, axisModel, nameLayoutInfo, nameMoveDirVec, thisRecord);
    // If nameLocation 'center', and there are multiple axes parallel to this axis, do not adjust by
    //  other axes, because the axis name should be close to its axis line as much as possible even
    //  if overlapping; otherwise it might cause misleading.
    // If nameLocation 'center', do not adjust by perpendicular axes, since they are not likely to overlap.
    // If nameLocation 'start'/'end', move name within the same direction to escape overlap with the
    //  perpendicular axes.
    if (!(0, $3e6d0d29922ecf90$export$c06aa22293dea9d2)(cfg.nameLocation)) (0, $43e0a445ed6711da$export$79b2f7037acddd43)(ctx.recordMap[perpendicularDim], function(perpenRecord) {
        // perpendicular axis may be no name.
        if (perpenRecord && perpenRecord.labelInfoList && perpenRecord.dirVec) (0, $377a1d5467eb3e77$export$e033c6449cc6f6a1)(perpenRecord.labelInfoList, perpenRecord.dirVec, nameLayoutInfo, nameMoveDirVec);
    });
};
var $aa53a27ee8d5b906$export$2e2bcd8739ae039 = $aa53a27ee8d5b906$var$Grid;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $00e38f766da9741c$export$bb44f104e3c54dae(ecModel, api) {
    var result = {
        /**
     * key: makeKey(axis.model)
     * value: {
     *      axis,
     *      coordSys,
     *      axisPointerModel,
     *      triggerTooltip,
     *      triggerEmphasis,
     *      involveSeries,
     *      snap,
     *      seriesModels,
     *      seriesDataCount
     * }
     */ axesInfo: {},
        seriesInvolved: false,
        /**
     * key: makeKey(coordSys.model)
     * value: Object: key makeKey(axis.model), value: axisInfo
     */ coordSysAxesInfo: {},
        coordSysMap: {}
    };
    $00e38f766da9741c$var$collectAxesInfo(result, ecModel, api);
    // Check seriesInvolved for performance, in case too many series in some chart.
    result.seriesInvolved && $00e38f766da9741c$var$collectSeriesInfo(result, ecModel);
    return result;
}
function $00e38f766da9741c$var$collectAxesInfo(result, ecModel, api) {
    var globalTooltipModel = ecModel.getComponent("tooltip");
    var globalAxisPointerModel = ecModel.getComponent("axisPointer");
    // links can only be set on global.
    var linksOption = globalAxisPointerModel.get("link", true) || [];
    var linkGroups = [];
    // Collect axes info.
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)(api.getCoordinateSystems(), function(coordSys) {
        // Some coordinate system do not support axes, like geo.
        if (!coordSys.axisPointerEnabled) return;
        var coordSysKey = $00e38f766da9741c$export$d01b444bafb1a792(coordSys.model);
        var axesInfoInCoordSys = result.coordSysAxesInfo[coordSysKey] = {};
        result.coordSysMap[coordSysKey] = coordSys;
        // Set tooltip (like 'cross') is a convenient way to show axisPointer
        // for user. So we enable setting tooltip on coordSys model.
        var coordSysModel = coordSys.model;
        var baseTooltipModel = coordSysModel.getModel("tooltip", globalTooltipModel);
        (0, $43e0a445ed6711da$export$79b2f7037acddd43)(coordSys.getAxes(), (0, $43e0a445ed6711da$export$c3095a23b368d1f2)(saveTooltipAxisInfo, false, null));
        // If axis tooltip used, choose tooltip axis for each coordSys.
        // Notice this case: coordSys is `grid` but not `cartesian2D` here.
        if (coordSys.getTooltipAxes && globalTooltipModel && baseTooltipModel.get("show")) {
            // Compatible with previous logic. But series.tooltip.trigger: 'axis'
            // or series.data[n].tooltip.trigger: 'axis' are not support any more.
            var triggerAxis = baseTooltipModel.get("trigger") === "axis";
            var cross = baseTooltipModel.get([
                "axisPointer",
                "type"
            ]) === "cross";
            var tooltipAxes = coordSys.getTooltipAxes(baseTooltipModel.get([
                "axisPointer",
                "axis"
            ]));
            if (triggerAxis || cross) (0, $43e0a445ed6711da$export$79b2f7037acddd43)(tooltipAxes.baseAxes, (0, $43e0a445ed6711da$export$c3095a23b368d1f2)(saveTooltipAxisInfo, cross ? "cross" : true, triggerAxis));
            if (cross) (0, $43e0a445ed6711da$export$79b2f7037acddd43)(tooltipAxes.otherAxes, (0, $43e0a445ed6711da$export$c3095a23b368d1f2)(saveTooltipAxisInfo, "cross", false));
        }
        // fromTooltip: true | false | 'cross'
        // triggerTooltip: true | false | null
        function saveTooltipAxisInfo(fromTooltip, triggerTooltip, axis) {
            var axisPointerModel = axis.model.getModel("axisPointer", globalAxisPointerModel);
            var axisPointerShow = axisPointerModel.get("show");
            if (!axisPointerShow || axisPointerShow === "auto" && !fromTooltip && !$00e38f766da9741c$var$isHandleTrigger(axisPointerModel)) return;
            if (triggerTooltip == null) triggerTooltip = axisPointerModel.get("triggerTooltip");
            axisPointerModel = fromTooltip ? $00e38f766da9741c$var$makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) : axisPointerModel;
            var snap = axisPointerModel.get("snap");
            var triggerEmphasis = axisPointerModel.get("triggerEmphasis");
            var axisKey = $00e38f766da9741c$export$d01b444bafb1a792(axis.model);
            var involveSeries = triggerTooltip || snap || axis.type === "category";
            // If result.axesInfo[key] exist, override it (tooltip has higher priority).
            var axisInfo = result.axesInfo[axisKey] = {
                key: axisKey,
                axis: axis,
                coordSys: coordSys,
                axisPointerModel: axisPointerModel,
                triggerTooltip: triggerTooltip,
                triggerEmphasis: triggerEmphasis,
                involveSeries: involveSeries,
                snap: snap,
                useHandle: $00e38f766da9741c$var$isHandleTrigger(axisPointerModel),
                seriesModels: [],
                linkGroup: null
            };
            axesInfoInCoordSys[axisKey] = axisInfo;
            result.seriesInvolved = result.seriesInvolved || involveSeries;
            var groupIndex = $00e38f766da9741c$var$getLinkGroupIndex(linksOption, axis);
            if (groupIndex != null) {
                var linkGroup = linkGroups[groupIndex] || (linkGroups[groupIndex] = {
                    axesInfo: {}
                });
                linkGroup.axesInfo[axisKey] = axisInfo;
                linkGroup.mapper = linksOption[groupIndex].mapper;
                axisInfo.linkGroup = linkGroup;
            }
        }
    });
}
function $00e38f766da9741c$var$makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) {
    var tooltipAxisPointerModel = baseTooltipModel.getModel("axisPointer");
    var fields = [
        "type",
        "snap",
        "lineStyle",
        "shadowStyle",
        "label",
        "animation",
        "animationDurationUpdate",
        "animationEasingUpdate",
        "z"
    ];
    var volatileOption = {};
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)(fields, function(field) {
        volatileOption[field] = (0, $43e0a445ed6711da$export$9cd59f9826255e47)(tooltipAxisPointerModel.get(field));
    });
    // category axis do not auto snap, otherwise some tick that do not
    // has value can not be hovered. value/time/log axis default snap if
    // triggered from tooltip and trigger tooltip.
    volatileOption.snap = axis.type !== "category" && !!triggerTooltip;
    // Compatible with previous behavior, tooltip axis does not show label by default.
    // Only these properties can be overridden from tooltip to axisPointer.
    if (tooltipAxisPointerModel.get("type") === "cross") volatileOption.type = "line";
    var labelOption = volatileOption.label || (volatileOption.label = {});
    // Follow the convention, do not show label when triggered by tooltip by default.
    labelOption.show == null && (labelOption.show = false);
    if (fromTooltip === "cross") {
        // When 'cross', both axes show labels.
        var tooltipAxisPointerLabelShow = tooltipAxisPointerModel.get([
            "label",
            "show"
        ]);
        labelOption.show = tooltipAxisPointerLabelShow != null ? tooltipAxisPointerLabelShow : true;
        // If triggerTooltip, this is a base axis, which should better not use cross style
        // (cross style is dashed by default)
        if (!triggerTooltip) {
            var crossStyle = volatileOption.lineStyle = tooltipAxisPointerModel.get("crossStyle");
            crossStyle && (0, $43e0a445ed6711da$export$ebe90cb607ad99e)(labelOption, crossStyle.textStyle);
        }
    }
    return axis.model.getModel("axisPointer", new (0, $279973fc50f77a15$export$2e2bcd8739ae039)(volatileOption, globalAxisPointerModel, ecModel));
}
function $00e38f766da9741c$var$collectSeriesInfo(result, ecModel) {
    // Prepare data for axis trigger
    ecModel.eachSeries(function(seriesModel) {
        // Notice this case: this coordSys is `cartesian2D` but not `grid`.
        var coordSys = seriesModel.coordinateSystem;
        var seriesTooltipTrigger = seriesModel.get([
            "tooltip",
            "trigger"
        ], true);
        var seriesTooltipShow = seriesModel.get([
            "tooltip",
            "show"
        ], true);
        if (!coordSys || !coordSys.model // PENDING: radar do not have a model.
         || seriesTooltipTrigger === "none" || seriesTooltipTrigger === false || seriesTooltipTrigger === "item" || seriesTooltipShow === false || seriesModel.get([
            "axisPointer",
            "show"
        ], true) === false) return;
        (0, $43e0a445ed6711da$export$79b2f7037acddd43)(result.coordSysAxesInfo[$00e38f766da9741c$export$d01b444bafb1a792(coordSys.model)], function(axisInfo) {
            var axis = axisInfo.axis;
            if (coordSys.getAxis(axis.dim) === axis) {
                axisInfo.seriesModels.push(seriesModel);
                axisInfo.seriesDataCount == null && (axisInfo.seriesDataCount = 0);
                axisInfo.seriesDataCount += seriesModel.getData().count();
            }
        });
    });
}
/**
 * For example:
 * {
 *     axisPointer: {
 *         links: [{
 *             xAxisIndex: [2, 4],
 *             yAxisIndex: 'all'
 *         }, {
 *             xAxisId: ['a5', 'a7'],
 *             xAxisName: 'xxx'
 *         }]
 *     }
 * }
 */ function $00e38f766da9741c$var$getLinkGroupIndex(linksOption, axis) {
    var axisModel = axis.model;
    var dim = axis.dim;
    for(var i = 0; i < linksOption.length; i++){
        var linkOption = linksOption[i] || {};
        if ($00e38f766da9741c$var$checkPropInLink(linkOption[dim + "AxisId"], axisModel.id) || $00e38f766da9741c$var$checkPropInLink(linkOption[dim + "AxisIndex"], axisModel.componentIndex) || $00e38f766da9741c$var$checkPropInLink(linkOption[dim + "AxisName"], axisModel.name)) return i;
    }
}
function $00e38f766da9741c$var$checkPropInLink(linkPropValue, axisPropValue) {
    return linkPropValue === "all" || (0, $43e0a445ed6711da$export$43bee75e5e14138e)(linkPropValue) && (0, $43e0a445ed6711da$export$305f7d4e9d4624f2)(linkPropValue, axisPropValue) >= 0 || linkPropValue === axisPropValue;
}
function $00e38f766da9741c$export$f5ea32e3629d8043(axisModel) {
    var axisInfo = $00e38f766da9741c$export$bd39458db76002ab(axisModel);
    if (!axisInfo) return;
    var axisPointerModel = axisInfo.axisPointerModel;
    var scale = axisInfo.axis.scale;
    var option = axisPointerModel.option;
    var status = axisPointerModel.get("status");
    var value = axisPointerModel.get("value");
    // Parse init value for category and time axis.
    if (value != null) value = scale.parse(value);
    var useHandle = $00e38f766da9741c$var$isHandleTrigger(axisPointerModel);
    // If `handle` used, `axisPointer` will always be displayed, so value
    // and status should be initialized.
    if (status == null) option.status = useHandle ? "show" : "hide";
    var extent = scale.getExtent();
    if (// Pick a value on axis when initializing.
    value == null || value > extent[1]) // Make handle displayed on the end of the axis when init, which looks better.
    value = extent[1];
    if (value < extent[0]) value = extent[0];
    option.value = value;
    if (useHandle) option.status = axisInfo.axis.scale.isBlank() ? "hide" : "show";
}
function $00e38f766da9741c$export$bd39458db76002ab(axisModel) {
    var coordSysAxesInfo = (axisModel.ecModel.getComponent("axisPointer") || {}).coordSysAxesInfo;
    return coordSysAxesInfo && coordSysAxesInfo.axesInfo[$00e38f766da9741c$export$d01b444bafb1a792(axisModel)];
}
function $00e38f766da9741c$export$3b06fce3f68b734(axisModel) {
    var axisInfo = $00e38f766da9741c$export$bd39458db76002ab(axisModel);
    return axisInfo && axisInfo.axisPointerModel;
}
function $00e38f766da9741c$var$isHandleTrigger(axisPointerModel) {
    return !!axisPointerModel.get([
        "handle",
        "show"
    ]);
}
function $00e38f766da9741c$export$d01b444bafb1a792(model) {
    return model.type + "||" + model.id;
}



var $6436493435aeada5$var$axisPointerClazz = {};
/**
 * Base class of AxisView.
 */ var $6436493435aeada5$var$AxisView = /** @class */ function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(AxisView, _super);
    function AxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = AxisView.type;
        return _this;
    }
    /**
   * @override
   */ AxisView.prototype.render = function(axisModel, ecModel, api, payload) {
        // FIXME
        // This process should proformed after coordinate systems updated
        // (axis scale updated), and should be performed each time update.
        // So put it here temporarily, although it is not appropriate to
        // put a model-writing procedure in `view`.
        this.axisPointerClass && $00e38f766da9741c$export$f5ea32e3629d8043(axisModel);
        _super.prototype.render.apply(this, arguments);
        this._doUpdateAxisPointerClass(axisModel, api, true);
    };
    /**
   * Action handler.
   */ AxisView.prototype.updateAxisPointer = function(axisModel, ecModel, api, payload) {
        this._doUpdateAxisPointerClass(axisModel, api, false);
    };
    /**
   * @override
   */ AxisView.prototype.remove = function(ecModel, api) {
        var axisPointer = this._axisPointer;
        axisPointer && axisPointer.remove(api);
    };
    /**
   * @override
   */ AxisView.prototype.dispose = function(ecModel, api) {
        this._disposeAxisPointer(api);
        _super.prototype.dispose.apply(this, arguments);
    };
    AxisView.prototype._doUpdateAxisPointerClass = function(axisModel, api, forceRender) {
        var Clazz = AxisView.getAxisPointerClass(this.axisPointerClass);
        if (!Clazz) return;
        var axisPointerModel = $00e38f766da9741c$export$3b06fce3f68b734(axisModel);
        axisPointerModel ? (this._axisPointer || (this._axisPointer = new Clazz())).render(axisModel, axisPointerModel, api, forceRender) : this._disposeAxisPointer(api);
    };
    AxisView.prototype._disposeAxisPointer = function(api) {
        this._axisPointer && this._axisPointer.dispose(api);
        this._axisPointer = null;
    };
    AxisView.registerAxisPointerClass = function(type, clazz) {
        $6436493435aeada5$var$axisPointerClazz[type] = clazz;
    };
    AxisView.getAxisPointerClass = function(type) {
        return type && $6436493435aeada5$var$axisPointerClazz[type];
    };
    AxisView.type = "axis";
    return AxisView;
}((0, $c81700f6bd52c5a7$export$2e2bcd8739ae039));
var $6436493435aeada5$export$2e2bcd8739ae039 = $6436493435aeada5$var$AxisView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $a5c1dd0cc9f4e7d6$var$inner = (0, $87f4a59ac66e0ee6$export$64df9f8d92ae083f)();
function $a5c1dd0cc9f4e7d6$export$c80b7ef1527ec8c9(axisView, axisGroup, axisModel, gridModel) {
    var axis = axisModel.axis;
    if (axis.scale.isBlank()) return;
    var splitAreaModel = axisModel.getModel("splitArea");
    var areaStyleModel = splitAreaModel.getModel("areaStyle");
    var areaColors = areaStyleModel.get("color");
    var gridRect = gridModel.coordinateSystem.getRect();
    var ticksCoords = axis.getTicksCoords({
        tickModel: splitAreaModel,
        breakTicks: "none",
        pruneByBreak: "preserve_extent_bound"
    });
    if (!ticksCoords.length) return;
    // For Making appropriate splitArea animation, the color and anid
    // should be corresponding to previous one if possible.
    var areaColorsLen = areaColors.length;
    var lastSplitAreaColors = $a5c1dd0cc9f4e7d6$var$inner(axisView).splitAreaColors;
    var newSplitAreaColors = $43e0a445ed6711da$export$55f8aa7ef875b0a4();
    var colorIndex = 0;
    if (lastSplitAreaColors) for(var i = 0; i < ticksCoords.length; i++){
        var cIndex = lastSplitAreaColors.get(ticksCoords[i].tickValue);
        if (cIndex != null) {
            colorIndex = (cIndex + (areaColorsLen - 1) * i) % areaColorsLen;
            break;
        }
    }
    var prev = axis.toGlobalCoord(ticksCoords[0].coord);
    var areaStyle = areaStyleModel.getAreaStyle();
    areaColors = $43e0a445ed6711da$export$43bee75e5e14138e(areaColors) ? areaColors : [
        areaColors
    ];
    for(var i = 1; i < ticksCoords.length; i++){
        var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
        var x = void 0;
        var y = void 0;
        var width = void 0;
        var height = void 0;
        if (axis.isHorizontal()) {
            x = prev;
            y = gridRect.y;
            width = tickCoord - x;
            height = gridRect.height;
            prev = x + width;
        } else {
            x = gridRect.x;
            y = prev;
            width = gridRect.width;
            height = tickCoord - y;
            prev = y + height;
        }
        var tickValue = ticksCoords[i - 1].tickValue;
        tickValue != null && newSplitAreaColors.set(tickValue, colorIndex);
        axisGroup.add(new $42ed508a93973e78$export$2e2bcd8739ae039({
            anid: tickValue != null ? "area_" + tickValue : null,
            shape: {
                x: x,
                y: y,
                width: width,
                height: height
            },
            style: $43e0a445ed6711da$export$ebe90cb607ad99e({
                fill: areaColors[colorIndex]
            }, areaStyle),
            autoBatch: true,
            silent: true
        }));
        colorIndex = (colorIndex + 1) % areaColorsLen;
    }
    $a5c1dd0cc9f4e7d6$var$inner(axisView).splitAreaColors = newSplitAreaColors;
}
function $a5c1dd0cc9f4e7d6$export$48ebf2d6ce8ad076(axisView) {
    $a5c1dd0cc9f4e7d6$var$inner(axisView).splitAreaColors = null;
}




var $39f721b0dcbdb9db$var$selfBuilderAttrs = [
    "splitArea",
    "splitLine",
    "minorSplitLine",
    "breakArea"
];
var $39f721b0dcbdb9db$var$CartesianAxisView = /** @class */ function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(CartesianAxisView, _super);
    function CartesianAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CartesianAxisView.type;
        _this.axisPointerClass = "CartesianAxisPointer";
        return _this;
    }
    /**
   * @override
   */ CartesianAxisView.prototype.render = function(axisModel, ecModel, api, payload) {
        this.group.removeAll();
        var oldAxisGroup = this._axisGroup;
        this._axisGroup = new $a8978f7a0e842e3d$export$2e2bcd8739ae039();
        this.group.add(this._axisGroup);
        if (!(0, $3e6d0d29922ecf90$export$75b737736393e03c)(axisModel)) return;
        this._axisGroup.add(axisModel.axis.axisBuilder.group);
        $43e0a445ed6711da$export$79b2f7037acddd43($39f721b0dcbdb9db$var$selfBuilderAttrs, function(name) {
            if (axisModel.get([
                name,
                "show"
            ])) $39f721b0dcbdb9db$var$axisElementBuilders[name](this, this._axisGroup, axisModel, axisModel.getCoordSysModel(), api);
        }, this);
        // THIS is a special case for bar racing chart.
        // Update the axis label from the natural initial layout to
        // sorted layout should has no animation.
        var isInitialSortFromBarRacing = payload && payload.type === "changeAxisOrder" && payload.isInitSort;
        if (!isInitialSortFromBarRacing) $6552edac5ca572b1$export$64fcab7860c216ae(oldAxisGroup, this._axisGroup, axisModel);
        _super.prototype.render.call(this, axisModel, ecModel, api, payload);
    };
    CartesianAxisView.prototype.remove = function() {
        (0, $a5c1dd0cc9f4e7d6$export$48ebf2d6ce8ad076)(this);
    };
    CartesianAxisView.type = "cartesianAxis";
    return CartesianAxisView;
}((0, $6436493435aeada5$export$2e2bcd8739ae039));
var $39f721b0dcbdb9db$var$axisElementBuilders = {
    splitLine: function(axisView, axisGroup, axisModel, gridModel, api) {
        var axis = axisModel.axis;
        if (axis.scale.isBlank()) return;
        var splitLineModel = axisModel.getModel("splitLine");
        var lineStyleModel = splitLineModel.getModel("lineStyle");
        var lineColors = lineStyleModel.get("color");
        var showMinLine = splitLineModel.get("showMinLine") !== false;
        var showMaxLine = splitLineModel.get("showMaxLine") !== false;
        lineColors = $43e0a445ed6711da$export$43bee75e5e14138e(lineColors) ? lineColors : [
            lineColors
        ];
        var gridRect = gridModel.coordinateSystem.getRect();
        var isHorizontal = axis.isHorizontal();
        var lineCount = 0;
        var ticksCoords = axis.getTicksCoords({
            tickModel: splitLineModel,
            breakTicks: "none",
            pruneByBreak: "preserve_extent_bound"
        });
        var p1 = [];
        var p2 = [];
        var lineStyle = lineStyleModel.getLineStyle();
        for(var i = 0; i < ticksCoords.length; i++){
            var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
            if (i === 0 && !showMinLine || i === ticksCoords.length - 1 && !showMaxLine) continue;
            var tickValue = ticksCoords[i].tickValue;
            if (isHorizontal) {
                p1[0] = tickCoord;
                p1[1] = gridRect.y;
                p2[0] = tickCoord;
                p2[1] = gridRect.y + gridRect.height;
            } else {
                p1[0] = gridRect.x;
                p1[1] = tickCoord;
                p2[0] = gridRect.x + gridRect.width;
                p2[1] = tickCoord;
            }
            var colorIndex = lineCount++ % lineColors.length;
            var line = new $0e0ee2afac2bc66d$export$2e2bcd8739ae039({
                anid: tickValue != null ? "line_" + tickValue : null,
                autoBatch: true,
                shape: {
                    x1: p1[0],
                    y1: p1[1],
                    x2: p2[0],
                    y2: p2[1]
                },
                style: $43e0a445ed6711da$export$ebe90cb607ad99e({
                    stroke: lineColors[colorIndex]
                }, lineStyle),
                silent: true
            });
            $6552edac5ca572b1$export$8b4b620d7f4aad1b(line.shape, lineStyle.lineWidth);
            axisGroup.add(line);
        }
    },
    minorSplitLine: function(axisView, axisGroup, axisModel, gridModel, api) {
        var axis = axisModel.axis;
        var minorSplitLineModel = axisModel.getModel("minorSplitLine");
        var lineStyleModel = minorSplitLineModel.getModel("lineStyle");
        var gridRect = gridModel.coordinateSystem.getRect();
        var isHorizontal = axis.isHorizontal();
        var minorTicksCoords = axis.getMinorTicksCoords();
        if (!minorTicksCoords.length) return;
        var p1 = [];
        var p2 = [];
        var lineStyle = lineStyleModel.getLineStyle();
        for(var i = 0; i < minorTicksCoords.length; i++)for(var k = 0; k < minorTicksCoords[i].length; k++){
            var tickCoord = axis.toGlobalCoord(minorTicksCoords[i][k].coord);
            if (isHorizontal) {
                p1[0] = tickCoord;
                p1[1] = gridRect.y;
                p2[0] = tickCoord;
                p2[1] = gridRect.y + gridRect.height;
            } else {
                p1[0] = gridRect.x;
                p1[1] = tickCoord;
                p2[0] = gridRect.x + gridRect.width;
                p2[1] = tickCoord;
            }
            var line = new $0e0ee2afac2bc66d$export$2e2bcd8739ae039({
                anid: "minor_line_" + minorTicksCoords[i][k].tickValue,
                autoBatch: true,
                shape: {
                    x1: p1[0],
                    y1: p1[1],
                    x2: p2[0],
                    y2: p2[1]
                },
                style: lineStyle,
                silent: true
            });
            $6552edac5ca572b1$export$8b4b620d7f4aad1b(line.shape, lineStyle.lineWidth);
            axisGroup.add(line);
        }
    },
    splitArea: function(axisView, axisGroup, axisModel, gridModel, api) {
        (0, $a5c1dd0cc9f4e7d6$export$c80b7ef1527ec8c9)(axisView, axisGroup, axisModel, gridModel);
    },
    breakArea: function(axisView, axisGroup, axisModel, gridModel, api) {
        var axisBreakHelper = (0, $6ef64eccf67efcc6$export$c1d9b2cc33e7e5e)();
        var scale = axisModel.axis.scale;
        if (axisBreakHelper && scale.type !== "ordinal") axisBreakHelper.rectCoordBuildBreakAxis(axisGroup, axisView, axisModel, gridModel.coordinateSystem.getRect(), api);
    }
};
var $39f721b0dcbdb9db$export$b6d40cd875b8a1c8 = /** @class */ function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(CartesianXAxisView, _super);
    function CartesianXAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CartesianXAxisView.type;
        return _this;
    }
    CartesianXAxisView.type = "xAxis";
    return CartesianXAxisView;
}($39f721b0dcbdb9db$var$CartesianAxisView);
var $39f721b0dcbdb9db$export$417e1bdd0616e0dc = /** @class */ function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(CartesianYAxisView, _super);
    function CartesianYAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = $39f721b0dcbdb9db$export$b6d40cd875b8a1c8.type;
        return _this;
    }
    CartesianYAxisView.type = "yAxis";
    return CartesianYAxisView;
}($39f721b0dcbdb9db$var$CartesianAxisView);
var $39f721b0dcbdb9db$export$2e2bcd8739ae039 = $39f721b0dcbdb9db$var$CartesianAxisView;


// Grid view
var $86f0ec3924072a02$var$GridView = /** @class */ function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(GridView, _super);
    function GridView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = "grid";
        return _this;
    }
    GridView.prototype.render = function(gridModel, ecModel) {
        this.group.removeAll();
        if (gridModel.get("show")) this.group.add(new (0, $42ed508a93973e78$export$2e2bcd8739ae039)({
            shape: gridModel.coordinateSystem.getRect(),
            style: (0, $43e0a445ed6711da$export$ebe90cb607ad99e)({
                fill: gridModel.get("backgroundColor")
            }, gridModel.getItemStyle()),
            silent: true,
            z2: -1
        }));
    };
    GridView.type = "grid";
    return GridView;
}((0, $c81700f6bd52c5a7$export$2e2bcd8739ae039));
var $86f0ec3924072a02$var$extraOption = {
    // gridIndex: 0,
    // gridId: '',
    offset: 0
};
function $86f0ec3924072a02$export$4b3e715f166fdd78(registers) {
    registers.registerComponentView($86f0ec3924072a02$var$GridView);
    registers.registerComponentModel((0, $01837d90925fb939$export$2e2bcd8739ae039));
    registers.registerCoordinateSystem("cartesian2d", (0, $aa53a27ee8d5b906$export$2e2bcd8739ae039));
    (0, $0aad7c25257f2936$export$2e2bcd8739ae039)(registers, "x", (0, $dd4d3cff2e5a37aa$export$483dc37e6ad83a3c), $86f0ec3924072a02$var$extraOption);
    (0, $0aad7c25257f2936$export$2e2bcd8739ae039)(registers, "y", (0, $dd4d3cff2e5a37aa$export$483dc37e6ad83a3c), $86f0ec3924072a02$var$extraOption);
    registers.registerComponentView((0, $39f721b0dcbdb9db$export$b6d40cd875b8a1c8));
    registers.registerComponentView((0, $39f721b0dcbdb9db$export$417e1bdd0616e0dc));
    registers.registerPreprocessor(function(option) {
        // Only create grid when need
        if (option.xAxis && option.yAxis && !option.grid) option.grid = {};
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






var $9fa45239c23b4ed1$var$inner = (0, $87f4a59ac66e0ee6$export$64df9f8d92ae083f)();
var $9fa45239c23b4ed1$var$clone = $43e0a445ed6711da$export$9cd59f9826255e47;
var $9fa45239c23b4ed1$var$bind = $43e0a445ed6711da$export$2385a24977818dd0;
/**
 * Base axis pointer class in 2D.
 */ var $9fa45239c23b4ed1$var$BaseAxisPointer = /** @class */ function() {
    function BaseAxisPointer() {
        this._dragging = false;
        /**
     * In px, arbitrary value. Do not set too small,
     * no animation is ok for most cases.
     */ this.animationThreshold = 15;
    }
    /**
   * @implement
   */ BaseAxisPointer.prototype.render = function(axisModel, axisPointerModel, api, forceRender) {
        var value = axisPointerModel.get("value");
        var status = axisPointerModel.get("status");
        // Bind them to `this`, not in closure, otherwise they will not
        // be replaced when user calling setOption in not merge mode.
        this._axisModel = axisModel;
        this._axisPointerModel = axisPointerModel;
        this._api = api;
        // Optimize: `render` will be called repeatedly during mouse move.
        // So it is power consuming if performing `render` each time,
        // especially on mobile device.
        if (!forceRender && this._lastValue === value && this._lastStatus === status) return;
        this._lastValue = value;
        this._lastStatus = status;
        var group = this._group;
        var handle = this._handle;
        if (!status || status === "hide") {
            // Do not clear here, for animation better.
            group && group.hide();
            handle && handle.hide();
            return;
        }
        group && group.show();
        handle && handle.show();
        // Otherwise status is 'show'
        var elOption = {};
        this.makeElOption(elOption, value, axisModel, axisPointerModel, api);
        // Enable change axis pointer type.
        var graphicKey = elOption.graphicKey;
        if (graphicKey !== this._lastGraphicKey) this.clear(api);
        this._lastGraphicKey = graphicKey;
        var moveAnimation = this._moveAnimation = this.determineAnimation(axisModel, axisPointerModel);
        if (!group) {
            group = this._group = new $6552edac5ca572b1$exports.Group();
            this.createPointerEl(group, elOption, axisModel, axisPointerModel);
            this.createLabelEl(group, elOption, axisModel, axisPointerModel);
            api.getZr().add(group);
        } else {
            var doUpdateProps = $43e0a445ed6711da$export$c3095a23b368d1f2($9fa45239c23b4ed1$var$updateProps, axisPointerModel, moveAnimation);
            this.updatePointerEl(group, elOption, doUpdateProps);
            this.updateLabelEl(group, elOption, doUpdateProps, axisPointerModel);
        }
        $9fa45239c23b4ed1$var$updateMandatoryProps(group, axisPointerModel, true);
        this._renderHandle(value);
    };
    /**
   * @implement
   */ BaseAxisPointer.prototype.remove = function(api) {
        this.clear(api);
    };
    /**
   * @implement
   */ BaseAxisPointer.prototype.dispose = function(api) {
        this.clear(api);
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.determineAnimation = function(axisModel, axisPointerModel) {
        var animation = axisPointerModel.get("animation");
        var axis = axisModel.axis;
        var isCategoryAxis = axis.type === "category";
        var useSnap = axisPointerModel.get("snap");
        // Value axis without snap always do not snap.
        if (!useSnap && !isCategoryAxis) return false;
        if (animation === "auto" || animation == null) {
            var animationThreshold = this.animationThreshold;
            if (isCategoryAxis && (0, $8c5e7e1639db3579$export$141021262b29d96e)(axis).w > animationThreshold) return true;
            // It is important to auto animation when snap used. Consider if there is
            // a dataZoom, animation will be disabled when too many points exist, while
            // it will be enabled for better visual effect when little points exist.
            if (useSnap) {
                var seriesDataCount = $00e38f766da9741c$export$bd39458db76002ab(axisModel).seriesDataCount;
                var axisExtent = axis.getExtent();
                // Approximate band width
                return Math.abs(axisExtent[0] - axisExtent[1]) / seriesDataCount > animationThreshold;
            }
            return false;
        }
        return animation === true;
    };
    /**
   * add {pointer, label, graphicKey} to elOption
   * @protected
   */ BaseAxisPointer.prototype.makeElOption = function(elOption, value, axisModel, axisPointerModel, api) {
    // Should be implemented by sub-class.
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.createPointerEl = function(group, elOption, axisModel, axisPointerModel) {
        var pointerOption = elOption.pointer;
        if (pointerOption) {
            var pointerEl = $9fa45239c23b4ed1$var$inner(group).pointerEl = new $6552edac5ca572b1$exports[pointerOption.type]($9fa45239c23b4ed1$var$clone(elOption.pointer));
            group.add(pointerEl);
        }
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.createLabelEl = function(group, elOption, axisModel, axisPointerModel) {
        if (elOption.label) {
            var labelEl = $9fa45239c23b4ed1$var$inner(group).labelEl = new $6552edac5ca572b1$exports.Text($9fa45239c23b4ed1$var$clone(elOption.label));
            group.add(labelEl);
            $9fa45239c23b4ed1$var$updateLabelShowHide(labelEl, axisPointerModel);
        }
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.updatePointerEl = function(group, elOption, updateProps) {
        var pointerEl = $9fa45239c23b4ed1$var$inner(group).pointerEl;
        if (pointerEl && elOption.pointer) {
            pointerEl.setStyle(elOption.pointer.style);
            updateProps(pointerEl, {
                shape: elOption.pointer.shape
            });
        }
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.updateLabelEl = function(group, elOption, updateProps, axisPointerModel) {
        var labelEl = $9fa45239c23b4ed1$var$inner(group).labelEl;
        if (labelEl) {
            labelEl.setStyle(elOption.label.style);
            updateProps(labelEl, {
                // Consider text length change in vertical axis, animation should
                // be used on shape, otherwise the effect will be weird.
                // TODOTODO
                // shape: elOption.label.shape,
                x: elOption.label.x,
                y: elOption.label.y
            });
            $9fa45239c23b4ed1$var$updateLabelShowHide(labelEl, axisPointerModel);
        }
    };
    /**
   * @private
   */ BaseAxisPointer.prototype._renderHandle = function(value) {
        if (this._dragging || !this.updateHandleTransform) return;
        var axisPointerModel = this._axisPointerModel;
        var zr = this._api.getZr();
        var handle = this._handle;
        var handleModel = axisPointerModel.getModel("handle");
        var status = axisPointerModel.get("status");
        if (!handleModel.get("show") || !status || status === "hide") {
            handle && zr.remove(handle);
            this._handle = null;
            return;
        }
        var isInit;
        if (!this._handle) {
            isInit = true;
            handle = this._handle = $6552edac5ca572b1$exports.createIcon(handleModel.get("icon"), {
                cursor: "move",
                draggable: true,
                onmousemove: function(e) {
                    // For mobile device, prevent screen slider on the button.
                    $e48a660b5a6fd3cb$export$fa6813432f753b0d(e.event);
                },
                onmousedown: $9fa45239c23b4ed1$var$bind(this._onHandleDragMove, this, 0, 0),
                drift: $9fa45239c23b4ed1$var$bind(this._onHandleDragMove, this),
                ondragend: $9fa45239c23b4ed1$var$bind(this._onHandleDragEnd, this)
            });
            zr.add(handle);
        }
        $9fa45239c23b4ed1$var$updateMandatoryProps(handle, axisPointerModel, false);
        // update style
        handle.setStyle(handleModel.getItemStyle(null, [
            "color",
            "borderColor",
            "borderWidth",
            "opacity",
            "shadowColor",
            "shadowBlur",
            "shadowOffsetX",
            "shadowOffsetY"
        ]));
        // update position
        var handleSize = handleModel.get("size");
        if (!$43e0a445ed6711da$export$43bee75e5e14138e(handleSize)) handleSize = [
            handleSize,
            handleSize
        ];
        handle.scaleX = handleSize[0] / 2;
        handle.scaleY = handleSize[1] / 2;
        $3a03c388017fa83a$export$958e3e1a02eac4b6(this, "_doDispatchAxisPointer", handleModel.get("throttle") || 0, "fixRate");
        this._moveHandleToValue(value, isInit);
    };
    BaseAxisPointer.prototype._moveHandleToValue = function(value, isInit) {
        $9fa45239c23b4ed1$var$updateProps(this._axisPointerModel, !isInit && this._moveAnimation, this._handle, $9fa45239c23b4ed1$var$getHandleTransProps(this.getHandleTransform(value, this._axisModel, this._axisPointerModel)));
    };
    BaseAxisPointer.prototype._onHandleDragMove = function(dx, dy) {
        var handle = this._handle;
        if (!handle) return;
        this._dragging = true;
        // Persistent for throttle.
        var trans = this.updateHandleTransform($9fa45239c23b4ed1$var$getHandleTransProps(handle), [
            dx,
            dy
        ], this._axisModel, this._axisPointerModel);
        this._payloadInfo = trans;
        handle.stopAnimation();
        handle.attr($9fa45239c23b4ed1$var$getHandleTransProps(trans));
        $9fa45239c23b4ed1$var$inner(handle).lastProp = null;
        this._doDispatchAxisPointer();
    };
    /**
   * Throttled method.
   */ BaseAxisPointer.prototype._doDispatchAxisPointer = function() {
        var handle = this._handle;
        if (!handle) return;
        var payloadInfo = this._payloadInfo;
        var axisModel = this._axisModel;
        this._api.dispatchAction({
            type: "updateAxisPointer",
            x: payloadInfo.cursorPoint[0],
            y: payloadInfo.cursorPoint[1],
            tooltipOption: payloadInfo.tooltipOption,
            axesInfo: [
                {
                    axisDim: axisModel.axis.dim,
                    axisIndex: axisModel.componentIndex
                }
            ]
        });
    };
    BaseAxisPointer.prototype._onHandleDragEnd = function() {
        this._dragging = false;
        var handle = this._handle;
        if (!handle) return;
        var value = this._axisPointerModel.get("value");
        // Consider snap or categroy axis, handle may be not consistent with
        // axisPointer. So move handle to align the exact value position when
        // drag ended.
        this._moveHandleToValue(value);
        // For the effect: tooltip will be shown when finger holding on handle
        // button, and will be hidden after finger left handle button.
        this._api.dispatchAction({
            type: "hideTip"
        });
    };
    /**
   * @private
   */ BaseAxisPointer.prototype.clear = function(api) {
        this._lastValue = null;
        this._lastStatus = null;
        var zr = api.getZr();
        var group = this._group;
        var handle = this._handle;
        if (zr && group) {
            this._lastGraphicKey = null;
            group && zr.remove(group);
            handle && zr.remove(handle);
            this._group = null;
            this._handle = null;
            this._payloadInfo = null;
        }
        $3a03c388017fa83a$export$42ffd38884aecdac(this, "_doDispatchAxisPointer");
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.doClear = function() {
    // Implemented by sub-class if necessary.
    };
    BaseAxisPointer.prototype.buildLabel = function(xy, wh, xDimIndex) {
        xDimIndex = xDimIndex || 0;
        return {
            x: xy[xDimIndex],
            y: xy[1 - xDimIndex],
            width: wh[xDimIndex],
            height: wh[1 - xDimIndex]
        };
    };
    return BaseAxisPointer;
}();
function $9fa45239c23b4ed1$var$updateProps(animationModel, moveAnimation, el, props) {
    // Animation optimize.
    if (!$9fa45239c23b4ed1$var$propsEqual($9fa45239c23b4ed1$var$inner(el).lastProp, props)) {
        $9fa45239c23b4ed1$var$inner(el).lastProp = props;
        moveAnimation ? $6552edac5ca572b1$exports.updateProps(el, props, animationModel) : (el.stopAnimation(), el.attr(props));
    }
}
function $9fa45239c23b4ed1$var$propsEqual(lastProps, newProps) {
    if ($43e0a445ed6711da$export$a6cdc56e425d0d0a(lastProps) && $43e0a445ed6711da$export$a6cdc56e425d0d0a(newProps)) {
        var equals_1 = true;
        $43e0a445ed6711da$export$79b2f7037acddd43(newProps, function(item, key) {
            equals_1 = equals_1 && $9fa45239c23b4ed1$var$propsEqual(lastProps[key], item);
        });
        return !!equals_1;
    } else return lastProps === newProps;
}
function $9fa45239c23b4ed1$var$updateLabelShowHide(labelEl, axisPointerModel) {
    labelEl[axisPointerModel.get([
        "label",
        "show"
    ]) ? "show" : "hide"]();
}
function $9fa45239c23b4ed1$var$getHandleTransProps(trans) {
    return {
        x: trans.x || 0,
        y: trans.y || 0,
        rotation: trans.rotation || 0
    };
}
function $9fa45239c23b4ed1$var$updateMandatoryProps(group, axisPointerModel, silent) {
    var z = axisPointerModel.get("z");
    var zlevel = axisPointerModel.get("zlevel");
    group && group.traverse(function(el) {
        if (el.type !== "group") {
            z != null && (el.z = z);
            zlevel != null && (el.zlevel = zlevel);
            el.silent = silent;
        }
    });
}
var $9fa45239c23b4ed1$export$2e2bcd8739ae039 = $9fa45239c23b4ed1$var$BaseAxisPointer;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 









function $34f90d1e7121e565$export$b7fe459c7cc50060(axisPointerModel) {
    var axisPointerType = axisPointerModel.get("type");
    var styleModel = axisPointerModel.getModel(axisPointerType + "Style");
    var style;
    if (axisPointerType === "line") {
        style = styleModel.getLineStyle();
        style.fill = null;
    } else if (axisPointerType === "shadow") {
        style = styleModel.getAreaStyle();
        style.stroke = null;
    }
    return style;
}
function $34f90d1e7121e565$export$8206a9937c45910f(elOption, axisModel, axisPointerModel, api, labelPos) {
    var value = axisPointerModel.get("value");
    var text = $34f90d1e7121e565$export$7cffee0f9aed39d0(value, axisModel.axis, axisModel.ecModel, axisPointerModel.get("seriesDataIndices"), {
        precision: axisPointerModel.get([
            "label",
            "precision"
        ]),
        formatter: axisPointerModel.get([
            "label",
            "formatter"
        ])
    });
    var labelModel = axisPointerModel.getModel("label");
    var paddings = $78c2ece6dfa6bb7a$export$f3a38102c49f4268(labelModel.get("padding") || 0);
    var font = labelModel.getFont();
    var textRect = $67e15a06bdb46d49$export$c381147bfed79d9f(text, font);
    var position = labelPos.position;
    var width = textRect.width + paddings[1] + paddings[3];
    var height = textRect.height + paddings[0] + paddings[2];
    // Adjust by align.
    var align = labelPos.align;
    align === "right" && (position[0] -= width);
    align === "center" && (position[0] -= width / 2);
    var verticalAlign = labelPos.verticalAlign;
    verticalAlign === "bottom" && (position[1] -= height);
    verticalAlign === "middle" && (position[1] -= height / 2);
    // Not overflow ec container
    $34f90d1e7121e565$var$confineInContainer(position, width, height, api);
    var bgColor = labelModel.get("backgroundColor");
    if (!bgColor || bgColor === "auto") bgColor = axisModel.get([
        "axisLine",
        "lineStyle",
        "color"
    ]);
    elOption.label = {
        // shape: {x: 0, y: 0, width: width, height: height, r: labelModel.get('borderRadius')},
        x: position[0],
        y: position[1],
        style: (0, $6556fe1ed9fb479d$export$f8998c3d0a13de59)(labelModel, {
            text: text,
            font: font,
            fill: labelModel.getTextColor(),
            padding: paddings,
            backgroundColor: bgColor
        }),
        // Label should be over axisPointer.
        z2: 10
    };
}
// Do not overflow ec container
function $34f90d1e7121e565$var$confineInContainer(position, width, height, api) {
    var viewWidth = api.getWidth();
    var viewHeight = api.getHeight();
    position[0] = Math.min(position[0] + width, viewWidth) - width;
    position[1] = Math.min(position[1] + height, viewHeight) - height;
    position[0] = Math.max(position[0], 0);
    position[1] = Math.max(position[1], 0);
}
function $34f90d1e7121e565$export$7cffee0f9aed39d0(value, axis, ecModel, seriesDataIndices, opt) {
    value = axis.scale.parse(value);
    var text = axis.scale.getLabel({
        value: value
    }, {
        // If `precision` is set, width can be fixed (like '12.00500'), which
        // helps to debounce when when moving label.
        precision: opt.precision
    });
    var formatter = opt.formatter;
    if (formatter) {
        var params_1 = {
            value: $3e6d0d29922ecf90$export$a5a32f324c1fa457(axis, {
                value: value
            }),
            axisDimension: axis.dim,
            axisIndex: axis.index,
            seriesData: []
        };
        $43e0a445ed6711da$export$79b2f7037acddd43(seriesDataIndices, function(idxItem) {
            var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
            var dataIndex = idxItem.dataIndexInside;
            var dataParams = series && series.getDataParams(dataIndex);
            dataParams && params_1.seriesData.push(dataParams);
        });
        if ($43e0a445ed6711da$export$844ec244b1367d54(formatter)) text = formatter.replace("{value}", text);
        else if ($43e0a445ed6711da$export$f6e2535fb5126e54(formatter)) text = formatter(params_1);
    }
    return text;
}
function $34f90d1e7121e565$export$4bb66440324c3a3d(axis, value, layoutInfo) {
    var transform = $87ac8de5537d9a34$export$185802fd694ee1f5();
    $87ac8de5537d9a34$export$bb628a54ab399bc9(transform, transform, layoutInfo.rotation);
    $87ac8de5537d9a34$export$d73ee8ef04f5226a(transform, transform, layoutInfo.position);
    return $6552edac5ca572b1$export$9f9dcb98c894b623([
        axis.dataToCoord(value),
        (layoutInfo.labelOffset || 0) + (layoutInfo.labelDirection || 1) * (layoutInfo.labelMargin || 0)
    ], transform);
}
function $34f90d1e7121e565$export$fd3eb3812211a173(value, elOption, layoutInfo, axisModel, axisPointerModel, api) {
    var textLayout = (0, $377a1d5467eb3e77$export$2e2bcd8739ae039).innerTextLayout(layoutInfo.rotation, 0, layoutInfo.labelDirection);
    layoutInfo.labelMargin = axisPointerModel.get([
        "label",
        "margin"
    ]);
    $34f90d1e7121e565$export$8206a9937c45910f(elOption, axisModel, axisPointerModel, api, {
        position: $34f90d1e7121e565$export$4bb66440324c3a3d(axisModel.axis, value, layoutInfo),
        align: textLayout.textAlign,
        verticalAlign: textLayout.textVerticalAlign
    });
}
function $34f90d1e7121e565$export$885fa0ad5a826207(p1, p2, xDimIndex) {
    xDimIndex = xDimIndex || 0;
    return {
        x1: p1[xDimIndex],
        y1: p1[1 - xDimIndex],
        x2: p2[xDimIndex],
        y2: p2[1 - xDimIndex]
    };
}
function $34f90d1e7121e565$export$a8b35248bcc02756(xy, wh, xDimIndex) {
    xDimIndex = xDimIndex || 0;
    return {
        x: xy[xDimIndex],
        y: xy[1 - xDimIndex],
        width: wh[xDimIndex],
        height: wh[1 - xDimIndex]
    };
}
function $34f90d1e7121e565$export$b0cf82e7ebc0d7d0(cx, cy, r0, r, startAngle, endAngle) {
    return {
        cx: cx,
        cy: cy,
        r0: r0,
        r: r,
        startAngle: startAngle,
        endAngle: endAngle,
        clockwise: true
    };
}
function $34f90d1e7121e565$export$19cae73ec299246f(axis, seriesDataIndices, ecModel) {
    return (0, $8c5e7e1639db3579$export$141021262b29d96e)(axis, {
        fromStat: {
            sers: $43e0a445ed6711da$export$871de8747c9eaa88(seriesDataIndices, function(item) {
                return ecModel.getSeriesByIndex(item.seriesIndex);
            })
        },
        min: 1
    }).w;
}
function $34f90d1e7121e565$export$a1c116ca0a73a1a2(val, axisExtent, bandWidth) {
    return [
        (0, $b49750109e236fd8$export$2ca8010d037f830f)((0, $b49750109e236fd8$export$e411eeaf23dccbe8)(axisExtent[0], axisExtent[1]), val - bandWidth / 2),
        (0, $b49750109e236fd8$export$e411eeaf23dccbe8)(val + bandWidth / 2, (0, $b49750109e236fd8$export$2ca8010d037f830f)(axisExtent[0], axisExtent[1]))
    ];
}




var $678cc533f9983fe5$var$CartesianAxisPointer = /** @class */ function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(CartesianAxisPointer, _super);
    function CartesianAxisPointer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
   * @override
   */ CartesianAxisPointer.prototype.makeElOption = function(elOption, value, axisModel, axisPointerModel, api) {
        var axis = axisModel.axis;
        var grid = axis.grid;
        var axisPointerType = axisPointerModel.get("type");
        var thisExtent = axis.getGlobalExtent();
        var otherExtent = $678cc533f9983fe5$var$getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
        var pixelValue = axis.toGlobalCoord(axis.dataToCoord(value, true));
        if (axisPointerType && axisPointerType !== "none") {
            var elStyle = $34f90d1e7121e565$export$b7fe459c7cc50060(axisPointerModel);
            var pointerOption = $678cc533f9983fe5$var$pointerShapeBuilder[axisPointerType](axis, pixelValue, thisExtent, otherExtent, axisPointerModel.get("seriesDataIndices"), axisPointerModel.ecModel);
            pointerOption.style = elStyle;
            elOption.graphicKey = pointerOption.type;
            elOption.pointer = pointerOption;
        }
        var layoutInfo = $ea10c38ae65d6707$export$b3219800bda33a1f(grid.getRect(), axisModel);
        $34f90d1e7121e565$export$fd3eb3812211a173(value, elOption, layoutInfo, axisModel, axisPointerModel, api);
    };
    /**
   * @override
   */ CartesianAxisPointer.prototype.getHandleTransform = function(value, axisModel, axisPointerModel) {
        var layoutInfo = $ea10c38ae65d6707$export$b3219800bda33a1f(axisModel.axis.grid.getRect(), axisModel, {
            labelInside: false
        });
        layoutInfo.labelMargin = axisPointerModel.get([
            "handle",
            "margin"
        ]);
        var pos = $34f90d1e7121e565$export$4bb66440324c3a3d(axisModel.axis, value, layoutInfo);
        return {
            x: pos[0],
            y: pos[1],
            rotation: layoutInfo.rotation + (layoutInfo.labelDirection < 0 ? Math.PI : 0)
        };
    };
    /**
   * @override
   */ CartesianAxisPointer.prototype.updateHandleTransform = function(transform, delta, axisModel, axisPointerModel) {
        var axis = axisModel.axis;
        var grid = axis.grid;
        var axisExtent = axis.getGlobalExtent(true);
        var otherExtent = $678cc533f9983fe5$var$getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
        var dimIndex = axis.dim === "x" ? 0 : 1;
        var currPosition = [
            transform.x,
            transform.y
        ];
        currPosition[dimIndex] += delta[dimIndex];
        currPosition[dimIndex] = (0, $b49750109e236fd8$export$e411eeaf23dccbe8)(axisExtent[1], currPosition[dimIndex]);
        currPosition[dimIndex] = (0, $b49750109e236fd8$export$2ca8010d037f830f)(axisExtent[0], currPosition[dimIndex]);
        var cursorOtherValue = (otherExtent[1] + otherExtent[0]) / 2;
        var cursorPoint = [
            cursorOtherValue,
            cursorOtherValue
        ];
        cursorPoint[dimIndex] = currPosition[dimIndex];
        // Make tooltip do not overlap axisPointer and in the middle of the grid.
        var tooltipOptions = [
            {
                verticalAlign: "middle"
            },
            {
                align: "center"
            }
        ];
        return {
            x: currPosition[0],
            y: currPosition[1],
            rotation: transform.rotation,
            cursorPoint: cursorPoint,
            tooltipOption: tooltipOptions[dimIndex]
        };
    };
    return CartesianAxisPointer;
}((0, $9fa45239c23b4ed1$export$2e2bcd8739ae039));
function $678cc533f9983fe5$var$getCartesian(grid, axis) {
    var opt = {};
    opt[axis.dim + "AxisIndex"] = axis.index;
    return grid.getCartesian(opt);
}
var $678cc533f9983fe5$var$pointerShapeBuilder = {
    line: function(axis, pixelValue, thisExtent, otherExtent) {
        var targetShape = $34f90d1e7121e565$export$885fa0ad5a826207([
            pixelValue,
            otherExtent[0]
        ], [
            pixelValue,
            otherExtent[1]
        ], $678cc533f9983fe5$var$getAxisDimIndex(axis));
        return {
            type: "Line",
            subPixelOptimize: true,
            shape: targetShape
        };
    },
    shadow: function(axis, pixelValue, thisExtent, otherExtent, seriesDataIndices, ecModel) {
        var bandWidth = $34f90d1e7121e565$export$19cae73ec299246f(axis, seriesDataIndices, ecModel);
        var otherSpan = otherExtent[1] - otherExtent[0];
        var _a = $34f90d1e7121e565$export$a1c116ca0a73a1a2(pixelValue, thisExtent, bandWidth), min = _a[0], max = _a[1];
        return {
            type: "Rect",
            shape: $34f90d1e7121e565$export$a8b35248bcc02756([
                min,
                otherExtent[0]
            ], [
                max - min,
                otherSpan
            ], $678cc533f9983fe5$var$getAxisDimIndex(axis))
        };
    }
};
function $678cc533f9983fe5$var$getAxisDimIndex(axis) {
    return axis.dim === "x" ? 0 : 1;
}
var $678cc533f9983fe5$export$2e2bcd8739ae039 = $678cc533f9983fe5$var$CartesianAxisPointer;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $d6971a68866ad53e$var$AxisPointerModel = /** @class */ function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(AxisPointerModel, _super);
    function AxisPointerModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = AxisPointerModel.type;
        return _this;
    }
    AxisPointerModel.type = "axisPointer";
    AxisPointerModel.defaultOption = {
        // 'auto' means that show when triggered by tooltip or handle.
        show: "auto",
        // zlevel: 0,
        z: 50,
        type: "line",
        // axispointer triggered by tootip determine snap automatically,
        // see `modelHelper`.
        snap: false,
        triggerTooltip: true,
        triggerEmphasis: true,
        value: null,
        status: null,
        link: [],
        // Do not set 'auto' here, otherwise global animation: false
        // will not effect at this axispointer.
        animation: null,
        animationDurationUpdate: 200,
        lineStyle: {
            color: (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.border,
            width: 1,
            type: "dashed"
        },
        shadowStyle: {
            color: (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.shadowTint
        },
        label: {
            show: true,
            formatter: null,
            precision: "auto",
            margin: 3,
            color: (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.neutral00,
            padding: [
                5,
                7,
                5,
                7
            ],
            backgroundColor: (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.accent60,
            borderColor: null,
            borderWidth: 0,
            borderRadius: 3
        },
        handle: {
            show: false,
            // eslint-disable-next-line
            icon: "M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7v-1.2h6.6z M13.3,22H6.7v-1.2h6.6z M13.3,19.6H6.7v-1.2h6.6z",
            size: 45,
            // handle margin is from symbol center to axis, which is stable when circular move.
            margin: 50,
            // color: '#1b8bbd'
            // color: '#2f4554'
            color: (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.accent40,
            // For mobile performance
            throttle: 40
        }
    };
    return AxisPointerModel;
}((0, $4a9041b12b787d1b$export$2e2bcd8739ae039));
var $d6971a68866ad53e$export$2e2bcd8739ae039 = $d6971a68866ad53e$var$AxisPointerModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $3720a9b5b8b4a4bd$var$inner = (0, $87f4a59ac66e0ee6$export$64df9f8d92ae083f)();
var $3720a9b5b8b4a4bd$var$each = $43e0a445ed6711da$export$79b2f7037acddd43;
function $3720a9b5b8b4a4bd$export$6503ec6e8aabbaf(key, api, handler) {
    if ((0, $a84633bb9c74d89c$export$2e2bcd8739ae039).node) return;
    var zr = api.getZr();
    $3720a9b5b8b4a4bd$var$inner(zr).records || ($3720a9b5b8b4a4bd$var$inner(zr).records = {});
    $3720a9b5b8b4a4bd$var$initGlobalListeners(zr, api);
    var record = $3720a9b5b8b4a4bd$var$inner(zr).records[key] || ($3720a9b5b8b4a4bd$var$inner(zr).records[key] = {});
    record.handler = handler;
}
function $3720a9b5b8b4a4bd$var$initGlobalListeners(zr, api) {
    if ($3720a9b5b8b4a4bd$var$inner(zr).initialized) return;
    $3720a9b5b8b4a4bd$var$inner(zr).initialized = true;
    useHandler("click", $43e0a445ed6711da$export$c3095a23b368d1f2($3720a9b5b8b4a4bd$var$doEnter, "click"));
    useHandler("mousemove", $43e0a445ed6711da$export$c3095a23b368d1f2($3720a9b5b8b4a4bd$var$doEnter, "mousemove"));
    // For example, dataZoom may update series layout while mousewheel,
    // axisPointer and tooltip need to follow that updates, otherwise,
    // highlighted items (by axisPointer) may have no chance to downplay.
    useHandler("mousewheel", $43e0a445ed6711da$export$c3095a23b368d1f2($3720a9b5b8b4a4bd$var$doEnter, "mousewheel"));
    // useHandler('mouseout', onLeave);
    useHandler("globalout", $3720a9b5b8b4a4bd$var$onLeave);
    function useHandler(eventType, cb) {
        zr.on(eventType, function(e) {
            var dis = $3720a9b5b8b4a4bd$var$makeDispatchAction(api);
            $3720a9b5b8b4a4bd$var$each($3720a9b5b8b4a4bd$var$inner(zr).records, function(record) {
                record && cb(record, e, dis.dispatchAction);
            });
            $3720a9b5b8b4a4bd$var$dispatchTooltipFinally(dis.pendings, api);
        });
    }
}
function $3720a9b5b8b4a4bd$var$dispatchTooltipFinally(pendings, api) {
    var showLen = pendings.showTip.length;
    var hideLen = pendings.hideTip.length;
    var actuallyPayload;
    if (showLen) actuallyPayload = pendings.showTip[showLen - 1];
    else if (hideLen) actuallyPayload = pendings.hideTip[hideLen - 1];
    if (actuallyPayload) {
        actuallyPayload.dispatchAction = null;
        api.dispatchAction(actuallyPayload);
    }
}
function $3720a9b5b8b4a4bd$var$onLeave(record, e, dispatchAction) {
    record.handler("leave", null, dispatchAction);
}
function $3720a9b5b8b4a4bd$var$doEnter(currTrigger, record, e, dispatchAction) {
    record.handler(currTrigger, e, dispatchAction);
}
function $3720a9b5b8b4a4bd$var$makeDispatchAction(api) {
    var pendings = {
        showTip: [],
        hideTip: []
    };
    // FIXME
    // better approach?
    // 'showTip' and 'hideTip' can be triggered by axisPointer and tooltip,
    // which may be conflict, (axisPointer call showTip but tooltip call hideTip);
    // So we have to add "final stage" to merge those dispatched actions.
    var dispatchAction = function(payload) {
        var pendingList = pendings[payload.type];
        if (pendingList) pendingList.push(payload);
        else {
            payload.dispatchAction = dispatchAction;
            api.dispatchAction(payload);
        }
    };
    return {
        dispatchAction: dispatchAction,
        pendings: pendings
    };
}
function $3720a9b5b8b4a4bd$export$d07f55d4c15c0440(key, api) {
    if ((0, $a84633bb9c74d89c$export$2e2bcd8739ae039).node) return;
    var zr = api.getZr();
    var record = ($3720a9b5b8b4a4bd$var$inner(zr).records || {})[key];
    if (record) $3720a9b5b8b4a4bd$var$inner(zr).records[key] = null;
}



var $a749fc9ed0ad5354$var$AxisPointerView = /** @class */ function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(AxisPointerView, _super);
    function AxisPointerView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = AxisPointerView.type;
        return _this;
    }
    AxisPointerView.prototype.render = function(globalAxisPointerModel, ecModel, api) {
        var globalTooltipModel = ecModel.getComponent("tooltip");
        var triggerOn = globalAxisPointerModel.get("triggerOn") || globalTooltipModel && globalTooltipModel.get("triggerOn") || "mousemove|click|mousewheel";
        // Register global listener in AxisPointerView to enable
        // AxisPointerView to be independent to Tooltip.
        $3720a9b5b8b4a4bd$export$6503ec6e8aabbaf("axisPointer", api, function(currTrigger, e, dispatchAction) {
            // If 'none', it is not controlled by mouse totally.
            if (triggerOn !== "none" && (currTrigger === "leave" || triggerOn.indexOf(currTrigger) >= 0)) dispatchAction({
                type: "updateAxisPointer",
                currTrigger: currTrigger,
                x: e && e.offsetX,
                y: e && e.offsetY
            });
        });
    };
    AxisPointerView.prototype.remove = function(ecModel, api) {
        $3720a9b5b8b4a4bd$export$d07f55d4c15c0440("axisPointer", api);
    };
    AxisPointerView.prototype.dispose = function(ecModel, api) {
        $3720a9b5b8b4a4bd$export$d07f55d4c15c0440("axisPointer", api);
    };
    AxisPointerView.type = "axisPointer";
    return AxisPointerView;
}((0, $c81700f6bd52c5a7$export$2e2bcd8739ae039));
var $a749fc9ed0ad5354$export$2e2bcd8739ae039 = $a749fc9ed0ad5354$var$AxisPointerView;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $172948c0a816aa9c$export$2e2bcd8739ae039(finder, ecModel) {
    var point = [];
    var seriesIndex = finder.seriesIndex;
    var seriesModel;
    if (seriesIndex == null || !(seriesModel = ecModel.getSeriesByIndex(seriesIndex))) return {
        point: []
    };
    var data = seriesModel.getData();
    var dataIndex = $87f4a59ac66e0ee6$export$42b26cae8b8d10(data, finder);
    if (dataIndex == null || dataIndex < 0 || $43e0a445ed6711da$export$43bee75e5e14138e(dataIndex)) return {
        point: []
    };
    var el = data.getItemGraphicEl(dataIndex);
    var coordSys = seriesModel.coordinateSystem;
    if (seriesModel.getTooltipPosition) point = seriesModel.getTooltipPosition(dataIndex) || [];
    else if (coordSys && coordSys.dataToPoint) {
        if (finder.isStacked) {
            var baseAxis = coordSys.getBaseAxis();
            var valueAxis = coordSys.getOtherAxis(baseAxis);
            var valueAxisDim = valueAxis.dim;
            var baseAxisDim = baseAxis.dim;
            var baseDataOffset = valueAxisDim === "x" || valueAxisDim === "radius" ? 1 : 0;
            var baseDim = data.mapDimension(baseAxisDim);
            var stackedData = [];
            stackedData[baseDataOffset] = data.get(baseDim, dataIndex);
            stackedData[1 - baseDataOffset] = data.get(data.getCalculationInfo("stackResultDimension"), dataIndex);
            point = coordSys.dataToPoint(stackedData) || [];
        } else point = coordSys.dataToPoint(data.getValues($43e0a445ed6711da$export$871de8747c9eaa88(coordSys.dimensions, function(dim) {
            return data.mapDimension(dim);
        }), dataIndex)) || [];
    } else if (el) {
        // Use graphic bounding rect
        var rect = el.getBoundingRect().clone();
        rect.applyTransform(el.transform);
        point = [
            rect.x + rect.width / 2,
            rect.y + rect.height / 2
        ];
    }
    return {
        point: point,
        el: el
    };
}




var $e44079a6a54d5e6e$var$inner = (0, $87f4a59ac66e0ee6$export$64df9f8d92ae083f)();
function $e44079a6a54d5e6e$export$2e2bcd8739ae039(payload, ecModel, api) {
    var currTrigger = payload.currTrigger;
    var point = [
        payload.x,
        payload.y
    ];
    var finder = payload;
    var dispatchAction = payload.dispatchAction || (0, $43e0a445ed6711da$export$2385a24977818dd0)(api.dispatchAction, api);
    var coordSysAxesInfo = ecModel.getComponent("axisPointer").coordSysAxesInfo;
    // Pending
    // See #6121. But we are not able to reproduce it yet.
    if (!coordSysAxesInfo) return;
    if ($e44079a6a54d5e6e$var$illegalPoint(point)) // Used in the default behavior of `connection`: use the sample seriesIndex
    // and dataIndex. And also used in the tooltipView trigger.
    point = (0, $172948c0a816aa9c$export$2e2bcd8739ae039)({
        seriesIndex: finder.seriesIndex,
        // Do not use dataIndexInside from other ec instance.
        // FIXME: auto detect it?
        dataIndex: finder.dataIndex
    }, ecModel).point;
    var isIllegalPoint = $e44079a6a54d5e6e$var$illegalPoint(point);
    // Axis and value can be specified when calling dispatchAction({type: 'updateAxisPointer'}).
    // Notice: In this case, it is difficult to get the `point` (which is necessary to show
    // tooltip, so if point is not given, we just use the point found by sample seriesIndex
    // and dataIndex.
    var inputAxesInfo = finder.axesInfo;
    var axesInfo = coordSysAxesInfo.axesInfo;
    var shouldHide = currTrigger === "leave" || $e44079a6a54d5e6e$var$illegalPoint(point);
    var outputPayload = {};
    var showValueMap = {};
    var dataByCoordSys = {
        list: [],
        map: {}
    };
    var updaters = {
        showPointer: (0, $43e0a445ed6711da$export$c3095a23b368d1f2)($e44079a6a54d5e6e$var$showPointer, showValueMap),
        showTooltip: (0, $43e0a445ed6711da$export$c3095a23b368d1f2)($e44079a6a54d5e6e$var$showTooltip, dataByCoordSys)
    };
    // Process for triggered axes.
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)(coordSysAxesInfo.coordSysMap, function(coordSys, coordSysKey) {
        // If a point given, it must be contained by the coordinate system.
        var coordSysContainsPoint = isIllegalPoint || coordSys.containPoint(point);
        (0, $43e0a445ed6711da$export$79b2f7037acddd43)(coordSysAxesInfo.coordSysAxesInfo[coordSysKey], function(axisInfo, key) {
            var axis = axisInfo.axis;
            var inputAxisInfo = $e44079a6a54d5e6e$var$findInputAxisInfo(inputAxesInfo, axisInfo);
            // If no inputAxesInfo, no axis is restricted.
            if (!shouldHide && coordSysContainsPoint && (!inputAxesInfo || inputAxisInfo)) {
                var val = inputAxisInfo && inputAxisInfo.value;
                if (val == null && !isIllegalPoint) val = axis.pointToData(point);
                val != null && $e44079a6a54d5e6e$var$processOnAxis(axisInfo, val, updaters, false, outputPayload);
            }
        });
    });
    // Process for linked axes.
    var linkTriggers = {};
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)(axesInfo, function(tarAxisInfo, tarKey) {
        var linkGroup = tarAxisInfo.linkGroup;
        // If axis has been triggered in the previous stage, it should not be triggered by link.
        if (linkGroup && !showValueMap[tarKey]) (0, $43e0a445ed6711da$export$79b2f7037acddd43)(linkGroup.axesInfo, function(srcAxisInfo, srcKey) {
            var srcValItem = showValueMap[srcKey];
            // If srcValItem exist, source axis is triggered, so link to target axis.
            if (srcAxisInfo !== tarAxisInfo && srcValItem) {
                var val = srcValItem.value;
                linkGroup.mapper && (val = tarAxisInfo.axis.scale.parse(linkGroup.mapper(val, $e44079a6a54d5e6e$var$makeMapperParam(srcAxisInfo), $e44079a6a54d5e6e$var$makeMapperParam(tarAxisInfo))));
                linkTriggers[tarAxisInfo.key] = val;
            }
        });
    });
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)(linkTriggers, function(val, tarKey) {
        $e44079a6a54d5e6e$var$processOnAxis(axesInfo[tarKey], val, updaters, true, outputPayload);
    });
    $e44079a6a54d5e6e$var$updateModelActually(showValueMap, axesInfo, outputPayload);
    $e44079a6a54d5e6e$var$dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction);
    $e44079a6a54d5e6e$var$dispatchHighDownActually(axesInfo, dispatchAction, api);
    return outputPayload;
}
function $e44079a6a54d5e6e$var$processOnAxis(axisInfo, newValue, updaters, noSnap, outputFinder) {
    var axis = axisInfo.axis;
    if (axis.scale.isBlank() || !axis.containData(newValue)) return;
    if (!axisInfo.involveSeries) {
        updaters.showPointer(axisInfo, newValue);
        return;
    }
    // Heavy calculation. So put it after axis.containData checking.
    var payloadInfo = $e44079a6a54d5e6e$var$buildPayloadsBySeries(newValue, axisInfo);
    var payloadBatch = payloadInfo.payloadBatch;
    var snapToValue = payloadInfo.snapToValue;
    // Fill content of event obj for echarts.connect.
    // By default use the first involved series data as a sample to connect.
    if (payloadBatch[0] && outputFinder.seriesIndex == null) (0, $43e0a445ed6711da$export$8b58be045bf06082)(outputFinder, payloadBatch[0]);
    // If no linkSource input, this process is for collecting link
    // target, where snap should not be accepted.
    if (!noSnap && axisInfo.snap) {
        if (axis.containData(snapToValue) && snapToValue != null) newValue = snapToValue;
    }
    updaters.showPointer(axisInfo, newValue, payloadBatch);
    // Tooltip should always be snapToValue, otherwise there will be
    // incorrect "axis value ~ series value" mapping displayed in tooltip.
    updaters.showTooltip(axisInfo, payloadInfo, snapToValue);
}
function $e44079a6a54d5e6e$var$buildPayloadsBySeries(value, axisInfo) {
    var axis = axisInfo.axis;
    var dim = axis.dim;
    var snapToValue = value;
    var payloadBatch = [];
    var minDist = Number.MAX_VALUE;
    var minDiff = -1;
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)(axisInfo.seriesModels, function(series, idx) {
        var dataDim = series.getData().mapDimensionsAll(dim);
        var seriesNestestValue;
        var dataIndices;
        if (series.getAxisTooltipData) {
            var result = series.getAxisTooltipData(dataDim, value, axis);
            dataIndices = result.dataIndices;
            seriesNestestValue = result.nestestValue;
        } else {
            dataIndices = series.indicesOfNearest(dim, dataDim[0], value, // Add a threshold to avoid find the wrong dataIndex
            // when data length is not same.
            // false,
            axis.type === "category" ? 0.5 : null);
            if (!dataIndices.length) return;
            seriesNestestValue = series.getData().get(dataDim[0], dataIndices[0]);
        }
        if (!(0, $b49750109e236fd8$export$b5c30d4208814a65)(seriesNestestValue)) return;
        var diff = value - seriesNestestValue;
        var dist = Math.abs(diff);
        // Consider category case
        if (dist <= minDist) {
            if (dist < minDist || diff >= 0 && minDiff < 0) {
                minDist = dist;
                minDiff = diff;
                snapToValue = seriesNestestValue;
                payloadBatch.length = 0;
            }
            (0, $43e0a445ed6711da$export$79b2f7037acddd43)(dataIndices, function(dataIndex) {
                payloadBatch.push({
                    seriesIndex: series.seriesIndex,
                    dataIndexInside: dataIndex,
                    dataIndex: series.getData().getRawIndex(dataIndex)
                });
            });
        }
    });
    return {
        payloadBatch: payloadBatch,
        snapToValue: snapToValue
    };
}
function $e44079a6a54d5e6e$var$showPointer(showValueMap, axisInfo, value, payloadBatch) {
    showValueMap[axisInfo.key] = {
        value: value,
        payloadBatch: payloadBatch
    };
}
function $e44079a6a54d5e6e$var$showTooltip(dataByCoordSys, axisInfo, payloadInfo, value) {
    var payloadBatch = payloadInfo.payloadBatch;
    var axis = axisInfo.axis;
    var axisModel = axis.model;
    var axisPointerModel = axisInfo.axisPointerModel;
    // If no data, do not create anything in dataByCoordSys,
    // whose length will be used to judge whether dispatch action.
    if (!axisInfo.triggerTooltip || !payloadBatch.length) return;
    var coordSysModel = axisInfo.coordSys.model;
    var coordSysKey = $00e38f766da9741c$export$d01b444bafb1a792(coordSysModel);
    var coordSysItem = dataByCoordSys.map[coordSysKey];
    if (!coordSysItem) {
        coordSysItem = dataByCoordSys.map[coordSysKey] = {
            coordSysId: coordSysModel.id,
            coordSysIndex: coordSysModel.componentIndex,
            coordSysType: coordSysModel.type,
            coordSysMainType: coordSysModel.mainType,
            dataByAxis: []
        };
        dataByCoordSys.list.push(coordSysItem);
    }
    coordSysItem.dataByAxis.push({
        axisDim: axis.dim,
        axisIndex: axisModel.componentIndex,
        axisType: axisModel.type,
        axisId: axisModel.id,
        value: value,
        // Caution: viewHelper.getValueLabel is actually on "view stage", which
        // depends that all models have been updated. So it should not be performed
        // here. Considering axisPointerModel used here is volatile, which is hard
        // to be retrieve in TooltipView, we prepare parameters here.
        valueLabelOpt: {
            precision: axisPointerModel.get([
                "label",
                "precision"
            ]),
            formatter: axisPointerModel.get([
                "label",
                "formatter"
            ])
        },
        seriesDataIndices: payloadBatch.slice()
    });
}
function $e44079a6a54d5e6e$var$updateModelActually(showValueMap, axesInfo, outputPayload) {
    var outputAxesInfo = outputPayload.axesInfo = [];
    // Basic logic: If no 'show' required, 'hide' this axisPointer.
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)(axesInfo, function(axisInfo, key) {
        var option = axisInfo.axisPointerModel.option;
        var valItem = showValueMap[key];
        if (valItem) {
            !axisInfo.useHandle && (option.status = "show");
            option.value = valItem.value;
            // For label formatter param and highlight.
            option.seriesDataIndices = (valItem.payloadBatch || []).slice();
        } else // If hide, value still need to be set, consider
        // click legend to toggle axis blank.
        !axisInfo.useHandle && (option.status = "hide");
        // If status is 'hide', should be no info in payload.
        option.status === "show" && outputAxesInfo.push({
            axisDim: axisInfo.axis.dim,
            axisIndex: axisInfo.axis.model.componentIndex,
            value: option.value
        });
    });
}
function $e44079a6a54d5e6e$var$dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction) {
    // Basic logic: If no showTip required, hideTip will be dispatched.
    if ($e44079a6a54d5e6e$var$illegalPoint(point) || !dataByCoordSys.list.length) {
        dispatchAction({
            type: "hideTip"
        });
        return;
    }
    // In most case only one axis (or event one series is used). It is
    // convenient to fetch payload.seriesIndex and payload.dataIndex
    // directly. So put the first seriesIndex and dataIndex of the first
    // axis on the payload.
    var sampleItem = ((dataByCoordSys.list[0].dataByAxis[0] || {}).seriesDataIndices || [])[0] || {};
    dispatchAction({
        type: "showTip",
        escapeConnect: true,
        x: point[0],
        y: point[1],
        tooltipOption: payload.tooltipOption,
        position: payload.position,
        dataIndexInside: sampleItem.dataIndexInside,
        dataIndex: sampleItem.dataIndex,
        seriesIndex: sampleItem.seriesIndex,
        dataByCoordSys: dataByCoordSys.list
    });
}
function $e44079a6a54d5e6e$var$dispatchHighDownActually(axesInfo, dispatchAction, api) {
    // FIXME
    // highlight status modification should be a stage of main process?
    // (Consider conflict (e.g., legend and axisPointer) and setOption)
    var zr = api.getZr();
    var highDownKey = "axisPointerLastHighlights";
    var lastHighlights = $e44079a6a54d5e6e$var$inner(zr)[highDownKey] || {};
    var newHighlights = $e44079a6a54d5e6e$var$inner(zr)[highDownKey] = {};
    // Update highlight/downplay status according to axisPointer model.
    // Build hash map and remove duplicate incidentally.
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)(axesInfo, function(axisInfo, key) {
        var option = axisInfo.axisPointerModel.option;
        option.status === "show" && axisInfo.triggerEmphasis && (0, $43e0a445ed6711da$export$79b2f7037acddd43)(option.seriesDataIndices, function(batchItem) {
            newHighlights[batchItem.seriesIndex + "|" + batchItem.dataIndex] = batchItem;
        });
    });
    // Diff.
    var toHighlight = [];
    var toDownplay = [];
    function makeHighDownItem(batchItem) {
        // `dataIndexInside` should be removed, since the last recorded `dataIndexInside` may have
        // been changed if `dataZoomInside` changed the view. Only `dataIndex` will suffice.
        return {
            seriesIndex: batchItem.seriesIndex,
            dataIndex: batchItem.dataIndex
        };
    }
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)(lastHighlights, function(batchItem, key) {
        !newHighlights[key] && toDownplay.push(makeHighDownItem(batchItem));
    });
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)(newHighlights, function(batchItem, key) {
        !lastHighlights[key] && toHighlight.push(makeHighDownItem(batchItem));
    });
    toDownplay.length && api.dispatchAction({
        type: "downplay",
        escapeConnect: true,
        // Not blur others when highlight in axisPointer.
        notBlur: true,
        batch: toDownplay
    });
    toHighlight.length && api.dispatchAction({
        type: "highlight",
        escapeConnect: true,
        // Not blur others when highlight in axisPointer.
        notBlur: true,
        batch: toHighlight
    });
}
function $e44079a6a54d5e6e$var$findInputAxisInfo(inputAxesInfo, axisInfo) {
    for(var i = 0; i < (inputAxesInfo || []).length; i++){
        var inputAxisInfo = inputAxesInfo[i];
        if (axisInfo.axis.dim === inputAxisInfo.axisDim && axisInfo.axis.model.componentIndex === inputAxisInfo.axisIndex) return inputAxisInfo;
    }
}
function $e44079a6a54d5e6e$var$makeMapperParam(axisInfo) {
    var axisModel = axisInfo.axis.model;
    var item = {};
    var dim = item.axisDim = axisInfo.axis.dim;
    item.axisIndex = item[dim + "AxisIndex"] = axisModel.componentIndex;
    item.axisName = item[dim + "AxisName"] = axisModel.name;
    item.axisId = item[dim + "AxisId"] = axisModel.id;
    return item;
}
function $e44079a6a54d5e6e$var$illegalPoint(point) {
    return !point || point[0] == null || isNaN(point[0]) || point[1] == null || isNaN(point[1]);
}


function $038a39790a59cee8$export$4b3e715f166fdd78(registers) {
    // CartesianAxisPointer is not supposed to be required here. But consider
    // echarts.simple.js and online build tooltip, which only require gridSimple,
    // CartesianAxisPointer should be able to required somewhere.
    (0, $6436493435aeada5$export$2e2bcd8739ae039).registerAxisPointerClass("CartesianAxisPointer", (0, $678cc533f9983fe5$export$2e2bcd8739ae039));
    registers.registerComponentModel((0, $d6971a68866ad53e$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $a749fc9ed0ad5354$export$2e2bcd8739ae039));
    registers.registerPreprocessor(function(option) {
        // Always has a global axisPointerModel for default setting.
        if (option) {
            (!option.axisPointer || option.axisPointer.length === 0) && (option.axisPointer = {});
            var link = option.axisPointer.link;
            // Normalize to array to avoid object mergin. But if link
            // is not set, remain null/undefined, otherwise it will
            // override existent link setting.
            if (link && !(0, $43e0a445ed6711da$export$43bee75e5e14138e)(link)) option.axisPointer.link = [
                link
            ];
        }
    });
    // This process should proformed after coordinate systems created
    // and series data processed. So put it on statistic processing stage.
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, {
        overallReset: function(ecModel, api) {
            // Build axisPointerModel, mergin tooltip.axisPointer model for each axis.
            // allAxesInfo should be updated when setOption performed.
            ecModel.getComponent("axisPointer").coordSysAxesInfo = (0, $00e38f766da9741c$export$bb44f104e3c54dae)(ecModel, api);
        }
    });
    // Broadcast to all views.
    registers.registerAction({
        type: "updateAxisPointer",
        event: "updateAxisPointer",
        update: ":updateAxisPointer"
    }, (0, $e44079a6a54d5e6e$export$2e2bcd8739ae039));
}



function $22382c3fac79675a$export$4b3e715f166fdd78(registers) {
    (0, $8f6e8e1f1e941d98$export$1f96ae73734a86cc)((0, $86f0ec3924072a02$export$4b3e715f166fdd78));
    (0, $8f6e8e1f1e941d98$export$1f96ae73734a86cc)((0, $038a39790a59cee8$export$4b3e715f166fdd78));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $c6ea17e005d9942d$var$TooltipModel = /** @class */ function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(TooltipModel, _super);
    function TooltipModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TooltipModel.type;
        return _this;
    }
    TooltipModel.type = "tooltip";
    TooltipModel.dependencies = [
        "axisPointer"
    ];
    TooltipModel.defaultOption = {
        // zlevel: 0,
        z: 60,
        show: true,
        // tooltip main content
        showContent: true,
        // 'trigger' only works on coordinate system.
        // 'item' | 'axis' | 'none'
        trigger: "item",
        // 'click' | 'mousemove' | 'none'
        triggerOn: "mousemove|click|mousewheel",
        alwaysShowContent: false,
        renderMode: "auto",
        // whether restraint content inside viewRect.
        // If renderMode: 'richText', default true.
        // If renderMode: 'html', defaults to `false` (for backward compat).
        confine: null,
        showDelay: 0,
        hideDelay: 100,
        // Animation transition time, unit is second
        transitionDuration: 0.4,
        displayTransition: true,
        enterable: false,
        backgroundColor: (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.neutral00,
        // box shadow
        shadowBlur: 10,
        shadowColor: "rgba(0, 0, 0, .2)",
        shadowOffsetX: 1,
        shadowOffsetY: 2,
        // tooltip border radius, unit is px, default is 4
        borderRadius: 4,
        // tooltip border width, unit is px, default is 0 (no border)
        borderWidth: 1,
        defaultBorderColor: (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.border,
        // Tooltip inside padding, default is 5 for all direction
        // Array is allowed to set up, right, bottom, left, same with css
        // The default value: See `tooltip/tooltipMarkup.ts#getPaddingFromTooltipModel`.
        padding: null,
        // Extra css text
        extraCssText: "",
        // axis indicator, trigger by axis
        axisPointer: {
            // default is line
            // legal values: 'line' | 'shadow' | 'cross'
            type: "line",
            // Valid when type is line, appoint tooltip line locate on which line. Optional
            // legal values: 'x' | 'y' | 'angle' | 'radius' | 'auto'
            // default is 'auto', chose the axis which type is category.
            // for multiply y axis, cartesian coord chose x axis, polar chose angle axis
            axis: "auto",
            animation: "auto",
            animationDurationUpdate: 200,
            animationEasingUpdate: "exponentialOut",
            crossStyle: {
                color: (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.borderShade,
                width: 1,
                type: "dashed",
                // TODO formatter
                textStyle: {}
            }
        },
        textStyle: {
            color: (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.tertiary,
            fontSize: 14
        }
    };
    return TooltipModel;
}((0, $4a9041b12b787d1b$export$2e2bcd8739ae039));
var $c6ea17e005d9942d$export$2e2bcd8739ae039 = $c6ea17e005d9942d$var$TooltipModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $a354c0f7db071b45$export$a309528050824ba4(tooltipModel) {
    var confineOption = tooltipModel.get("confine");
    return confineOption != null ? !!confineOption : tooltipModel.get("renderMode") === "richText";
}
function $a354c0f7db071b45$var$testStyle(styleProps) {
    if (!(0, $a84633bb9c74d89c$export$2e2bcd8739ae039).domSupported) return;
    var style = document.documentElement.style;
    for(var i = 0, len = styleProps.length; i < len; i++){
        if (styleProps[i] in style) return styleProps[i];
    }
}
var $a354c0f7db071b45$export$7b4286b1e4a23439 = $a354c0f7db071b45$var$testStyle([
    "transform",
    "webkitTransform",
    "OTransform",
    "MozTransform",
    "msTransform"
]);
var $a354c0f7db071b45$export$70a631ae991b5e76 = $a354c0f7db071b45$var$testStyle([
    "webkitTransition",
    "transition",
    "OTransition",
    "MozTransition",
    "msTransition"
]);
function $a354c0f7db071b45$export$5886acafe29a08d1(styleVendor, styleProp) {
    if (!styleVendor) return styleProp;
    styleProp = (0, $78c2ece6dfa6bb7a$export$86f54f62aa7a7514)(styleProp, true);
    var idx = styleVendor.indexOf(styleProp);
    styleVendor = idx === -1 ? styleProp : "-" + styleVendor.slice(0, idx) + "-" + styleProp;
    return styleVendor.toLowerCase();
}
function $a354c0f7db071b45$export$3735103072e4a80(el, style) {
    var stl = el.currentStyle || document.defaultView && document.defaultView.getComputedStyle(el);
    return stl ? style ? stl[style] : stl : null;
}



/* global document, window */ var $5759392692f31ad1$var$CSS_TRANSITION_VENDOR = (0, $a354c0f7db071b45$export$5886acafe29a08d1)((0, $a354c0f7db071b45$export$70a631ae991b5e76), "transition");
var $5759392692f31ad1$var$CSS_TRANSFORM_VENDOR = (0, $a354c0f7db071b45$export$5886acafe29a08d1)((0, $a354c0f7db071b45$export$7b4286b1e4a23439), "transform");
// eslint-disable-next-line
var $5759392692f31ad1$var$gCssText = "position:absolute;display:block;border-style:solid;white-space:nowrap;z-index:9999999;" + ((0, $a84633bb9c74d89c$export$2e2bcd8739ae039).transform3dSupported ? "will-change:transform;" : "");
function $5759392692f31ad1$var$mirrorPos(pos) {
    pos = pos === "left" ? "right" : pos === "right" ? "left" : pos === "top" ? "bottom" : "top";
    return pos;
}
function $5759392692f31ad1$var$assembleArrow(tooltipModel, borderColor, arrowPosition) {
    if (!(0, $43e0a445ed6711da$export$844ec244b1367d54)(arrowPosition) || arrowPosition === "inside") return "";
    var backgroundColor = tooltipModel.get("backgroundColor");
    var borderWidth = tooltipModel.get("borderWidth");
    borderColor = (0, $78c2ece6dfa6bb7a$export$cda04d03233e5555)(borderColor);
    var arrowPos = $5759392692f31ad1$var$mirrorPos(arrowPosition);
    var arrowSize = Math.max(Math.round(borderWidth) * 1.5, 6);
    var positionStyle = "";
    var transformStyle = $5759392692f31ad1$var$CSS_TRANSFORM_VENDOR + ":";
    var rotateDeg;
    if ((0, $43e0a445ed6711da$export$305f7d4e9d4624f2)([
        "left",
        "right"
    ], arrowPos) > -1) {
        positionStyle += "top:50%";
        transformStyle += "translateY(-50%) rotate(" + (rotateDeg = arrowPos === "left" ? -225 : -45) + "deg)";
    } else {
        positionStyle += "left:50%";
        transformStyle += "translateX(-50%) rotate(" + (rotateDeg = arrowPos === "top" ? 225 : 45) + "deg)";
    }
    var rotateRadian = rotateDeg * Math.PI / 180;
    var arrowWH = arrowSize + borderWidth;
    var rotatedWH = arrowWH * Math.abs(Math.cos(rotateRadian)) + arrowWH * Math.abs(Math.sin(rotateRadian));
    var arrowOffset = Math.round(((rotatedWH - Math.SQRT2 * borderWidth) / 2 + Math.SQRT2 * borderWidth - (rotatedWH - arrowWH) / 2) * 100) / 100;
    positionStyle += ";" + arrowPos + ":-" + arrowOffset + "px";
    var borderStyle = borderColor + " solid " + borderWidth + "px;";
    var styleCss = [
        "position:absolute;width:" + arrowSize + "px;height:" + arrowSize + "px;z-index:-1;",
        positionStyle + ";" + transformStyle + ";",
        "border-bottom:" + borderStyle,
        "border-right:" + borderStyle,
        "background-color:" + backgroundColor + ";"
    ];
    return '<div style="' + styleCss.join("") + '"></div>';
}
function $5759392692f31ad1$var$assembleTransition(duration, onlyFadeTransition, enableDisplayTransition) {
    var transitionCurve = "cubic-bezier(0.23,1,0.32,1)";
    var transitionOption = "";
    var transitionText = "";
    if (enableDisplayTransition) {
        transitionOption = " " + duration / 2 + "s " + transitionCurve;
        transitionText = "opacity" + transitionOption + ",visibility" + transitionOption;
    }
    if (!onlyFadeTransition) {
        transitionOption = " " + duration + "s " + transitionCurve;
        transitionText += (transitionText.length ? "," : "") + ((0, $a84633bb9c74d89c$export$2e2bcd8739ae039).transformSupported ? "" + $5759392692f31ad1$var$CSS_TRANSFORM_VENDOR + transitionOption : ",left" + transitionOption + ",top" + transitionOption);
    }
    return $5759392692f31ad1$var$CSS_TRANSITION_VENDOR + ":" + transitionText;
}
function $5759392692f31ad1$var$assembleTransform(x, y, toString) {
    // If using float on style, the final width of the dom might
    // keep changing slightly while mouse move. So `toFixed(0)` them.
    var x0 = x.toFixed(0) + "px";
    var y0 = y.toFixed(0) + "px";
    // not support transform, use `left` and `top` instead.
    if (!(0, $a84633bb9c74d89c$export$2e2bcd8739ae039).transformSupported) return toString ? "top:" + y0 + ";left:" + x0 + ";" : [
        [
            "top",
            y0
        ],
        [
            "left",
            x0
        ]
    ];
    // support transform
    var is3d = (0, $a84633bb9c74d89c$export$2e2bcd8739ae039).transform3dSupported;
    var translate = "translate" + (is3d ? "3d" : "") + "(" + x0 + "," + y0 + (is3d ? ",0" : "") + ")";
    return toString ? "top:0;left:0;" + $5759392692f31ad1$var$CSS_TRANSFORM_VENDOR + ":" + translate + ";" : [
        [
            "top",
            0
        ],
        [
            "left",
            0
        ],
        [
            (0, $a354c0f7db071b45$export$7b4286b1e4a23439),
            translate
        ]
    ];
}
/**
 * @param {Object} textStyle
 * @return {string}
 * @inner
 */ function $5759392692f31ad1$var$assembleFont(textStyleModel) {
    var cssText = [];
    var fontSize = textStyleModel.get("fontSize");
    var color = textStyleModel.getTextColor();
    color && cssText.push("color:" + color);
    cssText.push("font:" + textStyleModel.getFont());
    // @ts-ignore, leave it to the tooltip refactor.
    var lineHeight = (0, $43e0a445ed6711da$export$995e01f2f5c9d030)(textStyleModel.get("lineHeight"), Math.round(fontSize * 3 / 2));
    fontSize && cssText.push("line-height:" + lineHeight + "px");
    var shadowColor = textStyleModel.get("textShadowColor");
    var shadowBlur = textStyleModel.get("textShadowBlur") || 0;
    var shadowOffsetX = textStyleModel.get("textShadowOffsetX") || 0;
    var shadowOffsetY = textStyleModel.get("textShadowOffsetY") || 0;
    shadowColor && shadowBlur && cssText.push("text-shadow:" + shadowOffsetX + "px " + shadowOffsetY + "px " + shadowBlur + "px " + shadowColor);
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)([
        "decoration",
        "align"
    ], function(name) {
        var val = textStyleModel.get(name);
        val && cssText.push("text-" + name + ":" + val);
    });
    return cssText.join(";");
}
function $5759392692f31ad1$var$assembleCssText(tooltipModel, enableTransition, onlyFadeTransition, enableDisplayTransition) {
    var cssText = [];
    var transitionDuration = tooltipModel.get("transitionDuration");
    var backgroundColor = tooltipModel.get("backgroundColor");
    var shadowBlur = tooltipModel.get("shadowBlur");
    var shadowColor = tooltipModel.get("shadowColor");
    var shadowOffsetX = tooltipModel.get("shadowOffsetX");
    var shadowOffsetY = tooltipModel.get("shadowOffsetY");
    var textStyleModel = tooltipModel.getModel("textStyle");
    var padding = (0, $805c7be1c699f811$export$3048212c802df496)(tooltipModel, "html");
    var boxShadow = shadowOffsetX + "px " + shadowOffsetY + "px " + shadowBlur + "px " + shadowColor;
    cssText.push("box-shadow:" + boxShadow);
    // Animation transition. Do not animate when transitionDuration <= 0.
    enableTransition && transitionDuration > 0 && cssText.push($5759392692f31ad1$var$assembleTransition(transitionDuration, onlyFadeTransition, enableDisplayTransition));
    if (backgroundColor) cssText.push("background-color:" + backgroundColor);
    // Border style
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)([
        "width",
        "color",
        "radius"
    ], function(name) {
        var borderName = "border-" + name;
        var camelCase = (0, $78c2ece6dfa6bb7a$export$86f54f62aa7a7514)(borderName);
        var val = tooltipModel.get(camelCase);
        val != null && cssText.push(borderName + ":" + val + (name === "color" ? "" : "px"));
    });
    // Text style
    cssText.push($5759392692f31ad1$var$assembleFont(textStyleModel));
    // Padding
    if (padding != null) cssText.push("padding:" + (0, $78c2ece6dfa6bb7a$export$f3a38102c49f4268)(padding).join("px ") + "px");
    return cssText.join(";") + ";";
}
// If not able to make, do not modify the input `out`.
function $5759392692f31ad1$var$makeStyleCoord(out, zr, container, zrX, zrY) {
    var zrPainter = zr && zr.painter;
    if (container) {
        var zrViewportRoot = zrPainter && zrPainter.getViewportRoot();
        if (zrViewportRoot) // Some APPs might use scale on body, so we support CSS transform here.
        (0, $e2318d49eb46f886$export$8c5c02e118307e20)(out, zrViewportRoot, container, zrX, zrY);
    } else {
        out[0] = zrX;
        out[1] = zrY;
        // xy should be based on canvas root. But tooltipContent is
        // the sibling of canvas root. So padding of ec container
        // should be considered here.
        var viewportRootOffset = zrPainter && zrPainter.getViewportRootOffset();
        if (viewportRootOffset) {
            out[0] += viewportRootOffset.offsetLeft;
            out[1] += viewportRootOffset.offsetTop;
        }
    }
    out[2] = out[0] / zr.getWidth();
    out[3] = out[1] / zr.getHeight();
}
var $5759392692f31ad1$var$TooltipHTMLContent = /** @class */ function() {
    function TooltipHTMLContent(api, opt) {
        this._show = false;
        this._styleCoord = [
            0,
            0,
            0,
            0
        ];
        this._enterable = true;
        this._alwaysShowContent = false;
        this._firstShow = true;
        this._longHide = true;
        if ((0, $a84633bb9c74d89c$export$2e2bcd8739ae039).wxa) return null;
        var el = document.createElement("div");
        // TODO: TYPE
        el.domBelongToZr = true;
        this.el = el;
        var zr = this._zr = api.getZr();
        var appendTo = opt.appendTo;
        var container = appendTo && ((0, $43e0a445ed6711da$export$844ec244b1367d54)(appendTo) ? document.querySelector(appendTo) : (0, $43e0a445ed6711da$export$9f57505b7bd8dae)(appendTo) ? appendTo : (0, $43e0a445ed6711da$export$f6e2535fb5126e54)(appendTo) && appendTo(api.getDom()));
        $5759392692f31ad1$var$makeStyleCoord(this._styleCoord, zr, container, api.getWidth() / 2, api.getHeight() / 2);
        (container || api.getDom()).appendChild(el);
        this._api = api;
        this._container = container;
        // FIXME
        // Is it needed to trigger zr event manually if
        // the browser do not support `pointer-events: none`.
        var self = this;
        el.onmouseenter = function() {
            // clear the timeout in hideLater and keep showing tooltip
            if (self._enterable) {
                clearTimeout(self._hideTimeout);
                self._show = true;
            }
            self._inContent = true;
        };
        el.onmousemove = function(e) {
            e = e || window.event;
            if (!self._enterable) {
                // `pointer-events: none` is set to tooltip content div
                // if `enterable` is set as `false`, and `el.onmousemove`
                // can not be triggered. But in browser that do not
                // support `pointer-events`, we need to do this:
                // Try trigger zrender event to avoid mouse
                // in and out shape too frequently
                var handler = zr.handler;
                var zrViewportRoot = zr.painter.getViewportRoot();
                (0, $e48a660b5a6fd3cb$export$40fadb093aebad71)(zrViewportRoot, e, true);
                handler.dispatch("mousemove", e);
            }
        };
        el.onmouseleave = function() {
            // set `_inContent` to `false` before `hideLater`
            self._inContent = false;
            if (self._enterable) {
                if (self._show) self.hideLater(self._hideDelay);
            }
        };
    }
    /**
   * Update when tooltip is rendered
   */ TooltipHTMLContent.prototype.update = function(tooltipModel) {
        // FIXME
        // Move this logic to ec main?
        if (!this._container) {
            var container = this._api.getDom();
            var position = (0, $a354c0f7db071b45$export$3735103072e4a80)(container, "position");
            var domStyle = container.style;
            if (domStyle.position !== "absolute" && position !== "absolute") domStyle.position = "relative";
        }
        // move tooltip if chart resized
        var alwaysShowContent = tooltipModel.get("alwaysShowContent");
        alwaysShowContent && this._moveIfResized();
        // update alwaysShowContent
        this._alwaysShowContent = alwaysShowContent;
        this._enableDisplayTransition = tooltipModel.get("displayTransition") && tooltipModel.get("transitionDuration") > 0;
        // update className
        this.el.className = tooltipModel.get("className") || "";
    // Hide the tooltip
    // PENDING
    // this.hide();
    };
    TooltipHTMLContent.prototype.show = function(tooltipModel, nearPointColor) {
        clearTimeout(this._hideTimeout);
        clearTimeout(this._longHideTimeout);
        var el = this.el;
        var style = el.style;
        var styleCoord = this._styleCoord;
        if (!el.innerHTML) style.display = "none";
        else style.cssText = $5759392692f31ad1$var$gCssText + $5759392692f31ad1$var$assembleCssText(tooltipModel, !this._firstShow, this._longHide, this._enableDisplayTransition) + $5759392692f31ad1$var$assembleTransform(styleCoord[0], styleCoord[1], true) + ("border-color:" + (0, $78c2ece6dfa6bb7a$export$cda04d03233e5555)(nearPointColor) + ";") + (tooltipModel.get("extraCssText") || "") + (";pointer-events:" + (this._enterable ? "auto" : "none"));
        this._show = true;
        this._firstShow = false;
        this._longHide = false;
    };
    TooltipHTMLContent.prototype.setContent = function(content, markers, tooltipModel, borderColor, arrowPosition) {
        var el = this.el;
        if (content == null) {
            el.innerHTML = "";
            return;
        }
        var arrow = "";
        if ((0, $43e0a445ed6711da$export$844ec244b1367d54)(arrowPosition) && tooltipModel.get("trigger") === "item" && !(0, $a354c0f7db071b45$export$a309528050824ba4)(tooltipModel)) arrow = $5759392692f31ad1$var$assembleArrow(tooltipModel, borderColor, arrowPosition);
        if ((0, $43e0a445ed6711da$export$844ec244b1367d54)(content)) el.innerHTML = content + arrow;
        else if (content) {
            // Clear previous
            el.innerHTML = "";
            if (!(0, $43e0a445ed6711da$export$43bee75e5e14138e)(content)) content = [
                content
            ];
            for(var i = 0; i < content.length; i++)if ((0, $43e0a445ed6711da$export$9f57505b7bd8dae)(content[i]) && content[i].parentNode !== el) el.appendChild(content[i]);
            // no arrow if empty
            if (arrow && el.childNodes.length) {
                // no need to create a new parent element, but it's not supported by IE 10 and older.
                // const arrowEl = document.createRange().createContextualFragment(arrow);
                var arrowEl = document.createElement("div");
                arrowEl.innerHTML = arrow;
                el.appendChild(arrowEl);
            }
        }
    };
    TooltipHTMLContent.prototype.setEnterable = function(enterable) {
        this._enterable = enterable;
    };
    TooltipHTMLContent.prototype.getSize = function() {
        var el = this.el;
        return el ? [
            el.offsetWidth,
            el.offsetHeight
        ] : [
            0,
            0
        ];
    };
    TooltipHTMLContent.prototype.moveTo = function(zrX, zrY) {
        if (!this.el) return;
        var styleCoord = this._styleCoord;
        $5759392692f31ad1$var$makeStyleCoord(styleCoord, this._zr, this._container, zrX, zrY);
        if (styleCoord[0] != null && styleCoord[1] != null) {
            var style_1 = this.el.style;
            var transforms = $5759392692f31ad1$var$assembleTransform(styleCoord[0], styleCoord[1]);
            (0, $43e0a445ed6711da$export$79b2f7037acddd43)(transforms, function(transform) {
                style_1[transform[0]] = transform[1];
            });
        }
    };
    /**
   * when `alwaysShowContent` is true,
   * move the tooltip after chart resized
   */ TooltipHTMLContent.prototype._moveIfResized = function() {
        // The ratio of left to width
        var ratioX = this._styleCoord[2];
        // The ratio of top to height
        var ratioY = this._styleCoord[3];
        this.moveTo(ratioX * this._zr.getWidth(), ratioY * this._zr.getHeight());
    };
    TooltipHTMLContent.prototype.hide = function() {
        var _this = this;
        var style = this.el.style;
        if (this._enableDisplayTransition) {
            style.visibility = "hidden";
            style.opacity = "0";
        } else style.display = "none";
        (0, $a84633bb9c74d89c$export$2e2bcd8739ae039).transform3dSupported && (style.willChange = "");
        this._show = false;
        this._longHideTimeout = setTimeout(function() {
            return _this._longHide = true;
        }, 500);
    };
    TooltipHTMLContent.prototype.hideLater = function(time) {
        if (this._show && !(this._inContent && this._enterable) && !this._alwaysShowContent) {
            if (time) {
                this._hideDelay = time;
                // Set show false to avoid invoke hideLater multiple times
                this._show = false;
                this._hideTimeout = setTimeout((0, $43e0a445ed6711da$export$2385a24977818dd0)(this.hide, this), time);
            } else this.hide();
        }
    };
    TooltipHTMLContent.prototype.isShow = function() {
        return this._show;
    };
    TooltipHTMLContent.prototype.dispose = function() {
        clearTimeout(this._hideTimeout);
        clearTimeout(this._longHideTimeout);
        var zr = this._zr;
        (0, $e2318d49eb46f886$export$a29dbe4b7d3cd586)(zr && zr.painter && zr.painter.getViewportRoot(), this._container);
        var el = this.el;
        if (el) {
            el.onmouseenter = el.onmousemove = el.onmouseleave = null;
            var parentNode = el.parentNode;
            parentNode && parentNode.removeChild(el);
        }
        this.el = this._container = null;
    };
    return TooltipHTMLContent;
}();
var $5759392692f31ad1$export$2e2bcd8739ae039 = $5759392692f31ad1$var$TooltipHTMLContent;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $8c16d269e36da0ce$var$TooltipRichContent = /** @class */ function() {
    function TooltipRichContent(api) {
        this._show = false;
        this._styleCoord = [
            0,
            0,
            0,
            0
        ];
        this._alwaysShowContent = false;
        this._enterable = true;
        this._zr = api.getZr();
        $8c16d269e36da0ce$var$makeStyleCoord(this._styleCoord, this._zr, api.getWidth() / 2, api.getHeight() / 2);
    }
    /**
   * Update when tooltip is rendered
   */ TooltipRichContent.prototype.update = function(tooltipModel) {
        var alwaysShowContent = tooltipModel.get("alwaysShowContent");
        alwaysShowContent && this._moveIfResized();
        // update alwaysShowContent
        this._alwaysShowContent = alwaysShowContent;
    };
    TooltipRichContent.prototype.show = function() {
        if (this._hideTimeout) clearTimeout(this._hideTimeout);
        this.el.show();
        this._show = true;
    };
    /**
   * Set tooltip content
   */ TooltipRichContent.prototype.setContent = function(content, markupStyleCreator, tooltipModel, borderColor, arrowPosition) {
        var _this = this;
        if ($43e0a445ed6711da$export$a6cdc56e425d0d0a(content)) (0, $51c99d7efb19f4a2$export$8bf7aba4a9e09055)("");
        if (this.el) this._zr.remove(this.el);
        var textStyleModel = tooltipModel.getModel("textStyle");
        this.el = new (0, $7db7960d25b39b7c$export$2e2bcd8739ae039)({
            style: {
                rich: markupStyleCreator.richTextStyles,
                text: content,
                lineHeight: 22,
                borderWidth: 1,
                borderColor: borderColor,
                textShadowColor: textStyleModel.get("textShadowColor"),
                fill: tooltipModel.get([
                    "textStyle",
                    "color"
                ]),
                padding: (0, $805c7be1c699f811$export$3048212c802df496)(tooltipModel, "richText"),
                verticalAlign: "top",
                align: "left"
            },
            z: tooltipModel.get("z")
        });
        $43e0a445ed6711da$export$79b2f7037acddd43([
            "backgroundColor",
            "borderRadius",
            "shadowColor",
            "shadowBlur",
            "shadowOffsetX",
            "shadowOffsetY"
        ], function(propName) {
            _this.el.style[propName] = tooltipModel.get(propName);
        });
        $43e0a445ed6711da$export$79b2f7037acddd43([
            "textShadowBlur",
            "textShadowOffsetX",
            "textShadowOffsetY"
        ], function(propName) {
            _this.el.style[propName] = textStyleModel.get(propName) || 0;
        });
        this._zr.add(this.el);
        var self = this;
        this.el.on("mouseover", function() {
            // clear the timeout in hideLater and keep showing tooltip
            if (self._enterable) {
                clearTimeout(self._hideTimeout);
                self._show = true;
            }
            self._inContent = true;
        });
        this.el.on("mouseout", function() {
            if (self._enterable) {
                if (self._show) self.hideLater(self._hideDelay);
            }
            self._inContent = false;
        });
    };
    TooltipRichContent.prototype.setEnterable = function(enterable) {
        this._enterable = enterable;
    };
    TooltipRichContent.prototype.getSize = function() {
        var el = this.el;
        var bounding = this.el.getBoundingRect();
        // bounding rect does not include shadow. For renderMode richText,
        // if overflow, it will be cut. So calculate them accurately.
        var shadowOuterSize = $8c16d269e36da0ce$var$calcShadowOuterSize(el.style);
        return [
            bounding.width + shadowOuterSize.left + shadowOuterSize.right,
            bounding.height + shadowOuterSize.top + shadowOuterSize.bottom
        ];
    };
    TooltipRichContent.prototype.moveTo = function(x, y) {
        var el = this.el;
        if (el) {
            var styleCoord = this._styleCoord;
            $8c16d269e36da0ce$var$makeStyleCoord(styleCoord, this._zr, x, y);
            x = styleCoord[0];
            y = styleCoord[1];
            var style = el.style;
            var borderWidth = $8c16d269e36da0ce$var$mathMaxWith0(style.borderWidth || 0);
            var shadowOuterSize = $8c16d269e36da0ce$var$calcShadowOuterSize(style);
            // rich text x, y do not include border.
            el.x = x + borderWidth + shadowOuterSize.left;
            el.y = y + borderWidth + shadowOuterSize.top;
            el.markRedraw();
        }
    };
    /**
   * when `alwaysShowContent` is true,
   * move the tooltip after chart resized
   */ TooltipRichContent.prototype._moveIfResized = function() {
        // The ratio of left to width
        var ratioX = this._styleCoord[2];
        // The ratio of top to height
        var ratioY = this._styleCoord[3];
        this.moveTo(ratioX * this._zr.getWidth(), ratioY * this._zr.getHeight());
    };
    TooltipRichContent.prototype.hide = function() {
        if (this.el) this.el.hide();
        this._show = false;
    };
    TooltipRichContent.prototype.hideLater = function(time) {
        if (this._show && !(this._inContent && this._enterable) && !this._alwaysShowContent) {
            if (time) {
                this._hideDelay = time;
                // Set show false to avoid invoke hideLater multiple times
                this._show = false;
                this._hideTimeout = setTimeout($43e0a445ed6711da$export$2385a24977818dd0(this.hide, this), time);
            } else this.hide();
        }
    };
    TooltipRichContent.prototype.isShow = function() {
        return this._show;
    };
    TooltipRichContent.prototype.dispose = function() {
        this._zr.remove(this.el);
    };
    return TooltipRichContent;
}();
function $8c16d269e36da0ce$var$mathMaxWith0(val) {
    return Math.max(0, val);
}
function $8c16d269e36da0ce$var$calcShadowOuterSize(style) {
    var shadowBlur = $8c16d269e36da0ce$var$mathMaxWith0(style.shadowBlur || 0);
    var shadowOffsetX = $8c16d269e36da0ce$var$mathMaxWith0(style.shadowOffsetX || 0);
    var shadowOffsetY = $8c16d269e36da0ce$var$mathMaxWith0(style.shadowOffsetY || 0);
    return {
        left: $8c16d269e36da0ce$var$mathMaxWith0(shadowBlur - shadowOffsetX),
        right: $8c16d269e36da0ce$var$mathMaxWith0(shadowBlur + shadowOffsetX),
        top: $8c16d269e36da0ce$var$mathMaxWith0(shadowBlur - shadowOffsetY),
        bottom: $8c16d269e36da0ce$var$mathMaxWith0(shadowBlur + shadowOffsetY)
    };
}
function $8c16d269e36da0ce$var$makeStyleCoord(out, zr, zrX, zrY) {
    out[0] = zrX;
    out[1] = zrY;
    out[2] = out[0] / zr.getWidth();
    out[3] = out[1] / zr.getHeight();
}
var $8c16d269e36da0ce$export$2e2bcd8739ae039 = $8c16d269e36da0ce$var$TooltipRichContent;




















var $58b6bf122b8706e8$var$proxyRect = new (0, $42ed508a93973e78$export$2e2bcd8739ae039)({
    shape: {
        x: -1,
        y: -1,
        width: 2,
        height: 2
    }
});
var $58b6bf122b8706e8$var$TooltipView = /** @class */ function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(TooltipView, _super);
    function TooltipView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TooltipView.type;
        return _this;
    }
    TooltipView.prototype.init = function(ecModel, api) {
        if ((0, $a84633bb9c74d89c$export$2e2bcd8739ae039).node || !api.getDom()) return;
        var tooltipModel = ecModel.getComponent("tooltip");
        var renderMode = this._renderMode = (0, $87f4a59ac66e0ee6$export$cc0a17a5d27b4e17)(tooltipModel.get("renderMode"));
        this._tooltipContent = renderMode === "richText" ? new (0, $8c16d269e36da0ce$export$2e2bcd8739ae039)(api) : new (0, $5759392692f31ad1$export$2e2bcd8739ae039)(api, {
            appendTo: tooltipModel.get("appendToBody", true) ? "body" : tooltipModel.get("appendTo", true)
        });
    };
    TooltipView.prototype.render = function(tooltipModel, ecModel, api) {
        if ((0, $a84633bb9c74d89c$export$2e2bcd8739ae039).node || !api.getDom()) return;
        // Reset
        this.group.removeAll();
        this._tooltipModel = tooltipModel;
        this._ecModel = ecModel;
        this._api = api;
        var tooltipContent = this._tooltipContent;
        tooltipContent.update(tooltipModel);
        tooltipContent.setEnterable(tooltipModel.get("enterable"));
        this._initGlobalListener();
        this._keepShow();
        // PENDING
        // `mousemove` event will be triggered very frequently when the mouse moves fast,
        // which causes that the `updatePosition` function was also called frequently.
        // In Chrome with devtools open and Firefox, tooltip looks laggy and shakes. See #14695 #16101
        // To avoid frequent triggering,
        // consider throttling it in 50ms when transition is enabled
        if (this._renderMode !== "richText" && tooltipModel.get("transitionDuration")) (0, $3a03c388017fa83a$export$958e3e1a02eac4b6)(this, "_updatePosition", 50, "fixRate");
        else (0, $3a03c388017fa83a$export$42ffd38884aecdac)(this, "_updatePosition");
    };
    TooltipView.prototype._initGlobalListener = function() {
        var tooltipModel = this._tooltipModel;
        var triggerOn = tooltipModel.get("triggerOn");
        $3720a9b5b8b4a4bd$export$6503ec6e8aabbaf("itemTooltip", this._api, (0, $43e0a445ed6711da$export$2385a24977818dd0)(function(currTrigger, e, dispatchAction) {
            // If 'none', it is not controlled by mouse totally.
            if (triggerOn !== "none") {
                if (triggerOn.indexOf(currTrigger) >= 0) this._tryShow(e, dispatchAction);
                else if (currTrigger === "leave") this._hide(dispatchAction);
            }
        }, this));
    };
    TooltipView.prototype._keepShow = function() {
        var tooltipModel = this._tooltipModel;
        var ecModel = this._ecModel;
        var api = this._api;
        var triggerOn = tooltipModel.get("triggerOn");
        if (tooltipModel.get("trigger") !== "axis") {
            // _lastDataByCoordSys and _cbParamsList are used for axis tooltip only.
            this._lastDataByCoordSys = null;
            this._cbParamsList = null;
        }
        // Try to keep the tooltip show when refreshing
        if (this._lastX != null && this._lastY != null && triggerOn !== "none" && triggerOn !== "click") {
            var self_1 = this;
            clearTimeout(this._refreshUpdateTimeout);
            this._refreshUpdateTimeout = setTimeout(function() {
                // Show tip next tick after other charts are rendered
                // In case highlight action has wrong result
                // FIXME
                !api.isDisposed() && self_1.manuallyShowTip(tooltipModel, ecModel, api, {
                    x: self_1._lastX,
                    y: self_1._lastY,
                    dataByCoordSys: self_1._lastDataByCoordSys
                });
            });
        }
    };
    /**
   * Show tip manually by
   * dispatchAction({
   *     type: 'showTip',
   *     x: 10,
   *     y: 10
   * });
   * Or
   * dispatchAction({
   *      type: 'showTip',
   *      seriesIndex: 0,
   *      dataIndex or dataIndexInside or name
   * });
   *
   *  TODO Batch
   */ TooltipView.prototype.manuallyShowTip = function(tooltipModel, ecModel, api, payload) {
        if (payload.from === this.uid || (0, $a84633bb9c74d89c$export$2e2bcd8739ae039).node || !api.getDom()) return;
        var dispatchAction = $58b6bf122b8706e8$var$makeDispatchAction(payload, api);
        // Reset ticket
        this._ticket = "";
        // When triggered from axisPointer.
        var dataByCoordSys = payload.dataByCoordSys;
        var cmptRef = $58b6bf122b8706e8$var$findComponentReference(payload, ecModel, api);
        if (cmptRef) {
            var rect = cmptRef.el.getBoundingRect().clone();
            rect.applyTransform(cmptRef.el.transform);
            this._tryShow({
                offsetX: rect.x + rect.width / 2,
                offsetY: rect.y + rect.height / 2,
                target: cmptRef.el,
                position: payload.position,
                // When manully trigger, the mouse is not on the el, so we'd better to
                // position tooltip on the bottom of the el and display arrow is possible.
                positionDefault: "bottom"
            }, dispatchAction);
        } else if (payload.tooltip && payload.x != null && payload.y != null) {
            var el = $58b6bf122b8706e8$var$proxyRect;
            el.x = payload.x;
            el.y = payload.y;
            el.update();
            (0, $7e4afcfca8f5121f$export$b1c39b2bacd1ddc2)(el).tooltipConfig = {
                name: null,
                option: payload.tooltip
            };
            // Manually show tooltip while view is not using zrender elements.
            this._tryShow({
                offsetX: payload.x,
                offsetY: payload.y,
                target: el
            }, dispatchAction);
        } else if (dataByCoordSys) this._tryShow({
            offsetX: payload.x,
            offsetY: payload.y,
            position: payload.position,
            dataByCoordSys: dataByCoordSys,
            tooltipOption: payload.tooltipOption
        }, dispatchAction);
        else if (payload.seriesIndex != null) {
            if (this._manuallyAxisShowTip(tooltipModel, ecModel, api, payload)) return;
            var pointInfo = (0, $172948c0a816aa9c$export$2e2bcd8739ae039)(payload, ecModel);
            var cx = pointInfo.point[0];
            var cy = pointInfo.point[1];
            if (cx != null && cy != null) this._tryShow({
                offsetX: cx,
                offsetY: cy,
                target: pointInfo.el,
                position: payload.position,
                // When manully trigger, the mouse is not on the el, so we'd better to
                // position tooltip on the bottom of the el and display arrow is possible.
                positionDefault: "bottom"
            }, dispatchAction);
        } else if (payload.x != null && payload.y != null) {
            // FIXME
            // should wrap dispatchAction like `axisPointer/globalListener` ?
            api.dispatchAction({
                type: "updateAxisPointer",
                x: payload.x,
                y: payload.y
            });
            this._tryShow({
                offsetX: payload.x,
                offsetY: payload.y,
                position: payload.position,
                target: api.getZr().findHover(payload.x, payload.y).target
            }, dispatchAction);
        }
    };
    TooltipView.prototype.manuallyHideTip = function(tooltipModel, ecModel, api, payload) {
        var tooltipContent = this._tooltipContent;
        if (this._tooltipModel) tooltipContent.hideLater(this._tooltipModel.get("hideDelay"));
        this._lastX = this._lastY = this._lastDataByCoordSys = null;
        this._cbParamsList = null;
        if (payload.from !== this.uid) this._hide($58b6bf122b8706e8$var$makeDispatchAction(payload, api));
    };
    // Be compatible with previous design, that is, when tooltip.type is 'axis' and
    // dispatchAction 'showTip' with seriesIndex and dataIndex will trigger axis pointer
    // and tooltip.
    TooltipView.prototype._manuallyAxisShowTip = function(tooltipModel, ecModel, api, payload) {
        var seriesIndex = payload.seriesIndex;
        var dataIndex = payload.dataIndex;
        // @ts-ignore
        var coordSysAxesInfo = ecModel.getComponent("axisPointer").coordSysAxesInfo;
        if (seriesIndex == null || dataIndex == null || coordSysAxesInfo == null) return;
        var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
        if (!seriesModel) return;
        var data = seriesModel.getData();
        var tooltipCascadedModel = $58b6bf122b8706e8$var$buildTooltipModel([
            data.getItemModel(dataIndex),
            seriesModel,
            (seriesModel.coordinateSystem || {}).model
        ], this._tooltipModel);
        if (tooltipCascadedModel.get("trigger") !== "axis") return;
        api.dispatchAction({
            type: "updateAxisPointer",
            seriesIndex: seriesIndex,
            dataIndex: dataIndex,
            position: payload.position
        });
        return true;
    };
    TooltipView.prototype._tryShow = function(e, dispatchAction) {
        var el = e.target;
        var tooltipModel = this._tooltipModel;
        if (!tooltipModel) return;
        // Save mouse x, mouse y. So we can try to keep showing the tip if chart is refreshed
        this._lastX = e.offsetX;
        this._lastY = e.offsetY;
        var dataByCoordSys = e.dataByCoordSys;
        if (dataByCoordSys && dataByCoordSys.length) this._showAxisTooltip(dataByCoordSys, e);
        else if (el) {
            var ecData = (0, $7e4afcfca8f5121f$export$b1c39b2bacd1ddc2)(el);
            if (ecData.ssrType === "legend") // Don't trigger tooltip for legend tooltip item
            return;
            this._lastDataByCoordSys = null;
            this._cbParamsList = null;
            var seriesDispatcher_1;
            var cmptDispatcher_1;
            (0, $10e23f9ea92ef04e$export$8a4fca9e04eb4df6)(el, function(target) {
                if (target.tooltipDisabled) {
                    seriesDispatcher_1 = cmptDispatcher_1 = null;
                    return true;
                }
                if (seriesDispatcher_1 || cmptDispatcher_1) return;
                // Always show item tooltip if mouse is on the element with dataIndex
                if ((0, $7e4afcfca8f5121f$export$b1c39b2bacd1ddc2)(target).dataIndex != null) seriesDispatcher_1 = target;
                else if ((0, $7e4afcfca8f5121f$export$b1c39b2bacd1ddc2)(target).tooltipConfig != null) cmptDispatcher_1 = target;
            }, true);
            if (seriesDispatcher_1) this._showSeriesItemTooltip(e, seriesDispatcher_1, dispatchAction);
            else if (cmptDispatcher_1) this._showComponentItemTooltip(e, cmptDispatcher_1, dispatchAction);
            else this._hide(dispatchAction);
        } else {
            this._lastDataByCoordSys = null;
            this._cbParamsList = null;
            this._hide(dispatchAction);
        }
    };
    TooltipView.prototype._showOrMove = function(tooltipModel, cb) {
        // showDelay is used in this case: tooltip.enterable is set
        // as true. User intent to move mouse into tooltip and click
        // something. `showDelay` makes it easier to enter the content
        // but tooltip do not move immediately.
        var delay = tooltipModel.get("showDelay");
        cb = (0, $43e0a445ed6711da$export$2385a24977818dd0)(cb, this);
        clearTimeout(this._showTimout);
        delay > 0 ? this._showTimout = setTimeout(cb, delay) : cb();
    };
    TooltipView.prototype._showAxisTooltip = function(dataByCoordSys, e) {
        var ecModel = this._ecModel;
        var globalTooltipModel = this._tooltipModel;
        var point = [
            e.offsetX,
            e.offsetY
        ];
        var singleTooltipModel = $58b6bf122b8706e8$var$buildTooltipModel([
            e.tooltipOption
        ], globalTooltipModel);
        var renderMode = this._renderMode;
        var cbParamsList = [];
        var articleMarkup = (0, $805c7be1c699f811$export$cf63b23ce77d1921)("section", {
            blocks: [],
            noHeader: true
        });
        // Only for legacy: `Serise['formatTooltip']` returns a string.
        var markupTextArrLegacy = [];
        var markupStyleCreator = new (0, $805c7be1c699f811$export$2fba3afbcdcf3e18)();
        (0, $43e0a445ed6711da$export$79b2f7037acddd43)(dataByCoordSys, function(itemCoordSys) {
            (0, $43e0a445ed6711da$export$79b2f7037acddd43)(itemCoordSys.dataByAxis, function(axisItem) {
                var axisModel = ecModel.getComponent(axisItem.axisDim + "Axis", axisItem.axisIndex);
                var axisValue = axisItem.value;
                var axis = axisModel.axis;
                var axisValueParsed = axis.scale.parse(axisValue);
                if (!axisModel || axisValue == null) return;
                // FIXME: when using `tooltip.trigger: 'axis'`, the precision of the axis value displayed in tooltip
                //  should match the original series values rather than using the default strategy in Interval.ts
                //  (getPrecision(interval) + 2); otherwise it may cause confusion.
                var axisValueLabel = $34f90d1e7121e565$export$7cffee0f9aed39d0(axisValue, axis, ecModel, axisItem.seriesDataIndices, axisItem.valueLabelOpt);
                var axisSectionMarkup = (0, $805c7be1c699f811$export$cf63b23ce77d1921)("section", {
                    header: axisValueLabel,
                    noHeader: !(0, $43e0a445ed6711da$export$87c2784dc9fc4ab)(axisValueLabel),
                    sortBlocks: true,
                    blocks: []
                });
                articleMarkup.blocks.push(axisSectionMarkup);
                (0, $43e0a445ed6711da$export$79b2f7037acddd43)(axisItem.seriesDataIndices, function(idxItem) {
                    var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
                    var dataIndex = idxItem.dataIndexInside;
                    var cbParams = series.getDataParams(dataIndex);
                    // Can't find data.
                    if (cbParams.dataIndex < 0) return;
                    cbParams.axisDim = axisItem.axisDim;
                    cbParams.axisIndex = axisItem.axisIndex;
                    cbParams.axisType = axisItem.axisType;
                    cbParams.axisId = axisItem.axisId;
                    cbParams.axisValue = $3e6d0d29922ecf90$export$a5a32f324c1fa457(axisModel.axis, {
                        value: axisValueParsed
                    });
                    cbParams.axisValueLabel = axisValueLabel;
                    // Pre-create marker style for makers. Users can assemble richText
                    // text in `formatter` callback and use those markers style.
                    cbParams.marker = markupStyleCreator.makeTooltipMarker("item", (0, $78c2ece6dfa6bb7a$export$cda04d03233e5555)(cbParams.color), renderMode);
                    var seriesTooltipResult = (0, $f48a6be4420f5faf$export$2d16fa82a50c4741)(series.formatTooltip(dataIndex, true, null));
                    var frag = seriesTooltipResult.frag;
                    if (frag) {
                        var valueFormatter = $58b6bf122b8706e8$var$buildTooltipModel([
                            series
                        ], globalTooltipModel).get("valueFormatter");
                        axisSectionMarkup.blocks.push(valueFormatter ? (0, $43e0a445ed6711da$export$8b58be045bf06082)({
                            valueFormatter: valueFormatter
                        }, frag) : frag);
                    }
                    if (seriesTooltipResult.text) markupTextArrLegacy.push(seriesTooltipResult.text);
                    cbParamsList.push(cbParams);
                });
            });
        });
        // In most cases, the second axis is displays upper on the first one.
        // So we reverse it to look better.
        articleMarkup.blocks.reverse();
        markupTextArrLegacy.reverse();
        var positionExpr = e.position;
        var orderMode = singleTooltipModel.get("order");
        var builtMarkupText = (0, $805c7be1c699f811$export$6969ffb02c1cb49a)(articleMarkup, markupStyleCreator, renderMode, orderMode, ecModel.get("useUTC"), singleTooltipModel.get("textStyle"));
        builtMarkupText && markupTextArrLegacy.unshift(builtMarkupText);
        var blockBreak = renderMode === "richText" ? "\n\n" : "<br/>";
        var allMarkupText = markupTextArrLegacy.join(blockBreak);
        this._showOrMove(singleTooltipModel, function() {
            if (this._updateContentNotChangedOnAxis(dataByCoordSys, cbParamsList)) this._updatePosition(singleTooltipModel, positionExpr, point[0], point[1], this._tooltipContent, cbParamsList);
            else this._showTooltipContent(singleTooltipModel, allMarkupText, cbParamsList, Math.random() + "", point[0], point[1], positionExpr, null, markupStyleCreator);
        });
    // Do not trigger events here, because this branch only be entered
    // from dispatchAction.
    };
    TooltipView.prototype._showSeriesItemTooltip = function(e, dispatcher, dispatchAction) {
        var ecModel = this._ecModel;
        var ecData = (0, $7e4afcfca8f5121f$export$b1c39b2bacd1ddc2)(dispatcher);
        // Use dataModel in element if possible
        // Used when mouseover on a element like markPoint or edge
        // In which case, the data is not main data in series.
        var seriesIndex = ecData.seriesIndex;
        var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
        // For example, graph link.
        var dataModel = ecData.dataModel || seriesModel;
        var dataIndex = ecData.dataIndex;
        var dataType = ecData.dataType;
        var data = dataModel.getData(dataType);
        var renderMode = this._renderMode;
        var positionDefault = e.positionDefault;
        var tooltipModel = $58b6bf122b8706e8$var$buildTooltipModel([
            data.getItemModel(dataIndex),
            dataModel,
            seriesModel && (seriesModel.coordinateSystem || {}).model
        ], this._tooltipModel, positionDefault ? {
            position: positionDefault
        } : null);
        var tooltipTrigger = tooltipModel.get("trigger");
        if (tooltipTrigger != null && tooltipTrigger !== "item") return;
        var params = dataModel.getDataParams(dataIndex, dataType);
        var markupStyleCreator = new (0, $805c7be1c699f811$export$2fba3afbcdcf3e18)();
        // Pre-create marker style for makers. Users can assemble richText
        // text in `formatter` callback and use those markers style.
        params.marker = markupStyleCreator.makeTooltipMarker("item", (0, $78c2ece6dfa6bb7a$export$cda04d03233e5555)(params.color), renderMode);
        var seriesTooltipResult = (0, $f48a6be4420f5faf$export$2d16fa82a50c4741)(dataModel.formatTooltip(dataIndex, false, dataType));
        var orderMode = tooltipModel.get("order");
        var valueFormatter = tooltipModel.get("valueFormatter");
        var frag = seriesTooltipResult.frag;
        var markupText = frag ? (0, $805c7be1c699f811$export$6969ffb02c1cb49a)(valueFormatter ? (0, $43e0a445ed6711da$export$8b58be045bf06082)({
            valueFormatter: valueFormatter
        }, frag) : frag, markupStyleCreator, renderMode, orderMode, ecModel.get("useUTC"), tooltipModel.get("textStyle")) : seriesTooltipResult.text;
        var asyncTicket = "item_" + dataModel.name + "_" + dataIndex;
        this._showOrMove(tooltipModel, function() {
            this._showTooltipContent(tooltipModel, markupText, params, asyncTicket, e.offsetX, e.offsetY, e.position, e.target, markupStyleCreator);
        });
        // FIXME
        // duplicated showtip if manuallyShowTip is called from dispatchAction.
        dispatchAction({
            type: "showTip",
            dataIndexInside: dataIndex,
            dataIndex: data.getRawIndex(dataIndex),
            seriesIndex: seriesIndex,
            from: this.uid
        });
    };
    TooltipView.prototype._showComponentItemTooltip = function(e, el, dispatchAction) {
        var isHTMLRenderMode = this._renderMode === "html";
        var ecData = (0, $7e4afcfca8f5121f$export$b1c39b2bacd1ddc2)(el);
        var tooltipConfig = ecData.tooltipConfig;
        var tooltipOpt = tooltipConfig.option || {};
        var encodeHTMLContent = tooltipOpt.encodeHTMLContent;
        if ((0, $43e0a445ed6711da$export$844ec244b1367d54)(tooltipOpt)) {
            var content = tooltipOpt;
            tooltipOpt = {
                content: content,
                // Fixed formatter
                formatter: content
            };
            // when `tooltipConfig.option` is a string rather than an object,
            // we can't know if the content needs to be encoded
            // for the sake of security, encode it by default.
            encodeHTMLContent = true;
        }
        if (encodeHTMLContent && isHTMLRenderMode && tooltipOpt.content) {
            // clone might be unnecessary?
            tooltipOpt = (0, $43e0a445ed6711da$export$9cd59f9826255e47)(tooltipOpt);
            tooltipOpt.content = (0, $e2318d49eb46f886$export$f9d6449b9af28dc1)(tooltipOpt.content);
        }
        var tooltipModelCascade = [
            tooltipOpt
        ];
        var cmpt = this._ecModel.getComponent(ecData.componentMainType, ecData.componentIndex);
        if (cmpt) tooltipModelCascade.push(cmpt);
        // In most cases, component tooltip formatter has different params with series tooltip formatter,
        // so that they cannot share the same formatter. Since the global tooltip formatter is used for series
        // by convention, we do not use it as the default formatter for component.
        tooltipModelCascade.push({
            formatter: tooltipOpt.content
        });
        var positionDefault = e.positionDefault;
        var subTooltipModel = $58b6bf122b8706e8$var$buildTooltipModel(tooltipModelCascade, this._tooltipModel, positionDefault ? {
            position: positionDefault
        } : null);
        var defaultHtml = subTooltipModel.get("content");
        var asyncTicket = Math.random() + "";
        // PENDING: this case do not support richText style yet.
        var markupStyleCreator = new (0, $805c7be1c699f811$export$2fba3afbcdcf3e18)();
        // Do not check whether `trigger` is 'none' here, because `trigger`
        // only works on coordinate system. In fact, we have not found case
        // that requires setting `trigger` nothing on component yet.
        this._showOrMove(subTooltipModel, function() {
            // Use formatterParams from element defined in component
            // Avoid users modify it.
            var formatterParams = (0, $43e0a445ed6711da$export$9cd59f9826255e47)(subTooltipModel.get("formatterParams") || {});
            this._showTooltipContent(subTooltipModel, defaultHtml, formatterParams, asyncTicket, e.offsetX, e.offsetY, e.position, el, markupStyleCreator);
        });
        // If not dispatch showTip, tip may be hide triggered by axis.
        dispatchAction({
            type: "showTip",
            from: this.uid
        });
    };
    TooltipView.prototype._showTooltipContent = function(// Use Model<TooltipOption> instead of TooltipModel because this model may be from series or other options.
    // Instead of top level tooltip.
    tooltipModel, defaultHtml, params, asyncTicket, x, y, positionExpr, el, markupStyleCreator) {
        // Reset ticket
        this._ticket = "";
        if (!tooltipModel.get("showContent") || !tooltipModel.get("show")) return;
        var tooltipContent = this._tooltipContent;
        tooltipContent.setEnterable(tooltipModel.get("enterable"));
        var formatter = tooltipModel.get("formatter");
        positionExpr = positionExpr || tooltipModel.get("position");
        var html = defaultHtml;
        var nearPoint = this._getNearestPoint([
            x,
            y
        ], params, tooltipModel.get("trigger"), tooltipModel.get("borderColor"), tooltipModel.get("defaultBorderColor", true));
        var nearPointColor = nearPoint.color;
        if (formatter) {
            if ((0, $43e0a445ed6711da$export$844ec244b1367d54)(formatter)) {
                var useUTC = tooltipModel.ecModel.get("useUTC");
                var params0 = (0, $43e0a445ed6711da$export$43bee75e5e14138e)(params) ? params[0] : params;
                var isTimeAxis = params0 && params0.axisType && params0.axisType.indexOf("time") >= 0;
                html = formatter;
                if (isTimeAxis) html = (0, $d28d71d6b904c104$export$d9468344d3651243)(params0.axisValue, html, useUTC);
                html = (0, $78c2ece6dfa6bb7a$export$2028496a35766e41)(html, params, true);
            } else if ((0, $43e0a445ed6711da$export$f6e2535fb5126e54)(formatter)) {
                var callback = (0, $43e0a445ed6711da$export$2385a24977818dd0)(function(cbTicket, html) {
                    if (cbTicket === this._ticket) {
                        tooltipContent.setContent(html, markupStyleCreator, tooltipModel, nearPointColor, positionExpr);
                        this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
                    }
                }, this);
                this._ticket = asyncTicket;
                html = formatter(params, asyncTicket, callback);
            } else html = formatter;
        }
        tooltipContent.setContent(html, markupStyleCreator, tooltipModel, nearPointColor, positionExpr);
        tooltipContent.show(tooltipModel, nearPointColor);
        this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
    };
    TooltipView.prototype._getNearestPoint = function(point, tooltipDataParams, trigger, borderColor, defaultBorderColor) {
        if (trigger === "axis" || (0, $43e0a445ed6711da$export$43bee75e5e14138e)(tooltipDataParams)) return {
            color: borderColor || defaultBorderColor
        };
        if (!(0, $43e0a445ed6711da$export$43bee75e5e14138e)(tooltipDataParams)) return {
            color: borderColor || tooltipDataParams.color || tooltipDataParams.borderColor
        };
    };
    TooltipView.prototype._updatePosition = function(tooltipModel, positionExpr, x, // Mouse x
    y, // Mouse y
    content, params, el) {
        var viewWidth = this._api.getWidth();
        var viewHeight = this._api.getHeight();
        positionExpr = positionExpr || tooltipModel.get("position");
        var contentSize = content.getSize();
        var align = tooltipModel.get("align");
        var vAlign = tooltipModel.get("verticalAlign");
        var rect = el && el.getBoundingRect().clone();
        el && rect.applyTransform(el.transform);
        if ((0, $43e0a445ed6711da$export$f6e2535fb5126e54)(positionExpr)) // Callback of position can be an array or a string specify the position
        positionExpr = positionExpr([
            x,
            y
        ], params, content.el, rect, {
            viewSize: [
                viewWidth,
                viewHeight
            ],
            contentSize: contentSize.slice()
        });
        if ((0, $43e0a445ed6711da$export$43bee75e5e14138e)(positionExpr)) {
            x = (0, $b49750109e236fd8$export$e8514cb5a5e2b40f)(positionExpr[0], viewWidth);
            y = (0, $b49750109e236fd8$export$e8514cb5a5e2b40f)(positionExpr[1], viewHeight);
        } else if ((0, $43e0a445ed6711da$export$a6cdc56e425d0d0a)(positionExpr)) {
            var boxLayoutPosition = positionExpr;
            boxLayoutPosition.width = contentSize[0];
            boxLayoutPosition.height = contentSize[1];
            var layoutRect = (0, $826bc4094efae72b$export$4517a5ca639a7293)(boxLayoutPosition, {
                width: viewWidth,
                height: viewHeight
            });
            x = layoutRect.x;
            y = layoutRect.y;
            align = null;
            // When positionExpr is left/top/right/bottom,
            // align and verticalAlign will not work.
            vAlign = null;
        } else if ((0, $43e0a445ed6711da$export$844ec244b1367d54)(positionExpr) && el) {
            var pos = $58b6bf122b8706e8$var$calcTooltipPosition(positionExpr, rect, contentSize, tooltipModel.get("borderWidth"));
            x = pos[0];
            y = pos[1];
        } else {
            var pos = $58b6bf122b8706e8$var$refixTooltipPosition(x, y, content, viewWidth, viewHeight, align ? null : 20, vAlign ? null : 20);
            x = pos[0];
            y = pos[1];
        }
        align && (x -= $58b6bf122b8706e8$var$isCenterAlign(align) ? contentSize[0] / 2 : align === "right" ? contentSize[0] : 0);
        vAlign && (y -= $58b6bf122b8706e8$var$isCenterAlign(vAlign) ? contentSize[1] / 2 : vAlign === "bottom" ? contentSize[1] : 0);
        if ((0, $a354c0f7db071b45$export$a309528050824ba4)(tooltipModel)) {
            var pos = $58b6bf122b8706e8$var$confineTooltipPosition(x, y, content, viewWidth, viewHeight);
            x = pos[0];
            y = pos[1];
        }
        content.moveTo(x, y);
    };
    // FIXME
    // Should we remove this but leave this to user?
    TooltipView.prototype._updateContentNotChangedOnAxis = function(dataByCoordSys, cbParamsList) {
        var lastCoordSys = this._lastDataByCoordSys;
        var lastCbParamsList = this._cbParamsList;
        var contentNotChanged = !!lastCoordSys && lastCoordSys.length === dataByCoordSys.length;
        contentNotChanged && (0, $43e0a445ed6711da$export$79b2f7037acddd43)(lastCoordSys, function(lastItemCoordSys, indexCoordSys) {
            var lastDataByAxis = lastItemCoordSys.dataByAxis || [];
            var thisItemCoordSys = dataByCoordSys[indexCoordSys] || {};
            var thisDataByAxis = thisItemCoordSys.dataByAxis || [];
            contentNotChanged = contentNotChanged && lastDataByAxis.length === thisDataByAxis.length;
            contentNotChanged && (0, $43e0a445ed6711da$export$79b2f7037acddd43)(lastDataByAxis, function(lastItem, indexAxis) {
                var thisItem = thisDataByAxis[indexAxis] || {};
                var lastIndices = lastItem.seriesDataIndices || [];
                var newIndices = thisItem.seriesDataIndices || [];
                contentNotChanged = contentNotChanged && lastItem.value === thisItem.value && lastItem.axisType === thisItem.axisType && lastItem.axisId === thisItem.axisId && lastIndices.length === newIndices.length;
                contentNotChanged && (0, $43e0a445ed6711da$export$79b2f7037acddd43)(lastIndices, function(lastIdxItem, j) {
                    var newIdxItem = newIndices[j];
                    contentNotChanged = contentNotChanged && lastIdxItem.seriesIndex === newIdxItem.seriesIndex && lastIdxItem.dataIndex === newIdxItem.dataIndex;
                });
                // check is cbParams data value changed
                lastCbParamsList && (0, $43e0a445ed6711da$export$79b2f7037acddd43)(lastItem.seriesDataIndices, function(idxItem) {
                    var seriesIdx = idxItem.seriesIndex;
                    var cbParams = cbParamsList[seriesIdx];
                    var lastCbParams = lastCbParamsList[seriesIdx];
                    if (cbParams && lastCbParams && lastCbParams.data !== cbParams.data) contentNotChanged = false;
                });
            });
        });
        this._lastDataByCoordSys = dataByCoordSys;
        this._cbParamsList = cbParamsList;
        return !!contentNotChanged;
    };
    TooltipView.prototype._hide = function(dispatchAction) {
        // Do not directly hideLater here, because this behavior may be prevented
        // in dispatchAction when showTip is dispatched.
        // FIXME
        // duplicated hideTip if manuallyHideTip is called from dispatchAction.
        this._lastDataByCoordSys = null;
        this._cbParamsList = null;
        dispatchAction({
            type: "hideTip",
            from: this.uid
        });
    };
    TooltipView.prototype.dispose = function(ecModel, api) {
        if ((0, $a84633bb9c74d89c$export$2e2bcd8739ae039).node || !api.getDom()) return;
        (0, $3a03c388017fa83a$export$42ffd38884aecdac)(this, "_updatePosition");
        this._tooltipContent.dispose();
        $3720a9b5b8b4a4bd$export$d07f55d4c15c0440("itemTooltip", api);
        this._tooltipContent = null;
        this._tooltipModel = null;
        this._lastDataByCoordSys = null;
        this._cbParamsList = null;
    };
    TooltipView.type = "tooltip";
    return TooltipView;
}((0, $c81700f6bd52c5a7$export$2e2bcd8739ae039));
/**
 * From top to bottom. (the last one should be globalTooltipModel);
 */ function $58b6bf122b8706e8$var$buildTooltipModel(modelCascade, globalTooltipModel, defaultTooltipOption) {
    // Last is always tooltip model.
    var ecModel = globalTooltipModel.ecModel;
    var resultModel;
    if (defaultTooltipOption) {
        resultModel = new (0, $279973fc50f77a15$export$2e2bcd8739ae039)(defaultTooltipOption, ecModel, ecModel);
        resultModel = new (0, $279973fc50f77a15$export$2e2bcd8739ae039)(globalTooltipModel.option, resultModel, ecModel);
    } else resultModel = globalTooltipModel;
    for(var i = modelCascade.length - 1; i >= 0; i--){
        var tooltipOpt = modelCascade[i];
        if (tooltipOpt) {
            if (tooltipOpt instanceof (0, $279973fc50f77a15$export$2e2bcd8739ae039)) tooltipOpt = tooltipOpt.get("tooltip", true);
            // In each data item tooltip can be simply write:
            // {
            //  value: 10,
            //  tooltip: 'Something you need to know'
            // }
            if ((0, $43e0a445ed6711da$export$844ec244b1367d54)(tooltipOpt)) tooltipOpt = {
                formatter: tooltipOpt
            };
            if (tooltipOpt) resultModel = new (0, $279973fc50f77a15$export$2e2bcd8739ae039)(tooltipOpt, resultModel, ecModel);
        }
    }
    return resultModel;
}
function $58b6bf122b8706e8$var$makeDispatchAction(payload, api) {
    return payload.dispatchAction || (0, $43e0a445ed6711da$export$2385a24977818dd0)(api.dispatchAction, api);
}
function $58b6bf122b8706e8$var$refixTooltipPosition(x, y, content, viewWidth, viewHeight, gapH, gapV) {
    var size = content.getSize();
    var width = size[0];
    var height = size[1];
    if (gapH != null) {
        // Add extra 2 pixels for this case:
        // At present the "values" in default tooltip are using CSS `float: right`.
        // When the right edge of the tooltip box is on the right side of the
        // viewport, the `float` layout might push the "values" to the second line.
        if (x + width + gapH + 2 > viewWidth) x -= width + gapH;
        else x += gapH;
    }
    if (gapV != null) {
        if (y + height + gapV > viewHeight) y -= height + gapV;
        else y += gapV;
    }
    return [
        x,
        y
    ];
}
function $58b6bf122b8706e8$var$confineTooltipPosition(x, y, content, viewWidth, viewHeight) {
    var size = content.getSize();
    var width = size[0];
    var height = size[1];
    x = Math.min(x + width, viewWidth) - width;
    y = Math.min(y + height, viewHeight) - height;
    x = Math.max(x, 0);
    y = Math.max(y, 0);
    return [
        x,
        y
    ];
}
function $58b6bf122b8706e8$var$calcTooltipPosition(position, rect, contentSize, borderWidth) {
    var domWidth = contentSize[0];
    var domHeight = contentSize[1];
    var offset = Math.ceil(Math.SQRT2 * borderWidth) + 8;
    var x = 0;
    var y = 0;
    var rectWidth = rect.width;
    var rectHeight = rect.height;
    switch(position){
        case "inside":
            x = rect.x + rectWidth / 2 - domWidth / 2;
            y = rect.y + rectHeight / 2 - domHeight / 2;
            break;
        case "top":
            x = rect.x + rectWidth / 2 - domWidth / 2;
            y = rect.y - domHeight - offset;
            break;
        case "bottom":
            x = rect.x + rectWidth / 2 - domWidth / 2;
            y = rect.y + rectHeight + offset;
            break;
        case "left":
            x = rect.x - domWidth - offset;
            y = rect.y + rectHeight / 2 - domHeight / 2;
            break;
        case "right":
            x = rect.x + rectWidth + offset;
            y = rect.y + rectHeight / 2 - domHeight / 2;
    }
    return [
        x,
        y
    ];
}
function $58b6bf122b8706e8$var$isCenterAlign(align) {
    return align === "center" || align === "middle";
}
/**
 * Find target component by payload like:
 * ```js
 * { legendId: 'some_id', name: 'xxx' }
 * { toolboxIndex: 1, name: 'xxx' }
 * { geoName: 'some_name', name: 'xxx' }
 * ```
 * PENDING: at present only
 *
 * If not found, return null/undefined.
 */ function $58b6bf122b8706e8$var$findComponentReference(payload, ecModel, api) {
    var queryOptionMap = (0, $87f4a59ac66e0ee6$export$fe600815775d9400)(payload).queryOptionMap;
    var componentMainType = queryOptionMap.keys()[0];
    if (!componentMainType || componentMainType === "series") return;
    var queryResult = (0, $87f4a59ac66e0ee6$export$dc741340f7e5f186)(ecModel, componentMainType, queryOptionMap.get(componentMainType), {
        useDefault: false,
        enableAll: false,
        enableNone: false
    });
    var model = queryResult.models[0];
    if (!model) return;
    var view = api.getViewOfComponentModel(model);
    var el;
    view.group.traverse(function(subEl) {
        var tooltipConfig = (0, $7e4afcfca8f5121f$export$b1c39b2bacd1ddc2)(subEl).tooltipConfig;
        if (tooltipConfig && tooltipConfig.name === payload.name) {
            el = subEl;
            return true; // stop
        }
    });
    if (el) return {
        componentMainType: componentMainType,
        componentIndex: model.componentIndex,
        el: el
    };
}
var $58b6bf122b8706e8$export$2e2bcd8739ae039 = $58b6bf122b8706e8$var$TooltipView;



function $a284e3b35d3412c3$export$4b3e715f166fdd78(registers) {
    (0, $8f6e8e1f1e941d98$export$1f96ae73734a86cc)((0, $038a39790a59cee8$export$4b3e715f166fdd78));
    registers.registerComponentModel((0, $c6ea17e005d9942d$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $58b6bf122b8706e8$export$2e2bcd8739ae039));
    /**
   * @action
   * @property {string} type
   * @property {number} seriesIndex
   * @property {number} dataIndex
   * @property {number} [x]
   * @property {number} [y]
   */ registers.registerAction({
        type: "showTip",
        event: "showTip",
        update: "tooltip:manuallyShowTip"
    }, (0, $43e0a445ed6711da$export$8793edee2d425525));
    registers.registerAction({
        type: "hideTip",
        event: "hideTip",
        update: "tooltip:manuallyHideTip"
    }, (0, $43e0a445ed6711da$export$8793edee2d425525));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $069fa11c93b2880e$var$getDefaultSelectorOptions = function(ecModel, type) {
    if (type === "all") return {
        type: "all",
        title: ecModel.getLocaleModel().get([
            "legend",
            "selector",
            "all"
        ])
    };
    else if (type === "inverse") return {
        type: "inverse",
        title: ecModel.getLocaleModel().get([
            "legend",
            "selector",
            "inverse"
        ])
    };
};
var $069fa11c93b2880e$var$LegendModel = /** @class */ function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(LegendModel, _super);
    function LegendModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = LegendModel.type;
        _this.layoutMode = {
            type: "box",
            // legend.width/height are maxWidth/maxHeight actually,
            // whereas real width/height is calculated by its content.
            // (Setting {left: 10, right: 10} does not make sense).
            // So consider the case:
            // `setOption({legend: {left: 10});`
            // then `setOption({legend: {right: 10});`
            // The previous `left` should be cleared by setting `ignoreSize`.
            ignoreSize: true
        };
        return _this;
    }
    LegendModel.prototype.init = function(option, parentModel, ecModel) {
        this.mergeDefaultAndTheme(option, ecModel);
        option.selected = option.selected || {};
        this._updateSelector(option);
    };
    LegendModel.prototype.mergeOption = function(option, ecModel) {
        _super.prototype.mergeOption.call(this, option, ecModel);
        this._updateSelector(option);
    };
    LegendModel.prototype._updateSelector = function(option) {
        var selector = option.selector;
        var ecModel = this.ecModel;
        if (selector === true) selector = option.selector = [
            "all",
            "inverse"
        ];
        if ($43e0a445ed6711da$export$43bee75e5e14138e(selector)) $43e0a445ed6711da$export$79b2f7037acddd43(selector, function(item, index) {
            $43e0a445ed6711da$export$844ec244b1367d54(item) && (item = {
                type: item
            });
            selector[index] = $43e0a445ed6711da$export$4950aa0f605343fb(item, $069fa11c93b2880e$var$getDefaultSelectorOptions(ecModel, item.type));
        });
    };
    LegendModel.prototype.optionUpdated = function() {
        this._updateData(this.ecModel);
        var legendData = this._data;
        // If selectedMode is single, try to select one
        if (legendData[0] && this.get("selectedMode") === "single") {
            var hasSelected = false;
            // If has any selected in option.selected
            for(var i = 0; i < legendData.length; i++){
                var name_1 = legendData[i].get("name");
                if (this.isSelected(name_1)) {
                    // Force to unselect others
                    this.select(name_1);
                    hasSelected = true;
                    break;
                }
            }
            // Try select the first if selectedMode is single
            !hasSelected && this.select(legendData[0].get("name"));
        }
    };
    LegendModel.prototype._updateData = function(ecModel) {
        var potentialData = [];
        var availableNames = [];
        ecModel.eachRawSeries(function(seriesModel) {
            var seriesName = seriesModel.name;
            availableNames.push(seriesName);
            var isPotential;
            if (seriesModel.legendVisualProvider) {
                var provider = seriesModel.legendVisualProvider;
                var names = provider.getAllNames();
                if (!ecModel.isSeriesFiltered(seriesModel)) availableNames = availableNames.concat(names);
                if (names.length) potentialData = potentialData.concat(names);
                else isPotential = true;
            } else isPotential = true;
            if (isPotential && (0, $87f4a59ac66e0ee6$export$beae19a2652b3368)(seriesModel)) potentialData.push(seriesModel.name);
        });
        /**
     * @type {Array.<string>}
     * @private
     */ this._availableNames = availableNames;
        // If legend.data is not specified in option, use availableNames as data,
        // which is convenient for user preparing option.
        var rawData = this.get("data") || potentialData;
        var legendNameMap = $43e0a445ed6711da$export$55f8aa7ef875b0a4();
        var legendData = $43e0a445ed6711da$export$871de8747c9eaa88(rawData, function(dataItem) {
            // Can be string or number
            if ($43e0a445ed6711da$export$844ec244b1367d54(dataItem) || $43e0a445ed6711da$export$7e4aa119212bc614(dataItem)) dataItem = {
                name: dataItem
            };
            if (legendNameMap.get(dataItem.name)) // remove legend name duplicate
            return null;
            legendNameMap.set(dataItem.name, true);
            return new (0, $279973fc50f77a15$export$2e2bcd8739ae039)(dataItem, this, this.ecModel);
        }, this);
        /**
     * @type {Array.<module:echarts/model/Model>}
     * @private
     */ this._data = $43e0a445ed6711da$export$3dea766d36a8935f(legendData, function(item) {
            return !!item;
        });
    };
    LegendModel.prototype.getData = function() {
        return this._data;
    };
    LegendModel.prototype.select = function(name) {
        var selected = this.option.selected;
        var selectedMode = this.get("selectedMode");
        if (selectedMode === "single") {
            var data = this._data;
            $43e0a445ed6711da$export$79b2f7037acddd43(data, function(dataItem) {
                selected[dataItem.get("name")] = false;
            });
        }
        selected[name] = true;
    };
    LegendModel.prototype.unSelect = function(name) {
        if (this.get("selectedMode") !== "single") this.option.selected[name] = false;
    };
    LegendModel.prototype.toggleSelected = function(name) {
        var selected = this.option.selected;
        // Default is true
        if (!selected.hasOwnProperty(name)) selected[name] = true;
        this[selected[name] ? "unSelect" : "select"](name);
    };
    LegendModel.prototype.allSelect = function() {
        var data = this._data;
        var selected = this.option.selected;
        $43e0a445ed6711da$export$79b2f7037acddd43(data, function(dataItem) {
            selected[dataItem.get("name", true)] = true;
        });
    };
    LegendModel.prototype.inverseSelect = function() {
        var data = this._data;
        var selected = this.option.selected;
        $43e0a445ed6711da$export$79b2f7037acddd43(data, function(dataItem) {
            var name = dataItem.get("name", true);
            // Initially, default value is true
            if (!selected.hasOwnProperty(name)) selected[name] = true;
            selected[name] = !selected[name];
        });
    };
    LegendModel.prototype.isSelected = function(name) {
        var selected = this.option.selected;
        return !(selected.hasOwnProperty(name) && !selected[name]) && $43e0a445ed6711da$export$305f7d4e9d4624f2(this._availableNames, name) >= 0;
    };
    LegendModel.prototype.getOrient = function() {
        return this.get("orient") === "vertical" ? {
            index: 1,
            name: "vertical"
        } : {
            index: 0,
            name: "horizontal"
        };
    };
    LegendModel.type = "legend.plain";
    LegendModel.dependencies = [
        "series"
    ];
    LegendModel.defaultOption = {
        // zlevel: 0,
        z: 4,
        show: true,
        orient: "horizontal",
        left: "center",
        // right: 'center',
        // top: 0,
        bottom: (0, $8327d823e00b772c$export$2e2bcd8739ae039).size.m,
        align: "auto",
        backgroundColor: (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.transparent,
        borderColor: (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.border,
        borderRadius: 0,
        borderWidth: 0,
        padding: 5,
        itemGap: 8,
        itemWidth: 25,
        itemHeight: 14,
        symbolRotate: "inherit",
        symbolKeepAspect: true,
        inactiveColor: (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.disabled,
        inactiveBorderColor: (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.disabled,
        inactiveBorderWidth: "auto",
        itemStyle: {
            color: "inherit",
            opacity: "inherit",
            borderColor: "inherit",
            borderWidth: "auto",
            borderCap: "inherit",
            borderJoin: "inherit",
            borderDashOffset: "inherit",
            borderMiterLimit: "inherit"
        },
        lineStyle: {
            width: "auto",
            color: "inherit",
            inactiveColor: (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.disabled,
            inactiveWidth: 2,
            opacity: "inherit",
            type: "inherit",
            cap: "inherit",
            join: "inherit",
            dashOffset: "inherit",
            miterLimit: "inherit"
        },
        textStyle: {
            color: (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.secondary
        },
        selectedMode: true,
        selector: false,
        selectorLabel: {
            show: true,
            borderRadius: 10,
            padding: [
                3,
                5,
                3,
                5
            ],
            fontSize: 12,
            fontFamily: "sans-serif",
            color: (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.tertiary,
            borderWidth: 1,
            borderColor: (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.border
        },
        emphasis: {
            selectorLabel: {
                show: true,
                color: (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.quaternary
            }
        },
        selectorPosition: "auto",
        selectorItemGap: 7,
        selectorButtonGap: 10,
        tooltip: {
            show: false
        },
        triggerEvent: false
    };
    return LegendModel;
}((0, $4a9041b12b787d1b$export$2e2bcd8739ae039));
var $069fa11c93b2880e$export$2e2bcd8739ae039 = $069fa11c93b2880e$var$LegendModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $10d60f22f3306c0d$export$fae23936eedfad4f(rect, componentModel) {
    var padding = $78c2ece6dfa6bb7a$export$f3a38102c49f4268(componentModel.get("padding"));
    var style = componentModel.getItemStyle([
        "color",
        "opacity"
    ]);
    style.fill = componentModel.get("backgroundColor");
    var bgRect = new $42ed508a93973e78$export$2e2bcd8739ae039({
        shape: {
            x: rect.x - padding[3],
            y: rect.y - padding[0],
            width: rect.width + padding[1] + padding[3],
            height: rect.height + padding[0] + padding[2],
            r: componentModel.get("borderRadius")
        },
        style: style,
        silent: true,
        z2: -1
    });
    // FIXME
    // `subPixelOptimizeRect` may bring some gap between edge of viewpart
    // and background rect when setting like `left: 0`, `top: 0`.
    // graphic.subPixelOptimizeRect(rect);
    return bgRect;
}








var $08c3412b120bf58f$var$curry = $43e0a445ed6711da$export$c3095a23b368d1f2;
var $08c3412b120bf58f$var$each = $43e0a445ed6711da$export$79b2f7037acddd43;
var $08c3412b120bf58f$var$Group = $a8978f7a0e842e3d$export$2e2bcd8739ae039;
var $08c3412b120bf58f$var$LegendView = /** @class */ function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(LegendView, _super);
    function LegendView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = LegendView.type;
        _this.newlineDisabled = false;
        return _this;
    }
    LegendView.prototype.init = function() {
        this.group.add(this._contentGroup = new $08c3412b120bf58f$var$Group());
        this.group.add(this._selectorGroup = new $08c3412b120bf58f$var$Group());
        this._isFirstRender = true;
    };
    /**
   * @protected
   */ LegendView.prototype.getContentGroup = function() {
        return this._contentGroup;
    };
    /**
   * @protected
   */ LegendView.prototype.getSelectorGroup = function() {
        return this._selectorGroup;
    };
    /**
   * @override
   */ LegendView.prototype.render = function(legendModel, ecModel, api) {
        var isFirstRender = this._isFirstRender;
        this._isFirstRender = false;
        this.resetInner();
        if (!legendModel.get("show", true)) return;
        var itemAlign = legendModel.get("align");
        var orient = legendModel.get("orient");
        if (!itemAlign || itemAlign === "auto") itemAlign = legendModel.get("left") === "right" && orient === "vertical" ? "right" : "left";
        // selector has been normalized to an array in model
        var selector = legendModel.get("selector", true);
        var selectorPosition = legendModel.get("selectorPosition", true);
        if (selector && (!selectorPosition || selectorPosition === "auto")) selectorPosition = orient === "horizontal" ? "end" : "start";
        this.renderInner(itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition);
        // Perform layout.
        var refContainer = $826bc4094efae72b$export$5aec1e94f566e59f(legendModel, api).refContainer;
        var positionInfo = legendModel.getBoxLayoutParams();
        var padding = legendModel.get("padding");
        var maxSize = $826bc4094efae72b$export$4517a5ca639a7293(positionInfo, refContainer, padding);
        var mainRect = this.layoutInner(legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition);
        // Place mainGroup, based on the calculated `mainRect`.
        var layoutRect = $826bc4094efae72b$export$4517a5ca639a7293($43e0a445ed6711da$export$ebe90cb607ad99e({
            width: mainRect.width,
            height: mainRect.height
        }, positionInfo), refContainer, padding);
        this.group.x = layoutRect.x - mainRect.x;
        this.group.y = layoutRect.y - mainRect.y;
        this.group.markRedraw();
        // Render background after group is layout.
        this.group.add(this._backgroundEl = (0, $10d60f22f3306c0d$export$fae23936eedfad4f)(mainRect, // FXIME: most itemStyle options does not work in background because inherit is not handled yet.
        legendModel));
    };
    LegendView.prototype.resetInner = function() {
        this.getContentGroup().removeAll();
        this._backgroundEl && this.group.remove(this._backgroundEl);
        this.getSelectorGroup().removeAll();
    };
    LegendView.prototype.renderInner = function(itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition) {
        var contentGroup = this.getContentGroup();
        var legendDrawnMap = $43e0a445ed6711da$export$55f8aa7ef875b0a4();
        var selectMode = legendModel.get("selectedMode");
        var triggerEvent = legendModel.get("triggerEvent");
        var excludeSeriesId = [];
        ecModel.eachRawSeries(function(seriesModel) {
            !seriesModel.get("legendHoverLink") && excludeSeriesId.push(seriesModel.id);
        });
        $08c3412b120bf58f$var$each(legendModel.getData(), function(legendItemModel, dataIndex) {
            var _this = this;
            var name = legendItemModel.get("name");
            // Use empty string or \n as a newline string
            if (!this.newlineDisabled && (name === "" || name === "\n")) {
                var g = new $08c3412b120bf58f$var$Group();
                // @ts-ignore
                g.newline = true;
                contentGroup.add(g);
                return;
            }
            // Representitive series.
            var seriesModel = ecModel.getSeriesByName(name)[0];
            if (legendDrawnMap.get(name)) // Have been drawn
            return;
            // Legend to control series.
            if (seriesModel) {
                var data = seriesModel.getData();
                var lineVisualStyle = data.getVisual("legendLineStyle") || {};
                var legendIcon = data.getVisual("legendIcon");
                /**
         * `data.getVisual('style')` may be the color from the register
         * in series. For example, for line series,
         */ var style = data.getVisual("style");
                var itemGroup = this._createItem(seriesModel, name, dataIndex, legendItemModel, legendModel, itemAlign, lineVisualStyle, style, legendIcon, selectMode, api);
                itemGroup.on("click", $08c3412b120bf58f$var$curry($08c3412b120bf58f$var$dispatchSelectAction, name, null, api, excludeSeriesId)).on("mouseover", $08c3412b120bf58f$var$curry($08c3412b120bf58f$var$dispatchHighlightAction, seriesModel.name, null, api, excludeSeriesId)).on("mouseout", $08c3412b120bf58f$var$curry($08c3412b120bf58f$var$dispatchDownplayAction, seriesModel.name, null, api, excludeSeriesId));
                if (ecModel.ssr) itemGroup.eachChild(function(child) {
                    var ecData = (0, $7e4afcfca8f5121f$export$b1c39b2bacd1ddc2)(child);
                    ecData.seriesIndex = seriesModel.seriesIndex;
                    ecData.dataIndex = dataIndex;
                    ecData.ssrType = "legend";
                });
                if (triggerEvent) itemGroup.eachChild(function(child) {
                    _this.packEventData(child, legendModel, seriesModel, dataIndex, name);
                });
                legendDrawnMap.set(name, true);
            } else // Legend to control data. In pie and funnel.
            ecModel.eachRawSeries(function(seriesModel) {
                var _this = this;
                // In case multiple series has same data name
                if (legendDrawnMap.get(name)) return;
                if (seriesModel.legendVisualProvider) {
                    var provider = seriesModel.legendVisualProvider;
                    if (!provider.containName(name)) return;
                    var idx = provider.indexOfName(name);
                    var style = provider.getItemVisual(idx, "style");
                    var legendIcon = provider.getItemVisual(idx, "legendIcon");
                    var colorArr = (0, $b0979f18b0a232f9$export$98e6a39c04603d36)(style.fill);
                    // Color may be set to transparent in visualMap when data is out of range.
                    // Do not show nothing.
                    if (colorArr && colorArr[3] === 0) {
                        colorArr[3] = 0.2;
                        // TODO color is set to 0, 0, 0, 0. Should show correct RGBA
                        style = $43e0a445ed6711da$export$8b58be045bf06082($43e0a445ed6711da$export$8b58be045bf06082({}, style), {
                            fill: (0, $b0979f18b0a232f9$export$fac44ee5b035f737)(colorArr, "rgba")
                        });
                    }
                    var itemGroup = this._createItem(seriesModel, name, dataIndex, legendItemModel, legendModel, itemAlign, {}, style, legendIcon, selectMode, api);
                    // FIXME: consider different series has items with the same name.
                    itemGroup.on("click", $08c3412b120bf58f$var$curry($08c3412b120bf58f$var$dispatchSelectAction, null, name, api, excludeSeriesId))// Should not specify the series name, consider legend controls
                    // more than one pie series.
                    .on("mouseover", $08c3412b120bf58f$var$curry($08c3412b120bf58f$var$dispatchHighlightAction, null, name, api, excludeSeriesId)).on("mouseout", $08c3412b120bf58f$var$curry($08c3412b120bf58f$var$dispatchDownplayAction, null, name, api, excludeSeriesId));
                    if (ecModel.ssr) itemGroup.eachChild(function(child) {
                        var ecData = (0, $7e4afcfca8f5121f$export$b1c39b2bacd1ddc2)(child);
                        ecData.seriesIndex = seriesModel.seriesIndex;
                        ecData.dataIndex = dataIndex;
                        ecData.ssrType = "legend";
                    });
                    if (triggerEvent) itemGroup.eachChild(function(child) {
                        _this.packEventData(child, legendModel, seriesModel, dataIndex, name);
                    });
                    legendDrawnMap.set(name, true);
                }
            }, this);
        }, this);
        if (selector) this._createSelector(selector, legendModel, api, orient, selectorPosition);
    };
    LegendView.prototype.packEventData = function(el, legendModel, seriesModel, dataIndex, name) {
        var eventData = {
            componentType: "legend",
            componentIndex: legendModel.componentIndex,
            dataIndex: dataIndex,
            value: name,
            seriesIndex: seriesModel.seriesIndex
        };
        (0, $7e4afcfca8f5121f$export$b1c39b2bacd1ddc2)(el).eventData = eventData;
    };
    LegendView.prototype._createSelector = function(selector, legendModel, api, orient, selectorPosition) {
        var selectorGroup = this.getSelectorGroup();
        $08c3412b120bf58f$var$each(selector, function createSelectorButton(selectorItem) {
            var type = selectorItem.type;
            var labelText = new $7db7960d25b39b7c$export$2e2bcd8739ae039({
                style: {
                    x: 0,
                    y: 0,
                    align: "center",
                    verticalAlign: "middle"
                },
                onclick: function() {
                    api.dispatchAction({
                        type: type === "all" ? "legendAllSelect" : "legendInverseSelect",
                        legendId: legendModel.id
                    });
                }
            });
            selectorGroup.add(labelText);
            var labelModel = legendModel.getModel("selectorLabel");
            var emphasisLabelModel = legendModel.getModel([
                "emphasis",
                "selectorLabel"
            ]);
            (0, $6556fe1ed9fb479d$export$9a13992917966657)(labelText, {
                normal: labelModel,
                emphasis: emphasisLabelModel
            }, {
                defaultText: selectorItem.title
            });
            (0, $fffc76734a157b4c$export$5f393df0b5aee2e7)(labelText);
        });
    };
    LegendView.prototype._createItem = function(seriesModel, name, dataIndex, legendItemModel, legendModel, itemAlign, lineVisualStyle, itemVisualStyle, legendIcon, selectMode, api) {
        var drawType = seriesModel.visualDrawType;
        var itemWidth = legendModel.get("itemWidth");
        var itemHeight = legendModel.get("itemHeight");
        var isSelected = legendModel.isSelected(name);
        var iconRotate = legendItemModel.get("symbolRotate");
        var symbolKeepAspect = legendItemModel.get("symbolKeepAspect");
        var legendIconType = legendItemModel.get("icon");
        legendIcon = legendIconType || legendIcon || "roundRect";
        var style = $08c3412b120bf58f$var$getLegendStyle(legendIcon, legendItemModel, lineVisualStyle, itemVisualStyle, drawType, isSelected, api);
        var itemGroup = new $08c3412b120bf58f$var$Group();
        var textStyleModel = legendItemModel.getModel("textStyle");
        if ($43e0a445ed6711da$export$f6e2535fb5126e54(seriesModel.getLegendIcon) && (!legendIconType || legendIconType === "inherit")) // Series has specific way to define legend icon
        itemGroup.add(seriesModel.getLegendIcon({
            itemWidth: itemWidth,
            itemHeight: itemHeight,
            icon: legendIcon,
            iconRotate: iconRotate,
            itemStyle: style.itemStyle,
            lineStyle: style.lineStyle,
            symbolKeepAspect: symbolKeepAspect
        }));
        else {
            // Use default legend icon policy for most series
            var rotate = legendIconType === "inherit" && seriesModel.getData().getVisual("symbol") ? iconRotate === "inherit" ? seriesModel.getData().getVisual("symbolRotate") : iconRotate : 0; // No rotation for no icon
            itemGroup.add($08c3412b120bf58f$var$getDefaultLegendIcon({
                itemWidth: itemWidth,
                itemHeight: itemHeight,
                icon: legendIcon,
                iconRotate: rotate,
                itemStyle: style.itemStyle,
                lineStyle: style.lineStyle,
                symbolKeepAspect: symbolKeepAspect
            }));
        }
        var textX = itemAlign === "left" ? itemWidth + 5 : -5;
        var textAlign = itemAlign;
        var formatter = legendModel.get("formatter");
        var content = name;
        if ($43e0a445ed6711da$export$844ec244b1367d54(formatter) && formatter) content = formatter.replace("{name}", name != null ? name : "");
        else if ($43e0a445ed6711da$export$f6e2535fb5126e54(formatter)) content = formatter(name);
        var textColor = isSelected ? textStyleModel.getTextColor() : legendItemModel.get("inactiveColor");
        itemGroup.add(new $7db7960d25b39b7c$export$2e2bcd8739ae039({
            style: (0, $6556fe1ed9fb479d$export$f8998c3d0a13de59)(textStyleModel, {
                text: content,
                x: textX,
                y: itemHeight / 2,
                fill: textColor,
                align: textAlign,
                verticalAlign: "middle"
            }, {
                inheritColor: textColor
            })
        }));
        // Add a invisible rect to increase the area of mouse hover
        var hitRect = new $42ed508a93973e78$export$2e2bcd8739ae039({
            shape: itemGroup.getBoundingRect(),
            style: {
                // Cannot use 'invisible' because SVG SSR will miss the node
                fill: "transparent"
            }
        });
        var tooltipModel = legendItemModel.getModel("tooltip");
        if (tooltipModel.get("show")) $6552edac5ca572b1$export$fc6410d97fab306c({
            el: hitRect,
            componentModel: legendModel,
            itemName: name,
            itemTooltipOption: tooltipModel.option
        });
        itemGroup.add(hitRect);
        itemGroup.eachChild(function(child) {
            child.silent = true;
        });
        hitRect.silent = !selectMode;
        this.getContentGroup().add(itemGroup);
        (0, $fffc76734a157b4c$export$5f393df0b5aee2e7)(itemGroup);
        // @ts-ignore
        itemGroup.__legendDataIndex = dataIndex;
        return itemGroup;
    };
    LegendView.prototype.layoutInner = function(legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition) {
        var contentGroup = this.getContentGroup();
        var selectorGroup = this.getSelectorGroup();
        // Place items in contentGroup.
        $826bc4094efae72b$export$827f4ee28efc37(legendModel.get("orient"), contentGroup, legendModel.get("itemGap"), maxSize.width, maxSize.height);
        var contentRect = contentGroup.getBoundingRect();
        var contentPos = [
            -contentRect.x,
            -contentRect.y
        ];
        selectorGroup.markRedraw();
        contentGroup.markRedraw();
        if (selector) {
            // Place buttons in selectorGroup
            $826bc4094efae72b$export$827f4ee28efc37(// Buttons in selectorGroup always layout horizontally
            "horizontal", selectorGroup, legendModel.get("selectorItemGap", true));
            var selectorRect = selectorGroup.getBoundingRect();
            var selectorPos = [
                -selectorRect.x,
                -selectorRect.y
            ];
            var selectorButtonGap = legendModel.get("selectorButtonGap", true);
            var orientIdx = legendModel.getOrient().index;
            var wh = orientIdx === 0 ? "width" : "height";
            var hw = orientIdx === 0 ? "height" : "width";
            var yx = orientIdx === 0 ? "y" : "x";
            if (selectorPosition === "end") selectorPos[orientIdx] += contentRect[wh] + selectorButtonGap;
            else contentPos[orientIdx] += selectorRect[wh] + selectorButtonGap;
            // Always align selector to content as 'middle'
            selectorPos[1 - orientIdx] += contentRect[hw] / 2 - selectorRect[hw] / 2;
            selectorGroup.x = selectorPos[0];
            selectorGroup.y = selectorPos[1];
            contentGroup.x = contentPos[0];
            contentGroup.y = contentPos[1];
            var mainRect = {
                x: 0,
                y: 0
            };
            mainRect[wh] = contentRect[wh] + selectorButtonGap + selectorRect[wh];
            mainRect[hw] = Math.max(contentRect[hw], selectorRect[hw]);
            mainRect[yx] = Math.min(0, selectorRect[yx] + selectorPos[1 - orientIdx]);
            return mainRect;
        } else {
            contentGroup.x = contentPos[0];
            contentGroup.y = contentPos[1];
            return this.group.getBoundingRect();
        }
    };
    /**
   * @protected
   */ LegendView.prototype.remove = function() {
        this.getContentGroup().removeAll();
        this._isFirstRender = true;
    };
    LegendView.type = "legend.plain";
    return LegendView;
}((0, $c81700f6bd52c5a7$export$2e2bcd8739ae039));
function $08c3412b120bf58f$var$getLegendStyle(iconType, legendItemModel, lineVisualStyle, itemVisualStyle, drawType, isSelected, api) {
    /**
   * Use series style if is inherit;
   * elsewise, use legend style
   */ function handleCommonProps(style, visualStyle) {
        // If lineStyle.width is 'auto', it is set to be 2 if series has border
        if (style.lineWidth === "auto") style.lineWidth = visualStyle.lineWidth > 0 ? 2 : 0;
        $08c3412b120bf58f$var$each(style, function(propVal, propName) {
            style[propName] === "inherit" && (style[propName] = visualStyle[propName]);
        });
    }
    // itemStyle
    var itemStyleModel = legendItemModel.getModel("itemStyle");
    var itemStyle = itemStyleModel.getItemStyle();
    var iconBrushType = iconType.lastIndexOf("empty", 0) === 0 ? "fill" : "stroke";
    var decalStyle = itemStyleModel.getShallow("decal");
    itemStyle.decal = !decalStyle || decalStyle === "inherit" ? itemVisualStyle.decal : (0, $3850641d805af85d$export$a3ba048e1a648972)(decalStyle, api);
    if (itemStyle.fill === "inherit") /**
     * Series with visualDrawType as 'stroke' should have
     * series stroke as legend fill
     */ itemStyle.fill = itemVisualStyle[drawType];
    if (itemStyle.stroke === "inherit") /**
     * icon type with "emptyXXX" should use fill color
     * in visual style
     */ itemStyle.stroke = itemVisualStyle[iconBrushType];
    if (itemStyle.opacity === "inherit") /**
     * Use lineStyle.opacity if drawType is stroke
     */ itemStyle.opacity = (drawType === "fill" ? itemVisualStyle : lineVisualStyle).opacity;
    handleCommonProps(itemStyle, itemVisualStyle);
    // lineStyle
    var legendLineModel = legendItemModel.getModel("lineStyle");
    var lineStyle = legendLineModel.getLineStyle();
    handleCommonProps(lineStyle, lineVisualStyle);
    // Fix auto color to real color
    itemStyle.fill === "auto" && (itemStyle.fill = itemVisualStyle.fill);
    itemStyle.stroke === "auto" && (itemStyle.stroke = itemVisualStyle.fill);
    lineStyle.stroke === "auto" && (lineStyle.stroke = itemVisualStyle.fill);
    if (!isSelected) {
        var borderWidth = legendItemModel.get("inactiveBorderWidth");
        /**
     * Since stroke is set to be inactiveBorderColor, it may occur that
     * there is no border in series but border in legend, so we need to
     * use border only when series has border if is set to be auto
     */ var visualHasBorder = itemStyle[iconBrushType];
        itemStyle.lineWidth = borderWidth === "auto" ? itemVisualStyle.lineWidth > 0 && visualHasBorder ? 2 : 0 : itemStyle.lineWidth;
        itemStyle.fill = legendItemModel.get("inactiveColor");
        itemStyle.stroke = legendItemModel.get("inactiveBorderColor");
        lineStyle.stroke = legendLineModel.get("inactiveColor");
        lineStyle.lineWidth = legendLineModel.get("inactiveWidth");
    }
    return {
        itemStyle: itemStyle,
        lineStyle: lineStyle
    };
}
function $08c3412b120bf58f$var$getDefaultLegendIcon(opt) {
    var symboType = opt.icon || "roundRect";
    var icon = (0, $4ff41a845d4679a6$export$af050e04da3a02e8)(symboType, 0, 0, opt.itemWidth, opt.itemHeight, opt.itemStyle.fill, opt.symbolKeepAspect);
    icon.setStyle(opt.itemStyle);
    icon.rotation = (opt.iconRotate || 0) * Math.PI / 180;
    icon.setOrigin([
        opt.itemWidth / 2,
        opt.itemHeight / 2
    ]);
    if (symboType.indexOf("empty") > -1) {
        icon.style.stroke = icon.style.fill;
        icon.style.fill = (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.neutral00;
        icon.style.lineWidth = 2;
    }
    return icon;
}
function $08c3412b120bf58f$var$dispatchSelectAction(seriesName, dataName, api, excludeSeriesId) {
    // downplay before unselect
    $08c3412b120bf58f$var$dispatchDownplayAction(seriesName, dataName, api, excludeSeriesId);
    api.dispatchAction({
        type: "legendToggleSelect",
        name: seriesName != null ? seriesName : dataName
    });
    // highlight after select
    // TODO highlight immediately may cause animation loss.
    $08c3412b120bf58f$var$dispatchHighlightAction(seriesName, dataName, api, excludeSeriesId);
}
function $08c3412b120bf58f$var$dispatchHighlightAction(seriesName, dataName, api, excludeSeriesId) {
    if (!api.usingTHL()) api.dispatchAction({
        type: "highlight",
        seriesName: seriesName,
        name: dataName,
        excludeSeriesId: excludeSeriesId
    });
}
function $08c3412b120bf58f$var$dispatchDownplayAction(seriesName, dataName, api, excludeSeriesId) {
    if (!api.usingTHL()) api.dispatchAction({
        type: "downplay",
        seriesName: seriesName,
        name: dataName,
        excludeSeriesId: excludeSeriesId
    });
}
var $08c3412b120bf58f$export$2e2bcd8739ae039 = $08c3412b120bf58f$var$LegendView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $c8d834178d0862b2$var$legendSelectActionHandler(methodName, payload, ecModel) {
    var isAllSelect = methodName === "allSelect" || methodName === "inverseSelect";
    var selectedMap = {};
    var actionLegendIndices = [];
    ecModel.eachComponent({
        mainType: "legend",
        query: payload
    }, function(legendModel) {
        if (isAllSelect) legendModel[methodName]();
        else legendModel[methodName](payload.name);
        $c8d834178d0862b2$var$makeSelectedMap(legendModel, selectedMap);
        actionLegendIndices.push(legendModel.componentIndex);
    });
    var allSelectedMap = {};
    // make selectedMap from all legend components
    ecModel.eachComponent("legend", function(legendModel) {
        (0, $43e0a445ed6711da$export$79b2f7037acddd43)(selectedMap, function(isSelected, name) {
            // Force other legend has same selected status
            // Or the first is toggled to true and other are toggled to false
            // In the case one legend has some item unSelected in option. And if other legend
            // doesn't has the item, they will assume it is selected.
            legendModel[isSelected ? "select" : "unSelect"](name);
        });
        $c8d834178d0862b2$var$makeSelectedMap(legendModel, allSelectedMap);
    });
    // Return the event explicitly
    return isAllSelect ? {
        selected: allSelectedMap,
        // return legendIndex array to tell the developers which legends are allSelect / inverseSelect
        legendIndex: actionLegendIndices
    } : {
        name: payload.name,
        selected: allSelectedMap
    };
}
function $c8d834178d0862b2$var$makeSelectedMap(legendModel, out) {
    var selectedMap = out || {};
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)(legendModel.getData(), function(model) {
        var name = model.get("name");
        // Wrap element
        if (name === "\n" || name === "") return;
        var isItemSelected = legendModel.isSelected(name);
        if ((0, $43e0a445ed6711da$export$b5a638e9b3fff9f3)(selectedMap, name)) // Unselected if any legend is unselected
        selectedMap[name] = selectedMap[name] && isItemSelected;
        else selectedMap[name] = isItemSelected;
    });
    return selectedMap;
}
function $c8d834178d0862b2$export$139982ea529c452f(registers) {
    /**
   * @event legendToggleSelect
   * @type {Object}
   * @property {string} type 'legendToggleSelect'
   * @property {string} [from]
   * @property {string} name Series name or data item name
   */ registers.registerAction("legendToggleSelect", "legendselectchanged", (0, $43e0a445ed6711da$export$c3095a23b368d1f2)($c8d834178d0862b2$var$legendSelectActionHandler, "toggleSelected"));
    registers.registerAction("legendAllSelect", "legendselectall", (0, $43e0a445ed6711da$export$c3095a23b368d1f2)($c8d834178d0862b2$var$legendSelectActionHandler, "allSelect"));
    registers.registerAction("legendInverseSelect", "legendinverseselect", (0, $43e0a445ed6711da$export$c3095a23b368d1f2)($c8d834178d0862b2$var$legendSelectActionHandler, "inverseSelect"));
    /**
   * @event legendSelect
   * @type {Object}
   * @property {string} type 'legendSelect'
   * @property {string} name Series name or data item name
   */ registers.registerAction("legendSelect", "legendselected", (0, $43e0a445ed6711da$export$c3095a23b368d1f2)($c8d834178d0862b2$var$legendSelectActionHandler, "select"));
    /**
   * @event legendUnSelect
   * @type {Object}
   * @property {string} type 'legendUnSelect'
   * @property {string} name Series name or data item name
   */ registers.registerAction("legendUnSelect", "legendunselected", (0, $43e0a445ed6711da$export$c3095a23b368d1f2)($c8d834178d0862b2$var$legendSelectActionHandler, "unSelect"));
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $8dcc6a1562d32216$export$93f5c873e193c7e3 = (0, $87f4a59ac66e0ee6$export$d62c61cad9d1ab83)($8dcc6a1562d32216$var$legendFilter);
function $8dcc6a1562d32216$var$legendFilter(ecModel) {
    var legendModels = ecModel.findComponents({
        mainType: "legend"
    });
    if (legendModels && legendModels.length) ecModel.filterSeries(function(series) {
        // If in any legend component the status is not selected.
        // Because in legend series is assumed selected when it is not in the legend data.
        for(var i = 0; i < legendModels.length; i++){
            if (!legendModels[i].isSelected(series.name)) return false;
        }
        return true;
    });
}


function $2d2b67c744a79774$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $069fa11c93b2880e$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $08c3412b120bf58f$export$2e2bcd8739ae039));
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.SERIES_FILTER, (0, $8dcc6a1562d32216$export$93f5c873e193c7e3));
    registers.registerSubTypeDefaulter("legend", function() {
        return "plain";
    });
    (0, $c8d834178d0862b2$export$139982ea529c452f)(registers);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $8bef61f5e99ebdd5$var$ScrollableLegendModel = /** @class */ function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(ScrollableLegendModel, _super);
    function ScrollableLegendModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ScrollableLegendModel.type;
        return _this;
    }
    /**
   * @param {number} scrollDataIndex
   */ ScrollableLegendModel.prototype.setScrollDataIndex = function(scrollDataIndex) {
        this.option.scrollDataIndex = scrollDataIndex;
    };
    ScrollableLegendModel.prototype.init = function(option, parentModel, ecModel) {
        var inputPositionParams = (0, $826bc4094efae72b$export$4b0d20af19c9875e)(option);
        _super.prototype.init.call(this, option, parentModel, ecModel);
        $8bef61f5e99ebdd5$var$mergeAndNormalizeLayoutParams(this, option, inputPositionParams);
    };
    /**
   * @override
   */ ScrollableLegendModel.prototype.mergeOption = function(option, ecModel) {
        _super.prototype.mergeOption.call(this, option, ecModel);
        $8bef61f5e99ebdd5$var$mergeAndNormalizeLayoutParams(this, this.option, option);
    };
    ScrollableLegendModel.type = "legend.scroll";
    ScrollableLegendModel.defaultOption = (0, $f7a89889802a4565$export$68acc510e46fef2)((0, $069fa11c93b2880e$export$2e2bcd8739ae039).defaultOption, {
        scrollDataIndex: 0,
        pageButtonItemGap: 5,
        pageButtonGap: null,
        pageButtonPosition: "end",
        pageFormatter: "{current}/{total}",
        pageIcons: {
            horizontal: [
                "M0,0L12,-10L12,10z",
                "M0,0L-12,-10L-12,10z"
            ],
            vertical: [
                "M0,0L20,0L10,-20z",
                "M0,0L20,0L10,20z"
            ]
        },
        pageIconColor: (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.accent50,
        pageIconInactiveColor: (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.accent10,
        pageIconSize: 15,
        pageTextStyle: {
            color: (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.tertiary
        },
        animationDurationUpdate: 800
    });
    return ScrollableLegendModel;
}((0, $069fa11c93b2880e$export$2e2bcd8739ae039));
// Do not `ignoreSize` to enable setting {left: 10, right: 10}.
function $8bef61f5e99ebdd5$var$mergeAndNormalizeLayoutParams(legendModel, target, raw) {
    var orient = legendModel.getOrient();
    var ignoreSize = [
        1,
        1
    ];
    ignoreSize[orient.index] = 0;
    (0, $826bc4094efae72b$export$1754cb91f16ca028)(target, raw, {
        type: "box",
        ignoreSize: !!ignoreSize
    });
}
var $8bef61f5e99ebdd5$export$2e2bcd8739ae039 = $8bef61f5e99ebdd5$var$ScrollableLegendModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $f2e58675ab04c5fd$var$Group = $a8978f7a0e842e3d$export$2e2bcd8739ae039;
var $f2e58675ab04c5fd$var$WH = [
    "width",
    "height"
];
var $f2e58675ab04c5fd$var$XY = [
    "x",
    "y"
];
var $f2e58675ab04c5fd$var$ScrollableLegendView = /** @class */ function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(ScrollableLegendView, _super);
    function ScrollableLegendView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ScrollableLegendView.type;
        _this.newlineDisabled = true;
        _this._currentIndex = 0;
        return _this;
    }
    ScrollableLegendView.prototype.init = function() {
        _super.prototype.init.call(this);
        this.group.add(this._containerGroup = new $f2e58675ab04c5fd$var$Group());
        this._containerGroup.add(this.getContentGroup());
        this.group.add(this._controllerGroup = new $f2e58675ab04c5fd$var$Group());
    };
    /**
   * @override
   */ ScrollableLegendView.prototype.resetInner = function() {
        _super.prototype.resetInner.call(this);
        this._controllerGroup.removeAll();
        this._containerGroup.removeClipPath();
        this._containerGroup.__rectSize = null;
    };
    /**
   * @override
   */ ScrollableLegendView.prototype.renderInner = function(itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition) {
        var self = this;
        // Render content items.
        _super.prototype.renderInner.call(this, itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition);
        var controllerGroup = this._controllerGroup;
        // FIXME: support be 'auto' adapt to size number text length,
        // e.g., '3/12345' should not overlap with the control arrow button.
        var pageIconSize = legendModel.get("pageIconSize", true);
        var pageIconSizeArr = $43e0a445ed6711da$export$43bee75e5e14138e(pageIconSize) ? pageIconSize : [
            pageIconSize,
            pageIconSize
        ];
        createPageButton("pagePrev", 0);
        var pageTextStyleModel = legendModel.getModel("pageTextStyle");
        controllerGroup.add(new $7db7960d25b39b7c$export$2e2bcd8739ae039({
            name: "pageText",
            style: {
                // Placeholder to calculate a proper layout.
                text: "xx/xx",
                fill: pageTextStyleModel.getTextColor(),
                font: pageTextStyleModel.getFont(),
                verticalAlign: "middle",
                align: "center"
            },
            silent: true
        }));
        createPageButton("pageNext", 1);
        function createPageButton(name, iconIdx) {
            var pageDataIndexName = name + "DataIndex";
            var icon = $6552edac5ca572b1$export$274edc73af1ae9c8(legendModel.get("pageIcons", true)[legendModel.getOrient().name][iconIdx], {
                // Buttons will be created in each render, so we do not need
                // to worry about avoiding using legendModel kept in scope.
                onclick: $43e0a445ed6711da$export$2385a24977818dd0(self._pageGo, self, pageDataIndexName, legendModel, api)
            }, {
                x: -pageIconSizeArr[0] / 2,
                y: -pageIconSizeArr[1] / 2,
                width: pageIconSizeArr[0],
                height: pageIconSizeArr[1]
            });
            icon.name = name;
            controllerGroup.add(icon);
        }
    };
    /**
   * @override
   */ ScrollableLegendView.prototype.layoutInner = function(legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition) {
        var selectorGroup = this.getSelectorGroup();
        var orientIdx = legendModel.getOrient().index;
        var wh = $f2e58675ab04c5fd$var$WH[orientIdx];
        var xy = $f2e58675ab04c5fd$var$XY[orientIdx];
        var hw = $f2e58675ab04c5fd$var$WH[1 - orientIdx];
        var yx = $f2e58675ab04c5fd$var$XY[1 - orientIdx];
        selector && $826bc4094efae72b$export$827f4ee28efc37(// Buttons in selectorGroup always layout horizontally
        "horizontal", selectorGroup, legendModel.get("selectorItemGap", true));
        var selectorButtonGap = legendModel.get("selectorButtonGap", true);
        var selectorRect = selectorGroup.getBoundingRect();
        var selectorPos = [
            -selectorRect.x,
            -selectorRect.y
        ];
        var processMaxSize = $43e0a445ed6711da$export$9cd59f9826255e47(maxSize);
        selector && (processMaxSize[wh] = maxSize[wh] - selectorRect[wh] - selectorButtonGap);
        var mainRect = this._layoutContentAndController(legendModel, isFirstRender, processMaxSize, orientIdx, wh, hw, yx, xy);
        if (selector) {
            if (selectorPosition === "end") selectorPos[orientIdx] += mainRect[wh] + selectorButtonGap;
            else {
                var offset = selectorRect[wh] + selectorButtonGap;
                selectorPos[orientIdx] -= offset;
                mainRect[xy] -= offset;
            }
            mainRect[wh] += selectorRect[wh] + selectorButtonGap;
            selectorPos[1 - orientIdx] += mainRect[yx] + mainRect[hw] / 2 - selectorRect[hw] / 2;
            mainRect[hw] = Math.max(mainRect[hw], selectorRect[hw]);
            mainRect[yx] = Math.min(mainRect[yx], selectorRect[yx] + selectorPos[1 - orientIdx]);
            selectorGroup.x = selectorPos[0];
            selectorGroup.y = selectorPos[1];
            selectorGroup.markRedraw();
        }
        return mainRect;
    };
    ScrollableLegendView.prototype._layoutContentAndController = function(legendModel, isFirstRender, maxSize, orientIdx, wh, hw, yx, xy) {
        var contentGroup = this.getContentGroup();
        var containerGroup = this._containerGroup;
        var controllerGroup = this._controllerGroup;
        // Place items in contentGroup.
        $826bc4094efae72b$export$827f4ee28efc37(legendModel.get("orient"), contentGroup, legendModel.get("itemGap"), !orientIdx ? null : maxSize.width, orientIdx ? null : maxSize.height);
        $826bc4094efae72b$export$827f4ee28efc37(// Buttons in controller are layout always horizontally.
        "horizontal", controllerGroup, legendModel.get("pageButtonItemGap", true));
        var contentRect = contentGroup.getBoundingRect();
        var controllerRect = controllerGroup.getBoundingRect();
        var showController = this._showController = contentRect[wh] > maxSize[wh];
        // In case that the inner elements of contentGroup layout do not based on [0, 0]
        var contentPos = [
            -contentRect.x,
            -contentRect.y
        ];
        // Remain contentPos when scroll animation perfroming.
        // If first rendering, `contentGroup.position` is [0, 0], which
        // does not make sense and may cause unexepcted animation if adopted.
        if (!isFirstRender) contentPos[orientIdx] = contentGroup[xy];
        // Layout container group based on 0.
        var containerPos = [
            0,
            0
        ];
        var controllerPos = [
            -controllerRect.x,
            -controllerRect.y
        ];
        var pageButtonGap = $43e0a445ed6711da$export$995e01f2f5c9d030(legendModel.get("pageButtonGap", true), legendModel.get("itemGap", true));
        // Place containerGroup and controllerGroup and contentGroup.
        if (showController) {
            var pageButtonPosition = legendModel.get("pageButtonPosition", true);
            // controller is on the right / bottom.
            if (pageButtonPosition === "end") controllerPos[orientIdx] += maxSize[wh] - controllerRect[wh];
            else containerPos[orientIdx] += controllerRect[wh] + pageButtonGap;
        }
        // Always align controller to content as 'middle'.
        controllerPos[1 - orientIdx] += contentRect[hw] / 2 - controllerRect[hw] / 2;
        contentGroup.setPosition(contentPos);
        containerGroup.setPosition(containerPos);
        controllerGroup.setPosition(controllerPos);
        // Calculate `mainRect` and set `clipPath`.
        // mainRect should not be calculated by `this.group.getBoundingRect()`
        // for sake of the overflow.
        var mainRect = {
            x: 0,
            y: 0
        };
        // Consider content may be overflow (should be clipped).
        mainRect[wh] = showController ? maxSize[wh] : contentRect[wh];
        mainRect[hw] = Math.max(contentRect[hw], controllerRect[hw]);
        // `containerRect[yx] + containerPos[1 - orientIdx]` is 0.
        mainRect[yx] = Math.min(0, controllerRect[yx] + controllerPos[1 - orientIdx]);
        containerGroup.__rectSize = maxSize[wh];
        if (showController) {
            var clipShape = {
                x: 0,
                y: 0
            };
            clipShape[wh] = Math.max(maxSize[wh] - controllerRect[wh] - pageButtonGap, 0);
            clipShape[hw] = mainRect[hw];
            containerGroup.setClipPath(new $42ed508a93973e78$export$2e2bcd8739ae039({
                shape: clipShape
            }));
            // Consider content may be larger than container, container rect
            // can not be obtained from `containerGroup.getBoundingRect()`.
            containerGroup.__rectSize = clipShape[wh];
        } else // Do not remove or ignore controller. Keep them set as placeholders.
        controllerGroup.eachChild(function(child) {
            child.attr({
                invisible: true,
                silent: true
            });
        });
        // Content translate animation.
        var pageInfo = this._getPageInfo(legendModel);
        pageInfo.pageIndex != null && $4feffdaaa31d998e$export$c8dce3c08436e91e(contentGroup, {
            x: pageInfo.contentPosition[0],
            y: pageInfo.contentPosition[1]
        }, // When switch from "show controller" to "not show controller", view should be
        // updated immediately without animation, otherwise causes weird effect.
        showController ? legendModel : null);
        this._updatePageInfoView(legendModel, pageInfo);
        return mainRect;
    };
    ScrollableLegendView.prototype._pageGo = function(to, legendModel, api) {
        var scrollDataIndex = this._getPageInfo(legendModel)[to];
        scrollDataIndex != null && api.dispatchAction({
            type: "legendScroll",
            scrollDataIndex: scrollDataIndex,
            legendId: legendModel.id
        });
    };
    ScrollableLegendView.prototype._updatePageInfoView = function(legendModel, pageInfo) {
        var controllerGroup = this._controllerGroup;
        $43e0a445ed6711da$export$79b2f7037acddd43([
            "pagePrev",
            "pageNext"
        ], function(name) {
            var key = name + "DataIndex";
            var canJump = pageInfo[key] != null;
            var icon = controllerGroup.childOfName(name);
            if (icon) {
                icon.setStyle("fill", canJump ? legendModel.get("pageIconColor", true) : legendModel.get("pageIconInactiveColor", true));
                icon.cursor = canJump ? "pointer" : "default";
            }
        });
        var pageText = controllerGroup.childOfName("pageText");
        var pageFormatter = legendModel.get("pageFormatter");
        var pageIndex = pageInfo.pageIndex;
        var current = pageIndex != null ? pageIndex + 1 : 0;
        var total = pageInfo.pageCount;
        pageText && pageFormatter && pageText.setStyle("text", $43e0a445ed6711da$export$844ec244b1367d54(pageFormatter) ? pageFormatter.replace("{current}", current == null ? "" : current + "").replace("{total}", total == null ? "" : total + "") : pageFormatter({
            current: current,
            total: total
        }));
    };
    /**
   *  contentPosition: Array.<number>, null when data item not found.
   *  pageIndex: number, null when data item not found.
   *  pageCount: number, always be a number, can be 0.
   *  pagePrevDataIndex: number, null when no previous page.
   *  pageNextDataIndex: number, null when no next page.
   * }
   */ ScrollableLegendView.prototype._getPageInfo = function(legendModel) {
        var scrollDataIndex = legendModel.get("scrollDataIndex", true);
        var contentGroup = this.getContentGroup();
        var containerRectSize = this._containerGroup.__rectSize;
        var orientIdx = legendModel.getOrient().index;
        var wh = $f2e58675ab04c5fd$var$WH[orientIdx];
        var xy = $f2e58675ab04c5fd$var$XY[orientIdx];
        var targetItemIndex = this._findTargetItemIndex(scrollDataIndex);
        var children = contentGroup.children();
        var targetItem = children[targetItemIndex];
        var itemCount = children.length;
        var pCount = !itemCount ? 0 : 1;
        var result = {
            contentPosition: [
                contentGroup.x,
                contentGroup.y
            ],
            pageCount: pCount,
            pageIndex: pCount - 1,
            pagePrevDataIndex: null,
            pageNextDataIndex: null
        };
        if (!targetItem) return result;
        var targetItemInfo = getItemInfo(targetItem);
        result.contentPosition[orientIdx] = -targetItemInfo.s;
        // Strategy:
        // (1) Always align based on the left/top most item.
        // (2) It is user-friendly that the last item shown in the
        // current window is shown at the begining of next window.
        // Otherwise if half of the last item is cut by the window,
        // it will have no chance to display entirely.
        // (3) Consider that item size probably be different, we
        // have calculate pageIndex by size rather than item index,
        // and we can not get page index directly by division.
        // (4) The window is to narrow to contain more than
        // one item, we should make sure that the page can be fliped.
        for(var i = targetItemIndex + 1, winStartItemInfo = targetItemInfo, winEndItemInfo = targetItemInfo, currItemInfo = null; i <= itemCount; ++i){
            currItemInfo = getItemInfo(children[i]);
            if (// Half of the last item is out of the window.
            !currItemInfo && winEndItemInfo.e > winStartItemInfo.s + containerRectSize || currItemInfo && !intersect(currItemInfo, winStartItemInfo.s)) {
                if (winEndItemInfo.i > winStartItemInfo.i) winStartItemInfo = winEndItemInfo;
                else // e.g., when page size is smaller than item size.
                winStartItemInfo = currItemInfo;
                if (winStartItemInfo) {
                    if (result.pageNextDataIndex == null) result.pageNextDataIndex = winStartItemInfo.i;
                    ++result.pageCount;
                }
            }
            winEndItemInfo = currItemInfo;
        }
        for(var i = targetItemIndex - 1, winStartItemInfo = targetItemInfo, winEndItemInfo = targetItemInfo, currItemInfo = null; i >= -1; --i){
            currItemInfo = getItemInfo(children[i]);
            if (// If the the end item does not intersect with the window started
            // from the current item, a page can be settled.
            (!currItemInfo || !intersect(winEndItemInfo, currItemInfo.s)) && winStartItemInfo.i < winEndItemInfo.i) {
                winEndItemInfo = winStartItemInfo;
                if (result.pagePrevDataIndex == null) result.pagePrevDataIndex = winStartItemInfo.i;
                ++result.pageCount;
                ++result.pageIndex;
            }
            winStartItemInfo = currItemInfo;
        }
        return result;
        function getItemInfo(el) {
            if (el) {
                var itemRect = el.getBoundingRect();
                var start = itemRect[xy] + el[xy];
                return {
                    s: start,
                    e: start + itemRect[wh],
                    i: el.__legendDataIndex
                };
            }
        }
        function intersect(itemInfo, winStart) {
            return itemInfo.e >= winStart && itemInfo.s <= winStart + containerRectSize;
        }
    };
    ScrollableLegendView.prototype._findTargetItemIndex = function(targetDataIndex) {
        if (!this._showController) return 0;
        var index;
        var contentGroup = this.getContentGroup();
        var defaultIndex;
        contentGroup.eachChild(function(child, idx) {
            var legendDataIdx = child.__legendDataIndex;
            // FIXME
            // If the given targetDataIndex (from model) is illegal,
            // we use defaultIndex. But the index on the legend model and
            // action payload is still illegal. That case will not be
            // changed until some scenario requires.
            if (defaultIndex == null && legendDataIdx != null) defaultIndex = idx;
            if (legendDataIdx === targetDataIndex) index = idx;
        });
        return index != null ? index : defaultIndex;
    };
    ScrollableLegendView.type = "legend.scroll";
    return ScrollableLegendView;
}((0, $08c3412b120bf58f$export$2e2bcd8739ae039));
var $f2e58675ab04c5fd$export$2e2bcd8739ae039 = $f2e58675ab04c5fd$var$ScrollableLegendView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $516f512242f8dcfe$export$2e2bcd8739ae039(registers) {
    /**
   * @event legendScroll
   * @type {Object}
   * @property {string} type 'legendScroll'
   * @property {string} scrollDataIndex
   */ registers.registerAction("legendScroll", "legendscroll", function(payload, ecModel) {
        var scrollDataIndex = payload.scrollDataIndex;
        scrollDataIndex != null && ecModel.eachComponent({
            mainType: "legend",
            subType: "scroll",
            query: payload
        }, function(legendModel) {
            legendModel.setScrollDataIndex(scrollDataIndex);
        });
    });
}


function $926f974ce83d7663$export$4b3e715f166fdd78(registers) {
    (0, $8f6e8e1f1e941d98$export$1f96ae73734a86cc)((0, $2d2b67c744a79774$export$4b3e715f166fdd78));
    registers.registerComponentModel((0, $8bef61f5e99ebdd5$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $f2e58675ab04c5fd$export$2e2bcd8739ae039));
    (0, $516f512242f8dcfe$export$2e2bcd8739ae039)(registers);
}


function $ff2bffb12297f574$export$4b3e715f166fdd78(registers) {
    (0, $8f6e8e1f1e941d98$export$1f96ae73734a86cc)((0, $2d2b67c744a79774$export$4b3e715f166fdd78));
    (0, $8f6e8e1f1e941d98$export$1f96ae73734a86cc)((0, $926f974ce83d7663$export$4b3e715f166fdd78));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $1eb1ecd0989c64d5$var$CalendarModel = /** @class */ function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(CalendarModel, _super);
    function CalendarModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CalendarModel.type;
        return _this;
    }
    /**
   * @override
   */ CalendarModel.prototype.init = function(option, parentModel, ecModel) {
        var inputPositionParams = (0, $826bc4094efae72b$export$4b0d20af19c9875e)(option);
        _super.prototype.init.apply(this, arguments);
        $1eb1ecd0989c64d5$var$mergeAndNormalizeLayoutParams(option, inputPositionParams);
    };
    /**
   * @override
   */ CalendarModel.prototype.mergeOption = function(option) {
        _super.prototype.mergeOption.apply(this, arguments);
        $1eb1ecd0989c64d5$var$mergeAndNormalizeLayoutParams(this.option, option);
    };
    CalendarModel.prototype.getCellSize = function() {
        // Has been normalized
        return this.option.cellSize;
    };
    CalendarModel.type = "calendar";
    CalendarModel.layoutMode = "box";
    CalendarModel.defaultOption = {
        // zlevel: 0,
        // TODO: theoretically, the z of the calendar should be lower
        // than series, but we don't want the series to be displayed
        // on top of the borders like month split line. To align with
        // the effect of previous versions, we set the z to 2 for now
        // until better solution is found.
        z: 2,
        left: 80,
        top: 60,
        cellSize: 20,
        // horizontal vertical
        orient: "horizontal",
        // month separate line style
        splitLine: {
            show: true,
            lineStyle: {
                color: (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.axisLine,
                width: 1,
                type: "solid"
            }
        },
        // rect style  temporarily unused emphasis
        itemStyle: {
            color: (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.neutral00,
            borderWidth: 1,
            borderColor: (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.neutral10
        },
        // week text style
        dayLabel: {
            show: true,
            firstDay: 0,
            // start end
            position: "start",
            margin: (0, $8327d823e00b772c$export$2e2bcd8739ae039).size.s,
            color: (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.secondary
        },
        // month text style
        monthLabel: {
            show: true,
            // start end
            position: "start",
            margin: (0, $8327d823e00b772c$export$2e2bcd8739ae039).size.s,
            // center or left
            align: "center",
            formatter: null,
            color: (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.secondary
        },
        // year text style
        yearLabel: {
            show: true,
            // top bottom left right
            position: null,
            margin: (0, $8327d823e00b772c$export$2e2bcd8739ae039).size.xl,
            formatter: null,
            color: (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.quaternary,
            fontFamily: "sans-serif",
            fontWeight: "bolder",
            fontSize: 20
        }
    };
    return CalendarModel;
}((0, $4a9041b12b787d1b$export$2e2bcd8739ae039));
function $1eb1ecd0989c64d5$var$mergeAndNormalizeLayoutParams(target, raw) {
    // Normalize cellSize
    var cellSize = target.cellSize;
    var cellSizeArr;
    if (!$43e0a445ed6711da$export$43bee75e5e14138e(cellSize)) cellSizeArr = target.cellSize = [
        cellSize,
        cellSize
    ];
    else cellSizeArr = cellSize;
    if (cellSizeArr.length === 1) cellSizeArr[1] = cellSizeArr[0];
    var ignoreSize = $43e0a445ed6711da$export$871de8747c9eaa88([
        0,
        1
    ], function(hvIdx) {
        // If user have set `width` or both `left` and `right`, cellSizeArr
        // will be automatically set to 'auto', otherwise the default
        // setting of cellSizeArr will make `width` setting not work.
        if ((0, $826bc4094efae72b$export$7ede609e8ebc9650)(raw, hvIdx)) cellSizeArr[hvIdx] = "auto";
        return cellSizeArr[hvIdx] != null && cellSizeArr[hvIdx] !== "auto";
    });
    (0, $826bc4094efae72b$export$1754cb91f16ca028)(target, raw, {
        type: "box",
        ignoreSize: ignoreSize
    });
}
var $1eb1ecd0989c64d5$export$2e2bcd8739ae039 = $1eb1ecd0989c64d5$var$CalendarModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







var $e320c2f2c921c454$var$CalendarView = /** @class */ function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(CalendarView, _super);
    function CalendarView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CalendarView.type;
        return _this;
    }
    CalendarView.prototype.render = function(calendarModel, ecModel, api) {
        var group = this.group;
        group.removeAll();
        var coordSys = calendarModel.coordinateSystem;
        // range info
        var rangeData = coordSys.getRangeInfo();
        var orient = coordSys.getOrient();
        // locale
        var localeModel = ecModel.getLocaleModel();
        this._renderDayRect(calendarModel, rangeData, group);
        // _renderLines must be called prior to following function
        this._renderLines(calendarModel, rangeData, orient, group);
        this._renderYearText(calendarModel, rangeData, orient, group);
        this._renderMonthText(calendarModel, localeModel, orient, group);
        this._renderWeekText(calendarModel, localeModel, rangeData, orient, group);
    };
    // render day rect
    CalendarView.prototype._renderDayRect = function(calendarModel, rangeData, group) {
        var coordSys = calendarModel.coordinateSystem;
        var itemRectStyleModel = calendarModel.getModel("itemStyle").getItemStyle();
        var sw = coordSys.getCellWidth();
        var sh = coordSys.getCellHeight();
        for(var i = rangeData.start.time; i <= rangeData.end.time; i = coordSys.getNextNDay(i, 1).time){
            var point = coordSys.dataToCalendarLayout([
                i
            ], false).tl;
            // every rect
            var rect = new $42ed508a93973e78$export$2e2bcd8739ae039({
                shape: {
                    x: point[0],
                    y: point[1],
                    width: sw,
                    height: sh
                },
                cursor: "default",
                style: itemRectStyleModel
            });
            group.add(rect);
        }
    };
    // render separate line
    CalendarView.prototype._renderLines = function(calendarModel, rangeData, orient, group) {
        var self = this;
        var coordSys = calendarModel.coordinateSystem;
        var lineStyleModel = calendarModel.getModel([
            "splitLine",
            "lineStyle"
        ]).getLineStyle();
        var show = calendarModel.get([
            "splitLine",
            "show"
        ]);
        var lineWidth = lineStyleModel.lineWidth;
        this._tlpoints = [];
        this._blpoints = [];
        this._firstDayOfMonth = [];
        this._firstDayPoints = [];
        var firstDay = rangeData.start;
        for(var i = 0; firstDay.time <= rangeData.end.time; i++){
            addPoints(firstDay.formatedDate);
            if (i === 0) firstDay = coordSys.getDateInfo(rangeData.start.y + "-" + rangeData.start.m);
            var date = firstDay.date;
            date.setMonth(date.getMonth() + 1);
            firstDay = coordSys.getDateInfo(date);
        }
        addPoints(coordSys.getNextNDay(rangeData.end.time, 1).formatedDate);
        function addPoints(date) {
            self._firstDayOfMonth.push(coordSys.getDateInfo(date));
            self._firstDayPoints.push(coordSys.dataToCalendarLayout([
                date
            ], false).tl);
            var points = self._getLinePointsOfOneWeek(calendarModel, date, orient);
            self._tlpoints.push(points[0]);
            self._blpoints.push(points[points.length - 1]);
            show && self._drawSplitline(points, lineStyleModel, group);
        }
        // render top/left line
        show && this._drawSplitline(self._getEdgesPoints(self._tlpoints, lineWidth, orient), lineStyleModel, group);
        // render bottom/right line
        show && this._drawSplitline(self._getEdgesPoints(self._blpoints, lineWidth, orient), lineStyleModel, group);
    };
    // get points at both ends
    CalendarView.prototype._getEdgesPoints = function(points, lineWidth, orient) {
        var rs = [
            points[0].slice(),
            points[points.length - 1].slice()
        ];
        var idx = orient === "horizontal" ? 0 : 1;
        // both ends of the line are extend half lineWidth
        rs[0][idx] = rs[0][idx] - lineWidth / 2;
        rs[1][idx] = rs[1][idx] + lineWidth / 2;
        return rs;
    };
    // render split line
    CalendarView.prototype._drawSplitline = function(points, lineStyle, group) {
        var poyline = new $363f38bff4966f60$export$2e2bcd8739ae039({
            z2: 20,
            shape: {
                points: points
            },
            style: lineStyle
        });
        group.add(poyline);
    };
    // render month line of one week points
    CalendarView.prototype._getLinePointsOfOneWeek = function(calendarModel, date, orient) {
        var coordSys = calendarModel.coordinateSystem;
        var parsedDate = coordSys.getDateInfo(date);
        var points = [];
        for(var i = 0; i < 7; i++){
            var tmpD = coordSys.getNextNDay(parsedDate.time, i);
            var point = coordSys.dataToCalendarLayout([
                tmpD.time
            ], false);
            points[2 * tmpD.day] = point.tl;
            points[2 * tmpD.day + 1] = point[orient === "horizontal" ? "bl" : "tr"];
        }
        return points;
    };
    CalendarView.prototype._formatterLabel = function(formatter, params) {
        if ((0, $43e0a445ed6711da$export$844ec244b1367d54)(formatter) && formatter) return (0, $78c2ece6dfa6bb7a$export$2fa08233ee42f8e1)(formatter, params);
        if ((0, $43e0a445ed6711da$export$f6e2535fb5126e54)(formatter)) return formatter(params);
        return params.nameMap;
    };
    CalendarView.prototype._yearTextPositionControl = function(textEl, point, orient, position, margin) {
        var x = point[0];
        var y = point[1];
        var aligns = [
            "center",
            "bottom"
        ];
        if (position === "bottom") {
            y += margin;
            aligns = [
                "center",
                "top"
            ];
        } else if (position === "left") x -= margin;
        else if (position === "right") {
            x += margin;
            aligns = [
                "center",
                "top"
            ];
        } else // top
        y -= margin;
        var rotate = 0;
        if (position === "left" || position === "right") rotate = Math.PI / 2;
        return {
            rotation: rotate,
            x: x,
            y: y,
            style: {
                align: aligns[0],
                verticalAlign: aligns[1]
            }
        };
    };
    // render year
    CalendarView.prototype._renderYearText = function(calendarModel, rangeData, orient, group) {
        var yearLabel = calendarModel.getModel("yearLabel");
        if (!yearLabel.get("show")) return;
        var margin = yearLabel.get("margin");
        var pos = yearLabel.get("position");
        if (!pos) pos = orient !== "horizontal" ? "top" : "left";
        var points = [
            this._tlpoints[this._tlpoints.length - 1],
            this._blpoints[0]
        ];
        var xc = (points[0][0] + points[1][0]) / 2;
        var yc = (points[0][1] + points[1][1]) / 2;
        var idx = orient === "horizontal" ? 0 : 1;
        var posPoints = {
            top: [
                xc,
                points[idx][1]
            ],
            bottom: [
                xc,
                points[1 - idx][1]
            ],
            left: [
                points[1 - idx][0],
                yc
            ],
            right: [
                points[idx][0],
                yc
            ]
        };
        var name = rangeData.start.y;
        if (+rangeData.end.y > +rangeData.start.y) name = name + "-" + rangeData.end.y;
        var formatter = yearLabel.get("formatter");
        var params = {
            start: rangeData.start.y,
            end: rangeData.end.y,
            nameMap: name
        };
        var content = this._formatterLabel(formatter, params);
        var yearText = new $7db7960d25b39b7c$export$2e2bcd8739ae039({
            z2: 30,
            style: (0, $6556fe1ed9fb479d$export$f8998c3d0a13de59)(yearLabel, {
                text: content
            }),
            silent: yearLabel.get("silent")
        });
        yearText.attr(this._yearTextPositionControl(yearText, posPoints[pos], orient, pos, margin));
        group.add(yearText);
    };
    CalendarView.prototype._monthTextPositionControl = function(point, isCenter, orient, position, margin) {
        var align = "left";
        var vAlign = "top";
        var x = point[0];
        var y = point[1];
        if (orient === "horizontal") {
            y = y + margin;
            if (isCenter) align = "center";
            if (position === "start") vAlign = "bottom";
        } else {
            x = x + margin;
            if (isCenter) vAlign = "middle";
            if (position === "start") align = "right";
        }
        return {
            x: x,
            y: y,
            align: align,
            verticalAlign: vAlign
        };
    };
    // render month and year text
    CalendarView.prototype._renderMonthText = function(calendarModel, localeModel, orient, group) {
        var monthLabel = calendarModel.getModel("monthLabel");
        if (!monthLabel.get("show")) return;
        var nameMap = monthLabel.get("nameMap");
        var margin = monthLabel.get("margin");
        var pos = monthLabel.get("position");
        var align = monthLabel.get("align");
        var termPoints = [
            this._tlpoints,
            this._blpoints
        ];
        if (!nameMap || (0, $43e0a445ed6711da$export$844ec244b1367d54)(nameMap)) {
            if (nameMap) // case-sensitive
            localeModel = (0, $89683316752ed4c5$export$37cc638e0e11865f)(nameMap) || localeModel;
            // PENDING
            // for ZH locale, original form is `一月` but current form is `1月`
            nameMap = localeModel.get([
                "time",
                "monthAbbr"
            ]) || [];
        }
        var idx = pos === "start" ? 0 : 1;
        var axis = orient === "horizontal" ? 0 : 1;
        margin = pos === "start" ? -margin : margin;
        var isCenter = align === "center";
        var labelSilent = monthLabel.get("silent");
        for(var i = 0; i < termPoints[idx].length - 1; i++){
            var tmp = termPoints[idx][i].slice();
            var firstDay = this._firstDayOfMonth[i];
            if (isCenter) {
                var firstDayPoints = this._firstDayPoints[i];
                tmp[axis] = (firstDayPoints[axis] + termPoints[0][i + 1][axis]) / 2;
            }
            var formatter = monthLabel.get("formatter");
            var name_1 = nameMap[+firstDay.m - 1];
            var params = {
                yyyy: firstDay.y,
                yy: (firstDay.y + "").slice(2),
                MM: firstDay.m,
                M: +firstDay.m,
                nameMap: name_1
            };
            var content = this._formatterLabel(formatter, params);
            var monthText = new $7db7960d25b39b7c$export$2e2bcd8739ae039({
                z2: 30,
                style: (0, $43e0a445ed6711da$export$8b58be045bf06082)((0, $6556fe1ed9fb479d$export$f8998c3d0a13de59)(monthLabel, {
                    text: content
                }), this._monthTextPositionControl(tmp, isCenter, orient, pos, margin)),
                silent: labelSilent
            });
            group.add(monthText);
        }
    };
    CalendarView.prototype._weekTextPositionControl = function(point, orient, position, margin, cellSize) {
        var align = "center";
        var vAlign = "middle";
        var x = point[0];
        var y = point[1];
        var isStart = position === "start";
        if (orient === "horizontal") {
            x = x + margin + (isStart ? 1 : -1) * cellSize[0] / 2;
            align = isStart ? "right" : "left";
        } else {
            y = y + margin + (isStart ? 1 : -1) * cellSize[1] / 2;
            vAlign = isStart ? "bottom" : "top";
        }
        return {
            x: x,
            y: y,
            align: align,
            verticalAlign: vAlign
        };
    };
    // render weeks
    CalendarView.prototype._renderWeekText = function(calendarModel, localeModel, rangeData, orient, group) {
        var dayLabel = calendarModel.getModel("dayLabel");
        if (!dayLabel.get("show")) return;
        var coordSys = calendarModel.coordinateSystem;
        var pos = dayLabel.get("position");
        var nameMap = dayLabel.get("nameMap");
        var margin = dayLabel.get("margin");
        var firstDayOfWeek = coordSys.getFirstDayOfWeek();
        if (!nameMap || (0, $43e0a445ed6711da$export$844ec244b1367d54)(nameMap)) {
            if (nameMap) // case-sensitive
            localeModel = (0, $89683316752ed4c5$export$37cc638e0e11865f)(nameMap) || localeModel;
            // Use the first letter of `dayOfWeekAbbr` if `dayOfWeekShort` doesn't exist in the locale file
            var dayOfWeekShort = localeModel.get([
                "time",
                "dayOfWeekShort"
            ]);
            nameMap = dayOfWeekShort || (0, $43e0a445ed6711da$export$871de8747c9eaa88)(localeModel.get([
                "time",
                "dayOfWeekAbbr"
            ]), function(val) {
                return val[0];
            });
        }
        var start = coordSys.getNextNDay(rangeData.end.time, 7 - rangeData.lweek).time;
        var cellSize = [
            coordSys.getCellWidth(),
            coordSys.getCellHeight()
        ];
        margin = (0, $b49750109e236fd8$export$e8514cb5a5e2b40f)(margin, Math.min(cellSize[1], cellSize[0]));
        if (pos === "start") {
            start = coordSys.getNextNDay(rangeData.start.time, -(7 + rangeData.fweek)).time;
            margin = -margin;
        }
        var labelSilent = dayLabel.get("silent");
        for(var i = 0; i < 7; i++){
            var tmpD = coordSys.getNextNDay(start, i);
            var point = coordSys.dataToCalendarLayout([
                tmpD.time
            ], false).center;
            var day = i;
            day = Math.abs((i + firstDayOfWeek) % 7);
            var weekText = new $7db7960d25b39b7c$export$2e2bcd8739ae039({
                z2: 30,
                style: (0, $43e0a445ed6711da$export$8b58be045bf06082)((0, $6556fe1ed9fb479d$export$f8998c3d0a13de59)(dayLabel, {
                    text: nameMap[day]
                }), this._weekTextPositionControl(point, orient, pos, margin, cellSize)),
                silent: labelSilent
            });
            group.add(weekText);
        }
    };
    CalendarView.type = "calendar";
    return CalendarView;
}((0, $c81700f6bd52c5a7$export$2e2bcd8739ae039));
var $e320c2f2c921c454$export$2e2bcd8739ae039 = $e320c2f2c921c454$var$CalendarView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





// (24*60*60*1000)
var $66fc274744e4c9d6$var$PROXIMATE_ONE_DAY = 86400000;
var $66fc274744e4c9d6$var$Calendar = /** @class */ function() {
    function Calendar(calendarModel, ecModel, api) {
        this.type = "calendar";
        this.dimensions = Calendar.dimensions;
        // Required in createListFromData
        this.getDimensionsInfo = Calendar.getDimensionsInfo;
        this._model = calendarModel;
        this._update(ecModel, api);
    }
    Calendar.getDimensionsInfo = function() {
        return [
            {
                name: "time",
                type: "time"
            },
            "value"
        ];
    };
    Calendar.prototype.getRangeInfo = function() {
        return this._rangeInfo;
    };
    Calendar.prototype.getModel = function() {
        return this._model;
    };
    Calendar.prototype.getRect = function() {
        return this._rect;
    };
    Calendar.prototype.getCellWidth = function() {
        return this._sw;
    };
    Calendar.prototype.getCellHeight = function() {
        return this._sh;
    };
    Calendar.prototype.getOrient = function() {
        return this._orient;
    };
    /**
   * getFirstDayOfWeek
   *
   * @example
   *     0 : start at Sunday
   *     1 : start at Monday
   *
   * @return {number}
   */ Calendar.prototype.getFirstDayOfWeek = function() {
        return this._firstDayOfWeek;
    };
    /**
   * get date info
   * }
   */ Calendar.prototype.getDateInfo = function(date) {
        date = $b49750109e236fd8$export$6b862160d295c8e(date);
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        var mStr = m < 10 ? "0" + m : "" + m;
        var d = date.getDate();
        var dStr = d < 10 ? "0" + d : "" + d;
        var day = date.getDay();
        day = Math.abs((day + 7 - this.getFirstDayOfWeek()) % 7);
        return {
            y: y + "",
            m: mStr,
            d: dStr,
            day: day,
            time: date.getTime(),
            formatedDate: y + "-" + mStr + "-" + dStr,
            date: date
        };
    };
    Calendar.prototype.getNextNDay = function(date, n) {
        n = n || 0;
        if (n === 0) return this.getDateInfo(date);
        date = new Date(this.getDateInfo(date).time);
        date.setDate(date.getDate() + n);
        return this.getDateInfo(date);
    };
    Calendar.prototype._update = function(ecModel, api) {
        this._firstDayOfWeek = +this._model.getModel("dayLabel").get("firstDay");
        this._orient = this._model.get("orient");
        this._lineWidth = this._model.getModel("itemStyle").getItemStyle().lineWidth || 0;
        this._rangeInfo = this._getRangeInfo(this._initRangeOption());
        var weeks = this._rangeInfo.weeks || 1;
        var whNames = [
            "width",
            "height"
        ];
        var cellSize = this._model.getCellSize().slice();
        var layoutParams = this._model.getBoxLayoutParams();
        var cellNumbers = this._orient === "horizontal" ? [
            weeks,
            7
        ] : [
            7,
            weeks
        ];
        $43e0a445ed6711da$export$79b2f7037acddd43([
            0,
            1
        ], function(idx) {
            if (cellSizeSpecified(cellSize, idx)) layoutParams[whNames[idx]] = cellSize[idx] * cellNumbers[idx];
        });
        var whGlobal = {
            width: api.getWidth(),
            height: api.getHeight()
        };
        var calendarRect = this._rect = $826bc4094efae72b$export$4517a5ca639a7293(layoutParams, whGlobal);
        $43e0a445ed6711da$export$79b2f7037acddd43([
            0,
            1
        ], function(idx) {
            if (!cellSizeSpecified(cellSize, idx)) cellSize[idx] = calendarRect[whNames[idx]] / cellNumbers[idx];
        });
        function cellSizeSpecified(cellSize, idx) {
            return cellSize[idx] != null && cellSize[idx] !== "auto";
        }
        // Has been calculated out number.
        this._sw = cellSize[0];
        this._sh = cellSize[1];
    };
    /**
   * Convert a time data(time, value) item to (x, y) point.
   */ // TODO Clamp of calendar is not same with cartesian coordinate systems.
    // It will return NaN if data exceeds.
    Calendar.prototype.dataToPoint = function(data, clamp, out) {
        out = out || [];
        $43e0a445ed6711da$export$43bee75e5e14138e(data) && (data = data[0]);
        clamp == null && (clamp = true);
        var dayInfo = this.getDateInfo(data);
        var range = this._rangeInfo;
        var date = dayInfo.formatedDate;
        // if not in range return [NaN, NaN]
        if (clamp && !(dayInfo.time >= range.start.time && dayInfo.time < range.end.time + $66fc274744e4c9d6$var$PROXIMATE_ONE_DAY)) {
            out[0] = out[1] = NaN;
            return out;
        }
        var week = dayInfo.day;
        var nthWeek = this._getRangeInfo([
            range.start.time,
            date
        ]).nthWeek;
        if (this._orient === "vertical") {
            out[0] = this._rect.x + week * this._sw + this._sw / 2;
            out[1] = this._rect.y + nthWeek * this._sh + this._sh / 2;
        } else {
            out[0] = this._rect.x + nthWeek * this._sw + this._sw / 2;
            out[1] = this._rect.y + week * this._sh + this._sh / 2;
        }
        return out;
    };
    /**
   * Convert a (x, y) point to time data
   */ Calendar.prototype.pointToData = function(point) {
        var date = this.pointToDate(point);
        return date && date.time;
    };
    Calendar.prototype.dataToLayout = function(data, clamp, out) {
        out = out || {};
        var rect = out.rect = out.rect || {};
        var contentRect = out.contentRect = out.contentRect || {};
        var point = this.dataToPoint(data, clamp);
        rect.x = point[0] - this._sw / 2;
        rect.y = point[1] - this._sh / 2;
        rect.width = this._sw;
        rect.height = this._sh;
        (0, $c437f598d9c9ee16$export$2e2bcd8739ae039).copy(contentRect, rect);
        (0, $6552edac5ca572b1$export$81ed941fdeb91c7c)(contentRect, this._lineWidth / 2, true, true);
        return out;
    };
    /**
   * Convert a time date item to (x, y) four point.
   */ Calendar.prototype.dataToCalendarLayout = function(data, clamp) {
        var point = this.dataToPoint(data, clamp);
        return {
            center: point,
            tl: [
                point[0] - this._sw / 2,
                point[1] - this._sh / 2
            ],
            tr: [
                point[0] + this._sw / 2,
                point[1] - this._sh / 2
            ],
            br: [
                point[0] + this._sw / 2,
                point[1] + this._sh / 2
            ],
            bl: [
                point[0] - this._sw / 2,
                point[1] + this._sh / 2
            ]
        };
    };
    /**
   * Convert a (x, y) point to time date
   *
   * @param  {Array} point point
   * @return {Object}       date
   */ Calendar.prototype.pointToDate = function(point) {
        var nthX = Math.floor((point[0] - this._rect.x) / this._sw) + 1;
        var nthY = Math.floor((point[1] - this._rect.y) / this._sh) + 1;
        var range = this._rangeInfo.range;
        if (this._orient === "vertical") return this._getDateByWeeksAndDay(nthY, nthX - 1, range);
        return this._getDateByWeeksAndDay(nthX, nthY - 1, range);
    };
    Calendar.prototype.convertToPixel = function(ecModel, finder, value) {
        var coordSys = $66fc274744e4c9d6$var$getCoordSys(finder);
        return coordSys === this ? coordSys.dataToPoint(value) : null;
    };
    Calendar.prototype.convertToLayout = function(ecModel, finder, value) {
        var coordSys = $66fc274744e4c9d6$var$getCoordSys(finder);
        return coordSys === this ? coordSys.dataToLayout(value) : null;
    };
    Calendar.prototype.convertFromPixel = function(ecModel, finder, pixel) {
        var coordSys = $66fc274744e4c9d6$var$getCoordSys(finder);
        return coordSys === this ? coordSys.pointToData(pixel) : null;
    };
    Calendar.prototype.containPoint = function(point) {
        console.warn("Not implemented.");
        return false;
    };
    /**
   * initRange
   * Normalize to an [start, end] array
   */ Calendar.prototype._initRangeOption = function() {
        var range = this._model.get("range");
        var normalizedRange;
        // Convert [1990] to 1990
        if ($43e0a445ed6711da$export$43bee75e5e14138e(range) && range.length === 1) range = range[0];
        if (!$43e0a445ed6711da$export$43bee75e5e14138e(range)) {
            var rangeStr = range.toString();
            // One year.
            if (/^\d{4}$/.test(rangeStr)) normalizedRange = [
                rangeStr + "-01-01",
                rangeStr + "-12-31"
            ];
            // One month
            if (/^\d{4}[\/|-]\d{1,2}$/.test(rangeStr)) {
                var start = this.getDateInfo(rangeStr);
                var firstDay = start.date;
                firstDay.setMonth(firstDay.getMonth() + 1);
                var end = this.getNextNDay(firstDay, -1);
                normalizedRange = [
                    start.formatedDate,
                    end.formatedDate
                ];
            }
            // One day
            if (/^\d{4}[\/|-]\d{1,2}[\/|-]\d{1,2}$/.test(rangeStr)) normalizedRange = [
                rangeStr,
                rangeStr
            ];
        } else normalizedRange = range;
        if (!normalizedRange) // Not handling it.
        return range;
        var tmp = this._getRangeInfo(normalizedRange);
        if (tmp.start.time > tmp.end.time) normalizedRange.reverse();
        return normalizedRange;
    };
    /**
   * range info
   *
   * @private
   * @param  {Array} range range ['2017-01-01', '2017-07-08']
   *  If range[0] > range[1], they will not be reversed.
   * @return {Object}       obj
   */ Calendar.prototype._getRangeInfo = function(range) {
        var parsedRange = [
            this.getDateInfo(range[0]),
            this.getDateInfo(range[1])
        ];
        var reversed;
        if (parsedRange[0].time > parsedRange[1].time) {
            reversed = true;
            parsedRange.reverse();
        }
        var allDay = Math.floor(parsedRange[1].time / $66fc274744e4c9d6$var$PROXIMATE_ONE_DAY) - Math.floor(parsedRange[0].time / $66fc274744e4c9d6$var$PROXIMATE_ONE_DAY) + 1;
        // Consider case1 (#11677 #10430):
        // Set the system timezone as "UK", set the range to `['2016-07-01', '2016-12-31']`
        // Consider case2:
        // Firstly set system timezone as "Time Zone: America/Toronto",
        // ```
        // let first = new Date(1478412000000 - 3600 * 1000 * 2.5);
        // let second = new Date(1478412000000);
        // let allDays = Math.floor(second / ONE_DAY) - Math.floor(first / ONE_DAY) + 1;
        // ```
        // will get wrong result because of DST. So we should fix it.
        var date = new Date(parsedRange[0].time);
        var startDateNum = date.getDate();
        var endDateNum = parsedRange[1].date.getDate();
        date.setDate(startDateNum + allDay - 1);
        // The bias can not over a month, so just compare date.
        var dateNum = date.getDate();
        if (dateNum !== endDateNum) {
            var sign = date.getTime() - parsedRange[1].time > 0 ? 1 : -1;
            while((dateNum = date.getDate()) !== endDateNum && (date.getTime() - parsedRange[1].time) * sign > 0){
                allDay -= sign;
                date.setDate(dateNum - sign);
            }
        }
        var weeks = Math.floor((allDay + parsedRange[0].day + 6) / 7);
        var nthWeek = reversed ? -weeks + 1 : weeks - 1;
        reversed && parsedRange.reverse();
        return {
            range: [
                parsedRange[0].formatedDate,
                parsedRange[1].formatedDate
            ],
            start: parsedRange[0],
            end: parsedRange[1],
            allDay: allDay,
            weeks: weeks,
            // From 0.
            nthWeek: nthWeek,
            fweek: parsedRange[0].day,
            lweek: parsedRange[1].day
        };
    };
    /**
   * get date by nthWeeks and week day in range
   *
   * @private
   * @param  {number} nthWeek the week
   * @param  {number} day   the week day
   * @param  {Array} range [d1, d2]
   * @return {Object}
   */ Calendar.prototype._getDateByWeeksAndDay = function(nthWeek, day, range) {
        var rangeInfo = this._getRangeInfo(range);
        if (nthWeek > rangeInfo.weeks || nthWeek === 0 && day < rangeInfo.fweek || nthWeek === rangeInfo.weeks && day > rangeInfo.lweek) return null;
        var nthDay = (nthWeek - 1) * 7 - rangeInfo.fweek + day;
        var date = new Date(rangeInfo.start.time);
        date.setDate(+rangeInfo.start.d + nthDay);
        return this.getDateInfo(date);
    };
    Calendar.create = function(ecModel, api) {
        var calendarList = [];
        ecModel.eachComponent("calendar", function(calendarModel) {
            var calendar = new Calendar(calendarModel, ecModel, api);
            calendarList.push(calendar);
            calendarModel.coordinateSystem = calendar;
        });
        // Inject coordinate system
        ecModel.eachComponent(function(mainType, componentModel) {
            (0, $a30c5e122eaab0a1$export$7ed0c09d4f5c932e)({
                targetModel: componentModel,
                coordSysType: "calendar",
                coordSysProvider: (0, $a30c5e122eaab0a1$export$33b06c851894cd19)
            });
        });
        return calendarList;
    };
    Calendar.dimensions = [
        "time",
        "value"
    ];
    return Calendar;
}();
function $66fc274744e4c9d6$var$getCoordSys(finder) {
    var calendarModel = finder.calendarModel;
    var seriesModel = finder.seriesModel;
    var coordSys = calendarModel ? calendarModel.coordinateSystem : seriesModel ? seriesModel.coordinateSystem : null;
    return coordSys;
}
var $66fc274744e4c9d6$export$2e2bcd8739ae039 = $66fc274744e4c9d6$var$Calendar;


function $9580c6053e3028db$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $1eb1ecd0989c64d5$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $e320c2f2c921c454$export$2e2bcd8739ae039));
    registers.registerCoordinateSystem("calendar", (0, $66fc274744e4c9d6$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * @file Visual mapping.
 */ 

var $031e7d9d693e91a3$var$visualDefault = {
    /**
   * @public
   */ get: function(visualType, key, isCategory) {
        var value = $43e0a445ed6711da$export$9cd59f9826255e47(($031e7d9d693e91a3$var$defaultOption[visualType] || {})[key]);
        return isCategory ? $43e0a445ed6711da$export$43bee75e5e14138e(value) ? value[value.length - 1] : value : value;
    }
};
var $031e7d9d693e91a3$var$defaultOption = {
    color: {
        active: [
            "#006edd",
            "#e0ffff"
        ],
        inactive: [
            (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.transparent
        ]
    },
    colorHue: {
        active: [
            0,
            360
        ],
        inactive: [
            0,
            0
        ]
    },
    colorSaturation: {
        active: [
            0.3,
            1
        ],
        inactive: [
            0,
            0
        ]
    },
    colorLightness: {
        active: [
            0.9,
            0.5
        ],
        inactive: [
            0,
            0
        ]
    },
    colorAlpha: {
        active: [
            0.3,
            1
        ],
        inactive: [
            0,
            0
        ]
    },
    opacity: {
        active: [
            0.3,
            1
        ],
        inactive: [
            0,
            0
        ]
    },
    symbol: {
        active: [
            "circle",
            "roundRect",
            "diamond"
        ],
        inactive: [
            "none"
        ]
    },
    symbolSize: {
        active: [
            10,
            50
        ],
        inactive: [
            0,
            0
        ]
    }
};
var $031e7d9d693e91a3$export$2e2bcd8739ae039 = $031e7d9d693e91a3$var$visualDefault;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $46853c8218ff2c50$var$each = $43e0a445ed6711da$export$79b2f7037acddd43;
var $46853c8218ff2c50$var$isObject = $43e0a445ed6711da$export$a6cdc56e425d0d0a;
var $46853c8218ff2c50$var$CATEGORY_DEFAULT_VISUAL_INDEX = -1;
var $46853c8218ff2c50$var$VisualMapping = /** @class */ function() {
    function VisualMapping(option) {
        var mappingMethod = option.mappingMethod;
        var visualType = option.type;
        var thisOption = this.option = $43e0a445ed6711da$export$9cd59f9826255e47(option);
        this.type = visualType;
        this.mappingMethod = mappingMethod;
        this._normalizeData = $46853c8218ff2c50$var$normalizers[mappingMethod];
        var visualHandler = VisualMapping.visualHandlers[visualType];
        this.applyVisual = visualHandler.applyVisual;
        this.getColorMapper = visualHandler.getColorMapper;
        this._normalizedToVisual = visualHandler._normalizedToVisual[mappingMethod];
        if (mappingMethod === "piecewise") {
            $46853c8218ff2c50$var$normalizeVisualRange(thisOption);
            $46853c8218ff2c50$var$preprocessForPiecewise(thisOption);
        } else if (mappingMethod === "category") thisOption.categories ? $46853c8218ff2c50$var$preprocessForSpecifiedCategory(thisOption) : $46853c8218ff2c50$var$normalizeVisualRange(thisOption, true);
        else {
            // mappingMethod === 'linear' or 'fixed'
            $43e0a445ed6711da$export$a7a9523472993e97(mappingMethod !== "linear" || thisOption.dataExtent);
            $46853c8218ff2c50$var$normalizeVisualRange(thisOption);
        }
    }
    VisualMapping.prototype.mapValueToVisual = function(value) {
        var normalized = this._normalizeData(value);
        return this._normalizedToVisual(normalized, value);
    };
    VisualMapping.prototype.getNormalizer = function() {
        return $43e0a445ed6711da$export$2385a24977818dd0(this._normalizeData, this);
    };
    /**
   * List available visual types.
   *
   * @public
   * @return {Array.<string>}
   */ VisualMapping.listVisualTypes = function() {
        return $43e0a445ed6711da$export$ed97f33186d4b816(VisualMapping.visualHandlers);
    };
    // /**
    //  * @public
    //  */
    // static addVisualHandler(name, handler) {
    //     visualHandlers[name] = handler;
    // }
    /**
   * @public
   */ VisualMapping.isValidType = function(visualType) {
        return VisualMapping.visualHandlers.hasOwnProperty(visualType);
    };
    /**
   * Convenient method.
   * Visual can be Object or Array or primary type.
   */ VisualMapping.eachVisual = function(visual, callback, context) {
        if ($43e0a445ed6711da$export$a6cdc56e425d0d0a(visual)) $43e0a445ed6711da$export$79b2f7037acddd43(visual, callback, context);
        else callback.call(context, visual);
    };
    VisualMapping.mapVisual = function(visual, callback, context) {
        var isPrimary;
        var newVisual = $43e0a445ed6711da$export$43bee75e5e14138e(visual) ? [] : $43e0a445ed6711da$export$a6cdc56e425d0d0a(visual) ? {} : (isPrimary = true, null);
        VisualMapping.eachVisual(visual, function(v, key) {
            var newVal = callback.call(context, v, key);
            isPrimary ? newVisual = newVal : newVisual[key] = newVal;
        });
        return newVisual;
    };
    /**
   * Retrieve visual properties from given object.
   */ VisualMapping.retrieveVisuals = function(obj) {
        var ret = {};
        var hasVisual;
        obj && $46853c8218ff2c50$var$each(VisualMapping.visualHandlers, function(h, visualType) {
            if (obj.hasOwnProperty(visualType)) {
                ret[visualType] = obj[visualType];
                hasVisual = true;
            }
        });
        return hasVisual ? ret : null;
    };
    /**
   * Give order to visual types, considering colorSaturation, colorAlpha depends on color.
   *
   * @public
   * @param {(Object|Array)} visualTypes If Object, like: {color: ..., colorSaturation: ...}
   *                                     IF Array, like: ['color', 'symbol', 'colorSaturation']
   * @return {Array.<string>} Sorted visual types.
   */ VisualMapping.prepareVisualTypes = function(visualTypes) {
        if ($43e0a445ed6711da$export$43bee75e5e14138e(visualTypes)) visualTypes = visualTypes.slice();
        else if ($46853c8218ff2c50$var$isObject(visualTypes)) {
            var types_1 = [];
            $46853c8218ff2c50$var$each(visualTypes, function(item, type) {
                types_1.push(type);
            });
            visualTypes = types_1;
        } else return [];
        visualTypes.sort(function(type1, type2) {
            // color should be front of colorSaturation, colorAlpha, ...
            // symbol and symbolSize do not matter.
            return type2 === "color" && type1 !== "color" && type1.indexOf("color") === 0 ? 1 : -1;
        });
        return visualTypes;
    };
    /**
   * 'color', 'colorSaturation', 'colorAlpha', ... are depends on 'color'.
   * Other visuals are only depends on themself.
   */ VisualMapping.dependsOn = function(visualType1, visualType2) {
        return visualType2 === "color" ? !!(visualType1 && visualType1.indexOf(visualType2) === 0) : visualType1 === visualType2;
    };
    /**
   * @param value
   * @param pieceList [{value: ..., interval: [min, max]}, ...]
   *                         Always from small to big.
   * @param findClosestWhenOutside Default to be false
   * @return index
   */ VisualMapping.findPieceIndex = function(value, pieceList, findClosestWhenOutside) {
        var possibleI;
        var abs = Infinity;
        // value has the higher priority.
        for(var i = 0, len = pieceList.length; i < len; i++){
            var pieceValue = pieceList[i].value;
            if (pieceValue != null) {
                if (pieceValue === value || $43e0a445ed6711da$export$844ec244b1367d54(pieceValue) && pieceValue === value + "") return i;
                findClosestWhenOutside && updatePossible(pieceValue, i);
            }
        }
        for(var i = 0, len = pieceList.length; i < len; i++){
            var piece = pieceList[i];
            var interval = piece.interval;
            var close_1 = piece.close;
            if (interval) {
                if (interval[0] === -Infinity) {
                    if ($46853c8218ff2c50$var$littleThan(close_1[1], value, interval[1])) return i;
                } else if (interval[1] === Infinity) {
                    if ($46853c8218ff2c50$var$littleThan(close_1[0], interval[0], value)) return i;
                } else if ($46853c8218ff2c50$var$littleThan(close_1[0], interval[0], value) && $46853c8218ff2c50$var$littleThan(close_1[1], value, interval[1])) return i;
                findClosestWhenOutside && updatePossible(interval[0], i);
                findClosestWhenOutside && updatePossible(interval[1], i);
            }
        }
        if (findClosestWhenOutside) return value === Infinity ? pieceList.length - 1 : value === -Infinity ? 0 : possibleI;
        function updatePossible(val, index) {
            var newAbs = Math.abs(val - value);
            if (newAbs < abs) {
                abs = newAbs;
                possibleI = index;
            }
        }
    };
    VisualMapping.visualHandlers = {
        color: {
            applyVisual: $46853c8218ff2c50$var$makeApplyVisual("color"),
            getColorMapper: function() {
                var thisOption = this.option;
                return $43e0a445ed6711da$export$2385a24977818dd0(thisOption.mappingMethod === "category" ? function(value, isNormalized) {
                    !isNormalized && (value = this._normalizeData(value));
                    return $46853c8218ff2c50$var$doMapCategory.call(this, value);
                } : function(value, isNormalized, out) {
                    // If output rgb array
                    // which will be much faster and useful in pixel manipulation
                    var returnRGBArray = !!out;
                    !isNormalized && (value = this._normalizeData(value));
                    out = $b0979f18b0a232f9$export$66cb3c0e9efc61c8(value, thisOption.parsedVisual, out);
                    return returnRGBArray ? out : $b0979f18b0a232f9$export$fac44ee5b035f737(out, "rgba");
                }, this);
            },
            _normalizedToVisual: {
                linear: function(normalized) {
                    return $b0979f18b0a232f9$export$fac44ee5b035f737($b0979f18b0a232f9$export$66cb3c0e9efc61c8(normalized, this.option.parsedVisual), "rgba");
                },
                category: $46853c8218ff2c50$var$doMapCategory,
                piecewise: function(normalized, value) {
                    var result = $46853c8218ff2c50$var$getSpecifiedVisual.call(this, value);
                    if (result == null) result = $b0979f18b0a232f9$export$fac44ee5b035f737($b0979f18b0a232f9$export$66cb3c0e9efc61c8(normalized, this.option.parsedVisual), "rgba");
                    return result;
                },
                fixed: $46853c8218ff2c50$var$doMapFixed
            }
        },
        colorHue: $46853c8218ff2c50$var$makePartialColorVisualHandler(function(color, value) {
            return $b0979f18b0a232f9$export$d898ae866e27bf18(color, value);
        }),
        colorSaturation: $46853c8218ff2c50$var$makePartialColorVisualHandler(function(color, value) {
            return $b0979f18b0a232f9$export$d898ae866e27bf18(color, null, value);
        }),
        colorLightness: $46853c8218ff2c50$var$makePartialColorVisualHandler(function(color, value) {
            return $b0979f18b0a232f9$export$d898ae866e27bf18(color, null, null, value);
        }),
        colorAlpha: $46853c8218ff2c50$var$makePartialColorVisualHandler(function(color, value) {
            return $b0979f18b0a232f9$export$ab4754bf42583a26(color, value);
        }),
        decal: {
            applyVisual: $46853c8218ff2c50$var$makeApplyVisual("decal"),
            _normalizedToVisual: {
                linear: null,
                category: $46853c8218ff2c50$var$doMapCategory,
                piecewise: null,
                fixed: null
            }
        },
        opacity: {
            applyVisual: $46853c8218ff2c50$var$makeApplyVisual("opacity"),
            _normalizedToVisual: $46853c8218ff2c50$var$createNormalizedToNumericVisual([
                0,
                1
            ])
        },
        liftZ: {
            applyVisual: $46853c8218ff2c50$var$makeApplyVisual("liftZ"),
            _normalizedToVisual: {
                linear: $46853c8218ff2c50$var$doMapFixed,
                category: $46853c8218ff2c50$var$doMapFixed,
                piecewise: $46853c8218ff2c50$var$doMapFixed,
                fixed: $46853c8218ff2c50$var$doMapFixed
            }
        },
        symbol: {
            applyVisual: function(value, getter, setter) {
                var symbolCfg = this.mapValueToVisual(value);
                setter("symbol", symbolCfg);
            },
            _normalizedToVisual: {
                linear: $46853c8218ff2c50$var$doMapToArray,
                category: $46853c8218ff2c50$var$doMapCategory,
                piecewise: function(normalized, value) {
                    var result = $46853c8218ff2c50$var$getSpecifiedVisual.call(this, value);
                    if (result == null) result = $46853c8218ff2c50$var$doMapToArray.call(this, normalized);
                    return result;
                },
                fixed: $46853c8218ff2c50$var$doMapFixed
            }
        },
        symbolSize: {
            applyVisual: $46853c8218ff2c50$var$makeApplyVisual("symbolSize"),
            _normalizedToVisual: $46853c8218ff2c50$var$createNormalizedToNumericVisual([
                0,
                1
            ])
        }
    };
    return VisualMapping;
}();
function $46853c8218ff2c50$var$preprocessForPiecewise(thisOption) {
    var pieceList = thisOption.pieceList;
    thisOption.hasSpecialVisual = false;
    $43e0a445ed6711da$export$79b2f7037acddd43(pieceList, function(piece, index) {
        piece.originIndex = index;
        // piece.visual is "result visual value" but not
        // a visual range, so it does not need to be normalized.
        if (piece.visual != null) thisOption.hasSpecialVisual = true;
    });
}
function $46853c8218ff2c50$var$preprocessForSpecifiedCategory(thisOption) {
    // Hash categories.
    var categories = thisOption.categories;
    var categoryMap = thisOption.categoryMap = {};
    var visual = thisOption.visual;
    $46853c8218ff2c50$var$each(categories, function(cate, index) {
        categoryMap[cate] = index;
    });
    // Process visual map input.
    if (!$43e0a445ed6711da$export$43bee75e5e14138e(visual)) {
        var visualArr_1 = [];
        if ($43e0a445ed6711da$export$a6cdc56e425d0d0a(visual)) $46853c8218ff2c50$var$each(visual, function(v, cate) {
            var index = categoryMap[cate];
            visualArr_1[index != null ? index : $46853c8218ff2c50$var$CATEGORY_DEFAULT_VISUAL_INDEX] = v;
        });
        else // Is primary type, represents default visual.
        visualArr_1[$46853c8218ff2c50$var$CATEGORY_DEFAULT_VISUAL_INDEX] = visual;
        visual = $46853c8218ff2c50$var$setVisualToOption(thisOption, visualArr_1);
    }
    // Remove categories that has no visual,
    // then we can mapping them to CATEGORY_DEFAULT_VISUAL_INDEX.
    for(var i = categories.length - 1; i >= 0; i--)if (visual[i] == null) {
        delete categoryMap[categories[i]];
        categories.pop();
    }
}
function $46853c8218ff2c50$var$normalizeVisualRange(thisOption, isCategory) {
    var visual = thisOption.visual;
    var visualArr = [];
    if ($43e0a445ed6711da$export$a6cdc56e425d0d0a(visual)) $46853c8218ff2c50$var$each(visual, function(v) {
        visualArr.push(v);
    });
    else if (visual != null) visualArr.push(visual);
    var doNotNeedPair = {
        color: 1,
        symbol: 1
    };
    if (!isCategory && visualArr.length === 1 && !doNotNeedPair.hasOwnProperty(thisOption.type)) // Do not care visualArr.length === 0, which is illegal.
    visualArr[1] = visualArr[0];
    $46853c8218ff2c50$var$setVisualToOption(thisOption, visualArr);
}
function $46853c8218ff2c50$var$makePartialColorVisualHandler(applyValue) {
    return {
        applyVisual: function(value, getter, setter) {
            // Only used in HSL
            var colorChannel = this.mapValueToVisual(value);
            // Must not be array value
            setter("color", applyValue(getter("color"), colorChannel));
        },
        _normalizedToVisual: $46853c8218ff2c50$var$createNormalizedToNumericVisual([
            0,
            1
        ])
    };
}
function $46853c8218ff2c50$var$doMapToArray(normalized) {
    var visual = this.option.visual;
    return visual[Math.round((0, $b49750109e236fd8$export$d3f68fbaa670562)(normalized, [
        0,
        1
    ], [
        0,
        visual.length - 1
    ], true))] || {}; // TODO {}?
}
function $46853c8218ff2c50$var$makeApplyVisual(visualType) {
    return function(value, getter, setter) {
        setter(visualType, this.mapValueToVisual(value));
    };
}
function $46853c8218ff2c50$var$doMapCategory(normalized) {
    var visual = this.option.visual;
    return visual[this.option.loop && normalized !== $46853c8218ff2c50$var$CATEGORY_DEFAULT_VISUAL_INDEX ? normalized % visual.length : normalized];
}
function $46853c8218ff2c50$var$doMapFixed() {
    // visual will be convert to array.
    return this.option.visual[0];
}
/**
 * Create mapped to numeric visual
 */ function $46853c8218ff2c50$var$createNormalizedToNumericVisual(sourceExtent) {
    return {
        linear: function(normalized) {
            return (0, $b49750109e236fd8$export$d3f68fbaa670562)(normalized, sourceExtent, this.option.visual, true);
        },
        category: $46853c8218ff2c50$var$doMapCategory,
        piecewise: function(normalized, value) {
            var result = $46853c8218ff2c50$var$getSpecifiedVisual.call(this, value);
            if (result == null) result = (0, $b49750109e236fd8$export$d3f68fbaa670562)(normalized, sourceExtent, this.option.visual, true);
            return result;
        },
        fixed: $46853c8218ff2c50$var$doMapFixed
    };
}
function $46853c8218ff2c50$var$getSpecifiedVisual(value) {
    var thisOption = this.option;
    var pieceList = thisOption.pieceList;
    if (thisOption.hasSpecialVisual) {
        var pieceIndex = $46853c8218ff2c50$var$VisualMapping.findPieceIndex(value, pieceList);
        var piece = pieceList[pieceIndex];
        if (piece && piece.visual) return piece.visual[this.type];
    }
}
function $46853c8218ff2c50$var$setVisualToOption(thisOption, visualArr) {
    thisOption.visual = visualArr;
    if (thisOption.type === "color") thisOption.parsedVisual = $43e0a445ed6711da$export$871de8747c9eaa88(visualArr, function(item) {
        var color = $b0979f18b0a232f9$export$98e6a39c04603d36(item);
        return color || [
            0,
            0,
            0,
            1
        ];
    });
    return visualArr;
}
/**
 * Normalizers by mapping methods.
 */ var $46853c8218ff2c50$var$normalizers = {
    linear: function(value) {
        return (0, $b49750109e236fd8$export$d3f68fbaa670562)(value, this.option.dataExtent, [
            0,
            1
        ], true);
    },
    piecewise: function(value) {
        var pieceList = this.option.pieceList;
        var pieceIndex = $46853c8218ff2c50$var$VisualMapping.findPieceIndex(value, pieceList, true);
        if (pieceIndex != null) return (0, $b49750109e236fd8$export$d3f68fbaa670562)(pieceIndex, [
            0,
            pieceList.length - 1
        ], [
            0,
            1
        ], true);
    },
    category: function(value) {
        var index = this.option.categories ? this.option.categoryMap[value] : value; // ordinal value
        return index == null ? $46853c8218ff2c50$var$CATEGORY_DEFAULT_VISUAL_INDEX : index;
    },
    fixed: $43e0a445ed6711da$export$8793edee2d425525
};
function $46853c8218ff2c50$var$littleThan(close, a, b) {
    return close ? a <= b : a < b;
}
var $46853c8218ff2c50$export$2e2bcd8739ae039 = $46853c8218ff2c50$var$VisualMapping;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * @file Visual solution, for consistent option specification.
 */ 


var $02cc52f53cf557df$var$each = $43e0a445ed6711da$export$79b2f7037acddd43;
function $02cc52f53cf557df$var$hasKeys(obj) {
    if (obj) for(var name_1 in obj){
        if (obj.hasOwnProperty(name_1)) return true;
    }
}
function $02cc52f53cf557df$export$89974527642f24a0(option, stateList, supplementVisualOption) {
    var visualMappings = {};
    $02cc52f53cf557df$var$each(stateList, function(state) {
        var mappings = visualMappings[state] = createMappings();
        $02cc52f53cf557df$var$each(option[state], function(visualData, visualType) {
            if (!(0, $46853c8218ff2c50$export$2e2bcd8739ae039).isValidType(visualType)) return;
            var mappingOption = {
                type: visualType,
                visual: visualData
            };
            supplementVisualOption && supplementVisualOption(mappingOption, state);
            mappings[visualType] = new (0, $46853c8218ff2c50$export$2e2bcd8739ae039)(mappingOption);
            // Prepare a alpha for opacity, for some case that opacity
            // is not supported, such as rendering using gradient color.
            if (visualType === "opacity") {
                mappingOption = $43e0a445ed6711da$export$9cd59f9826255e47(mappingOption);
                mappingOption.type = "colorAlpha";
                mappings.__hidden.__alphaForOpacity = new (0, $46853c8218ff2c50$export$2e2bcd8739ae039)(mappingOption);
            }
        });
    });
    return visualMappings;
    function createMappings() {
        var Creater = function() {};
        // Make sure hidden fields will not be visited by
        // object iteration (with hasOwnProperty checking).
        Creater.prototype.__hidden = Creater.prototype;
        var obj = new Creater();
        return obj;
    }
}
function $02cc52f53cf557df$export$797d20c0a6de578f(thisOption, newOption, keys) {
    // Visual attributes merge is not supported, otherwise it
    // brings overcomplicated merge logic. See #2853. So if
    // newOption has anyone of these keys, all of these keys
    // will be reset. Otherwise, all keys remain.
    var has;
    $43e0a445ed6711da$export$79b2f7037acddd43(keys, function(key) {
        if (newOption.hasOwnProperty(key) && $02cc52f53cf557df$var$hasKeys(newOption[key])) has = true;
    });
    has && $43e0a445ed6711da$export$79b2f7037acddd43(keys, function(key) {
        if (newOption.hasOwnProperty(key) && $02cc52f53cf557df$var$hasKeys(newOption[key])) thisOption[key] = $43e0a445ed6711da$export$9cd59f9826255e47(newOption[key]);
        else delete thisOption[key];
    });
}
function $02cc52f53cf557df$export$bb1ef43951d58629(stateList, visualMappings, data, getValueState, scope, dimension) {
    var visualTypesMap = {};
    $43e0a445ed6711da$export$79b2f7037acddd43(stateList, function(state) {
        var visualTypes = (0, $46853c8218ff2c50$export$2e2bcd8739ae039).prepareVisualTypes(visualMappings[state]);
        visualTypesMap[state] = visualTypes;
    });
    var dataIndex;
    function getVisual(key) {
        return (0, $76af5bb296a0e67b$export$91d919a86b2df624)(data, dataIndex, key);
    }
    function setVisual(key, value) {
        (0, $76af5bb296a0e67b$export$3aab879e9d0e7c75)(data, dataIndex, key, value);
    }
    if (dimension == null) data.each(eachItem);
    else data.each([
        dimension
    ], eachItem);
    function eachItem(valueOrIndex, index) {
        dataIndex = dimension == null ? valueOrIndex // First argument is index
         : index;
        var rawDataItem = data.getRawDataItem(dataIndex);
        // Consider performance
        // @ts-ignore
        if (rawDataItem && rawDataItem.visualMap === false) return;
        var valueState = getValueState.call(scope, valueOrIndex);
        var mappings = visualMappings[valueState];
        var visualTypes = visualTypesMap[valueState];
        for(var i = 0, len = visualTypes.length; i < len; i++){
            var type = visualTypes[i];
            mappings[type] && mappings[type].applyVisual(valueOrIndex, getVisual, setVisual);
        }
    }
}
function $02cc52f53cf557df$export$fc0ef8703cccf128(stateList, visualMappings, getValueState, dim) {
    var visualTypesMap = {};
    $43e0a445ed6711da$export$79b2f7037acddd43(stateList, function(state) {
        var visualTypes = (0, $46853c8218ff2c50$export$2e2bcd8739ae039).prepareVisualTypes(visualMappings[state]);
        visualTypesMap[state] = visualTypes;
    });
    return {
        progress: function progress(params, data) {
            var dimIndex;
            if (dim != null) dimIndex = data.getDimensionIndex(dim);
            function getVisual(key) {
                return (0, $76af5bb296a0e67b$export$91d919a86b2df624)(data, dataIndex, key);
            }
            function setVisual(key, value) {
                (0, $76af5bb296a0e67b$export$3aab879e9d0e7c75)(data, dataIndex, key, value);
            }
            var dataIndex;
            var store = data.getStore();
            while((dataIndex = params.next()) != null){
                var rawDataItem = data.getRawDataItem(dataIndex);
                // Consider performance
                // @ts-ignore
                if (rawDataItem && rawDataItem.visualMap === false) continue;
                var value = dim != null ? store.get(dimIndex, dataIndex) : dataIndex;
                var valueState = getValueState(value);
                var mappings = visualMappings[valueState];
                var visualTypes = visualTypesMap[valueState];
                for(var i = 0, len = visualTypes.length; i < len; i++){
                    var type = visualTypes[i];
                    mappings[type] && mappings[type].applyVisual(value, getVisual, setVisual);
                }
            }
        }
    };
}






var $6c5fdd461a5b821e$var$mapVisual = (0, $46853c8218ff2c50$export$2e2bcd8739ae039).mapVisual;
var $6c5fdd461a5b821e$var$eachVisual = (0, $46853c8218ff2c50$export$2e2bcd8739ae039).eachVisual;
var $6c5fdd461a5b821e$var$isArray = $43e0a445ed6711da$export$43bee75e5e14138e;
var $6c5fdd461a5b821e$var$each = $43e0a445ed6711da$export$79b2f7037acddd43;
var $6c5fdd461a5b821e$var$asc = $b49750109e236fd8$export$debe6e778e0a6d32;
var $6c5fdd461a5b821e$var$linearMap = $b49750109e236fd8$export$d3f68fbaa670562;
var $6c5fdd461a5b821e$var$VisualMapModel = /** @class */ function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(VisualMapModel, _super);
    function VisualMapModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = VisualMapModel.type;
        _this.stateList = [
            "inRange",
            "outOfRange"
        ];
        _this.replacableOptionKeys = [
            "inRange",
            "outOfRange",
            "target",
            "controller",
            "color"
        ];
        _this.layoutMode = {
            type: "box",
            ignoreSize: true
        };
        /**
     * [lowerBound, upperBound]
     */ _this.dataBound = [
            -Infinity,
            Infinity
        ];
        _this.targetVisuals = {};
        _this.controllerVisuals = {};
        return _this;
    }
    VisualMapModel.prototype.init = function(option, parentModel, ecModel) {
        this.mergeDefaultAndTheme(option, ecModel);
    };
    /**
   * @protected
   */ VisualMapModel.prototype.optionUpdated = function(newOption, isInit) {
        var thisOption = this.option;
        !isInit && $02cc52f53cf557df$export$797d20c0a6de578f(thisOption, newOption, this.replacableOptionKeys);
        this.textStyleModel = this.getModel("textStyle");
        this.resetItemSize();
        this.completeVisualOption();
    };
    /**
   * @protected
   */ VisualMapModel.prototype.resetVisual = function(supplementVisualOption) {
        var stateList = this.stateList;
        supplementVisualOption = $43e0a445ed6711da$export$2385a24977818dd0(supplementVisualOption, this);
        this.controllerVisuals = $02cc52f53cf557df$export$89974527642f24a0(this.option.controller, stateList, supplementVisualOption);
        this.targetVisuals = $02cc52f53cf557df$export$89974527642f24a0(this.option.target, stateList, supplementVisualOption);
    };
    /**
   * @public
   */ VisualMapModel.prototype.getItemSymbol = function() {
        return null;
    };
    /**
   * @return An array of series indices.
   */ VisualMapModel.prototype.getTargetSeriesIndices = function() {
        var _this = this;
        var seriesTargets = this.option.seriesTargets;
        if (seriesTargets) {
            // When seriesTargets is provided, collect all target series indices
            var indices_1 = [];
            $6c5fdd461a5b821e$var$each(seriesTargets, function(target) {
                if (target.seriesIndex != null) indices_1.push(target.seriesIndex);
                else if (target.seriesId != null) {
                    // Find series by ID
                    var seriesModel_1;
                    _this.ecModel.eachSeries(function(series) {
                        if (series.id === target.seriesId) seriesModel_1 = series;
                    });
                    if (seriesModel_1) indices_1.push(seriesModel_1.componentIndex);
                }
            });
            return indices_1;
        }
        var optionSeriesId = this.option.seriesId;
        var optionSeriesIndex = this.option.seriesIndex;
        if (optionSeriesIndex == null && optionSeriesId == null) optionSeriesIndex = "all";
        var seriesModels = $87f4a59ac66e0ee6$export$dc741340f7e5f186(this.ecModel, "series", {
            index: optionSeriesIndex,
            id: optionSeriesId
        }, {
            useDefault: false,
            enableAll: true,
            enableNone: false
        }).models;
        return $43e0a445ed6711da$export$871de8747c9eaa88(seriesModels, function(seriesModel) {
            return seriesModel.componentIndex;
        });
    };
    /**
   * @public
   */ VisualMapModel.prototype.eachTargetSeries = function(callback, context) {
        $43e0a445ed6711da$export$79b2f7037acddd43(this.getTargetSeriesIndices(), function(seriesIndex) {
            var seriesModel = this.ecModel.getSeriesByIndex(seriesIndex);
            if (seriesModel) callback.call(context, seriesModel);
        }, this);
    };
    /**
   * @pubilc
   */ VisualMapModel.prototype.isTargetSeries = function(seriesModel) {
        var is = false;
        this.eachTargetSeries(function(model) {
            model === seriesModel && (is = true);
        });
        return is;
    };
    /**
   * @example
   * this.formatValueText(someVal); // format single numeric value to text.
   * this.formatValueText(someVal, true); // format single category value to text.
   * this.formatValueText([min, max]); // format numeric min-max to text.
   * this.formatValueText([this.dataBound[0], max]); // using data lower bound.
   * this.formatValueText([min, this.dataBound[1]]); // using data upper bound.
   *
   * @param value Real value, or this.dataBound[0 or 1].
   * @param isCategory Only available when value is number.
   * @param edgeSymbols Open-close symbol when value is interval.
   * @protected
   */ VisualMapModel.prototype.formatValueText = function(value, isCategory, edgeSymbols) {
        var option = this.option;
        var precision = option.precision;
        var dataBound = this.dataBound;
        var formatter = option.formatter;
        var isMinMax;
        edgeSymbols = edgeSymbols || [
            "<",
            ">"
        ];
        if ($43e0a445ed6711da$export$43bee75e5e14138e(value)) {
            value = value.slice();
            isMinMax = true;
        }
        var textValue = isCategory ? value // Value is string when isCategory
         : isMinMax ? [
            toFixed(value[0]),
            toFixed(value[1])
        ] : toFixed(value);
        if ($43e0a445ed6711da$export$844ec244b1367d54(formatter)) return formatter.replace("{value}", isMinMax ? textValue[0] : textValue).replace("{value2}", isMinMax ? textValue[1] : textValue);
        else if ($43e0a445ed6711da$export$f6e2535fb5126e54(formatter)) return isMinMax ? formatter(value[0], value[1]) : formatter(value);
        if (isMinMax) {
            if (value[0] === dataBound[0]) return edgeSymbols[0] + " " + textValue[1];
            else if (value[1] === dataBound[1]) return edgeSymbols[1] + " " + textValue[0];
            else return textValue[0] + " - " + textValue[1];
        } else // Format single value (includes category case).
        return textValue;
        function toFixed(val) {
            return val === dataBound[0] ? "min" : val === dataBound[1] ? "max" : (+val).toFixed(Math.min(precision, 20));
        }
    };
    /**
   * @protected
   */ VisualMapModel.prototype.resetExtent = function() {
        var thisOption = this.option;
        // Can not calculate data extent by data here.
        // Because series and data may be modified in processing stage.
        // So we do not support the feature "auto min/max".
        var extent = $6c5fdd461a5b821e$var$asc([
            thisOption.min,
            thisOption.max
        ]);
        this._dataExtent = extent;
    };
    /**
   * PENDING:
   * delete this method if no outer usage.
   *
   * Return  Concrete dimension. If null/undefined is returned, no dimension is used.
   */ // getDataDimension(data: SeriesData) {
    //     const optDim = this.option.dimension;
    //     if (optDim != null) {
    //         return data.getDimension(optDim);
    //     }
    //     const dimNames = data.dimensions;
    //     for (let i = dimNames.length - 1; i >= 0; i--) {
    //         const dimName = dimNames[i];
    //         const dimInfo = data.getDimensionInfo(dimName);
    //         if (!dimInfo.isCalculationCoord) {
    //             return dimName;
    //         }
    //     }
    // }
    VisualMapModel.prototype.getDimension = function(seriesIndex) {
        var _this = this;
        var seriesTargets = this.option.seriesTargets;
        if (seriesTargets) {
            var target = $43e0a445ed6711da$export$71aa6c912b956294(seriesTargets, function(target) {
                return target.seriesIndex != null && target.seriesIndex === seriesIndex || target.seriesId != null && target.seriesId === _this.ecModel.getSeriesByIndex(seriesIndex).id;
            });
            if (target) return target.dimension;
        }
        return this.option.dimension;
    };
    VisualMapModel.prototype.getDataDimensionIndex = function(data) {
        var seriesIndex = data.hostModel.seriesIndex;
        var optDim = this.getDimension(seriesIndex);
        if (optDim != null) return data.getDimensionIndex(optDim);
        var dimNames = data.dimensions;
        for(var i = dimNames.length - 1; i >= 0; i--){
            var dimName = dimNames[i];
            var dimInfo = data.getDimensionInfo(dimName);
            if (!dimInfo.isCalculationCoord) return dimInfo.storeDimIndex;
        }
    };
    VisualMapModel.prototype.getExtent = function() {
        return this._dataExtent.slice();
    };
    VisualMapModel.prototype.completeVisualOption = function() {
        var ecModel = this.ecModel;
        var thisOption = this.option;
        var base = {
            inRange: thisOption.inRange,
            outOfRange: thisOption.outOfRange
        };
        var target = thisOption.target || (thisOption.target = {});
        var controller = thisOption.controller || (thisOption.controller = {});
        $43e0a445ed6711da$export$4950aa0f605343fb(target, base); // Do not override
        $43e0a445ed6711da$export$4950aa0f605343fb(controller, base); // Do not override
        var isCategory = this.isCategory();
        completeSingle.call(this, target);
        completeSingle.call(this, controller);
        completeInactive.call(this, target, "inRange", "outOfRange");
        // completeInactive.call(this, target, 'outOfRange', 'inRange');
        completeController.call(this, controller);
        function completeSingle(base) {
            // Compatible with ec2 dataRange.color.
            // The mapping order of dataRange.color is: [high value, ..., low value]
            // whereas inRange.color and outOfRange.color is [low value, ..., high value]
            // Notice: ec2 has no inverse.
            if ($6c5fdd461a5b821e$var$isArray(thisOption.color) && !base.inRange) base.inRange = {
                color: thisOption.color.slice().reverse()
            };
            // Compatible with previous logic, always give a default color, otherwise
            // simple config with no inRange and outOfRange will not work.
            // Originally we use visualMap.color as the default color, but setOption at
            // the second time the default color will be erased. So we change to use
            // constant DEFAULT_COLOR.
            // If user do not want the default color, set inRange: {color: null}.
            base.inRange = base.inRange || {
                color: ecModel.get("gradientColor")
            };
        }
        function completeInactive(base, stateExist, stateAbsent) {
            var optExist = base[stateExist];
            var optAbsent = base[stateAbsent];
            if (optExist && !optAbsent) {
                optAbsent = base[stateAbsent] = {};
                $6c5fdd461a5b821e$var$each(optExist, function(visualData, visualType) {
                    if (!(0, $46853c8218ff2c50$export$2e2bcd8739ae039).isValidType(visualType)) return;
                    var defa = (0, $031e7d9d693e91a3$export$2e2bcd8739ae039).get(visualType, "inactive", isCategory);
                    if (defa != null) {
                        optAbsent[visualType] = defa;
                        // Compatibable with ec2:
                        // Only inactive color to rgba(0,0,0,0) can not
                        // make label transparent, so use opacity also.
                        if (visualType === "color" && !optAbsent.hasOwnProperty("opacity") && !optAbsent.hasOwnProperty("colorAlpha")) optAbsent.opacity = [
                            0,
                            0
                        ];
                    }
                });
            }
        }
        function completeController(controller) {
            var symbolExists = (controller.inRange || {}).symbol || (controller.outOfRange || {}).symbol;
            var symbolSizeExists = (controller.inRange || {}).symbolSize || (controller.outOfRange || {}).symbolSize;
            var inactiveColor = this.get("inactiveColor");
            var itemSymbol = this.getItemSymbol();
            var defaultSymbol = itemSymbol || "roundRect";
            $6c5fdd461a5b821e$var$each(this.stateList, function(state) {
                var itemSize = this.itemSize;
                var visuals = controller[state];
                // Set inactive color for controller if no other color
                // attr (like colorAlpha) specified.
                if (!visuals) visuals = controller[state] = {
                    color: isCategory ? inactiveColor : [
                        inactiveColor
                    ]
                };
                // Consistent symbol and symbolSize if not specified.
                if (visuals.symbol == null) visuals.symbol = symbolExists && $43e0a445ed6711da$export$9cd59f9826255e47(symbolExists) || (isCategory ? defaultSymbol : [
                    defaultSymbol
                ]);
                if (visuals.symbolSize == null) visuals.symbolSize = symbolSizeExists && $43e0a445ed6711da$export$9cd59f9826255e47(symbolSizeExists) || (isCategory ? itemSize[0] : [
                    itemSize[0],
                    itemSize[0]
                ]);
                // Filter none
                visuals.symbol = $6c5fdd461a5b821e$var$mapVisual(visuals.symbol, function(symbol) {
                    return symbol === "none" ? defaultSymbol : symbol;
                });
                // Normalize symbolSize
                var symbolSize = visuals.symbolSize;
                if (symbolSize != null) {
                    var max_1 = -Infinity;
                    // symbolSize can be object when categories defined.
                    $6c5fdd461a5b821e$var$eachVisual(symbolSize, function(value) {
                        value > max_1 && (max_1 = value);
                    });
                    visuals.symbolSize = $6c5fdd461a5b821e$var$mapVisual(symbolSize, function(value) {
                        return $6c5fdd461a5b821e$var$linearMap(value, [
                            0,
                            max_1
                        ], [
                            0,
                            itemSize[0]
                        ], true);
                    });
                }
            }, this);
        }
    };
    VisualMapModel.prototype.resetItemSize = function() {
        this.itemSize = [
            parseFloat(this.get("itemWidth")),
            parseFloat(this.get("itemHeight"))
        ];
    };
    VisualMapModel.prototype.isCategory = function() {
        return !!this.option.categories;
    };
    /**
   * @public
   * @abstract
   */ VisualMapModel.prototype.setSelected = function(selected) {};
    VisualMapModel.prototype.getSelected = function() {
        return null;
    };
    /**
   * @public
   * @abstract
   */ VisualMapModel.prototype.getValueState = function(value) {
        return null;
    };
    /**
   * FIXME
   * Do not publish to thirt-part-dev temporarily
   * util the interface is stable. (Should it return
   * a function but not visual meta?)
   *
   * @pubilc
   * @abstract
   * @param getColorVisual
   *        params: value, valueState
   *        return: color
   * @return {Object} visualMeta
   *        should includes {stops, outerColors}
   *        outerColor means [colorBeyondMinValue, colorBeyondMaxValue]
   */ VisualMapModel.prototype.getVisualMeta = function(getColorVisual) {
        return null;
    };
    VisualMapModel.type = "visualMap";
    VisualMapModel.dependencies = [
        "series"
    ];
    VisualMapModel.defaultOption = {
        show: true,
        // zlevel: 0,
        z: 4,
        // seriesIndex: 'all',
        min: 0,
        max: 200,
        left: 0,
        right: null,
        top: null,
        bottom: 0,
        itemWidth: null,
        itemHeight: null,
        inverse: false,
        orient: "vertical",
        backgroundColor: (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.transparent,
        borderColor: (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.borderTint,
        contentColor: (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.theme[0],
        inactiveColor: (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.disabled,
        borderWidth: 0,
        padding: (0, $8327d823e00b772c$export$2e2bcd8739ae039).size.m,
        // 接受数组分别设定上右下左边距，同css
        textGap: 10,
        precision: 0,
        textStyle: {
            color: (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.secondary // 值域文字颜色
        }
    };
    return VisualMapModel;
}((0, $4a9041b12b787d1b$export$2e2bcd8739ae039));
var $6c5fdd461a5b821e$export$2e2bcd8739ae039 = $6c5fdd461a5b821e$var$VisualMapModel;





// Constant
var $10544d61198eef87$var$DEFAULT_BAR_BOUND = [
    20,
    140
];
var $10544d61198eef87$var$ContinuousModel = /** @class */ function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(ContinuousModel, _super);
    function ContinuousModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ContinuousModel.type;
        return _this;
    }
    /**
   * @override
   */ ContinuousModel.prototype.optionUpdated = function(newOption, isInit) {
        _super.prototype.optionUpdated.apply(this, arguments);
        this.resetExtent();
        this.resetVisual(function(mappingOption) {
            mappingOption.mappingMethod = "linear";
            mappingOption.dataExtent = this.getExtent();
        });
        this._resetRange();
    };
    /**
   * @protected
   * @override
   */ ContinuousModel.prototype.resetItemSize = function() {
        _super.prototype.resetItemSize.apply(this, arguments);
        var itemSize = this.itemSize;
        (itemSize[0] == null || isNaN(itemSize[0])) && (itemSize[0] = $10544d61198eef87$var$DEFAULT_BAR_BOUND[0]);
        (itemSize[1] == null || isNaN(itemSize[1])) && (itemSize[1] = $10544d61198eef87$var$DEFAULT_BAR_BOUND[1]);
    };
    /**
   * @private
   */ ContinuousModel.prototype._resetRange = function() {
        var dataExtent = this.getExtent();
        var range = this.option.range;
        if (!range || range.auto) {
            // `range` should always be array (so we don't use other
            // value like 'auto') for user-friend. (consider getOption).
            dataExtent.auto = 1;
            this.option.range = dataExtent;
        } else if ($43e0a445ed6711da$export$43bee75e5e14138e(range)) {
            if (range[0] > range[1]) range.reverse();
            range[0] = Math.max(range[0], dataExtent[0]);
            range[1] = Math.min(range[1], dataExtent[1]);
        }
    };
    /**
   * @protected
   * @override
   */ ContinuousModel.prototype.completeVisualOption = function() {
        _super.prototype.completeVisualOption.apply(this, arguments);
        $43e0a445ed6711da$export$79b2f7037acddd43(this.stateList, function(state) {
            var symbolSize = this.option.controller[state].symbolSize;
            if (symbolSize && symbolSize[0] !== symbolSize[1]) symbolSize[0] = symbolSize[1] / 3; // For good looking.
        }, this);
    };
    /**
   * @override
   */ ContinuousModel.prototype.setSelected = function(selected) {
        this.option.range = selected.slice();
        this._resetRange();
    };
    /**
   * @public
   */ ContinuousModel.prototype.getSelected = function() {
        var dataExtent = this.getExtent();
        var dataInterval = $b49750109e236fd8$export$debe6e778e0a6d32((this.get("range") || []).slice());
        // Clamp
        dataInterval[0] > dataExtent[1] && (dataInterval[0] = dataExtent[1]);
        dataInterval[1] > dataExtent[1] && (dataInterval[1] = dataExtent[1]);
        dataInterval[0] < dataExtent[0] && (dataInterval[0] = dataExtent[0]);
        dataInterval[1] < dataExtent[0] && (dataInterval[1] = dataExtent[0]);
        return dataInterval;
    };
    /**
   * @override
   */ ContinuousModel.prototype.getValueState = function(value) {
        var range = this.option.range;
        var dataExtent = this.getExtent();
        var unboundedRange = $43e0a445ed6711da$export$995e01f2f5c9d030(this.option.unboundedRange, true);
        return (unboundedRange && range[0] <= dataExtent[0] || range[0] <= value) && (unboundedRange && range[1] >= dataExtent[1] || value <= range[1]) ? "inRange" : "outOfRange";
    };
    ContinuousModel.prototype.findTargetDataIndices = function(range) {
        var result = [];
        this.eachTargetSeries(function(seriesModel) {
            var dataIndices = [];
            var data = seriesModel.getData();
            data.each(this.getDataDimensionIndex(data), function(value, dataIndex) {
                range[0] <= value && value <= range[1] && dataIndices.push(dataIndex);
            }, this);
            result.push({
                seriesId: seriesModel.id,
                dataIndex: dataIndices
            });
        }, this);
        return result;
    };
    /**
   * @implement
   */ ContinuousModel.prototype.getVisualMeta = function(getColorVisual) {
        var oVals = $10544d61198eef87$var$getColorStopValues(this, "outOfRange", this.getExtent());
        var iVals = $10544d61198eef87$var$getColorStopValues(this, "inRange", this.option.range.slice());
        var stops = [];
        function setStop(value, valueState) {
            stops.push({
                value: value,
                color: getColorVisual(value, valueState)
            });
        }
        // Format to: outOfRange -- inRange -- outOfRange.
        var iIdx = 0;
        var oIdx = 0;
        var iLen = iVals.length;
        var oLen = oVals.length;
        for(; oIdx < oLen && (!iVals.length || oVals[oIdx] <= iVals[0]); oIdx++)// If oVal[oIdx] === iVals[iIdx], oVal[oIdx] should be ignored.
        if (oVals[oIdx] < iVals[iIdx]) setStop(oVals[oIdx], "outOfRange");
        for(var first = 1; iIdx < iLen; iIdx++, first = 0){
            // If range is full, value beyond min, max will be clamped.
            // make a singularity
            first && stops.length && setStop(iVals[iIdx], "outOfRange");
            setStop(iVals[iIdx], "inRange");
        }
        for(var first = 1; oIdx < oLen; oIdx++)if (!iVals.length || iVals[iVals.length - 1] < oVals[oIdx]) {
            // make a singularity
            if (first) {
                stops.length && setStop(stops[stops.length - 1].value, "outOfRange");
                first = 0;
            }
            setStop(oVals[oIdx], "outOfRange");
        }
        var stopsLen = stops.length;
        return {
            stops: stops,
            outerColors: [
                stopsLen ? stops[0].color : "transparent",
                stopsLen ? stops[stopsLen - 1].color : "transparent"
            ]
        };
    };
    ContinuousModel.type = "visualMap.continuous";
    ContinuousModel.defaultOption = (0, $f7a89889802a4565$export$68acc510e46fef2)((0, $6c5fdd461a5b821e$export$2e2bcd8739ae039).defaultOption, {
        align: "auto",
        calculable: false,
        hoverLink: true,
        realtime: true,
        handleIcon: "path://M-11.39,9.77h0a3.5,3.5,0,0,1-3.5,3.5h-22a3.5,3.5,0,0,1-3.5-3.5h0a3.5,3.5,0,0,1,3.5-3.5h22A3.5,3.5,0,0,1-11.39,9.77Z",
        handleSize: "120%",
        handleStyle: {
            borderColor: (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.neutral00,
            borderWidth: 1
        },
        indicatorIcon: "circle",
        indicatorSize: "50%",
        indicatorStyle: {
            borderColor: (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.neutral00,
            borderWidth: 2,
            shadowBlur: 2,
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowColor: (0, $8327d823e00b772c$export$2e2bcd8739ae039).color.shadow
        }
    });
    return ContinuousModel;
}((0, $6c5fdd461a5b821e$export$2e2bcd8739ae039));
function $10544d61198eef87$var$getColorStopValues(visualMapModel, valueState, dataExtent) {
    if (dataExtent[0] === dataExtent[1]) return dataExtent.slice();
    // When using colorHue mapping, it is not linear color any more.
    // Moreover, canvas gradient seems not to be accurate linear.
    // FIXME
    // Should be arbitrary value 100? or based on pixel size?
    var count = 200;
    var step = (dataExtent[1] - dataExtent[0]) / count;
    var value = dataExtent[0];
    var stopValues = [];
    for(var i = 0; i <= count && value < dataExtent[1]; i++){
        stopValues.push(value);
        value += step;
    }
    stopValues.push(dataExtent[1]);
    return stopValues;
}
var $10544d61198eef87$export$2e2bcd8739ae039 = $10544d61198eef87$var$ContinuousModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






var $6dbd59d1e3935d9c$var$VisualMapView = /** @class */ function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(VisualMapView, _super);
    function VisualMapView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = VisualMapView.type;
        _this.autoPositionValues = {
            left: 1,
            right: 1,
            top: 1,
            bottom: 1
        };
        return _this;
    }
    VisualMapView.prototype.init = function(ecModel, api) {
        this.ecModel = ecModel;
        this.api = api;
    };
    /**
   * @protected
   */ VisualMapView.prototype.render = function(visualMapModel, ecModel, api, payload // TODO: TYPE
    ) {
        this.visualMapModel = visualMapModel;
        if (visualMapModel.get("show") === false) {
            this.group.removeAll();
            return;
        }
        this.doRender(visualMapModel, ecModel, api, payload);
    };
    /**
   * @protected
   */ VisualMapView.prototype.renderBackground = function(group) {
        var visualMapModel = this.visualMapModel;
        var padding = $78c2ece6dfa6bb7a$export$f3a38102c49f4268(visualMapModel.get("padding") || 0);
        var rect = group.getBoundingRect();
        group.add(new (0, $42ed508a93973e78$export$2e2bcd8739ae039)({
            z2: -1,
            silent: true,
            shape: {
                x: rect.x - padding[3],
                y: rect.y - padding[0],
                width: rect.width + padding[3] + padding[1],
                height: rect.height + padding[0] + padding[2]
            },
            style: {
                fill: visualMapModel.get("backgroundColor"),
                stroke: visualMapModel.get("borderColor"),
                lineWidth: visualMapModel.get("borderWidth")
            }
        }));
    };
    /**
   * @protected
   * @param targetValue can be Infinity or -Infinity
   * @param visualCluster Only can be 'color' 'opacity' 'symbol' 'symbolSize'
   * @param opts
   * @param opts.forceState Specify state, instead of using getValueState method.
   * @param opts.convertOpacityToAlpha For color gradient in controller widget.
   * @return {*} Visual value.
   */ VisualMapView.prototype.getControllerVisual = function(targetValue, visualCluster, opts) {
        opts = opts || {};
        var forceState = opts.forceState;
        var visualMapModel = this.visualMapModel;
        var visualObj = {};
        // Default values.
        if (visualCluster === "color") {
            var defaultColor = visualMapModel.get("contentColor");
            visualObj.color = defaultColor;
        }
        function getter(key) {
            return visualObj[key];
        }
        function setter(key, value) {
            visualObj[key] = value;
        }
        var mappings = visualMapModel.controllerVisuals[forceState || visualMapModel.getValueState(targetValue)];
        var visualTypes = (0, $46853c8218ff2c50$export$2e2bcd8739ae039).prepareVisualTypes(mappings);
        $43e0a445ed6711da$export$79b2f7037acddd43(visualTypes, function(type) {
            var visualMapping = mappings[type];
            if (opts.convertOpacityToAlpha && type === "opacity") {
                type = "colorAlpha";
                visualMapping = mappings.__alphaForOpacity;
            }
            if ((0, $46853c8218ff2c50$export$2e2bcd8739ae039).dependsOn(type, visualCluster)) visualMapping && visualMapping.applyVisual(targetValue, getter, setter);
        });
        return visualObj[visualCluster];
    };
    VisualMapView.prototype.positionGroup = function(group) {
        var model = this.visualMapModel;
        var api = this.api;
        var refContainer = $826bc4094efae72b$export$5aec1e94f566e59f(model, api).refContainer;
        $826bc4094efae72b$export$74054bd96b5eeef1(group, model.getBoxLayoutParams(), refContainer);
    };
    VisualMapView.prototype.doRender = function(visualMapModel, ecModel, api, payload) {};
    VisualMapView.type = "visualMap";
    return VisualMapView;
}((0, $c81700f6bd52c5a7$export$2e2bcd8739ae039));
var $6dbd59d1e3935d9c$export$2e2bcd8739ae039 = $6dbd59d1e3935d9c$var$VisualMapView;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $35fb95cd629f7415$export$2e2bcd8739ae039(delta, handleEnds, extent, handleIndex, minSpan, maxSpan) {
    delta = delta || 0;
    // Consider `7.1e-9 - 7e-9` get `1.0000000000000007e-10`, so use `addSafe`
    // to remove rounding error whenever possible.
    var extentSpan = (0, $b49750109e236fd8$export$d3389a301c3a5706)(extent[1], -extent[0]);
    // Notice maxSpan and minSpan can be null/undefined.
    if (minSpan != null) minSpan = $35fb95cd629f7415$var$restrict(minSpan, [
        0,
        extentSpan
    ]);
    if (maxSpan != null) maxSpan = Math.max(maxSpan, minSpan != null ? minSpan : 0);
    if (handleIndex === "all") {
        var handleSpan = Math.abs((0, $b49750109e236fd8$export$d3389a301c3a5706)(handleEnds[1], -handleEnds[0]));
        handleSpan = $35fb95cd629f7415$var$restrict(handleSpan, [
            0,
            extentSpan
        ]);
        minSpan = maxSpan = $35fb95cd629f7415$var$restrict(handleSpan, [
            minSpan,
            maxSpan
        ]);
        handleIndex = 0;
    }
    handleEnds[0] = $35fb95cd629f7415$var$restrict(handleEnds[0], extent);
    handleEnds[1] = $35fb95cd629f7415$var$restrict(handleEnds[1], extent);
    var originalDistSign = $35fb95cd629f7415$var$getSpanSign(handleEnds, handleIndex);
    handleEnds[handleIndex] += delta;
    // Restrict in extent.
    var extentMinSpan = minSpan || 0;
    var realExtent = extent.slice();
    originalDistSign.sign < 0 ? realExtent[0] = (0, $b49750109e236fd8$export$d3389a301c3a5706)(realExtent[0], extentMinSpan) : realExtent[1] = (0, $b49750109e236fd8$export$d3389a301c3a5706)(realExtent[1], -extentMinSpan);
    handleEnds[handleIndex] = $35fb95cd629f7415$var$restrict(handleEnds[handleIndex], realExtent);
    // Expand span.
    var currDistSign;
    currDistSign = $35fb95cd629f7415$var$getSpanSign(handleEnds, handleIndex);
    if (minSpan != null && (currDistSign.sign !== originalDistSign.sign || currDistSign.span < minSpan)) // If minSpan exists, 'cross' is forbidden.
    handleEnds[1 - handleIndex] = (0, $b49750109e236fd8$export$d3389a301c3a5706)(handleEnds[handleIndex], originalDistSign.sign * minSpan);
    // Shrink span.
    currDistSign = $35fb95cd629f7415$var$getSpanSign(handleEnds, handleIndex);
    if (maxSpan != null && currDistSign.span > maxSpan) handleEnds[1 - handleIndex] = (0, $b49750109e236fd8$export$d3389a301c3a5706)(handleEnds[handleIndex], currDistSign.sign * maxSpan);
    return handleEnds;
}
function $35fb95cd629f7415$var$getSpanSign(handleEnds, handleIndex) {
    var dist = handleEnds[handleIndex] - handleEnds[1 - handleIndex];
    // If `handleEnds[0] === handleEnds[1]`, always believe that handleEnd[0]
    // is at left of handleEnds[1] for non-cross case.
    return {
        span: Math.abs(dist),
        sign: dist > 0 ? -1 : dist < 0 ? 1 : handleIndex ? -1 : 1
    };
}
function $35fb95cd629f7415$var$restrict(value, extend) {
    return Math.min(extend[1] != null ? extend[1] : Infinity, Math.max(extend[0] != null ? extend[0] : -Infinity, value));
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $86290a88c460962b$var$paramsSet = [
    [
        "left",
        "right",
        "width"
    ],
    [
        "top",
        "bottom",
        "height"
    ]
];
function $86290a88c460962b$export$dca53c4702e35c6(visualMapModel, api, itemSize) {
    var modelOption = visualMapModel.option;
    var itemAlign = modelOption.align;
    if (itemAlign != null && itemAlign !== "auto") return itemAlign;
    // Auto decision align.
    var ecSize = {
        width: api.getWidth(),
        height: api.getHeight()
    };
    var realIndex = modelOption.orient === "horizontal" ? 1 : 0;
    var reals = $86290a88c460962b$var$paramsSet[realIndex];
    var fakeValue = [
        0,
        null,
        10
    ];
    var layoutInput = {};
    for(var i = 0; i < 3; i++){
        layoutInput[$86290a88c460962b$var$paramsSet[1 - realIndex][i]] = fakeValue[i];
        layoutInput[reals[i]] = i === 2 ? itemSize[0] : modelOption[reals[i]];
    }
    var rParam = [
        [
            "x",
            "width",
            3
        ],
        [
            "y",
            "height",
            0
        ]
    ][realIndex];
    var rect = (0, $826bc4094efae72b$export$4517a5ca639a7293)(layoutInput, ecSize, modelOption.padding);
    return reals[(rect.margin[rParam[2]] || 0) + rect[rParam[0]] + rect[rParam[1]] * 0.5 < ecSize[rParam[1]] * 0.5 ? 0 : 1];
}
function $86290a88c460962b$export$5381a9dc5427ba18(batch, visualMapModel) {
    $43e0a445ed6711da$export$79b2f7037acddd43(batch || [], function(batchItem) {
        if (batchItem.dataIndex != null) {
            batchItem.dataIndexInside = batchItem.dataIndex;
            batchItem.dataIndex = null;
        }
        batchItem.highlightKey = "visualMap" + (visualMapModel ? visualMapModel.componentIndex : "");
    });
    return batch;
}










var $0b2db4a7d3fb8a9a$var$linearMap = $b49750109e236fd8$export$d3f68fbaa670562;
var $0b2db4a7d3fb8a9a$var$each = $43e0a445ed6711da$export$79b2f7037acddd43;
var $0b2db4a7d3fb8a9a$var$mathMin = Math.min;
var $0b2db4a7d3fb8a9a$var$mathMax = Math.max;
// Arbitrary value
var $0b2db4a7d3fb8a9a$var$HOVER_LINK_SIZE = 12;
var $0b2db4a7d3fb8a9a$var$HOVER_LINK_OUT = 6;
// Notice:
// Any "interval" should be by the order of [low, high].
// "handle0" (handleIndex === 0) maps to
// low data value: this._dataInterval[0] and has low coord.
// "handle1" (handleIndex === 1) maps to
// high data value: this._dataInterval[1] and has high coord.
// The logic of transform is implemented in this._createBarGroup.
var $0b2db4a7d3fb8a9a$var$ContinuousView = /** @class */ function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(ContinuousView, _super);
    function ContinuousView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ContinuousView.type;
        _this._shapes = {};
        _this._dataInterval = [];
        _this._handleEnds = [];
        _this._hoverLinkDataIndices = [];
        return _this;
    }
    ContinuousView.prototype.init = function(ecModel, api) {
        _super.prototype.init.call(this, ecModel, api);
        this._hoverLinkFromSeriesMouseOver = $43e0a445ed6711da$export$2385a24977818dd0(this._hoverLinkFromSeriesMouseOver, this);
        this._hideIndicator = $43e0a445ed6711da$export$2385a24977818dd0(this._hideIndicator, this);
    };
    ContinuousView.prototype.doRender = function(visualMapModel, ecModel, api, payload) {
        if (!payload || payload.type !== "selectDataRange" || payload.from !== this.uid) this._buildView();
    };
    ContinuousView.prototype._buildView = function() {
        this.group.removeAll();
        var visualMapModel = this.visualMapModel;
        var thisGroup = this.group;
        this._orient = visualMapModel.get("orient");
        this._useHandle = visualMapModel.get("calculable");
        this._resetInterval();
        this._renderBar(thisGroup);
        var dataRangeText = visualMapModel.get("text");
        this._renderEndsText(thisGroup, dataRangeText, 0);
        this._renderEndsText(thisGroup, dataRangeText, 1);
        // Do this for background size calculation.
        this._updateView(true);
        // After updating view, inner shapes is built completely,
        // and then background can be rendered.
        this.renderBackground(thisGroup);
        // Real update view
        this._updateView();
        this._enableHoverLinkToSeries();
        this._enableHoverLinkFromSeries();
        this.positionGroup(thisGroup);
    };
    ContinuousView.prototype._renderEndsText = function(group, dataRangeText, endsIndex) {
        if (!dataRangeText) return;
        // Compatible with ec2, text[0] map to high value, text[1] map low value.
        var text = dataRangeText[1 - endsIndex];
        text = text != null ? text + "" : "";
        var visualMapModel = this.visualMapModel;
        var textGap = visualMapModel.get("textGap");
        var itemSize = visualMapModel.itemSize;
        var barGroup = this._shapes.mainGroup;
        var position = this._applyTransform([
            itemSize[0] / 2,
            endsIndex === 0 ? -textGap : itemSize[1] + textGap
        ], barGroup);
        var align = this._applyTransform(endsIndex === 0 ? "bottom" : "top", barGroup);
        var orient = this._orient;
        var textStyleModel = this.visualMapModel.textStyleModel;
        this.group.add(new $7db7960d25b39b7c$export$2e2bcd8739ae039({
            style: (0, $6556fe1ed9fb479d$export$f8998c3d0a13de59)(textStyleModel, {
                x: position[0],
                y: position[1],
                verticalAlign: textStyleModel.get("verticalAlign") || (orient === "horizontal" ? "middle" : align),
                align: textStyleModel.get("align") || (orient === "horizontal" ? align : "center"),
                text: text
            })
        }));
    };
    ContinuousView.prototype._renderBar = function(targetGroup) {
        var visualMapModel = this.visualMapModel;
        var shapes = this._shapes;
        var itemSize = visualMapModel.itemSize;
        var orient = this._orient;
        var useHandle = this._useHandle;
        var itemAlign = $86290a88c460962b$export$dca53c4702e35c6(visualMapModel, this.api, itemSize);
        var mainGroup = shapes.mainGroup = this._createBarGroup(itemAlign);
        var gradientBarGroup = new $a8978f7a0e842e3d$export$2e2bcd8739ae039();
        mainGroup.add(gradientBarGroup);
        // Bar
        gradientBarGroup.add(shapes.outOfRange = $0b2db4a7d3fb8a9a$var$createPolygon());
        gradientBarGroup.add(shapes.inRange = $0b2db4a7d3fb8a9a$var$createPolygon(null, useHandle ? $0b2db4a7d3fb8a9a$var$getCursor(this._orient) : null, $43e0a445ed6711da$export$2385a24977818dd0(this._dragHandle, this, "all", false), $43e0a445ed6711da$export$2385a24977818dd0(this._dragHandle, this, "all", true)));
        // A border radius clip.
        gradientBarGroup.setClipPath(new $42ed508a93973e78$export$2e2bcd8739ae039({
            shape: {
                x: 0,
                y: 0,
                width: itemSize[0],
                height: itemSize[1],
                r: 3
            }
        }));
        var textRect = visualMapModel.textStyleModel.getTextRect("\u56FD");
        var textSize = $0b2db4a7d3fb8a9a$var$mathMax(textRect.width, textRect.height);
        // Handle
        if (useHandle) {
            shapes.handleThumbs = [];
            shapes.handleLabels = [];
            shapes.handleLabelPoints = [];
            this._createHandle(visualMapModel, mainGroup, 0, itemSize, textSize, orient);
            this._createHandle(visualMapModel, mainGroup, 1, itemSize, textSize, orient);
        }
        this._createIndicator(visualMapModel, mainGroup, itemSize, textSize, orient);
        targetGroup.add(mainGroup);
    };
    ContinuousView.prototype._createHandle = function(visualMapModel, mainGroup, handleIndex, itemSize, textSize, orient) {
        var onDrift = $43e0a445ed6711da$export$2385a24977818dd0(this._dragHandle, this, handleIndex, false);
        var onDragEnd = $43e0a445ed6711da$export$2385a24977818dd0(this._dragHandle, this, handleIndex, true);
        var handleSize = (0, $67e15a06bdb46d49$export$e8514cb5a5e2b40f)(visualMapModel.get("handleSize"), itemSize[0]);
        var handleThumb = (0, $4ff41a845d4679a6$export$af050e04da3a02e8)(visualMapModel.get("handleIcon"), -handleSize / 2, -handleSize / 2, handleSize, handleSize, null, true);
        var cursor = $0b2db4a7d3fb8a9a$var$getCursor(this._orient);
        handleThumb.attr({
            cursor: cursor,
            draggable: true,
            drift: onDrift,
            ondragend: onDragEnd,
            onmousemove: function(e) {
                $e48a660b5a6fd3cb$export$fa6813432f753b0d(e.event);
            }
        });
        handleThumb.x = itemSize[0] / 2;
        handleThumb.useStyle(visualMapModel.getModel("handleStyle").getItemStyle());
        handleThumb.setStyle({
            strokeNoScale: true,
            strokeFirst: true
        });
        handleThumb.style.lineWidth *= 2;
        handleThumb.ensureState("emphasis").style = visualMapModel.getModel([
            "emphasis",
            "handleStyle"
        ]).getItemStyle();
        (0, $fffc76734a157b4c$export$9ba15aea1e048d48)(handleThumb, true);
        mainGroup.add(handleThumb);
        // Text is always horizontal layout but should not be effected by
        // transform (orient/inverse). So label is built separately but not
        // use zrender/graphic/helper/RectText, and is located based on view
        // group (according to handleLabelPoint) but not barGroup.
        var textStyleModel = this.visualMapModel.textStyleModel;
        var handleLabel = new $7db7960d25b39b7c$export$2e2bcd8739ae039({
            cursor: cursor,
            draggable: true,
            drift: onDrift,
            onmousemove: function(e) {
                // For mobile device, prevent screen slider on the button.
                $e48a660b5a6fd3cb$export$fa6813432f753b0d(e.event);
            },
            ondragend: onDragEnd,
            style: (0, $6556fe1ed9fb479d$export$f8998c3d0a13de59)(textStyleModel, {
                x: 0,
                y: 0,
                text: ""
            })
        });
        handleLabel.ensureState("blur").style = {
            opacity: 0.1
        };
        handleLabel.stateTransition = {
            duration: 200
        };
        this.group.add(handleLabel);
        var handleLabelPoint = [
            handleSize,
            0
        ];
        var shapes = this._shapes;
        shapes.handleThumbs[handleIndex] = handleThumb;
        shapes.handleLabelPoints[handleIndex] = handleLabelPoint;
        shapes.handleLabels[handleIndex] = handleLabel;
    };
    ContinuousView.prototype._createIndicator = function(visualMapModel, mainGroup, itemSize, textSize, orient) {
        var scale = (0, $67e15a06bdb46d49$export$e8514cb5a5e2b40f)(visualMapModel.get("indicatorSize"), itemSize[0]);
        var indicator = (0, $4ff41a845d4679a6$export$af050e04da3a02e8)(visualMapModel.get("indicatorIcon"), -scale / 2, -scale / 2, scale, scale, null, true);
        indicator.attr({
            cursor: "move",
            invisible: true,
            silent: true,
            x: itemSize[0] / 2
        });
        var indicatorStyle = visualMapModel.getModel("indicatorStyle").getItemStyle();
        if (indicator instanceof (0, $d3b0315ae8e8e298$export$2e2bcd8739ae039)) {
            var pathStyle = indicator.style;
            indicator.useStyle($43e0a445ed6711da$export$8b58be045bf06082({
                // TODO other properties like x, y ?
                image: pathStyle.image,
                x: pathStyle.x,
                y: pathStyle.y,
                width: pathStyle.width,
                height: pathStyle.height
            }, indicatorStyle));
        } else indicator.useStyle(indicatorStyle);
        mainGroup.add(indicator);
        var textStyleModel = this.visualMapModel.textStyleModel;
        var indicatorLabel = new $7db7960d25b39b7c$export$2e2bcd8739ae039({
            silent: true,
            invisible: true,
            style: (0, $6556fe1ed9fb479d$export$f8998c3d0a13de59)(textStyleModel, {
                x: 0,
                y: 0,
                text: ""
            })
        });
        this.group.add(indicatorLabel);
        var indicatorLabelPoint = [
            (orient === "horizontal" ? textSize / 2 : $0b2db4a7d3fb8a9a$var$HOVER_LINK_OUT) + itemSize[0] / 2,
            0
        ];
        var shapes = this._shapes;
        shapes.indicator = indicator;
        shapes.indicatorLabel = indicatorLabel;
        shapes.indicatorLabelPoint = indicatorLabelPoint;
        this._firstShowIndicator = true;
    };
    ContinuousView.prototype._dragHandle = function(handleIndex, isEnd, // dx is event from ondragend if isEnd is true. It's not used
    dx, dy) {
        if (!this._useHandle) return;
        this._dragging = !isEnd;
        if (!isEnd) {
            // Transform dx, dy to bar coordination.
            var vertex = this._applyTransform([
                dx,
                dy
            ], this._shapes.mainGroup, true);
            this._updateInterval(handleIndex, vertex[1]);
            this._hideIndicator();
            // Considering realtime, update view should be executed
            // before dispatch action.
            this._updateView();
        }
        // dragEnd do not dispatch action when realtime.
        if (isEnd === !this.visualMapModel.get("realtime")) // jshint ignore:line
        this.api.dispatchAction({
            type: "selectDataRange",
            from: this.uid,
            visualMapId: this.visualMapModel.id,
            selected: this._dataInterval.slice()
        });
        if (isEnd) !this._hovering && this._clearHoverLinkToSeries();
        else if ($0b2db4a7d3fb8a9a$var$useHoverLinkOnHandle(this.visualMapModel)) this._doHoverLinkToSeries(this._handleEnds[handleIndex], false);
    };
    ContinuousView.prototype._resetInterval = function() {
        var visualMapModel = this.visualMapModel;
        var dataInterval = this._dataInterval = visualMapModel.getSelected();
        var dataExtent = visualMapModel.getExtent();
        var sizeExtent = [
            0,
            visualMapModel.itemSize[1]
        ];
        this._handleEnds = [
            $0b2db4a7d3fb8a9a$var$linearMap(dataInterval[0], dataExtent, sizeExtent, true),
            $0b2db4a7d3fb8a9a$var$linearMap(dataInterval[1], dataExtent, sizeExtent, true)
        ];
    };
    /**
   * @private
   * @param {(number|string)} handleIndex 0 or 1 or 'all'
   * @param {number} dx
   * @param {number} dy
   */ ContinuousView.prototype._updateInterval = function(handleIndex, delta) {
        delta = delta || 0;
        var visualMapModel = this.visualMapModel;
        var handleEnds = this._handleEnds;
        var sizeExtent = [
            0,
            visualMapModel.itemSize[1]
        ];
        (0, $35fb95cd629f7415$export$2e2bcd8739ae039)(delta, handleEnds, sizeExtent, handleIndex, // cross is forbidden
        0);
        var dataExtent = visualMapModel.getExtent();
        // Update data interval.
        this._dataInterval = [
            $0b2db4a7d3fb8a9a$var$linearMap(handleEnds[0], sizeExtent, dataExtent, true),
            $0b2db4a7d3fb8a9a$var$linearMap(handleEnds[1], sizeExtent, dataExtent, true)
        ];
    };
    ContinuousView.prototype._updateView = function(forSketch) {
        var visualMapModel = this.visualMapModel;
        var dataExtent = visualMapModel.getExtent();
        var shapes = this._shapes;
        var outOfRangeHandleEnds = [
            0,
            visualMapModel.itemSize[1]
        ];
        var inRangeHandleEnds = forSketch ? outOfRangeHandleEnds : this._handleEnds;
        var visualInRange = this._createBarVisual(this._dataInterval, dataExtent, inRangeHandleEnds, "inRange");
        var visualOutOfRange = this._createBarVisual(dataExtent, dataExtent, outOfRangeHandleEnds, "outOfRange");
        shapes.inRange.setStyle({
            fill: visualInRange.barColor
        }).setShape("points", visualInRange.barPoints);
        shapes.outOfRange.setStyle({
            fill: visualOutOfRange.barColor
        }).setShape("points", visualOutOfRange.barPoints);
        this._updateHandle(inRangeHandleEnds, visualInRange);
    };
    ContinuousView.prototype._createBarVisual = function(dataInterval, dataExtent, handleEnds, forceState) {
        var opts = {
            forceState: forceState,
            convertOpacityToAlpha: true
        };
        var colorStops = this._makeColorGradient(dataInterval, opts);
        var symbolSizes = [
            this.getControllerVisual(dataInterval[0], "symbolSize", opts),
            this.getControllerVisual(dataInterval[1], "symbolSize", opts)
        ];
        var barPoints = this._createBarPoints(handleEnds, symbolSizes);
        return {
            barColor: new (0, $9cb489c6746d60b7$export$2e2bcd8739ae039)(0, 0, 0, 1, colorStops),
            barPoints: barPoints,
            handlesColor: [
                colorStops[0].color,
                colorStops[colorStops.length - 1].color
            ]
        };
    };
    ContinuousView.prototype._makeColorGradient = function(dataInterval, opts) {
        // Considering colorHue, which is not linear, so we have to sample
        // to calculate gradient color stops, but not only calculate head
        // and tail.
        var sampleNumber = 100; // Arbitrary value.
        var colorStops = [];
        var step = (dataInterval[1] - dataInterval[0]) / sampleNumber;
        colorStops.push({
            color: this.getControllerVisual(dataInterval[0], "color", opts),
            offset: 0
        });
        for(var i = 1; i < sampleNumber; i++){
            var currValue = dataInterval[0] + step * i;
            if (currValue > dataInterval[1]) break;
            colorStops.push({
                color: this.getControllerVisual(currValue, "color", opts),
                offset: i / sampleNumber
            });
        }
        colorStops.push({
            color: this.getControllerVisual(dataInterval[1], "color", opts),
            offset: 1
        });
        return colorStops;
    };
    ContinuousView.prototype._createBarPoints = function(handleEnds, symbolSizes) {
        var itemSize = this.visualMapModel.itemSize;
        return [
            [
                itemSize[0] - symbolSizes[0],
                handleEnds[0]
            ],
            [
                itemSize[0],
                handleEnds[0]
            ],
            [
                itemSize[0],
                handleEnds[1]
            ],
            [
                itemSize[0] - symbolSizes[1],
                handleEnds[1]
            ]
        ];
    };
    ContinuousView.prototype._createBarGroup = function(itemAlign) {
        var orient = this._orient;
        var inverse = this.visualMapModel.get("inverse");
        return new $a8978f7a0e842e3d$export$2e2bcd8739ae039(orient === "horizontal" && !inverse ? {
            scaleX: itemAlign === "bottom" ? 1 : -1,
            rotation: Math.PI / 2
        } : orient === "horizontal" && inverse ? {
            scaleX: itemAlign === "bottom" ? -1 : 1,
            rotation: -Math.PI / 2
        } : orient === "vertical" && !inverse ? {
            scaleX: itemAlign === "left" ? 1 : -1,
            scaleY: -1
        } : {
            scaleX: itemAlign === "left" ? 1 : -1
        });
    };
    ContinuousView.prototype._updateHandle = function(handleEnds, visualInRange) {
        if (!this._useHandle) return;
        var shapes = this._shapes;
        var visualMapModel = this.visualMapModel;
        var handleThumbs = shapes.handleThumbs;
        var handleLabels = shapes.handleLabels;
        var itemSize = visualMapModel.itemSize;
        var dataExtent = visualMapModel.getExtent();
        var align = this._applyTransform("left", shapes.mainGroup);
        $0b2db4a7d3fb8a9a$var$each([
            0,
            1
        ], function(handleIndex) {
            var handleThumb = handleThumbs[handleIndex];
            handleThumb.setStyle("fill", visualInRange.handlesColor[handleIndex]);
            handleThumb.y = handleEnds[handleIndex];
            var val = $0b2db4a7d3fb8a9a$var$linearMap(handleEnds[handleIndex], [
                0,
                itemSize[1]
            ], dataExtent, true);
            var symbolSize = this.getControllerVisual(val, "symbolSize");
            handleThumb.scaleX = handleThumb.scaleY = symbolSize / itemSize[0];
            handleThumb.x = itemSize[0] - symbolSize / 2;
            // Update handle label position.
            var textPoint = $6552edac5ca572b1$export$9f9dcb98c894b623(shapes.handleLabelPoints[handleIndex], $6552edac5ca572b1$export$fce0c6cfca85ed96(handleThumb, this.group));
            if (this._orient === "horizontal") {
                // If visualMap controls symbol size, an additional offset needs to be added to labels to avoid collision at minimum size.
                // Offset reaches value of 0 at "maximum" position, so maximum position is not altered at all.
                var minimumOffset = align === "left" || align === "top" ? (itemSize[0] - symbolSize) / 2 : (itemSize[0] - symbolSize) / -2;
                textPoint[1] += minimumOffset;
            }
            handleLabels[handleIndex].setStyle({
                x: textPoint[0],
                y: textPoint[1],
                text: visualMapModel.formatValueText(this._dataInterval[handleIndex]),
                verticalAlign: "middle",
                align: this._orient === "vertical" ? this._applyTransform("left", shapes.mainGroup) : "center"
            });
        }, this);
    };
    ContinuousView.prototype._showIndicator = function(cursorValue, textValue, rangeSymbol, halfHoverLinkSize) {
        var visualMapModel = this.visualMapModel;
        var dataExtent = visualMapModel.getExtent();
        var itemSize = visualMapModel.itemSize;
        var sizeExtent = [
            0,
            itemSize[1]
        ];
        var shapes = this._shapes;
        var indicator = shapes.indicator;
        if (!indicator) return;
        indicator.attr("invisible", false);
        var opts = {
            convertOpacityToAlpha: true
        };
        var color = this.getControllerVisual(cursorValue, "color", opts);
        var symbolSize = this.getControllerVisual(cursorValue, "symbolSize");
        var y = $0b2db4a7d3fb8a9a$var$linearMap(cursorValue, dataExtent, sizeExtent, true);
        var x = itemSize[0] - symbolSize / 2;
        var oldIndicatorPos = {
            x: indicator.x,
            y: indicator.y
        };
        // Update handle label position.
        indicator.y = y;
        indicator.x = x;
        var textPoint = $6552edac5ca572b1$export$9f9dcb98c894b623(shapes.indicatorLabelPoint, $6552edac5ca572b1$export$fce0c6cfca85ed96(indicator, this.group));
        var indicatorLabel = shapes.indicatorLabel;
        indicatorLabel.attr("invisible", false);
        var align = this._applyTransform("left", shapes.mainGroup);
        var orient = this._orient;
        var isHorizontal = orient === "horizontal";
        indicatorLabel.setStyle({
            text: (rangeSymbol ? rangeSymbol : "") + visualMapModel.formatValueText(textValue),
            verticalAlign: isHorizontal ? align : "middle",
            align: isHorizontal ? "center" : align
        });
        var indicatorNewProps = {
            x: x,
            y: y,
            style: {
                fill: color
            }
        };
        var labelNewProps = {
            style: {
                x: textPoint[0],
                y: textPoint[1]
            }
        };
        if (visualMapModel.ecModel.isAnimationEnabled() && !this._firstShowIndicator) {
            var animationCfg = {
                duration: 100,
                easing: "cubicInOut",
                additive: true
            };
            indicator.x = oldIndicatorPos.x;
            indicator.y = oldIndicatorPos.y;
            indicator.animateTo(indicatorNewProps, animationCfg);
            indicatorLabel.animateTo(labelNewProps, animationCfg);
        } else {
            indicator.attr(indicatorNewProps);
            indicatorLabel.attr(labelNewProps);
        }
        this._firstShowIndicator = false;
        var handleLabels = this._shapes.handleLabels;
        if (handleLabels) for(var i = 0; i < handleLabels.length; i++)// Fade out handle labels.
        // NOTE: Must use api enter/leave on emphasis/blur/select state. Or the global states manager will change it.
        this.api.enterBlur(handleLabels[i]);
    };
    ContinuousView.prototype._enableHoverLinkToSeries = function() {
        var self = this;
        this._shapes.mainGroup.on("mousemove", function(e) {
            self._hovering = true;
            if (!self._dragging) {
                var itemSize = self.visualMapModel.itemSize;
                var pos = self._applyTransform([
                    e.offsetX,
                    e.offsetY
                ], self._shapes.mainGroup, true, true);
                // For hover link show when hover handle, which might be
                // below or upper than sizeExtent.
                pos[1] = $0b2db4a7d3fb8a9a$var$mathMin($0b2db4a7d3fb8a9a$var$mathMax(0, pos[1]), itemSize[1]);
                self._doHoverLinkToSeries(pos[1], 0 <= pos[0] && pos[0] <= itemSize[0]);
            }
        }).on("mouseout", function() {
            // When mouse is out of handle, hoverLink still need
            // to be displayed when realtime is set as false.
            self._hovering = false;
            !self._dragging && self._clearHoverLinkToSeries();
        });
    };
    ContinuousView.prototype._enableHoverLinkFromSeries = function() {
        var zr = this.api.getZr();
        if (this.visualMapModel.option.hoverLink) {
            zr.on("mouseover", this._hoverLinkFromSeriesMouseOver, this);
            zr.on("mouseout", this._hideIndicator, this);
        } else this._clearHoverLinkFromSeries();
    };
    ContinuousView.prototype._doHoverLinkToSeries = function(cursorPos, hoverOnBar) {
        var visualMapModel = this.visualMapModel;
        var itemSize = visualMapModel.itemSize;
        if (!visualMapModel.option.hoverLink) return;
        var sizeExtent = [
            0,
            itemSize[1]
        ];
        var dataExtent = visualMapModel.getExtent();
        // For hover link show when hover handle, which might be below or upper than sizeExtent.
        cursorPos = $0b2db4a7d3fb8a9a$var$mathMin($0b2db4a7d3fb8a9a$var$mathMax(sizeExtent[0], cursorPos), sizeExtent[1]);
        var halfHoverLinkSize = $0b2db4a7d3fb8a9a$var$getHalfHoverLinkSize(visualMapModel, dataExtent, sizeExtent);
        var hoverRange = [
            cursorPos - halfHoverLinkSize,
            cursorPos + halfHoverLinkSize
        ];
        var cursorValue = $0b2db4a7d3fb8a9a$var$linearMap(cursorPos, sizeExtent, dataExtent, true);
        var valueRange = [
            $0b2db4a7d3fb8a9a$var$linearMap(hoverRange[0], sizeExtent, dataExtent, true),
            $0b2db4a7d3fb8a9a$var$linearMap(hoverRange[1], sizeExtent, dataExtent, true)
        ];
        // Consider data range is out of visualMap range, see test/visualMap-continuous.html,
        // where china and india has very large population.
        hoverRange[0] < sizeExtent[0] && (valueRange[0] = -Infinity);
        hoverRange[1] > sizeExtent[1] && (valueRange[1] = Infinity);
        // Do not show indicator when mouse is over handle,
        // otherwise labels overlap, especially when dragging.
        if (hoverOnBar) {
            if (valueRange[0] === -Infinity) this._showIndicator(cursorValue, valueRange[1], "< ", halfHoverLinkSize);
            else if (valueRange[1] === Infinity) this._showIndicator(cursorValue, valueRange[0], "> ", halfHoverLinkSize);
            else this._showIndicator(cursorValue, cursorValue, "\u2248 ", halfHoverLinkSize);
        }
        // When realtime is set as false, handles, which are in barGroup,
        // also trigger hoverLink, which help user to realize where they
        // focus on when dragging. (see test/heatmap-large.html)
        // When realtime is set as true, highlight will not show when hover
        // handle, because the label on handle, which displays a exact value
        // but not range, might mislead users.
        var oldBatch = this._hoverLinkDataIndices;
        var newBatch = [];
        if (hoverOnBar || $0b2db4a7d3fb8a9a$var$useHoverLinkOnHandle(visualMapModel)) newBatch = this._hoverLinkDataIndices = visualMapModel.findTargetDataIndices(valueRange);
        var resultBatches = $87f4a59ac66e0ee6$export$6d12cabb0c9bf8e3(oldBatch, newBatch);
        this._dispatchHighDown("downplay", $86290a88c460962b$export$5381a9dc5427ba18(resultBatches[0], visualMapModel));
        this._dispatchHighDown("highlight", $86290a88c460962b$export$5381a9dc5427ba18(resultBatches[1], visualMapModel));
    };
    ContinuousView.prototype._hoverLinkFromSeriesMouseOver = function(e) {
        var ecData;
        (0, $10e23f9ea92ef04e$export$8a4fca9e04eb4df6)(e.target, function(target) {
            var currECData = (0, $7e4afcfca8f5121f$export$b1c39b2bacd1ddc2)(target);
            if (currECData.dataIndex != null) {
                ecData = currECData;
                return true;
            }
        }, true);
        if (!ecData) return;
        var dataModel = this.ecModel.getSeriesByIndex(ecData.seriesIndex);
        var visualMapModel = this.visualMapModel;
        if (!visualMapModel.isTargetSeries(dataModel)) return;
        var data = dataModel.getData(ecData.dataType);
        var value = data.getStore().get(visualMapModel.getDataDimensionIndex(data), ecData.dataIndex);
        if (!isNaN(value)) this._showIndicator(value, value);
    };
    ContinuousView.prototype._hideIndicator = function() {
        var shapes = this._shapes;
        shapes.indicator && shapes.indicator.attr("invisible", true);
        shapes.indicatorLabel && shapes.indicatorLabel.attr("invisible", true);
        var handleLabels = this._shapes.handleLabels;
        if (handleLabels) for(var i = 0; i < handleLabels.length; i++)// Fade out handle labels.
        // NOTE: Must use api enter/leave on emphasis/blur/select state. Or the global states manager will change it.
        this.api.leaveBlur(handleLabels[i]);
    };
    ContinuousView.prototype._clearHoverLinkToSeries = function() {
        this._hideIndicator();
        var indices = this._hoverLinkDataIndices;
        this._dispatchHighDown("downplay", $86290a88c460962b$export$5381a9dc5427ba18(indices, this.visualMapModel));
        indices.length = 0;
    };
    ContinuousView.prototype._clearHoverLinkFromSeries = function() {
        this._hideIndicator();
        var zr = this.api.getZr();
        zr.off("mouseover", this._hoverLinkFromSeriesMouseOver);
        zr.off("mouseout", this._hideIndicator);
    };
    ContinuousView.prototype._applyTransform = function(vertex, element, inverse, global) {
        var transform = $6552edac5ca572b1$export$fce0c6cfca85ed96(element, global ? null : this.group);
        return $43e0a445ed6711da$export$43bee75e5e14138e(vertex) ? $6552edac5ca572b1$export$9f9dcb98c894b623(vertex, transform, inverse) : $6552edac5ca572b1$export$fff94e9792354cfa(vertex, transform, inverse);
    };
    // TODO: TYPE more specified payload types.
    ContinuousView.prototype._dispatchHighDown = function(type, batch) {
        batch && batch.length && this.api.dispatchAction({
            type: type,
            batch: batch
        });
    };
    /**
   * @override
   */ ContinuousView.prototype.dispose = function() {
        this._clearHoverLinkFromSeries();
        this._clearHoverLinkToSeries();
    };
    ContinuousView.type = "visualMap.continuous";
    return ContinuousView;
}((0, $6dbd59d1e3935d9c$export$2e2bcd8739ae039));
function $0b2db4a7d3fb8a9a$var$createPolygon(points, cursor, onDrift, onDragEnd) {
    return new $dbc82dce785be05b$export$2e2bcd8739ae039({
        shape: {
            points: points
        },
        draggable: !!onDrift,
        cursor: cursor,
        drift: onDrift,
        onmousemove: function(e) {
            // For mobile device, prevent screen slider on the button.
            $e48a660b5a6fd3cb$export$fa6813432f753b0d(e.event);
        },
        ondragend: onDragEnd
    });
}
function $0b2db4a7d3fb8a9a$var$getHalfHoverLinkSize(visualMapModel, dataExtent, sizeExtent) {
    var halfHoverLinkSize = $0b2db4a7d3fb8a9a$var$HOVER_LINK_SIZE / 2;
    var hoverLinkDataSize = visualMapModel.get("hoverLinkDataSize");
    if (hoverLinkDataSize) halfHoverLinkSize = $0b2db4a7d3fb8a9a$var$linearMap(hoverLinkDataSize, dataExtent, sizeExtent, true) / 2;
    return halfHoverLinkSize;
}
function $0b2db4a7d3fb8a9a$var$useHoverLinkOnHandle(visualMapModel) {
    var hoverLinkOnHandle = visualMapModel.get("hoverLinkOnHandle");
    return !!(hoverLinkOnHandle == null ? visualMapModel.get("realtime") : hoverLinkOnHandle);
}
function $0b2db4a7d3fb8a9a$var$getCursor(orient) {
    return orient === "vertical" ? "ns-resize" : "ew-resize";
}
var $0b2db4a7d3fb8a9a$export$2e2bcd8739ae039 = $0b2db4a7d3fb8a9a$var$ContinuousView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $94e541c01264dd6d$export$c5097295b52f5ecd = {
    type: "selectDataRange",
    event: "dataRangeSelected",
    // FIXME use updateView appears wrong
    update: "update"
};
var $94e541c01264dd6d$export$8655c04a6fcbaa76 = function(payload, ecModel) {
    ecModel.eachComponent({
        mainType: "visualMap",
        query: payload
    }, function(model) {
        model.setSelected(payload.selected);
    });
};


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $bd35b466871db5ff$export$5933e7c74ab358d1 = [
    {
        createOnAllSeries: true,
        reset: function(seriesModel, ecModel) {
            var resetDefines = [];
            ecModel.eachComponent("visualMap", function(visualMapModel) {
                var pipelineContext = seriesModel.pipelineContext;
                if (!visualMapModel.isTargetSeries(seriesModel) || pipelineContext && pipelineContext.large) return;
                resetDefines.push($02cc52f53cf557df$export$fc0ef8703cccf128(visualMapModel.stateList, visualMapModel.targetVisuals, $43e0a445ed6711da$export$2385a24977818dd0(visualMapModel.getValueState, visualMapModel), visualMapModel.getDataDimensionIndex(seriesModel.getData())));
            });
            return resetDefines;
        }
    },
    // Only support color.
    {
        createOnAllSeries: true,
        reset: function(seriesModel, ecModel) {
            var data = seriesModel.getData();
            var visualMetaList = [];
            ecModel.eachComponent("visualMap", function(visualMapModel) {
                if (visualMapModel.isTargetSeries(seriesModel)) {
                    var visualMeta = visualMapModel.getVisualMeta($43e0a445ed6711da$export$2385a24977818dd0($bd35b466871db5ff$var$getColorVisual, null, seriesModel, visualMapModel)) || {
                        stops: [],
                        outerColors: []
                    };
                    var dimIdx = visualMapModel.getDataDimensionIndex(data);
                    if (dimIdx >= 0) {
                        // visualMeta.dimension should be dimension index, but not concrete dimension.
                        visualMeta.dimension = dimIdx;
                        visualMetaList.push(visualMeta);
                    }
                }
            });
            // console.log(JSON.stringify(visualMetaList.map(a => a.stops)));
            seriesModel.getData().setVisual("visualMeta", visualMetaList);
        }
    }
];
// FIXME
// performance and export for heatmap?
// value can be Infinity or -Infinity
function $bd35b466871db5ff$var$getColorVisual(seriesModel, visualMapModel, value, valueState) {
    var mappings = visualMapModel.targetVisuals[valueState];
    var visualTypes = (0, $46853c8218ff2c50$export$2e2bcd8739ae039).prepareVisualTypes(mappings);
    var resultVisual = {
        color: (0, $76af5bb296a0e67b$export$d76e333a86ea1a2)(seriesModel.getData(), "color") // default color.
    };
    for(var i = 0, len = visualTypes.length; i < len; i++){
        var type = visualTypes[i];
        var mapping = mappings[type === "opacity" ? "__alphaForOpacity" : type];
        mapping && mapping.applyVisual(value, getVisual, setVisual);
    }
    return resultVisual.color;
    function getVisual(key) {
        return resultVisual[key];
    }
    function setVisual(key, value) {
        resultVisual[key] = value;
    }
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // @ts-nocheck

var $d3d24261944405e2$var$each = $43e0a445ed6711da$export$79b2f7037acddd43;
function $d3d24261944405e2$export$2e2bcd8739ae039(option) {
    var visualMap = option && option.visualMap;
    if (!$43e0a445ed6711da$export$43bee75e5e14138e(visualMap)) visualMap = visualMap ? [
        visualMap
    ] : [];
    $d3d24261944405e2$var$each(visualMap, function(opt) {
        if (!opt) return;
        // rename splitList to pieces
        if ($d3d24261944405e2$var$has(opt, "splitList") && !$d3d24261944405e2$var$has(opt, "pieces")) {
            opt.pieces = opt.splitList;
            delete opt.splitList;
        }
        var pieces = opt.pieces;
        if (pieces && $43e0a445ed6711da$export$43bee75e5e14138e(pieces)) $d3d24261944405e2$var$each(pieces, function(piece) {
            if ($43e0a445ed6711da$export$a6cdc56e425d0d0a(piece)) {
                if ($d3d24261944405e2$var$has(piece, "start") && !$d3d24261944405e2$var$has(piece, "min")) piece.min = piece.start;
                if ($d3d24261944405e2$var$has(piece, "end") && !$d3d24261944405e2$var$has(piece, "max")) piece.max = piece.end;
            }
        });
        var seriesTargets;
    });
}
function $d3d24261944405e2$var$has(obj, name) {
    return obj && obj.hasOwnProperty && obj.hasOwnProperty(name);
}


var $c9514609b151525a$var$installed = false;
function $c9514609b151525a$export$2e2bcd8739ae039(registers) {
    if ($c9514609b151525a$var$installed) return;
    $c9514609b151525a$var$installed = true;
    registers.registerSubTypeDefaulter("visualMap", function(option) {
        // Compatible with ec2, when splitNumber === 0, continuous visualMap will be used.
        return !option.categories && (!(option.pieces ? option.pieces.length > 0 : option.splitNumber > 0) || option.calculable) ? "continuous" : "piecewise";
    });
    registers.registerAction((0, $94e541c01264dd6d$export$c5097295b52f5ecd), (0, $94e541c01264dd6d$export$8655c04a6fcbaa76));
    (0, $43e0a445ed6711da$export$79b2f7037acddd43)((0, $bd35b466871db5ff$export$5933e7c74ab358d1), function(handler) {
        registers.registerVisual(registers.PRIORITY.VISUAL.COMPONENT, handler);
    });
    registers.registerPreprocessor((0, $d3d24261944405e2$export$2e2bcd8739ae039));
}


function $cdf85201c1868fa1$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $10544d61198eef87$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $0b2db4a7d3fb8a9a$export$2e2bcd8739ae039));
    (0, $c9514609b151525a$export$2e2bcd8739ae039)(registers);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






var $ffa0ceeb4633b4a6$var$PiecewiseModel = /** @class */ function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(PiecewiseModel, _super);
    function PiecewiseModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = PiecewiseModel.type;
        /**
     * The order is always [low, ..., high].
     * [{text: string, interval: Array.<number>}, ...]
     */ _this._pieceList = [];
        return _this;
    }
    PiecewiseModel.prototype.optionUpdated = function(newOption, isInit) {
        _super.prototype.optionUpdated.apply(this, arguments);
        this.resetExtent();
        var mode = this._mode = this._determineMode();
        this._pieceList = [];
        $ffa0ceeb4633b4a6$var$resetMethods[this._mode].call(this, this._pieceList);
        this._resetSelected(newOption, isInit);
        var categories = this.option.categories;
        this.resetVisual(function(mappingOption, state) {
            if (mode === "categories") {
                mappingOption.mappingMethod = "category";
                mappingOption.categories = $43e0a445ed6711da$export$9cd59f9826255e47(categories);
            } else {
                mappingOption.dataExtent = this.getExtent();
                mappingOption.mappingMethod = "piecewise";
                mappingOption.pieceList = $43e0a445ed6711da$export$871de8747c9eaa88(this._pieceList, function(piece) {
                    piece = $43e0a445ed6711da$export$9cd59f9826255e47(piece);
                    if (state !== "inRange") // FIXME
                    // outOfRange do not support special visual in pieces.
                    piece.visual = null;
                    return piece;
                });
            }
        });
    };
    /**
   * @protected
   * @override
   */ PiecewiseModel.prototype.completeVisualOption = function() {
        // Consider this case:
        // visualMap: {
        //      pieces: [{symbol: 'circle', lt: 0}, {symbol: 'rect', gte: 0}]
        // }
        // where no inRange/outOfRange set but only pieces. So we should make
        // default inRange/outOfRange for this case, otherwise visuals that only
        // appear in `pieces` will not be taken into account in visual encoding.
        var option = this.option;
        var visualTypesInPieces = {};
        var visualTypes = (0, $46853c8218ff2c50$export$2e2bcd8739ae039).listVisualTypes();
        var isCategory = this.isCategory();
        $43e0a445ed6711da$export$79b2f7037acddd43(option.pieces, function(piece) {
            $43e0a445ed6711da$export$79b2f7037acddd43(visualTypes, function(visualType) {
                if (piece.hasOwnProperty(visualType)) visualTypesInPieces[visualType] = 1;
            });
        });
        $43e0a445ed6711da$export$79b2f7037acddd43(visualTypesInPieces, function(v, visualType) {
            var exists = false;
            $43e0a445ed6711da$export$79b2f7037acddd43(this.stateList, function(state) {
                exists = exists || has(option, state, visualType) || has(option.target, state, visualType);
            }, this);
            !exists && $43e0a445ed6711da$export$79b2f7037acddd43(this.stateList, function(state) {
                (option[state] || (option[state] = {}))[visualType] = (0, $031e7d9d693e91a3$export$2e2bcd8739ae039).get(visualType, state === "inRange" ? "active" : "inactive", isCategory);
            });
        }, this);
        function has(obj, state, visualType) {
            return obj && obj[state] && obj[state].hasOwnProperty(visualType);
        }
        _super.prototype.completeVisualOption.apply(this, arguments);
    };
    PiecewiseModel.prototype._resetSelected = function(newOption, isInit) {
        var thisOption = this.option;
        var pieceList = this._pieceList;
        // Selected do not merge but all override.
        var selected = (isInit ? thisOption : newOption).selected || {};
        thisOption.selected = selected;
        // Consider 'not specified' means true.
        $43e0a445ed6711da$export$79b2f7037acddd43(pieceList, function(piece, index) {
            var key = this.getSelectedMapKey(piece);
            if (!selected.hasOwnProperty(key)) selected[key] = true;
        }, this);
        if (thisOption.selectedMode === "single") {
            // Ensure there is only one selected.
            var hasSel_1 = false;
            $43e0a445ed6711da$export$79b2f7037acddd43(pieceList, function(piece, index) {
                var key = this.getSelectedMapKey(piece);
                if (selected[key]) hasSel_1 ? selected[key] = false : hasSel_1 = true;
            }, this);
        }
    // thisOption.selectedMode === 'multiple', default: all selected.
    };
    /**
   * @public
   */ PiecewiseModel.prototype.getItemSymbol = function() {
        return this.get("itemSymbol");
    };
    /**
   * @public
   */ PiecewiseModel.prototype.getSelectedMapKey = function(piece) {
        return this._mode === "categories" ? piece.value + "" : piece.index + "";
    };
    /**
   * @public
   */ PiecewiseModel.prototype.getPieceList = function() {
        return this._pieceList;
    };
    /**
   * @return {string}
   */ PiecewiseModel.prototype._determineMode = function() {
        var option = this.option;
        return option.pieces && option.pieces.length > 0 ? "pieces" : this.option.categories ? "categories" : "splitNumber";
    };
    /**
   * @override
   */ PiecewiseModel.prototype.setSelected = function(selected) {
        this.option.selected = $43e0a445ed6711da$export$9cd59f9826255e47(selected);
    };
    /**
   * @override
   */ PiecewiseModel.prototype.getValueState = function(value) {
        var index = (0, $46853c8218ff2c50$export$2e2bcd8739ae039).findPieceIndex(value, this._pieceList);
        return index != null ? this.option.selected[this.getSelectedMapKey(this._pieceList[index])] ? "inRange" : "outOfRange" : "outOfRange";
    };
    /**
   * @public
   * @param pieceIndex piece index in visualMapModel.getPieceList()
   */ PiecewiseModel.prototype.findTargetDataIndices = function(pieceIndex) {
        var result = [];
        var pieceList = this._pieceList;
        this.eachTargetSeries(function(seriesModel) {
            var dataIndices = [];
            var data = seriesModel.getData();
            data.each(this.getDataDimensionIndex(data), function(value, dataIndex) {
                // Should always base on model pieceList, because it is order sensitive.
                var pIdx = (0, $46853c8218ff2c50$export$2e2bcd8739ae039).findPieceIndex(value, pieceList);
                pIdx === pieceIndex && dataIndices.push(dataIndex);
            }, this);
            result.push({
                seriesId: seriesModel.id,
                dataIndex: dataIndices
            });
        }, this);
        return result;
    };
    /**
   * @private
   * @param piece piece.value or piece.interval is required.
   * @return  Can be Infinity or -Infinity
   */ PiecewiseModel.prototype.getRepresentValue = function(piece) {
        var representValue;
        if (this.isCategory()) representValue = piece.value;
        else if (piece.value != null) representValue = piece.value;
        else {
            var pieceInterval = piece.interval || [];
            representValue = pieceInterval[0] === -Infinity && pieceInterval[1] === Infinity ? 0 : (pieceInterval[0] + pieceInterval[1]) / 2;
        }
        return representValue;
    };
    PiecewiseModel.prototype.getVisualMeta = function(getColorVisual) {
        // Do not support category. (category axis is ordinal, numerical)
        if (this.isCategory()) return;
        var stops = [];
        var outerColors = [
            "",
            ""
        ];
        var visualMapModel = this;
        function setStop(interval, valueState) {
            var representValue = visualMapModel.getRepresentValue({
                interval: interval
            }); // Not category
            if (!valueState) valueState = visualMapModel.getValueState(representValue);
            var color = getColorVisual(representValue, valueState);
            if (interval[0] === -Infinity) outerColors[0] = color;
            else if (interval[1] === Infinity) outerColors[1] = color;
            else stops.push({
                value: interval[0],
                color: color
            }, {
                value: interval[1],
                color: color
            });
        }
        // Suplement
        var pieceList = this._pieceList.slice();
        if (!pieceList.length) pieceList.push({
            interval: [
                -Infinity,
                Infinity
            ]
        });
        else {
            var edge = pieceList[0].interval[0];
            edge !== -Infinity && pieceList.unshift({
                interval: [
                    -Infinity,
                    edge
                ]
            });
            edge = pieceList[pieceList.length - 1].interval[1];
            edge !== Infinity && pieceList.push({
                interval: [
                    edge,
                    Infinity
                ]
            });
        }
        var curr = -Infinity;
        $43e0a445ed6711da$export$79b2f7037acddd43(pieceList, function(piece) {
            var interval = piece.interval;
            if (interval) {
                // Fulfill gap.
                interval[0] > curr && setStop([
                    curr,
                    interval[0]
                ], "outOfRange");
                setStop(interval.slice());
                curr = interval[1];
            }
        }, this);
        return {
            stops: stops,
            outerColors: outerColors
        };
    };
    PiecewiseModel.type = "visualMap.piecewise";
    PiecewiseModel.defaultOption = (0, $f7a89889802a4565$export$68acc510e46fef2)((0, $6c5fdd461a5b821e$export$2e2bcd8739ae039).defaultOption, {
        selected: null,
        minOpen: false,
        maxOpen: false,
        align: "auto",
        itemWidth: 20,
        itemHeight: 14,
        itemSymbol: "roundRect",
        pieces: null,
        categories: null,
        splitNumber: 5,
        selectedMode: "multiple",
        itemGap: 10,
        hoverLink: true // Enable hover highlight.
    });
    return PiecewiseModel;
}((0, $6c5fdd461a5b821e$export$2e2bcd8739ae039));
/**
 * Key is this._mode
 * @type {Object}
 * @this {module:echarts/component/viusalMap/PiecewiseMode}
 */ var $ffa0ceeb4633b4a6$var$resetMethods = {
    splitNumber: function(outPieceList) {
        var thisOption = this.option;
        var precision = Math.min(thisOption.precision, 20);
        var dataExtent = this.getExtent();
        var splitNumber = thisOption.splitNumber;
        splitNumber = Math.max(parseInt(splitNumber, 10), 1);
        thisOption.splitNumber = splitNumber;
        var splitStep = (dataExtent[1] - dataExtent[0]) / splitNumber;
        // Precision auto-adaption
        while(+splitStep.toFixed(precision) !== splitStep && precision < 5)precision++;
        thisOption.precision = precision;
        splitStep = +splitStep.toFixed(precision);
        if (thisOption.minOpen) outPieceList.push({
            interval: [
                -Infinity,
                dataExtent[0]
            ],
            close: [
                0,
                0
            ]
        });
        for(var index = 0, curr = dataExtent[0]; index < splitNumber; curr += splitStep, index++){
            var max = index === splitNumber - 1 ? dataExtent[1] : curr + splitStep;
            outPieceList.push({
                interval: [
                    curr,
                    max
                ],
                close: [
                    1,
                    1
                ]
            });
        }
        if (thisOption.maxOpen) outPieceList.push({
            interval: [
                dataExtent[1],
                Infinity
            ],
            close: [
                0,
                0
            ]
        });
        (0, $b49750109e236fd8$export$12f7386070bc380a)(outPieceList);
        $43e0a445ed6711da$export$79b2f7037acddd43(outPieceList, function(piece, index) {
            piece.index = index;
            piece.text = this.formatValueText(piece.interval);
        }, this);
    },
    categories: function(outPieceList) {
        var thisOption = this.option;
        $43e0a445ed6711da$export$79b2f7037acddd43(thisOption.categories, function(cate) {
            // FIXME category模式也使用pieceList，但在visualMapping中不是使用pieceList。
            // 是否改一致。
            outPieceList.push({
                text: this.formatValueText(cate, true),
                value: cate
            });
        }, this);
        // See "Order Rule".
        $ffa0ceeb4633b4a6$var$normalizeReverse(thisOption, outPieceList);
    },
    pieces: function(outPieceList) {
        var thisOption = this.option;
        $43e0a445ed6711da$export$79b2f7037acddd43(thisOption.pieces, function(pieceListItem, index) {
            if (!$43e0a445ed6711da$export$a6cdc56e425d0d0a(pieceListItem)) pieceListItem = {
                value: pieceListItem
            };
            var item = {
                text: "",
                index: index
            };
            if (pieceListItem.label != null) item.text = pieceListItem.label;
            if (pieceListItem.hasOwnProperty("value")) {
                var value = item.value = pieceListItem.value;
                item.interval = [
                    value,
                    value
                ];
                item.close = [
                    1,
                    1
                ];
            } else {
                // `min` `max` is legacy option.
                // `lt` `gt` `lte` `gte` is recommended.
                var interval = item.interval = [];
                var close_1 = item.close = [
                    0,
                    0
                ];
                var closeList = [
                    1,
                    0,
                    1
                ];
                var infinityList = [
                    -Infinity,
                    Infinity
                ];
                var useMinMax = [];
                for(var lg = 0; lg < 2; lg++){
                    var names = [
                        [
                            "gte",
                            "gt",
                            "min"
                        ],
                        [
                            "lte",
                            "lt",
                            "max"
                        ]
                    ][lg];
                    for(var i = 0; i < 3 && interval[lg] == null; i++){
                        interval[lg] = pieceListItem[names[i]];
                        close_1[lg] = closeList[i];
                        useMinMax[lg] = i === 2;
                    }
                    interval[lg] == null && (interval[lg] = infinityList[lg]);
                }
                useMinMax[0] && interval[1] === Infinity && (close_1[0] = 0);
                useMinMax[1] && interval[0] === -Infinity && (close_1[1] = 0);
                if (interval[0] === interval[1] && close_1[0] && close_1[1]) // Consider: [{min: 5, max: 5, visual: {...}}, {min: 0, max: 5}],
                // we use value to lift the priority when min === max
                item.value = interval[0];
            }
            item.visual = (0, $46853c8218ff2c50$export$2e2bcd8739ae039).retrieveVisuals(pieceListItem);
            outPieceList.push(item);
        }, this);
        // See "Order Rule".
        $ffa0ceeb4633b4a6$var$normalizeReverse(thisOption, outPieceList);
        // Only pieces
        (0, $b49750109e236fd8$export$12f7386070bc380a)(outPieceList);
        $43e0a445ed6711da$export$79b2f7037acddd43(outPieceList, function(piece) {
            var close = piece.close;
            var edgeSymbols = [
                [
                    "<",
                    "\u2264"
                ][close[1]],
                [
                    ">",
                    "\u2265"
                ][close[0]]
            ];
            piece.text = piece.text || this.formatValueText(piece.value != null ? piece.value : piece.interval, false, edgeSymbols);
        }, this);
    }
};
function $ffa0ceeb4633b4a6$var$normalizeReverse(thisOption, pieceList) {
    var inverse = thisOption.inverse;
    if (thisOption.orient === "vertical" ? !inverse : inverse) pieceList.reverse();
}
var $ffa0ceeb4633b4a6$export$2e2bcd8739ae039 = $ffa0ceeb4633b4a6$var$PiecewiseModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







var $71025c23973e5380$var$PiecewiseVisualMapView = /** @class */ function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(PiecewiseVisualMapView, _super);
    function PiecewiseVisualMapView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = PiecewiseVisualMapView.type;
        return _this;
    }
    PiecewiseVisualMapView.prototype.doRender = function() {
        var thisGroup = this.group;
        thisGroup.removeAll();
        var visualMapModel = this.visualMapModel;
        var textGap = visualMapModel.get("textGap");
        var textStyleModel = visualMapModel.textStyleModel;
        var itemAlign = this._getItemAlign();
        var itemSize = visualMapModel.itemSize;
        var viewData = this._getViewData();
        var endsText = viewData.endsText;
        var showLabel = $43e0a445ed6711da$export$8a4d17b6e8486e66(visualMapModel.get("showLabel", true), !endsText);
        var silent = !visualMapModel.get("selectedMode");
        endsText && this._renderEndsText(thisGroup, endsText[0], itemSize, showLabel, itemAlign);
        $43e0a445ed6711da$export$79b2f7037acddd43(viewData.viewPieceList, function(item) {
            var piece = item.piece;
            var itemGroup = new $a8978f7a0e842e3d$export$2e2bcd8739ae039();
            itemGroup.onclick = $43e0a445ed6711da$export$2385a24977818dd0(this._onItemClick, this, piece);
            this._enableHoverLink(itemGroup, item.indexInModelPieceList);
            // TODO Category
            var representValue = visualMapModel.getRepresentValue(piece);
            this._createItemSymbol(itemGroup, representValue, [
                0,
                0,
                itemSize[0],
                itemSize[1]
            ], silent);
            if (showLabel) {
                var visualState = this.visualMapModel.getValueState(representValue);
                var align = textStyleModel.get("align") || itemAlign;
                itemGroup.add(new $7db7960d25b39b7c$export$2e2bcd8739ae039({
                    style: (0, $6556fe1ed9fb479d$export$f8998c3d0a13de59)(textStyleModel, {
                        x: align === "right" ? -textGap : itemSize[0] + textGap,
                        y: itemSize[1] / 2,
                        text: piece.text,
                        verticalAlign: textStyleModel.get("verticalAlign") || "middle",
                        align: align,
                        opacity: $43e0a445ed6711da$export$995e01f2f5c9d030(textStyleModel.get("opacity"), visualState === "outOfRange" ? 0.5 : 1)
                    }),
                    silent: silent
                }));
            }
            thisGroup.add(itemGroup);
        }, this);
        endsText && this._renderEndsText(thisGroup, endsText[1], itemSize, showLabel, itemAlign);
        $826bc4094efae72b$export$827f4ee28efc37(visualMapModel.get("orient"), thisGroup, visualMapModel.get("itemGap"));
        this.renderBackground(thisGroup);
        this.positionGroup(thisGroup);
    };
    PiecewiseVisualMapView.prototype._enableHoverLink = function(itemGroup, pieceIndex) {
        var _this = this;
        itemGroup.on("mouseover", function() {
            return onHoverLink("highlight");
        }).on("mouseout", function() {
            return onHoverLink("downplay");
        });
        var onHoverLink = function(method) {
            var visualMapModel = _this.visualMapModel;
            // TODO: TYPE More detailed action types
            visualMapModel.option.hoverLink && _this.api.dispatchAction({
                type: method,
                batch: $86290a88c460962b$export$5381a9dc5427ba18(visualMapModel.findTargetDataIndices(pieceIndex), visualMapModel)
            });
        };
    };
    PiecewiseVisualMapView.prototype._getItemAlign = function() {
        var visualMapModel = this.visualMapModel;
        var modelOption = visualMapModel.option;
        if (modelOption.orient === "vertical") return $86290a88c460962b$export$dca53c4702e35c6(visualMapModel, this.api, visualMapModel.itemSize);
        else {
            // horizontal, most case left unless specifying right.
            var align = modelOption.align;
            if (!align || align === "auto") align = "left";
            return align;
        }
    };
    PiecewiseVisualMapView.prototype._renderEndsText = function(group, text, itemSize, showLabel, itemAlign) {
        if (!text) return;
        var itemGroup = new $a8978f7a0e842e3d$export$2e2bcd8739ae039();
        var textStyleModel = this.visualMapModel.textStyleModel;
        itemGroup.add(new $7db7960d25b39b7c$export$2e2bcd8739ae039({
            style: (0, $6556fe1ed9fb479d$export$f8998c3d0a13de59)(textStyleModel, {
                x: showLabel ? itemAlign === "right" ? itemSize[0] : 0 : itemSize[0] / 2,
                y: itemSize[1] / 2,
                verticalAlign: "middle",
                align: showLabel ? itemAlign : "center",
                text: text
            })
        }));
        group.add(itemGroup);
    };
    /**
   * @private
   * @return {Object} {peiceList, endsText} The order is the same as screen pixel order.
   */ PiecewiseVisualMapView.prototype._getViewData = function() {
        var visualMapModel = this.visualMapModel;
        var viewPieceList = $43e0a445ed6711da$export$871de8747c9eaa88(visualMapModel.getPieceList(), function(piece, index) {
            return {
                piece: piece,
                indexInModelPieceList: index
            };
        });
        var endsText = visualMapModel.get("text");
        // Consider orient and inverse.
        var orient = visualMapModel.get("orient");
        var inverse = visualMapModel.get("inverse");
        // Order of model pieceList is always [low, ..., high]
        if (orient === "horizontal" ? inverse : !inverse) viewPieceList.reverse();
        else if (endsText) endsText = endsText.slice().reverse();
        return {
            viewPieceList: viewPieceList,
            endsText: endsText
        };
    };
    PiecewiseVisualMapView.prototype._createItemSymbol = function(group, representValue, shapeParam, silent) {
        var itemSymbol = (0, $4ff41a845d4679a6$export$af050e04da3a02e8)(// symbol will be string
        this.getControllerVisual(representValue, "symbol"), shapeParam[0], shapeParam[1], shapeParam[2], shapeParam[3], // color will be string
        this.getControllerVisual(representValue, "color"));
        itemSymbol.silent = silent;
        group.add(itemSymbol);
    };
    PiecewiseVisualMapView.prototype._onItemClick = function(piece) {
        var visualMapModel = this.visualMapModel;
        var option = visualMapModel.option;
        var selectedMode = option.selectedMode;
        if (!selectedMode) return;
        var selected = $43e0a445ed6711da$export$9cd59f9826255e47(option.selected);
        var newKey = visualMapModel.getSelectedMapKey(piece);
        if (selectedMode === "single" || selectedMode === true) {
            selected[newKey] = true;
            $43e0a445ed6711da$export$79b2f7037acddd43(selected, function(o, key) {
                selected[key] = key === newKey;
            });
        } else selected[newKey] = !selected[newKey];
        this.api.dispatchAction({
            type: "selectDataRange",
            from: this.uid,
            visualMapId: this.visualMapModel.id,
            selected: selected
        });
    };
    PiecewiseVisualMapView.type = "visualMap.piecewise";
    return PiecewiseVisualMapView;
}((0, $6dbd59d1e3935d9c$export$2e2bcd8739ae039));
var $71025c23973e5380$export$2e2bcd8739ae039 = $71025c23973e5380$var$PiecewiseVisualMapView;



function $1d45f2f664c9bebf$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $ffa0ceeb4633b4a6$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $71025c23973e5380$export$2e2bcd8739ae039));
    (0, $c9514609b151525a$export$2e2bcd8739ae039)(registers);
}


function $0a3086143b3c8b1b$export$4b3e715f166fdd78(registers) {
    (0, $8f6e8e1f1e941d98$export$1f96ae73734a86cc)((0, $cdf85201c1868fa1$export$4b3e715f166fdd78));
    (0, $8f6e8e1f1e941d98$export$1f96ae73734a86cc)((0, $1d45f2f664c9bebf$export$4b3e715f166fdd78));
// Do not install './dataZoomSelect',
// since it only work for toolbox dataZoom.
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $3258c55c30d2bcd6$var$DEFAULT_OPTION = {
    label: {
        enabled: true
    },
    decal: {
        show: false
    }
};
var $3258c55c30d2bcd6$var$innerSeries = (0, $87f4a59ac66e0ee6$export$64df9f8d92ae083f)();
var $3258c55c30d2bcd6$var$innerGlobal = (0, $87f4a59ac66e0ee6$export$64df9f8d92ae083f)();
var $3258c55c30d2bcd6$export$b30f1fd316fd93ca = (0, $87f4a59ac66e0ee6$export$d62c61cad9d1ab83)($3258c55c30d2bcd6$var$ariaVisual);
function $3258c55c30d2bcd6$var$ariaVisual(ecModel, api) {
    var ariaModel = ecModel.getModel("aria");
    // See "area enabled" detection code in `GlobalModel.ts`.
    if (!ariaModel.get("enabled")) return;
    var decalPaletteScope = $3258c55c30d2bcd6$var$innerGlobal(ecModel).scope || ($3258c55c30d2bcd6$var$innerGlobal(ecModel).scope = {});
    var defaultOption = $43e0a445ed6711da$export$9cd59f9826255e47($3258c55c30d2bcd6$var$DEFAULT_OPTION);
    $43e0a445ed6711da$export$4950aa0f605343fb(defaultOption.label, ecModel.getLocaleModel().get("aria"), false);
    $43e0a445ed6711da$export$4950aa0f605343fb(ariaModel.option, defaultOption, false);
    setDecal();
    setLabel();
    function setDecal() {
        var decalModel = ariaModel.getModel("decal");
        var useDecal = decalModel.get("show");
        if (useDecal) {
            // Each type of series use one scope.
            // Pie and funnel are using different scopes.
            var paletteScopeGroupByType_1 = $43e0a445ed6711da$export$55f8aa7ef875b0a4();
            ecModel.eachSeries(function(seriesModel) {
                if (!seriesModel.isColorBySeries()) $3258c55c30d2bcd6$var$innerSeries(seriesModel).scope = paletteScopeGroupByType_1.get(seriesModel.type) || paletteScopeGroupByType_1.set(seriesModel.type, {});
            });
            ecModel.eachSeries(function(seriesModel) {
                if ($43e0a445ed6711da$export$f6e2535fb5126e54(seriesModel.enableAriaDecal)) {
                    // Let series define how to use decal palette on data
                    seriesModel.enableAriaDecal();
                    return;
                }
                var data = seriesModel.getData();
                if (!seriesModel.isColorBySeries()) {
                    var dataAll_1 = seriesModel.getRawData();
                    var idxMap_1 = {};
                    var decalScope_1 = $3258c55c30d2bcd6$var$innerSeries(seriesModel).scope;
                    data.each(function(idx) {
                        var rawIdx = data.getRawIndex(idx);
                        idxMap_1[rawIdx] = idx;
                    });
                    var dataCount_1 = dataAll_1.count();
                    dataAll_1.each(function(rawIdx) {
                        var idx = idxMap_1[rawIdx];
                        var name = dataAll_1.getName(rawIdx) || rawIdx + "";
                        var paletteDecal = (0, $98b3e46db1e9df2f$export$e4d892222945a227)(seriesModel.ecModel, name, decalScope_1, dataCount_1);
                        var specifiedDecal = data.getItemVisual(idx, "decal");
                        data.setItemVisual(idx, "decal", mergeDecal(specifiedDecal, paletteDecal));
                    });
                } else {
                    var paletteDecal = (0, $98b3e46db1e9df2f$export$e4d892222945a227)(seriesModel.ecModel, seriesModel.name, decalPaletteScope, ecModel.getSeriesCount());
                    var specifiedDecal = data.getVisual("decal");
                    data.setVisual("decal", mergeDecal(specifiedDecal, paletteDecal));
                }
                function mergeDecal(specifiedDecal, paletteDecal) {
                    // Merge decal from palette to decal from itemStyle.
                    // User do not need to specify all of the decal props.
                    var resultDecal = specifiedDecal ? $43e0a445ed6711da$export$8b58be045bf06082($43e0a445ed6711da$export$8b58be045bf06082({}, paletteDecal), specifiedDecal) : paletteDecal;
                    resultDecal.dirty = true;
                    return resultDecal;
                }
            });
        }
    }
    function setLabel() {
        var dom = api.getZr().dom;
        // TODO: support for SSR
        if (!dom) return;
        var labelLocale = ecModel.getLocaleModel().get("aria");
        var labelModel = ariaModel.getModel("label");
        labelModel.option = $43e0a445ed6711da$export$ebe90cb607ad99e(labelModel.option, labelLocale);
        if (!labelModel.get("enabled")) return;
        dom.setAttribute("role", "img");
        if (labelModel.get("description")) {
            dom.setAttribute("aria-label", labelModel.get("description"));
            return;
        }
        var seriesCnt = ecModel.getSeriesCount();
        var maxDataCnt = labelModel.get([
            "data",
            "maxCount"
        ]) || 10;
        var maxSeriesCnt = labelModel.get([
            "series",
            "maxCount"
        ]) || 10;
        var displaySeriesCnt = Math.min(seriesCnt, maxSeriesCnt);
        var ariaLabel;
        if (seriesCnt < 1) // No series, no aria label
        return;
        else {
            var title = getTitle();
            if (title) {
                var withTitle = labelModel.get([
                    "general",
                    "withTitle"
                ]);
                ariaLabel = replace(withTitle, {
                    title: title
                });
            } else ariaLabel = labelModel.get([
                "general",
                "withoutTitle"
            ]);
            var seriesLabels_1 = [];
            var prefix = seriesCnt > 1 ? labelModel.get([
                "series",
                "multiple",
                "prefix"
            ]) : labelModel.get([
                "series",
                "single",
                "prefix"
            ]);
            ariaLabel += replace(prefix, {
                seriesCount: seriesCnt
            });
            ecModel.eachSeries(function(seriesModel, idx) {
                if (idx < displaySeriesCnt) {
                    var seriesLabel = void 0;
                    var seriesName = seriesModel.get("name");
                    var withName = seriesName ? "withName" : "withoutName";
                    seriesLabel = seriesCnt > 1 ? labelModel.get([
                        "series",
                        "multiple",
                        withName
                    ]) : labelModel.get([
                        "series",
                        "single",
                        withName
                    ]);
                    seriesLabel = replace(seriesLabel, {
                        seriesId: seriesModel.seriesIndex,
                        seriesName: seriesModel.get("name"),
                        seriesType: getSeriesTypeName(seriesModel.subType)
                    });
                    var data = seriesModel.getData();
                    if (data.count() > maxDataCnt) {
                        // Show part of data
                        var partialLabel = labelModel.get([
                            "data",
                            "partialData"
                        ]);
                        seriesLabel += replace(partialLabel, {
                            displayCnt: maxDataCnt
                        });
                    } else seriesLabel += labelModel.get([
                        "data",
                        "allData"
                    ]);
                    var middleSeparator_1 = labelModel.get([
                        "data",
                        "separator",
                        "middle"
                    ]);
                    var endSeparator_1 = labelModel.get([
                        "data",
                        "separator",
                        "end"
                    ]);
                    var excludeDimensionId_1 = labelModel.get([
                        "data",
                        "excludeDimensionId"
                    ]);
                    var dataLabels = [];
                    for(var i = 0; i < data.count(); i++)if (i < maxDataCnt) {
                        var name_1 = data.getName(i);
                        var value = !excludeDimensionId_1 ? data.getValues(i) : $43e0a445ed6711da$export$3dea766d36a8935f(data.getValues(i), function(v, j) {
                            return $43e0a445ed6711da$export$305f7d4e9d4624f2(excludeDimensionId_1, j) === -1;
                        });
                        var dataLabel = labelModel.get([
                            "data",
                            name_1 ? "withName" : "withoutName"
                        ]);
                        dataLabels.push(replace(dataLabel, {
                            name: name_1,
                            value: value.join(middleSeparator_1)
                        }));
                    }
                    seriesLabel += dataLabels.join(middleSeparator_1) + endSeparator_1;
                    seriesLabels_1.push(seriesLabel);
                }
            });
            var separatorModel = labelModel.getModel([
                "series",
                "multiple",
                "separator"
            ]);
            var middleSeparator = separatorModel.get("middle");
            var endSeparator = separatorModel.get("end");
            ariaLabel += seriesLabels_1.join(middleSeparator) + endSeparator;
            dom.setAttribute("aria-label", ariaLabel);
        }
    }
    function replace(str, keyValues) {
        if (!$43e0a445ed6711da$export$844ec244b1367d54(str)) return str;
        var result = str;
        $43e0a445ed6711da$export$79b2f7037acddd43(keyValues, function(value, key) {
            result = result.replace(new RegExp("\\{\\s*" + key + "\\s*\\}", "g"), value);
        });
        return result;
    }
    function getTitle() {
        var title = ecModel.get("title");
        if (title && title.length) title = title[0];
        return title && title.text;
    }
    function getSeriesTypeName(type) {
        var typeNames = ecModel.getLocaleModel().get([
            "series",
            "typeNames"
        ]);
        return typeNames[type] || typeNames.chart;
    }
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $b143c2dbc61b0be8$export$2e2bcd8739ae039(option) {
    if (!option || !option.aria) return;
    var aria = option.aria;
    // aria.show is deprecated and should use aria.enabled instead
    if (aria.show != null) aria.enabled = aria.show;
    aria.label = aria.label || {};
    // move description, general, series, data to be under aria.label
    $43e0a445ed6711da$export$79b2f7037acddd43([
        "description",
        "general",
        "series",
        "data"
    ], function(name) {
        if (aria[name] != null) aria.label[name] = aria[name];
    });
}


function $6aa34e5297455890$export$4b3e715f166fdd78(registers) {
    registers.registerPreprocessor((0, $b143c2dbc61b0be8$export$2e2bcd8739ae039));
    registers.registerVisual(registers.PRIORITY.VISUAL.ARIA, (0, $3258c55c30d2bcd6$export$b30f1fd316fd93ca));
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 











function $6e9e91c23eabb83b$var$createDom(id, painter, dpr) {
    var newDom = (0, $08c3209e6efc839a$export$ef5e599365494451).createCanvas();
    var width = painter.getWidth();
    var height = painter.getHeight();
    var newDomStyle = newDom.style;
    if (newDomStyle) {
        newDomStyle.position = "absolute";
        newDomStyle.left = "0";
        newDomStyle.top = "0";
        newDomStyle.width = width + "px";
        newDomStyle.height = height + "px";
        newDom.setAttribute("data-zr-dom-id", id);
    }
    newDom.width = width * dpr;
    newDom.height = height * dpr;
    return newDom;
}
function $6e9e91c23eabb83b$export$1844a24bc46be48a(layer) {
    return !layer.__cursors.get((0, $0f043989b8b0b396$export$2dc95e9f4fd018cd));
}
function $6e9e91c23eabb83b$var$getStartEndFromCursor(layer) {
    var cursor = layer.__cursors.get((0, $0f043989b8b0b396$export$2dc95e9f4fd018cd));
    return {
        startIdx: cursor ? cursor.startIdx : 0,
        endIdx: cursor ? cursor.endIdx : 0
    };
}
var $6e9e91c23eabb83b$var$Layer = function(_super) {
    (0, $418c8561bd4b31f8$export$a8ba968b8961cb8a)(Layer, _super);
    function Layer(id, painter, dpr) {
        var _this = _super.call(this) || this;
        _this.motionBlur = false;
        _this.lastFrameAlpha = 0.7;
        _this.dpr = 1;
        _this.virtual = false;
        _this.config = {};
        _this.zlevel = 0;
        _this.zlevel2 = (0, $0f043989b8b0b396$export$63f5564428138c5e);
        _this.maxRepaintRectCount = 5;
        _this.__dirty = true;
        _this.__firstTimePaint = true;
        _this.__prevIdx = {
            startIdx: 0,
            endIdx: 0
        };
        var dom;
        dpr = dpr || (0, $b4769615a730dcfc$export$508f096bfcdaac40);
        if (typeof id === "string") dom = $6e9e91c23eabb83b$var$createDom(id, painter, dpr);
        else if ($43e0a445ed6711da$export$a6cdc56e425d0d0a(id)) {
            dom = id;
            id = dom.id;
        }
        _this.id = id;
        _this.dom = dom;
        var domStyle = dom.style;
        if (domStyle) {
            $43e0a445ed6711da$export$23a5d775868fdd2c(dom);
            dom.onselectstart = function() {
                return false;
            };
            domStyle.padding = "0";
            domStyle.margin = "0";
            domStyle.borderWidth = "0";
        }
        _this.painter = painter;
        _this.dpr = dpr;
        return _this;
    }
    Layer.prototype.afterBrush = function() {
        this.__prevIdx = $6e9e91c23eabb83b$var$getStartEndFromCursor(this);
    };
    Layer.prototype.initContext = function() {
        this.ctx = this.dom.getContext("2d");
        this.ctx.dpr = this.dpr;
    };
    Layer.prototype.setUnpainted = function() {
        this.__firstTimePaint = true;
    };
    Layer.prototype.createBackBuffer = function() {
        var dpr = this.dpr;
        this.domBack = $6e9e91c23eabb83b$var$createDom("back-" + this.id, this.painter, dpr);
        this.ctxBack = this.domBack.getContext("2d");
        if (dpr !== 1) this.ctxBack.scale(dpr, dpr);
    };
    Layer.prototype.createRepaintRects = function(displayList, prevList, viewWidth, viewHeight) {
        if (this.__firstTimePaint) {
            this.__firstTimePaint = false;
            return null;
        }
        var mergedRepaintRects = [];
        var maxRepaintRectCount = this.maxRepaintRectCount;
        var full = false;
        var pendingRect = new (0, $c437f598d9c9ee16$export$2e2bcd8739ae039)(0, 0, 0, 0);
        function addRectToMergePool(rect) {
            if (!rect.isFinite() || rect.isZero()) return;
            if (mergedRepaintRects.length === 0) {
                var boundingRect = new (0, $c437f598d9c9ee16$export$2e2bcd8739ae039)(0, 0, 0, 0);
                boundingRect.copy(rect);
                mergedRepaintRects.push(boundingRect);
            } else {
                var isMerged = false;
                var minDeltaArea = Infinity;
                var bestRectToMergeIdx = 0;
                for(var i = 0; i < mergedRepaintRects.length; ++i){
                    var mergedRect = mergedRepaintRects[i];
                    if (mergedRect.intersect(rect)) {
                        var pendingRect_1 = new (0, $c437f598d9c9ee16$export$2e2bcd8739ae039)(0, 0, 0, 0);
                        pendingRect_1.copy(mergedRect);
                        pendingRect_1.union(rect);
                        mergedRepaintRects[i] = pendingRect_1;
                        isMerged = true;
                        break;
                    } else if (full) {
                        pendingRect.copy(rect);
                        pendingRect.union(mergedRect);
                        var aArea = rect.width * rect.height;
                        var bArea = mergedRect.width * mergedRect.height;
                        var pendingArea = pendingRect.width * pendingRect.height;
                        var deltaArea = pendingArea - aArea - bArea;
                        if (deltaArea < minDeltaArea) {
                            minDeltaArea = deltaArea;
                            bestRectToMergeIdx = i;
                        }
                    }
                }
                if (full) {
                    mergedRepaintRects[bestRectToMergeIdx].union(rect);
                    isMerged = true;
                }
                if (!isMerged) {
                    var boundingRect = new (0, $c437f598d9c9ee16$export$2e2bcd8739ae039)(0, 0, 0, 0);
                    boundingRect.copy(rect);
                    mergedRepaintRects.push(boundingRect);
                }
                if (!full) full = mergedRepaintRects.length >= maxRepaintRectCount;
            }
        }
        var se = $6e9e91c23eabb83b$var$getStartEndFromCursor(this);
        for(var i = se.startIdx; i < se.endIdx; ++i){
            var el = displayList[i];
            if (el) {
                var shouldPaint = el.shouldBePainted(viewWidth, viewHeight, true, true);
                var prevRect = el.__isRendered && (el.__dirty & (0, $24fa4a8d26d34a24$export$a7b6db622c6c7dbd) || !shouldPaint) ? el.getPrevPaintRect() : null;
                if (prevRect) addRectToMergePool(prevRect);
                var curRect = shouldPaint && (el.__dirty & (0, $24fa4a8d26d34a24$export$a7b6db622c6c7dbd) || !el.__isRendered) ? el.getPaintRect() : null;
                if (curRect) addRectToMergePool(curRect);
            }
        }
        var prevIdx = this.__prevIdx;
        for(var i = prevIdx.startIdx; i < prevIdx.endIdx; ++i){
            var el = prevList[i];
            var shouldPaint = el && el.shouldBePainted(viewWidth, viewHeight, true, true);
            if (el && (!shouldPaint || !el.__zr) && el.__isRendered) {
                var prevRect = el.getPrevPaintRect();
                if (prevRect) addRectToMergePool(prevRect);
            }
        }
        var hasIntersections;
        do {
            hasIntersections = false;
            for(var i = 0; i < mergedRepaintRects.length;){
                if (mergedRepaintRects[i].isZero()) {
                    mergedRepaintRects.splice(i, 1);
                    continue;
                }
                for(var j = i + 1; j < mergedRepaintRects.length;)if (mergedRepaintRects[i].intersect(mergedRepaintRects[j])) {
                    hasIntersections = true;
                    mergedRepaintRects[i].union(mergedRepaintRects[j]);
                    mergedRepaintRects.splice(j, 1);
                } else j++;
                i++;
            }
        }while (hasIntersections);
        this._paintRects = mergedRepaintRects;
        return mergedRepaintRects;
    };
    Layer.prototype.debugGetPaintRects = function() {
        return (this._paintRects || []).slice();
    };
    Layer.prototype.resize = function(width, height) {
        var dpr = this.dpr;
        var dom = this.dom;
        var domStyle = dom.style;
        var domBack = this.domBack;
        if (domStyle) {
            domStyle.width = width + "px";
            domStyle.height = height + "px";
        }
        dom.width = width * dpr;
        dom.height = height * dpr;
        if (domBack) {
            domBack.width = width * dpr;
            domBack.height = height * dpr;
            if (dpr !== 1) this.ctxBack.scale(dpr, dpr);
        }
    };
    Layer.prototype.clear = function(clearAll, clearColor, repaintRects) {
        var dom = this.dom;
        var ctx = this.ctx;
        var width = dom.width;
        var height = dom.height;
        clearColor = clearColor || this.clearColor;
        var haveMotionBLur = this.motionBlur && !clearAll;
        var lastFrameAlpha = this.lastFrameAlpha;
        var dpr = this.dpr;
        var self = this;
        if (haveMotionBLur) {
            if (!this.domBack) this.createBackBuffer();
            this.ctxBack.globalCompositeOperation = "copy";
            this.ctxBack.drawImage(dom, 0, 0, width / dpr, height / dpr);
        }
        var domBack = this.domBack;
        function doClear(x, y, width, height) {
            ctx.clearRect(x, y, width, height);
            if (clearColor && clearColor !== "transparent") {
                var clearColorGradientOrPattern = void 0;
                if ($43e0a445ed6711da$export$fa2c283003ed971c(clearColor)) {
                    var shouldCache = clearColor.global || clearColor.__width === width && clearColor.__height === height;
                    clearColorGradientOrPattern = shouldCache && clearColor.__canvasGradient || (0, $0aca998062cac624$export$3dab6afd018d48c7)(ctx, clearColor, {
                        x: 0,
                        y: 0,
                        width: width,
                        height: height
                    });
                    clearColor.__canvasGradient = clearColorGradientOrPattern;
                    clearColor.__width = width;
                    clearColor.__height = height;
                } else if ($43e0a445ed6711da$export$a49bbf3a55dcef7b(clearColor)) {
                    clearColor.scaleX = clearColor.scaleX || dpr;
                    clearColor.scaleY = clearColor.scaleY || dpr;
                    clearColorGradientOrPattern = (0, $6bc3d3dcea2beb63$export$8eb5db6b7bc27903)(ctx, clearColor, {
                        dirty: function() {
                            self.setUnpainted();
                            self.painter.refresh();
                        }
                    });
                }
                ctx.save();
                ctx.fillStyle = clearColorGradientOrPattern || clearColor;
                ctx.fillRect(x, y, width, height);
                ctx.restore();
            }
            if (haveMotionBLur) {
                ctx.save();
                ctx.globalAlpha = lastFrameAlpha;
                ctx.drawImage(domBack, x, y, width, height);
                ctx.restore();
            }
        }
        if (!repaintRects || haveMotionBLur) doClear(0, 0, width, height);
        else if (repaintRects.length) $43e0a445ed6711da$export$79b2f7037acddd43(repaintRects, function(rect) {
            doClear(rect.x * dpr, rect.y * dpr, rect.width * dpr, rect.height * dpr);
        });
    };
    return Layer;
}((0, $131b7833cdf735df$export$2e2bcd8739ae039));
var $6e9e91c23eabb83b$export$2e2bcd8739ae039 = $6e9e91c23eabb83b$var$Layer;









var $5635ce7742a5e147$var$HOVER_LAYER_ZLEVEL = 1e5;
var $5635ce7742a5e147$var$CANVAS_ZLEVEL = 314159;
var $5635ce7742a5e147$var$HOVER_LAYER_DIRTY_NO = undefined;
var $5635ce7742a5e147$var$HOVER_LAYER_DIRTY_REPAINT_IF_EXISTING = 1;
var $5635ce7742a5e147$var$HOVER_LAYER_DIRTY_REPAINT = 2;
function $5635ce7742a5e147$var$isLayerValid(layer) {
    if (!layer) return false;
    if (layer.__builtin__) return true;
    if (typeof layer.resize !== "function" || typeof layer.refresh !== "function") return false;
    return true;
}
function $5635ce7742a5e147$var$createRoot(width, height) {
    var domRoot = document.createElement("div");
    domRoot.style.cssText = [
        "position:relative",
        "width:" + width + "px",
        "height:" + height + "px",
        "padding:0",
        "margin:0",
        "border-width:0"
    ].join(";") + ";";
    return domRoot;
}
function $5635ce7742a5e147$var$createBuiltinLayer(id, painter, zlevel, zlevel2) {
    var layer = new (0, $6e9e91c23eabb83b$export$2e2bcd8739ae039)(id, painter, painter.dpr);
    layer.zlevel = zlevel;
    layer.zlevel2 = zlevel2;
    layer.__builtin__ = true;
    $5635ce7742a5e147$var$resetLayerDrawCursors(layer);
    return layer;
}
function $5635ce7742a5e147$var$resetLayerDrawCursors(layer) {
    layer.__cursorStack = [];
    layer.__cursors = $43e0a445ed6711da$export$55f8aa7ef875b0a4();
}
function $5635ce7742a5e147$var$resetLayerDrawCursor(cursor) {
    cursor.startIdx = cursor.drawIdx = cursor.endIdx = cursor.endIdxNew = 0;
    cursor.used = false;
    cursor.first = cursor.last = NaN;
    cursor.notClearIdx = -1;
    return cursor;
}
function $5635ce7742a5e147$var$ensureLayerDrawCursor(layer, incrementalCompat) {
    var cursors = layer.__cursors;
    var incremental = +incrementalCompat;
    return cursors.get(incremental) || (layer.__cursorStack.push(incremental), cursors.set(incremental, $5635ce7742a5e147$var$resetLayerDrawCursor({
        key: incremental
    })));
}
function $5635ce7742a5e147$var$eachCursorInLayer(layer, cb) {
    var cursorStack = layer.__cursorStack;
    for(var i = 0; i < cursorStack.length; i++)cb(layer.__cursors.get(cursorStack[i]));
}
function $5635ce7742a5e147$var$ensureLayerListInZLevel(internal, zlevel) {
    var layers = internal.layers;
    return layers[zlevel] || (layers[zlevel] = new Array(3));
}
function $5635ce7742a5e147$var$eachLayer(internal, cb, filter) {
    var layerStack = internal.layerStack;
    for(var i = 0; i < layerStack.length; i++){
        var zlevel = layerStack[i].zl;
        var zlevel2 = layerStack[i].zl2;
        var layer = internal.layers[zlevel][zlevel2];
        if (!filter || (!(filter & $5635ce7742a5e147$var$EACH_LAYER_BUILTIN) || layer.__builtin__) && (!(filter & $5635ce7742a5e147$var$EACH_LAYER_NOT_BUILTIN) || !layer.__builtin__) && (!(filter & $5635ce7742a5e147$var$EACH_LAYER_NOT_HOVER) || layer !== internal.hoverlayer)) cb(layer, zlevel, zlevel2, i);
    }
}
var $5635ce7742a5e147$var$EACH_LAYER_BUILTIN = 1;
var $5635ce7742a5e147$var$EACH_LAYER_NOT_BUILTIN = 2;
var $5635ce7742a5e147$var$EACH_LAYER_NOT_HOVER = 4;
var $5635ce7742a5e147$var$EACH_LAYER_BUILTIN_NOT_HOVER = $5635ce7742a5e147$var$EACH_LAYER_BUILTIN | $5635ce7742a5e147$var$EACH_LAYER_NOT_HOVER;
var $5635ce7742a5e147$var$CanvasPainter = function() {
    function CanvasPainter(root, storage, opts, id) {
        this.type = "canvas";
        this._prevDisplayList = [];
        this._layerConfig = {};
        this._needsManuallyCompositing = false;
        this.type = "canvas";
        this._i = {
            layerStack: [],
            layers: []
        };
        var singleCanvas = !root.nodeName || root.nodeName.toUpperCase() === "CANVAS";
        this._opts = opts = $43e0a445ed6711da$export$8b58be045bf06082({}, opts || {});
        this.dpr = opts.devicePixelRatio || (0, $b4769615a730dcfc$export$508f096bfcdaac40);
        this._singleCanvas = singleCanvas;
        this.root = root;
        var rootStyle = root.style;
        if (rootStyle) {
            $43e0a445ed6711da$export$23a5d775868fdd2c(root);
            root.innerHTML = "";
        }
        this.storage = storage;
        this._prevDisplayList = [];
        if (!singleCanvas) {
            this._width = (0, $0aca998062cac624$export$31b21d0167753bb4)(root, 0, opts);
            this._height = (0, $0aca998062cac624$export$31b21d0167753bb4)(root, 1, opts);
            var domRoot = this._domRoot = $5635ce7742a5e147$var$createRoot(this._width, this._height);
            root.appendChild(domRoot);
        } else {
            var rootCanvas = root;
            var width = rootCanvas.width;
            var height = rootCanvas.height;
            if (opts.width != null) width = opts.width;
            if (opts.height != null) height = opts.height;
            this.dpr = opts.devicePixelRatio || 1;
            rootCanvas.width = width * this.dpr;
            rootCanvas.height = height * this.dpr;
            this._width = width;
            this._height = height;
            var singleLayer = $5635ce7742a5e147$var$createBuiltinLayer(rootCanvas, this, $5635ce7742a5e147$var$CANVAS_ZLEVEL, (0, $0f043989b8b0b396$export$63f5564428138c5e));
            singleLayer.initContext();
            this._insertLayer(singleLayer, $5635ce7742a5e147$var$CANVAS_ZLEVEL, (0, $0f043989b8b0b396$export$63f5564428138c5e), true);
            this._domRoot = root;
        }
    }
    CanvasPainter.prototype.getType = function() {
        return "canvas";
    };
    CanvasPainter.prototype.isSingleCanvas = function() {
        return this._singleCanvas;
    };
    CanvasPainter.prototype.getViewportRoot = function() {
        return this._domRoot;
    };
    CanvasPainter.prototype.getViewportRootOffset = function() {
        var viewportRoot = this.getViewportRoot();
        if (viewportRoot) return {
            offsetLeft: viewportRoot.offsetLeft || 0,
            offsetTop: viewportRoot.offsetTop || 0
        };
    };
    CanvasPainter.prototype.refresh = function(optOrPaintAll) {
        var opt;
        if (optOrPaintAll && !$43e0a445ed6711da$export$a6cdc56e425d0d0a(optOrPaintAll)) opt = {
            paintAll: !!optOrPaintAll
        };
        else opt = optOrPaintAll || {};
        var refresh = $43e0a445ed6711da$export$995e01f2f5c9d030(opt.refresh, true);
        var refreshHover = $43e0a445ed6711da$export$995e01f2f5c9d030(opt.refreshHover, false);
        if (refreshHover) this._hoverLayerDirty = $5635ce7742a5e147$var$HOVER_LAYER_DIRTY_REPAINT;
        if (!refresh) {
            if (refreshHover) this._paintHoverList(this.storage.getDisplayList(false));
            return this;
        }
        var list = this.storage.getDisplayList(true);
        this._updateLayerStatus(list, opt.paintAll);
        this._redrawId = Math.random();
        var prevList = this._prevDisplayList;
        this._paintList(list, prevList, this._redrawId);
        var bgColor = this._backgroundColor;
        $5635ce7742a5e147$var$eachLayer(this._i, function(layer, zlevel, zlevel2, idx) {
            if (layer.refresh) layer.refresh(idx === 0 ? bgColor : null);
        }, $5635ce7742a5e147$var$EACH_LAYER_NOT_BUILTIN);
        if (this._opts.useDirtyRect) this._prevDisplayList = list.slice();
        return this;
    };
    CanvasPainter.prototype._paintHoverList = function(list) {
        var hoverLayer = this._i.hoverlayer;
        var hoverLayerDirty = this._hoverLayerDirty;
        this._hoverLayerDirty = $5635ce7742a5e147$var$HOVER_LAYER_DIRTY_NO;
        if (hoverLayerDirty === $5635ce7742a5e147$var$HOVER_LAYER_DIRTY_NO) return;
        if (!hoverLayer && hoverLayerDirty === $5635ce7742a5e147$var$HOVER_LAYER_DIRTY_REPAINT) hoverLayer = this._i.hoverlayer = this._ensureLayer($5635ce7742a5e147$var$HOVER_LAYER_ZLEVEL);
        if (!hoverLayer) return;
        hoverLayer.clear();
        var scope = {
            inHover: true,
            viewWidth: this._width,
            viewHeight: this._height,
            beforeBrushParam: {}
        };
        var ctx;
        for(var i = 0, len = list.length; i < len; i++){
            var el = list[i];
            if (!el.__inHover) continue;
            if (!ctx) {
                ctx = hoverLayer.ctx;
                ctx.save();
            }
            var hoverStyle = el.__hoverStyle;
            var originalStyle = void 0;
            if (hoverStyle) {
                originalStyle = el.style;
                el.style = hoverStyle;
            }
            (0, $6bc3d3dcea2beb63$export$da5d6544e8c27bc1)(ctx, el, scope);
            if (hoverStyle) el.style = originalStyle;
        }
        if (ctx) {
            (0, $6bc3d3dcea2beb63$export$aa9c98b43779289a)(ctx, scope);
            ctx.restore();
        }
    };
    CanvasPainter.prototype.getHoverLayer = function() {
        return this._ensureLayer($5635ce7742a5e147$var$HOVER_LAYER_ZLEVEL);
    };
    CanvasPainter.prototype.paintOne = function(ctx, el) {
        (0, $6bc3d3dcea2beb63$export$567881adfc3eb7f3)(ctx, el);
    };
    CanvasPainter.prototype._paintList = function(list, prevList, redrawId) {
        if (this._redrawId !== redrawId) return;
        var finished = this._doPaintList(list, prevList);
        if (this._needsManuallyCompositing) this._compositeManually();
        if (!finished) {
            var self_1 = this;
            (0, $261197b637bbe3ef$export$2e2bcd8739ae039)(function() {
                self_1._paintList(list, prevList, redrawId);
            });
        } else {
            $5635ce7742a5e147$var$eachLayer(this._i, function(layer) {
                layer.afterBrush && layer.afterBrush();
            }, $5635ce7742a5e147$var$EACH_LAYER_BUILTIN_NOT_HOVER);
            this._paintHoverList(list);
        }
    };
    CanvasPainter.prototype._compositeManually = function() {
        var ctx = this._ensureLayer($5635ce7742a5e147$var$CANVAS_ZLEVEL).ctx;
        var width = this._domRoot.width;
        var height = this._domRoot.height;
        ctx.clearRect(0, 0, width, height);
        $5635ce7742a5e147$var$eachLayer(this._i, function(layer) {
            if (layer.virtual) ctx.drawImage(layer.dom, 0, 0, width, height);
        }, $5635ce7742a5e147$var$EACH_LAYER_BUILTIN);
    };
    CanvasPainter.prototype._doPaintList = function(list, prevList) {
        var painter = this;
        var finished = true;
        $5635ce7742a5e147$var$eachLayer(this._i, function(layer) {
            var needDraw = false;
            $5635ce7742a5e147$var$eachCursorInLayer(layer, function(cursor) {
                if (cursor.drawIdx < cursor.endIdx || cursor.notClearIdx >= 0) needDraw = true;
            });
            if (!needDraw && !layer.__dirty) return;
            var repaintRects = painter._opts.useDirtyRect && !(0, $6e9e91c23eabb83b$export$1844a24bc46be48a)(layer) ? layer.createRepaintRects(list, prevList, painter._width, painter._height) : null;
            var firstLayerKey = painter._i.layerStack[0];
            var contentRetained = true;
            if (layer.__dirty) {
                contentRetained = false;
                layer.__dirty = false;
                var clearColor = layer.zlevel === firstLayerKey.zl && layer.zlevel2 === firstLayerKey.zl2 ? painter._backgroundColor : null;
                layer.clear(false, clearColor, repaintRects);
            }
            $5635ce7742a5e147$var$eachCursorInLayer(layer, function(cursor) {
                var cursorFinished = painter._paintPerCursor(layer, cursor, list, repaintRects, contentRetained);
                finished = finished && cursorFinished;
            });
        }, $5635ce7742a5e147$var$EACH_LAYER_BUILTIN_NOT_HOVER);
        if ((0, $a84633bb9c74d89c$export$2e2bcd8739ae039).wxa) $5635ce7742a5e147$var$eachLayer(this._i, function(layer) {
            if (layer && layer.ctx && layer.ctx.draw) layer.ctx.draw();
        });
        return finished;
    };
    CanvasPainter.prototype._paintPerCursor = function(layer, layerCursor, list, repaintRects, contentRetained) {
        var ctx = layer.ctx;
        if (repaintRects) {
            if (!repaintRects.length) layerCursor.drawIdx = layerCursor.endIdx;
            else {
                var dpr = this.dpr;
                for(var r = 0; r < repaintRects.length; ++r){
                    var rect = repaintRects[r];
                    ctx.save();
                    ctx.beginPath();
                    ctx.rect(rect.x * dpr, rect.y * dpr, rect.width * dpr, rect.height * dpr);
                    ctx.clip();
                    this._paintPerCursorInRect(layer, layerCursor, list, rect, contentRetained);
                    ctx.restore();
                }
            }
        } else {
            ctx.save();
            this._paintPerCursorInRect(layer, layerCursor, list, null, contentRetained);
            ctx.restore();
        }
        return layerCursor.drawIdx >= layerCursor.endIdx;
    };
    CanvasPainter.prototype._paintPerCursorInRect = function(layer, layerCursor, list, repaintRect, contentRetained) {
        var scope = {
            inHover: false,
            allClipped: false,
            prevEl: null,
            viewWidth: this._width,
            viewHeight: this._height,
            beforeBrushParam: {
                contentRetained: contentRetained
            }
        };
        var ctx = layer.ctx;
        var useTimer = (0, $6e9e91c23eabb83b$export$1844a24bc46be48a)(layer);
        var startTime = useTimer && (0, $08c3209e6efc839a$export$ef5e599365494451).getTime();
        var drawIdxBegin = layerCursor.drawIdx;
        var notClearIdx = layerCursor.notClearIdx;
        var idx = notClearIdx >= 0 ? Math.min(notClearIdx, drawIdxBegin) : drawIdxBegin;
        for(; idx < layerCursor.endIdx; idx++){
            var el = list[idx];
            if (idx < drawIdxBegin && !el.notClear) continue;
            if (el.__inHover) this._hoverLayerDirty = $5635ce7742a5e147$var$HOVER_LAYER_DIRTY_REPAINT;
            if (repaintRect != null) {
                var paintRect = el.getPaintRect();
                if (paintRect && paintRect.intersect(repaintRect)) {
                    (0, $6bc3d3dcea2beb63$export$da5d6544e8c27bc1)(ctx, el, scope);
                    el.setPrevPaintRect(paintRect);
                }
            } else (0, $6bc3d3dcea2beb63$export$da5d6544e8c27bc1)(ctx, el, scope);
            if (useTimer) {
                var dTime = (0, $08c3209e6efc839a$export$ef5e599365494451).getTime() - startTime;
                if (dTime > 15) {
                    idx++;
                    break;
                }
            }
        }
        (0, $6bc3d3dcea2beb63$export$aa9c98b43779289a)(ctx, scope);
        layerCursor.drawIdx = Math.max(idx, drawIdxBegin);
    };
    CanvasPainter.prototype.getLayer = function(zlevel, virtual) {
        return this._ensureLayer(zlevel, 0, virtual);
    };
    CanvasPainter.prototype._ensureLayer = function(zlevel, zlevel2, virtual) {
        zlevel2 = zlevel2 || 0;
        var singleCanvas = this._singleCanvas;
        if (singleCanvas && !this._needsManuallyCompositing) {
            zlevel = $5635ce7742a5e147$var$CANVAS_ZLEVEL;
            zlevel2 = 0;
        }
        var layer = $5635ce7742a5e147$var$ensureLayerListInZLevel(this._i, zlevel)[zlevel2];
        if (!layer) {
            layer = $5635ce7742a5e147$var$createBuiltinLayer("zr_" + zlevel + "." + zlevel2, this, zlevel, zlevel2);
            if (this._layerConfig[zlevel]) $43e0a445ed6711da$export$4950aa0f605343fb(layer, this._layerConfig[zlevel], true);
            if (virtual || singleCanvas && zlevel !== $5635ce7742a5e147$var$CANVAS_ZLEVEL) layer.virtual = true;
            this._insertLayer(layer, zlevel, zlevel2, false);
            layer.initContext();
        }
        return layer;
    };
    CanvasPainter.prototype.insertLayer = function(zlevel, layer) {
        this._insertLayer(layer, zlevel, 0, false);
    };
    CanvasPainter.prototype._insertLayer = function(layer, zlevel, zlevel2, suppressDOMInsert) {
        var internal = this._i;
        var layersMap = internal.layers;
        var layerStack = internal.layerStack;
        var domRoot = this._domRoot;
        var prevLayer = null;
        if (layersMap[zlevel] && layersMap[zlevel][zlevel2]) return;
        if (!$5635ce7742a5e147$var$isLayerValid(layer)) return;
        var len = layerStack.length;
        var i = 0;
        while(i < len && (layerStack[i].zl < zlevel || layerStack[i].zl === zlevel && layerStack[i].zl2 < zlevel2))i++;
        if (i > 0) prevLayer = $5635ce7742a5e147$var$ensureLayerListInZLevel(internal, layerStack[i - 1].zl)[layerStack[i - 1].zl2];
        layerStack.splice(i, 0, {
            zl: zlevel,
            zl2: zlevel2
        });
        $5635ce7742a5e147$var$ensureLayerListInZLevel(internal, zlevel)[zlevel2] = layer;
        if (!suppressDOMInsert && !layer.virtual) {
            if (prevLayer) {
                var prevDom = prevLayer.dom;
                if (prevDom.nextSibling) domRoot.insertBefore(layer.dom, prevDom.nextSibling);
                else domRoot.appendChild(layer.dom);
            } else if (domRoot.firstChild) domRoot.insertBefore(layer.dom, domRoot.firstChild);
            else domRoot.appendChild(layer.dom);
        }
        layer.painter || (layer.painter = this);
    };
    CanvasPainter.prototype.eachLayer = function(cb, context) {
        return $5635ce7742a5e147$var$eachLayer(this._i, function(layer, zlevel) {
            cb.call(context, layer, zlevel);
        });
    };
    CanvasPainter.prototype.eachBuiltinLayer = function(cb, context) {
        return $5635ce7742a5e147$var$eachLayer(this._i, function(layer, zlevel) {
            cb.call(context, layer, zlevel);
        }, $5635ce7742a5e147$var$EACH_LAYER_BUILTIN);
    };
    CanvasPainter.prototype.eachOtherLayer = function(cb, context) {
        return $5635ce7742a5e147$var$eachLayer(this._i, function(layer, zlevel) {
            cb.call(context, layer, zlevel);
        }, $5635ce7742a5e147$var$EACH_LAYER_NOT_BUILTIN);
    };
    CanvasPainter.prototype.getLayers = function() {
        var layers = {};
        $5635ce7742a5e147$var$eachLayer(this._i, function(layer, zlevel, zlevel2) {
            layers[layer.id] = layer;
        });
        return layers;
    };
    CanvasPainter.prototype._updateLayerStatus = function(list, paintAll) {
        var painter = this;
        if (painter._singleCanvas) for(var i = 1; i < list.length; i++){
            var el = list[i];
            if (el.zlevel !== list[i - 1].zlevel || el.incremental) {
                painter._needsManuallyCompositing = true;
                break;
            }
        }
        $5635ce7742a5e147$var$eachLayer(painter._i, function(layer) {
            layer.__dirty = false;
            $5635ce7742a5e147$var$eachCursorInLayer(layer, function(cursor) {
                cursor.used = false;
                cursor.endIdxNew = 0;
                cursor.notClearIdx = -1;
            });
        }, $5635ce7742a5e147$var$EACH_LAYER_BUILTIN_NOT_HOVER);
        var prevZLevel;
        var currLayer = null;
        var currCursor = null;
        var aboveIncrementalInCurrZLevel = false;
        for(var idx = 0, len = list.length; idx < len; idx++){
            var el = list[idx];
            var zlevel = el.zlevel;
            var elIncremental = el.incremental;
            var zlevel2 = void 0;
            if (prevZLevel !== zlevel) {
                prevZLevel = zlevel;
                aboveIncrementalInCurrZLevel = false;
            }
            if (elIncremental) {
                aboveIncrementalInCurrZLevel = true;
                zlevel2 = (0, $0f043989b8b0b396$export$5bf503311eda4292);
            } else zlevel2 = aboveIncrementalInCurrZLevel ? (0, $0f043989b8b0b396$export$f2b95933e1444751) : (0, $0f043989b8b0b396$export$63f5564428138c5e);
            if (!currLayer || zlevel !== currLayer.zlevel || zlevel2 !== currLayer.zlevel2) {
                currLayer = painter._ensureLayer(zlevel, zlevel2);
                currCursor = null;
                if (!currLayer.__builtin__) {
                    $43e0a445ed6711da$export$58da9968c3170cb1("ZLevel " + zlevel + " has been used by unknown layer " + currLayer.id);
                    continue;
                }
            }
            if (!currCursor || elIncremental !== currCursor.key) {
                currCursor = $5635ce7742a5e147$var$ensureLayerDrawCursor(currLayer, elIncremental);
                if (!currCursor.used) {
                    currCursor.used = true;
                    if (!paintAll && currCursor.first === el.id) {
                        var idxShift = idx - currCursor.startIdx;
                        currCursor.startIdx = idx;
                        currCursor.drawIdx += idxShift;
                        currCursor.endIdx += idxShift;
                    } else {
                        currLayer.__dirty = true;
                        currCursor.first = el.id;
                        currCursor.startIdx = currCursor.drawIdx = idx;
                        currCursor.endIdx = idx + 1;
                    }
                }
            }
            currCursor.endIdxNew = idx + 1;
            if (el.__dirty & (0, $24fa4a8d26d34a24$export$a7b6db622c6c7dbd) && !el.__inHover) {
                if (!elIncremental || !el.notClear && idx < currCursor.drawIdx) currLayer.__dirty = true;
                if (elIncremental && el.notClear && currCursor.notClearIdx < 0) currCursor.notClearIdx = idx;
            }
        }
        $5635ce7742a5e147$var$eachLayer(painter._i, function(layer) {
            var cursorStack = layer.__cursorStack;
            var cursors = layer.__cursors;
            for(var i = cursorStack.length - 1; i >= 0; i--){
                var cursor = cursors.get(cursorStack[i]);
                if (!cursor.used) {
                    layer.__dirty = true;
                    cursors.removeKey(cursorStack[i]);
                    cursorStack.splice(i, 1);
                } else {
                    var endIdxNew = cursor.endIdxNew;
                    if ((0, $6e9e91c23eabb83b$export$1844a24bc46be48a)(layer) ? endIdxNew < cursor.drawIdx : endIdxNew !== cursor.endIdx || !endIdxNew || list[endIdxNew - 1].id !== cursor.last) layer.__dirty = true;
                    cursor.endIdx = cursor.endIdxNew;
                    cursor.last = endIdxNew ? list[endIdxNew - 1].id : NaN;
                }
            }
            if (layer.__dirty) {
                $5635ce7742a5e147$var$eachCursorInLayer(layer, function(cursor) {
                    cursor.drawIdx = cursor.startIdx;
                });
                if (painter._hoverLayerDirty === $5635ce7742a5e147$var$HOVER_LAYER_DIRTY_NO) painter._hoverLayerDirty = $5635ce7742a5e147$var$HOVER_LAYER_DIRTY_REPAINT_IF_EXISTING;
            }
        }, $5635ce7742a5e147$var$EACH_LAYER_BUILTIN_NOT_HOVER);
    };
    CanvasPainter.prototype.clear = function() {
        $5635ce7742a5e147$var$eachLayer(this._i, function(layer) {
            layer.clear();
            $5635ce7742a5e147$var$resetLayerDrawCursors(layer);
        }, $5635ce7742a5e147$var$EACH_LAYER_BUILTIN);
        return this;
    };
    CanvasPainter.prototype.setBackgroundColor = function(backgroundColor) {
        this._backgroundColor = backgroundColor;
        $5635ce7742a5e147$var$eachLayer(this._i, function(layer) {
            layer.setUnpainted();
        });
    };
    CanvasPainter.prototype.configLayer = function(zlevel, config) {
        if (config) {
            var layerConfig_1 = this._layerConfig;
            if (!layerConfig_1[zlevel]) layerConfig_1[zlevel] = config;
            else $43e0a445ed6711da$export$4950aa0f605343fb(layerConfig_1[zlevel], config, true);
            $5635ce7742a5e147$var$eachLayer(this._i, function(layer, zlevel) {
                $43e0a445ed6711da$export$4950aa0f605343fb(layer, layerConfig_1[zlevel], true);
            });
        }
    };
    CanvasPainter.prototype.delLayer = function(zlevel) {
        var layerStack = this._i.layerStack;
        var layersMap = this._i.layers;
        for(var i = layerStack.length - 1; i >= 0; i--){
            var key = layerStack[i];
            if (key.zl === zlevel) {
                var layer = layersMap[zlevel][key.zl2];
                if (layer.__builtin__) continue;
                layerStack.splice(i, 1);
                layersMap[zlevel][key.zl2] = undefined;
                if (!layer.virtual) {
                    var parentNode = layer.dom.parentNode;
                    parentNode && parentNode.removeChild(layer.dom);
                }
            }
        }
    };
    CanvasPainter.prototype.resize = function(width, height) {
        if (!this._domRoot.style) {
            if (width == null || height == null) return;
            this._width = width;
            this._height = height;
            this._ensureLayer($5635ce7742a5e147$var$CANVAS_ZLEVEL).resize(width, height);
        } else {
            var domRoot = this._domRoot;
            domRoot.style.display = "none";
            var opts = this._opts;
            var root = this.root;
            width != null && (opts.width = width);
            height != null && (opts.height = height);
            width = (0, $0aca998062cac624$export$31b21d0167753bb4)(root, 0, opts);
            height = (0, $0aca998062cac624$export$31b21d0167753bb4)(root, 1, opts);
            domRoot.style.display = "";
            if (this._width !== width || height !== this._height) {
                domRoot.style.width = width + "px";
                domRoot.style.height = height + "px";
                $5635ce7742a5e147$var$eachLayer(this._i, function(layer) {
                    layer.resize(width, height);
                });
                this.refresh({
                    paintAll: true
                });
            }
            this._width = width;
            this._height = height;
        }
        return this;
    };
    CanvasPainter.prototype.clearLayer = function(zlevel) {
        $43e0a445ed6711da$export$79b2f7037acddd43(this._i.layers[zlevel], function(layer) {
            if (layer && !layer.__builtin__) layer.clear();
        });
    };
    CanvasPainter.prototype.dispose = function() {
        this.root.innerHTML = "";
        this.root = this.storage = this._domRoot = this._i = null;
    };
    CanvasPainter.prototype.getRenderedCanvas = function(opts) {
        opts = opts || {};
        if (this._singleCanvas && !this._compositeManually) return this._i.layers[$5635ce7742a5e147$var$CANVAS_ZLEVEL][0].dom;
        var imageLayer = new (0, $6e9e91c23eabb83b$export$2e2bcd8739ae039)("image", this, opts.pixelRatio || this.dpr);
        imageLayer.initContext();
        imageLayer.clear(false, opts.backgroundColor || this._backgroundColor);
        var ctx = imageLayer.ctx;
        if (opts.pixelRatio <= this.dpr) {
            this.refresh();
            var width_1 = imageLayer.dom.width;
            var height_1 = imageLayer.dom.height;
            $5635ce7742a5e147$var$eachLayer(this._i, function(layer) {
                if (layer.__builtin__) ctx.drawImage(layer.dom, 0, 0, width_1, height_1);
                else if (layer.renderToCanvas) {
                    ctx.save();
                    layer.renderToCanvas(ctx);
                    ctx.restore();
                }
            });
        } else {
            var scope = {
                inHover: false,
                viewWidth: this._width,
                viewHeight: this._height,
                beforeBrushParam: {}
            };
            var displayList = this.storage.getDisplayList(true);
            for(var i = 0, len = displayList.length; i < len; i++){
                var el = displayList[i];
                (0, $6bc3d3dcea2beb63$export$da5d6544e8c27bc1)(ctx, el, scope);
            }
            (0, $6bc3d3dcea2beb63$export$aa9c98b43779289a)(ctx, scope);
        }
        return imageLayer.dom;
    };
    CanvasPainter.prototype.getWidth = function() {
        return this._width;
    };
    CanvasPainter.prototype.getHeight = function() {
        return this._height;
    };
    return CanvasPainter;
}();
var $5635ce7742a5e147$export$2e2bcd8739ae039 = $5635ce7742a5e147$var$CanvasPainter;


function $0e4a673c6e483c20$export$4b3e715f166fdd78(registers) {
    registers.registerPainter("canvas", (0, $5635ce7742a5e147$export$2e2bcd8739ae039));
}


$8f6e8e1f1e941d98$export$1f96ae73734a86cc([
    (0, $d4e0260b8893a517$export$4b3e715f166fdd78),
    (0, $bb562bde2a71d0dd$export$4b3e715f166fdd78),
    (0, $6d301525e3baeb85$export$4b3e715f166fdd78),
    (0, $22382c3fac79675a$export$4b3e715f166fdd78),
    (0, $a284e3b35d3412c3$export$4b3e715f166fdd78),
    (0, $ff2bffb12297f574$export$4b3e715f166fdd78),
    (0, $9580c6053e3028db$export$4b3e715f166fdd78),
    (0, $0a3086143b3c8b1b$export$4b3e715f166fdd78),
    (0, $6aa34e5297455890$export$4b3e715f166fdd78),
    (0, $0e4a673c6e483c20$export$4b3e715f166fdd78)
]);
/* Canvas cannot read CSS custom properties, so every colour a chart draws has to
   be resolved to a literal first. Reading them off :root at runtime keeps
   tokens.css the single source of truth — no hex is duplicated into JS. */ const $c1978192ce2e9b34$var$TOKENS = [
    "--text-primary",
    "--text-secondary",
    "--surface-page",
    "--surface-sunken",
    "--border-subtle",
    "--action-primary",
    "--series-visits",
    "--series-reports",
    "--series-answers",
    "--chart-grid",
    "--chart-axis",
    "--success-500",
    "--warning-500",
    "--danger-500",
    "--danger-700",
    "--success-700",
    "--brand-50",
    "--brand-200",
    "--brand-400",
    "--brand-500",
    "--brand-600",
    "--brand-800"
];
function $c1978192ce2e9b34$export$7c008f4adb925d9f() {
    return (0, $cQmXV.useMemo)(()=>{
        const style = getComputedStyle(document.documentElement);
        const out = {};
        $c1978192ce2e9b34$var$TOKENS.forEach((name)=>{
            out[name.slice(2)] = style.getPropertyValue(name).trim();
        });
        return out;
    }, []);
}
const $c1978192ce2e9b34$export$e648100d89a49654 = (t, key)=>({
        visits: t["series-visits"],
        reports: t["series-reports"],
        answers: t["series-answers"],
        survey_answers: t["success-500"],
        approved: t["success-500"],
        on_verification: t["warning-500"],
        not_approved: t["danger-500"],
        submitted: t["series-visits"],
        reviewed: t["series-reports"],
        photo: t["brand-500"],
        dropdown: t["series-reports"],
        numeric: t["success-500"],
        text: t["series-answers"],
        boolean: t["warning-500"],
        date: t["brand-200"]
    })[key];
const $c1978192ce2e9b34$export$8f1900708ebed28 = (t)=>({
        fontFamily: getComputedStyle(document.body).fontFamily,
        fontSize: 12,
        color: t["chart-axis"]
    });
const $c1978192ce2e9b34$export$48de320f211e88f1 = (t)=>({
        backgroundColor: t["surface-page"],
        borderColor: t["border-subtle"],
        borderWidth: 1,
        padding: [
            8,
            12
        ],
        textStyle: {
            ...$c1978192ce2e9b34$export$8f1900708ebed28(t),
            color: t["text-primary"]
        },
        extraCssText: "box-shadow:var(--elevation-3);border-radius:var(--radius-md);"
    });
function $c1978192ce2e9b34$export$1572c1bbbe4962da(option) {
    const host = (0, $cQmXV.useRef)(null);
    const chart = (0, $cQmXV.useRef)(null);
    (0, $cQmXV.useEffect)(()=>{
        if (!host.current) return undefined;
        chart.current = $8d957d74809727b8$export$2cd8252107eb640b(host.current, null, {
            renderer: "canvas"
        });
        const observer = new ResizeObserver(()=>chart.current.resize());
        observer.observe(host.current);
        return ()=>{
            observer.disconnect();
            chart.current.dispose();
            chart.current = null;
        };
    }, []);
    (0, $cQmXV.useEffect)(()=>{
        if (chart.current && option) chart.current.setOption(option, true);
    }, [
        option
    ]);
    return host;
}







const $1aa6f1d8358888de$var$PAGE_SIZE = 10;
/* Icon and series colour per KPI. The three activity metrics reuse their trend
   series colour so a card and its line agree; the two headcounts share the
   interactive blue. */ const $1aa6f1d8358888de$var$KPI_META = [
    {
        key: "active_merchandisers",
        Icon: (0, $e85f2e3cc711f245$export$2e2bcd8739ae039),
        tone: "action-primary"
    },
    {
        key: "active_supervisors",
        Icon: (0, $d5baeea001a6abe5$export$2e2bcd8739ae039),
        tone: "action-primary"
    },
    {
        key: "visits",
        Icon: (0, $d6c8837c82724a15$export$2e2bcd8739ae039),
        tone: "series-visits"
    },
    {
        key: "reports",
        Icon: (0, $235e2c6c1e527cba$export$2e2bcd8739ae039),
        tone: "series-reports"
    },
    {
        key: "answers",
        Icon: (0, $d94a0f59d1b3bbaa$export$2e2bcd8739ae039),
        tone: "series-answers"
    }
];
const $1aa6f1d8358888de$var$TREND_SERIES = [
    "visits",
    "reports",
    "answers",
    "survey_answers"
];
const $1aa6f1d8358888de$var$VISIT_STATUSES = [
    "approved",
    "on_verification",
    "not_approved"
];
const $1aa6f1d8358888de$var$FUNNEL_STAGES = [
    "submitted",
    "reviewed",
    "approved"
];
const $1aa6f1d8358888de$var$ymOf = (date)=>`${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
const $1aa6f1d8358888de$var$monthDate = (ym)=>{
    const [y, m] = ym.split("-").map(Number);
    return new Date(y, m - 1, 1);
};
const $1aa6f1d8358888de$var$pct = (part, whole)=>whole ? Math.round(part / whole * 100) : 0;
/** `{a} of {b}` → the values, without ever inflecting a noun against a count. */ const $1aa6f1d8358888de$var$fill = (template, vars)=>Object.keys(vars).reduce((out, k)=>out.split(`{${k}}`).join(vars[k]), template);
function $1aa6f1d8358888de$var$computeDelta(current, previous) {
    if (!previous) return {
        pct: current ? 100 : 0,
        dir: current ? "up" : "flat"
    };
    const raw = Math.round((current - previous) / previous * 100);
    return {
        pct: Math.abs(raw),
        dir: raw > 0 ? "up" : raw < 0 ? "down" : "flat"
    };
}
/* A signed percentage reads as a direction; an unsigned one reads as a fact. */ const $1aa6f1d8358888de$var$signOf = (delta)=>delta.dir === "up" ? "+" : delta.dir === "down" ? "-" : "";
/**
 * Fill in whatever the payload is missing.
 *
 * Every card reads one section of a single response, so one absent section used
 * to take the whole page down: against an API that predates `visit_status` /
 * `surveys` / `photo_review` / `regions`, the first `stats.visit_status.approved`
 * threw and the ErrorBoundary replaced the entire dashboard with an error.
 *
 * Normalising once here, at the boundary, is what keeps that a per-card empty
 * state instead of a blank page — and it means the front end can be deployed
 * before the API change without the page breaking.
 */ function $1aa6f1d8358888de$var$withDefaults(res) {
    const surveys = res.surveys || {};
    return {
        ...res,
        kpis: Object.fromEntries($1aa6f1d8358888de$var$KPI_META.map(({ key: key })=>[
                key,
                {
                    current: 0,
                    previous: 0,
                    ...res.kpis?.[key]
                }
            ])),
        timeseries: {
            visits: [],
            reports: [],
            answers: [],
            survey_answers: [],
            ...res.timeseries
        },
        visit_status: {
            approved: 0,
            on_verification: 0,
            not_approved: 0,
            ...res.visit_status
        },
        photo_review: {
            submitted: 0,
            reviewed: 0,
            approved: 0,
            rejected: 0,
            ...res.photo_review
        },
        regions: {
            top: [],
            others: 0,
            ...res.regions
        },
        surveys: {
            active: 0,
            total: 0,
            ending_this_week: 0,
            ...surveys,
            answers: {
                current: 0,
                previous: 0,
                ...surveys.answers
            },
            by_type: surveys.by_type || [],
            list: surveys.list || []
        },
        top_merchandisers: res.top_merchandisers || [],
        /* A plain array now. `.results` is the paginated shape the endpoint returned
       before this page stopped paging server-side — read it so the front end can
       be deployed ahead of the API without the table throwing. */ by_merchandiser: Array.isArray(res.by_merchandiser) ? res.by_merchandiser : res.by_merchandiser?.results || []
    };
}
const $1aa6f1d8358888de$var$initials = (name)=>name.split(" ").filter(Boolean).map((w)=>w[0]).slice(0, 2).join("").toUpperCase();
/* ---------------------------------------------------------------- primitives */ function $1aa6f1d8358888de$var$Card({ title: title, hint: hint, children: children, className: className = "" }) {
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("section", {
        className: `ov-card ${className}`,
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                className: "ov-card__head",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("h2", {
                        className: "ov-card__title",
                        children: title
                    }),
                    hint ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "ov-card__hint",
                        children: hint
                    }) : null
                ]
            }),
            children
        ]
    });
}
function $1aa6f1d8358888de$var$BarList({ rows: rows, color: color }) {
    const max = Math.max(...rows.map((r)=>r.value), 1);
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
        className: "ov-bars",
        children: rows.map((r)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                className: "ov-bar",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "ov-bar__name",
                        title: r.name,
                        children: r.name
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "ov-bar__val",
                        children: r.label
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "ov-bar__track",
                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                            className: "ov-bar__fill",
                            style: {
                                width: `${r.value / max * 100}%`,
                                background: color
                            }
                        })
                    })
                ]
            }, r.name))
    });
}
/** Donut ring plus a legend that carries the numbers — the ring alone cannot be
    read to a value, and the centre label only has room for one. */ function $1aa6f1d8358888de$var$Donut({ segments: segments, centre: centre, caption: caption, tokens: tokens, label: label, format: format }) {
    const total = segments.reduce((a, s)=>a + s.value, 0);
    const option = (0, $cQmXV.useMemo)(()=>({
            textStyle: (0, $c1978192ce2e9b34$export$8f1900708ebed28)(tokens),
            tooltip: {
                ...(0, $c1978192ce2e9b34$export$48de320f211e88f1)(tokens),
                trigger: "item",
                formatter: (p)=>`${p.name}<br><b>${format(p.value)}</b> \xb7 ${p.percent}%`
            },
            series: [
                {
                    type: "pie",
                    radius: [
                        "62%",
                        "88%"
                    ],
                    center: [
                        "50%",
                        "50%"
                    ],
                    avoidLabelOverlap: false,
                    label: {
                        show: false
                    },
                    labelLine: {
                        show: false
                    },
                    itemStyle: {
                        borderWidth: 2,
                        borderColor: tokens["surface-page"]
                    },
                    emphasis: {
                        scale: true,
                        scaleSize: 4
                    },
                    data: segments.map((s)=>({
                            name: s.name,
                            value: s.value,
                            itemStyle: {
                                color: s.color
                            }
                        }))
                }
            ],
            aria: {
                enabled: true,
                label: {
                    description: label
                }
            }
        }), [
        segments,
        tokens,
        label,
        format
    ]);
    const host = (0, $c1978192ce2e9b34$export$1572c1bbbe4962da)(option);
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
        className: "ov-donut-wrap",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                className: "ov-donut",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                        className: "ov-donut__c",
                        ref: host
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                        className: "ov-donut__mid",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                                className: "ov-donut__val",
                                children: centre
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                                className: "ov-donut__cap",
                                children: caption
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                className: "ov-breakdown",
                children: segments.map((s)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                        className: "ov-breakdown__row",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("i", {
                                style: {
                                    background: s.color
                                }
                            }),
                            s.name,
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("b", {
                                children: format(s.value)
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                                className: "ov-breakdown__pct",
                                children: [
                                    $1aa6f1d8358888de$var$pct(s.value, total),
                                    "%"
                                ]
                            })
                        ]
                    }, s.name))
            })
        ]
    });
}
function $1aa6f1d8358888de$export$2e2bcd8739ae039() {
    const lang = (0, $b83e93e5ef3de8b0$export$2105062e25df4afe)((state)=>state.me?.language) || "en";
    const t = (0, $cQmXV.useCallback)((key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$9cbb0f231a0ab7ea), key, lang), [
        lang
    ]);
    const tokens = (0, $c1978192ce2e9b34$export$7c008f4adb925d9f)();
    const [month, setMonth] = (0, $cQmXV.useState)($1aa6f1d8358888de$var$ymOf(new Date()));
    const [state, setState] = (0, $cQmXV.useState)({
        stats: null,
        loading: true,
        busy: false,
        error: false
    });
    /* The month is the only thing that refetches. The merchandiser table's search
     and paging run over the rows already in hand — they used to be request
     parameters, which meant every keystroke re-ran the SQL behind all nine cards
     so the server could slice ten rows off a list it had built in full anyway. */ const load = (0, $cQmXV.useCallback)(()=>{
        setState((s)=>({
                ...s,
                busy: true,
                error: false
            }));
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "GET",
            url: `stats/dashboard/?month=${month}`
        }, (res)=>{
            if (res && res.kpis) setState({
                stats: $1aa6f1d8358888de$var$withDefaults(res),
                loading: false,
                busy: false,
                error: false
            });
            else setState((s)=>({
                    ...s,
                    loading: false,
                    busy: false,
                    error: true
                }));
        });
    }, [
        month
    ]);
    (0, $cQmXV.useEffect)(()=>{
        load();
    }, [
        load
    ]);
    const stepMonth = (delta)=>{
        const next = $1aa6f1d8358888de$var$ymOf((0, $7d0f78de0b68a104$export$17c93e242b2d3a22)($1aa6f1d8358888de$var$monthDate(month), delta));
        if (next > $1aa6f1d8358888de$var$ymOf(new Date())) return; // no future months
        setMonth(next);
    };
    const { stats: stats, loading: loading, busy: busy, error: error } = state;
    const current = $1aa6f1d8358888de$var$monthDate(month);
    const atCurrentMonth = month >= $1aa6f1d8358888de$var$ymOf(new Date());
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
        className: "shell-content ov",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                className: "ov-head",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("h1", {
                                className: "ov-title",
                                children: t("title")
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("p", {
                                className: "ov-sub",
                                children: $1aa6f1d8358888de$var$fill(t("period_sub"), {
                                    m: (0, $7d0f78de0b68a104$export$4f81354ee858acb4)(current, lang),
                                    /* `period_sub` is "{m} · проти {p}" — the slot after the preposition takes the genitive. */ p: (0, $7d0f78de0b68a104$export$1411063a75ad0425)((0, $7d0f78de0b68a104$export$17c93e242b2d3a22)(current, -1), lang)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                        className: "ov-monthnav",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                type: "text",
                                shape: "circle",
                                size: "small",
                                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0f3c6d60b091c877$export$2e2bcd8739ae039), {}),
                                disabled: busy,
                                onClick: ()=>stepMonth(-1),
                                "aria-label": t("prev_month")
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                className: "ov-monthnav__label",
                                children: (0, $7d0f78de0b68a104$export$4f81354ee858acb4)(current, lang)
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                type: "text",
                                shape: "circle",
                                size: "small",
                                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $89db7229a7e10f8f$export$2e2bcd8739ae039), {}),
                                disabled: busy || atCurrentMonth,
                                onClick: ()=>stepMonth(1),
                                "aria-label": t("next_month")
                            })
                        ]
                    })
                ]
            }),
            loading ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                className: "ov-state",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $62b8cbcd99b9ffa2$export$2e2bcd8739ae039), {}),
                    " ",
                    t("loading")
                ]
            }) : null,
            !loading && error ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                className: "ov-state",
                children: [
                    t("error"),
                    " ",
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                        type: "link",
                        onClick: load,
                        children: t("retry")
                    })
                ]
            }) : null,
            !loading && !error && stats ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($1aa6f1d8358888de$var$Dashboard, {
                stats: stats,
                t: t,
                lang: lang,
                tokens: tokens,
                month: month,
                busy: busy
            }) : null
        ]
    });
}
function $1aa6f1d8358888de$var$Dashboard({ stats: stats, t: t, lang: lang, tokens: tokens, month: month, busy: busy }) {
    const current = $1aa6f1d8358888de$var$monthDate(month);
    const previous = (0, $7d0f78de0b68a104$export$17c93e242b2d3a22)(current, -1);
    const surveys = stats.surveys;
    const [query, setQuery] = (0, $cQmXV.useState)("");
    const needle = query.trim().toLowerCase();
    const rows = needle ? stats.by_merchandiser.filter((r)=>r.name.toLowerCase().includes(needle)) : stats.by_merchandiser;
    /* Numbers follow the app language, not the browser's — the two disagree on
     every machine where someone picked a language by hand. */ const n = (0, $cQmXV.useMemo)(()=>{
        const formatter = new Intl.NumberFormat((0, $7d0f78de0b68a104$export$bd7bed267fc278f2)(lang));
        return (value)=>formatter.format(value || 0);
    }, [
        lang
    ]);
    /* ---- trend: four daily series over the month -------------------------- */ const trendOption = (0, $cQmXV.useMemo)(()=>{
        const [year, m] = month.split("-").map(Number);
        const days = new Date(year, m, 0).getDate();
        const labels = Array.from({
            length: days
        }, (_, i)=>i + 1);
        const byDay = (key)=>{
            const map = {};
            (stats.timeseries[key] || []).forEach((r)=>{
                map[Number(r.date.slice(8, 10))] = r.count;
            });
            return labels.map((d)=>map[d] || 0);
        };
        const series = $1aa6f1d8358888de$var$TREND_SERIES.map((key)=>({
                key: key,
                data: byDay(key)
            }));
        /* Biggest series first so its translucent fill sits behind the smaller ones
       rather than washing them out. */ series.sort((a, b)=>Math.max(...b.data, 0) - Math.max(...a.data, 0));
        return {
            textStyle: (0, $c1978192ce2e9b34$export$8f1900708ebed28)(tokens),
            legend: {
                top: 0,
                right: 0,
                /* Fixed order. `series` is re-sorted below for paint order, and without
           this the legend would reshuffle itself whenever the data changes. */ data: $1aa6f1d8358888de$var$TREND_SERIES.map(t),
                icon: "roundRect",
                itemWidth: 9,
                itemHeight: 9,
                itemGap: 14,
                textStyle: (0, $c1978192ce2e9b34$export$8f1900708ebed28)(tokens)
            },
            grid: {
                top: 34,
                right: 12,
                bottom: 26,
                left: 52
            },
            tooltip: {
                ...(0, $c1978192ce2e9b34$export$48de320f211e88f1)(tokens),
                trigger: "axis",
                axisPointer: {
                    type: "line",
                    lineStyle: {
                        color: tokens["border-subtle"],
                        width: 1
                    }
                },
                valueFormatter: n
            },
            xAxis: {
                type: "category",
                data: labels,
                boundaryGap: false,
                axisLine: {
                    show: false
                },
                axisTick: {
                    show: false
                },
                axisLabel: {
                    ...(0, $c1978192ce2e9b34$export$8f1900708ebed28)(tokens),
                    interval: (i, v)=>Number(v) === 1 || Number(v) % 5 === 0
                }
            },
            yAxis: {
                type: "value",
                splitLine: {
                    lineStyle: {
                        color: tokens["chart-grid"]
                    }
                },
                axisLabel: {
                    ...(0, $c1978192ce2e9b34$export$8f1900708ebed28)(tokens),
                    formatter: n
                }
            },
            series: series.map((s, i)=>{
                const color = (0, $c1978192ce2e9b34$export$e648100d89a49654)(tokens, s.key);
                return {
                    name: t(s.key),
                    type: "line",
                    symbol: "circle",
                    symbolSize: 6,
                    showSymbol: false,
                    z: i + 1,
                    lineStyle: {
                        width: 2,
                        color: color
                    },
                    itemStyle: {
                        color: color
                    },
                    areaStyle: {
                        color: new (0, $3ffd465796cef3c9$exports).graphic.LinearGradient(0, 0, 0, 1, [
                            {
                                offset: 0,
                                color: `${color}42`
                            },
                            {
                                offset: 1,
                                color: `${color}00`
                            }
                        ])
                    },
                    emphasis: {
                        focus: "series"
                    },
                    data: s.data
                };
            })
        };
    }, [
        stats,
        tokens,
        t,
        month,
        n
    ]);
    const trendHost = (0, $c1978192ce2e9b34$export$1572c1bbbe4962da)(trendOption);
    /* ---- heatmap: the same visit series on a month calendar --------------- */ const heatOption = (0, $cQmXV.useMemo)(()=>{
        const data = (stats.timeseries.visits || []).map((r)=>[
                r.date,
                r.count
            ]);
        const counts = data.map((d)=>d[1]);
        /* nameMap is indexed from Sunday no matter what firstDay says, so the
       Monday-first headers have to be rotated. */ const mon2sun = (0, $7d0f78de0b68a104$export$8d7bfd7870d0d02)(lang);
        return {
            textStyle: (0, $c1978192ce2e9b34$export$8f1900708ebed28)(tokens),
            tooltip: {
                ...(0, $c1978192ce2e9b34$export$48de320f211e88f1)(tokens),
                formatter: (p)=>`${p.value[0]}<br><b>${n(p.value[1])}</b> ${t("visits").toLowerCase()}`
            },
            visualMap: {
                type: "piecewise",
                min: Math.min(...counts, 0),
                max: Math.max(...counts, 1),
                /* splitNumber generates the buckets. Passing `pieces` without a min and
           max on each entry collapses everything into one colour. */ splitNumber: 5,
                inRange: {
                    color: [
                        tokens["brand-50"],
                        tokens["brand-200"],
                        tokens["brand-400"],
                        tokens["brand-600"],
                        tokens["brand-800"]
                    ]
                },
                orient: "horizontal",
                right: 8,
                bottom: 4,
                itemWidth: 14,
                itemHeight: 10,
                itemGap: 4,
                showLabel: false,
                text: [
                    t("more"),
                    t("fewer")
                ],
                textStyle: (0, $c1978192ce2e9b34$export$8f1900708ebed28)(tokens)
            },
            calendar: {
                top: 22,
                left: 48,
                right: 24,
                bottom: 46,
                /* 'auto' width needs `right` set, or it has no rect to fill. A month has
           only ~6 week columns, so across a full-width card the cells stretch to
           130px and read as bars — hence the max-width on the host, which also
           lets them shrink on a phone instead of being clipped. */ cellSize: [
                    "auto",
                    30
                ],
                range: month,
                splitLine: {
                    show: false
                },
                itemStyle: {
                    color: tokens["surface-sunken"],
                    borderWidth: 3,
                    borderColor: tokens["surface-page"]
                },
                yearLabel: {
                    show: false
                },
                monthLabel: {
                    show: false
                },
                /* firstDay lives under dayLabel, not on calendar — set on the calendar
           itself it is silently ignored and weeks stay Sunday-first. */ dayLabel: {
                    nameMap: [
                        mon2sun[6],
                        ...mon2sun.slice(0, 6)
                    ],
                    firstDay: 1,
                    ...(0, $c1978192ce2e9b34$export$8f1900708ebed28)(tokens)
                }
            },
            series: [
                {
                    type: "heatmap",
                    coordinateSystem: "calendar",
                    data: data,
                    itemStyle: {
                        borderWidth: 3,
                        borderColor: tokens["surface-page"]
                    },
                    emphasis: {
                        itemStyle: {
                            borderColor: tokens["chart-axis"]
                        }
                    }
                }
            ],
            aria: {
                enabled: true,
                label: {
                    description: t("visit_intensity")
                }
            }
        };
    }, [
        stats,
        tokens,
        t,
        lang,
        month,
        n
    ]);
    const heatHost = (0, $c1978192ce2e9b34$export$1572c1bbbe4962da)(heatOption);
    /* ---- derived card data ------------------------------------------------
     The two donut segment lists are memoised because they are the dependency
     ECharts' setOption keys off: rebuilt every render, the ring would be
     re-configured on every keystroke in the table's search box. */ const visitSegments = (0, $cQmXV.useMemo)(()=>$1aa6f1d8358888de$var$VISIT_STATUSES.map((key)=>({
                name: t(key),
                value: stats.visit_status[key] || 0,
                color: (0, $c1978192ce2e9b34$export$e648100d89a49654)(tokens, key)
            })), [
        stats,
        t,
        tokens
    ]);
    const visitTotal = visitSegments.reduce((a, s)=>a + s.value, 0);
    const typeSegments = (0, $cQmXV.useMemo)(()=>surveys.by_type.filter((r)=>r.count > 0).map((r)=>({
                name: t(`t_${r.type}`),
                value: r.count,
                color: (0, $c1978192ce2e9b34$export$e648100d89a49654)(tokens, r.type)
            })), [
        surveys,
        t,
        tokens
    ]);
    const typeTotal = typeSegments.reduce((a, s)=>a + s.value, 0);
    /* The donut's centre carries the largest type and its share — a count of how
     many types exist would be a fact about the chart, not about the data. */ const topType = typeSegments.reduce((a, s)=>s.value > a.value ? s : a, {
        value: 0,
        name: ""
    });
    const funnelTop = stats.photo_review.submitted || 1;
    const answersDelta = $1aa6f1d8358888de$var$computeDelta(surveys.answers.current, surveys.answers.previous);
    const regionRows = [
        ...stats.regions.top.map((r)=>({
                name: r.name,
                value: r.visits,
                label: n(r.visits)
            })),
        ...stats.regions.others ? [
            {
                name: t("other_regions"),
                value: stats.regions.others,
                label: n(stats.regions.others)
            }
        ] : []
    ];
    const columns = [
        {
            title: t("col_merchandiser"),
            dataIndex: "name",
            render: (name)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                    className: "ov-who",
                    children: [
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                            className: "ov-avatar",
                            children: $1aa6f1d8358888de$var$initials(name)
                        }),
                        name
                    ]
                })
        },
        ...[
            "visits",
            "reports",
            "answers"
        ].map((key)=>({
                title: t(`col_${key}`),
                dataIndex: key,
                align: "right",
                className: "ov-num",
                render: (v)=>n(v)
            }))
    ];
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
        className: busy ? "ov-body ov-body--busy" : "ov-body",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("section", {
                className: "ov-grid-kpi",
                children: $1aa6f1d8358888de$var$KPI_META.map(({ key: key, Icon: Icon, tone: tone })=>{
                    const item = stats.kpis[key] || {
                        current: 0,
                        previous: 0
                    };
                    const d = $1aa6f1d8358888de$var$computeDelta(item.current, item.previous);
                    const DirIcon = d.dir === "up" ? (0, $1c94f5240fc505a2$export$2e2bcd8739ae039) : d.dir === "down" ? (0, $3ebb5094d17c7fda$export$2e2bcd8739ae039) : (0, $886bddec374e5a95$export$2e2bcd8739ae039);
                    const color = tokens[tone] || `var(--${tone})`;
                    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("article", {
                        className: "ov-card ov-kpi",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                                className: "ov-kpi__top",
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                        className: "ov-kpi__icon",
                                        style: {
                                            color: color,
                                            background: `${color}1a`
                                        },
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)(Icon, {})
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                                        className: `ov-chip ov-chip--${d.dir}`,
                                        children: [
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)(DirIcon, {}),
                                            d.pct,
                                            "%"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                                        className: "ov-kpi__value",
                                        children: n(item.current)
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                                        className: "ov-kpi__label",
                                        children: t(key)
                                    })
                                ]
                            })
                        ]
                    }, key);
                })
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($1aa6f1d8358888de$var$Card, {
                title: t("surveys"),
                hint: t("active_this_month"),
                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                    className: "ov-band",
                    children: [
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                            className: "ov-band__cell",
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                                    className: "ov-band__label",
                                    children: [
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $170c031fa50279f7$export$2e2bcd8739ae039), {}),
                                        " ",
                                        t("active_surveys")
                                    ]
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                    className: "ov-band__value",
                                    children: surveys.active
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                    className: "ov-band__hint",
                                    children: $1aa6f1d8358888de$var$fill(t("active_surveys_hint"), {
                                        t: surveys.total,
                                        e: surveys.ending_this_week
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                            className: "ov-band__cell",
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                                    className: "ov-band__label",
                                    children: [
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $d94a0f59d1b3bbaa$export$2e2bcd8739ae039), {}),
                                        " ",
                                        t("answers_collected")
                                    ]
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                    className: "ov-band__value",
                                    children: n(surveys.answers.current)
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                    className: "ov-band__hint",
                                    children: $1aa6f1d8358888de$var$fill(t("vs_previous_month"), {
                                        p: `${$1aa6f1d8358888de$var$signOf(answersDelta)}${answersDelta.pct}`,
                                        m: (0, $7d0f78de0b68a104$export$1411063a75ad0425)(previous, lang)
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("section", {
                className: "ov-grid-2-1",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($1aa6f1d8358888de$var$Card, {
                        title: t("trend_title"),
                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                            className: "ov-chart ov-chart--tall",
                            ref: trendHost
                        })
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($1aa6f1d8358888de$var$Card, {
                        title: t("visit_status"),
                        hint: `${n(visitTotal)} ${t("total")}`,
                        children: visitTotal ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($1aa6f1d8358888de$var$Donut, {
                            segments: visitSegments,
                            centre: `${$1aa6f1d8358888de$var$pct(stats.visit_status.approved, visitTotal)}%`,
                            caption: t("approved"),
                            tokens: tokens,
                            label: t("visit_status"),
                            format: n
                        }) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $99350450b877904c$export$2e2bcd8739ae039), {
                            image: (0, $99350450b877904c$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE,
                            description: t("empty")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("section", {
                className: "ov-grid-3",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($1aa6f1d8358888de$var$Card, {
                        title: t("photo_pipeline"),
                        children: stats.photo_review.submitted ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $575603080129eb00$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                                    className: "ov-funnel",
                                    children: $1aa6f1d8358888de$var$FUNNEL_STAGES.map((key)=>{
                                        const value = stats.photo_review[key] || 0;
                                        const share = value / funnelTop * 100;
                                        return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                                            className: "ov-funnel__row",
                                            children: [
                                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                                                    className: "ov-funnel__meta",
                                                    children: [
                                                        t(key),
                                                        " ",
                                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("b", {
                                                            children: n(value)
                                                        }),
                                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                                                            className: "ov-funnel__pct",
                                                            children: [
                                                                share.toFixed(1),
                                                                "%"
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                                                    className: "ov-funnel__bar",
                                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                                                        className: "ov-funnel__fill",
                                                        style: {
                                                            width: `${share}%`,
                                                            background: (0, $c1978192ce2e9b34$export$e648100d89a49654)(tokens, key)
                                                        }
                                                    })
                                                })
                                            ]
                                        }, key);
                                    })
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                                    className: "ov-note",
                                    children: [
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $4d7cc9843b581604$export$2e2bcd8739ae039), {
                                            className: "ov-note__icon"
                                        }),
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                            children: $1aa6f1d8358888de$var$fill(t("rejected_hint"), {
                                                n: n(stats.photo_review.rejected),
                                                p: $1aa6f1d8358888de$var$pct(stats.photo_review.rejected, stats.photo_review.reviewed)
                                            })
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $99350450b877904c$export$2e2bcd8739ae039), {
                            image: (0, $99350450b877904c$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE,
                            description: t("empty")
                        })
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($1aa6f1d8358888de$var$Card, {
                        title: t("answers_by_type"),
                        hint: `${n(typeTotal)} ${t("total")}`,
                        children: typeSegments.length ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($1aa6f1d8358888de$var$Donut, {
                            segments: typeSegments,
                            centre: `${$1aa6f1d8358888de$var$pct(topType.value, typeTotal)}%`,
                            caption: topType.name,
                            tokens: tokens,
                            label: t("answers_by_type"),
                            format: n
                        }) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $99350450b877904c$export$2e2bcd8739ae039), {
                            image: (0, $99350450b877904c$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE,
                            description: t("empty")
                        })
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($1aa6f1d8358888de$var$Card, {
                        title: t("visits_by_region"),
                        hint: t("top_regions"),
                        children: regionRows.length ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($1aa6f1d8358888de$var$BarList, {
                            rows: regionRows,
                            color: tokens["brand-500"]
                        }) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $99350450b877904c$export$2e2bcd8739ae039), {
                            image: (0, $99350450b877904c$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE,
                            description: t("empty")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("section", {
                className: "ov-grid-13-1",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($1aa6f1d8358888de$var$Card, {
                        title: t("survey_activity"),
                        hint: t("active_this_month"),
                        children: surveys.list.length ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($1aa6f1d8358888de$var$BarList, {
                            rows: surveys.list.map((s)=>({
                                    name: s.name,
                                    value: s.answers,
                                    label: n(s.answers)
                                })),
                            color: tokens["series-answers"]
                        }) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $99350450b877904c$export$2e2bcd8739ae039), {
                            image: (0, $99350450b877904c$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE,
                            description: t("empty")
                        })
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($1aa6f1d8358888de$var$Card, {
                        title: t("top_merchandisers"),
                        hint: t("by_visits"),
                        children: stats.top_merchandisers.length ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($1aa6f1d8358888de$var$BarList, {
                            rows: stats.top_merchandisers.map((m)=>({
                                    name: m.name,
                                    value: m.visits,
                                    label: n(m.visits)
                                })),
                            color: tokens["brand-500"]
                        }) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $99350450b877904c$export$2e2bcd8739ae039), {
                            image: (0, $99350450b877904c$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE,
                            description: t("empty")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($1aa6f1d8358888de$var$Card, {
                title: t("visit_intensity"),
                hint: `${t("per_day")} \xb7 ${(0, $7d0f78de0b68a104$export$4f81354ee858acb4)(current, lang)}`,
                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                    className: "ov-chart ov-chart--tall",
                    ref: heatHost
                })
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($1aa6f1d8358888de$var$Card, {
                title: t("by_merchandiser"),
                hint: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0883e7f8083c01b0$export$2e2bcd8739ae039), {
                    className: "ov-search",
                    allowClear: true,
                    prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $20a259d46bffcb08$export$2e2bcd8739ae039), {}),
                    placeholder: t("search_ph"),
                    value: query,
                    onChange: (e)=>setQuery(e.target.value),
                    "aria-label": t("search_ph")
                }),
                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $dff4d45d201c6dfe$export$2e2bcd8739ae039), {
                    rowKey: "id",
                    size: "middle",
                    columns: columns,
                    dataSource: rows,
                    loading: busy,
                    scroll: {
                        x: 560
                    },
                    locale: {
                        emptyText: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $99350450b877904c$export$2e2bcd8739ae039), {
                            image: (0, $99350450b877904c$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE,
                            description: t("empty")
                        })
                    },
                    pagination: {
                        pageSize: $1aa6f1d8358888de$var$PAGE_SIZE,
                        showSizeChanger: false,
                        hideOnSinglePage: true
                    }
                })
            })
        ]
    });
}


/* Photo report — the review grid.
   Visual reference: docs/design/photo-review.html. Normative rules: docs/design/spec/.

   Shape: filters card → status/view segments → photo grid → sticky bulk bar → review modal.
   Filters apply as they change (there is no Apply button in the design); the free-text comment
   field is debounced so typing costs one request, not one per keystroke.

   Two things the API cannot do, and how this page copes:
   - `visits/photos_from_reports/` proxies Outforz and joins picsell approvals onto the page it
     got back, so it cannot FILTER by approval status. The status segment therefore narrows the
     rows currently LOADED, and this page states no total at all: the endpoint's own `count` is
     Outforz's and the verdicts are picsell's, so any number over the whole filtered set needed
     an extra join across both (`photo_report_status_counts`, since deleted) and every count on
     the screen would have been either a page-local number reading as a total or a total that
     quietly ignored an Outforz-only filter.
     ponytail: client-side status filter over the loaded rows. Needs an
     `is_approved` query param on the endpoint to become a real server-side filter.
   - A shared URL carries only what the endpoint matches on: names for categories / brands / tags,
     a code for products, ids for points and merchandisers. The first two are self-describing, so
     their chips read as words straight away; the id-matched ones are named by `EntitySelect`'s
     `onResolve` once it has fetched them, into the `labels` cache. */ 

var $cQmXV = parcelRequire("cQmXV");



var $cQmXV = parcelRequire("cQmXV");










var $cQmXV = parcelRequire("cQmXV");


function $0c76a414426a4728$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $89c7ad5d109a1176$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $0c76a414426a4728$export$2e2bcd8739ae039)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}











var $cQmXV = parcelRequire("cQmXV");
var $13e9780397f098d5$var$initialState = {
    animating: false,
    autoplaying: null,
    currentDirection: 0,
    currentLeft: null,
    currentSlide: 0,
    direction: 1,
    dragging: false,
    edgeDragged: false,
    initialized: false,
    lazyLoadedList: [],
    listHeight: null,
    listWidth: null,
    scrolling: false,
    slideCount: null,
    slideHeight: null,
    slideWidth: null,
    swipeLeft: null,
    swiped: false,
    // used by swipeEvent. differentites between touch and swipe.
    swiping: false,
    touchObject: {
        startX: 0,
        startY: 0,
        curX: 0,
        curY: 0
    },
    trackStyle: {},
    trackWidth: 0,
    targetSlide: 0
};
var $13e9780397f098d5$export$2e2bcd8739ae039 = $13e9780397f098d5$var$initialState;






var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");
var $4547f3e58e9675f5$var$defaultProps = {
    accessibility: true,
    adaptiveHeight: false,
    afterChange: null,
    appendDots: function appendDots(dots) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("ul", {
            style: {
                display: "block"
            }
        }, dots);
    },
    arrows: true,
    autoplay: false,
    autoplaySpeed: 3000,
    beforeChange: null,
    centerMode: false,
    centerPadding: "50px",
    className: "",
    cssEase: "ease",
    customPaging: function customPaging(i) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("button", null, i + 1);
    },
    dots: false,
    dotsClass: "slick-dots",
    draggable: true,
    easing: "linear",
    edgeFriction: 0.35,
    fade: false,
    focusOnSelect: false,
    infinite: true,
    initialSlide: 0,
    lazyLoad: null,
    nextArrow: null,
    onEdge: null,
    onInit: null,
    onLazyLoadError: null,
    onReInit: null,
    pauseOnDotsHover: false,
    pauseOnFocus: false,
    pauseOnHover: true,
    prevArrow: null,
    responsive: null,
    rows: 1,
    rtl: false,
    slide: "div",
    slidesPerRow: 1,
    slidesToScroll: 1,
    slidesToShow: 1,
    speed: 500,
    swipe: true,
    swipeEvent: null,
    swipeToSlide: false,
    touchMove: true,
    touchThreshold: 5,
    useCSS: true,
    useTransform: true,
    variableWidth: false,
    vertical: false,
    verticalSwiping: false,
    waitForAnimate: true,
    asNavFor: null,
    unslick: false
};
var $4547f3e58e9675f5$export$2e2bcd8739ae039 = $4547f3e58e9675f5$var$defaultProps;


function $e3a0420005a1a536$export$7d15b64cf5a3a4c4(number, lowerBound, upperBound) {
    return Math.max(lowerBound, Math.min(number, upperBound));
}
var $e3a0420005a1a536$export$ed7b1178205ba7d = function safePreventDefault(event) {
    var passiveEvents = [
        "onTouchStart",
        "onTouchMove",
        "onWheel"
    ];
    if (!passiveEvents.includes(event._reactName)) event.preventDefault();
};
var $e3a0420005a1a536$export$62701ea96990f316 = function getOnDemandLazySlides(spec) {
    var onDemandSlides = [];
    var startIndex = $e3a0420005a1a536$export$8931689ba1e6a542(spec);
    var endIndex = $e3a0420005a1a536$export$fc4e3e46621b5503(spec);
    for(var slideIndex = startIndex; slideIndex < endIndex; slideIndex++)if (spec.lazyLoadedList.indexOf(slideIndex) < 0) onDemandSlides.push(slideIndex);
    return onDemandSlides;
};
var $e3a0420005a1a536$export$61de20028e4bc291 = function getRequiredLazySlides(spec) {
    var requiredSlides = [];
    var startIndex = $e3a0420005a1a536$export$8931689ba1e6a542(spec);
    var endIndex = $e3a0420005a1a536$export$fc4e3e46621b5503(spec);
    for(var slideIndex = startIndex; slideIndex < endIndex; slideIndex++)requiredSlides.push(slideIndex);
    return requiredSlides;
};
var $e3a0420005a1a536$export$8931689ba1e6a542 = function lazyStartIndex(spec) {
    return spec.currentSlide - $e3a0420005a1a536$export$2c85b0e65618cf24(spec);
};
var $e3a0420005a1a536$export$fc4e3e46621b5503 = function lazyEndIndex(spec) {
    return spec.currentSlide + $e3a0420005a1a536$export$d4d84a0677f3a05c(spec);
};
var $e3a0420005a1a536$export$2c85b0e65618cf24 = function lazySlidesOnLeft(spec) {
    return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
};
var $e3a0420005a1a536$export$d4d84a0677f3a05c = function lazySlidesOnRight(spec) {
    return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
};
var $e3a0420005a1a536$export$3c49c185de0c2bfc = function getWidth(elem) {
    return elem && elem.offsetWidth || 0;
};
var $e3a0420005a1a536$export$c08559766941f856 = function getHeight(elem) {
    return elem && elem.offsetHeight || 0;
};
var $e3a0420005a1a536$export$67fc172604a155ba = function getSwipeDirection(touchObject) {
    var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var xDist, yDist, r, swipeAngle;
    xDist = touchObject.startX - touchObject.curX;
    yDist = touchObject.startY - touchObject.curY;
    r = Math.atan2(yDist, xDist);
    swipeAngle = Math.round(r * 180 / Math.PI);
    if (swipeAngle < 0) swipeAngle = 360 - Math.abs(swipeAngle);
    if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) return "left";
    if (swipeAngle >= 135 && swipeAngle <= 225) return "right";
    if (verticalSwiping === true) {
        if (swipeAngle >= 35 && swipeAngle <= 135) return "up";
        else return "down";
    }
    return "vertical";
};
var $e3a0420005a1a536$export$30e977044f8f3618 = function canGoNext(spec) {
    var canGo = true;
    if (!spec.infinite) {
        if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) canGo = false;
        else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) canGo = false;
    }
    return canGo;
};
var $e3a0420005a1a536$export$e9dd1a4ab6b7c5b0 = function extractObject(spec, keys) {
    var newObject = {};
    keys.forEach(function(key) {
        return newObject[key] = spec[key];
    });
    return newObject;
};
var $e3a0420005a1a536$export$446226dbc576c3ab = function initializedState(spec) {
    // spec also contains listRef, trackRef
    var slideCount = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Children.count(spec.children);
    var listNode = spec.listRef;
    var listWidth = Math.ceil($e3a0420005a1a536$export$3c49c185de0c2bfc(listNode));
    var trackNode = spec.trackRef && spec.trackRef.node;
    var trackWidth = Math.ceil($e3a0420005a1a536$export$3c49c185de0c2bfc(trackNode));
    var slideWidth;
    if (!spec.vertical) {
        var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;
        if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") centerPaddingAdj *= listWidth / 100;
        slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
    } else slideWidth = listWidth;
    var slideHeight = listNode && $e3a0420005a1a536$export$c08559766941f856(listNode.querySelector('[data-index="0"]'));
    var listHeight = slideHeight * spec.slidesToShow;
    var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;
    if (spec.rtl && spec.currentSlide === undefined) currentSlide = slideCount - 1 - spec.initialSlide;
    var lazyLoadedList = spec.lazyLoadedList || [];
    var slidesToLoad = $e3a0420005a1a536$export$62701ea96990f316((0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, spec), {}, {
        currentSlide: currentSlide,
        lazyLoadedList: lazyLoadedList
    }));
    lazyLoadedList = lazyLoadedList.concat(slidesToLoad);
    var state = {
        slideCount: slideCount,
        slideWidth: slideWidth,
        listWidth: listWidth,
        trackWidth: trackWidth,
        currentSlide: currentSlide,
        slideHeight: slideHeight,
        listHeight: listHeight,
        lazyLoadedList: lazyLoadedList
    };
    if (spec.autoplaying === null && spec.autoplay) state["autoplaying"] = "playing";
    return state;
};
var $e3a0420005a1a536$export$961f912fd58954b = function slideHandler(spec) {
    var waitForAnimate = spec.waitForAnimate, animating = spec.animating, fade = spec.fade, infinite = spec.infinite, index = spec.index, slideCount = spec.slideCount, lazyLoad = spec.lazyLoad, currentSlide = spec.currentSlide, centerMode = spec.centerMode, slidesToScroll = spec.slidesToScroll, slidesToShow = spec.slidesToShow, useCSS = spec.useCSS;
    var lazyLoadedList = spec.lazyLoadedList;
    if (waitForAnimate && animating) return {};
    var animationSlide = index, finalSlide, animationLeft, finalLeft;
    var state = {}, nextState = {};
    var targetSlide = infinite ? index : $e3a0420005a1a536$export$7d15b64cf5a3a4c4(index, 0, slideCount - 1);
    if (fade) {
        if (!infinite && (index < 0 || index >= slideCount)) return {};
        if (index < 0) animationSlide = index + slideCount;
        else if (index >= slideCount) animationSlide = index - slideCount;
        if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) lazyLoadedList = lazyLoadedList.concat(animationSlide);
        state = {
            animating: true,
            currentSlide: animationSlide,
            lazyLoadedList: lazyLoadedList,
            targetSlide: animationSlide
        };
        nextState = {
            animating: false,
            targetSlide: animationSlide
        };
    } else {
        finalSlide = animationSlide;
        if (animationSlide < 0) {
            finalSlide = animationSlide + slideCount;
            if (!infinite) finalSlide = 0;
            else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
        } else if (!$e3a0420005a1a536$export$30e977044f8f3618(spec) && animationSlide > currentSlide) animationSlide = finalSlide = currentSlide;
        else if (centerMode && animationSlide >= slideCount) {
            animationSlide = infinite ? slideCount : slideCount - 1;
            finalSlide = infinite ? 0 : slideCount - 1;
        } else if (animationSlide >= slideCount) {
            finalSlide = animationSlide - slideCount;
            if (!infinite) finalSlide = slideCount - slidesToShow;
            else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
        }
        if (!infinite && animationSlide + slidesToShow >= slideCount) finalSlide = slideCount - slidesToShow;
        animationLeft = $e3a0420005a1a536$export$e6afb656f970c8d4((0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, spec), {}, {
            slideIndex: animationSlide
        }));
        finalLeft = $e3a0420005a1a536$export$e6afb656f970c8d4((0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, spec), {}, {
            slideIndex: finalSlide
        }));
        if (!infinite) {
            if (animationLeft === finalLeft) animationSlide = finalSlide;
            animationLeft = finalLeft;
        }
        if (lazyLoad) lazyLoadedList = lazyLoadedList.concat($e3a0420005a1a536$export$62701ea96990f316((0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, spec), {}, {
            currentSlide: animationSlide
        })));
        if (!useCSS) state = {
            currentSlide: finalSlide,
            trackStyle: $e3a0420005a1a536$export$a56204438fe3ba9e((0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, spec), {}, {
                left: finalLeft
            })),
            lazyLoadedList: lazyLoadedList,
            targetSlide: targetSlide
        };
        else {
            state = {
                animating: true,
                currentSlide: finalSlide,
                trackStyle: $e3a0420005a1a536$export$529c0c74aae30645((0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, spec), {}, {
                    left: animationLeft
                })),
                lazyLoadedList: lazyLoadedList,
                targetSlide: targetSlide
            };
            nextState = {
                animating: false,
                currentSlide: finalSlide,
                trackStyle: $e3a0420005a1a536$export$a56204438fe3ba9e((0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, spec), {}, {
                    left: finalLeft
                })),
                swipeLeft: null,
                targetSlide: targetSlide
            };
        }
    }
    return {
        state: state,
        nextState: nextState
    };
};
var $e3a0420005a1a536$export$2b178751aa586095 = function changeSlide(spec, options) {
    var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
    var slidesToScroll = spec.slidesToScroll, slidesToShow = spec.slidesToShow, slideCount = spec.slideCount, currentSlide = spec.currentSlide, previousTargetSlide = spec.targetSlide, lazyLoad = spec.lazyLoad, infinite = spec.infinite;
    unevenOffset = slideCount % slidesToScroll !== 0;
    indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;
    if (options.message === "previous") {
        slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
        targetSlide = currentSlide - slideOffset;
        if (lazyLoad && !infinite) {
            previousInt = currentSlide - slideOffset;
            targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
        }
        if (!infinite) targetSlide = previousTargetSlide - slidesToScroll;
    } else if (options.message === "next") {
        slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
        targetSlide = currentSlide + slideOffset;
        if (lazyLoad && !infinite) targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
        if (!infinite) targetSlide = previousTargetSlide + slidesToScroll;
    } else if (options.message === "dots") // Click on dots
    targetSlide = options.index * options.slidesToScroll;
    else if (options.message === "children") {
        // Click on the slides
        targetSlide = options.index;
        if (infinite) {
            var direction = $e3a0420005a1a536$export$660692989fc3ca25((0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, spec), {}, {
                targetSlide: targetSlide
            }));
            if (targetSlide > options.currentSlide && direction === "left") targetSlide = targetSlide - slideCount;
            else if (targetSlide < options.currentSlide && direction === "right") targetSlide = targetSlide + slideCount;
        }
    } else if (options.message === "index") targetSlide = Number(options.index);
    return targetSlide;
};
var $e3a0420005a1a536$export$53be3f01be2e49ac = function keyHandler(e, accessibility, rtl) {
    if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
    if (e.keyCode === 37) return rtl ? "next" : "previous";
    if (e.keyCode === 39) return rtl ? "previous" : "next";
    return "";
};
var $e3a0420005a1a536$export$517240397a2d6b8e = function swipeStart(e, swipe, draggable) {
    e.target.tagName === "IMG" && $e3a0420005a1a536$export$ed7b1178205ba7d(e);
    if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
    return {
        dragging: true,
        touchObject: {
            startX: e.touches ? e.touches[0].pageX : e.clientX,
            startY: e.touches ? e.touches[0].pageY : e.clientY,
            curX: e.touches ? e.touches[0].pageX : e.clientX,
            curY: e.touches ? e.touches[0].pageY : e.clientY
        }
    };
};
var $e3a0420005a1a536$export$b6bbad7797799ea9 = function swipeMove(e, spec) {
    // spec also contains, trackRef and slideIndex
    var scrolling = spec.scrolling, animating = spec.animating, vertical = spec.vertical, swipeToSlide = spec.swipeToSlide, verticalSwiping = spec.verticalSwiping, rtl = spec.rtl, currentSlide = spec.currentSlide, edgeFriction = spec.edgeFriction, edgeDragged = spec.edgeDragged, onEdge = spec.onEdge, swiped = spec.swiped, swiping = spec.swiping, slideCount = spec.slideCount, slidesToScroll = spec.slidesToScroll, infinite = spec.infinite, touchObject = spec.touchObject, swipeEvent = spec.swipeEvent, listHeight = spec.listHeight, listWidth = spec.listWidth;
    if (scrolling) return;
    if (animating) return $e3a0420005a1a536$export$ed7b1178205ba7d(e);
    if (vertical && swipeToSlide && verticalSwiping) $e3a0420005a1a536$export$ed7b1178205ba7d(e);
    var swipeLeft, state = {};
    var curLeft = $e3a0420005a1a536$export$e6afb656f970c8d4(spec);
    touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
    touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
    touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
    var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
    if (!verticalSwiping && !swiping && verticalSwipeLength > 10) return {
        scrolling: true
    };
    if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
    var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
    if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
    var dotCount = Math.ceil(slideCount / slidesToScroll);
    var swipeDirection = $e3a0420005a1a536$export$67fc172604a155ba(spec.touchObject, verticalSwiping);
    var touchSwipeLength = touchObject.swipeLength;
    if (!infinite) {
        if (currentSlide === 0 && (swipeDirection === "right" || swipeDirection === "down") || currentSlide + 1 >= dotCount && (swipeDirection === "left" || swipeDirection === "up") || !$e3a0420005a1a536$export$30e977044f8f3618(spec) && (swipeDirection === "left" || swipeDirection === "up")) {
            touchSwipeLength = touchObject.swipeLength * edgeFriction;
            if (edgeDragged === false && onEdge) {
                onEdge(swipeDirection);
                state["edgeDragged"] = true;
            }
        }
    }
    if (!swiped && swipeEvent) {
        swipeEvent(swipeDirection);
        state["swiped"] = true;
    }
    if (!vertical) {
        if (!rtl) swipeLeft = curLeft + touchSwipeLength * positionOffset;
        else swipeLeft = curLeft - touchSwipeLength * positionOffset;
    } else swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
    if (verticalSwiping) swipeLeft = curLeft + touchSwipeLength * positionOffset;
    state = (0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, state), {}, {
        touchObject: touchObject,
        swipeLeft: swipeLeft,
        trackStyle: $e3a0420005a1a536$export$a56204438fe3ba9e((0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, spec), {}, {
            left: swipeLeft
        }))
    });
    if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) return state;
    if (touchObject.swipeLength > 10) {
        state["swiping"] = true;
        $e3a0420005a1a536$export$ed7b1178205ba7d(e);
    }
    return state;
};
var $e3a0420005a1a536$export$a1cf77dc3a4b9ee0 = function swipeEnd(e, spec) {
    var dragging = spec.dragging, swipe = spec.swipe, touchObject = spec.touchObject, listWidth = spec.listWidth, touchThreshold = spec.touchThreshold, verticalSwiping = spec.verticalSwiping, listHeight = spec.listHeight, swipeToSlide = spec.swipeToSlide, scrolling = spec.scrolling, onSwipe = spec.onSwipe, targetSlide = spec.targetSlide, currentSlide = spec.currentSlide, infinite = spec.infinite;
    if (!dragging) {
        if (swipe) $e3a0420005a1a536$export$ed7b1178205ba7d(e);
        return {};
    }
    var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
    var swipeDirection = $e3a0420005a1a536$export$67fc172604a155ba(touchObject, verticalSwiping);
    // reset the state of touch related state variables.
    var state = {
        dragging: false,
        edgeDragged: false,
        scrolling: false,
        swiping: false,
        swiped: false,
        swipeLeft: null,
        touchObject: {}
    };
    if (scrolling) return state;
    if (!touchObject.swipeLength) return state;
    if (touchObject.swipeLength > minSwipe) {
        $e3a0420005a1a536$export$ed7b1178205ba7d(e);
        if (onSwipe) onSwipe(swipeDirection);
        var slideCount, newSlide;
        var activeSlide = infinite ? currentSlide : targetSlide;
        switch(swipeDirection){
            case "left":
            case "up":
                newSlide = activeSlide + $e3a0420005a1a536$export$d5dbde6ad0a0e1f2(spec);
                slideCount = swipeToSlide ? $e3a0420005a1a536$export$17fa202e6fecedb5(spec, newSlide) : newSlide;
                state["currentDirection"] = 0;
                break;
            case "right":
            case "down":
                newSlide = activeSlide - $e3a0420005a1a536$export$d5dbde6ad0a0e1f2(spec);
                slideCount = swipeToSlide ? $e3a0420005a1a536$export$17fa202e6fecedb5(spec, newSlide) : newSlide;
                state["currentDirection"] = 1;
                break;
            default:
                slideCount = activeSlide;
        }
        state["triggerSlideHandler"] = slideCount;
    } else {
        // Adjust the track back to it's original position.
        var currentLeft = $e3a0420005a1a536$export$e6afb656f970c8d4(spec);
        state["trackStyle"] = $e3a0420005a1a536$export$529c0c74aae30645((0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, spec), {}, {
            left: currentLeft
        }));
    }
    return state;
};
var $e3a0420005a1a536$export$51be2376bcc08466 = function getNavigableIndexes(spec) {
    var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
    var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
    var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
    var indexes = [];
    while(breakpoint < max){
        indexes.push(breakpoint);
        breakpoint = counter + spec.slidesToScroll;
        counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
    }
    return indexes;
};
var $e3a0420005a1a536$export$17fa202e6fecedb5 = function checkNavigable(spec, index) {
    var navigables = $e3a0420005a1a536$export$51be2376bcc08466(spec);
    var prevNavigable = 0;
    if (index > navigables[navigables.length - 1]) index = navigables[navigables.length - 1];
    else for(var n in navigables){
        if (index < navigables[n]) {
            index = prevNavigable;
            break;
        }
        prevNavigable = navigables[n];
    }
    return index;
};
var $e3a0420005a1a536$export$d5dbde6ad0a0e1f2 = function getSlideCount(spec) {
    var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;
    if (spec.swipeToSlide) {
        var swipedSlide;
        var slickList = spec.listRef;
        var slides = slickList.querySelectorAll && slickList.querySelectorAll(".slick-slide") || [];
        Array.from(slides).every(function(slide) {
            if (!spec.vertical) {
                if (slide.offsetLeft - centerOffset + $e3a0420005a1a536$export$3c49c185de0c2bfc(slide) / 2 > spec.swipeLeft * -1) {
                    swipedSlide = slide;
                    return false;
                }
            } else if (slide.offsetTop + $e3a0420005a1a536$export$c08559766941f856(slide) / 2 > spec.swipeLeft * -1) {
                swipedSlide = slide;
                return false;
            }
            return true;
        });
        if (!swipedSlide) return 0;
        var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
        var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
        return slidesTraversed;
    } else return spec.slidesToScroll;
};
var $e3a0420005a1a536$export$86da4920db51899b = function checkSpecKeys(spec, keysArray) {
    return(// eslint-disable-next-line no-prototype-builtins
    keysArray.reduce(function(value, key) {
        return value && spec.hasOwnProperty(key);
    }, true) ? null : console.error("Keys Missing:", spec));
};
var $e3a0420005a1a536$export$a56204438fe3ba9e = function getTrackCSS(spec) {
    $e3a0420005a1a536$export$86da4920db51899b(spec, [
        "left",
        "variableWidth",
        "slideCount",
        "slidesToShow",
        "slideWidth"
    ]);
    var trackWidth, trackHeight;
    if (!spec.vertical) trackWidth = $e3a0420005a1a536$export$f865154a8ab21780(spec) * spec.slideWidth;
    else {
        var trackChildren = spec.unslick ? spec.slideCount : spec.slideCount + 2 * spec.slidesToShow;
        trackHeight = trackChildren * spec.slideHeight;
    }
    var style = {
        opacity: 1,
        transition: "",
        WebkitTransition: ""
    };
    if (spec.useTransform) {
        var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
        var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
        var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
        style = (0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, style), {}, {
            WebkitTransform: WebkitTransform,
            transform: transform,
            msTransform: msTransform
        });
    } else if (spec.vertical) style["top"] = spec.left;
    else style["left"] = spec.left;
    if (spec.fade) style = {
        opacity: 1
    };
    if (trackWidth) style.width = trackWidth;
    if (trackHeight) style.height = trackHeight;
    // Fallback for IE8
    if (window && !window.addEventListener && window.attachEvent) {
        if (!spec.vertical) style.marginLeft = spec.left + "px";
        else style.marginTop = spec.left + "px";
    }
    return style;
};
var $e3a0420005a1a536$export$529c0c74aae30645 = function getTrackAnimateCSS(spec) {
    $e3a0420005a1a536$export$86da4920db51899b(spec, [
        "left",
        "variableWidth",
        "slideCount",
        "slidesToShow",
        "slideWidth",
        "speed",
        "cssEase"
    ]);
    var style = $e3a0420005a1a536$export$a56204438fe3ba9e(spec);
    // useCSS is true by default so it can be undefined
    if (spec.useTransform) {
        style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
        style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
    } else if (spec.vertical) style.transition = "top " + spec.speed + "ms " + spec.cssEase;
    else style.transition = "left " + spec.speed + "ms " + spec.cssEase;
    return style;
};
var $e3a0420005a1a536$export$e6afb656f970c8d4 = function getTrackLeft(spec) {
    if (spec.unslick) return 0;
    $e3a0420005a1a536$export$86da4920db51899b(spec, [
        "slideIndex",
        "trackRef",
        "infinite",
        "centerMode",
        "slideCount",
        "slidesToShow",
        "slidesToScroll",
        "slideWidth",
        "listWidth",
        "variableWidth",
        "slideHeight"
    ]);
    var slideIndex = spec.slideIndex, trackRef = spec.trackRef, infinite = spec.infinite, centerMode = spec.centerMode, slideCount = spec.slideCount, slidesToShow = spec.slidesToShow, slidesToScroll = spec.slidesToScroll, slideWidth = spec.slideWidth, listWidth = spec.listWidth, variableWidth = spec.variableWidth, slideHeight = spec.slideHeight, fade = spec.fade, vertical = spec.vertical;
    var slideOffset = 0;
    var targetLeft;
    var targetSlide;
    var verticalOffset = 0;
    if (fade || spec.slideCount === 1) return 0;
    var slidesToOffset = 0;
    if (infinite) {
        slidesToOffset = -$e3a0420005a1a536$export$b7c426bbf733f421(spec); // bring active slide to the beginning of visual area
        // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children
        if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
        // shift current slide to center of the frame
        if (centerMode) slidesToOffset += parseInt(slidesToShow / 2);
    } else {
        if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) slidesToOffset = slidesToShow - slideCount % slidesToScroll;
        if (centerMode) slidesToOffset = parseInt(slidesToShow / 2);
    }
    slideOffset = slidesToOffset * slideWidth;
    verticalOffset = slidesToOffset * slideHeight;
    if (!vertical) targetLeft = slideIndex * slideWidth * -1 + slideOffset;
    else targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
    if (variableWidth === true) {
        var targetSlideIndex;
        var trackElem = trackRef && trackRef.node;
        targetSlideIndex = slideIndex + $e3a0420005a1a536$export$b7c426bbf733f421(spec);
        targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
        targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
        if (centerMode === true) {
            targetSlideIndex = infinite ? slideIndex + $e3a0420005a1a536$export$b7c426bbf733f421(spec) : slideIndex;
            targetSlide = trackElem && trackElem.children[targetSlideIndex];
            targetLeft = 0;
            for(var slide = 0; slide < targetSlideIndex; slide++)targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
            targetLeft -= parseInt(spec.centerPadding);
            targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
        }
    }
    return targetLeft;
};
var $e3a0420005a1a536$export$b7c426bbf733f421 = function getPreClones(spec) {
    if (spec.unslick || !spec.infinite) return 0;
    if (spec.variableWidth) return spec.slideCount;
    return spec.slidesToShow + (spec.centerMode ? 1 : 0);
};
var $e3a0420005a1a536$export$50a387a8fd3c60d = function getPostClones(spec) {
    if (spec.unslick || !spec.infinite) return 0;
    if (spec.variableWidth) return spec.slideCount;
    return spec.slidesToShow + (spec.centerMode ? 1 : 0);
};
var $e3a0420005a1a536$export$f865154a8ab21780 = function getTotalSlides(spec) {
    return spec.slideCount === 1 ? 1 : $e3a0420005a1a536$export$b7c426bbf733f421(spec) + spec.slideCount + $e3a0420005a1a536$export$50a387a8fd3c60d(spec);
};
var $e3a0420005a1a536$export$660692989fc3ca25 = function siblingDirection(spec) {
    if (spec.targetSlide > spec.currentSlide) {
        if (spec.targetSlide > spec.currentSlide + $e3a0420005a1a536$export$10cb311a34b9e55b(spec)) return "left";
        return "right";
    } else {
        if (spec.targetSlide < spec.currentSlide - $e3a0420005a1a536$export$56584c3df96565e5(spec)) return "right";
        return "left";
    }
};
var $e3a0420005a1a536$export$10cb311a34b9e55b = function slidesOnRight(_ref) {
    var slidesToShow = _ref.slidesToShow, centerMode = _ref.centerMode, rtl = _ref.rtl, centerPadding = _ref.centerPadding;
    // returns no of slides on the right of active slide
    if (centerMode) {
        var right = (slidesToShow - 1) / 2 + 1;
        if (parseInt(centerPadding) > 0) right += 1;
        if (rtl && slidesToShow % 2 === 0) right += 1;
        return right;
    }
    if (rtl) return 0;
    return slidesToShow - 1;
};
var $e3a0420005a1a536$export$56584c3df96565e5 = function slidesOnLeft(_ref2) {
    var slidesToShow = _ref2.slidesToShow, centerMode = _ref2.centerMode, rtl = _ref2.rtl, centerPadding = _ref2.centerPadding;
    // returns no of slides on the left of active slide
    if (centerMode) {
        var left = (slidesToShow - 1) / 2 + 1;
        if (parseInt(centerPadding) > 0) left += 1;
        if (!rtl && slidesToShow % 2 === 0) left += 1;
        return left;
    }
    if (rtl) return slidesToShow - 1;
    return 0;
};
var $e3a0420005a1a536$export$71594e8a50f746f4 = function canUseDOM() {
    return !!(typeof window !== "undefined" && window.document && window.document.createElement);
};
var $e3a0420005a1a536$export$dbd19fc785436235 = Object.keys((0, $4547f3e58e9675f5$export$2e2bcd8739ae039));
function $e3a0420005a1a536$export$b01d4e122f0895e5(settings) {
    return $e3a0420005a1a536$export$dbd19fc785436235.reduce(function(acc, settingName) {
        if (settings.hasOwnProperty(settingName)) acc[settingName] = settings[settingName];
        return acc;
    }, {});
}












var $cQmXV = parcelRequire("cQmXV");


"use strict";
function $aa77adab1a9284b1$var$_callSuper(t, o, e) {
    return o = (0, $5b4fe65c74408c52$export$2e2bcd8739ae039)(o), (0, $33c3c70a2b283b30$export$2e2bcd8739ae039)(t, (0, $5d696402a43f7962$export$2e2bcd8739ae039)() ? Reflect.construct(o, e || [], (0, $5b4fe65c74408c52$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
var $aa77adab1a9284b1$var$getSlideClasses = function getSlideClasses(spec) {
    var slickActive, slickCenter, slickCloned;
    var centerOffset, index;
    if (spec.rtl) index = spec.slideCount - 1 - spec.index;
    else index = spec.index;
    slickCloned = index < 0 || index >= spec.slideCount;
    if (spec.centerMode) {
        centerOffset = Math.floor(spec.slidesToShow / 2);
        slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
        if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) slickActive = true;
    } else slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
    var focusedSlide;
    if (spec.targetSlide < 0) focusedSlide = spec.targetSlide + spec.slideCount;
    else if (spec.targetSlide >= spec.slideCount) focusedSlide = spec.targetSlide - spec.slideCount;
    else focusedSlide = spec.targetSlide;
    var slickCurrent = index === focusedSlide;
    return {
        "slick-slide": true,
        "slick-active": slickActive,
        "slick-center": slickCenter,
        "slick-cloned": slickCloned,
        "slick-current": slickCurrent // dubious in case of RTL
    };
};
var $aa77adab1a9284b1$var$getSlideStyle = function getSlideStyle(spec) {
    var style = {};
    if (spec.variableWidth === undefined || spec.variableWidth === false) style.width = spec.slideWidth;
    if (spec.fade) {
        style.position = "relative";
        if (spec.vertical && spec.slideHeight) style.top = -spec.index * parseInt(spec.slideHeight);
        else style.left = -spec.index * parseInt(spec.slideWidth);
        style.opacity = spec.currentSlide === spec.index ? 1 : 0;
        style.zIndex = spec.currentSlide === spec.index ? 999 : 998;
        if (spec.useCSS) style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
    }
    return style;
};
var $aa77adab1a9284b1$var$getKey = function getKey(child, fallbackKey) {
    return child.key + "-" + fallbackKey;
};
var $aa77adab1a9284b1$var$renderSlides = function renderSlides(spec) {
    var key;
    var slides = [];
    var preCloneSlides = [];
    var postCloneSlides = [];
    var childrenCount = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Children.count(spec.children);
    var startIndex = (0, $e3a0420005a1a536$export$8931689ba1e6a542)(spec);
    var endIndex = (0, $e3a0420005a1a536$export$fc4e3e46621b5503)(spec);
    (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Children.forEach(spec.children, function(elem, index) {
        var child;
        var childOnClickOptions = {
            message: "children",
            index: index,
            slidesToScroll: spec.slidesToScroll,
            currentSlide: spec.currentSlide
        };
        // in case of lazyLoad, whether or not we want to fetch the slide
        if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) child = elem;
        else child = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", null);
        var childStyle = $aa77adab1a9284b1$var$getSlideStyle((0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, spec), {}, {
            index: index
        }));
        var slideClass = child.props.className || "";
        var slideClasses = $aa77adab1a9284b1$var$getSlideClasses((0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, spec), {}, {
            index: index
        }));
        // push a cloned element of the desired slide
        slides.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).cloneElement(child, {
            key: "original" + $aa77adab1a9284b1$var$getKey(child, index),
            "data-index": index,
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(slideClasses, slideClass),
            tabIndex: "-1",
            "aria-hidden": !slideClasses["slick-active"],
            style: (0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({
                outline: "none"
            }, child.props.style || {}), childStyle),
            onClick: function onClick(e) {
                child.props && child.props.onClick && child.props.onClick(e);
                if (spec.focusOnSelect) spec.focusOnSelect(childOnClickOptions);
            }
        }));
        // if slide needs to be precloned or postcloned
        if (spec.infinite && childrenCount > 1 && spec.fade === false && !spec.unslick) {
            var preCloneNo = childrenCount - index;
            if (preCloneNo <= (0, $e3a0420005a1a536$export$b7c426bbf733f421)(spec)) {
                key = -preCloneNo;
                if (key >= startIndex) child = elem;
                slideClasses = $aa77adab1a9284b1$var$getSlideClasses((0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, spec), {}, {
                    index: key
                }));
                preCloneSlides.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).cloneElement(child, {
                    key: "precloned" + $aa77adab1a9284b1$var$getKey(child, key),
                    "data-index": key,
                    tabIndex: "-1",
                    className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(slideClasses, slideClass),
                    "aria-hidden": !slideClasses["slick-active"],
                    style: (0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, child.props.style || {}), childStyle),
                    onClick: function onClick(e) {
                        child.props && child.props.onClick && child.props.onClick(e);
                        if (spec.focusOnSelect) spec.focusOnSelect(childOnClickOptions);
                    }
                }));
            }
            if (index < (0, $e3a0420005a1a536$export$50a387a8fd3c60d)(spec)) {
                key = childrenCount + index;
                if (key < endIndex) child = elem;
                slideClasses = $aa77adab1a9284b1$var$getSlideClasses((0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, spec), {}, {
                    index: key
                }));
                postCloneSlides.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).cloneElement(child, {
                    key: "postcloned" + $aa77adab1a9284b1$var$getKey(child, key),
                    "data-index": key,
                    tabIndex: "-1",
                    className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(slideClasses, slideClass),
                    "aria-hidden": !slideClasses["slick-active"],
                    style: (0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, child.props.style || {}), childStyle),
                    onClick: function onClick(e) {
                        child.props && child.props.onClick && child.props.onClick(e);
                        if (spec.focusOnSelect) spec.focusOnSelect(childOnClickOptions);
                    }
                }));
            }
        }
    });
    if (spec.rtl) return preCloneSlides.concat(slides, postCloneSlides).reverse();
    else return preCloneSlides.concat(slides, postCloneSlides);
};
var $aa77adab1a9284b1$export$13921ac0cc260818 = /*#__PURE__*/ function(_React$PureComponent) {
    function Track() {
        var _this;
        (0, $07be749aeca07699$export$2e2bcd8739ae039)(this, Track);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $aa77adab1a9284b1$var$_callSuper(this, Track, [].concat(args));
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(_this, "node", null);
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(_this, "handleRef", function(ref) {
            _this.node = ref;
        });
        return _this;
    }
    (0, $97a7799c9b277eb6$export$2e2bcd8739ae039)(Track, _React$PureComponent);
    return (0, $c180160353ceabc3$export$2e2bcd8739ae039)(Track, [
        {
            key: "render",
            value: function render() {
                var slides = $aa77adab1a9284b1$var$renderSlides(this.props);
                var _this$props = this.props, onMouseEnter = _this$props.onMouseEnter, onMouseOver = _this$props.onMouseOver, onMouseLeave = _this$props.onMouseLeave;
                var mouseEvents = {
                    onMouseEnter: onMouseEnter,
                    onMouseOver: onMouseOver,
                    onMouseLeave: onMouseLeave
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", (0, $e69a41570260c349$export$2e2bcd8739ae039)({
                    ref: this.handleRef,
                    className: "slick-track",
                    style: this.props.trackStyle
                }, mouseEvents), slides);
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).PureComponent);










var $cQmXV = parcelRequire("cQmXV");


"use strict";
function $2895032962937e24$var$_callSuper(t, o, e) {
    return o = (0, $5b4fe65c74408c52$export$2e2bcd8739ae039)(o), (0, $33c3c70a2b283b30$export$2e2bcd8739ae039)(t, (0, $5d696402a43f7962$export$2e2bcd8739ae039)() ? Reflect.construct(o, e || [], (0, $5b4fe65c74408c52$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
var $2895032962937e24$var$getDotCount = function getDotCount(spec) {
    var dots;
    if (spec.infinite) dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
    else dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
    return dots;
};
var $2895032962937e24$export$8da50d3722682be0 = /*#__PURE__*/ function(_React$PureComponent) {
    function Dots() {
        (0, $07be749aeca07699$export$2e2bcd8739ae039)(this, Dots);
        return $2895032962937e24$var$_callSuper(this, Dots, arguments);
    }
    (0, $97a7799c9b277eb6$export$2e2bcd8739ae039)(Dots, _React$PureComponent);
    return (0, $c180160353ceabc3$export$2e2bcd8739ae039)(Dots, [
        {
            key: "clickHandler",
            value: function clickHandler(options, e) {
                // In Autoplay the focus stays on clicked button even after transition
                // to next slide. That only goes away by click somewhere outside
                e.preventDefault();
                this.props.clickHandler(options);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, onMouseEnter = _this$props.onMouseEnter, onMouseOver = _this$props.onMouseOver, onMouseLeave = _this$props.onMouseLeave, infinite = _this$props.infinite, slidesToScroll = _this$props.slidesToScroll, slidesToShow = _this$props.slidesToShow, slideCount = _this$props.slideCount, currentSlide = _this$props.currentSlide;
                var dotCount = $2895032962937e24$var$getDotCount({
                    slideCount: slideCount,
                    slidesToScroll: slidesToScroll,
                    slidesToShow: slidesToShow,
                    infinite: infinite
                });
                var mouseEvents = {
                    onMouseEnter: onMouseEnter,
                    onMouseOver: onMouseOver,
                    onMouseLeave: onMouseLeave
                };
                var dots = [];
                for(var i = 0; i < dotCount; i++){
                    var _rightBound = (i + 1) * slidesToScroll - 1;
                    var rightBound = infinite ? _rightBound : (0, $e3a0420005a1a536$export$7d15b64cf5a3a4c4)(_rightBound, 0, slideCount - 1);
                    var _leftBound = rightBound - (slidesToScroll - 1);
                    var leftBound = infinite ? _leftBound : (0, $e3a0420005a1a536$export$7d15b64cf5a3a4c4)(_leftBound, 0, slideCount - 1);
                    var className = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)({
                        "slick-active": infinite ? currentSlide >= leftBound && currentSlide <= rightBound : currentSlide === leftBound
                    });
                    var dotOptions = {
                        message: "dots",
                        index: i,
                        slidesToScroll: slidesToScroll,
                        currentSlide: currentSlide
                    };
                    var onClick = this.clickHandler.bind(this, dotOptions);
                    dots = dots.concat(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("li", {
                        key: i,
                        className: className
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).cloneElement(this.props.customPaging(i), {
                        onClick: onClick
                    })));
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).cloneElement(this.props.appendDots(dots), (0, $f163cd56d32104d1$export$2e2bcd8739ae039)({
                    className: this.props.dotsClass
                }, mouseEvents));
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).PureComponent);











var $cQmXV = parcelRequire("cQmXV");


"use strict";
function $e42ceb7465446e94$var$_callSuper(t, o, e) {
    return o = (0, $5b4fe65c74408c52$export$2e2bcd8739ae039)(o), (0, $33c3c70a2b283b30$export$2e2bcd8739ae039)(t, (0, $5d696402a43f7962$export$2e2bcd8739ae039)() ? Reflect.construct(o, e || [], (0, $5b4fe65c74408c52$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
var $e42ceb7465446e94$export$9c1f62bf9cbb344b = /*#__PURE__*/ function(_React$PureComponent) {
    function PrevArrow() {
        (0, $07be749aeca07699$export$2e2bcd8739ae039)(this, PrevArrow);
        return $e42ceb7465446e94$var$_callSuper(this, PrevArrow, arguments);
    }
    (0, $97a7799c9b277eb6$export$2e2bcd8739ae039)(PrevArrow, _React$PureComponent);
    return (0, $c180160353ceabc3$export$2e2bcd8739ae039)(PrevArrow, [
        {
            key: "clickHandler",
            value: function clickHandler(options, e) {
                if (e) e.preventDefault();
                this.props.clickHandler(options, e);
            }
        },
        {
            key: "render",
            value: function render() {
                var prevClasses = {
                    "slick-arrow": true,
                    "slick-prev": true
                };
                var prevHandler = this.clickHandler.bind(this, {
                    message: "previous"
                });
                if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
                    prevClasses["slick-disabled"] = true;
                    prevHandler = null;
                }
                var prevArrowProps = {
                    key: "0",
                    "data-role": "none",
                    className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prevClasses),
                    style: {
                        display: "block"
                    },
                    onClick: prevHandler
                };
                var customProps = {
                    currentSlide: this.props.currentSlide,
                    slideCount: this.props.slideCount
                };
                var prevArrow;
                if (this.props.prevArrow) prevArrow = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).cloneElement(this.props.prevArrow, (0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, prevArrowProps), customProps));
                else prevArrow = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("button", (0, $e69a41570260c349$export$2e2bcd8739ae039)({
                    key: "0",
                    type: "button"
                }, prevArrowProps), " ", "Previous");
                return prevArrow;
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).PureComponent);
var $e42ceb7465446e94$export$40405f1f48d6dbd = /*#__PURE__*/ function(_React$PureComponent2) {
    function NextArrow() {
        (0, $07be749aeca07699$export$2e2bcd8739ae039)(this, NextArrow);
        return $e42ceb7465446e94$var$_callSuper(this, NextArrow, arguments);
    }
    (0, $97a7799c9b277eb6$export$2e2bcd8739ae039)(NextArrow, _React$PureComponent2);
    return (0, $c180160353ceabc3$export$2e2bcd8739ae039)(NextArrow, [
        {
            key: "clickHandler",
            value: function clickHandler(options, e) {
                if (e) e.preventDefault();
                this.props.clickHandler(options, e);
            }
        },
        {
            key: "render",
            value: function render() {
                var nextClasses = {
                    "slick-arrow": true,
                    "slick-next": true
                };
                var nextHandler = this.clickHandler.bind(this, {
                    message: "next"
                });
                if (!(0, $e3a0420005a1a536$export$30e977044f8f3618)(this.props)) {
                    nextClasses["slick-disabled"] = true;
                    nextHandler = null;
                }
                var nextArrowProps = {
                    key: "1",
                    "data-role": "none",
                    className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(nextClasses),
                    style: {
                        display: "block"
                    },
                    onClick: nextHandler
                };
                var customProps = {
                    currentSlide: this.props.currentSlide,
                    slideCount: this.props.slideCount
                };
                var nextArrow;
                if (this.props.nextArrow) nextArrow = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).cloneElement(this.props.nextArrow, (0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, nextArrowProps), customProps));
                else nextArrow = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("button", (0, $e69a41570260c349$export$2e2bcd8739ae039)({
                    key: "1",
                    type: "button"
                }, nextArrowProps), " ", "Next");
                return nextArrow;
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).PureComponent);


"use strict";
var $6b4ac0da403cd40d$var$_excluded = [
    "animating"
];
function $6b4ac0da403cd40d$var$_callSuper(t, o, e) {
    return o = (0, $5b4fe65c74408c52$export$2e2bcd8739ae039)(o), (0, $33c3c70a2b283b30$export$2e2bcd8739ae039)(t, (0, $5d696402a43f7962$export$2e2bcd8739ae039)() ? Reflect.construct(o, e || [], (0, $5b4fe65c74408c52$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
var $6b4ac0da403cd40d$export$14a303763f47951d = /*#__PURE__*/ function(_React$Component) {
    function InnerSlider(props) {
        var _this;
        (0, $07be749aeca07699$export$2e2bcd8739ae039)(this, InnerSlider);
        _this = $6b4ac0da403cd40d$var$_callSuper(this, InnerSlider, [
            props
        ]);
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(_this, "listRefHandler", function(ref) {
            return _this.list = ref;
        });
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(_this, "trackRefHandler", function(ref) {
            return _this.track = ref;
        });
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(_this, "adaptHeight", function() {
            if (_this.props.adaptiveHeight && _this.list) {
                var elem = _this.list.querySelector('[data-index="'.concat(_this.state.currentSlide, '"]'));
                _this.list.style.height = (0, $e3a0420005a1a536$export$c08559766941f856)(elem) + "px";
            }
        });
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(_this, "componentDidMount", function() {
            _this.props.onInit && _this.props.onInit();
            if (_this.props.lazyLoad) {
                var slidesToLoad = (0, $e3a0420005a1a536$export$62701ea96990f316)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, _this.props), _this.state));
                if (slidesToLoad.length > 0) {
                    _this.setState(function(prevState) {
                        return {
                            lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
                        };
                    });
                    if (_this.props.onLazyLoad) _this.props.onLazyLoad(slidesToLoad);
                }
            }
            var spec = (0, $f163cd56d32104d1$export$2e2bcd8739ae039)({
                listRef: _this.list,
                trackRef: _this.track
            }, _this.props);
            _this.updateState(spec, true, function() {
                _this.adaptHeight();
                _this.props.autoplay && _this.autoPlay("playing");
            });
            if (_this.props.lazyLoad === "progressive") _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
            if (typeof ResizeObserver !== "undefined") {
                _this.ro = new ResizeObserver(function() {
                    if (_this.state.animating) {
                        _this.onWindowResized(false); // don't set trackStyle hence don't break animation
                        _this.callbackTimers.push(setTimeout(function() {
                            return _this.onWindowResized();
                        }, _this.props.speed));
                    } else _this.onWindowResized();
                });
                _this.ro.observe(_this.list);
            }
            document.querySelectorAll && Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function(slide) {
                slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
                slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
            });
            if (window.addEventListener) window.addEventListener("resize", _this.onWindowResized);
            else window.attachEvent("onresize", _this.onWindowResized);
        });
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(_this, "componentWillUnmount", function() {
            var _this$ro;
            if (_this.animationEndCallback) clearTimeout(_this.animationEndCallback);
            if (_this.lazyLoadTimer) clearInterval(_this.lazyLoadTimer);
            if (_this.callbackTimers.length) {
                _this.callbackTimers.forEach(function(timer) {
                    return clearTimeout(timer);
                });
                _this.callbackTimers = [];
            }
            if (window.addEventListener) window.removeEventListener("resize", _this.onWindowResized);
            else window.detachEvent("onresize", _this.onWindowResized);
            if (_this.autoplayTimer) clearInterval(_this.autoplayTimer);
            (_this$ro = _this.ro) === null || _this$ro === void 0 || _this$ro.disconnect();
        });
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(_this, "componentDidUpdate", function(prevProps) {
            _this.checkImagesLoad();
            _this.props.onReInit && _this.props.onReInit();
            if (_this.props.lazyLoad) {
                var slidesToLoad = (0, $e3a0420005a1a536$export$62701ea96990f316)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, _this.props), _this.state));
                if (slidesToLoad.length > 0) {
                    _this.setState(function(prevState) {
                        return {
                            lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
                        };
                    });
                    if (_this.props.onLazyLoad) _this.props.onLazyLoad(slidesToLoad);
                }
            }
            // if (this.props.onLazyLoad) {
            //   this.props.onLazyLoad([leftMostSlide])
            // }
            _this.adaptHeight();
            var spec = (0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({
                listRef: _this.list,
                trackRef: _this.track
            }, _this.props), _this.state);
            var setTrackStyle = _this.didPropsChange(prevProps);
            setTrackStyle && _this.updateState(spec, setTrackStyle, function() {
                if (_this.state.currentSlide >= (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Children.count(_this.props.children)) _this.changeSlide({
                    message: "index",
                    index: (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Children.count(_this.props.children) - _this.props.slidesToShow,
                    currentSlide: _this.state.currentSlide
                });
                if (prevProps.autoplay !== _this.props.autoplay || prevProps.autoplaySpeed !== _this.props.autoplaySpeed) {
                    if (!prevProps.autoplay && _this.props.autoplay) _this.autoPlay("playing");
                    else if (_this.props.autoplay) _this.autoPlay("update");
                    else _this.pause("paused");
                }
            });
        });
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(_this, "onWindowResized", function(setTrackStyle) {
            if (_this.debouncedResize) _this.debouncedResize.cancel();
            _this.debouncedResize = (0, $ac11bb2a597bd9e1$export$61fc7d43ac8f84b0)(50, function() {
                return _this.resizeWindow(setTrackStyle);
            });
            _this.debouncedResize();
        });
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(_this, "resizeWindow", function() {
            var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            var isTrackMounted = Boolean(_this.track && _this.track.node);
            // prevent warning: setting state on unmounted component (server side rendering)
            if (!isTrackMounted) return;
            var spec = (0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({
                listRef: _this.list,
                trackRef: _this.track
            }, _this.props), _this.state);
            _this.updateState(spec, setTrackStyle, function() {
                if (_this.props.autoplay) _this.autoPlay("update");
                else _this.pause("paused");
            });
            // animating state should be cleared while resizing, otherwise autoplay stops working
            _this.setState({
                animating: false
            });
            clearTimeout(_this.animationEndCallback);
            delete _this.animationEndCallback;
        });
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(_this, "updateState", function(spec, setTrackStyle, callback) {
            var updatedState = (0, $e3a0420005a1a536$export$446226dbc576c3ab)(spec);
            spec = (0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, spec), updatedState), {}, {
                slideIndex: updatedState.currentSlide
            });
            var targetLeft = (0, $e3a0420005a1a536$export$e6afb656f970c8d4)(spec);
            spec = (0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, spec), {}, {
                left: targetLeft
            });
            var trackStyle = (0, $e3a0420005a1a536$export$a56204438fe3ba9e)(spec);
            if (setTrackStyle || (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Children.count(_this.props.children) !== (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Children.count(spec.children)) updatedState["trackStyle"] = trackStyle;
            _this.setState(updatedState, callback);
        });
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(_this, "ssrInit", function() {
            if (_this.props.variableWidth) {
                var _trackWidth = 0, _trackLeft = 0;
                var childrenWidths = [];
                var preClones = (0, $e3a0420005a1a536$export$b7c426bbf733f421)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, _this.props), _this.state), {}, {
                    slideCount: _this.props.children.length
                }));
                var postClones = (0, $e3a0420005a1a536$export$50a387a8fd3c60d)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, _this.props), _this.state), {}, {
                    slideCount: _this.props.children.length
                }));
                _this.props.children.forEach(function(child) {
                    childrenWidths.push(child.props.style.width);
                    _trackWidth += child.props.style.width;
                });
                for(var i = 0; i < preClones; i++){
                    _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
                    _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
                }
                for(var _i = 0; _i < postClones; _i++)_trackWidth += childrenWidths[_i];
                for(var _i2 = 0; _i2 < _this.state.currentSlide; _i2++)_trackLeft += childrenWidths[_i2];
                var _trackStyle = {
                    width: _trackWidth + "px",
                    left: -_trackLeft + "px"
                };
                if (_this.props.centerMode) {
                    var currentWidth = "".concat(childrenWidths[_this.state.currentSlide], "px");
                    _trackStyle.left = "calc(".concat(_trackStyle.left, " + (100% - ").concat(currentWidth, ") / 2 ) ");
                }
                return {
                    trackStyle: _trackStyle
                };
            }
            var childrenCount = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Children.count(_this.props.children);
            var spec = (0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, _this.props), _this.state), {}, {
                slideCount: childrenCount
            });
            var slideCount = (0, $e3a0420005a1a536$export$b7c426bbf733f421)(spec) + (0, $e3a0420005a1a536$export$50a387a8fd3c60d)(spec) + childrenCount;
            var trackWidth = 100 / _this.props.slidesToShow * slideCount;
            var slideWidth = 100 / slideCount;
            var trackLeft = -slideWidth * ((0, $e3a0420005a1a536$export$b7c426bbf733f421)(spec) + _this.state.currentSlide) * trackWidth / 100;
            if (_this.props.centerMode) trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
            var trackStyle = {
                width: trackWidth + "%",
                left: trackLeft + "%"
            };
            return {
                slideWidth: slideWidth + "%",
                trackStyle: trackStyle
            };
        });
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(_this, "checkImagesLoad", function() {
            var images = _this.list && _this.list.querySelectorAll && _this.list.querySelectorAll(".slick-slide img") || [];
            var imagesCount = images.length, loadedCount = 0;
            Array.prototype.forEach.call(images, function(image) {
                var handler = function handler() {
                    return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
                };
                if (!image.onclick) image.onclick = function() {
                    return image.parentNode.focus();
                };
                else {
                    var prevClickHandler = image.onclick;
                    image.onclick = function(e) {
                        prevClickHandler(e);
                        image.parentNode.focus();
                    };
                }
                if (!image.onload) {
                    if (_this.props.lazyLoad) image.onload = function() {
                        _this.adaptHeight();
                        _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
                    };
                    else {
                        image.onload = handler;
                        image.onerror = function() {
                            handler();
                            _this.props.onLazyLoadError && _this.props.onLazyLoadError();
                        };
                    }
                }
            });
        });
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(_this, "progressiveLazyLoad", function() {
            var slidesToLoad = [];
            var spec = (0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, _this.props), _this.state);
            for(var index = _this.state.currentSlide; index < _this.state.slideCount + (0, $e3a0420005a1a536$export$50a387a8fd3c60d)(spec); index++)if (_this.state.lazyLoadedList.indexOf(index) < 0) {
                slidesToLoad.push(index);
                break;
            }
            for(var _index = _this.state.currentSlide - 1; _index >= -(0, $e3a0420005a1a536$export$b7c426bbf733f421)(spec); _index--)if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
                slidesToLoad.push(_index);
                break;
            }
            if (slidesToLoad.length > 0) {
                _this.setState(function(state) {
                    return {
                        lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
                    };
                });
                if (_this.props.onLazyLoad) _this.props.onLazyLoad(slidesToLoad);
            } else if (_this.lazyLoadTimer) {
                clearInterval(_this.lazyLoadTimer);
                delete _this.lazyLoadTimer;
            }
        });
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(_this, "slideHandler", function(index) {
            var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var _this$props = _this.props, asNavFor = _this$props.asNavFor, beforeChange = _this$props.beforeChange, onLazyLoad = _this$props.onLazyLoad, speed = _this$props.speed, afterChange = _this$props.afterChange;
            // capture currentslide before state is updated
            var currentSlide = _this.state.currentSlide;
            var _slideHandler = (0, $e3a0420005a1a536$export$961f912fd58954b)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({
                index: index
            }, _this.props), _this.state), {}, {
                trackRef: _this.track,
                useCSS: _this.props.useCSS && !dontAnimate
            })), state = _slideHandler.state, nextState = _slideHandler.nextState;
            if (!state) return;
            beforeChange && beforeChange(currentSlide, state.currentSlide);
            var slidesToLoad = state.lazyLoadedList.filter(function(value) {
                return _this.state.lazyLoadedList.indexOf(value) < 0;
            });
            onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);
            if (!_this.props.waitForAnimate && _this.animationEndCallback) {
                clearTimeout(_this.animationEndCallback);
                afterChange && afterChange(currentSlide);
                delete _this.animationEndCallback;
            }
            _this.setState(state, function() {
                // asNavForIndex check is to avoid recursive calls of slideHandler in waitForAnimate=false mode
                if (asNavFor && _this.asNavForIndex !== index) {
                    _this.asNavForIndex = index;
                    asNavFor.innerSlider.slideHandler(index);
                }
                if (!nextState) return;
                _this.animationEndCallback = setTimeout(function() {
                    var animating = nextState.animating, firstBatch = (0, $89c7ad5d109a1176$export$2e2bcd8739ae039)(nextState, $6b4ac0da403cd40d$var$_excluded);
                    _this.setState(firstBatch, function() {
                        _this.callbackTimers.push(setTimeout(function() {
                            return _this.setState({
                                animating: animating
                            });
                        }, 10));
                        afterChange && afterChange(state.currentSlide);
                        delete _this.animationEndCallback;
                    });
                }, speed);
            });
        });
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(_this, "changeSlide", function(options) {
            var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var spec = (0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, _this.props), _this.state);
            var targetSlide = (0, $e3a0420005a1a536$export$2b178751aa586095)(spec, options);
            if (targetSlide !== 0 && !targetSlide) return;
            if (dontAnimate === true) _this.slideHandler(targetSlide, dontAnimate);
            else _this.slideHandler(targetSlide);
            _this.props.autoplay && _this.autoPlay("update");
            if (_this.props.focusOnSelect) {
                var nodes = _this.list.querySelectorAll(".slick-current");
                nodes[0] && nodes[0].focus();
            }
        });
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(_this, "clickHandler", function(e) {
            if (_this.clickable === false) {
                e.stopPropagation();
                e.preventDefault();
            }
            _this.clickable = true;
        });
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(_this, "keyHandler", function(e) {
            var dir = (0, $e3a0420005a1a536$export$53be3f01be2e49ac)(e, _this.props.accessibility, _this.props.rtl);
            dir !== "" && _this.changeSlide({
                message: dir
            });
        });
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(_this, "selectHandler", function(options) {
            _this.changeSlide(options);
        });
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(_this, "disableBodyScroll", function() {
            var preventDefault = function preventDefault(e) {
                e = e || window.event;
                if (e.preventDefault) e.preventDefault();
                e.returnValue = false;
            };
            window.ontouchmove = preventDefault;
        });
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(_this, "enableBodyScroll", function() {
            window.ontouchmove = null;
        });
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(_this, "swipeStart", function(e) {
            if (_this.props.verticalSwiping) _this.disableBodyScroll();
            var state = (0, $e3a0420005a1a536$export$517240397a2d6b8e)(e, _this.props.swipe, _this.props.draggable);
            state !== "" && _this.setState(state);
        });
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(_this, "swipeMove", function(e) {
            var state = (0, $e3a0420005a1a536$export$b6bbad7797799ea9)(e, (0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, _this.props), _this.state), {}, {
                trackRef: _this.track,
                listRef: _this.list,
                slideIndex: _this.state.currentSlide
            }));
            if (!state) return;
            if (state["swiping"]) _this.clickable = false;
            _this.setState(state);
        });
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(_this, "swipeEnd", function(e) {
            var state = (0, $e3a0420005a1a536$export$a1cf77dc3a4b9ee0)(e, (0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, _this.props), _this.state), {}, {
                trackRef: _this.track,
                listRef: _this.list,
                slideIndex: _this.state.currentSlide
            }));
            if (!state) return;
            var triggerSlideHandler = state["triggerSlideHandler"];
            delete state["triggerSlideHandler"];
            _this.setState(state);
            if (triggerSlideHandler === undefined) return;
            _this.slideHandler(triggerSlideHandler);
            if (_this.props.verticalSwiping) _this.enableBodyScroll();
        });
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(_this, "touchEnd", function(e) {
            _this.swipeEnd(e);
            _this.clickable = true;
        });
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(_this, "slickPrev", function() {
            // this and fellow methods are wrapped in setTimeout
            // to make sure initialize setState has happened before
            // any of such methods are called
            _this.callbackTimers.push(setTimeout(function() {
                return _this.changeSlide({
                    message: "previous"
                });
            }, 0));
        });
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(_this, "slickNext", function() {
            _this.callbackTimers.push(setTimeout(function() {
                return _this.changeSlide({
                    message: "next"
                });
            }, 0));
        });
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(_this, "slickGoTo", function(slide) {
            var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            slide = Number(slide);
            if (isNaN(slide)) return "";
            _this.callbackTimers.push(setTimeout(function() {
                return _this.changeSlide({
                    message: "index",
                    index: slide,
                    currentSlide: _this.state.currentSlide
                }, dontAnimate);
            }, 0));
        });
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(_this, "play", function() {
            var nextIndex;
            if (_this.props.rtl) nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
            else {
                if ((0, $e3a0420005a1a536$export$30e977044f8f3618)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, _this.props), _this.state))) nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
                else return false;
            }
            _this.slideHandler(nextIndex);
        });
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(_this, "autoPlay", function(playType) {
            if (_this.autoplayTimer) clearInterval(_this.autoplayTimer);
            var autoplaying = _this.state.autoplaying;
            if (playType === "update") {
                if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") return;
            } else if (playType === "leave") {
                if (autoplaying === "paused" || autoplaying === "focused") return;
            } else if (playType === "blur") {
                if (autoplaying === "paused" || autoplaying === "hovered") return;
            }
            _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);
            _this.setState({
                autoplaying: "playing"
            });
        });
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(_this, "pause", function(pauseType) {
            if (_this.autoplayTimer) {
                clearInterval(_this.autoplayTimer);
                _this.autoplayTimer = null;
            }
            var autoplaying = _this.state.autoplaying;
            if (pauseType === "paused") _this.setState({
                autoplaying: "paused"
            });
            else if (pauseType === "focused") {
                if (autoplaying === "hovered" || autoplaying === "playing") _this.setState({
                    autoplaying: "focused"
                });
            } else // pauseType  is 'hovered'
            if (autoplaying === "playing") _this.setState({
                autoplaying: "hovered"
            });
        });
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(_this, "onDotsOver", function() {
            return _this.props.autoplay && _this.pause("hovered");
        });
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(_this, "onDotsLeave", function() {
            return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
        });
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(_this, "onTrackOver", function() {
            return _this.props.autoplay && _this.pause("hovered");
        });
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(_this, "onTrackLeave", function() {
            return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
        });
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(_this, "onSlideFocus", function() {
            return _this.props.autoplay && _this.pause("focused");
        });
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(_this, "onSlideBlur", function() {
            return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
        });
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(_this, "render", function() {
            var className = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)("slick-slider", _this.props.className, {
                "slick-vertical": _this.props.vertical,
                "slick-initialized": true
            });
            var spec = (0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, _this.props), _this.state);
            var trackProps = (0, $e3a0420005a1a536$export$e9dd1a4ab6b7c5b0)(spec, [
                "fade",
                "cssEase",
                "speed",
                "infinite",
                "centerMode",
                "focusOnSelect",
                "currentSlide",
                "lazyLoad",
                "lazyLoadedList",
                "rtl",
                "slideWidth",
                "slideHeight",
                "listHeight",
                "vertical",
                "slidesToShow",
                "slidesToScroll",
                "slideCount",
                "trackStyle",
                "variableWidth",
                "unslick",
                "centerPadding",
                "targetSlide",
                "useCSS"
            ]);
            var pauseOnHover = _this.props.pauseOnHover;
            trackProps = (0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, trackProps), {}, {
                onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
                onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
                onMouseOver: pauseOnHover ? _this.onTrackOver : null,
                focusOnSelect: _this.props.focusOnSelect && _this.clickable ? _this.selectHandler : null
            });
            var dots;
            if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
                var dotProps = (0, $e3a0420005a1a536$export$e9dd1a4ab6b7c5b0)(spec, [
                    "dotsClass",
                    "slideCount",
                    "slidesToShow",
                    "currentSlide",
                    "slidesToScroll",
                    "clickHandler",
                    "children",
                    "customPaging",
                    "infinite",
                    "appendDots"
                ]);
                var pauseOnDotsHover = _this.props.pauseOnDotsHover;
                dotProps = (0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, dotProps), {}, {
                    clickHandler: _this.changeSlide,
                    onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
                    onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
                    onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
                });
                dots = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $2895032962937e24$export$8da50d3722682be0), dotProps);
            }
            var prevArrow, nextArrow;
            var arrowProps = (0, $e3a0420005a1a536$export$e9dd1a4ab6b7c5b0)(spec, [
                "infinite",
                "centerMode",
                "currentSlide",
                "slideCount",
                "slidesToShow",
                "prevArrow",
                "nextArrow"
            ]);
            arrowProps.clickHandler = _this.changeSlide;
            if (_this.props.arrows) {
                prevArrow = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $e42ceb7465446e94$export$9c1f62bf9cbb344b), arrowProps);
                nextArrow = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $e42ceb7465446e94$export$40405f1f48d6dbd), arrowProps);
            }
            var verticalHeightStyle = null;
            if (_this.props.vertical) verticalHeightStyle = {
                height: _this.state.listHeight
            };
            var centerPaddingStyle = null;
            if (_this.props.vertical === false) {
                if (_this.props.centerMode === true) centerPaddingStyle = {
                    padding: "0px " + _this.props.centerPadding
                };
            } else if (_this.props.centerMode === true) centerPaddingStyle = {
                padding: _this.props.centerPadding + " 0px"
            };
            var listStyle = (0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, verticalHeightStyle), centerPaddingStyle);
            var touchMove = _this.props.touchMove;
            var listProps = {
                className: "slick-list",
                style: listStyle,
                onClick: _this.clickHandler,
                onMouseDown: touchMove ? _this.swipeStart : null,
                onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
                onMouseUp: touchMove ? _this.swipeEnd : null,
                onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
                onTouchStart: touchMove ? _this.swipeStart : null,
                onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
                onTouchEnd: touchMove ? _this.touchEnd : null,
                onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
                onKeyDown: _this.props.accessibility ? _this.keyHandler : null
            };
            var innerSliderProps = {
                className: className,
                dir: "ltr",
                style: _this.props.style
            };
            if (_this.props.unslick) {
                listProps = {
                    className: "slick-list"
                };
                innerSliderProps = {
                    className: className,
                    style: _this.props.style
                };
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", innerSliderProps, !_this.props.unslick ? prevArrow : "", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", (0, $e69a41570260c349$export$2e2bcd8739ae039)({
                ref: _this.listRefHandler
            }, listProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $aa77adab1a9284b1$export$13921ac0cc260818), (0, $e69a41570260c349$export$2e2bcd8739ae039)({
                ref: _this.trackRefHandler
            }, trackProps), _this.props.children)), !_this.props.unslick ? nextArrow : "", !_this.props.unslick ? dots : "");
        });
        _this.list = null;
        _this.track = null;
        _this.state = (0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, (0, $13e9780397f098d5$export$2e2bcd8739ae039)), {}, {
            currentSlide: _this.props.initialSlide,
            targetSlide: _this.props.initialSlide ? _this.props.initialSlide : 0,
            slideCount: (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Children.count(_this.props.children)
        });
        _this.callbackTimers = [];
        _this.clickable = true;
        _this.debouncedResize = null;
        var ssrState = _this.ssrInit();
        _this.state = (0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, _this.state), ssrState);
        return _this;
    }
    (0, $97a7799c9b277eb6$export$2e2bcd8739ae039)(InnerSlider, _React$Component);
    return (0, $c180160353ceabc3$export$2e2bcd8739ae039)(InnerSlider, [
        {
            key: "didPropsChange",
            value: function didPropsChange(prevProps) {
                var setTrackStyle = false;
                for(var _i3 = 0, _Object$keys = Object.keys(this.props); _i3 < _Object$keys.length; _i3++){
                    var key = _Object$keys[_i3];
                    // eslint-disable-next-line no-prototype-builtins
                    if (!prevProps.hasOwnProperty(key)) {
                        setTrackStyle = true;
                        break;
                    }
                    if ((0, $ccb28fa1a7ecc481$export$2e2bcd8739ae039)(prevProps[key]) === "object" || typeof prevProps[key] === "function" || isNaN(prevProps[key])) continue;
                    if (prevProps[key] !== this.props[key]) {
                        setTrackStyle = true;
                        break;
                    }
                }
                return setTrackStyle || (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Children.count(this.props.children) !== (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Children.count(prevProps.children);
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Component);


var $7cf1f0fa01ebe79d$exports = {};
var $3e440f239a7aabfb$exports = {};
var $3e440f239a7aabfb$var$camel2hyphen = function(str) {
    return str.replace(/[A-Z]/g, function(match) {
        return "-" + match.toLowerCase();
    }).toLowerCase();
};
$3e440f239a7aabfb$exports = $3e440f239a7aabfb$var$camel2hyphen;


var $7cf1f0fa01ebe79d$var$isDimension = function(feature) {
    var re = /[height|width]$/;
    return re.test(feature);
};
var $7cf1f0fa01ebe79d$var$obj2mq = function(obj) {
    var mq = "";
    var features = Object.keys(obj);
    features.forEach(function(feature, index) {
        var value = obj[feature];
        feature = $3e440f239a7aabfb$exports(feature);
        // Add px to dimension features
        if ($7cf1f0fa01ebe79d$var$isDimension(feature) && typeof value === "number") value = value + "px";
        if (value === true) mq += feature;
        else if (value === false) mq += "not " + feature;
        else mq += "(" + feature + ": " + value + ")";
        if (index < features.length - 1) mq += " and ";
    });
    return mq;
};
var $7cf1f0fa01ebe79d$var$json2mq = function(query) {
    var mq = "";
    if (typeof query === "string") return query;
    // Handling array of media queries
    if (query instanceof Array) {
        query.forEach(function(q, index) {
            mq += $7cf1f0fa01ebe79d$var$obj2mq(q);
            if (index < query.length - 1) mq += ", ";
        });
        return mq;
    }
    // Handling single media query
    return $7cf1f0fa01ebe79d$var$obj2mq(query);
};
$7cf1f0fa01ebe79d$exports = $7cf1f0fa01ebe79d$var$json2mq;




"use strict";
function $e3e702cb0d064b20$var$_callSuper(t, o, e) {
    return o = (0, $5b4fe65c74408c52$export$2e2bcd8739ae039)(o), (0, $33c3c70a2b283b30$export$2e2bcd8739ae039)(t, (0, $5d696402a43f7962$export$2e2bcd8739ae039)() ? Reflect.construct(o, e || [], (0, $5b4fe65c74408c52$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
var $e3e702cb0d064b20$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    function Slider(props) {
        var _this;
        (0, $07be749aeca07699$export$2e2bcd8739ae039)(this, Slider);
        _this = $e3e702cb0d064b20$var$_callSuper(this, Slider, [
            props
        ]);
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(_this, "innerSliderRefHandler", function(ref) {
            return _this.innerSlider = ref;
        });
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(_this, "slickPrev", function() {
            return _this.innerSlider.slickPrev();
        });
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(_this, "slickNext", function() {
            return _this.innerSlider.slickNext();
        });
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(_this, "slickGoTo", function(slide) {
            var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            return _this.innerSlider.slickGoTo(slide, dontAnimate);
        });
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(_this, "slickPause", function() {
            return _this.innerSlider.pause("paused");
        });
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(_this, "slickPlay", function() {
            return _this.innerSlider.autoPlay("play");
        });
        _this.state = {
            breakpoint: null
        };
        _this._responsiveMediaHandlers = [];
        return _this;
    }
    (0, $97a7799c9b277eb6$export$2e2bcd8739ae039)(Slider, _React$Component);
    return (0, $c180160353ceabc3$export$2e2bcd8739ae039)(Slider, [
        {
            key: "media",
            value: function media(query, handler) {
                // javascript handler for  css media query
                var mql = window.matchMedia(query);
                var listener = function listener(_ref) {
                    var matches = _ref.matches;
                    if (matches) handler();
                };
                mql.addListener(listener);
                this._responsiveMediaHandlers.push({
                    mql: mql,
                    query: query,
                    listener: listener
                });
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this2 = this;
                // performance monitoring
                //if (process.env.NODE_ENV !== 'production') {
                //const { whyDidYouUpdate } = require('why-did-you-update')
                //whyDidYouUpdate(React)
                //}
                if (this.props.responsive) {
                    var breakpoints = this.props.responsive.map(function(breakpt) {
                        return breakpt.breakpoint;
                    });
                    // sort them in increasing order of their numerical value
                    breakpoints.sort(function(x, y) {
                        return x - y;
                    });
                    breakpoints.forEach(function(breakpoint, index) {
                        // media query for each breakpoint
                        var bQuery;
                        if (index === 0) bQuery = (0, (/*@__PURE__*/$parcel$interopDefault($7cf1f0fa01ebe79d$exports)))({
                            minWidth: 0,
                            maxWidth: breakpoint
                        });
                        else bQuery = (0, (/*@__PURE__*/$parcel$interopDefault($7cf1f0fa01ebe79d$exports)))({
                            minWidth: breakpoints[index - 1] + 1,
                            maxWidth: breakpoint
                        });
                        // when not using server side rendering
                        (0, $e3a0420005a1a536$export$71594e8a50f746f4)() && _this2.media(bQuery, function() {
                            _this2.setState({
                                breakpoint: breakpoint
                            });
                        });
                    });
                    // Register media query for full screen. Need to support resize from small to large
                    // convert javascript object to media query string
                    var query = (0, (/*@__PURE__*/$parcel$interopDefault($7cf1f0fa01ebe79d$exports)))({
                        minWidth: breakpoints.slice(-1)[0]
                    });
                    (0, $e3a0420005a1a536$export$71594e8a50f746f4)() && this.media(query, function() {
                        _this2.setState({
                            breakpoint: null
                        });
                    });
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this._responsiveMediaHandlers.forEach(function(obj) {
                    obj.mql.removeListener(obj.listener);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var settings;
                var newProps;
                if (this.state.breakpoint) {
                    newProps = this.props.responsive.filter(function(resp) {
                        return resp.breakpoint === _this3.state.breakpoint;
                    });
                    settings = newProps[0].settings === "unslick" ? "unslick" : (0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, (0, $4547f3e58e9675f5$export$2e2bcd8739ae039)), this.props), newProps[0].settings);
                } else settings = (0, $f163cd56d32104d1$export$2e2bcd8739ae039)((0, $f163cd56d32104d1$export$2e2bcd8739ae039)({}, (0, $4547f3e58e9675f5$export$2e2bcd8739ae039)), this.props);
                // force scrolling by one if centerMode is on
                if (settings.centerMode) {
                    settings.slidesToScroll;
                    settings.slidesToScroll = 1;
                }
                // force showing one slide and scrolling by one if the fade mode is on
                if (settings.fade) {
                    settings.slidesToShow;
                    settings.slidesToScroll;
                    settings.slidesToShow = 1;
                    settings.slidesToScroll = 1;
                }
                // makes sure that children is an array, even when there is only 1 child
                var children = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Children.toArray(this.props.children);
                // Children may contain false or null, so we should filter them
                // children may also contain string filled with spaces (in certain cases where we use jsx strings)
                children = children.filter(function(child) {
                    if (typeof child === "string") return !!child.trim();
                    return !!child;
                });
                // rows and slidesPerRow logic is handled here
                if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
                    console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
                    settings.variableWidth = false;
                }
                var newChildren = [];
                var currentWidth = null;
                for(var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow){
                    var newSlide = [];
                    for(var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow){
                        var row = [];
                        for(var k = j; k < j + settings.slidesPerRow; k += 1){
                            if (settings.variableWidth && children[k].props.style) currentWidth = children[k].props.style.width;
                            if (k >= children.length) break;
                            row.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).cloneElement(children[k], {
                                key: 100 * i + 10 * j + k,
                                tabIndex: -1,
                                style: {
                                    width: "".concat(100 / settings.slidesPerRow, "%"),
                                    display: "inline-block"
                                }
                            }));
                        }
                        newSlide.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
                            key: 10 * i + j
                        }, row));
                    }
                    if (settings.variableWidth) newChildren.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
                        key: i,
                        style: {
                            width: currentWidth
                        }
                    }, newSlide));
                    else newChildren.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
                        key: i
                    }, newSlide));
                }
                if (settings === "unslick") {
                    var className = "regular slider " + (this.props.className || "");
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
                        className: className
                    }, children);
                } else if (newChildren.length <= settings.slidesToShow) settings.unslick = true;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $6b4ac0da403cd40d$export$14a303763f47951d), (0, $e69a41570260c349$export$2e2bcd8739ae039)({
                    style: this.props.style,
                    ref: this.innerSliderRefHandler
                }, (0, $e3a0420005a1a536$export$b01d4e122f0895e5)(settings)), newChildren);
            }
        }
    ]);
}((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Component);


var $1ef2cd6bd99132c0$export$2e2bcd8739ae039 = (0, $e3e702cb0d064b20$export$2e2bcd8739ae039);










const $d51d916edb403aa3$export$313f763ccae4d53d = "--dot-duration";
const $d51d916edb403aa3$var$genCarouselStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    return {
        [componentCls]: {
            ...(0, $519d20bf207ce864$export$23997c3e44cc1c59)(token),
            ".slick-slider": {
                position: "relative",
                display: "block",
                boxSizing: "border-box",
                touchAction: "pan-y",
                WebkitTouchCallout: "none",
                WebkitTapHighlightColor: "transparent",
                ".slick-track, .slick-list": {
                    transform: "translate3d(0, 0, 0)",
                    touchAction: "pan-y"
                }
            },
            ".slick-list": {
                position: "relative",
                display: "block",
                margin: 0,
                padding: 0,
                overflow: "hidden",
                "&:focus": {
                    outline: "none"
                },
                "&.dragging": {
                    cursor: "pointer"
                },
                ".slick-slide": {
                    pointerEvents: "none",
                    // https://github.com/ant-design/ant-design/issues/23294
                    [`input${antCls}-radio-input, input${antCls}-checkbox-input`]: {
                        visibility: "hidden"
                    },
                    "&.slick-active": {
                        pointerEvents: "auto",
                        [`input${antCls}-radio-input, input${antCls}-checkbox-input`]: {
                            visibility: "visible"
                        }
                    },
                    // fix Carousel content height not match parent node
                    // when children is empty node
                    // https://github.com/ant-design/ant-design/issues/25878
                    "> div > div": {
                        verticalAlign: "bottom"
                    }
                }
            },
            ".slick-track": {
                position: "relative",
                top: 0,
                insetInlineStart: 0,
                display: "block",
                "&::before, &::after": {
                    display: "table",
                    content: '""'
                },
                "&::after": {
                    clear: "both"
                }
            },
            ".slick-slide": {
                display: "none",
                float: "left",
                height: "100%",
                minHeight: 1,
                img: {
                    display: "block"
                },
                "&.dragging img": {
                    pointerEvents: "none"
                }
            },
            ".slick-initialized .slick-slide": {
                display: "block"
            },
            ".slick-vertical .slick-slide": {
                display: "block",
                height: "auto"
            }
        }
    };
};
const $d51d916edb403aa3$var$genArrowsStyle = (token)=>{
    const { componentCls: componentCls, motionDurationSlow: motionDurationSlow, arrowSize: arrowSize, arrowOffset: arrowOffset } = token;
    const arrowLength = token.calc(arrowSize).div(Math.SQRT2).equal();
    return {
        [componentCls]: {
            // Arrows
            ".slick-prev, .slick-next": {
                position: "absolute",
                top: "50%",
                width: arrowSize,
                height: arrowSize,
                transform: "translateY(-50%)",
                color: "#fff",
                opacity: 0.4,
                background: "transparent",
                padding: 0,
                lineHeight: 0,
                border: 0,
                outline: "none",
                cursor: "pointer",
                zIndex: 1,
                transition: `opacity ${motionDurationSlow}`,
                "&:hover, &:focus": {
                    opacity: 1
                },
                "&.slick-disabled": {
                    pointerEvents: "none",
                    opacity: 0
                },
                "&::after": {
                    boxSizing: "border-box",
                    position: "absolute",
                    top: token.calc(arrowSize).sub(arrowLength).div(2).equal(),
                    insetInlineStart: token.calc(arrowSize).sub(arrowLength).div(2).equal(),
                    display: "inline-block",
                    width: arrowLength,
                    height: arrowLength,
                    border: `0 solid currentcolor`,
                    borderInlineStartWidth: 2,
                    borderBlockStartWidth: 2,
                    borderRadius: 1,
                    content: '""'
                }
            },
            ".slick-prev": {
                insetInlineStart: arrowOffset,
                "&::after": {
                    transform: "rotate(-45deg)"
                }
            },
            ".slick-next": {
                insetInlineEnd: arrowOffset,
                "&::after": {
                    transform: "rotate(135deg)"
                }
            }
        }
    };
};
const $d51d916edb403aa3$var$genDotsStyle = (token)=>{
    const { componentCls: componentCls, dotOffset: dotOffset, dotWidth: dotWidth, dotHeight: dotHeight, dotGap: dotGap, colorBgContainer: colorBgContainer, motionDurationSlow: motionDurationSlow } = token;
    const animation = new (0, $e928d3664c9ed565$export$2e2bcd8739ae039)(`${token.prefixCls}-dot-animation`, {
        from: {
            width: 0
        },
        to: {
            width: token.dotActiveWidth
        }
    });
    return {
        [componentCls]: {
            ".slick-dots": {
                position: "absolute",
                insetInlineEnd: 0,
                bottom: 0,
                insetInlineStart: 0,
                zIndex: 15,
                display: "flex !important",
                justifyContent: "center",
                paddingInlineStart: 0,
                margin: 0,
                listStyle: "none",
                "&-bottom": {
                    bottom: dotOffset
                },
                "&-top": {
                    top: dotOffset,
                    bottom: "auto"
                },
                li: {
                    position: "relative",
                    display: "inline-block",
                    flex: "0 1 auto",
                    boxSizing: "content-box",
                    width: dotWidth,
                    height: dotHeight,
                    marginInline: dotGap,
                    padding: 0,
                    textAlign: "center",
                    textIndent: -999,
                    verticalAlign: "top",
                    transition: `all ${motionDurationSlow}`,
                    borderRadius: dotHeight,
                    overflow: "hidden",
                    "&::after": {
                        display: "block",
                        position: "absolute",
                        top: 0,
                        insetInlineStart: 0,
                        width: 0,
                        height: dotHeight,
                        content: '""',
                        background: "transparent",
                        borderRadius: dotHeight,
                        opacity: 1,
                        outline: "none",
                        cursor: "pointer",
                        overflow: "hidden"
                    },
                    button: {
                        position: "relative",
                        display: "block",
                        width: "100%",
                        height: dotHeight,
                        padding: 0,
                        color: "transparent",
                        fontSize: 0,
                        background: colorBgContainer,
                        border: 0,
                        borderRadius: dotHeight,
                        outline: "none",
                        cursor: "pointer",
                        opacity: 0.2,
                        transition: `all ${motionDurationSlow}`,
                        overflow: "hidden",
                        "&:hover": {
                            opacity: 0.75
                        },
                        "&::after": {
                            position: "absolute",
                            inset: token.calc(dotGap).mul(-1).equal(),
                            content: '""'
                        }
                    },
                    "&.slick-active": {
                        width: token.dotActiveWidth,
                        position: "relative",
                        "&:hover": {
                            opacity: 1
                        },
                        "&::after": {
                            background: colorBgContainer,
                            animationName: animation,
                            animationDuration: `var(${$d51d916edb403aa3$export$313f763ccae4d53d})`,
                            animationTimingFunction: "ease-out",
                            animationFillMode: "forwards"
                        }
                    }
                }
            }
        }
    };
};
const $d51d916edb403aa3$var$genCarouselVerticalStyle = (token)=>{
    const { componentCls: componentCls, dotOffset: dotOffset, arrowOffset: arrowOffset, marginXXS: marginXXS } = token;
    const animation = new (0, $e928d3664c9ed565$export$2e2bcd8739ae039)(`${token.prefixCls}-dot-vertical-animation`, {
        from: {
            height: 0
        },
        to: {
            height: token.dotActiveWidth
        }
    });
    const reverseSizeOfDot = {
        width: token.dotHeight,
        height: token.dotWidth
    };
    return {
        [`${componentCls}-vertical`]: {
            ".slick-prev, .slick-next": {
                insetInlineStart: "50%",
                marginBlockStart: "unset",
                transform: "translateX(-50%)"
            },
            ".slick-prev": {
                insetBlockStart: arrowOffset,
                insetInlineStart: "50%",
                "&::after": {
                    transform: "rotate(45deg)"
                }
            },
            ".slick-next": {
                insetBlockStart: "auto",
                insetBlockEnd: arrowOffset,
                "&::after": {
                    transform: "rotate(-135deg)"
                }
            },
            ".slick-dots": {
                top: "50%",
                bottom: "auto",
                flexDirection: "column",
                width: token.dotHeight,
                height: "auto",
                margin: 0,
                transform: "translateY(-50%)",
                "&-start": {
                    insetInlineEnd: "auto",
                    insetInlineStart: dotOffset
                },
                "&-end": {
                    insetInlineEnd: dotOffset,
                    insetInlineStart: "auto"
                },
                li: {
                    // reverse width and height in vertical situation
                    ...reverseSizeOfDot,
                    margin: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(marginXXS)} 0`,
                    verticalAlign: "baseline",
                    button: reverseSizeOfDot,
                    "&::after": {
                        ...reverseSizeOfDot,
                        height: 0
                    },
                    "&.slick-active": {
                        ...reverseSizeOfDot,
                        height: token.dotActiveWidth,
                        button: {
                            ...reverseSizeOfDot,
                            height: token.dotActiveWidth
                        },
                        "&::after": {
                            ...reverseSizeOfDot,
                            animationName: animation,
                            animationDuration: `var(${$d51d916edb403aa3$export$313f763ccae4d53d})`,
                            animationTimingFunction: "ease-out",
                            animationFillMode: "forwards"
                        }
                    }
                }
            }
        }
    };
};
const $d51d916edb403aa3$var$genCarouselRtlStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return [
        {
            [`${componentCls}-rtl`]: {
                direction: "rtl"
            }
        },
        {
            [`${componentCls}-vertical`]: {
                ".slick-dots": {
                    [`${componentCls}-rtl&`]: {
                        flexDirection: "column"
                    }
                }
            }
        }
    ];
};
const $d51d916edb403aa3$export$9ca1be8807fe0675 = (token)=>{
    const dotActiveWidth = 24;
    return {
        arrowSize: 16,
        arrowOffset: token.marginXS,
        dotWidth: 16,
        dotHeight: 3,
        dotGap: token.marginXXS,
        dotOffset: 12,
        dotWidthActive: dotActiveWidth,
        dotActiveWidth: dotActiveWidth
    };
};
var // ============================== Export ==============================
$d51d916edb403aa3$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$51ec95de45185b42)("Carousel", (token)=>[
        $d51d916edb403aa3$var$genCarouselStyle(token),
        $d51d916edb403aa3$var$genArrowsStyle(token),
        $d51d916edb403aa3$var$genDotsStyle(token),
        $d51d916edb403aa3$var$genCarouselVerticalStyle(token),
        $d51d916edb403aa3$var$genCarouselRtlStyle(token)
    ], $d51d916edb403aa3$export$9ca1be8807fe0675, {
    deprecatedTokens: [
        [
            "dotWidthActive",
            "dotActiveWidth"
        ]
    ]
});


"use client";
const $e5e8f6bf1e4edb2c$var$dotsClass = "slick-dots";
const $e5e8f6bf1e4edb2c$var$ArrowButton = ({ currentSlide: currentSlide, slideCount: slideCount, ...rest })=>/*#__PURE__*/ $cQmXV.createElement("button", {
        type: "button",
        ...rest
    });
const $e5e8f6bf1e4edb2c$var$Carousel = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { dots: dots = true, arrows: arrows = false, prevArrow: prevArrow, nextArrow: nextArrow, draggable: draggable = false, waitForAnimate: waitForAnimate = false, dotPosition: dotPosition, dotPlacement: dotPlacement, vertical: vertical, rootClassName: rootClassName, className: customClassName, style: style, id: id, autoplay: autoplay = false, autoplaySpeed: autoplaySpeed = 3000, rtl: rtl, ...otherProps } = props;
    const mergedDotPlacement = $cQmXV.useMemo(()=>{
        const placement = dotPlacement ?? dotPosition ?? "bottom";
        switch(placement){
            case "left":
                return "start";
            case "right":
                return "end";
            default:
                return placement;
        }
    }, [
        dotPosition,
        dotPlacement
    ]);
    const mergedVertical = vertical ?? (mergedDotPlacement === "start" || mergedDotPlacement === "end");
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("carousel");
    const slickRef = $cQmXV.useRef(null);
    const nativeElementRef = $cQmXV.useRef(null);
    const goTo = (slide, dontAnimate = false)=>{
        slickRef.current.slickGoTo(slide, dontAnimate);
    };
    $cQmXV.useImperativeHandle(ref, ()=>({
            goTo: goTo,
            autoPlay: slickRef.current.innerSlider.autoPlay,
            innerSlider: slickRef.current.innerSlider,
            prev: slickRef.current.slickPrev,
            next: slickRef.current.slickNext,
            nativeElement: nativeElementRef.current
        }), [
        slickRef.current
    ]);
    const { children: children, initialSlide: initialSlide = 0 } = props;
    const childNodes = (0, $cd966a313e0a92ff$export$2e2bcd8739ae039)(children);
    const count = childNodes.length;
    const isRTL = (rtl ?? direction === "rtl") && !vertical;
    $cQmXV.useEffect(()=>{
        if (count > 0) {
            const newIndex = isRTL ? count - initialSlide - 1 : initialSlide;
            goTo(newIndex, false);
        }
    }, [
        initialSlide,
        isRTL
    ]);
    const newProps = {
        vertical: mergedVertical,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(customClassName, contextClassName),
        style: {
            ...contextStyle,
            ...style
        },
        autoplay: !!autoplay,
        ...otherProps
    };
    if (newProps.effect === "fade") newProps.fade = true;
    const prefixCls = getPrefixCls("carousel", newProps.prefixCls);
    const enableDots = !!dots;
    const dsClass = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)($e5e8f6bf1e4edb2c$var$dotsClass, `${$e5e8f6bf1e4edb2c$var$dotsClass}-${mergedDotPlacement}`, typeof dots === "boolean" ? false : dots?.className);
    const [hashId, cssVarCls] = (0, $d51d916edb403aa3$export$2e2bcd8739ae039)(prefixCls);
    const className = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, {
        [`${prefixCls}-rtl`]: isRTL,
        [`${prefixCls}-vertical`]: newProps.vertical
    }, hashId, cssVarCls, rootClassName);
    const mergedShowDuration = autoplay && ((0, $8e2d153a3c855782$export$53b83ca8eaab0383)(autoplay) ? autoplay.dotDuration : false);
    const dotDurationStyle = mergedShowDuration ? {
        [(0, $d51d916edb403aa3$export$313f763ccae4d53d)]: `${autoplaySpeed}ms`
    } : {};
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        ref: nativeElementRef,
        className: className,
        id: id,
        style: dotDurationStyle
    }, /*#__PURE__*/ $cQmXV.createElement((0, $1ef2cd6bd99132c0$export$2e2bcd8739ae039), {
        ref: slickRef,
        ...newProps,
        dots: enableDots,
        dotsClass: dsClass,
        arrows: arrows,
        prevArrow: prevArrow ?? /*#__PURE__*/ $cQmXV.createElement($e5e8f6bf1e4edb2c$var$ArrowButton, {
            "aria-label": isRTL ? "next" : "prev"
        }),
        nextArrow: nextArrow ?? /*#__PURE__*/ $cQmXV.createElement($e5e8f6bf1e4edb2c$var$ArrowButton, {
            "aria-label": isRTL ? "prev" : "next"
        }),
        draggable: draggable,
        verticalSwiping: mergedVertical,
        autoplaySpeed: autoplaySpeed,
        waitForAnimate: waitForAnimate,
        rtl: isRTL
    }));
});
var $e5e8f6bf1e4edb2c$export$2e2bcd8739ae039 = $e5e8f6bf1e4edb2c$var$Carousel;


var $cQmXV = parcelRequire("cQmXV");



var $cQmXV = parcelRequire("cQmXV");





var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");
const $c68ed2119d59ce29$export$3062997f0b99863 = /*#__PURE__*/ $cQmXV.createContext(null);




var $cQmXV = parcelRequire("cQmXV");
function $7e85f40564c78999$export$602246410992d405(src) {
    return new Promise((resolve)=>{
        if (!src) {
            resolve(false);
            return;
        }
        const img = document.createElement("img");
        img.onerror = ()=>resolve(false);
        img.onload = ()=>resolve(true);
        img.src = src;
    });
}
function $7e85f40564c78999$export$1feb45891927fcb4() {
    const width = document.documentElement.clientWidth;
    const height = window.innerHeight || document.documentElement.clientHeight;
    return {
        width: width,
        height: height
    };
}


const $2de2f370d9b22b13$var$initialTransform = {
    x: 0,
    y: 0,
    rotate: 0,
    scale: 1,
    flipX: false,
    flipY: false
};
function $2de2f370d9b22b13$export$2e2bcd8739ae039(imgRef, minScale, maxScale, onTransform) {
    const frame = (0, $cQmXV.useRef)(null);
    const queue = (0, $cQmXV.useRef)([]);
    const [transform, setTransform] = (0, $cQmXV.useState)($2de2f370d9b22b13$var$initialTransform);
    const resetTransform = (action)=>{
        setTransform($2de2f370d9b22b13$var$initialTransform);
        if (!(0, $3f19ee2a2ff4618a$export$2e2bcd8739ae039)($2de2f370d9b22b13$var$initialTransform, transform)) onTransform?.({
            transform: $2de2f370d9b22b13$var$initialTransform,
            action: action
        });
    };
    /** Direct update transform */ const updateTransform = (newTransform, action)=>{
        if (frame.current === null) {
            queue.current = [];
            frame.current = (0, $905c53b807de704e$export$2e2bcd8739ae039)(()=>{
                setTransform((preState)=>{
                    let memoState = preState;
                    queue.current.forEach((queueState)=>{
                        memoState = {
                            ...memoState,
                            ...queueState
                        };
                    });
                    frame.current = null;
                    onTransform?.({
                        transform: memoState,
                        action: action
                    });
                    return memoState;
                });
            });
        }
        queue.current.push({
            ...transform,
            ...newTransform
        });
    };
    /** Scale according to the position of centerX and centerY */ const dispatchZoomChange = (ratio, action, centerX, centerY, isTouch)=>{
        const { width: width, height: height, offsetWidth: offsetWidth, offsetHeight: offsetHeight, offsetLeft: offsetLeft, offsetTop: offsetTop } = imgRef.current;
        let newRatio = ratio;
        let newScale = transform.scale * ratio;
        if (newScale > maxScale) {
            newScale = maxScale;
            newRatio = maxScale / transform.scale;
        } else if (newScale < minScale) {
            // For mobile interactions, allow scaling down to the minimum scale.
            newScale = isTouch ? newScale : minScale;
            newRatio = newScale / transform.scale;
        }
        /** Default center point scaling */ const mergedCenterX = centerX ?? innerWidth / 2;
        const mergedCenterY = centerY ?? innerHeight / 2;
        const diffRatio = newRatio - 1;
        /** Deviation calculated from image size */ const diffImgX = diffRatio * width * 0.5;
        const diffImgY = diffRatio * height * 0.5;
        /** The difference between the click position and the edge of the document */ const diffOffsetLeft = diffRatio * (mergedCenterX - transform.x - offsetLeft);
        const diffOffsetTop = diffRatio * (mergedCenterY - transform.y - offsetTop);
        /** Final positioning */ let newX = transform.x - (diffOffsetLeft - diffImgX);
        let newY = transform.y - (diffOffsetTop - diffImgY);
        /**
     * When zooming the image
     * When the image size is smaller than the width and height of the window, the position is initialized
     */ if (ratio < 1 && newScale === 1) {
            const mergedWidth = offsetWidth * newScale;
            const mergedHeight = offsetHeight * newScale;
            const { width: clientWidth, height: clientHeight } = (0, $7e85f40564c78999$export$1feb45891927fcb4)();
            if (mergedWidth <= clientWidth && mergedHeight <= clientHeight) {
                newX = 0;
                newY = 0;
            }
        }
        updateTransform({
            x: newX,
            y: newY,
            scale: newScale
        }, action);
    };
    return {
        transform: transform,
        resetTransform: resetTransform,
        updateTransform: updateTransform,
        dispatchZoomChange: dispatchZoomChange
    };
}




var $cQmXV = parcelRequire("cQmXV");

function $bc27a2491dd4c6a4$var$fixPoint(key, start, width, clientWidth) {
    const startAddWidth = start + width;
    const offsetStart = (width - clientWidth) / 2;
    if (width > clientWidth) {
        if (start > 0) return {
            [key]: offsetStart
        };
        if (start < 0 && startAddWidth < clientWidth) return {
            [key]: -offsetStart
        };
    } else if (start < 0 || startAddWidth > clientWidth) return {
        [key]: start < 0 ? offsetStart : -offsetStart
    };
    return {};
}
function $bc27a2491dd4c6a4$export$2e2bcd8739ae039(width, height, left, top) {
    const { width: clientWidth, height: clientHeight } = (0, $7e85f40564c78999$export$1feb45891927fcb4)();
    let fixPos = null;
    if (width <= clientWidth && height <= clientHeight) fixPos = {
        x: 0,
        y: 0
    };
    else if (width > clientWidth || height > clientHeight) fixPos = {
        ...$bc27a2491dd4c6a4$var$fixPoint("x", left, width, clientWidth),
        ...$bc27a2491dd4c6a4$var$fixPoint("y", top, height, clientHeight)
    };
    return fixPos;
}


/** Scale the ratio base */ const $e3148aa1d7aecacb$export$6e76060232ffaf48 = 1;
const $e3148aa1d7aecacb$export$137a7d87d4a2aae5 = 1;


function $4a10bf8feca6f334$export$2e2bcd8739ae039(imgRef, movable, open, scaleStep, transform, updateTransform, dispatchZoomChange, wheel = true) {
    const { rotate: rotate, scale: scale, x: x, y: y } = transform;
    const [isMoving, setMoving] = (0, $cQmXV.useState)(false);
    const startPositionInfo = (0, $cQmXV.useRef)({
        diffX: 0,
        diffY: 0,
        transformX: 0,
        transformY: 0
    });
    const onMouseDown = (event)=>{
        // Only allow main button
        if (!movable || event.button !== 0) return;
        event.preventDefault();
        event.stopPropagation();
        startPositionInfo.current = {
            diffX: event.pageX - x,
            diffY: event.pageY - y,
            transformX: x,
            transformY: y
        };
        setMoving(true);
    };
    const onMouseMove = (event)=>{
        if (open && isMoving) updateTransform({
            x: event.pageX - startPositionInfo.current.diffX,
            y: event.pageY - startPositionInfo.current.diffY
        }, "move");
    };
    const onMouseUp = ()=>{
        if (open && isMoving) {
            setMoving(false);
            /** No need to restore the position when the picture is not moved, So as not to interfere with the click */ const { transformX: transformX, transformY: transformY } = startPositionInfo.current;
            const hasChangedPosition = x !== transformX && y !== transformY;
            if (!hasChangedPosition) return;
            const width = imgRef.current.offsetWidth * scale;
            const height = imgRef.current.offsetHeight * scale;
            // eslint-disable-next-line @typescript-eslint/no-shadow
            const { left: left, top: top } = imgRef.current.getBoundingClientRect();
            const isRotate = rotate % 180 !== 0;
            const fixState = (0, $bc27a2491dd4c6a4$export$2e2bcd8739ae039)(isRotate ? height : width, isRotate ? width : height, left, top);
            if (fixState) updateTransform({
                ...fixState
            }, "dragRebound");
        }
    };
    const onWheel = (event)=>{
        if (!open || !wheel || event.deltaY == 0) return;
        // Scale ratio depends on the deltaY size
        const scaleRatio = Math.abs(event.deltaY / 100);
        // Limit the maximum scale ratio
        const mergedScaleRatio = Math.min(scaleRatio, (0, $e3148aa1d7aecacb$export$137a7d87d4a2aae5));
        // Scale the ratio each time
        let ratio = (0, $e3148aa1d7aecacb$export$6e76060232ffaf48) + mergedScaleRatio * scaleStep;
        if (event.deltaY > 0) ratio = (0, $e3148aa1d7aecacb$export$6e76060232ffaf48) / ratio;
        dispatchZoomChange(ratio, "wheel", event.clientX, event.clientY);
    };
    (0, $cQmXV.useEffect)(()=>{
        if (movable) {
            window.addEventListener("mouseup", onMouseUp, false);
            window.addEventListener("mousemove", onMouseMove, false);
            try {
                // Resolve if in iframe lost event
                /* istanbul ignore next */ if (window.top !== window.self) {
                    window.top.addEventListener("mouseup", onMouseUp, false);
                    window.top.addEventListener("mousemove", onMouseMove, false);
                }
            } catch (error) {
                /* istanbul ignore next */ (0, $26d7cf6379fe7659$export$2e2bcd8739ae039)(false, `[rc-image] ${error}`);
            }
        }
        return ()=>{
            window.removeEventListener("mouseup", onMouseUp);
            window.removeEventListener("mousemove", onMouseMove);
            /* istanbul ignore next */ try {
                window.top?.removeEventListener("mouseup", onMouseUp);
                window.top?.removeEventListener("mousemove", onMouseMove);
            } catch (error) {
            // Do nothing
            }
        };
    }, [
        open,
        isMoving,
        x,
        y,
        rotate,
        movable
    ]);
    return {
        isMoving: isMoving,
        onMouseDown: onMouseDown,
        onMouseMove: onMouseMove,
        onMouseUp: onMouseUp,
        onWheel: onWheel
    };
}



var $cQmXV = parcelRequire("cQmXV");

function $9cab1977659d2768$export$2e2bcd8739ae039({ src: src, isCustomPlaceholder: isCustomPlaceholder, fallback: fallback }) {
    const [status, setStatus] = (0, $cQmXV.useState)(isCustomPlaceholder ? "loading" : "normal");
    const isLoaded = (0, $cQmXV.useRef)(false);
    const isError = status === "error";
    // https://github.com/react-component/image/pull/187
    (0, $cQmXV.useEffect)(()=>{
        let isCurrentSrc = true;
        (0, $7e85f40564c78999$export$602246410992d405)(src).then((isValid)=>{
            // https://github.com/ant-design/ant-design/issues/44948
            // If src changes, the previous setStatus should not be triggered
            if (!isValid && isCurrentSrc) setStatus("error");
        });
        return ()=>{
            isCurrentSrc = false;
        };
    }, [
        src
    ]);
    (0, $cQmXV.useEffect)(()=>{
        if (isCustomPlaceholder && !isLoaded.current) setStatus("loading");
        else if (isError) setStatus("normal");
    }, [
        src
    ]);
    const onLoad = ()=>{
        setStatus("normal");
    };
    const getImgRef = (img)=>{
        isLoaded.current = false;
        if (status === "loading" && img?.complete && (img.naturalWidth || img.naturalHeight)) {
            isLoaded.current = true;
            onLoad();
        }
    };
    const srcAndOnload = isError && fallback ? {
        src: fallback
    } : {
        onLoad: onLoad,
        src: src
    };
    return [
        getImgRef,
        srcAndOnload,
        status
    ];
}



var $cQmXV = parcelRequire("cQmXV");

function $f837f2aed15bbbe3$var$getDistance(a, b) {
    const x = a.x - b.x;
    const y = a.y - b.y;
    return Math.hypot(x, y);
}
function $f837f2aed15bbbe3$var$getCenter(oldPoint1, oldPoint2, newPoint1, newPoint2) {
    // Calculate the distance each point has moved
    const distance1 = $f837f2aed15bbbe3$var$getDistance(oldPoint1, newPoint1);
    const distance2 = $f837f2aed15bbbe3$var$getDistance(oldPoint2, newPoint2);
    // If both distances are 0, return the original points
    if (distance1 === 0 && distance2 === 0) return [
        oldPoint1.x,
        oldPoint1.y
    ];
    // Calculate the ratio of the distances
    const ratio = distance1 / (distance1 + distance2);
    // Calculate the new center point based on the ratio
    const x = oldPoint1.x + ratio * (oldPoint2.x - oldPoint1.x);
    const y = oldPoint1.y + ratio * (oldPoint2.y - oldPoint1.y);
    return [
        x,
        y
    ];
}
function $f837f2aed15bbbe3$export$2e2bcd8739ae039(imgRef, movable, open, minScale, transform, updateTransform, dispatchZoomChange) {
    const { rotate: rotate, scale: scale, x: x, y: y } = transform;
    const [isTouching, setIsTouching] = (0, $cQmXV.useState)(false);
    const touchPointInfo = (0, $cQmXV.useRef)({
        point1: {
            x: 0,
            y: 0
        },
        point2: {
            x: 0,
            y: 0
        },
        eventType: "none"
    });
    const updateTouchPointInfo = (values)=>{
        touchPointInfo.current = {
            ...touchPointInfo.current,
            ...values
        };
    };
    const onTouchStart = (event)=>{
        if (!movable) return;
        event.stopPropagation();
        setIsTouching(true);
        const { touches: touches = [] } = event;
        if (touches.length > 1) // touch zoom
        updateTouchPointInfo({
            point1: {
                x: touches[0].clientX,
                y: touches[0].clientY
            },
            point2: {
                x: touches[1].clientX,
                y: touches[1].clientY
            },
            eventType: "touchZoom"
        });
        else // touch move
        updateTouchPointInfo({
            point1: {
                x: touches[0].clientX - x,
                y: touches[0].clientY - y
            },
            eventType: "move"
        });
    };
    const onTouchMove = (event)=>{
        const { touches: touches = [] } = event;
        const { point1: point1, point2: point2, eventType: eventType } = touchPointInfo.current;
        if (touches.length > 1 && eventType === "touchZoom") {
            // touch zoom
            const newPoint1 = {
                x: touches[0].clientX,
                y: touches[0].clientY
            };
            const newPoint2 = {
                x: touches[1].clientX,
                y: touches[1].clientY
            };
            const [centerX, centerY] = $f837f2aed15bbbe3$var$getCenter(point1, point2, newPoint1, newPoint2);
            const ratio = $f837f2aed15bbbe3$var$getDistance(newPoint1, newPoint2) / $f837f2aed15bbbe3$var$getDistance(point1, point2);
            dispatchZoomChange(ratio, "touchZoom", centerX, centerY, true);
            updateTouchPointInfo({
                point1: newPoint1,
                point2: newPoint2,
                eventType: "touchZoom"
            });
        } else if (eventType === "move") {
            // touch move
            updateTransform({
                x: touches[0].clientX - point1.x,
                y: touches[0].clientY - point1.y
            }, "move");
            updateTouchPointInfo({
                eventType: "move"
            });
        }
    };
    const onTouchEnd = ()=>{
        if (!open) return;
        if (isTouching) setIsTouching(false);
        updateTouchPointInfo({
            eventType: "none"
        });
        if (minScale > scale) /** When the scaling ratio is less than the minimum scaling ratio, reset the scaling ratio */ return updateTransform({
            x: 0,
            y: 0,
            scale: minScale
        }, "touchZoom");
        const width = imgRef.current.offsetWidth * scale;
        const height = imgRef.current.offsetHeight * scale;
        // eslint-disable-next-line @typescript-eslint/no-shadow
        const { left: left, top: top } = imgRef.current.getBoundingClientRect();
        const isRotate = rotate % 180 !== 0;
        const fixState = (0, $bc27a2491dd4c6a4$export$2e2bcd8739ae039)(isRotate ? height : width, isRotate ? width : height, left, top);
        if (fixState) updateTransform({
            ...fixState
        }, "dragRebound");
    };
    (0, $cQmXV.useEffect)(()=>{
        const preventDefault = (e)=>{
            e.preventDefault();
        };
        if (open && movable) window.addEventListener("touchmove", preventDefault, {
            passive: false
        });
        return ()=>{
            window.removeEventListener("touchmove", preventDefault);
        };
    }, [
        open,
        movable
    ]);
    return {
        isTouching: isTouching,
        onTouchStart: onTouchStart,
        onTouchMove: onTouchMove,
        onTouchEnd: onTouchEnd
    };
}





var $cQmXV = parcelRequire("cQmXV");
function $bceaf0d371d14f06$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, icon: icon, onClick: onClick, className: className, style: style } = props;
    return /*#__PURE__*/ $cQmXV.createElement("button", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-close`, className),
        style: style,
        onClick: onClick
    }, icon);
}




var $cQmXV = parcelRequire("cQmXV");
function $ec5c36eea3f4aab1$export$2e2bcd8739ae039(props) {
    // 修改解构，添加缺失的属性，并提供默认值
    const { prefixCls: prefixCls, showProgress: showProgress, current: current, count: count, showSwitch: showSwitch, classNames: // Style
    classNames, styles: styles, icons: // render
    icons, image: image, transform: transform, countRender: countRender, actionsRender: actionsRender, scale: // Scale
    scale, minScale: minScale, maxScale: maxScale, onActive: // Actions
    onActive, onFlipY: onFlipY, onFlipX: onFlipX, onRotateLeft: onRotateLeft, onRotateRight: onRotateRight, onZoomOut: onZoomOut, onZoomIn: onZoomIn, onClose: onClose, onReset: onReset } = props;
    const { left: left, right: right, prev: prev, next: next, flipY: flipY, flipX: flipX, rotateLeft: rotateLeft, rotateRight: rotateRight, zoomOut: zoomOut, zoomIn: zoomIn } = icons;
    // ========================== Render ==========================
    // >>>>> Progress
    const progressNode = showProgress && /*#__PURE__*/ $cQmXV.createElement("div", {
        className: `${prefixCls}-progress`
    }, countRender ? countRender(current + 1, count) : /*#__PURE__*/ $cQmXV.createElement("bdi", null, `${current + 1} / ${count}`));
    // >>>>> Actions
    const actionCls = `${prefixCls}-actions-action`;
    const renderOperation = ({ type: type, disabled: disabled, onClick: onClick, icon: icon })=>{
        return /*#__PURE__*/ $cQmXV.createElement("button", {
            type: "button",
            key: type,
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(actionCls, `${actionCls}-${type}`, {
                [`${actionCls}-disabled`]: !!disabled
            }),
            onClick: onClick,
            disabled: !!disabled,
            "aria-label": type
        }, icon);
    };
    const switchPrevNode = showSwitch ? renderOperation({
        icon: prev ?? left,
        onClick: ()=>onActive(-1),
        type: "prev",
        disabled: current === 0
    }) : undefined;
    const switchNextNode = showSwitch ? renderOperation({
        icon: next ?? right,
        onClick: ()=>onActive(1),
        type: "next",
        disabled: current === count - 1
    }) : undefined;
    const flipYNode = renderOperation({
        icon: flipY,
        onClick: onFlipY,
        type: "flipY"
    });
    const flipXNode = renderOperation({
        icon: flipX,
        onClick: onFlipX,
        type: "flipX"
    });
    const rotateLeftNode = renderOperation({
        icon: rotateLeft,
        onClick: onRotateLeft,
        type: "rotateLeft"
    });
    const rotateRightNode = renderOperation({
        icon: rotateRight,
        onClick: onRotateRight,
        type: "rotateRight"
    });
    const zoomOutNode = renderOperation({
        icon: zoomOut,
        onClick: onZoomOut,
        type: "zoomOut",
        disabled: scale <= minScale
    });
    const zoomInNode = renderOperation({
        icon: zoomIn,
        onClick: onZoomIn,
        type: "zoomIn",
        disabled: scale === maxScale
    });
    const actionsNode = /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-actions`, classNames.actions),
        style: styles.actions
    }, flipYNode, flipXNode, rotateLeftNode, rotateRightNode, zoomOutNode, zoomInNode);
    // >>>>> Render
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-footer`, classNames.footer),
        style: styles.footer
    }, progressNode, actionsRender ? actionsRender(actionsNode, {
        icons: {
            prevIcon: switchPrevNode,
            nextIcon: switchNextNode,
            flipYIcon: flipYNode,
            flipXIcon: flipXNode,
            rotateLeftIcon: rotateLeftNode,
            rotateRightIcon: rotateRightNode,
            zoomOutIcon: zoomOutNode,
            zoomInIcon: zoomInNode
        },
        actions: {
            onActive: onActive,
            onFlipY: onFlipY,
            onFlipX: onFlipX,
            onRotateLeft: onRotateLeft,
            onRotateRight: onRotateRight,
            onZoomOut: onZoomOut,
            onZoomIn: onZoomIn,
            onReset: onReset,
            onClose: onClose
        },
        transform: transform,
        current: current,
        total: count,
        image: image
    }) : actionsNode);
}




var $cQmXV = parcelRequire("cQmXV");
function $cee7c3b34fbd7e5e$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, onActive: onActive, current: current, count: count, icons: { left: left, right: right, prev: prev, next: next } } = props;
    const switchCls = `${prefixCls}-switch`;
    const prevDisabled = current === 0;
    const nextDisabled = current === count - 1;
    return /*#__PURE__*/ $cQmXV.createElement($cQmXV.Fragment, null, /*#__PURE__*/ $cQmXV.createElement("button", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(switchCls, `${switchCls}-prev`, {
            [`${switchCls}-disabled`]: prevDisabled
        }),
        onClick: ()=>onActive(-1),
        disabled: prevDisabled
    }, prev ?? left), /*#__PURE__*/ $cQmXV.createElement("button", {
        type: "button",
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(switchCls, `${switchCls}-next`, {
            [`${switchCls}-disabled`]: nextDisabled
        }),
        onClick: ()=>onActive(1),
        disabled: nextDisabled
    }, next ?? right));
}


function $198c37323f34246d$var$_extends() {
    $198c37323f34246d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $198c37323f34246d$var$_extends.apply(this, arguments);
}
// Note: if you want to add `action`,
// pls contact @zombieJ or @thinkasany first.
const $198c37323f34246d$var$PreviewImage = ({ fallback: fallback, src: src, imgRef: imgRef, ...props })=>{
    const [getImgRef, srcAndOnload] = (0, $9cab1977659d2768$export$2e2bcd8739ae039)({
        src: src,
        fallback: fallback
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("img", $198c37323f34246d$var$_extends({
        ref: (ref)=>{
            imgRef.current = ref;
            getImgRef(ref);
        }
    }, props, srcAndOnload));
};
const $198c37323f34246d$var$Preview = (props)=>{
    const { prefixCls: prefixCls, rootClassName: rootClassName, src: src, alt: alt, imageInfo: imageInfo, fallback: fallback, movable: movable = true, onClose: onClose, open: open, afterOpenChange: afterOpenChange, maskClosable: maskClosable = true, icons: icons = {}, closeIcon: closeIcon, getContainer: getContainer, current: current = 0, count: count = 1, countRender: countRender, scaleStep: scaleStep = 0.5, minScale: minScale = 1, maxScale: maxScale = 50, motionName: motionName = "fade", imageRender: imageRender, imgCommonProps: imgCommonProps, actionsRender: actionsRender, onTransform: onTransform, onChange: onChange, classNames: classNames = {}, styles: styles = {}, mousePosition: mousePosition, zIndex: zIndex, wheel: wheel = true, focusTrap: focusTrap = true } = props;
    const imgRef = (0, $cQmXV.useRef)(null);
    const wrapperRef = (0, $cQmXV.useRef)(null);
    const triggerRef = (0, $cQmXV.useRef)(null);
    const groupContext = (0, $cQmXV.useContext)((0, $c68ed2119d59ce29$export$3062997f0b99863));
    const showLeftOrRightSwitches = groupContext && count > 1;
    const showOperationsProgress = groupContext && count >= 1;
    // ======================== Transform =========================
    const [enableTransition, setEnableTransition] = (0, $cQmXV.useState)(true);
    const { transform: transform, resetTransform: resetTransform, updateTransform: updateTransform, dispatchZoomChange: dispatchZoomChange } = (0, $2de2f370d9b22b13$export$2e2bcd8739ae039)(imgRef, minScale, maxScale, onTransform);
    const { isMoving: isMoving, onMouseDown: onMouseDown, onWheel: onWheel } = (0, $4a10bf8feca6f334$export$2e2bcd8739ae039)(imgRef, movable, open, scaleStep, transform, updateTransform, dispatchZoomChange, wheel);
    const { isTouching: isTouching, onTouchStart: onTouchStart, onTouchMove: onTouchMove, onTouchEnd: onTouchEnd } = (0, $f837f2aed15bbbe3$export$2e2bcd8739ae039)(imgRef, movable, open, minScale, transform, updateTransform, dispatchZoomChange);
    const { rotate: rotate, scale: scale } = transform;
    (0, $cQmXV.useEffect)(()=>{
        if (!enableTransition) setEnableTransition(true);
    }, [
        enableTransition
    ]);
    (0, $cQmXV.useEffect)(()=>{
        if (!open) resetTransform("close");
    }, [
        open
    ]);
    // ========================== Image ===========================
    const onDoubleClick = (event)=>{
        if (open) {
            if (scale !== 1) updateTransform({
                x: 0,
                y: 0,
                scale: 1
            }, "doubleClick");
            else dispatchZoomChange((0, $e3148aa1d7aecacb$export$6e76060232ffaf48) + scaleStep, "doubleClick", event.clientX, event.clientY);
        }
    };
    const imgNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($198c37323f34246d$var$PreviewImage, $198c37323f34246d$var$_extends({}, imgCommonProps, {
        width: props.width,
        height: props.height,
        imgRef: imgRef,
        className: `${prefixCls}-img`,
        alt: alt,
        style: {
            transform: `translate3d(${transform.x}px, ${transform.y}px, 0) scale3d(${transform.flipX ? "-" : ""}${scale}, ${transform.flipY ? "-" : ""}${scale}, 1) rotate(${rotate}deg)`,
            transitionDuration: (!enableTransition || isTouching) && "0s"
        },
        fallback: fallback,
        src: src,
        onWheel: onWheel,
        onMouseDown: onMouseDown,
        onDoubleClick: onDoubleClick,
        onTouchStart: onTouchStart,
        onTouchMove: onTouchMove,
        onTouchEnd: onTouchEnd,
        onTouchCancel: onTouchEnd
    }));
    const image = {
        url: src,
        alt: alt,
        ...imageInfo
    };
    // ======================== Operation =========================
    // >>>>> Actions
    const onZoomIn = ()=>{
        dispatchZoomChange((0, $e3148aa1d7aecacb$export$6e76060232ffaf48) + scaleStep, "zoomIn");
    };
    const onZoomOut = ()=>{
        dispatchZoomChange((0, $e3148aa1d7aecacb$export$6e76060232ffaf48) / ((0, $e3148aa1d7aecacb$export$6e76060232ffaf48) + scaleStep), "zoomOut");
    };
    const onRotateRight = ()=>{
        updateTransform({
            rotate: rotate + 90
        }, "rotateRight");
    };
    const onRotateLeft = ()=>{
        updateTransform({
            rotate: rotate - 90
        }, "rotateLeft");
    };
    const onFlipX = ()=>{
        updateTransform({
            flipX: !transform.flipX
        }, "flipX");
    };
    const onFlipY = ()=>{
        updateTransform({
            flipY: !transform.flipY
        }, "flipY");
    };
    const onReset = ()=>{
        resetTransform("reset");
    };
    const onActive = (offset)=>{
        const nextCurrent = current + offset;
        if (nextCurrent >= 0 && nextCurrent <= count - 1) {
            setEnableTransition(false);
            resetTransform(offset < 0 ? "prev" : "next");
            onChange?.(nextCurrent, current);
        }
    };
    // >>>>> Effect: Keyboard
    const onKeyDown = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((event)=>{
        if (open) {
            const { keyCode: keyCode } = event;
            if (showLeftOrRightSwitches) {
                if (keyCode === (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).LEFT) onActive(-1);
                else if (keyCode === (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).RIGHT) onActive(1);
            }
        }
    });
    (0, $cQmXV.useEffect)(()=>{
        if (open) {
            window.addEventListener("keydown", onKeyDown);
            return ()=>{
                window.removeEventListener("keydown", onKeyDown);
            };
        }
    }, [
        open
    ]);
    // ======================= Lock Scroll ========================
    const [lockScroll, setLockScroll] = (0, $cQmXV.useState)(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useEffect(()=>{
        if (open) setLockScroll(true);
    }, [
        open
    ]);
    const onVisibleChanged = (nextVisible)=>{
        if (!nextVisible) {
            setLockScroll(false);
            // Restore focus to the trigger element after leave animation
            triggerRef.current?.focus?.();
            triggerRef.current = null;
        }
        afterOpenChange?.(nextVisible);
    };
    // ========================== Portal ==========================
    const [portalRender, setPortalRender] = (0, $cQmXV.useState)(false);
    (0, $7673d874dab69d07$export$2e2bcd8739ae039)(()=>{
        if (open) setPortalRender(true);
    }, [
        open
    ]);
    const onEsc = ({ top: top })=>{
        if (top) onClose?.();
    };
    // =========================== Focus ============================
    (0, $7673d874dab69d07$export$2e2bcd8739ae039)(()=>{
        if (open) triggerRef.current = document.activeElement;
    }, [
        open
    ]);
    (0, $7aa1eaa901116c60$export$9e3bf6f439c42dc9)(focusTrap && open && portalRender, ()=>wrapperRef.current);
    // ========================== Render ==========================
    const bodyStyle = {
        ...styles.body
    };
    if (mousePosition) bodyStyle.transformOrigin = `${mousePosition.x}px ${mousePosition.y}px`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $aa72a6fdf7676c76$export$2e2bcd8739ae039), {
        open: portalRender && open,
        autoDestroy: false,
        getContainer: getContainer,
        autoLock: lockScroll,
        onEsc: onEsc
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $04c53b89814950f8$export$2e2bcd8739ae039), {
        motionName: motionName,
        visible: portalRender && open,
        motionAppear: true,
        motionEnter: true,
        motionLeave: true,
        onVisibleChanged: onVisibleChanged
    }, ({ className: motionClassName, style: motionStyle })=>{
        const mergedStyle = {
            ...styles.root,
            ...motionStyle
        };
        if (zIndex) mergedStyle.zIndex = zIndex;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
            ref: wrapperRef,
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, rootClassName, classNames.root, motionClassName, {
                [`${prefixCls}-movable`]: movable,
                [`${prefixCls}-moving`]: isMoving
            }),
            style: mergedStyle,
            role: "dialog",
            "aria-modal": "true",
            "aria-label": alt,
            tabIndex: -1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-mask`, classNames.mask),
            style: styles.mask,
            onClick: maskClosable ? onClose : undefined
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
            className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-body`, classNames.body),
            style: bodyStyle
        }, imageRender ? imageRender(imgNode, {
            transform: transform,
            image: image,
            ...groupContext ? {
                current: current
            } : {}
        }) : imgNode), closeIcon !== false && closeIcon !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $bceaf0d371d14f06$export$2e2bcd8739ae039), {
            prefixCls: prefixCls,
            icon: closeIcon === true ? icons.close : closeIcon || icons.close,
            onClick: onClose,
            className: classNames.close,
            style: styles.close
        }), showLeftOrRightSwitches && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $cee7c3b34fbd7e5e$export$2e2bcd8739ae039), {
            prefixCls: prefixCls,
            current: current,
            count: count,
            icons: icons,
            onActive: onActive
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $ec5c36eea3f4aab1$export$2e2bcd8739ae039), {
            prefixCls: prefixCls,
            showProgress: showOperationsProgress,
            current: current,
            count: count,
            showSwitch: showLeftOrRightSwitches,
            classNames: classNames,
            styles: styles,
            image: image,
            transform: transform,
            icons: icons,
            countRender: countRender,
            actionsRender: actionsRender,
            scale: scale,
            minScale: minScale,
            maxScale: maxScale,
            onActive: onActive,
            onFlipY: onFlipY,
            onFlipX: onFlipX,
            onRotateLeft: onRotateLeft,
            onRotateRight: onRotateRight,
            onZoomOut: onZoomOut,
            onZoomIn: onZoomIn,
            onClose: onClose,
            onReset: onReset
        }));
    }));
};
var $198c37323f34246d$export$2e2bcd8739ae039 = $198c37323f34246d$var$Preview;




var $cQmXV = parcelRequire("cQmXV");



var $cQmXV = parcelRequire("cQmXV");
const $1b99547655001391$export$2367aee66755576 = [
    "crossOrigin",
    "decoding",
    "draggable",
    "loading",
    "referrerPolicy",
    "sizes",
    "srcSet",
    "useMap",
    "alt",
    "fetchPriority"
];


function $5d7ab2b8456ed268$export$2e2bcd8739ae039(items) {
    // Context collection image data
    const [images, setImages] = $cQmXV.useState({});
    const registerImage = $cQmXV.useCallback((id, data)=>{
        setImages((imgs)=>({
                ...imgs,
                [id]: data
            }));
        return ()=>{
            setImages((imgs)=>{
                const cloneImgs = {
                    ...imgs
                };
                delete cloneImgs[id];
                return cloneImgs;
            });
        };
    }, []);
    // items
    const mergedItems = $cQmXV.useMemo(()=>{
        // use `items` first
        if (items) return items.map((item)=>{
            if (typeof item === "string") return {
                data: {
                    src: item
                }
            };
            const data = {};
            Object.keys(item).forEach((key)=>{
                if ([
                    "src",
                    ...(0, $1b99547655001391$export$2367aee66755576)
                ].includes(key)) data[key] = item[key];
            });
            return {
                data: data
            };
        });
        // use registered images secondly
        return Object.keys(images).reduce((total, id)=>{
            const { canPreview: canPreview, data: data } = images[id];
            if (canPreview) total.push({
                data: data,
                id: id
            });
            return total;
        }, []);
    }, [
        items,
        images
    ]);
    return [
        mergedItems,
        registerImage,
        !!items
    ];
}


function $32cb2905f9b24691$var$_extends() {
    $32cb2905f9b24691$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $32cb2905f9b24691$var$_extends.apply(this, arguments);
}
const $32cb2905f9b24691$var$Group = ({ previewPrefixCls: previewPrefixCls = "rc-image-preview", classNames: classNames, styles: styles, children: children, icons: icons = {}, items: items, preview: preview, fallback: fallback })=>{
    const { open: previewOpen, onOpenChange: onOpenChange, current: currentIndex, onChange: onChange, ...restProps } = preview && typeof preview === "object" ? preview : {};
    // ========================== Items ===========================
    const [mergedItems, register, fromItems] = (0, $5d7ab2b8456ed268$export$2e2bcd8739ae039)(items);
    // ========================= Preview ==========================
    // >>> Index
    const [current, setCurrent] = (0, $a51866d781137e08$export$2e2bcd8739ae039)(0, currentIndex);
    const [keepOpenIndex, setKeepOpenIndex] = (0, $cQmXV.useState)(false);
    // >>> Image
    const { src: src, ...imgCommonProps } = mergedItems[current]?.data || {};
    // >>> Visible
    const [isShowPreview, setShowPreview] = (0, $a51866d781137e08$export$2e2bcd8739ae039)(!!previewOpen, previewOpen);
    const triggerShowPreview = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((next)=>{
        setShowPreview(next);
        if (next !== isShowPreview) onOpenChange?.(next, {
            current: current
        });
    });
    // >>> Position
    const [mousePosition, setMousePosition] = (0, $cQmXV.useState)(null);
    const onPreviewFromImage = $cQmXV.useCallback((id, imageSrc, mouseX, mouseY)=>{
        const index = fromItems ? mergedItems.findIndex((item)=>item.data.src === imageSrc) : mergedItems.findIndex((item)=>item.id === id);
        setCurrent(index < 0 ? 0 : index);
        triggerShowPreview(true);
        setMousePosition({
            x: mouseX,
            y: mouseY
        });
        setKeepOpenIndex(true);
    }, [
        mergedItems,
        fromItems
    ]);
    // Reset current when reopen
    $cQmXV.useEffect(()=>{
        if (isShowPreview) {
            if (!keepOpenIndex) setCurrent(0);
        } else setKeepOpenIndex(false);
    }, [
        isShowPreview
    ]);
    // ========================== Events ==========================
    const onInternalChange = (next, prev)=>{
        setCurrent(next);
        onChange?.(next, prev);
    };
    const onPreviewClose = ()=>{
        triggerShowPreview(false);
        setMousePosition(null);
    };
    // ========================= Context ==========================
    const previewGroupContext = $cQmXV.useMemo(()=>({
            register: register,
            onPreview: onPreviewFromImage
        }), [
        register,
        onPreviewFromImage
    ]);
    // ========================== Render ==========================
    return /*#__PURE__*/ $cQmXV.createElement((0, $c68ed2119d59ce29$export$3062997f0b99863).Provider, {
        value: previewGroupContext
    }, children, /*#__PURE__*/ $cQmXV.createElement((0, $198c37323f34246d$export$2e2bcd8739ae039), $32cb2905f9b24691$var$_extends({
        "aria-hidden": !isShowPreview,
        open: isShowPreview,
        prefixCls: previewPrefixCls,
        onClose: onPreviewClose,
        mousePosition: mousePosition,
        imgCommonProps: imgCommonProps,
        src: src,
        fallback: fallback,
        icons: icons,
        current: current,
        count: mergedItems.length,
        onChange: onInternalChange
    }, restProps, {
        classNames: classNames?.popup,
        styles: styles?.popup
    })));
};
var $32cb2905f9b24691$export$2e2bcd8739ae039 = $32cb2905f9b24691$var$Group;





var $cQmXV = parcelRequire("cQmXV");

let $632c4cd354afe806$var$uid = 0;
function $632c4cd354afe806$export$2e2bcd8739ae039(canPreview, data) {
    const [id] = $cQmXV.useState(()=>{
        $632c4cd354afe806$var$uid += 1;
        return String($632c4cd354afe806$var$uid);
    });
    const groupContext = $cQmXV.useContext((0, $c68ed2119d59ce29$export$3062997f0b99863));
    const registerData = {
        data: data,
        canPreview: canPreview
    };
    // Keep order start
    // Resolve https://github.com/ant-design/ant-design/issues/28881
    // Only need unRegister when component unMount
    $cQmXV.useEffect(()=>{
        if (groupContext) return groupContext.register(id, registerData);
    }, []);
    $cQmXV.useEffect(()=>{
        if (groupContext) groupContext.register(id, registerData);
    }, [
        canPreview,
        data
    ]);
    return id;
}



function $ce847a3f9d261668$var$_extends() {
    $ce847a3f9d261668$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ce847a3f9d261668$var$_extends.apply(this, arguments);
}
const $ce847a3f9d261668$var$ImageInternal = (props)=>{
    const { prefixCls: // Misc
    prefixCls = "rc-image", previewPrefixCls: previewPrefixCls = `${prefixCls}-preview`, rootClassName: // Style
    rootClassName, className: className, style: style, classNames: classNames = {}, styles: styles = {}, width: width, height: height, // Image
    src: imgSrc, alt: alt, placeholder: placeholder, fallback: fallback, preview: // Preview
    preview = true, onClick: // Events
    onClick, onError: onError, onKeyDown: onKeyDown, ...otherProps } = props;
    const groupContext = (0, $cQmXV.useContext)((0, $c68ed2119d59ce29$export$3062997f0b99863));
    // ========================== Preview ===========================
    const canPreview = !!preview;
    const { src: previewSrc, open: previewOpen, onOpenChange: onPreviewOpenChange, cover: cover, rootClassName: previewRootClassName, ...restProps } = preview && typeof preview === "object" ? preview : {};
    const coverPlacement = typeof cover === "object" && cover.placement ? cover.placement || "center" : "center";
    const coverNode = typeof cover === "object" && cover.coverNode ? cover.coverNode : cover;
    // ============================ Open ============================
    const [isShowPreview, setShowPreview] = (0, $a51866d781137e08$export$2e2bcd8739ae039)(!!previewOpen, previewOpen);
    const [mousePosition, setMousePosition] = (0, $cQmXV.useState)(null);
    const triggerPreviewOpen = (nextOpen)=>{
        setShowPreview(nextOpen);
        onPreviewOpenChange?.(nextOpen);
    };
    const onPreviewClose = ()=>{
        triggerPreviewOpen(false);
    };
    // ========================= ImageProps =========================
    const isCustomPlaceholder = placeholder && placeholder !== true;
    const src = previewSrc ?? imgSrc;
    const [getImgRef, srcAndOnload, status] = (0, $9cab1977659d2768$export$2e2bcd8739ae039)({
        src: imgSrc,
        isCustomPlaceholder: isCustomPlaceholder,
        fallback: fallback
    });
    const imgCommonProps = (0, $cQmXV.useMemo)(()=>{
        const obj = {};
        (0, $1b99547655001391$export$2367aee66755576).forEach((prop)=>{
            if (props[prop] !== undefined) obj[prop] = props[prop];
        });
        return obj;
    }, (0, $1b99547655001391$export$2367aee66755576).map((prop)=>props[prop]));
    // ========================== Register ==========================
    const registerData = (0, $cQmXV.useMemo)(()=>({
            ...imgCommonProps,
            src: src
        }), [
        src,
        imgCommonProps
    ]);
    const imageId = (0, $632c4cd354afe806$export$2e2bcd8739ae039)(canPreview, registerData);
    // ========================== Preview ===========================
    const onPreview = (e)=>{
        const rect = e.target.getBoundingClientRect();
        const left = rect.x + rect.width / 2;
        const top = rect.y + rect.height / 2;
        if (groupContext) groupContext.onPreview(imageId, src, left, top);
        else {
            setMousePosition({
                x: left,
                y: top
            });
            triggerPreviewOpen(true);
        }
        onClick?.(e);
    };
    // ======================= Keyboard Preview =====================
    const onPreviewKeyDown = (event)=>{
        onKeyDown?.(event);
        if (!canPreview) return;
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            const rect = event.target.getBoundingClientRect();
            const left = rect.x + rect.width / 2;
            const top = rect.y + rect.height / 2;
            if (groupContext) groupContext.onPreview(imageId, src, left, top);
            else {
                setMousePosition({
                    x: left,
                    y: top
                });
                triggerPreviewOpen(true);
            }
        }
    };
    // =========================== Render ===========================
    return /*#__PURE__*/ $cQmXV.createElement($cQmXV.Fragment, null, /*#__PURE__*/ $cQmXV.createElement("div", $ce847a3f9d261668$var$_extends({}, otherProps, {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, rootClassName, classNames.root, {
            [`${prefixCls}-error`]: status === "error"
        }),
        onClick: canPreview ? onPreview : onClick,
        role: canPreview ? "button" : otherProps.role,
        tabIndex: canPreview && otherProps.tabIndex == null ? 0 : otherProps.tabIndex,
        "aria-label": canPreview ? otherProps["aria-label"] ?? alt : otherProps["aria-label"],
        onKeyDown: onPreviewKeyDown,
        style: {
            width: width,
            height: height,
            ...styles.root
        }
    }), /*#__PURE__*/ $cQmXV.createElement("img", $ce847a3f9d261668$var$_extends({}, imgCommonProps, {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-img`, {
            [`${prefixCls}-img-placeholder`]: placeholder === true
        }, classNames.image, className),
        style: {
            height: height,
            ...styles.image,
            ...style
        },
        ref: getImgRef
    }, srcAndOnload, {
        width: width,
        height: height,
        onError: onError
    })), status === "loading" && /*#__PURE__*/ $cQmXV.createElement("div", {
        "aria-hidden": "true",
        className: `${prefixCls}-placeholder`
    }, placeholder), cover !== false && canPreview && /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-cover`, classNames.cover, `${prefixCls}-cover-${coverPlacement}`),
        style: {
            display: style?.display === "none" ? "none" : undefined,
            ...styles.cover
        }
    }, coverNode)), !groupContext && canPreview && /*#__PURE__*/ $cQmXV.createElement((0, $198c37323f34246d$export$2e2bcd8739ae039), $ce847a3f9d261668$var$_extends({
        "aria-hidden": !isShowPreview,
        open: isShowPreview,
        prefixCls: previewPrefixCls,
        onClose: onPreviewClose,
        mousePosition: mousePosition,
        src: src,
        alt: alt,
        imageInfo: {
            width: width,
            height: height
        },
        fallback: fallback,
        imgCommonProps: imgCommonProps
    }, restProps, {
        classNames: classNames?.popup,
        styles: styles?.popup,
        rootClassName: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(previewRootClassName, rootClassName)
    })));
};
$ce847a3f9d261668$var$ImageInternal.PreviewGroup = (0, $32cb2905f9b24691$export$2e2bcd8739ae039);
var $ce847a3f9d261668$export$2e2bcd8739ae039 = $ce847a3f9d261668$var$ImageInternal;


var $6388b10bd30f3904$export$2e2bcd8739ae039 = (0, $ce847a3f9d261668$export$2e2bcd8739ae039);








var $cQmXV = parcelRequire("cQmXV");



const $654c8de64df62232$var$useMergedPreviewConfig = (previewConfig, contextPreviewConfig, prefixCls, mergedRootClassName, getContextPopupContainer, icons, defaultCover)=>{
    const [zIndex] = (0, $b2b300e6909d7707$export$3e7906d4075187a4)("ImagePreview", previewConfig?.zIndex);
    const [mergedPreviewMask, blurClassName, mergedMaskClosable] = (0, $43591a623a20c2b6$export$a4ac1bdd74570410)(previewConfig?.mask, contextPreviewConfig?.mask, `${prefixCls}-preview`);
    return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useMemo(()=>{
        if (!previewConfig) return previewConfig;
        const { cover: cover, getContainer: getContainer, closeIcon: closeIcon, rootClassName: previewRootClassName } = previewConfig;
        const { closeIcon: contextCloseIcon } = contextPreviewConfig ?? {};
        return {
            motionName: (0, $047a5f051ebda8ba$export$27c72201b1d09951)(`${prefixCls}-preview`, "fade"),
            ...previewConfig,
            ...defaultCover ? {
                cover: cover ?? defaultCover
            } : {},
            icons: icons,
            getContainer: getContainer ?? getContextPopupContainer,
            zIndex: zIndex,
            closeIcon: closeIcon ?? contextCloseIcon,
            rootClassName: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(mergedRootClassName, previewRootClassName),
            mask: mergedPreviewMask,
            maskClosable: mergedMaskClosable,
            blurClassName: blurClassName.mask
        };
    }, [
        previewConfig,
        contextPreviewConfig,
        prefixCls,
        mergedRootClassName,
        getContextPopupContainer,
        defaultCover,
        icons,
        zIndex,
        mergedPreviewMask,
        mergedMaskClosable,
        blurClassName
    ]);
};
var $654c8de64df62232$export$2e2bcd8739ae039 = $654c8de64df62232$var$useMergedPreviewConfig;



var $cQmXV = parcelRequire("cQmXV");

function $f33cfe509d3a6526$export$729c95a855c13bb3(placeholder) {
    return (0, $8e2d153a3c855782$export$53b83ca8eaab0383)(placeholder) && !/*#__PURE__*/ (0, $cQmXV.isValidElement)(placeholder);
}
function $f33cfe509d3a6526$export$2e2bcd8739ae039(placeholder) {
    return (0, $cQmXV.useMemo)(()=>{
        if (!placeholder || !$f33cfe509d3a6526$export$729c95a855c13bb3(placeholder)) return {};
        if (typeof placeholder.progress === "boolean") return {
            progressConfig: placeholder.progress ? {} : undefined
        };
        return {
            progressConfig: placeholder.progress
        };
    }, [
        placeholder
    ]);
}



var $cQmXV = parcelRequire("cQmXV");


function $a4ea6279308af340$var$normalizeMask(mask) {
    if (/*#__PURE__*/ (0, $cQmXV.isValidElement)(mask)) return [
        mask,
        undefined
    ];
    if (typeof mask === "boolean" || (0, $8e2d153a3c855782$export$53b83ca8eaab0383)(mask)) return [
        undefined,
        mask
    ];
    return [
        undefined,
        undefined
    ];
}
function $a4ea6279308af340$export$2e2bcd8739ae039(preview) {
    // Get origin preview config
    const rawPreviewConfig = (0, $cQmXV.useMemo)(()=>{
        if (typeof preview === "boolean") return preview ? {} : null;
        return (0, $8e2d153a3c855782$export$53b83ca8eaab0383)(preview) ? preview : {};
    }, [
        preview
    ]);
    const splittedPreviewConfig = (0, $cQmXV.useMemo)(()=>{
        if (!rawPreviewConfig) return [
            rawPreviewConfig,
            "",
            ""
        ];
        const { open: open, onOpenChange: onOpenChange, cover: cover, actionsRender: actionsRender, visible: visible, onVisibleChange: onVisibleChange, rootClassName: rootClassName, maskClassName: maskClassName, mask: mask, forceRender: _forceRender, destroyOnClose: _destroyOnClose, toolbarRender: toolbarRender, ...restPreviewConfig } = rawPreviewConfig;
        let onInternalOpenChange;
        if (onOpenChange) onInternalOpenChange = onOpenChange;
        else if (onVisibleChange) onInternalOpenChange = (nextOpen, info)=>{
            const { current: current } = info || {};
            if (current !== undefined) onVisibleChange(nextOpen, !nextOpen, current);
            else onVisibleChange(nextOpen, !nextOpen);
        };
        const [coverElement, maskConfig] = $a4ea6279308af340$var$normalizeMask(mask);
        return [
            {
                ...restPreviewConfig,
                open: open ?? visible,
                onOpenChange: onInternalOpenChange,
                cover: cover ?? coverElement,
                mask: maskConfig,
                actionsRender: actionsRender ?? toolbarRender
            },
            rootClassName,
            maskClassName
        ];
    }, [
        rawPreviewConfig
    ]);
    var deprecatedName, newName;
    return splittedPreviewConfig;
}



var $cQmXV = parcelRequire("cQmXV");




var $cQmXV = parcelRequire("cQmXV");
var $51d55e6dad731924$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($51d55e6dad731924$exports, "__esModule", {
    value: true
});
var $51d55e6dad731924$var$RotateLeftOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M672 418H144c-17.7 0-32 14.3-32 32v414c0 17.7 14.3 32 32 32h528c17.7 0 32-14.3 32-32V450c0-17.7-14.3-32-32-32zm-44 402H188V494h440v326z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M819.3 328.5c-78.8-100.7-196-153.6-314.6-154.2l-.2-64c0-6.5-7.6-10.1-12.6-6.1l-128 101c-4 3.1-3.9 9.1 0 12.3L492 318.6c5.1 4 12.7.4 12.6-6.1v-63.9c12.9.1 25.9.9 38.8 2.5 42.1 5.2 82.1 18.2 119 38.7 38.1 21.2 71.2 49.7 98.4 84.3 27.1 34.7 46.7 73.7 58.1 115.8a325.95 325.95 0 016.5 140.9h74.9c14.8-103.6-11.3-213-81-302.3z"
                }
            }
        ]
    },
    "name": "rotate-left",
    "theme": "outlined"
};
$51d55e6dad731924$exports.default = $51d55e6dad731924$var$RotateLeftOutlined;



function $b43c93cd5468b78d$var$_extends() {
    $b43c93cd5468b78d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b43c93cd5468b78d$var$_extends.apply(this, arguments);
}
const $b43c93cd5468b78d$var$RotateLeftOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $b43c93cd5468b78d$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($51d55e6dad731924$exports)))
    }));
/**![rotate-left](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTY3MiA0MThIMTQ0Yy0xNy43IDAtMzIgMTQuMy0zMiAzMnY0MTRjMCAxNy43IDE0LjMgMzIgMzIgMzJoNTI4YzE3LjcgMCAzMi0xNC4zIDMyLTMyVjQ1MGMwLTE3LjctMTQuMy0zMi0zMi0zMnptLTQ0IDQwMkgxODhWNDk0aDQ0MHYzMjZ6IiAvPjxwYXRoIGQ9Ik04MTkuMyAzMjguNWMtNzguOC0xMDAuNy0xOTYtMTUzLjYtMzE0LjYtMTU0LjJsLS4yLTY0YzAtNi41LTcuNi0xMC4xLTEyLjYtNi4xbC0xMjggMTAxYy00IDMuMS0zLjkgOS4xIDAgMTIuM0w0OTIgMzE4LjZjNS4xIDQgMTIuNy40IDEyLjYtNi4xdi02My45YzEyLjkuMSAyNS45LjkgMzguOCAyLjUgNDIuMSA1LjIgODIuMSAxOC4yIDExOSAzOC43IDM4LjEgMjEuMiA3MS4yIDQ5LjcgOTguNCA4NC4zIDI3LjEgMzQuNyA0Ni43IDczLjcgNTguMSAxMTUuOGEzMjUuOTUgMzI1Ljk1IDAgMDE2LjUgMTQwLjloNzQuOWMxNC44LTEwMy42LTExLjMtMjEzLTgxLTMwMi4zeiIgLz48L3N2Zz4=) */ const $b43c93cd5468b78d$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($b43c93cd5468b78d$var$RotateLeftOutlined);
var $b43c93cd5468b78d$export$2e2bcd8739ae039 = $b43c93cd5468b78d$var$RefIcon;



var $cQmXV = parcelRequire("cQmXV");
var $5b873d496add674d$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($5b873d496add674d$exports, "__esModule", {
    value: true
});
var $5b873d496add674d$var$RotateRightOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M480.5 251.2c13-1.6 25.9-2.4 38.8-2.5v63.9c0 6.5 7.5 10.1 12.6 6.1L660 217.6c4-3.2 4-9.2 0-12.3l-128-101c-5.1-4-12.6-.4-12.6 6.1l-.2 64c-118.6.5-235.8 53.4-314.6 154.2A399.75 399.75 0 00123.5 631h74.9c-.9-5.3-1.7-10.7-2.4-16.1-5.1-42.1-2.1-84.1 8.9-124.8 11.4-42.2 31-81.1 58.1-115.8 27.2-34.7 60.3-63.2 98.4-84.3 37-20.6 76.9-33.6 119.1-38.8z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M880 418H352c-17.7 0-32 14.3-32 32v414c0 17.7 14.3 32 32 32h528c17.7 0 32-14.3 32-32V450c0-17.7-14.3-32-32-32zm-44 402H396V494h440v326z"
                }
            }
        ]
    },
    "name": "rotate-right",
    "theme": "outlined"
};
$5b873d496add674d$exports.default = $5b873d496add674d$var$RotateRightOutlined;



function $1e5d2bd177a61753$var$_extends() {
    $1e5d2bd177a61753$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1e5d2bd177a61753$var$_extends.apply(this, arguments);
}
const $1e5d2bd177a61753$var$RotateRightOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $1e5d2bd177a61753$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5b873d496add674d$exports)))
    }));
/**![rotate-right](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTQ4MC41IDI1MS4yYzEzLTEuNiAyNS45LTIuNCAzOC44LTIuNXY2My45YzAgNi41IDcuNSAxMC4xIDEyLjYgNi4xTDY2MCAyMTcuNmM0LTMuMiA0LTkuMiAwLTEyLjNsLTEyOC0xMDFjLTUuMS00LTEyLjYtLjQtMTIuNiA2LjFsLS4yIDY0Yy0xMTguNi41LTIzNS44IDUzLjQtMzE0LjYgMTU0LjJBMzk5Ljc1IDM5OS43NSAwIDAwMTIzLjUgNjMxaDc0LjljLS45LTUuMy0xLjctMTAuNy0yLjQtMTYuMS01LjEtNDIuMS0yLjEtODQuMSA4LjktMTI0LjggMTEuNC00Mi4yIDMxLTgxLjEgNTguMS0xMTUuOCAyNy4yLTM0LjcgNjAuMy02My4yIDk4LjQtODQuMyAzNy0yMC42IDc2LjktMzMuNiAxMTkuMS0zOC44eiIgLz48cGF0aCBkPSJNODgwIDQxOEgzNTJjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjQxNGMwIDE3LjcgMTQuMyAzMiAzMiAzMmg1MjhjMTcuNyAwIDMyLTE0LjMgMzItMzJWNDUwYzAtMTcuNy0xNC4zLTMyLTMyLTMyem0tNDQgNDAySDM5NlY0OTRoNDQwdjMyNnoiIC8+PC9zdmc+) */ const $1e5d2bd177a61753$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($1e5d2bd177a61753$var$RotateRightOutlined);
var $1e5d2bd177a61753$export$2e2bcd8739ae039 = $1e5d2bd177a61753$var$RefIcon;



var $cQmXV = parcelRequire("cQmXV");
var $95a72acd21d21154$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($95a72acd21d21154$exports, "__esModule", {
    value: true
});
var $95a72acd21d21154$var$SwapOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M847.9 592H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h605.2L612.9 851c-4.1 5.2-.4 13 6.3 13h72.5c4.9 0 9.5-2.2 12.6-6.1l168.8-214.1c16.5-21 1.6-51.8-25.2-51.8zM872 356H266.8l144.3-183c4.1-5.2.4-13-6.3-13h-72.5c-4.9 0-9.5 2.2-12.6 6.1L150.9 380.2c-16.5 21-1.6 51.8 25.1 51.8h696c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "swap",
    "theme": "outlined"
};
$95a72acd21d21154$exports.default = $95a72acd21d21154$var$SwapOutlined;



function $4ba33a962ed90fbf$var$_extends() {
    $4ba33a962ed90fbf$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4ba33a962ed90fbf$var$_extends.apply(this, arguments);
}
const $4ba33a962ed90fbf$var$SwapOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $4ba33a962ed90fbf$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($95a72acd21d21154$exports)))
    }));
/**![swap](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg0Ny45IDU5MkgxNTJjLTQuNCAwLTggMy42LTggOHY2MGMwIDQuNCAzLjYgOCA4IDhoNjA1LjJMNjEyLjkgODUxYy00LjEgNS4yLS40IDEzIDYuMyAxM2g3Mi41YzQuOSAwIDkuNS0yLjIgMTIuNi02LjFsMTY4LjgtMjE0LjFjMTYuNS0yMSAxLjYtNTEuOC0yNS4yLTUxLjh6TTg3MiAzNTZIMjY2LjhsMTQ0LjMtMTgzYzQuMS01LjIuNC0xMy02LjMtMTNoLTcyLjVjLTQuOSAwLTkuNSAyLjItMTIuNiA2LjFMMTUwLjkgMzgwLjJjLTE2LjUgMjEtMS42IDUxLjggMjUuMSA1MS44aDY5NmM0LjQgMCA4LTMuNiA4LTh2LTYwYzAtNC40LTMuNi04LTgtOHoiIC8+PC9zdmc+) */ const $4ba33a962ed90fbf$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($4ba33a962ed90fbf$var$SwapOutlined);
var $4ba33a962ed90fbf$export$2e2bcd8739ae039 = $4ba33a962ed90fbf$var$RefIcon;



var $cQmXV = parcelRequire("cQmXV");
var $55930603353a3382$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($55930603353a3382$exports, "__esModule", {
    value: true
});
var $55930603353a3382$var$ZoomInOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M637 443H519V309c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v134H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h118v134c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V519h118c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z"
                }
            }
        ]
    },
    "name": "zoom-in",
    "theme": "outlined"
};
$55930603353a3382$exports.default = $55930603353a3382$var$ZoomInOutlined;



function $815b934ea3c76706$var$_extends() {
    $815b934ea3c76706$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $815b934ea3c76706$var$_extends.apply(this, arguments);
}
const $815b934ea3c76706$var$ZoomInOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $815b934ea3c76706$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($55930603353a3382$exports)))
    }));
/**![zoom-in](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTYzNyA0NDNINTE5VjMwOWMwLTQuNC0zLjYtOC04LThoLTYwYy00LjQgMC04IDMuNi04IDh2MTM0SDMyNWMtNC40IDAtOCAzLjYtOCA4djYwYzAgNC40IDMuNiA4IDggOGgxMTh2MTM0YzAgNC40IDMuNiA4IDggOGg2MGM0LjQgMCA4LTMuNiA4LThWNTE5aDExOGM0LjQgMCA4LTMuNiA4LTh2LTYwYzAtNC40LTMuNi04LTgtOHptMjg0IDQyNEw3NzUgNzIxYzEyMi4xLTE0OC45IDExMy42LTM2OS41LTI2LTUwOS0xNDgtMTQ4LjEtMzg4LjQtMTQ4LjEtNTM3IDAtMTQ4LjEgMTQ4LjYtMTQ4LjEgMzg5IDAgNTM3IDEzOS41IDEzOS42IDM2MC4xIDE0OC4xIDUwOSAyNmwxNDYgMTQ2YzMuMiAyLjggOC4zIDIuOCAxMSAwbDQzLTQzYzIuOC0yLjcgMi44LTcuOCAwLTExek02OTYgNjk2Yy0xMTguOCAxMTguNy0zMTEuMiAxMTguNy00MzAgMC0xMTguNy0xMTguOC0xMTguNy0zMTEuMiAwLTQzMCAxMTguOC0xMTguNyAzMTEuMi0xMTguNyA0MzAgMCAxMTguNyAxMTguOCAxMTguNyAzMTEuMiAwIDQzMHoiIC8+PC9zdmc+) */ const $815b934ea3c76706$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($815b934ea3c76706$var$ZoomInOutlined);
var $815b934ea3c76706$export$2e2bcd8739ae039 = $815b934ea3c76706$var$RefIcon;



var $cQmXV = parcelRequire("cQmXV");
var $1ff124741a2e76fa$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($1ff124741a2e76fa$exports, "__esModule", {
    value: true
});
var $1ff124741a2e76fa$var$ZoomOutOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M637 443H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h312c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z"
                }
            }
        ]
    },
    "name": "zoom-out",
    "theme": "outlined"
};
$1ff124741a2e76fa$exports.default = $1ff124741a2e76fa$var$ZoomOutOutlined;



function $ccc5bd0954e2dcd0$var$_extends() {
    $ccc5bd0954e2dcd0$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ccc5bd0954e2dcd0$var$_extends.apply(this, arguments);
}
const $ccc5bd0954e2dcd0$var$ZoomOutOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $ccc5bd0954e2dcd0$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1ff124741a2e76fa$exports)))
    }));
/**![zoom-out](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTYzNyA0NDNIMzI1Yy00LjQgMC04IDMuNi04IDh2NjBjMCA0LjQgMy42IDggOCA4aDMxMmM0LjQgMCA4LTMuNiA4LTh2LTYwYzAtNC40LTMuNi04LTgtOHptMjg0IDQyNEw3NzUgNzIxYzEyMi4xLTE0OC45IDExMy42LTM2OS41LTI2LTUwOS0xNDgtMTQ4LjEtMzg4LjQtMTQ4LjEtNTM3IDAtMTQ4LjEgMTQ4LjYtMTQ4LjEgMzg5IDAgNTM3IDEzOS41IDEzOS42IDM2MC4xIDE0OC4xIDUwOSAyNmwxNDYgMTQ2YzMuMiAyLjggOC4zIDIuOCAxMSAwbDQzLTQzYzIuOC0yLjcgMi44LTcuOCAwLTExek02OTYgNjk2Yy0xMTguOCAxMTguNy0zMTEuMiAxMTguNy00MzAgMC0xMTguNy0xMTguOC0xMTguNy0zMTEuMiAwLTQzMCAxMTguOC0xMTguNyAzMTEuMi0xMTguNyA0MzAgMCAxMTguNyAxMTguOCAxMTguNyAzMTEuMiAwIDQzMHoiIC8+PC9zdmc+) */ const $ccc5bd0954e2dcd0$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($ccc5bd0954e2dcd0$var$ZoomOutOutlined);
var $ccc5bd0954e2dcd0$export$2e2bcd8739ae039 = $ccc5bd0954e2dcd0$var$RefIcon;














const $5deb16b44e5f553c$export$6d28acd232c7303a = new (0, $e928d3664c9ed565$export$2e2bcd8739ae039)("antImageProgressActive", {
    "0%": {
        backgroundPosition: "200% 0"
    },
    "100%": {
        backgroundPosition: "-200% 0"
    }
});
// Create ink flow keyframes with custom transform and opacity values
const $5deb16b44e5f553c$var$createInkFlow = (name, midTransform, midOpacity, startTransform = "translate(0%, 0%)", startOpacity = 0.8)=>new (0, $e928d3664c9ed565$export$2e2bcd8739ae039)(name, {
        "0%": {
            transform: startTransform,
            opacity: startOpacity
        },
        "50%": {
            transform: midTransform,
            opacity: midOpacity
        },
        "100%": {
            transform: startTransform,
            opacity: startOpacity
        }
    });
const $5deb16b44e5f553c$export$19e31ec1aa2435f2 = $5deb16b44e5f553c$var$createInkFlow("antImageInkFlow1", "translate(15%, -20%) scale(1.25)", 0.5);
const $5deb16b44e5f553c$export$d4e9298c0358b871 = $5deb16b44e5f553c$var$createInkFlow("antImageInkFlow2", "translate(-18%, 15%) scale(0.85)", 0.9, "translate(0%, 0%) scale(1.1)", 0.7);
const $5deb16b44e5f553c$export$be16572567cbe58e = $5deb16b44e5f553c$var$createInkFlow("antImageInkFlow3", "translate(8%, 10%) scale(1.15)", 0.8, "translate(0%, 0%) scale(0.85)", 0.65);


const $07810788e8ac3200$export$cee50e75a801b845 = (position)=>({
        position: position || "absolute",
        inset: 0
    });
const $07810788e8ac3200$export$6a2be70d6f540150 = (token)=>{
    const { componentCls: componentCls, motionDurationSlow: motionDurationSlow, colorTextLightSolid: colorTextLightSolid } = token;
    return {
        [componentCls]: {
            [`${componentCls}-cover`]: {
                position: "absolute",
                inset: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: colorTextLightSolid,
                background: new (0, $3bb84f07fb2a2f32$export$2c4f38d6c0ecc25a)("#000").setA(0.3).toRgbString(),
                cursor: "pointer",
                opacity: 0,
                transition: `opacity ${motionDurationSlow}`
            },
            "&:hover, &:focus-visible": {
                [`${componentCls}-cover`]: {
                    opacity: 1
                }
            },
            [`${componentCls}-cover-top`]: {
                inset: "0 0 auto 0",
                justifyContent: "center"
            },
            [`${componentCls}-cover-bottom`]: {
                inset: "auto 0 0 0",
                justifyContent: "center"
            }
        }
    };
};
const $07810788e8ac3200$export$4f4590c44d659a82 = (token)=>{
    const { componentCls: componentCls, motionDurationMid: motionDurationMid, motionEaseInOut: motionEaseInOut, progressAnimationDuration: progressAnimationDuration } = token;
    // Common ink layer base styles
    const inkBaseStyle = {
        position: "absolute",
        width: "150%",
        height: "150%",
        left: "-25%",
        top: "-25%",
        animationTimingFunction: motionEaseInOut,
        animationIterationCount: "infinite",
        pointerEvents: "none",
        willChange: "transform, opacity"
    };
    return {
        // Progress root (wrapper)
        [`${componentCls}-progress-wrapper`]: {
            position: "relative",
            display: "inline-block",
            overflow: "hidden",
            borderRadius: "inherit",
            backgroundColor: token.colorBgBase,
            backdropFilter: "blur(8px)",
            // Ink group 1: Ink 1 (main) + Ink 2 (::before) + Ink 3 (::after)
            [`${componentCls}-progress-ink-1`]: {
                ...inkBaseStyle,
                // Ink 1 - Top left blue cloud
                background: `radial-gradient(ellipse 65% 55% at 25% 30%, rgba(100, 180, 255, 0.98) 0%, transparent 55%)`,
                animationName: (0, $5deb16b44e5f553c$export$19e31ec1aa2435f2),
                animationDuration: progressAnimationDuration,
                filter: "blur(40px)",
                // Ink 2 - Center right lavender
                "&::before": {
                    content: '""',
                    ...inkBaseStyle,
                    background: `radial-gradient(ellipse 60% 65% at 75% 45%, rgba(180, 140, 255, 0.95) 0%, transparent 50%)`,
                    animationName: (0, $5deb16b44e5f553c$export$d4e9298c0358b871),
                    animationDuration: `calc(${progressAnimationDuration} + 2s)`,
                    animationDelay: "-1s",
                    filter: "blur(45px)"
                },
                // Ink 3 - Bottom center cyan
                "&::after": {
                    content: '""',
                    ...inkBaseStyle,
                    background: `radial-gradient(ellipse 55% 50% at 50% 70%, rgba(100, 220, 220, 0.9) 0%, transparent 45%)`,
                    animationName: (0, $5deb16b44e5f553c$export$be16572567cbe58e),
                    animationDuration: `calc(${progressAnimationDuration} + 0.5s)`,
                    animationDelay: "-2s",
                    filter: "blur(38px)"
                }
            },
            // Ink group 2: Ink 4 (main) + Ink 5 (::before)
            [`${componentCls}-progress-ink-2`]: {
                ...inkBaseStyle,
                // Ink 4 - Scattered pink blossom
                background: `radial-gradient(ellipse 45% 40% at 60% 20%, rgba(255, 150, 200, 0.88) 0%, transparent 45%)`,
                animationName: (0, $5deb16b44e5f553c$export$be16572567cbe58e),
                animationDuration: `calc(${progressAnimationDuration} + 1.5s)`,
                animationDelay: "-3s",
                filter: "blur(42px)",
                // Ink 5 - Soft periwinkle accent
                "&::before": {
                    content: '""',
                    ...inkBaseStyle,
                    background: `radial-gradient(ellipse 50% 55% at 20% 75%, rgba(160, 190, 255, 0.88) 0%, transparent 50%)`,
                    animationName: (0, $5deb16b44e5f553c$export$19e31ec1aa2435f2),
                    animationDuration: `calc(${progressAnimationDuration} + 2.5s)`,
                    animationDelay: "-2.5s",
                    filter: "blur(35px)"
                }
            },
            // Progress content
            [`${componentCls}-progress-content`]: {
                position: "absolute",
                top: "50%",
                left: 0,
                transform: "translateY(-50%)",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: "100%",
                paddingInline: token.paddingLG,
                textAlign: "center",
                fontSize: token.fontSize,
                color: token.colorTextSecondary,
                zIndex: 1
            },
            // Progress rail (background container)
            [`${componentCls}-progress-rail`]: {
                width: "100%",
                height: 6,
                marginTop: token.marginSM,
                backgroundColor: "rgba(255, 255, 255, 0.5)",
                borderRadius: token.borderRadiusXS,
                overflow: "hidden",
                backdropFilter: "blur(4px)",
                // Track (filled portion) using ::before
                "&::before": {
                    content: '""',
                    display: "block",
                    height: "100%",
                    width: "var(--progress-percent, 0%)",
                    background: "linear-gradient(90deg, rgba(120, 170, 255, 0.85) 0%, rgba(160, 150, 245, 0.85) 40%, rgba(130, 200, 220, 0.85) 60%, rgba(120, 170, 255, 0.85) 100%)",
                    backgroundSize: "200% 100%",
                    borderRadius: token.borderRadiusXS / 2,
                    transition: `width ${motionDurationMid} ease`,
                    animationName: (0, $5deb16b44e5f553c$export$6d28acd232c7303a),
                    animationDuration: progressAnimationDuration,
                    animationTimingFunction: "linear",
                    animationIterationCount: "infinite"
                }
            },
            // Progress indicator (percent text)
            [`${componentCls}-progress-indicator`]: {
                marginTop: token.marginXS
            }
        }
    };
};
const $07810788e8ac3200$export$f8264fb430b07c9a = (token)=>{
    const { motionEaseOut: motionEaseOut, previewCls: previewCls, motionDurationSlow: motionDurationSlow, componentCls: componentCls, colorBgMask: colorBgMask, marginXL: marginXL, marginSM: marginSM, margin: margin, colorTextLightSolid: colorTextLightSolid, paddingSM: paddingSM, paddingLG: paddingLG, previewOperationHoverColor: previewOperationHoverColor, previewOperationColorDisabled: previewOperationColorDisabled, previewOperationSize: previewOperationSize, zIndexPopup: zIndexPopup } = token;
    const operationBg = new (0, $3bb84f07fb2a2f32$export$2c4f38d6c0ecc25a)(colorBgMask).setA(0.1);
    const operationBgHover = operationBg.clone().setA(0.2);
    const singleBtn = {
        position: "absolute",
        color: colorTextLightSolid,
        backgroundColor: operationBg.toRgbString(),
        borderRadius: "50%",
        padding: paddingSM,
        outline: 0,
        border: 0,
        cursor: "pointer",
        transition: `all ${motionDurationSlow}`,
        display: "flex",
        fontSize: previewOperationSize,
        "&:hover": {
            backgroundColor: operationBgHover.toRgbString()
        },
        "&:active": {
            backgroundColor: operationBg.toRgbString()
        },
        "&:focus-visible": (0, $519d20bf207ce864$export$6539948f0a737e39)(token)
    };
    return {
        [`${componentCls}-preview`]: {
            textAlign: "center",
            inset: 0,
            position: "fixed",
            userSelect: "none",
            zIndex: zIndexPopup,
            // ================= Mask =================
            [`${previewCls}-mask`]: {
                inset: 0,
                position: "absolute",
                background: colorBgMask,
                backdropFilter: "blur(0px)",
                transition: `backdrop-filter ${motionDurationSlow}`,
                [`&${componentCls}-preview-mask-blur`]: {
                    backdropFilter: "blur(4px)"
                },
                [`&${componentCls}-preview-mask-hidden`]: {
                    display: "none"
                }
            },
            // ================= Body =================
            [`${previewCls}-body`]: {
                ...$07810788e8ac3200$export$cee50e75a801b845(),
                "pointer-events": "none",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                "> *": {
                    pointerEvents: "auto"
                }
            },
            // Body > Image
            [`${previewCls}-img`]: {
                maxWidth: "100%",
                maxHeight: "70%",
                verticalAlign: "middle",
                transform: "scale3d(1, 1, 1)",
                transition: `transform ${motionDurationSlow} ${motionEaseOut} 0s`
            },
            [`&-movable ${previewCls}-img`]: {
                cursor: "grab"
            },
            [`&-moving ${previewCls}-img`]: {
                cursor: "grabbing"
            },
            // =============== CloseBtn ===============
            [`${previewCls}-close`]: {
                // Shared style
                ...singleBtn,
                top: marginSM,
                insetInlineEnd: marginSM
            },
            // ================ Switch ================
            [`${previewCls}-switch`]: {
                ...singleBtn,
                top: "50%",
                transform: `translateY(-50%)`,
                "&-disabled": {
                    "&, &:hover, &:active": {
                        color: previewOperationColorDisabled,
                        background: "transparent",
                        cursor: "not-allowed"
                    }
                },
                "&-prev": {
                    insetInlineStart: marginSM
                },
                "&-next": {
                    insetInlineEnd: marginSM
                }
            },
            // ================ Footer ================
            [`${previewCls}-footer`]: {
                position: "absolute",
                bottom: marginXL,
                left: {
                    _skip_check_: true,
                    value: "50%"
                },
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                color: token.previewOperationColor,
                transform: "translateX(-50%)",
                gap: margin
            },
            // =============== Actions ================
            [`${previewCls}-actions`]: {
                display: "flex",
                gap: paddingSM,
                padding: `0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(paddingLG)}`,
                backgroundColor: operationBg.toRgbString(),
                borderRadius: 100,
                fontSize: previewOperationSize,
                "&-action": {
                    color: "inherit",
                    background: "transparent",
                    border: 0,
                    font: "inherit",
                    padding: paddingSM,
                    cursor: "pointer",
                    transition: `all ${motionDurationSlow}`,
                    display: "flex",
                    [`&:not(${previewCls}-actions-action-disabled):hover`]: {
                        color: previewOperationHoverColor
                    },
                    "&:focus-visible": (0, $519d20bf207ce864$export$6539948f0a737e39)(token),
                    "&-disabled": {
                        color: previewOperationColorDisabled,
                        cursor: "not-allowed"
                    }
                }
            }
        }
    };
};
const $07810788e8ac3200$var$genImageStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        // ============================== image ==============================
        [componentCls]: {
            position: "relative",
            display: "inline-block",
            ...(0, $519d20bf207ce864$export$a44db842bcb28231)(token),
            [`${componentCls}-img`]: {
                width: "100%",
                height: "auto",
                verticalAlign: "middle"
            },
            [`${componentCls}-img-placeholder`]: {
                backgroundColor: token.colorBgContainerDisabled,
                backgroundImage: "url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQuNSAyLjVoLTEzQS41LjUgMCAwIDAgMSAzdjEwYS41LjUgMCAwIDAgLjUuNWgxM2EuNS41IDAgMCAwIC41LS41VjNhLjUuNSAwIDAgMC0uNS0uNXpNNS4yODEgNC43NWExIDEgMCAwIDEgMCAyIDEgMSAwIDAgMSAwLTJ6bTguMDMgNi44M2EuMTI3LjEyNyAwIDAgMS0uMDgxLjAzSDIuNzY5YS4xMjUuMTI1IDAgMCAxLS4wOTYtLjIwN2wyLjY2MS0zLjE1NmEuMTI2LjEyNiAwIDAgMSAuMTc3LS4wMTZsLjAxNi4wMTZMNy4wOCAxMC4wOWwyLjQ3LTIuOTNhLjEyNi4xMjYgMCAwIDEgLjE3Ny0uMDE2bC4wMTUuMDE2IDMuNTg4IDQuMjQ0YS4xMjcuMTI3IDAgMCAxLS4wMi4xNzV6IiBmaWxsPSIjOEM4QzhDIiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48L3N2Zz4=')",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center center",
                backgroundSize: "30%"
            },
            [`${componentCls}-placeholder`]: {
                ...$07810788e8ac3200$export$cee50e75a801b845()
            }
        }
    };
};
const $07810788e8ac3200$var$genPreviewMotion = (token)=>{
    const { previewCls: previewCls, motionDurationSlow: motionDurationSlow } = token;
    return {
        [previewCls]: {
            "&-fade": {
                transition: `opacity ${motionDurationSlow}`,
                "&-enter, &-appear": {
                    opacity: 0,
                    [`${previewCls}-body`]: {
                        transform: "scale(0)"
                    },
                    "&-active": {
                        opacity: 1,
                        [`${previewCls}-body`]: {
                            transform: "scale(1)",
                            transition: `transform ${motionDurationSlow}`
                        }
                    }
                },
                "&-leave": {
                    opacity: 1,
                    "&-active": {
                        opacity: 0,
                        [`${previewCls}-body`]: {
                            transform: "scale(0)",
                            transition: `transform ${motionDurationSlow}`
                        }
                    }
                }
            }
        }
    };
};
const $07810788e8ac3200$export$9ca1be8807fe0675 = (token)=>({
        zIndexPopup: token.zIndexPopupBase + 80,
        previewOperationColor: new (0, $3bb84f07fb2a2f32$export$2c4f38d6c0ecc25a)(token.colorTextLightSolid).setA(0.65).toRgbString(),
        previewOperationHoverColor: new (0, $3bb84f07fb2a2f32$export$2c4f38d6c0ecc25a)(token.colorTextLightSolid).setA(0.85).toRgbString(),
        previewOperationColorDisabled: new (0, $3bb84f07fb2a2f32$export$2c4f38d6c0ecc25a)(token.colorTextLightSolid).setA(0.25).toRgbString(),
        previewOperationSize: token.fontSizeIcon * 1.5,
        // FIXME: fontSizeIconLG
        progressAnimationDuration: "3s"
    });
var $07810788e8ac3200$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$51ec95de45185b42)("Image", (token)=>{
    const previewCls = `${token.componentCls}-preview`;
    const imageToken = (0, $fef50f256b80dfa5$export$4950aa0f605343fb)(token, {
        previewCls: previewCls,
        imagePreviewSwitchSize: token.controlHeightLG
    });
    return [
        $07810788e8ac3200$var$genImageStyle(imageToken),
        $07810788e8ac3200$export$6a2be70d6f540150(imageToken),
        $07810788e8ac3200$export$4f4590c44d659a82(imageToken),
        $07810788e8ac3200$export$f8264fb430b07c9a(imageToken),
        $07810788e8ac3200$var$genPreviewMotion(imageToken)
    ];
}, $07810788e8ac3200$export$9ca1be8807fe0675);


"use client";
const $e47076d3c0345de5$export$df03f54e09e486fa = {
    rotateLeft: /*#__PURE__*/ $cQmXV.createElement((0, $b43c93cd5468b78d$export$2e2bcd8739ae039), null),
    rotateRight: /*#__PURE__*/ $cQmXV.createElement((0, $1e5d2bd177a61753$export$2e2bcd8739ae039), null),
    zoomIn: /*#__PURE__*/ $cQmXV.createElement((0, $815b934ea3c76706$export$2e2bcd8739ae039), null),
    zoomOut: /*#__PURE__*/ $cQmXV.createElement((0, $ccc5bd0954e2dcd0$export$2e2bcd8739ae039), null),
    close: /*#__PURE__*/ $cQmXV.createElement((0, $837faca566926e3c$export$2e2bcd8739ae039), null),
    left: /*#__PURE__*/ $cQmXV.createElement((0, $0f3c6d60b091c877$export$2e2bcd8739ae039), null),
    right: /*#__PURE__*/ $cQmXV.createElement((0, $89db7229a7e10f8f$export$2e2bcd8739ae039), null),
    flipX: /*#__PURE__*/ $cQmXV.createElement((0, $4ba33a962ed90fbf$export$2e2bcd8739ae039), null),
    flipY: /*#__PURE__*/ $cQmXV.createElement((0, $4ba33a962ed90fbf$export$2e2bcd8739ae039), {
        rotate: 90
    })
};
const $e47076d3c0345de5$var$InternalPreviewGroup = ({ previewPrefixCls: customizePrefixCls, preview: preview, classNames: classNames, styles: styles, ...otherProps })=>{
    // =============================== MISC ===============================
    // Context
    const { getPrefixCls: getPrefixCls, getPopupContainer: getContextPopupContainer, direction: direction, preview: contextPreview, classNames: contextClassNames, styles: contextStyles } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("image");
    const prefixCls = getPrefixCls("image", customizePrefixCls);
    const previewPrefixCls = `${prefixCls}-preview`;
    // ============================== Style ===============================
    const rootCls = (0, $2237081acd3cfc09$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $07810788e8ac3200$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const mergedRootClassName = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(hashId, cssVarCls, rootCls);
    // ============================= Preview ==============================
    const [previewConfig, previewRootClassName, previewMaskClassName] = (0, $a4ea6279308af340$export$2e2bcd8739ae039)(preview);
    const [contextPreviewConfig, contextPreviewRootClassName, contextPreviewMaskClassName] = (0, $a4ea6279308af340$export$2e2bcd8739ae039)(contextPreview);
    // ============================ Semantics =============================
    const memoizedIcons = $cQmXV.useMemo(()=>({
            ...$e47076d3c0345de5$export$df03f54e09e486fa,
            left: direction === "rtl" ? /*#__PURE__*/ $cQmXV.createElement((0, $89db7229a7e10f8f$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $cQmXV.createElement((0, $0f3c6d60b091c877$export$2e2bcd8739ae039), null),
            right: direction === "rtl" ? /*#__PURE__*/ $cQmXV.createElement((0, $0f3c6d60b091c877$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $cQmXV.createElement((0, $89db7229a7e10f8f$export$2e2bcd8739ae039), null)
        }), [
        direction
    ]);
    const mergedPreview = (0, $654c8de64df62232$export$2e2bcd8739ae039)(// Preview config
    previewConfig, contextPreviewConfig, // MISC
    prefixCls, mergedRootClassName, getContextPopupContainer, $e47076d3c0345de5$export$df03f54e09e486fa);
    const { mask: mergedMask, blurClassName: blurClassName } = mergedPreview ?? {};
    // =========== Merged Props for Semantic ===========
    const mergedProps = {
        ...otherProps,
        classNames: classNames,
        styles: styles
    };
    const [mergedClassNames, mergedStyles] = (0, $30c5f9f911d4f61b$export$648566b068f28737)([
        contextClassNames,
        classNames,
        {
            cover: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(contextPreviewMaskClassName, previewMaskClassName),
            popup: {
                root: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(contextPreviewRootClassName, previewRootClassName),
                mask: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)({
                    [`${prefixCls}-preview-mask-hidden`]: !mergedMask
                }, blurClassName)
            }
        }
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    }, {
        popup: {
            _default: "root"
        }
    });
    return /*#__PURE__*/ $cQmXV.createElement((0, $6388b10bd30f3904$export$2e2bcd8739ae039).PreviewGroup, {
        preview: mergedPreview,
        previewPrefixCls: previewPrefixCls,
        icons: memoizedIcons,
        ...otherProps,
        classNames: mergedClassNames,
        styles: mergedStyles
    });
};
var $e47076d3c0345de5$export$2e2bcd8739ae039 = $e47076d3c0345de5$var$InternalPreviewGroup;



var $cQmXV = parcelRequire("cQmXV");


"use client";
// Visually hidden styles for screen readers
const $099b10a8f98cc767$var$VISUALLY_HIDDEN_STYLE = {
    position: "absolute",
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    border: 0
};
const $099b10a8f98cc767$var$Progress = (props)=>{
    const { prefixCls: prefixCls, percent: percent, render: progressRender, classNames: progressClassNames, styles: progressStyles, rootClassName: rootClassName, rootStyle: rootStyle, width: width, height: height } = props;
    // Check if percent is a valid finite number
    const hasPercent = (0, $8e2d153a3c855782$export$7e4aa119212bc614)(percent) && Number.isFinite(percent);
    // Calculate percent value (clamped to 0-100 for progress bar width)
    const percentValue = hasPercent ? Math.max(0, Math.min(100, Math.round(percent))) : 0;
    // ARIA attributes for accessibility
    const ariaProps = hasPercent ? {
        role: "progressbar",
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-valuenow": percentValue,
        "aria-label": `${percentValue}%`
    } : {
        "aria-busy": true
    };
    // Render progress bar (rail with ::before pseudo for track)
    const progressBar = hasPercent ? /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-progress-rail`, progressClassNames?.rail),
        style: {
            ...progressStyles?.rail,
            "--progress-percent": `${percentValue}%`
        }
    }) : null;
    // Render progress content
    const progressContent = progressRender ? progressRender(progressBar, percentValue) : /*#__PURE__*/ $cQmXV.createElement($cQmXV.Fragment, null, progressBar, hasPercent && /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-progress-indicator`, progressClassNames?.indicator),
        style: progressStyles?.indicator
    }, `${percentValue}%`));
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-progress-wrapper`, progressClassNames?.root, rootClassName),
        style: {
            width: width,
            height: height,
            ...rootStyle,
            ...progressStyles?.root
        },
        ...ariaProps
    }, !hasPercent && /*#__PURE__*/ $cQmXV.createElement("span", {
        role: "status",
        "aria-live": "polite",
        style: $099b10a8f98cc767$var$VISUALLY_HIDDEN_STYLE
    }, "Loading"), /*#__PURE__*/ $cQmXV.createElement("div", {
        className: `${prefixCls}-progress-ink-1`
    }), /*#__PURE__*/ $cQmXV.createElement("div", {
        className: `${prefixCls}-progress-ink-2`
    }), /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-progress-content`, progressClassNames?.content),
        style: progressStyles?.content
    }, progressContent));
};
var $099b10a8f98cc767$export$2e2bcd8739ae039 = $099b10a8f98cc767$var$Progress;



"use client";
const $7012c54fc4de0c33$var$Image = (props)=>{
    const { prefixCls: customizePrefixCls, preview: preview, className: className, rootClassName: rootClassName, style: style, styles: styles, classNames: classNames, wrapperStyle: wrapperStyle, fallback: fallback, placeholder: placeholder, ...otherProps } = props;
    // =============================== MISC ===============================
    // Context
    const { getPrefixCls: getPrefixCls, getPopupContainer: getContextPopupContainer, className: contextClassName, style: contextStyle, preview: contextPreview, styles: contextStyles, classNames: contextClassNames, fallback: contextFallback } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("image");
    const prefixCls = getPrefixCls("image", customizePrefixCls);
    // ============================== Styles ==============================
    const rootCls = (0, $2237081acd3cfc09$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $07810788e8ac3200$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const mergedRootClassName = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(rootClassName, hashId, cssVarCls, rootCls);
    const mergedClassName = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(className, hashId, contextClassName);
    // ============================= Preview ==============================
    const [previewConfig, previewRootClassName, previewMaskClassName] = (0, $a4ea6279308af340$export$2e2bcd8739ae039)(preview);
    const [contextPreviewConfig, contextPreviewRootClassName, contextPreviewMaskClassName] = (0, $a4ea6279308af340$export$2e2bcd8739ae039)(contextPreview);
    const mergedPreviewConfig = (0, $654c8de64df62232$export$2e2bcd8739ae039)(// Preview config
    previewConfig, contextPreviewConfig, // MISC
    prefixCls, mergedRootClassName, getContextPopupContainer, (0, $e47076d3c0345de5$export$df03f54e09e486fa), true);
    // =========== Merged Props for Semantic ===========
    const mergedProps = {
        ...props,
        preview: mergedPreviewConfig
    };
    // ============================= Semantic =============================
    const mergedLegacyClassNames = $cQmXV.useMemo(()=>({
            cover: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(contextPreviewMaskClassName, previewMaskClassName),
            popup: {
                root: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(contextPreviewRootClassName, previewRootClassName)
            }
        }), [
        previewRootClassName,
        previewMaskClassName,
        contextPreviewRootClassName,
        contextPreviewMaskClassName
    ]);
    const { mask: mergedMask, blurClassName: blurClassName } = mergedPreviewConfig ?? {};
    const mergedPopupClassNames = $cQmXV.useMemo(()=>({
            mask: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)({
                [`${prefixCls}-preview-mask-hidden`]: !mergedMask
            }, blurClassName)
        }), [
        mergedMask,
        prefixCls,
        blurClassName
    ]);
    const internalClassNames = $cQmXV.useMemo(()=>[
            contextClassNames,
            classNames,
            mergedLegacyClassNames,
            {
                popup: mergedPopupClassNames
            }
        ], [
        contextClassNames,
        classNames,
        mergedLegacyClassNames,
        mergedPopupClassNames
    ]);
    const contextImageStyle = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(contextStyle, "image");
    const imageStyle = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(style, "image");
    const contextRootStyle = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(contextStyle);
    const rootStyle = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $30c5f9f911d4f61b$export$648566b068f28737)(internalClassNames, [
        contextStyles,
        {
            root: wrapperStyle
        },
        contextImageStyle,
        styles,
        imageStyle
    ], {
        props: mergedProps
    }, {
        popup: {
            _default: "root"
        },
        placeholder: {}
    });
    const [, progressMergedStyles] = (0, $30c5f9f911d4f61b$export$648566b068f28737)([], [
        contextStyles,
        contextRootStyle,
        {
            root: wrapperStyle
        },
        styles,
        rootStyle
    ], {
        props: mergedProps
    }, {
        popup: {
            _default: "root"
        },
        placeholder: {}
    });
    const { image: mergedImageStyle, ...restMergedStyles } = mergedStyles;
    const mergedFallback = fallback ?? contextFallback;
    // ============================= Progress ==============================
    const { progressConfig: progressConfig } = (0, $f33cfe509d3a6526$export$2e2bcd8739ae039)(placeholder);
    const showProgressOverlay = progressConfig !== undefined;
    const { percent: percent, render: progressRender } = progressConfig || {};
    // Get progress classNames and styles
    const progressClassNames = mergedClassNames?.placeholder?.progress;
    const progressStyles = progressMergedStyles?.placeholder?.progress;
    // ============================== Render ==============================
    const { width: width, height: height, src: src, ...restOtherProps } = otherProps;
    // When placeholder is ReactNode (not progress config) and src is not provided,
    // render it as an overlay since rc-image would set status to 'error' when src is empty
    const placeholderNode = (0, $f33cfe509d3a6526$export$729c95a855c13bb3)(placeholder) ? undefined : placeholder;
    const shouldRenderPlaceholderOverlay = placeholderNode && !src;
    // Memoize the placeholder render function to avoid creating new function on each render
    const mergedProgressRender = shouldRenderPlaceholderOverlay ? (_progress)=>placeholderNode : progressRender;
    // When progress is active, render only progress layer with dimensions
    if (showProgressOverlay || shouldRenderPlaceholderOverlay) return /*#__PURE__*/ $cQmXV.createElement((0, $099b10a8f98cc767$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        percent: percent,
        render: mergedProgressRender,
        classNames: progressClassNames,
        styles: progressStyles,
        rootClassName: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(mergedRootClassName, mergedClassName),
        rootStyle: progressMergedStyles?.root,
        width: width,
        height: height
    });
    return /*#__PURE__*/ $cQmXV.createElement((0, $6388b10bd30f3904$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        preview: mergedPreviewConfig || false,
        rootClassName: mergedRootClassName,
        className: mergedClassName,
        style: mergedImageStyle,
        fallback: mergedFallback,
        placeholder: placeholderNode,
        width: width,
        height: height,
        src: src,
        ...restOtherProps,
        classNames: mergedClassNames,
        styles: restMergedStyles
    });
};
$7012c54fc4de0c33$var$Image.PreviewGroup = (0, $e47076d3c0345de5$export$2e2bcd8739ae039);
var $7012c54fc4de0c33$export$2e2bcd8739ae039 = $7012c54fc4de0c33$var$Image;


var $cQmXV = parcelRequire("cQmXV");









var $cQmXV = parcelRequire("cQmXV");












// =============================== Base ===============================
const $e5ce4d273c2f2567$var$genBaseStyle = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, antCls: antCls, zIndexPopup: zIndexPopup, colorText: colorText, colorWarning: colorWarning, marginXXS: marginXXS, marginXS: marginXS, fontSize: fontSize, fontWeightStrong: fontWeightStrong, colorTextHeading: colorTextHeading } = token;
    return {
        [componentCls]: {
            zIndex: zIndexPopup,
            [`&${antCls}-popover`]: {
                fontSize: fontSize
            },
            [`${componentCls}-message`]: {
                marginBottom: marginXS,
                display: "flex",
                flexWrap: "nowrap",
                alignItems: "start",
                [`> ${componentCls}-message-icon`]: {
                    color: colorWarning
                },
                [`> ${componentCls}-message-icon ${iconCls}`]: {
                    fontSize: fontSize,
                    lineHeight: 1,
                    marginInlineEnd: marginXS
                },
                [`${componentCls}-title`]: {
                    fontWeight: fontWeightStrong,
                    color: colorTextHeading,
                    "&:only-child": {
                        fontWeight: "normal"
                    }
                },
                [`${componentCls}-description`]: {
                    marginTop: marginXXS,
                    color: colorText
                }
            },
            [`${componentCls}-buttons`]: {
                textAlign: "end",
                whiteSpace: "nowrap",
                button: {
                    marginInlineStart: marginXS
                }
            }
        }
    };
};
const $e5ce4d273c2f2567$export$9ca1be8807fe0675 = (token)=>{
    const { zIndexPopupBase: zIndexPopupBase } = token;
    return {
        zIndexPopup: zIndexPopupBase + 60
    };
};
var $e5ce4d273c2f2567$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$51ec95de45185b42)("Popconfirm", $e5ce4d273c2f2567$var$genBaseStyle, $e5ce4d273c2f2567$export$9ca1be8807fe0675, {
    resetStyle: false
});


"use client";
const $c13955c55b3e3780$export$c6fdb837b070b4ff = (props)=>{
    const { prefixCls: prefixCls, okButtonProps: okButtonProps, cancelButtonProps: cancelButtonProps, title: title, description: description, cancelText: cancelText, okText: okText, okType: okType = "primary", icon: icon = /*#__PURE__*/ $cQmXV.createElement((0, $39711bf58c19fcd8$export$2e2bcd8739ae039), null), showCancel: showCancel = true, close: close, onConfirm: onConfirm, onCancel: onCancel, onPopupClick: onPopupClick, classNames: classNames, styles: styles } = props;
    const { getPrefixCls: getPrefixCls } = $cQmXV.useContext((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    const [contextLocale] = (0, $c953dac9d015386e$export$2e2bcd8739ae039)("Popconfirm", (0, $4ab0c7032ff9de6a$export$2e2bcd8739ae039).Popconfirm);
    const titleNode = (0, $6b33481525a35462$export$15e5fca53711d340)(title);
    const descriptionNode = (0, $6b33481525a35462$export$15e5fca53711d340)(description);
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        className: `${prefixCls}-inner-content`,
        onClick: onPopupClick
    }, /*#__PURE__*/ $cQmXV.createElement("div", {
        className: `${prefixCls}-message`
    }, icon && /*#__PURE__*/ $cQmXV.createElement("span", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-message-icon`, classNames?.icon),
        style: styles?.icon
    }, icon), /*#__PURE__*/ $cQmXV.createElement("div", {
        className: `${prefixCls}-message-text`
    }, (0, $8e2d153a3c855782$export$72280d5f896dac9a)(titleNode) && /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-title`, classNames?.title),
        style: styles?.title
    }, titleNode), (0, $8e2d153a3c855782$export$72280d5f896dac9a)(descriptionNode) && /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-description`, classNames?.content),
        style: styles?.content
    }, descriptionNode))), /*#__PURE__*/ $cQmXV.createElement("div", {
        className: `${prefixCls}-buttons`
    }, showCancel && /*#__PURE__*/ $cQmXV.createElement((0, $1fc505710073cde5$export$2e2bcd8739ae039), {
        onClick: onCancel,
        size: "small",
        ...cancelButtonProps
    }, cancelText || contextLocale?.cancelText), /*#__PURE__*/ $cQmXV.createElement((0, $6d18b68c8fb73984$export$2e2bcd8739ae039), {
        buttonProps: {
            size: "small",
            ...(0, $62e55ded4111e367$export$19bc9a290855952)(okType),
            ...okButtonProps
        },
        actionFn: onConfirm,
        close: close,
        prefixCls: getPrefixCls("btn"),
        quitOnNullishReturnValue: true,
        emitEvent: true
    }, okText || contextLocale?.okText)));
};
const $c13955c55b3e3780$var$PurePanel = (props)=>{
    const { prefixCls: customizePrefixCls, placement: placement, className: className, style: style, ...restProps } = props;
    const { getPrefixCls: getPrefixCls } = $cQmXV.useContext((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls("popconfirm", customizePrefixCls);
    (0, $e5ce4d273c2f2567$export$2e2bcd8739ae039)(prefixCls);
    return /*#__PURE__*/ $cQmXV.createElement((0, $8ff13a211d3e959f$export$2e2bcd8739ae039), {
        placement: placement,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, className),
        style: style,
        content: /*#__PURE__*/ $cQmXV.createElement($c13955c55b3e3780$export$c6fdb837b070b4ff, {
            prefixCls: prefixCls,
            ...restProps
        })
    });
};
var $c13955c55b3e3780$export$2e2bcd8739ae039 = $c13955c55b3e3780$var$PurePanel;



"use client";
const $06cf5142874b7968$var$InternalPopconfirm = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, placement: placement = "top", trigger: trigger, okType: okType = "primary", icon: icon = /*#__PURE__*/ $cQmXV.createElement((0, $39711bf58c19fcd8$export$2e2bcd8739ae039), null), children: children, overlayClassName: overlayClassName, onOpenChange: onOpenChange, overlayStyle: overlayStyle, styles: styles, arrow: popconfirmArrow, classNames: classNames, disabled: disabled = false, mouseEnterDelay: mouseEnterDelay, mouseLeaveDelay: mouseLeaveDelay, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles, arrow: contextArrow, trigger: contextTrigger, mouseEnterDelay: contextMouseEnterDelay, mouseLeaveDelay: contextMouseLeaveDelay } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("popconfirm");
    const [open, setOpen] = (0, $a51866d781137e08$export$2e2bcd8739ae039)(props.defaultOpen ?? false, props.open);
    const mergedArrow = (0, $91d7bcfa626b18b0$export$2e2bcd8739ae039)(popconfirmArrow, contextArrow);
    const mergedTrigger = trigger || contextTrigger || "click";
    const mergedMouseEnterDelay = mouseEnterDelay ?? contextMouseEnterDelay ?? 0.1;
    const mergedMouseLeaveDelay = mouseLeaveDelay ?? contextMouseLeaveDelay ?? 0.1;
    const settingOpen = (value)=>{
        setOpen(value);
        onOpenChange?.(value);
    };
    const close = ()=>{
        settingOpen(false);
    };
    const onConfirm = (e)=>props.onConfirm?.call(undefined, e);
    const onCancel = (e)=>{
        settingOpen(false);
        props.onCancel?.call(undefined, e);
    };
    const onInternalOpenChange = (value)=>{
        if (disabled) return;
        settingOpen(value);
    };
    const prefixCls = getPrefixCls("popconfirm", customizePrefixCls);
    const mergedProps = {
        ...props,
        placement: placement,
        trigger: mergedTrigger,
        okType: okType,
        overlayStyle: overlayStyle,
        styles: styles,
        classNames: classNames,
        mouseEnterDelay: mergedMouseEnterDelay,
        mouseLeaveDelay: mergedMouseLeaveDelay
    };
    const contextStyleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(contextStyle);
    const overlayStyleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(overlayStyle);
    const [mergedClassNames, mergedStyles] = (0, $30c5f9f911d4f61b$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        overlayStyleRoot
    ], {
        props: mergedProps
    });
    const rootClassNames = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, contextClassName, overlayClassName, mergedClassNames.root);
    (0, $e5ce4d273c2f2567$export$2e2bcd8739ae039)(prefixCls);
    return /*#__PURE__*/ $cQmXV.createElement((0, $81ac8d1f20faf53f$export$2e2bcd8739ae039), {
        arrow: mergedArrow,
        ...(0, $e8c5093aebad6025$export$2e2bcd8739ae039)(restProps, [
            "title"
        ]),
        trigger: mergedTrigger,
        placement: placement,
        onOpenChange: onInternalOpenChange,
        open: open,
        ref: ref,
        mouseEnterDelay: mergedMouseEnterDelay,
        mouseLeaveDelay: mergedMouseLeaveDelay,
        classNames: {
            root: rootClassNames,
            container: mergedClassNames.container,
            arrow: mergedClassNames.arrow
        },
        styles: {
            root: mergedStyles.root,
            container: mergedStyles.container,
            arrow: mergedStyles.arrow
        },
        content: /*#__PURE__*/ $cQmXV.createElement((0, $c13955c55b3e3780$export$c6fdb837b070b4ff), {
            okType: okType,
            icon: icon,
            ...props,
            prefixCls: prefixCls,
            close: close,
            onConfirm: onConfirm,
            onCancel: onCancel,
            classNames: mergedClassNames,
            styles: mergedStyles
        }),
        "data-popover-inject": true
    }, children);
});
const $06cf5142874b7968$var$Popconfirm = $06cf5142874b7968$var$InternalPopconfirm;
// We don't care debug panel
/* istanbul ignore next */ $06cf5142874b7968$var$Popconfirm._InternalPanelDoNotUseOrYouWillBeFired = (0, $c13955c55b3e3780$export$2e2bcd8739ae039);
var $06cf5142874b7968$export$2e2bcd8739ae039 = $06cf5142874b7968$var$Popconfirm;



var $cQmXV = parcelRequire("cQmXV");
var $b043ace3fa920820$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($b043ace3fa920820$exports, "__esModule", {
    value: true
});
var $b043ace3fa920820$var$CloseCircleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "fill-rule": "evenodd",
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm0 76c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm128.01 198.83c.03 0 .05.01.09.06l45.02 45.01a.2.2 0 01.05.09.12.12 0 010 .07c0 .02-.01.04-.05.08L557.25 512l127.87 127.86a.27.27 0 01.05.06v.02a.12.12 0 010 .07c0 .03-.01.05-.05.09l-45.02 45.02a.2.2 0 01-.09.05.12.12 0 01-.07 0c-.02 0-.04-.01-.08-.05L512 557.25 384.14 685.12c-.04.04-.06.05-.08.05a.12.12 0 01-.07 0c-.03 0-.05-.01-.09-.05l-45.02-45.02a.2.2 0 01-.05-.09.12.12 0 010-.07c0-.02.01-.04.06-.08L466.75 512 338.88 384.14a.27.27 0 01-.05-.06l-.01-.02a.12.12 0 010-.07c0-.03.01-.05.05-.09l45.02-45.02a.2.2 0 01.09-.05.12.12 0 01.07 0c.02 0 .04.01.08.06L512 466.75l127.86-127.86c.04-.05.06-.06.08-.06a.12.12 0 01.07 0z"
                }
            }
        ]
    },
    "name": "close-circle",
    "theme": "outlined"
};
$b043ace3fa920820$exports.default = $b043ace3fa920820$var$CloseCircleOutlined;



function $bdfb1f797481a352$var$_extends() {
    $bdfb1f797481a352$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bdfb1f797481a352$var$_extends.apply(this, arguments);
}
const $bdfb1f797481a352$var$CloseCircleOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $bdfb1f797481a352$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($b043ace3fa920820$exports)))
    }));
/**![close-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdmlld0JveD0iNjQgNjQgODk2IDg5NiIgZm9jdXNhYmxlPSJmYWxzZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNTEyIDY0YzI0Ny40IDAgNDQ4IDIwMC42IDQ0OCA0NDhTNzU5LjQgOTYwIDUxMiA5NjAgNjQgNzU5LjQgNjQgNTEyIDI2NC42IDY0IDUxMiA2NHptMCA3NmMtMjA1LjQgMC0zNzIgMTY2LjYtMzcyIDM3MnMxNjYuNiAzNzIgMzcyIDM3MiAzNzItMTY2LjYgMzcyLTM3Mi0xNjYuNi0zNzItMzcyLTM3MnptMTI4LjAxIDE5OC44M2MuMDMgMCAuMDUuMDEuMDkuMDZsNDUuMDIgNDUuMDFhLjIuMiAwIDAxLjA1LjA5LjEyLjEyIDAgMDEwIC4wN2MwIC4wMi0uMDEuMDQtLjA1LjA4TDU1Ny4yNSA1MTJsMTI3Ljg3IDEyNy44NmEuMjcuMjcgMCAwMS4wNS4wNnYuMDJhLjEyLjEyIDAgMDEwIC4wN2MwIC4wMy0uMDEuMDUtLjA1LjA5bC00NS4wMiA0NS4wMmEuMi4yIDAgMDEtLjA5LjA1LjEyLjEyIDAgMDEtLjA3IDBjLS4wMiAwLS4wNC0uMDEtLjA4LS4wNUw1MTIgNTU3LjI1IDM4NC4xNCA2ODUuMTJjLS4wNC4wNC0uMDYuMDUtLjA4LjA1YS4xMi4xMiAwIDAxLS4wNyAwYy0uMDMgMC0uMDUtLjAxLS4wOS0uMDVsLTQ1LjAyLTQ1LjAyYS4yLjIgMCAwMS0uMDUtLjA5LjEyLjEyIDAgMDEwLS4wN2MwLS4wMi4wMS0uMDQuMDYtLjA4TDQ2Ni43NSA1MTIgMzM4Ljg4IDM4NC4xNGEuMjcuMjcgMCAwMS0uMDUtLjA2bC0uMDEtLjAyYS4xMi4xMiAwIDAxMC0uMDdjMC0uMDMuMDEtLjA1LjA1LS4wOWw0NS4wMi00NS4wMmEuMi4yIDAgMDEuMDktLjA1LjEyLjEyIDAgMDEuMDcgMGMuMDIgMCAuMDQuMDEuMDguMDZMNTEyIDQ2Ni43NWwxMjcuODYtMTI3Ljg2Yy4wNC0uMDUuMDYtLjA2LjA4LS4wNmEuMTIuMTIgMCAwMS4wNyAweiIgLz48L3N2Zz4=) */ const $bdfb1f797481a352$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($bdfb1f797481a352$var$CloseCircleOutlined);
var $bdfb1f797481a352$export$2e2bcd8739ae039 = $bdfb1f797481a352$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $458267895c4e03bd$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($458267895c4e03bd$exports, "__esModule", {
    value: true
});
var $458267895c4e03bd$var$PrinterOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M820 436h-40c-4.4 0-8 3.6-8 8v40c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-40c0-4.4-3.6-8-8-8zm32-104H732V120c0-4.4-3.6-8-8-8H300c-4.4 0-8 3.6-8 8v212H172c-44.2 0-80 35.8-80 80v328c0 17.7 14.3 32 32 32h168v132c0 4.4 3.6 8 8 8h424c4.4 0 8-3.6 8-8V772h168c17.7 0 32-14.3 32-32V412c0-44.2-35.8-80-80-80zM360 180h304v152H360V180zm304 664H360V568h304v276zm200-140H732V500H292v204H160V412c0-6.6 5.4-12 12-12h680c6.6 0 12 5.4 12 12v292z"
                }
            }
        ]
    },
    "name": "printer",
    "theme": "outlined"
};
$458267895c4e03bd$exports.default = $458267895c4e03bd$var$PrinterOutlined;



function $15d85cc2607f0b44$var$_extends() {
    $15d85cc2607f0b44$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $15d85cc2607f0b44$var$_extends.apply(this, arguments);
}
const $15d85cc2607f0b44$var$PrinterOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $15d85cc2607f0b44$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($458267895c4e03bd$exports)))
    }));
/**![printer](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTgyMCA0MzZoLTQwYy00LjQgMC04IDMuNi04IDh2NDBjMCA0LjQgMy42IDggOCA4aDQwYzQuNCAwIDgtMy42IDgtOHYtNDBjMC00LjQtMy42LTgtOC04em0zMi0xMDRINzMyVjEyMGMwLTQuNC0zLjYtOC04LThIMzAwYy00LjQgMC04IDMuNi04IDh2MjEySDE3MmMtNDQuMiAwLTgwIDM1LjgtODAgODB2MzI4YzAgMTcuNyAxNC4zIDMyIDMyIDMyaDE2OHYxMzJjMCA0LjQgMy42IDggOCA4aDQyNGM0LjQgMCA4LTMuNiA4LThWNzcyaDE2OGMxNy43IDAgMzItMTQuMyAzMi0zMlY0MTJjMC00NC4yLTM1LjgtODAtODAtODB6TTM2MCAxODBoMzA0djE1MkgzNjBWMTgwem0zMDQgNjY0SDM2MFY1NjhoMzA0djI3NnptMjAwLTE0MEg3MzJWNTAwSDI5MnYyMDRIMTYwVjQxMmMwLTYuNiA1LjQtMTIgMTItMTJoNjgwYzYuNiAwIDEyIDUuNCAxMiAxMnYyOTJ6IiAvPjwvc3ZnPg==) */ const $15d85cc2607f0b44$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($15d85cc2607f0b44$var$PrinterOutlined);
var $15d85cc2607f0b44$export$2e2bcd8739ae039 = $15d85cc2607f0b44$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $e0ce250abc992644$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($e0ce250abc992644$exports, "__esModule", {
    value: true
});
var $e0ce250abc992644$var$ShopOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M882 272.1V144c0-17.7-14.3-32-32-32H174c-17.7 0-32 14.3-32 32v128.1c-16.7 1-30 14.9-30 31.9v131.7a177 177 0 0014.4 70.4c4.3 10.2 9.6 19.8 15.6 28.9v345c0 17.6 14.3 32 32 32h676c17.7 0 32-14.3 32-32V535a175 175 0 0015.6-28.9c9.5-22.3 14.4-46 14.4-70.4V304c0-17-13.3-30.9-30-31.9zM214 184h596v88H214v-88zm362 656.1H448V736h128v104.1zm234 0H640V704c0-17.7-14.3-32-32-32H416c-17.7 0-32 14.3-32 32v136.1H214V597.9c2.9 1.4 5.9 2.8 9 4 22.3 9.4 46 14.1 70.4 14.1s48-4.7 70.4-14.1c13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0038.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0038.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 3-1.3 6-2.6 9-4v242.2zm30-404.4c0 59.8-49 108.3-109.3 108.3-40.8 0-76.4-22.1-95.2-54.9-2.9-5-8.1-8.1-13.9-8.1h-.6c-5.7 0-11 3.1-13.9 8.1A109.24 109.24 0 01512 544c-40.7 0-76.2-22-95-54.7-3-5.1-8.4-8.3-14.3-8.3s-11.4 3.2-14.3 8.3a109.63 109.63 0 01-95.1 54.7C233 544 184 495.5 184 435.7v-91.2c0-.3.2-.5.5-.5h655c.3 0 .5.2.5.5v91.2z"
                }
            }
        ]
    },
    "name": "shop",
    "theme": "outlined"
};
$e0ce250abc992644$exports.default = $e0ce250abc992644$var$ShopOutlined;



function $6238f9dab5cff517$var$_extends() {
    $6238f9dab5cff517$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6238f9dab5cff517$var$_extends.apply(this, arguments);
}
const $6238f9dab5cff517$var$ShopOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $6238f9dab5cff517$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e0ce250abc992644$exports)))
    }));
/**![shop](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg4MiAyNzIuMVYxNDRjMC0xNy43LTE0LjMtMzItMzItMzJIMTc0Yy0xNy43IDAtMzIgMTQuMy0zMiAzMnYxMjguMWMtMTYuNyAxLTMwIDE0LjktMzAgMzEuOXYxMzEuN2ExNzcgMTc3IDAgMDAxNC40IDcwLjRjNC4zIDEwLjIgOS42IDE5LjggMTUuNiAyOC45djM0NWMwIDE3LjYgMTQuMyAzMiAzMiAzMmg2NzZjMTcuNyAwIDMyLTE0LjMgMzItMzJWNTM1YTE3NSAxNzUgMCAwMDE1LjYtMjguOWM5LjUtMjIuMyAxNC40LTQ2IDE0LjQtNzAuNFYzMDRjMC0xNy0xMy4zLTMwLjktMzAtMzEuOXpNMjE0IDE4NGg1OTZ2ODhIMjE0di04OHptMzYyIDY1Ni4xSDQ0OFY3MzZoMTI4djEwNC4xem0yMzQgMEg2NDBWNzA0YzAtMTcuNy0xNC4zLTMyLTMyLTMySDQxNmMtMTcuNyAwLTMyIDE0LjMtMzIgMzJ2MTM2LjFIMjE0VjU5Ny45YzIuOSAxLjQgNS45IDIuOCA5IDQgMjIuMyA5LjQgNDYgMTQuMSA3MC40IDE0LjFzNDgtNC43IDcwLjQtMTQuMWMxMy44LTUuOCAyNi44LTEzLjIgMzguNy0yMi4xLjItLjEuNC0uMS42IDBhMTgwLjQgMTgwLjQgMCAwMDM4LjcgMjIuMWMyMi4zIDkuNCA0NiAxNC4xIDcwLjQgMTQuMSAyNC40IDAgNDgtNC43IDcwLjQtMTQuMSAxMy44LTUuOCAyNi44LTEzLjIgMzguNy0yMi4xLjItLjEuNC0uMS42IDBhMTgwLjQgMTgwLjQgMCAwMDM4LjcgMjIuMWMyMi4zIDkuNCA0NiAxNC4xIDcwLjQgMTQuMSAyNC40IDAgNDgtNC43IDcwLjQtMTQuMSAzLTEuMyA2LTIuNiA5LTR2MjQyLjJ6bTMwLTQwNC40YzAgNTkuOC00OSAxMDguMy0xMDkuMyAxMDguMy00MC44IDAtNzYuNC0yMi4xLTk1LjItNTQuOS0yLjktNS04LjEtOC4xLTEzLjktOC4xaC0uNmMtNS43IDAtMTEgMy4xLTEzLjkgOC4xQTEwOS4yNCAxMDkuMjQgMCAwMTUxMiA1NDRjLTQwLjcgMC03Ni4yLTIyLTk1LTU0LjctMy01LjEtOC40LTguMy0xNC4zLTguM3MtMTEuNCAzLjItMTQuMyA4LjNhMTA5LjYzIDEwOS42MyAwIDAxLTk1LjEgNTQuN0MyMzMgNTQ0IDE4NCA0OTUuNSAxODQgNDM1Ljd2LTkxLjJjMC0uMy4yLS41LjUtLjVoNjU1Yy4zIDAgLjUuMi41LjV2OTEuMnoiIC8+PC9zdmc+) */ const $6238f9dab5cff517$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($6238f9dab5cff517$var$ShopOutlined);
var $6238f9dab5cff517$export$2e2bcd8739ae039 = $6238f9dab5cff517$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $d041c99ead2f4edc$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($d041c99ead2f4edc$exports, "__esModule", {
    value: true
});
var $d041c99ead2f4edc$var$TagOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M938 458.8l-29.6-312.6c-1.5-16.2-14.4-29-30.6-30.6L565.2 86h-.4c-3.2 0-5.7 1-7.6 2.9L88.9 557.2a9.96 9.96 0 000 14.1l363.8 363.8c1.9 1.9 4.4 2.9 7.1 2.9s5.2-1 7.1-2.9l468.3-468.3c2-2.1 3-5 2.8-8zM459.7 834.7L189.3 564.3 589 164.6 836 188l23.4 247-399.7 399.7zM680 256c-48.5 0-88 39.5-88 88s39.5 88 88 88 88-39.5 88-88-39.5-88-88-88zm0 120c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
                }
            }
        ]
    },
    "name": "tag",
    "theme": "outlined"
};
$d041c99ead2f4edc$exports.default = $d041c99ead2f4edc$var$TagOutlined;



function $d520e945c3123459$var$_extends() {
    $d520e945c3123459$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d520e945c3123459$var$_extends.apply(this, arguments);
}
const $d520e945c3123459$var$TagOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $d520e945c3123459$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d041c99ead2f4edc$exports)))
    }));
/**![tag](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkzOCA0NTguOGwtMjkuNi0zMTIuNmMtMS41LTE2LjItMTQuNC0yOS0zMC42LTMwLjZMNTY1LjIgODZoLS40Yy0zLjIgMC01LjcgMS03LjYgMi45TDg4LjkgNTU3LjJhOS45NiA5Ljk2IDAgMDAwIDE0LjFsMzYzLjggMzYzLjhjMS45IDEuOSA0LjQgMi45IDcuMSAyLjlzNS4yLTEgNy4xLTIuOWw0NjguMy00NjguM2MyLTIuMSAzLTUgMi44LTh6TTQ1OS43IDgzNC43TDE4OS4zIDU2NC4zIDU4OSAxNjQuNiA4MzYgMTg4bDIzLjQgMjQ3LTM5OS43IDM5OS43ek02ODAgMjU2Yy00OC41IDAtODggMzkuNS04OCA4OHMzOS41IDg4IDg4IDg4IDg4LTM5LjUgODgtODgtMzkuNS04OC04OC04OHptMCAxMjBjLTE3LjcgMC0zMi0xNC4zLTMyLTMyczE0LjMtMzIgMzItMzIgMzIgMTQuMyAzMiAzMi0xNC4zIDMyLTMyIDMyeiIgLz48L3N2Zz4=) */ const $d520e945c3123459$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($d520e945c3123459$var$TagOutlined);
var $d520e945c3123459$export$2e2bcd8739ae039 = $d520e945c3123459$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $b438d62f0d084465$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($b438d62f0d084465$exports, "__esModule", {
    value: true
});
var $b438d62f0d084465$var$InboxOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M885.2 446.3l-.2-.8-112.2-285.1c-5-16.1-19.9-27.2-36.8-27.2H281.2c-17 0-32.1 11.3-36.9 27.6L139.4 443l-.3.7-.2.8c-1.3 4.9-1.7 9.9-1 14.8-.1 1.6-.2 3.2-.2 4.8V830a60.9 60.9 0 0060.8 60.8h627.2c33.5 0 60.8-27.3 60.9-60.8V464.1c0-1.3 0-2.6-.1-3.7.4-4.9 0-9.6-1.3-14.1zm-295.8-43l-.3 15.7c-.8 44.9-31.8 75.1-77.1 75.1-22.1 0-41.1-7.1-54.8-20.6S436 441.2 435.6 419l-.3-15.7H229.5L309 210h399.2l81.7 193.3H589.4zm-375 76.8h157.3c24.3 57.1 76 90.8 140.4 90.8 33.7 0 65-9.4 90.3-27.2 22.2-15.6 39.5-37.4 50.7-63.6h156.5V814H214.4V480.1z"
                }
            }
        ]
    },
    "name": "inbox",
    "theme": "outlined"
};
$b438d62f0d084465$exports.default = $b438d62f0d084465$var$InboxOutlined;



function $268dc9f9b8c7fd21$var$_extends() {
    $268dc9f9b8c7fd21$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $268dc9f9b8c7fd21$var$_extends.apply(this, arguments);
}
const $268dc9f9b8c7fd21$var$InboxOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $268dc9f9b8c7fd21$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($b438d62f0d084465$exports)))
    }));
/**![inbox](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg4NS4yIDQ0Ni4zbC0uMi0uOC0xMTIuMi0yODUuMWMtNS0xNi4xLTE5LjktMjcuMi0zNi44LTI3LjJIMjgxLjJjLTE3IDAtMzIuMSAxMS4zLTM2LjkgMjcuNkwxMzkuNCA0NDNsLS4zLjctLjIuOGMtMS4zIDQuOS0xLjcgOS45LTEgMTQuOC0uMSAxLjYtLjIgMy4yLS4yIDQuOFY4MzBhNjAuOSA2MC45IDAgMDA2MC44IDYwLjhoNjI3LjJjMzMuNSAwIDYwLjgtMjcuMyA2MC45LTYwLjhWNDY0LjFjMC0xLjMgMC0yLjYtLjEtMy43LjQtNC45IDAtOS42LTEuMy0xNC4xem0tMjk1LjgtNDNsLS4zIDE1LjdjLS44IDQ0LjktMzEuOCA3NS4xLTc3LjEgNzUuMS0yMi4xIDAtNDEuMS03LjEtNTQuOC0yMC42UzQzNiA0NDEuMiA0MzUuNiA0MTlsLS4zLTE1LjdIMjI5LjVMMzA5IDIxMGgzOTkuMmw4MS43IDE5My4zSDU4OS40em0tMzc1IDc2LjhoMTU3LjNjMjQuMyA1Ny4xIDc2IDkwLjggMTQwLjQgOTAuOCAzMy43IDAgNjUtOS40IDkwLjMtMjcuMiAyMi4yLTE1LjYgMzkuNS0zNy40IDUwLjctNjMuNmgxNTYuNVY4MTRIMjE0LjRWNDgwLjF6IiAvPjwvc3ZnPg==) */ const $268dc9f9b8c7fd21$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($268dc9f9b8c7fd21$var$InboxOutlined);
var $268dc9f9b8c7fd21$export$2e2bcd8739ae039 = $268dc9f9b8c7fd21$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $deab354ee55b3d81$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($deab354ee55b3d81$exports, "__esModule", {
    value: true
});
var $deab354ee55b3d81$var$TagsOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M483.2 790.3L861.4 412c1.7-1.7 2.5-4 2.3-6.3l-25.5-301.4c-.7-7.8-6.8-13.9-14.6-14.6L522.2 64.3c-2.3-.2-4.7.6-6.3 2.3L137.7 444.8a8.03 8.03 0 000 11.3l334.2 334.2c3.1 3.2 8.2 3.2 11.3 0zm62.6-651.7l224.6 19 19 224.6L477.5 694 233.9 450.5l311.9-311.9zm60.16 186.23a48 48 0 1067.88-67.89 48 48 0 10-67.88 67.89zM889.7 539.8l-39.6-39.5a8.03 8.03 0 00-11.3 0l-362 361.3-237.6-237a8.03 8.03 0 00-11.3 0l-39.6 39.5a8.03 8.03 0 000 11.3l243.2 242.8 39.6 39.5c3.1 3.1 8.2 3.1 11.3 0l407.3-406.6c3.1-3.1 3.1-8.2 0-11.3z"
                }
            }
        ]
    },
    "name": "tags",
    "theme": "outlined"
};
$deab354ee55b3d81$exports.default = $deab354ee55b3d81$var$TagsOutlined;



function $acd344b554ad3277$var$_extends() {
    $acd344b554ad3277$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $acd344b554ad3277$var$_extends.apply(this, arguments);
}
const $acd344b554ad3277$var$TagsOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $acd344b554ad3277$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($deab354ee55b3d81$exports)))
    }));
/**![tags](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTQ4My4yIDc5MC4zTDg2MS40IDQxMmMxLjctMS43IDIuNS00IDIuMy02LjNsLTI1LjUtMzAxLjRjLS43LTcuOC02LjgtMTMuOS0xNC42LTE0LjZMNTIyLjIgNjQuM2MtMi4zLS4yLTQuNy42LTYuMyAyLjNMMTM3LjcgNDQ0LjhhOC4wMyA4LjAzIDAgMDAwIDExLjNsMzM0LjIgMzM0LjJjMy4xIDMuMiA4LjIgMy4yIDExLjMgMHptNjIuNi02NTEuN2wyMjQuNiAxOSAxOSAyMjQuNkw0NzcuNSA2OTQgMjMzLjkgNDUwLjVsMzExLjktMzExLjl6bTYwLjE2IDE4Ni4yM2E0OCA0OCAwIDEwNjcuODgtNjcuODkgNDggNDggMCAxMC02Ny44OCA2Ny44OXpNODg5LjcgNTM5LjhsLTM5LjYtMzkuNWE4LjAzIDguMDMgMCAwMC0xMS4zIDBsLTM2MiAzNjEuMy0yMzcuNi0yMzdhOC4wMyA4LjAzIDAgMDAtMTEuMyAwbC0zOS42IDM5LjVhOC4wMyA4LjAzIDAgMDAwIDExLjNsMjQzLjIgMjQyLjggMzkuNiAzOS41YzMuMSAzLjEgOC4yIDMuMSAxMS4zIDBsNDA3LjMtNDA2LjZjMy4xLTMuMSAzLjEtOC4yIDAtMTEuM3oiIC8+PC9zdmc+) */ const $acd344b554ad3277$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($acd344b554ad3277$var$TagsOutlined);
var $acd344b554ad3277$export$2e2bcd8739ae039 = $acd344b554ad3277$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $fe89aa31ac661d7f$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($fe89aa31ac661d7f$exports, "__esModule", {
    value: true
});
var $fe89aa31ac661d7f$var$BookOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-260 72h96v209.9L621.5 312 572 347.4V136zm220 752H232V136h280v296.9c0 3.3 1 6.6 3 9.3a15.9 15.9 0 0022.3 3.7l83.8-59.9 81.4 59.4c2.7 2 6 3.1 9.4 3.1 8.8 0 16-7.2 16-16V136h64v752z"
                }
            }
        ]
    },
    "name": "book",
    "theme": "outlined"
};
$fe89aa31ac661d7f$exports.default = $fe89aa31ac661d7f$var$BookOutlined;



function $9224f489e607325f$var$_extends() {
    $9224f489e607325f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9224f489e607325f$var$_extends.apply(this, arguments);
}
const $9224f489e607325f$var$BookOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $9224f489e607325f$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fe89aa31ac661d7f$exports)))
    }));
/**![book](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTgzMiA2NEgxOTJjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjgzMmMwIDE3LjcgMTQuMyAzMiAzMiAzMmg2NDBjMTcuNyAwIDMyLTE0LjMgMzItMzJWOTZjMC0xNy43LTE0LjMtMzItMzItMzJ6bS0yNjAgNzJoOTZ2MjA5LjlMNjIxLjUgMzEyIDU3MiAzNDcuNFYxMzZ6bTIyMCA3NTJIMjMyVjEzNmgyODB2Mjk2LjljMCAzLjMgMSA2LjYgMyA5LjNhMTUuOSAxNS45IDAgMDAyMi4zIDMuN2w4My44LTU5LjkgODEuNCA1OS40YzIuNyAyIDYgMy4xIDkuNCAzLjEgOC44IDAgMTYtNy4yIDE2LTE2VjEzNmg2NHY3NTJ6IiAvPjwvc3ZnPg==) */ const $9224f489e607325f$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($9224f489e607325f$var$BookOutlined);
var $9224f489e607325f$export$2e2bcd8739ae039 = $9224f489e607325f$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $06ed8948750d9f55$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($06ed8948750d9f55$exports, "__esModule", {
    value: true
});
var $06ed8948750d9f55$var$SlidersOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M320 224h-66v-56c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v56h-66c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h66v56c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-56h66c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zm-60 508h-80V292h80v440zm644-436h-66v-96c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v96h-66c-4.4 0-8 3.6-8 8v416c0 4.4 3.6 8 8 8h66v96c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-96h66c4.4 0 8-3.6 8-8V304c0-4.4-3.6-8-8-8zm-60 364h-80V364h80v296zM612 404h-66V232c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v172h-66c-4.4 0-8 3.6-8 8v200c0 4.4 3.6 8 8 8h66v172c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V620h66c4.4 0 8-3.6 8-8V412c0-4.4-3.6-8-8-8zm-60 145a3 3 0 01-3 3h-74a3 3 0 01-3-3v-74a3 3 0 013-3h74a3 3 0 013 3v74z"
                }
            }
        ]
    },
    "name": "sliders",
    "theme": "outlined"
};
$06ed8948750d9f55$exports.default = $06ed8948750d9f55$var$SlidersOutlined;



function $b6833bd3d006f741$var$_extends() {
    $b6833bd3d006f741$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b6833bd3d006f741$var$_extends.apply(this, arguments);
}
const $b6833bd3d006f741$var$SlidersOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $b6833bd3d006f741$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($06ed8948750d9f55$exports)))
    }));
/**![sliders](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTMyMCAyMjRoLTY2di01NmMwLTQuNC0zLjYtOC04LThoLTUyYy00LjQgMC04IDMuNi04IDh2NTZoLTY2Yy00LjQgMC04IDMuNi04IDh2NTYwYzAgNC40IDMuNiA4IDggOGg2NnY1NmMwIDQuNCAzLjYgOCA4IDhoNTJjNC40IDAgOC0zLjYgOC04di01Nmg2NmM0LjQgMCA4LTMuNiA4LThWMjMyYzAtNC40LTMuNi04LTgtOHptLTYwIDUwOGgtODBWMjkyaDgwdjQ0MHptNjQ0LTQzNmgtNjZ2LTk2YzAtNC40LTMuNi04LTgtOGgtNTJjLTQuNCAwLTggMy42LTggOHY5NmgtNjZjLTQuNCAwLTggMy42LTggOHY0MTZjMCA0LjQgMy42IDggOCA4aDY2djk2YzAgNC40IDMuNiA4IDggOGg1MmM0LjQgMCA4LTMuNiA4LTh2LTk2aDY2YzQuNCAwIDgtMy42IDgtOFYzMDRjMC00LjQtMy42LTgtOC04em0tNjAgMzY0aC04MFYzNjRoODB2Mjk2ek02MTIgNDA0aC02NlYyMzJjMC00LjQtMy42LTgtOC04aC01MmMtNC40IDAtOCAzLjYtOCA4djE3MmgtNjZjLTQuNCAwLTggMy42LTggOHYyMDBjMCA0LjQgMy42IDggOCA4aDY2djE3MmMwIDQuNCAzLjYgOCA4IDhoNTJjNC40IDAgOC0zLjYgOC04VjYyMGg2NmM0LjQgMCA4LTMuNiA4LThWNDEyYzAtNC40LTMuNi04LTgtOHptLTYwIDE0NWEzIDMgMCAwMS0zIDNoLTc0YTMgMyAwIDAxLTMtM3YtNzRhMyAzIDAgMDEzLTNoNzRhMyAzIDAgMDEzIDN2NzR6IiAvPjwvc3ZnPg==) */ const $b6833bd3d006f741$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($b6833bd3d006f741$var$SlidersOutlined);
var $b6833bd3d006f741$export$2e2bcd8739ae039 = $b6833bd3d006f741$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $ae72f29e3e5911c4$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($ae72f29e3e5911c4$exports, "__esModule", {
    value: true
});
var $ae72f29e3e5911c4$var$CheckSquareOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M433.1 657.7a31.8 31.8 0 0051.7 0l210.6-292c3.8-5.3 0-12.7-6.5-12.7H642c-10.2 0-19.9 4.9-25.9 13.3L459 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H315c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    },
    "name": "check-square",
    "theme": "outlined"
};
$ae72f29e3e5911c4$exports.default = $ae72f29e3e5911c4$var$CheckSquareOutlined;



function $28c0ad5395372ff7$var$_extends() {
    $28c0ad5395372ff7$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $28c0ad5395372ff7$var$_extends.apply(this, arguments);
}
const $28c0ad5395372ff7$var$CheckSquareOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $28c0ad5395372ff7$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ae72f29e3e5911c4$exports)))
    }));
/**![check-square](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTQzMy4xIDY1Ny43YTMxLjggMzEuOCAwIDAwNTEuNyAwbDIxMC42LTI5MmMzLjgtNS4zIDAtMTIuNy02LjUtMTIuN0g2NDJjLTEwLjIgMC0xOS45IDQuOS0yNS45IDEzLjNMNDU5IDU4NC4zbC03MS4yLTk4LjhjLTYtOC4zLTE1LjYtMTMuMy0yNS45LTEzLjNIMzE1Yy02LjUgMC0xMC4zIDcuNC02LjUgMTIuN2wxMjQuNiAxNzIuOHoiIC8+PHBhdGggZD0iTTg4MCAxMTJIMTQ0Yy0xNy43IDAtMzIgMTQuMy0zMiAzMnY3MzZjMCAxNy43IDE0LjMgMzIgMzIgMzJoNzM2YzE3LjcgMCAzMi0xNC4zIDMyLTMyVjE0NGMwLTE3LjctMTQuMy0zMi0zMi0zMnptLTQwIDcyOEgxODRWMTg0aDY1NnY2NTZ6IiAvPjwvc3ZnPg==) */ const $28c0ad5395372ff7$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($28c0ad5395372ff7$var$CheckSquareOutlined);
var $28c0ad5395372ff7$export$2e2bcd8739ae039 = $28c0ad5395372ff7$var$RefIcon;





/* PeriodPicker — the app's date-range control.
 *
 * `docs/design/spec/02-components.md` maps the mockups' `.rp*` / `.cal*` / `.presets*` to
 * `<DatePicker.RangePicker presets>`; this is that component, with the design's six preset windows,
 * the calendar glyph on the leading edge, "From / To" placeholders and the panel's footer hint.
 * Every period filter in the redesign uses it — the mockups draw the same control on the photo
 * report, visits, surveys and the merchandiser detail page.
 *
 * Anything visual lives in `period-picker.scss` / `src/theme/antd.js`, never inline: the panel's
 * geometry is the reason this is one component rather than a prop bag repeated per page.
 *
 * ```jsx
 * <PeriodPicker value={range} onChange={setRange} />   // range: [dayjs, dayjs] | null
 * ```
 */ 

var $cQmXV = parcelRequire("cQmXV");


var $cQmXV = parcelRequire("cQmXV");
var $ae8573466a034eed$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($ae8573466a034eed$exports, "__esModule", {
    value: true
});
var $ae8573466a034eed$var$ArrowRightOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M869 487.8L491.2 159.9c-2.9-2.5-6.6-3.9-10.5-3.9h-88.5c-7.4 0-10.8 9.2-5.2 14l350.2 304H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h585.1L386.9 854c-5.6 4.9-2.2 14 5.2 14h91.5c1.9 0 3.8-.7 5.2-2L869 536.2a32.07 32.07 0 000-48.4z"
                }
            }
        ]
    },
    "name": "arrow-right",
    "theme": "outlined"
};
$ae8573466a034eed$exports.default = $ae8573466a034eed$var$ArrowRightOutlined;



function $e06b91036be8b9cc$var$_extends() {
    $e06b91036be8b9cc$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e06b91036be8b9cc$var$_extends.apply(this, arguments);
}
const $e06b91036be8b9cc$var$ArrowRightOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $e06b91036be8b9cc$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ae8573466a034eed$exports)))
    }));
/**![arrow-right](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg2OSA0ODcuOEw0OTEuMiAxNTkuOWMtMi45LTIuNS02LjYtMy45LTEwLjUtMy45aC04OC41Yy03LjQgMC0xMC44IDkuMi01LjIgMTRsMzUwLjIgMzA0SDE1MmMtNC40IDAtOCAzLjYtOCA4djYwYzAgNC40IDMuNiA4IDggOGg1ODUuMUwzODYuOSA4NTRjLTUuNiA0LjktMi4yIDE0IDUuMiAxNGg5MS41YzEuOSAwIDMuOC0uNyA1LjItMkw4NjkgNTM2LjJhMzIuMDcgMzIuMDcgMCAwMDAtNDguNHoiIC8+PC9zdmc+) */ const $e06b91036be8b9cc$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($e06b91036be8b9cc$var$ArrowRightOutlined);
var $e06b91036be8b9cc$export$2e2bcd8739ae039 = $e06b91036be8b9cc$var$RefIcon;







const $cc63266e8518a62e$export$bc60caf710959399 = 14;
/** `n` days ending today, inclusive — so 14 is today and the 13 days before it, not 15 days. */ const $cc63266e8518a62e$var$lastDays = (n)=>[
        (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)().subtract(n - 1, "day").startOf("day"),
        (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)().startOf("day")
    ];
const $cc63266e8518a62e$export$33e9fd85c7cf1b3c = ()=>$cc63266e8518a62e$var$lastDays($cc63266e8518a62e$export$bc60caf710959399);
const $cc63266e8518a62e$export$df1f3759cd7b9c97 = (range, earliest)=>{
    if (!earliest || !range?.[0] || !range?.[1]) return range;
    const floor = (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)(earliest).startOf("day");
    const start = (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)(range[0]).isBefore(floor) ? floor : range[0];
    const end = (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)(range[1]).isBefore(floor) ? floor : range[1];
    return [
        start,
        end
    ];
};
const $cc63266e8518a62e$export$e9d4863bcce07ce9 = (range, maxDays)=>{
    if (!maxDays || !range?.[0] || !range?.[1]) return range;
    const earliest = (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)(range[1]).subtract(maxDays - 1, "day");
    return (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)(range[0]).isBefore(earliest) ? [
        earliest,
        range[1]
    ] : range;
};
/** Days a preset spans, inclusive — the same arithmetic `lastDays` builds them with. */ const $cc63266e8518a62e$var$presetDays = ([from, to])=>(0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)(to).diff((0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)(from), "day") + 1;
/* The design's windows, in its order. Built per open rather than per module load, so a tab left
   open overnight does not offer yesterday's "today". */ const $cc63266e8518a62e$var$PRESETS = [
    [
        "date_today",
        ()=>[
                (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)().startOf("day"),
                (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)().startOf("day")
            ]
    ],
    [
        "date_yesterday",
        ()=>[
                (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)().subtract(1, "day").startOf("day"),
                (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)().subtract(1, "day").startOf("day")
            ]
    ],
    [
        "date_last_7_days",
        ()=>[
                (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)().subtract(6, "day").startOf("day"),
                (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)().startOf("day")
            ]
    ],
    [
        "date_last_14_days",
        ()=>$cc63266e8518a62e$var$lastDays($cc63266e8518a62e$export$bc60caf710959399)
    ],
    [
        "date_last_30_days",
        ()=>[
                (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)().subtract(29, "day").startOf("day"),
                (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)().startOf("day")
            ]
    ],
    [
        "date_current_month",
        ()=>[
                (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)().startOf("month"),
                (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)().startOf("day")
            ]
    ],
    [
        "date_last_month",
        ()=>[
                (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)().subtract(1, "month").startOf("month"),
                (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)().subtract(1, "month").endOf("month").startOf("day")
            ]
    ]
];
function $cc63266e8518a62e$export$2e2bcd8739ae039({ value: value, onChange: onChange, allowFuture: allowFuture = false, maxDays: /** Widest window the field will accept, in DAYS (inclusive). Omit for no cap. */ maxDays, earliest: /**
   * Absolute earliest day the field will accept — a dayjs, or omit for no floor.
   *
   * Distinct from `maxDays`, and neither implies the other: `maxDays` caps a window's WIDTH
   * relative to its own end, so `[a year ago, a year ago + 60d]` satisfies a 62-day cap
   * while sitting entirely outside a retention window. A page with a data-retention floor
   * needs both.
   */ earliest, clearTo: /** Where `allowClear` lands. Omit to clear to nothing, as antd does by default. */ clearTo, className: className = "", onOpenChange: onOpenChangeProp, onCalendarChange: onCalendarChangeProp, ...rest }) {
    const lang = (0, $b83e93e5ef3de8b0$export$2105062e25df4afe)((state)=>state.me?.language) || "en";
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), key, lang);
    /* Which end the panel is waiting for, for the footer hint. antd reports the end that just
     changed, so the next one to pick is the other. */ const [picking, setPicking] = (0, $cQmXV.useState)("start");
    /**
   * `disabledDate` is handed the end already picked as `info.from`, which is what makes the cap
   * enforceable in the calendar rather than after the fact: once one end is down, everything
   * further than `maxDays` from it greys out in BOTH directions, so an over-long range cannot
   * be expressed. Without `from` (nothing picked yet) only the future rule applies.
   */ const disabledDate = (current, info)=>{
        if (!current) return false;
        if (!allowFuture && current > (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)().endOf("day")) return true;
        if (earliest && current < (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)(earliest).startOf("day")) return true;
        const from = info?.from;
        if (!maxDays || !from) return false;
        // Inclusive, so a 14-day cap allows a 13-day gap between the two ends.
        return Math.abs(current.diff(from, "day")) > maxDays - 1;
    };
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $bf89508d36c51d8b$export$2e2bcd8739ae039).RangePicker, {
        ...rest,
        className: `pp ${className}`,
        /* `popupClassName` is deprecated in antd v6; the panel's classes live under `classNames`. */ classNames: {
            popup: {
                root: "pp-panel"
            }
        },
        value: value,
        /* The mockup puts the calendar glyph on the leading edge; antd's default is a trailing one. */ prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3368c84d60c50017$export$2e2bcd8739ae039), {}),
        suffixIcon: null,
        /* The mockup's `.rp__dash` is `arrow_forward` — a straight arrow, which spec/02's icon table
         maps to `ArrowRightOutlined`. antd defaults to `SwapRightOutlined`: one half of a swap
         pair, so its shaft carries a dropped tail on the left and it reads as a broken arrow
         rather than "from → to". */ separator: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e06b91036be8b9cc$export$2e2bcd8739ae039), {}),
        allowClear: true,
        placeholder: [
            t("date_from"),
            t("date_to")
        ],
        /* A preset WIDER than the cap is dropped, not clamped. Clamping it left the label lying —
         "Last 30 days" handing back 14 — and a preset the calendar would refuse is a worse bug
         than a missing one. So the cap decides the list: at 14 days the panel offers Today,
         Yesterday, Last 7 and Last 14, and nothing that cannot be picked by hand either. */ presets: $cc63266e8518a62e$var$PRESETS.filter(([, range])=>{
            const span = range();
            if (maxDays && $cc63266e8518a62e$var$presetDays(span) > maxDays) return false;
            // Same reason a too-wide preset is dropped rather than clamped: a preset the
            // calendar would refuse is worse than a missing one.
            return !earliest || !(0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)(span[0]).isBefore((0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)(earliest).startOf("day"));
        }).map(([key, range])=>({
                label: t(key),
                value: range()
            })),
        disabledDate: disabledDate,
        renderExtraFooter: ()=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                className: "pp-hint",
                children: [
                    t(picking === "start" ? "date_pick_start" : "date_pick_end"),
                    maxDays ? ` \xb7 ${t("date_max_range").replace("{n}", maxDays)}` : ""
                ]
            }),
        onOpenChange: (open)=>{
            if (open) setPicking("start");
            onOpenChangeProp?.(open);
        },
        onCalendarChange: (dates, strings, info)=>{
            setPicking(info?.range === "start" ? "end" : "start");
            onCalendarChangeProp?.(dates, strings, info);
        },
        /* A half-picked range is not a range: report null until both ends exist. Clearing reports
         `clearTo` when the caller named one — the field is never empty on those pages, so the
         page cannot end up querying without a window. */ onChange: (next)=>onChange(next && next[0] && next[1] ? $cc63266e8518a62e$export$df1f3759cd7b9c97($cc63266e8518a62e$export$e9d4863bcce07ce9(next, maxDays), earliest) : clearTo?.() ?? null)
    });
}



class $ec5347b150ba521a$export$4c12a832a2e7f99f {
    constructor(data){
        this.id = data.id; // string
        /* The recorded GPS track: a list of coordinates, written only by the mobile app. Present only
       on the single-visit endpoint (`VisitDetailSerializer`) — every other visit serializer
       excludes it, so it is absent from list rows and from a visit nested in an answer. */ this.meta = data.meta;
        this.point = data.point; // object
        this.start = data.start; // string
        this.end = data.end; // string
        this.user = data.user;
    }
}


var $aa2d6dc1bd01cabc$exports = {};
$aa2d6dc1bd01cabc$exports = new URL("no_photo.e6da4db4.jpg", import.meta.url).toString();


/*!
 * mime-types
 * Copyright(c) 2014 Jonathan Ong
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */ /**
 * Module exports.
 * @public
 */ var $2a0f535cbe281dd6$export$e4c823724462c3fd;
var $2a0f535cbe281dd6$export$48d2c0a44ea41a2f;
var $2a0f535cbe281dd6$export$8019223850b8bf78;
var $2a0f535cbe281dd6$export$1b45514b112dd749;
var $2a0f535cbe281dd6$export$cc3e2d3244e01b7f;
var $2a0f535cbe281dd6$export$dfc7155ac0343b8;
var $2a0f535cbe281dd6$export$b14ad400b1d09e0f;
"use strict";
var $6b496156e4d3d65d$exports = {};
/*!
 * mime-db
 * Copyright(c) 2014 Jonathan Ong
 * Copyright(c) 2015-2022 Douglas Christopher Wilson
 * MIT Licensed
 */ /**
 * Module exports.
 */ 
$6b496156e4d3d65d$exports = (parcelRequire("bdrlo"));


var $e60c8a8b864d4b98$exports = {};
// 'path' module extracted from Node.js v8.11.1 (only the posix part)
// transplited with Babel
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $4dBQg = parcelRequire("4dBQg");
"use strict";
function $e60c8a8b864d4b98$var$assertPath(path) {
    if (typeof path !== "string") throw new TypeError("Path must be a string. Received " + JSON.stringify(path));
}
// Resolves . and .. elements in a path with directory names
function $e60c8a8b864d4b98$var$normalizeStringPosix(path, allowAboveRoot) {
    var res = "";
    var lastSegmentLength = 0;
    var lastSlash = -1;
    var dots = 0;
    var code;
    for(var i = 0; i <= path.length; ++i){
        if (i < path.length) code = path.charCodeAt(i);
        else if (code === 47 /*/*/ ) break;
        else code = 47 /*/*/ ;
        if (code === 47 /*/*/ ) {
            if (lastSlash === i - 1 || dots === 1) ;
            else if (lastSlash !== i - 1 && dots === 2) {
                if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 /*.*/  || res.charCodeAt(res.length - 2) !== 46 /*.*/ ) {
                    if (res.length > 2) {
                        var lastSlashIndex = res.lastIndexOf("/");
                        if (lastSlashIndex !== res.length - 1) {
                            if (lastSlashIndex === -1) {
                                res = "";
                                lastSegmentLength = 0;
                            } else {
                                res = res.slice(0, lastSlashIndex);
                                lastSegmentLength = res.length - 1 - res.lastIndexOf("/");
                            }
                            lastSlash = i;
                            dots = 0;
                            continue;
                        }
                    } else if (res.length === 2 || res.length === 1) {
                        res = "";
                        lastSegmentLength = 0;
                        lastSlash = i;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    if (res.length > 0) res += "/..";
                    else res = "..";
                    lastSegmentLength = 2;
                }
            } else {
                if (res.length > 0) res += "/" + path.slice(lastSlash + 1, i);
                else res = path.slice(lastSlash + 1, i);
                lastSegmentLength = i - lastSlash - 1;
            }
            lastSlash = i;
            dots = 0;
        } else if (code === 46 /*.*/  && dots !== -1) ++dots;
        else dots = -1;
    }
    return res;
}
function $e60c8a8b864d4b98$var$_format(sep, pathObject) {
    var dir = pathObject.dir || pathObject.root;
    var base = pathObject.base || (pathObject.name || "") + (pathObject.ext || "");
    if (!dir) return base;
    if (dir === pathObject.root) return dir + base;
    return dir + sep + base;
}
var $e60c8a8b864d4b98$var$posix = {
    // path.resolve([from ...], to)
    resolve: function resolve() {
        var resolvedPath = "";
        var resolvedAbsolute = false;
        var cwd;
        for(var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--){
            var path;
            if (i >= 0) path = arguments[i];
            else {
                if (cwd === undefined) cwd = $4dBQg.cwd();
                path = cwd;
            }
            $e60c8a8b864d4b98$var$assertPath(path);
            // Skip empty entries
            if (path.length === 0) continue;
            resolvedPath = path + "/" + resolvedPath;
            resolvedAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        }
        // At this point the path should be resolved to a full absolute path, but
        // handle relative paths to be safe (might happen when process.cwd() fails)
        // Normalize the path
        resolvedPath = $e60c8a8b864d4b98$var$normalizeStringPosix(resolvedPath, !resolvedAbsolute);
        if (resolvedAbsolute) {
            if (resolvedPath.length > 0) return "/" + resolvedPath;
            else return "/";
        } else if (resolvedPath.length > 0) return resolvedPath;
        else return ".";
    },
    normalize: function normalize(path) {
        $e60c8a8b864d4b98$var$assertPath(path);
        if (path.length === 0) return ".";
        var isAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        var trailingSeparator = path.charCodeAt(path.length - 1) === 47 /*/*/ ;
        // Normalize the path
        path = $e60c8a8b864d4b98$var$normalizeStringPosix(path, !isAbsolute);
        if (path.length === 0 && !isAbsolute) path = ".";
        if (path.length > 0 && trailingSeparator) path += "/";
        if (isAbsolute) return "/" + path;
        return path;
    },
    isAbsolute: function isAbsolute(path) {
        $e60c8a8b864d4b98$var$assertPath(path);
        return path.length > 0 && path.charCodeAt(0) === 47 /*/*/ ;
    },
    join: function join() {
        if (arguments.length === 0) return ".";
        var joined;
        for(var i = 0; i < arguments.length; ++i){
            var arg = arguments[i];
            $e60c8a8b864d4b98$var$assertPath(arg);
            if (arg.length > 0) {
                if (joined === undefined) joined = arg;
                else joined += "/" + arg;
            }
        }
        if (joined === undefined) return ".";
        return $e60c8a8b864d4b98$var$posix.normalize(joined);
    },
    relative: function relative(from, to) {
        $e60c8a8b864d4b98$var$assertPath(from);
        $e60c8a8b864d4b98$var$assertPath(to);
        if (from === to) return "";
        from = $e60c8a8b864d4b98$var$posix.resolve(from);
        to = $e60c8a8b864d4b98$var$posix.resolve(to);
        if (from === to) return "";
        // Trim any leading backslashes
        var fromStart = 1;
        for(; fromStart < from.length; ++fromStart){
            if (from.charCodeAt(fromStart) !== 47 /*/*/ ) break;
        }
        var fromEnd = from.length;
        var fromLen = fromEnd - fromStart;
        // Trim any leading backslashes
        var toStart = 1;
        for(; toStart < to.length; ++toStart){
            if (to.charCodeAt(toStart) !== 47 /*/*/ ) break;
        }
        var toEnd = to.length;
        var toLen = toEnd - toStart;
        // Compare paths to find the longest common path from root
        var length = fromLen < toLen ? fromLen : toLen;
        var lastCommonSep = -1;
        var i = 0;
        for(; i <= length; ++i){
            if (i === length) {
                if (toLen > length) {
                    if (to.charCodeAt(toStart + i) === 47 /*/*/ ) // We get here if `from` is the exact base path for `to`.
                    // For example: from='/foo/bar'; to='/foo/bar/baz'
                    return to.slice(toStart + i + 1);
                    else if (i === 0) // We get here if `from` is the root
                    // For example: from='/'; to='/foo'
                    return to.slice(toStart + i);
                } else if (fromLen > length) {
                    if (from.charCodeAt(fromStart + i) === 47 /*/*/ ) // We get here if `to` is the exact base path for `from`.
                    // For example: from='/foo/bar/baz'; to='/foo/bar'
                    lastCommonSep = i;
                    else if (i === 0) // We get here if `to` is the root.
                    // For example: from='/foo'; to='/'
                    lastCommonSep = 0;
                }
                break;
            }
            var fromCode = from.charCodeAt(fromStart + i);
            var toCode = to.charCodeAt(toStart + i);
            if (fromCode !== toCode) break;
            else if (fromCode === 47 /*/*/ ) lastCommonSep = i;
        }
        var out = "";
        // Generate the relative path based on the path difference between `to`
        // and `from`
        for(i = fromStart + lastCommonSep + 1; i <= fromEnd; ++i)if (i === fromEnd || from.charCodeAt(i) === 47 /*/*/ ) {
            if (out.length === 0) out += "..";
            else out += "/..";
        }
        // Lastly, append the rest of the destination (`to`) path that comes after
        // the common path parts
        if (out.length > 0) return out + to.slice(toStart + lastCommonSep);
        else {
            toStart += lastCommonSep;
            if (to.charCodeAt(toStart) === 47 /*/*/ ) ++toStart;
            return to.slice(toStart);
        }
    },
    _makeLong: function _makeLong(path) {
        return path;
    },
    dirname: function dirname(path) {
        $e60c8a8b864d4b98$var$assertPath(path);
        if (path.length === 0) return ".";
        var code = path.charCodeAt(0);
        var hasRoot = code === 47 /*/*/ ;
        var end = -1;
        var matchedSlash = true;
        for(var i = path.length - 1; i >= 1; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                if (!matchedSlash) {
                    end = i;
                    break;
                }
            } else // We saw the first non-path separator
            matchedSlash = false;
        }
        if (end === -1) return hasRoot ? "/" : ".";
        if (hasRoot && end === 1) return "//";
        return path.slice(0, end);
    },
    basename: function basename(path, ext) {
        if (ext !== undefined && typeof ext !== "string") throw new TypeError('"ext" argument must be a string');
        $e60c8a8b864d4b98$var$assertPath(path);
        var start = 0;
        var end = -1;
        var matchedSlash = true;
        var i;
        if (ext !== undefined && ext.length > 0 && ext.length <= path.length) {
            if (ext.length === path.length && ext === path) return "";
            var extIdx = ext.length - 1;
            var firstNonSlashEnd = -1;
            for(i = path.length - 1; i >= 0; --i){
                var code = path.charCodeAt(i);
                if (code === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else {
                    if (firstNonSlashEnd === -1) {
                        // We saw the first non-path separator, remember this index in case
                        // we need it if the extension ends up not matching
                        matchedSlash = false;
                        firstNonSlashEnd = i + 1;
                    }
                    if (extIdx >= 0) {
                        // Try to match the explicit extension
                        if (code === ext.charCodeAt(extIdx)) {
                            if (--extIdx === -1) // We matched the extension, so mark this as the end of our path
                            // component
                            end = i;
                        } else {
                            // Extension does not match, so our result is the entire path
                            // component
                            extIdx = -1;
                            end = firstNonSlashEnd;
                        }
                    }
                }
            }
            if (start === end) end = firstNonSlashEnd;
            else if (end === -1) end = path.length;
            return path.slice(start, end);
        } else {
            for(i = path.length - 1; i >= 0; --i){
                if (path.charCodeAt(i) === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else if (end === -1) {
                    // We saw the first non-path separator, mark this as the end of our
                    // path component
                    matchedSlash = false;
                    end = i + 1;
                }
            }
            if (end === -1) return "";
            return path.slice(start, end);
        }
    },
    extname: function extname(path) {
        $e60c8a8b864d4b98$var$assertPath(path);
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        for(var i = path.length - 1; i >= 0; --i){
            var code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return "";
        return path.slice(startDot, end);
    },
    format: function format(pathObject) {
        if (pathObject === null || typeof pathObject !== "object") throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof pathObject);
        return $e60c8a8b864d4b98$var$_format("/", pathObject);
    },
    parse: function parse(path) {
        $e60c8a8b864d4b98$var$assertPath(path);
        var ret = {
            root: "",
            dir: "",
            base: "",
            ext: "",
            name: ""
        };
        if (path.length === 0) return ret;
        var code = path.charCodeAt(0);
        var isAbsolute = code === 47 /*/*/ ;
        var start;
        if (isAbsolute) {
            ret.root = "/";
            start = 1;
        } else start = 0;
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        var i = path.length - 1;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        // Get non-dir info
        for(; i >= start; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
            if (end !== -1) {
                if (startPart === 0 && isAbsolute) ret.base = ret.name = path.slice(1, end);
                else ret.base = ret.name = path.slice(startPart, end);
            }
        } else {
            if (startPart === 0 && isAbsolute) {
                ret.name = path.slice(1, startDot);
                ret.base = path.slice(1, end);
            } else {
                ret.name = path.slice(startPart, startDot);
                ret.base = path.slice(startPart, end);
            }
            ret.ext = path.slice(startDot, end);
        }
        if (startPart > 0) ret.dir = path.slice(0, startPart - 1);
        else if (isAbsolute) ret.dir = "/";
        return ret;
    },
    sep: "/",
    delimiter: ":",
    win32: null,
    posix: null
};
$e60c8a8b864d4b98$var$posix.posix = $e60c8a8b864d4b98$var$posix;
$e60c8a8b864d4b98$exports = $e60c8a8b864d4b98$var$posix;


var $2a0f535cbe281dd6$require$extname = $e60c8a8b864d4b98$exports.extname;
/**
 * Module variables.
 * @private
 */ var $2a0f535cbe281dd6$var$EXTRACT_TYPE_REGEXP = /^\s*([^;\s]*)(?:;|\s|$)/;
var $2a0f535cbe281dd6$var$TEXT_TYPE_REGEXP = /^text\//i;
$2a0f535cbe281dd6$export$e4c823724462c3fd = $2a0f535cbe281dd6$var$charset;
$2a0f535cbe281dd6$export$48d2c0a44ea41a2f = {
    lookup: $2a0f535cbe281dd6$var$charset
};
$2a0f535cbe281dd6$export$8019223850b8bf78 = $2a0f535cbe281dd6$var$contentType;
$2a0f535cbe281dd6$export$1b45514b112dd749 = $2a0f535cbe281dd6$var$extension;
$2a0f535cbe281dd6$export$cc3e2d3244e01b7f = Object.create(null);
$2a0f535cbe281dd6$export$dfc7155ac0343b8 = $2a0f535cbe281dd6$var$lookup;
$2a0f535cbe281dd6$export$b14ad400b1d09e0f = Object.create(null);
// Populate the extensions/types maps
$2a0f535cbe281dd6$var$populateMaps($2a0f535cbe281dd6$export$cc3e2d3244e01b7f, $2a0f535cbe281dd6$export$b14ad400b1d09e0f);
/**
 * Get the default charset for a MIME type.
 *
 * @param {string} type
 * @return {boolean|string}
 */ function $2a0f535cbe281dd6$var$charset(type) {
    if (!type || typeof type !== "string") return false;
    // TODO: use media-typer
    var match = $2a0f535cbe281dd6$var$EXTRACT_TYPE_REGEXP.exec(type);
    var mime = match && $6b496156e4d3d65d$exports[match[1].toLowerCase()];
    if (mime && mime.charset) return mime.charset;
    // default text/* to utf-8
    if (match && $2a0f535cbe281dd6$var$TEXT_TYPE_REGEXP.test(match[1])) return "UTF-8";
    return false;
}
/**
 * Create a full Content-Type header given a MIME type or extension.
 *
 * @param {string} str
 * @return {boolean|string}
 */ function $2a0f535cbe281dd6$var$contentType(str) {
    // TODO: should this even be in this module?
    if (!str || typeof str !== "string") return false;
    var mime = str.indexOf("/") === -1 ? $2a0f535cbe281dd6$export$dfc7155ac0343b8(str) : str;
    if (!mime) return false;
    // TODO: use content-type or other module
    if (mime.indexOf("charset") === -1) {
        var charset = $2a0f535cbe281dd6$export$e4c823724462c3fd(mime);
        if (charset) mime += "; charset=" + charset.toLowerCase();
    }
    return mime;
}
/**
 * Get the default extension for a MIME type.
 *
 * @param {string} type
 * @return {boolean|string}
 */ function $2a0f535cbe281dd6$var$extension(type) {
    if (!type || typeof type !== "string") return false;
    // TODO: use media-typer
    var match = $2a0f535cbe281dd6$var$EXTRACT_TYPE_REGEXP.exec(type);
    // get extensions
    var exts = match && $2a0f535cbe281dd6$export$cc3e2d3244e01b7f[match[1].toLowerCase()];
    if (!exts || !exts.length) return false;
    return exts[0];
}
/**
 * Lookup the MIME type for a file path/extension.
 *
 * @param {string} path
 * @return {boolean|string}
 */ function $2a0f535cbe281dd6$var$lookup(path) {
    if (!path || typeof path !== "string") return false;
    // get the extension ("ext" or ".ext" or full path)
    var extension = $2a0f535cbe281dd6$require$extname("x." + path).toLowerCase().substr(1);
    if (!extension) return false;
    return $2a0f535cbe281dd6$export$b14ad400b1d09e0f[extension] || false;
}
/**
 * Populate the extensions and types maps.
 * @private
 */ function $2a0f535cbe281dd6$var$populateMaps(extensions, types) {
    // source preference (least -> most)
    var preference = [
        "nginx",
        "apache",
        undefined,
        "iana"
    ];
    Object.keys($6b496156e4d3d65d$exports).forEach(function forEachMimeType(type) {
        var mime = $6b496156e4d3d65d$exports[type];
        var exts = mime.extensions;
        if (!exts || !exts.length) return;
        // mime -> extensions
        extensions[type] = exts;
        // extension -> mime
        for(var i = 0; i < exts.length; i++){
            var extension = exts[i];
            if (types[extension]) {
                var from = preference.indexOf($6b496156e4d3d65d$exports[types[extension]].source);
                var to = preference.indexOf(mime.source);
                if (types[extension] !== "application/octet-stream" && (from > to || from === to && types[extension].substr(0, 12) === "application/")) continue;
            }
            // set the extension -> mime
            types[extension] = type;
        }
    });
}


const $dd80b063693a1e94$export$bef94a5618bf18bf = (urlString)=>{
    urlString = urlString ? urlString : "NEW ITEM NOT EXIST";
    try {
        new URL(urlString);
        return true;
    } catch (err) {
        console.error("Error on getting photo url", err);
        return false;
    }
};
function $dd80b063693a1e94$export$fb85bc5d6d9ef19b(url) {
    const mimeType = $2a0f535cbe281dd6$export$dfc7155ac0343b8(url);
    return mimeType && mimeType.startsWith("image/");
}


class $4e9873a13607b352$export$29d24e359e2fdff9 {
    constructor(data){
        this.id = data.id; // number
        this.additional_info = data.ticket_contents && data.ticket_contents.length > 0 ? data.ticket_contents[0].additional_info : data.additional_info ? data.additional_info : null; // object
        this.picsell_info = data.picsell_info || {}; // obj
        this.approval = data.approval || {}; // obj
        this.ticket = data.ticket || ""; // string
        this.ticket_additional_info = data.ticket_additional_info || null; // object
        this.tip = data.tip || ""; // string
        // this.photo = data.url_photo && isValidUrl(data.url_photo) ? data.url_photo : ""; // string ${PHOTO_REVIEW_IMAGE_URL_BASE}
        this.photo = this.imgGroup(data);
        this.visit = data.visit && new (0, $ec5347b150ba521a$export$4c12a832a2e7f99f)(data.visit);
        this.visit_id = data.visit_id; // string
    }
    imgGroup(data) {
        const arrPhotos = [];
        if (data.ticket_contents && data.ticket_contents.length > 0) {
            data.ticket_contents.forEach((item)=>{
                (0, $dd80b063693a1e94$export$fb85bc5d6d9ef19b)(item.url_photo) ? arrPhotos.push(item.url_photo) : arrPhotos.push((0, (/*@__PURE__*/$parcel$interopDefault($aa2d6dc1bd01cabc$exports))));
            });
            return arrPhotos;
        } else {
            (0, $dd80b063693a1e94$export$fb85bc5d6d9ef19b)(data.url_photo) ? arrPhotos.push(data.url_photo) : arrPhotos.push((0, (/*@__PURE__*/$parcel$interopDefault($aa2d6dc1bd01cabc$exports))));
            return arrPhotos;
        }
    }
}






/* Reject → corrective task (Доручення).
 *
 * Restores the flow the redesign dropped: rejecting a photo does not just record a verdict, it
 * asks the merchandiser to fix the shelf. The rejection is posted only AFTER the task is created,
 * so a failed task never leaves a rejection with nothing attached to it — that ordering is from
 * the pre-redesign implementation and is the reason it is worth keeping.
 *
 * The payload is the old one, field for field (`git show HEAD:src/module/photo-review/View.js`):
 * `components: [3]` is the "photo" component, hardcoded there too because the API exposes no way
 * to look it up; `template` is seeded with the company's default from `templates/`.
 *
 * Shared by `/photo-review` and `/answers`. It takes the four things it actually needs rather than
 * a page's record — it used to read `item.picsell_info` and `item.photo[0]`, which is the photo
 * report's own shape and nothing else's:
 *
 * ```jsx
 * <RejectTaskModal
 *   target={{ objectId, objectType }}   // what the verdict is posted against
 *   photo={url}                         // what the annotator opens on; optional
 *   point={{ id, name, locality }}      // where the corrective task lands; optional
 *   visitId={n} lang={lang} onCancel={…} onDone={…} />
 * ```
 */ 

var $cQmXV = parcelRequire("cQmXV");








/* Photo annotator — mark up a rejected photo before it becomes a corrective task.
 *
 * The job is to say WHERE the problem is: circle the gap on the shelf, box the wrong facing, write
 * a word next to it. Four marks cover that — pen, box, arrow, text — plus a stroke weight and a
 * colour. Anything more is a drawing app, not a review tool.
 *
 * Two things shape the implementation:
 *
 * 1. The viewport is FIXED height and the photo is fitted into it. A shelf photo is 3–4000px tall;
 *    rendered at the form's width it pushed every field below the fold, which is what made the
 *    form unusable. Scroll zooms about the cursor and drag pans, so detail is still reachable.
 * 2. Marks are stored in the IMAGE's coordinate space, never the viewport's. That is what lets the
 *    view zoom, pan and resize without the marks drifting, and what lets the export run at the
 *    photo's own resolution from a second, untransformed stage.
 *
 * The photo is loaded through `images/convert_image_to_base64/` — the same server-side hop
 * `urlToIdPhotoAsync` uses — because the S3 bucket sends no CORS headers, and a canvas that has
 * drawn a cross-origin image is tainted: `toDataURL()` then throws and there is nothing to upload.
 */ 

var $cQmXV = parcelRequire("cQmXV");


var $cQmXV = parcelRequire("cQmXV");
var $2da03a0643d55430$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($2da03a0643d55430$exports, "__esModule", {
    value: true
});
var $2da03a0643d55430$var$BorderOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z"
                }
            }
        ]
    },
    "name": "border",
    "theme": "outlined"
};
$2da03a0643d55430$exports.default = $2da03a0643d55430$var$BorderOutlined;



function $6a1efae62acd3656$var$_extends() {
    $6a1efae62acd3656$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6a1efae62acd3656$var$_extends.apply(this, arguments);
}
const $6a1efae62acd3656$var$BorderOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $6a1efae62acd3656$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2da03a0643d55430$exports)))
    }));
/**![border](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg4MCAxMTJIMTQ0Yy0xNy43IDAtMzIgMTQuMy0zMiAzMnY3MzZjMCAxNy43IDE0LjMgMzIgMzIgMzJoNzM2YzE3LjcgMCAzMi0xNC4zIDMyLTMyVjE0NGMwLTE3LjctMTQuMy0zMi0zMi0zMnptLTQwIDcyOEgxODRWMTg0aDY1NnY2NTZ6IiAvPjwvc3ZnPg==) */ const $6a1efae62acd3656$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($6a1efae62acd3656$var$BorderOutlined);
var $6a1efae62acd3656$export$2e2bcd8739ae039 = $6a1efae62acd3656$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $ea82dec6fdb496d6$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($ea82dec6fdb496d6$exports, "__esModule", {
    value: true
});
var $ea82dec6fdb496d6$var$FontSizeOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M920 416H616c-4.4 0-8 3.6-8 8v112c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-56h60v320h-46c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h164c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-46V480h60v56c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V424c0-4.4-3.6-8-8-8zM656 296V168c0-4.4-3.6-8-8-8H104c-4.4 0-8 3.6-8 8v128c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-64h168v560h-92c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-92V232h168v64c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8z"
                }
            }
        ]
    },
    "name": "font-size",
    "theme": "outlined"
};
$ea82dec6fdb496d6$exports.default = $ea82dec6fdb496d6$var$FontSizeOutlined;



function $e06fa30038248833$var$_extends() {
    $e06fa30038248833$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e06fa30038248833$var$_extends.apply(this, arguments);
}
const $e06fa30038248833$var$FontSizeOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $e06fa30038248833$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ea82dec6fdb496d6$exports)))
    }));
/**![font-size](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkyMCA0MTZINjE2Yy00LjQgMC04IDMuNi04IDh2MTEyYzAgNC40IDMuNiA4IDggOGg0OGM0LjQgMCA4LTMuNiA4LTh2LTU2aDYwdjMyMGgtNDZjLTQuNCAwLTggMy42LTggOHY0OGMwIDQuNCAzLjYgOCA4IDhoMTY0YzQuNCAwIDgtMy42IDgtOHYtNDhjMC00LjQtMy42LTgtOC04aC00NlY0ODBoNjB2NTZjMCA0LjQgMy42IDggOCA4aDQ4YzQuNCAwIDgtMy42IDgtOFY0MjRjMC00LjQtMy42LTgtOC04ek02NTYgMjk2VjE2OGMwLTQuNC0zLjYtOC04LThIMTA0Yy00LjQgMC04IDMuNi04IDh2MTI4YzAgNC40IDMuNiA4IDggOGg1NmM0LjQgMCA4LTMuNiA4LTh2LTY0aDE2OHY1NjBoLTkyYy00LjQgMC04IDMuNi04IDh2NTZjMCA0LjQgMy42IDggOCA4aDI2NGM0LjQgMCA4LTMuNiA4LTh2LTU2YzAtNC40LTMuNi04LTgtOGgtOTJWMjMyaDE2OHY2NGMwIDQuNCAzLjYgOCA4IDhoNTZjNC40IDAgOC0zLjYgOC04eiIgLz48L3N2Zz4=) */ const $e06fa30038248833$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($e06fa30038248833$var$FontSizeOutlined);
var $e06fa30038248833$export$2e2bcd8739ae039 = $e06fa30038248833$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $60df30d744d73e87$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($60df30d744d73e87$exports, "__esModule", {
    value: true
});
var $60df30d744d73e87$var$DragOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M909.3 506.3L781.7 405.6a7.23 7.23 0 00-11.7 5.7V476H548V254h64.8c6 0 9.4-7 5.7-11.7L517.7 114.7a7.14 7.14 0 00-11.3 0L405.6 242.3a7.23 7.23 0 005.7 11.7H476v222H254v-64.8c0-6-7-9.4-11.7-5.7L114.7 506.3a7.14 7.14 0 000 11.3l127.5 100.8c4.7 3.7 11.7.4 11.7-5.7V548h222v222h-64.8c-6 0-9.4 7-5.7 11.7l100.8 127.5c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5c3.7-4.7.4-11.7-5.7-11.7H548V548h222v64.8c0 6 7 9.4 11.7 5.7l127.5-100.8a7.3 7.3 0 00.1-11.4z"
                }
            }
        ]
    },
    "name": "drag",
    "theme": "outlined"
};
$60df30d744d73e87$exports.default = $60df30d744d73e87$var$DragOutlined;



function $28aae357299e4b48$var$_extends() {
    $28aae357299e4b48$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $28aae357299e4b48$var$_extends.apply(this, arguments);
}
const $28aae357299e4b48$var$DragOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $28aae357299e4b48$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($60df30d744d73e87$exports)))
    }));
/**![drag](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkwOS4zIDUwNi4zTDc4MS43IDQwNS42YTcuMjMgNy4yMyAwIDAwLTExLjcgNS43VjQ3Nkg1NDhWMjU0aDY0LjhjNiAwIDkuNC03IDUuNy0xMS43TDUxNy43IDExNC43YTcuMTQgNy4xNCAwIDAwLTExLjMgMEw0MDUuNiAyNDIuM2E3LjIzIDcuMjMgMCAwMDUuNyAxMS43SDQ3NnYyMjJIMjU0di02NC44YzAtNi03LTkuNC0xMS43LTUuN0wxMTQuNyA1MDYuM2E3LjE0IDcuMTQgMCAwMDAgMTEuM2wxMjcuNSAxMDAuOGM0LjcgMy43IDExLjcuNCAxMS43LTUuN1Y1NDhoMjIydjIyMmgtNjQuOGMtNiAwLTkuNCA3LTUuNyAxMS43bDEwMC44IDEyNy41YzIuOSAzLjcgOC41IDMuNyAxMS4zIDBsMTAwLjgtMTI3LjVjMy43LTQuNy40LTExLjctNS43LTExLjdINTQ4VjU0OGgyMjJ2NjQuOGMwIDYgNyA5LjQgMTEuNyA1LjdsMTI3LjUtMTAwLjhhNy4zIDcuMyAwIDAwLjEtMTEuNHoiIC8+PC9zdmc+) */ const $28aae357299e4b48$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($28aae357299e4b48$var$DragOutlined);
var $28aae357299e4b48$export$2e2bcd8739ae039 = $28aae357299e4b48$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $dfea882007cc8830$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($dfea882007cc8830$exports, "__esModule", {
    value: true
});
var $dfea882007cc8830$var$AimOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M952 474H829.8C812.5 327.6 696.4 211.5 550 194.2V72c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v122.2C327.6 211.5 211.5 327.6 194.2 474H72c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h122.2C211.5 696.4 327.6 812.5 474 829.8V952c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V829.8C696.4 812.5 812.5 696.4 829.8 550H952c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zM512 756c-134.8 0-244-109.2-244-244s109.2-244 244-244 244 109.2 244 244-109.2 244-244 244z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 392c-32.1 0-62.1 12.4-84.8 35.2-22.7 22.7-35.2 52.7-35.2 84.8s12.5 62.1 35.2 84.8C449.9 619.4 480 632 512 632s62.1-12.5 84.8-35.2C619.4 574.1 632 544 632 512s-12.5-62.1-35.2-84.8A118.57 118.57 0 00512 392z"
                }
            }
        ]
    },
    "name": "aim",
    "theme": "outlined"
};
$dfea882007cc8830$exports.default = $dfea882007cc8830$var$AimOutlined;



function $bd49e6611c97a88c$var$_extends() {
    $bd49e6611c97a88c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bd49e6611c97a88c$var$_extends.apply(this, arguments);
}
const $bd49e6611c97a88c$var$AimOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $bd49e6611c97a88c$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dfea882007cc8830$exports)))
    }));
/**![aim](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTk1MiA0NzRIODI5LjhDODEyLjUgMzI3LjYgNjk2LjQgMjExLjUgNTUwIDE5NC4yVjcyYzAtNC40LTMuNi04LTgtOGgtNjBjLTQuNCAwLTggMy42LTggOHYxMjIuMkMzMjcuNiAyMTEuNSAyMTEuNSAzMjcuNiAxOTQuMiA0NzRINzJjLTQuNCAwLTggMy42LTggOHY2MGMwIDQuNCAzLjYgOCA4IDhoMTIyLjJDMjExLjUgNjk2LjQgMzI3LjYgODEyLjUgNDc0IDgyOS44Vjk1MmMwIDQuNCAzLjYgOCA4IDhoNjBjNC40IDAgOC0zLjYgOC04VjgyOS44QzY5Ni40IDgxMi41IDgxMi41IDY5Ni40IDgyOS44IDU1MEg5NTJjNC40IDAgOC0zLjYgOC04di02MGMwLTQuNC0zLjYtOC04LTh6TTUxMiA3NTZjLTEzNC44IDAtMjQ0LTEwOS4yLTI0NC0yNDRzMTA5LjItMjQ0IDI0NC0yNDQgMjQ0IDEwOS4yIDI0NCAyNDQtMTA5LjIgMjQ0LTI0NCAyNDR6IiAvPjxwYXRoIGQ9Ik01MTIgMzkyYy0zMi4xIDAtNjIuMSAxMi40LTg0LjggMzUuMi0yMi43IDIyLjctMzUuMiA1Mi43LTM1LjIgODQuOHMxMi41IDYyLjEgMzUuMiA4NC44QzQ0OS45IDYxOS40IDQ4MCA2MzIgNTEyIDYzMnM2Mi4xLTEyLjUgODQuOC0zNS4yQzYxOS40IDU3NC4xIDYzMiA1NDQgNjMyIDUxMnMtMTIuNS02Mi4xLTM1LjItODQuOEExMTguNTcgMTE4LjU3IDAgMDA1MTIgMzkyeiIgLz48L3N2Zz4=) */ const $bd49e6611c97a88c$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($bd49e6611c97a88c$var$AimOutlined);
var $bd49e6611c97a88c$export$2e2bcd8739ae039 = $bd49e6611c97a88c$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $99678d0f40b4c364$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($99678d0f40b4c364$exports, "__esModule", {
    value: true
});
var $99678d0f40b4c364$var$UndoOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M511.4 124C290.5 124.3 112 303 112 523.9c0 128 60.2 242 153.8 315.2l-37.5 48c-4.1 5.3-.3 13 6.3 12.9l167-.8c5.2 0 9-4.9 7.7-9.9L369.8 727a8 8 0 00-14.1-3L315 776.1c-10.2-8-20-16.7-29.3-26a318.64 318.64 0 01-68.6-101.7C200.4 609 192 567.1 192 523.9s8.4-85.1 25.1-124.5c16.1-38.1 39.2-72.3 68.6-101.7 29.4-29.4 63.6-52.5 101.7-68.6C426.9 212.4 468.8 204 512 204s85.1 8.4 124.5 25.1c38.1 16.1 72.3 39.2 101.7 68.6 29.4 29.4 52.5 63.6 68.6 101.7 16.7 39.4 25.1 81.3 25.1 124.5s-8.4 85.1-25.1 124.5a318.64 318.64 0 01-68.6 101.7c-7.5 7.5-15.3 14.5-23.4 21.2a7.93 7.93 0 00-1.2 11.1l39.4 50.5c2.8 3.5 7.9 4.1 11.4 1.3C854.5 760.8 912 649.1 912 523.9c0-221.1-179.4-400.2-400.6-399.9z"
                }
            }
        ]
    },
    "name": "undo",
    "theme": "outlined"
};
$99678d0f40b4c364$exports.default = $99678d0f40b4c364$var$UndoOutlined;



function $89531e4b0315317b$var$_extends() {
    $89531e4b0315317b$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $89531e4b0315317b$var$_extends.apply(this, arguments);
}
const $89531e4b0315317b$var$UndoOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $89531e4b0315317b$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($99678d0f40b4c364$exports)))
    }));
/**![undo](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMS40IDEyNEMyOTAuNSAxMjQuMyAxMTIgMzAzIDExMiA1MjMuOWMwIDEyOCA2MC4yIDI0MiAxNTMuOCAzMTUuMmwtMzcuNSA0OGMtNC4xIDUuMy0uMyAxMyA2LjMgMTIuOWwxNjctLjhjNS4yIDAgOS00LjkgNy43LTkuOUwzNjkuOCA3MjdhOCA4IDAgMDAtMTQuMS0zTDMxNSA3NzYuMWMtMTAuMi04LTIwLTE2LjctMjkuMy0yNmEzMTguNjQgMzE4LjY0IDAgMDEtNjguNi0xMDEuN0MyMDAuNCA2MDkgMTkyIDU2Ny4xIDE5MiA1MjMuOXM4LjQtODUuMSAyNS4xLTEyNC41YzE2LjEtMzguMSAzOS4yLTcyLjMgNjguNi0xMDEuNyAyOS40LTI5LjQgNjMuNi01Mi41IDEwMS43LTY4LjZDNDI2LjkgMjEyLjQgNDY4LjggMjA0IDUxMiAyMDRzODUuMSA4LjQgMTI0LjUgMjUuMWMzOC4xIDE2LjEgNzIuMyAzOS4yIDEwMS43IDY4LjYgMjkuNCAyOS40IDUyLjUgNjMuNiA2OC42IDEwMS43IDE2LjcgMzkuNCAyNS4xIDgxLjMgMjUuMSAxMjQuNXMtOC40IDg1LjEtMjUuMSAxMjQuNWEzMTguNjQgMzE4LjY0IDAgMDEtNjguNiAxMDEuN2MtNy41IDcuNS0xNS4zIDE0LjUtMjMuNCAyMS4yYTcuOTMgNy45MyAwIDAwLTEuMiAxMS4xbDM5LjQgNTAuNWMyLjggMy41IDcuOSA0LjEgMTEuNCAxLjNDODU0LjUgNzYwLjggOTEyIDY0OS4xIDkxMiA1MjMuOWMwLTIyMS4xLTE3OS40LTQwMC4yLTQwMC42LTM5OS45eiIgLz48L3N2Zz4=) */ const $89531e4b0315317b$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($89531e4b0315317b$var$UndoOutlined);
var $89531e4b0315317b$export$2e2bcd8739ae039 = $89531e4b0315317b$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $1dbd22c9c7844406$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($1dbd22c9c7844406$exports, "__esModule", {
    value: true
});
var $1dbd22c9c7844406$var$ClearOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M899.1 869.6l-53-305.6H864c14.4 0 26-11.6 26-26V346c0-14.4-11.6-26-26-26H618V138c0-14.4-11.6-26-26-26H432c-14.4 0-26 11.6-26 26v182H160c-14.4 0-26 11.6-26 26v192c0 14.4 11.6 26 26 26h17.9l-53 305.6a25.95 25.95 0 0025.6 30.4h723c1.5 0 3-.1 4.4-.4a25.88 25.88 0 0021.2-30zM204 390h272V182h72v208h272v104H204V390zm468 440V674c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v156H416V674c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v156H202.8l45.1-260H776l45.1 260H672z"
                }
            }
        ]
    },
    "name": "clear",
    "theme": "outlined"
};
$1dbd22c9c7844406$exports.default = $1dbd22c9c7844406$var$ClearOutlined;



function $9f593298a7a1453a$var$_extends() {
    $9f593298a7a1453a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9f593298a7a1453a$var$_extends.apply(this, arguments);
}
const $9f593298a7a1453a$var$ClearOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $9f593298a7a1453a$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1dbd22c9c7844406$exports)))
    }));
/**![clear](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg5OS4xIDg2OS42bC01My0zMDUuNkg4NjRjMTQuNCAwIDI2LTExLjYgMjYtMjZWMzQ2YzAtMTQuNC0xMS42LTI2LTI2LTI2SDYxOFYxMzhjMC0xNC40LTExLjYtMjYtMjYtMjZINDMyYy0xNC40IDAtMjYgMTEuNi0yNiAyNnYxODJIMTYwYy0xNC40IDAtMjYgMTEuNi0yNiAyNnYxOTJjMCAxNC40IDExLjYgMjYgMjYgMjZoMTcuOWwtNTMgMzA1LjZhMjUuOTUgMjUuOTUgMCAwMDI1LjYgMzAuNGg3MjNjMS41IDAgMy0uMSA0LjQtLjRhMjUuODggMjUuODggMCAwMDIxLjItMzB6TTIwNCAzOTBoMjcyVjE4Mmg3MnYyMDhoMjcydjEwNEgyMDRWMzkwem00NjggNDQwVjY3NGMwLTQuNC0zLjYtOC04LThoLTQ4Yy00LjQgMC04IDMuNi04IDh2MTU2SDQxNlY2NzRjMC00LjQtMy42LTgtOC04aC00OGMtNC40IDAtOCAzLjYtOCA4djE1NkgyMDIuOGw0NS4xLTI2MEg3NzZsNDUuMSAyNjBINjcyeiIgLz48L3N2Zz4=) */ const $9f593298a7a1453a$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($9f593298a7a1453a$var$ClearOutlined);
var $9f593298a7a1453a$export$2e2bcd8739ae039 = $9f593298a7a1453a$var$RefIcon;


/**
 * Based on ReactArt.js
 * Copyright (c) 2017-present Lavrenov Anton.
 * All rights reserved.
 *
 * MIT
 */ const $bd77714a0ea3dd4d$var$PI_OVER_180 = Math.PI / 180;
function $bd77714a0ea3dd4d$var$detectBrowser() {
    return typeof window !== "undefined" && (({}).toString.call(window) === "[object Window]" || ({}).toString.call(window) === "[object global]");
}
const $bd77714a0ea3dd4d$export$442f1a04865e4790 = typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof WorkerGlobalScope !== "undefined" ? self : {};
const $bd77714a0ea3dd4d$export$b9f99057a3c7692 = {
    _global: $bd77714a0ea3dd4d$export$442f1a04865e4790,
    version: "10.3.0",
    isBrowser: $bd77714a0ea3dd4d$var$detectBrowser(),
    isUnminified: /param/.test((function(param) {}).toString()),
    dblClickWindow: 400,
    getAngle (angle) {
        return $bd77714a0ea3dd4d$export$b9f99057a3c7692.angleDeg ? angle * $bd77714a0ea3dd4d$var$PI_OVER_180 : angle;
    },
    enableTrace: false,
    pointerEventsEnabled: true,
    autoDrawEnabled: true,
    hitOnDragEnabled: false,
    capturePointerEventsEnabled: false,
    _mouseListenClick: false,
    _touchListenClick: false,
    _pointerListenClick: false,
    _mouseInDblClickWindow: false,
    _touchInDblClickWindow: false,
    _pointerInDblClickWindow: false,
    _mouseDblClickPointerId: null,
    _touchDblClickPointerId: null,
    _pointerDblClickPointerId: null,
    _renderBackend: "web",
    legacyTextRendering: false,
    pixelRatio: typeof window !== "undefined" && window.devicePixelRatio || 1,
    dragDistance: 3,
    angleDeg: true,
    showWarnings: true,
    dragButtons: [
        0,
        1
    ],
    isDragging () {
        return $bd77714a0ea3dd4d$export$b9f99057a3c7692["DD"].isDragging;
    },
    isTransforming () {
        var _a, _b;
        return (_b = (_a = $bd77714a0ea3dd4d$export$b9f99057a3c7692["Transformer"]) === null || _a === void 0 ? void 0 : _a.isTransforming()) !== null && _b !== void 0 ? _b : false;
    },
    isDragReady () {
        return !!$bd77714a0ea3dd4d$export$b9f99057a3c7692["DD"].node;
    },
    releaseCanvasOnDestroy: true,
    document: $bd77714a0ea3dd4d$export$442f1a04865e4790.document,
    _injectGlobal (Konva) {
        if (typeof $bd77714a0ea3dd4d$export$442f1a04865e4790.Konva !== "undefined") console.error("Several Konva instances detected. It is not recommended to use multiple Konva instances in the same environment.");
        $bd77714a0ea3dd4d$export$442f1a04865e4790.Konva = Konva;
    }
};
const $bd77714a0ea3dd4d$export$f7a70d87a5e829eb = (NodeClass)=>{
    $bd77714a0ea3dd4d$export$b9f99057a3c7692[NodeClass.prototype.getClassName()] = NodeClass;
};
$bd77714a0ea3dd4d$export$b9f99057a3c7692._injectGlobal($bd77714a0ea3dd4d$export$b9f99057a3c7692);



const $a838f7f004abc0fb$var$NODE_ERROR = `Konva.js unsupported environment.

Looks like you are trying to use Konva.js in Node.js environment. because "document" object is undefined.

To use Konva.js in Node.js environment, you need to use the "canvas-backend" or "skia-backend" module.

bash: npm install canvas
js: import "konva/canvas-backend";

or

bash: npm install skia-canvas
js: import "konva/skia-backend";
`;
const $a838f7f004abc0fb$var$ensureBrowser = ()=>{
    if (typeof document === "undefined") throw new Error($a838f7f004abc0fb$var$NODE_ERROR);
};
class $a838f7f004abc0fb$export$563a914cafbdc389 {
    constructor(m = [
        1,
        0,
        0,
        1,
        0,
        0
    ]){
        this.dirty = false;
        this.m = m && m.slice() || [
            1,
            0,
            0,
            1,
            0,
            0
        ];
    }
    reset() {
        this.m[0] = 1;
        this.m[1] = 0;
        this.m[2] = 0;
        this.m[3] = 1;
        this.m[4] = 0;
        this.m[5] = 0;
    }
    copy() {
        return new $a838f7f004abc0fb$export$563a914cafbdc389(this.m);
    }
    copyInto(tr) {
        tr.m[0] = this.m[0];
        tr.m[1] = this.m[1];
        tr.m[2] = this.m[2];
        tr.m[3] = this.m[3];
        tr.m[4] = this.m[4];
        tr.m[5] = this.m[5];
    }
    point(point) {
        const m = this.m;
        return {
            x: m[0] * point.x + m[2] * point.y + m[4],
            y: m[1] * point.x + m[3] * point.y + m[5]
        };
    }
    translate(x, y) {
        this.m[4] += this.m[0] * x + this.m[2] * y;
        this.m[5] += this.m[1] * x + this.m[3] * y;
        return this;
    }
    scale(sx, sy) {
        this.m[0] *= sx;
        this.m[1] *= sx;
        this.m[2] *= sy;
        this.m[3] *= sy;
        return this;
    }
    rotate(rad) {
        const c = Math.cos(rad);
        const s = Math.sin(rad);
        const m11 = this.m[0] * c + this.m[2] * s;
        const m12 = this.m[1] * c + this.m[3] * s;
        const m21 = this.m[0] * -s + this.m[2] * c;
        const m22 = this.m[1] * -s + this.m[3] * c;
        this.m[0] = m11;
        this.m[1] = m12;
        this.m[2] = m21;
        this.m[3] = m22;
        return this;
    }
    getTranslation() {
        return {
            x: this.m[4],
            y: this.m[5]
        };
    }
    skew(sx, sy) {
        const m11 = this.m[0] + this.m[2] * sy;
        const m12 = this.m[1] + this.m[3] * sy;
        const m21 = this.m[2] + this.m[0] * sx;
        const m22 = this.m[3] + this.m[1] * sx;
        this.m[0] = m11;
        this.m[1] = m12;
        this.m[2] = m21;
        this.m[3] = m22;
        return this;
    }
    multiply(matrix) {
        const m11 = this.m[0] * matrix.m[0] + this.m[2] * matrix.m[1];
        const m12 = this.m[1] * matrix.m[0] + this.m[3] * matrix.m[1];
        const m21 = this.m[0] * matrix.m[2] + this.m[2] * matrix.m[3];
        const m22 = this.m[1] * matrix.m[2] + this.m[3] * matrix.m[3];
        const dx = this.m[0] * matrix.m[4] + this.m[2] * matrix.m[5] + this.m[4];
        const dy = this.m[1] * matrix.m[4] + this.m[3] * matrix.m[5] + this.m[5];
        this.m[0] = m11;
        this.m[1] = m12;
        this.m[2] = m21;
        this.m[3] = m22;
        this.m[4] = dx;
        this.m[5] = dy;
        return this;
    }
    invert() {
        const d = 1 / (this.m[0] * this.m[3] - this.m[1] * this.m[2]);
        const m0 = this.m[3] * d;
        const m1 = -this.m[1] * d;
        const m2 = -this.m[2] * d;
        const m3 = this.m[0] * d;
        const m4 = d * (this.m[2] * this.m[5] - this.m[3] * this.m[4]);
        const m5 = d * (this.m[1] * this.m[4] - this.m[0] * this.m[5]);
        this.m[0] = m0;
        this.m[1] = m1;
        this.m[2] = m2;
        this.m[3] = m3;
        this.m[4] = m4;
        this.m[5] = m5;
        return this;
    }
    getMatrix() {
        return this.m;
    }
    decompose() {
        const a = this.m[0];
        const b = this.m[1];
        const c = this.m[2];
        const d = this.m[3];
        const e = this.m[4];
        const f = this.m[5];
        const delta = a * d - b * c;
        const result = {
            x: e,
            y: f,
            rotation: 0,
            scaleX: 0,
            scaleY: 0,
            skewX: 0,
            skewY: 0
        };
        if (a != 0 || b != 0) {
            const r = Math.sqrt(a * a + b * b);
            result.rotation = b > 0 ? Math.acos(a / r) : -Math.acos(a / r);
            result.scaleX = r;
            result.scaleY = delta / r;
            result.skewX = (a * c + b * d) / delta;
            result.skewY = 0;
        } else if (c != 0 || d != 0) {
            const s = Math.sqrt(c * c + d * d);
            result.rotation = Math.PI / 2 - (d > 0 ? Math.acos(-c / s) : -Math.acos(c / s));
            result.scaleX = delta / s;
            result.scaleY = s;
            result.skewX = 0;
            result.skewY = (a * c + b * d) / delta;
        }
        result.rotation = $a838f7f004abc0fb$export$f8f26dd395d7e1bd._getRotation(result.rotation);
        return result;
    }
}
const $a838f7f004abc0fb$var$OBJECT_ARRAY = "[object Array]", $a838f7f004abc0fb$var$OBJECT_NUMBER = "[object Number]", $a838f7f004abc0fb$var$OBJECT_STRING = "[object String]", $a838f7f004abc0fb$var$OBJECT_BOOLEAN = "[object Boolean]", $a838f7f004abc0fb$var$PI_OVER_DEG180 = Math.PI / 180, $a838f7f004abc0fb$var$DEG180_OVER_PI = 180 / Math.PI, $a838f7f004abc0fb$var$HASH = "#", $a838f7f004abc0fb$var$EMPTY_STRING = "", $a838f7f004abc0fb$var$ZERO = "0", $a838f7f004abc0fb$var$KONVA_WARNING = "Konva warning: ", $a838f7f004abc0fb$var$KONVA_ERROR = "Konva error: ", $a838f7f004abc0fb$var$RGB_PAREN = "rgb(", $a838f7f004abc0fb$var$COLORS = {
    aliceblue: [
        240,
        248,
        255
    ],
    antiquewhite: [
        250,
        235,
        215
    ],
    aqua: [
        0,
        255,
        255
    ],
    aquamarine: [
        127,
        255,
        212
    ],
    azure: [
        240,
        255,
        255
    ],
    beige: [
        245,
        245,
        220
    ],
    bisque: [
        255,
        228,
        196
    ],
    black: [
        0,
        0,
        0
    ],
    blanchedalmond: [
        255,
        235,
        205
    ],
    blue: [
        0,
        0,
        255
    ],
    blueviolet: [
        138,
        43,
        226
    ],
    brown: [
        165,
        42,
        42
    ],
    burlywood: [
        222,
        184,
        135
    ],
    cadetblue: [
        95,
        158,
        160
    ],
    chartreuse: [
        127,
        255,
        0
    ],
    chocolate: [
        210,
        105,
        30
    ],
    coral: [
        255,
        127,
        80
    ],
    cornflowerblue: [
        100,
        149,
        237
    ],
    cornsilk: [
        255,
        248,
        220
    ],
    crimson: [
        220,
        20,
        60
    ],
    cyan: [
        0,
        255,
        255
    ],
    darkblue: [
        0,
        0,
        139
    ],
    darkcyan: [
        0,
        139,
        139
    ],
    darkgoldenrod: [
        184,
        132,
        11
    ],
    darkgray: [
        169,
        169,
        169
    ],
    darkgreen: [
        0,
        100,
        0
    ],
    darkgrey: [
        169,
        169,
        169
    ],
    darkkhaki: [
        189,
        183,
        107
    ],
    darkmagenta: [
        139,
        0,
        139
    ],
    darkolivegreen: [
        85,
        107,
        47
    ],
    darkorange: [
        255,
        140,
        0
    ],
    darkorchid: [
        153,
        50,
        204
    ],
    darkred: [
        139,
        0,
        0
    ],
    darksalmon: [
        233,
        150,
        122
    ],
    darkseagreen: [
        143,
        188,
        143
    ],
    darkslateblue: [
        72,
        61,
        139
    ],
    darkslategray: [
        47,
        79,
        79
    ],
    darkslategrey: [
        47,
        79,
        79
    ],
    darkturquoise: [
        0,
        206,
        209
    ],
    darkviolet: [
        148,
        0,
        211
    ],
    deeppink: [
        255,
        20,
        147
    ],
    deepskyblue: [
        0,
        191,
        255
    ],
    dimgray: [
        105,
        105,
        105
    ],
    dimgrey: [
        105,
        105,
        105
    ],
    dodgerblue: [
        30,
        144,
        255
    ],
    firebrick: [
        178,
        34,
        34
    ],
    floralwhite: [
        255,
        255,
        240
    ],
    forestgreen: [
        34,
        139,
        34
    ],
    fuchsia: [
        255,
        0,
        255
    ],
    gainsboro: [
        220,
        220,
        220
    ],
    ghostwhite: [
        248,
        248,
        255
    ],
    gold: [
        255,
        215,
        0
    ],
    goldenrod: [
        218,
        165,
        32
    ],
    gray: [
        128,
        128,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    greenyellow: [
        173,
        255,
        47
    ],
    grey: [
        128,
        128,
        128
    ],
    honeydew: [
        240,
        255,
        240
    ],
    hotpink: [
        255,
        105,
        180
    ],
    indianred: [
        205,
        92,
        92
    ],
    indigo: [
        75,
        0,
        130
    ],
    ivory: [
        255,
        255,
        240
    ],
    khaki: [
        240,
        230,
        140
    ],
    lavender: [
        230,
        230,
        250
    ],
    lavenderblush: [
        255,
        240,
        245
    ],
    lawngreen: [
        124,
        252,
        0
    ],
    lemonchiffon: [
        255,
        250,
        205
    ],
    lightblue: [
        173,
        216,
        230
    ],
    lightcoral: [
        240,
        128,
        128
    ],
    lightcyan: [
        224,
        255,
        255
    ],
    lightgoldenrodyellow: [
        250,
        250,
        210
    ],
    lightgray: [
        211,
        211,
        211
    ],
    lightgreen: [
        144,
        238,
        144
    ],
    lightgrey: [
        211,
        211,
        211
    ],
    lightpink: [
        255,
        182,
        193
    ],
    lightsalmon: [
        255,
        160,
        122
    ],
    lightseagreen: [
        32,
        178,
        170
    ],
    lightskyblue: [
        135,
        206,
        250
    ],
    lightslategray: [
        119,
        136,
        153
    ],
    lightslategrey: [
        119,
        136,
        153
    ],
    lightsteelblue: [
        176,
        196,
        222
    ],
    lightyellow: [
        255,
        255,
        224
    ],
    lime: [
        0,
        255,
        0
    ],
    limegreen: [
        50,
        205,
        50
    ],
    linen: [
        250,
        240,
        230
    ],
    magenta: [
        255,
        0,
        255
    ],
    maroon: [
        128,
        0,
        0
    ],
    mediumaquamarine: [
        102,
        205,
        170
    ],
    mediumblue: [
        0,
        0,
        205
    ],
    mediumorchid: [
        186,
        85,
        211
    ],
    mediumpurple: [
        147,
        112,
        219
    ],
    mediumseagreen: [
        60,
        179,
        113
    ],
    mediumslateblue: [
        123,
        104,
        238
    ],
    mediumspringgreen: [
        0,
        250,
        154
    ],
    mediumturquoise: [
        72,
        209,
        204
    ],
    mediumvioletred: [
        199,
        21,
        133
    ],
    midnightblue: [
        25,
        25,
        112
    ],
    mintcream: [
        245,
        255,
        250
    ],
    mistyrose: [
        255,
        228,
        225
    ],
    moccasin: [
        255,
        228,
        181
    ],
    navajowhite: [
        255,
        222,
        173
    ],
    navy: [
        0,
        0,
        128
    ],
    oldlace: [
        253,
        245,
        230
    ],
    olive: [
        128,
        128,
        0
    ],
    olivedrab: [
        107,
        142,
        35
    ],
    orange: [
        255,
        165,
        0
    ],
    orangered: [
        255,
        69,
        0
    ],
    orchid: [
        218,
        112,
        214
    ],
    palegoldenrod: [
        238,
        232,
        170
    ],
    palegreen: [
        152,
        251,
        152
    ],
    paleturquoise: [
        175,
        238,
        238
    ],
    palevioletred: [
        219,
        112,
        147
    ],
    papayawhip: [
        255,
        239,
        213
    ],
    peachpuff: [
        255,
        218,
        185
    ],
    peru: [
        205,
        133,
        63
    ],
    pink: [
        255,
        192,
        203
    ],
    plum: [
        221,
        160,
        203
    ],
    powderblue: [
        176,
        224,
        230
    ],
    purple: [
        128,
        0,
        128
    ],
    rebeccapurple: [
        102,
        51,
        153
    ],
    red: [
        255,
        0,
        0
    ],
    rosybrown: [
        188,
        143,
        143
    ],
    royalblue: [
        65,
        105,
        225
    ],
    saddlebrown: [
        139,
        69,
        19
    ],
    salmon: [
        250,
        128,
        114
    ],
    sandybrown: [
        244,
        164,
        96
    ],
    seagreen: [
        46,
        139,
        87
    ],
    seashell: [
        255,
        245,
        238
    ],
    sienna: [
        160,
        82,
        45
    ],
    silver: [
        192,
        192,
        192
    ],
    skyblue: [
        135,
        206,
        235
    ],
    slateblue: [
        106,
        90,
        205
    ],
    slategray: [
        119,
        128,
        144
    ],
    slategrey: [
        119,
        128,
        144
    ],
    snow: [
        255,
        255,
        250
    ],
    springgreen: [
        0,
        255,
        127
    ],
    steelblue: [
        70,
        130,
        180
    ],
    tan: [
        210,
        180,
        140
    ],
    teal: [
        0,
        128,
        128
    ],
    thistle: [
        216,
        191,
        216
    ],
    transparent: [
        255,
        255,
        255,
        0
    ],
    tomato: [
        255,
        99,
        71
    ],
    turquoise: [
        64,
        224,
        208
    ],
    violet: [
        238,
        130,
        238
    ],
    wheat: [
        245,
        222,
        179
    ],
    white: [
        255,
        255,
        255
    ],
    whitesmoke: [
        245,
        245,
        245
    ],
    yellow: [
        255,
        255,
        0
    ],
    yellowgreen: [
        154,
        205,
        5
    ]
}, $a838f7f004abc0fb$var$RGB_REGEX = /rgb\((\d{1,3}),(\d{1,3}),(\d{1,3})\)/;
let $a838f7f004abc0fb$var$animQueue = [];
let $a838f7f004abc0fb$var$_isCanvasFarblingActive = null;
const $a838f7f004abc0fb$var$req = typeof requestAnimationFrame !== "undefined" && requestAnimationFrame || function(f) {
    setTimeout(f, 16);
};
const $a838f7f004abc0fb$export$f8f26dd395d7e1bd = {
    _isElement (obj) {
        return !!(obj && obj.nodeType == 1);
    },
    _isFunction (obj) {
        return !!(obj && obj.constructor && obj.call && obj.apply);
    },
    _isPlainObject (obj) {
        return !!obj && obj.constructor === Object;
    },
    _isArray (obj) {
        return Object.prototype.toString.call(obj) === $a838f7f004abc0fb$var$OBJECT_ARRAY;
    },
    _isNumber (obj) {
        return Object.prototype.toString.call(obj) === $a838f7f004abc0fb$var$OBJECT_NUMBER && !isNaN(obj) && isFinite(obj);
    },
    _isString (obj) {
        return Object.prototype.toString.call(obj) === $a838f7f004abc0fb$var$OBJECT_STRING;
    },
    _isBoolean (obj) {
        return Object.prototype.toString.call(obj) === $a838f7f004abc0fb$var$OBJECT_BOOLEAN;
    },
    isObject (val) {
        return val instanceof Object;
    },
    isValidSelector (selector) {
        if (typeof selector !== "string") return false;
        const firstChar = selector[0];
        return firstChar === "#" || firstChar === "." || firstChar === firstChar.toUpperCase();
    },
    _sign (number) {
        if (number === 0) return 1;
        if (number > 0) return 1;
        else return -1;
    },
    requestAnimFrame (callback) {
        $a838f7f004abc0fb$var$animQueue.push(callback);
        if ($a838f7f004abc0fb$var$animQueue.length === 1) $a838f7f004abc0fb$var$req(function() {
            const queue = $a838f7f004abc0fb$var$animQueue;
            $a838f7f004abc0fb$var$animQueue = [];
            queue.forEach(function(cb) {
                cb();
            });
        });
    },
    createCanvasElement () {
        $a838f7f004abc0fb$var$ensureBrowser();
        const canvas = document.createElement("canvas");
        try {
            canvas.style = canvas.style || {};
        } catch (e) {}
        return canvas;
    },
    createImageElement () {
        $a838f7f004abc0fb$var$ensureBrowser();
        return document.createElement("img");
    },
    _isInDocument (el) {
        while(el = el.parentNode){
            if (el == document) return true;
        }
        return false;
    },
    _urlToImage (url, callback) {
        const imageObj = $a838f7f004abc0fb$export$f8f26dd395d7e1bd.createImageElement();
        imageObj.onload = function() {
            callback(imageObj);
        };
        imageObj.src = url;
    },
    _rgbToHex (r, g, b) {
        return (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
    },
    _hexToRgb (hex) {
        hex = hex.replace($a838f7f004abc0fb$var$HASH, $a838f7f004abc0fb$var$EMPTY_STRING);
        const bigint = parseInt(hex, 16);
        return {
            r: bigint >> 16 & 255,
            g: bigint >> 8 & 255,
            b: bigint & 255
        };
    },
    getRandomColor () {
        let randColor = (Math.random() * 0xffffff << 0).toString(16);
        while(randColor.length < 6)randColor = $a838f7f004abc0fb$var$ZERO + randColor;
        return $a838f7f004abc0fb$var$HASH + randColor;
    },
    isCanvasFarblingActive () {
        if ($a838f7f004abc0fb$var$_isCanvasFarblingActive !== null) return $a838f7f004abc0fb$var$_isCanvasFarblingActive;
        if (typeof document === "undefined") {
            $a838f7f004abc0fb$var$_isCanvasFarblingActive = false;
            return false;
        }
        const c = this.createCanvasElement();
        c.width = 10;
        c.height = 10;
        const ctx = c.getContext("2d", {
            willReadFrequently: true
        });
        ctx.clearRect(0, 0, 10, 10);
        ctx.fillStyle = "#282828";
        ctx.fillRect(0, 0, 10, 10);
        const d = ctx.getImageData(0, 0, 10, 10).data;
        let isFarbling = false;
        for(let i = 0; i < 100; i++)if (d[i * 4] !== 40 || d[i * 4 + 1] !== 40 || d[i * 4 + 2] !== 40 || d[i * 4 + 3] !== 255) {
            isFarbling = true;
            break;
        }
        $a838f7f004abc0fb$var$_isCanvasFarblingActive = isFarbling;
        this.releaseCanvas(c);
        return $a838f7f004abc0fb$var$_isCanvasFarblingActive;
    },
    getHitColor () {
        const color = this.getRandomColor();
        return this.isCanvasFarblingActive() ? this.getSnappedHexColor(color) : color;
    },
    getHitColorKey (r, g, b) {
        if (this.isCanvasFarblingActive()) {
            r = Math.round(r / 5) * 5;
            g = Math.round(g / 5) * 5;
            b = Math.round(b / 5) * 5;
        }
        return $a838f7f004abc0fb$var$HASH + this._rgbToHex(r, g, b);
    },
    getSnappedHexColor (hex) {
        const rgb = this._hexToRgb(hex);
        return $a838f7f004abc0fb$var$HASH + this._rgbToHex(Math.round(rgb.r / 5) * 5, Math.round(rgb.g / 5) * 5, Math.round(rgb.b / 5) * 5);
    },
    getRGB (color) {
        let rgb;
        if (color in $a838f7f004abc0fb$var$COLORS) {
            rgb = $a838f7f004abc0fb$var$COLORS[color];
            return {
                r: rgb[0],
                g: rgb[1],
                b: rgb[2]
            };
        } else if (color[0] === $a838f7f004abc0fb$var$HASH) return this._hexToRgb(color.substring(1));
        else if (color.substr(0, 4) === $a838f7f004abc0fb$var$RGB_PAREN) {
            rgb = $a838f7f004abc0fb$var$RGB_REGEX.exec(color.replace(/ /g, ""));
            return {
                r: parseInt(rgb[1], 10),
                g: parseInt(rgb[2], 10),
                b: parseInt(rgb[3], 10)
            };
        } else return {
            r: 0,
            g: 0,
            b: 0
        };
    },
    colorToRGBA (str) {
        str = str || "black";
        return $a838f7f004abc0fb$export$f8f26dd395d7e1bd._namedColorToRBA(str) || $a838f7f004abc0fb$export$f8f26dd395d7e1bd._hex3ColorToRGBA(str) || $a838f7f004abc0fb$export$f8f26dd395d7e1bd._hex4ColorToRGBA(str) || $a838f7f004abc0fb$export$f8f26dd395d7e1bd._hex6ColorToRGBA(str) || $a838f7f004abc0fb$export$f8f26dd395d7e1bd._hex8ColorToRGBA(str) || $a838f7f004abc0fb$export$f8f26dd395d7e1bd._rgbColorToRGBA(str) || $a838f7f004abc0fb$export$f8f26dd395d7e1bd._rgbaColorToRGBA(str) || $a838f7f004abc0fb$export$f8f26dd395d7e1bd._hslColorToRGBA(str);
    },
    _namedColorToRBA (str) {
        const c = $a838f7f004abc0fb$var$COLORS[str.toLowerCase()];
        if (!c) return null;
        return {
            r: c[0],
            g: c[1],
            b: c[2],
            a: 1
        };
    },
    _rgbColorToRGBA (str) {
        if (str.indexOf("rgb(") === 0) {
            str = str.match(/rgb\(([^)]+)\)/)[1];
            const parts = str.split(/ *, */).map(Number);
            return {
                r: parts[0],
                g: parts[1],
                b: parts[2],
                a: 1
            };
        }
    },
    _rgbaColorToRGBA (str) {
        if (str.indexOf("rgba(") === 0) {
            str = str.match(/rgba\(([^)]+)\)/)[1];
            const parts = str.split(/ *, */).map((n, index)=>{
                if (n.slice(-1) === "%") return index === 3 ? parseInt(n) / 100 : parseInt(n) / 100 * 255;
                return Number(n);
            });
            return {
                r: parts[0],
                g: parts[1],
                b: parts[2],
                a: parts[3]
            };
        }
    },
    _hex8ColorToRGBA (str) {
        if (str[0] === "#" && str.length === 9) return {
            r: parseInt(str.slice(1, 3), 16),
            g: parseInt(str.slice(3, 5), 16),
            b: parseInt(str.slice(5, 7), 16),
            a: parseInt(str.slice(7, 9), 16) / 0xff
        };
    },
    _hex6ColorToRGBA (str) {
        if (str[0] === "#" && str.length === 7) return {
            r: parseInt(str.slice(1, 3), 16),
            g: parseInt(str.slice(3, 5), 16),
            b: parseInt(str.slice(5, 7), 16),
            a: 1
        };
    },
    _hex4ColorToRGBA (str) {
        if (str[0] === "#" && str.length === 5) return {
            r: parseInt(str[1] + str[1], 16),
            g: parseInt(str[2] + str[2], 16),
            b: parseInt(str[3] + str[3], 16),
            a: parseInt(str[4] + str[4], 16) / 0xff
        };
    },
    _hex3ColorToRGBA (str) {
        if (str[0] === "#" && str.length === 4) return {
            r: parseInt(str[1] + str[1], 16),
            g: parseInt(str[2] + str[2], 16),
            b: parseInt(str[3] + str[3], 16),
            a: 1
        };
    },
    _hslColorToRGBA (str) {
        if (/hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.test(str)) {
            const [_, ...hsl] = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(str);
            const h = Number(hsl[0]) / 360;
            const s = Number(hsl[1]) / 100;
            const l = Number(hsl[2]) / 100;
            let t2;
            let t3;
            let val;
            if (s === 0) {
                val = l * 255;
                return {
                    r: Math.round(val),
                    g: Math.round(val),
                    b: Math.round(val),
                    a: 1
                };
            }
            if (l < 0.5) t2 = l * (1 + s);
            else t2 = l + s - l * s;
            const t1 = 2 * l - t2;
            const rgb = [
                0,
                0,
                0
            ];
            for(let i = 0; i < 3; i++){
                t3 = h + 1 / 3 * -(i - 1);
                if (t3 < 0) t3++;
                if (t3 > 1) t3--;
                if (6 * t3 < 1) val = t1 + (t2 - t1) * 6 * t3;
                else if (2 * t3 < 1) val = t2;
                else if (3 * t3 < 2) val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
                else val = t1;
                rgb[i] = val * 255;
            }
            return {
                r: Math.round(rgb[0]),
                g: Math.round(rgb[1]),
                b: Math.round(rgb[2]),
                a: 1
            };
        }
    },
    haveIntersection (r1, r2) {
        return !(r2.x > r1.x + r1.width || r2.x + r2.width < r1.x || r2.y > r1.y + r1.height || r2.y + r2.height < r1.y);
    },
    cloneObject (obj) {
        const retObj = {};
        for(const key in obj){
            if (this._isPlainObject(obj[key])) retObj[key] = this.cloneObject(obj[key]);
            else if (this._isArray(obj[key])) retObj[key] = this.cloneArray(obj[key]);
            else retObj[key] = obj[key];
        }
        return retObj;
    },
    cloneArray (arr) {
        return arr.slice(0);
    },
    degToRad (deg) {
        return deg * $a838f7f004abc0fb$var$PI_OVER_DEG180;
    },
    radToDeg (rad) {
        return rad * $a838f7f004abc0fb$var$DEG180_OVER_PI;
    },
    _degToRad (deg) {
        $a838f7f004abc0fb$export$f8f26dd395d7e1bd.warn("Util._degToRad is removed. Please use public Util.degToRad instead.");
        return $a838f7f004abc0fb$export$f8f26dd395d7e1bd.degToRad(deg);
    },
    _radToDeg (rad) {
        $a838f7f004abc0fb$export$f8f26dd395d7e1bd.warn("Util._radToDeg is removed. Please use public Util.radToDeg instead.");
        return $a838f7f004abc0fb$export$f8f26dd395d7e1bd.radToDeg(rad);
    },
    _getRotation (radians) {
        return (0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).angleDeg ? $a838f7f004abc0fb$export$f8f26dd395d7e1bd.radToDeg(radians) : radians;
    },
    _capitalize (str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    },
    throw (str) {
        throw new Error($a838f7f004abc0fb$var$KONVA_ERROR + str);
    },
    error (str) {
        console.error($a838f7f004abc0fb$var$KONVA_ERROR + str);
    },
    warn (str) {
        if (!(0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).showWarnings) return;
        console.warn($a838f7f004abc0fb$var$KONVA_WARNING + str);
    },
    each (obj, func) {
        for(const key in obj)func(key, obj[key]);
    },
    _inRange (val, left, right) {
        return left <= val && val < right;
    },
    _getProjectionToSegment (x1, y1, x2, y2, x3, y3) {
        let x, y, dist;
        const pd2 = (x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2);
        if (pd2 == 0) {
            x = x1;
            y = y1;
            dist = (x3 - x2) * (x3 - x2) + (y3 - y2) * (y3 - y2);
        } else {
            const u = ((x3 - x1) * (x2 - x1) + (y3 - y1) * (y2 - y1)) / pd2;
            if (u < 0) {
                x = x1;
                y = y1;
                dist = (x1 - x3) * (x1 - x3) + (y1 - y3) * (y1 - y3);
            } else if (u > 1.0) {
                x = x2;
                y = y2;
                dist = (x2 - x3) * (x2 - x3) + (y2 - y3) * (y2 - y3);
            } else {
                x = x1 + u * (x2 - x1);
                y = y1 + u * (y2 - y1);
                dist = (x - x3) * (x - x3) + (y - y3) * (y - y3);
            }
        }
        return [
            x,
            y,
            dist
        ];
    },
    _getProjectionToLine (pt, line, isClosed) {
        const pc = $a838f7f004abc0fb$export$f8f26dd395d7e1bd.cloneObject(pt);
        let dist = Number.MAX_VALUE;
        line.forEach(function(p1, i) {
            if (!isClosed && i === line.length - 1) return;
            const p2 = line[(i + 1) % line.length];
            const proj = $a838f7f004abc0fb$export$f8f26dd395d7e1bd._getProjectionToSegment(p1.x, p1.y, p2.x, p2.y, pt.x, pt.y);
            const px = proj[0], py = proj[1], pdist = proj[2];
            if (pdist < dist) {
                pc.x = px;
                pc.y = py;
                dist = pdist;
            }
        });
        return pc;
    },
    _prepareArrayForTween (startArray, endArray, isClosed) {
        const start = [], end = [];
        if (startArray.length > endArray.length) {
            const temp = endArray;
            endArray = startArray;
            startArray = temp;
        }
        for(let n = 0; n < startArray.length; n += 2)start.push({
            x: startArray[n],
            y: startArray[n + 1]
        });
        for(let n = 0; n < endArray.length; n += 2)end.push({
            x: endArray[n],
            y: endArray[n + 1]
        });
        const newStart = [];
        end.forEach(function(point) {
            const pr = $a838f7f004abc0fb$export$f8f26dd395d7e1bd._getProjectionToLine(point, start, isClosed);
            newStart.push(pr.x);
            newStart.push(pr.y);
        });
        return newStart;
    },
    _prepareToStringify (obj) {
        let desc;
        obj.visitedByCircularReferenceRemoval = true;
        for(const key in obj){
            if (!(obj.hasOwnProperty(key) && obj[key] && typeof obj[key] == "object")) continue;
            desc = Object.getOwnPropertyDescriptor(obj, key);
            if (obj[key].visitedByCircularReferenceRemoval || $a838f7f004abc0fb$export$f8f26dd395d7e1bd._isElement(obj[key])) {
                if (desc.configurable) delete obj[key];
                else return null;
            } else if ($a838f7f004abc0fb$export$f8f26dd395d7e1bd._prepareToStringify(obj[key]) === null) {
                if (desc.configurable) delete obj[key];
                else return null;
            }
        }
        delete obj.visitedByCircularReferenceRemoval;
        return obj;
    },
    _assign (target, source) {
        for(const key in source)target[key] = source[key];
        return target;
    },
    _getFirstPointerId (evt) {
        if (!evt.touches) return evt.pointerId || 999;
        else return evt.changedTouches[0].identifier;
    },
    releaseCanvas (...canvases) {
        if (!(0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).releaseCanvasOnDestroy) return;
        canvases.forEach((c)=>{
            c.width = 0;
            c.height = 0;
        });
    },
    drawRoundedRectPath (context, width, height, cornerRadius) {
        let xOrigin = width < 0 ? width : 0;
        let yOrigin = height < 0 ? height : 0;
        width = Math.abs(width);
        height = Math.abs(height);
        let topLeft = 0;
        let topRight = 0;
        let bottomLeft = 0;
        let bottomRight = 0;
        if (typeof cornerRadius === "number") topLeft = topRight = bottomLeft = bottomRight = Math.min(cornerRadius, width / 2, height / 2);
        else {
            topLeft = Math.min(cornerRadius[0] || 0, width / 2, height / 2);
            topRight = Math.min(cornerRadius[1] || 0, width / 2, height / 2);
            bottomRight = Math.min(cornerRadius[2] || 0, width / 2, height / 2);
            bottomLeft = Math.min(cornerRadius[3] || 0, width / 2, height / 2);
        }
        context.moveTo(xOrigin + topLeft, yOrigin);
        context.lineTo(xOrigin + width - topRight, yOrigin);
        context.arc(xOrigin + width - topRight, yOrigin + topRight, topRight, Math.PI * 3 / 2, 0, false);
        context.lineTo(xOrigin + width, yOrigin + height - bottomRight);
        context.arc(xOrigin + width - bottomRight, yOrigin + height - bottomRight, bottomRight, 0, Math.PI / 2, false);
        context.lineTo(xOrigin + bottomLeft, yOrigin + height);
        context.arc(xOrigin + bottomLeft, yOrigin + height - bottomLeft, bottomLeft, Math.PI / 2, Math.PI, false);
        context.lineTo(xOrigin, yOrigin + topLeft);
        context.arc(xOrigin + topLeft, yOrigin + topLeft, topLeft, Math.PI, Math.PI * 3 / 2, false);
    },
    drawRoundedPolygonPath (context, points, sides, radius, cornerRadius) {
        radius = Math.abs(radius);
        for(let i = 0; i < sides; i++){
            const prev = points[(i - 1 + sides) % sides];
            const curr = points[i];
            const next = points[(i + 1) % sides];
            const vec1 = {
                x: curr.x - prev.x,
                y: curr.y - prev.y
            };
            const vec2 = {
                x: next.x - curr.x,
                y: next.y - curr.y
            };
            const len1 = Math.hypot(vec1.x, vec1.y);
            const len2 = Math.hypot(vec2.x, vec2.y);
            let currCornerRadius;
            if (typeof cornerRadius === "number") currCornerRadius = cornerRadius;
            else currCornerRadius = i < cornerRadius.length ? cornerRadius[i] : 0;
            const maxCornerRadius = radius * Math.cos(Math.PI / sides);
            currCornerRadius = maxCornerRadius * Math.min(1, currCornerRadius / radius * 2);
            const normalVec1 = {
                x: vec1.x / len1,
                y: vec1.y / len1
            };
            const normalVec2 = {
                x: vec2.x / len2,
                y: vec2.y / len2
            };
            const p1 = {
                x: curr.x - normalVec1.x * currCornerRadius,
                y: curr.y - normalVec1.y * currCornerRadius
            };
            const p2 = {
                x: curr.x + normalVec2.x * currCornerRadius,
                y: curr.y + normalVec2.y * currCornerRadius
            };
            if (i === 0) context.moveTo(p1.x, p1.y);
            else context.lineTo(p1.x, p1.y);
            context.arcTo(curr.x, curr.y, p2.x, p2.y, currCornerRadius);
        }
    }
};





function $8efbfe36b14beb68$var$simplifyArray(arr) {
    const retArr = [], len = arr.length, util = (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd);
    for(let n = 0; n < len; n++){
        let val = arr[n];
        if (util._isNumber(val)) val = Math.round(val * 1000) / 1000;
        else if (!util._isString(val)) val = val + "";
        retArr.push(val);
    }
    return retArr;
}
const $8efbfe36b14beb68$var$COMMA = ",", $8efbfe36b14beb68$var$OPEN_PAREN = "(", $8efbfe36b14beb68$var$CLOSE_PAREN = ")", $8efbfe36b14beb68$var$OPEN_PAREN_BRACKET = "([", $8efbfe36b14beb68$var$CLOSE_BRACKET_PAREN = "])", $8efbfe36b14beb68$var$SEMICOLON = ";", $8efbfe36b14beb68$var$DOUBLE_PAREN = "()", $8efbfe36b14beb68$var$EQUALS = "=", $8efbfe36b14beb68$var$CONTEXT_METHODS = [
    "arc",
    "arcTo",
    "beginPath",
    "bezierCurveTo",
    "clearRect",
    "clip",
    "closePath",
    "createLinearGradient",
    "createPattern",
    "createRadialGradient",
    "drawImage",
    "ellipse",
    "fill",
    "fillText",
    "getImageData",
    "createImageData",
    "lineTo",
    "moveTo",
    "putImageData",
    "quadraticCurveTo",
    "rect",
    "roundRect",
    "restore",
    "rotate",
    "save",
    "scale",
    "setLineDash",
    "setTransform",
    "stroke",
    "strokeText",
    "transform",
    "translate"
];
const $8efbfe36b14beb68$var$CONTEXT_PROPERTIES = [
    "fillStyle",
    "strokeStyle",
    "shadowColor",
    "shadowBlur",
    "shadowOffsetX",
    "shadowOffsetY",
    "letterSpacing",
    "lineCap",
    "lineDashOffset",
    "lineJoin",
    "lineWidth",
    "miterLimit",
    "direction",
    "font",
    "textAlign",
    "textBaseline",
    "globalAlpha",
    "globalCompositeOperation",
    "imageSmoothingEnabled",
    "filter"
];
const $8efbfe36b14beb68$var$traceArrMax = 100;
let $8efbfe36b14beb68$var$_cssFiltersSupported = null;
function $8efbfe36b14beb68$export$887ce9926cc3f80f() {
    if ($8efbfe36b14beb68$var$_cssFiltersSupported !== null) return $8efbfe36b14beb68$var$_cssFiltersSupported;
    try {
        const canvas = (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).createCanvasElement();
        const ctx = canvas.getContext("2d");
        if (!ctx) {
            $8efbfe36b14beb68$var$_cssFiltersSupported = false;
            return false;
        }
        return !!ctx && "filter" in ctx;
    } catch (e) {
        $8efbfe36b14beb68$var$_cssFiltersSupported = false;
        return false;
    }
}
class $8efbfe36b14beb68$export$841858b892ce1f4c {
    constructor(canvas){
        this.canvas = canvas;
        if ((0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).enableTrace) {
            this.traceArr = [];
            this._enableTrace();
        }
    }
    fillShape(shape) {
        if (shape.fillEnabled()) this._fill(shape);
    }
    _fill(shape) {}
    strokeShape(shape) {
        if (shape.hasStroke()) this._stroke(shape);
    }
    _stroke(shape) {}
    fillStrokeShape(shape) {
        if (shape.attrs.fillAfterStrokeEnabled) {
            this.strokeShape(shape);
            this.fillShape(shape);
        } else {
            this.fillShape(shape);
            this.strokeShape(shape);
        }
    }
    getTrace(relaxed, rounded) {
        let traceArr = this.traceArr, len = traceArr.length, str = "", n, trace, method, args;
        for(n = 0; n < len; n++){
            trace = traceArr[n];
            method = trace.method;
            if (method) {
                args = trace.args;
                str += method;
                if (relaxed) str += $8efbfe36b14beb68$var$DOUBLE_PAREN;
                else if ((0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._isArray(args[0])) str += $8efbfe36b14beb68$var$OPEN_PAREN_BRACKET + args.join($8efbfe36b14beb68$var$COMMA) + $8efbfe36b14beb68$var$CLOSE_BRACKET_PAREN;
                else {
                    if (rounded) args = args.map((a)=>typeof a === "number" ? Math.floor(a) : a);
                    str += $8efbfe36b14beb68$var$OPEN_PAREN + args.join($8efbfe36b14beb68$var$COMMA) + $8efbfe36b14beb68$var$CLOSE_PAREN;
                }
            } else {
                str += trace.property;
                if (!relaxed) str += $8efbfe36b14beb68$var$EQUALS + trace.val;
            }
            str += $8efbfe36b14beb68$var$SEMICOLON;
        }
        return str;
    }
    clearTrace() {
        this.traceArr = [];
    }
    _trace(str) {
        let traceArr = this.traceArr, len;
        traceArr.push(str);
        len = traceArr.length;
        if (len >= $8efbfe36b14beb68$var$traceArrMax) traceArr.shift();
    }
    reset() {
        const pixelRatio = this.getCanvas().getPixelRatio();
        this.setTransform(1 * pixelRatio, 0, 0, 1 * pixelRatio, 0, 0);
    }
    getCanvas() {
        return this.canvas;
    }
    clear(bounds) {
        const canvas = this.getCanvas();
        if (bounds) this.clearRect(bounds.x || 0, bounds.y || 0, bounds.width || 0, bounds.height || 0);
        else this.clearRect(0, 0, canvas.getWidth() / canvas.pixelRatio, canvas.getHeight() / canvas.pixelRatio);
    }
    _applyLineCap(shape) {
        const lineCap = shape.attrs.lineCap;
        if (lineCap) this.setAttr("lineCap", lineCap);
    }
    _applyOpacity(shape) {
        const absOpacity = shape.getAbsoluteOpacity();
        if (absOpacity !== 1) this.setAttr("globalAlpha", absOpacity);
    }
    _applyLineJoin(shape) {
        const lineJoin = shape.attrs.lineJoin;
        if (lineJoin) this.setAttr("lineJoin", lineJoin);
    }
    _applyMiterLimit(shape) {
        const miterLimit = shape.attrs.miterLimit;
        if (miterLimit != null) this.setAttr("miterLimit", miterLimit);
    }
    setAttr(attr, val) {
        this._context[attr] = val;
    }
    arc(x, y, radius, startAngle, endAngle, counterClockwise) {
        this._context.arc(x, y, radius, startAngle, endAngle, counterClockwise);
    }
    arcTo(x1, y1, x2, y2, radius) {
        this._context.arcTo(x1, y1, x2, y2, radius);
    }
    beginPath() {
        this._context.beginPath();
    }
    bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y) {
        this._context.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y);
    }
    clearRect(x, y, width, height) {
        this._context.clearRect(x, y, width, height);
    }
    clip(...args) {
        this._context.clip.apply(this._context, args);
    }
    closePath() {
        this._context.closePath();
    }
    createImageData(width, height) {
        const a = arguments;
        if (a.length === 2) return this._context.createImageData(width, height);
        else if (a.length === 1) return this._context.createImageData(width);
    }
    createLinearGradient(x0, y0, x1, y1) {
        return this._context.createLinearGradient(x0, y0, x1, y1);
    }
    createPattern(image, repetition) {
        return this._context.createPattern(image, repetition);
    }
    createRadialGradient(x0, y0, r0, x1, y1, r1) {
        return this._context.createRadialGradient(x0, y0, r0, x1, y1, r1);
    }
    drawImage(image, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight) {
        const a = arguments, _context = this._context;
        if (a.length === 3) _context.drawImage(image, sx, sy);
        else if (a.length === 5) _context.drawImage(image, sx, sy, sWidth, sHeight);
        else if (a.length === 9) _context.drawImage(image, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight);
    }
    ellipse(x, y, radiusX, radiusY, rotation, startAngle, endAngle, counterclockwise) {
        this._context.ellipse(x, y, radiusX, radiusY, rotation, startAngle, endAngle, counterclockwise);
    }
    isPointInPath(x, y, path, fillRule) {
        if (path) return this._context.isPointInPath(path, x, y, fillRule);
        return this._context.isPointInPath(x, y, fillRule);
    }
    fill(...args) {
        this._context.fill.apply(this._context, args);
    }
    fillRect(x, y, width, height) {
        this._context.fillRect(x, y, width, height);
    }
    strokeRect(x, y, width, height) {
        this._context.strokeRect(x, y, width, height);
    }
    fillText(text, x, y, maxWidth) {
        if (maxWidth) this._context.fillText(text, x, y, maxWidth);
        else this._context.fillText(text, x, y);
    }
    measureText(text) {
        return this._context.measureText(text);
    }
    getImageData(sx, sy, sw, sh) {
        return this._context.getImageData(sx, sy, sw, sh);
    }
    lineTo(x, y) {
        this._context.lineTo(x, y);
    }
    moveTo(x, y) {
        this._context.moveTo(x, y);
    }
    rect(x, y, width, height) {
        this._context.rect(x, y, width, height);
    }
    roundRect(x, y, width, height, radii) {
        this._context.roundRect(x, y, width, height, radii);
    }
    putImageData(imageData, dx, dy) {
        this._context.putImageData(imageData, dx, dy);
    }
    quadraticCurveTo(cpx, cpy, x, y) {
        this._context.quadraticCurveTo(cpx, cpy, x, y);
    }
    restore() {
        this._context.restore();
    }
    rotate(angle) {
        this._context.rotate(angle);
    }
    save() {
        this._context.save();
    }
    scale(x, y) {
        this._context.scale(x, y);
    }
    setLineDash(segments) {
        if (this._context.setLineDash) this._context.setLineDash(segments);
        else if ("mozDash" in this._context) this._context["mozDash"] = segments;
        else if ("webkitLineDash" in this._context) this._context["webkitLineDash"] = segments;
    }
    getLineDash() {
        return this._context.getLineDash();
    }
    setTransform(a, b, c, d, e, f) {
        this._context.setTransform(a, b, c, d, e, f);
    }
    stroke(path2d) {
        if (path2d) this._context.stroke(path2d);
        else this._context.stroke();
    }
    strokeText(text, x, y, maxWidth) {
        this._context.strokeText(text, x, y, maxWidth);
    }
    transform(a, b, c, d, e, f) {
        this._context.transform(a, b, c, d, e, f);
    }
    translate(x, y) {
        this._context.translate(x, y);
    }
    _enableTrace() {
        let that = this, len = $8efbfe36b14beb68$var$CONTEXT_METHODS.length, origSetter = this.setAttr, n, args;
        const func = function(methodName) {
            let origMethod = that[methodName], ret;
            that[methodName] = function() {
                args = $8efbfe36b14beb68$var$simplifyArray(Array.prototype.slice.call(arguments, 0));
                ret = origMethod.apply(that, arguments);
                that._trace({
                    method: methodName,
                    args: args
                });
                return ret;
            };
        };
        for(n = 0; n < len; n++)func($8efbfe36b14beb68$var$CONTEXT_METHODS[n]);
        that.setAttr = function() {
            origSetter.apply(that, arguments);
            const prop = arguments[0];
            let val = arguments[1];
            if (prop === "shadowOffsetX" || prop === "shadowOffsetY" || prop === "shadowBlur") val = val / this.canvas.getPixelRatio();
            that._trace({
                property: prop,
                val: val
            });
        };
    }
    _applyGlobalCompositeOperation(node) {
        const op = node.attrs.globalCompositeOperation;
        const def = !op || op === "source-over";
        if (!def) this.setAttr("globalCompositeOperation", op);
    }
}
$8efbfe36b14beb68$var$CONTEXT_PROPERTIES.forEach(function(prop) {
    Object.defineProperty($8efbfe36b14beb68$export$841858b892ce1f4c.prototype, prop, {
        get () {
            return this._context[prop];
        },
        set (val) {
            this._context[prop] = val;
        }
    });
});
class $8efbfe36b14beb68$export$576380cfa99ddf20 extends $8efbfe36b14beb68$export$841858b892ce1f4c {
    constructor(canvas, { willReadFrequently: willReadFrequently = false } = {}){
        super(canvas);
        this._context = canvas._canvas.getContext("2d", {
            willReadFrequently: willReadFrequently
        });
    }
    _fillColor(shape) {
        const fill = shape.fill();
        this.setAttr("fillStyle", fill);
        shape._fillFunc(this);
    }
    _fillPattern(shape) {
        this.setAttr("fillStyle", shape._getFillPattern());
        shape._fillFunc(this);
    }
    _fillLinearGradient(shape) {
        const grd = shape._getLinearGradient();
        if (grd) {
            this.setAttr("fillStyle", grd);
            shape._fillFunc(this);
        }
    }
    _fillRadialGradient(shape) {
        const grd = shape._getRadialGradient();
        if (grd) {
            this.setAttr("fillStyle", grd);
            shape._fillFunc(this);
        }
    }
    _fill(shape) {
        const hasColor = shape.fill(), fillPriority = shape.getFillPriority();
        if (hasColor && fillPriority === "color") {
            this._fillColor(shape);
            return;
        }
        const hasPattern = shape.getFillPatternImage();
        if (hasPattern && fillPriority === "pattern") {
            this._fillPattern(shape);
            return;
        }
        const hasLinearGradient = shape.getFillLinearGradientColorStops();
        if (hasLinearGradient && fillPriority === "linear-gradient") {
            this._fillLinearGradient(shape);
            return;
        }
        const hasRadialGradient = shape.getFillRadialGradientColorStops();
        if (hasRadialGradient && fillPriority === "radial-gradient") {
            this._fillRadialGradient(shape);
            return;
        }
        if (hasColor) this._fillColor(shape);
        else if (hasPattern) this._fillPattern(shape);
        else if (hasLinearGradient) this._fillLinearGradient(shape);
        else if (hasRadialGradient) this._fillRadialGradient(shape);
    }
    _strokeLinearGradient(shape) {
        const start = shape.getStrokeLinearGradientStartPoint(), end = shape.getStrokeLinearGradientEndPoint(), colorStops = shape.getStrokeLinearGradientColorStops(), grd = this.createLinearGradient(start.x, start.y, end.x, end.y);
        if (colorStops) {
            for(let n = 0; n < colorStops.length; n += 2)grd.addColorStop(colorStops[n], colorStops[n + 1]);
            this.setAttr("strokeStyle", grd);
        }
    }
    _stroke(shape) {
        const dash = shape.dash(), strokeScaleEnabled = shape.getStrokeScaleEnabled();
        if (shape.hasStroke()) {
            if (!strokeScaleEnabled) {
                this.save();
                const pixelRatio = this.getCanvas().getPixelRatio();
                this.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
            }
            this._applyLineCap(shape);
            if (dash && shape.dashEnabled()) {
                this.setLineDash(dash);
                this.setAttr("lineDashOffset", shape.dashOffset());
            }
            this.setAttr("lineWidth", shape.strokeWidth());
            if (!shape.getShadowForStrokeEnabled()) this.setAttr("shadowColor", "rgba(0,0,0,0)");
            const hasLinearGradient = shape.getStrokeLinearGradientColorStops();
            if (hasLinearGradient) this._strokeLinearGradient(shape);
            else this.setAttr("strokeStyle", shape.stroke());
            shape._strokeFunc(this);
            if (!strokeScaleEnabled) this.restore();
        }
    }
    _applyShadow(shape) {
        var _a, _b, _c;
        const color = (_a = shape.getShadowRGBA()) !== null && _a !== void 0 ? _a : "black", blur = (_b = shape.getShadowBlur()) !== null && _b !== void 0 ? _b : 5, offset = (_c = shape.getShadowOffset()) !== null && _c !== void 0 ? _c : {
            x: 0,
            y: 0
        }, scale = shape.getAbsoluteScale(), ratio = this.canvas.getPixelRatio(), scaleX = scale.x * ratio, scaleY = scale.y * ratio;
        this.setAttr("shadowColor", color);
        this.setAttr("shadowBlur", blur * Math.min(Math.abs(scaleX), Math.abs(scaleY)));
        this.setAttr("shadowOffsetX", offset.x * scaleX);
        this.setAttr("shadowOffsetY", offset.y * scaleY);
    }
}
class $8efbfe36b14beb68$export$85eec7ef35542dce extends $8efbfe36b14beb68$export$841858b892ce1f4c {
    constructor(canvas){
        super(canvas);
        this._context = canvas._canvas.getContext("2d", {
            willReadFrequently: true
        });
    }
    _fill(shape) {
        this.save();
        this.setAttr("fillStyle", shape.colorKey);
        shape._fillFuncHit(this);
        this.restore();
    }
    strokeShape(shape) {
        if (shape.hasHitStroke()) this._stroke(shape);
    }
    _stroke(shape) {
        if (shape.hasHitStroke()) {
            const strokeScaleEnabled = shape.getStrokeScaleEnabled();
            if (!strokeScaleEnabled) {
                this.save();
                const pixelRatio = this.getCanvas().getPixelRatio();
                this.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
            }
            this._applyLineCap(shape);
            const hitStrokeWidth = shape.hitStrokeWidth();
            const strokeWidth = hitStrokeWidth === "auto" ? shape.strokeWidth() : hitStrokeWidth;
            this.setAttr("lineWidth", strokeWidth);
            this.setAttr("strokeStyle", shape.colorKey);
            shape._strokeFuncHit(this);
            if (!strokeScaleEnabled) this.restore();
        }
    }
}



let $e3f0e6aa12a16394$var$_pixelRatio;
function $e3f0e6aa12a16394$var$getDevicePixelRatio() {
    if ($e3f0e6aa12a16394$var$_pixelRatio) return $e3f0e6aa12a16394$var$_pixelRatio;
    const canvas = (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).createCanvasElement();
    const context = canvas.getContext("2d");
    $e3f0e6aa12a16394$var$_pixelRatio = function() {
        const devicePixelRatio = (0, $bd77714a0ea3dd4d$export$b9f99057a3c7692)._global.devicePixelRatio || 1, backingStoreRatio = context.webkitBackingStorePixelRatio || context.mozBackingStorePixelRatio || context.msBackingStorePixelRatio || context.oBackingStorePixelRatio || context.backingStorePixelRatio || 1;
        return devicePixelRatio / backingStoreRatio;
    }();
    (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).releaseCanvas(canvas);
    return $e3f0e6aa12a16394$var$_pixelRatio;
}
class $e3f0e6aa12a16394$export$8d01c972ee8b14a9 {
    constructor(config){
        this.pixelRatio = 1;
        this.width = 0;
        this.height = 0;
        this.isCache = false;
        const conf = config || {};
        const pixelRatio = conf.pixelRatio || (0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).pixelRatio || $e3f0e6aa12a16394$var$getDevicePixelRatio();
        this.pixelRatio = pixelRatio;
        this._canvas = (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).createCanvasElement();
        this._canvas.style.padding = "0";
        this._canvas.style.margin = "0";
        this._canvas.style.border = "0";
        this._canvas.style.background = "transparent";
        this._canvas.style.position = "absolute";
        this._canvas.style.top = "0";
        this._canvas.style.left = "0";
    }
    getContext() {
        return this.context;
    }
    getPixelRatio() {
        return this.pixelRatio;
    }
    setPixelRatio(pixelRatio) {
        const previousRatio = this.pixelRatio;
        this.pixelRatio = pixelRatio;
        this.setSize(this.getWidth() / previousRatio, this.getHeight() / previousRatio);
    }
    setWidth(width) {
        this.width = this._canvas.width = width * this.pixelRatio;
        this._canvas.style.width = width + "px";
        const pixelRatio = this.pixelRatio, _context = this.getContext()._context;
        _context.scale(pixelRatio, pixelRatio);
    }
    setHeight(height) {
        this.height = this._canvas.height = height * this.pixelRatio;
        this._canvas.style.height = height + "px";
        const pixelRatio = this.pixelRatio, _context = this.getContext()._context;
        _context.scale(pixelRatio, pixelRatio);
    }
    getWidth() {
        return this.width;
    }
    getHeight() {
        return this.height;
    }
    setSize(width, height) {
        this.setWidth(width || 0);
        this.setHeight(height || 0);
    }
    toDataURL(mimeType, quality) {
        try {
            return this._canvas.toDataURL(mimeType, quality);
        } catch (e) {
            try {
                return this._canvas.toDataURL();
            } catch (err) {
                (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).error("Unable to get data URL. " + err.message + " For more info read https://konvajs.org/docs/posts/Tainted_Canvas.html.");
                return "";
            }
        }
    }
}
class $e3f0e6aa12a16394$export$ee612225bd2e63be extends $e3f0e6aa12a16394$export$8d01c972ee8b14a9 {
    constructor(config = {
        width: 0,
        height: 0,
        willReadFrequently: false
    }){
        super(config);
        this.context = new (0, $8efbfe36b14beb68$export$576380cfa99ddf20)(this, {
            willReadFrequently: config.willReadFrequently
        });
        this.setSize(config.width, config.height);
    }
}
class $e3f0e6aa12a16394$export$43a2e1456e27dc84 extends $e3f0e6aa12a16394$export$8d01c972ee8b14a9 {
    constructor(config = {
        width: 0,
        height: 0
    }){
        super(config);
        this.hitCanvas = true;
        this.context = new (0, $8efbfe36b14beb68$export$85eec7ef35542dce)(this);
        this.setSize(config.width, config.height);
    }
}





const $5801123e8d1755fa$export$e34f1b340034d7f = {
    get isDragging () {
        let flag = false;
        $5801123e8d1755fa$export$e34f1b340034d7f._dragElements.forEach((elem)=>{
            if (elem.dragStatus === "dragging") flag = true;
        });
        return flag;
    },
    justDragged: false,
    get node () {
        let node;
        $5801123e8d1755fa$export$e34f1b340034d7f._dragElements.forEach((elem)=>{
            node = elem.node;
        });
        return node;
    },
    _dragElements: new Map(),
    _drag (evt) {
        const nodesToFireEvents = [];
        $5801123e8d1755fa$export$e34f1b340034d7f._dragElements.forEach((elem, key)=>{
            const { node: node } = elem;
            const stage = node.getStage();
            stage.setPointersPositions(evt);
            if (elem.pointerId === undefined) elem.pointerId = (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._getFirstPointerId(evt);
            const pos = stage._changedPointerPositions.find((pos)=>pos.id === elem.pointerId);
            if (!pos) return;
            if (elem.dragStatus !== "dragging") {
                const dragDistance = node.dragDistance();
                const distance = Math.max(Math.abs(pos.x - elem.startPointerPos.x), Math.abs(pos.y - elem.startPointerPos.y));
                if (distance < dragDistance) return;
                node.startDrag({
                    evt: evt
                });
                if (!node.isDragging()) return;
            }
            node._setDragPosition(evt, elem);
            nodesToFireEvents.push(node);
        });
        nodesToFireEvents.forEach((node)=>{
            if (!node.getStage()) return;
            node.fire("dragmove", {
                type: "dragmove",
                target: node,
                evt: evt
            }, true);
        });
    },
    _endDragBefore (evt) {
        const drawNodes = [];
        $5801123e8d1755fa$export$e34f1b340034d7f._dragElements.forEach((elem)=>{
            const { node: node } = elem;
            const stage = node.getStage();
            if (evt) stage.setPointersPositions(evt);
            const pos = stage._changedPointerPositions.find((pos)=>pos.id === elem.pointerId);
            if (!pos) return;
            if (elem.dragStatus === "dragging" || elem.dragStatus === "stopped") {
                $5801123e8d1755fa$export$e34f1b340034d7f.justDragged = true;
                (0, $bd77714a0ea3dd4d$export$b9f99057a3c7692)._mouseListenClick = false;
                (0, $bd77714a0ea3dd4d$export$b9f99057a3c7692)._touchListenClick = false;
                (0, $bd77714a0ea3dd4d$export$b9f99057a3c7692)._pointerListenClick = false;
                elem.dragStatus = "stopped";
            }
            const drawNode = elem.node.getLayer() || elem.node instanceof (0, $bd77714a0ea3dd4d$export$b9f99057a3c7692)["Stage"] && elem.node;
            if (drawNode && drawNodes.indexOf(drawNode) === -1) drawNodes.push(drawNode);
        });
        drawNodes.forEach((drawNode)=>{
            drawNode.draw();
        });
    },
    _endDragAfter (evt) {
        $5801123e8d1755fa$export$e34f1b340034d7f._dragElements.forEach((elem, key)=>{
            if (elem.dragStatus === "stopped") elem.node.fire("dragend", {
                type: "dragend",
                target: elem.node,
                evt: evt
            }, true);
            if (elem.dragStatus !== "dragging") $5801123e8d1755fa$export$e34f1b340034d7f._dragElements.delete(key);
        });
    }
};
if ((0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).isBrowser) {
    window.addEventListener("mouseup", $5801123e8d1755fa$export$e34f1b340034d7f._endDragBefore, true);
    window.addEventListener("touchend", $5801123e8d1755fa$export$e34f1b340034d7f._endDragBefore, true);
    window.addEventListener("touchcancel", $5801123e8d1755fa$export$e34f1b340034d7f._endDragBefore, true);
    window.addEventListener("mousemove", $5801123e8d1755fa$export$e34f1b340034d7f._drag);
    window.addEventListener("touchmove", $5801123e8d1755fa$export$e34f1b340034d7f._drag);
    window.addEventListener("mouseup", $5801123e8d1755fa$export$e34f1b340034d7f._endDragAfter, false);
    window.addEventListener("touchend", $5801123e8d1755fa$export$e34f1b340034d7f._endDragAfter, false);
    window.addEventListener("touchcancel", $5801123e8d1755fa$export$e34f1b340034d7f._endDragAfter, false);
}





function $dc39f19751b6eb0f$var$_formatValue(val) {
    if ((0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._isString(val)) return '"' + val + '"';
    if (Object.prototype.toString.call(val) === "[object Number]") return val;
    if ((0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._isBoolean(val)) return val;
    return Object.prototype.toString.call(val);
}
function $dc39f19751b6eb0f$export$af51e4581c640b27(val) {
    if (val > 255) return 255;
    else if (val < 0) return 0;
    return Math.round(val);
}
function $dc39f19751b6eb0f$export$7078afdc21938e7(val) {
    if (val > 1) return 1;
    else if (val < 0.0001) return 0.0001;
    return val;
}
function $dc39f19751b6eb0f$export$6b1205b9fbe7de2c() {
    if ((0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        if (!(0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._isNumber(val)) (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).warn($dc39f19751b6eb0f$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a number.');
        return val;
    };
}
function $dc39f19751b6eb0f$export$7d4ab1842c1b264b(noOfElements) {
    if ((0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        let isNumber = (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._isNumber(val);
        let isValidArray = (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._isArray(val) && val.length == noOfElements;
        if (!isNumber && !isValidArray) (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).warn($dc39f19751b6eb0f$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a number or Array<number>(' + noOfElements + ")");
        return val;
    };
}
function $dc39f19751b6eb0f$export$3b7df2720ef33404() {
    if ((0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        const isNumber = (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._isNumber(val);
        const isAuto = val === "auto";
        if (!(isNumber || isAuto)) (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).warn($dc39f19751b6eb0f$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a number or "auto".');
        return val;
    };
}
function $dc39f19751b6eb0f$export$5837c5b6cc5b4d63() {
    if ((0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        if (!(0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._isString(val)) (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).warn($dc39f19751b6eb0f$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a string.');
        return val;
    };
}
function $dc39f19751b6eb0f$export$9c72f966a828cc68() {
    if ((0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        const isString = (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._isString(val);
        const isGradient = Object.prototype.toString.call(val) === "[object CanvasGradient]" || val && val["addColorStop"];
        if (!(isString || isGradient)) (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).warn($dc39f19751b6eb0f$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a string or a native gradient.');
        return val;
    };
}
function $dc39f19751b6eb0f$export$61d6863134de1cd() {
    if ((0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        if (!(0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._isFunction(val)) (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).warn($dc39f19751b6eb0f$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a function.');
        return val;
    };
}
function $dc39f19751b6eb0f$export$42b6f8f340e9a165() {
    if ((0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        const TypedArray = Int8Array ? Object.getPrototypeOf(Int8Array) : null;
        if (TypedArray && val instanceof TypedArray) return val;
        if (!(0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._isArray(val)) (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).warn($dc39f19751b6eb0f$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a array of numbers.');
        else val.forEach(function(item) {
            if (!(0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._isNumber(item)) (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).warn('"' + attr + '" attribute has non numeric element ' + item + ". Make sure that all elements are numbers.");
        });
        return val;
    };
}
function $dc39f19751b6eb0f$export$147fc8b6cd20fda1() {
    if ((0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        const isBool = val === true || val === false;
        if (!isBool) (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).warn($dc39f19751b6eb0f$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a boolean.');
        return val;
    };
}
function $dc39f19751b6eb0f$export$5c1978fb8431d4a1(components) {
    if ((0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).isUnminified) return function(val, attr) {
        if (val === undefined || val === null) return val;
        if (!(0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).isObject(val)) (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).warn($dc39f19751b6eb0f$var$_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be an object with properties ' + components);
        return val;
    };
}


const $45b0bbe8561b93ca$var$GET = "get";
const $45b0bbe8561b93ca$var$SET = "set";
const $45b0bbe8561b93ca$export$8354032f3852ec50 = {
    addGetterSetter (constructor, attr, def, validator, after) {
        $45b0bbe8561b93ca$export$8354032f3852ec50.addGetter(constructor, attr, def);
        $45b0bbe8561b93ca$export$8354032f3852ec50.addSetter(constructor, attr, validator, after);
        $45b0bbe8561b93ca$export$8354032f3852ec50.addOverloadedGetterSetter(constructor, attr);
    },
    addGetter (constructor, attr, def) {
        const method = $45b0bbe8561b93ca$var$GET + (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._capitalize(attr);
        constructor.prototype[method] = constructor.prototype[method] || function() {
            const val = this.attrs[attr];
            return val === undefined ? def : val;
        };
    },
    addSetter (constructor, attr, validator, after) {
        const method = $45b0bbe8561b93ca$var$SET + (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._capitalize(attr);
        if (!constructor.prototype[method]) $45b0bbe8561b93ca$export$8354032f3852ec50.overWriteSetter(constructor, attr, validator, after);
    },
    overWriteSetter (constructor, attr, validator, after) {
        const method = $45b0bbe8561b93ca$var$SET + (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._capitalize(attr);
        constructor.prototype[method] = function(val) {
            if (validator && val !== undefined && val !== null) val = validator.call(this, val, attr);
            this._setAttr(attr, val);
            if (after) after.call(this);
            return this;
        };
    },
    addComponentsGetterSetter (constructor, attr, components, validator, after) {
        const len = components.length, capitalize = (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._capitalize, getter = $45b0bbe8561b93ca$var$GET + capitalize(attr), setter = $45b0bbe8561b93ca$var$SET + capitalize(attr);
        constructor.prototype[getter] = function() {
            const ret = {};
            for(let n = 0; n < len; n++){
                const component = components[n];
                ret[component] = this.getAttr(attr + capitalize(component));
            }
            return ret;
        };
        const basicValidator = (0, $dc39f19751b6eb0f$export$5c1978fb8431d4a1)(components);
        constructor.prototype[setter] = function(val) {
            const oldVal = this.attrs[attr];
            if (validator) val = validator.call(this, val, attr);
            if (basicValidator) basicValidator.call(this, val, attr);
            for(const key in val){
                if (!val.hasOwnProperty(key)) continue;
                this._setAttr(attr + capitalize(key), val[key]);
            }
            if (!val) components.forEach((component)=>{
                this._setAttr(attr + capitalize(component), undefined);
            });
            this._fireChangeEvent(attr, oldVal, val);
            if (after) after.call(this);
            return this;
        };
        $45b0bbe8561b93ca$export$8354032f3852ec50.addOverloadedGetterSetter(constructor, attr);
    },
    addOverloadedGetterSetter (constructor, attr) {
        const capitalizedAttr = (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._capitalize(attr), setter = $45b0bbe8561b93ca$var$SET + capitalizedAttr, getter = $45b0bbe8561b93ca$var$GET + capitalizedAttr;
        constructor.prototype[attr] = function() {
            if (arguments.length) {
                this[setter](arguments[0]);
                return this;
            }
            return this[getter]();
        };
    },
    addDeprecatedGetterSetter (constructor, attr, def, validator) {
        (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).error("Adding deprecated " + attr);
        const method = $45b0bbe8561b93ca$var$GET + (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._capitalize(attr);
        const message = attr + " property is deprecated and will be removed soon. Look at Konva change log for more information.";
        constructor.prototype[method] = function() {
            (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).error(message);
            const val = this.attrs[attr];
            return val === undefined ? def : val;
        };
        $45b0bbe8561b93ca$export$8354032f3852ec50.addSetter(constructor, attr, validator, function() {
            (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).error(message);
        });
        $45b0bbe8561b93ca$export$8354032f3852ec50.addOverloadedGetterSetter(constructor, attr);
    },
    backCompat (constructor, methods) {
        (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).each(methods, function(oldMethodName, newMethodName) {
            const method = constructor.prototype[newMethodName];
            const oldGetter = $45b0bbe8561b93ca$var$GET + (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._capitalize(oldMethodName);
            const oldSetter = $45b0bbe8561b93ca$var$SET + (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._capitalize(oldMethodName);
            function deprecated() {
                method.apply(this, arguments);
                (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).error('"' + oldMethodName + '" method is deprecated and will be removed soon. Use ""' + newMethodName + '" instead.');
            }
            constructor.prototype[oldMethodName] = deprecated;
            constructor.prototype[oldGetter] = deprecated;
            constructor.prototype[oldSetter] = deprecated;
        });
    },
    afterSetFilter () {
        this._filterUpToDate = false;
    }
};





function $29d50c16ed06fd36$var$parseCSSFilters(cssFilter) {
    const filterRegex = /(\w+)\(([^)]+)\)/g;
    let match;
    while((match = filterRegex.exec(cssFilter)) !== null){
        const [, filterName, filterValue] = match;
        switch(filterName){
            case "blur":
                {
                    const blurRadius = parseFloat(filterValue.replace("px", ""));
                    return function(imageData) {
                        this.blurRadius(blurRadius * 0.5);
                        const KonvaFilters = (0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).Filters;
                        if (KonvaFilters && KonvaFilters.Blur) KonvaFilters.Blur.call(this, imageData);
                    };
                }
            case "brightness":
                {
                    const brightness = filterValue.includes("%") ? parseFloat(filterValue) / 100 : parseFloat(filterValue);
                    return function(imageData) {
                        this.brightness(brightness);
                        const KonvaFilters = (0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).Filters;
                        if (KonvaFilters && KonvaFilters.Brightness) KonvaFilters.Brightness.call(this, imageData);
                    };
                }
            case "contrast":
                {
                    const contrast = parseFloat(filterValue);
                    return function(imageData) {
                        const konvaContrast = 100 * (Math.sqrt(contrast) - 1);
                        this.contrast(konvaContrast);
                        const KonvaFilters = (0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).Filters;
                        if (KonvaFilters && KonvaFilters.Contrast) KonvaFilters.Contrast.call(this, imageData);
                    };
                }
            case "grayscale":
                return function(imageData) {
                    const KonvaFilters = (0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).Filters;
                    if (KonvaFilters && KonvaFilters.Grayscale) KonvaFilters.Grayscale.call(this, imageData);
                };
            case "sepia":
                return function(imageData) {
                    const KonvaFilters = (0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).Filters;
                    if (KonvaFilters && KonvaFilters.Sepia) KonvaFilters.Sepia.call(this, imageData);
                };
            case "invert":
                return function(imageData) {
                    const KonvaFilters = (0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).Filters;
                    if (KonvaFilters && KonvaFilters.Invert) KonvaFilters.Invert.call(this, imageData);
                };
            default:
                (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).warn(`CSS filter "${filterName}" is not supported in fallback mode. Consider using function filters for better compatibility.`);
                break;
        }
    }
    return ()=>{};
}
const $29d50c16ed06fd36$var$ABSOLUTE_OPACITY = "absoluteOpacity", $29d50c16ed06fd36$var$ALL_LISTENERS = "allEventListeners", $29d50c16ed06fd36$var$ABSOLUTE_TRANSFORM = "absoluteTransform", $29d50c16ed06fd36$var$ABSOLUTE_SCALE = "absoluteScale", $29d50c16ed06fd36$var$CANVAS = "canvas", $29d50c16ed06fd36$var$CHANGE = "Change", $29d50c16ed06fd36$var$CHILDREN = "children", $29d50c16ed06fd36$var$KONVA = "konva", $29d50c16ed06fd36$var$LISTENING = "listening", $29d50c16ed06fd36$var$MOUSEENTER = "mouseenter", $29d50c16ed06fd36$var$MOUSELEAVE = "mouseleave", $29d50c16ed06fd36$var$POINTERENTER = "pointerenter", $29d50c16ed06fd36$var$POINTERLEAVE = "pointerleave", $29d50c16ed06fd36$var$TOUCHENTER = "touchenter", $29d50c16ed06fd36$var$TOUCHLEAVE = "touchleave", $29d50c16ed06fd36$var$NAME = "name", $29d50c16ed06fd36$var$SET = "set", $29d50c16ed06fd36$var$SHAPE = "Shape", $29d50c16ed06fd36$var$SPACE = " ", $29d50c16ed06fd36$var$STAGE = "stage", $29d50c16ed06fd36$var$TRANSFORM = "transform", $29d50c16ed06fd36$var$UPPER_STAGE = "Stage", $29d50c16ed06fd36$var$VISIBLE = "visible", $29d50c16ed06fd36$var$TRANSFORM_CHANGE_STR = [
    "xChange.konva",
    "yChange.konva",
    "scaleXChange.konva",
    "scaleYChange.konva",
    "skewXChange.konva",
    "skewYChange.konva",
    "rotationChange.konva",
    "offsetXChange.konva",
    "offsetYChange.konva",
    "transformsEnabledChange.konva"
].join($29d50c16ed06fd36$var$SPACE);
let $29d50c16ed06fd36$var$idCounter = 1;
class $29d50c16ed06fd36$export$85c928794f8d04d4 {
    constructor(config){
        this._id = $29d50c16ed06fd36$var$idCounter++;
        this.eventListeners = {};
        this.attrs = {};
        this.index = 0;
        this._allEventListeners = null;
        this.parent = null;
        this._cache = new Map();
        this._attachedDepsListeners = new Map();
        this._lastPos = null;
        this._batchingTransformChange = false;
        this._needClearTransformCache = false;
        this._filterUpToDate = false;
        this._isUnderCache = false;
        this._dragEventId = null;
        this._shouldFireChangeEvents = false;
        this.setAttrs(config);
        this._shouldFireChangeEvents = true;
    }
    hasChildren() {
        return false;
    }
    _clearCache(attr) {
        if ((attr === $29d50c16ed06fd36$var$TRANSFORM || attr === $29d50c16ed06fd36$var$ABSOLUTE_TRANSFORM) && this._cache.get(attr)) this._cache.get(attr).dirty = true;
        else if (attr) this._cache.delete(attr);
        else this._cache.clear();
    }
    _getCache(attr, privateGetter) {
        let cache = this._cache.get(attr);
        const isTransform = attr === $29d50c16ed06fd36$var$TRANSFORM || attr === $29d50c16ed06fd36$var$ABSOLUTE_TRANSFORM;
        const invalid = cache === undefined || isTransform && cache.dirty === true;
        if (invalid) {
            cache = privateGetter.call(this);
            this._cache.set(attr, cache);
        }
        return cache;
    }
    _calculate(name, deps, getter) {
        if (!this._attachedDepsListeners.get(name)) {
            const depsString = deps.map((dep)=>dep + "Change.konva").join($29d50c16ed06fd36$var$SPACE);
            this.on(depsString, ()=>{
                this._clearCache(name);
            });
            this._attachedDepsListeners.set(name, true);
        }
        return this._getCache(name, getter);
    }
    _getCanvasCache() {
        return this._cache.get($29d50c16ed06fd36$var$CANVAS);
    }
    _clearSelfAndDescendantCache(attr) {
        this._clearCache(attr);
        if (attr === $29d50c16ed06fd36$var$ABSOLUTE_TRANSFORM) this.fire("absoluteTransformChange");
    }
    clearCache() {
        if (this._cache.has($29d50c16ed06fd36$var$CANVAS)) {
            const { scene: scene, filter: filter, hit: hit } = this._cache.get($29d50c16ed06fd36$var$CANVAS);
            (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).releaseCanvas(scene._canvas, filter._canvas, hit._canvas);
            this._cache.delete($29d50c16ed06fd36$var$CANVAS);
        }
        this._clearSelfAndDescendantCache();
        this._requestDraw();
        return this;
    }
    cache(config) {
        const conf = config || {};
        let rect = {};
        if (conf.x === undefined || conf.y === undefined || conf.width === undefined || conf.height === undefined) rect = this.getClientRect({
            skipTransform: true,
            relativeTo: this.getParent() || undefined
        });
        let width = Math.ceil(conf.width || rect.width), height = Math.ceil(conf.height || rect.height), pixelRatio = conf.pixelRatio, x = conf.x === undefined ? Math.floor(rect.x) : conf.x, y = conf.y === undefined ? Math.floor(rect.y) : conf.y, offset = conf.offset || 0, drawBorder = conf.drawBorder || false, hitCanvasPixelRatio = conf.hitCanvasPixelRatio || 1;
        if (!width || !height) {
            (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).error("Can not cache the node. Width or height of the node equals 0. Caching is skipped.");
            return;
        }
        const extraPaddingX = Math.abs(Math.round(rect.x) - x) > 0.5 ? 1 : 0;
        const extraPaddingY = Math.abs(Math.round(rect.y) - y) > 0.5 ? 1 : 0;
        width += offset * 2 + extraPaddingX;
        height += offset * 2 + extraPaddingY;
        x -= offset;
        y -= offset;
        const cachedSceneCanvas = new (0, $e3f0e6aa12a16394$export$ee612225bd2e63be)({
            pixelRatio: pixelRatio,
            width: width,
            height: height
        }), cachedFilterCanvas = new (0, $e3f0e6aa12a16394$export$ee612225bd2e63be)({
            pixelRatio: pixelRatio,
            width: 0,
            height: 0,
            willReadFrequently: true
        }), cachedHitCanvas = new (0, $e3f0e6aa12a16394$export$43a2e1456e27dc84)({
            pixelRatio: hitCanvasPixelRatio,
            width: width,
            height: height
        }), sceneContext = cachedSceneCanvas.getContext(), hitContext = cachedHitCanvas.getContext();
        const bufferCanvas = new (0, $e3f0e6aa12a16394$export$ee612225bd2e63be)({
            width: cachedSceneCanvas.width / cachedSceneCanvas.pixelRatio + Math.abs(x),
            height: cachedSceneCanvas.height / cachedSceneCanvas.pixelRatio + Math.abs(y),
            pixelRatio: cachedSceneCanvas.pixelRatio
        }), bufferContext = bufferCanvas.getContext();
        cachedHitCanvas.isCache = true;
        cachedSceneCanvas.isCache = true;
        this._cache.delete($29d50c16ed06fd36$var$CANVAS);
        this._filterUpToDate = false;
        if (conf.imageSmoothingEnabled === false) {
            cachedSceneCanvas.getContext()._context.imageSmoothingEnabled = false;
            cachedFilterCanvas.getContext()._context.imageSmoothingEnabled = false;
        }
        sceneContext.save();
        hitContext.save();
        bufferContext.save();
        sceneContext.translate(-x, -y);
        hitContext.translate(-x, -y);
        bufferContext.translate(-x, -y);
        bufferCanvas.x = x;
        bufferCanvas.y = y;
        this._isUnderCache = true;
        this._clearSelfAndDescendantCache($29d50c16ed06fd36$var$ABSOLUTE_OPACITY);
        this._clearSelfAndDescendantCache($29d50c16ed06fd36$var$ABSOLUTE_SCALE);
        this.drawScene(cachedSceneCanvas, this, bufferCanvas);
        this.drawHit(cachedHitCanvas, this);
        this._isUnderCache = false;
        sceneContext.restore();
        hitContext.restore();
        if (drawBorder) {
            sceneContext.save();
            sceneContext.beginPath();
            sceneContext.rect(0, 0, width, height);
            sceneContext.closePath();
            sceneContext.setAttr("strokeStyle", "red");
            sceneContext.setAttr("lineWidth", 5);
            sceneContext.stroke();
            sceneContext.restore();
        }
        (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).releaseCanvas(bufferCanvas._canvas);
        this._cache.set($29d50c16ed06fd36$var$CANVAS, {
            scene: cachedSceneCanvas,
            filter: cachedFilterCanvas,
            hit: cachedHitCanvas,
            x: x,
            y: y
        });
        this._requestDraw();
        return this;
    }
    isCached() {
        return this._cache.has($29d50c16ed06fd36$var$CANVAS);
    }
    getClientRect(config) {
        throw new Error('abstract "getClientRect" method call');
    }
    _transformedRect(rect, top) {
        const points = [
            {
                x: rect.x,
                y: rect.y
            },
            {
                x: rect.x + rect.width,
                y: rect.y
            },
            {
                x: rect.x + rect.width,
                y: rect.y + rect.height
            },
            {
                x: rect.x,
                y: rect.y + rect.height
            }
        ];
        let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
        const trans = this.getAbsoluteTransform(top);
        points.forEach(function(point) {
            const transformed = trans.point(point);
            if (minX === undefined) {
                minX = maxX = transformed.x;
                minY = maxY = transformed.y;
            }
            minX = Math.min(minX, transformed.x);
            minY = Math.min(minY, transformed.y);
            maxX = Math.max(maxX, transformed.x);
            maxY = Math.max(maxY, transformed.y);
        });
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    }
    _drawCachedSceneCanvas(context) {
        context.save();
        context._applyOpacity(this);
        context._applyGlobalCompositeOperation(this);
        const canvasCache = this._getCanvasCache();
        context.translate(canvasCache.x, canvasCache.y);
        const cacheCanvas = this._getCachedSceneCanvas();
        const ratio = cacheCanvas.pixelRatio;
        context.drawImage(cacheCanvas._canvas, 0, 0, cacheCanvas.width / ratio, cacheCanvas.height / ratio);
        context.restore();
    }
    _drawCachedHitCanvas(context) {
        const canvasCache = this._getCanvasCache(), hitCanvas = canvasCache.hit;
        context.save();
        context.translate(canvasCache.x, canvasCache.y);
        context.drawImage(hitCanvas._canvas, 0, 0, hitCanvas.width / hitCanvas.pixelRatio, hitCanvas.height / hitCanvas.pixelRatio);
        context.restore();
    }
    _getCachedSceneCanvas() {
        let filters = this.filters(), cachedCanvas = this._getCanvasCache(), sceneCanvas = cachedCanvas.scene, filterCanvas = cachedCanvas.filter, filterContext = filterCanvas.getContext(), len, imageData, n, filter;
        if (!filters || filters.length === 0) return sceneCanvas;
        if (this._filterUpToDate) return filterCanvas;
        let useNativeOnly = true;
        for(let i = 0; i < filters.length; i++){
            const fallbackRequired = typeof filters[i] === "string" && !(0, $8efbfe36b14beb68$export$887ce9926cc3f80f)();
            fallbackRequired;
            if (typeof filters[i] !== "string" || !(0, $8efbfe36b14beb68$export$887ce9926cc3f80f)()) {
                useNativeOnly = false;
                break;
            }
        }
        const ratio = sceneCanvas.pixelRatio;
        filterCanvas.setSize(sceneCanvas.width / sceneCanvas.pixelRatio, sceneCanvas.height / sceneCanvas.pixelRatio);
        if (useNativeOnly) {
            const finalFilter = filters.join(" ");
            filterContext.save();
            filterContext.setAttr("filter", finalFilter);
            filterContext.drawImage(sceneCanvas._canvas, 0, 0, sceneCanvas.getWidth() / ratio, sceneCanvas.getHeight() / ratio);
            filterContext.restore();
            this._filterUpToDate = true;
            return filterCanvas;
        }
        try {
            len = filters.length;
            filterContext.clear();
            filterContext.drawImage(sceneCanvas._canvas, 0, 0, sceneCanvas.getWidth() / ratio, sceneCanvas.getHeight() / ratio);
            imageData = filterContext.getImageData(0, 0, filterCanvas.getWidth(), filterCanvas.getHeight());
            for(n = 0; n < len; n++){
                filter = filters[n];
                if (typeof filter === "string") filter = $29d50c16ed06fd36$var$parseCSSFilters(filter);
                filter.call(this, imageData);
                filterContext.putImageData(imageData, 0, 0);
            }
        } catch (e) {
            (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).error("Unable to apply filter. " + e.message + " This post my help you https://konvajs.org/docs/posts/Tainted_Canvas.html.");
        }
        this._filterUpToDate = true;
        return filterCanvas;
    }
    on(...args) {
        const evtStr = args[0];
        const selectorOrHandler = args[1];
        const handler = args[2];
        if (this._cache) this._cache.delete($29d50c16ed06fd36$var$ALL_LISTENERS);
        if (args.length === 3) return this._delegate.apply(this, args);
        const events = evtStr.split($29d50c16ed06fd36$var$SPACE);
        for(let n = 0; n < events.length; n++){
            const event = events[n];
            const parts = event.split(".");
            const baseEvent = parts[0];
            const name = parts[1] || "";
            if (!this.eventListeners[baseEvent]) this.eventListeners[baseEvent] = [];
            this.eventListeners[baseEvent].push({
                name: name,
                handler: selectorOrHandler
            });
        }
        return this;
    }
    off(evtStr, callback) {
        let events = (evtStr || "").split($29d50c16ed06fd36$var$SPACE), len = events.length, n, t, event, parts, baseEvent, name;
        this._cache && this._cache.delete($29d50c16ed06fd36$var$ALL_LISTENERS);
        if (!evtStr) for(t in this.eventListeners)this._off(t);
        for(n = 0; n < len; n++){
            event = events[n];
            parts = event.split(".");
            baseEvent = parts[0];
            name = parts[1];
            if (baseEvent) {
                if (this.eventListeners[baseEvent]) this._off(baseEvent, name, callback);
            } else for(t in this.eventListeners)this._off(t, name, callback);
        }
        return this;
    }
    dispatchEvent(evt) {
        const e = {
            target: this,
            type: evt.type,
            evt: evt
        };
        this.fire(evt.type, e);
        return this;
    }
    addEventListener(type, handler) {
        this.on(type, function(evt) {
            handler.call(this, evt.evt);
        });
        return this;
    }
    removeEventListener(type) {
        this.off(type);
        return this;
    }
    _delegate(event, selector, handler) {
        const stopNode = this;
        this.on(event, function(evt) {
            const targets = evt.target.findAncestors(selector, true, stopNode);
            for(let i = 0; i < targets.length; i++){
                evt = (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).cloneObject(evt);
                evt.currentTarget = targets[i];
                handler.call(targets[i], evt);
            }
        });
        return this;
    }
    remove() {
        if (this.isDragging()) this.stopDrag();
        (0, $5801123e8d1755fa$export$e34f1b340034d7f)._dragElements.delete(this._id);
        (0, $5801123e8d1755fa$export$e34f1b340034d7f)._dragElements.forEach((elem, key)=>{
            if (this.isAncestorOf(elem.node)) (0, $5801123e8d1755fa$export$e34f1b340034d7f)._dragElements.delete(key);
        });
        this._remove();
        return this;
    }
    _clearCaches() {
        this._clearSelfAndDescendantCache($29d50c16ed06fd36$var$ABSOLUTE_TRANSFORM);
        this._clearSelfAndDescendantCache($29d50c16ed06fd36$var$ABSOLUTE_OPACITY);
        this._clearSelfAndDescendantCache($29d50c16ed06fd36$var$ABSOLUTE_SCALE);
        this._clearSelfAndDescendantCache($29d50c16ed06fd36$var$STAGE);
        this._clearSelfAndDescendantCache($29d50c16ed06fd36$var$VISIBLE);
        this._clearSelfAndDescendantCache($29d50c16ed06fd36$var$LISTENING);
    }
    _remove() {
        this._clearCaches();
        const parent = this.getParent();
        if (parent && parent.children) {
            parent.children.splice(this.index, 1);
            parent._setChildrenIndices();
            this.parent = null;
        }
    }
    destroy() {
        this.remove();
        this.clearCache();
        return this;
    }
    getAttr(attr) {
        const method = "get" + (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._capitalize(attr);
        if ((0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._isFunction(this[method])) return this[method]();
        return this.attrs[attr];
    }
    getAncestors() {
        let parent = this.getParent(), ancestors = [];
        while(parent){
            ancestors.push(parent);
            parent = parent.getParent();
        }
        return ancestors;
    }
    getAttrs() {
        return this.attrs || {};
    }
    setAttrs(config) {
        this._batchTransformChanges(()=>{
            let key, method;
            if (!config) return this;
            for(key in config){
                if (key === $29d50c16ed06fd36$var$CHILDREN) continue;
                method = $29d50c16ed06fd36$var$SET + (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._capitalize(key);
                if ((0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._isFunction(this[method])) this[method](config[key]);
                else this._setAttr(key, config[key]);
            }
        });
        return this;
    }
    isListening() {
        return this._getCache($29d50c16ed06fd36$var$LISTENING, this._isListening);
    }
    _isListening(relativeTo) {
        const listening = this.listening();
        if (!listening) return false;
        const parent = this.getParent();
        if (parent && parent !== relativeTo && this !== relativeTo) return parent._isListening(relativeTo);
        else return true;
    }
    isVisible() {
        return this._getCache($29d50c16ed06fd36$var$VISIBLE, this._isVisible);
    }
    _isVisible(relativeTo) {
        const visible = this.visible();
        if (!visible) return false;
        const parent = this.getParent();
        if (parent && parent !== relativeTo && this !== relativeTo) return parent._isVisible(relativeTo);
        else return true;
    }
    shouldDrawHit(top, skipDragCheck = false) {
        if (top) return this._isVisible(top) && this._isListening(top);
        const layer = this.getLayer();
        let layerUnderDrag = false;
        (0, $5801123e8d1755fa$export$e34f1b340034d7f)._dragElements.forEach((elem)=>{
            if (elem.dragStatus !== "dragging") return;
            else if (elem.node.nodeType === "Stage") layerUnderDrag = true;
            else if (elem.node.getLayer() === layer) layerUnderDrag = true;
        });
        const dragSkip = !skipDragCheck && !(0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).hitOnDragEnabled && (layerUnderDrag || (0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).isTransforming());
        return this.isListening() && this.isVisible() && !dragSkip;
    }
    show() {
        this.visible(true);
        return this;
    }
    hide() {
        this.visible(false);
        return this;
    }
    getZIndex() {
        return this.index || 0;
    }
    getAbsoluteZIndex() {
        let depth = this.getDepth(), that = this, index = 0, nodes, len, n, child;
        function addChildren(children) {
            nodes = [];
            len = children.length;
            for(n = 0; n < len; n++){
                child = children[n];
                index++;
                if (child.nodeType !== $29d50c16ed06fd36$var$SHAPE) nodes = nodes.concat(child.getChildren().slice());
                if (child._id === that._id) n = len;
            }
            if (nodes.length > 0 && nodes[0].getDepth() <= depth) addChildren(nodes);
        }
        const stage = this.getStage();
        if (that.nodeType !== $29d50c16ed06fd36$var$UPPER_STAGE && stage) addChildren(stage.getChildren());
        return index;
    }
    getDepth() {
        let depth = 0, parent = this.parent;
        while(parent){
            depth++;
            parent = parent.parent;
        }
        return depth;
    }
    _batchTransformChanges(func) {
        this._batchingTransformChange = true;
        func();
        this._batchingTransformChange = false;
        if (this._needClearTransformCache) {
            this._clearCache($29d50c16ed06fd36$var$TRANSFORM);
            this._clearSelfAndDescendantCache($29d50c16ed06fd36$var$ABSOLUTE_TRANSFORM);
        }
        this._needClearTransformCache = false;
    }
    setPosition(pos) {
        this._batchTransformChanges(()=>{
            this.x(pos.x);
            this.y(pos.y);
        });
        return this;
    }
    getPosition() {
        return {
            x: this.x(),
            y: this.y()
        };
    }
    getRelativePointerPosition() {
        const stage = this.getStage();
        if (!stage) return null;
        const pos = stage.getPointerPosition();
        if (!pos) return null;
        const transform = this.getAbsoluteTransform().copy();
        transform.invert();
        return transform.point(pos);
    }
    getAbsolutePosition(top) {
        let haveCachedParent = false;
        let parent = this.parent;
        while(parent){
            if (parent.isCached()) {
                haveCachedParent = true;
                break;
            }
            parent = parent.parent;
        }
        if (haveCachedParent && !top) top = true;
        const absoluteMatrix = this.getAbsoluteTransform(top).getMatrix(), absoluteTransform = new (0, $a838f7f004abc0fb$export$563a914cafbdc389)(), offset = this.offset();
        absoluteTransform.m = absoluteMatrix.slice();
        absoluteTransform.translate(offset.x, offset.y);
        return absoluteTransform.getTranslation();
    }
    setAbsolutePosition(pos) {
        const { x: x, y: y, ...origTrans } = this._clearTransform();
        this.attrs.x = x;
        this.attrs.y = y;
        this._clearCache($29d50c16ed06fd36$var$TRANSFORM);
        const it = this._getAbsoluteTransform().copy();
        it.invert();
        it.translate(pos.x, pos.y);
        pos = {
            x: this.attrs.x + it.getTranslation().x,
            y: this.attrs.y + it.getTranslation().y
        };
        this._setTransform(origTrans);
        this.setPosition({
            x: pos.x,
            y: pos.y
        });
        this._clearCache($29d50c16ed06fd36$var$TRANSFORM);
        this._clearSelfAndDescendantCache($29d50c16ed06fd36$var$ABSOLUTE_TRANSFORM);
        return this;
    }
    _setTransform(trans) {
        let key;
        for(key in trans)this.attrs[key] = trans[key];
    }
    _clearTransform() {
        const trans = {
            x: this.x(),
            y: this.y(),
            rotation: this.rotation(),
            scaleX: this.scaleX(),
            scaleY: this.scaleY(),
            offsetX: this.offsetX(),
            offsetY: this.offsetY(),
            skewX: this.skewX(),
            skewY: this.skewY()
        };
        this.attrs.x = 0;
        this.attrs.y = 0;
        this.attrs.rotation = 0;
        this.attrs.scaleX = 1;
        this.attrs.scaleY = 1;
        this.attrs.offsetX = 0;
        this.attrs.offsetY = 0;
        this.attrs.skewX = 0;
        this.attrs.skewY = 0;
        return trans;
    }
    move(change) {
        let changeX = change.x, changeY = change.y, x = this.x(), y = this.y();
        if (changeX !== undefined) x += changeX;
        if (changeY !== undefined) y += changeY;
        this.setPosition({
            x: x,
            y: y
        });
        return this;
    }
    _eachAncestorReverse(func, top) {
        let family = [], parent = this.getParent(), len, n;
        if (top && top._id === this._id) return;
        family.unshift(this);
        while(parent && (!top || parent._id !== top._id)){
            family.unshift(parent);
            parent = parent.parent;
        }
        len = family.length;
        for(n = 0; n < len; n++)func(family[n]);
    }
    rotate(theta) {
        this.rotation(this.rotation() + theta);
        return this;
    }
    moveToTop() {
        if (!this.parent) {
            (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).warn("Node has no parent. moveToTop function is ignored.");
            return false;
        }
        const index = this.index, len = this.parent.getChildren().length;
        if (index < len - 1) {
            this.parent.children.splice(index, 1);
            this.parent.children.push(this);
            this.parent._setChildrenIndices();
            return true;
        }
        return false;
    }
    moveUp() {
        if (!this.parent) {
            (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).warn("Node has no parent. moveUp function is ignored.");
            return false;
        }
        const index = this.index, len = this.parent.getChildren().length;
        if (index < len - 1) {
            this.parent.children.splice(index, 1);
            this.parent.children.splice(index + 1, 0, this);
            this.parent._setChildrenIndices();
            return true;
        }
        return false;
    }
    moveDown() {
        if (!this.parent) {
            (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).warn("Node has no parent. moveDown function is ignored.");
            return false;
        }
        const index = this.index;
        if (index > 0) {
            this.parent.children.splice(index, 1);
            this.parent.children.splice(index - 1, 0, this);
            this.parent._setChildrenIndices();
            return true;
        }
        return false;
    }
    moveToBottom() {
        if (!this.parent) {
            (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).warn("Node has no parent. moveToBottom function is ignored.");
            return false;
        }
        const index = this.index;
        if (index > 0) {
            this.parent.children.splice(index, 1);
            this.parent.children.unshift(this);
            this.parent._setChildrenIndices();
            return true;
        }
        return false;
    }
    setZIndex(zIndex) {
        if (!this.parent) {
            (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).warn("Node has no parent. zIndex parameter is ignored.");
            return this;
        }
        if (zIndex < 0 || zIndex >= this.parent.children.length) (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).warn("Unexpected value " + zIndex + " for zIndex property. zIndex is just index of a node in children of its parent. Expected value is from 0 to " + (this.parent.children.length - 1) + ".");
        const index = this.index;
        this.parent.children.splice(index, 1);
        this.parent.children.splice(zIndex, 0, this);
        this.parent._setChildrenIndices();
        return this;
    }
    getAbsoluteOpacity() {
        return this._getCache($29d50c16ed06fd36$var$ABSOLUTE_OPACITY, this._getAbsoluteOpacity);
    }
    _getAbsoluteOpacity() {
        let absOpacity = this.opacity();
        const parent = this.getParent();
        if (parent && !parent._isUnderCache) absOpacity *= parent.getAbsoluteOpacity();
        return absOpacity;
    }
    moveTo(newContainer) {
        if (this.getParent() !== newContainer) {
            this._remove();
            newContainer.add(this);
        }
        return this;
    }
    toObject() {
        let attrs = this.getAttrs(), key, val, getter, defaultValue, nonPlainObject;
        const obj = {
            attrs: {},
            className: this.getClassName()
        };
        for(key in attrs){
            val = attrs[key];
            nonPlainObject = (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).isObject(val) && !(0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._isPlainObject(val) && !(0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._isArray(val);
            if (nonPlainObject) continue;
            getter = typeof this[key] === "function" && this[key];
            delete attrs[key];
            defaultValue = getter ? getter.call(this) : null;
            attrs[key] = val;
            if (defaultValue !== val) obj.attrs[key] = val;
        }
        return (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._prepareToStringify(obj);
    }
    toJSON() {
        return JSON.stringify(this.toObject());
    }
    getParent() {
        return this.parent;
    }
    findAncestors(selector, includeSelf, stopNode) {
        const res = [];
        if (includeSelf && this._isMatch(selector)) res.push(this);
        let ancestor = this.parent;
        while(ancestor){
            if (ancestor === stopNode) return res;
            if (ancestor._isMatch(selector)) res.push(ancestor);
            ancestor = ancestor.parent;
        }
        return res;
    }
    isAncestorOf(node) {
        return false;
    }
    findAncestor(selector, includeSelf, stopNode) {
        return this.findAncestors(selector, includeSelf, stopNode)[0];
    }
    _isMatch(selector) {
        if (!selector) return false;
        if (typeof selector === "function") return selector(this);
        let selectorArr = selector.replace(/ /g, "").split(","), len = selectorArr.length, n, sel;
        for(n = 0; n < len; n++){
            sel = selectorArr[n];
            if (!(0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).isValidSelector(sel)) {
                (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).warn('Selector "' + sel + '" is invalid. Allowed selectors examples are "#foo", ".bar" or "Group".');
                (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).warn('If you have a custom shape with such className, please change it to start with upper letter like "Triangle".');
                (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).warn("Konva is awesome, right?");
            }
            if (sel.charAt(0) === "#") {
                if (this.id() === sel.slice(1)) return true;
            } else if (sel.charAt(0) === ".") {
                if (this.hasName(sel.slice(1))) return true;
            } else if (this.className === sel || this.nodeType === sel) return true;
        }
        return false;
    }
    getLayer() {
        const parent = this.getParent();
        return parent ? parent.getLayer() : null;
    }
    getStage() {
        return this._getCache($29d50c16ed06fd36$var$STAGE, this._getStage);
    }
    _getStage() {
        const parent = this.getParent();
        if (parent) return parent.getStage();
        else return null;
    }
    fire(eventType, evt = {}, bubble) {
        evt.target = evt.target || this;
        if (bubble) this._fireAndBubble(eventType, evt);
        else this._fire(eventType, evt);
        return this;
    }
    getAbsoluteTransform(top) {
        if (top) return this._getAbsoluteTransform(top);
        else return this._getCache($29d50c16ed06fd36$var$ABSOLUTE_TRANSFORM, this._getAbsoluteTransform);
    }
    _getAbsoluteTransform(top) {
        let at;
        if (top) {
            at = new (0, $a838f7f004abc0fb$export$563a914cafbdc389)();
            this._eachAncestorReverse(function(node) {
                const transformsEnabled = node.transformsEnabled();
                if (transformsEnabled === "all") at.multiply(node.getTransform());
                else if (transformsEnabled === "position") at.translate(node.x() - node.offsetX(), node.y() - node.offsetY());
            }, top);
            return at;
        } else {
            at = this._cache.get($29d50c16ed06fd36$var$ABSOLUTE_TRANSFORM) || new (0, $a838f7f004abc0fb$export$563a914cafbdc389)();
            if (this.parent) this.parent.getAbsoluteTransform().copyInto(at);
            else at.reset();
            const transformsEnabled = this.transformsEnabled();
            if (transformsEnabled === "all") at.multiply(this.getTransform());
            else if (transformsEnabled === "position") {
                const x = this.attrs.x || 0;
                const y = this.attrs.y || 0;
                const offsetX = this.attrs.offsetX || 0;
                const offsetY = this.attrs.offsetY || 0;
                at.translate(x - offsetX, y - offsetY);
            }
            at.dirty = false;
            return at;
        }
    }
    getAbsoluteScale(top) {
        let parent = this;
        while(parent){
            if (parent._isUnderCache) top = parent;
            parent = parent.getParent();
        }
        const transform = this.getAbsoluteTransform(top);
        const attrs = transform.decompose();
        return {
            x: attrs.scaleX,
            y: attrs.scaleY
        };
    }
    getAbsoluteRotation() {
        return this.getAbsoluteTransform().decompose().rotation;
    }
    getTransform() {
        return this._getCache($29d50c16ed06fd36$var$TRANSFORM, this._getTransform);
    }
    _getTransform() {
        var _a, _b;
        const m = this._cache.get($29d50c16ed06fd36$var$TRANSFORM) || new (0, $a838f7f004abc0fb$export$563a914cafbdc389)();
        m.reset();
        const x = this.x(), y = this.y(), rotation = (0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).getAngle(this.rotation()), scaleX = (_a = this.attrs.scaleX) !== null && _a !== void 0 ? _a : 1, scaleY = (_b = this.attrs.scaleY) !== null && _b !== void 0 ? _b : 1, skewX = this.attrs.skewX || 0, skewY = this.attrs.skewY || 0, offsetX = this.attrs.offsetX || 0, offsetY = this.attrs.offsetY || 0;
        if (x !== 0 || y !== 0) m.translate(x, y);
        if (rotation !== 0) m.rotate(rotation);
        if (skewX !== 0 || skewY !== 0) m.skew(skewX, skewY);
        if (scaleX !== 1 || scaleY !== 1) m.scale(scaleX, scaleY);
        if (offsetX !== 0 || offsetY !== 0) m.translate(-1 * offsetX, -1 * offsetY);
        m.dirty = false;
        return m;
    }
    clone(obj) {
        let attrs = (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).cloneObject(this.attrs), key, allListeners, len, n, listener;
        for(key in obj)attrs[key] = obj[key];
        const node = new this.constructor(attrs);
        for(key in this.eventListeners){
            allListeners = this.eventListeners[key];
            len = allListeners.length;
            for(n = 0; n < len; n++){
                listener = allListeners[n];
                if (listener.name.indexOf($29d50c16ed06fd36$var$KONVA) < 0) {
                    if (!node.eventListeners[key]) node.eventListeners[key] = [];
                    node.eventListeners[key].push(listener);
                }
            }
        }
        return node;
    }
    _toKonvaCanvas(config) {
        config = config || {};
        const box = this.getClientRect();
        const stage = this.getStage(), x = config.x !== undefined ? config.x : Math.floor(box.x), y = config.y !== undefined ? config.y : Math.floor(box.y), pixelRatio = config.pixelRatio || 1, canvas = new (0, $e3f0e6aa12a16394$export$ee612225bd2e63be)({
            width: config.width || Math.ceil(box.width) || (stage ? stage.width() : 0),
            height: config.height || Math.ceil(box.height) || (stage ? stage.height() : 0),
            pixelRatio: pixelRatio
        }), context = canvas.getContext();
        const bufferCanvas = new (0, $e3f0e6aa12a16394$export$ee612225bd2e63be)({
            width: canvas.width / canvas.pixelRatio + Math.abs(x),
            height: canvas.height / canvas.pixelRatio + Math.abs(y),
            pixelRatio: canvas.pixelRatio
        });
        if (config.imageSmoothingEnabled === false) context._context.imageSmoothingEnabled = false;
        context.save();
        if (x || y) context.translate(-1 * x, -1 * y);
        this.drawScene(canvas, undefined, bufferCanvas);
        context.restore();
        return canvas;
    }
    toCanvas(config) {
        return this._toKonvaCanvas(config)._canvas;
    }
    toDataURL(config) {
        config = config || {};
        const mimeType = config.mimeType || null, quality = config.quality || null;
        const url = this._toKonvaCanvas(config).toDataURL(mimeType, quality);
        if (config.callback) config.callback(url);
        return url;
    }
    toImage(config) {
        return new Promise((resolve, reject)=>{
            try {
                const callback = config === null || config === void 0 ? void 0 : config.callback;
                if (callback) delete config.callback;
                (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._urlToImage(this.toDataURL(config), function(img) {
                    resolve(img);
                    callback === null || callback === void 0 || callback(img);
                });
            } catch (err) {
                reject(err);
            }
        });
    }
    toBlob(config) {
        return new Promise((resolve, reject)=>{
            try {
                const callback = config === null || config === void 0 ? void 0 : config.callback;
                if (callback) delete config.callback;
                this.toCanvas(config).toBlob((blob)=>{
                    resolve(blob);
                    callback === null || callback === void 0 || callback(blob);
                }, config === null || config === void 0 ? void 0 : config.mimeType, config === null || config === void 0 ? void 0 : config.quality);
            } catch (err) {
                reject(err);
            }
        });
    }
    setSize(size) {
        this.width(size.width);
        this.height(size.height);
        return this;
    }
    getSize() {
        return {
            width: this.width(),
            height: this.height()
        };
    }
    getClassName() {
        return this.className || this.nodeType;
    }
    getType() {
        return this.nodeType;
    }
    getDragDistance() {
        if (this.attrs.dragDistance !== undefined) return this.attrs.dragDistance;
        else if (this.parent) return this.parent.getDragDistance();
        else return (0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).dragDistance;
    }
    _off(type, name, callback) {
        let evtListeners = this.eventListeners[type], i, evtName, handler;
        for(i = 0; i < evtListeners.length; i++){
            evtName = evtListeners[i].name;
            handler = evtListeners[i].handler;
            if ((evtName !== "konva" || name === "konva") && (!name || evtName === name) && (!callback || callback === handler)) {
                evtListeners.splice(i, 1);
                if (evtListeners.length === 0) {
                    delete this.eventListeners[type];
                    break;
                }
                i--;
            }
        }
    }
    _fireChangeEvent(attr, oldVal, newVal) {
        this._fire(attr + $29d50c16ed06fd36$var$CHANGE, {
            oldVal: oldVal,
            newVal: newVal
        });
    }
    addName(name) {
        if (!this.hasName(name)) {
            const oldName = this.name();
            const newName = oldName ? oldName + " " + name : name;
            this.name(newName);
        }
        return this;
    }
    hasName(name) {
        if (!name) return false;
        const fullName = this.name();
        if (!fullName) return false;
        const names = (fullName || "").split(/\s/g);
        return names.indexOf(name) !== -1;
    }
    removeName(name) {
        const names = (this.name() || "").split(/\s/g);
        const index = names.indexOf(name);
        if (index !== -1) {
            names.splice(index, 1);
            this.name(names.join(" "));
        }
        return this;
    }
    setAttr(attr, val) {
        const func = this[$29d50c16ed06fd36$var$SET + (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._capitalize(attr)];
        if ((0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._isFunction(func)) func.call(this, val);
        else this._setAttr(attr, val);
        return this;
    }
    _requestDraw() {
        if ((0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).autoDrawEnabled) {
            const drawNode = this.getLayer() || this.getStage();
            drawNode === null || drawNode === void 0 || drawNode.batchDraw();
        }
    }
    _setAttr(key, val) {
        const oldVal = this.attrs[key];
        if (oldVal === val && !(0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).isObject(val)) return;
        if (val === undefined || val === null) delete this.attrs[key];
        else this.attrs[key] = val;
        if (this._shouldFireChangeEvents) this._fireChangeEvent(key, oldVal, val);
        this._requestDraw();
    }
    _setComponentAttr(key, component, val) {
        let oldVal;
        if (val !== undefined) {
            oldVal = this.attrs[key];
            if (!oldVal) this.attrs[key] = this.getAttr(key);
            this.attrs[key][component] = val;
            this._fireChangeEvent(key, oldVal, val);
        }
    }
    _fireAndBubble(eventType, evt, compareShape) {
        if (evt && this.nodeType === $29d50c16ed06fd36$var$SHAPE) evt.target = this;
        const nonBubbling = [
            $29d50c16ed06fd36$var$MOUSEENTER,
            $29d50c16ed06fd36$var$MOUSELEAVE,
            $29d50c16ed06fd36$var$POINTERENTER,
            $29d50c16ed06fd36$var$POINTERLEAVE,
            $29d50c16ed06fd36$var$TOUCHENTER,
            $29d50c16ed06fd36$var$TOUCHLEAVE
        ];
        const shouldStop = nonBubbling.indexOf(eventType) !== -1 && (compareShape && (this === compareShape || this.isAncestorOf && this.isAncestorOf(compareShape)) || this.nodeType === "Stage" && !compareShape);
        if (!shouldStop) {
            this._fire(eventType, evt);
            const stopBubble = nonBubbling.indexOf(eventType) !== -1 && compareShape && compareShape.isAncestorOf && compareShape.isAncestorOf(this) && !compareShape.isAncestorOf(this.parent);
            if ((evt && !evt.cancelBubble || !evt) && this.parent && this.parent.isListening() && !stopBubble) {
                if (compareShape && compareShape.parent) this._fireAndBubble.call(this.parent, eventType, evt, compareShape);
                else this._fireAndBubble.call(this.parent, eventType, evt);
            }
        }
    }
    _getProtoListeners(eventType) {
        var _a, _b;
        const { nodeType: nodeType } = this;
        const allListeners = $29d50c16ed06fd36$export$85c928794f8d04d4.protoListenerMap.get(nodeType) || {};
        let events = allListeners === null || allListeners === void 0 ? void 0 : allListeners[eventType];
        if (events === undefined) {
            events = [];
            let obj = Object.getPrototypeOf(this);
            while(obj){
                const hierarchyEvents = (_b = (_a = obj.eventListeners) === null || _a === void 0 ? void 0 : _a[eventType]) !== null && _b !== void 0 ? _b : [];
                events.push(...hierarchyEvents);
                obj = Object.getPrototypeOf(obj);
            }
            allListeners[eventType] = events;
            $29d50c16ed06fd36$export$85c928794f8d04d4.protoListenerMap.set(nodeType, allListeners);
        }
        return events;
    }
    _fire(eventType, evt) {
        evt = evt || {};
        evt.currentTarget = this;
        evt.type = eventType;
        const topListeners = this._getProtoListeners(eventType);
        if (topListeners) {
            const list = topListeners.slice();
            for(let i = 0; i < list.length; i++)list[i].handler.call(this, evt);
        }
        const selfListeners = this.eventListeners[eventType];
        if (selfListeners) {
            const list = selfListeners.slice();
            const origLen = list.length;
            for(let i = 0; i < list.length; i++)list[i].handler.call(this, evt);
            const liveListeners = this.eventListeners[eventType];
            if (liveListeners) for(let i = origLen; i < liveListeners.length; i++)liveListeners[i].handler.call(this, evt);
        }
    }
    draw() {
        this.drawScene();
        this.drawHit();
        return this;
    }
    _createDragElement(evt) {
        const pointerId = evt ? evt.pointerId : undefined;
        const stage = this.getStage();
        const ap = this.getAbsolutePosition();
        if (!stage) return;
        const pos = stage._getPointerById(pointerId) || stage._changedPointerPositions[0] || ap;
        (0, $5801123e8d1755fa$export$e34f1b340034d7f)._dragElements.set(this._id, {
            node: this,
            startPointerPos: pos,
            offset: {
                x: pos.x - ap.x,
                y: pos.y - ap.y
            },
            dragStatus: "ready",
            pointerId: pointerId,
            startEvent: evt
        });
    }
    startDrag(evt, bubbleEvent = true) {
        if (!(0, $5801123e8d1755fa$export$e34f1b340034d7f)._dragElements.has(this._id)) this._createDragElement(evt);
        const elem = (0, $5801123e8d1755fa$export$e34f1b340034d7f)._dragElements.get(this._id);
        elem.dragStatus = "dragging";
        this.fire("dragstart", {
            type: "dragstart",
            target: this,
            evt: elem.startEvent && elem.startEvent.evt || evt && evt.evt
        }, bubbleEvent);
    }
    _setDragPosition(evt, elem) {
        const pos = this.getStage()._getPointerById(elem.pointerId);
        if (!pos) return;
        let newNodePos = {
            x: pos.x - elem.offset.x,
            y: pos.y - elem.offset.y
        };
        const dbf = this.dragBoundFunc();
        if (dbf !== undefined) {
            const bounded = dbf.call(this, newNodePos, evt);
            if (!bounded) (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).warn("dragBoundFunc did not return any value. That is unexpected behavior. You must return new absolute position from dragBoundFunc.");
            else newNodePos = bounded;
        }
        if (!this._lastPos || this._lastPos.x !== newNodePos.x || this._lastPos.y !== newNodePos.y) {
            this.setAbsolutePosition(newNodePos);
            this._requestDraw();
        }
        this._lastPos = newNodePos;
    }
    stopDrag(evt) {
        const elem = (0, $5801123e8d1755fa$export$e34f1b340034d7f)._dragElements.get(this._id);
        if (elem) elem.dragStatus = "stopped";
        (0, $5801123e8d1755fa$export$e34f1b340034d7f)._endDragBefore(evt);
        (0, $5801123e8d1755fa$export$e34f1b340034d7f)._endDragAfter(evt);
    }
    setDraggable(draggable) {
        this._setAttr("draggable", draggable);
        this._dragChange();
    }
    isDragging() {
        const elem = (0, $5801123e8d1755fa$export$e34f1b340034d7f)._dragElements.get(this._id);
        return elem ? elem.dragStatus === "dragging" : false;
    }
    _listenDrag() {
        this._dragCleanup();
        this.on("mousedown.konva touchstart.konva", function(evt) {
            const shouldCheckButton = evt.evt["button"] !== undefined;
            const canDrag = !shouldCheckButton || (0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).dragButtons.indexOf(evt.evt["button"]) >= 0;
            if (!canDrag) return;
            if (this.isDragging()) return;
            let hasDraggingChild = false;
            (0, $5801123e8d1755fa$export$e34f1b340034d7f)._dragElements.forEach((elem)=>{
                if (this.isAncestorOf(elem.node)) hasDraggingChild = true;
            });
            if (!hasDraggingChild) this._createDragElement(evt);
        });
    }
    _dragChange() {
        if (this.attrs.draggable) this._listenDrag();
        else {
            this._dragCleanup();
            const stage = this.getStage();
            if (!stage) return;
            const dragElement = (0, $5801123e8d1755fa$export$e34f1b340034d7f)._dragElements.get(this._id);
            const isDragging = dragElement && dragElement.dragStatus === "dragging";
            const isReady = dragElement && dragElement.dragStatus === "ready";
            if (isDragging) this.stopDrag();
            else if (isReady) (0, $5801123e8d1755fa$export$e34f1b340034d7f)._dragElements.delete(this._id);
        }
    }
    _dragCleanup() {
        this.off("mousedown.konva");
        this.off("touchstart.konva");
    }
    isClientRectOnScreen(margin = {
        x: 0,
        y: 0
    }) {
        const stage = this.getStage();
        if (!stage) return false;
        const screenRect = {
            x: -margin.x,
            y: -margin.y,
            width: stage.width() + 2 * margin.x,
            height: stage.height() + 2 * margin.y
        };
        return (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).haveIntersection(screenRect, this.getClientRect());
    }
    static create(data, container) {
        if ((0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._isString(data)) data = JSON.parse(data);
        return this._createNode(data, container);
    }
    static _createNode(obj, container) {
        let className = $29d50c16ed06fd36$export$85c928794f8d04d4.prototype.getClassName.call(obj), children = obj.children, no, len, n;
        if (container) obj.attrs.container = container;
        if (!(0, $bd77714a0ea3dd4d$export$b9f99057a3c7692)[className]) {
            (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).warn('Can not find a node with class name "' + className + '". Fallback to "Shape".');
            className = "Shape";
        }
        const Class = (0, $bd77714a0ea3dd4d$export$b9f99057a3c7692)[className];
        no = new Class(obj.attrs);
        if (children) {
            len = children.length;
            for(n = 0; n < len; n++)no.add($29d50c16ed06fd36$export$85c928794f8d04d4._createNode(children[n]));
        }
        return no;
    }
}
$29d50c16ed06fd36$export$85c928794f8d04d4.protoListenerMap = new Map();
$29d50c16ed06fd36$export$85c928794f8d04d4.prototype.nodeType = "Node";
$29d50c16ed06fd36$export$85c928794f8d04d4.prototype._attrsAffectingSize = [];
$29d50c16ed06fd36$export$85c928794f8d04d4.prototype.eventListeners = {};
$29d50c16ed06fd36$export$85c928794f8d04d4.prototype.on($29d50c16ed06fd36$var$TRANSFORM_CHANGE_STR, function() {
    if (this._batchingTransformChange) {
        this._needClearTransformCache = true;
        return;
    }
    this._clearCache($29d50c16ed06fd36$var$TRANSFORM);
    this._clearSelfAndDescendantCache($29d50c16ed06fd36$var$ABSOLUTE_TRANSFORM);
});
$29d50c16ed06fd36$export$85c928794f8d04d4.prototype.on("visibleChange.konva", function() {
    this._clearSelfAndDescendantCache($29d50c16ed06fd36$var$VISIBLE);
});
$29d50c16ed06fd36$export$85c928794f8d04d4.prototype.on("listeningChange.konva", function() {
    this._clearSelfAndDescendantCache($29d50c16ed06fd36$var$LISTENING);
});
$29d50c16ed06fd36$export$85c928794f8d04d4.prototype.on("opacityChange.konva", function() {
    this._clearSelfAndDescendantCache($29d50c16ed06fd36$var$ABSOLUTE_OPACITY);
});
const $29d50c16ed06fd36$var$addGetterSetter = (0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter;
$29d50c16ed06fd36$var$addGetterSetter($29d50c16ed06fd36$export$85c928794f8d04d4, "zIndex");
$29d50c16ed06fd36$var$addGetterSetter($29d50c16ed06fd36$export$85c928794f8d04d4, "absolutePosition");
$29d50c16ed06fd36$var$addGetterSetter($29d50c16ed06fd36$export$85c928794f8d04d4, "position");
$29d50c16ed06fd36$var$addGetterSetter($29d50c16ed06fd36$export$85c928794f8d04d4, "x", 0, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
$29d50c16ed06fd36$var$addGetterSetter($29d50c16ed06fd36$export$85c928794f8d04d4, "y", 0, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
$29d50c16ed06fd36$var$addGetterSetter($29d50c16ed06fd36$export$85c928794f8d04d4, "globalCompositeOperation", "source-over", (0, $dc39f19751b6eb0f$export$5837c5b6cc5b4d63)());
$29d50c16ed06fd36$var$addGetterSetter($29d50c16ed06fd36$export$85c928794f8d04d4, "opacity", 1, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
$29d50c16ed06fd36$var$addGetterSetter($29d50c16ed06fd36$export$85c928794f8d04d4, "name", "", (0, $dc39f19751b6eb0f$export$5837c5b6cc5b4d63)());
$29d50c16ed06fd36$var$addGetterSetter($29d50c16ed06fd36$export$85c928794f8d04d4, "id", "", (0, $dc39f19751b6eb0f$export$5837c5b6cc5b4d63)());
$29d50c16ed06fd36$var$addGetterSetter($29d50c16ed06fd36$export$85c928794f8d04d4, "rotation", 0, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addComponentsGetterSetter($29d50c16ed06fd36$export$85c928794f8d04d4, "scale", [
    "x",
    "y"
]);
$29d50c16ed06fd36$var$addGetterSetter($29d50c16ed06fd36$export$85c928794f8d04d4, "scaleX", 1, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
$29d50c16ed06fd36$var$addGetterSetter($29d50c16ed06fd36$export$85c928794f8d04d4, "scaleY", 1, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addComponentsGetterSetter($29d50c16ed06fd36$export$85c928794f8d04d4, "skew", [
    "x",
    "y"
]);
$29d50c16ed06fd36$var$addGetterSetter($29d50c16ed06fd36$export$85c928794f8d04d4, "skewX", 0, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
$29d50c16ed06fd36$var$addGetterSetter($29d50c16ed06fd36$export$85c928794f8d04d4, "skewY", 0, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addComponentsGetterSetter($29d50c16ed06fd36$export$85c928794f8d04d4, "offset", [
    "x",
    "y"
]);
$29d50c16ed06fd36$var$addGetterSetter($29d50c16ed06fd36$export$85c928794f8d04d4, "offsetX", 0, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
$29d50c16ed06fd36$var$addGetterSetter($29d50c16ed06fd36$export$85c928794f8d04d4, "offsetY", 0, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
$29d50c16ed06fd36$var$addGetterSetter($29d50c16ed06fd36$export$85c928794f8d04d4, "dragDistance", undefined, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
$29d50c16ed06fd36$var$addGetterSetter($29d50c16ed06fd36$export$85c928794f8d04d4, "width", 0, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
$29d50c16ed06fd36$var$addGetterSetter($29d50c16ed06fd36$export$85c928794f8d04d4, "height", 0, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
$29d50c16ed06fd36$var$addGetterSetter($29d50c16ed06fd36$export$85c928794f8d04d4, "listening", true, (0, $dc39f19751b6eb0f$export$147fc8b6cd20fda1)());
$29d50c16ed06fd36$var$addGetterSetter($29d50c16ed06fd36$export$85c928794f8d04d4, "preventDefault", true, (0, $dc39f19751b6eb0f$export$147fc8b6cd20fda1)());
$29d50c16ed06fd36$var$addGetterSetter($29d50c16ed06fd36$export$85c928794f8d04d4, "filters", undefined, function(val) {
    this._filterUpToDate = false;
    return val;
});
$29d50c16ed06fd36$var$addGetterSetter($29d50c16ed06fd36$export$85c928794f8d04d4, "visible", true, (0, $dc39f19751b6eb0f$export$147fc8b6cd20fda1)());
$29d50c16ed06fd36$var$addGetterSetter($29d50c16ed06fd36$export$85c928794f8d04d4, "transformsEnabled", "all", (0, $dc39f19751b6eb0f$export$5837c5b6cc5b4d63)());
$29d50c16ed06fd36$var$addGetterSetter($29d50c16ed06fd36$export$85c928794f8d04d4, "size");
$29d50c16ed06fd36$var$addGetterSetter($29d50c16ed06fd36$export$85c928794f8d04d4, "dragBoundFunc");
$29d50c16ed06fd36$var$addGetterSetter($29d50c16ed06fd36$export$85c928794f8d04d4, "draggable", false, (0, $dc39f19751b6eb0f$export$147fc8b6cd20fda1)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).backCompat($29d50c16ed06fd36$export$85c928794f8d04d4, {
    rotateDeg: "rotate",
    setRotationDeg: "setRotation",
    getRotationDeg: "getRotation"
});





class $e95078a0a7406ae2$export$42a852a2b6b56249 extends (0, $29d50c16ed06fd36$export$85c928794f8d04d4) {
    constructor(){
        super(...arguments);
        this.children = [];
    }
    getChildren(filterFunc) {
        const children = this.children || [];
        if (filterFunc) return children.filter(filterFunc);
        return children;
    }
    hasChildren() {
        return this.getChildren().length > 0;
    }
    removeChildren() {
        this.getChildren().forEach((child)=>{
            child.parent = null;
            child.index = 0;
            child.remove();
        });
        this.children = [];
        this._requestDraw();
        return this;
    }
    destroyChildren() {
        this.getChildren().forEach((child)=>{
            child.parent = null;
            child.index = 0;
            child.destroy();
        });
        this.children = [];
        this._requestDraw();
        return this;
    }
    add(...children) {
        if (children.length === 0) return this;
        if (children.length > 1) {
            for(let i = 0; i < children.length; i++)this.add(children[i]);
            return this;
        }
        const child = children[0];
        if (child.getParent()) {
            child.moveTo(this);
            return this;
        }
        this._validateAdd(child);
        child.index = this.getChildren().length;
        child.parent = this;
        child._clearCaches();
        this.getChildren().push(child);
        this._fire("add", {
            child: child
        });
        this._requestDraw();
        return this;
    }
    destroy() {
        if (this.hasChildren()) this.destroyChildren();
        super.destroy();
        return this;
    }
    find(selector) {
        return this._generalFind(selector, false);
    }
    findOne(selector) {
        const result = this._generalFind(selector, true);
        return result.length > 0 ? result[0] : undefined;
    }
    _generalFind(selector, findOne) {
        const retArr = [];
        this._descendants((node)=>{
            const valid = node._isMatch(selector);
            if (valid) retArr.push(node);
            if (valid && findOne) return true;
            return false;
        });
        return retArr;
    }
    _descendants(fn) {
        let shouldStop = false;
        const children = this.getChildren();
        for (const child of children){
            shouldStop = fn(child);
            if (shouldStop) return true;
            if (!child.hasChildren()) continue;
            shouldStop = child._descendants(fn);
            if (shouldStop) return true;
        }
        return false;
    }
    toObject() {
        const obj = (0, $29d50c16ed06fd36$export$85c928794f8d04d4).prototype.toObject.call(this);
        obj.children = [];
        this.getChildren().forEach((child)=>{
            obj.children.push(child.toObject());
        });
        return obj;
    }
    isAncestorOf(node) {
        let parent = node.getParent();
        while(parent){
            if (parent._id === this._id) return true;
            parent = parent.getParent();
        }
        return false;
    }
    clone(obj) {
        const node = (0, $29d50c16ed06fd36$export$85c928794f8d04d4).prototype.clone.call(this, obj);
        this.getChildren().forEach(function(no) {
            node.add(no.clone());
        });
        return node;
    }
    getAllIntersections(pos) {
        const arr = [];
        this.find("Shape").forEach((shape)=>{
            if (shape.isVisible() && shape.intersects(pos)) arr.push(shape);
        });
        return arr;
    }
    _clearSelfAndDescendantCache(attr) {
        var _a;
        super._clearSelfAndDescendantCache(attr);
        if (this.isCached()) return;
        (_a = this.children) === null || _a === void 0 || _a.forEach(function(node) {
            node._clearSelfAndDescendantCache(attr);
        });
    }
    _setChildrenIndices() {
        var _a;
        (_a = this.children) === null || _a === void 0 || _a.forEach(function(child, n) {
            child.index = n;
        });
        this._requestDraw();
    }
    drawScene(can, top, bufferCanvas) {
        const layer = this.getLayer(), canvas = can || layer && layer.getCanvas(), context = canvas && canvas.getContext(), cachedCanvas = this._getCanvasCache(), cachedSceneCanvas = cachedCanvas && cachedCanvas.scene;
        const caching = canvas && canvas.isCache;
        if (!this.isVisible() && !caching) return this;
        if (cachedSceneCanvas) {
            context.save();
            const m = this.getAbsoluteTransform(top).getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            this._drawCachedSceneCanvas(context);
            context.restore();
        } else this._drawChildren("drawScene", canvas, top, bufferCanvas);
        return this;
    }
    drawHit(can, top) {
        if (!this.shouldDrawHit(top)) return this;
        const layer = this.getLayer(), canvas = can || layer && layer.hitCanvas, context = canvas && canvas.getContext(), cachedCanvas = this._getCanvasCache(), cachedHitCanvas = cachedCanvas && cachedCanvas.hit;
        if (cachedHitCanvas) {
            context.save();
            const m = this.getAbsoluteTransform(top).getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            this._drawCachedHitCanvas(context);
            context.restore();
        } else this._drawChildren("drawHit", canvas, top);
        return this;
    }
    _drawChildren(drawMethod, canvas, top, bufferCanvas) {
        var _a;
        const context = canvas && canvas.getContext(), clipWidth = this.clipWidth(), clipHeight = this.clipHeight(), clipFunc = this.clipFunc(), hasClip = typeof clipWidth === "number" && typeof clipHeight === "number" || clipFunc;
        const selfCache = top === this;
        if (hasClip) {
            context.save();
            const transform = this.getAbsoluteTransform(top);
            let m = transform.getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            context.beginPath();
            let clipArgs;
            if (clipFunc) clipArgs = clipFunc.call(this, context, this);
            else {
                const clipX = this.clipX();
                const clipY = this.clipY();
                context.rect(clipX || 0, clipY || 0, clipWidth, clipHeight);
            }
            context.clip.apply(context, clipArgs);
            m = transform.copy().invert().getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
        }
        const hasComposition = !selfCache && this.globalCompositeOperation() !== "source-over" && drawMethod === "drawScene";
        if (hasComposition) {
            context.save();
            context._applyGlobalCompositeOperation(this);
        }
        (_a = this.children) === null || _a === void 0 || _a.forEach(function(child) {
            child[drawMethod](canvas, top, bufferCanvas);
        });
        if (hasComposition) context.restore();
        if (hasClip) context.restore();
    }
    getClientRect(config = {}) {
        var _a;
        const skipTransform = config.skipTransform;
        const relativeTo = config.relativeTo;
        let minX, minY, maxX, maxY;
        let selfRect = {
            x: Infinity,
            y: Infinity,
            width: 0,
            height: 0
        };
        const that = this;
        (_a = this.children) === null || _a === void 0 || _a.forEach(function(child) {
            if (!child.visible()) return;
            const rect = child.getClientRect({
                relativeTo: that,
                skipShadow: config.skipShadow,
                skipStroke: config.skipStroke
            });
            if (rect.width === 0 && rect.height === 0) return;
            if (minX === undefined) {
                minX = rect.x;
                minY = rect.y;
                maxX = rect.x + rect.width;
                maxY = rect.y + rect.height;
            } else {
                minX = Math.min(minX, rect.x);
                minY = Math.min(minY, rect.y);
                maxX = Math.max(maxX, rect.x + rect.width);
                maxY = Math.max(maxY, rect.y + rect.height);
            }
        });
        const shapes = this.find("Shape");
        let hasVisible = false;
        for(let i = 0; i < shapes.length; i++){
            const shape = shapes[i];
            if (shape._isVisible(this)) {
                hasVisible = true;
                break;
            }
        }
        if (hasVisible && minX !== undefined) selfRect = {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
        else selfRect = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
        if (!skipTransform) return this._transformedRect(selfRect, relativeTo);
        return selfRect;
    }
}
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addComponentsGetterSetter($e95078a0a7406ae2$export$42a852a2b6b56249, "clip", [
    "x",
    "y",
    "width",
    "height"
]);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($e95078a0a7406ae2$export$42a852a2b6b56249, "clipX", undefined, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($e95078a0a7406ae2$export$42a852a2b6b56249, "clipY", undefined, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($e95078a0a7406ae2$export$42a852a2b6b56249, "clipWidth", undefined, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($e95078a0a7406ae2$export$42a852a2b6b56249, "clipHeight", undefined, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($e95078a0a7406ae2$export$42a852a2b6b56249, "clipFunc");









const $688ce46e8c7c90ce$var$Captures = new Map();
const $688ce46e8c7c90ce$var$SUPPORT_POINTER_EVENTS = (0, $bd77714a0ea3dd4d$export$b9f99057a3c7692)._global["PointerEvent"] !== undefined;
function $688ce46e8c7c90ce$export$a55e3aaa85f15b00(pointerId) {
    return $688ce46e8c7c90ce$var$Captures.get(pointerId);
}
function $688ce46e8c7c90ce$export$c30017717ce2168e(evt) {
    return {
        evt: evt,
        pointerId: evt.pointerId
    };
}
function $688ce46e8c7c90ce$export$3b42bc7c43025bad(pointerId, shape) {
    return $688ce46e8c7c90ce$var$Captures.get(pointerId) === shape;
}
function $688ce46e8c7c90ce$export$1cab177b65f17c5a(pointerId, shape) {
    $688ce46e8c7c90ce$export$50f687f23c43e4d9(pointerId);
    const stage = shape.getStage();
    if (!stage) return;
    $688ce46e8c7c90ce$var$Captures.set(pointerId, shape);
    if ($688ce46e8c7c90ce$var$SUPPORT_POINTER_EVENTS) shape._fire("gotpointercapture", $688ce46e8c7c90ce$export$c30017717ce2168e(new PointerEvent("gotpointercapture")));
}
function $688ce46e8c7c90ce$export$50f687f23c43e4d9(pointerId, target) {
    const shape = $688ce46e8c7c90ce$var$Captures.get(pointerId);
    if (!shape) return;
    const stage = shape.getStage();
    stage && stage.content;
    $688ce46e8c7c90ce$var$Captures.delete(pointerId);
    if ($688ce46e8c7c90ce$var$SUPPORT_POINTER_EVENTS) shape._fire("lostpointercapture", $688ce46e8c7c90ce$export$c30017717ce2168e(new PointerEvent("lostpointercapture")));
}


const $fd163e62a715a165$var$STAGE = "Stage", $fd163e62a715a165$var$STRING = "string", $fd163e62a715a165$var$PX = "px", $fd163e62a715a165$var$MOUSEOUT = "mouseout", $fd163e62a715a165$var$MOUSELEAVE = "mouseleave", $fd163e62a715a165$var$MOUSEOVER = "mouseover", $fd163e62a715a165$var$MOUSEENTER = "mouseenter", $fd163e62a715a165$var$MOUSEMOVE = "mousemove", $fd163e62a715a165$var$MOUSEDOWN = "mousedown", $fd163e62a715a165$var$MOUSEUP = "mouseup", $fd163e62a715a165$var$POINTERMOVE = "pointermove", $fd163e62a715a165$var$POINTERDOWN = "pointerdown", $fd163e62a715a165$var$POINTERUP = "pointerup", $fd163e62a715a165$var$POINTERCANCEL = "pointercancel", $fd163e62a715a165$var$LOSTPOINTERCAPTURE = "lostpointercapture", $fd163e62a715a165$var$POINTEROUT = "pointerout", $fd163e62a715a165$var$POINTERLEAVE = "pointerleave", $fd163e62a715a165$var$POINTEROVER = "pointerover", $fd163e62a715a165$var$POINTERENTER = "pointerenter", $fd163e62a715a165$var$CONTEXTMENU = "contextmenu", $fd163e62a715a165$var$TOUCHSTART = "touchstart", $fd163e62a715a165$var$TOUCHEND = "touchend", $fd163e62a715a165$var$TOUCHMOVE = "touchmove", $fd163e62a715a165$var$TOUCHCANCEL = "touchcancel", $fd163e62a715a165$var$WHEEL = "wheel", $fd163e62a715a165$var$MAX_LAYERS_NUMBER = 5, $fd163e62a715a165$var$EVENTS = [
    [
        $fd163e62a715a165$var$MOUSEENTER,
        "_pointerenter"
    ],
    [
        $fd163e62a715a165$var$MOUSEDOWN,
        "_pointerdown"
    ],
    [
        $fd163e62a715a165$var$MOUSEMOVE,
        "_pointermove"
    ],
    [
        $fd163e62a715a165$var$MOUSEUP,
        "_pointerup"
    ],
    [
        $fd163e62a715a165$var$MOUSELEAVE,
        "_pointerleave"
    ],
    [
        $fd163e62a715a165$var$TOUCHSTART,
        "_pointerdown"
    ],
    [
        $fd163e62a715a165$var$TOUCHMOVE,
        "_pointermove"
    ],
    [
        $fd163e62a715a165$var$TOUCHEND,
        "_pointerup"
    ],
    [
        $fd163e62a715a165$var$TOUCHCANCEL,
        "_pointercancel"
    ],
    [
        $fd163e62a715a165$var$MOUSEOVER,
        "_pointerover"
    ],
    [
        $fd163e62a715a165$var$WHEEL,
        "_wheel"
    ],
    [
        $fd163e62a715a165$var$CONTEXTMENU,
        "_contextmenu"
    ],
    [
        $fd163e62a715a165$var$POINTERDOWN,
        "_pointerdown"
    ],
    [
        $fd163e62a715a165$var$POINTERMOVE,
        "_pointermove"
    ],
    [
        $fd163e62a715a165$var$POINTERUP,
        "_pointerup"
    ],
    [
        $fd163e62a715a165$var$POINTERCANCEL,
        "_pointercancel"
    ],
    [
        $fd163e62a715a165$var$POINTERLEAVE,
        "_pointerleave"
    ],
    [
        $fd163e62a715a165$var$LOSTPOINTERCAPTURE,
        "_lostpointercapture"
    ]
];
const $fd163e62a715a165$var$EVENTS_MAP = {
    mouse: {
        [$fd163e62a715a165$var$POINTEROUT]: $fd163e62a715a165$var$MOUSEOUT,
        [$fd163e62a715a165$var$POINTERLEAVE]: $fd163e62a715a165$var$MOUSELEAVE,
        [$fd163e62a715a165$var$POINTEROVER]: $fd163e62a715a165$var$MOUSEOVER,
        [$fd163e62a715a165$var$POINTERENTER]: $fd163e62a715a165$var$MOUSEENTER,
        [$fd163e62a715a165$var$POINTERMOVE]: $fd163e62a715a165$var$MOUSEMOVE,
        [$fd163e62a715a165$var$POINTERDOWN]: $fd163e62a715a165$var$MOUSEDOWN,
        [$fd163e62a715a165$var$POINTERUP]: $fd163e62a715a165$var$MOUSEUP,
        [$fd163e62a715a165$var$POINTERCANCEL]: "mousecancel",
        pointerclick: "click",
        pointerdblclick: "dblclick"
    },
    touch: {
        [$fd163e62a715a165$var$POINTEROUT]: "touchout",
        [$fd163e62a715a165$var$POINTERLEAVE]: "touchleave",
        [$fd163e62a715a165$var$POINTEROVER]: "touchover",
        [$fd163e62a715a165$var$POINTERENTER]: "touchenter",
        [$fd163e62a715a165$var$POINTERMOVE]: $fd163e62a715a165$var$TOUCHMOVE,
        [$fd163e62a715a165$var$POINTERDOWN]: $fd163e62a715a165$var$TOUCHSTART,
        [$fd163e62a715a165$var$POINTERUP]: $fd163e62a715a165$var$TOUCHEND,
        [$fd163e62a715a165$var$POINTERCANCEL]: $fd163e62a715a165$var$TOUCHCANCEL,
        pointerclick: "tap",
        pointerdblclick: "dbltap"
    },
    pointer: {
        [$fd163e62a715a165$var$POINTEROUT]: $fd163e62a715a165$var$POINTEROUT,
        [$fd163e62a715a165$var$POINTERLEAVE]: $fd163e62a715a165$var$POINTERLEAVE,
        [$fd163e62a715a165$var$POINTEROVER]: $fd163e62a715a165$var$POINTEROVER,
        [$fd163e62a715a165$var$POINTERENTER]: $fd163e62a715a165$var$POINTERENTER,
        [$fd163e62a715a165$var$POINTERMOVE]: $fd163e62a715a165$var$POINTERMOVE,
        [$fd163e62a715a165$var$POINTERDOWN]: $fd163e62a715a165$var$POINTERDOWN,
        [$fd163e62a715a165$var$POINTERUP]: $fd163e62a715a165$var$POINTERUP,
        [$fd163e62a715a165$var$POINTERCANCEL]: $fd163e62a715a165$var$POINTERCANCEL,
        pointerclick: "pointerclick",
        pointerdblclick: "pointerdblclick"
    }
};
const $fd163e62a715a165$var$getEventType = (type)=>{
    if (type.indexOf("pointer") >= 0) return "pointer";
    if (type.indexOf("touch") >= 0) return "touch";
    return "mouse";
};
const $fd163e62a715a165$var$getEventsMap = (eventType)=>{
    const type = $fd163e62a715a165$var$getEventType(eventType);
    if (type === "pointer") return (0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).pointerEventsEnabled && $fd163e62a715a165$var$EVENTS_MAP.pointer;
    if (type === "touch") return $fd163e62a715a165$var$EVENTS_MAP.touch;
    if (type === "mouse") return $fd163e62a715a165$var$EVENTS_MAP.mouse;
};
function $fd163e62a715a165$var$checkNoClip(attrs = {}) {
    if (attrs.clipFunc || attrs.clipWidth || attrs.clipHeight) (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).warn("Stage does not support clipping. Please use clip for Layers or Groups.");
    return attrs;
}
const $fd163e62a715a165$var$NO_POINTERS_MESSAGE = `Pointer position is missing and not registered by the stage. Looks like it is outside of the stage container. You can set it manually from event: stage.setPointersPositions(event);`;
const $fd163e62a715a165$export$1bfcff8d7c4bf05 = [];
class $fd163e62a715a165$export$208cd1682bd0e4b6 extends (0, $e95078a0a7406ae2$export$42a852a2b6b56249) {
    constructor(config){
        super($fd163e62a715a165$var$checkNoClip(config));
        this._pointerPositions = [];
        this._changedPointerPositions = [];
        this._buildDOM();
        this._bindContentEvents();
        $fd163e62a715a165$export$1bfcff8d7c4bf05.push(this);
        this.on("widthChange.konva heightChange.konva", this._resizeDOM);
        this.on("visibleChange.konva", this._checkVisibility);
        this.on("clipWidthChange.konva clipHeightChange.konva clipFuncChange.konva", ()=>{
            $fd163e62a715a165$var$checkNoClip(this.attrs);
        });
        this._checkVisibility();
    }
    _validateAdd(child) {
        const isLayer = child.getType() === "Layer";
        const isFastLayer = child.getType() === "FastLayer";
        const valid = isLayer || isFastLayer;
        if (!valid) (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).throw("You may only add layers to the stage.");
    }
    _checkVisibility() {
        if (!this.content) return;
        const style = this.visible() ? "" : "none";
        this.content.style.display = style;
    }
    setContainer(container) {
        if (typeof container === $fd163e62a715a165$var$STRING) {
            let id;
            if (container.charAt(0) === ".") {
                const className = container.slice(1);
                container = document.getElementsByClassName(className)[0];
            } else {
                if (container.charAt(0) !== "#") id = container;
                else id = container.slice(1);
                container = document.getElementById(id);
            }
            if (!container) throw "Can not find container in document with id " + id;
        }
        this._setAttr("container", container);
        if (this.content) {
            if (this.content.parentElement) this.content.parentElement.removeChild(this.content);
            container.appendChild(this.content);
        }
        return this;
    }
    shouldDrawHit() {
        return true;
    }
    clear() {
        const layers = this.children, len = layers.length;
        for(let n = 0; n < len; n++)layers[n].clear();
        return this;
    }
    clone(obj) {
        if (!obj) obj = {};
        obj.container = typeof document !== "undefined" && document.createElement("div");
        return (0, $e95078a0a7406ae2$export$42a852a2b6b56249).prototype.clone.call(this, obj);
    }
    destroy() {
        super.destroy();
        const content = this.content;
        if (content && (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._isInDocument(content)) this.container().removeChild(content);
        const index = $fd163e62a715a165$export$1bfcff8d7c4bf05.indexOf(this);
        if (index > -1) $fd163e62a715a165$export$1bfcff8d7c4bf05.splice(index, 1);
        (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).releaseCanvas(this.bufferCanvas._canvas, this.bufferHitCanvas._canvas);
        return this;
    }
    getPointerPosition() {
        const pos = this._pointerPositions[0] || this._changedPointerPositions[0];
        if (!pos) {
            (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).warn($fd163e62a715a165$var$NO_POINTERS_MESSAGE);
            return null;
        }
        return {
            x: pos.x,
            y: pos.y
        };
    }
    _getPointerById(id) {
        return this._pointerPositions.find((p)=>p.id === id);
    }
    getPointersPositions() {
        return this._pointerPositions;
    }
    getStage() {
        return this;
    }
    getContent() {
        return this.content;
    }
    _toKonvaCanvas(config) {
        config = {
            ...config
        };
        config.x = config.x || 0;
        config.y = config.y || 0;
        config.width = config.width || this.width();
        config.height = config.height || this.height();
        const canvas = new (0, $e3f0e6aa12a16394$export$ee612225bd2e63be)({
            width: config.width,
            height: config.height,
            pixelRatio: config.pixelRatio || 1
        });
        const _context = canvas.getContext()._context;
        const layers = this.children;
        if (config.x || config.y) _context.translate(-1 * config.x, -1 * config.y);
        layers.forEach(function(layer) {
            if (!layer.isVisible()) return;
            const layerCanvas = layer._toKonvaCanvas(config);
            _context.drawImage(layerCanvas._canvas, config.x, config.y, layerCanvas.getWidth() / layerCanvas.getPixelRatio(), layerCanvas.getHeight() / layerCanvas.getPixelRatio());
        });
        return canvas;
    }
    getIntersection(pos) {
        if (!pos) return null;
        const layers = this.children, len = layers.length, end = len - 1;
        for(let n = end; n >= 0; n--){
            const shape = layers[n].getIntersection(pos);
            if (shape) return shape;
        }
        return null;
    }
    _resizeDOM() {
        const width = this.width();
        const height = this.height();
        if (this.content) {
            this.content.style.width = width + $fd163e62a715a165$var$PX;
            this.content.style.height = height + $fd163e62a715a165$var$PX;
        }
        this.bufferCanvas.setSize(width, height);
        this.bufferHitCanvas.setSize(width, height);
        this.children.forEach((layer)=>{
            layer.setSize({
                width: width,
                height: height
            });
            layer.draw();
        });
    }
    add(layer, ...rest) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.add(arguments[i]);
            return this;
        }
        super.add(layer);
        const length = this.children.length;
        if (length > $fd163e62a715a165$var$MAX_LAYERS_NUMBER) (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).warn("The stage has " + length + " layers. Recommended maximum number of layers is 3-5. Adding more layers into the stage may drop the performance. Rethink your tree structure, you can use Konva.Group.");
        layer.setSize({
            width: this.width(),
            height: this.height()
        });
        layer.draw();
        if ((0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).isBrowser) this.content.appendChild(layer.canvas._canvas);
        return this;
    }
    getParent() {
        return null;
    }
    getLayer() {
        return null;
    }
    hasPointerCapture(pointerId) {
        return $688ce46e8c7c90ce$export$3b42bc7c43025bad(pointerId, this);
    }
    setPointerCapture(pointerId) {
        $688ce46e8c7c90ce$export$1cab177b65f17c5a(pointerId, this);
    }
    releaseCapture(pointerId) {
        $688ce46e8c7c90ce$export$50f687f23c43e4d9(pointerId, this);
    }
    getLayers() {
        return this.children;
    }
    _bindContentEvents() {
        if (!(0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).isBrowser) return;
        $fd163e62a715a165$var$EVENTS.forEach(([event, methodName])=>{
            this.content.addEventListener(event, (evt)=>{
                this[methodName](evt);
            }, {
                passive: false
            });
        });
    }
    _pointerenter(evt) {
        this.setPointersPositions(evt);
        const events = $fd163e62a715a165$var$getEventsMap(evt.type);
        if (events) this._fire(events.pointerenter, {
            evt: evt,
            target: this,
            currentTarget: this
        });
    }
    _pointerover(evt) {
        this.setPointersPositions(evt);
        const events = $fd163e62a715a165$var$getEventsMap(evt.type);
        if (events) this._fire(events.pointerover, {
            evt: evt,
            target: this,
            currentTarget: this
        });
    }
    _getTargetShape(evenType) {
        let shape = this[evenType + "targetShape"];
        if (shape && !shape.getStage()) shape = null;
        return shape;
    }
    _pointerleave(evt) {
        const events = $fd163e62a715a165$var$getEventsMap(evt.type);
        const eventType = $fd163e62a715a165$var$getEventType(evt.type);
        if (!events) return;
        this.setPointersPositions(evt);
        const targetShape = this._getTargetShape(eventType);
        const eventsEnabled = !((0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).isDragging() || (0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).isTransforming()) || (0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).hitOnDragEnabled;
        if (targetShape && eventsEnabled) {
            targetShape._fireAndBubble(events.pointerout, {
                evt: evt
            });
            targetShape._fireAndBubble(events.pointerleave, {
                evt: evt
            });
            this._fire(events.pointerleave, {
                evt: evt,
                target: this,
                currentTarget: this
            });
            this[eventType + "targetShape"] = null;
        } else if (eventsEnabled) {
            this._fire(events.pointerleave, {
                evt: evt,
                target: this,
                currentTarget: this
            });
            this._fire(events.pointerout, {
                evt: evt,
                target: this,
                currentTarget: this
            });
        }
        this.pointerPos = null;
        this._pointerPositions = [];
    }
    _pointerdown(evt) {
        const events = $fd163e62a715a165$var$getEventsMap(evt.type);
        const eventType = $fd163e62a715a165$var$getEventType(evt.type);
        if (!events) return;
        this.setPointersPositions(evt);
        let triggeredOnShape = false;
        this._changedPointerPositions.forEach((pos)=>{
            const shape = this.getIntersection(pos);
            (0, $5801123e8d1755fa$export$e34f1b340034d7f).justDragged = false;
            (0, $bd77714a0ea3dd4d$export$b9f99057a3c7692)["_" + eventType + "ListenClick"] = true;
            if (!shape || !shape.isListening()) {
                this[eventType + "ClickStartShape"] = undefined;
                return;
            }
            if ((0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).capturePointerEventsEnabled) shape.setPointerCapture(pos.id);
            this[eventType + "ClickStartShape"] = shape;
            shape._fireAndBubble(events.pointerdown, {
                evt: evt,
                pointerId: pos.id
            });
            triggeredOnShape = true;
            const isTouch = evt.type.indexOf("touch") >= 0;
            if (shape.preventDefault() && evt.cancelable && isTouch) evt.preventDefault();
        });
        if (!triggeredOnShape) this._fire(events.pointerdown, {
            evt: evt,
            target: this,
            currentTarget: this,
            pointerId: this._pointerPositions[0].id
        });
    }
    _pointermove(evt) {
        const events = $fd163e62a715a165$var$getEventsMap(evt.type);
        const eventType = $fd163e62a715a165$var$getEventType(evt.type);
        if (!events) return;
        const isTouchPointer = evt.type.indexOf("touch") >= 0 || evt.pointerType === "touch";
        if ((0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).isDragging() && (0, $5801123e8d1755fa$export$e34f1b340034d7f).node.preventDefault() && evt.cancelable && isTouchPointer) evt.preventDefault();
        this.setPointersPositions(evt);
        const eventsEnabled = !((0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).isDragging() || (0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).isTransforming()) || (0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).hitOnDragEnabled;
        if (!eventsEnabled) return;
        const processedShapesIds = {};
        let triggeredOnShape = false;
        const targetShape = this._getTargetShape(eventType);
        this._changedPointerPositions.forEach((pos)=>{
            const shape = $688ce46e8c7c90ce$export$a55e3aaa85f15b00(pos.id) || this.getIntersection(pos);
            const pointerId = pos.id;
            const event = {
                evt: evt,
                pointerId: pointerId
            };
            const differentTarget = targetShape !== shape;
            if (differentTarget && targetShape) {
                targetShape._fireAndBubble(events.pointerout, {
                    ...event
                }, shape);
                targetShape._fireAndBubble(events.pointerleave, {
                    ...event
                }, shape);
            }
            if (shape) {
                if (processedShapesIds[shape._id]) return;
                processedShapesIds[shape._id] = true;
            }
            if (shape && shape.isListening()) {
                triggeredOnShape = true;
                if (differentTarget) {
                    shape._fireAndBubble(events.pointerover, {
                        ...event
                    }, targetShape);
                    shape._fireAndBubble(events.pointerenter, {
                        ...event
                    }, targetShape);
                    this[eventType + "targetShape"] = shape;
                }
                shape._fireAndBubble(events.pointermove, {
                    ...event
                });
            } else if (targetShape) {
                this._fire(events.pointerover, {
                    evt: evt,
                    target: this,
                    currentTarget: this,
                    pointerId: pointerId
                });
                this[eventType + "targetShape"] = null;
            }
        });
        if (!triggeredOnShape) this._fire(events.pointermove, {
            evt: evt,
            target: this,
            currentTarget: this,
            pointerId: this._changedPointerPositions[0].id
        });
    }
    _pointerup(evt) {
        const events = $fd163e62a715a165$var$getEventsMap(evt.type);
        const eventType = $fd163e62a715a165$var$getEventType(evt.type);
        if (!events) return;
        this.setPointersPositions(evt);
        const clickStartShape = this[eventType + "ClickStartShape"];
        const clickEndShape = this[eventType + "ClickEndShape"];
        const processedShapesIds = {};
        let skipPointerUpTrigger = false;
        this._changedPointerPositions.forEach((pos)=>{
            const shape = $688ce46e8c7c90ce$export$a55e3aaa85f15b00(pos.id) || this.getIntersection(pos);
            if (shape) {
                shape.releaseCapture(pos.id);
                if (processedShapesIds[shape._id]) return;
                processedShapesIds[shape._id] = true;
            }
            const pointerId = pos.id;
            const event = {
                evt: evt,
                pointerId: pointerId
            };
            let fireDblClick = false;
            if ((0, $bd77714a0ea3dd4d$export$b9f99057a3c7692)["_" + eventType + "InDblClickWindow"]) {
                fireDblClick = true;
                clearTimeout(this[eventType + "DblTimeout"]);
            } else if (!(0, $5801123e8d1755fa$export$e34f1b340034d7f).justDragged) {
                (0, $bd77714a0ea3dd4d$export$b9f99057a3c7692)["_" + eventType + "InDblClickWindow"] = true;
                clearTimeout(this[eventType + "DblTimeout"]);
            }
            this[eventType + "DblTimeout"] = setTimeout(function() {
                (0, $bd77714a0ea3dd4d$export$b9f99057a3c7692)["_" + eventType + "InDblClickWindow"] = false;
            }, (0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).dblClickWindow);
            if (shape && shape.isListening()) {
                skipPointerUpTrigger = true;
                this[eventType + "ClickEndShape"] = shape;
                shape._fireAndBubble(events.pointerup, {
                    ...event
                });
                if ((0, $bd77714a0ea3dd4d$export$b9f99057a3c7692)["_" + eventType + "ListenClick"] && clickStartShape && clickStartShape === shape) {
                    shape._fireAndBubble(events.pointerclick, {
                        ...event
                    });
                    if (fireDblClick && clickEndShape && clickEndShape === shape) shape._fireAndBubble(events.pointerdblclick, {
                        ...event
                    });
                }
            } else {
                this[eventType + "ClickEndShape"] = null;
                if (!skipPointerUpTrigger) {
                    this._fire(events.pointerup, {
                        evt: evt,
                        target: this,
                        currentTarget: this,
                        pointerId: this._changedPointerPositions[0].id
                    });
                    skipPointerUpTrigger = true;
                }
                if ((0, $bd77714a0ea3dd4d$export$b9f99057a3c7692)["_" + eventType + "ListenClick"]) this._fire(events.pointerclick, {
                    evt: evt,
                    target: this,
                    currentTarget: this,
                    pointerId: pointerId
                });
                if (fireDblClick) this._fire(events.pointerdblclick, {
                    evt: evt,
                    target: this,
                    currentTarget: this,
                    pointerId: pointerId
                });
            }
        });
        if (!skipPointerUpTrigger) this._fire(events.pointerup, {
            evt: evt,
            target: this,
            currentTarget: this,
            pointerId: this._changedPointerPositions[0].id
        });
        (0, $bd77714a0ea3dd4d$export$b9f99057a3c7692)["_" + eventType + "ListenClick"] = false;
        if (evt.cancelable && eventType !== "touch" && eventType !== "pointer") evt.preventDefault();
    }
    _contextmenu(evt) {
        this.setPointersPositions(evt);
        const shape = this.getIntersection(this.getPointerPosition());
        if (shape && shape.isListening()) shape._fireAndBubble($fd163e62a715a165$var$CONTEXTMENU, {
            evt: evt
        });
        else this._fire($fd163e62a715a165$var$CONTEXTMENU, {
            evt: evt,
            target: this,
            currentTarget: this
        });
    }
    _wheel(evt) {
        this.setPointersPositions(evt);
        const shape = this.getIntersection(this.getPointerPosition());
        if (shape && shape.isListening()) shape._fireAndBubble($fd163e62a715a165$var$WHEEL, {
            evt: evt
        });
        else this._fire($fd163e62a715a165$var$WHEEL, {
            evt: evt,
            target: this,
            currentTarget: this
        });
    }
    _pointercancel(evt) {
        this.setPointersPositions(evt);
        const shape = $688ce46e8c7c90ce$export$a55e3aaa85f15b00(evt.pointerId) || this.getIntersection(this.getPointerPosition());
        if (shape) shape._fireAndBubble($fd163e62a715a165$var$POINTERUP, $688ce46e8c7c90ce$export$c30017717ce2168e(evt));
        $688ce46e8c7c90ce$export$50f687f23c43e4d9(evt.pointerId);
    }
    _lostpointercapture(evt) {
        $688ce46e8c7c90ce$export$50f687f23c43e4d9(evt.pointerId);
    }
    setPointersPositions(evt) {
        const contentPosition = this._getContentPosition();
        let x = null, y = null;
        evt = evt ? evt : window.event;
        if (evt.touches !== undefined) {
            this._pointerPositions = [];
            this._changedPointerPositions = [];
            Array.prototype.forEach.call(evt.touches, (touch)=>{
                this._pointerPositions.push({
                    id: touch.identifier,
                    x: (touch.clientX - contentPosition.left) / contentPosition.scaleX,
                    y: (touch.clientY - contentPosition.top) / contentPosition.scaleY
                });
            });
            Array.prototype.forEach.call(evt.changedTouches || evt.touches, (touch)=>{
                this._changedPointerPositions.push({
                    id: touch.identifier,
                    x: (touch.clientX - contentPosition.left) / contentPosition.scaleX,
                    y: (touch.clientY - contentPosition.top) / contentPosition.scaleY
                });
            });
        } else {
            x = (evt.clientX - contentPosition.left) / contentPosition.scaleX;
            y = (evt.clientY - contentPosition.top) / contentPosition.scaleY;
            this.pointerPos = {
                x: x,
                y: y
            };
            this._pointerPositions = [
                {
                    x: x,
                    y: y,
                    id: (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._getFirstPointerId(evt)
                }
            ];
            this._changedPointerPositions = [
                {
                    x: x,
                    y: y,
                    id: (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._getFirstPointerId(evt)
                }
            ];
        }
    }
    _setPointerPosition(evt) {
        (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).warn('Method _setPointerPosition is deprecated. Use "stage.setPointersPositions(event)" instead.');
        this.setPointersPositions(evt);
    }
    _getContentPosition() {
        if (!this.content || !this.content.getBoundingClientRect) return {
            top: 0,
            left: 0,
            scaleX: 1,
            scaleY: 1
        };
        const rect = this.content.getBoundingClientRect();
        return {
            top: rect.top,
            left: rect.left,
            scaleX: rect.width / this.content.clientWidth || 1,
            scaleY: rect.height / this.content.clientHeight || 1
        };
    }
    _buildDOM() {
        this.bufferCanvas = new (0, $e3f0e6aa12a16394$export$ee612225bd2e63be)({
            width: this.width(),
            height: this.height()
        });
        this.bufferHitCanvas = new (0, $e3f0e6aa12a16394$export$43a2e1456e27dc84)({
            pixelRatio: 1,
            width: this.width(),
            height: this.height()
        });
        if (!(0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).isBrowser) return;
        const container = this.container();
        if (!container) throw "Stage has no container. A container is required.";
        container.innerHTML = "";
        this.content = document.createElement("div");
        this.content.style.position = "relative";
        this.content.style.userSelect = "none";
        this.content.className = "konvajs-content";
        this.content.setAttribute("role", "presentation");
        container.appendChild(this.content);
        this._resizeDOM();
    }
    cache() {
        (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).warn("Cache function is not allowed for stage. You may use cache only for layers, groups and shapes.");
        return this;
    }
    clearCache() {
        return this;
    }
    batchDraw() {
        this.getChildren().forEach(function(layer) {
            layer.batchDraw();
        });
        return this;
    }
}
$fd163e62a715a165$export$208cd1682bd0e4b6.prototype.nodeType = $fd163e62a715a165$var$STAGE;
(0, $bd77714a0ea3dd4d$export$f7a70d87a5e829eb)($fd163e62a715a165$export$208cd1682bd0e4b6);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($fd163e62a715a165$export$208cd1682bd0e4b6, "container");
if ((0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).isBrowser) document.addEventListener("visibilitychange", ()=>{
    $fd163e62a715a165$export$1bfcff8d7c4bf05.forEach((stage)=>{
        stage.batchDraw();
    });
});














const $dfc94508c89c186c$var$HAS_SHADOW = "hasShadow";
const $dfc94508c89c186c$var$SHADOW_RGBA = "shadowRGBA";
const $dfc94508c89c186c$var$patternImage = "patternImage";
const $dfc94508c89c186c$var$linearGradient = "linearGradient";
const $dfc94508c89c186c$var$radialGradient = "radialGradient";
let $dfc94508c89c186c$var$dummyContext;
function $dfc94508c89c186c$var$getDummyContext() {
    if ($dfc94508c89c186c$var$dummyContext) return $dfc94508c89c186c$var$dummyContext;
    $dfc94508c89c186c$var$dummyContext = (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).createCanvasElement().getContext("2d");
    return $dfc94508c89c186c$var$dummyContext;
}
const $dfc94508c89c186c$export$4ff7fc6f1af248b5 = {};
function $dfc94508c89c186c$var$_fillFunc(context) {
    const fillRule = this.attrs.fillRule;
    if (fillRule) context.fill(fillRule);
    else context.fill();
}
function $dfc94508c89c186c$var$_strokeFunc(context) {
    context.stroke();
}
function $dfc94508c89c186c$var$_fillFuncHit(context) {
    const fillRule = this.attrs.fillRule;
    if (fillRule) context.fill(fillRule);
    else context.fill();
}
function $dfc94508c89c186c$var$_strokeFuncHit(context) {
    context.stroke();
}
function $dfc94508c89c186c$var$_clearHasShadowCache() {
    this._clearCache($dfc94508c89c186c$var$HAS_SHADOW);
}
function $dfc94508c89c186c$var$_clearGetShadowRGBACache() {
    this._clearCache($dfc94508c89c186c$var$SHADOW_RGBA);
}
function $dfc94508c89c186c$var$_clearFillPatternCache() {
    this._clearCache($dfc94508c89c186c$var$patternImage);
}
function $dfc94508c89c186c$var$_clearLinearGradientCache() {
    this._clearCache($dfc94508c89c186c$var$linearGradient);
}
function $dfc94508c89c186c$var$_clearRadialGradientCache() {
    this._clearCache($dfc94508c89c186c$var$radialGradient);
}
class $dfc94508c89c186c$export$6428a7f2611ef1fa extends (0, $29d50c16ed06fd36$export$85c928794f8d04d4) {
    constructor(config){
        super(config);
        let key;
        let attempts = 0;
        while(true){
            key = (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).getHitColor();
            if (key && !(key in $dfc94508c89c186c$export$4ff7fc6f1af248b5)) break;
            attempts++;
            if (attempts >= 10000) {
                (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).warn("Failed to find a unique color key for a shape. Konva may work incorrectly. Most likely your browser is using canvas farbling. Consider disabling it.");
                key = (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).getRandomColor();
                break;
            }
        }
        this.colorKey = key;
        $dfc94508c89c186c$export$4ff7fc6f1af248b5[key] = this;
    }
    getContext() {
        (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).warn("shape.getContext() method is deprecated. Please do not use it.");
        return this.getLayer().getContext();
    }
    getCanvas() {
        (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).warn("shape.getCanvas() method is deprecated. Please do not use it.");
        return this.getLayer().getCanvas();
    }
    getSceneFunc() {
        return this.attrs.sceneFunc || this["_sceneFunc"];
    }
    getHitFunc() {
        return this.attrs.hitFunc || this["_hitFunc"];
    }
    hasShadow() {
        return this._getCache($dfc94508c89c186c$var$HAS_SHADOW, this._hasShadow);
    }
    _hasShadow() {
        return this.shadowEnabled() && this.shadowOpacity() !== 0 && !!(this.shadowColor() || this.shadowBlur() || this.shadowOffsetX() || this.shadowOffsetY());
    }
    _getFillPattern() {
        return this._getCache($dfc94508c89c186c$var$patternImage, this.__getFillPattern);
    }
    __getFillPattern() {
        if (this.fillPatternImage()) {
            const ctx = $dfc94508c89c186c$var$getDummyContext();
            const pattern = ctx.createPattern(this.fillPatternImage(), this.fillPatternRepeat() || "repeat");
            if (pattern && pattern.setTransform) {
                const tr = new (0, $a838f7f004abc0fb$export$563a914cafbdc389)();
                tr.translate(this.fillPatternX(), this.fillPatternY());
                tr.rotate((0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).getAngle(this.fillPatternRotation()));
                tr.scale(this.fillPatternScaleX(), this.fillPatternScaleY());
                tr.translate(-1 * this.fillPatternOffsetX(), -1 * this.fillPatternOffsetY());
                const m = tr.getMatrix();
                const matrix = typeof DOMMatrix === "undefined" ? {
                    a: m[0],
                    b: m[1],
                    c: m[2],
                    d: m[3],
                    e: m[4],
                    f: m[5]
                } : new DOMMatrix(m);
                pattern.setTransform(matrix);
            }
            return pattern;
        }
    }
    _getLinearGradient() {
        return this._getCache($dfc94508c89c186c$var$linearGradient, this.__getLinearGradient);
    }
    __getLinearGradient() {
        const colorStops = this.fillLinearGradientColorStops();
        if (colorStops) {
            const ctx = $dfc94508c89c186c$var$getDummyContext();
            const start = this.fillLinearGradientStartPoint();
            const end = this.fillLinearGradientEndPoint();
            const grd = ctx.createLinearGradient(start.x, start.y, end.x, end.y);
            for(let n = 0; n < colorStops.length; n += 2)grd.addColorStop(colorStops[n], colorStops[n + 1]);
            return grd;
        }
    }
    _getRadialGradient() {
        return this._getCache($dfc94508c89c186c$var$radialGradient, this.__getRadialGradient);
    }
    __getRadialGradient() {
        const colorStops = this.fillRadialGradientColorStops();
        if (colorStops) {
            const ctx = $dfc94508c89c186c$var$getDummyContext();
            const start = this.fillRadialGradientStartPoint();
            const end = this.fillRadialGradientEndPoint();
            const grd = ctx.createRadialGradient(start.x, start.y, this.fillRadialGradientStartRadius(), end.x, end.y, this.fillRadialGradientEndRadius());
            for(let n = 0; n < colorStops.length; n += 2)grd.addColorStop(colorStops[n], colorStops[n + 1]);
            return grd;
        }
    }
    getShadowRGBA() {
        return this._getCache($dfc94508c89c186c$var$SHADOW_RGBA, this._getShadowRGBA);
    }
    _getShadowRGBA() {
        if (!this.hasShadow()) return;
        const rgba = (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).colorToRGBA(this.shadowColor());
        if (rgba) return "rgba(" + rgba.r + "," + rgba.g + "," + rgba.b + "," + rgba.a * (this.shadowOpacity() || 1) + ")";
    }
    hasFill() {
        return this._calculate("hasFill", [
            "fillEnabled",
            "fill",
            "fillPatternImage",
            "fillLinearGradientColorStops",
            "fillRadialGradientColorStops"
        ], ()=>{
            return this.fillEnabled() && !!(this.fill() || this.fillPatternImage() || this.fillLinearGradientColorStops() || this.fillRadialGradientColorStops());
        });
    }
    hasStroke() {
        return this._calculate("hasStroke", [
            "strokeEnabled",
            "strokeWidth",
            "stroke",
            "strokeLinearGradientColorStops"
        ], ()=>{
            return this.strokeEnabled() && this.strokeWidth() && !!(this.stroke() || this.strokeLinearGradientColorStops());
        });
    }
    hasHitStroke() {
        const width = this.hitStrokeWidth();
        if (width === "auto") return this.hasStroke();
        return this.strokeEnabled() && !!width;
    }
    intersects(point) {
        const stage = this.getStage();
        if (!stage) return false;
        const bufferHitCanvas = stage.bufferHitCanvas;
        bufferHitCanvas.getContext().clear();
        this.drawHit(bufferHitCanvas, undefined, true);
        const p = bufferHitCanvas.context.getImageData(Math.round(point.x), Math.round(point.y), 1, 1).data;
        return p[3] > 0;
    }
    destroy() {
        (0, $29d50c16ed06fd36$export$85c928794f8d04d4).prototype.destroy.call(this);
        delete $dfc94508c89c186c$export$4ff7fc6f1af248b5[this.colorKey];
        delete this.colorKey;
        return this;
    }
    _useBufferCanvas(forceFill) {
        var _a;
        const perfectDrawEnabled = (_a = this.attrs.perfectDrawEnabled) !== null && _a !== void 0 ? _a : true;
        if (!perfectDrawEnabled) return false;
        const hasFill = forceFill || this.hasFill();
        const hasStroke = this.hasStroke();
        const isTransparent = this.getAbsoluteOpacity() !== 1;
        if (hasFill && hasStroke && isTransparent) return true;
        const hasShadow = this.hasShadow();
        const strokeForShadow = this.shadowForStrokeEnabled();
        if (hasFill && hasStroke && hasShadow && strokeForShadow) return true;
        return false;
    }
    setStrokeHitEnabled(val) {
        (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).warn("strokeHitEnabled property is deprecated. Please use hitStrokeWidth instead.");
        if (val) this.hitStrokeWidth("auto");
        else this.hitStrokeWidth(0);
    }
    getStrokeHitEnabled() {
        if (this.hitStrokeWidth() === 0) return false;
        else return true;
    }
    getSelfRect() {
        const size = this.size();
        return {
            x: this._centroid ? -size.width / 2 : 0,
            y: this._centroid ? -size.height / 2 : 0,
            width: size.width,
            height: size.height
        };
    }
    getClientRect(config = {}) {
        let hasCachedParent = false;
        let parent = this.getParent();
        while(parent){
            if (parent.isCached()) {
                hasCachedParent = true;
                break;
            }
            parent = parent.getParent();
        }
        const skipTransform = config.skipTransform;
        const relativeTo = config.relativeTo || hasCachedParent && this.getStage() || undefined;
        const fillRect = this.getSelfRect();
        const applyStroke = !config.skipStroke && this.hasStroke();
        const strokeWidth = applyStroke && this.strokeWidth() || 0;
        const fillAndStrokeWidth = fillRect.width + strokeWidth;
        const fillAndStrokeHeight = fillRect.height + strokeWidth;
        const applyShadow = !config.skipShadow && this.hasShadow();
        const shadowOffsetX = applyShadow ? this.shadowOffsetX() : 0;
        const shadowOffsetY = applyShadow ? this.shadowOffsetY() : 0;
        const preWidth = fillAndStrokeWidth + Math.abs(shadowOffsetX);
        const preHeight = fillAndStrokeHeight + Math.abs(shadowOffsetY);
        const blurRadius = applyShadow && this.shadowBlur() || 0;
        const width = preWidth + blurRadius * 2;
        const height = preHeight + blurRadius * 2;
        const rect = {
            width: width,
            height: height,
            x: -(strokeWidth / 2 + blurRadius) + Math.min(shadowOffsetX, 0) + fillRect.x,
            y: -(strokeWidth / 2 + blurRadius) + Math.min(shadowOffsetY, 0) + fillRect.y
        };
        if (!skipTransform) return this._transformedRect(rect, relativeTo);
        return rect;
    }
    drawScene(can, top, bufferCanvas) {
        const layer = this.getLayer();
        const canvas = can || layer.getCanvas(), context = canvas.getContext(), cachedCanvas = this._getCanvasCache(), drawFunc = this.getSceneFunc(), hasShadow = this.hasShadow();
        let stage;
        const skipBuffer = false;
        const cachingSelf = top === this;
        if (!this.isVisible() && !cachingSelf) return this;
        if (cachedCanvas) {
            context.save();
            const m = this.getAbsoluteTransform(top).getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            this._drawCachedSceneCanvas(context);
            context.restore();
            return this;
        }
        if (!drawFunc) return this;
        context.save();
        if (this._useBufferCanvas() && !skipBuffer) {
            stage = this.getStage();
            const bc = bufferCanvas || stage.bufferCanvas;
            const bufferContext = bc.getContext();
            if (bufferCanvas) {
                bufferContext.save();
                bufferContext.setTransform(1, 0, 0, 1, 0, 0);
                bufferContext.clearRect(0, 0, bc.width, bc.height);
                bufferContext.restore();
            } else bufferContext.clear();
            bufferContext.save();
            bufferContext._applyLineJoin(this);
            bufferContext._applyMiterLimit(this);
            const o = this.getAbsoluteTransform(top).getMatrix();
            bufferContext.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
            drawFunc.call(this, bufferContext, this);
            bufferContext.restore();
            const ratio = bc.pixelRatio;
            if (hasShadow) context._applyShadow(this);
            if (!cachingSelf) {
                context._applyOpacity(this);
                context._applyGlobalCompositeOperation(this);
            }
            context.drawImage(bc._canvas, bc.x || 0, bc.y || 0, bc.width / ratio, bc.height / ratio);
        } else {
            context._applyLineJoin(this);
            context._applyMiterLimit(this);
            if (!cachingSelf) {
                const o = this.getAbsoluteTransform(top).getMatrix();
                context.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
                context._applyOpacity(this);
                context._applyGlobalCompositeOperation(this);
            }
            if (hasShadow) context._applyShadow(this);
            drawFunc.call(this, context, this);
        }
        context.restore();
        return this;
    }
    drawHit(can, top, skipDragCheck = false) {
        if (!this.shouldDrawHit(top, skipDragCheck)) return this;
        const layer = this.getLayer(), canvas = can || layer.hitCanvas, context = canvas && canvas.getContext(), drawFunc = this.hitFunc() || this.sceneFunc(), cachedCanvas = this._getCanvasCache(), cachedHitCanvas = cachedCanvas && cachedCanvas.hit;
        if (!this.colorKey) (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).warn("Looks like your canvas has a destroyed shape in it. Do not reuse shape after you destroyed it. If you want to reuse shape you should call remove() instead of destroy()");
        if (cachedHitCanvas) {
            context.save();
            const m = this.getAbsoluteTransform(top).getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            this._drawCachedHitCanvas(context);
            context.restore();
            return this;
        }
        if (!drawFunc) return this;
        context.save();
        context._applyLineJoin(this);
        context._applyMiterLimit(this);
        const selfCache = this === top;
        if (!selfCache) {
            const o = this.getAbsoluteTransform(top).getMatrix();
            context.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
        }
        drawFunc.call(this, context, this);
        context.restore();
        return this;
    }
    drawHitFromCache(alphaThreshold = 0) {
        const cachedCanvas = this._getCanvasCache(), sceneCanvas = this._getCachedSceneCanvas(), hitCanvas = cachedCanvas.hit, hitContext = hitCanvas.getContext(), hitWidth = hitCanvas.getWidth(), hitHeight = hitCanvas.getHeight();
        hitContext.clear();
        hitContext.drawImage(sceneCanvas._canvas, 0, 0, hitWidth, hitHeight);
        try {
            const hitImageData = hitContext.getImageData(0, 0, hitWidth, hitHeight);
            const hitData = hitImageData.data;
            const len = hitData.length;
            const rgbColorKey = (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._hexToRgb(this.colorKey);
            for(let i = 0; i < len; i += 4){
                const alpha = hitData[i + 3];
                if (alpha > alphaThreshold) {
                    hitData[i] = rgbColorKey.r;
                    hitData[i + 1] = rgbColorKey.g;
                    hitData[i + 2] = rgbColorKey.b;
                    hitData[i + 3] = 255;
                } else hitData[i + 3] = 0;
            }
            hitContext.putImageData(hitImageData, 0, 0);
        } catch (e) {
            (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).error("Unable to draw hit graph from cached scene canvas. " + e.message);
        }
        return this;
    }
    hasPointerCapture(pointerId) {
        return $688ce46e8c7c90ce$export$3b42bc7c43025bad(pointerId, this);
    }
    setPointerCapture(pointerId) {
        $688ce46e8c7c90ce$export$1cab177b65f17c5a(pointerId, this);
    }
    releaseCapture(pointerId) {
        $688ce46e8c7c90ce$export$50f687f23c43e4d9(pointerId, this);
    }
}
$dfc94508c89c186c$export$6428a7f2611ef1fa.prototype._fillFunc = $dfc94508c89c186c$var$_fillFunc;
$dfc94508c89c186c$export$6428a7f2611ef1fa.prototype._strokeFunc = $dfc94508c89c186c$var$_strokeFunc;
$dfc94508c89c186c$export$6428a7f2611ef1fa.prototype._fillFuncHit = $dfc94508c89c186c$var$_fillFuncHit;
$dfc94508c89c186c$export$6428a7f2611ef1fa.prototype._strokeFuncHit = $dfc94508c89c186c$var$_strokeFuncHit;
$dfc94508c89c186c$export$6428a7f2611ef1fa.prototype._centroid = false;
$dfc94508c89c186c$export$6428a7f2611ef1fa.prototype.nodeType = "Shape";
(0, $bd77714a0ea3dd4d$export$f7a70d87a5e829eb)($dfc94508c89c186c$export$6428a7f2611ef1fa);
$dfc94508c89c186c$export$6428a7f2611ef1fa.prototype.eventListeners = {};
$dfc94508c89c186c$export$6428a7f2611ef1fa.prototype.on("shadowColorChange.konva shadowBlurChange.konva shadowOffsetChange.konva shadowOpacityChange.konva shadowEnabledChange.konva", $dfc94508c89c186c$var$_clearHasShadowCache);
$dfc94508c89c186c$export$6428a7f2611ef1fa.prototype.on("shadowColorChange.konva shadowOpacityChange.konva shadowEnabledChange.konva", $dfc94508c89c186c$var$_clearGetShadowRGBACache);
$dfc94508c89c186c$export$6428a7f2611ef1fa.prototype.on("fillPriorityChange.konva fillPatternImageChange.konva fillPatternRepeatChange.konva fillPatternScaleXChange.konva fillPatternScaleYChange.konva fillPatternOffsetXChange.konva fillPatternOffsetYChange.konva fillPatternXChange.konva fillPatternYChange.konva fillPatternRotationChange.konva", $dfc94508c89c186c$var$_clearFillPatternCache);
$dfc94508c89c186c$export$6428a7f2611ef1fa.prototype.on("fillPriorityChange.konva fillLinearGradientColorStopsChange.konva fillLinearGradientStartPointXChange.konva fillLinearGradientStartPointYChange.konva fillLinearGradientEndPointXChange.konva fillLinearGradientEndPointYChange.konva", $dfc94508c89c186c$var$_clearLinearGradientCache);
$dfc94508c89c186c$export$6428a7f2611ef1fa.prototype.on("fillPriorityChange.konva fillRadialGradientColorStopsChange.konva fillRadialGradientStartPointXChange.konva fillRadialGradientStartPointYChange.konva fillRadialGradientEndPointXChange.konva fillRadialGradientEndPointYChange.konva fillRadialGradientStartRadiusChange.konva fillRadialGradientEndRadiusChange.konva", $dfc94508c89c186c$var$_clearRadialGradientCache);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "stroke", undefined, (0, $dc39f19751b6eb0f$export$9c72f966a828cc68)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "strokeWidth", 2, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "fillAfterStrokeEnabled", false);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "hitStrokeWidth", "auto", (0, $dc39f19751b6eb0f$export$3b7df2720ef33404)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "strokeHitEnabled", true, (0, $dc39f19751b6eb0f$export$147fc8b6cd20fda1)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "perfectDrawEnabled", true, (0, $dc39f19751b6eb0f$export$147fc8b6cd20fda1)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "shadowForStrokeEnabled", true, (0, $dc39f19751b6eb0f$export$147fc8b6cd20fda1)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "lineJoin");
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "lineCap");
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "miterLimit");
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "sceneFunc");
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "hitFunc");
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "dash");
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "dashOffset", 0, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "shadowColor", undefined, (0, $dc39f19751b6eb0f$export$5837c5b6cc5b4d63)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "shadowBlur", 0, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "shadowOpacity", 1, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addComponentsGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "shadowOffset", [
    "x",
    "y"
]);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "shadowOffsetX", 0, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "shadowOffsetY", 0, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "fillPatternImage");
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "fill", undefined, (0, $dc39f19751b6eb0f$export$9c72f966a828cc68)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "fillPatternX", 0, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "fillPatternY", 0, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "fillLinearGradientColorStops");
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "strokeLinearGradientColorStops");
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "fillRadialGradientStartRadius", 0);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "fillRadialGradientEndRadius", 0);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "fillRadialGradientColorStops");
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "fillPatternRepeat", "repeat");
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "fillEnabled", true);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "strokeEnabled", true);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "shadowEnabled", true);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "dashEnabled", true);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "strokeScaleEnabled", true);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "fillPriority", "color");
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addComponentsGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "fillPatternOffset", [
    "x",
    "y"
]);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "fillPatternOffsetX", 0, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "fillPatternOffsetY", 0, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addComponentsGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "fillPatternScale", [
    "x",
    "y"
]);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "fillPatternScaleX", 1, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "fillPatternScaleY", 1, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addComponentsGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "fillLinearGradientStartPoint", [
    "x",
    "y"
]);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addComponentsGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "strokeLinearGradientStartPoint", [
    "x",
    "y"
]);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "fillLinearGradientStartPointX", 0);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "strokeLinearGradientStartPointX", 0);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "fillLinearGradientStartPointY", 0);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "strokeLinearGradientStartPointY", 0);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addComponentsGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "fillLinearGradientEndPoint", [
    "x",
    "y"
]);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addComponentsGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "strokeLinearGradientEndPoint", [
    "x",
    "y"
]);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "fillLinearGradientEndPointX", 0);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "strokeLinearGradientEndPointX", 0);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "fillLinearGradientEndPointY", 0);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "strokeLinearGradientEndPointY", 0);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addComponentsGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "fillRadialGradientStartPoint", [
    "x",
    "y"
]);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "fillRadialGradientStartPointX", 0);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "fillRadialGradientStartPointY", 0);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addComponentsGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "fillRadialGradientEndPoint", [
    "x",
    "y"
]);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "fillRadialGradientEndPointX", 0);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "fillRadialGradientEndPointY", 0);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "fillPatternRotation", 0);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($dfc94508c89c186c$export$6428a7f2611ef1fa, "fillRule", undefined, (0, $dc39f19751b6eb0f$export$5837c5b6cc5b4d63)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).backCompat($dfc94508c89c186c$export$6428a7f2611ef1fa, {
    dashArray: "dash",
    getDashArray: "getDash",
    setDashArray: "getDash",
    drawFunc: "sceneFunc",
    getDrawFunc: "getSceneFunc",
    setDrawFunc: "setSceneFunc",
    drawHitFunc: "hitFunc",
    getDrawHitFunc: "getHitFunc",
    setDrawHitFunc: "setHitFunc"
});



const $1e0c075da7d3b8ed$var$HASH = "#", $1e0c075da7d3b8ed$var$BEFORE_DRAW = "beforeDraw", $1e0c075da7d3b8ed$var$DRAW = "draw", $1e0c075da7d3b8ed$var$INTERSECTION_OFFSETS = [
    {
        x: 0,
        y: 0
    },
    {
        x: -1,
        y: -1
    },
    {
        x: 1,
        y: -1
    },
    {
        x: 1,
        y: 1
    },
    {
        x: -1,
        y: 1
    }
], $1e0c075da7d3b8ed$var$INTERSECTION_OFFSETS_LEN = $1e0c075da7d3b8ed$var$INTERSECTION_OFFSETS.length;
class $1e0c075da7d3b8ed$export$936d0764594b6eb3 extends (0, $e95078a0a7406ae2$export$42a852a2b6b56249) {
    constructor(config){
        super(config);
        this.canvas = new (0, $e3f0e6aa12a16394$export$ee612225bd2e63be)();
        this.hitCanvas = new (0, $e3f0e6aa12a16394$export$43a2e1456e27dc84)({
            pixelRatio: 1
        });
        this._waitingForDraw = false;
        this.on("visibleChange.konva", this._checkVisibility);
        this._checkVisibility();
        this.on("imageSmoothingEnabledChange.konva", this._setSmoothEnabled);
        this._setSmoothEnabled();
    }
    createPNGStream() {
        const c = this.canvas._canvas;
        return c.createPNGStream();
    }
    getCanvas() {
        return this.canvas;
    }
    getNativeCanvasElement() {
        return this.canvas._canvas;
    }
    getHitCanvas() {
        return this.hitCanvas;
    }
    getContext() {
        return this.getCanvas().getContext();
    }
    clear(bounds) {
        this.getContext().clear(bounds);
        this.getHitCanvas().getContext().clear(bounds);
        return this;
    }
    setZIndex(index) {
        super.setZIndex(index);
        const stage = this.getStage();
        if (stage && stage.content) {
            stage.content.removeChild(this.getNativeCanvasElement());
            if (index < stage.children.length - 1) stage.content.insertBefore(this.getNativeCanvasElement(), stage.children[index + 1].getCanvas()._canvas);
            else stage.content.appendChild(this.getNativeCanvasElement());
        }
        return this;
    }
    moveToTop() {
        (0, $29d50c16ed06fd36$export$85c928794f8d04d4).prototype.moveToTop.call(this);
        const stage = this.getStage();
        if (stage && stage.content) {
            stage.content.removeChild(this.getNativeCanvasElement());
            stage.content.appendChild(this.getNativeCanvasElement());
        }
        return true;
    }
    moveUp() {
        const moved = (0, $29d50c16ed06fd36$export$85c928794f8d04d4).prototype.moveUp.call(this);
        if (!moved) return false;
        const stage = this.getStage();
        if (!stage || !stage.content) return false;
        stage.content.removeChild(this.getNativeCanvasElement());
        if (this.index < stage.children.length - 1) stage.content.insertBefore(this.getNativeCanvasElement(), stage.children[this.index + 1].getCanvas()._canvas);
        else stage.content.appendChild(this.getNativeCanvasElement());
        return true;
    }
    moveDown() {
        if ((0, $29d50c16ed06fd36$export$85c928794f8d04d4).prototype.moveDown.call(this)) {
            const stage = this.getStage();
            if (stage) {
                const children = stage.children;
                if (stage.content) {
                    stage.content.removeChild(this.getNativeCanvasElement());
                    stage.content.insertBefore(this.getNativeCanvasElement(), children[this.index + 1].getCanvas()._canvas);
                }
            }
            return true;
        }
        return false;
    }
    moveToBottom() {
        if ((0, $29d50c16ed06fd36$export$85c928794f8d04d4).prototype.moveToBottom.call(this)) {
            const stage = this.getStage();
            if (stage) {
                const children = stage.children;
                if (stage.content) {
                    stage.content.removeChild(this.getNativeCanvasElement());
                    stage.content.insertBefore(this.getNativeCanvasElement(), children[1].getCanvas()._canvas);
                }
            }
            return true;
        }
        return false;
    }
    getLayer() {
        return this;
    }
    remove() {
        const _canvas = this.getNativeCanvasElement();
        (0, $29d50c16ed06fd36$export$85c928794f8d04d4).prototype.remove.call(this);
        if (_canvas && _canvas.parentNode && (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._isInDocument(_canvas)) _canvas.parentNode.removeChild(_canvas);
        return this;
    }
    getStage() {
        return this.parent;
    }
    setSize({ width: width, height: height }) {
        this.canvas.setSize(width, height);
        this.hitCanvas.setSize(width, height);
        this._setSmoothEnabled();
        return this;
    }
    _validateAdd(child) {
        const type = child.getType();
        if (type !== "Group" && type !== "Shape") (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).throw("You may only add groups and shapes to a layer.");
    }
    _toKonvaCanvas(config) {
        config = {
            ...config
        };
        config.width = config.width || this.getWidth();
        config.height = config.height || this.getHeight();
        config.x = config.x !== undefined ? config.x : this.x();
        config.y = config.y !== undefined ? config.y : this.y();
        return (0, $29d50c16ed06fd36$export$85c928794f8d04d4).prototype._toKonvaCanvas.call(this, config);
    }
    _checkVisibility() {
        const visible = this.visible();
        if (visible) this.canvas._canvas.style.display = "block";
        else this.canvas._canvas.style.display = "none";
    }
    _setSmoothEnabled() {
        this.getContext()._context.imageSmoothingEnabled = this.imageSmoothingEnabled();
    }
    getWidth() {
        if (this.parent) return this.parent.width();
    }
    setWidth() {
        (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).warn('Can not change width of layer. Use "stage.width(value)" function instead.');
    }
    getHeight() {
        if (this.parent) return this.parent.height();
    }
    setHeight() {
        (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).warn('Can not change height of layer. Use "stage.height(value)" function instead.');
    }
    batchDraw() {
        if (!this._waitingForDraw) {
            this._waitingForDraw = true;
            (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).requestAnimFrame(()=>{
                this.draw();
                this._waitingForDraw = false;
            });
        }
        return this;
    }
    getIntersection(pos) {
        if (!this.isListening() || !this.isVisible()) return null;
        let spiralSearchDistance = 1;
        let continueSearch = false;
        while(true){
            for(let i = 0; i < $1e0c075da7d3b8ed$var$INTERSECTION_OFFSETS_LEN; i++){
                const intersectionOffset = $1e0c075da7d3b8ed$var$INTERSECTION_OFFSETS[i];
                const obj = this._getIntersection({
                    x: pos.x + intersectionOffset.x * spiralSearchDistance,
                    y: pos.y + intersectionOffset.y * spiralSearchDistance
                });
                const shape = obj.shape;
                if (shape) return shape;
                continueSearch = !!obj.antialiased;
                if (!obj.antialiased) break;
            }
            if (continueSearch) spiralSearchDistance += 1;
            else return null;
        }
    }
    _getIntersection(pos) {
        const ratio = this.hitCanvas.pixelRatio;
        const p = this.hitCanvas.context.getImageData(Math.round(pos.x * ratio), Math.round(pos.y * ratio), 1, 1).data;
        const p3 = p[3];
        if (p3 === 255) {
            const colorKey = (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).getHitColorKey(p[0], p[1], p[2]);
            const shape = (0, $dfc94508c89c186c$export$4ff7fc6f1af248b5)[colorKey];
            if (shape) return {
                shape: shape
            };
            return {
                antialiased: true
            };
        } else if (p3 > 0) return {
            antialiased: true
        };
        return {};
    }
    drawScene(can, top, bufferCanvas) {
        const layer = this.getLayer(), canvas = can || layer && layer.getCanvas();
        this._fire($1e0c075da7d3b8ed$var$BEFORE_DRAW, {
            node: this
        });
        if (this.clearBeforeDraw()) canvas.getContext().clear();
        (0, $e95078a0a7406ae2$export$42a852a2b6b56249).prototype.drawScene.call(this, canvas, top, bufferCanvas);
        this._fire($1e0c075da7d3b8ed$var$DRAW, {
            node: this
        });
        return this;
    }
    drawHit(can, top) {
        const layer = this.getLayer(), canvas = can || layer && layer.hitCanvas;
        if (layer && layer.clearBeforeDraw()) layer.getHitCanvas().getContext().clear();
        (0, $e95078a0a7406ae2$export$42a852a2b6b56249).prototype.drawHit.call(this, canvas, top);
        return this;
    }
    enableHitGraph() {
        this.hitGraphEnabled(true);
        return this;
    }
    disableHitGraph() {
        this.hitGraphEnabled(false);
        return this;
    }
    setHitGraphEnabled(val) {
        (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).warn("hitGraphEnabled method is deprecated. Please use layer.listening() instead.");
        this.listening(val);
    }
    getHitGraphEnabled(val) {
        (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).warn("hitGraphEnabled method is deprecated. Please use layer.listening() instead.");
        return this.listening();
    }
    toggleHitCanvas() {
        if (!this.parent || !this.parent["content"]) return;
        const parent = this.parent;
        const added = !!this.hitCanvas._canvas.parentNode;
        if (added) parent.content.removeChild(this.hitCanvas._canvas);
        else parent.content.appendChild(this.hitCanvas._canvas);
    }
    destroy() {
        (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).releaseCanvas(this.getNativeCanvasElement(), this.getHitCanvas()._canvas);
        return super.destroy();
    }
}
$1e0c075da7d3b8ed$export$936d0764594b6eb3.prototype.nodeType = "Layer";
(0, $bd77714a0ea3dd4d$export$f7a70d87a5e829eb)($1e0c075da7d3b8ed$export$936d0764594b6eb3);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($1e0c075da7d3b8ed$export$936d0764594b6eb3, "imageSmoothingEnabled", true);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($1e0c075da7d3b8ed$export$936d0764594b6eb3, "clearBeforeDraw", true);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($1e0c075da7d3b8ed$export$936d0764594b6eb3, "hitGraphEnabled", true, (0, $dc39f19751b6eb0f$export$147fc8b6cd20fda1)());





class $7e87aab4034298c2$export$92d64f29192d1118 extends (0, $1e0c075da7d3b8ed$export$936d0764594b6eb3) {
    constructor(attrs){
        super(attrs);
        this.listening(false);
        (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).warn('Konva.Fast layer is deprecated. Please use "new Konva.Layer({ listening: false })" instead.');
    }
}
$7e87aab4034298c2$export$92d64f29192d1118.prototype.nodeType = "FastLayer";
(0, $bd77714a0ea3dd4d$export$f7a70d87a5e829eb)($7e87aab4034298c2$export$92d64f29192d1118);





class $be5edb8df13e00d8$export$eb2fcfdbd7ba97d4 extends (0, $e95078a0a7406ae2$export$42a852a2b6b56249) {
    _validateAdd(child) {
        const type = child.getType();
        if (type !== "Group" && type !== "Shape") (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).throw("You may only add groups and shapes to groups.");
    }
}
$be5edb8df13e00d8$export$eb2fcfdbd7ba97d4.prototype.nodeType = "Group";
(0, $bd77714a0ea3dd4d$export$f7a70d87a5e829eb)($be5edb8df13e00d8$export$eb2fcfdbd7ba97d4);






const $a7f600c41a6fb34b$var$now = function() {
    if ((0, $bd77714a0ea3dd4d$export$442f1a04865e4790).performance && (0, $bd77714a0ea3dd4d$export$442f1a04865e4790).performance.now) return function() {
        return (0, $bd77714a0ea3dd4d$export$442f1a04865e4790).performance.now();
    };
    return function() {
        return new Date().getTime();
    };
}();
class $a7f600c41a6fb34b$export$c35d437ae5945fcd {
    constructor(func, layers){
        this.id = $a7f600c41a6fb34b$export$c35d437ae5945fcd.animIdCounter++;
        this.frame = {
            time: 0,
            timeDiff: 0,
            lastTime: $a7f600c41a6fb34b$var$now(),
            frameRate: 0
        };
        this.func = func;
        this.setLayers(layers);
    }
    setLayers(layers) {
        let lays = [];
        if (layers) lays = Array.isArray(layers) ? layers : [
            layers
        ];
        this.layers = lays;
        return this;
    }
    getLayers() {
        return this.layers;
    }
    addLayer(layer) {
        const layers = this.layers;
        const len = layers.length;
        for(let n = 0; n < len; n++){
            if (layers[n]._id === layer._id) return false;
        }
        this.layers.push(layer);
        return true;
    }
    isRunning() {
        const a = $a7f600c41a6fb34b$export$c35d437ae5945fcd;
        const animations = a.animations;
        const len = animations.length;
        for(let n = 0; n < len; n++){
            if (animations[n].id === this.id) return true;
        }
        return false;
    }
    start() {
        this.stop();
        this.frame.timeDiff = 0;
        this.frame.lastTime = $a7f600c41a6fb34b$var$now();
        $a7f600c41a6fb34b$export$c35d437ae5945fcd._addAnimation(this);
        return this;
    }
    stop() {
        $a7f600c41a6fb34b$export$c35d437ae5945fcd._removeAnimation(this);
        return this;
    }
    _updateFrameObject(time) {
        this.frame.timeDiff = time - this.frame.lastTime;
        this.frame.lastTime = time;
        this.frame.time += this.frame.timeDiff;
        this.frame.frameRate = 1000 / this.frame.timeDiff;
    }
    static _addAnimation(anim) {
        this.animations.push(anim);
        this._handleAnimation();
    }
    static _removeAnimation(anim) {
        const id = anim.id;
        const animations = this.animations;
        const len = animations.length;
        for(let n = 0; n < len; n++)if (animations[n].id === id) {
            this.animations.splice(n, 1);
            break;
        }
    }
    static _runFrames() {
        const layerHash = {};
        const animations = this.animations;
        for(let n = 0; n < animations.length; n++){
            const anim = animations[n];
            const layers = anim.layers;
            const func = anim.func;
            anim._updateFrameObject($a7f600c41a6fb34b$var$now());
            const layersLen = layers.length;
            let needRedraw;
            if (func) needRedraw = func.call(anim, anim.frame) !== false;
            else needRedraw = true;
            if (!needRedraw) continue;
            for(let i = 0; i < layersLen; i++){
                const layer = layers[i];
                if (layer._id !== undefined) layerHash[layer._id] = layer;
            }
        }
        for(const key in layerHash){
            if (!layerHash.hasOwnProperty(key)) continue;
            layerHash[key].batchDraw();
        }
    }
    static _animationLoop() {
        const Anim = $a7f600c41a6fb34b$export$c35d437ae5945fcd;
        if (Anim.animations.length) {
            Anim._runFrames();
            (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).requestAnimFrame(Anim._animationLoop);
        } else Anim.animRunning = false;
    }
    static _handleAnimation() {
        if (!this.animRunning) {
            this.animRunning = true;
            (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).requestAnimFrame(this._animationLoop);
        }
    }
}
$a7f600c41a6fb34b$export$c35d437ae5945fcd.animations = [];
$a7f600c41a6fb34b$export$c35d437ae5945fcd.animIdCounter = 0;
$a7f600c41a6fb34b$export$c35d437ae5945fcd.animRunning = false;






const $9c32e51f99e83b53$var$blacklist = {
    node: 1,
    duration: 1,
    easing: 1,
    onFinish: 1,
    yoyo: 1
}, $9c32e51f99e83b53$var$PAUSED = 1, $9c32e51f99e83b53$var$PLAYING = 2, $9c32e51f99e83b53$var$REVERSING = 3, $9c32e51f99e83b53$var$colorAttrs = [
    "fill",
    "stroke",
    "shadowColor"
];
let $9c32e51f99e83b53$var$idCounter = 0;
class $9c32e51f99e83b53$var$TweenEngine {
    constructor(prop, propFunc, func, begin, finish, duration, yoyo){
        this.prop = prop;
        this.propFunc = propFunc;
        this.begin = begin;
        this._pos = begin;
        this.duration = duration;
        this._change = 0;
        this.prevPos = 0;
        this.yoyo = yoyo;
        this._time = 0;
        this._position = 0;
        this._startTime = 0;
        this._finish = 0;
        this.func = func;
        this._change = finish - this.begin;
        this.pause();
    }
    fire(str) {
        const handler = this[str];
        if (handler) handler();
    }
    setTime(t) {
        if (t > this.duration) {
            if (this.yoyo) {
                this._time = this.duration;
                this.reverse();
            } else this.finish();
        } else if (t < 0) {
            if (this.yoyo) {
                this._time = 0;
                this.play();
            } else this.reset();
        } else {
            this._time = t;
            this.update();
        }
    }
    getTime() {
        return this._time;
    }
    setPosition(p) {
        this.prevPos = this._pos;
        this.propFunc(p);
        this._pos = p;
    }
    getPosition(t) {
        if (t === undefined) t = this._time;
        return this.func(t, this.begin, this._change, this.duration);
    }
    play() {
        this.state = $9c32e51f99e83b53$var$PLAYING;
        this._startTime = this.getTimer() - this._time;
        this.onEnterFrame();
        this.fire("onPlay");
    }
    reverse() {
        this.state = $9c32e51f99e83b53$var$REVERSING;
        this._time = this.duration - this._time;
        this._startTime = this.getTimer() - this._time;
        this.onEnterFrame();
        this.fire("onReverse");
    }
    seek(t) {
        this.pause();
        this._time = t;
        this.update();
        this.fire("onSeek");
    }
    reset() {
        this.pause();
        this._time = 0;
        this.update();
        this.fire("onReset");
    }
    finish() {
        this.pause();
        this._time = this.duration;
        this.update();
        this.fire("onFinish");
    }
    update() {
        this.setPosition(this.getPosition(this._time));
        this.fire("onUpdate");
    }
    onEnterFrame() {
        const t = this.getTimer() - this._startTime;
        if (this.state === $9c32e51f99e83b53$var$PLAYING) this.setTime(t);
        else if (this.state === $9c32e51f99e83b53$var$REVERSING) this.setTime(this.duration - t);
    }
    pause() {
        this.state = $9c32e51f99e83b53$var$PAUSED;
        this.fire("onPause");
    }
    getTimer() {
        return new Date().getTime();
    }
}
class $9c32e51f99e83b53$export$208a41d6b4e37b97 {
    constructor(config){
        const that = this, node = config.node, nodeId = node._id, easing = config.easing || $9c32e51f99e83b53$export$ade85cc9682adcc5.Linear, yoyo = !!config.yoyo;
        let duration, key;
        if (typeof config.duration === "undefined") duration = 0.3;
        else if (config.duration === 0) duration = 0.001;
        else duration = config.duration;
        this.node = node;
        this._id = $9c32e51f99e83b53$var$idCounter++;
        const layers = node.getLayer() || (node instanceof (0, $bd77714a0ea3dd4d$export$b9f99057a3c7692)["Stage"] ? node.getLayers() : null);
        if (!layers) (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).error("Tween constructor have `node` that is not in a layer. Please add node into layer first.");
        this.anim = new (0, $a7f600c41a6fb34b$export$c35d437ae5945fcd)(function() {
            that.tween.onEnterFrame();
        }, layers);
        this.tween = new $9c32e51f99e83b53$var$TweenEngine(key, function(i) {
            that._tweenFunc(i);
        }, easing, 0, 1, duration * 1000, yoyo);
        this._addListeners();
        if (!$9c32e51f99e83b53$export$208a41d6b4e37b97.attrs[nodeId]) $9c32e51f99e83b53$export$208a41d6b4e37b97.attrs[nodeId] = {};
        if (!$9c32e51f99e83b53$export$208a41d6b4e37b97.attrs[nodeId][this._id]) $9c32e51f99e83b53$export$208a41d6b4e37b97.attrs[nodeId][this._id] = {};
        if (!$9c32e51f99e83b53$export$208a41d6b4e37b97.tweens[nodeId]) $9c32e51f99e83b53$export$208a41d6b4e37b97.tweens[nodeId] = {};
        for(key in config)if ($9c32e51f99e83b53$var$blacklist[key] === undefined) this._addAttr(key, config[key]);
        this.reset();
        this.onFinish = config.onFinish;
        this.onReset = config.onReset;
        this.onUpdate = config.onUpdate;
    }
    _addAttr(key, end) {
        const node = this.node, nodeId = node._id;
        let diff, len, trueEnd, trueStart, endRGBA;
        const tweenId = $9c32e51f99e83b53$export$208a41d6b4e37b97.tweens[nodeId][key];
        if (tweenId) delete $9c32e51f99e83b53$export$208a41d6b4e37b97.attrs[nodeId][tweenId][key];
        let start = node.getAttr(key);
        if ((0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._isArray(end)) {
            diff = [];
            len = Math.max(end.length, start.length);
            if (key === "points" && end.length !== start.length) {
                if (end.length > start.length) {
                    trueStart = start;
                    start = (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._prepareArrayForTween(start, end, node.closed());
                } else {
                    trueEnd = end;
                    end = (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._prepareArrayForTween(end, start, node.closed());
                }
            }
            if (key.indexOf("fill") === 0) {
                for(let n = 0; n < len; n++)if (n % 2 === 0) diff.push(end[n] - start[n]);
                else {
                    const startRGBA = (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).colorToRGBA(start[n]);
                    endRGBA = (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).colorToRGBA(end[n]);
                    start[n] = startRGBA;
                    diff.push({
                        r: endRGBA.r - startRGBA.r,
                        g: endRGBA.g - startRGBA.g,
                        b: endRGBA.b - startRGBA.b,
                        a: endRGBA.a - startRGBA.a
                    });
                }
            } else for(let n = 0; n < len; n++)diff.push(end[n] - start[n]);
        } else if ($9c32e51f99e83b53$var$colorAttrs.indexOf(key) !== -1) {
            start = (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).colorToRGBA(start);
            endRGBA = (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).colorToRGBA(end);
            diff = {
                r: endRGBA.r - start.r,
                g: endRGBA.g - start.g,
                b: endRGBA.b - start.b,
                a: endRGBA.a - start.a
            };
        } else diff = end - start;
        $9c32e51f99e83b53$export$208a41d6b4e37b97.attrs[nodeId][this._id][key] = {
            start: start,
            diff: diff,
            end: end,
            trueEnd: trueEnd,
            trueStart: trueStart
        };
        $9c32e51f99e83b53$export$208a41d6b4e37b97.tweens[nodeId][key] = this._id;
    }
    _tweenFunc(i) {
        const node = this.node, attrs = $9c32e51f99e83b53$export$208a41d6b4e37b97.attrs[node._id][this._id];
        let key, attr, start, diff, newVal, n, len, end;
        for(key in attrs){
            attr = attrs[key];
            start = attr.start;
            diff = attr.diff;
            end = attr.end;
            if ((0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._isArray(start)) {
                newVal = [];
                len = Math.max(start.length, end.length);
                if (key.indexOf("fill") === 0) {
                    for(n = 0; n < len; n++)if (n % 2 === 0) newVal.push((start[n] || 0) + diff[n] * i);
                    else newVal.push("rgba(" + Math.round(start[n].r + diff[n].r * i) + "," + Math.round(start[n].g + diff[n].g * i) + "," + Math.round(start[n].b + diff[n].b * i) + "," + (start[n].a + diff[n].a * i) + ")");
                } else for(n = 0; n < len; n++)newVal.push((start[n] || 0) + diff[n] * i);
            } else if ($9c32e51f99e83b53$var$colorAttrs.indexOf(key) !== -1) newVal = "rgba(" + Math.round(start.r + diff.r * i) + "," + Math.round(start.g + diff.g * i) + "," + Math.round(start.b + diff.b * i) + "," + (start.a + diff.a * i) + ")";
            else newVal = start + diff * i;
            node.setAttr(key, newVal);
        }
    }
    _addListeners() {
        this.tween.onPlay = ()=>{
            this.anim.start();
        };
        this.tween.onReverse = ()=>{
            this.anim.start();
        };
        this.tween.onPause = ()=>{
            this.anim.stop();
        };
        this.tween.onFinish = ()=>{
            const node = this.node;
            const attrs = $9c32e51f99e83b53$export$208a41d6b4e37b97.attrs[node._id][this._id];
            if (attrs.points && attrs.points.trueEnd) node.setAttr("points", attrs.points.trueEnd);
            if (this.onFinish) this.onFinish.call(this);
        };
        this.tween.onReset = ()=>{
            const node = this.node;
            const attrs = $9c32e51f99e83b53$export$208a41d6b4e37b97.attrs[node._id][this._id];
            if (attrs.points && attrs.points.trueStart) node.points(attrs.points.trueStart);
            if (this.onReset) this.onReset();
        };
        this.tween.onUpdate = ()=>{
            if (this.onUpdate) this.onUpdate.call(this);
        };
    }
    play() {
        this.tween.play();
        return this;
    }
    reverse() {
        this.tween.reverse();
        return this;
    }
    reset() {
        this.tween.reset();
        return this;
    }
    seek(t) {
        this.tween.seek(t * 1000);
        return this;
    }
    pause() {
        this.tween.pause();
        return this;
    }
    finish() {
        this.tween.finish();
        return this;
    }
    destroy() {
        const nodeId = this.node._id, thisId = this._id, attrs = $9c32e51f99e83b53$export$208a41d6b4e37b97.tweens[nodeId];
        this.pause();
        if (this.anim) this.anim.stop();
        for(const key in attrs)delete $9c32e51f99e83b53$export$208a41d6b4e37b97.tweens[nodeId][key];
        delete $9c32e51f99e83b53$export$208a41d6b4e37b97.attrs[nodeId][thisId];
        if ($9c32e51f99e83b53$export$208a41d6b4e37b97.tweens[nodeId]) {
            if (Object.keys($9c32e51f99e83b53$export$208a41d6b4e37b97.tweens[nodeId]).length === 0) delete $9c32e51f99e83b53$export$208a41d6b4e37b97.tweens[nodeId];
            if (Object.keys($9c32e51f99e83b53$export$208a41d6b4e37b97.attrs[nodeId]).length === 0) delete $9c32e51f99e83b53$export$208a41d6b4e37b97.attrs[nodeId];
        }
    }
}
$9c32e51f99e83b53$export$208a41d6b4e37b97.attrs = {};
$9c32e51f99e83b53$export$208a41d6b4e37b97.tweens = {};
(0, $29d50c16ed06fd36$export$85c928794f8d04d4).prototype.to = function(params) {
    const onFinish = params.onFinish;
    params.node = this;
    params.onFinish = function() {
        this.destroy();
        if (onFinish) onFinish();
    };
    const tween = new $9c32e51f99e83b53$export$208a41d6b4e37b97(params);
    tween.play();
};
const $9c32e51f99e83b53$export$ade85cc9682adcc5 = {
    BackEaseIn (t, b, c, d) {
        const s = 1.70158;
        return c * (t /= d) * t * ((s + 1) * t - s) + b;
    },
    BackEaseOut (t, b, c, d) {
        const s = 1.70158;
        return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
    },
    BackEaseInOut (t, b, c, d) {
        let s = 1.70158;
        if ((t /= d / 2) < 1) return c / 2 * (t * t * (((s *= 1.525) + 1) * t - s)) + b;
        return c / 2 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2) + b;
    },
    ElasticEaseIn (t, b, c, d, a, p) {
        let s = 0;
        if (t === 0) return b;
        if ((t /= d) === 1) return b + c;
        if (!p) p = d * 0.3;
        if (!a || a < Math.abs(c)) {
            a = c;
            s = p / 4;
        } else s = p / (2 * Math.PI) * Math.asin(c / a);
        return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
    },
    ElasticEaseOut (t, b, c, d, a, p) {
        let s = 0;
        if (t === 0) return b;
        if ((t /= d) === 1) return b + c;
        if (!p) p = d * 0.3;
        if (!a || a < Math.abs(c)) {
            a = c;
            s = p / 4;
        } else s = p / (2 * Math.PI) * Math.asin(c / a);
        return a * Math.pow(2, -10 * t) * Math.sin((t * d - s) * (2 * Math.PI) / p) + c + b;
    },
    ElasticEaseInOut (t, b, c, d, a, p) {
        let s = 0;
        if (t === 0) return b;
        if ((t /= d / 2) === 2) return b + c;
        if (!p) p = d * (0.3 * 1.5);
        if (!a || a < Math.abs(c)) {
            a = c;
            s = p / 4;
        } else s = p / (2 * Math.PI) * Math.asin(c / a);
        if (t < 1) return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
        return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p) * 0.5 + c + b;
    },
    BounceEaseOut (t, b, c, d) {
        if ((t /= d) < 1 / 2.75) return c * (7.5625 * t * t) + b;
        else if (t < 2 / 2.75) return c * (7.5625 * (t -= 1.5 / 2.75) * t + 0.75) + b;
        else if (t < 2.5 / 2.75) return c * (7.5625 * (t -= 2.25 / 2.75) * t + 0.9375) + b;
        else return c * (7.5625 * (t -= 2.625 / 2.75) * t + 0.984375) + b;
    },
    BounceEaseIn (t, b, c, d) {
        return c - $9c32e51f99e83b53$export$ade85cc9682adcc5.BounceEaseOut(d - t, 0, c, d) + b;
    },
    BounceEaseInOut (t, b, c, d) {
        if (t < d / 2) return $9c32e51f99e83b53$export$ade85cc9682adcc5.BounceEaseIn(t * 2, 0, c, d) * 0.5 + b;
        else return $9c32e51f99e83b53$export$ade85cc9682adcc5.BounceEaseOut(t * 2 - d, 0, c, d) * 0.5 + c * 0.5 + b;
    },
    EaseIn (t, b, c, d) {
        return c * (t /= d) * t + b;
    },
    EaseOut (t, b, c, d) {
        return -c * (t /= d) * (t - 2) + b;
    },
    EaseInOut (t, b, c, d) {
        if ((t /= d / 2) < 1) return c / 2 * t * t + b;
        return -c / 2 * (--t * (t - 2) - 1) + b;
    },
    StrongEaseIn (t, b, c, d) {
        return c * (t /= d) * t * t * t * t + b;
    },
    StrongEaseOut (t, b, c, d) {
        return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
    },
    StrongEaseInOut (t, b, c, d) {
        if ((t /= d / 2) < 1) return c / 2 * t * t * t * t * t + b;
        return c / 2 * ((t -= 2) * t * t * t * t + 2) + b;
    },
    Linear (t, b, c, d) {
        return c * t / d + b;
    }
};




const $534de9cde37e0764$export$b9f99057a3c7692 = (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._assign((0, $bd77714a0ea3dd4d$export$b9f99057a3c7692), {
    Util: $a838f7f004abc0fb$export$f8f26dd395d7e1bd,
    Transform: $a838f7f004abc0fb$export$563a914cafbdc389,
    Node: $29d50c16ed06fd36$export$85c928794f8d04d4,
    Container: $e95078a0a7406ae2$export$42a852a2b6b56249,
    Stage: $fd163e62a715a165$export$208cd1682bd0e4b6,
    stages: $fd163e62a715a165$export$1bfcff8d7c4bf05,
    Layer: $1e0c075da7d3b8ed$export$936d0764594b6eb3,
    FastLayer: $7e87aab4034298c2$export$92d64f29192d1118,
    Group: $be5edb8df13e00d8$export$eb2fcfdbd7ba97d4,
    DD: $5801123e8d1755fa$export$e34f1b340034d7f,
    Shape: $dfc94508c89c186c$export$6428a7f2611ef1fa,
    shapes: $dfc94508c89c186c$export$4ff7fc6f1af248b5,
    Animation: $a7f600c41a6fb34b$export$c35d437ae5945fcd,
    Tween: $9c32e51f99e83b53$export$208a41d6b4e37b97,
    Easings: $9c32e51f99e83b53$export$ade85cc9682adcc5,
    Context: $8efbfe36b14beb68$export$841858b892ce1f4c,
    Canvas: $e3f0e6aa12a16394$export$8d01c972ee8b14a9
});
var $534de9cde37e0764$export$2e2bcd8739ae039 = $534de9cde37e0764$export$b9f99057a3c7692;






class $9591be4d5842003b$export$6ef80ffb606dd232 extends (0, $dfc94508c89c186c$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        const angle = (0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).getAngle(this.angle()), clockwise = this.clockwise();
        context.beginPath();
        context.arc(0, 0, this.outerRadius(), 0, angle, clockwise);
        context.arc(0, 0, this.innerRadius(), angle, 0, !clockwise);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return this.outerRadius() * 2;
    }
    getHeight() {
        return this.outerRadius() * 2;
    }
    setWidth(width) {
        this.outerRadius(width / 2);
    }
    setHeight(height) {
        this.outerRadius(height / 2);
    }
    getSelfRect() {
        const innerRadius = this.innerRadius();
        const outerRadius = this.outerRadius();
        const clockwise = this.clockwise();
        const angle = (0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).getAngle(clockwise ? 360 - this.angle() : this.angle());
        const boundLeftRatio = Math.cos(Math.min(angle, Math.PI));
        const boundRightRatio = 1;
        const boundTopRatio = Math.sin(Math.min(Math.max(Math.PI, angle), 3 * Math.PI / 2));
        const boundBottomRatio = Math.sin(Math.min(angle, Math.PI / 2));
        const boundLeft = boundLeftRatio * (boundLeftRatio > 0 ? innerRadius : outerRadius);
        const boundRight = boundRightRatio * (boundRightRatio > 0 ? outerRadius : innerRadius);
        const boundTop = boundTopRatio * (boundTopRatio > 0 ? innerRadius : outerRadius);
        const boundBottom = boundBottomRatio * (boundBottomRatio > 0 ? outerRadius : innerRadius);
        return {
            x: boundLeft,
            y: clockwise ? -1 * boundBottom : boundTop,
            width: boundRight - boundLeft,
            height: boundBottom - boundTop
        };
    }
}
$9591be4d5842003b$export$6ef80ffb606dd232.prototype._centroid = true;
$9591be4d5842003b$export$6ef80ffb606dd232.prototype.className = "Arc";
$9591be4d5842003b$export$6ef80ffb606dd232.prototype._attrsAffectingSize = [
    "innerRadius",
    "outerRadius",
    "angle",
    "clockwise"
];
(0, $bd77714a0ea3dd4d$export$f7a70d87a5e829eb)($9591be4d5842003b$export$6ef80ffb606dd232);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($9591be4d5842003b$export$6ef80ffb606dd232, "innerRadius", 0, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($9591be4d5842003b$export$6ef80ffb606dd232, "outerRadius", 0, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($9591be4d5842003b$export$6ef80ffb606dd232, "angle", 0, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($9591be4d5842003b$export$6ef80ffb606dd232, "clockwise", false, (0, $dc39f19751b6eb0f$export$147fc8b6cd20fda1)());







function $297515b488d52990$var$getControlPoints(x0, y0, x1, y1, x2, y2, t) {
    const d01 = Math.sqrt(Math.pow(x1 - x0, 2) + Math.pow(y1 - y0, 2)), d12 = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2)), fa = t * d01 / (d01 + d12), fb = t * d12 / (d01 + d12), p1x = x1 - fa * (x2 - x0), p1y = y1 - fa * (y2 - y0), p2x = x1 + fb * (x2 - x0), p2y = y1 + fb * (y2 - y0);
    return [
        p1x,
        p1y,
        p2x,
        p2y
    ];
}
function $297515b488d52990$var$expandPoints(p, tension) {
    const len = p.length, allPoints = [];
    for(let n = 2; n < len - 2; n += 2){
        const cp = $297515b488d52990$var$getControlPoints(p[n - 2], p[n - 1], p[n], p[n + 1], p[n + 2], p[n + 3], tension);
        if (isNaN(cp[0])) continue;
        allPoints.push(cp[0]);
        allPoints.push(cp[1]);
        allPoints.push(p[n]);
        allPoints.push(p[n + 1]);
        allPoints.push(cp[2]);
        allPoints.push(cp[3]);
    }
    return allPoints;
}
function $297515b488d52990$var$getBezierExtremaPoints(points) {
    const axisPoints = [
        [
            points[0],
            points[2],
            points[4],
            points[6]
        ],
        [
            points[1],
            points[3],
            points[5],
            points[7]
        ]
    ];
    const extremaTs = [];
    for (const axis of axisPoints){
        const a = -3 * axis[0] + 9 * axis[1] - 9 * axis[2] + 3 * axis[3];
        if (a !== 0) {
            const b = 6 * axis[0] - 12 * axis[1] + 6 * axis[2];
            const c = -3 * axis[0] + 3 * axis[1];
            const discriminant = b * b - 4 * a * c;
            if (discriminant >= 0) {
                const d = Math.sqrt(discriminant);
                extremaTs.push((-b + d) / (2 * a));
                extremaTs.push((-b - d) / (2 * a));
            }
        }
    }
    return extremaTs.filter((t)=>t > 0 && t < 1).flatMap((t)=>axisPoints.map((axis)=>{
            const mt = 1 - t;
            return mt * mt * mt * axis[0] + 3 * mt * mt * t * axis[1] + 3 * mt * t * t * axis[2] + t * t * t * axis[3];
        }));
}
class $297515b488d52990$export$17d680238e50603e extends (0, $dfc94508c89c186c$export$6428a7f2611ef1fa) {
    constructor(config){
        super(config);
        this.on("pointsChange.konva tensionChange.konva closedChange.konva bezierChange.konva", function() {
            this._clearCache("tensionPoints");
        });
    }
    _sceneFunc(context) {
        const points = this.points(), length = points.length, tension = this.tension(), closed = this.closed(), bezier = this.bezier();
        if (!length) return;
        let n = 0;
        context.beginPath();
        context.moveTo(points[0], points[1]);
        if (tension !== 0 && length > 4) {
            const tp = this.getTensionPoints();
            const len = tp.length;
            n = closed ? 0 : 4;
            if (!closed) context.quadraticCurveTo(tp[0], tp[1], tp[2], tp[3]);
            while(n < len - 2)context.bezierCurveTo(tp[n++], tp[n++], tp[n++], tp[n++], tp[n++], tp[n++]);
            if (!closed) context.quadraticCurveTo(tp[len - 2], tp[len - 1], points[length - 2], points[length - 1]);
        } else if (bezier) {
            n = 2;
            while(n < length)context.bezierCurveTo(points[n++], points[n++], points[n++], points[n++], points[n++], points[n++]);
        } else for(n = 2; n < length; n += 2)context.lineTo(points[n], points[n + 1]);
        if (closed) {
            context.closePath();
            context.fillStrokeShape(this);
        } else context.strokeShape(this);
    }
    getTensionPoints() {
        return this._getCache("tensionPoints", this._getTensionPoints);
    }
    _getTensionPoints() {
        if (this.closed()) return this._getTensionPointsClosed();
        else return $297515b488d52990$var$expandPoints(this.points(), this.tension());
    }
    _getTensionPointsClosed() {
        const p = this.points(), len = p.length, tension = this.tension(), firstControlPoints = $297515b488d52990$var$getControlPoints(p[len - 2], p[len - 1], p[0], p[1], p[2], p[3], tension), lastControlPoints = $297515b488d52990$var$getControlPoints(p[len - 4], p[len - 3], p[len - 2], p[len - 1], p[0], p[1], tension), middle = $297515b488d52990$var$expandPoints(p, tension), tp = [
            firstControlPoints[2],
            firstControlPoints[3]
        ].concat(middle).concat([
            lastControlPoints[0],
            lastControlPoints[1],
            p[len - 2],
            p[len - 1],
            lastControlPoints[2],
            lastControlPoints[3],
            firstControlPoints[0],
            firstControlPoints[1],
            p[0],
            p[1]
        ]);
        return tp;
    }
    getWidth() {
        return this.getSelfRect().width;
    }
    getHeight() {
        return this.getSelfRect().height;
    }
    getSelfRect() {
        let points = this.points();
        if (points.length < 4) return {
            x: points[0] || 0,
            y: points[1] || 0,
            width: 0,
            height: 0
        };
        if (this.tension() !== 0) points = [
            points[0],
            points[1],
            ...this._getTensionPoints(),
            points[points.length - 2],
            points[points.length - 1]
        ];
        else if (this.bezier()) points = [
            points[0],
            points[1],
            ...$297515b488d52990$var$getBezierExtremaPoints(this.points()),
            points[points.length - 2],
            points[points.length - 1]
        ];
        else points = this.points();
        let minX = points[0];
        let maxX = points[0];
        let minY = points[1];
        let maxY = points[1];
        let x, y;
        for(let i = 0; i < points.length / 2; i++){
            x = points[i * 2];
            y = points[i * 2 + 1];
            minX = Math.min(minX, x);
            maxX = Math.max(maxX, x);
            minY = Math.min(minY, y);
            maxY = Math.max(maxY, y);
        }
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    }
}
$297515b488d52990$export$17d680238e50603e.prototype.className = "Line";
$297515b488d52990$export$17d680238e50603e.prototype._attrsAffectingSize = [
    "points",
    "bezier",
    "tension"
];
(0, $bd77714a0ea3dd4d$export$f7a70d87a5e829eb)($297515b488d52990$export$17d680238e50603e);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($297515b488d52990$export$17d680238e50603e, "closed", false);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($297515b488d52990$export$17d680238e50603e, "bezier", false);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($297515b488d52990$export$17d680238e50603e, "tension", 0, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($297515b488d52990$export$17d680238e50603e, "points", [], (0, $dc39f19751b6eb0f$export$42b6f8f340e9a165)());







const $345fe44424a3a77d$export$9b0e545caa171200 = [
    [],
    [],
    [
        -0.5773502691896257,
        0.5773502691896257645091487805019574556476
    ],
    [
        0,
        -0.7745966692414834,
        0.7745966692414833770358530799564799221665
    ],
    [
        -0.33998104358485626,
        0.3399810435848562648026657591032446872005,
        -0.8611363115940526,
        0.8611363115940525752239464888928095050957
    ],
    [
        0,
        -0.5384693101056831,
        0.5384693101056830910363144207002088049672,
        -0.906179845938664,
        0.9061798459386639927976268782993929651256
    ],
    [
        0.6612093864662645136613995950199053470064,
        -0.6612093864662645,
        -0.2386191860831969,
        0.2386191860831969086305017216807119354186,
        -0.932469514203152,
        0.9324695142031520278123015544939946091347
    ],
    [
        0,
        0.4058451513773971669066064120769614633473,
        -0.4058451513773972,
        -0.7415311855993945,
        0.7415311855993944398638647732807884070741,
        -0.9491079123427585,
        0.9491079123427585245261896840478512624007
    ],
    [
        -0.1834346424956498,
        0.1834346424956498049394761423601839806667,
        -0.525532409916329,
        0.5255324099163289858177390491892463490419,
        -0.7966664774136267,
        0.7966664774136267395915539364758304368371,
        -0.9602898564975363,
        0.9602898564975362316835608685694729904282
    ],
    [
        0,
        -0.8360311073266358,
        0.8360311073266357942994297880697348765441,
        -0.9681602395076261,
        0.9681602395076260898355762029036728700494,
        -0.3242534234038089,
        0.3242534234038089290385380146433366085719,
        -0.6133714327005904,
        0.6133714327005903973087020393414741847857
    ],
    [
        -0.14887433898163122,
        0.1488743389816312108848260011297199846175,
        -0.4333953941292472,
        0.4333953941292471907992659431657841622,
        -0.6794095682990244,
        0.6794095682990244062343273651148735757692,
        -0.8650633666889845,
        0.8650633666889845107320966884234930485275,
        -0.9739065285171717,
        0.9739065285171717200779640120844520534282
    ],
    [
        0,
        -0.26954315595234496,
        0.2695431559523449723315319854008615246796,
        -0.5190961292068118,
        0.5190961292068118159257256694586095544802,
        -0.7301520055740494,
        0.7301520055740493240934162520311534580496,
        -0.8870625997680953,
        0.8870625997680952990751577693039272666316,
        -0.978228658146057,
        0.9782286581460569928039380011228573907714
    ],
    [
        -0.1252334085114689,
        0.1252334085114689154724413694638531299833,
        -0.3678314989981802,
        0.3678314989981801937526915366437175612563,
        -0.5873179542866175,
        0.587317954286617447296702418940534280369,
        -0.7699026741943047,
        0.7699026741943046870368938332128180759849,
        -0.9041172563704749,
        0.9041172563704748566784658661190961925375,
        -0.9815606342467192,
        0.9815606342467192506905490901492808229601
    ],
    [
        0,
        -0.2304583159551348,
        0.2304583159551347940655281210979888352115,
        -0.44849275103644687,
        0.4484927510364468528779128521276398678019,
        -0.6423493394403402,
        0.6423493394403402206439846069955156500716,
        -0.8015780907333099,
        0.8015780907333099127942064895828598903056,
        -0.9175983992229779,
        0.9175983992229779652065478365007195123904,
        -0.9841830547185881,
        0.9841830547185881494728294488071096110649
    ],
    [
        -0.10805494870734367,
        0.1080549487073436620662446502198347476119,
        -0.31911236892788974,
        0.3191123689278897604356718241684754668342,
        -0.5152486363581541,
        0.5152486363581540919652907185511886623088,
        -0.6872929048116855,
        0.6872929048116854701480198030193341375384,
        -0.827201315069765,
        0.8272013150697649931897947426503949610397,
        -0.9284348836635735,
        0.928434883663573517336391139377874264477,
        -0.9862838086968123,
        0.986283808696812338841597266704052801676
    ],
    [
        0,
        -0.20119409399743451,
        0.2011940939974345223006283033945962078128,
        -0.3941513470775634,
        0.3941513470775633698972073709810454683627,
        -0.5709721726085388,
        0.5709721726085388475372267372539106412383,
        -0.7244177313601701,
        0.7244177313601700474161860546139380096308,
        -0.8482065834104272,
        0.8482065834104272162006483207742168513662,
        -0.937273392400706,
        0.9372733924007059043077589477102094712439,
        -0.9879925180204854,
        0.9879925180204854284895657185866125811469
    ],
    [
        -0.09501250983763744,
        0.0950125098376374401853193354249580631303,
        -0.2816035507792589,
        0.281603550779258913230460501460496106486,
        -0.45801677765722737,
        0.45801677765722738634241944298357757354,
        -0.6178762444026438,
        0.6178762444026437484466717640487910189918,
        -0.755404408355003,
        0.7554044083550030338951011948474422683538,
        -0.8656312023878318,
        0.8656312023878317438804678977123931323873,
        -0.9445750230732326,
        0.9445750230732325760779884155346083450911,
        -0.9894009349916499,
        0.9894009349916499325961541734503326274262
    ],
    [
        0,
        -0.17848418149584785,
        0.1784841814958478558506774936540655574754,
        -0.3512317634538763,
        0.3512317634538763152971855170953460050405,
        -0.5126905370864769,
        0.5126905370864769678862465686295518745829,
        -0.6576711592166907,
        0.6576711592166907658503022166430023351478,
        -0.7815140038968014,
        0.7815140038968014069252300555204760502239,
        -0.8802391537269859,
        0.8802391537269859021229556944881556926234,
        -0.9506755217687678,
        0.9506755217687677612227169578958030214433,
        -0.9905754753144174,
        0.9905754753144173356754340199406652765077
    ],
    [
        -0.0847750130417353,
        0.0847750130417353012422618529357838117333,
        -0.2518862256915055,
        0.2518862256915055095889728548779112301628,
        -0.41175116146284263,
        0.4117511614628426460359317938330516370789,
        -0.5597708310739475,
        0.5597708310739475346078715485253291369276,
        -0.6916870430603532,
        0.6916870430603532078748910812888483894522,
        -0.8037049589725231,
        0.8037049589725231156824174550145907971032,
        -0.8926024664975557,
        0.8926024664975557392060605911271455154078,
        -0.9558239495713977,
        0.9558239495713977551811958929297763099728,
        -0.9915651684209309,
        0.9915651684209309467300160047061507702525
    ],
    [
        0,
        -0.16035864564022537,
        0.1603586456402253758680961157407435495048,
        -0.31656409996362983,
        0.3165640999636298319901173288498449178922,
        -0.46457074137596094,
        0.4645707413759609457172671481041023679762,
        -0.600545304661681,
        0.6005453046616810234696381649462392798683,
        -0.7209661773352294,
        0.7209661773352293786170958608237816296571,
        -0.8227146565371428,
        0.8227146565371428249789224867127139017745,
        -0.9031559036148179,
        0.9031559036148179016426609285323124878093,
        -0.96020815213483,
        0.960208152134830030852778840687651526615,
        -0.9924068438435844,
        0.9924068438435844031890176702532604935893
    ],
    [
        -0.07652652113349734,
        0.0765265211334973337546404093988382110047,
        -0.22778585114164507,
        0.227785851141645078080496195368574624743,
        -0.37370608871541955,
        0.3737060887154195606725481770249272373957,
        -0.5108670019508271,
        0.5108670019508270980043640509552509984254,
        -0.636053680726515,
        0.6360536807265150254528366962262859367433,
        -0.7463319064601508,
        0.7463319064601507926143050703556415903107,
        -0.8391169718222188,
        0.8391169718222188233945290617015206853296,
        -0.912234428251326,
        0.9122344282513259058677524412032981130491,
        -0.9639719272779138,
        0.963971927277913791267666131197277221912,
        -0.9931285991850949,
        0.9931285991850949247861223884713202782226
    ],
    [
        0,
        -0.1455618541608951,
        0.1455618541608950909370309823386863301163,
        -0.2880213168024011,
        0.288021316802401096600792516064600319909,
        -0.4243421202074388,
        0.4243421202074387835736688885437880520964,
        -0.5516188358872198,
        0.551618835887219807059018796724313286622,
        -0.6671388041974123,
        0.667138804197412319305966669990339162597,
        -0.7684399634756779,
        0.7684399634756779086158778513062280348209,
        -0.8533633645833173,
        0.8533633645833172836472506385875676702761,
        -0.9200993341504008,
        0.9200993341504008287901871337149688941591,
        -0.9672268385663063,
        0.9672268385663062943166222149076951614246,
        -0.9937521706203895,
        0.9937521706203895002602420359379409291933
    ],
    [
        -0.06973927331972223,
        0.0697392733197222212138417961186280818222,
        -0.20786042668822127,
        0.2078604266882212854788465339195457342156,
        -0.34193582089208424,
        0.3419358208920842251581474204273796195591,
        -0.469355837986757,
        0.4693558379867570264063307109664063460953,
        -0.5876404035069116,
        0.5876404035069115929588769276386473488776,
        -0.6944872631866827,
        0.6944872631866827800506898357622567712673,
        -0.7878168059792081,
        0.7878168059792081620042779554083515213881,
        -0.8658125777203002,
        0.8658125777203001365364256370193787290847,
        -0.926956772187174,
        0.9269567721871740005206929392590531966353,
        -0.9700604978354287,
        0.9700604978354287271239509867652687108059,
        -0.9942945854823992,
        0.994294585482399292073031421161298980393
    ],
    [
        0,
        -0.1332568242984661,
        0.1332568242984661109317426822417661370104,
        -0.26413568097034495,
        0.264135680970344930533869538283309602979,
        -0.3903010380302908,
        0.390301038030290831421488872880605458578,
        -0.5095014778460075,
        0.5095014778460075496897930478668464305448,
        -0.6196098757636461,
        0.6196098757636461563850973116495956533871,
        -0.7186613631319502,
        0.7186613631319501944616244837486188483299,
        -0.8048884016188399,
        0.8048884016188398921511184069967785579414,
        -0.8767523582704416,
        0.8767523582704416673781568859341456716389,
        -0.9329710868260161,
        0.9329710868260161023491969890384229782357,
        -0.9725424712181152,
        0.9725424712181152319560240768207773751816,
        -0.9947693349975522,
        0.9947693349975521235239257154455743605736
    ],
    [
        -0.06405689286260563,
        0.0640568928626056260850430826247450385909,
        -0.1911188674736163,
        0.1911188674736163091586398207570696318404,
        -0.3150426796961634,
        0.3150426796961633743867932913198102407864,
        -0.4337935076260451,
        0.4337935076260451384870842319133497124524,
        -0.5454214713888396,
        0.5454214713888395356583756172183723700107,
        -0.6480936519369755,
        0.6480936519369755692524957869107476266696,
        -0.7401241915785544,
        0.7401241915785543642438281030999784255232,
        -0.820001985973903,
        0.8200019859739029219539498726697452080761,
        -0.8864155270044011,
        0.8864155270044010342131543419821967550873,
        -0.9382745520027328,
        0.9382745520027327585236490017087214496548,
        -0.9747285559713095,
        0.9747285559713094981983919930081690617411,
        -0.9951872199970213,
        0.9951872199970213601799974097007368118745
    ]
];
const $345fe44424a3a77d$export$63f082a24e4d0d2 = [
    [],
    [],
    [
        1.0,
        1.0
    ],
    [
        0.8888888888888888888888888888888888888888,
        0.5555555555555555555555555555555555555555,
        0.5555555555555555555555555555555555555555
    ],
    [
        0.6521451548625461426269360507780005927646,
        0.6521451548625461426269360507780005927646,
        0.3478548451374538573730639492219994072353,
        0.3478548451374538573730639492219994072353
    ],
    [
        0.5688888888888888888888888888888888888888,
        0.4786286704993664680412915148356381929122,
        0.4786286704993664680412915148356381929122,
        0.2369268850561890875142640407199173626432,
        0.2369268850561890875142640407199173626432
    ],
    [
        0.3607615730481386075698335138377161116615,
        0.3607615730481386075698335138377161116615,
        0.4679139345726910473898703439895509948116,
        0.4679139345726910473898703439895509948116,
        0.1713244923791703450402961421727328935268,
        0.1713244923791703450402961421727328935268
    ],
    [
        0.4179591836734693877551020408163265306122,
        0.3818300505051189449503697754889751338783,
        0.3818300505051189449503697754889751338783,
        0.2797053914892766679014677714237795824869,
        0.2797053914892766679014677714237795824869,
        0.1294849661688696932706114326790820183285,
        0.1294849661688696932706114326790820183285
    ],
    [
        0.3626837833783619829651504492771956121941,
        0.3626837833783619829651504492771956121941,
        0.3137066458778872873379622019866013132603,
        0.3137066458778872873379622019866013132603,
        0.2223810344533744705443559944262408844301,
        0.2223810344533744705443559944262408844301,
        0.1012285362903762591525313543099621901153,
        0.1012285362903762591525313543099621901153
    ],
    [
        0.3302393550012597631645250692869740488788,
        0.1806481606948574040584720312429128095143,
        0.1806481606948574040584720312429128095143,
        0.0812743883615744119718921581105236506756,
        0.0812743883615744119718921581105236506756,
        0.3123470770400028400686304065844436655987,
        0.3123470770400028400686304065844436655987,
        0.2606106964029354623187428694186328497718,
        0.2606106964029354623187428694186328497718
    ],
    [
        0.295524224714752870173892994651338329421,
        0.295524224714752870173892994651338329421,
        0.2692667193099963550912269215694693528597,
        0.2692667193099963550912269215694693528597,
        0.2190863625159820439955349342281631924587,
        0.2190863625159820439955349342281631924587,
        0.1494513491505805931457763396576973324025,
        0.1494513491505805931457763396576973324025,
        0.0666713443086881375935688098933317928578,
        0.0666713443086881375935688098933317928578
    ],
    [
        0.272925086777900630714483528336342189156,
        0.2628045445102466621806888698905091953727,
        0.2628045445102466621806888698905091953727,
        0.2331937645919904799185237048431751394317,
        0.2331937645919904799185237048431751394317,
        0.1862902109277342514260976414316558916912,
        0.1862902109277342514260976414316558916912,
        0.1255803694649046246346942992239401001976,
        0.1255803694649046246346942992239401001976,
        0.0556685671161736664827537204425485787285,
        0.0556685671161736664827537204425485787285
    ],
    [
        0.2491470458134027850005624360429512108304,
        0.2491470458134027850005624360429512108304,
        0.2334925365383548087608498989248780562594,
        0.2334925365383548087608498989248780562594,
        0.2031674267230659217490644558097983765065,
        0.2031674267230659217490644558097983765065,
        0.160078328543346226334652529543359071872,
        0.160078328543346226334652529543359071872,
        0.1069393259953184309602547181939962242145,
        0.1069393259953184309602547181939962242145,
        0.047175336386511827194615961485017060317,
        0.047175336386511827194615961485017060317
    ],
    [
        0.2325515532308739101945895152688359481566,
        0.2262831802628972384120901860397766184347,
        0.2262831802628972384120901860397766184347,
        0.2078160475368885023125232193060527633865,
        0.2078160475368885023125232193060527633865,
        0.1781459807619457382800466919960979955128,
        0.1781459807619457382800466919960979955128,
        0.1388735102197872384636017768688714676218,
        0.1388735102197872384636017768688714676218,
        0.0921214998377284479144217759537971209236,
        0.0921214998377284479144217759537971209236,
        0.0404840047653158795200215922009860600419,
        0.0404840047653158795200215922009860600419
    ],
    [
        0.2152638534631577901958764433162600352749,
        0.2152638534631577901958764433162600352749,
        0.2051984637212956039659240656612180557103,
        0.2051984637212956039659240656612180557103,
        0.1855383974779378137417165901251570362489,
        0.1855383974779378137417165901251570362489,
        0.1572031671581935345696019386238421566056,
        0.1572031671581935345696019386238421566056,
        0.1215185706879031846894148090724766259566,
        0.1215185706879031846894148090724766259566,
        0.0801580871597602098056332770628543095836,
        0.0801580871597602098056332770628543095836,
        0.0351194603317518630318328761381917806197,
        0.0351194603317518630318328761381917806197
    ],
    [
        0.2025782419255612728806201999675193148386,
        0.1984314853271115764561183264438393248186,
        0.1984314853271115764561183264438393248186,
        0.1861610000155622110268005618664228245062,
        0.1861610000155622110268005618664228245062,
        0.1662692058169939335532008604812088111309,
        0.1662692058169939335532008604812088111309,
        0.1395706779261543144478047945110283225208,
        0.1395706779261543144478047945110283225208,
        0.1071592204671719350118695466858693034155,
        0.1071592204671719350118695466858693034155,
        0.0703660474881081247092674164506673384667,
        0.0703660474881081247092674164506673384667,
        0.0307532419961172683546283935772044177217,
        0.0307532419961172683546283935772044177217
    ],
    [
        0.1894506104550684962853967232082831051469,
        0.1894506104550684962853967232082831051469,
        0.1826034150449235888667636679692199393835,
        0.1826034150449235888667636679692199393835,
        0.1691565193950025381893120790303599622116,
        0.1691565193950025381893120790303599622116,
        0.1495959888165767320815017305474785489704,
        0.1495959888165767320815017305474785489704,
        0.1246289712555338720524762821920164201448,
        0.1246289712555338720524762821920164201448,
        0.0951585116824927848099251076022462263552,
        0.0951585116824927848099251076022462263552,
        0.0622535239386478928628438369943776942749,
        0.0622535239386478928628438369943776942749,
        0.0271524594117540948517805724560181035122,
        0.0271524594117540948517805724560181035122
    ],
    [
        0.1794464703562065254582656442618856214487,
        0.1765627053669926463252709901131972391509,
        0.1765627053669926463252709901131972391509,
        0.1680041021564500445099706637883231550211,
        0.1680041021564500445099706637883231550211,
        0.1540457610768102880814315948019586119404,
        0.1540457610768102880814315948019586119404,
        0.1351363684685254732863199817023501973721,
        0.1351363684685254732863199817023501973721,
        0.1118838471934039710947883856263559267358,
        0.1118838471934039710947883856263559267358,
        0.0850361483171791808835353701910620738504,
        0.0850361483171791808835353701910620738504,
        0.0554595293739872011294401653582446605128,
        0.0554595293739872011294401653582446605128,
        0.0241483028685479319601100262875653246916,
        0.0241483028685479319601100262875653246916
    ],
    [
        0.1691423829631435918406564701349866103341,
        0.1691423829631435918406564701349866103341,
        0.1642764837458327229860537764659275904123,
        0.1642764837458327229860537764659275904123,
        0.1546846751262652449254180038363747721932,
        0.1546846751262652449254180038363747721932,
        0.1406429146706506512047313037519472280955,
        0.1406429146706506512047313037519472280955,
        0.1225552067114784601845191268002015552281,
        0.1225552067114784601845191268002015552281,
        0.1009420441062871655628139849248346070628,
        0.1009420441062871655628139849248346070628,
        0.0764257302548890565291296776166365256053,
        0.0764257302548890565291296776166365256053,
        0.0497145488949697964533349462026386416808,
        0.0497145488949697964533349462026386416808,
        0.0216160135264833103133427102664524693876,
        0.0216160135264833103133427102664524693876
    ],
    [
        0.1610544498487836959791636253209167350399,
        0.1589688433939543476499564394650472016787,
        0.1589688433939543476499564394650472016787,
        0.152766042065859666778855400897662998461,
        0.152766042065859666778855400897662998461,
        0.1426067021736066117757461094419029724756,
        0.1426067021736066117757461094419029724756,
        0.1287539625393362276755157848568771170558,
        0.1287539625393362276755157848568771170558,
        0.1115666455473339947160239016817659974813,
        0.1115666455473339947160239016817659974813,
        0.0914900216224499994644620941238396526609,
        0.0914900216224499994644620941238396526609,
        0.0690445427376412265807082580060130449618,
        0.0690445427376412265807082580060130449618,
        0.0448142267656996003328381574019942119517,
        0.0448142267656996003328381574019942119517,
        0.0194617882297264770363120414644384357529,
        0.0194617882297264770363120414644384357529
    ],
    [
        0.1527533871307258506980843319550975934919,
        0.1527533871307258506980843319550975934919,
        0.1491729864726037467878287370019694366926,
        0.1491729864726037467878287370019694366926,
        0.1420961093183820513292983250671649330345,
        0.1420961093183820513292983250671649330345,
        0.1316886384491766268984944997481631349161,
        0.1316886384491766268984944997481631349161,
        0.118194531961518417312377377711382287005,
        0.118194531961518417312377377711382287005,
        0.1019301198172404350367501354803498761666,
        0.1019301198172404350367501354803498761666,
        0.0832767415767047487247581432220462061001,
        0.0832767415767047487247581432220462061001,
        0.0626720483341090635695065351870416063516,
        0.0626720483341090635695065351870416063516,
        0.040601429800386941331039952274932109879,
        0.040601429800386941331039952274932109879,
        0.0176140071391521183118619623518528163621,
        0.0176140071391521183118619623518528163621
    ],
    [
        0.1460811336496904271919851476833711882448,
        0.1445244039899700590638271665537525436099,
        0.1445244039899700590638271665537525436099,
        0.1398873947910731547221334238675831108927,
        0.1398873947910731547221334238675831108927,
        0.132268938633337461781052574496775604329,
        0.132268938633337461781052574496775604329,
        0.1218314160537285341953671771257335983563,
        0.1218314160537285341953671771257335983563,
        0.1087972991671483776634745780701056420336,
        0.1087972991671483776634745780701056420336,
        0.0934444234560338615532897411139320884835,
        0.0934444234560338615532897411139320884835,
        0.0761001136283793020170516533001831792261,
        0.0761001136283793020170516533001831792261,
        0.0571344254268572082836358264724479574912,
        0.0571344254268572082836358264724479574912,
        0.0369537897708524937999506682993296661889,
        0.0369537897708524937999506682993296661889,
        0.0160172282577743333242246168584710152658,
        0.0160172282577743333242246168584710152658
    ],
    [
        0.1392518728556319933754102483418099578739,
        0.1392518728556319933754102483418099578739,
        0.1365414983460151713525738312315173965863,
        0.1365414983460151713525738312315173965863,
        0.1311735047870623707329649925303074458757,
        0.1311735047870623707329649925303074458757,
        0.1232523768105124242855609861548144719594,
        0.1232523768105124242855609861548144719594,
        0.1129322960805392183934006074217843191142,
        0.1129322960805392183934006074217843191142,
        0.1004141444428809649320788378305362823508,
        0.1004141444428809649320788378305362823508,
        0.0859416062170677274144436813727028661891,
        0.0859416062170677274144436813727028661891,
        0.0697964684245204880949614189302176573987,
        0.0697964684245204880949614189302176573987,
        0.0522933351526832859403120512732112561121,
        0.0522933351526832859403120512732112561121,
        0.0337749015848141547933022468659129013491,
        0.0337749015848141547933022468659129013491,
        0.0146279952982722006849910980471854451902,
        0.0146279952982722006849910980471854451902
    ],
    [
        0.1336545721861061753514571105458443385831,
        0.132462039404696617371642464703316925805,
        0.132462039404696617371642464703316925805,
        0.1289057221880821499785953393997936532597,
        0.1289057221880821499785953393997936532597,
        0.1230490843067295304675784006720096548158,
        0.1230490843067295304675784006720096548158,
        0.1149966402224113649416435129339613014914,
        0.1149966402224113649416435129339613014914,
        0.1048920914645414100740861850147438548584,
        0.1048920914645414100740861850147438548584,
        0.0929157660600351474770186173697646486034,
        0.0929157660600351474770186173697646486034,
        0.0792814117767189549228925247420432269137,
        0.0792814117767189549228925247420432269137,
        0.0642324214085258521271696151589109980391,
        0.0642324214085258521271696151589109980391,
        0.0480376717310846685716410716320339965612,
        0.0480376717310846685716410716320339965612,
        0.0309880058569794443106942196418845053837,
        0.0309880058569794443106942196418845053837,
        0.0134118594871417720813094934586150649766,
        0.0134118594871417720813094934586150649766
    ],
    [
        0.1279381953467521569740561652246953718517,
        0.1279381953467521569740561652246953718517,
        0.1258374563468282961213753825111836887264,
        0.1258374563468282961213753825111836887264,
        0.121670472927803391204463153476262425607,
        0.121670472927803391204463153476262425607,
        0.1155056680537256013533444839067835598622,
        0.1155056680537256013533444839067835598622,
        0.1074442701159656347825773424466062227946,
        0.1074442701159656347825773424466062227946,
        0.0976186521041138882698806644642471544279,
        0.0976186521041138882698806644642471544279,
        0.086190161531953275917185202983742667185,
        0.086190161531953275917185202983742667185,
        0.0733464814110803057340336152531165181193,
        0.0733464814110803057340336152531165181193,
        0.0592985849154367807463677585001085845412,
        0.0592985849154367807463677585001085845412,
        0.0442774388174198061686027482113382288593,
        0.0442774388174198061686027482113382288593,
        0.0285313886289336631813078159518782864491,
        0.0285313886289336631813078159518782864491,
        0.0123412297999871995468056670700372915759,
        0.0123412297999871995468056670700372915759
    ]
];
const $345fe44424a3a77d$export$75c342514231e6de = [
    [
        1
    ],
    [
        1,
        1
    ],
    [
        1,
        2,
        1
    ],
    [
        1,
        3,
        3,
        1
    ]
];
const $345fe44424a3a77d$export$303d0010d4a82673 = (xs, ys, t)=>{
    let sum;
    let correctedT;
    const n = 20;
    const z = t / 2;
    sum = 0;
    for(let i = 0; i < n; i++){
        correctedT = z * $345fe44424a3a77d$export$9b0e545caa171200[n][i] + z;
        sum += $345fe44424a3a77d$export$63f082a24e4d0d2[n][i] * $345fe44424a3a77d$var$BFunc(xs, ys, correctedT);
    }
    return z * sum;
};
const $345fe44424a3a77d$export$80a8cfc7cba8a0a9 = (xs, ys, t)=>{
    if (t === undefined) t = 1;
    const ax = xs[0] - 2 * xs[1] + xs[2];
    const ay = ys[0] - 2 * ys[1] + ys[2];
    const bx = 2 * xs[1] - 2 * xs[0];
    const by = 2 * ys[1] - 2 * ys[0];
    const A = 4 * (ax * ax + ay * ay);
    const B = 4 * (ax * bx + ay * by);
    const C = bx * bx + by * by;
    if (A === 0) return t * Math.sqrt(Math.pow(xs[2] - xs[0], 2) + Math.pow(ys[2] - ys[0], 2));
    const b = B / (2 * A);
    const c = C / A;
    const u = t + b;
    const k = c - b * b;
    const uuk = u * u + k > 0 ? Math.sqrt(u * u + k) : 0;
    const bbk = b * b + k > 0 ? Math.sqrt(b * b + k) : 0;
    const term = b + Math.sqrt(b * b + k) !== 0 ? k * Math.log(Math.abs((u + uuk) / (b + bbk))) : 0;
    return Math.sqrt(A) / 2 * (u * uuk - b * bbk + term);
};
function $345fe44424a3a77d$var$BFunc(xs, ys, t) {
    const xbase = $345fe44424a3a77d$var$getDerivative(1, t, xs);
    const ybase = $345fe44424a3a77d$var$getDerivative(1, t, ys);
    const combined = xbase * xbase + ybase * ybase;
    return Math.sqrt(combined);
}
const $345fe44424a3a77d$var$getDerivative = (derivative, t, vs)=>{
    const n = vs.length - 1;
    let _vs;
    let value;
    if (n === 0) return 0;
    if (derivative === 0) {
        value = 0;
        for(let k = 0; k <= n; k++)value += $345fe44424a3a77d$export$75c342514231e6de[n][k] * Math.pow(1 - t, n - k) * Math.pow(t, k) * vs[k];
        return value;
    } else {
        _vs = new Array(n);
        for(let k = 0; k < n; k++)_vs[k] = n * (vs[k + 1] - vs[k]);
        return $345fe44424a3a77d$var$getDerivative(derivative - 1, t, _vs);
    }
};
const $345fe44424a3a77d$export$e638253c5cb35420 = (length, totalLength, func)=>{
    let error = 1;
    let t = length / totalLength;
    let step = (length - func(t)) / totalLength;
    let numIterations = 0;
    while(error > 0.001){
        const increasedTLength = func(t + step);
        const increasedTError = Math.abs(length - increasedTLength) / totalLength;
        if (increasedTError < error) {
            error = increasedTError;
            t += step;
        } else {
            const decreasedTLength = func(t - step);
            const decreasedTError = Math.abs(length - decreasedTLength) / totalLength;
            if (decreasedTError < error) {
                error = decreasedTError;
                t -= step;
            } else step /= 2;
        }
        numIterations++;
        if (numIterations > 500) break;
    }
    return t;
};


class $df50b4cb4b867012$export$4b2950bdac9b6ee9 extends (0, $dfc94508c89c186c$export$6428a7f2611ef1fa) {
    constructor(config){
        super(config);
        this.dataArray = [];
        this.pathLength = 0;
        this._readDataAttribute();
        this.on("dataChange.konva", function() {
            this._readDataAttribute();
        });
    }
    _readDataAttribute() {
        this.dataArray = $df50b4cb4b867012$export$4b2950bdac9b6ee9.parsePathData(this.data());
        this.pathLength = $df50b4cb4b867012$export$4b2950bdac9b6ee9.getPathLength(this.dataArray);
    }
    _sceneFunc(context) {
        const ca = this.dataArray;
        context.beginPath();
        let isClosed = false;
        for(let n = 0; n < ca.length; n++){
            const c = ca[n].command;
            const p = ca[n].points;
            switch(c){
                case "L":
                    context.lineTo(p[0], p[1]);
                    break;
                case "M":
                    context.moveTo(p[0], p[1]);
                    break;
                case "C":
                    context.bezierCurveTo(p[0], p[1], p[2], p[3], p[4], p[5]);
                    break;
                case "Q":
                    context.quadraticCurveTo(p[0], p[1], p[2], p[3]);
                    break;
                case "A":
                    const cx = p[0], cy = p[1], rx = p[2], ry = p[3], theta = p[4], dTheta = p[5], psi = p[6], fs = p[7];
                    const r = rx > ry ? rx : ry;
                    const scaleX = rx > ry ? 1 : rx / ry;
                    const scaleY = rx > ry ? ry / rx : 1;
                    context.translate(cx, cy);
                    context.rotate(psi);
                    context.scale(scaleX, scaleY);
                    context.arc(0, 0, r, theta, theta + dTheta, 1 - fs);
                    context.scale(1 / scaleX, 1 / scaleY);
                    context.rotate(-psi);
                    context.translate(-cx, -cy);
                    break;
                case "z":
                    isClosed = true;
                    context.closePath();
                    break;
            }
        }
        if (!isClosed && !this.hasFill()) context.strokeShape(this);
        else context.fillStrokeShape(this);
    }
    getSelfRect() {
        let points = [];
        this.dataArray.forEach(function(data) {
            if (data.command === "A") {
                const start = data.points[4];
                const dTheta = data.points[5];
                const end = data.points[4] + dTheta;
                let inc = Math.PI / 180.0;
                if (Math.abs(start - end) < inc) inc = Math.abs(start - end);
                if (dTheta < 0) for(let t = start - inc; t > end; t -= inc){
                    const point = $df50b4cb4b867012$export$4b2950bdac9b6ee9.getPointOnEllipticalArc(data.points[0], data.points[1], data.points[2], data.points[3], t, 0);
                    points.push(point.x, point.y);
                }
                else for(let t = start + inc; t < end; t += inc){
                    const point = $df50b4cb4b867012$export$4b2950bdac9b6ee9.getPointOnEllipticalArc(data.points[0], data.points[1], data.points[2], data.points[3], t, 0);
                    points.push(point.x, point.y);
                }
            } else if (data.command === "C") for(let t = 0.0; t <= 1; t += 0.01){
                const point = $df50b4cb4b867012$export$4b2950bdac9b6ee9.getPointOnCubicBezier(t, data.start.x, data.start.y, data.points[0], data.points[1], data.points[2], data.points[3], data.points[4], data.points[5]);
                points.push(point.x, point.y);
            }
            else points = points.concat(data.points);
        });
        let minX = points[0];
        let maxX = points[0];
        let minY = points[1];
        let maxY = points[1];
        let x, y;
        for(let i = 0; i < points.length / 2; i++){
            x = points[i * 2];
            y = points[i * 2 + 1];
            if (!isNaN(x)) {
                minX = Math.min(minX, x);
                maxX = Math.max(maxX, x);
            }
            if (!isNaN(y)) {
                minY = Math.min(minY, y);
                maxY = Math.max(maxY, y);
            }
        }
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    }
    getLength() {
        return this.pathLength;
    }
    getPointAtLength(length) {
        return $df50b4cb4b867012$export$4b2950bdac9b6ee9.getPointAtLengthOfDataArray(length, this.dataArray);
    }
    static getLineLength(x1, y1, x2, y2) {
        return Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
    }
    static getPathLength(dataArray) {
        let pathLength = 0;
        for(let i = 0; i < dataArray.length; ++i)pathLength += dataArray[i].pathLength;
        return pathLength;
    }
    static getPointAtLengthOfDataArray(length, dataArray) {
        let points, i = 0, ii = dataArray.length;
        if (!ii) return null;
        while(i < ii && length > dataArray[i].pathLength){
            length -= dataArray[i].pathLength;
            ++i;
        }
        if (i === ii) {
            points = dataArray[i - 1].points.slice(-2);
            return {
                x: points[0],
                y: points[1]
            };
        }
        if (length < 0.01) {
            const cmd = dataArray[i].command;
            if (cmd === "M") {
                points = dataArray[i].points.slice(0, 2);
                return {
                    x: points[0],
                    y: points[1]
                };
            } else return {
                x: dataArray[i].start.x,
                y: dataArray[i].start.y
            };
        }
        const cp = dataArray[i];
        const p = cp.points;
        switch(cp.command){
            case "L":
                return $df50b4cb4b867012$export$4b2950bdac9b6ee9.getPointOnLine(length, cp.start.x, cp.start.y, p[0], p[1]);
            case "C":
                return $df50b4cb4b867012$export$4b2950bdac9b6ee9.getPointOnCubicBezier((0, $345fe44424a3a77d$export$e638253c5cb35420)(length, $df50b4cb4b867012$export$4b2950bdac9b6ee9.getPathLength(dataArray), (i)=>{
                    return (0, $345fe44424a3a77d$export$303d0010d4a82673)([
                        cp.start.x,
                        p[0],
                        p[2],
                        p[4]
                    ], [
                        cp.start.y,
                        p[1],
                        p[3],
                        p[5]
                    ], i);
                }), cp.start.x, cp.start.y, p[0], p[1], p[2], p[3], p[4], p[5]);
            case "Q":
                return $df50b4cb4b867012$export$4b2950bdac9b6ee9.getPointOnQuadraticBezier((0, $345fe44424a3a77d$export$e638253c5cb35420)(length, $df50b4cb4b867012$export$4b2950bdac9b6ee9.getPathLength(dataArray), (i)=>{
                    return (0, $345fe44424a3a77d$export$80a8cfc7cba8a0a9)([
                        cp.start.x,
                        p[0],
                        p[2]
                    ], [
                        cp.start.y,
                        p[1],
                        p[3]
                    ], i);
                }), cp.start.x, cp.start.y, p[0], p[1], p[2], p[3]);
            case "A":
                const cx = p[0], cy = p[1], rx = p[2], ry = p[3], dTheta = p[5], psi = p[6];
                let theta = p[4];
                theta += dTheta * length / cp.pathLength;
                return $df50b4cb4b867012$export$4b2950bdac9b6ee9.getPointOnEllipticalArc(cx, cy, rx, ry, theta, psi);
        }
        return null;
    }
    static getPointOnLine(dist, P1x, P1y, P2x, P2y, fromX, fromY) {
        fromX = fromX !== null && fromX !== void 0 ? fromX : P1x;
        fromY = fromY !== null && fromY !== void 0 ? fromY : P1y;
        const len = this.getLineLength(P1x, P1y, P2x, P2y);
        if (len < 1e-10) return {
            x: P1x,
            y: P1y
        };
        if (P2x === P1x) return {
            x: fromX,
            y: fromY + (P2y > P1y ? dist : -dist)
        };
        const m = (P2y - P1y) / (P2x - P1x);
        const run = Math.sqrt(dist * dist / (1 + m * m)) * (P2x < P1x ? -1 : 1);
        const rise = m * run;
        if (Math.abs(fromY - P1y - m * (fromX - P1x)) < 1e-10) return {
            x: fromX + run,
            y: fromY + rise
        };
        const u = ((fromX - P1x) * (P2x - P1x) + (fromY - P1y) * (P2y - P1y)) / (len * len);
        const ix = P1x + u * (P2x - P1x);
        const iy = P1y + u * (P2y - P1y);
        const pRise = this.getLineLength(fromX, fromY, ix, iy);
        const pRun = Math.sqrt(dist * dist - pRise * pRise);
        const adjustedRun = Math.sqrt(pRun * pRun / (1 + m * m)) * (P2x < P1x ? -1 : 1);
        const adjustedRise = m * adjustedRun;
        return {
            x: ix + adjustedRun,
            y: iy + adjustedRise
        };
    }
    static getPointOnCubicBezier(pct, P1x, P1y, P2x, P2y, P3x, P3y, P4x, P4y) {
        function CB1(t) {
            return t * t * t;
        }
        function CB2(t) {
            return 3 * t * t * (1 - t);
        }
        function CB3(t) {
            return 3 * t * (1 - t) * (1 - t);
        }
        function CB4(t) {
            return (1 - t) * (1 - t) * (1 - t);
        }
        const x = P4x * CB1(pct) + P3x * CB2(pct) + P2x * CB3(pct) + P1x * CB4(pct);
        const y = P4y * CB1(pct) + P3y * CB2(pct) + P2y * CB3(pct) + P1y * CB4(pct);
        return {
            x: x,
            y: y
        };
    }
    static getPointOnQuadraticBezier(pct, P1x, P1y, P2x, P2y, P3x, P3y) {
        function QB1(t) {
            return t * t;
        }
        function QB2(t) {
            return 2 * t * (1 - t);
        }
        function QB3(t) {
            return (1 - t) * (1 - t);
        }
        const x = P3x * QB1(pct) + P2x * QB2(pct) + P1x * QB3(pct);
        const y = P3y * QB1(pct) + P2y * QB2(pct) + P1y * QB3(pct);
        return {
            x: x,
            y: y
        };
    }
    static getPointOnEllipticalArc(cx, cy, rx, ry, theta, psi) {
        const cosPsi = Math.cos(psi), sinPsi = Math.sin(psi);
        const pt = {
            x: rx * Math.cos(theta),
            y: ry * Math.sin(theta)
        };
        return {
            x: cx + (pt.x * cosPsi - pt.y * sinPsi),
            y: cy + (pt.x * sinPsi + pt.y * cosPsi)
        };
    }
    static parsePathData(data) {
        if (!data) return [];
        let cs = data;
        const cc = [
            "m",
            "M",
            "l",
            "L",
            "v",
            "V",
            "h",
            "H",
            "z",
            "Z",
            "c",
            "C",
            "q",
            "Q",
            "t",
            "T",
            "s",
            "S",
            "a",
            "A"
        ];
        cs = cs.replace(new RegExp(" ", "g"), ",");
        for(let n = 0; n < cc.length; n++)cs = cs.replace(new RegExp(cc[n], "g"), "|" + cc[n]);
        const arr = cs.split("|");
        const ca = [];
        const coords = [];
        let cpx = 0;
        let cpy = 0;
        const re = /([-+]?((\d+\.\d+)|((\d+)|(\.\d+)))(?:e[-+]?\d+)?)/gi;
        let match;
        for(let n = 1; n < arr.length; n++){
            let str = arr[n];
            let c = str.charAt(0);
            str = str.slice(1);
            coords.length = 0;
            while(match = re.exec(str))coords.push(match[0]);
            let p = [];
            let arcParamIndex = c === "A" || c === "a" ? 0 : -1;
            for(let j = 0, jlen = coords.length; j < jlen; j++){
                const token = coords[j];
                if (token === "00") {
                    p.push(0, 0);
                    if (arcParamIndex >= 0) {
                        arcParamIndex += 2;
                        if (arcParamIndex >= 7) arcParamIndex -= 7;
                    }
                    continue;
                }
                if (arcParamIndex >= 0) {
                    if (arcParamIndex === 3) {
                        if (/^[01]{2}\d+(?:\.\d+)?$/.test(token)) {
                            p.push(parseInt(token[0], 10));
                            p.push(parseInt(token[1], 10));
                            p.push(parseFloat(token.slice(2)));
                            arcParamIndex += 3;
                            if (arcParamIndex >= 7) arcParamIndex -= 7;
                            continue;
                        }
                        if (token === "11" || token === "10" || token === "01") {
                            p.push(parseInt(token[0], 10));
                            p.push(parseInt(token[1], 10));
                            arcParamIndex += 2;
                            if (arcParamIndex >= 7) arcParamIndex -= 7;
                            continue;
                        }
                        if (token === "0" || token === "1") {
                            p.push(parseInt(token, 10));
                            arcParamIndex += 1;
                            if (arcParamIndex >= 7) arcParamIndex -= 7;
                            continue;
                        }
                    } else if (arcParamIndex === 4) {
                        if (/^[01]\d+(?:\.\d+)?$/.test(token)) {
                            p.push(parseInt(token[0], 10));
                            p.push(parseFloat(token.slice(1)));
                            arcParamIndex += 2;
                            if (arcParamIndex >= 7) arcParamIndex -= 7;
                            continue;
                        }
                        if (token === "0" || token === "1") {
                            p.push(parseInt(token, 10));
                            arcParamIndex += 1;
                            if (arcParamIndex >= 7) arcParamIndex -= 7;
                            continue;
                        }
                    }
                    const parsedArc = parseFloat(token);
                    if (!isNaN(parsedArc)) p.push(parsedArc);
                    else p.push(0);
                    arcParamIndex += 1;
                    if (arcParamIndex >= 7) arcParamIndex -= 7;
                } else {
                    const parsed = parseFloat(token);
                    if (!isNaN(parsed)) p.push(parsed);
                    else p.push(0);
                }
            }
            while(p.length > 0){
                if (isNaN(p[0])) break;
                let cmd = "";
                let points = [];
                const startX = cpx, startY = cpy;
                let prevCmd, ctlPtx, ctlPty;
                let rx, ry, psi, fa, fs, x1, y1;
                switch(c){
                    case "l":
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = "L";
                        points.push(cpx, cpy);
                        break;
                    case "L":
                        cpx = p.shift();
                        cpy = p.shift();
                        points.push(cpx, cpy);
                        break;
                    case "m":
                        const dx = p.shift();
                        const dy = p.shift();
                        cpx += dx;
                        cpy += dy;
                        cmd = "M";
                        if (ca.length > 2 && ca[ca.length - 1].command === "z") {
                            for(let idx = ca.length - 2; idx >= 0; idx--)if (ca[idx].command === "M") {
                                cpx = ca[idx].points[0] + dx;
                                cpy = ca[idx].points[1] + dy;
                                break;
                            }
                        }
                        points.push(cpx, cpy);
                        c = "l";
                        break;
                    case "M":
                        cpx = p.shift();
                        cpy = p.shift();
                        cmd = "M";
                        points.push(cpx, cpy);
                        c = "L";
                        break;
                    case "h":
                        cpx += p.shift();
                        cmd = "L";
                        points.push(cpx, cpy);
                        break;
                    case "H":
                        cpx = p.shift();
                        cmd = "L";
                        points.push(cpx, cpy);
                        break;
                    case "v":
                        cpy += p.shift();
                        cmd = "L";
                        points.push(cpx, cpy);
                        break;
                    case "V":
                        cpy = p.shift();
                        cmd = "L";
                        points.push(cpx, cpy);
                        break;
                    case "C":
                        points.push(p.shift(), p.shift(), p.shift(), p.shift());
                        cpx = p.shift();
                        cpy = p.shift();
                        points.push(cpx, cpy);
                        break;
                    case "c":
                        points.push(cpx + p.shift(), cpy + p.shift(), cpx + p.shift(), cpy + p.shift());
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = "C";
                        points.push(cpx, cpy);
                        break;
                    case "S":
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        prevCmd = ca[ca.length - 1];
                        if (prevCmd.command === "C") {
                            ctlPtx = cpx + (cpx - prevCmd.points[2]);
                            ctlPty = cpy + (cpy - prevCmd.points[3]);
                        }
                        points.push(ctlPtx, ctlPty, p.shift(), p.shift());
                        cpx = p.shift();
                        cpy = p.shift();
                        cmd = "C";
                        points.push(cpx, cpy);
                        break;
                    case "s":
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        prevCmd = ca[ca.length - 1];
                        if (prevCmd.command === "C") {
                            ctlPtx = cpx + (cpx - prevCmd.points[2]);
                            ctlPty = cpy + (cpy - prevCmd.points[3]);
                        }
                        points.push(ctlPtx, ctlPty, cpx + p.shift(), cpy + p.shift());
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = "C";
                        points.push(cpx, cpy);
                        break;
                    case "Q":
                        points.push(p.shift(), p.shift());
                        cpx = p.shift();
                        cpy = p.shift();
                        points.push(cpx, cpy);
                        break;
                    case "q":
                        points.push(cpx + p.shift(), cpy + p.shift());
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = "Q";
                        points.push(cpx, cpy);
                        break;
                    case "T":
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        prevCmd = ca[ca.length - 1];
                        if (prevCmd.command === "Q") {
                            ctlPtx = cpx + (cpx - prevCmd.points[0]);
                            ctlPty = cpy + (cpy - prevCmd.points[1]);
                        }
                        cpx = p.shift();
                        cpy = p.shift();
                        cmd = "Q";
                        points.push(ctlPtx, ctlPty, cpx, cpy);
                        break;
                    case "t":
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        prevCmd = ca[ca.length - 1];
                        if (prevCmd.command === "Q") {
                            ctlPtx = cpx + (cpx - prevCmd.points[0]);
                            ctlPty = cpy + (cpy - prevCmd.points[1]);
                        }
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = "Q";
                        points.push(ctlPtx, ctlPty, cpx, cpy);
                        break;
                    case "A":
                        rx = p.shift();
                        ry = p.shift();
                        psi = p.shift();
                        fa = p.shift();
                        fs = p.shift();
                        x1 = cpx;
                        y1 = cpy;
                        cpx = p.shift();
                        cpy = p.shift();
                        cmd = "A";
                        points = this.convertEndpointToCenterParameterization(x1, y1, cpx, cpy, fa, fs, rx, ry, psi);
                        break;
                    case "a":
                        rx = p.shift();
                        ry = p.shift();
                        psi = p.shift();
                        fa = p.shift();
                        fs = p.shift();
                        x1 = cpx;
                        y1 = cpy;
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = "A";
                        points = this.convertEndpointToCenterParameterization(x1, y1, cpx, cpy, fa, fs, rx, ry, psi);
                        break;
                }
                ca.push({
                    command: cmd || c,
                    points: points,
                    start: {
                        x: startX,
                        y: startY
                    },
                    pathLength: this.calcLength(startX, startY, cmd || c, points)
                });
            }
            if (c === "z" || c === "Z") ca.push({
                command: "z",
                points: [],
                start: undefined,
                pathLength: 0
            });
        }
        return ca;
    }
    static calcLength(x, y, cmd, points) {
        let len, p1, p2, t;
        const path = $df50b4cb4b867012$export$4b2950bdac9b6ee9;
        switch(cmd){
            case "L":
                return path.getLineLength(x, y, points[0], points[1]);
            case "C":
                return (0, $345fe44424a3a77d$export$303d0010d4a82673)([
                    x,
                    points[0],
                    points[2],
                    points[4]
                ], [
                    y,
                    points[1],
                    points[3],
                    points[5]
                ], 1);
            case "Q":
                return (0, $345fe44424a3a77d$export$80a8cfc7cba8a0a9)([
                    x,
                    points[0],
                    points[2]
                ], [
                    y,
                    points[1],
                    points[3]
                ], 1);
            case "A":
                len = 0.0;
                const start = points[4];
                const dTheta = points[5];
                const end = points[4] + dTheta;
                let inc = Math.PI / 180.0;
                if (Math.abs(start - end) < inc) inc = Math.abs(start - end);
                p1 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], start, 0);
                if (dTheta < 0) for(t = start - inc; t > end; t -= inc){
                    p2 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], t, 0);
                    len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
                    p1 = p2;
                }
                else for(t = start + inc; t < end; t += inc){
                    p2 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], t, 0);
                    len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
                    p1 = p2;
                }
                p2 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], end, 0);
                len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
                return len;
        }
        return 0;
    }
    static convertEndpointToCenterParameterization(x1, y1, x2, y2, fa, fs, rx, ry, psiDeg) {
        const psi = psiDeg * (Math.PI / 180.0);
        const xp = Math.cos(psi) * (x1 - x2) / 2.0 + Math.sin(psi) * (y1 - y2) / 2.0;
        const yp = -1 * Math.sin(psi) * (x1 - x2) / 2.0 + Math.cos(psi) * (y1 - y2) / 2.0;
        const lambda = xp * xp / (rx * rx) + yp * yp / (ry * ry);
        if (lambda > 1) {
            rx *= Math.sqrt(lambda);
            ry *= Math.sqrt(lambda);
        }
        let f = Math.sqrt((rx * rx * (ry * ry) - rx * rx * (yp * yp) - ry * ry * (xp * xp)) / (rx * rx * (yp * yp) + ry * ry * (xp * xp)));
        if (fa === fs) f *= -1;
        if (isNaN(f)) f = 0;
        const cxp = f * rx * yp / ry;
        const cyp = f * -ry * xp / rx;
        const cx = (x1 + x2) / 2.0 + Math.cos(psi) * cxp - Math.sin(psi) * cyp;
        const cy = (y1 + y2) / 2.0 + Math.sin(psi) * cxp + Math.cos(psi) * cyp;
        const vMag = function(v) {
            return Math.sqrt(v[0] * v[0] + v[1] * v[1]);
        };
        const vRatio = function(u, v) {
            return (u[0] * v[0] + u[1] * v[1]) / (vMag(u) * vMag(v));
        };
        const vAngle = function(u, v) {
            return (u[0] * v[1] < u[1] * v[0] ? -1 : 1) * Math.acos(vRatio(u, v));
        };
        const theta = vAngle([
            1,
            0
        ], [
            (xp - cxp) / rx,
            (yp - cyp) / ry
        ]);
        const u = [
            (xp - cxp) / rx,
            (yp - cyp) / ry
        ];
        const v = [
            (-1 * xp - cxp) / rx,
            (-1 * yp - cyp) / ry
        ];
        let dTheta = vAngle(u, v);
        if (vRatio(u, v) <= -1) dTheta = Math.PI;
        if (vRatio(u, v) >= 1) dTheta = 0;
        if (fs === 0 && dTheta > 0) dTheta = dTheta - 2 * Math.PI;
        if (fs === 1 && dTheta < 0) dTheta = dTheta + 2 * Math.PI;
        return [
            cx,
            cy,
            rx,
            ry,
            theta,
            dTheta,
            psi,
            fs
        ];
    }
}
$df50b4cb4b867012$export$4b2950bdac9b6ee9.prototype.className = "Path";
$df50b4cb4b867012$export$4b2950bdac9b6ee9.prototype._attrsAffectingSize = [
    "data"
];
(0, $bd77714a0ea3dd4d$export$f7a70d87a5e829eb)($df50b4cb4b867012$export$4b2950bdac9b6ee9);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($df50b4cb4b867012$export$4b2950bdac9b6ee9, "data");


class $217b7afd7d07e01a$export$21b07c8f274aebd5 extends (0, $297515b488d52990$export$17d680238e50603e) {
    _sceneFunc(ctx) {
        super._sceneFunc(ctx);
        const PI2 = Math.PI * 2;
        const points = this.points();
        let tp = points;
        const fromTension = this.tension() !== 0 && points.length > 4;
        if (fromTension) tp = this.getTensionPoints();
        const length = this.pointerLength();
        const n = points.length;
        let dx, dy;
        if (fromTension) {
            const lp = [
                tp[tp.length - 4],
                tp[tp.length - 3],
                tp[tp.length - 2],
                tp[tp.length - 1],
                points[n - 2],
                points[n - 1]
            ];
            const lastLength = (0, $df50b4cb4b867012$export$4b2950bdac9b6ee9).calcLength(tp[tp.length - 4], tp[tp.length - 3], "C", lp);
            const previous = (0, $df50b4cb4b867012$export$4b2950bdac9b6ee9).getPointOnQuadraticBezier(Math.min(1, 1 - length / lastLength), lp[0], lp[1], lp[2], lp[3], lp[4], lp[5]);
            dx = points[n - 2] - previous.x;
            dy = points[n - 1] - previous.y;
        } else {
            dx = points[n - 2] - points[n - 4];
            dy = points[n - 1] - points[n - 3];
        }
        const radians = (Math.atan2(dy, dx) + PI2) % PI2;
        const width = this.pointerWidth();
        if (this.pointerAtEnding()) {
            ctx.save();
            ctx.beginPath();
            ctx.translate(points[n - 2], points[n - 1]);
            ctx.rotate(radians);
            ctx.moveTo(0, 0);
            ctx.lineTo(-length, width / 2);
            ctx.lineTo(-length, -width / 2);
            ctx.closePath();
            ctx.restore();
            this.__fillStroke(ctx);
        }
        if (this.pointerAtBeginning()) {
            ctx.save();
            ctx.beginPath();
            ctx.translate(points[0], points[1]);
            if (fromTension) {
                dx = (tp[0] + tp[2]) / 2 - points[0];
                dy = (tp[1] + tp[3]) / 2 - points[1];
            } else {
                dx = points[2] - points[0];
                dy = points[3] - points[1];
            }
            ctx.rotate((Math.atan2(-dy, -dx) + PI2) % PI2);
            ctx.moveTo(0, 0);
            ctx.lineTo(-length, width / 2);
            ctx.lineTo(-length, -width / 2);
            ctx.closePath();
            ctx.restore();
            this.__fillStroke(ctx);
        }
    }
    __fillStroke(ctx) {
        const isDashEnabled = this.dashEnabled();
        if (isDashEnabled) {
            this.attrs.dashEnabled = false;
            ctx.setLineDash([]);
        }
        ctx.fillStrokeShape(this);
        if (isDashEnabled) this.attrs.dashEnabled = true;
    }
    getSelfRect() {
        const lineRect = super.getSelfRect();
        const offset = this.pointerWidth() / 2;
        return {
            x: lineRect.x,
            y: lineRect.y - offset,
            width: lineRect.width,
            height: lineRect.height + offset * 2
        };
    }
}
$217b7afd7d07e01a$export$21b07c8f274aebd5.prototype.className = "Arrow";
(0, $bd77714a0ea3dd4d$export$f7a70d87a5e829eb)($217b7afd7d07e01a$export$21b07c8f274aebd5);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($217b7afd7d07e01a$export$21b07c8f274aebd5, "pointerLength", 10, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($217b7afd7d07e01a$export$21b07c8f274aebd5, "pointerWidth", 10, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($217b7afd7d07e01a$export$21b07c8f274aebd5, "pointerAtBeginning", false);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($217b7afd7d07e01a$export$21b07c8f274aebd5, "pointerAtEnding", true);






class $0a508e443e6ad41b$export$c89a927ffc67e6fa extends (0, $dfc94508c89c186c$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        context.beginPath();
        context.arc(0, 0, this.attrs.radius || 0, 0, Math.PI * 2, false);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return this.radius() * 2;
    }
    getHeight() {
        return this.radius() * 2;
    }
    setWidth(width) {
        if (this.radius() !== width / 2) this.radius(width / 2);
    }
    setHeight(height) {
        if (this.radius() !== height / 2) this.radius(height / 2);
    }
}
$0a508e443e6ad41b$export$c89a927ffc67e6fa.prototype._centroid = true;
$0a508e443e6ad41b$export$c89a927ffc67e6fa.prototype.className = "Circle";
$0a508e443e6ad41b$export$c89a927ffc67e6fa.prototype._attrsAffectingSize = [
    "radius"
];
(0, $bd77714a0ea3dd4d$export$f7a70d87a5e829eb)($0a508e443e6ad41b$export$c89a927ffc67e6fa);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($0a508e443e6ad41b$export$c89a927ffc67e6fa, "radius", 0, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());






class $2bdece97e49d6002$export$80b0269ab108fa11 extends (0, $dfc94508c89c186c$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        const rx = this.radiusX(), ry = this.radiusY();
        context.beginPath();
        context.save();
        if (rx !== ry) context.scale(1, ry / rx);
        context.arc(0, 0, rx, 0, Math.PI * 2, false);
        context.restore();
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return this.radiusX() * 2;
    }
    getHeight() {
        return this.radiusY() * 2;
    }
    setWidth(width) {
        this.radiusX(width / 2);
    }
    setHeight(height) {
        this.radiusY(height / 2);
    }
}
$2bdece97e49d6002$export$80b0269ab108fa11.prototype.className = "Ellipse";
$2bdece97e49d6002$export$80b0269ab108fa11.prototype._centroid = true;
$2bdece97e49d6002$export$80b0269ab108fa11.prototype._attrsAffectingSize = [
    "radiusX",
    "radiusY"
];
(0, $bd77714a0ea3dd4d$export$f7a70d87a5e829eb)($2bdece97e49d6002$export$80b0269ab108fa11);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addComponentsGetterSetter($2bdece97e49d6002$export$80b0269ab108fa11, "radius", [
    "x",
    "y"
]);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($2bdece97e49d6002$export$80b0269ab108fa11, "radiusX", 0, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($2bdece97e49d6002$export$80b0269ab108fa11, "radiusY", 0, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());







class $362fe94bcf32bf79$export$3e431a229df88919 extends (0, $dfc94508c89c186c$export$6428a7f2611ef1fa) {
    constructor(attrs){
        super(attrs);
        this._loadListener = ()=>{
            this._requestDraw();
        };
        this.on("imageChange.konva", (props)=>{
            this._removeImageLoad(props.oldVal);
            this._setImageLoad();
        });
        this._setImageLoad();
    }
    _setImageLoad() {
        const image = this.image();
        if (image && image.complete) return;
        if (image && image.readyState === 4) return;
        if (image && image["addEventListener"]) image["addEventListener"]("load", this._loadListener);
    }
    _removeImageLoad(image) {
        if (image && image["removeEventListener"]) image["removeEventListener"]("load", this._loadListener);
    }
    destroy() {
        this._removeImageLoad(this.image());
        super.destroy();
        return this;
    }
    _useBufferCanvas() {
        const hasCornerRadius = !!this.cornerRadius();
        const hasShadow = this.hasShadow();
        if (hasCornerRadius && hasShadow) return true;
        return super._useBufferCanvas(true);
    }
    _sceneFunc(context) {
        const width = this.getWidth();
        const height = this.getHeight();
        const cornerRadius = this.cornerRadius();
        const image = this.attrs.image;
        let params;
        if (image) {
            const cropWidth = this.attrs.cropWidth;
            const cropHeight = this.attrs.cropHeight;
            if (cropWidth && cropHeight) params = [
                image,
                this.cropX(),
                this.cropY(),
                cropWidth,
                cropHeight,
                0,
                0,
                width,
                height
            ];
            else params = [
                image,
                0,
                0,
                width,
                height
            ];
        }
        if (this.hasFill() || this.hasStroke() || cornerRadius) {
            context.beginPath();
            cornerRadius ? (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).drawRoundedRectPath(context, width, height, cornerRadius) : context.rect(0, 0, width, height);
            context.closePath();
            context.fillStrokeShape(this);
        }
        if (image) {
            if (cornerRadius) context.clip();
            context.drawImage.apply(context, params);
        }
    }
    _hitFunc(context) {
        const width = this.width(), height = this.height(), cornerRadius = this.cornerRadius();
        context.beginPath();
        if (!cornerRadius) context.rect(0, 0, width, height);
        else (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).drawRoundedRectPath(context, width, height, cornerRadius);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        var _a, _b, _c;
        return (_c = (_a = this.attrs.width) !== null && _a !== void 0 ? _a : (_b = this.image()) === null || _b === void 0 ? void 0 : _b.width) !== null && _c !== void 0 ? _c : 0;
    }
    getHeight() {
        var _a, _b, _c;
        return (_c = (_a = this.attrs.height) !== null && _a !== void 0 ? _a : (_b = this.image()) === null || _b === void 0 ? void 0 : _b.height) !== null && _c !== void 0 ? _c : 0;
    }
    static fromURL(url, callback, onError = null) {
        const img = (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).createImageElement();
        img.onload = function() {
            const image = new $362fe94bcf32bf79$export$3e431a229df88919({
                image: img
            });
            callback(image);
        };
        img.onerror = onError;
        img.crossOrigin = "Anonymous";
        img.src = url;
    }
}
$362fe94bcf32bf79$export$3e431a229df88919.prototype.className = "Image";
$362fe94bcf32bf79$export$3e431a229df88919.prototype._attrsAffectingSize = [
    "image"
];
(0, $bd77714a0ea3dd4d$export$f7a70d87a5e829eb)($362fe94bcf32bf79$export$3e431a229df88919);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($362fe94bcf32bf79$export$3e431a229df88919, "cornerRadius", 0, (0, $dc39f19751b6eb0f$export$7d4ab1842c1b264b)(4));
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($362fe94bcf32bf79$export$3e431a229df88919, "image");
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addComponentsGetterSetter($362fe94bcf32bf79$export$3e431a229df88919, "crop", [
    "x",
    "y",
    "width",
    "height"
]);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($362fe94bcf32bf79$export$3e431a229df88919, "cropX", 0, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($362fe94bcf32bf79$export$3e431a229df88919, "cropY", 0, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($362fe94bcf32bf79$export$3e431a229df88919, "cropWidth", 0, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($362fe94bcf32bf79$export$3e431a229df88919, "cropHeight", 0, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());







const $804896d9b1fc553a$var$ATTR_CHANGE_LIST = [
    "fontFamily",
    "fontSize",
    "fontStyle",
    "padding",
    "lineHeight",
    "text",
    "width",
    "height",
    "pointerDirection",
    "pointerWidth",
    "pointerHeight"
], $804896d9b1fc553a$var$CHANGE_KONVA = "Change.konva", $804896d9b1fc553a$var$NONE = "none", $804896d9b1fc553a$var$UP = "up", $804896d9b1fc553a$var$RIGHT = "right", $804896d9b1fc553a$var$DOWN = "down", $804896d9b1fc553a$var$LEFT = "left", $804896d9b1fc553a$var$attrChangeListLen = $804896d9b1fc553a$var$ATTR_CHANGE_LIST.length;
class $804896d9b1fc553a$export$b04be29aa201d4f5 extends (0, $be5edb8df13e00d8$export$eb2fcfdbd7ba97d4) {
    constructor(config){
        super(config);
        this.on("add.konva", function(evt) {
            this._addListeners(evt.child);
            this._sync();
        });
    }
    getText() {
        return this.find("Text")[0];
    }
    getTag() {
        return this.find("Tag")[0];
    }
    _addListeners(text) {
        let that = this, n;
        const func = function() {
            that._sync();
        };
        for(n = 0; n < $804896d9b1fc553a$var$attrChangeListLen; n++)text.on($804896d9b1fc553a$var$ATTR_CHANGE_LIST[n] + $804896d9b1fc553a$var$CHANGE_KONVA, func);
    }
    getWidth() {
        return this.getText().width();
    }
    getHeight() {
        return this.getText().height();
    }
    _sync() {
        let text = this.getText(), tag = this.getTag(), width, height, pointerDirection, pointerWidth, x, y, pointerHeight;
        if (text && tag) {
            width = text.width();
            height = text.height();
            pointerDirection = tag.pointerDirection();
            pointerWidth = tag.pointerWidth();
            pointerHeight = tag.pointerHeight();
            x = 0;
            y = 0;
            switch(pointerDirection){
                case $804896d9b1fc553a$var$UP:
                    x = width / 2;
                    y = -1 * pointerHeight;
                    break;
                case $804896d9b1fc553a$var$RIGHT:
                    x = width + pointerWidth;
                    y = height / 2;
                    break;
                case $804896d9b1fc553a$var$DOWN:
                    x = width / 2;
                    y = height + pointerHeight;
                    break;
                case $804896d9b1fc553a$var$LEFT:
                    x = -1 * pointerWidth;
                    y = height / 2;
                    break;
            }
            tag.setAttrs({
                x: -1 * x,
                y: -1 * y,
                width: width,
                height: height
            });
            text.setAttrs({
                x: -1 * x,
                y: -1 * y
            });
        }
    }
}
$804896d9b1fc553a$export$b04be29aa201d4f5.prototype.className = "Label";
(0, $bd77714a0ea3dd4d$export$f7a70d87a5e829eb)($804896d9b1fc553a$export$b04be29aa201d4f5);
class $804896d9b1fc553a$export$3288d34c523a1192 extends (0, $dfc94508c89c186c$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        const width = this.width(), height = this.height(), pointerDirection = this.pointerDirection(), pointerWidth = this.pointerWidth(), pointerHeight = this.pointerHeight(), cornerRadius = this.cornerRadius();
        let topLeft = 0;
        let topRight = 0;
        let bottomLeft = 0;
        let bottomRight = 0;
        if (typeof cornerRadius === "number") topLeft = topRight = bottomLeft = bottomRight = Math.min(cornerRadius, width / 2, height / 2);
        else {
            topLeft = Math.min(cornerRadius[0] || 0, width / 2, height / 2);
            topRight = Math.min(cornerRadius[1] || 0, width / 2, height / 2);
            bottomRight = Math.min(cornerRadius[2] || 0, width / 2, height / 2);
            bottomLeft = Math.min(cornerRadius[3] || 0, width / 2, height / 2);
        }
        context.beginPath();
        context.moveTo(topLeft, 0);
        if (pointerDirection === $804896d9b1fc553a$var$UP) {
            context.lineTo((width - pointerWidth) / 2, 0);
            context.lineTo(width / 2, -1 * pointerHeight);
            context.lineTo((width + pointerWidth) / 2, 0);
        }
        context.lineTo(width - topRight, 0);
        context.arc(width - topRight, topRight, topRight, Math.PI * 3 / 2, 0, false);
        if (pointerDirection === $804896d9b1fc553a$var$RIGHT) {
            context.lineTo(width, (height - pointerHeight) / 2);
            context.lineTo(width + pointerWidth, height / 2);
            context.lineTo(width, (height + pointerHeight) / 2);
        }
        context.lineTo(width, height - bottomRight);
        context.arc(width - bottomRight, height - bottomRight, bottomRight, 0, Math.PI / 2, false);
        if (pointerDirection === $804896d9b1fc553a$var$DOWN) {
            context.lineTo((width + pointerWidth) / 2, height);
            context.lineTo(width / 2, height + pointerHeight);
            context.lineTo((width - pointerWidth) / 2, height);
        }
        context.lineTo(bottomLeft, height);
        context.arc(bottomLeft, height - bottomLeft, bottomLeft, Math.PI / 2, Math.PI, false);
        if (pointerDirection === $804896d9b1fc553a$var$LEFT) {
            context.lineTo(0, (height + pointerHeight) / 2);
            context.lineTo(-1 * pointerWidth, height / 2);
            context.lineTo(0, (height - pointerHeight) / 2);
        }
        context.lineTo(0, topLeft);
        context.arc(topLeft, topLeft, topLeft, Math.PI, Math.PI * 3 / 2, false);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getSelfRect() {
        let x = 0, y = 0, pointerWidth = this.pointerWidth(), pointerHeight = this.pointerHeight(), direction = this.pointerDirection(), width = this.width(), height = this.height();
        if (direction === $804896d9b1fc553a$var$UP) {
            y -= pointerHeight;
            height += pointerHeight;
        } else if (direction === $804896d9b1fc553a$var$DOWN) height += pointerHeight;
        else if (direction === $804896d9b1fc553a$var$LEFT) {
            x -= pointerWidth * 1.5;
            width += pointerWidth;
        } else if (direction === $804896d9b1fc553a$var$RIGHT) width += pointerWidth * 1.5;
        return {
            x: x,
            y: y,
            width: width,
            height: height
        };
    }
}
$804896d9b1fc553a$export$3288d34c523a1192.prototype.className = "Tag";
(0, $bd77714a0ea3dd4d$export$f7a70d87a5e829eb)($804896d9b1fc553a$export$3288d34c523a1192);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($804896d9b1fc553a$export$3288d34c523a1192, "pointerDirection", $804896d9b1fc553a$var$NONE);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($804896d9b1fc553a$export$3288d34c523a1192, "pointerWidth", 0, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($804896d9b1fc553a$export$3288d34c523a1192, "pointerHeight", 0, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($804896d9b1fc553a$export$3288d34c523a1192, "cornerRadius", 0, (0, $dc39f19751b6eb0f$export$7d4ab1842c1b264b)(4));









class $ae05f3bb0fb9d52c$export$c79fc6492f3af13d extends (0, $dfc94508c89c186c$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        const cornerRadius = this.cornerRadius(), width = this.width(), height = this.height();
        context.beginPath();
        if (!cornerRadius) context.rect(0, 0, width, height);
        else (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).drawRoundedRectPath(context, width, height, cornerRadius);
        context.closePath();
        context.fillStrokeShape(this);
    }
}
$ae05f3bb0fb9d52c$export$c79fc6492f3af13d.prototype.className = "Rect";
(0, $bd77714a0ea3dd4d$export$f7a70d87a5e829eb)($ae05f3bb0fb9d52c$export$c79fc6492f3af13d);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($ae05f3bb0fb9d52c$export$c79fc6492f3af13d, "cornerRadius", 0, (0, $dc39f19751b6eb0f$export$7d4ab1842c1b264b)(4));







class $661f741ea95afa17$export$e2ee866164812ecd extends (0, $dfc94508c89c186c$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        const points = this._getPoints(), radius = this.radius(), sides = this.sides(), cornerRadius = this.cornerRadius();
        context.beginPath();
        if (!cornerRadius) {
            context.moveTo(points[0].x, points[0].y);
            for(let n = 1; n < points.length; n++)context.lineTo(points[n].x, points[n].y);
        } else (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).drawRoundedPolygonPath(context, points, sides, radius, cornerRadius);
        context.closePath();
        context.fillStrokeShape(this);
    }
    _getPoints() {
        const sides = this.attrs.sides;
        const radius = this.attrs.radius || 0;
        const points = [];
        for(let n = 0; n < sides; n++)points.push({
            x: radius * Math.sin(n * 2 * Math.PI / sides),
            y: -1 * radius * Math.cos(n * 2 * Math.PI / sides)
        });
        return points;
    }
    getSelfRect() {
        const points = this._getPoints();
        let minX = points[0].x;
        let maxX = points[0].x;
        let minY = points[0].y;
        let maxY = points[0].y;
        points.forEach((point)=>{
            minX = Math.min(minX, point.x);
            maxX = Math.max(maxX, point.x);
            minY = Math.min(minY, point.y);
            maxY = Math.max(maxY, point.y);
        });
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    }
    getWidth() {
        return this.radius() * 2;
    }
    getHeight() {
        return this.radius() * 2;
    }
    setWidth(width) {
        this.radius(width / 2);
    }
    setHeight(height) {
        this.radius(height / 2);
    }
}
$661f741ea95afa17$export$e2ee866164812ecd.prototype.className = "RegularPolygon";
$661f741ea95afa17$export$e2ee866164812ecd.prototype._centroid = true;
$661f741ea95afa17$export$e2ee866164812ecd.prototype._attrsAffectingSize = [
    "radius"
];
(0, $bd77714a0ea3dd4d$export$f7a70d87a5e829eb)($661f741ea95afa17$export$e2ee866164812ecd);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($661f741ea95afa17$export$e2ee866164812ecd, "radius", 0, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($661f741ea95afa17$export$e2ee866164812ecd, "sides", 0, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($661f741ea95afa17$export$e2ee866164812ecd, "cornerRadius", 0, (0, $dc39f19751b6eb0f$export$7d4ab1842c1b264b)(4));






const $c7993a07651333a8$var$PIx2 = Math.PI * 2;
class $c7993a07651333a8$export$a6e3577650b6d6d7 extends (0, $dfc94508c89c186c$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        context.beginPath();
        context.arc(0, 0, this.innerRadius(), 0, $c7993a07651333a8$var$PIx2, false);
        context.moveTo(this.outerRadius(), 0);
        context.arc(0, 0, this.outerRadius(), $c7993a07651333a8$var$PIx2, 0, true);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return this.outerRadius() * 2;
    }
    getHeight() {
        return this.outerRadius() * 2;
    }
    setWidth(width) {
        this.outerRadius(width / 2);
    }
    setHeight(height) {
        this.outerRadius(height / 2);
    }
}
$c7993a07651333a8$export$a6e3577650b6d6d7.prototype.className = "Ring";
$c7993a07651333a8$export$a6e3577650b6d6d7.prototype._centroid = true;
$c7993a07651333a8$export$a6e3577650b6d6d7.prototype._attrsAffectingSize = [
    "innerRadius",
    "outerRadius"
];
(0, $bd77714a0ea3dd4d$export$f7a70d87a5e829eb)($c7993a07651333a8$export$a6e3577650b6d6d7);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($c7993a07651333a8$export$a6e3577650b6d6d7, "innerRadius", 0, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($c7993a07651333a8$export$a6e3577650b6d6d7, "outerRadius", 0, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());







class $17b2f1f00540e12f$export$3075603db8e6204c extends (0, $dfc94508c89c186c$export$6428a7f2611ef1fa) {
    constructor(config){
        super(config);
        this._updated = true;
        this.anim = new (0, $a7f600c41a6fb34b$export$c35d437ae5945fcd)(()=>{
            const updated = this._updated;
            this._updated = false;
            return updated;
        });
        this.on("animationChange.konva", function() {
            this.frameIndex(0);
        });
        this.on("frameIndexChange.konva", function() {
            this._updated = true;
        });
        this.on("frameRateChange.konva", function() {
            if (!this.anim.isRunning()) return;
            clearInterval(this.interval);
            this._setInterval();
        });
    }
    _sceneFunc(context) {
        const anim = this.animation(), index = this.frameIndex(), ix4 = index * 4, set = this.animations()[anim], offsets = this.frameOffsets(), x = set[ix4 + 0], y = set[ix4 + 1], width = set[ix4 + 2], height = set[ix4 + 3], image = this.image();
        if (this.hasFill() || this.hasStroke()) {
            context.beginPath();
            context.rect(0, 0, width, height);
            context.closePath();
            context.fillStrokeShape(this);
        }
        if (image) {
            if (offsets) {
                const offset = offsets[anim], ix2 = index * 2;
                context.drawImage(image, x, y, width, height, offset[ix2 + 0], offset[ix2 + 1], width, height);
            } else context.drawImage(image, x, y, width, height, 0, 0, width, height);
        }
    }
    _hitFunc(context) {
        const anim = this.animation(), index = this.frameIndex(), ix4 = index * 4, set = this.animations()[anim], offsets = this.frameOffsets(), width = set[ix4 + 2], height = set[ix4 + 3];
        context.beginPath();
        if (offsets) {
            const offset = offsets[anim];
            const ix2 = index * 2;
            context.rect(offset[ix2 + 0], offset[ix2 + 1], width, height);
        } else context.rect(0, 0, width, height);
        context.closePath();
        context.fillShape(this);
    }
    _useBufferCanvas() {
        return super._useBufferCanvas(true);
    }
    _setInterval() {
        const that = this;
        this.interval = setInterval(function() {
            that._updateIndex();
        }, 1000 / this.frameRate());
    }
    start() {
        if (this.isRunning()) return;
        const layer = this.getLayer();
        this.anim.setLayers(layer);
        this._setInterval();
        this.anim.start();
    }
    stop() {
        this.anim.stop();
        clearInterval(this.interval);
    }
    isRunning() {
        return this.anim.isRunning();
    }
    _updateIndex() {
        const index = this.frameIndex(), animation = this.animation(), animations = this.animations(), anim = animations[animation], len = anim.length / 4;
        if (index < len - 1) this.frameIndex(index + 1);
        else this.frameIndex(0);
    }
}
$17b2f1f00540e12f$export$3075603db8e6204c.prototype.className = "Sprite";
(0, $bd77714a0ea3dd4d$export$f7a70d87a5e829eb)($17b2f1f00540e12f$export$3075603db8e6204c);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($17b2f1f00540e12f$export$3075603db8e6204c, "animation");
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($17b2f1f00540e12f$export$3075603db8e6204c, "animations");
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($17b2f1f00540e12f$export$3075603db8e6204c, "frameOffsets");
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($17b2f1f00540e12f$export$3075603db8e6204c, "image");
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($17b2f1f00540e12f$export$3075603db8e6204c, "frameIndex", 0, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($17b2f1f00540e12f$export$3075603db8e6204c, "frameRate", 17, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).backCompat($17b2f1f00540e12f$export$3075603db8e6204c, {
    index: "frameIndex",
    getIndex: "getFrameIndex",
    setIndex: "setFrameIndex"
});






class $816d95ab50ba2abf$export$1644ba17714857f1 extends (0, $dfc94508c89c186c$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        const innerRadius = this.innerRadius(), outerRadius = this.outerRadius(), numPoints = this.numPoints();
        context.beginPath();
        context.moveTo(0, 0 - outerRadius);
        for(let n = 1; n < numPoints * 2; n++){
            const radius = n % 2 === 0 ? outerRadius : innerRadius;
            const x = radius * Math.sin(n * Math.PI / numPoints);
            const y = -1 * radius * Math.cos(n * Math.PI / numPoints);
            context.lineTo(x, y);
        }
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return this.outerRadius() * 2;
    }
    getHeight() {
        return this.outerRadius() * 2;
    }
    setWidth(width) {
        this.outerRadius(width / 2);
    }
    setHeight(height) {
        this.outerRadius(height / 2);
    }
}
$816d95ab50ba2abf$export$1644ba17714857f1.prototype.className = "Star";
$816d95ab50ba2abf$export$1644ba17714857f1.prototype._centroid = true;
$816d95ab50ba2abf$export$1644ba17714857f1.prototype._attrsAffectingSize = [
    "innerRadius",
    "outerRadius"
];
(0, $bd77714a0ea3dd4d$export$f7a70d87a5e829eb)($816d95ab50ba2abf$export$1644ba17714857f1);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($816d95ab50ba2abf$export$1644ba17714857f1, "numPoints", 5, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($816d95ab50ba2abf$export$1644ba17714857f1, "innerRadius", 0, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($816d95ab50ba2abf$export$1644ba17714857f1, "outerRadius", 0, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());







function $647a17bcb821382d$export$b9ca061da17f2d30(string) {
    return [
        ...string
    ].reduce((acc, char, index, array)=>{
        if (/\p{Emoji}/u.test(char)) {
            const nextChar = array[index + 1];
            if (nextChar && /\p{Emoji_Modifier}|\u200D/u.test(nextChar)) {
                acc.push(char + nextChar);
                array[index + 1] = "";
            } else acc.push(char);
        } else if (/\p{Regional_Indicator}{2}/u.test(char + (array[index + 1] || ""))) acc.push(char + array[index + 1]);
        else if (index > 0 && /\p{Mn}|\p{Me}|\p{Mc}/u.test(char)) acc[acc.length - 1] += char;
        else if (char) acc.push(char);
        return acc;
    }, []);
}
const $647a17bcb821382d$var$AUTO = "auto", $647a17bcb821382d$var$CENTER = "center", $647a17bcb821382d$var$INHERIT = "inherit", $647a17bcb821382d$var$JUSTIFY = "justify", $647a17bcb821382d$var$CHANGE_KONVA = "Change.konva", $647a17bcb821382d$var$CONTEXT_2D = "2d", $647a17bcb821382d$var$DASH = "-", $647a17bcb821382d$var$LEFT = "left", $647a17bcb821382d$var$TEXT = "text", $647a17bcb821382d$var$TEXT_UPPER = "Text", $647a17bcb821382d$var$TOP = "top", $647a17bcb821382d$var$BOTTOM = "bottom", $647a17bcb821382d$var$MIDDLE = "middle", $647a17bcb821382d$var$NORMAL = "normal", $647a17bcb821382d$var$PX_SPACE = "px ", $647a17bcb821382d$var$SPACE = " ", $647a17bcb821382d$var$RIGHT = "right", $647a17bcb821382d$var$RTL = "rtl", $647a17bcb821382d$var$WORD = "word", $647a17bcb821382d$var$CHAR = "char", $647a17bcb821382d$var$NONE = "none", $647a17bcb821382d$var$ELLIPSIS = "\u2026", $647a17bcb821382d$var$ATTR_CHANGE_LIST = [
    "direction",
    "fontFamily",
    "fontSize",
    "fontStyle",
    "fontVariant",
    "padding",
    "align",
    "verticalAlign",
    "lineHeight",
    "text",
    "width",
    "height",
    "wrap",
    "ellipsis",
    "letterSpacing"
], $647a17bcb821382d$var$attrChangeListLen = $647a17bcb821382d$var$ATTR_CHANGE_LIST.length;
let $647a17bcb821382d$var$_shadowOpacityBuggy = null;
function $647a17bcb821382d$var$hasShadowOpacityBug() {
    if ($647a17bcb821382d$var$_shadowOpacityBuggy !== null) return $647a17bcb821382d$var$_shadowOpacityBuggy;
    $647a17bcb821382d$var$_shadowOpacityBuggy = false;
    try {
        const c = document.createElement("canvas");
        c.width = 10;
        c.height = 10;
        const ctx = c.getContext($647a17bcb821382d$var$CONTEXT_2D);
        if (ctx) {
            ctx.globalAlpha = 0;
            ctx.shadowColor = "black";
            ctx.shadowBlur = 5;
            ctx.shadowOffsetX = 5;
            ctx.shadowOffsetY = 5;
            ctx.fillStyle = "black";
            ctx.font = "10px Arial";
            ctx.fillText("X", 0, 10);
            const data = ctx.getImageData(0, 0, 10, 10).data;
            for(let i = 3; i < data.length; i += 4)if (data[i] > 0) {
                $647a17bcb821382d$var$_shadowOpacityBuggy = true;
                break;
            }
        }
    } catch (e) {}
    return $647a17bcb821382d$var$_shadowOpacityBuggy;
}
function $647a17bcb821382d$var$normalizeFontFamily(fontFamily) {
    return fontFamily.split(",").map((family)=>{
        family = family.trim();
        const hasSpace = family.indexOf(" ") >= 0;
        const hasQuotes = family.indexOf('"') >= 0 || family.indexOf("'") >= 0;
        if (hasSpace && !hasQuotes) family = `"${family}"`;
        return family;
    }).join(", ");
}
let $647a17bcb821382d$var$dummyContext;
function $647a17bcb821382d$var$getDummyContext() {
    if ($647a17bcb821382d$var$dummyContext) return $647a17bcb821382d$var$dummyContext;
    $647a17bcb821382d$var$dummyContext = (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).createCanvasElement().getContext($647a17bcb821382d$var$CONTEXT_2D);
    return $647a17bcb821382d$var$dummyContext;
}
function $647a17bcb821382d$var$_fillFunc(context) {
    context.fillText(this._partialText, this._partialTextX, this._partialTextY);
}
function $647a17bcb821382d$var$_strokeFunc(context) {
    context.setAttr("miterLimit", 2);
    context.strokeText(this._partialText, this._partialTextX, this._partialTextY);
}
function $647a17bcb821382d$var$checkDefaultFill(config) {
    config = config || {};
    if (!config.fillLinearGradientColorStops && !config.fillRadialGradientColorStops && !config.fillPatternImage) config.fill = config.fill || "black";
    return config;
}
class $647a17bcb821382d$export$5f1af8db9871e1d6 extends (0, $dfc94508c89c186c$export$6428a7f2611ef1fa) {
    constructor(config){
        super($647a17bcb821382d$var$checkDefaultFill(config));
        this._partialTextX = 0;
        this._partialTextY = 0;
        for(let n = 0; n < $647a17bcb821382d$var$attrChangeListLen; n++)this.on($647a17bcb821382d$var$ATTR_CHANGE_LIST[n] + $647a17bcb821382d$var$CHANGE_KONVA, this._setTextData);
        this._setTextData();
    }
    _sceneFunc(context) {
        var _a, _b;
        const textArr = this.textArr, textArrLen = textArr.length;
        if (!this.text()) return;
        let padding = this.padding(), fontSize = this.fontSize(), lineHeightPx = this.lineHeight() * fontSize, verticalAlign = this.verticalAlign(), direction = this.direction(), alignY = 0, align = this.align(), totalWidth = this.getWidth(), letterSpacing = this.letterSpacing(), charRenderFunc = this.charRenderFunc(), fill = this.fill(), textDecoration = this.textDecoration(), underlineOffset = this.underlineOffset(), shouldUnderline = textDecoration.indexOf("underline") !== -1, shouldLineThrough = textDecoration.indexOf("line-through") !== -1, n;
        direction = direction === $647a17bcb821382d$var$INHERIT ? context.direction : direction;
        let translateY = lineHeightPx / 2;
        let baseline = $647a17bcb821382d$var$MIDDLE;
        if (!(0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).legacyTextRendering) {
            const metrics = this.measureSize("M");
            baseline = "alphabetic";
            const ascent = (_a = metrics.fontBoundingBoxAscent) !== null && _a !== void 0 ? _a : metrics.actualBoundingBoxAscent;
            const descent = (_b = metrics.fontBoundingBoxDescent) !== null && _b !== void 0 ? _b : metrics.actualBoundingBoxDescent;
            translateY = (ascent - descent) / 2 + lineHeightPx / 2;
        }
        if (direction === $647a17bcb821382d$var$RTL) context.setAttr("direction", direction);
        context.setAttr("font", this._getContextFont());
        context.setAttr("textBaseline", baseline);
        context.setAttr("textAlign", $647a17bcb821382d$var$LEFT);
        if (verticalAlign === $647a17bcb821382d$var$MIDDLE) alignY = (this.getHeight() - textArrLen * lineHeightPx - padding * 2) / 2;
        else if (verticalAlign === $647a17bcb821382d$var$BOTTOM) alignY = this.getHeight() - textArrLen * lineHeightPx - padding * 2;
        context.translate(padding, alignY + padding);
        for(n = 0; n < textArrLen; n++){
            let lineTranslateX = 0;
            let lineTranslateY = 0;
            const obj = textArr[n], text = obj.text, width = obj.width, lastLine = obj.lastInParagraph;
            context.save();
            if (align === $647a17bcb821382d$var$RIGHT) lineTranslateX += totalWidth - width - padding * 2;
            else if (align === $647a17bcb821382d$var$CENTER) lineTranslateX += (totalWidth - width - padding * 2) / 2;
            if (shouldUnderline) {
                context.save();
                context.beginPath();
                const yOffset = underlineOffset !== null && underlineOffset !== void 0 ? underlineOffset : !(0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).legacyTextRendering ? Math.round(fontSize / 4) : Math.round(fontSize / 2);
                const x = lineTranslateX;
                const y = translateY + lineTranslateY + yOffset;
                context.moveTo(x, y);
                const lineWidth = align === $647a17bcb821382d$var$JUSTIFY && !lastLine ? totalWidth - padding * 2 : width;
                context.lineTo(x + Math.round(lineWidth), y);
                context.lineWidth = fontSize / 15;
                const gradient = this._getLinearGradient();
                context.strokeStyle = gradient || fill;
                context.stroke();
                context.restore();
            }
            const lineThroughStartX = lineTranslateX;
            if (direction !== $647a17bcb821382d$var$RTL && (letterSpacing !== 0 || align === $647a17bcb821382d$var$JUSTIFY || charRenderFunc)) {
                const spacesNumber = text.split(" ").length - 1;
                const array = $647a17bcb821382d$export$b9ca061da17f2d30(text);
                for(let li = 0; li < array.length; li++){
                    const letter = array[li];
                    if (letter === " " && !lastLine && align === $647a17bcb821382d$var$JUSTIFY) lineTranslateX += (totalWidth - padding * 2 - width) / spacesNumber;
                    this._partialTextX = lineTranslateX;
                    this._partialTextY = translateY + lineTranslateY;
                    this._partialText = letter;
                    if (charRenderFunc) {
                        context.save();
                        const previousLines = textArr.slice(0, n);
                        const previousGraphemes = previousLines.reduce((acc, line)=>acc + $647a17bcb821382d$export$b9ca061da17f2d30(line.text).length, 0);
                        const charIndex = li + previousGraphemes;
                        charRenderFunc({
                            char: letter,
                            index: charIndex,
                            x: lineTranslateX,
                            y: translateY + lineTranslateY,
                            lineIndex: n,
                            column: li,
                            isLastInLine: lastLine,
                            width: this.measureSize(letter).width,
                            context: context
                        });
                    }
                    context.fillStrokeShape(this);
                    if (charRenderFunc) context.restore();
                    lineTranslateX += this.measureSize(letter).width + letterSpacing;
                }
            } else {
                if (letterSpacing !== 0) context.setAttr("letterSpacing", `${letterSpacing}px`);
                this._partialTextX = lineTranslateX;
                this._partialTextY = translateY + lineTranslateY;
                this._partialText = text;
                context.fillStrokeShape(this);
            }
            if (shouldLineThrough) {
                context.save();
                context.beginPath();
                const yOffset = !(0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).legacyTextRendering ? -Math.round(fontSize / 4) : 0;
                const x = lineThroughStartX;
                context.moveTo(x, translateY + lineTranslateY + yOffset);
                const lineWidth = align === $647a17bcb821382d$var$JUSTIFY && !lastLine ? totalWidth - padding * 2 : width;
                context.lineTo(x + Math.round(lineWidth), translateY + lineTranslateY + yOffset);
                context.lineWidth = fontSize / 15;
                const gradient = this._getLinearGradient();
                context.strokeStyle = gradient || fill;
                context.stroke();
                context.restore();
            }
            context.restore();
            if (textArrLen > 1) translateY += lineHeightPx;
        }
    }
    _hitFunc(context) {
        const width = this.getWidth(), height = this.getHeight();
        context.beginPath();
        context.rect(0, 0, width, height);
        context.closePath();
        context.fillStrokeShape(this);
    }
    setText(text) {
        const str = (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._isString(text) ? text : text === null || text === undefined ? "" : text + "";
        this._setAttr($647a17bcb821382d$var$TEXT, str);
        return this;
    }
    getWidth() {
        const isAuto = this.attrs.width === $647a17bcb821382d$var$AUTO || this.attrs.width === undefined;
        return isAuto ? this.getTextWidth() + this.padding() * 2 : this.attrs.width;
    }
    getHeight() {
        const isAuto = this.attrs.height === $647a17bcb821382d$var$AUTO || this.attrs.height === undefined;
        return isAuto ? this.fontSize() * this.textArr.length * this.lineHeight() + this.padding() * 2 : this.attrs.height;
    }
    getTextWidth() {
        return this.textWidth;
    }
    getTextHeight() {
        (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).warn("text.getTextHeight() method is deprecated. Use text.height() - for full height and text.fontSize() - for one line height.");
        return this.textHeight;
    }
    measureSize(text) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        let _context = $647a17bcb821382d$var$getDummyContext(), fontSize = this.fontSize(), metrics;
        _context.save();
        _context.font = this._getContextFont();
        metrics = _context.measureText(text);
        _context.restore();
        const scaleFactor = fontSize / 100;
        return {
            actualBoundingBoxAscent: (_a = metrics.actualBoundingBoxAscent) !== null && _a !== void 0 ? _a : 71.58203125 * scaleFactor,
            actualBoundingBoxDescent: (_b = metrics.actualBoundingBoxDescent) !== null && _b !== void 0 ? _b : 0,
            actualBoundingBoxLeft: (_c = metrics.actualBoundingBoxLeft) !== null && _c !== void 0 ? _c : -7.421875 * scaleFactor,
            actualBoundingBoxRight: (_d = metrics.actualBoundingBoxRight) !== null && _d !== void 0 ? _d : 75.732421875 * scaleFactor,
            alphabeticBaseline: (_e = metrics.alphabeticBaseline) !== null && _e !== void 0 ? _e : 0,
            emHeightAscent: (_f = metrics.emHeightAscent) !== null && _f !== void 0 ? _f : 100 * scaleFactor,
            emHeightDescent: (_g = metrics.emHeightDescent) !== null && _g !== void 0 ? _g : -20 * scaleFactor,
            fontBoundingBoxAscent: (_h = metrics.fontBoundingBoxAscent) !== null && _h !== void 0 ? _h : 91 * scaleFactor,
            fontBoundingBoxDescent: (_j = metrics.fontBoundingBoxDescent) !== null && _j !== void 0 ? _j : 21 * scaleFactor,
            hangingBaseline: (_k = metrics.hangingBaseline) !== null && _k !== void 0 ? _k : 72.80000305175781 * scaleFactor,
            ideographicBaseline: (_l = metrics.ideographicBaseline) !== null && _l !== void 0 ? _l : -21 * scaleFactor,
            width: metrics.width,
            height: fontSize
        };
    }
    _getContextFont() {
        return this.fontStyle() + $647a17bcb821382d$var$SPACE + this.fontVariant() + $647a17bcb821382d$var$SPACE + (this.fontSize() + $647a17bcb821382d$var$PX_SPACE) + $647a17bcb821382d$var$normalizeFontFamily(this.fontFamily());
    }
    _addTextLine(line) {
        const align = this.align();
        if (align === $647a17bcb821382d$var$JUSTIFY) line = line.trim();
        const width = this._getTextWidth(line);
        return this.textArr.push({
            text: line,
            width: width,
            lastInParagraph: false
        });
    }
    _getTextWidth(text) {
        const letterSpacing = this.letterSpacing();
        const length = text.length;
        return $647a17bcb821382d$var$getDummyContext().measureText(text).width + letterSpacing * length;
    }
    _setTextData() {
        let lines = this.text().split("\n"), fontSize = +this.fontSize(), textWidth = 0, lineHeightPx = this.lineHeight() * fontSize, width = this.attrs.width, height = this.attrs.height, fixedWidth = width !== $647a17bcb821382d$var$AUTO && width !== undefined, fixedHeight = height !== $647a17bcb821382d$var$AUTO && height !== undefined, padding = this.padding(), maxWidth = width - padding * 2, maxHeightPx = height - padding * 2, currentHeightPx = 0, wrap = this.wrap(), shouldWrap = wrap !== $647a17bcb821382d$var$NONE, wrapAtWord = wrap !== $647a17bcb821382d$var$CHAR && shouldWrap, shouldAddEllipsis = this.ellipsis();
        this.textArr = [];
        $647a17bcb821382d$var$getDummyContext().font = this._getContextFont();
        const additionalWidth = shouldAddEllipsis ? this._getTextWidth($647a17bcb821382d$var$ELLIPSIS) : 0;
        for(let i = 0, max = lines.length; i < max; ++i){
            let line = lines[i];
            let lineWidth = this._getTextWidth(line);
            if (fixedWidth && lineWidth > maxWidth) while(line.length > 0){
                let low = 0, high = $647a17bcb821382d$export$b9ca061da17f2d30(line).length, match = "", matchWidth = 0;
                while(low < high){
                    const mid = low + high >>> 1, lineArray = $647a17bcb821382d$export$b9ca061da17f2d30(line), substr = lineArray.slice(0, mid + 1).join(""), substrWidth = this._getTextWidth(substr);
                    const shouldConsiderEllipsis = shouldAddEllipsis && fixedHeight && currentHeightPx + lineHeightPx > maxHeightPx;
                    const effectiveWidth = shouldConsiderEllipsis ? substrWidth + additionalWidth : substrWidth;
                    if (effectiveWidth <= maxWidth) {
                        low = mid + 1;
                        match = substr;
                        matchWidth = substrWidth;
                    } else high = mid;
                }
                if (match) {
                    if (wrapAtWord) {
                        const lineArray = $647a17bcb821382d$export$b9ca061da17f2d30(line);
                        const matchArray = $647a17bcb821382d$export$b9ca061da17f2d30(match);
                        const nextChar = lineArray[matchArray.length];
                        const nextIsSpaceOrDash = nextChar === $647a17bcb821382d$var$SPACE || nextChar === $647a17bcb821382d$var$DASH;
                        let wrapIndex;
                        if (nextIsSpaceOrDash && matchWidth <= maxWidth) wrapIndex = matchArray.length;
                        else {
                            const lastSpaceIndex = matchArray.lastIndexOf($647a17bcb821382d$var$SPACE);
                            const lastDashIndex = matchArray.lastIndexOf($647a17bcb821382d$var$DASH);
                            wrapIndex = Math.max(lastSpaceIndex, lastDashIndex) + 1;
                        }
                        if (wrapIndex > 0) {
                            low = wrapIndex;
                            match = lineArray.slice(0, low).join("");
                            matchWidth = this._getTextWidth(match);
                        }
                    }
                    match = match.trimRight();
                    this._addTextLine(match);
                    textWidth = Math.max(textWidth, matchWidth);
                    currentHeightPx += lineHeightPx;
                    const shouldHandleEllipsis = this._shouldHandleEllipsis(currentHeightPx);
                    if (shouldHandleEllipsis) {
                        this._tryToAddEllipsisToLastLine();
                        break;
                    }
                    const lineArray = $647a17bcb821382d$export$b9ca061da17f2d30(line);
                    line = lineArray.slice(low).join("").trimLeft();
                    if (line.length > 0) {
                        lineWidth = this._getTextWidth(line);
                        if (lineWidth <= maxWidth) {
                            this._addTextLine(line);
                            currentHeightPx += lineHeightPx;
                            textWidth = Math.max(textWidth, lineWidth);
                            break;
                        }
                    }
                } else break;
            }
            else {
                this._addTextLine(line);
                currentHeightPx += lineHeightPx;
                textWidth = Math.max(textWidth, lineWidth);
                if (this._shouldHandleEllipsis(currentHeightPx) && i < max - 1) this._tryToAddEllipsisToLastLine();
            }
            if (this.textArr[this.textArr.length - 1]) this.textArr[this.textArr.length - 1].lastInParagraph = true;
            if (fixedHeight && currentHeightPx + lineHeightPx > maxHeightPx) break;
        }
        this.textHeight = fontSize;
        this.textWidth = textWidth;
    }
    _shouldHandleEllipsis(currentHeightPx) {
        const fontSize = +this.fontSize(), lineHeightPx = this.lineHeight() * fontSize, height = this.attrs.height, fixedHeight = height !== $647a17bcb821382d$var$AUTO && height !== undefined, padding = this.padding(), maxHeightPx = height - padding * 2, wrap = this.wrap(), shouldWrap = wrap !== $647a17bcb821382d$var$NONE;
        return !shouldWrap || fixedHeight && currentHeightPx + lineHeightPx > maxHeightPx;
    }
    _tryToAddEllipsisToLastLine() {
        const width = this.attrs.width, fixedWidth = width !== $647a17bcb821382d$var$AUTO && width !== undefined, padding = this.padding(), maxWidth = width - padding * 2, shouldAddEllipsis = this.ellipsis();
        const lastLine = this.textArr[this.textArr.length - 1];
        if (!lastLine || !shouldAddEllipsis) return;
        if (fixedWidth) {
            const haveSpace = this._getTextWidth(lastLine.text + $647a17bcb821382d$var$ELLIPSIS) < maxWidth;
            if (!haveSpace) lastLine.text = lastLine.text.slice(0, lastLine.text.length - 3);
        }
        this.textArr.splice(this.textArr.length - 1, 1);
        this._addTextLine(lastLine.text + $647a17bcb821382d$var$ELLIPSIS);
    }
    getStrokeScaleEnabled() {
        return true;
    }
    _useBufferCanvas() {
        const hasLine = this.textDecoration().indexOf("underline") !== -1 || this.textDecoration().indexOf("line-through") !== -1;
        const hasShadow = this.hasShadow();
        if (hasLine && hasShadow) return true;
        if (hasShadow && this.getAbsoluteOpacity() !== 1 && $647a17bcb821382d$var$hasShadowOpacityBug()) return true;
        return super._useBufferCanvas();
    }
}
$647a17bcb821382d$export$5f1af8db9871e1d6.prototype._fillFunc = $647a17bcb821382d$var$_fillFunc;
$647a17bcb821382d$export$5f1af8db9871e1d6.prototype._strokeFunc = $647a17bcb821382d$var$_strokeFunc;
$647a17bcb821382d$export$5f1af8db9871e1d6.prototype.className = $647a17bcb821382d$var$TEXT_UPPER;
$647a17bcb821382d$export$5f1af8db9871e1d6.prototype._attrsAffectingSize = [
    "text",
    "fontSize",
    "padding",
    "wrap",
    "lineHeight",
    "letterSpacing"
];
(0, $bd77714a0ea3dd4d$export$f7a70d87a5e829eb)($647a17bcb821382d$export$5f1af8db9871e1d6);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).overWriteSetter($647a17bcb821382d$export$5f1af8db9871e1d6, "width", (0, $dc39f19751b6eb0f$export$3b7df2720ef33404)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).overWriteSetter($647a17bcb821382d$export$5f1af8db9871e1d6, "height", (0, $dc39f19751b6eb0f$export$3b7df2720ef33404)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($647a17bcb821382d$export$5f1af8db9871e1d6, "direction", $647a17bcb821382d$var$INHERIT);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($647a17bcb821382d$export$5f1af8db9871e1d6, "fontFamily", "Arial");
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($647a17bcb821382d$export$5f1af8db9871e1d6, "fontSize", 12, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($647a17bcb821382d$export$5f1af8db9871e1d6, "fontStyle", $647a17bcb821382d$var$NORMAL);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($647a17bcb821382d$export$5f1af8db9871e1d6, "fontVariant", $647a17bcb821382d$var$NORMAL);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($647a17bcb821382d$export$5f1af8db9871e1d6, "padding", 0, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($647a17bcb821382d$export$5f1af8db9871e1d6, "align", $647a17bcb821382d$var$LEFT);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($647a17bcb821382d$export$5f1af8db9871e1d6, "verticalAlign", $647a17bcb821382d$var$TOP);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($647a17bcb821382d$export$5f1af8db9871e1d6, "lineHeight", 1, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($647a17bcb821382d$export$5f1af8db9871e1d6, "wrap", $647a17bcb821382d$var$WORD);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($647a17bcb821382d$export$5f1af8db9871e1d6, "ellipsis", false, (0, $dc39f19751b6eb0f$export$147fc8b6cd20fda1)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($647a17bcb821382d$export$5f1af8db9871e1d6, "letterSpacing", 0, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($647a17bcb821382d$export$5f1af8db9871e1d6, "text", "", (0, $dc39f19751b6eb0f$export$5837c5b6cc5b4d63)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($647a17bcb821382d$export$5f1af8db9871e1d6, "textDecoration", "");
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($647a17bcb821382d$export$5f1af8db9871e1d6, "underlineOffset", undefined, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($647a17bcb821382d$export$5f1af8db9871e1d6, "charRenderFunc", undefined);









const $e290b26343fc00d0$var$EMPTY_STRING = "", $e290b26343fc00d0$var$NORMAL = "normal";
function $e290b26343fc00d0$var$_fillFunc(context) {
    context.fillText(this.partialText, 0, 0);
}
function $e290b26343fc00d0$var$_strokeFunc(context) {
    context.strokeText(this.partialText, 0, 0);
}
class $e290b26343fc00d0$export$f7e34a95cc06fac7 extends (0, $dfc94508c89c186c$export$6428a7f2611ef1fa) {
    constructor(config){
        super(config);
        this.dummyCanvas = (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).createCanvasElement();
        this.dataArray = [];
        this._readDataAttribute();
        this.on("dataChange.konva", function() {
            this._readDataAttribute();
            this._setTextData();
        });
        this.on("textChange.konva alignChange.konva letterSpacingChange.konva kerningFuncChange.konva fontSizeChange.konva fontFamilyChange.konva directionChange.konva", this._setTextData);
        this._setTextData();
    }
    _getTextPathLength() {
        return (0, $df50b4cb4b867012$export$4b2950bdac9b6ee9).getPathLength(this.dataArray);
    }
    _getPointAtLength(length) {
        if (!this.attrs.data) return null;
        const totalLength = this.pathLength;
        if (length > totalLength) return null;
        return (0, $df50b4cb4b867012$export$4b2950bdac9b6ee9).getPointAtLengthOfDataArray(length, this.dataArray);
    }
    _readDataAttribute() {
        this.dataArray = (0, $df50b4cb4b867012$export$4b2950bdac9b6ee9).parsePathData(this.attrs.data);
        this.pathLength = this._getTextPathLength();
    }
    _sceneFunc(context) {
        context.setAttr("font", this._getContextFont());
        context.setAttr("textBaseline", this.textBaseline());
        context.setAttr("textAlign", "left");
        context.save();
        const textDecoration = this.textDecoration();
        const fill = this.fill();
        const fontSize = this.fontSize();
        const glyphInfo = this.glyphInfo;
        const hasUnderline = textDecoration.indexOf("underline") !== -1;
        const hasLineThrough = textDecoration.indexOf("line-through") !== -1;
        if (hasUnderline) context.beginPath();
        for(let i = 0; i < glyphInfo.length; i++){
            context.save();
            const p0 = glyphInfo[i].p0;
            context.translate(p0.x, p0.y);
            context.rotate(glyphInfo[i].rotation);
            this.partialText = glyphInfo[i].text;
            context.fillStrokeShape(this);
            if (hasUnderline) {
                if (i === 0) context.moveTo(0, fontSize / 2 + 1);
                context.lineTo(glyphInfo[i].width, fontSize / 2 + 1);
            }
            context.restore();
        }
        if (hasUnderline) {
            context.strokeStyle = fill;
            context.lineWidth = fontSize / 20;
            context.stroke();
        }
        if (hasLineThrough) {
            context.beginPath();
            for(let i = 0; i < glyphInfo.length; i++){
                context.save();
                const p0 = glyphInfo[i].p0;
                context.translate(p0.x, p0.y);
                context.rotate(glyphInfo[i].rotation);
                if (i === 0) context.moveTo(0, 0);
                context.lineTo(glyphInfo[i].width, 0);
                context.restore();
            }
            context.strokeStyle = fill;
            context.lineWidth = fontSize / 20;
            context.stroke();
        }
        context.restore();
    }
    _hitFunc(context) {
        context.beginPath();
        const glyphInfo = this.glyphInfo;
        if (glyphInfo.length >= 1) {
            const p0 = glyphInfo[0].p0;
            context.moveTo(p0.x, p0.y);
        }
        for(let i = 0; i < glyphInfo.length; i++){
            const p1 = glyphInfo[i].p1;
            context.lineTo(p1.x, p1.y);
        }
        context.setAttr("lineWidth", this.fontSize());
        context.setAttr("strokeStyle", this.colorKey);
        context.stroke();
    }
    getTextWidth() {
        return this.textWidth;
    }
    getTextHeight() {
        (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).warn("text.getTextHeight() method is deprecated. Use text.height() - for full height and text.fontSize() - for one line height.");
        return this.textHeight;
    }
    setText(text) {
        return (0, $647a17bcb821382d$export$5f1af8db9871e1d6).prototype.setText.call(this, text);
    }
    _getContextFont() {
        return (0, $647a17bcb821382d$export$5f1af8db9871e1d6).prototype._getContextFont.call(this);
    }
    _getTextSize(text) {
        const dummyCanvas = this.dummyCanvas;
        const _context = dummyCanvas.getContext("2d");
        _context.save();
        _context.font = this._getContextFont();
        const metrics = _context.measureText(text);
        _context.restore();
        return {
            width: metrics.width,
            height: parseInt(`${this.fontSize()}`, 10)
        };
    }
    _setTextData() {
        const charArr = (0, $647a17bcb821382d$export$b9ca061da17f2d30)(this.text());
        if (this.direction() === "rtl") charArr.reverse();
        const chars = [];
        let width = 0;
        for(let i = 0; i < charArr.length; i++){
            chars.push({
                char: charArr[i],
                width: this._getTextSize(charArr[i]).width
            });
            width += chars[i].width;
        }
        const { width: fullTextWidth, height: height } = this._getTextSize(this.attrs.text);
        this.textWidth = width;
        this.textHeight = height;
        this.glyphInfo = [];
        if (!this.attrs.data) return null;
        const letterSpacing = this.letterSpacing();
        const align = this.align();
        const kerningFunc = this.kerningFunc();
        const kerningAdjustment = Math.max(0, width - fullTextWidth);
        const textWidth = Math.max(this.textWidth + ((this.attrs.text || "").length - 1) * letterSpacing, 0);
        let offset = 0;
        if (align === "center") offset = Math.max(0, this.pathLength / 2 - textWidth / 2);
        if (align === "right") offset = Math.max(0, this.pathLength - textWidth);
        let offsetToGlyph = offset;
        for(let i = 0; i < chars.length; i++){
            const charStartPoint = this._getPointAtLength(offsetToGlyph);
            if (!charStartPoint) return;
            const char = chars[i].char;
            let glyphWidth = chars[i].width + letterSpacing;
            if (char === " " && align === "justify") {
                const numberOfSpaces = this.text().split(" ").length - 1;
                glyphWidth += (this.pathLength - textWidth) / numberOfSpaces;
            }
            const charEndLength = offsetToGlyph + glyphWidth;
            const charEndPoint = this._getPointAtLength(charEndLength > this.pathLength && charEndLength - this.pathLength <= kerningAdjustment ? this.pathLength : charEndLength);
            if (!charEndPoint) return;
            const width = (0, $df50b4cb4b867012$export$4b2950bdac9b6ee9).getLineLength(charStartPoint.x, charStartPoint.y, charEndPoint.x, charEndPoint.y);
            let kern = 0;
            if (kerningFunc) try {
                kern = kerningFunc(chars[i - 1].char, char) * this.fontSize();
            } catch (e) {
                kern = 0;
            }
            charStartPoint.x += kern;
            charEndPoint.x += kern;
            this.textWidth += kern;
            const midpoint = (0, $df50b4cb4b867012$export$4b2950bdac9b6ee9).getPointOnLine(kern + width / 2.0, charStartPoint.x, charStartPoint.y, charEndPoint.x, charEndPoint.y);
            const rotation = Math.atan2(charEndPoint.y - charStartPoint.y, charEndPoint.x - charStartPoint.x);
            this.glyphInfo.push({
                transposeX: midpoint.x,
                transposeY: midpoint.y,
                text: charArr[i],
                rotation: rotation,
                p0: charStartPoint,
                p1: charEndPoint,
                width: width
            });
            offsetToGlyph += glyphWidth;
        }
    }
    getSelfRect() {
        if (!this.glyphInfo.length) return {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
        const points = [];
        this.glyphInfo.forEach(function(info) {
            points.push(info.p0.x);
            points.push(info.p0.y);
            points.push(info.p1.x);
            points.push(info.p1.y);
        });
        let minX = points[0] || 0;
        let maxX = points[0] || 0;
        let minY = points[1] || 0;
        let maxY = points[1] || 0;
        let x, y;
        for(let i = 0; i < points.length / 2; i++){
            x = points[i * 2];
            y = points[i * 2 + 1];
            minX = Math.min(minX, x);
            maxX = Math.max(maxX, x);
            minY = Math.min(minY, y);
            maxY = Math.max(maxY, y);
        }
        const fontSize = this.fontSize();
        return {
            x: minX - fontSize / 2,
            y: minY - fontSize / 2,
            width: maxX - minX + fontSize,
            height: maxY - minY + fontSize
        };
    }
    destroy() {
        (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).releaseCanvas(this.dummyCanvas);
        return super.destroy();
    }
}
$e290b26343fc00d0$export$f7e34a95cc06fac7.prototype._fillFunc = $e290b26343fc00d0$var$_fillFunc;
$e290b26343fc00d0$export$f7e34a95cc06fac7.prototype._strokeFunc = $e290b26343fc00d0$var$_strokeFunc;
$e290b26343fc00d0$export$f7e34a95cc06fac7.prototype._fillFuncHit = $e290b26343fc00d0$var$_fillFunc;
$e290b26343fc00d0$export$f7e34a95cc06fac7.prototype._strokeFuncHit = $e290b26343fc00d0$var$_strokeFunc;
$e290b26343fc00d0$export$f7e34a95cc06fac7.prototype.className = "TextPath";
$e290b26343fc00d0$export$f7e34a95cc06fac7.prototype._attrsAffectingSize = [
    "text",
    "fontSize",
    "data"
];
(0, $bd77714a0ea3dd4d$export$f7a70d87a5e829eb)($e290b26343fc00d0$export$f7e34a95cc06fac7);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($e290b26343fc00d0$export$f7e34a95cc06fac7, "data");
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($e290b26343fc00d0$export$f7e34a95cc06fac7, "fontFamily", "Arial");
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($e290b26343fc00d0$export$f7e34a95cc06fac7, "fontSize", 12, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($e290b26343fc00d0$export$f7e34a95cc06fac7, "fontStyle", $e290b26343fc00d0$var$NORMAL);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($e290b26343fc00d0$export$f7e34a95cc06fac7, "align", "left");
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($e290b26343fc00d0$export$f7e34a95cc06fac7, "letterSpacing", 0, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($e290b26343fc00d0$export$f7e34a95cc06fac7, "textBaseline", "middle");
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($e290b26343fc00d0$export$f7e34a95cc06fac7, "fontVariant", $e290b26343fc00d0$var$NORMAL);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($e290b26343fc00d0$export$f7e34a95cc06fac7, "text", $e290b26343fc00d0$var$EMPTY_STRING);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($e290b26343fc00d0$export$f7e34a95cc06fac7, "textDecoration", "");
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($e290b26343fc00d0$export$f7e34a95cc06fac7, "kerningFunc", undefined);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($e290b26343fc00d0$export$f7e34a95cc06fac7, "direction", "inherit");










const $f029f8c01ca14ce2$var$EVENTS_NAME = "tr-konva";
const $f029f8c01ca14ce2$var$ATTR_CHANGE_LIST = [
    "resizeEnabledChange",
    "rotateAnchorOffsetChange",
    "rotateAnchorAngleChange",
    "rotateEnabledChange",
    "enabledAnchorsChange",
    "anchorSizeChange",
    "borderEnabledChange",
    "borderStrokeChange",
    "borderStrokeWidthChange",
    "borderDashChange",
    "anchorStrokeChange",
    "anchorStrokeWidthChange",
    "anchorFillChange",
    "anchorCornerRadiusChange",
    "ignoreStrokeChange",
    "anchorStyleFuncChange"
].map((e)=>e + `.${$f029f8c01ca14ce2$var$EVENTS_NAME}`).join(" ");
const $f029f8c01ca14ce2$var$NODES_RECT = "nodesRect";
const $f029f8c01ca14ce2$var$TRANSFORM_CHANGE_STR = [
    "widthChange",
    "heightChange",
    "scaleXChange",
    "scaleYChange",
    "skewXChange",
    "skewYChange",
    "rotationChange",
    "offsetXChange",
    "offsetYChange",
    "transformsEnabledChange",
    "strokeWidthChange",
    "draggableChange"
];
const $f029f8c01ca14ce2$var$ANGLES = {
    "top-left": -45,
    "top-center": 0,
    "top-right": 45,
    "middle-right": -90,
    "middle-left": 90,
    "bottom-left": -135,
    "bottom-center": 180,
    "bottom-right": 135
};
const $f029f8c01ca14ce2$var$TOUCH_DEVICE = "ontouchstart" in (0, $bd77714a0ea3dd4d$export$b9f99057a3c7692)._global;
function $f029f8c01ca14ce2$var$getCursor(anchorName, rad, rotateCursor) {
    if (anchorName === "rotater") return rotateCursor;
    rad += (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).degToRad($f029f8c01ca14ce2$var$ANGLES[anchorName] || 0);
    const angle = ((0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).radToDeg(rad) % 360 + 360) % 360;
    if ((0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._inRange(angle, 337.5, 360) || (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._inRange(angle, 0, 22.5)) return "ns-resize";
    else if ((0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._inRange(angle, 22.5, 67.5)) return "nesw-resize";
    else if ((0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._inRange(angle, 67.5, 112.5)) return "ew-resize";
    else if ((0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._inRange(angle, 112.5, 157.5)) return "nwse-resize";
    else if ((0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._inRange(angle, 157.5, 202.5)) return "ns-resize";
    else if ((0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._inRange(angle, 202.5, 247.5)) return "nesw-resize";
    else if ((0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._inRange(angle, 247.5, 292.5)) return "ew-resize";
    else if ((0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._inRange(angle, 292.5, 337.5)) return "nwse-resize";
    else {
        (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).error("Transformer has unknown angle for cursor detection: " + angle);
        return "pointer";
    }
}
const $f029f8c01ca14ce2$var$ANCHORS_NAMES = [
    "top-left",
    "top-center",
    "top-right",
    "middle-right",
    "middle-left",
    "bottom-left",
    "bottom-center",
    "bottom-right"
];
const $f029f8c01ca14ce2$var$MAX_SAFE_INTEGER = 100000000;
function $f029f8c01ca14ce2$var$getCenter(shape) {
    return {
        x: shape.x + shape.width / 2 * Math.cos(shape.rotation) + shape.height / 2 * Math.sin(-shape.rotation),
        y: shape.y + shape.height / 2 * Math.cos(shape.rotation) + shape.width / 2 * Math.sin(shape.rotation)
    };
}
function $f029f8c01ca14ce2$var$rotateAroundPoint(shape, angleRad, point) {
    const x = point.x + (shape.x - point.x) * Math.cos(angleRad) - (shape.y - point.y) * Math.sin(angleRad);
    const y = point.y + (shape.x - point.x) * Math.sin(angleRad) + (shape.y - point.y) * Math.cos(angleRad);
    return {
        ...shape,
        rotation: shape.rotation + angleRad,
        x: x,
        y: y
    };
}
function $f029f8c01ca14ce2$var$rotateAroundCenter(shape, deltaRad) {
    const center = $f029f8c01ca14ce2$var$getCenter(shape);
    return $f029f8c01ca14ce2$var$rotateAroundPoint(shape, deltaRad, center);
}
function $f029f8c01ca14ce2$var$getSnap(snaps, newRotationRad, tol) {
    let snapped = newRotationRad;
    for(let i = 0; i < snaps.length; i++){
        const angle = (0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).getAngle(snaps[i]);
        const absDiff = Math.abs(angle - newRotationRad) % (Math.PI * 2);
        const dif = Math.min(absDiff, Math.PI * 2 - absDiff);
        if (dif < tol) snapped = angle;
    }
    return snapped;
}
let $f029f8c01ca14ce2$var$activeTransformersCount = 0;
class $f029f8c01ca14ce2$export$f993aef960936087 extends (0, $be5edb8df13e00d8$export$eb2fcfdbd7ba97d4) {
    constructor(config){
        super(config);
        this._movingAnchorName = null;
        this._transforming = false;
        this._elementsCreated = false;
        this._createElements();
        this._handleMouseMove = this._handleMouseMove.bind(this);
        this._handleMouseUp = this._handleMouseUp.bind(this);
        this.update = this.update.bind(this);
        this.on($f029f8c01ca14ce2$var$ATTR_CHANGE_LIST, this.update);
        if (this.getNode()) this.update();
    }
    attachTo(node) {
        this.setNode(node);
        return this;
    }
    setNode(node) {
        (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).warn("tr.setNode(shape), tr.node(shape) and tr.attachTo(shape) methods are deprecated. Please use tr.nodes(nodesArray) instead.");
        return this.setNodes([
            node
        ]);
    }
    getNode() {
        return this._nodes && this._nodes[0];
    }
    _getEventNamespace() {
        return $f029f8c01ca14ce2$var$EVENTS_NAME + this._id;
    }
    setNodes(nodes = []) {
        if (this._nodes && this._nodes.length) this.detach();
        const filteredNodes = nodes.filter((node)=>{
            if (node.isAncestorOf(this)) {
                (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).error("Konva.Transformer cannot be an a child of the node you are trying to attach");
                return false;
            }
            return true;
        });
        this._nodes = nodes = filteredNodes;
        if (nodes.length === 1 && this.useSingleNodeRotation()) this.rotation(nodes[0].getAbsoluteRotation());
        else this.rotation(0);
        this._nodes.forEach((node)=>{
            const onChange = ()=>{
                if (this.nodes().length === 1 && this.useSingleNodeRotation()) this.rotation(this.nodes()[0].getAbsoluteRotation());
                this._resetTransformCache();
                if (!this._transforming && !this.isDragging()) this.update();
            };
            if (node._attrsAffectingSize.length) {
                const additionalEvents = node._attrsAffectingSize.map((prop)=>prop + "Change." + this._getEventNamespace()).join(" ");
                node.on(additionalEvents, onChange);
            }
            node.on($f029f8c01ca14ce2$var$TRANSFORM_CHANGE_STR.map((e)=>e + `.${this._getEventNamespace()}`).join(" "), onChange);
            node.on(`absoluteTransformChange.${this._getEventNamespace()}`, onChange);
            this._proxyDrag(node);
        });
        this._resetTransformCache();
        const elementsCreated = !!this.findOne(".top-left");
        if (elementsCreated) this.update();
        return this;
    }
    _proxyDrag(node) {
        let lastPos;
        node.on(`dragstart.${this._getEventNamespace()}`, (e)=>{
            lastPos = node.getAbsolutePosition();
            if (!this.isDragging() && node !== this.findOne(".back")) this.startDrag(e, false);
        });
        node.on(`dragmove.${this._getEventNamespace()}`, (e)=>{
            if (!lastPos) return;
            const abs = node.getAbsolutePosition();
            const dx = abs.x - lastPos.x;
            const dy = abs.y - lastPos.y;
            this.nodes().forEach((otherNode)=>{
                if (otherNode === node) return;
                if (otherNode.isDragging()) return;
                const otherAbs = otherNode.getAbsolutePosition();
                otherNode.setAbsolutePosition({
                    x: otherAbs.x + dx,
                    y: otherAbs.y + dy
                });
                otherNode.startDrag(e);
            });
            lastPos = null;
        });
    }
    getNodes() {
        return this._nodes || [];
    }
    getActiveAnchor() {
        return this._movingAnchorName;
    }
    detach() {
        if (this._nodes) this._nodes.forEach((node)=>{
            node.off("." + this._getEventNamespace());
        });
        this._nodes = [];
        this._resetTransformCache();
    }
    _resetTransformCache() {
        this._clearCache($f029f8c01ca14ce2$var$NODES_RECT);
        this._clearCache("transform");
        this._clearSelfAndDescendantCache("absoluteTransform");
    }
    _getNodeRect() {
        return this._getCache($f029f8c01ca14ce2$var$NODES_RECT, this.__getNodeRect);
    }
    __getNodeShape(node, rot = this.rotation(), relative) {
        const rect = node.getClientRect({
            skipTransform: true,
            skipShadow: true,
            skipStroke: this.ignoreStroke()
        });
        const absScale = node.getAbsoluteScale(relative);
        const absPos = node.getAbsolutePosition(relative);
        const dx = rect.x * absScale.x - node.offsetX() * absScale.x;
        const dy = rect.y * absScale.y - node.offsetY() * absScale.y;
        const rotation = ((0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).getAngle(node.getAbsoluteRotation()) + Math.PI * 2) % (Math.PI * 2);
        const box = {
            x: absPos.x + dx * Math.cos(rotation) + dy * Math.sin(-rotation),
            y: absPos.y + dy * Math.cos(rotation) + dx * Math.sin(rotation),
            width: rect.width * absScale.x,
            height: rect.height * absScale.y,
            rotation: rotation
        };
        return $f029f8c01ca14ce2$var$rotateAroundPoint(box, -(0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).getAngle(rot), {
            x: 0,
            y: 0
        });
    }
    __getNodeRect() {
        const node = this.getNode();
        if (!node) return {
            x: -$f029f8c01ca14ce2$var$MAX_SAFE_INTEGER,
            y: -$f029f8c01ca14ce2$var$MAX_SAFE_INTEGER,
            width: 0,
            height: 0,
            rotation: 0
        };
        const totalPoints = [];
        this.nodes().map((node)=>{
            const box = node.getClientRect({
                skipTransform: true,
                skipShadow: true,
                skipStroke: this.ignoreStroke()
            });
            const points = [
                {
                    x: box.x,
                    y: box.y
                },
                {
                    x: box.x + box.width,
                    y: box.y
                },
                {
                    x: box.x + box.width,
                    y: box.y + box.height
                },
                {
                    x: box.x,
                    y: box.y + box.height
                }
            ];
            const trans = node.getAbsoluteTransform();
            points.forEach(function(point) {
                const transformed = trans.point(point);
                totalPoints.push(transformed);
            });
        });
        const tr = new (0, $a838f7f004abc0fb$export$563a914cafbdc389)();
        tr.rotate(-(0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).getAngle(this.rotation()));
        let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
        totalPoints.forEach(function(point) {
            const transformed = tr.point(point);
            if (minX === undefined) {
                minX = maxX = transformed.x;
                minY = maxY = transformed.y;
            }
            minX = Math.min(minX, transformed.x);
            minY = Math.min(minY, transformed.y);
            maxX = Math.max(maxX, transformed.x);
            maxY = Math.max(maxY, transformed.y);
        });
        tr.invert();
        const p = tr.point({
            x: minX,
            y: minY
        });
        return {
            x: p.x,
            y: p.y,
            width: maxX - minX,
            height: maxY - minY,
            rotation: (0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).getAngle(this.rotation())
        };
    }
    getX() {
        return this._getNodeRect().x;
    }
    getY() {
        return this._getNodeRect().y;
    }
    getWidth() {
        return this._getNodeRect().width;
    }
    getHeight() {
        return this._getNodeRect().height;
    }
    _createElements() {
        this._createBack();
        $f029f8c01ca14ce2$var$ANCHORS_NAMES.forEach((name)=>{
            this._createAnchor(name);
        });
        this._createAnchor("rotater");
        this._elementsCreated = true;
    }
    _createAnchor(name) {
        const anchor = new (0, $ae05f3bb0fb9d52c$export$c79fc6492f3af13d)({
            stroke: "rgb(0, 161, 255)",
            fill: "white",
            strokeWidth: 1,
            name: name + " _anchor",
            dragDistance: 0,
            draggable: true,
            hitStrokeWidth: $f029f8c01ca14ce2$var$TOUCH_DEVICE ? 10 : "auto"
        });
        const self = this;
        anchor.on("mousedown touchstart", function(e) {
            self._handleMouseDown(e);
        });
        anchor.on("dragstart", (e)=>{
            anchor.stopDrag();
            e.cancelBubble = true;
        });
        anchor.on("dragend", (e)=>{
            e.cancelBubble = true;
        });
        anchor.on("mouseenter", ()=>{
            const rad = (0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).getAngle(this.rotation());
            const rotateCursor = this.rotateAnchorCursor();
            const cursor = $f029f8c01ca14ce2$var$getCursor(name, rad, rotateCursor);
            anchor.getStage().content && (anchor.getStage().content.style.cursor = cursor);
            this._cursorChange = true;
        });
        anchor.on("mouseout", ()=>{
            anchor.getStage().content && (anchor.getStage().content.style.cursor = "");
            this._cursorChange = false;
        });
        this.add(anchor);
    }
    _createBack() {
        const back = new (0, $dfc94508c89c186c$export$6428a7f2611ef1fa)({
            name: "back",
            width: 0,
            height: 0,
            sceneFunc (ctx, shape) {
                const tr = shape.getParent();
                const padding = tr.padding();
                const width = shape.width();
                const height = shape.height();
                ctx.beginPath();
                ctx.rect(-padding, -padding, width + padding * 2, height + padding * 2);
                if (tr.rotateEnabled() && tr.rotateLineVisible()) {
                    const rotateAnchorAngle = tr.rotateAnchorAngle();
                    const rotateAnchorOffset = tr.rotateAnchorOffset();
                    const rad = (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).degToRad(rotateAnchorAngle);
                    const dirX = Math.sin(rad);
                    const dirY = -Math.cos(rad);
                    const cx = width / 2;
                    const cy = height / 2;
                    let t = Infinity;
                    if (dirY < 0) t = Math.min(t, -cy / dirY);
                    else if (dirY > 0) t = Math.min(t, (height - cy) / dirY);
                    if (dirX < 0) t = Math.min(t, -cx / dirX);
                    else if (dirX > 0) t = Math.min(t, (width - cx) / dirX);
                    const edgeX = cx + dirX * t;
                    const edgeY = cy + dirY * t;
                    const sign = (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._sign(height);
                    const endX = edgeX + dirX * rotateAnchorOffset * sign;
                    const endY = edgeY + dirY * rotateAnchorOffset * sign;
                    ctx.moveTo(edgeX, edgeY);
                    ctx.lineTo(endX, endY);
                }
                ctx.fillStrokeShape(shape);
            },
            hitFunc: (ctx, shape)=>{
                if (!this.shouldOverdrawWholeArea()) return;
                const padding = this.padding();
                ctx.beginPath();
                ctx.rect(-padding, -padding, shape.width() + padding * 2, shape.height() + padding * 2);
                ctx.fillStrokeShape(shape);
            }
        });
        this.add(back);
        this._proxyDrag(back);
        back.on("dragstart", (e)=>{
            e.cancelBubble = true;
        });
        back.on("dragmove", (e)=>{
            e.cancelBubble = true;
        });
        back.on("dragend", (e)=>{
            e.cancelBubble = true;
        });
        this.on("dragmove", (e)=>{
            this.update();
        });
    }
    _handleMouseDown(e) {
        if (this._transforming) return;
        this._movingAnchorName = e.target.name().split(" ")[0];
        const attrs = this._getNodeRect();
        const width = attrs.width;
        const height = attrs.height;
        const hypotenuse = Math.sqrt(Math.pow(width, 2) + Math.pow(height, 2));
        this.sin = Math.abs(height / hypotenuse);
        this.cos = Math.abs(width / hypotenuse);
        if (typeof window !== "undefined") {
            window.addEventListener("mousemove", this._handleMouseMove);
            window.addEventListener("touchmove", this._handleMouseMove);
            window.addEventListener("mouseup", this._handleMouseUp, true);
            window.addEventListener("touchend", this._handleMouseUp, true);
        }
        this._transforming = true;
        const ap = e.target.getAbsolutePosition();
        const pos = e.target.getStage().getPointerPosition();
        this._anchorDragOffset = {
            x: pos.x - ap.x,
            y: pos.y - ap.y
        };
        $f029f8c01ca14ce2$var$activeTransformersCount++;
        this._fire("transformstart", {
            evt: e.evt,
            target: this.getNode()
        });
        this._nodes.forEach((target)=>{
            target._fire("transformstart", {
                evt: e.evt,
                target: target
            });
        });
    }
    _handleMouseMove(e) {
        let x, y, newHypotenuse;
        const anchorNode = this.findOne("." + this._movingAnchorName);
        const stage = anchorNode.getStage();
        stage.setPointersPositions(e);
        const pp = stage.getPointerPosition();
        let newNodePos = {
            x: pp.x - this._anchorDragOffset.x,
            y: pp.y - this._anchorDragOffset.y
        };
        const oldAbs = anchorNode.getAbsolutePosition();
        if (this.anchorDragBoundFunc()) newNodePos = this.anchorDragBoundFunc()(oldAbs, newNodePos, e);
        anchorNode.setAbsolutePosition(newNodePos);
        const newAbs = anchorNode.getAbsolutePosition();
        if (oldAbs.x === newAbs.x && oldAbs.y === newAbs.y) return;
        if (this._movingAnchorName === "rotater") {
            const attrs = this._getNodeRect();
            x = anchorNode.x() - attrs.width / 2;
            y = -anchorNode.y() + attrs.height / 2;
            const rotateAnchorAngleRad = (0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).getAngle(this.rotateAnchorAngle());
            let delta = Math.atan2(-y, x) + Math.PI / 2 - rotateAnchorAngleRad;
            if (attrs.height < 0) delta -= Math.PI;
            const oldRotation = (0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).getAngle(this.rotation());
            const newRotation = oldRotation + delta;
            const tol = (0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).getAngle(this.rotationSnapTolerance());
            const snappedRot = $f029f8c01ca14ce2$var$getSnap(this.rotationSnaps(), newRotation, tol);
            const diff = snappedRot - attrs.rotation;
            const shape = $f029f8c01ca14ce2$var$rotateAroundCenter(attrs, diff);
            this._fitNodesInto(shape, e);
            return;
        }
        const shiftBehavior = this.shiftBehavior();
        let keepProportion;
        if (shiftBehavior === "inverted") keepProportion = this.keepRatio() && !e.shiftKey;
        else if (shiftBehavior === "none") keepProportion = this.keepRatio();
        else keepProportion = this.keepRatio() || e.shiftKey;
        let centeredScaling = this.centeredScaling() || e.altKey;
        if (this._movingAnchorName === "top-left") {
            if (keepProportion) {
                const comparePoint = centeredScaling ? {
                    x: this.width() / 2,
                    y: this.height() / 2
                } : {
                    x: this.findOne(".bottom-right").x(),
                    y: this.findOne(".bottom-right").y()
                };
                newHypotenuse = Math.sqrt(Math.pow(comparePoint.x - anchorNode.x(), 2) + Math.pow(comparePoint.y - anchorNode.y(), 2));
                const reverseX = this.findOne(".top-left").x() > comparePoint.x ? -1 : 1;
                const reverseY = this.findOne(".top-left").y() > comparePoint.y ? -1 : 1;
                x = newHypotenuse * this.cos * reverseX;
                y = newHypotenuse * this.sin * reverseY;
                this.findOne(".top-left").x(comparePoint.x - x);
                this.findOne(".top-left").y(comparePoint.y - y);
            }
        } else if (this._movingAnchorName === "top-center") this.findOne(".top-left").y(anchorNode.y());
        else if (this._movingAnchorName === "top-right") {
            if (keepProportion) {
                const comparePoint = centeredScaling ? {
                    x: this.width() / 2,
                    y: this.height() / 2
                } : {
                    x: this.findOne(".bottom-left").x(),
                    y: this.findOne(".bottom-left").y()
                };
                newHypotenuse = Math.sqrt(Math.pow(anchorNode.x() - comparePoint.x, 2) + Math.pow(comparePoint.y - anchorNode.y(), 2));
                const reverseX = this.findOne(".top-right").x() < comparePoint.x ? -1 : 1;
                const reverseY = this.findOne(".top-right").y() > comparePoint.y ? -1 : 1;
                x = newHypotenuse * this.cos * reverseX;
                y = newHypotenuse * this.sin * reverseY;
                this.findOne(".top-right").x(comparePoint.x + x);
                this.findOne(".top-right").y(comparePoint.y - y);
            }
            var pos = anchorNode.position();
            this.findOne(".top-left").y(pos.y);
            this.findOne(".bottom-right").x(pos.x);
        } else if (this._movingAnchorName === "middle-left") this.findOne(".top-left").x(anchorNode.x());
        else if (this._movingAnchorName === "middle-right") this.findOne(".bottom-right").x(anchorNode.x());
        else if (this._movingAnchorName === "bottom-left") {
            if (keepProportion) {
                const comparePoint = centeredScaling ? {
                    x: this.width() / 2,
                    y: this.height() / 2
                } : {
                    x: this.findOne(".top-right").x(),
                    y: this.findOne(".top-right").y()
                };
                newHypotenuse = Math.sqrt(Math.pow(comparePoint.x - anchorNode.x(), 2) + Math.pow(anchorNode.y() - comparePoint.y, 2));
                const reverseX = comparePoint.x < anchorNode.x() ? -1 : 1;
                const reverseY = anchorNode.y() < comparePoint.y ? -1 : 1;
                x = newHypotenuse * this.cos * reverseX;
                y = newHypotenuse * this.sin * reverseY;
                anchorNode.x(comparePoint.x - x);
                anchorNode.y(comparePoint.y + y);
            }
            pos = anchorNode.position();
            this.findOne(".top-left").x(pos.x);
            this.findOne(".bottom-right").y(pos.y);
        } else if (this._movingAnchorName === "bottom-center") this.findOne(".bottom-right").y(anchorNode.y());
        else if (this._movingAnchorName === "bottom-right") {
            if (keepProportion) {
                const comparePoint = centeredScaling ? {
                    x: this.width() / 2,
                    y: this.height() / 2
                } : {
                    x: this.findOne(".top-left").x(),
                    y: this.findOne(".top-left").y()
                };
                newHypotenuse = Math.sqrt(Math.pow(anchorNode.x() - comparePoint.x, 2) + Math.pow(anchorNode.y() - comparePoint.y, 2));
                const reverseX = this.findOne(".bottom-right").x() < comparePoint.x ? -1 : 1;
                const reverseY = this.findOne(".bottom-right").y() < comparePoint.y ? -1 : 1;
                x = newHypotenuse * this.cos * reverseX;
                y = newHypotenuse * this.sin * reverseY;
                this.findOne(".bottom-right").x(comparePoint.x + x);
                this.findOne(".bottom-right").y(comparePoint.y + y);
            }
        } else console.error(new Error("Wrong position argument of selection resizer: " + this._movingAnchorName));
        centeredScaling = this.centeredScaling() || e.altKey;
        if (centeredScaling) {
            const topLeft = this.findOne(".top-left");
            const bottomRight = this.findOne(".bottom-right");
            const topOffsetX = topLeft.x();
            const topOffsetY = topLeft.y();
            const bottomOffsetX = this.getWidth() - bottomRight.x();
            const bottomOffsetY = this.getHeight() - bottomRight.y();
            bottomRight.move({
                x: -topOffsetX,
                y: -topOffsetY
            });
            topLeft.move({
                x: bottomOffsetX,
                y: bottomOffsetY
            });
        }
        const absPos = this.findOne(".top-left").getAbsolutePosition();
        x = absPos.x;
        y = absPos.y;
        const width = this.findOne(".bottom-right").x() - this.findOne(".top-left").x();
        const height = this.findOne(".bottom-right").y() - this.findOne(".top-left").y();
        this._fitNodesInto({
            x: x,
            y: y,
            width: width,
            height: height,
            rotation: (0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).getAngle(this.rotation())
        }, e);
    }
    _handleMouseUp(e) {
        this._removeEvents(e);
    }
    getAbsoluteTransform() {
        return this.getTransform();
    }
    _removeEvents(e) {
        var _a;
        if (this._transforming) {
            this._transforming = false;
            if (typeof window !== "undefined") {
                window.removeEventListener("mousemove", this._handleMouseMove);
                window.removeEventListener("touchmove", this._handleMouseMove);
                window.removeEventListener("mouseup", this._handleMouseUp, true);
                window.removeEventListener("touchend", this._handleMouseUp, true);
            }
            const node = this.getNode();
            $f029f8c01ca14ce2$var$activeTransformersCount--;
            this._fire("transformend", {
                evt: e,
                target: node
            });
            (_a = this.getLayer()) === null || _a === void 0 || _a.batchDraw();
            if (node) this._nodes.forEach((target)=>{
                var _a;
                target._fire("transformend", {
                    evt: e,
                    target: target
                });
                (_a = target.getLayer()) === null || _a === void 0 || _a.batchDraw();
            });
            this._movingAnchorName = null;
        }
    }
    _fitNodesInto(newAttrs, evt) {
        const oldAttrs = this._getNodeRect();
        const minSize = 1;
        if ((0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._inRange(newAttrs.width, -this.padding() * 2 - minSize, minSize)) {
            this.update();
            return;
        }
        if ((0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._inRange(newAttrs.height, -this.padding() * 2 - minSize, minSize)) {
            this.update();
            return;
        }
        const t = new (0, $a838f7f004abc0fb$export$563a914cafbdc389)();
        t.rotate((0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).getAngle(this.rotation()));
        if (this._movingAnchorName && newAttrs.width < 0 && this._movingAnchorName.indexOf("left") >= 0) {
            const offset = t.point({
                x: -this.padding() * 2,
                y: 0
            });
            newAttrs.x += offset.x;
            newAttrs.y += offset.y;
            newAttrs.width += this.padding() * 2;
            this._movingAnchorName = this._movingAnchorName.replace("left", "right");
            this._anchorDragOffset.x -= offset.x;
            this._anchorDragOffset.y -= offset.y;
        } else if (this._movingAnchorName && newAttrs.width < 0 && this._movingAnchorName.indexOf("right") >= 0) {
            const offset = t.point({
                x: this.padding() * 2,
                y: 0
            });
            this._movingAnchorName = this._movingAnchorName.replace("right", "left");
            this._anchorDragOffset.x -= offset.x;
            this._anchorDragOffset.y -= offset.y;
            newAttrs.width += this.padding() * 2;
        }
        if (this._movingAnchorName && newAttrs.height < 0 && this._movingAnchorName.indexOf("top") >= 0) {
            const offset = t.point({
                x: 0,
                y: -this.padding() * 2
            });
            newAttrs.x += offset.x;
            newAttrs.y += offset.y;
            this._movingAnchorName = this._movingAnchorName.replace("top", "bottom");
            this._anchorDragOffset.x -= offset.x;
            this._anchorDragOffset.y -= offset.y;
            newAttrs.height += this.padding() * 2;
        } else if (this._movingAnchorName && newAttrs.height < 0 && this._movingAnchorName.indexOf("bottom") >= 0) {
            const offset = t.point({
                x: 0,
                y: this.padding() * 2
            });
            this._movingAnchorName = this._movingAnchorName.replace("bottom", "top");
            this._anchorDragOffset.x -= offset.x;
            this._anchorDragOffset.y -= offset.y;
            newAttrs.height += this.padding() * 2;
        }
        if (this.boundBoxFunc()) {
            const bounded = this.boundBoxFunc()(oldAttrs, newAttrs);
            if (bounded) newAttrs = bounded;
            else (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).warn("boundBoxFunc returned falsy. You should return new bound rect from it!");
        }
        const baseSize = 10000000;
        const oldTr = new (0, $a838f7f004abc0fb$export$563a914cafbdc389)();
        oldTr.translate(oldAttrs.x, oldAttrs.y);
        oldTr.rotate(oldAttrs.rotation);
        oldTr.scale(oldAttrs.width / baseSize, oldAttrs.height / baseSize);
        const newTr = new (0, $a838f7f004abc0fb$export$563a914cafbdc389)();
        const newScaleX = newAttrs.width / baseSize;
        const newScaleY = newAttrs.height / baseSize;
        if (this.flipEnabled() === false) {
            newTr.translate(newAttrs.x, newAttrs.y);
            newTr.rotate(newAttrs.rotation);
            newTr.translate(newAttrs.width < 0 ? newAttrs.width : 0, newAttrs.height < 0 ? newAttrs.height : 0);
            newTr.scale(Math.abs(newScaleX), Math.abs(newScaleY));
        } else {
            newTr.translate(newAttrs.x, newAttrs.y);
            newTr.rotate(newAttrs.rotation);
            newTr.scale(newScaleX, newScaleY);
        }
        const delta = newTr.multiply(oldTr.invert());
        this._nodes.forEach((node)=>{
            var _a;
            if (!node.getStage()) return;
            const parentTransform = node.getParent().getAbsoluteTransform();
            const localTransform = node.getTransform().copy();
            localTransform.translate(node.offsetX(), node.offsetY());
            const newLocalTransform = new (0, $a838f7f004abc0fb$export$563a914cafbdc389)();
            newLocalTransform.multiply(parentTransform.copy().invert()).multiply(delta).multiply(parentTransform).multiply(localTransform);
            const attrs = newLocalTransform.decompose();
            node.setAttrs(attrs);
            (_a = node.getLayer()) === null || _a === void 0 || _a.batchDraw();
        });
        this.rotation((0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._getRotation(newAttrs.rotation));
        this._nodes.forEach((node)=>{
            this._fire("transform", {
                evt: evt,
                target: node
            });
            node._fire("transform", {
                evt: evt,
                target: node
            });
        });
        this._resetTransformCache();
        this.update();
        this.getLayer().batchDraw();
    }
    forceUpdate() {
        this._resetTransformCache();
        this.update();
    }
    _batchChangeChild(selector, attrs) {
        const anchor = this.findOne(selector);
        anchor.setAttrs(attrs);
    }
    update() {
        var _a;
        const attrs = this._getNodeRect();
        this.rotation((0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._getRotation(attrs.rotation));
        const width = attrs.width;
        const height = attrs.height;
        const enabledAnchors = this.enabledAnchors();
        const resizeEnabled = this.resizeEnabled();
        const padding = this.padding();
        const anchorSize = this.anchorSize();
        const anchors = this.find("._anchor");
        anchors.forEach((node)=>{
            node.setAttrs({
                width: anchorSize,
                height: anchorSize,
                offsetX: anchorSize / 2,
                offsetY: anchorSize / 2,
                stroke: this.anchorStroke(),
                strokeWidth: this.anchorStrokeWidth(),
                fill: this.anchorFill(),
                cornerRadius: this.anchorCornerRadius()
            });
        });
        this._batchChangeChild(".top-left", {
            x: 0,
            y: 0,
            offsetX: anchorSize / 2 + padding,
            offsetY: anchorSize / 2 + padding,
            visible: resizeEnabled && enabledAnchors.indexOf("top-left") >= 0
        });
        this._batchChangeChild(".top-center", {
            x: width / 2,
            y: 0,
            offsetY: anchorSize / 2 + padding,
            visible: resizeEnabled && enabledAnchors.indexOf("top-center") >= 0
        });
        this._batchChangeChild(".top-right", {
            x: width,
            y: 0,
            offsetX: anchorSize / 2 - padding,
            offsetY: anchorSize / 2 + padding,
            visible: resizeEnabled && enabledAnchors.indexOf("top-right") >= 0
        });
        this._batchChangeChild(".middle-left", {
            x: 0,
            y: height / 2,
            offsetX: anchorSize / 2 + padding,
            visible: resizeEnabled && enabledAnchors.indexOf("middle-left") >= 0
        });
        this._batchChangeChild(".middle-right", {
            x: width,
            y: height / 2,
            offsetX: anchorSize / 2 - padding,
            visible: resizeEnabled && enabledAnchors.indexOf("middle-right") >= 0
        });
        this._batchChangeChild(".bottom-left", {
            x: 0,
            y: height,
            offsetX: anchorSize / 2 + padding,
            offsetY: anchorSize / 2 - padding,
            visible: resizeEnabled && enabledAnchors.indexOf("bottom-left") >= 0
        });
        this._batchChangeChild(".bottom-center", {
            x: width / 2,
            y: height,
            offsetY: anchorSize / 2 - padding,
            visible: resizeEnabled && enabledAnchors.indexOf("bottom-center") >= 0
        });
        this._batchChangeChild(".bottom-right", {
            x: width,
            y: height,
            offsetX: anchorSize / 2 - padding,
            offsetY: anchorSize / 2 - padding,
            visible: resizeEnabled && enabledAnchors.indexOf("bottom-right") >= 0
        });
        const rotateAnchorAngle = this.rotateAnchorAngle();
        const rotateAnchorOffset = this.rotateAnchorOffset();
        const rad = (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).degToRad(rotateAnchorAngle);
        const dirX = Math.sin(rad);
        const dirY = -Math.cos(rad);
        const cx = width / 2;
        const cy = height / 2;
        let t = Infinity;
        if (dirY < 0) t = Math.min(t, -cy / dirY);
        else if (dirY > 0) t = Math.min(t, (height - cy) / dirY);
        if (dirX < 0) t = Math.min(t, -cx / dirX);
        else if (dirX > 0) t = Math.min(t, (width - cx) / dirX);
        const edgeX = cx + dirX * t;
        const edgeY = cy + dirY * t;
        const sign = (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd)._sign(height);
        this._batchChangeChild(".rotater", {
            x: edgeX + dirX * rotateAnchorOffset * sign,
            y: edgeY + dirY * rotateAnchorOffset * sign - padding * dirY,
            visible: this.rotateEnabled()
        });
        this._batchChangeChild(".back", {
            width: width,
            height: height,
            visible: this.borderEnabled(),
            stroke: this.borderStroke(),
            strokeWidth: this.borderStrokeWidth(),
            dash: this.borderDash(),
            draggable: this.nodes().some((node)=>node.draggable()),
            x: 0,
            y: 0
        });
        const styleFunc = this.anchorStyleFunc();
        if (styleFunc) anchors.forEach((node)=>{
            styleFunc(node);
        });
        (_a = this.getLayer()) === null || _a === void 0 || _a.batchDraw();
    }
    isTransforming() {
        return this._transforming;
    }
    stopTransform() {
        if (this._transforming) {
            this._removeEvents();
            const anchorNode = this.findOne("." + this._movingAnchorName);
            if (anchorNode) anchorNode.stopDrag();
        }
    }
    destroy() {
        if (this.getStage() && this._cursorChange) this.getStage().content && (this.getStage().content.style.cursor = "");
        (0, $be5edb8df13e00d8$export$eb2fcfdbd7ba97d4).prototype.destroy.call(this);
        this.detach();
        this._removeEvents();
        return this;
    }
    add(...children) {
        if (this._elementsCreated) {
            (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).error("You cannot add external nodes to the Transformer. Use tr.nodes([node]) instead.");
            return this;
        }
        return super.add(...children);
    }
    toObject() {
        return (0, $29d50c16ed06fd36$export$85c928794f8d04d4).prototype.toObject.call(this);
    }
    clone(obj) {
        const node = (0, $29d50c16ed06fd36$export$85c928794f8d04d4).prototype.clone.call(this, obj);
        return node;
    }
    getClientRect() {
        if (this.nodes().length > 0) return super.getClientRect();
        else return {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
    }
}
$f029f8c01ca14ce2$export$f993aef960936087.isTransforming = ()=>{
    return $f029f8c01ca14ce2$var$activeTransformersCount > 0;
};
function $f029f8c01ca14ce2$var$validateAnchors(val) {
    if (!(val instanceof Array)) (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).warn("enabledAnchors value should be an array");
    if (val instanceof Array) val.forEach(function(name) {
        if ($f029f8c01ca14ce2$var$ANCHORS_NAMES.indexOf(name) === -1) (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).warn("Unknown anchor name: " + name + ". Available names are: " + $f029f8c01ca14ce2$var$ANCHORS_NAMES.join(", "));
    });
    return val || [];
}
$f029f8c01ca14ce2$export$f993aef960936087.prototype.className = "Transformer";
(0, $bd77714a0ea3dd4d$export$f7a70d87a5e829eb)($f029f8c01ca14ce2$export$f993aef960936087);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($f029f8c01ca14ce2$export$f993aef960936087, "enabledAnchors", $f029f8c01ca14ce2$var$ANCHORS_NAMES, $f029f8c01ca14ce2$var$validateAnchors);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($f029f8c01ca14ce2$export$f993aef960936087, "flipEnabled", true, (0, $dc39f19751b6eb0f$export$147fc8b6cd20fda1)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($f029f8c01ca14ce2$export$f993aef960936087, "resizeEnabled", true);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($f029f8c01ca14ce2$export$f993aef960936087, "anchorSize", 10, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($f029f8c01ca14ce2$export$f993aef960936087, "rotateEnabled", true);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($f029f8c01ca14ce2$export$f993aef960936087, "rotateLineVisible", true);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($f029f8c01ca14ce2$export$f993aef960936087, "rotationSnaps", []);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($f029f8c01ca14ce2$export$f993aef960936087, "rotateAnchorOffset", 50, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($f029f8c01ca14ce2$export$f993aef960936087, "rotateAnchorAngle", 0, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($f029f8c01ca14ce2$export$f993aef960936087, "rotateAnchorCursor", "crosshair");
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($f029f8c01ca14ce2$export$f993aef960936087, "rotationSnapTolerance", 5, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($f029f8c01ca14ce2$export$f993aef960936087, "borderEnabled", true);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($f029f8c01ca14ce2$export$f993aef960936087, "anchorStroke", "rgb(0, 161, 255)");
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($f029f8c01ca14ce2$export$f993aef960936087, "anchorStrokeWidth", 1, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($f029f8c01ca14ce2$export$f993aef960936087, "anchorFill", "white");
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($f029f8c01ca14ce2$export$f993aef960936087, "anchorCornerRadius", 0, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($f029f8c01ca14ce2$export$f993aef960936087, "borderStroke", "rgb(0, 161, 255)");
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($f029f8c01ca14ce2$export$f993aef960936087, "borderStrokeWidth", 1, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($f029f8c01ca14ce2$export$f993aef960936087, "borderDash");
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($f029f8c01ca14ce2$export$f993aef960936087, "keepRatio", true);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($f029f8c01ca14ce2$export$f993aef960936087, "shiftBehavior", "default");
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($f029f8c01ca14ce2$export$f993aef960936087, "centeredScaling", false);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($f029f8c01ca14ce2$export$f993aef960936087, "ignoreStroke", false);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($f029f8c01ca14ce2$export$f993aef960936087, "padding", 0, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($f029f8c01ca14ce2$export$f993aef960936087, "nodes");
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($f029f8c01ca14ce2$export$f993aef960936087, "node");
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($f029f8c01ca14ce2$export$f993aef960936087, "boundBoxFunc");
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($f029f8c01ca14ce2$export$f993aef960936087, "anchorDragBoundFunc");
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($f029f8c01ca14ce2$export$f993aef960936087, "anchorStyleFunc");
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($f029f8c01ca14ce2$export$f993aef960936087, "shouldOverdrawWholeArea", false);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($f029f8c01ca14ce2$export$f993aef960936087, "useSingleNodeRotation", true);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).backCompat($f029f8c01ca14ce2$export$f993aef960936087, {
    lineEnabled: "borderEnabled",
    rotateHandlerOffset: "rotateAnchorOffset",
    enabledHandlers: "enabledAnchors"
});






class $3739947f7cc155fa$export$28718c7785907330 extends (0, $dfc94508c89c186c$export$6428a7f2611ef1fa) {
    _sceneFunc(context) {
        context.beginPath();
        context.arc(0, 0, this.radius(), 0, (0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).getAngle(this.angle()), this.clockwise());
        context.lineTo(0, 0);
        context.closePath();
        context.fillStrokeShape(this);
    }
    getWidth() {
        return this.radius() * 2;
    }
    getHeight() {
        return this.radius() * 2;
    }
    setWidth(width) {
        this.radius(width / 2);
    }
    setHeight(height) {
        this.radius(height / 2);
    }
}
$3739947f7cc155fa$export$28718c7785907330.prototype.className = "Wedge";
$3739947f7cc155fa$export$28718c7785907330.prototype._centroid = true;
$3739947f7cc155fa$export$28718c7785907330.prototype._attrsAffectingSize = [
    "radius"
];
(0, $bd77714a0ea3dd4d$export$f7a70d87a5e829eb)($3739947f7cc155fa$export$28718c7785907330);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($3739947f7cc155fa$export$28718c7785907330, "radius", 0, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($3739947f7cc155fa$export$28718c7785907330, "angle", 0, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)());
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter($3739947f7cc155fa$export$28718c7785907330, "clockwise", false);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).backCompat($3739947f7cc155fa$export$28718c7785907330, {
    angleDeg: "angle",
    getAngleDeg: "getAngle",
    setAngleDeg: "setAngle"
});





function $ccea4d2e4586a222$var$BlurStack() {
    this.r = 0;
    this.g = 0;
    this.b = 0;
    this.a = 0;
    this.next = null;
}
const $ccea4d2e4586a222$var$mul_table = [
    512,
    512,
    456,
    512,
    328,
    456,
    335,
    512,
    405,
    328,
    271,
    456,
    388,
    335,
    292,
    512,
    454,
    405,
    364,
    328,
    298,
    271,
    496,
    456,
    420,
    388,
    360,
    335,
    312,
    292,
    273,
    512,
    482,
    454,
    428,
    405,
    383,
    364,
    345,
    328,
    312,
    298,
    284,
    271,
    259,
    496,
    475,
    456,
    437,
    420,
    404,
    388,
    374,
    360,
    347,
    335,
    323,
    312,
    302,
    292,
    282,
    273,
    265,
    512,
    497,
    482,
    468,
    454,
    441,
    428,
    417,
    405,
    394,
    383,
    373,
    364,
    354,
    345,
    337,
    328,
    320,
    312,
    305,
    298,
    291,
    284,
    278,
    271,
    265,
    259,
    507,
    496,
    485,
    475,
    465,
    456,
    446,
    437,
    428,
    420,
    412,
    404,
    396,
    388,
    381,
    374,
    367,
    360,
    354,
    347,
    341,
    335,
    329,
    323,
    318,
    312,
    307,
    302,
    297,
    292,
    287,
    282,
    278,
    273,
    269,
    265,
    261,
    512,
    505,
    497,
    489,
    482,
    475,
    468,
    461,
    454,
    447,
    441,
    435,
    428,
    422,
    417,
    411,
    405,
    399,
    394,
    389,
    383,
    378,
    373,
    368,
    364,
    359,
    354,
    350,
    345,
    341,
    337,
    332,
    328,
    324,
    320,
    316,
    312,
    309,
    305,
    301,
    298,
    294,
    291,
    287,
    284,
    281,
    278,
    274,
    271,
    268,
    265,
    262,
    259,
    257,
    507,
    501,
    496,
    491,
    485,
    480,
    475,
    470,
    465,
    460,
    456,
    451,
    446,
    442,
    437,
    433,
    428,
    424,
    420,
    416,
    412,
    408,
    404,
    400,
    396,
    392,
    388,
    385,
    381,
    377,
    374,
    370,
    367,
    363,
    360,
    357,
    354,
    350,
    347,
    344,
    341,
    338,
    335,
    332,
    329,
    326,
    323,
    320,
    318,
    315,
    312,
    310,
    307,
    304,
    302,
    299,
    297,
    294,
    292,
    289,
    287,
    285,
    282,
    280,
    278,
    275,
    273,
    271,
    269,
    267,
    265,
    263,
    261,
    259
];
const $ccea4d2e4586a222$var$shg_table = [
    9,
    11,
    12,
    13,
    13,
    14,
    14,
    15,
    15,
    15,
    15,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24
];
function $ccea4d2e4586a222$var$filterGaussBlurRGBA(imageData, radius) {
    const pixels = imageData.data, width = imageData.width, height = imageData.height;
    let p, yi, yw, r_sum, g_sum, b_sum, a_sum, r_out_sum, g_out_sum, b_out_sum, a_out_sum, r_in_sum, g_in_sum, b_in_sum, a_in_sum, pr, pg, pb, pa, rbs;
    const div = radius + radius + 1, widthMinus1 = width - 1, heightMinus1 = height - 1, radiusPlus1 = radius + 1, sumFactor = radiusPlus1 * (radiusPlus1 + 1) / 2, stackStart = new $ccea4d2e4586a222$var$BlurStack(), mul_sum = $ccea4d2e4586a222$var$mul_table[radius], shg_sum = $ccea4d2e4586a222$var$shg_table[radius];
    let stackEnd = null, stack = stackStart, stackIn = null, stackOut = null;
    for(let i = 1; i < div; i++){
        stack = stack.next = new $ccea4d2e4586a222$var$BlurStack();
        if (i === radiusPlus1) stackEnd = stack;
    }
    stack.next = stackStart;
    yw = yi = 0;
    for(let y = 0; y < height; y++){
        r_in_sum = g_in_sum = b_in_sum = a_in_sum = r_sum = g_sum = b_sum = a_sum = 0;
        r_out_sum = radiusPlus1 * (pr = pixels[yi]);
        g_out_sum = radiusPlus1 * (pg = pixels[yi + 1]);
        b_out_sum = radiusPlus1 * (pb = pixels[yi + 2]);
        a_out_sum = radiusPlus1 * (pa = pixels[yi + 3]);
        r_sum += sumFactor * pr;
        g_sum += sumFactor * pg;
        b_sum += sumFactor * pb;
        a_sum += sumFactor * pa;
        stack = stackStart;
        for(let i = 0; i < radiusPlus1; i++){
            stack.r = pr;
            stack.g = pg;
            stack.b = pb;
            stack.a = pa;
            stack = stack.next;
        }
        for(let i = 1; i < radiusPlus1; i++){
            p = yi + ((widthMinus1 < i ? widthMinus1 : i) << 2);
            r_sum += (stack.r = pr = pixels[p]) * (rbs = radiusPlus1 - i);
            g_sum += (stack.g = pg = pixels[p + 1]) * rbs;
            b_sum += (stack.b = pb = pixels[p + 2]) * rbs;
            a_sum += (stack.a = pa = pixels[p + 3]) * rbs;
            r_in_sum += pr;
            g_in_sum += pg;
            b_in_sum += pb;
            a_in_sum += pa;
            stack = stack.next;
        }
        stackIn = stackStart;
        stackOut = stackEnd;
        for(let x = 0; x < width; x++){
            pixels[yi + 3] = pa = a_sum * mul_sum >> shg_sum;
            if (pa !== 0) {
                pa = 255 / pa;
                pixels[yi] = (r_sum * mul_sum >> shg_sum) * pa;
                pixels[yi + 1] = (g_sum * mul_sum >> shg_sum) * pa;
                pixels[yi + 2] = (b_sum * mul_sum >> shg_sum) * pa;
            } else pixels[yi] = pixels[yi + 1] = pixels[yi + 2] = 0;
            r_sum -= r_out_sum;
            g_sum -= g_out_sum;
            b_sum -= b_out_sum;
            a_sum -= a_out_sum;
            r_out_sum -= stackIn.r;
            g_out_sum -= stackIn.g;
            b_out_sum -= stackIn.b;
            a_out_sum -= stackIn.a;
            p = yw + ((p = x + radius + 1) < widthMinus1 ? p : widthMinus1) << 2;
            r_in_sum += stackIn.r = pixels[p];
            g_in_sum += stackIn.g = pixels[p + 1];
            b_in_sum += stackIn.b = pixels[p + 2];
            a_in_sum += stackIn.a = pixels[p + 3];
            r_sum += r_in_sum;
            g_sum += g_in_sum;
            b_sum += b_in_sum;
            a_sum += a_in_sum;
            stackIn = stackIn.next;
            r_out_sum += pr = stackOut.r;
            g_out_sum += pg = stackOut.g;
            b_out_sum += pb = stackOut.b;
            a_out_sum += pa = stackOut.a;
            r_in_sum -= pr;
            g_in_sum -= pg;
            b_in_sum -= pb;
            a_in_sum -= pa;
            stackOut = stackOut.next;
            yi += 4;
        }
        yw += width;
    }
    for(let x = 0; x < width; x++){
        g_in_sum = b_in_sum = a_in_sum = r_in_sum = g_sum = b_sum = a_sum = r_sum = 0;
        yi = x << 2;
        r_out_sum = radiusPlus1 * (pr = pixels[yi]);
        g_out_sum = radiusPlus1 * (pg = pixels[yi + 1]);
        b_out_sum = radiusPlus1 * (pb = pixels[yi + 2]);
        a_out_sum = radiusPlus1 * (pa = pixels[yi + 3]);
        r_sum += sumFactor * pr;
        g_sum += sumFactor * pg;
        b_sum += sumFactor * pb;
        a_sum += sumFactor * pa;
        stack = stackStart;
        for(let i = 0; i < radiusPlus1; i++){
            stack.r = pr;
            stack.g = pg;
            stack.b = pb;
            stack.a = pa;
            stack = stack.next;
        }
        let yp = width;
        for(let i = 1; i <= radius; i++){
            yi = yp + x << 2;
            r_sum += (stack.r = pr = pixels[yi]) * (rbs = radiusPlus1 - i);
            g_sum += (stack.g = pg = pixels[yi + 1]) * rbs;
            b_sum += (stack.b = pb = pixels[yi + 2]) * rbs;
            a_sum += (stack.a = pa = pixels[yi + 3]) * rbs;
            r_in_sum += pr;
            g_in_sum += pg;
            b_in_sum += pb;
            a_in_sum += pa;
            stack = stack.next;
            if (i < heightMinus1) yp += width;
        }
        yi = x;
        stackIn = stackStart;
        stackOut = stackEnd;
        for(let y = 0; y < height; y++){
            p = yi << 2;
            pixels[p + 3] = pa = a_sum * mul_sum >> shg_sum;
            if (pa > 0) {
                pa = 255 / pa;
                pixels[p] = (r_sum * mul_sum >> shg_sum) * pa;
                pixels[p + 1] = (g_sum * mul_sum >> shg_sum) * pa;
                pixels[p + 2] = (b_sum * mul_sum >> shg_sum) * pa;
            } else pixels[p] = pixels[p + 1] = pixels[p + 2] = 0;
            r_sum -= r_out_sum;
            g_sum -= g_out_sum;
            b_sum -= b_out_sum;
            a_sum -= a_out_sum;
            r_out_sum -= stackIn.r;
            g_out_sum -= stackIn.g;
            b_out_sum -= stackIn.b;
            a_out_sum -= stackIn.a;
            p = x + ((p = y + radiusPlus1) < heightMinus1 ? p : heightMinus1) * width << 2;
            r_sum += r_in_sum += stackIn.r = pixels[p];
            g_sum += g_in_sum += stackIn.g = pixels[p + 1];
            b_sum += b_in_sum += stackIn.b = pixels[p + 2];
            a_sum += a_in_sum += stackIn.a = pixels[p + 3];
            stackIn = stackIn.next;
            r_out_sum += pr = stackOut.r;
            g_out_sum += pg = stackOut.g;
            b_out_sum += pb = stackOut.b;
            a_out_sum += pa = stackOut.a;
            r_in_sum -= pr;
            g_in_sum -= pg;
            b_in_sum -= pb;
            a_in_sum -= pa;
            stackOut = stackOut.next;
            yi += width;
        }
    }
}
const $ccea4d2e4586a222$export$975a268f2c733e4 = function Blur(imageData) {
    const radius = Math.round(this.blurRadius());
    if (radius > 0) $ccea4d2e4586a222$var$filterGaussBlurRGBA(imageData, radius);
};
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter((0, $29d50c16ed06fd36$export$85c928794f8d04d4), "blurRadius", 0, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)(), (0, $45b0bbe8561b93ca$export$8354032f3852ec50).afterSetFilter);





const $3e9ce4adb30b8391$export$a2d0d82739cac11f = function(imageData) {
    const brightness = this.brightness() * 255, data = imageData.data, len = data.length;
    for(let i = 0; i < len; i += 4){
        data[i] += brightness;
        data[i + 1] += brightness;
        data[i + 2] += brightness;
    }
};
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter((0, $29d50c16ed06fd36$export$85c928794f8d04d4), "brightness", 0, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)(), (0, $45b0bbe8561b93ca$export$8354032f3852ec50).afterSetFilter);


const $d00dbdac6a5fbea6$export$98835ff3df8927e5 = function(imageData) {
    const brightness = this.brightness(), data = imageData.data, len = data.length;
    for(let i = 0; i < len; i += 4){
        data[i] = Math.min(255, data[i] * brightness);
        data[i + 1] = Math.min(255, data[i + 1] * brightness);
        data[i + 2] = Math.min(255, data[i + 2] * brightness);
    }
};





const $4346045936718cd9$export$656ae42051d0ca86 = function(imageData) {
    const adjust = Math.pow((this.contrast() + 100) / 100, 2);
    const data = imageData.data, nPixels = data.length;
    let red = 150, green = 150, blue = 150;
    for(let i = 0; i < nPixels; i += 4){
        red = data[i];
        green = data[i + 1];
        blue = data[i + 2];
        red /= 255;
        red -= 0.5;
        red *= adjust;
        red += 0.5;
        red *= 255;
        green /= 255;
        green -= 0.5;
        green *= adjust;
        green += 0.5;
        green *= 255;
        blue /= 255;
        blue -= 0.5;
        blue *= adjust;
        blue += 0.5;
        blue *= 255;
        red = red < 0 ? 0 : red > 255 ? 255 : red;
        green = green < 0 ? 0 : green > 255 ? 255 : green;
        blue = blue < 0 ? 0 : blue > 255 ? 255 : blue;
        data[i] = red;
        data[i + 1] = green;
        data[i + 2] = blue;
    }
};
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter((0, $29d50c16ed06fd36$export$85c928794f8d04d4), "contrast", 0, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)(), (0, $45b0bbe8561b93ca$export$8354032f3852ec50).afterSetFilter);





const $ca5081ab3685b8f6$export$3c8699b389eb838 = function(imageData) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const data = imageData.data;
    const w = imageData.width;
    const h = imageData.height;
    const strength01 = Math.min(1, Math.max(0, (_b = (_a = this.embossStrength) === null || _a === void 0 ? void 0 : _a.call(this)) !== null && _b !== void 0 ? _b : 0.5));
    const whiteLevel01 = Math.min(1, Math.max(0, (_d = (_c = this.embossWhiteLevel) === null || _c === void 0 ? void 0 : _c.call(this)) !== null && _d !== void 0 ? _d : 0.5));
    const directionMap = {
        "top-left": 315,
        top: 270,
        "top-right": 225,
        right: 180,
        "bottom-right": 135,
        bottom: 90,
        "bottom-left": 45,
        left: 0
    };
    const directionDeg = (_g = directionMap[(_f = (_e = this.embossDirection) === null || _e === void 0 ? void 0 : _e.call(this)) !== null && _f !== void 0 ? _f : "top-left"]) !== null && _g !== void 0 ? _g : 315;
    const blend = !!((_j = (_h = this.embossBlend) === null || _h === void 0 ? void 0 : _h.call(this)) !== null && _j !== void 0 ? _j : false);
    const strength = strength01 * 10;
    const bias = whiteLevel01 * 255;
    const dirRad = directionDeg * Math.PI / 180;
    const cx = Math.cos(dirRad);
    const cy = Math.sin(dirRad);
    const SCALE = 128 / 1020 * strength;
    const src = new Uint8ClampedArray(data);
    const lum = new Float32Array(w * h);
    for(let p = 0, i = 0; i < data.length; i += 4, p++)lum[p] = 0.2126 * src[i] + 0.7152 * src[i + 1] + 0.0722 * src[i + 2];
    const Gx = [
        -1,
        0,
        1,
        -2,
        0,
        2,
        -1,
        0,
        1
    ];
    const Gy = [
        -1,
        -2,
        -1,
        0,
        0,
        0,
        1,
        2,
        1
    ];
    const OFF = [
        -w - 1,
        -w,
        -w + 1,
        -1,
        0,
        1,
        w - 1,
        w,
        w + 1
    ];
    const clamp8 = (v)=>v < 0 ? 0 : v > 255 ? 255 : v;
    for(let y = 1; y < h - 1; y++)for(let x = 1; x < w - 1; x++){
        const p = y * w + x;
        let sx = 0, sy = 0;
        sx += lum[p + OFF[0]] * Gx[0];
        sy += lum[p + OFF[0]] * Gy[0];
        sx += lum[p + OFF[1]] * Gx[1];
        sy += lum[p + OFF[1]] * Gy[1];
        sx += lum[p + OFF[2]] * Gx[2];
        sy += lum[p + OFF[2]] * Gy[2];
        sx += lum[p + OFF[3]] * Gx[3];
        sy += lum[p + OFF[3]] * Gy[3];
        sx += lum[p + OFF[5]] * Gx[5];
        sy += lum[p + OFF[5]] * Gy[5];
        sx += lum[p + OFF[6]] * Gx[6];
        sy += lum[p + OFF[6]] * Gy[6];
        sx += lum[p + OFF[7]] * Gx[7];
        sy += lum[p + OFF[7]] * Gy[7];
        sx += lum[p + OFF[8]] * Gx[8];
        sy += lum[p + OFF[8]] * Gy[8];
        const r = cx * sx + cy * sy;
        const outGray = clamp8(bias + r * SCALE);
        const o = p * 4;
        if (blend) {
            const delta = outGray - bias;
            data[o] = clamp8(src[o] + delta);
            data[o + 1] = clamp8(src[o + 1] + delta);
            data[o + 2] = clamp8(src[o + 2] + delta);
            data[o + 3] = src[o + 3];
        } else {
            data[o] = data[o + 1] = data[o + 2] = outGray;
            data[o + 3] = src[o + 3];
        }
    }
    for(let x = 0; x < w; x++){
        let oTop = x * 4, oBot = ((h - 1) * w + x) * 4;
        data[oTop] = src[oTop];
        data[oTop + 1] = src[oTop + 1];
        data[oTop + 2] = src[oTop + 2];
        data[oTop + 3] = src[oTop + 3];
        data[oBot] = src[oBot];
        data[oBot + 1] = src[oBot + 1];
        data[oBot + 2] = src[oBot + 2];
        data[oBot + 3] = src[oBot + 3];
    }
    for(let y = 1; y < h - 1; y++){
        let oL = y * w * 4, oR = (y * w + (w - 1)) * 4;
        data[oL] = src[oL];
        data[oL + 1] = src[oL + 1];
        data[oL + 2] = src[oL + 2];
        data[oL + 3] = src[oL + 3];
        data[oR] = src[oR];
        data[oR + 1] = src[oR + 1];
        data[oR + 2] = src[oR + 2];
        data[oR + 3] = src[oR + 3];
    }
    return imageData;
};
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter((0, $29d50c16ed06fd36$export$85c928794f8d04d4), "embossStrength", 0.5, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)(), (0, $45b0bbe8561b93ca$export$8354032f3852ec50).afterSetFilter);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter((0, $29d50c16ed06fd36$export$85c928794f8d04d4), "embossWhiteLevel", 0.5, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)(), (0, $45b0bbe8561b93ca$export$8354032f3852ec50).afterSetFilter);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter((0, $29d50c16ed06fd36$export$85c928794f8d04d4), "embossDirection", "top-left", undefined, (0, $45b0bbe8561b93ca$export$8354032f3852ec50).afterSetFilter);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter((0, $29d50c16ed06fd36$export$85c928794f8d04d4), "embossBlend", false, undefined, (0, $45b0bbe8561b93ca$export$8354032f3852ec50).afterSetFilter);





function $0ecd0bebc2bb183e$var$remap(fromValue, fromMin, fromMax, toMin, toMax) {
    const fromRange = fromMax - fromMin, toRange = toMax - toMin;
    if (fromRange === 0) return toMin + toRange / 2;
    if (toRange === 0) return toMin;
    let toValue = (fromValue - fromMin) / fromRange;
    toValue = toRange * toValue + toMin;
    return toValue;
}
const $0ecd0bebc2bb183e$export$5cb8e8388f951d6f = function(imageData) {
    const data = imageData.data, nSubPixels = data.length;
    let rMin = data[0], rMax = rMin, r, gMin = data[1], gMax = gMin, g, bMin = data[2], bMax = bMin, b;
    const enhanceAmount = this.enhance();
    if (enhanceAmount === 0) return;
    for(let i = 0; i < nSubPixels; i += 4){
        r = data[i + 0];
        if (r < rMin) rMin = r;
        else if (r > rMax) rMax = r;
        g = data[i + 1];
        if (g < gMin) gMin = g;
        else if (g > gMax) gMax = g;
        b = data[i + 2];
        if (b < bMin) bMin = b;
        else if (b > bMax) bMax = b;
    }
    if (rMax === rMin) {
        rMax = 255;
        rMin = 0;
    }
    if (gMax === gMin) {
        gMax = 255;
        gMin = 0;
    }
    if (bMax === bMin) {
        bMax = 255;
        bMin = 0;
    }
    let rGoalMax, rGoalMin, gGoalMax, gGoalMin, bGoalMax, bGoalMin;
    if (enhanceAmount > 0) {
        rGoalMax = rMax + enhanceAmount * (255 - rMax);
        rGoalMin = rMin - enhanceAmount * (rMin - 0);
        gGoalMax = gMax + enhanceAmount * (255 - gMax);
        gGoalMin = gMin - enhanceAmount * (gMin - 0);
        bGoalMax = bMax + enhanceAmount * (255 - bMax);
        bGoalMin = bMin - enhanceAmount * (bMin - 0);
    } else {
        const rMid = (rMax + rMin) * 0.5;
        rGoalMax = rMax + enhanceAmount * (rMax - rMid);
        rGoalMin = rMin + enhanceAmount * (rMin - rMid);
        const gMid = (gMax + gMin) * 0.5;
        gGoalMax = gMax + enhanceAmount * (gMax - gMid);
        gGoalMin = gMin + enhanceAmount * (gMin - gMid);
        const bMid = (bMax + bMin) * 0.5;
        bGoalMax = bMax + enhanceAmount * (bMax - bMid);
        bGoalMin = bMin + enhanceAmount * (bMin - bMid);
    }
    for(let i = 0; i < nSubPixels; i += 4){
        data[i + 0] = $0ecd0bebc2bb183e$var$remap(data[i + 0], rMin, rMax, rGoalMin, rGoalMax);
        data[i + 1] = $0ecd0bebc2bb183e$var$remap(data[i + 1], gMin, gMax, gGoalMin, gGoalMax);
        data[i + 2] = $0ecd0bebc2bb183e$var$remap(data[i + 2], bMin, bMax, bGoalMin, bGoalMax);
    }
};
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter((0, $29d50c16ed06fd36$export$85c928794f8d04d4), "enhance", 0, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)(), (0, $45b0bbe8561b93ca$export$8354032f3852ec50).afterSetFilter);


const $6f79c94f458decc5$export$e2b0a794e83ca071 = function(imageData) {
    const data = imageData.data, len = data.length;
    for(let i = 0; i < len; i += 4){
        const brightness = 0.34 * data[i] + 0.5 * data[i + 1] + 0.16 * data[i + 2];
        data[i] = brightness;
        data[i + 1] = brightness;
        data[i + 2] = brightness;
    }
};





(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter((0, $29d50c16ed06fd36$export$85c928794f8d04d4), "hue", 0, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)(), (0, $45b0bbe8561b93ca$export$8354032f3852ec50).afterSetFilter);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter((0, $29d50c16ed06fd36$export$85c928794f8d04d4), "saturation", 0, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)(), (0, $45b0bbe8561b93ca$export$8354032f3852ec50).afterSetFilter);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter((0, $29d50c16ed06fd36$export$85c928794f8d04d4), "luminance", 0, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)(), (0, $45b0bbe8561b93ca$export$8354032f3852ec50).afterSetFilter);
const $12434559d1eb8ba9$export$46d8b0f9bc8f87a2 = function(imageData) {
    const data = imageData.data, nPixels = data.length, v = 1, s = Math.pow(2, this.saturation()), h = Math.abs(this.hue() + 360) % 360, l = this.luminance() * 127;
    const vsu = v * s * Math.cos(h * Math.PI / 180), vsw = v * s * Math.sin(h * Math.PI / 180);
    const rr = 0.299 * v + 0.701 * vsu + 0.167 * vsw, rg = 0.587 * v - 0.587 * vsu + 0.33 * vsw, rb = 0.114 * v - 0.114 * vsu - 0.497 * vsw;
    const gr = 0.299 * v - 0.299 * vsu - 0.328 * vsw, gg = 0.587 * v + 0.413 * vsu + 0.035 * vsw, gb = 0.114 * v - 0.114 * vsu + 0.293 * vsw;
    const br = 0.299 * v - 0.3 * vsu + 1.25 * vsw, bg = 0.587 * v - 0.586 * vsu - 1.05 * vsw, bb = 0.114 * v + 0.886 * vsu - 0.2 * vsw;
    let r, g, b, a;
    for(let i = 0; i < nPixels; i += 4){
        r = data[i + 0];
        g = data[i + 1];
        b = data[i + 2];
        a = data[i + 3];
        data[i + 0] = rr * r + rg * g + rb * b + l;
        data[i + 1] = gr * r + gg * g + gb * b + l;
        data[i + 2] = br * r + bg * g + bb * b + l;
        data[i + 3] = a;
    }
};





const $347cb543a2665959$export$d2edaecd208aed43 = function(imageData) {
    const data = imageData.data, nPixels = data.length, v = Math.pow(2, this.value()), s = Math.pow(2, this.saturation()), h = Math.abs(this.hue() + 360) % 360;
    const vsu = v * s * Math.cos(h * Math.PI / 180), vsw = v * s * Math.sin(h * Math.PI / 180);
    const rr = 0.299 * v + 0.701 * vsu + 0.167 * vsw, rg = 0.587 * v - 0.587 * vsu + 0.33 * vsw, rb = 0.114 * v - 0.114 * vsu - 0.497 * vsw;
    const gr = 0.299 * v - 0.299 * vsu - 0.328 * vsw, gg = 0.587 * v + 0.413 * vsu + 0.035 * vsw, gb = 0.114 * v - 0.114 * vsu + 0.293 * vsw;
    const br = 0.299 * v - 0.3 * vsu + 1.25 * vsw, bg = 0.587 * v - 0.586 * vsu - 1.05 * vsw, bb = 0.114 * v + 0.886 * vsu - 0.2 * vsw;
    for(let i = 0; i < nPixels; i += 4){
        const r = data[i + 0];
        const g = data[i + 1];
        const b = data[i + 2];
        const a = data[i + 3];
        data[i + 0] = rr * r + rg * g + rb * b;
        data[i + 1] = gr * r + gg * g + gb * b;
        data[i + 2] = br * r + bg * g + bb * b;
        data[i + 3] = a;
    }
};
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter((0, $29d50c16ed06fd36$export$85c928794f8d04d4), "hue", 0, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)(), (0, $45b0bbe8561b93ca$export$8354032f3852ec50).afterSetFilter);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter((0, $29d50c16ed06fd36$export$85c928794f8d04d4), "saturation", 0, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)(), (0, $45b0bbe8561b93ca$export$8354032f3852ec50).afterSetFilter);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter((0, $29d50c16ed06fd36$export$85c928794f8d04d4), "value", 0, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)(), (0, $45b0bbe8561b93ca$export$8354032f3852ec50).afterSetFilter);


const $60d93e440be646b7$export$1073348d81b17440 = function(imageData) {
    const data = imageData.data, len = data.length;
    for(let i = 0; i < len; i += 4){
        data[i] = 255 - data[i];
        data[i + 1] = 255 - data[i + 1];
        data[i + 2] = 255 - data[i + 2];
    }
};






const $b1a7bdbba3034639$var$ToPolar = function(src, dst, opt) {
    const srcPixels = src.data, dstPixels = dst.data, xSize = src.width, ySize = src.height, xMid = opt.polarCenterX || xSize / 2, yMid = opt.polarCenterY || ySize / 2;
    let rMax = Math.sqrt(xMid * xMid + yMid * yMid);
    let x = xSize - xMid;
    let y = ySize - yMid;
    const rad = Math.sqrt(x * x + y * y);
    rMax = rad > rMax ? rad : rMax;
    const rSize = ySize, tSize = xSize;
    const conversion = 360 / tSize * Math.PI / 180;
    for(let theta = 0; theta < tSize; theta += 1){
        const sin = Math.sin(theta * conversion);
        const cos = Math.cos(theta * conversion);
        for(let radius = 0; radius < rSize; radius += 1){
            x = Math.floor(xMid + rMax * radius / rSize * cos);
            y = Math.floor(yMid + rMax * radius / rSize * sin);
            let i = (y * xSize + x) * 4;
            const r = srcPixels[i + 0];
            const g = srcPixels[i + 1];
            const b = srcPixels[i + 2];
            const a = srcPixels[i + 3];
            i = (theta + radius * xSize) * 4;
            dstPixels[i + 0] = r;
            dstPixels[i + 1] = g;
            dstPixels[i + 2] = b;
            dstPixels[i + 3] = a;
        }
    }
};
const $b1a7bdbba3034639$var$FromPolar = function(src, dst, opt) {
    const srcPixels = src.data, dstPixels = dst.data, xSize = src.width, ySize = src.height, xMid = opt.polarCenterX || xSize / 2, yMid = opt.polarCenterY || ySize / 2;
    let rMax = Math.sqrt(xMid * xMid + yMid * yMid);
    let x = xSize - xMid;
    let y = ySize - yMid;
    const rad = Math.sqrt(x * x + y * y);
    rMax = rad > rMax ? rad : rMax;
    const rSize = ySize, tSize = xSize, phaseShift = opt.polarRotation || 0;
    let x1, y1;
    for(x = 0; x < xSize; x += 1)for(y = 0; y < ySize; y += 1){
        const dx = x - xMid;
        const dy = y - yMid;
        const radius = Math.sqrt(dx * dx + dy * dy) * rSize / rMax;
        let theta = (Math.atan2(dy, dx) * 180 / Math.PI + 360 + phaseShift) % 360;
        theta = theta * tSize / 360;
        x1 = Math.floor(theta);
        y1 = Math.floor(radius);
        let i = (y1 * xSize + x1) * 4;
        const r = srcPixels[i + 0];
        const g = srcPixels[i + 1];
        const b = srcPixels[i + 2];
        const a = srcPixels[i + 3];
        i = (y * xSize + x) * 4;
        dstPixels[i + 0] = r;
        dstPixels[i + 1] = g;
        dstPixels[i + 2] = b;
        dstPixels[i + 3] = a;
    }
};
const $b1a7bdbba3034639$export$e731e8a0fd067155 = function(imageData) {
    const xSize = imageData.width, ySize = imageData.height;
    let x, y, xoff, i, r, g, b, a, srcPos, dstPos;
    let power = Math.round(this.kaleidoscopePower());
    const angle = Math.round(this.kaleidoscopeAngle());
    const offset = Math.floor(xSize * (angle % 360) / 360);
    if (power < 1) return;
    const tempCanvas = (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).createCanvasElement();
    tempCanvas.width = xSize;
    tempCanvas.height = ySize;
    const scratchData = tempCanvas.getContext("2d").getImageData(0, 0, xSize, ySize);
    (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).releaseCanvas(tempCanvas);
    $b1a7bdbba3034639$var$ToPolar(imageData, scratchData, {
        polarCenterX: xSize / 2,
        polarCenterY: ySize / 2
    });
    let minSectionSize = xSize / Math.pow(2, power);
    while(minSectionSize <= 8){
        minSectionSize = minSectionSize * 2;
        power -= 1;
    }
    minSectionSize = Math.ceil(minSectionSize);
    let sectionSize = minSectionSize;
    let xStart = 0, xEnd = sectionSize, xDelta = 1;
    if (offset + minSectionSize > xSize) {
        xStart = sectionSize;
        xEnd = 0;
        xDelta = -1;
    }
    for(y = 0; y < ySize; y += 1)for(x = xStart; x !== xEnd; x += xDelta){
        xoff = Math.round(x + offset) % xSize;
        srcPos = (xSize * y + xoff) * 4;
        r = scratchData.data[srcPos + 0];
        g = scratchData.data[srcPos + 1];
        b = scratchData.data[srcPos + 2];
        a = scratchData.data[srcPos + 3];
        dstPos = (xSize * y + x) * 4;
        scratchData.data[dstPos + 0] = r;
        scratchData.data[dstPos + 1] = g;
        scratchData.data[dstPos + 2] = b;
        scratchData.data[dstPos + 3] = a;
    }
    for(y = 0; y < ySize; y += 1){
        sectionSize = Math.floor(minSectionSize);
        for(i = 0; i < power; i += 1){
            for(x = 0; x < sectionSize + 1; x += 1){
                srcPos = (xSize * y + x) * 4;
                r = scratchData.data[srcPos + 0];
                g = scratchData.data[srcPos + 1];
                b = scratchData.data[srcPos + 2];
                a = scratchData.data[srcPos + 3];
                dstPos = (xSize * y + sectionSize * 2 - x - 1) * 4;
                scratchData.data[dstPos + 0] = r;
                scratchData.data[dstPos + 1] = g;
                scratchData.data[dstPos + 2] = b;
                scratchData.data[dstPos + 3] = a;
            }
            sectionSize *= 2;
        }
    }
    $b1a7bdbba3034639$var$FromPolar(scratchData, imageData, {
        polarRotation: 0
    });
};
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter((0, $29d50c16ed06fd36$export$85c928794f8d04d4), "kaleidoscopePower", 2, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)(), (0, $45b0bbe8561b93ca$export$8354032f3852ec50).afterSetFilter);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter((0, $29d50c16ed06fd36$export$85c928794f8d04d4), "kaleidoscopeAngle", 0, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)(), (0, $45b0bbe8561b93ca$export$8354032f3852ec50).afterSetFilter);





function $ed441474c3fe3373$var$pixelAt(idata, x, y) {
    let idx = (y * idata.width + x) * 4;
    const d = [];
    d.push(idata.data[idx++], idata.data[idx++], idata.data[idx++], idata.data[idx++]);
    return d;
}
function $ed441474c3fe3373$var$rgbDistance(p1, p2) {
    return Math.sqrt(Math.pow(p1[0] - p2[0], 2) + Math.pow(p1[1] - p2[1], 2) + Math.pow(p1[2] - p2[2], 2));
}
function $ed441474c3fe3373$var$rgbMean(pTab) {
    const m = [
        0,
        0,
        0
    ];
    for(let i = 0; i < pTab.length; i++){
        m[0] += pTab[i][0];
        m[1] += pTab[i][1];
        m[2] += pTab[i][2];
    }
    m[0] /= pTab.length;
    m[1] /= pTab.length;
    m[2] /= pTab.length;
    return m;
}
function $ed441474c3fe3373$var$backgroundMask(idata, threshold) {
    const rgbv_no = $ed441474c3fe3373$var$pixelAt(idata, 0, 0);
    const rgbv_ne = $ed441474c3fe3373$var$pixelAt(idata, idata.width - 1, 0);
    const rgbv_so = $ed441474c3fe3373$var$pixelAt(idata, 0, idata.height - 1);
    const rgbv_se = $ed441474c3fe3373$var$pixelAt(idata, idata.width - 1, idata.height - 1);
    const thres = threshold || 10;
    if ($ed441474c3fe3373$var$rgbDistance(rgbv_no, rgbv_ne) < thres && $ed441474c3fe3373$var$rgbDistance(rgbv_ne, rgbv_se) < thres && $ed441474c3fe3373$var$rgbDistance(rgbv_se, rgbv_so) < thres && $ed441474c3fe3373$var$rgbDistance(rgbv_so, rgbv_no) < thres) {
        const mean = $ed441474c3fe3373$var$rgbMean([
            rgbv_ne,
            rgbv_no,
            rgbv_se,
            rgbv_so
        ]);
        const mask = [];
        for(let i = 0; i < idata.width * idata.height; i++){
            const d = $ed441474c3fe3373$var$rgbDistance(mean, [
                idata.data[i * 4],
                idata.data[i * 4 + 1],
                idata.data[i * 4 + 2]
            ]);
            mask[i] = d < thres ? 0 : 255;
        }
        return mask;
    }
}
function $ed441474c3fe3373$var$applyMask(idata, mask) {
    for(let i = 0; i < idata.width * idata.height; i++)idata.data[4 * i + 3] = mask[i];
}
function $ed441474c3fe3373$var$erodeMask(mask, sw, sh) {
    const weights = [
        1,
        1,
        1,
        1,
        0,
        1,
        1,
        1,
        1
    ];
    const side = Math.round(Math.sqrt(weights.length));
    const halfSide = Math.floor(side / 2);
    const maskResult = [];
    for(let y = 0; y < sh; y++)for(let x = 0; x < sw; x++){
        const so = y * sw + x;
        let a = 0;
        for(let cy = 0; cy < side; cy++)for(let cx = 0; cx < side; cx++){
            const scy = y + cy - halfSide;
            const scx = x + cx - halfSide;
            if (scy >= 0 && scy < sh && scx >= 0 && scx < sw) {
                const srcOff = scy * sw + scx;
                const wt = weights[cy * side + cx];
                a += mask[srcOff] * wt;
            }
        }
        maskResult[so] = a === 2040 ? 255 : 0;
    }
    return maskResult;
}
function $ed441474c3fe3373$var$dilateMask(mask, sw, sh) {
    const weights = [
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1
    ];
    const side = Math.round(Math.sqrt(weights.length));
    const halfSide = Math.floor(side / 2);
    const maskResult = [];
    for(let y = 0; y < sh; y++)for(let x = 0; x < sw; x++){
        const so = y * sw + x;
        let a = 0;
        for(let cy = 0; cy < side; cy++)for(let cx = 0; cx < side; cx++){
            const scy = y + cy - halfSide;
            const scx = x + cx - halfSide;
            if (scy >= 0 && scy < sh && scx >= 0 && scx < sw) {
                const srcOff = scy * sw + scx;
                const wt = weights[cy * side + cx];
                a += mask[srcOff] * wt;
            }
        }
        maskResult[so] = a >= 1020 ? 255 : 0;
    }
    return maskResult;
}
function $ed441474c3fe3373$var$smoothEdgeMask(mask, sw, sh) {
    const weights = [
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9,
        1 / 9
    ];
    const side = Math.round(Math.sqrt(weights.length));
    const halfSide = Math.floor(side / 2);
    const maskResult = [];
    for(let y = 0; y < sh; y++)for(let x = 0; x < sw; x++){
        const so = y * sw + x;
        let a = 0;
        for(let cy = 0; cy < side; cy++)for(let cx = 0; cx < side; cx++){
            const scy = y + cy - halfSide;
            const scx = x + cx - halfSide;
            if (scy >= 0 && scy < sh && scx >= 0 && scx < sw) {
                const srcOff = scy * sw + scx;
                const wt = weights[cy * side + cx];
                a += mask[srcOff] * wt;
            }
        }
        maskResult[so] = a;
    }
    return maskResult;
}
const $ed441474c3fe3373$export$991dcf7284de63d = function(imageData) {
    const threshold = this.threshold();
    let mask = $ed441474c3fe3373$var$backgroundMask(imageData, threshold);
    if (mask) {
        mask = $ed441474c3fe3373$var$erodeMask(mask, imageData.width, imageData.height);
        mask = $ed441474c3fe3373$var$dilateMask(mask, imageData.width, imageData.height);
        mask = $ed441474c3fe3373$var$smoothEdgeMask(mask, imageData.width, imageData.height);
        $ed441474c3fe3373$var$applyMask(imageData, mask);
    }
    return imageData;
};
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter((0, $29d50c16ed06fd36$export$85c928794f8d04d4), "threshold", 0, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)(), (0, $45b0bbe8561b93ca$export$8354032f3852ec50).afterSetFilter);





const $91934fec8a922d4a$export$484d33a0500a4ce1 = function(imageData) {
    const amount = this.noise() * 255, data = imageData.data, nPixels = data.length, half = amount / 2;
    for(let i = 0; i < nPixels; i += 4){
        data[i + 0] += half - 2 * half * Math.random();
        data[i + 1] += half - 2 * half * Math.random();
        data[i + 2] += half - 2 * half * Math.random();
    }
};
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter((0, $29d50c16ed06fd36$export$85c928794f8d04d4), "noise", 0.2, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)(), (0, $45b0bbe8561b93ca$export$8354032f3852ec50).afterSetFilter);






const $738ffdcaff6ea08d$export$63396595bf5aeaa7 = function(imageData) {
    let pixelSize = Math.ceil(this.pixelSize()), width = imageData.width, height = imageData.height, nBinsX = Math.ceil(width / pixelSize), nBinsY = Math.ceil(height / pixelSize), data = imageData.data;
    if (pixelSize <= 0) {
        (0, $a838f7f004abc0fb$export$f8f26dd395d7e1bd).error("pixelSize value can not be <= 0");
        return;
    }
    for(let xBin = 0; xBin < nBinsX; xBin += 1)for(let yBin = 0; yBin < nBinsY; yBin += 1){
        let red = 0;
        let green = 0;
        let blue = 0;
        let alpha = 0;
        const xBinStart = xBin * pixelSize;
        const xBinEnd = xBinStart + pixelSize;
        const yBinStart = yBin * pixelSize;
        const yBinEnd = yBinStart + pixelSize;
        let pixelsInBin = 0;
        for(let x = xBinStart; x < xBinEnd; x += 1){
            if (x >= width) continue;
            for(let y = yBinStart; y < yBinEnd; y += 1){
                if (y >= height) continue;
                const i = (width * y + x) * 4;
                red += data[i + 0];
                green += data[i + 1];
                blue += data[i + 2];
                alpha += data[i + 3];
                pixelsInBin += 1;
            }
        }
        red = red / pixelsInBin;
        green = green / pixelsInBin;
        blue = blue / pixelsInBin;
        alpha = alpha / pixelsInBin;
        for(let x = xBinStart; x < xBinEnd; x += 1){
            if (x >= width) continue;
            for(let y = yBinStart; y < yBinEnd; y += 1){
                if (y >= height) continue;
                const i = (width * y + x) * 4;
                data[i + 0] = red;
                data[i + 1] = green;
                data[i + 2] = blue;
                data[i + 3] = alpha;
            }
        }
    }
};
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter((0, $29d50c16ed06fd36$export$85c928794f8d04d4), "pixelSize", 8, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)(), (0, $45b0bbe8561b93ca$export$8354032f3852ec50).afterSetFilter);





const $843fd45d6a74a128$export$ccda2563bc5d1354 = function(imageData) {
    const levels = Math.round(this.levels() * 254) + 1, data = imageData.data, len = data.length, scale = 255 / levels;
    for(let i = 0; i < len; i += 1)data[i] = Math.floor(data[i] / scale) * scale;
};
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter((0, $29d50c16ed06fd36$export$85c928794f8d04d4), "levels", 0.5, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)(), (0, $45b0bbe8561b93ca$export$8354032f3852ec50).afterSetFilter);





const $d6d2092f747e879a$export$8f9ece5a47764b93 = function(imageData) {
    const data = imageData.data, nPixels = data.length, red = this.red(), green = this.green(), blue = this.blue();
    for(let i = 0; i < nPixels; i += 4){
        const brightness = (0.34 * data[i] + 0.5 * data[i + 1] + 0.16 * data[i + 2]) / 255;
        data[i] = brightness * red;
        data[i + 1] = brightness * green;
        data[i + 2] = brightness * blue;
        data[i + 3] = data[i + 3];
    }
};
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter((0, $29d50c16ed06fd36$export$85c928794f8d04d4), "red", 0, function(val) {
    this._filterUpToDate = false;
    if (val > 255) return 255;
    else if (val < 0) return 0;
    else return Math.round(val);
});
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter((0, $29d50c16ed06fd36$export$85c928794f8d04d4), "green", 0, function(val) {
    this._filterUpToDate = false;
    if (val > 255) return 255;
    else if (val < 0) return 0;
    else return Math.round(val);
});
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter((0, $29d50c16ed06fd36$export$85c928794f8d04d4), "blue", 0, (0, $dc39f19751b6eb0f$export$af51e4581c640b27), (0, $45b0bbe8561b93ca$export$8354032f3852ec50).afterSetFilter);





const $afa1bb650ac1aae3$export$f50470518fe8f14a = function(imageData) {
    const data = imageData.data, nPixels = data.length, red = this.red(), green = this.green(), blue = this.blue(), alpha = this.alpha();
    for(let i = 0; i < nPixels; i += 4){
        const ia = 1 - alpha;
        data[i] = red * alpha + data[i] * ia;
        data[i + 1] = green * alpha + data[i + 1] * ia;
        data[i + 2] = blue * alpha + data[i + 2] * ia;
    }
};
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter((0, $29d50c16ed06fd36$export$85c928794f8d04d4), "red", 0, function(val) {
    this._filterUpToDate = false;
    if (val > 255) return 255;
    else if (val < 0) return 0;
    else return Math.round(val);
});
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter((0, $29d50c16ed06fd36$export$85c928794f8d04d4), "green", 0, function(val) {
    this._filterUpToDate = false;
    if (val > 255) return 255;
    else if (val < 0) return 0;
    else return Math.round(val);
});
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter((0, $29d50c16ed06fd36$export$85c928794f8d04d4), "blue", 0, (0, $dc39f19751b6eb0f$export$af51e4581c640b27), (0, $45b0bbe8561b93ca$export$8354032f3852ec50).afterSetFilter);
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter((0, $29d50c16ed06fd36$export$85c928794f8d04d4), "alpha", 1, function(val) {
    this._filterUpToDate = false;
    if (val > 1) return 1;
    else if (val < 0) return 0;
    else return val;
});


const $42dfd60e56624b2f$export$1eeb4741c69006fa = function(imageData) {
    const data = imageData.data, nPixels = data.length;
    for(let i = 0; i < nPixels; i += 4){
        const r = data[i + 0];
        const g = data[i + 1];
        const b = data[i + 2];
        data[i + 0] = Math.min(255, r * 0.393 + g * 0.769 + b * 0.189);
        data[i + 1] = Math.min(255, r * 0.349 + g * 0.686 + b * 0.168);
        data[i + 2] = Math.min(255, r * 0.272 + g * 0.534 + b * 0.131);
    }
};


const $70582d75fe47ec8d$export$d60d51c3865bca60 = function(imageData) {
    const threshold = 128;
    const d = imageData.data;
    for(let i = 0; i < d.length; i += 4){
        const r = d[i], g = d[i + 1], b = d[i + 2];
        const L = 0.2126 * r + 0.7152 * g + 0.0722 * b;
        if (L >= threshold) {
            d[i] = 255 - r;
            d[i + 1] = 255 - g;
            d[i + 2] = 255 - b;
        }
    }
    return imageData;
};





const $344515a8d8240cd7$export$14f770b2ce0bb8ad = function(imageData) {
    const level = this.threshold() * 255, data = imageData.data, len = data.length;
    for(let i = 0; i < len; i += 1)data[i] = data[i] < level ? 0 : 255;
};
(0, $45b0bbe8561b93ca$export$8354032f3852ec50).addGetterSetter((0, $29d50c16ed06fd36$export$85c928794f8d04d4), "threshold", 0.5, (0, $dc39f19751b6eb0f$export$6b1205b9fbe7de2c)(), (0, $45b0bbe8561b93ca$export$8354032f3852ec50).afterSetFilter);


const $5527024b66f10ef1$export$b9f99057a3c7692 = (0, $534de9cde37e0764$export$b9f99057a3c7692).Util._assign((0, $534de9cde37e0764$export$b9f99057a3c7692), {
    Arc: $9591be4d5842003b$export$6ef80ffb606dd232,
    Arrow: $217b7afd7d07e01a$export$21b07c8f274aebd5,
    Circle: $0a508e443e6ad41b$export$c89a927ffc67e6fa,
    Ellipse: $2bdece97e49d6002$export$80b0269ab108fa11,
    Image: $362fe94bcf32bf79$export$3e431a229df88919,
    Label: $804896d9b1fc553a$export$b04be29aa201d4f5,
    Tag: $804896d9b1fc553a$export$3288d34c523a1192,
    Line: $297515b488d52990$export$17d680238e50603e,
    Path: $df50b4cb4b867012$export$4b2950bdac9b6ee9,
    Rect: $ae05f3bb0fb9d52c$export$c79fc6492f3af13d,
    RegularPolygon: $661f741ea95afa17$export$e2ee866164812ecd,
    Ring: $c7993a07651333a8$export$a6e3577650b6d6d7,
    Sprite: $17b2f1f00540e12f$export$3075603db8e6204c,
    Star: $816d95ab50ba2abf$export$1644ba17714857f1,
    Text: $647a17bcb821382d$export$5f1af8db9871e1d6,
    TextPath: $e290b26343fc00d0$export$f7e34a95cc06fac7,
    Transformer: $f029f8c01ca14ce2$export$f993aef960936087,
    Wedge: $3739947f7cc155fa$export$28718c7785907330,
    Filters: {
        Blur: $ccea4d2e4586a222$export$975a268f2c733e4,
        Brightness: $d00dbdac6a5fbea6$export$98835ff3df8927e5,
        Brighten: $3e9ce4adb30b8391$export$a2d0d82739cac11f,
        Contrast: $4346045936718cd9$export$656ae42051d0ca86,
        Emboss: $ca5081ab3685b8f6$export$3c8699b389eb838,
        Enhance: $0ecd0bebc2bb183e$export$5cb8e8388f951d6f,
        Grayscale: $6f79c94f458decc5$export$e2b0a794e83ca071,
        HSL: $12434559d1eb8ba9$export$46d8b0f9bc8f87a2,
        HSV: $347cb543a2665959$export$d2edaecd208aed43,
        Invert: $60d93e440be646b7$export$1073348d81b17440,
        Kaleidoscope: $b1a7bdbba3034639$export$e731e8a0fd067155,
        Mask: $ed441474c3fe3373$export$991dcf7284de63d,
        Noise: $91934fec8a922d4a$export$484d33a0500a4ce1,
        Pixelate: $738ffdcaff6ea08d$export$63396595bf5aeaa7,
        Posterize: $843fd45d6a74a128$export$ccda2563bc5d1354,
        RGB: $d6d2092f747e879a$export$8f9ece5a47764b93,
        RGBA: $afa1bb650ac1aae3$export$f50470518fe8f14a,
        Sepia: $42dfd60e56624b2f$export$1eeb4741c69006fa,
        Solarize: $70582d75fe47ec8d$export$d60d51c3865bca60,
        Threshold: $344515a8d8240cd7$export$14f770b2ce0bb8ad
    }
});


var $fab5e4a84905fd07$export$2e2bcd8739ae039 = (0, $5527024b66f10ef1$export$b9f99057a3c7692);


/**
 * Based on ReactArt.js
 * Copyright (c) 2017-present Lavrenov Anton.
 * All rights reserved.
 *
 * MIT
 */ 
var $cQmXV = parcelRequire("cQmXV");

var $e3bf8cae380c991a$export$2e2bcd8739ae039 = (0, $534de9cde37e0764$export$b9f99057a3c7692);


var $70935a6fe984d465$exports = {};
"use strict";

$70935a6fe984d465$exports = (parcelRequire("3PYIs"));


var $62e9e0fd8ee33f88$exports = {};
"use strict";

$62e9e0fd8ee33f88$exports = (parcelRequire("lL7Ui"));


var $d309a15caee7339c$exports = {};

$parcel$export($d309a15caee7339c$exports, "appendInitialChild", function () { return $d309a15caee7339c$export$b1cefef778e97ee8; });
$parcel$export($d309a15caee7339c$exports, "createInstance", function () { return $d309a15caee7339c$export$99152e8d49ca4e7d; });
$parcel$export($d309a15caee7339c$exports, "createTextInstance", function () { return $d309a15caee7339c$export$d1ef805cf7083486; });
$parcel$export($d309a15caee7339c$exports, "finalizeInitialChildren", function () { return $d309a15caee7339c$export$7bb0b211bcb5abfd; });
$parcel$export($d309a15caee7339c$exports, "getPublicInstance", function () { return $d309a15caee7339c$export$d2475cc200518c86; });
$parcel$export($d309a15caee7339c$exports, "prepareForCommit", function () { return $d309a15caee7339c$export$ba5994afaabfdb0c; });
$parcel$export($d309a15caee7339c$exports, "preparePortalMount", function () { return $d309a15caee7339c$export$e15c8ecd0a0092b2; });
$parcel$export($d309a15caee7339c$exports, "prepareUpdate", function () { return $d309a15caee7339c$export$c885331d842f22b5; });
$parcel$export($d309a15caee7339c$exports, "resetAfterCommit", function () { return $d309a15caee7339c$export$683e88f306512aed; });
$parcel$export($d309a15caee7339c$exports, "resetTextContent", function () { return $d309a15caee7339c$export$2119d6fc5d6f51aa; });
$parcel$export($d309a15caee7339c$exports, "shouldDeprioritizeSubtree", function () { return $d309a15caee7339c$export$70ab89a99d11d186; });
$parcel$export($d309a15caee7339c$exports, "getRootHostContext", function () { return $d309a15caee7339c$export$dce2ca0b0f5feeb5; });
$parcel$export($d309a15caee7339c$exports, "getChildHostContext", function () { return $d309a15caee7339c$export$1236a84b6992d37a; });
$parcel$export($d309a15caee7339c$exports, "scheduleTimeout", function () { return $d309a15caee7339c$export$5f4d6617421d489b; });
$parcel$export($d309a15caee7339c$exports, "cancelTimeout", function () { return $d309a15caee7339c$export$f78ec70d8091ca88; });
$parcel$export($d309a15caee7339c$exports, "supportsMicrotasks", function () { return $d309a15caee7339c$export$89e638aec9befae6; });
$parcel$export($d309a15caee7339c$exports, "scheduleMicrotask", function () { return $d309a15caee7339c$export$4304cb76768ca134; });
$parcel$export($d309a15caee7339c$exports, "noTimeout", function () { return $d309a15caee7339c$export$78506abae4a4951d; });
$parcel$export($d309a15caee7339c$exports, "shouldSetTextContent", function () { return $d309a15caee7339c$export$c82139d6d374ec34; });
$parcel$export($d309a15caee7339c$exports, "isPrimaryRenderer", function () { return $d309a15caee7339c$export$a5fcb8abea5b71a4; });
$parcel$export($d309a15caee7339c$exports, "warnsIfNotActing", function () { return $d309a15caee7339c$export$2516db7323c01bd5; });
$parcel$export($d309a15caee7339c$exports, "supportsMutation", function () { return $d309a15caee7339c$export$20f97ad47f9ebeb; });
$parcel$export($d309a15caee7339c$exports, "supportsPersistence", function () { return $d309a15caee7339c$export$bbd97ba52b7267a6; });
$parcel$export($d309a15caee7339c$exports, "supportsHydration", function () { return $d309a15caee7339c$export$34ffff2962cf1f3f; });
$parcel$export($d309a15caee7339c$exports, "appendChild", function () { return $d309a15caee7339c$export$1b8e57c9ea42f1d2; });
$parcel$export($d309a15caee7339c$exports, "appendChildToContainer", function () { return $d309a15caee7339c$export$5e391de19acdf645; });
$parcel$export($d309a15caee7339c$exports, "insertBefore", function () { return $d309a15caee7339c$export$86b68c7dbeb53c22; });
$parcel$export($d309a15caee7339c$exports, "insertInContainerBefore", function () { return $d309a15caee7339c$export$7ec3655259385e44; });
$parcel$export($d309a15caee7339c$exports, "removeChild", function () { return $d309a15caee7339c$export$7ae609f7af59e4f7; });
$parcel$export($d309a15caee7339c$exports, "removeChildFromContainer", function () { return $d309a15caee7339c$export$2e4ef5d75a473f1a; });
$parcel$export($d309a15caee7339c$exports, "commitTextUpdate", function () { return $d309a15caee7339c$export$50a92d0155bee474; });
$parcel$export($d309a15caee7339c$exports, "commitMount", function () { return $d309a15caee7339c$export$fe90794743fbfeb0; });
$parcel$export($d309a15caee7339c$exports, "commitUpdate", function () { return $d309a15caee7339c$export$fd8222818e57ec6; });
$parcel$export($d309a15caee7339c$exports, "hideInstance", function () { return $d309a15caee7339c$export$6db9fd2b8188b8b7; });
$parcel$export($d309a15caee7339c$exports, "hideTextInstance", function () { return $d309a15caee7339c$export$17ed9cbd9cb3aad2; });
$parcel$export($d309a15caee7339c$exports, "unhideInstance", function () { return $d309a15caee7339c$export$933e25c2090d1941; });
$parcel$export($d309a15caee7339c$exports, "unhideTextInstance", function () { return $d309a15caee7339c$export$8ff685cdcb7326ff; });
$parcel$export($d309a15caee7339c$exports, "clearContainer", function () { return $d309a15caee7339c$export$28e08eff11ac64f6; });
$parcel$export($d309a15caee7339c$exports, "detachDeletedInstance", function () { return $d309a15caee7339c$export$92ab91999be04e45; });
$parcel$export($d309a15caee7339c$exports, "getInstanceFromNode", function () { return $d309a15caee7339c$export$b6da67e8086e06b3; });
$parcel$export($d309a15caee7339c$exports, "beforeActiveInstanceBlur", function () { return $d309a15caee7339c$export$cd460d80a57b741b; });
$parcel$export($d309a15caee7339c$exports, "afterActiveInstanceBlur", function () { return $d309a15caee7339c$export$88d3229cfb17f808; });
$parcel$export($d309a15caee7339c$exports, "getCurrentEventPriority", function () { return $d309a15caee7339c$export$e23f0d5a7e18b951; });
$parcel$export($d309a15caee7339c$exports, "prepareScopeUpdate", function () { return $d309a15caee7339c$export$74582bbc838a85f1; });
$parcel$export($d309a15caee7339c$exports, "getInstanceFromScope", function () { return $d309a15caee7339c$export$e72a7699e3f311ad; });
$parcel$export($d309a15caee7339c$exports, "setCurrentUpdatePriority", function () { return $d309a15caee7339c$export$4fb095533041de6d; });
$parcel$export($d309a15caee7339c$exports, "getCurrentUpdatePriority", function () { return $d309a15caee7339c$export$724ac2800379cc97; });
$parcel$export($d309a15caee7339c$exports, "resolveUpdatePriority", function () { return $d309a15caee7339c$export$b6533cf90daee409; });
$parcel$export($d309a15caee7339c$exports, "shouldAttemptEagerTransition", function () { return $d309a15caee7339c$export$cb814fda1e5be712; });
$parcel$export($d309a15caee7339c$exports, "trackSchedulerEvent", function () { return $d309a15caee7339c$export$272267bc2837bcf0; });
$parcel$export($d309a15caee7339c$exports, "resolveEventType", function () { return $d309a15caee7339c$export$439ee49fa1e5d4d0; });
$parcel$export($d309a15caee7339c$exports, "resolveEventTimeStamp", function () { return $d309a15caee7339c$export$7b46ffb2e8b4b008; });
$parcel$export($d309a15caee7339c$exports, "requestPostPaintCallback", function () { return $d309a15caee7339c$export$915c0853ff0eb74b; });
$parcel$export($d309a15caee7339c$exports, "maySuspendCommit", function () { return $d309a15caee7339c$export$51314f8806e96994; });
$parcel$export($d309a15caee7339c$exports, "preloadInstance", function () { return $d309a15caee7339c$export$3dbbf6d5b17ac866; });
$parcel$export($d309a15caee7339c$exports, "startSuspendingCommit", function () { return $d309a15caee7339c$export$7c085e43cd9f6234; });
$parcel$export($d309a15caee7339c$exports, "suspendInstance", function () { return $d309a15caee7339c$export$80e4955416adc509; });
$parcel$export($d309a15caee7339c$exports, "waitForCommitToBeReady", function () { return $d309a15caee7339c$export$8620ec5aded4d151; });
$parcel$export($d309a15caee7339c$exports, "NotPendingTransition", function () { return $d309a15caee7339c$export$589be177d7bdb1b3; });
$parcel$export($d309a15caee7339c$exports, "HostTransitionContext", function () { return $d309a15caee7339c$export$5efab139fccd4e7d; });
$parcel$export($d309a15caee7339c$exports, "resetFormInstance", function () { return $d309a15caee7339c$export$5004dbd428defbd5; });
$parcel$export($d309a15caee7339c$exports, "now", function () { return (parcelRequire("1zXL0")).unstable_now; });
$parcel$export($d309a15caee7339c$exports, "idlePriority", function () { return (parcelRequire("1zXL0")).unstable_IdlePriority; });
$parcel$export($d309a15caee7339c$exports, "run", function () { return (parcelRequire("1zXL0")).unstable_runWithPriority; });

var $cQmXV = parcelRequire("cQmXV");


const $72a863ccdef2c215$var$propsToSkip = {
    children: true,
    ref: true,
    key: true,
    style: true,
    forwardedRef: true,
    unstable_applyCache: true,
    unstable_applyDrawHitFromCache: true
};
let $72a863ccdef2c215$var$zIndexWarningShowed = false;
let $72a863ccdef2c215$var$dragWarningShowed = false;
const $72a863ccdef2c215$export$3a20cc353cdae1b2 = ".react-konva-event";
let $72a863ccdef2c215$var$useStrictMode = false;
function $72a863ccdef2c215$export$5a38dcef855281ce(value) {
    $72a863ccdef2c215$var$useStrictMode = value;
}
const $72a863ccdef2c215$var$DRAGGABLE_WARNING = `ReactKonva: You have a Konva node with draggable = true and position defined but no onDragMove or onDragEnd events are handled.
Position of a node will be changed during drag&drop, so you should update state of the react app as well.
Consider to add onDragMove or onDragEnd events.
For more info see: https://github.com/konvajs/react-konva/issues/256
`;
const $72a863ccdef2c215$var$Z_INDEX_WARNING = `ReactKonva: You are using "zIndex" attribute for a Konva node.
react-konva may get confused with ordering. Just define correct order of elements in your render function of a component.
For more info see: https://github.com/konvajs/react-konva/issues/194
`;
const $72a863ccdef2c215$var$EMPTY_PROPS = {};
// Konva internals synchronously read node state right after firing events —
// e.g. Transformer fires "transform", the user handler calls setState, and
// Transformer.update() immediately repositions its anchors from the node.
// React commits async (microtask), so without a flush the chrome is measured
// from the stale node on every event. Draining the reconciler's pending sync
// work right after the user handler returns keeps Konva's read-after-fire
// contract. Injected from ReactKonvaCore to avoid an import cycle.
let $72a863ccdef2c215$var$flushPendingWork = ()=>{};
function $72a863ccdef2c215$export$64de9035c6f7d9c8(fn) {
    $72a863ccdef2c215$var$flushPendingWork = fn;
}
let $72a863ccdef2c215$var$isFlushing = false;
function $72a863ccdef2c215$var$wrapEventHandler(handler) {
    return function(...args) {
        const result = handler.apply(this, args);
        if (!$72a863ccdef2c215$var$isFlushing) {
            $72a863ccdef2c215$var$isFlushing = true;
            try {
                $72a863ccdef2c215$var$flushPendingWork();
            } finally{
                $72a863ccdef2c215$var$isFlushing = false;
            }
        }
        return result;
    };
}
function $72a863ccdef2c215$export$25d4dd8d7c7a61f6(instance, props, oldProps = $72a863ccdef2c215$var$EMPTY_PROPS) {
    // don't use zIndex in react-konva
    if (!$72a863ccdef2c215$var$zIndexWarningShowed && "zIndex" in props) {
        console.warn($72a863ccdef2c215$var$Z_INDEX_WARNING);
        $72a863ccdef2c215$var$zIndexWarningShowed = true;
    }
    // check correct draggable usage
    if (!$72a863ccdef2c215$var$dragWarningShowed && props.draggable) {
        var hasPosition = props.x !== undefined || props.y !== undefined;
        var hasEvents = props.onDragEnd || props.onDragMove;
        if (hasPosition && !hasEvents) {
            console.warn($72a863ccdef2c215$var$DRAGGABLE_WARNING);
            $72a863ccdef2c215$var$dragWarningShowed = true;
        }
    }
    // check old props
    // we need to unset properties that are not in new props
    // and remove all events
    for(var key in oldProps){
        if ($72a863ccdef2c215$var$propsToSkip[key]) continue;
        var isEvent = key.slice(0, 2) === "on";
        var propChanged = oldProps[key] !== props[key];
        // if that is a changed event, we need to remove it
        if (isEvent && propChanged) {
            var eventName = key.substr(2).toLowerCase();
            if (eventName.substr(0, 7) === "content") eventName = "content" + eventName.substr(7, 1).toUpperCase() + eventName.substr(8);
            // the bound listener is a wrapper, not the user handler, so remove by
            // our namespace (react-konva binds at most one listener per event there)
            instance.off(eventName + $72a863ccdef2c215$export$3a20cc353cdae1b2);
        }
        var toRemove = !props.hasOwnProperty(key);
        if (toRemove) instance.setAttr(key, undefined);
    }
    var strictUpdate = $72a863ccdef2c215$var$useStrictMode || props._useStrictMode;
    var updatedProps = {};
    var hasUpdates = false;
    const newEvents = {};
    for(var key in props){
        if ($72a863ccdef2c215$var$propsToSkip[key]) continue;
        var isEvent = key.slice(0, 2) === "on";
        var toAdd = oldProps[key] !== props[key];
        if (isEvent && toAdd) {
            var eventName = key.substr(2).toLowerCase();
            if (eventName.substr(0, 7) === "content") eventName = "content" + eventName.substr(7, 1).toUpperCase() + eventName.substr(8);
            // check that event is not undefined
            if (props[key]) newEvents[eventName] = props[key];
        }
        if (!isEvent && (props[key] !== oldProps[key] || strictUpdate && props[key] !== instance.getAttr(key))) {
            hasUpdates = true;
            updatedProps[key] = props[key];
        }
    }
    if (hasUpdates) {
        instance.setAttrs(updatedProps);
        $72a863ccdef2c215$export$8d64f55d8bab80d4(instance);
    }
    // subscribe to events AFTER we set attrs
    // we need it to fix https://github.com/konvajs/react-konva/issues/471
    // settings attrs may add events. Like "draggable: true" will add "mousedown" listener
    for(var eventName in newEvents){
        // first clear any existing listeners, it is required for strict mode
        instance.off(eventName + $72a863ccdef2c215$export$3a20cc353cdae1b2);
        // then attach new one
        instance.on(eventName + $72a863ccdef2c215$export$3a20cc353cdae1b2, $72a863ccdef2c215$var$wrapEventHandler(newEvents[eventName]));
    }
}
function $72a863ccdef2c215$export$8d64f55d8bab80d4(node) {
    if (!(0, $bd77714a0ea3dd4d$export$b9f99057a3c7692).autoDrawEnabled) {
        var drawingNode = node.getLayer() || node.getStage();
        drawingNode && drawingNode.batchDraw();
    }
}



var $1zXL0 = parcelRequire("1zXL0");

const $d309a15caee7339c$var$NO_CONTEXT = {};
const $d309a15caee7339c$var$UPDATE_SIGNAL = {};
// for react-spring capability
(0, $e3bf8cae380c991a$export$2e2bcd8739ae039).Node.prototype._applyProps = (0, $72a863ccdef2c215$export$25d4dd8d7c7a61f6);
// let currentUpdatePriority: number = NoEventPriority;
let $d309a15caee7339c$var$currentUpdatePriority = (0, $62e9e0fd8ee33f88$exports.DefaultEventPriority);
function $d309a15caee7339c$export$b1cefef778e97ee8(parentInstance, child) {
    if (typeof child === "string") {
        // Noop for string children of Text (eg <Text>foo</Text>)
        console.error(`Do not use plain text as child of Konva.Node. You are using text: ${child}`);
        return;
    }
    parentInstance.add(child);
    (0, $72a863ccdef2c215$export$8d64f55d8bab80d4)(parentInstance);
}
function $d309a15caee7339c$export$99152e8d49ca4e7d(type, props, internalInstanceHandle) {
    let NodeClass = (0, $e3bf8cae380c991a$export$2e2bcd8739ae039)[type];
    if (!NodeClass) {
        console.error(`Konva has no node with the type ${type}. Group will be used instead. If you use minimal version of react-konva, just import required nodes into Konva: "import "konva/lib/shapes/${type}"  If you want to render DOM elements as part of canvas tree take a look into this demo: https://konvajs.github.io/docs/react/DOM_Portal.html`);
        NodeClass = (0, $e3bf8cae380c991a$export$2e2bcd8739ae039).Group;
    }
    // we need to split props into events and non events
    // we we can pass non events into constructor directly
    // that way the performance should be better
    // we we apply change "applyNodeProps"
    // then it will trigger change events on first run
    // but we don't need them!
    const propsWithoutEvents = {};
    const propsWithOnlyEvents = {};
    for(var key in props){
        // ignore ref
        if (key === "ref") continue;
        var isEvent = key.slice(0, 2) === "on";
        if (isEvent) propsWithOnlyEvents[key] = props[key];
        else propsWithoutEvents[key] = props[key];
    }
    const instance = new NodeClass(propsWithoutEvents);
    (0, $72a863ccdef2c215$export$25d4dd8d7c7a61f6)(instance, propsWithOnlyEvents);
    return instance;
}
function $d309a15caee7339c$export$d1ef805cf7083486(text, rootContainerInstance, internalInstanceHandle) {
    console.error(`Text components are not supported for now in ReactKonva. Your text is: "${text}"`);
}
function $d309a15caee7339c$export$7bb0b211bcb5abfd(domElement, type, props) {
    return false;
}
function $d309a15caee7339c$export$d2475cc200518c86(instance) {
    return instance;
}
function $d309a15caee7339c$export$ba5994afaabfdb0c() {
    return null;
}
function $d309a15caee7339c$export$e15c8ecd0a0092b2() {
    return null;
}
function $d309a15caee7339c$export$c885331d842f22b5(domElement, type, oldProps, newProps) {
    return $d309a15caee7339c$var$UPDATE_SIGNAL;
}
function $d309a15caee7339c$export$683e88f306512aed() {
// Noop
}
function $d309a15caee7339c$export$2119d6fc5d6f51aa(domElement) {
// Noop
}
function $d309a15caee7339c$export$70ab89a99d11d186(type, props) {
    return false;
}
function $d309a15caee7339c$export$dce2ca0b0f5feeb5() {
    return $d309a15caee7339c$var$NO_CONTEXT;
}
function $d309a15caee7339c$export$1236a84b6992d37a() {
    return $d309a15caee7339c$var$NO_CONTEXT;
}
const $d309a15caee7339c$export$5f4d6617421d489b = setTimeout;
const $d309a15caee7339c$export$f78ec70d8091ca88 = clearTimeout;
const $d309a15caee7339c$export$89e638aec9befae6 = true;
const $d309a15caee7339c$export$4304cb76768ca134 = typeof queueMicrotask === "function" ? queueMicrotask : (fn)=>Promise.resolve(null).then(fn);
const $d309a15caee7339c$export$78506abae4a4951d = -1;
function $d309a15caee7339c$export$c82139d6d374ec34(type, props) {
    return false;
}
const $d309a15caee7339c$export$a5fcb8abea5b71a4 = false;
const $d309a15caee7339c$export$2516db7323c01bd5 = false;
const $d309a15caee7339c$export$20f97ad47f9ebeb = true;
const $d309a15caee7339c$export$bbd97ba52b7267a6 = false;
const $d309a15caee7339c$export$34ffff2962cf1f3f = false;
function $d309a15caee7339c$export$1b8e57c9ea42f1d2(parentInstance, child) {
    if (child.parent === parentInstance) child.moveToTop();
    else parentInstance.add(child);
    (0, $72a863ccdef2c215$export$8d64f55d8bab80d4)(parentInstance);
}
function $d309a15caee7339c$export$5e391de19acdf645(parentInstance, child) {
    if (child.parent === parentInstance) child.moveToTop();
    else parentInstance.add(child);
    (0, $72a863ccdef2c215$export$8d64f55d8bab80d4)(parentInstance);
}
function $d309a15caee7339c$export$86b68c7dbeb53c22(parentInstance, child, beforeChild) {
    // child._remove() will not stop dragging
    // but child.remove() will stop it, but we don't need it
    // removing will reset zIndexes
    child._remove();
    parentInstance.add(child);
    child.setZIndex(beforeChild.getZIndex());
    (0, $72a863ccdef2c215$export$8d64f55d8bab80d4)(parentInstance);
}
function $d309a15caee7339c$export$7ec3655259385e44(parentInstance, child, beforeChild) {
    $d309a15caee7339c$export$86b68c7dbeb53c22(parentInstance, child, beforeChild);
}
function $d309a15caee7339c$export$7ae609f7af59e4f7(parentInstance, child) {
    child.destroy();
    child.off((0, $72a863ccdef2c215$export$3a20cc353cdae1b2));
    (0, $72a863ccdef2c215$export$8d64f55d8bab80d4)(parentInstance);
}
function $d309a15caee7339c$export$2e4ef5d75a473f1a(parentInstance, child) {
    child.destroy();
    child.off((0, $72a863ccdef2c215$export$3a20cc353cdae1b2));
    (0, $72a863ccdef2c215$export$8d64f55d8bab80d4)(parentInstance);
}
function $d309a15caee7339c$export$50a92d0155bee474(textInstance, oldText, newText) {
    console.error(`Text components are not yet supported in ReactKonva. You text is: "${newText}"`);
}
function $d309a15caee7339c$export$fe90794743fbfeb0(instance, type, newProps) {
// Noop
}
function $d309a15caee7339c$export$fd8222818e57ec6(instance, type, oldProps, newProps) {
    (0, $72a863ccdef2c215$export$25d4dd8d7c7a61f6)(instance, newProps, oldProps);
}
function $d309a15caee7339c$export$6db9fd2b8188b8b7(instance) {
    instance.hide();
    (0, $72a863ccdef2c215$export$8d64f55d8bab80d4)(instance);
}
function $d309a15caee7339c$export$17ed9cbd9cb3aad2(textInstance) {
// Noop
}
function $d309a15caee7339c$export$933e25c2090d1941(instance, props) {
    if (props.visible == null || props.visible) instance.show();
}
function $d309a15caee7339c$export$8ff685cdcb7326ff(textInstance, text) {
// Noop
}
function $d309a15caee7339c$export$28e08eff11ac64f6(container) {
// Noop
}
function $d309a15caee7339c$export$92ab91999be04e45() {}
function $d309a15caee7339c$export$b6da67e8086e06b3() {
    return null;
}
function $d309a15caee7339c$export$cd460d80a57b741b() {}
function $d309a15caee7339c$export$88d3229cfb17f808() {}
function $d309a15caee7339c$export$e23f0d5a7e18b951() {
    return 0, $62e9e0fd8ee33f88$exports.DefaultEventPriority;
}
function $d309a15caee7339c$export$74582bbc838a85f1() {}
function $d309a15caee7339c$export$e72a7699e3f311ad() {
    return null;
}
function $d309a15caee7339c$export$4fb095533041de6d(newPriority) {
    $d309a15caee7339c$var$currentUpdatePriority = newPriority;
}
function $d309a15caee7339c$export$724ac2800379cc97() {
    return $d309a15caee7339c$var$currentUpdatePriority;
}
function $d309a15caee7339c$export$b6533cf90daee409() {
    return 0, $62e9e0fd8ee33f88$exports.DiscreteEventPriority;
}
function $d309a15caee7339c$export$cb814fda1e5be712() {
    return false;
}
function $d309a15caee7339c$export$272267bc2837bcf0() {}
function $d309a15caee7339c$export$439ee49fa1e5d4d0() {
    return null;
}
function $d309a15caee7339c$export$7b46ffb2e8b4b008() {
    return -1.1;
}
function $d309a15caee7339c$export$915c0853ff0eb74b() {}
function $d309a15caee7339c$export$51314f8806e96994() {
    return false;
}
function $d309a15caee7339c$export$3dbbf6d5b17ac866() {
    return true;
}
function $d309a15caee7339c$export$7c085e43cd9f6234() {}
function $d309a15caee7339c$export$80e4955416adc509() {}
function $d309a15caee7339c$export$8620ec5aded4d151() {
    return null;
}
const $d309a15caee7339c$export$589be177d7bdb1b3 = null;
const $d309a15caee7339c$export$5efab139fccd4e7d = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createContext(null);
function $d309a15caee7339c$export$5004dbd428defbd5() {}




var $cQmXV = parcelRequire("cQmXV");
const $a51749b727b78f16$var$f = /* @__PURE__ */ (()=>{
    var e, t;
    return typeof window != "undefined" && (((e = window.document) == null ? void 0 : e.createElement) || ((t = window.navigator) == null ? void 0 : t.product) === "ReactNative");
})() ? $cQmXV.useLayoutEffect : $cQmXV.useEffect;
function $a51749b727b78f16$export$e2f435051054a3fd(e, t, r) {
    if (!e) return;
    if (r(e) === !0) return e;
    let n = t ? e.return : e.child;
    for(; n;){
        const u = $a51749b727b78f16$export$e2f435051054a3fd(n, t, r);
        if (u) return u;
        n = t ? null : n.sibling;
    }
}
function $a51749b727b78f16$var$l(e) {
    try {
        return Object.defineProperties(e, {
            _currentRenderer: {
                get () {
                    return null;
                },
                set () {}
            },
            _currentRenderer2: {
                get () {
                    return null;
                },
                set () {}
            }
        });
    } catch (t) {
        return e;
    }
}
const $a51749b727b78f16$var$a = /* @__PURE__ */ $a51749b727b78f16$var$l(/* @__PURE__ */ $cQmXV.createContext(null));
class $a51749b727b78f16$export$5a20fcbfd44d38b7 extends $cQmXV.Component {
    render() {
        return /* @__PURE__ */ $cQmXV.createElement($a51749b727b78f16$var$a.Provider, {
            value: this._reactInternals
        }, this.props.children);
    }
}
function $a51749b727b78f16$export$69c8591d5df5c7d6() {
    const e = $cQmXV.useContext($a51749b727b78f16$var$a);
    if (e === null) throw new Error("its-fine: useFiber must be called within a <FiberProvider />!");
    const t = $cQmXV.useId();
    return $cQmXV.useMemo(()=>{
        for (const n of [
            e,
            e == null ? void 0 : e.alternate
        ]){
            if (!n) continue;
            const u = $a51749b727b78f16$export$e2f435051054a3fd(n, !1, (d)=>{
                let s = d.memoizedState;
                for(; s;){
                    if (s.memoizedState === t) return !0;
                    s = s.next;
                }
            });
            if (u) return u;
        }
    }, [
        e,
        t
    ]);
}
function $a51749b727b78f16$export$b537cf6ebaf7ff54() {
    const e = $a51749b727b78f16$export$69c8591d5df5c7d6(), t = $cQmXV.useMemo(()=>$a51749b727b78f16$export$e2f435051054a3fd(e, !0, (r)=>{
            var n;
            return ((n = r.stateNode) == null ? void 0 : n.containerInfo) != null;
        }), [
        e
    ]);
    return t == null ? void 0 : t.stateNode.containerInfo;
}
function $a51749b727b78f16$export$aec415ac1d7388b6(e) {
    const t = $a51749b727b78f16$export$69c8591d5df5c7d6(), r = $cQmXV.useRef(void 0);
    return $a51749b727b78f16$var$f(()=>{
        var n;
        r.current = (n = $a51749b727b78f16$export$e2f435051054a3fd(t, !1, (u)=>typeof u.type == "string" && (e === void 0 || u.type === e))) == null ? void 0 : n.stateNode;
    }, [
        t
    ]), r;
}
function $a51749b727b78f16$export$b57c9fdd1434988b(e) {
    const t = $a51749b727b78f16$export$69c8591d5df5c7d6(), r = $cQmXV.useRef(void 0);
    return $a51749b727b78f16$var$f(()=>{
        var n;
        r.current = (n = $a51749b727b78f16$export$e2f435051054a3fd(t, !0, (u)=>typeof u.type == "string" && (e === void 0 || u.type === e))) == null ? void 0 : n.stateNode;
    }, [
        t
    ]), r;
}
const $a51749b727b78f16$var$p = Symbol.for("react.context"), $a51749b727b78f16$var$b = (e)=>e !== null && typeof e == "object" && "$$typeof" in e && e.$$typeof === $a51749b727b78f16$var$p;
function $a51749b727b78f16$export$8859381a76e56404() {
    const e = $a51749b727b78f16$export$69c8591d5df5c7d6(), [t] = $cQmXV.useState(()=>/* @__PURE__ */ new Map());
    t.clear();
    let r = e;
    for(; r;){
        const n = r.type;
        $a51749b727b78f16$var$b(n) && n !== $a51749b727b78f16$var$a && !t.has(n) && t.set(n, $cQmXV.use($a51749b727b78f16$var$l(n))), r = r.return;
    }
    return t;
}
function $a51749b727b78f16$export$39579d26c695d393() {
    const e = $a51749b727b78f16$export$8859381a76e56404();
    return $cQmXV.useMemo(()=>Array.from(e.keys()).reduce((t, r)=>(n)=>/* @__PURE__ */ $cQmXV.createElement(t, null, /* @__PURE__ */ $cQmXV.createElement(r.Provider, {
                    ...n,
                    value: e.get(r)
                })), (t)=>/* @__PURE__ */ $cQmXV.createElement($a51749b727b78f16$export$5a20fcbfd44d38b7, {
                ...t
            })), [
        e
    ]);
}


"use strict";
if ((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).version.indexOf("19") === -1) throw new Error("react-konva version 19 is only compatible with React 19. Make sure to have the last version of react-konva and react or downgrade react-konva to version 18.");
function $e0d17c5c7b128a8a$var$usePrevious(value) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useRef({});
    (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useLayoutEffect(()=>{
        ref.current = value;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useLayoutEffect(()=>{
        return ()=>{
            // when using suspense it is possible that stage is unmounted
            // but React still keep component ref
            // in that case we need to manually flush props
            // we have a special test for that
            ref.current = {};
        };
    }, []);
    return ref.current;
}
const $e0d17c5c7b128a8a$var$useIsReactStrictMode = ()=>{
    const memoCount = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useRef(0);
    // in strict mode, memo will be called twice
    (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useMemo(()=>{
        memoCount.current++;
    }, []);
    return memoCount.current > 1;
};
const $e0d17c5c7b128a8a$var$StageWrap = (props)=>{
    const container = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useRef(null);
    const stage = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useRef(null);
    const fiberRef = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useRef(null);
    const oldProps = $e0d17c5c7b128a8a$var$usePrevious(props);
    const Bridge = (0, $a51749b727b78f16$export$39579d26c695d393)();
    const pendingDestroy = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useRef(null);
    const _setRef = (stage)=>{
        const { forwardedRef: forwardedRef } = props;
        if (!forwardedRef) return;
        if (typeof forwardedRef === "function") forwardedRef(stage);
        else forwardedRef.current = stage;
    };
    const isStrictMode = $e0d17c5c7b128a8a$var$useIsReactStrictMode();
    const destroyStage = ()=>{
        _setRef(null);
        // CRITICAL: flushSyncFromReconciler is required here to ensure pending work
        // (e.g. stale MobX updates on child components) is flushed synchronously
        // before the tree is torn down. Without it, unmounting a Stage can leave
        // pending Konva work that runs after the stage is already destroyed.
        $e0d17c5c7b128a8a$export$1998d71d1bc35390.flushSyncFromReconciler(()=>{
            $e0d17c5c7b128a8a$export$1998d71d1bc35390.updateContainer(null, fiberRef.current, null);
        });
        stage.current?.destroy();
        stage.current = null;
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useLayoutEffect(()=>{
        // Cancel any pending destruction (happens during re-ordering in strict mode)
        if (pendingDestroy.current) {
            clearTimeout(pendingDestroy.current);
            pendingDestroy.current = null;
        }
        // If stage already exists (re-ordering scenario), reuse it
        if (stage.current) _setRef(stage.current);
        else {
            stage.current = new (0, $e3bf8cae380c991a$export$2e2bcd8739ae039).Stage({
                width: props.width,
                height: props.height,
                container: container.current
            });
            _setRef(stage.current);
            // @ts-ignore
            fiberRef.current = $e0d17c5c7b128a8a$export$1998d71d1bc35390.createContainer(stage.current, (0, $62e9e0fd8ee33f88$exports.ConcurrentRoot), null, false, null, "", console.error, console.error, console.error, null);
            $e0d17c5c7b128a8a$export$1998d71d1bc35390.updateContainer((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement(Bridge, {}, props.children), fiberRef.current, null, ()=>{});
        }
        return ()=>{
            if (isStrictMode) // Delay destruction to allow cancellation on remount
            pendingDestroy.current = setTimeout(destroyStage, 0);
            else destroyStage();
        };
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useLayoutEffect(()=>{
        _setRef(stage.current);
        (0, $72a863ccdef2c215$export$25d4dd8d7c7a61f6)(stage.current, props, oldProps);
        // updateContainer schedules sync-lane work; with async scheduleMicrotask
        // the work is queued, so flushSyncWork() drains it inline here so that
        // a parent useLayoutEffect can read Konva nodes added by subscribing
        // children. (Lighter than flushSyncFromReconciler — no callback wrapper.)
        $e0d17c5c7b128a8a$export$1998d71d1bc35390.updateContainer((0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement(Bridge, {}, props.children), fiberRef.current, null);
        $e0d17c5c7b128a8a$export$1998d71d1bc35390.flushSyncWork();
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
        ref: container,
        id: props.id,
        accessKey: props.accessKey,
        className: props.className,
        role: props.role,
        style: props.style,
        tabIndex: props.tabIndex,
        title: props.title
    });
};
const $e0d17c5c7b128a8a$export$936d0764594b6eb3 = "Layer";
const $e0d17c5c7b128a8a$export$92d64f29192d1118 = "FastLayer";
const $e0d17c5c7b128a8a$export$eb2fcfdbd7ba97d4 = "Group";
const $e0d17c5c7b128a8a$export$b04be29aa201d4f5 = "Label";
const $e0d17c5c7b128a8a$export$c79fc6492f3af13d = "Rect";
const $e0d17c5c7b128a8a$export$c89a927ffc67e6fa = "Circle";
const $e0d17c5c7b128a8a$export$80b0269ab108fa11 = "Ellipse";
const $e0d17c5c7b128a8a$export$28718c7785907330 = "Wedge";
const $e0d17c5c7b128a8a$export$17d680238e50603e = "Line";
const $e0d17c5c7b128a8a$export$3075603db8e6204c = "Sprite";
const $e0d17c5c7b128a8a$export$3e431a229df88919 = "Image";
const $e0d17c5c7b128a8a$export$5f1af8db9871e1d6 = "Text";
const $e0d17c5c7b128a8a$export$f7e34a95cc06fac7 = "TextPath";
const $e0d17c5c7b128a8a$export$1644ba17714857f1 = "Star";
const $e0d17c5c7b128a8a$export$a6e3577650b6d6d7 = "Ring";
const $e0d17c5c7b128a8a$export$6ef80ffb606dd232 = "Arc";
const $e0d17c5c7b128a8a$export$3288d34c523a1192 = "Tag";
const $e0d17c5c7b128a8a$export$4b2950bdac9b6ee9 = "Path";
const $e0d17c5c7b128a8a$export$e2ee866164812ecd = "RegularPolygon";
const $e0d17c5c7b128a8a$export$21b07c8f274aebd5 = "Arrow";
const $e0d17c5c7b128a8a$export$6428a7f2611ef1fa = "Shape";
const $e0d17c5c7b128a8a$export$f993aef960936087 = "Transformer";
const $e0d17c5c7b128a8a$export$83d89fbfd8236492 = "19.2.5";
const $e0d17c5c7b128a8a$export$1998d71d1bc35390 = (0, (/*@__PURE__*/$parcel$interopDefault($70935a6fe984d465$exports)))($d309a15caee7339c$exports);
// Konva event handlers (bound in makeUpdates) flush pending reconciler work
// inline after the user handler returns, so Konva code that synchronously
// reads node state right after firing an event (Transformer.update) sees the
// committed result. See wrapEventHandler in makeUpdates.ts.
(0, $72a863ccdef2c215$export$64de9035c6f7d9c8)(()=>$e0d17c5c7b128a8a$export$1998d71d1bc35390.flushSyncWork());
const $e0d17c5c7b128a8a$export$208cd1682bd0e4b6 = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).forwardRef((props, ref)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $a51749b727b78f16$export$5a20fcbfd44d38b7), {}, (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement($e0d17c5c7b128a8a$var$StageWrap, {
        ...props,
        forwardedRef: ref
    }));
});
const $e0d17c5c7b128a8a$export$2e548393fba9b338 = (0, $72a863ccdef2c215$export$5a38dcef855281ce);


"use strict";





const $47e2a24e077d73f6$var$TOOLS = [
    "pen",
    "rect",
    "arrow",
    "text",
    "pan"
];
const $47e2a24e077d73f6$var$TOOL_ICON = {
    pen: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $1141984d2e96fc67$export$2e2bcd8739ae039), {}),
    rect: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $6a1efae62acd3656$export$2e2bcd8739ae039), {}),
    arrow: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e06b91036be8b9cc$export$2e2bcd8739ae039), {}),
    text: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e06fa30038248833$export$2e2bcd8739ae039), {}),
    pan: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $28aae357299e4b48$export$2e2bcd8739ae039), {})
};
/** Stroke weights, in image pixels — a 2px line is invisible on a 3000px photo, so these scale. */ const $47e2a24e077d73f6$var$WEIGHTS = {
    s: 0.004,
    m: 0.008,
    l: 0.016
};
const $47e2a24e077d73f6$var$MIN_SCALE = 0.1;
const $47e2a24e077d73f6$var$MAX_SCALE = 8;
/** Caps the exported bitmap. A 6000px source would otherwise allocate a 144MB canvas. */ const $47e2a24e077d73f6$var$MAX_EXPORT_WIDTH = 2400;
const $47e2a24e077d73f6$var$readToken = (name)=>getComputedStyle(document.documentElement).getPropertyValue(name).trim();
const $47e2a24e077d73f6$var$clamp = (value, min, max)=>Math.min(Math.max(value, min), max);
/** The two ends of a mark; freehand keeps everything between them. */ const $47e2a24e077d73f6$var$ends = (points)=>[
        points[0],
        points[1],
        points.at(-2),
        points.at(-1)
    ];
/** Every mark, drawn the same way in the live stage and in the export stage. `onMoveText` is passed
    only for the live stage — the export stage is a static snapshot and must not be interactive. */ function $47e2a24e077d73f6$var$Marks({ shapes: shapes, onMoveText: onMoveText }) {
    return shapes.map((shape, i)=>{
        const [x1, y1, x2, y2] = $47e2a24e077d73f6$var$ends(shape.points);
        /* Text is sized off the stroke weight so one control drives both, but at 5× rather than 3×:
       at 3× an M label on a 1920px photo came out at 45 image px, which is 9px on screen once the
       photo is fitted — legible in the export, unreadable while placing it.
       A placed label is draggable so it can be nudged off whatever it is pointing at. */ if (shape.tool === "text") return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e0d17c5c7b128a8a$export$5f1af8db9871e1d6), {
            name: "mark-text",
            x: x1,
            y: y1,
            text: shape.text,
            fill: shape.stroke,
            fontSize: shape.weight * 5,
            fontStyle: "bold",
            lineHeight: 1.2,
            draggable: !!onMoveText,
            onDragEnd: onMoveText ? (event)=>onMoveText(i, event.target.x(), event.target.y()) : undefined,
            onMouseEnter: onMoveText ? (event)=>event.target.getStage().container().style.cursor = "move" : undefined,
            onMouseLeave: onMoveText ? (event)=>event.target.getStage().container().style.cursor = "" : undefined
        }, i);
        if (shape.tool === "pen") return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e0d17c5c7b128a8a$export$17d680238e50603e), {
            points: shape.points,
            stroke: shape.stroke,
            strokeWidth: shape.weight,
            lineCap: "round",
            lineJoin: "round",
            tension: 0.4
        }, i);
        if (shape.tool === "rect") return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e0d17c5c7b128a8a$export$c79fc6492f3af13d), {
            x: x1,
            y: y1,
            width: x2 - x1,
            height: y2 - y1,
            stroke: shape.stroke,
            strokeWidth: shape.weight
        }, i);
        return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e0d17c5c7b128a8a$export$21b07c8f274aebd5), {
            points: [
                x1,
                y1,
                x2,
                y2
            ],
            stroke: shape.stroke,
            fill: shape.stroke,
            strokeWidth: shape.weight,
            pointerLength: shape.weight * 3,
            pointerWidth: shape.weight * 3
        }, i);
    });
}
function $47e2a24e077d73f6$var$PhotoAnnotator({ src: src, lang: lang, onDirtyChange: onDirtyChange }, ref) {
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b8441a9a81ffc5d6), key, lang);
    const [image, setImage] = (0, $cQmXV.useState)(null);
    const [loading, setLoading] = (0, $cQmXV.useState)(true);
    const [failed, setFailed] = (0, $cQmXV.useState)(false);
    const [tool, setTool] = (0, $cQmXV.useState)("pen");
    const [weightKey, setWeightKey] = (0, $cQmXV.useState)("m");
    const [colour, setColour] = (0, $cQmXV.useState)(null);
    const [shapes, setShapes] = (0, $cQmXV.useState)([]);
    /** `{ x, y, value }` in image space while a text mark is being typed. */ const [typing, setTyping] = (0, $cQmXV.useState)(null);
    const [view, setView] = (0, $cQmXV.useState)({
        scale: 1,
        x: 0,
        y: 0
    });
    const [box, setBox] = (0, $cQmXV.useState)({
        width: 0,
        height: 0
    });
    const drawing = (0, $cQmXV.useRef)(false);
    const exportStage = (0, $cQmXV.useRef)(null);
    const typingRef = (0, $cQmXV.useRef)(null);
    const observer = (0, $cQmXV.useRef)(null);
    /* The click that CREATES a text box also fires a blur on the freshly-focused input (the pointer
     sequence steals focus straight back). Committing on that blur closes the empty box before a
     key is pressed. Arm the commit-on-blur only after the creating click settles. */ const armed = (0, $cQmXV.useRef)(false);
    const palette = (0, $cQmXV.useMemo)(()=>[
            $47e2a24e077d73f6$var$readToken("--danger-500"),
            $47e2a24e077d73f6$var$readToken("--warning-500"),
            $47e2a24e077d73f6$var$readToken("--success-700"),
            $47e2a24e077d73f6$var$readToken("--action-primary")
        ], []);
    const stroke = colour || palette[0];
    /* Weights are a fraction of the photo's long edge, so a mark reads the same on any resolution. */ const weight = image ? Math.max(2, Math.round(Math.max(image.width, image.height) * $47e2a24e077d73f6$var$WEIGHTS[weightKey])) : 4;
    /* Fetch through the API so the pixels are same-origin by the time they reach the canvas. */ (0, $cQmXV.useEffect)(()=>{
        let alive = true;
        setLoading(true);
        setFailed(false);
        (0, $c9936523dc38c641$export$ae8c526ac59e8cc8)({
            method: "POST",
            url: "images/convert_image_to_base64/",
            post: {
                image: src
            }
        }, (data)=>{
            if (!alive) return;
            if (!data?.image) {
                setFailed(true);
                setLoading(false);
                return;
            }
            const element = new window.Image();
            element.onload = ()=>alive && (setImage(element), setLoading(false));
            element.onerror = ()=>alive && (setFailed(true), setLoading(false));
            /* The endpoint returns bare base64 for some records and a full data URI for others. */ element.src = String(data.image).startsWith("data:") ? data.image : `data:image/jpeg;base64,${data.image}`;
        });
        return ()=>{
            alive = false;
        };
    }, [
        src
    ]);
    /**
   * Konva sizes its canvas in pixels, so the stage is measured from its box and re-measured on
   * resize — the modal is responsive and a stage cannot be a percentage.
   *
   * ⚠ A CALLBACK ref, not `useRef` + an effect. This box does not exist until the photo has
   * loaded (the component renders a skeleton before that), so a mount effect ran while the ref
   * was still null: nothing was measured, nothing was observed, `box.width` stayed 0 and the live
   * stage was never rendered at all. A callback ref fires exactly when the node attaches.
   */ const boxRef = (0, $cQmXV.useCallback)((node)=>{
        observer.current?.disconnect();
        if (!node) return;
        const measure = ()=>setBox({
                width: node.clientWidth,
                height: node.clientHeight
            });
        measure();
        observer.current = new ResizeObserver(measure);
        observer.current.observe(node);
    }, []);
    (0, $cQmXV.useEffect)(()=>()=>observer.current?.disconnect(), []);
    /** Fit the whole photo in the viewport and centre it. Also the reset. */ const fit = (0, $cQmXV.useCallback)(()=>{
        if (!image || !box.width || !box.height) return;
        const scale = Math.min(box.width / image.width, box.height / image.height);
        setView({
            scale: scale,
            x: (box.width - image.width * scale) / 2,
            y: (box.height - image.height * scale) / 2
        });
    }, [
        image,
        box.width,
        box.height
    ]);
    (0, $cQmXV.useEffect)(fit, [
        fit
    ]);
    (0, $cQmXV.useEffect)(()=>onDirtyChange?.(shapes.length > 0), [
        shapes,
        onDirtyChange
    ]);
    /* The export renders from a SECOND stage that carries no view transform, so what is written is
     the photo at its own resolution with the marks where they were drawn — not a screenshot of
     the viewport. */ (0, $cQmXV.useImperativeHandle)(ref, ()=>({
            hasMarks: ()=>shapes.length > 0,
            toDataURL: ()=>{
                /* With or without marks. The export IS the photo the corrective task carries, and gating it
           on marks left every un-annotated rejection — the common case — with a task and no photo
           (PICSELL-1615 follow-up). Null only while the photo has not loaded. */ if (!exportStage.current || !image) return null;
                return exportStage.current.toDataURL({
                    pixelRatio: Math.min(1, $47e2a24e077d73f6$var$MAX_EXPORT_WIDTH / (image?.width || 1))
                });
            }
        }), [
        shapes,
        image
    ]);
    /**
   * Pointer → image coordinates, CLAMPED into the photo.
   *
   * The viewport is bigger than the fitted photo — on a portrait shelf shot most of the canvas is
   * empty margin — and the layer is clipped to the image, so a mark made out there would be thrown
   * away. Ignoring those clicks outright was worse: it read as "the tool is broken". Clamping puts
   * the mark on the nearest edge of the photo, which always produces visible feedback.
   */ const toImage = (stage)=>{
        const point = stage.getPointerPosition();
        return [
            $47e2a24e077d73f6$var$clamp((point.x - view.x) / view.scale, 0, image.width),
            $47e2a24e077d73f6$var$clamp((point.y - view.y) / view.scale, 0, image.height)
        ];
    };
    const onWheel = (event)=>{
        event.evt.preventDefault();
        const stage = event.target.getStage();
        const pointer = stage.getPointerPosition();
        const next = $47e2a24e077d73f6$var$clamp(view.scale * Math.exp(-event.evt.deltaY / 400), $47e2a24e077d73f6$var$MIN_SCALE, $47e2a24e077d73f6$var$MAX_SCALE);
        /* Keep the pixel under the cursor under the cursor — zooming about the centre makes finding
       a spot on a tall photo a hunt. */ setView({
            scale: next,
            x: pointer.x - (pointer.x - view.x) / view.scale * next,
            y: pointer.y - (pointer.y - view.y) / view.scale * next
        });
    };
    const onDown = (event)=>{
        if (!image || tool === "pan") return;
        /* A mousedown on an existing text mark starts its drag (the node is draggable) — don't also
       drop a new text box under it. */ if (event.target?.name?.() === "mark-text") return;
        const [x, y] = toImage(event.target.getStage());
        if (tool === "text") {
            /* `mousedown` fires BEFORE `blur`, so React has already replaced `typing` by the time the
         open box's onBlur runs — it would commit the new empty box and drop what was typed. */ if (typing) commitText();
            setTyping({
                x: x,
                y: y,
                value: ""
            });
            return;
        }
        drawing.current = true;
        setShapes((prev)=>[
                ...prev,
                {
                    tool: tool,
                    stroke: stroke,
                    weight: weight,
                    points: [
                        x,
                        y,
                        x,
                        y
                    ]
                }
            ]);
    };
    const onMove = (event)=>{
        if (!drawing.current) return;
        const [x, y] = toImage(event.target.getStage());
        setShapes((prev)=>{
            const next = prev.slice();
            const shape = {
                ...next[next.length - 1]
            };
            shape.points = shape.tool === "pen" ? [
                ...shape.points,
                x,
                y
            ] : [
                shape.points[0],
                shape.points[1],
                x,
                y
            ];
            next[next.length - 1] = shape;
            return next;
        });
    };
    const onUp = ()=>{
        if (!drawing.current) return;
        drawing.current = false;
        /* A click with no drag leaves a zero-length mark that draws as nothing but still counts as an
       edit — drop it so "has marks" stays truthful. */ setShapes((prev)=>{
            const last = prev[prev.length - 1];
            if (!last || last.tool === "text") return prev;
            const [x1, y1, x2, y2] = $47e2a24e077d73f6$var$ends(last.points);
            return Math.abs(x2 - x1) < 2 && Math.abs(y2 - y1) < 2 && last.points.length <= 4 ? prev.slice(0, -1) : prev;
        });
    };
    const commitText = ()=>{
        const value = typing?.value.trim();
        if (value) setShapes((prev)=>[
                ...prev,
                {
                    tool: "text",
                    stroke: stroke,
                    weight: weight,
                    text: value,
                    points: [
                        typing.x,
                        typing.y,
                        typing.x,
                        typing.y
                    ]
                }
            ]);
        setTyping(null);
    };
    /* The BOX's identity, not what is typed in it. Depending on the whole `typing` object re-ran the
     effect below on every keystroke, so `armed` was false for 60ms at a time and any blur-commit
     landing in that window was swallowed. */ const typingKey = typing ? `${typing.x}:${typing.y}` : null;
    (0, $cQmXV.useEffect)(()=>{
        if (!typingKey) return undefined;
        armed.current = false;
        typingRef.current?.focus();
        const id = setTimeout(()=>{
            armed.current = true;
        }, 60);
        return ()=>clearTimeout(id);
    }, [
        typingKey
    ]);
    if (loading) return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e855c7114b2916ed$export$2e2bcd8739ae039).Image, {
        active: true,
        className: "rtm-annot__skeleton"
    });
    if (failed || !image) return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $dc33dcdb2d24fbd9$export$2e2bcd8739ae039), {
        type: "warning",
        showIcon: true,
        message: t("annot_unavailable")
    });
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
        vertical: true,
        gap: "small",
        className: "rtm-annot",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                className: "rtm-annot__bar",
                align: "center",
                gap: "small",
                wrap: true,
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $ac40310dc424be23$export$2e2bcd8739ae039), {
                        value: tool,
                        onChange: setTool,
                        options: $47e2a24e077d73f6$var$TOOLS.map((value)=>({
                                value: value,
                                label: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $1e5256cf9d329b2c$export$2e2bcd8739ae039), {
                                    title: t(`annot_${value}`),
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                        role: "img",
                                        "aria-label": t(`annot_${value}`),
                                        children: $47e2a24e077d73f6$var$TOOL_ICON[value]
                                    })
                                })
                            }))
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $ac40310dc424be23$export$2e2bcd8739ae039), {
                        value: weightKey,
                        onChange: setWeightKey,
                        options: Object.keys($47e2a24e077d73f6$var$WEIGHTS).map((value)=>({
                                value: value,
                                label: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                    "aria-label": `${t("annot_weight")} ${t(`annot_weight_${value}`)}`,
                                    children: t(`annot_weight_${value}`)
                                })
                            }))
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $eb1133c43d00490b$export$2e2bcd8739ae039), {
                        size: 4,
                        role: "radiogroup",
                        "aria-label": t("annot_colour"),
                        children: palette.map((value)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("button", {
                                type: "button",
                                role: "radio",
                                "aria-checked": value === stroke,
                                "aria-label": value,
                                className: `rtm-annot__swatch${value === stroke ? " rtm-annot__swatch--on" : ""}`,
                                style: {
                                    background: value
                                },
                                onClick: ()=>setColour(value)
                            }, value))
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $eb1133c43d00490b$export$2e2bcd8739ae039), {
                        size: 4,
                        className: "rtm-annot__acts",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $1e5256cf9d329b2c$export$2e2bcd8739ae039), {
                                title: t("annot_fit"),
                                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                    size: "small",
                                    icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $bd49e6611c97a88c$export$2e2bcd8739ae039), {}),
                                    "aria-label": t("annot_fit"),
                                    onClick: fit
                                })
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $1e5256cf9d329b2c$export$2e2bcd8739ae039), {
                                title: t("annot_undo"),
                                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                    size: "small",
                                    icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $89531e4b0315317b$export$2e2bcd8739ae039), {}),
                                    disabled: !shapes.length,
                                    "aria-label": t("annot_undo"),
                                    onClick: ()=>setShapes((prev)=>prev.slice(0, -1))
                                })
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $1e5256cf9d329b2c$export$2e2bcd8739ae039), {
                                title: t("annot_clear"),
                                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                    size: "small",
                                    icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $9f593298a7a1453a$export$2e2bcd8739ae039), {}),
                                    disabled: !shapes.length,
                                    "aria-label": t("annot_clear"),
                                    onClick: ()=>setShapes([])
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                className: `rtm-annot__stage rtm-annot__stage--${tool}`,
                ref: boxRef,
                children: [
                    box.width > 0 && /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e0d17c5c7b128a8a$export$208cd1682bd0e4b6), {
                        width: box.width,
                        height: box.height,
                        onWheel: onWheel,
                        onMouseDown: onDown,
                        onMouseMove: onMove,
                        onMouseUp: onUp,
                        onMouseLeave: onUp,
                        onTouchStart: onDown,
                        onTouchMove: onMove,
                        onTouchEnd: onUp,
                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $e0d17c5c7b128a8a$export$936d0764594b6eb3), {
                            scaleX: view.scale,
                            scaleY: view.scale,
                            x: view.x,
                            y: view.y,
                            /* Clipped to the photo, so a stroke that runs into the empty margin is cut where the
                 export would cut it. Without this the viewport shows marks the exported bitmap
                 does not have — the canvas is bigger than the fitted photo by design. */ clipX: 0,
                            clipY: 0,
                            clipWidth: image.width,
                            clipHeight: image.height,
                            draggable: tool === "pan",
                            onDragEnd: (event)=>{
                                /* Konva bubbles a text mark's dragend up to here — ignore it, or the label's
                   coordinates would be written into the pan offset and the photo would jump.
                   Only the layer's own drag (panning) moves the view. */ if (event.target !== event.currentTarget) return;
                                setView((prev)=>({
                                        ...prev,
                                        x: event.target.x(),
                                        y: event.target.y()
                                    }));
                            },
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e0d17c5c7b128a8a$export$3e431a229df88919), {
                                    image: image,
                                    width: image.width,
                                    height: image.height
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($47e2a24e077d73f6$var$Marks, {
                                    shapes: shapes,
                                    onMoveText: (i, x, y)=>setShapes((prev)=>prev.map((shape, idx)=>idx === i ? {
                                                    ...shape,
                                                    points: [
                                                        x,
                                                        y,
                                                        x,
                                                        y
                                                    ]
                                                } : shape))
                                })
                            ]
                        })
                    }),
                    typing && /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("input", {
                        ref: typingRef,
                        className: "rtm-annot__text",
                        value: typing.value,
                        placeholder: t("annot_text_hint"),
                        style: {
                            left: typing.x * view.scale + view.x,
                            top: typing.y * view.scale + view.y,
                            color: stroke
                        },
                        onChange: (event)=>setTyping((prev)=>({
                                    ...prev,
                                    value: event.target.value
                                })),
                        onBlur: ()=>{
                            /* Ignore the focus-steal from the creating click; keep the box open so it can be typed
                 into. A genuine blur (clicking elsewhere) arrives after the box is armed. */ if (!armed.current) {
                                typingRef.current?.focus();
                                return;
                            }
                            commitText();
                        },
                        onKeyDown: (event)=>{
                            if (event.key === "Enter") commitText();
                            if (event.key === "Escape") setTyping(null);
                            event.stopPropagation();
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                type: "secondary",
                className: "rtm-annot__hint",
                children: t("annot_hint")
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                className: "rtm-annot__export",
                "aria-hidden": "true",
                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e0d17c5c7b128a8a$export$208cd1682bd0e4b6), {
                    ref: exportStage,
                    width: image.width,
                    height: image.height,
                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $e0d17c5c7b128a8a$export$936d0764594b6eb3), {
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e0d17c5c7b128a8a$export$3e431a229df88919), {
                                image: image,
                                width: image.width,
                                height: image.height
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($47e2a24e077d73f6$var$Marks, {
                                shapes: shapes
                            })
                        ]
                    })
                })
            })
        ]
    });
}
var $47e2a24e077d73f6$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $cQmXV.forwardRef)($47e2a24e077d73f6$var$PhotoAnnotator);


/** The "photo" task component. Hardcoded in the pre-redesign flow for want of a lookup endpoint. */ const $9525ffc2d869d787$var$PHOTO_COMPONENT_ID = 3;
/** How long the merchandiser gets, in days, before the task is due. */ const $9525ffc2d869d787$var$DEFAULT_DUE_DAYS = 30;
function $9525ffc2d869d787$export$2e2bcd8739ae039({ target: target, photo: photo, point: point, visitId: visitId, lang: lang, onCancel: onCancel, onDone: onDone }) {
    const me = (0, $b83e93e5ef3de8b0$export$2105062e25df4afe)((state)=>state.me);
    const t = (key, group = (0, $fc3f36407bc5ec6c$export$b8441a9a81ffc5d6))=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)(group, key, lang);
    const [title, setTitle] = (0, $cQmXV.useState)("");
    const [comment, setComment] = (0, $cQmXV.useState)("");
    const [due, setDue] = (0, $cQmXV.useState)((0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)().add($9525ffc2d869d787$var$DEFAULT_DUE_DAYS, "day"));
    const [priority, setPriority] = (0, $cQmXV.useState)(2);
    /* The template decides what the merchandiser is asked to submit, so it is a choice, not a
     constant — but it is REQUIRED, so opening on an empty field means every rejection starts with
     a validation error. It used to seed from `state.defaultTemplate`, which has been permanently
     null since the legacy `EntityDropdown` that dispatched it was deleted. `templates/` is ordered
     `-is_default` server-side, so page 1 row 1 IS the company default. */ const [template, setTemplate] = (0, $cQmXV.useState)(null);
    const [busy, setBusy] = (0, $cQmXV.useState)(false);
    const [error, setError] = (0, $cQmXV.useState)(null);
    const annotator = (0, $cQmXV.useRef)(null);
    (0, $cQmXV.useEffect)(()=>{
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "GET",
            url: "templates/?page_size=1"
        }, (response)=>{
            const preset = response?.results?.[0];
            if (preset?.is_default) setTemplate(preset);
        });
    }, []);
    /* The annotator exports from its own untransformed stage, so this gets the photo at its own
     resolution with the marks in place — or without any, which is the original photo re-encoded.
     ⚠ Never gate this on "has marks": `images/` takes base64 only (`Base64ImageField`), so a task
     created without an upload had NO photo, and the merchandiser got "fix this shelf" with nothing
     to look at whenever the reviewer drew nothing. Null means the photo has not loaded yet. */ const exportPhoto = ()=>annotator.current?.toDataURL() || null;
    /* The rejection itself. Posted last, so the merchandiser never sees a rejection with no task. */ const postRejection = (taskCreated)=>{
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "POST",
            url: "approvals/",
            post: {
                object_id: target.objectId,
                object_type: target.objectType,
                is_approved: false,
                comment: comment
            }
        }, (response)=>{
            setBusy(false);
            if (!response) {
                /* The task exists but the verdict did not land. Say so precisely — "failed" would send
             the reviewer back to create a second task for the same photo. */ (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).error(t("reject_task_saved_verdict_failed"));
                return;
            }
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success(taskCreated ? (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f544127b46daf517), "newtask_success_msg", lang) : t("reject_done"));
            onDone(response);
        });
    };
    const createTask = (imageId)=>{
        const post = {
            images: imageId ? [
                imageId
            ] : [],
            company: null,
            title: title.trim(),
            /* The reviewer's text goes on the TASK too, not only on the rejection — the old payload
         never sent it, so the assignment always arrived with an empty description in the admin
         panel and the mobile app alike (PICSELL-1583). Same words, two records: what was wrong
         (approval.comment) is what to fix (task.description). */ description: comment.trim(),
            start: (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)().format("YYYY-MM-DDT00:00:00"),
            end: (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)(due).format("YYYY-MM-DDT23:59:59"),
            tags: [],
            components: [
                $9525ffc2d869d787$var$PHOTO_COMPONENT_ID
            ],
            priority: priority,
            template: template && typeof template === "object" ? template.id ?? template.value : template,
            point: point?.id || null,
            network: null,
            created_by: me?.id || null,
            visit_id: visitId || 0
        };
        const { validate: validate, errors: errors } = (0, $3b579ca6158bc61b$export$6daeeb4cea31fc5)("photo-review", post);
        if (!validate) {
            setBusy(false);
            setError(Object.values(errors)[0]);
            return;
        }
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "POST",
            url: "tasks/",
            post: post
        }, (response)=>{
            if (!response?.id) {
                setBusy(false);
                setError((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f544127b46daf517), "valid_error_msg", lang));
                return;
            }
            postRejection(true);
        });
    };
    const submit = ()=>{
        if (!target?.objectId || !target?.objectType) {
            setError((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f544127b46daf517), "task_object_item_id_msg", lang));
            return;
        }
        setError(null);
        setBusy(true);
        const marked = exportPhoto();
        if (photo && !marked) {
            /* Not loaded (or failed to): a task without the photo sends the merchandiser to fix a shelf
         they cannot see. Reject-without-task stays available in the footer. */ setBusy(false);
            setError(t("reject_task_photo_pending"));
            return;
        }
        if (!marked) {
            /* This record has no photo at all — the task still goes out, without an image. */ createTask(null);
            return;
        }
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "POST",
            url: "images/",
            post: {
                owner: me,
                image: marked
            }
        }, (image)=>{
            if (!image?.id) {
                setBusy(false);
                setError((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f544127b46daf517), "valid_error_msg", lang));
                return;
            }
            createTask(image.id);
        });
    };
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $05a90c67d3627fd9$export$2e2bcd8739ae039), {
        open: true,
        title: t("reject_task_title"),
        width: 1240,
        centered: true,
        rootClassName: "rtm",
        onCancel: busy ? undefined : onCancel,
        footer: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
            align: "center",
            justify: "space-between",
            gap: "small",
            children: [
                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                    type: "text",
                    disabled: busy,
                    onClick: ()=>(setBusy(true), postRejection(false)),
                    children: t("reject_without_task")
                }),
                /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                    gap: "small",
                    children: [
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                            disabled: busy,
                            onClick: onCancel,
                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f544127b46daf517), "cancel", lang)
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                            type: "primary",
                            danger: true,
                            loading: busy,
                            onClick: submit,
                            children: t("reject_task_submit")
                        })
                    ]
                })
            ]
        }),
        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $db6c3adada49524e$export$2e2bcd8739ae039), {
            gutter: [
                16,
                16
            ],
            className: "rtm__body",
            children: [
                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $cde227eb983ae1d2$export$2e2bcd8739ae039), {
                    xs: 24,
                    lg: 14,
                    children: photo ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $47e2a24e077d73f6$export$2e2bcd8739ae039), {
                        ref: annotator,
                        src: photo,
                        lang: lang
                    }) : null
                }),
                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $cde227eb983ae1d2$export$2e2bcd8739ae039), {
                    xs: 24,
                    lg: 10,
                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039), {
                        layout: "vertical",
                        component: false,
                        colon: false,
                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                            vertical: true,
                            gap: "small",
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                    label: t("reject_task_name"),
                                    required: true,
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0883e7f8083c01b0$export$2e2bcd8739ae039), {
                                        value: title,
                                        maxLength: 120,
                                        onChange: (event)=>setTitle(event.target.value)
                                    })
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                    label: t("reject_task_template"),
                                    required: true,
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b6929c6a194abc34$export$2e2bcd8739ae039), {
                                        entity: "template",
                                        value: template,
                                        onChange: setTemplate,
                                        allowClear: false
                                    })
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                    gap: "small",
                                    wrap: true,
                                    children: [
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                            label: t("reject_task_due"),
                                            className: "rtm__due",
                                            children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $bf89508d36c51d8b$export$2e2bcd8739ae039), {
                                                value: due,
                                                allowClear: false,
                                                disabledDate: (d)=>d && d < (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)().startOf("day"),
                                                onChange: setDue
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                            label: t("reject_task_priority"),
                                            className: "rtm__priority",
                                            children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $872fd39f1285217b$export$2e2bcd8739ae039), {
                                                value: priority,
                                                onChange: setPriority,
                                                options: [
                                                    1,
                                                    2,
                                                    3
                                                ].map((value)=>({
                                                        value: value,
                                                        label: t(`priority_${value}`)
                                                    }))
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                    label: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ce86776e5caf6dd0), "comment", lang),
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0883e7f8083c01b0$export$2e2bcd8739ae039).TextArea, {
                                        value: comment,
                                        rows: 3,
                                        maxLength: 500,
                                        onChange: (event)=>setComment(event.target.value)
                                    })
                                }),
                                point?.name ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                    type: "secondary",
                                    children: [
                                        t("reject_task_for"),
                                        ": ",
                                        [
                                            point.locality?.name,
                                            point.name
                                        ].filter(Boolean).join(" \xb7 ")
                                    ]
                                }) : null,
                                error ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $dc33dcdb2d24fbd9$export$2e2bcd8739ae039), {
                                    type: "error",
                                    showIcon: true,
                                    message: error
                                }) : null
                            ]
                        })
                    })
                })
            ]
        })
    });
}


/* Photo report review modal — one report at a time, stepped through the caller's queue.
   Visual reference: docs/design/photo-review.html (`.modal` / `.stage` / `.side-info`).

   Archetype C in docs/design/spec/03-patterns.md: a queue plus one document, keyboard-driven.
   ← → step the queue, A approves, R rejects, Esc closes; the thumbnail strip steps the photos
   of the current report. antd's Modal supplies the mask, the focus trap and Esc.

   SHARED by /photo-review and /visit/:id's reports section — both list the same
   `photos_in_visit` / `photos_from_reports` records, and the visit page was opening a generic
   `<Descriptions>` dialog for them instead: no zoom, no thumbnail strip, no keyboard. Styles are
   `component/review-modal.scss`, imported once from `src/index.js`.

   ⚠ `item` must be a `PhotoReview` (`src/models/photo-review.js`), not a raw API row. `photo` is
   an ARRAY that only that model synthesises — the endpoints carry `url_photo` / `ticket_contents`,
   and reading `item.photo` off a raw row is why the visit page's report covers were all
   placeholders. */ 

var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");










// ============================== Size ================================
const $841ee3e8db72d9b8$var$genSizeDividerStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: {
            "&-horizontal": {
                [`&${componentCls}`]: {
                    "&-sm": {
                        marginBlock: token.marginXS
                    },
                    "&-md": {
                        marginBlock: token.margin
                    }
                }
            }
        }
    };
};
// ============================== Shared ==============================
const $841ee3e8db72d9b8$var$genSharedDividerStyle = (token)=>{
    const { componentCls: componentCls, sizePaddingEdgeHorizontal: sizePaddingEdgeHorizontal, colorSplit: colorSplit, lineWidth: lineWidth, textPaddingInline: textPaddingInline, orientationMargin: orientationMargin, verticalMarginInline: verticalMarginInline } = token;
    const railCls = `${componentCls}-rail`;
    return {
        [componentCls]: {
            ...(0, $519d20bf207ce864$export$23997c3e44cc1c59)(token),
            borderBlockStart: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(lineWidth)} solid ${colorSplit}`,
            [railCls]: {
                borderBlockStart: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(lineWidth)} solid ${colorSplit}`
            },
            // vertical
            "&-vertical": {
                position: "relative",
                top: "-0.06em",
                display: "inline-block",
                height: "0.9em",
                marginInline: verticalMarginInline,
                marginBlock: 0,
                verticalAlign: "middle",
                borderTop: 0,
                borderInlineStart: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(lineWidth)} solid ${colorSplit}`
            },
            "&-horizontal": {
                display: "flex",
                clear: "both",
                width: "100%",
                minWidth: "100%",
                // Fix https://github.com/ant-design/ant-design/issues/10914
                margin: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.marginLG)} 0`
            },
            [`&-horizontal${componentCls}-with-text`]: {
                display: "flex",
                alignItems: "center",
                margin: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.dividerHorizontalWithTextGutterMargin)} 0`,
                color: token.colorTextHeading,
                fontWeight: 500,
                fontSize: token.fontSizeLG,
                whiteSpace: "nowrap",
                textAlign: "center",
                borderBlockStart: `0 ${colorSplit}`,
                [`${railCls}-start, ${railCls}-end`]: {
                    width: "50%",
                    // Chrome not accept `inherit` in `border-top`
                    borderBlockStartColor: "inherit",
                    borderBlockEnd: 0,
                    content: "''"
                }
            },
            [`&-horizontal${componentCls}-with-text-start`]: {
                [`${railCls}-start`]: {
                    width: `calc(${orientationMargin} * 100%)`
                },
                [`${railCls}-end`]: {
                    width: `calc(100% - ${orientationMargin} * 100%)`
                }
            },
            [`&-horizontal${componentCls}-with-text-end`]: {
                [`${railCls}-start`]: {
                    width: `calc(100% - ${orientationMargin} * 100%)`
                },
                [`${railCls}-end`]: {
                    width: `calc(${orientationMargin} * 100%)`
                }
            },
            [`${componentCls}-inner-text`]: {
                display: "inline-block",
                paddingBlock: 0,
                paddingInline: textPaddingInline
            },
            "&-dashed": {
                background: "none",
                borderColor: colorSplit,
                borderStyle: "dashed",
                borderWidth: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(lineWidth)} 0 0`,
                [railCls]: {
                    borderBlockStart: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(lineWidth)} dashed ${colorSplit}`
                }
            },
            [`&-horizontal${componentCls}-with-text${componentCls}-dashed`]: {
                [`${railCls}-start, ${railCls}-end`]: {
                    borderStyle: "dashed none none"
                }
            },
            [`&-vertical${componentCls}-dashed`]: {
                borderInlineStartWidth: lineWidth,
                borderInlineEnd: 0,
                borderBlockStart: 0,
                borderBlockEnd: 0
            },
            "&-dotted": {
                background: "none",
                borderColor: colorSplit,
                borderStyle: "dotted",
                borderWidth: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(lineWidth)} 0 0`,
                [railCls]: {
                    borderBlockStart: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(lineWidth)} dotted ${colorSplit}`
                }
            },
            [`&-horizontal${componentCls}-with-text${componentCls}-dotted`]: {
                "&::before, &::after": {
                    borderStyle: "dotted none none"
                }
            },
            [`&-vertical${componentCls}-dotted`]: {
                borderInlineStartWidth: lineWidth,
                borderInlineEnd: 0,
                borderBlockStart: 0,
                borderBlockEnd: 0
            },
            [`&-plain${componentCls}-with-text`]: {
                color: token.colorText,
                fontWeight: "normal",
                fontSize: token.fontSize
            },
            [`&-horizontal${componentCls}-with-text-start${componentCls}-no-default-orientation-margin-start`]: {
                [`${railCls}-start`]: {
                    width: 0
                },
                [`${railCls}-end`]: {
                    width: "100%"
                },
                [`${componentCls}-inner-text`]: {
                    paddingInlineStart: sizePaddingEdgeHorizontal
                }
            },
            [`&-horizontal${componentCls}-with-text-end${componentCls}-no-default-orientation-margin-end`]: {
                [`${railCls}-start`]: {
                    width: "100%"
                },
                [`${railCls}-end`]: {
                    width: 0
                },
                [`${componentCls}-inner-text`]: {
                    paddingInlineEnd: sizePaddingEdgeHorizontal
                }
            }
        }
    };
};
const $841ee3e8db72d9b8$export$9ca1be8807fe0675 = (token)=>({
        textPaddingInline: "1em",
        orientationMargin: 0.05,
        verticalMarginInline: token.marginXS
    });
var // ============================== Export ==============================
$841ee3e8db72d9b8$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$51ec95de45185b42)("Divider", (token)=>{
    const dividerToken = (0, $fef50f256b80dfa5$export$4950aa0f605343fb)(token, {
        dividerHorizontalWithTextGutterMargin: token.margin,
        sizePaddingEdgeHorizontal: 0
    });
    return [
        $841ee3e8db72d9b8$var$genSharedDividerStyle(dividerToken),
        $841ee3e8db72d9b8$var$genSizeDividerStyle(dividerToken)
    ];
}, $841ee3e8db72d9b8$export$9ca1be8807fe0675, {
    unitless: {
        orientationMargin: true
    }
});


"use client";
const $0e5d78eff3409cb5$var$titlePlacementList = [
    "left",
    "right",
    "center",
    "start",
    "end"
];
const $0e5d78eff3409cb5$var$Divider = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("divider");
    const { prefixCls: customizePrefixCls, type: type, orientation: orientation, vertical: vertical, titlePlacement: titlePlacement, orientationMargin: orientationMargin, className: className, rootClassName: rootClassName, children: children, dashed: dashed, variant: variant = "solid", plain: plain, style: style, size: customSize, classNames: classNames, styles: styles, ...restProps } = props;
    const prefixCls = getPrefixCls("divider", customizePrefixCls);
    const railCls = `${prefixCls}-rail`;
    const [hashId, cssVarCls] = (0, $841ee3e8db72d9b8$export$2e2bcd8739ae039)(prefixCls);
    const sizeFullName = (0, $78cdfb6138721329$export$2e2bcd8739ae039)(customSize);
    const hasChildren = !!children;
    const validTitlePlacement = $0e5d78eff3409cb5$var$titlePlacementList.includes(orientation || "");
    const mergedTitlePlacement = $cQmXV.useMemo(()=>{
        const placement = titlePlacement ?? (validTitlePlacement ? orientation : "center");
        if (placement === "left") return direction === "rtl" ? "end" : "start";
        if (placement === "right") return direction === "rtl" ? "start" : "end";
        return placement;
    }, [
        direction,
        orientation,
        titlePlacement,
        validTitlePlacement
    ]);
    const hasMarginStart = mergedTitlePlacement === "start" && orientationMargin != null;
    const hasMarginEnd = mergedTitlePlacement === "end" && orientationMargin != null;
    const [mergedOrientation, mergedVertical] = (0, $78e4f9cb51a5af1c$export$550084c67147f6c4)(orientation, vertical, type);
    // ========================= Semantic =========================
    const mergedProps = {
        ...props,
        orientation: mergedOrientation,
        titlePlacement: mergedTitlePlacement,
        size: sizeFullName
    };
    const contextStyleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(contextStyle);
    const [mergedClassNames, mergedStyles] = (0, $30c5f9f911d4f61b$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles
    ], {
        props: mergedProps
    });
    const classString = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, contextClassName, hashId, cssVarCls, `${prefixCls}-${mergedOrientation}`, {
        [`${prefixCls}-with-text`]: hasChildren,
        [`${prefixCls}-with-text-${mergedTitlePlacement}`]: hasChildren,
        [`${prefixCls}-dashed`]: !!dashed,
        [`${prefixCls}-${variant}`]: variant !== "solid",
        [`${prefixCls}-plain`]: !!plain,
        [`${prefixCls}-rtl`]: direction === "rtl",
        [`${prefixCls}-no-default-orientation-margin-start`]: hasMarginStart,
        [`${prefixCls}-no-default-orientation-margin-end`]: hasMarginEnd,
        [`${prefixCls}-md`]: sizeFullName === "medium" || sizeFullName === "middle",
        [`${prefixCls}-sm`]: sizeFullName === "small",
        [railCls]: !children,
        [mergedClassNames.rail]: mergedClassNames.rail && !children
    }, className, rootClassName, mergedClassNames.root);
    const memoizedPlacementMargin = $cQmXV.useMemo(()=>{
        if ((0, $8e2d153a3c855782$export$7e4aa119212bc614)(orientationMargin)) return orientationMargin;
        if (/^\d+$/.test(orientationMargin)) return Number(orientationMargin);
        return orientationMargin;
    }, [
        orientationMargin
    ]);
    const innerStyle = {
        marginInlineStart: hasMarginStart ? memoizedPlacementMargin : undefined,
        marginInlineEnd: hasMarginEnd ? memoizedPlacementMargin : undefined
    };
    const nativeElementRef = $cQmXV.useRef(null);
    $cQmXV.useImperativeHandle(ref, ()=>({
            nativeElement: nativeElementRef.current
        }));
    var deprecatedName, newName;
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        ref: nativeElementRef,
        className: classString,
        style: {
            ...mergedStyles.root,
            ...children ? {} : mergedStyles.rail,
            ...style
        },
        ...restProps,
        role: "separator"
    }, children && !mergedVertical && /*#__PURE__*/ $cQmXV.createElement($cQmXV.Fragment, null, /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(railCls, `${railCls}-start`, mergedClassNames.rail),
        style: mergedStyles.rail
    }), /*#__PURE__*/ $cQmXV.createElement("span", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-inner-text`, mergedClassNames.content),
        style: {
            ...innerStyle,
            ...mergedStyles.content
        }
    }, children), /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(railCls, `${railCls}-end`, mergedClassNames.rail),
        style: mergedStyles.rail
    })));
});
var $0e5d78eff3409cb5$export$2e2bcd8739ae039 = $0e5d78eff3409cb5$var$Divider;



var $cQmXV = parcelRequire("cQmXV");
var $082592782d6d9725$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($082592782d6d9725$exports, "__esModule", {
    value: true
});
var $082592782d6d9725$var$CompressOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M326 664H104c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h174v176c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V696c0-17.7-14.3-32-32-32zm16-576h-48c-8.8 0-16 7.2-16 16v176H104c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h222c17.7 0 32-14.3 32-32V104c0-8.8-7.2-16-16-16zm578 576H698c-17.7 0-32 14.3-32 32v224c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V744h174c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16zm0-384H746V104c0-8.8-7.2-16-16-16h-48c-8.8 0-16 7.2-16 16v224c0 17.7 14.3 32 32 32h222c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16z"
                }
            }
        ]
    },
    "name": "compress",
    "theme": "outlined"
};
$082592782d6d9725$exports.default = $082592782d6d9725$var$CompressOutlined;



function $11a3e787021f568d$var$_extends() {
    $11a3e787021f568d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $11a3e787021f568d$var$_extends.apply(this, arguments);
}
const $11a3e787021f568d$var$CompressOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $11a3e787021f568d$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($082592782d6d9725$exports)))
    }));
/**![compress](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTMyNiA2NjRIMTA0Yy04LjggMC0xNiA3LjItMTYgMTZ2NDhjMCA4LjggNy4yIDE2IDE2IDE2aDE3NHYxNzZjMCA4LjggNy4yIDE2IDE2IDE2aDQ4YzguOCAwIDE2LTcuMiAxNi0xNlY2OTZjMC0xNy43LTE0LjMtMzItMzItMzJ6bTE2LTU3NmgtNDhjLTguOCAwLTE2IDcuMi0xNiAxNnYxNzZIMTA0Yy04LjggMC0xNiA3LjItMTYgMTZ2NDhjMCA4LjggNy4yIDE2IDE2IDE2aDIyMmMxNy43IDAgMzItMTQuMyAzMi0zMlYxMDRjMC04LjgtNy4yLTE2LTE2LTE2em01NzggNTc2SDY5OGMtMTcuNyAwLTMyIDE0LjMtMzIgMzJ2MjI0YzAgOC44IDcuMiAxNiAxNiAxNmg0OGM4LjggMCAxNi03LjIgMTYtMTZWNzQ0aDE3NGM4LjggMCAxNi03LjIgMTYtMTZ2LTQ4YzAtOC44LTcuMi0xNi0xNi0xNnptMC0zODRINzQ2VjEwNGMwLTguOC03LjItMTYtMTYtMTZoLTQ4Yy04LjggMC0xNiA3LjItMTYgMTZ2MjI0YzAgMTcuNyAxNC4zIDMyIDMyIDMyaDIyMmM4LjggMCAxNi03LjIgMTYtMTZ2LTQ4YzAtOC44LTcuMi0xNi0xNi0xNnoiIC8+PC9zdmc+) */ const $11a3e787021f568d$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($11a3e787021f568d$var$CompressOutlined);
var $11a3e787021f568d$export$2e2bcd8739ae039 = $11a3e787021f568d$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $a88e6448cf724c87$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($a88e6448cf724c87$exports, "__esModule", {
    value: true
});
var $a88e6448cf724c87$var$LinkOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M574 665.4a8.03 8.03 0 00-11.3 0L446.5 781.6c-53.8 53.8-144.6 59.5-204 0-59.5-59.5-53.8-150.2 0-204l116.2-116.2c3.1-3.1 3.1-8.2 0-11.3l-39.8-39.8a8.03 8.03 0 00-11.3 0L191.4 526.5c-84.6 84.6-84.6 221.5 0 306s221.5 84.6 306 0l116.2-116.2c3.1-3.1 3.1-8.2 0-11.3L574 665.4zm258.6-474c-84.6-84.6-221.5-84.6-306 0L410.3 307.6a8.03 8.03 0 000 11.3l39.7 39.7c3.1 3.1 8.2 3.1 11.3 0l116.2-116.2c53.8-53.8 144.6-59.5 204 0 59.5 59.5 53.8 150.2 0 204L665.3 562.6a8.03 8.03 0 000 11.3l39.8 39.8c3.1 3.1 8.2 3.1 11.3 0l116.2-116.2c84.5-84.6 84.5-221.5 0-306.1zM610.1 372.3a8.03 8.03 0 00-11.3 0L372.3 598.7a8.03 8.03 0 000 11.3l39.6 39.6c3.1 3.1 8.2 3.1 11.3 0l226.4-226.4c3.1-3.1 3.1-8.2 0-11.3l-39.5-39.6z"
                }
            }
        ]
    },
    "name": "link",
    "theme": "outlined"
};
$a88e6448cf724c87$exports.default = $a88e6448cf724c87$var$LinkOutlined;



function $0ddb3666fa5a86f7$var$_extends() {
    $0ddb3666fa5a86f7$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0ddb3666fa5a86f7$var$_extends.apply(this, arguments);
}
const $0ddb3666fa5a86f7$var$LinkOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $0ddb3666fa5a86f7$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($a88e6448cf724c87$exports)))
    }));
/**![link](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTU3NCA2NjUuNGE4LjAzIDguMDMgMCAwMC0xMS4zIDBMNDQ2LjUgNzgxLjZjLTUzLjggNTMuOC0xNDQuNiA1OS41LTIwNCAwLTU5LjUtNTkuNS01My44LTE1MC4yIDAtMjA0bDExNi4yLTExNi4yYzMuMS0zLjEgMy4xLTguMiAwLTExLjNsLTM5LjgtMzkuOGE4LjAzIDguMDMgMCAwMC0xMS4zIDBMMTkxLjQgNTI2LjVjLTg0LjYgODQuNi04NC42IDIyMS41IDAgMzA2czIyMS41IDg0LjYgMzA2IDBsMTE2LjItMTE2LjJjMy4xLTMuMSAzLjEtOC4yIDAtMTEuM0w1NzQgNjY1LjR6bTI1OC42LTQ3NGMtODQuNi04NC42LTIyMS41LTg0LjYtMzA2IDBMNDEwLjMgMzA3LjZhOC4wMyA4LjAzIDAgMDAwIDExLjNsMzkuNyAzOS43YzMuMSAzLjEgOC4yIDMuMSAxMS4zIDBsMTE2LjItMTE2LjJjNTMuOC01My44IDE0NC42LTU5LjUgMjA0IDAgNTkuNSA1OS41IDUzLjggMTUwLjIgMCAyMDRMNjY1LjMgNTYyLjZhOC4wMyA4LjAzIDAgMDAwIDExLjNsMzkuOCAzOS44YzMuMSAzLjEgOC4yIDMuMSAxMS4zIDBsMTE2LjItMTE2LjJjODQuNS04NC42IDg0LjUtMjIxLjUgMC0zMDYuMXpNNjEwLjEgMzcyLjNhOC4wMyA4LjAzIDAgMDAtMTEuMyAwTDM3Mi4zIDU5OC43YTguMDMgOC4wMyAwIDAwMCAxMS4zbDM5LjYgMzkuNmMzLjEgMy4xIDguMiAzLjEgMTEuMyAwbDIyNi40LTIyNi40YzMuMS0zLjEgMy4xLTguMiAwLTExLjNsLTM5LjUtMzkuNnoiIC8+PC9zdmc+) */ const $0ddb3666fa5a86f7$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($0ddb3666fa5a86f7$var$LinkOutlined);
var $0ddb3666fa5a86f7$export$2e2bcd8739ae039 = $0ddb3666fa5a86f7$var$RefIcon;



var $cQmXV = parcelRequire("cQmXV");

/**
 * Rounds number to given decimal
 * eg. roundNumber(2.34343, 1) => 2.3
 */ var $c9b1aa9458d4ea13$var$roundNumber = function(num, decimal) {
    return Number(num.toFixed(decimal));
};
/**
 * Checks if value is number, if not it returns default value
 * 1# eg. checkIsNumber(2, 30) => 2
 * 2# eg. checkIsNumber(null, 30) => 30
 */ var $c9b1aa9458d4ea13$var$checkIsNumber = function(num, defaultValue) {
    return typeof num === "number" ? num : defaultValue;
};
var $c9b1aa9458d4ea13$var$handleCallback = function(context, event, callback) {
    if (callback && typeof callback === "function") callback(context, event);
};
/* eslint-disable no-plusplus */ /* eslint-disable no-param-reassign */ /**
 * Functions should return denominator of the target value, which is the next animation step.
 * t is a value from 0 to 1, reflecting the percentage of animation status.
 */ var $c9b1aa9458d4ea13$var$easeOut = function(t) {
    return -Math.cos(t * Math.PI) / 2 + 0.5;
};
// linear
var $c9b1aa9458d4ea13$var$linear = function(t) {
    return t;
};
// accelerating from zero velocity
var $c9b1aa9458d4ea13$var$easeInQuad = function(t) {
    return t * t;
};
// decelerating to zero velocity
var $c9b1aa9458d4ea13$var$easeOutQuad = function(t) {
    return t * (2 - t);
};
// acceleration until halfway, then deceleration
var $c9b1aa9458d4ea13$var$easeInOutQuad = function(t) {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
};
// accelerating from zero velocity
var $c9b1aa9458d4ea13$var$easeInCubic = function(t) {
    return t * t * t;
};
// decelerating to zero velocity
var $c9b1aa9458d4ea13$var$easeOutCubic = function(t) {
    return --t * t * t + 1;
};
// acceleration until halfway, then deceleration
var $c9b1aa9458d4ea13$var$easeInOutCubic = function(t) {
    return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
};
// accelerating from zero velocity
var $c9b1aa9458d4ea13$var$easeInQuart = function(t) {
    return t * t * t * t;
};
// decelerating to zero velocity
var $c9b1aa9458d4ea13$var$easeOutQuart = function(t) {
    return 1 - --t * t * t * t;
};
// acceleration until halfway, then deceleration
var $c9b1aa9458d4ea13$var$easeInOutQuart = function(t) {
    return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
};
// accelerating from zero velocity
var $c9b1aa9458d4ea13$var$easeInQuint = function(t) {
    return t * t * t * t * t;
};
// decelerating to zero velocity
var $c9b1aa9458d4ea13$var$easeOutQuint = function(t) {
    return 1 + --t * t * t * t * t;
};
// acceleration until halfway, then deceleration
var $c9b1aa9458d4ea13$var$easeInOutQuint = function(t) {
    return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
};
var $c9b1aa9458d4ea13$var$animations = {
    easeOut: $c9b1aa9458d4ea13$var$easeOut,
    linear: $c9b1aa9458d4ea13$var$linear,
    easeInQuad: $c9b1aa9458d4ea13$var$easeInQuad,
    easeOutQuad: $c9b1aa9458d4ea13$var$easeOutQuad,
    easeInOutQuad: $c9b1aa9458d4ea13$var$easeInOutQuad,
    easeInCubic: $c9b1aa9458d4ea13$var$easeInCubic,
    easeOutCubic: $c9b1aa9458d4ea13$var$easeOutCubic,
    easeInOutCubic: $c9b1aa9458d4ea13$var$easeInOutCubic,
    easeInQuart: $c9b1aa9458d4ea13$var$easeInQuart,
    easeOutQuart: $c9b1aa9458d4ea13$var$easeOutQuart,
    easeInOutQuart: $c9b1aa9458d4ea13$var$easeInOutQuart,
    easeInQuint: $c9b1aa9458d4ea13$var$easeInQuint,
    easeOutQuint: $c9b1aa9458d4ea13$var$easeOutQuint,
    easeInOutQuint: $c9b1aa9458d4ea13$var$easeInOutQuint
};
/* eslint-disable no-param-reassign */ var $c9b1aa9458d4ea13$var$handleCancelAnimationFrame = function(animation) {
    if (typeof animation === "number") cancelAnimationFrame(animation);
};
var $c9b1aa9458d4ea13$var$handleCancelAnimation = function(contextInstance) {
    if (!contextInstance.mounted) return;
    $c9b1aa9458d4ea13$var$handleCancelAnimationFrame(contextInstance.animation);
    // Clear animation state
    contextInstance.isAnimating = false;
    contextInstance.animation = null;
    contextInstance.velocity = null;
};
function $c9b1aa9458d4ea13$var$handleSetupAnimation(contextInstance, animationName, animationTime, callback) {
    if (!contextInstance.mounted) return;
    var startTime = new Date().getTime();
    var lastStep = 1;
    // if another animation is active
    $c9b1aa9458d4ea13$var$handleCancelAnimation(contextInstance);
    // new animation
    contextInstance.animation = function() {
        if (!contextInstance.mounted) return $c9b1aa9458d4ea13$var$handleCancelAnimationFrame(contextInstance.animation);
        var frameTime = new Date().getTime() - startTime;
        var animationProgress = frameTime / animationTime;
        var animationType = $c9b1aa9458d4ea13$var$animations[animationName];
        var step = animationType(animationProgress);
        if (frameTime >= animationTime) {
            callback(lastStep);
            contextInstance.animation = null;
        } else if (contextInstance.animation) {
            callback(step);
            requestAnimationFrame(contextInstance.animation);
        }
    };
    requestAnimationFrame(contextInstance.animation);
}
function $c9b1aa9458d4ea13$var$isValidTargetState(targetState) {
    var scale = targetState.scale, positionX = targetState.positionX, positionY = targetState.positionY;
    if (Number.isNaN(scale) || Number.isNaN(positionX) || Number.isNaN(positionY)) return false;
    return true;
}
function $c9b1aa9458d4ea13$var$animate(contextInstance, targetState, animationTime, animationName) {
    var isValid = $c9b1aa9458d4ea13$var$isValidTargetState(targetState);
    if (!contextInstance.mounted || !isValid) return;
    var setState = contextInstance.setState;
    var _a = contextInstance.state, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    var scaleDiff = targetState.scale - scale;
    var positionXDiff = targetState.positionX - positionX;
    var positionYDiff = targetState.positionY - positionY;
    if (animationTime === 0) setState(targetState.scale, targetState.positionX, targetState.positionY);
    else // animation start timestamp
    $c9b1aa9458d4ea13$var$handleSetupAnimation(contextInstance, animationName, animationTime, function(step) {
        if (step !== 1) contextInstance.isAnimating = true;
        else contextInstance.isAnimating = false;
        var newScale = scale + scaleDiff * step;
        var newPositionX = positionX + positionXDiff * step;
        var newPositionY = positionY + positionYDiff * step;
        setState(newScale, newPositionX, newPositionY);
    });
}
/* eslint-disable no-param-reassign */ function $c9b1aa9458d4ea13$var$getComponentsSizes(wrapperComponent, contentComponent, newScale) {
    var wrapperWidth = wrapperComponent.offsetWidth;
    var wrapperHeight = wrapperComponent.offsetHeight;
    var contentWidth = contentComponent.offsetWidth;
    var contentHeight = contentComponent.offsetHeight;
    var newContentWidth = contentWidth * newScale;
    var newContentHeight = contentHeight * newScale;
    var newDiffWidth = wrapperWidth - newContentWidth;
    var newDiffHeight = wrapperHeight - newContentHeight;
    return {
        wrapperWidth: wrapperWidth,
        wrapperHeight: wrapperHeight,
        newContentWidth: newContentWidth,
        newDiffWidth: newDiffWidth,
        newContentHeight: newContentHeight,
        newDiffHeight: newDiffHeight
    };
}
var $c9b1aa9458d4ea13$var$getBounds = function(wrapperWidth, newContentWidth, diffWidth, wrapperHeight, newContentHeight, diffHeight, centerZoomedOut) {
    var scaleWidthFactor = wrapperWidth > newContentWidth ? diffWidth * (centerZoomedOut ? 0.5 : 1) : 0;
    var scaleHeightFactor = wrapperHeight > newContentHeight ? diffHeight * (centerZoomedOut ? 0.5 : 1) : 0;
    var minPositionX = wrapperWidth - newContentWidth - scaleWidthFactor;
    var maxPositionX = scaleWidthFactor;
    var minPositionY = wrapperHeight - newContentHeight - scaleHeightFactor;
    var maxPositionY = scaleHeightFactor;
    return {
        minPositionX: minPositionX,
        maxPositionX: maxPositionX,
        minPositionY: minPositionY,
        maxPositionY: maxPositionY,
        scaleWidthFactor: scaleWidthFactor,
        scaleHeightFactor: scaleHeightFactor
    };
};
var $c9b1aa9458d4ea13$var$calculateBounds = function(contextInstance, newScale) {
    var wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent;
    var _a = contextInstance.setup, centerZoomedOut = _a.centerZoomedOut, disablePadding = _a.disablePadding;
    if (!wrapperComponent || !contentComponent) throw new Error("Components are not mounted");
    var _b = $c9b1aa9458d4ea13$var$getComponentsSizes(wrapperComponent, contentComponent, newScale), wrapperWidth = _b.wrapperWidth, wrapperHeight = _b.wrapperHeight, newContentWidth = _b.newContentWidth, newContentHeight = _b.newContentHeight, newDiffWidth = _b.newDiffWidth, newDiffHeight = _b.newDiffHeight;
    var bounds = $c9b1aa9458d4ea13$var$getBounds(wrapperWidth, newContentWidth, newDiffWidth, wrapperHeight, newContentHeight, newDiffHeight, Boolean(centerZoomedOut));
    var contentFitsCompletely = wrapperWidth >= newContentWidth && wrapperHeight >= newContentHeight;
    if (disablePadding && contentFitsCompletely && !centerZoomedOut) {
        bounds.minPositionX = 0;
        bounds.maxPositionX = 0;
        bounds.minPositionY = 0;
        bounds.maxPositionY = 0;
    }
    var _c = contextInstance.setup, propMinX = _c.minPositionX, propMaxX = _c.maxPositionX, propMinY = _c.minPositionY, propMaxY = _c.maxPositionY;
    // Explicit position props define content-space boundaries at scale=1.
    // Scale them so the same content region stays reachable at every zoom level.
    if (propMinX != null) bounds.minPositionX = wrapperWidth * (1 - newScale) + propMinX * newScale;
    if (propMaxX != null) bounds.maxPositionX = propMaxX * newScale;
    if (propMinY != null) bounds.minPositionY = wrapperHeight * (1 - newScale) + propMinY * newScale;
    if (propMaxY != null) bounds.maxPositionY = propMaxY * newScale;
    return bounds;
};
/**
 * Keeps value between given bounds, used for limiting view to given boundaries
 * 1# eg. boundLimiter(2, 0, 3, true) => 2
 * 2# eg. boundLimiter(4, 0, 3, true) => 3
 * 3# eg. boundLimiter(-2, 0, 3, true) => 0
 * 4# eg. boundLimiter(10, 0, 3, false) => 10
 */ var $c9b1aa9458d4ea13$var$boundLimiter = function(value, minBound, maxBound, isActive) {
    if (!isActive) return $c9b1aa9458d4ea13$var$roundNumber(value, 2);
    if (value < minBound) return $c9b1aa9458d4ea13$var$roundNumber(minBound, 2);
    if (value > maxBound) return $c9b1aa9458d4ea13$var$roundNumber(maxBound, 2);
    return $c9b1aa9458d4ea13$var$roundNumber(value, 2);
};
var $c9b1aa9458d4ea13$var$handleCalculateBounds = function(contextInstance, newScale) {
    var bounds = $c9b1aa9458d4ea13$var$calculateBounds(contextInstance, newScale);
    // Save bounds
    contextInstance.bounds = bounds;
    return bounds;
};
function $c9b1aa9458d4ea13$var$getMouseBoundedPosition(positionX, positionY, bounds, limitToBounds, paddingValueX, paddingValueY, wrapperComponent) {
    var minPositionX = bounds.minPositionX, minPositionY = bounds.minPositionY, maxPositionX = bounds.maxPositionX, maxPositionY = bounds.maxPositionY;
    var paddingX = 0;
    var paddingY = 0;
    if (wrapperComponent) {
        paddingX = paddingValueX;
        paddingY = paddingValueY;
    }
    var x = $c9b1aa9458d4ea13$var$boundLimiter(positionX, minPositionX - paddingX, maxPositionX + paddingX, limitToBounds);
    var y = $c9b1aa9458d4ea13$var$boundLimiter(positionY, minPositionY - paddingY, maxPositionY + paddingY, limitToBounds);
    return {
        x: x,
        y: y
    };
}
function $c9b1aa9458d4ea13$var$handleCalculateZoomPositions(contextInstance, mouseX, mouseY, newScale, bounds, limitToBounds) {
    var _a = contextInstance.state, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    var scaleDifference = newScale - scale;
    if (!Number.isFinite(mouseX) || !Number.isFinite(mouseY)) {
        console.error("Mouse X and Y position were not provided!");
        return {
            x: positionX,
            y: positionY
        };
    }
    var calculatedPositionX = positionX - mouseX * scaleDifference;
    var calculatedPositionY = positionY - mouseY * scaleDifference;
    // do not limit to bounds when there is padding animation,
    // it causes animation strange behaviour
    var newPositions = $c9b1aa9458d4ea13$var$getMouseBoundedPosition(calculatedPositionX, calculatedPositionY, bounds, limitToBounds, 0, 0, null);
    return newPositions;
}
var $c9b1aa9458d4ea13$var$MIN_SAFE_SCALE = 1e-7;
function $c9b1aa9458d4ea13$var$checkZoomBounds(zoom, minScale, maxScale, zoomPadding, enablePadding) {
    var scalePadding = enablePadding ? zoomPadding : 0;
    var minScaleWithPadding = Math.max(minScale - scalePadding, $c9b1aa9458d4ea13$var$MIN_SAFE_SCALE);
    var maxScaleWithPadding = maxScale + scalePadding;
    if (!Number.isNaN(maxScale) && zoom >= maxScaleWithPadding) return maxScaleWithPadding;
    if (!Number.isNaN(minScale) && zoom <= minScaleWithPadding) return minScaleWithPadding;
    return Math.max(zoom, $c9b1aa9458d4ea13$var$MIN_SAFE_SCALE);
}
var $c9b1aa9458d4ea13$var$isPanningStartAllowed = function(contextInstance, event) {
    var excluded = contextInstance.setup.panning.excluded;
    var isInitialized = contextInstance.isInitialized, wrapperComponent = contextInstance.wrapperComponent;
    var target = event.target;
    var targetIsShadowDom = "shadowRoot" in target && "composedPath" in event;
    var isWrapperChild = targetIsShadowDom ? event.composedPath().some(function(el) {
        if (!(el instanceof Element)) return false;
        return wrapperComponent === null || wrapperComponent === void 0 ? void 0 : wrapperComponent.contains(el);
    }) : wrapperComponent === null || wrapperComponent === void 0 ? void 0 : wrapperComponent.contains(target);
    var isAllowed = isInitialized && target && isWrapperChild;
    if (!isAllowed) return false;
    var isExcluded = $c9b1aa9458d4ea13$var$isExcludedNode(target, excluded);
    if (isExcluded) return false;
    if (target.getAttribute("draggable") === "true" || target.getAttribute("contenteditable") === "true" || target.isContentEditable) return false;
    return true;
};
var $c9b1aa9458d4ea13$var$isPanningAllowed = function(contextInstance) {
    var isInitialized = contextInstance.isInitialized, isPanning = contextInstance.isPanning, setup = contextInstance.setup;
    var disabled = setup.panning.disabled;
    var isAllowed = isInitialized && isPanning && !disabled;
    if (!isAllowed) return false;
    return true;
};
var $c9b1aa9458d4ea13$var$handlePanningSetup = function(contextInstance, event) {
    var _a = contextInstance.state, positionX = _a.positionX, positionY = _a.positionY;
    contextInstance.isPanning = true;
    // Panning with mouse
    var x = event.clientX;
    var y = event.clientY;
    contextInstance.startCoords = {
        x: x - positionX,
        y: y - positionY
    };
};
var $c9b1aa9458d4ea13$var$handleTouchPanningSetup = function(contextInstance, event) {
    var touches = event.touches;
    var _a = contextInstance.state, positionX = _a.positionX, positionY = _a.positionY;
    contextInstance.isPanning = true;
    // Panning with touch
    var oneFingerTouch = touches.length === 1;
    if (oneFingerTouch) {
        var x = touches[0].clientX;
        var y = touches[0].clientY;
        contextInstance.startCoords = {
            x: x - positionX,
            y: y - positionY
        };
    }
};
function $c9b1aa9458d4ea13$var$handlePanToBounds(contextInstance) {
    var _a = contextInstance.state, positionX = _a.positionX, positionY = _a.positionY, scale = _a.scale;
    var _b = contextInstance.setup, disabled = _b.disabled, limitToBounds = _b.limitToBounds, centerZoomedOut = _b.centerZoomedOut;
    var wrapperComponent = contextInstance.wrapperComponent;
    if (disabled || !wrapperComponent || !contextInstance.bounds) return;
    var _c = contextInstance.bounds, maxPositionX = _c.maxPositionX, minPositionX = _c.minPositionX, maxPositionY = _c.maxPositionY, minPositionY = _c.minPositionY;
    var xChanged = positionX > maxPositionX || positionX < minPositionX;
    var yChanged = positionY > maxPositionY || positionY < minPositionY;
    var mousePosX = positionX > maxPositionX ? wrapperComponent.offsetWidth : contextInstance.setup.minPositionX || 0;
    var mousePosY = positionY > maxPositionY ? wrapperComponent.offsetHeight : contextInstance.setup.minPositionY || 0;
    var _d = $c9b1aa9458d4ea13$var$handleCalculateZoomPositions(contextInstance, mousePosX, mousePosY, scale, contextInstance.bounds, limitToBounds || centerZoomedOut), x = _d.x, y = _d.y;
    return {
        scale: scale,
        positionX: xChanged ? x : positionX,
        positionY: yChanged ? y : positionY
    };
}
function $c9b1aa9458d4ea13$var$handleNewPosition(contextInstance, newPositionX, newPositionY, paddingValueX, paddingValueY) {
    var limitToBounds = contextInstance.setup.limitToBounds;
    var wrapperComponent = contextInstance.wrapperComponent, bounds = contextInstance.bounds;
    var _a = contextInstance.state, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    if (wrapperComponent === null || bounds === null || newPositionX === positionX && newPositionY === positionY) return;
    var _b = $c9b1aa9458d4ea13$var$getMouseBoundedPosition(newPositionX, newPositionY, bounds, limitToBounds, paddingValueX, paddingValueY, wrapperComponent), x = _b.x, y = _b.y;
    contextInstance.setState(scale, x, y);
}
var $c9b1aa9458d4ea13$var$getPanningClientPosition = function(contextInstance, clientX, clientY) {
    var startCoords = contextInstance.startCoords, state = contextInstance.state;
    var panning = contextInstance.setup.panning;
    var lockAxisX = panning.lockAxisX, lockAxisY = panning.lockAxisY;
    var positionX = state.positionX, positionY = state.positionY;
    if (!startCoords) return {
        x: positionX,
        y: positionY
    };
    var mouseX = clientX - startCoords.x;
    var mouseY = clientY - startCoords.y;
    var newPositionX = lockAxisX ? positionX : mouseX;
    var newPositionY = lockAxisY ? positionY : mouseY;
    return {
        x: newPositionX,
        y: newPositionY
    };
};
var $c9b1aa9458d4ea13$var$getPaddingValue = function(contextInstance, size, explicitScale) {
    var setup = contextInstance.setup, state = contextInstance.state;
    var minScale = setup.minScale, disablePadding = setup.disablePadding, centerZoomedOut = setup.centerZoomedOut;
    var scale = explicitScale !== null && explicitScale !== void 0 ? explicitScale : state.scale;
    if (size > 0 && scale >= minScale && !disablePadding && !centerZoomedOut) return size;
    return 0;
};
var $c9b1aa9458d4ea13$export$ec1e04e4e5ef8233;
(function(DeviceType) {
    DeviceType["TRACK_PAD"] = "track_pad";
    DeviceType["MOUSE"] = "mouse";
    DeviceType["TOUCH"] = "touch";
})($c9b1aa9458d4ea13$export$ec1e04e4e5ef8233 || ($c9b1aa9458d4ea13$export$ec1e04e4e5ef8233 = {}));
var $c9b1aa9458d4ea13$var$isVelocityCalculationAllowed = function(contextInstance) {
    var mounted = contextInstance.mounted, wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent;
    var _a = contextInstance.setup, disabled = _a.disabled, velocityAnimation = _a.velocityAnimation, limitToBounds = _a.limitToBounds;
    var scale = contextInstance.state.scale;
    var disabledVelocity = velocityAnimation.disabled;
    if (disabledVelocity || disabled || !mounted) return false;
    if (!wrapperComponent || !contentComponent) return false;
    if (!limitToBounds) return true;
    var contentOverflows = wrapperComponent.offsetWidth < contentComponent.offsetWidth * scale || wrapperComponent.offsetHeight < contentComponent.offsetHeight * scale;
    return contentOverflows;
};
var $c9b1aa9458d4ea13$var$isVelocityAllowed = function(contextInstance) {
    var mounted = contextInstance.mounted, velocity = contextInstance.velocity, bounds = contextInstance.bounds;
    var _a = contextInstance.setup, disabled = _a.disabled, velocityAnimation = _a.velocityAnimation;
    var disabledVelocity = velocityAnimation.disabled;
    var isAllowed = !disabledVelocity && !disabled && mounted;
    if (!isAllowed) return false;
    if (!velocity || !bounds) return false;
    return true;
};
function $c9b1aa9458d4ea13$var$getVelocityMoveTime(contextInstance, velocity) {
    var velocityAnimation = contextInstance.setup.velocityAnimation;
    var animationTime = velocityAnimation.animationTime, maxAnimationTime = velocityAnimation.maxAnimationTime, inertia = velocityAnimation.inertia;
    return Math.min(animationTime * Math.max(1, Math.abs(velocity / inertia)), maxAnimationTime);
}
function $c9b1aa9458d4ea13$var$getVelocityPosition(newPosition, startPosition, currentPosition, isLocked, limitToBounds, minPosition, maxPosition, minTarget, maxTarget, step) {
    if (limitToBounds) {
        if (startPosition > maxPosition && currentPosition > maxPosition) {
            var calculatedPosition = maxPosition + (newPosition - maxPosition) * step;
            if (calculatedPosition > maxTarget) return maxTarget;
            if (calculatedPosition < maxPosition) return maxPosition;
            return calculatedPosition;
        }
        if (startPosition < minPosition && currentPosition < minPosition) {
            var calculatedPosition = minPosition + (newPosition - minPosition) * step;
            if (calculatedPosition < minTarget) return minTarget;
            if (calculatedPosition > minPosition) return minPosition;
            return calculatedPosition;
        }
    }
    if (isLocked) return startPosition;
    return $c9b1aa9458d4ea13$var$boundLimiter(newPosition, minPosition, maxPosition, limitToBounds);
}
/* eslint-disable no-param-reassign */ function $c9b1aa9458d4ea13$var$getSizeMultiplier(wrapperComponent) {
    var defaultMultiplier = 1;
    var value = wrapperComponent.offsetWidth / window.innerWidth;
    if (Number.isNaN(value)) return defaultMultiplier;
    return Math.min(defaultMultiplier, value);
}
var $c9b1aa9458d4ea13$var$getMinMaxVelocity = function(velocity, maxStrength, sensitivity) {
    var defaultMultiplier = 0;
    var value = velocity * sensitivity;
    if (Number.isNaN(value)) return defaultMultiplier;
    if (velocity < 0) return Math.max(value, -maxStrength);
    return Math.min(value, maxStrength);
};
function $c9b1aa9458d4ea13$var$handleCalculateVelocity(contextInstance, position, device) {
    var _a, _b;
    var isAllowed = $c9b1aa9458d4ea13$var$isVelocityCalculationAllowed(contextInstance);
    if (!isAllowed) return;
    var lastMousePosition = contextInstance.lastMousePosition, velocityTime = contextInstance.velocityTime, setup = contextInstance.setup;
    var wrapperComponent = contextInstance.wrapperComponent;
    var _c = setup.velocityAnimation, maxStrengthMouse = _c.maxStrengthMouse, maxStrengthTouch = _c.maxStrengthTouch, sensitivityTouch = _c.sensitivityTouch, sensitivityMouse = _c.sensitivityMouse;
    var now = Date.now();
    if (lastMousePosition && velocityTime && wrapperComponent) {
        var sizeMultiplier = $c9b1aa9458d4ea13$var$getSizeMultiplier(wrapperComponent);
        var sensitivity = (_a = {}, _a[$c9b1aa9458d4ea13$export$ec1e04e4e5ef8233.TOUCH] = sensitivityTouch, _a[$c9b1aa9458d4ea13$export$ec1e04e4e5ef8233.MOUSE] = sensitivityMouse, _a)[device];
        var maxStrength = (_b = {}, _b[$c9b1aa9458d4ea13$export$ec1e04e4e5ef8233.TOUCH] = maxStrengthTouch, _b[$c9b1aa9458d4ea13$export$ec1e04e4e5ef8233.MOUSE] = maxStrengthMouse, _b)[device];
        var distanceX = position.x - lastMousePosition.x;
        var distanceY = position.y - lastMousePosition.y;
        var velocityX = $c9b1aa9458d4ea13$var$getMinMaxVelocity(distanceX / sizeMultiplier, maxStrength, sensitivity);
        var velocityY = $c9b1aa9458d4ea13$var$getMinMaxVelocity(distanceY / sizeMultiplier, maxStrength, sensitivity);
        var interval = now - velocityTime;
        var speed = distanceX * distanceX + distanceY * distanceY;
        var velocity = $c9b1aa9458d4ea13$var$getMinMaxVelocity(Math.sqrt(speed) / interval, maxStrength, sensitivity);
        contextInstance.velocity = {
            velocityX: velocityX,
            velocityY: velocityY,
            total: velocity
        };
    }
    contextInstance.lastMousePosition = position;
    contextInstance.velocityTime = now;
}
function $c9b1aa9458d4ea13$var$handleVelocityPanning(contextInstance) {
    var velocity = contextInstance.velocity, bounds = contextInstance.bounds, setup = contextInstance.setup, wrapperComponent = contextInstance.wrapperComponent;
    var isAllowed = $c9b1aa9458d4ea13$var$isVelocityAllowed(contextInstance);
    if (!isAllowed || !velocity || !bounds || !wrapperComponent) return;
    var velocityX = velocity.velocityX, velocityY = velocity.velocityY, total = velocity.total;
    var maxPositionX = bounds.maxPositionX, minPositionX = bounds.minPositionX, maxPositionY = bounds.maxPositionY, minPositionY = bounds.minPositionY;
    var limitToBounds = setup.limitToBounds, autoAlignment = setup.autoAlignment;
    var zoomAnimation = setup.zoomAnimation, panning = setup.panning;
    var lockAxisY = panning.lockAxisY, lockAxisX = panning.lockAxisX;
    var animationType = zoomAnimation.animationType;
    var sizeX = autoAlignment.sizeX, sizeY = autoAlignment.sizeY, velocityAlignmentTime = autoAlignment.velocityAlignmentTime;
    var alignAnimationTime = velocityAlignmentTime;
    var moveAnimationTime = $c9b1aa9458d4ea13$var$getVelocityMoveTime(contextInstance, total);
    var finalAnimationTime = Math.max(moveAnimationTime, alignAnimationTime);
    var paddingValueX = $c9b1aa9458d4ea13$var$getPaddingValue(contextInstance, sizeX);
    var paddingValueY = $c9b1aa9458d4ea13$var$getPaddingValue(contextInstance, sizeY);
    var paddingX = paddingValueX * wrapperComponent.offsetWidth / 100;
    var paddingY = paddingValueY * wrapperComponent.offsetHeight / 100;
    var maxTargetX = maxPositionX + paddingX;
    var minTargetX = minPositionX - paddingX;
    var maxTargetY = maxPositionY + paddingY;
    var minTargetY = minPositionY - paddingY;
    var startState = contextInstance.state;
    var startTime = new Date().getTime();
    $c9b1aa9458d4ea13$var$handleSetupAnimation(contextInstance, animationType, finalAnimationTime, function(step) {
        var _a = contextInstance.state, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
        var frameTime = new Date().getTime() - startTime;
        var animationProgress = frameTime / alignAnimationTime;
        var alignAnimation = $c9b1aa9458d4ea13$var$animations[autoAlignment.animationType];
        var alignStep = 1 - alignAnimation(Math.min(1, animationProgress));
        var customStep = 1 - step;
        var newPositionX = positionX + velocityX * customStep;
        var newPositionY = positionY + velocityY * customStep;
        var currentPositionX = $c9b1aa9458d4ea13$var$getVelocityPosition(newPositionX, startState.positionX, positionX, lockAxisX, limitToBounds, minPositionX, maxPositionX, minTargetX, maxTargetX, alignStep);
        var currentPositionY = $c9b1aa9458d4ea13$var$getVelocityPosition(newPositionY, startState.positionY, positionY, lockAxisY, limitToBounds, minPositionY, maxPositionY, minTargetY, maxTargetY, alignStep);
        if (positionX !== newPositionX || positionY !== newPositionY) {
            contextInstance.setState(scale, currentPositionX, currentPositionY);
            var onPanning = contextInstance.props.onPanning;
            if (onPanning) onPanning($c9b1aa9458d4ea13$var$getContext(contextInstance), {});
        }
    });
}
function $c9b1aa9458d4ea13$var$handlePanningStart(contextInstance, event) {
    var _a = contextInstance.state, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    contextInstance.panStartPosition = {
        x: positionX,
        y: positionY
    };
    $c9b1aa9458d4ea13$var$handleCancelAnimation(contextInstance);
    $c9b1aa9458d4ea13$var$handleCalculateBounds(contextInstance, scale);
    if (window.TouchEvent !== undefined && event instanceof TouchEvent) $c9b1aa9458d4ea13$var$handleTouchPanningSetup(contextInstance, event);
    else $c9b1aa9458d4ea13$var$handlePanningSetup(contextInstance, event);
}
function $c9b1aa9458d4ea13$var$handleAlignToBounds(contextInstance, customAnimationTime) {
    var scale = contextInstance.state.scale;
    var _a = contextInstance.setup, minScale = _a.minScale, autoAlignment = _a.autoAlignment;
    var disabled = autoAlignment.disabled, sizeX = autoAlignment.sizeX, sizeY = autoAlignment.sizeY, animationTime = autoAlignment.animationTime, animationType = autoAlignment.animationType;
    var isDisabled = disabled || scale < minScale || !sizeX && !sizeY;
    if (isDisabled) return;
    var targetState = $c9b1aa9458d4ea13$var$handlePanToBounds(contextInstance);
    if (targetState) $c9b1aa9458d4ea13$var$animate(contextInstance, targetState, customAnimationTime !== null && customAnimationTime !== void 0 ? customAnimationTime : animationTime, animationType);
}
function $c9b1aa9458d4ea13$var$handlePanning(contextInstance, clientX, clientY, device) {
    var startCoords = contextInstance.startCoords, setup = contextInstance.setup;
    var _a = setup.autoAlignment, sizeX = _a.sizeX, sizeY = _a.sizeY;
    if (!startCoords) return;
    var _b = $c9b1aa9458d4ea13$var$getPanningClientPosition(contextInstance, clientX, clientY), x = _b.x, y = _b.y;
    var paddingValueX = $c9b1aa9458d4ea13$var$getPaddingValue(contextInstance, sizeX);
    var paddingValueY = $c9b1aa9458d4ea13$var$getPaddingValue(contextInstance, sizeY);
    $c9b1aa9458d4ea13$var$handleCalculateVelocity(contextInstance, {
        x: x,
        y: y
    }, device);
    $c9b1aa9458d4ea13$var$handleNewPosition(contextInstance, x, y, paddingValueX, paddingValueY);
}
function $c9b1aa9458d4ea13$var$handlePanningEnd(contextInstance, velocityDisabled) {
    if (contextInstance.isPanning) {
        var velocity = contextInstance.velocity, wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent;
        contextInstance.isPanning = false;
        var _a = contextInstance.state, positionX = _a.positionX, positionY = _a.positionY, scale = _a.scale;
        var start = contextInstance.panStartPosition;
        contextInstance.panStartPosition = null;
        if (start) {
            var dx = positionX - start.x;
            var dy = positionY - start.y;
            if (dx * dx + dy * dy <= 25) return;
        }
        contextInstance.isAnimating = false;
        contextInstance.animation = null;
        var wrapperWidth = (wrapperComponent === null || wrapperComponent === void 0 ? void 0 : wrapperComponent.offsetWidth) || 0;
        var wrapperHeight = (wrapperComponent === null || wrapperComponent === void 0 ? void 0 : wrapperComponent.offsetHeight) || 0;
        var contentWidth = ((contentComponent === null || contentComponent === void 0 ? void 0 : contentComponent.offsetWidth) || 0) * scale;
        var contentHeight = ((contentComponent === null || contentComponent === void 0 ? void 0 : contentComponent.offsetHeight) || 0) * scale;
        var isContentOverflowing = !contextInstance.setup.limitToBounds || wrapperWidth < contentWidth || wrapperHeight < contentHeight;
        var shouldAnimate = !velocityDisabled && velocity && velocity.total > 0.1 && isContentOverflowing;
        if (shouldAnimate) $c9b1aa9458d4ea13$var$handleVelocityPanning(contextInstance);
        else $c9b1aa9458d4ea13$var$handleAlignToBounds(contextInstance);
    }
}
function $c9b1aa9458d4ea13$var$handleZoomToPoint(contextInstance, scale, mouseX, mouseY) {
    var _a = contextInstance.setup, minScale = _a.minScale, maxScale = _a.maxScale, limitToBounds = _a.limitToBounds;
    var newScale = $c9b1aa9458d4ea13$var$checkZoomBounds($c9b1aa9458d4ea13$var$roundNumber(scale, 2), minScale, maxScale, 0, false);
    var bounds = $c9b1aa9458d4ea13$var$handleCalculateBounds(contextInstance, newScale);
    var _b = $c9b1aa9458d4ea13$var$handleCalculateZoomPositions(contextInstance, mouseX, mouseY, newScale, bounds, limitToBounds), x = _b.x, y = _b.y;
    return {
        scale: newScale,
        positionX: x,
        positionY: y
    };
}
function $c9b1aa9458d4ea13$var$handleAlignToScaleBounds(contextInstance, mousePositionX, mousePositionY) {
    var scale = contextInstance.state.scale;
    var wrapperComponent = contextInstance.wrapperComponent;
    var _a = contextInstance.setup, minScale = _a.minScale, maxScale = _a.maxScale, limitToBounds = _a.limitToBounds, zoomAnimation = _a.zoomAnimation;
    var disabled = zoomAnimation.disabled, animationTime = zoomAnimation.animationTime, animationType = zoomAnimation.animationType;
    var isWithinBounds = scale >= minScale && scale <= maxScale;
    var isDisabled = disabled || isWithinBounds;
    if (scale >= 1 || limitToBounds) $c9b1aa9458d4ea13$var$handleAlignToBounds(contextInstance);
    if (isDisabled || !wrapperComponent || !contextInstance.mounted) return;
    var mouseX = mousePositionX || wrapperComponent.offsetWidth / 2;
    var mouseY = mousePositionY || wrapperComponent.offsetHeight / 2;
    var targetScale = scale < minScale ? minScale : maxScale;
    var targetState = $c9b1aa9458d4ea13$var$handleZoomToPoint(contextInstance, targetScale, mouseX, mouseY);
    if (targetState) $c9b1aa9458d4ea13$var$animate(contextInstance, targetState, animationTime, animationType);
}
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $c9b1aa9458d4ea13$var$__assign = function() {
    $c9b1aa9458d4ea13$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c9b1aa9458d4ea13$var$__assign.apply(this, arguments);
};
function $c9b1aa9458d4ea13$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $c9b1aa9458d4ea13$var$__spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
typeof SuppressedError === "function" && SuppressedError;
var $c9b1aa9458d4ea13$var$initialState = {
    previousScale: 1,
    scale: 1,
    positionX: 0,
    positionY: 0
};
var $c9b1aa9458d4ea13$var$initialSetup = {
    disabled: false,
    minPositionX: null,
    maxPositionX: null,
    minPositionY: null,
    maxPositionY: null,
    minScale: 1,
    maxScale: 8,
    limitToBounds: true,
    centerZoomedOut: false,
    centerOnInit: false,
    disablePadding: false,
    smooth: true,
    detached: false,
    wheel: {
        step: 0.015,
        disabled: false,
        wheelDisabled: false,
        touchPadDisabled: false,
        activationKeys: [],
        excluded: []
    },
    trackPadPanning: {
        disabled: true,
        velocityDisabled: false,
        lockAxisX: false,
        lockAxisY: false,
        activationKeys: [],
        excluded: []
    },
    panning: {
        disabled: false,
        velocityDisabled: false,
        lockAxisX: false,
        lockAxisY: false,
        allowLeftClickPan: true,
        allowMiddleClickPan: true,
        allowRightClickPan: true,
        activationKeys: [],
        excluded: []
    },
    pinch: {
        step: 5,
        disabled: false,
        allowPanning: true,
        excluded: []
    },
    doubleClick: {
        disabled: false,
        step: 0.7,
        mode: "zoomIn",
        animationType: "easeOut",
        animationTime: 200,
        excluded: []
    },
    zoomAnimation: {
        disabled: false,
        size: 0.4,
        animationTime: 200,
        animationType: "easeOut"
    },
    autoAlignment: {
        disabled: false,
        sizeX: 100,
        sizeY: 100,
        animationTime: 200,
        velocityAlignmentTime: 400,
        animationType: "easeOut"
    },
    velocityAnimation: {
        disabled: false,
        sensitivityMouse: 1,
        sensitivityTouch: 1.2,
        maxStrengthMouse: 20,
        maxStrengthTouch: 40,
        inertia: 1,
        animationTime: 300,
        maxAnimationTime: 800,
        animationType: "easeOut"
    }
};
var $c9b1aa9458d4ea13$var$baseClasses = {
    wrapperClass: "react-transform-wrapper",
    contentClass: "react-transform-component"
};
var $c9b1aa9458d4ea13$var$createState = function(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var minScale = Math.max((_a = props.minScale) !== null && _a !== void 0 ? _a : $c9b1aa9458d4ea13$var$initialSetup.minScale, 1e-7);
    var maxScale = (_b = props.maxScale) !== null && _b !== void 0 ? _b : $c9b1aa9458d4ea13$var$initialSetup.maxScale;
    var rawScale = (_c = props.initialScale) !== null && _c !== void 0 ? _c : $c9b1aa9458d4ea13$var$initialState.scale;
    var scale = Math.min(Math.max(rawScale, minScale), maxScale);
    var positionX = $c9b1aa9458d4ea13$var$boundLimiter((_d = props.initialPositionX) !== null && _d !== void 0 ? _d : $c9b1aa9458d4ea13$var$initialState.positionX, (_e = props.minPositionX) !== null && _e !== void 0 ? _e : -Infinity, (_f = props.maxPositionX) !== null && _f !== void 0 ? _f : Infinity, props.minPositionX != null || props.maxPositionX != null);
    var positionY = $c9b1aa9458d4ea13$var$boundLimiter((_g = props.initialPositionY) !== null && _g !== void 0 ? _g : $c9b1aa9458d4ea13$var$initialState.positionY, (_h = props.minPositionY) !== null && _h !== void 0 ? _h : -Infinity, (_j = props.maxPositionY) !== null && _j !== void 0 ? _j : Infinity, props.minPositionY != null || props.maxPositionY != null);
    return {
        previousScale: scale,
        scale: scale,
        positionX: positionX,
        positionY: positionY
    };
};
var $c9b1aa9458d4ea13$var$createSetup = function(props) {
    var newSetup = $c9b1aa9458d4ea13$var$__assign({}, $c9b1aa9458d4ea13$var$initialSetup);
    Object.keys(props).forEach(function(key) {
        var k = key;
        var validValue = typeof props[k] !== "undefined";
        var validParameter = typeof $c9b1aa9458d4ea13$var$initialSetup[k] !== "undefined";
        if (validParameter && validValue) {
            var dataType = Object.prototype.toString.call($c9b1aa9458d4ea13$var$initialSetup[k]);
            var isObject = dataType === "[object Object]";
            var isArray = dataType === "[object Array]";
            if (isObject) newSetup[k] = $c9b1aa9458d4ea13$var$__assign($c9b1aa9458d4ea13$var$__assign({}, $c9b1aa9458d4ea13$var$initialSetup[k]), props[k]);
            else if (isArray) newSetup[k] = $c9b1aa9458d4ea13$var$__spreadArray($c9b1aa9458d4ea13$var$__spreadArray([], $c9b1aa9458d4ea13$var$initialSetup[k], true), props[k], true);
            else newSetup[k] = props[k];
        }
    });
    if (newSetup.minScale <= 0) newSetup.minScale = 1e-7;
    return newSetup;
};
var $c9b1aa9458d4ea13$var$handleCalculateButtonZoom = function(contextInstance, delta, step) {
    var scale = contextInstance.state.scale;
    var wrapperComponent = contextInstance.wrapperComponent, setup = contextInstance.setup;
    var maxScale = setup.maxScale, minScale = setup.minScale, zoomAnimation = setup.zoomAnimation, smooth = setup.smooth;
    var size = zoomAnimation.size;
    if (!wrapperComponent) throw new Error("Wrapper is not mounted");
    var targetScale = smooth ? scale * Math.exp(delta * step) : scale + delta * step;
    var newScale = $c9b1aa9458d4ea13$var$checkZoomBounds($c9b1aa9458d4ea13$var$roundNumber(targetScale, 3), minScale, maxScale, size, false);
    return newScale;
};
function $c9b1aa9458d4ea13$var$handleZoomToViewCenter(contextInstance, delta, step, animationTime, animationType) {
    var _a, _b;
    var wrapperComponent = contextInstance.wrapperComponent;
    var _c = contextInstance.state, scale = _c.scale, positionX = _c.positionX, positionY = _c.positionY;
    var zoomAnimation = contextInstance.setup.zoomAnimation;
    if (!wrapperComponent) return console.error("No WrapperComponent found");
    var effectiveAnimationTime = zoomAnimation.disabled ? 0 : animationTime;
    var wrapperWidth = wrapperComponent.offsetWidth;
    var wrapperHeight = wrapperComponent.offsetHeight;
    var mouseX = (wrapperWidth / 2 - positionX) / scale;
    var mouseY = (wrapperHeight / 2 - positionY) / scale;
    var newScale = $c9b1aa9458d4ea13$var$handleCalculateButtonZoom(contextInstance, delta, step);
    var targetState = $c9b1aa9458d4ea13$var$handleZoomToPoint(contextInstance, newScale, mouseX, mouseY);
    if (!targetState) return console.error("Error during zoom event. New transformation state was not calculated.");
    var _d = contextInstance.props, onZoomStart = _d.onZoomStart, onZoom = _d.onZoom, onZoomStop = _d.onZoomStop;
    var event = new MouseEvent("mousemove", {
        bubbles: true
    });
    var ctx = $c9b1aa9458d4ea13$var$getContext(contextInstance);
    $c9b1aa9458d4ea13$var$handleCallback(ctx, event, onZoomStart);
    $c9b1aa9458d4ea13$var$handleCallback(ctx, event, onZoom);
    $c9b1aa9458d4ea13$var$animate(contextInstance, targetState, effectiveAnimationTime, animationType);
    var win = (_b = (_a = wrapperComponent.ownerDocument) === null || _a === void 0 ? void 0 : _a.defaultView) !== null && _b !== void 0 ? _b : typeof window !== "undefined" ? window : null;
    if (win) win.setTimeout(function() {
        if (!contextInstance.mounted) return;
        $c9b1aa9458d4ea13$var$handleCallback($c9b1aa9458d4ea13$var$getContext(contextInstance), event, onZoomStop);
    }, effectiveAnimationTime);
}
function $c9b1aa9458d4ea13$var$resetTransformations(contextInstance, animationTime, animationType, onResetTransformation) {
    var _a, _b;
    var setup = contextInstance.setup, wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent;
    var limitToBounds = setup.limitToBounds, centerOnInit = setup.centerOnInit;
    var initialTransformation = $c9b1aa9458d4ea13$var$createState(contextInstance.props);
    var _c = contextInstance.state, scale = _c.scale, positionX = _c.positionX, positionY = _c.positionY;
    if (!wrapperComponent) return;
    var targetPositionX = initialTransformation.positionX;
    var targetPositionY = initialTransformation.positionY;
    if (centerOnInit && contentComponent) {
        var centered = $c9b1aa9458d4ea13$export$a51b33620579dad4(initialTransformation.scale, wrapperComponent, contentComponent);
        targetPositionX = centered.positionX;
        targetPositionY = centered.positionY;
    }
    var newBounds = $c9b1aa9458d4ea13$var$calculateBounds(contextInstance, initialTransformation.scale);
    var boundedPositions = $c9b1aa9458d4ea13$var$getMouseBoundedPosition(targetPositionX, targetPositionY, newBounds, limitToBounds, 0, 0, wrapperComponent);
    var newState = {
        scale: initialTransformation.scale,
        positionX: boundedPositions.x,
        positionY: boundedPositions.y
    };
    if (scale === initialTransformation.scale && positionX === initialTransformation.positionX && positionY === initialTransformation.positionY) return;
    onResetTransformation === null || onResetTransformation === void 0 || onResetTransformation();
    var _d = contextInstance.props, onZoomStart = _d.onZoomStart, onZoom = _d.onZoom, onZoomStop = _d.onZoomStop;
    var event = new MouseEvent("mousemove", {
        bubbles: true
    });
    var ctx = $c9b1aa9458d4ea13$var$getContext(contextInstance);
    $c9b1aa9458d4ea13$var$handleCallback(ctx, event, onZoomStart);
    $c9b1aa9458d4ea13$var$handleCallback(ctx, event, onZoom);
    $c9b1aa9458d4ea13$var$animate(contextInstance, newState, animationTime, animationType);
    var win = (_b = (_a = wrapperComponent.ownerDocument) === null || _a === void 0 ? void 0 : _a.defaultView) !== null && _b !== void 0 ? _b : typeof window !== "undefined" ? window : null;
    if (win) win.setTimeout(function() {
        if (!contextInstance.mounted) return;
        $c9b1aa9458d4ea13$var$handleCallback($c9b1aa9458d4ea13$var$getContext(contextInstance), event, onZoomStop);
    }, animationTime);
}
function $c9b1aa9458d4ea13$var$getOffset(element, wrapper, content, state) {
    var offset = element.getBoundingClientRect();
    var wrapperOffset = wrapper.getBoundingClientRect();
    var contentOffset = content.getBoundingClientRect();
    var xOff = wrapperOffset.x * state.scale;
    var yOff = wrapperOffset.y * state.scale;
    return {
        x: (offset.x - contentOffset.x + xOff) / state.scale,
        y: (offset.y - contentOffset.y + yOff) / state.scale
    };
}
function $c9b1aa9458d4ea13$var$calculateZoomToNode(contextInstance, node, customZoom, customOffsetX, customOffsetY) {
    if (customOffsetX === void 0) customOffsetX = 0;
    if (customOffsetY === void 0) customOffsetY = 0;
    var wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent, state = contextInstance.state;
    var _a = contextInstance.setup, limitToBounds = _a.limitToBounds, minScale = _a.minScale, maxScale = _a.maxScale;
    if (!wrapperComponent || !contentComponent) return state;
    var wrapperRect = wrapperComponent.getBoundingClientRect();
    var nodeRect = node.getBoundingClientRect();
    var nodeOffset = $c9b1aa9458d4ea13$var$getOffset(node, wrapperComponent, contentComponent, state);
    var nodeLeft = nodeOffset.x;
    var nodeTop = nodeOffset.y;
    var nodeWidth = nodeRect.width / state.scale;
    var nodeHeight = nodeRect.height / state.scale;
    var scaleX = wrapperComponent.offsetWidth / nodeWidth;
    var scaleY = wrapperComponent.offsetHeight / nodeHeight;
    var newScale = $c9b1aa9458d4ea13$var$checkZoomBounds(customZoom || Math.min(scaleX, scaleY), minScale, maxScale, 0, false);
    var offsetX = (wrapperRect.width - nodeWidth * newScale) / 2;
    var offsetY = (wrapperRect.height - nodeHeight * newScale) / 2;
    var newPositionX = (wrapperRect.left - nodeLeft) * newScale + offsetX + customOffsetX;
    var newPositionY = (wrapperRect.top - nodeTop) * newScale + offsetY + customOffsetY;
    var bounds = $c9b1aa9458d4ea13$var$calculateBounds(contextInstance, newScale);
    var _b = $c9b1aa9458d4ea13$var$getMouseBoundedPosition(newPositionX, newPositionY, bounds, limitToBounds, 0, 0, wrapperComponent), x = _b.x, y = _b.y;
    return {
        positionX: x,
        positionY: y,
        scale: newScale
    };
}
var $c9b1aa9458d4ea13$var$zoomIn = function(contextInstance) {
    return function(step, animationTime, animationType) {
        if (step === void 0) step = 0.5;
        if (animationTime === void 0) animationTime = 300;
        if (animationType === void 0) animationType = "easeOut";
        $c9b1aa9458d4ea13$var$handleZoomToViewCenter(contextInstance, 1, step, animationTime, animationType);
    };
};
var $c9b1aa9458d4ea13$var$zoomOut = function(contextInstance) {
    return function(step, animationTime, animationType) {
        if (step === void 0) step = 0.5;
        if (animationTime === void 0) animationTime = 300;
        if (animationType === void 0) animationType = "easeOut";
        $c9b1aa9458d4ea13$var$handleZoomToViewCenter(contextInstance, -1, step, animationTime, animationType);
    };
};
var $c9b1aa9458d4ea13$var$setTransform = function(contextInstance) {
    return function(newPositionX, newPositionY, newScale, animationTime, animationType) {
        if (animationTime === void 0) animationTime = 300;
        if (animationType === void 0) animationType = "easeOut";
        var _a = contextInstance.state, positionX = _a.positionX, positionY = _a.positionY, scale = _a.scale;
        var wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent;
        var disabled = contextInstance.setup.disabled;
        if (disabled || !wrapperComponent || !contentComponent) return;
        var targetState = {
            positionX: Number.isNaN(newPositionX) ? positionX : newPositionX,
            positionY: Number.isNaN(newPositionY) ? positionY : newPositionY,
            scale: Number.isNaN(newScale) ? scale : newScale
        };
        $c9b1aa9458d4ea13$var$animate(contextInstance, targetState, animationTime, animationType);
    };
};
var $c9b1aa9458d4ea13$var$resetTransform = function(contextInstance) {
    return function(animationTime, animationType) {
        if (animationTime === void 0) animationTime = 200;
        if (animationType === void 0) animationType = "easeOut";
        $c9b1aa9458d4ea13$var$resetTransformations(contextInstance, animationTime, animationType);
    };
};
var $c9b1aa9458d4ea13$var$centerView = function(contextInstance) {
    return function(scale, animationTime, animationType) {
        if (animationTime === void 0) animationTime = 200;
        if (animationType === void 0) animationType = "easeOut";
        var state = contextInstance.state, wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent;
        if (wrapperComponent && contentComponent) {
            var targetState = $c9b1aa9458d4ea13$export$a51b33620579dad4(scale || state.scale, wrapperComponent, contentComponent);
            $c9b1aa9458d4ea13$var$animate(contextInstance, targetState, animationTime, animationType);
        }
    };
};
var $c9b1aa9458d4ea13$var$zoomToElement = function(contextInstance) {
    return function(node, scale, animationTime, animationType, offsetX, offsetY) {
        if (animationTime === void 0) animationTime = 600;
        if (animationType === void 0) animationType = "easeOut";
        if (offsetX === void 0) offsetX = 0;
        if (offsetY === void 0) offsetY = 0;
        $c9b1aa9458d4ea13$var$handleCancelAnimation(contextInstance);
        var wrapperComponent = contextInstance.wrapperComponent;
        var target = typeof node === "string" ? document.getElementById(node) : node;
        if (wrapperComponent && target && wrapperComponent.contains(target)) {
            var targetState = $c9b1aa9458d4ea13$var$calculateZoomToNode(contextInstance, target, scale, offsetX, offsetY);
            $c9b1aa9458d4ea13$var$animate(contextInstance, targetState, animationTime, animationType);
        }
    };
};
var $c9b1aa9458d4ea13$var$getControls = function(contextInstance) {
    return {
        instance: contextInstance,
        state: contextInstance.state,
        zoomIn: $c9b1aa9458d4ea13$var$zoomIn(contextInstance),
        zoomOut: $c9b1aa9458d4ea13$var$zoomOut(contextInstance),
        setTransform: $c9b1aa9458d4ea13$var$setTransform(contextInstance),
        resetTransform: $c9b1aa9458d4ea13$var$resetTransform(contextInstance),
        centerView: $c9b1aa9458d4ea13$var$centerView(contextInstance),
        zoomToElement: $c9b1aa9458d4ea13$var$zoomToElement(contextInstance)
    };
};
var $c9b1aa9458d4ea13$var$getState = function(contextInstance) {
    return {
        instance: contextInstance,
        state: contextInstance.state
    };
};
var $c9b1aa9458d4ea13$var$getContext = function(contextInstance) {
    var ref = {};
    Object.assign(ref, $c9b1aa9458d4ea13$var$getState(contextInstance));
    Object.assign(ref, $c9b1aa9458d4ea13$var$getControls(contextInstance));
    return ref;
};
// We want to make event listeners non-passive, and to do so have to check
// that browsers support EventListenerOptions in the first place.
// https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
var $c9b1aa9458d4ea13$var$passiveSupported = false;
function $c9b1aa9458d4ea13$var$makePassiveEventOption() {
    try {
        var options = {
            get passive () {
                // This function will be called when the browser
                //   attempts to access the passive property.
                $c9b1aa9458d4ea13$var$passiveSupported = true;
                return false;
            }
        };
        return options;
    } catch (err) {
        $c9b1aa9458d4ea13$var$passiveSupported = false;
        return $c9b1aa9458d4ea13$var$passiveSupported;
    }
}
var $c9b1aa9458d4ea13$var$matchPrefix = ".".concat($c9b1aa9458d4ea13$var$baseClasses.wrapperClass);
var $c9b1aa9458d4ea13$var$isExcludedNode = function(node, excluded) {
    return excluded.some(function(exclude) {
        return node.matches("".concat($c9b1aa9458d4ea13$var$matchPrefix, " ").concat(exclude, ", ").concat($c9b1aa9458d4ea13$var$matchPrefix, " .").concat(exclude, ", ").concat($c9b1aa9458d4ea13$var$matchPrefix, " ").concat(exclude, " *, ").concat($c9b1aa9458d4ea13$var$matchPrefix, " .").concat(exclude, " *"));
    });
};
var $c9b1aa9458d4ea13$var$cancelTimeout = function(timeout) {
    if (timeout) clearTimeout(timeout);
};
/** Drop binary float noise on scale (e.g. 1.5000000000000002) without clipping real zoom values. */ var $c9b1aa9458d4ea13$export$a6a10b4438122f80 = function(scale) {
    return Number.parseFloat(scale.toFixed(8));
};
var $c9b1aa9458d4ea13$export$c15ec262effbd456 = function(x, y, scale) {
    // Standard translate prevents blurry svg on the safari
    var s = $c9b1aa9458d4ea13$export$a6a10b4438122f80(scale);
    return "translate(".concat(x, "px, ").concat(y, "px) scale(").concat(s, ")");
};
var $c9b1aa9458d4ea13$export$3b94f66093db6f05 = function(x, y, scale) {
    // The shorthand for matrix does not work for Safari hence the need to explicitly use matrix3d
    // Refer to https://developer.mozilla.org/en-US/docs/Web/CSS/transform-function/matrix
    var a = scale;
    var b = 0;
    var c = 0;
    var d = scale;
    var tx = x;
    var ty = y;
    return "matrix3d(".concat(a, ", ").concat(b, ", 0, 0, ").concat(c, ", ").concat(d, ", 0, 0, 0, 0, 1, 0, ").concat(tx, ", ").concat(ty, ", 0, 1)");
};
var $c9b1aa9458d4ea13$export$a51b33620579dad4 = function(scale, wrapperComponent, contentComponent) {
    var contentWidth = contentComponent.offsetWidth * scale;
    var contentHeight = contentComponent.offsetHeight * scale;
    var centerPositionX = (wrapperComponent.offsetWidth - contentWidth) / 2;
    var centerPositionY = (wrapperComponent.offsetHeight - contentHeight) / 2;
    return {
        scale: scale,
        positionX: centerPositionX,
        positionY: centerPositionY
    };
};
function $c9b1aa9458d4ea13$var$assignRef(ref, value) {
    if (ref == null) return;
    if (typeof ref === "function") ref(value);
    else ref.current = value;
}
function $c9b1aa9458d4ea13$var$mergeRefs(refs) {
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
var $c9b1aa9458d4ea13$var$isWheelAllowed = function(contextInstance, event) {
    var _a = contextInstance.setup.wheel, disabled = _a.disabled, wheelDisabled = _a.wheelDisabled, touchPadDisabled = _a.touchPadDisabled, excluded = _a.excluded;
    var isInitialized = contextInstance.isInitialized, isPanning = contextInstance.isPanning;
    var target = event.target;
    var isAllowed = isInitialized && !isPanning && !disabled && target;
    if (!isAllowed) return false;
    // Event ctrlKey detects if touchpad action is executing wheel or pinch gesture
    if (wheelDisabled && !event.ctrlKey) return false;
    if (touchPadDisabled && event.ctrlKey) return false;
    var isExcluded = $c9b1aa9458d4ea13$var$isExcludedNode(target, excluded);
    if (isExcluded) return false;
    var keysPressed = contextInstance.isPressingKeys(contextInstance.setup.wheel.activationKeys);
    if (!keysPressed) return false;
    return true;
};
var $c9b1aa9458d4ea13$var$isWheelPanningAllowed = function(contextInstance, event) {
    var _a = contextInstance.setup, disabled = _a.disabled, trackPadPanning = _a.trackPadPanning;
    var activationKeys = trackPadPanning.activationKeys, excluded = trackPadPanning.excluded;
    if (!contextInstance.wrapperComponent || !contextInstance.contentComponent) return false;
    if (disabled || trackPadPanning.disabled || event.ctrlKey) return false;
    var isAllowed = $c9b1aa9458d4ea13$var$isWheelAllowed(contextInstance, event);
    // Cannot execute at the same time as wheel zoom
    if (isAllowed) return false;
    var target = event.target;
    var isExcluded = $c9b1aa9458d4ea13$var$isExcludedNode(target, excluded);
    if (isExcluded) return false;
    var keysPressed = contextInstance.isPressingKeys(activationKeys);
    if (!keysPressed) return false;
    return true;
};
var $c9b1aa9458d4ea13$var$getDeltaY = function(event) {
    if (event) return event.deltaY < 0 ? 1 : -1;
    return 0;
};
function $c9b1aa9458d4ea13$var$getDelta(event, customDelta) {
    var deltaY = $c9b1aa9458d4ea13$var$getDeltaY(event);
    var delta = $c9b1aa9458d4ea13$var$checkIsNumber(customDelta, deltaY);
    return delta;
}
function $c9b1aa9458d4ea13$var$getMousePosition(event, contentComponent, scale) {
    var contentRect = contentComponent.getBoundingClientRect();
    var mouseX = 0;
    var mouseY = 0;
    if ("clientX" in event) {
        // mouse position x, y over wrapper component
        mouseX = (event.clientX - contentRect.left) / scale;
        mouseY = (event.clientY - contentRect.top) / scale;
    } else {
        var touch = event.touches[0];
        mouseX = (touch.clientX - contentRect.left) / scale;
        mouseY = (touch.clientY - contentRect.top) / scale;
    }
    if (Number.isNaN(mouseX) || Number.isNaN(mouseY)) {
        console.error("No mouse or touch offset found");
        return {
            x: 0,
            y: 0
        };
    }
    return {
        x: mouseX,
        y: mouseY
    };
}
var $c9b1aa9458d4ea13$var$handleCalculateWheelZoom = function(contextInstance, delta, step, disable, getTarget) {
    var scale = contextInstance.state.scale;
    var wrapperComponent = contextInstance.wrapperComponent, setup = contextInstance.setup;
    var maxScale = setup.maxScale, minScale = setup.minScale, zoomAnimation = setup.zoomAnimation, disablePadding = setup.disablePadding;
    var size = zoomAnimation.size, disabled = zoomAnimation.disabled;
    if (!wrapperComponent) throw new Error("Wrapper is not mounted");
    var targetScale = scale + delta * step;
    if (getTarget) return targetScale;
    var paddingEnabled = disable ? false : !disabled;
    var newScale = $c9b1aa9458d4ea13$var$checkZoomBounds(targetScale, minScale, maxScale, size, paddingEnabled && !disablePadding);
    return newScale;
};
var $c9b1aa9458d4ea13$var$handleWheelZoomStop = function(contextInstance, event) {
    var previousWheelEvent = contextInstance.previousWheelEvent;
    var scale = contextInstance.state.scale;
    var _a = contextInstance.setup, maxScale = _a.maxScale, minScale = _a.minScale;
    if (!previousWheelEvent) return false;
    if (scale < maxScale || scale > minScale) return true;
    if (Math.sign(previousWheelEvent.deltaY) !== Math.sign(event.deltaY)) return true;
    if (previousWheelEvent.deltaY > 0 && previousWheelEvent.deltaY < event.deltaY) return true;
    if (previousWheelEvent.deltaY < 0 && previousWheelEvent.deltaY > event.deltaY) return true;
    if (Math.sign(previousWheelEvent.deltaY) !== Math.sign(event.deltaY)) return true;
    return false;
};
var $c9b1aa9458d4ea13$var$isPinchStartAllowed = function(contextInstance, event) {
    var _a = contextInstance.setup.pinch, disabled = _a.disabled, excluded = _a.excluded;
    var isInitialized = contextInstance.isInitialized;
    var target = event.target;
    var isAllowed = isInitialized && !disabled && target;
    if (!isAllowed) return false;
    var isExcluded = $c9b1aa9458d4ea13$var$isExcludedNode(target, excluded);
    if (isExcluded) return false;
    return true;
};
var $c9b1aa9458d4ea13$var$isPinchAllowed = function(contextInstance) {
    var disabled = contextInstance.setup.pinch.disabled;
    var isInitialized = contextInstance.isInitialized, pinchStartDistance = contextInstance.pinchStartDistance;
    var isAllowed = isInitialized && !disabled && pinchStartDistance !== null;
    if (!isAllowed) return false;
    return true;
};
var $c9b1aa9458d4ea13$var$calculateTouchMidPoint = function(event, scale, contentComponent) {
    var contentRect = contentComponent.getBoundingClientRect();
    var touches = event.touches;
    var firstPointX = touches[0].clientX - contentRect.left;
    var firstPointY = touches[0].clientY - contentRect.top;
    var secondPointX = touches[1].clientX - contentRect.left;
    var secondPointY = touches[1].clientY - contentRect.top;
    return {
        x: (firstPointX + secondPointX) / 2 / scale,
        y: (firstPointY + secondPointY) / 2 / scale
    };
};
var $c9b1aa9458d4ea13$var$getTouchDistance = function(event) {
    return Math.sqrt(Math.pow(event.touches[0].pageX - event.touches[1].pageX, 2) + Math.pow(event.touches[0].pageY - event.touches[1].pageY, 2));
};
var $c9b1aa9458d4ea13$var$DEFAULT_PINCH_STEP = 5;
var $c9b1aa9458d4ea13$var$calculatePinchZoom = function(contextInstance, currentDistance) {
    var pinchStartScale = contextInstance.pinchStartScale, pinchStartDistance = contextInstance.pinchStartDistance, setup = contextInstance.setup;
    var maxScale = setup.maxScale, minScale = setup.minScale, zoomAnimation = setup.zoomAnimation, disablePadding = setup.disablePadding, pinch = setup.pinch;
    var size = zoomAnimation.size, disabled = zoomAnimation.disabled;
    var step = pinch.step;
    if (!pinchStartScale || pinchStartDistance === null) throw new Error("Pinch touches distance was not provided");
    if (currentDistance < 0) return contextInstance.state.scale;
    var touchProportion = currentDistance / pinchStartDistance;
    var rawScale = touchProportion * pinchStartScale;
    var scaleDelta = (rawScale - pinchStartScale) * (step / $c9b1aa9458d4ea13$var$DEFAULT_PINCH_STEP);
    var computed = pinchStartScale + scaleDelta;
    var scale = computed === Infinity ? 0 : $c9b1aa9458d4ea13$var$roundNumber(computed, 10);
    return $c9b1aa9458d4ea13$var$checkZoomBounds(scale, minScale, maxScale, size, !disabled && !disablePadding);
};
var $c9b1aa9458d4ea13$var$wheelStopEventTime = 160;
var $c9b1aa9458d4ea13$var$wheelAnimationTime = 100;
var $c9b1aa9458d4ea13$var$handleWheelStart = function(contextInstance, event) {
    var _a = contextInstance.props, onWheelStart = _a.onWheelStart, onZoomStart = _a.onZoomStart;
    if (!contextInstance.wheelStopEventTimer) {
        $c9b1aa9458d4ea13$var$handleCancelAnimation(contextInstance);
        $c9b1aa9458d4ea13$var$handleCallback($c9b1aa9458d4ea13$var$getContext(contextInstance), event, onWheelStart);
        $c9b1aa9458d4ea13$var$handleCallback($c9b1aa9458d4ea13$var$getContext(contextInstance), event, onZoomStart);
    }
};
var $c9b1aa9458d4ea13$var$handleWheelZoom = function(contextInstance, event) {
    var _a = contextInstance.props, onWheel = _a.onWheel, onZoom = _a.onZoom;
    var contentComponent = contextInstance.contentComponent, setup = contextInstance.setup, state = contextInstance.state;
    var scale = state.scale;
    var limitToBounds = setup.limitToBounds, centerZoomedOut = setup.centerZoomedOut, zoomAnimation = setup.zoomAnimation, wheel = setup.wheel, disablePadding = setup.disablePadding, smooth = setup.smooth;
    var size = zoomAnimation.size, disabled = zoomAnimation.disabled;
    var step = wheel.step;
    if (!contentComponent) throw new Error("Component not mounted");
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
    var delta = $c9b1aa9458d4ea13$var$getDelta(event, null);
    var zoomStep = smooth ? step * Math.abs(event.deltaY) : step;
    var newScale = $c9b1aa9458d4ea13$var$handleCalculateWheelZoom(contextInstance, delta, zoomStep, !event.ctrlKey);
    // if scale not change
    if (scale === newScale) return;
    var bounds = $c9b1aa9458d4ea13$var$handleCalculateBounds(contextInstance, newScale);
    var mousePosition = $c9b1aa9458d4ea13$var$getMousePosition(event, contentComponent, scale);
    var isPaddingDisabled = disabled || size === 0 || centerZoomedOut || disablePadding;
    var isLimitedToBounds = limitToBounds && isPaddingDisabled;
    var _b = $c9b1aa9458d4ea13$var$handleCalculateZoomPositions(contextInstance, mousePosition.x, mousePosition.y, newScale, bounds, isLimitedToBounds), x = _b.x, y = _b.y;
    contextInstance.previousWheelEvent = event;
    contextInstance.setState(newScale, x, y);
    $c9b1aa9458d4ea13$var$handleCallback($c9b1aa9458d4ea13$var$getContext(contextInstance), event, onWheel);
    $c9b1aa9458d4ea13$var$handleCallback($c9b1aa9458d4ea13$var$getContext(contextInstance), event, onZoom);
};
var $c9b1aa9458d4ea13$var$handleWheelStop = function(contextInstance, event) {
    var _a = contextInstance.props, onWheelStop = _a.onWheelStop, onZoomStop = _a.onZoomStop;
    // fire animation
    $c9b1aa9458d4ea13$var$cancelTimeout(contextInstance.wheelAnimationTimer);
    contextInstance.wheelAnimationTimer = setTimeout(function() {
        if (!contextInstance.mounted) return;
        $c9b1aa9458d4ea13$var$handleAlignToScaleBounds(contextInstance, event.x, event.y);
        contextInstance.wheelAnimationTimer = null;
    }, $c9b1aa9458d4ea13$var$wheelAnimationTime);
    // Wheel stop event
    var hasStoppedZooming = $c9b1aa9458d4ea13$var$handleWheelZoomStop(contextInstance, event);
    if (hasStoppedZooming) {
        $c9b1aa9458d4ea13$var$cancelTimeout(contextInstance.wheelStopEventTimer);
        contextInstance.wheelStopEventTimer = setTimeout(function() {
            if (!contextInstance.mounted) return;
            contextInstance.wheelStopEventTimer = null;
            $c9b1aa9458d4ea13$var$handleCallback($c9b1aa9458d4ea13$var$getContext(contextInstance), event, onWheelStop);
            $c9b1aa9458d4ea13$var$handleCallback($c9b1aa9458d4ea13$var$getContext(contextInstance), event, onZoomStop);
        }, $c9b1aa9458d4ea13$var$wheelStopEventTime);
    }
};
var $c9b1aa9458d4ea13$var$handleWheelPanningStart = function(contextInstance, event) {
    var _a = contextInstance.props, onWheelStart = _a.onWheelStart, onPanningStart = _a.onPanningStart;
    if (!contextInstance.wheelStopEventTimer) {
        $c9b1aa9458d4ea13$var$handleCancelAnimation(contextInstance);
        $c9b1aa9458d4ea13$var$handleCallback($c9b1aa9458d4ea13$var$getContext(contextInstance), event, onWheelStart);
        $c9b1aa9458d4ea13$var$handleCallback($c9b1aa9458d4ea13$var$getContext(contextInstance), event, onPanningStart);
    }
};
var $c9b1aa9458d4ea13$var$handleWheelPanningStop = function(contextInstance, event) {
    var _a = contextInstance.props, onWheelStop = _a.onWheelStop, onPanningStop = _a.onPanningStop;
    // fire animation
    $c9b1aa9458d4ea13$var$cancelTimeout(contextInstance.wheelAnimationTimer);
    contextInstance.wheelAnimationTimer = setTimeout(function() {
        if (!contextInstance.mounted) return;
        $c9b1aa9458d4ea13$var$handleAlignToScaleBounds(contextInstance, event.x, event.y);
        contextInstance.wheelAnimationTimer = null;
    }, $c9b1aa9458d4ea13$var$wheelAnimationTime);
    // Wheel stop event
    var hasStoppedZooming = $c9b1aa9458d4ea13$var$handleWheelZoomStop(contextInstance, event);
    if (hasStoppedZooming) {
        $c9b1aa9458d4ea13$var$cancelTimeout(contextInstance.wheelStopEventTimer);
        contextInstance.wheelStopEventTimer = setTimeout(function() {
            if (!contextInstance.mounted) return;
            contextInstance.wheelStopEventTimer = null;
            $c9b1aa9458d4ea13$var$handleCallback($c9b1aa9458d4ea13$var$getContext(contextInstance), event, onWheelStop);
            $c9b1aa9458d4ea13$var$handleCallback($c9b1aa9458d4ea13$var$getContext(contextInstance), event, onPanningStop);
        }, $c9b1aa9458d4ea13$var$wheelStopEventTime);
    }
};
var $c9b1aa9458d4ea13$var$getTouchCenter = function(event) {
    var totalX = 0;
    var totalY = 0;
    // Sum up the positions of all touches
    for(var i = 0; i < 2; i += 1){
        totalX += event.touches[i].clientX;
        totalY += event.touches[i].clientY;
    }
    // Calculate the average position
    var x = totalX / 2;
    var y = totalY / 2;
    return {
        x: x,
        y: y
    };
};
var $c9b1aa9458d4ea13$var$handlePinchStart = function(contextInstance, event) {
    var distance = $c9b1aa9458d4ea13$var$getTouchDistance(event);
    contextInstance.pinchStartDistance = distance;
    contextInstance.lastDistance = distance;
    contextInstance.pinchStartScale = contextInstance.state.scale;
    contextInstance.isPanning = false;
    contextInstance.isPinching = true;
    contextInstance.pinchPreviousCenter = $c9b1aa9458d4ea13$var$getTouchCenter(event);
    $c9b1aa9458d4ea13$var$handleCancelAnimation(contextInstance);
};
var $c9b1aa9458d4ea13$var$handlePinchZoom = function(contextInstance, event) {
    var contentComponent = contextInstance.contentComponent, pinchStartDistance = contextInstance.pinchStartDistance, wrapperComponent = contextInstance.wrapperComponent, pinchPreviousCenter = contextInstance.pinchPreviousCenter;
    var scale = contextInstance.state.scale;
    var _a = contextInstance.setup, limitToBounds = _a.limitToBounds, centerZoomedOut = _a.centerZoomedOut, zoomAnimation = _a.zoomAnimation, autoAlignment = _a.autoAlignment, pinch = _a.pinch, panning = _a.panning;
    var disabled = zoomAnimation.disabled, size = zoomAnimation.size;
    var allowPanning = pinch.allowPanning;
    // if one finger starts from outside of wrapper
    if (pinchStartDistance === null || !contentComponent) return;
    var midPoint = $c9b1aa9458d4ea13$var$calculateTouchMidPoint(event, scale, contentComponent);
    // if touches goes off of the wrapper element
    if (!Number.isFinite(midPoint.x) || !Number.isFinite(midPoint.y)) return;
    var currentDistance = $c9b1aa9458d4ea13$var$getTouchDistance(event);
    var newScale = $c9b1aa9458d4ea13$var$calculatePinchZoom(contextInstance, currentDistance);
    var center = $c9b1aa9458d4ea13$var$getTouchCenter(event);
    // pan should be scale invariant.
    var scaleDiff = scale / newScale;
    var panX = (center.x - ((pinchPreviousCenter === null || pinchPreviousCenter === void 0 ? void 0 : pinchPreviousCenter.x) || 0)) * scaleDiff;
    var panY = (center.y - ((pinchPreviousCenter === null || pinchPreviousCenter === void 0 ? void 0 : pinchPreviousCenter.y) || 0)) * scaleDiff;
    if (newScale === scale && panX === 0 && panY === 0) return;
    contextInstance.pinchPreviousCenter = center;
    var bounds = $c9b1aa9458d4ea13$var$handleCalculateBounds(contextInstance, newScale);
    var isPaddingDisabled = disabled || size === 0 || centerZoomedOut;
    var isLimitedToBounds = limitToBounds && isPaddingDisabled;
    var _b = $c9b1aa9458d4ea13$var$handleCalculateZoomPositions(contextInstance, midPoint.x, midPoint.y, newScale, bounds, isLimitedToBounds), x = _b.x, y = _b.y;
    contextInstance.pinchMidpoint = midPoint;
    contextInstance.lastDistance = currentDistance;
    if (panning.disabled || !allowPanning) contextInstance.setState(newScale, x, y);
    else {
        var sizeX = autoAlignment.sizeX, sizeY = autoAlignment.sizeY;
        var paddingValueX = $c9b1aa9458d4ea13$var$getPaddingValue(contextInstance, sizeX, newScale);
        var paddingValueY = $c9b1aa9458d4ea13$var$getPaddingValue(contextInstance, sizeY, newScale);
        var newPositionX = x + panX;
        var newPositionY = y + panY;
        var _c = $c9b1aa9458d4ea13$var$getMouseBoundedPosition(newPositionX, newPositionY, bounds, limitToBounds, paddingValueX, paddingValueY, wrapperComponent), finalX = _c.x, finalY = _c.y;
        contextInstance.setState(newScale, finalX, finalY);
    }
};
var $c9b1aa9458d4ea13$var$handlePinchStop = function(contextInstance) {
    var pinchMidpoint = contextInstance.pinchMidpoint;
    contextInstance.velocity = null;
    contextInstance.lastDistance = null;
    contextInstance.pinchMidpoint = null;
    contextInstance.pinchStartScale = null;
    contextInstance.pinchStartDistance = null;
    contextInstance.isPinching = false;
    $c9b1aa9458d4ea13$var$handleAlignToScaleBounds(contextInstance, pinchMidpoint === null || pinchMidpoint === void 0 ? void 0 : pinchMidpoint.x, pinchMidpoint === null || pinchMidpoint === void 0 ? void 0 : pinchMidpoint.y);
};
var $c9b1aa9458d4ea13$var$handleDoubleClickStop = function(contextInstance, event) {
    var onZoomStop = contextInstance.props.onZoomStop;
    var animationTime = contextInstance.setup.doubleClick.animationTime;
    $c9b1aa9458d4ea13$var$cancelTimeout(contextInstance.doubleClickStopEventTimer);
    contextInstance.doubleClickStopEventTimer = setTimeout(function() {
        contextInstance.doubleClickStopEventTimer = null;
        $c9b1aa9458d4ea13$var$handleCallback($c9b1aa9458d4ea13$var$getContext(contextInstance), event, onZoomStop);
    }, animationTime);
};
var $c9b1aa9458d4ea13$var$handleDoubleClickResetMode = function(contextInstance, event) {
    var _a = contextInstance.props, onZoomStart = _a.onZoomStart, onZoom = _a.onZoom;
    var _b = contextInstance.setup.doubleClick, animationTime = _b.animationTime, animationType = _b.animationType;
    $c9b1aa9458d4ea13$var$handleCallback($c9b1aa9458d4ea13$var$getContext(contextInstance), event, onZoomStart);
    $c9b1aa9458d4ea13$var$resetTransformations(contextInstance, animationTime, animationType, function() {
        return $c9b1aa9458d4ea13$var$handleCallback($c9b1aa9458d4ea13$var$getContext(contextInstance), event, onZoom);
    });
    $c9b1aa9458d4ea13$var$handleDoubleClickStop(contextInstance, event);
};
function $c9b1aa9458d4ea13$var$getDoubleClickScale(mode, scale) {
    if (mode === "toggle") return scale === 1 ? 1 : -1;
    return mode === "zoomOut" ? -1 : 1;
}
function $c9b1aa9458d4ea13$var$handleDoubleClick(contextInstance, event) {
    var setup = contextInstance.setup, doubleClickStopEventTimer = contextInstance.doubleClickStopEventTimer, state = contextInstance.state, contentComponent = contextInstance.contentComponent;
    var scale = state.scale;
    var _a = contextInstance.props, onZoomStart = _a.onZoomStart, onZoom = _a.onZoom;
    var _b = setup.doubleClick, disabled = _b.disabled, mode = _b.mode, step = _b.step, animationTime = _b.animationTime, animationType = _b.animationType;
    if (disabled) return;
    if (doubleClickStopEventTimer) return;
    if (mode === "reset") return $c9b1aa9458d4ea13$var$handleDoubleClickResetMode(contextInstance, event);
    if (!contentComponent) return console.error("No ContentComponent found");
    var delta = $c9b1aa9458d4ea13$var$getDoubleClickScale(mode, contextInstance.state.scale);
    var newScale = $c9b1aa9458d4ea13$var$handleCalculateButtonZoom(contextInstance, delta, step);
    // stop execution when scale didn't change
    if (scale === newScale) return;
    $c9b1aa9458d4ea13$var$handleCallback($c9b1aa9458d4ea13$var$getContext(contextInstance), event, onZoomStart);
    var mousePosition = $c9b1aa9458d4ea13$var$getMousePosition(event, contentComponent, scale);
    var targetState = $c9b1aa9458d4ea13$var$handleZoomToPoint(contextInstance, newScale, mousePosition.x, mousePosition.y);
    if (!targetState) return console.error("Error during zoom event. New transformation state was not calculated.");
    $c9b1aa9458d4ea13$var$handleCallback($c9b1aa9458d4ea13$var$getContext(contextInstance), event, onZoom);
    $c9b1aa9458d4ea13$var$animate(contextInstance, targetState, animationTime, animationType);
    $c9b1aa9458d4ea13$var$handleDoubleClickStop(contextInstance, event);
}
var $c9b1aa9458d4ea13$var$isDoubleClickAllowed = function(contextInstance, event) {
    var isInitialized = contextInstance.isInitialized, setup = contextInstance.setup, wrapperComponent = contextInstance.wrapperComponent;
    var _a = setup.doubleClick, disabled = _a.disabled, excluded = _a.excluded;
    var target = event.target;
    var isWrapperChild = wrapperComponent === null || wrapperComponent === void 0 ? void 0 : wrapperComponent.contains(target);
    var isAllowed = isInitialized && target && isWrapperChild && !disabled;
    if (!isAllowed) return false;
    var isExcluded = $c9b1aa9458d4ea13$var$isExcludedNode(target, excluded);
    if (isExcluded) return false;
    return true;
};
var $c9b1aa9458d4ea13$var$ZoomPanPinch = /** @class */ function() {
    function ZoomPanPinch(props) {
        var _this = this;
        this.mounted = true;
        this.onChangeCallbacks = new Set();
        this.onInitCallbacks = new Set();
        this.onTransformCallbacks = new Set();
        // Components
        this.wrapperComponent = null;
        this.contentComponent = null;
        // Initialization
        this.isInitialized = false;
        this.bounds = null;
        // wheel helpers
        this.previousWheelEvent = null;
        this.wheelStopEventTimer = null;
        this.wheelAnimationTimer = null;
        // panning helpers
        this.isPanning = false;
        this.isWheelPanning = false;
        this.startCoords = null;
        this.panStartPosition = null;
        this.lastTouch = null;
        // pinch helpers
        this.isPinching = false;
        this.distance = null;
        this.lastDistance = null;
        this.pinchStartDistance = null;
        this.pinchStartScale = null;
        this.pinchMidpoint = null;
        this.pinchPreviousCenter = null;
        // double click helpers
        this.doubleClickStopEventTimer = null;
        // velocity helpers
        this.velocity = null;
        this.velocityTime = null;
        this.lastMousePosition = null;
        // animations helpers
        this.isAnimating = false;
        this.animation = null;
        // key press
        this.pressedKeys = {};
        this.mount = function() {
            _this.initializeWindowEvents();
        };
        this.unmount = function() {
            _this.cleanupWindowEvents();
        };
        this.update = function(newProps) {
            _this.props = newProps;
            if (_this.wrapperComponent && _this.contentComponent) $c9b1aa9458d4ea13$var$handleCalculateBounds(_this, _this.state.scale);
            _this.setup = $c9b1aa9458d4ea13$var$createSetup(newProps);
        };
        this.initializeWindowEvents = function() {
            var _a, _b, _c, _d;
            var passive = $c9b1aa9458d4ea13$var$makePassiveEventOption();
            var currentDocument = (_a = _this.wrapperComponent) === null || _a === void 0 ? void 0 : _a.ownerDocument;
            var currentWindow = currentDocument === null || currentDocument === void 0 ? void 0 : currentDocument.defaultView;
            (_b = _this.wrapperComponent) === null || _b === void 0 || _b.addEventListener("wheel", _this.onWheelPanning, passive);
            (_c = _this.wrapperComponent) === null || _c === void 0 || _c.addEventListener("keyup", _this.setKeyUnPressed, passive);
            (_d = _this.wrapperComponent) === null || _d === void 0 || _d.addEventListener("keydown", _this.setKeyPressed, passive);
            // Panning on window to allow panning when mouse is out of component wrapper
            currentWindow === null || currentWindow === void 0 || currentWindow.addEventListener("mousedown", _this.onPanningStart, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.addEventListener("mousemove", _this.onPanning, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.addEventListener("mouseup", _this.onPanningStop, passive);
            currentDocument === null || currentDocument === void 0 || currentDocument.addEventListener("mouseleave", _this.clearPanning, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.addEventListener("keyup", _this.setKeyUnPressed, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.addEventListener("keydown", _this.setKeyPressed, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.addEventListener("blur", _this.handleWindowBlur);
        };
        this.cleanupWindowEvents = function() {
            var _a, _b, _c, _d, _e;
            var passive = $c9b1aa9458d4ea13$var$makePassiveEventOption();
            var currentDocument = (_a = _this.wrapperComponent) === null || _a === void 0 ? void 0 : _a.ownerDocument;
            var currentWindow = currentDocument === null || currentDocument === void 0 ? void 0 : currentDocument.defaultView;
            currentWindow === null || currentWindow === void 0 || currentWindow.removeEventListener("mousedown", _this.onPanningStart, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.removeEventListener("mousemove", _this.onPanning, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.removeEventListener("mouseup", _this.onPanningStop, passive);
            currentDocument === null || currentDocument === void 0 || currentDocument.removeEventListener("mouseleave", _this.clearPanning, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.removeEventListener("keyup", _this.setKeyUnPressed, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.removeEventListener("keydown", _this.setKeyPressed, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.removeEventListener("blur", _this.handleWindowBlur);
            document.removeEventListener("mouseleave", _this.clearPanning, passive);
            (_b = _this.wrapperComponent) === null || _b === void 0 || _b.removeEventListener("wheel", _this.onWheelPanning, passive);
            (_c = _this.wrapperComponent) === null || _c === void 0 || _c.removeEventListener("keyup", _this.setKeyUnPressed, passive);
            (_d = _this.wrapperComponent) === null || _d === void 0 || _d.removeEventListener("keydown", _this.setKeyPressed, passive);
            $c9b1aa9458d4ea13$var$handleCancelAnimation(_this);
            (_e = _this.observer) === null || _e === void 0 || _e.disconnect();
        };
        this.handleInitializeWrapperEvents = function(wrapper) {
            // Zooming events on wrapper
            var passive = $c9b1aa9458d4ea13$var$makePassiveEventOption();
            wrapper.addEventListener("wheel", _this.onWheelZoom, passive);
            wrapper.addEventListener("dblclick", _this.onDoubleClick, passive);
            wrapper.addEventListener("touchstart", _this.onTouchPanningStart, passive);
            wrapper.addEventListener("touchmove", _this.onTouchPanning, passive);
            wrapper.addEventListener("touchend", _this.onTouchPanningStop, passive);
        };
        this.handleInitialize = function(contentComponent) {
            var centerOnInit = _this.setup.centerOnInit;
            _this.applyTransformation();
            _this.onInitCallbacks.forEach(function(callback) {
                return callback($c9b1aa9458d4ea13$var$getContext(_this));
            });
            if (centerOnInit) {
                _this.setCenter();
                _this.observer = new ResizeObserver(function() {
                    var _a;
                    var currentWidth = contentComponent.offsetWidth;
                    var currentHeight = contentComponent.offsetHeight;
                    if (currentWidth > 0 || currentHeight > 0) {
                        _this.onInitCallbacks.forEach(function(callback) {
                            return callback($c9b1aa9458d4ea13$var$getContext(_this));
                        });
                        _this.setCenter();
                        (_a = _this.observer) === null || _a === void 0 || _a.disconnect();
                    }
                });
                // TODO: CHANGE to first interaction?
                // if nothing about the contentComponent has changed after 5 seconds, disconnect the observer
                setTimeout(function() {
                    var _a;
                    (_a = _this.observer) === null || _a === void 0 || _a.disconnect();
                }, 5000);
                // Start observing the target node for configured mutations
                _this.observer.observe(contentComponent);
            }
        };
        /// ///////
        // Zoom
        /// ///////
        this.onWheelZoom = function(event) {
            var disabled = _this.setup.disabled;
            if (disabled) return;
            _this.syncModifierKeys(event);
            var isAllowed = $c9b1aa9458d4ea13$var$isWheelAllowed(_this, event);
            if (!isAllowed) return;
            $c9b1aa9458d4ea13$var$handleWheelStart(_this, event);
            $c9b1aa9458d4ea13$var$handleWheelZoom(_this, event);
            $c9b1aa9458d4ea13$var$handleWheelStop(_this, event);
        };
        /// ///////
        // Track Pad Panning
        /// ///////
        this.onWheelPanning = function(event) {
            var onPanning = _this.props.onPanning;
            var trackPadPanning = _this.setup.trackPadPanning;
            var lockAxisX = trackPadPanning.lockAxisX, lockAxisY = trackPadPanning.lockAxisY;
            _this.syncModifierKeys(event);
            var isAllowed = $c9b1aa9458d4ea13$var$isWheelPanningAllowed(_this, event);
            if (!isAllowed) return;
            if (event.cancelable) event.preventDefault();
            event.stopPropagation();
            var _a = _this.state, positionX = _a.positionX, positionY = _a.positionY;
            var mouseX = positionX - event.deltaX;
            var mouseY = positionY - event.deltaY;
            var newPositionX = lockAxisX ? positionX : mouseX;
            var newPositionY = lockAxisY ? positionY : mouseY;
            var _b = _this.setup.autoAlignment, sizeX = _b.sizeX, sizeY = _b.sizeY;
            var paddingValueX = $c9b1aa9458d4ea13$var$getPaddingValue(_this, sizeX);
            var paddingValueY = $c9b1aa9458d4ea13$var$getPaddingValue(_this, sizeY);
            if (newPositionX === positionX && newPositionY === positionY) return;
            $c9b1aa9458d4ea13$var$handleWheelPanningStart(_this, event);
            $c9b1aa9458d4ea13$var$handleNewPosition(_this, newPositionX, newPositionY, paddingValueX, paddingValueY);
            $c9b1aa9458d4ea13$var$handleCallback($c9b1aa9458d4ea13$var$getContext(_this), event, onPanning);
            $c9b1aa9458d4ea13$var$handleWheelPanningStop(_this, event);
        };
        /// ///////
        // Pan
        /// ///////
        this.onPanningStart = function(event) {
            var disabled = _this.setup.disabled;
            var onPanningStart = _this.props.onPanningStart;
            if (disabled) return;
            _this.syncModifierKeys(event);
            var isAllowed = $c9b1aa9458d4ea13$var$isPanningStartAllowed(_this, event);
            if (!isAllowed) return;
            var keysPressed = _this.isPressingKeys(_this.setup.panning.activationKeys);
            if (!keysPressed) return;
            if (event.button === 0 && !_this.setup.panning.allowLeftClickPan) return;
            if (event.button === 1 && !_this.setup.panning.allowMiddleClickPan) return;
            if (event.button === 2 && !_this.setup.panning.allowRightClickPan) return;
            if (event.cancelable) event.preventDefault();
            event.stopPropagation();
            $c9b1aa9458d4ea13$var$handleCancelAnimation(_this);
            $c9b1aa9458d4ea13$var$handlePanningStart(_this, event);
            $c9b1aa9458d4ea13$var$handleCallback($c9b1aa9458d4ea13$var$getContext(_this), event, onPanningStart);
        };
        this.onPanning = function(event) {
            var disabled = _this.setup.disabled;
            var onPanning = _this.props.onPanning;
            if (disabled) return;
            _this.syncModifierKeys(event);
            // Detect missed mouseup — e.g. when the mouse was released outside an
            // iframe boundary where the host frame swallows the mouseup event.
            if (_this.isPanning && event.buttons === 0) {
                _this.clearPanning(event);
                return;
            }
            var isAllowed = $c9b1aa9458d4ea13$var$isPanningAllowed(_this);
            if (!isAllowed) return;
            var keysPressed = _this.isPressingKeys(_this.setup.panning.activationKeys);
            if (!keysPressed) return;
            if (event.cancelable) event.preventDefault();
            event.stopPropagation();
            $c9b1aa9458d4ea13$var$handlePanning(_this, event.clientX, event.clientY, $c9b1aa9458d4ea13$export$ec1e04e4e5ef8233.MOUSE);
            $c9b1aa9458d4ea13$var$handleCallback($c9b1aa9458d4ea13$var$getContext(_this), event, onPanning);
        };
        this.onPanningStop = function(event) {
            var velocityDisabled = _this.setup.panning.velocityDisabled;
            var onPanningStop = _this.props.onPanningStop;
            if (_this.isPanning) {
                $c9b1aa9458d4ea13$var$handlePanningEnd(_this, velocityDisabled);
                $c9b1aa9458d4ea13$var$handleCallback($c9b1aa9458d4ea13$var$getContext(_this), event, onPanningStop);
            }
        };
        /// ///////
        // Pinch
        /// ///////
        this.onPinchStart = function(event) {
            var disabled = _this.setup.disabled;
            var onPinchStart = _this.props.onPinchStart;
            if (disabled) return;
            var isAllowed = $c9b1aa9458d4ea13$var$isPinchStartAllowed(_this, event);
            if (!isAllowed) return;
            $c9b1aa9458d4ea13$var$handlePinchStart(_this, event);
            $c9b1aa9458d4ea13$var$handleCancelAnimation(_this);
            $c9b1aa9458d4ea13$var$handleCallback($c9b1aa9458d4ea13$var$getContext(_this), event, onPinchStart);
        };
        this.onPinch = function(event) {
            var disabled = _this.setup.disabled;
            var onPinch = _this.props.onPinch;
            if (disabled) return;
            var isAllowed = $c9b1aa9458d4ea13$var$isPinchAllowed(_this);
            if (!isAllowed) return;
            if (event.cancelable) event.preventDefault();
            event.stopPropagation();
            $c9b1aa9458d4ea13$var$handlePinchZoom(_this, event);
            $c9b1aa9458d4ea13$var$handleCallback($c9b1aa9458d4ea13$var$getContext(_this), event, onPinch);
        };
        this.onPinchStop = function(event) {
            var onPinchStop = _this.props.onPinchStop;
            if (_this.pinchStartScale) {
                $c9b1aa9458d4ea13$var$handlePinchStop(_this);
                $c9b1aa9458d4ea13$var$handleCallback($c9b1aa9458d4ea13$var$getContext(_this), event, onPinchStop);
            }
        };
        /// ///////
        // Touch
        /// ///////
        this.onTouchPanningStart = function(event) {
            var _a = _this.setup, disabled = _a.disabled, doubleClick = _a.doubleClick;
            var onPanningStart = _this.props.onPanningStart;
            if (disabled) return;
            var isDoubleTapAllowed = !(doubleClick === null || doubleClick === void 0 ? void 0 : doubleClick.disabled);
            var isDoubleTap = _this.lastTouch && +new Date() - _this.lastTouch < 200;
            if (isDoubleTapAllowed && isDoubleTap && event.touches.length === 1) _this.onDoubleClick(event);
            else {
                _this.lastTouch = +new Date();
                $c9b1aa9458d4ea13$var$handleCancelAnimation(_this);
                var touches = event.touches;
                var isPanningAction = touches.length === 1;
                var isPinchAction = touches.length === 2;
                var isAllowed = $c9b1aa9458d4ea13$var$isPanningStartAllowed(_this, event);
                if (isPanningAction) {
                    if (!isAllowed) return;
                    $c9b1aa9458d4ea13$var$handleCancelAnimation(_this);
                    $c9b1aa9458d4ea13$var$handlePanningStart(_this, event);
                    $c9b1aa9458d4ea13$var$handleCallback($c9b1aa9458d4ea13$var$getContext(_this), event, onPanningStart);
                }
                if (isPinchAction) _this.onPinchStart(event);
            }
        };
        this.onTouchPanning = function(event) {
            var disabled = _this.setup.disabled;
            var onPanning = _this.props.onPanning;
            if (_this.isPanning && event.touches.length === 1) {
                if (disabled) return;
                var isAllowed = $c9b1aa9458d4ea13$var$isPanningAllowed(_this);
                if (!isAllowed) return;
                if (event.cancelable) event.preventDefault();
                event.stopPropagation();
                var touch = event.touches[0];
                $c9b1aa9458d4ea13$var$handlePanning(_this, touch.clientX, touch.clientY, $c9b1aa9458d4ea13$export$ec1e04e4e5ef8233.TOUCH);
                $c9b1aa9458d4ea13$var$handleCallback($c9b1aa9458d4ea13$var$getContext(_this), event, onPanning);
            } else if (event.touches.length > 1) _this.onPinch(event);
        };
        this.onTouchPanningStop = function(event) {
            _this.onPanningStop(event);
            _this.onPinchStop(event);
        };
        /// ///////
        // Double Click
        /// ///////
        this.onDoubleClick = function(event) {
            var disabled = _this.setup.disabled;
            if (disabled) return;
            var isAllowed = $c9b1aa9458d4ea13$var$isDoubleClickAllowed(_this, event);
            if (!isAllowed) return;
            $c9b1aa9458d4ea13$var$handleDoubleClick(_this, event);
        };
        /// ///////
        // Helpers
        /// ///////
        this.clearPanning = function(event) {
            if (_this.isPanning) _this.onPanningStop(event);
        };
        // When the window loses focus (e.g. user clicks outside an iframe),
        // keyup and mouseup events are swallowed by the parent frame. Clear all
        // tracked state to prevent stale activation keys or ghost panning.
        this.handleWindowBlur = function() {
            _this.pressedKeys = {};
            if (_this.isPanning) {
                _this.isPanning = false;
                _this.startCoords = null;
            }
        };
        // Iframe focus problem (e.g. Storybook):
        //
        // When the library runs inside an iframe, keyboard events (keydown/keyup)
        // only reach the iframe's window when it has focus. If the user navigates
        // via the host UI (e.g. Storybook sidebar) the iframe never receives
        // focus, so keydown never fires and activationKeys like Cmd/Ctrl are
        // invisible to pressedKeys.
        //
        // Mouse and wheel events, however, DO reach the iframe regardless of
        // focus — and they carry modifier flags (ctrlKey, metaKey, shiftKey,
        // altKey) that always reflect the real physical key state at event time.
        //
        // We sync those flags into pressedKeys on every interaction event so
        // that activationKeys checks work without requiring iframe focus.
        // Both pressed (true) AND released (false) states must be written;
        // writing only `true` would leave stale keys after release because
        // keyup never fires in an unfocused iframe.
        this.syncModifierKeys = function(event) {
            var ctrlKey = event.ctrlKey, metaKey = event.metaKey, shiftKey = event.shiftKey, altKey = event.altKey;
            if (typeof ctrlKey === "boolean") _this.pressedKeys.Control = ctrlKey;
            if (typeof metaKey === "boolean") _this.pressedKeys.Meta = metaKey;
            if (typeof shiftKey === "boolean") _this.pressedKeys.Shift = shiftKey;
            if (typeof altKey === "boolean") _this.pressedKeys.Alt = altKey;
        };
        this.setKeyPressed = function(e) {
            _this.pressedKeys[e.key] = true;
        };
        this.setKeyUnPressed = function(e) {
            _this.pressedKeys[e.key] = false;
        };
        this.isPressingKeys = function(keys) {
            if (typeof keys === "function") return keys(Object.entries(_this.pressedKeys).filter(function(_a) {
                var pressed = _a[1];
                return pressed;
            }).map(function(_a) {
                var key = _a[0];
                return key;
            }));
            if (!keys.length) return true;
            return Boolean(keys.every(function(key) {
                return _this.pressedKeys[key];
            }));
        };
        this.setCenter = function() {
            if (_this.wrapperComponent && _this.contentComponent) {
                var targetState = $c9b1aa9458d4ea13$export$a51b33620579dad4(_this.state.scale, _this.wrapperComponent, _this.contentComponent);
                _this.setState(targetState.scale, targetState.positionX, targetState.positionY);
            }
        };
        this.handleTransformStyles = function(x, y, scale) {
            if (_this.props.customTransform) return _this.props.customTransform(x, y, scale);
            return $c9b1aa9458d4ea13$export$c15ec262effbd456(x, y, scale);
        };
        this.getContext = function() {
            return $c9b1aa9458d4ea13$var$getContext(_this);
        };
        this.applyTransformation = function() {
            if (!_this.mounted || !_this.contentComponent) return;
            var _a = _this.state, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
            var transform = _this.handleTransformStyles(positionX, positionY, scale);
            // Detached mode do not apply transformation directly to content component
            if (!_this.props.detached) _this.contentComponent.style.transform = transform;
            _this.onTransformCallbacks.forEach(function(callback) {
                return callback({
                    scale: scale,
                    positionX: positionX,
                    positionY: positionY,
                    previousScale: _this.state.previousScale,
                    ref: $c9b1aa9458d4ea13$var$getContext(_this)
                });
            });
        };
        this.setState = function(scale, positionX, positionY) {
            var onTransform = _this.props.onTransform;
            if (!Number.isNaN(scale) && !Number.isNaN(positionX) && !Number.isNaN(positionY)) {
                var safeScale = Math.max(scale, 1e-7);
                if (safeScale !== _this.state.scale) {
                    _this.state.previousScale = _this.state.scale;
                    _this.state.scale = safeScale;
                }
                _this.state.positionX = positionX;
                _this.state.positionY = positionY;
                _this.applyTransformation();
                var ctx_1 = $c9b1aa9458d4ea13$var$getContext(_this);
                _this.onChangeCallbacks.forEach(function(callback) {
                    return callback(ctx_1);
                });
                $c9b1aa9458d4ea13$var$handleCallback(ctx_1, {
                    scale: _this.state.scale,
                    positionX: positionX,
                    positionY: positionY
                }, onTransform);
            } else console.error("Detected NaN set state values");
        };
        /**
         * Hooks
         */ this.onTransform = function(callback) {
            if (!_this.onTransformCallbacks.has(callback)) _this.onTransformCallbacks.add(callback);
            return function() {
                _this.onTransformCallbacks.delete(callback);
            };
        };
        this.onChange = function(callback) {
            if (!_this.onChangeCallbacks.has(callback)) _this.onChangeCallbacks.add(callback);
            return function() {
                _this.onChangeCallbacks.delete(callback);
            };
        };
        this.onInit = function(callback) {
            if (!_this.onInitCallbacks.has(callback)) _this.onInitCallbacks.add(callback);
            return function() {
                _this.onInitCallbacks.delete(callback);
            };
        };
        /**
         * Initialization
         */ this.init = function(wrapperComponent, contentComponent) {
            _this.cleanupWindowEvents();
            _this.wrapperComponent = wrapperComponent;
            _this.contentComponent = contentComponent;
            $c9b1aa9458d4ea13$var$handleCalculateBounds(_this, _this.state.scale);
            _this.handleInitializeWrapperEvents(wrapperComponent);
            _this.handleInitialize(contentComponent);
            _this.initializeWindowEvents();
            _this.isInitialized = true;
            var ctx = $c9b1aa9458d4ea13$var$getContext(_this);
            $c9b1aa9458d4ea13$var$handleCallback(ctx, undefined, _this.props.onInit);
            $c9b1aa9458d4ea13$var$assignRef(_this.props.ref, ctx);
        };
        this.props = props;
        this.setup = $c9b1aa9458d4ea13$var$createSetup(this.props);
        this.state = $c9b1aa9458d4ea13$var$createState(this.props);
    }
    return ZoomPanPinch;
}();
var $c9b1aa9458d4ea13$export$841858b892ce1f4c = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createContext(null);
var $c9b1aa9458d4ea13$var$getContent = function(children, ctx) {
    if (typeof children === "function") return children(ctx);
    return children;
};
var $c9b1aa9458d4ea13$export$51cb649375dcd655 = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).forwardRef(function(props, ref) {
    var instance = (0, $cQmXV.useRef)(new $c9b1aa9458d4ea13$var$ZoomPanPinch(props)).current;
    var content = $c9b1aa9458d4ea13$var$getContent(props.children, $c9b1aa9458d4ea13$var$getControls(instance));
    (0, $cQmXV.useImperativeHandle)(ref, function() {
        return $c9b1aa9458d4ea13$var$getControls(instance);
    }, [
        instance
    ]);
    (0, $cQmXV.useEffect)(function() {
        instance.update(props);
    }, [
        instance,
        props
    ]);
    return (0, $575603080129eb00$exports.jsx)($c9b1aa9458d4ea13$export$841858b892ce1f4c.Provider, $c9b1aa9458d4ea13$var$__assign({
        value: instance
    }, {
        children: content
    }));
});
var $c9b1aa9458d4ea13$export$cbc53e226f857b23 = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).forwardRef(function(props, ref) {
    var localRef = (0, $cQmXV.useRef)(null);
    var instance = (0, $cQmXV.useContext)($c9b1aa9458d4ea13$export$841858b892ce1f4c);
    (0, $cQmXV.useEffect)(function() {
        return instance.onChange(function(ctx) {
            if (localRef.current) {
                var positionX = 0;
                var positionY = 0;
                localRef.current.style.transform = instance.handleTransformStyles(positionX, positionY, 1 / ctx.instance.state.scale);
            }
        });
    }, [
        instance
    ]);
    return (0, $575603080129eb00$exports.jsx)("div", $c9b1aa9458d4ea13$var$__assign({}, props, {
        ref: $c9b1aa9458d4ea13$var$mergeRefs([
            localRef,
            ref
        ])
    }));
});
var $c9b1aa9458d4ea13$var$initialElementRect = {
    width: 0,
    height: 0,
    y: 0,
    x: 0,
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
};
var $c9b1aa9458d4ea13$var$useResize = function(ref, onResize, dependencies) {
    var resizeObserverRef = (0, $cQmXV.useRef)();
    var rectRef = (0, $cQmXV.useRef)($c9b1aa9458d4ea13$var$initialElementRect);
    var didUnmount = (0, $cQmXV.useRef)(false);
    (0, $cQmXV.useLayoutEffect)(function() {
        var _a;
        didUnmount.current = false;
        if (!("ResizeObserver" in window)) return;
        if (ref) {
            resizeObserverRef.current = new ResizeObserver(function(entries) {
                var newSize = ref.getBoundingClientRect();
                if (!Array.isArray(entries) || !entries.length || didUnmount.current || newSize.width === rectRef.current.width && newSize.height === rectRef.current.height) return;
                onResize(newSize, ref);
                rectRef.current = newSize;
            });
            (_a = resizeObserverRef.current) === null || _a === void 0 || _a.observe(ref);
        }
        return function() {
            var _a;
            didUnmount.current = true;
            if (ref) (_a = resizeObserverRef.current) === null || _a === void 0 || _a.unobserve(ref);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $c9b1aa9458d4ea13$var$__spreadArray([
        onResize,
        ref
    ], dependencies, true));
};
var $c9b1aa9458d4ea13$var$previewStyles = {
    position: "absolute",
    zIndex: 2,
    top: "0px",
    left: "0px",
    boxSizing: "border-box",
    border: "3px solid red",
    transformOrigin: "0% 0%",
    boxShadow: "rgba(0,0,0,0.2) 0 0 0 10000000px",
    pointerEvents: "none"
};
var $c9b1aa9458d4ea13$export$a97dd8f3835953ef = function(_a) {
    var _b = _a.width, width = _b === void 0 ? 200 : _b, _c = _a.height, height = _c === void 0 ? 200 : _c, _d = _a.borderColor, borderColor = _d === void 0 ? "red" : _d, previewStyle = _a.previewStyle, wrapperClassName = _a.wrapperClassName, previewClassName = _a.previewClassName, children = _a.children, _e = _a.panning, panning = _e === void 0 ? true : _e, rest = $c9b1aa9458d4ea13$var$__rest(_a, [
        "width",
        "height",
        "borderColor",
        "previewStyle",
        "wrapperClassName",
        "previewClassName",
        "children",
        "panning"
    ]);
    var _f = (0, $cQmXV.useState)(false), initialized = _f[0], setInitialized = _f[1];
    var instance = $c9b1aa9458d4ea13$export$1708b11af87412f8();
    var _g = (0, $cQmXV.useState)(false), isDown = _g[0], setIsDown = _g[1];
    var miniMapInstance = (0, $cQmXV.useRef)(null);
    var mainRef = (0, $cQmXV.useRef)(null);
    var wrapperRef = (0, $cQmXV.useRef)(null);
    var previewRef = (0, $cQmXV.useRef)(null);
    var getViewportSize = (0, $cQmXV.useCallback)(function() {
        if (instance.wrapperComponent) {
            var rect = instance.wrapperComponent.getBoundingClientRect();
            return {
                width: rect.width,
                height: rect.height
            };
        }
        return {
            width: 0,
            height: 0
        };
    }, [
        instance.wrapperComponent
    ]);
    var getContentSize = (0, $cQmXV.useCallback)(function() {
        if (instance.contentComponent) {
            var rect = instance.contentComponent.getBoundingClientRect();
            return {
                width: rect.width / instance.state.scale,
                height: rect.height / instance.state.scale
            };
        }
        return {
            width: 0,
            height: 0
        };
    }, [
        instance.contentComponent,
        instance.state.scale
    ]);
    var computeMiniMapScale = (0, $cQmXV.useCallback)(function() {
        var contentSize = getContentSize();
        var scaleX = width / contentSize.width;
        var scaleY = height / contentSize.height;
        var scale = scaleY > scaleX ? scaleX : scaleY;
        return scale;
    }, [
        getContentSize,
        height,
        width
    ]);
    var computeMiniMapSize = function() {
        var contentSize = getContentSize();
        var scaleX = width / contentSize.width;
        var scaleY = height / contentSize.height;
        if (scaleY > scaleX) return {
            width: width,
            height: contentSize.height * scaleX
        };
        return {
            width: contentSize.width * scaleY,
            height: height
        };
    };
    var computeMiniMapStyle = function() {
        var scale = computeMiniMapScale();
        var style = {
            transform: "scale(".concat(scale || 1, ")"),
            transformOrigin: "0% 0%",
            position: "absolute",
            boxSizing: "border-box",
            zIndex: 1
        };
        if (wrapperRef.current) {
            var el = wrapperRef.current.style;
            el.transform = style.transform;
            el.transformOrigin = style.transformOrigin;
            el.position = style.position;
            el.boxSizing = style.boxSizing;
            el.zIndex = String(style.zIndex);
        }
    };
    var transformMiniMap = function() {
        computeMiniMapStyle();
        var miniSize = computeMiniMapSize();
        var wrapSize = getContentSize();
        if (wrapperRef.current) {
            wrapperRef.current.style.width = "".concat(wrapSize.width, "px");
            wrapperRef.current.style.height = "".concat(wrapSize.height, "px");
        }
        if (mainRef.current) {
            mainRef.current.style.width = "".concat(miniSize.width, "px");
            mainRef.current.style.height = "".concat(miniSize.height, "px");
        }
        if (previewRef.current) {
            var size = getViewportSize();
            var scale = computeMiniMapScale();
            var previewScale = scale * (1 / instance.state.scale);
            var transform = instance.handleTransformStyles(-instance.state.positionX * previewScale, -instance.state.positionY * previewScale, 1);
            previewRef.current.style.transform = transform;
            previewRef.current.style.width = "".concat(size.width * previewScale, "px");
            previewRef.current.style.height = "".concat(size.height * previewScale, "px");
        }
    };
    var initialize = function() {
        transformMiniMap();
    };
    $c9b1aa9458d4ea13$export$769cca75086a299c(function() {
        transformMiniMap();
    });
    $c9b1aa9458d4ea13$export$e14839139473133b(function() {
        initialize();
        setInitialized(true);
    });
    $c9b1aa9458d4ea13$var$useResize(instance.contentComponent, initialize, [
        initialized
    ]);
    (0, $cQmXV.useEffect)(function() {
        return instance.onChange(function(zpp) {
            var scale = computeMiniMapScale();
            if (miniMapInstance.current) {
                miniMapInstance.current.instance.state.scale = zpp.instance.state.scale;
                miniMapInstance.current.instance.state.positionX = zpp.instance.state.positionX * scale;
                miniMapInstance.current.instance.state.positionY = zpp.instance.state.positionY * scale;
            }
        });
    }, [
        computeMiniMapScale,
        instance,
        miniMapInstance
    ]);
    (0, $cQmXV.useEffect)(function() {
        var move = function(e) {
            var _a, _b;
            if (panning && isDown && instance.contentComponent && previewRef.current && mainRef.current) {
                var scale = computeMiniMapScale();
                var previewRect = previewRef.current.getBoundingClientRect();
                var mainRect = mainRef.current.getBoundingClientRect();
                var relativeX = (e.clientX - mainRect.left) / scale;
                var relativeY = (e.clientY - mainRect.top) / scale;
                var x = relativeX - previewRect.width / 2;
                var y = relativeY - previewRect.height / 2;
                var instanceWidth = (((_a = instance.wrapperComponent) === null || _a === void 0 ? void 0 : _a.offsetWidth) || 0) * instance.state.scale;
                var instanceHeight = (((_b = instance.wrapperComponent) === null || _b === void 0 ? void 0 : _b.offsetHeight) || 0) * instance.state.scale;
                var limitWidth = instanceWidth - previewRect.width * 2 * instance.state.scale;
                var limitHeight = instanceHeight - previewRect.height * 2 * instance.state.scale;
                var boundedX = $c9b1aa9458d4ea13$var$boundLimiter(x * instance.state.scale, 0, limitWidth, true);
                var boundedY = $c9b1aa9458d4ea13$var$boundLimiter(y * instance.state.scale, 0, limitHeight, true);
                instance.setState(instance.state.scale, -boundedX, -boundedY);
            }
        };
        var setDown = function(e) {
            var _a;
            if (((_a = mainRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target)) || e.target === mainRef.current) {
                move(e);
                setIsDown(true);
            }
        };
        var setUp = function() {
            setIsDown(false);
        };
        document.addEventListener("mousedown", setDown);
        document.addEventListener("mouseup", setUp);
        document.addEventListener("mousemove", move);
        return function() {
            document.removeEventListener("mousemove", move);
            document.removeEventListener("mouseup", setUp);
        };
    });
    var wrapperStyle = (0, $cQmXV.useMemo)(function() {
        return {
            position: "relative",
            zIndex: 2,
            // overflow: "hidden",
            userSelect: "none"
        };
    }, []);
    return (0, $575603080129eb00$exports.jsxs)("div", $c9b1aa9458d4ea13$var$__assign({}, rest, {
        ref: mainRef,
        style: wrapperStyle,
        className: "rzpp-mini-map ".concat(rest.className || "").trim()
    }, {
        children: [
            (0, $575603080129eb00$exports.jsx)("div", $c9b1aa9458d4ea13$var$__assign({
                style: {
                    pointerEvents: "none"
                },
                ref: wrapperRef,
                className: "rzpp-minimap-wrapper ".concat(wrapperClassName || "").trim()
            }, {
                children: children
            })),
            (0, $575603080129eb00$exports.jsx)("div", {
                className: "rzpp-minimap-preview ".concat(previewClassName || "").trim(),
                ref: previewRef,
                style: $c9b1aa9458d4ea13$var$__assign($c9b1aa9458d4ea13$var$__assign($c9b1aa9458d4ea13$var$__assign({}, $c9b1aa9458d4ea13$var$previewStyles), {
                    borderColor: borderColor
                }), previewStyle)
            })
        ]
    }));
};
function $c9b1aa9458d4ea13$var$styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") return;
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) head.insertBefore(style, head.firstChild);
        else head.appendChild(style);
    } else head.appendChild(style);
    if (style.styleSheet) style.styleSheet.cssText = css;
    else style.appendChild(document.createTextNode(css));
}
var $c9b1aa9458d4ea13$var$css_248z = ".transform-component-module_wrapper__SPB86 {\n  position: relative;\n  width: -moz-fit-content;\n  width: fit-content;\n  height: -moz-fit-content;\n  height: fit-content;\n  overflow: hidden;\n  -webkit-touch-callout: none; /* iOS Safari */\n  -webkit-user-select: none; /* Safari */\n  -khtml-user-select: none; /* Konqueror HTML */\n  -moz-user-select: none; /* Firefox */\n  -ms-user-select: none; /* Internet Explorer/Edge */\n  user-select: none;\n  margin: 0;\n  padding: 0;\n  transform: translate3d(0, 0, 0);\n}\n.transform-component-module_content__FBWxo {\n  display: flex;\n  flex-wrap: wrap;\n  width: -moz-fit-content;\n  width: fit-content;\n  height: -moz-fit-content;\n  height: fit-content;\n  margin: 0;\n  padding: 0;\n  transform-origin: 0% 0%;\n}\n.transform-component-module_content__FBWxo img {\n  pointer-events: none;\n}\n.transform-component-module_infiniteGrid__Z-aP3 {\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  background-image: radial-gradient(\n    circle,\n    rgba(0, 0, 0, 0.12) 1px,\n    transparent 1px\n  );\n  background-size: 20px 20px;\n  background-position: 0 0;\n}\n";
var $c9b1aa9458d4ea13$var$styles = {
    "wrapper": "transform-component-module_wrapper__SPB86",
    "content": "transform-component-module_content__FBWxo",
    "infiniteGrid": "transform-component-module_infiniteGrid__Z-aP3"
};
$c9b1aa9458d4ea13$var$styleInject($c9b1aa9458d4ea13$var$css_248z);
var $c9b1aa9458d4ea13$export$1def2aa75b7c7fe0 = function(_a) {
    var children = _a.children, _b = _a.wrapperClass, wrapperClass = _b === void 0 ? "" : _b, _c = _a.contentClass, contentClass = _c === void 0 ? "" : _c, wrapperStyle = _a.wrapperStyle, contentStyle = _a.contentStyle, _d = _a.wrapperProps, wrapperProps = _d === void 0 ? {} : _d, _e = _a.contentProps, contentProps = _e === void 0 ? {} : _e, _f = _a.infinite, infinite = _f === void 0 ? false : _f;
    var instance = (0, $cQmXV.useContext)($c9b1aa9458d4ea13$export$841858b892ce1f4c);
    var init = instance.init, cleanupWindowEvents = instance.cleanupWindowEvents;
    var wrapperRef = (0, $cQmXV.useRef)(null);
    var contentRef = (0, $cQmXV.useRef)(null);
    var gridRef = (0, $cQmXV.useRef)(null);
    (0, $cQmXV.useEffect)(function() {
        var wrapper = wrapperRef.current;
        var content = contentRef.current;
        if (wrapper !== null && content !== null && init) init === null || init === void 0 || init(wrapper, content);
        return function() {
            cleanupWindowEvents === null || cleanupWindowEvents === void 0 || cleanupWindowEvents();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $cQmXV.useEffect)(function() {
        if (!infinite) return;
        var grid = gridRef.current;
        if (!grid) return;
        var sync = function() {
            var _a = instance.state, positionX = _a.positionX, positionY = _a.positionY;
            grid.style.backgroundPosition = "".concat(positionX, "px ").concat(positionY, "px");
        };
        sync();
        return instance.onChange(sync);
    }, [
        infinite,
        instance
    ]);
    return (0, $575603080129eb00$exports.jsxs)("div", $c9b1aa9458d4ea13$var$__assign({}, wrapperProps, {
        ref: wrapperRef,
        className: "".concat($c9b1aa9458d4ea13$var$baseClasses.wrapperClass, " ").concat($c9b1aa9458d4ea13$var$styles.wrapper, " ").concat(wrapperClass),
        style: wrapperStyle
    }, {
        children: [
            infinite && (0, $575603080129eb00$exports.jsx)("div", {
                ref: gridRef,
                className: $c9b1aa9458d4ea13$var$styles.infiniteGrid,
                "aria-hidden": true
            }),
            (0, $575603080129eb00$exports.jsx)("div", $c9b1aa9458d4ea13$var$__assign({}, contentProps, {
                ref: contentRef,
                className: "".concat($c9b1aa9458d4ea13$var$baseClasses.contentClass, " ").concat($c9b1aa9458d4ea13$var$styles.content, " ").concat(contentClass),
                style: $c9b1aa9458d4ea13$var$__assign($c9b1aa9458d4ea13$var$__assign({}, contentStyle), {
                    transform: $c9b1aa9458d4ea13$export$c15ec262effbd456(instance.state.positionX, instance.state.positionY, instance.state.scale)
                })
            }, {
                children: children
            }))
        ]
    }));
};
/**
 * Compute the overlap area between two axis-aligned rectangles.
 * Returns 0 when the rectangles do not intersect.
 */ function $c9b1aa9458d4ea13$var$getOverlapArea(a, b) {
    var overlapX = Math.max(0, Math.min(a.x + a.width, b.x + b.width) - Math.max(a.x, b.x));
    var overlapY = Math.max(0, Math.min(a.y + a.height, b.y + b.height) - Math.max(a.y, b.y));
    return overlapX * overlapY;
}
/**
 * Determine whether an element's content-space bounding box is visible
 * in the current viewport, accounting for transform, margin, and threshold.
 */ function $c9b1aa9458d4ea13$var$isElementVisible(opts) {
    var elementX = opts.elementX, elementY = opts.elementY, elementWidth = opts.elementWidth, elementHeight = opts.elementHeight, scale = opts.scale, positionX = opts.positionX, positionY = opts.positionY, viewportWidth = opts.viewportWidth, viewportHeight = opts.viewportHeight, _a = opts.margin, margin = _a === void 0 ? 0 : _a, _b = opts.threshold, threshold = _b === void 0 ? 0 : _b;
    var viewport = {
        x: -margin,
        y: -margin,
        width: viewportWidth + 2 * margin,
        height: viewportHeight + 2 * margin
    };
    var element = {
        x: elementX * scale + positionX,
        y: elementY * scale + positionY,
        width: elementWidth * scale,
        height: elementHeight * scale
    };
    if (threshold <= 0) {
        var intersectsX = element.x < viewport.x + viewport.width && element.x + element.width > viewport.x;
        var intersectsY = element.y < viewport.y + viewport.height && element.y + element.height > viewport.y;
        return intersectsX && intersectsY;
    }
    var elementArea = element.width * element.height;
    if (elementArea <= 0) return false;
    var overlap = $c9b1aa9458d4ea13$var$getOverlapArea(viewport, element);
    return overlap / elementArea >= threshold;
}
var $c9b1aa9458d4ea13$export$f816dd0f57b7992e = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).forwardRef(function(_a, ref) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height, _b = _a.margin, margin = _b === void 0 ? 0 : _b, _c = _a.threshold, threshold = _c === void 0 ? 0 : _c, _d = _a.placeholder, placeholder = _d === void 0 ? null : _d, onShow = _a.onShow, onHide = _a.onHide, children = _a.children, className = _a.className, style = _a.style;
    var instance = (0, $cQmXV.useContext)($c9b1aa9458d4ea13$export$841858b892ce1f4c);
    var _e = (0, $cQmXV.useState)(false), visible = _e[0], setVisible = _e[1];
    var visibleRef = (0, $cQmXV.useRef)(false);
    var onShowRef = (0, $cQmXV.useRef)(onShow);
    var onHideRef = (0, $cQmXV.useRef)(onHide);
    onShowRef.current = onShow;
    onHideRef.current = onHide;
    (0, $cQmXV.useEffect)(function() {
        var check = function() {
            var _a, _b;
            var wrapper = instance.wrapperComponent;
            if (!wrapper) return;
            var nowVisible = $c9b1aa9458d4ea13$var$isElementVisible({
                elementX: x,
                elementY: y,
                elementWidth: width,
                elementHeight: height,
                scale: instance.state.scale,
                positionX: instance.state.positionX,
                positionY: instance.state.positionY,
                viewportWidth: wrapper.offsetWidth,
                viewportHeight: wrapper.offsetHeight,
                margin: margin,
                threshold: threshold
            });
            if (nowVisible !== visibleRef.current) {
                visibleRef.current = nowVisible;
                setVisible(nowVisible);
                if (nowVisible) (_a = onShowRef.current) === null || _a === void 0 || _a.call(onShowRef);
                else (_b = onHideRef.current) === null || _b === void 0 || _b.call(onHideRef);
            }
        };
        check();
        var unsubChange = instance.onChange(check);
        var unsubInit;
        if (!instance.wrapperComponent) unsubInit = instance.onInit(function() {
            return check();
        });
        return function() {
            unsubChange();
            unsubInit === null || unsubInit === void 0 || unsubInit();
        };
    }, [
        instance,
        x,
        y,
        width,
        height,
        margin,
        threshold
    ]);
    if (!visible) // eslint-disable-next-line react/jsx-no-useless-fragment
    return placeholder ? (0, $575603080129eb00$exports.jsx)((0, $575603080129eb00$exports.Fragment), {
        children: placeholder
    }) : null;
    return (0, $575603080129eb00$exports.jsx)("div", $c9b1aa9458d4ea13$var$__assign({
        ref: ref,
        className: className,
        style: style
    }, {
        children: children
    }));
});
var $c9b1aa9458d4ea13$export$1708b11af87412f8 = function() {
    var libraryContext = (0, $cQmXV.useContext)($c9b1aa9458d4ea13$export$841858b892ce1f4c);
    if (!libraryContext) throw new Error("Transform context must be placed inside TransformWrapper");
    return libraryContext;
};
var $c9b1aa9458d4ea13$export$8a75c83865bcf9dd = function() {
    var libraryContext = $c9b1aa9458d4ea13$export$1708b11af87412f8();
    return $c9b1aa9458d4ea13$var$getControls(libraryContext);
};
var $c9b1aa9458d4ea13$export$e14839139473133b = function(callback) {
    var libraryContext = $c9b1aa9458d4ea13$export$1708b11af87412f8();
    (0, $cQmXV.useEffect)(function() {
        var unmountCallback;
        var unmount;
        if (libraryContext.contentComponent && libraryContext.wrapperComponent) unmountCallback = callback($c9b1aa9458d4ea13$var$getState(libraryContext));
        else unmount = libraryContext.onInit(function(ref) {
            unmountCallback = callback($c9b1aa9458d4ea13$var$getState(ref.instance));
        });
        return function() {
            unmount === null || unmount === void 0 || unmount();
            unmountCallback === null || unmountCallback === void 0 || unmountCallback();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
var $c9b1aa9458d4ea13$export$769cca75086a299c = function(callback) {
    var libraryContext = $c9b1aa9458d4ea13$export$1708b11af87412f8();
    (0, $cQmXV.useEffect)(function() {
        var unmountCallback;
        var unmount = libraryContext.onChange(function(ref) {
            unmountCallback = callback($c9b1aa9458d4ea13$var$getState(ref.instance));
        });
        return function() {
            unmount();
            unmountCallback === null || unmountCallback === void 0 || unmountCallback();
        };
    }, [
        callback,
        libraryContext
    ]);
};
function $c9b1aa9458d4ea13$export$4915c4f91c47b682(callback) {
    var libraryContext = $c9b1aa9458d4ea13$export$1708b11af87412f8();
    var _a = (0, $cQmXV.useState)(callback($c9b1aa9458d4ea13$var$getState(libraryContext))), transformRender = _a[0], setTransformRender = _a[1];
    (0, $cQmXV.useEffect)(function() {
        var mounted = true;
        var unmount = libraryContext.onChange(function(ref) {
            if (mounted) setTransformRender(callback($c9b1aa9458d4ea13$var$getState(ref.instance)));
        });
        return function() {
            unmount();
            mounted = false;
        };
    }, [
        callback,
        libraryContext
    ]);
    return transformRender;
}








/* Small pieces shared by the photo-report grid and its review modal. */ 
parcelRequire("cQmXV");




const $c9fa058dfa50f419$export$1094b4db5e23d27c = (item)=>item?.approval?.is_approved === true ? "approved" : item?.approval?.is_approved === false ? "rejected" : "pending";
const $c9fa058dfa50f419$export$1d6cfa7493842c29 = (user)=>user ? [
        user.first_name,
        user.last_name
    ].filter(Boolean).join(" ") : "";
const $c9fa058dfa50f419$export$f6a098653d630c23 = (name)=>(name || "").split(" ").filter(Boolean).map((word)=>word[0]).slice(0, 2).join("").toUpperCase();
/* Tint + `-700` label + an icon: colour is never the only signal (spec/01). */ const $c9fa058dfa50f419$var$PILL = {
    approved: {
        tone: "ok",
        Icon: (0, $45839ed7c4a7faa2$export$2e2bcd8739ae039),
        key: "status_approved"
    },
    rejected: {
        tone: "no",
        Icon: (0, $bdfb1f797481a352$export$2e2bcd8739ae039),
        key: "status_rejected"
    },
    pending: {
        tone: "wait",
        Icon: (0, $7b23ac4854de9809$export$2e2bcd8739ae039),
        key: "status_pending"
    }
};
function $c9fa058dfa50f419$export$44918318b8113b6b({ status: status, lang: lang, inline: inline }) {
    const { tone: tone, Icon: Icon, key: key } = $c9fa058dfa50f419$var$PILL[status] || $c9fa058dfa50f419$var$PILL.pending;
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $602120e6d17ff12a$export$2e2bcd8739ae039), {
        variant: "filled",
        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)(Icon, {}),
        className: `status-tag status-tag--${tone} pr-pill${inline ? " pr-pill--inline" : ""}`,
        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b8441a9a81ffc5d6), key, lang)
    });
}


/**
 * The rail's label/value groups: antd `<Descriptions>`, per spec/02 ("Key/value read-only →
 * `<Descriptions>`", "Detail modal → `<Modal>` + `<Descriptions>`").
 *
 * `vertical` is the design's stacked pair. Rows with no value are dropped BEFORE the items array
 * is handed over — `Descriptions` renders whatever it is given, so an absent brand or price would
 * otherwise show as a label above an empty line. That filtering is the one behaviour the old
 * hand-built `Kv` had that antd does not.
 */ function $bc657e1ecc306871$var$Facts({ rows: rows }) {
    const items = rows.filter((row)=>row && row.children !== null && row.children !== undefined && row.children !== "" && row.children !== false).map((row, i)=>({
            key: String(i),
            ...row
        }));
    if (!items.length) return null;
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $47da64cf901a0567$export$2e2bcd8739ae039), {
        className: "pr-facts",
        column: 1,
        size: "small",
        layout: "vertical",
        colon: false,
        items: items
    });
}
function $bc657e1ecc306871$export$2e2bcd8739ae039({ item: item, position: position, total: total, lang: lang, busy: busy, onClose: onClose, onPrev: onPrev, onNext: onNext, onApprove: onApprove, onReject: onReject }) {
    const t = (key, group = (0, $fc3f36407bc5ec6c$export$b8441a9a81ffc5d6))=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)(group, key, lang);
    const [photoIndex, setPhotoIndex] = (0, $cQmXV.useState)(0);
    /* The linked task lives on a different record; fetched only when this modal is open and only
     for answer-type reports, per the hydrate-on-demand rule (spec/03). */ const [answer, setAnswer] = (0, $cQmXV.useState)(null);
    const [answerLoading, setAnswerLoading] = (0, $cQmXV.useState)(false);
    const photos = item.photo || [];
    const currentPhoto = photos[Math.min(photoIndex, photos.length - 1)];
    /* `null` for the bundled placeholder `imgGroup()` substitutes when a report carries no usable
     photo — opening it or pasting its link into a ticket would hand someone a link to our own
     "no photo" asset. Absolutised so a relative src (none today) still copies as a usable link. */ const photoHref = currentPhoto && currentPhoto !== (0, (/*@__PURE__*/$parcel$interopDefault($aa2d6dc1bd01cabc$exports))) ? new URL(currentPhoto, window.location.href).href : null;
    const status = (0, $c9fa058dfa50f419$export$1094b4db5e23d27c)(item);
    const info = item.additional_info || {};
    const point = item.visit?.point;
    /* Pulled out as plain locals so the hook dependencies below are statically checkable. */ const itemId = item.id;
    const objectId = item.picsell_info?.object_id;
    const objectType = item.picsell_info?.object_type;
    const dateTime = (value)=>value ? new Intl.DateTimeFormat((0, $7d0f78de0b68a104$export$bd7bed267fc278f2)(lang), {
            dateStyle: "medium",
            timeStyle: "short"
        }).format(new Date(value)) : "";
    (0, $cQmXV.useEffect)(()=>setPhotoIndex(0), [
        itemId
    ]);
    (0, $cQmXV.useEffect)(()=>{
        if (objectType !== "answer" || !objectId) {
            setAnswer(null);
            return;
        }
        setAnswer(null);
        setAnswerLoading(true);
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "GET",
            url: `answers/${objectId}/`
        }, (data)=>{
            setAnswer(data && data.task ? data : null);
            setAnswerLoading(false);
        });
    }, [
        objectId,
        objectType
    ]);
    /* Keyboard drives the queue. Bound on the document rather than the dialog so it works
     wherever focus happens to sit inside the modal; Esc is antd's own. */ (0, $cQmXV.useEffect)(()=>{
        const onKey = (event)=>{
            if (event.metaKey || event.ctrlKey || event.altKey) return;
            const tag = document.activeElement?.tagName;
            if (tag === "INPUT" || tag === "TEXTAREA") return;
            if (event.key === "ArrowRight") onNext();
            else if (event.key === "ArrowLeft") onPrev();
            else if (event.key === "a" || event.key === "A") onApprove();
            else if (event.key === "r" || event.key === "R") onReject();
            else return;
            event.preventDefault();
        };
        document.addEventListener("keydown", onKey);
        return ()=>document.removeEventListener("keydown", onKey);
    }, [
        onNext,
        onPrev,
        onApprove,
        onReject
    ]);
    /* `navigator.clipboard` is undefined outside a secure context, and `writeText` rejects when the
     permission is refused — both land in the same catch rather than failing silently. */ const copyLink = async ()=>{
        try {
            await navigator.clipboard.writeText(photoHref);
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success(t("link_copied"));
        } catch  {
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).error(t("link_copy_failed"));
        }
    };
    const visitStart = dateTime(item.visit?.start);
    const visitEnd = dateTime(item.visit?.end);
    const approvedAt = dateTime(item.approval?.approved_at);
    const tags = Array.isArray(info.tags) ? info.tags : typeof info.tags === "string" && info.tags ? [
        info.tags
    ] : [];
    const title = /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
        className: "pr-modal__head",
        align: "center",
        gap: "middle",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Title, {
                level: 4,
                className: "pr-modal__title",
                children: `${t("review_title")} \xb7 #${item.id}`
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                type: "secondary",
                className: "pr-modal__pos",
                children: (0, $3b579ca6158bc61b$export$9563e054e6f787fb)(t("w_position"), {
                    i: position,
                    n: total
                })
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $eb1133c43d00490b$export$2e2bcd8739ae039), {
                className: "pr-modal__nav",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                        size: "small",
                        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0f3c6d60b091c877$export$2e2bcd8739ae039), {}),
                        "aria-label": t("a_prev"),
                        onClick: onPrev
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                        size: "small",
                        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $89db7229a7e10f8f$export$2e2bcd8739ae039), {}),
                        "aria-label": t("a_next"),
                        onClick: onNext
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                        size: "small",
                        type: "text",
                        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $837faca566926e3c$export$2e2bcd8739ae039), {}),
                        "aria-label": t("a_close"),
                        onClick: onClose
                    })
                ]
            })
        ]
    });
    const footer = /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
        className: "pr-modal__foot",
        align: "center",
        gap: "small",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                type: "secondary",
                className: "pr-modal__hint",
                children: t("kbd_hint")
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $eb1133c43d00490b$export$2e2bcd8739ae039), {
                className: "pr-modal__acts",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                        className: "pr-btn--no",
                        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $bdfb1f797481a352$export$2e2bcd8739ae039), {}),
                        loading: busy,
                        disabled: status === "rejected",
                        onClick: onReject,
                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ce86776e5caf6dd0), "reject_btn", lang)
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                        className: "pr-btn--ok",
                        type: "primary",
                        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $45839ed7c4a7faa2$export$2e2bcd8739ae039), {}),
                        loading: busy,
                        disabled: status === "approved",
                        onClick: onApprove,
                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ce86776e5caf6dd0), "approv_btn", lang)
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $05a90c67d3627fd9$export$2e2bcd8739ae039), {
        open: true,
        /* The head carries prev / next / close together, so antd's own close button would be a
         fourth control in the same corner. */ closable: false,
        title: title,
        footer: footer,
        width: 1120,
        centered: true,
        rootClassName: "pr-modal",
        onCancel: onClose,
        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $db6c3adada49524e$export$2e2bcd8739ae039), {
            className: "pr-modal__body",
            wrap: false,
            children: [
                /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $cde227eb983ae1d2$export$2e2bcd8739ae039), {
                    className: "pr-stage",
                    flex: "auto",
                    children: [
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                            className: "pr-stage__img",
                            align: "center",
                            justify: "center",
                            children: photos.length ? /* Zoom happens IN the stage — antd's `Image` preview would have given wheel zoom and
                 pan for free, but only by opening a full-screen overlay above this modal, which
                 hides the facts rail the reviewer is checking the photo against.
                 `react-zoom-pan-pinch` is the wheel/drag/pinch surface antd has no equivalent for.
                 Keyed on the photo so switching one resets the transform — a 6× zoom carried over
                 to the next shelf is disorienting. */ /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $c9b1aa9458d4ea13$export$51cb649375dcd655), {
                                minScale: 1,
                                maxScale: 8,
                                doubleClick: {
                                    mode: "reset"
                                },
                                wheel: {
                                    step: 0.2
                                },
                                /* The stage is bigger than the letterboxed photo, and that dark margin is part of
                   the working area: `limitToBounds` would stop the drag at the photo's own edge,
                   so a corner of a zoomed shelf could never be brought to the middle of the view.
                   `centerZoomedOut` puts it back when you zoom out to fit, so free panning cannot
                   strand the photo off-screen. */ limitToBounds: false,
                                centerZoomedOut: true,
                                centerOnInit: true,
                                panning: {
                                    velocityDisabled: true
                                },
                                children: ({ zoomIn: zoomIn, zoomOut: zoomOut, resetTransform: resetTransform })=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $575603080129eb00$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $c9b1aa9458d4ea13$export$1def2aa75b7c7fe0), {
                                                wrapperClass: "pr-zoom",
                                                contentClass: "pr-zoom__content",
                                                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $7012c54fc4de0c33$export$2e2bcd8739ae039), {
                                                    src: currentPhoto,
                                                    alt: "",
                                                    preview: false,
                                                    draggable: false,
                                                    rootClassName: "pr-stage__imgwrap"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $eb1133c43d00490b$export$2e2bcd8739ae039), {
                                                className: "pr-zoom__acts",
                                                orientation: "vertical",
                                                size: 4,
                                                children: [
                                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                                        shape: "circle",
                                                        size: "small",
                                                        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $815b934ea3c76706$export$2e2bcd8739ae039), {}),
                                                        "aria-label": t("a_zoom_in"),
                                                        onClick: ()=>zoomIn()
                                                    }),
                                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                                        shape: "circle",
                                                        size: "small",
                                                        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $ccc5bd0954e2dcd0$export$2e2bcd8739ae039), {}),
                                                        "aria-label": t("a_zoom_out"),
                                                        onClick: ()=>zoomOut()
                                                    }),
                                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                                        shape: "circle",
                                                        size: "small",
                                                        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $11a3e787021f568d$export$2e2bcd8739ae039), {}),
                                                        "aria-label": t("a_zoom_reset"),
                                                        onClick: ()=>resetTransform()
                                                    }),
                                                    photoHref && /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                                        shape: "circle",
                                                        size: "small",
                                                        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $357da3723e13ae38$export$2e2bcd8739ae039), {}),
                                                        "aria-label": t("a_open_image"),
                                                        href: photoHref,
                                                        target: "_blank",
                                                        rel: "noopener noreferrer"
                                                    }),
                                                    photoHref && /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                                        shape: "circle",
                                                        size: "small",
                                                        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $37ec80fabde4926c$export$2e2bcd8739ae039), {}),
                                                        "aria-label": t("a_copy_image_link"),
                                                        onClick: copyLink
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                            }, `${itemId}-${photoIndex}`) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                className: "pr-stage__none",
                                vertical: true,
                                align: "center",
                                gap: "small",
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $c3b8d7d247171904$export$2e2bcd8739ae039), {
                                        className: "pr-stage__none-icon"
                                    }),
                                    t("no_photo")
                                ]
                            })
                        }),
                        photos.length > 1 && /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                            className: "pr-strip",
                            gap: "small",
                            children: photos.map((src, i)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                    className: "pr-thumb",
                                    "aria-current": i === photoIndex,
                                    "aria-label": (0, $3b579ca6158bc61b$export$9563e054e6f787fb)(t("a_photo_n"), {
                                        n: i + 1
                                    }),
                                    onClick: ()=>setPhotoIndex(i),
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $7012c54fc4de0c33$export$2e2bcd8739ae039), {
                                        src: src,
                                        alt: "",
                                        preview: false,
                                        rootClassName: "pr-thumb__imgwrap"
                                    })
                                }, `${src}-${i}`))
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $cde227eb983ae1d2$export$2e2bcd8739ae039), {
                    className: "pr-rail",
                    flex: "0 0 330px",
                    children: [
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $c9fa058dfa50f419$export$44918318b8113b6b), {
                            status: status,
                            lang: lang,
                            inline: true
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($bc657e1ecc306871$var$Facts, {
                            rows: [
                                {
                                    label: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), "point", lang),
                                    children: point?.name ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $575603080129eb00$exports.Fragment), {
                                        children: [
                                            point.name,
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                                type: "secondary",
                                                className: "pr-facts__sub",
                                                children: [
                                                    point.locality?.name,
                                                    point.network?.name
                                                ].filter(Boolean).join(" \xb7 ")
                                            })
                                        ]
                                    }) : null
                                },
                                {
                                    label: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ce86776e5caf6dd0), "merchendiser", lang),
                                    children: (0, $c9fa058dfa50f419$export$1d6cfa7493842c29)(item?.visit?.user)
                                },
                                {
                                    label: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ce86776e5caf6dd0), "responsible_supervisor", lang),
                                    children: (0, $c9fa058dfa50f419$export$1d6cfa7493842c29)(point?.responsible_supervisors?.[0])
                                },
                                {
                                    label: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ce86776e5caf6dd0), "start_visit", lang),
                                    children: visitStart
                                },
                                {
                                    label: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ce86776e5caf6dd0), "end_visit", lang),
                                    children: visitEnd
                                }
                            ]
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0e5d78eff3409cb5$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($bc657e1ecc306871$var$Facts, {
                            rows: [
                                {
                                    label: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), "brand", lang),
                                    children: info.brand
                                },
                                {
                                    label: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), "category", lang),
                                    children: info.category
                                },
                                {
                                    label: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), "clients", lang),
                                    children: info.client
                                },
                                {
                                    label: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), "tags", lang),
                                    children: tags.length > 0 && /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                        gap: 4,
                                        wrap: true,
                                        children: tags.map((tag)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $602120e6d17ff12a$export$2e2bcd8739ae039), {
                                                variant: "filled",
                                                className: "pr-tag",
                                                children: tag
                                            }, tag))
                                    })
                                }
                            ]
                        }),
                        (info.price || info.sale_price) && info.price !== "None" ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $575603080129eb00$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0e5d78eff3409cb5$export$2e2bcd8739ae039), {}),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($bc657e1ecc306871$var$Facts, {
                                    rows: [
                                        {
                                            label: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ce86776e5caf6dd0), "price", lang),
                                            children: info.price !== "None" ? info.price : null
                                        },
                                        {
                                            label: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ce86776e5caf6dd0), "sales_price", lang),
                                            children: info.sale_price !== "None" ? info.sale_price : null
                                        }
                                    ]
                                })
                            ]
                        }) : null,
                        info.comment ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $575603080129eb00$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0e5d78eff3409cb5$export$2e2bcd8739ae039), {}),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($bc657e1ecc306871$var$Facts, {
                                    rows: [
                                        {
                                            label: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ce86776e5caf6dd0), "comment", lang),
                                            children: info.comment
                                        }
                                    ]
                                })
                            ]
                        }) : null,
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0e5d78eff3409cb5$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($bc657e1ecc306871$var$Facts, {
                            rows: [
                                {
                                    label: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ce86776e5caf6dd0), "linkedVisit", lang),
                                    children: item.visit_id ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Link, {
                                        href: `/visit/${item.visit_id}`,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        children: [
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0ddb3666fa5a86f7$export$2e2bcd8739ae039), {
                                                className: "pr-facts__link-icon"
                                            }),
                                            " ",
                                            [
                                                point?.locality?.name,
                                                point?.name
                                            ].filter(Boolean).join(" ")
                                        ]
                                    }) : null
                                },
                                {
                                    label: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ce86776e5caf6dd0), "linkedTasks", lang),
                                    children: answer ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Link, {
                                        href: `/task/${answer.task.id}`,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        children: [
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0ddb3666fa5a86f7$export$2e2bcd8739ae039), {
                                                className: "pr-facts__link-icon"
                                            }),
                                            " #",
                                            answer.task.id,
                                            " \u2014 ",
                                            answer.task.title
                                        ]
                                    }) : null
                                }
                            ]
                        }),
                        answerLoading && /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e855c7114b2916ed$export$2e2bcd8739ae039), {
                            active: true,
                            paragraph: {
                                rows: 2
                            },
                            title: false
                        }),
                        item.approval?.approved_at ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $575603080129eb00$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0e5d78eff3409cb5$export$2e2bcd8739ae039), {}),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($bc657e1ecc306871$var$Facts, {
                                    rows: [
                                        {
                                            label: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ce86776e5caf6dd0), "approve_reject_label_block", lang),
                                            children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $1e5256cf9d329b2c$export$2e2bcd8739ae039), {
                                                title: approvedAt,
                                                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                                    children: [
                                                        (0, $c9fa058dfa50f419$export$1d6cfa7493842c29)(item.approval.approved_by),
                                                        " \xb7 ",
                                                        approvedAt
                                                    ]
                                                })
                                            })
                                        }
                                    ]
                                })
                            ]
                        }) : null
                    ]
                })
            ]
        })
    });
}




/**
 * The photo report shows two months, and no more.
 *
 * That is a retention rule before it is a performance one — but it is also load-bearing for
 * speed. The Outforz index behind this query is PARTIAL (outforz-api migration
 * `0030_photo_report_indexes`): it covers only rows newer than a fixed cutoff. Postgres uses a
 * partial index only where it can prove the query implies the predicate, so a request reaching
 * back past the cutoff does not return older rows — it loses the index and sequentially scans
 * tens of millions of them.
 *
 * ⚠ Two DIFFERENT guards, and neither implies the other:
 * - `MAX_RANGE_DAYS` caps a window's WIDTH, measured from its own end.
 * - `earliestDay()` is an ABSOLUTE floor. Without it `[a year ago, a year ago + 60d]` passes
 *   the width cap while sitting entirely outside retention — narrow, and unservable.
 *
 * Enforced in the same three places as before — the calendar greys the days out,
 * `searchToFilter` handles a pasted URL, and `buildQuery` handles whatever is in state at
 * request time — but **the guard that actually holds is `photo_report_window.clamp` in
 * picsell-api**, because a direct API call reaches none of these. Those four move together,
 * and with `INDEX_CUTOFF` in that migration.
 */ const $a11cc2758244e822$var$MAX_RANGE_DAYS = 62;
/** The oldest day this page will ask for: today minus the retention window. */ const $a11cc2758244e822$var$earliestDay = ()=>(0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)().subtract($a11cc2758244e822$var$MAX_RANGE_DAYS, "day").startOf("day");
/** Both guards, in the one order that is correct: width first, then the absolute floor. */ const $a11cc2758244e822$var$holdRange = (range)=>(0, $cc63266e8518a62e$export$df1f3759cd7b9c97)((0, $cc63266e8518a62e$export$e9d4863bcce07ce9)(range, $a11cc2758244e822$var$MAX_RANGE_DAYS), $a11cc2758244e822$var$earliestDay());
/* One request per pause in filtering, not one per click (spec/03). The comment box keeps its own
   timer of the same length so a keystroke does not also rewrite the address bar. */ const $a11cc2758244e822$var$FILTER_DEBOUNCE_MS = 250;
const $a11cc2758244e822$var$STATUS_SEGMENTS = [
    [
        "all",
        "status_all"
    ],
    [
        "pending",
        "status_pending"
    ],
    [
        "approved",
        "status_approved"
    ],
    [
        "rejected",
        "status_rejected"
    ]
];
/* Cards: 1 / 2 / 3 / 4 / 6 across, on antd's 24-column grid per spec/02. */ const $a11cc2758244e822$var$CARD_COL = {
    xs: 24,
    sm: 12,
    md: 8,
    lg: 6,
    xxl: 4
};
/* The filter row is five equal tracks with the period spanning two, and 24 does not divide by
   five. `<Col>`'s responsive value may be an object rather than a span, and that object takes
   `flex` — so the track width is expressed as a percentage instead. It lands on the design's
   210px because antd implements `<Row gutter>` as padding INSIDE each Col (with a negative margin
   on the Row), so `0 0 20%` is a fifth of the row and the 12px gap comes out of it.
   `0 0` rather than `1 1`: a last row of three must leave two empty tracks, not stretch. */ const $a11cc2758244e822$var$FIELD_COL = {
    xs: {
        flex: "0 0 100%"
    },
    sm: {
        flex: "0 0 50%"
    },
    md: {
        flex: "0 0 33.3333%"
    },
    lg: {
        flex: "0 0 20%"
    }
};
const $a11cc2758244e822$var$FIELD_COL_WIDE = {
    xs: {
        flex: "0 0 100%"
    },
    sm: {
        flex: "0 0 100%"
    },
    md: {
        flex: "0 0 66.6667%"
    },
    lg: {
        flex: "0 0 40%"
    }
};
const $a11cc2758244e822$var$blankFilter = ()=>({
        county: "",
        clients: "",
        point__networks: [],
        points: [],
        users: [],
        categories: [],
        subcategories: [],
        brands: [],
        products: [],
        tags: [],
        comment: ""
    });
/* Which chips a filter key produces, and where its label comes from. Single-value keys read
   their label from `chosen` (the option object the select handed back); array keys carry their
   own objects. */ const $a11cc2758244e822$var$CHIP_LABEL = {
    county: "region",
    clients: "clients",
    point__networks: "network",
    points: "points",
    users: "merchandisers",
    categories: "categories",
    subcategories: "subcategories",
    brands: "brands",
    products: "products",
    tags: "tags",
    comment: "comment"
};
const $a11cc2758244e822$var$SINGLE_KEYS = [
    "county",
    "clients"
];
/* Network went multi with PICSELL-1581 #8 — the proxy has read a plural `point__networks`
   param all along; only this page was stuck at one. */ const $a11cc2758244e822$var$ARRAY_KEYS = [
    "point__networks",
    "points",
    "users",
    "categories",
    "subcategories",
    "brands",
    "products",
    "tags"
];
/**
 * The array filters the endpoint matches by NAME rather than by id (see `buildQuery`).
 *
 * Their URL value has to be the name too. Round-tripping them by id — which is what this used to
 * do — meant `joinNames` got a `{ id: 5 }` with no `name` on it after a reload, dropped the value,
 * and the filter silently stopped applying while its chip still showed. Products are the same
 * problem a third way: they match by `code`.
 */ const $a11cc2758244e822$var$NAME_KEYS = [
    "categories",
    "subcategories",
    "brands",
    "tags"
];
const $a11cc2758244e822$var$idOf = (v)=>v && typeof v === "object" ? v.id ?? v.value : v;
const $a11cc2758244e822$var$nameOf = (v)=>v && typeof v === "object" ? v.label || v.name : v;
const $a11cc2758244e822$var$joinIds = (list)=>(list || []).map($a11cc2758244e822$var$idOf).filter((v)=>v !== undefined && v !== null && v !== "").join(",");
const $a11cc2758244e822$var$joinNames = (list)=>(list || []).map($a11cc2758244e822$var$nameOf).filter(Boolean).join(",");
const $a11cc2758244e822$var$joinCodes = (list)=>(list || []).map((o)=>o?.code).filter(Boolean).join(",");
const $a11cc2758244e822$var$isoDay = (d)=>(0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)(d).format("YYYY-MM-DD");
/**
 * The request the grid runs on.
 *
 * Built here rather than through `filterUrl()` so the mapping is visible in one place: each
 * value has to arrive in the shape the Outforz proxy expects — ids for merchandisers and
 * points, names for categories / subcategories / brands / tags, product *codes* for products.
 * `end__lte` is the selected end date plus a day, which is what makes the range inclusive.
 */ function $a11cc2758244e822$var$buildQuery({ filter: filter, range: range, page: page, viewMode: viewMode }) {
    const p = new URLSearchParams();
    p.set("page", String(page));
    if (filter.county) p.set("county", String($a11cc2758244e822$var$idOf(filter.county)));
    if (filter.clients) p.set("clients", String($a11cc2758244e822$var$idOf(filter.clients)));
    if (filter.point__networks?.length) p.set("point__networks", $a11cc2758244e822$var$joinIds(filter.point__networks));
    if (filter.points?.length) p.set("points", $a11cc2758244e822$var$joinIds(filter.points));
    if (filter.users?.length) p.set("users", $a11cc2758244e822$var$joinIds(filter.users));
    if (filter.categories?.length) p.set("categories", $a11cc2758244e822$var$joinNames(filter.categories));
    if (filter.subcategories?.length) p.set("subcategories", $a11cc2758244e822$var$joinNames(filter.subcategories));
    if (filter.brands?.length) p.set("brands", $a11cc2758244e822$var$joinNames(filter.brands));
    if (filter.tags?.length) p.set("tags", $a11cc2758244e822$var$joinNames(filter.tags));
    if (filter.products?.length) p.set("products", $a11cc2758244e822$var$joinCodes(filter.products));
    if (filter.comment) p.set("comment", filter.comment);
    // The backend only applies a date window when it gets both ends.
    const window1 = $a11cc2758244e822$var$holdRange(range);
    if (window1?.[0] && window1?.[1]) {
        p.set("start__gte", $a11cc2758244e822$var$isoDay(window1[0]));
        p.set("end__lte", $a11cc2758244e822$var$isoDay((0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)(window1[1]).add(1, "day")));
    }
    if (viewMode === "group") p.set("report_type", "grouped");
    return p.toString();
}
/** URL ↔ filter sync, so a filtered view can be shared and survives a reload. */ function $a11cc2758244e822$var$filterToSearch(filter, range) {
    const p = new URLSearchParams();
    if (range?.[0]) p.set("start", $a11cc2758244e822$var$isoDay(range[0]));
    if (range?.[1]) p.set("end", $a11cc2758244e822$var$isoDay(range[1]));
    $a11cc2758244e822$var$SINGLE_KEYS.forEach((key)=>{
        if (filter[key]) p.set(key, String($a11cc2758244e822$var$idOf(filter[key])));
    });
    $a11cc2758244e822$var$ARRAY_KEYS.forEach((key)=>{
        (filter[key] || []).forEach((v)=>{
            /* Whatever the endpoint matches on — see NAME_KEYS. The URL carries the same token the query
         will, so a reload reconstructs a working filter rather than an id the query cannot use. */ const token = key === "products" ? v?.code : $a11cc2758244e822$var$NAME_KEYS.includes(key) ? $a11cc2758244e822$var$nameOf(v) : $a11cc2758244e822$var$idOf(v);
            if (token !== undefined && token !== null && token !== "") p.append(key, String(token));
        });
    });
    if (filter.comment) p.set("comment", filter.comment);
    return p.toString();
}
function $a11cc2758244e822$var$searchToFilter(search) {
    const p = new URLSearchParams(search);
    const filter = $a11cc2758244e822$var$blankFilter();
    $a11cc2758244e822$var$SINGLE_KEYS.forEach((key)=>{
        if (p.get(key)) filter[key] = p.get(key);
    });
    $a11cc2758244e822$var$ARRAY_KEYS.forEach((key)=>{
        const values = p.getAll(key);
        if (!values.length) return;
        /* A name-matched filter is self-describing, so its chip reads as words with no lookup. An
       id-matched one (points, merchandisers) is not: `EntitySelect`'s `onResolve` names those. */ filter[key] = values.map((v)=>key === "products" ? {
                code: v,
                id: v,
                name: v
            } : $a11cc2758244e822$var$NAME_KEYS.includes(key) ? {
                id: v,
                name: v
            } : {
                id: /^\d+$/.test(v) ? Number(v) : v
            });
    });
    /* Pre-#1581 URLs and bookmarks carried the single `point__network=<id>`. */ const legacyNetwork = p.get("point__network");
    if (legacyNetwork && !filter.point__networks.length) filter.point__networks = [
        {
            id: /^\d+$/.test(legacyNetwork) ? Number(legacyNetwork) : legacyNetwork
        }
    ];
    if (p.get("comment")) filter.comment = p.get("comment");
    const start = p.get("start");
    const end = p.get("end");
    /* A pasted or bookmarked URL is untrusted input like any other: clamp it to the cap rather than
     trusting the address bar, and fall back to the default window if it carries no period at all
     (or only one end, which is not a range). */ const range = start && end ? $a11cc2758244e822$var$holdRange([
        (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)(start),
        (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)(end)
    ]) : (0, $cc63266e8518a62e$export$33e9fd85c7cf1b3c)();
    return {
        filter: filter,
        range: range
    };
}
/* -------------------------------------------------------------------- pieces */ /**
 * The card cover: `<Carousel>` for the photos, `<Image>` for each one.
 *
 * The carousel owns the index — that is why `photoIndex` / `onRoll` / `onDot` are gone from the
 * page. It reports back through `afterChange` only so the `n/N` tag can say where it is; nothing
 * outside this component reads the value, so there is no state to keep in sync.
 *
 * `<Image preview={false}>`: the cover's job is to open the review modal, and antd's own preview
 * overlay would intercept the click that does it.
 */ function $a11cc2758244e822$var$PhotoCover({ item: item, lang: lang, isSelected: isSelected, busy: busy, onToggle: onToggle, onOpen: onOpen, onApprove: onApprove, onReject: onReject }) {
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b8441a9a81ffc5d6), key, lang);
    const photos = item.photo || [];
    const many = photos.length > 1;
    const status = (0, $c9fa058dfa50f419$export$1094b4db5e23d27c)(item);
    const carousel = (0, $cQmXV.useRef)(null);
    const [index, setIndex] = (0, $cQmXV.useState)(0);
    /* Only the cover image opens the review modal; every control on top of it stops the click. */ const swallow = (fn)=>(event)=>{
            event.stopPropagation();
            fn();
        };
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
        className: "pr-cover",
        onClick: onOpen,
        children: [
            photos.length ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e5e8f6bf1e4edb2c$export$2e2bcd8739ae039), {
                ref: carousel,
                /* `className` lands on the inner slick slider; the outer `.ant-carousel` — the one that
             has to fill the cover — is only reachable through `rootClassName`. */ rootClassName: "pr-cover__reel",
                dots: many,
                infinite: false,
                /* A grouped report can hold a dozen photos and slick renders every slide, so without
             this the card fetched all of them at full size to show one. */ lazyLoad: "ondemand",
                /* Slide changes are a side effect of the arrows below, which already stop the click. */ afterChange: setIndex,
                children: photos.map((src, i)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $7012c54fc4de0c33$export$2e2bcd8739ae039), {
                        className: "pr-cover__img",
                        src: src,
                        alt: "",
                        preview: false,
                        rootClassName: "pr-cover__imgwrap",
                        /* These are full-resolution shelf photos — there is no thumbnail endpoint — and a
                 page is 20 cards. `loading="lazy"` is what keeps a page from opening 20 of them
                 at once through a 6-connection budget. The cover's box is fixed in CSS
                 (`aspect-ratio` + `object-fit`), so nothing shifts as they arrive. */ loading: "lazy"
                    }, `${src}-${i}`))
            }) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                className: "pr-cover__none",
                vertical: true,
                align: "center",
                justify: "center",
                gap: 4,
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $c3b8d7d247171904$export$2e2bcd8739ae039), {
                        className: "pr-cover__none-icon"
                    }),
                    t("no_photo")
                ]
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $c9fa058dfa50f419$export$44918318b8113b6b), {
                status: status,
                lang: lang
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                className: "pr-cover__check",
                align: "center",
                justify: "center",
                onClick: (event)=>event.stopPropagation(),
                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $7a650444b7c2c328$export$2e2bcd8739ae039), {
                    checked: isSelected,
                    onChange: onToggle,
                    "aria-label": t("a_select")
                })
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $eb1133c43d00490b$export$2e2bcd8739ae039), {
                className: "pr-cover__acts",
                size: 4,
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                        className: "pr-actbtn",
                        size: "small",
                        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $815b934ea3c76706$export$2e2bcd8739ae039), {}),
                        "aria-label": t("review_title"),
                        onClick: swallow(onOpen)
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                        className: `pr-actbtn pr-actbtn--no${status === "rejected" ? " pr-actbtn--on" : ""}`,
                        size: "small",
                        loading: busy,
                        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $bdfb1f797481a352$export$2e2bcd8739ae039), {}),
                        "aria-label": (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ce86776e5caf6dd0), "reject_btn", lang),
                        onClick: swallow(onReject)
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                        className: `pr-actbtn pr-actbtn--ok${status === "approved" ? " pr-actbtn--on" : ""}`,
                        size: "small",
                        loading: busy,
                        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $45839ed7c4a7faa2$export$2e2bcd8739ae039), {}),
                        "aria-label": (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ce86776e5caf6dd0), "approv_btn", lang),
                        onClick: swallow(onApprove)
                    })
                ]
            }),
            many && /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $575603080129eb00$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $602120e6d17ff12a$export$2e2bcd8739ae039), {
                        variant: "filled",
                        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $9f1db3a3fd7715e2$export$2e2bcd8739ae039), {}),
                        className: "pr-countpill",
                        children: [
                            index + 1,
                            "/",
                            photos.length
                        ]
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                        className: "pr-cover__nav",
                        align: "center",
                        justify: "space-between",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                className: "pr-navbtn",
                                shape: "circle",
                                size: "small",
                                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0f3c6d60b091c877$export$2e2bcd8739ae039), {}),
                                "aria-label": t("a_prev_photo"),
                                onClick: swallow(()=>carousel.current?.prev())
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                className: "pr-navbtn",
                                shape: "circle",
                                size: "small",
                                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $89db7229a7e10f8f$export$2e2bcd8739ae039), {}),
                                "aria-label": t("a_next_photo"),
                                onClick: swallow(()=>carousel.current?.next())
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
/**
 * The card's tag row: one line, scrolled sideways, never wrapped.
 *
 * A wrapping row made the card grow by a line for every extra tag, so a grid of cards with uneven
 * tag counts had uneven heights. This keeps the row one line tall whatever it holds, and says how
 * many tags are off-screen with a `+N` pinned to the right edge.
 *
 * `+N` hides while the row is being scrolled, because during a scroll it is both wrong (the count
 * is changing under the finger) and in the way of what the user is scrolling toward. It comes back
 * ~400ms after the last scroll event, recounted.
 */ function $a11cc2758244e822$var$TagRow({ tags: tags }) {
    const ref = (0, $cQmXV.useRef)(null);
    const idle = (0, $cQmXV.useRef)(null);
    const [hidden, setHidden] = (0, $cQmXV.useState)(0);
    const [scrolling, setScrolling] = (0, $cQmXV.useState)(false);
    const measure = (0, $cQmXV.useCallback)(()=>{
        const el = ref.current;
        if (!el) return;
        /* Count what starts past the right edge rather than what merely straddles it: a half-visible
       tag is legible, and counting it made `+N` say there was more than there was. */ const edge = el.scrollLeft + el.clientWidth;
        setHidden([
            ...el.children
        ].filter((child)=>child.offsetLeft + child.offsetWidth > edge + 1).length);
    }, []);
    (0, $cQmXV.useEffect)(()=>{
        measure();
        /* The card is in a responsive grid, so the row's width changes without any scroll or
       re-render — a resize is the only signal that the count is stale. */ const observer = new ResizeObserver(measure);
        if (ref.current) observer.observe(ref.current);
        return ()=>{
            observer.disconnect();
            clearTimeout(idle.current);
        };
    }, [
        measure,
        tags
    ]);
    const onScroll = ()=>{
        measure();
        setScrolling(true);
        clearTimeout(idle.current);
        idle.current = setTimeout(()=>setScrolling(false), 400);
    };
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
        className: "pr-tagrow",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                ref: ref,
                className: "pr-tagrow__scroll",
                gap: 4,
                onScroll: onScroll,
                children: tags.map((tag)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $602120e6d17ff12a$export$2e2bcd8739ae039), {
                        variant: "filled",
                        className: "pr-tag",
                        children: tag
                    }, tag))
            }),
            hidden > 0 && !scrolling && /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $602120e6d17ff12a$export$2e2bcd8739ae039), {
                variant: "filled",
                className: "pr-tagrow__more",
                title: tags.slice(tags.length - hidden).join(", "),
                children: [
                    "+",
                    hidden
                ]
            })
        ]
    });
}
/* The grid keeps every loaded page mounted, each card with a slick carousel and a ResizeObserver,
   so an unmemoised card meant one keystroke in the comment box re-rendered the whole grid. The
   parent's `on*` handlers take the item and are `useCallback`-stable for this to hold; the
   zero-arg wrappers the cover wants are built here, where they cost nothing. */ const $a11cc2758244e822$var$PhotoCard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).memo(function PhotoCard(props) {
    const { item: item, lang: lang, grouped: grouped, isSelected: isSelected, onToggle: onToggle, onOpen: onOpen, onApprove: onApprove, onReject: onReject } = props;
    const info = item.additional_info || {};
    const tags = Array.isArray(info.tags) ? info.tags : [];
    const point = item.visit?.point;
    const user = (0, $c9fa058dfa50f419$export$1d6cfa7493842c29)(item.visit?.user);
    const photos = item.photo || [];
    const open = ()=>onOpen(item);
    const cover = /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a11cc2758244e822$var$PhotoCover, {
        item: item,
        lang: lang,
        grouped: grouped,
        isSelected: isSelected,
        busy: props.busy,
        onToggle: ()=>onToggle(item),
        onOpen: open,
        onApprove: ()=>onApprove(item),
        onReject: ()=>onReject(item)
    });
    const since = item.visit?.start ? $a11cc2758244e822$var$relativeFormat(lang).format(...$a11cc2758244e822$var$relativeParts(new Date(item.visit.start))) : "";
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b4fda840b736e640$export$2e2bcd8739ae039), {
        hoverable: true,
        className: `pr-card${grouped ? " pr-card--group" : ""}${isSelected ? " pr-card--selected" : ""}`,
        cover: cover,
        styles: {
            body: {
                padding: 0
            }
        },
        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
            vertical: true,
            gap: "small",
            className: "pr-card__body",
            onClick: open,
            children: [
                /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                    vertical: true,
                    children: [
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                            type: "secondary",
                            className: "pr-card__loc",
                            children: [
                                point?.locality?.name,
                                point?.network?.name
                            ].filter(Boolean).join(" \xb7 ")
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                            strong: true,
                            ellipsis: {
                                tooltip: point?.name || ""
                            },
                            className: "pr-card__pt",
                            children: point?.name
                        })
                    ]
                }),
                tags.length > 0 && /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a11cc2758244e822$var$TagRow, {
                    tags: tags
                }),
                /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                    align: "center",
                    gap: "small",
                    className: "pr-card__foot",
                    children: [
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                            align: "center",
                            gap: 4,
                            className: "pr-card__who",
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $72b7444d01b36e98$export$2e2bcd8739ae039), {
                                    size: 24,
                                    className: "pr-card__av",
                                    children: (0, $c9fa058dfa50f419$export$f6a098653d630c23)(user)
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                    ellipsis: true,
                                    children: user
                                })
                            ]
                        }),
                        grouped ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $1e5256cf9d329b2c$export$2e2bcd8739ae039), {
                            title: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b8441a9a81ffc5d6), "photos_label", lang),
                            children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                className: "pr-card__time",
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $9f1db3a3fd7715e2$export$2e2bcd8739ae039), {
                                        className: "pr-card__count-icon"
                                    }),
                                    " ",
                                    photos.length
                                ]
                            })
                        }) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                            className: "pr-card__time",
                            children: since
                        })
                    ]
                })
            ]
        })
    });
});
/* One formatter per locale rather than one per card per render. */ const $a11cc2758244e822$var$RELATIVE_FORMATS = new Map();
function $a11cc2758244e822$var$relativeFormat(lang) {
    const locale = (0, $7d0f78de0b68a104$export$bd7bed267fc278f2)(lang);
    if (!$a11cc2758244e822$var$RELATIVE_FORMATS.has(locale)) $a11cc2758244e822$var$RELATIVE_FORMATS.set(locale, new Intl.RelativeTimeFormat(locale, {
        numeric: "auto"
    }));
    return $a11cc2758244e822$var$RELATIVE_FORMATS.get(locale);
}
/** `Intl.RelativeTimeFormat` args for "11 d ago" — the largest unit that isn't zero. */ function $a11cc2758244e822$var$relativeParts(date) {
    const minutes = Math.max(Math.round((Date.now() - date.getTime()) / 60000), 0);
    if (minutes < 60) return [
        -minutes,
        "minute"
    ];
    if (minutes < 1440) return [
        -Math.round(minutes / 60),
        "hour"
    ];
    return [
        -Math.round(minutes / 1440),
        "day"
    ];
}
/* The same `<Card cover>` the real thing uses, so the placeholder cannot drift from it. */ function $a11cc2758244e822$var$CardSkeleton() {
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b4fda840b736e640$export$2e2bcd8739ae039), {
        className: "pr-card pr-sk",
        cover: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e855c7114b2916ed$export$2e2bcd8739ae039).Image, {
            active: true
        }),
        styles: {
            body: {
                padding: "var(--space-3)"
            }
        },
        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e855c7114b2916ed$export$2e2bcd8739ae039), {
            active: true,
            title: false,
            paragraph: {
                rows: 2
            }
        })
    });
}
function $a11cc2758244e822$export$2e2bcd8739ae039() {
    const me = (0, $b83e93e5ef3de8b0$export$2105062e25df4afe)((state)=>state.me);
    const lang = me?.language || "en";
    const history = (0, $6f5d68f762d5488a$export$3420e1dc2c4a518c)();
    const location = (0, $6f5d68f762d5488a$export$45d76561a5302f2b)();
    const { id: routeId } = (0, $6f5d68f762d5488a$export$99eaa27ddbbb95ef)();
    const t = (key, group = (0, $fc3f36407bc5ec6c$export$b8441a9a81ffc5d6))=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)(group, key, lang);
    /* Read once, on the first render: after that the address bar is written FROM this state, so
     re-reading it would fight the write. */ const initialRef = (0, $cQmXV.useRef)(null);
    if (!initialRef.current) initialRef.current = location.search && location.search.length > 1 ? $a11cc2758244e822$var$searchToFilter(location.search) : {
        filter: {
            ...$a11cc2758244e822$var$blankFilter(),
            county: (0, $3b579ca6158bc61b$export$6339e4f5afb1eeb0)(me) || ""
        },
        range: (0, $cc63266e8518a62e$export$33e9fd85c7cf1b3c)()
    };
    const initial = initialRef.current;
    const [filter, setFilter] = (0, $cQmXV.useState)(initial.filter);
    /* Labels for the single-value selects, so their chips read as words. The filter itself keeps
     ids, which is what the endpoint wants. */ const [chosen, setChosen] = (0, $cQmXV.useState)(()=>me?.county && typeof me.county === "object" ? {
            county: me.county
        } : {});
    const [range, setRangeState] = (0, $cQmXV.useState)(initial.range);
    /**
   * The only way the period changes. Everything routes through here — the picker, the chip's ×,
   * a saved preset, Reset — so "the state never holds a window wider than the cap, and never
   * holds none" is an invariant rather than a rule each call site has to remember.
   *
   * The picker clamps too, but antd commits a range on blur and on Esc as well as on a completed
   * pick, and those paths do not all pass through the same handler. Clamping here means it does
   * not matter which one fired.
   */ const setRange = (next)=>setRangeState($a11cc2758244e822$var$holdRange(next) || (0, $cc63266e8518a62e$export$33e9fd85c7cf1b3c)());
    const [data, setData] = (0, $cQmXV.useState)([]);
    const [loading, setLoading] = (0, $cQmXV.useState)(true);
    const [loadingMore, setLoadingMore] = (0, $cQmXV.useState)(false);
    const [hasNext, setHasNext] = (0, $cQmXV.useState)(false);
    const page = (0, $cQmXV.useRef)(1);
    const [viewMode, setViewMode] = (0, $cQmXV.useState)("single");
    const [statusFilter, setStatusFilter] = (0, $cQmXV.useState)("all");
    const [showExtra, setShowExtra] = (0, $cQmXV.useState)(false);
    const [selected, setSelected] = (0, $cQmXV.useState)(()=>new Set());
    const [busyId, setBusyId] = (0, $cQmXV.useState)(null);
    /** `{ item, advance }` while the reject-and-raise-a-task modal is open. */ const [rejecting, setRejecting] = (0, $cQmXV.useState)(null);
    const [openId, setOpenId] = (0, $cQmXV.useState)(routeId ? Number(routeId) : null);
    const [presetName, setPresetName] = (0, $cQmXV.useState)("");
    const [presetVersion, setPresetVersion] = (0, $cQmXV.useState)(0);
    const [preset, setPreset] = (0, $cQmXV.useState)(null);
    const [exporting, setExporting] = (0, $cQmXV.useState)(false);
    /* One in-flight request at a time, via the same `getAbortable` every other list in the app
     uses. A `seq` ref used to drop the stale RESPONSE, which is not the same thing: the socket
     stayed open and the upstream query kept running, so fiddling with filters stacked several
     of the slowest query in the product. Aborting frees the browser's connection slot for the
     images — it does not stop a query already executing on the server. */ const inflight = (0, $cQmXV.useRef)(null);
    const fetchPage = (0, $cQmXV.useCallback)((nextPage, append)=>{
        inflight.current?.abort();
        const controller = new AbortController();
        inflight.current = controller;
        const url = `visits/photos_from_reports/?${$a11cc2758244e822$var$buildQuery({
            filter: filter,
            range: range,
            page: nextPage,
            viewMode: viewMode
        })}`;
        append ? setLoadingMore(true) : setLoading(true);
        (0, $c9936523dc38c641$export$86557ef9e0794d10)(url, controller.signal).then((response)=>{
            if (!response?.results) {
                setLoading(false);
                setLoadingMore(false);
                return;
            }
            const rows = response.results.map((row)=>new (0, $4e9873a13607b352$export$29d24e359e2fdff9)(row));
            page.current = nextPage;
            // `report_type=grouped` answers without a `next` key; infer from an empty page there.
            setHasNext(response.next !== undefined ? Boolean(response.next) : rows.length > 0);
            /* No trailing-window slice here any more. `slice(-MAX)` silently dropped the OLDEST
             page from state once the list passed the cap, so scrolling back up met a hole where
             the first 20 photos had been (PICSELL-1581 #9). Off-screen cards are cheap instead:
             `content-visibility: auto` on `.pr-card` skips their layout/paint work. */ setData((prev)=>append ? [
                    ...prev,
                    ...rows
                ] : rows);
            setLoading(false);
            setLoadingMore(false);
        }).catch((error)=>{
            if (error.name === "AbortError") return;
            /* `call()` turned a 500 into `{results: [], count: 0}`, and `[]` is truthy — so a
             failed request rendered as "no photos found" with no way to tell the two apart.
             `getAbortable` throws, so a failure is a failure. */ (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).error(t("load_failed"));
            setLoading(false);
            setLoadingMore(false);
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        filter,
        range,
        viewMode
    ]);
    /* Filters apply as they change — but one tick of a multi-select fired a full request
     immediately, so ticking five points meant five of them in flight at once. Coalescing here
     rather than per control means every filter gets it, including the ones added later. */ (0, $cQmXV.useEffect)(()=>{
        page.current = 1;
        const timer = setTimeout(()=>fetchPage(1, false), $a11cc2758244e822$var$FILTER_DEBOUNCE_MS);
        return ()=>{
            clearTimeout(timer);
            inflight.current?.abort();
        };
    }, [
        fetchPage
    ]);
    /* Keep the address bar in step so the view can be shared, without adding history entries. */ (0, $cQmXV.useEffect)(()=>{
        const search = $a11cc2758244e822$var$filterToSearch(filter, range);
        if (search !== location.search.replace(/^\?/, "")) history.replace({
            search: search
        });
    // location.search is read, not depended on: reacting to it would fight the write above.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        filter,
        range
    ]);
    const visible = (0, $cQmXV.useMemo)(()=>statusFilter === "all" ? data : data.filter((item)=>(0, $c9fa058dfa50f419$export$1094b4db5e23d27c)(item) === statusFilter), [
        data,
        statusFilter
    ]);
    const openIndex = openId == null ? -1 : visible.findIndex((item)=>item.id === openId);
    const openItem = openIndex >= 0 ? visible[openIndex] : null;
    /* ------------------------------------------------------------- mutations */ /* The row is patched rather than refetched: one refetch to keep the grid honest would repaint
     it under the reviewer's cursor. */ const patchLocal = (ids, isApproved)=>{
        /* A Set, not `ids.includes` inside the map: bulk-approving a full page of 100 was 10,000
       comparisons. */ const touched = new Set(ids);
        setData((prev)=>prev.map((item)=>touched.has(item.id) ? {
                    ...item,
                    approval: {
                        ...item.approval,
                        is_approved: isApproved,
                        approved_by: me,
                        approved_at: new Date().toISOString()
                    }
                } : item));
    };
    const postApproval = (item, isApproved)=>new Promise((resolve)=>{
            const info = item?.picsell_info;
            if (!info?.object_id || !info?.object_type) {
                resolve(false);
                return;
            }
            (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
                method: "POST",
                url: "approvals/",
                post: {
                    object_id: info.object_id,
                    object_type: info.object_type,
                    is_approved: isApproved,
                    comment: ""
                }
            }, /* `isOk`, not truthiness — a 5xx hands the callback a truthy failedResponse, which is
           how a failed batch used to toast an error AND a success (PICSELL-1581 #10). */ (response)=>resolve((0, $c9936523dc38c641$export$71a04ee6075aae31)(response)));
        });
    const decide = async (item, isApproved, advance)=>{
        if (!item?.picsell_info?.object_id || !item?.picsell_info?.object_type) {
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).error((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f544127b46daf517), "task_object_item_id_msg", lang));
            return;
        }
        /* Rejecting asks what to do about it: the reviewer marks up the photo and raises a corrective
       task, and the rejection is posted once that exists. "Reject only" inside the modal is the
       way out for a photo that needs no shelf work. Approving stays one click. */ if (!isApproved) {
            setRejecting({
                item: item,
                advance: advance
            });
            return;
        }
        setBusyId(item.id);
        const ok = await postApproval(item, isApproved);
        setBusyId(null);
        if (!ok) return;
        patchLocal([
            item.id
        ], isApproved);
        (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f544127b46daf517), isApproved ? "task_accept_msg" : "task_reject_msg", lang));
        if (advance) step(1);
    };
    /* One `bulk_approval` request per object_type, not one `approvals/` POST per row — a hundred
     simultaneous POSTs is what produced the 5xx error toasts over a batch that mostly landed
     (PICSELL-1581 #10). A failed group's toast comes from `call()` itself; only rows the server
     confirmed get patched locally. */ const bulkDecide = async (isApproved)=>{
        const chosen = data.filter((item)=>selected.has(item.id));
        const items = chosen.filter((item)=>item.picsell_info?.object_id && item.picsell_info?.object_type);
        if (chosen.length > items.length) (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).warning((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f544127b46daf517), "task_object_item_id_msg", lang));
        if (!items.length) {
            setSelected(new Set());
            return;
        }
        setBusyId("bulk");
        const groups = new Map();
        items.forEach((item)=>{
            const type = item.picsell_info.object_type;
            if (!groups.has(type)) groups.set(type, []);
            groups.get(type).push(item);
        });
        const done = [];
        for (const [type, group] of groups){
            const ok = await new Promise((resolve)=>(0, $c9936523dc38c641$export$848feb93d8f32b9b)({
                    method: "POST",
                    url: "approvals/bulk_approval/",
                    post: {
                        object_ids: group.map((item)=>item.picsell_info.object_id),
                        object_type: type,
                        is_approved: isApproved,
                        comment: ""
                    }
                }, (response)=>resolve((0, $c9936523dc38c641$export$71a04ee6075aae31)(response))));
            if (ok) done.push(...group.map((item)=>item.id));
        }
        setBusyId(null);
        if (done.length) {
            patchLocal(done, isApproved);
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f544127b46daf517), isApproved ? "task_accept_msg" : "task_reject_msg", lang));
        }
        setSelected(new Set());
    };
    /* --------------------------------------------------------------- queue nav */ const step = (delta)=>{
        if (!visible.length) {
            setOpenId(null);
            return;
        }
        /* After a decision the item may have left the filtered set, which makes "stay in place"
       the same thing as "move to the next one". */ const from = openIndex < 0 ? 0 : openIndex;
        const next = (from + delta + visible.length) % visible.length;
        setOpenId(visible[next].id);
    };
    const closeModal = ()=>{
        setOpenId(null);
        if (routeId) history.replace({
            pathname: "/photo-review",
            search: location.search
        });
    };
    /* ---------------------------------------------------------------- filters */ const setSingle = (key, option)=>{
        setChosen((prev)=>({
                ...prev,
                [key]: option
            }));
        setFilter((prev)=>({
                ...prev,
                [key]: option ? $a11cc2758244e822$var$idOf(option) : ""
            }));
    };
    const setArray = (key, list)=>setFilter((prev)=>({
                ...prev,
                [key]: list
            }));
    /* Names for values that arrived as bare ids — see `useLabelCache`. */ const { labels: labels, remember: rememberLabels, nameFor: nameFor } = (0, $a9e321bb60aaf998$export$243aa1fcbfd1886a)();
    /* One request per pause, not per keystroke (spec/03 — 250 ms). */ const commentTimer = (0, $cQmXV.useRef)(null);
    const [commentDraft, setCommentDraft] = (0, $cQmXV.useState)(initial.filter.comment || "");
    const onComment = (value)=>{
        setCommentDraft(value);
        clearTimeout(commentTimer.current);
        commentTimer.current = setTimeout(()=>setFilter((prev)=>({
                    ...prev,
                    comment: value
                })), $a11cc2758244e822$var$FILTER_DEBOUNCE_MS);
    };
    const resetFilters = ()=>{
        setFilter($a11cc2758244e822$var$blankFilter());
        setChosen({});
        setCommentDraft("");
        setRange((0, $cc63266e8518a62e$export$33e9fd85c7cf1b3c)());
        setStatusFilter("all");
        setSelected(new Set());
        setPreset(null);
        setPresetName("");
    };
    const clearChip = (key, value)=>{
        if (key === "comment") {
            setCommentDraft("");
            setFilter((prev)=>({
                    ...prev,
                    comment: ""
                }));
            return;
        }
        if ($a11cc2758244e822$var$SINGLE_KEYS.includes(key)) {
            setSingle(key, null);
            return;
        }
        setFilter((prev)=>({
                ...prev,
                [key]: (prev[key] || []).filter((v)=>String($a11cc2758244e822$var$idOf(v)) !== String(value))
            }));
    };
    const chips = (0, $cQmXV.useMemo)(()=>{
        const out = [];
        if (range?.[0] && range?.[1]) {
            /* Short form, per spec/04 — `28 Jul → 11 Aug`. The year is only shown when the range
         leaves the current one, which is also what keeps the chip on one line on a phone. */ const thisYear = new Date().getFullYear();
            const sameYear = range[0].year() === thisYear && range[1].year() === thisYear;
            const fmt = new Intl.DateTimeFormat((0, $7d0f78de0b68a104$export$bd7bed267fc278f2)(lang), {
                day: "numeric",
                month: "short",
                ...sameYear ? {} : {
                    year: "numeric"
                }
            });
            out.push({
                key: "period",
                label: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b8441a9a81ffc5d6), "period", lang),
                value: `${fmt.format(range[0].toDate())} \u{2192} ${fmt.format(range[1].toDate())}`
            });
        }
        $a11cc2758244e822$var$SINGLE_KEYS.forEach((key)=>{
            if (!filter[key]) return;
            /* `chosen[key]` is the option object the select handed back, so it names itself; falling
         back to the bare id sends `nameFor` to the resolution cache. */ out.push({
                key: key,
                label: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), $a11cc2758244e822$var$CHIP_LABEL[key], lang),
                value: nameFor(key, chosen[key] ?? filter[key])
            });
        });
        $a11cc2758244e822$var$ARRAY_KEYS.forEach((key)=>{
            (filter[key] || []).forEach((v)=>out.push({
                    key: key,
                    id: $a11cc2758244e822$var$idOf(v),
                    label: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), $a11cc2758244e822$var$CHIP_LABEL[key], lang),
                    value: nameFor(key, v)
                }));
        });
        if (filter.comment) out.push({
            key: "comment",
            label: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), "comment", lang),
            value: filter.comment
        });
        return out;
    /* `labels` is a dependency: a chip that arrived as an id has to re-render once its name lands. */ // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        filter,
        chosen,
        labels,
        range,
        lang
    ]);
    /* ---------------------------------------------------------------- presets */ const applyPreset = (option)=>{
        setPreset(option);
        if (!option) {
            resetFilters();
            return;
        }
        let parsed = {};
        try {
            parsed = JSON.parse(option.filters_string) || {};
        } catch (error) {
            parsed = {};
        }
        /* A preset saved before #1581 carries the single `point__network` id. */ if (parsed.point__network && !parsed.point__networks?.length) parsed.point__networks = [
            {
                id: parsed.point__network
            }
        ];
        delete parsed.point__network;
        // A saved filter may predate a field, so start from the full shape.
        setFilter({
            ...$a11cc2758244e822$var$blankFilter(),
            ...parsed,
            comment: parsed.comment || ""
        });
        setChosen({});
        setCommentDraft(parsed.comment || "");
        setPresetName(option.label || option.name || "");
    };
    const savePreset = ()=>{
        const name = presetName.trim();
        if (!name) {
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).error((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f544127b46daf517), "valid_error_msg", lang), {
                position: "top"
            });
            return;
        }
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "POST",
            url: "filters/",
            post: {
                name: name,
                is_active: true,
                filters_string: JSON.stringify(filter)
            }
        }, (response)=>{
            if (!response?.id) {
                (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).warning((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f544127b46daf517), "valid_error_msg", lang), {
                    position: "top"
                });
                return;
            }
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success(t("filter_saved_msg"), {
                position: "top"
            });
            setPreset({
                ...response,
                label: name
            });
            setPresetVersion((v)=>v + 1);
        });
    };
    const removePreset = ()=>{
        if (!preset?.id) {
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).warning((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f544127b46daf517), "remove_confirmation_msg", lang), {
                position: "top"
            });
            return;
        }
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "DELETE",
            url: `filters/${preset.id}/`
        }, (response)=>{
            if (response?.ok !== true) return;
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f544127b46daf517), "remove_success_msg", lang), {
                position: "top"
            });
            setPreset(null);
            setPresetName("");
            setPresetVersion((v)=>v + 1);
            resetFilters();
        });
    };
    /* --------------------------------------------------------------- download */ const exportImages = (urls)=>{
        if (!urls.length) return;
        setExporting(true);
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "POST",
            url: "images/export/",
            post: {
                images: urls
            }
        }, ()=>setExporting(false), {}, true);
    };
    const firstPhotos = (items)=>items.map((item)=>item.photo?.[0]).filter(Boolean);
    /* ------------------------------------------------------------- selection */ const toggle = (id)=>setSelected((prev)=>{
            const next = new Set(prev);
            next.has(id) ? next.delete(id) : next.add(id);
            return next;
        });
    const toggleAll = ()=>{
        const allOn = visible.length > 0 && visible.every((item)=>selected.has(item.id));
        setSelected(allOn ? new Set() : new Set(visible.map((item)=>item.id)));
    };
    /* `React.memo` on the card only pays off if its handlers are referentially stable, and
     `toggle`/`decide` close over half the page's state. Rather than `useCallback` all the way
     down that chain, the current versions live in a ref and the card gets four handlers that
     never change identity. */ const latest = (0, $cQmXV.useRef)({});
    latest.current = {
        toggle: toggle,
        decide: decide
    };
    const onCardToggle = (0, $cQmXV.useCallback)((item)=>latest.current.toggle(item.id), []);
    const onCardOpen = (0, $cQmXV.useCallback)((item)=>setOpenId(item.id), []);
    const onCardApprove = (0, $cQmXV.useCallback)((item)=>latest.current.decide(item, true, false), []);
    const onCardReject = (0, $cQmXV.useCallback)((item)=>latest.current.decide(item, false, false), []);
    /* ------------------------------------------------------------------ render */ /* `<Form.Item label>` per spec/02, and the Form.Item IS the grid item. The Form is
     `component={false}` — there is nothing to submit here, filters apply as they change, and a
     real <form> would turn Enter in the comment box into a page reload. */ const field = (labelKey, control, col = $a11cc2758244e822$var$FIELD_COL)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $cde227eb983ae1d2$export$2e2bcd8739ae039), {
            ...col,
            children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                label: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), labelKey, lang),
                children: control
            })
        }, labelKey);
    const selectedItems = data.filter((item)=>selected.has(item.id));
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
        vertical: true,
        gap: "middle",
        className: "shell-content pr",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                className: "pr-head",
                justify: "space-between",
                align: "flex-end",
                gap: "middle",
                wrap: true,
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Title, {
                        level: 1,
                        className: "pr-title",
                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$72266474e9355649), "photo_report", lang)
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $eb1133c43d00490b$export$2e2bcd8739ae039), {
                        className: "pr-head__actions",
                        wrap: true,
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $1e5256cf9d329b2c$export$2e2bcd8739ae039), {
                                title: t("print_hint"),
                                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                    icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $15d85cc2607f0b44$export$2e2bcd8739ae039), {}),
                                    onClick: ()=>window.print(),
                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f544127b46daf517), "export", lang)
                                })
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                type: "primary",
                                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $a8f7d355c4714d40$export$2e2bcd8739ae039), {}),
                                loading: exporting,
                                disabled: !visible.length,
                                onClick: ()=>exportImages(firstPhotos(visible)),
                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f544127b46daf517), "downloadAll", lang)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b4fda840b736e640$export$2e2bcd8739ae039), {
                className: "pr-filters",
                variant: "outlined",
                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039), {
                    layout: "vertical",
                    component: false,
                    colon: false,
                    children: [
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $db6c3adada49524e$export$2e2bcd8739ae039), {
                            gutter: [
                                12,
                                12
                            ],
                            className: "pr-filters__grid",
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $cde227eb983ae1d2$export$2e2bcd8739ae039), {
                                    ...$a11cc2758244e822$var$FIELD_COL_WIDE,
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                        label: t("period"),
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $cc63266e8518a62e$export$2e2bcd8739ae039), {
                                            value: range,
                                            onChange: setRange,
                                            maxDays: $a11cc2758244e822$var$MAX_RANGE_DAYS,
                                            earliest: $a11cc2758244e822$var$earliestDay(),
                                            clearTo: (0, $cc63266e8518a62e$export$33e9fd85c7cf1b3c)
                                        })
                                    })
                                }),
                                field("region", /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b6929c6a194abc34$export$2e2bcd8739ae039), {
                                    entity: "county",
                                    value: filter.county,
                                    seed: chosen.county,
                                    prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $68eebcef827bb540$export$2e2bcd8739ae039), {}),
                                    onChange: (o)=>setSingle("county", o),
                                    onResolve: rememberLabels("county")
                                })),
                                field("network", /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b6929c6a194abc34$export$2e2bcd8739ae039), {
                                    entity: "network",
                                    isMulti: true,
                                    value: filter.point__networks,
                                    prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $f48fe90789d2a71a$export$2e2bcd8739ae039), {}),
                                    onChange: (list)=>setArray("point__networks", list),
                                    onResolve: rememberLabels("point__networks")
                                })),
                                field("points", /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b6929c6a194abc34$export$2e2bcd8739ae039), {
                                    entity: "points",
                                    isMulti: true,
                                    value: filter.points,
                                    county: filter.county,
                                    /* `EntitySelect` can scope its point list by ONE network; with several picked the
                   scope is dropped rather than silently narrowed to the first. */ moduleFilter: filter.point__networks?.length === 1 ? $a11cc2758244e822$var$idOf(filter.point__networks[0]) : null,
                                    prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $a1f80a723f71d713$export$2e2bcd8739ae039), {}),
                                    onChange: (list)=>setArray("points", list),
                                    onResolve: rememberLabels("points")
                                })),
                                field("merchandisers", /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b6929c6a194abc34$export$2e2bcd8739ae039), {
                                    entity: "merchandisers",
                                    isMulti: true,
                                    value: filter.users,
                                    prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e85f2e3cc711f245$export$2e2bcd8739ae039), {}),
                                    onChange: (list)=>setArray("users", list),
                                    onResolve: rememberLabels("users")
                                })),
                                field("clients", /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b6929c6a194abc34$export$2e2bcd8739ae039), {
                                    entity: "clients",
                                    value: filter.clients,
                                    seed: chosen.clients,
                                    prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $6238f9dab5cff517$export$2e2bcd8739ae039), {}),
                                    onChange: (o)=>setSingle("clients", o),
                                    onResolve: rememberLabels("clients")
                                })),
                                field("comment", /* No placeholder: the field's own label already names it, and a repeat of the label
               inside the box reads as pre-filled text. */ /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0883e7f8083c01b0$export$2e2bcd8739ae039), {
                                    value: commentDraft,
                                    prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $20a259d46bffcb08$export$2e2bcd8739ae039), {}),
                                    allowClear: true,
                                    onChange: (event)=>onComment(event.target.value)
                                }))
                            ]
                        }),
                        showExtra && /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $db6c3adada49524e$export$2e2bcd8739ae039), {
                            gutter: [
                                12,
                                12
                            ],
                            className: "pr-filters__grid pr-filters__grid--extra",
                            children: [
                                field("categories", /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b6929c6a194abc34$export$2e2bcd8739ae039), {
                                    entity: "categories",
                                    isMulti: true,
                                    value: filter.categories,
                                    prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e6f9777135677668$export$2e2bcd8739ae039), {}),
                                    onChange: (list)=>setArray("categories", list),
                                    onResolve: rememberLabels("categories")
                                })),
                                field("subcategories", /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b6929c6a194abc34$export$2e2bcd8739ae039), {
                                    entity: "subcategories",
                                    isMulti: true,
                                    value: filter.subcategories,
                                    prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $68e85fc2f9283018$export$2e2bcd8739ae039), {}),
                                    onChange: (list)=>setArray("subcategories", list),
                                    onResolve: rememberLabels("subcategories")
                                })),
                                field("brands", /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b6929c6a194abc34$export$2e2bcd8739ae039), {
                                    entity: "brands",
                                    isMulti: true,
                                    value: filter.brands,
                                    prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $d520e945c3123459$export$2e2bcd8739ae039), {}),
                                    onChange: (list)=>setArray("brands", list),
                                    onResolve: rememberLabels("brands")
                                })),
                                field("products", /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b6929c6a194abc34$export$2e2bcd8739ae039), {
                                    entity: "products",
                                    isMulti: true,
                                    value: filter.products,
                                    prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $268dc9f9b8c7fd21$export$2e2bcd8739ae039), {}),
                                    onChange: (list)=>setArray("products", list),
                                    onResolve: rememberLabels("products")
                                })),
                                field("tags", /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b6929c6a194abc34$export$2e2bcd8739ae039), {
                                    entity: "tags",
                                    isMulti: true,
                                    value: filter.tags,
                                    prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $acd344b554ad3277$export$2e2bcd8739ae039), {}),
                                    onChange: (list)=>setArray("tags", list),
                                    onResolve: rememberLabels("tags")
                                }))
                            ]
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                            vertical: true,
                            className: "pr-presets",
                            children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                label: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), "custom_filter", lang),
                                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $eb1133c43d00490b$export$2e2bcd8739ae039), {
                                    wrap: true,
                                    children: [
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b6929c6a194abc34$export$2e2bcd8739ae039), {
                                            className: "pr-presets__pick",
                                            entity: "filters",
                                            value: preset,
                                            prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $9224f489e607325f$export$2e2bcd8739ae039), {}),
                                            ariaLabel: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), "custom_filter", lang),
                                            onChange: applyPreset
                                        }, presetVersion),
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0883e7f8083c01b0$export$2e2bcd8739ae039), {
                                            className: "pr-presets__name",
                                            value: presetName,
                                            prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $9224f489e607325f$export$2e2bcd8739ae039), {}),
                                            "aria-label": (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), "filter_name_placeholder", lang),
                                            placeholder: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), "filter_name_placeholder", lang),
                                            onChange: (event)=>setPresetName(event.target.value)
                                        }),
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                            size: "small",
                                            icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $7f0f32b5e0f33a0e$export$2e2bcd8739ae039), {}),
                                            onClick: savePreset,
                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), "filter_save", lang)
                                        }),
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $06cf5142874b7968$export$2e2bcd8739ae039), {
                                            title: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f544127b46daf517), "confirmation_msg", lang),
                                            okText: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), "filter_remove", lang),
                                            cancelText: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f544127b46daf517), "cancel", lang),
                                            okButtonProps: {
                                                danger: true
                                            },
                                            onConfirm: removePreset,
                                            children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                                size: "small",
                                                danger: true,
                                                type: "text",
                                                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5234c28d879e38c1$export$2e2bcd8739ae039), {}),
                                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), "filter_remove", lang)
                                            })
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                            className: "pr-filters__foot",
                            align: "center",
                            gap: "small",
                            wrap: true,
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $a9e321bb60aaf998$export$2e2bcd8739ae039), {
                                    items: chips,
                                    closeLabel: t("a_remove_filter"),
                                    onClose: (key, id)=>key === "period" ? setRange((0, $cc63266e8518a62e$export$33e9fd85c7cf1b3c)()) : clearChip(key, id)
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                    type: "text",
                                    size: "small",
                                    icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b6833bd3d006f741$export$2e2bcd8739ae039), {}),
                                    "aria-expanded": showExtra,
                                    onClick: ()=>setShowExtra((v)=>!v),
                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), "additional_filters", lang)
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                    size: "small",
                                    onClick: resetFilters,
                                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), "filter_reset", lang)
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                className: "pr-toolbar",
                align: "center",
                gap: "middle",
                wrap: true,
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $ac40310dc424be23$export$2e2bcd8739ae039), {
                        value: statusFilter,
                        onChange: setStatusFilter,
                        options: $a11cc2758244e822$var$STATUS_SEGMENTS.map(([value, key])=>({
                                value: value,
                                label: t(key)
                            }))
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $ac40310dc424be23$export$2e2bcd8739ae039), {
                        value: viewMode,
                        onChange: (value)=>{
                            setViewMode(value);
                            setSelected(new Set());
                        },
                        options: [
                            {
                                value: "single",
                                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $9f1db3a3fd7715e2$export$2e2bcd8739ae039), {}),
                                label: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), "photo_review_type_single", lang)
                            },
                            {
                                value: "group",
                                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $37ec80fabde4926c$export$2e2bcd8739ae039), {}),
                                label: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), "photo_review_type_group", lang)
                            }
                        ]
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                        type: "text",
                        size: "small",
                        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $28c0ad5395372ff7$export$2e2bcd8739ae039), {}),
                        disabled: !visible.length,
                        onClick: toggleAll,
                        children: t("select_all")
                    })
                ]
            }),
            loading ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $db6c3adada49524e$export$2e2bcd8739ae039), {
                gutter: [
                    16,
                    16
                ],
                className: "pr-grid",
                children: Array.from({
                    length: 8
                }, (_, i)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $cde227eb983ae1d2$export$2e2bcd8739ae039), {
                        ...$a11cc2758244e822$var$CARD_COL,
                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a11cc2758244e822$var$CardSkeleton, {})
                    }, i))
            }) : visible.length ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $db6c3adada49524e$export$2e2bcd8739ae039), {
                gutter: [
                    16,
                    16
                ],
                className: "pr-grid",
                children: visible.map((item)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $cde227eb983ae1d2$export$2e2bcd8739ae039), {
                        ...$a11cc2758244e822$var$CARD_COL,
                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a11cc2758244e822$var$PhotoCard, {
                            item: item,
                            lang: lang,
                            grouped: viewMode === "group",
                            isSelected: selected.has(item.id),
                            busy: busyId === item.id,
                            onToggle: onCardToggle,
                            onOpen: onCardOpen,
                            onApprove: onCardApprove,
                            onReject: onCardReject
                        })
                    }, item.id))
            }) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $99350450b877904c$export$2e2bcd8739ae039), {
                className: "pr-empty",
                image: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $c3b8d7d247171904$export$2e2bcd8739ae039), {
                    className: "pr-empty__glyph-icon"
                }),
                description: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $575603080129eb00$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Title, {
                            level: 5,
                            className: "pr-empty__title",
                            children: t("empty_title")
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                            type: "secondary",
                            className: "pr-empty__desc",
                            children: t("empty_desc")
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                    onClick: resetFilters,
                    children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), "filter_reset", lang)
                })
            }),
            hasNext && !loading && /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                className: "pr-loadmore",
                justify: "center",
                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                    icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e7119b602540b2c5$export$2e2bcd8739ae039), {}),
                    loading: loadingMore,
                    onClick: ()=>fetchPage(page.current + 1, true),
                    children: t("load_more")
                })
            }),
            selected.size > 0 && /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                className: "pr-bulkbar",
                role: "region",
                "aria-label": t("select_all"),
                align: "center",
                gap: "middle",
                wrap: true,
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                        strong: true,
                        className: "pr-bulkbar__n",
                        children: (0, $3b579ca6158bc61b$export$9563e054e6f787fb)(t("w_selected"), {
                            n: selected.size
                        })
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $eb1133c43d00490b$export$2e2bcd8739ae039), {
                        className: "pr-bulkbar__acts",
                        wrap: true,
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                size: "small",
                                onClick: ()=>setSelected(new Set()),
                                children: t("clear_selection")
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                size: "small",
                                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $a8f7d355c4714d40$export$2e2bcd8739ae039), {}),
                                loading: exporting,
                                onClick: ()=>exportImages(firstPhotos(selectedItems)),
                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f544127b46daf517), "download", lang)
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                size: "small",
                                className: "pr-btn--no",
                                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $bdfb1f797481a352$export$2e2bcd8739ae039), {}),
                                loading: busyId === "bulk",
                                onClick: ()=>bulkDecide(false),
                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ce86776e5caf6dd0), "reject_btn", lang)
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                size: "small",
                                type: "primary",
                                className: "pr-btn--ok",
                                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $45839ed7c4a7faa2$export$2e2bcd8739ae039), {}),
                                loading: busyId === "bulk",
                                onClick: ()=>bulkDecide(true),
                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ce86776e5caf6dd0), "approv_btn", lang)
                            })
                        ]
                    })
                ]
            }),
            openItem && !rejecting && /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $bc657e1ecc306871$export$2e2bcd8739ae039), {
                item: openItem,
                position: openIndex + 1,
                total: visible.length,
                lang: lang,
                busy: busyId === openItem.id,
                onClose: closeModal,
                onPrev: ()=>step(-1),
                onNext: ()=>step(1),
                onApprove: ()=>decide(openItem, true, true),
                onReject: ()=>decide(openItem, false, true)
            }),
            rejecting && /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $9525ffc2d869d787$export$2e2bcd8739ae039), {
                /* The photo report's own shape, mapped at the call site now that the modal is shared:
             `picsell_info` is where this endpoint carries the approvable object's identity. */ target: {
                    objectId: rejecting.item.picsell_info?.object_id,
                    objectType: rejecting.item.picsell_info?.object_type
                },
                photo: rejecting.item.photo?.[0],
                point: rejecting.item.visit?.point,
                visitId: rejecting.item.visit_id,
                lang: lang,
                onCancel: ()=>setRejecting(null),
                onDone: ()=>{
                    const { item: item, advance: advance } = rejecting;
                    patchLocal([
                        item.id
                    ], false);
                    setRejecting(null);
                    if (advance) step(1);
                }
            })
        ]
    });
}



parcelRequire("cQmXV");
/* ResourceList — the page frame around `ResourceTable`.
 *
 * spec/03 archetype A's head, and nothing else: the shell owns the navigation, `ResourceTable`
 * owns the filter card, the table card and the bulk bar. The head is title + one-line subtitle +
 * the primary action, as `/visit`, `/supervisors` and `/points` all draw it — the New button used
 * to sit in the table's toolbar, which put the page's one primary action somewhere no other list
 * keeps it.
 */ 
parcelRequire("cQmXV");


/* ResourceTable — the descriptor-driven list, on antd.
 *
 * One table for every admin entity in `resources/` (networks, categories, countries, counties,
 * localities, point_groups, points, merchandisers, supervisors, surveys). It renders spec/03
 * archetype A out of the shared parts the redesigned pages already use — `list-page.scss`'s
 * `lp-*` chrome, `EntitySelect`, `FilterChips`, `table-cells`' `StatusIcon` / `RowActions` /
 * `TableFoot` — so a reference list reads as the same product as /visit and /supervisors.
 *
 * Everything still comes from the descriptor: `columns` (with `format` / `sort`), `filters`
 * (entity pickers, `scopeBy` scoping, `defaultRegion` seeding, `type: "me"` toggles), and
 * `softDelete` / `deactivation` for the status glyph.
 *
 * Behaviour kept from the legacy table, deliberately:
 * - **Filter state is remembered per resource in `sessionStorage`** (`rt:<slug>`), so returning
 *   from a record restores the search, filters, sort and page rather than resetting them. That is
 *   why this page does not put its filters in the URL as /visit does: the state is already
 *   restored on the way back, and the two mechanisms would fight over which one wins.
 * - **Sorting is server-side**, over `descriptor.columns[].sort` (or `name` by convention). A
 *   column with no sort key does not sort — `format`-only columns are computed client-side, so
 *   sorting them could only reorder the loaded page.
 * - **The selection is the bulk archive's, and only that.** The descriptor's old `bulkActions`
 *   slot went with the grouping panel: the one action that used it ("add to group") is now a
 *   modal on the bespoke /points list, so a checkbox here means exactly one thing.
 *
 * One thing the archetype asks for and this table does NOT have, for want of an endpoint: an
 * active/archived `<Segmented>` split. The archived rows come back mixed into the list with a
 * status flag, so the state is shown per row (the leading glyph) rather than as a working-set
 * filter. Adding the split is a backend change; counts are not — the number beside a filter was
 * removed app-wide.
 */ 

var $cQmXV = parcelRequire("cQmXV");




/* A leading glyph for a descriptor field's control, so the edit form reads like the mockups (each
 * `.ctl` there carries a material-symbol icon). Resolved automatically from the field so no
 * descriptor has to spell one out — but a field may override with its own `icon` component.
 *
 * Order: explicit `field.icon` → by field name → by entity (for entity fields) → by type. Returns
 * a rendered element (so callers just drop it into a `prefix`), or null when nothing fits.
 */ 
parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");
var $3ed705f09a292c57$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($3ed705f09a292c57$exports, "__esModule", {
    value: true
});
var $3ed705f09a292c57$var$BarcodeOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M120 160H72c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8zm833 0h-48c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8zM200 736h112c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8H200c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8zm321 0h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8zm126 0h178c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8H647c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8zm-255 0h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8zm-79 64H201c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h112c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm257 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm256 0H648c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h178c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-385 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "barcode",
    "theme": "outlined"
};
$3ed705f09a292c57$exports.default = $3ed705f09a292c57$var$BarcodeOutlined;



function $de066d687a269ad0$var$_extends() {
    $de066d687a269ad0$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $de066d687a269ad0$var$_extends.apply(this, arguments);
}
const $de066d687a269ad0$var$BarcodeOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $de066d687a269ad0$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3ed705f09a292c57$exports)))
    }));
/**![barcode](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTEyMCAxNjBINzJjLTQuNCAwLTggMy42LTggOHY2ODhjMCA0LjQgMy42IDggOCA4aDQ4YzQuNCAwIDgtMy42IDgtOFYxNjhjMC00LjQtMy42LTgtOC04em04MzMgMGgtNDhjLTQuNCAwLTggMy42LTggOHY2ODhjMCA0LjQgMy42IDggOCA4aDQ4YzQuNCAwIDgtMy42IDgtOFYxNjhjMC00LjQtMy42LTgtOC04ek0yMDAgNzM2aDExMmM0LjQgMCA4LTMuNiA4LThWMTY4YzAtNC40LTMuNi04LTgtOEgyMDBjLTQuNCAwLTggMy42LTggOHY1NjBjMCA0LjQgMy42IDggOCA4em0zMjEgMGg0OGM0LjQgMCA4LTMuNiA4LThWMTY4YzAtNC40LTMuNi04LTgtOGgtNDhjLTQuNCAwLTggMy42LTggOHY1NjBjMCA0LjQgMy42IDggOCA4em0xMjYgMGgxNzhjNC40IDAgOC0zLjYgOC04VjE2OGMwLTQuNC0zLjYtOC04LThINjQ3Yy00LjQgMC04IDMuNi04IDh2NTYwYzAgNC40IDMuNiA4IDggOHptLTI1NSAwaDQ4YzQuNCAwIDgtMy42IDgtOFYxNjhjMC00LjQtMy42LTgtOC04aC00OGMtNC40IDAtOCAzLjYtOCA4djU2MGMwIDQuNCAzLjYgOCA4IDh6bS03OSA2NEgyMDFjLTQuNCAwLTggMy42LTggOHY0OGMwIDQuNCAzLjYgOCA4IDhoMTEyYzQuNCAwIDgtMy42IDgtOHYtNDhjMC00LjQtMy42LTgtOC04em0yNTcgMGgtNDhjLTQuNCAwLTggMy42LTggOHY0OGMwIDQuNCAzLjYgOCA4IDhoNDhjNC40IDAgOC0zLjYgOC04di00OGMwLTQuNC0zLjYtOC04LTh6bTI1NiAwSDY0OGMtNC40IDAtOCAzLjYtOCA4djQ4YzAgNC40IDMuNiA4IDggOGgxNzhjNC40IDAgOC0zLjYgOC04di00OGMwLTQuNC0zLjYtOC04LTh6bS0zODUgMGgtNDhjLTQuNCAwLTggMy42LTggOHY0OGMwIDQuNCAzLjYgOCA4IDhoNDhjNC40IDAgOC0zLjYgOC04di00OGMwLTQuNC0zLjYtOC04LTh6IiAvPjwvc3ZnPg==) */ const $de066d687a269ad0$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($de066d687a269ad0$var$BarcodeOutlined);
var $de066d687a269ad0$export$2e2bcd8739ae039 = $de066d687a269ad0$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $4499440f6c8053f1$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($4499440f6c8053f1$exports, "__esModule", {
    value: true
});
var $4499440f6c8053f1$var$FieldNumberOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M508 280h-63.3c-3.3 0-6 2.7-6 6v340.2H433L197.4 282.6c-1.1-1.6-3-2.6-4.9-2.6H126c-3.3 0-6 2.7-6 6v464c0 3.3 2.7 6 6 6h62.7c3.3 0 6-2.7 6-6V405.1h5.7l238.2 348.3c1.1 1.6 3 2.6 5 2.6H508c3.3 0 6-2.7 6-6V286c0-3.3-2.7-6-6-6zm378 413H582c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-152.2-63c52.9 0 95.2-17.2 126.2-51.7 29.4-32.9 44-75.8 44-128.8 0-53.1-14.6-96.5-44-129.3-30.9-34.8-73.2-52.2-126.2-52.2-53.7 0-95.9 17.5-126.3 52.8-29.2 33.1-43.4 75.9-43.4 128.7 0 52.4 14.3 95.2 43.5 128.3 30.6 34.7 73 52.2 126.2 52.2zm-71.5-263.7c16.9-20.6 40.3-30.9 71.4-30.9 31.5 0 54.8 9.6 71 29.1 16.4 20.3 24.9 48.6 24.9 84.9 0 36.3-8.4 64.1-24.8 83.9-16.5 19.4-40 29.2-71.1 29.2-31.2 0-55-10.3-71.4-30.4-16.3-20.1-24.5-47.3-24.5-82.6.1-35.8 8.2-63 24.5-83.2z"
                }
            }
        ]
    },
    "name": "field-number",
    "theme": "outlined"
};
$4499440f6c8053f1$exports.default = $4499440f6c8053f1$var$FieldNumberOutlined;



function $33c50e9dcee24ce6$var$_extends() {
    $33c50e9dcee24ce6$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $33c50e9dcee24ce6$var$_extends.apply(this, arguments);
}
const $33c50e9dcee24ce6$var$FieldNumberOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $33c50e9dcee24ce6$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4499440f6c8053f1$exports)))
    }));
/**![field-number](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUwOCAyODBoLTYzLjNjLTMuMyAwLTYgMi43LTYgNnYzNDAuMkg0MzNMMTk3LjQgMjgyLjZjLTEuMS0xLjYtMy0yLjYtNC45LTIuNkgxMjZjLTMuMyAwLTYgMi43LTYgNnY0NjRjMCAzLjMgMi43IDYgNiA2aDYyLjdjMy4zIDAgNi0yLjcgNi02VjQwNS4xaDUuN2wyMzguMiAzNDguM2MxLjEgMS42IDMgMi42IDUgMi42SDUwOGMzLjMgMCA2LTIuNyA2LTZWMjg2YzAtMy4zLTIuNy02LTYtNnptMzc4IDQxM0g1ODJjLTQuNCAwLTggMy42LTggOHY0OGMwIDQuNCAzLjYgOCA4IDhoMzA0YzQuNCAwIDgtMy42IDgtOHYtNDhjMC00LjQtMy42LTgtOC04em0tMTUyLjItNjNjNTIuOSAwIDk1LjItMTcuMiAxMjYuMi01MS43IDI5LjQtMzIuOSA0NC03NS44IDQ0LTEyOC44IDAtNTMuMS0xNC42LTk2LjUtNDQtMTI5LjMtMzAuOS0zNC44LTczLjItNTIuMi0xMjYuMi01Mi4yLTUzLjcgMC05NS45IDE3LjUtMTI2LjMgNTIuOC0yOS4yIDMzLjEtNDMuNCA3NS45LTQzLjQgMTI4LjcgMCA1Mi40IDE0LjMgOTUuMiA0My41IDEyOC4zIDMwLjYgMzQuNyA3MyA1Mi4yIDEyNi4yIDUyLjJ6bS03MS41LTI2My43YzE2LjktMjAuNiA0MC4zLTMwLjkgNzEuNC0zMC45IDMxLjUgMCA1NC44IDkuNiA3MSAyOS4xIDE2LjQgMjAuMyAyNC45IDQ4LjYgMjQuOSA4NC45IDAgMzYuMy04LjQgNjQuMS0yNC44IDgzLjktMTYuNSAxOS40LTQwIDI5LjItNzEuMSAyOS4yLTMxLjIgMC01NS0xMC4zLTcxLjQtMzAuNC0xNi4zLTIwLjEtMjQuNS00Ny4zLTI0LjUtODIuNi4xLTM1LjggOC4yLTYzIDI0LjUtODMuMnoiIC8+PC9zdmc+) */ const $33c50e9dcee24ce6$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($33c50e9dcee24ce6$var$FieldNumberOutlined);
var $33c50e9dcee24ce6$export$2e2bcd8739ae039 = $33c50e9dcee24ce6$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $61856fe733f7784b$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($61856fe733f7784b$exports, "__esModule", {
    value: true
});
var $61856fe733f7784b$var$AlignLeftOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M120 230h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0 424h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm784 140H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-424H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "align-left",
    "theme": "outlined"
};
$61856fe733f7784b$exports.default = $61856fe733f7784b$var$AlignLeftOutlined;



function $e86fc63b6cae696a$var$_extends() {
    $e86fc63b6cae696a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e86fc63b6cae696a$var$_extends.apply(this, arguments);
}
const $e86fc63b6cae696a$var$AlignLeftOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $e86fc63b6cae696a$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($61856fe733f7784b$exports)))
    }));
/**![align-left](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTEyMCAyMzBoNDk2YzQuNCAwIDgtMy42IDgtOHYtNTZjMC00LjQtMy42LTgtOC04SDEyMGMtNC40IDAtOCAzLjYtOCA4djU2YzAgNC40IDMuNiA4IDggOHptMCA0MjRoNDk2YzQuNCAwIDgtMy42IDgtOHYtNTZjMC00LjQtMy42LTgtOC04SDEyMGMtNC40IDAtOCAzLjYtOCA4djU2YzAgNC40IDMuNiA4IDggOHptNzg0IDE0MEgxMjBjLTQuNCAwLTggMy42LTggOHY1NmMwIDQuNCAzLjYgOCA4IDhoNzg0YzQuNCAwIDgtMy42IDgtOHYtNTZjMC00LjQtMy42LTgtOC04em0wLTQyNEgxMjBjLTQuNCAwLTggMy42LTggOHY1NmMwIDQuNCAzLjYgOCA4IDhoNzg0YzQuNCAwIDgtMy42IDgtOHYtNTZjMC00LjQtMy42LTgtOC04eiIgLz48L3N2Zz4=) */ const $e86fc63b6cae696a$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($e86fc63b6cae696a$var$AlignLeftOutlined);
var $e86fc63b6cae696a$export$2e2bcd8739ae039 = $e86fc63b6cae696a$var$RefIcon;


/** By exact field name — the strongest signal, since these names are stable across entities. */ const $5cf5963f505f5084$var$NAME_ICON = {
    name: (0, $3ad3610a8cd8d8e0$export$2e2bcd8739ae039),
    title: (0, $3ad3610a8cd8d8e0$export$2e2bcd8739ae039),
    code: (0, $de066d687a269ad0$export$2e2bcd8739ae039),
    address: (0, $d6c8837c82724a15$export$2e2bcd8739ae039),
    phone_number: (0, $efbc782831576418$export$2e2bcd8739ae039),
    minutes_recommended: (0, $7b23ac4854de9809$export$2e2bcd8739ae039)
};
/** By the entity an `entity` field points at — reuses the nav/entity glyph vocabulary. */ const $5cf5963f505f5084$var$ENTITY_ICON = {
    network: (0, $6238f9dab5cff517$export$2e2bcd8739ae039),
    categories_point: (0, $e6f9777135677668$export$2e2bcd8739ae039),
    categories: (0, $e6f9777135677668$export$2e2bcd8739ae039),
    countries: (0, $8afda6637c46830f$export$2e2bcd8739ae039),
    county: (0, $68eebcef827bb540$export$2e2bcd8739ae039),
    counties: (0, $68eebcef827bb540$export$2e2bcd8739ae039),
    locality: (0, $68e85fc2f9283018$export$2e2bcd8739ae039),
    localities: (0, $68e85fc2f9283018$export$2e2bcd8739ae039),
    merchandiser: (0, $e85f2e3cc711f245$export$2e2bcd8739ae039),
    supervisor: (0, $d5baeea001a6abe5$export$2e2bcd8739ae039),
    created_by: (0, $d5baeea001a6abe5$export$2e2bcd8739ae039),
    point: (0, $a1f80a723f71d713$export$2e2bcd8739ae039),
    points: (0, $a1f80a723f71d713$export$2e2bcd8739ae039),
    point_groups: (0, $8e67197b587f6486$export$2e2bcd8739ae039),
    networks: (0, $f48fe90789d2a71a$export$2e2bcd8739ae039),
    tags: (0, $acd344b554ad3277$export$2e2bcd8739ae039),
    brands: (0, $d520e945c3123459$export$2e2bcd8739ae039),
    products: (0, $268dc9f9b8c7fd21$export$2e2bcd8739ae039),
    subcategories: (0, $68e85fc2f9283018$export$2e2bcd8739ae039)
};
/** Fallback by field type. */ const $5cf5963f505f5084$var$TYPE_ICON = {
    number: (0, $33c50e9dcee24ce6$export$2e2bcd8739ae039),
    datetime: (0, $3368c84d60c50017$export$2e2bcd8739ae039),
    location: (0, $d6c8837c82724a15$export$2e2bcd8739ae039),
    coordinate: (0, $d6c8837c82724a15$export$2e2bcd8739ae039),
    textarea: (0, $e86fc63b6cae696a$export$2e2bcd8739ae039)
};
function $5cf5963f505f5084$var$iconComponent(field) {
    if (field.icon) return field.icon;
    if ($5cf5963f505f5084$var$NAME_ICON[field.name]) return $5cf5963f505f5084$var$NAME_ICON[field.name];
    if (field.type === "entity") return $5cf5963f505f5084$var$ENTITY_ICON[field.entity] || null;
    return $5cf5963f505f5084$var$TYPE_ICON[field.type] || null;
}
function $5cf5963f505f5084$export$2e2bcd8739ae039(field) {
    const Icon = $5cf5963f505f5084$var$iconComponent(field);
    return Icon ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)(Icon, {
        className: "pt-field-icon"
    }) : null;
}








// Shared option lists + i18n keys for the "questions" field type, used by both the edit-mode
// repeater (QuestionsField) and the read-only view (ResourceView) so labels stay in sync.
const $fc5e81b33777a483$export$cfa61bd69ae51266 = [
    "numeric",
    "text",
    "photo",
    "dropdown",
    "date",
    "boolean"
];
const $fc5e81b33777a483$export$81b4e28637de863c = {
    numeric: "answer_numeric",
    text: "answer_text",
    photo: "answer_photo",
    dropdown: "answer_dropdown",
    date: "answer_date",
    boolean: "answer_boolean"
};
const $fc5e81b33777a483$export$19868e2467c966ad = [
    0,
    1,
    2
];
const $fc5e81b33777a483$export$2a8cdb37ef652224 = {
    0: "priority_low",
    1: "priority_medium",
    2: "priority_high"
};
const $fc5e81b33777a483$export$83a015f6589bb8cf = [
    "products",
    "brands",
    "categories",
    "subcategories"
];
const $fc5e81b33777a483$export$4ed51751d1746b72 = {
    products: "mode_products",
    brands: "mode_brands",
    categories: "mode_categories",
    subcategories: "mode_subcategories"
};
const $fc5e81b33777a483$export$be5830653d73dd2d = [
    "all",
    "assortment_matrix"
];
const $fc5e81b33777a483$export$724501524e89eac8 = {
    all: "source_all",
    assortment_matrix: "source_assortment_matrix"
};
const $fc5e81b33777a483$export$69d5f3de0d42532 = [
    {
        key: "products",
        allKey: "all_products",
        entity: "products",
        labelKey: "f_products",
        allLabelKey: "f_all_products"
    },
    {
        key: "brands",
        allKey: "all_brands",
        entity: "brands",
        labelKey: "f_brands",
        allLabelKey: "f_all_brands"
    },
    {
        key: "categories",
        allKey: "all_categories",
        entity: "categories",
        labelKey: "f_categories",
        allLabelKey: "f_all_categories"
    },
    {
        key: "subcategories",
        allKey: "all_subcategories",
        entity: "subcategories",
        labelKey: "f_subcategories",
        allLabelKey: "f_all_subcategories"
    }
];
const $fc5e81b33777a483$export$2941c0a502c64c7f = [
    {
        key: "points",
        entity: "point",
        labelKey: "target_points"
    },
    {
        key: "point_groups",
        entity: "point_groups",
        labelKey: "target_point_groups"
    },
    {
        key: "networks",
        entity: "networks",
        labelKey: "target_networks"
    }
];


function $da70838858bfad8a$export$7212735dbabb867d(descriptor, { page: page = 1, size: size = 25, search: search = "", filters: filters = {}, ordering: ordering = "" } = {}) {
    const parts = [
        `page=${page}`
    ];
    // The table owns the page size (its footer offers 25/50/100); 25 is the API's
    // StandardResultsSetPagination default and the fallback for any caller that omits it.
    parts.push(`page_size=${size}`);
    if (search) parts.push(`search=${encodeURIComponent(search)}`);
    if (ordering) parts.push(`ordering=${encodeURIComponent(ordering)}`);
    Object.entries(filters).forEach(([k, v])=>{
        if (v !== undefined && v !== null && v !== "") parts.push(`${k}=${encodeURIComponent(v)}`);
    });
    return `${descriptor.endpoint}?${parts.join("&")}`;
}
function $da70838858bfad8a$export$3dddb10616f03c3a(descriptor, params, cb) {
    (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
        method: "GET",
        url: $da70838858bfad8a$export$7212735dbabb867d(descriptor, params)
    }, (r)=>{
        if (Array.isArray(r)) return cb({
            results: r,
            count: r.length
        });
        if (r && Array.isArray(r.results)) return cb({
            results: r.results,
            count: r.count ?? r.results.length
        });
        cb({
            results: [],
            count: 0
        });
    });
}
function $da70838858bfad8a$export$78af959256a39335(descriptor, id, cb) {
    (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
        method: "GET",
        url: `${descriptor.endpoint}${id}/`
    }, cb);
}
/** An entity picker hands back the full option OBJECT so a chip can name itself; the API wants pks.
 *  One definition, used for top-level entity fields and for the two field types that nest their own
 *  pickers (audience targets, per-question targeting). */ const $da70838858bfad8a$var$toId = (x)=>x && typeof x === "object" ? x.id ?? x.value ?? x : x;
const $da70838858bfad8a$var$toIds = (list)=>Array.isArray(list) ? list.map($da70838858bfad8a$var$toId) : list;
function $da70838858bfad8a$export$488773977679fb92(descriptor, item, me, cb) {
    const isNew = !item.id;
    let payload = {
        ...item
    };
    if (isNew && typeof descriptor.injectOnCreate === "function") payload = descriptor.injectOnCreate(payload, me);
    (descriptor.fields || []).forEach((f)=>{
        if (f.type !== "entity") return;
        const v = payload[f.name];
        if (v == null) return;
        payload[f.name] = Array.isArray(v) ? $da70838858bfad8a$var$toIds(v) : $da70838858bfad8a$var$toId(v);
    });
    /* The two field types whose pickers are NESTED, and so are not reached by the loop above. Both
     used to flatten to ids inside the renderer, which is why their chips could not label themselves
     once the loaded option page moved on (PICSELL-1574 #22, #34) — the unwrapping belongs at the
     edge, where the payload is built, not in the editor. */ (descriptor.fields || []).forEach((f)=>{
        if (f.type === "audience") (0, $fc5e81b33777a483$export$2941c0a502c64c7f).forEach((target)=>{
            if (target.key in payload) payload[target.key] = $da70838858bfad8a$var$toIds(payload[target.key]);
        });
        if (f.type === "questions" && Array.isArray(payload[f.name])) payload[f.name] = payload[f.name].map((question)=>{
            const out = {
                ...question
            };
            (0, $fc5e81b33777a483$export$69d5f3de0d42532).forEach((g)=>{
                if (g.key in out) out[g.key] = $da70838858bfad8a$var$toIds(out[g.key]);
            });
            return out;
        });
    });
    // An `audience` field owns no key of its own: a survey targets exactly one of points /
    // point_groups / networks, so `AudienceField` writes into those three directly. `emptyValueFor`
    // still seeds a placeholder under the field's own name, which would otherwise be POSTed as a
    // phantom `audience: null` on every create.
    (descriptor.fields || []).forEach((f)=>{
        if (f.type === "audience") delete payload[f.name];
    });
    // Image fields: only resend a File (new upload) or "" (explicit clear).
    // An unchanged value is a URL string (or null) fetched from GET — the API can't accept that back.
    const clearedImages = [];
    (descriptor.fields || []).forEach((f)=>{
        if (f.type !== "image") return;
        const v = payload[f.name];
        if (typeof File !== "undefined" && v instanceof File) return;
        if (v === "") {
            clearedImages.push(f.name);
            return;
        }
        delete payload[f.name];
    });
    const hasFile = Object.values(payload).some((v)=>typeof File !== "undefined" && v instanceof File);
    /* ⚠ How a cleared image is spelled depends on the ENCODING, because DRF only coerces `""` on its
     HTML/multipart branch:
       multipart — `""` becomes the `empty` sentinel, which a partial update turns into `SkipField`;
                   with `allow_null` on the serializer it becomes None, which its `validate()`
                   normalises back to `""` (the column is NOT NULL, so `""` is the stored "no image").
       JSON      — `""` goes straight to `ImageField.to_internal_value`, where `data.name` raises and
                   DRF answers 400 "The submitted data was not a file. Check the encoding type on the
                   form." That was the network-logo bug verbatim (PICSELL-1574 #32), and since a
                   clear carries no File, JSON is exactly the branch it takes.
     So: `null` over JSON, `""` over multipart. Needs `image = ImageField(allow_null=True)` on the
     serializer — see NetworkWriteSerializer in picsell-api. */ if (hasFile) {
        const fd = new FormData();
        /* ⚠ The object branch is unreachable today and wrong if it is ever reached: a nested object (a
       point's `location`) would arrive server-side as a JSON STRING, which the field cannot parse.
       It needs no fix because no descriptor has both an image field and an object field — `points`
       has `location` and no image, `networks` has an image and no object. Give one both and this is
       the line to revisit. */ Object.entries(payload).forEach(([k, v])=>{
            if (v === undefined || v === null) return;
            if (typeof File !== "undefined" && v instanceof File) fd.append(k, v);
            else if (Array.isArray(v)) v.forEach((item)=>fd.append(k, item));
            else if (typeof v === "object") fd.append(k, JSON.stringify(v));
            else fd.append(k, v);
        });
        (0, $c9936523dc38c641$export$e9af2f996ea0b059)({
            method: isNew ? "POST" : "PATCH",
            url: isNew ? descriptor.endpoint : `${descriptor.endpoint}${item.id}/`,
            post: fd
        }, cb);
        return;
    }
    clearedImages.forEach((name)=>{
        payload[name] = null;
    });
    (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
        method: isNew ? "POST" : "PATCH",
        url: isNew ? descriptor.endpoint : `${descriptor.endpoint}${item.id}/`,
        post: payload
    }, cb);
}
function $da70838858bfad8a$export$8d8542dbbc23fe1a(descriptor, id, cb) {
    (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
        method: "DELETE",
        url: `${descriptor.endpoint}${id}/`
    }, (r)=>cb(!!r && r.status === 204));
}
function $da70838858bfad8a$export$43fc4be2c4b87d49(descriptor, id, data, cb) {
    (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
        method: "PATCH",
        url: `${descriptor.endpoint}${id}/`,
        post: data
    }, cb);
}
function $da70838858bfad8a$export$13b0757be3ff9c68(descriptor) {
    if (descriptor.deactivation) {
        const d = descriptor.deactivation;
        return {
            field: d.field,
            activeValue: d.activeValue,
            inactiveValue: "inactiveValue" in d ? d.inactiveValue : !d.activeValue,
            via: d.via || "patch"
        };
    }
    if (descriptor.softDelete) return {
        field: "is_removed",
        activeValue: false,
        inactiveValue: true,
        via: "delete"
    };
    return null;
}
function $da70838858bfad8a$export$bb7ceb464758d5fe(item, cfg) {
    return cfg ? item[cfg.field] !== cfg.activeValue : false;
} /* `parseErrors` lives in `util/action.js` now — a 400 body is that file's business, and the
   merchandiser page needed the same reader. */ 


const $cec7e23dedd0f8c4$var$PAGE_SIZES = [
    25,
    50,
    100
];
/** How many archive/deactivate requests may be in flight at once (there is no bulk endpoint). */ const $cec7e23dedd0f8c4$var$BULK_CHUNK = 6;
const $cec7e23dedd0f8c4$var$FIELD_COL = {
    xs: {
        flex: "0 0 100%"
    },
    md: {
        flex: "0 0 50%"
    },
    xl: {
        flex: "0 0 33.3333%"
    }
};
const $cec7e23dedd0f8c4$var$idOf = (v)=>v && typeof v === "object" ? v.id ?? v.value : v;
/** A column sorts only if the descriptor gave it a key; `name` is the standing convention. */ const $cec7e23dedd0f8c4$var$sortKeyOf = (column)=>column.sort || (column.field === "name" ? "name" : null);
function $cec7e23dedd0f8c4$export$2e2bcd8739ae039({ descriptor: descriptor, currentUser: currentUser, onOpen: onOpen }) {
    const lang = currentUser.language;
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ac552071080927b0), key, lang);
    const td = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), key, lang);
    const tp = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b8441a9a81ffc5d6), key, lang);
    const tv = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), key, lang);
    const deact = (0, $da70838858bfad8a$export$13b0757be3ff9c68)(descriptor);
    const filterDefs = descriptor.filters || [];
    const storeKey = `rt:${descriptor.slug || "resource"}`;
    /* Restored once, on mount. `defaultRegion` filters open pre-scoped to the supervisor's own
     region — but only when there is nothing saved to restore, or reopening a list the user had
     deliberately widened would silently narrow it again. */ const initial = (0, $cQmXV.useRef)((()=>{
        /* `?q=` is how the app bar's search hands a term over ("see all"). An explicit term outranks
         the saved state, and starts from no filters — a remembered region could hide the very row
         the user just searched for. */ const handed = new URLSearchParams(window.location.search).get("q");
        if (handed) return {
            search: handed,
            filters: {},
            page: 1,
            size: $cec7e23dedd0f8c4$var$PAGE_SIZES[0],
            ordering: descriptor.defaultOrdering || "name"
        };
        let saved = null;
        try {
            saved = JSON.parse(sessionStorage.getItem(storeKey) || "null");
        } catch (_) {
            saved = null;
        }
        if (saved) return {
            search: saved.search || "",
            filters: saved.filters || {},
            page: saved.page || 1,
            size: $cec7e23dedd0f8c4$var$PAGE_SIZES.includes(saved.size) ? saved.size : $cec7e23dedd0f8c4$var$PAGE_SIZES[0],
            ordering: saved.ordering ?? descriptor.defaultOrdering ?? "name"
        };
        const region = (0, $3b579ca6158bc61b$export$6339e4f5afb1eeb0)(currentUser);
        const filters = {};
        if (region) filterDefs.forEach((f)=>f.defaultRegion && (filters[f.name] = region));
        return {
            search: "",
            filters: filters,
            page: 1,
            size: $cec7e23dedd0f8c4$var$PAGE_SIZES[0],
            ordering: descriptor.defaultOrdering || "name"
        };
    })()).current;
    const [typed, setTyped] = (0, $cQmXV.useState)(initial.search);
    const [search, setSearch] = (0, $cQmXV.useState)(initial.search);
    const [filters, setFilters] = (0, $cQmXV.useState)(initial.filters);
    const [page, setPage] = (0, $cQmXV.useState)(initial.page);
    const [size, setSize] = (0, $cQmXV.useState)(initial.size);
    const [ordering, setOrdering] = (0, $cQmXV.useState)(initial.ordering);
    const [rows, setRows] = (0, $cQmXV.useState)([]);
    const [count, setCount] = (0, $cQmXV.useState)(0);
    const [loading, setLoading] = (0, $cQmXV.useState)(true);
    /* `{ id, name }` per selection, kept across pages. */ const [checked, setChecked] = (0, $cQmXV.useState)([]);
    const [busy, setBusy] = (0, $cQmXV.useState)(false);
    const [reloads, setReloads] = (0, $cQmXV.useState)(0);
    const scrollY = (0, $66539b2560a58e4e$export$f44b992e82788e9)();
    /* Keyed off the same per-resource store as the filters, so names and filters survive together. */ const { labels: labels, remember: remember, nameFor: nameFor } = (0, $a9e321bb60aaf998$export$243aa1fcbfd1886a)(`${storeKey}:labels`);
    /* -------------------------------------------------------------- fetch */ /* `fetchList` runs on the callback-style `call()`, which has no abort, so the newest request
     wins by sequence number instead — otherwise a slow page-1 lands on top of the page the user
     has since asked for. */ const seq = (0, $cQmXV.useRef)(0);
    (0, $cQmXV.useEffect)(()=>{
        const mine = ++seq.current;
        setLoading(true);
        (0, $da70838858bfad8a$export$3dddb10616f03c3a)(descriptor, {
            page: page,
            size: size,
            search: search,
            filters: filters,
            ordering: ordering
        }, ({ results: results, count: total })=>{
            if (mine !== seq.current) return;
            setRows(results);
            setCount(total);
            setLoading(false);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        descriptor,
        page,
        size,
        search,
        ordering,
        JSON.stringify(filters),
        reloads
    ]);
    (0, $cQmXV.useEffect)(()=>{
        try {
            sessionStorage.setItem(storeKey, JSON.stringify({
                page: page,
                size: size,
                search: search,
                filters: filters,
                ordering: ordering
            }));
        } catch (_) {
        /* storage unavailable (private mode) — the list still works, it just forgets */ }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        page,
        size,
        search,
        ordering,
        JSON.stringify(filters)
    ]);
    (0, $cQmXV.useEffect)(()=>{
        if (typed === search) return undefined;
        const timer = setTimeout(()=>{
            setSearch(typed);
            setPage(1);
        }, (0, $91ea30cb49819b9a$export$8e5d48d2b3bed316));
        return ()=>clearTimeout(timer);
    }, [
        typed,
        search
    ]);
    const reload = (0, $cQmXV.useCallback)(()=>setReloads((n)=>n + 1), []);
    /* ------------------------------------------------------------- filters */ /* Any narrowing invalidates the page number: page 7 of the old result set is usually past the
     end of the new one, which renders an empty table over a non-empty result. */ const setFilter = (name, value)=>setFilters((prev)=>{
            const next = {
                ...prev,
                [name]: value ? $cec7e23dedd0f8c4$var$idOf(value) : ""
            };
            /* A dependent filter cannot survive its scope changing — a locality from the old region
         would narrow the list to nothing. */ filterDefs.forEach((f)=>f.scopeBy === name && (next[f.name] = ""));
            return next;
        });
    /* Narrowing resets the page — but NOT on mount, or the restored page number would be thrown
     away by the very effect meant to protect the user from an out-of-range page. */ const mounted = (0, $cQmXV.useRef)(false);
    (0, $cQmXV.useEffect)(()=>{
        if (!mounted.current) {
            mounted.current = true;
            return;
        }
        setPage(1);
        setChecked([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        JSON.stringify(filters),
        search
    ]);
    const resetFilters = ()=>{
        setTyped("");
        setSearch("");
        setFilters({});
        setOrdering(descriptor.defaultOrdering || "name");
    };
    const chips = (0, $cQmXV.useMemo)(()=>{
        const out = [];
        if (search) out.push({
            key: "__search",
            label: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$2cbd0be658ac061c), "search", lang),
            value: search
        });
        filterDefs.forEach((f)=>{
            const value = filters[f.name];
            if (!value) return;
            const label = f.label ? t(f.label) : td(f.entity) || f.name;
            out.push({
                key: f.name,
                label: label,
                value: f.type === "me" ? t("filter_created_by_me") : nameFor(f.name, value)
            });
        });
        return out;
    /* `labels` is a dependency: a chip that arrived as a bare id has to re-render once its name
       lands from `EntitySelect`'s resolution. */ // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        search,
        JSON.stringify(filters),
        labels,
        lang
    ]);
    const clearChip = (key)=>{
        if (key === "__search") {
            setTyped("");
            setSearch("");
            return;
        }
        setFilter(key, null);
    };
    /* ------------------------------------------------------------- columns */ const columns = (0, $cQmXV.useMemo)(()=>{
        const out = [];
        /* ⚠ Archived ≠ deactivated (spec/03). A `softDelete` record that is off is ARCHIVED; only a
       `deactivation` record is "inactive". The glyph is shared, the word is not. */ if (deact) out.push((0, $66539b2560a58e4e$export$81ff514f95f0c424)((value, row)=>{
            const off = (0, $da70838858bfad8a$export$bb7ceb464758d5fe)(row, deact);
            const label = off ? t(archiving ? "archived" : "inactive") : t("active");
            return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $66539b2560a58e4e$export$b131c49b26d3f427), {
                Icon: off ? archiving ? (0, $268dc9f9b8c7fd21$export$2e2bcd8739ae039) : (0, $e539a200877e5e8f$export$2e2bcd8739ae039) : (0, $45839ed7c4a7faa2$export$2e2bcd8739ae039),
                tone: off ? "off" : "ok",
                label: label
            });
        }));
        /* The identity column is the first one that reads a FIELD, not simply the first column: on
       networks that is `name`, while column 0 is the logo — pinning and bolding an <img> would
       both waste the pinned slot and put an element inside a text-measuring `ellipsis`. */ const identity = descriptor.columns.findIndex((column)=>column.field);
        descriptor.columns.forEach((column, index)=>{
            const key = $cec7e23dedd0f8c4$var$sortKeyOf(column);
            const isIdentity = index === identity;
            out.push({
                key: column.field || column.label || String(index),
                title: t(column.label) || column.label,
                /* antd's `width` is a minimum, not a cap, so `ellipsis` is what actually keeps a long
           value from stretching the column (spec/02). */ width: isIdentity ? 280 : column.field ? 180 : 120,
                fixed: isIdentity ? "left" : undefined,
                ellipsis: true,
                sorter: key ? true : undefined,
                sortOrder: key && ordering === key ? "ascend" : key && ordering === `-${key}` ? "descend" : null,
                render: (value, row)=>{
                    const content = column.format ? column.format(row, lang) : row[column.field];
                    if (content === null || content === undefined || content === "" || content === "\u2014") return 0, $66539b2560a58e4e$export$eb03490a10c3abc9;
                    return isIdentity && typeof content === "string" ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                        strong: true,
                        ellipsis: {
                            tooltip: content
                        },
                        children: content
                    }) : content;
                }
            });
        });
        /* The row menu carries the record's lifecycle as well as Open — a menu holding one item that
       repeats the row click is an affordance that does nothing. Which verb it offers follows the
       same `via` split as the detail page and the bulk bar. */ out.push((0, $66539b2560a58e4e$export$b0493221521ca587)((value, row)=>{
            const off = deact && (0, $da70838858bfad8a$export$bb7ceb464758d5fe)(row, deact);
            const items = [
                {
                    key: "open",
                    icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $357da3723e13ae38$export$2e2bcd8739ae039), {}),
                    label: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$fbb7ce4dc3b38367), "open", lang)
                }
            ];
            if (deact) items.push(off ? {
                key: "restore",
                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $89531e4b0315317b$export$2e2bcd8739ae039), {}),
                label: t(archiving ? "restore_btn" : "activate_btn")
            } : {
                key: "off",
                icon: archiving ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $268dc9f9b8c7fd21$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e539a200877e5e8f$export$2e2bcd8739ae039), {}),
                label: t(archiving ? "archive_btn" : "deactivate_btn"),
                danger: true
            });
            return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $66539b2560a58e4e$export$523acc1bb0ce2e43), {
                label: tv("row_actions"),
                items: items,
                onClick: (key)=>{
                    if (key === "open") onOpen(row.id);
                    else confirmBulk([
                        row
                    ], key === "restore");
                }
            });
        }));
        return out;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        descriptor,
        lang,
        ordering,
        deact
    ]);
    /* `+ 60` covers antd's own selection column, which is not in `columns`. */ const scrollX = (0, $cQmXV.useMemo)(()=>columns.reduce((sum, column)=>sum + (column.width || 0), deact ? 60 : 0), [
        columns,
        deact
    ]);
    /* antd cycles a sorter asc → desc → none by itself; the empty string is the API's own default
     ordering, which is what "none" means here. */ const onTableChange = (pagination, tableFilters, sorter)=>{
        const column = descriptor.columns.find((c)=>(c.field || c.label) === sorter?.columnKey);
        const key = column ? $cec7e23dedd0f8c4$var$sortKeyOf(column) : null;
        const next = sorter?.order && key ? `${sorter.order === "descend" ? "-" : ""}${key}` : "";
        if (next === ordering) return;
        setOrdering(next);
        setPage(1);
    };
    /* Rows are selectable wherever the descriptor can archive or deactivate — the bulk bar does in
     one pass what the record's own detail page can already do one at a time. */ const rowSelection = deact ? {
        fixed: true,
        /* Keys survive paging, so a selection built across two pages archives both. */ preserveSelectedRowKeys: true,
        selectedRowKeys: checked.map((c)=>c.id),
        /* antd's own header menu. "All" is all LOADED rows — the bulk bar says so, because the
             alternative reading ("every record matching the filter") would be wrong. */ selections: [
            (0, $dff4d45d201c6dfe$export$2e2bcd8739ae039).SELECTION_ALL,
            (0, $dff4d45d201c6dfe$export$2e2bcd8739ae039).SELECTION_INVERT,
            (0, $dff4d45d201c6dfe$export$2e2bcd8739ae039).SELECTION_NONE
        ],
        onChange: (keys, selected)=>setChecked(keys.map((id)=>selected.find((row)=>row && row.id === id) || checked.find((c)=>c.id === id) || {
                    id: id
                }))
    } : undefined;
    /* ------------------------------------------------------- bulk archive / deactivate */ const archiving = !deact || deact.via === "delete";
    /* Restoring is always a PATCH back to the active value, even where archiving is a DELETE —
     `softDelete` is `is_removed`, a flag, so there is nothing to un-delete. Same pair the record's
     own detail page uses (`ResourcePage.runRemove` / `.activate`). */ const applyOne = (row, restore)=>new Promise((resolve)=>{
            if (restore) (0, $da70838858bfad8a$export$43fc4be2c4b87d49)(descriptor, row.id, {
                [deact.field]: deact.activeValue
            }, (r)=>resolve(Boolean(r && r.id)));
            else if (deact && deact.via === "patch") (0, $da70838858bfad8a$export$43fc4be2c4b87d49)(descriptor, row.id, {
                [deact.field]: deact.inactiveValue
            }, (r)=>resolve(Boolean(r && r.id)));
            else (0, $da70838858bfad8a$export$8d8542dbbc23fe1a)(descriptor, row.id, (ok)=>resolve(Boolean(ok)));
        });
    /* One request per record — there is no bulk endpoint — but in small batches rather than 100 at
     once, so a full page of selections does not open a hundred sockets. A real bulk endpoint is the
     upgrade if these lists ever grow past a few hundred. */ const runBulk = async (targets, restore = false)=>{
        if (!targets.length) return;
        setBusy(true);
        const done = [];
        for(let i = 0; i < targets.length; i += $cec7e23dedd0f8c4$var$BULK_CHUNK){
            const batch = targets.slice(i, i + $cec7e23dedd0f8c4$var$BULK_CHUNK);
            const results = await Promise.all(batch.map((row)=>applyOne(row, restore)));
            batch.forEach((row, index)=>results[index] && done.push(row));
        }
        setBusy(false);
        if (done.length) (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success((0, $3b579ca6158bc61b$export$9563e054e6f787fb)(t(restore ? archiving ? "restored_n" : "activated_n" : archiving ? "archived_n" : "deactivated_n"), {
            n: done.length
        }), {
            position: "top-right"
        });
        if (done.length < targets.length) (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).warning((0, $3b579ca6158bc61b$export$9563e054e6f787fb)(t("bulk_failed_n"), {
            n: targets.length - done.length
        }), {
            position: "top-right"
        });
        setChecked([]);
        /* Refetch rather than patch rows in place: an archived row may leave this page entirely (the
       list is ordered by name, and `?active=true` is not in play here), and the server owns which
       record moves up to fill the gap. */ reload();
    };
    /* Archiving/deactivating is destructive, so it is confirmed and the confirm says how many
     (spec/03). Restoring is not, so it just runs. */ const confirmBulk = (targets, restore = false)=>{
        if (restore) {
            runBulk(targets, true);
            return;
        }
        (0, $05a90c67d3627fd9$export$2e2bcd8739ae039).confirm({
            title: (0, $3b579ca6158bc61b$export$9563e054e6f787fb)(t(archiving ? "confirm_archive_n" : "confirm_deactivate_n"), {
                n: targets.length
            }),
            /* One record: name it, so the confirm is about a thing rather than a count. */ content: targets.length === 1 ? targets[0].name || targets[0].title || `#${targets[0].id}` : undefined,
            okText: t(archiving ? "archive_btn" : "deactivate_btn"),
            okButtonProps: {
                danger: true
            },
            /* `Modal.confirm` renders outside the tree and does not inherit AppShell's
         `ConfigProvider locale`, so both labels are passed explicitly. */ cancelText: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f544127b46daf517), "cancel", lang),
            onOk: ()=>runBulk(targets, false)
        });
    };
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $575603080129eb00$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b4fda840b736e640$export$2e2bcd8739ae039), {
                className: "lp-filters",
                variant: "outlined",
                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039), {
                    layout: "vertical",
                    component: false,
                    colon: false,
                    children: [
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $db6c3adada49524e$export$2e2bcd8739ae039), {
                            gutter: [
                                12,
                                12
                            ],
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $cde227eb983ae1d2$export$2e2bcd8739ae039), {
                                    ...$cec7e23dedd0f8c4$var$FIELD_COL,
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                        label: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$2cbd0be658ac061c), "search", lang),
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0883e7f8083c01b0$export$2e2bcd8739ae039), {
                                            allowClear: true,
                                            prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $20a259d46bffcb08$export$2e2bcd8739ae039), {}),
                                            placeholder: t("search_ph"),
                                            "aria-label": (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$2cbd0be658ac061c), "search", lang),
                                            value: typed,
                                            onChange: (event)=>setTyped(event.target.value)
                                        })
                                    })
                                }),
                                filterDefs.map((f)=>f.type === "me" ? /*#__PURE__*/ (0, $cQmXV.createElement)((0, $cde227eb983ae1d2$export$2e2bcd8739ae039), {
                                        ...$cec7e23dedd0f8c4$var$FIELD_COL,
                                        key: f.name
                                    }, /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                        label: " ",
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $7a650444b7c2c328$export$2e2bcd8739ae039), {
                                            checked: Boolean(filters[f.name]),
                                            onChange: (event)=>setFilter(f.name, event.target.checked ? currentUser.id : null),
                                            children: t(f.label)
                                        })
                                    })) : /*#__PURE__*/ (0, $cQmXV.createElement)((0, $cde227eb983ae1d2$export$2e2bcd8739ae039), {
                                        ...$cec7e23dedd0f8c4$var$FIELD_COL,
                                        key: f.name
                                    }, /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                        label: (f.label ? t(f.label) : td(f.entity)) || " ",
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b6929c6a194abc34$export$2e2bcd8739ae039), {
                                            entity: f.entity,
                                            /* The same glyph vocabulary the edit form's controls use — `fieldIcon`
                         resolves by name, then entity, and it is the `type` that routes a filter
                         to the entity map. Every other redesigned list carries these. */ prefix: (0, $5cf5963f505f5084$export$2e2bcd8739ae039)({
                                                ...f,
                                                type: "entity"
                                            }),
                                            value: filters[f.name] || "",
                                            seed: f.defaultRegion && currentUser?.county && typeof currentUser.county === "object" ? currentUser.county : null,
                                            county: f.scopeBy ? filters[f.scopeBy] : undefined,
                                            onChange: (option)=>setFilter(f.name, option),
                                            onResolve: remember(f.name)
                                        })
                                    })))
                            ]
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $a9e321bb60aaf998$export$2e2bcd8739ae039), {
                            className: "lp-chips",
                            items: chips,
                            closeLabel: tp("a_remove_filter"),
                            onClose: clearChip
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                            className: "lp-filters__foot",
                            align: "center",
                            gap: "small",
                            wrap: true,
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                    className: "lp-spacer"
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                    size: "small",
                                    onClick: resetFilters,
                                    children: td("filter_reset")
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $b4fda840b736e640$export$2e2bcd8739ae039), {
                className: "lp-table",
                variant: "outlined",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                        className: "lp-table__bar",
                        align: "center",
                        gap: "small",
                        wrap: true,
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                strong: true,
                                className: "lp-table__title",
                                children: t(descriptor.titleKey)
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                type: "secondary",
                                "aria-live": "polite",
                                children: [
                                    tp("records_count"),
                                    ": ",
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                        strong: true,
                                        children: count
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                className: "lp-spacer"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $dff4d45d201c6dfe$export$2e2bcd8739ae039), {
                        className: "lp-table__grid",
                        rowKey: "id",
                        size: "middle",
                        columns: columns,
                        dataSource: rows,
                        loading: loading,
                        /* Sized from the columns this descriptor actually declares, not a fixed number: a
             two-column reference list would otherwise reserve scroll width it never uses, and a
             wide one would clip. */ scroll: {
                            x: scrollX,
                            y: scrollY
                        },
                        rowClassName: (row)=>"lp-row" + (deact && (0, $da70838858bfad8a$export$bb7ceb464758d5fe)(row, deact) ? " lp-row--off" : ""),
                        rowSelection: rowSelection,
                        onRow: (row)=>({
                                onClick: (event)=>{
                                    /* The selection cell and the row menu own their clicks; everything else opens. */ if (event.target.closest(".ant-table-selection-column, .ant-dropdown, .ant-btn, .ant-checkbox-wrapper")) return;
                                    onOpen(row.id);
                                }
                            }),
                        onChange: onTableChange,
                        pagination: false,
                        /* "Nothing here yet" and "no results for these filters" are different states and get
             different copy (spec/03), each a title plus a line saying what to do about it. */ locale: {
                            emptyText: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $99350450b877904c$export$2e2bcd8739ae039), {
                                image: (0, $99350450b877904c$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE,
                                description: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                    vertical: true,
                                    gap: 4,
                                    children: [
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                            strong: true,
                                            children: t(search || chips.length ? "empty_filtered" : "empty")
                                        }),
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                            type: "secondary",
                                            children: t(search || chips.length ? "empty_filtered_desc" : "empty_desc")
                                        })
                                    ]
                                })
                            })
                        }
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $66539b2560a58e4e$export$6cb97cd1ceda576d), {
                        id: descriptor.slug || "rt",
                        page: page,
                        size: size,
                        total: count,
                        sizes: $cec7e23dedd0f8c4$var$PAGE_SIZES,
                        labels: {
                            perPage: tv("rows_per_page"),
                            range: tv("range_of")
                        },
                        onPage: setPage,
                        onSize: (next)=>{
                            setSize(next);
                            setPage(1);
                        }
                    })
                ]
            }),
            checked.length > 0 && /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                className: "lp-bulkbar",
                align: "center",
                gap: "middle",
                wrap: true,
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                        className: "lp-bulkbar__n",
                        children: (0, $3b579ca6158bc61b$export$9563e054e6f787fb)(tp("w_selected"), {
                            n: checked.length
                        })
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                        className: "lp-bulkbar__hint",
                        children: t("select_page_hint")
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $eb1133c43d00490b$export$2e2bcd8739ae039), {
                        size: 8,
                        className: "lp-bulkbar__acts",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                size: "small",
                                onClick: ()=>setChecked([]),
                                children: tp("clear_selection")
                            }),
                            deact && /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                size: "small",
                                danger: true,
                                type: "primary",
                                icon: archiving ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $268dc9f9b8c7fd21$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e539a200877e5e8f$export$2e2bcd8739ae039), {}),
                                loading: busy,
                                onClick: ()=>confirmBulk(checked.slice()),
                                children: t(archiving ? "archive_btn" : "deactivate_btn")
                            })
                        ]
                    })
                ]
            })
        ]
    });
}




function $c92f0e47dd84f4f9$export$2e2bcd8739ae039({ descriptor: descriptor, currentUser: currentUser, history: history }) {
    const lang = currentUser.language;
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ac552071080927b0), key, lang);
    const open = (id)=>history.push(id === "new" ? descriptor.newPath || `/${descriptor.slug}/new` : descriptor.detailPath ? descriptor.detailPath(id) : `/${descriptor.slug}/${id}`);
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
        vertical: true,
        gap: "middle",
        className: "shell-content lp",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                className: "lp-head",
                justify: "space-between",
                align: "flex-end",
                gap: "middle",
                wrap: true,
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                        vertical: true,
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Title, {
                                level: 1,
                                className: "lp-title",
                                children: t(descriptor.titleKey)
                            }),
                            descriptor.subtitleKey && /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Paragraph, {
                                type: "secondary",
                                className: "lp-sub",
                                children: t(descriptor.subtitleKey)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                        type: "primary",
                        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $fa25166ced813feb$export$2e2bcd8739ae039), {}),
                        onClick: ()=>open("new"),
                        children: t("new_btn")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $cec7e23dedd0f8c4$export$2e2bcd8739ae039), {
                descriptor: descriptor,
                currentUser: currentUser,
                onOpen: open
            })
        ]
    });
}


/* ResourcePage — one record: edit or create. One page for all eight reference entities.
 *
 * spec/03 archetype B, read like `/profile`:
 *
 *   page head   — NOT sticky: breadcrumb (list ▸ record) + title + status + the lifecycle action
 *   main column — one card per descriptor section, fields on the `.pt-fieldgrid` grid
 *   side rail   — identity card, Summary (the facts) and Data quality (what is missing, clickable)
 *   save bar    — bottom, and only while there is something to save
 *
 * There is no view/edit toggle and no sticky command bar. The page is always an open form, so the
 * measured-offset machinery archetype B otherwise needs is not paid for here — it has shipped
 * broken four times elsewhere and this page has nothing to hang it on.
 *
 * Rules that each cost time, and are not negotiable:
 * - **Two baselines**: `pristine` (a signature string) for the dirty check, `original`
 *   (`structuredClone`) for reverting. `JSON.parse(JSON.stringify(item))` destroys `Date` fields.
 * - **`canSave = isNew ? true : dirty`** — a pristine NEW record must still be savable.
 * - **Archived ≠ deactivated.** `getDeactivation().via` decides which verb the page says:
 *   `delete` → Archive / Restore, `patch` → Deactivate / Activate. Saying "deactivate" while
 *   sending a DELETE told the user the wrong thing about what happened to their record.
 * - A failed save focuses the **first invalid field**, not a button the re-render may have detached.
 */ 

var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");








var $cQmXV = parcelRequire("cQmXV");
const $bcb3bc52f7181516$var$BreadcrumbContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createContext({});
var $bcb3bc52f7181516$export$2e2bcd8739ae039 = $bcb3bc52f7181516$var$BreadcrumbContext;



var $cQmXV = parcelRequire("cQmXV");






var $cQmXV = parcelRequire("cQmXV");



"use client";
const $774e429e616e4606$var$BreadcrumbSeparator = ({ children: children })=>{
    const { getPrefixCls: getPrefixCls } = $cQmXV.useContext((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls("breadcrumb");
    const breadcrumbContext = $cQmXV.useContext((0, $bcb3bc52f7181516$export$2e2bcd8739ae039));
    const { classNames: mergedClassNames, styles: mergedStyles } = breadcrumbContext;
    return /*#__PURE__*/ $cQmXV.createElement("li", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-separator`, mergedClassNames?.separator),
        style: mergedStyles?.separator,
        "aria-hidden": "true"
    }, children === "" ? children : children || "/");
};
$774e429e616e4606$var$BreadcrumbSeparator.__ANT_BREADCRUMB_SEPARATOR = true;
var $774e429e616e4606$export$2e2bcd8739ae039 = $774e429e616e4606$var$BreadcrumbSeparator;



var $cQmXV = parcelRequire("cQmXV");



"use client";
function $f54a90853a46435b$var$getBreadcrumbName(route, params) {
    if (!(0, $8e2d153a3c855782$export$72280d5f896dac9a)(route.title)) return null;
    const paramsKeys = Object.keys(params).join("|");
    return (0, $8e2d153a3c855782$export$53b83ca8eaab0383)(route.title) ? route.title : String(route.title).replace(new RegExp(`:(${paramsKeys})`, "g"), (replacement, key)=>params[key] || replacement);
}
function $f54a90853a46435b$export$7178ad99788f9ddc(prefixCls, item, children, href) {
    if (!(0, $8e2d153a3c855782$export$72280d5f896dac9a)(children)) return null;
    const { className: className, onClick: onClick, ...restItem } = item;
    const passedProps = {
        ...(0, $4b5c733d1d7bb306$export$2e2bcd8739ae039)(restItem, {
            data: true,
            aria: true
        }),
        onClick: onClick
    };
    if (href !== undefined) return /*#__PURE__*/ $cQmXV.createElement("a", {
        ...passedProps,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-link`, className),
        href: href
    }, children);
    return /*#__PURE__*/ $cQmXV.createElement("span", {
        ...passedProps,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-link`, className)
    }, children);
}
function $f54a90853a46435b$export$2e2bcd8739ae039(prefixCls, itemRender) {
    const mergedItemRender = (item, params, routes, path, href)=>{
        if (itemRender) return itemRender(item, params, routes, path);
        const name = $f54a90853a46435b$var$getBreadcrumbName(item, params);
        return $f54a90853a46435b$export$7178ad99788f9ddc(prefixCls, item, name, href);
    };
    return mergedItemRender;
}


"use client";
const $8546be58e1a78def$export$ac5486a97fd4c014 = (props)=>{
    const { prefixCls: prefixCls, separator: separator = "/", children: children, menu: menu, dropdownProps: dropdownProps, href: href, dropdownIcon: dropdownIcon } = props;
    const breadcrumbContext = $cQmXV.useContext((0, $bcb3bc52f7181516$export$2e2bcd8739ae039));
    const { classNames: mergedClassNames, styles: mergedStyles } = breadcrumbContext;
    /** If overlay is have Wrap a Dropdown */ const renderBreadcrumbNode = (breadcrumbItem)=>{
        if (menu) {
            const mergeDropDownProps = {
                ...dropdownProps
            };
            if (menu) {
                const { items: items, ...menuProps } = menu || {};
                mergeDropDownProps.menu = {
                    ...menuProps,
                    items: items?.map(({ key: key, title: title, label: label, path: path, ...itemProps }, index)=>{
                        let mergedLabel = label ?? title;
                        if (path) mergedLabel = /*#__PURE__*/ $cQmXV.createElement("a", {
                            href: `${href}${path}`
                        }, mergedLabel);
                        return {
                            ...itemProps,
                            key: key ?? index,
                            label: mergedLabel
                        };
                    })
                };
            }
            return /*#__PURE__*/ $cQmXV.createElement((0, $8f2ae9c9297cd2c6$export$2e2bcd8739ae039), {
                placement: "bottom",
                ...mergeDropDownProps
            }, /*#__PURE__*/ $cQmXV.createElement("span", {
                className: `${prefixCls}-overlay-link`
            }, breadcrumbItem, dropdownIcon));
        }
        return breadcrumbItem;
    };
    // wrap to dropDown
    const link = renderBreadcrumbNode(children);
    if ((0, $8e2d153a3c855782$export$826fff653a329e83)(link)) return /*#__PURE__*/ $cQmXV.createElement($cQmXV.Fragment, null, /*#__PURE__*/ $cQmXV.createElement("li", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-item`, mergedClassNames?.item),
        style: mergedStyles?.item
    }, link), separator && /*#__PURE__*/ $cQmXV.createElement((0, $774e429e616e4606$export$2e2bcd8739ae039), null, separator));
    return null;
};
const $8546be58e1a78def$var$BreadcrumbItem = (props)=>{
    const { prefixCls: customizePrefixCls, children: children, href: href, ...restProps } = props;
    const { getPrefixCls: getPrefixCls } = $cQmXV.useContext((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls("breadcrumb", customizePrefixCls);
    return /*#__PURE__*/ $cQmXV.createElement($8546be58e1a78def$export$ac5486a97fd4c014, {
        ...restProps,
        prefixCls: prefixCls
    }, (0, $f54a90853a46435b$export$7178ad99788f9ddc)(prefixCls, restProps, children, href));
};
$8546be58e1a78def$var$BreadcrumbItem.__ANT_BREADCRUMB_ITEM = true;
var $8546be58e1a78def$export$2e2bcd8739ae039 = $8546be58e1a78def$var$BreadcrumbItem;






const $96baabc923d234dd$var$genBreadcrumbStyle = (token)=>{
    const { componentCls: componentCls, iconCls: iconCls, calc: calc } = token;
    return {
        [componentCls]: {
            ...(0, $519d20bf207ce864$export$23997c3e44cc1c59)(token),
            color: token.itemColor,
            fontSize: token.fontSize,
            [iconCls]: {
                fontSize: token.iconFontSize
            },
            ol: {
                display: "flex",
                flexWrap: "wrap",
                margin: 0,
                padding: 0,
                listStyle: "none"
            },
            [`${componentCls}-item a`]: {
                color: token.linkColor,
                transition: `color ${token.motionDurationMid}`,
                padding: `0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.paddingXXS)}`,
                borderRadius: token.borderRadiusSM,
                height: token.fontHeight,
                display: "inline-block",
                marginInline: calc(token.marginXXS).mul(-1).equal(),
                "&:hover": {
                    color: token.linkHoverColor,
                    backgroundColor: token.colorBgTextHover
                },
                ...(0, $519d20bf207ce864$export$a44db842bcb28231)(token)
            },
            [`${componentCls}-item:last-child`]: {
                color: token.lastItemColor
            },
            [`${componentCls}-separator`]: {
                marginInline: token.separatorMargin,
                color: token.separatorColor
            },
            [`${componentCls}-link`]: {
                // Icons from third-party libraries render as a bare `<svg>`, which the `.anticon`
                // reset never reaches. An `<svg>` has no baseline of its own, so it is aligned by its
                // bottom margin edge (CSS 2.1 §10.8.1) and rides above the link text.
                // `display: inline-block` keeps it an atomic inline box so `vertical-align` still applies
                // even under a CSS reset that forces `svg { display: block }` (e.g. Tailwind Preflight),
                // which would otherwise drop the icon onto its own line. `vertical-align: middle` centres
                // its margin box on the x-height line; `margin-block-end` then lifts it by half its own
                // value onto the cap-height centre (capHeight − xHeight ≈ 0.2em across typical fonts),
                // keeping it centred at any icon size.
                // Only matches a bare `<svg>`: an `.anticon` keeps its `<svg>` one level deeper.
                "> svg": {
                    display: "inline-block",
                    verticalAlign: "middle",
                    marginBlockEnd: "0.2em"
                },
                // Same spacing an `.anticon` gets before the following text, extended to a bare `<svg>`.
                [`
          > ${iconCls} + span,
          > ${iconCls} + a,
          > svg + span,
          > svg + a
        `]: {
                    marginInlineStart: token.marginXXS
                }
            },
            [`${componentCls}-overlay-link`]: {
                borderRadius: token.borderRadiusSM,
                height: token.fontHeight,
                display: "inline-block",
                padding: `0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.paddingXXS)}`,
                marginInline: calc(token.marginXXS).mul(-1).equal(),
                [`> ${iconCls}`]: {
                    marginInlineStart: token.marginXXS,
                    fontSize: token.fontSizeIcon
                },
                "&:hover": {
                    color: token.linkHoverColor,
                    backgroundColor: token.colorBgTextHover,
                    a: {
                        color: token.linkHoverColor
                    }
                },
                a: {
                    "&:hover": {
                        backgroundColor: "transparent"
                    }
                }
            },
            // rtl style
            [`&${token.componentCls}-rtl`]: {
                direction: "rtl"
            }
        }
    };
};
const $96baabc923d234dd$export$9ca1be8807fe0675 = (token)=>({
        itemColor: token.colorTextDescription,
        lastItemColor: token.colorText,
        iconFontSize: token.fontSize,
        linkColor: token.colorTextDescription,
        linkHoverColor: token.colorText,
        separatorColor: token.colorTextDescription,
        separatorMargin: token.marginXS
    });
var // ============================== Export ==============================
$96baabc923d234dd$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$51ec95de45185b42)("Breadcrumb", (token)=>{
    const breadcrumbToken = (0, $fef50f256b80dfa5$export$4950aa0f605343fb)(token, {});
    return $96baabc923d234dd$var$genBreadcrumbStyle(breadcrumbToken);
}, $96baabc923d234dd$export$9ca1be8807fe0675);




var $cQmXV = parcelRequire("cQmXV");
function $1343f0fbcf408d2d$var$route2item(route) {
    const { breadcrumbName: breadcrumbName, children: children, ...rest } = route;
    const clone = {
        title: breadcrumbName,
        ...rest
    };
    if (children) clone.menu = {
        items: children.map(({ breadcrumbName: itemBreadcrumbName, ...itemProps })=>({
                ...itemProps,
                title: itemBreadcrumbName
            }))
    };
    return clone;
}
function $1343f0fbcf408d2d$export$2e2bcd8739ae039(items, routes) {
    return (0, $cQmXV.useMemo)(()=>{
        if (items) return items;
        if (routes) return routes.map($1343f0fbcf408d2d$var$route2item);
        return null;
    }, [
        items,
        routes
    ]);
}


"use client";
const $293302b3ea9e089f$var$getPath = (params, path)=>{
    if (path === undefined) return path;
    let mergedPath = (path || "").replace(/^\//, "");
    Object.keys(params).forEach((key)=>{
        mergedPath = mergedPath.replace(`:${key}`, params[key]);
    });
    return mergedPath;
};
const $293302b3ea9e089f$var$InternalBreadcrumb = (props, ref)=>{
    const { prefixCls: customizePrefixCls, separator: separator, style: style, className: className, rootClassName: rootClassName, routes: legacyRoutes, items: items, children: children, itemRender: itemRender, params: params = {}, classNames: classNames, styles: styles, dropdownIcon: dropdownIcon, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles, separator: contextSeparator, dropdownIcon: contextDropdownIcon } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("breadcrumb");
    const mergedSeparator = separator ?? contextSeparator ?? "/";
    const mergedDropdownIcon = dropdownIcon ?? contextDropdownIcon ?? /*#__PURE__*/ $cQmXV.createElement((0, $e7119b602540b2c5$export$2e2bcd8739ae039), null);
    let crumbs;
    const prefixCls = getPrefixCls("breadcrumb", customizePrefixCls);
    const [hashId, cssVarCls] = (0, $96baabc923d234dd$export$2e2bcd8739ae039)(prefixCls);
    const mergedItems = (0, $1343f0fbcf408d2d$export$2e2bcd8739ae039)(items, legacyRoutes);
    // =========== Merged Props for Semantic ==========
    const mergedProps = $cQmXV.useMemo(()=>{
        return {
            ...props,
            separator: mergedSeparator
        };
    }, [
        props,
        mergedSeparator
    ]);
    // ========================= Style ==========================
    const contextStyleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $30c5f9f911d4f61b$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: mergedProps
    });
    var element;
    const mergedItemRender = (0, $f54a90853a46435b$export$2e2bcd8739ae039)(prefixCls, itemRender);
    if (mergedItems && mergedItems.length > 0) {
        // generated by route
        const paths = [];
        const itemRenderRoutes = items || legacyRoutes;
        crumbs = mergedItems.map((item, index)=>{
            const { path: path, key: key, type: type, menu: menu, onClick: onClick, className: itemClassName, style: style, separator: itemSeparator, dropdownProps: dropdownProps } = item;
            const mergedPath = $293302b3ea9e089f$var$getPath(params, path);
            if (mergedPath !== undefined) paths.push(mergedPath);
            const mergedKey = key ?? index;
            if (type === "separator") return /*#__PURE__*/ $cQmXV.createElement((0, $774e429e616e4606$export$2e2bcd8739ae039), {
                key: mergedKey
            }, itemSeparator);
            const itemProps = {};
            const isLastItem = index === mergedItems.length - 1;
            if (menu) itemProps.menu = menu;
            let { href: href } = item;
            if (paths.length && mergedPath !== undefined) href = `#/${paths.join("/")}`;
            return /*#__PURE__*/ $cQmXV.createElement((0, $8546be58e1a78def$export$ac5486a97fd4c014), {
                key: mergedKey,
                ...itemProps,
                ...(0, $4b5c733d1d7bb306$export$2e2bcd8739ae039)(item, {
                    data: true,
                    aria: true
                }),
                className: itemClassName,
                style: style,
                dropdownProps: dropdownProps,
                dropdownIcon: mergedDropdownIcon,
                href: href,
                separator: isLastItem ? "" : mergedSeparator,
                onClick: onClick,
                prefixCls: prefixCls
            }, mergedItemRender(item, params, itemRenderRoutes, paths, href));
        });
    } else if (children) {
        const childrenLength = (0, $cd966a313e0a92ff$export$2e2bcd8739ae039)(children).length;
        crumbs = (0, $cd966a313e0a92ff$export$2e2bcd8739ae039)(children).map((element, index)=>{
            if (!element) return element;
            const isLastItem = index === childrenLength - 1;
            return (0, $a91ef204d03d8eec$export$e530037191fcd5d7)(element, {
                separator: isLastItem ? "" : mergedSeparator,
                // eslint-disable-next-line react/no-array-index-key
                key: index
            });
        });
    }
    const breadcrumbClassName = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, contextClassName, {
        [`${prefixCls}-rtl`]: direction === "rtl"
    }, className, rootClassName, mergedClassNames.root, hashId, cssVarCls);
    const mergedStyle = {
        ...mergedStyles.root
    };
    const memoizedValue = $cQmXV.useMemo(()=>({
            classNames: mergedClassNames,
            styles: mergedStyles
        }), [
        mergedClassNames,
        mergedStyles
    ]);
    const nativeElementRef = $cQmXV.useRef(null);
    $cQmXV.useImperativeHandle(ref, ()=>({
            nativeElement: nativeElementRef.current
        }));
    return /*#__PURE__*/ $cQmXV.createElement((0, $bcb3bc52f7181516$export$2e2bcd8739ae039).Provider, {
        value: memoizedValue
    }, /*#__PURE__*/ $cQmXV.createElement("nav", {
        ref: nativeElementRef,
        className: breadcrumbClassName,
        style: mergedStyle,
        ...restProps
    }, /*#__PURE__*/ $cQmXV.createElement("ol", null, crumbs)));
};
const $293302b3ea9e089f$var$Breadcrumb = /*#__PURE__*/ $cQmXV.forwardRef($293302b3ea9e089f$var$InternalBreadcrumb);
var $293302b3ea9e089f$export$2e2bcd8739ae039 = $293302b3ea9e089f$var$Breadcrumb;




"use client";
const $acdea7eebf8fd4fd$var$Breadcrumb = (0, $293302b3ea9e089f$export$2e2bcd8739ae039);
$acdea7eebf8fd4fd$var$Breadcrumb.Item = (0, $8546be58e1a78def$export$2e2bcd8739ae039);
$acdea7eebf8fd4fd$var$Breadcrumb.Separator = (0, $774e429e616e4606$export$2e2bcd8739ae039);
var $acdea7eebf8fd4fd$export$2e2bcd8739ae039 = $acdea7eebf8fd4fd$var$Breadcrumb;



var $cQmXV = parcelRequire("cQmXV");
var $42d4dac5bc3d819e$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($42d4dac5bc3d819e$exports, "__esModule", {
    value: true
});
var $42d4dac5bc3d819e$var$WarningOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M464 720a48 48 0 1096 0 48 48 0 10-96 0zm16-304v184c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V416c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8zm475.7 440l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zm-783.5-27.9L512 239.9l339.8 588.2H172.2z"
                }
            }
        ]
    },
    "name": "warning",
    "theme": "outlined"
};
$42d4dac5bc3d819e$exports.default = $42d4dac5bc3d819e$var$WarningOutlined;



function $8c4bbfcbcade090a$var$_extends() {
    $8c4bbfcbcade090a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8c4bbfcbcade090a$var$_extends.apply(this, arguments);
}
const $8c4bbfcbcade090a$var$WarningOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $8c4bbfcbcade090a$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($42d4dac5bc3d819e$exports)))
    }));
/**![warning](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTQ2NCA3MjBhNDggNDggMCAxMDk2IDAgNDggNDggMCAxMC05NiAwem0xNi0zMDR2MTg0YzAgNC40IDMuNiA4IDggOGg0OGM0LjQgMCA4LTMuNiA4LThWNDE2YzAtNC40LTMuNi04LTgtOGgtNDhjLTQuNCAwLTggMy42LTggOHptNDc1LjcgNDQwbC00MTYtNzIwYy02LjItMTAuNy0xNi45LTE2LTI3LjctMTZzLTIxLjYgNS4zLTI3LjcgMTZsLTQxNiA3MjBDNTYgODc3LjQgNzEuNCA5MDQgOTYgOTA0aDgzMmMyNC42IDAgNDAtMjYuNiAyNy43LTQ4em0tNzgzLjUtMjcuOUw1MTIgMjM5LjlsMzM5LjggNTg4LjJIMTcyLjJ6IiAvPjwvc3ZnPg==) */ const $8c4bbfcbcade090a$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($8c4bbfcbcade090a$var$WarningOutlined);
var $8c4bbfcbcade090a$export$2e2bcd8739ae039 = $8c4bbfcbcade090a$var$RefIcon;



/* ResourceForm — the descriptor's `fields` as an antd form, in the /profile page's visual language.
 *
 * `<Form component={false}>`: the item lives in `ResourcePage`'s state and every renderer is a
 * controlled control calling `onChange(name, value)`, so antd's own field store is deliberately
 * not used — `<Form.Item>` is here for the label, the required marker and the error, which is the
 * one part every field otherwise had to draw for itself. That is also why the renderers no longer
 * carry a `<label>`: it lives in exactly one place now.
 *
 * The look mirrors `/profile` (the user asked for it): each descriptor section is a card with a
 * plain title + optional one-line description (not an icon eyebrow), and the controls are
 * `size="large"` — set once via a scoped `ConfigProvider` so every renderer inherits it rather
 * than threading a size prop through each. Fields tile on `.pt-fieldgrid`, the mockups' `.edform`
 * auto-fit grid, with `wide`/`tall` descriptor fields spanning the row.
 */ 
parcelRequire("cQmXV");


parcelRequire("cQmXV");


function $8ab0a5ff7c5b526c$export$2e2bcd8739ae039({ field: field, value: value, onChange: onChange }) {
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0883e7f8083c01b0$export$2e2bcd8739ae039), {
        prefix: (0, $5cf5963f505f5084$export$2e2bcd8739ae039)(field),
        value: value ?? "",
        placeholder: field.placeholder || "",
        onChange: (event)=>onChange(field.name, event.target.value)
    });
}



parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");




var $cQmXV = parcelRequire("cQmXV");
var $4a9c6cdee0e987f5$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($4a9c6cdee0e987f5$exports, "__esModule", {
    value: true
});
var $4a9c6cdee0e987f5$var$UpOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M890.5 755.3L537.9 269.2c-12.8-17.6-39-17.6-51.7 0L133.5 755.3A8 8 0 00140 768h75c5.1 0 9.9-2.5 12.9-6.6L512 369.8l284.1 391.6c3 4.1 7.8 6.6 12.9 6.6h75c6.5 0 10.3-7.4 6.5-12.7z"
                }
            }
        ]
    },
    "name": "up",
    "theme": "outlined"
};
$4a9c6cdee0e987f5$exports.default = $4a9c6cdee0e987f5$var$UpOutlined;



function $a9acaf08b7547d32$var$_extends() {
    $a9acaf08b7547d32$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a9acaf08b7547d32$var$_extends.apply(this, arguments);
}
const $a9acaf08b7547d32$var$UpOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $a9acaf08b7547d32$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4a9c6cdee0e987f5$exports)))
    }));
/**![up](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg5MC41IDc1NS4zTDUzNy45IDI2OS4yYy0xMi44LTE3LjYtMzktMTcuNi01MS43IDBMMTMzLjUgNzU1LjNBOCA4IDAgMDAxNDAgNzY4aDc1YzUuMSAwIDkuOS0yLjUgMTIuOS02LjZMNTEyIDM2OS44bDI4NC4xIDM5MS42YzMgNC4xIDcuOCA2LjYgMTIuOSA2LjZoNzVjNi41IDAgMTAuMy03LjQgNi41LTEyLjd6IiAvPjwvc3ZnPg==) */ const $a9acaf08b7547d32$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($a9acaf08b7547d32$var$UpOutlined);
var $a9acaf08b7547d32$export$2e2bcd8739ae039 = $a9acaf08b7547d32$var$RefIcon;


/* eslint-disable max-classes-per-file */ 



function $d95f46c711d55b9d$export$d5c7b2f63580e8f5() {
    return typeof BigInt === "function";
}


function $e6cee2a632b9f457$export$dd1bc94b04021eeb(value) {
    return !value && value !== 0 && !Number.isNaN(value) || !String(value).trim();
}
function $e6cee2a632b9f457$export$5be79a0015c5ab12(numStr) {
    var str = numStr.trim();
    var negative = str.startsWith("-");
    if (negative) str = str.slice(1);
    str = str// Remove decimal 0. `1.000` => `1.`, `1.100` => `1.1`
    .replace(/(\.\d*[^0])0*$/, "$1")// Remove useless decimal. `1.` => `1`
    .replace(/\.0*$/, "")// Remove integer 0. `0001` => `1`, 000.1' => `.1`
    .replace(/^0+/, "");
    if (str.startsWith(".")) str = "0".concat(str);
    var trimStr = str || "0";
    var splitNumber = trimStr.split(".");
    var integerStr = splitNumber[0] || "0";
    var decimalStr = splitNumber[1] || "0";
    if (integerStr === "0" && decimalStr === "0") negative = false;
    var negativeStr = negative ? "-" : "";
    return {
        negative: negative,
        negativeStr: negativeStr,
        trimStr: trimStr,
        integerStr: integerStr,
        decimalStr: decimalStr,
        fullStr: "".concat(negativeStr).concat(trimStr)
    };
}
function $e6cee2a632b9f457$export$ee6c12ef7f6d8b32(number) {
    var str = String(number);
    return !Number.isNaN(Number(str)) && str.includes("e");
}
/**
 * Parse a scientific-notation string into reusable parts.
 *
 * The idea is to split the value into mantissa and exponent first, then
 * normalize the mantissa into sign, integer/decimal segments, and a compact
 * digit sequence so later logic can move the decimal point without re-parsing.
 */ function $e6cee2a632b9f457$var$parseScientificNotation(numStr) {
    var _numStr$toLowerCase$s = numStr.toLowerCase().split("e"), _numStr$toLowerCase$s2 = (0, $6b65fc3b4acde7f2$export$2e2bcd8739ae039)(_numStr$toLowerCase$s, 2), mantissa = _numStr$toLowerCase$s2[0], _numStr$toLowerCase$s3 = _numStr$toLowerCase$s2[1], exponent = _numStr$toLowerCase$s3 === void 0 ? "0" : _numStr$toLowerCase$s3;
    var negative = mantissa.startsWith("-");
    var unsignedMantissa = negative ? mantissa.slice(1) : mantissa;
    var _unsignedMantissa$spl = unsignedMantissa.split("."), _unsignedMantissa$spl2 = (0, $6b65fc3b4acde7f2$export$2e2bcd8739ae039)(_unsignedMantissa$spl, 2), _unsignedMantissa$spl3 = _unsignedMantissa$spl2[0], integer = _unsignedMantissa$spl3 === void 0 ? "0" : _unsignedMantissa$spl3, _unsignedMantissa$spl4 = _unsignedMantissa$spl2[1], decimal = _unsignedMantissa$spl4 === void 0 ? "" : _unsignedMantissa$spl4;
    var digits = "".concat(integer).concat(decimal).replace(/^0+/, "") || "0";
    return {
        decimal: decimal,
        digits: digits,
        exponent: Number(exponent),
        integer: integer,
        negative: negative
    };
}
/**
 * Expand parsed scientific notation into a plain decimal string.
 *
 * The core idea is to calculate where the decimal point lands after applying
 * the exponent, then rebuild the string by either padding zeros or inserting
 * the decimal point inside the normalized digit sequence.
 */ function $e6cee2a632b9f457$var$expandScientificNotation(parsed) {
    var decimal = parsed.decimal, digits = parsed.digits, exponent = parsed.exponent, integer = parsed.integer, negative = parsed.negative;
    if (digits === "0") return "0";
    var integerDigits = integer.replace(/^0+/, "").length;
    var leadingDecimalZeros = (decimal.match(/^0*/) || [
        ""
    ])[0].length;
    var initialDecimalIndex = integerDigits || -leadingDecimalZeros;
    var decimalIndex = initialDecimalIndex + exponent;
    var expanded = "";
    if (decimalIndex <= 0) expanded = "0.".concat("0".repeat(-decimalIndex)).concat(digits);
    else if (decimalIndex >= digits.length) expanded = "".concat(digits).concat("0".repeat(decimalIndex - digits.length));
    else expanded = "".concat(digits.slice(0, decimalIndex), ".").concat(digits.slice(decimalIndex));
    return "".concat(negative ? "-" : "").concat(expanded);
}
function $e6cee2a632b9f457$var$getScientificPrecision(parsed) {
    if (parsed.exponent >= 0) return Math.max(0, parsed.decimal.length - parsed.exponent);
    return Math.abs(parsed.exponent) + parsed.decimal.length;
}
function $e6cee2a632b9f457$export$2e56483e4ad90ee6(number) {
    var numStr = String(number);
    if ($e6cee2a632b9f457$export$ee6c12ef7f6d8b32(number)) return $e6cee2a632b9f457$var$getScientificPrecision($e6cee2a632b9f457$var$parseScientificNotation(numStr));
    return numStr.includes(".") && $e6cee2a632b9f457$export$b3d198e17b370bec(numStr) ? numStr.length - numStr.indexOf(".") - 1 : 0;
}
function $e6cee2a632b9f457$export$fdc98affa95a4322(number) {
    var numStr = String(number);
    if ($e6cee2a632b9f457$export$ee6c12ef7f6d8b32(number)) {
        if (number > Number.MAX_SAFE_INTEGER) return String((0, $d95f46c711d55b9d$export$d5c7b2f63580e8f5)() ? BigInt(number).toString() : Number.MAX_SAFE_INTEGER);
        if (number < Number.MIN_SAFE_INTEGER) return String((0, $d95f46c711d55b9d$export$d5c7b2f63580e8f5)() ? BigInt(number).toString() : Number.MIN_SAFE_INTEGER);
        var parsed = $e6cee2a632b9f457$var$parseScientificNotation(numStr);
        var precision = $e6cee2a632b9f457$var$getScientificPrecision(parsed);
        numStr = precision > 100 ? $e6cee2a632b9f457$var$expandScientificNotation(parsed) : number.toFixed(precision);
    }
    return $e6cee2a632b9f457$export$5be79a0015c5ab12(numStr).fullStr;
}
function $e6cee2a632b9f457$export$b3d198e17b370bec(num) {
    if (typeof num === "number") return !Number.isNaN(num);
    // Empty
    if (!num) return false;
    return(// Normal type: 11.28
    /^\s*-?\d+(\.\d+)?\s*$/.test(num) || // Pre-number: 1.
    /^\s*-?\d+\.\s*$/.test(num) || // Post-number: .1
    /^\s*-?\.\d+\s*$/.test(num));
}


var $2e99e4b9b9c08964$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function BigIntDecimal(value) {
        (0, $07be749aeca07699$export$2e2bcd8739ae039)(this, BigIntDecimal);
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(this, "origin", "");
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(this, "negative", void 0);
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(this, "integer", void 0);
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(this, "decimal", void 0);
        /** BigInt will convert `0009` to `9`. We need record the len of decimal */ (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(this, "decimalLen", void 0);
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(this, "empty", void 0);
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(this, "nan", void 0);
        if ((0, $e6cee2a632b9f457$export$dd1bc94b04021eeb)(value)) {
            this.empty = true;
            return;
        }
        this.origin = String(value);
        // Act like Number convert
        if (value === "-" || Number.isNaN(value)) {
            this.nan = true;
            return;
        }
        var mergedValue = value;
        // We need convert back to Number since it require `toFixed` to handle this
        if ((0, $e6cee2a632b9f457$export$ee6c12ef7f6d8b32)(mergedValue)) mergedValue = Number(mergedValue);
        mergedValue = typeof mergedValue === "string" ? mergedValue : (0, $e6cee2a632b9f457$export$fdc98affa95a4322)(mergedValue);
        if ((0, $e6cee2a632b9f457$export$b3d198e17b370bec)(mergedValue)) {
            var trimRet = (0, $e6cee2a632b9f457$export$5be79a0015c5ab12)(mergedValue);
            this.negative = trimRet.negative;
            var numbers = trimRet.trimStr.split(".");
            this.integer = BigInt(numbers[0]);
            var decimalStr = numbers[1] || "0";
            this.decimal = BigInt(decimalStr);
            this.decimalLen = decimalStr.length;
        } else this.nan = true;
    }
    (0, $c180160353ceabc3$export$2e2bcd8739ae039)(BigIntDecimal, [
        {
            key: "getMark",
            value: function getMark() {
                return this.negative ? "-" : "";
            }
        },
        {
            key: "getIntegerStr",
            value: function getIntegerStr() {
                return this.integer.toString();
            }
        },
        {
            key: "getDecimalStr",
            value: function getDecimalStr() {
                return this.decimal.toString().padStart(this.decimalLen, "0");
            }
        },
        {
            key: "alignDecimal",
            value: function alignDecimal(decimalLength) {
                var str = "".concat(this.getMark()).concat(this.getIntegerStr()).concat(this.getDecimalStr().padEnd(decimalLength, "0"));
                return BigInt(str);
            }
        },
        {
            key: "negate",
            value: function negate() {
                var clone = new BigIntDecimal(this.toString());
                clone.negative = !clone.negative;
                return clone;
            }
        },
        {
            key: "cal",
            value: function cal(offset, calculator, calDecimalLen) {
                var maxDecimalLength = Math.max(this.getDecimalStr().length, offset.getDecimalStr().length);
                var myAlignedDecimal = this.alignDecimal(maxDecimalLength);
                var offsetAlignedDecimal = offset.alignDecimal(maxDecimalLength);
                var valueStr = calculator(myAlignedDecimal, offsetAlignedDecimal).toString();
                var nextDecimalLength = calDecimalLen(maxDecimalLength);
                // We need fill string length back to `maxDecimalLength` to avoid parser failed
                var _trimNumber = (0, $e6cee2a632b9f457$export$5be79a0015c5ab12)(valueStr), negativeStr = _trimNumber.negativeStr, trimStr = _trimNumber.trimStr;
                var hydrateValueStr = "".concat(negativeStr).concat(trimStr.padStart(nextDecimalLength + 1, "0"));
                return new BigIntDecimal("".concat(hydrateValueStr.slice(0, -nextDecimalLength), ".").concat(hydrateValueStr.slice(-nextDecimalLength)));
            }
        },
        {
            key: "add",
            value: function add(value) {
                if (this.isInvalidate()) return new BigIntDecimal(value);
                var offset = new BigIntDecimal(value);
                if (offset.isInvalidate()) return this;
                return this.cal(offset, function(num1, num2) {
                    return num1 + num2;
                }, function(len) {
                    return len;
                });
            }
        },
        {
            key: "multi",
            value: function multi(value) {
                var target = new BigIntDecimal(value);
                if (this.isInvalidate() || target.isInvalidate()) return new BigIntDecimal(NaN);
                return this.cal(target, function(num1, num2) {
                    return num1 * num2;
                }, function(len) {
                    return len * 2;
                });
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return this.empty;
            }
        },
        {
            key: "isNaN",
            value: function isNaN() {
                return this.nan;
            }
        },
        {
            key: "isInvalidate",
            value: function isInvalidate() {
                return this.isEmpty() || this.isNaN();
            }
        },
        {
            key: "equals",
            value: function equals(target) {
                return this.toString() === (target === null || target === void 0 ? void 0 : target.toString());
            }
        },
        {
            key: "lessEquals",
            value: function lessEquals(target) {
                return this.add(target.negate().toString()).toNumber() <= 0;
            }
        },
        {
            key: "toNumber",
            value: function toNumber() {
                if (this.isNaN()) return NaN;
                return Number(this.toString());
            }
        },
        {
            key: "toString",
            value: function toString() {
                var safe = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                if (!safe) return this.origin;
                if (this.isInvalidate()) return "";
                return (0, $e6cee2a632b9f457$export$5be79a0015c5ab12)("".concat(this.getMark()).concat(this.getIntegerStr(), ".").concat(this.getDecimalStr())).fullStr;
            }
        }
    ]);
    return BigIntDecimal;
}();






/**
 * We can remove this when IE not support anymore
 */ var $e62780a504cd4638$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function NumberDecimal(value) {
        (0, $07be749aeca07699$export$2e2bcd8739ae039)(this, NumberDecimal);
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(this, "origin", "");
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(this, "number", void 0);
        (0, $8a87dbb78c4121a9$export$2e2bcd8739ae039)(this, "empty", void 0);
        if ((0, $e6cee2a632b9f457$export$dd1bc94b04021eeb)(value)) {
            this.empty = true;
            return;
        }
        this.origin = String(value);
        this.number = Number(value);
    }
    (0, $c180160353ceabc3$export$2e2bcd8739ae039)(NumberDecimal, [
        {
            key: "negate",
            value: function negate() {
                return new NumberDecimal(-this.toNumber());
            }
        },
        {
            key: "add",
            value: function add(value) {
                if (this.isInvalidate()) return new NumberDecimal(value);
                var target = Number(value);
                if (Number.isNaN(target)) return this;
                var number = this.number + target;
                // [Legacy] Back to safe integer
                if (number > Number.MAX_SAFE_INTEGER) return new NumberDecimal(Number.MAX_SAFE_INTEGER);
                if (number < Number.MIN_SAFE_INTEGER) return new NumberDecimal(Number.MIN_SAFE_INTEGER);
                var maxPrecision = Math.max((0, $e6cee2a632b9f457$export$2e56483e4ad90ee6)(this.number), (0, $e6cee2a632b9f457$export$2e56483e4ad90ee6)(target));
                return new NumberDecimal(number.toFixed(maxPrecision));
            }
        },
        {
            key: "multi",
            value: function multi(value) {
                var target = Number(value);
                if (this.isInvalidate() || Number.isNaN(target)) return new NumberDecimal(NaN);
                var number = this.number * target;
                // [Legacy] Back to safe integer
                if (number > Number.MAX_SAFE_INTEGER) return new NumberDecimal(Number.MAX_SAFE_INTEGER);
                if (number < Number.MIN_SAFE_INTEGER) return new NumberDecimal(Number.MIN_SAFE_INTEGER);
                var maxPrecision = Math.max((0, $e6cee2a632b9f457$export$2e56483e4ad90ee6)(this.number), (0, $e6cee2a632b9f457$export$2e56483e4ad90ee6)(target));
                return new NumberDecimal(number.toFixed(maxPrecision));
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return this.empty;
            }
        },
        {
            key: "isNaN",
            value: function isNaN() {
                return Number.isNaN(this.number);
            }
        },
        {
            key: "isInvalidate",
            value: function isInvalidate() {
                return this.isEmpty() || this.isNaN();
            }
        },
        {
            key: "equals",
            value: function equals(target) {
                return this.toNumber() === (target === null || target === void 0 ? void 0 : target.toNumber());
            }
        },
        {
            key: "lessEquals",
            value: function lessEquals(target) {
                return this.add(target.negate().toString()).toNumber() <= 0;
            }
        },
        {
            key: "toNumber",
            value: function toNumber() {
                return this.number;
            }
        },
        {
            key: "toString",
            value: function toString() {
                var safe = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                if (!safe) return this.origin;
                if (this.isInvalidate()) return "";
                if ((0, $e6cee2a632b9f457$export$ee6c12ef7f6d8b32)(this.number) && (0, $e6cee2a632b9f457$export$2e56483e4ad90ee6)(this.number) > 100) return String(this.number);
                return (0, $e6cee2a632b9f457$export$fdc98affa95a4322)(this.number);
            }
        }
    ]);
    return NumberDecimal;
}();




function $38fb46469877b701$export$2e2bcd8739ae039(value) {
    // We use BigInt here.
    // Will fallback to Number if not support.
    if ((0, $d95f46c711d55b9d$export$d5c7b2f63580e8f5)()) return new (0, $2e99e4b9b9c08964$export$2e2bcd8739ae039)(value);
    return new (0, $e62780a504cd4638$export$2e2bcd8739ae039)(value);
}
function $38fb46469877b701$export$a81f732198733497(numStr, separatorStr, precision) {
    var cutOnly = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (numStr === "") return "";
    var _trimNumber = (0, $e6cee2a632b9f457$export$5be79a0015c5ab12)(numStr), negativeStr = _trimNumber.negativeStr, integerStr = _trimNumber.integerStr, decimalStr = _trimNumber.decimalStr;
    var precisionDecimalStr = "".concat(separatorStr).concat(decimalStr);
    var numberWithoutDecimal = "".concat(negativeStr).concat(integerStr);
    if (precision >= 0) {
        // We will get last + 1 number to check if need advanced number
        var advancedNum = Number(decimalStr[precision]);
        if (advancedNum >= 5 && !cutOnly) {
            var advancedDecimal = $38fb46469877b701$export$2e2bcd8739ae039(numStr).add("".concat(negativeStr, "0.").concat("0".repeat(precision)).concat(10 - advancedNum));
            return $38fb46469877b701$export$a81f732198733497(advancedDecimal.toString(), separatorStr, precision, cutOnly);
        }
        if (precision === 0) return numberWithoutDecimal;
        return "".concat(numberWithoutDecimal).concat(separatorStr).concat(decimalStr.padEnd(precision, "0").slice(0, precision));
    }
    if (precisionDecimalStr === ".0") return numberWithoutDecimal;
    return "".concat(numberWithoutDecimal).concat(precisionDecimalStr);
}



var $9017971b85cd0c98$export$2e2bcd8739ae039 = (0, $38fb46469877b701$export$2e2bcd8739ae039);






var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");

function $10c22ecb2bfb0fd6$export$2e2bcd8739ae039(input, focused) {
    const selectionRef = (0, $cQmXV.useRef)(null);
    function recordCursor() {
        // Record position
        try {
            const { selectionStart: start, selectionEnd: end, value: value } = input;
            const beforeTxt = value.substring(0, start);
            const afterTxt = value.substring(end);
            selectionRef.current = {
                start: start,
                end: end,
                value: value,
                beforeTxt: beforeTxt,
                afterTxt: afterTxt
            };
        } catch (e) {
        // Fix error in Chrome:
        // Failed to read the 'selectionStart' property from 'HTMLInputElement'
        // http://stackoverflow.com/q/21177489/3040605
        }
    }
    /**
   * Restore logic:
   *  1. back string same
   *  2. start string same
   */ function restoreCursor() {
        if (input && selectionRef.current && focused) try {
            const { value: value } = input;
            const { beforeTxt: beforeTxt, afterTxt: afterTxt, start: start } = selectionRef.current;
            let startPos = value.length;
            if (value.startsWith(beforeTxt)) startPos = beforeTxt.length;
            else if (value.endsWith(afterTxt)) startPos = value.length - selectionRef.current.afterTxt.length;
            else {
                const beforeLastChar = beforeTxt[start - 1];
                const newIndex = value.indexOf(beforeLastChar, start - 1);
                if (newIndex !== -1) startPos = newIndex + 1;
            }
            input.setSelectionRange(startPos, startPos);
        } catch (e) {
            (0, $26d7cf6379fe7659$export$2e2bcd8739ae039)(false, `Something warning of cursor restore. Please fire issue about this: ${e.message}`);
        }
    }
    return [
        recordCursor,
        restoreCursor
    ];
}


/* eslint-disable react/no-unknown-property */ 


var $cQmXV = parcelRequire("cQmXV");
/**
 * When click and hold on a button - the speed of auto changing the value.
 */ const $9387a7533ef86dab$var$STEP_INTERVAL = 200;
/**
 * When click and hold on a button - the delay before auto changing the value.
 */ const $9387a7533ef86dab$var$STEP_DELAY = 600;
function $9387a7533ef86dab$export$2e2bcd8739ae039({ prefixCls: prefixCls, action: action, children: children, disabled: disabled, className: className, style: style, onStep: onStep }) {
    // ======================== MISC ========================
    const isUpAction = action === "up";
    // ======================== Step ========================
    const stepTimeoutRef = $cQmXV.useRef();
    const frameIds = $cQmXV.useRef([]);
    const onStopStep = ()=>{
        clearTimeout(stepTimeoutRef.current);
    };
    // We will interval update step when hold mouse down
    const onStepMouseDown = (e)=>{
        e.preventDefault();
        onStopStep();
        onStep(isUpAction, "handler");
        // Loop step for interval
        function loopStep() {
            onStep(isUpAction, "handler");
            stepTimeoutRef.current = setTimeout(loopStep, $9387a7533ef86dab$var$STEP_INTERVAL);
        }
        // First time press will wait some time to trigger loop step update
        stepTimeoutRef.current = setTimeout(loopStep, $9387a7533ef86dab$var$STEP_DELAY);
    };
    $cQmXV.useEffect(()=>()=>{
            onStopStep();
            frameIds.current.forEach((id)=>{
                (0, $905c53b807de704e$export$2e2bcd8739ae039).cancel(id);
            });
        }, []);
    // ======================= Render =======================
    const actionClassName = `${prefixCls}-action`;
    const mergedClassName = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(actionClassName, `${actionClassName}-${action}`, {
        [`${actionClassName}-${action}-disabled`]: disabled
    }, className);
    // fix: https://github.com/ant-design/ant-design/issues/43088
    // In Safari, When we fire onmousedown and onmouseup events in quick succession,
    // there may be a problem that the onmouseup events are executed first,
    // resulting in a disordered program execution.
    // So, we need to use requestAnimationFrame to ensure that the onmouseup event is executed after the onmousedown event.
    const safeOnStopStep = ()=>frameIds.current.push((0, $905c53b807de704e$export$2e2bcd8739ae039)(onStopStep));
    return /*#__PURE__*/ $cQmXV.createElement("span", {
        unselectable: "on",
        role: "button",
        onMouseUp: safeOnStopStep,
        onMouseLeave: safeOnStopStep,
        onMouseDown: (e)=>{
            onStepMouseDown(e);
        },
        "aria-label": isUpAction ? "Increase Value" : "Decrease Value",
        "aria-disabled": disabled,
        className: mergedClassName,
        style: style
    }, children || /*#__PURE__*/ $cQmXV.createElement("span", {
        unselectable: "on",
        className: `${prefixCls}-action-${action}-inner`
    }));
}



function $34664f1c800e8c05$export$d2883c6c6307c415(step) {
    const stepStr = typeof step === "number" ? (0, $e6cee2a632b9f457$export$fdc98affa95a4322)(step) : (0, $e6cee2a632b9f457$export$5be79a0015c5ab12)(step).fullStr;
    const hasPoint = stepStr.includes(".");
    if (!hasPoint) return step + "0";
    return (0, $e6cee2a632b9f457$export$5be79a0015c5ab12)(stepStr.replace(/(\d)\.(\d)/g, "$1$2.")).fullStr;
}





var $cQmXV = parcelRequire("cQmXV");

var /**
 * Always trigger latest once when call multiple time
 */ $bda3bf84a21632e7$export$2e2bcd8739ae039 = ()=>{
    const idRef = (0, $cQmXV.useRef)(0);
    const cleanUp = ()=>{
        (0, $905c53b807de704e$export$2e2bcd8739ae039).cancel(idRef.current);
    };
    (0, $cQmXV.useEffect)(()=>cleanUp, []);
    return (callback)=>{
        cleanUp();
        idRef.current = (0, $905c53b807de704e$export$2e2bcd8739ae039)(()=>{
            callback();
        });
    };
};


function $ef152f3c458e58b7$var$_extends() {
    $ef152f3c458e58b7$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ef152f3c458e58b7$var$_extends.apply(this, arguments);
}
/**
 * We support `stringMode` which need handle correct type when user call in onChange
 * format max or min value
 * 1. if isInvalid return null
 * 2. if precision is undefined, return decimal
 * 3. format with precision
 *    I. if max > 0, round down with precision. Example: max= 3.5, precision=0  afterFormat: 3
 *    II. if max < 0, round up with precision. Example: max= -3.5, precision=0  afterFormat: -4
 *    III. if min > 0, round up with precision. Example: min= 3.5, precision=0  afterFormat: 4
 *    IV. if min < 0, round down with precision. Example: max= -3.5, precision=0  afterFormat: -3
 */ const $ef152f3c458e58b7$var$getDecimalValue = (stringMode, decimalValue)=>{
    if (stringMode || decimalValue.isEmpty()) return decimalValue.toString();
    return decimalValue.toNumber();
};
const $ef152f3c458e58b7$var$getDecimalIfValidate = (value)=>{
    const decimal = (0, $9017971b85cd0c98$export$2e2bcd8739ae039)(value);
    return decimal.isInvalidate() ? null : decimal;
};
const $ef152f3c458e58b7$var$InputNumber = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { mode: mode = "input", prefixCls: prefixCls = "rc-input-number", className: className, style: style, classNames: classNames, styles: styles, min: min, max: max, step: step = 1, defaultValue: defaultValue, value: value, disabled: disabled, readOnly: readOnly, upHandler: upHandler, downHandler: downHandler, keyboard: keyboard, changeOnWheel: changeOnWheel = false, controls: controls = true, prefix: prefix, suffix: suffix, stringMode: stringMode, parser: parser, formatter: formatter, precision: precision, decimalSeparator: decimalSeparator, onChange: onChange, onInput: onInput, onPressEnter: onPressEnter, onStep: onStep, onMouseDown: // Mouse Events
    onMouseDown, onClick: onClick, onMouseUp: onMouseUp, onMouseLeave: onMouseLeave, onMouseMove: onMouseMove, onMouseEnter: onMouseEnter, onMouseOut: onMouseOut, changeOnBlur: changeOnBlur = true, ...restProps } = props;
    const [focus, setFocus] = $cQmXV.useState(false);
    const userTypingRef = $cQmXV.useRef(false);
    const compositionRef = $cQmXV.useRef(false);
    const shiftKeyRef = $cQmXV.useRef(false);
    // ============================= Refs =============================
    const rootRef = $cQmXV.useRef(null);
    const inputRef = $cQmXV.useRef(null);
    $cQmXV.useImperativeHandle(ref, ()=>(0, $7849fe9d137ec9a3$export$2e2bcd8739ae039)(inputRef.current, {
            focus: (option)=>{
                (0, $7aa1eaa901116c60$export$2b92016deb0b7aad)(inputRef.current, option);
            },
            blur: ()=>{
                inputRef.current?.blur();
            },
            nativeElement: rootRef.current
        }));
    // ============================ Value =============================
    // Real value control
    const [decimalValue, setDecimalValue] = $cQmXV.useState(()=>(0, $9017971b85cd0c98$export$2e2bcd8739ae039)(value ?? defaultValue));
    function setUncontrolledDecimalValue(newDecimal) {
        if (value === undefined) setDecimalValue(newDecimal);
    }
    // ====================== Parser & Formatter ======================
    /**
   * `precision` is used for formatter & onChange.
   * It will auto generate by `value` & `step`.
   * But it will not block user typing.
   *
   * Note: Auto generate `precision` is used for legacy logic.
   * We should remove this since we already support high precision with BigInt.
   *
   * @param number  Provide which number should calculate precision
   * @param userTyping  Change by user typing
   */ const getPrecision = $cQmXV.useCallback((numStr, userTyping)=>{
        if (userTyping) return undefined;
        if (precision >= 0) return precision;
        return Math.max((0, $e6cee2a632b9f457$export$2e56483e4ad90ee6)(numStr), (0, $e6cee2a632b9f457$export$2e56483e4ad90ee6)(step));
    }, [
        precision,
        step
    ]);
    // >>> Parser
    const mergedParser = $cQmXV.useCallback((num)=>{
        const numStr = String(num);
        if (parser) return parser(numStr);
        let parsedStr = numStr;
        if (decimalSeparator) parsedStr = parsedStr.replace(decimalSeparator, ".");
        // [Legacy] We still support auto convert `$ 123,456` to `123456`
        return parsedStr.replace(/[^\w.-]+/g, "");
    }, [
        parser,
        decimalSeparator
    ]);
    // >>> Formatter
    const inputValueRef = $cQmXV.useRef("");
    const mergedFormatter = $cQmXV.useCallback((number, userTyping)=>{
        if (formatter) return formatter(number, {
            userTyping: userTyping,
            input: String(inputValueRef.current)
        });
        let str = typeof number === "number" ? (0, $e6cee2a632b9f457$export$fdc98affa95a4322)(number) : number;
        // User typing will not auto format with precision directly
        if (!userTyping) {
            const mergedPrecision = getPrecision(str, userTyping);
            if ((0, $e6cee2a632b9f457$export$b3d198e17b370bec)(str) && (decimalSeparator || mergedPrecision >= 0)) {
                // Separator
                const separatorStr = decimalSeparator || ".";
                str = (0, $38fb46469877b701$export$a81f732198733497)(str, separatorStr, mergedPrecision);
            }
        }
        return str;
    }, [
        formatter,
        getPrecision,
        decimalSeparator
    ]);
    // ========================== InputValue ==========================
    /**
   * Input text value control
   *
   * User can not update input content directly. It updates with follow rules by priority:
   *  1. controlled `value` changed
   *    * [SPECIAL] Typing like `1.` should not immediately convert to `1`
   *  2. User typing with format (not precision)
   *  3. Blur or Enter trigger revalidate
   */ const [inputValue, setInternalInputValue] = $cQmXV.useState(()=>{
        const initValue = defaultValue ?? value;
        if (decimalValue.isInvalidate() && [
            "string",
            "number"
        ].includes(typeof initValue)) return Number.isNaN(initValue) ? "" : initValue;
        return mergedFormatter(decimalValue.toString(), false);
    });
    inputValueRef.current = inputValue;
    // Should always be string
    function setInputValue(newValue, userTyping) {
        setInternalInputValue(mergedFormatter(// Invalidate number is sometime passed by external control, we should let it go
        // Otherwise is controlled by internal interactive logic which check by userTyping
        // You can ref 'show limited value when input is not focused' test for more info.
        newValue.isInvalidate() ? newValue.toString(false) : newValue.toString(!userTyping), userTyping));
    }
    // >>> Max & Min limit
    const maxDecimal = $cQmXV.useMemo(()=>$ef152f3c458e58b7$var$getDecimalIfValidate(max), [
        max,
        precision
    ]);
    const minDecimal = $cQmXV.useMemo(()=>$ef152f3c458e58b7$var$getDecimalIfValidate(min), [
        min,
        precision
    ]);
    const upDisabled = $cQmXV.useMemo(()=>{
        if (!maxDecimal || !decimalValue || decimalValue.isInvalidate()) return false;
        return maxDecimal.lessEquals(decimalValue);
    }, [
        maxDecimal,
        decimalValue
    ]);
    const downDisabled = $cQmXV.useMemo(()=>{
        if (!minDecimal || !decimalValue || decimalValue.isInvalidate()) return false;
        return decimalValue.lessEquals(minDecimal);
    }, [
        minDecimal,
        decimalValue
    ]);
    // Cursor controller
    const [recordCursor, restoreCursor] = (0, $10c22ecb2bfb0fd6$export$2e2bcd8739ae039)(inputRef.current, focus);
    // ============================= Data =============================
    /**
   * Find target value closet within range.
   * e.g. [11, 28]:
   *    3  => 11
   *    23 => 23
   *    99 => 28
   */ const getRangeValue = (target)=>{
        // target > max
        if (maxDecimal && !target.lessEquals(maxDecimal)) return maxDecimal;
        // target < min
        if (minDecimal && !minDecimal.lessEquals(target)) return minDecimal;
        return null;
    };
    /**
   * Check value is in [min, max] range
   */ const isInRange = (target)=>!getRangeValue(target);
    /**
   * Trigger `onChange` if value validated and not equals of origin.
   * Return the value that re-align in range.
   */ const triggerValueUpdate = (newValue, userTyping)=>{
        let updateValue = newValue;
        let isRangeValidate = isInRange(updateValue) || updateValue.isEmpty();
        // Skip align value when trigger value is empty.
        // We just trigger onChange(null)
        // This should not block user typing
        if (!updateValue.isEmpty() && !userTyping) {
            // Revert value in range if needed
            updateValue = getRangeValue(updateValue) || updateValue;
            isRangeValidate = true;
        }
        if (!readOnly && !disabled && isRangeValidate) {
            const numStr = updateValue.toString();
            const mergedPrecision = getPrecision(numStr, userTyping);
            if (mergedPrecision >= 0) {
                updateValue = (0, $9017971b85cd0c98$export$2e2bcd8739ae039)((0, $38fb46469877b701$export$a81f732198733497)(numStr, ".", mergedPrecision));
                // When to fixed. The value may out of min & max range.
                // 4 in [0, 3.8] => 3.8 => 4 (toFixed)
                if (!isInRange(updateValue)) updateValue = (0, $9017971b85cd0c98$export$2e2bcd8739ae039)((0, $38fb46469877b701$export$a81f732198733497)(numStr, ".", mergedPrecision, true));
            }
            // Trigger event
            if (!updateValue.equals(decimalValue)) {
                setUncontrolledDecimalValue(updateValue);
                onChange?.(updateValue.isEmpty() ? null : $ef152f3c458e58b7$var$getDecimalValue(stringMode, updateValue));
                // Reformat input if value is not controlled
                if (value === undefined) setInputValue(updateValue, userTyping);
            }
            return updateValue;
        }
        return decimalValue;
    };
    // ========================== User Input ==========================
    const onNextPromise = (0, $bda3bf84a21632e7$export$2e2bcd8739ae039)();
    // >>> Collect input value
    const collectInputValue = (inputStr)=>{
        recordCursor();
        // Update inputValue in case input can not parse as number
        // Refresh ref value immediately since it may used by formatter
        inputValueRef.current = inputStr;
        setInternalInputValue(inputStr);
        // Parse number
        if (!compositionRef.current) {
            const finalValue = mergedParser(inputStr);
            const finalDecimal = (0, $9017971b85cd0c98$export$2e2bcd8739ae039)(finalValue);
            if (!finalDecimal.isNaN()) triggerValueUpdate(finalDecimal, true);
        }
        // Trigger onInput later to let user customize value if they want to handle something after onChange
        onInput?.(inputStr);
        // optimize for chinese input experience
        // https://github.com/ant-design/ant-design/issues/8196
        onNextPromise(()=>{
            let nextInputStr = inputStr;
            if (!parser) nextInputStr = inputStr.replace(/。/g, ".");
            if (nextInputStr !== inputStr) collectInputValue(nextInputStr);
        });
    };
    // >>> Composition
    const onCompositionStart = ()=>{
        compositionRef.current = true;
    };
    const onCompositionEnd = ()=>{
        compositionRef.current = false;
        collectInputValue(inputRef.current.value);
    };
    // >>> Input
    const onInternalInput = (e)=>{
        collectInputValue(e.target.value);
    };
    // ============================= Step =============================
    const onInternalStep = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((up, emitter)=>{
        // Ignore step since out of range
        if (up && upDisabled || !up && downDisabled) return;
        // Clear typing status since it may be caused by up & down key.
        // We should sync with input value.
        userTypingRef.current = false;
        let stepDecimal = (0, $9017971b85cd0c98$export$2e2bcd8739ae039)(shiftKeyRef.current ? (0, $34664f1c800e8c05$export$d2883c6c6307c415)(step) : step);
        if (!up) stepDecimal = stepDecimal.negate();
        const target = (decimalValue || (0, $9017971b85cd0c98$export$2e2bcd8739ae039)(0)).add(stepDecimal.toString());
        const updatedValue = triggerValueUpdate(target, false);
        onStep?.($ef152f3c458e58b7$var$getDecimalValue(stringMode, updatedValue), {
            offset: shiftKeyRef.current ? (0, $34664f1c800e8c05$export$d2883c6c6307c415)(step) : step,
            type: up ? "up" : "down",
            emitter: emitter
        });
        inputRef.current?.focus();
    });
    // ============================ Flush =============================
    /**
   * Flush current input content to trigger value change & re-formatter input if needed.
   * This will always flush input value for update.
   * If it's invalidate, will fallback to last validate value.
   */ const flushInputValue = (userTyping)=>{
        const parsedValue = (0, $9017971b85cd0c98$export$2e2bcd8739ae039)(mergedParser(inputValue));
        let formatValue;
        if (!parsedValue.isNaN()) // Only validate value or empty value can be re-fill to inputValue
        // Reassign the formatValue within ranged of trigger control
        formatValue = triggerValueUpdate(parsedValue, userTyping);
        else formatValue = triggerValueUpdate(decimalValue, userTyping);
        if (value !== undefined) // Reset back with controlled value first
        setInputValue(decimalValue, false);
        else if (!formatValue.isNaN()) // Reset input back since no validate value
        setInputValue(formatValue, false);
    };
    // Solve the issue of the event triggering sequence when entering numbers in chinese input (Safari)
    const onBeforeInput = ()=>{
        userTypingRef.current = true;
    };
    const onKeyDown = (event)=>{
        const { key: key, shiftKey: shiftKey } = event;
        userTypingRef.current = true;
        shiftKeyRef.current = shiftKey;
        if (key === "Enter") {
            if (!compositionRef.current) userTypingRef.current = false;
            flushInputValue(false);
            onPressEnter?.(event);
        }
        if (keyboard === false) return;
        // Do step
        if (!compositionRef.current && [
            "Up",
            "ArrowUp",
            "Down",
            "ArrowDown"
        ].includes(key)) {
            onInternalStep(key === "Up" || key === "ArrowUp", "keyboard");
            event.preventDefault();
        }
    };
    const onKeyUp = ()=>{
        userTypingRef.current = false;
        shiftKeyRef.current = false;
    };
    $cQmXV.useEffect(()=>{
        if (changeOnWheel && focus) {
            const onWheel = (event)=>{
                // moving mouse wheel rises wheel event with deltaY < 0
                // scroll value grows from top to bottom, as screen Y coordinate
                onInternalStep(event.deltaY < 0, "wheel");
                event.preventDefault();
            };
            const input = inputRef.current;
            if (input) {
                // React onWheel is passive and we can't preventDefault() in it.
                // That's why we should subscribe with DOM listener
                // https://stackoverflow.com/questions/63663025/react-onwheel-handler-cant-preventdefault-because-its-a-passive-event-listenev
                input.addEventListener("wheel", onWheel, {
                    passive: false
                });
                return ()=>input.removeEventListener("wheel", onWheel);
            }
        }
    });
    // >>> Focus & Blur
    const onBlur = ()=>{
        if (changeOnBlur) flushInputValue(false);
        setFocus(false);
        userTypingRef.current = false;
    };
    // >>> Mouse events
    const onInternalMouseDown = (event)=>{
        if (inputRef.current && event.target !== inputRef.current) {
            inputRef.current.focus();
            event.preventDefault();
        }
        onMouseDown?.(event);
    };
    // ========================== Controlled ==========================
    // Input by precision & formatter
    (0, $7673d874dab69d07$export$9283e56bae2f7b0f)(()=>{
        if (!decimalValue.isInvalidate()) setInputValue(decimalValue, false);
    }, [
        precision,
        formatter
    ]);
    // Input by value
    (0, $7673d874dab69d07$export$9283e56bae2f7b0f)(()=>{
        const newValue = (0, $9017971b85cd0c98$export$2e2bcd8739ae039)(value);
        setDecimalValue(newValue);
        const currentParsedValue = (0, $9017971b85cd0c98$export$2e2bcd8739ae039)(mergedParser(inputValue));
        // When user typing from `1.2` to `1.`, we should not convert to `1` immediately.
        // But let it go if user set `formatter`
        if (!newValue.equals(currentParsedValue) || !userTypingRef.current || formatter) // Update value as effect
        setInputValue(newValue, userTypingRef.current);
    }, [
        value
    ]);
    // ============================ Cursor ============================
    (0, $7673d874dab69d07$export$9283e56bae2f7b0f)(()=>{
        if (formatter) restoreCursor();
    }, [
        inputValue
    ]);
    // ============================ Render ============================
    // >>>>>> Handler
    const sharedHandlerProps = {
        prefixCls: prefixCls,
        onStep: onInternalStep,
        className: classNames?.action,
        style: styles?.action
    };
    const upNode = /*#__PURE__*/ $cQmXV.createElement((0, $9387a7533ef86dab$export$2e2bcd8739ae039), $ef152f3c458e58b7$var$_extends({}, sharedHandlerProps, {
        action: "up",
        disabled: upDisabled
    }), upHandler);
    const downNode = /*#__PURE__*/ $cQmXV.createElement((0, $9387a7533ef86dab$export$2e2bcd8739ae039), $ef152f3c458e58b7$var$_extends({}, sharedHandlerProps, {
        action: "down",
        disabled: downDisabled
    }), downHandler);
    // >>>>>> Render
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        ref: rootRef,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-mode-${mode}`, className, classNames?.root, {
            [`${prefixCls}-focused`]: focus,
            [`${prefixCls}-disabled`]: disabled,
            [`${prefixCls}-readonly`]: readOnly,
            [`${prefixCls}-not-a-number`]: decimalValue.isNaN(),
            [`${prefixCls}-out-of-range`]: !decimalValue.isInvalidate() && !isInRange(decimalValue)
        }),
        style: {
            ...styles?.root,
            ...style
        },
        onMouseDown: onInternalMouseDown,
        onMouseUp: onMouseUp,
        onMouseLeave: onMouseLeave,
        onMouseMove: onMouseMove,
        onMouseEnter: onMouseEnter,
        onMouseOut: onMouseOut,
        onClick: onClick,
        onFocus: ()=>{
            setFocus(true);
        },
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onCompositionStart: onCompositionStart,
        onCompositionEnd: onCompositionEnd,
        onBeforeInput: onBeforeInput
    }, mode === "spinner" && controls && downNode, prefix !== undefined && /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-prefix`, classNames?.prefix),
        style: styles?.prefix
    }, prefix), /*#__PURE__*/ $cQmXV.createElement("input", $ef152f3c458e58b7$var$_extends({
        autoComplete: "off",
        role: "spinbutton",
        "aria-valuemin": min,
        "aria-valuemax": max,
        "aria-valuenow": decimalValue.isInvalidate() ? null : decimalValue.toString(),
        step: step,
        ref: inputRef,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-input`, classNames?.input),
        style: styles?.input,
        value: inputValue,
        onChange: onInternalInput,
        disabled: disabled,
        readOnly: readOnly
    }, restProps)), suffix !== undefined && /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-suffix`, classNames?.suffix),
        style: styles?.suffix
    }, suffix), mode === "spinner" && controls && upNode, mode === "input" && controls && /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-actions`, classNames?.actions),
        style: styles?.actions
    }, upNode, downNode));
});
var $ef152f3c458e58b7$export$2e2bcd8739ae039 = $ef152f3c458e58b7$var$InputNumber;


var $57f464fd424e4295$export$2e2bcd8739ae039 = (0, $ef152f3c458e58b7$export$2e2bcd8739ae039);


























const $24db2285bcbf985f$export$9ca1be8807fe0675 = (token)=>{
    const handleVisible = token.handleVisible ?? "auto";
    const handleWidth = token.controlHeightSM - token.lineWidth * 2;
    return {
        ...(0, $5e693f0c6e8784bd$export$bd8b682992bc9781)(token),
        controlWidth: 90,
        handleWidth: handleWidth,
        handleFontSize: token.fontSize / 2,
        handleVisible: handleVisible,
        handleActiveBg: token.colorFillAlter,
        handleBg: token.colorBgContainer,
        filledHandleBg: new (0, $3bb84f07fb2a2f32$export$2c4f38d6c0ecc25a)(token.colorFillSecondary).onBackground(token.colorBgContainer).toHexString(),
        handleHoverColor: token.colorPrimary,
        handleBorderColor: token.colorBorder,
        handleOpacity: handleVisible === true ? 1 : 0,
        handleVisibleWidth: handleVisible === true ? handleWidth : 0
    };
};


const $c592b335d6b441d4$var$genInputNumberStyles = (token)=>{
    const { componentCls: componentCls, lineWidth: lineWidth, lineType: lineType, borderRadius: borderRadius, inputFontSizeSM: inputFontSizeSM, inputFontSizeLG: inputFontSizeLG, colorError: colorError, paddingInlineSM: paddingInlineSM, paddingBlockSM: paddingBlockSM, paddingBlockLG: paddingBlockLG, paddingInlineLG: paddingInlineLG, colorIcon: colorIcon, colorTextDisabled: colorTextDisabled, motionDurationMid: motionDurationMid, handleHoverColor: handleHoverColor, handleOpacity: handleOpacity, paddingInline: paddingInline, paddingBlock: paddingBlock, handleBg: handleBg, handleActiveBg: handleActiveBg, inputAffixPadding: inputAffixPadding, borderRadiusSM: borderRadiusSM, controlWidth: controlWidth, handleBorderColor: handleBorderColor, filledHandleBg: filledHandleBg, lineHeightLG: lineHeightLG, antCls: antCls } = token;
    const borderStyle = `${(0, $05f34ed03d41967d$export$523c0b569236b342)(lineWidth)} ${lineType} ${handleBorderColor}`;
    const [varName, varRef] = (0, $6870d4d7c14ae0bb$export$d82b8f66c5649e14)(antCls, "input-number");
    return [
        // ==========================================================
        // ==                         Base                         ==
        // ==========================================================
        {
            [componentCls]: {
                ...(0, $519d20bf207ce864$export$23997c3e44cc1c59)(token),
                ...(0, $8c2dcdcd3819e8c0$export$8c9a381315f3ebcd)(token),
                [varName("input-padding-block")]: (0, $05f34ed03d41967d$export$523c0b569236b342)(paddingBlock),
                [varName("input-padding-inline")]: (0, $05f34ed03d41967d$export$523c0b569236b342)(paddingInline),
                display: "inline-flex",
                width: controlWidth,
                margin: 0,
                paddingBlock: 0,
                borderRadius: borderRadius,
                // ======================= Variants =======================
                ...(0, $189bffeae8a9954a$export$53795bafd774ce02)(token, {
                    [`${componentCls}-actions`]: {
                        background: handleBg,
                        [`${componentCls}-action-down`]: {
                            borderBlockStart: borderStyle
                        }
                    }
                }),
                ...(0, $189bffeae8a9954a$export$b8365cd7e6671d79)(token, {
                    [`${componentCls}-actions`]: {
                        background: filledHandleBg,
                        [`${componentCls}-action-down`]: {
                            borderBlockStart: borderStyle
                        }
                    },
                    "&:focus-within": {
                        [`${componentCls}-actions`]: {
                            background: handleBg
                        }
                    }
                }),
                ...(0, $189bffeae8a9954a$export$34771e60e0439351)(token, {
                    [`${componentCls}-actions`]: {
                        background: handleBg,
                        [`${componentCls}-action-down`]: {
                            borderBlockStart: borderStyle
                        }
                    }
                }),
                ...(0, $189bffeae8a9954a$export$b6de5da7f39edfcb)(token),
                // InputNumber 两层结构：borderless 补偿只加在内层 input 的 CSS 变量上，避免外层+内层双重 padding 导致高度异常
                [`&${componentCls}-borderless`]: {
                    paddingBlock: 0,
                    [varName("input-padding-block")]: (0, $05f34ed03d41967d$export$523c0b569236b342)(token.calc(paddingBlock).add(lineWidth).equal())
                },
                [`&${componentCls}-borderless${componentCls}-sm`]: {
                    paddingBlock: 0,
                    [varName("input-padding-block")]: (0, $05f34ed03d41967d$export$523c0b569236b342)(token.calc(paddingBlockSM).add(lineWidth).equal())
                },
                [`&${componentCls}-borderless${componentCls}-lg`]: {
                    paddingBlock: 0,
                    [varName("input-padding-block")]: (0, $05f34ed03d41967d$export$523c0b569236b342)(token.calc(paddingBlockLG).add(lineWidth).equal())
                },
                // ========================= RTL ==========================
                "&-rtl": {
                    direction: "rtl",
                    [`${componentCls}-input`]: {
                        direction: "rtl"
                    }
                },
                // ===================== Out Of Range =====================
                [`&${componentCls}-out-of-range`]: {
                    [`${componentCls}-input`]: {
                        color: colorError
                    }
                },
                // ======================== Input =========================
                [`${componentCls}-input`]: {
                    ...(0, $519d20bf207ce864$export$23997c3e44cc1c59)(token),
                    width: "100%",
                    paddingBlock: varRef("input-padding-block"),
                    textAlign: "start",
                    backgroundColor: "transparent",
                    border: 0,
                    borderRadius: 0,
                    outline: 0,
                    transition: `all ${motionDurationMid} linear`,
                    appearance: "textfield",
                    fontSize: "inherit",
                    lineHeight: "inherit",
                    ...(0, $8c2dcdcd3819e8c0$export$92095d0f4c77bd56)(token.colorTextPlaceholder),
                    '&[type="number"]::-webkit-inner-spin-button, &[type="number"]::-webkit-outer-spin-button': {
                        margin: 0,
                        appearance: "none"
                    }
                },
                [`&:hover ${componentCls}-handler-wrap, &-focused ${componentCls}-handler-wrap`]: {
                    width: token.handleWidth,
                    opacity: 1
                },
                // ======================= Disabled =======================
                [`&-disabled ${componentCls}-input`]: {
                    cursor: "not-allowed",
                    color: token.colorTextDisabled
                }
            }
        },
        // ==========================================================
        // ==                        Action                        ==
        // ==========================================================
        {
            [componentCls]: {
                // ======================= Shared =======================
                [`${componentCls}-action`]: {
                    ...(0, $519d20bf207ce864$export$171ccda7bc085e59)(),
                    userSelect: "none",
                    overflow: "hidden",
                    fontWeight: "bold",
                    lineHeight: 0,
                    textAlign: "center",
                    cursor: "pointer",
                    transition: `all ${motionDurationMid} linear`,
                    // Active: change background not disabled only;
                    [`&:active:not(${componentCls}-action-up-disabled):not(${componentCls}-action-down-disabled)`]: {
                        background: handleActiveBg
                    },
                    // Hover: change color not disabled only;
                    [`&:hover:not(${componentCls}-action-up-disabled):not(${componentCls}-action-down-disabled)`]: {
                        color: handleHoverColor
                    },
                    [`&${componentCls}-action-up-disabled, &${componentCls}-action-down-disabled`]: {
                        cursor: "not-allowed",
                        color: colorTextDisabled
                    }
                },
                // ===================== Input Mode =====================
                "&-mode-input": {
                    overflow: "hidden",
                    [`${componentCls}-actions`]: {
                        position: "absolute",
                        insetBlockStart: 0,
                        insetInlineEnd: 0,
                        width: token.handleVisibleWidth,
                        opacity: handleOpacity,
                        height: "100%",
                        borderRadius: 0,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "stretch",
                        transition: `all ${motionDurationMid}`,
                        overflow: "hidden",
                        // Fix input number inside Menu makes icon too large
                        // We arise the selector priority by nest selector here
                        // https://github.com/ant-design/ant-design/issues/14367
                        [`${componentCls}-action`]: {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flex: "auto",
                            height: "40%",
                            marginInlineEnd: 0,
                            fontSize: token.handleFontSize
                        }
                    },
                    [`&:hover ${componentCls}-actions, &-focused ${componentCls}-actions`]: {
                        width: token.handleWidth,
                        opacity: 1
                    },
                    [`${componentCls}-action`]: {
                        color: colorIcon,
                        height: "50%",
                        borderInlineStart: borderStyle,
                        // Hover: change height not disabled only;
                        [`&:hover:not(${componentCls}-action-up-disabled):not(${componentCls}-action-down-disabled)`]: {
                            height: `60%`
                        }
                    },
                    [`&${componentCls}-disabled, &${componentCls}-readonly`]: {
                        [`${componentCls}-actions`]: {
                            display: "none"
                        }
                    }
                },
                // ==================== Spinner Mode ====================
                [`&${componentCls}-mode-spinner`]: {
                    padding: 0,
                    width: "auto",
                    [`${componentCls}-action`]: {
                        flex: "none",
                        paddingInline: varRef("input-padding-inline"),
                        "&-up": {
                            borderInlineStart: borderStyle
                        },
                        "&-down": {
                            borderInlineEnd: borderStyle
                        }
                    },
                    [`${componentCls}-input`]: {
                        textAlign: "center",
                        paddingInline: varRef("input-padding-inline")
                    }
                }
            }
        },
        // ==========================================================
        // ==                         Size                         ==
        // ==========================================================
        {
            [componentCls]: {
                "&-lg": {
                    [varName("input-padding-block")]: (0, $05f34ed03d41967d$export$523c0b569236b342)(paddingBlockLG),
                    [varName("input-padding-inline")]: (0, $05f34ed03d41967d$export$523c0b569236b342)(paddingInlineLG),
                    paddingBlock: 0,
                    fontSize: inputFontSizeLG,
                    lineHeight: lineHeightLG
                },
                "&-sm": {
                    [varName("input-padding-block")]: (0, $05f34ed03d41967d$export$523c0b569236b342)(paddingBlockSM),
                    [varName("input-padding-inline")]: (0, $05f34ed03d41967d$export$523c0b569236b342)(paddingInlineSM),
                    paddingBlock: 0,
                    fontSize: inputFontSizeSM,
                    borderRadius: borderRadiusSM
                }
            }
        },
        // ==========================================================
        // ==                      Pre/Suffix                      ==
        // ==========================================================
        {
            [componentCls]: {
                [`${componentCls}-prefix, ${componentCls}-suffix`]: {
                    display: "flex",
                    flex: "none",
                    alignItems: "center",
                    alignSelf: "center",
                    pointerEvents: "none"
                },
                [`${componentCls}-prefix`]: {
                    marginInlineEnd: inputAffixPadding
                },
                [`${componentCls}-suffix`]: {
                    height: "100%",
                    marginInlineStart: inputAffixPadding,
                    transition: `margin ${motionDurationMid}`
                },
                [`&:hover:not(${componentCls}-without-controls)`]: {
                    [`${componentCls}-suffix`]: {
                        marginInlineEnd: token.handleWidth
                    }
                }
            }
        }
    ];
};
const $c592b335d6b441d4$var$genCompatibleStyles = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    return {
        [`${componentCls}-addon`]: {
            [`&:has(${antCls}-select)`]: {
                border: 0,
                padding: 0
            }
        }
    };
};
var $c592b335d6b441d4$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$51ec95de45185b42)("InputNumber", (token)=>{
    const inputNumberToken = (0, $fef50f256b80dfa5$export$4950aa0f605343fb)(token, (0, $5e693f0c6e8784bd$export$a157d95850191a12)(token));
    return [
        $c592b335d6b441d4$var$genInputNumberStyles(inputNumberToken),
        $c592b335d6b441d4$var$genCompatibleStyles(inputNumberToken),
        // =====================================================
        // ==             Space Compact                       ==
        // =====================================================
        (0, $6e46145470fc0a51$export$b1208b23589b4b73)(inputNumberToken)
    ];
}, (0, $24db2285bcbf985f$export$9ca1be8807fe0675), {
    unitless: {
        handleOpacity: true
    },
    resetFont: false
});


"use client";
const $ee8161052e4cbd2f$var$InternalInputNumber = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const inputRef = $cQmXV.useRef(null);
    $cQmXV.useImperativeHandle(ref, ()=>inputRef.current);
    const { rootClassName: rootClassName, size: customizeSize, disabled: customDisabled, prefixCls: prefixCls, addonBefore: _addonBefore, addonAfter: _addonAfter, prefix: prefix, suffix: suffix, bordered: bordered, readOnly: readOnly, status: status, controls: controls = true, variant: customVariant, className: className, style: style, classNames: classNames, styles: styles, mode: mode, ...others } = props;
    const { direction: direction, className: contextClassName, style: contextStyle, styles: contextStyles, classNames: contextClassNames } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("inputNumber");
    // ===================== Disabled =====================
    const disabled = $cQmXV.useContext((0, $4f0e1ea30330557c$export$2e2bcd8739ae039));
    const mergedDisabled = customDisabled ?? disabled;
    // controls && !mergedDisabled && !readOnly;
    const mergedControls = $cQmXV.useMemo(()=>{
        if (!controls || mergedDisabled || readOnly) return false;
        return controls;
    }, [
        controls,
        mergedDisabled,
        readOnly
    ]);
    const { compactSize: compactSize, compactItemClassnames: compactItemClassnames } = (0, $68fddf51400eda11$export$cd8cf9d7bab8dd4)(prefixCls, direction);
    let upIcon = mode === "spinner" ? /*#__PURE__*/ $cQmXV.createElement((0, $fa25166ced813feb$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $cQmXV.createElement((0, $a9acaf08b7547d32$export$2e2bcd8739ae039), null);
    let downIcon = mode === "spinner" ? /*#__PURE__*/ $cQmXV.createElement((0, $886bddec374e5a95$export$2e2bcd8739ae039), null) : /*#__PURE__*/ $cQmXV.createElement((0, $e7119b602540b2c5$export$2e2bcd8739ae039), null);
    const controlsTemp = typeof mergedControls === "boolean" ? mergedControls : undefined;
    if ((0, $8e2d153a3c855782$export$53b83ca8eaab0383)(mergedControls)) {
        upIcon = mergedControls.upIcon || upIcon;
        downIcon = mergedControls.downIcon || downIcon;
    }
    const { hasFeedback: hasFeedback, isFormItemInput: isFormItemInput, feedbackIcon: feedbackIcon } = $cQmXV.useContext((0, $7a3804f153d8a19d$export$bbb5553c6c7a14ed));
    const mergedSize = (0, $78cdfb6138721329$export$2e2bcd8739ae039)((ctx)=>customizeSize ?? compactSize ?? ctx);
    const [variant, enableVariantCls] = (0, $11c15dfa3883fb6f$export$2e2bcd8739ae039)("inputNumber", customVariant, bordered);
    const suffixNode = (hasFeedback || suffix) && /*#__PURE__*/ $cQmXV.createElement($cQmXV.Fragment, null, suffix, hasFeedback && feedbackIcon);
    // =========== Merged Props for Semantic ==========
    const mergedProps = {
        ...props,
        size: mergedSize,
        disabled: mergedDisabled,
        controls: mergedControls
    };
    const contextStyleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $30c5f9f911d4f61b$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: mergedProps
    });
    return /*#__PURE__*/ $cQmXV.createElement((0, $57f464fd424e4295$export$2e2bcd8739ae039), {
        ref: inputRef,
        mode: mode,
        disabled: mergedDisabled,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(className, rootClassName, mergedClassNames.root, contextClassName, compactItemClassnames, (0, $4a3ea1f9228016b7$export$b08e7b47149942a2)(prefixCls, status, hasFeedback), {
            [`${prefixCls}-${variant}`]: enableVariantCls,
            [`${prefixCls}-lg`]: mergedSize === "large",
            [`${prefixCls}-sm`]: mergedSize === "small",
            [`${prefixCls}-rtl`]: direction === "rtl",
            [`${prefixCls}-in-form-item`]: isFormItemInput,
            [`${prefixCls}-without-controls`]: !mergedControls
        }),
        style: mergedStyles.root,
        upHandler: upIcon,
        downHandler: downIcon,
        prefixCls: prefixCls,
        readOnly: readOnly,
        controls: controlsTemp,
        prefix: prefix,
        suffix: suffixNode,
        classNames: mergedClassNames,
        styles: mergedStyles,
        ...others
    });
});
// ===================================================================
// ==                          InputNumber                          ==
// ===================================================================
const $ee8161052e4cbd2f$var$InputNumber = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { addonBefore: addonBefore, addonAfter: addonAfter, prefixCls: customizePrefixCls, className: className, status: customStatus, rootClassName: rootClassName, ...rest } = props;
    const { getPrefixCls: getPrefixCls } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("inputNumber");
    const prefixCls = getPrefixCls("input-number", customizePrefixCls);
    const { status: contextStatus } = $cQmXV.useContext((0, $7a3804f153d8a19d$export$bbb5553c6c7a14ed));
    const mergedStatus = (0, $4a3ea1f9228016b7$export$314e193082d7ba49)(contextStatus, customStatus);
    const rootCls = (0, $2237081acd3cfc09$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $c592b335d6b441d4$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const hasLegacyAddon = addonBefore || addonAfter;
    var prop, newProp;
    // ====================== Render ======================
    const inputNumberNode = /*#__PURE__*/ $cQmXV.createElement($ee8161052e4cbd2f$var$InternalInputNumber, {
        ref: ref,
        ...rest,
        prefixCls: prefixCls,
        status: mergedStatus,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(cssVarCls, rootCls, hashId, className),
        rootClassName: !hasLegacyAddon ? rootClassName : undefined
    });
    if (hasLegacyAddon) {
        const renderAddon = (node)=>{
            if (!node) return null;
            return /*#__PURE__*/ $cQmXV.createElement((0, $783061a72adde0bd$export$2e2bcd8739ae039), {
                className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-addon`, cssVarCls, hashId),
                variant: props.variant,
                disabled: props.disabled,
                status: mergedStatus
            }, /*#__PURE__*/ $cQmXV.createElement((0, $1585084388e75c84$export$2e2bcd8739ae039), {
                form: true
            }, node));
        };
        const addonBeforeNode = renderAddon(addonBefore);
        const addonAfterNode = renderAddon(addonAfter);
        return /*#__PURE__*/ $cQmXV.createElement((0, $68fddf51400eda11$export$2e2bcd8739ae039), {
            rootClassName: rootClassName
        }, addonBeforeNode, inputNumberNode, addonAfterNode);
    }
    return inputNumberNode;
});
const $ee8161052e4cbd2f$var$TypedInputNumber = $ee8161052e4cbd2f$var$InputNumber;
/** @private Internal Component. Do not use in your production. */ const $ee8161052e4cbd2f$var$PureInputNumber = (props)=>/*#__PURE__*/ $cQmXV.createElement((0, $5764e43cf38ca965$export$2e2bcd8739ae039), {
        theme: {
            components: {
                InputNumber: {
                    handleVisible: true
                }
            }
        }
    }, /*#__PURE__*/ $cQmXV.createElement($ee8161052e4cbd2f$var$InputNumber, {
        ...props
    }));
$ee8161052e4cbd2f$var$TypedInputNumber._InternalPanelDoNotUseOrYouWillBeFired = $ee8161052e4cbd2f$var$PureInputNumber;
var $ee8161052e4cbd2f$export$2e2bcd8739ae039 = $ee8161052e4cbd2f$var$TypedInputNumber;



function $2ec2d0e23c24ce52$export$2e2bcd8739ae039({ field: field, value: value, onChange: onChange }) {
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $ee8161052e4cbd2f$export$2e2bcd8739ae039), {
        prefix: (0, $5cf5963f505f5084$export$2e2bcd8739ae039)(field),
        value: value ?? null,
        onChange: (next)=>onChange(field.name, next ?? null)
    });
}



parcelRequire("cQmXV");

function $c63a8eb75f76f029$export$2e2bcd8739ae039({ field: field, value: value, onChange: onChange }) {
    const display = field.json && value && typeof value !== "string" ? JSON.stringify(value, null, 2) : value ?? "";
    const handle = (event)=>{
        const raw = event.target.value;
        if (!field.json) return onChange(field.name, raw);
        try {
            onChange(field.name, raw ? JSON.parse(raw) : {});
        } catch  {
            onChange(field.name, raw);
        } // keep raw; the server validates
    };
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0883e7f8083c01b0$export$2e2bcd8739ae039).TextArea, {
        rows: 4,
        value: display,
        onChange: handle,
        className: field.json ? "pt-form-textarea--code" : undefined
    });
}



parcelRequire("cQmXV");

function $7391c7def2587363$export$2e2bcd8739ae039({ field: field, value: value, onChange: onChange }) {
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $7a650444b7c2c328$export$2e2bcd8739ae039), {
        checked: !!value,
        onChange: (event)=>onChange(field.name, event.target.checked),
        children: field._label
    });
}



parcelRequire("cQmXV");




function $3f35eb033bcc08a0$export$2e2bcd8739ae039({ field: field, value: value, onChange: onChange, lang: lang }) {
    // Localize option display labels (keyed by value); fall back to the raw label.
    const options = (field.options || []).map((o)=>({
            value: o.value,
            label: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$912d163297011df8), String(o.value), lang) || o.label
        }));
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $872fd39f1285217b$export$2e2bcd8739ae039), {
        prefix: (0, $5cf5963f505f5084$export$2e2bcd8739ae039)(field),
        options: options,
        value: value ?? undefined,
        allowClear: !field.required,
        onChange: (next)=>onChange(field.name, next ?? null)
    });
}




var $cQmXV = parcelRequire("cQmXV");








const $bb83f1a52e933cf8$var$byId = (list)=>Array.from(new Map(list.map((o)=>[
            o.id,
            o
        ])).values());
function $bb83f1a52e933cf8$export$2e2bcd8739ae039({ field: field, value: value, onChange: onChange, item: item = {}, lang: lang }) {
    const [importing, setImporting] = (0, $cQmXV.useState)(false);
    const select = /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b6929c6a194abc34$export$2e2bcd8739ae039), {
        entity: field.entity,
        value: value,
        isMulti: !!field.isMulti,
        /* County scope, applied by EntitySelect for point entities only. */ county: field.scopeBy ? item[field.scopeBy] : undefined,
        /* Create/edit pickers offer ACTIVE related objects only — a deactivated one cannot be
         saved. A descriptor overrides via `field.query`. */ extraQuery: {
            active: true,
            ...field.query || {}
        },
        prefix: (0, $5cf5963f505f5084$export$2e2bcd8739ae039)(field),
        /* `tall` shows every chip in a wrapping, scrollable area; a plain wide multi shows as many as
         fit on one line then `+N`; a normal-width one keeps the single-chip `+N`. */ tall: !!field.tall,
        maxTagCount: field.tall ? undefined : field.isMulti && field.wide ? "responsive" : 1,
        placeholder: field.placeholder,
        ariaLabel: field._label,
        onChange: (option)=>onChange(field.name, field.isMulti ? option || [] : option || null)
    });
    if (!field.fileImport || !field.isMulti) return select;
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), key, lang);
    const importFile = (file)=>{
        const form = new FormData();
        form.append("file", file);
        setImporting(true);
        (0, $c9936523dc38c641$export$a3c8e1472dc2ed84)({
            method: "POST",
            url: field.fileImport.url,
            post: form
        }, (response)=>{
            setImporting(false);
            if (response?.errors?.length) (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).error(`${t("file_error_uploaded")} ( ${response.errors[0]?.reason} )`, {
                position: "top-right"
            });
            if (!Array.isArray(response?.valid_ids)) return;
            onChange(field.name, $bb83f1a52e933cf8$var$byId([
                ...value || [],
                ...response.valid_ids
            ]));
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success(t("file_successfully_uploaded"), {
                position: "top-right"
            });
        });
        return false; // never let antd upload it itself
    };
    return /* Default stretch, so the select keeps the full cell width it takes from its parent. */ /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
        vertical: true,
        gap: 8,
        children: [
            select,
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b615b6e60c753ce5$export$2e2bcd8739ae039), {
                accept: field.fileImport.accept || ".csv,.xlsx",
                showUploadList: false,
                beforeUpload: importFile,
                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                    size: "small",
                    icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $08a66dd72a6d5552$export$2e2bcd8739ae039), {}),
                    loading: importing,
                    children: t("group_import_btn")
                })
            })
        ]
    });
}



parcelRequire("cQmXV");

const $9ca4377bf068c205$var$toLatLng = (v)=>{
    if (v && (v.latitude !== undefined || v.longitude !== undefined)) return {
        lat: v.latitude,
        lng: v.longitude
    };
    return {
        lat: null,
        lng: null
    };
};
function $9ca4377bf068c205$export$2e2bcd8739ae039({ field: field, value: value, onChange: onChange, labels: labels = {} }) {
    const { lat: lat, lng: lng } = $9ca4377bf068c205$var$toLatLng(value);
    const emit = (nextLat, nextLng)=>{
        if (nextLat === null && nextLng === null) return onChange(field.name, null);
        onChange(field.name, {
            latitude: Number(nextLat),
            longitude: Number(nextLng)
        });
    };
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
        gap: "small",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $ee8161052e4cbd2f$export$2e2bcd8739ae039), {
                style: {
                    flex: 1
                },
                step: "any",
                placeholder: labels.lat,
                "aria-label": labels.lat,
                value: lat ?? null,
                onChange: (next)=>emit(next ?? null, lng)
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $ee8161052e4cbd2f$export$2e2bcd8739ae039), {
                style: {
                    flex: 1
                },
                step: "any",
                placeholder: labels.lng,
                "aria-label": labels.lng,
                value: lng ?? null,
                onChange: (next)=>emit(lat, next ?? null)
            })
        ]
    });
}



parcelRequire("cQmXV");




function $b726eec519e5aa1c$export$2e2bcd8739ae039({ field: field, value: value, onChange: onChange, lang: lang }) {
    // Localize option display labels (keyed by value); fall back to the raw label.
    const options = (field.options || []).map((o)=>({
            value: o.value,
            label: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$912d163297011df8), String(o.value), lang) || o.label
        }));
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $872fd39f1285217b$export$2e2bcd8739ae039), {
        mode: "multiple",
        prefix: (0, $5cf5963f505f5084$export$2e2bcd8739ae039)(field),
        /* The mockups' `+N` overflow tag is antd's own behaviour (spec/02) — don't reimplement it. */ maxTagCount: "responsive",
        options: options,
        value: value || [],
        onChange: (next)=>onChange(field.name, next || [])
    });
}




var $cQmXV = parcelRequire("cQmXV");




var $cQmXV = parcelRequire("cQmXV");






"use client";
const { Option: $3f5a3af5eaaa1daa$var$Option } = (0, $872fd39f1285217b$export$2e2bcd8739ae039);
function $3f5a3af5eaaa1daa$var$isSelectOptionOrSelectOptGroup(child) {
    return child?.type && (child.type.isSelectOption || child.type.isSelectOptGroup);
}
const $3f5a3af5eaaa1daa$var$AutoComplete = (props, ref)=>{
    const { prefixCls: customizePrefixCls, className: className, style: style, popupClassName: popupClassName, dropdownClassName: dropdownClassName, children: children, dataSource: dataSource, rootClassName: rootClassName, dropdownStyle: dropdownStyle, dropdownRender: dropdownRender, popupRender: popupRender, onDropdownVisibleChange: onDropdownVisibleChange, onOpenChange: onOpenChange, styles: styles, classNames: classNames, popupMatchSelectWidth: popupMatchSelectWidth, dropdownMatchSelectWidth: dropdownMatchSelectWidth } = props;
    const childNodes = (0, $cd966a313e0a92ff$export$2e2bcd8739ae039)(children);
    const mergedPopupRender = popupRender || dropdownRender;
    const mergedOnOpenChange = onOpenChange || onDropdownVisibleChange;
    const mergedPopupMatchSelectWidth = popupMatchSelectWidth ?? dropdownMatchSelectWidth;
    // ============================= Input =============================
    let customizeInput;
    if (childNodes.length === 1 && /*#__PURE__*/ $cQmXV.isValidElement(childNodes[0]) && !$3f5a3af5eaaa1daa$var$isSelectOptionOrSelectOptGroup(childNodes[0])) [customizeInput] = childNodes;
    const getInputElement = customizeInput ? ()=>customizeInput : undefined;
    // ============================ Options ============================
    let optionChildren;
    // [Legacy] convert `children` or `dataSource` into option children
    if (childNodes.length && $3f5a3af5eaaa1daa$var$isSelectOptionOrSelectOptGroup(childNodes[0])) optionChildren = children;
    else optionChildren = dataSource ? dataSource.map((item)=>{
        if (/*#__PURE__*/ $cQmXV.isValidElement(item)) return item;
        switch(typeof item){
            case "string":
                return /*#__PURE__*/ $cQmXV.createElement($3f5a3af5eaaa1daa$var$Option, {
                    key: item,
                    value: item
                }, item);
            case "object":
                {
                    const { value: optionValue } = item;
                    return /*#__PURE__*/ $cQmXV.createElement($3f5a3af5eaaa1daa$var$Option, {
                        key: optionValue,
                        value: optionValue
                    }, item.text);
                }
            default:
                return undefined;
        }
    }) : [];
    var oldProp, newProp;
    const { getPrefixCls: getPrefixCls } = $cQmXV.useContext((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls("select", customizePrefixCls);
    // =========== Merged Props for Semantic ===========
    const mergedProps = {
        ...props,
        popupRender: mergedPopupRender,
        onOpenChange: mergedOnOpenChange,
        popupMatchSelectWidth: mergedPopupMatchSelectWidth
    };
    // ========================= Style ==========================
    const [mergedClassNames, mergedStyles] = (0, $30c5f9f911d4f61b$export$648566b068f28737)([
        classNames
    ], [
        styles
    ], {
        props: mergedProps
    }, {
        popup: {
            _default: "root"
        }
    });
    const finalClassNames = $cQmXV.useMemo(()=>({
            root: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-auto-complete`, className, rootClassName, mergedClassNames.root, {
                [`${prefixCls}-customize`]: customizeInput
            }),
            prefix: mergedClassNames.prefix,
            input: mergedClassNames.input,
            placeholder: mergedClassNames.placeholder,
            content: mergedClassNames.content,
            popup: {
                root: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(popupClassName, dropdownClassName, mergedClassNames.popup.root),
                list: mergedClassNames.popup.list,
                listItem: mergedClassNames.popup.listItem
            }
        }), [
        prefixCls,
        className,
        rootClassName,
        mergedClassNames,
        popupClassName,
        dropdownClassName
    ]);
    const finalStyles = $cQmXV.useMemo(()=>({
            root: {
                ...mergedStyles.root,
                ...style
            },
            input: mergedStyles.input,
            prefix: mergedStyles.prefix,
            placeholder: mergedStyles.placeholder,
            content: mergedStyles.content,
            popup: {
                root: {
                    ...dropdownStyle,
                    ...mergedStyles.popup.root
                },
                list: mergedStyles.popup.list,
                listItem: mergedStyles.popup.listItem
            }
        }), [
        mergedStyles,
        style,
        dropdownStyle
    ]);
    return /*#__PURE__*/ $cQmXV.createElement((0, $872fd39f1285217b$export$2e2bcd8739ae039), {
        ref: ref,
        suffixIcon: null,
        ...(0, $e8c5093aebad6025$export$2e2bcd8739ae039)(props, [
            "dataSource",
            "dropdownClassName",
            "popupClassName"
        ]),
        prefixCls: prefixCls,
        classNames: finalClassNames,
        styles: finalStyles,
        mode: (0, $872fd39f1285217b$export$2e2bcd8739ae039).SECRET_COMBOBOX_MODE_DO_NOT_USE,
        popupRender: mergedPopupRender,
        onPopupVisibleChange: mergedOnOpenChange,
        popupMatchSelectWidth: mergedPopupMatchSelectWidth,
        getInputElement: // Internal api
        getInputElement
    }, optionChildren);
};
const $3f5a3af5eaaa1daa$var$RefAutoComplete = /*#__PURE__*/ $cQmXV.forwardRef($3f5a3af5eaaa1daa$var$AutoComplete);
var $3f5a3af5eaaa1daa$export$2e2bcd8739ae039 = $3f5a3af5eaaa1daa$var$RefAutoComplete;


"use client";
const { Option: $19caa9cae6c98104$var$Option } = (0, $872fd39f1285217b$export$2e2bcd8739ae039);
// We don't care debug panel
/* istanbul ignore next */ const $19caa9cae6c98104$var$PurePanel = (0, $f2e41308375833b9$export$2e2bcd8739ae039)((0, $3f5a3af5eaaa1daa$export$2e2bcd8739ae039), "popupAlign", (props)=>(0, $e8c5093aebad6025$export$2e2bcd8739ae039)(props, [
        "visible"
    ]));
const $19caa9cae6c98104$var$AutoComplete = (0, $3f5a3af5eaaa1daa$export$2e2bcd8739ae039);
$19caa9cae6c98104$var$AutoComplete.Option = $19caa9cae6c98104$var$Option;
$19caa9cae6c98104$var$AutoComplete._InternalPanelDoNotUseOrYouWillBeFired = $19caa9cae6c98104$var$PurePanel;
var $19caa9cae6c98104$export$2e2bcd8739ae039 = $19caa9cae6c98104$var$AutoComplete;





var $cQmXV = parcelRequire("cQmXV");

var $3af2dca0564538a0$exports = {};
$3af2dca0564538a0$exports = new URL("marker-icon.3f7d3721.png", import.meta.url).toString();


const $6967b95453f7bc7e$var$LEAFLET_SRC = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.js";
const $6967b95453f7bc7e$var$LEAFLET_INTEGRITY = "sha256-20nQCchB9co0qIjJZRGuk2/Z9VM+kNiyxNV1lvTlZBo=";
/* ⚠ THE BASEMAP IS AN UNRESOLVED LICENSING QUESTION, AND THIS IS NOT THE SAFE ANSWER — it is the
   status quo. `tile.openstreetmap.org` is what the app has always used, but the OSMF Tile Usage
   Policy asks that it NOT be used for commercial or heavy traffic, so this is a known debt, not a
   cleared one. See docs/design/spec/02-components.md#maps.

   CARTO Positron was tried here and reverted on 2026-08-24: its basemaps are free with attribution
   for light use, but the terms expect an account for commercial volume, and because there is no
   API key it works silently until it is rate-limited — the worst failure mode for production. That
   is a paid dependency wearing a free coat, so it is not an improvement over the debt above.

   The genuinely production-safe routes are vector and both need MapLibre GL rather than raster
   tiles: OpenFreeMap (no key, self-hostable) or self-hosted Protomaps. Either is a real change —
   a new CDN dependency and a different layer type — and a commercial decision, so it is deliberately
   NOT made here. Do not swap this URL for another free raster host without checking its terms:
   every well-known one carries the same restriction. */ const $6967b95453f7bc7e$var$TILE_URL = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";
const $6967b95453f7bc7e$var$TILE_ATTR = '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';
let $6967b95453f7bc7e$var$leafletPromise = null;
function $6967b95453f7bc7e$var$ensureLeaflet() {
    if (window.L) return Promise.resolve(window.L);
    if ($6967b95453f7bc7e$var$leafletPromise) return $6967b95453f7bc7e$var$leafletPromise;
    const pending = new Promise((resolve, reject)=>{
        const script = document.createElement("script");
        script.src = $6967b95453f7bc7e$var$LEAFLET_SRC;
        script.integrity = $6967b95453f7bc7e$var$LEAFLET_INTEGRITY;
        script.crossOrigin = "";
        script.async = true;
        script.onload = ()=>resolve(window.L);
        script.onerror = (err)=>reject(err);
        document.body.appendChild(script);
    });
    /* ⚠ A REJECTION MUST NOT STAY MEMOIZED. One CDN blip used to poison this module for the whole
     session — every later mount got the same failed promise back and no map could ever load
     again. Clearing it lets the next mount retry; the guard keeps a slow failure from clobbering
     a newer, successful attempt. */ pending.catch(()=>{
        if ($6967b95453f7bc7e$var$leafletPromise === pending) $6967b95453f7bc7e$var$leafletPromise = null;
    });
    $6967b95453f7bc7e$var$leafletPromise = pending;
    return pending;
}
/* One content signature per collection. Identity comparison is not enough: every poll builds a
   new array and every unrelated re-render reaches componentDidUpdate, so comparing references
   would rebuild every pin on each pass — a visible flicker. Signing the CONTENT means the caller
   needs no memoization discipline at all. */ const $6967b95453f7bc7e$var$markerSig = (markers)=>(markers || []).map((m)=>[
            m.key,
            m.lat,
            m.lng,
            m.tone,
            m.kind,
            m.label,
            m.photo
        ].join(":")).join("|");
const $6967b95453f7bc7e$var$lineSig = (track, plan)=>JSON.stringify([
        track || null,
        plan || null
    ]);
const $6967b95453f7bc7e$var$isNum = (value)=>Number.isFinite(value);
class $6967b95453f7bc7e$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Component {
    constructor(props){
        super(props);
        this.containerId = `pt-map-${Math.random().toString(36).slice(2)}`;
        this.map = null;
        this.marker = null;
        this._destroyed = false;
        this._fitted = false;
        this.state = {
            failed: false
        };
    }
    componentDidMount() {
        $6967b95453f7bc7e$var$ensureLeaflet().then((L)=>{
            if (!this._destroyed) this.init(L);
        }, ()=>{
            /* Graceful fallback rather than a blank box — spec/02 asks for coordinates plus a
           notice when the CDN is unreachable. */ if (!this._destroyed) this.setState({
                failed: true
            });
        });
    }
    init(L) {
        const { lat: lat, lng: lng, zoom: zoom = 13, editable: editable, markers: markers } = this.props;
        const center = [
            lat ?? 0,
            lng ?? 0
        ];
        this.L = L;
        /* `scrollWheelZoom: false` per spec/02 — a map that eats the wheel makes the long form it
       sits in unusable. Zoom via the +/- controls.
       ponytail: no ctrl+wheel escape hatch. Leaflet has no native modifier option; if precise
       zooming is missed in the point editor, a keydown listener toggling
       `map.scrollWheelZoom.enable()` is the upgrade. */ this.map = L.map(this.containerId, {
            scrollWheelZoom: false
        }).setView(center, zoom);
        L.tileLayer($6967b95453f7bc7e$var$TILE_URL, {
            attribution: $6967b95453f7bc7e$var$TILE_ATTR,
            maxZoom: 19
        }).addTo(this.map);
        /* The single draggable pin, for the coordinate editor and the visit's point.
       ⚠ Gated on `markers` being ABSENT — never on lat/lng being present. LocationPickerField
       opens a NEW point with no coordinates at all and depends on this pin existing at [0,0]:
       both the drag handler and the map-click handler call `this.marker.setLatLng`, so gating on
       a coordinate would make creating a point impossible. */ if (!markers) {
            const icon = L.icon({
                iconUrl: (0, (/*@__PURE__*/$parcel$interopDefault($3af2dca0564538a0$exports))),
                iconSize: [
                    25,
                    41
                ],
                iconAnchor: [
                    12,
                    41
                ]
            });
            this.marker = L.marker(center, {
                icon: icon,
                draggable: !!editable
            }).addTo(this.map);
            if (editable) {
                this.marker.on("dragend", ()=>{
                    const { lat: newLat, lng: newLng } = this.marker.getLatLng();
                    if (this.props.onChange) this.props.onChange({
                        lat: newLat,
                        lng: newLng
                    });
                });
                this.map.on("click", (e)=>{
                    this.marker.setLatLng(e.latlng);
                    if (this.props.onChange) this.props.onChange({
                        lat: e.latlng.lat,
                        lng: e.latlng.lng
                    });
                });
            }
        }
        this.lines = L.layerGroup().addTo(this.map);
        this.pins = L.layerGroup().addTo(this.map);
        this.sync(true);
        setTimeout(()=>this.map && this.map.invalidateSize(), 0);
    }
    /* A divIcon rather than an image: Leaflet's default icon resolves its PNGs relative to its own
     CSS, which breaks under a bundler. `html` is an ELEMENT, not a string — Leaflet 1.9 accepts
     one, and setting textContent sidesteps escaping a user-supplied name. Passing `className`
     replaces Leaflet's own `leaflet-div-icon`, so the default white box never appears. */ pin(marker) {
        const el = document.createElement("span");
        el.className = [
            "lf-pin",
            marker.tone && `lf-pin--${marker.tone}`,
            marker.kind && `lf-pin--${marker.kind}`
        ].filter(Boolean).join(" ");
        const label = marker.label == null ? "" : String(marker.label);
        if (marker.photo) {
            /* ⚠ ALWAYS give an avatar an onError fallback. Old records point at uploads whose files are
         long gone, so without this the pin renders as a broken image — and unlike antd's <Avatar>,
         a raw <img> has no children to fall back to. On failure the img is dropped and the
         initials take over, which is the house avatar anyway. */ const img = document.createElement("img");
            img.src = marker.photo;
            img.alt = "";
            img.onerror = ()=>{
                img.remove();
                el.textContent = label;
            };
            el.appendChild(img);
        } else el.textContent = label;
        /* ⚠ Must MATCH the CSS width for that kind, or `iconAnchor` centres the wrong box and the pin
       sits visibly off its own coordinate. lf-pin--here is 42, lf-pin--who is 34, lf-pin--dot is
       12 (a GPS ping, not a place), the rest 28. */ const size = marker.kind === "here" ? 42 : marker.kind === "who" ? 34 : marker.kind === "dot" ? 12 : 28;
        return this.L.divIcon({
            html: el,
            className: "lf-pin-host",
            iconSize: [
                size,
                size
            ],
            iconAnchor: [
                size / 2,
                size / 2
            ]
        });
    }
    drawPins() {
        const { markers: markers } = this.props;
        this.pins.clearLayers();
        (markers || []).filter((m)=>$6967b95453f7bc7e$var$isNum(m.lat) && $6967b95453f7bc7e$var$isNum(m.lng)).forEach((m)=>{
            const pin = this.L.marker([
                m.lat,
                m.lng
            ], {
                icon: this.pin(m),
                title: m.title || undefined,
                riseOnHover: true,
                /* Makes the pin FOCUSABLE — Leaflet sets `tabindex="0"` and `role="button"` on the icon.
             It does not make it operable; see the keydown handler below. */ keyboard: !!m.clickable
            }).addTo(this.pins);
            if (m.clickable) {
                /* `this.props` is read at CALL time, so a marker built in an earlier sync never holds a
             stale handler. */ pin.on("click", ()=>this.props.onMarkerClick && this.props.onMarkerClick(m));
                /* ⚠ LEAFLET'S `keyboard: true` IMPLEMENTS NO ACTIVATION. It sets `tabindex` and
             `role="button"` and stops there — and a browser only synthesises click-on-Enter for a
             real <button> or <a>, never for a `role="button"` element. So the pin was focusable and
             completely dead to the keyboard, which is the `<div onClick>` failure spec/03 forbids,
             wearing an ARIA role that promised otherwise. Verified by dispatching Enter: nothing
             happened, on `keydown` and on Leaflet's `keypress` alike.
             Space is handled too, because `role="button"` advertises both. */ const el = pin.getElement();
                if (el) el.addEventListener("keydown", (event)=>{
                    if (event.key !== "Enter" && event.key !== " ") return;
                    event.preventDefault();
                    if (this.props.onMarkerClick) this.props.onMarkerClick(m);
                });
            }
        });
    }
    drawLines() {
        const { track: track, plan: plan } = this.props;
        this.lines.clearLayers();
        /* Leaflet renders polylines as real SVG in the DOM, so the stroke comes from a token via a
       class — no hex passed through Leaflet's options, and the lines follow the theme. */ if (Array.isArray(plan) && plan.length >= 2) this.L.polyline(plan, {
            className: "lf-plan"
        }).addTo(this.lines);
        if (Array.isArray(track) && track.length >= 2) this.L.polyline(track, {
            className: "lf-track"
        }).addTo(this.lines);
    }
    /* Every coordinate the DATA props contribute. Deliberately excludes the primary lat/lng marker:
     fitting to it would override the caller's `zoom`, and LocationPickerField opens a new point at
     zoom 6 on purpose. No data props => no fit => the constructor's setView stands. */ dataPoints() {
        const { markers: markers, track: track, plan: plan } = this.props;
        const out = [];
        (markers || []).forEach((m)=>{
            if ($6967b95453f7bc7e$var$isNum(m.lat) && $6967b95453f7bc7e$var$isNum(m.lng)) out.push([
                m.lat,
                m.lng
            ]);
        });
        if (Array.isArray(track)) track.forEach((p)=>out.push(p));
        if (Array.isArray(plan)) plan.forEach((p)=>out.push(p));
        return out;
    }
    fit() {
        const points = this.dataPoints();
        if (!points.length) return;
        this._fitted = true;
        /* One point has no bounds to speak of — fitBounds would slam to max zoom. Centre instead, so
       a lone active merchandiser is visible rather than a map parked in the Atlantic. */ if (points.length === 1) {
            this.map.setView(points[0], this.props.zoom ?? 13);
            return;
        }
        this.map.fitBounds(this.L.latLngBounds(points), {
            padding: [
                24,
                24
            ],
            maxZoom: 16
        });
    }
    sync(force) {
        if (!this.map) return;
        const { markers: markers, track: track, plan: plan, fitKey: fitKey } = this.props;
        const nextMarkers = $6967b95453f7bc7e$var$markerSig(markers);
        if (force || nextMarkers !== this._markerSig) {
            this._markerSig = nextMarkers;
            this.drawPins();
        }
        const nextLines = $6967b95453f7bc7e$var$lineSig(track, plan);
        if (force || nextLines !== this._lineSig) {
            this._lineSig = nextLines;
            this.drawLines();
        }
        /* Fit is driven by `fitKey` ALONE, and re-armed rather than fired directly: comparing
       prevProps.fitKey to fitKey would miss first-data-arrival, since the day and the selection
       are already set at mount and the rows land later. Arming a flag and fitting on the first
       sync that actually has bounds covers both. A poll changes no key, so it never touches the
       pan or zoom the user set. */ if (!force && fitKey !== this._fitKey) this._fitted = false;
        this._fitKey = fitKey;
        if (!this._fitted) this.fit();
        /* `focus` — a list of [lat, lng] to bring into view together (the visit's point beside one
       chosen GPS ping), framed without disturbing anything else; a change in the list is what fires
       it, so re-renders and polls never move the map. `maxZoom` keeps two coordinates 30 m apart
       from zooming to a rooftop. */ const { focus: focus } = this.props;
        const nextFocus = JSON.stringify(focus || null);
        if (nextFocus !== this._focusSig) {
            this._focusSig = nextFocus;
            if (focus && focus.length) this.map.fitBounds(focus, {
                padding: [
                    40,
                    40
                ],
                maxZoom: 17
            });
        }
    }
    componentDidUpdate(prevProps) {
        if (!this.map) return;
        this.sync(false);
        /* The single-marker path. Untouched behaviour for the two callers that use it: move the pin
       in place, never rebuild the map (spec/02) and never change the zoom. */ if (!this.marker) return;
        const { lat: lat, lng: lng } = this.props;
        if (!$6967b95453f7bc7e$var$isNum(lat) || !$6967b95453f7bc7e$var$isNum(lng)) return;
        if (prevProps.lat === lat && prevProps.lng === lng) return;
        this.marker.setLatLng([
            lat,
            lng
        ]);
        this.map.setView([
            lat,
            lng
        ], this.map.getZoom());
    }
    componentWillUnmount() {
        this._destroyed = true;
        if (this.map) {
            this.map.remove();
            this.map = null;
        }
    }
    render() {
        const { height: height = 320, lat: lat, lng: lng, failedText: failedText } = this.props;
        if (this.state.failed) return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
            className: "pt-map pt-map--failed",
            style: {
                height: height,
                width: "100%"
            },
            children: [
                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                    children: failedText || "Map unavailable"
                }),
                $6967b95453f7bc7e$var$isNum(lat) && $6967b95453f7bc7e$var$isNum(lng) ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("code", {
                    children: `${lat.toFixed(5)}, ${lng.toFixed(5)}`
                }) : null
            ]
        });
        return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
            id: this.containerId,
            className: "pt-map",
            style: {
                height: height,
                width: "100%"
            }
        });
    }
}





/* Real address lookup: Nominatim `search`, a handful of candidates the user picks from — not a
   blind jump to the single top hit. Debounced and abortable, both because a keystroke-per-request
   flood is wrong and because Nominatim's usage policy is ~1 req/s (see the memory note). */ async function $7a4a9b6d201c3830$var$geocodeSearch(query, signal) {
    const url = `https://nominatim.openstreetmap.org/search?format=json&addressdetails=1&limit=6&q=${encodeURIComponent(query)}`;
    const res = await fetch(url, {
        signal: signal,
        headers: {
            "Accept-Language": "en"
        }
    });
    return res.ok ? res.json() : [];
}
async function $7a4a9b6d201c3830$var$geocodeReverse(lat, lng) {
    const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`;
    const res = await fetch(url);
    return res.json();
}
const $7a4a9b6d201c3830$var$MIN_CHARS = 3;
function $7a4a9b6d201c3830$export$2e2bcd8739ae039({ field: field, value: value, onChange: onChange, item: item, labels: labels = {}, lang: lang }) {
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ac552071080927b0), key, lang);
    const [text, setText] = (0, $cQmXV.useState)(item && item.address || "");
    const [options, setOptions] = (0, $cQmXV.useState)([]);
    const [loading, setLoading] = (0, $cQmXV.useState)(false);
    const debounce = (0, $cQmXV.useRef)(null);
    const controller = (0, $cQmXV.useRef)(null);
    const lat = value ? value.latitude : null;
    const lng = value ? value.longitude : null;
    /* Type → debounced fetch → candidate list. One AbortController per request, so a fast typist
     leaves one request in flight rather than one per keystroke. */ const handleSearch = (query)=>{
        setText(query);
        clearTimeout(debounce.current);
        if (controller.current) controller.current.abort();
        if (!query || query.trim().length < $7a4a9b6d201c3830$var$MIN_CHARS) {
            setOptions([]);
            setLoading(false);
            return;
        }
        setLoading(true);
        debounce.current = setTimeout(()=>{
            controller.current = new AbortController();
            $7a4a9b6d201c3830$var$geocodeSearch(query.trim(), controller.current.signal).then((results)=>{
                setOptions((results || []).map((r)=>({
                        value: r.place_id ? String(r.place_id) : r.display_name,
                        label: r.display_name,
                        result: r
                    })));
                setLoading(false);
            }).catch((error)=>{
                if (error.name === "AbortError") return;
                setOptions([]);
                setLoading(false);
            });
        }, (0, $91ea30cb49819b9a$export$8e5d48d2b3bed316));
    };
    /* Picking a candidate is the single writer of a searched location: it sets the coordinate AND
     the address together, and pans the map (value change drives LeafletMap). */ const handleSelect = (optionValue, option)=>{
        const r = option.result;
        if (!r) return;
        setText(r.display_name);
        setOptions([]);
        onChange(field.name, {
            latitude: Number(r.lat),
            longitude: Number(r.lon)
        });
        onChange("address", r.display_name);
    };
    const reverseGeocode = async (rLat, rLng)=>{
        try {
            const result = await $7a4a9b6d201c3830$var$geocodeReverse(rLat, rLng);
            if (result && result.display_name) {
                setText(result.display_name);
                onChange("address", result.display_name);
            }
        } catch (e) {
        // ignore reverse geocode failures, never crash the form
        }
    };
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
        vertical: true,
        gap: "small",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $19caa9cae6c98104$export$2e2bcd8739ae039), {
                options: options,
                value: text,
                onSearch: handleSearch,
                onSelect: handleSelect,
                onChange: setText,
                /* Keep the picked/typed text visible; matching is server-side, so don't also filter the
           returned candidates client-side. */ filterOption: false,
                notFoundContent: loading ? t("searching") : text.trim().length >= $7a4a9b6d201c3830$var$MIN_CHARS ? t("not_found") : t("address_min_chars"),
                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0883e7f8083c01b0$export$2e2bcd8739ae039), {
                    allowClear: true,
                    prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $20a259d46bffcb08$export$2e2bcd8739ae039), {}),
                    placeholder: t("search_address"),
                    "aria-label": t("search_address")
                })
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                gap: "small",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $ee8161052e4cbd2f$export$2e2bcd8739ae039), {
                        prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $bd49e6611c97a88c$export$2e2bcd8739ae039), {}),
                        style: {
                            flex: 1
                        },
                        value: lat ?? null,
                        placeholder: labels.lat,
                        "aria-label": labels.lat,
                        disabled: true
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $ee8161052e4cbd2f$export$2e2bcd8739ae039), {
                        prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $bd49e6611c97a88c$export$2e2bcd8739ae039), {}),
                        style: {
                            flex: 1
                        },
                        value: lng ?? null,
                        placeholder: labels.lng,
                        "aria-label": labels.lng,
                        disabled: true
                    })
                ]
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                type: "secondary",
                className: "pt-loc-hint",
                children: t("coords_readonly")
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $6967b95453f7bc7e$export$2e2bcd8739ae039), {
                lat: value && value.latitude,
                lng: value && value.longitude,
                zoom: value ? 15 : 6,
                editable: true,
                onChange: ({ lat: newLat, lng: newLng })=>{
                    onChange(field.name, {
                        latitude: newLat,
                        longitude: newLng
                    });
                    reverseGeocode(newLat, newLng);
                },
                height: 300
            })
        ]
    });
}




var $cQmXV = parcelRequire("cQmXV");


var $cQmXV = parcelRequire("cQmXV");
var $97b18b0585988b45$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($97b18b0585988b45$exports, "__esModule", {
    value: true
});
var $97b18b0585988b45$var$ExpandOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M342 88H120c-17.7 0-32 14.3-32 32v224c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V168h174c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16zm578 576h-48c-8.8 0-16 7.2-16 16v176H682c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h222c17.7 0 32-14.3 32-32V680c0-8.8-7.2-16-16-16zM342 856H168V680c0-8.8-7.2-16-16-16h-48c-8.8 0-16 7.2-16 16v224c0 17.7 14.3 32 32 32h222c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16zM904 88H682c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h174v176c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V120c0-17.7-14.3-32-32-32z"
                }
            }
        ]
    },
    "name": "expand",
    "theme": "outlined"
};
$97b18b0585988b45$exports.default = $97b18b0585988b45$var$ExpandOutlined;



function $1231e9abf7ce61ea$var$_extends() {
    $1231e9abf7ce61ea$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1231e9abf7ce61ea$var$_extends.apply(this, arguments);
}
const $1231e9abf7ce61ea$var$ExpandOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $1231e9abf7ce61ea$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($97b18b0585988b45$exports)))
    }));
/**![expand](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTM0MiA4OEgxMjBjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjIyNGMwIDguOCA3LjIgMTYgMTYgMTZoNDhjOC44IDAgMTYtNy4yIDE2LTE2VjE2OGgxNzRjOC44IDAgMTYtNy4yIDE2LTE2di00OGMwLTguOC03LjItMTYtMTYtMTZ6bTU3OCA1NzZoLTQ4Yy04LjggMC0xNiA3LjItMTYgMTZ2MTc2SDY4MmMtOC44IDAtMTYgNy4yLTE2IDE2djQ4YzAgOC44IDcuMiAxNiAxNiAxNmgyMjJjMTcuNyAwIDMyLTE0LjMgMzItMzJWNjgwYzAtOC44LTcuMi0xNi0xNi0xNnpNMzQyIDg1NkgxNjhWNjgwYzAtOC44LTcuMi0xNi0xNi0xNmgtNDhjLTguOCAwLTE2IDcuMi0xNiAxNnYyMjRjMCAxNy43IDE0LjMgMzIgMzIgMzJoMjIyYzguOCAwIDE2LTcuMiAxNi0xNnYtNDhjMC04LjgtNy4yLTE2LTE2LTE2ek05MDQgODhINjgyYy04LjggMC0xNiA3LjItMTYgMTZ2NDhjMCA4LjggNy4yIDE2IDE2IDE2aDE3NHYxNzZjMCA4LjggNy4yIDE2IDE2IDE2aDQ4YzguOCAwIDE2LTcuMiAxNi0xNlYxMjBjMC0xNy43LTE0LjMtMzItMzItMzJ6IiAvPjwvc3ZnPg==) */ const $1231e9abf7ce61ea$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($1231e9abf7ce61ea$var$ExpandOutlined);
var $1231e9abf7ce61ea$export$2e2bcd8739ae039 = $1231e9abf7ce61ea$var$RefIcon;


/* ImageCropper — the square crop step every uploaded image goes through.
 *
 * It is an antd `<Modal>` now, not a hand-rolled scrim: the modal chrome, the focus trap, Esc, and
 * the button pair come from the kit (spec/02), and the shared modal rules apply — no boxed chrome
 * inside the body, the actions in the footer.
 *
 * **The selection is always a square, and that is a decision, not a limitation.** The result is
 * rendered into square avatars (the record's identity strip) and a 40px table thumbnail, so a
 * free-ratio crop would only be cropped again — badly — by everything that displays it.
 *
 * What it can do beyond dragging, because a mouse-only editor is an unusable one (spec/03's
 * accessibility floor):
 * - **Zoom** — a slider over the selection's side length, plus `+` / `-`. Zooming in shrinks the
 *   square around its own centre, which is what "closer" means when the image is fixed.
 * - **Arrow keys** nudge the selection by 1px, or 10px with Shift; Home re-centres it.
 * - **A live 1:1 preview**, drawn with `background-position` rather than a second canvas — the
 *   point of cropping is seeing the framing you are choosing.
 *
 * The geometry (display ↔ natural scaling, corner anchoring, bounds clamping) is unchanged from the
 * version that worked; only the chrome and the input methods are new.
 */ 

var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");






var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");

var $3h5eW = parcelRequire("3h5eW");
function $b19824e7d6c755ca$export$622cea445a1c5b7d(value, min, max) {
    return (value - min) / (max - min);
}
function $b19824e7d6c755ca$export$a41628415415e6e(direction, value, min, max) {
    const offset = $b19824e7d6c755ca$export$622cea445a1c5b7d(value, min, max);
    const positionStyle = {};
    switch(direction){
        case "rtl":
            positionStyle.right = `${offset * 100}%`;
            positionStyle.transform = "translateX(50%)";
            break;
        case "btt":
            positionStyle.bottom = `${offset * 100}%`;
            positionStyle.transform = "translateY(50%)";
            break;
        case "ttb":
            positionStyle.top = `${offset * 100}%`;
            positionStyle.transform = "translateY(-50%)";
            break;
        default:
            positionStyle.left = `${offset * 100}%`;
            positionStyle.transform = "translateX(-50%)";
            break;
    }
    return positionStyle;
}
function $b19824e7d6c755ca$export$ddfa24987dade61b(value, index) {
    return Array.isArray(value) ? value[index] : value;
}





var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");
const $3d287409329d294d$var$SliderContext = /*#__PURE__*/ $cQmXV.createContext({
    min: 0,
    max: 0,
    direction: "ltr",
    step: 1,
    includedStart: 0,
    includedEnd: 0,
    tabIndex: 0,
    keyboard: true,
    styles: {},
    classNames: {},
    isHandleDisabled: ()=>false
});
var $3d287409329d294d$export$2e2bcd8739ae039 = $3d287409329d294d$var$SliderContext;
const $3d287409329d294d$export$e508d6f1a100e5dd = /*#__PURE__*/ $cQmXV.createContext({});



function $258749caffe049d0$var$_extends() {
    $258749caffe049d0$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $258749caffe049d0$var$_extends.apply(this, arguments);
}
const $258749caffe049d0$var$Handle = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { prefixCls: prefixCls, value: value, valueIndex: valueIndex, onStartMove: onStartMove, onDelete: onDelete, style: style, render: render, dragging: dragging, draggingDelete: draggingDelete, onOffsetChange: onOffsetChange, onChangeComplete: onChangeComplete, onFocus: onFocus, onMouseEnter: onMouseEnter, ...restProps } = props;
    const { min: min, max: max, direction: direction, keyboard: keyboard, range: range, tabIndex: tabIndex, ariaLabelForHandle: ariaLabelForHandle, ariaLabelledByForHandle: ariaLabelledByForHandle, ariaRequired: ariaRequired, ariaValueTextFormatterForHandle: ariaValueTextFormatterForHandle, styles: styles, classNames: classNames, isHandleDisabled: isHandleDisabled } = $cQmXV.useContext((0, $3d287409329d294d$export$2e2bcd8739ae039));
    const mergedDisabled = isHandleDisabled(valueIndex);
    const handlePrefixCls = `${prefixCls}-handle`;
    // ============================ Events ============================
    const onInternalStartMove = (e)=>{
        if (mergedDisabled) {
            e.stopPropagation();
            return;
        }
        onStartMove(e, valueIndex);
    };
    const onInternalFocus = (e)=>{
        onFocus?.(e, valueIndex);
    };
    const onInternalMouseEnter = (e)=>{
        onMouseEnter(e, valueIndex);
    };
    // =========================== Keyboard ===========================
    const onKeyDown = (e)=>{
        if (!mergedDisabled && keyboard) {
            let offset;
            // Change the value
            switch(e.which || e.keyCode){
                case (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).LEFT:
                    offset = direction === "ltr" || direction === "btt" ? -1 : 1;
                    break;
                case (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).RIGHT:
                    offset = direction === "ltr" || direction === "btt" ? 1 : -1;
                    break;
                // Up is plus
                case (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).UP:
                    offset = direction !== "ttb" ? 1 : -1;
                    break;
                // Down is minus
                case (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).DOWN:
                    offset = direction !== "ttb" ? -1 : 1;
                    break;
                case (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).HOME:
                    offset = "min";
                    break;
                case (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).END:
                    offset = "max";
                    break;
                case (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).PAGE_UP:
                    offset = 2;
                    break;
                case (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).PAGE_DOWN:
                    offset = -2;
                    break;
                case (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).BACKSPACE:
                case (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).DELETE:
                    onDelete?.(valueIndex);
                    break;
            }
            if (offset !== undefined) {
                e.preventDefault();
                onOffsetChange(offset, valueIndex);
            }
        }
    };
    const handleKeyUp = (e)=>{
        switch(e.which || e.keyCode){
            case (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).LEFT:
            case (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).RIGHT:
            case (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).UP:
            case (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).DOWN:
            case (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).HOME:
            case (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).END:
            case (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).PAGE_UP:
            case (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).PAGE_DOWN:
                onChangeComplete?.();
                break;
        }
    };
    // ============================ Offset ============================
    const positionStyle = (0, $b19824e7d6c755ca$export$a41628415415e6e)(direction, value, min, max);
    // ============================ Render ============================
    let divProps = {};
    if (valueIndex !== null) divProps = {
        tabIndex: mergedDisabled ? undefined : (0, $b19824e7d6c755ca$export$ddfa24987dade61b)(tabIndex, valueIndex) ?? undefined,
        role: "slider",
        "aria-valuemin": min,
        "aria-valuemax": max,
        "aria-valuenow": value,
        "aria-disabled": mergedDisabled,
        "aria-label": (0, $b19824e7d6c755ca$export$ddfa24987dade61b)(ariaLabelForHandle, valueIndex),
        "aria-labelledby": (0, $b19824e7d6c755ca$export$ddfa24987dade61b)(ariaLabelledByForHandle, valueIndex),
        "aria-required": (0, $b19824e7d6c755ca$export$ddfa24987dade61b)(ariaRequired, valueIndex),
        "aria-valuetext": (0, $b19824e7d6c755ca$export$ddfa24987dade61b)(ariaValueTextFormatterForHandle, valueIndex)?.(value),
        "aria-orientation": direction === "ltr" || direction === "rtl" ? "horizontal" : "vertical",
        onMouseDown: onInternalStartMove,
        onTouchStart: onInternalStartMove,
        onFocus: onInternalFocus,
        onMouseEnter: onInternalMouseEnter,
        onKeyDown: onKeyDown,
        onKeyUp: handleKeyUp
    };
    let handleNode = /*#__PURE__*/ $cQmXV.createElement("div", $258749caffe049d0$var$_extends({
        ref: ref,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(handlePrefixCls, {
            [`${handlePrefixCls}-${valueIndex + 1}`]: valueIndex !== null && range,
            [`${handlePrefixCls}-dragging`]: dragging,
            [`${handlePrefixCls}-dragging-delete`]: draggingDelete,
            [`${handlePrefixCls}-disabled`]: mergedDisabled
        }, classNames.handle),
        style: {
            ...positionStyle,
            ...style,
            ...styles.handle
        }
    }, divProps, restProps));
    // Customize
    if (render) handleNode = render(handleNode, {
        index: valueIndex,
        prefixCls: prefixCls,
        value: value,
        dragging: dragging,
        draggingDelete: draggingDelete
    });
    return handleNode;
});
var $258749caffe049d0$export$2e2bcd8739ae039 = $258749caffe049d0$var$Handle;


function $6f27592960834549$var$_extends() {
    $6f27592960834549$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6f27592960834549$var$_extends.apply(this, arguments);
}
const $6f27592960834549$var$Handles = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { prefixCls: prefixCls, style: style, onStartMove: onStartMove, onOffsetChange: onOffsetChange, values: values, handleRender: handleRender, activeHandleRender: activeHandleRender, draggingIndex: draggingIndex, draggingDelete: draggingDelete, onFocus: onFocus, ...restProps } = props;
    const handlesRef = $cQmXV.useRef({});
    // =========================== Active ===========================
    const [activeVisible, setActiveVisible] = $cQmXV.useState(false);
    const [activeIndex, setActiveIndex] = $cQmXV.useState(-1);
    const onActive = (index)=>{
        setActiveIndex(index);
        setActiveVisible(true);
    };
    const onHandleFocus = (e, index)=>{
        onActive(index);
        onFocus?.(e);
    };
    const onHandleMouseEnter = (e, index)=>{
        onActive(index);
    };
    // =========================== Render ===========================
    $cQmXV.useImperativeHandle(ref, ()=>({
            focus: (index)=>{
                handlesRef.current[index]?.focus();
            },
            hideHelp: ()=>{
                (0, $3h5eW.flushSync)(()=>{
                    setActiveVisible(false);
                });
            }
        }));
    // =========================== Render ===========================
    // Handle Props
    const handleProps = {
        prefixCls: prefixCls,
        onStartMove: onStartMove,
        onOffsetChange: onOffsetChange,
        render: handleRender,
        onFocus: onHandleFocus,
        onMouseEnter: onHandleMouseEnter,
        ...restProps
    };
    return /*#__PURE__*/ $cQmXV.createElement($cQmXV.Fragment, null, values.map((value, index)=>{
        const dragging = draggingIndex === index;
        return /*#__PURE__*/ $cQmXV.createElement((0, $258749caffe049d0$export$2e2bcd8739ae039), $6f27592960834549$var$_extends({
            ref: (node)=>{
                if (!node) delete handlesRef.current[index];
                else handlesRef.current[index] = node;
            },
            dragging: dragging,
            draggingDelete: dragging && draggingDelete,
            style: (0, $b19824e7d6c755ca$export$ddfa24987dade61b)(style, index),
            key: index,
            value: value,
            valueIndex: index
        }, handleProps));
    }), activeHandleRender && activeVisible && /*#__PURE__*/ $cQmXV.createElement((0, $258749caffe049d0$export$2e2bcd8739ae039), $6f27592960834549$var$_extends({
        key: "a11y"
    }, handleProps, {
        value: values[activeIndex],
        valueIndex: null,
        dragging: draggingIndex !== -1,
        draggingDelete: draggingDelete,
        render: activeHandleRender,
        style: {
            pointerEvents: "none"
        },
        tabIndex: undefined,
        "aria-hidden": true
    })));
});
var $6f27592960834549$export$2e2bcd8739ae039 = $6f27592960834549$var$Handles;



var $cQmXV = parcelRequire("cQmXV");


var $cQmXV = parcelRequire("cQmXV");


const $ce55ec28acb8533b$var$Mark = (props)=>{
    const { prefixCls: prefixCls, style: style, children: children, value: value, onClick: onClick } = props;
    const { min: min, max: max, direction: direction, includedStart: includedStart, includedEnd: includedEnd, included: included } = $cQmXV.useContext((0, $3d287409329d294d$export$2e2bcd8739ae039));
    const textCls = `${prefixCls}-text`;
    // ============================ Offset ============================
    const positionStyle = (0, $b19824e7d6c755ca$export$a41628415415e6e)(direction, value, min, max);
    return /*#__PURE__*/ $cQmXV.createElement("span", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(textCls, {
            [`${textCls}-active`]: included && includedStart <= value && value <= includedEnd
        }),
        style: {
            ...positionStyle,
            ...style
        },
        onMouseDown: (e)=>{
            e.stopPropagation();
        },
        onClick: ()=>{
            onClick(value);
        }
    }, children);
};
var $ce55ec28acb8533b$export$2e2bcd8739ae039 = $ce55ec28acb8533b$var$Mark;


const $768f2290e18cf27e$var$Marks = (props)=>{
    const { prefixCls: prefixCls, marks: marks = [], onClick: onClick } = props;
    const markPrefixCls = `${prefixCls}-mark`;
    // Not render mark if empty
    if (!marks.length) return null;
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        className: markPrefixCls
    }, marks.map(({ value: value, style: style, label: label })=>/*#__PURE__*/ $cQmXV.createElement((0, $ce55ec28acb8533b$export$2e2bcd8739ae039), {
            key: value,
            prefixCls: markPrefixCls,
            style: style,
            value: value,
            onClick: onClick
        }, label)));
};
var $768f2290e18cf27e$export$2e2bcd8739ae039 = $768f2290e18cf27e$var$Marks;



var $cQmXV = parcelRequire("cQmXV");



var $cQmXV = parcelRequire("cQmXV");


const $bc5725c7059552a7$var$Dot = (props)=>{
    const { prefixCls: prefixCls, value: value, style: style, activeStyle: activeStyle } = props;
    const { min: min, max: max, direction: direction, included: included, includedStart: includedStart, includedEnd: includedEnd } = $cQmXV.useContext((0, $3d287409329d294d$export$2e2bcd8739ae039));
    const dotClassName = `${prefixCls}-dot`;
    const active = included && includedStart <= value && value <= includedEnd;
    // ============================ Offset ============================
    let mergedStyle = {
        ...(0, $b19824e7d6c755ca$export$a41628415415e6e)(direction, value, min, max),
        ...typeof style === "function" ? style(value) : style
    };
    if (active) mergedStyle = {
        ...mergedStyle,
        ...typeof activeStyle === "function" ? activeStyle(value) : activeStyle
    };
    return /*#__PURE__*/ $cQmXV.createElement("span", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(dotClassName, {
            [`${dotClassName}-active`]: active
        }),
        style: mergedStyle
    });
};
var $bc5725c7059552a7$export$2e2bcd8739ae039 = $bc5725c7059552a7$var$Dot;


const $63cf52dfa73a148c$var$Steps = (props)=>{
    const { prefixCls: prefixCls, marks: marks, dots: dots, style: style, activeStyle: activeStyle } = props;
    const { min: min, max: max, step: step } = $cQmXV.useContext((0, $3d287409329d294d$export$2e2bcd8739ae039));
    const stepDots = $cQmXV.useMemo(()=>{
        const dotSet = new Set();
        // Add marks
        marks.forEach((mark)=>{
            dotSet.add(mark.value);
        });
        // Fill dots
        if (dots && step !== null) {
            let current = min;
            while(current <= max){
                dotSet.add(current);
                current += step;
            }
        }
        return Array.from(dotSet);
    }, [
        min,
        max,
        step,
        dots,
        marks
    ]);
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        className: `${prefixCls}-step`
    }, stepDots.map((dotValue)=>/*#__PURE__*/ $cQmXV.createElement((0, $bc5725c7059552a7$export$2e2bcd8739ae039), {
            prefixCls: prefixCls,
            key: dotValue,
            value: dotValue,
            style: style,
            activeStyle: activeStyle
        })));
};
var $63cf52dfa73a148c$export$2e2bcd8739ae039 = $63cf52dfa73a148c$var$Steps;




var $cQmXV = parcelRequire("cQmXV");




var $cQmXV = parcelRequire("cQmXV");


const $9eebc7bdc4a0a4fe$var$Track = (props)=>{
    const { prefixCls: prefixCls, style: style, start: start, end: end, index: index, onStartMove: onStartMove, replaceCls: replaceCls } = props;
    const { direction: direction, min: min, max: max, disabled: disabled, range: range, classNames: classNames } = $cQmXV.useContext((0, $3d287409329d294d$export$2e2bcd8739ae039));
    const trackPrefixCls = `${prefixCls}-track`;
    const offsetStart = (0, $b19824e7d6c755ca$export$622cea445a1c5b7d)(start, min, max);
    const offsetEnd = (0, $b19824e7d6c755ca$export$622cea445a1c5b7d)(end, min, max);
    // ============================ Events ============================
    const onInternalStartMove = (e)=>{
        if (!disabled && onStartMove) onStartMove(e, -1);
    };
    // ============================ Render ============================
    const positionStyle = {};
    switch(direction){
        case "rtl":
            positionStyle.right = `${offsetStart * 100}%`;
            positionStyle.width = `${offsetEnd * 100 - offsetStart * 100}%`;
            break;
        case "btt":
            positionStyle.bottom = `${offsetStart * 100}%`;
            positionStyle.height = `${offsetEnd * 100 - offsetStart * 100}%`;
            break;
        case "ttb":
            positionStyle.top = `${offsetStart * 100}%`;
            positionStyle.height = `${offsetEnd * 100 - offsetStart * 100}%`;
            break;
        default:
            positionStyle.left = `${offsetStart * 100}%`;
            positionStyle.width = `${offsetEnd * 100 - offsetStart * 100}%`;
    }
    const className = replaceCls || (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(trackPrefixCls, {
        [`${trackPrefixCls}-${index + 1}`]: index !== null && range,
        [`${prefixCls}-track-draggable`]: onStartMove
    }, classNames.track);
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        className: className,
        style: {
            ...positionStyle,
            ...style
        },
        onMouseDown: onInternalStartMove,
        onTouchStart: onInternalStartMove
    });
};
var $9eebc7bdc4a0a4fe$export$2e2bcd8739ae039 = $9eebc7bdc4a0a4fe$var$Track;


const $0cf7e74f1a97ef0c$var$Tracks = (props)=>{
    const { prefixCls: prefixCls, style: style, values: values, startPoint: startPoint, onStartMove: propsOnStartMove } = props;
    const { included: included, range: range, min: min, styles: styles, classNames: classNames, isHandleDisabled: isHandleDisabled } = $cQmXV.useContext((0, $3d287409329d294d$export$2e2bcd8739ae039));
    const hasDisabledHandle = $cQmXV.useMemo(()=>values.some((_, index)=>isHandleDisabled(index)), [
        isHandleDisabled,
        values
    ]);
    const onStartMove = hasDisabledHandle ? undefined : propsOnStartMove;
    // =========================== List ===========================
    const trackList = $cQmXV.useMemo(()=>{
        if (!range) {
            // null value do not have track
            if (values.length === 0) return [];
            const startValue = startPoint ?? min;
            const endValue = values[0];
            return [
                {
                    start: Math.min(startValue, endValue),
                    end: Math.max(startValue, endValue)
                }
            ];
        }
        // Multiple
        const list = [];
        for(let i = 0; i < values.length - 1; i += 1)list.push({
            start: values[i],
            end: values[i + 1]
        });
        return list;
    }, [
        values,
        range,
        startPoint,
        min
    ]);
    if (!included) return null;
    // ========================== Render ==========================
    const tracksNode = trackList?.length && (classNames.tracks || styles.tracks) ? /*#__PURE__*/ $cQmXV.createElement((0, $9eebc7bdc4a0a4fe$export$2e2bcd8739ae039), {
        index: null,
        prefixCls: prefixCls,
        start: trackList[0].start,
        end: trackList[trackList.length - 1].end,
        replaceCls: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(classNames.tracks, `${prefixCls}-tracks`),
        style: styles.tracks
    }) : null;
    return /*#__PURE__*/ $cQmXV.createElement($cQmXV.Fragment, null, tracksNode, trackList.map(({ start: start, end: end }, index)=>/*#__PURE__*/ $cQmXV.createElement((0, $9eebc7bdc4a0a4fe$export$2e2bcd8739ae039), {
            index: index,
            prefixCls: prefixCls,
            style: {
                ...(0, $b19824e7d6c755ca$export$ddfa24987dade61b)(style, index),
                ...styles.track
            },
            start: start,
            end: end,
            key: index,
            onStartMove: onStartMove
        })));
};
var $0cf7e74f1a97ef0c$export$2e2bcd8739ae039 = $0cf7e74f1a97ef0c$var$Tracks;




var $cQmXV = parcelRequire("cQmXV");
const $b9a64569ec989554$var$useDisabled = (rawDisabled)=>{
    const isHandleDisabled = $cQmXV.useCallback((index)=>{
        if (typeof rawDisabled === "boolean") return rawDisabled;
        return rawDisabled[index] ?? false;
    }, [
        rawDisabled
    ]);
    const getDisabledState = $cQmXV.useCallback((rawValues)=>{
        if (typeof rawDisabled === "boolean") return [
            rawDisabled,
            rawDisabled && rawValues.length > 0
        ];
        return [
            rawValues.length > 0 && rawValues.every((_, index)=>isHandleDisabled(index)),
            rawValues.some((_, index)=>isHandleDisabled(index))
        ];
    }, [
        rawDisabled,
        isHandleDisabled
    ]);
    return $cQmXV.useMemo(()=>[
            isHandleDisabled,
            getDisabledState
        ], [
        isHandleDisabled,
        getDisabledState
    ]);
};
var $b9a64569ec989554$export$2e2bcd8739ae039 = $b9a64569ec989554$var$useDisabled;



var $cQmXV = parcelRequire("cQmXV");



/** Drag to delete offset. It's a user experience number for dragging out */ const $939f23e0fb36c5ca$var$REMOVE_DIST = 130;
function $939f23e0fb36c5ca$var$getPosition(e) {
    const obj = "targetTouches" in e ? e.targetTouches[0] : e;
    return {
        pageX: obj.pageX,
        pageY: obj.pageY
    };
}
function $939f23e0fb36c5ca$var$useDrag(containerRef, direction, rawValues, min, max, formatValue, triggerChange, finishChange, offsetValues, editable, minCount, isHandleDisabled) {
    const [draggingValue, setDraggingValue] = $cQmXV.useState(null);
    const [draggingIndex, setDraggingIndex] = $cQmXV.useState(-1);
    const [draggingDelete, setDraggingDelete] = $cQmXV.useState(false);
    const [cacheValues, setCacheValues] = $cQmXV.useState(rawValues);
    const [originValues, setOriginValues] = $cQmXV.useState(rawValues);
    const mouseMoveEventRef = $cQmXV.useRef(null);
    const mouseUpEventRef = $cQmXV.useRef(null);
    const touchEventTargetRef = $cQmXV.useRef(null);
    const { onDragStart: onDragStart, onDragChange: onDragChange } = $cQmXV.useContext((0, $3d287409329d294d$export$e508d6f1a100e5dd));
    (0, $7673d874dab69d07$export$2e2bcd8739ae039)(()=>{
        if (draggingIndex === -1) setCacheValues(rawValues);
    }, [
        rawValues,
        draggingIndex
    ]);
    // Clean up event
    $cQmXV.useEffect(()=>()=>{
            if (mouseMoveEventRef.current) document.removeEventListener("mousemove", mouseMoveEventRef.current);
            if (mouseUpEventRef.current) document.removeEventListener("mouseup", mouseUpEventRef.current);
            if (touchEventTargetRef.current) {
                if (mouseMoveEventRef.current) touchEventTargetRef.current.removeEventListener("touchmove", mouseMoveEventRef.current);
                if (mouseUpEventRef.current) touchEventTargetRef.current.removeEventListener("touchend", mouseUpEventRef.current);
            }
        }, []);
    const flushValues = (nextValues, nextValue, deleteMark)=>{
        // Perf: Only update state when value changed
        if (nextValue !== undefined) setDraggingValue(nextValue);
        setCacheValues(nextValues);
        let changeValues = nextValues;
        if (deleteMark) changeValues = nextValues.filter((_, i)=>i !== draggingIndex);
        triggerChange(changeValues);
        // Optional callback for drag change (not used in current implementation)
        if (onDragChange) onDragChange({
            rawValues: nextValues,
            deleteIndex: deleteMark ? draggingIndex : -1,
            draggingIndex: draggingIndex,
            draggingValue: nextValue
        });
    };
    const updateCacheValue = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((valueIndex, offsetPercent, deleteMark)=>{
        if (valueIndex === -1) {
            // >>>> Dragging on the track
            // Defensive: should not happen as Tracks/index.tsx blocks this when any handle is disabled
            if (originValues.some((_, index)=>isHandleDisabled(index))) return;
            const startValue = originValues[0];
            const endValue = originValues[originValues.length - 1];
            const maxStartOffset = min - startValue;
            const maxEndOffset = max - endValue;
            // Get valid offset
            let offset = offsetPercent * (max - min);
            offset = Math.max(offset, maxStartOffset);
            offset = Math.min(offset, maxEndOffset);
            // Use first value to revert back of valid offset (like steps marks)
            const formatStartValue = formatValue(startValue + offset);
            offset = formatStartValue - startValue;
            const cloneCacheValues = originValues.map((val)=>val + offset);
            flushValues(cloneCacheValues);
        } else {
            // >>>> Dragging on the handle
            const offsetDist = (max - min) * offsetPercent;
            // Always start with the valueIndex origin value
            const cloneValues = [
                ...cacheValues
            ];
            cloneValues[valueIndex] = originValues[valueIndex];
            const next = offsetValues(cloneValues, offsetDist, valueIndex, "dist");
            flushValues(next.values, next.value, deleteMark);
        }
    });
    const onStartMove = (e, valueIndex, startValues)=>{
        e.stopPropagation();
        const initialValues = startValues || rawValues;
        // Defensive: should not happen as Handle.tsx blocks this when handle is disabled
        if (isHandleDisabled(valueIndex)) return;
        const originValue = initialValues[valueIndex];
        setDraggingIndex(valueIndex);
        setDraggingValue(originValue);
        setOriginValues(initialValues);
        setCacheValues(initialValues);
        setDraggingDelete(false);
        const { pageX: startX, pageY: startY } = $939f23e0fb36c5ca$var$getPosition(e);
        // We declare it here since closure can't get outer latest value
        let deleteMark = false;
        // Optional callback for drag start (not used in current implementation)
        if (onDragStart) onDragStart({
            rawValues: initialValues,
            draggingIndex: valueIndex,
            draggingValue: originValue
        });
        // Moving
        const onMouseMove = (event)=>{
            event.preventDefault();
            const { pageX: moveX, pageY: moveY } = $939f23e0fb36c5ca$var$getPosition(event);
            const offsetX = moveX - startX;
            const offsetY = moveY - startY;
            const { width: width, height: height } = containerRef.current.getBoundingClientRect();
            let offSetPercent;
            let removeDist;
            switch(direction){
                case "btt":
                    offSetPercent = -offsetY / height;
                    removeDist = offsetX;
                    break;
                case "ttb":
                    offSetPercent = offsetY / height;
                    removeDist = offsetX;
                    break;
                case "rtl":
                    offSetPercent = -offsetX / width;
                    removeDist = offsetY;
                    break;
                default:
                    offSetPercent = offsetX / width;
                    removeDist = offsetY;
            }
            // Check if need mark remove
            deleteMark = editable ? Math.abs(removeDist) > $939f23e0fb36c5ca$var$REMOVE_DIST && minCount < cacheValues.length : false;
            setDraggingDelete(deleteMark);
            updateCacheValue(valueIndex, offSetPercent, deleteMark);
        };
        // End
        const onMouseUp = (event)=>{
            event.preventDefault();
            document.removeEventListener("mouseup", onMouseUp);
            document.removeEventListener("mousemove", onMouseMove);
            if (touchEventTargetRef.current) {
                if (mouseMoveEventRef.current) touchEventTargetRef.current.removeEventListener("touchmove", mouseMoveEventRef.current);
                if (mouseUpEventRef.current) touchEventTargetRef.current.removeEventListener("touchend", mouseUpEventRef.current);
            }
            mouseMoveEventRef.current = null;
            mouseUpEventRef.current = null;
            touchEventTargetRef.current = null;
            finishChange(deleteMark);
            setDraggingIndex(-1);
            setDraggingDelete(false);
        };
        document.addEventListener("mouseup", onMouseUp);
        document.addEventListener("mousemove", onMouseMove);
        e.currentTarget.addEventListener("touchend", onMouseUp);
        e.currentTarget.addEventListener("touchmove", onMouseMove);
        mouseMoveEventRef.current = onMouseMove;
        mouseUpEventRef.current = onMouseUp;
        touchEventTargetRef.current = e.currentTarget;
    };
    // Only return cache value when it mapping with rawValues
    const returnValues = $cQmXV.useMemo(()=>{
        const sourceValues = [
            ...rawValues
        ].sort((a, b)=>a - b);
        const targetValues = [
            ...cacheValues
        ].sort((a, b)=>a - b);
        const counts = {};
        targetValues.forEach((val)=>{
            counts[val] = (counts[val] || 0) + 1;
        });
        sourceValues.forEach((val)=>{
            counts[val] = (counts[val] || 0) - 1;
        });
        const maxDiffCount = editable ? 1 : 0;
        const diffCount = Object.values(counts).reduce((prev, next)=>prev + Math.abs(next), 0);
        return diffCount <= maxDiffCount ? cacheValues : rawValues;
    }, [
        rawValues,
        cacheValues,
        editable
    ]);
    return [
        draggingIndex,
        draggingValue,
        draggingDelete,
        returnValues,
        onStartMove
    ];
}
var $939f23e0fb36c5ca$export$2e2bcd8739ae039 = $939f23e0fb36c5ca$var$useDrag;



var $cQmXV = parcelRequire("cQmXV");
const $c2d39b6355be66e3$export$205603655568a9fa = (values, valueIndex, min, max, pushable, isHandleDisabled)=>{
    const pushGap = typeof pushable === "number" ? pushable : 0;
    let minBound = min;
    let maxBound = max;
    for(let i = valueIndex - 1; i >= 0; i -= 1)if (isHandleDisabled(i)) {
        minBound = values[i] + pushGap;
        break;
    }
    for(let i = valueIndex + 1; i < values.length; i += 1)if (isHandleDisabled(i)) {
        maxBound = values[i] - pushGap;
        break;
    }
    return [
        minBound,
        maxBound
    ];
};
const $c2d39b6355be66e3$export$83e80e8c13bf4564 = (values, targetValue, min, max, pushable, isHandleDisabled)=>{
    let closestIndex = -1;
    let closestDist = max - min;
    values.forEach((value, index)=>{
        if (isHandleDisabled(index)) return;
        const [minBound, maxBound] = $c2d39b6355be66e3$export$205603655568a9fa(values, index, min, max, pushable, isHandleDisabled);
        if (minBound <= targetValue && targetValue <= maxBound) {
            const dist = Math.abs(targetValue - value);
            if (dist <= closestDist) {
                closestDist = dist;
                closestIndex = index;
            }
        }
    });
    return closestIndex;
};
function $c2d39b6355be66e3$export$2e2bcd8739ae039(min, max, step, markList, allowCross, pushable, isHandleDisabled) {
    const formatRangeValue = $cQmXV.useCallback((val)=>Math.max(min, Math.min(max, val)), [
        min,
        max
    ]);
    const formatStepValue = $cQmXV.useCallback((val)=>{
        if (step !== null) {
            const stepValue = min + Math.round((formatRangeValue(val) - min) / step) * step;
            // Cut number in case to be like 0.30000000000000004
            const getDecimal = (num)=>(String(num).split(".")[1] || "").length;
            const maxDecimal = Math.max(getDecimal(step), getDecimal(max), getDecimal(min));
            const fixedValue = Number(stepValue.toFixed(maxDecimal));
            return min <= fixedValue && fixedValue <= max ? fixedValue : null;
        }
        return null;
    }, [
        step,
        min,
        max,
        formatRangeValue
    ]);
    const formatValue = $cQmXV.useCallback((val)=>{
        const formatNextValue = formatRangeValue(val);
        // List align values
        const alignValues = markList.map((mark)=>mark.value);
        if (step !== null) alignValues.push(formatStepValue(val));
        // min & max
        alignValues.push(min, max);
        // Align with marks
        let closeValue = alignValues[0];
        let closeDist = max - min;
        alignValues.forEach((alignValue)=>{
            const dist = Math.abs(formatNextValue - alignValue);
            if (dist <= closeDist) {
                closeValue = alignValue;
                closeDist = dist;
            }
        });
        return closeValue;
    }, [
        min,
        max,
        markList,
        step,
        formatRangeValue,
        formatStepValue
    ]);
    // ========================== Offset ==========================
    // Single Value
    const offsetValue = (values, offset, valueIndex, mode = "unit")=>{
        if (typeof offset === "number") {
            let nextValue;
            const originValue = values[valueIndex];
            // Only used for `dist` mode
            const targetDistValue = originValue + offset;
            // Compare next step value & mark value which is best match
            let potentialValues = [];
            markList.forEach((mark)=>{
                potentialValues.push(mark.value);
            });
            // Min & Max
            potentialValues.push(min, max);
            // In case origin value is align with mark but not with step
            potentialValues.push(formatStepValue(originValue));
            // Put offset step value also
            const sign = offset > 0 ? 1 : -1;
            if (mode === "unit") potentialValues.push(formatStepValue(originValue + sign * step));
            else potentialValues.push(formatStepValue(targetDistValue));
            // Find close one
            potentialValues = potentialValues.filter((val)=>val !== null)// Remove reverse value
            .filter((val)=>offset < 0 ? val <= originValue : val >= originValue);
            if (mode === "unit") // `unit` mode can not contain itself
            potentialValues = potentialValues.filter((val)=>val !== originValue);
            const compareValue = mode === "unit" ? originValue : targetDistValue;
            nextValue = potentialValues[0];
            let valueDist = Math.abs(nextValue - compareValue);
            potentialValues.forEach((potentialValue)=>{
                const dist = Math.abs(potentialValue - compareValue);
                if (dist < valueDist) {
                    nextValue = potentialValue;
                    valueDist = dist;
                }
            });
            // Out of range will back to range
            if (nextValue === undefined) return offset < 0 ? min : max;
            // `dist` mode
            if (mode === "dist") return nextValue;
            // `unit` mode may need another round
            if (Math.abs(offset) > 1) {
                const cloneValues = [
                    ...values
                ];
                cloneValues[valueIndex] = nextValue;
                return offsetValue(cloneValues, offset - sign, valueIndex, mode);
            }
            return nextValue;
        } else if (offset === "min") return min;
        else if (offset === "max") return max;
        // Unreachable since `offset` is typed as number | 'min' | 'max'.
        return max;
    };
    /** Same as `offsetValue` but return `changed` mark to tell value changed */ const offsetChangedValue = (values, offset, valueIndex, mode = "unit")=>{
        const originValue = values[valueIndex];
        const nextValue = offsetValue(values, offset, valueIndex, mode);
        return {
            value: nextValue,
            changed: nextValue !== originValue
        };
    };
    const needPush = (dist)=>{
        return pushable === null && dist === 0 || typeof pushable === "number" && dist < pushable;
    };
    // Values
    const offsetValues = (values, offset, valueIndex, mode = "unit")=>{
        const nextValues = values.map(formatValue);
        const originValue = nextValues[valueIndex];
        const [minBound, maxBound] = $c2d39b6355be66e3$export$205603655568a9fa(nextValues, valueIndex, min, max, pushable, isHandleDisabled);
        const nextValue = offsetValue(nextValues, offset, valueIndex, mode);
        nextValues[valueIndex] = nextValue;
        if (minBound <= maxBound) nextValues[valueIndex] = Math.max(minBound, Math.min(maxBound, nextValues[valueIndex]));
        else nextValues[valueIndex] = originValue;
        if (allowCross === false) {
            // >>>>> Allow Cross
            const pushNum = pushable || 0;
            // ============ AllowCross ===============
            if (valueIndex > 0 && nextValues[valueIndex - 1] !== originValue) nextValues[valueIndex] = Math.max(nextValues[valueIndex], nextValues[valueIndex - 1] + pushNum);
            if (valueIndex < nextValues.length - 1 && nextValues[valueIndex + 1] !== originValue) nextValues[valueIndex] = Math.min(nextValues[valueIndex], nextValues[valueIndex + 1] - pushNum);
        } else if (typeof pushable === "number" || pushable === null) {
            // >>>>> Pushable
            // =============== Push ==================
            // >>>>>> Basic push
            // End values
            for(let i = valueIndex + 1; i < nextValues.length; i += 1){
                if (isHandleDisabled(i)) break;
                let changed = true;
                while(needPush(nextValues[i] - nextValues[i - 1]) && changed)({ value: nextValues[i], changed: changed } = offsetChangedValue(nextValues, 1, i));
                const [, itemMaxBound] = $c2d39b6355be66e3$export$205603655568a9fa(nextValues, i, min, max, pushable, isHandleDisabled);
                nextValues[i] = Math.min(nextValues[i], itemMaxBound);
            }
            // Start values
            for(let i = valueIndex; i > 0; i -= 1){
                if (isHandleDisabled(i - 1)) break;
                let changed = true;
                while(needPush(nextValues[i] - nextValues[i - 1]) && changed)({ value: nextValues[i - 1], changed: changed } = offsetChangedValue(nextValues, -1, i - 1));
                const [itemMinBound] = $c2d39b6355be66e3$export$205603655568a9fa(nextValues, i - 1, min, max, pushable, isHandleDisabled);
                nextValues[i - 1] = Math.max(nextValues[i - 1], itemMinBound);
            }
            // >>>>> Revert back to safe push range
            // End to Start
            for(let i = nextValues.length - 1; i > 0; i -= 1){
                if (isHandleDisabled(i) || isHandleDisabled(i - 1)) continue;
                let changed = true;
                while(needPush(nextValues[i] - nextValues[i - 1]) && changed)({ value: nextValues[i - 1], changed: changed } = offsetChangedValue(nextValues, -1, i - 1));
                const [itemMinBound] = $c2d39b6355be66e3$export$205603655568a9fa(nextValues, i - 1, min, max, pushable, isHandleDisabled);
                nextValues[i - 1] = Math.max(nextValues[i - 1], itemMinBound);
            }
            // Start to End
            for(let i = 0; i < nextValues.length - 1; i += 1){
                if (isHandleDisabled(i) || isHandleDisabled(i + 1)) continue;
                let changed = true;
                while(needPush(nextValues[i + 1] - nextValues[i]) && changed)({ value: nextValues[i + 1], changed: changed } = offsetChangedValue(nextValues, 1, i + 1));
                const [, itemMaxBound] = $c2d39b6355be66e3$export$205603655568a9fa(nextValues, i + 1, min, max, pushable, isHandleDisabled);
                nextValues[i + 1] = Math.min(nextValues[i + 1], itemMaxBound);
            }
        }
        return {
            value: nextValues[valueIndex],
            values: nextValues
        };
    };
    return [
        formatValue,
        offsetValues
    ];
}




var $cQmXV = parcelRequire("cQmXV");
function $b52ff04b334c9304$export$2e2bcd8739ae039(range) {
    return (0, $cQmXV.useMemo)(()=>{
        if (range === true || !range) return [
            !!range,
            false,
            false,
            0
        ];
        const { editable: editable, draggableTrack: draggableTrack, minCount: minCount, maxCount: maxCount } = range;
        return [
            true,
            !!editable,
            !editable && !!draggableTrack,
            minCount || 0,
            maxCount
        ];
    }, [
        range
    ]);
}


/**
 * New:
 * - click mark to update range value
 * - handleRender
 * - Fix handle with count not correct
 * - Fix pushable not work in some case
 * - No more FindDOMNode
 * - Move all position related style into inline style
 * - Key: up is plus, down is minus
 * - fix Key with step = null not align with marks
 * - Change range should not trigger onChange
 * - keyboard support pushable
 */ const $de32c727b6605f68$var$Slider = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { prefixCls: prefixCls = "rc-slider", className: className, style: style, classNames: classNames, styles: styles, id: id, disabled: rawDisabled = false, keyboard: keyboard = true, autoFocus: autoFocus, onFocus: onFocus, onBlur: onBlur, min: // Value
    min = 0, max: max = 100, step: step = 1, value: value, defaultValue: defaultValue, range: range, count: count, onChange: onChange, onBeforeChange: onBeforeChange, onAfterChange: onAfterChange, onChangeComplete: onChangeComplete, allowCross: // Cross
    allowCross = true, pushable: pushable = false, reverse: // Direction
    reverse, vertical: vertical, included: // Style
    included = true, startPoint: startPoint, trackStyle: trackStyle, handleStyle: handleStyle, railStyle: railStyle, dotStyle: dotStyle, activeDotStyle: activeDotStyle, marks: // Decorations
    marks, dots: dots, handleRender: // Components
    handleRender, activeHandleRender: activeHandleRender, track: track, tabIndex: // Accessibility
    tabIndex = 0, ariaLabelForHandle: ariaLabelForHandle, ariaLabelledByForHandle: ariaLabelledByForHandle, ariaRequired: ariaRequired, ariaValueTextFormatterForHandle: ariaValueTextFormatterForHandle } = props;
    const handlesRef = $cQmXV.useRef(null);
    const containerRef = $cQmXV.useRef(null);
    const [mergedValue, setValue] = (0, $a51866d781137e08$export$2e2bcd8739ae039)(defaultValue, value);
    const direction = $cQmXV.useMemo(()=>{
        if (vertical) return reverse ? "ttb" : "btt";
        return reverse ? "rtl" : "ltr";
    }, [
        reverse,
        vertical
    ]);
    // ============================ Range =============================
    const [rangeEnabled, rangeEditable, rangeDraggableTrack, minCount, maxCount] = (0, $b52ff04b334c9304$export$2e2bcd8739ae039)(range);
    const mergedMin = $cQmXV.useMemo(()=>isFinite(min) ? min : 0, [
        min
    ]);
    const mergedMax = $cQmXV.useMemo(()=>isFinite(max) ? max : 100, [
        max
    ]);
    // ============================= Step =============================
    const mergedStep = $cQmXV.useMemo(()=>step !== null && step <= 0 ? 1 : step, [
        step
    ]);
    // ============================= Push =============================
    const mergedPush = $cQmXV.useMemo(()=>{
        if (typeof pushable === "boolean") return pushable ? mergedStep : false;
        return pushable >= 0 ? pushable : false;
    }, [
        pushable,
        mergedStep
    ]);
    // ============================ Marks =============================
    const markList = $cQmXV.useMemo(()=>{
        const markRecord = marks || {};
        return Object.keys(markRecord).map((key)=>{
            const mark = markRecord[key];
            const markObj = {
                value: Number(key)
            };
            if (mark && typeof mark === "object" && !/*#__PURE__*/ $cQmXV.isValidElement(mark) && ("label" in mark || "style" in mark)) {
                markObj.style = mark.style;
                markObj.label = mark.label;
            } else markObj.label = mark;
            return markObj;
        }).filter(({ label: label })=>label || typeof label === "number").sort((a, b)=>a.value - b.value);
    }, [
        marks
    ]);
    // ============================ Disabled ============================
    const [isHandleDisabled, getDisabledState] = (0, $b9a64569ec989554$export$2e2bcd8739ae039)(rawDisabled);
    // ============================ Format ============================
    const [formatValue, offsetValues] = (0, $c2d39b6355be66e3$export$2e2bcd8739ae039)(mergedMin, mergedMax, mergedStep, markList, allowCross, mergedPush, isHandleDisabled);
    // ============================ Values ============================
    const rawValues = $cQmXV.useMemo(()=>{
        const valueList = mergedValue === null || mergedValue === undefined ? [] : Array.isArray(mergedValue) ? mergedValue : [
            mergedValue
        ];
        const [val0 = mergedMin] = valueList;
        let returnValues = mergedValue === null ? [] : [
            val0
        ];
        // Format as range
        if (rangeEnabled) {
            returnValues = [
                ...valueList
            ];
            // When count provided or value is `undefined`, we fill values
            if (count || mergedValue === undefined) {
                const pointCount = count !== undefined && count >= 0 ? count + 1 : 2;
                returnValues = returnValues.slice(0, pointCount);
                // Fill with count
                while(returnValues.length < pointCount)returnValues.push(returnValues[returnValues.length - 1] ?? mergedMin);
            }
            returnValues.sort((a, b)=>a - b);
        }
        // Align in range
        returnValues.forEach((val, index)=>{
            returnValues[index] = formatValue(val);
        });
        return returnValues;
    }, [
        mergedValue,
        rangeEnabled,
        mergedMin,
        count,
        formatValue
    ]);
    const [disabled, hasDisabledHandle] = $cQmXV.useMemo(()=>getDisabledState(rawValues), [
        getDisabledState,
        rawValues
    ]);
    const effectiveRangeEditable = rangeEditable && !hasDisabledHandle;
    // =========================== onChange ===========================
    const getTriggerValue = (triggerValues)=>rangeEnabled ? triggerValues : triggerValues[0];
    const triggerChange = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((nextValues)=>{
        // Order first
        const cloneNextValues = [
            ...nextValues
        ].sort((a, b)=>a - b);
        // Trigger event if needed
        if (onChange && !(0, $3f19ee2a2ff4618a$export$2e2bcd8739ae039)(cloneNextValues, rawValues, true)) onChange(getTriggerValue(cloneNextValues));
        // We set this later since it will re-render component immediately
        setValue(cloneNextValues);
    });
    const finishChange = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((draggingDelete)=>{
        // Trigger from `useDrag` will tell if it's a delete action
        if (draggingDelete) handlesRef.current.hideHelp();
        const finishValue = getTriggerValue(rawValues);
        onAfterChange?.(finishValue);
        (0, $26d7cf6379fe7659$export$2e2bcd8739ae039)(!onAfterChange, "[rc-slider] `onAfterChange` is deprecated. Please use `onChangeComplete` instead.");
        onChangeComplete?.(finishValue);
    });
    const onDelete = (index)=>{
        if (disabled || !effectiveRangeEditable || rawValues.length <= minCount) return;
        const cloneNextValues = [
            ...rawValues
        ];
        cloneNextValues.splice(index, 1);
        onBeforeChange?.(getTriggerValue(cloneNextValues));
        triggerChange(cloneNextValues);
        const nextFocusIndex = Math.max(0, index - 1);
        handlesRef.current.hideHelp();
        handlesRef.current.focus(nextFocusIndex);
    };
    const [draggingIndex, draggingValue, draggingDelete, cacheValues, onStartDrag] = (0, $939f23e0fb36c5ca$export$2e2bcd8739ae039)(containerRef, direction, rawValues, mergedMin, mergedMax, formatValue, triggerChange, finishChange, offsetValues, effectiveRangeEditable, minCount, isHandleDisabled);
    /**
   * When `rangeEditable` will insert a new value in the values array.
   * Else it will replace the value in the values array.
   */ const changeToCloseValue = (newValue, e)=>{
        if (!disabled) {
            const valueIndex = rawValues.length ? (0, $c2d39b6355be66e3$export$83e80e8c13bf4564)(rawValues, newValue, mergedMin, mergedMax, mergedPush, isHandleDisabled) : 0;
            if (valueIndex === -1) return;
            // Create new values
            const cloneNextValues = [
                ...rawValues
            ];
            let valueBeforeIndex = 0; // Record the index which value < newValue
            const valueDist = rawValues.length ? Math.abs(newValue - rawValues[valueIndex]) : mergedMax - mergedMin;
            rawValues.forEach((val, index)=>{
                if (val < newValue) valueBeforeIndex = index;
            });
            let focusIndex = valueIndex;
            if (effectiveRangeEditable && valueDist !== 0 && (!maxCount || rawValues.length < maxCount)) {
                cloneNextValues.splice(valueBeforeIndex + 1, 0, newValue);
                focusIndex = valueBeforeIndex + 1;
            } else {
                cloneNextValues[valueIndex] = newValue;
                focusIndex = valueIndex;
            }
            // Fill value to match default 2 (only when `rawValues` is empty)
            if (rangeEnabled && !rawValues.length && count === undefined) cloneNextValues.push(newValue);
            const nextValue = getTriggerValue(cloneNextValues);
            onBeforeChange?.(nextValue);
            triggerChange(cloneNextValues);
            if (e) {
                document.activeElement?.blur?.();
                handlesRef.current.focus(focusIndex);
                onStartDrag(e, focusIndex, cloneNextValues);
            } else {
                // https://github.com/ant-design/ant-design/issues/49997
                onAfterChange?.(nextValue);
                (0, $26d7cf6379fe7659$export$2e2bcd8739ae039)(!onAfterChange, "[rc-slider] `onAfterChange` is deprecated. Please use `onChangeComplete` instead.");
                onChangeComplete?.(nextValue);
            }
        }
    };
    // ============================ Click =============================
    const onSliderMouseDown = (e)=>{
        e.preventDefault();
        const { width: width, height: height, left: left, top: top, bottom: bottom, right: right } = containerRef.current.getBoundingClientRect();
        const { clientX: clientX, clientY: clientY } = e;
        let percent;
        switch(direction){
            case "btt":
                percent = (bottom - clientY) / height;
                break;
            case "ttb":
                percent = (clientY - top) / height;
                break;
            case "rtl":
                percent = (right - clientX) / width;
                break;
            default:
                percent = (clientX - left) / width;
        }
        const nextValue = mergedMin + percent * (mergedMax - mergedMin);
        changeToCloseValue(formatValue(nextValue), e);
    };
    // =========================== Keyboard ===========================
    const [keyboardValue, setKeyboardValue] = $cQmXV.useState(null);
    const onHandleOffsetChange = (offset, valueIndex)=>{
        if (!disabled && !isHandleDisabled(valueIndex)) {
            const next = offsetValues(rawValues, offset, valueIndex);
            onBeforeChange?.(getTriggerValue(rawValues));
            triggerChange(next.values);
            setKeyboardValue({
                value: next.value,
                index: valueIndex
            });
        }
    };
    $cQmXV.useEffect(()=>{
        if (keyboardValue !== null) {
            const { value: nextKeyboardValue, index: index } = keyboardValue;
            const valueIndex = rawValues[index] === nextKeyboardValue ? index : rawValues.indexOf(nextKeyboardValue);
            if (valueIndex >= 0) handlesRef.current.focus(valueIndex);
        }
        setKeyboardValue(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        keyboardValue
    ]);
    // ============================= Drag =============================
    const mergedDraggableTrack = $cQmXV.useMemo(()=>{
        if (rangeDraggableTrack && mergedStep === null) return false;
        return rangeDraggableTrack;
    }, [
        rangeDraggableTrack,
        mergedStep
    ]);
    const onStartMove = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((e, valueIndex)=>{
        onStartDrag(e, valueIndex);
        onBeforeChange?.(getTriggerValue(rawValues));
    });
    // Auto focus for updated handle
    const dragging = draggingIndex !== -1;
    $cQmXV.useEffect(()=>{
        if (!dragging) {
            const valueIndex = rawValues.lastIndexOf(draggingValue);
            handlesRef.current.focus(valueIndex);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        dragging
    ]);
    // =========================== Included ===========================
    const sortedCacheValues = $cQmXV.useMemo(()=>[
            ...cacheValues
        ].sort((a, b)=>a - b), [
        cacheValues
    ]);
    // Provide a range values with included [min, max]
    // Used for Track, Mark & Dot
    const [includedStart, includedEnd] = $cQmXV.useMemo(()=>{
        if (!rangeEnabled) return [
            mergedMin,
            sortedCacheValues[0]
        ];
        return [
            sortedCacheValues[0],
            sortedCacheValues[sortedCacheValues.length - 1]
        ];
    }, [
        sortedCacheValues,
        rangeEnabled,
        mergedMin
    ]);
    // ============================= Refs =============================
    $cQmXV.useImperativeHandle(ref, ()=>({
            focus: ()=>{
                handlesRef.current.focus(0);
            },
            blur: ()=>{
                const { activeElement: activeElement } = document;
                if (containerRef.current?.contains(activeElement)) activeElement?.blur();
            }
        }));
    // ========================== Auto Focus ==========================
    const autoFocusRef = $cQmXV.useRef(autoFocus);
    $cQmXV.useEffect(()=>{
        if (autoFocusRef.current) handlesRef.current.focus(0);
    }, []);
    // =========================== Context ============================
    const context = $cQmXV.useMemo(()=>({
            min: mergedMin,
            max: mergedMax,
            direction: direction,
            disabled: disabled,
            keyboard: keyboard,
            step: mergedStep,
            included: included,
            includedStart: includedStart,
            includedEnd: includedEnd,
            range: rangeEnabled,
            tabIndex: tabIndex,
            ariaLabelForHandle: ariaLabelForHandle,
            ariaLabelledByForHandle: ariaLabelledByForHandle,
            ariaRequired: ariaRequired,
            ariaValueTextFormatterForHandle: ariaValueTextFormatterForHandle,
            styles: styles || {},
            classNames: classNames || {},
            isHandleDisabled: isHandleDisabled
        }), [
        mergedMin,
        mergedMax,
        direction,
        disabled,
        keyboard,
        mergedStep,
        included,
        includedStart,
        includedEnd,
        rangeEnabled,
        tabIndex,
        ariaLabelForHandle,
        ariaLabelledByForHandle,
        ariaRequired,
        ariaValueTextFormatterForHandle,
        styles,
        classNames,
        isHandleDisabled
    ]);
    // ============================ Render ============================
    return /*#__PURE__*/ $cQmXV.createElement((0, $3d287409329d294d$export$2e2bcd8739ae039).Provider, {
        value: context
    }, /*#__PURE__*/ $cQmXV.createElement("div", {
        ref: containerRef,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, className, {
            [`${prefixCls}-disabled`]: disabled,
            [`${prefixCls}-vertical`]: vertical,
            [`${prefixCls}-horizontal`]: !vertical,
            [`${prefixCls}-with-marks`]: markList.length
        }),
        style: style,
        onMouseDown: onSliderMouseDown,
        id: id
    }, /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-rail`, classNames?.rail),
        style: {
            ...railStyle,
            ...styles?.rail
        }
    }), track !== false && /*#__PURE__*/ $cQmXV.createElement((0, $0cf7e74f1a97ef0c$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        style: trackStyle,
        values: rawValues,
        startPoint: startPoint,
        onStartMove: mergedDraggableTrack ? onStartMove : undefined
    }), /*#__PURE__*/ $cQmXV.createElement((0, $63cf52dfa73a148c$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        marks: markList,
        dots: dots,
        style: dotStyle,
        activeStyle: activeDotStyle
    }), /*#__PURE__*/ $cQmXV.createElement((0, $6f27592960834549$export$2e2bcd8739ae039), {
        ref: handlesRef,
        prefixCls: prefixCls,
        style: handleStyle,
        values: cacheValues,
        draggingIndex: draggingIndex,
        draggingDelete: draggingDelete,
        onStartMove: onStartMove,
        onOffsetChange: onHandleOffsetChange,
        onFocus: onFocus,
        onBlur: onBlur,
        handleRender: handleRender,
        activeHandleRender: activeHandleRender,
        onChangeComplete: finishChange,
        onDelete: effectiveRangeEditable ? onDelete : undefined
    }), /*#__PURE__*/ $cQmXV.createElement((0, $768f2290e18cf27e$export$2e2bcd8739ae039), {
        prefixCls: prefixCls,
        marks: markList,
        onClick: changeToCloseValue
    })));
});
var $de32c727b6605f68$export$2e2bcd8739ae039 = $de32c727b6605f68$var$Slider;



var $f3aaa3474d7cdbd5$export$2e2bcd8739ae039 = (0, $de32c727b6605f68$export$2e2bcd8739ae039);











var $cQmXV = parcelRequire("cQmXV");
/** @private Internal context. Do not use in your production. */ const $63c9568a454632ae$var$SliderInternalContext = /*#__PURE__*/ (0, $cQmXV.createContext)({});
var $63c9568a454632ae$export$2e2bcd8739ae039 = $63c9568a454632ae$var$SliderInternalContext;



var $cQmXV = parcelRequire("cQmXV");


"use client";
const $b554329b32696345$var$SliderTooltip = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { open: open, draggingDelete: draggingDelete, value: value } = props;
    const innerRef = (0, $cQmXV.useRef)(null);
    const mergedOpen = open && !draggingDelete;
    const rafRef = (0, $cQmXV.useRef)(null);
    function cancelKeepAlign() {
        (0, $905c53b807de704e$export$2e2bcd8739ae039).cancel(rafRef.current);
        rafRef.current = null;
    }
    function keepAlign() {
        rafRef.current = (0, $905c53b807de704e$export$2e2bcd8739ae039)(()=>{
            innerRef.current?.forceAlign();
            rafRef.current = null;
        });
    }
    $cQmXV.useEffect(()=>{
        if (mergedOpen) keepAlign();
        else cancelKeepAlign();
        return cancelKeepAlign;
    }, [
        mergedOpen,
        props.title,
        value
    ]);
    return /*#__PURE__*/ $cQmXV.createElement((0, $1e5256cf9d329b2c$export$2e2bcd8739ae039), {
        ref: (0, $10341b937b26f69d$export$ab452c34e8e05029)(innerRef, ref),
        ...props,
        open: mergedOpen
    });
});
var $b554329b32696345$export$2e2bcd8739ae039 = $b554329b32696345$var$SliderTooltip;






// =============================== Base ===============================
const $aba49b961b955581$var$genBaseStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls, controlSize: controlSize, dotSize: dotSize, marginFull: marginFull, marginPart: marginPart, colorFillContentHover: colorFillContentHover, handleColorDisabled: handleColorDisabled, calc: calc, handleSize: handleSize, handleSizeHover: handleSizeHover, handleActiveColor: handleActiveColor, handleActiveOutlineColor: handleActiveOutlineColor, handleLineWidth: handleLineWidth, handleLineWidthHover: handleLineWidthHover, motionDurationMid: motionDurationMid } = token;
    const disabledHandle = {
        backgroundColor: token.colorBgElevated,
        cursor: "not-allowed",
        width: handleSize,
        height: handleSize,
        boxShadow: `0 0 0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(handleLineWidth)} ${handleColorDisabled}`,
        insetInlineStart: 0,
        insetBlockStart: 0
    };
    return {
        [componentCls]: {
            ...(0, $519d20bf207ce864$export$23997c3e44cc1c59)(token),
            position: "relative",
            height: controlSize,
            margin: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(marginPart)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(marginFull)}`,
            padding: 0,
            cursor: "pointer",
            touchAction: "none",
            // https://github.com/ant-design/ant-design/issues/55686
            // Prevent text selection on adjacent content when dragging the handle in Safari.
            userSelect: "none",
            "&-vertical": {
                margin: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(marginFull)} ${(0, $05f34ed03d41967d$export$523c0b569236b342)(marginPart)}`
            },
            [`${componentCls}-rail`]: {
                position: "absolute",
                backgroundColor: token.railBg,
                borderRadius: token.borderRadiusXS,
                transition: `background-color ${motionDurationMid}`
            },
            [`${componentCls}-track,${componentCls}-tracks`]: {
                position: "absolute",
                transition: `background-color ${motionDurationMid}`
            },
            [`${componentCls}-track`]: {
                backgroundColor: token.trackBg,
                borderRadius: token.borderRadiusXS
            },
            [`${componentCls}-track-draggable`]: {
                boxSizing: "content-box",
                backgroundClip: "content-box",
                border: "solid rgba(0,0,0,0)"
            },
            "&:hover": {
                [`${componentCls}-rail`]: {
                    backgroundColor: token.railHoverBg
                },
                [`${componentCls}-track`]: {
                    backgroundColor: token.trackHoverBg
                },
                [`${componentCls}-dot`]: {
                    borderColor: colorFillContentHover
                },
                [`${componentCls}-handle:not(${componentCls}-handle-disabled)::after`]: {
                    boxShadow: `0 0 0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(handleLineWidth)} ${token.colorPrimaryBorderHover}`
                },
                [`${componentCls}-dot-active`]: {
                    borderColor: token.dotActiveBorderColor
                }
            },
            [`${componentCls}-handle`]: {
                position: "absolute",
                width: handleSize,
                height: handleSize,
                outline: "none",
                userSelect: "none",
                // Dragging status
                "&-dragging-delete": {
                    opacity: 0
                },
                // 扩大选区
                "&::before": {
                    content: '""',
                    position: "absolute",
                    insetInlineStart: calc(handleLineWidth).mul(-1).equal(),
                    insetBlockStart: calc(handleLineWidth).mul(-1).equal(),
                    width: calc(handleSize).add(calc(handleLineWidth).mul(2)).equal(),
                    height: calc(handleSize).add(calc(handleLineWidth).mul(2)).equal(),
                    backgroundColor: "transparent"
                },
                "&::after": {
                    content: '""',
                    position: "absolute",
                    insetBlockStart: 0,
                    insetInlineStart: 0,
                    width: handleSize,
                    height: handleSize,
                    backgroundColor: token.colorBgElevated,
                    boxShadow: `0 0 0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(handleLineWidth)} ${token.handleColor}`,
                    outline: `0px solid transparent`,
                    borderRadius: "50%",
                    cursor: "pointer",
                    transition: [
                        "inset-inline-start",
                        "inset-block-start",
                        "width",
                        "height",
                        "box-shadow",
                        "outline"
                    ].map((prop)=>`${prop} ${motionDurationMid}`).join(", ")
                },
                "&:hover, &:active, &:focus": {
                    [`&:not(${componentCls}-handle-disabled)::before`]: {
                        insetInlineStart: calc(handleSizeHover).sub(handleSize).div(2).add(handleLineWidthHover).mul(-1).equal(),
                        insetBlockStart: calc(handleSizeHover).sub(handleSize).div(2).add(handleLineWidthHover).mul(-1).equal(),
                        width: calc(handleSizeHover).add(calc(handleLineWidthHover).mul(2)).equal(),
                        height: calc(handleSizeHover).add(calc(handleLineWidthHover).mul(2)).equal()
                    },
                    [`&:not(${componentCls}-handle-disabled)::after`]: {
                        boxShadow: `0 0 0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(handleLineWidthHover)} ${handleActiveColor}`,
                        outline: `6px solid ${handleActiveOutlineColor}`,
                        width: handleSizeHover,
                        height: handleSizeHover,
                        insetInlineStart: token.calc(handleSize).sub(handleSizeHover).div(2).equal(),
                        insetBlockStart: token.calc(handleSize).sub(handleSizeHover).div(2).equal()
                    }
                }
            },
            [`&-lock ${componentCls}-handle`]: {
                "&::before, &::after": {
                    transition: "none"
                }
            },
            [`${componentCls}-mark`]: {
                position: "absolute",
                fontSize: token.fontSize
            },
            [`${componentCls}-mark-text`]: {
                position: "absolute",
                display: "inline-block",
                color: token.colorTextDescription,
                textAlign: "center",
                wordBreak: "keep-all",
                cursor: "pointer",
                userSelect: "none",
                "&-active": {
                    color: token.colorText
                }
            },
            [`${componentCls}-step`]: {
                position: "absolute",
                background: "transparent",
                pointerEvents: "none"
            },
            [`${componentCls}-dot`]: {
                position: "absolute",
                width: dotSize,
                height: dotSize,
                backgroundColor: token.colorBgElevated,
                border: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(handleLineWidth)} solid ${token.dotBorderColor}`,
                borderRadius: "50%",
                cursor: "pointer",
                transition: `border-color ${token.motionDurationSlow}`,
                pointerEvents: "auto",
                "&-active": {
                    borderColor: token.dotActiveBorderColor
                }
            },
            [`&${componentCls}-disabled`]: {
                cursor: "not-allowed",
                [`${componentCls}-rail`]: {
                    backgroundColor: `${token.railBg} !important`
                },
                [`${componentCls}-track`]: {
                    backgroundColor: `${token.trackBgDisabled} !important`
                },
                [`
          ${componentCls}-dot
        `]: {
                    backgroundColor: token.colorBgElevated,
                    borderColor: token.trackBgDisabled,
                    boxShadow: "none",
                    cursor: "not-allowed"
                },
                [`${componentCls}-handle::after`]: {
                    ...disabledHandle
                },
                [`
          ${componentCls}-mark-text,
          ${componentCls}-dot
        `]: {
                    cursor: `not-allowed !important`
                }
            },
            [`${componentCls}-handle-disabled::after`]: {
                ...disabledHandle
            },
            [`&-tooltip ${antCls}-tooltip-container`]: {
                minWidth: "unset"
            }
        }
    };
};
// ============================ Horizontal ============================
const $aba49b961b955581$var$genDirectionStyle = (token, horizontal)=>{
    const { componentCls: componentCls, railSize: railSize, handleSize: handleSize, dotSize: dotSize, marginFull: marginFull, calc: calc } = token;
    const railPadding = horizontal ? "paddingBlock" : "paddingInline";
    const full = horizontal ? "width" : "height";
    const part = horizontal ? "height" : "width";
    const handlePos = horizontal ? "insetBlockStart" : "insetInlineStart";
    const markInset = horizontal ? "top" : "insetInlineStart";
    const handlePosSize = calc(railSize).mul(3).sub(handleSize).div(2).equal();
    const draggableBorderSize = calc(handleSize).sub(railSize).div(2).equal();
    const draggableBorder = horizontal ? {
        borderWidth: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(draggableBorderSize)} 0`,
        transform: `translateY(${(0, $05f34ed03d41967d$export$523c0b569236b342)(calc(draggableBorderSize).mul(-1).equal())})`
    } : {
        borderWidth: `0 ${(0, $05f34ed03d41967d$export$523c0b569236b342)(draggableBorderSize)}`,
        transform: `translateX(${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.calc(draggableBorderSize).mul(-1).equal())})`
    };
    return {
        [railPadding]: railSize,
        [part]: calc(railSize).mul(3).equal(),
        [`${componentCls}-rail`]: {
            [full]: "100%",
            [part]: railSize
        },
        [`${componentCls}-track,${componentCls}-tracks`]: {
            [part]: railSize
        },
        [`${componentCls}-track-draggable`]: {
            ...draggableBorder
        },
        [`${componentCls}-handle`]: {
            [handlePos]: handlePosSize
        },
        [`${componentCls}-mark`]: {
            // Reset all
            insetInlineStart: 0,
            top: 0,
            // https://github.com/ant-design/ant-design/issues/43731
            [markInset]: calc(railSize).mul(3).add(horizontal ? 0 : marginFull).equal(),
            [full]: "100%"
        },
        [`${componentCls}-step`]: {
            // Reset all
            insetInlineStart: 0,
            top: 0,
            [markInset]: railSize,
            [full]: "100%",
            [part]: railSize
        },
        [`${componentCls}-dot`]: {
            position: "absolute",
            [handlePos]: calc(railSize).sub(dotSize).div(2).equal()
        }
    };
};
// ============================ Horizontal ============================
const $aba49b961b955581$var$genHorizontalStyle = (token)=>{
    const { componentCls: componentCls, marginPartWithMark: marginPartWithMark } = token;
    return {
        [`${componentCls}-horizontal`]: {
            ...$aba49b961b955581$var$genDirectionStyle(token, true),
            [`&${componentCls}-with-marks`]: {
                marginBottom: marginPartWithMark
            }
        }
    };
};
// ============================= Vertical =============================
const $aba49b961b955581$var$genVerticalStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [`${componentCls}-vertical`]: {
            ...$aba49b961b955581$var$genDirectionStyle(token, false),
            height: "100%"
        }
    };
};
const $aba49b961b955581$export$9ca1be8807fe0675 = (token)=>{
    // Handle line width is always width-er 1px
    const increaseHandleWidth = 1;
    const controlSize = token.controlHeightLG / 4;
    const controlSizeHover = token.controlHeightSM / 2;
    const handleLineWidth = token.lineWidth + increaseHandleWidth;
    const handleLineWidthHover = token.lineWidth + increaseHandleWidth * 1.5;
    const handleActiveColor = token.colorPrimary;
    const handleActiveOutlineColor = new (0, $3bb84f07fb2a2f32$export$2c4f38d6c0ecc25a)(handleActiveColor).setA(0.2).toRgbString();
    return {
        controlSize: controlSize,
        railSize: 4,
        handleSize: controlSize,
        handleSizeHover: controlSizeHover,
        dotSize: 8,
        handleLineWidth: handleLineWidth,
        handleLineWidthHover: handleLineWidthHover,
        railBg: token.colorFillTertiary,
        railHoverBg: token.colorFillSecondary,
        trackBg: token.colorPrimaryBorder,
        trackHoverBg: token.colorPrimaryBorderHover,
        handleColor: token.colorPrimaryBorder,
        handleActiveColor: handleActiveColor,
        handleActiveOutlineColor: handleActiveOutlineColor,
        handleColorDisabled: new (0, $3bb84f07fb2a2f32$export$2c4f38d6c0ecc25a)(token.colorTextDisabled).onBackground(token.colorBgContainer).toHexString(),
        dotBorderColor: token.colorBorderSecondary,
        dotActiveBorderColor: token.colorPrimaryBorder,
        trackBgDisabled: token.colorBgContainerDisabled
    };
};
var $aba49b961b955581$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$51ec95de45185b42)("Slider", (token)=>{
    const sliderToken = (0, $fef50f256b80dfa5$export$4950aa0f605343fb)(token, {
        marginPart: token.calc(token.controlHeight).sub(token.controlSize).div(2).equal(),
        marginFull: token.calc(token.controlSize).div(2).equal(),
        marginPartWithMark: token.calc(token.controlHeightLG).sub(token.controlSize).equal()
    });
    return [
        $aba49b961b955581$var$genBaseStyle(sliderToken),
        $aba49b961b955581$var$genHorizontalStyle(sliderToken),
        $aba49b961b955581$var$genVerticalStyle(sliderToken)
    ];
}, $aba49b961b955581$export$9ca1be8807fe0675);


"use client";
function $ad6b1c42726e460c$var$getTipFormatter(tipFormatter) {
    if (tipFormatter || tipFormatter === null) return tipFormatter;
    return (val)=>(0, $8e2d153a3c855782$export$7e4aa119212bc614)(val) ? val.toString() : "";
}
const $ad6b1c42726e460c$var$Slider = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, range: range, className: className, rootClassName: rootClassName, style: style, disabled: disabled, tooltip: // Deprecated Props
    tooltip = {}, onChangeComplete: onChangeComplete, classNames: classNames, styles: styles, vertical: vertical, orientation: orientation, ...restProps } = props;
    const [, mergedVertical] = (0, $78e4f9cb51a5af1c$export$550084c67147f6c4)(orientation, vertical);
    const { getPrefixCls: getPrefixCls, direction: contextDirection, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles, getPopupContainer: getPopupContainer } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("slider");
    const contextDisabled = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useContext((0, $4f0e1ea30330557c$export$2e2bcd8739ae039));
    const mergedDisabled = disabled ?? contextDisabled;
    // =========== Merged Props for Semantic ==========
    const mergedProps = {
        ...props,
        disabled: mergedDisabled,
        vertical: mergedVertical
    };
    const contextStyleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $30c5f9f911d4f61b$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: mergedProps
    });
    // ============================= Context ==============================
    const { handleRender: contextHandleRender, direction: internalContextDirection } = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useContext((0, $63c9568a454632ae$export$2e2bcd8739ae039));
    const mergedDirection = internalContextDirection || contextDirection;
    const isRTL = mergedDirection === "rtl";
    // =============================== Open ===============================
    const [hoverOpen, setHoverOpen] = (0, $f0cf805f93abd5af$export$2e2bcd8739ae039)(false);
    const [focusOpen, setFocusOpen] = (0, $f0cf805f93abd5af$export$2e2bcd8739ae039)(false);
    const tooltipProps = {
        ...tooltip
    };
    const { open: tooltipOpen, placement: tooltipPlacement, getPopupContainer: getTooltipPopupContainer, prefixCls: customizeTooltipPrefixCls, formatter: tipFormatter } = tooltipProps;
    const lockOpen = tooltipOpen;
    const activeOpen = (hoverOpen || focusOpen) && lockOpen !== false;
    const mergedTipFormatter = $ad6b1c42726e460c$var$getTipFormatter(tipFormatter);
    // ============================= Change ==============================
    const [dragging, setDragging] = (0, $f0cf805f93abd5af$export$2e2bcd8739ae039)(false);
    const onInternalChangeComplete = (nextValues)=>{
        onChangeComplete?.(nextValues);
        setDragging(false);
    };
    // ============================ Placement ============================
    const getTooltipPlacement = (placement, vert)=>{
        if (placement) return placement;
        if (!vert) return "top";
        return isRTL ? "left" : "right";
    };
    // ============================== Style ===============================
    const prefixCls = getPrefixCls("slider", customizePrefixCls);
    const [hashId, cssVarCls] = (0, $aba49b961b955581$export$2e2bcd8739ae039)(prefixCls);
    const rootClassNames = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(className, contextClassName, mergedClassNames.root, rootClassName, {
        [`${prefixCls}-rtl`]: isRTL,
        [`${prefixCls}-lock`]: dragging
    }, hashId, cssVarCls);
    // make reverse default on rtl direction
    if (isRTL && !mergedVertical) restProps.reverse = !restProps.reverse;
    var deprecatedName, newName;
    // ============================== Handle ==============================
    (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useEffect(()=>{
        const onMouseUp = ()=>{
            // Delay for 1 frame to make the click to enable hide tooltip
            // even when the handle is focused
            (0, $905c53b807de704e$export$2e2bcd8739ae039)(()=>{
                setFocusOpen(false);
            }, 1);
        };
        document.addEventListener("mouseup", onMouseUp);
        return ()=>{
            document.removeEventListener("mouseup", onMouseUp);
        };
    }, []);
    const useActiveTooltipHandle = range && !lockOpen;
    const handleRender = contextHandleRender || ((node, info)=>{
        const { index: index } = info;
        const nodeProps = node.props;
        function proxyEvent(eventName, event) {
            nodeProps[eventName]?.(event);
        }
        const passedProps = {
            ...nodeProps,
            onMouseEnter: (e)=>{
                setHoverOpen(true, true);
                proxyEvent("onMouseEnter", e);
            },
            onMouseLeave: (e)=>{
                setHoverOpen(false);
                proxyEvent("onMouseLeave", e);
            },
            onMouseDown: (e)=>{
                setFocusOpen(true, true);
                setDragging(true, true);
                proxyEvent("onMouseDown", e);
            },
            onFocus: (e)=>{
                setFocusOpen(true, true);
                proxyEvent("onFocus", e);
            },
            onBlur: (e)=>{
                setFocusOpen(false);
                proxyEvent("onBlur", e);
            }
        };
        const cloneNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).cloneElement(node, passedProps);
        const open = (!!lockOpen || activeOpen) && mergedTipFormatter !== null;
        // Wrap on handle with Tooltip when is single mode or multiple with all show tooltip
        if (!useActiveTooltipHandle) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $b554329b32696345$export$2e2bcd8739ae039), {
            ...tooltipProps,
            prefixCls: getPrefixCls("tooltip", customizeTooltipPrefixCls),
            title: mergedTipFormatter ? mergedTipFormatter(info.value) : undefined,
            value: info.value,
            open: open,
            placement: getTooltipPlacement(tooltipPlacement, mergedVertical),
            key: index,
            classNames: {
                root: `${prefixCls}-tooltip`
            },
            getPopupContainer: getTooltipPopupContainer || getPopupContainer
        }, cloneNode);
        return cloneNode;
    });
    // ========================== Active Handle ===========================
    const activeHandleRender = useActiveTooltipHandle ? (handle, info)=>{
        const cloneNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).cloneElement(handle, {
            style: {
                ...handle.props.style,
                visibility: "hidden"
            }
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $b554329b32696345$export$2e2bcd8739ae039), {
            ...tooltipProps,
            prefixCls: getPrefixCls("tooltip", customizeTooltipPrefixCls),
            title: mergedTipFormatter ? mergedTipFormatter(info.value) : undefined,
            open: mergedTipFormatter !== null && activeOpen,
            placement: getTooltipPlacement(tooltipPlacement, mergedVertical),
            key: "tooltip",
            classNames: {
                root: `${prefixCls}-tooltip`
            },
            getPopupContainer: getTooltipPopupContainer || getPopupContainer,
            draggingDelete: info.draggingDelete
        }, cloneNode);
    } : undefined;
    // ============================== Render ==============================
    const rootStyle = {
        ...mergedStyles.root
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $f3aaa3474d7cdbd5$export$2e2bcd8739ae039), {
        ...restProps,
        classNames: mergedClassNames,
        styles: mergedStyles,
        step: restProps.step,
        range: range,
        className: rootClassNames,
        style: rootStyle,
        disabled: mergedDisabled,
        vertical: mergedVertical,
        ref: ref,
        prefixCls: prefixCls,
        handleRender: handleRender,
        activeHandleRender: activeHandleRender,
        onChangeComplete: onInternalChangeComplete
    });
});
var $ad6b1c42726e460c$export$2e2bcd8739ae039 = $ad6b1c42726e460c$var$Slider;



function $7e7c319001ede09b$var$clamp(v, min, max) {
    return Math.max(min, Math.min(max, v));
}
const $7e7c319001ede09b$var$MIN_SIDE = 24;
const $7e7c319001ede09b$var$NUDGE = 1;
const $7e7c319001ede09b$var$NUDGE_FAR = 10;
const $7e7c319001ede09b$var$ZOOM_STEP = 8;
class $7e7c319001ede09b$export$2e2bcd8739ae039 extends (0, $cQmXV.Component) {
    constructor(props){
        super(props);
        this.imgRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createRef();
        this.selRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createRef();
        this.state = {
            url: URL.createObjectURL(props.file),
            natural: null,
            display: null,
            sel: null,
            drag: null
        };
    }
    componentWillUnmount() {
        if (this.state.url) URL.revokeObjectURL(this.state.url);
    }
    onImgLoad = ()=>{
        const img = this.imgRef.current;
        const display = {
            w: img.clientWidth,
            h: img.clientHeight
        };
        const natural = {
            w: img.naturalWidth,
            h: img.naturalHeight
        };
        // Square selection (1:1), centered, sized to 60% of the shorter side.
        const side = Math.round(Math.min(display.w, display.h) * 0.6);
        this.setState({
            natural: natural,
            display: display,
            sel: {
                x: Math.round((display.w - side) / 2),
                y: Math.round((display.h - side) / 2),
                w: side,
                h: side
            }
        }, /* Focus the selection, not the footer: arrow keys are the keyboard path into this editor, and
         they only reach it while it holds focus. */ ()=>this.selRef.current && this.selRef.current.focus());
    };
    /** The largest square that still fits the image. */ get maxSide() {
        const { display: display } = this.state;
        return display ? Math.min(display.w, display.h) : $7e7c319001ede09b$var$MIN_SIDE;
    }
    /** Resize around the selection's centre, then push it back inside the image. */ setSide = (nextSide)=>{
        const { sel: sel, display: display } = this.state;
        if (!sel || !display) return;
        const side = $7e7c319001ede09b$var$clamp(Math.round(nextSide), $7e7c319001ede09b$var$MIN_SIDE, this.maxSide);
        const cx = sel.x + sel.w / 2;
        const cy = sel.y + sel.h / 2;
        this.setState({
            sel: {
                x: $7e7c319001ede09b$var$clamp(Math.round(cx - side / 2), 0, display.w - side),
                y: $7e7c319001ede09b$var$clamp(Math.round(cy - side / 2), 0, display.h - side),
                w: side,
                h: side
            }
        });
    };
    move = (dx, dy)=>{
        const { sel: sel, display: display } = this.state;
        if (!sel || !display) return;
        this.setState({
            sel: {
                ...sel,
                x: $7e7c319001ede09b$var$clamp(sel.x + dx, 0, display.w - sel.w),
                y: $7e7c319001ede09b$var$clamp(sel.y + dy, 0, display.h - sel.h)
            }
        });
    };
    onKeyDown = (event)=>{
        const { sel: sel, display: display } = this.state;
        if (!sel || !display) return;
        const step = event.shiftKey ? $7e7c319001ede09b$var$NUDGE_FAR : $7e7c319001ede09b$var$NUDGE;
        const keys = {
            "ArrowLeft": ()=>this.move(-step, 0),
            "ArrowRight": ()=>this.move(step, 0),
            "ArrowUp": ()=>this.move(0, -step),
            "ArrowDown": ()=>this.move(0, step),
            "+": ()=>this.setSide(sel.w - $7e7c319001ede09b$var$ZOOM_STEP),
            "=": ()=>this.setSide(sel.w - $7e7c319001ede09b$var$ZOOM_STEP),
            "-": ()=>this.setSide(sel.w + $7e7c319001ede09b$var$ZOOM_STEP),
            "_": ()=>this.setSide(sel.w + $7e7c319001ede09b$var$ZOOM_STEP),
            "Home": ()=>this.centre(),
            "Enter": ()=>this.confirm()
        };
        const handler = keys[event.key];
        if (!handler) return;
        /* Arrow keys scroll the modal body otherwise, so the selection appears not to move. */ event.preventDefault();
        handler();
    };
    centre = ()=>{
        const { sel: sel, display: display } = this.state;
        if (!sel || !display) return;
        this.setState({
            sel: {
                ...sel,
                x: Math.round((display.w - sel.w) / 2),
                y: Math.round((display.h - sel.h) / 2)
            }
        });
    };
    startDrag = (mode, e)=>{
        e.preventDefault();
        e.stopPropagation();
        this.setState({
            drag: {
                mode: mode,
                startX: e.clientX,
                startY: e.clientY,
                orig: {
                    ...this.state.sel
                }
            }
        });
    };
    onMove = (e)=>{
        const { drag: drag, display: display } = this.state;
        if (!drag || !display) return;
        const dx = e.clientX - drag.startX, dy = e.clientY - drag.startY;
        const o = drag.orig;
        // Move: shift the square within the image bounds (size unchanged).
        if (drag.mode === "move") {
            const x = $7e7c319001ede09b$var$clamp(o.x + dx, 0, display.w - o.w);
            const y = $7e7c319001ede09b$var$clamp(o.y + dy, 0, display.h - o.h);
            this.setState({
                sel: {
                    x: x,
                    y: y,
                    w: o.w,
                    h: o.h
                }
            });
            return;
        }
        // Corner resize: keep a perfect square (1:1). The opposite corner stays fixed,
        // and the side grows/shrinks with the drag, clamped to the image bounds.
        let grow, maxSide;
        if (drag.mode === "se") {
            grow = Math.max(dx, dy);
            maxSide = Math.min(display.w - o.x, display.h - o.y);
        } else if (drag.mode === "nw") {
            grow = Math.max(-dx, -dy);
            maxSide = Math.min(o.x + o.w, o.y + o.h);
        } else if (drag.mode === "ne") {
            grow = Math.max(dx, -dy);
            maxSide = Math.min(display.w - o.x, o.y + o.h);
        } else {
            grow = Math.max(-dx, dy);
            maxSide = Math.min(o.x + o.w, display.h - o.y);
        } // sw
        const side = $7e7c319001ede09b$var$clamp(o.w + grow, $7e7c319001ede09b$var$MIN_SIDE, maxSide);
        let x = o.x, y = o.y; // se anchors at top-left
        if (drag.mode === "nw") {
            x = o.x + o.w - side;
            y = o.y + o.h - side;
        } else if (drag.mode === "ne") y = o.y + o.h - side;
        else if (drag.mode === "sw") x = o.x + o.w - side;
        this.setState({
            sel: {
                x: x,
                y: y,
                w: side,
                h: side
            }
        });
    };
    endDrag = ()=>{
        if (this.state.drag) this.setState({
            drag: null
        });
    };
    confirm = ()=>{
        const { natural: natural, display: display, sel: sel } = this.state;
        if (!sel || !display || !natural) return;
        const sx = sel.x / display.w * natural.w, sy = sel.y / display.h * natural.h;
        const sw = sel.w / display.w * natural.w, sh = sel.h / display.h * natural.h;
        const canvas = document.createElement("canvas");
        canvas.width = Math.max(1, Math.round(sw));
        canvas.height = Math.max(1, Math.round(sh));
        canvas.getContext("2d").drawImage(this.imgRef.current, sx, sy, sw, sh, 0, 0, canvas.width, canvas.height);
        const type = this.props.file.type || "image/png";
        canvas.toBlob((blob)=>{
            const cropped = new File([
                blob
            ], this.props.file.name || "logo.png", {
                type: type
            });
            this.props.onConfirm(cropped);
        }, type, 0.92);
    };
    /** The crop, as a background window onto the same image — no second canvas, no second decode. */ previewStyle() {
        const { url: url, sel: sel, display: display } = this.state;
        if (!sel || !display) return {
            backgroundImage: `url(${url})`
        };
        const scale = 72 / sel.w;
        return {
            backgroundImage: `url(${url})`,
            backgroundSize: `${display.w * scale}px ${display.h * scale}px`,
            backgroundPosition: `${-sel.x * scale}px ${-sel.y * scale}px`
        };
    }
    render() {
        const { url: url, sel: sel } = this.state;
        const L = this.props.labels || {};
        return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $05a90c67d3627fd9$export$2e2bcd8739ae039), {
            open: true,
            title: L.cropTitle,
            okText: L.cropConfirm,
            cancelText: L.cropCancel,
            onOk: this.confirm,
            onCancel: this.props.onCancel,
            width: 620,
            destroyOnHidden: true,
            children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                vertical: true,
                gap: "middle",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                        className: "pt-cropper-stage",
                        onPointerMove: this.onMove,
                        onPointerUp: this.endDrag,
                        onPointerLeave: this.endDrag,
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("img", {
                                ref: this.imgRef,
                                src: url,
                                onLoad: this.onImgLoad,
                                className: "pt-cropper-img",
                                alt: "",
                                draggable: false
                            }),
                            sel && /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                                ref: this.selRef,
                                className: "pt-cropper-sel",
                                style: {
                                    left: sel.x,
                                    top: sel.y,
                                    width: sel.w,
                                    height: sel.h
                                },
                                role: "group",
                                "aria-label": L.cropArea,
                                tabIndex: 0,
                                onKeyDown: this.onKeyDown,
                                onPointerDown: (e)=>this.startDrag("move", e),
                                children: [
                                    "nw",
                                    "ne",
                                    "sw",
                                    "se"
                                ].map((hd)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                        className: "pt-cropper-handle pt-cropper-handle-" + hd,
                                        onPointerDown: (e)=>this.startDrag(hd, e)
                                    }, hd))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                        align: "center",
                        gap: "middle",
                        wrap: true,
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                align: "center",
                                gap: "small",
                                flex: "1",
                                className: "pt-cropper-zoom",
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $ccc5bd0954e2dcd0$export$2e2bcd8739ae039), {
                                        "aria-hidden": true
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $ad6b1c42726e460c$export$2e2bcd8739ae039), {
                                        style: {
                                            flex: 1
                                        },
                                        min: $7e7c319001ede09b$var$MIN_SIDE,
                                        max: Math.max($7e7c319001ede09b$var$MIN_SIDE + 1, this.maxSide),
                                        value: sel ? this.maxSide + $7e7c319001ede09b$var$MIN_SIDE - sel.w : this.maxSide,
                                        disabled: !sel,
                                        tooltip: {
                                            open: false
                                        },
                                        "aria-label": L.cropSize,
                                        onChange: (value)=>this.setSide(this.maxSide + $7e7c319001ede09b$var$MIN_SIDE - value)
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $815b934ea3c76706$export$2e2bcd8739ae039), {
                                        "aria-hidden": true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                vertical: true,
                                align: "center",
                                gap: 4,
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                                        className: "pt-cropper-preview",
                                        style: this.previewStyle(),
                                        role: "img",
                                        "aria-label": L.cropPreview
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                        type: "secondary",
                                        className: "pt-cropper-caption",
                                        children: L.cropPreview
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                        type: "secondary",
                        className: "pt-cropper-caption",
                        children: L.cropHint
                    })
                ]
            })
        });
    }
}


function $28744222778d38c2$export$2e2bcd8739ae039({ field: field, value: value, onChange: onChange, labels: labels = {} }) {
    const [rawFile, setRawFile] = (0, $cQmXV.useState)(null);
    const isFile = typeof File !== "undefined" && value instanceof File;
    const url = isFile ? URL.createObjectURL(value) : typeof value === "string" && value ? value : null;
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
        vertical: true,
        gap: "small",
        align: "flex-start",
        children: [
            url && /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("img", {
                src: url,
                alt: "",
                className: "pt-image-preview"
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                gap: "small",
                wrap: true,
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b615b6e60c753ce5$export$2e2bcd8739ae039), {
                        accept: "image/*",
                        maxCount: 1,
                        showUploadList: false,
                        beforeUpload: (file)=>{
                            setRawFile(file);
                            return false;
                        },
                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                            icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $08a66dd72a6d5552$export$2e2bcd8739ae039), {}),
                            children: labels.pickImage
                        })
                    }),
                    isFile && /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $1231e9abf7ce61ea$export$2e2bcd8739ae039), {}),
                        onClick: ()=>setRawFile(value),
                        children: labels.crop
                    }),
                    url && /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                        danger: true,
                        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5234c28d879e38c1$export$2e2bcd8739ae039), {}),
                        onClick: ()=>onChange(field.name, ""),
                        children: labels.removeImage
                    })
                ]
            }),
            rawFile && /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $7e7c319001ede09b$export$2e2bcd8739ae039), {
                file: rawFile,
                labels: labels,
                onConfirm: (cropped)=>{
                    onChange(field.name, cropped);
                    setRawFile(null);
                },
                onCancel: ()=>{
                    // Cropping is mandatory: cancelling discards the pick and leaves the current value
                    // unchanged — an uncropped file is never uploaded.
                    setRawFile(null);
                }
            })
        ]
    });
}




var $cQmXV = parcelRequire("cQmXV");




// An editor for a JSON object field: rows of { label -> value } the user can add and remove.
// The stored value is a plain object { key: value }.
const $7c1dda5e4574a6ab$var$toRows = (v)=>v && typeof v === "object" && !Array.isArray(v) ? Object.entries(v).map(([key, value])=>({
            key: key,
            value: value == null ? "" : String(value)
        })) : [];
const $7c1dda5e4574a6ab$var$toObject = (rows)=>rows.reduce((o, r)=>{
        const k = r.key.trim();
        if (k) o[k] = r.value;
        return o;
    }, {});
function $7c1dda5e4574a6ab$export$2e2bcd8739ae039({ field: field, value: value, onChange: onChange, lang: lang }) {
    const [rows, setRows] = (0, $cQmXV.useState)(()=>$7c1dda5e4574a6ab$var$toRows(value));
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ac552071080927b0), key, lang);
    const sync = (next)=>{
        setRows(next);
        onChange(field.name, $7c1dda5e4574a6ab$var$toObject(next));
    };
    const update = (i, key, val)=>sync(rows.map((r, idx)=>idx === i ? {
                ...r,
                [key]: val
            } : r));
    /* A blank row carries no key, so it is not in the stored object yet — adding one is local
     state, not a change to the record. */ const add = ()=>setRows([
            ...rows,
            {
                key: "",
                value: ""
            }
        ]);
    const remove = (i)=>sync(rows.filter((_, idx)=>idx !== i));
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
        vertical: true,
        gap: "small",
        align: "flex-start",
        children: [
            rows.map((row, i)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                    gap: "small",
                    style: {
                        width: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0883e7f8083c01b0$export$2e2bcd8739ae039), {
                            placeholder: t("kv_key"),
                            "aria-label": t("kv_key"),
                            value: row.key,
                            onChange: (e)=>update(i, "key", e.target.value)
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0883e7f8083c01b0$export$2e2bcd8739ae039), {
                            placeholder: t("kv_value"),
                            "aria-label": t("kv_value"),
                            value: row.value,
                            onChange: (e)=>update(i, "value", e.target.value)
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                            type: "text",
                            icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5234c28d879e38c1$export$2e2bcd8739ae039), {}),
                            "aria-label": t("delete_btn"),
                            onClick: ()=>remove(i)
                        })
                    ]
                }, i)),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                size: "small",
                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $fa25166ced813feb$export$2e2bcd8739ae039), {}),
                onClick: add,
                children: t("kv_add")
            })
        ]
    });
}



parcelRequire("cQmXV");



/* Stored as a naive `YYYY-MM-DDTHH:mm:ss` string — the same shape the native `datetime-local`
   input produced before this, so nothing downstream (the API, the list's date columns) had to
   change. Import the app's dayjs instance, not `dayjs`, or the calendar starts its week on
   Sunday in English (see `src/util/dayjs.js`). */ const $6c1a868478667937$var$FORMAT = "YYYY-MM-DDTHH:mm:ss";
function $6c1a868478667937$export$2e2bcd8739ae039({ field: field, value: value, onChange: onChange }) {
    const parsed = value ? (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)(value) : null;
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $bf89508d36c51d8b$export$2e2bcd8739ae039), {
        showTime: true,
        prefix: (0, $5cf5963f505f5084$export$2e2bcd8739ae039)(field),
        value: parsed && parsed.isValid() ? parsed : null,
        onChange: (next)=>onChange(field.name, next ? next.format($6c1a868478667937$var$FORMAT) : "")
    });
}




var $cQmXV = parcelRequire("cQmXV");





// A survey targets exactly one of points / point_groups / networks (enforced server-side).
// This field shows a single target-type selector plus one multi-select for whichever type is
// active, and clears the other two keys on change so the invalid multi-target combination can
// never be produced from this UI. It writes directly into item.points/point_groups/networks
// rather than into its own "audience" key.
const $ab22bdf68594384e$var$hasValue = (v)=>Array.isArray(v) && v.length > 0;
function $ab22bdf68594384e$export$2e2bcd8739ae039({ item: item = {}, onChange: onChange, lang: lang }) {
    // Hold the active target type in state. Deriving it from item every render made an empty
    // selection (e.g. right after switching to "Point groups") snap back to the default type,
    // so the point_groups/networks dropdowns could never be used.
    const [activeKey, setActiveKey] = (0, $cQmXV.useState)(()=>((0, $fc5e81b33777a483$export$2941c0a502c64c7f).find((t)=>$ab22bdf68594384e$var$hasValue(item[t.key])) || (0, $fc5e81b33777a483$export$2941c0a502c64c7f)[0]).key);
    const active = (0, $fc5e81b33777a483$export$2941c0a502c64c7f).find((t)=>t.key === activeKey) || (0, $fc5e81b33777a483$export$2941c0a502c64c7f)[0];
    const typeLabel = (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ac552071080927b0), "audience_target_type", lang);
    const setTargetType = (key)=>{
        setActiveKey(key);
        (0, $fc5e81b33777a483$export$2941c0a502c64c7f).forEach((t)=>onChange(t.key, t.key === key ? item[t.key] || [] : []));
    };
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
        vertical: true,
        gap: "small",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $872fd39f1285217b$export$2e2bcd8739ae039), {
                "aria-label": typeLabel,
                value: activeKey,
                onChange: setTargetType,
                options: (0, $fc5e81b33777a483$export$2941c0a502c64c7f).map((t)=>({
                        value: t.key,
                        label: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ac552071080927b0), t.labelKey, lang)
                    }))
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b6929c6a194abc34$export$2e2bcd8739ae039), {
                entity: active.entity,
                value: item[active.key] || [],
                isMulti: true,
                extraQuery: {
                    active: true
                },
                ariaLabel: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ac552071080927b0), active.labelKey, lang),
                /* Option OBJECTS, unwrapped to ids by `useResource.saveItem` — see the note there. Storing
           ids here left every chip showing a raw key as soon as the option list moved on. */ onChange: (option)=>onChange(active.key, option)
            })
        ]
    });
}


/* QuestionsField — the survey question repeater, rebuilt on antd to `docs/design/survey-edit.html`.
 *
 * The old version was the last legacy holdout (`mp-form-*`, material icons, native selects). The
 * design is an ACCORDION: each question is a collapsible row that, closed, shows its number, text
 * and a strip of meta tags (required / answer-type-with-icon / priority / targeting summary) plus
 * move + delete controls; open, it reveals the editor — text, type, priority, required, dropdown
 * options (when the type is dropdown), and a collapsible Targeting sub-panel. One question is open
 * at a time.
 *
 * State: the question list is held locally and pushed up through `onChange` on every edit — the
 * position in the list IS the saved `order`. Targeting multi-selects store ids (the payload shape
 * the backend wants); `useResource`'s entity normalisation only walks top-level `descriptor.fields`,
 * not values nested in a `questions` array, so the id-unwrapping is done here.
 */ 

var $cQmXV = parcelRequire("cQmXV");


var $cQmXV = parcelRequire("cQmXV");
var $d6e0086d92ecfee8$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($d6e0086d92ecfee8$exports, "__esModule", {
    value: true
});
var $d6e0086d92ecfee8$var$UnorderedListOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0z"
                }
            }
        ]
    },
    "name": "unordered-list",
    "theme": "outlined"
};
$d6e0086d92ecfee8$exports.default = $d6e0086d92ecfee8$var$UnorderedListOutlined;



function $475b81153edc583f$var$_extends() {
    $475b81153edc583f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $475b81153edc583f$var$_extends.apply(this, arguments);
}
const $475b81153edc583f$var$UnorderedListOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $475b81153edc583f$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d6e0086d92ecfee8$exports)))
    }));
/**![unordered-list](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkxMiAxOTJIMzI4Yy00LjQgMC04IDMuNi04IDh2NTZjMCA0LjQgMy42IDggOCA4aDU4NGM0LjQgMCA4LTMuNiA4LTh2LTU2YzAtNC40LTMuNi04LTgtOHptMCAyODRIMzI4Yy00LjQgMC04IDMuNi04IDh2NTZjMCA0LjQgMy42IDggOCA4aDU4NGM0LjQgMCA4LTMuNiA4LTh2LTU2YzAtNC40LTMuNi04LTgtOHptMCAyODRIMzI4Yy00LjQgMC04IDMuNi04IDh2NTZjMCA0LjQgMy42IDggOCA4aDU4NGM0LjQgMCA4LTMuNiA4LTh2LTU2YzAtNC40LTMuNi04LTgtOHpNMTA0IDIyOGE1NiA1NiAwIDEwMTEyIDAgNTYgNTYgMCAxMC0xMTIgMHptMCAyODRhNTYgNTYgMCAxMDExMiAwIDU2IDU2IDAgMTAtMTEyIDB6bTAgMjg0YTU2IDU2IDAgMTAxMTIgMCA1NiA1NiAwIDEwLTExMiAweiIgLz48L3N2Zz4=) */ const $475b81153edc583f$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($475b81153edc583f$var$UnorderedListOutlined);
var $475b81153edc583f$export$2e2bcd8739ae039 = $475b81153edc583f$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $732dab9dcfc86df0$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($732dab9dcfc86df0$exports, "__esModule", {
    value: true
});
var $732dab9dcfc86df0$var$FilterOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M880.1 154H143.9c-24.5 0-39.8 26.7-27.5 48L349 597.4V838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V597.4L907.7 202c12.2-21.3-3.1-48-27.6-48zM603.4 798H420.6V642h182.9v156zm9.6-236.6l-9.5 16.6h-183l-9.5-16.6L212.7 226h598.6L613 561.4z"
                }
            }
        ]
    },
    "name": "filter",
    "theme": "outlined"
};
$732dab9dcfc86df0$exports.default = $732dab9dcfc86df0$var$FilterOutlined;



function $ca419dbeac73bb65$var$_extends() {
    $ca419dbeac73bb65$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ca419dbeac73bb65$var$_extends.apply(this, arguments);
}
const $ca419dbeac73bb65$var$FilterOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $ca419dbeac73bb65$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($732dab9dcfc86df0$exports)))
    }));
/**![filter](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg4MC4xIDE1NEgxNDMuOWMtMjQuNSAwLTM5LjggMjYuNy0yNy41IDQ4TDM0OSA1OTcuNFY4MzhjMCAxNy43IDE0LjIgMzIgMzEuOCAzMmgyNjIuNGMxNy42IDAgMzEuOC0xNC4zIDMxLjgtMzJWNTk3LjRMOTA3LjcgMjAyYzEyLjItMjEuMy0zLjEtNDgtMjcuNi00OHpNNjAzLjQgNzk4SDQyMC42VjY0MmgxODIuOXYxNTZ6bTkuNi0yMzYuNmwtOS41IDE2LjZoLTE4M2wtOS41LTE2LjZMMjEyLjcgMjI2aDU5OC42TDYxMyA1NjEuNHoiIC8+PC9zdmc+) */ const $ca419dbeac73bb65$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($ca419dbeac73bb65$var$FilterOutlined);
var $ca419dbeac73bb65$export$2e2bcd8739ae039 = $ca419dbeac73bb65$var$RefIcon;






/** Answer-type glyphs (the mockup's `A_TYPE_ICON`, mapped to verified antd icons). */ const $509bf78f41ee3bf0$var$ANSWER_TYPE_ICON = {
    numeric: (0, $33c50e9dcee24ce6$export$2e2bcd8739ae039),
    text: (0, $e86fc63b6cae696a$export$2e2bcd8739ae039),
    photo: (0, $3602cb83fb466795$export$2e2bcd8739ae039),
    dropdown: (0, $475b81153edc583f$export$2e2bcd8739ae039),
    date: (0, $3368c84d60c50017$export$2e2bcd8739ae039),
    boolean: (0, $28c0ad5395372ff7$export$2e2bcd8739ae039)
};
const $509bf78f41ee3bf0$var$emptyQuestion = ()=>({
        text: "",
        answer_type: "text",
        required: false,
        priority: 0,
        question_mode: null,
        products_source: null,
        all_products: false,
        all_brands: false,
        all_categories: false,
        all_subcategories: false,
        products: [],
        brands: [],
        categories: [],
        subcategories: [],
        dropdown_options: []
    });
const $509bf78f41ee3bf0$var$emptyOption = ()=>({
        label: "",
        value: ""
    });
// The list position IS the saved order; reordering re-derives it.
const $509bf78f41ee3bf0$var$withOrder = (list)=>list.map((row, i)=>({
            ...row,
            order: i
        }));
const $509bf78f41ee3bf0$var$byOrder = (list)=>(list || []).slice().sort((a, b)=>(a.order ?? 0) - (b.order ?? 0));
function $509bf78f41ee3bf0$export$2e2bcd8739ae039({ field: field, value: value, onChange: onChange, lang: lang }) {
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ac552071080927b0), key, lang);
    const [questions, setQuestions] = (0, $cQmXV.useState)(()=>$509bf78f41ee3bf0$var$byOrder(value));
    const [active, setActive] = (0, $cQmXV.useState)([]); // the open row(s) — accordion keeps this to one
    const [targetingOpen, setTargetingOpen] = (0, $cQmXV.useState)({});
    /* The exact array last pushed up, so our own echo can be told apart from a genuinely new `value`.
     Reference equality is enough: `withOrder` builds a fresh array every time, and the parent stores
     it unchanged. */ const emitted = (0, $cQmXV.useRef)(null);
    /* ⚠ This has to sync, and it did not. The list was seeded ONCE from `value` with no effect
     watching it and no `key` on the renderer, so a `value` arriving later — the record loading, a
     Cancel restoring the pristine copy, the post-save refetch — was never read. Write-only local
     state cannot recover from that, and worse, it MASKS a server-side drop: the questions stay on
     screen because they are local, so a save that silently persisted none of them looks like it
     worked until the next visit (PICSELL-1574 #27). */ (0, $cQmXV.useEffect)(()=>{
        if (value === emitted.current) return;
        setQuestions($509bf78f41ee3bf0$var$byOrder(value));
    }, [
        value
    ]);
    const sync = (next)=>{
        const ordered = $509bf78f41ee3bf0$var$withOrder(next);
        emitted.current = ordered;
        setQuestions(ordered);
        onChange(field.name, ordered);
    };
    const updateQuestion = (qi, patch)=>sync(questions.map((q, idx)=>idx === qi ? {
                ...q,
                ...patch
            } : q));
    const addQuestion = ()=>{
        const next = [
            ...questions,
            $509bf78f41ee3bf0$var$emptyQuestion()
        ];
        sync(next);
        setActive([
            String(next.length - 1)
        ]); // open the new one
    };
    const removeQuestion = (qi)=>{
        sync(questions.filter((_, idx)=>idx !== qi));
        setActive([]);
    };
    const moveQuestion = (qi, dir)=>{
        const j = qi + dir;
        if (j < 0 || j >= questions.length) return;
        const next = questions.slice();
        [next[qi], next[j]] = [
            next[j],
            next[qi]
        ];
        sync(next);
    };
    const updateOptions = (qi, options)=>updateQuestion(qi, {
            dropdown_options: $509bf78f41ee3bf0$var$withOrder(options)
        });
    const addOption = (qi)=>updateOptions(qi, [
            ...questions[qi].dropdown_options || [],
            $509bf78f41ee3bf0$var$emptyOption()
        ]);
    const removeOption = (qi, oi)=>updateOptions(qi, questions[qi].dropdown_options.filter((_, idx)=>idx !== oi));
    const updateOption = (qi, oi, patch)=>updateOptions(qi, questions[qi].dropdown_options.map((o, idx)=>idx === oi ? {
                ...o,
                ...patch
            } : o));
    /** "All products · 3 brands" — the one-line summary shown on the closed row and the targeting bar. */ const targetSummary = (q)=>{
        const parts = [];
        (0, $fc5e81b33777a483$export$69d5f3de0d42532).forEach((g)=>{
            if (q[g.allKey]) parts.push(t(g.allLabelKey));
            else if ((q[g.key] || []).length) parts.push(`${q[g.key].length} ${t(g.labelKey).toLowerCase()}`);
        });
        return parts.length ? parts.join(" \xb7 ") : null;
    };
    const stop = (e)=>e.stopPropagation();
    const rowHeader = (q, qi)=>{
        const Icon = $509bf78f41ee3bf0$var$ANSWER_TYPE_ICON[q.answer_type] || (0, $e86fc63b6cae696a$export$2e2bcd8739ae039);
        const summary = targetSummary(q);
        const hasText = q.text.trim().length > 0;
        return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
            align: "center",
            gap: 10,
            className: "pt-q__head",
            children: [
                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                    className: "pt-q__n",
                    children: qi + 1
                }),
                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                    strong: true,
                    ellipsis: true,
                    className: hasText ? "pt-q__t" : "pt-q__t pt-q__t--empty",
                    children: hasText ? q.text : t("f_question_text")
                }),
                /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                    className: "pt-q__meta",
                    align: "center",
                    gap: 6,
                    children: [
                        q.required && /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $602120e6d17ff12a$export$2e2bcd8739ae039), {
                            children: t("f_required")
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $602120e6d17ff12a$export$2e2bcd8739ae039), {
                            icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)(Icon, {}),
                            children: t((0, $fc5e81b33777a483$export$81b4e28637de863c)[q.answer_type])
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $602120e6d17ff12a$export$2e2bcd8739ae039), {
                            children: t((0, $fc5e81b33777a483$export$2a8cdb37ef652224)[q.priority])
                        }),
                        summary && /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $602120e6d17ff12a$export$2e2bcd8739ae039), {
                            icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $ca419dbeac73bb65$export$2e2bcd8739ae039), {}),
                            className: "pt-q__tgt",
                            title: `${t("sec_targeting")}: ${summary}`,
                            children: summary
                        })
                    ]
                })
            ]
        });
    };
    const rowExtra = (qi)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
            align: "center",
            gap: 2,
            className: "pt-q__acts",
            onClick: stop,
            children: [
                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                    type: "text",
                    size: "small",
                    icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $a9acaf08b7547d32$export$2e2bcd8739ae039), {}),
                    disabled: qi === 0,
                    "aria-label": t("question_move_up"),
                    title: t("question_move_up"),
                    onClick: (e)=>{
                        stop(e);
                        moveQuestion(qi, -1);
                    }
                }),
                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                    type: "text",
                    size: "small",
                    icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e7119b602540b2c5$export$2e2bcd8739ae039), {}),
                    disabled: qi === questions.length - 1,
                    "aria-label": t("question_move_down"),
                    title: t("question_move_down"),
                    onClick: (e)=>{
                        stop(e);
                        moveQuestion(qi, 1);
                    }
                }),
                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                    type: "text",
                    size: "small",
                    danger: true,
                    icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5234c28d879e38c1$export$2e2bcd8739ae039), {}),
                    "aria-label": t("question_remove_btn"),
                    title: t("question_remove_btn"),
                    onClick: (e)=>{
                        stop(e);
                        removeQuestion(qi);
                    }
                })
            ]
        });
    const questionBody = (q, qi)=>{
        const summary = targetSummary(q);
        return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
            vertical: true,
            gap: "middle",
            className: "pt-q__body",
            children: [
                /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                    className: "pt-qform",
                    children: [
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("label", {
                            className: "pt-qf pt-qf--wide",
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                                    className: "pt-qf__label",
                                    children: [
                                        t("f_question_text"),
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                            className: "pt-req",
                                            children: " *"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0883e7f8083c01b0$export$2e2bcd8739ae039), {
                                    value: q.text,
                                    placeholder: t("f_question_text"),
                                    onChange: (e)=>updateQuestion(qi, {
                                            text: e.target.value
                                        })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("label", {
                            className: "pt-qf",
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                    className: "pt-qf__label",
                                    children: t("f_answer_type")
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $872fd39f1285217b$export$2e2bcd8739ae039), {
                                    value: q.answer_type,
                                    onChange: (v)=>updateQuestion(qi, {
                                            answer_type: v
                                        }),
                                    options: (0, $fc5e81b33777a483$export$cfa61bd69ae51266).map((v)=>({
                                            value: v,
                                            label: t((0, $fc5e81b33777a483$export$81b4e28637de863c)[v])
                                        }))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("label", {
                            className: "pt-qf",
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                    className: "pt-qf__label",
                                    children: t("f_priority")
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $872fd39f1285217b$export$2e2bcd8739ae039), {
                                    value: q.priority,
                                    onChange: (v)=>updateQuestion(qi, {
                                            priority: v
                                        }),
                                    options: (0, $fc5e81b33777a483$export$19868e2467c966ad).map((v)=>({
                                            value: v,
                                            label: t((0, $fc5e81b33777a483$export$2a8cdb37ef652224)[v])
                                        }))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                            className: "pt-qf pt-qf--check",
                            children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $7a650444b7c2c328$export$2e2bcd8739ae039), {
                                checked: !!q.required,
                                onChange: (e)=>updateQuestion(qi, {
                                        required: e.target.checked
                                    }),
                                children: t("f_required")
                            })
                        })
                    ]
                }),
                q.answer_type === "dropdown" && /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                    className: "pt-subsec",
                    children: [
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                            className: "pt-subsec__t",
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $475b81153edc583f$export$2e2bcd8739ae039), {}),
                                " ",
                                t("f_dropdown_options")
                            ]
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                            vertical: true,
                            gap: 6,
                            className: "pt-optlist",
                            children: [
                                (q.dropdown_options || []).map((opt, oi)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                                        className: "pt-optrow",
                                        children: [
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0883e7f8083c01b0$export$2e2bcd8739ae039), {
                                                value: opt.label,
                                                placeholder: t("option_label_ph"),
                                                onChange: (e)=>updateOption(qi, oi, {
                                                        label: e.target.value
                                                    })
                                            }),
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0883e7f8083c01b0$export$2e2bcd8739ae039), {
                                                value: opt.value,
                                                placeholder: t("option_value_ph"),
                                                onChange: (e)=>updateOption(qi, oi, {
                                                        value: e.target.value
                                                    })
                                            }),
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                                type: "text",
                                                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5234c28d879e38c1$export$2e2bcd8739ae039), {}),
                                                "aria-label": t("option_remove"),
                                                onClick: ()=>removeOption(qi, oi)
                                            })
                                        ]
                                    }, oi)),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                        size: "small",
                                        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $fa25166ced813feb$export$2e2bcd8739ae039), {}),
                                        onClick: ()=>addOption(qi),
                                        children: t("option_add_btn")
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                    className: "pt-subsec",
                    children: [
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("button", {
                            type: "button",
                            className: "pt-subsec__toggle",
                            "aria-expanded": !!targetingOpen[qi],
                            onClick: ()=>setTargetingOpen((s)=>({
                                        ...s,
                                        [qi]: !s[qi]
                                    })),
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e7119b602540b2c5$export$2e2bcd8739ae039), {
                                    className: `pt-subsec__chev${targetingOpen[qi] ? " pt-subsec__chev--open" : ""}`
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                    children: t("sec_targeting")
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                    className: "pt-subsec__sum",
                                    children: summary || t("all_answers")
                                })
                            ]
                        }),
                        targetingOpen[qi] && /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                            vertical: true,
                            gap: "middle",
                            className: "pt-q__targeting",
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                                    className: "pt-qform",
                                    children: [
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("label", {
                                            className: "pt-qf",
                                            children: [
                                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                                    className: "pt-qf__label",
                                                    children: t("f_question_mode")
                                                }),
                                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $872fd39f1285217b$export$2e2bcd8739ae039), {
                                                    allowClear: true,
                                                    value: q.question_mode || undefined,
                                                    placeholder: "\u2014",
                                                    onChange: (v)=>updateQuestion(qi, {
                                                            question_mode: v || null
                                                        }),
                                                    options: (0, $fc5e81b33777a483$export$83a015f6589bb8cf).map((v)=>({
                                                            value: v,
                                                            label: t((0, $fc5e81b33777a483$export$4ed51751d1746b72)[v])
                                                        }))
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("label", {
                                            className: "pt-qf",
                                            children: [
                                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                                    className: "pt-qf__label",
                                                    children: t("f_products_source")
                                                }),
                                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $872fd39f1285217b$export$2e2bcd8739ae039), {
                                                    allowClear: true,
                                                    value: q.products_source || undefined,
                                                    placeholder: "\u2014",
                                                    onChange: (v)=>updateQuestion(qi, {
                                                            products_source: v || null
                                                        }),
                                                    options: (0, $fc5e81b33777a483$export$be5830653d73dd2d).map((v)=>({
                                                            value: v,
                                                            label: t((0, $fc5e81b33777a483$export$724501524e89eac8)[v])
                                                        }))
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                    vertical: true,
                                    gap: "small",
                                    children: (0, $fc5e81b33777a483$export$69d5f3de0d42532).map((g)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                                            className: "pt-tgroup__r",
                                            children: [
                                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $7a650444b7c2c328$export$2e2bcd8739ae039), {
                                                    checked: !!q[g.allKey],
                                                    onChange: (e)=>updateQuestion(qi, {
                                                            [g.allKey]: e.target.checked,
                                                            ...e.target.checked ? {
                                                                [g.key]: []
                                                            } : null
                                                        }),
                                                    children: t(g.allLabelKey)
                                                }),
                                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("label", {
                                                    className: "pt-qf",
                                                    children: [
                                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                                            className: "pt-qf__label",
                                                            children: t(g.labelKey)
                                                        }),
                                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b6929c6a194abc34$export$2e2bcd8739ae039), {
                                                            entity: g.entity,
                                                            value: q[g.key] || [],
                                                            isMulti: true,
                                                            tall: true,
                                                            disabled: !!q[g.allKey],
                                                            extraQuery: {
                                                                active: true
                                                            },
                                                            ariaLabel: t(g.labelKey),
                                                            /* Stores option OBJECTS, not ids. Flattening to ids here made the field
                           permanently dependent on whatever page of options happened to be loaded
                           for its labels, so every chip read as a bare number once the list moved
                           on (PICSELL-1574 #22). `useResource.saveItem` unwraps these to ids for the
                           payload — an object can name itself, an id cannot. */ onChange: (o)=>updateQuestion(qi, {
                                                                    [g.key]: o
                                                                })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, g.key))
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    const items = questions.map((q, qi)=>({
            key: String(qi),
            label: rowHeader(q, qi),
            extra: rowExtra(qi),
            children: questionBody(q, qi)
        }));
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
        vertical: true,
        gap: "middle",
        children: [
            questions.length ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $23bd4bba91b7ee72$export$2e2bcd8739ae039), {
                /* `pt-qlist` exists to out-specify one antd rule — see `.pt-qlist … .ant-collapse-title`
             in `style.scss`. */ className: "pt-qlist",
                accordion: true,
                activeKey: active,
                onChange: (keys)=>setActive(keys),
                /* The header and chevron toggle; the move/delete controls in `extra` stop propagation
             (see `rowExtra`), so they act without opening/closing the panel. */ items: items
            }) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $99350450b877904c$export$2e2bcd8739ae039), {
                image: (0, $99350450b877904c$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE,
                description: t("no_questions")
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                    icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $fa25166ced813feb$export$2e2bcd8739ae039), {}),
                    onClick: addQuestion,
                    children: t("question_add_btn")
                })
            })
        ]
    });
}


const $ae419e9c69a502cf$export$810990d4fe683121 = {
    text: (0, $8ab0a5ff7c5b526c$export$2e2bcd8739ae039),
    number: (0, $2ec2d0e23c24ce52$export$2e2bcd8739ae039),
    textarea: (0, $c63a8eb75f76f029$export$2e2bcd8739ae039),
    checkbox: (0, $7391c7def2587363$export$2e2bcd8739ae039),
    select: (0, $3f35eb033bcc08a0$export$2e2bcd8739ae039),
    entity: (0, $bb83f1a52e933cf8$export$2e2bcd8739ae039),
    coordinate: (0, $9ca4377bf068c205$export$2e2bcd8739ae039),
    chips: (0, $b726eec519e5aa1c$export$2e2bcd8739ae039),
    location: (0, $7a4a9b6d201c3830$export$2e2bcd8739ae039),
    image: (0, $28744222778d38c2$export$2e2bcd8739ae039),
    keyvalue: (0, $7c1dda5e4574a6ab$export$2e2bcd8739ae039),
    datetime: (0, $6c1a868478667937$export$2e2bcd8739ae039),
    audience: (0, $ab22bdf68594384e$export$2e2bcd8739ae039),
    questions: (0, $509bf78f41ee3bf0$export$2e2bcd8739ae039)
};
function $ae419e9c69a502cf$export$49e47a0ff457b5eb(field) {
    switch(field.type){
        case "checkbox":
            return false;
        case "number":
            return null;
        case "chips":
            return [];
        case "entity":
            return field.isMulti ? [] : null;
        case "coordinate":
            return null;
        case "location":
            return null;
        case "image":
            return null;
        case "keyvalue":
            return {};
        case "datetime":
            return "";
        case "audience":
            return null;
        case "questions":
            return [];
        default:
            return "";
    }
}




/** The card's head — a title and, when the section declares one, a one-line description
 *  (profile's `pf-card__head`). */ function $4be72c690417f76e$var$SectionHeader({ title: title, desc: desc }) {
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
        className: "dp-sec-head",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("h2", {
                className: "dp-sec-title",
                children: title
            }),
            desc ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("p", {
                className: "dp-sec-desc",
                children: desc
            }) : null
        ]
    });
}
/** Group a descriptor's fields by its `sections`, resolving field names, the section label and its
 *  optional `desc` key. Falls back to one untitled group when a descriptor declares no sections. */ function $4be72c690417f76e$var$groupBySection(descriptor, lang) {
    const byName = {};
    (descriptor.fields || []).forEach((field)=>{
        byName[field.name] = field;
    });
    if (Array.isArray(descriptor.sections) && descriptor.sections.length) return descriptor.sections.map((section)=>({
            key: section.title,
            title: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ac552071080927b0), section.title, lang) || section.title,
            desc: section.desc ? (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ac552071080927b0), section.desc, lang) || section.desc : null,
            fields: section.fields.map((name)=>byName[name]).filter(Boolean)
        }));
    return [
        {
            key: null,
            title: null,
            desc: null,
            fields: descriptor.fields || []
        }
    ];
}
function $4be72c690417f76e$var$FieldItem({ field: field, item: item, errors: errors, onChange: onChange, lang: lang, labels: labels }) {
    const Renderer = (0, $ae419e9c69a502cf$export$810990d4fe683121)[field.type];
    if (!Renderer) return null;
    const label = (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ac552071080927b0), field.label, lang) || field.label;
    const error = errors[field.name];
    return(/* `data-field` is how a failed save finds the first invalid control to focus
       (spec/03#failed-save) — antd's own field store is not in play here. A `wide` field (or a
       tall one, like the point list) spans the whole grid row; the rest tile. */ /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
        "data-field": field.name,
        className: field.wide || field.tall ? "pt-field pt-field--wide" : "pt-field",
        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
            /* A checkbox names itself beside the box, so the real label is suppressed — but the row is
           kept as a non-breaking-space spacer, not dropped, so the box lines up with labelled
           fields around it. */ label: field.type === "checkbox" ? " " : label,
            required: !!field.required,
            validateStatus: error ? "error" : undefined,
            help: error || undefined,
            children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)(Renderer, {
                field: {
                    ...field,
                    _label: label
                },
                value: item[field.name],
                item: item,
                lang: lang,
                labels: labels,
                onChange: onChange,
                error: error
            })
        })
    }));
}
function $4be72c690417f76e$export$2e2bcd8739ae039({ descriptor: descriptor, item: item, errors: errors = {}, onChange: onChange, lang: lang }) {
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ac552071080927b0), key, lang);
    const labels = {
        lat: t("f_lat"),
        lng: t("f_lng"),
        pickImage: t("pick_image"),
        removeImage: t("remove_image"),
        crop: t("crop_confirm"),
        cropConfirm: t("crop_confirm"),
        cropCancel: t("crop_cancel"),
        cropTitle: t("crop_title"),
        cropSize: t("crop_size"),
        cropPreview: t("crop_preview"),
        cropArea: t("crop_area"),
        cropHint: t("crop_hint")
    };
    const ctx = {
        item: item,
        errors: errors,
        onChange: onChange,
        lang: lang,
        labels: labels
    };
    /* `heroField` (points → `location`) is hoisted to a headerless hero card at the top of the form
     and dropped from its normal section, so the map leads the edit page. Optional. */ const heroName = descriptor.heroField;
    const heroField = heroName ? (descriptor.fields || []).find((f)=>f.name === heroName) : null;
    const sections = $4be72c690417f76e$var$groupBySection(descriptor, lang).map((section)=>({
            ...section,
            fields: section.fields.filter((f)=>f.name !== heroName)
        })).filter((section)=>section.fields.length);
    return(/* Large controls, profile-style — scoped here so the page's own chrome (head, save bar) keeps
       the default size. */ /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5764e43cf38ca965$export$2e2bcd8739ae039), {
        componentSize: "large",
        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039), {
            layout: "vertical",
            component: false,
            colon: false,
            requiredMark: true,
            children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                vertical: true,
                gap: "middle",
                className: "dp-form",
                children: [
                    heroField && /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b4fda840b736e640$export$2e2bcd8739ae039), {
                        className: "dp-section pt-herocard",
                        variant: "outlined",
                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($4be72c690417f76e$var$FieldItem, {
                            field: heroField,
                            ...ctx
                        })
                    }),
                    sections.map((section, index)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b4fda840b736e640$export$2e2bcd8739ae039), {
                            className: "dp-section",
                            variant: "outlined",
                            title: section.title ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($4be72c690417f76e$var$SectionHeader, {
                                title: section.title,
                                desc: section.desc
                            }) : undefined,
                            children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                                className: "pt-fieldgrid",
                                children: section.fields.map((field)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($4be72c690417f76e$var$FieldItem, {
                                        field: field,
                                        ...ctx
                                    }, field.name))
                            })
                        }, section.key || index))
                ]
            })
        })
    }));
}










/* The dirty signature, not a plain `JSON.stringify`: an image field holds a `File`, which
   serialises to `{}` — so picking a new logo on an existing record left the form looking pristine
   and Save disabled. */ const $bbfa4fbd0e8cac16$var$signature = (item)=>JSON.stringify(item, (key, value)=>typeof File !== "undefined" && value instanceof File ? `File:${value.name}:${value.size}:${value.lastModified}` : value);
const $bbfa4fbd0e8cac16$var$seed = (descriptor)=>{
    const item = {};
    descriptor.fields.forEach((f)=>{
        item[f.name] = (0, $ae419e9c69a502cf$export$49e47a0ff457b5eb)(f);
    });
    return item;
};
const $bbfa4fbd0e8cac16$var$isEmpty = (v)=>v === null || v === undefined || v === "" || Array.isArray(v) && !v.length;
class $bbfa4fbd0e8cac16$export$2e2bcd8739ae039 extends (0, $cQmXV.Component) {
    constructor(props){
        super(props);
        this.state = {
            mode: "VIEW",
            isNew: false,
            item: {},
            errors: {},
            saving: false,
            pristine: "{}"
        };
        this.original = {};
    }
    get me() {
        return this.props.currentUser || (0, $81aca8a46f6ecb51$export$6fec604aa7293d0c)().getState().me;
    }
    get lang() {
        return this.me.language;
    }
    get listPath() {
        return "/" + this.props.descriptor.slug;
    }
    t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ac552071080927b0), key, this.lang);
    fieldLabel = (field)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ac552071080927b0), field.label, this.lang) || field.label;
    /* A data-quality issue reads as a sentence, in the rail and under the field alike — the mockup's
     "Name is required", not a red copy of the label the user is already looking at. */ requiredText = (field)=>(0, $3b579ca6158bc61b$export$9563e054e6f787fb)(this.t("q_required"), {
            f: this.fieldLabel(field)
        });
    leave = ()=>this.props.history.replace(this.listPath);
    componentDidMount() {
        this._isMounted = true;
        const { id: id } = this.props.match.params;
        const { descriptor: descriptor } = this.props;
        if (id === "new") this.setBaseline($bbfa4fbd0e8cac16$var$seed(descriptor), {
            mode: "EDIT",
            isNew: true
        });
        else (0, $da70838858bfad8a$export$78af959256a39335)(descriptor, id, (item)=>this.setBaseline(item || {}));
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    safeSetState = (...args)=>{
        if (this._isMounted) this.setState(...args);
    };
    /** Whatever the server last confirmed becomes both baselines and the current item. */ setBaseline = (item, extra = {})=>{
        this.original = structuredClone(item);
        if (this._isMounted) this.setState({
            item: item,
            pristine: $bbfa4fbd0e8cac16$var$signature(item),
            errors: {},
            ...extra
        });
    };
    get dirty() {
        return $bbfa4fbd0e8cac16$var$signature(this.state.item) !== this.state.pristine;
    }
    get canSave() {
        return this.state.isNew ? true : this.dirty;
    }
    /** The required fields this record has not filled in — the rail's Data quality list. */ get missing() {
        return (this.props.descriptor.fields || []).filter((f)=>f.required && $bbfa4fbd0e8cac16$var$isEmpty(this.state.item[f.name]));
    }
    onChange = (name, value)=>{
        this.setState((s)=>({
                item: {
                    ...s.item,
                    [name]: value
                },
                errors: {
                    ...s.errors,
                    [name]: undefined
                }
            }));
    };
    /* The re-render after a failed save detaches whatever had focus, so focus goes to the field the
     user has to fix — `data-field` is set by ResourceForm. */ focusField = (name)=>{
        if (!name || typeof document === "undefined") return;
        const host = document.querySelector(`[data-field="${name}"]`);
        if (!host) return;
        host.scrollIntoView({
            block: "center",
            behavior: "smooth"
        });
        const control = host.querySelector("input, textarea, .ant-select-selector");
        if (control && control.focus) control.focus();
    };
    submit = ()=>{
        const { descriptor: descriptor } = this.props;
        const { item: item } = this.state;
        const wasNew = !item.id;
        const errors = {};
        this.missing.forEach((f)=>{
            errors[f.name] = this.requiredText(f);
        });
        if (Object.keys(errors).length) {
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).warning(this.t("fix_first"), {
                position: "top-right"
            });
            this.setState({
                errors: errors
            }, ()=>this.focusField(Object.keys(errors)[0]));
            return;
        }
        this.setState({
            saving: true
        });
        (0, $da70838858bfad8a$export$488773977679fb92)(descriptor, item, this.me, (r)=>{
            if (r && r.id) {
                (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success(this.t("saved"), {
                    position: "top-right"
                });
                /* Refetch rather than trust the write response, exactly as `runRemove` and `activate` do:
           the write serializer returns FK/M2M as BARE IDS, so seeding the form from `r` made every
           entity select and every nested field render its id — "10", "11" where names had been —
           until the page was reloaded (PICSELL-1574 #22, #34). `submit` was the one lifecycle action
           still missing this. A refetch also means the form shows what the server actually stored,
           which is how a silently-dropped nested field becomes visible instead of staying hidden
           behind optimistic local state. */ this.setBaseline(r, {
                    mode: "VIEW",
                    isNew: false,
                    saving: false
                });
                (0, $da70838858bfad8a$export$78af959256a39335)(descriptor, r.id, (it)=>it && it.id && this.setBaseline(it));
                if (wasNew) this.props.history.replace(`${this.listPath}/${r.id}`);
            } else if (r && typeof r.json === "function") /* A 400 comes back as the raw Response (see action.js) — its body is the field errors. */ (0, $c9936523dc38c641$export$45fc6b2d335e3c39)(r).then((parsed)=>{
                this.safeSetState({
                    errors: parsed.fields,
                    saving: false
                }, ()=>this.focusField(Object.keys(parsed.fields)[0]));
                (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).warning(parsed.message || this.t("save_error"), {
                    position: "top-right"
                });
            });
            else {
                this.safeSetState({
                    saving: false
                });
                (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).warning(this.t("save_error"), {
                    position: "top-right"
                });
            }
        });
    };
    /* Cancel reverts from the CLONE, never from the serialised baseline. Leaving a dirty form asks
     first — the design's `discard_confirm`. */ cancel = ()=>{
        if (this.state.isNew) {
            this.props.history.replace(this.listPath);
            return;
        }
        if (!this.dirty) {
            this.setState({
                mode: "VIEW",
                errors: {}
            });
            return;
        }
        (0, $05a90c67d3627fd9$export$2e2bcd8739ae039).confirm({
            title: this.t("discard_confirm"),
            okText: this.t("view_btn"),
            okButtonProps: {
                danger: true
            },
            cancelText: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f544127b46daf517), "cancel", this.lang),
            onOk: ()=>this.setBaseline(structuredClone(this.original), {
                    mode: "VIEW"
                })
        });
    };
    /** Archive (DELETE, flips `is_removed`) or deactivate (PATCH one flag) — never conflated. */ remove = ()=>{
        const deact = (0, $da70838858bfad8a$export$13b0757be3ff9c68)(this.props.descriptor);
        const archiving = !deact || deact.via === "delete";
        (0, $05a90c67d3627fd9$export$2e2bcd8739ae039).confirm({
            title: archiving ? this.t("confirm_archive") : this.t("confirm_deactivate"),
            content: this.recordTitle,
            okText: this.t(deact ? archiving ? "archive_btn" : "deactivate_btn" : "delete_btn"),
            okButtonProps: {
                danger: true
            },
            /* `Modal.confirm` renders outside the tree, so it does not inherit AppShell's
         `ConfigProvider locale` — without this the buttons stay English. */ cancelText: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f544127b46daf517), "cancel", this.lang),
            onOk: ()=>this.runRemove(deact)
        });
    };
    runRemove = (deact)=>{
        const { descriptor: descriptor } = this.props;
        const { item: item } = this.state;
        if (deact && deact.via === "patch") {
            (0, $da70838858bfad8a$export$43fc4be2c4b87d49)(descriptor, item.id, {
                [deact.field]: deact.inactiveValue
            }, (r)=>{
                if (r && r.id) {
                    (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success(this.t("deleted"), {
                        position: "top-right"
                    });
                    // The write serializer returns FK/M2M as bare ids; refetch so nested objects (names)
                    // render instead of raw ids, without needing a page refresh.
                    (0, $da70838858bfad8a$export$78af959256a39335)(descriptor, item.id, (it)=>this.setBaseline(it || r));
                } else (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).warning(this.t("save_error"), {
                    position: "top-right"
                });
            });
            return;
        }
        (0, $da70838858bfad8a$export$8d8542dbbc23fe1a)(descriptor, item.id, (ok)=>{
            if (!ok) {
                (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).warning(this.t("save_error"), {
                    position: "top-right"
                });
                return;
            }
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success(this.t("deleted"), {
                position: "top-right"
            });
            /* An ARCHIVED record still exists and can be restored, so the page stays open on it. A
         hard-deleted one does not, so there is nothing left to show. */ if (deact) (0, $da70838858bfad8a$export$78af959256a39335)(descriptor, item.id, (it)=>this.setBaseline(it || item));
            else this.props.history.replace(this.listPath);
        });
    };
    activate = ()=>{
        const { descriptor: descriptor } = this.props;
        const deact = (0, $da70838858bfad8a$export$13b0757be3ff9c68)(descriptor);
        if (!deact) return;
        (0, $da70838858bfad8a$export$43fc4be2c4b87d49)(descriptor, this.state.item.id, {
            [deact.field]: deact.activeValue
        }, (r)=>{
            if (r && r.id) {
                (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success(this.t("saved"), {
                    position: "top-right"
                });
                // Refetch so FK/M2M fields come back as nested objects (names), not bare ids.
                (0, $da70838858bfad8a$export$78af959256a39335)(descriptor, this.state.item.id, (it)=>this.setBaseline(it || r));
            } else (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).warning(this.t("save_error"), {
                position: "top-right"
            });
        });
    };
    get recordTitle() {
        const { item: item, isNew: isNew } = this.state;
        if (isNew) return this.t("new_btn");
        return item.name || item.title || (item.id != null ? `#${item.id}` : "");
    }
    /* --------------------------------------------------------------- pieces */ /** The soft warnings the descriptor declares whose condition is currently true (a real gap that
   *  does not block Save the way a required field does). */ get warnings() {
        const { item: item } = this.state;
        return (this.props.descriptor.warnings || []).filter((w)=>w.when(item));
    }
    /** The rail, /profile-style: an id card (logo/tile + name + status), an account-facts list
   *  (metrics + created), and a data-quality card. All derived from the descriptor. */ renderRail() {
        const { descriptor: descriptor } = this.props;
        const { item: item, isNew: isNew } = this.state;
        const deact = (0, $da70838858bfad8a$export$13b0757be3ff9c68)(descriptor);
        const off = !isNew && deact && (0, $da70838858bfad8a$export$bb7ceb464758d5fe)(item, deact);
        const archiving = !deact || deact.via === "delete";
        const errors = this.missing;
        const warnings = this.warnings;
        const imageField = (descriptor.fields || []).find((f)=>f.type === "image");
        const logoSrc = imageField && typeof item[imageField.name] === "string" && item[imageField.name] ? item[imageField.name] : null;
        /* A descriptor can override the shared initials avatar with a tinted 2-letter tile — points
       hues it by network. `identityLogo` returns `{ text, hue }`. */ const tile = !logoSrc && typeof descriptor.identityLogo === "function" ? descriptor.identityLogo(item) : null;
        /* Facts = the descriptor's metrics (Visits / Last visit) then the record's own facts. */ const facts = [];
        if (!isNew) (descriptor.metrics || []).forEach((m)=>facts.push({
                key: m.key,
                label: this.t(m.labelKey),
                value: m.value(item, this.lang)
            }));
        if (item.code) facts.push({
            key: "code",
            label: this.t("f_code"),
            value: item.code
        });
        if (item.created) facts.push({
            key: "created",
            label: this.t("created_at"),
            value: (0, $b79edb411f97c469$export$236fe9b998ba9793)(item)
        });
        return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("aside", {
            className: "dp-rail",
            children: [
                !isNew && /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("section", {
                    className: "dp-card pt-idcard",
                    children: [
                        tile ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                            className: "pt-logo pt-logo--lg",
                            style: {
                                "--h": tile.hue
                            },
                            "aria-hidden": true,
                            children: tile.text
                        }) : /* Initials, photo preferred — never an `icon` prop (it would short-circuit the
               initials; see `table-cells.js`). */ /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $72b7444d01b36e98$export$2e2bcd8739ae039), {
                            shape: "square",
                            size: 72,
                            src: logoSrc,
                            className: "pt-idcard__logo",
                            style: {
                                fontSize: 24
                            },
                            children: (0, $66539b2560a58e4e$export$f6a098653d630c23)(this.recordTitle)
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                            className: "pt-idcard__name",
                            children: this.recordTitle
                        }),
                        off ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                            className: "pt-badge pt-badge--off",
                            children: this.t(archiving ? "archived" : "inactive")
                        }) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                            className: "pt-badge pt-badge--ok",
                            children: this.t("active")
                        })
                    ]
                }),
                facts.length > 0 && /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("section", {
                    className: "dp-card",
                    children: [
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                            className: "dp-sec-head",
                            children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("h2", {
                                className: "dp-sec-title",
                                children: this.t("summary")
                            })
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("ul", {
                            className: "pt-facts",
                            children: facts.map((f)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                            className: "pt-facts__k",
                                            children: f.label
                                        }),
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                            className: "pt-facts__v",
                                            children: f.value
                                        })
                                    ]
                                }, f.key))
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("section", {
                    className: "dp-card",
                    children: [
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                            className: "dp-sec-head",
                            children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("h2", {
                                className: "dp-sec-title",
                                children: this.t("data_quality")
                            })
                        }),
                        errors.length || warnings.length ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                            vertical: true,
                            align: "flex-start",
                            gap: 2,
                            children: [
                                errors.map((field)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                        type: "link",
                                        size: "small",
                                        className: "pt-issue pt-issue--err",
                                        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $798c0df65ce199b6$export$2e2bcd8739ae039), {}),
                                        onClick: ()=>this.focusField(field.name),
                                        children: this.requiredText(field)
                                    }, field.name)),
                                warnings.map((w)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                        type: "link",
                                        size: "small",
                                        className: "pt-issue pt-issue--warn",
                                        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $8c4bbfcbcade090a$export$2e2bcd8739ae039), {}),
                                        onClick: ()=>this.focusField(w.field),
                                        children: this.t(w.labelKey)
                                    }, w.key))
                            ]
                        }) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                            align: "center",
                            gap: 8,
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $45839ed7c4a7faa2$export$2e2bcd8739ae039), {
                                    className: "pt-ok-icon"
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                    type: "secondary",
                                    children: this.t("q_complete")
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
    render() {
        const { descriptor: descriptor } = this.props;
        const { item: item, isNew: isNew, errors: errors, saving: saving } = this.state;
        const deact = (0, $da70838858bfad8a$export$13b0757be3ff9c68)(descriptor);
        /* No view/edit toggle: the detail page is ALWAYS an open form. Save is dirty-driven, in the
       bottom bar. (There used to be a `descriptor.readOnly` branch rendering a `<Descriptions>`
       view plus `descriptor.detailPanel` — no descriptor ever set the flag, so neither could
       render; both were deleted rather than left as a second layout to keep in sync.) */ const off = !isNew && deact && (0, $da70838858bfad8a$export$bb7ceb464758d5fe)(item, deact);
        const archiving = !deact || deact.via === "delete";
        /* The bottom save bar exists only while there is something to save — an unsaved edit or a new
       draft. Profile's signature element. */ const showSavebar = isNew || this.dirty;
        return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
            className: "shell-content",
            children: [
                /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                    className: "dp-head",
                    children: [
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                            className: "dp-head__main",
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $acdea7eebf8fd4fd$export$2e2bcd8739ae039), {
                                    items: [
                                        {
                                            title: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Link, {
                                                onClick: ()=>this.leave(),
                                                children: this.t(descriptor.titleKey)
                                            })
                                        },
                                        {
                                            title: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("strong", {
                                                children: this.recordTitle
                                            })
                                        }
                                    ]
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                                    className: "dp-head__titlerow",
                                    children: [
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("h1", {
                                            className: "dp-title",
                                            children: this.recordTitle
                                        }),
                                        off && /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $602120e6d17ff12a$export$2e2bcd8739ae039), {
                                            className: "dp-tag--off",
                                            children: this.t(archiving ? "archived" : "inactive")
                                        })
                                    ]
                                })
                            ]
                        }),
                        !isNew && /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $eb1133c43d00490b$export$2e2bcd8739ae039), {
                            size: 8,
                            wrap: true,
                            children: off ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $89531e4b0315317b$export$2e2bcd8739ae039), {}),
                                onClick: this.activate,
                                children: this.t(archiving ? "restore_btn" : "activate_btn")
                            }) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                danger: true,
                                icon: deact ? archiving ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $268dc9f9b8c7fd21$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e539a200877e5e8f$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5234c28d879e38c1$export$2e2bcd8739ae039), {}),
                                onClick: this.remove,
                                children: this.t(deact ? archiving ? "archive_btn" : "deactivate_btn" : "delete_btn")
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                    className: "dp-grid",
                    children: [
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                            className: "dp-main",
                            children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $4be72c690417f76e$export$2e2bcd8739ae039), {
                                descriptor: descriptor,
                                item: item,
                                errors: errors,
                                onChange: this.onChange,
                                lang: this.lang
                            })
                        }),
                        this.renderRail(),
                        showSavebar && /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                            className: "dp-savebar pt-savebar",
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                                    className: "dp-savebar__msg",
                                    children: [
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $1141984d2e96fc67$export$2e2bcd8739ae039), {}),
                                        isNew ? this.t("draft") : this.t("unsaved")
                                    ]
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                                    className: "dp-savebar__acts",
                                    children: [
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                            type: "text",
                                            onClick: this.cancel,
                                            disabled: saving,
                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f544127b46daf517), "cancel", this.lang)
                                        }),
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                            type: "primary",
                                            icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $7f0f32b5e0f33a0e$export$2e2bcd8739ae039), {}),
                                            loading: saving,
                                            disabled: !this.canSave,
                                            onClick: this.submit,
                                            children: isNew ? this.t("create_btn") : this.t("save_btn")
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
}



var $cQmXV = parcelRequire("cQmXV");
var $eb2083f4ff5cb21c$export$2e2bcd8739ae039 = {
    slug: "networks",
    endpoint: "networks/",
    titleKey: "networks_title",
    subtitleKey: "networks_sub",
    columns: [
        {
            label: "f_logo",
            format: (row)=>row.image ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("img", {
                    src: row.image,
                    className: "pt-image-thumb",
                    alt: ""
                }) : "\u2014"
        },
        {
            field: "name",
            label: "f_name"
        },
        {
            field: "code",
            label: "f_code"
        }
    ],
    fields: [
        {
            name: "image",
            type: "image",
            label: "f_logo",
            wide: true
        },
        {
            name: "name",
            type: "text",
            label: "f_name",
            required: true
        },
        {
            name: "code",
            type: "text",
            label: "f_code"
        }
    ],
    injectOnCreate: (item, me)=>({
            ...item,
            company: me && me.company ? me.company.id : null
        }),
    softDelete: true
};


var $d76a7d555b424545$export$2e2bcd8739ae039 = {
    slug: "countries",
    endpoint: "countries/",
    titleKey: "countries_title",
    subtitleKey: "countries_sub",
    columns: [
        {
            field: "name",
            label: "f_name"
        }
    ],
    fields: [
        {
            name: "name",
            type: "text",
            label: "f_name",
            required: true
        }
    ],
    injectOnCreate: (item, me)=>({
            ...item,
            company: me && me.company ? me.company.id : null
        }),
    softDelete: true
};


const $d2380bc640409603$var$countyCountry = (row)=>row.country && row.country.name || "\u2014";
var $d2380bc640409603$export$2e2bcd8739ae039 = {
    slug: "counties",
    endpoint: "counties/",
    titleKey: "counties_title",
    subtitleKey: "counties_sub",
    columns: [
        {
            field: "name",
            label: "f_name"
        },
        {
            label: "f_country",
            format: $d2380bc640409603$var$countyCountry
        }
    ],
    filters: [
        {
            name: "country",
            entity: "countries"
        }
    ],
    fields: [
        {
            name: "name",
            type: "text",
            label: "f_name",
            required: true
        },
        {
            name: "country",
            type: "entity",
            entity: "countries",
            label: "f_country",
            required: true,
            query: {
                active: true
            }
        }
    ],
    softDelete: true
};


const $142d23eb1e534931$var$localityCounty = (row)=>row.county && row.county.name || "\u2014";
var $142d23eb1e534931$export$2e2bcd8739ae039 = {
    slug: "localities",
    endpoint: "localities/",
    titleKey: "localities_title",
    subtitleKey: "localities_sub",
    columns: [
        {
            field: "name",
            label: "f_name"
        },
        {
            label: "f_county",
            format: $142d23eb1e534931$var$localityCounty
        }
    ],
    filters: [
        {
            name: "county",
            entity: "county",
            label: "f_county",
            defaultRegion: true
        }
    ],
    fields: [
        {
            name: "name",
            type: "text",
            label: "f_name",
            required: true
        },
        {
            name: "county",
            type: "entity",
            entity: "county",
            label: "f_county",
            required: true
        },
        {
            name: "additional_info",
            type: "keyvalue",
            label: "f_additional_info",
            wide: true
        }
    ],
    softDelete: true
};



const $b7158dc819ea8c2e$var$yesNo = (row)=>row.price_monitoring ? "\u2713" : "\u2014";
var $b7158dc819ea8c2e$export$2e2bcd8739ae039 = {
    slug: "categories",
    endpoint: "categories_point/",
    titleKey: "categories_title",
    subtitleKey: "categories_sub",
    columns: [
        {
            field: "name",
            label: "f_name"
        },
        {
            label: "f_price_monitoring",
            format: $b7158dc819ea8c2e$var$yesNo
        }
    ],
    fields: [
        {
            name: "name",
            type: "text",
            label: "f_name",
            required: true
        },
        {
            name: "price_monitoring",
            type: "checkbox",
            label: "f_price_monitoring"
        },
        {
            name: "price_monitoring_components",
            type: "chips",
            label: "f_pm_components",
            options: (0, $6f1c09625235f1f0$export$9fa78f64b50a636c)
        },
        {
            name: "price_monitoring_required_components",
            type: "chips",
            label: "f_pm_required",
            options: (0, $6f1c09625235f1f0$export$9fa78f64b50a636c)
        },
        {
            name: "send_to_outforz",
            type: "checkbox",
            label: "f_send_outforz"
        },
        {
            name: "is_auto_approve_price_monitoring_reports",
            type: "checkbox",
            label: "f_auto_approve"
        },
        {
            name: "status_to_send_to_outforz",
            type: "select",
            label: "f_status_outforz",
            options: (0, $6f1c09625235f1f0$export$18af5ff50af8d1b5)
        },
        {
            name: "default_tags",
            type: "entity",
            entity: "tags",
            isMulti: true,
            label: "f_default_tags",
            wide: true
        }
    ],
    /* Grouped rather than a flat 3-column grid: the checkboxes and their dependent multi-selects read
     as scattered otherwise. Price-monitoring config together, the Outforz integration together. */ sections: [
        {
            title: "sec_basic",
            fields: [
                "name",
                "default_tags"
            ]
        },
        {
            title: "sec_price_monitoring",
            fields: [
                "price_monitoring",
                "price_monitoring_components",
                "price_monitoring_required_components",
                "is_auto_approve_price_monitoring_reports"
            ]
        },
        {
            title: "sec_integration",
            fields: [
                "send_to_outforz",
                "status_to_send_to_outforz"
            ]
        }
    ],
    injectOnCreate: (item, me)=>({
            ...item,
            company: me && me.company ? me.company.id : null
        }),
    /* ⚠ Depends on the picsell-api change that makes `Category` a `SoftDeletableModel` (migration
     0052) — before it, DELETE on a category was a HARD delete: the row was destroyed, and
     `Point.category` being SET_NULL meant every point silently lost its category. Migration 0051
     gave the other four reference models `is_removed` and skipped this one. */ softDelete: true
};




/* Network name → a stable hue, so the identity tile is the same colour every time a point of that
   network is opened (the mockup's `--h` from `netHue`). A plain char-sum hash is enough — it only
   needs to be deterministic and spread, not cryptographic. */ const $557b82e5c7a8bf8a$var$hueOf = (name)=>{
    const s = String(name || "");
    let h = 0;
    for(let i = 0; i < s.length; i++)h = (h * 31 + s.charCodeAt(i)) % 360;
    return h;
};
const $557b82e5c7a8bf8a$var$networkLabel = (item)=>item.network && typeof item.network === "object" ? item.network.name : "";
var $557b82e5c7a8bf8a$export$2e2bcd8739ae039 = {
    slug: "points",
    endpoint: "points/",
    titleKey: "points_title",
    subtitleKey: "points_sub",
    columns: [
        {
            label: "f_network",
            format: (row)=>(0, $b79edb411f97c469$export$c2dc1fe4fd2f6ef2)(null, row)
        },
        {
            field: "name",
            label: "f_name"
        },
        {
            field: "address",
            label: "f_address"
        },
        {
            field: "code",
            label: "f_code"
        },
        {
            label: "f_locality",
            format: (row)=>(0, $b79edb411f97c469$export$2a939cfc6449d94d)(null, row)
        }
    ],
    filters: [
        {
            name: "network",
            entity: "network"
        },
        {
            name: "locality__county",
            entity: "county",
            label: "f_county",
            defaultRegion: true
        },
        {
            name: "locality",
            entity: "locality",
            label: "f_locality",
            scopeBy: "locality__county"
        }
    ],
    fields: [
        {
            name: "name",
            type: "text",
            label: "f_name",
            required: true
        },
        {
            name: "code",
            type: "text",
            label: "f_code"
        },
        {
            name: "address",
            type: "text",
            label: "f_address",
            wide: true
        },
        {
            name: "network",
            type: "entity",
            entity: "network",
            label: "f_network",
            required: true
        },
        {
            name: "category",
            type: "entity",
            entity: "categories_point",
            label: "f_category"
        },
        {
            name: "locality",
            type: "entity",
            entity: "locality",
            label: "f_locality"
        },
        // Required: a point with no coordinates can't be geofenced, so a visit to it can never be
        // verified on site (the same gap the list flags as "No coordinates"). `isEmpty(null)` catches
        // an unset location; a set one is `{latitude, longitude}`, which passes.
        {
            name: "location",
            type: "location",
            label: "f_location",
            wide: true,
            required: true
        },
        {
            name: "minutes_recommended",
            type: "number",
            label: "f_minutes"
        },
        {
            name: "responsible_merchandiser",
            type: "entity",
            entity: "merchandiser",
            label: "f_merchandiser"
        },
        {
            name: "responsible_supervisors",
            type: "entity",
            entity: "supervisor",
            isMulti: true,
            label: "f_supervisors"
        },
        {
            name: "is_active",
            type: "checkbox",
            label: "f_is_active"
        },
        {
            name: "is_available_for_task_creation",
            type: "checkbox",
            label: "f_available_tasks"
        }
    ],
    sections: [
        {
            title: "sec_basic",
            desc: "sec_basic_desc",
            fields: [
                "name",
                "code",
                "network",
                "category"
            ]
        },
        {
            title: "sec_location",
            desc: "sec_location_desc",
            fields: [
                "address",
                "locality",
                "location"
            ]
        },
        {
            title: "sec_assignment",
            desc: "sec_assignment_desc",
            fields: [
                "responsible_merchandiser",
                "responsible_supervisors"
            ]
        },
        {
            title: "sec_options",
            desc: "sec_options_desc",
            fields: [
                "minutes_recommended",
                "is_active",
                "is_available_for_task_creation"
            ]
        }
    ],
    softDelete: true,
    /* ---- points-only detail-page hooks (docs/design/point-detail.html) ----
     These are optional on a descriptor; only points sets them, so the other nine reference
     entities render the plain identity strip + rail unchanged. */ /* The identity tile: a 2-letter chip tinted by the network, not the shared initials avatar. */ identityLogo: (item)=>{
        const net = $557b82e5c7a8bf8a$var$networkLabel(item);
        return {
            text: (net || item.name || "\u2014").slice(0, 2).toUpperCase(),
            hue: $557b82e5c7a8bf8a$var$hueOf(net)
        };
    },
    /* Last visit — the activity signal for the identity strip and the rail Summary. It comes from
     the detail serializer (annotated on the queryset as a subquery) and is absent on an unsaved
     point, hence the fallback. There is no visit COUNT beside it: that was a `Count` join, and it
     put a GROUP BY into every query on the points viewset. */ metrics: [
        {
            key: "last_visit",
            labelKey: "last_visit",
            value: (item)=>item.last_visit ? (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)(item.last_visit).format("DD MMM YYYY") : "\u2014"
        }
    ],
    /* Soft warnings for the rail's Data quality — real gaps that do not block a save the way a
     required field does. "Unassigned" is the same signal the list flags. */ warnings: [
        {
            key: "unassigned",
            field: "responsible_merchandiser",
            labelKey: "w_no_merch",
            when: (item)=>!item.responsible_merchandiser
        }
    ],
    /* The coordinate editor is hoisted out of the Location section into a hero card at the top of
     the form (the mockup's `pdMap`), so the map leads the page. It is the only map on this page —
     the old read-only `detailPanel` was unreachable (no descriptor ever set `readOnly`) and went
     with `ResourceView`. */ heroField: "location"
};



var $138b5278448c8637$export$2e2bcd8739ae039 = {
    slug: "point_groups",
    endpoint: "point_groups/",
    titleKey: "point_groups_title",
    subtitleKey: "point_groups_sub",
    columns: [
        {
            field: "name",
            label: "f_name"
        },
        {
            label: "f_created_by",
            format: (row)=>row.created_by ? (0, $b79edb411f97c469$export$99f62f7c9ad8c7ce)(null, row) : "\u2014"
        }
    ],
    filters: [
        {
            name: "created_by",
            type: "me",
            label: "filter_created_by_me"
        },
        {
            name: "available_for_supervisors",
            entity: "created_by",
            label: "f_available_supervisors"
        },
        {
            name: "points",
            entity: "point",
            label: "f_points"
        }
    ],
    fields: [
        {
            name: "name",
            type: "text",
            label: "f_name",
            required: true
        },
        {
            name: "available_for_supervisors",
            type: "entity",
            entity: "created_by",
            isMulti: true,
            label: "f_available_supervisors",
            wide: true
        },
        /* `tall`: a group can hold many points, so this select is a wrapping, scrollable chip area that
       shows every one, not a one-line control that collapses them into `+N`.
       `fileImport`: bulk-add points from a CSV/XLSX of ids, on create and edit alike — the same
       endpoint the /points bulk-bar modal uses, returning ready {id, name} options that MERGE
       into the current selection (PICSELL-1581 #18/#19). */ {
            name: "points",
            type: "entity",
            entity: "point",
            isMulti: true,
            label: "f_points",
            wide: true,
            tall: true,
            fileImport: {
                url: "point_groups/points-ids-from-file/",
                accept: ".csv,.xlsx"
            }
        }
    ],
    softDelete: true
};



var $f385a83456e8df3b$export$2e2bcd8739ae039 = {
    slug: "merchandisers",
    endpoint: "merchandisers/",
    titleKey: "merchandisers_title",
    defaultOrdering: "first_name",
    columns: [
        {
            label: "f_name",
            format: (row)=>(0, $b79edb411f97c469$export$c86d3ca66f38ed60)(null, row),
            sort: "first_name"
        },
        {
            field: "phone_number",
            label: "f_phone"
        },
        {
            label: "f_movement",
            format: (row)=>(0, $b79edb411f97c469$export$c1c72f42e43ef7e9)(null, row)
        }
    ],
    deactivation: {
        field: "is_active",
        activeValue: true,
        via: "patch"
    },
    // detail + create stay in the existing rich merchandiser module:
    detailPath: (id)=>`/merchandiser/${id}`,
    newPath: "/merchandiser/new"
};



/* ⚠ `YYYY`, not moment's `yyyy`: dayjs has no lowercase year token and passes an unknown one
   through literally, so the moment-era format string rendered "14.08.yyyy 09:05" verbatim. */ const $082b55e2d33186f5$var$fmtDate = (v)=>v ? (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)(v).format("DD.MM.YYYY HH:mm") : "\u2014";
var $082b55e2d33186f5$export$2e2bcd8739ae039 = {
    slug: "surveys",
    endpoint: "surveys/",
    titleKey: "surveys_title",
    subtitleKey: "surveys_sub",
    columns: [
        {
            field: "title",
            label: "f_title",
            sort: "title"
        },
        {
            label: "f_active_from",
            format: (row)=>$082b55e2d33186f5$var$fmtDate(row.active_from)
        },
        {
            label: "f_active_to",
            format: (row)=>$082b55e2d33186f5$var$fmtDate(row.active_to)
        }
    ],
    fields: [
        {
            name: "title",
            type: "text",
            label: "f_title",
            required: true
        },
        {
            name: "description",
            type: "textarea",
            label: "f_description",
            wide: true
        },
        {
            name: "active_from",
            type: "datetime",
            label: "f_active_from",
            required: true
        },
        {
            name: "active_to",
            type: "datetime",
            label: "f_active_to",
            required: true
        },
        {
            name: "form_organization_mode",
            type: "select",
            label: "f_form_organization_mode",
            options: [
                {
                    value: "products",
                    label: "Products"
                },
                {
                    value: "brands",
                    label: "Brands"
                },
                {
                    value: "categories",
                    label: "Categories"
                },
                {
                    value: "subcategories",
                    label: "Subcategories"
                }
            ]
        },
        {
            name: "audience",
            type: "audience",
            label: "f_audience",
            wide: true
        },
        {
            name: "questions",
            type: "questions",
            label: "f_questions",
            wide: true
        }
    ],
    sections: [
        {
            title: "sec_basic",
            fields: [
                "title",
                "description"
            ]
        },
        {
            title: "sec_schedule",
            fields: [
                "active_from",
                "active_to",
                "form_organization_mode"
            ]
        },
        {
            title: "sec_audience",
            fields: [
                "audience"
            ]
        },
        {
            title: "sec_questions",
            fields: [
                "questions"
            ]
        }
    ],
    softDelete: true
};


const $beba70bdcd76b688$export$4e841128923ef26 = {
    networks: $eb2083f4ff5cb21c$export$2e2bcd8739ae039,
    countries: $d76a7d555b424545$export$2e2bcd8739ae039,
    counties: $d2380bc640409603$export$2e2bcd8739ae039,
    localities: $142d23eb1e534931$export$2e2bcd8739ae039,
    categories: $b7158dc819ea8c2e$export$2e2bcd8739ae039,
    points: $557b82e5c7a8bf8a$export$2e2bcd8739ae039,
    point_groups: $138b5278448c8637$export$2e2bcd8739ae039,
    merchandisers: $f385a83456e8df3b$export$2e2bcd8739ae039,
    surveys: $082b55e2d33186f5$export$2e2bcd8739ae039
};
function $beba70bdcd76b688$export$dd068f9289a3efeb(slug) {
    return $beba70bdcd76b688$export$4e841128923ef26[slug];
}



function $e3e209289ea60a84$export$5636abe024a9e6a3(slug) {
    return function Bound(props) {
        return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $c92f0e47dd84f4f9$export$2e2bcd8739ae039), {
            descriptor: (0, $beba70bdcd76b688$export$dd068f9289a3efeb)(slug),
            ...props
        });
    };
}
function $e3e209289ea60a84$export$fd0f57f0ca46c3d2(slug) {
    return function Bound(props) {
        return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $bbfa4fbd0e8cac16$export$2e2bcd8739ae039), {
            descriptor: (0, $beba70bdcd76b688$export$dd068f9289a3efeb)(slug),
            ...props
        });
    };
}


/* Points — retail locations, assignment and data quality.
 *
 * 1:1 with `docs/design/points.html`. This is the bespoke list the descriptor-driven
 * `ResourceTable` was always the interim for (see the points-framework memory): the mockup's
 * angle is DATA QUALITY, and two states that break operations on their own are first-class
 * filters rather than columns the user has to eyeball —
 *   • no coordinates → the point cannot be geofenced, so a visit to it can never be verified
 *   • unassigned (no responsible merchandiser) → nobody is going.
 *
 * Built the same way `/visit` and `/supervisors` are (spec/03 archetype A): the shared `lp-*`
 * chrome (`component/list-page.scss`), `table-cells` primitives, `EntitySelect`,
 * `FilterChips`/`useLabelCache`, and the same table / footer / bulk-bar composition. The only
 * new code is the columns, the four extra filters and the archive lifecycle. The other eight
 * admin entities still render through the generic `ResourceTable`.
 *
 * Everything narrows on the SERVER — `GET points/` gained the data-quality filters, the
 * activity annotation (`last_visit`) in the same change
 * (picsell-api `points/api/web/v1/`).
 *
 * ⚠ Archived (`is_removed`, via DELETE) is NOT the editable `is_active` flag shown beside it —
 * softDelete semantics. Row click opens a quick-look modal; "Open editor" navigates to the full
 * `/points/:id` page, which is still the generic `ResourcePage`. */ 

var $cQmXV = parcelRequire("cQmXV");




var $cQmXV = parcelRequire("cQmXV");
var $31d4134f1b86b714$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($31d4134f1b86b714$exports, "__esModule", {
    value: true
});
var $31d4134f1b86b714$var$UserDeleteOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M678.3 655.4c24.2-13 51.9-20.4 81.4-20.4h.1c3 0 4.4-3.6 2.2-5.6a371.67 371.67 0 00-103.7-65.8c-.4-.2-.8-.3-1.2-.5C719.2 518 759.6 444.7 759.6 362c0-137-110.8-248-247.5-248S264.7 225 264.7 362c0 82.7 40.4 156 102.6 201.1-.4.2-.8.3-1.2.5-44.7 18.9-84.8 46-119.3 80.6a373.42 373.42 0 00-80.4 119.5A373.6 373.6 0 00137 901.8a8 8 0 008 8.2h59.9c4.3 0 7.9-3.5 8-7.8 2-77.2 32.9-149.5 87.6-204.3C357 641.2 432.2 610 512.2 610c56.7 0 111.1 15.7 158 45.1a8.1 8.1 0 008.1.3zM512.2 534c-45.8 0-88.9-17.9-121.4-50.4A171.2 171.2 0 01340.5 362c0-45.9 17.9-89.1 50.3-121.6S466.3 190 512.2 190s88.9 17.9 121.4 50.4A171.2 171.2 0 01683.9 362c0 45.9-17.9 89.1-50.3 121.6C601.1 516.1 558 534 512.2 534zM880 772H640c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h240c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "user-delete",
    "theme": "outlined"
};
$31d4134f1b86b714$exports.default = $31d4134f1b86b714$var$UserDeleteOutlined;



function $8631fc7734d1e427$var$_extends() {
    $8631fc7734d1e427$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8631fc7734d1e427$var$_extends.apply(this, arguments);
}
const $8631fc7734d1e427$var$UserDeleteOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $8631fc7734d1e427$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($31d4134f1b86b714$exports)))
    }));
/**![user-delete](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTY3OC4zIDY1NS40YzI0LjItMTMgNTEuOS0yMC40IDgxLjQtMjAuNGguMWMzIDAgNC40LTMuNiAyLjItNS42YTM3MS42NyAzNzEuNjcgMCAwMC0xMDMuNy02NS44Yy0uNC0uMi0uOC0uMy0xLjItLjVDNzE5LjIgNTE4IDc1OS42IDQ0NC43IDc1OS42IDM2MmMwLTEzNy0xMTAuOC0yNDgtMjQ3LjUtMjQ4UzI2NC43IDIyNSAyNjQuNyAzNjJjMCA4Mi43IDQwLjQgMTU2IDEwMi42IDIwMS4xLS40LjItLjguMy0xLjIuNS00NC43IDE4LjktODQuOCA0Ni0xMTkuMyA4MC42YTM3My40MiAzNzMuNDIgMCAwMC04MC40IDExOS41QTM3My42IDM3My42IDAgMDAxMzcgOTAxLjhhOCA4IDAgMDA4IDguMmg1OS45YzQuMyAwIDcuOS0zLjUgOC03LjggMi03Ny4yIDMyLjktMTQ5LjUgODcuNi0yMDQuM0MzNTcgNjQxLjIgNDMyLjIgNjEwIDUxMi4yIDYxMGM1Ni43IDAgMTExLjEgMTUuNyAxNTggNDUuMWE4LjEgOC4xIDAgMDA4LjEuM3pNNTEyLjIgNTM0Yy00NS44IDAtODguOS0xNy45LTEyMS40LTUwLjRBMTcxLjIgMTcxLjIgMCAwMTM0MC41IDM2MmMwLTQ1LjkgMTcuOS04OS4xIDUwLjMtMTIxLjZTNDY2LjMgMTkwIDUxMi4yIDE5MHM4OC45IDE3LjkgMTIxLjQgNTAuNEExNzEuMiAxNzEuMiAwIDAxNjgzLjkgMzYyYzAgNDUuOS0xNy45IDg5LjEtNTAuMyAxMjEuNkM2MDEuMSA1MTYuMSA1NTggNTM0IDUxMi4yIDUzNHpNODgwIDc3Mkg2NDBjLTQuNCAwLTggMy42LTggOHY1NmMwIDQuNCAzLjYgOCA4IDhoMjQwYzQuNCAwIDgtMy42IDgtOHYtNTZjMC00LjQtMy42LTgtOC04eiIgLz48L3N2Zz4=) */ const $8631fc7734d1e427$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($8631fc7734d1e427$var$UserDeleteOutlined);
var $8631fc7734d1e427$export$2e2bcd8739ae039 = $8631fc7734d1e427$var$RefIcon;






/* "Add to group" — the points list's bulk action.
 *
 * Replaces the legacy `point/Grouping.js` + `point/AddGroup.js` slide-in panel, which was a
 * second, worse copy of `/point_groups`: it listed every group with edit / clone / delete, and
 * its editor re-implemented the name, the "available for" picker and the point list that the
 * descriptor-driven page already renders. It also took over the table's checkboxes for the
 * duration of a "grouping session", so the same checkbox meant two things depending on hidden
 * state, and it fed the group bare row ids while rendering `point.name` — so every chip was blank.
 *
 * This does ONE thing: take the selected points and put them in a group, existing or new.
 * Managing groups themselves (rename, share, delete, edit membership) is `/point_groups`, linked
 * from the footer. Clone is the one capability that went away with the panel.
 *
 * Membership is merged, never replaced: the group is fetched on pick and PATCHed with the union,
 * so adding 3 points to a 900-point group cannot silently drop the 900.
 */ 

var $cQmXV = parcelRequire("cQmXV");









/* Relation pickers ask for `active=true` so a deactivated group is not offered (see
   `active_only` in picsell-api). Module-scope so the reference is stable — `EntitySelect`
   keys its option cache on it. */ const $dce32b0c026318e9$var$ACTIVE_ONLY = {
    active: true
};
/* ponytail: "add all" can stage thousands of points; only the first 200 chips render and the
   rest are counted. Add windowing if a group ever needs per-point removal at that size. */ const $dce32b0c026318e9$var$SHOWN = 200;
const $dce32b0c026318e9$var$MIN_NAME = 5;
const $dce32b0c026318e9$var$byId = (list)=>Array.from(new Map(list.map((p)=>[
            p.id,
            p
        ])).values());
function $dce32b0c026318e9$export$2e2bcd8739ae039({ points: points = [], query: query = "", total: total = 0, currentUser: currentUser, onDone: onDone }) {
    const history = (0, $6f5d68f762d5488a$export$3420e1dc2c4a518c)();
    const lang = currentUser?.language || "en";
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$5f49f978abb09725), key, lang);
    const [open, setOpen] = (0, $cQmXV.useState)(false);
    const [mode, setMode] = (0, $cQmXV.useState)("existing");
    const [pending, setPending] = (0, $cQmXV.useState)([]);
    const [group, setGroup] = (0, $cQmXV.useState)(null);
    /* The picked group's current membership — the merge base, and what lets the form say how many
     of the selection are already in it before anything is written. */ const [members, setMembers] = (0, $cQmXV.useState)(null);
    const [name, setName] = (0, $cQmXV.useState)("");
    const [supervisors, setSupervisors] = (0, $cQmXV.useState)([]);
    const [busy, setBusy] = (0, $cQmXV.useState)(false);
    const start = ()=>{
        setMode("existing");
        setPending(points);
        setGroup(null);
        setMembers(null);
        setName("");
        setSupervisors([]);
        setOpen(true);
    };
    const pickGroup = (option)=>{
        setGroup(option);
        setMembers(null);
        if (!option) return;
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "GET",
            url: `point_groups/${option.id}/`
        }, (response)=>{
            setMembers(Array.isArray(response?.points) ? response.points.map((p)=>p.id) : []);
        });
    };
    const addAllFiltered = ()=>{
        /* The same filters the table is showing, minus the paging — `points/all-points/` runs the
       list's own filterset, so a filtered "all" is exactly what the user is looking at. */ const p = new URLSearchParams(query);
        [
            "page",
            "page_size",
            "ordering"
        ].forEach((key)=>p.delete(key));
        setBusy(true);
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "GET",
            url: `points/all-points/${p.toString() ? `?${p}` : ""}`
        }, (response)=>{
            setBusy(false);
            if (!Array.isArray(response?.points)) return (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).error(t("new_group_popup_error_update_text"), {
                position: "top-right"
            });
            setPending((prev)=>$dce32b0c026318e9$var$byId([
                    ...prev,
                    ...response.points
                ]));
        });
    };
    const importFile = (file)=>{
        const form = new FormData();
        form.append("file", file);
        setBusy(true);
        (0, $c9936523dc38c641$export$a3c8e1472dc2ed84)({
            method: "POST",
            url: "point_groups/points-ids-from-file/",
            post: form
        }, (response)=>{
            setBusy(false);
            if (response?.errors?.length) (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).error(`${t("file_error_uploaded")} ( ${response.errors[0]?.reason} )`, {
                position: "top-right"
            });
            if (!Array.isArray(response?.valid_ids)) return;
            setPending((prev)=>$dce32b0c026318e9$var$byId([
                    ...prev,
                    ...response.valid_ids
                ]));
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success(t("file_successfully_uploaded"), {
                position: "top-right"
            });
        });
        return false; // never let antd upload it itself
    };
    const finish = (response)=>{
        setBusy(false);
        if (!response?.id) return (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).error(t(mode === "new" ? "new_group_popup_error_save_text" : "new_group_popup_error_update_text"), {
            position: "top-right"
        });
        (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success(t("group_points_added"), {
            position: "top-right"
        });
        setOpen(false);
        if (onDone) onDone();
    };
    const submit = ()=>{
        const ids = pending.map((p)=>p.id);
        setBusy(true);
        if (mode === "new") (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "POST",
            url: "point_groups/",
            post: {
                name: name.trim(),
                available_for_supervisors: supervisors.map((s)=>s.id),
                points: ids
            }
        }, finish);
        else (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "PATCH",
            url: `point_groups/${group.id}/`,
            post: {
                points: Array.from(new Set([
                    ...members || [],
                    ...ids
                ]))
            }
        }, finish);
    };
    /* Editing a group you did not create is the manager's call — the same rule the legacy panel
     applied to edit and delete. The server scopes the list to groups you own or are shared with;
     this is the narrower client-side half of it. */ const mayEdit = !group || group.created_by?.id === currentUser?.id || currentUser?.role === "supervisor_manager";
    const dupes = members ? pending.filter((p)=>members.includes(p.id)).length : 0;
    const shortName = mode === "new" && name.trim().length > 0 && name.trim().length < $dce32b0c026318e9$var$MIN_NAME;
    const canSubmit = pending.length > 0 && !busy && (mode === "new" ? name.trim().length >= $dce32b0c026318e9$var$MIN_NAME : Boolean(group) && mayEdit);
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $575603080129eb00$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                size: "small",
                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $8e67197b587f6486$export$2e2bcd8739ae039), {}),
                onClick: start,
                children: t("add_to_group_btn")
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $05a90c67d3627fd9$export$2e2bcd8739ae039), {
                open: open,
                width: 620,
                destroyOnHidden: true,
                className: "atg",
                title: t("add_to_group_btn"),
                onCancel: ()=>setOpen(false),
                footer: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                    align: "center",
                    justify: "space-between",
                    gap: "small",
                    wrap: true,
                    children: [
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                            type: "link",
                            className: "atg__manage",
                            onClick: ()=>history.push("/point_groups"),
                            children: t("group_manage_link")
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                            gap: "small",
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                    onClick: ()=>setOpen(false),
                                    children: t("cancel_btn")
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                    type: "primary",
                                    loading: busy,
                                    disabled: !canSubmit,
                                    onClick: submit,
                                    children: t("add_to_group_btn")
                                })
                            ]
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039), {
                    layout: "vertical",
                    component: false,
                    colon: false,
                    children: [
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $ac40310dc424be23$export$2e2bcd8739ae039), {
                            block: true,
                            className: "atg__mode",
                            value: mode,
                            onChange: setMode,
                            options: [
                                {
                                    value: "existing",
                                    label: t("group_target_existing"),
                                    icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $8e67197b587f6486$export$2e2bcd8739ae039), {})
                                },
                                {
                                    value: "new",
                                    label: t("group_target_new"),
                                    icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $fa25166ced813feb$export$2e2bcd8739ae039), {})
                                }
                            ]
                        }),
                        mode === "existing" ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $575603080129eb00$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                    required: true,
                                    label: t("group_field_label"),
                                    validateStatus: group && !mayEdit ? "error" : "",
                                    help: group && !mayEdit ? t("new_group_popup_user_validate_error_text") : null,
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b6929c6a194abc34$export$2e2bcd8739ae039), {
                                        entity: "point_groups",
                                        value: group,
                                        onChange: pickGroup,
                                        extraQuery: $dce32b0c026318e9$var$ACTIVE_ONLY,
                                        ariaLabel: t("group_field_label")
                                    })
                                }),
                                group && members ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                    className: "atg__facts",
                                    gap: "large",
                                    wrap: true,
                                    children: [
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                            type: "secondary",
                                            children: [
                                                t("group_has_points"),
                                                " ",
                                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("b", {
                                                    children: members.length
                                                })
                                            ]
                                        }),
                                        dupes > 0 ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                            type: "secondary",
                                            children: [
                                                t("group_already_in"),
                                                " ",
                                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("b", {
                                                    children: dupes
                                                })
                                            ]
                                        }) : null
                                    ]
                                }) : null
                            ]
                        }) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $575603080129eb00$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                    required: true,
                                    htmlFor: "atg-name",
                                    label: t("new_group_popup_field_name"),
                                    validateStatus: shortName ? "error" : "",
                                    help: shortName ? t("new_group_popup_error_text_minimum") : null,
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0883e7f8083c01b0$export$2e2bcd8739ae039), {
                                        id: "atg-name",
                                        value: name,
                                        onChange: (event)=>setName(event.target.value),
                                        placeholder: t("new_group_popup_field_name_placeholder")
                                    })
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                    label: t("new_group_popup_field_group_available_users"),
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b6929c6a194abc34$export$2e2bcd8739ae039), {
                                        entity: "created_by",
                                        isMulti: true,
                                        maxTagCount: "responsive",
                                        value: supervisors,
                                        onChange: (value)=>setSupervisors(value || []),
                                        placeholder: t("new_group_popup_field_users_placeholder"),
                                        ariaLabel: t("new_group_popup_field_group_available_users")
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                            className: "atg__pointshead",
                            align: "center",
                            gap: "small",
                            wrap: true,
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                    strong: true,
                                    children: t("group_points_to_add")
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                    className: "atg__n",
                                    children: pending.length
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                    className: "atg__spacer"
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                    size: "small",
                                    type: "text",
                                    loading: busy,
                                    onClick: addAllFiltered,
                                    children: [
                                        t("new_group_popup_field_group_add_all_btn_text"),
                                        " ",
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                            className: "atg__n",
                                            children: total
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b615b6e60c753ce5$export$2e2bcd8739ae039), {
                                    accept: ".csv,.xlsx",
                                    showUploadList: false,
                                    beforeUpload: importFile,
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                        size: "small",
                                        type: "text",
                                        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $08a66dd72a6d5552$export$2e2bcd8739ae039), {}),
                                        children: t("group_import_btn")
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                            className: "atg__points",
                            children: pending.length === 0 ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $99350450b877904c$export$2e2bcd8739ae039), {
                                image: (0, $99350450b877904c$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE,
                                description: t("group_no_points")
                            }) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $575603080129eb00$exports.Fragment), {
                                children: [
                                    pending.slice(0, $dce32b0c026318e9$var$SHOWN).map((point)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $602120e6d17ff12a$export$2e2bcd8739ae039), {
                                            className: "atg__chip",
                                            closable: true,
                                            onClose: ()=>setPending((prev)=>prev.filter((p)=>p.id !== point.id)),
                                            children: point.name
                                        }, point.id)),
                                    pending.length > $dce32b0c026318e9$var$SHOWN ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                        type: "secondary",
                                        children: (0, $3b579ca6158bc61b$export$9563e054e6f787fb)(t("group_more_hidden"), {
                                            n: pending.length - $dce32b0c026318e9$var$SHOWN
                                        })
                                    }) : null
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
}






const $038bb54df492679d$var$PAGE_SIZES = [
    25,
    50,
    100
];
const $038bb54df492679d$var$SEGMENTS = [
    [
        "all",
        "seg_all"
    ],
    [
        "active",
        "active"
    ],
    [
        "inactive",
        "inactive"
    ],
    [
        "archived",
        "archived"
    ]
];
/* Column key → the field the API orders on. A key missing here is not sortable (spec/03). */ const $038bb54df492679d$var$ORDERING = {
    name: "name",
    network: "network__name",
    location: "locality__name",
    assignment: "responsible_merchandiser__first_name",
    last_visit: "last_visit",
    minutes: "minutes_recommended",
    status: "is_active"
};
const $038bb54df492679d$var$FIELD_COL = {
    xs: {
        flex: "0 0 100%"
    },
    sm: {
        flex: "0 0 50%"
    },
    xl: {
        flex: "0 0 33.3333%"
    }
};
const $038bb54df492679d$var$idOf = (v)=>v && typeof v === "object" ? v.id ?? v.value : v;
const $038bb54df492679d$var$netName = (row)=>row?.network?.name || "";
/* A deterministic hue per network, so the logo stand-in is stable across renders — the mockup's
   `netHue`. Only used when a network has no uploaded logo. */ const $038bb54df492679d$var$netHue = (row)=>(($038bb54df492679d$var$idOf(row?.network) || 0) * 47 + 190) % 360;
/** The request the table runs on — one place where the endpoint's parameter shape is visible. */ function $038bb54df492679d$var$buildQuery({ search: search, network: network, county: county, locality: locality, category: category, merch: merch, segment: segment, noGeo: noGeo, noMerch: noMerch, page: page, size: size, sort: sort }) {
    const p = new URLSearchParams();
    p.set("page", String(page));
    p.set("page_size", String(size));
    if (search) p.set("search", search);
    if (network) p.set("network", String($038bb54df492679d$var$idOf(network)));
    if (county) p.set("locality__county", String($038bb54df492679d$var$idOf(county)));
    if (locality) p.set("locality", String($038bb54df492679d$var$idOf(locality)));
    if (category) p.set("category", String($038bb54df492679d$var$idOf(category)));
    if (merch) p.set("responsible_merchandiser", String($038bb54df492679d$var$idOf(merch)));
    p.set("archived", segment === "archived" ? "true" : "false");
    if (segment === "active") p.set("is_active", "true");
    if (segment === "inactive") p.set("is_active", "false");
    if (noGeo) p.set("no_geo", "true");
    if (noMerch) p.set("unassigned", "true");
    if (sort) p.set("ordering", `${sort.dir === "descend" ? "-" : ""}${$038bb54df492679d$var$ORDERING[sort.key]}`);
    return p.toString();
}
/** URL ↔ state, so a filtered view is shareable and survives Back from a point's editor. */ function $038bb54df492679d$var$stateToSearch(s) {
    const p = new URLSearchParams();
    if (s.search) p.set("q", s.search);
    [
        "network",
        "county",
        "locality",
        "category",
        "merch"
    ].forEach((key)=>{
        if (s[key]) p.set(key, String($038bb54df492679d$var$idOf(s[key])));
    });
    if (s.segment !== "all") p.set("segment", s.segment);
    if (s.noGeo) p.set("no_geo", "1");
    if (s.noMerch) p.set("unassigned", "1");
    if (s.page > 1) p.set("page", String(s.page));
    if (s.size !== $038bb54df492679d$var$PAGE_SIZES[0]) p.set("size", String(s.size));
    if (s.sort) p.set("sort", `${s.sort.dir === "descend" ? "-" : ""}${s.sort.key}`);
    return p.toString();
}
function $038bb54df492679d$var$searchToState(locationSearch, me) {
    const p = new URLSearchParams(locationSearch);
    const sort = p.get("sort");
    const hasFilters = Boolean(locationSearch && locationSearch.replace(/^\?/, ""));
    return {
        search: p.get("q") || "",
        network: p.get("network") || "",
        /* Without a URL to restore, the manager's own region is the sensible default scope — the
       same seeding the visits and supervisors lists do. */ county: p.get("county") || (hasFilters ? "" : (0, $3b579ca6158bc61b$export$6339e4f5afb1eeb0)(me) || ""),
        locality: p.get("locality") || "",
        category: p.get("category") || "",
        merch: p.get("merch") || "",
        segment: $038bb54df492679d$var$SEGMENTS.some(([value])=>value === p.get("segment")) ? p.get("segment") : "all",
        noGeo: p.get("no_geo") === "1",
        noMerch: p.get("unassigned") === "1",
        page: Math.max(1, Number(p.get("page")) || 1),
        size: $038bb54df492679d$var$PAGE_SIZES.includes(Number(p.get("size"))) ? Number(p.get("size")) : $038bb54df492679d$var$PAGE_SIZES[0],
        sort: sort && $038bb54df492679d$var$ORDERING[sort.replace(/^-/, "")] ? {
            key: sort.replace(/^-/, ""),
            dir: sort[0] === "-" ? "descend" : "ascend"
        } : null
    };
}
const $038bb54df492679d$var$List = ()=>{
    const history = (0, $6f5d68f762d5488a$export$3420e1dc2c4a518c)();
    const location = (0, $6f5d68f762d5488a$export$45d76561a5302f2b)();
    const me = (0, $b83e93e5ef3de8b0$export$2105062e25df4afe)((state)=>state.me);
    const lang = me?.language || "en";
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ac552071080927b0), key, lang);
    const td = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), key, lang);
    const tp = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b8441a9a81ffc5d6), key, lang);
    const tv = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), key, lang);
    const initial = (0, $cQmXV.useRef)($038bb54df492679d$var$searchToState(location.search, me)).current;
    const [search, setSearch] = (0, $cQmXV.useState)(initial.search);
    const [typed, setTyped] = (0, $cQmXV.useState)(initial.search);
    const [network, setNetwork] = (0, $cQmXV.useState)(initial.network);
    const [county, setCounty] = (0, $cQmXV.useState)(initial.county);
    const [locality, setLocality] = (0, $cQmXV.useState)(initial.locality);
    const [category, setCategory] = (0, $cQmXV.useState)(initial.category);
    const [merch, setMerch] = (0, $cQmXV.useState)(initial.merch);
    const [segment, setSegment] = (0, $cQmXV.useState)(initial.segment);
    const [noGeo, setNoGeo] = (0, $cQmXV.useState)(initial.noGeo);
    const [noMerch, setNoMerch] = (0, $cQmXV.useState)(initial.noMerch);
    const [page, setPage] = (0, $cQmXV.useState)(initial.page);
    const [size, setSize] = (0, $cQmXV.useState)(initial.size);
    const [sort, setSort] = (0, $cQmXV.useState)(initial.sort);
    /* Option objects the selects handed back, so a chosen value labels its own chip. */ const [chosen, setChosen] = (0, $cQmXV.useState)({
        network: null,
        county: null,
        locality: null,
        category: null,
        merch: null
    });
    const rememberChosen = (key, option)=>setChosen((prev)=>({
                ...prev,
                [key]: option
            }));
    const [rows, setRows] = (0, $cQmXV.useState)([]);
    const [total, setTotal] = (0, $cQmXV.useState)(0);
    const [loading, setLoading] = (0, $cQmXV.useState)(true);
    const [selected, setSelected] = (0, $cQmXV.useState)([]);
    const [busy, setBusy] = (0, $cQmXV.useState)(false);
    /* --------------------------------------------------------------- fetch */ const query = (0, $cQmXV.useMemo)(()=>$038bb54df492679d$var$buildQuery({
            search: search,
            network: network,
            county: county,
            locality: locality,
            category: category,
            merch: merch,
            segment: segment,
            noGeo: noGeo,
            noMerch: noMerch,
            page: page,
            size: size,
            sort: sort
        }), [
        search,
        network,
        county,
        locality,
        category,
        merch,
        segment,
        noGeo,
        noMerch,
        page,
        size,
        sort
    ]);
    const [reloadKey, setReloadKey] = (0, $cQmXV.useState)(0);
    const reload = ()=>setReloadKey((k)=>k + 1);
    (0, $cQmXV.useEffect)(()=>{
        const controller = new AbortController();
        setLoading(true);
        (0, $c9936523dc38c641$export$86557ef9e0794d10)(`points/?${query}`, controller.signal).then((response)=>{
            if (!response) return;
            setRows(response.results || []);
            setTotal(response.count || 0);
            setLoading(false);
        }).catch((error)=>{
            if (error.name === "AbortError") return;
            setRows([]);
            setTotal(0);
            setLoading(false);
        });
        return ()=>controller.abort();
    }, [
        query,
        reloadKey
    ]);
    /* 250ms, matching every other search box in the app: one request per pause, not per keystroke. */ (0, $cQmXV.useEffect)(()=>{
        if (typed === search) return undefined;
        const timer = setTimeout(()=>{
            setSearch(typed);
            setPage(1);
            setSelected([]);
        }, 250);
        return ()=>clearTimeout(timer);
    }, [
        typed,
        search
    ]);
    (0, $cQmXV.useEffect)(()=>{
        const next = $038bb54df492679d$var$stateToSearch({
            search: search,
            network: network,
            county: county,
            locality: locality,
            category: category,
            merch: merch,
            segment: segment,
            noGeo: noGeo,
            noMerch: noMerch,
            page: page,
            size: size,
            sort: sort
        });
        if (next !== location.search.replace(/^\?/, "")) history.replace({
            search: next
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        search,
        network,
        county,
        locality,
        category,
        merch,
        segment,
        noGeo,
        noMerch,
        page,
        size,
        sort
    ]);
    /* Any narrowing invalidates the page number: page 7 of the old result set is usually past the
     end of the new one, which renders an empty table over a non-empty result. */ const narrow = (fn)=>(...args)=>{
            setPage(1);
            setSelected([]);
            fn(...args);
        };
    const resetFilters = narrow(()=>{
        setTyped("");
        setSearch("");
        setNetwork("");
        setCounty("");
        setLocality("");
        setCategory("");
        setMerch("");
        setChosen({
            network: null,
            county: null,
            locality: null,
            category: null,
            merch: null
        });
        setSegment("all");
        setNoGeo(false);
        setNoMerch(false);
        setSort(null);
        (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).info(t("filters_reset"), {
            position: "top-right"
        });
    });
    /* ---------------------------------------------------------------- chips */ const { labels: labels, remember: remember, nameFor: nameFor } = (0, $a9e321bb60aaf998$export$243aa1fcbfd1886a)();
    const chips = (0, $cQmXV.useMemo)(()=>{
        const out = [];
        if (search) out.push({
            key: "q",
            label: tp("search") || t("search_ph"),
            value: search
        });
        if (network) out.push({
            key: "network",
            label: t("f_network"),
            value: nameFor("network", chosen.network ?? network)
        });
        if (county) out.push({
            key: "county",
            label: t("f_county"),
            value: nameFor("county", chosen.county ?? county)
        });
        if (locality) out.push({
            key: "locality",
            label: t("f_locality"),
            value: nameFor("locality", chosen.locality ?? locality)
        });
        if (category) out.push({
            key: "category",
            label: t("f_category"),
            value: nameFor("category", chosen.category ?? category)
        });
        if (merch) out.push({
            key: "merch",
            label: t("f_merchandiser"),
            value: nameFor("merch", chosen.merch ?? merch)
        });
        if (noGeo) out.push({
            key: "no_geo",
            label: t("data_quality"),
            value: t("no_coords")
        });
        if (noMerch) out.push({
            key: "unassigned",
            label: t("data_quality"),
            value: t("unassigned")
        });
        return out;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        search,
        network,
        county,
        locality,
        category,
        merch,
        noGeo,
        noMerch,
        chosen,
        labels,
        lang
    ]);
    const clearChip = narrow((key)=>{
        if (key === "q") {
            setTyped("");
            setSearch("");
        } else if (key === "no_geo") setNoGeo(false);
        else if (key === "unassigned") setNoMerch(false);
        else {
            /* One of the entity selects. */ const setter = {
                network: setNetwork,
                county: setCounty,
                locality: setLocality,
                category: setCategory,
                merch: setMerch
            }[key];
            setter("");
            rememberChosen(key, null);
            /* Clearing the county unscopes and clears the locality with it. */ if (key === "county") {
                setLocality("");
                rememberChosen("locality", null);
            }
        }
    });
    /* ------------------------------------------------------------- archive / restore */ const archiveOne = (row, restore)=>new Promise((resolve)=>{
            if (restore) (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
                method: "PATCH",
                url: `points/${row.id}/`,
                post: {
                    is_removed: false
                }
            }, (r)=>resolve(Boolean(r)));
            else (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
                method: "DELETE",
                url: `points/${row.id}/`
            }, (r)=>resolve(Boolean(r) && r.status === 204));
        });
    const runArchive = async (targets, restore)=>{
        if (!targets.length) {
            setSelected([]);
            return;
        }
        setBusy(true);
        const results = await Promise.all(targets.map((row)=>archiveOne(row, restore)));
        setBusy(false);
        const done = results.filter(Boolean).length;
        if (done) {
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success((0, $3b579ca6158bc61b$export$9563e054e6f787fb)(t(restore ? "restored_n" : "archived_n"), {
                n: done
            }), {
                position: "top-right"
            });
            reload();
        }
        if (done < targets.length) (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).warning((0, $3b579ca6158bc61b$export$9563e054e6f787fb)(t("bulk_failed_n"), {
            n: targets.length - done
        }), {
            position: "top-right"
        });
        setSelected([]);
    };
    /* Archiving is destructive, so it is confirmed and the confirm says how many (spec/03).
     Restore is not, so it just runs. `Modal.confirm` is a static call — it renders outside the
     tree and does not inherit AppShell's `ConfigProvider locale`, so the buttons are labelled
     explicitly or they stay English. */ const confirmArchive = (targets, restore)=>{
        if (restore) {
            runArchive(targets, true);
            return;
        }
        (0, $05a90c67d3627fd9$export$2e2bcd8739ae039).confirm({
            title: (0, $3b579ca6158bc61b$export$9563e054e6f787fb)(t(targets.length === 1 ? "confirm_archive" : "confirm_archive_n"), {
                n: targets.length
            }),
            okText: t("archive_btn"),
            okButtonProps: {
                danger: true
            },
            cancelText: t("back_btn"),
            onOk: ()=>runArchive(targets, false)
        });
    };
    const openEditor = (row)=>history.push(`/points/${row.id}`);
    /* ------------------------------------------------------------- columns */ const columns = (0, $cQmXV.useMemo)(()=>[
            {
                key: "name",
                title: t("f_name"),
                width: 300,
                fixed: "left",
                ellipsis: true,
                sorter: true,
                render: (value, row)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                        align: "center",
                        gap: 10,
                        className: "pt-id",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $72b7444d01b36e98$export$2e2bcd8739ae039), {
                                shape: "square",
                                size: 30,
                                className: "pt-logo",
                                style: {
                                    "--h": $038bb54df492679d$var$netHue(row),
                                    "fontSize": 12
                                },
                                src: row.network?.image || null,
                                children: (0, $66539b2560a58e4e$export$f6a098653d630c23)($038bb54df492679d$var$netName(row))
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $66539b2560a58e4e$export$2692b073ef5fee01), {
                                title: row.name,
                                sub: [
                                    row.code,
                                    row.address
                                ].filter(Boolean).join(" \xb7 ")
                            })
                        ]
                    })
            },
            {
                key: "network",
                title: t("f_network"),
                width: 170,
                ellipsis: true,
                sorter: true,
                render: (value, row)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $66539b2560a58e4e$export$2692b073ef5fee01), {
                        title: $038bb54df492679d$var$netName(row) || (0, $66539b2560a58e4e$export$eb03490a10c3abc9),
                        sub: row.category?.name
                    })
            },
            {
                key: "location",
                title: t("f_locality"),
                width: 210,
                ellipsis: true,
                sorter: true,
                render: (value, row)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $66539b2560a58e4e$export$2692b073ef5fee01), {
                        title: row.locality?.name || (0, $66539b2560a58e4e$export$eb03490a10c3abc9),
                        sub: row.location ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                            className: "pt-geo",
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $d6c8837c82724a15$export$2e2bcd8739ae039), {
                                    className: "pt-geo-icon"
                                }),
                                " ",
                                row.location.latitude?.toFixed?.(5),
                                ", ",
                                row.location.longitude?.toFixed?.(5)
                            ]
                        }) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $1e5256cf9d329b2c$export$2e2bcd8739ae039), {
                            title: t("no_coords_hint"),
                            children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $602120e6d17ff12a$export$2e2bcd8739ae039), {
                                className: "pt-tag pt-tag--warn",
                                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $d6c8837c82724a15$export$2e2bcd8739ae039), {}),
                                children: t("no_coords")
                            })
                        })
                    })
            },
            {
                key: "assignment",
                title: t("f_merchandiser"),
                width: 210,
                ellipsis: true,
                sorter: true,
                render: (value, row)=>{
                    if (!row.responsible_merchandiser) return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $602120e6d17ff12a$export$2e2bcd8739ae039), {
                        className: "pt-tag pt-tag--warn",
                        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $8631fc7734d1e427$export$2e2bcd8739ae039), {}),
                        children: t("unassigned")
                    });
                    const sups = row.responsible_supervisors || [];
                    const supNames = sups.map((s)=>[
                            s.first_name,
                            s.last_name
                        ].filter(Boolean).join(" ")).join(", ");
                    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                        vertical: true,
                        gap: 2,
                        className: "pt-assign",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $66539b2560a58e4e$export$8a3d0b92eb0904a5), {
                                user: row.responsible_merchandiser,
                                strong: false
                            }),
                            sups.length ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $1e5256cf9d329b2c$export$2e2bcd8739ae039), {
                                title: `${t("f_supervisors")}: ${supNames}`,
                                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                    type: "secondary",
                                    className: "pt-sup",
                                    children: [
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $d5baeea001a6abe5$export$2e2bcd8739ae039), {}),
                                        " ",
                                        sups.length
                                    ]
                                })
                            }) : null
                        ]
                    });
                }
            },
            /* Last visit, not a visit COUNT: the count was a `Count` join, so it dragged a GROUP BY
         through every query on the points viewset — including this list's pagination `COUNT(*)`
         and the app-bar search, which borrows the same queryset. The date is one correlated
         subquery and answers "is anyone going there" more directly. */ {
                key: "last_visit",
                title: t("last_visit"),
                width: 130,
                align: "right",
                sorter: true,
                render: (value, row)=>row.last_visit ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "lp-num",
                        children: new Date(row.last_visit).toLocaleDateString(lang === "en" ? "en-GB" : lang, {
                            day: "2-digit",
                            month: "short",
                            year: "numeric"
                        })
                    }) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                        type: "secondary",
                        className: "pt-lastvisit",
                        children: t("never_visited")
                    })
            },
            {
                key: "minutes",
                title: t("min_col"),
                dataIndex: "minutes_recommended",
                width: 116,
                align: "right",
                sorter: true,
                render: (value)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                        className: "lp-num",
                        children: [
                            value || 0,
                            " ",
                            t("min_short")
                        ]
                    })
            },
            {
                key: "status",
                title: t("f_status"),
                width: 150,
                render: (value, row)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                        vertical: true,
                        align: "flex-start",
                        gap: 4,
                        className: "pt-status",
                        children: [
                            row.is_removed ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $602120e6d17ff12a$export$2e2bcd8739ae039), {
                                className: "pt-tag pt-tag--warn",
                                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $268dc9f9b8c7fd21$export$2e2bcd8739ae039), {}),
                                children: t("archived")
                            }) : null,
                            row.is_active ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $602120e6d17ff12a$export$2e2bcd8739ae039), {
                                className: "pt-tag pt-tag--ok",
                                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $45839ed7c4a7faa2$export$2e2bcd8739ae039), {}),
                                children: t("active")
                            }) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $602120e6d17ff12a$export$2e2bcd8739ae039), {
                                className: "pt-tag pt-tag--off",
                                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e539a200877e5e8f$export$2e2bcd8739ae039), {}),
                                children: t("inactive")
                            }),
                            row.is_available_for_task_creation ? null : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $1e5256cf9d329b2c$export$2e2bcd8739ae039), {
                                title: t("f_available_tasks"),
                                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $602120e6d17ff12a$export$2e2bcd8739ae039), {
                                    className: "pt-tag pt-tag--muted",
                                    icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $4d7cc9843b581604$export$2e2bcd8739ae039), {}),
                                    children: t("no_tasks")
                                })
                            })
                        ]
                    })
            },
            (0, $66539b2560a58e4e$export$b0493221521ca587)((value, row)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $66539b2560a58e4e$export$523acc1bb0ce2e43), {
                    label: tv("row_actions"),
                    items: [
                        {
                            key: "open",
                            icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $1141984d2e96fc67$export$2e2bcd8739ae039), {}),
                            label: t("open_editor")
                        },
                        row.is_removed ? {
                            key: "restore",
                            icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $89531e4b0315317b$export$2e2bcd8739ae039), {}),
                            label: t("restore_btn")
                        } : {
                            key: "archive",
                            icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $268dc9f9b8c7fd21$export$2e2bcd8739ae039), {}),
                            label: t("archive_btn"),
                            danger: true
                        }
                    ],
                    onClick: (key)=>{
                        if (key === "open") openEditor(row);
                        else confirmArchive([
                            row
                        ], key === "restore");
                    }
                }))
        ], // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        lang,
        rows
    ]);
    const scrollY = (0, $66539b2560a58e4e$export$f44b992e82788e9)();
    /* The selected rows themselves — the bulk bar archives them, and "Add to group" needs their
     names, not just their ids. */ const targets = rows.filter((row)=>selected.includes(row.id));
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
        vertical: true,
        gap: "middle",
        className: "shell-content lp pt",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                className: "lp-head",
                justify: "space-between",
                align: "flex-end",
                gap: "middle",
                wrap: true,
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                        vertical: true,
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Title, {
                                level: 1,
                                className: "lp-title",
                                children: t("points_title")
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Paragraph, {
                                type: "secondary",
                                className: "lp-sub",
                                children: t("points_sub")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                        type: "primary",
                        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $fa25166ced813feb$export$2e2bcd8739ae039), {}),
                        onClick: ()=>history.push("/points/new"),
                        children: t("new_point")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b4fda840b736e640$export$2e2bcd8739ae039), {
                className: "lp-filters",
                variant: "outlined",
                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039), {
                    layout: "vertical",
                    component: false,
                    colon: false,
                    children: [
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $db6c3adada49524e$export$2e2bcd8739ae039), {
                            gutter: [
                                12,
                                12
                            ],
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $cde227eb983ae1d2$export$2e2bcd8739ae039), {
                                    ...$038bb54df492679d$var$FIELD_COL,
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                        label: tp("search") || t("search_ph"),
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0883e7f8083c01b0$export$2e2bcd8739ae039), {
                                            allowClear: true,
                                            prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $20a259d46bffcb08$export$2e2bcd8739ae039), {}),
                                            placeholder: t("search_point_ph"),
                                            value: typed,
                                            onChange: (event)=>setTyped(event.target.value)
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $cde227eb983ae1d2$export$2e2bcd8739ae039), {
                                    ...$038bb54df492679d$var$FIELD_COL,
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                        label: t("f_network"),
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b6929c6a194abc34$export$2e2bcd8739ae039), {
                                            entity: "network",
                                            value: network,
                                            seed: chosen.network,
                                            prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $68e85fc2f9283018$export$2e2bcd8739ae039), {}),
                                            onChange: narrow((option)=>{
                                                rememberChosen("network", option);
                                                setNetwork(option ? $038bb54df492679d$var$idOf(option) : "");
                                            }),
                                            onResolve: remember("network")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $cde227eb983ae1d2$export$2e2bcd8739ae039), {
                                    ...$038bb54df492679d$var$FIELD_COL,
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                        label: t("f_county"),
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b6929c6a194abc34$export$2e2bcd8739ae039), {
                                            entity: "county",
                                            value: county,
                                            seed: chosen.county || (me?.county && typeof me.county === "object" ? me.county : null),
                                            prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $68eebcef827bb540$export$2e2bcd8739ae039), {}),
                                            onChange: narrow((option)=>{
                                                rememberChosen("county", option);
                                                setCounty(option ? $038bb54df492679d$var$idOf(option) : "");
                                                /* The old locality may not exist in the new county — clear it (mockup). */ setLocality("");
                                                rememberChosen("locality", null);
                                            }),
                                            onResolve: remember("county")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $cde227eb983ae1d2$export$2e2bcd8739ae039), {
                                    ...$038bb54df492679d$var$FIELD_COL,
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                        label: t("f_locality"),
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b6929c6a194abc34$export$2e2bcd8739ae039), {
                                            entity: "locality",
                                            value: locality,
                                            seed: chosen.locality,
                                            prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $d6c8837c82724a15$export$2e2bcd8739ae039), {}),
                                            extraQuery: county ? {
                                                county: $038bb54df492679d$var$idOf(county)
                                            } : undefined,
                                            onChange: narrow((option)=>{
                                                rememberChosen("locality", option);
                                                setLocality(option ? $038bb54df492679d$var$idOf(option) : "");
                                            }),
                                            onResolve: remember("locality")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $cde227eb983ae1d2$export$2e2bcd8739ae039), {
                                    ...$038bb54df492679d$var$FIELD_COL,
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                        label: t("f_category"),
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b6929c6a194abc34$export$2e2bcd8739ae039), {
                                            entity: "categories_point",
                                            value: category,
                                            seed: chosen.category,
                                            prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e6f9777135677668$export$2e2bcd8739ae039), {}),
                                            onChange: narrow((option)=>{
                                                rememberChosen("category", option);
                                                setCategory(option ? $038bb54df492679d$var$idOf(option) : "");
                                            }),
                                            onResolve: remember("category")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $cde227eb983ae1d2$export$2e2bcd8739ae039), {
                                    ...$038bb54df492679d$var$FIELD_COL,
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                        label: t("f_merchandiser"),
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b6929c6a194abc34$export$2e2bcd8739ae039), {
                                            entity: "merchandiser",
                                            value: merch,
                                            seed: chosen.merch,
                                            prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e85f2e3cc711f245$export$2e2bcd8739ae039), {}),
                                            onChange: narrow((option)=>{
                                                rememberChosen("merch", option);
                                                setMerch(option ? $038bb54df492679d$var$idOf(option) : "");
                                            }),
                                            onResolve: remember("merch")
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $a9e321bb60aaf998$export$2e2bcd8739ae039), {
                            className: "lp-chips",
                            items: chips,
                            closeLabel: tp("a_remove_filter"),
                            onClose: clearChip
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                            className: "lp-filters__foot",
                            align: "center",
                            gap: "small",
                            wrap: true,
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $ac40310dc424be23$export$2e2bcd8739ae039), {
                                    value: segment,
                                    onChange: narrow(setSegment),
                                    options: $038bb54df492679d$var$SEGMENTS.map(([value, key])=>({
                                            value: value,
                                            label: t(key)
                                        }))
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $602120e6d17ff12a$export$2e2bcd8739ae039).CheckableTag, {
                                    className: "pt-chip",
                                    checked: noGeo,
                                    onChange: narrow(setNoGeo),
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $eb1133c43d00490b$export$2e2bcd8739ae039), {
                                        size: 6,
                                        children: [
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $d6c8837c82724a15$export$2e2bcd8739ae039), {}),
                                            t("no_coords")
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $602120e6d17ff12a$export$2e2bcd8739ae039).CheckableTag, {
                                    className: "pt-chip",
                                    checked: noMerch,
                                    onChange: narrow(setNoMerch),
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $eb1133c43d00490b$export$2e2bcd8739ae039), {
                                        size: 6,
                                        children: [
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $8631fc7734d1e427$export$2e2bcd8739ae039), {}),
                                            t("unassigned")
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                    className: "lp-spacer"
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                    size: "small",
                                    onClick: resetFilters,
                                    children: td("filter_reset")
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $b4fda840b736e640$export$2e2bcd8739ae039), {
                className: "lp-table",
                variant: "outlined",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                        className: "lp-table__bar",
                        align: "center",
                        gap: "small",
                        wrap: true,
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                strong: true,
                                className: "lp-table__title",
                                children: t("points_title")
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                type: "secondary",
                                "aria-live": "polite",
                                children: [
                                    tp("records_count"),
                                    ": ",
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                        strong: true,
                                        children: total
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $dff4d45d201c6dfe$export$2e2bcd8739ae039), {
                        className: "lp-table__grid",
                        rowKey: "id",
                        size: "middle",
                        columns: columns,
                        dataSource: rows,
                        loading: loading,
                        scroll: {
                            x: 1180,
                            y: scrollY
                        },
                        rowClassName: (row)=>selected.includes(row.id) ? "lp-row lp-row--on" : "lp-row",
                        rowSelection: {
                            fixed: true,
                            selectedRowKeys: selected,
                            onChange: (keys)=>setSelected(keys)
                        },
                        onRow: (row)=>({
                                onClick: (event)=>{
                                    if (event.target.closest(".ant-table-selection-column, .ant-dropdown, .ant-btn")) return;
                                    openEditor(row);
                                }
                            }),
                        onChange: (pagination, filters, sorter)=>{
                            const next = sorter?.order && $038bb54df492679d$var$ORDERING[sorter.columnKey] ? {
                                key: sorter.columnKey,
                                dir: sorter.order
                            } : null;
                            if (JSON.stringify(next) === JSON.stringify(sort)) return;
                            setSort(next);
                            setPage(1);
                        },
                        pagination: false,
                        locale: {
                            emptyText: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $99350450b877904c$export$2e2bcd8739ae039), {
                                image: (0, $99350450b877904c$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE,
                                description: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                    vertical: true,
                                    gap: 4,
                                    children: [
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                            strong: true,
                                            children: t("empty_filtered")
                                        }),
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                            type: "secondary",
                                            children: t("empty")
                                        })
                                    ]
                                })
                            })
                        }
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $66539b2560a58e4e$export$6cb97cd1ceda576d), {
                        id: "pt",
                        page: page,
                        size: size,
                        total: total,
                        sizes: $038bb54df492679d$var$PAGE_SIZES,
                        labels: {
                            perPage: tv("rows_per_page"),
                            range: tv("range_of")
                        },
                        onPage: (next)=>{
                            setPage(next);
                            setSelected([]);
                        },
                        onSize: (next)=>{
                            setSize(next);
                            setPage(1);
                            setSelected([]);
                        }
                    })
                ]
            }),
            selected.length > 0 && /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                className: "lp-bulkbar",
                align: "center",
                gap: "middle",
                wrap: true,
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                        className: "lp-bulkbar__n",
                        children: (0, $3b579ca6158bc61b$export$9563e054e6f787fb)(tp("w_selected"), {
                            n: selected.length
                        })
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $eb1133c43d00490b$export$2e2bcd8739ae039), {
                        size: 8,
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                size: "small",
                                onClick: ()=>setSelected([]),
                                children: tp("clear_selection")
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $dce32b0c026318e9$export$2e2bcd8739ae039), {
                                points: targets,
                                query: query,
                                total: total,
                                currentUser: me,
                                onDone: ()=>{
                                    setSelected([]);
                                    reload();
                                }
                            }),
                            segment === "archived" ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                size: "small",
                                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $89531e4b0315317b$export$2e2bcd8739ae039), {}),
                                loading: busy,
                                onClick: ()=>confirmArchive(targets, true),
                                children: t("restore_btn")
                            }) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                size: "small",
                                danger: true,
                                type: "primary",
                                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $268dc9f9b8c7fd21$export$2e2bcd8739ae039), {}),
                                loading: busy,
                                onClick: ()=>confirmArchive(targets, false),
                                children: t("archive_btn")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $038bb54df492679d$export$2e2bcd8739ae039 = $038bb54df492679d$var$List;




var $cQmXV = parcelRequire("cQmXV");


var $cQmXV = parcelRequire("cQmXV");
var $942c242de970c60f$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($942c242de970c60f$exports, "__esModule", {
    value: true
});
var $942c242de970c60f$var$LockOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M832 464h-68V240c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM332 240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v224H332V240zm460 600H232V536h560v304zM484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 10-56 0z"
                }
            }
        ]
    },
    "name": "lock",
    "theme": "outlined"
};
$942c242de970c60f$exports.default = $942c242de970c60f$var$LockOutlined;



function $4339460c12354107$var$_extends() {
    $4339460c12354107$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4339460c12354107$var$_extends.apply(this, arguments);
}
const $4339460c12354107$var$LockOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $4339460c12354107$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($942c242de970c60f$exports)))
    }));
/**![lock](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTgzMiA0NjRoLTY4VjI0MGMwLTcwLjctNTcuMy0xMjgtMTI4LTEyOEgzODhjLTcwLjcgMC0xMjggNTcuMy0xMjggMTI4djIyNGgtNjhjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjM4NGMwIDE3LjcgMTQuMyAzMiAzMiAzMmg2NDBjMTcuNyAwIDMyLTE0LjMgMzItMzJWNDk2YzAtMTcuNy0xNC4zLTMyLTMyLTMyek0zMzIgMjQwYzAtMzAuOSAyNS4xLTU2IDU2LTU2aDI0OGMzMC45IDAgNTYgMjUuMSA1NiA1NnYyMjRIMzMyVjI0MHptNDYwIDYwMEgyMzJWNTM2aDU2MHYzMDR6TTQ4NCA3MDF2NTNjMCA0LjQgMy42IDggOCA4aDQwYzQuNCAwIDgtMy42IDgtOHYtNTNhNDguMDEgNDguMDEgMCAxMC01NiAweiIgLz48L3N2Zz4=) */ const $4339460c12354107$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($4339460c12354107$var$LockOutlined);
var $4339460c12354107$export$2e2bcd8739ae039 = $4339460c12354107$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $21dd50284685c046$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($21dd50284685c046$exports, "__esModule", {
    value: true
});
var $21dd50284685c046$var$MobileOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M744 62H280c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h464c35.3 0 64-28.7 64-64V126c0-35.3-28.7-64-64-64zm-8 824H288V134h448v752zM472 784a40 40 0 1080 0 40 40 0 10-80 0z"
                }
            }
        ]
    },
    "name": "mobile",
    "theme": "outlined"
};
$21dd50284685c046$exports.default = $21dd50284685c046$var$MobileOutlined;



function $7bf1c632e6a4cb6a$var$_extends() {
    $7bf1c632e6a4cb6a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7bf1c632e6a4cb6a$var$_extends.apply(this, arguments);
}
const $7bf1c632e6a4cb6a$var$MobileOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $7bf1c632e6a4cb6a$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($21dd50284685c046$exports)))
    }));
/**![mobile](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTc0NCA2MkgyODBjLTM1LjMgMC02NCAyOC43LTY0IDY0djc2OGMwIDM1LjMgMjguNyA2NCA2NCA2NGg0NjRjMzUuMyAwIDY0LTI4LjcgNjQtNjRWMTI2YzAtMzUuMy0yOC43LTY0LTY0LTY0em0tOCA4MjRIMjg4VjEzNGg0NDh2NzUyek00NzIgNzg0YTQwIDQwIDAgMTA4MCAwIDQwIDQwIDAgMTAtODAgMHoiIC8+PC9zdmc+) */ const $7bf1c632e6a4cb6a$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($7bf1c632e6a4cb6a$var$MobileOutlined);
var $7bf1c632e6a4cb6a$export$2e2bcd8739ae039 = $7bf1c632e6a4cb6a$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $01416f52928217e0$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($01416f52928217e0$exports, "__esModule", {
    value: true
});
var $01416f52928217e0$var$SendOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M931.4 498.9L94.9 79.5c-3.4-1.7-7.3-2.1-11-1.2a15.99 15.99 0 00-11.7 19.3l86.2 352.2c1.3 5.3 5.2 9.6 10.4 11.3l147.7 50.7-147.6 50.7c-5.2 1.8-9.1 6-10.3 11.3L72.2 926.5c-.9 3.7-.5 7.6 1.2 10.9 3.9 7.9 13.5 11.1 21.5 7.2l836.5-417c3.1-1.5 5.6-4.1 7.2-7.1 3.9-8 .7-17.6-7.2-21.6zM170.8 826.3l50.3-205.6 295.2-101.3c2.3-.8 4.2-2.6 5-5 1.4-4.2-.8-8.7-5-10.2L221.1 403 171 198.2l628 314.9-628.2 313.2z"
                }
            }
        ]
    },
    "name": "send",
    "theme": "outlined"
};
$01416f52928217e0$exports.default = $01416f52928217e0$var$SendOutlined;



function $596dfd17c3c1c62c$var$_extends() {
    $596dfd17c3c1c62c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $596dfd17c3c1c62c$var$_extends.apply(this, arguments);
}
const $596dfd17c3c1c62c$var$SendOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $596dfd17c3c1c62c$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($01416f52928217e0$exports)))
    }));
/**![send](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkzMS40IDQ5OC45TDk0LjkgNzkuNWMtMy40LTEuNy03LjMtMi4xLTExLTEuMmExNS45OSAxNS45OSAwIDAwLTExLjcgMTkuM2w4Ni4yIDM1Mi4yYzEuMyA1LjMgNS4yIDkuNiAxMC40IDExLjNsMTQ3LjcgNTAuNy0xNDcuNiA1MC43Yy01LjIgMS44LTkuMSA2LTEwLjMgMTEuM0w3Mi4yIDkyNi41Yy0uOSAzLjctLjUgNy42IDEuMiAxMC45IDMuOSA3LjkgMTMuNSAxMS4xIDIxLjUgNy4ybDgzNi41LTQxN2MzLjEtMS41IDUuNi00LjEgNy4yLTcuMSAzLjktOCAuNy0xNy42LTcuMi0yMS42ek0xNzAuOCA4MjYuM2w1MC4zLTIwNS42IDI5NS4yLTEwMS4zYzIuMy0uOCA0LjItMi42IDUtNSAxLjQtNC4yLS44LTguNy01LTEwLjJMMjIxLjEgNDAzIDE3MSAxOTguMmw2MjggMzE0LjktNjI4LjIgMzEzLjJ6IiAvPjwvc3ZnPg==) */ const $596dfd17c3c1c62c$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($596dfd17c3c1c62c$var$SendOutlined);
var $596dfd17c3c1c62c$export$2e2bcd8739ae039 = $596dfd17c3c1c62c$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $db414dea2d253c91$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($db414dea2d253c91$exports, "__esModule", {
    value: true
});
var $db414dea2d253c91$var$SafetyCertificateOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6zm-405.8-201c-3-4.1-7.8-6.6-13-6.6H336c-6.5 0-10.3 7.4-6.5 12.7l126.4 174a16.1 16.1 0 0026 0l212.6-292.7c3.8-5.3 0-12.7-6.5-12.7h-55.2c-5.1 0-10 2.5-13 6.6L468.9 542.4l-64.7-89.1z"
                }
            }
        ]
    },
    "name": "safety-certificate",
    "theme": "outlined"
};
$db414dea2d253c91$exports.default = $db414dea2d253c91$var$SafetyCertificateOutlined;



function $6effa71513971c73$var$_extends() {
    $6effa71513971c73$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6effa71513971c73$var$_extends.apply(this, arguments);
}
const $6effa71513971c73$var$SafetyCertificateOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $6effa71513971c73$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($db414dea2d253c91$exports)))
    }));
/**![safety-certificate](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg2Ni45IDE2OS45TDUyNy4xIDU0LjFDNTIzIDUyLjcgNTE3LjUgNTIgNTEyIDUycy0xMSAuNy0xNS4xIDIuMUwxNTcuMSAxNjkuOWMtOC4zIDIuOC0xNS4xIDEyLjQtMTUuMSAyMS4ydjQ4Mi40YzAgOC44IDUuNyAyMC40IDEyLjYgMjUuOUw0OTkuMyA5NjhjMy41IDIuNyA4IDQuMSAxMi42IDQuMXM5LjItMS40IDEyLjYtNC4xbDM0NC43LTI2OC42YzYuOS01LjQgMTIuNi0xNyAxMi42LTI1LjlWMTkxLjFjLjItOC44LTYuNi0xOC4zLTE0LjktMjEuMnpNODEwIDY1NC4zTDUxMiA4ODYuNSAyMTQgNjU0LjNWMjI2LjdsMjk4LTEwMS42IDI5OCAxMDEuNnY0MjcuNnptLTQwNS44LTIwMWMtMy00LjEtNy44LTYuNi0xMy02LjZIMzM2Yy02LjUgMC0xMC4zIDcuNC02LjUgMTIuN2wxMjYuNCAxNzRhMTYuMSAxNi4xIDAgMDAyNiAwbDIxMi42LTI5Mi43YzMuOC01LjMgMC0xMi43LTYuNS0xMi43aC01NS4yYy01LjEgMC0xMCAyLjUtMTMgNi42TDQ2OC45IDU0Mi40bC02NC43LTg5LjF6IiAvPjwvc3ZnPg==) */ const $6effa71513971c73$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($6effa71513971c73$var$SafetyCertificateOutlined);
var $6effa71513971c73$export$2e2bcd8739ae039 = $6effa71513971c73$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $860b3cc4b1818a5e$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($860b3cc4b1818a5e$exports, "__esModule", {
    value: true
});
var $860b3cc4b1818a5e$var$ReloadOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M909.1 209.3l-56.4 44.1C775.8 155.1 656.2 92 521.9 92 290 92 102.3 279.5 102 511.5 101.7 743.7 289.8 932 521.9 932c181.3 0 335.8-115 394.6-276.1 1.5-4.2-.7-8.9-4.9-10.3l-56.7-19.5a8 8 0 00-10.1 4.8c-1.8 5-3.8 10-5.9 14.9-17.3 41-42.1 77.8-73.7 109.4A344.77 344.77 0 01655.9 829c-42.3 17.9-87.4 27-133.8 27-46.5 0-91.5-9.1-133.8-27A341.5 341.5 0 01279 755.2a342.16 342.16 0 01-73.7-109.4c-17.9-42.4-27-87.4-27-133.9s9.1-91.5 27-133.9c17.3-41 42.1-77.8 73.7-109.4 31.6-31.6 68.4-56.4 109.3-73.8 42.3-17.9 87.4-27 133.8-27 46.5 0 91.5 9.1 133.8 27a341.5 341.5 0 01109.3 73.8c9.9 9.9 19.2 20.4 27.8 31.4l-60.2 47a8 8 0 003 14.1l175.6 43c5 1.2 9.9-2.6 9.9-7.7l.8-180.9c-.1-6.6-7.8-10.3-13-6.2z"
                }
            }
        ]
    },
    "name": "reload",
    "theme": "outlined"
};
$860b3cc4b1818a5e$exports.default = $860b3cc4b1818a5e$var$ReloadOutlined;



function $d27e4ec0a39831fe$var$_extends() {
    $d27e4ec0a39831fe$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d27e4ec0a39831fe$var$_extends.apply(this, arguments);
}
const $d27e4ec0a39831fe$var$ReloadOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $d27e4ec0a39831fe$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($860b3cc4b1818a5e$exports)))
    }));
/**![reload](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkwOS4xIDIwOS4zbC01Ni40IDQ0LjFDNzc1LjggMTU1LjEgNjU2LjIgOTIgNTIxLjkgOTIgMjkwIDkyIDEwMi4zIDI3OS41IDEwMiA1MTEuNSAxMDEuNyA3NDMuNyAyODkuOCA5MzIgNTIxLjkgOTMyYzE4MS4zIDAgMzM1LjgtMTE1IDM5NC42LTI3Ni4xIDEuNS00LjItLjctOC45LTQuOS0xMC4zbC01Ni43LTE5LjVhOCA4IDAgMDAtMTAuMSA0LjhjLTEuOCA1LTMuOCAxMC01LjkgMTQuOS0xNy4zIDQxLTQyLjEgNzcuOC03My43IDEwOS40QTM0NC43NyAzNDQuNzcgMCAwMTY1NS45IDgyOWMtNDIuMyAxNy45LTg3LjQgMjctMTMzLjggMjctNDYuNSAwLTkxLjUtOS4xLTEzMy44LTI3QTM0MS41IDM0MS41IDAgMDEyNzkgNzU1LjJhMzQyLjE2IDM0Mi4xNiAwIDAxLTczLjctMTA5LjRjLTE3LjktNDIuNC0yNy04Ny40LTI3LTEzMy45czkuMS05MS41IDI3LTEzMy45YzE3LjMtNDEgNDIuMS03Ny44IDczLjctMTA5LjQgMzEuNi0zMS42IDY4LjQtNTYuNCAxMDkuMy03My44IDQyLjMtMTcuOSA4Ny40LTI3IDEzMy44LTI3IDQ2LjUgMCA5MS41IDkuMSAxMzMuOCAyN2EzNDEuNSAzNDEuNSAwIDAxMTA5LjMgNzMuOGM5LjkgOS45IDE5LjIgMjAuNCAyNy44IDMxLjRsLTYwLjIgNDdhOCA4IDAgMDAzIDE0LjFsMTc1LjYgNDNjNSAxLjIgOS45LTIuNiA5LjktNy43bC44LTE4MC45Yy0uMS02LjYtNy44LTEwLjMtMTMtNi4yeiIgLz48L3N2Zz4=) */ const $d27e4ec0a39831fe$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($d27e4ec0a39831fe$var$ReloadOutlined);
var $d27e4ec0a39831fe$export$2e2bcd8739ae039 = $d27e4ec0a39831fe$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $af4a5e1d3027efb4$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($af4a5e1d3027efb4$exports, "__esModule", {
    value: true
});
var $af4a5e1d3027efb4$var$TranslationOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M140 188h584v164h76V144c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h544v-76H140V188z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M414.3 256h-60.6c-3.4 0-6.4 2.2-7.6 5.4L219 629.4c-.3.8-.4 1.7-.4 2.6 0 4.4 3.6 8 8 8h55.1c3.4 0 6.4-2.2 7.6-5.4L322 540h196.2L422 261.4a8.42 8.42 0 00-7.7-5.4zm12.4 228h-85.5L384 360.2 426.7 484zM936 528H800v-93c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v93H592c-13.3 0-24 10.7-24 24v176c0 13.3 10.7 24 24 24h136v152c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V752h136c13.3 0 24-10.7 24-24V552c0-13.3-10.7-24-24-24zM728 680h-88v-80h88v80zm160 0h-88v-80h88v80z"
                }
            }
        ]
    },
    "name": "translation",
    "theme": "outlined"
};
$af4a5e1d3027efb4$exports.default = $af4a5e1d3027efb4$var$TranslationOutlined;



function $6c6258c9201cb746$var$_extends() {
    $6c6258c9201cb746$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6c6258c9201cb746$var$_extends.apply(this, arguments);
}
const $6c6258c9201cb746$var$TranslationOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $6c6258c9201cb746$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($af4a5e1d3027efb4$exports)))
    }));
/**![translation](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTE0MCAxODhoNTg0djE2NGg3NlYxNDRjMC0xNy43LTE0LjMtMzItMzItMzJIOTZjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjczNmMwIDE3LjcgMTQuMyAzMiAzMiAzMmg1NDR2LTc2SDE0MFYxODh6IiAvPjxwYXRoIGQ9Ik00MTQuMyAyNTZoLTYwLjZjLTMuNCAwLTYuNCAyLjItNy42IDUuNEwyMTkgNjI5LjRjLS4zLjgtLjQgMS43LS40IDIuNiAwIDQuNCAzLjYgOCA4IDhoNTUuMWMzLjQgMCA2LjQtMi4yIDcuNi01LjRMMzIyIDU0MGgxOTYuMkw0MjIgMjYxLjRhOC40MiA4LjQyIDAgMDAtNy43LTUuNHptMTIuNCAyMjhoLTg1LjVMMzg0IDM2MC4yIDQyNi43IDQ4NHpNOTM2IDUyOEg4MDB2LTkzYzAtNC40LTMuNi04LTgtOGgtNTZjLTQuNCAwLTggMy42LTggOHY5M0g1OTJjLTEzLjMgMC0yNCAxMC43LTI0IDI0djE3NmMwIDEzLjMgMTAuNyAyNCAyNCAyNGgxMzZ2MTUyYzAgNC40IDMuNiA4IDggOGg1NmM0LjQgMCA4LTMuNiA4LThWNzUyaDEzNmMxMy4zIDAgMjQtMTAuNyAyNC0yNFY1NTJjMC0xMy4zLTEwLjctMjQtMjQtMjR6TTcyOCA2ODBoLTg4di04MGg4OHY4MHptMTYwIDBoLTg4di04MGg4OHY4MHoiIC8+PC9zdmc+) */ const $6c6258c9201cb746$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($6c6258c9201cb746$var$TranslationOutlined);
var $6c6258c9201cb746$export$2e2bcd8739ae039 = $6c6258c9201cb746$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $aa18f684ea10a962$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($aa18f684ea10a962$exports, "__esModule", {
    value: true
});
var $aa18f684ea10a962$var$InfoCircleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M464 336a48 48 0 1096 0 48 48 0 10-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "info-circle",
    "theme": "outlined"
};
$aa18f684ea10a962$exports.default = $aa18f684ea10a962$var$InfoCircleOutlined;



function $67c3a41cb5427986$var$_extends() {
    $67c3a41cb5427986$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $67c3a41cb5427986$var$_extends.apply(this, arguments);
}
const $67c3a41cb5427986$var$InfoCircleOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $67c3a41cb5427986$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($aa18f684ea10a962$exports)))
    }));
/**![info-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0wIDgyMGMtMjA1LjQgMC0zNzItMTY2LjYtMzcyLTM3MnMxNjYuNi0zNzIgMzcyLTM3MiAzNzIgMTY2LjYgMzcyIDM3Mi0xNjYuNiAzNzItMzcyIDM3MnoiIC8+PHBhdGggZD0iTTQ2NCAzMzZhNDggNDggMCAxMDk2IDAgNDggNDggMCAxMC05NiAwem03MiAxMTJoLTQ4Yy00LjQgMC04IDMuNi04IDh2MjcyYzAgNC40IDMuNiA4IDggOGg0OGM0LjQgMCA4LTMuNiA4LThWNDU2YzAtNC40LTMuNi04LTgtOHoiIC8+PC9zdmc+) */ const $67c3a41cb5427986$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($67c3a41cb5427986$var$InfoCircleOutlined);
var $67c3a41cb5427986$export$2e2bcd8739ae039 = $67c3a41cb5427986$var$RefIcon;











/** Only these are editable; everything else on the record is read-only here. */ const $464b3d7a8ec63582$var$EDITABLE = [
    "first_name",
    "last_name",
    "position",
    "telegram_id",
    "county",
    "language"
];
const $464b3d7a8ec63582$var$ROLE_KEY = {
    supervisor_manager: "role_supervisor_manager",
    supervisor: "role_supervisor"
};
/** A handle, with or without the leading @; the server is the authority beyond this. */ const $464b3d7a8ec63582$var$isTelegram = (v)=>!v || /^@?[A-Za-z0-9_]{5,32}$/.test(v.trim());
const $464b3d7a8ec63582$var$initialsOf = (me)=>((me?.first_name?.[0] || "") + (me?.last_name?.[0] || "")).toUpperCase() || "?";
/** county may arrive as a full object or a bare id depending on how it was last written. */ const $464b3d7a8ec63582$var$countyId = (c)=>(c && typeof c === "object" ? c.id : c) ?? null;
function $464b3d7a8ec63582$var$Avatar({ src: src, initials: initials, large: large, onError: onError }) {
    const cls = `pf-avatar${large ? " pf-avatar--lg" : ""}`;
    /* A stored photo whose file no longer exists is common on old records — this account's
     points at a 2021 upload that 404s. Without the fallback the page shows a broken image. */ if (src) return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("img", {
        className: `${cls} pf-avatar--img`,
        src: src,
        alt: "",
        onError: onError
    });
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
        className: cls,
        "aria-hidden": "true",
        children: initials
    });
}
/** A locked, non-editable value — the design's `control--ro`. */ function $464b3d7a8ec63582$var$ReadOnlyField({ label: label, icon: icon, value: value, hint: hint }) {
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
        className: "pf-field",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                className: "pf-label",
                children: [
                    label,
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $4339460c12354107$export$2e2bcd8739ae039), {
                        className: "pf-lock",
                        "aria-hidden": "true"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                className: "pf-ro",
                children: [
                    icon,
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        children: value || "\u2014"
                    })
                ]
            }),
            hint ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                className: "pf-hint",
                children: hint
            }) : null
        ]
    });
}
/** Label with the design's trailing required asterisk. antd's own mark sits before the text. */ function $464b3d7a8ec63582$var$Req({ children: children }) {
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $575603080129eb00$exports.Fragment), {
        children: [
            children,
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                className: "pf-req",
                "aria-hidden": "true",
                children: " *"
            })
        ]
    });
}
/** Tinted note box — the design's own palette rather than antd Alert's. */ function $464b3d7a8ec63582$var$Note({ tone: tone, icon: icon, children: children }) {
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("p", {
        className: `pf-note${tone === "warn" ? " pf-note--warn" : ""}`,
        children: [
            icon,
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                children: children
            })
        ]
    });
}
function $464b3d7a8ec63582$var$Section({ title: title, desc: desc, children: children }) {
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("section", {
        className: "pf-card",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                className: "pf-card__head",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("h2", {
                        className: "pf-card__title",
                        children: title
                    }),
                    desc ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("p", {
                        className: "pf-card__desc",
                        children: desc
                    }) : null
                ]
            }),
            children
        ]
    });
}
function $464b3d7a8ec63582$export$2e2bcd8739ae039() {
    const me = (0, $b83e93e5ef3de8b0$export$2105062e25df4afe)((state)=>state.me);
    const dispatch = (0, $b83e93e5ef3de8b0$export$8ad76b76a4c905f8)();
    const langCtx = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useContext((0, $422de08ffd33db6b$export$214e5fb64d34c1fc));
    const [form] = (0, $e9904e0132e26ce3$export$2e2bcd8739ae039).useForm();
    const [counties, setCounties] = (0, $cQmXV.useState)([]);
    const [loadingCounties, setLoadingCounties] = (0, $cQmXV.useState)(true);
    const [saving, setSaving] = (0, $cQmXV.useState)(false);
    const [dirty, setDirty] = (0, $cQmXV.useState)(false);
    /** A staged photo: `File` to upload, `null` to clear, `undefined` to leave alone. */ const [photo, setPhoto] = (0, $cQmXV.useState)(undefined);
    const [preview, setPreview] = (0, $cQmXV.useState)(null);
    const [imgFailed, setImgFailed] = (0, $cQmXV.useState)(false);
    const fileRef = (0, $cQmXV.useRef)(null);
    /* `me.language` drives the copy, and it is also an editable field — so labels follow the
   *saved* language, not the pending selection. Changing it needs a reload to take effect. */ const lang = me?.language;
    const t = (0, $cQmXV.useCallback)((key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$e24f02e1b5477764), key, lang), [
        lang
    ]);
    const tp = (0, $cQmXV.useCallback)((key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$7926257c0571e339), key, lang), [
        lang
    ]);
    const pristine = (0, $cQmXV.useMemo)(()=>{
        const out = {};
        for (const k of $464b3d7a8ec63582$var$EDITABLE)out[k] = k === "county" ? $464b3d7a8ec63582$var$countyId(me?.[k]) : me?.[k] ?? null;
        return out;
    }, [
        me
    ]);
    (0, $cQmXV.useEffect)(()=>{
        form.setFieldsValue(pristine);
        setDirty(false);
        setPhoto(undefined);
        setPreview(null);
    }, [
        pristine,
        form
    ]);
    /* The region list is small and closed, so one fetch beats a paged async select. */ (0, $cQmXV.useEffect)(()=>{
        let alive = true;
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "GET",
            url: "counties/?active=true"
        }, (r)=>{
            if (!alive) return;
            setCounties(Array.isArray(r?.results) ? r.results : Array.isArray(r) ? r : []);
            setLoadingCounties(false);
        });
        return ()=>{
            alive = false;
        };
    }, []);
    /* Object URLs are a leak if they are never revoked. */ (0, $cQmXV.useEffect)(()=>()=>preview && URL.revokeObjectURL(preview), [
        preview
    ]);
    const recomputeDirty = (0, $cQmXV.useCallback)(()=>{
        const now = form.getFieldsValue($464b3d7a8ec63582$var$EDITABLE);
        const changed = $464b3d7a8ec63582$var$EDITABLE.some((k)=>(now[k] ?? null) !== (pristine[k] ?? null));
        setDirty(changed || photo !== undefined);
    }, [
        form,
        pristine,
        photo
    ]);
    (0, $cQmXV.useEffect)(recomputeDirty, [
        photo,
        recomputeDirty
    ]);
    const pickPhoto = (file)=>{
        if (!file) return;
        setPhoto(file);
        setImgFailed(false);
        setPreview((prev)=>{
            if (prev) URL.revokeObjectURL(prev);
            return URL.createObjectURL(file);
        });
    };
    const discard = ()=>{
        form.setFieldsValue(pristine);
        setPhoto(undefined);
        setPreview((prev)=>{
            if (prev) URL.revokeObjectURL(prev);
            return null;
        });
        setDirty(false);
    };
    const submit = (values)=>{
        setSaving(true);
        const prevLanguage = me?.language;
        const done = (r)=>{
            setSaving(false);
            if (!r || !r.id) {
                (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).warning("Error while saving. " + JSON.stringify(r), {
                    position: "bottom-right"
                });
                return;
            }
            /* A photo change the server did not apply must not report success. `photo: ""` used to be
         dropped silently by DRF (HTTP 200, field untouched), so the page cheerfully said "saved"
         while the avatar stayed put — which is exactly how this looked like a UI bug. */ if (photo !== undefined && photo === null === !!r.photo) {
                /* Deliberately no dispatch: updating `me` recomputes the pristine snapshot, which resets
           the form and throws away the staged photo — so a failed save would silently discard
           what the user asked for. Leaving it dirty keeps Save available for a retry. The other
           fields did persist; the local copy catches up on the next successful save or reload. */ (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).warning("Error while saving. " + JSON.stringify({
                    photo: r.photo ?? null
                }), {
                    position: "bottom-right"
                });
                return;
            }
            dispatch((0, $cca4416321e611bf$export$953a134f6e0e87ac)({
                ...me,
                ...r
            }));
            if (r.language !== prevLanguage) {
                /* Almost every screen reads me.language at render time from persisted state, so a
           reload is still how a language change reaches the whole app. */ (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success(tp("save_success_reload"), {
                    position: "bottom-right",
                    timeout: 1000
                });
                setTimeout(()=>window.location.reload(), 250);
                return;
            }
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success(tp("save_success"), {
                position: "bottom-right"
            });
            langCtx?.updateLangFn?.();
            setDirty(false);
            setPhoto(undefined);
        };
        /* PATCH, not PUT: only the fields on this form should ever be written, and a partial PUT
       would blank whatever the serializer accepts but this page does not show. */ if (photo === undefined) {
            /* ⚠ allowClear yields `county: undefined`, and JSON.stringify DROPS undefined keys — so
         clearing the region never reached the server (HTTP 200, field untouched). null survives
         serialisation, and the column is SET_NULL. */ (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
                method: "PATCH",
                url: `users/${me.id}/`,
                post: {
                    ...values,
                    county: values.county ?? null
                }
            }, done);
            return;
        }
        /* A photo change has to go as multipart. An empty string is how the API clears a FileField. */ const fd = new FormData();
        for (const k of $464b3d7a8ec63582$var$EDITABLE){
            const v = values[k];
            if (v !== null && v !== undefined && v !== "") fd.append(k, v);
        }
        /* Multipart cannot say null; '' is the cleared value — DRF's Field.get_value maps '' to None
       when allow_null is set, which a null=True FK gets automatically. */ if (values.county === undefined || values.county === null) fd.append("county", "");
        fd.append("photo", photo === null ? "" : photo);
        (0, $c9936523dc38c641$export$e9af2f996ea0b059)({
            method: "PATCH",
            url: `users/${me.id}/`,
            post: fd
        }, done);
    };
    const storedPhoto = photo === null ? null : preview || me?.photo || null;
    const photoSrc = imgFailed && !preview ? null : storedPhoto;
    /* Offered whenever a photo is *recorded*, even if its file is missing — clearing the stale
     reference is exactly what Remove is for. */ const canRemove = storedPhoto !== null;
    const initials = $464b3d7a8ec63582$var$initialsOf(me);
    const fullName = `${me?.first_name || ""} ${me?.last_name || ""}`.trim();
    const roleLabel = $464b3d7a8ec63582$var$ROLE_KEY[me?.role] ? t($464b3d7a8ec63582$var$ROLE_KEY[me.role]) : me?.role || "";
    const languageChanged = (0, $e9904e0132e26ce3$export$2e2bcd8739ae039).useWatch("language", form) !== pristine.language;
    const currentCounty = counties.find((c)=>c.id === $464b3d7a8ec63582$var$countyId(me?.county));
    const currentLang = (0, $2753457ad00c82b6$export$b4b5a31092c79bca).find((l)=>l.code === lang);
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
        className: "shell-content pf",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                className: "pf-head",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("h1", {
                        className: "pf-title",
                        children: tp("my_profile")
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("p", {
                        className: "pf-sub",
                        children: t("profile_sub")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039), {
                form: form,
                className: "pf-grid",
                layout: "vertical",
                requiredMark: false,
                onFinish: submit,
                onValuesChange: recomputeDirty,
                validateTrigger: "onChange",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                        className: "pf-main",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)($464b3d7a8ec63582$var$Section, {
                                title: t("sec_identity"),
                                desc: t("sec_identity_desc"),
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                                        className: "pf-avarow",
                                        children: [
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($464b3d7a8ec63582$var$Avatar, {
                                                src: photoSrc,
                                                initials: initials,
                                                large: true,
                                                onError: ()=>setImgFailed(true)
                                            }),
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                                                className: "pf-avaacts",
                                                children: [
                                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                                                        className: "pf-avabtns",
                                                        children: [
                                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                                                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $08a66dd72a6d5552$export$2e2bcd8739ae039), {}),
                                                                onClick: ()=>fileRef.current?.click(),
                                                                children: t("upload_photo")
                                                            }),
                                                            canRemove ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                                                danger: true,
                                                                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5234c28d879e38c1$export$2e2bcd8739ae039), {}),
                                                                onClick: ()=>{
                                                                    setPhoto(null);
                                                                    setPreview(null);
                                                                },
                                                                children: t("remove_photo")
                                                            }) : null,
                                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("input", {
                                                                ref: fileRef,
                                                                id: "photo",
                                                                name: "photo",
                                                                type: "file",
                                                                accept: "image/*",
                                                                hidden: true,
                                                                onChange: (e)=>pickPhoto(e.target.files?.[0])
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                                        className: "pf-hint",
                                                        children: t("photo_hint")
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                                        className: "pf-row",
                                        children: [
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                                name: "first_name",
                                                label: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($464b3d7a8ec63582$var$Req, {
                                                    children: tp("name")
                                                }),
                                                required: true,
                                                rules: [
                                                    {
                                                        required: true,
                                                        whitespace: true,
                                                        message: t("err_required")
                                                    }
                                                ],
                                                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0883e7f8083c01b0$export$2e2bcd8739ae039), {
                                                    size: "large",
                                                    autoComplete: "given-name"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                                name: "last_name",
                                                label: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($464b3d7a8ec63582$var$Req, {
                                                    children: tp("surname")
                                                }),
                                                required: true,
                                                rules: [
                                                    {
                                                        required: true,
                                                        whitespace: true,
                                                        message: t("err_required")
                                                    }
                                                ],
                                                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0883e7f8083c01b0$export$2e2bcd8739ae039), {
                                                    size: "large",
                                                    autoComplete: "family-name"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                        name: "position",
                                        label: tp("position"),
                                        extra: t("position_hint"),
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0883e7f8083c01b0$export$2e2bcd8739ae039), {
                                            size: "large",
                                            autoComplete: "organization-title"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)($464b3d7a8ec63582$var$Section, {
                                title: t("sec_contact"),
                                desc: t("sec_contact_desc"),
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($464b3d7a8ec63582$var$ReadOnlyField, {
                                        label: t("phone"),
                                        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $7bf1c632e6a4cb6a$export$2e2bcd8739ae039), {}),
                                        value: me?.phone_number,
                                        hint: t("phone_hint")
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                        name: "telegram_id",
                                        label: tp("telegram"),
                                        extra: t("telegram_hint"),
                                        rules: [
                                            {
                                                validator: (_, v)=>$464b3d7a8ec63582$var$isTelegram(v) ? Promise.resolve() : Promise.reject(new Error(t("err_telegram")))
                                            }
                                        ],
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0883e7f8083c01b0$export$2e2bcd8739ae039), {
                                            size: "large",
                                            prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $596dfd17c3c1c62c$export$2e2bcd8739ae039), {}),
                                            placeholder: "@username"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)($464b3d7a8ec63582$var$Section, {
                                title: t("sec_work"),
                                desc: t("sec_work_desc"),
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                        name: "county",
                                        label: tp("my_region"),
                                        extra: t("region_hint"),
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $872fd39f1285217b$export$2e2bcd8739ae039), {
                                            size: "large",
                                            showSearch: true,
                                            allowClear: true,
                                            loading: loadingCounties,
                                            optionFilterProp: "label",
                                            suffixIcon: loadingCounties ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $62b8cbcd99b9ffa2$export$2e2bcd8739ae039), {
                                                size: "small"
                                            }) : undefined,
                                            options: counties.map((c)=>({
                                                    value: c.id,
                                                    label: c.name
                                                }))
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                                        className: "pf-row",
                                        children: [
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($464b3d7a8ec63582$var$ReadOnlyField, {
                                                label: t("role"),
                                                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $6effa71513971c73$export$2e2bcd8739ae039), {}),
                                                value: roleLabel
                                            }),
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($464b3d7a8ec63582$var$ReadOnlyField, {
                                                label: t("company"),
                                                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $6238f9dab5cff517$export$2e2bcd8739ae039), {}),
                                                value: me?.company?.name
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                        className: "pf-hint",
                                        children: t("readonly_hint")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)($464b3d7a8ec63582$var$Section, {
                                title: t("sec_prefs"),
                                desc: t("sec_prefs_desc"),
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                        name: "language",
                                        label: tp("language"),
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $872fd39f1285217b$export$2e2bcd8739ae039), {
                                            size: "large",
                                            options: (0, $2753457ad00c82b6$export$b4b5a31092c79bca).map((l)=>({
                                                    value: l.code,
                                                    label: l.native ? `${l.label} \xb7 ${l.native}` : l.label
                                                }))
                                        })
                                    }),
                                    languageChanged ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($464b3d7a8ec63582$var$Note, {
                                        tone: "warn",
                                        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $d27e4ec0a39831fe$export$2e2bcd8739ae039), {}),
                                        children: t("language_reload_warn")
                                    }) : null
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("aside", {
                        className: "pf-rail",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("section", {
                                className: "pf-card pf-idcard",
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($464b3d7a8ec63582$var$Avatar, {
                                        src: photoSrc,
                                        initials: initials,
                                        large: true,
                                        onError: ()=>setImgFailed(true)
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                                        className: "pf-idcard__name",
                                        children: fullName || "\u2014"
                                    }),
                                    me?.position ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                                        className: "pf-idcard__pos",
                                        children: me.position
                                    }) : null,
                                    roleLabel ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                                        className: "pf-badge",
                                        children: [
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e85f2e3cc711f245$export$2e2bcd8739ae039), {}),
                                            roleLabel
                                        ]
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("section", {
                                className: "pf-card",
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                                        className: "pf-card__head",
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("h2", {
                                            className: "pf-card__title",
                                            children: t("account")
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("ul", {
                                        className: "pf-facts",
                                        children: [
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $7bf1c632e6a4cb6a$export$2e2bcd8739ae039), {}),
                                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                                        className: "pf-facts__k",
                                                        children: t("phone")
                                                    }),
                                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                                        className: "pf-facts__v",
                                                        children: me?.phone_number || "\u2014"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $8afda6637c46830f$export$2e2bcd8739ae039), {}),
                                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                                        className: "pf-facts__k",
                                                        children: tp("my_region")
                                                    }),
                                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                                        className: "pf-facts__v",
                                                        children: currentCounty?.name || "\u2014"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $6c6258c9201cb746$export$2e2bcd8739ae039), {}),
                                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                                        className: "pf-facts__k",
                                                        children: tp("language")
                                                    }),
                                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                                        className: "pf-facts__v",
                                                        children: currentLang?.label || lang || "\u2014"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $6238f9dab5cff517$export$2e2bcd8739ae039), {}),
                                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                                        className: "pf-facts__k",
                                                        children: t("company")
                                                    }),
                                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                                        className: "pf-facts__v",
                                                        children: me?.company?.name || "\u2014"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($464b3d7a8ec63582$var$Note, {
                                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $67c3a41cb5427986$export$2e2bcd8739ae039), {}),
                                children: t("rail_note")
                            })
                        ]
                    }),
                    dirty ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                        className: "pf-savebar",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                                className: "pf-savebar__msg",
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $1141984d2e96fc67$export$2e2bcd8739ae039), {}),
                                    t("unsaved_changes")
                                ]
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                                className: "pf-savebar__acts",
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                        type: "text",
                                        onClick: discard,
                                        disabled: saving,
                                        children: t("discard")
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                        type: "primary",
                                        htmlType: "submit",
                                        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $7f0f32b5e0f33a0e$export$2e2bcd8739ae039), {}),
                                        loading: saving,
                                        children: tp("save")
                                    })
                                ]
                            })
                        ]
                    }) : null
                ]
            })
        ]
    });
}


/**
 * /help — an illustrated guide to the dashboard, reached from the user menu's Help item.
 *
 * ⚠ A FOURTH PAGE SHAPE, on purpose (spec/03 says not to invent one without saying why). The
 * archetypes — list (A), record (B), queue-plus-document (C) — are data surfaces, and every rule
 * they carry (one section mounted, hydrate on demand, cache once, summary counts) exists to bound
 * requests and data-sized DOM. This page makes ZERO requests, its size is fixed at authoring time,
 * and it is read top to bottom or entered by a deep link — the one use that tabs and one-at-a-time
 * mounting make worse. So it is a content page: one scrolling column of `dp-card`s with a sticky
 * anchor rail, in archetype-B chrome so it reads as the same product. The cost the one-section
 * rule guards against is paid here as ~17 CSS animations, bounded by PAUSING whatever is off-screen
 * (`useInView`) rather than by unmounting it.
 *
 * Sections are gated by the same allowlist as the sidebar (`canOpen`), so nobody reads about a
 * page they cannot open. The support request that used to fire straight from the menu lives in the
 * card at the bottom, behind the same confirm (`users/support/` Telegram-messages every support
 * account). No mockup exists for this screen; `profile.html` is the nearest reference.
 */ 

var $cQmXV = parcelRequire("cQmXV");


var $cQmXV = parcelRequire("cQmXV");









var $cQmXV = parcelRequire("cQmXV");




function $9b46b765de3fbacd$var$throttleByAnimationFrame(fn) {
    let requestId = null;
    const later = (args)=>()=>{
            requestId = null;
            fn.apply(void 0, (0, $68381b18b974dc9f$export$2e2bcd8739ae039)(args));
        };
    const throttled = (...args)=>{
        if (requestId === null) requestId = (0, $905c53b807de704e$export$2e2bcd8739ae039)(later(args));
    };
    throttled.cancel = ()=>{
        (0, $905c53b807de704e$export$2e2bcd8739ae039).cancel(requestId);
        requestId = null;
    };
    return throttled;
}
var $9b46b765de3fbacd$export$2e2bcd8739ae039 = $9b46b765de3fbacd$var$throttleByAnimationFrame;




// ============================== Shared ==============================
const $449c3bc16f7740e0$var$genSharedAffixStyle = (token)=>{
    const { componentCls: componentCls } = token;
    return {
        [componentCls]: {
            position: "fixed",
            zIndex: token.zIndexPopup
        }
    };
};
const $449c3bc16f7740e0$export$9ca1be8807fe0675 = (token)=>({
        zIndexPopup: token.zIndexBase + 10
    });
var // ============================== Export ==============================
$449c3bc16f7740e0$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$51ec95de45185b42)("Affix", $449c3bc16f7740e0$var$genSharedAffixStyle, $449c3bc16f7740e0$export$9ca1be8807fe0675);


function $1acc0c0a395d7b10$export$aed5335c572022ae(target) {
    return target !== window ? target.getBoundingClientRect() : {
        top: 0,
        bottom: window.innerHeight
    };
}
function $1acc0c0a395d7b10$export$4d1d62ced3cd1e0d(placeholderRect, targetRect, offsetTop) {
    if (offsetTop !== undefined && Math.round(targetRect.top) > Math.round(placeholderRect.top) - offsetTop) return offsetTop + targetRect.top;
    return undefined;
}
function $1acc0c0a395d7b10$export$904e4c17274c89b0(placeholderRect, targetRect, offsetBottom) {
    if (offsetBottom !== undefined && Math.round(targetRect.bottom) < Math.round(placeholderRect.bottom) + offsetBottom) {
        const targetBottomOffset = window.innerHeight - targetRect.bottom;
        return offsetBottom + targetBottomOffset;
    }
    return undefined;
}


"use client";
const $0e89b465606c575a$var$TRIGGER_EVENTS = [
    "resize",
    "scroll",
    "touchstart",
    "touchmove",
    "touchend",
    "pageshow",
    "load"
];
const $0e89b465606c575a$var$getDefaultTarget = ()=>{
    return typeof window !== "undefined" ? window : null;
};
const $0e89b465606c575a$var$AFFIX_STATUS_NONE = 0;
const $0e89b465606c575a$var$AFFIX_STATUS_PREPARE = 1;
const $0e89b465606c575a$var$Affix = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).forwardRef((props, ref)=>{
    const { style: style, offsetTop: offsetTop, offsetBottom: offsetBottom, prefixCls: prefixCls, className: className, rootClassName: rootClassName, children: children, target: target, onChange: onChange, onTestUpdatePosition: onTestUpdatePosition, ...restProps } = props;
    const { getPrefixCls: getPrefixCls, className: contextClassName, style: contextStyle } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("affix");
    const { getTargetContainer: getTargetContainer } = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useContext((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    const affixPrefixCls = getPrefixCls("affix", prefixCls);
    const [lastAffix, setLastAffix] = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useState(false);
    const [affixStyle, setAffixStyle] = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useState();
    const [placeholderStyle, setPlaceholderStyle] = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useState();
    const statusRef = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useRef($0e89b465606c575a$var$AFFIX_STATUS_NONE);
    const prevTargetRef = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useRef(null);
    const prevListenerRef = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useRef(null);
    const placeholderNodeRef = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useRef(null);
    const fixedNodeRef = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useRef(null);
    const timerRef = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useRef(null);
    const targetFunc = target ?? getTargetContainer ?? $0e89b465606c575a$var$getDefaultTarget;
    const internalOffsetTop = offsetBottom === undefined && offsetTop === undefined ? 0 : offsetTop;
    // =================== Measure ===================
    const measure = ()=>{
        if (statusRef.current !== $0e89b465606c575a$var$AFFIX_STATUS_PREPARE || !fixedNodeRef.current || !placeholderNodeRef.current || !targetFunc) return;
        const targetNode = targetFunc();
        if (targetNode) {
            const newState = {
                status: $0e89b465606c575a$var$AFFIX_STATUS_NONE
            };
            const placeholderRect = (0, $1acc0c0a395d7b10$export$aed5335c572022ae)(placeholderNodeRef.current);
            if (placeholderRect.top === 0 && placeholderRect.left === 0 && placeholderRect.width === 0 && placeholderRect.height === 0) return;
            const targetRect = (0, $1acc0c0a395d7b10$export$aed5335c572022ae)(targetNode);
            const fixedTop = (0, $1acc0c0a395d7b10$export$4d1d62ced3cd1e0d)(placeholderRect, targetRect, internalOffsetTop);
            const fixedBottom = (0, $1acc0c0a395d7b10$export$904e4c17274c89b0)(placeholderRect, targetRect, offsetBottom);
            if (fixedTop !== undefined) {
                newState.affixStyle = {
                    position: "fixed",
                    top: fixedTop,
                    width: placeholderRect.width,
                    height: placeholderRect.height
                };
                newState.placeholderStyle = {
                    width: placeholderRect.width,
                    height: placeholderRect.height
                };
            } else if (fixedBottom !== undefined) {
                newState.affixStyle = {
                    position: "fixed",
                    bottom: fixedBottom,
                    width: placeholderRect.width,
                    height: placeholderRect.height
                };
                newState.placeholderStyle = {
                    width: placeholderRect.width,
                    height: placeholderRect.height
                };
            }
            newState.lastAffix = !!newState.affixStyle;
            if (lastAffix !== newState.lastAffix) onChange?.(newState.lastAffix);
            statusRef.current = newState.status;
            setAffixStyle(newState.affixStyle);
            setPlaceholderStyle(newState.placeholderStyle);
            setLastAffix(newState.lastAffix);
        }
    };
    const prepareMeasure = ()=>{
        statusRef.current = $0e89b465606c575a$var$AFFIX_STATUS_PREPARE;
        measure();
    };
    const updatePosition = (0, $9b46b765de3fbacd$export$2e2bcd8739ae039)(()=>{
        prepareMeasure();
    });
    const lazyUpdatePosition = (0, $9b46b765de3fbacd$export$2e2bcd8739ae039)(()=>{
        // Check position change before measure to make Safari smooth
        if (targetFunc && affixStyle) {
            const targetNode = targetFunc();
            if (targetNode && placeholderNodeRef.current) {
                const targetRect = (0, $1acc0c0a395d7b10$export$aed5335c572022ae)(targetNode);
                const placeholderRect = (0, $1acc0c0a395d7b10$export$aed5335c572022ae)(placeholderNodeRef.current);
                const fixedTop = (0, $1acc0c0a395d7b10$export$4d1d62ced3cd1e0d)(placeholderRect, targetRect, internalOffsetTop);
                const fixedBottom = (0, $1acc0c0a395d7b10$export$904e4c17274c89b0)(placeholderRect, targetRect, offsetBottom);
                if (fixedTop !== undefined && affixStyle.top === fixedTop || fixedBottom !== undefined && affixStyle.bottom === fixedBottom) return;
            }
        }
        // Directly call prepare measure since it's already throttled.
        prepareMeasure();
    });
    const addListeners = ()=>{
        const listenerTarget = targetFunc?.();
        if (!listenerTarget) return;
        $0e89b465606c575a$var$TRIGGER_EVENTS.forEach((eventName)=>{
            if (prevListenerRef.current) prevTargetRef.current?.removeEventListener(eventName, prevListenerRef.current);
            listenerTarget?.addEventListener(eventName, lazyUpdatePosition);
        });
        prevTargetRef.current = listenerTarget;
        prevListenerRef.current = lazyUpdatePosition;
    };
    const removeListeners = ()=>{
        const newTarget = targetFunc?.();
        $0e89b465606c575a$var$TRIGGER_EVENTS.forEach((eventName)=>{
            newTarget?.removeEventListener(eventName, lazyUpdatePosition);
            if (prevListenerRef.current) prevTargetRef.current?.removeEventListener(eventName, prevListenerRef.current);
        });
        updatePosition.cancel();
        lazyUpdatePosition.cancel();
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useImperativeHandle(ref, ()=>({
            updatePosition: updatePosition
        }));
    // mount & unmount
    (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useEffect(()=>{
        // [Legacy] Wait for parent component ref has its value.
        // We should use target as directly element instead of function which makes element check hard.
        timerRef.current = setTimeout(addListeners);
        return ()=>{
            if (timerRef.current) {
                clearTimeout(timerRef.current);
                timerRef.current = null;
            }
            removeListeners();
        };
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useEffect(()=>{
        addListeners();
        return ()=>removeListeners();
    }, [
        target,
        affixStyle,
        lastAffix,
        offsetTop,
        offsetBottom
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useEffect(()=>{
        updatePosition();
    }, [
        target,
        offsetTop,
        offsetBottom
    ]);
    const [hashId, cssVarCls] = (0, $449c3bc16f7740e0$export$2e2bcd8739ae039)(affixPrefixCls);
    const rootCls = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(rootClassName, hashId, affixPrefixCls, cssVarCls);
    const mergedCls = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)({
        [rootCls]: affixStyle
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $1d6306c05e604045$export$2e2bcd8739ae039), {
        onResize: updatePosition
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
        style: {
            ...contextStyle,
            ...style
        },
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(className, contextClassName),
        ref: placeholderNodeRef,
        ...restProps
    }, affixStyle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
        style: placeholderStyle,
        "aria-hidden": "true"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement("div", {
        className: mergedCls,
        ref: fixedNodeRef,
        style: affixStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $1d6306c05e604045$export$2e2bcd8739ae039), {
        onResize: updatePosition
    }, children))));
});
var $0e89b465606c575a$export$2e2bcd8739ae039 = $0e89b465606c575a$var$Affix;





var $cQmXV = parcelRequire("cQmXV");




var $cQmXV = parcelRequire("cQmXV");
const $db3500f62dc5e733$var$AnchorContext = /*#__PURE__*/ $cQmXV.createContext(undefined);
var $db3500f62dc5e733$export$2e2bcd8739ae039 = $db3500f62dc5e733$var$AnchorContext;


"use client";
const $b1a1ae44e23b3e0c$var$AnchorLink = (props)=>{
    const { href: href, title: title, prefixCls: customizePrefixCls, children: children, className: className, target: target, replace: replace, targetOffset: targetOffset } = props;
    const context = $cQmXV.useContext((0, $db3500f62dc5e733$export$2e2bcd8739ae039));
    const { registerLink: registerLink, unregisterLink: unregisterLink, scrollTo: scrollTo, onClick: onClick, activeLink: activeLink, direction: direction, classNames: mergedClassNames, styles: mergedStyles } = context || {};
    $cQmXV.useEffect(()=>{
        registerLink?.(href, targetOffset);
        return ()=>{
            unregisterLink?.(href);
        };
    }, [
        href,
        targetOffset
    ]);
    const handleClick = (e)=>{
        onClick?.(e, {
            title: title,
            href: href
        });
        scrollTo?.(href, targetOffset);
        // Support clicking on an anchor does not record history.
        if (e.defaultPrevented) return;
        const isExternalLink = href.startsWith("http://") || href.startsWith("https://");
        // Support external link
        if (isExternalLink) {
            if (replace) {
                e.preventDefault();
                window.location.replace(href);
            }
            return;
        }
        // Handling internal anchor link
        e.preventDefault();
        const historyMethod = replace ? "replaceState" : "pushState";
        window.history[historyMethod](null, "", href);
    };
    const { getPrefixCls: getPrefixCls } = $cQmXV.useContext((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls("anchor", customizePrefixCls);
    const active = activeLink === href;
    const wrapperClassName = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-link`, className, mergedClassNames?.item, {
        [`${prefixCls}-link-active`]: active
    });
    const titleClassName = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-link-title`, mergedClassNames?.itemTitle, {
        [`${prefixCls}-link-title-active`]: active
    });
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        className: wrapperClassName,
        style: mergedStyles?.item
    }, /*#__PURE__*/ $cQmXV.createElement("a", {
        className: titleClassName,
        style: mergedStyles?.itemTitle,
        href: href,
        title: typeof title === "string" ? title : undefined,
        target: target,
        onClick: handleClick
    }, title), direction !== "horizontal" ? children : null);
};
var $b1a1ae44e23b3e0c$export$2e2bcd8739ae039 = $b1a1ae44e23b3e0c$var$AnchorLink;






// ============================== Shared ==============================
const $5e43db10a807874c$var$genSharedAnchorStyle = (token)=>{
    const { componentCls: componentCls, holderOffsetBlock: holderOffsetBlock, motionDurationSlow: motionDurationSlow, lineWidthBold: lineWidthBold, colorPrimary: colorPrimary, lineType: lineType, colorSplit: colorSplit, calc: calc } = token;
    return {
        [`${componentCls}-wrapper`]: {
            marginBlockStart: calc(holderOffsetBlock).mul(-1).equal(),
            paddingBlockStart: holderOffsetBlock,
            // delete overflow: auto
            // overflow: 'auto',
            [componentCls]: {
                ...(0, $519d20bf207ce864$export$23997c3e44cc1c59)(token),
                position: "relative",
                paddingInlineStart: lineWidthBold,
                [`${componentCls}-link`]: {
                    paddingBlock: token.linkPaddingBlock,
                    paddingInline: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.linkPaddingInlineStart)} 0`,
                    "&-title": {
                        ...(0, $519d20bf207ce864$export$b2b65df0d0824629),
                        position: "relative",
                        display: "block",
                        marginBlockEnd: token.anchorTitleBlock,
                        color: token.colorText,
                        transition: `all ${token.motionDurationSlow}`,
                        "&:only-child": {
                            marginBlockEnd: 0
                        }
                    },
                    [`&-active > ${componentCls}-link-title`]: {
                        color: token.colorPrimary
                    },
                    // link link
                    [`${componentCls}-link`]: {
                        paddingBlock: token.anchorPaddingBlockSecondary
                    }
                }
            },
            [`&:not(${componentCls}-wrapper-horizontal)`]: {
                [componentCls]: {
                    "&::before": {
                        position: "absolute",
                        insetInlineStart: 0,
                        top: 0,
                        height: "100%",
                        borderInlineStart: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(lineWidthBold)} ${lineType} ${colorSplit}`,
                        content: '" "'
                    },
                    [`${componentCls}-ink`]: {
                        position: "absolute",
                        insetInlineStart: 0,
                        display: "none",
                        transform: "translateY(-50%)",
                        transition: `top ${motionDurationSlow} ease-in-out`,
                        width: lineWidthBold,
                        backgroundColor: colorPrimary,
                        [`&${componentCls}-ink-visible`]: {
                            display: "inline-block"
                        }
                    }
                }
            },
            [`${componentCls}-fixed ${componentCls}-ink ${componentCls}-ink`]: {
                display: "none"
            }
        }
    };
};
const $5e43db10a807874c$var$genSharedAnchorHorizontalStyle = (token)=>{
    const { componentCls: componentCls, motionDurationSlow: motionDurationSlow, lineWidthBold: lineWidthBold, colorPrimary: colorPrimary } = token;
    return {
        [`${componentCls}-wrapper-horizontal`]: {
            position: "relative",
            "&::before": {
                position: "absolute",
                left: {
                    _skip_check_: true,
                    value: 0
                },
                right: {
                    _skip_check_: true,
                    value: 0
                },
                bottom: 0,
                borderBottom: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${token.colorSplit}`,
                content: '" "'
            },
            [componentCls]: {
                overflowX: "scroll",
                position: "relative",
                display: "flex",
                scrollbarWidth: "none" /* Firefox */ ,
                "&::-webkit-scrollbar": {
                    display: "none" /* Safari and Chrome */ 
                },
                [`${componentCls}-link:first-of-type`]: {
                    paddingInline: 0
                },
                [`${componentCls}-ink`]: {
                    position: "absolute",
                    bottom: 0,
                    transition: [
                        `left`,
                        `width`
                    ].map((prop)=>`${prop} ${motionDurationSlow} ease-in-out`).join(", "),
                    height: lineWidthBold,
                    backgroundColor: colorPrimary
                }
            }
        }
    };
};
const $5e43db10a807874c$export$9ca1be8807fe0675 = (token)=>({
        linkPaddingBlock: token.paddingXXS,
        linkPaddingInlineStart: token.padding
    });
var // ============================== Export ==============================
$5e43db10a807874c$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$51ec95de45185b42)("Anchor", (token)=>{
    const { fontSize: fontSize, fontSizeLG: fontSizeLG, paddingXXS: paddingXXS, calc: calc } = token;
    const anchorToken = (0, $fef50f256b80dfa5$export$4950aa0f605343fb)(token, {
        holderOffsetBlock: paddingXXS,
        anchorPaddingBlockSecondary: calc(paddingXXS).div(2).equal(),
        anchorTitleBlock: calc(fontSize).div(14).mul(3).equal(),
        anchorBallSize: calc(fontSizeLG).div(2).equal()
    });
    return [
        $5e43db10a807874c$var$genSharedAnchorStyle(anchorToken),
        $5e43db10a807874c$var$genSharedAnchorHorizontalStyle(anchorToken)
    ];
}, $5e43db10a807874c$export$9ca1be8807fe0675);


"use client";
function $214f6d462acc5598$var$getDefaultContainer() {
    return window;
}
function $214f6d462acc5598$var$getOffsetTop(element, container) {
    if (!element.getClientRects().length) return 0;
    const rect = element.getBoundingClientRect();
    if (rect.width || rect.height) {
        if (container === window) return rect.top - element.ownerDocument.documentElement.clientTop;
        return rect.top - container.getBoundingClientRect().top;
    }
    return rect.top;
}
const $214f6d462acc5598$var$sharpMatcherRegex = /#([^\t\r\n\f\v]+)$/;
const $214f6d462acc5598$var$Anchor = (props)=>{
    const { rootClassName: rootClassName, prefixCls: customPrefixCls, className: className, style: style, offsetTop: offsetTop, affix: affix = true, showInkInFixed: showInkInFixed = false, children: children, items: items, direction: anchorDirection = "vertical", bounds: bounds, targetOffset: targetOffset, onClick: onClick, onChange: onChange, getContainer: getContainer, getCurrentAnchor: getCurrentAnchor, replace: replace, classNames: classNames, styles: styles } = props;
    const [links, setLinks] = $cQmXV.useState([]);
    const [activeLink, setActiveLink] = $cQmXV.useState(null);
    const activeLinkRef = $cQmXV.useRef(activeLink);
    const wrapperRef = $cQmXV.useRef(null);
    const spanLinkNodeRef = $cQmXV.useRef(null);
    const animatingRef = $cQmXV.useRef(false);
    const scrollRequestIdRef = $cQmXV.useRef(null);
    const linkTargetOffsetRef = $cQmXV.useRef({});
    const { direction: direction, getPrefixCls: getPrefixCls, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("anchor");
    const { getTargetContainer: getTargetContainer } = $cQmXV.useContext((0, $82ffd17441b57982$export$a92f85ab3e9ad68b));
    const prefixCls = getPrefixCls("anchor", customPrefixCls);
    const rootCls = (0, $2237081acd3cfc09$export$2e2bcd8739ae039)(prefixCls);
    const [hashId, cssVarCls] = (0, $5e43db10a807874c$export$2e2bcd8739ae039)(prefixCls, rootCls);
    const getCurrentContainer = getContainer ?? getTargetContainer ?? $214f6d462acc5598$var$getDefaultContainer;
    const dependencyListItem = JSON.stringify(links);
    const registerLink = (link, newTargetOffset)=>{
        setLinks((prev)=>{
            if (!prev.includes(link)) return [].concat((0, $68381b18b974dc9f$export$2e2bcd8739ae039)(prev), [
                link
            ]);
            return prev;
        });
        // Store link-level targetOffset for scroll detection
        if (newTargetOffset !== undefined) linkTargetOffsetRef.current[link] = newTargetOffset;
    };
    const unregisterLink = (link)=>{
        setLinks((prev)=>prev.filter((i)=>i !== link));
        // Clean up targetOffset when unregistering
        delete linkTargetOffsetRef.current[link];
    };
    const updateInk = ()=>{
        const linkNode = wrapperRef.current?.querySelector(`.${prefixCls}-link-title-active`);
        if (linkNode && spanLinkNodeRef.current) {
            const { style: inkStyle } = spanLinkNodeRef.current;
            const horizontalAnchor = anchorDirection === "horizontal";
            inkStyle.top = horizontalAnchor ? "" : `${linkNode.offsetTop + linkNode.clientHeight / 2}px`;
            inkStyle.height = horizontalAnchor ? "" : `${linkNode.clientHeight}px`;
            inkStyle.left = horizontalAnchor ? `${linkNode.offsetLeft}px` : "";
            inkStyle.width = horizontalAnchor ? `${linkNode.clientWidth}px` : "";
            if (horizontalAnchor) (0, $01bbd7cb34e4099b$export$2e2bcd8739ae039)(linkNode, {
                scrollMode: "if-needed",
                block: "nearest"
            });
        }
    };
    const getInternalCurrentAnchor = (_links, _offsetTop, _bounds = 5, _linkTargetOffset)=>{
        const linkSections = [];
        const container = getCurrentContainer();
        _links.forEach((link)=>{
            const sharpLinkMatch = $214f6d462acc5598$var$sharpMatcherRegex.exec(link?.toString());
            if (!sharpLinkMatch) return;
            const target = document.getElementById(sharpLinkMatch[1]);
            if (target) {
                // Use link-level targetOffset if provided, otherwise use global offsetTop
                const linkOffsetTop = _linkTargetOffset?.[link] ?? _offsetTop;
                const top = $214f6d462acc5598$var$getOffsetTop(target, container);
                if (top <= linkOffsetTop + _bounds) linkSections.push({
                    link: link,
                    top: top
                });
            }
        });
        if (linkSections.length) {
            const maxSection = linkSections.reduce((prev, curr)=>curr.top > prev.top ? curr : prev);
            return maxSection.link;
        }
        return "";
    };
    const setCurrentActiveLink = (0, $eeae8f903af414c5$export$2e2bcd8739ae039)((link)=>{
        // FIXME: Seems a bug since this compare is not equals
        // `activeLinkRef` is parsed value which will always trigger `onChange` event.
        if (activeLinkRef.current === link) return;
        // https://github.com/ant-design/ant-design/issues/30584
        const newLink = (0, $8e2d153a3c855782$export$f6e2535fb5126e54)(getCurrentAnchor) ? getCurrentAnchor(link) : link;
        setActiveLink(newLink);
        activeLinkRef.current = newLink;
        // onChange should respect the original link (which may caused by
        // window scroll or user click), not the new link
        onChange?.(link);
    });
    const handleScroll = $cQmXV.useCallback(()=>{
        if (animatingRef.current) return;
        const currentActiveLink = getInternalCurrentAnchor(links, (0, $8e2d153a3c855782$export$7e4aa119212bc614)(targetOffset) ? targetOffset : offsetTop || 0, bounds, linkTargetOffsetRef.current);
        setCurrentActiveLink(currentActiveLink);
    }, [
        links,
        targetOffset,
        offsetTop,
        bounds
    ]);
    const handleScrollTo = $cQmXV.useCallback((link, targetOffsetParams)=>{
        const previousActiveLink = activeLinkRef.current;
        setCurrentActiveLink(link);
        const sharpLinkMatch = $214f6d462acc5598$var$sharpMatcherRegex.exec(link);
        if (!sharpLinkMatch) return;
        const targetElement = document.getElementById(sharpLinkMatch[1]);
        if (!targetElement) return;
        if (animatingRef.current) {
            if (previousActiveLink === link) return;
            scrollRequestIdRef.current?.();
        }
        const container = getCurrentContainer();
        const scrollTop = (0, $764c529cb0981ab5$export$2e2bcd8739ae039)(container);
        const eleOffsetTop = $214f6d462acc5598$var$getOffsetTop(targetElement, container);
        let y = scrollTop + eleOffsetTop;
        const finalTargetOffset = targetOffsetParams ?? targetOffset ?? offsetTop ?? 0;
        y -= finalTargetOffset;
        animatingRef.current = true;
        scrollRequestIdRef.current = (0, $355a55ff8bfb603e$export$2e2bcd8739ae039)(y, {
            getContainer: getCurrentContainer,
            callback () {
                animatingRef.current = false;
            }
        });
    }, [
        targetOffset,
        offsetTop
    ]);
    // =========== Merged Props for Semantic ==========
    const mergedProps = {
        ...props,
        direction: anchorDirection
    };
    const contextStyleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $30c5f9f911d4f61b$export$648566b068f28737)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: mergedProps
    });
    const wrapperClass = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(hashId, cssVarCls, rootCls, rootClassName, `${prefixCls}-wrapper`, {
        [`${prefixCls}-wrapper-horizontal`]: anchorDirection === "horizontal",
        [`${prefixCls}-rtl`]: direction === "rtl"
    }, className, contextClassName, mergedClassNames.root);
    const anchorClass = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, {
        [`${prefixCls}-fixed`]: !affix && !showInkInFixed
    });
    const inkClass = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${prefixCls}-ink`, mergedClassNames.indicator, {
        [`${prefixCls}-ink-visible`]: activeLink
    });
    const wrapperStyle = {
        maxHeight: offsetTop ? `calc(100vh - ${offsetTop}px)` : "100vh",
        ...mergedStyles.root
    };
    const createNestedLink = (options)=>Array.isArray(options) ? options.map((item)=>/*#__PURE__*/ $cQmXV.createElement((0, $b1a1ae44e23b3e0c$export$2e2bcd8739ae039), {
                replace: replace,
                ...item,
                key: item.key
            }, anchorDirection === "vertical" && createNestedLink(item.children))) : null;
    const anchorContent = /*#__PURE__*/ $cQmXV.createElement("div", {
        ref: wrapperRef,
        className: wrapperClass,
        style: wrapperStyle
    }, /*#__PURE__*/ $cQmXV.createElement("div", {
        className: anchorClass
    }, /*#__PURE__*/ $cQmXV.createElement("span", {
        className: inkClass,
        ref: spanLinkNodeRef,
        style: mergedStyles.indicator
    }), "items" in props ? createNestedLink(items) : children));
    $cQmXV.useEffect(()=>{
        const scrollContainer = getCurrentContainer();
        handleScroll();
        scrollContainer?.addEventListener("scroll", handleScroll);
        return ()=>{
            scrollContainer?.removeEventListener("scroll", handleScroll);
        };
    }, [
        dependencyListItem
    ]);
    $cQmXV.useEffect(()=>{
        if ((0, $8e2d153a3c855782$export$f6e2535fb5126e54)(getCurrentAnchor)) setCurrentActiveLink(getCurrentAnchor(activeLinkRef.current || ""));
    }, [
        getCurrentAnchor
    ]);
    $cQmXV.useEffect(()=>{
        updateInk();
    }, [
        anchorDirection,
        getCurrentAnchor,
        dependencyListItem,
        activeLink
    ]);
    const memoizedContextValue = $cQmXV.useMemo(()=>({
            registerLink: registerLink,
            unregisterLink: unregisterLink,
            scrollTo: handleScrollTo,
            activeLink: activeLink,
            onClick: onClick,
            direction: anchorDirection,
            classNames: mergedClassNames,
            styles: mergedStyles
        }), [
        activeLink,
        onClick,
        handleScrollTo,
        anchorDirection,
        mergedStyles,
        mergedClassNames
    ]);
    const affixProps = (0, $8e2d153a3c855782$export$53b83ca8eaab0383)(affix) ? affix : undefined;
    return /*#__PURE__*/ $cQmXV.createElement((0, $db3500f62dc5e733$export$2e2bcd8739ae039).Provider, {
        value: memoizedContextValue
    }, affix ? /*#__PURE__*/ $cQmXV.createElement((0, $0e89b465606c575a$export$2e2bcd8739ae039), {
        offsetTop: offsetTop,
        target: getCurrentContainer,
        ...affixProps
    }, anchorContent) : anchorContent);
};
var $214f6d462acc5598$export$2e2bcd8739ae039 = $214f6d462acc5598$var$Anchor;



"use client";
const $e394c3c2787ab103$var$Anchor = (0, $214f6d462acc5598$export$2e2bcd8739ae039);
$e394c3c2787ab103$var$Anchor.Link = (0, $b1a1ae44e23b3e0c$export$2e2bcd8739ae039);
var $e394c3c2787ab103$export$2e2bcd8739ae039 = $e394c3c2787ab103$var$Anchor;










/**
 * The /help illustrations — one small stateless component per section.
 *
 * Each is a simplified replica of the real screen built from the `hp-*` mock primitives in
 * help.scss, animated by the seven shared keyframes there (see the motion contract at the top of
 * that file: the resting stylesheet state IS the final frame). The frame around them is
 * `aria-hidden`, so nothing here is a real <button> or <a>, and identity-bearing labels only —
 * names, points, times, counts — are real text; everything descriptive is an `hp-bar`.
 *
 * The data is a FICTIONAL company (Marigold Trading: networks Bluefinch and Okapi; merchandisers
 * Ana Voss, Leo Mard, Nika Vale; supervisors Olena Brant and Davit Aren), deliberately Latin-script
 * and untranslated: the copy beside each picture, which is translated, says what it shows.
 */ 
parcelRequire("cQmXV");


var $cQmXV = parcelRequire("cQmXV");
var $385ca835d2898e2c$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($385ca835d2898e2c$exports, "__esModule", {
    value: true
});
var $385ca835d2898e2c$var$StarOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 00.6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0046.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3zM664.8 561.6l36.1 210.3L512 672.7 323.1 772l36.1-210.3-152.8-149L417.6 382 512 190.7 606.4 382l211.2 30.7-152.8 148.9z"
                }
            }
        ]
    },
    "name": "star",
    "theme": "outlined"
};
$385ca835d2898e2c$exports.default = $385ca835d2898e2c$var$StarOutlined;



function $795a2546557f74e6$var$_extends() {
    $795a2546557f74e6$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $795a2546557f74e6$var$_extends.apply(this, arguments);
}
const $795a2546557f74e6$var$StarOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $795a2546557f74e6$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($385ca835d2898e2c$exports)))
    }));
/**![star](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkwOC4xIDM1My4xbC0yNTMuOS0zNi45TDU0MC43IDg2LjFjLTMuMS02LjMtOC4yLTExLjQtMTQuNS0xNC41LTE1LjgtNy44LTM1LTEuMy00Mi45IDE0LjVMMzY5LjggMzE2LjJsLTI1My45IDM2LjljLTcgMS0xMy40IDQuMy0xOC4zIDkuM2EzMi4wNSAzMi4wNSAwIDAwLjYgNDUuM2wxODMuNyAxNzkuMS00My40IDI1Mi45YTMxLjk1IDMxLjk1IDAgMDA0Ni40IDMzLjdMNTEyIDc1NGwyMjcuMSAxMTkuNGM2LjIgMy4zIDEzLjQgNC40IDIwLjMgMy4yIDE3LjQtMyAyOS4xLTE5LjUgMjYuMS0zNi45bC00My40LTI1Mi45IDE4My43LTE3OS4xYzUtNC45IDguMy0xMS4zIDkuMy0xOC4zIDIuNy0xNy41LTkuNS0zMy43LTI3LTM2LjN6TTY2NC44IDU2MS42bDM2LjEgMjEwLjNMNTEyIDY3Mi43IDMyMy4xIDc3MmwzNi4xLTIxMC4zLTE1Mi44LTE0OUw0MTcuNiAzODIgNTEyIDE5MC43IDYwNi40IDM4MmwyMTEuMiAzMC43LTE1Mi44IDE0OC45eiIgLz48L3N2Zz4=) */ const $795a2546557f74e6$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($795a2546557f74e6$var$StarOutlined);
var $795a2546557f74e6$export$2e2bcd8739ae039 = $795a2546557f74e6$var$RefIcon;



const $a1790aa2194b2ed1$var$cx = (...parts)=>parts.filter(Boolean).join(" ");
const $a1790aa2194b2ed1$var$TONE_ICON = {
    ok: (0, $45839ed7c4a7faa2$export$2e2bcd8739ae039),
    no: (0, $bdfb1f797481a352$export$2e2bcd8739ae039),
    wait: (0, $7b23ac4854de9809$export$2e2bcd8739ae039),
    off: (0, $e539a200877e5e8f$export$2e2bcd8739ae039)
};
/** The house status glyph (same `lp-*` classes the real tables use), without the Tooltip. */ const $a1790aa2194b2ed1$var$Glyph = ({ tone: tone, extra: extra })=>{
    const Icon = $a1790aa2194b2ed1$var$TONE_ICON[tone];
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)(Icon, {
        className: $a1790aa2194b2ed1$var$cx("lp-status-icon", `lp-status-icon--${tone}`, extra)
    });
};
/** A glyph that flips at the click: `from` is drawn only before it, `to` is the resting state. */ const $a1790aa2194b2ed1$var$Flip = ({ from: from, to: to })=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
        className: "hp-flip",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Glyph, {
                tone: from,
                extra: "hp-flip__before"
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Glyph, {
                tone: to,
                extra: "hp-flip__after"
            })
        ]
    });
const $a1790aa2194b2ed1$var$Av = ({ name: name })=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $72b7444d01b36e98$export$2e2bcd8739ae039), {
        size: 28,
        className: "lp-who__av",
        style: {
            fontSize: 12
        },
        children: (0, $66539b2560a58e4e$export$f6a098653d630c23)(name)
    });
const $a1790aa2194b2ed1$var$Bar = ({ w: w = "60%" })=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
        className: "hp-bar",
        style: {
            "--w": w
        }
    });
const $a1790aa2194b2ed1$export$b6a79797ad180576 = ({ x: x, y: y, dx: dx = "120px", dy: dy = "80px" })=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
        className: "hp-cursor",
        style: {
            "--x": x,
            "--y": y,
            "--dx": dx,
            "--dy": dy
        },
        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("svg", {
            viewBox: "0 0 16 16",
            children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("path", {
                d: "M2 2 14 8 8 9.5 6 15z"
            })
        })
    });
function $a1790aa2194b2ed1$var$Row({ lead: lead, who: who, where: where, tail: tail, target: target, appear: appear }) {
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
        className: $a1790aa2194b2ed1$var$cx("hp-row", target && "hp-row--target", appear && "hp-appear"),
        children: [
            lead,
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                className: "hp-row__main",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("strong", {
                        children: who
                    }),
                    where ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        children: where
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                className: "hp-row__tail",
                children: tail
            })
        ]
    });
}
function $a1790aa2194b2ed1$export$bb59d28c15d71af8() {
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
        className: "hp-mock",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                className: "hp-search",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $20a259d46bffcb08$export$2e2bcd8739ae039), {
                        className: "hp-search__icon"
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                className: "hp-type--1",
                                children: "b"
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                className: "hp-type--2",
                                children: "l"
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                className: "hp-type--3",
                                children: "u"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "hp-key",
                        children: "/"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                className: "hp-glabel hp-appear",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Bar, {
                        w: "48px"
                    }),
                    " \xb7 2"
                ]
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Row, {
                lead: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                    className: "hp-tile",
                    children: "BF"
                }),
                who: "Bluefinch 12",
                where: "Okapi Park \xb7 Bluefinch",
                tail: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $89db7229a7e10f8f$export$2e2bcd8739ae039), {}),
                appear: true
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Row, {
                lead: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                    className: "hp-tile",
                    children: "BF"
                }),
                who: "Bluefinch Central",
                where: "Bluefinch",
                tail: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $89db7229a7e10f8f$export$2e2bcd8739ae039), {}),
                appear: true
            })
        ]
    });
}
function $a1790aa2194b2ed1$export$3ff67e221420b0e8() {
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
        className: "hp-mock",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                className: "hp-mock__bar hp-mock__bar--end",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Bar, {
                        w: "40%"
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "hp-spacer"
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                        className: "hp-bell",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $1005916731c83b87$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                className: "hp-bell__dot hp-flip__before"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                        className: "hp-userchip",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Av, {
                                name: "Olena Brant"
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Bar, {
                                w: "56px"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                className: "hp-menu",
                style: {
                    width: "62%"
                },
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                        className: "hp-menu__row",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Glyph, {
                                tone: "wait"
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Bar, {
                                w: "55%"
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                className: "hp-spacer"
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                className: "hp-chip hp-chip--warn",
                                children: "3"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                        className: "hp-menu__row",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $7804300d9b621775$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Bar, {
                                w: "45%"
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                className: "hp-spacer"
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                className: "hp-chip",
                                children: "2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                        className: "hp-menu__row",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3368c84d60c50017$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Bar, {
                                w: "50%"
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                className: "hp-spacer"
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                className: "hp-chip",
                                children: "1"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$export$b6a79797ad180576, {
                x: "calc(100% - 118px)",
                y: "14px",
                dx: "-160px",
                dy: "90px"
            })
        ]
    });
}
function $a1790aa2194b2ed1$export$889ebfc541e98cfb() {
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
        className: "hp-mock",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                className: "hp-mock__bar hp-mock__bar--end",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Bar, {
                        w: "40%"
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "hp-spacer"
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                        className: "hp-btn hp-btn--ghost",
                        children: [
                            "EN ",
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e7119b602540b2c5$export$2e2bcd8739ae039), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                        className: "hp-userchip",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Av, {
                                name: "Olena Brant"
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                                className: "hp-row__main",
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("strong", {
                                        children: "Olena Brant"
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Bar, {
                                        w: "48px"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e7119b602540b2c5$export$2e2bcd8739ae039), {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                className: "hp-menu",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                        className: "hp-menu__row",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Av, {
                                name: "Olena Brant"
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                                className: "hp-row__main",
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("strong", {
                                        children: "Olena Brant"
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Bar, {
                                        w: "56px"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                        className: "hp-menu__row",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $7804300d9b621775$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Bar, {
                                w: "40%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                        className: "hp-menu__row",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $9e51bdaef216a39c$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Bar, {
                                w: "30%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                        className: "hp-menu__row",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $27dfd059157cea02$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Bar, {
                                w: "24%"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$export$b6a79797ad180576, {
                x: "calc(100% - 60px)",
                y: "16px",
                dx: "-180px",
                dy: "80px"
            })
        ]
    });
}
function $a1790aa2194b2ed1$export$57e9d27c7144c740() {
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
        className: "hp-mock",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                className: "hp-mock__bar",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                        className: "hp-input",
                        style: {
                            width: "34%"
                        },
                        children: [
                            "Bluefinch",
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                className: "hp-spacer"
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e7119b602540b2c5$export$2e2bcd8739ae039), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "hp-input",
                        style: {
                            width: "30%"
                        },
                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Bar, {
                            w: "70%"
                        })
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                        className: "hp-input",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3368c84d60c50017$export$2e2bcd8739ae039), {}),
                            "\xa001.08 \u2192 14.08"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                className: "hp-mock__bar",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                        className: "hp-chip hp-chip--on hp-appear",
                        children: [
                            "Bluefinch ",
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $837faca566926e3c$export$2e2bcd8739ae039), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "hp-spacer"
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        children: "\xb7 24"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Row, {
                lead: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Glyph, {
                    tone: "ok"
                }),
                who: "Bluefinch 12",
                where: "Ana Voss \xb7 12:05",
                tail: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Bar, {
                    w: "32px"
                }),
                appear: true
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Row, {
                lead: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Glyph, {
                    tone: "wait"
                }),
                who: "Bluefinch Central",
                where: "Leo Mard \xb7 12:40",
                tail: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Bar, {
                    w: "32px"
                }),
                appear: true
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Row, {
                lead: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Glyph, {
                    tone: "ok"
                }),
                who: "Bluefinch Station",
                where: "Nika Vale \xb7 13:10",
                tail: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Bar, {
                    w: "32px"
                }),
                appear: true
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$export$b6a79797ad180576, {
                x: "26%",
                y: "18px",
                dx: "140px",
                dy: "110px"
            })
        ]
    });
}
function $a1790aa2194b2ed1$export$5a5a83d053ac188() {
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
        className: "hp-mock",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                className: "hp-mock__bar",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Bar, {
                        w: "30%"
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "hp-spacer"
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "hp-key",
                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0f3c6d60b091c877$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                            className: "hp-flip",
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                    className: "hp-flip__before",
                                    children: "Jul 2026"
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                    className: "hp-flip__after",
                                    children: "Aug 2026"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "hp-key",
                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $89db7229a7e10f8f$export$2e2bcd8739ae039), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                className: "hp-kpis",
                children: [
                    [
                        "128",
                        "141",
                        "+10%"
                    ],
                    [
                        "36",
                        "41",
                        "+14%"
                    ],
                    [
                        "512",
                        "590",
                        "+15%"
                    ]
                ].map(([a, b, d])=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                        className: "hp-kpi",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Bar, {
                                w: "50%"
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                                className: "hp-kpi__n hp-flip",
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                        className: "hp-flip__before",
                                        children: a
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                        className: "hp-flip__after",
                                        children: b
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                className: "hp-chip hp-chip--ok hp-appear",
                                children: d
                            })
                        ]
                    }, a))
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                className: "hp-chart",
                children: [
                    "40%",
                    "65%",
                    "55%",
                    "80%",
                    "70%",
                    "95%",
                    "60%"
                ].map((h, i)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "hp-chart__bar",
                        style: {
                            "--h": h
                        }
                    }, i))
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$export$b6a79797ad180576, {
                x: "calc(100% - 22px)",
                y: "14px",
                dx: "-120px",
                dy: "100px"
            })
        ]
    });
}
function $a1790aa2194b2ed1$export$960f920d813fdc66() {
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
        className: "hp-mock",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                className: "hp-mock__bar",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "hp-chip hp-chip--on",
                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Bar, {
                            w: "32px"
                        })
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "hp-chip",
                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Bar, {
                            w: "40px"
                        })
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "hp-chip",
                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Bar, {
                            w: "36px"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                className: "hp-photos",
                children: [
                    "ok",
                    "wait",
                    "wait",
                    "ok",
                    "no",
                    "wait"
                ].map((tone, i)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                        className: "hp-photo",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3602cb83fb466795$export$2e2bcd8739ae039), {
                                className: "hp-photo__icon"
                            }),
                            i === 1 ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Flip, {
                                from: "wait",
                                to: "ok"
                            }) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Glyph, {
                                tone: tone
                            })
                        ]
                    }, i))
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                className: "hp-float",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "hp-photo hp-photo--big",
                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3602cb83fb466795$export$2e2bcd8739ae039), {
                            className: "hp-photo__icon"
                        })
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                        className: "hp-row__main",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("strong", {
                                children: "Okapi Park"
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                children: "Leo Mard \xb7 12:40"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                        className: "hp-float__acts",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                className: "hp-btn hp-btn--ghost",
                                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $77ccca814b0c39fe$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                className: "hp-btn hp-btn--danger",
                                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $837faca566926e3c$export$2e2bcd8739ae039), {})
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$export$b6a79797ad180576, {
                x: "42%",
                y: "70px",
                dx: "-80px",
                dy: "90px"
            })
        ]
    });
}
function $a1790aa2194b2ed1$export$f258ee8bd0d2019e() {
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
        className: "hp-mock",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                className: "hp-mock__bar",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "hp-chip hp-chip--on",
                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Bar, {
                            w: "28px"
                        })
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "hp-chip",
                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Bar, {
                            w: "44px"
                        })
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "hp-chip",
                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Bar, {
                            w: "36px"
                        })
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "hp-spacer"
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        children: "\xb7 84"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Row, {
                lead: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Av, {
                    name: "Ana Voss"
                }),
                who: "Ana Voss",
                where: "Bluefinch 12 \xb7 12:05",
                tail: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Glyph, {
                    tone: "ok"
                })
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Row, {
                lead: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Av, {
                    name: "Leo Mard"
                }),
                who: "Leo Mard",
                where: "Okapi Park \xb7 12:40",
                tail: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Flip, {
                    from: "wait",
                    to: "ok"
                }),
                target: true
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Row, {
                lead: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Av, {
                    name: "Nika Vale"
                }),
                who: "Nika Vale",
                where: "Bluefinch Central \xb7 13:10",
                tail: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Glyph, {
                    tone: "wait"
                })
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$export$b6a79797ad180576, {
                x: "calc(100% - 26px)",
                y: "86px",
                dx: "-160px",
                dy: "70px"
            })
        ]
    });
}
function $a1790aa2194b2ed1$export$cbd19a722827b5ab() {
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
        className: "hp-mock",
        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
            className: "hp-cols hp-cols--rail",
            children: [
                /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                    className: "hp-panel",
                    children: [
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Row, {
                            lead: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Av, {
                                name: "Ana Voss"
                            }),
                            who: "Ana Voss",
                            where: "Bluefinch 12 \xb7 12:05",
                            tail: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Glyph, {
                                tone: "ok"
                            }),
                            target: true
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Row, {
                            lead: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Av, {
                                name: "Leo Mard"
                            }),
                            who: "Leo Mard",
                            where: "Okapi Park \xb7 08:10",
                            tail: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Glyph, {
                                tone: "wait"
                            })
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Row, {
                            lead: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Av, {
                                name: "Nika Vale"
                            }),
                            who: "Nika Vale",
                            where: "Bluefinch Central \xb7 11:20",
                            tail: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Glyph, {
                                tone: "off"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                    className: "hp-map",
                    children: [
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("svg", {
                            className: "hp-track",
                            viewBox: "0 0 100 100",
                            preserveAspectRatio: "none",
                            children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("path", {
                                d: "M14 78 L38 56 L62 30"
                            })
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                            className: "hp-pin hp-pin--off",
                            style: {
                                "--x": "10%",
                                "--y": "72%"
                            }
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                            className: "hp-pin hp-pin--ok",
                            style: {
                                "--x": "36%",
                                "--y": "50%"
                            }
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                            className: "hp-pin hp-pin--off",
                            style: {
                                "--x": "78%",
                                "--y": "60%"
                            }
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                            className: "hp-pin hp-pin--here hp-pin--ok",
                            style: {
                                "--x": "58%",
                                "--y": "22%"
                            }
                        })
                    ]
                })
            ]
        })
    });
}
function $a1790aa2194b2ed1$export$c6e90366b251bdee() {
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
        className: "hp-mock",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                className: "hp-accordion",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Row, {
                        lead: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $235e2c6c1e527cba$export$2e2bcd8739ae039), {}),
                        who: "Sales by network",
                        tail: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e7119b602540b2c5$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Row, {
                        lead: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $235e2c6c1e527cba$export$2e2bcd8739ae039), {}),
                        who: "Visit coverage",
                        tail: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e7119b602540b2c5$export$2e2bcd8739ae039), {}),
                        target: true
                    })
                ]
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                className: "hp-frame hp-appear",
                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                    className: "hp-chart",
                    children: [
                        "50%",
                        "80%",
                        "35%",
                        "95%",
                        "60%"
                    ].map((h, i)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                            className: "hp-chart__bar",
                            style: {
                                "--h": h
                            }
                        }, i))
                })
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Row, {
                lead: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $235e2c6c1e527cba$export$2e2bcd8739ae039), {}),
                who: "Shelf share",
                tail: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e7119b602540b2c5$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$export$b6a79797ad180576, {
                x: "calc(100% - 24px)",
                y: "52px",
                dx: "-140px",
                dy: "80px"
            })
        ]
    });
}
function $a1790aa2194b2ed1$export$5742e3581f9fa603() {
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
        className: "hp-mock",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                className: "hp-mock__bar",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Bar, {
                        w: "30%"
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "hp-spacer"
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                        className: "hp-btn",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $fa25166ced813feb$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Bar, {
                                w: "40px"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Row, {
                lead: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Glyph, {
                    tone: "ok"
                }),
                who: "Okapi Park",
                where: "Ana Voss \xb7 28.08",
                tail: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Bar, {
                    w: "28px"
                })
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Row, {
                lead: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Glyph, {
                    tone: "wait"
                }),
                who: "Bluefinch 12",
                where: "Leo Mard \xb7 04.09",
                tail: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Bar, {
                    w: "28px"
                }),
                appear: true
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Row, {
                lead: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Glyph, {
                    tone: "wait"
                }),
                who: "Bluefinch Central",
                where: "Nika Vale \xb7 04.09",
                tail: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Bar, {
                    w: "28px"
                }),
                appear: true
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Row, {
                lead: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Glyph, {
                    tone: "wait"
                }),
                who: "Bluefinch Station",
                where: "Nika Vale \xb7 04.09",
                tail: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Bar, {
                    w: "28px"
                }),
                appear: true
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$export$b6a79797ad180576, {
                x: "calc(100% - 44px)",
                y: "16px",
                dx: "-160px",
                dy: "100px"
            })
        ]
    });
}
function $a1790aa2194b2ed1$export$227d9f98e0a65e8a() {
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
        className: "hp-mock",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                className: "hp-mock__bar",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Bar, {
                        w: "24%"
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "hp-spacer"
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "hp-key",
                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0f3c6d60b091c877$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                        className: "hp-flip",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                className: "hp-flip__before",
                                children: "3 / 84"
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                className: "hp-flip__after",
                                children: "4 / 84"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "hp-key",
                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $89db7229a7e10f8f$export$2e2bcd8739ae039), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                className: "hp-cols",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "hp-photo hp-photo--big",
                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3602cb83fb466795$export$2e2bcd8739ae039), {
                            className: "hp-photo__icon"
                        })
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                        className: "hp-col",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                                className: "hp-row__main",
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("strong", {
                                        children: "Okapi Riverside"
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                        children: "Nika Vale \xb7 13:10"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Bar, {
                                w: "90%"
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Bar, {
                                w: "70%"
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                                className: "hp-float__acts",
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                        className: "hp-btn hp-btn--ghost",
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Flip, {
                                            from: "wait",
                                            to: "ok"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                        className: "hp-btn hp-btn--danger",
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $837faca566926e3c$export$2e2bcd8739ae039), {})
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$export$b6a79797ad180576, {
                x: "calc(50% + 30px)",
                y: "calc(100% - 30px)",
                dx: "-120px",
                dy: "-70px"
            })
        ]
    });
}
function $a1790aa2194b2ed1$export$920e1d4bb2399201() {
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
        className: "hp-mock",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                className: "hp-drop",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $268dc9f9b8c7fd21$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Bar, {
                        w: "40%"
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "hp-spacer"
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                        className: "hp-chip hp-chip--on hp-appear",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3e7ed8d791051c11$export$2e2bcd8739ae039), {}),
                            " tasks_09.xlsx"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Row, {
                lead: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Glyph, {
                    tone: "ok"
                }),
                who: "Bluefinch 12",
                where: "04.09 \xb7 Facing check",
                tail: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Bar, {
                    w: "28px"
                }),
                appear: true
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Row, {
                lead: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Glyph, {
                    tone: "ok"
                }),
                who: "Okapi Park",
                where: "04.09 \xb7 Facing check",
                tail: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Bar, {
                    w: "28px"
                }),
                appear: true
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Row, {
                lead: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Glyph, {
                    tone: "no"
                }),
                who: "BLF-0199",
                where: "31.02 \xb7 Facing check",
                tail: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $8c4bbfcbcade090a$export$2e2bcd8739ae039), {
                    className: "lp-status-icon lp-status-icon--no"
                }),
                appear: true
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$export$b6a79797ad180576, {
                x: "30%",
                y: "28px",
                dx: "100px",
                dy: "100px"
            })
        ]
    });
}
function $a1790aa2194b2ed1$export$df249002ef40f935() {
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
        className: "hp-mock",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                className: "hp-mock__bar",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "hp-chip",
                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3368c84d60c50017$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "hp-chip",
                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $795a2546557f74e6$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "hp-chip",
                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $d6c8837c82724a15$export$2e2bcd8739ae039), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                className: "hp-cols hp-cols--rail",
                style: {
                    paddingTop: 0
                },
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                        className: "hp-panel",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Row, {
                                lead: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Av, {
                                    name: "Ana Voss"
                                }),
                                who: "Ana Voss",
                                where: "Olena Brant",
                                tail: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Glyph, {
                                    tone: "ok"
                                })
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Row, {
                                lead: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Av, {
                                    name: "Leo Mard"
                                }),
                                who: "Leo Mard",
                                where: "Olena Brant",
                                tail: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $795a2546557f74e6$export$2e2bcd8739ae039), {}),
                                target: true
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Row, {
                                lead: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Av, {
                                    name: "Nika Vale"
                                }),
                                who: "Nika Vale",
                                where: "Davit Aren",
                                tail: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Glyph, {
                                    tone: "off"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                        className: "hp-col hp-appear",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                                className: "hp-tabs",
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                        className: "hp-tabs__on",
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Bar, {
                                            w: "40px"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Bar, {
                                            w: "32px"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Bar, {
                                            w: "28px"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                                className: "hp-cal",
                                children: [
                                    1,
                                    2,
                                    3,
                                    4,
                                    5,
                                    6,
                                    7,
                                    8,
                                    9,
                                    10,
                                    11,
                                    12,
                                    13,
                                    14
                                ].map((d)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                        className: $a1790aa2194b2ed1$var$cx("hp-cal__d", [
                                            2,
                                            4,
                                            9,
                                            11,
                                            12
                                        ].includes(d) && "hp-cal__d--on"),
                                        children: d
                                    }, d))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$export$b6a79797ad180576, {
                x: "22%",
                y: "96px",
                dx: "120px",
                dy: "-60px"
            })
        ]
    });
}
function $a1790aa2194b2ed1$export$7355ec5c20140f11() {
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
        className: "hp-mock",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                className: "hp-cols hp-cols--rail",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                        className: "hp-panel",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Row, {
                                lead: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Av, {
                                    name: "Olena Brant"
                                }),
                                who: "Olena Brant",
                                where: "Points: 24",
                                tail: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Glyph, {
                                    tone: "ok"
                                }),
                                target: true
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Row, {
                                lead: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Av, {
                                    name: "Davit Aren"
                                }),
                                who: "Davit Aren",
                                where: "Points: 0",
                                tail: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $8c4bbfcbcade090a$export$2e2bcd8739ae039), {
                                    className: "lp-status-icon lp-status-icon--wait"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                        className: "hp-col",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                                className: "hp-tabs",
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                                        className: "hp-tabs__on",
                                        children: [
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $d6c8837c82724a15$export$2e2bcd8739ae039), {}),
                                            " 24"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                                        children: [
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $d5baeea001a6abe5$export$2e2bcd8739ae039), {}),
                                            " 3"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                        className: "hp-spacer"
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                        className: "hp-btn",
                                        style: {
                                            alignSelf: "center"
                                        },
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $fa25166ced813feb$export$2e2bcd8739ae039), {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                className: "hp-chip",
                                children: "Bluefinch 12"
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                className: "hp-chip",
                                children: "Okapi Park"
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                className: "hp-chip hp-chip--on hp-appear",
                                children: "Okapi Riverside"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$export$b6a79797ad180576, {
                x: "calc(100% - 30px)",
                y: "26px",
                dx: "-140px",
                dy: "90px"
            })
        ]
    });
}
function $a1790aa2194b2ed1$export$772cdc46201edc07() {
    const open = /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $357da3723e13ae38$export$2e2bcd8739ae039), {
        className: "lp-status-icon lp-status-icon--off"
    });
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
        className: "hp-mock",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                className: "hp-mock__bar",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "hp-input",
                        style: {
                            width: "40%"
                        },
                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $20a259d46bffcb08$export$2e2bcd8739ae039), {
                            className: "hp-search__icon"
                        })
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "hp-spacer"
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                        className: "hp-btn",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $fa25166ced813feb$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Bar, {
                                w: "36px"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Row, {
                lead: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $48c531267acac240$export$2e2bcd8739ae039), {
                    className: "hp-photo__icon"
                }),
                who: "Planogram Q3",
                where: "PDF \xb7 12.08",
                tail: open
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Row, {
                lead: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3e7ed8d791051c11$export$2e2bcd8739ae039), {
                    className: "hp-photo__icon"
                }),
                who: "Price list 09",
                where: "XLSX \xb7 28.08",
                tail: open,
                target: true
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Row, {
                lead: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $c3b8d7d247171904$export$2e2bcd8739ae039), {
                    className: "hp-photo__icon"
                }),
                who: "Shelf standard",
                where: "PNG \xb7 02.09",
                tail: open
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$export$b6a79797ad180576, {
                x: "calc(100% - 22px)",
                y: "92px",
                dx: "-160px",
                dy: "-40px"
            })
        ]
    });
}
function $a1790aa2194b2ed1$export$518b8f0601dab267() {
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
        className: "hp-mock",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Row, {
                lead: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                    className: "hp-tile",
                    children: "1"
                }),
                who: "Shelf share, %",
                tail: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e7119b602540b2c5$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Row, {
                lead: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                    className: "hp-tile",
                    children: "2"
                }),
                who: "Promo material present?",
                tail: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e7119b602540b2c5$export$2e2bcd8739ae039), {}),
                target: true
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                className: "hp-frame hp-appear",
                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                    className: "hp-col",
                    style: {
                        padding: 12,
                        flex: 1
                    },
                    children: [
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                            className: "hp-input",
                            children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Bar, {
                                w: "60%"
                            })
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                            className: "hp-float__acts",
                            style: {
                                marginTop: 0
                            },
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                    className: "hp-chip hp-chip--on",
                                    children: "Bluefinch"
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                    className: "hp-chip",
                                    children: "Okapi"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Row, {
                lead: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                    className: "hp-tile",
                    children: "3"
                }),
                who: "Competitor price",
                tail: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e7119b602540b2c5$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$export$b6a79797ad180576, {
                x: "calc(100% - 24px)",
                y: "52px",
                dx: "-140px",
                dy: "90px"
            })
        ]
    });
}
function $a1790aa2194b2ed1$export$4043f6b509107bd2() {
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
        className: "hp-mock",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                className: "hp-mock__bar",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "hp-chip",
                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $d6c8837c82724a15$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "hp-chip",
                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $7804300d9b621775$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "hp-spacer"
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                        className: "hp-btn",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $fa25166ced813feb$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Bar, {
                                w: "32px"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Row, {
                lead: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                    className: "hp-tile",
                    children: "BF"
                }),
                who: "Bluefinch 12",
                where: "Ana Voss",
                tail: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Glyph, {
                    tone: "ok"
                })
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Row, {
                lead: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                    className: "hp-tile",
                    children: "OK"
                }),
                who: "Okapi Park",
                where: "Leo Mard",
                tail: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Glyph, {
                    tone: "ok"
                })
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Row, {
                lead: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                    className: "hp-tile",
                    children: "OK"
                }),
                who: "Okapi Riverside",
                where: "\u2014",
                tail: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $8c4bbfcbcade090a$export$2e2bcd8739ae039), {
                    className: "lp-status-icon lp-status-icon--wait"
                })
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                className: "hp-float hp-float--below",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "hp-input",
                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Bar, {
                            w: "55%"
                        })
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "hp-input",
                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$var$Bar, {
                            w: "40%"
                        })
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "hp-map",
                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                            className: "hp-pin hp-pin--here",
                            style: {
                                "--x": "46%",
                                "--y": "38%"
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($a1790aa2194b2ed1$export$b6a79797ad180576, {
                x: "calc(100% - 40px)",
                y: "16px",
                dx: "-160px",
                dy: "90px"
            })
        ]
    });
}



/** `path` is the MENU row that gates the section; shell sections have none and show for every role.
 *  `nav` is that row's SIDE_NAV key: a section that IS one nav row takes the sidebar's own label as its
 *  title, so the guide and the menu can never call the same page two different things. */ const $e28c7067209a584d$var$SECTIONS = [
    {
        id: "search",
        bullets: 4,
        Illo: $a1790aa2194b2ed1$export$bb59d28c15d71af8
    },
    {
        id: "notifications",
        bullets: 3,
        Illo: $a1790aa2194b2ed1$export$3ff67e221420b0e8
    },
    {
        id: "account",
        bullets: 4,
        Illo: $a1790aa2194b2ed1$export$889ebfc541e98cfb
    },
    {
        id: "lists",
        bullets: 6,
        Illo: $a1790aa2194b2ed1$export$57e9d27c7144c740
    },
    {
        id: "overview",
        path: "/overview",
        nav: "overview",
        bullets: 4,
        Illo: $a1790aa2194b2ed1$export$5a5a83d053ac188
    },
    {
        id: "photo_review",
        path: "/photo-review",
        nav: "photo_report",
        bullets: 5,
        Illo: $a1790aa2194b2ed1$export$960f920d813fdc66
    },
    {
        id: "visits",
        path: "/visit",
        nav: "visit",
        bullets: 4,
        Illo: $a1790aa2194b2ed1$export$f258ee8bd0d2019e
    },
    {
        id: "tracking",
        path: "/tracking",
        nav: "tracking",
        bullets: 4,
        Illo: $a1790aa2194b2ed1$export$cbd19a722827b5ab
    },
    {
        id: "bi_reports",
        path: "/bi-report",
        nav: "all_reports",
        bullets: 3,
        Illo: $a1790aa2194b2ed1$export$c6e90366b251bdee
    },
    {
        id: "tasks",
        path: "/task",
        nav: "tasks",
        bullets: 4,
        Illo: $a1790aa2194b2ed1$export$5742e3581f9fa603
    },
    {
        id: "answers",
        path: "/answers",
        nav: "answers",
        bullets: 4,
        Illo: $a1790aa2194b2ed1$export$227d9f98e0a65e8a
    },
    {
        id: "import",
        path: "/import",
        bullets: 4,
        Illo: $a1790aa2194b2ed1$export$920e1d4bb2399201
    },
    {
        id: "merchandisers",
        path: "/merchandiser",
        nav: "merchandiser",
        bullets: 4,
        Illo: $a1790aa2194b2ed1$export$df249002ef40f935
    },
    {
        id: "supervisors",
        path: "/supervisors",
        nav: "supervisors",
        bullets: 3,
        Illo: $a1790aa2194b2ed1$export$7355ec5c20140f11
    },
    {
        id: "documents",
        path: "/document",
        nav: "documents",
        bullets: 3,
        Illo: $a1790aa2194b2ed1$export$772cdc46201edc07
    },
    {
        id: "surveys",
        path: "/surveys",
        nav: "pt_surveys",
        bullets: 4,
        Illo: $a1790aa2194b2ed1$export$518b8f0601dab267
    },
    {
        id: "reference",
        path: "/points",
        bullets: 4,
        Illo: $a1790aa2194b2ed1$export$4043f6b509107bd2
    }
];
function $e28c7067209a584d$var$useInView(ref) {
    const [inView, setInView] = (0, $cQmXV.useState)(false);
    (0, $cQmXV.useEffect)(()=>{
        const io = new IntersectionObserver(([e])=>setInView(e.isIntersecting), {
            threshold: 0.25
        });
        io.observe(ref.current);
        return ()=>io.disconnect();
    }, [
        ref
    ]);
    return inView;
}
/** Decorative: the copy beside it says what it shows, and nothing inside is focusable. */ function $e28c7067209a584d$var$Illo({ children: children }) {
    const ref = (0, $cQmXV.useRef)(null);
    const play = $e28c7067209a584d$var$useInView(ref);
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
        ref: ref,
        className: `hp-illo${play ? " hp-illo--play" : ""}`,
        "aria-hidden": "true",
        children: children
    });
}
function $e28c7067209a584d$var$SupportCard({ t: t, lang: lang }) {
    /* A static `Modal.confirm` does not inherit ConfigProvider's locale, so the buttons are named
     explicitly. `onOk` returns the promise so OK shows its loading state until the call answers. */ const ask = ()=>(0, $05a90c67d3627fd9$export$2e2bcd8739ae039).confirm({
            title: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$7926257c0571e339), "my_help", lang),
            icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $9e51bdaef216a39c$export$2e2bcd8739ae039), {}),
            content: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$e24f02e1b5477764), "help_confirm", lang),
            okText: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$e24f02e1b5477764), "help_send", lang),
            cancelText: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$e24f02e1b5477764), "discard", lang),
            onOk: ()=>new Promise((resolve)=>{
                    (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
                        method: "GET",
                        url: "users/support/"
                    }, (r)=>{
                        /* The endpoint answers 200 `{ ok, delivered }`, and `ok` is false when NO support account could
               be reached (a blocked bot, a stale chat id) — so the body's flag is the truth, not the HTTP
               status. `isOk()` would call an undelivered request a success. */ if (r?.ok) (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$e24f02e1b5477764), "help_sent", lang));
                        else (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).warning((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$e24f02e1b5477764), "help_failed", lang));
                        resolve();
                    });
                })
        });
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("section", {
        id: "support",
        className: "dp-card hp-section hp-support",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("h2", {
                className: "hp-sec-title",
                children: t("support_title")
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("p", {
                className: "hp-desc",
                children: t("support_desc")
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                type: "primary",
                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $9e51bdaef216a39c$export$2e2bcd8739ae039), {}),
                onClick: ask,
                children: t("support_btn")
            })
        ]
    });
}
function $e28c7067209a584d$export$2e2bcd8739ae039() {
    const me = (0, $b83e93e5ef3de8b0$export$2105062e25df4afe)((state)=>state.me);
    const lang = me?.language;
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$4402302c977bcdb5), key, lang);
    const titleOf = (s)=>s.nav ? (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$72266474e9355649), s.nav, lang) : t(`${s.id}_title`);
    const { hash: hash } = (0, $6f5d68f762d5488a$export$45d76561a5302f2b)();
    const sections = $e28c7067209a584d$var$SECTIONS.filter((s)=>!s.path || (0, $c6c8415f44fd661c$export$e9d5f14ba05b3c5d)(s.path, me?.role));
    /* `--header-h` is a fixed 64px token (tokens.css; `.shell-bar` never wraps), read once the way
     overview's useTokens() reads its palette. `.hp-section { scroll-margin-top }` is the same sum. */ const offset = (0, $cQmXV.useMemo)(()=>{
        const h = parseFloat(getComputedStyle(document.documentElement).getPropertyValue("--header-h"));
        return (Number.isFinite(h) ? h : 64) + 16;
    }, []);
    /* antd's Anchor picks the active link on mount but never scrolls to the hash — the browser tried
     before React rendered the sections. `scroll-margin-top` keeps the landing clear of the bar. */ (0, $cQmXV.useEffect)(()=>{
        const el = hash && document.getElementById(hash.slice(1));
        if (el) el.scrollIntoView();
    }, [
        hash
    ]);
    const items = [
        ...sections.map((s)=>({
                key: s.id,
                href: `#${s.id}`,
                title: titleOf(s)
            })),
        {
            key: "support",
            href: "#support",
            title: t("support_title")
        }
    ];
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
        className: "shell-content hp",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                className: "dp-head",
                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                    className: "dp-head__main",
                    children: [
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("h1", {
                            className: "dp-title",
                            children: t("title")
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("p", {
                            className: "hp-sub",
                            children: t("subtitle")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                className: "hp-grid",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("nav", {
                        className: "hp-rail",
                        "aria-label": t("rail_label"),
                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e394c3c2787ab103$export$2e2bcd8739ae039), {
                            affix: false,
                            showInkInFixed: true,
                            replace: true,
                            targetOffset: offset,
                            items: items,
                            getCurrentAnchor: (active)=>active || items[0].href
                        })
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                        className: "hp-body",
                        children: [
                            sections.map((section)=>{
                                const { id: id, bullets: bullets, Illo: Picture } = section;
                                return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("section", {
                                    id: id,
                                    className: "dp-card hp-section",
                                    children: [
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("h2", {
                                            className: "hp-sec-title",
                                            children: titleOf(section)
                                        }),
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("p", {
                                            className: "hp-desc",
                                            children: t(`${id}_desc`)
                                        }),
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("ul", {
                                            className: "hp-list",
                                            children: Array.from({
                                                length: bullets
                                            }, (_, i)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("li", {
                                                    children: t(`${id}_b${i + 1}`)
                                                }, i))
                                        }),
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($e28c7067209a584d$var$Illo, {
                                            children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)(Picture, {})
                                        })
                                    ]
                                }, id);
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($e28c7067209a584d$var$SupportCard, {
                                t: t,
                                lang: lang
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


/* Answers — the verdict queue.
   No mockup exists for this screen; the visual reference is `docs/design/visits.html` (the same
   archetype) and the normative rules are `docs/design/spec/`.

   Shape (spec/03 archetype A): page head → filter card → status segment + derived chips → table →
   sticky bulk bar. Filters apply as they change and everything narrows on the SERVER — the page
   only ever holds one page of rows, so it must never filter or sort them itself.

   Read this before changing the query. The screen this replaced (`/task-review`) ran on
   `answers/photos_on_review/`, which hardcodes `is_supervised=None, is_active=True` and drops
   every answer without a photo — so the list could only ever show the pending, photographed ones:
   no way to see what you had already decided, and no sorting. And its Supervisor control
   sent `visit__point__responsible_supervisor`, which `AnswerFilter` never declared, so
   django-filter dropped it silently and the filter narrowed nothing.

   This runs on plain `GET answers/` with `AnswerWebFilter` (picsell-api
   `tasks/api/web/v1/filters.py`): `status` over the `annotate_answer_approval` subquery, a
   supervisor that works, multi-value points/networks/merchandisers/templates, `has_photo` and
   `negative` for the chips. */ 

var $cQmXV = parcelRequire("cQmXV");












/* Reading an answer row's fields.
 *
 * Their own module rather than `module/answer/List.js` because `/task/:id`'s answers table
 * needs them too, and importing that page would drag `answers.scss` into the tasks bundle —
 * Parcel re-emits a stylesheet per entry that reaches it (see CLAUDE.md on `list-page.scss`).
 */ /**
 * The URL of one photo, whatever shape it arrives in.
 *
 * ⚠ Three shapes are real, and assuming one is why the thumbnails rendered broken:
 * - `AnswerListSerializer` flattens each photo to a plain URL **string**;
 * - `AnswerSerializer` (the detail, and the list until picsell-api ships) nests
 *   `AnswerPhotoSerializer` — an **object**;
 * - and an `AnswerPhoto` itself holds a photo in **either** `photo_url` (hosted elsewhere, what
 *   the mobile app usually writes) or `photo` (an uploaded file). Reading only `photo_url` shows
 *   nothing for every file-backed photo.
 */ const $e873a05126b50f33$export$d207af4090dcc84a = (photo)=>{
    if (!photo) return null;
    if (typeof photo === "string") return photo;
    return photo.photo_url || photo.photo || null;
};
const $e873a05126b50f33$export$57b71c8db173e2e4 = (row)=>[
        ...(row?.photos || []).map($e873a05126b50f33$export$d207af4090dcc84a),
        ...row?.photo ? [
            $e873a05126b50f33$export$d207af4090dcc84a(row.photo)
        ] : []
    ].filter(Boolean);
const $e873a05126b50f33$export$86e04a8683d602c4 = (row)=>row?.point || row?.visit?.point || row?.task?.point || null;
const $e873a05126b50f33$export$2232f994bf45777c = (row)=>row?.merchandiser || row?.visit?.user || null;
const $e873a05126b50f33$export$ae56d47664a26562 = (point)=>point?.locality_name || point?.locality?.name || null;
const $e873a05126b50f33$export$6e020ab67105656f = (row)=>row?.is_supervised === true ? "approved" : row?.is_supervised === false ? "rejected" : "pending";





/* Shared pieces of the visit review workspace: the status vocabulary, the record modal every
   section opens into, and the reject-with-a-reason flow.

   Visual reference: docs/design/visit-detail.html. Normative rules: docs/design/spec/. */ 

var $cQmXV = parcelRequire("cQmXV");





const $e36e070b6f6386b6$export$f0f7184e405c819f = [
    "report",
    "answer",
    "pricemonitoringreport"
];
const $e36e070b6f6386b6$export$3e32193a9a2be58f = {
    report: "reports",
    answer: "tasks",
    pricemonitoringreport: "price"
};
const $e36e070b6f6386b6$export$1094b4db5e23d27c = (approval)=>approval?.is_approved === true ? "approved" : approval?.is_approved === false ? "rejected" : "pending";
const $e36e070b6f6386b6$var$TONE = {
    approved: {
        tone: "ok",
        Icon: (0, $45839ed7c4a7faa2$export$2e2bcd8739ae039),
        key: "approved_single_visit_name"
    },
    rejected: {
        tone: "no",
        Icon: (0, $bdfb1f797481a352$export$2e2bcd8739ae039),
        key: "no_approved_single_visit_name"
    },
    pending: {
        tone: "wait",
        Icon: (0, $7b23ac4854de9809$export$2e2bcd8739ae039),
        key: "on_verification_single_visit_name"
    },
    /* A task nobody has answered — a resting state, not a fault, so the neutral tone. */ awaiting: {
        tone: "off",
        Icon: (0, $e539a200877e5e8f$export$2e2bcd8739ae039),
        key: "awaiting_answer_name"
    }
};
function $e36e070b6f6386b6$export$5452e567de639f2a({ status: status, lang: lang, className: className = "" }) {
    const { tone: tone, Icon: Icon, key: key } = $e36e070b6f6386b6$var$TONE[status] || $e36e070b6f6386b6$var$TONE.pending;
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $602120e6d17ff12a$export$2e2bcd8739ae039), {
        variant: "filled",
        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)(Icon, {}),
        className: `status-tag status-tag--${tone} ${className}`,
        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), key, lang)
    });
}
function $e36e070b6f6386b6$export$a0b6e408d0d7f6e8({ objectId: objectId, objectType: objectType, isApproved: isApproved, comment: comment = "" }, done) {
    (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
        method: "POST",
        url: "approvals/",
        post: {
            object_id: objectId,
            object_type: objectType,
            is_approved: isApproved,
            comment: comment
        }
    }, (response)=>done((0, $c9936523dc38c641$export$71a04ee6075aae31)(response)));
}
const $e36e070b6f6386b6$export$eb03490a10c3abc9 = /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
    className: "vd-dash",
    children: "\u2014"
});
/** A value cell that says "—" rather than rendering an empty row. */ const $e36e070b6f6386b6$var$shown = (value)=>value === null || value === undefined || value === "" ? $e36e070b6f6386b6$export$eb03490a10c3abc9 : value;
function $e36e070b6f6386b6$export$458b63e78009e70e({ open: open, record: record, lang: lang, onClose: onClose }) {
    if (!record) return null;
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), key, lang);
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $05a90c67d3627fd9$export$2e2bcd8739ae039), {
        open: open,
        onCancel: onClose,
        width: record.wide ? 1000 : 720,
        className: "vd-modal",
        destroyOnHidden: true,
        title: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
            align: "flex-start",
            gap: "small",
            wrap: true,
            children: [
                /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                    vertical: true,
                    flex: "1",
                    className: "vd-modal__id",
                    children: [
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                            strong: true,
                            className: "vd-modal__t",
                            children: record.title
                        }),
                        record.subtitle ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                            type: "secondary",
                            className: "vd-modal__s",
                            children: record.subtitle
                        }) : null
                    ]
                }),
                record.status ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($e36e070b6f6386b6$export$5452e567de639f2a, {
                    status: record.status,
                    lang: lang
                }) : null
            ]
        }),
        footer: [
            ...(record.actions || []).map((action)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                    type: action.tone === "no" ? "primary" : action.tone === "ok" ? "default" : "default",
                    danger: action.tone === "no",
                    className: action.tone === "ok" ? "vd-btn--ok" : "",
                    icon: action.icon,
                    onClick: action.onClick,
                    children: action.label
                }, action.key)),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                onClick: onClose,
                children: t("surveys_modal_close")
            }, "close")
        ],
        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
            vertical: true,
            gap: "middle",
            children: (record.sections || []).filter(Boolean).map((section, index)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("section", {
                    children: [
                        section.titleKey ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                            className: "vd-modal__h",
                            children: [
                                section.icon,
                                t(section.titleKey),
                                section.count != null ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                    className: "vd-cnt",
                                    children: section.count
                                }) : null
                            ]
                        }) : null,
                        section.node != null ? section.node : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $47da64cf901a0567$export$2e2bcd8739ae039), {
                            className: "vd-desc",
                            column: 1,
                            size: "small",
                            bordered: false,
                            children: (section.rows || []).filter(Boolean).map(([label, value, opts])=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $47da64cf901a0567$export$2e2bcd8739ae039).Item, {
                                    label: label,
                                    className: opts?.num ? "vd-desc__num" : "",
                                    children: $e36e070b6f6386b6$var$shown(value)
                                }, label))
                        })
                    ]
                }, section.titleKey || index))
        })
    });
}
function $e36e070b6f6386b6$export$a16bdbbbfa22bef2({ open: open, target: target, lang: lang, onCancel: onCancel, onConfirm: onConfirm }) {
    const [reason, setReason] = (0, $cQmXV.useState)("");
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), key, lang);
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $05a90c67d3627fd9$export$2e2bcd8739ae039), {
        open: open,
        /* The title names the action and the subtitle names the record, so the two do not echo. */ title: t("reject_btn"),
        className: "vd-modal",
        okText: t("reject_btn"),
        cancelText: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), "surveys_modal_close", lang),
        okButtonProps: {
            danger: true
        },
        afterOpenChange: (visible)=>visible || setReason(""),
        onCancel: onCancel,
        onOk: ()=>onConfirm(reason.trim()),
        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
            vertical: true,
            gap: "small",
            children: [
                target?.title ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                    type: "secondary",
                    children: target.title
                }) : null,
                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0883e7f8083c01b0$export$2e2bcd8739ae039).TextArea, {
                    autoFocus: true,
                    rows: 3,
                    value: reason,
                    placeholder: t("reject_reason_ph"),
                    onChange: (event)=>setReason(event.target.value)
                })
            ]
        })
    });
}
function $e36e070b6f6386b6$export$9be373a312e080ff({ text: text }) {
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $99350450b877904c$export$2e2bcd8739ae039), {
        image: (0, $99350450b877904c$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE,
        description: text
    });
}



const $f23c147c1832a8e4$var$PAGE_SIZES = [
    10,
    20,
    50,
    100
];
/** Widest period the list will accept, in DAYS — the same cap `/task`, `/photo-review` and
    `/uploads` enforce, so every period control in the app offers the same six presets.

    The DEFAULT is the shared `defaultRange()` — two weeks, today inclusive. The period is the only
    thing bounding how many rows this endpoint scans; it opened on a single day for a while, which
    kept the first paint cheap but hid every verdict older than this morning behind a filter change.
    `/visit` matches it.

    Held in three places: the calendar greys out days beyond the cap, `searchToState` clamps a
    pasted URL, and `buildQuery` clamps whatever is in state at request time — the last is what
    holds. */ const $f23c147c1832a8e4$var$MAX_RANGE_DAYS = 90;
/* The derived first-class filters — the operational questions this list is asked, none of them a
   column the user can eyeball. `param` is what the server calls it.

   ⚠ "With a photo" is MASKED, not deleted: `has_photo` still works on the endpoint
   (`AnswerWebFilter.filter_has_photo`, and `?chip=has_photo` in a bookmarked URL is still read
   back), it is only off the filter row. Restore it by uncommenting the line. */ const $f23c147c1832a8e4$var$CHIPS = [
    // { key: "has_photo", param: "has_photo", label: "chip_photo", hint: "chip_photo_hint" },
    {
        key: "negative",
        param: "negative",
        label: "chip_negative",
        hint: "chip_negative_hint"
    }
];
/* Column key → the field the API orders on. A key missing here is NOT sortable. */ const $f23c147c1832a8e4$var$ORDERING = {
    point: "visit__point__name",
    by: "visit__user__first_name",
    when: "created"
};
/* Six tracks with the period spanning two — eight units, and 24 does not divide by eight into the
   same track width, so the tracks are percentages. `0 0` rather than `1 1`: a short last row
   leaves empty tracks instead of stretching the fields it does have. */ const $f23c147c1832a8e4$var$FIELD_COL = {
    xs: {
        flex: "0 0 100%"
    },
    sm: {
        flex: "0 0 50%"
    },
    md: {
        flex: "0 0 33.3333%"
    },
    xl: {
        flex: "0 0 12.5%"
    }
};
const $f23c147c1832a8e4$var$PERIOD_COL = {
    xs: {
        flex: "0 0 100%"
    },
    sm: {
        flex: "0 0 100%"
    },
    md: {
        flex: "0 0 66.6667%"
    },
    xl: {
        flex: "0 0 25%"
    }
};
const $f23c147c1832a8e4$var$blankFilter = ()=>({
        county: "",
        network: "",
        template: "",
        merchandiser: "",
        supervisor: [],
        points: [],
        search: ""
    });
const $f23c147c1832a8e4$var$SINGLE_KEYS = [
    "county",
    "network",
    "template",
    "merchandiser"
];
const $f23c147c1832a8e4$var$ARRAY_KEYS = [
    "supervisor",
    "points"
];
/** Which ENTITY_DROPDOWN_SETTINGS key names each filter's chip. */ const $f23c147c1832a8e4$var$CHIP_LABEL = {
    county: "region",
    network: "network",
    template: "template",
    merchandiser: "merchandisers",
    supervisor: "supervisor",
    points: "points"
};
/* One request per record — there is no bulk approval endpoint — in batches, so a 100-row selection
   does not open 100 sockets at once. */ const $f23c147c1832a8e4$var$BULK_CHUNK = 6;
const $f23c147c1832a8e4$var$idOf = (v)=>v && typeof v === "object" ? v.id ?? v.value : v;
const $f23c147c1832a8e4$var$joinIds = (list)=>(list || []).map($f23c147c1832a8e4$var$idOf).filter((v)=>v !== undefined && v !== null && v !== "").join(",");
const $f23c147c1832a8e4$var$isoDay = (d)=>(0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)(d).format("YYYY-MM-DD");
function $f23c147c1832a8e4$export$d7b58f10109feb02({ filter: filter, range: range, chips: chips, page: page, size: size, sort: sort }) {
    const p = new URLSearchParams();
    const period = (0, $cc63266e8518a62e$export$e9d4863bcce07ce9)(range, $f23c147c1832a8e4$var$MAX_RANGE_DAYS);
    p.set("page", String(page));
    p.set("page_size", String(size));
    /* A deactivated answer is not part of any working set here, and there is no segment for one —
     the legacy endpoint filtered it out server-side and nothing asked for them. */ p.set("is_active", "true");
    if (filter.county) p.set("county", String($f23c147c1832a8e4$var$idOf(filter.county)));
    if (filter.network) p.set("networks", String($f23c147c1832a8e4$var$idOf(filter.network)));
    if (filter.template) p.set("templates", String($f23c147c1832a8e4$var$idOf(filter.template)));
    if (filter.merchandiser) p.set("merchandisers", String($f23c147c1832a8e4$var$idOf(filter.merchandiser)));
    if (filter.supervisor?.length) p.set("supervisor", $f23c147c1832a8e4$var$joinIds(filter.supervisor));
    if (filter.points?.length) p.set("points", $f23c147c1832a8e4$var$joinIds(filter.points));
    if (filter.search?.trim()) p.set("search", filter.search.trim());
    /* Unchecked sends NOTHING. `false` means "no constraint" on the server, but an absent param is
     unambiguous either way — and `has_photo=false` is a real filter ("answers with nothing to
     look at"), so sending it by accident would be a silent narrowing. */ $f23c147c1832a8e4$var$CHIPS.forEach((chip)=>chips.includes(chip.key) && p.set(chip.param, "true"));
    if (period?.[0]) p.set("created__gte", $f23c147c1832a8e4$var$isoDay(period[0]));
    /* Inclusive end: `created__lte` against a bare date is midnight, so the picked day itself would
     drop every answer that did not arrive at exactly 00:00. */ if (period?.[1]) p.set("created__lte", $f23c147c1832a8e4$var$isoDay((0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)(period[1]).add(1, "day")));
    if (sort) p.set("ordering", `${sort.dir === "descend" ? "-" : ""}${$f23c147c1832a8e4$var$ORDERING[sort.key]}`);
    return p.toString();
}
function $f23c147c1832a8e4$export$7155eef0ece5897e({ filter: filter, range: range, chips: chips, page: page, size: size, sort: sort }) {
    const p = new URLSearchParams();
    if (range?.[0]) p.set("from", $f23c147c1832a8e4$var$isoDay(range[0]));
    if (range?.[1]) p.set("to", $f23c147c1832a8e4$var$isoDay(range[1]));
    $f23c147c1832a8e4$var$SINGLE_KEYS.forEach((key)=>{
        if (filter[key]) p.set(key, String($f23c147c1832a8e4$var$idOf(filter[key])));
    });
    $f23c147c1832a8e4$var$ARRAY_KEYS.forEach((key)=>(filter[key] || []).forEach((v)=>p.append(key, String($f23c147c1832a8e4$var$idOf(v)))));
    if (filter.search?.trim()) p.set("q", filter.search.trim());
    chips.forEach((key)=>p.append("chip", key));
    if (page > 1) p.set("page", String(page));
    if (size !== $f23c147c1832a8e4$var$PAGE_SIZES[0]) p.set("size", String(size));
    if (sort) p.set("sort", `${sort.dir === "descend" ? "-" : ""}${sort.key}`);
    return p.toString();
}
function $f23c147c1832a8e4$export$fade2611c23f9109(search, me) {
    const p = new URLSearchParams(search);
    const filter = $f23c147c1832a8e4$var$blankFilter();
    $f23c147c1832a8e4$var$SINGLE_KEYS.forEach((key)=>{
        if (p.get(key)) filter[key] = p.get(key);
    });
    /* Ids only — `EntitySelect` names them once it has fetched the option they belong to. */ $f23c147c1832a8e4$var$ARRAY_KEYS.forEach((key)=>{
        filter[key] = p.getAll(key).map((v)=>({
                id: Number(v)
            }));
    });
    filter.search = p.get("q") || "";
    const hasFilters = Boolean(search && search.replace(/^\?/, ""));
    /* Without a URL to restore, the supervisor's own region is the scope they are responsible for —
     the same default `/visit` and `/task` seed. */ if (!hasFilters) filter.county = (0, $3b579ca6158bc61b$export$6339e4f5afb1eeb0)(me) || "";
    const from = p.get("from");
    const to = p.get("to");
    const sort = p.get("sort");
    return {
        filter: filter,
        range: from && to ? (0, $cc63266e8518a62e$export$e9d4863bcce07ce9)([
            (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)(from),
            (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)(to)
        ], $f23c147c1832a8e4$var$MAX_RANGE_DAYS) : (0, $cc63266e8518a62e$export$33e9fd85c7cf1b3c)(),
        chips: p.getAll("chip").filter((key)=>$f23c147c1832a8e4$var$CHIPS.some((chip)=>chip.key === key)),
        page: Math.max(1, Number(p.get("page")) || 1),
        size: $f23c147c1832a8e4$var$PAGE_SIZES.includes(Number(p.get("size"))) ? Number(p.get("size")) : $f23c147c1832a8e4$var$PAGE_SIZES[0],
        sort: sort && $f23c147c1832a8e4$var$ORDERING[sort.replace(/^-/, "")] ? {
            key: sort.replace(/^-/, ""),
            dir: sort[0] === "-" ? "descend" : "ascend"
        } : null
    };
}
const $f23c147c1832a8e4$var$List = ()=>{
    const history = (0, $6f5d68f762d5488a$export$3420e1dc2c4a518c)();
    const location = (0, $6f5d68f762d5488a$export$45d76561a5302f2b)();
    const me = (0, $b83e93e5ef3de8b0$export$2105062e25df4afe)((state)=>state.me);
    const lang = me?.language || "en";
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$d944b88894773aab), key, lang);
    const td = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), key, lang);
    const tp = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b8441a9a81ffc5d6), key, lang);
    const tv = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), key, lang);
    /* Read once. After mount this component owns the state and writes the URL, not the reverse —
     reading it back on every change would fight the user's own typing. */ const initial = (0, $cQmXV.useRef)($f23c147c1832a8e4$export$fade2611c23f9109(location.search, me)).current;
    const [filter, setFilter] = (0, $cQmXV.useState)(initial.filter);
    const [range, setRangeState] = (0, $cQmXV.useState)(initial.range);
    /* A cleared period returns to the default window instead of "all time": the cap exists so this
     list never asks for a year of answers, and clearing to nothing walks straight past it. */ const setRange = (next)=>setRangeState((0, $cc63266e8518a62e$export$e9d4863bcce07ce9)(next, $f23c147c1832a8e4$var$MAX_RANGE_DAYS) || (0, $cc63266e8518a62e$export$33e9fd85c7cf1b3c)());
    const [chips, setChips] = (0, $cQmXV.useState)(initial.chips);
    const [page, setPage] = (0, $cQmXV.useState)(initial.page);
    const [size, setSize] = (0, $cQmXV.useState)(initial.size);
    const [sort, setSort] = (0, $cQmXV.useState)(initial.sort);
    /* What the user is typing, kept apart from `filter.search` so the request is debounced without
     the input lagging a keystroke behind the caret. */ const [term, setTerm] = (0, $cQmXV.useState)(initial.filter.search);
    /* The option objects the selects handed back, so a chosen value labels itself. */ const [chosen, setChosen] = (0, $cQmXV.useState)({
        county: null,
        network: null,
        template: null,
        merchandiser: null
    });
    const [rows, setRows] = (0, $cQmXV.useState)([]);
    const [total, setTotal] = (0, $cQmXV.useState)(0);
    const [loading, setLoading] = (0, $cQmXV.useState)(true);
    const [selected, setSelected] = (0, $cQmXV.useState)([]);
    const [busy, setBusy] = (0, $cQmXV.useState)(false);
    /* The row a rejection is being written for, or null. */ const [rejecting, setRejecting] = (0, $cQmXV.useState)(null);
    /* --------------------------------------------------------------- fetch */ const query = (0, $cQmXV.useMemo)(()=>$f23c147c1832a8e4$export$d7b58f10109feb02({
            filter: filter,
            range: range,
            chips: chips,
            page: page,
            size: size,
            sort: sort
        }), [
        filter,
        range,
        chips,
        page,
        size,
        sort
    ]);
    (0, $cQmXV.useEffect)(()=>{
        const controller = new AbortController();
        setLoading(true);
        (0, $c9936523dc38c641$export$86557ef9e0794d10)(`answers/?${query}`, controller.signal).then((response)=>{
            if (!response) return;
            setRows(response.results || []);
            setTotal(response.count || 0);
            setLoading(false);
        }).catch((error)=>{
            if (error.name === "AbortError") return;
            setRows([]);
            setTotal(0);
            setLoading(false);
        });
        return ()=>controller.abort();
    }, [
        query
    ]);
    /* The URL trails the state; `replace` so filtering does not fill the history stack and Back
     still leaves the page rather than undoing one filter at a time. */ (0, $cQmXV.useEffect)(()=>{
        const search = $f23c147c1832a8e4$export$7155eef0ece5897e({
            filter: filter,
            range: range,
            chips: chips,
            page: page,
            size: size,
            sort: sort
        });
        if (search !== location.search.replace(/^\?/, "")) history.replace({
            search: search
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        filter,
        range,
        chips,
        page,
        size,
        sort
    ]);
    /* Only the free-text field is debounced; every other control applies on change. */ (0, $cQmXV.useEffect)(()=>{
        if (term === filter.search) return;
        const timer = setTimeout(()=>{
            setPage(1);
            setSelected([]);
            setFilter((prev)=>({
                    ...prev,
                    search: term
                }));
        }, 250);
        return ()=>clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        term
    ]);
    /* Any narrowing invalidates the page number: page 7 of the old result set is usually past the
     end of the new one, which would render an empty table over a non-empty result. */ const narrow = (fn)=>(...args)=>{
            setPage(1);
            setSelected([]);
            fn(...args);
        };
    const setSingle = narrow((key, option)=>{
        setChosen((prev)=>({
                ...prev,
                [key]: option
            }));
        setFilter((prev)=>({
                ...prev,
                [key]: option ? $f23c147c1832a8e4$var$idOf(option) : ""
            }));
    });
    const setArray = narrow((key, list)=>setFilter((prev)=>({
                ...prev,
                [key]: list
            })));
    const toggleChip = narrow((key)=>setChips((prev)=>prev.includes(key) ? prev.filter((k)=>k !== key) : [
                ...prev,
                key
            ]));
    const resetFilters = narrow(()=>{
        setFilter($f23c147c1832a8e4$var$blankFilter());
        setChosen({
            county: null,
            network: null,
            template: null,
            merchandiser: null
        });
        setRange((0, $cc63266e8518a62e$export$33e9fd85c7cf1b3c)());
        setChips([]);
        setTerm("");
        setSort(null);
    });
    /* ---------------------------------------------------------------- chips */ /* Persisted: a point picked on page 7 has no name after Back without it (PICSELL-1615 #12). */ const { labels: labels, remember: remember, nameFor: nameFor } = (0, $a9e321bb60aaf998$export$243aa1fcbfd1886a)("answer:labels");
    const clearChip = narrow((key, id)=>{
        if (key === "period") {
            setRange((0, $cc63266e8518a62e$export$33e9fd85c7cf1b3c)());
            return;
        }
        if (key === "search") {
            setTerm("");
            setFilter((prev)=>({
                    ...prev,
                    search: ""
                }));
            return;
        }
        if ($f23c147c1832a8e4$var$SINGLE_KEYS.includes(key)) {
            setChosen((prev)=>({
                    ...prev,
                    [key]: null
                }));
            setFilter((prev)=>({
                    ...prev,
                    [key]: ""
                }));
            return;
        }
        setFilter((prev)=>({
                ...prev,
                [key]: (prev[key] || []).filter((v)=>String($f23c147c1832a8e4$var$idOf(v)) !== String(id))
            }));
    });
    const activeChips = (0, $cQmXV.useMemo)(()=>{
        const out = [];
        if (range?.[0] && range?.[1]) {
            /* Short form, per spec/04 — `28 Jul → 11 Aug`. The year shows only when the range leaves the
         current one, which is also what keeps the chip on one line on a phone. */ const thisYear = new Date().getFullYear();
            const sameYear = range[0].year() === thisYear && range[1].year() === thisYear;
            const fmt = new Intl.DateTimeFormat((0, $7d0f78de0b68a104$export$bd7bed267fc278f2)(lang), {
                day: "numeric",
                month: "short",
                ...sameYear ? {} : {
                    year: "numeric"
                }
            });
            out.push({
                key: "period",
                label: tp("period"),
                value: `${fmt.format(range[0].toDate())} \u{2192} ${fmt.format(range[1].toDate())}`
            });
        }
        if (filter.search) out.push({
            key: "search",
            label: tp("search"),
            value: filter.search
        });
        $f23c147c1832a8e4$var$SINGLE_KEYS.forEach((key)=>{
            if (!filter[key]) return;
            /* `chosen[key]` is the option object the select handed back, so it names itself; falling back
         to the bare id sends `nameFor` to the resolution cache. */ out.push({
                key: key,
                label: td($f23c147c1832a8e4$var$CHIP_LABEL[key]),
                value: nameFor(key, chosen[key] ?? filter[key])
            });
        });
        $f23c147c1832a8e4$var$ARRAY_KEYS.forEach((key)=>{
            (filter[key] || []).forEach((v)=>out.push({
                    key: key,
                    id: $f23c147c1832a8e4$var$idOf(v),
                    label: td($f23c147c1832a8e4$var$CHIP_LABEL[key]),
                    value: nameFor(key, v)
                }));
        });
        return out;
    /* `labels` is a dependency: a chip that arrived as an id has to re-render once its name lands. */ // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        filter,
        chosen,
        labels,
        range,
        lang
    ]);
    /* ------------------------------------------------------- approve / reject */ const approve = (row)=>new Promise((resolve)=>{
            (0, $e36e070b6f6386b6$export$a0b6e408d0d7f6e8)({
                objectId: row.id,
                objectType: "answer",
                isApproved: true,
                comment: ""
            }, (ok)=>resolve(ok));
        });
    const approveOne = async (row)=>{
        setBusy(true);
        const ok = await approve(row);
        setBusy(false);
        if (!ok) return;
        /* Patched in place, not refetched: the table must not jump under the cursor. */ setRows((prev)=>prev.map((r)=>r.id === row.id ? {
                    ...r,
                    is_supervised: true
                } : r));
        (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success(tv("record_approved"), {
            position: "top-right"
        });
    };
    const approveSelected = async ()=>{
        const targets = rows.filter((row)=>selected.includes(row.id));
        if (!targets.length) {
            setSelected([]);
            return;
        }
        setBusy(true);
        const done = [];
        for(let i = 0; i < targets.length; i += $f23c147c1832a8e4$var$BULK_CHUNK){
            const batch = targets.slice(i, i + $f23c147c1832a8e4$var$BULK_CHUNK);
            const results = await Promise.all(batch.map(approve));
            batch.forEach((row, index)=>results[index] && done.push(row.id));
        }
        setBusy(false);
        if (done.length) {
            setRows((prev)=>prev.map((r)=>done.includes(r.id) ? {
                        ...r,
                        is_supervised: true
                    } : r));
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success((0, $3b579ca6158bc61b$export$9563e054e6f787fb)(t("approved_msg"), {
                n: done.length
            }), {
                position: "top-right"
            });
        }
        if (done.length < targets.length) (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).warning((0, $3b579ca6158bc61b$export$9563e054e6f787fb)(t("failed_msg"), {
            n: targets.length - done.length
        }), {
            position: "top-right"
        });
        setSelected([]);
    };
    /* Walk into the record carrying this row's position in the FILTERED list and the filters
     themselves, so the workspace can step through the same queue and come back to this view. */ const openAnswer = (row, indexOnPage)=>{
        const search = new URLSearchParams($f23c147c1832a8e4$export$7155eef0ece5897e({
            filter: filter,
            range: range,
            chips: chips,
            page: page,
            size: size,
            sort: sort
        }));
        if (indexOnPage != null) {
            search.set("i", String((page - 1) * size + indexOnPage + 1));
            search.set("n", String(total));
        }
        history.push(`/answers/${row.id}?${search.toString()}`);
    };
    /* ------------------------------------------------------------- columns */ const dateFmt = (0, $cQmXV.useMemo)(()=>new Intl.DateTimeFormat((0, $7d0f78de0b68a104$export$bd7bed267fc278f2)(lang), {
            day: "2-digit",
            month: "short",
            hour: "2-digit",
            minute: "2-digit"
        }), [
        lang
    ]);
    const columns = (0, $cQmXV.useMemo)(()=>[
            {
                /* The verdict, as a pill on the row: a decided answer used to look exactly like a pending
           one, and only a toast said anything had happened (PICSELL-1615 #5). */ key: "status",
                title: tv("status_label"),
                width: 150,
                fixed: "left",
                render: (value, row)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e36e070b6f6386b6$export$5452e567de639f2a), {
                        status: (0, $e873a05126b50f33$export$6e020ab67105656f)(row),
                        lang: lang
                    })
            },
            {
                key: "point",
                title: t("col_point"),
                width: 300,
                fixed: "left",
                ellipsis: true,
                sorter: true,
                render: (value, row)=>{
                    const point = (0, $e873a05126b50f33$export$86e04a8683d602c4)(row);
                    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $66539b2560a58e4e$export$2692b073ef5fee01), {
                        title: [
                            (0, $e873a05126b50f33$export$ae56d47664a26562)(point),
                            point?.name
                        ].filter(Boolean).join(" \xb7 "),
                        sub: row.task?.title
                    });
                }
            },
            {
                key: "answer",
                title: t("col_answer"),
                width: 320,
                render: (value, row)=>{
                    const photos = (0, $e873a05126b50f33$export$57b71c8db173e2e4)(row);
                    const cover = photos[0];
                    /* Boolean first: a "no" is the operational signal on this row, and it reads as a word
             plus a tone rather than as a bare true/false. */ const text = row.answer || (row.boolean_answer === null ? null : t(row.boolean_answer ? "ans_yes" : "ans_no"));
                    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                        align: "center",
                        gap: 8,
                        className: "an-ans",
                        children: [
                            cover ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $7012c54fc4de0c33$export$2e2bcd8739ae039), {
                                src: cover,
                                preview: false,
                                width: 36,
                                height: 36,
                                rootClassName: "an-thumb",
                                alt: ""
                            }) : null,
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                vertical: true,
                                className: "lp-main",
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                        ellipsis: {
                                            tooltip: text
                                        },
                                        className: row.boolean_answer === false ? "an-ans__no" : "",
                                        children: text || /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                            className: "lp-dash",
                                            children: t("ans_photo_only")
                                        })
                                    }),
                                    photos.length > 1 ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                        type: "secondary",
                                        className: "lp-main__sub",
                                        children: (0, $3b579ca6158bc61b$export$9563e054e6f787fb)(t("photos_count"), {
                                            n: photos.length
                                        })
                                    }) : null
                                ]
                            })
                        ]
                    });
                }
            },
            {
                key: "by",
                title: t("col_by"),
                width: 200,
                ellipsis: true,
                sorter: true,
                render: (value, row)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $66539b2560a58e4e$export$8a3d0b92eb0904a5), {
                        user: (0, $e873a05126b50f33$export$2232f994bf45777c)(row),
                        strong: false
                    })
            },
            {
                key: "when",
                title: t("col_when"),
                width: 170,
                sorter: true,
                render: (value, row)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "lp-num",
                        children: row.created ? dateFmt.format(new Date(row.created)) : "\u2014"
                    })
            },
            (0, $66539b2560a58e4e$export$b0493221521ca587)((value, row, index)=>{
                /* The verdict is offered only while the row is still pending — `is_supervised` is a plain
           column the list serves again (PICSELL-1581 #20); a decided row shows its pill instead. */ const pending = (0, $e873a05126b50f33$export$6e020ab67105656f)(row) === "pending";
                return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $66539b2560a58e4e$export$523acc1bb0ce2e43), {
                    label: t("row_actions"),
                    items: [
                        {
                            key: "open",
                            icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $357da3723e13ae38$export$2e2bcd8739ae039), {}),
                            label: t("open")
                        },
                        ...pending ? [
                            {
                                key: "approve",
                                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $45839ed7c4a7faa2$export$2e2bcd8739ae039), {}),
                                label: tv("approv_btn")
                            },
                            {
                                key: "reject",
                                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $bdfb1f797481a352$export$2e2bcd8739ae039), {}),
                                label: tv("reject_btn"),
                                danger: true
                            }
                        ] : []
                    ],
                    onClick: (key)=>{
                        if (key === "open") return openAnswer(row, index);
                        if (key === "approve") return approveOne(row);
                        setRejecting(row);
                    }
                });
            })
        ], // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        lang,
        rows,
        dateFmt
    ]);
    const scrollY = (0, $66539b2560a58e4e$export$f44b992e82788e9)();
    const selectable = rows.filter((row)=>selected.includes(row.id));
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
        vertical: true,
        gap: "middle",
        className: "shell-content lp an",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                className: "lp-head",
                justify: "space-between",
                align: "flex-end",
                gap: "middle",
                wrap: true,
                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                    vertical: true,
                    children: [
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Title, {
                            level: 1,
                            className: "lp-title",
                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$72266474e9355649), "answers", lang)
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Paragraph, {
                            type: "secondary",
                            className: "lp-sub",
                            children: t("page_sub")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b4fda840b736e640$export$2e2bcd8739ae039), {
                className: "lp-filters",
                variant: "outlined",
                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039), {
                    layout: "vertical",
                    component: false,
                    colon: false,
                    children: [
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $db6c3adada49524e$export$2e2bcd8739ae039), {
                            gutter: [
                                12,
                                12
                            ],
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $cde227eb983ae1d2$export$2e2bcd8739ae039), {
                                    ...$f23c147c1832a8e4$var$PERIOD_COL,
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                        label: tp("period"),
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $cc63266e8518a62e$export$2e2bcd8739ae039), {
                                            value: range,
                                            onChange: narrow(setRange),
                                            maxDays: $f23c147c1832a8e4$var$MAX_RANGE_DAYS,
                                            clearTo: (0, $cc63266e8518a62e$export$33e9fd85c7cf1b3c)
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $cde227eb983ae1d2$export$2e2bcd8739ae039), {
                                    ...$f23c147c1832a8e4$var$FIELD_COL,
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                        label: td("region"),
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b6929c6a194abc34$export$2e2bcd8739ae039), {
                                            entity: "county",
                                            value: filter.county,
                                            seed: chosen.county || (me?.county && typeof me.county === "object" ? me.county : null),
                                            prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $68eebcef827bb540$export$2e2bcd8739ae039), {}),
                                            onChange: (option)=>setSingle("county", option),
                                            onResolve: remember("county")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $cde227eb983ae1d2$export$2e2bcd8739ae039), {
                                    ...$f23c147c1832a8e4$var$FIELD_COL,
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                        label: td("network"),
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b6929c6a194abc34$export$2e2bcd8739ae039), {
                                            entity: "network",
                                            value: filter.network,
                                            seed: chosen.network,
                                            prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $f48fe90789d2a71a$export$2e2bcd8739ae039), {}),
                                            onChange: (option)=>setSingle("network", option),
                                            onResolve: remember("network")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $cde227eb983ae1d2$export$2e2bcd8739ae039), {
                                    ...$f23c147c1832a8e4$var$FIELD_COL,
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                        label: td("template"),
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b6929c6a194abc34$export$2e2bcd8739ae039), {
                                            entity: "template",
                                            value: filter.template,
                                            seed: chosen.template,
                                            prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $170c031fa50279f7$export$2e2bcd8739ae039), {}),
                                            onChange: (option)=>setSingle("template", option),
                                            onResolve: remember("template")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $cde227eb983ae1d2$export$2e2bcd8739ae039), {
                                    ...$f23c147c1832a8e4$var$FIELD_COL,
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                        label: td("merchandisers"),
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b6929c6a194abc34$export$2e2bcd8739ae039), {
                                            entity: "merchandisers",
                                            value: filter.merchandiser,
                                            seed: chosen.merchandiser,
                                            prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e85f2e3cc711f245$export$2e2bcd8739ae039), {}),
                                            onChange: (option)=>setSingle("merchandiser", option),
                                            onResolve: remember("merchandiser")
                                        })
                                    })
                                }),
                                me?.role === "supervisor_manager" ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $cde227eb983ae1d2$export$2e2bcd8739ae039), {
                                    ...$f23c147c1832a8e4$var$FIELD_COL,
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                        label: td("supervisor"),
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b6929c6a194abc34$export$2e2bcd8739ae039), {
                                            entity: "supervisor",
                                            isMulti: true,
                                            value: filter.supervisor,
                                            prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $d5baeea001a6abe5$export$2e2bcd8739ae039), {}),
                                            onChange: (list)=>setArray("supervisor", list),
                                            onResolve: remember("supervisor")
                                        })
                                    })
                                }) : null,
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $cde227eb983ae1d2$export$2e2bcd8739ae039), {
                                    ...$f23c147c1832a8e4$var$FIELD_COL,
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                        label: td("points"),
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b6929c6a194abc34$export$2e2bcd8739ae039), {
                                            entity: "points",
                                            isMulti: true,
                                            value: filter.points,
                                            county: filter.county,
                                            moduleFilter: filter.network,
                                            prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $a1f80a723f71d713$export$2e2bcd8739ae039), {}),
                                            /* Only names the cache already knows: seeding an id AS its label would satisfy
                     the select and stop it ever fetching the real name. */ seed: (filter.points || []).flatMap((p)=>{
                                                const name = labels[`points:${$f23c147c1832a8e4$var$idOf(p)}`];
                                                return name ? [
                                                    {
                                                        id: $f23c147c1832a8e4$var$idOf(p),
                                                        label: name
                                                    }
                                                ] : [];
                                            }),
                                            onChange: (list)=>setArray("points", list),
                                            onResolve: remember("points")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $cde227eb983ae1d2$export$2e2bcd8739ae039), {
                                    ...$f23c147c1832a8e4$var$FIELD_COL,
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                        label: tp("search"),
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0883e7f8083c01b0$export$2e2bcd8739ae039), {
                                            allowClear: true,
                                            prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $20a259d46bffcb08$export$2e2bcd8739ae039), {}),
                                            placeholder: t("search_ph"),
                                            value: term,
                                            onChange: (event)=>setTerm(event.target.value)
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $a9e321bb60aaf998$export$2e2bcd8739ae039), {
                            className: "lp-chips",
                            items: activeChips,
                            closeLabel: tp("a_remove_filter"),
                            onClose: clearChip
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                            className: "lp-quality",
                            align: "center",
                            gap: "small",
                            wrap: true,
                            children: $f23c147c1832a8e4$var$CHIPS.map((chip)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $602120e6d17ff12a$export$2e2bcd8739ae039).CheckableTag, {
                                    checked: chips.includes(chip.key),
                                    onChange: ()=>toggleChip(chip.key),
                                    title: t(chip.hint),
                                    children: t(chip.label)
                                }, chip.key))
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                            className: "lp-filters__foot",
                            align: "center",
                            gap: "small",
                            wrap: true,
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                    className: "lp-spacer"
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                    size: "small",
                                    onClick: resetFilters,
                                    children: td("filter_reset")
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $b4fda840b736e640$export$2e2bcd8739ae039), {
                className: "lp-table",
                variant: "outlined",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                        className: "lp-table__bar",
                        align: "center",
                        gap: "small",
                        wrap: true,
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                strong: true,
                                className: "lp-table__title",
                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$72266474e9355649), "answers", lang)
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                type: "secondary",
                                "aria-live": "polite",
                                children: [
                                    tp("records_count"),
                                    ": ",
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                        strong: true,
                                        children: total
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $dff4d45d201c6dfe$export$2e2bcd8739ae039), {
                        className: "lp-table__grid",
                        rowKey: "id",
                        size: "middle",
                        columns: columns,
                        dataSource: rows,
                        loading: loading,
                        scroll: {
                            x: 1140,
                            y: scrollY
                        },
                        rowClassName: (row)=>selected.includes(row.id) ? "lp-row lp-row--on" : "lp-row",
                        rowSelection: {
                            fixed: true,
                            selectedRowKeys: selected,
                            onChange: (keys)=>setSelected(keys)
                        },
                        onRow: (row, index)=>({
                                onClick: (event)=>{
                                    /* The selection cell and the row menu own their clicks; everything else walks into
                 the record. */ if (event.target.closest(".ant-table-selection-column, .ant-dropdown, .ant-btn")) return;
                                    openAnswer(row, index);
                                }
                            }),
                        /* Paging is the footer below, so the only thing left for the table's own onChange is the
             sorter — with `pagination={false}` its first argument carries nothing. */ onChange: (pagination, filters, sorter)=>{
                            const next = sorter?.order && $f23c147c1832a8e4$var$ORDERING[sorter.columnKey] ? {
                                key: sorter.columnKey,
                                dir: sorter.order
                            } : null;
                            if (JSON.stringify(next) === JSON.stringify(sort)) return;
                            setSort(next);
                            setPage(1);
                        },
                        pagination: false,
                        locale: {
                            emptyText: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $99350450b877904c$export$2e2bcd8739ae039), {
                                image: (0, $99350450b877904c$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE,
                                description: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                    vertical: true,
                                    gap: 8,
                                    align: "center",
                                    children: [
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                            strong: true,
                                            children: t("empty_title")
                                        }),
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                            type: "secondary",
                                            children: t("empty_desc")
                                        }),
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                            size: "small",
                                            onClick: resetFilters,
                                            children: td("filter_reset")
                                        })
                                    ]
                                })
                            })
                        }
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $66539b2560a58e4e$export$6cb97cd1ceda576d), {
                        id: "an",
                        page: page,
                        size: size,
                        total: total,
                        sizes: $f23c147c1832a8e4$var$PAGE_SIZES,
                        labels: {
                            perPage: t("rows_per_page"),
                            range: t("range_of")
                        },
                        onPage: (next)=>{
                            setPage(next);
                            setSelected([]);
                        },
                        onSize: (next)=>{
                            setSize(next);
                            setPage(1);
                            setSelected([]);
                        }
                    })
                ]
            }),
            selected.length > 0 && /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                className: "lp-bulkbar",
                align: "center",
                gap: "middle",
                wrap: true,
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                        className: "lp-bulkbar__n",
                        children: (0, $3b579ca6158bc61b$export$9563e054e6f787fb)(tp("w_selected"), {
                            n: selected.length
                        })
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                        className: "lp-bulkbar__hint",
                        children: t("select_page_hint")
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $eb1133c43d00490b$export$2e2bcd8739ae039), {
                        className: "lp-bulkbar__acts",
                        size: 8,
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                size: "small",
                                onClick: ()=>setSelected([]),
                                children: tp("clear_selection")
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                size: "small",
                                className: "an-btn--ok",
                                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $45839ed7c4a7faa2$export$2e2bcd8739ae039), {}),
                                loading: busy,
                                disabled: !selectable.length,
                                onClick: approveSelected,
                                children: tv("approv_btn")
                            })
                        ]
                    })
                ]
            }),
            rejecting && /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $9525ffc2d869d787$export$2e2bcd8739ae039), {
                target: {
                    objectId: rejecting.id,
                    objectType: "answer"
                },
                photo: (0, $e873a05126b50f33$export$57b71c8db173e2e4)(rejecting)[0] || null,
                point: (0, $e873a05126b50f33$export$86e04a8683d602c4)(rejecting) ? {
                    ...(0, $e873a05126b50f33$export$86e04a8683d602c4)(rejecting),
                    locality: {
                        name: (0, $e873a05126b50f33$export$ae56d47664a26562)((0, $e873a05126b50f33$export$86e04a8683d602c4)(rejecting))
                    }
                } : null,
                visitId: rejecting.visit_id,
                lang: lang,
                onCancel: ()=>setRejecting(null),
                onDone: ()=>{
                    setRows((prev)=>prev.map((r)=>r.id === rejecting.id ? {
                                ...r,
                                is_supervised: false
                            } : r));
                    setRejecting(null);
                }
            })
        ]
    });
};
var $f23c147c1832a8e4$export$2e2bcd8739ae039 = $f23c147c1832a8e4$var$List;


/* /answers/:id — the answer review workspace.
   No mockup exists for this screen; the visual reference is `docs/design/visit-detail.html` (the
   same archetype) and the normative rules are `docs/design/spec/`.

   Shape (spec/03 archetype C): a queue plus one document. Page head with the position in the
   filtered queue → the photo beside the two things it is judged against (what was asked, what came
   back) → one verdict bar. It replaced a full-screen overlay that had no URL of its own: the old
   screen faked history with `pushState`/`popstate`, so an answer could not be linked, shared or
   reloaded, and its `keydown` listener was never removed — remounting stacked handlers.

   The queue is the LIST's queue. The id of the neighbour cannot be derived here (the order is
   whatever the list was filtered and sorted by), so the filters ride in the query string and one
   `page_size=1` request at the target position resolves it through `List.js`'s own `buildQuery` —
   one definition of the query shape, not two. Same mechanism as `/visit/:id`. */ 

var $cQmXV = parcelRequire("cQmXV");















const $f55238b83d3d3fdb$var$Page = ()=>{
    const { id: id } = (0, $6f5d68f762d5488a$export$99eaa27ddbbb95ef)();
    const history = (0, $6f5d68f762d5488a$export$3420e1dc2c4a518c)();
    const location = (0, $6f5d68f762d5488a$export$45d76561a5302f2b)();
    const me = (0, $b83e93e5ef3de8b0$export$2105062e25df4afe)((state)=>state.me);
    const lang = me?.language || "en";
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$4a057643b4c36045), key, lang);
    const tv = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), key, lang);
    const tp = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b8441a9a81ffc5d6), key, lang);
    const [answer, setAnswer] = (0, $cQmXV.useState)(null);
    const [loading, setLoading] = (0, $cQmXV.useState)(true);
    const [busy, setBusy] = (0, $cQmXV.useState)(false);
    const [rejecting, setRejecting] = (0, $cQmXV.useState)(false);
    /* Which photo is on the stage. Clamped at render rather than reset on load, so a shorter next
     answer cannot leave the index pointing past its last photo. */ const [photoIndex, setPhotoIndex] = (0, $cQmXV.useState)(0);
    /* Position in the filtered queue, handed over by the list so stepping continues it. */ const params = new URLSearchParams(location.search);
    const queueIndex = Number(params.get("i")) || 0;
    const queueTotal = Number(params.get("n")) || 0;
    /* ------------------------------------------------------------------ load */ (0, $cQmXV.useEffect)(()=>{
        const controller = new AbortController();
        setLoading(true);
        (0, $c9936523dc38c641$export$86557ef9e0794d10)(`answers/${id}/`, controller.signal).then((response)=>{
            setAnswer(response?.id ? response : null);
            setLoading(false);
        }).catch((error)=>{
            if (error.name === "AbortError") return;
            setAnswer(null);
            setLoading(false);
        });
        return ()=>controller.abort();
    }, [
        id
    ]);
    /* ------------------------------------------------------- queue stepping */ const step = (0, $cQmXV.useCallback)((delta)=>{
        if (!queueTotal || busy) return;
        const next = queueIndex + delta;
        if (next < 1 || next > queueTotal) return;
        const state = (0, $f23c147c1832a8e4$export$fade2611c23f9109)(location.search, me);
        setBusy(true);
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "GET",
            url: `answers/?${(0, $f23c147c1832a8e4$export$d7b58f10109feb02)({
                ...state,
                page: next,
                size: 1
            })}`
        }, (response)=>{
            setBusy(false);
            const neighbour = response?.results?.[0];
            if (!neighbour?.id) {
                /* A verdict can shrink the filtered set under us, so the target position may no longer
             exist. Returning silently made the arrow look broken. */ (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).info((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$4a057643b4c36045), "queue_end", me?.language || "en"), {
                    position: "top-right"
                });
                return;
            }
            const search = new URLSearchParams(location.search);
            search.set("i", String(next));
            history.push(`/answers/${neighbour.id}?${search.toString()}`);
        });
    }, [
        queueIndex,
        queueTotal,
        busy,
        history,
        location.search,
        me
    ]);
    /* The list no longer filters by verdict, so a decision cannot drop the record out of the set —
     the queue does not close up behind us and +1 is simply the next record. */ const stepAfterVerdict = ()=>step(1);
    (0, $cQmXV.useEffect)(()=>{
        const onKey = (event)=>{
            if (event.metaKey || event.ctrlKey || event.altKey) return;
            const tag = (event.target.tagName || "").toLowerCase();
            if (tag === "input" || tag === "textarea" || tag === "select" || event.target.isContentEditable) return;
            /* A modal — the reject flow, or the photo lightbox — owns the keyboard while it is open. */ if (document.querySelector(".ant-modal-wrap:not([style*='display: none']), .ant-image-preview-wrap")) return;
            if (event.key !== "[" && event.key !== "]") return;
            event.preventDefault();
            step(event.key === "[" ? -1 : 1);
        };
        /* Removed on unmount. The screen this replaced never did, so every remount of the overlay
       added another live handler to `document`. */ document.addEventListener("keydown", onKey);
        return ()=>document.removeEventListener("keydown", onKey);
    }, [
        step
    ]);
    /* --------------------------------------------------------- moderation */ const decided = (isApproved)=>{
        /* A record's verdict is not the visit's verdict — sharing one message made approving a single
       answer read as approving the whole visit. */ (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success(tv(isApproved ? "record_approved" : "record_rejected"), {
            position: "top-right"
        });
    };
    const approve = ()=>{
        setBusy(true);
        (0, $e36e070b6f6386b6$export$a0b6e408d0d7f6e8)({
            objectId: answer.id,
            objectType: "answer",
            isApproved: true,
            comment: ""
        }, (ok)=>{
            setBusy(false);
            if (!ok) return;
            /* The record itself says so too, for the case where there is no next one to step to. */ setAnswer((a)=>({
                    ...a,
                    is_supervised: true
                }));
            decided(true);
            /* Straight on to the next one in the queue: this page exists to be walked. */ stepAfterVerdict();
        });
    };
    /* ------------------------------------------------------------- render */ const dateFmt = (0, $cQmXV.useMemo)(()=>new Intl.DateTimeFormat((0, $7d0f78de0b68a104$export$bd7bed267fc278f2)(lang), {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit"
        }), [
        lang
    ]);
    const dayFmt = (0, $cQmXV.useMemo)(()=>new Intl.DateTimeFormat((0, $7d0f78de0b68a104$export$bd7bed267fc278f2)(lang), {
            day: "2-digit",
            month: "short",
            year: "numeric"
        }), [
        lang
    ]);
    const backTo = `/answers${location.search ? `?${new URLSearchParams(location.search).toString()}` : ""}`;
    if (loading) return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
        className: "shell-content an",
        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e855c7114b2916ed$export$2e2bcd8739ae039), {
            active: true,
            paragraph: {
                rows: 8
            }
        })
    });
    if (!answer) return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
        className: "shell-content an",
        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $99350450b877904c$export$2e2bcd8739ae039), {
            image: (0, $99350450b877904c$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE,
            description: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                vertical: true,
                gap: 8,
                align: "center",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                        strong: true,
                        children: t("not_found_title")
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                        type: "secondary",
                        children: t("not_found_desc")
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                        size: "small",
                        onClick: ()=>history.push(backTo),
                        children: t("back_to_list")
                    })
                ]
            })
        })
    });
    const task = answer.task || {};
    const point = (0, $e873a05126b50f33$export$86e04a8683d602c4)(answer);
    const photos = (0, $e873a05126b50f33$export$57b71c8db173e2e4)(answer);
    /* Clamped, not reset: stepping the queue swaps `answer` without unmounting, and the next one may
     carry fewer photos than the index that was left behind. */ const shown = Math.min(photoIndex, Math.max(photos.length - 1, 0));
    const supervisors = (point?.responsible_supervisors || []).map((0, $66539b2560a58e4e$export$1d6cfa7493842c29)).filter(Boolean);
    const tags = answer.selected_tags || [];
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
        className: "shell-content an",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                className: "dp-head",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                        className: "dp-head__main",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                align: "center",
                                gap: 6,
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Link, {
                                        onClick: ()=>history.push(backTo),
                                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$72266474e9355649), "answers", lang)
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $89db7229a7e10f8f$export$2e2bcd8739ae039), {
                                        className: "an-crumb-icon"
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                        type: "secondary",
                                        children: [
                                            "#",
                                            answer.id
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                                className: "dp-head__titlerow",
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("h1", {
                                        className: "dp-title",
                                        children: [
                                            (0, $e873a05126b50f33$export$ae56d47664a26562)(point),
                                            point?.name
                                        ].filter(Boolean).join(" \xb7 ") || task.title || `#${answer.id}`
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e36e070b6f6386b6$export$5452e567de639f2a), {
                                        status: (0, $e873a05126b50f33$export$6e020ab67105656f)(answer),
                                        lang: lang
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                type: "secondary",
                                children: task.title
                            })
                        ]
                    }),
                    queueTotal > 1 && queueIndex ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                        vertical: true,
                        align: "flex-end",
                        gap: 2,
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                align: "center",
                                gap: 2,
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                        type: "text",
                                        size: "small",
                                        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0f3c6d60b091c877$export$2e2bcd8739ae039), {}),
                                        disabled: queueIndex <= 1 || busy,
                                        "aria-label": t("queue_prev"),
                                        title: `${t("queue_prev")} [`,
                                        onClick: ()=>step(-1)
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                        type: "secondary",
                                        className: "an-queue",
                                        children: (0, $3b579ca6158bc61b$export$9563e054e6f787fb)(t("queue_of"), {
                                            i: queueIndex,
                                            n: queueTotal
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                        type: "text",
                                        size: "small",
                                        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $89db7229a7e10f8f$export$2e2bcd8739ae039), {}),
                                        disabled: queueIndex >= queueTotal || busy,
                                        "aria-label": t("queue_next"),
                                        title: `${t("queue_next")} ]`,
                                        onClick: ()=>step(1)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                type: "secondary",
                                className: "an-keys",
                                children: t("keys_hint")
                            })
                        ]
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                className: "an-work",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                        className: "dp-card",
                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                            vertical: true,
                            gap: "middle",
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                    strong: true,
                                    className: "dp-sec-title",
                                    children: t("sec_photos")
                                }),
                                photos.length ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $7012c54fc4de0c33$export$2e2bcd8739ae039).PreviewGroup, {
                                    children: [
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                                            className: "an-photo",
                                            children: [
                                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $7012c54fc4de0c33$export$2e2bcd8739ae039), {
                                                    src: photos[shown],
                                                    alt: ""
                                                }),
                                                photos.length > 1 ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $575603080129eb00$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                                            className: "an-photo__nav an-photo__nav--prev",
                                                            shape: "circle",
                                                            icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0f3c6d60b091c877$export$2e2bcd8739ae039), {}),
                                                            "aria-label": t("photo_prev"),
                                                            onClick: ()=>setPhotoIndex(shown - 1 < 0 ? photos.length - 1 : shown - 1)
                                                        }),
                                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                                            className: "an-photo__nav an-photo__nav--next",
                                                            shape: "circle",
                                                            icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $89db7229a7e10f8f$export$2e2bcd8739ae039), {}),
                                                            "aria-label": t("photo_next"),
                                                            onClick: ()=>setPhotoIndex((shown + 1) % photos.length)
                                                        }),
                                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                                            className: "an-photo__n lp-num",
                                                            children: (0, $3b579ca6158bc61b$export$9563e054e6f787fb)(t("photo_of"), {
                                                                i: shown + 1,
                                                                n: photos.length
                                                            })
                                                        })
                                                    ]
                                                }) : null
                                            ]
                                        }),
                                        photos.length > 1 ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                            className: "an-strip",
                                            gap: "small",
                                            children: photos.map((url, index)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("button", {
                                                    type: "button",
                                                    className: `an-strip__t${index === shown ? " an-strip__t--on" : ""}`,
                                                    "aria-label": (0, $3b579ca6158bc61b$export$9563e054e6f787fb)(t("photo_of"), {
                                                        i: index + 1,
                                                        n: photos.length
                                                    }),
                                                    "aria-current": index === shown,
                                                    onClick: ()=>setPhotoIndex(index),
                                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("img", {
                                                        src: url,
                                                        alt: ""
                                                    })
                                                }, `${url}-${index}`))
                                        }) : null
                                    ]
                                }) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $99350450b877904c$export$2e2bcd8739ae039), {
                                    image: (0, $99350450b877904c$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE,
                                    description: t("no_photos")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                        vertical: true,
                        gap: "middle",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                                className: "dp-card",
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                        className: "an-sec-head",
                                        align: "center",
                                        gap: "small",
                                        wrap: true,
                                        children: [
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                                strong: true,
                                                className: "dp-sec-title",
                                                children: t("sec_task")
                                            }),
                                            task.id ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Link, {
                                                className: "an-sec-link",
                                                onClick: ()=>history.push(`/task/${task.id}`),
                                                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $eb1133c43d00490b$export$2e2bcd8739ae039), {
                                                    size: 4,
                                                    children: [
                                                        t("open_task"),
                                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $357da3723e13ae38$export$2e2bcd8739ae039), {})
                                                    ]
                                                })
                                            }) : null
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $47da64cf901a0567$export$2e2bcd8739ae039), {
                                        column: 1,
                                        size: "small",
                                        colon: false,
                                        children: [
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $47da64cf901a0567$export$2e2bcd8739ae039).Item, {
                                                label: t("k_title"),
                                                children: task.id ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Link, {
                                                    onClick: ()=>history.push(`/task/${task.id}`),
                                                    children: task.title || `#${task.id}`
                                                }) : task.title || (0, $66539b2560a58e4e$export$eb03490a10c3abc9)
                                            }),
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $47da64cf901a0567$export$2e2bcd8739ae039).Item, {
                                                label: t("k_point"),
                                                children: [
                                                    (0, $e873a05126b50f33$export$ae56d47664a26562)(point),
                                                    point?.name
                                                ].filter(Boolean).join(" \xb7 ") || (0, $66539b2560a58e4e$export$eb03490a10c3abc9)
                                            }),
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $47da64cf901a0567$export$2e2bcd8739ae039).Item, {
                                                label: t("k_priority"),
                                                children: task.priority ? tp(`priority_${task.priority}`) : (0, $66539b2560a58e4e$export$eb03490a10c3abc9)
                                            }),
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $47da64cf901a0567$export$2e2bcd8739ae039).Item, {
                                                label: t("k_deadline"),
                                                children: task.end ? dayFmt.format(new Date(task.end)) : (0, $66539b2560a58e4e$export$eb03490a10c3abc9)
                                            }),
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $47da64cf901a0567$export$2e2bcd8739ae039).Item, {
                                                label: t("k_description"),
                                                children: task.description || (0, $66539b2560a58e4e$export$eb03490a10c3abc9)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                                className: "dp-card",
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                        strong: true,
                                        className: "dp-sec-title",
                                        children: t("sec_response")
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $47da64cf901a0567$export$2e2bcd8739ae039), {
                                        column: 1,
                                        size: "small",
                                        colon: false,
                                        children: [
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $47da64cf901a0567$export$2e2bcd8739ae039).Item, {
                                                label: t("k_by"),
                                                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $66539b2560a58e4e$export$8a3d0b92eb0904a5), {
                                                    user: answer.visit?.user,
                                                    strong: false
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $47da64cf901a0567$export$2e2bcd8739ae039).Item, {
                                                label: t("k_supervisor"),
                                                children: supervisors.join(", ") || (0, $66539b2560a58e4e$export$eb03490a10c3abc9)
                                            }),
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $47da64cf901a0567$export$2e2bcd8739ae039).Item, {
                                                label: t("k_when"),
                                                children: answer.created ? dateFmt.format(new Date(answer.created)) : (0, $66539b2560a58e4e$export$eb03490a10c3abc9)
                                            }),
                                            answer.answer ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $47da64cf901a0567$export$2e2bcd8739ae039).Item, {
                                                label: t("k_text"),
                                                children: answer.answer
                                            }) : null,
                                            answer.boolean_answer !== null && answer.boolean_answer !== undefined ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $47da64cf901a0567$export$2e2bcd8739ae039).Item, {
                                                label: t("k_boolean"),
                                                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $602120e6d17ff12a$export$2e2bcd8739ae039), {
                                                    variant: "filled",
                                                    className: `status-tag status-tag--${answer.boolean_answer ? "ok" : "no"}`,
                                                    children: t(answer.boolean_answer ? "yes" : "no")
                                                })
                                            }) : null,
                                            tags.length ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $47da64cf901a0567$export$2e2bcd8739ae039).Item, {
                                                label: t("k_tags"),
                                                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $eb1133c43d00490b$export$2e2bcd8739ae039), {
                                                    size: 4,
                                                    wrap: true,
                                                    children: tags.map((tag)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $602120e6d17ff12a$export$2e2bcd8739ae039), {
                                                            children: tag
                                                        }, tag))
                                                })
                                            }) : null,
                                            answer.visit?.id ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $47da64cf901a0567$export$2e2bcd8739ae039).Item, {
                                                label: t("k_visit"),
                                                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Link, {
                                                    onClick: ()=>history.push(`/visit/${answer.visit.id}`),
                                                    children: [
                                                        "#",
                                                        String(answer.visit.id).slice(0, 8)
                                                    ]
                                                })
                                            }) : null
                                        ]
                                    })
                                ]
                            }),
                            (0, $e873a05126b50f33$export$6e020ab67105656f)(answer) === "pending" ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                className: "an-verdict",
                                gap: "small",
                                wrap: true,
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                        className: "an-btn--ok",
                                        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $45839ed7c4a7faa2$export$2e2bcd8739ae039), {}),
                                        loading: busy,
                                        onClick: approve,
                                        children: tv("approv_btn")
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                        danger: true,
                                        type: "primary",
                                        disabled: busy,
                                        onClick: ()=>setRejecting(true),
                                        children: tv("reject_btn")
                                    })
                                ]
                            }) : null
                        ]
                    })
                ]
            }),
            rejecting && /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $9525ffc2d869d787$export$2e2bcd8739ae039), {
                target: {
                    objectId: answer.id,
                    objectType: "answer"
                },
                photo: photos[0] || null,
                point: point,
                visitId: answer.visit?.id,
                lang: lang,
                onCancel: ()=>setRejecting(false),
                onDone: ()=>{
                    setRejecting(false);
                    setAnswer((a)=>({
                            ...a,
                            is_supervised: false
                        }));
                    decided(false);
                    stepAfterVerdict();
                }
            })
        ]
    });
};
var $f55238b83d3d3fdb$export$2e2bcd8739ae039 = $f55238b83d3d3fdb$var$Page;


/* Tasks — the completion list.
   No mockup exists for this screen; the visual reference is `docs/design/visits.html` (the same
   archetype) and the normative rules are `docs/design/spec/`.

   Shape (spec/03 archetype A): page head → filter card → status segment + derived chips → table →
   sticky bulk bar. Filters apply as they change and everything narrows on the SERVER — the page
   only ever holds one page of rows, so it must never filter or sort them itself.

   Read this before changing the query: **none of these filters worked before this rewrite.**
   `TaskViewSet` carried `filter_class = TaskFilter`, the attribute name django-filter dropped in
   2.0, and picsell-api pins 2.4.0 — so `get_filterset_class` returned None, `filter_queryset` was
   a pass-through, and every param the old page sent (status, network, template, region, point,
   created_by, supervisor, the date ranges, overdue, negative answers) was silently ignored. The
   list returned the whole company scope no matter what the panel said. picsell-api gained
   `tasks/api/web/v1/filters.py` (`TaskWebFilter`) and the correct attribute in the same change.

   `status` is a queryset annotation now (`annotate_task_status`), not the old per-object English
   label — which is what lets it be filtered, sorted and counted, and lets the four state words
   live here in four locales. It has four states where the old one had three: "nobody answered"
   and "answered and rejected" were both `Not Completed`, and they are different jobs. */ 

var $cQmXV = parcelRequire("cQmXV");




var $cQmXV = parcelRequire("cQmXV");
var $43e4e3ce7a657b26$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($43e4e3ce7a657b26$exports, "__esModule", {
    value: true
});
var $43e4e3ce7a657b26$var$TableOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 208H676V232h212v136zm0 224H676V432h212v160zM412 432h200v160H412V432zm200-64H412V232h200v136zm-476 64h212v160H136V432zm0-200h212v136H136V232zm0 424h212v136H136V656zm276 0h200v136H412V656zm476 136H676V656h212v136z"
                }
            }
        ]
    },
    "name": "table",
    "theme": "outlined"
};
$43e4e3ce7a657b26$exports.default = $43e4e3ce7a657b26$var$TableOutlined;



function $a8085ca9c62f778e$var$_extends() {
    $a8085ca9c62f778e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a8085ca9c62f778e$var$_extends.apply(this, arguments);
}
const $a8085ca9c62f778e$var$TableOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $a8085ca9c62f778e$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($43e4e3ce7a657b26$exports)))
    }));
/**![table](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkyOCAxNjBIOTZjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjY0MGMwIDE3LjcgMTQuMyAzMiAzMiAzMmg4MzJjMTcuNyAwIDMyLTE0LjMgMzItMzJWMTkyYzAtMTcuNy0xNC4zLTMyLTMyLTMyem0tNDAgMjA4SDY3NlYyMzJoMjEydjEzNnptMCAyMjRINjc2VjQzMmgyMTJ2MTYwek00MTIgNDMyaDIwMHYxNjBINDEyVjQzMnptMjAwLTY0SDQxMlYyMzJoMjAwdjEzNnptLTQ3NiA2NGgyMTJ2MTYwSDEzNlY0MzJ6bTAtMjAwaDIxMnYxMzZIMTM2VjIzMnptMCA0MjRoMjEydjEzNkgxMzZWNjU2em0yNzYgMGgyMDB2MTM2SDQxMlY2NTZ6bTQ3NiAxMzZINjc2VjY1NmgyMTJ2MTM2eiIgLz48L3N2Zz4=) */ const $a8085ca9c62f778e$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($a8085ca9c62f778e$var$TableOutlined);
var $a8085ca9c62f778e$export$2e2bcd8739ae039 = $a8085ca9c62f778e$var$RefIcon;















const $30ad5da16ca1f695$var$PAGE_SIZES = [
    10,
    20,
    50,
    100
];
/**
 * Widest period the list will accept, in DAYS — the same cap `/photo-review` enforces.
 *
 * Enforced in the same THREE places, for the same reason: the calendar greys out days beyond it,
 * `searchToState` clamps a pasted URL, and `buildQuery` clamps whatever is in state at request
 * time. The last one is the backstop that makes the other two convenience rather than the rule.
 */ const $30ad5da16ca1f695$var$MAX_RANGE_DAYS = 90;
/* NOT the shared `defaultRange()` (two weeks ending today). This list filters the DEADLINE, so a
   backward-only default answered "what was due" and hid everything due this week; centring the
   same width on today asks both questions at once. The window size is also what bounds how many
   rows the server scans per request — this is `tasks_task`'s only always-present range filter. */ const $30ad5da16ca1f695$var$defaultTaskRange = ()=>[
        (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)().subtract(7, "day"),
        (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)().add(7, "day")
    ];
/* The row's verdict is the API's four-way `status` — the NEWEST answer's `is_supervised`
   (`annotate_verdict`, PICSELL-1615 #6/#9; the old `Approval` subquery per row is not back) —
   mapped onto the shared pill's tones. Active/inactive is a separate fact and keeps its glyph. */ const $30ad5da16ca1f695$var$TAG_STATUS = {
    awaiting: "awaiting",
    on_review: "pending",
    approved: "approved",
    rejected: "rejected"
};
const $30ad5da16ca1f695$var$STATUSES = Object.keys($30ad5da16ca1f695$var$TAG_STATUS);
const $30ad5da16ca1f695$var$INACTIVE_ICON = {
    Icon: (0, $4d7cc9843b581604$export$2e2bcd8739ae039),
    tone: "off",
    key: "st_inactive"
};
/* The derived first-class filters — the operational questions this list is asked, none of them a
   column the user can eyeball. `param` is what the server calls it. */ const $30ad5da16ca1f695$var$CHIPS = [
    {
        key: "overdue",
        param: "overdue",
        label: "chip_overdue",
        hint: "chip_overdue_hint"
    },
    {
        key: "negative",
        param: "with_negative_answers",
        label: "chip_negative",
        hint: "chip_negative_hint"
    },
    {
        key: "inactive",
        param: "is_active",
        label: "chip_inactive",
        hint: "chip_inactive_hint",
        invert: true
    }
];
/* Column key → the field the API orders on. A key missing here is NOT sortable: `priority` and
   `components` come from the template, and anything computed per object could only reorder the
   page already loaded, which reads as a sort and is not one. */ const $30ad5da16ca1f695$var$ORDERING = {
    task: "title",
    type: "template__name",
    point: "point__name",
    deadline: "end"
};
/* Seven tracks with the period spanning two — nine units, and 24 does not divide by nine. A
   `<Col>`'s responsive value may be an object rather than a span, and that object takes `flex`.
   `0 0` rather than `1 1`: a short last row leaves empty tracks instead of stretching. */ const $30ad5da16ca1f695$var$FIELD_COL = {
    xs: {
        flex: "0 0 100%"
    },
    sm: {
        flex: "0 0 50%"
    },
    md: {
        flex: "0 0 33.3333%"
    },
    xl: {
        flex: "0 0 12.5%"
    }
};
const $30ad5da16ca1f695$var$PERIOD_COL = {
    xs: {
        flex: "0 0 100%"
    },
    sm: {
        flex: "0 0 100%"
    },
    md: {
        flex: "0 0 66.6667%"
    },
    xl: {
        flex: "0 0 25%"
    }
};
const $30ad5da16ca1f695$var$blankFilter = ()=>({
        county: "",
        network: "",
        template: "",
        merchandiser: "",
        supervisor: [],
        author: [],
        points: [],
        search: "",
        status: ""
    });
const $30ad5da16ca1f695$var$SINGLE_KEYS = [
    "county",
    "network",
    "template",
    "merchandiser"
];
const $30ad5da16ca1f695$var$ARRAY_KEYS = [
    "supervisor",
    "author",
    "points"
];
/** Which ENTITY_DROPDOWN_SETTINGS key names each filter's chip. */ const $30ad5da16ca1f695$var$CHIP_LABEL = {
    county: "region",
    network: "network",
    template: "template",
    merchandiser: "merchandisers",
    supervisor: "supervisor",
    author: "created_by",
    points: "points"
};
/** Which TASK_LIST key names each toggleable column in the Columns panel. */ const $30ad5da16ca1f695$var$COLUMN_LABEL = {
    type: "col_type",
    point: "col_point",
    merchandiser: "k_merchandiser",
    author: "col_author"
};
const $30ad5da16ca1f695$var$TOGGLEABLE = Object.keys($30ad5da16ca1f695$var$COLUMN_LABEL);
/* One request per record — there is no bulk endpoint — in batches, so a 100-row selection does not
   open 100 sockets at once. */ const $30ad5da16ca1f695$var$BULK_CHUNK = 6;
const $30ad5da16ca1f695$var$idOf = (v)=>v && typeof v === "object" ? v.id ?? v.value : v;
const $30ad5da16ca1f695$var$joinIds = (list)=>(list || []).map($30ad5da16ca1f695$var$idOf).filter((v)=>v !== undefined && v !== null && v !== "").join(",");
const $30ad5da16ca1f695$var$isoDay = (d)=>(0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)(d).format("YYYY-MM-DD");
function $30ad5da16ca1f695$export$d7b58f10109feb02({ filter: filter, range: range, chips: chips, page: page, size: size, sort: sort }) {
    const p = new URLSearchParams();
    /* Clamped here as well as in the picker and in `searchToState`: this is the one place every
     request goes through, so it is what actually holds the cap. */ const period = (0, $cc63266e8518a62e$export$e9d4863bcce07ce9)(range, $30ad5da16ca1f695$var$MAX_RANGE_DAYS);
    p.set("page", String(page));
    p.set("page_size", String(size));
    if (filter.county) p.set("county", String($30ad5da16ca1f695$var$idOf(filter.county)));
    if (filter.network) p.set("networks", String($30ad5da16ca1f695$var$idOf(filter.network)));
    if (filter.template) p.set("templates", String($30ad5da16ca1f695$var$idOf(filter.template)));
    if (filter.merchandiser) p.set("merchandiser", String($30ad5da16ca1f695$var$idOf(filter.merchandiser)));
    if (filter.supervisor?.length) p.set("supervisor", $30ad5da16ca1f695$var$joinIds(filter.supervisor));
    if (filter.author?.length) p.set("authors", $30ad5da16ca1f695$var$joinIds(filter.author));
    if (filter.points?.length) p.set("points", $30ad5da16ca1f695$var$joinIds(filter.points));
    if (filter.search?.trim()) p.set("search", filter.search.trim());
    if (filter.status) p.set("status", filter.status);
    $30ad5da16ca1f695$var$CHIPS.forEach((chip)=>{
        if (!chips.includes(chip.key)) return;
        /* `invert` is the "deactivated" chip: the flag it reads is `is_active`, so asking for the
       deactivated ones means sending false. Unchecked sends NOTHING — the server treats a `false`
       on the other flags as "don't care" now, but an absent param is unambiguous either way. */ p.set(chip.param, chip.invert ? "false" : "true");
    });
    if (period?.[0]) p.set("end__gte", $30ad5da16ca1f695$var$isoDay(period[0]));
    /* Inclusive end: `end__lte` against a bare date is midnight, so the picked day itself would drop
     every task not due at exactly 00:00. */ if (period?.[1]) p.set("end__lte", $30ad5da16ca1f695$var$isoDay((0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)(period[1]).add(1, "day")));
    if (sort) p.set("ordering", `${sort.dir === "descend" ? "-" : ""}${$30ad5da16ca1f695$var$ORDERING[sort.key]}`);
    return p.toString();
}
/** URL ↔ state, so a filtered view is shareable and survives Back from a task's detail page. */ function $30ad5da16ca1f695$var$stateToSearch({ filter: filter, range: range, chips: chips, page: page, size: size, sort: sort }) {
    const p = new URLSearchParams();
    if (range?.[0]) p.set("from", $30ad5da16ca1f695$var$isoDay(range[0]));
    if (range?.[1]) p.set("to", $30ad5da16ca1f695$var$isoDay(range[1]));
    $30ad5da16ca1f695$var$SINGLE_KEYS.forEach((key)=>{
        if (filter[key]) p.set(key, String($30ad5da16ca1f695$var$idOf(filter[key])));
    });
    $30ad5da16ca1f695$var$ARRAY_KEYS.forEach((key)=>(filter[key] || []).forEach((v)=>p.append(key, String($30ad5da16ca1f695$var$idOf(v)))));
    if (filter.search?.trim()) p.set("q", filter.search.trim());
    /* Same default both ways ("" = all), so the round trip cannot desync as /answers' once did. */ if (filter.status) p.set("status", filter.status);
    chips.forEach((key)=>p.append("chip", key));
    if (page > 1) p.set("page", String(page));
    if (size !== $30ad5da16ca1f695$var$PAGE_SIZES[0]) p.set("size", String(size));
    if (sort) p.set("sort", `${sort.dir === "descend" ? "-" : ""}${sort.key}`);
    return p.toString();
}
function $30ad5da16ca1f695$export$fade2611c23f9109(search, me) {
    const p = new URLSearchParams(search);
    const filter = $30ad5da16ca1f695$var$blankFilter();
    $30ad5da16ca1f695$var$SINGLE_KEYS.forEach((key)=>{
        if (p.get(key)) filter[key] = p.get(key);
    });
    /* Ids only — `EntitySelect` names them once it has fetched the option they belong to. */ $30ad5da16ca1f695$var$ARRAY_KEYS.forEach((key)=>{
        filter[key] = p.getAll(key).map((v)=>({
                id: Number(v)
            }));
    });
    filter.search = p.get("q") || "";
    filter.status = $30ad5da16ca1f695$var$STATUSES.includes(p.get("status")) ? p.get("status") : "";
    const hasFilters = Boolean(search && search.replace(/^\?/, ""));
    /* Without a URL to restore, the supervisor's own region is the scope they are responsible for —
     the same default the old page seeded. */ if (!hasFilters) filter.county = (0, $3b579ca6158bc61b$export$6339e4f5afb1eeb0)(me) || "";
    const from = p.get("from");
    const to = p.get("to");
    const sort = p.get("sort");
    return {
        filter: filter,
        range: from && to ? (0, $cc63266e8518a62e$export$e9d4863bcce07ce9)([
            (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)(from),
            (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)(to)
        ], $30ad5da16ca1f695$var$MAX_RANGE_DAYS) : $30ad5da16ca1f695$var$defaultTaskRange(),
        chips: p.getAll("chip").filter((key)=>$30ad5da16ca1f695$var$CHIPS.some((chip)=>chip.key === key)),
        page: Math.max(1, Number(p.get("page")) || 1),
        size: $30ad5da16ca1f695$var$PAGE_SIZES.includes(Number(p.get("size"))) ? Number(p.get("size")) : $30ad5da16ca1f695$var$PAGE_SIZES[0],
        sort: sort && $30ad5da16ca1f695$var$ORDERING[sort.replace(/^-/, "")] ? {
            key: sort.replace(/^-/, ""),
            dir: sort[0] === "-" ? "descend" : "ascend"
        } : null
    };
}
/* The deadline cell's own reading: past its deadline, still active and not approved — the same
   question the `overdue` chip asks server-side (`end < now AND no approved answer`). */ const $30ad5da16ca1f695$var$isOverdue = (row)=>Boolean(row.end) && row.is_active !== false && row.status !== "approved" && (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)(row.end).isBefore((0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)());
const $30ad5da16ca1f695$export$771a55a10b0a40ae = ()=>{
    const history = (0, $6f5d68f762d5488a$export$3420e1dc2c4a518c)();
    const location = (0, $6f5d68f762d5488a$export$45d76561a5302f2b)();
    const me = (0, $b83e93e5ef3de8b0$export$2105062e25df4afe)((state)=>state.me);
    const lang = me?.language || "en";
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$601c8c0f45aeb0a0), key, lang);
    const td = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), key, lang);
    const tp = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b8441a9a81ffc5d6), key, lang);
    /* Read once. After mount this component owns the state and writes the URL, not the reverse —
     reading it back on every change would fight the user's own typing. */ const initial = (0, $cQmXV.useRef)($30ad5da16ca1f695$export$fade2611c23f9109(location.search, me)).current;
    const [filter, setFilter] = (0, $cQmXV.useState)(initial.filter);
    const [range, setRangeState] = (0, $cQmXV.useState)(initial.range);
    /* A cleared period returns to the default window instead of "all time": the cap exists so this
     list never asks for a year of tasks, and clearing to nothing would walk straight past it. */ const setRange = (next)=>setRangeState((0, $cc63266e8518a62e$export$e9d4863bcce07ce9)(next, $30ad5da16ca1f695$var$MAX_RANGE_DAYS) || $30ad5da16ca1f695$var$defaultTaskRange());
    const [chips, setChips] = (0, $cQmXV.useState)(initial.chips);
    const [page, setPage] = (0, $cQmXV.useState)(initial.page);
    const [size, setSize] = (0, $cQmXV.useState)(initial.size);
    const [sort, setSort] = (0, $cQmXV.useState)(initial.sort);
    /* What the user is typing, kept apart from `filter.search` so the request is debounced without
     the input lagging a keystroke behind the caret. */ const [term, setTerm] = (0, $cQmXV.useState)(initial.filter.search);
    /* The option objects the selects handed back, so a chosen value labels itself. */ const [chosen, setChosen] = (0, $cQmXV.useState)({
        county: null,
        network: null,
        template: null,
        merchandiser: null
    });
    const [rows, setRows] = (0, $cQmXV.useState)([]);
    /* Not a total. `GET tasks/` pages through `NoCountResultsSetPagination` now and answers
     `{next, previous, results}` — the pagination `COUNT(*)` was a second full sequential scan
     of `tasks_task`, matching the page query row for row, and nothing here displayed it. */ const [hasNext, setHasNext] = (0, $cQmXV.useState)(false);
    const [loading, setLoading] = (0, $cQmXV.useState)(true);
    const [failed, setFailed] = (0, $cQmXV.useState)(false);
    const [selected, setSelected] = (0, $cQmXV.useState)([]);
    const [busy, setBusy] = (0, $cQmXV.useState)(false);
    const [hidden, setHidden] = (0, $cQmXV.useState)([]);
    /* --------------------------------------------------------------- fetch */ const query = (0, $cQmXV.useMemo)(()=>$30ad5da16ca1f695$export$d7b58f10109feb02({
            filter: filter,
            range: range,
            chips: chips,
            page: page,
            size: size,
            sort: sort
        }), [
        filter,
        range,
        chips,
        page,
        size,
        sort
    ]);
    (0, $cQmXV.useEffect)(()=>{
        const controller = new AbortController();
        setLoading(true);
        (0, $c9936523dc38c641$export$86557ef9e0794d10)(`tasks/?${query}`, controller.signal).then((response)=>{
            if (!response) return;
            setRows(response.results || []);
            setHasNext(Boolean(response.next));
            setFailed(false);
            setLoading(false);
        }).catch((error)=>{
            if (error.name === "AbortError") return;
            setRows([]);
            setHasNext(false);
            setFailed(true);
            setLoading(false);
        });
        return ()=>controller.abort();
    }, [
        query
    ]);
    /* The URL trails the state; `replace` so filtering does not fill the history stack and Back
     still leaves the page rather than undoing one filter at a time. */ (0, $cQmXV.useEffect)(()=>{
        const search = $30ad5da16ca1f695$var$stateToSearch({
            filter: filter,
            range: range,
            chips: chips,
            page: page,
            size: size,
            sort: sort
        });
        if (search !== location.search.replace(/^\?/, "")) history.replace({
            search: search
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        filter,
        range,
        chips,
        page,
        size,
        sort
    ]);
    /* Only the free-text field is debounced; every other control applies on change. */ (0, $cQmXV.useEffect)(()=>{
        if (term === filter.search) return;
        const timer = setTimeout(()=>{
            setPage(1);
            setSelected([]);
            setFilter((prev)=>({
                    ...prev,
                    search: term
                }));
        }, (0, $91ea30cb49819b9a$export$8e5d48d2b3bed316));
        return ()=>clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        term
    ]);
    /* Any narrowing invalidates the page number: page 7 of the old result set is usually past the
     end of the new one, which would render an empty table over a non-empty result. */ const narrow = (fn)=>(...args)=>{
            setPage(1);
            setSelected([]);
            fn(...args);
        };
    const setSingle = narrow((key, option)=>{
        setChosen((prev)=>({
                ...prev,
                [key]: option
            }));
        setFilter((prev)=>({
                ...prev,
                [key]: option ? $30ad5da16ca1f695$var$idOf(option) : ""
            }));
    });
    const setArray = narrow((key, list)=>setFilter((prev)=>({
                ...prev,
                [key]: list
            })));
    const toggleChip = narrow((key)=>setChips((prev)=>prev.includes(key) ? prev.filter((k)=>k !== key) : [
                ...prev,
                key
            ]));
    const resetFilters = narrow(()=>{
        setFilter($30ad5da16ca1f695$var$blankFilter());
        setChosen({
            county: null,
            network: null,
            template: null,
            merchandiser: null
        });
        setRange($30ad5da16ca1f695$var$defaultTaskRange());
        setChips([]);
        setTerm("");
        setSort(null);
    });
    /* ---------------------------------------------------------------- chips */ /* Persisted: a point picked on page 7 has no name after Back without it (PICSELL-1615 #12). */ const { labels: labels, remember: remember, nameFor: nameFor } = (0, $a9e321bb60aaf998$export$243aa1fcbfd1886a)("task:labels");
    const clearChip = narrow((key, id)=>{
        if (key === "period") {
            setRange($30ad5da16ca1f695$var$defaultTaskRange());
            return;
        }
        if (key === "search") {
            setTerm("");
            setFilter((prev)=>({
                    ...prev,
                    search: ""
                }));
            return;
        }
        if (key === "status") {
            setFilter((prev)=>({
                    ...prev,
                    status: ""
                }));
            return;
        }
        if ($30ad5da16ca1f695$var$SINGLE_KEYS.includes(key)) {
            setChosen((prev)=>({
                    ...prev,
                    [key]: null
                }));
            setFilter((prev)=>({
                    ...prev,
                    [key]: ""
                }));
            return;
        }
        setFilter((prev)=>({
                ...prev,
                [key]: (prev[key] || []).filter((v)=>String($30ad5da16ca1f695$var$idOf(v)) !== String(id))
            }));
    });
    const activeChips = (0, $cQmXV.useMemo)(()=>{
        const out = [];
        if (range?.[0] && range?.[1]) {
            /* Short form, per spec/04 — `28 Jul → 11 Aug`. The year shows only when the range leaves the
         current one, which is also what keeps the chip on one line on a phone. */ const thisYear = new Date().getFullYear();
            const sameYear = range[0].year() === thisYear && range[1].year() === thisYear;
            const fmt = new Intl.DateTimeFormat((0, $7d0f78de0b68a104$export$bd7bed267fc278f2)(lang), {
                day: "numeric",
                month: "short",
                ...sameYear ? {} : {
                    year: "numeric"
                }
            });
            out.push({
                key: "period",
                label: t("col_deadline"),
                value: `${fmt.format(range[0].toDate())} \u{2192} ${fmt.format(range[1].toDate())}`
            });
        }
        if (filter.search) out.push({
            key: "search",
            label: tp("search"),
            value: filter.search
        });
        if (filter.status) out.push({
            key: "status",
            label: t("col_status"),
            value: t(`st_${filter.status}`)
        });
        $30ad5da16ca1f695$var$SINGLE_KEYS.forEach((key)=>{
            if (!filter[key]) return;
            /* `chosen[key]` is the option object the select handed back, so it names itself; falling back
         to the bare id sends `nameFor` to the resolution cache. */ out.push({
                key: key,
                label: td($30ad5da16ca1f695$var$CHIP_LABEL[key]),
                value: nameFor(key, chosen[key] ?? filter[key])
            });
        });
        $30ad5da16ca1f695$var$ARRAY_KEYS.forEach((key)=>{
            (filter[key] || []).forEach((v)=>out.push({
                    key: key,
                    id: $30ad5da16ca1f695$var$idOf(v),
                    label: td($30ad5da16ca1f695$var$CHIP_LABEL[key]),
                    value: nameFor(key, v)
                }));
        });
        return out;
    /* `labels` is a dependency: a chip that arrived as an id has to re-render once its name lands. */ // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        filter,
        chosen,
        labels,
        range,
        lang
    ]);
    /* --------------------------------------------------------- deactivate */ /* PATCH, never DELETE. `Task.delete()` sets `is_active = False` when the task has answers but
     **hard-deletes when it has none** — one control doing two irreversibly different things
     depending on state the user cannot see. PATCH means one verb with one meaning. */ const deactivate = (task)=>new Promise((resolve)=>{
            (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
                method: "PATCH",
                url: `tasks/${task.id}/`,
                post: {
                    is_active: false
                }
            }, (response)=>resolve(Boolean(response)));
        });
    /* Rows are patched in place rather than refetched, so the table does not jump under the cursor.
     A row that no longer matches the active filters stays until the next fetch: its glyph has
     already changed, so it is showing the result of the action rather than a stale state. */ const applyLocally = (ids)=>{
        setRows((prev)=>prev.map((row)=>ids.includes(row.id) ? {
                    ...row,
                    is_active: false
                } : row));
    };
    const runDeactivate = async (targets)=>{
        if (!targets.length) return;
        setBusy(true);
        const done = [];
        for(let i = 0; i < targets.length; i += $30ad5da16ca1f695$var$BULK_CHUNK){
            const batch = targets.slice(i, i + $30ad5da16ca1f695$var$BULK_CHUNK);
            const results = await Promise.all(batch.map(deactivate));
            batch.forEach((task, index)=>results[index] && done.push(task.id));
        }
        setBusy(false);
        if (done.length) {
            applyLocally(done);
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success((0, $3b579ca6158bc61b$export$9563e054e6f787fb)(t("deactivated_msg"), {
                n: done.length
            }), {
                position: "top-right"
            });
        }
        if (done.length < targets.length) (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).warning((0, $3b579ca6158bc61b$export$9563e054e6f787fb)(t("change_failed_msg"), {
            n: targets.length - done.length
        }), {
            position: "top-right"
        });
        setSelected([]);
    };
    /* Confirm states WHAT and HOW MANY, and the button carries the verb, never "OK". `Modal.confirm`
     is a static call: it renders outside the tree and does not inherit AppShell's
     `ConfigProvider locale`, so both button labels are passed explicitly. */ const confirmDeactivate = (targets)=>{
        if (!targets.length) return;
        (0, $05a90c67d3627fd9$export$2e2bcd8739ae039).confirm({
            title: (0, $3b579ca6158bc61b$export$9563e054e6f787fb)(t("confirm_deactivate"), {
                n: targets.length
            }),
            content: t("confirm_deactivate_desc"),
            okText: t("deactivate"),
            okButtonProps: {
                danger: true
            },
            cancelText: t("cancel_btn"),
            onOk: ()=>runDeactivate(targets)
        });
    };
    /* Walk into the record carrying this row's position in the FILTERED list and the filters
     themselves, so the detail page can come back to exactly this view. */ const openTask = (task)=>{
        const search = $30ad5da16ca1f695$var$stateToSearch({
            filter: filter,
            range: range,
            chips: chips,
            page: page,
            size: size,
            sort: sort
        });
        history.push(`/task/${task.id}${search ? `?${search}` : ""}`);
    };
    /* ------------------------------------------------------------- columns */ const dateFmt = (0, $cQmXV.useMemo)(()=>new Intl.DateTimeFormat((0, $7d0f78de0b68a104$export$bd7bed267fc278f2)(lang), {
            day: "2-digit",
            month: "short",
            year: "numeric"
        }), [
        lang
    ]);
    const columns = (0, $cQmXV.useMemo)(()=>{
        const all = [
            {
                key: "status",
                title: t("col_status"),
                width: 150,
                fixed: "left",
                /* A word, not only a glyph: supervisors had to open each task to learn its verdict. The
           deactivated glyph stays beside it — a different fact about the row. */ render: (value, row)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                        align: "center",
                        gap: 4,
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e36e070b6f6386b6$export$5452e567de639f2a), {
                                status: $30ad5da16ca1f695$var$TAG_STATUS[row.status] || "awaiting",
                                lang: lang
                            }),
                            row.is_active === false ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $66539b2560a58e4e$export$b131c49b26d3f427), {
                                Icon: $30ad5da16ca1f695$var$INACTIVE_ICON.Icon,
                                tone: $30ad5da16ca1f695$var$INACTIVE_ICON.tone,
                                label: t($30ad5da16ca1f695$var$INACTIVE_ICON.key)
                            }) : null
                        ]
                    })
            },
            {
                key: "task",
                title: t("col_task"),
                width: 280,
                fixed: "left",
                ellipsis: true,
                sorter: true,
                render: (value, row)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                        vertical: true,
                        className: "lp-main",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                strong: true,
                                ellipsis: {
                                    tooltip: row.title
                                },
                                children: row.title
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                type: "secondary",
                                className: "lp-main__sub",
                                ellipsis: {
                                    tooltip: row.description
                                },
                                children: row.description || "\u2014"
                            })
                        ]
                    })
            },
            {
                key: "type",
                title: t("col_type"),
                width: 160,
                ellipsis: true,
                sorter: true,
                render: (value, row)=>row.template?.name || /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "lp-dash",
                        children: "\u2014"
                    })
            },
            {
                key: "point",
                title: t("col_point"),
                width: 240,
                ellipsis: true,
                sorter: true,
                render: (value, row)=>{
                    if (!row.point) return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "lp-dash",
                        children: "\u2014"
                    });
                    const meta = [
                        row.point.locality?.name,
                        row.point.network?.name
                    ].filter(Boolean).join(" \xb7 ");
                    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                        vertical: true,
                        className: "lp-main",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                ellipsis: {
                                    tooltip: row.point.name
                                },
                                children: row.point.name
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                type: "secondary",
                                className: "lp-main__sub",
                                ellipsis: {
                                    tooltip: meta
                                },
                                children: meta || "\u2014"
                            })
                        ]
                    });
                }
            },
            {
                key: "merchandiser",
                title: t("k_merchandiser"),
                width: 190,
                ellipsis: true,
                /* Derived from the point — a task carries no merchandiser of its own, which is also why a
           point with nobody responsible makes the task nobody's. */ render: (value, row)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $66539b2560a58e4e$export$8a3d0b92eb0904a5), {
                        user: row.point?.responsible_merchandiser,
                        strong: false
                    })
            },
            {
                key: "deadline",
                title: t("col_deadline"),
                width: 150,
                sorter: true,
                render: (value, row)=>{
                    if (!row.end) return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "lp-dash",
                        children: "\u2014"
                    });
                    const late = $30ad5da16ca1f695$var$isOverdue(row);
                    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                        vertical: true,
                        className: "lp-main",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                className: late ? "tk-late" : undefined,
                                children: dateFmt.format(new Date(row.end))
                            }),
                            late ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                type: "secondary",
                                className: "lp-main__sub tk-late",
                                children: t("chip_overdue")
                            }) : null
                        ]
                    });
                }
            },
            {
                key: "author",
                title: t("col_author"),
                width: 190,
                ellipsis: true,
                render: (value, row)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $66539b2560a58e4e$export$8a3d0b92eb0904a5), {
                        user: row.created_by,
                        strong: false
                    })
            },
            (0, $66539b2560a58e4e$export$b0493221521ca587)((value, row)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $66539b2560a58e4e$export$523acc1bb0ce2e43), {
                    label: t("row_actions"),
                    items: [
                        {
                            key: "open",
                            icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $357da3723e13ae38$export$2e2bcd8739ae039), {}),
                            label: t("open")
                        },
                        ...row.is_active === false ? [] : [
                            {
                                key: "off",
                                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $4d7cc9843b581604$export$2e2bcd8739ae039), {}),
                                label: t("deactivate"),
                                danger: true
                            }
                        ]
                    ],
                    onClick: (key)=>key === "open" ? openTask(row) : confirmDeactivate([
                            row
                        ])
                }))
        ];
        return all.filter((column)=>!hidden.includes(column.key));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        lang,
        hidden,
        rows,
        dateFmt
    ]);
    const scrollY = (0, $66539b2560a58e4e$export$f44b992e82788e9)();
    /* "Nothing here yet" and "nothing matches these filters" are different states needing different
     copy and different actions (spec/03). Anything narrowing means the latter. */ const isFiltered = Boolean(filter.search || chips.length) || $30ad5da16ca1f695$var$SINGLE_KEYS.some((key)=>filter[key]) || $30ad5da16ca1f695$var$ARRAY_KEYS.some((key)=>(filter[key] || []).length);
    const selectable = rows.filter((row)=>selected.includes(row.id) && row.is_active !== false);
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
        vertical: true,
        gap: "middle",
        className: "shell-content lp tk",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                className: "lp-head",
                justify: "space-between",
                align: "flex-end",
                gap: "middle",
                wrap: true,
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                        vertical: true,
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Title, {
                                level: 1,
                                className: "lp-title",
                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$72266474e9355649), "tasks", lang)
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Paragraph, {
                                type: "secondary",
                                className: "lp-sub",
                                children: t("page_sub")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $30ddd2d6a9f4b7d6$export$2e2bcd8739ae039), {
                        trigger: [
                            "click"
                        ],
                        menu: {
                            items: [
                                {
                                    key: "point",
                                    icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $a1f80a723f71d713$export$2e2bcd8739ae039), {}),
                                    label: t("new_for_point")
                                },
                                {
                                    key: "network",
                                    icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $f48fe90789d2a71a$export$2e2bcd8739ae039), {}),
                                    label: t("new_for_network")
                                },
                                {
                                    key: "point_group",
                                    icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $68e85fc2f9283018$export$2e2bcd8739ae039), {}),
                                    label: t("new_for_group")
                                }
                            ],
                            onClick: ({ key: key })=>history.push(`/task/new/${key}`)
                        },
                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                            type: "primary",
                            icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $fa25166ced813feb$export$2e2bcd8739ae039), {}),
                            children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $eb1133c43d00490b$export$2e2bcd8739ae039), {
                                size: 4,
                                children: [
                                    t("new_task"),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e7119b602540b2c5$export$2e2bcd8739ae039), {})
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b4fda840b736e640$export$2e2bcd8739ae039), {
                className: "lp-filters",
                variant: "outlined",
                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039), {
                    layout: "vertical",
                    component: false,
                    colon: false,
                    children: [
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $db6c3adada49524e$export$2e2bcd8739ae039), {
                            gutter: [
                                12,
                                12
                            ],
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $cde227eb983ae1d2$export$2e2bcd8739ae039), {
                                    ...$30ad5da16ca1f695$var$PERIOD_COL,
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                        label: t("col_deadline"),
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $cc63266e8518a62e$export$2e2bcd8739ae039), {
                                            value: range,
                                            onChange: narrow(setRange),
                                            maxDays: $30ad5da16ca1f695$var$MAX_RANGE_DAYS,
                                            clearTo: $30ad5da16ca1f695$var$defaultTaskRange,
                                            allowFuture: true
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $cde227eb983ae1d2$export$2e2bcd8739ae039), {
                                    ...$30ad5da16ca1f695$var$FIELD_COL,
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                        label: td("region"),
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b6929c6a194abc34$export$2e2bcd8739ae039), {
                                            entity: "county",
                                            value: filter.county,
                                            seed: chosen.county || (me?.county && typeof me.county === "object" ? me.county : null),
                                            prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $68eebcef827bb540$export$2e2bcd8739ae039), {}),
                                            onChange: (option)=>setSingle("county", option),
                                            onResolve: remember("county")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $cde227eb983ae1d2$export$2e2bcd8739ae039), {
                                    ...$30ad5da16ca1f695$var$FIELD_COL,
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                        label: td("network"),
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b6929c6a194abc34$export$2e2bcd8739ae039), {
                                            entity: "network",
                                            value: filter.network,
                                            seed: chosen.network,
                                            prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $f48fe90789d2a71a$export$2e2bcd8739ae039), {}),
                                            onChange: (option)=>setSingle("network", option),
                                            onResolve: remember("network")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $cde227eb983ae1d2$export$2e2bcd8739ae039), {
                                    ...$30ad5da16ca1f695$var$FIELD_COL,
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                        label: t("col_type"),
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b6929c6a194abc34$export$2e2bcd8739ae039), {
                                            entity: "template",
                                            value: filter.template,
                                            seed: chosen.template,
                                            prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $170c031fa50279f7$export$2e2bcd8739ae039), {}),
                                            onChange: (option)=>setSingle("template", option),
                                            onResolve: remember("template")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $cde227eb983ae1d2$export$2e2bcd8739ae039), {
                                    ...$30ad5da16ca1f695$var$FIELD_COL,
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                        label: t("k_merchandiser"),
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b6929c6a194abc34$export$2e2bcd8739ae039), {
                                            entity: "merchandisers",
                                            value: filter.merchandiser,
                                            seed: chosen.merchandiser,
                                            prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e85f2e3cc711f245$export$2e2bcd8739ae039), {}),
                                            onChange: (option)=>setSingle("merchandiser", option),
                                            onResolve: remember("merchandiser")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $cde227eb983ae1d2$export$2e2bcd8739ae039), {
                                    ...$30ad5da16ca1f695$var$FIELD_COL,
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                        label: t("col_author"),
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b6929c6a194abc34$export$2e2bcd8739ae039), {
                                            entity: "created_by",
                                            isMulti: true,
                                            value: filter.author,
                                            prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $1141984d2e96fc67$export$2e2bcd8739ae039), {}),
                                            onChange: (list)=>setArray("author", list),
                                            onResolve: remember("author")
                                        })
                                    })
                                }),
                                me?.role === "supervisor_manager" ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $cde227eb983ae1d2$export$2e2bcd8739ae039), {
                                    ...$30ad5da16ca1f695$var$FIELD_COL,
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                        label: td("supervisor"),
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b6929c6a194abc34$export$2e2bcd8739ae039), {
                                            entity: "created_by",
                                            isMulti: true,
                                            value: filter.supervisor,
                                            prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $d5baeea001a6abe5$export$2e2bcd8739ae039), {}),
                                            onChange: (list)=>setArray("supervisor", list),
                                            onResolve: remember("supervisor")
                                        })
                                    })
                                }) : null,
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $cde227eb983ae1d2$export$2e2bcd8739ae039), {
                                    ...$30ad5da16ca1f695$var$FIELD_COL,
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                        label: td("points"),
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b6929c6a194abc34$export$2e2bcd8739ae039), {
                                            entity: "points",
                                            isMulti: true,
                                            value: filter.points,
                                            county: filter.county,
                                            moduleFilter: filter.network,
                                            prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $a1f80a723f71d713$export$2e2bcd8739ae039), {}),
                                            /* Only names the cache already knows: seeding an id AS its label would satisfy
                     the select and stop it ever fetching the real name. */ seed: (filter.points || []).flatMap((p)=>{
                                                const name = labels[`points:${$30ad5da16ca1f695$var$idOf(p)}`];
                                                return name ? [
                                                    {
                                                        id: $30ad5da16ca1f695$var$idOf(p),
                                                        label: name
                                                    }
                                                ] : [];
                                            }),
                                            onChange: (list)=>setArray("points", list),
                                            onResolve: remember("points")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $cde227eb983ae1d2$export$2e2bcd8739ae039), {
                                    ...$30ad5da16ca1f695$var$FIELD_COL,
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                        label: tp("search"),
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0883e7f8083c01b0$export$2e2bcd8739ae039), {
                                            allowClear: true,
                                            prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $20a259d46bffcb08$export$2e2bcd8739ae039), {}),
                                            placeholder: t("search_ph"),
                                            value: term,
                                            onChange: (event)=>setTerm(event.target.value)
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $a9e321bb60aaf998$export$2e2bcd8739ae039), {
                            className: "lp-chips",
                            items: activeChips,
                            closeLabel: tp("a_remove_filter"),
                            onClose: clearChip
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                            className: "lp-quality",
                            align: "center",
                            gap: "small",
                            wrap: true,
                            children: $30ad5da16ca1f695$var$CHIPS.map((chip)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $602120e6d17ff12a$export$2e2bcd8739ae039).CheckableTag, {
                                    checked: chips.includes(chip.key),
                                    onChange: ()=>toggleChip(chip.key),
                                    title: t(chip.hint),
                                    children: t(chip.label)
                                }, chip.key))
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                            className: "lp-filters__foot",
                            align: "center",
                            gap: "small",
                            wrap: true,
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $ac40310dc424be23$export$2e2bcd8739ae039), {
                                    value: filter.status || "all",
                                    onChange: narrow((value)=>setFilter((prev)=>({
                                                ...prev,
                                                status: value === "all" ? "" : value
                                            }))),
                                    options: [
                                        "all",
                                        ...$30ad5da16ca1f695$var$STATUSES
                                    ].map((value)=>({
                                            value: value,
                                            label: t(value === "all" ? "st_all" : `st_${value}`)
                                        }))
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                    className: "lp-spacer"
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                    size: "small",
                                    onClick: resetFilters,
                                    children: td("filter_reset")
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $b4fda840b736e640$export$2e2bcd8739ae039), {
                className: "lp-table",
                variant: "outlined",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                        className: "lp-table__bar",
                        align: "center",
                        gap: "small",
                        wrap: true,
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                strong: true,
                                className: "lp-table__title",
                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$72266474e9355649), "tasks", lang)
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                className: "lp-spacer"
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $30ddd2d6a9f4b7d6$export$2e2bcd8739ae039), {
                                trigger: [
                                    "click"
                                ],
                                /* A plain checkbox list, not a `menu` — a menu item swallows the checkbox's own click
               and closes the panel after every single toggle. */ popupRender: ()=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b4fda840b736e640$export$2e2bcd8739ae039), {
                                        className: "tk-colcfg",
                                        variant: "outlined",
                                        size: "small",
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $7a650444b7c2c328$export$2e2bcd8739ae039).Group, {
                                            value: $30ad5da16ca1f695$var$TOGGLEABLE.filter((key)=>!hidden.includes(key)),
                                            onChange: (visible)=>setHidden($30ad5da16ca1f695$var$TOGGLEABLE.filter((key)=>!visible.includes(key))),
                                            children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                                vertical: true,
                                                gap: 4,
                                                children: $30ad5da16ca1f695$var$TOGGLEABLE.map((key)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $7a650444b7c2c328$export$2e2bcd8739ae039), {
                                                        value: key,
                                                        children: t($30ad5da16ca1f695$var$COLUMN_LABEL[key])
                                                    }, key))
                                            })
                                        })
                                    }),
                                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                    size: "small",
                                    icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $a8085ca9c62f778e$export$2e2bcd8739ae039), {}),
                                    children: t("columns")
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $dff4d45d201c6dfe$export$2e2bcd8739ae039), {
                        className: "lp-table__grid",
                        rowKey: "id",
                        size: "middle",
                        columns: columns,
                        dataSource: rows,
                        loading: loading,
                        scroll: {
                            x: 1626,
                            y: scrollY
                        },
                        rowClassName: (row)=>{
                            const classes = [
                                "lp-row"
                            ];
                            if (selected.includes(row.id)) classes.push("lp-row--on");
                            /* An already-deactivated row recedes rather than disappearing — it is still a record. */ if (row.is_active === false) classes.push("lp-row--off");
                            return classes.join(" ");
                        },
                        rowSelection: {
                            fixed: true,
                            selectedRowKeys: selected,
                            onChange: (keys)=>setSelected(keys),
                            /* A checkbox here means exactly one thing: this row can be deactivated. */ getCheckboxProps: (row)=>({
                                    disabled: row.is_active === false
                                })
                        },
                        onRow: (row)=>({
                                onClick: (event)=>{
                                    /* The selection cell and the row menu own their clicks; everything else walks into
                 the task. */ if (event.target.closest(".ant-table-selection-column, .ant-dropdown, .ant-btn")) return;
                                    openTask(row);
                                }
                            }),
                        /* Paging is the footer below, so the only thing left for the table's own onChange is the
             sorter — with `pagination={false}` its first argument carries nothing. */ onChange: (pagination, filters, sorter)=>{
                            const next = sorter?.order && $30ad5da16ca1f695$var$ORDERING[sorter.columnKey] ? {
                                key: sorter.columnKey,
                                dir: sorter.order
                            } : null;
                            if (JSON.stringify(next) === JSON.stringify(sort)) return;
                            setSort(next);
                            setPage(1);
                        },
                        pagination: false,
                        locale: {
                            emptyText: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $99350450b877904c$export$2e2bcd8739ae039), {
                                image: (0, $99350450b877904c$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE,
                                description: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                    vertical: true,
                                    gap: 8,
                                    align: "center",
                                    children: [
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                            strong: true,
                                            children: t(failed ? "empty_title" : isFiltered ? "empty_title" : "empty_none_title")
                                        }),
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                            type: "secondary",
                                            children: t(isFiltered ? "empty_desc" : "empty_none_desc")
                                        }),
                                        isFiltered ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                            size: "small",
                                            onClick: resetFilters,
                                            children: td("filter_reset")
                                        }) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                            size: "small",
                                            type: "primary",
                                            icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $fa25166ced813feb$export$2e2bcd8739ae039), {}),
                                            onClick: ()=>history.push("/task/new/point"),
                                            children: t("new_task")
                                        })
                                    ]
                                })
                            })
                        }
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $66539b2560a58e4e$export$616d7706d7176288), {
                        id: "tk",
                        page: page,
                        size: size,
                        hasNext: hasNext,
                        sizes: $30ad5da16ca1f695$var$PAGE_SIZES,
                        labels: {
                            perPage: t("rows_per_page"),
                            page: t("page_n"),
                            prev: t("page_prev"),
                            next: t("page_next")
                        },
                        onPage: (next)=>{
                            setPage(next);
                            setSelected([]);
                        },
                        onSize: (next)=>{
                            setSize(next);
                            setPage(1);
                            setSelected([]);
                        }
                    })
                ]
            }),
            selected.length > 0 && /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                className: "lp-bulkbar",
                align: "center",
                gap: "middle",
                wrap: true,
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                        className: "lp-bulkbar__n",
                        children: (0, $3b579ca6158bc61b$export$9563e054e6f787fb)(tp("w_selected"), {
                            n: selected.length
                        })
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                        className: "lp-bulkbar__hint",
                        children: t("select_page_hint")
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $eb1133c43d00490b$export$2e2bcd8739ae039), {
                        className: "lp-bulkbar__acts",
                        size: 8,
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                size: "small",
                                onClick: ()=>setSelected([]),
                                children: tp("clear_selection")
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                size: "small",
                                danger: true,
                                type: "primary",
                                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $4d7cc9843b581604$export$2e2bcd8739ae039), {}),
                                loading: busy,
                                onClick: ()=>confirmDeactivate(selectable),
                                children: t("deactivate")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $30ad5da16ca1f695$export$2e2bcd8739ae039 = $30ad5da16ca1f695$export$771a55a10b0a40ae;


/* /task/:id and /task/new/:type — the task detail page.
   No mockup exists; `docs/design/point-detail.html` is the closest reference and
   `docs/design/spec/` is normative.

   Shape (spec/03 archetype B): a non-sticky page head, a `minmax(0,720px) 320px` grid of form +
   reference rail, and a bottom save bar that exists only while the form is dirty. The frame is the
   shared `dp-*` chrome in `component/detail-page.scss`.

   No sticky command bar, deliberately — the same call `supervisor/Page.js` made. Archetype B's
   exists so a long form's Save stays in reach; Save is already pinned to the bottom here, so the
   measured-offset apparatus (which has shipped broken four times) buys nothing.

   Things that were broken in the page this replaces, so they do not come back:
     - `PATCH tasks/:id/` returned **405**: `TaskViewSet` had no `UpdateModelMixin`. Saving an
       existing task never worked. picsell-api gained it, plus a narrow `TaskWriteSerializer`.
     - The mode was read from `location.hash`, so `/task/:id/edit` and `/task/:id/view` were dead
       aliases. It rides in the query string as `?edit=1` now, per spec/03.
     - `me` was captured at MODULE LOAD (`getStore().getState()` beside the imports), so a
       language change did not re-render. It is read at render time now.
     - Saving navigated with `window.location.replace` + `document.location.reload()`.
     - `removeTask` read `item.created_by.id` unguarded and threw on a task with no author.
     - Deleting: `DELETE tasks/:id/` hard-deletes a task with no answers and only soft-deletes one
       with answers — one control, two irreversibly different outcomes depending on hidden state.
       Deactivating is `PATCH { is_active: false }`, one verb with one meaning.

   ⚠ Behaviour change needing product sign-off: rejecting an answer no longer creates a duplicate
   follow-up task carrying the rejected photo with the deadline pushed out seven days. It records
   the verdict WITH A REASON (which the old flow never did — it posted `comment: ""`), and the
   deadline is editable on this same page, so re-issuing is an edit rather than a second record.
   `photo-review/RejectTaskModal.js` still does create a corrective task from a rejected photo;
   that flow is unchanged. */ 

var $cQmXV = parcelRequire("cQmXV");














/* The answers a task collected, as a table, and the approve/reject workflow over them.
 *
 * MOUNTED ONLY WHILE OPEN, and that is not negotiable (spec/03#mount-one-section-at-a-time). A task
 * can hold dozens of answers, each with several photos, so rendering them alongside the form would
 * put a request and an unbounded image list on every page open. `Page.js` fetches on first open and
 * caches; switching away unmounts this — not `display: none`, actually unmounted, which is what
 * `document.querySelectorAll(".tk-answers").length` asserts.
 *
 * Built from the SHARED table parts so it reads as the same product as every other table in the
 * app: `PersonCell` / `actionsColumn` / `RowActions` / `dash` from `component/table-cells.js`, the
 * `lp-table__grid` skin from `component/list-page.scss` (header type, body type, hover) and its
 * `lp-main` / `lp-main__sub` / `lp-num` cell classes — all imported once from `src/index.js`.
 *
 * ⚠ `visit/sections.js`'s `SectionTable` is deliberately NOT reused: it is a local function styled
 * from `vd-table` in `visit-detail.scss`, so importing it would mean importing another page's whole
 * stylesheet to get a border and a font size. The verdict logic IS shared from `visit/parts.js`
 * (`postApproval`) — that is CSS-independent, unlike the pill whose shape
 * comes from `.status-tag` in `theme/antd.scss`, which is global.
 *
 * ⚠ Row fields are read through `util/answer-fields.js`, NOT re-derived here. This file had its own
 * `photosOf` reading `photo.photo_url` off what `AnswerListSerializer` flattens to plain URL
 * STRINGS, and its own `row.visit?.user` for the merchandiser, which that serializer lifts to the
 * top level — so a four-photo answer showed "—" and "Answered by" was always empty. It was written
 * against `AnswerSerializer` and never followed the endpoint's switch to the list one.
 */ 

var $cQmXV = parcelRequire("cQmXV");









function $31c1786c7a4b0517$export$2e2bcd8739ae039({ task: task, rows: rows, lang: lang, dateFmt: dateFmt, onModerated: onModerated }) {
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$9b31c804fa72c7c), key, lang);
    const [busy, setBusy] = (0, $cQmXV.useState)(null);
    const [rejecting, setRejecting] = (0, $cQmXV.useState)(null);
    /* Approve only. Rejecting goes through `RejectTaskModal`, which posts its own `approvals/` row
     after creating the corrective task — the ordering that keeps a rejection from ever existing
     with nothing attached to it. */ const approve = (answer)=>{
        setBusy(answer.id);
        (0, $e36e070b6f6386b6$export$a0b6e408d0d7f6e8)({
            objectId: answer.id,
            objectType: "answer",
            isApproved: true,
            comment: ""
        }, (ok)=>{
            setBusy(null);
            if (!ok) {
                (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).error(t("load_error"), {
                    position: "top-right"
                });
                return;
            }
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success(t("approved_msg"), {
                position: "top-right"
            });
            /* Only this section and the task's own status refetch — anything that repaints the whole page
         loses the reviewer's place. */ onModerated();
        });
    };
    const columns = (0, $cQmXV.useMemo)(()=>[
            /* Written out rather than built from `statusColumn()`: that helper is shaped for a 44px
         icon-only glyph and this column wants a labelled pill — a reviewer is deciding about the
         word, and there is room for it inside one task's answers. Overriding four of its six
         properties to claim reuse would be worse than not using it. The key and `fixed: "left"`
         match it so the column sits where every other table's status sits. */ {
                key: "status",
                title: t("col_status"),
                width: 150,
                render: (value, row)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e36e070b6f6386b6$export$5452e567de639f2a), {
                        status: (0, $e873a05126b50f33$export$6e020ab67105656f)(row),
                        lang: lang
                    })
            },
            {
                key: "photos",
                title: t("k_photos"),
                width: 90,
                render: (value, row)=>{
                    const photos = (0, $e873a05126b50f33$export$57b71c8db173e2e4)(row);
                    if (!photos.length) return 0, $66539b2560a58e4e$export$eb03490a10c3abc9;
                    /* One thumbnail opens the whole set — antd's preview is the viewer, which is also what
             replaced `react-image-lightbox`, whose prev and next both stepped the same way. */ return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $7012c54fc4de0c33$export$2e2bcd8739ae039).PreviewGroup, {
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $7012c54fc4de0c33$export$2e2bcd8739ae039), {
                                src: photos[0],
                                width: 44,
                                height: 44,
                                className: "tk-thumb",
                                alt: ""
                            }),
                            photos.slice(1).map((url)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $7012c54fc4de0c33$export$2e2bcd8739ae039), {
                                    src: url,
                                    style: {
                                        display: "none"
                                    },
                                    alt: ""
                                }, url)),
                            photos.length > 1 ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                className: "tk-thumb__n lp-num",
                                children: photos.length
                            }) : null
                        ]
                    });
                }
            },
            /* Comment and tags are two columns, not one stacked cell — the same split `/photo-review`
         shows, so a reviewer comparing the two screens reads the same shape twice. */ {
                key: "answer",
                title: t("ans_comment"),
                ellipsis: true,
                render: (value, row)=>row.answer ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                        ellipsis: {
                            tooltip: row.answer
                        },
                        children: row.answer
                    }) : (0, $66539b2560a58e4e$export$eb03490a10c3abc9)
            },
            {
                key: "tags",
                title: t("cmp_tags"),
                width: 200,
                render: (value, row)=>{
                    const tags = row.selected_tags || [];
                    if (!tags.length) return 0, $66539b2560a58e4e$export$eb03490a10c3abc9;
                    /* `Flex`, not `Space`: a Space item wraps each tag in a box that never shrinks, so
             `max-width` on the tag had nothing to measure against. */ return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                        gap: 4,
                        wrap: true,
                        children: tags.map((tag, index)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $602120e6d17ff12a$export$2e2bcd8739ae039), {
                                className: "tk-tag--quiet",
                                title: tag,
                                children: tag
                            }, `${tag}-${index}`))
                    });
                }
            },
            {
                key: "boolean",
                title: t("cmp_boolean"),
                width: 90,
                /* A yes/no answer is a word, never a colour alone. */ render: (value, row)=>row.boolean_answer === null || row.boolean_answer === undefined ? (0, $66539b2560a58e4e$export$eb03490a10c3abc9) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                        strong: true,
                        children: t(row.boolean_answer ? "ans_yes" : "ans_no")
                    })
            },
            {
                key: "by",
                title: t("ans_by"),
                width: 180,
                ellipsis: true,
                render: (value, row)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $66539b2560a58e4e$export$8a3d0b92eb0904a5), {
                        user: (0, $e873a05126b50f33$export$2232f994bf45777c)(row),
                        strong: false
                    })
            },
            {
                key: "created",
                title: t("ans_date"),
                width: 170,
                render: (value, row)=>row.created ? dateFmt.format(new Date(row.created)) : (0, $66539b2560a58e4e$export$eb03490a10c3abc9)
            },
            /* The verdict is the reason this table exists, so it is NOT behind a `⋮`: the two buttons are
         the row's payload, not an incidental row action. (Every other table in the app keeps the
         menu — there the action is incidental to reading the row.)
         Offered only while the row is still pending — `is_supervised` says which is which again,
         and the status column states what was already decided. A pre-deploy payload without the
         field reads as pending, so nothing is hidden on rows we know nothing about.
         Plain antd buttons: the green `.vd-btn--ok` lives in `visit-detail.scss`, which is not
         globally imported, so using it here would drag another page's stylesheet in. */ {
                ...(0, $66539b2560a58e4e$export$b0493221521ca587)((value, row)=>(0, $e873a05126b50f33$export$6e020ab67105656f)(row) === "pending" ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $eb1133c43d00490b$export$2e2bcd8739ae039), {
                        size: 4,
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                size: "small",
                                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $45839ed7c4a7faa2$export$2e2bcd8739ae039), {}),
                                disabled: busy !== null,
                                onClick: ()=>approve(row),
                                children: t("approve")
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                size: "small",
                                danger: true,
                                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $bdfb1f797481a352$export$2e2bcd8739ae039), {}),
                                disabled: busy !== null,
                                onClick: ()=>setRejecting(row),
                                children: t("reject")
                            })
                        ]
                    }) : null),
                width: 210
            }
        ], // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        lang,
        dateFmt,
        busy
    ]);
    /* `undefined` is "not fetched yet", `null` is "the fetch failed" — different states needing
     different UI (spec/03). An empty array is a real, successful, empty answer list. */ if (rows === undefined) return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e855c7114b2916ed$export$2e2bcd8739ae039), {
        active: true,
        paragraph: {
            rows: 4
        }
    });
    if (rows === null) return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $dc33dcdb2d24fbd9$export$2e2bcd8739ae039), {
        type: "error",
        showIcon: true,
        message: t("load_error"),
        action: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
            size: "small",
            onClick: ()=>onModerated(),
            children: t("retry")
        })
    });
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
        className: "tk-answers",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $dff4d45d201c6dfe$export$2e2bcd8739ae039), {
                className: "lp-table__grid tk-anstable",
                rowKey: "id",
                size: "small",
                columns: columns,
                dataSource: rows,
                pagination: false,
                scroll: {
                    x: 1390
                },
                loading: busy !== null,
                locale: {
                    emptyText: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $99350450b877904c$export$2e2bcd8739ae039), {
                        image: (0, $99350450b877904c$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE,
                        description: t("ans_empty")
                    })
                }
            }),
            rejecting ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $9525ffc2d869d787$export$2e2bcd8739ae039), {
                target: {
                    objectId: rejecting.id,
                    objectType: "answer"
                },
                photo: (0, $e873a05126b50f33$export$57b71c8db173e2e4)(rejecting)[0] || null,
                point: task?.point || null,
                visitId: rejecting.visit_id,
                lang: lang,
                onCancel: ()=>setRejecting(null),
                onDone: ()=>{
                    setRejecting(null);
                    onModerated();
                }
            }) : null
        ]
    });
}


/* The task form — four sections: what to do, where, when, and the answer form.
 *
 * A field renderer here is the CONTROL ONLY; `<Form.Item>` owns the label, the required marker and
 * the error, exactly as `points/ResourceForm.js` does it. `<Form component={false}>` because the
 * item lives in `Page.js`'s state, not antd's field store — there is nothing to submit.
 *
 * Two things this form deliberately does NOT let you edit, both because the API has no such column
 * and the old form's versions were discarded on every save:
 *
 *   - **priority** and **components** belong to the TEMPLATE (`source="template.priority"` /
 *     `"template.components"` on the read serializer). `Task` has neither. The old page offered
 *     priority as an editable select and posted it; DRF dropped it silently. They are shown here as
 *     read-only facts, which is also what makes the template select meaningful — the template is
 *     *what the merchandiser will be asked for*.
 *   - **the target** (`point` / `network` / `point_group`) after creation. `Task.point` is a CASCADE
 *     FK, so re-pointing a task that already has answers would leave them attached to a different
 *     point.
 */ 
parcelRequire("cQmXV");







/** `Template.Components` — what the merchandiser is asked to submit. */ const $5674c01508872783$var$COMPONENT_LABEL = {
    photo: "cmp_photo",
    text: "cmp_text",
    boolean: "cmp_boolean",
    numeric: "cmp_numeric",
    tags: "cmp_tags"
};
const $5674c01508872783$export$d1ff3caf57547dc5 = [
    "point",
    "network",
    "point_group"
];
function $5674c01508872783$var$Section({ title: title, desc: desc, children: children }) {
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("section", {
        className: "dp-card",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                className: "dp-sec-head",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("h2", {
                        className: "dp-sec-title",
                        children: title
                    }),
                    desc ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("p", {
                        className: "dp-sec-desc",
                        children: desc
                    }) : null
                ]
            }),
            children
        ]
    });
}
function $5674c01508872783$export$2e2bcd8739ae039({ item: item, target: target, isNew: isNew, readOnly: readOnly, errors: errors = {}, lang: lang, onChange: onChange, onImage: onImage, onImageRemove: onImageRemove }) {
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$9b31c804fa72c7c), key, lang);
    /* Formatted via Intl with the active locale, never hand-built (spec/04). */ const dateText = (value)=>new Intl.DateTimeFormat((0, $7d0f78de0b68a104$export$bd7bed267fc278f2)(lang), {
            day: "2-digit",
            month: "short",
            year: "numeric"
        }).format(new Date(value));
    const err = (name)=>errors[name] ? {
            validateStatus: "error",
            help: errors[name]
        } : {};
    /**
   * One field.
   *
   * ⚠ In VIEW mode this renders the VALUE AS TEXT, not the control with `disabled`. antd draws a
   * disabled input's text at `rgba(23,28,32,.25)` on a `.04` fill — measured at roughly 1.9:1,
   * against a 4.5:1 floor — so the first version of this page was literally unreadable in the state
   * it opens in. Nothing is gained by showing an inert input either: view mode should read like a
   * record, which is what spec/03's archetype B asks for and what `points/ResourceView.js` does for
   * the descriptor resources.
   *
   * `view` is the text to show; pass `view: null` for a field that renders its own display (the
   * image), and it falls through to `node`.
   */ const field = (name, node, extra = {})=>{
        const readable = readOnly && extra.view !== undefined;
        return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
            "data-field": name,
            children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                label: t(extra.label || `f_${name}`),
                required: !readOnly && extra.required,
                extra: extra.hint,
                ...readOnly ? {} : err(name),
                children: readable ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                    className: "tk-value",
                    children: extra.view || /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "tk-value--empty",
                        children: "\u2014"
                    })
                }) : node
            })
        });
    };
    const image = item.images?.[0];
    const imageUrl = image?.image || image?.preview || null;
    return(/* Large controls come from one scoped ConfigProvider, not from a `size` on each renderer —
       same as ResourceForm, so the two detail pages cannot drift apart on control height. */ /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5764e43cf38ca965$export$2e2bcd8739ae039), {
        componentSize: "large",
        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039), {
            layout: "vertical",
            component: false,
            colon: false,
            requiredMark: true,
            children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                vertical: true,
                gap: "middle",
                className: "dp-form tk-form",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($5674c01508872783$var$Section, {
                        title: t("sec_what"),
                        desc: t("sec_what_desc"),
                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                            vertical: true,
                            gap: "middle",
                            children: [
                                field("title", /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0883e7f8083c01b0$export$2e2bcd8739ae039), {
                                    maxLength: 256,
                                    disabled: readOnly,
                                    value: item.title || "",
                                    onChange: (event)=>onChange("title", event.target.value),
                                    placeholder: t("f_title")
                                }), {
                                    required: true,
                                    view: item.title
                                }),
                                field("description", /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0883e7f8083c01b0$export$2e2bcd8739ae039).TextArea, {
                                    rows: 3,
                                    maxLength: 2000,
                                    disabled: readOnly,
                                    value: item.description || "",
                                    onChange: (event)=>onChange("description", event.target.value)
                                }), {
                                    view: item.description
                                }),
                                field("image", /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                    vertical: true,
                                    gap: "small",
                                    children: [
                                        imageUrl ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("img", {
                                            className: "tk-shot",
                                            src: imageUrl,
                                            alt: ""
                                        }) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                                            className: "tk-shot tk-shot--empty",
                                            children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $9f1db3a3fd7715e2$export$2e2bcd8739ae039), {})
                                        }),
                                        readOnly ? null : /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $eb1133c43d00490b$export$2e2bcd8739ae039), {
                                            size: 8,
                                            children: [
                                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b615b6e60c753ce5$export$2e2bcd8739ae039), {
                                                    accept: "image/jpeg,image/png",
                                                    showUploadList: false,
                                                    maxCount: 1,
                                                    beforeUpload: (file)=>(onImage(file), false),
                                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Link, {
                                                        children: [
                                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $fa25166ced813feb$export$2e2bcd8739ae039), {}),
                                                            " ",
                                                            t(imageUrl ? "img_change" : "img_add")
                                                        ]
                                                    })
                                                }),
                                                imageUrl ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Link, {
                                                    onClick: onImageRemove,
                                                    children: [
                                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5234c28d879e38c1$export$2e2bcd8739ae039), {}),
                                                        " ",
                                                        t("img_remove")
                                                    ]
                                                }) : null
                                            ]
                                        })
                                    ]
                                }), {
                                    hint: t("f_image_hint")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($5674c01508872783$var$Section, {
                        title: t("sec_where"),
                        desc: isNew ? undefined : t("sec_where_desc"),
                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                            vertical: true,
                            gap: "middle",
                            children: !isNew ? field("point", null, {
                                view: [
                                    item.point?.locality?.name,
                                    item.point?.name
                                ].filter(Boolean).join(" \xb7 ")
                            }) : target === "network" ? field("network", /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b6929c6a194abc34$export$2e2bcd8739ae039), {
                                entity: "network",
                                value: item.network,
                                prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $f48fe90789d2a71a$export$2e2bcd8739ae039), {}),
                                extraQuery: {
                                    active: true
                                },
                                onChange: (option)=>onChange("network", option)
                            }), {
                                required: true
                            }) : target === "point_group" ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $575603080129eb00$exports.Fragment), {
                                children: [
                                    field("group", /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b6929c6a194abc34$export$2e2bcd8739ae039), {
                                        entity: "point_groups",
                                        value: item.point_groups,
                                        prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $68e85fc2f9283018$export$2e2bcd8739ae039), {}),
                                        onChange: (option)=>onChange("point_groups", option)
                                    }), {
                                        required: true
                                    }),
                                    field("group_name", /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0883e7f8083c01b0$export$2e2bcd8739ae039), {
                                        maxLength: 120,
                                        value: item.title_group_uploads || "",
                                        onChange: (event)=>onChange("title_group_uploads", event.target.value)
                                    }), {
                                        required: true
                                    })
                                ]
                            }) : field("point", /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b6929c6a194abc34$export$2e2bcd8739ae039), {
                                entity: "point",
                                value: item.point,
                                prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $a1f80a723f71d713$export$2e2bcd8739ae039), {}),
                                extraQuery: {
                                    active: true
                                },
                                onChange: (option)=>onChange("point", option)
                            }), {
                                required: true
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($5674c01508872783$var$Section, {
                        title: t("sec_when"),
                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                            gap: "middle",
                            wrap: true,
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                                    className: "tk-form__half",
                                    children: field("start", /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $bf89508d36c51d8b$export$2e2bcd8739ae039), {
                                        disabled: readOnly,
                                        value: item.start ? (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)(item.start) : null,
                                        onChange: (value)=>onChange("start", value ? value.startOf("day").toISOString() : null)
                                    }), {
                                        view: item.start ? dateText(item.start) : null
                                    })
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                                    className: "tk-form__half",
                                    children: field("end", /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $bf89508d36c51d8b$export$2e2bcd8739ae039), {
                                        disabled: readOnly,
                                        value: item.end ? (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)(item.end) : null,
                                        /* End of day, so a deadline of "today" includes today — the same inclusivity
                       the list's period filter applies. */ onChange: (value)=>onChange("end", value ? value.endOf("day").toISOString() : null)
                                    }), {
                                        required: true,
                                        view: item.end ? dateText(item.end) : null
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($5674c01508872783$var$Section, {
                        title: t("sec_form"),
                        desc: t("sec_form_desc"),
                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                            vertical: true,
                            gap: "middle",
                            children: [
                                field("template", /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b6929c6a194abc34$export$2e2bcd8739ae039), {
                                    entity: "template",
                                    value: item.template,
                                    onChange: (option)=>onChange("template", option)
                                }), {
                                    required: true
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("ul", {
                                    className: "tk-facts",
                                    children: [
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                                    className: "tk-facts__k",
                                                    children: t("f_priority")
                                                }),
                                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                                    className: "tk-facts__v",
                                                    children: item.priority === null || item.priority === undefined ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                                        type: "secondary",
                                                        children: t("from_template")
                                                    }) : t(`prio_${item.priority}`)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                                    className: "tk-facts__k",
                                                    children: t("f_components")
                                                }),
                                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                                    className: "tk-facts__v",
                                                    children: (item.components || []).length ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $eb1133c43d00490b$export$2e2bcd8739ae039), {
                                                        size: 4,
                                                        wrap: true,
                                                        children: item.components.map((name)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $602120e6d17ff12a$export$2e2bcd8739ae039), {
                                                                children: $5674c01508872783$var$COMPONENT_LABEL[name] ? t($5674c01508872783$var$COMPONENT_LABEL[name]) : name
                                                            }, name))
                                                    }) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                                        type: "secondary",
                                                        children: t("from_template")
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    }));
}



/** What `PATCH tasks/:id/` accepts — mirrors `TaskWriteSerializer`. Anything outside this is not
    sent, so a partial update cannot blank a field the form does not show (the /profile lesson). */ const $51ef8b1748b26f2f$var$WRITABLE = [
    "title",
    "description",
    "start",
    "end",
    "images",
    "template",
    "is_active"
];
const $51ef8b1748b26f2f$var$REQUIRED = {
    point: [
        "title",
        "end",
        "template",
        "point"
    ],
    network: [
        "title",
        "end",
        "template",
        "network"
    ],
    point_group: [
        "title",
        "end",
        "template",
        "point_groups"
    ]
};
const $51ef8b1748b26f2f$var$MAX_IMAGE_MB = 10;
const $51ef8b1748b26f2f$var$idOf = (v)=>v && typeof v === "object" ? v.id ?? v.value : v;
/** Active or deactivated — the only state a task carries now.
 *
 * The four-state completion pill (awaiting / on review / done / rejected) is gone with
 * `annotate_task_status`: it resolved the newest answer and then that answer's `Approval`, a
 * correlated subquery per row over an unindexed `object_id`. The pill's SHAPE is still shared,
 * from `.status-tag` in `theme/antd.scss` (a `-bg` tint with a `-700` label, never antd's
 * `<Tag color="success">`, which derives its label from the `-500` fills and fails AA).
 */ function $51ef8b1748b26f2f$var$TaskStatusTag({ isActive: isActive, lang: lang }) {
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $602120e6d17ff12a$export$2e2bcd8739ae039), {
        variant: "filled",
        className: `status-tag status-tag--${isActive === false ? "off" : "ok"}`,
        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$601c8c0f45aeb0a0), isActive === false ? "st_inactive" : "st_active", lang)
    });
}
/** Two weeks is the window the old page seeded a new task with. */ const $51ef8b1748b26f2f$var$seedItem = ()=>({
        title: "",
        description: "",
        start: (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)().startOf("day").toISOString(),
        end: (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)().add(14, "day").endOf("day").toISOString(),
        images: [],
        template: "",
        point: null,
        network: null,
        point_groups: null,
        title_group_uploads: ""
    });
/**
 * The dirty signature.
 *
 * ⚠ NOT a plain `JSON.stringify`: a freshly picked image is a `File`, which serialises to `{}`, so
 * choosing a new photo on an existing record left the form looking pristine and Save disabled.
 * Same replacer `points/ResourcePage.js` carries, for the same bug.
 */ const $51ef8b1748b26f2f$var$signature = (item)=>JSON.stringify(item, (key, value)=>value instanceof File ? `File:${value.name}:${value.size}:${value.lastModified}` : value instanceof Blob ? `Blob:${value.size}` : value);
function $51ef8b1748b26f2f$export$2e2bcd8739ae039() {
    const history = (0, $6f5d68f762d5488a$export$3420e1dc2c4a518c)();
    const location = (0, $6f5d68f762d5488a$export$45d76561a5302f2b)();
    const { id: id, type: type } = (0, $6f5d68f762d5488a$export$99eaa27ddbbb95ef)();
    const me = (0, $b83e93e5ef3de8b0$export$2105062e25df4afe)((state)=>state.me);
    const lang = me?.language || "en";
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$9b31c804fa72c7c), key, lang);
    const tl = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$601c8c0f45aeb0a0), key, lang);
    const isNew = !id;
    const target = (0, $5674c01508872783$export$d1ff3caf57547dc5).includes(type) ? type : "point";
    const [item, setItem] = (0, $cQmXV.useState)(isNew ? $51ef8b1748b26f2f$var$seedItem() : null);
    const [status, setStatus] = (0, $cQmXV.useState)(isNew ? "ready" : "loading");
    /* Two baselines, deliberately. `pristine` is the signature for the dirty comparison; `original`
     is a structuredClone for reverting — `JSON.parse(JSON.stringify(item))` would turn Date fields
     into strings, which threw inside a render on the points page. */ const [pristine, setPristine] = (0, $cQmXV.useState)(()=>$51ef8b1748b26f2f$var$signature(isNew ? $51ef8b1748b26f2f$var$seedItem() : {}));
    const original = (0, $cQmXV.useRef)(null);
    const [errors, setErrors] = (0, $cQmXV.useState)({});
    const [saving, setSaving] = (0, $cQmXV.useState)(false);
    const [busy, setBusy] = (0, $cQmXV.useState)(false);
    /* The answers section: `undefined` = never opened, `null` = the fetch failed, array = loaded and
     cached. Opening is what triggers the fetch, and it opens on arrival for an existing task — the
     verdict is what a reviewer came here to give, and it used to sit collapsed at the bottom behind
     an extra click (PICSELL-1572). A NEW task has no answers, so it stays shut and fetches nothing.
     The lazy-mount contract is unchanged: the section is still mounted only while open, and still
     unmounted (not `display: none`) when it is closed. */ const [answersOpen, setAnswersOpen] = (0, $cQmXV.useState)(!isNew);
    const [answers, setAnswers] = (0, $cQmXV.useState)(undefined);
    const loadingAnswers = (0, $cQmXV.useRef)(false);
    /* Edit mode rides in the URL so a reload lands back where the user was (spec/03). */ const params = new URLSearchParams(location.search);
    const editing = isNew || params.get("edit") === "1";
    const dateFmt = (0, $cQmXV.useMemo)(()=>new Intl.DateTimeFormat((0, $7d0f78de0b68a104$export$bd7bed267fc278f2)(lang), {
            day: "2-digit",
            month: "short",
            year: "numeric"
        }), [
        lang
    ]);
    const dateTimeFmt = (0, $cQmXV.useMemo)(()=>new Intl.DateTimeFormat((0, $7d0f78de0b68a104$export$bd7bed267fc278f2)(lang), {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit"
        }), [
        lang
    ]);
    const setBaseline = (next)=>{
        original.current = structuredClone(next);
        setPristine($51ef8b1748b26f2f$var$signature(next));
    };
    /* ------------------------------------------------------------------ load */ const load = ()=>{
        const controller = new AbortController();
        setStatus("loading");
        (0, $c9936523dc38c641$export$86557ef9e0794d10)(`tasks/${id}/`, controller.signal).then((response)=>{
            if (!response) {
                setStatus("error");
                return;
            }
            setItem(response);
            setBaseline(response);
            setStatus("ready");
        }).catch((error)=>{
            if (error.name === "AbortError") return;
            setStatus("error");
        });
        return ()=>controller.abort();
    };
    (0, $cQmXV.useEffect)(()=>{
        if (isNew) {
            setBaseline(item);
            return undefined;
        }
        /* A different record invalidates the cached answers as well as the item. Reopened, not closed —
       closing here would silently undo the open-on-arrival default on every task→task navigation. */ setAnswers(undefined);
        setAnswersOpen(true);
        return load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        id
    ]);
    /* Hydrate the answers on first open, then cache. */ (0, $cQmXV.useEffect)(()=>{
        if (!answersOpen || isNew || answers !== undefined || loadingAnswers.current) return;
        loadingAnswers.current = true;
        const controller = new AbortController();
        /* `?task=` only started narrowing anything when `AnswerViewSet.filter_class` was corrected to
       `filterset_class` — before that this endpoint returned every answer in the company, and the
       old page rendered all of them as if they belonged to the open task. */ /* `ordering=-created` because the head's verdict acts on the NEWEST answer and the endpoint
       sends no default ordering of its own — "newest" would otherwise be whatever the database
       happened to return first. */ (0, $c9936523dc38c641$export$86557ef9e0794d10)(`answers/?task=${id}&page_size=100&ordering=-created`, controller.signal).then((response)=>{
            loadingAnswers.current = false;
            setAnswers(response?.results || []);
        }).catch((error)=>{
            loadingAnswers.current = false;
            if (error.name === "AbortError") return;
            setAnswers(null);
        });
        return ()=>controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        answersOpen,
        id,
        answers
    ]);
    /* After moderating, the answers and the task's own status refetch — the status is derived from
     the newest answer's verdict, so it moves when a verdict lands. */ const afterModerate = ()=>{
        setAnswers(undefined);
        loadingAnswers.current = false;
        if (!isNew) load();
    };
    /* ------------------------------------------------------- the head's verdict */ /* ⚠ A verdict is given on an ANSWER, never on the task. `approvals/` would happily accept
     `object_type: "task"` and answer 201 — the model is generic and its serializer validates only
     that a ContentType by that name exists — but `annotate_task_status()` hard-codes
     `content_type__model="answer"` and casts from the Answer pk, so a task-level row is invisible to
     the status pill, the list column, the sort and every segment count. The buttons would appear to
     do nothing (PICSELL-1574 #19).
     THE NEWEST answer — `ordering=-created` above is what makes `[0]` the newest.
     The verdict is `is_supervised` — the plain column ApprovalViewSet mirrors every verdict into
     (PICSELL-1581 #20); the per-row `approval` subqueries it replaced stay deleted. `== null`
     (loose) covers both a genuine NULL and a pre-deploy payload without the field — the latter
     keeps today's offer-on-every-row behaviour rather than hiding the buttons. */ const newestAnswer = Array.isArray(answers) && answers.length ? answers[0] : null;
    const pendingAnswer = newestAnswer && newestAnswer.is_supervised == null ? newestAnswer : null;
    /* The completion pill: the verdict on the newest answer decides. No answers → no pill; there
     is nothing to review yet and "pending" would claim otherwise. */ const verdictStatus = newestAnswer ? newestAnswer.is_supervised === true ? "approved" : newestAnswer.is_supervised === false ? "rejected" : "pending" : null;
    const [verdictBusy, setVerdictBusy] = (0, $cQmXV.useState)(false);
    const [rejectingAnswer, setRejectingAnswer] = (0, $cQmXV.useState)(null);
    const approveNewest = ()=>{
        if (!pendingAnswer) return;
        setVerdictBusy(true);
        (0, $e36e070b6f6386b6$export$a0b6e408d0d7f6e8)({
            objectId: pendingAnswer.id,
            objectType: "answer",
            isApproved: true,
            comment: ""
        }, (ok)=>{
            setVerdictBusy(false);
            if (!ok) {
                (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).error(t("load_error"), {
                    position: "top-right"
                });
                return;
            }
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success(t("approved_msg"), {
                position: "top-right"
            });
            afterModerate();
        });
    };
    /* ----------------------------------------------------------------- dirty */ const dirty = item !== null && $51ef8b1748b26f2f$var$signature(item) !== pristine;
    /* A pristine NEW record must still be savable, or Save is dead on arrival and the author cannot
     see what is missing. This shipped broken twice elsewhere. */ const canSave = isNew ? true : dirty;
    const showSavebar = editing && (isNew || dirty);
    const change = (name, value)=>{
        setItem((prev)=>({
                ...prev,
                [name]: value
            }));
        setErrors((prev)=>prev[name] ? {
                ...prev,
                [name]: undefined
            } : prev);
    };
    /* ----------------------------------------------------------------- image */ const uploadImage = (file)=>{
        if (file.size > $51ef8b1748b26f2f$var$MAX_IMAGE_MB * 1048576) {
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).warning((0, $3b579ca6158bc61b$export$9563e054e6f787fb)(t("img_too_big"), {
                n: $51ef8b1748b26f2f$var$MAX_IMAGE_MB
            }), {
                position: "top-right"
            });
            return;
        }
        const reader = new FileReader();
        reader.onload = (event)=>{
            /* `images/` takes a data URL (its `Base64ImageField`), not a multipart file — which is why
         antd's own uploader is bypassed with `beforeUpload → false`. `owner` is the id: the old
         code sent the whole `me` object from one call site and `undefined` from another. */ (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
                method: "POST",
                url: "images/",
                post: {
                    owner: me?.id,
                    image: event.target.result
                }
            }, (response)=>{
                if (!response?.id) {
                    (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).error(t("img_failed"), {
                        position: "top-right"
                    });
                    return;
                }
                change("images", [
                    response
                ]);
            });
        };
        reader.readAsDataURL(file);
    };
    /* The reference is dropped from the task; the Image row itself is left alone. Deleting it would
     break any other task pointing at the same upload, and Django would not reap the file anyway. */ const removeImage = ()=>change("images", []);
    /* ------------------------------------------------------------------ save */ const missing = ()=>{
        const names = $51ef8b1748b26f2f$var$REQUIRED[isNew ? target : "point"];
        const out = {};
        names.forEach((name)=>{
            if (name === "point" && !isNew) return;
            const value = item?.[name];
            if (value === null || value === undefined || value === "" || Array.isArray(value) && !value.length) out[name] = t("required_field");
        });
        if (isNew && target === "point_group" && !item?.title_group_uploads?.trim()) out.group_name = t("required_field");
        return out;
    };
    /* Focus the FIRST INVALID FIELD, not a button that may no longer exist after the re-render. */ const focusField = (name)=>{
        const host = document.querySelector(`[data-field="${name}"]`);
        if (!host) return;
        host.scrollIntoView({
            behavior: "smooth",
            block: "center"
        });
        const control = host.querySelector("input, textarea, .ant-select-selector");
        if (control) control.focus();
    };
    const payload = ()=>{
        const out = {};
        $51ef8b1748b26f2f$var$WRITABLE.forEach((name)=>{
            if (item[name] === undefined) return;
            out[name] = name === "images" ? (item.images || []).map($51ef8b1748b26f2f$var$idOf).filter(Boolean) : name === "template" ? $51ef8b1748b26f2f$var$idOf(item.template) : item[name];
        });
        return out;
    };
    const save = ()=>{
        const gaps = missing();
        if (Object.keys(gaps).length) {
            setErrors(gaps);
            focusField(Object.keys(gaps)[0]);
            return;
        }
        setErrors({});
        setSaving(true);
        if (!isNew) {
            (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
                method: "PATCH",
                url: `tasks/${item.id}/`,
                post: payload()
            }, (response)=>{
                setSaving(false);
                if (!response?.id) {
                    (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).error(t("save_failed"), {
                        position: "top-right"
                    });
                    return;
                }
                setItem(response);
                setBaseline(response);
                (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success(t("saved_msg"), {
                    position: "top-right"
                });
                history.replace({
                    search: ""
                });
            });
            return;
        }
        /* Create. A point lands on the new record; a network or a group is a FAN-OUT that returns no
       single id — `tasks/` with a `network` creates one task per point in it, and
       `tasks/bulk-create-by-group/` queues a Celery job answering `{action, status}`. Pretending
       either produced one record is what made the old page reload the whole app. */ if (target === "point_group") {
            const body = {
                action_name: item.title_group_uploads || "",
                group_id: $51ef8b1748b26f2f$var$idOf(item.point_groups),
                template: $51ef8b1748b26f2f$var$idOf(item.template),
                tasks: [
                    {
                        title: item.title,
                        description: item.description || "",
                        start: item.start,
                        end: item.end,
                        images: (item.images || []).map($51ef8b1748b26f2f$var$idOf).filter(Boolean)
                    }
                ]
            };
            (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
                method: "POST",
                url: "tasks/bulk-create-by-group/",
                post: body
            }, (response)=>{
                setSaving(false);
                if (!response?.action) {
                    (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).error(t("save_failed"), {
                        position: "top-right"
                    });
                    return;
                }
                (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success(t("bulk_queued_msg"), {
                    position: "top-right"
                });
                history.push("/task");
            });
            return;
        }
        const body = {
            ...payload(),
            point: target === "point" ? $51ef8b1748b26f2f$var$idOf(item.point) : null,
            network: target === "network" ? $51ef8b1748b26f2f$var$idOf(item.network) : null,
            created_by: me?.id || null,
            is_active: true
        };
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "POST",
            url: "tasks/",
            post: body
        }, (response)=>{
            setSaving(false);
            /* A network fan-out answers with a LIST, one task per point; a single point answers with one
         object. Both are successes and they are told apart here rather than assumed. */ if (Array.isArray(response)) {
                (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success((0, $3b579ca6158bc61b$export$9563e054e6f787fb)(t("bulk_created_msg"), {
                    n: response.length
                }), {
                    position: "top-right"
                });
                history.push("/task");
                return;
            }
            if (!response?.id) {
                (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).error(t("save_failed"), {
                    position: "top-right"
                });
                return;
            }
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success(t("saved_msg"), {
                position: "top-right"
            });
            history.push(`/task/${response.id}`);
        });
    };
    const cancel = ()=>{
        if (isNew) {
            history.push("/task");
            return;
        }
        if (!dirty) {
            history.replace({
                search: ""
            });
            return;
        }
        (0, $05a90c67d3627fd9$export$2e2bcd8739ae039).confirm({
            title: t("confirm_cancel"),
            okText: t("cancel"),
            cancelText: tl("cancel_btn"),
            onOk: ()=>{
                /* Revert from the structuredClone, never from a re-parsed JSON baseline. */ const restored = structuredClone(original.current);
                setItem(restored);
                setPristine($51ef8b1748b26f2f$var$signature(restored));
                setErrors({});
                history.replace({
                    search: ""
                });
            }
        });
    };
    const deactivate = ()=>{
        (0, $05a90c67d3627fd9$export$2e2bcd8739ae039).confirm({
            title: (0, $3b579ca6158bc61b$export$9563e054e6f787fb)(tl("confirm_deactivate"), {
                n: 1
            }),
            content: tl("confirm_deactivate_desc"),
            okText: tl("deactivate"),
            okButtonProps: {
                danger: true
            },
            cancelText: tl("cancel_btn"),
            onOk: ()=>{
                setBusy(true);
                (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
                    method: "PATCH",
                    url: `tasks/${item.id}/`,
                    post: {
                        is_active: false
                    }
                }, (response)=>{
                    setBusy(false);
                    if (!response?.id) {
                        (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).error(t("save_failed"), {
                            position: "top-right"
                        });
                        return;
                    }
                    setItem(response);
                    setBaseline(response);
                    (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success((0, $3b579ca6158bc61b$export$9563e054e6f787fb)(tl("deactivated_msg"), {
                        n: 1
                    }), {
                        position: "top-right"
                    });
                });
            }
        });
    };
    /* ----------------------------------------------------------------- states */ if (status === "loading") return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
        className: "shell-content",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e855c7114b2916ed$export$2e2bcd8739ae039), {
                active: true,
                title: true,
                paragraph: {
                    rows: 2
                }
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                className: "dp-grid",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e855c7114b2916ed$export$2e2bcd8739ae039), {
                        active: true,
                        paragraph: {
                            rows: 8
                        }
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e855c7114b2916ed$export$2e2bcd8739ae039), {
                        active: true,
                        paragraph: {
                            rows: 5
                        }
                    })
                ]
            })
        ]
    });
    if (status === "error" || !item) return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
        className: "shell-content",
        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $99350450b877904c$export$2e2bcd8739ae039), {
            image: (0, $99350450b877904c$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE,
            description: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                vertical: true,
                gap: 8,
                align: "center",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                        strong: true,
                        children: t("not_found_title")
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                        type: "secondary",
                        children: t("not_found_desc")
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                        type: "primary",
                        onClick: ()=>history.push("/task"),
                        children: t("back_to_list")
                    })
                ]
            })
        })
    });
    const off = item.is_active === false;
    const imageUrl = item.images?.[0]?.image || null;
    /* The list's `?…` ride-along, so Back from here returns to the exact filtered view. */ const backSearch = location.search.replace(/[?&]edit=1/, "").replace(/^&/, "?");
    const facts = [
        [
            t("k_created"),
            item.created ? dateTimeFmt.format(new Date(item.created)) : "\u2014"
        ],
        [
            t("f_start"),
            item.start ? dateFmt.format(new Date(item.start)) : "\u2014"
        ],
        [
            t("f_end"),
            item.end ? dateFmt.format(new Date(item.end)) : "\u2014"
        ],
        [
            t("k_locality"),
            item.point?.locality?.name || "\u2014"
        ],
        [
            t("f_network"),
            item.point?.network?.name || "\u2014"
        ],
        [
            t("k_last_answer"),
            item.last_answer_date ? dateFmt.format(new Date(item.last_answer_date)) : "\u2014"
        ]
    ];
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
        className: "shell-content dp-detail tk-detail",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                className: "dp-head",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                        className: "dp-head__main",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $acdea7eebf8fd4fd$export$2e2bcd8739ae039), {
                                items: [
                                    {
                                        title: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("a", {
                                            onClick: ()=>history.push(`/task${backSearch}`),
                                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$72266474e9355649), "tasks", lang)
                                        })
                                    },
                                    {
                                        title: isNew ? t("new_title") : item.title || `#${item.id}`
                                    }
                                ]
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                                className: "dp-head__titlerow",
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("h1", {
                                        className: "dp-title",
                                        children: isNew ? t("new_title") : item.title || `#${item.id}`
                                    }),
                                    isNew ? null : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($51ef8b1748b26f2f$var$TaskStatusTag, {
                                        isActive: item.is_active,
                                        lang: lang
                                    }),
                                    verdictStatus ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e36e070b6f6386b6$export$5452e567de639f2a), {
                                        status: verdictStatus,
                                        lang: lang
                                    }) : null,
                                    off ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $602120e6d17ff12a$export$2e2bcd8739ae039), {
                                        className: "dp-tag--off",
                                        children: tl("st_inactive")
                                    }) : null
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $eb1133c43d00490b$export$2e2bcd8739ae039), {
                        size: 8,
                        wrap: true,
                        children: [
                            pendingAnswer ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $575603080129eb00$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $45839ed7c4a7faa2$export$2e2bcd8739ae039), {}),
                                        loading: verdictBusy,
                                        onClick: approveNewest,
                                        children: t("approve")
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                        danger: true,
                                        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $bdfb1f797481a352$export$2e2bcd8739ae039), {}),
                                        disabled: verdictBusy,
                                        onClick: ()=>setRejectingAnswer(pendingAnswer),
                                        children: t("reject")
                                    })
                                ]
                            }) : null,
                            !isNew && !editing ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $1141984d2e96fc67$export$2e2bcd8739ae039), {}),
                                onClick: ()=>history.replace({
                                        search: "?edit=1"
                                    }),
                                children: t("edit")
                            }) : null,
                            !isNew && !off ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                danger: true,
                                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $4d7cc9843b581604$export$2e2bcd8739ae039), {}),
                                loading: busy,
                                onClick: deactivate,
                                children: tl("deactivate")
                            }) : null
                        ]
                    })
                ]
            }),
            isNew ? null : /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("section", {
                className: "dp-card tk-answers-card",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                        className: "dp-sec-head",
                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                            align: "center",
                            justify: "space-between",
                            gap: "small",
                            wrap: true,
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("h2", {
                                    className: "dp-sec-title",
                                    children: t("sec_answers")
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                    size: "small",
                                    "aria-expanded": answersOpen,
                                    "aria-controls": "tk-answers-panel",
                                    onClick: ()=>setAnswersOpen((open)=>!open),
                                    children: t(answersOpen ? "ans_hide" : "ans_show")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                        id: "tk-answers-panel",
                        role: "region",
                        "aria-label": t("sec_answers"),
                        children: answersOpen ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $31c1786c7a4b0517$export$2e2bcd8739ae039), {
                            task: item,
                            rows: answers,
                            lang: lang,
                            dateFmt: dateTimeFmt,
                            onModerated: afterModerate
                        }) : null
                    })
                ]
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                className: "dp-grid",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                        className: "dp-main",
                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5674c01508872783$export$2e2bcd8739ae039), {
                            item: item,
                            target: target,
                            isNew: isNew,
                            readOnly: !editing,
                            errors: errors,
                            lang: lang,
                            onChange: change,
                            onImage: uploadImage,
                            onImageRemove: removeImage
                        })
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("aside", {
                        className: "dp-rail",
                        children: [
                            isNew ? null : /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("section", {
                                className: "dp-card tk-idcard",
                                children: [
                                    imageUrl ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("img", {
                                        className: "tk-idcard__shot",
                                        src: imageUrl,
                                        alt: ""
                                    }) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                                        className: "tk-idcard__shot tk-shot--empty",
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $9f1db3a3fd7715e2$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                        className: "tk-idcard__name",
                                        children: item.title || `#${item.id}`
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                        type: "secondary",
                                        children: item.template?.name || item.point?.name || ""
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("section", {
                                className: "dp-card",
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                                        className: "dp-sec-head",
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("h2", {
                                            className: "dp-sec-title",
                                            children: t("rail_summary")
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("ul", {
                                        className: "tk-facts",
                                        children: [
                                            facts.map(([label, value])=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                                            className: "tk-facts__k",
                                                            children: label
                                                        }),
                                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                                            className: "tk-facts__v",
                                                            children: value
                                                        })
                                                    ]
                                                }, label)),
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                                        className: "tk-facts__k",
                                                        children: t("k_merchandiser")
                                                    }),
                                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                                        className: "tk-facts__v",
                                                        children: item.point?.responsible_merchandiser ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $66539b2560a58e4e$export$8a3d0b92eb0904a5), {
                                                            user: item.point.responsible_merchandiser,
                                                            strong: false
                                                        }) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                                            type: "secondary",
                                                            children: t("no_merchandiser")
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                                        className: "tk-facts__k",
                                                        children: t("k_created_by")
                                                    }),
                                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                                        className: "tk-facts__v",
                                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $66539b2560a58e4e$export$8a3d0b92eb0904a5), {
                                                            user: item.created_by,
                                                            strong: false
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            editing && Object.keys(missing()).length ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("section", {
                                className: "dp-card",
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                                        className: "dp-sec-head",
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("h2", {
                                            className: "dp-sec-title",
                                            children: t("rail_quality")
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                        vertical: true,
                                        gap: 4,
                                        align: "flex-start",
                                        children: Object.keys(missing()).map((name)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                                type: "link",
                                                className: "tk-issue",
                                                onClick: ()=>focusField(name),
                                                children: t(`f_${name}`) || name
                                            }, name))
                                    })
                                ]
                            }) : null
                        ]
                    })
                ]
            }),
            showSavebar ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                className: "dp-savebar",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                        className: "dp-savebar__msg",
                        children: [
                            isNew ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $9f1db3a3fd7715e2$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $1141984d2e96fc67$export$2e2bcd8739ae039), {}),
                            t(isNew ? "draft" : "unsaved")
                        ]
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                        className: "dp-savebar__acts",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                type: "text",
                                onClick: cancel,
                                children: t("cancel")
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                type: "primary",
                                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $45839ed7c4a7faa2$export$2e2bcd8739ae039), {}),
                                loading: saving,
                                disabled: !canSave,
                                onClick: save,
                                children: t("save")
                            })
                        ]
                    })
                ]
            }) : null,
            rejectingAnswer ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $9525ffc2d869d787$export$2e2bcd8739ae039), {
                target: {
                    objectId: rejectingAnswer.id,
                    objectType: "answer"
                },
                photo: (0, $e873a05126b50f33$export$57b71c8db173e2e4)(rejectingAnswer)[0] || null,
                point: item?.point || null,
                visitId: rejectingAnswer.visit_id,
                lang: lang,
                onCancel: ()=>setRejectingAnswer(null),
                onDone: ()=>{
                    setRejectingAnswer(null);
                    afterModerate();
                }
            }) : null
        ]
    });
}


/* /import — bulk create tasks or assortment matrices from a file.
 *
 * No mockup exists for this screen. It is spec/03 **archetype B** applied to a create-only record:
 * page head → `dp-grid` of form + reference rail → bottom save bar that exists only while there is
 * something to submit. There is no view mode and no id, so there is no `?edit=1` and no dirty
 * comparison — `canSave` is simply "are there rows".
 *
 * It replaces four MUI tabs (`src/module/tasks-import/`, 1,419 lines). Three of them were the same
 * flow copy-pasted; the fourth is now `/uploads`.
 *
 * Two things this page does that the one it replaces did not:
 *
 * 1. **It shows you the rows before it sends them.** The old page enabled Save the moment a file
 *    parsed and posted blind; the only feedback was the API's `details` string in a red box.
 *    Validation here is SHAPE ONLY and the page says so — point, network, product and template
 *    codes exist in the database, not in the file, so only the server can resolve them.
 * 2. **It hands you off to the result.** Both endpoints are ASYNCHRONOUS: they answer
 *    `{action, status: "pending"}` and Celery does the work. The old page showed a green
 *    "Items successfully saved" toast and stopped, so a batch where every row failed looked
 *    identical to one that worked. Submitting now lands on `/uploads`, which is where the outcome
 *    actually lives.
 */ 

var $cQmXV = parcelRequire("cQmXV");








/* The app's one tabular-file reader: CSV in, CSV out, xlsx in.
 *
 * It replaces three copies of `reader.result.split(/\r?\n/)` + `row.split(",")` — one in each of
 * the old import tabs — plus a fourth hand-rolled `join(",")` writer in the upload log. That
 * approach breaks on the first field containing a comma, which for a task *description* is not an
 * edge case, and it silently produced garbage for the `.xlsx` files the assortment-matrix tab
 * advertised it accepted.
 *
 * `scripts/check-csv.mjs` is the runnable check: `yarn check:csv`.
 */ /**
 * RFC 4180, as a single character scan.
 *
 * Handles quoted fields (so a value may contain a comma or a newline), `""` as an escaped quote,
 * CRLF / LF / lone-CR line endings, and a UTF-8 BOM — which Excel writes and which otherwise ends
 * up *inside* the first header cell, so a column named `id` never matches.
 *
 * Line endings are normalised up front rather than branched on in the loop: a CRLF inside a quoted
 * field should become a newline anyway, so there is nothing to preserve.
 *
 * @param {string} text
 * @returns {string[][]} rows of raw cell strings; wholly blank rows are dropped
 */ function $21ef098471e9fbe6$export$2dc6f8ad0f55f4d8(text) {
    const src = String(text || "").replace(/^\uFEFF/, "").replace(/\r\n?/g, "\n");
    const rows = [];
    let row = [];
    let field = "";
    let quoted = false;
    for(let i = 0; i < src.length; i++){
        const char = src[i];
        if (quoted) {
            if (char !== '"') field += char;
            else if (src[i + 1] === '"') {
                field += '"';
                i++;
            } else quoted = false;
            continue;
        }
        if (char === '"') quoted = true;
        else if (char === ",") {
            row.push(field);
            field = "";
        } else if (char === "\n") {
            row.push(field);
            rows.push(row);
            row = [];
            field = "";
        } else field += char;
    }
    row.push(field);
    rows.push(row);
    /* A trailing newline leaves one empty row, and files exported from a spreadsheet routinely carry
     a run of them. A row that is blank in every cell carries no record either way. */ return rows.filter((cells)=>cells.some((cell)=>cell.trim() !== ""));
}
/** Quote only where the value forces it, so a plain file stays diffable and readable. */ const $21ef098471e9fbe6$var$escapeCell = (value)=>{
    const cell = value == null ? "" : String(value);
    return /["\n,]/.test(cell) ? `"${cell.split('"').join('""')}"` : cell;
};
const $21ef098471e9fbe6$export$71898ff6dc6dd523 = (rows)=>rows.map((cells)=>cells.map($21ef098471e9fbe6$var$escapeCell).join(",")).join("\n");

async function $21ef098471e9fbe6$export$8758d6f4ef74c142(file) {
    const name = (file?.name || "").toLowerCase();
    if (name.endsWith(".xlsx") || name.endsWith(".xls")) {
        const XLSX = await (parcelRequire("dAj32"));
        const book = XLSX.read(await file.arrayBuffer(), {
            type: "array",
            cellDates: true
        });
        /* The first sheet only. A workbook whose data is on sheet 2 is a support question, not a
       silently-half-imported batch. */ const sheet = book.Sheets[book.SheetNames[0]];
        if (!sheet) return [];
        return XLSX.utils.sheet_to_json(sheet, {
            header: 1,
            blankrows: false,
            defval: "",
            raw: false,
            dateNF: "dd/mm/yyyy"
        }).map((cells)=>cells.map((cell)=>cell == null ? "" : String(cell))).filter((cells)=>cells.some((cell)=>cell.trim() !== ""));
    }
    return $21ef098471e9fbe6$export$2dc6f8ad0f55f4d8(await file.text());
}
function $21ef098471e9fbe6$export$c6d851d1877b46af(rows, filename) {
    const url = URL.createObjectURL(new Blob([
        "\uFEFF" + $21ef098471e9fbe6$export$71898ff6dc6dd523(rows)
    ], {
        type: "text/csv;charset=utf-8"
    }));
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    /* Revoking synchronously cancels the download in Safari. */ setTimeout(()=>URL.revokeObjectURL(url), 0);
}


/* The three things this app can bulk-import, as three descriptors.
 *
 * They were three near-identical class components before this (`import/ImportCore.js`,
 * `import-advanced/ImportAdvanced.js`, `import-amatrix/ImportAMatrix.js`, ~1,140 lines) whose
 * `uploadFile` / `getUploadData` / `validate` / `submit` / `changeFilter` / `handleChangeBulkName`
 * and whole `state` shape were copy-pasted. They differ in exactly four ways — the endpoint, the
 * column contract, whether a template or a scope is needed, and the payload shape — so that is
 * what a descriptor carries and everything else is the one page in `Import.js`.
 *
 * This is deliberately a plain array of three, not a registry: there are three, they are named in
 * the UI, and a fourth is a backend endpoint away, not a configuration away.
 */ 
const $d2f98770df1a68b1$export$45c85543ba71221d = "DD/MM/YYYY";
/* What the API's task deserialiser accepts. Kept exactly as the page this replaces sent it. */ const $d2f98770df1a68b1$var$API_DATETIME = "YYYY-MM-DDTHH:mm";
/* Accepted on the way IN, strictly. A spreadsheet cell reaches us as whatever its own number
   format rendered, and a hand-typed CSV is whatever the author's locale writes, so several real
   shapes arrive — but each is parsed strictly, so `31/13/2026` is rejected rather than rolled
   forward into 2027. */ const $d2f98770df1a68b1$var$DATE_FORMATS = [
    "DD/MM/YYYY",
    "D/M/YYYY",
    "DD.MM.YYYY",
    "D.M.YYYY",
    "YYYY-MM-DD"
];
const $d2f98770df1a68b1$export$6b862160d295c8e = (text)=>{
    const parsed = (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)(String(text ?? "").trim(), $d2f98770df1a68b1$var$DATE_FORMATS, true);
    return parsed.isValid() ? parsed : null;
};
const $d2f98770df1a68b1$export$9f2ce0d73c62bfe5 = (value)=>(0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039).isDayjs(value) ? value.isValid() ? value : null : $d2f98770df1a68b1$export$6b862160d295c8e(value);
const $d2f98770df1a68b1$var$trim = (value)=>String(value ?? "").trim();
/* ------------------------------------------------------------------ tasks */ /* Shared by both task kinds — the only difference is where the point and network come from. */ const $d2f98770df1a68b1$var$TASK_COLUMNS = [
    {
        key: "title",
        label: "col_title",
        type: "text",
        required: true,
        width: 240
    },
    {
        key: "description",
        label: "col_description",
        type: "text",
        required: false,
        width: 260
    },
    {
        key: "start",
        label: "col_start",
        type: "date",
        required: true,
        width: 150
    },
    {
        key: "end",
        label: "col_end",
        type: "date",
        required: true,
        width: 150
    }
];
const $d2f98770df1a68b1$var$ROW_SCOPE_COLUMNS = [
    {
        key: "point",
        label: "col_point",
        type: "code",
        required: false,
        width: 140
    },
    {
        key: "network",
        label: "col_network",
        type: "code",
        required: false,
        width: 140
    }
];
const $d2f98770df1a68b1$var$validateTask = (row)=>{
    const errors = {};
    if (!$d2f98770df1a68b1$var$trim(row.title)) errors.title = "e_required";
    [
        "start",
        "end"
    ].forEach((key)=>{
        if (!$d2f98770df1a68b1$var$trim(row[key]) && !(0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039).isDayjs(row[key])) errors[key] = "e_required";
        else if (!$d2f98770df1a68b1$export$9f2ce0d73c62bfe5(row[key])) errors[key] = "e_date";
    });
    const start = $d2f98770df1a68b1$export$9f2ce0d73c62bfe5(row.start);
    const end = $d2f98770df1a68b1$export$9f2ce0d73c62bfe5(row.end);
    /* Only meaningful once both parsed; otherwise the row already carries the truer message. */ if (start && end && end.isBefore(start, "day")) errors.end = "e_end_before_start";
    return errors;
};
const $d2f98770df1a68b1$var$taskPayload = (row)=>({
        title: $d2f98770df1a68b1$var$trim(row.title),
        description: $d2f98770df1a68b1$var$trim(row.description),
        start: $d2f98770df1a68b1$export$9f2ce0d73c62bfe5(row.start).format($d2f98770df1a68b1$var$API_DATETIME),
        end: $d2f98770df1a68b1$export$9f2ce0d73c62bfe5(row.end).format($d2f98770df1a68b1$var$API_DATETIME),
        point: $d2f98770df1a68b1$var$trim(row.point),
        network: $d2f98770df1a68b1$var$trim(row.network),
        images: (row.images || []).map((image)=>image.id).filter(Boolean)
    });
const $d2f98770df1a68b1$export$a1d1a2dbce5ef265 = [
    {
        key: "tasks",
        label: "kind_tasks",
        desc: "kind_tasks_desc",
        endpoint: "tasks/bulk_create/",
        accept: ".csv,.xlsx",
        needsTemplate: true,
        /* The API 400s with "No point or network given" when both are empty, so the scope is required
       rather than merely offered — the old page let you submit without one and read the refusal
       back as an opaque red string. */ needsScope: true,
        editable: true,
        columns: $d2f98770df1a68b1$var$TASK_COLUMNS,
        emptyRow: ()=>({
                title: "",
                description: "",
                start: (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)(),
                end: (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)().add(14, "day"),
                images: []
            }),
        parse: (rows)=>rows.slice(1).map((cells)=>({
                    title: cells[0] || "",
                    description: cells[1] || "",
                    start: cells[2] || "",
                    end: cells[3] || "",
                    images: []
                })),
        validate: $d2f98770df1a68b1$var$validateTask,
        buildPayload: (form, rows)=>{
            /* Every row shares the one scope chosen on the page. */ const point = form.scopeType === "point" ? form.scope?.code || "" : "";
            const network = form.scopeType === "network" ? form.scope?.code || "" : "";
            return {
                action_name: $d2f98770df1a68b1$var$trim(form.name),
                points: point ? [
                    point
                ] : [],
                networks: network ? [
                    network
                ] : [],
                template: form.template?.id ?? form.template ?? undefined,
                tasks: rows.map((row)=>$d2f98770df1a68b1$var$taskPayload({
                        ...row,
                        point: point,
                        network: network
                    }))
            };
        }
    },
    {
        key: "tasks_by_row",
        label: "kind_tasks_by_row",
        desc: "kind_tasks_by_row_desc",
        endpoint: "tasks/bulk_create/",
        accept: ".csv,.xlsx",
        needsTemplate: true,
        /* The scope is in the file, one per row — that is the whole point of this kind. */ needsScope: false,
        /* No hand editor: a batch worth naming a point per row is a batch that came from somewhere. */ editable: false,
        columns: [
            ...$d2f98770df1a68b1$var$TASK_COLUMNS,
            ...$d2f98770df1a68b1$var$ROW_SCOPE_COLUMNS
        ],
        parse: (rows)=>rows.slice(1).map((cells)=>({
                    title: cells[0] || "",
                    description: cells[1] || "",
                    start: cells[2] || "",
                    end: cells[3] || "",
                    point: cells[4] || "",
                    network: cells[5] || ""
                })),
        validate: (row)=>{
            const errors = $d2f98770df1a68b1$var$validateTask(row);
            /* One or the other, per row. The API takes the union of every row's codes as the batch scope
         and would otherwise be handed an empty one. */ if (!$d2f98770df1a68b1$var$trim(row.point) && !$d2f98770df1a68b1$var$trim(row.network)) {
                errors.point = "e_point_or_network";
                errors.network = "e_point_or_network";
            }
            return errors;
        },
        buildPayload: (form, rows)=>({
                action_name: $d2f98770df1a68b1$var$trim(form.name),
                points: [
                    ...new Set(rows.map((row)=>$d2f98770df1a68b1$var$trim(row.point)).filter(Boolean))
                ],
                networks: [
                    ...new Set(rows.map((row)=>$d2f98770df1a68b1$var$trim(row.network)).filter(Boolean))
                ],
                template: form.template?.id ?? form.template ?? undefined,
                tasks: rows.map($d2f98770df1a68b1$var$taskPayload)
            })
    },
    {
        key: "assortment_matrix",
        label: "kind_matrix",
        desc: "kind_matrix_desc",
        endpoint: "assortment_matrix/bulk_create/",
        accept: ".csv,.xlsx",
        needsTemplate: false,
        needsScope: false,
        editable: false,
        /* Not the file's columns — the file is a grid. These are the PREVIEW's columns; see `parse`. */ columns: [
            {
                key: "point",
                label: "col_point",
                type: "code",
                required: true,
                width: 200
            },
            {
                key: "count",
                label: "col_products",
                type: "number",
                required: false,
                width: 120
            }
        ],
        /**
     * The file is a matrix: row 0 is `<blank>, pointCode, pointCode, …`, every later row is
     * `productCode, mark, mark, …`, and a non-blank cell means "this product belongs in this
     * point's assortment".
     *
     * It is previewed as ONE ROW PER POINT with its product count, not as the raw grid: points ×
     * products is unbounded on both axes, and a 400-column table is not a check anyone can read.
     * The products themselves ride along for the payload and the row's tooltip.
     */ parse: (rows)=>{
            const header = rows[0] || [];
            const points = header.slice(1).map($d2f98770df1a68b1$var$trim);
            const byPoint = points.map((point)=>({
                    point: point,
                    products: []
                }));
            rows.slice(1).forEach((cells)=>{
                const product = $d2f98770df1a68b1$var$trim(cells[0]);
                if (!product) return;
                points.forEach((point, index)=>{
                    /* `cells[index + 1]` — column 0 is the product code. Any non-blank mark counts; the
             files in use carry `1`, `x` and `+` interchangeably. */ if ($d2f98770df1a68b1$var$trim(cells[index + 1])) byPoint[index].products.push(product);
                });
            });
            return byPoint.map((row)=>({
                    ...row,
                    count: row.products.length
                }));
        },
        validate: (row)=>{
            const errors = {};
            if (!$d2f98770df1a68b1$var$trim(row.point)) errors.point = "e_required";
            else if (!row.products.length) errors.count = "e_no_assignments";
            return errors;
        },
        buildPayload: (form, rows)=>({
                action_name: $d2f98770df1a68b1$var$trim(form.name),
                points: rows.map((row)=>$d2f98770df1a68b1$var$trim(row.point)),
                /* ⚠ A dict keyed by point code, despite the name — the view iterates it with `.items()`.
         Posting a list gets swallowed by its `except Exception` and answers 200 with a failed
         action. */ assortment_matrix_list: Object.fromEntries(rows.map((row)=>[
                        $d2f98770df1a68b1$var$trim(row.point),
                        row.products
                    ]))
            })
    }
];
const $d2f98770df1a68b1$export$7328289ba9a44022 = (key)=>$d2f98770df1a68b1$export$a1d1a2dbce5ef265.find((kind)=>kind.key === key) || $d2f98770df1a68b1$export$a1d1a2dbce5ef265[0];
function $d2f98770df1a68b1$export$3579ae33990db395(kind, t) {
    if (kind.key === "assortment_matrix") return [
        [
            "",
            "POINT-001",
            "POINT-002"
        ],
        [
            "SKU-001",
            "1",
            ""
        ],
        [
            "SKU-002",
            "1",
            "1"
        ]
    ];
    const header = kind.columns.map((column)=>t(column.label));
    const example = kind.columns.map((column)=>{
        if (column.type === "date") return (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)().format($d2f98770df1a68b1$export$45c85543ba71221d);
        if (column.key === "point") return "POINT-001";
        if (column.key === "network") return "";
        if (column.key === "title") return t("sample_title");
        return "";
    });
    return [
        header,
        example
    ];
}





let $f00aa72c5a7b810e$var$rowSeq = 0;
const $f00aa72c5a7b810e$var$withKey = (row)=>({
        ...row,
        key: `r${++$f00aa72c5a7b810e$var$rowSeq}`
    });
const $f00aa72c5a7b810e$var$Import = ()=>{
    const history = (0, $6f5d68f762d5488a$export$3420e1dc2c4a518c)();
    const location = (0, $6f5d68f762d5488a$export$45d76561a5302f2b)();
    const lang = (0, $b83e93e5ef3de8b0$export$2105062e25df4afe)((state)=>state.me?.language) || "en";
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$a763edbf796b780a), key, lang);
    const td = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), key, lang);
    /* The kind lives in the URL so a bookmark, a Back, or a link from a colleague lands on the same
     importer rather than always on the first one. */ const initialKind = (0, $cQmXV.useRef)(new URLSearchParams(location.search).get("kind")).current;
    const [kindKey, setKindKey] = (0, $cQmXV.useState)(()=>(0, $d2f98770df1a68b1$export$a1d1a2dbce5ef265).some((k)=>k.key === initialKind) ? initialKind : (0, $d2f98770df1a68b1$export$a1d1a2dbce5ef265)[0].key);
    const kind = (0, $d2f98770df1a68b1$export$7328289ba9a44022)(kindKey);
    const [form, setForm] = (0, $cQmXV.useState)({
        name: "",
        template: null,
        scopeType: "network",
        scope: null
    });
    const [rows, setRows] = (0, $cQmXV.useState)([]);
    const [file, setFile] = (0, $cQmXV.useState)(null);
    const [reading, setReading] = (0, $cQmXV.useState)(false);
    const [fileError, setFileError] = (0, $cQmXV.useState)(null);
    const [submitting, setSubmitting] = (0, $cQmXV.useState)(false);
    /* A 400-row file puts its problems on page 8 of the preview, where nobody will find them. */ const [onlyBad, setOnlyBad] = (0, $cQmXV.useState)(false);
    /* Shown against the fields only after a refused submit — flagging an empty form the moment it
     opens tells the user off for not having filled it in yet. */ const [showFormErrors, setShowFormErrors] = (0, $cQmXV.useState)(false);
    /* Set just before an intentional navigation, so the unsaved-rows guard lets it through. */ const leaving = (0, $cQmXV.useRef)(false);
    const setField = (key, value)=>setForm((prev)=>({
                ...prev,
                [key]: value
            }));
    /* ------------------------------------------------------------ validation */ /** A row error code → its sentence. `e_date` names the format rather than just refusing. */ const msg = (code)=>code === "e_date" ? (0, $3b579ca6158bc61b$export$9563e054e6f787fb)(t("e_date"), {
            f: (0, $d2f98770df1a68b1$export$45c85543ba71221d)
        }) : t(code);
    /* `n` is the row's position in the FILE, carried on the row itself — the preview can be filtered
     to the problems, and a number derived from the render index would then renumber them. */ const checked = (0, $cQmXV.useMemo)(()=>rows.map((row, index)=>({
                ...row,
                n: index + 1,
                errors: kind.validate(row)
            })), [
        rows,
        kind
    ]);
    const okRows = (0, $cQmXV.useMemo)(()=>checked.filter((row)=>!Object.keys(row.errors).length), [
        checked
    ]);
    const badCount = checked.length - okRows.length;
    const visible = (0, $cQmXV.useMemo)(()=>onlyBad ? checked.filter((row)=>Object.keys(row.errors).length) : checked, [
        checked,
        onlyBad
    ]);
    const formErrors = (0, $cQmXV.useMemo)(()=>{
        const errors = {};
        if (!form.name.trim()) errors.name = t("v_name_required");
        if (kind.needsTemplate && !form.template) errors.template = t("v_template_required");
        if (kind.needsScope && !form.scope) errors.scope = t("v_scope_required");
        return errors;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        form,
        kind,
        lang
    ]);
    /* ------------------------------------------------------------------ file */ const clearRows = ()=>{
        setRows([]);
        setFile(null);
        setFileError(null);
    };
    const changeKind = (next)=>{
        if (!rows.length) {
            setKindKey(next);
            history.replace({
                search: next === (0, $d2f98770df1a68b1$export$a1d1a2dbce5ef265)[0].key ? "" : `?kind=${next}`
            });
            return;
        }
        /* The column contract differs per kind, so the parsed rows cannot carry over — and losing a
       400-row file to a mis-click on a segment would be the page's worst moment. */ /* A static `Modal.confirm` renders outside the tree and does not inherit AppShell's
       `ConfigProvider locale`, so its buttons stay English unless they are passed. The verb names
       the action rather than saying OK (spec/04). */ (0, $05a90c67d3627fd9$export$2e2bcd8739ae039).confirm({
            title: t("change_kind_confirm"),
            okText: t("discard_rows"),
            okButtonProps: {
                danger: true
            },
            cancelText: t("cancel"),
            onOk: ()=>{
                clearRows();
                setKindKey(next);
                history.replace({
                    search: next === (0, $d2f98770df1a68b1$export$a1d1a2dbce5ef265)[0].key ? "" : `?kind=${next}`
                });
            }
        });
    };
    const takeFile = async (picked)=>{
        setReading(true);
        setFileError(null);
        try {
            const table = await (0, $21ef098471e9fbe6$export$8758d6f4ef74c142)(picked);
            const parsed = kind.parse(table);
            if (!parsed.length) {
                setFileError(t("empty_file"));
                setFile(null);
                setRows([]);
            } else {
                setFile({
                    name: picked.name
                });
                setRows(parsed.map($f00aa72c5a7b810e$var$withKey));
            }
        } catch (error) {
            console.error("import: could not read the file", error);
            setFileError(t("read_error"));
            setFile(null);
            setRows([]);
        }
        setReading(false);
    };
    /* ---------------------------------------------------------------- submit */ const submit = ()=>{
        setShowFormErrors(true);
        const firstFormError = Object.values(formErrors)[0];
        if (firstFormError) {
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).warning(firstFormError, {
                position: "top-right"
            });
            return;
        }
        if (!okRows.length) {
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).warning(t("v_no_valid_rows"), {
                position: "top-right"
            });
            return;
        }
        setSubmitting(true);
        (0, $c9936523dc38c641$export$46f383001bf60e04)({
            method: "POST",
            url: kind.endpoint,
            post: kind.buildPayload(form, okRows)
        }, async (response)=>{
            setSubmitting(false);
            /* `httpRequest` hands back a Response for 200/204/400 but a plain object for the failures it
         has already toasted — reading `.json()` off that would throw inside the callback. */ if (typeof response?.json !== "function") return;
            let body = null;
            try {
                body = await response.json();
            } catch (error) {
                body = null;
            }
            if (response.status === 400) {
                /* `details` is always a plain string on both endpoints. */ (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).error(body?.details || t("submit_failed"), {
                    position: "top-right"
                });
                return;
            }
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success(t("queued_msg"), {
                position: "top-right"
            });
            /* ⚠ Clearing the rows here is NOT enough to quiet `<Prompt>`. React batches the state
         updates, so the re-render happens after this callback returns — at `history.push` time the
         Prompt still holds `when={true}` from the last render, and a *successful* import asked
         "the rows will be lost, leave the page?". The ref is read inside `message`, which
         react-router calls at navigation time, so it is current. */ leaving.current = true;
            setRows([]);
            setFile(null);
            history.push(body?.action ? `/uploads?new=${encodeURIComponent(body.action)}` : "/uploads");
        });
    };
    /* --------------------------------------------------------------- columns */ const editRow = (key, field, value)=>setRows((prev)=>prev.map((row)=>row.key === key ? {
                    ...row,
                    [field]: value
                } : row));
    const columns = (0, $cQmXV.useMemo)(()=>{
        const cells = kind.columns.map((column)=>({
                key: column.key,
                dataIndex: column.key,
                title: t(column.label),
                width: column.width,
                ellipsis: column.type !== "date",
                align: column.type === "number" ? "right" : undefined,
                render: (value, row)=>{
                    const invalid = Boolean(row.errors[column.key]);
                    if (kind.editable) {
                        if (column.type === "date") {
                            /* A cell that did not parse falls back to a text input carrying the RAW value. A
               `<DatePicker>` can only show a valid date, so an unparseable `31/02/2026` rendered as
               an empty field — the reason column said "not a date" while the offending text was
               invisible, which is the one thing the user needs to see to fix it. Typing over it
               re-parses through `asDate`, so the field heals back into a real date. */ const parsed = (0, $d2f98770df1a68b1$export$9f2ce0d73c62bfe5)(value);
                            if (!parsed && String(value ?? "").trim()) return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0883e7f8083c01b0$export$2e2bcd8739ae039), {
                                value: String(value),
                                status: "error",
                                onChange: (event)=>editRow(row.key, column.key, event.target.value)
                            });
                            return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $bf89508d36c51d8b$export$2e2bcd8739ae039), {
                                value: parsed,
                                format: (0, $d2f98770df1a68b1$export$45c85543ba71221d),
                                status: invalid ? "error" : undefined,
                                allowClear: false,
                                onChange: (next)=>editRow(row.key, column.key, next)
                            });
                        }
                        return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0883e7f8083c01b0$export$2e2bcd8739ae039), {
                            value: String(value ?? ""),
                            status: invalid ? "error" : undefined,
                            onChange: (event)=>editRow(row.key, column.key, event.target.value)
                        });
                    }
                    if (column.type === "date") {
                        const parsed = (0, $d2f98770df1a68b1$export$9f2ce0d73c62bfe5)(value);
                        /* An unparseable cell shows the text that is actually in the file — that is the whole
             point of a preview, and blanking it would hide the thing that needs fixing. */ return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                            className: `lp-num ${invalid ? "im-cell--bad" : ""}`,
                            children: parsed ? parsed.format((0, $d2f98770df1a68b1$export$45c85543ba71221d)) : String(value ?? "") || "\u2014"
                        });
                    }
                    if (column.type === "number") return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $1e5256cf9d329b2c$export$2e2bcd8739ae039), {
                        title: (row.products || []).join(", ") || null,
                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                            className: "lp-num",
                            children: value
                        })
                    });
                    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                        ellipsis: {
                            tooltip: String(value ?? "")
                        },
                        children: String(value ?? "") || "\u2014"
                    });
                }
            }));
        return [
            {
                key: "state",
                title: "",
                width: 44,
                align: "center",
                fixed: "left",
                render: (value, row)=>{
                    const bad = Object.keys(row.errors).length > 0;
                    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $66539b2560a58e4e$export$b131c49b26d3f427), {
                        Icon: bad ? (0, $bdfb1f797481a352$export$2e2bcd8739ae039) : (0, $45839ed7c4a7faa2$export$2e2bcd8739ae039),
                        tone: bad ? "no" : "ok",
                        label: bad ? t("n_problems") : t("n_ok")
                    });
                }
            },
            {
                key: "n",
                dataIndex: "n",
                title: t("col_row"),
                width: 64,
                fixed: "left",
                render: (value)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "lp-num",
                        children: value
                    })
            },
            ...cells,
            {
                key: "reason",
                title: t("col_reason"),
                width: 220,
                ellipsis: true,
                render: (value, row)=>{
                    const text = [
                        ...new Set(Object.values(row.errors).map(msg))
                    ].join(" \xb7 ");
                    if (!text) return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "lp-dash",
                        children: "\u2014"
                    });
                    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                        ellipsis: {
                            tooltip: text
                        },
                        className: "im-reason",
                        children: text
                    });
                }
            },
            ...kind.editable ? [
                {
                    key: "remove",
                    title: "",
                    width: 56,
                    fixed: "right",
                    render: (value, row)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                            type: "text",
                            size: "small",
                            icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5234c28d879e38c1$export$2e2bcd8739ae039), {}),
                            "aria-label": t("remove_row"),
                            onClick: ()=>setRows((prev)=>prev.filter((item)=>item.key !== row.key))
                        })
                }
            ] : []
        ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        kind,
        lang
    ]);
    const scrollY = (0, $66539b2560a58e4e$export$f44b992e82788e9)();
    const tableWidth = 328 + (kind.editable ? 56 : 0) + kind.columns.reduce((sum, column)=>sum + column.width, 0);
    /* ------------------------------------------------------------------ view */ return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
        vertical: true,
        className: "shell-content im",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $6f5d68f762d5488a$export$83716a4aa1642908), {
                when: rows.length > 0,
                message: ()=>leaving.current ? true : t("leave_confirm")
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                className: "dp-head",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                        className: "dp-head__main",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                                className: "dp-head__titlerow",
                                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Title, {
                                    level: 1,
                                    className: "dp-title",
                                    children: t("page_title")
                                })
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Paragraph, {
                                type: "secondary",
                                className: "im-sub",
                                children: t("page_sub")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $08a66dd72a6d5552$export$2e2bcd8739ae039), {}),
                        onClick: ()=>history.push("/uploads"),
                        children: t("to_uploads")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                className: "dp-grid",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                        className: "dp-main dp-form",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $b4fda840b736e640$export$2e2bcd8739ae039), {
                                className: "dp-section",
                                variant: "outlined",
                                title: null,
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                                        className: "dp-sec-head",
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("h2", {
                                            className: "dp-sec-title",
                                            children: t("kind_label")
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $ac40310dc424be23$export$2e2bcd8739ae039), {
                                        className: "im-kinds",
                                        value: kindKey,
                                        onChange: changeKind,
                                        options: (0, $d2f98770df1a68b1$export$a1d1a2dbce5ef265).map((item)=>({
                                                value: item.key,
                                                label: t(item.label)
                                            })),
                                        block: true
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Paragraph, {
                                        type: "secondary",
                                        className: "dp-sec-desc im-kind-desc",
                                        children: t(kind.desc)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039), {
                                layout: "vertical",
                                component: false,
                                colon: false,
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $b4fda840b736e640$export$2e2bcd8739ae039), {
                                        className: "dp-section",
                                        variant: "outlined",
                                        children: [
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                                                className: "dp-sec-head",
                                                children: [
                                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("h2", {
                                                        className: "dp-sec-title",
                                                        children: t("sec_batch")
                                                    }),
                                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("p", {
                                                        className: "dp-sec-desc",
                                                        children: t("sec_batch_desc")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                                label: t("f_name"),
                                                required: true,
                                                validateStatus: showFormErrors && formErrors.name ? "error" : undefined,
                                                help: showFormErrors ? formErrors.name : undefined,
                                                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0883e7f8083c01b0$export$2e2bcd8739ae039), {
                                                    value: form.name,
                                                    placeholder: t("f_name_ph"),
                                                    onChange: (event)=>setField("name", event.target.value)
                                                })
                                            }),
                                            kind.needsTemplate ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                                label: td("template"),
                                                required: true,
                                                validateStatus: showFormErrors && formErrors.template ? "error" : undefined,
                                                help: showFormErrors ? formErrors.template : undefined,
                                                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b6929c6a194abc34$export$2e2bcd8739ae039), {
                                                    entity: "template",
                                                    value: form.template,
                                                    prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $170c031fa50279f7$export$2e2bcd8739ae039), {}),
                                                    onChange: (option)=>setField("template", option)
                                                })
                                            }) : null
                                        ]
                                    }),
                                    kind.needsScope ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $b4fda840b736e640$export$2e2bcd8739ae039), {
                                        className: "dp-section",
                                        variant: "outlined",
                                        children: [
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                                                className: "dp-sec-head",
                                                children: [
                                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("h2", {
                                                        className: "dp-sec-title",
                                                        children: t("sec_scope")
                                                    }),
                                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("p", {
                                                        className: "dp-sec-desc",
                                                        children: t("sec_scope_desc")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                                label: t("f_scope_type"),
                                                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $ac40310dc424be23$export$2e2bcd8739ae039), {
                                                    value: form.scopeType,
                                                    onChange: (next)=>setForm((prev)=>({
                                                                ...prev,
                                                                scopeType: next,
                                                                scope: null
                                                            })),
                                                    options: [
                                                        {
                                                            value: "network",
                                                            label: t("scope_network")
                                                        },
                                                        {
                                                            value: "point",
                                                            label: t("scope_point")
                                                        }
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                                label: form.scopeType === "network" ? t("scope_network") : t("scope_point"),
                                                required: true,
                                                validateStatus: showFormErrors && formErrors.scope ? "error" : undefined,
                                                help: showFormErrors ? formErrors.scope : undefined,
                                                children: form.scopeType === "network" ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b6929c6a194abc34$export$2e2bcd8739ae039), {
                                                    entity: "network",
                                                    value: form.scope,
                                                    extraQuery: {
                                                        active: true
                                                    },
                                                    prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $f48fe90789d2a71a$export$2e2bcd8739ae039), {}),
                                                    onChange: (option)=>setField("scope", option)
                                                }) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b6929c6a194abc34$export$2e2bcd8739ae039), {
                                                    entity: "point",
                                                    value: form.scope,
                                                    prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $a1f80a723f71d713$export$2e2bcd8739ae039), {}),
                                                    onChange: (option)=>setField("scope", option)
                                                })
                                            })
                                        ]
                                    }) : null,
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $b4fda840b736e640$export$2e2bcd8739ae039), {
                                        className: "dp-section",
                                        variant: "outlined",
                                        children: [
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                                                className: "dp-sec-head",
                                                children: [
                                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("h2", {
                                                        className: "dp-sec-title",
                                                        children: t("sec_file")
                                                    }),
                                                    kind.columns.some((column)=>column.type === "date") ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("p", {
                                                        className: "dp-sec-desc",
                                                        children: (0, $3b579ca6158bc61b$export$9563e054e6f787fb)(t("date_format_hint"), {
                                                            f: (0, $d2f98770df1a68b1$export$45c85543ba71221d)
                                                        })
                                                    }) : null
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $b615b6e60c753ce5$export$2e2bcd8739ae039).Dragger, {
                                                className: "im-drop",
                                                accept: kind.accept,
                                                maxCount: 1,
                                                multiple: false,
                                                showUploadList: false,
                                                disabled: reading,
                                                /* `false` keeps antd from posting the file anywhere: it is parsed in the browser
                   and only the resulting rows are ever sent. */ beforeUpload: (picked)=>{
                                                    takeFile(picked);
                                                    return false;
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("p", {
                                                        className: "im-drop__icon",
                                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $268dc9f9b8c7fd21$export$2e2bcd8739ae039), {})
                                                    }),
                                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("p", {
                                                        className: "im-drop__title",
                                                        children: reading ? t("reading") : t("drop_hint")
                                                    }),
                                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("p", {
                                                        className: "im-drop__sub",
                                                        children: t("drop_sub")
                                                    })
                                                ]
                                            }),
                                            file ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                                className: "im-file",
                                                align: "center",
                                                gap: "small",
                                                wrap: true,
                                                children: [
                                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $602120e6d17ff12a$export$2e2bcd8739ae039), {
                                                        children: file.name
                                                    }),
                                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                                        type: "text",
                                                        size: "small",
                                                        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5234c28d879e38c1$export$2e2bcd8739ae039), {}),
                                                        onClick: clearRows,
                                                        children: t("file_remove")
                                                    })
                                                ]
                                            }) : null,
                                            fileError ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Paragraph, {
                                                className: "im-fileerror",
                                                role: "alert",
                                                children: fileError
                                            }) : null,
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                                className: "im-cols",
                                                vertical: true,
                                                gap: 4,
                                                children: [
                                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                                        type: "secondary",
                                                        children: t("expected_columns")
                                                    }),
                                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $eb1133c43d00490b$export$2e2bcd8739ae039), {
                                                        size: [
                                                            6,
                                                            6
                                                        ],
                                                        wrap: true,
                                                        children: kind.key === "assortment_matrix" ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                                            type: "secondary",
                                                            className: "im-cols__note",
                                                            children: t("kind_matrix_desc")
                                                        }) : kind.columns.map((column)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $602120e6d17ff12a$export$2e2bcd8739ae039), {
                                                                className: "im-col",
                                                                children: [
                                                                    t(column.label),
                                                                    column.required ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                                                        className: "im-col__req",
                                                                        children: " *"
                                                                    }) : null
                                                                ]
                                                            }, column.key))
                                                    }),
                                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                                            size: "small",
                                                            icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $a8f7d355c4714d40$export$2e2bcd8739ae039), {}),
                                                            onClick: ()=>(0, $21ef098471e9fbe6$export$c6d851d1877b46af)((0, $d2f98770df1a68b1$export$3579ae33990db395)(kind, t), `${kind.key}-template.csv`),
                                                            children: t("download_template")
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $b4fda840b736e640$export$2e2bcd8739ae039), {
                                className: "dp-section",
                                variant: "outlined",
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                                        className: "dp-sec-head",
                                        children: [
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("h2", {
                                                className: "dp-sec-title",
                                                children: t("sec_rows")
                                            }),
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("p", {
                                                className: "dp-sec-desc",
                                                children: t("sec_rows_desc")
                                            })
                                        ]
                                    }),
                                    checked.length ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                        className: "im-rows__bar",
                                        align: "center",
                                        gap: "small",
                                        wrap: true,
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $602120e6d17ff12a$export$2e2bcd8739ae039).CheckableTag, {
                                            checked: onlyBad,
                                            onChange: setOnlyBad,
                                            children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $eb1133c43d00490b$export$2e2bcd8739ae039), {
                                                size: 6,
                                                children: [
                                                    t("only_problems"),
                                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                                        className: "lp-num",
                                                        children: badCount
                                                    })
                                                ]
                                            })
                                        })
                                    }) : null,
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $dff4d45d201c6dfe$export$2e2bcd8739ae039), {
                                        className: "lp-table__grid im-rows",
                                        rowKey: "key",
                                        size: "middle",
                                        columns: columns,
                                        dataSource: visible,
                                        scroll: {
                                            x: tableWidth,
                                            y: scrollY
                                        },
                                        rowClassName: (row)=>Object.keys(row.errors).length ? "lp-row im-row--bad" : "lp-row",
                                        /* A spreadsheet of a few thousand rows is ordinary here, and antd does not
                 virtualise — without a page size the preview alone would put every one of them in
                 the DOM. The problems stay reachable through the filter above. */ pagination: {
                                            pageSize: 50,
                                            showSizeChanger: false,
                                            size: "small",
                                            hideOnSinglePage: true
                                        },
                                        locale: {
                                            emptyText: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $99350450b877904c$export$2e2bcd8739ae039), {
                                                image: (0, $99350450b877904c$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE,
                                                description: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                                    vertical: true,
                                                    gap: 8,
                                                    align: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                                            strong: true,
                                                            children: t("rows_empty_title")
                                                        }),
                                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                                            type: "secondary",
                                                            children: kind.editable ? t("rows_empty_desc") : t("rows_empty_file_desc")
                                                        })
                                                    ]
                                                })
                                            })
                                        }
                                    }),
                                    kind.editable ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                        className: "im-rows__foot",
                                        align: "center",
                                        gap: "small",
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                            icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $fa25166ced813feb$export$2e2bcd8739ae039), {}),
                                            onClick: ()=>setRows((prev)=>[
                                                        ...prev,
                                                        $f00aa72c5a7b810e$var$withKey(kind.emptyRow())
                                                    ]),
                                            children: t("add_row")
                                        })
                                    }) : null
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("aside", {
                        className: "dp-rail",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $b4fda840b736e640$export$2e2bcd8739ae039), {
                                className: "dp-card",
                                variant: "outlined",
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                        strong: true,
                                        children: t("rail_summary")
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                        className: "im-facts",
                                        gap: "middle",
                                        wrap: true,
                                        children: [
                                            [
                                                "n_parsed",
                                                checked.length
                                            ],
                                            [
                                                "n_ok",
                                                okRows.length
                                            ],
                                            [
                                                "n_problems",
                                                badCount
                                            ]
                                        ].map(([key, value])=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                                vertical: true,
                                                className: `im-fact ${key === "n_problems" && value ? "im-fact--bad" : ""}`,
                                                children: [
                                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                                        className: "im-fact__n",
                                                        children: value
                                                    }),
                                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                                        type: "secondary",
                                                        className: "im-fact__label",
                                                        children: t(key)
                                                    })
                                                ]
                                            }, key))
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Paragraph, {
                                        type: "secondary",
                                        className: "im-hint",
                                        children: t("server_checks_hint")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $b4fda840b736e640$export$2e2bcd8739ae039), {
                                className: "dp-card",
                                variant: "outlined",
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                        strong: true,
                                        children: t("rail_target")
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $47da64cf901a0567$export$2e2bcd8739ae039), {
                                        className: "im-target",
                                        column: 1,
                                        size: "small",
                                        colon: false,
                                        children: [
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $47da64cf901a0567$export$2e2bcd8739ae039).Item, {
                                                label: t("f_name"),
                                                children: form.name.trim() || /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                                    className: "lp-dash",
                                                    children: "\u2014"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $47da64cf901a0567$export$2e2bcd8739ae039).Item, {
                                                label: t("kind_label"),
                                                children: t(kind.label)
                                            }),
                                            kind.needsTemplate ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $47da64cf901a0567$export$2e2bcd8739ae039).Item, {
                                                label: td("template"),
                                                children: form.template?.name || form.template?.label || /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                                    className: "lp-dash",
                                                    children: "\u2014"
                                                })
                                            }) : null,
                                            kind.needsScope ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $47da64cf901a0567$export$2e2bcd8739ae039).Item, {
                                                label: form.scopeType === "network" ? t("scope_network") : t("scope_point"),
                                                children: form.scope?.name || form.scope?.label || /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                                    className: "lp-dash",
                                                    children: "\u2014"
                                                })
                                            }) : null
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    rows.length > 0 ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                        className: "dp-savebar",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                                className: "dp-savebar__msg",
                                children: [
                                    badCount ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $bdfb1f797481a352$export$2e2bcd8739ae039), {}) : null,
                                    t("n_ok"),
                                    ": ",
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                        className: "lp-num",
                                        children: okRows.length
                                    }),
                                    " / ",
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                        className: "lp-num",
                                        children: checked.length
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                                className: "dp-savebar__acts",
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                        onClick: clearRows,
                                        children: t("cancel")
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                        type: "primary",
                                        loading: submitting,
                                        disabled: !okRows.length,
                                        onClick: submit,
                                        children: t("submit")
                                    })
                                ]
                            })
                        ]
                    }) : null
                ]
            })
        ]
    });
};
var $f00aa72c5a7b810e$export$2e2bcd8739ae039 = $f00aa72c5a7b810e$var$Import;


/* /uploads — every import and how it went.
 *
 * Tab 3 of the old `tasks-import` screen, which was a bare `<table>` with hand-rolled prev/next
 * buttons and `if (!uploadLogs.length) return null` — so a manager who had never imported anything
 * got a blank page with no explanation, and one who had could not search, filter or sort.
 *
 * spec/03 archetype A, on the shared chrome (`lp-*`, `table-cells.js`, `PeriodPicker`), with two
 * deliberate absences:
 *
 * - **No `<Segmented>`.** The endpoint cannot filter by status, so the state is a per-row glyph.
 *   Counts are not the missing piece: the number beside a filter was removed app-wide, and the
 *   `_segment_counts`/`status_counts` the other lists once carried are gone from picsell-api too.
 * - **No bulk bar.** There is no bulk endpoint, and the only row action is destructive.
 *
 * This page is the other half of `/import`: both `tasks/bulk_create/` and
 * `assortment_matrix/bulk_create/` answer `{action, status: "pending"}` and hand off to Celery, so
 * this is the only place the outcome of an import can honestly be read.
 */ 

var $cQmXV = parcelRequire("cQmXV");









/* `Action.logs` → one list of rows, whatever shape the server actually sent.
 *
 * There are FIVE shapes in production and the old page handled one and a half of them. Reading
 * them from picsell-api rather than guessing:
 *
 * 1. `{invalid_tasks: [{title, description, start, end, point, network, images, validation_error}]}`
 *    — the point path (`tasks/services/task_services.py`). `validation_error` is a DICT, either
 *    `{field: [messages]}` from a Django ValidationError or the catch-all `{error: "<str>"}`.
 * 2. `{invalid_tasks: ["title", "description", "start", …]}` — the NETWORK path. The worker writes
 *    `logs = {'invalid_tasks': {…a dict…}}` (`tasks/tasks.py`), and `ActionSerializer.get_logs`
 *    then does `list += dict`, which iterates the dict's KEYS. So a failed network import
 *    serialises as an array of field-name strings and every `.title` on it is `undefined`. It also
 *    records only the first failure regardless of how many points failed.
 * 3. `{invalid_matrices: [{point, products: [], validation_error: "<str>"}]}` — here
 *    `validation_error` is a plain STRING, not the dict it is on the task side.
 * 4. `{fail_reason: "<str>"}` — written straight onto the Action when the fan-out itself throws
 *    (`points/api/web/v1/views.py`). Undocumented and previously unhandled.
 * 5. `{}` — success, and also "this action spawned no DelayedTask rows at all". The two are
 *    indistinguishable through the API.
 *
 * Shape 2 is lossy at the source: the record is gone before it reaches us, so it is reported as
 * such rather than rendered as a table of `undefined`s.
 */ /** `validation_error` in either of its two forms, as one line of text. */ function $ff50e3f85e276894$export$2ebc84e491ffd2ae(error) {
    if (!error) return "";
    if (typeof error === "string") return error;
    if (typeof error !== "object") return String(error);
    /* The catch-all wrapper carries nothing but the message. */ if (typeof error.error === "string" && Object.keys(error).length === 1) return error.error;
    return Object.entries(error).map(([field, messages])=>`${field}: ${[].concat(messages).join(", ")}`).join("; ");
}
function $ff50e3f85e276894$export$40da4038418ee641(action) {
    const logs = action?.logs;
    if (!logs || typeof logs !== "object" || Array.isArray(logs)) return {
        kind: "none",
        rows: []
    };
    if (typeof logs.fail_reason === "string" && logs.fail_reason.trim()) return {
        kind: "message",
        rows: [
            {
                key: "fail",
                reason: logs.fail_reason
            }
        ]
    };
    if (logs.invalid_tasks) {
        const list = Array.isArray(logs.invalid_tasks) ? logs.invalid_tasks : [
            logs.invalid_tasks
        ];
        const records = list.filter((item)=>item && typeof item === "object" && !Array.isArray(item));
        if (!records.length) return {
            kind: list.length ? "opaque" : "none",
            rows: []
        };
        return {
            kind: "tasks",
            rows: records.map((item, index)=>({
                    key: `t${index}`,
                    title: item.title || "",
                    description: item.description || "",
                    /* `str()` of whatever arrived, so these are not reliably dates — shown verbatim. */ start: item.start || "",
                    end: item.end || "",
                    point: item.point || "",
                    network: item.network || "",
                    reason: $ff50e3f85e276894$export$2ebc84e491ffd2ae(item.validation_error)
                }))
        };
    }
    if (logs.invalid_matrices) {
        const list = Array.isArray(logs.invalid_matrices) ? logs.invalid_matrices : [
            logs.invalid_matrices
        ];
        const records = list.filter((item)=>item && typeof item === "object" && !Array.isArray(item));
        if (!records.length) return {
            kind: list.length ? "opaque" : "none",
            rows: []
        };
        return {
            kind: "matrices",
            rows: records.map((item, index)=>({
                    key: `m${index}`,
                    point: item.point || "",
                    products: Array.isArray(item.products) ? item.products : [],
                    reason: $ff50e3f85e276894$export$2ebc84e491ffd2ae(item.validation_error)
                }))
        };
    }
    return {
        kind: "none",
        rows: []
    };
}
const $ff50e3f85e276894$export$e62a86a95c866d0 = (action)=>$ff50e3f85e276894$export$40da4038418ee641(action).kind !== "none";
function $ff50e3f85e276894$export$6993d6181580d6f8(action, t) {
    const { kind: kind, rows: rows } = $ff50e3f85e276894$export$40da4038418ee641(action);
    if (kind === "tasks") return [
        [
            t("col_title"),
            t("col_description"),
            t("col_start"),
            t("col_end"),
            t("col_point"),
            t("col_network"),
            t("col_reason")
        ],
        ...rows.map((row)=>[
                row.title,
                row.description,
                row.start,
                row.end,
                row.point,
                row.network,
                row.reason
            ])
    ];
    if (kind === "matrices") return [
        [
            t("col_point"),
            t("col_products"),
            t("col_reason")
        ],
        ...rows.map((row)=>[
                row.point,
                row.products.join(" "),
                row.reason
            ])
    ];
    if (kind === "message") return [
        [
            t("col_reason")
        ],
        [
            rows[0].reason
        ]
    ];
    return [];
}







const $7cdeb4e07eb0c872$var$PAGE_SIZES = [
    10,
    20,
    50,
    100
];
/** Widest period the list will accept, matching `/answers` and `/task`. */ const $7cdeb4e07eb0c872$var$MAX_RANGE_DAYS = 90;
/* `Action.Type` — there are exactly two, and no code path produces a third. */ const $7cdeb4e07eb0c872$var$TYPES = [
    [
        "TASKS_CREATION",
        "type_tasks"
    ],
    [
        "ASSORTMENT_MATRIX_CREATION",
        "type_matrix"
    ]
];
/* `Action.STATUS`, in the order a batch moves through it. */ const $7cdeb4e07eb0c872$var$STATUSES = [
    [
        "received",
        "st_received"
    ],
    [
        "pending",
        "st_pending"
    ],
    [
        "done",
        "st_done"
    ],
    [
        "failed",
        "st_failed"
    ],
    [
        "deleted",
        "st_deleted"
    ]
];
/* Tone per state. `deleted` is `off` — the import's data was removed on purpose, which is a
   resting state, not a fault. */ const $7cdeb4e07eb0c872$var$STATUS_ICON = {
    received: {
        Icon: (0, $7b23ac4854de9809$export$2e2bcd8739ae039),
        tone: "wait",
        key: "st_received"
    },
    pending: {
        Icon: (0, $7b23ac4854de9809$export$2e2bcd8739ae039),
        tone: "wait",
        key: "st_pending"
    },
    done: {
        Icon: (0, $45839ed7c4a7faa2$export$2e2bcd8739ae039),
        tone: "ok",
        key: "st_done"
    },
    failed: {
        Icon: (0, $bdfb1f797481a352$export$2e2bcd8739ae039),
        tone: "no",
        key: "st_failed"
    },
    deleted: {
        Icon: (0, $4d7cc9843b581604$export$2e2bcd8739ae039),
        tone: "off",
        key: "st_deleted"
    }
};
/** Column key → the field the API orders on. A key missing here is NOT sortable. */ const $7cdeb4e07eb0c872$var$ORDERING = {
    name: "name",
    type: "type",
    created: "created",
    status: "status"
};
const $7cdeb4e07eb0c872$var$FIELD_COL = {
    xs: {
        flex: "0 0 100%"
    },
    sm: {
        flex: "0 0 50%"
    },
    lg: {
        flex: "0 0 25%"
    }
};
const $7cdeb4e07eb0c872$var$isoDay = (date)=>(0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)(date).format("YYYY-MM-DD");
/** Still moving, so the list is worth re-reading. */ const $7cdeb4e07eb0c872$var$isRunning = (row)=>row?.status === "pending" || row?.status === "received";
/** How often to re-read while anything is still processing. */ const $7cdeb4e07eb0c872$var$POLL_MS = 5000;
function $7cdeb4e07eb0c872$export$d7b58f10109feb02({ term: term, type: type, status: status, range: range, page: page, size: size, sort: sort }) {
    const params = new URLSearchParams();
    const period = (0, $cc63266e8518a62e$export$e9d4863bcce07ce9)(range, $7cdeb4e07eb0c872$var$MAX_RANGE_DAYS);
    params.set("page", String(page));
    params.set("page_size", String(size));
    if (term.trim()) params.set("search", term.trim());
    if (type) params.set("type", type);
    if (status) params.set("status", status);
    /* Plain dates on both ends, inclusive — the filter compares `created__date`, so the picked last
     day is included rather than cut off at its midnight. */ if (period?.[0]) params.set("created_after", $7cdeb4e07eb0c872$var$isoDay(period[0]));
    if (period?.[1]) params.set("created_before", $7cdeb4e07eb0c872$var$isoDay(period[1]));
    if (sort) params.set("ordering", `${sort.dir === "descend" ? "-" : ""}${$7cdeb4e07eb0c872$var$ORDERING[sort.key]}`);
    return params.toString();
}
const $7cdeb4e07eb0c872$var$Uploads = ()=>{
    const history = (0, $6f5d68f762d5488a$export$3420e1dc2c4a518c)();
    const location = (0, $6f5d68f762d5488a$export$45d76561a5302f2b)();
    const lang = (0, $b83e93e5ef3de8b0$export$2105062e25df4afe)((state)=>state.me?.language) || "en";
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$a763edbf796b780a), key, lang);
    const td = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), key, lang);
    const tp = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b8441a9a81ffc5d6), key, lang);
    /* The action just submitted, handed over by `/import`. Read once: it marks a row, it is not
     state the page maintains. */ const justNew = (0, $cQmXV.useRef)(new URLSearchParams(location.search).get("new")).current;
    const [term, setTerm] = (0, $cQmXV.useState)("");
    const [search, setSearch] = (0, $cQmXV.useState)("");
    const [type, setType] = (0, $cQmXV.useState)(null);
    const [status, setStatus] = (0, $cQmXV.useState)(null);
    const [range, setRangeState] = (0, $cQmXV.useState)((0, $cc63266e8518a62e$export$33e9fd85c7cf1b3c));
    const setRange = (next)=>setRangeState((0, $cc63266e8518a62e$export$e9d4863bcce07ce9)(next, $7cdeb4e07eb0c872$var$MAX_RANGE_DAYS) || (0, $cc63266e8518a62e$export$33e9fd85c7cf1b3c)());
    const [page, setPage] = (0, $cQmXV.useState)(1);
    const [size, setSize] = (0, $cQmXV.useState)($7cdeb4e07eb0c872$var$PAGE_SIZES[0]);
    const [sort, setSort] = (0, $cQmXV.useState)(null);
    const [rows, setRows] = (0, $cQmXV.useState)([]);
    const [total, setTotal] = (0, $cQmXV.useState)(0);
    const [loading, setLoading] = (0, $cQmXV.useState)(true);
    const [failed, setFailed] = (0, $cQmXV.useState)(false);
    /* The action whose error log is open, or null. */ const [showing, setShowing] = (0, $cQmXV.useState)(null);
    /* Bumped to force a refetch without changing the query. */ const [tick, setTick] = (0, $cQmXV.useState)(0);
    const filtered = Boolean(search.trim() || type || status);
    const query = (0, $cQmXV.useMemo)(()=>$7cdeb4e07eb0c872$export$d7b58f10109feb02({
            term: search,
            type: type,
            status: status,
            range: range,
            page: page,
            size: size,
            sort: sort
        }), [
        search,
        type,
        status,
        range,
        page,
        size,
        sort
    ]);
    (0, $cQmXV.useEffect)(()=>{
        const controller = new AbortController();
        setLoading(true);
        (0, $c9936523dc38c641$export$86557ef9e0794d10)(`actions/?${query}`, controller.signal).then((response)=>{
            if (!response) return;
            setRows(response.results || []);
            setTotal(response.count || 0);
            setFailed(false);
            setLoading(false);
        }).catch((error)=>{
            if (error.name === "AbortError") return;
            setRows([]);
            setTotal(0);
            setFailed(true);
            setLoading(false);
        });
        return ()=>controller.abort();
    }, [
        query,
        tick
    ]);
    /* Only the free-text field is debounced; every other control applies on change. */ (0, $cQmXV.useEffect)(()=>{
        if (term === search) return;
        const timer = setTimeout(()=>{
            setPage(1);
            setSearch(term);
        }, 250);
        return ()=>clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        term
    ]);
    /* Re-read while anything on the loaded page is still processing, and stop the moment nothing is.
     Landing here straight from an import is the case this exists for — otherwise the row you were
     sent to look at sits on "Processing" until you reload by hand.

     ⚠ Until picsell-api stops deriving the status on read, every row reads `done` immediately and
     this simply never runs. That is harmless, and it starts working when the fix ships. */ (0, $cQmXV.useEffect)(()=>{
        if (!rows.some($7cdeb4e07eb0c872$var$isRunning)) return;
        const timer = setTimeout(()=>setTick((value)=>value + 1), $7cdeb4e07eb0c872$var$POLL_MS);
        return ()=>clearTimeout(timer);
    }, [
        rows
    ]);
    const narrow = (fn)=>(...args)=>{
            setPage(1);
            fn(...args);
        };
    const resetFilters = narrow(()=>{
        setTerm("");
        setSearch("");
        setType(null);
        setStatus(null);
        setRange((0, $cc63266e8518a62e$export$33e9fd85c7cf1b3c)());
        setSort(null);
    });
    /* ------------------------------------------------------------- row actions */ const removeData = (row)=>{
        /* This HARD-DELETES the tasks or assortment matrices the import created; only the upload
       record itself survives. The screen this replaces fired it straight off a trash button with
       no confirmation at all.

       `Modal.confirm` is a static call — it renders outside the tree and does not inherit
       AppShell's `ConfigProvider locale`, so the button labels are passed explicitly or they stay
       English. The confirm names WHAT is going and the button carries the verb (spec/03, spec/04). */ (0, $05a90c67d3627fd9$export$2e2bcd8739ae039).confirm({
            title: t("delete_data"),
            icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $798c0df65ce199b6$export$2e2bcd8739ae039), {}),
            content: (0, $3b579ca6158bc61b$export$9563e054e6f787fb)((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$a763edbf796b780a), row.type === "ASSORTMENT_MATRIX_CREATION" ? "delete_confirm_matrix" : "delete_confirm_tasks", lang), {
                name: row.name?.trim() || "\u2014"
            }),
            okText: t("delete_data"),
            okButtonProps: {
                danger: true
            },
            cancelText: t("cancel"),
            onOk: ()=>new Promise((resolve)=>{
                    (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
                        method: "DELETE",
                        url: `actions/${row.id}/delete_action_data/`
                    }, ()=>{
                        (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success(t("deleted_msg"), {
                            position: "top-right"
                        });
                        /* The row is not removed server-side — its status becomes `deleted` — so the page is
               re-read rather than patched. */ setTick((value)=>value + 1);
                        resolve();
                    });
                })
        });
    };
    const exportLogs = (row)=>{
        const stamp = row.created ? (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)(row.created).format("YYYY-MM-DD-HHmm") : "upload";
        (0, $21ef098471e9fbe6$export$c6d851d1877b46af)((0, $ff50e3f85e276894$export$6993d6181580d6f8)(row, t), `${stamp}-errors.csv`);
    };
    /* ---------------------------------------------------------------- columns */ const dateFmt = (0, $cQmXV.useMemo)(()=>new Intl.DateTimeFormat((0, $7d0f78de0b68a104$export$bd7bed267fc278f2)(lang), {
            day: "2-digit",
            month: "short",
            hour: "2-digit",
            minute: "2-digit"
        }), [
        lang
    ]);
    const columns = (0, $cQmXV.useMemo)(()=>[
            (0, $66539b2560a58e4e$export$81ff514f95f0c424)((value, row)=>{
                const state = $7cdeb4e07eb0c872$var$STATUS_ICON[row.status] || $7cdeb4e07eb0c872$var$STATUS_ICON.received;
                return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $66539b2560a58e4e$export$b131c49b26d3f427), {
                    Icon: state.Icon,
                    tone: state.tone,
                    label: t(state.key)
                });
            }),
            {
                key: "name",
                title: t("u_col_name"),
                width: 320,
                fixed: "left",
                ellipsis: true,
                sorter: true,
                render: (value, row)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $66539b2560a58e4e$export$2692b073ef5fee01), {
                        title: row.name,
                        sub: row.id === justNew ? t("new_row") : null
                    })
            },
            {
                key: "type",
                title: t("u_col_type"),
                width: 220,
                ellipsis: true,
                sorter: true,
                render: (value, row)=>{
                    const known = $7cdeb4e07eb0c872$var$TYPES.find(([key])=>key === row.type);
                    return known ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $602120e6d17ff12a$export$2e2bcd8739ae039), {
                        children: t(known[1])
                    }) : (0, $66539b2560a58e4e$export$eb03490a10c3abc9);
                }
            },
            {
                key: "created",
                title: t("u_col_created"),
                width: 180,
                sorter: true,
                render: (value, row)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "lp-num",
                        children: row.created ? dateFmt.format(new Date(row.created)) : "\u2014"
                    })
            },
            {
                key: "errors",
                title: t("u_col_errors"),
                width: 170,
                render: (value, row)=>{
                    if (!(0, $ff50e3f85e276894$export$e62a86a95c866d0)(row)) return 0, $66539b2560a58e4e$export$eb03490a10c3abc9;
                    const { kind: kind, rows: logRows } = (0, $ff50e3f85e276894$export$40da4038418ee641)(row);
                    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                        type: "link",
                        size: "small",
                        onClick: ()=>setShowing(row),
                        children: kind === "opaque" ? t("view_logs") : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                            className: "lp-num",
                            children: logRows.length
                        })
                    });
                }
            },
            (0, $66539b2560a58e4e$export$b0493221521ca587)((value, row)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $66539b2560a58e4e$export$523acc1bb0ce2e43), {
                    label: t("row_actions"),
                    items: [
                        ...(0, $ff50e3f85e276894$export$e62a86a95c866d0)(row) ? [
                            {
                                key: "logs",
                                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $798c0df65ce199b6$export$2e2bcd8739ae039), {}),
                                label: t("view_logs")
                            }
                        ] : [],
                        ...(0, $ff50e3f85e276894$export$e62a86a95c866d0)(row) ? [
                            {
                                key: "csv",
                                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $a8f7d355c4714d40$export$2e2bcd8739ae039), {}),
                                label: t("download_logs")
                            }
                        ] : [],
                        ...row.status !== "deleted" ? [
                            {
                                key: "remove",
                                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $4d7cc9843b581604$export$2e2bcd8739ae039), {}),
                                label: t("delete_data"),
                                danger: true
                            }
                        ] : []
                    ],
                    onClick: (key)=>{
                        if (key === "logs") return setShowing(row);
                        if (key === "csv") return exportLogs(row);
                        removeData(row);
                    }
                }))
        ], // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        lang,
        dateFmt,
        justNew
    ]);
    const scrollY = (0, $66539b2560a58e4e$export$f44b992e82788e9)();
    /* ------------------------------------------------------------- error log */ const opened = showing ? (0, $ff50e3f85e276894$export$40da4038418ee641)(showing) : null;
    const logColumns = (0, $cQmXV.useMemo)(()=>{
        if (opened?.kind === "matrices") return [
            {
                key: "point",
                dataIndex: "point",
                title: t("col_point"),
                width: 180,
                ellipsis: true
            },
            {
                key: "products",
                title: t("col_products"),
                width: 100,
                align: "right",
                render: (value, row)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "lp-num",
                        children: row.products.length
                    })
            },
            {
                key: "reason",
                dataIndex: "reason",
                title: t("col_reason"),
                ellipsis: true,
                className: "up-logs__reason"
            }
        ];
        return [
            {
                key: "title",
                dataIndex: "title",
                title: t("col_title"),
                width: 200,
                ellipsis: true
            },
            {
                key: "point",
                dataIndex: "point",
                title: t("col_point"),
                width: 130,
                ellipsis: true
            },
            {
                key: "network",
                dataIndex: "network",
                title: t("col_network"),
                width: 130,
                ellipsis: true
            },
            {
                key: "start",
                dataIndex: "start",
                title: t("col_start"),
                width: 130,
                ellipsis: true
            },
            {
                key: "end",
                dataIndex: "end",
                title: t("col_end"),
                width: 130,
                ellipsis: true
            },
            {
                key: "reason",
                dataIndex: "reason",
                title: t("col_reason"),
                width: 260,
                ellipsis: true,
                className: "up-logs__reason"
            }
        ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        opened?.kind,
        lang
    ]);
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
        vertical: true,
        gap: "middle",
        className: "shell-content lp up",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                className: "lp-head",
                justify: "space-between",
                align: "flex-end",
                gap: "middle",
                wrap: true,
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                        vertical: true,
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Title, {
                                level: 1,
                                className: "lp-title",
                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$72266474e9355649), "my_uploads", lang)
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Paragraph, {
                                type: "secondary",
                                className: "lp-sub",
                                children: t("uploads_sub")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                        type: "primary",
                        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $08a66dd72a6d5552$export$2e2bcd8739ae039), {}),
                        onClick: ()=>history.push("/import"),
                        children: t("page_title")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b4fda840b736e640$export$2e2bcd8739ae039), {
                className: "lp-filters",
                variant: "outlined",
                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039), {
                    layout: "vertical",
                    component: false,
                    colon: false,
                    children: [
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $db6c3adada49524e$export$2e2bcd8739ae039), {
                            gutter: [
                                12,
                                12
                            ],
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $cde227eb983ae1d2$export$2e2bcd8739ae039), {
                                    ...$7cdeb4e07eb0c872$var$FIELD_COL,
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                        label: tp("period"),
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $cc63266e8518a62e$export$2e2bcd8739ae039), {
                                            value: range,
                                            onChange: narrow(setRange),
                                            maxDays: $7cdeb4e07eb0c872$var$MAX_RANGE_DAYS,
                                            clearTo: (0, $cc63266e8518a62e$export$33e9fd85c7cf1b3c)
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $cde227eb983ae1d2$export$2e2bcd8739ae039), {
                                    ...$7cdeb4e07eb0c872$var$FIELD_COL,
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                        label: t("f_type"),
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $872fd39f1285217b$export$2e2bcd8739ae039), {
                                            allowClear: true,
                                            value: type,
                                            onChange: narrow(setType),
                                            placeholder: t("f_type"),
                                            options: $7cdeb4e07eb0c872$var$TYPES.map(([value, key])=>({
                                                    value: value,
                                                    label: t(key)
                                                }))
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $cde227eb983ae1d2$export$2e2bcd8739ae039), {
                                    ...$7cdeb4e07eb0c872$var$FIELD_COL,
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                        label: t("f_status"),
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $872fd39f1285217b$export$2e2bcd8739ae039), {
                                            allowClear: true,
                                            value: status,
                                            onChange: narrow(setStatus),
                                            placeholder: t("f_status"),
                                            options: $7cdeb4e07eb0c872$var$STATUSES.map(([value, key])=>({
                                                    value: value,
                                                    label: t(key)
                                                }))
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $cde227eb983ae1d2$export$2e2bcd8739ae039), {
                                    ...$7cdeb4e07eb0c872$var$FIELD_COL,
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                        label: tp("search"),
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0883e7f8083c01b0$export$2e2bcd8739ae039), {
                                            allowClear: true,
                                            prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $20a259d46bffcb08$export$2e2bcd8739ae039), {}),
                                            placeholder: t("f_search_ph"),
                                            value: term,
                                            onChange: (event)=>setTerm(event.target.value)
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                            className: "lp-filters__foot",
                            align: "center",
                            gap: "small",
                            wrap: true,
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                    className: "lp-spacer"
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                    size: "small",
                                    icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $d27e4ec0a39831fe$export$2e2bcd8739ae039), {}),
                                    onClick: ()=>setTick((value)=>value + 1),
                                    children: t("refresh")
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                    size: "small",
                                    onClick: resetFilters,
                                    children: td("filter_reset")
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $b4fda840b736e640$export$2e2bcd8739ae039), {
                className: "lp-table",
                variant: "outlined",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                        className: "lp-table__bar",
                        align: "center",
                        gap: "small",
                        wrap: true,
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                strong: true,
                                className: "lp-table__title",
                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$72266474e9355649), "my_uploads", lang)
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                type: "secondary",
                                "aria-live": "polite",
                                children: [
                                    tp("records_count"),
                                    ": ",
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                        strong: true,
                                        children: total
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $dff4d45d201c6dfe$export$2e2bcd8739ae039), {
                        className: "lp-table__grid",
                        rowKey: "id",
                        size: "middle",
                        columns: columns,
                        dataSource: rows,
                        loading: loading,
                        scroll: {
                            x: 1100,
                            y: scrollY
                        },
                        rowClassName: (row)=>row.id === justNew ? "lp-row up-row--new" : "lp-row",
                        onChange: (pagination, filters, sorter)=>{
                            const next = sorter?.order && $7cdeb4e07eb0c872$var$ORDERING[sorter.columnKey] ? {
                                key: sorter.columnKey,
                                dir: sorter.order
                            } : null;
                            if (JSON.stringify(next) === JSON.stringify(sort)) return;
                            setSort(next);
                            setPage(1);
                        },
                        pagination: false,
                        locale: {
                            emptyText: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $99350450b877904c$export$2e2bcd8739ae039), {
                                image: (0, $99350450b877904c$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE,
                                description: /* Three different causes, three different offers — "nothing yet", "nothing
                     matches", and "the request failed" are not the same state (spec/03). */ /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                    vertical: true,
                                    gap: 8,
                                    align: "center",
                                    children: [
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                            strong: true,
                                            children: failed ? t("submit_failed") : filtered ? t("empty_filtered_title") : t("empty_title")
                                        }),
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                            type: "secondary",
                                            children: failed ? "" : filtered ? t("empty_filtered_desc") : t("empty_desc")
                                        }),
                                        failed ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                            size: "small",
                                            icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $d27e4ec0a39831fe$export$2e2bcd8739ae039), {}),
                                            onClick: ()=>setTick((value)=>value + 1),
                                            children: t("refresh")
                                        }) : filtered ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                            size: "small",
                                            onClick: resetFilters,
                                            children: td("filter_reset")
                                        }) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                            size: "small",
                                            type: "primary",
                                            onClick: ()=>history.push("/import"),
                                            children: t("go_import")
                                        })
                                    ]
                                })
                            })
                        }
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $66539b2560a58e4e$export$6cb97cd1ceda576d), {
                        id: "up",
                        page: page,
                        size: size,
                        total: total,
                        sizes: $7cdeb4e07eb0c872$var$PAGE_SIZES,
                        labels: {
                            perPage: t("rows_per_page"),
                            range: t("range_of")
                        },
                        onPage: setPage,
                        onSize: (next)=>{
                            setSize(next);
                            setPage(1);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $265dbad0185b5dfc$export$2e2bcd8739ae039), {
                open: Boolean(showing),
                onClose: ()=>setShowing(null),
                /* antd v6 deprecated `width` in favour of `size` (default 378 / large 736); the task log is
           six columns wide, so it scrolls inside its own table rather than widening the panel. */ size: "large",
                title: t("logs_title"),
                extra: showing && opened?.kind !== "opaque" ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                    size: "small",
                    icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $a8f7d355c4714d40$export$2e2bcd8739ae039), {}),
                    onClick: ()=>exportLogs(showing),
                    children: t("download_logs")
                }) : null,
                children: opened?.kind === "opaque" ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Paragraph, {
                    className: "up-logs__opaque",
                    children: t("logs_opaque")
                }) : opened?.kind === "message" ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Paragraph, {
                    className: "up-logs__reason",
                    children: opened.rows[0].reason
                }) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $dff4d45d201c6dfe$export$2e2bcd8739ae039), {
                    className: "lp-table__grid",
                    rowKey: "key",
                    size: "small",
                    columns: logColumns,
                    dataSource: opened?.rows || [],
                    scroll: {
                        x: 900
                    },
                    pagination: {
                        pageSize: 50,
                        showSizeChanger: false,
                        size: "small",
                        hideOnSinglePage: true
                    }
                })
            })
        ]
    });
};
var $7cdeb4e07eb0c872$export$2e2bcd8739ae039 = $7cdeb4e07eb0c872$var$Uploads;


/* Supervisors — who covers what.
   No mockup for this screen; `docs/design/merchandisers.html` is the visual reference for a
   people list, and the shape is spec/03 archetype A: page head → filter card → segments →
   table → sticky bulk bar.

   Built out of what already exists rather than new parts: `EntitySelect` for the region,
   `FilterChips` + `useLabelCache` for the applied-filter row, `getAbortable` for the request,
   and the same table/pagination/bulk-bar composition as `/visit`. The only new code here is the
   columns, the two derived filters, and the activate/deactivate call.

   The list's job is to answer an operational question, not to mirror the API (spec/03): a
   supervisor responsible for **no points** covers nothing, so that is a first-class filter,
   next to the active/inactive split.

   Everything narrows on the SERVER. `GET supervisors/` gained `county`, `is_active`, `no_points`
   and a `points_count` annotation in the same change (picsell-api
   `users/api/web/v1/filters.py`) — before it, the endpoint could only be searched and sorted, so
   a region filter here would have been decorative.

   ⚠ Route access is `supervisor_manager` only (`AppNav.MENU`), which is what makes deactivating
   a peer a manager action rather than something any supervisor can do to another. */ 

var $cQmXV = parcelRequire("cQmXV");












const $77c659030dd190f5$var$PAGE_SIZES = [
    25,
    50,
    100
];
const $77c659030dd190f5$var$SEGMENTS = [
    [
        "all",
        "seg_all"
    ],
    [
        "active",
        "seg_active"
    ],
    [
        "inactive",
        "seg_inactive"
    ]
];
/* Column key → the field the API orders on. A key missing here is not sortable. */ const $77c659030dd190f5$var$ORDERING = {
    name: "first_name",
    points: "points_count"
};
const $77c659030dd190f5$var$FIELD_COL = {
    xs: {
        flex: "0 0 100%"
    },
    md: {
        flex: "0 0 50%"
    },
    xl: {
        flex: "0 0 33.3333%"
    }
};
const $77c659030dd190f5$var$idOf = (v)=>v && typeof v === "object" ? v.id ?? v.value : v;
/** The request the table runs on — one place where the endpoint's parameter shape is visible. */ function $77c659030dd190f5$var$buildQuery({ search: search, county: county, segment: segment, noPoints: noPoints, page: page, size: size, sort: sort }) {
    const p = new URLSearchParams();
    p.set("page", String(page));
    p.set("page_size", String(size));
    if (search) p.set("search", search);
    if (county) p.set("county", String($77c659030dd190f5$var$idOf(county)));
    if (segment !== "all") p.set("is_active", segment === "active" ? "true" : "false");
    if (noPoints) p.set("no_points", "true");
    if (sort) p.set("ordering", `${sort.dir === "descend" ? "-" : ""}${$77c659030dd190f5$var$ORDERING[sort.key]}`);
    return p.toString();
}
/** URL ↔ state, so a filtered view is shareable and survives Back from a supervisor's page. */ function $77c659030dd190f5$var$stateToSearch({ search: search, county: county, segment: segment, noPoints: noPoints, page: page, size: size, sort: sort }) {
    const p = new URLSearchParams();
    if (search) p.set("q", search);
    if (county) p.set("county", String($77c659030dd190f5$var$idOf(county)));
    if (segment !== "all") p.set("segment", segment);
    if (noPoints) p.set("no_points", "1");
    if (page > 1) p.set("page", String(page));
    if (size !== $77c659030dd190f5$var$PAGE_SIZES[0]) p.set("size", String(size));
    if (sort) p.set("sort", `${sort.dir === "descend" ? "-" : ""}${sort.key}`);
    return p.toString();
}
function $77c659030dd190f5$var$searchToState(locationSearch, me) {
    const p = new URLSearchParams(locationSearch);
    const sort = p.get("sort");
    const hasFilters = Boolean(locationSearch && locationSearch.replace(/^\?/, ""));
    return {
        search: p.get("q") || "",
        /* Without a URL to restore, the manager's own region is the sensible default scope — the
       same seeding the visits list does. */ county: p.get("county") || (hasFilters ? "" : (0, $3b579ca6158bc61b$export$6339e4f5afb1eeb0)(me) || ""),
        segment: $77c659030dd190f5$var$SEGMENTS.some(([value])=>value === p.get("segment")) ? p.get("segment") : "all",
        noPoints: p.get("no_points") === "1",
        page: Math.max(1, Number(p.get("page")) || 1),
        size: $77c659030dd190f5$var$PAGE_SIZES.includes(Number(p.get("size"))) ? Number(p.get("size")) : $77c659030dd190f5$var$PAGE_SIZES[0],
        sort: sort && $77c659030dd190f5$var$ORDERING[sort.replace(/^-/, "")] ? {
            key: sort.replace(/^-/, ""),
            dir: sort[0] === "-" ? "descend" : "ascend"
        } : null
    };
}
const $77c659030dd190f5$var$List = ()=>{
    const history = (0, $6f5d68f762d5488a$export$3420e1dc2c4a518c)();
    const location = (0, $6f5d68f762d5488a$export$45d76561a5302f2b)();
    const me = (0, $b83e93e5ef3de8b0$export$2105062e25df4afe)((state)=>state.me);
    const lang = me?.language || "en";
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$fbb7ce4dc3b38367), key, lang);
    const td = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), key, lang);
    const tp = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b8441a9a81ffc5d6), key, lang);
    const tv = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), key, lang);
    /* Read once. After mount this component owns the state and writes the URL, not the reverse. */ const initial = (0, $cQmXV.useRef)($77c659030dd190f5$var$searchToState(location.search, me)).current;
    const [search, setSearch] = (0, $cQmXV.useState)(initial.search);
    const [county, setCounty] = (0, $cQmXV.useState)(initial.county);
    const [segment, setSegment] = (0, $cQmXV.useState)(initial.segment);
    const [noPoints, setNoPoints] = (0, $cQmXV.useState)(initial.noPoints);
    const [page, setPage] = (0, $cQmXV.useState)(initial.page);
    const [size, setSize] = (0, $cQmXV.useState)(initial.size);
    const [sort, setSort] = (0, $cQmXV.useState)(initial.sort);
    /* The option object the region select handed back, so a chosen value labels itself. */ const [chosenCounty, setChosenCounty] = (0, $cQmXV.useState)(null);
    /* Typing is separate from the applied term: the field must not lag the keystroke while the
     request that the keystroke will eventually cause is still debounced. */ const [typed, setTyped] = (0, $cQmXV.useState)(initial.search);
    const [rows, setRows] = (0, $cQmXV.useState)([]);
    const [total, setTotal] = (0, $cQmXV.useState)(0);
    const [loading, setLoading] = (0, $cQmXV.useState)(true);
    const [selected, setSelected] = (0, $cQmXV.useState)([]);
    const [busy, setBusy] = (0, $cQmXV.useState)(false);
    /* --------------------------------------------------------------- fetch */ const query = (0, $cQmXV.useMemo)(()=>$77c659030dd190f5$var$buildQuery({
            search: search,
            county: county,
            segment: segment,
            noPoints: noPoints,
            page: page,
            size: size,
            sort: sort
        }), [
        search,
        county,
        segment,
        noPoints,
        page,
        size,
        sort
    ]);
    (0, $cQmXV.useEffect)(()=>{
        const controller = new AbortController();
        setLoading(true);
        (0, $c9936523dc38c641$export$86557ef9e0794d10)(`supervisors/?${query}`, controller.signal).then((response)=>{
            if (!response) return;
            setRows(response.results || []);
            setTotal(response.count || 0);
            setLoading(false);
        }).catch((error)=>{
            if (error.name === "AbortError") return;
            setRows([]);
            setTotal(0);
            setLoading(false);
        });
        return ()=>controller.abort();
    }, [
        query
    ]);
    /* 250ms, matching every other search box in the app: one request per pause, not per keystroke. */ (0, $cQmXV.useEffect)(()=>{
        if (typed === search) return undefined;
        const timer = setTimeout(()=>{
            setSearch(typed);
            setPage(1);
            setSelected([]);
        }, 250);
        return ()=>clearTimeout(timer);
    }, [
        typed,
        search
    ]);
    /* The URL trails the state; `replace` so filtering does not fill the history stack. */ (0, $cQmXV.useEffect)(()=>{
        const next = $77c659030dd190f5$var$stateToSearch({
            search: search,
            county: county,
            segment: segment,
            noPoints: noPoints,
            page: page,
            size: size,
            sort: sort
        });
        if (next !== location.search.replace(/^\?/, "")) history.replace({
            search: next
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        search,
        county,
        segment,
        noPoints,
        page,
        size,
        sort
    ]);
    /* Any narrowing invalidates the page number: page 7 of the old result set is usually past the
     end of the new one, which renders an empty table over a non-empty result. */ const narrow = (fn)=>(...args)=>{
            setPage(1);
            setSelected([]);
            fn(...args);
        };
    const resetFilters = narrow(()=>{
        setTyped("");
        setSearch("");
        setCounty("");
        setChosenCounty(null);
        setSegment("all");
        setNoPoints(false);
        setSort(null);
    });
    /* ---------------------------------------------------------------- chips */ const { labels: labels, remember: remember, nameFor: nameFor } = (0, $a9e321bb60aaf998$export$243aa1fcbfd1886a)();
    const chips = (0, $cQmXV.useMemo)(()=>{
        const out = [];
        if (search) out.push({
            key: "q",
            label: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$2cbd0be658ac061c), "search", lang),
            value: search
        });
        if (county) out.push({
            key: "county",
            label: td("region"),
            value: nameFor("county", chosenCounty ?? county)
        });
        if (noPoints) out.push({
            key: "no_points",
            label: t("no_points"),
            value: t("no_points_hint")
        });
        return out;
    /* `labels` is a dependency: a chip that arrived as a bare id has to re-render once its name
       lands from `EntitySelect`'s resolution. */ // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        search,
        county,
        chosenCounty,
        noPoints,
        labels,
        lang
    ]);
    const clearChip = narrow((key)=>{
        if (key === "q") {
            setTyped("");
            setSearch("");
        } else if (key === "county") {
            setCounty("");
            setChosenCounty(null);
        } else if (key === "no_points") setNoPoints(false);
    });
    /* ------------------------------------------------------ activate / deactivate */ const patchActive = (row, value)=>new Promise((resolve)=>{
            (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
                method: "PATCH",
                url: `supervisors/${row.id}/`,
                post: {
                    is_active: value
                }
            }, (response)=>resolve(Boolean(response)));
        });
    /* Rows are patched in place rather than refetched, so the table does not jump under the
     cursor. A row that no longer matches the active segment stays until the next fetch: its
     status has already changed, so it is showing the result of the action, not a stale state. */ const applyLocally = (ids, value)=>{
        setRows((prev)=>prev.map((row)=>ids.includes(row.id) ? {
                    ...row,
                    is_active: value
                } : row));
    };
    const runChange = async (targets, value)=>{
        if (!targets.length) {
            setSelected([]);
            return;
        }
        setBusy(true);
        const results = await Promise.all(targets.map((row)=>patchActive(row, value)));
        setBusy(false);
        const done = targets.filter((row, i)=>results[i]);
        if (done.length) {
            applyLocally(done.map((row)=>row.id), value);
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success((0, $3b579ca6158bc61b$export$9563e054e6f787fb)(t(value ? "activated_msg" : "deactivated_msg"), {
                n: done.length
            }), {
                position: "top-right"
            });
        }
        if (done.length < targets.length) (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).warning((0, $3b579ca6158bc61b$export$9563e054e6f787fb)(t("change_failed_msg"), {
            n: targets.length - done.length
        }), {
            position: "top-right"
        });
        setSelected([]);
    };
    /* Deactivation is destructive, so it is confirmed and the confirm says what and how many
     (spec/03). Activation is not, so it just runs. */ const changeSelected = (value)=>{
        const targets = rows.filter((row)=>selected.includes(row.id) && row.is_active !== value);
        if (value) {
            runChange(targets, true);
            return;
        }
        (0, $05a90c67d3627fd9$export$2e2bcd8739ae039).confirm({
            title: (0, $3b579ca6158bc61b$export$9563e054e6f787fb)(t("confirm_deactivate"), {
                n: targets.length
            }),
            okText: t("deactivate"),
            okButtonProps: {
                danger: true
            },
            cancelText: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f544127b46daf517), "cancel", lang),
            onOk: ()=>runChange(targets, false)
        });
    };
    const openSupervisor = (row)=>history.push(`/supervisors/${row.id}`);
    /* ------------------------------------------------------------- columns */ const columns = (0, $cQmXV.useMemo)(()=>[
            (0, $66539b2560a58e4e$export$81ff514f95f0c424)((value, row)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $66539b2560a58e4e$export$b131c49b26d3f427), {
                    Icon: row.is_active ? (0, $45839ed7c4a7faa2$export$2e2bcd8739ae039) : (0, $e539a200877e5e8f$export$2e2bcd8739ae039),
                    tone: row.is_active ? "ok" : "off",
                    label: t(row.is_active ? "status_active" : "status_inactive")
                })),
            {
                key: "name",
                title: td("supervisor"),
                width: 280,
                fixed: "left",
                ellipsis: true,
                sorter: true,
                render: (value, row)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $66539b2560a58e4e$export$8a3d0b92eb0904a5), {
                        user: row
                    })
            },
            {
                key: "phone",
                title: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ac552071080927b0), "f_phone", lang),
                dataIndex: "phone_number",
                width: 170,
                render: (value)=>value || (0, $66539b2560a58e4e$export$eb03490a10c3abc9)
            },
            {
                key: "region",
                title: td("region"),
                width: 200,
                ellipsis: true,
                render: (value, row)=>row.county_name || /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $1e5256cf9d329b2c$export$2e2bcd8739ae039), {
                        title: t("no_region"),
                        children: (0, $66539b2560a58e4e$export$eb03490a10c3abc9)
                    })
            },
            {
                key: "points",
                title: td("points"),
                dataIndex: "points_count",
                width: 130,
                align: "right",
                sorter: true,
                /* Zero is the signal the page is built around, so it is called out in words as well as
           colour — colour is never the only signal (spec/01). */ render: (value)=>value ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "lp-num",
                        children: value
                    }) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $1e5256cf9d329b2c$export$2e2bcd8739ae039), {
                        title: t("no_points_hint"),
                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $602120e6d17ff12a$export$2e2bcd8739ae039), {
                            className: "sv-tag--warn",
                            children: t("no_points")
                        })
                    })
            },
            (0, $66539b2560a58e4e$export$b0493221521ca587)((value, row)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $66539b2560a58e4e$export$523acc1bb0ce2e43), {
                    label: tv("row_actions"),
                    items: [
                        {
                            key: "open",
                            icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $357da3723e13ae38$export$2e2bcd8739ae039), {}),
                            label: t("open")
                        },
                        row.is_active ? {
                            key: "deactivate",
                            icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e539a200877e5e8f$export$2e2bcd8739ae039), {}),
                            label: t("deactivate"),
                            danger: true
                        } : {
                            key: "activate",
                            icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $45839ed7c4a7faa2$export$2e2bcd8739ae039), {}),
                            label: t("activate")
                        }
                    ],
                    onClick: (key)=>{
                        if (key === "open") openSupervisor(row);
                        else if (key === "activate") runChange([
                            row
                        ], true);
                        else (0, $05a90c67d3627fd9$export$2e2bcd8739ae039).confirm({
                            title: (0, $3b579ca6158bc61b$export$9563e054e6f787fb)(t("confirm_deactivate"), {
                                n: 1
                            }),
                            okText: t("deactivate"),
                            okButtonProps: {
                                danger: true
                            },
                            /* `Modal.confirm` is a static call, so it renders outside the tree and does not
                   inherit `AppShell`'s `ConfigProvider locale` — without these the buttons stay
                   English whatever the account's language is. */ cancelText: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f544127b46daf517), "cancel", lang),
                            onOk: ()=>runChange([
                                    row
                                ], false)
                        });
                    }
                }))
        ], // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        lang,
        rows
    ]);
    const scrollY = (0, $66539b2560a58e4e$export$f44b992e82788e9)();
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
        vertical: true,
        gap: "middle",
        className: "shell-content lp sv",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                className: "lp-head",
                justify: "space-between",
                align: "flex-end",
                gap: "middle",
                wrap: true,
                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                    vertical: true,
                    children: [
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Title, {
                            level: 1,
                            className: "lp-title",
                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$72266474e9355649), "supervisors", lang)
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Paragraph, {
                            type: "secondary",
                            className: "lp-sub",
                            children: t("page_sub")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b4fda840b736e640$export$2e2bcd8739ae039), {
                className: "lp-filters",
                variant: "outlined",
                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039), {
                    layout: "vertical",
                    component: false,
                    colon: false,
                    children: [
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $db6c3adada49524e$export$2e2bcd8739ae039), {
                            gutter: [
                                12,
                                12
                            ],
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $cde227eb983ae1d2$export$2e2bcd8739ae039), {
                                    ...$77c659030dd190f5$var$FIELD_COL,
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                        label: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$2cbd0be658ac061c), "search", lang),
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0883e7f8083c01b0$export$2e2bcd8739ae039), {
                                            allowClear: true,
                                            prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $20a259d46bffcb08$export$2e2bcd8739ae039), {}),
                                            placeholder: t("search_ph"),
                                            value: typed,
                                            onChange: (event)=>setTyped(event.target.value)
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $cde227eb983ae1d2$export$2e2bcd8739ae039), {
                                    ...$77c659030dd190f5$var$FIELD_COL,
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                        label: td("region"),
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b6929c6a194abc34$export$2e2bcd8739ae039), {
                                            entity: "county",
                                            value: county,
                                            seed: chosenCounty || (me?.county && typeof me.county === "object" ? me.county : null),
                                            prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $68eebcef827bb540$export$2e2bcd8739ae039), {}),
                                            onChange: narrow((option)=>{
                                                setChosenCounty(option);
                                                setCounty(option ? $77c659030dd190f5$var$idOf(option) : "");
                                            }),
                                            onResolve: remember("county")
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $a9e321bb60aaf998$export$2e2bcd8739ae039), {
                            className: "lp-chips",
                            items: chips,
                            closeLabel: tp("a_remove_filter"),
                            onClose: clearChip
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                            className: "lp-filters__foot",
                            align: "center",
                            gap: "small",
                            wrap: true,
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $ac40310dc424be23$export$2e2bcd8739ae039), {
                                    value: segment,
                                    onChange: narrow(setSegment),
                                    options: $77c659030dd190f5$var$SEGMENTS.map(([value, key])=>({
                                            value: value,
                                            label: t(key)
                                        }))
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $602120e6d17ff12a$export$2e2bcd8739ae039).CheckableTag, {
                                    className: "sv-chip",
                                    checked: noPoints,
                                    onChange: narrow(setNoPoints),
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $eb1133c43d00490b$export$2e2bcd8739ae039), {
                                        size: 6,
                                        children: [
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $a1f80a723f71d713$export$2e2bcd8739ae039), {}),
                                            t("no_points")
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                    className: "lp-spacer"
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                    size: "small",
                                    onClick: resetFilters,
                                    children: td("filter_reset")
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $b4fda840b736e640$export$2e2bcd8739ae039), {
                className: "lp-table",
                variant: "outlined",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                        className: "lp-table__bar",
                        align: "center",
                        gap: "small",
                        wrap: true,
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                strong: true,
                                className: "lp-table__title",
                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$72266474e9355649), "supervisors", lang)
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                type: "secondary",
                                "aria-live": "polite",
                                children: [
                                    tp("records_count"),
                                    ": ",
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                        strong: true,
                                        children: total
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $dff4d45d201c6dfe$export$2e2bcd8739ae039), {
                        className: "lp-table__grid",
                        rowKey: "id",
                        size: "middle",
                        columns: columns,
                        dataSource: rows,
                        loading: loading,
                        scroll: {
                            x: 880,
                            y: scrollY
                        },
                        rowClassName: (row)=>selected.includes(row.id) ? "lp-row lp-row--on" : "lp-row",
                        rowSelection: {
                            fixed: true,
                            selectedRowKeys: selected,
                            onChange: (keys)=>setSelected(keys)
                        },
                        onRow: (row)=>({
                                onClick: (event)=>{
                                    /* The selection cell and the row menu own their clicks; everything else opens. */ if (event.target.closest(".ant-table-selection-column, .ant-dropdown, .ant-btn")) return;
                                    openSupervisor(row);
                                }
                            }),
                        /* Paging is the footer below, so the only thing left for the table's own onChange is
             the sorter — with `pagination={false}` its first argument carries nothing. */ onChange: (pagination, filters, sorter)=>{
                            const next = sorter?.order && $77c659030dd190f5$var$ORDERING[sorter.columnKey] ? {
                                key: sorter.columnKey,
                                dir: sorter.order
                            } : null;
                            if (JSON.stringify(next) === JSON.stringify(sort)) return;
                            setSort(next);
                            setPage(1);
                        },
                        pagination: false,
                        locale: {
                            emptyText: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $99350450b877904c$export$2e2bcd8739ae039), {
                                image: (0, $99350450b877904c$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE,
                                description: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                    vertical: true,
                                    gap: 4,
                                    children: [
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                            strong: true,
                                            children: t("empty_title")
                                        }),
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                            type: "secondary",
                                            children: t("empty_desc")
                                        })
                                    ]
                                })
                            })
                        }
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $66539b2560a58e4e$export$6cb97cd1ceda576d), {
                        id: "sv",
                        page: page,
                        size: size,
                        total: total,
                        sizes: $77c659030dd190f5$var$PAGE_SIZES,
                        labels: {
                            perPage: tv("rows_per_page"),
                            range: tv("range_of")
                        },
                        onPage: (next)=>{
                            setPage(next);
                            setSelected([]);
                        },
                        onSize: (next)=>{
                            setSize(next);
                            setPage(1);
                            setSelected([]);
                        }
                    })
                ]
            }),
            selected.length > 0 && /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                className: "lp-bulkbar",
                align: "center",
                gap: "middle",
                wrap: true,
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                        className: "lp-bulkbar__n",
                        children: (0, $3b579ca6158bc61b$export$9563e054e6f787fb)(tp("w_selected"), {
                            n: selected.length
                        })
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $eb1133c43d00490b$export$2e2bcd8739ae039), {
                        size: 8,
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                size: "small",
                                onClick: ()=>setSelected([]),
                                children: tp("clear_selection")
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                size: "small",
                                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $45839ed7c4a7faa2$export$2e2bcd8739ae039), {}),
                                loading: busy,
                                onClick: ()=>changeSelected(true),
                                children: t("activate")
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                size: "small",
                                danger: true,
                                type: "primary",
                                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e539a200877e5e8f$export$2e2bcd8739ae039), {}),
                                loading: busy,
                                onClick: ()=>changeSelected(false),
                                children: t("deactivate")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $77c659030dd190f5$export$2e2bcd8739ae039 = $77c659030dd190f5$var$List;


/* Supervisor detail — one person, and what they are responsible for.
   No mockup; `docs/design/merch-detail.html` is the visual reference for a person page. Spec/03
   archetype B, minus the parts this record cannot use: the API exposes no writable field on a
   supervisor except `is_active`, so there is no view/edit toggle, no dirty state and no Save —
   it is a read-only profile with one lifecycle action.

   **There is deliberately no sticky command bar.** Archetype B's is there for a long form whose
   Save has to stay in reach; this page has one action and short content, so the actions sit in
   the page head and the whole sticky-layering apparatus (measured offsets, ResizeObserver,
   hit-testing at both breakpoints) is not paid for. That machinery has shipped broken four times
   — the cheapest way to not break it a fifth is to not need it.

   ONE TAB IS MOUNTED AT A TIME (spec/03). antd `<Tabs destroyOnHidden>` unmounts the inactive
   pane; each tab fetches on first open and its page is cached in `tabData`, so returning to a
   tab costs nothing but only one occupies the DOM. Both tab counts come from the single
   `GET supervisors/:id/` (`points_count` / `merchandisers_count`), so the rail is complete
   before either tab has loaded.

   Two tabs, both editable, each needing a filter the endpoint did not have:
   - points — `points/?responsible_supervisors=<id>` (new `PointWebFilter` in picsell-api)
   - team   — `merchandisers/?supervisor=<id>` (new `MerchandiserWebFilter`)

   A visits tab was built and removed: `/visit` already lists them, filtered by supervisor, with
   the filters, sorting and review workspace this page would only have restated in miniature. */ 

var $cQmXV = parcelRequire("cQmXV");











const $8a5b9f48d1d79d00$var$TABS = [
    "points",
    "team"
];
/* Both tabs are editable; this is the entity each one's picker offers. */ const $8a5b9f48d1d79d00$var$ASSIGNABLE = {
    points: {
        path: "points",
        entity: "points"
    },
    team: {
        path: "merchandisers",
        entity: "merchandisers"
    }
};
const $8a5b9f48d1d79d00$var$PAGE_SIZES = [
    10,
    25,
    50
];
const $8a5b9f48d1d79d00$var$Page = ()=>{
    const { id: id } = (0, $6f5d68f762d5488a$export$99eaa27ddbbb95ef)();
    const history = (0, $6f5d68f762d5488a$export$3420e1dc2c4a518c)();
    const location = (0, $6f5d68f762d5488a$export$45d76561a5302f2b)();
    const me = (0, $b83e93e5ef3de8b0$export$2105062e25df4afe)((state)=>state.me);
    const lang = me?.language || "en";
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$d5a72fe01869f310), key, lang);
    const tl = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$fbb7ce4dc3b38367), key, lang);
    const td = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), key, lang);
    const tpa = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ac552071080927b0), key, lang);
    const tv = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), key, lang);
    const [item, setItem] = (0, $cQmXV.useState)(null);
    const [status, setStatus] = (0, $cQmXV.useState)("loading"); // loading | ready | error
    const [busy, setBusy] = (0, $cQmXV.useState)(false);
    const initialTab = new URLSearchParams(location.search).get("t");
    const [tab, setTab] = (0, $cQmXV.useState)($8a5b9f48d1d79d00$var$TABS.includes(initialTab) ? initialTab : "points");
    /* Per tab: `{ rows, count }` once loaded, `null` if the request failed, absent if never
     opened. Paging is server-side, so a tab holds the CURRENT page only and its `count` is the
     true total — which is what the pager and the tab badge both read. */ const [tabData, setTabData] = (0, $cQmXV.useState)({});
    const [tabPage, setTabPage] = (0, $cQmXV.useState)({
        points: 1,
        team: 1
    });
    const [tabSize, setTabSize] = (0, $cQmXV.useState)($8a5b9f48d1d79d00$var$PAGE_SIZES[1]);
    const loadingTabs = (0, $cQmXV.useRef)(new Set());
    /* The assignment picker: which tab it is adding to, and what has been picked so far. */ const [picker, setPicker] = (0, $cQmXV.useState)(null);
    const [picked, setPicked] = (0, $cQmXV.useState)([]);
    /* ---------------------------------------------------------------- record */ const load = (0, $cQmXV.useCallback)(()=>{
        setStatus("loading");
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "GET",
            url: `supervisors/${id}/`
        }, (response)=>{
            if (!response?.id) return setStatus("error");
            setItem(response);
            setStatus("ready");
        });
    }, [
        id
    ]);
    (0, $cQmXV.useEffect)(load, [
        load
    ]);
    /* The request each tab runs on. One place where the three parameter shapes are visible. */ const tabUrl = (0, $cQmXV.useCallback)((key, page, size)=>{
        const paging = `page=${page}&page_size=${size}`;
        if (key === "points") return `points/?responsible_supervisors=${id}&${paging}&ordering=name`;
        return `merchandisers/?supervisor=${id}&${paging}`;
    }, [
        id
    ]);
    const loadTab = (0, $cQmXV.useCallback)((key, page)=>{
        const stamp = `${key}:${page}:${tabSize}`;
        if (loadingTabs.current.has(stamp)) return;
        loadingTabs.current.add(stamp);
        setTabData((prev)=>({
                ...prev,
                [key]: undefined
            }));
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "GET",
            url: tabUrl(key, page, tabSize)
        }, (response)=>{
            loadingTabs.current.delete(stamp);
            setTabData((prev)=>({
                    ...prev,
                    [key]: response?.results ? {
                        rows: response.results,
                        count: response.count ?? response.results.length
                    } : null
                }));
        });
    }, [
        tabUrl,
        tabSize
    ]);
    /* Hydrate on demand: a tab fetches the first time it is opened, and its page stays cached, so
     coming back to it costs nothing. Paging and assignment refetch it explicitly. */ (0, $cQmXV.useEffect)(()=>{
        if (status !== "ready" || tabData[tab] !== undefined) return;
        if ([
            ...loadingTabs.current
        ].some((stamp)=>stamp.startsWith(`${tab}:`))) return;
        loadTab(tab, tabPage[tab]);
    }, [
        tab,
        status,
        tabData,
        tabPage,
        loadTab
    ]);
    /* The open tab rides in the URL, so a reload or a shared link lands in place. */ (0, $cQmXV.useEffect)(()=>{
        const next = new URLSearchParams(location.search);
        if (next.get("t") === tab) return;
        next.set("t", tab);
        history.replace({
            search: next.toString()
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        tab
    ]);
    /* ------------------------------------------------- activate / deactivate */ const setActive = (value)=>{
        const run = ()=>{
            setBusy(true);
            (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
                method: "PATCH",
                url: `supervisors/${id}/`,
                post: {
                    is_active: value
                }
            }, (response)=>{
                setBusy(false);
                if (!response) return;
                setItem((prev)=>({
                        ...prev,
                        is_active: value
                    }));
                (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success((0, $3b579ca6158bc61b$export$9563e054e6f787fb)((0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$fbb7ce4dc3b38367), value ? "activated_msg" : "deactivated_msg", lang), {
                    n: 1
                }), {
                    position: "top-right"
                });
            });
        };
        if (value) return run();
        /* Destructive, so it is confirmed and the confirm carries the verb, never "OK" (spec/03). */ (0, $05a90c67d3627fd9$export$2e2bcd8739ae039).confirm({
            title: (0, $3b579ca6158bc61b$export$9563e054e6f787fb)(tl("confirm_deactivate"), {
                n: 1
            }),
            okText: tl("deactivate"),
            okButtonProps: {
                danger: true
            },
            /* Static `Modal.confirm` renders outside the tree, so it does not inherit AppShell's
         `ConfigProvider locale` — without this the Cancel button stays English. */ cancelText: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f544127b46daf517), "cancel", lang),
            onOk: run
        });
    };
    /* ------------------------------------------------------------- assignment */ /**
   * Attach or detach members of one of the supervisor's sets.
   *
   * `POST supervisors/:id/(points|merchandisers)/ {ids, detach}` — add/remove rather than a
   * PATCH replacing the whole set, because this page only ever holds ONE PAGE of the relation
   * and a replace would silently unassign everything not on screen. The server answers with the
   * refreshed counts, so the tab badges and the coverage rail move without re-reading the record.
   */ const assign = (key, ids, detach)=>{
        const { path: path } = $8a5b9f48d1d79d00$var$ASSIGNABLE[key];
        setBusy(true);
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "POST",
            url: `supervisors/${id}/${path}/`,
            post: {
                ids: ids,
                detach: Boolean(detach)
            }
        }, (response)=>{
            setBusy(false);
            if (!response || response.changed == null) {
                (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).error(t("assign_error"), {
                    position: "top-right"
                });
                return;
            }
            setItem((prev)=>({
                    ...prev,
                    points_count: response.points_count ?? prev.points_count,
                    merchandisers_count: response.merchandisers_count ?? prev.merchandisers_count
                }));
            /* Removing the last row of the last page would otherwise leave the pager past the end. */ const page = detach && tabData[key]?.rows.length === ids.length && tabPage[key] > 1 ? tabPage[key] - 1 : tabPage[key];
            setTabPage((prev)=>({
                    ...prev,
                    [key]: page
                }));
            loadTab(key, page);
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success((0, $3b579ca6158bc61b$export$9563e054e6f787fb)(t(detach ? "removed_msg" : "added_msg"), {
                n: response.changed
            }), {
                position: "top-right"
            });
            /* Ids the server refused — out of company scope, or the wrong role for the relation. */ if (response.ignored) (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).warning((0, $3b579ca6158bc61b$export$9563e054e6f787fb)(t("ignored_msg"), {
                n: response.ignored
            }), {
                position: "top-right"
            });
        });
    };
    const confirmRemove = (key, row, label)=>(0, $05a90c67d3627fd9$export$2e2bcd8739ae039).confirm({
            title: (0, $3b579ca6158bc61b$export$9563e054e6f787fb)(t(key === "points" ? "confirm_remove_point" : "confirm_remove_merchandiser"), {
                name: label
            }),
            okText: t("remove"),
            okButtonProps: {
                danger: true
            },
            cancelText: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f544127b46daf517), "cancel", lang),
            onOk: ()=>assign(key, [
                    row.id
                ], true)
        });
    const submitPicker = ()=>{
        const ids = picked.map((option)=>option?.id ?? option?.value).filter(Boolean);
        if (!ids.length) return setPicker(null);
        assign(picker, ids, false);
        setPicker(null);
        setPicked([]);
    };
    /* ------------------------------------------------------------- tab tables */ /* The row action is a MENU, not a bare icon button, because both list pages put row actions in
     one — same affordance, same place, and a second action later does not move the first. */ const removeColumn = (key)=>(0, $66539b2560a58e4e$export$b0493221521ca587)((value, row)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $66539b2560a58e4e$export$523acc1bb0ce2e43), {
                label: tv("row_actions"),
                items: [
                    {
                        key: "remove",
                        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5234c28d879e38c1$export$2e2bcd8739ae039), {}),
                        label: t("remove"),
                        danger: true
                    }
                ],
                onClick: ()=>confirmRemove(key, row, key === "points" ? row.name : (0, $66539b2560a58e4e$export$1d6cfa7493842c29)(row))
            }));
    /* Both tables are built from the same primitives as the supervisors and visits lists
     (`component/table-cells.js`): the leading status glyph, the avatar-plus-name cell, the
     two-line title cell and the row-action menu. Three tables of the same records reading as
     three different products is exactly what this replaced. */ const TAB_COLUMNS = {
        points: [
            {
                key: "name",
                title: tpa("f_name"),
                ellipsis: true,
                render: (value, row)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $66539b2560a58e4e$export$2692b073ef5fee01), {
                        title: row.name,
                        sub: [
                            row.locality?.name,
                            row.address
                        ].filter(Boolean).join(" \xb7 ")
                    })
            },
            {
                key: "network",
                title: tpa("f_network"),
                width: 180,
                ellipsis: true,
                render: (value, row)=>row.network?.name || (0, $66539b2560a58e4e$export$eb03490a10c3abc9)
            },
            {
                key: "quality",
                title: "",
                width: 150,
                /* A point with no coordinates cannot be geofenced, so a visit there can never be
           verified — the same data-quality signal the points list leads with. */ render: (value, row)=>row.location ? null : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $1e5256cf9d329b2c$export$2e2bcd8739ae039), {
                        title: t("no_coordinates"),
                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $602120e6d17ff12a$export$2e2bcd8739ae039), {
                            className: "sv-tag--warn",
                            children: t("no_coordinates")
                        })
                    })
            },
            removeColumn("points")
        ],
        team: [
            /* The status is the ICON the supervisors list uses, not a word in a column of its own —
         same signal, same position, one less column competing with the name. */ (0, $66539b2560a58e4e$export$81ff514f95f0c424)((value, row)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $66539b2560a58e4e$export$b131c49b26d3f427), {
                    Icon: row.is_active ? (0, $45839ed7c4a7faa2$export$2e2bcd8739ae039) : (0, $e539a200877e5e8f$export$2e2bcd8739ae039),
                    tone: row.is_active ? "ok" : "off",
                    label: tl(row.is_active ? "status_active" : "status_inactive")
                })),
            {
                key: "name",
                title: td("merchandisers"),
                ellipsis: true,
                render: (value, row)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $66539b2560a58e4e$export$8a3d0b92eb0904a5), {
                        user: row
                    })
            },
            {
                key: "phone",
                title: tpa("f_phone"),
                width: 180,
                render: (value, row)=>row.phone_number || (0, $66539b2560a58e4e$export$eb03490a10c3abc9)
            },
            removeColumn("team")
        ]
    };
    /* ------------------------------------------------------------------ render */ if (status === "loading") return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
        vertical: true,
        gap: "middle",
        className: "shell-content lp sd",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e855c7114b2916ed$export$2e2bcd8739ae039), {
                active: true,
                avatar: true,
                paragraph: {
                    rows: 2
                }
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e855c7114b2916ed$export$2e2bcd8739ae039), {
                active: true,
                title: false,
                paragraph: {
                    rows: 6
                }
            })
        ]
    });
    if (status === "error" || !item) return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
        vertical: true,
        gap: "middle",
        className: "shell-content lp sd",
        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $99350450b877904c$export$2e2bcd8739ae039), {
            image: (0, $99350450b877904c$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE,
            description: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                vertical: true,
                gap: 4,
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                        strong: true,
                        children: t("not_found_title")
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                        type: "secondary",
                        children: t("not_found_desc")
                    })
                ]
            }),
            children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                onClick: ()=>history.push("/supervisors"),
                children: tpa("back_btn")
            })
        })
    });
    const name = (0, $66539b2560a58e4e$export$1d6cfa7493842c29)(item) || "\u2014";
    const role = (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$e24f02e1b5477764), item.role === "supervisor_manager" ? "role_supervisor_manager" : "role_supervisor", lang);
    const countOf = {
        points: item.points_count,
        team: item.merchandisers_count
    };
    const tabLabel = {
        points: td("points"),
        team: td("merchandisers")
    };
    const tabItems = $8a5b9f48d1d79d00$var$TABS.map((key)=>({
            key: key,
            label: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $eb1133c43d00490b$export$2e2bcd8739ae039), {
                size: 6,
                children: [
                    tabLabel[key],
                    countOf[key] != null ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "sd-cnt",
                        children: countOf[key]
                    }) : null
                ]
            }),
            children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                vertical: true,
                gap: "small",
                className: "sd-tab",
                children: [
                    $8a5b9f48d1d79d00$var$ASSIGNABLE[key] ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                        justify: "flex-end",
                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                            type: "primary",
                            icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $fa25166ced813feb$export$2e2bcd8739ae039), {}),
                            disabled: busy,
                            onClick: ()=>{
                                setPicked([]);
                                setPicker(key);
                            },
                            children: t(key === "points" ? "add_points" : "add_merchandisers")
                        })
                    }) : null,
                    tabData[key] === undefined ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e855c7114b2916ed$export$2e2bcd8739ae039), {
                        active: true,
                        title: false,
                        paragraph: {
                            rows: 4
                        }
                    }) : tabData[key] === null ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $dc33dcdb2d24fbd9$export$2e2bcd8739ae039), {
                        type: "error",
                        showIcon: true,
                        message: t("load_error"),
                        action: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                            size: "small",
                            onClick: ()=>loadTab(key, tabPage[key]),
                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$9cbb0f231a0ab7ea), "retry", lang)
                        })
                    }) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $575603080129eb00$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $dff4d45d201c6dfe$export$2e2bcd8739ae039), {
                                className: "lp-table__grid",
                                rowKey: "id",
                                size: "middle",
                                columns: TAB_COLUMNS[key],
                                dataSource: tabData[key].rows,
                                pagination: false,
                                scroll: {
                                    x: 620
                                },
                                locale: {
                                    emptyText: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $99350450b877904c$export$2e2bcd8739ae039), {
                                        image: (0, $99350450b877904c$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE,
                                        description: t("empty_tab")
                                    })
                                }
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $66539b2560a58e4e$export$6cb97cd1ceda576d), {
                                id: `sd-${key}`,
                                page: tabPage[key],
                                size: tabSize,
                                total: tabData[key].count,
                                sizes: $8a5b9f48d1d79d00$var$PAGE_SIZES,
                                labels: {
                                    perPage: tv("rows_per_page"),
                                    range: tv("range_of")
                                },
                                onPage: (next)=>{
                                    setTabPage((prev)=>({
                                            ...prev,
                                            [key]: next
                                        }));
                                    loadTab(key, next);
                                },
                                onSize: (next)=>{
                                    setTabSize(next);
                                    setTabPage((prev)=>({
                                            ...prev,
                                            [key]: 1
                                        }));
                                    /* Every tab's cached page was sized by the old value, so they all go. */ setTabData({});
                                }
                            })
                        ]
                    })
                ]
            })
        }));
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
        vertical: true,
        gap: "middle",
        className: "shell-content lp sd",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $acdea7eebf8fd4fd$export$2e2bcd8739ae039), {
                items: [
                    {
                        title: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("a", {
                            onClick: ()=>history.push("/supervisors"),
                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$72266474e9355649), "supervisors", lang)
                        })
                    },
                    {
                        title: name
                    }
                ]
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                className: "lp-head",
                justify: "space-between",
                align: "flex-end",
                gap: "middle",
                wrap: true,
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                        vertical: true,
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Title, {
                                level: 1,
                                className: "lp-title",
                                children: name
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Paragraph, {
                                type: "secondary",
                                className: "lp-sub",
                                children: [
                                    role,
                                    item.county_name
                                ].filter(Boolean).join(" \xb7 ")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $eb1133c43d00490b$export$2e2bcd8739ae039), {
                        wrap: true,
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                onClick: ()=>history.push("/supervisors"),
                                children: tpa("back_btn")
                            }),
                            item.is_active ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                danger: true,
                                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e539a200877e5e8f$export$2e2bcd8739ae039), {}),
                                loading: busy,
                                onClick: ()=>setActive(false),
                                children: tl("deactivate")
                            }) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                type: "primary",
                                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $45839ed7c4a7faa2$export$2e2bcd8739ae039), {}),
                                loading: busy,
                                onClick: ()=>setActive(true),
                                children: tl("activate")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $db6c3adada49524e$export$2e2bcd8739ae039), {
                gutter: [
                    16,
                    16
                ],
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $cde227eb983ae1d2$export$2e2bcd8739ae039), {
                        xs: 24,
                        xl: 16,
                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                            vertical: true,
                            gap: "middle",
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b4fda840b736e640$export$2e2bcd8739ae039), {
                                    className: "sd-id",
                                    variant: "outlined",
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                        align: "center",
                                        gap: "middle",
                                        wrap: true,
                                        children: [
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $72b7444d01b36e98$export$2e2bcd8739ae039), {
                                                size: 64,
                                                className: "sd-id__av",
                                                style: {
                                                    fontSize: 20
                                                },
                                                src: item.photo || null,
                                                children: (0, $66539b2560a58e4e$export$f6a098653d630c23)(name)
                                            }),
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                                vertical: true,
                                                flex: "1 1 240px",
                                                children: [
                                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                                        strong: true,
                                                        className: "sd-id__t",
                                                        children: name
                                                    }),
                                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                                        className: "sd-id__sub",
                                                        align: "center",
                                                        gap: "small",
                                                        wrap: true,
                                                        children: [
                                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e85f2e3cc711f245$export$2e2bcd8739ae039), {}),
                                                                    " ",
                                                                    role
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $efbc782831576418$export$2e2bcd8739ae039), {}),
                                                                    " ",
                                                                    item.phone_number || "\u2014"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $68eebcef827bb540$export$2e2bcd8739ae039), {}),
                                                                    " ",
                                                                    item.county_name || tl("no_region")
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $66539b2560a58e4e$export$b131c49b26d3f427), {
                                                Icon: item.is_active ? (0, $45839ed7c4a7faa2$export$2e2bcd8739ae039) : (0, $e539a200877e5e8f$export$2e2bcd8739ae039),
                                                tone: item.is_active ? "ok" : "off",
                                                label: tl(item.is_active ? "status_active" : "status_inactive")
                                            }),
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                                type: item.is_active ? undefined : "secondary",
                                                children: tl(item.is_active ? "status_active" : "status_inactive")
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b4fda840b736e640$export$2e2bcd8739ae039), {
                                    className: "sd-tabs",
                                    variant: "outlined",
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $cf7a430748488e77$export$2e2bcd8739ae039), {
                                        activeKey: tab,
                                        onChange: setTab,
                                        items: tabItems,
                                        destroyOnHidden: true
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $cde227eb983ae1d2$export$2e2bcd8739ae039), {
                        xs: 24,
                        xl: 8,
                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                            vertical: true,
                            gap: "middle",
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $b4fda840b736e640$export$2e2bcd8739ae039), {
                                    className: "sd-rail",
                                    variant: "outlined",
                                    title: t("coverage"),
                                    children: [
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                            className: "sd-stats",
                                            gap: "middle",
                                            wrap: true,
                                            children: [
                                                [
                                                    "points",
                                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $a1f80a723f71d713$export$2e2bcd8739ae039), {}, "i")
                                                ],
                                                [
                                                    "team",
                                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e85f2e3cc711f245$export$2e2bcd8739ae039), {}, "i")
                                                ]
                                            ].map(([key, icon])=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                                    vertical: true,
                                                    className: "sd-stat",
                                                    children: [
                                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                                                            className: "sd-stat__label",
                                                            children: [
                                                                icon,
                                                                " ",
                                                                tabLabel[key]
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                                            className: "sd-stat__n",
                                                            children: countOf[key] ?? "\u2014"
                                                        })
                                                    ]
                                                }, key))
                                        }),
                                        !item.points_count ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $dc33dcdb2d24fbd9$export$2e2bcd8739ae039), {
                                            className: "sd-warn",
                                            type: "warning",
                                            showIcon: true,
                                            message: tl("no_points_hint")
                                        }) : null
                                    ]
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b4fda840b736e640$export$2e2bcd8739ae039), {
                                    className: "sd-rail",
                                    variant: "outlined",
                                    title: t("account"),
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $47da64cf901a0567$export$2e2bcd8739ae039), {
                                        column: 1,
                                        size: "small",
                                        colon: false,
                                        children: [
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $47da64cf901a0567$export$2e2bcd8739ae039).Item, {
                                                label: tpa("f_phone"),
                                                children: item.phone_number || /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                                    className: "lp-dash",
                                                    children: "\u2014"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $47da64cf901a0567$export$2e2bcd8739ae039).Item, {
                                                label: tpa("f_county"),
                                                children: item.county_name || /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                                    className: "lp-dash",
                                                    children: "\u2014"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $47da64cf901a0567$export$2e2bcd8739ae039).Item, {
                                                label: t("f_telegram"),
                                                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                                    type: item.telegram_id ? undefined : "secondary",
                                                    children: t(item.telegram_id ? "telegram_linked" : "telegram_none")
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $47da64cf901a0567$export$2e2bcd8739ae039).Item, {
                                                label: tpa("f_status"),
                                                children: tpa(item.is_active ? "active" : "inactive")
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $05a90c67d3627fd9$export$2e2bcd8739ae039), {
                open: Boolean(picker),
                title: picker ? t(picker === "points" ? "add_points" : "add_merchandisers") : "",
                okText: t("add"),
                okButtonProps: {
                    disabled: !picked.length,
                    loading: busy
                },
                cancelText: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f544127b46daf517), "cancel", lang),
                onOk: submitPicker,
                onCancel: ()=>setPicker(null),
                destroyOnHidden: true,
                children: picker ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b6929c6a194abc34$export$2e2bcd8739ae039), {
                    className: "sd-picker",
                    entity: $8a5b9f48d1d79d00$var$ASSIGNABLE[picker].entity,
                    isMulti: true,
                    value: picked,
                    /* Deliberately NOT scoped to the supervisor's own county: responsibility does not
               have to follow the region on their profile, and a picker that quietly omits valid
               choices is worse than one that lists a few too many. Company scope is enforced
               server-side, which is the boundary that matters. */ ariaLabel: t(picker === "points" ? "add_points" : "add_merchandisers"),
                    placeholder: t("picker_ph"),
                    onChange: setPicked
                }) : null
            })
        ]
    });
};
var $8a5b9f48d1d79d00$export$2e2bcd8739ae039 = $8a5b9f48d1d79d00$var$Page;


/* Visits — the approval list.
   Visual reference: docs/design/visits.html. Normative rules: docs/design/spec/.

   Shape (spec/03 archetype A): page head → filter card → status segment → table → sticky bulk bar.
   Filters apply as they change. Everything narrows on the SERVER — the page never filters or
   sorts rows it already has, because it only ever holds one page of them.

   The endpoint this runs on gained the filters it needed in the same change (picsell-api
   `visits/api/web/v1/filters.py`): `county` and `supervisor` were being sent by the old page and
   silently dropped, and `status` / multi-value `users` / `networks` / `points` did not exist.

   Two columns the design draws as sortable are not: report status and progress are computed per
   visit outside the queryset (`collect_status_reports_bulk`), so ordering by them could only ever
   sort the loaded page — which reads as a sort and is not one. */ 

var $cQmXV = parcelRequire("cQmXV");
















const $199198b5a2e0dacc$var$PAGE_SIZES = [
    10,
    20,
    50,
    100
];
/** Widest period the list will accept, in DAYS — the same cap `/task`, `/photo-review` and
    `/uploads` enforce, so every period control in the app offers the same six presets.

    The DEFAULT is the shared `defaultRange()` — two weeks, today inclusive — not the cap. It had
    no cap at all before: a pasted URL could ask for a year of visits and `VisitFilter` would honour
    it, and the period is the only thing bounding how many rows the endpoint considers. It opened on
    a single day for a while, which kept the first paint cheap but put every visit older than this
    morning a filter change away; two weeks is what `/answers` opens on too.

    Held in three places, as `/answers` holds its own: the calendar greys out days beyond the cap,
    `searchToState` clamps a pasted URL, and `buildQuery` clamps whatever is in state at request
    time — the last is what actually holds, including for `/visit/:id`'s queue stepping, which
    re-runs `buildQuery`. */ const $199198b5a2e0dacc$var$MAX_RANGE_DAYS = 90;
const $199198b5a2e0dacc$var$STATUS_SEGMENTS = [
    [
        "all",
        "status_all"
    ],
    [
        "pending",
        "status_pending"
    ],
    [
        "approved",
        "status_approved"
    ],
    [
        "rejected",
        "status_rejected"
    ]
];
/* `is_approved` is a nullable boolean: null means still on verification. */ const $199198b5a2e0dacc$var$statusOf = (visit)=>visit?.is_approved === true ? "approved" : visit?.is_approved === false ? "rejected" : "pending";
const $199198b5a2e0dacc$var$STATUS_ICON = {
    approved: {
        Icon: (0, $45839ed7c4a7faa2$export$2e2bcd8739ae039),
        tone: "ok",
        key: "approved_single_visit_name"
    },
    rejected: {
        Icon: (0, $bdfb1f797481a352$export$2e2bcd8739ae039),
        tone: "no",
        key: "no_approved_single_visit_name"
    },
    pending: {
        Icon: (0, $7b23ac4854de9809$export$2e2bcd8739ae039),
        tone: "wait",
        key: "on_verification_single_visit_name"
    }
};
/* Column key → the field the API orders on. A key missing here is not sortable (see the header
   comment); `duration` is an annotation on the queryset, not a column. */ const $199198b5a2e0dacc$var$ORDERING = {
    point: "point__name",
    approved_by: "approved_by__first_name",
    author: "user__first_name",
    time: "duration"
};
/* Six tracks with the period spanning two — seven units, and 24 does not divide by seven. A
   `<Col>`'s responsive value may be an object rather than a span, and that object takes `flex`,
   so the track is a percentage instead. `0 0` rather than `1 1`: a short last row leaves empty
   tracks instead of stretching the fields it does have. */ const $199198b5a2e0dacc$var$FIELD_COL = {
    xs: {
        flex: "0 0 100%"
    },
    sm: {
        flex: "0 0 50%"
    },
    md: {
        flex: "0 0 33.3333%"
    },
    xl: {
        flex: "0 0 14.2857%"
    }
};
const $199198b5a2e0dacc$var$PERIOD_COL = {
    xs: {
        flex: "0 0 100%"
    },
    sm: {
        flex: "0 0 100%"
    },
    md: {
        flex: "0 0 66.6667%"
    },
    xl: {
        flex: "0 0 28.5714%"
    }
};
const $199198b5a2e0dacc$var$blankFilter = ()=>({
        county: "",
        network: "",
        users: [],
        supervisor: [],
        points: []
    });
const $199198b5a2e0dacc$var$SINGLE_KEYS = [
    "county",
    "network"
];
const $199198b5a2e0dacc$var$ARRAY_KEYS = [
    "users",
    "supervisor",
    "points"
];
/* Which ENTITY_DROPDOWN_SETTINGS key names each filter's chip. */ const $199198b5a2e0dacc$var$CHIP_LABEL = {
    county: "region",
    network: "network",
    users: "merchandisers",
    supervisor: "supervisor",
    points: "points"
};
/** Which VISIT_PAGE key names each toggleable column in the Columns panel. */ const $199198b5a2e0dacc$var$COLUMN_LABEL = {
    supervisor: "supervisor",
    approved_by: "approved_by",
    author: "author_way",
    time: "table_timespent",
    reports: "status_label",
    progress: "progress_label"
};
const $199198b5a2e0dacc$var$TOGGLEABLE = Object.keys($199198b5a2e0dacc$var$COLUMN_LABEL);
const $199198b5a2e0dacc$var$idOf = (v)=>v && typeof v === "object" ? v.id ?? v.value : v;
const $199198b5a2e0dacc$var$joinIds = (list)=>(list || []).map($199198b5a2e0dacc$var$idOf).filter((v)=>v !== undefined && v !== null && v !== "").join(",");
const $199198b5a2e0dacc$var$isoDay = (d)=>(0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)(d).format("YYYY-MM-DD");
const $199198b5a2e0dacc$var$fullName = (user)=>user ? [
        user.first_name,
        user.last_name
    ].filter(Boolean).join(" ") : "";
function $199198b5a2e0dacc$export$d7b58f10109feb02({ filter: filter, range: range, status: status, page: page, size: size, sort: sort }) {
    // The backstop. Every other clamp is convenience; this one is on the path to the request.
    const period = (0, $cc63266e8518a62e$export$e9d4863bcce07ce9)(range, $199198b5a2e0dacc$var$MAX_RANGE_DAYS);
    const p = new URLSearchParams();
    p.set("page", String(page));
    p.set("page_size", String(size));
    if (filter.county) p.set("county", String($199198b5a2e0dacc$var$idOf(filter.county)));
    if (filter.network) p.set("networks", String($199198b5a2e0dacc$var$idOf(filter.network)));
    if (filter.users?.length) p.set("users", $199198b5a2e0dacc$var$joinIds(filter.users));
    if (filter.supervisor?.length) p.set("supervisor", $199198b5a2e0dacc$var$joinIds(filter.supervisor));
    if (filter.points?.length) p.set("points", $199198b5a2e0dacc$var$joinIds(filter.points));
    if (status !== "all") p.set("status", status);
    if (period?.[0]) p.set("start__gte", $199198b5a2e0dacc$var$isoDay(period[0]));
    /* Inclusive end: `start__lte` against a date is midnight, so the picked day itself would be
     excluded for every visit that did not begin at 00:00. */ if (period?.[1]) p.set("start__lte", $199198b5a2e0dacc$var$isoDay((0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)(period[1]).add(1, "day")));
    if (sort) p.set("ordering", `${sort.dir === "descend" ? "-" : ""}${$199198b5a2e0dacc$var$ORDERING[sort.key]}`);
    return p.toString();
}
/** URL ↔ state sync, so a filtered view can be shared, bookmarked, and survives coming back
    from a visit's detail page with the browser's Back button. */ function $199198b5a2e0dacc$var$stateToSearch({ filter: filter, range: range, status: status, page: page, size: size, sort: sort }) {
    const p = new URLSearchParams();
    if (range?.[0]) p.set("start", $199198b5a2e0dacc$var$isoDay(range[0]));
    if (range?.[1]) p.set("end", $199198b5a2e0dacc$var$isoDay(range[1]));
    if (filter.county) p.set("county", String($199198b5a2e0dacc$var$idOf(filter.county)));
    if (filter.network) p.set("network", String($199198b5a2e0dacc$var$idOf(filter.network)));
    (filter.users || []).forEach((v)=>p.append("users", String($199198b5a2e0dacc$var$idOf(v))));
    (filter.supervisor || []).forEach((v)=>p.append("supervisor", String($199198b5a2e0dacc$var$idOf(v))));
    (filter.points || []).forEach((v)=>p.append("points", String($199198b5a2e0dacc$var$idOf(v))));
    if (status !== "all") p.set("status", status);
    if (page > 1) p.set("page", String(page));
    if (size !== $199198b5a2e0dacc$var$PAGE_SIZES[0]) p.set("size", String(size));
    if (sort) p.set("sort", `${sort.dir === "descend" ? "-" : ""}${sort.key}`);
    return p.toString();
}
function $199198b5a2e0dacc$export$fade2611c23f9109(search, me) {
    const p = new URLSearchParams(search);
    const filter = $199198b5a2e0dacc$var$blankFilter();
    if (p.get("county")) filter.county = p.get("county");
    if (p.get("network")) filter.network = p.get("network");
    /* Ids only — `EntitySelect` names them once it has fetched the option they belong to. */ filter.users = p.getAll("users").map((v)=>({
            id: Number(v)
        }));
    filter.supervisor = p.getAll("supervisor").map((v)=>({
            id: Number(v)
        }));
    filter.points = p.getAll("points").map((v)=>({
            id: Number(v)
        }));
    const hasFilters = Boolean(search && search.replace(/^\?/, ""));
    /* Without a URL to restore, the supervisor's own region is the sensible default view — it is
     the scope they are responsible for, and the old page seeded it the same way. */ if (!hasFilters) filter.county = (0, $3b579ca6158bc61b$export$6339e4f5afb1eeb0)(me) || "";
    const start = p.get("start");
    const end = p.get("end");
    const sort = p.get("sort");
    return {
        filter: filter,
        /* A shared URL with filters but no dates used to arrive with NO window — the one path that
       could ask for everything. It gets the default like any other. */ range: start && end ? (0, $cc63266e8518a62e$export$e9d4863bcce07ce9)([
            (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)(start),
            (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)(end)
        ], $199198b5a2e0dacc$var$MAX_RANGE_DAYS) : (0, $cc63266e8518a62e$export$33e9fd85c7cf1b3c)(),
        status: $199198b5a2e0dacc$var$STATUS_SEGMENTS.some(([value])=>value === p.get("status")) ? p.get("status") : "all",
        page: Math.max(1, Number(p.get("page")) || 1),
        size: $199198b5a2e0dacc$var$PAGE_SIZES.includes(Number(p.get("size"))) ? Number(p.get("size")) : $199198b5a2e0dacc$var$PAGE_SIZES[0],
        sort: sort && $199198b5a2e0dacc$var$ORDERING[sort.replace(/^-/, "")] ? {
            key: sort.replace(/^-/, ""),
            dir: sort[0] === "-" ? "descend" : "ascend"
        } : null
    };
}
/* ------------------------------------------------------------------ cells */ /** Completed / on review / not completed, as one bar — `collect_status_reports` from the API.
    The counts sit ON the fill, so the fill is a `-700` and not the `-500` the mockup draws:
    white on `--success-500` is 4.21:1 and text needs 4.5:1 (spec/01#status-colour). */ function $199198b5a2e0dacc$var$ReportBar({ reports: reports, lang: lang }) {
    const parts = [
        [
            reports?.completed_reports || 0,
            "ok",
            "approved_label_popup"
        ],
        [
            reports?.on_review_reports || 0,
            "wait",
            "pending_label_popup"
        ],
        [
            reports?.not_completed_reports || 0,
            "no",
            "rejected_label_popup"
        ]
    ];
    const total = parts.reduce((sum, [n])=>sum + n, 0);
    if (!total) return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
        className: "vt-bar vt-bar--empty",
        "aria-hidden": "true"
    });
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
        className: "vt-bar",
        children: parts.map(([n, tone, key])=>n ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $1e5256cf9d329b2c$export$2e2bcd8739ae039), {
                title: `${(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), key, lang)}: ${n}`,
                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                    className: `vt-bar__seg vt-bar__seg--${tone}`,
                    style: {
                        flex: `${n} 1 0`
                    },
                    children: n
                })
            }, tone) : null)
    });
}
/* ------------------------------------------------------------------ page */ const $199198b5a2e0dacc$var$List = ()=>{
    const history = (0, $6f5d68f762d5488a$export$3420e1dc2c4a518c)();
    const location = (0, $6f5d68f762d5488a$export$45d76561a5302f2b)();
    const me = (0, $b83e93e5ef3de8b0$export$2105062e25df4afe)((state)=>state.me);
    const lang = me?.language || "en";
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), key, lang);
    const td = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), key, lang);
    const tp = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$b8441a9a81ffc5d6), key, lang);
    /* Read once. After mount this component owns the state and writes the URL, not the reverse —
     reading it back on every change would fight the user's own typing. */ const initial = (0, $cQmXV.useRef)($199198b5a2e0dacc$export$fade2611c23f9109(location.search, me)).current;
    const [filter, setFilter] = (0, $cQmXV.useState)(initial.filter);
    const [range, setRangeState] = (0, $cQmXV.useState)(initial.range);
    /* Everything routes through here — picker, chip ×, Reset — so "the state never holds a window
     wider than the cap, and never holds none" is an invariant rather than a per-call-site rule. */ const setRange = (next)=>setRangeState((0, $cc63266e8518a62e$export$e9d4863bcce07ce9)(next, $199198b5a2e0dacc$var$MAX_RANGE_DAYS) || (0, $cc63266e8518a62e$export$33e9fd85c7cf1b3c)());
    const [status, setStatus] = (0, $cQmXV.useState)(initial.status);
    const [page, setPage] = (0, $cQmXV.useState)(initial.page);
    const [size, setSize] = (0, $cQmXV.useState)(initial.size);
    const [sort, setSort] = (0, $cQmXV.useState)(initial.sort);
    /* The option objects the selects handed back, so a chosen value labels itself. */ const [chosen, setChosen] = (0, $cQmXV.useState)({
        county: null,
        network: null
    });
    const [rows, setRows] = (0, $cQmXV.useState)([]);
    const [total, setTotal] = (0, $cQmXV.useState)(0);
    const [loading, setLoading] = (0, $cQmXV.useState)(true);
    const [selected, setSelected] = (0, $cQmXV.useState)([]);
    const [busy, setBusy] = (0, $cQmXV.useState)(false);
    const [hidden, setHidden] = (0, $cQmXV.useState)([]);
    /* --------------------------------------------------------------- fetch */ const query = (0, $cQmXV.useMemo)(()=>$199198b5a2e0dacc$export$d7b58f10109feb02({
            filter: filter,
            range: range,
            status: status,
            page: page,
            size: size,
            sort: sort
        }), [
        filter,
        range,
        status,
        page,
        size,
        sort
    ]);
    (0, $cQmXV.useEffect)(()=>{
        const controller = new AbortController();
        setLoading(true);
        (0, $c9936523dc38c641$export$86557ef9e0794d10)(`visits/?${query}`, controller.signal).then((response)=>{
            if (!response) return;
            setRows(response.results || []);
            setTotal(response.count || 0);
            setLoading(false);
        }).catch((error)=>{
            if (error.name === "AbortError") return;
            setRows([]);
            setTotal(0);
            setLoading(false);
        });
        return ()=>controller.abort();
    }, [
        query
    ]);
    /* The URL trails the state; `replace` so filtering does not fill the history stack, and the
     Back button still leaves the page rather than undoing one filter at a time. */ (0, $cQmXV.useEffect)(()=>{
        const search = $199198b5a2e0dacc$var$stateToSearch({
            filter: filter,
            range: range,
            status: status,
            page: page,
            size: size,
            sort: sort
        });
        if (search !== location.search.replace(/^\?/, "")) history.replace({
            search: search
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        filter,
        range,
        status,
        page,
        size,
        sort
    ]);
    /* Any narrowing invalidates the page number: page 7 of the old result set is usually past the
     end of the new one, which would render an empty table over a non-empty result. */ const narrow = (fn)=>(...args)=>{
            setPage(1);
            setSelected([]);
            fn(...args);
        };
    const setSingle = narrow((key, option)=>{
        setChosen((prev)=>({
                ...prev,
                [key]: option
            }));
        setFilter((prev)=>({
                ...prev,
                [key]: option ? $199198b5a2e0dacc$var$idOf(option) : ""
            }));
    });
    const setArray = narrow((key, list)=>setFilter((prev)=>({
                ...prev,
                [key]: list
            })));
    const resetFilters = narrow(()=>{
        setFilter($199198b5a2e0dacc$var$blankFilter());
        setChosen({
            county: null,
            network: null
        });
        setRange((0, $cc63266e8518a62e$export$33e9fd85c7cf1b3c)());
        setStatus("all");
        setSort(null);
    });
    /* ---------------------------------------------------------------- chips */ const { labels: labels, remember: remember, nameFor: nameFor } = (0, $a9e321bb60aaf998$export$243aa1fcbfd1886a)();
    const clearChip = narrow((key, id)=>{
        if (key === "period") {
            setRange((0, $cc63266e8518a62e$export$33e9fd85c7cf1b3c)());
            return;
        }
        if ($199198b5a2e0dacc$var$SINGLE_KEYS.includes(key)) {
            setChosen((prev)=>({
                    ...prev,
                    [key]: null
                }));
            setFilter((prev)=>({
                    ...prev,
                    [key]: ""
                }));
            return;
        }
        setFilter((prev)=>({
                ...prev,
                [key]: (prev[key] || []).filter((v)=>String($199198b5a2e0dacc$var$idOf(v)) !== String(id))
            }));
    });
    const chips = (0, $cQmXV.useMemo)(()=>{
        const out = [];
        if (range?.[0] && range?.[1]) {
            /* Short form, per spec/04 — `28 Jul → 11 Aug`. The year shows only when the range leaves
         the current one, which is also what keeps the chip on one line on a phone. */ const thisYear = new Date().getFullYear();
            const sameYear = range[0].year() === thisYear && range[1].year() === thisYear;
            const fmt = new Intl.DateTimeFormat((0, $7d0f78de0b68a104$export$bd7bed267fc278f2)(lang), {
                day: "numeric",
                month: "short",
                ...sameYear ? {} : {
                    year: "numeric"
                }
            });
            out.push({
                key: "period",
                label: tp("period"),
                value: `${fmt.format(range[0].toDate())} \u{2192} ${fmt.format(range[1].toDate())}`
            });
        }
        $199198b5a2e0dacc$var$SINGLE_KEYS.forEach((key)=>{
            if (!filter[key]) return;
            /* `chosen[key]` is the option object the select handed back, so it names itself; falling
         back to the bare id sends `nameFor` to the resolution cache. */ out.push({
                key: key,
                label: td($199198b5a2e0dacc$var$CHIP_LABEL[key]),
                value: nameFor(key, chosen[key] ?? filter[key])
            });
        });
        $199198b5a2e0dacc$var$ARRAY_KEYS.forEach((key)=>{
            (filter[key] || []).forEach((v)=>out.push({
                    key: key,
                    id: $199198b5a2e0dacc$var$idOf(v),
                    label: td($199198b5a2e0dacc$var$CHIP_LABEL[key]),
                    value: nameFor(key, v)
                }));
        });
        return out;
    /* `labels` is a dependency: a chip that arrived as an id has to re-render once its name lands. */ // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        filter,
        chosen,
        labels,
        range,
        lang
    ]);
    /* ------------------------------------------------------- approve / reject */ const patchVisit = (visit, value)=>new Promise((resolve)=>{
            /* `isOk`, not truthiness — a 5xx hands the callback a truthy failedResponse (see action.js). */ (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
                method: "PATCH",
                url: `visits/${visit.id}/`,
                post: {
                    is_approved: value,
                    approved_by: me.id
                }
            }, (response)=>resolve((0, $c9936523dc38c641$export$71a04ee6075aae31)(response)));
        });
    /* The row is patched in place rather than refetched, so the table does not jump under the
     cursor. A row that no longer matches the active status filter stays until the next fetch: its
     dot has already changed, so it is showing the result of the action, not a stale state. */ const applyLocally = (ids, value)=>{
        setRows((prev)=>prev.map((row)=>ids.includes(row.id) ? {
                    ...row,
                    is_approved: value,
                    approved_by: me
                } : row));
    };
    const decide = async (visit, value)=>{
        if (visit.is_approved === value) {
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).warning(t(value ? "already_approve_visit_msg" : "already_reject_visit_msg"), {
                position: "top-right"
            });
            return;
        }
        setBusy(true);
        const ok = await patchVisit(visit, value);
        setBusy(false);
        if (!ok) return;
        applyLocally([
            visit.id
        ], value);
        (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success(t(value ? "approve_visit_msg" : "reject_visit_msg"), {
            position: "top-right"
        });
    };
    const decideSelected = async (value)=>{
        const targets = rows.filter((row)=>selected.includes(row.id) && row.is_approved !== value);
        if (!targets.length) {
            setSelected([]);
            return;
        }
        setBusy(true);
        const results = await Promise.all(targets.map((row)=>patchVisit(row, value)));
        setBusy(false);
        const done = targets.filter((row, i)=>results[i]);
        if (done.length) {
            applyLocally(done.map((row)=>row.id), value);
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success((0, $3b579ca6158bc61b$export$9563e054e6f787fb)(t(value ? "approve_visits_msg" : "reject_visits_msg"), {
                n: done.length
            }), {
                position: "top-right"
            });
        }
        if (done.length < targets.length) (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).warning((0, $3b579ca6158bc61b$export$9563e054e6f787fb)(t("decide_failed_msg"), {
            n: targets.length - done.length
        }), {
            position: "top-right"
        });
        setSelected([]);
    };
    /* Walk into the review workspace carrying this row's position in the FILTERED list, so the
     detail page's prev/next stepping continues the same queue. The filters ride along in the
     same query string, which is what lets it ask for the neighbour without re-deriving them. */ const openVisit = (visit, indexOnPage)=>{
        const search = new URLSearchParams($199198b5a2e0dacc$var$stateToSearch({
            filter: filter,
            range: range,
            status: status,
            page: page,
            size: size,
            sort: sort
        }));
        if (indexOnPage != null) {
            search.set("i", String((page - 1) * size + indexOnPage + 1));
            search.set("n", String(total));
        }
        history.push(`/visit/${visit.id}?${search.toString()}`);
    };
    /* ------------------------------------------------------------- columns */ const dateFmt = (0, $cQmXV.useMemo)(()=>new Intl.DateTimeFormat((0, $7d0f78de0b68a104$export$bd7bed267fc278f2)(lang), {
            day: "2-digit",
            month: "2-digit",
            year: "numeric"
        }), [
        lang
    ]);
    const columns = (0, $cQmXV.useMemo)(()=>{
        const all = [
            (0, $66539b2560a58e4e$export$81ff514f95f0c424)((value, row)=>{
                const { Icon: Icon, tone: tone, key: key } = $199198b5a2e0dacc$var$STATUS_ICON[$199198b5a2e0dacc$var$statusOf(row)];
                return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $66539b2560a58e4e$export$b131c49b26d3f427), {
                    Icon: Icon,
                    tone: tone,
                    label: t(key)
                });
            }),
            {
                key: "point",
                title: td("point"),
                width: 300,
                fixed: "left",
                ellipsis: true,
                sorter: true,
                render: (value, row)=>{
                    const title = [
                        row.point?.locality?.name,
                        row.point?.name
                    ].filter(Boolean).join(" \xb7 ");
                    const meta = [
                        row.point?.address,
                        row.start ? dateFmt.format(new Date(row.start)) : null
                    ].filter(Boolean).join(" \xb7 ");
                    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                        vertical: true,
                        className: "lp-main",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                strong: true,
                                ellipsis: {
                                    tooltip: title
                                },
                                children: title
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                type: "secondary",
                                className: "lp-main__sub",
                                ellipsis: {
                                    tooltip: meta
                                },
                                children: meta
                            })
                        ]
                    });
                }
            },
            {
                key: "supervisor",
                title: t("supervisor"),
                width: 190,
                ellipsis: true,
                /* The point's responsible supervisors are an M2M; ordering across it duplicates rows,
           so this column shows the first one and does not sort. */ render: (value, row)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $66539b2560a58e4e$export$8a3d0b92eb0904a5), {
                        user: row.point?.responsible_supervisors?.[0],
                        strong: false
                    })
            },
            {
                key: "approved_by",
                title: t("approved_by"),
                width: 190,
                ellipsis: true,
                sorter: true,
                render: (value, row)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $66539b2560a58e4e$export$8a3d0b92eb0904a5), {
                        user: row.approved_by,
                        strong: false
                    })
            },
            {
                key: "author",
                title: t("author_way"),
                width: 200,
                ellipsis: true,
                sorter: true,
                render: (value, row)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                        vertical: true,
                        className: "lp-main",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                ellipsis: {
                                    tooltip: $199198b5a2e0dacc$var$fullName(row.user)
                                },
                                children: $199198b5a2e0dacc$var$fullName(row.user) || "\u2014"
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                type: "secondary",
                                className: "lp-main__sub",
                                children: t(row.is_planned ? "on_route" : "off_route")
                            })
                        ]
                    })
            },
            {
                key: "time",
                title: t("table_timespent"),
                width: 110,
                align: "right",
                sorter: true,
                render: (value, row)=>{
                    const spent = (0, $9277fdae5adb8dfa$export$bc733b0c5cbb3e8a)(row.time_spent, lang);
                    return spent ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "lp-num",
                        children: spent
                    }) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "lp-dash",
                        children: "\u2014"
                    });
                }
            },
            {
                key: "reports",
                title: t("status_label"),
                width: 150,
                render: (value, row)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($199198b5a2e0dacc$var$ReportBar, {
                        reports: row.collect_status_reports,
                        lang: lang
                    })
            },
            {
                key: "progress",
                title: t("progress_label"),
                width: 130,
                align: "center",
                render: (value, row)=>{
                    const percent = row.collect_status_reports?.progress_reports || 0;
                    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                        align: "center",
                        justify: "center",
                        gap: 8,
                        className: "vt-prog",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $deaf5cd30ff4a7d3$export$2e2bcd8739ae039), {
                                percent: percent,
                                size: [
                                    46,
                                    6
                                ],
                                showInfo: false,
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                                className: "lp-num",
                                children: [
                                    percent,
                                    "%"
                                ]
                            })
                        ]
                    });
                }
            },
            (0, $66539b2560a58e4e$export$b0493221521ca587)((value, row, index)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $66539b2560a58e4e$export$523acc1bb0ce2e43), {
                    label: t("row_actions"),
                    items: [
                        {
                            key: "open",
                            icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $357da3723e13ae38$export$2e2bcd8739ae039), {}),
                            label: t("open_visit")
                        },
                        {
                            key: "approve",
                            icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $45839ed7c4a7faa2$export$2e2bcd8739ae039), {}),
                            label: t("approv_btn")
                        },
                        {
                            key: "reject",
                            icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $bdfb1f797481a352$export$2e2bcd8739ae039), {}),
                            label: t("reject_btn"),
                            danger: true
                        }
                    ],
                    onClick: (key)=>key === "open" ? openVisit(row, index) : decide(row, key === "approve")
                }))
        ];
        return all.filter((column)=>!hidden.includes(column.key));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        lang,
        hidden,
        rows,
        dateFmt
    ]);
    const scrollY = (0, $66539b2560a58e4e$export$f44b992e82788e9)();
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
        vertical: true,
        gap: "middle",
        className: "shell-content lp vt",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                className: "lp-head",
                justify: "space-between",
                align: "flex-end",
                gap: "middle",
                wrap: true,
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                        vertical: true,
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Title, {
                                level: 1,
                                className: "lp-title",
                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$72266474e9355649), "visit", lang)
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Paragraph, {
                                type: "secondary",
                                className: "lp-sub",
                                children: t("page_sub")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $1e5256cf9d329b2c$export$2e2bcd8739ae039), {
                        title: tp("print_hint"),
                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                            icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $15d85cc2607f0b44$export$2e2bcd8739ae039), {}),
                            onClick: ()=>window.print(),
                            children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$f544127b46daf517), "export", lang)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b4fda840b736e640$export$2e2bcd8739ae039), {
                className: "lp-filters",
                variant: "outlined",
                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039), {
                    layout: "vertical",
                    component: false,
                    colon: false,
                    children: [
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $db6c3adada49524e$export$2e2bcd8739ae039), {
                            gutter: [
                                12,
                                12
                            ],
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $cde227eb983ae1d2$export$2e2bcd8739ae039), {
                                    ...$199198b5a2e0dacc$var$PERIOD_COL,
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                        label: tp("period"),
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $cc63266e8518a62e$export$2e2bcd8739ae039), {
                                            value: range,
                                            onChange: narrow(setRange),
                                            maxDays: $199198b5a2e0dacc$var$MAX_RANGE_DAYS,
                                            clearTo: (0, $cc63266e8518a62e$export$33e9fd85c7cf1b3c)
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $cde227eb983ae1d2$export$2e2bcd8739ae039), {
                                    ...$199198b5a2e0dacc$var$FIELD_COL,
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                        label: td("region"),
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b6929c6a194abc34$export$2e2bcd8739ae039), {
                                            entity: "county",
                                            value: filter.county,
                                            seed: chosen.county || (me?.county && typeof me.county === "object" ? me.county : null),
                                            prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $68eebcef827bb540$export$2e2bcd8739ae039), {}),
                                            onChange: (option)=>setSingle("county", option),
                                            onResolve: remember("county")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $cde227eb983ae1d2$export$2e2bcd8739ae039), {
                                    ...$199198b5a2e0dacc$var$FIELD_COL,
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                        label: td("network"),
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b6929c6a194abc34$export$2e2bcd8739ae039), {
                                            entity: "network",
                                            value: filter.network,
                                            seed: chosen.network,
                                            prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $f48fe90789d2a71a$export$2e2bcd8739ae039), {}),
                                            onChange: (option)=>setSingle("network", option),
                                            onResolve: remember("network")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $cde227eb983ae1d2$export$2e2bcd8739ae039), {
                                    ...$199198b5a2e0dacc$var$FIELD_COL,
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                        label: td("merchandisers"),
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b6929c6a194abc34$export$2e2bcd8739ae039), {
                                            entity: "merchandisers",
                                            isMulti: true,
                                            value: filter.users,
                                            prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e85f2e3cc711f245$export$2e2bcd8739ae039), {}),
                                            onChange: (list)=>setArray("users", list),
                                            onResolve: remember("users")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $cde227eb983ae1d2$export$2e2bcd8739ae039), {
                                    ...$199198b5a2e0dacc$var$FIELD_COL,
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                        label: td("supervisor"),
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b6929c6a194abc34$export$2e2bcd8739ae039), {
                                            entity: "supervisor",
                                            isMulti: true,
                                            value: filter.supervisor,
                                            prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $d5baeea001a6abe5$export$2e2bcd8739ae039), {}),
                                            onChange: (list)=>setArray("supervisor", list),
                                            onResolve: remember("supervisor")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $cde227eb983ae1d2$export$2e2bcd8739ae039), {
                                    ...$199198b5a2e0dacc$var$FIELD_COL,
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e9904e0132e26ce3$export$2e2bcd8739ae039).Item, {
                                        label: td("points"),
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b6929c6a194abc34$export$2e2bcd8739ae039), {
                                            entity: "points",
                                            isMulti: true,
                                            value: filter.points,
                                            county: filter.county,
                                            moduleFilter: filter.network,
                                            prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $a1f80a723f71d713$export$2e2bcd8739ae039), {}),
                                            onChange: (list)=>setArray("points", list),
                                            onResolve: remember("points")
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $a9e321bb60aaf998$export$2e2bcd8739ae039), {
                            className: "lp-chips",
                            items: chips,
                            closeLabel: tp("a_remove_filter"),
                            onClose: clearChip
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                            className: "lp-filters__foot",
                            align: "center",
                            gap: "small",
                            wrap: true,
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $ac40310dc424be23$export$2e2bcd8739ae039), {
                                    value: status,
                                    onChange: narrow(setStatus),
                                    options: $199198b5a2e0dacc$var$STATUS_SEGMENTS.map(([value, key])=>({
                                            value: value,
                                            label: tp(key)
                                        }))
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                    className: "lp-spacer"
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                    size: "small",
                                    onClick: resetFilters,
                                    children: td("filter_reset")
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $b4fda840b736e640$export$2e2bcd8739ae039), {
                className: "lp-table",
                variant: "outlined",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                        className: "lp-table__bar",
                        align: "center",
                        gap: "small",
                        wrap: true,
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                strong: true,
                                className: "lp-table__title",
                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$72266474e9355649), "visit", lang)
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                type: "secondary",
                                "aria-live": "polite",
                                children: [
                                    tp("records_count"),
                                    ": ",
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                        strong: true,
                                        children: total
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                className: "lp-spacer"
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $30ddd2d6a9f4b7d6$export$2e2bcd8739ae039), {
                                trigger: [
                                    "click"
                                ],
                                /* A plain checkbox list, not a `menu` — a menu item swallows the checkbox's own
               click and closes the panel after every single toggle. */ popupRender: ()=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b4fda840b736e640$export$2e2bcd8739ae039), {
                                        className: "vt-colcfg",
                                        variant: "outlined",
                                        size: "small",
                                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $7a650444b7c2c328$export$2e2bcd8739ae039).Group, {
                                            value: $199198b5a2e0dacc$var$TOGGLEABLE.filter((key)=>!hidden.includes(key)),
                                            onChange: (visible)=>setHidden($199198b5a2e0dacc$var$TOGGLEABLE.filter((key)=>!visible.includes(key))),
                                            children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                                vertical: true,
                                                gap: 4,
                                                children: $199198b5a2e0dacc$var$TOGGLEABLE.map((key)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $7a650444b7c2c328$export$2e2bcd8739ae039), {
                                                        value: key,
                                                        children: t($199198b5a2e0dacc$var$COLUMN_LABEL[key])
                                                    }, key))
                                            })
                                        })
                                    }),
                                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                    size: "small",
                                    icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $a8085ca9c62f778e$export$2e2bcd8739ae039), {}),
                                    children: t("columns")
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $dff4d45d201c6dfe$export$2e2bcd8739ae039), {
                        className: "lp-table__grid",
                        rowKey: "id",
                        size: "middle",
                        columns: columns,
                        dataSource: rows,
                        loading: loading,
                        scroll: {
                            x: 1420,
                            y: scrollY
                        },
                        rowClassName: (row)=>selected.includes(row.id) ? "lp-row lp-row--on" : "lp-row",
                        rowSelection: {
                            fixed: true,
                            selectedRowKeys: selected,
                            onChange: (keys)=>setSelected(keys)
                        },
                        onRow: (row, index)=>({
                                onClick: (event)=>{
                                    /* The selection cell and the row menu own their clicks; everything else walks
                 into the visit. */ if (event.target.closest(".ant-table-selection-column, .ant-dropdown, .ant-btn")) return;
                                    openVisit(row, index);
                                }
                            }),
                        /* Paging is the footer below, so the only thing left for the table's own onChange is
             the sorter — with `pagination={false}` its first argument carries nothing. */ onChange: (pagination, filters, sorter)=>{
                            const next = sorter?.order && $199198b5a2e0dacc$var$ORDERING[sorter.columnKey] ? {
                                key: sorter.columnKey,
                                dir: sorter.order
                            } : null;
                            if (JSON.stringify(next) === JSON.stringify(sort)) return;
                            setSort(next);
                            setPage(1);
                        },
                        pagination: false,
                        locale: {
                            emptyText: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $99350450b877904c$export$2e2bcd8739ae039), {
                                image: (0, $99350450b877904c$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE,
                                description: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                    vertical: true,
                                    gap: 4,
                                    children: [
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                            strong: true,
                                            children: t("empty_title")
                                        }),
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                            type: "secondary",
                                            children: t("empty_desc")
                                        })
                                    ]
                                })
                            })
                        }
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $66539b2560a58e4e$export$6cb97cd1ceda576d), {
                        id: "vt",
                        page: page,
                        size: size,
                        total: total,
                        sizes: $199198b5a2e0dacc$var$PAGE_SIZES,
                        labels: {
                            perPage: t("rows_per_page"),
                            range: t("range_of")
                        },
                        onPage: (next)=>{
                            setPage(next);
                            setSelected([]);
                        },
                        onSize: (next)=>{
                            setSize(next);
                            setPage(1);
                            setSelected([]);
                        }
                    })
                ]
            }),
            selected.length > 0 && /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                className: "lp-bulkbar",
                align: "center",
                gap: "middle",
                wrap: true,
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                        className: "lp-bulkbar__n",
                        children: (0, $3b579ca6158bc61b$export$9563e054e6f787fb)(tp("w_selected"), {
                            n: selected.length
                        })
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $eb1133c43d00490b$export$2e2bcd8739ae039), {
                        className: "lp-bulkbar__acts",
                        size: 8,
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                size: "small",
                                onClick: ()=>setSelected([]),
                                children: tp("clear_selection")
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                size: "small",
                                className: "vt-btn--ok",
                                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $45839ed7c4a7faa2$export$2e2bcd8739ae039), {}),
                                loading: busy,
                                onClick: ()=>decideSelected(true),
                                children: t("approv_btn")
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                size: "small",
                                danger: true,
                                type: "primary",
                                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $bdfb1f797481a352$export$2e2bcd8739ae039), {}),
                                loading: busy,
                                onClick: ()=>decideSelected(false),
                                children: t("reject_btn")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $199198b5a2e0dacc$export$2e2bcd8739ae039 /* `EntityTable`'s `entity === "visit"` branches — including the `visitCurrentPage` /
   `visitCurrentFilter` localStorage round-trip this page used to need — have no caller left.
   They are dead, not load-bearing; they go with the next legacy sweep, along with
   `formatter.js`'s visit cell helpers. */  = $199198b5a2e0dacc$var$List;


/* Visit detail — the review workspace.
   Visual reference: docs/design/visit-detail.html. Normative rules: docs/design/spec/.

   This is spec/03 archetype C, and it replaced a nine-tab record viewer. The reframe: this screen
   is a DECISION tool, not a record browser. The old page advertised everything across nine tabs
   while hiding the handful of records that actually needed a verdict, and put the verdict buttons
   above the evidence needed to reach it.

   Shape: sticky command bar (breadcrumb + queue stepping + the visit verdict) → compact identity
   strip → "Needs your attention" queue → section rail → ONE mounted section.

   ⚠ ONE SECTION IS MOUNTED AT A TIME, and that is not an optimisation to trade away. Nine live
   sections mean nine requests and a DOM that scales with the whole visit — price monitoring is
   hundreds of rows, a survey thousands of answers, and every photo report is an image request.
   The rail still shows every count and every "work waiting" dot because those come from the
   summary, so the supervisor sees WHERE the work is without loading any of it.

   Requests: ONE on open — `GET visits/{id}/?summary=1`, which carries the visit plus per-section
   counts, pending counts and the queue rows (see `collect_visit_summary` in picsell-api). Each
   section then fetches its own endpoint the first time it is opened, once, and is cached. */ 

var $cQmXV = parcelRequire("cQmXV");




var $cQmXV = parcelRequire("cQmXV");
var $0fce140d68499ec1$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($0fce140d68499ec1$exports, "__esModule", {
    value: true
});
var $0fce140d68499ec1$var$AuditOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M296 250c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm184 144H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-48 458H208V148h560v320c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm440-88H728v-36.6c46.3-13.8 80-56.6 80-107.4 0-61.9-50.1-112-112-112s-112 50.1-112 112c0 50.7 33.7 93.6 80 107.4V764H520c-8.8 0-16 7.2-16 16v152c0 8.8 7.2 16 16 16h352c8.8 0 16-7.2 16-16V780c0-8.8-7.2-16-16-16zM646 620c0-27.6 22.4-50 50-50s50 22.4 50 50-22.4 50-50 50-50-22.4-50-50zm180 266H566v-60h260v60z"
                }
            }
        ]
    },
    "name": "audit",
    "theme": "outlined"
};
$0fce140d68499ec1$exports.default = $0fce140d68499ec1$var$AuditOutlined;



function $9eca0c0bf6c54372$var$_extends() {
    $9eca0c0bf6c54372$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9eca0c0bf6c54372$var$_extends.apply(this, arguments);
}
const $9eca0c0bf6c54372$var$AuditOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $9eca0c0bf6c54372$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($0fce140d68499ec1$exports)))
    }));
/**![audit](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTI5NiAyNTBjLTQuNCAwLTggMy42LTggOHY0OGMwIDQuNCAzLjYgOCA4IDhoMzg0YzQuNCAwIDgtMy42IDgtOHYtNDhjMC00LjQtMy42LTgtOC04SDI5NnptMTg0IDE0NEgyOTZjLTQuNCAwLTggMy42LTggOHY0OGMwIDQuNCAzLjYgOCA4IDhoMTg0YzQuNCAwIDgtMy42IDgtOHYtNDhjMC00LjQtMy42LTgtOC04em0tNDggNDU4SDIwOFYxNDhoNTYwdjMyMGMwIDQuNCAzLjYgOCA4IDhoNTZjNC40IDAgOC0zLjYgOC04VjEwOGMwLTE3LjctMTQuMy0zMi0zMi0zMkgxNjhjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjc4NGMwIDE3LjcgMTQuMyAzMiAzMiAzMmgyNjRjNC40IDAgOC0zLjYgOC04di01NmMwLTQuNC0zLjYtOC04LTh6bTQ0MC04OEg3Mjh2LTM2LjZjNDYuMy0xMy44IDgwLTU2LjYgODAtMTA3LjQgMC02MS45LTUwLjEtMTEyLTExMi0xMTJzLTExMiA1MC4xLTExMiAxMTJjMCA1MC43IDMzLjcgOTMuNiA4MCAxMDcuNFY3NjRINTIwYy04LjggMC0xNiA3LjItMTYgMTZ2MTUyYzAgOC44IDcuMiAxNiAxNiAxNmgzNTJjOC44IDAgMTYtNy4yIDE2LTE2Vjc4MGMwLTguOC03LjItMTYtMTYtMTZ6TTY0NiA2MjBjMC0yNy42IDIyLjQtNTAgNTAtNTBzNTAgMjIuNCA1MCA1MC0yMi40IDUwLTUwIDUwLTUwLTIyLjQtNTAtNTB6bTE4MCAyNjZINTY2di02MGgyNjB2NjB6IiAvPjwvc3ZnPg==) */ const $9eca0c0bf6c54372$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($9eca0c0bf6c54372$var$AuditOutlined);
var $9eca0c0bf6c54372$export$2e2bcd8739ae039 = $9eca0c0bf6c54372$var$RefIcon;


var $cQmXV = parcelRequire("cQmXV");
var $9c14e603979f3611$exports = {};
"use strict";
// This icon file is generated automatically.
Object.defineProperty($9c14e603979f3611$exports, "__esModule", {
    value: true
});
var $9c14e603979f3611$var$FieldTimeOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M945 412H689c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h256c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM811 548H689c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h122c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM477.3 322.5H434c-6.2 0-11.2 5-11.2 11.2v248c0 3.6 1.7 6.9 4.6 9l148.9 108.6c5 3.6 12 2.6 15.6-2.4l25.7-35.1v-.1c3.6-5 2.5-12-2.5-15.6l-126.7-91.6V333.7c.1-6.2-5-11.2-11.1-11.2z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M804.8 673.9H747c-5.6 0-10.9 2.9-13.9 7.7a321 321 0 01-44.5 55.7 317.17 317.17 0 01-101.3 68.3c-39.3 16.6-81 25-124 25-43.1 0-84.8-8.4-124-25-37.9-16-72-39-101.3-68.3s-52.3-63.4-68.3-101.3c-16.6-39.2-25-80.9-25-124 0-43.1 8.4-84.7 25-124 16-37.9 39-72 68.3-101.3 29.3-29.3 63.4-52.3 101.3-68.3 39.2-16.6 81-25 124-25 43.1 0 84.8 8.4 124 25 37.9 16 72 39 101.3 68.3a321 321 0 0144.5 55.7c3 4.8 8.3 7.7 13.9 7.7h57.8c6.9 0 11.3-7.2 8.2-13.3-65.2-129.7-197.4-214-345-215.7-216.1-2.7-395.6 174.2-396 390.1C71.6 727.5 246.9 903 463.2 903c149.5 0 283.9-84.6 349.8-215.8a9.18 9.18 0 00-8.2-13.3z"
                }
            }
        ]
    },
    "name": "field-time",
    "theme": "outlined"
};
$9c14e603979f3611$exports.default = $9c14e603979f3611$var$FieldTimeOutlined;



function $786fda1e352afb36$var$_extends() {
    $786fda1e352afb36$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $786fda1e352afb36$var$_extends.apply(this, arguments);
}
const $786fda1e352afb36$var$FieldTimeOutlined = (props, ref)=>/*#__PURE__*/ $cQmXV.createElement((0, $162ce9b1660c259f$export$2e2bcd8739ae039), $786fda1e352afb36$var$_extends({}, props, {
        ref: ref,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9c14e603979f3611$exports)))
    }));
/**![field-time](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTk0NSA0MTJINjg5Yy00LjQgMC04IDMuNi04IDh2NDhjMCA0LjQgMy42IDggOCA4aDI1NmM0LjQgMCA4LTMuNiA4LTh2LTQ4YzAtNC40LTMuNi04LTgtOHpNODExIDU0OEg2ODljLTQuNCAwLTggMy42LTggOHY0OGMwIDQuNCAzLjYgOCA4IDhoMTIyYzQuNCAwIDgtMy42IDgtOHYtNDhjMC00LjQtMy42LTgtOC04ek00NzcuMyAzMjIuNUg0MzRjLTYuMiAwLTExLjIgNS0xMS4yIDExLjJ2MjQ4YzAgMy42IDEuNyA2LjkgNC42IDlsMTQ4LjkgMTA4LjZjNSAzLjYgMTIgMi42IDE1LjYtMi40bDI1LjctMzUuMXYtLjFjMy42LTUgMi41LTEyLTIuNS0xNS42bC0xMjYuNy05MS42VjMzMy43Yy4xLTYuMi01LTExLjItMTEuMS0xMS4yeiIgLz48cGF0aCBkPSJNODA0LjggNjczLjlINzQ3Yy01LjYgMC0xMC45IDIuOS0xMy45IDcuN2EzMjEgMzIxIDAgMDEtNDQuNSA1NS43IDMxNy4xNyAzMTcuMTcgMCAwMS0xMDEuMyA2OC4zYy0zOS4zIDE2LjYtODEgMjUtMTI0IDI1LTQzLjEgMC04NC44LTguNC0xMjQtMjUtMzcuOS0xNi03Mi0zOS0xMDEuMy02OC4zcy01Mi4zLTYzLjQtNjguMy0xMDEuM2MtMTYuNi0zOS4yLTI1LTgwLjktMjUtMTI0IDAtNDMuMSA4LjQtODQuNyAyNS0xMjQgMTYtMzcuOSAzOS03MiA2OC4zLTEwMS4zIDI5LjMtMjkuMyA2My40LTUyLjMgMTAxLjMtNjguMyAzOS4yLTE2LjYgODEtMjUgMTI0LTI1IDQzLjEgMCA4NC44IDguNCAxMjQgMjUgMzcuOSAxNiA3MiAzOSAxMDEuMyA2OC4zYTMyMSAzMjEgMCAwMTQ0LjUgNTUuN2MzIDQuOCA4LjMgNy43IDEzLjkgNy43aDU3LjhjNi45IDAgMTEuMy03LjIgOC4yLTEzLjMtNjUuMi0xMjkuNy0xOTcuNC0yMTQtMzQ1LTIxNS43LTIxNi4xLTIuNy0zOTUuNiAxNzQuMi0zOTYgMzkwLjFDNzEuNiA3MjcuNSAyNDYuOSA5MDMgNDYzLjIgOTAzYzE0OS41IDAgMjgzLjktODQuNiAzNDkuOC0yMTUuOGE5LjE4IDkuMTggMCAwMC04LjItMTMuM3oiIC8+PC9zdmc+) */ const $786fda1e352afb36$var$RefIcon = /*#__PURE__*/ $cQmXV.forwardRef($786fda1e352afb36$var$FieldTimeOutlined);
var $786fda1e352afb36$export$2e2bcd8739ae039 = $786fda1e352afb36$var$RefIcon;












/* The nine sections of the visit review workspace.
   Visual reference: docs/design/visit-detail.html. Normative rules: docs/design/spec/.

   Each is a plain component over data the workspace already fetched — ONE section is mounted at a
   time, so nothing here may hold its own long-lived state beyond what the reader is looking at.

   Orders / returns / payments are read-only here: they carry a document status from Excalibur that
   this user does not own. Reports, task answers and price monitoring are the three moderatable
   kinds, and they are the ones the queue above hoists. */ 

var $cQmXV = parcelRequire("cQmXV");


var $cQmXV = parcelRequire("cQmXV");


var $cQmXV = parcelRequire("cQmXV");

var $cQmXV = parcelRequire("cQmXV");



var $cQmXV = parcelRequire("cQmXV");

function $c700aae30995076e$export$2e2bcd8739ae039(props) {
    const { prefixCls: prefixCls, className: className, style: style, status: status } = props;
    const railCls = `${prefixCls}-rail`;
    // ============================= render =============================
    return /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(railCls, `${railCls}-${status}`, className),
        style: style
    });
}



var $cQmXV = parcelRequire("cQmXV");
const $57d4307ad96576f3$export$e508d6f1a100e5dd = /*#__PURE__*/ $cQmXV.createContext({});



var $cQmXV = parcelRequire("cQmXV");


var $cQmXV = parcelRequire("cQmXV");
const $6151f1920bee4197$export$3592d73ed1131d52 = /*#__PURE__*/ $cQmXV.createContext(null);



function $6394da207b555123$var$_extends() {
    $6394da207b555123$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6394da207b555123$var$_extends.apply(this, arguments);
}
const $6394da207b555123$export$7b06b07495b1e032 = /*#__PURE__*/ $cQmXV.createContext({});
const $6394da207b555123$var$StepIcon = /*#__PURE__*/ $cQmXV.forwardRef((props, ref)=>{
    const { className: className, style: style, children: children, ...restProps } = props;
    const { prefixCls: prefixCls, classNames: classNames, styles: styles } = $cQmXV.useContext((0, $6151f1920bee4197$export$3592d73ed1131d52));
    const { className: itemClassName, style: itemStyle } = $cQmXV.useContext($6394da207b555123$export$7b06b07495b1e032);
    const itemCls = `${prefixCls}-item`;
    return /*#__PURE__*/ $cQmXV.createElement("div", $6394da207b555123$var$_extends({}, (0, $4b5c733d1d7bb306$export$2e2bcd8739ae039)(restProps, false), {
        ref: ref,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${itemCls}-icon`, classNames.itemIcon, itemClassName, className),
        style: {
            ...styles.itemIcon,
            ...itemStyle,
            ...style
        }
    }), children);
});
var $6394da207b555123$export$2e2bcd8739ae039 = $6394da207b555123$var$StepIcon;



function $87e085c18f89cb07$var$_extends() {
    $87e085c18f89cb07$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $87e085c18f89cb07$var$_extends.apply(this, arguments);
}
function $87e085c18f89cb07$var$hasContent(value) {
    return value !== undefined && value !== null;
}
function $87e085c18f89cb07$export$2e2bcd8739ae039(props) {
    const { prefixCls: // style
    prefixCls, classNames: classNames, styles: styles, data: // data
    data, last: last, nextStatus: nextStatus, active: active, index: index, itemRender: // render
    itemRender, iconRender: iconRender, itemWrapperRender: itemWrapperRender, onClick: // events
    onClick } = props;
    const itemCls = `${prefixCls}-item`;
    // ======================== Contexts ========================
    const { railFollowPrevStatus: railFollowPrevStatus } = $cQmXV.useContext((0, $57d4307ad96576f3$export$e508d6f1a100e5dd));
    const { ItemComponent: ItemComponent } = $cQmXV.useContext((0, $6151f1920bee4197$export$3592d73ed1131d52));
    // ========================== Data ==========================
    const { onClick: onItemClick, title: title, subTitle: subTitle, content: content, description: description, disabled: disabled, icon: icon, status: status, className: className, style: style, classNames: itemClassNames = {}, styles: itemStyles = {}, ...restItemProps } = data;
    const mergedContent = content ?? description;
    const renderInfo = {
        item: {
            ...data,
            content: mergedContent
        },
        index: index,
        active: active
    };
    // ========================= Click ==========================
    const clickable = !!(onClick || onItemClick) && !disabled;
    const accessibilityProps = {};
    if (clickable) {
        accessibilityProps.role = "button";
        accessibilityProps.tabIndex = 0;
        accessibilityProps.onClick = (e)=>{
            onItemClick?.(e);
            onClick(index);
        };
        accessibilityProps.onKeyDown = (e)=>{
            const { which: which } = e;
            if (which === (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).ENTER || which === (0, $7c2257a1fd9763eb$export$2e2bcd8739ae039).SPACE) onClick(index);
        };
    }
    // ========================= Render =========================
    const mergedStatus = status || "wait";
    const hasTitle = $87e085c18f89cb07$var$hasContent(title);
    const hasSubTitle = $87e085c18f89cb07$var$hasContent(subTitle);
    const classString = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(itemCls, `${itemCls}-${mergedStatus}`, {
        [`${itemCls}-custom`]: icon,
        [`${itemCls}-active`]: active,
        [`${itemCls}-disabled`]: disabled === true,
        [`${itemCls}-empty-header`]: !hasTitle && !hasSubTitle
    }, className, classNames.item, itemClassNames.root);
    let iconNode = /*#__PURE__*/ $cQmXV.createElement((0, $6394da207b555123$export$2e2bcd8739ae039), null);
    if (iconRender) iconNode = iconRender(iconNode, {
        ...renderInfo,
        components: {
            Icon: (0, $6394da207b555123$export$2e2bcd8739ae039)
        }
    });
    const wrapperNode = /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${itemCls}-wrapper`, classNames.itemWrapper, itemClassNames.wrapper),
        style: {
            ...styles.itemWrapper,
            ...itemStyles.wrapper
        }
    }, /*#__PURE__*/ $cQmXV.createElement((0, $6394da207b555123$export$7b06b07495b1e032).Provider, {
        value: {
            className: itemClassNames.icon,
            style: itemStyles.icon
        }
    }, iconNode), /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${itemCls}-section`, classNames.itemSection, itemClassNames.section),
        style: {
            ...styles.itemSection,
            ...itemStyles.section
        }
    }, /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${itemCls}-header`, classNames.itemHeader, itemClassNames.header),
        style: {
            ...styles.itemHeader,
            ...itemStyles.header
        }
    }, hasTitle && /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${itemCls}-title`, classNames.itemTitle, itemClassNames.title),
        style: {
            ...styles.itemTitle,
            ...itemStyles.title
        }
    }, title), hasSubTitle && /*#__PURE__*/ $cQmXV.createElement("div", {
        title: typeof subTitle === "string" ? subTitle : undefined,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${itemCls}-subtitle`, classNames.itemSubtitle, itemClassNames.subtitle),
        style: {
            ...styles.itemSubtitle,
            ...itemStyles.subtitle
        }
    }, subTitle), !last && /*#__PURE__*/ $cQmXV.createElement((0, $c700aae30995076e$export$2e2bcd8739ae039), {
        prefixCls: itemCls,
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(classNames.itemRail, itemClassNames.rail),
        style: {
            ...styles.itemRail,
            ...itemStyles.rail
        },
        status: railFollowPrevStatus ? status : nextStatus
    })), $87e085c18f89cb07$var$hasContent(mergedContent) && /*#__PURE__*/ $cQmXV.createElement("div", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(`${itemCls}-content`, classNames.itemContent, itemClassNames.content),
        style: {
            ...styles.itemContent,
            ...itemStyles.content
        }
    }, mergedContent)));
    let stepNode = /*#__PURE__*/ $cQmXV.createElement(ItemComponent, $87e085c18f89cb07$var$_extends({}, restItemProps, accessibilityProps, {
        className: classString,
        style: {
            ...styles.item,
            ...itemStyles.root,
            ...style
        }
    }), itemWrapperRender ? itemWrapperRender(wrapperNode) : wrapperNode);
    if (itemRender) stepNode = itemRender(stepNode, renderInfo) || null;
    return stepNode;
}



function $0c4340a41cba6b05$var$_extends() {
    $0c4340a41cba6b05$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0c4340a41cba6b05$var$_extends.apply(this, arguments);
}
const $0c4340a41cba6b05$var$EmptyObject = {};
function $0c4340a41cba6b05$export$2e2bcd8739ae039(props) {
    const { prefixCls: // style
    prefixCls = "rc-steps", style: style, className: className, classNames: classNames = $0c4340a41cba6b05$var$EmptyObject, styles: styles = $0c4340a41cba6b05$var$EmptyObject, rootClassName: rootClassName, orientation: // layout
    orientation, titlePlacement: titlePlacement, components: components, status: // data
    status = "process", current: current = 0, initial: initial = 0, onChange: onChange, items: items, iconRender: // render
    iconRender, itemRender: itemRender, itemWrapperRender: itemWrapperRender, ...restProps } = props;
    // ============================= layout =============================
    const isVertical = orientation === "vertical";
    const mergedOrientation = isVertical ? "vertical" : "horizontal";
    const mergeTitlePlacement = !isVertical && titlePlacement === "vertical" ? "vertical" : "horizontal";
    // ============================= styles =============================
    const classString = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, `${prefixCls}-${mergedOrientation}`, `${prefixCls}-title-${mergeTitlePlacement}`, rootClassName, className, classNames.root);
    // ============================== Data ==============================
    const mergedItems = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useMemo(()=>(items || []).filter(Boolean), [
        items
    ]);
    const statuses = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useMemo(()=>mergedItems.map(({ status: itemStatus }, index)=>{
            const stepNumber = initial + index;
            if (!itemStatus) {
                if (stepNumber === current) return status;
                else if (stepNumber < current) return "finish";
                return "wait";
            }
            return itemStatus;
        }), [
        mergedItems,
        status,
        current,
        initial
    ]);
    // ============================= events =============================
    const onStepClick = (next)=>{
        if (onChange && current !== next) onChange(next);
    };
    // =========================== components ===========================
    const { root: RootComponent = "div", item: ItemComponent = "div" } = components || {};
    // ============================ contexts ============================
    const stepIconContext = (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).useMemo(()=>({
            prefixCls: prefixCls,
            classNames: classNames,
            styles: styles,
            ItemComponent: ItemComponent
        }), [
        prefixCls,
        classNames,
        styles,
        ItemComponent
    ]);
    // ============================= render =============================
    const renderStep = (item, index)=>{
        const stepIndex = initial + index;
        const itemStatus = statuses[index];
        const nextStatus = statuses[index + 1];
        const data = {
            ...item,
            status: itemStatus
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $87e085c18f89cb07$export$2e2bcd8739ae039), {
            key: stepIndex,
            prefixCls: prefixCls,
            classNames: classNames,
            styles: styles,
            data: data,
            nextStatus: nextStatus,
            active: stepIndex === current,
            index: stepIndex,
            last: mergedItems.length - 1 === index,
            iconRender: iconRender,
            itemRender: itemRender,
            itemWrapperRender: itemWrapperRender,
            onClick: onChange && onStepClick
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement(RootComponent, $0c4340a41cba6b05$var$_extends({
        className: classString,
        style: {
            ...style,
            ...styles?.root
        }
    }, restProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).createElement((0, $6151f1920bee4197$export$3592d73ed1131d52).Provider, {
        value: stepIconContext
    }, mergedItems.map(renderStep)));
}




var $4d86378bf681e560$export$2e2bcd8739ae039 = (0, $0c4340a41cba6b05$export$2e2bcd8739ae039);








var $cQmXV = parcelRequire("cQmXV");















var $cQmXV = parcelRequire("cQmXV");
const $4eb4f06563db30e7$export$d056f9c7816498b6 = /*#__PURE__*/ $cQmXV.createContext(null);



var $cQmXV = parcelRequire("cQmXV");
"use client";
const $df49e983f4225348$var$PanelArrow = (props)=>{
    const { prefixCls: prefixCls } = props;
    return /*#__PURE__*/ $cQmXV.createElement("svg", {
        className: `${prefixCls}-panel-arrow`,
        viewBox: "0 0 100 100",
        xmlns: "http://www.w3.org/2000/svg",
        preserveAspectRatio: "none"
    }, /*#__PURE__*/ $cQmXV.createElement("title", null, "Arrow"), /*#__PURE__*/ $cQmXV.createElement("path", {
        d: "M 0 0 L 100 50 L 0 100"
    }));
};
var $df49e983f4225348$export$2e2bcd8739ae039 = $df49e983f4225348$var$PanelArrow;



var $cQmXV = parcelRequire("cQmXV");


"use client";
const $50a3991d999afde0$var$ProgressIcon = (props)=>{
    const { prefixCls: prefixCls, rootPrefixCls: rootPrefixCls, children: children, percent: percent } = props;
    const progressCls = `${prefixCls}-item-progress-icon`;
    const circleCls = `${progressCls}-circle`;
    const [, varRef] = (0, $6870d4d7c14ae0bb$export$d82b8f66c5649e14)(rootPrefixCls, "cmp-steps");
    const dashArray = `calc(${varRef("progress-radius")} * 2 * ${Math.PI * percent / 100}) 9999`;
    return /*#__PURE__*/ $cQmXV.createElement($cQmXV.Fragment, null, /*#__PURE__*/ $cQmXV.createElement("svg", {
        className: `${progressCls}-svg`,
        viewBox: "0 0 100 100",
        width: "100%",
        height: "100%",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-valuemax": 100,
        "aria-valuemin": 0,
        "aria-valuenow": percent
    }, /*#__PURE__*/ $cQmXV.createElement("title", null, "Progress"), /*#__PURE__*/ $cQmXV.createElement("circle", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(circleCls, `${circleCls}-rail`)
    }), /*#__PURE__*/ $cQmXV.createElement("circle", {
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(circleCls, `${circleCls}-ptg`),
        strokeDasharray: dashArray,
        transform: "rotate(-90 50 50)"
    })), children);
};
var $50a3991d999afde0$export$2e2bcd8739ae039 = $50a3991d999afde0$var$ProgressIcon;






const $01ec0fe6b22f84dd$var$genHorizontalStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    const itemCls = `${componentCls}-item`;
    const [varName, varRef] = (0, $6870d4d7c14ae0bb$export$d82b8f66c5649e14)(antCls, "cmp-steps");
    return {
        [`${componentCls}-horizontal`]: {
            [`> ${itemCls}`]: {
                flex: "1 1 auto",
                minWidth: token.iconSize,
                [`${itemCls}-rail`]: {
                    [varName("horizontal-rail-margin")]: `calc(${varRef("icon-size-max")} / 2 - ${varRef("rail-size")} / 2 + ${varRef("item-wrapper-padding-top")})`,
                    position: "static",
                    marginTop: varRef("horizontal-rail-margin"),
                    width: "auto",
                    borderBlockStartWidth: varRef("rail-size"),
                    flex: 1,
                    minWidth: 0,
                    alignSelf: "flex-start"
                }
            }
        }
    };
};
var $01ec0fe6b22f84dd$export$2e2bcd8739ae039 = $01ec0fe6b22f84dd$var$genHorizontalStyle;



const $9851c7d254a5cbf3$var$genIconStyle = (token)=>{
    const { componentCls: componentCls, customIconFontSize: customIconFontSize, motionDurationSlow: motionDurationSlow, iconSize: iconSize, lineWidth: lineWidth, lineType: lineType, antCls: antCls } = token;
    const itemCls = `${componentCls}-item`;
    const [varName, varRef] = (0, $6870d4d7c14ae0bb$export$d82b8f66c5649e14)(antCls, "cmp-steps");
    return {
        [componentCls]: {
            [varName("icon-size")]: iconSize,
            [varName("icon-border-width")]: lineWidth,
            [`${itemCls}-icon`]: {
                width: varRef("icon-size"),
                height: varRef("icon-size"),
                margin: 0,
                flex: "none",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: token.iconFontSize,
                fontFamily: token.fontFamily,
                lineHeight: varRef("icon-size"),
                textAlign: "center",
                borderRadius: varRef("icon-size"),
                border: `${varRef("icon-border-width")} ${lineType} transparent`,
                transition: [
                    "background-color",
                    "border",
                    "color",
                    "inset",
                    "transform"
                ].map((key)=>`${key} ${motionDurationSlow}`).join(", "),
                zIndex: 1
            },
            // ==================== Custom ====================
            [`${itemCls}-custom ${itemCls}-icon`]: {
                background: "none",
                border: 0,
                fontSize: customIconFontSize
            }
        }
    };
};
var $9851c7d254a5cbf3$export$2e2bcd8739ae039 = $9851c7d254a5cbf3$var$genIconStyle;



const $6b163469c42409f4$var$genInlineStyle = (token)=>{
    const { componentCls: componentCls, inlineDotSize: inlineDotSize, paddingXS: paddingXS, lineWidth: lineWidth, antCls: antCls, calc: calc } = token;
    const containerPaddingTop = calc(paddingXS).add(lineWidth).equal();
    const itemCls = `${componentCls}-item`;
    const [varName, varRef] = (0, $6870d4d7c14ae0bb$export$d82b8f66c5649e14)(antCls, "cmp-steps");
    return {
        [`${componentCls}-inline`]: {
            [varName("items-offset")]: "0",
            [varName("item-wrapper-padding-top")]: containerPaddingTop,
            display: "inline-flex",
            "&:before": {
                content: '""',
                flex: varRef("items-offset")
            },
            [itemCls]: {
                // ========================= Variable =========================
                // Item
                [varName("title-vertical-row-gap")]: paddingXS,
                // Icon
                [varName("icon-size")]: inlineDotSize,
                [varName("icon-size-active")]: inlineDotSize,
                // Title
                [varName("title-font-size")]: token.fontSizeSM,
                [varName("title-line-height")]: token.lineHeightSM,
                [varName("item-title-color")]: token.colorTextSecondary,
                [varName("subtitle-font-size")]: token.fontSizeSM,
                [varName("subtitle-line-height")]: token.lineHeightSM,
                [varName("item-subtitle-color")]: token.colorTextQuaternary,
                // Rail
                [varName("rail-size")]: token.lineWidth,
                [varName("title-horizontal-rail-gap")]: "0px",
                // ========================== Styles ==========================
                flex: 1,
                "&-wrapper": {
                    paddingInline: token.paddingXXS,
                    marginInline: token.calc(token.marginXXS).div(2).equal(),
                    borderRadius: token.borderRadiusSM,
                    cursor: "pointer",
                    transition: `background-color ${token.motionDurationMid}`,
                    "&:hover": {
                        background: token.controlItemBgHover
                    }
                },
                // Icon
                "&-icon": {
                    [`${itemCls}-icon-dot`]: {
                        "&:after": {
                            display: "none"
                        }
                    }
                },
                // Header
                "&-title": {
                    fontWeight: "normal",
                    whiteSpace: "nowrap"
                },
                "&-content": {
                    display: "none"
                }
            }
        }
    };
};
var $6b163469c42409f4$export$2e2bcd8739ae039 = $6b163469c42409f4$var$genInlineStyle;




function $2bee063026c005fe$var$withoutVar(cssVar) {
    return (cssVar || "--ant-not-exist").replace(/var\((.*)\)/, "$1");
}
const $2bee063026c005fe$export$f0196ef13ff2a3b7 = (token, marginSize, optionalStyle)=>{
    const { calc: calc, componentCls: componentCls, descriptionMaxWidth: descriptionMaxWidth, antCls: antCls } = token;
    const itemCls = `${componentCls}-item`;
    const [, varRef] = (0, $6870d4d7c14ae0bb$export$d82b8f66c5649e14)(antCls, "cmp-steps");
    return {
        [`@container style(${$2bee063026c005fe$var$withoutVar(descriptionMaxWidth)})`]: [
            {
                // Icon
                [`${itemCls}-icon`]: {
                    marginInlineStart: calc(descriptionMaxWidth).sub(varRef("icon-size")).div(2).equal()
                },
                // >>> Rail
                [`${itemCls}-rail`]: {
                    width: "auto",
                    insetInlineStart: calc(descriptionMaxWidth).add(varRef("icon-size")).div(2).add(marginSize).equal(),
                    insetInlineEnd: calc(descriptionMaxWidth).sub(varRef("icon-size")).div(2).sub(marginSize).mul(-1).equal()
                }
            },
            optionalStyle
        ]
    };
};


const $125d0d1beb3a3f72$var$genLabelPlacementStyle = (token)=>{
    const { componentCls: componentCls, descriptionMaxWidth: descriptionMaxWidth, marginXS: marginXS, fontHeightLG: fontHeightLG, margin: margin, paddingSM: paddingSM, marginXXS: marginXXS, antCls: antCls, calc: calc } = token;
    const itemCls = `${componentCls}-item`;
    const [varName, varRef] = (0, $6870d4d7c14ae0bb$export$d82b8f66c5649e14)(antCls, "cmp-steps");
    return {
        // ====================== Shared ======================
        [componentCls]: {
            // Dot Steps active icon size is 2px larger than the default icon size
            [varName("icon-size-max")]: `max(${varRef("icon-size")}, ${varRef("icon-size-active", varRef("icon-size"))})`,
            // Icon
            [`${itemCls}-icon`]: {
                marginBlockStart: `calc((${varRef("heading-height")} - ${varRef("icon-size")}) / 2)`
            }
        },
        // ==================== Horizontal ====================
        [`${componentCls}-title-horizontal`]: {
            [varName("title-horizontal-item-margin")]: margin,
            [varName("title-horizontal-rail-margin")]: margin,
            [varName("title-horizontal-title-height")]: fontHeightLG,
            [varName("heading-height")]: `max(${varRef("icon-size")}, ${varRef("title-horizontal-title-height")})`,
            // Horizontal only
            [`&${componentCls}-horizontal, &${componentCls}-horizontal-alternate`]: {
                [`${itemCls}:not(:first-child)`]: {
                    marginInlineStart: varRef("title-horizontal-item-margin")
                },
                [`${itemCls}:last-child`]: {
                    flex: "0 1 auto"
                },
                [`${itemCls}-wrapper`]: {
                    columnGap: token.marginXS
                }
            },
            // Vertical only
            [`&${componentCls}-vertical`]: {
                [`${itemCls}-wrapper`]: {
                    columnGap: token.margin
                },
                [`${itemCls}-empty-header`]: {
                    [`${itemCls}-header`]: {
                        minHeight: "auto"
                    },
                    [`${itemCls}-content`]: {
                        marginTop: calc(varRef("heading-height")).sub(token.fontHeight).div(2).equal()
                    }
                }
            },
            // Shared
            [`${itemCls}-section`]: {
                flex: 1,
                minWidth: 0
            },
            [`${itemCls}-header`]: {
                minHeight: varRef("heading-height")
            },
            [`${itemCls}-title`]: {
                flex: "0 1 auto"
            },
            [`${itemCls}-content`]: {
                maxWidth: descriptionMaxWidth
            },
            [`${itemCls}-subtitle`]: {
                flex: "0 9999 auto"
            },
            [`&${componentCls}-horizontal ${itemCls}-rail`]: {
                [varName("item-wrapper-padding-top")]: "0px",
                flex: "1 1 0%",
                marginInlineStart: varRef("title-horizontal-rail-margin")
            }
        },
        // ===================== Vertical =====================
        [`${componentCls}-title-vertical`]: {
            [varName("title-vertical-row-gap")]: paddingSM,
            [varName("title-horizontal-rail-gap")]: marginXXS,
            [varName("heading-height")]: varRef("icon-size-max"),
            [`> ${itemCls}`]: {
                flex: "1 1 0%",
                [`${itemCls}-wrapper`]: {
                    flexDirection: "column",
                    rowGap: varRef("title-vertical-row-gap"),
                    alignItems: "center"
                },
                // Section
                [`${itemCls}-section`]: {
                    alignSelf: "stretch"
                },
                // Header
                [`${itemCls}-header`]: {
                    flexDirection: "column",
                    alignItems: "center"
                },
                // >>> title & subtitle & Content
                [`${itemCls}-title, ${itemCls}-subtitle, ${itemCls}-content`]: {
                    textAlign: "center",
                    maxWidth: "100%"
                },
                [`${itemCls}-subtitle`]: {
                    margin: 0
                },
                // >>> rail
                [`${itemCls}-rail`]: {
                    position: "absolute",
                    top: 0,
                    width: `calc(100% - ${varRef("icon-size")} - ${varRef("title-horizontal-rail-gap")} * 2)`,
                    insetInlineStart: `calc(50% + ${varRef("icon-size")} / 2 + ${varRef("title-horizontal-rail-gap")})`
                }
            },
            // With descriptionMaxWidth
            ...(0, $2bee063026c005fe$export$f0196ef13ff2a3b7)(token, marginXS, {
                [`${itemCls}:last-child`]: {
                    flex: "none"
                },
                // Icon
                [`${itemCls}-icon`]: {
                    alignSelf: "flex-start"
                },
                // Section
                [`${itemCls}-section`]: {
                    width: descriptionMaxWidth
                }
            })
        }
    };
};
var $125d0d1beb3a3f72$export$2e2bcd8739ae039 = $125d0d1beb3a3f72$var$genLabelPlacementStyle;


const $ee5e6bb75817d665$var$genMaxCountStyle = (token)=>{
    const { componentCls: componentCls } = token;
    const itemCls = `${componentCls}-item`;
    return {
        [`${componentCls}-max-count`]: {
            [`${itemCls}-ellipsis`]: {
                [`${itemCls}-title, ${itemCls}-subtitle, ${itemCls}-content`]: {
                    color: token.colorTextDescription
                }
            }
        }
    };
};
var $ee5e6bb75817d665$export$2e2bcd8739ae039 = $ee5e6bb75817d665$var$genMaxCountStyle;




const $d0b15bbdd72f086b$var$genLegacyNavStyle = (token)=>{
    const { componentCls: componentCls, fontSizeIcon: fontSizeIcon, navContentMaxWidth: navContentMaxWidth, navArrowColor: navArrowColor, colorPrimary: colorPrimary, motionDurationSlow: motionDurationSlow, antCls: antCls, calc: calc } = token;
    const itemCls = `${componentCls}-item`;
    const stepsNavActiveColor = colorPrimary;
    const [varName, varRef] = (0, $6870d4d7c14ae0bb$export$d82b8f66c5649e14)(antCls, "cmp-steps");
    return {
        [`${componentCls}${componentCls}-navigation`]: {
            // ==========================================================
            // ==                        Shared                        ==
            // ==========================================================
            // ========================== Item ==========================
            [itemCls.repeat(4)]: {
                display: "flex",
                justifyContent: "center",
                position: "relative",
                flex: 1,
                marginInlineStart: 0,
                [`${itemCls}-wrapper`]: {
                    paddingBlock: token.paddingSM
                },
                // Section
                [`${itemCls}-section`]: {
                    maxWidth: navContentMaxWidth
                },
                // Rail
                [`${itemCls}-rail`]: {
                    display: "none"
                },
                // ======================== Active ========================
                "&:before": {
                    position: "absolute",
                    display: "block",
                    backgroundColor: stepsNavActiveColor,
                    transition: `all ${motionDurationSlow}`,
                    transitionTimingFunction: "ease-out",
                    content: '""'
                },
                "&:not(:last-child):after": {
                    position: "absolute",
                    display: "block",
                    borderTop: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${navArrowColor}`,
                    borderBottom: "none",
                    borderInlineStart: "none",
                    borderInlineEnd: `${(0, $05f34ed03d41967d$export$523c0b569236b342)(token.lineWidth)} ${token.lineType} ${navArrowColor}`,
                    content: '""'
                },
                // Reset active item style to same as default
                [`&${itemCls}-active`]: {
                    [varName("item-content-active-color")]: varRef("item-content-color"),
                    [varName("item-icon-active-bg-color")]: varRef("item-icon-bg-color"),
                    [varName("item-icon-active-border-color")]: varRef("item-icon-border-color"),
                    [varName("item-icon-active-text-color")]: varRef("item-icon-text-color")
                }
            },
            // ==========================================================
            // ==                       Horizontal                     ==
            // ==========================================================
            [`&${componentCls}-horizontal`]: {
                [itemCls]: {
                    "&:before": {
                        bottom: 0,
                        insetInlineStart: "50%",
                        width: 0,
                        height: token.lineWidthBold
                    },
                    [`&${itemCls}-active:before`]: {
                        insetInlineStart: 0,
                        width: "100%"
                    },
                    "&:not(:last-child):after": {
                        top: `50%`,
                        insetInlineStart: calc(fontSizeIcon).div(2).mul(-1).add("100%").equal(),
                        width: fontSizeIcon,
                        height: fontSizeIcon,
                        transform: "translateY(-50%) rotate(45deg)"
                    }
                }
            },
            // ==========================================================
            // ==                        Vertical                      ==
            // ==========================================================
            [`&${componentCls}-vertical`]: {
                [itemCls.repeat(4)]: {
                    [`${itemCls}-content`]: {
                        padding: 0
                    },
                    "&:before": {
                        insetInlineEnd: 0,
                        top: "50%",
                        width: token.lineWidthBold,
                        height: 0
                    },
                    [`&${itemCls}-active::before`]: {
                        top: 0,
                        height: "100%"
                    },
                    "&:not(:last-child):after": {
                        left: {
                            _skip_check_: true,
                            value: "50%"
                        },
                        top: "100%",
                        width: calc(fontSizeIcon).div(3).mul(2).equal(),
                        height: calc(fontSizeIcon).div(3).mul(2).equal(),
                        transform: "translateY(-50%) translateX(-50%) rotate(135deg)"
                    }
                }
            }
        }
    };
};
var $d0b15bbdd72f086b$export$2e2bcd8739ae039 = $d0b15bbdd72f086b$var$genLegacyNavStyle;




const $1eff16e0c3a794a8$var$genPanelStyle = (token)=>{
    const { componentCls: componentCls, lineWidthBold: lineWidthBold, borderRadius: borderRadius, borderRadiusSM: borderRadiusSM, motionDurationMid: motionDurationMid, paddingXS: paddingXS, lineType: lineType, paddingSM: paddingSM, antCls: antCls, calc: calc } = token;
    const itemCls = `${componentCls}-item`;
    const [varName, varRef] = (0, $6870d4d7c14ae0bb$export$d82b8f66c5649e14)(antCls, "cmp-steps");
    const borderStyle = `${(0, $05f34ed03d41967d$export$523c0b569236b342)(lineWidthBold)} ${lineType} ${varRef("panel-border-color")}`;
    return {
        [`${componentCls}${componentCls}-panel`]: [
            // ==========================================================
            // ==                       Clean up                       ==
            // ==========================================================
            {
                // ====================== Shared ======================
                [`${itemCls}-rail`]: {
                    display: "none"
                },
                // ==================== Horizontal ====================
                [`&${componentCls}-horizontal`]: {
                    alignItems: "stretch",
                    [itemCls]: {
                        flex: 1,
                        margin: 0
                    }
                }
            },
            // ==========================================================
            // ==                       Template                       ==
            // ==========================================================
            {
                "&": {
                    [varName("panel-padding")]: paddingSM,
                    [varName("item-border-radius")]: borderRadius,
                    [itemCls]: {
                        // Panel background
                        [varName("panel-bg-color")]: varRef("item-icon-bg-color"),
                        [varName("panel-border-color")]: varRef("item-icon-border-color"),
                        [varName("panel-active-bg-color")]: varRef("item-icon-active-bg-color"),
                        [varName("panel-active-border-color")]: varRef("item-icon-active-border-color"),
                        [varName("panel-title-height")]: `calc(${varRef("title-font-size")} * ${varRef("title-line-height")})`,
                        // Base height = padding * 2 + iconSize + contentHeight
                        [varName("item-base-height")]: calc(varRef("panel-padding")).mul(2).add(varRef("icon-size")).add(varRef("panel-title-height")).equal(),
                        [varName("item-base-width")]: `calc(${varRef("item-base-height")} * 0.7071)`,
                        transition: `background-color ${motionDurationMid}`
                    }
                },
                // ======================= Icon =======================
                [`${itemCls}-icon`]: {
                    display: "none"
                },
                // ====================== Header ======================
                [`${itemCls}-header`]: {
                    minHeight: "auto"
                },
                // ====================== Arrow =======================
                [`${componentCls}-panel-arrow`]: {
                    position: "absolute",
                    top: calc(lineWidthBold).mul(-1).equal(),
                    insetInlineStart: "100%",
                    zIndex: 1,
                    height: calc(lineWidthBold).mul(2).add("100%").equal(),
                    width: varRef("item-base-width"),
                    overflow: "visible",
                    strokeLinecap: "round",
                    path: {
                        fill: varRef("panel-bg-color"),
                        stroke: varRef("panel-border-color"),
                        strokeWidth: lineWidthBold,
                        vectorEffect: "non-scaling-stroke",
                        transition: `fill ${motionDurationMid}`
                    }
                },
                [`${itemCls}:last-child ${componentCls}-panel-arrow`]: {
                    display: "none"
                },
                // ======================= Item =======================
                [itemCls]: {
                    padding: varRef("panel-padding"),
                    background: varRef("panel-bg-color"),
                    position: "relative",
                    borderBlock: borderStyle,
                    "&:not(:first-child)": {
                        paddingInlineStart: `calc(${varRef("panel-padding")} + ${varRef("item-base-width")})`
                    },
                    "&:first-child": {
                        borderInlineStart: borderStyle,
                        borderStartStartRadius: varRef("item-border-radius"),
                        borderEndStartRadius: varRef("item-border-radius")
                    },
                    "&:last-child": {
                        borderInlineEnd: borderStyle,
                        borderStartEndRadius: varRef("item-border-radius"),
                        borderEndEndRadius: varRef("item-border-radius")
                    },
                    "&-active": {
                        background: varRef("panel-active-bg-color"),
                        borderColor: varRef("panel-active-border-color"),
                        [`${componentCls}-panel-arrow`]: {
                            path: {
                                fill: varRef("panel-active-bg-color"),
                                stroke: varRef("panel-active-border-color")
                            }
                        },
                        [`${itemCls}-title, ${itemCls}-subtitle, ${itemCls}-content`]: {
                            color: varRef("item-icon-active-text-color")
                        }
                    }
                }
            },
            // ==========================================================
            // ==                         Size                         ==
            // ==========================================================
            {
                [`&${componentCls}-small`]: {
                    [varName("panel-padding")]: paddingXS,
                    [varName("item-border-radius")]: borderRadiusSM
                }
            },
            // ==========================================================
            // ==                        Filled                        ==
            // ==========================================================
            {
                [`&${componentCls}-filled`]: {
                    [itemCls]: {
                        "&:not(:first-child)": {
                            clipPath: `polygon(${[
                                `${(0, $05f34ed03d41967d$export$523c0b569236b342)(lineWidthBold)} 0`,
                                `calc(100% + ${varRef("item-base-width")}) 0`,
                                `calc(100% + ${varRef("item-base-width")}) 100%`,
                                `${(0, $05f34ed03d41967d$export$523c0b569236b342)(lineWidthBold)} 100%`,
                                `calc(${varRef("item-base-width")} + ${(0, $05f34ed03d41967d$export$523c0b569236b342)(lineWidthBold)}) 50%`
                            ].join(",")})`
                        }
                    }
                }
            },
            // ==========================================================
            // ==                       Outlined                       ==
            // ==========================================================
            {
                [`&${componentCls}-outlined`]: {
                    [`${componentCls}-panel-arrow`]: {
                        top: calc(lineWidthBold).div(2).mul(-1).equal(),
                        height: calc(lineWidthBold).add("100%").equal()
                    }
                }
            }
        ]
    };
};
var $1eff16e0c3a794a8$export$2e2bcd8739ae039 = $1eff16e0c3a794a8$var$genPanelStyle;



const $bdf53ccd651f4a76$var$genStepsProgressStyle = (token)=>{
    const { calc: calc, antCls: antCls, componentCls: componentCls, lineWidthBold: lineWidthBold, motionDurationSlow: motionDurationSlow } = token;
    const itemCls = `${componentCls}-item`;
    const [varName, varRef] = (0, $6870d4d7c14ae0bb$export$d82b8f66c5649e14)(antCls, "cmp-steps");
    const enhanceSize = calc(lineWidthBold).add(lineWidthBold).equal();
    return {
        [`${componentCls}${componentCls}-with-progress`]: {
            [varName("item-wrapper-padding-top")]: enhanceSize,
            [`${itemCls}${itemCls}-process`]: {
                [`${itemCls}-icon`]: {
                    position: "relative"
                }
            },
            [`${itemCls}-progress-icon`]: {
                "&-svg": {
                    [varName("svg-size")]: calc(enhanceSize).mul(2).add(varRef("icon-size")).equal(),
                    [varName("icon-size-ptg-unitless")]: `calc(100 / tan(atan2(${varRef("svg-size")}, 1px)))`,
                    fontSize: varRef("svg-size"),
                    lineHeight: varRef("icon-size-ptg-unitless"),
                    position: "absolute",
                    inset: calc(enhanceSize).mul(-1).equal(),
                    width: "auto",
                    height: "auto"
                },
                "&-circle": {
                    lineHeight: varRef("icon-size-ptg-unitless"),
                    strokeWidth: calc(varRef("icon-size-ptg-unitless")).mul(lineWidthBold).equal(),
                    [varName("progress-radius")]: calc(varRef("svg-size")).sub(lineWidthBold).mul(varRef("icon-size-ptg-unitless")).div(2).equal(),
                    r: varRef("progress-radius"),
                    fill: "none",
                    cx: 50,
                    cy: 50,
                    transition: `all ${motionDurationSlow} ease-in-out`,
                    "&-rail": {
                        stroke: token.colorSplit
                    },
                    "&-ptg": {
                        stroke: token.colorPrimary
                    }
                }
            }
        }
    };
};
var $bdf53ccd651f4a76$export$2e2bcd8739ae039 = $bdf53ccd651f4a76$var$genStepsProgressStyle;




const $0f2011d6e3422644$var$genDotStyle = (token)=>{
    const { componentCls: componentCls, iconSize: iconSize, dotSize: dotSize, dotCurrentSize: dotCurrentSize, marginXXS: marginXXS, lineWidthBold: lineWidthBold, fontSizeSM: fontSizeSM, antCls: antCls } = token;
    const itemCls = `${componentCls}-item`;
    const [varName, varRef] = (0, $6870d4d7c14ae0bb$export$d82b8f66c5649e14)(antCls, "cmp-steps");
    return {
        [`${componentCls}${componentCls}-dot`]: {
            [varName("icon-size-active")]: dotCurrentSize,
            [varName("icon-size")]: dotSize,
            [varName("dot-icon-size")]: dotSize,
            [varName("dot-icon-border-width")]: lineWidthBold,
            [varName("rail-size")]: lineWidthBold,
            [varName("icon-border-width")]: lineWidthBold,
            // ========================= Shared ==========================
            // Icon
            [`${itemCls}-custom ${itemCls}-icon`]: {
                fontSize: fontSizeSM
            },
            [`${itemCls}-icon`]: {
                position: "relative",
                "&:after": {
                    content: '""',
                    width: iconSize,
                    height: iconSize,
                    display: "block",
                    position: "absolute",
                    top: "50%",
                    left: {
                        _skip_check_: true,
                        value: "50%"
                    },
                    transform: "translate(-50%, -50%)"
                }
            },
            // // >>> active
            [`${itemCls}-active ${itemCls}-icon`]: {
                [varName("icon-size")]: varRef("icon-size-active")
            },
            // ======================= Horizontal ========================
            [`&${componentCls}-horizontal`]: {
                // With descriptionMaxWidth
                [`&, &${componentCls}-small`]: (0, $2bee063026c005fe$export$f0196ef13ff2a3b7)(token, marginXXS)
            }
        }
    };
};
var $0f2011d6e3422644$export$2e2bcd8739ae039 = $0f2011d6e3422644$var$genDotStyle;




const $7d5867adfc7fa48a$var$genRTLStyle = (token)=>{
    const { componentCls: componentCls, lineWidthBold: lineWidthBold, antCls: antCls } = token;
    const itemCls = `${componentCls}-item`;
    const [, varRef] = (0, $6870d4d7c14ae0bb$export$d82b8f66c5649e14)(antCls, "cmp-steps");
    return {
        [`${componentCls}${componentCls}-rtl`]: {
            direction: "rtl",
            // nav
            [`&${componentCls}-navigation${componentCls}-horizontal`]: {
                [`${itemCls}:after`]: {
                    transform: "translateY(-50%) rotate(-45deg)"
                }
            },
            // panel
            [`&${componentCls}-panel`]: {
                [`${componentCls}-panel-arrow`]: {
                    transform: `scaleX(-1)`
                },
                [`&${componentCls}-filled`]: {
                    [itemCls]: {
                        "&:not(:first-child)": {
                            clipPath: `polygon(${[
                                `calc(0px - ${varRef("item-base-width")}) 0px`,
                                `calc(100% - ${(0, $05f34ed03d41967d$export$523c0b569236b342)(lineWidthBold)}) 0px`,
                                `calc(100% - ${varRef("item-base-width")} - ${(0, $05f34ed03d41967d$export$523c0b569236b342)(lineWidthBold)}) 50%`,
                                `calc(100% - ${(0, $05f34ed03d41967d$export$523c0b569236b342)(lineWidthBold)}) 100%`,
                                `calc(0px - ${varRef("item-base-width")}) 100%`
                            ].join(",")})`
                        }
                    }
                }
            }
        }
    };
};
var $7d5867adfc7fa48a$export$2e2bcd8739ae039 = $7d5867adfc7fa48a$var$genRTLStyle;




const $3de58e3b2a094d60$var$genSmallStyle = (token)=>{
    const { componentCls: componentCls, iconSizeSM: iconSizeSM, fontSize: fontSize, lineHeight: lineHeight, marginXS: marginXS, fontHeight: fontHeight, marginSM: marginSM, paddingXS: paddingXS, antCls: antCls } = token;
    const [varName] = (0, $6870d4d7c14ae0bb$export$d82b8f66c5649e14)(antCls, "cmp-steps");
    return {
        [`${componentCls}${componentCls}-small`]: {
            [varName("icon-size")]: iconSizeSM,
            [varName("title-horizontal-item-margin")]: marginSM,
            [varName("title-vertical-row-gap")]: paddingXS,
            [varName("title-font-size")]: fontSize,
            [varName("title-line-height")]: lineHeight,
            [varName("title-horizontal-rail-margin")]: marginXS,
            [varName("title-horizontal-title-height")]: fontHeight,
            // Horizontal: label vertical
            [`&${componentCls}-horizontal${componentCls}-title-vertical`]: (0, $2bee063026c005fe$export$f0196ef13ff2a3b7)(token, marginXS)
        }
    };
};
var $3de58e3b2a094d60$export$2e2bcd8739ae039 = $3de58e3b2a094d60$var$genSmallStyle;



const $67ffb1e1c9c7fe43$export$d49353233049811e = "wait";
const $67ffb1e1c9c7fe43$export$a9cb6a5cf5715b5b = "process";
const $67ffb1e1c9c7fe43$export$1b962970083dc27b = "finish";
const $67ffb1e1c9c7fe43$export$6ef4b5709ac3acad = "error";
const $67ffb1e1c9c7fe43$var$genStatusStyle = (token)=>{
    const { componentCls: componentCls, colorTextDisabled: colorTextDisabled, colorTextLightSolid: colorTextLightSolid, colorPrimary: colorPrimary, colorTextLabel: colorTextLabel, colorError: colorError, colorErrorHover: colorErrorHover, colorErrorBgFilledHover: colorErrorBgFilledHover, colorFillTertiary: colorFillTertiary, colorErrorBg: colorErrorBg, colorPrimaryBgHover: colorPrimaryBgHover, colorPrimaryBg: colorPrimaryBg, colorText: colorText, colorTextDescription: colorTextDescription, colorBgContainer: colorBgContainer, colorPrimaryHover: colorPrimaryHover, lineType: lineType, antCls: antCls } = token;
    const itemCls = `${componentCls}-item`;
    const [varName, varRef] = (0, $6870d4d7c14ae0bb$export$d82b8f66c5649e14)(antCls, "cmp-steps");
    return {
        [componentCls]: [
            {
                // ========================= Variable =========================
                [itemCls]: {
                    // Normal
                    // >>> line
                    [varName("item-solid-line-color")]: "#000",
                    // >>> text
                    [varName("item-title-color")]: "#000",
                    [varName("item-content-color")]: "#000",
                    [varName("item-subtitle-color")]: varRef("item-content-color"),
                    // >>> icon
                    [varName("item-icon-custom-color")]: "#000",
                    [varName("item-icon-bg-color")]: "#000",
                    [varName("item-icon-border-color")]: "#000",
                    [varName("item-icon-text-color")]: "#fff",
                    // >>> dot
                    [varName("item-icon-dot-color")]: "#000",
                    [varName("item-icon-dot-bg-color")]: varRef("item-icon-dot-color"),
                    [varName("item-icon-dot-border-color")]: varRef("item-icon-dot-color"),
                    // Hover
                    // >>> text
                    [varName("item-text-hover-color")]: "#000",
                    // >>> icon
                    [varName("item-icon-bg-hover-color")]: varRef("item-icon-bg-color"),
                    [varName("item-icon-border-hover-color")]: varRef("item-icon-border-color"),
                    [varName("item-icon-text-hover-color")]: varRef("item-icon-text-color"),
                    // Active
                    // >>> text
                    [varName("item-content-active-color")]: varRef("item-content-color"),
                    // >>> icon
                    [varName("item-icon-active-bg-color")]: varRef("item-icon-bg-color"),
                    [varName("item-icon-active-border-color")]: varRef("item-icon-border-color"),
                    [varName("item-icon-active-text-color")]: varRef("item-icon-text-color"),
                    // Status
                    [varName("item-process-rail-line-style")]: lineType
                },
                // ========================= Template =========================
                // Normal
                // >>> line
                [`${itemCls}-rail`]: {
                    borderColor: varRef("item-solid-line-color")
                },
                // >>> icon
                [`${itemCls}-custom ${itemCls}-icon`]: {
                    color: varRef("item-icon-custom-color")
                },
                // >>> text
                [`${itemCls}-title`]: {
                    color: varRef("item-title-color")
                },
                [`${itemCls}-subtitle`]: {
                    color: varRef("item-subtitle-color")
                },
                [`${itemCls}-content`]: {
                    color: varRef("item-content-color")
                },
                // Active
                // >>> icon
                [`${itemCls}-active ${itemCls}-icon`]: {
                },
                // >>> text
                [`${itemCls}-active ${itemCls}-content`]: {
                    color: varRef("item-content-active-color")
                },
                // Hover
                // >>> text
                [`${itemCls}[role='button']:not(${itemCls}-active):hover`]: {
                    [`${itemCls}-title, ${itemCls}-content`]: {
                        color: varRef("item-text-hover-color")
                    }
                },
                // Not dot
                [`&:not(${componentCls}-dot)`]: {
                    [`${itemCls}:not(${itemCls}-custom)`]: {
                        [`${itemCls}-icon`]: {
                            background: varRef("item-icon-bg-color"),
                            borderColor: varRef("item-icon-border-color"),
                            color: varRef("item-icon-text-color")
                        },
                        // Hover
                        [`&[role='button']:not(${itemCls}-active):hover`]: {
                            [`${itemCls}-icon`]: {
                                background: varRef("item-icon-bg-hover-color"),
                                borderColor: varRef("item-icon-border-hover-color"),
                                color: varRef("item-icon-text-hover-color")
                            }
                        },
                        // Active
                        [`&${itemCls}-active`]: {
                            [`${itemCls}-icon`]: {
                                background: varRef("item-icon-active-bg-color"),
                                borderColor: varRef("item-icon-active-border-color"),
                                color: varRef("item-icon-active-text-color")
                            }
                        }
                    }
                },
                // Dot
                [`&${componentCls}-dot`]: {
                    [`${itemCls}-icon`]: {
                        background: varRef("item-icon-dot-bg-color"),
                        borderColor: varRef("item-icon-dot-border-color"),
                        color: varRef("item-icon-dot-color"),
                        [`&${itemCls}-icon-dot-custom`]: {
                            background: "transparent",
                            border: "none"
                        }
                    }
                }
            },
            {
                // ========================== Shared ==========================
                // Wait
                [`${itemCls}-${$67ffb1e1c9c7fe43$export$d49353233049811e}`]: {
                    [varName("item-icon-custom-color")]: colorTextDisabled,
                    [varName("item-title-color")]: colorTextDescription,
                    [varName("item-content-color")]: colorTextDescription,
                    [varName("item-content-active-color")]: colorText,
                    [varName("item-text-hover-color")]: colorPrimaryHover
                },
                [`${itemCls}-rail-${$67ffb1e1c9c7fe43$export$d49353233049811e}`]: {
                    [varName("item-solid-line-color")]: colorTextDisabled
                },
                // Process
                [`${itemCls}-${$67ffb1e1c9c7fe43$export$a9cb6a5cf5715b5b}`]: {
                    [varName("item-icon-custom-color")]: colorPrimary,
                    [varName("item-title-color")]: colorText,
                    [varName("item-content-color")]: colorTextDescription,
                    [varName("item-content-active-color")]: colorText,
                    [varName("item-text-hover-color")]: colorPrimaryHover
                },
                [`${itemCls}-rail-${$67ffb1e1c9c7fe43$export$a9cb6a5cf5715b5b}`]: {
                    [varName("item-solid-line-color")]: colorPrimary,
                    // Special for Timeline usage
                    [varName("rail-line-style")]: varRef("item-process-rail-line-style")
                },
                // Finish
                [`${itemCls}-${$67ffb1e1c9c7fe43$export$1b962970083dc27b}`]: {
                    [varName("item-icon-custom-color")]: colorPrimary,
                    [varName("item-title-color")]: colorText,
                    [varName("item-content-color")]: colorTextDescription,
                    [varName("item-content-active-color")]: colorText,
                    [varName("item-text-hover-color")]: colorPrimaryHover
                },
                [`${itemCls}-rail-${$67ffb1e1c9c7fe43$export$1b962970083dc27b}`]: {
                    [varName("item-solid-line-color")]: colorPrimary
                },
                // Error
                [`${itemCls}-${$67ffb1e1c9c7fe43$export$6ef4b5709ac3acad}`]: {
                    [varName("item-icon-custom-color")]: colorError,
                    [varName("item-title-color")]: colorError,
                    [varName("item-content-color")]: colorError,
                    [varName("item-content-active-color")]: colorError,
                    [varName("item-text-hover-color")]: colorErrorHover
                },
                [`${itemCls}-rail-${$67ffb1e1c9c7fe43$export$6ef4b5709ac3acad}`]: {
                    [varName("item-solid-line-color")]: colorError
                }
            },
            {
                // ========================== Filled ==========================
                [`&${componentCls}-filled`]: {
                    [itemCls]: {
                        [varName("item-icon-dot-border-color")]: "transparent"
                    },
                    // Wait
                    [`${itemCls}-${$67ffb1e1c9c7fe43$export$d49353233049811e}`]: {
                        [varName("item-icon-bg-color")]: colorFillTertiary,
                        [varName("item-icon-border-color")]: "transparent",
                        [varName("item-icon-text-color")]: colorTextLabel,
                        [varName("item-icon-dot-bg-color")]: colorTextDisabled,
                        // Hover
                        [varName("item-icon-bg-hover-color")]: colorPrimaryBgHover,
                        [varName("item-icon-border-hover-color")]: "transparent",
                        [varName("item-icon-text-hover-color")]: colorPrimary,
                        // Active
                        [varName("item-icon-active-bg-color")]: colorPrimary,
                        [varName("item-icon-active-border-color")]: "transparent",
                        [varName("item-icon-active-text-color")]: colorTextLightSolid
                    },
                    // Finish & Process
                    [`${itemCls}-${$67ffb1e1c9c7fe43$export$a9cb6a5cf5715b5b}, ${itemCls}-${$67ffb1e1c9c7fe43$export$1b962970083dc27b}`]: {
                        [varName("item-icon-bg-color")]: colorPrimaryBg,
                        [varName("item-icon-border-color")]: "transparent",
                        [varName("item-icon-text-color")]: colorPrimary,
                        [varName("item-icon-dot-bg-color")]: colorPrimary,
                        // Hover
                        [varName("item-icon-bg-hover-color")]: colorPrimaryBgHover,
                        [varName("item-icon-border-hover-color")]: "transparent",
                        [varName("item-icon-text-hover-color")]: colorPrimary,
                        // Active
                        [varName("item-icon-active-bg-color")]: colorPrimary,
                        [varName("item-icon-active-border-color")]: "transparent",
                        [varName("item-icon-active-text-color")]: colorTextLightSolid
                    },
                    // Error
                    [`${itemCls}-${$67ffb1e1c9c7fe43$export$6ef4b5709ac3acad}`]: {
                        [varName("item-icon-bg-color")]: colorErrorBg,
                        [varName("item-icon-border-color")]: "transparent",
                        [varName("item-icon-text-color")]: colorError,
                        [varName("item-icon-dot-bg-color")]: colorError,
                        // Hover
                        [varName("item-icon-bg-hover-color")]: colorErrorBgFilledHover,
                        [varName("item-icon-border-hover-color")]: "transparent",
                        [varName("item-icon-text-hover-color")]: colorError,
                        // Active
                        [varName("item-icon-active-bg-color")]: colorError,
                        [varName("item-icon-active-border-color")]: "transparent",
                        [varName("item-icon-active-text-color")]: colorTextLightSolid
                    }
                }
            },
            {
                // ========================= Outlined =========================
                [`&${componentCls}-outlined`]: {
                    [itemCls]: {
                        [varName("item-icon-dot-bg-color")]: "transparent"
                    },
                    // Wait
                    [`${itemCls}-${$67ffb1e1c9c7fe43$export$d49353233049811e}`]: {
                        [varName("item-icon-bg-color")]: colorBgContainer,
                        [varName("item-icon-border-color")]: colorTextDisabled,
                        [varName("item-icon-text-color")]: colorTextDisabled,
                        [varName("item-icon-dot-color")]: colorTextDisabled,
                        // Hover
                        [varName("item-icon-bg-hover-color")]: "transparent",
                        [varName("item-icon-border-hover-color")]: colorPrimaryHover,
                        [varName("item-icon-text-hover-color")]: colorPrimaryHover,
                        // Active
                        [varName("item-icon-active-bg-color")]: colorFillTertiary
                    },
                    // Finish & Process
                    [`${itemCls}-${$67ffb1e1c9c7fe43$export$a9cb6a5cf5715b5b}, ${itemCls}-${$67ffb1e1c9c7fe43$export$1b962970083dc27b}`]: {
                        [varName("item-icon-bg-color")]: colorBgContainer,
                        [varName("item-icon-border-color")]: colorPrimary,
                        [varName("item-icon-text-color")]: colorPrimary,
                        [varName("item-icon-dot-color")]: colorPrimary,
                        // Hover
                        [varName("item-icon-bg-hover-color")]: "transparent",
                        [varName("item-icon-border-hover-color")]: colorPrimaryHover,
                        [varName("item-icon-text-hover-color")]: colorPrimaryHover,
                        // Active
                        [varName("item-icon-active-bg-color")]: colorPrimaryBg
                    },
                    // Error
                    [`${itemCls}-${$67ffb1e1c9c7fe43$export$6ef4b5709ac3acad}`]: {
                        [varName("item-icon-bg-color")]: colorBgContainer,
                        [varName("item-icon-border-color")]: colorError,
                        [varName("item-icon-text-color")]: colorError,
                        [varName("item-icon-dot-color")]: colorError,
                        // Hover
                        [varName("item-icon-bg-hover-color")]: "transparent",
                        [varName("item-icon-border-hover-color")]: colorErrorHover,
                        [varName("item-icon-text-hover-color")]: colorErrorHover,
                        // Active
                        [varName("item-icon-active-bg-color")]: colorErrorBg
                    }
                }
            }
        ]
    };
};
var $67ffb1e1c9c7fe43$export$2e2bcd8739ae039 = $67ffb1e1c9c7fe43$var$genStatusStyle;



const $2859fbd85ba08916$var$genVerticalStyle = (token)=>{
    const { componentCls: componentCls, marginXXS: marginXXS, paddingSM: paddingSM, controlHeight: controlHeight, antCls: antCls, calc: calc } = token;
    const itemCls = `${componentCls}-item`;
    const [varName, varRef] = (0, $6870d4d7c14ae0bb$export$d82b8f66c5649e14)(antCls, "cmp-steps");
    return {
        [`${componentCls}-vertical`]: {
            [varName("vertical-rail-margin")]: calc(marginXXS).mul(1.5).equal(),
            flexDirection: "column",
            alignItems: "stretch",
            // Item
            [`> ${itemCls}`]: {
                minHeight: calc(controlHeight).mul(1.5).equal(),
                paddingBottom: paddingSM,
                "&:last-child": {
                    paddingBottom: 0
                },
                // Icon
                [`${itemCls}-icon`]: {
                    marginInlineStart: `calc((${varRef("icon-size-max")} - ${varRef("icon-size")}) / 2)`
                },
                // >>> Rail
                [`${itemCls}-rail`]: {
                    [varName("rail-offset")]: calc(varRef("heading-height")).sub(varRef("icon-size")).div(2).equal(),
                    borderInlineStartWidth: varRef("rail-size"),
                    position: "absolute",
                    top: calc(varRef("icon-size")).add(varRef("item-wrapper-padding-top")).add(varRef("rail-offset")).add(varRef("vertical-rail-margin")).equal(),
                    insetInlineStart: calc(varRef("icon-size-max")).div(2).equal(),
                    bottom: calc(varRef("vertical-rail-margin")).sub(varRef("rail-offset")).equal(),
                    marginInlineStart: `calc(${varRef("rail-size")} / -2)`
                }
            }
        }
    };
};
var $2859fbd85ba08916$export$2e2bcd8739ae039 = $2859fbd85ba08916$var$genVerticalStyle;


const $8adc1ce968828615$var$genBasicStyle = (token)=>{
    const { componentCls: componentCls, antCls: antCls } = token;
    const itemCls = `${componentCls}-item`;
    const [varName, varRef] = (0, $6870d4d7c14ae0bb$export$d82b8f66c5649e14)(antCls, "cmp-steps");
    return {
        [componentCls]: {
            [varName("title-font-size")]: token.fontSizeLG,
            [varName("title-line-height")]: token.lineHeightLG,
            [varName("subtitle-font-size")]: token.fontSize,
            [varName("subtitle-line-height")]: token.lineHeight,
            [varName("item-wrapper-padding-top")]: "0px",
            [varName("rail-size")]: token.lineWidth,
            [varName("rail-line-style")]: token.lineType,
            ...(0, $519d20bf207ce864$export$23997c3e44cc1c59)(token),
            display: "flex",
            flexWrap: "nowrap",
            alignItems: "flex-start",
            [itemCls]: {
                flex: "none",
                position: "relative"
            },
            [`${itemCls}-wrapper`]: {
                display: "flex",
                flexWrap: "nowrap",
                paddingTop: varRef("item-wrapper-padding-top")
            },
            // Icon
            // Check `./icon.ts`
            // Header
            [`${itemCls}-header`]: {
                display: "flex",
                flexWrap: "nowrap",
                alignItems: "center"
            },
            // >>> Title
            [`${itemCls}-title`]: {
                color: token.colorText,
                fontSize: varRef("title-font-size"),
                lineHeight: varRef("title-line-height"),
                wordBreak: "break-word"
            },
            // >>> Sub Title
            [`${itemCls}-subtitle`]: {
                color: token.colorTextDescription,
                fontWeight: "normal",
                fontSize: varRef("subtitle-font-size"),
                lineHeight: varRef("subtitle-line-height"),
                marginInlineStart: token.marginXS,
                wordBreak: "break-word"
            },
            // Content
            [`${itemCls}-content`]: {
                color: token.colorTextDescription,
                fontSize: token.fontSize,
                lineHeight: token.lineHeight,
                wordBreak: "break-word"
            },
            // Rail
            [`${itemCls}-rail`]: {
                borderStyle: varRef("rail-line-style"),
                borderWidth: 0
            },
            // Motion
            [`${itemCls}-title, ${itemCls}-subtitle, ${itemCls}-content, ${itemCls}-rail`]: {
                transition: `all ${token.motionDurationSlow}`
            },
            // ========================== Ellipsis ==========================
            [`&${componentCls}-ellipsis`]: {
                [`${itemCls}-title, ${itemCls}-subtitle, ${itemCls}-content`]: (0, $519d20bf207ce864$export$b2b65df0d0824629)
            },
            // ========================= Clickable ==========================
            [`${itemCls}[role='button']:focus-visible`]: (0, $519d20bf207ce864$export$6539948f0a737e39)(token),
            [`${itemCls}[role='button']:not(${itemCls}-active):hover`]: {
                cursor: "pointer"
            }
        }
    };
};
const $8adc1ce968828615$export$9ca1be8807fe0675 = (token)=>({
        titleLineHeight: token.controlHeight,
        customIconSize: token.controlHeight,
        customIconTop: 0,
        customIconFontSize: token.controlHeightSM,
        iconSize: token.controlHeight,
        iconTop: -0.5,
        // magic for ui experience
        iconFontSize: token.fontSize,
        iconSizeSM: token.fontSizeHeading3,
        dotSize: token.controlHeight / 4,
        dotCurrentSize: token.controlHeightLG / 4,
        navArrowColor: token.colorTextDisabled,
        navContentMaxWidth: "unset",
        descriptionMaxWidth: undefined,
        // should be `undefined` to create css var
        waitIconColor: token.wireframe ? token.colorTextDisabled : token.colorTextLabel,
        waitIconBgColor: token.wireframe ? token.colorBgContainer : token.colorFillContent,
        waitIconBorderColor: token.wireframe ? token.colorTextDisabled : "transparent",
        finishIconBgColor: token.wireframe ? token.colorBgContainer : token.controlItemBgActive,
        finishIconBorderColor: token.wireframe ? token.colorPrimary : token.controlItemBgActive
    });
var $8adc1ce968828615$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$51ec95de45185b42)("Steps", (token)=>{
    const stepsToken = (0, $fef50f256b80dfa5$export$4950aa0f605343fb)(token, {
        inlineDotSize: 6
    });
    return [
        $8adc1ce968828615$var$genBasicStyle(stepsToken),
        (0, $9851c7d254a5cbf3$export$2e2bcd8739ae039)(stepsToken),
        (0, $2859fbd85ba08916$export$2e2bcd8739ae039)(stepsToken),
        (0, $01ec0fe6b22f84dd$export$2e2bcd8739ae039)(stepsToken),
        (0, $125d0d1beb3a3f72$export$2e2bcd8739ae039)(stepsToken),
        (0, $3de58e3b2a094d60$export$2e2bcd8739ae039)(stepsToken),
        (0, $0f2011d6e3422644$export$2e2bcd8739ae039)(stepsToken),
        (0, $67ffb1e1c9c7fe43$export$2e2bcd8739ae039)(stepsToken),
        (0, $d0b15bbdd72f086b$export$2e2bcd8739ae039)(stepsToken),
        (0, $1eff16e0c3a794a8$export$2e2bcd8739ae039)(stepsToken),
        (0, $6b163469c42409f4$export$2e2bcd8739ae039)(stepsToken),
        (0, $ee5e6bb75817d665$export$2e2bcd8739ae039)(stepsToken),
        (0, $bdf53ccd651f4a76$export$2e2bcd8739ae039)(stepsToken),
        (0, $7d5867adfc7fa48a$export$2e2bcd8739ae039)(stepsToken)
    ];
}, $8adc1ce968828615$export$9ca1be8807fe0675);



var $cQmXV = parcelRequire("cQmXV");

/**
 * Normalize a real item into the collapsed display list.
 * The original item key is preserved when provided, otherwise the original index keeps
 * React reconciliation stable while visible steps move around the collapsed list.
 */ function $eaa80db0b3b89d94$var$getDisplayStep(item, index) {
    return {
        item: {
            ...item,
            key: item.key ?? index
        },
        originIndex: index
    };
}
/**
 * Build the disabled ellipsis item between two visible steps.
 * Its status reflects the hidden range so the connector still communicates
 * finished or error progress, and its key is derived from the adjacent real steps.
 */ function $eaa80db0b3b89d94$var$getEllipsisStep(items, currentIndex, prevIndex, nextIndex, prefixCls) {
    const prevKey = items[prevIndex].key ?? prevIndex;
    const nextKey = items[nextIndex].key ?? nextIndex;
    const hasError = items.slice(prevIndex + 1, nextIndex).some((step)=>step.status === "error");
    const ellipsisStatus = hasError ? "error" : nextIndex - 1 < currentIndex ? "finish" : "wait";
    return {
        item: {
            key: `ellipsis-${prevKey}-${nextKey}`,
            title: "",
            icon: /*#__PURE__*/ $cQmXV.createElement((0, $f172eb883972dae9$export$2e2bcd8739ae039)),
            status: ellipsisStatus,
            disabled: true,
            className: `${prefixCls}-item-ellipsis`
        },
        originIndex: -1
    };
}
/**
 * Pick the real step indexes that should remain visible when `maxCount` applies.
 * First, last, and current are always kept. Remaining slots are filled by priority:
 * current left, current right, first right, last left, then repeat at larger distances.
 *
 * `null` is inserted between non-contiguous indexes and later rendered as an ellipsis.
 */ function $eaa80db0b3b89d94$var$getCollapsedIndexes(total, currentIndex, maxCount) {
    const safeCurrent = Math.min(Math.max(currentIndex, 0), total - 1);
    const targetCount = Math.min(maxCount, total);
    const indexes = new Set([
        0,
        safeCurrent,
        total - 1
    ]);
    for(let distance = 1; indexes.size < targetCount && distance < total; distance += 1){
        const candidates = [
            safeCurrent - distance,
            safeCurrent + distance,
            distance,
            total - 1 - distance
        ];
        for (const index of candidates){
            if (indexes.size >= targetCount) break;
            if (index >= 0 && index < total) indexes.add(index);
        }
    }
    return Array.from(indexes).sort((a, b)=>a - b).flatMap((index, order, sortedIndexes)=>order > 0 && index - sortedIndexes[order - 1] > 1 ? [
            null,
            index
        ] : [
            index
        ]);
}
function $eaa80db0b3b89d94$export$2e2bcd8739ae039(mergedItems, current, initial, maxCount, prefixCls) {
    const canApplyMaxCount = maxCount !== undefined && maxCount >= 3 && mergedItems.length > maxCount;
    const mappedCurrent = current - initial;
    const displaySteps = $cQmXV.useMemo(()=>{
        if (!canApplyMaxCount) return mergedItems.map((item, originIndex)=>({
                item: item,
                originIndex: originIndex
            }));
        const collapsedIndexes = $eaa80db0b3b89d94$var$getCollapsedIndexes(mergedItems.length, mappedCurrent, maxCount);
        return collapsedIndexes.map((index, collapsedIndex)=>index === null ? $eaa80db0b3b89d94$var$getEllipsisStep(mergedItems, mappedCurrent, collapsedIndexes[collapsedIndex - 1], collapsedIndexes[collapsedIndex + 1], prefixCls) : $eaa80db0b3b89d94$var$getDisplayStep(mergedItems[index], index));
    }, [
        canApplyMaxCount,
        mappedCurrent,
        mergedItems,
        maxCount,
        prefixCls
    ]);
    const displayCurrent = displaySteps.findIndex((step)=>step.originIndex === mappedCurrent);
    return {
        canApplyMaxCount: canApplyMaxCount,
        displaySteps: displaySteps,
        mappedDisplayCurrent: displayCurrent >= 0 ? displayCurrent : mappedCurrent,
        displayItems: displaySteps.map((step)=>step.item)
    };
}


"use client";
const $bd4d3b77c380503b$var$waveEffectClassNames = {
    itemIcon: (0, $1f1e565d7b1db8d0$export$23466a5792b7a5d3)
};
const $bd4d3b77c380503b$var$Steps = (props)=>{
    const { size: // Style
    size, className: className, rootClassName: rootClassName, style: style, variant: variant = "filled", type: type, classNames: classNames, styles: styles, direction: // Layout
    direction, orientation: orientation, responsive: responsive = true, progressDot: progressDot, labelPlacement: labelPlacement, titlePlacement: titlePlacement, ellipsis: ellipsis, maxCount: maxCount, offset: offset = 0, items: // Data
    items, percent: percent, current: current = 0, initial: initial = 0, onChange: onChange, iconRender: // Render
    iconRender, // MISC
    ...restProps } = props;
    const internalContent = $cQmXV.useContext((0, $4eb4f06563db30e7$export$d056f9c7816498b6));
    const contextContent = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("steps");
    const { getPrefixCls: getPrefixCls, direction: rtlDirection, className: contextClassName, style: contextStyle } = contextContent;
    let contextClassNames;
    let contextStyles;
    let components = {};
    if (internalContent) components = {
        root: internalContent.rootComponent,
        item: internalContent.itemComponent
    };
    else ({ classNames: contextClassNames, styles: contextStyles } = contextContent);
    const rootPrefixCls = getPrefixCls();
    const prefixCls = getPrefixCls("steps", props.prefixCls);
    const itemIconCls = `${prefixCls}-item-icon`;
    const [hashId, cssVarCls] = (0, $8adc1ce968828615$export$2e2bcd8739ae039)(prefixCls);
    const [varName] = (0, $6870d4d7c14ae0bb$export$d82b8f66c5649e14)(rootPrefixCls, "cmp-steps");
    const mergedSize = (0, $78cdfb6138721329$export$2e2bcd8739ae039)(size);
    // ============================= Item =============================
    const mergedItems = $cQmXV.useMemo(()=>(items || []).filter(Boolean), [
        items
    ]);
    // ============================ Layout ============================
    const { xs: xs } = (0, $27af0f2a794acde0$export$2e2bcd8739ae039)(responsive);
    // Type
    const mergedType = $cQmXV.useMemo(()=>{
        if (type && type !== "default") return type;
        if (progressDot) return "dot";
        return type;
    }, [
        progressDot,
        type
    ]);
    const isInline = mergedType === "inline";
    const isDot = mergedType === "dot" || mergedType === "inline";
    // Progress Dot Render function
    const legacyProgressDotRender = $cQmXV.useMemo(()=>{
        return mergedType === "dot" && (0, $8e2d153a3c855782$export$f6e2535fb5126e54)(progressDot) ? progressDot : undefined;
    }, [
        mergedType,
        progressDot
    ]);
    const mergedOrientation = $cQmXV.useMemo(()=>{
        const nextOrientation = orientation || direction;
        if (mergedType === "panel") return "horizontal";
        return responsive && xs || nextOrientation === "vertical" ? "vertical" : "horizontal";
    }, [
        orientation,
        direction,
        mergedType,
        responsive,
        xs
    ]);
    const mergedTitlePlacement = $cQmXV.useMemo(()=>{
        if (isDot || mergedOrientation === "vertical") return mergedOrientation === "vertical" ? "horizontal" : "vertical";
        if (type === "navigation") return "horizontal";
        return titlePlacement || labelPlacement || "horizontal";
    }, [
        isDot,
        labelPlacement,
        mergedOrientation,
        titlePlacement,
        type
    ]);
    // ========================== Percentage ==========================
    const mergedPercent = isInline ? undefined : percent;
    const { canApplyMaxCount: canApplyMaxCount, displaySteps: displaySteps, mappedDisplayCurrent: mappedDisplayCurrent, displayItems: displayItems } = (0, $eaa80db0b3b89d94$export$2e2bcd8739ae039)(mergedItems, current, initial, maxCount, prefixCls);
    // =========== Merged Props for Semantic ===========
    const mergedProps = {
        ...props,
        variant: variant,
        size: mergedSize,
        type: mergedType,
        orientation: mergedOrientation,
        titlePlacement: mergedTitlePlacement,
        current: current,
        initial: initial,
        percent: mergedPercent,
        responsive: responsive,
        offset: offset,
        ellipsis: ellipsis,
        maxCount: maxCount
    };
    // ============================ Styles ============================
    const contextStyleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $30c5f9f911d4f61b$export$648566b068f28737)([
        $bd4d3b77c380503b$var$waveEffectClassNames,
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: mergedProps
    });
    // ============================= Icon =============================
    const internalIconRender = (_, info)=>{
        const { item: item, index: index, active: active, components: { Icon: StepIcon } } = info;
        const originIndex = displaySteps[index]?.originIndex;
        const mappedIndex = originIndex !== undefined && originIndex >= 0 ? initial + originIndex : index;
        const { status: status, icon: icon } = item;
        let iconContent = null;
        if (isDot || icon) iconContent = icon;
        else switch(status){
            case "finish":
                iconContent = /*#__PURE__*/ $cQmXV.createElement((0, $77ccca814b0c39fe$export$2e2bcd8739ae039), {
                    className: `${itemIconCls}-finish`
                });
                break;
            case "error":
                iconContent = /*#__PURE__*/ $cQmXV.createElement((0, $837faca566926e3c$export$2e2bcd8739ae039), {
                    className: `${itemIconCls}-error`
                });
                break;
            default:
                {
                    let numNode = /*#__PURE__*/ $cQmXV.createElement("span", {
                        className: `${itemIconCls}-number`
                    }, mappedIndex + 1);
                    if (status === "process" && mergedPercent !== undefined) numNode = /*#__PURE__*/ $cQmXV.createElement((0, $50a3991d999afde0$export$2e2bcd8739ae039), {
                        prefixCls: prefixCls,
                        rootPrefixCls: rootPrefixCls,
                        percent: mergedPercent
                    }, numNode);
                    iconContent = numNode;
                }
        }
        let iconNode = /*#__PURE__*/ $cQmXV.createElement(StepIcon, null, iconContent);
        // Custom Render Props
        if (iconRender) iconNode = iconRender(iconNode, {
            index: mappedIndex,
            active: active,
            item: item,
            components: {
                Icon: StepIcon
            }
        });
        else if ((0, $8e2d153a3c855782$export$f6e2535fb5126e54)(legacyProgressDotRender)) iconNode = legacyProgressDotRender(iconNode, {
            index: mappedIndex,
            ...item
        });
        return iconNode;
    };
    // ============================ Custom ============================
    const itemRender = (itemNode, itemInfo)=>{
        let content = itemNode;
        if (isInline && itemInfo.item.content) content = /*#__PURE__*/ $cQmXV.createElement((0, $1e5256cf9d329b2c$export$2e2bcd8739ae039), {
            destroyOnHidden: true,
            title: itemInfo.item.content
        }, itemNode);
        return /*#__PURE__*/ $cQmXV.createElement((0, $02f5adbd0068e010$export$2e2bcd8739ae039), {
            component: "Steps",
            disabled: itemInfo.item.disabled || !onChange,
            colorSource: variant === "filled" ? "color" : null
        }, content);
    };
    const itemWrapperRender = mergedType === "panel" ? (itemNode)=>{
        return /*#__PURE__*/ $cQmXV.createElement($cQmXV.Fragment, null, itemNode, /*#__PURE__*/ $cQmXV.createElement((0, $df49e983f4225348$export$2e2bcd8739ae039), {
            prefixCls: prefixCls
        }));
    } : undefined;
    // ============================ Styles ============================
    const mergedStyle = {
        [varName("items-offset")]: `${offset}`
    };
    const stepsClassName = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(contextClassName, `${prefixCls}-${variant}`, {
        [`${prefixCls}-${mergedType}`]: mergedType !== "dot" ? mergedType : false,
        [`${prefixCls}-rtl`]: rtlDirection === "rtl",
        [`${prefixCls}-dot`]: isDot,
        [`${prefixCls}-ellipsis`]: ellipsis,
        [`${prefixCls}-max-count`]: canApplyMaxCount,
        [`${prefixCls}-with-progress`]: mergedPercent !== undefined,
        [`${prefixCls}-small`]: mergedSize === "small"
    }, className, rootClassName, hashId, cssVarCls);
    var item;
    const onDisplayChange = (displayCurrent)=>{
        const target = displaySteps[displayCurrent];
        if (onChange && target && target.originIndex >= 0) onChange(initial + target.originIndex);
    };
    // ============================ Render ============================
    return /*#__PURE__*/ $cQmXV.createElement((0, $4d86378bf681e560$export$2e2bcd8739ae039), {
        ...restProps,
        // Style
        prefixCls: prefixCls,
        className: stepsClassName,
        style: mergedStyle,
        classNames: mergedClassNames,
        styles: mergedStyles,
        // Layout
        orientation: mergedOrientation,
        titlePlacement: mergedTitlePlacement,
        components: components,
        // Data
        initial: 0,
        current: mappedDisplayCurrent,
        items: displayItems,
        onChange: onChange ? onDisplayChange : undefined,
        // Render
        iconRender: internalIconRender,
        itemRender: itemRender,
        itemWrapperRender: itemWrapperRender
    });
};
var $bd4d3b77c380503b$export$2e2bcd8739ae039 = $bd4d3b77c380503b$var$Steps;









const $b041126987fcc0be$var$genHorizontalStyle = (token)=>{
    const { componentCls: componentCls, fontHeight: fontHeight, antCls: antCls, paddingXS: paddingXS } = token;
    const [stepsVarName, stepsVarRef] = (0, $6870d4d7c14ae0bb$export$d82b8f66c5649e14)(antCls, "cmp-steps");
    const [timelineVarName, timelineVarRef] = (0, $6870d4d7c14ae0bb$export$d82b8f66c5649e14)(antCls, "timeline");
    const itemCls = `${componentCls}-item`;
    return {
        [`${componentCls}-horizontal`]: {
            [stepsVarName("title-vertical-row-gap")]: paddingXS,
            [timelineVarName("content-height")]: (0, $05f34ed03d41967d$export$523c0b569236b342)(fontHeight),
            // =============================================================
            // ==                          Share                          ==
            // =============================================================
            alignItems: "stretch",
            // =============================================================
            // ==                        Alternate                        ==
            // =============================================================
            [`&${componentCls}-layout-alternate`]: {
                [itemCls]: {
                    [`${itemCls}-wrapper`]: {
                        [timelineVarName("alternate-content-offset")]: `calc(${timelineVarRef("content-height")} + ${stepsVarRef("title-vertical-row-gap")} * 2 + ${stepsVarRef("icon-size-max")})`,
                        height: `calc(${timelineVarRef("content-height")} * 2 + ${stepsVarRef("title-vertical-row-gap")} * 2 + ${stepsVarRef("icon-size-max")})`
                    },
                    // Icon
                    [`${itemCls}-icon`]: {
                        position: "absolute"
                    },
                    // Icon & Rail
                    [`${itemCls}-icon, ${itemCls}-rail`]: {
                        position: "absolute",
                        top: "50%",
                        transform: "translateY(-50%)",
                        margin: 0
                    },
                    // Title & Content
                    [`${itemCls}-title, ${itemCls}-subtitle, ${itemCls}-content`]: {
                        whiteSpace: "nowrap",
                        maxWidth: "unset"
                    },
                    // Title
                    [`${itemCls}-title`]: {
                        position: "absolute",
                        left: {
                            _skip_check_: true,
                            value: "50%"
                        },
                        transform: "translateX(-50%)"
                    },
                    // Content
                    [`${itemCls}-content`]: {
                        position: "absolute",
                        left: {
                            _skip_check_: true,
                            value: "50%"
                        },
                        transform: "translateX(-50%)"
                    },
                    // Placement
                    "&-placement-start": {
                        [`${itemCls}-title`]: {
                            bottom: timelineVarRef("alternate-content-offset")
                        },
                        [`${itemCls}-content`]: {
                            top: timelineVarRef("alternate-content-offset")
                        }
                    },
                    "&-placement-end": {
                        [`${itemCls}-title`]: {
                            top: timelineVarRef("alternate-content-offset")
                        },
                        [`${itemCls}-content`]: {
                            bottom: timelineVarRef("alternate-content-offset")
                        }
                    }
                }
            },
            // =============================================================
            // ==                        Same Side                        ==
            // =============================================================
            [`&:not(${componentCls}-layout-alternate)`]: {
                [`${itemCls}-placement-end`]: {
                    display: "flex",
                    alignItems: "flex-end",
                    [`${itemCls}-wrapper`]: {
                        flex: "auto",
                        flexDirection: "column-reverse"
                    },
                    [`${itemCls}-rail`]: {
                        top: "auto",
                        bottom: stepsVarRef("horizontal-rail-margin"),
                        transform: "translateY(50%)"
                    }
                }
            }
        }
    };
};
var $b041126987fcc0be$export$2e2bcd8739ae039 = $b041126987fcc0be$var$genHorizontalStyle;


const $c594ebddfa9fa6d4$var$genTimelineStyle = (token)=>{
    const { componentCls: componentCls, tailColor: tailColor, fontHeight: fontHeight, dotSize: dotSize, dotBg: dotBg, dotBorderWidth: dotBorderWidth, fontSize: fontSize, lineHeight: lineHeight, colorText: colorText, tailWidth: tailWidth, colorPrimary: colorPrimary, colorError: colorError, colorSuccess: colorSuccess, colorTextDisabled: colorTextDisabled, antCls: antCls } = token;
    const itemCls = `${componentCls}-item`;
    const [varName, varRef] = (0, $6870d4d7c14ae0bb$export$d82b8f66c5649e14)(antCls, "cmp-steps");
    return {
        [componentCls]: [
            // ==============================================================
            // ==                           Item                           ==
            // ==============================================================
            {
                ...(0, $519d20bf207ce864$export$23997c3e44cc1c59)(token),
                [itemCls]: {
                    [varName("title-horizontal-title-height")]: fontHeight,
                    [varName("vertical-rail-margin")]: "0px",
                    [varName("title-horizontal-rail-gap")]: "0px",
                    // Root Level: Record Steps icon size and support fallback
                    [varName("icon-dot-size-origin")]: varRef("icon-size-active"),
                    [varName("icon-dot-size-custom")]: dotSize,
                    // Item Level: Record Steps icon color and support fallback
                    [varName("item-icon-dot-bg-color-origin")]: varRef("item-icon-dot-bg-color"),
                    [varName("item-icon-dot-bg-color-custom")]: dotBg,
                    [varName("icon-size")]: varRef("icon-dot-size-custom", varRef("icon-dot-size-origin")),
                    // Icon
                    [`${itemCls}-icon`]: {
                        [varName("dot-icon-border-width")]: dotBorderWidth,
                        [varName("dot-icon-size")]: varRef("icon-size"),
                        [varName("item-icon-dot-bg-color")]: varRef("item-icon-dot-bg-color-custom", varRef("item-icon-dot-bg-color-origin"))
                    },
                    // Title
                    [`${itemCls}-title`]: {
                        fontSize: fontSize,
                        lineHeight: lineHeight
                    },
                    // Content
                    [`${itemCls}-content`]: {
                        color: colorText
                    },
                    // Rail
                    [`${itemCls}-rail`]: {
                        [varName("item-solid-line-color")]: tailColor,
                        [varName("rail-size")]: tailWidth
                    }
                }
            },
            // ==============================================================
            // ==                          Status                          ==
            // ==============================================================
            {
                [itemCls]: {
                    [varName("item-process-rail-line-style")]: "dotted"
                },
                [`${itemCls}${itemCls}${itemCls}-color`]: {
                    "&-blue": {
                        [varName("item-icon-dot-color")]: colorPrimary
                    },
                    "&-red": {
                        [varName("item-icon-dot-color")]: colorError
                    },
                    "&-green": {
                        [varName("item-icon-dot-color")]: colorSuccess
                    },
                    "&-gray": {
                        [varName("item-icon-dot-color")]: colorTextDisabled
                    }
                }
            }
        ]
    };
};
const $c594ebddfa9fa6d4$var$genVerticalStyle = (token)=>{
    const { calc: calc, componentCls: componentCls, itemPaddingBottom: itemPaddingBottom, margin: margin, antCls: antCls } = token;
    const itemCls = `${componentCls}-item`;
    const [, stepsVarRef] = (0, $6870d4d7c14ae0bb$export$d82b8f66c5649e14)(antCls, "cmp-steps");
    const [timelineVarName, timelineVarRef] = (0, $6870d4d7c14ae0bb$export$d82b8f66c5649e14)(antCls, "timeline");
    return {
        [`${componentCls}:not(${componentCls}-horizontal)`]: {
            [timelineVarName("head-span")]: "12",
            [timelineVarName("head-span-ptg")]: `calc(${timelineVarRef("head-span")} / 24 * 100%)`,
            // =============================================================
            // ==                        Alternate                        ==
            // =============================================================
            [`&${componentCls}-layout-alternate`]: {
                [itemCls]: {
                    [timelineVarName("alternate-gap")]: calc(margin).mul(2).add(stepsVarRef("dot-icon-size")).equal(),
                    minHeight: "auto",
                    paddingBottom: itemPaddingBottom,
                    // Icon & Rail
                    [`${itemCls}-icon, ${itemCls}-rail`]: {
                        position: "absolute",
                        insetInlineStart: timelineVarRef("head-span-ptg")
                    },
                    // Icon
                    [`${itemCls}-icon`]: {
                        marginInlineStart: `calc(${stepsVarRef("icon-size")} / -2)`
                    },
                    // Section
                    [`${itemCls}-section`]: {
                        display: "flex",
                        flexWrap: "nowrap",
                        gap: timelineVarRef("alternate-gap")
                    },
                    // >>> Header
                    [`${itemCls}-header`]: {
                        textAlign: "end",
                        flexDirection: "column",
                        alignItems: "stretch",
                        flex: `1 1 calc(${timelineVarRef("head-span-ptg")} - ${timelineVarRef("alternate-gap")} / 2)`
                    },
                    // >>> Content
                    [`${itemCls}-content`]: {
                        textAlign: "start",
                        flex: `1 1 calc(100% - ${timelineVarRef("head-span-ptg")} - ${timelineVarRef("alternate-gap")} / 2)`
                    },
                    // Placement
                    "&-placement-end": {
                        [`${itemCls}-header`]: {
                            textAlign: "start",
                            order: 1
                        },
                        [`${itemCls}-content`]: {
                            textAlign: "end"
                        },
                        [`${itemCls}-icon, ${itemCls}-rail`]: {
                            insetInlineStart: `calc(100% - ${timelineVarRef("head-span-ptg")})`
                        }
                    }
                }
            },
            // =============================================================
            // ==                        Same Side                        ==
            // =============================================================
            [`&:not(${componentCls}-layout-alternate)`]: {
                [`${itemCls}-placement-end`]: {
                    textAlign: "end",
                    [`${itemCls}-icon`]: {
                        order: 1
                    },
                    [`${itemCls}-rail`]: {
                        insetInlineStart: "auto",
                        insetInlineEnd: `calc(${stepsVarRef("icon-size")} / 2)`,
                        marginInlineEnd: `calc(${stepsVarRef("rail-size")} / -2)`
                    }
                }
            }
        }
    };
};
const $c594ebddfa9fa6d4$export$9ca1be8807fe0675 = (token)=>({
        tailColor: token.colorSplit,
        tailWidth: token.lineWidthBold,
        dotBorderWidth: token.lineWidthBold,
        dotBg: undefined,
        dotSize: undefined,
        itemPaddingBottom: token.padding * 1.25
    });
var $c594ebddfa9fa6d4$export$2e2bcd8739ae039 = (0, $6870d4d7c14ae0bb$export$51ec95de45185b42)("Timeline", (token)=>{
    const timeLineToken = (0, $fef50f256b80dfa5$export$4950aa0f605343fb)(token, {
        itemHeadSize: 10,
        customHeadPaddingVertical: token.paddingXXS,
        paddingInlineEnd: 2
    });
    return [
        $c594ebddfa9fa6d4$var$genTimelineStyle(timeLineToken),
        $c594ebddfa9fa6d4$var$genVerticalStyle(timeLineToken),
        (0, $b041126987fcc0be$export$2e2bcd8739ae039)(timeLineToken)
    ];
}, $c594ebddfa9fa6d4$export$9ca1be8807fe0675);



var $cQmXV = parcelRequire("cQmXV");




"use client";
const $0dac6f0806fe5fd8$var$useItems = (rootPrefixCls, prefixCls, mode, items, children, pending, pendingDot)=>{
    const itemCls = `${prefixCls}-item`;
    const [varName] = (0, $6870d4d7c14ae0bb$export$d82b8f66c5649e14)(rootPrefixCls, "cmp-steps");
    // Merge items and children
    const parseItems = $cQmXV.useMemo(()=>{
        return Array.isArray(items) ? items : (0, $cd966a313e0a92ff$export$2e2bcd8739ae039)(children).map((ele)=>({
                ...ele.props
            }));
    }, [
        items,
        children
    ]);
    // convert legacy type
    return $cQmXV.useMemo(()=>{
        const mergedItems = parseItems.map((item, index)=>{
            const { label: label, children: children, title: title, content: content, color: color, className: className, style: style, icon: icon, dot: dot, placement: placement, position: position, loading: loading, ...restProps } = item;
            let mergedStyle = style;
            let mergedClassName = className;
            if (color) {
                if ([
                    "blue",
                    "red",
                    "green",
                    "gray"
                ].includes(color)) mergedClassName = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(className, `${itemCls}-color-${color}`);
                else mergedStyle = {
                    [varName("item-icon-dot-color")]: color,
                    ...style
                };
            }
            // Placement
            const mergedPlacement = placement ?? position ?? (mode === "alternate" ? index % 2 === 0 ? "start" : "end" : mode);
            mergedClassName = (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(mergedClassName, `${itemCls}-placement-${mergedPlacement}`);
            // Icon
            let mergedIcon = icon ?? dot;
            if (!mergedIcon && loading) mergedIcon = /*#__PURE__*/ $cQmXV.createElement((0, $bf7996ca956facd7$export$2e2bcd8739ae039), null);
            return {
                ...restProps,
                title: title ?? label,
                content: content ?? children,
                style: mergedStyle,
                className: mergedClassName,
                icon: mergedIcon,
                status: loading ? "process" : "finish"
            };
        });
        if (pending) mergedItems.push({
            icon: pendingDot ?? /*#__PURE__*/ $cQmXV.createElement((0, $bf7996ca956facd7$export$2e2bcd8739ae039), null),
            content: pending,
            status: "process"
        });
        return mergedItems;
    }, [
        parseItems,
        pending,
        mode,
        itemCls,
        varName,
        pendingDot
    ]);
};
var $0dac6f0806fe5fd8$export$2e2bcd8739ae039 = $0dac6f0806fe5fd8$var$useItems;


"use client";
const $4c7225a0e2af061a$var$stepInternalContext = {
    rootComponent: "ol",
    itemComponent: "li"
};
const $4c7225a0e2af061a$var$Timeline = (props)=>{
    const { getPrefixCls: getPrefixCls, direction: direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, $82ffd17441b57982$export$46f4bd6436a25a31)("timeline");
    const { prefixCls: customizePrefixCls, className: // Style
    className, style: style, classNames: classNames, styles: styles, variant: // Design
    variant = "outlined", mode: mode, orientation: orientation = "vertical", titleSpan: titleSpan, items: // Data
    items, children: children, reverse: reverse, pending: // Legacy Pending
    pending, pendingDot: pendingDot, ...restProps } = props;
    // ===================== MISC =======================
    const rootPrefixCls = getPrefixCls();
    const prefixCls = getPrefixCls("timeline", customizePrefixCls);
    // ==================== Styles ======================
    // This will be duplicated with Steps's hashId & cssVarCls when they have same token
    // But this is safe to keep here since web will do nothing
    const [hashId, cssVarCls] = (0, $c594ebddfa9fa6d4$export$2e2bcd8739ae039)(prefixCls);
    const [varName] = (0, $6870d4d7c14ae0bb$export$d82b8f66c5649e14)(rootPrefixCls, "timeline");
    const stepsClassNames = $cQmXV.useMemo(()=>({
            item: `${prefixCls}-item`,
            itemTitle: `${prefixCls}-item-title`,
            itemIcon: `${prefixCls}-item-icon`,
            itemContent: `${prefixCls}-item-content`,
            itemRail: `${prefixCls}-item-rail`,
            itemWrapper: `${prefixCls}-item-wrapper`,
            itemSection: `${prefixCls}-item-section`,
            itemHeader: `${prefixCls}-item-header`
        }), [
        prefixCls
    ]);
    // ===================== Mode =======================
    const mergedMode = $cQmXV.useMemo(()=>{
        // Deprecated
        if (mode === "left") return "start";
        if (mode === "right") return "end";
        // Fill
        const modeList = [
            "alternate",
            "start",
            "end"
        ];
        return modeList.includes(mode) ? mode : "start";
    }, [
        mode
    ]);
    // ===================== Data =======================
    const rawItems = (0, $0dac6f0806fe5fd8$export$2e2bcd8739ae039)(rootPrefixCls, prefixCls, mergedMode, items, children, pending, pendingDot);
    const mergedItems = $cQmXV.useMemo(()=>reverse ? (0, $68381b18b974dc9f$export$2e2bcd8739ae039)(rawItems).reverse() : rawItems, [
        reverse,
        rawItems
    ]);
    // =========== Merged Props for Semantic ===========
    const mergedProps = {
        ...props,
        variant: variant,
        mode: mergedMode,
        orientation: orientation,
        items: mergedItems
    };
    const contextStyleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(contextStyle);
    const styleRoot = (0, $30c5f9f911d4f61b$export$e6b3587a05cff7e4)(style);
    const [mergedClassNames, mergedStyles] = (0, $30c5f9f911d4f61b$export$648566b068f28737)([
        stepsClassNames,
        contextClassNames,
        classNames
    ], [
        contextStyles,
        contextStyleRoot,
        styles,
        styleRoot
    ], {
        props: mergedProps
    });
    const stepContext = $cQmXV.useMemo(()=>({
            railFollowPrevStatus: reverse
        }), [
        reverse
    ]);
    // ==================== Design ======================
    const layoutAlternate = $cQmXV.useMemo(()=>mergedMode === "alternate" || orientation === "vertical" && mergedItems.some((item)=>item.title), [
        mergedItems,
        mergedMode,
        orientation
    ]);
    var oldProp, newProp, item;
    // ==================== Render ======================
    const stepStyle = {};
    if ((0, $8e2d153a3c855782$export$826fff653a329e83)(titleSpan) && mergedMode !== "alternate") {
        if ((0, $8e2d153a3c855782$export$7e4aa119212bc614)(titleSpan)) stepStyle[varName("head-span")] = titleSpan;
        else stepStyle[varName("head-span-ptg")] = titleSpan;
    }
    return /*#__PURE__*/ $cQmXV.createElement((0, $4eb4f06563db30e7$export$d056f9c7816498b6).Provider, {
        value: $4c7225a0e2af061a$var$stepInternalContext
    }, /*#__PURE__*/ $cQmXV.createElement((0, $57d4307ad96576f3$export$e508d6f1a100e5dd).Provider, {
        value: stepContext
    }, /*#__PURE__*/ $cQmXV.createElement((0, $bd4d3b77c380503b$export$2e2bcd8739ae039), {
        ...restProps,
        // Style
        className: (0, $772fd6e40f1fbf40$export$4f5d2d50c9deca37)(prefixCls, contextClassName, className, hashId, cssVarCls, {
            [`${prefixCls}-${orientation}`]: orientation === "horizontal",
            [`${prefixCls}-layout-alternate`]: layoutAlternate,
            [`${prefixCls}-rtl`]: direction === "rtl"
        }),
        style: stepStyle,
        classNames: mergedClassNames,
        styles: mergedStyles,
        // Design
        variant: variant,
        orientation: orientation,
        // Layout
        type: "dot",
        items: mergedItems,
        current: mergedItems.length - 1
    })));
};
$4c7225a0e2af061a$var$Timeline.Item = ()=>{};
var $4c7225a0e2af061a$export$2e2bcd8739ae039 = $4c7225a0e2af061a$var$Timeline;


"use client";
var $11b45828f3043c61$export$2e2bcd8739ae039 = (0, $4c7225a0e2af061a$export$2e2bcd8739ae039);










/**
 * Reading the recorded GPS track off `visit.meta` — pure and dependency-free, so `yarn check:gps`
 * runs it under node the way `check:tracking` runs `tracking/derive.js`.
 *
 * The mobile app (`sendLog` in picsell_api.dart) PATCHes the visit at close with
 *   { visitWithoutGeoData: bool, logs: "<JSON STRING of LocationLog[]>" }
 * where a LocationLog is { latitude, longitude (STRINGS), dateTime (device-local
 * "YYYY-MM-DD HH:mm:ss.ffffff", no zone), gpsEnabled, permissionsGranted, isFake }.
 * `meta` arrives only from `VisitDetailSerializer`; older rows and other writers may hold a bare
 * list, so every plausible shape is accepted rather than assumed.
 *
 * ⚠ A FAILED fix is written as latitude = longitude = -1 (`TrySetLocationAction`, whenever the
 * service is off, permission is denied, there is no connection, or the fix itself fails). That is a
 * real coordinate in the Gulf of Guinea, not an absence, so it is dropped here.
 */ /** A ping the mobile app marked as coming from a mock-location provider (`isFake`, from Android's
    isMocked). A flagged ping turns its dot red and raises the section's warning (PICSELL-1581 #5). */ const $74749913e46c60bd$export$550fa1786590653d = (ping)=>ping.mock === true || ping.mock === 1 || ping.mock === "true";
function $74749913e46c60bd$export$6caac4d0ccca49a8(visit) {
    return $74749913e46c60bd$export$9ccb3aa0a7b3126d(visit?.meta).map((entry)=>{
        if (Array.isArray(entry) && entry.length >= 2) return {
            pos: [
                $74749913e46c60bd$var$coord(entry[0]),
                $74749913e46c60bd$var$coord(entry[1])
            ]
        };
        if (entry && typeof entry === "object") {
            const lat = entry.latitude ?? entry.lat;
            const lng = entry.longitude ?? entry.lng ?? entry.lon;
            if (lat !== undefined && lng !== undefined) return {
                pos: [
                    $74749913e46c60bd$var$coord(lat),
                    $74749913e46c60bd$var$coord(lng)
                ],
                mock: entry.isFake ?? entry.mock ?? entry.is_mock ?? entry.isFromMockProvider ?? entry.is_from_mock_provider,
                time: $74749913e46c60bd$var$isoTime(entry.dateTime ?? entry.time ?? entry.timestamp ?? entry.created ?? entry.date)
            };
        }
        return null;
    }).filter((ping)=>ping && Number.isFinite(ping.pos[0]) && Number.isFinite(ping.pos[1]) && !(ping.pos[0] === -1 && ping.pos[1] === -1));
}
function $74749913e46c60bd$export$85c1126bdbff8196([lat1, lng1], [lat2, lng2]) {
    const rad = (deg)=>deg * Math.PI / 180;
    const dLat = rad(lat2 - lat1);
    const dLng = rad(lng2 - lng1);
    const a = Math.sin(dLat / 2) ** 2 + Math.cos(rad(lat1)) * Math.cos(rad(lat2)) * Math.sin(dLng / 2) ** 2;
    return 12742000 * Math.asin(Math.sqrt(a));
}
const $74749913e46c60bd$export$2c14ff85d6318973 = (metres, units, locale)=>metres < 1000 ? `${Math.round(metres)} ${units.m}` : `${(metres / 1000).toLocaleString(locale, {
        maximumFractionDigits: 1
    })} ${units.km}`;
/** `Number(null)` and `Number("")` are both 0 — the equator, not "missing". */ const $74749913e46c60bd$var$coord = (value)=>value === null || value === "" ? NaN : Number(value);
/** Dart's `DateTime.now().toString()` is "2026-09-09 12:42:12.664627"; Safari rejects the space and
    a fraction longer than three digits, so hand `Date` the ISO form. It carries no zone, so it reads
    as the viewer's local time — the merchandiser's zone in every case this app serves. */ const $74749913e46c60bd$var$isoTime = (value)=>typeof value === "string" ? value.replace(" ", "T").replace(/(\.\d{3})\d+/, "$1") : value;
function $74749913e46c60bd$export$9ccb3aa0a7b3126d(meta) {
    if (typeof meta === "string" && meta) try {
        meta = JSON.parse(meta);
    } catch  {
        return [];
    }
    if (Array.isArray(meta)) return meta;
    if (meta && typeof meta === "object" && "logs" in meta) return $74749913e46c60bd$export$9ccb3aa0a7b3126d(meta.logs);
    return [];
}




/* ------------------------------------------------------------------ helpers */ const $b8606fd3839b989b$var$rowsOf = (response)=>Array.isArray(response) ? response : response?.results || [];
const $b8606fd3839b989b$export$1d6cfa7493842c29 = (user)=>user ? [
        user.first_name,
        user.last_name
    ].filter(Boolean).join(" ") : "";
const $b8606fd3839b989b$export$5517df3497010beb = (value)=>value === null || value === undefined || value === "" ? "" : Number(value).toFixed(2);
/* Order and Return statuses are stored as `TextChoices` KEYS, and DRF serialises the key, not the
   label — so the cell rendered `sent_for_delivering`, lowercase and English in all four locales.
   Bordered rather than filled: this is a document status from Excalibur that the supervisor does
   not own, so it must not read like one of our own `.status-tag` verdicts. The label carries the
   `-700` tone (it is text) while the border carries `-500` (spec/01#status-colour). */ const $b8606fd3839b989b$var$ORDER_STATUS = {
    new: "new",
    processing: "processing",
    sent_for_delivering: "ok",
    sent_to_logistics: "ok",
    closed: "closed",
    canceled: "no"
};
function $b8606fd3839b989b$export$18ba65a8ef47b37b({ value: value, lang: lang }) {
    if (!value) return 0, $e36e070b6f6386b6$export$eb03490a10c3abc9;
    const tone = $b8606fd3839b989b$var$ORDER_STATUS[value] || "new";
    const label = (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), `order_status_${value}`, lang);
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $602120e6d17ff12a$export$2e2bcd8739ae039), {
        bordered: true,
        className: `vd-ostatus vd-ostatus--${tone}`,
        children: label || value
    });
}
/* Newest first. These endpoints return a per-visit list with no pagination and no ordering — and
   neither `Order` nor `Return` declares a `Meta.ordering`, so the rows arrive in whatever order the
   database felt like. Sorting the loaded list is therefore the whole list, not a page of it. */ const $b8606fd3839b989b$var$newestFirst = (rows, key = "datetime")=>[
        ...rows
    ].sort((a, b)=>new Date(b[key] || 0) - new Date(a[key] || 0));
/** `additional_info.tags` is an array, or a bare string when there is exactly one. */ const $b8606fd3839b989b$var$tagsOf = (tags)=>Array.isArray(tags) ? tags : typeof tags === "string" && tags ? [
        tags
    ] : [];
/** A table that scrolls inside itself, so the page never scrolls sideways (spec/02). */ function $b8606fd3839b989b$var$SectionTable({ columns: columns, rows: rows, onRow: onRow, minWidth: minWidth, rowSelection: rowSelection }) {
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $dff4d45d201c6dfe$export$2e2bcd8739ae039), {
        className: "vd-table",
        size: "small",
        rowKey: "id",
        columns: columns,
        dataSource: rows,
        pagination: false,
        scroll: {
            x: minWidth
        },
        rowSelection: rowSelection,
        onRow: (record)=>({
                onClick: (event)=>{
                    /* The same guard every list page carries: a click on the checkbox or a button is not
             a request to open the record. */ if (event.target.closest(".ant-table-selection-column, .ant-btn")) return;
                    if (onRow) onRow(record);
                },
                className: onRow ? "vd-row" : ""
            })
    });
}
/**
 * A section's pager — the app's shared `TableFoot`, so the rows-per-page control, the range and the
 * page window read the same here as on every list page.
 *
 * `total` is the caller's, because only the caller knows whether it is the server's `count` or the
 * length of a list already in memory.
 */ function $b8606fd3839b989b$var$SectionFoot({ id: id, total: total, pager: pager }) {
    if (!pager || total <= pager.size) return null;
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $66539b2560a58e4e$export$6cb97cd1ceda576d), {
        id: id,
        page: pager.page,
        size: pager.size,
        total: total,
        sizes: pager.sizes,
        labels: pager.labels,
        onPage: pager.onPage,
        onSize: pager.onSize
    });
}
/** The trailing chevron every drill-in row carries in the design. */ const $b8606fd3839b989b$var$openColumn = (label)=>({
        key: "open",
        width: 56,
        align: "right",
        render: ()=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                type: "text",
                size: "small",
                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $89db7229a7e10f8f$export$2e2bcd8739ae039), {}),
                "aria-label": label
            })
    });
function $b8606fd3839b989b$export$a7f864e9a31ae39c({ data: data, lang: lang, onOpen: onOpen }) {
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), key, lang);
    const rows = $b8606fd3839b989b$var$rowsOf(data);
    if (!rows.length) return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e36e070b6f6386b6$export$9be373a312e080ff), {
        text: t("nothing_here")
    });
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($b8606fd3839b989b$var$SectionTable, {
        minWidth: 1180,
        rows: $b8606fd3839b989b$var$newestFirst(rows),
        onRow: onOpen,
        columns: [
            {
                key: "name",
                title: t("orders_popup_order_id_title"),
                dataIndex: "name",
                width: 140,
                render: (value)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("b", {
                        children: value
                    })
            },
            /* Widthed. It was the only column without one, so it took every spare pixel and left the
           gap the delivery date now fills. */ {
                key: "cp",
                title: t("orders_popup_counterparty_label"),
                dataIndex: [
                    "counterparty",
                    "name"
                ],
                width: 240,
                ellipsis: true
            },
            /* The counterparty's OWN address, not the visited point's — `Counterparty.address` was on the
           model all along but `CounterpartyShortSerializer` (the one every visit section nests) was
           the only Counterparty serializer not exposing it. */ {
                key: "cp_address",
                title: t("orders_address_label"),
                dataIndex: [
                    "counterparty",
                    "address"
                ],
                width: 220,
                ellipsis: true,
                render: (value)=>value || (0, $e36e070b6f6386b6$export$eb03490a10c3abc9)
            },
            /* Annotated server-side (`Count("items")`). The list payload carries no `items` — the modal
           fetches the detail for those — so counting client-side would have meant one request per
           row. */ {
                key: "n",
                title: t("orders_items_count_label"),
                dataIndex: "items_count",
                width: 110,
                align: "right",
                render: (value)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "vd-num",
                        children: value ?? (0, $e36e070b6f6386b6$export$eb03490a10c3abc9)
                    })
            },
            {
                key: "delivery",
                title: t("orders_delivery_label"),
                dataIndex: "delivery_date",
                width: 140,
                render: (value)=>value ? $b8606fd3839b989b$export$3ae94a2503e890a1(value, lang) : (0, $e36e070b6f6386b6$export$eb03490a10c3abc9)
            },
            {
                key: "at",
                title: t("orders_product_status_date"),
                dataIndex: "datetime",
                width: 160,
                render: (value)=>$b8606fd3839b989b$export$8b492ed8828f789c(value, lang)
            },
            {
                key: "status",
                title: t("status_label"),
                dataIndex: "status",
                width: 180,
                render: (value)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($b8606fd3839b989b$export$18ba65a8ef47b37b, {
                        value: value,
                        lang: lang
                    })
            },
            {
                key: "total",
                title: t("orders_product_total"),
                dataIndex: "order_total",
                width: 130,
                align: "right",
                render: (value)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "vd-num",
                        children: $b8606fd3839b989b$export$5517df3497010beb(value)
                    })
            },
            $b8606fd3839b989b$var$openColumn(t("view_details"))
        ]
    });
}
function $b8606fd3839b989b$export$7fe938b3398327d2({ data: data, lang: lang, onOpen: onOpen }) {
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), key, lang);
    const rows = $b8606fd3839b989b$var$rowsOf(data);
    if (!rows.length) return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e36e070b6f6386b6$export$9be373a312e080ff), {
        text: t("nothing_here")
    });
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($b8606fd3839b989b$var$SectionTable, {
        minWidth: 1150,
        rows: $b8606fd3839b989b$var$newestFirst(rows),
        onRow: onOpen,
        columns: [
            {
                key: "id",
                title: t("orders_return_id_label"),
                dataIndex: "name",
                width: 130,
                render: (value, row)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("b", {
                        children: value || `#${row.id}`
                    })
            },
            {
                key: "cp",
                title: t("orders_popup_counterparty_label"),
                dataIndex: [
                    "counterparty",
                    "name"
                ],
                width: 260,
                ellipsis: true
            },
            {
                key: "cp_address",
                title: t("orders_address_label"),
                dataIndex: [
                    "counterparty",
                    "address"
                ],
                width: 220,
                ellipsis: true,
                render: (value)=>value || (0, $e36e070b6f6386b6$export$eb03490a10c3abc9)
            },
            /* Counted from the row, no backend change needed: `items` IS nested on the return LIST
           serializer (the detail modal reuses the row rather than fetching), with `items__product`
           prefetched. An order is the opposite case — see its column above. */ {
                key: "n",
                title: t("orders_items_count_label"),
                width: 110,
                align: "right",
                render: (value, row)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "vd-num",
                        children: (row.items || []).length
                    })
            },
            {
                key: "at",
                title: t("orders_return_crated_label"),
                dataIndex: "datetime",
                width: 160,
                render: (value)=>$b8606fd3839b989b$export$8b492ed8828f789c(value, lang)
            },
            {
                key: "phys",
                title: t("orders_physical_return_label"),
                dataIndex: "date_of_physical_return",
                width: 170,
                render: (value)=>value ? $b8606fd3839b989b$export$3ae94a2503e890a1(value, lang) : (0, $e36e070b6f6386b6$export$eb03490a10c3abc9)
            },
            /* No Status column: a return's document status is Excalibur's, it never enters the review
           queue, and the detail modal still shows it. A Total belongs here (PICSELL-1572) but the
           web API models neither a return total nor a per-item price — a backend item, not a
           column that could be filled with a wrong number today. */ $b8606fd3839b989b$var$openColumn(t("view_details"))
        ]
    });
}
function $b8606fd3839b989b$export$21c9bae90c5629f5({ data: data, lang: lang, onOpen: onOpen }) {
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), key, lang);
    const rows = $b8606fd3839b989b$var$rowsOf(data);
    if (!rows.length) return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e36e070b6f6386b6$export$9be373a312e080ff), {
        text: t("nothing_here")
    });
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($b8606fd3839b989b$var$SectionTable, {
        minWidth: 1040,
        rows: $b8606fd3839b989b$var$newestFirst(rows),
        onRow: onOpen,
        columns: [
            {
                key: "id",
                title: t("orders_payment_id_label"),
                dataIndex: "id",
                width: 120,
                render: (value)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("b", {
                        children: [
                            "#",
                            value
                        ]
                    })
            },
            {
                key: "cp",
                title: t("orders_popup_counterparty_label"),
                dataIndex: [
                    "counterparty",
                    "name"
                ],
                width: 240,
                ellipsis: true
            },
            /* ⚠ `debt.name` does not exist — `Debt` is serialised as `(id, name_of_the_document)`, so
           this column was blank on every row and read as the empty gap QA reported. */ {
                key: "debt",
                title: t("orders_payment_debt_label"),
                dataIndex: [
                    "debt",
                    "name_of_the_document"
                ],
                width: 180,
                ellipsis: true
            },
            {
                key: "amount",
                title: t("orders_payment_amount_label"),
                dataIndex: "amount",
                width: 130,
                align: "right",
                render: (value)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "vd-num",
                        children: $b8606fd3839b989b$export$5517df3497010beb(value)
                    })
            },
            {
                key: "at",
                title: t("orders_product_status_date"),
                dataIndex: "datetime",
                width: 160,
                render: (value)=>$b8606fd3839b989b$export$8b492ed8828f789c(value, lang)
            },
            {
                key: "comment",
                title: t("orders_popup_comment_label"),
                dataIndex: "comment",
                ellipsis: true,
                render: (value)=>value || (0, $e36e070b6f6386b6$export$eb03490a10c3abc9)
            },
            $b8606fd3839b989b$var$openColumn(t("view_details"))
        ]
    });
}
function $b8606fd3839b989b$export$e0a0d30234fefcbf({ data: data, lang: lang, pager: pager, onOpen: onOpen }) {
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), key, lang);
    const rows = (0, $cQmXV.useMemo)(()=>$b8606fd3839b989b$var$rowsOf(data).map((row)=>new (0, $4e9873a13607b352$export$29d24e359e2fdff9)(row)), [
        data
    ]);
    if (!rows.length) return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e36e070b6f6386b6$export$9be373a312e080ff), {
        text: t("nothing_here")
    });
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
        vertical: true,
        gap: "middle",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                className: "vd-rgrid",
                children: rows.map((item, index)=>{
                    const photo = item.photo?.[0];
                    const title = item.additional_info?.title || item.ticket || `#${item.id}`;
                    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $b4fda840b736e640$export$2e2bcd8739ae039), {
                        className: "vd-rcard",
                        variant: "outlined",
                        hoverable: true,
                        /* The whole loaded page goes over, so the modal can step it. */ onClick: ()=>onOpen(rows, index),
                        cover: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                            className: "vd-rcard__c",
                            children: [
                                photo ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $7012c54fc4de0c33$export$2e2bcd8739ae039), {
                                    src: photo,
                                    alt: "",
                                    preview: false,
                                    rootClassName: "vd-rcard__imgwrap"
                                }) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $c3b8d7d247171904$export$2e2bcd8739ae039), {
                                    className: "vd-rcard__none-icon"
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e36e070b6f6386b6$export$5452e567de639f2a), {
                                    status: (0, $e36e070b6f6386b6$export$1094b4db5e23d27c)(item.approval),
                                    lang: lang,
                                    className: "vd-rcard__pill"
                                })
                            ]
                        }),
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                strong: true,
                                ellipsis: {
                                    tooltip: title
                                },
                                className: "vd-rcard__t",
                                children: title
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $eb1133c43d00490b$export$2e2bcd8739ae039), {
                                size: 4,
                                wrap: true,
                                className: "vd-rcard__tags",
                                children: $b8606fd3839b989b$var$tagsOf(item.additional_info?.tags).map((tag, i)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $602120e6d17ff12a$export$2e2bcd8739ae039), {
                                        className: "vd-rcard__tag",
                                        children: tag
                                    }, `${tag}-${i}`))
                            })
                        ]
                    }, item.id ?? index);
                })
            }),
            pager ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $66539b2560a58e4e$export$616d7706d7176288), {
                id: "vdrep",
                page: pager.page,
                hasNext: Boolean(data?.next),
                onPage: pager.onPage,
                labels: {
                    page: t("page_n"),
                    prev: t("page_prev"),
                    next: t("page_next")
                }
            }) : null
        ]
    });
}
/* ------------------------------------------------------------------ tasks */ const $b8606fd3839b989b$var$TASK_SIZES = [
    10,
    25,
    50
];
function $b8606fd3839b989b$export$3e2ce5dc7b3dae26({ data: data, lang: lang, onOpen: onOpen, busy: busy, onBulkDecide: onBulkDecide }) {
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), key, lang);
    const all = $b8606fd3839b989b$var$rowsOf(data);
    const [page, setPage] = (0, $cQmXV.useState)(1);
    const [size, setSize] = (0, $cQmXV.useState)($b8606fd3839b989b$var$TASK_SIZES[1]);
    const [selected, setSelected] = (0, $cQmXV.useState)([]);
    const [rejecting, setRejecting] = (0, $cQmXV.useState)(false);
    const rows = all.slice((page - 1) * size, page * size);
    if (!all.length) return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e36e070b6f6386b6$export$9be373a312e080ff), {
        text: t("nothing_here")
    });
    /* A verdict is posted against the ANSWER, so the selection resolves task rows → answer ids. */ const answerIds = all.filter((row)=>selected.includes(row.id) && row.answer?.id).map((row)=>row.answer.id);
    const decide = (isApproved, comment = "")=>onBulkDecide(answerIds, isApproved, comment, (ok)=>{
            if (!ok) return;
            setRejecting(false);
            setSelected([]);
        });
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
        vertical: true,
        gap: "middle",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($b8606fd3839b989b$var$SectionTable, {
                minWidth: 1120,
                rows: rows,
                onRow: onOpen,
                rowSelection: onBulkDecide ? {
                    selectedRowKeys: selected,
                    onChange: (keys)=>setSelected(keys),
                    /* Only an answered task carries anything a verdict can land on. */ getCheckboxProps: (row)=>({
                            disabled: !row.answer?.id
                        })
                } : undefined,
                columns: [
                    {
                        key: "status",
                        title: t("task_tab_answer_status_label"),
                        width: 150,
                        /* `is_supervised`, the column every verdict is mirrored into — this serializer never
               carried `approval`, so bulk-approving left every row "on verification" (PICSELL-1615
               #1). A task nobody answered shows a dash, not a claim. */ render: (value, row)=>row.answer ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e36e070b6f6386b6$export$5452e567de639f2a), {
                                status: (0, $e873a05126b50f33$export$6e020ab67105656f)(row.answer),
                                lang: lang
                            }) : (0, $e36e070b6f6386b6$export$eb03490a10c3abc9)
                    },
                    {
                        key: "template",
                        title: t("task_tab_type_label"),
                        dataIndex: [
                            "template",
                            "name"
                        ],
                        width: 170,
                        ellipsis: true
                    },
                    {
                        key: "title",
                        title: t("task_tab_task_name_label"),
                        dataIndex: "title",
                        ellipsis: true,
                        render: (value, row)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                vertical: true,
                                className: "vd-cell",
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                        ellipsis: {
                                            tooltip: value
                                        },
                                        children: value
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                        type: "secondary",
                                        className: "vd-cell__s",
                                        ellipsis: {
                                            tooltip: row.description
                                        },
                                        children: row.description
                                    })
                                ]
                            })
                    },
                    {
                        key: "end",
                        title: t("task_tab_deadline_label"),
                        dataIndex: "end",
                        width: 150,
                        render: (value)=>value ? $b8606fd3839b989b$export$3ae94a2503e890a1(value, lang) : (0, $e36e070b6f6386b6$export$eb03490a10c3abc9)
                    },
                    {
                        key: "photos",
                        title: t("task_tab_count_photo_label"),
                        dataIndex: "image_count",
                        width: 100,
                        align: "center",
                        render: (value)=>value ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                className: "vd-num",
                                children: value
                            }) : (0, $e36e070b6f6386b6$export$eb03490a10c3abc9)
                    },
                    {
                        key: "answer",
                        title: t("task_tab_answer_comment_label"),
                        width: 200,
                        ellipsis: true,
                        render: (value, row)=>row.answer?.answer || /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                className: "vd-dash",
                                children: t("no_answer")
                            })
                    },
                    $b8606fd3839b989b$var$openColumn(t("view_details"))
                ]
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($b8606fd3839b989b$var$SectionFoot, {
                id: "vd-tasks",
                total: all.length,
                pager: {
                    page: page,
                    size: size,
                    sizes: $b8606fd3839b989b$var$TASK_SIZES,
                    labels: {
                        perPage: t("rows_per_page"),
                        range: t("range_of")
                    },
                    onPage: setPage,
                    onSize: (next)=>{
                        setSize(next);
                        setPage(1);
                    }
                }
            }),
            selected.length > 0 && onBulkDecide ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                className: "lp-bulkbar",
                align: "center",
                gap: "middle",
                wrap: true,
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                        className: "lp-bulkbar__n",
                        children: (0, $3b579ca6158bc61b$export$9563e054e6f787fb)(t("w_selected"), {
                            n: answerIds.length
                        })
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $eb1133c43d00490b$export$2e2bcd8739ae039), {
                        className: "lp-bulkbar__acts",
                        size: 8,
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                size: "small",
                                onClick: ()=>setSelected([]),
                                children: t("clear_selection")
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                size: "small",
                                danger: true,
                                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $bdfb1f797481a352$export$2e2bcd8739ae039), {}),
                                disabled: busy || !answerIds.length,
                                onClick: ()=>setRejecting(true),
                                children: t("reject_btn")
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                size: "small",
                                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $45839ed7c4a7faa2$export$2e2bcd8739ae039), {}),
                                loading: busy,
                                disabled: !answerIds.length,
                                onClick: ()=>decide(true),
                                children: t("approv_btn")
                            })
                        ]
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e36e070b6f6386b6$export$a16bdbbbfa22bef2), {
                open: rejecting,
                target: {
                    title: (0, $3b579ca6158bc61b$export$9563e054e6f787fb)(t("w_selected"), {
                        n: answerIds.length
                    })
                },
                lang: lang,
                onCancel: ()=>setRejecting(false),
                onConfirm: (reason)=>decide(false, reason)
            })
        ]
    });
}
/* ------------------------------------------------------------- price monitoring */ const $b8606fd3839b989b$var$PRICE_SEGMENTS = [
    [
        "all",
        "f_all"
    ],
    [
        "pending",
        "on_verification_single_visit_name"
    ],
    [
        "approved",
        "approved_single_visit_name"
    ],
    [
        "rejected",
        "no_approved_single_visit_name"
    ]
];
function $b8606fd3839b989b$export$e1cdc4bd8c8b22b2({ data: data, lang: lang, pager: pager, onOpen: onOpen }) {
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), key, lang);
    const all = $b8606fd3839b989b$var$rowsOf(data);
    const total = data?.count ?? all.length;
    const [status, setStatus] = (0, $cQmXV.useState)("all");
    const [query, setQuery] = (0, $cQmXV.useState)("");
    /* ⚠ The segment and the search filter the LOADED PAGE, not the section. This endpoint paginates
     (200 a page by default) and cannot be filtered server-side, which is the same constraint
     /photo-review's client-side status segment lives under. The footer below still describes the
     PAGE (`1–50 of 200`), so while a filter is on it counts more rows than the table shows. */ const rows = (0, $cQmXV.useMemo)(()=>{
        const needle = query.trim().toLowerCase();
        return all.filter((row)=>{
            if (status !== "all" && (0, $e36e070b6f6386b6$export$1094b4db5e23d27c)(row.approval) !== status) return false;
            if (!needle) return true;
            return `${row.product_name || ""} ${row.product_code || ""}`.toLowerCase().includes(needle);
        });
    }, [
        all,
        status,
        query
    ]);
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
        vertical: true,
        gap: "middle",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                className: "vd-toolbar",
                align: "center",
                gap: "small",
                wrap: true,
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $ac40310dc424be23$export$2e2bcd8739ae039), {
                        value: status,
                        onChange: setStatus,
                        options: $b8606fd3839b989b$var$PRICE_SEGMENTS.map(([value, key])=>({
                                value: value,
                                label: t(key)
                            }))
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0883e7f8083c01b0$export$2e2bcd8739ae039), {
                        className: "vd-toolbar__search",
                        value: query,
                        allowClear: true,
                        prefix: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $20a259d46bffcb08$export$2e2bcd8739ae039), {}),
                        "aria-label": t("monitoring_tab_pname_label"),
                        onChange: (event)=>setQuery(event.target.value)
                    })
                ]
            }),
            rows.length ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($b8606fd3839b989b$var$SectionTable, {
                minWidth: 900,
                rows: rows,
                onRow: onOpen,
                columns: [
                    {
                        key: "photo",
                        title: "",
                        width: 66,
                        render: (value, row)=>row.photo_url ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $7012c54fc4de0c33$export$2e2bcd8739ae039), {
                                src: row.photo_url,
                                alt: "",
                                width: 46,
                                height: 34,
                                className: "vd-thumb",
                                preview: false
                            }) : (0, $e36e070b6f6386b6$export$eb03490a10c3abc9)
                    },
                    {
                        key: "product",
                        title: t("monitoring_tab_pname_label"),
                        ellipsis: true,
                        render: (value, row)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                vertical: true,
                                className: "vd-cell",
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                        ellipsis: {
                                            tooltip: row.product_name
                                        },
                                        children: row.product_name
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                        type: "secondary",
                                        className: "vd-cell__s",
                                        children: row.product_code
                                    })
                                ]
                            })
                    },
                    {
                        key: "price",
                        title: t("monitoring_tab_price_label"),
                        dataIndex: "price",
                        width: 120,
                        align: "right",
                        render: (value)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                className: "vd-num",
                                children: $b8606fd3839b989b$export$5517df3497010beb(value)
                            })
                    },
                    {
                        key: "sale",
                        title: t("monitoring_tab_sale_price_label"),
                        dataIndex: "sale_price",
                        width: 130,
                        align: "right",
                        render: (value)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                className: "vd-num",
                                children: $b8606fd3839b989b$export$5517df3497010beb(value)
                            })
                    },
                    {
                        key: "delta",
                        title: t("delta"),
                        width: 100,
                        align: "right",
                        render: (value, row)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($b8606fd3839b989b$export$1f333647865369bf, {
                                price: row.price,
                                salePrice: row.sale_price
                            })
                    },
                    {
                        key: "status",
                        title: t("status_label"),
                        width: 150,
                        render: (value, row)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e36e070b6f6386b6$export$5452e567de639f2a), {
                                status: (0, $e36e070b6f6386b6$export$1094b4db5e23d27c)(row.approval),
                                lang: lang
                            })
                    },
                    $b8606fd3839b989b$var$openColumn(t("view_details"))
                ]
            }) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e36e070b6f6386b6$export$9be373a312e080ff), {
                text: t("nothing_here")
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($b8606fd3839b989b$var$SectionFoot, {
                id: "vd-price",
                total: total,
                pager: pager
            })
        ]
    });
}
function $b8606fd3839b989b$export$1f333647865369bf({ price: price, salePrice: salePrice }) {
    if (price === null || price === undefined || salePrice === null || salePrice === undefined) return 0, $e36e070b6f6386b6$export$eb03490a10c3abc9;
    const value = Number(salePrice) - Number(price);
    if (!value) return 0, $e36e070b6f6386b6$export$eb03490a10c3abc9;
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
        className: `vd-num vd-delta vd-delta--${value < 0 ? "down" : "up"}`,
        children: `${value > 0 ? "+" : ""}${value.toFixed(2)}`
    });
}
function $b8606fd3839b989b$export$4110bfc1db2278b4({ visitId: visitId, data: data, lang: lang }) {
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), key, lang);
    /* Only surveys with something recorded. `surveys_in_visit` lists every survey TARGETING the
     point, answered or not, and an untouched one is noise in a review queue — the legacy tab
     filtered the same way. The summary counts above still describe all of them. */ const surveys = (data?.surveys || []).filter((survey)=>(survey.answers_count ?? 0) > 0 || (survey.photos_count ?? 0) > 0);
    const summary = data?.summary || {};
    const [open, setOpen] = (0, $cQmXV.useState)(null);
    const [detail, setDetail] = (0, $cQmXV.useState)({});
    const [loading, setLoading] = (0, $cQmXV.useState)(null);
    const toggle = (survey)=>{
        if (open === survey.id) {
            setOpen(null);
            return;
        }
        setOpen(survey.id);
        if (detail[survey.id]) return;
        setLoading(survey.id);
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "GET",
            url: `visit_surveys/${survey.id}/?visit_id=${visitId}`
        }, (response)=>{
            setLoading(null);
            setDetail((prev)=>({
                    ...prev,
                    [survey.id]: response || {}
                }));
        });
    };
    if (!surveys.length) return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e36e070b6f6386b6$export$9be373a312e080ff), {
        text: t("nothing_here")
    });
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
        vertical: true,
        gap: "middle",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                className: "vd-svstats",
                gap: "middle",
                wrap: true,
                children: [
                    [
                        summary.surveys,
                        t("surveys_summary_surveys_label")
                    ],
                    [
                        summary.answers,
                        t("surveys_summary_answers_label")
                    ],
                    [
                        summary.photos,
                        t("surveys_summary_photos_label")
                    ]
                ].map(([value, label])=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                        vertical: true,
                        className: "vd-svstat",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                className: "vd-svstat__n",
                                children: value ?? 0
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                type: "secondary",
                                className: "vd-svstat__l",
                                children: label
                            })
                        ]
                    }, label))
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                vertical: true,
                gap: "small",
                children: surveys.map((survey)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($b8606fd3839b989b$var$SurveyCard, {
                        survey: survey,
                        lang: lang,
                        open: open === survey.id,
                        loading: loading === survey.id,
                        detail: detail[survey.id],
                        onToggle: ()=>toggle(survey)
                    }, survey.id))
            })
        ]
    });
}
/* `visit_surveys/:id/` groups the answers four ways, and the fourth is NOT shaped like the others:
   products / brands / categories are blocks of `{ <entity>: {...}, answers: [...] }`, while `other`
   is a FLAT list of answers with no entity to hang them under. The entity's name is nested under
   its own key — reading `entity.name` (as this did) is undefined for all three, which is why every
   header rendered blank. */ const $b8606fd3839b989b$var$GROUPS = [
    [
        "products",
        "surveys_tab_products",
        "product"
    ],
    [
        "brands",
        "surveys_tab_brands",
        "brand"
    ],
    [
        "categories",
        "surveys_tab_categories",
        "category"
    ],
    [
        "other",
        "surveys_tab_other",
        null
    ]
];
function $b8606fd3839b989b$var$SurveyCard({ survey: survey, lang: lang, open: open, loading: loading, detail: detail, onToggle: onToggle }) {
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), key, lang);
    const [group, setGroup] = (0, $cQmXV.useState)("products");
    const groups = detail?.groups || {};
    const entities = groups[group] || [];
    const entityKey = $b8606fd3839b989b$var$GROUPS.find(([key])=>key === group)?.[2];
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $b4fda840b736e640$export$2e2bcd8739ae039), {
        className: `vd-sv${open ? " vd-sv--open" : ""}`,
        variant: "outlined",
        size: "small",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("button", {
                type: "button",
                className: "vd-sv__head",
                "aria-expanded": open,
                onClick: onToggle,
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                        strong: true,
                        className: "vd-sv__t",
                        children: survey.title || survey.name
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                        type: "secondary",
                        className: "vd-sv__m",
                        children: [
                            survey.answers_count ?? 0,
                            " \xb7 ",
                            t("surveys_summary_answers_label")
                        ]
                    })
                ]
            }),
            open ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                className: "vd-sv__body",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $ac40310dc424be23$export$2e2bcd8739ae039), {
                        value: group,
                        onChange: setGroup,
                        options: $b8606fd3839b989b$var$GROUPS.map(([key, labelKey])=>({
                                value: key,
                                label: t(labelKey)
                            }))
                    }),
                    loading ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                        type: "secondary",
                        children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$33bf88bbb69ebeac), "option_loading", lang)
                    }) : !entities.length ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $99350450b877904c$export$2e2bcd8739ae039), {
                        image: (0, $99350450b877904c$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE,
                        description: t("surveys_no_results")
                    }) : entityKey ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                        vertical: true,
                        gap: "small",
                        className: "vd-sv__ents",
                        children: entities.map((entity, index)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($b8606fd3839b989b$var$SurveyEntity, {
                                entity: entity,
                                entityKey: entityKey,
                                lang: lang
                            }, entity[entityKey]?.id ?? index))
                    }) : /* `other` is already the answers — there is no entity to collapse it under. */ /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($b8606fd3839b989b$var$AnswerRows, {
                        answers: entities,
                        lang: lang
                    })
                ]
            }) : null
        ]
    });
}
function $b8606fd3839b989b$var$SurveyEntity({ entity: entity, entityKey: entityKey, lang: lang }) {
    const [open, setOpen] = (0, $cQmXV.useState)(false);
    const answers = entity.answers || [];
    const subject = entity[entityKey] || {};
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
        className: `vd-ent${open ? " vd-ent--open" : ""}`,
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("button", {
                type: "button",
                className: "vd-ent__h",
                "aria-expanded": open,
                onClick: ()=>setOpen((value)=>!value),
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                        strong: true,
                        children: subject.name || (0, $e36e070b6f6386b6$export$eb03490a10c3abc9)
                    }),
                    subject.code ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                        type: "secondary",
                        className: "vd-ent__c",
                        children: subject.code
                    }) : null,
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "vd-spacer"
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                        type: "secondary",
                        children: answers.length
                    })
                ]
            }),
            open ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($b8606fd3839b989b$var$AnswerRows, {
                answers: answers,
                lang: lang
            }) : null
        ]
    });
}
/* Answers arrive in insertion order, which is the order they were ANSWERED — the questionnaire's own
   order is `question.order`, and that is the order a reviewer reads the survey in. Sorted here, in
   the one place both the per-entity groups and the flat `other` group render through, rather than
   per group at fetch time. */ function $b8606fd3839b989b$var$AnswerRows({ answers: answers, lang: lang }) {
    const ordered = (0, $cQmXV.useMemo)(()=>[
            ...answers
        ].sort((a, b)=>(a.question?.order ?? 0) - (b.question?.order ?? 0)), [
        answers
    ]);
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
        className: "vd-qa",
        children: ordered.map((answer, index)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                className: "vd-qa__row",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                        className: "vd-qa__q",
                        children: [
                            answer.question?.required ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $602120e6d17ff12a$export$2e2bcd8739ae039), {
                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$ac552071080927b0), "f_required", lang)
                            }) : null,
                            answer.question?.text || (0, $e36e070b6f6386b6$export$eb03490a10c3abc9)
                        ]
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "vd-qa__a",
                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($b8606fd3839b989b$var$AnswerValue, {
                            answer: answer,
                            lang: lang
                        })
                    })
                ]
            }, answer.id ?? index))
    });
}
/**
 * One answer's value.
 *
 * A survey answer is stored in a column PER TYPE (`answer_text`, `answer_numeric`,
 * `answer_dropdown`, `answer_date`, `answer_boolean`, `photos`) and `question.answer_type` says
 * which one holds it — there is no generic `answer` / `value` field, which is why every non-photo
 * answer used to render as a dash.
 */ function $b8606fd3839b989b$var$AnswerValue({ answer: answer, lang: lang }) {
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), key, lang);
    const photos = (answer.photos || []).map((photo)=>photo.photo).filter(Boolean);
    switch(answer.question?.answer_type){
        case "boolean":
            /* Tri-state: null is "not answered", which is not the same statement as "no".
         Plain text, not a status tag — the legacy tab painted "No" red, but a negative survey
         answer is data and may well be the expected one; only an approval verdict earns a tone. */ if (answer.answer_boolean === null || answer.answer_boolean === undefined) return 0, $e36e070b6f6386b6$export$eb03490a10c3abc9;
            return t(answer.answer_boolean ? "surveys_answer_bool_yes" : "surveys_answer_bool_no");
        case "numeric":
            return answer.answer_numeric === null || answer.answer_numeric === undefined ? (0, $e36e070b6f6386b6$export$eb03490a10c3abc9) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                className: "vd-num",
                children: answer.answer_numeric
            });
        case "dropdown":
            return answer.answer_dropdown?.label || (0, $e36e070b6f6386b6$export$eb03490a10c3abc9);
        case "text":
            return answer.answer_text || (0, $e36e070b6f6386b6$export$eb03490a10c3abc9);
        case "date":
            return answer.answer_date ? $b8606fd3839b989b$export$3ae94a2503e890a1(answer.answer_date, lang) : (0, $e36e070b6f6386b6$export$eb03490a10c3abc9);
        case "photo":
            if (!photos.length) return 0, $e36e070b6f6386b6$export$eb03490a10c3abc9;
            /* antd's own lightbox, with arrows and a counter — the same thing /answers and /task use
         rather than a hand-rolled overlay. */ return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $7012c54fc4de0c33$export$2e2bcd8739ae039).PreviewGroup, {
                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                    gap: 4,
                    wrap: true,
                    children: photos.map((src, index)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $7012c54fc4de0c33$export$2e2bcd8739ae039), {
                            src: src,
                            alt: "",
                            width: 64,
                            className: "vd-thumb"
                        }, index))
                })
            });
        default:
            /* An unknown type is still worth showing whatever was recorded rather than nothing. */ return answer.answer_text || answer.answer_dropdown?.label || (0, $e36e070b6f6386b6$export$eb03490a10c3abc9);
    }
}
function $b8606fd3839b989b$export$88f8942a9973f999({ visit: visit, lang: lang }) {
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), key, lang);
    const pings = (0, $cQmXV.useMemo)(()=>(0, $74749913e46c60bd$export$6caac4d0ccca49a8)(visit), [
        visit
    ]);
    const track = (0, $cQmXV.useMemo)(()=>pings.map((ping)=>ping.pos), [
        pings
    ]);
    const point = visit?.point?.location;
    const pointPos = point ? [
        Number(point.latitude),
        Number(point.longitude)
    ] : null;
    const mockCount = pings.filter((0, $74749913e46c60bd$export$550fa1786590653d)).length;
    /* The chosen ping, by index — from the numbered list or from its dot on the map. */ const [selected, setSelected] = (0, $cQmXV.useState)(null);
    const pick = (index)=>setSelected((current)=>current === index ? null : index);
    const markers = (0, $cQmXV.useMemo)(()=>{
        const out = pings.map((ping, index)=>({
                key: `ping-${index}`,
                index: index,
                lat: ping.pos[0],
                lng: ping.pos[1],
                /* The chosen ping is the full-size numbered pin; every other one stays a dot. */ kind: index === selected ? "sel" : "dot",
                label: index === selected ? index + 1 : undefined,
                tone: (0, $74749913e46c60bd$export$550fa1786590653d)(ping) ? "no" : undefined,
                title: `${index + 1}${ping.time ? ` \xb7 ${$b8606fd3839b989b$export$3203edd9e5edd663(ping.time, lang)}` : ""}`,
                clickable: true
            }));
        /* ⚠ Passing `markers` suppresses LeafletMap's own primary pin, so the point rides along in
       the same array — which is also what lets `fit()` frame the point AND the whole track. */ if (point) out.push({
            key: "point",
            lat: point.latitude,
            lng: point.longitude,
            kind: "point",
            title: visit?.point?.name
        });
        return out;
    }, [
        pings,
        point,
        visit,
        lang,
        selected
    ]);
    /* Frame the chosen ping WITH the point, so "how far off was it" is answered by the map itself. */ const focus = selected == null || !pings[selected] ? null : [
        pings[selected].pos,
        ...pointPos ? [
            pointPos
        ] : []
    ];
    const units = {
        m: t("gps_m"),
        km: t("gps_km")
    };
    const stats = [
        [
            t("point_started_title"),
            $b8606fd3839b989b$export$3203edd9e5edd663(visit?.start, lang)
        ],
        [
            t("visit_end"),
            $b8606fd3839b989b$export$3203edd9e5edd663(visit?.end, lang)
        ],
        [
            t("point"),
            visit?.point?.name
        ]
    ];
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
        vertical: true,
        gap: "middle",
        children: [
            mockCount ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $dc33dcdb2d24fbd9$export$2e2bcd8739ae039), {
                type: "warning",
                showIcon: true,
                message: (0, $3b579ca6158bc61b$export$9563e054e6f787fb)(t("gps_mock_warning"), {
                    n: mockCount
                })
            }) : null,
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                className: "vd-gps",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                        children: point || track.length ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $6967b95453f7bc7e$export$2e2bcd8739ae039), {
                            lat: point?.latitude,
                            lng: point?.longitude,
                            markers: markers,
                            track: track,
                            focus: focus,
                            onMarkerClick: (marker)=>marker.index != null && pick(marker.index),
                            height: 320
                        }) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e36e070b6f6386b6$export$9be373a312e080ff), {
                            text: t("no_coordinates")
                        })
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                        vertical: true,
                        gap: "small",
                        className: "vd-gps__stats",
                        children: [
                            stats.map(([label, value])=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                    align: "center",
                                    justify: "space-between",
                                    gap: "small",
                                    className: "vd-gps__stat",
                                    children: [
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                            type: "secondary",
                                            children: label
                                        }),
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                            strong: true,
                                            children: value || (0, $e36e070b6f6386b6$export$eb03490a10c3abc9)
                                        })
                                    ]
                                }, label)),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                type: "secondary",
                                className: "vd-gps__head",
                                children: t("gps_points")
                            }),
                            pings.length ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $575603080129eb00$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                        type: "secondary",
                                        className: "vd-gps__hint",
                                        children: t("gps_from_point")
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                                        className: "vd-gps__list",
                                        children: pings.map((ping, index)=>{
                                            const on = index === selected;
                                            const mock = (0, $74749913e46c60bd$export$550fa1786590653d)(ping);
                                            return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("button", {
                                                type: "button",
                                                className: `vd-ping${on ? " vd-ping--on" : ""}`,
                                                "aria-pressed": on,
                                                onClick: ()=>pick(index),
                                                children: [
                                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                                        className: `vd-ping__n${mock ? " vd-ping__n--no" : ""}`,
                                                        children: index + 1
                                                    }),
                                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                                        className: "vd-ping__time",
                                                        children: ping.time ? $b8606fd3839b989b$export$3203edd9e5edd663(ping.time, lang) : (0, $e36e070b6f6386b6$export$eb03490a10c3abc9)
                                                    }),
                                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                                        className: "vd-ping__dist",
                                                        children: pointPos ? (0, $74749913e46c60bd$export$2c14ff85d6318973)((0, $74749913e46c60bd$export$85c1126bdbff8196)(ping.pos, pointPos), units, (0, $7d0f78de0b68a104$export$bd7bed267fc278f2)(lang)) : (0, $e36e070b6f6386b6$export$eb03490a10c3abc9)
                                                    }),
                                                    mock ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $602120e6d17ff12a$export$2e2bcd8739ae039), {
                                                        color: "error",
                                                        children: t("gps_mock_tag")
                                                    }) : null
                                                ]
                                            }, index);
                                        })
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                type: "secondary",
                                className: "vd-gps__hint",
                                children: (0, $e36e070b6f6386b6$export$eb03490a10c3abc9)
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function $b8606fd3839b989b$export$770119c1605110bd({ data: data, lang: lang }) {
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), key, lang);
    const rows = $b8606fd3839b989b$var$rowsOf(data);
    if (!rows.length) return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e36e070b6f6386b6$export$9be373a312e080ff), {
        text: t("nothing_here")
    });
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $11b45828f3043c61$export$2e2bcd8739ae039), {
        className: "vd-log",
        items: rows.map((entry)=>({
                key: entry.id,
                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                    vertical: true,
                    gap: 2,
                    children: [
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                            children: entry.additional_info?.event || entry.action
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                            align: "center",
                            gap: "small",
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                    type: "secondary",
                                    className: "vd-log__m",
                                    children: $b8606fd3839b989b$export$8b492ed8828f789c(entry.timestamp, lang)
                                }),
                                entry.user ? /* The same avatar as every other person in the app: initials, photo preferred.
                   28px rather than the log's old 20 because the initials are the 12px scale
                   floor and two characters at 12px do not fit a smaller circle (spec/01#type). */ /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $66539b2560a58e4e$export$8a3d0b92eb0904a5), {
                                    user: entry.user,
                                    strong: false
                                }) : null
                            ]
                        })
                    ]
                })
            }))
    });
}
const $b8606fd3839b989b$var$fmt = (value, lang, options)=>{
    if (!value) return "";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "";
    return new Intl.DateTimeFormat((0, $7d0f78de0b68a104$export$bd7bed267fc278f2)(lang), options).format(date);
};
const $b8606fd3839b989b$export$3ae94a2503e890a1 = (value, lang)=>$b8606fd3839b989b$var$fmt(value, lang, {
        day: "2-digit",
        month: "2-digit",
        year: "numeric"
    });
const $b8606fd3839b989b$export$8b492ed8828f789c = (value, lang)=>$b8606fd3839b989b$var$fmt(value, lang, {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit"
    });
const $b8606fd3839b989b$export$3203edd9e5edd663 = (value, lang)=>$b8606fd3839b989b$var$fmt(value, lang, {
        hour: "2-digit",
        minute: "2-digit"
    });
function $b8606fd3839b989b$export$f9cfc03362754c2({ lang: lang, size: size = "small", className: className = "", onApprove: onApprove, onReject: onReject, busy: busy }) {
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), key, lang);
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
        className: className,
        align: "center",
        gap: 8,
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                size: size,
                danger: true,
                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $bdfb1f797481a352$export$2e2bcd8739ae039), {}),
                loading: busy,
                onClick: onReject,
                children: t("reject_btn")
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                size: size,
                className: "vd-btn--ok",
                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $45839ed7c4a7faa2$export$2e2bcd8739ae039), {}),
                loading: busy,
                onClick: onApprove,
                children: t("approv_btn")
            })
        ]
    });
}



/* One entry per section. `count` and `pending` are read from the summary, never from the section
   payload — that is what lets the rail be complete before anything is loaded. `skeleton` reserves
   roughly the height the loaded section will take, so switching does not collapse the page under
   the reader. */ const $8dae7032dddf1d05$var$SECTIONS = [
    {
        key: "orders",
        labelKey: "orders_tab_name",
        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3ad3610a8cd8d8e0$export$2e2bcd8739ae039), {}),
        url: (id)=>`visits/${id}/orders_in_visit/`,
        skeleton: 6,
        orders: true
    },
    {
        key: "returns",
        labelKey: "returns_tab_name",
        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3ad3610a8cd8d8e0$export$2e2bcd8739ae039), {}),
        url: (id)=>`visits/${id}/returns_in_visit/`,
        skeleton: 5,
        orders: true
    },
    {
        key: "payments",
        labelKey: "payments_tab_name",
        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3ad3610a8cd8d8e0$export$2e2bcd8739ae039), {}),
        url: (id)=>`visits/${id}/payments_in_visit/`,
        skeleton: 5,
        orders: true
    },
    /* `paged` sections hold ONE page of a longer list and take the page in their url. The two that
     do were both showing page 1 of N with nothing saying so — reports had `page=1` hardcoded, and
     price fetched 200 at a time while its toolbar reported the loaded rows as the total. */ /* `pageSize` without `sizes`: Outforz fixes the page at 20 (`picsell_photo_report`) and the proxy
     forwards only `page`, so the size is a fact, not a choice to offer. Keep the two in step —
     here it keys the per-page cache, and a wrong value would cache two pages under one key. */ {
        key: "reports",
        labelKey: "zvit_tab_name",
        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $c3b8d7d247171904$export$2e2bcd8739ae039), {}),
        url: (id, page)=>`visits/${id}/photos_in_visit?page=${page}`,
        skeleton: 8,
        paged: true,
        pageSize: 20
    },
    {
        key: "tasks",
        labelKey: "task_tab_name",
        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $f76885e21060a150$export$2e2bcd8739ae039), {}),
        url: (id)=>`visits/${id}/tasks_in_visit/`,
        skeleton: 7
    },
    {
        key: "price",
        labelKey: "monitoring_tab_name",
        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $9eca0c0bf6c54372$export$2e2bcd8739ae039), {}),
        url: (id, page, size)=>`visits/${id}/price_monitoring_in_visit/?page=${page}&page_size=${size}`,
        skeleton: 10,
        paged: true,
        sizes: [
            50,
            100,
            200
        ]
    },
    {
        key: "surveys",
        labelKey: "surveys_tab_name",
        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $170c031fa50279f7$export$2e2bcd8739ae039), {}),
        url: (id)=>`visits/${id}/surveys_in_visit/`,
        skeleton: 12
    },
    /* The track rides on the visit itself (`visit.meta`), so this one has nothing to fetch. */ {
        key: "gps",
        labelKey: "gps_track",
        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $68eebcef827bb540$export$2e2bcd8739ae039), {}),
        url: null,
        skeleton: 8
    },
    {
        key: "log",
        labelKey: "log_tab_name",
        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $6c0489580aed4320$export$2e2bcd8739ae039), {}),
        url: (id)=>`visits/${id}/events/`,
        skeleton: 6
    }
];
/* A section's cache entry is per PAGE, so that changing page fetches without dropping the page the
   reader came from — and coming back to it costs nothing. An unpaged section is always `:1:0`. */ const $8dae7032dddf1d05$var$cacheKey = (key, page, size)=>`${key}:${page}:${size}`;
const $8dae7032dddf1d05$var$pageOf = (paging, section)=>section?.paged ? paging[section.key] || {
        page: 1,
        size: section.pageSize || section.sizes[0]
    } : {
        page: 1,
        size: 0
    };
const $8dae7032dddf1d05$var$VISIT_STATUS = {
    approved: "approved",
    rejected: "rejected",
    pending: "pending"
};
const $8dae7032dddf1d05$var$visitStatus = (visit)=>visit?.is_approved === true ? $8dae7032dddf1d05$var$VISIT_STATUS.approved : visit?.is_approved === false ? $8dae7032dddf1d05$var$VISIT_STATUS.rejected : $8dae7032dddf1d05$var$VISIT_STATUS.pending;
const $8dae7032dddf1d05$var$initialsOf = (name)=>(name || "").split(" ").filter(Boolean).map((word)=>word[0]).slice(0, 2).join("").toUpperCase();
const $8dae7032dddf1d05$var$View = ()=>{
    const { id: id } = (0, $6f5d68f762d5488a$export$99eaa27ddbbb95ef)();
    const history = (0, $6f5d68f762d5488a$export$3420e1dc2c4a518c)();
    const location = (0, $6f5d68f762d5488a$export$45d76561a5302f2b)();
    const me = (0, $b83e93e5ef3de8b0$export$2105062e25df4afe)((state)=>state.me);
    const lang = me?.language || "en";
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), key, lang);
    const [visit, setVisit] = (0, $cQmXV.useState)(null);
    const [summary, setSummary] = (0, $cQmXV.useState)({
        counts: {},
        pending: {},
        pending_items: []
    });
    const [loading, setLoading] = (0, $cQmXV.useState)(true);
    const [busy, setBusy] = (0, $cQmXV.useState)(false);
    /* Section payloads, keyed by `<section>:<page>:<size>`. Cached so returning to a section — or to
     a page of it — costs nothing, but only the ACTIVE one is ever rendered, so the cache holds
     data, never DOM. The paging state is separate so a page change invalidates nothing else. */ const [sectionData, setSectionData] = (0, $cQmXV.useState)({});
    const [paging, setPaging] = (0, $cQmXV.useState)({});
    const loadingSections = (0, $cQmXV.useRef)(new Set());
    const [record, setRecord] = (0, $cQmXV.useState)(null);
    /* Photo reports get their own modal (the one /photo-review uses), which steps the loaded page —
     hence `{ items, index }` rather than a single record. */ const [report, setReport] = (0, $cQmXV.useState)(null);
    const [reject, setReject] = (0, $cQmXV.useState)(null);
    /* Position in the filtered visit queue, handed over by the list so stepping continues it. */ const params = new URLSearchParams(location.search);
    const queueIndex = Number(params.get("i")) || 0;
    const queueTotal = Number(params.get("n")) || 0;
    /* Orders / returns / payments only exist for companies that bought the feature. */ const sections = (0, $cQmXV.useMemo)(()=>{
        const hasOrders = Boolean(me?.company?.features?.includes("orders"));
        return $8dae7032dddf1d05$var$SECTIONS.filter((section)=>hasOrders || !section.orders);
    }, [
        me
    ]);
    const [active, setActive] = (0, $cQmXV.useState)(()=>params.get("s") || null);
    /* The list's filters ARE its query string, and the row click hands the whole thing over. Going
     back to a bare `/visit` therefore reads as "no filters" and reseeds the county + default
     period — every filter silently lost. Carry the search back, as `/answers/:id` does. */ const backTo = `/visit${location.search ? location.search : ""}`;
    /* ------------------------------------------------------------------ load */ const loadVisit = (0, $cQmXV.useCallback)((signal)=>(0, $c9936523dc38c641$export$86557ef9e0794d10)(`visits/${id}/?summary=1`, signal).then((response)=>{
            if (!response?.id) return null;
            setVisit(response);
            if (response.summary) setSummary(response.summary);
            return response;
        }), [
        id
    ]);
    (0, $cQmXV.useEffect)(()=>{
        const controller = new AbortController();
        setLoading(true);
        /* A different visit invalidates every cached section — this is also the reset that makes
       queue stepping work without remounting the page. */ setSectionData({});
        setPaging({});
        loadingSections.current = new Set();
        loadVisit(controller.signal).then(()=>setLoading(false)).catch((error)=>{
            if (error.name !== "AbortError") setLoading(false);
        });
        return ()=>controller.abort();
    }, [
        loadVisit
    ]);
    /* Open on the first section that has work waiting, so the page lands where the supervisor is
     needed rather than on whatever happens to be first. */ (0, $cQmXV.useEffect)(()=>{
        if (active || loading) return;
        const withWork = sections.find((section)=>summary.pending?.[section.key]);
        setActive((withWork || sections[0])?.key || null);
    }, [
        active,
        loading,
        sections,
        summary
    ]);
    /* The open section rides in the URL, so a reload or a shared link lands in place. */ (0, $cQmXV.useEffect)(()=>{
        if (!active) return;
        const next = new URLSearchParams(location.search);
        if (next.get("s") === active) return;
        next.set("s", active);
        history.replace({
            search: next.toString()
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        active
    ]);
    /* One request per section PAGE, the first time it is asked for.
     ⚠ `getAbortable`, not `call()`: `call` hands `{results: [], count: 0}` to the callback on any
     5xx, and caching that rendered an OUTAGE as "nothing here" under a pending counter
     (PICSELL-1581 #21). A failure is cached as a marker the body renders as an error + Retry. */ (0, $cQmXV.useEffect)(()=>{
        if (!active || !visit) return;
        const section = sections.find((entry)=>entry.key === active);
        if (!section?.url) return;
        const { page: page, size: size } = $8dae7032dddf1d05$var$pageOf(paging, section);
        const key = $8dae7032dddf1d05$var$cacheKey(active, page, size);
        if (sectionData[key] !== undefined || loadingSections.current.has(key)) return;
        loadingSections.current.add(key);
        (0, $c9936523dc38c641$export$86557ef9e0794d10)(section.url(id, page, size)).then((response)=>{
            loadingSections.current.delete(key);
            setSectionData((prev)=>({
                    ...prev,
                    [key]: response ?? null
                }));
        }).catch(()=>{
            loadingSections.current.delete(key);
            setSectionData((prev)=>({
                    ...prev,
                    [key]: {
                        __error: true
                    }
                }));
        });
    }, [
        active,
        visit,
        sections,
        sectionData,
        paging,
        id
    ]);
    /* Retry after a failed section fetch: dropping the cache entry re-arms the effect above. */ const retrySection = (key)=>setSectionData((prev)=>({
                ...prev,
                [key]: undefined
            }));
    /* The rail sticks below the command bar, whose height changes when it wraps. Publish the
     measured heights rather than hardcoding numbers that silently drift (spec/03). */ const barRef = (0, $cQmXV.useRef)(null);
    const railRef = (0, $cQmXV.useRef)(null);
    (0, $cQmXV.useEffect)(()=>{
        const publish = ()=>{
            const root = document.documentElement;
            if (barRef.current) root.style.setProperty("--vdbar-h", `${Math.round(barRef.current.getBoundingClientRect().height)}px`);
            if (railRef.current) root.style.setProperty("--vdrail-h", `${Math.round(railRef.current.getBoundingClientRect().height)}px`);
        };
        publish();
        const observer = new ResizeObserver(publish);
        if (barRef.current) observer.observe(barRef.current);
        if (railRef.current) observer.observe(railRef.current);
        return ()=>observer.disconnect();
    }, [
        loading
    ]);
    /* ------------------------------------------------------- queue stepping */ /**
   * Step to the neighbouring visit in the FILTERED list.
   *
   * The id cannot be guessed from this page — the order is whatever the list was filtered and
   * sorted by. It rides along in the query string instead, so one `page_size=1` request at the
   * target position resolves the neighbour through the very same query the list ran.
   */ const stepVisit = (0, $cQmXV.useCallback)((delta)=>{
        if (!queueTotal || busy) return;
        const next = queueIndex + delta;
        if (next < 1 || next > queueTotal) return;
        const state = (0, $199198b5a2e0dacc$export$fade2611c23f9109)(location.search, me);
        setBusy(true);
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "GET",
            url: `visits/?${(0, $199198b5a2e0dacc$export$d7b58f10109feb02)({
                ...state,
                page: next,
                size: 1
            })}`
        }, (response)=>{
            setBusy(false);
            const neighbour = response?.results?.[0];
            if (!neighbour?.id) return;
            const search = new URLSearchParams(location.search);
            search.set("i", String(next));
            /* Keep the open section across the step: a reviewer walking a queue is usually looking at
           the same kind of evidence in each visit. */ history.push(`/visit/${neighbour.id}?${search.toString()}`);
        });
    }, [
        queueIndex,
        queueTotal,
        busy,
        history,
        location.search,
        me
    ]);
    (0, $cQmXV.useEffect)(()=>{
        const onKey = (event)=>{
            if (event.metaKey || event.ctrlKey || event.altKey) return;
            const tag = (event.target.tagName || "").toLowerCase();
            if (tag === "input" || tag === "textarea" || tag === "select" || event.target.isContentEditable) return;
            /* A modal owns the keyboard while it is open. */ if (document.querySelector(".ant-modal-wrap:not([style*='display: none'])")) return;
            if (event.key === "[") {
                event.preventDefault();
                stepVisit(-1);
            }
            if (event.key === "]") {
                event.preventDefault();
                stepVisit(1);
            }
        };
        document.addEventListener("keydown", onKey);
        return ()=>document.removeEventListener("keydown", onKey);
    }, [
        stepVisit
    ]);
    /* --------------------------------------------------------- moderation */ /** Approve/reject one record, then repaint only what changed: the summary (counts + queue) and
      the section the record belongs to. Anything that repaints the whole page loses the
      reviewer's place in it. */ /** The repaint after a verdict lands, wherever it was posted from — `RejectTaskModal` posts its
      own `approvals/` row (after the corrective task), so it needs this half without the POST. */ const afterVerdict = (item, isApproved, { toast: toast = true } = {})=>{
        const section = (0, $e36e070b6f6386b6$export$3e32193a9a2be58f)[item.type];
        /* Every cached PAGE of that section goes, not just the one on screen: a verdict changes the
       record's status wherever it was loaded from, and the count in the head above it. */ const stale = (key)=>key.startsWith(`${section}:`);
        setSectionData((prev)=>Object.fromEntries(Object.entries(prev).filter(([key])=>!stale(key))));
        loadingSections.current = new Set([
            ...loadingSections.current
        ].filter((key)=>!stale(key)));
        loadVisit();
        /* The record has been decided, so the modal that was showing it has nothing left to say —
       and the reports modal holds a snapshot of the page the refetch above is replacing, so
       leaving it open would show the old verdict. */ setRecord(null);
        setReport(null);
        /* A record's verdict is not the visit's verdict — they must never share a message, or
       approving one photo reads as approving the whole visit. */ if (toast) (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success(t(isApproved ? "record_approved" : "record_rejected"), {
            position: "top-right"
        });
    };
    const moderate = (item, isApproved, comment = "")=>{
        setBusy(true);
        (0, $e36e070b6f6386b6$export$a0b6e408d0d7f6e8)({
            objectId: item.object_id,
            objectType: item.type,
            isApproved: isApproved,
            comment: comment
        }, (ok)=>{
            setBusy(false);
            if (!ok) return;
            afterVerdict(item, isApproved);
        });
    };
    /* The whole selection in ONE request — `approvals/bulk_approval/` shares a comment across the
     batch, which is exactly the shape bulk carries (PICSELL-1581 #1): bulk reject takes one
     reason and raises no corrective tasks; that flow stays per-record. */ const bulkModerate = (answerIds, isApproved, comment, done)=>{
        if (!answerIds.length) return;
        setBusy(true);
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "POST",
            url: "approvals/bulk_approval/",
            post: {
                object_ids: answerIds,
                object_type: "answer",
                is_approved: isApproved,
                comment: comment || ""
            }
        }, (response)=>{
            setBusy(false);
            const ok = (0, $c9936523dc38c641$export$71a04ee6075aae31)(response);
            if (ok) {
                afterVerdict({
                    type: "answer"
                }, isApproved, {
                    toast: false
                });
                (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success((0, $3b579ca6158bc61b$export$9563e054e6f787fb)(t(isApproved ? "records_approved" : "records_rejected"), {
                    n: answerIds.length
                }), {
                    position: "top-right"
                });
            }
            if (done) done(ok);
        });
    };
    const setVisitApproval = (value)=>{
        if (visit?.is_approved === value) {
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).warning(t(value ? "already_approve_visit_msg" : "already_reject_visit_msg"), {
                position: "top-right"
            });
            return;
        }
        setBusy(true);
        (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
            method: "PATCH",
            url: `visits/${id}/`,
            post: {
                is_approved: value,
                approved_by: me.id
            }
        }, (response)=>{
            setBusy(false);
            if (!response) return;
            setVisit((prev)=>({
                    ...prev,
                    is_approved: value,
                    approved_by: me
                }));
            (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success(t(value ? "approve_visit_msg" : "reject_visit_msg"), {
                position: "top-right"
            });
        });
    };
    const copyLink = ()=>{
        if (navigator.clipboard) navigator.clipboard.writeText(`${window.location.origin}/visit/${id}`).catch(()=>{});
        (0, $8e06ecfa6b5e89ed$export$2e2bcd8739ae039).success(t("link_copied"), {
            position: "top-right"
        });
    };
    /* ------------------------------------------------------------- render */ if (loading && !visit) return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
        className: "shell-content vd",
        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e855c7114b2916ed$export$2e2bcd8739ae039), {
            active: true,
            paragraph: {
                rows: 6
            }
        })
    });
    if (!visit) return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
        className: "shell-content vd",
        children: t("empty_title")
    });
    const status = $8dae7032dddf1d05$var$visitStatus(visit);
    const point = visit.point || {};
    const merchandiser = (0, $b8606fd3839b989b$export$1d6cfa7493842c29)(visit.user);
    const activeSection = sections.find((section)=>section.key === active);
    const pendingItems = summary.pending_items || [];
    const openRecord = (next)=>setRecord(next);
    /* The active section's page, and the pager it hands down. A size change resets to page 1 —
     "page 7 of 25-row pages" is not page 7 of 200-row pages. */ const activePage = $8dae7032dddf1d05$var$pageOf(paging, activeSection);
    const pager = activeSection?.paged ? {
        page: activePage.page,
        size: activePage.size,
        sizes: activeSection.sizes,
        labels: {
            perPage: t("rows_per_page"),
            range: t("range_of")
        },
        onPage: (next)=>setPaging((prev)=>({
                    ...prev,
                    [activeSection.key]: {
                        ...activePage,
                        page: next
                    }
                })),
        onSize: (next)=>setPaging((prev)=>({
                    ...prev,
                    [activeSection.key]: {
                        page: 1,
                        size: next
                    }
                }))
    } : null;
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
        className: "shell-content vd",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                ref: barRef,
                className: "vd-bar",
                align: "center",
                gap: "middle",
                wrap: true,
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                        className: "vd-bar__crumb",
                        align: "center",
                        gap: 6,
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Link, {
                                className: "vd-crumb__parent",
                                onClick: ()=>history.push(backTo),
                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$72266474e9355649), "visit", lang)
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $89db7229a7e10f8f$export$2e2bcd8739ae039), {
                                className: "vd-crumb__sep"
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                strong: true,
                                className: "vd-num",
                                children: [
                                    "#",
                                    String(id).slice(0, 8)
                                ]
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e36e070b6f6386b6$export$5452e567de639f2a), {
                                status: status,
                                lang: lang
                            })
                        ]
                    }),
                    queueTotal > 1 && queueIndex ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                        className: "vd-bar__step",
                        align: "center",
                        gap: 2,
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                type: "text",
                                size: "small",
                                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $0f3c6d60b091c877$export$2e2bcd8739ae039), {}),
                                disabled: queueIndex <= 1,
                                "aria-label": t("prev_visit"),
                                title: `${t("prev_visit")} [`,
                                onClick: ()=>stepVisit(-1)
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                type: "secondary",
                                className: "vd-num vd-bar__pos",
                                children: (0, $3b579ca6158bc61b$export$9563e054e6f787fb)(t("position_of"), {
                                    i: queueIndex,
                                    n: queueTotal
                                })
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                type: "text",
                                size: "small",
                                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $89db7229a7e10f8f$export$2e2bcd8739ae039), {}),
                                disabled: queueIndex >= queueTotal,
                                "aria-label": t("next_visit"),
                                title: `${t("next_visit")} ]`,
                                onClick: ()=>stepVisit(1)
                            })
                        ]
                    }) : null,
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                        className: "vd-spacer"
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $eb1133c43d00490b$export$2e2bcd8739ae039), {
                        size: 8,
                        wrap: true,
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                className: "vd-btn--ok",
                                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $45839ed7c4a7faa2$export$2e2bcd8739ae039), {}),
                                loading: busy,
                                onClick: ()=>setVisitApproval(true),
                                children: t("approv_btn")
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                danger: true,
                                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $bdfb1f797481a352$export$2e2bcd8739ae039), {}),
                                loading: busy,
                                onClick: ()=>setVisitApproval(false),
                                children: t("reject_btn")
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $1e5256cf9d329b2c$export$2e2bcd8739ae039), {
                                title: t("copy_link"),
                                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                    type: "text",
                                    icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $37ec80fabde4926c$export$2e2bcd8739ae039), {}),
                                    "aria-label": t("copy_link"),
                                    onClick: copyLink
                                })
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $1e5256cf9d329b2c$export$2e2bcd8739ae039), {
                                title: t("show_on_map"),
                                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                    type: "text",
                                    icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $d6c8837c82724a15$export$2e2bcd8739ae039), {}),
                                    "aria-label": t("show_on_map"),
                                    onClick: ()=>setActive("gps")
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b4fda840b736e640$export$2e2bcd8739ae039), {
                className: "vd-id",
                variant: "outlined",
                children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                    align: "center",
                    gap: "middle",
                    wrap: true,
                    children: [
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                            className: "vd-id__shot",
                            children: point.image ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("img", {
                                src: point.image,
                                alt: "",
                                onError: (event)=>event.target.style.display = "none"
                            }) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $6238f9dab5cff517$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                            vertical: true,
                            flex: "1 1 260px",
                            className: "vd-id__main",
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                    strong: true,
                                    className: "vd-id__t",
                                    children: [
                                        point.locality?.name,
                                        point.name
                                    ].filter(Boolean).join(" \xb7 ")
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                    className: "vd-id__sub",
                                    align: "center",
                                    gap: "small",
                                    wrap: true,
                                    children: [
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                                            children: [
                                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $d6c8837c82724a15$export$2e2bcd8739ae039), {}),
                                                " ",
                                                point.address
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                                            children: [
                                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $7b23ac4854de9809$export$2e2bcd8739ae039), {}),
                                                " ",
                                                (0, $b8606fd3839b989b$export$8b492ed8828f789c)(visit.start, lang)
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                                            children: [
                                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $786fda1e352afb36$export$2e2bcd8739ae039), {}),
                                                " ",
                                                $8dae7032dddf1d05$var$durationOf(visit, lang)
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                                            children: [
                                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $68eebcef827bb540$export$2e2bcd8739ae039), {}),
                                                " ",
                                                t(visit.is_planned ? "on_route" : "off_route")
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                            align: "center",
                            gap: "small",
                            className: "vd-id__who",
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $72b7444d01b36e98$export$2e2bcd8739ae039), {
                                    size: 40,
                                    style: {
                                        fontSize: 16
                                    },
                                    src: visit.user?.photo || null,
                                    className: "vd-id__av",
                                    children: $8dae7032dddf1d05$var$initialsOf(merchandiser)
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                    vertical: true,
                                    children: [
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                            strong: true,
                                            children: merchandiser || (0, $e36e070b6f6386b6$export$eb03490a10c3abc9)
                                        }),
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                            type: "secondary",
                                            className: "vd-id__role",
                                            children: t("merchandiser")
                                        }),
                                        visit.user?.phone_number ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                            type: "secondary",
                                            className: "vd-id__phone",
                                            children: [
                                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $efbc782831576418$export$2e2bcd8739ae039), {}),
                                                " ",
                                                visit.user.phone_number
                                            ]
                                        }) : null
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $b4fda840b736e640$export$2e2bcd8739ae039), {
                className: `vd-q ${pendingItems.length ? "vd-q--work" : "vd-q--done"}`,
                variant: "outlined",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                        className: "vd-q__h",
                        align: "center",
                        gap: "small",
                        children: [
                            pendingItems.length ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $7b23ac4854de9809$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $45839ed7c4a7faa2$export$2e2bcd8739ae039), {}),
                            t(pendingItems.length ? "needs_attention" : "all_reviewed"),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                className: "vd-q__n",
                                children: pendingItems.length
                            })
                        ]
                    }),
                    pendingItems.length ? pendingItems.map((item)=>/* Hover (or keyboard focus — the row is tabbable for exactly this) shows the full
               details, and for a task answer the way OUT to /task/:id (PICSELL-1581 #11);
               `task_id` rides on the summary row because `object_id` here is the ANSWER pk. */ /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $81ac8d1f20faf53f$export$2e2bcd8739ae039), {
                            trigger: [
                                "hover",
                                "focus"
                            ],
                            placement: "topLeft",
                            styles: {
                                root: {
                                    maxWidth: 340
                                }
                            },
                            content: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                vertical: true,
                                gap: 4,
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                        strong: true,
                                        children: item.title || (0, $e36e070b6f6386b6$export$eb03490a10c3abc9)
                                    }),
                                    $8dae7032dddf1d05$var$queueMeta(item) ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                        type: "secondary",
                                        children: $8dae7032dddf1d05$var$queueMeta(item)
                                    }) : null,
                                    item.type === "answer" && item.task_id ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Link, {
                                        onClick: ()=>history.push(`/task/${item.task_id}`),
                                        children: [
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $357da3723e13ae38$export$2e2bcd8739ae039), {}),
                                            " ",
                                            t("open_task")
                                        ]
                                    }) : null
                                ]
                            }),
                            children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                className: "vd-q__row",
                                align: "center",
                                gap: "middle",
                                tabIndex: 0,
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                        className: "vd-q__tile",
                                        children: $8dae7032dddf1d05$var$KIND_ICON[item.type]
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                        vertical: true,
                                        flex: "1",
                                        className: "vd-q__body",
                                        children: [
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                                strong: true,
                                                ellipsis: true,
                                                children: item.title || (0, $e36e070b6f6386b6$export$eb03490a10c3abc9)
                                            }),
                                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                                type: "secondary",
                                                className: "vd-q__m",
                                                children: $8dae7032dddf1d05$var$queueMeta(item)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                        className: "vd-q__kind",
                                        children: t($8dae7032dddf1d05$var$KIND_LABEL[item.type])
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b8606fd3839b989b$export$f9cfc03362754c2), {
                                        className: "vd-q__btns",
                                        lang: lang,
                                        busy: busy,
                                        onApprove: ()=>moderate(item, true),
                                        onReject: ()=>setReject(item)
                                    })
                                ]
                            })
                        }, `${item.type}-${item.object_id}`)) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                        type: "secondary",
                        className: "vd-q__empty",
                        children: t("all_reviewed_hint")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                ref: railRef,
                className: "vd-rail",
                role: "tablist",
                "aria-label": t("sections"),
                children: sections.map((section)=>{
                    const pending = summary.pending?.[section.key];
                    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("button", {
                        type: "button",
                        role: "tab",
                        "aria-selected": section.key === active,
                        onClick: ()=>setActive(section.key),
                        children: [
                            t(section.labelKey),
                            pending ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                className: "vd-dot",
                                title: (0, $3b579ca6158bc61b$export$9563e054e6f787fb)(t("n_pending"), {
                                    n: pending
                                })
                            }) : null
                        ]
                    }, section.key);
                })
            }),
            activeSection ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $b4fda840b736e640$export$2e2bcd8739ae039), {
                className: "vd-sec",
                variant: "outlined",
                role: "tabpanel",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                        className: "vd-sec__h",
                        align: "center",
                        gap: "small",
                        children: [
                            activeSection.icon,
                            t(activeSection.labelKey),
                            summary.pending?.[activeSection.key] ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                className: "vd-sec__pend",
                                children: (0, $3b579ca6158bc61b$export$9563e054e6f787fb)(t("n_pending"), {
                                    n: summary.pending[activeSection.key]
                                })
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($8dae7032dddf1d05$var$SectionBody, {
                        section: activeSection,
                        data: sectionData[$8dae7032dddf1d05$var$cacheKey(activeSection.key, activePage.page, activePage.size)],
                        pager: pager,
                        visit: visit,
                        lang: lang,
                        onOpenRecord: openRecord,
                        onOpenReport: (items, index)=>setReport({
                                items: items,
                                index: index
                            }),
                        onModerate: moderate,
                        onBulkModerate: bulkModerate,
                        busy: busy,
                        onReject: setReject,
                        onRetry: ()=>retrySection($8dae7032dddf1d05$var$cacheKey(activeSection.key, activePage.page, activePage.size))
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e36e070b6f6386b6$export$458b63e78009e70e), {
                open: Boolean(record),
                record: record,
                lang: lang,
                onClose: ()=>setRecord(null)
            }),
            report && !reject ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($8dae7032dddf1d05$var$ReportModal, {
                report: report,
                lang: lang,
                busy: busy,
                onStep: setReport,
                onClose: ()=>setReport(null),
                onModerate: moderate,
                onReject: setReject
            }) : null,
            reject && reject.type !== "pricemonitoringreport" ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $9525ffc2d869d787$export$2e2bcd8739ae039), {
                target: {
                    objectId: reject.object_id,
                    objectType: reject.type
                },
                photo: reject.photo || null,
                point: visit.point || null,
                visitId: visit.id,
                lang: lang,
                onCancel: ()=>setReject(null),
                onDone: ()=>{
                    const item = reject;
                    setReject(null);
                    /* The modal has already toasted its own outcome ("task created" / "rejected"). */ afterVerdict(item, false, {
                        toast: false
                    });
                }
            }) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e36e070b6f6386b6$export$a16bdbbbfa22bef2), {
                open: Boolean(reject),
                target: reject,
                lang: lang,
                onCancel: ()=>setReject(null),
                onConfirm: (reason)=>{
                    const item = reject;
                    setReject(null);
                    setRecord(null);
                    moderate(item, false, reason);
                }
            })
        ]
    });
};
const $8dae7032dddf1d05$var$KIND_LABEL = {
    report: "zvit_tab_name",
    answer: "task_tab_name",
    pricemonitoringreport: "monitoring_tab_name"
};
const $8dae7032dddf1d05$var$KIND_ICON = {
    report: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $c3b8d7d247171904$export$2e2bcd8739ae039), {}),
    answer: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $f76885e21060a150$export$2e2bcd8739ae039), {}),
    pricemonitoringreport: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $9eca0c0bf6c54372$export$2e2bcd8739ae039), {})
};
/** The queue row's second line: whatever lets the decision be made without opening anything. */ function $8dae7032dddf1d05$var$queueMeta(item) {
    if (item.type === "report") return (item.tags || []).join(" \xb7 ");
    if (item.type === "answer") return item.answer || "";
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $575603080129eb00$exports.Fragment), {
        children: [
            (0, $b8606fd3839b989b$export$5517df3497010beb)(item.price),
            " \u2192 ",
            (0, $b8606fd3839b989b$export$5517df3497010beb)(item.sale_price),
            " ",
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b8606fd3839b989b$export$1f333647865369bf), {
                price: item.price,
                salePrice: item.sale_price
            })
        ]
    });
}
function $8dae7032dddf1d05$var$durationOf(visit, lang) {
    return (0, $9277fdae5adb8dfa$export$bc733b0c5cbb3e8a)(visit?.time_spent, lang) || (0, $b8606fd3839b989b$export$3203edd9e5edd663)(visit?.start, lang);
}
/** The mounted section, or the skeleton that reserves its height while it loads. */ function $8dae7032dddf1d05$var$SectionBody({ section: section, data: data, pager: pager, visit: visit, lang: lang, onOpenRecord: onOpenRecord, onOpenReport: onOpenReport, onModerate: onModerate, onBulkModerate: onBulkModerate, busy: busy, onReject: onReject, onRetry: onRetry }) {
    const history = (0, $6f5d68f762d5488a$export$3420e1dc2c4a518c)();
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), key, lang);
    if (section.key === "gps") return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b8606fd3839b989b$export$88f8942a9973f999), {
        visit: visit,
        lang: lang
    });
    if (data === undefined) return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e855c7114b2916ed$export$2e2bcd8739ae039), {
        active: true,
        paragraph: {
            rows: section.skeleton
        },
        title: false
    });
    /* A FAILED fetch, cached as a marker — never rendered as an empty section (#1581 #21). */ if (data && data.__error) return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $dc33dcdb2d24fbd9$export$2e2bcd8739ae039), {
        type: "error",
        showIcon: true,
        message: t("sec_load_failed"),
        action: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
            size: "small",
            onClick: onRetry,
            children: t("retry")
        })
    });
    const verdictActions = (objectType, objectId, status, title)=>status !== "pending" ? [] : [
            {
                key: "reject",
                tone: "no",
                label: t("reject_btn"),
                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $bdfb1f797481a352$export$2e2bcd8739ae039), {}),
                onClick: ()=>onReject({
                        type: objectType,
                        object_id: objectId,
                        title: title
                    })
            },
            {
                key: "approve",
                tone: "ok",
                label: t("approv_btn"),
                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $45839ed7c4a7faa2$export$2e2bcd8739ae039), {}),
                onClick: ()=>onModerate({
                        type: objectType,
                        object_id: objectId
                    }, true)
            }
        ];
    switch(section.key){
        case "orders":
            return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b8606fd3839b989b$export$a7f864e9a31ae39c), {
                data: data,
                lang: lang,
                onOpen: (row)=>$8dae7032dddf1d05$var$openOrder(row, lang, onOpenRecord)
            });
        case "returns":
            return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b8606fd3839b989b$export$7fe938b3398327d2), {
                data: data,
                lang: lang,
                onOpen: (row)=>onOpenRecord($8dae7032dddf1d05$var$returnRecord(row, lang))
            });
        case "payments":
            return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b8606fd3839b989b$export$21c9bae90c5629f5), {
                data: data,
                lang: lang,
                onOpen: (row)=>onOpenRecord($8dae7032dddf1d05$var$paymentRecord(row, lang))
            });
        case "reports":
            /* The report opens in /photo-review's own modal, not the generic record dialog — same
         records, so the same zoom stage, thumbnail strip, facts rail and keyboard. */ return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b8606fd3839b989b$export$e0a0d30234fefcbf), {
                data: data,
                lang: lang,
                pager: pager,
                onOpen: onOpenReport
            });
        case "tasks":
            return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b8606fd3839b989b$export$3e2ce5dc7b3dae26), {
                data: data,
                lang: lang,
                busy: busy,
                onBulkDecide: onBulkModerate,
                onOpen: (row)=>onOpenRecord($8dae7032dddf1d05$var$taskRecord(row, lang, verdictActions, (taskId)=>history.push(`/task/${taskId}`)))
            });
        case "price":
            return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b8606fd3839b989b$export$e1cdc4bd8c8b22b2), {
                data: data,
                lang: lang,
                pager: pager,
                onOpen: (row)=>onOpenRecord($8dae7032dddf1d05$var$priceRecord(row, lang, verdictActions))
            });
        case "surveys":
            return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b8606fd3839b989b$export$4110bfc1db2278b4), {
                visitId: visit.id,
                data: data,
                lang: lang
            });
        case "log":
            return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b8606fd3839b989b$export$770119c1605110bd), {
                data: data,
                lang: lang
            });
        default:
            return null;
    }
}
/* ------------------------------------------------------------ record modals */ /* Orders carry their line items only on the detail endpoint, so opening one costs a request the
   list never paid for. */ function $8dae7032dddf1d05$var$openOrder(row, lang, onOpenRecord) {
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), key, lang);
    (0, $c9936523dc38c641$export$848feb93d8f32b9b)({
        method: "GET",
        url: `excalibur/orders/${row.id}/`
    }, (response)=>{
        const order = response?.id ? response : row;
        const items = order.items || [];
        onOpenRecord({
            wide: true,
            title: `${t("orders_popup_order_id_title")} ${order.name || ""}`,
            subtitle: [
                order.counterparty?.name,
                (0, $b8606fd3839b989b$export$8b492ed8828f789c)(order.datetime, lang)
            ].filter(Boolean).join(" \xb7 "),
            sections: [
                {
                    titleKey: "orders_popup_details_title",
                    icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3ad3610a8cd8d8e0$export$2e2bcd8739ae039), {}),
                    rows: [
                        [
                            t("orders_popup_counterparty_label"),
                            order.counterparty?.name
                        ],
                        [
                            t("orders_address_label"),
                            order.counterparty?.address
                        ],
                        [
                            t("orders_popup_order_type_label"),
                            order.order_type?.name
                        ],
                        [
                            t("orders_popup_sales_rep_label"),
                            (0, $b8606fd3839b989b$export$1d6cfa7493842c29)(order.created_by)
                        ],
                        [
                            t("orders_popup_delivery_time_label"),
                            (0, $b8606fd3839b989b$export$3ae94a2503e890a1)(order.delivery_date, lang)
                        ],
                        [
                            t("orders_popup_order_status_label"),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b8606fd3839b989b$export$18ba65a8ef47b37b), {
                                value: order.status,
                                lang: lang
                            }, "s")
                        ],
                        [
                            t("orders_popup_comment_label"),
                            order.comments
                        ]
                    ]
                },
                {
                    titleKey: "orders_popup_order_table_label",
                    icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3ad3610a8cd8d8e0$export$2e2bcd8739ae039), {}),
                    count: items.length,
                    node: /* ⚠ The name is `item.product.name` — `OrderItemSerializer` NESTS the product. Reading a
               flat `item.name` left every row's name blank while its numbers rendered fine.
               The three numeric columns are fixed-width and headed: they were unwidthed spans in a
               flex row, so they never lined up and nothing said what they were.
               ⚠ The per-row sum is `amount × quantity`, the UNDISCOUNTED line total, while the
               `Всього` below carries the order-level discount. Making them agree needs a discounted
               price per line, which `BaseOrderItem` does not model (PICSELL-1572 #9, PICSELL-1574
               #17 — backend, and upstream of that the mobile app: `sendOrder` transmits
               `'amount': p.price`, the BASE price, per line while sending the discount-resolved sum
               as `order_total`, so the payload contradicts itself before picsell-api sees it).

               What is shown instead of a silent contradiction: BOTH numbers, labelled. The gross sum
               of the lines above (which always agrees with them, because it is computed from them)
               and the document's own total. When a discount applies the second is lower, and that
               gap is now visible as a fact rather than looking like a rendering bug.
               ⚠ Nothing here is COMPUTED FROM `order_total`. Across 510 dev orders, 140 of them hold
               the LINE COUNT in that field rather than money and 37 differ from the line sum by more
               than 30%, so any arithmetic on it would print nonsense for roughly a third of orders.
               It is passed through unchanged. */ /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                        className: "vd-items",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                className: "vd-items__row vd-items__row--head",
                                align: "center",
                                gap: "small",
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                        className: "vd-items__n",
                                        children: t("orders_popup_order_table_name")
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                        className: "vd-items__c",
                                        children: t("orders_popup_order_table_quantity")
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                        className: "vd-items__c",
                                        children: t("orders_item_price_label")
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                        className: "vd-items__c",
                                        children: t("orders_item_sum_label")
                                    })
                                ]
                            }),
                            items.map((item, index)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                    className: "vd-items__row",
                                    align: "center",
                                    gap: "small",
                                    children: [
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                            className: "vd-items__n",
                                            children: item.product?.name || item.product?.full_name || (0, $e36e070b6f6386b6$export$eb03490a10c3abc9)
                                        }),
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                            className: "vd-items__c vd-num",
                                            children: item.quantity
                                        }),
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                            className: "vd-items__c vd-num",
                                            children: (0, $b8606fd3839b989b$export$5517df3497010beb)(item.amount)
                                        }),
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("b", {
                                            className: "vd-items__c vd-num",
                                            children: (0, $b8606fd3839b989b$export$5517df3497010beb)((item.amount || 0) * (item.quantity || 0))
                                        })
                                    ]
                                }, item.id ?? index)),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                className: "vd-items__row vd-items__row--total",
                                align: "center",
                                gap: "small",
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                        className: "vd-items__n",
                                        children: t("orders_lines_total")
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("b", {
                                        className: "vd-items__c vd-num",
                                        children: (0, $b8606fd3839b989b$export$5517df3497010beb)(items.reduce((sum, item)=>sum + (Number(item.amount) || 0) * (Number(item.quantity) || 0), 0))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                className: "vd-items__row vd-items__row--total",
                                align: "center",
                                gap: "small",
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                        className: "vd-items__n",
                                        children: t("orders_product_total")
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("b", {
                                        className: "vd-items__c vd-num",
                                        children: (0, $b8606fd3839b989b$export$5517df3497010beb)(order.order_total ?? order.total)
                                    })
                                ]
                            })
                        ]
                    })
                }
            ]
        });
    });
}
function $8dae7032dddf1d05$var$returnRecord(row, lang) {
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), key, lang);
    const items = row.items || [];
    return {
        title: `${t("returns_tab_name")} ${row.name || `#${row.id}`}`,
        subtitle: [
            row.counterparty?.name,
            (0, $b8606fd3839b989b$export$8b492ed8828f789c)(row.datetime, lang)
        ].filter(Boolean).join(" \xb7 "),
        sections: [
            {
                titleKey: "returns_tab_name",
                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3ad3610a8cd8d8e0$export$2e2bcd8739ae039), {}),
                rows: [
                    [
                        t("orders_popup_counterparty_label"),
                        row.counterparty?.name
                    ],
                    [
                        t("orders_address_label"),
                        row.counterparty?.address
                    ],
                    [
                        t("orders_return_crated_label"),
                        (0, $b8606fd3839b989b$export$8b492ed8828f789c)(row.datetime, lang)
                    ],
                    [
                        t("orders_physical_return_label"),
                        (0, $b8606fd3839b989b$export$3ae94a2503e890a1)(row.date_of_physical_return, lang)
                    ],
                    [
                        t("orders_status_return_label"),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b8606fd3839b989b$export$18ba65a8ef47b37b), {
                            value: row.status,
                            lang: lang
                        }, "s")
                    ],
                    [
                        t("orders_popup_comment_label"),
                        row.comments
                    ]
                ]
            },
            /* What was actually returned. The modal showed only the four header facts before, so the one
         question it exists to answer — which products came back — had no answer on the page.
         ⚠ NO price or sum column, and that is not an omission to fill in from here: `ReturnItem`
         carries only `product` and `quantity` (the mobile app's `sendReturn` sends exactly those
         two), and a return records no department, so any price would be one of up to three
         department prices guessed and presented as fact. See PICSELL-1572 #12/#13. */ items.length ? {
                titleKey: "orders_popup_order_table_label",
                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3ad3610a8cd8d8e0$export$2e2bcd8739ae039), {}),
                count: items.length,
                node: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                    className: "vd-items",
                    children: [
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                            className: "vd-items__row vd-items__row--head",
                            align: "center",
                            gap: "small",
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                    className: "vd-items__n",
                                    children: t("orders_popup_order_table_name")
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                    className: "vd-items__c",
                                    children: t("orders_popup_order_table_quantity")
                                })
                            ]
                        }),
                        items.map((item, index)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                className: "vd-items__row",
                                align: "center",
                                gap: "small",
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                        className: "vd-items__n",
                                        children: item.product?.name || item.product?.full_name || (0, $e36e070b6f6386b6$export$eb03490a10c3abc9)
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                        className: "vd-items__c vd-num",
                                        children: item.quantity
                                    })
                                ]
                            }, item.id ?? index))
                    ]
                })
            } : null
        ]
    };
}
function $8dae7032dddf1d05$var$paymentRecord(row, lang) {
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), key, lang);
    return {
        title: `${t("payments_tab_name")} #${row.id}`,
        subtitle: [
            row.counterparty?.name,
            (0, $b8606fd3839b989b$export$5517df3497010beb)(row.amount)
        ].filter(Boolean).join(" \xb7 "),
        sections: [
            {
                titleKey: "payments_tab_name",
                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3ad3610a8cd8d8e0$export$2e2bcd8739ae039), {}),
                rows: [
                    [
                        t("orders_popup_counterparty_label"),
                        row.counterparty?.name
                    ],
                    [
                        t("orders_payment_amount_label"),
                        (0, $b8606fd3839b989b$export$5517df3497010beb)(row.amount),
                        {
                            num: true
                        }
                    ],
                    [
                        t("orders_payment_debt_label"),
                        row.debt?.name_of_the_document
                    ],
                    [
                        t("orders_product_status_date"),
                        (0, $b8606fd3839b989b$export$8b492ed8828f789c)(row.datetime, lang)
                    ],
                    [
                        t("orders_popup_comment_label"),
                        row.comment
                    ]
                ]
            }
        ]
    };
}
/**
 * The photo report, in /photo-review's modal.
 *
 * A thin adapter, not a second modal: `ReviewModal` is prop-driven and already carries the zoom
 * stage, the thumbnail strip, the facts rail and the ← → / A / R keyboard. All this has to do is
 * step the loaded page and translate a verdict into this page's `moderate` / reject-with-reason
 * flow. Stepping wraps, as it does on /photo-review.
 */ function $8dae7032dddf1d05$var$ReportModal({ report: report, lang: lang, busy: busy, onStep: onStep, onClose: onClose, onModerate: onModerate, onReject: onReject }) {
    const { items: items, index: index } = report;
    const item = items[index];
    if (!item) return null;
    const step = (delta)=>onStep({
            items: items,
            index: (index + delta + items.length) % items.length
        });
    /* `picsell_info.object_id` is what `approvals/` keys on — the Outforz content id is not it. */ const target = {
        type: "report",
        object_id: item.picsell_info?.object_id ?? item.id,
        title: item.additional_info?.title || `#${item.id}`,
        /* `PhotoReview.photo` is the synthesised array; the first frame is what the annotator opens on. */ photo: item.photo?.[0] || null
    };
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $bc657e1ecc306871$export$2e2bcd8739ae039), {
        item: item,
        position: index + 1,
        total: items.length,
        lang: lang,
        busy: busy,
        onClose: onClose,
        onPrev: ()=>step(-1),
        onNext: ()=>step(1),
        onApprove: ()=>onModerate(target, true),
        onReject: ()=>onReject(target)
    });
}
function $8dae7032dddf1d05$var$taskRecord(row, lang, verdictActions, onOpenTask) {
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), key, lang);
    const answer = row.answer;
    /* `statusOf` reads pending when `approval` is absent — which is both the truth for a fresh
     answer and the safe default until the API serves the field again. ⚠ It must be a real status,
     not null: `verdictActions` only renders for the literal "pending", and passing null here is
     what silently killed the modal's Approve/Reject (PICSELL-1581 #4). */ const status = answer ? (0, $e36e070b6f6386b6$export$1094b4db5e23d27c)(answer.approval) : null;
    const tags = (answer?.client_and_tags || []).flatMap((entry)=>entry.tags || []);
    /* The thumbnails, not just how many there are. This modal replaced a full page that showed the
     photos, and it was rendering `image_count` alone — a number is not evidence to judge on. The
     rows are already in the payload (`AnswerPhotoSerializer`), in either of the two shapes an
     `AnswerPhoto` uses. */ const photos = (0, $e873a05126b50f33$export$57b71c8db173e2e4)(answer);
    return {
        /* A task's description, photos and answer never fit 720px comfortably (PICSELL-1581 #4). */ wide: true,
        title: row.title,
        subtitle: [
            row.template?.name,
            `#${row.id}`
        ].filter(Boolean).join(" \xb7 "),
        status: status || undefined,
        actions: [
            ...answer?.id ? verdictActions("answer", answer.id, status, row.title) : [],
            {
                key: "open-task",
                label: t("open_task"),
                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $357da3723e13ae38$export$2e2bcd8739ae039), {}),
                onClick: ()=>onOpenTask(row.id)
            }
        ],
        sections: [
            {
                titleKey: "task_tab_name",
                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $f76885e21060a150$export$2e2bcd8739ae039), {}),
                rows: [
                    [
                        t("task_tab_info_label"),
                        row.description
                    ],
                    [
                        t("task_tab_type_label"),
                        row.template?.name
                    ],
                    [
                        t("task_tab_createdby_label"),
                        (0, $b8606fd3839b989b$export$1d6cfa7493842c29)(row.created_by)
                    ],
                    [
                        t("task_tab_deadline_label"),
                        (0, $b8606fd3839b989b$export$3ae94a2503e890a1)(row.end, lang)
                    ]
                ]
            },
            photos.length ? {
                titleKey: "task_tab_count_photo_label",
                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $c3b8d7d247171904$export$2e2bcd8739ae039), {}),
                count: photos.length,
                node: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $7012c54fc4de0c33$export$2e2bcd8739ae039).PreviewGroup, {
                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                        gap: 4,
                        wrap: true,
                        children: photos.map((src, index)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $7012c54fc4de0c33$export$2e2bcd8739ae039), {
                                src: src,
                                alt: "",
                                width: 64,
                                className: "vd-thumb"
                            }, `${src}-${index}`))
                    })
                })
            } : null,
            {
                titleKey: "task_tab_answer_comment_label",
                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $9eca0c0bf6c54372$export$2e2bcd8739ae039), {}),
                rows: [
                    [
                        t("task_tab_answer_comment_label"),
                        answer?.answer
                    ],
                    /* Tri-state: true / false / null — null is "not answered", not "no". */ [
                        t("task_tab_answer_status_label"),
                        answer?.boolean_answer === null || answer?.boolean_answer === undefined ? null : t(answer.boolean_answer ? "task_tab_answer_status_yes_label" : "task_tab_answer_status_no_label")
                    ],
                    [
                        t("task_tab_answer_tags_label"),
                        tags.join(", ")
                    ]
                ]
            }
        ]
    };
}
function $8dae7032dddf1d05$var$priceRecord(row, lang, verdictActions) {
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), key, lang);
    const status = (0, $e36e070b6f6386b6$export$1094b4db5e23d27c)(row.approval);
    return {
        title: row.product_name || row.product_code,
        subtitle: `${t("monitoring_tab_pcode_label")}: ${row.product_code}`,
        status: status,
        actions: verdictActions("pricemonitoringreport", row.id, status, row.product_name),
        sections: [
            row.photo_url ? {
                node: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("div", {
                    className: "vd-photo",
                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("img", {
                        src: row.photo_url,
                        alt: ""
                    })
                })
            } : null,
            {
                titleKey: "monitoring_tab_name",
                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $9eca0c0bf6c54372$export$2e2bcd8739ae039), {}),
                rows: [
                    [
                        t("monitoring_tab_price_label"),
                        (0, $b8606fd3839b989b$export$5517df3497010beb)(row.price),
                        {
                            num: true
                        }
                    ],
                    [
                        t("monitoring_tab_sale_price_label"),
                        (0, $b8606fd3839b989b$export$5517df3497010beb)(row.sale_price),
                        {
                            num: true
                        }
                    ],
                    [
                        t("delta"),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b8606fd3839b989b$export$1f333647865369bf), {
                            price: row.price,
                            salePrice: row.sale_price
                        }, "d"),
                        {
                            num: true
                        }
                    ],
                    [
                        t("monitoring_tab_comment_label"),
                        row.comment
                    ]
                ]
            },
            $8dae7032dddf1d05$var$approvalBlock(row.approval, lang)
        ]
    };
}
/** Who decided, when and why. Omitted while a record is pending: it would only print "Approved
    by —", which says nothing. */ function $8dae7032dddf1d05$var$approvalBlock(approval, lang) {
    const t = (key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$34f353d91e697be5), key, lang);
    if (!approval || approval.is_approved === null || approval.is_approved === undefined) return null;
    return {
        titleKey: "approve_reject_label_block",
        icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $9eca0c0bf6c54372$export$2e2bcd8739ae039), {}),
        rows: [
            [
                t("approved_by"),
                (0, $b8606fd3839b989b$export$1d6cfa7493842c29)(approval.approved_by)
            ],
            [
                t("approved_at"),
                (0, $b8606fd3839b989b$export$8b492ed8828f789c)(approval.approved_at, lang)
            ],
            approval.is_approved === false ? [
                t("reject_reason"),
                approval.comment
            ] : null
        ]
    };
}
var $8dae7032dddf1d05$export$2e2bcd8739ae039 = $8dae7032dddf1d05$var$View;


/* Online tracking — where the team is, and what route they walked, for one day.
 *
 * spec/03 **archetype C**: a roster plus one focused subject, one thing hydrated at a time. It is
 * `/visit/:id`'s shape without the moderation verbs, so it is not a fourth archetype. Nothing is
 * sticky — the head is short and carries one action, and the measured-offset apparatus archetype B
 * needs has shipped broken four times.
 *
 * ⚠ THERE IS NO LIVE GPS IN THIS SYSTEM, and the copy must never imply otherwise. A position is
 * the coordinate of the POINT of an OPEN visit; "last" is the point of the last closed one. The
 * mobile app does record a real 30-minute-cadence trail in `Visit.meta`, but it only exists on
 * `GET visits/{id}/` and only lands at visit close, so it is out of scope here. Everything the
 * page derives lives in `derive.js`, checked by `yarn check:tracking`.
 *
 * Built out of parts that already existed: `LeafletMap` (extended with `markers`/`plan`/`fitKey`
 * rather than forked), `PersonCell`/`StatusIcon` from `table-cells`, and — for the planned route —
 * `layersFromRoutes` + `mergedStopsForDate`, the same pure functions the routes editor runs on.
 */ 

var $cQmXV = parcelRequire("cQmXV");











/**
 * /tracking — turning a day of visit rows into positions, routes and roster state.
 *
 * Pure and dependency-free on purpose: `scripts/check-tracking.mjs` imports it directly under
 * node, the same way `check-csv.mjs` imports `import/csv.js`. No React, no dayjs, no formatting —
 * the view owns every string.
 *
 * The whole page rests on one derivation, so it is worth stating plainly: THERE IS NO LIVE GPS IN
 * THIS SYSTEM. A merchandiser's position is the coordinate of the POINT of their currently open
 * visit; their last known position is the point of their last closed one. `Visit.meta` — the real
 * 30-minute-cadence trail the mobile app records — is out of scope: it only exists on
 * `GET visits/{id}/` and only lands at visit close.
 */ /* An open visit older than this is a forgotten close, not somebody standing in a shop. It is a
   WARNING, not a fault — the merchandiser is probably working and needs a nudge to close it. */ const $1ae620a8a66bb4da$export$13efcd98c37622c0 = 4;
const $1ae620a8a66bb4da$export$4be155fc44d57dc5 = {
    IN_VISIT: "in_visit",
    OPEN_STALE: "open_stale",
    BETWEEN: "between",
    IDLE: "idle"
};
const $1ae620a8a66bb4da$export$a1ef82c6c242ab71 = {
    [$1ae620a8a66bb4da$export$4be155fc44d57dc5.IN_VISIT]: "ok",
    [$1ae620a8a66bb4da$export$4be155fc44d57dc5.OPEN_STALE]: "wait",
    [$1ae620a8a66bb4da$export$4be155fc44d57dc5.BETWEEN]: "off",
    [$1ae620a8a66bb4da$export$4be155fc44d57dc5.IDLE]: "off"
};
/* Sort order for the rail: the rows that want a phone call first, then who is out there, then who
   has finished, then who has not started. */ const $1ae620a8a66bb4da$var$RANK = {
    [$1ae620a8a66bb4da$export$4be155fc44d57dc5.OPEN_STALE]: 0,
    [$1ae620a8a66bb4da$export$4be155fc44d57dc5.IN_VISIT]: 1,
    [$1ae620a8a66bb4da$export$4be155fc44d57dc5.BETWEEN]: 2,
    [$1ae620a8a66bb4da$export$4be155fc44d57dc5.IDLE]: 3
};
/* ⚠ `Number(null)` is 0 and `Number("")` is 0, so a missing coordinate would read as the
   equator/prime-meridian rather than as absent. Reject the empty cases before converting.
   Values arrive as floats from the read serializer and as strings from the write one. */ const $1ae620a8a66bb4da$var$num = (value)=>{
    if (value === null || value === undefined || value === "") return NaN;
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : NaN;
};
const $1ae620a8a66bb4da$var$ms = (value)=>{
    const parsed = value ? Date.parse(value) : NaN;
    return Number.isFinite(parsed) ? parsed : NaN;
};
const $1ae620a8a66bb4da$export$dd0feb9b59bb352 = (point)=>{
    const location = point && point.location;
    if (!location) return null;
    const lat = $1ae620a8a66bb4da$var$num(location.latitude);
    const lng = $1ae620a8a66bb4da$var$num(location.longitude);
    return Number.isFinite(lat) && Number.isFinite(lng) ? [
        lat,
        lng
    ] : null;
};
const $1ae620a8a66bb4da$export$ea0830439c7fc698 = (visit)=>!visit.end;
const $1ae620a8a66bb4da$export$c82be66d0ebe16df = (visit)=>$1ae620a8a66bb4da$var$ms(visit && visit.start);
const $1ae620a8a66bb4da$export$438ca41f2c352cb = (visit)=>$1ae620a8a66bb4da$var$ms(visit && visit.end);
const $1ae620a8a66bb4da$export$2046ef26a802e964 = (visit, now)=>{
    const from = $1ae620a8a66bb4da$export$c82be66d0ebe16df(visit);
    if (!Number.isFinite(from)) return null;
    const to = $1ae620a8a66bb4da$export$ea0830439c7fc698(visit) ? now : $1ae620a8a66bb4da$export$438ca41f2c352cb(visit);
    if (!Number.isFinite(to)) return null;
    return Math.max(0, to - from);
};
const $1ae620a8a66bb4da$export$90fc3fe8e4a00b0 = (visits)=>(visits || []).filter((visit)=>Number.isFinite($1ae620a8a66bb4da$export$c82be66d0ebe16df(visit))).sort((a, b)=>$1ae620a8a66bb4da$export$c82be66d0ebe16df(a) - $1ae620a8a66bb4da$export$c82be66d0ebe16df(b));
const $1ae620a8a66bb4da$export$524b57d457259d96 = (visits)=>{
    const out = new Map();
    (visits || []).forEach((visit)=>{
        const id = visit && visit.user && visit.user.id;
        if (id === null || id === undefined) return;
        if (!out.has(id)) out.set(id, []);
        out.get(id).push(visit);
    });
    return out;
};
const $1ae620a8a66bb4da$export$f1f1a4e08a971958 = (visits, now)=>{
    const sequence = $1ae620a8a66bb4da$export$90fc3fe8e4a00b0(visits);
    if (!sequence.length) return {
        kind: $1ae620a8a66bb4da$export$4be155fc44d57dc5.IDLE,
        visit: null,
        since: null,
        sequence: sequence
    };
    /* ⚠ The LAST open row, not the first. Two open visits happen — a merchandiser who forgot to
     close one and started the next — and the newer one is where they actually are. */ let open = null;
    for(let i = sequence.length - 1; i >= 0; i -= 1)if ($1ae620a8a66bb4da$export$ea0830439c7fc698(sequence[i])) {
        open = sequence[i];
        break;
    }
    if (open) {
        const age = now - $1ae620a8a66bb4da$export$c82be66d0ebe16df(open);
        return {
            kind: age >= $1ae620a8a66bb4da$export$13efcd98c37622c0 * 3600000 ? $1ae620a8a66bb4da$export$4be155fc44d57dc5.OPEN_STALE : $1ae620a8a66bb4da$export$4be155fc44d57dc5.IN_VISIT,
            visit: open,
            since: $1ae620a8a66bb4da$export$c82be66d0ebe16df(open),
            sequence: sequence
        };
    }
    const last = sequence[sequence.length - 1];
    return {
        kind: $1ae620a8a66bb4da$export$4be155fc44d57dc5.BETWEEN,
        visit: last,
        since: $1ae620a8a66bb4da$export$438ca41f2c352cb(last),
        sequence: sequence
    };
};
const $1ae620a8a66bb4da$export$f1184897fafa08b2 = (merchandisers, visits, now)=>{
    const byUser = $1ae620a8a66bb4da$export$524b57d457259d96(visits);
    const seen = new Set();
    const rows = [];
    (merchandisers || []).forEach((user)=>{
        if (user === null || user === undefined || user.id === null || user.id === undefined) return;
        if (seen.has(user.id)) return;
        seen.add(user.id);
        rows.push({
            user: user,
            ...$1ae620a8a66bb4da$export$f1f1a4e08a971958(byUser.get(user.id) || [], now)
        });
    });
    byUser.forEach((userVisits, id)=>{
        if (seen.has(id)) return;
        seen.add(id);
        rows.push({
            user: userVisits[0].user,
            extra: true,
            ...$1ae620a8a66bb4da$export$f1f1a4e08a971958(userVisits, now)
        });
    });
    const name = (row)=>`${row.user.first_name || ""} ${row.user.last_name || ""}`.trim().toLowerCase();
    return rows.sort((a, b)=>$1ae620a8a66bb4da$var$RANK[a.kind] - $1ae620a8a66bb4da$var$RANK[b.kind] || name(a).localeCompare(name(b)));
};
const $1ae620a8a66bb4da$export$adf0973ed2892533 = (rows)=>(rows || []).filter((row)=>row.kind !== $1ae620a8a66bb4da$export$4be155fc44d57dc5.IDLE);
const $1ae620a8a66bb4da$export$e4d4117dfd264968 = (sequence)=>(sequence || []).map((visit, index)=>{
        const at = $1ae620a8a66bb4da$export$dd0feb9b59bb352(visit.point);
        if (!at) return null;
        const here = $1ae620a8a66bb4da$export$ea0830439c7fc698(visit);
        return {
            key: `v${visit.id}`,
            lat: at[0],
            lng: at[1],
            label: index + 1,
            kind: here ? "here" : null,
            tone: here ? "ok" : "off",
            title: visit.point && visit.point.name || "",
            visit: visit
        };
    }).filter(Boolean);
const $1ae620a8a66bb4da$export$6447fa5cf2187edf = (sequence)=>(sequence || []).map((visit)=>$1ae620a8a66bb4da$export$dd0feb9b59bb352(visit.point)).filter(Boolean);
const $1ae620a8a66bb4da$export$3f41e540b0316cbb = (stops, sequence)=>{
    const visited = new Set((sequence || []).map((visit)=>visit.point && visit.point.id).filter((id)=>id !== null && id !== undefined));
    return (stops || []).filter((stop)=>stop && stop.point && !visited.has(stop.point.id));
};
const $1ae620a8a66bb4da$export$853a2e6b3906eb7f = (stops, sequence)=>$1ae620a8a66bb4da$export$3f41e540b0316cbb(stops, sequence).map((stop)=>{
        const at = $1ae620a8a66bb4da$export$dd0feb9b59bb352(stop.point);
        if (!at) return null;
        return {
            key: `p${stop.point.id}`,
            lat: at[0],
            lng: at[1],
            label: "",
            kind: "plan",
            title: stop.point.name || "",
            point: stop.point
        };
    }).filter(Boolean);
const $1ae620a8a66bb4da$export$74006a903c999d93 = (stops)=>(stops || []).map((stop)=>$1ae620a8a66bb4da$export$dd0feb9b59bb352(stop && stop.point)).filter(Boolean);



/* `SmallResultsSetPagination.max_page_size` is 100 and the cap is silent — `?page_size=500`
   returns 100 rows with HTTP 200 and no warning. So a whole day is a walk, not one request. */ const $74a936419e82ff94$var$PAGE_SIZE = 100;
/* 10 pages = 1000 visits. The bound exists so a very large company cannot hang the page; when it
   bites, the page SAYS SO (see `truncated` below) rather than looking complete. */ const $74a936419e82ff94$var$MAX_PAGES = 10;
const $74a936419e82ff94$var$POLL_MS = 60000;
const $74a936419e82ff94$var$GLYPH = {
    [(0, $1ae620a8a66bb4da$export$4be155fc44d57dc5).IN_VISIT]: (0, $d6c8837c82724a15$export$2e2bcd8739ae039),
    [(0, $1ae620a8a66bb4da$export$4be155fc44d57dc5).OPEN_STALE]: (0, $798c0df65ce199b6$export$2e2bcd8739ae039),
    [(0, $1ae620a8a66bb4da$export$4be155fc44d57dc5).BETWEEN]: (0, $6c0489580aed4320$export$2e2bcd8739ae039),
    [(0, $1ae620a8a66bb4da$export$4be155fc44d57dc5).IDLE]: (0, $886bddec374e5a95$export$2e2bcd8739ae039)
};
const $74a936419e82ff94$var$STATE_KEY = {
    [(0, $1ae620a8a66bb4da$export$4be155fc44d57dc5).IN_VISIT]: "st_in_visit",
    [(0, $1ae620a8a66bb4da$export$4be155fc44d57dc5).OPEN_STALE]: "st_open_stale",
    [(0, $1ae620a8a66bb4da$export$4be155fc44d57dc5).BETWEEN]: "st_between",
    [(0, $1ae620a8a66bb4da$export$4be155fc44d57dc5).IDLE]: "st_idle"
};
/* Local calendar day. The server runs USE_TZ=False, so a local Y-M-D is what its date filters
   compare against. Copied rather than imported from `visit/List.js`: that import would drag
   `visits.scss` into this bundle. */ const $74a936419e82ff94$var$isoDay = (date)=>date.format("YYYY-MM-DD");
const $74a936419e82ff94$var$hhmm = (value)=>value ? (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)(value).format("HH:mm") : null;
/* ⚠ Round-trip `d` and `m` SYMMETRICALLY. /answers shipped a bug where one direction omitted a
   value the other read back with a different default, so a workspace opened from one segment
   stepped a different queue. `d` is always written; `m` absent means "whole team" in both
   directions. */ const $74a936419e82ff94$var$searchToState = (search)=>{
    const params = new URLSearchParams(search);
    const raw = params.get("d");
    const parsed = raw ? (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)(raw, "YYYY-MM-DD", true) : null;
    const id = params.get("m");
    return {
        day: parsed && parsed.isValid() ? parsed : (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)(),
        selected: id && Number.isFinite(Number(id)) ? Number(id) : null
    };
};
const $74a936419e82ff94$var$stateToSearch = (day, selected)=>{
    const params = new URLSearchParams();
    params.set("d", $74a936419e82ff94$var$isoDay(day));
    if (selected !== null && selected !== undefined) params.set("m", String(selected));
    return params.toString();
};
/**
 * Walk a DRF page sequence, bounded.
 *
 * ⚠ Does NOT follow `next`: it is an absolute URL and `getAbortable` prepends `API_URL_PREFIX`.
 * Every other caller in `src/` treats `next` as a boolean and increments `page`, and so does this.
 * `capped` is true when the bound stopped the walk short of `count` — the page must say so.
 */ async function $74a936419e82ff94$var$walk(base, signal, maxPages = $74a936419e82ff94$var$MAX_PAGES) {
    const rows = [];
    let total = 0;
    for(let page = 1; page <= maxPages; page += 1){
        const response = await (0, $c9936523dc38c641$export$86557ef9e0794d10)(`${base}&page=${page}`, signal);
        if (!response) break; /* the 401 path resolves null */ 
        rows.push(...response.results || []);
        total = Number.isFinite(response.count) ? response.count : rows.length;
        if (!response.next) break;
    }
    return {
        rows: rows,
        total: total,
        capped: total > rows.length
    };
}
/* Click-to-call. A real `tel:` link, so it dials on a phone and hands off to the desktop's
   handler otherwise — not a button that copies a number. `stopPropagation` because the map head's
   and the rail's copies sit inside clickable areas, where a bare click would also toggle the
   Collapse panel underneath. */ function $74a936419e82ff94$var$PhoneLink({ phone: phone, t: t }) {
    if (!phone) return null;
    const dial = String(phone).replace(/[^+\d]/g, "");
    if (!dial) return null;
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Link, {
        href: `tel:${dial}`,
        className: "ot-phone",
        onClick: (event)=>event.stopPropagation(),
        "aria-label": `${t("call")} ${phone}`,
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $efbc782831576418$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                children: phone
            })
        ]
    });
}
function $74a936419e82ff94$var$Duration({ visit: visit, now: now, t: t }) {
    const ms = (0, $1ae620a8a66bb4da$export$2046ef26a802e964)(visit, now);
    if (ms === null) return 0, $66539b2560a58e4e$export$eb03490a10c3abc9;
    const minutes = Math.round(ms / 60000);
    if (minutes < 60) return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $575603080129eb00$exports.Fragment), {
        children: (0, $3b579ca6158bc61b$export$9563e054e6f787fb)(t("dur_m"), {
            n: minutes
        })
    });
    const hours = Math.floor(minutes / 60);
    const rest = minutes % 60;
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $575603080129eb00$exports.Fragment), {
        children: [
            (0, $3b579ca6158bc61b$export$9563e054e6f787fb)(t("dur_h"), {
                n: hours
            }),
            rest ? ` ${(0, $3b579ca6158bc61b$export$9563e054e6f787fb)(t("dur_m"), {
                n: rest
            })}` : ""
        ]
    });
}
/* One merchandiser's day, inside the expanded rail row. Deliberately a plain list and not a
   <Table>: seven columns do not fit a 320px rail, and the map beside it carries the geography. */ function $74a936419e82ff94$var$Sequence({ row: row, plan: plan, planLoading: planLoading, now: now, t: t, onOpenVisit: onOpenVisit }) {
    const pending = (0, $cQmXV.useMemo)(()=>(0, $1ae620a8a66bb4da$export$3f41e540b0316cbb)(plan, row.sequence), [
        plan,
        row.sequence
    ]);
    const phone = /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($74a936419e82ff94$var$PhoneLink, {
        phone: row.user.phone_number,
        t: t
    });
    if (!row.sequence.length) return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
        vertical: true,
        gap: 4,
        className: "ot-seq",
        children: [
            phone,
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                type: "secondary",
                className: "ot-empty-line",
                children: t("st_idle")
            })
        ]
    });
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
        vertical: true,
        gap: 4,
        className: "ot-seq",
        children: [
            phone,
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                type: "secondary",
                className: "ot-seq__head",
                children: t("seq_title")
            }),
            row.sequence.map((visit, index)=>{
                const point = visit.point || {};
                const open = (0, $1ae620a8a66bb4da$export$ea0830439c7fc698)(visit);
                return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("button", {
                    type: "button",
                    className: "ot-stop",
                    onClick: ()=>onOpenVisit(visit),
                    children: [
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                            className: `ot-stop__n${open ? " ot-stop__n--here" : ""}`,
                            children: index + 1
                        }),
                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                            className: "ot-stop__body",
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                    className: "ot-stop__name",
                                    children: point.name || (0, $66539b2560a58e4e$export$eb03490a10c3abc9)
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                                    className: "ot-stop__meta",
                                    children: [
                                        $74a936419e82ff94$var$hhmm(visit.start),
                                        open ? " \xb7 " : ` \u{2013} ${$74a936419e82ff94$var$hhmm(visit.end)} \xb7 `,
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($74a936419e82ff94$var$Duration, {
                                            visit: visit,
                                            now: now,
                                            t: t
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                                    className: "ot-stop__tags",
                                    children: [
                                        open ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $602120e6d17ff12a$export$2e2bcd8739ae039), {
                                            color: "processing",
                                            children: t("here_now")
                                        }) : null,
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $602120e6d17ff12a$export$2e2bcd8739ae039), {
                                            className: visit.is_planned ? "ot-tag--on" : "ot-tag--off",
                                            children: visit.is_planned ? t("on_route") : t("off_route")
                                        }),
                                        (0, $1ae620a8a66bb4da$export$dd0feb9b59bb352)(point) ? null : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $602120e6d17ff12a$export$2e2bcd8739ae039), {
                                            className: "ot-tag--warn",
                                            children: t("no_coords")
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }, visit.id);
            }),
            planLoading ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e855c7114b2916ed$export$2e2bcd8739ae039), {
                active: true,
                paragraph: {
                    rows: 1
                },
                title: false
            }) : null,
            !planLoading && plan && !plan.length ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                type: "secondary",
                className: "ot-empty-line",
                children: t("no_plan")
            }) : null,
            pending.length ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $575603080129eb00$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                        type: "secondary",
                        className: "ot-seq__head",
                        children: t("plan_pending")
                    }),
                    pending.map((stop)=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("span", {
                            className: "ot-stop ot-stop--plan",
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                    className: "ot-stop__n ot-stop__n--plan",
                                    "aria-hidden": "true"
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                    className: "ot-stop__body",
                                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                        className: "ot-stop__name",
                                        children: stop.point.name || (0, $66539b2560a58e4e$export$eb03490a10c3abc9)
                                    })
                                })
                            ]
                        }, stop.point.id))
                ]
            }) : null
        ]
    });
}
function $74a936419e82ff94$export$2e2bcd8739ae039() {
    const lang = (0, $b83e93e5ef3de8b0$export$2105062e25df4afe)((state)=>state.me?.language);
    const history = (0, $6f5d68f762d5488a$export$3420e1dc2c4a518c)();
    const location = (0, $6f5d68f762d5488a$export$45d76561a5302f2b)();
    const t = (0, $cQmXV.useCallback)((key)=>(0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$63f54f62a76a9e58), key, lang), [
        lang
    ]);
    const initial = (0, $cQmXV.useMemo)(()=>$74a936419e82ff94$var$searchToState(location.search), []); // eslint-disable-line react-hooks/exhaustive-deps
    const [day, setDay] = (0, $cQmXV.useState)(initial.day);
    const [selected, setSelected] = (0, $cQmXV.useState)(initial.selected);
    const [team, setTeam] = (0, $cQmXV.useState)(null);
    const [visits, setVisits] = (0, $cQmXV.useState)([]);
    const [visitTotal, setVisitTotal] = (0, $cQmXV.useState)(0);
    const [capped, setCapped] = (0, $cQmXV.useState)(false);
    const [busy, setBusy] = (0, $cQmXV.useState)(true);
    const [error, setError] = (0, $cQmXV.useState)(false);
    const [updated, setUpdated] = (0, $cQmXV.useState)(null);
    const [tick, setTick] = (0, $cQmXV.useState)(0);
    const [plan, setPlan] = (0, $cQmXV.useState)(null);
    const [planLoading, setPlanLoading] = (0, $cQmXV.useState)(false);
    const planCache = (0, $cQmXV.useRef)(new Map());
    const dayKey = $74a936419e82ff94$var$isoDay(day);
    const isToday = dayKey === $74a936419e82ff94$var$isoDay((0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)());
    /* The filters ARE the query string: a view is shareable and survives a reload. */ (0, $cQmXV.useEffect)(()=>{
        const next = $74a936419e82ff94$var$stateToSearch(day, selected);
        if (next !== location.search.replace(/^\?/, "")) history.replace({
            pathname: location.pathname,
            search: `?${next}`
        });
    }, [
        dayKey,
        selected
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    /* The roster is day-independent, so it is fetched once per mount and never on a poll. It is
     needed at all because visit rows cannot answer "no visits today", and dropping an idle
     merchandiser would make the page look complete while hiding who has not started. */ (0, $cQmXV.useEffect)(()=>{
        const controller = new AbortController();
        $74a936419e82ff94$var$walk(`merchandisers/?is_active=true&page_size=${$74a936419e82ff94$var$PAGE_SIZE}`, controller.signal).then((result)=>{
            if (!controller.signal.aborted) setTeam(result.rows);
        }).catch((err)=>{
            if (err?.name !== "AbortError") setTeam([]);
        });
        return ()=>controller.abort();
    }, []);
    (0, $cQmXV.useEffect)(()=>{
        const controller = new AbortController();
        const { signal: signal } = controller;
        setBusy(true);
        /* `start__lte` is the NEXT day, and the filter is on `start` alone. Filtering `end__*` would
       drop every still-open visit — exactly the rows this page exists for — and there is no
       `end__isnull` to ask for them instead. `ordering=start` is mandatory, not cosmetic: without
       a deterministic order, 100-row windows can duplicate and skip rows between pages. */ const query = [
            `start__gte=${dayKey}`,
            `start__lte=${$74a936419e82ff94$var$isoDay(day.add(1, "day"))}`,
            "ordering=start",
            `page_size=${$74a936419e82ff94$var$PAGE_SIZE}`
        ].join("&");
        $74a936419e82ff94$var$walk(`visits/?${query}`, signal).then((result)=>{
            if (signal.aborted) return;
            setVisits(result.rows);
            setVisitTotal(result.total);
            setCapped(result.capped);
            setError(false);
            setUpdated(Date.now());
            setBusy(false);
        }).catch((err)=>{
            if (signal.aborted || err?.name === "AbortError") return;
            setError(true);
            setBusy(false);
        });
        return ()=>controller.abort();
    }, [
        dayKey,
        tick
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    /* Auto-refresh, today only — a past day cannot change.
     Re-arms on `updated` rather than on the rows, and does not arm at all while the tab is
     hidden: if the timer fired while hidden it would not tick, `updated` would never change and
     nothing would re-arm, so the cycle stops dead and `visibilitychange` restarts it. A tab left
     open overnight makes zero requests. */ (0, $cQmXV.useEffect)(()=>{
        if (!isToday || error || document.hidden) return undefined;
        const timer = setTimeout(()=>{
            if (!document.hidden) setTick((value)=>value + 1);
        }, $74a936419e82ff94$var$POLL_MS);
        return ()=>clearTimeout(timer);
    }, [
        isToday,
        updated,
        error
    ]);
    (0, $cQmXV.useEffect)(()=>{
        const onVisible = ()=>{
            if (!document.hidden) setTick((value)=>value + 1);
        };
        document.addEventListener("visibilitychange", onVisible);
        return ()=>document.removeEventListener("visibilitychange", onVisible);
    }, []);
    /* The planned route: one request, only once a merchandiser is selected, cached per person+day. */ (0, $cQmXV.useEffect)(()=>{
        if (selected === null || selected === undefined) {
            setPlan(null);
            return undefined;
        }
        const key = `${selected}|${dayKey}`;
        const cached = planCache.current.get(key);
        if (cached) {
            setPlan(cached);
            return undefined;
        }
        const controller = new AbortController();
        setPlanLoading(true);
        (0, $c9936523dc38c641$export$86557ef9e0794d10)(`routes?user=${selected}&date=${dayKey}`, controller.signal).then((response)=>{
            if (controller.signal.aborted) return;
            const list = Array.isArray(response) ? response : response?.results || [];
            /* ⚠ FILTER BY THE ROUTE'S OWN USER CLIENT-SIDE, and do not skip this because `?user=` is
           in the URL. picsell-api's base RouteViewSet carries `filter_class` — the attribute
           django-filter dropped in 2.0, while the project pins 2.4.0 — so `?user=` and `?date=`
           were both silently ignored and every route the supervisor created came back, for every
           merchandiser. The `filterset_class` fix is a local, undeployed edit; this line is what
           makes the page correct on either side of that deploy.
           Its queryset is also `created_by | user` scoped, so a route somebody else created is
           invisible — which is why an empty result renders as a neutral "no planned route" rather
           than a claim that the merchandiser is unplanned. */ const mine = list.filter((route)=>(route.user?.id ?? route.user) === selected);
            const { layers: layers } = (0, $29ff8c829ff33c74$export$65638ff2f6061a77)(mine);
            const stops = (0, $29ff8c829ff33c74$export$2a8916ca8520a9cf)(day.toDate(), layers);
            planCache.current.set(key, stops);
            setPlan(stops);
            setPlanLoading(false);
        }).catch((err)=>{
            if (controller.signal.aborted || err?.name === "AbortError") return;
            setPlan([]);
            setPlanLoading(false);
        });
        return ()=>controller.abort();
    }, [
        selected,
        dayKey
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    /* `updated` is the moment the data was true, and it is what the head reports — so staleness is
     measured against it rather than against a clock that moves under the render. */ const now = updated || Date.now();
    const rows = (0, $cQmXV.useMemo)(()=>(0, $1ae620a8a66bb4da$export$f1184897fafa08b2)(team || [], visits, now), [
        team,
        visits,
        now
    ]);
    const selectedRow = (0, $cQmXV.useMemo)(()=>rows.find((row)=>row.user.id === selected) || null, [
        rows,
        selected
    ]);
    const markers = (0, $cQmXV.useMemo)(()=>{
        if (selectedRow) /* Plan pins first so the numbered actual route paints over them. */ return [
            ...(0, $1ae620a8a66bb4da$export$853a2e6b3906eb7f)(plan, selectedRow.sequence),
            ...(0, $1ae620a8a66bb4da$export$e4d4117dfd264968)(selectedRow.sequence)
        ];
        /* At rest the map carries everyone with a position: green/amber = in an open visit now,
       grey = the point of their last closed visit. The tone is what keeps a last-known pin from
       reading as a live one; idle people appear in the rail only. */ return (0, $1ae620a8a66bb4da$export$adf0973ed2892533)(rows).map((row)=>{
            const at = (0, $1ae620a8a66bb4da$export$dd0feb9b59bb352)(row.visit && row.visit.point);
            if (!at) return null;
            const name = (0, $66539b2560a58e4e$export$1d6cfa7493842c29)(row.user);
            return {
                key: `u${row.user.id}`,
                lat: at[0],
                lng: at[1],
                /* The house avatar: the photo when there is one, the INITIALS otherwise — and the
             initials are also what LeafletMap falls back to when an old photo URL 404s, which is
             common on legacy records. Never a generic glyph. */ label: (0, $66539b2560a58e4e$export$f6a098653d630c23)(name),
                photo: row.user.photo || null,
                kind: "who",
                tone: (0, $1ae620a8a66bb4da$export$a1ef82c6c242ab71)[row.kind],
                clickable: true,
                userId: row.user.id,
                title: `${name} \u{2014} ${row.visit.point && row.visit.point.name || ""}`
            };
        }).filter(Boolean);
    }, [
        rows,
        selectedRow,
        plan
    ]);
    const track = (0, $cQmXV.useMemo)(()=>selectedRow ? (0, $1ae620a8a66bb4da$export$6447fa5cf2187edf)(selectedRow.sequence) : null, [
        selectedRow
    ]);
    const planLine = (0, $cQmXV.useMemo)(()=>selectedRow ? (0, $1ae620a8a66bb4da$export$74006a903c999d93)(plan) : null, [
        selectedRow,
        plan
    ]);
    /* Fit is re-armed by the DAY, the SELECTION, and whether the PLAN has landed — never by the
     visit data, so a 60-second poll leaves the pan and zoom the user set exactly where they are.
     The plan matters because it arrives one request later than the visits: fitting only on
     selection framed the visited points and left the planned-but-unvisited stop off-screen, with
     its dashed line running out of the corner. The plan is cached per person+day, so re-selecting
     somebody refits once, not twice, and a refresh not at all. */ const fitKey = `${dayKey}:${selected ?? "all"}:${plan ? plan.length : "-"}`;
    const hasGeometry = markers.length > 0 || track && track.length > 0 || planLine && planLine.length > 0;
    const loadingFirst = busy && team === null;
    const stateLine = (row)=>{
        if (row.kind === (0, $1ae620a8a66bb4da$export$4be155fc44d57dc5).IDLE) return t("st_idle");
        const point = row.visit && row.visit.point && row.visit.point.name || "";
        return (0, $3b579ca6158bc61b$export$9563e054e6f787fb)(t($74a936419e82ff94$var$STATE_KEY[row.kind]), {
            point: point,
            time: $74a936419e82ff94$var$hhmm(row.since ? new Date(row.since).toISOString() : null) || ""
        });
    };
    const items = rows.map((row)=>{
        const Icon = $74a936419e82ff94$var$GLYPH[row.kind];
        return {
            key: String(row.user.id),
            className: `ot-row ot-row--${row.kind}${row.user.id === selected ? " ot-row--on" : ""}`,
            label: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                align: "center",
                gap: 8,
                className: "ot-row__label",
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $66539b2560a58e4e$export$b131c49b26d3f427), {
                        Icon: Icon,
                        tone: (0, $1ae620a8a66bb4da$export$a1ef82c6c242ab71)[row.kind],
                        label: stateLine(row)
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                        vertical: true,
                        className: "ot-row__who",
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                align: "center",
                                gap: 8,
                                className: "ot-row__top",
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $66539b2560a58e4e$export$8a3d0b92eb0904a5), {
                                        user: row.user
                                    }),
                                    row.sequence.length ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                        type: "secondary",
                                        className: "ot-row__n",
                                        children: (0, $3b579ca6158bc61b$export$9563e054e6f787fb)(t("points_visited"), {
                                            n: row.sequence.length
                                        })
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                type: "secondary",
                                className: "ot-row__state",
                                ellipsis: {
                                    tooltip: stateLine(row)
                                },
                                children: stateLine(row)
                            })
                        ]
                    })
                ]
            }),
            children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($74a936419e82ff94$var$Sequence, {
                row: row,
                plan: plan,
                planLoading: planLoading,
                now: now,
                t: t,
                onOpenVisit: (visit)=>history.push(`/visit/${visit.id}`)
            })
        };
    });
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
        vertical: true,
        gap: "middle",
        className: "shell-content lp ot",
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                className: "lp-head",
                justify: "space-between",
                align: "flex-end",
                gap: "middle",
                wrap: true,
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                        vertical: true,
                        children: [
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Title, {
                                level: 1,
                                className: "lp-title",
                                children: (0, $3b579ca6158bc61b$export$d73ee8ef04f5226a)((0, $fc3f36407bc5ec6c$export$72266474e9355649), "tracking", lang)
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Paragraph, {
                                type: "secondary",
                                className: "lp-sub",
                                children: t("page_sub")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $eb1133c43d00490b$export$2e2bcd8739ae039), {
                        align: "center",
                        wrap: true,
                        children: [
                            updated ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                type: "secondary",
                                className: "ot-updated",
                                "aria-live": "polite",
                                children: (0, $3b579ca6158bc61b$export$9563e054e6f787fb)(t("updated"), {
                                    time: (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)(updated).format("HH:mm")
                                })
                            }) : null,
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $bf89508d36c51d8b$export$2e2bcd8739ae039), {
                                value: day,
                                onChange: (next)=>setDay(next || (0, $c2a1b4c9c0ea4716$export$2e2bcd8739ae039)()),
                                allowClear: false,
                                "aria-label": t("day"),
                                format: "DD.MM.YYYY"
                            }),
                            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                                icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $d27e4ec0a39831fe$export$2e2bcd8739ae039), {}),
                                onClick: ()=>setTick((value)=>value + 1),
                                loading: busy,
                                "aria-label": t("refresh"),
                                children: t("refresh")
                            })
                        ]
                    })
                ]
            }),
            error ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $dc33dcdb2d24fbd9$export$2e2bcd8739ae039), {
                type: "error",
                showIcon: true,
                message: t("load_error"),
                action: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                    size: "small",
                    onClick: ()=>setTick((value)=>value + 1),
                    children: t("retry")
                })
            }) : null,
            capped ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $dc33dcdb2d24fbd9$export$2e2bcd8739ae039), {
                type: "warning",
                showIcon: true,
                message: (0, $3b579ca6158bc61b$export$9563e054e6f787fb)(t("truncated"), {
                    shown: visits.length,
                    total: visitTotal
                })
            }) : null,
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
                className: `ot-body${busy && !loadingFirst ? " ot-body--busy" : ""}`,
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b4fda840b736e640$export$2e2bcd8739ae039), {
                        className: "ot-rail",
                        variant: "outlined",
                        size: "small",
                        children: loadingFirst ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e855c7114b2916ed$export$2e2bcd8739ae039), {
                            active: true,
                            paragraph: {
                                rows: 8
                            },
                            title: false
                        }) : rows.length ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $23bd4bba91b7ee72$export$2e2bcd8739ae039), {
                            accordion: true,
                            ghost: true,
                            items: items,
                            activeKey: selected === null || selected === undefined ? [] : [
                                String(selected)
                            ],
                            onChange: (keys)=>{
                                const key = Array.isArray(keys) ? keys[0] : keys;
                                setSelected(key === undefined || key === null ? null : Number(key));
                            }
                        }) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $99350450b877904c$export$2e2bcd8739ae039), {
                            image: (0, $99350450b877904c$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE,
                            description: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                vertical: true,
                                gap: 4,
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                        strong: true,
                                        children: t("empty_roster_title")
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                        type: "secondary",
                                        children: t("empty_roster_desc")
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b4fda840b736e640$export$2e2bcd8739ae039), {
                        className: "ot-mapcard",
                        variant: "outlined",
                        title: selectedRow ? /* The chosen merchandiser, stated with their face and a way to reach them — the map
                 alone showed a route with no owner, so "who is this" had to be read off the rail. */ /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                            align: "center",
                            gap: 10,
                            wrap: true,
                            className: "ot-who",
                            children: [
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $72b7444d01b36e98$export$2e2bcd8739ae039), {
                                    size: 32,
                                    style: {
                                        fontSize: 13
                                    },
                                    className: "lp-who__av",
                                    src: selectedRow.user.photo || null,
                                    children: (0, $66539b2560a58e4e$export$f6a098653d630c23)((0, $66539b2560a58e4e$export$1d6cfa7493842c29)(selectedRow.user))
                                }),
                                /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                    vertical: true,
                                    className: "ot-who__text",
                                    children: [
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)("span", {
                                            className: "ot-who__name",
                                            children: (0, $66539b2560a58e4e$export$1d6cfa7493842c29)(selectedRow.user)
                                        }),
                                        /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($74a936419e82ff94$var$PhoneLink, {
                                            phone: selectedRow.user.phone_number,
                                            t: t
                                        })
                                    ]
                                }),
                                planLine && planLine.length >= 2 ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $602120e6d17ff12a$export$2e2bcd8739ae039), {
                                    className: "ot-tag--plan",
                                    children: t("plan_title")
                                }) : null
                            ]
                        }) : null,
                        extra: selectedRow ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $2d1c32fbb5b444a6$export$2e2bcd8739ae039), {
                            size: "small",
                            icon: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $d5baeea001a6abe5$export$2e2bcd8739ae039), {}),
                            onClick: ()=>setSelected(null),
                            children: t("show_team")
                        }) : null,
                        children: loadingFirst ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $e855c7114b2916ed$export$2e2bcd8739ae039).Node, {
                            active: true,
                            className: "ot-map-sk"
                        }) : hasGeometry ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $6967b95453f7bc7e$export$2e2bcd8739ae039), {
                            markers: markers,
                            track: track,
                            plan: planLine,
                            fitKey: fitKey,
                            zoom: 11,
                            height: "100%",
                            failedText: t("map_unavailable"),
                            /* Clicking a face on the team map selects that merchandiser — the map is a way in to
                 a person, not only a readout of where they are. */ onMarkerClick: (marker)=>marker.userId && setSelected(marker.userId)
                        }) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $99350450b877904c$export$2e2bcd8739ae039), {
                            image: (0, $99350450b877904c$export$2e2bcd8739ae039).PRESENTED_IMAGE_SIMPLE,
                            description: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $3007e7c4e76d64e0$export$2e2bcd8739ae039), {
                                vertical: true,
                                gap: 4,
                                children: [
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                        strong: true,
                                        children: t("empty_map_title")
                                    }),
                                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5ff14f79745d0994$export$2e2bcd8739ae039).Text, {
                                        type: "secondary",
                                        children: t("empty_map_desc")
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
}




var $cQmXV = parcelRequire("cQmXV");

const $0cb9602690f12a91$export$552522b64eb5db81 = (WrappedComponent)=>{
    return class WithAuthorization extends (0, (/*@__PURE__*/$parcel$interopDefault($cQmXV))).Component {
        render() {
            const { me: me } = (0, $81aca8a46f6ecb51$export$6fec604aa7293d0c)().getState();
            if (me) return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)(WrappedComponent, {
                ...this.props,
                currentUser: me
            });
            else {
                window.location.replace("/");
                return null;
            }
        }
    };
};


const $576021dafcea8b48$export$1f44aaf2ec115b54 = (0, $0cb9602690f12a91$export$552522b64eb5db81);



const $8b71911a3e78f725$var$PrivateRoute = ({ component: Component, ...rest })=>{
    let me = (0, $81aca8a46f6ecb51$export$6fec604aa7293d0c)().getState().me;
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $6f5d68f762d5488a$export$e7b0ac011bb776c6), {
        ...rest,
        render: (props)=>me ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)(Component, {
                ...props,
                ...rest
            }) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $6f5d68f762d5488a$export$2d8d895a0a0f636e), {
                to: "/login"
            })
    });
};
/**
 * A route only a supervisor manager may open, matching that row's `role` in `AppNav.MENU`.
 *
 * The import screens were gated by a hand-rolled, untranslated, hardcoded-English "Page Not Found"
 * block inside the page itself. A redirect belongs at the routing layer and says the true thing:
 * this account has no such page, not "this page does not exist".
 *
 * ⚠ The API is LOOSER than this: `tasks/bulk_create/`, `assortment_matrix/bulk_create/` and
 * `actions/` all permit `IsSupervisor | IsSupervisorManager`. This preserves the stricter
 * behaviour the old screen had rather than quietly widening access; whether a plain supervisor
 * should be able to import is a product decision.
 */ const $8b71911a3e78f725$var$ManagerOnly = (Component)=>{
    const Gated = (props)=>(0, $81aca8a46f6ecb51$export$6fec604aa7293d0c)().getState().me?.role === "supervisor_manager" ? /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)(Component, {
            ...props
        }) : /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $6f5d68f762d5488a$export$2d8d895a0a0f636e), {
            to: "/"
        });
    Gated.displayName = `ManagerOnly(${Component.displayName || Component.name || "Component"})`;
    return Gated;
};
const $8b71911a3e78f725$var$AppRouter = ()=>{
    return /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $6f5d68f762d5488a$export$b5d5cf8927ab7262), {
        children: [
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $6f5d68f762d5488a$export$e7b0ac011bb776c6), {
                exact: true,
                path: "/login",
                component: (0, $d840257e31fd14f4$export$2e2bcd8739ae039)
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $6f5d68f762d5488a$export$e7b0ac011bb776c6), {
                exact: true,
                path: "/forgot-password",
                component: (0, $0c0a79c705228dbe$export$2e2bcd8739ae039)
            }),
            /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)((0, $a1d7e4e3ae62364a$export$c84671f46d6a1ca), {
                children: [
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/",
                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $6f5d68f762d5488a$export$2d8d895a0a0f636e), {
                            to: "/merchandiser"
                        })
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/overview",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $1aa6f1d8358888de$export$2e2bcd8739ae039))
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/profile",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $464b3d7a8ec63582$export$2e2bcd8739ae039))
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/help",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $e28c7067209a584d$export$2e2bcd8739ae039))
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/merchandiser",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $0460c6defa8dc216$export$2e2bcd8739ae039))
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/merchandiser/:id",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $c99a2835eadd6e89$export$2e2bcd8739ae039))
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/task",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $30ad5da16ca1f695$export$771a55a10b0a40ae))
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/task/new/:type",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $51ef8b1748b26f2f$export$2e2bcd8739ae039))
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/task/:id",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $51ef8b1748b26f2f$export$2e2bcd8739ae039))
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $6f5d68f762d5488a$export$e7b0ac011bb776c6), {
                        exact: true,
                        path: "/task/:id/edit",
                        render: ({ match: match })=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $6f5d68f762d5488a$export$2d8d895a0a0f636e), {
                                to: `/task/${match.params.id}?edit=1`
                            })
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $6f5d68f762d5488a$export$e7b0ac011bb776c6), {
                        exact: true,
                        path: "/task/:id/view",
                        render: ({ match: match })=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $6f5d68f762d5488a$export$2d8d895a0a0f636e), {
                                to: `/task/${match.params.id}`
                            })
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/answers",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $f23c147c1832a8e4$export$2e2bcd8739ae039))
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/answers/:id",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $f55238b83d3d3fdb$export$2e2bcd8739ae039))
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $6f5d68f762d5488a$export$e7b0ac011bb776c6), {
                        exact: true,
                        path: "/task-review",
                        render: ({ location: location })=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $6f5d68f762d5488a$export$2d8d895a0a0f636e), {
                                to: `/answers${location.search}`
                            })
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/import",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)($8b71911a3e78f725$var$ManagerOnly((0, $f00aa72c5a7b810e$export$2e2bcd8739ae039)))
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/uploads",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)($8b71911a3e78f725$var$ManagerOnly((0, $7cdeb4e07eb0c872$export$2e2bcd8739ae039)))
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $6f5d68f762d5488a$export$e7b0ac011bb776c6), {
                        exact: true,
                        path: "/tasks-import",
                        render: ()=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $6f5d68f762d5488a$export$2d8d895a0a0f636e), {
                                to: "/import"
                            })
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $6f5d68f762d5488a$export$e7b0ac011bb776c6), {
                        exact: true,
                        path: "/tasks-import/:id",
                        render: ({ match: match })=>/*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $6f5d68f762d5488a$export$2d8d895a0a0f636e), {
                                to: match.params.id === "3" ? "/uploads" : "/import"
                            })
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        path: "/photo-review",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $a11cc2758244e822$export$2e2bcd8739ae039))
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/document",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $8410c4bcf771fa83$export$2e2bcd8739ae039))
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/bi-report",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $d24c7edf7011cb65$export$2e2bcd8739ae039))
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/visit",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $199198b5a2e0dacc$export$2e2bcd8739ae039))
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/visit/:id",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $8dae7032dddf1d05$export$2e2bcd8739ae039))
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/tracking",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $74a936419e82ff94$export$2e2bcd8739ae039))
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/points",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $038bb54df492679d$export$2e2bcd8739ae039))
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/points/:id",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $e3e209289ea60a84$export$fd0f57f0ca46c3d2)("points"))
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/networks",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $e3e209289ea60a84$export$5636abe024a9e6a3)("networks"))
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/networks/:id",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $e3e209289ea60a84$export$fd0f57f0ca46c3d2)("networks"))
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/categories",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $e3e209289ea60a84$export$5636abe024a9e6a3)("categories"))
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/categories/:id",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $e3e209289ea60a84$export$fd0f57f0ca46c3d2)("categories"))
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/countries",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $e3e209289ea60a84$export$5636abe024a9e6a3)("countries"))
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/countries/:id",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $e3e209289ea60a84$export$fd0f57f0ca46c3d2)("countries"))
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/counties",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $e3e209289ea60a84$export$5636abe024a9e6a3)("counties"))
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/counties/:id",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $e3e209289ea60a84$export$fd0f57f0ca46c3d2)("counties"))
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/localities",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $e3e209289ea60a84$export$5636abe024a9e6a3)("localities"))
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/localities/:id",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $e3e209289ea60a84$export$fd0f57f0ca46c3d2)("localities"))
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/point_groups",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $e3e209289ea60a84$export$5636abe024a9e6a3)("point_groups"))
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/point_groups/:id",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $e3e209289ea60a84$export$fd0f57f0ca46c3d2)("point_groups"))
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/surveys",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $e3e209289ea60a84$export$5636abe024a9e6a3)("surveys"))
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/surveys/:id",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $e3e209289ea60a84$export$fd0f57f0ca46c3d2)("surveys"))
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/point",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $e3e209289ea60a84$export$5636abe024a9e6a3)("points"))
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/point/:id",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $e3e209289ea60a84$export$fd0f57f0ca46c3d2)("points"))
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/supervisors",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $77c659030dd190f5$export$2e2bcd8739ae039))
                    }),
                    /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)($8b71911a3e78f725$var$PrivateRoute, {
                        exact: true,
                        path: "/supervisors/:id",
                        component: (0, $576021dafcea8b48$export$1f44aaf2ec115b54)((0, $8a5b9f48d1d79d00$export$2e2bcd8739ae039))
                    })
                ]
            })
        ]
    });
};
var $8b71911a3e78f725$export$2e2bcd8739ae039 = $8b71911a3e78f725$var$AppRouter;



const $aeaaa25a0de5f5fe$var$store = (0, $81aca8a46f6ecb51$export$6fec604aa7293d0c)();
$aeaaa25a0de5f5fe$var$store.subscribe(()=>{
    const { me: me } = $aeaaa25a0de5f5fe$var$store.getState();
    (0, $67f64b78c4102acd$export$fb931cd598921492)({
        me: me
    });
});
// Last line of defence for async throws that never reach a React boundary
// (rejected promises, event-handler errors). No remote reporting configured — log only.
window.addEventListener("unhandledrejection", (event)=>{
    console.error("Unhandled promise rejection:", event.reason);
});
window.addEventListener("error", (event)=>{
    console.error("Uncaught error:", event.error || event.message);
});
const $aeaaa25a0de5f5fe$var$application = /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $b83e93e5ef3de8b0$export$2881499e37b75b9a), {
    store: $aeaaa25a0de5f5fe$var$store,
    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $5764e43cf38ca965$export$2e2bcd8739ae039), {
        theme: (0, $d40125f317306d19$export$ea009db4dcb4845b),
        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $896e8f74d1491439$export$f2815235e76a62b9), {
                    position: "top-center",
                    autoClose: 5000,
                    limit: 3
                }),
                /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $c4ecd91a3fcb0ac8$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $50f22649d61cdefc$export$9ba4e89fdfa1fc54), {
                        children: /*#__PURE__*/ (0, $575603080129eb00$exports.jsx)((0, $8b71911a3e78f725$export$2e2bcd8739ae039), {})
                    })
                })
            ]
        })
    })
});
const $aeaaa25a0de5f5fe$var$root = (0, $3e75b56ae88591f4$exports.createRoot)(document.getElementById("app"));
$aeaaa25a0de5f5fe$var$root.render($aeaaa25a0de5f5fe$var$application);


//# sourceMappingURL=index.bb635ada.js.map
